// modules are defined as an array
// [ module function, map of requires ]
//
// map of requires is short require name -> numeric require
//
// anything defined in a previous bundle is accessed via the
// orig method which is the require for previous bundles

(function (modules, entry, mainEntry, parcelRequireName, globalName) {
  /* eslint-disable no-undef */
  var globalObject =
    typeof globalThis !== 'undefined'
      ? globalThis
      : typeof self !== 'undefined'
      ? self
      : typeof window !== 'undefined'
      ? window
      : typeof global !== 'undefined'
      ? global
      : {};
  /* eslint-enable no-undef */

  // Save the require from previous bundle to this closure if any
  var previousRequire =
    typeof globalObject[parcelRequireName] === 'function' &&
    globalObject[parcelRequireName];

  var cache = previousRequire.cache || {};
  // Do not use `require` to prevent Webpack from trying to bundle this call
  var nodeRequire =
    typeof module !== 'undefined' &&
    typeof module.require === 'function' &&
    module.require.bind(module);

  function newRequire(name, jumped) {
    if (!cache[name]) {
      if (!modules[name]) {
        // if we cannot find the module within our internal map or
        // cache jump to the current global require ie. the last bundle
        // that was added to the page.
        var currentRequire =
          typeof globalObject[parcelRequireName] === 'function' &&
          globalObject[parcelRequireName];
        if (!jumped && currentRequire) {
          return currentRequire(name, true);
        }

        // If there are other bundles on this page the require from the
        // previous one is saved to 'previousRequire'. Repeat this as
        // many times as there are bundles until the module is found or
        // we exhaust the require chain.
        if (previousRequire) {
          return previousRequire(name, true);
        }

        // Try the node require function if it exists.
        if (nodeRequire && typeof name === 'string') {
          return nodeRequire(name);
        }

        var err = new Error("Cannot find module '" + name + "'");
        err.code = 'MODULE_NOT_FOUND';
        throw err;
      }

      localRequire.resolve = resolve;
      localRequire.cache = {};

      var module = (cache[name] = new newRequire.Module(name));

      modules[name][0].call(
        module.exports,
        localRequire,
        module,
        module.exports,
        this
      );
    }

    return cache[name].exports;

    function localRequire(x) {
      var res = localRequire.resolve(x);
      return res === false ? {} : newRequire(res);
    }

    function resolve(x) {
      var id = modules[name][1][x];
      return id != null ? id : x;
    }
  }

  function Module(moduleName) {
    this.id = moduleName;
    this.bundle = newRequire;
    this.exports = {};
  }

  newRequire.isParcelRequire = true;
  newRequire.Module = Module;
  newRequire.modules = modules;
  newRequire.cache = cache;
  newRequire.parent = previousRequire;
  newRequire.register = function (id, exports) {
    modules[id] = [
      function (require, module) {
        module.exports = exports;
      },
      {},
    ];
  };

  Object.defineProperty(newRequire, 'root', {
    get: function () {
      return globalObject[parcelRequireName];
    },
  });

  globalObject[parcelRequireName] = newRequire;

  for (var i = 0; i < entry.length; i++) {
    newRequire(entry[i]);
  }

  if (mainEntry) {
    // Expose entry point to Node, AMD or browser globals
    // Based on https://github.com/ForbesLindesay/umd/blob/master/template.js
    var mainExports = newRequire(mainEntry);

    // CommonJS
    if (typeof exports === 'object' && typeof module !== 'undefined') {
      module.exports = mainExports;

      // RequireJS
    } else if (typeof define === 'function' && define.amd) {
      define(function () {
        return mainExports;
      });

      // <script>
    } else if (globalName) {
      this[globalName] = mainExports;
    }
  }
})({"52JVb":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _reactDom = require("react-dom");
var _reactRouterDom = require("react-router-dom");
var _layout = require("./scenes/layout");
var _layoutDefault = parcelHelpers.interopDefault(_layout);
var _unstated = require("unstated");
var _containerProvider = require("./ContainerProvider");
var _containerProviderDefault = parcelHelpers.interopDefault(_containerProvider);
const App = ()=>{
    return (0, _react.jsx)((0, _unstated.Provider), null, (0, _react.jsx)((0, _containerProviderDefault.default), null, (0, _react.jsx)((0, _reactRouterDom.BrowserRouter), null, (0, _react.jsx)((0, _reactRouterDom.Route), {
        path: "/",
        component: (0, _layoutDefault.default)
    }))));
};
(0, _reactDom.render)((0, _react.jsx)(App, null), document.querySelector("#root"));

},{"@emotion/react":"djZKr","react":"6uln9","react-dom":"b8T3j","react-router-dom":"5fzqq","./scenes/layout":"h3ugb","unstated":"grh7p","./ContainerProvider":"6DQJV","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"djZKr":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CacheProvider", ()=>(0, _emotionElementC39617D8BrowserEsmJs.C));
parcelHelpers.export(exports, "ThemeContext", ()=>(0, _emotionElementC39617D8BrowserEsmJs.T));
parcelHelpers.export(exports, "ThemeProvider", ()=>(0, _emotionElementC39617D8BrowserEsmJs.a));
parcelHelpers.export(exports, "__unsafe_useEmotionCache", ()=>(0, _emotionElementC39617D8BrowserEsmJs._));
parcelHelpers.export(exports, "useTheme", ()=>(0, _emotionElementC39617D8BrowserEsmJs.u));
parcelHelpers.export(exports, "withEmotionCache", ()=>(0, _emotionElementC39617D8BrowserEsmJs.w));
parcelHelpers.export(exports, "withTheme", ()=>(0, _emotionElementC39617D8BrowserEsmJs.b));
parcelHelpers.export(exports, "ClassNames", ()=>ClassNames);
parcelHelpers.export(exports, "Global", ()=>Global);
parcelHelpers.export(exports, "createElement", ()=>jsx);
parcelHelpers.export(exports, "css", ()=>css);
parcelHelpers.export(exports, "jsx", ()=>jsx);
parcelHelpers.export(exports, "keyframes", ()=>keyframes);
var _emotionElementC39617D8BrowserEsmJs = require("./emotion-element-c39617d8.browser.esm.js");
var _react = require("react");
var _utils = require("@emotion/utils");
var _useInsertionEffectWithFallbacks = require("@emotion/use-insertion-effect-with-fallbacks");
var _serialize = require("@emotion/serialize");
var _cache = require("@emotion/cache");
var _extends = require("@babel/runtime/helpers/extends");
var _weakMemoize = require("@emotion/weak-memoize");
var _emotionReactIsolatedHnrsBrowserEsmJs = require("../_isolated-hnrs/dist/emotion-react-_isolated-hnrs.browser.esm.js");
var _hoistNonReactStatics = require("hoist-non-react-statics");
var pkg = {
    name: "@emotion/react",
    version: "11.11.1",
    main: "dist/emotion-react.cjs.js",
    module: "dist/emotion-react.esm.js",
    browser: {
        "./dist/emotion-react.esm.js": "./dist/emotion-react.browser.esm.js"
    },
    exports: {
        ".": {
            module: {
                worker: "./dist/emotion-react.worker.esm.js",
                browser: "./dist/emotion-react.browser.esm.js",
                "default": "./dist/emotion-react.esm.js"
            },
            "import": "./dist/emotion-react.cjs.mjs",
            "default": "./dist/emotion-react.cjs.js"
        },
        "./jsx-runtime": {
            module: {
                worker: "./jsx-runtime/dist/emotion-react-jsx-runtime.worker.esm.js",
                browser: "./jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js",
                "default": "./jsx-runtime/dist/emotion-react-jsx-runtime.esm.js"
            },
            "import": "./jsx-runtime/dist/emotion-react-jsx-runtime.cjs.mjs",
            "default": "./jsx-runtime/dist/emotion-react-jsx-runtime.cjs.js"
        },
        "./_isolated-hnrs": {
            module: {
                worker: "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.worker.esm.js",
                browser: "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.browser.esm.js",
                "default": "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.esm.js"
            },
            "import": "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.cjs.mjs",
            "default": "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.cjs.js"
        },
        "./jsx-dev-runtime": {
            module: {
                worker: "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.worker.esm.js",
                browser: "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.browser.esm.js",
                "default": "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.esm.js"
            },
            "import": "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.cjs.mjs",
            "default": "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.cjs.js"
        },
        "./package.json": "./package.json",
        "./types/css-prop": "./types/css-prop.d.ts",
        "./macro": {
            types: {
                "import": "./macro.d.mts",
                "default": "./macro.d.ts"
            },
            "default": "./macro.js"
        }
    },
    types: "types/index.d.ts",
    files: [
        "src",
        "dist",
        "jsx-runtime",
        "jsx-dev-runtime",
        "_isolated-hnrs",
        "types/*.d.ts",
        "macro.*"
    ],
    sideEffects: false,
    author: "Emotion Contributors",
    license: "MIT",
    scripts: {
        "test:typescript": "dtslint types"
    },
    dependencies: {
        "@babel/runtime": "^7.18.3",
        "@emotion/babel-plugin": "^11.11.0",
        "@emotion/cache": "^11.11.0",
        "@emotion/serialize": "^1.1.2",
        "@emotion/use-insertion-effect-with-fallbacks": "^1.0.1",
        "@emotion/utils": "^1.2.1",
        "@emotion/weak-memoize": "^0.3.1",
        "hoist-non-react-statics": "^3.3.1"
    },
    peerDependencies: {
        react: ">=16.8.0"
    },
    peerDependenciesMeta: {
        "@types/react": {
            optional: true
        }
    },
    devDependencies: {
        "@definitelytyped/dtslint": "0.0.112",
        "@emotion/css": "11.11.0",
        "@emotion/css-prettifier": "1.1.3",
        "@emotion/server": "11.11.0",
        "@emotion/styled": "11.11.0",
        "html-tag-names": "^1.1.2",
        react: "16.14.0",
        "svg-tag-names": "^1.1.1",
        typescript: "^4.5.5"
    },
    repository: "https://github.com/emotion-js/emotion/tree/main/packages/react",
    publishConfig: {
        access: "public"
    },
    "umd:main": "dist/emotion-react.umd.min.js",
    preconstruct: {
        entrypoints: [
            "./index.js",
            "./jsx-runtime.js",
            "./jsx-dev-runtime.js",
            "./_isolated-hnrs.js"
        ],
        umdName: "emotionReact",
        exports: {
            envConditions: [
                "browser",
                "worker"
            ],
            extra: {
                "./types/css-prop": "./types/css-prop.d.ts",
                "./macro": {
                    types: {
                        "import": "./macro.d.mts",
                        "default": "./macro.d.ts"
                    },
                    "default": "./macro.js"
                }
            }
        }
    }
};
var jsx = function jsx(type, props) {
    var args = arguments;
    if (props == null || !(0, _emotionElementC39617D8BrowserEsmJs.h).call(props, "css")) // $FlowFixMe
    return _react.createElement.apply(undefined, args);
    var argsLength = args.length;
    var createElementArgArray = new Array(argsLength);
    createElementArgArray[0] = (0, _emotionElementC39617D8BrowserEsmJs.E);
    createElementArgArray[1] = (0, _emotionElementC39617D8BrowserEsmJs.c)(type, props);
    for(var i = 2; i < argsLength; i++)createElementArgArray[i] = args[i];
     // $FlowFixMe
    return _react.createElement.apply(null, createElementArgArray);
};
var warnedAboutCssPropForGlobal = false; // maintain place over rerenders.
// initial render from browser, insertBefore context.sheet.tags[0] or if a style hasn't been inserted there yet, appendChild
// initial client-side render from SSR, use place of hydrating tag
var Global = /* #__PURE__ */ (0, _emotionElementC39617D8BrowserEsmJs.w)(function(props, cache) {
    var styles = props.styles;
    var serialized = (0, _serialize.serializeStyles)([
        styles
    ], undefined, _react.useContext((0, _emotionElementC39617D8BrowserEsmJs.T)));
    if (!(0, _emotionElementC39617D8BrowserEsmJs.i)) {
        var _ref;
        var serializedNames = serialized.name;
        var serializedStyles = serialized.styles;
        var next = serialized.next;
        while(next !== undefined){
            serializedNames += " " + next.name;
            serializedStyles += next.styles;
            next = next.next;
        }
        var shouldCache = cache.compat === true;
        var rules = cache.insert("", {
            name: serializedNames,
            styles: serializedStyles
        }, cache.sheet, shouldCache);
        if (shouldCache) return null;
        return /*#__PURE__*/ _react.createElement("style", (_ref = {}, _ref["data-emotion"] = cache.key + "-global " + serializedNames, _ref.dangerouslySetInnerHTML = {
            __html: rules
        }, _ref.nonce = cache.sheet.nonce, _ref));
    } // yes, i know these hooks are used conditionally
    // but it is based on a constant that will never change at runtime
    // it's effectively like having two implementations and switching them out
    // so it's not actually breaking anything
    var sheetRef = _react.useRef();
    (0, _useInsertionEffectWithFallbacks.useInsertionEffectWithLayoutFallback)(function() {
        var key = cache.key + "-global"; // use case of https://github.com/emotion-js/emotion/issues/2675
        var sheet = new cache.sheet.constructor({
            key: key,
            nonce: cache.sheet.nonce,
            container: cache.sheet.container,
            speedy: cache.sheet.isSpeedy
        });
        var rehydrating = false; // $FlowFixMe
        var node = document.querySelector('style[data-emotion="' + key + " " + serialized.name + '"]');
        if (cache.sheet.tags.length) sheet.before = cache.sheet.tags[0];
        if (node !== null) {
            rehydrating = true; // clear the hash so this node won't be recognizable as rehydratable by other <Global/>s
            node.setAttribute("data-emotion", key);
            sheet.hydrate([
                node
            ]);
        }
        sheetRef.current = [
            sheet,
            rehydrating
        ];
        return function() {
            sheet.flush();
        };
    }, [
        cache
    ]);
    (0, _useInsertionEffectWithFallbacks.useInsertionEffectWithLayoutFallback)(function() {
        var sheetRefCurrent = sheetRef.current;
        var sheet = sheetRefCurrent[0], rehydrating = sheetRefCurrent[1];
        if (rehydrating) {
            sheetRefCurrent[1] = false;
            return;
        }
        if (serialized.next !== undefined) // insert keyframes
        (0, _utils.insertStyles)(cache, serialized.next, true);
        if (sheet.tags.length) {
            // if this doesn't exist then it will be null so the style element will be appended
            var element = sheet.tags[sheet.tags.length - 1].nextElementSibling;
            sheet.before = element;
            sheet.flush();
        }
        cache.insert("", serialized, sheet, false);
    }, [
        cache,
        serialized.name
    ]);
    return null;
});
function css() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return (0, _serialize.serializeStyles)(args);
}
var keyframes = function keyframes() {
    var insertable = css.apply(void 0, arguments);
    var name = "animation-" + insertable.name; // $FlowFixMe
    return {
        name: name,
        styles: "@keyframes " + name + "{" + insertable.styles + "}",
        anim: 1,
        toString: function toString() {
            return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
        }
    };
};
var classnames = function classnames(args) {
    var len = args.length;
    var i = 0;
    var cls = "";
    for(; i < len; i++){
        var arg = args[i];
        if (arg == null) continue;
        var toAdd = void 0;
        switch(typeof arg){
            case "boolean":
                break;
            case "object":
                if (Array.isArray(arg)) toAdd = classnames(arg);
                else {
                    toAdd = "";
                    for(var k in arg)if (arg[k] && k) {
                        toAdd && (toAdd += " ");
                        toAdd += k;
                    }
                }
                break;
            default:
                toAdd = arg;
        }
        if (toAdd) {
            cls && (cls += " ");
            cls += toAdd;
        }
    }
    return cls;
};
function merge(registered, css, className) {
    var registeredStyles = [];
    var rawClassName = (0, _utils.getRegisteredStyles)(registered, registeredStyles, className);
    if (registeredStyles.length < 2) return className;
    return rawClassName + css(registeredStyles);
}
var Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serializedArr = _ref.serializedArr;
    (0, _useInsertionEffectWithFallbacks.useInsertionEffectAlwaysWithSyncFallback)(function() {
        for(var i = 0; i < serializedArr.length; i++)(0, _utils.insertStyles)(cache, serializedArr[i], false);
    });
    return null;
};
var ClassNames = /* #__PURE__ */ (0, _emotionElementC39617D8BrowserEsmJs.w)(function(props, cache) {
    var hasRendered = false;
    var serializedArr = [];
    var css = function css() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        var serialized = (0, _serialize.serializeStyles)(args, cache.registered);
        serializedArr.push(serialized); // registration has to happen here as the result of this might get consumed by `cx`
        (0, _utils.registerStyles)(cache, serialized, false);
        return cache.key + "-" + serialized.name;
    };
    var cx = function cx() {
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        return merge(cache.registered, css, classnames(args));
    };
    var content = {
        css: css,
        cx: cx,
        theme: _react.useContext((0, _emotionElementC39617D8BrowserEsmJs.T))
    };
    var ele = props.children(content);
    hasRendered = true;
    return /*#__PURE__*/ _react.createElement(_react.Fragment, null, /*#__PURE__*/ _react.createElement(Insertion, {
        cache: cache,
        serializedArr: serializedArr
    }), ele);
});
var isBrowser, isTestEnv, globalContext, globalKey;

},{"./emotion-element-c39617d8.browser.esm.js":"1xu50","react":"6uln9","@emotion/utils":"firjl","@emotion/use-insertion-effect-with-fallbacks":"d1zky","@emotion/serialize":"2Iv9c","@emotion/cache":"dJbf5","@babel/runtime/helpers/extends":"4iKIP","@emotion/weak-memoize":"9scve","../_isolated-hnrs/dist/emotion-react-_isolated-hnrs.browser.esm.js":"8wO4V","hoist-non-react-statics":"3bvdc","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1xu50":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "C", ()=>CacheProvider);
parcelHelpers.export(exports, "E", ()=>Emotion$1);
parcelHelpers.export(exports, "T", ()=>ThemeContext);
parcelHelpers.export(exports, "_", ()=>__unsafe_useEmotionCache);
parcelHelpers.export(exports, "a", ()=>ThemeProvider);
parcelHelpers.export(exports, "b", ()=>withTheme);
parcelHelpers.export(exports, "c", ()=>createEmotionProps);
parcelHelpers.export(exports, "h", ()=>hasOwnProperty);
parcelHelpers.export(exports, "i", ()=>isBrowser);
parcelHelpers.export(exports, "u", ()=>useTheme);
parcelHelpers.export(exports, "w", ()=>withEmotionCache);
var _react = require("react");
var _cache = require("@emotion/cache");
var _cacheDefault = parcelHelpers.interopDefault(_cache);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _weakMemoize = require("@emotion/weak-memoize");
var _weakMemoizeDefault = parcelHelpers.interopDefault(_weakMemoize);
var _emotionReactIsolatedHnrsBrowserEsmJs = require("../_isolated-hnrs/dist/emotion-react-_isolated-hnrs.browser.esm.js");
var _emotionReactIsolatedHnrsBrowserEsmJsDefault = parcelHelpers.interopDefault(_emotionReactIsolatedHnrsBrowserEsmJs);
var _utils = require("@emotion/utils");
var _serialize = require("@emotion/serialize");
var _useInsertionEffectWithFallbacks = require("@emotion/use-insertion-effect-with-fallbacks");
var isBrowser = true;
var hasOwnProperty = {}.hasOwnProperty;
var EmotionCacheContext = /* #__PURE__ */ _react.createContext(// because this module is primarily intended for the browser and node
// but it's also required in react native and similar environments sometimes
// and we could have a special build just for that
// but this is much easier and the native packages
// might use a different theme context in the future anyway
typeof HTMLElement !== "undefined" ? /* #__PURE__ */ (0, _cacheDefault.default)({
    key: "css"
}) : null);
var CacheProvider = EmotionCacheContext.Provider;
var __unsafe_useEmotionCache = function useEmotionCache() {
    return (0, _react.useContext)(EmotionCacheContext);
};
var withEmotionCache = function withEmotionCache(func) {
    // $FlowFixMe
    return /*#__PURE__*/ (0, _react.forwardRef)(function(props, ref) {
        // the cache will never be null in the browser
        var cache = (0, _react.useContext)(EmotionCacheContext);
        return func(props, cache, ref);
    });
};
if (!isBrowser) withEmotionCache = function withEmotionCache(func) {
    return function(props) {
        var cache = (0, _react.useContext)(EmotionCacheContext);
        if (cache === null) {
            // yes, we're potentially creating this on every render
            // it doesn't actually matter though since it's only on the server
            // so there will only every be a single render
            // that could change in the future because of suspense and etc. but for now,
            // this works and i don't want to optimise for a future thing that we aren't sure about
            cache = (0, _cacheDefault.default)({
                key: "css"
            });
            return /*#__PURE__*/ _react.createElement(EmotionCacheContext.Provider, {
                value: cache
            }, func(props, cache));
        } else return func(props, cache);
    };
};
var ThemeContext = /* #__PURE__ */ _react.createContext({});
var useTheme = function useTheme() {
    return _react.useContext(ThemeContext);
};
var getTheme = function getTheme(outerTheme, theme) {
    if (typeof theme === "function") {
        var mergedTheme = theme(outerTheme);
        return mergedTheme;
    }
    return (0, _extendsDefault.default)({}, outerTheme, theme);
};
var createCacheWithTheme = /* #__PURE__ */ (0, _weakMemoizeDefault.default)(function(outerTheme) {
    return (0, _weakMemoizeDefault.default)(function(theme) {
        return getTheme(outerTheme, theme);
    });
});
var ThemeProvider = function ThemeProvider(props) {
    var theme = _react.useContext(ThemeContext);
    if (props.theme !== theme) theme = createCacheWithTheme(theme)(props.theme);
    return /*#__PURE__*/ _react.createElement(ThemeContext.Provider, {
        value: theme
    }, props.children);
};
function withTheme(Component) {
    var componentName = Component.displayName || Component.name || "Component";
    var render = function render(props, ref) {
        var theme = _react.useContext(ThemeContext);
        return /*#__PURE__*/ _react.createElement(Component, (0, _extendsDefault.default)({
            theme: theme,
            ref: ref
        }, props));
    }; // $FlowFixMe
    var WithTheme = /*#__PURE__*/ _react.forwardRef(render);
    WithTheme.displayName = "WithTheme(" + componentName + ")";
    return (0, _emotionReactIsolatedHnrsBrowserEsmJsDefault.default)(WithTheme, Component);
}
var getLastPart = function getLastPart(functionName) {
    // The match may be something like 'Object.createEmotionProps' or
    // 'Loader.prototype.render'
    var parts = functionName.split(".");
    return parts[parts.length - 1];
};
var getFunctionNameFromStackTraceLine = function getFunctionNameFromStackTraceLine(line) {
    // V8
    var match = /^\s+at\s+([A-Za-z0-9$.]+)\s/.exec(line);
    if (match) return getLastPart(match[1]); // Safari / Firefox
    match = /^([A-Za-z0-9$.]+)@/.exec(line);
    if (match) return getLastPart(match[1]);
    return undefined;
};
var internalReactFunctionNames = /* #__PURE__ */ new Set([
    "renderWithHooks",
    "processChild",
    "finishClassComponent",
    "renderToString"
]); // These identifiers come from error stacks, so they have to be valid JS
// identifiers, thus we only need to replace what is a valid character for JS,
// but not for CSS.
var sanitizeIdentifier = function sanitizeIdentifier(identifier) {
    return identifier.replace(/\$/g, "-");
};
var getLabelFromStackTrace = function getLabelFromStackTrace(stackTrace) {
    if (!stackTrace) return undefined;
    var lines = stackTrace.split("\n");
    for(var i = 0; i < lines.length; i++){
        var functionName = getFunctionNameFromStackTraceLine(lines[i]); // The first line of V8 stack traces is just "Error"
        if (!functionName) continue; // If we reach one of these, we have gone too far and should quit
        if (internalReactFunctionNames.has(functionName)) break; // The component name is the first function in the stack that starts with an
        // uppercase letter
        if (/^[A-Z]/.test(functionName)) return sanitizeIdentifier(functionName);
    }
    return undefined;
};
var typePropName = "__EMOTION_TYPE_PLEASE_DO_NOT_USE__";
var labelPropName = "__EMOTION_LABEL_PLEASE_DO_NOT_USE__";
var createEmotionProps = function createEmotionProps(type, props) {
    var newProps = {};
    for(var key in props)if (hasOwnProperty.call(props, key)) newProps[key] = props[key];
    newProps[typePropName] = type; // For performance, only call getLabelFromStackTrace in development and when
    var label;
    return newProps;
};
var Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serialized = _ref.serialized, isStringTag = _ref.isStringTag;
    (0, _utils.registerStyles)(cache, serialized, isStringTag);
    (0, _useInsertionEffectWithFallbacks.useInsertionEffectAlwaysWithSyncFallback)(function() {
        return (0, _utils.insertStyles)(cache, serialized, isStringTag);
    });
    return null;
};
var Emotion = /* #__PURE__ */ withEmotionCache(function(props, cache, ref) {
    var cssProp = props.css; // so that using `css` from `emotion` and passing the result to the css prop works
    // not passing the registered cache to serializeStyles because it would
    // make certain babel optimisations not possible
    if (typeof cssProp === "string" && cache.registered[cssProp] !== undefined) cssProp = cache.registered[cssProp];
    var WrappedComponent = props[typePropName];
    var registeredStyles = [
        cssProp
    ];
    var className = "";
    if (typeof props.className === "string") className = (0, _utils.getRegisteredStyles)(cache.registered, registeredStyles, props.className);
    else if (props.className != null) className = props.className + " ";
    var serialized = (0, _serialize.serializeStyles)(registeredStyles, undefined, _react.useContext(ThemeContext));
    var labelFromStack;
    className += cache.key + "-" + serialized.name;
    var newProps = {};
    for(var key in props)if (hasOwnProperty.call(props, key) && key !== "css" && key !== typePropName && true) newProps[key] = props[key];
    newProps.ref = ref;
    newProps.className = className;
    return /*#__PURE__*/ _react.createElement(_react.Fragment, null, /*#__PURE__*/ _react.createElement(Insertion, {
        cache: cache,
        serialized: serialized,
        isStringTag: typeof WrappedComponent === "string"
    }), /*#__PURE__*/ _react.createElement(WrappedComponent, newProps));
});
var Emotion$1 = Emotion;

},{"react":"6uln9","@emotion/cache":"dJbf5","@babel/runtime/helpers/esm/extends":"fW5l8","@emotion/weak-memoize":"9scve","../_isolated-hnrs/dist/emotion-react-_isolated-hnrs.browser.esm.js":"8wO4V","@emotion/utils":"firjl","@emotion/serialize":"2Iv9c","@emotion/use-insertion-effect-with-fallbacks":"d1zky","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6uln9":[function(require,module,exports) {
"use strict";
module.exports = require("956f36295e4e0134");

},{"956f36295e4e0134":"8n7Eb"}],"8n7Eb":[function(require,module,exports) {
/** @license React v17.0.2
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var l = require("f790cf940e488cc5"), n = 60103, p = 60106;
exports.Fragment = 60107;
exports.StrictMode = 60108;
exports.Profiler = 60114;
var q = 60109, r = 60110, t = 60112;
exports.Suspense = 60113;
var u = 60115, v = 60116;
if ("function" === typeof Symbol && Symbol.for) {
    var w = Symbol.for;
    n = w("react.element");
    p = w("react.portal");
    exports.Fragment = w("react.fragment");
    exports.StrictMode = w("react.strict_mode");
    exports.Profiler = w("react.profiler");
    q = w("react.provider");
    r = w("react.context");
    t = w("react.forward_ref");
    exports.Suspense = w("react.suspense");
    u = w("react.memo");
    v = w("react.lazy");
}
var x = "function" === typeof Symbol && Symbol.iterator;
function y(a) {
    if (null === a || "object" !== typeof a) return null;
    a = x && a[x] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
function z(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var A = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, B = {};
function C(a, b, c) {
    this.props = a;
    this.context = b;
    this.refs = B;
    this.updater = c || A;
}
C.prototype.isReactComponent = {};
C.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error(z(85));
    this.updater.enqueueSetState(this, a, b, "setState");
};
C.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function D() {}
D.prototype = C.prototype;
function E(a, b, c) {
    this.props = a;
    this.context = b;
    this.refs = B;
    this.updater = c || A;
}
var F = E.prototype = new D;
F.constructor = E;
l(F, C.prototype);
F.isPureReactComponent = !0;
var G = {
    current: null
}, H = Object.prototype.hasOwnProperty, I = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function J(a, b, c) {
    var e, d = {}, k = null, h = null;
    if (null != b) for(e in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)H.call(b, e) && !I.hasOwnProperty(e) && (d[e] = b[e]);
    var g = arguments.length - 2;
    if (1 === g) d.children = c;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        d.children = f;
    }
    if (a && a.defaultProps) for(e in g = a.defaultProps, g)void 0 === d[e] && (d[e] = g[e]);
    return {
        $$typeof: n,
        type: a,
        key: k,
        ref: h,
        props: d,
        _owner: G.current
    };
}
function K(a, b) {
    return {
        $$typeof: n,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function L(a) {
    return "object" === typeof a && null !== a && a.$$typeof === n;
}
function escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var M = /\/+/g;
function N(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? escape("" + a.key) : b.toString(36);
}
function O(a, b, c, e, d) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case n:
                case p:
                    h = !0;
            }
    }
    if (h) return h = a, d = d(h), a = "" === e ? "." + N(h, 0) : e, Array.isArray(d) ? (c = "", null != a && (c = a.replace(M, "$&/") + "/"), O(d, b, c, "", function(a) {
        return a;
    })) : null != d && (L(d) && (d = K(d, c + (!d.key || h && h.key === d.key ? "" : ("" + d.key).replace(M, "$&/") + "/") + a)), b.push(d)), 1;
    h = 0;
    e = "" === e ? "." : e + ":";
    if (Array.isArray(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = e + N(k, g);
        h += O(k, b, c, f, d);
    }
    else if (f = y(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = e + N(k, g++), h += O(k, b, c, f, d);
    else if ("object" === k) throw b = "" + a, Error(z(31, "[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b));
    return h;
}
function P(a, b, c) {
    if (null == a) return a;
    var e = [], d = 0;
    O(a, e, "", "", function(a) {
        return b.call(c, a, d++);
    });
    return e;
}
function Q(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        a._status = 0;
        a._result = b;
        b.then(function(b) {
            0 === a._status && (b = b.default, a._status = 1, a._result = b);
        }, function(b) {
            0 === a._status && (a._status = 2, a._result = b);
        });
    }
    if (1 === a._status) return a._result;
    throw a._result;
}
var R = {
    current: null
};
function S() {
    var a = R.current;
    if (null === a) throw Error(z(321));
    return a;
}
var T = {
    ReactCurrentDispatcher: R,
    ReactCurrentBatchConfig: {
        transition: 0
    },
    ReactCurrentOwner: G,
    IsSomeRendererActing: {
        current: !1
    },
    assign: l
};
exports.Children = {
    map: P,
    forEach: function(a, b, c) {
        P(a, function() {
            b.apply(this, arguments);
        }, c);
    },
    count: function(a) {
        var b = 0;
        P(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return P(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!L(a)) throw Error(z(143));
        return a;
    }
};
exports.Component = C;
exports.PureComponent = E;
exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = T;
exports.cloneElement = function(a, b, c) {
    if (null === a || void 0 === a) throw Error(z(267, a));
    var e = l({}, a.props), d = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = G.current);
        void 0 !== b.key && (d = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)H.call(b, f) && !I.hasOwnProperty(f) && (e[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) e.children = c;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        e.children = g;
    }
    return {
        $$typeof: n,
        type: a.type,
        key: d,
        ref: k,
        props: e,
        _owner: h
    };
};
exports.createContext = function(a, b) {
    void 0 === b && (b = null);
    a = {
        $$typeof: r,
        _calculateChangedBits: b,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null
    };
    a.Provider = {
        $$typeof: q,
        _context: a
    };
    return a.Consumer = a;
};
exports.createElement = J;
exports.createFactory = function(a) {
    var b = J.bind(null, a);
    b.type = a;
    return b;
};
exports.createRef = function() {
    return {
        current: null
    };
};
exports.forwardRef = function(a) {
    return {
        $$typeof: t,
        render: a
    };
};
exports.isValidElement = L;
exports.lazy = function(a) {
    return {
        $$typeof: v,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: Q
    };
};
exports.memo = function(a, b) {
    return {
        $$typeof: u,
        type: a,
        compare: void 0 === b ? null : b
    };
};
exports.useCallback = function(a, b) {
    return S().useCallback(a, b);
};
exports.useContext = function(a, b) {
    return S().useContext(a, b);
};
exports.useDebugValue = function() {};
exports.useEffect = function(a, b) {
    return S().useEffect(a, b);
};
exports.useImperativeHandle = function(a, b, c) {
    return S().useImperativeHandle(a, b, c);
};
exports.useLayoutEffect = function(a, b) {
    return S().useLayoutEffect(a, b);
};
exports.useMemo = function(a, b) {
    return S().useMemo(a, b);
};
exports.useReducer = function(a, b, c) {
    return S().useReducer(a, b, c);
};
exports.useRef = function(a) {
    return S().useRef(a);
};
exports.useState = function(a) {
    return S().useState(a);
};
exports.version = "17.0.2";

},{"f790cf940e488cc5":"hdgcG"}],"hdgcG":[function(require,module,exports) {
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/ "use strict";
/* eslint-disable no-unused-vars */ var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;
function toObject(val) {
    if (val === null || val === undefined) throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(val);
}
function shouldUseNative() {
    try {
        if (!Object.assign) return false;
        // Detect buggy property enumeration order in older V8 versions.
        // https://bugs.chromium.org/p/v8/issues/detail?id=4118
        var test1 = new String("abc"); // eslint-disable-line no-new-wrappers
        test1[5] = "de";
        if (Object.getOwnPropertyNames(test1)[0] === "5") return false;
        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test2 = {};
        for(var i = 0; i < 10; i++)test2["_" + String.fromCharCode(i)] = i;
        var order2 = Object.getOwnPropertyNames(test2).map(function(n) {
            return test2[n];
        });
        if (order2.join("") !== "0123456789") return false;
        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test3 = {};
        "abcdefghijklmnopqrst".split("").forEach(function(letter) {
            test3[letter] = letter;
        });
        if (Object.keys(Object.assign({}, test3)).join("") !== "abcdefghijklmnopqrst") return false;
        return true;
    } catch (err) {
        // We don't expect any of the above to throw, but better to be safe.
        return false;
    }
}
module.exports = shouldUseNative() ? Object.assign : function(target, source) {
    var from;
    var to = toObject(target);
    var symbols;
    for(var s = 1; s < arguments.length; s++){
        from = Object(arguments[s]);
        for(var key in from)if (hasOwnProperty.call(from, key)) to[key] = from[key];
        if (getOwnPropertySymbols) {
            symbols = getOwnPropertySymbols(from);
            for(var i = 0; i < symbols.length; i++)if (propIsEnumerable.call(from, symbols[i])) to[symbols[i]] = from[symbols[i]];
        }
    }
    return to;
};

},{}],"dJbf5":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>createCache);
var _sheet = require("@emotion/sheet");
var _stylis = require("stylis");
var _weakMemoize = require("@emotion/weak-memoize");
var _memoize = require("@emotion/memoize");
var identifierWithPointTracking = function identifierWithPointTracking(begin, points, index) {
    var previous = 0;
    var character = 0;
    while(true){
        previous = character;
        character = (0, _stylis.peek)(); // &\f
        if (previous === 38 && character === 12) points[index] = 1;
        if ((0, _stylis.token)(character)) break;
        (0, _stylis.next)();
    }
    return (0, _stylis.slice)(begin, (0, _stylis.position));
};
var toRules = function toRules(parsed, points) {
    // pretend we've started with a comma
    var index = -1;
    var character = 44;
    do switch((0, _stylis.token)(character)){
        case 0:
            // &\f
            if (character === 38 && (0, _stylis.peek)() === 12) // this is not 100% correct, we don't account for literal sequences here - like for example quoted strings
            // stylis inserts \f after & to know when & where it should replace this sequence with the context selector
            // and when it should just concatenate the outer and inner selectors
            // it's very unlikely for this sequence to actually appear in a different context, so we just leverage this fact here
            points[index] = 1;
            parsed[index] += identifierWithPointTracking((0, _stylis.position) - 1, points, index);
            break;
        case 2:
            parsed[index] += (0, _stylis.delimit)(character);
            break;
        case 4:
            // comma
            if (character === 44) {
                // colon
                parsed[++index] = (0, _stylis.peek)() === 58 ? "&\f" : "";
                points[index] = parsed[index].length;
                break;
            }
        // fallthrough
        default:
            parsed[index] += (0, _stylis.from)(character);
    }
    while (character = (0, _stylis.next)());
    return parsed;
};
var getRules = function getRules(value, points) {
    return (0, _stylis.dealloc)(toRules((0, _stylis.alloc)(value), points));
}; // WeakSet would be more appropriate, but only WeakMap is supported in IE11
var fixedElements = /* #__PURE__ */ new WeakMap();
var compat = function compat(element) {
    if (element.type !== "rule" || !element.parent || // positive .length indicates that this rule contains pseudo
    // negative .length indicates that this rule has been already prefixed
    element.length < 1) return;
    var value = element.value, parent = element.parent;
    var isImplicitRule = element.column === parent.column && element.line === parent.line;
    while(parent.type !== "rule"){
        parent = parent.parent;
        if (!parent) return;
    } // short-circuit for the simplest case
    if (element.props.length === 1 && value.charCodeAt(0) !== 58 && !fixedElements.get(parent)) return;
     // if this is an implicitly inserted rule (the one eagerly inserted at the each new nested level)
    // then the props has already been manipulated beforehand as they that array is shared between it and its "rule parent"
    if (isImplicitRule) return;
    fixedElements.set(element, true);
    var points = [];
    var rules = getRules(value, points);
    var parentRules = parent.props;
    for(var i = 0, k = 0; i < rules.length; i++)for(var j = 0; j < parentRules.length; j++, k++)element.props[k] = points[i] ? rules[i].replace(/&\f/g, parentRules[j]) : parentRules[j] + " " + rules[i];
};
var removeLabel = function removeLabel(element) {
    if (element.type === "decl") {
        var value = element.value;
        if (value.charCodeAt(0) === 108 && // charcode for b
        value.charCodeAt(2) === 98) {
            // this ignores label
            element["return"] = "";
            element.value = "";
        }
    }
};
var ignoreFlag = "emotion-disable-server-rendering-unsafe-selector-warning-please-do-not-use-this-the-warning-exists-for-a-reason";
var isIgnoringComment = function isIgnoringComment(element) {
    return element.type === "comm" && element.children.indexOf(ignoreFlag) > -1;
};
var createUnsafeSelectorsAlarm = function createUnsafeSelectorsAlarm(cache) {
    return function(element, index, children) {
        if (element.type !== "rule" || cache.compat) return;
        var unsafePseudoClasses = element.value.match(/(:first|:nth|:nth-last)-child/g);
        if (unsafePseudoClasses) {
            var isNested = !!element.parent; // in nested rules comments become children of the "auto-inserted" rule and that's always the `element.parent`
            //
            // considering this input:
            // .a {
            //   .b /* comm */ {}
            //   color: hotpink;
            // }
            // we get output corresponding to this:
            // .a {
            //   & {
            //     /* comm */
            //     color: hotpink;
            //   }
            //   .b {}
            // }
            var commentContainer = isNested ? element.parent.children : children;
            for(var i = commentContainer.length - 1; i >= 0; i--){
                var node = commentContainer[i];
                if (node.line < element.line) break;
                 // it is quite weird but comments are *usually* put at `column: element.column - 1`
                // so we seek *from the end* for the node that is earlier than the rule's `element` and check that
                // this will also match inputs like this:
                // .a {
                //   /* comm */
                //   .b {}
                // }
                //
                // but that is fine
                //
                // it would be the easiest to change the placement of the comment to be the first child of the rule:
                // .a {
                //   .b { /* comm */ }
                // }
                // with such inputs we wouldn't have to search for the comment at all
                // TODO: consider changing this comment placement in the next major version
                if (node.column < element.column) {
                    if (isIgnoringComment(node)) return;
                    break;
                }
            }
            unsafePseudoClasses.forEach(function(unsafePseudoClass) {
                console.error('The pseudo class "' + unsafePseudoClass + '" is potentially unsafe when doing server-side rendering. Try changing it to "' + unsafePseudoClass.split("-child")[0] + '-of-type".');
            });
        }
    };
};
var isImportRule = function isImportRule(element) {
    return element.type.charCodeAt(1) === 105 && element.type.charCodeAt(0) === 64;
};
var isPrependedWithRegularRules = function isPrependedWithRegularRules(index, children) {
    for(var i = index - 1; i >= 0; i--){
        if (!isImportRule(children[i])) return true;
    }
    return false;
}; // use this to remove incorrect elements from further processing
// so they don't get handed to the `sheet` (or anything else)
// as that could potentially lead to additional logs which in turn could be overhelming to the user
var nullifyElement = function nullifyElement(element) {
    element.type = "";
    element.value = "";
    element["return"] = "";
    element.children = "";
    element.props = "";
};
var incorrectImportAlarm = function incorrectImportAlarm(element, index, children) {
    if (!isImportRule(element)) return;
    if (element.parent) {
        console.error("`@import` rules can't be nested inside other rules. Please move it to the top level and put it before regular rules. Keep in mind that they can only be used within global styles.");
        nullifyElement(element);
    } else if (isPrependedWithRegularRules(index, children)) {
        console.error("`@import` rules can't be after other rules. Please put your `@import` rules before your other rules.");
        nullifyElement(element);
    }
};
/* eslint-disable no-fallthrough */ function prefix(value, length) {
    switch((0, _stylis.hash)(value, length)){
        // color-adjust
        case 5103:
            return (0, _stylis.WEBKIT) + "print-" + value + value;
        // animation, animation-(delay|direction|duration|fill-mode|iteration-count|name|play-state|timing-function)
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return (0, _stylis.WEBKIT) + value + value;
        // appearance, user-select, transform, hyphens, text-size-adjust
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return (0, _stylis.WEBKIT) + value + (0, _stylis.MOZ) + value + (0, _stylis.MS) + value + value;
        // flex, flex-direction
        case 6828:
        case 4268:
            return (0, _stylis.WEBKIT) + value + (0, _stylis.MS) + value + value;
        // order
        case 6165:
            return (0, _stylis.WEBKIT) + value + (0, _stylis.MS) + "flex-" + value + value;
        // align-items
        case 5187:
            return (0, _stylis.WEBKIT) + value + (0, _stylis.replace)(value, /(\w+).+(:[^]+)/, (0, _stylis.WEBKIT) + "box-$1$2" + (0, _stylis.MS) + "flex-$1$2") + value;
        // align-self
        case 5443:
            return (0, _stylis.WEBKIT) + value + (0, _stylis.MS) + "flex-item-" + (0, _stylis.replace)(value, /flex-|-self/, "") + value;
        // align-content
        case 4675:
            return (0, _stylis.WEBKIT) + value + (0, _stylis.MS) + "flex-line-pack" + (0, _stylis.replace)(value, /align-content|flex-|-self/, "") + value;
        // flex-shrink
        case 5548:
            return (0, _stylis.WEBKIT) + value + (0, _stylis.MS) + (0, _stylis.replace)(value, "shrink", "negative") + value;
        // flex-basis
        case 5292:
            return (0, _stylis.WEBKIT) + value + (0, _stylis.MS) + (0, _stylis.replace)(value, "basis", "preferred-size") + value;
        // flex-grow
        case 6060:
            return (0, _stylis.WEBKIT) + "box-" + (0, _stylis.replace)(value, "-grow", "") + (0, _stylis.WEBKIT) + value + (0, _stylis.MS) + (0, _stylis.replace)(value, "grow", "positive") + value;
        // transition
        case 4554:
            return (0, _stylis.WEBKIT) + (0, _stylis.replace)(value, /([^-])(transform)/g, "$1" + (0, _stylis.WEBKIT) + "$2") + value;
        // cursor
        case 6187:
            return (0, _stylis.replace)((0, _stylis.replace)((0, _stylis.replace)(value, /(zoom-|grab)/, (0, _stylis.WEBKIT) + "$1"), /(image-set)/, (0, _stylis.WEBKIT) + "$1"), value, "") + value;
        // background, background-image
        case 5495:
        case 3959:
            return (0, _stylis.replace)(value, /(image-set\([^]*)/, (0, _stylis.WEBKIT) + "$1" + "$`$1");
        // justify-content
        case 4968:
            return (0, _stylis.replace)((0, _stylis.replace)(value, /(.+:)(flex-)?(.*)/, (0, _stylis.WEBKIT) + "box-pack:$3" + (0, _stylis.MS) + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + (0, _stylis.WEBKIT) + value + value;
        // (margin|padding)-inline-(start|end)
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return (0, _stylis.replace)(value, /(.+)-inline(.+)/, (0, _stylis.WEBKIT) + "$1$2") + value;
        // (min|max)?(width|height|inline-size|block-size)
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            // stretch, max-content, min-content, fill-available
            if ((0, _stylis.strlen)(value) - 1 - length > 6) switch((0, _stylis.charat)(value, length + 1)){
                // (m)ax-content, (m)in-content
                case 109:
                    // -
                    if ((0, _stylis.charat)(value, length + 4) !== 45) break;
                // (f)ill-available, (f)it-content
                case 102:
                    return (0, _stylis.replace)(value, /(.+:)(.+)-([^]+)/, "$1" + (0, _stylis.WEBKIT) + "$2-$3" + "$1" + (0, _stylis.MOZ) + ((0, _stylis.charat)(value, length + 3) == 108 ? "$3" : "$2-$3")) + value;
                // (s)tretch
                case 115:
                    return ~(0, _stylis.indexof)(value, "stretch") ? prefix((0, _stylis.replace)(value, "stretch", "fill-available"), length) + value : value;
            }
            break;
        // position: sticky
        case 4949:
            // (s)ticky?
            if ((0, _stylis.charat)(value, length + 1) !== 115) break;
        // display: (flex|inline-flex)
        case 6444:
            switch((0, _stylis.charat)(value, (0, _stylis.strlen)(value) - 3 - (~(0, _stylis.indexof)(value, "!important") && 10))){
                // stic(k)y
                case 107:
                    return (0, _stylis.replace)(value, ":", ":" + (0, _stylis.WEBKIT)) + value;
                // (inline-)?fl(e)x
                case 101:
                    return (0, _stylis.replace)(value, /(.+:)([^;!]+)(;|!.+)?/, "$1" + (0, _stylis.WEBKIT) + ((0, _stylis.charat)(value, 14) === 45 ? "inline-" : "") + "box$3" + "$1" + (0, _stylis.WEBKIT) + "$2$3" + "$1" + (0, _stylis.MS) + "$2box$3") + value;
            }
            break;
        // writing-mode
        case 5936:
            switch((0, _stylis.charat)(value, length + 11)){
                // vertical-l(r)
                case 114:
                    return (0, _stylis.WEBKIT) + value + (0, _stylis.MS) + (0, _stylis.replace)(value, /[svh]\w+-[tblr]{2}/, "tb") + value;
                // vertical-r(l)
                case 108:
                    return (0, _stylis.WEBKIT) + value + (0, _stylis.MS) + (0, _stylis.replace)(value, /[svh]\w+-[tblr]{2}/, "tb-rl") + value;
                // horizontal(-)tb
                case 45:
                    return (0, _stylis.WEBKIT) + value + (0, _stylis.MS) + (0, _stylis.replace)(value, /[svh]\w+-[tblr]{2}/, "lr") + value;
            }
            return (0, _stylis.WEBKIT) + value + (0, _stylis.MS) + value + value;
    }
    return value;
}
var prefixer = function prefixer(element, index, children, callback) {
    if (element.length > -1) {
        if (!element["return"]) switch(element.type){
            case 0, _stylis.DECLARATION:
                element["return"] = prefix(element.value, element.length);
                break;
            case 0, _stylis.KEYFRAMES:
                return (0, _stylis.serialize)([
                    (0, _stylis.copy)(element, {
                        value: (0, _stylis.replace)(element.value, "@", "@" + (0, _stylis.WEBKIT))
                    })
                ], callback);
            case 0, _stylis.RULESET:
                if (element.length) return (0, _stylis.combine)(element.props, function(value) {
                    switch((0, _stylis.match)(value, /(::plac\w+|:read-\w+)/)){
                        // :read-(only|write)
                        case ":read-only":
                        case ":read-write":
                            return (0, _stylis.serialize)([
                                (0, _stylis.copy)(element, {
                                    props: [
                                        (0, _stylis.replace)(value, /:(read-\w+)/, ":" + (0, _stylis.MOZ) + "$1")
                                    ]
                                })
                            ], callback);
                        // :placeholder
                        case "::placeholder":
                            return (0, _stylis.serialize)([
                                (0, _stylis.copy)(element, {
                                    props: [
                                        (0, _stylis.replace)(value, /:(plac\w+)/, ":" + (0, _stylis.WEBKIT) + "input-$1")
                                    ]
                                }),
                                (0, _stylis.copy)(element, {
                                    props: [
                                        (0, _stylis.replace)(value, /:(plac\w+)/, ":" + (0, _stylis.MOZ) + "$1")
                                    ]
                                }),
                                (0, _stylis.copy)(element, {
                                    props: [
                                        (0, _stylis.replace)(value, /:(plac\w+)/, (0, _stylis.MS) + "input-$1")
                                    ]
                                })
                            ], callback);
                    }
                    return "";
                });
        }
    }
};
var defaultStylisPlugins = [
    prefixer
];
var createCache = function createCache(options) {
    var key = options.key;
    if (key === "css") {
        var ssrStyles = document.querySelectorAll("style[data-emotion]:not([data-s])"); // get SSRed styles out of the way of React's hydration
        // document.head is a safe place to move them to(though note document.head is not necessarily the last place they will be)
        // note this very very intentionally targets all style elements regardless of the key to ensure
        // that creating a cache works inside of render of a React component
        Array.prototype.forEach.call(ssrStyles, function(node) {
            // we want to only move elements which have a space in the data-emotion attribute value
            // because that indicates that it is an Emotion 11 server-side rendered style elements
            // while we will already ignore Emotion 11 client-side inserted styles because of the :not([data-s]) part in the selector
            // Emotion 10 client-side inserted styles did not have data-s (but importantly did not have a space in their data-emotion attributes)
            // so checking for the space ensures that loading Emotion 11 after Emotion 10 has inserted some styles
            // will not result in the Emotion 10 styles being destroyed
            var dataEmotionAttribute = node.getAttribute("data-emotion");
            if (dataEmotionAttribute.indexOf(" ") === -1) return;
            document.head.appendChild(node);
            node.setAttribute("data-s", "");
        });
    }
    var stylisPlugins = options.stylisPlugins || defaultStylisPlugins;
    var inserted = {};
    var container;
    var nodesToHydrate = [];
    container = options.container || document.head;
    Array.prototype.forEach.call(// means that the style elements we're looking at are only Emotion 11 server-rendered style elements
    document.querySelectorAll('style[data-emotion^="' + key + ' "]'), function(node) {
        var attrib = node.getAttribute("data-emotion").split(" "); // $FlowFixMe
        for(var i = 1; i < attrib.length; i++)inserted[attrib[i]] = true;
        nodesToHydrate.push(node);
    });
    var _insert;
    var omnipresentPlugins = [
        compat,
        removeLabel
    ];
    var currentSheet;
    var finalizingPlugins = [
        (0, _stylis.stringify),
        (0, _stylis.rulesheet)(function(rule) {
            currentSheet.insert(rule);
        })
    ];
    var serializer = (0, _stylis.middleware)(omnipresentPlugins.concat(stylisPlugins, finalizingPlugins));
    var stylis = function stylis(styles) {
        return (0, _stylis.serialize)((0, _stylis.compile)(styles), serializer);
    };
    _insert = function insert(selector, serialized, sheet, shouldCache) {
        currentSheet = sheet;
        stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);
        if (shouldCache) cache.inserted[serialized.name] = true;
    };
    var cache = {
        key: key,
        sheet: new (0, _sheet.StyleSheet)({
            key: key,
            container: container,
            nonce: options.nonce,
            speedy: options.speedy,
            prepend: options.prepend,
            insertionPoint: options.insertionPoint
        }),
        nonce: options.nonce,
        inserted: inserted,
        registered: {},
        insert: _insert
    };
    cache.sheet.hydrate(nodesToHydrate);
    return cache;
};

},{"@emotion/sheet":"8lIuE","stylis":"lfeQC","@emotion/weak-memoize":"9scve","@emotion/memoize":"dMybP","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8lIuE":[function(require,module,exports) {
/*

Based off glamor's StyleSheet, thanks Sunil ❤️

high performance StyleSheet for css-in-js systems

- uses multiple style tags behind the scenes for millions of rules
- uses `insertRule` for appending in production for *much* faster performance

// usage

import { StyleSheet } from '@emotion/sheet'

let styleSheet = new StyleSheet({ key: '', container: document.head })

styleSheet.insert('#box { border: 1px solid red; }')
- appends a css rule into the stylesheet

styleSheet.flush()
- empties the stylesheet of all its contents

*/ // $FlowFixMe
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StyleSheet", ()=>StyleSheet);
function sheetForTag(tag) {
    if (tag.sheet) // $FlowFixMe
    return tag.sheet;
     // this weirdness brought to you by firefox
    /* istanbul ignore next */ for(var i = 0; i < document.styleSheets.length; i++){
        if (document.styleSheets[i].ownerNode === tag) // $FlowFixMe
        return document.styleSheets[i];
    }
}
function createStyleElement(options) {
    var tag = document.createElement("style");
    tag.setAttribute("data-emotion", options.key);
    if (options.nonce !== undefined) tag.setAttribute("nonce", options.nonce);
    tag.appendChild(document.createTextNode(""));
    tag.setAttribute("data-s", "");
    return tag;
}
var StyleSheet = /*#__PURE__*/ function() {
    // Using Node instead of HTMLElement since container may be a ShadowRoot
    function StyleSheet(options) {
        var _this = this;
        this._insertTag = function(tag) {
            var before;
            if (_this.tags.length === 0) {
                if (_this.insertionPoint) before = _this.insertionPoint.nextSibling;
                else if (_this.prepend) before = _this.container.firstChild;
                else before = _this.before;
            } else before = _this.tags[_this.tags.length - 1].nextSibling;
            _this.container.insertBefore(tag, before);
            _this.tags.push(tag);
        };
        this.isSpeedy = options.speedy === undefined ? true : options.speedy;
        this.tags = [];
        this.ctr = 0;
        this.nonce = options.nonce; // key is the value of the data-emotion attribute, it's used to identify different sheets
        this.key = options.key;
        this.container = options.container;
        this.prepend = options.prepend;
        this.insertionPoint = options.insertionPoint;
        this.before = null;
    }
    var _proto = StyleSheet.prototype;
    _proto.hydrate = function hydrate(nodes) {
        nodes.forEach(this._insertTag);
    };
    _proto.insert = function insert(rule) {
        // the max length is how many rules we have per style tag, it's 65000 in speedy mode
        // it's 1 in dev because we insert source maps that map a single rule to a location
        // and you can only have one source map per style tag
        if (this.ctr % (this.isSpeedy ? 65000 : 1) === 0) this._insertTag(createStyleElement(this));
        var tag = this.tags[this.tags.length - 1];
        var isImportRule;
        if (this.isSpeedy) {
            var sheet = sheetForTag(tag);
            try {
                // this is the ultrafast version, works across browsers
                // the big drawback is that the css won't be editable in devtools
                sheet.insertRule(rule, sheet.cssRules.length);
            } catch (e) {}
        } else tag.appendChild(document.createTextNode(rule));
        this.ctr++;
    };
    _proto.flush = function flush() {
        // $FlowFixMe
        this.tags.forEach(function(tag) {
            return tag.parentNode && tag.parentNode.removeChild(tag);
        });
        this.tags = [];
        this.ctr = 0;
    };
    return StyleSheet;
}();

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"k3151":[function(require,module,exports) {
exports.interopDefault = function(a) {
    return a && a.__esModule ? a : {
        default: a
    };
};
exports.defineInteropFlag = function(a) {
    Object.defineProperty(a, "__esModule", {
        value: true
    });
};
exports.exportAll = function(source, dest) {
    Object.keys(source).forEach(function(key) {
        if (key === "default" || key === "__esModule" || dest.hasOwnProperty(key)) return;
        Object.defineProperty(dest, key, {
            enumerable: true,
            get: function() {
                return source[key];
            }
        });
    });
    return dest;
};
exports.export = function(dest, destName, get) {
    Object.defineProperty(dest, destName, {
        enumerable: true,
        get: get
    });
};

},{}],"lfeQC":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CHARSET", ()=>f);
parcelHelpers.export(exports, "COMMENT", ()=>n);
parcelHelpers.export(exports, "COUNTER_STYLE", ()=>w);
parcelHelpers.export(exports, "DECLARATION", ()=>s);
parcelHelpers.export(exports, "DOCUMENT", ()=>v);
parcelHelpers.export(exports, "FONT_FACE", ()=>b);
parcelHelpers.export(exports, "FONT_FEATURE_VALUES", ()=>d);
parcelHelpers.export(exports, "IMPORT", ()=>i);
parcelHelpers.export(exports, "KEYFRAMES", ()=>h);
parcelHelpers.export(exports, "LAYER", ()=>$);
parcelHelpers.export(exports, "MEDIA", ()=>u);
parcelHelpers.export(exports, "MOZ", ()=>r);
parcelHelpers.export(exports, "MS", ()=>e);
parcelHelpers.export(exports, "NAMESPACE", ()=>p);
parcelHelpers.export(exports, "PAGE", ()=>t);
parcelHelpers.export(exports, "RULESET", ()=>c);
parcelHelpers.export(exports, "SUPPORTS", ()=>l);
parcelHelpers.export(exports, "VIEWPORT", ()=>o);
parcelHelpers.export(exports, "WEBKIT", ()=>a);
parcelHelpers.export(exports, "abs", ()=>g);
parcelHelpers.export(exports, "alloc", ()=>V);
parcelHelpers.export(exports, "append", ()=>q);
parcelHelpers.export(exports, "assign", ()=>m);
parcelHelpers.export(exports, "caret", ()=>R);
parcelHelpers.export(exports, "char", ()=>L);
parcelHelpers.export(exports, "character", ()=>H);
parcelHelpers.export(exports, "characters", ()=>I);
parcelHelpers.export(exports, "charat", ()=>O);
parcelHelpers.export(exports, "column", ()=>E);
parcelHelpers.export(exports, "combine", ()=>B);
parcelHelpers.export(exports, "comment", ()=>ue);
parcelHelpers.export(exports, "commenter", ()=>ae);
parcelHelpers.export(exports, "compile", ()=>ce);
parcelHelpers.export(exports, "copy", ()=>K);
parcelHelpers.export(exports, "dealloc", ()=>W);
parcelHelpers.export(exports, "declaration", ()=>ie);
parcelHelpers.export(exports, "delimit", ()=>X);
parcelHelpers.export(exports, "delimiter", ()=>re);
parcelHelpers.export(exports, "escaping", ()=>ee);
parcelHelpers.export(exports, "from", ()=>k);
parcelHelpers.export(exports, "hash", ()=>x);
parcelHelpers.export(exports, "identifier", ()=>ne);
parcelHelpers.export(exports, "indexof", ()=>C);
parcelHelpers.export(exports, "length", ()=>F);
parcelHelpers.export(exports, "line", ()=>D);
parcelHelpers.export(exports, "match", ()=>j);
parcelHelpers.export(exports, "middleware", ()=>ve);
parcelHelpers.export(exports, "namespace", ()=>be);
parcelHelpers.export(exports, "next", ()=>P);
parcelHelpers.export(exports, "node", ()=>J);
parcelHelpers.export(exports, "parse", ()=>se);
parcelHelpers.export(exports, "peek", ()=>Q);
parcelHelpers.export(exports, "position", ()=>G);
parcelHelpers.export(exports, "prefix", ()=>fe);
parcelHelpers.export(exports, "prefixer", ()=>he);
parcelHelpers.export(exports, "prev", ()=>N);
parcelHelpers.export(exports, "replace", ()=>z);
parcelHelpers.export(exports, "ruleset", ()=>te);
parcelHelpers.export(exports, "rulesheet", ()=>pe);
parcelHelpers.export(exports, "serialize", ()=>oe);
parcelHelpers.export(exports, "sizeof", ()=>S);
parcelHelpers.export(exports, "slice", ()=>T);
parcelHelpers.export(exports, "stringify", ()=>le);
parcelHelpers.export(exports, "strlen", ()=>M);
parcelHelpers.export(exports, "substr", ()=>A);
parcelHelpers.export(exports, "token", ()=>U);
parcelHelpers.export(exports, "tokenize", ()=>Y);
parcelHelpers.export(exports, "tokenizer", ()=>_);
parcelHelpers.export(exports, "trim", ()=>y);
parcelHelpers.export(exports, "whitespace", ()=>Z);
var e = "-ms-";
var r = "-moz-";
var a = "-webkit-";
var n = "comm";
var c = "rule";
var s = "decl";
var t = "@page";
var u = "@media";
var i = "@import";
var f = "@charset";
var o = "@viewport";
var l = "@supports";
var v = "@document";
var p = "@namespace";
var h = "@keyframes";
var b = "@font-face";
var w = "@counter-style";
var d = "@font-feature-values";
var $ = "@layer";
var g = Math.abs;
var k = String.fromCharCode;
var m = Object.assign;
function x(e, r) {
    return O(e, 0) ^ 45 ? (((r << 2 ^ O(e, 0)) << 2 ^ O(e, 1)) << 2 ^ O(e, 2)) << 2 ^ O(e, 3) : 0;
}
function y(e) {
    return e.trim();
}
function j(e, r) {
    return (e = r.exec(e)) ? e[0] : e;
}
function z(e, r, a) {
    return e.replace(r, a);
}
function C(e, r) {
    return e.indexOf(r);
}
function O(e, r) {
    return e.charCodeAt(r) | 0;
}
function A(e, r, a) {
    return e.slice(r, a);
}
function M(e) {
    return e.length;
}
function S(e) {
    return e.length;
}
function q(e, r) {
    return r.push(e), e;
}
function B(e, r) {
    return e.map(r).join("");
}
var D = 1;
var E = 1;
var F = 0;
var G = 0;
var H = 0;
var I = "";
function J(e, r, a, n, c, s, t) {
    return {
        value: e,
        root: r,
        parent: a,
        type: n,
        props: c,
        children: s,
        line: D,
        column: E,
        length: t,
        return: ""
    };
}
function K(e, r) {
    return m(J("", null, null, "", null, null, 0), e, {
        length: -e.length
    }, r);
}
function L() {
    return H;
}
function N() {
    H = G > 0 ? O(I, --G) : 0;
    if (E--, H === 10) E = 1, D--;
    return H;
}
function P() {
    H = G < F ? O(I, G++) : 0;
    if (E++, H === 10) E = 1, D++;
    return H;
}
function Q() {
    return O(I, G);
}
function R() {
    return G;
}
function T(e, r) {
    return A(I, e, r);
}
function U(e) {
    switch(e){
        case 0:
        case 9:
        case 10:
        case 13:
        case 32:
            return 5;
        case 33:
        case 43:
        case 44:
        case 47:
        case 62:
        case 64:
        case 126:
        case 59:
        case 123:
        case 125:
            return 4;
        case 58:
            return 3;
        case 34:
        case 39:
        case 40:
        case 91:
            return 2;
        case 41:
        case 93:
            return 1;
    }
    return 0;
}
function V(e) {
    return D = E = 1, F = M(I = e), G = 0, [];
}
function W(e) {
    return I = "", e;
}
function X(e) {
    return y(T(G - 1, re(e === 91 ? e + 2 : e === 40 ? e + 1 : e)));
}
function Y(e) {
    return W(_(V(e)));
}
function Z(e) {
    while(H = Q())if (H < 33) P();
    else break;
    return U(e) > 2 || U(H) > 3 ? "" : " ";
}
function _(e) {
    while(P())switch(U(H)){
        case 0:
            q(ne(G - 1), e);
            break;
        case 2:
            q(X(H), e);
            break;
        default:
            q(k(H), e);
    }
    return e;
}
function ee(e, r) {
    while(--r && P())if (H < 48 || H > 102 || H > 57 && H < 65 || H > 70 && H < 97) break;
    return T(e, R() + (r < 6 && Q() == 32 && P() == 32));
}
function re(e) {
    while(P())switch(H){
        case e:
            return G;
        case 34:
        case 39:
            if (e !== 34 && e !== 39) re(H);
            break;
        case 40:
            if (e === 41) re(e);
            break;
        case 92:
            P();
            break;
    }
    return G;
}
function ae(e, r) {
    while(P())if (e + H === 57) break;
    else if (e + H === 84 && Q() === 47) break;
    return "/*" + T(r, G - 1) + "*" + k(e === 47 ? e : P());
}
function ne(e) {
    while(!U(Q()))P();
    return T(e, G);
}
function ce(e) {
    return W(se("", null, null, null, [
        ""
    ], e = V(e), 0, [
        0
    ], e));
}
function se(e, r, a, n, c, s, t, u, i) {
    var f = 0;
    var o = 0;
    var l = t;
    var v = 0;
    var p = 0;
    var h = 0;
    var b = 1;
    var w = 1;
    var d = 1;
    var $ = 0;
    var g = "";
    var m = c;
    var x = s;
    var y = n;
    var j = g;
    while(w)switch(h = $, $ = P()){
        case 40:
            if (h != 108 && O(j, l - 1) == 58) {
                if (C(j += z(X($), "&", "&\f"), "&\f") != -1) d = -1;
                break;
            }
        case 34:
        case 39:
        case 91:
            j += X($);
            break;
        case 9:
        case 10:
        case 13:
        case 32:
            j += Z(h);
            break;
        case 92:
            j += ee(R() - 1, 7);
            continue;
        case 47:
            switch(Q()){
                case 42:
                case 47:
                    q(ue(ae(P(), R()), r, a), i);
                    break;
                default:
                    j += "/";
            }
            break;
        case 123 * b:
            u[f++] = M(j) * d;
        case 125 * b:
        case 59:
        case 0:
            switch($){
                case 0:
                case 125:
                    w = 0;
                case 59 + o:
                    if (d == -1) j = z(j, /\f/g, "");
                    if (p > 0 && M(j) - l) q(p > 32 ? ie(j + ";", n, a, l - 1) : ie(z(j, " ", "") + ";", n, a, l - 2), i);
                    break;
                case 59:
                    j += ";";
                default:
                    q(y = te(j, r, a, f, o, c, u, g, m = [], x = [], l), s);
                    if ($ === 123) {
                        if (o === 0) se(j, r, y, y, m, s, l, u, x);
                        else switch(v === 99 && O(j, 3) === 110 ? 100 : v){
                            case 100:
                            case 108:
                            case 109:
                            case 115:
                                se(e, y, y, n && q(te(e, y, y, 0, 0, c, u, g, c, m = [], l), x), c, x, l, u, n ? m : x);
                                break;
                            default:
                                se(j, y, y, y, [
                                    ""
                                ], x, 0, u, x);
                        }
                    }
            }
            f = o = p = 0, b = d = 1, g = j = "", l = t;
            break;
        case 58:
            l = 1 + M(j), p = h;
        default:
            if (b < 1) {
                if ($ == 123) --b;
                else if ($ == 125 && b++ == 0 && N() == 125) continue;
            }
            switch(j += k($), $ * b){
                case 38:
                    d = o > 0 ? 1 : (j += "\f", -1);
                    break;
                case 44:
                    u[f++] = (M(j) - 1) * d, d = 1;
                    break;
                case 64:
                    if (Q() === 45) j += X(P());
                    v = Q(), o = l = M(g = j += ne(R())), $++;
                    break;
                case 45:
                    if (h === 45 && M(j) == 2) b = 0;
            }
    }
    return s;
}
function te(e, r, a, n, s, t, u, i, f, o, l) {
    var v = s - 1;
    var p = s === 0 ? t : [
        ""
    ];
    var h = S(p);
    for(var b = 0, w = 0, d = 0; b < n; ++b)for(var $ = 0, k = A(e, v + 1, v = g(w = u[b])), m = e; $ < h; ++$)if (m = y(w > 0 ? p[$] + " " + k : z(k, /&\f/g, p[$]))) f[d++] = m;
    return J(e, r, a, s === 0 ? c : i, f, o, l);
}
function ue(e, r, a) {
    return J(e, r, a, n, k(L()), A(e, 2, -2), 0);
}
function ie(e, r, a, n) {
    return J(e, r, a, s, A(e, 0, n), A(e, n + 1, -1), n);
}
function fe(n, c, s) {
    switch(x(n, c)){
        case 5103:
            return a + "print-" + n + n;
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return a + n + n;
        case 4789:
            return r + n + n;
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return a + n + r + n + e + n + n;
        case 5936:
            switch(O(n, c + 11)){
                case 114:
                    return a + n + e + z(n, /[svh]\w+-[tblr]{2}/, "tb") + n;
                case 108:
                    return a + n + e + z(n, /[svh]\w+-[tblr]{2}/, "tb-rl") + n;
                case 45:
                    return a + n + e + z(n, /[svh]\w+-[tblr]{2}/, "lr") + n;
            }
        case 6828:
        case 4268:
        case 2903:
            return a + n + e + n + n;
        case 6165:
            return a + n + e + "flex-" + n + n;
        case 5187:
            return a + n + z(n, /(\w+).+(:[^]+)/, a + "box-$1$2" + e + "flex-$1$2") + n;
        case 5443:
            return a + n + e + "flex-item-" + z(n, /flex-|-self/g, "") + (!j(n, /flex-|baseline/) ? e + "grid-row-" + z(n, /flex-|-self/g, "") : "") + n;
        case 4675:
            return a + n + e + "flex-line-pack" + z(n, /align-content|flex-|-self/g, "") + n;
        case 5548:
            return a + n + e + z(n, "shrink", "negative") + n;
        case 5292:
            return a + n + e + z(n, "basis", "preferred-size") + n;
        case 6060:
            return a + "box-" + z(n, "-grow", "") + a + n + e + z(n, "grow", "positive") + n;
        case 4554:
            return a + z(n, /([^-])(transform)/g, "$1" + a + "$2") + n;
        case 6187:
            return z(z(z(n, /(zoom-|grab)/, a + "$1"), /(image-set)/, a + "$1"), n, "") + n;
        case 5495:
        case 3959:
            return z(n, /(image-set\([^]*)/, a + "$1" + "$`$1");
        case 4968:
            return z(z(n, /(.+:)(flex-)?(.*)/, a + "box-pack:$3" + e + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + a + n + n;
        case 4200:
            if (!j(n, /flex-|baseline/)) return e + "grid-column-align" + A(n, c) + n;
            break;
        case 2592:
        case 3360:
            return e + z(n, "template-", "") + n;
        case 4384:
        case 3616:
            if (s && s.some(function(e, r) {
                return c = r, j(e.props, /grid-\w+-end/);
            })) return ~C(n + (s = s[c].value), "span") ? n : e + z(n, "-start", "") + n + e + "grid-row-span:" + (~C(s, "span") ? j(s, /\d+/) : +j(s, /\d+/) - +j(n, /\d+/)) + ";";
            return e + z(n, "-start", "") + n;
        case 4896:
        case 4128:
            return s && s.some(function(e) {
                return j(e.props, /grid-\w+-start/);
            }) ? n : e + z(z(n, "-end", "-span"), "span ", "") + n;
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return z(n, /(.+)-inline(.+)/, a + "$1$2") + n;
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            if (M(n) - 1 - c > 6) switch(O(n, c + 1)){
                case 109:
                    if (O(n, c + 4) !== 45) break;
                case 102:
                    return z(n, /(.+:)(.+)-([^]+)/, "$1" + a + "$2-$3" + "$1" + r + (O(n, c + 3) == 108 ? "$3" : "$2-$3")) + n;
                case 115:
                    return ~C(n, "stretch") ? fe(z(n, "stretch", "fill-available"), c, s) + n : n;
            }
            break;
        case 5152:
        case 5920:
            return z(n, /(.+?):(\d+)(\s*\/\s*(span)?\s*(\d+))?(.*)/, function(r, a, c, s, t, u, i) {
                return e + a + ":" + c + i + (s ? e + a + "-span:" + (t ? u : +u - +c) + i : "") + n;
            });
        case 4949:
            if (O(n, c + 6) === 121) return z(n, ":", ":" + a) + n;
            break;
        case 6444:
            switch(O(n, O(n, 14) === 45 ? 18 : 11)){
                case 120:
                    return z(n, /(.+:)([^;\s!]+)(;|(\s+)?!.+)?/, "$1" + a + (O(n, 14) === 45 ? "inline-" : "") + "box$3" + "$1" + a + "$2$3" + "$1" + e + "$2box$3") + n;
                case 100:
                    return z(n, ":", ":" + e) + n;
            }
            break;
        case 5719:
        case 2647:
        case 2135:
        case 3927:
        case 2391:
            return z(n, "scroll-", "scroll-snap-") + n;
    }
    return n;
}
function oe(e, r) {
    var a = "";
    var n = S(e);
    for(var c = 0; c < n; c++)a += r(e[c], c, e, r) || "";
    return a;
}
function le(e, r, a, t) {
    switch(e.type){
        case $:
            if (e.children.length) break;
        case i:
        case s:
            return e.return = e.return || e.value;
        case n:
            return "";
        case h:
            return e.return = e.value + "{" + oe(e.children, t) + "}";
        case c:
            e.value = e.props.join(",");
    }
    return M(a = oe(e.children, t)) ? e.return = e.value + "{" + a + "}" : "";
}
function ve(e) {
    var r = S(e);
    return function(a, n, c, s) {
        var t = "";
        for(var u = 0; u < r; u++)t += e[u](a, n, c, s) || "";
        return t;
    };
}
function pe(e) {
    return function(r) {
        if (!r.root) {
            if (r = r.return) e(r);
        }
    };
}
function he(n, t, u, i) {
    if (n.length > -1) {
        if (!n.return) switch(n.type){
            case s:
                n.return = fe(n.value, n.length, u);
                return;
            case h:
                return oe([
                    K(n, {
                        value: z(n.value, "@", "@" + a)
                    })
                ], i);
            case c:
                if (n.length) return B(n.props, function(c) {
                    switch(j(c, /(::plac\w+|:read-\w+)/)){
                        case ":read-only":
                        case ":read-write":
                            return oe([
                                K(n, {
                                    props: [
                                        z(c, /:(read-\w+)/, ":" + r + "$1")
                                    ]
                                })
                            ], i);
                        case "::placeholder":
                            return oe([
                                K(n, {
                                    props: [
                                        z(c, /:(plac\w+)/, ":" + a + "input-$1")
                                    ]
                                }),
                                K(n, {
                                    props: [
                                        z(c, /:(plac\w+)/, ":" + r + "$1")
                                    ]
                                }),
                                K(n, {
                                    props: [
                                        z(c, /:(plac\w+)/, e + "input-$1")
                                    ]
                                })
                            ], i);
                    }
                    return "";
                });
        }
    }
}
function be(e) {
    switch(e.type){
        case c:
            e.props = e.props.map(function(r) {
                return B(Y(r), function(r, a, n) {
                    switch(O(r, 0)){
                        case 12:
                            return A(r, 1, M(r));
                        case 0:
                        case 40:
                        case 43:
                        case 62:
                        case 126:
                            return r;
                        case 58:
                            if (n[++a] === "global") n[a] = "", n[++a] = "\f" + A(n[a], a = 1, -1);
                        case 32:
                            return a === 1 ? "" : r;
                        default:
                            switch(a){
                                case 0:
                                    e = r;
                                    return S(n) > 1 ? "" : r;
                                case a = S(n) - 1:
                                case 2:
                                    return a === 2 ? r + e + e : r + e;
                                default:
                                    return r;
                            }
                    }
                });
            });
    }
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9scve":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>weakMemoize);
var weakMemoize = function weakMemoize(func) {
    // $FlowFixMe flow doesn't include all non-primitive types as allowed for weakmaps
    var cache = new WeakMap();
    return function(arg) {
        if (cache.has(arg)) // $FlowFixMe
        return cache.get(arg);
        var ret = func(arg);
        cache.set(arg, ret);
        return ret;
    };
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"dMybP":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>memoize);
function memoize(fn) {
    var cache = Object.create(null);
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"fW5l8":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_extends);
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8wO4V":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>hoistNonReactStatics);
var _hoistNonReactStatics = require("hoist-non-react-statics");
var _hoistNonReactStaticsDefault = parcelHelpers.interopDefault(_hoistNonReactStatics);
// this file isolates this package that is not tree-shakeable
// and if this module doesn't actually contain any logic of its own
// then Rollup just use 'hoist-non-react-statics' directly in other chunks
var hoistNonReactStatics = function(targetComponent, sourceComponent) {
    return (0, _hoistNonReactStaticsDefault.default)(targetComponent, sourceComponent);
};

},{"hoist-non-react-statics":"3bvdc","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3bvdc":[function(require,module,exports) {
"use strict";
var reactIs = require("c03b486d83967636");
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */ var REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var FORWARD_REF_STATICS = {
    "$$typeof": true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var MEMO_STATICS = {
    "$$typeof": true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var TYPE_STATICS = {};
TYPE_STATICS[reactIs.ForwardRef] = FORWARD_REF_STATICS;
TYPE_STATICS[reactIs.Memo] = MEMO_STATICS;
function getStatics(component) {
    // React v16.11 and below
    if (reactIs.isMemo(component)) return MEMO_STATICS;
     // React v16.12 and above
    return TYPE_STATICS[component["$$typeof"]] || REACT_STATICS;
}
var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = Object.prototype;
function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== "string") {
        // don't hoist over string (html) components
        if (objectPrototype) {
            var inheritedComponent = getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== objectPrototype) hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
        }
        var keys = getOwnPropertyNames(sourceComponent);
        if (getOwnPropertySymbols) keys = keys.concat(getOwnPropertySymbols(sourceComponent));
        var targetStatics = getStatics(targetComponent);
        var sourceStatics = getStatics(sourceComponent);
        for(var i = 0; i < keys.length; ++i){
            var key = keys[i];
            if (!KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    // Avoid failures from read-only properties
                    defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
module.exports = hoistNonReactStatics;

},{"c03b486d83967636":"aUAsc"}],"aUAsc":[function(require,module,exports) {
"use strict";
module.exports = require("f93b3bf7385544f5");

},{"f93b3bf7385544f5":"1Qg5l"}],"1Qg5l":[function(require,module,exports) {
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var b = "function" === typeof Symbol && Symbol.for, c = b ? Symbol.for("react.element") : 60103, d = b ? Symbol.for("react.portal") : 60106, e = b ? Symbol.for("react.fragment") : 60107, f = b ? Symbol.for("react.strict_mode") : 60108, g = b ? Symbol.for("react.profiler") : 60114, h = b ? Symbol.for("react.provider") : 60109, k = b ? Symbol.for("react.context") : 60110, l = b ? Symbol.for("react.async_mode") : 60111, m = b ? Symbol.for("react.concurrent_mode") : 60111, n = b ? Symbol.for("react.forward_ref") : 60112, p = b ? Symbol.for("react.suspense") : 60113, q = b ? Symbol.for("react.suspense_list") : 60120, r = b ? Symbol.for("react.memo") : 60115, t = b ? Symbol.for("react.lazy") : 60116, v = b ? Symbol.for("react.block") : 60121, w = b ? Symbol.for("react.fundamental") : 60117, x = b ? Symbol.for("react.responder") : 60118, y = b ? Symbol.for("react.scope") : 60119;
function z(a) {
    if ("object" === typeof a && null !== a) {
        var u = a.$$typeof;
        switch(u){
            case c:
                switch(a = a.type, a){
                    case l:
                    case m:
                    case e:
                    case g:
                    case f:
                    case p:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case k:
                            case n:
                            case t:
                            case r:
                            case h:
                                return a;
                            default:
                                return u;
                        }
                }
            case d:
                return u;
        }
    }
}
function A(a) {
    return z(a) === m;
}
exports.AsyncMode = l;
exports.ConcurrentMode = m;
exports.ContextConsumer = k;
exports.ContextProvider = h;
exports.Element = c;
exports.ForwardRef = n;
exports.Fragment = e;
exports.Lazy = t;
exports.Memo = r;
exports.Portal = d;
exports.Profiler = g;
exports.StrictMode = f;
exports.Suspense = p;
exports.isAsyncMode = function(a) {
    return A(a) || z(a) === l;
};
exports.isConcurrentMode = A;
exports.isContextConsumer = function(a) {
    return z(a) === k;
};
exports.isContextProvider = function(a) {
    return z(a) === h;
};
exports.isElement = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === c;
};
exports.isForwardRef = function(a) {
    return z(a) === n;
};
exports.isFragment = function(a) {
    return z(a) === e;
};
exports.isLazy = function(a) {
    return z(a) === t;
};
exports.isMemo = function(a) {
    return z(a) === r;
};
exports.isPortal = function(a) {
    return z(a) === d;
};
exports.isProfiler = function(a) {
    return z(a) === g;
};
exports.isStrictMode = function(a) {
    return z(a) === f;
};
exports.isSuspense = function(a) {
    return z(a) === p;
};
exports.isValidElementType = function(a) {
    return "string" === typeof a || "function" === typeof a || a === e || a === m || a === g || a === f || a === p || a === q || "object" === typeof a && null !== a && (a.$$typeof === t || a.$$typeof === r || a.$$typeof === h || a.$$typeof === k || a.$$typeof === n || a.$$typeof === w || a.$$typeof === x || a.$$typeof === y || a.$$typeof === v);
};
exports.typeOf = z;

},{}],"firjl":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getRegisteredStyles", ()=>getRegisteredStyles);
parcelHelpers.export(exports, "insertStyles", ()=>insertStyles);
parcelHelpers.export(exports, "registerStyles", ()=>registerStyles);
var isBrowser = true;
function getRegisteredStyles(registered, registeredStyles, classNames) {
    var rawClassName = "";
    classNames.split(" ").forEach(function(className) {
        if (registered[className] !== undefined) registeredStyles.push(registered[className] + ";");
        else rawClassName += className + " ";
    });
    return rawClassName;
}
var registerStyles = function registerStyles(cache, serialized, isStringTag) {
    var className = cache.key + "-" + serialized.name;
    if (// class name could be used further down
    // the tree but if it's a string tag, we know it won't
    // so we don't have to add it to registered cache.
    // this improves memory usage since we can avoid storing the whole style string
    (isStringTag === false || // we need to always store it if we're in compat mode and
    // in node since emotion-server relies on whether a style is in
    // the registered cache to know whether a style is global or not
    // also, note that this check will be dead code eliminated in the browser
    isBrowser === false) && cache.registered[className] === undefined) cache.registered[className] = serialized.styles;
};
var insertStyles = function insertStyles(cache, serialized, isStringTag) {
    registerStyles(cache, serialized, isStringTag);
    var className = cache.key + "-" + serialized.name;
    if (cache.inserted[serialized.name] === undefined) {
        var current = serialized;
        do {
            cache.insert(serialized === current ? "." + className : "", current, cache.sheet, true);
            current = current.next;
        }while (current !== undefined);
    }
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2Iv9c":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "serializeStyles", ()=>serializeStyles);
var _hash = require("@emotion/hash");
var _hashDefault = parcelHelpers.interopDefault(_hash);
var _unitless = require("@emotion/unitless");
var _unitlessDefault = parcelHelpers.interopDefault(_unitless);
var _memoize = require("@emotion/memoize");
var _memoizeDefault = parcelHelpers.interopDefault(_memoize);
var ILLEGAL_ESCAPE_SEQUENCE_ERROR = "You have illegal escape sequence in your template literal, most likely inside content's property value.\nBecause you write your CSS inside a JavaScript string you actually have to do double escaping, so for example \"content: '\\00d7';\" should become \"content: '\\\\00d7';\".\nYou can read more about this here:\nhttps://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences";
var UNDEFINED_AS_OBJECT_KEY_ERROR = "You have passed in falsy value as style object's key (can happen when in example you pass unexported component as computed key).";
var hyphenateRegex = /[A-Z]|^ms/g;
var animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;
var isCustomProperty = function isCustomProperty(property) {
    return property.charCodeAt(1) === 45;
};
var isProcessableValue = function isProcessableValue(value) {
    return value != null && typeof value !== "boolean";
};
var processStyleName = /* #__PURE__ */ (0, _memoizeDefault.default)(function(styleName) {
    return isCustomProperty(styleName) ? styleName : styleName.replace(hyphenateRegex, "-$&").toLowerCase();
});
var processStyleValue = function processStyleValue(key, value) {
    switch(key){
        case "animation":
        case "animationName":
            if (typeof value === "string") return value.replace(animationRegex, function(match, p1, p2) {
                cursor = {
                    name: p1,
                    styles: p2,
                    next: cursor
                };
                return p1;
            });
    }
    if ((0, _unitlessDefault.default)[key] !== 1 && !isCustomProperty(key) && typeof value === "number" && value !== 0) return value + "px";
    return value;
};
var contentValuePattern, contentValues, oldProcessStyleValue, msPattern, hyphenPattern, hyphenatedCache;
var noComponentSelectorMessage = "Component selectors can only be used in conjunction with @emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware compiler transform.";
function handleInterpolation(mergedProps, registered, interpolation) {
    if (interpolation == null) return "";
    if (interpolation.__emotion_styles !== undefined) return interpolation;
    switch(typeof interpolation){
        case "boolean":
            return "";
        case "object":
            if (interpolation.anim === 1) {
                cursor = {
                    name: interpolation.name,
                    styles: interpolation.styles,
                    next: cursor
                };
                return interpolation.name;
            }
            if (interpolation.styles !== undefined) {
                var next = interpolation.next;
                if (next !== undefined) // not the most efficient thing ever but this is a pretty rare case
                // and there will be very few iterations of this generally
                while(next !== undefined){
                    cursor = {
                        name: next.name,
                        styles: next.styles,
                        next: cursor
                    };
                    next = next.next;
                }
                var styles = interpolation.styles + ";";
                return styles;
            }
            return createStringFromObject(mergedProps, registered, interpolation);
        case "function":
            if (mergedProps !== undefined) {
                var previousCursor = cursor;
                var result = interpolation(mergedProps);
                cursor = previousCursor;
                return handleInterpolation(mergedProps, registered, result);
            }
            break;
        case "string":
            var matched, replaced;
            break;
    } // finalize string values (regular strings and functions interpolated into css calls)
    if (registered == null) return interpolation;
    var cached = registered[interpolation];
    return cached !== undefined ? cached : interpolation;
}
function createStringFromObject(mergedProps, registered, obj) {
    var string = "";
    if (Array.isArray(obj)) for(var i = 0; i < obj.length; i++)string += handleInterpolation(mergedProps, registered, obj[i]) + ";";
    else for(var _key in obj){
        var value = obj[_key];
        if (typeof value !== "object") {
            if (registered != null && registered[value] !== undefined) string += _key + "{" + registered[value] + "}";
            else if (isProcessableValue(value)) string += processStyleName(_key) + ":" + processStyleValue(_key, value) + ";";
        } else if (Array.isArray(value) && typeof value[0] === "string" && (registered == null || registered[value[0]] === undefined)) {
            for(var _i = 0; _i < value.length; _i++)if (isProcessableValue(value[_i])) string += processStyleName(_key) + ":" + processStyleValue(_key, value[_i]) + ";";
        } else {
            var interpolated = handleInterpolation(mergedProps, registered, value);
            switch(_key){
                case "animation":
                case "animationName":
                    string += processStyleName(_key) + ":" + interpolated + ";";
                    break;
                default:
                    string += _key + "{" + interpolated + "}";
            }
        }
    }
    return string;
}
var labelPattern = /label:\s*([^\s;\n{]+)\s*(;|$)/g;
var sourceMapPattern;
// keyframes are stored on the SerializedStyles object as a linked list
var cursor;
var serializeStyles = function serializeStyles(args, registered, mergedProps) {
    if (args.length === 1 && typeof args[0] === "object" && args[0] !== null && args[0].styles !== undefined) return args[0];
    var stringMode = true;
    var styles = "";
    cursor = undefined;
    var strings = args[0];
    if (strings == null || strings.raw === undefined) {
        stringMode = false;
        styles += handleInterpolation(mergedProps, registered, strings);
    } else styles += strings[0];
     // we start at 1 since we've already handled the first arg
    for(var i = 1; i < args.length; i++){
        styles += handleInterpolation(mergedProps, registered, args[i]);
        if (stringMode) styles += strings[i];
    }
    var sourceMap;
    labelPattern.lastIndex = 0;
    var identifierName = "";
    var match; // https://esbench.com/bench/5b809c2cf2949800a0f61fb5
    while((match = labelPattern.exec(styles)) !== null)identifierName += "-" + // $FlowFixMe we know it's not null
    match[1];
    var name = (0, _hashDefault.default)(styles) + identifierName;
    return {
        name: name,
        styles: styles,
        next: cursor
    };
};

},{"@emotion/hash":"2ma2h","@emotion/unitless":"dfdEh","@emotion/memoize":"dMybP","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2ma2h":[function(require,module,exports) {
/* eslint-disable */ // Inspired by https://github.com/garycourt/murmurhash-js
// Ported from https://github.com/aappleby/smhasher/blob/61a0530f28277f2e850bfc39600ce61d02b518de/src/MurmurHash2.cpp#L37-L86
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>murmur2);
function murmur2(str) {
    // 'm' and 'r' are mixing constants generated offline.
    // They're not really 'magic', they just happen to work well.
    // const m = 0x5bd1e995;
    // const r = 24;
    // Initialize the hash
    var h = 0; // Mix 4 bytes at a time into the hash
    var k, i = 0, len = str.length;
    for(; len >= 4; ++i, len -= 4){
        k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
        k = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16);
        k ^= /* k >>> r: */ k >>> 24;
        h = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16) ^ /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Handle the last few bytes of the input array
    switch(len){
        case 3:
            h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
        case 2:
            h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
        case 1:
            h ^= str.charCodeAt(i) & 0xff;
            h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Do a few final mixes of the hash to ensure the last few
    // bytes are well-incorporated.
    h ^= h >>> 13;
    h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    return ((h ^ h >>> 15) >>> 0).toString(36);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"dfdEh":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>unitlessKeys);
var unitlessKeys = {
    animationIterationCount: 1,
    aspectRatio: 1,
    borderImageOutset: 1,
    borderImageSlice: 1,
    borderImageWidth: 1,
    boxFlex: 1,
    boxFlexGroup: 1,
    boxOrdinalGroup: 1,
    columnCount: 1,
    columns: 1,
    flex: 1,
    flexGrow: 1,
    flexPositive: 1,
    flexShrink: 1,
    flexNegative: 1,
    flexOrder: 1,
    gridRow: 1,
    gridRowEnd: 1,
    gridRowSpan: 1,
    gridRowStart: 1,
    gridColumn: 1,
    gridColumnEnd: 1,
    gridColumnSpan: 1,
    gridColumnStart: 1,
    msGridRow: 1,
    msGridRowSpan: 1,
    msGridColumn: 1,
    msGridColumnSpan: 1,
    fontWeight: 1,
    lineHeight: 1,
    opacity: 1,
    order: 1,
    orphans: 1,
    tabSize: 1,
    widows: 1,
    zIndex: 1,
    zoom: 1,
    WebkitLineClamp: 1,
    // SVG-related properties
    fillOpacity: 1,
    floodOpacity: 1,
    stopOpacity: 1,
    strokeDasharray: 1,
    strokeDashoffset: 1,
    strokeMiterlimit: 1,
    strokeOpacity: 1,
    strokeWidth: 1
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"d1zky":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useInsertionEffectAlwaysWithSyncFallback", ()=>useInsertionEffectAlwaysWithSyncFallback);
parcelHelpers.export(exports, "useInsertionEffectWithLayoutFallback", ()=>useInsertionEffectWithLayoutFallback);
var _react = require("react");
var syncFallback = function syncFallback(create) {
    return create();
};
var useInsertionEffect = _react["useInsertionEffect"] ? _react["useInsertionEffect"] : false;
var useInsertionEffectAlwaysWithSyncFallback = useInsertionEffect || syncFallback;
var useInsertionEffectWithLayoutFallback = useInsertionEffect || _react.useLayoutEffect;

},{"react":"6uln9","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4iKIP":[function(require,module,exports) {
function _extends() {
    return module.exports = _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, _extends.apply(null, arguments);
}
module.exports = _extends, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{}],"b8T3j":[function(require,module,exports) {
"use strict";
function checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === "undefined" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== "function") return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
checkDCE();
module.exports = require("9223fb8c5161e54b");

},{"9223fb8c5161e54b":"bO0Ia"}],"bO0Ia":[function(require,module,exports) {
/** @license React v17.0.2
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ "use strict";
var aa = require("5393afc8c463ef07"), m = require("dc13beaf0535b548"), r = require("ece50e903283a22f");
function y(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
if (!aa) throw Error(y(227));
var ba = new Set, ca = {};
function da(a, b) {
    ea(a, b);
    ea(a + "Capture", b);
}
function ea(a, b) {
    ca[a] = b;
    for(a = 0; a < b.length; a++)ba.add(b[a]);
}
var fa = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), ha = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, ia = Object.prototype.hasOwnProperty, ja = {}, ka = {};
function la(a) {
    if (ia.call(ka, a)) return !0;
    if (ia.call(ja, a)) return !1;
    if (ha.test(a)) return ka[a] = !0;
    ja[a] = !0;
    return !1;
}
function ma(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function na(a, b, c, d) {
    if (null === b || "undefined" === typeof b || ma(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function B(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var D = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    D[a] = new B(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    D[b] = new B(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    D[a] = new B(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    D[a] = new B(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    D[a] = new B(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    D[a] = new B(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    D[a] = new B(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    D[a] = new B(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    D[a] = new B(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var oa = /[\-:]([a-z])/g;
function pa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace(oa, pa);
    D[b] = new B(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace(oa, pa);
    D[b] = new B(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace(oa, pa);
    D[b] = new B(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    D[a] = new B(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
D.xlinkHref = new B("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    D[a] = new B(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function qa(a, b, c, d) {
    var e = D.hasOwnProperty(b) ? D[b] : null;
    var f = null !== e ? 0 === e.type : d ? !1 : !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1] ? !1 : !0;
    f || (na(b, c, e, d) && (c = null), d || null === e ? la(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c))));
}
var ra = aa.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, sa = 60103, ta = 60106, ua = 60107, wa = 60108, xa = 60114, ya = 60109, za = 60110, Aa = 60112, Ba = 60113, Ca = 60120, Da = 60115, Ea = 60116, Fa = 60121, Ga = 60128, Ha = 60129, Ia = 60130, Ja = 60131;
if ("function" === typeof Symbol && Symbol.for) {
    var E = Symbol.for;
    sa = E("react.element");
    ta = E("react.portal");
    ua = E("react.fragment");
    wa = E("react.strict_mode");
    xa = E("react.profiler");
    ya = E("react.provider");
    za = E("react.context");
    Aa = E("react.forward_ref");
    Ba = E("react.suspense");
    Ca = E("react.suspense_list");
    Da = E("react.memo");
    Ea = E("react.lazy");
    Fa = E("react.block");
    E("react.scope");
    Ga = E("react.opaque.id");
    Ha = E("react.debug_trace_mode");
    Ia = E("react.offscreen");
    Ja = E("react.legacy_hidden");
}
var Ka = "function" === typeof Symbol && Symbol.iterator;
function La(a) {
    if (null === a || "object" !== typeof a) return null;
    a = Ka && a[Ka] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var Ma;
function Na(a) {
    if (void 0 === Ma) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        Ma = b && b[1] || "";
    }
    return "\n" + Ma + a;
}
var Oa = !1;
function Pa(a, b) {
    if (!a || Oa) return "";
    Oa = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (k) {
                    var d = k;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (k) {
                    d = k;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (k) {
                d = k;
            }
            a();
        }
    } catch (k) {
        if (k && d && "string" === typeof k.stack) {
            for(var e = k.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) return "\n" + e[g].replace(" at new ", " at ");
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        Oa = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? Na(a) : "";
}
function Qa(a) {
    switch(a.tag){
        case 5:
            return Na(a.type);
        case 16:
            return Na("Lazy");
        case 13:
            return Na("Suspense");
        case 19:
            return Na("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = Pa(a.type, !1), a;
        case 11:
            return a = Pa(a.type.render, !1), a;
        case 22:
            return a = Pa(a.type._render, !1), a;
        case 1:
            return a = Pa(a.type, !0), a;
        default:
            return "";
    }
}
function Ra(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case ua:
            return "Fragment";
        case ta:
            return "Portal";
        case xa:
            return "Profiler";
        case wa:
            return "StrictMode";
        case Ba:
            return "Suspense";
        case Ca:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case za:
            return (a.displayName || "Context") + ".Consumer";
        case ya:
            return (a._context.displayName || "Context") + ".Provider";
        case Aa:
            var b = a.render;
            b = b.displayName || b.name || "";
            return a.displayName || ("" !== b ? "ForwardRef(" + b + ")" : "ForwardRef");
        case Da:
            return Ra(a.type);
        case Fa:
            return Ra(a._render);
        case Ea:
            b = a._payload;
            a = a._init;
            try {
                return Ra(a(b));
            } catch (c) {}
    }
    return null;
}
function Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "object":
        case "string":
        case "undefined":
            return a;
        default:
            return "";
    }
}
function Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function Ua(a) {
    var b = Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function Va(a) {
    a._valueTracker || (a._valueTracker = Ua(a));
}
function Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function Ya(a, b) {
    var c = b.checked;
    return m({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $a(a, b) {
    b = b.checked;
    null != b && qa(a, "checked", b, !1);
}
function ab(a, b) {
    $a(a, b);
    var c = Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? bb(a, b.type, c) : b.hasOwnProperty("defaultValue") && bb(a, b.type, Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function cb(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function bb(a, b, c) {
    if ("number" !== b || Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
function db(a) {
    var b = "";
    aa.Children.forEach(a, function(a) {
        null != a && (b += a);
    });
    return b;
}
function eb(a, b) {
    a = m({
        children: void 0
    }, b);
    if (b = db(b.children)) a.children = b;
    return a;
}
function fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error(y(91));
    return m({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error(y(92));
            if (Array.isArray(c)) {
                if (!(1 >= c.length)) throw Error(y(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: Sa(c)
    };
}
function ib(a, b) {
    var c = Sa(b.value), d = Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
var kb = {
    html: "http://www.w3.org/1999/xhtml",
    mathml: "http://www.w3.org/1998/Math/MathML",
    svg: "http://www.w3.org/2000/svg"
};
function lb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function mb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? lb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var nb, ob = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if (a.namespaceURI !== kb.svg || "innerHTML" in a) a.innerHTML = b;
    else {
        nb = nb || document.createElement("div");
        nb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = nb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function pb(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var qb = {
    animationIterationCount: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, rb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys(qb).forEach(function(a) {
    rb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        qb[b] = qb[a];
    });
});
function sb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || qb.hasOwnProperty(a) && qb[a] ? ("" + b).trim() : b + "px";
}
function tb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = sb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var ub = m({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function vb(a, b) {
    if (b) {
        if (ub[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error(y(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error(y(60));
            if (!("object" === typeof b.dangerouslySetInnerHTML && "__html" in b.dangerouslySetInnerHTML)) throw Error(y(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error(y(62));
    }
}
function wb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
function xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var yb = null, zb = null, Ab = null;
function Bb(a) {
    if (a = Cb(a)) {
        if ("function" !== typeof yb) throw Error(y(280));
        var b = a.stateNode;
        b && (b = Db(b), yb(a.stateNode, a.type, b));
    }
}
function Eb(a) {
    zb ? Ab ? Ab.push(a) : Ab = [
        a
    ] : zb = a;
}
function Fb() {
    if (zb) {
        var a = zb, b = Ab;
        Ab = zb = null;
        Bb(a);
        if (b) for(a = 0; a < b.length; a++)Bb(b[a]);
    }
}
function Gb(a, b) {
    return a(b);
}
function Hb(a, b, c, d, e) {
    return a(b, c, d, e);
}
function Ib() {}
var Jb = Gb, Kb = !1, Lb = !1;
function Mb() {
    if (null !== zb || null !== Ab) Ib(), Fb();
}
function Nb(a, b, c) {
    if (Lb) return a(b, c);
    Lb = !0;
    try {
        return Jb(a, b, c);
    } finally{
        Lb = !1, Mb();
    }
}
function Ob(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error(y(231, b, typeof c));
    return c;
}
var Pb = !1;
if (fa) try {
    var Qb = {};
    Object.defineProperty(Qb, "passive", {
        get: function() {
            Pb = !0;
        }
    });
    window.addEventListener("test", Qb, Qb);
    window.removeEventListener("test", Qb, Qb);
} catch (a) {
    Pb = !1;
}
function Rb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (n) {
        this.onError(n);
    }
}
var Sb = !1, Tb = null, Ub = !1, Vb = null, Wb = {
    onError: function(a) {
        Sb = !0;
        Tb = a;
    }
};
function Xb(a, b, c, d, e, f, g, h, k) {
    Sb = !1;
    Tb = null;
    Rb.apply(Wb, arguments);
}
function Yb(a, b, c, d, e, f, g, h, k) {
    Xb.apply(this, arguments);
    if (Sb) {
        if (Sb) {
            var l = Tb;
            Sb = !1;
            Tb = null;
        } else throw Error(y(198));
        Ub || (Ub = !0, Vb = l);
    }
}
function Zb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 1026) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $b(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function ac(a) {
    if (Zb(a) !== a) throw Error(y(188));
}
function bc(a) {
    var b = a.alternate;
    if (!b) {
        b = Zb(a);
        if (null === b) throw Error(y(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return ac(e), a;
                if (f === d) return ac(e), b;
                f = f.sibling;
            }
            throw Error(y(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error(y(189));
            }
        }
        if (c.alternate !== d) throw Error(y(190));
    }
    if (3 !== c.tag) throw Error(y(188));
    return c.stateNode.current === c ? a : b;
}
function cc(a) {
    a = bc(a);
    if (!a) return null;
    for(var b = a;;){
        if (5 === b.tag || 6 === b.tag) return b;
        if (b.child) b.child.return = b, b = b.child;
        else {
            if (b === a) break;
            for(; !b.sibling;){
                if (!b.return || b.return === a) return null;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return null;
}
function dc(a, b) {
    for(var c = a.alternate; null !== b;){
        if (b === a || b === c) return !0;
        b = b.return;
    }
    return !1;
}
var ec, fc, gc, hc, ic = !1, jc = [], kc = null, lc = null, mc = null, nc = new Map, oc = new Map, pc = [], qc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function rc(a, b, c, d, e) {
    return {
        blockedOn: a,
        domEventName: b,
        eventSystemFlags: c | 16,
        nativeEvent: e,
        targetContainers: [
            d
        ]
    };
}
function sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            kc = null;
            break;
        case "dragenter":
        case "dragleave":
            lc = null;
            break;
        case "mouseover":
        case "mouseout":
            mc = null;
            break;
        case "pointerover":
        case "pointerout":
            nc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            oc.delete(b.pointerId);
    }
}
function tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = rc(b, c, d, e, f), null !== b && (b = Cb(b), null !== b && fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return kc = tc(kc, a, b, c, d, e), !0;
        case "dragenter":
            return lc = tc(lc, a, b, c, d, e), !0;
        case "mouseover":
            return mc = tc(mc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            nc.set(f, tc(nc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, oc.set(f, tc(oc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function vc(a) {
    var b = wc(a.target);
    if (null !== b) {
        var c = Zb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $b(c), null !== b) {
                    a.blockedOn = b;
                    hc(a.lanePriority, function() {
                        r.unstable_runWithPriority(a.priority, function() {
                            gc(c);
                        });
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.hydrate) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null !== c) return b = Cb(c), null !== b && fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function zc(a, b, c) {
    xc(a) && c.delete(b);
}
function Ac() {
    for(ic = !1; 0 < jc.length;){
        var a = jc[0];
        if (null !== a.blockedOn) {
            a = Cb(a.blockedOn);
            null !== a && ec(a);
            break;
        }
        for(var b = a.targetContainers; 0 < b.length;){
            var c = yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
            if (null !== c) {
                a.blockedOn = c;
                break;
            }
            b.shift();
        }
        null === a.blockedOn && jc.shift();
    }
    null !== kc && xc(kc) && (kc = null);
    null !== lc && xc(lc) && (lc = null);
    null !== mc && xc(mc) && (mc = null);
    nc.forEach(zc);
    oc.forEach(zc);
}
function Bc(a, b) {
    a.blockedOn === b && (a.blockedOn = null, ic || (ic = !0, r.unstable_scheduleCallback(r.unstable_NormalPriority, Ac)));
}
function Cc(a) {
    function b(b) {
        return Bc(b, a);
    }
    if (0 < jc.length) {
        Bc(jc[0], a);
        for(var c = 1; c < jc.length; c++){
            var d = jc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== kc && Bc(kc, a);
    null !== lc && Bc(lc, a);
    null !== mc && Bc(mc, a);
    nc.forEach(b);
    oc.forEach(b);
    for(c = 0; c < pc.length; c++)d = pc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < pc.length && (c = pc[0], null === c.blockedOn);)vc(c), null === c.blockedOn && pc.shift();
}
function Dc(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var Ec = {
    animationend: Dc("Animation", "AnimationEnd"),
    animationiteration: Dc("Animation", "AnimationIteration"),
    animationstart: Dc("Animation", "AnimationStart"),
    transitionend: Dc("Transition", "TransitionEnd")
}, Fc = {}, Gc = {};
fa && (Gc = document.createElement("div").style, "AnimationEvent" in window || (delete Ec.animationend.animation, delete Ec.animationiteration.animation, delete Ec.animationstart.animation), "TransitionEvent" in window || delete Ec.transitionend.transition);
function Hc(a) {
    if (Fc[a]) return Fc[a];
    if (!Ec[a]) return a;
    var b = Ec[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in Gc) return Fc[a] = b[c];
    return a;
}
var Ic = Hc("animationend"), Jc = Hc("animationiteration"), Kc = Hc("animationstart"), Lc = Hc("transitionend"), Mc = new Map, Nc = new Map, Oc = [
    "abort",
    "abort",
    Ic,
    "animationEnd",
    Jc,
    "animationIteration",
    Kc,
    "animationStart",
    "canplay",
    "canPlay",
    "canplaythrough",
    "canPlayThrough",
    "durationchange",
    "durationChange",
    "emptied",
    "emptied",
    "encrypted",
    "encrypted",
    "ended",
    "ended",
    "error",
    "error",
    "gotpointercapture",
    "gotPointerCapture",
    "load",
    "load",
    "loadeddata",
    "loadedData",
    "loadedmetadata",
    "loadedMetadata",
    "loadstart",
    "loadStart",
    "lostpointercapture",
    "lostPointerCapture",
    "playing",
    "playing",
    "progress",
    "progress",
    "seeking",
    "seeking",
    "stalled",
    "stalled",
    "suspend",
    "suspend",
    "timeupdate",
    "timeUpdate",
    Lc,
    "transitionEnd",
    "waiting",
    "waiting"
];
function Pc(a, b) {
    for(var c = 0; c < a.length; c += 2){
        var d = a[c], e = a[c + 1];
        e = "on" + (e[0].toUpperCase() + e.slice(1));
        Nc.set(d, b);
        Mc.set(d, e);
        da(e, [
            d
        ]);
    }
}
var Qc = r.unstable_now;
Qc();
var F = 8;
function Rc(a) {
    if (0 !== (1 & a)) return F = 15, 1;
    if (0 !== (2 & a)) return F = 14, 2;
    if (0 !== (4 & a)) return F = 13, 4;
    var b = 24 & a;
    if (0 !== b) return F = 12, b;
    if (0 !== (a & 32)) return F = 11, 32;
    b = 192 & a;
    if (0 !== b) return F = 10, b;
    if (0 !== (a & 256)) return F = 9, 256;
    b = 3584 & a;
    if (0 !== b) return F = 8, b;
    if (0 !== (a & 4096)) return F = 7, 4096;
    b = 4186112 & a;
    if (0 !== b) return F = 6, b;
    b = 62914560 & a;
    if (0 !== b) return F = 5, b;
    if (a & 67108864) return F = 4, 67108864;
    if (0 !== (a & 134217728)) return F = 3, 134217728;
    b = 805306368 & a;
    if (0 !== b) return F = 2, b;
    if (0 !== (1073741824 & a)) return F = 1, 1073741824;
    F = 8;
    return a;
}
function Sc(a) {
    switch(a){
        case 99:
            return 15;
        case 98:
            return 10;
        case 97:
        case 96:
            return 8;
        case 95:
            return 2;
        default:
            return 0;
    }
}
function Tc(a) {
    switch(a){
        case 15:
        case 14:
            return 99;
        case 13:
        case 12:
        case 11:
        case 10:
            return 98;
        case 9:
        case 8:
        case 7:
        case 6:
        case 4:
        case 5:
            return 97;
        case 3:
        case 2:
        case 1:
            return 95;
        case 0:
            return 90;
        default:
            throw Error(y(358, a));
    }
}
function Uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return F = 0;
    var d = 0, e = 0, f = a.expiredLanes, g = a.suspendedLanes, h = a.pingedLanes;
    if (0 !== f) d = f, e = F = 15;
    else if (f = c & 134217727, 0 !== f) {
        var k = f & ~g;
        0 !== k ? (d = Rc(k), e = F) : (h &= f, 0 !== h && (d = Rc(h), e = F));
    } else f = c & ~g, 0 !== f ? (d = Rc(f), e = F) : 0 !== h && (d = Rc(h), e = F);
    if (0 === d) return 0;
    d = 31 - Vc(d);
    d = c & ((0 > d ? 0 : 1 << d) << 1) - 1;
    if (0 !== b && b !== d && 0 === (b & g)) {
        Rc(b);
        if (e <= F) return b;
        F = e;
    }
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - Vc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function Wc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function Xc(a, b) {
    switch(a){
        case 15:
            return 1;
        case 14:
            return 2;
        case 12:
            return a = Yc(24 & ~b), 0 === a ? Xc(10, b) : a;
        case 10:
            return a = Yc(192 & ~b), 0 === a ? Xc(8, b) : a;
        case 8:
            return a = Yc(3584 & ~b), 0 === a && (a = Yc(4186112 & ~b), 0 === a && (a = 512)), a;
        case 2:
            return b = Yc(805306368 & ~b), 0 === b && (b = 268435456), b;
    }
    throw Error(y(358, a));
}
function Yc(a) {
    return a & -a;
}
function Zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $c(a, b, c) {
    a.pendingLanes |= b;
    var d = b - 1;
    a.suspendedLanes &= d;
    a.pingedLanes &= d;
    a = a.eventTimes;
    b = 31 - Vc(b);
    a[b] = c;
}
var Vc = Math.clz32 ? Math.clz32 : ad, bd = Math.log, cd = Math.LN2;
function ad(a) {
    return 0 === a ? 32 : 31 - (bd(a) / cd | 0) | 0;
}
var dd = r.unstable_UserBlockingPriority, ed = r.unstable_runWithPriority, fd = !0;
function gd(a, b, c, d) {
    Kb || Ib();
    var e = hd, f = Kb;
    Kb = !0;
    try {
        Hb(e, a, b, c, d);
    } finally{
        (Kb = f) || Mb();
    }
}
function id(a, b, c, d) {
    ed(dd, hd.bind(null, a, b, c, d));
}
function hd(a, b, c, d) {
    if (fd) {
        var e;
        if ((e = 0 === (b & 4)) && 0 < jc.length && -1 < qc.indexOf(a)) a = rc(null, a, b, c, d), jc.push(a);
        else {
            var f = yc(a, b, c, d);
            if (null === f) e && sc(a, d);
            else {
                if (e) {
                    if (-1 < qc.indexOf(a)) {
                        a = rc(f, a, b, c, d);
                        jc.push(a);
                        return;
                    }
                    if (uc(f, a, b, c, d)) return;
                    sc(a, d);
                }
                jd(a, b, d, null, c);
            }
        }
    }
}
function yc(a, b, c, d) {
    var e = xb(d);
    e = wc(e);
    if (null !== e) {
        var f = Zb(e);
        if (null === f) e = null;
        else {
            var g = f.tag;
            if (13 === g) {
                e = $b(f);
                if (null !== e) return e;
                e = null;
            } else if (3 === g) {
                if (f.stateNode.hydrate) return 3 === f.tag ? f.stateNode.containerInfo : null;
                e = null;
            } else f !== e && (e = null);
        }
    }
    jd(a, b, d, e, c);
    return null;
}
var kd = null, ld = null, md = null;
function nd() {
    if (md) return md;
    var a, b = ld, c = b.length, d, e = "value" in kd ? kd.value : kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function pd() {
    return !0;
}
function qd() {
    return !1;
}
function rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? pd : qd;
        this.isPropagationStopped = qd;
        return this;
    }
    m(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = pd);
        },
        persist: function() {},
        isPersistent: pd
    });
    return b;
}
var sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, td = rd(sd), ud = m({}, sd, {
    view: 0,
    detail: 0
}), vd = rd(ud), wd, xd, yd, Ad = m({}, ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== yd && (yd && "mousemove" === a.type ? (wd = a.screenX - yd.screenX, xd = a.screenY - yd.screenY) : xd = wd = 0, yd = a);
        return wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : xd;
    }
}), Bd = rd(Ad), Cd = m({}, Ad, {
    dataTransfer: 0
}), Dd = rd(Cd), Ed = m({}, ud, {
    relatedTarget: 0
}), Fd = rd(Ed), Gd = m({}, sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), Hd = rd(Gd), Id = m({}, sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), Jd = rd(Id), Kd = m({}, sd, {
    data: 0
}), Ld = rd(Kd), Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = Od[a]) ? !!b[a] : !1;
}
function zd() {
    return Pd;
}
var Qd = m({}, ud, {
    key: function(a) {
        if (a.key) {
            var b = Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: zd,
    charCode: function(a) {
        return "keypress" === a.type ? od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), Rd = rd(Qd), Sd = m({}, Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), Td = rd(Sd), Ud = m({}, ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: zd
}), Vd = rd(Ud), Wd = m({}, sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), Xd = rd(Wd), Yd = m({}, Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), Zd = rd(Yd), $d = [
    9,
    13,
    27,
    32
], ae = fa && "CompositionEvent" in window, be = null;
fa && "documentMode" in document && (be = document.documentMode);
var ce = fa && "TextEvent" in window && !be, de = fa && (!ae || be && 8 < be && 11 >= be), ee = String.fromCharCode(32), fe = !1;
function ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var ie = !1;
function je(a, b) {
    switch(a){
        case "compositionend":
            return he(b);
        case "keypress":
            if (32 !== b.which) return null;
            fe = !0;
            return ee;
        case "textInput":
            return a = b.data, a === ee && fe ? null : a;
        default:
            return null;
    }
}
function ke(a, b) {
    if (ie) return "compositionend" === a || !ae && ge(a, b) ? (a = nd(), md = ld = kd = null, ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!le[a.type] : "textarea" === b ? !0 : !1;
}
function ne(a, b, c, d) {
    Eb(d);
    b = oe(b, "onChange");
    0 < b.length && (c = new td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var pe = null, qe = null;
function re(a) {
    se(a, 0);
}
function te(a) {
    var b = ue(a);
    if (Wa(b)) return a;
}
function ve(a, b) {
    if ("change" === a) return b;
}
var we = !1;
if (fa) {
    var xe;
    if (fa) {
        var ye = "oninput" in document;
        if (!ye) {
            var ze = document.createElement("div");
            ze.setAttribute("oninput", "return;");
            ye = "function" === typeof ze.oninput;
        }
        xe = ye;
    } else xe = !1;
    we = xe && (!document.documentMode || 9 < document.documentMode);
}
function Ae() {
    pe && (pe.detachEvent("onpropertychange", Be), qe = pe = null);
}
function Be(a) {
    if ("value" === a.propertyName && te(qe)) {
        var b = [];
        ne(b, qe, a, xb(a));
        a = re;
        if (Kb) a(b);
        else {
            Kb = !0;
            try {
                Gb(a, b);
            } finally{
                Kb = !1, Mb();
            }
        }
    }
}
function Ce(a, b, c) {
    "focusin" === a ? (Ae(), pe = b, qe = c, pe.attachEvent("onpropertychange", Be)) : "focusout" === a && Ae();
}
function De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return te(qe);
}
function Ee(a, b) {
    if ("click" === a) return te(b);
}
function Fe(a, b) {
    if ("input" === a || "change" === a) return te(b);
}
function Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var He = "function" === typeof Object.is ? Object.is : Ge, Ie = Object.prototype.hasOwnProperty;
function Je(a, b) {
    if (He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++)if (!Ie.call(b, c[d]) || !He(a[c[d]], b[c[d]])) return !1;
    return !0;
}
function Ke(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function Le(a, b) {
    var c = Ke(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = Ke(c);
    }
}
function Me(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? Me(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function Ne() {
    for(var a = window, b = Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = Xa(a.document);
    }
    return b;
}
function Oe(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
var Pe = fa && "documentMode" in document && 11 >= document.documentMode, Qe = null, Re = null, Se = null, Te = !1;
function Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    Te || null == Qe || Qe !== Xa(d) || (d = Qe, "selectionStart" in d && Oe(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), Se && Je(Se, d) || (Se = d, d = oe(Re, "onSelect"), 0 < d.length && (b = new td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = Qe)));
}
Pc("cancel cancel click click close close contextmenu contextMenu copy copy cut cut auxclick auxClick dblclick doubleClick dragend dragEnd dragstart dragStart drop drop focusin focus focusout blur input input invalid invalid keydown keyDown keypress keyPress keyup keyUp mousedown mouseDown mouseup mouseUp paste paste pause pause play play pointercancel pointerCancel pointerdown pointerDown pointerup pointerUp ratechange rateChange reset reset seeked seeked submit submit touchcancel touchCancel touchend touchEnd touchstart touchStart volumechange volumeChange".split(" "), 0);
Pc("drag drag dragenter dragEnter dragexit dragExit dragleave dragLeave dragover dragOver mousemove mouseMove mouseout mouseOut mouseover mouseOver pointermove pointerMove pointerout pointerOut pointerover pointerOver scroll scroll toggle toggle touchmove touchMove wheel wheel".split(" "), 1);
Pc(Oc, 2);
for(var Ve = "change selectionchange textInput compositionstart compositionend compositionupdate".split(" "), We = 0; We < Ve.length; We++)Nc.set(Ve[We], 0);
ea("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
ea("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
ea("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
ea("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
da("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
da("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
da("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
da("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
da("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
da("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var Xe = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), Ye = new Set("cancel close invalid load scroll toggle".split(" ").concat(Xe));
function Ze(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    Yb(d, b, void 0, a);
    a.currentTarget = null;
}
function se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                Ze(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                Ze(e, h, l);
                f = k;
            }
        }
    }
    if (Ub) throw a = Vb, Ub = !1, Vb = null, a;
}
function G(a, b) {
    var c = $e(b), d = a + "__bubble";
    c.has(d) || (af(b, a, 2, !1), c.add(d));
}
var bf = "_reactListening" + Math.random().toString(36).slice(2);
function cf(a) {
    a[bf] || (a[bf] = !0, ba.forEach(function(b) {
        Ye.has(b) || df(b, !1, a, null);
        df(b, !0, a, null);
    }));
}
function df(a, b, c, d) {
    var e = 4 < arguments.length && void 0 !== arguments[4] ? arguments[4] : 0, f = c;
    "selectionchange" === a && 9 !== c.nodeType && (f = c.ownerDocument);
    if (null !== d && !b && Ye.has(a)) {
        if ("scroll" !== a) return;
        e |= 2;
        f = d;
    }
    var g = $e(f), h = a + "__" + (b ? "capture" : "bubble");
    g.has(h) || (b && (e |= 4), af(f, a, e, b), g.add(h));
}
function af(a, b, c, d) {
    var e = Nc.get(b);
    switch(void 0 === e ? 2 : e){
        case 0:
            e = gd;
            break;
        case 1:
            e = id;
            break;
        default:
            e = hd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !Pb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function jd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    Nb(function() {
        var d = f, e = xb(c), g = [];
        a: {
            var h = Mc.get(a);
            if (void 0 !== h) {
                var k = td, x = a;
                switch(a){
                    case "keypress":
                        if (0 === od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = Rd;
                        break;
                    case "focusin":
                        x = "focus";
                        k = Fd;
                        break;
                    case "focusout":
                        x = "blur";
                        k = Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = Vd;
                        break;
                    case Ic:
                    case Jc:
                    case Kc:
                        k = Hd;
                        break;
                    case Lc:
                        k = Xd;
                        break;
                    case "scroll":
                        k = vd;
                        break;
                    case "wheel":
                        k = Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = Td;
                }
                var w = 0 !== (b & 4), z = !w && "scroll" === a, u = w ? null !== h ? h + "Capture" : null : h;
                w = [];
                for(var t = d, q; null !== t;){
                    q = t;
                    var v = q.stateNode;
                    5 === q.tag && null !== v && (q = v, null !== u && (v = Ob(t, u), null != v && w.push(ef(t, v, q))));
                    if (z) break;
                    t = t.return;
                }
                0 < w.length && (h = new k(h, x, null, c, e), g.push({
                    event: h,
                    listeners: w
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && 0 === (b & 16) && (x = c.relatedTarget || c.fromElement) && (wc(x) || x[ff])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (x = c.relatedTarget || c.toElement, k = d, x = x ? wc(x) : null, null !== x && (z = Zb(x), x !== z || 5 !== x.tag && 6 !== x.tag)) x = null;
                    } else k = null, x = d;
                    if (k !== x) {
                        w = Bd;
                        v = "onMouseLeave";
                        u = "onMouseEnter";
                        t = "mouse";
                        if ("pointerout" === a || "pointerover" === a) w = Td, v = "onPointerLeave", u = "onPointerEnter", t = "pointer";
                        z = null == k ? h : ue(k);
                        q = null == x ? h : ue(x);
                        h = new w(v, t + "leave", k, c, e);
                        h.target = z;
                        h.relatedTarget = q;
                        v = null;
                        wc(e) === d && (w = new w(u, t + "enter", x, c, e), w.target = q, w.relatedTarget = z, v = w);
                        z = v;
                        if (k && x) b: {
                            w = k;
                            u = x;
                            t = 0;
                            for(q = w; q; q = gf(q))t++;
                            q = 0;
                            for(v = u; v; v = gf(v))q++;
                            for(; 0 < t - q;)w = gf(w), t--;
                            for(; 0 < q - t;)u = gf(u), q--;
                            for(; t--;){
                                if (w === u || null !== u && w === u.alternate) break b;
                                w = gf(w);
                                u = gf(u);
                            }
                            w = null;
                        }
                        else w = null;
                        null !== k && hf(g, h, k, w, !1);
                        null !== x && null !== z && hf(g, z, x, w, !0);
                    }
                }
            }
            a: {
                h = d ? ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var J = ve;
                else if (me(h)) {
                    if (we) J = Fe;
                    else {
                        J = De;
                        var K = Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (J = Ee);
                if (J && (J = J(a, d))) {
                    ne(g, J, c, e);
                    break a;
                }
                K && K(a, h, d);
                "focusout" === a && (K = h._wrapperState) && K.controlled && "number" === h.type && bb(h, "number", h.value);
            }
            K = d ? ue(d) : window;
            switch(a){
                case "focusin":
                    if (me(K) || "true" === K.contentEditable) Qe = K, Re = d, Se = null;
                    break;
                case "focusout":
                    Se = Re = Qe = null;
                    break;
                case "mousedown":
                    Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    Te = !1;
                    Ue(g, c, e);
                    break;
                case "selectionchange":
                    if (Pe) break;
                case "keydown":
                case "keyup":
                    Ue(g, c, e);
            }
            var Q;
            if (ae) b: {
                switch(a){
                    case "compositionstart":
                        var L = "onCompositionStart";
                        break b;
                    case "compositionend":
                        L = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        L = "onCompositionUpdate";
                        break b;
                }
                L = void 0;
            }
            else ie ? ge(a, c) && (L = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (L = "onCompositionStart");
            L && (de && "ko" !== c.locale && (ie || "onCompositionStart" !== L ? "onCompositionEnd" === L && ie && (Q = nd()) : (kd = e, ld = "value" in kd ? kd.value : kd.textContent, ie = !0)), K = oe(d, L), 0 < K.length && (L = new Ld(L, a, null, c, e), g.push({
                event: L,
                listeners: K
            }), Q ? L.data = Q : (Q = he(c), null !== Q && (L.data = Q))));
            if (Q = ce ? je(a, c) : ke(a, c)) d = oe(d, "onBeforeInput"), 0 < d.length && (e = new Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = Q);
        }
        se(g, b);
    });
}
function ef(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = Ob(a, c), null != f && d.unshift(ef(a, f, e)), f = Ob(a, b), null != f && d.push(ef(a, f, e)));
        a = a.return;
    }
    return d;
}
function gf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function hf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = Ob(c, f), null != k && g.unshift(ef(c, k, h))) : e || (k = Ob(c, f), null != k && g.push(ef(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
function jf() {}
var kf = null, lf = null;
function mf(a, b) {
    switch(a){
        case "button":
        case "input":
        case "select":
        case "textarea":
            return !!b.autoFocus;
    }
    return !1;
}
function nf(a, b) {
    return "textarea" === a || "option" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var of = "function" === typeof setTimeout ? setTimeout : void 0, pf = "function" === typeof clearTimeout ? clearTimeout : void 0;
function qf(a) {
    1 === a.nodeType ? a.textContent = "" : 9 === a.nodeType && (a = a.body, null != a && (a.textContent = ""));
}
function rf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
    }
    return a;
}
function sf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var tf = 0;
function uf(a) {
    return {
        $$typeof: Ga,
        toString: a,
        valueOf: a
    };
}
var vf = Math.random().toString(36).slice(2), wf = "__reactFiber$" + vf, xf = "__reactProps$" + vf, ff = "__reactContainer$" + vf, yf = "__reactEvents$" + vf;
function wc(a) {
    var b = a[wf];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[ff] || c[wf]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = sf(a); null !== a;){
                if (c = a[wf]) return c;
                a = sf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function Cb(a) {
    a = a[wf] || a[ff];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error(y(33));
}
function Db(a) {
    return a[xf] || null;
}
function $e(a) {
    var b = a[yf];
    void 0 === b && (b = a[yf] = new Set);
    return b;
}
var zf = [], Af = -1;
function Bf(a) {
    return {
        current: a
    };
}
function H(a) {
    0 > Af || (a.current = zf[Af], zf[Af] = null, Af--);
}
function I(a, b) {
    Af++;
    zf[Af] = a.current;
    a.current = b;
}
var Cf = {}, M = Bf(Cf), N = Bf(!1), Df = Cf;
function Ef(a, b) {
    var c = a.type.contextTypes;
    if (!c) return Cf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function Ff(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function Gf() {
    H(N);
    H(M);
}
function Hf(a, b, c) {
    if (M.current !== Cf) throw Error(y(168));
    I(M, b);
    I(N, c);
}
function If(a, b, c) {
    var d = a.stateNode;
    a = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in a)) throw Error(y(108, Ra(b) || "Unknown", e));
    return m({}, c, d);
}
function Jf(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || Cf;
    Df = M.current;
    I(M, a);
    I(N, N.current);
    return !0;
}
function Kf(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error(y(169));
    c ? (a = If(a, b, Df), d.__reactInternalMemoizedMergedChildContext = a, H(N), H(M), I(M, a)) : H(N);
    I(N, c);
}
var Lf = null, Mf = null, Nf = r.unstable_runWithPriority, Of = r.unstable_scheduleCallback, Pf = r.unstable_cancelCallback, Qf = r.unstable_shouldYield, Rf = r.unstable_requestPaint, Sf = r.unstable_now, Tf = r.unstable_getCurrentPriorityLevel, Uf = r.unstable_ImmediatePriority, Vf = r.unstable_UserBlockingPriority, Wf = r.unstable_NormalPriority, Xf = r.unstable_LowPriority, Yf = r.unstable_IdlePriority, Zf = {}, $f = void 0 !== Rf ? Rf : function() {}, ag = null, bg = null, cg = !1, dg = Sf(), O = 1E4 > dg ? Sf : function() {
    return Sf() - dg;
};
function eg() {
    switch(Tf()){
        case Uf:
            return 99;
        case Vf:
            return 98;
        case Wf:
            return 97;
        case Xf:
            return 96;
        case Yf:
            return 95;
        default:
            throw Error(y(332));
    }
}
function fg(a) {
    switch(a){
        case 99:
            return Uf;
        case 98:
            return Vf;
        case 97:
            return Wf;
        case 96:
            return Xf;
        case 95:
            return Yf;
        default:
            throw Error(y(332));
    }
}
function gg(a, b) {
    a = fg(a);
    return Nf(a, b);
}
function hg(a, b, c) {
    a = fg(a);
    return Of(a, b, c);
}
function ig() {
    if (null !== bg) {
        var a = bg;
        bg = null;
        Pf(a);
    }
    jg();
}
function jg() {
    if (!cg && null !== ag) {
        cg = !0;
        var a = 0;
        try {
            var b = ag;
            gg(99, function() {
                for(; a < b.length; a++){
                    var c = b[a];
                    do c = c(!0);
                    while (null !== c);
                }
            });
            ag = null;
        } catch (c) {
            throw null !== ag && (ag = ag.slice(a + 1)), Of(Uf, ig), c;
        } finally{
            cg = !1;
        }
    }
}
var kg = ra.ReactCurrentBatchConfig;
function lg(a, b) {
    if (a && a.defaultProps) {
        b = m({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
var mg = Bf(null), ng = null, og = null, pg = null;
function qg() {
    pg = og = ng = null;
}
function rg(a) {
    var b = mg.current;
    H(mg);
    a.type._context._currentValue = b;
}
function sg(a, b) {
    for(; null !== a;){
        var c = a.alternate;
        if ((a.childLanes & b) === b) {
            if (null === c || (c.childLanes & b) === b) break;
            else c.childLanes |= b;
        } else a.childLanes |= b, null !== c && (c.childLanes |= b);
        a = a.return;
    }
}
function tg(a, b) {
    ng = a;
    pg = og = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && (ug = !0), a.firstContext = null);
}
function vg(a, b) {
    if (pg !== a && !1 !== b && 0 !== b) {
        if ("number" !== typeof b || 1073741823 === b) pg = a, b = 1073741823;
        b = {
            context: a,
            observedBits: b,
            next: null
        };
        if (null === og) {
            if (null === ng) throw Error(y(308));
            og = b;
            ng.dependencies = {
                lanes: 0,
                firstContext: b,
                responders: null
            };
        } else og = og.next = b;
    }
    return a._currentValue;
}
var wg = !1;
function xg(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null
        },
        effects: null
    };
}
function yg(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function zg(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function Ag(a, b) {
    a = a.updateQueue;
    if (null !== a) {
        a = a.shared;
        var c = a.pending;
        null === c ? b.next = b : (b.next = c.next, c.next = b);
        a.pending = b;
    }
}
function Bg(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function Cg(a, b, c, d) {
    var e = a.updateQueue;
    wg = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var n = a.alternate;
        if (null !== n) {
            n = n.updateQueue;
            var A = n.lastBaseUpdate;
            A !== g && (null === A ? n.firstBaseUpdate = l : A.next = l, n.lastBaseUpdate = k);
        }
    }
    if (null !== f) {
        A = e.baseState;
        g = 0;
        n = l = k = null;
        do {
            h = f.lane;
            var p = f.eventTime;
            if ((d & h) === h) {
                null !== n && (n = n.next = {
                    eventTime: p,
                    lane: 0,
                    tag: f.tag,
                    payload: f.payload,
                    callback: f.callback,
                    next: null
                });
                a: {
                    var C = a, x = f;
                    h = b;
                    p = c;
                    switch(x.tag){
                        case 1:
                            C = x.payload;
                            if ("function" === typeof C) {
                                A = C.call(p, A, h);
                                break a;
                            }
                            A = C;
                            break a;
                        case 3:
                            C.flags = C.flags & -4097 | 64;
                        case 0:
                            C = x.payload;
                            h = "function" === typeof C ? C.call(p, A, h) : C;
                            if (null === h || void 0 === h) break a;
                            A = m({}, A, h);
                            break a;
                        case 2:
                            wg = !0;
                    }
                }
                null !== f.callback && (a.flags |= 32, h = e.effects, null === h ? e.effects = [
                    f
                ] : h.push(f));
            } else p = {
                eventTime: p,
                lane: h,
                tag: f.tag,
                payload: f.payload,
                callback: f.callback,
                next: null
            }, null === n ? (l = n = p, k = A) : n = n.next = p, g |= h;
            f = f.next;
            if (null === f) {
                if (h = e.shared.pending, null === h) break;
                else f = h.next, h.next = null, e.lastBaseUpdate = h, e.shared.pending = null;
            }
        }while (1);
        null === n && (k = A);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = n;
        Dg |= g;
        a.lanes = g;
        a.memoizedState = A;
    }
}
function Eg(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error(y(191, e));
            e.call(d);
        }
    }
}
var Fg = (new aa.Component).refs;
function Gg(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : m({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var Kg = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? Zb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = Hg(), e = Ig(a), f = zg(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        Ag(a, f);
        Jg(a, e, d);
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = Hg(), e = Ig(a), f = zg(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        Ag(a, f);
        Jg(a, e, d);
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = Hg(), d = Ig(a), e = zg(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        Ag(a, e);
        Jg(a, d, c);
    }
};
function Lg(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !Je(c, d) || !Je(e, f) : !0;
}
function Mg(a, b, c) {
    var d = !1, e = Cf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = vg(f) : (e = Ff(b) ? Df : M.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? Ef(a, e) : Cf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = Kg;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function Ng(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && Kg.enqueueReplaceState(b, b.state, null);
}
function Og(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = Fg;
    xg(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = vg(f) : (f = Ff(b) ? Df : M.current, e.context = Ef(a, f));
    Cg(a, c, e, d);
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && (Gg(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && Kg.enqueueReplaceState(e, e.state, null), Cg(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4);
}
var Pg = Array.isArray;
function Qg(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error(y(309));
                var d = c.stateNode;
            }
            if (!d) throw Error(y(147, a));
            var e = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === e) return b.ref;
            b = function(a) {
                var b = d.refs;
                b === Fg && (b = d.refs = {});
                null === a ? delete b[e] : b[e] = a;
            };
            b._stringRef = e;
            return b;
        }
        if ("string" !== typeof a) throw Error(y(284));
        if (!c._owner) throw Error(y(290, a));
    }
    return a;
}
function Rg(a, b) {
    if ("textarea" !== a.type) throw Error(y(31, "[object Object]" === Object.prototype.toString.call(b) ? "object with keys {" + Object.keys(b).join(", ") + "}" : b));
}
function Sg(a) {
    function b(b, c) {
        if (a) {
            var d = b.lastEffect;
            null !== d ? (d.nextEffect = c, b.lastEffect = c) : b.firstEffect = b.lastEffect = c;
            c.nextEffect = null;
            c.flags = 8;
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = Tg(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags = 2, c) : d;
        b.flags = 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags = 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = Ug(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        if (null !== b && b.elementType === c.type) return d = e(b, c.props), d.ref = Qg(a, b, c), d.return = a, d;
        d = Vg(c.type, c.key, c.props, null, a.mode, d);
        d.ref = Qg(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = Wg(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function n(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = Xg(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function A(a, b, c) {
        if ("string" === typeof b || "number" === typeof b) return b = Ug("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case sa:
                    return c = Vg(b.type, b.key, b.props, null, a.mode, c), c.ref = Qg(a, null, b), c.return = a, c;
                case ta:
                    return b = Wg(b, a.mode, c), b.return = a, b;
            }
            if (Pg(b) || La(b)) return b = Xg(b, a.mode, c, null), b.return = a, b;
            Rg(a, b);
        }
        return null;
    }
    function p(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case sa:
                    return c.key === e ? c.type === ua ? n(a, b, c.props.children, d, e) : k(a, b, c, d) : null;
                case ta:
                    return c.key === e ? l(a, b, c, d) : null;
            }
            if (Pg(c) || La(c)) return null !== e ? null : n(a, b, c, d, null);
            Rg(a, c);
        }
        return null;
    }
    function C(a, b, c, d, e) {
        if ("string" === typeof d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case sa:
                    return a = a.get(null === d.key ? c : d.key) || null, d.type === ua ? n(b, a, d.props.children, e, d.key) : k(b, a, d, e);
                case ta:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
            }
            if (Pg(d) || La(d)) return a = a.get(c) || null, n(b, a, d, e, null);
            Rg(b, d);
        }
        return null;
    }
    function x(e, g, h, k) {
        for(var l = null, t = null, u = g, z = g = 0, q = null; null !== u && z < h.length; z++){
            u.index > z ? (q = u, u = null) : q = u.sibling;
            var n = p(e, u, h[z], k);
            if (null === n) {
                null === u && (u = q);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, z);
            null === t ? l = n : t.sibling = n;
            t = n;
            u = q;
        }
        if (z === h.length) return c(e, u), l;
        if (null === u) {
            for(; z < h.length; z++)u = A(e, h[z], k), null !== u && (g = f(u, g, z), null === t ? l = u : t.sibling = u, t = u);
            return l;
        }
        for(u = d(e, u); z < h.length; z++)q = C(u, e, z, h[z], k), null !== q && (a && null !== q.alternate && u.delete(null === q.key ? z : q.key), g = f(q, g, z), null === t ? l = q : t.sibling = q, t = q);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        return l;
    }
    function w(e, g, h, k) {
        var l = La(h);
        if ("function" !== typeof l) throw Error(y(150));
        h = l.call(h);
        if (null == h) throw Error(y(151));
        for(var t = l = null, u = g, z = g = 0, q = null, n = h.next(); null !== u && !n.done; z++, n = h.next()){
            u.index > z ? (q = u, u = null) : q = u.sibling;
            var w = p(e, u, n.value, k);
            if (null === w) {
                null === u && (u = q);
                break;
            }
            a && u && null === w.alternate && b(e, u);
            g = f(w, g, z);
            null === t ? l = w : t.sibling = w;
            t = w;
            u = q;
        }
        if (n.done) return c(e, u), l;
        if (null === u) {
            for(; !n.done; z++, n = h.next())n = A(e, n.value, k), null !== n && (g = f(n, g, z), null === t ? l = n : t.sibling = n, t = n);
            return l;
        }
        for(u = d(e, u); !n.done; z++, n = h.next())n = C(u, e, z, n.value, k), null !== n && (a && null !== n.alternate && u.delete(null === n.key ? z : n.key), g = f(n, g, z), null === t ? l = n : t.sibling = n, t = n);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        return l;
    }
    return function(a, d, f, h) {
        var k = "object" === typeof f && null !== f && f.type === ua && null === f.key;
        k && (f = f.props.children);
        var l = "object" === typeof f && null !== f;
        if (l) switch(f.$$typeof){
            case sa:
                a: {
                    l = f.key;
                    for(k = d; null !== k;){
                        if (k.key === l) {
                            switch(k.tag){
                                case 7:
                                    if (f.type === ua) {
                                        c(a, k.sibling);
                                        d = e(k, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                    break;
                                default:
                                    if (k.elementType === f.type) {
                                        c(a, k.sibling);
                                        d = e(k, f.props);
                                        d.ref = Qg(a, k, f);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                            }
                            c(a, k);
                            break;
                        } else b(a, k);
                        k = k.sibling;
                    }
                    f.type === ua ? (d = Xg(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = Vg(f.type, f.key, f.props, null, a.mode, h), h.ref = Qg(a, d, f), h.return = a, a = h);
                }
                return g(a);
            case ta:
                a: {
                    for(k = f.key; null !== d;){
                        if (d.key === k) {
                            if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                c(a, d.sibling);
                                d = e(d, f.children || []);
                                d.return = a;
                                a = d;
                                break a;
                            } else {
                                c(a, d);
                                break;
                            }
                        } else b(a, d);
                        d = d.sibling;
                    }
                    d = Wg(f, a.mode, h);
                    d.return = a;
                    a = d;
                }
                return g(a);
        }
        if ("string" === typeof f || "number" === typeof f) return f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = Ug(f, a.mode, h), d.return = a, a = d), g(a);
        if (Pg(f)) return x(a, d, f, h);
        if (La(f)) return w(a, d, f, h);
        l && Rg(a, f);
        if ("undefined" === typeof f && !k) switch(a.tag){
            case 1:
            case 22:
            case 0:
            case 11:
            case 15:
                throw Error(y(152, Ra(a.type) || "Component"));
        }
        return c(a, d);
    };
}
var Yg = Sg(!0), Zg = Sg(!1), $g = {}, ah = Bf($g), bh = Bf($g), ch = Bf($g);
function dh(a) {
    if (a === $g) throw Error(y(174));
    return a;
}
function eh(a, b) {
    I(ch, b);
    I(bh, a);
    I(ah, $g);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : mb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = mb(b, a);
    }
    H(ah);
    I(ah, b);
}
function fh() {
    H(ah);
    H(bh);
    H(ch);
}
function gh(a) {
    dh(ch.current);
    var b = dh(ah.current);
    var c = mb(b, a.type);
    b !== c && (I(bh, a), I(ah, c));
}
function hh(a) {
    bh.current === a && (H(ah), H(bh));
}
var P = Bf(0);
function ih(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 64)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var jh = null, kh = null, lh = !1;
function mh(a, b) {
    var c = nh(5, null, null, 0);
    c.elementType = "DELETED";
    c.type = "DELETED";
    c.stateNode = b;
    c.return = a;
    c.flags = 8;
    null !== a.lastEffect ? (a.lastEffect.nextEffect = c, a.lastEffect = c) : a.firstEffect = a.lastEffect = c;
}
function oh(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, !0) : !1;
        case 13:
            return !1;
        default:
            return !1;
    }
}
function ph(a) {
    if (lh) {
        var b = kh;
        if (b) {
            var c = b;
            if (!oh(a, b)) {
                b = rf(c.nextSibling);
                if (!b || !oh(a, b)) {
                    a.flags = a.flags & -1025 | 2;
                    lh = !1;
                    jh = a;
                    return;
                }
                mh(jh, c);
            }
            jh = a;
            kh = rf(b.firstChild);
        } else a.flags = a.flags & -1025 | 2, lh = !1, jh = a;
    }
}
function qh(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    jh = a;
}
function rh(a) {
    if (a !== jh) return !1;
    if (!lh) return qh(a), lh = !0, !1;
    var b = a.type;
    if (5 !== a.tag || "head" !== b && "body" !== b && !nf(b, a.memoizedProps)) for(b = kh; b;)mh(a, b), b = rf(b.nextSibling);
    qh(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error(y(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            kh = rf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            kh = null;
        }
    } else kh = jh ? rf(a.stateNode.nextSibling) : null;
    return !0;
}
function sh() {
    kh = jh = null;
    lh = !1;
}
var th = [];
function uh() {
    for(var a = 0; a < th.length; a++)th[a]._workInProgressVersionPrimary = null;
    th.length = 0;
}
var vh = ra.ReactCurrentDispatcher, wh = ra.ReactCurrentBatchConfig, xh = 0, R = null, S = null, T = null, yh = !1, zh = !1;
function Ah() {
    throw Error(y(321));
}
function Bh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!He(a[c], b[c])) return !1;
    return !0;
}
function Ch(a, b, c, d, e, f) {
    xh = f;
    R = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    vh.current = null === a || null === a.memoizedState ? Dh : Eh;
    a = c(d, e);
    if (zh) {
        f = 0;
        do {
            zh = !1;
            if (!(25 > f)) throw Error(y(301));
            f += 1;
            T = S = null;
            b.updateQueue = null;
            vh.current = Fh;
            a = c(d, e);
        }while (zh);
    }
    vh.current = Gh;
    b = null !== S && null !== S.next;
    xh = 0;
    T = S = R = null;
    yh = !1;
    if (b) throw Error(y(300));
    return a;
}
function Hh() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === T ? R.memoizedState = T = a : T = T.next = a;
    return T;
}
function Ih() {
    if (null === S) {
        var a = R.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = S.next;
    var b = null === T ? R.memoizedState : T.next;
    if (null !== b) T = b, S = a;
    else {
        if (null === a) throw Error(y(310));
        S = a;
        a = {
            memoizedState: S.memoizedState,
            baseState: S.baseState,
            baseQueue: S.baseQueue,
            queue: S.queue,
            next: null
        };
        null === T ? R.memoizedState = T = a : T = T.next = a;
    }
    return T;
}
function Jh(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function Kh(a) {
    var b = Ih(), c = b.queue;
    if (null === c) throw Error(y(311));
    c.lastRenderedReducer = a;
    var d = S, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        e = e.next;
        d = d.baseState;
        var h = g = f = null, k = e;
        do {
            var l = k.lane;
            if ((xh & l) === l) null !== h && (h = h.next = {
                lane: 0,
                action: k.action,
                eagerReducer: k.eagerReducer,
                eagerState: k.eagerState,
                next: null
            }), d = k.eagerReducer === a ? k.eagerState : a(d, k.action);
            else {
                var n = {
                    lane: l,
                    action: k.action,
                    eagerReducer: k.eagerReducer,
                    eagerState: k.eagerState,
                    next: null
                };
                null === h ? (g = h = n, f = d) : h = h.next = n;
                R.lanes |= l;
                Dg |= l;
            }
            k = k.next;
        }while (null !== k && k !== e);
        null === h ? f = d : h.next = g;
        He(d, b.memoizedState) || (ug = !0);
        b.memoizedState = d;
        b.baseState = f;
        b.baseQueue = h;
        c.lastRenderedState = d;
    }
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function Lh(a) {
    var b = Ih(), c = b.queue;
    if (null === c) throw Error(y(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        He(f, b.memoizedState) || (ug = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function Mh(a, b, c) {
    var d = b._getVersion;
    d = d(b._source);
    var e = b._workInProgressVersionPrimary;
    if (null !== e) a = e === d;
    else if (a = a.mutableReadLanes, a = (xh & a) === a) b._workInProgressVersionPrimary = d, th.push(b);
    if (a) return c(b._source);
    th.push(b);
    throw Error(y(350));
}
function Nh(a, b, c, d) {
    var e = U;
    if (null === e) throw Error(y(349));
    var f = b._getVersion, g = f(b._source), h = vh.current, k = h.useState(function() {
        return Mh(e, b, c);
    }), l = k[1], n = k[0];
    k = T;
    var A = a.memoizedState, p = A.refs, C = p.getSnapshot, x = A.source;
    A = A.subscribe;
    var w = R;
    a.memoizedState = {
        refs: p,
        source: b,
        subscribe: d
    };
    h.useEffect(function() {
        p.getSnapshot = c;
        p.setSnapshot = l;
        var a = f(b._source);
        if (!He(g, a)) {
            a = c(b._source);
            He(n, a) || (l(a), a = Ig(w), e.mutableReadLanes |= a & e.pendingLanes);
            a = e.mutableReadLanes;
            e.entangledLanes |= a;
            for(var d = e.entanglements, h = a; 0 < h;){
                var k = 31 - Vc(h), v = 1 << k;
                d[k] |= a;
                h &= ~v;
            }
        }
    }, [
        c,
        b,
        d
    ]);
    h.useEffect(function() {
        return d(b._source, function() {
            var a = p.getSnapshot, c = p.setSnapshot;
            try {
                c(a(b._source));
                var d = Ig(w);
                e.mutableReadLanes |= d & e.pendingLanes;
            } catch (q) {
                c(function() {
                    throw q;
                });
            }
        });
    }, [
        b,
        d
    ]);
    He(C, c) && He(x, b) && He(A, d) || (a = {
        pending: null,
        dispatch: null,
        lastRenderedReducer: Jh,
        lastRenderedState: n
    }, a.dispatch = l = Oh.bind(null, R, a), k.queue = a, k.baseQueue = null, n = Mh(e, b, c), k.memoizedState = k.baseState = n);
    return n;
}
function Ph(a, b, c) {
    var d = Ih();
    return Nh(d, a, b, c);
}
function Qh(a) {
    var b = Hh();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = b.queue = {
        pending: null,
        dispatch: null,
        lastRenderedReducer: Jh,
        lastRenderedState: a
    };
    a = a.dispatch = Oh.bind(null, R, a);
    return [
        b.memoizedState,
        a
    ];
}
function Rh(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = R.updateQueue;
    null === b ? (b = {
        lastEffect: null
    }, R.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function Sh(a) {
    var b = Hh();
    a = {
        current: a
    };
    return b.memoizedState = a;
}
function Th() {
    return Ih().memoizedState;
}
function Uh(a, b, c, d) {
    var e = Hh();
    R.flags |= a;
    e.memoizedState = Rh(1 | b, c, void 0, void 0 === d ? null : d);
}
function Vh(a, b, c, d) {
    var e = Ih();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== S) {
        var g = S.memoizedState;
        f = g.destroy;
        if (null !== d && Bh(d, g.deps)) {
            Rh(b, c, f, d);
            return;
        }
    }
    R.flags |= a;
    e.memoizedState = Rh(1 | b, c, f, d);
}
function Wh(a, b) {
    return Uh(516, 4, a, b);
}
function Xh(a, b) {
    return Vh(516, 4, a, b);
}
function Yh(a, b) {
    return Vh(4, 2, a, b);
}
function Zh(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $h(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return Vh(4, 2, Zh.bind(null, b, a), c);
}
function ai() {}
function bi(a, b) {
    var c = Ih();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && Bh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function ci(a, b) {
    var c = Ih();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && Bh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function di(a, b) {
    var c = eg();
    gg(98 > c ? 98 : c, function() {
        a(!0);
    });
    gg(97 < c ? 97 : c, function() {
        var c = wh.transition;
        wh.transition = 1;
        try {
            a(!1), b();
        } finally{
            wh.transition = c;
        }
    });
}
function Oh(a, b, c) {
    var d = Hg(), e = Ig(a), f = {
        lane: e,
        action: c,
        eagerReducer: null,
        eagerState: null,
        next: null
    }, g = b.pending;
    null === g ? f.next = f : (f.next = g.next, g.next = f);
    b.pending = f;
    g = a.alternate;
    if (a === R || null !== g && g === R) zh = yh = !0;
    else {
        if (0 === a.lanes && (null === g || 0 === g.lanes) && (g = b.lastRenderedReducer, null !== g)) try {
            var h = b.lastRenderedState, k = g(h, c);
            f.eagerReducer = g;
            f.eagerState = k;
            if (He(k, h)) return;
        } catch (l) {} finally{}
        Jg(a, e, d);
    }
}
var Gh = {
    readContext: vg,
    useCallback: Ah,
    useContext: Ah,
    useEffect: Ah,
    useImperativeHandle: Ah,
    useLayoutEffect: Ah,
    useMemo: Ah,
    useReducer: Ah,
    useRef: Ah,
    useState: Ah,
    useDebugValue: Ah,
    useDeferredValue: Ah,
    useTransition: Ah,
    useMutableSource: Ah,
    useOpaqueIdentifier: Ah,
    unstable_isNewReconciler: !1
}, Dh = {
    readContext: vg,
    useCallback: function(a, b) {
        Hh().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: vg,
    useEffect: Wh,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return Uh(4, 2, Zh.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return Uh(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = Hh();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = Hh();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = d.queue = {
            pending: null,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        a = a.dispatch = Oh.bind(null, R, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: Sh,
    useState: Qh,
    useDebugValue: ai,
    useDeferredValue: function(a) {
        var b = Qh(a), c = b[0], d = b[1];
        Wh(function() {
            var b = wh.transition;
            wh.transition = 1;
            try {
                d(a);
            } finally{
                wh.transition = b;
            }
        }, [
            a
        ]);
        return c;
    },
    useTransition: function() {
        var a = Qh(!1), b = a[0];
        a = di.bind(null, a[1]);
        Sh(a);
        return [
            a,
            b
        ];
    },
    useMutableSource: function(a, b, c) {
        var d = Hh();
        d.memoizedState = {
            refs: {
                getSnapshot: b,
                setSnapshot: null
            },
            source: a,
            subscribe: c
        };
        return Nh(d, a, b, c);
    },
    useOpaqueIdentifier: function() {
        if (lh) {
            var a = !1, b = uf(function() {
                a || (a = !0, c("r:" + (tf++).toString(36)));
                throw Error(y(355));
            }), c = Qh(b)[1];
            0 === (R.mode & 2) && (R.flags |= 516, Rh(5, function() {
                c("r:" + (tf++).toString(36));
            }, void 0, null));
            return b;
        }
        b = "r:" + (tf++).toString(36);
        Qh(b);
        return b;
    },
    unstable_isNewReconciler: !1
}, Eh = {
    readContext: vg,
    useCallback: bi,
    useContext: vg,
    useEffect: Xh,
    useImperativeHandle: $h,
    useLayoutEffect: Yh,
    useMemo: ci,
    useReducer: Kh,
    useRef: Th,
    useState: function() {
        return Kh(Jh);
    },
    useDebugValue: ai,
    useDeferredValue: function(a) {
        var b = Kh(Jh), c = b[0], d = b[1];
        Xh(function() {
            var b = wh.transition;
            wh.transition = 1;
            try {
                d(a);
            } finally{
                wh.transition = b;
            }
        }, [
            a
        ]);
        return c;
    },
    useTransition: function() {
        var a = Kh(Jh)[0];
        return [
            Th().current,
            a
        ];
    },
    useMutableSource: Ph,
    useOpaqueIdentifier: function() {
        return Kh(Jh)[0];
    },
    unstable_isNewReconciler: !1
}, Fh = {
    readContext: vg,
    useCallback: bi,
    useContext: vg,
    useEffect: Xh,
    useImperativeHandle: $h,
    useLayoutEffect: Yh,
    useMemo: ci,
    useReducer: Lh,
    useRef: Th,
    useState: function() {
        return Lh(Jh);
    },
    useDebugValue: ai,
    useDeferredValue: function(a) {
        var b = Lh(Jh), c = b[0], d = b[1];
        Xh(function() {
            var b = wh.transition;
            wh.transition = 1;
            try {
                d(a);
            } finally{
                wh.transition = b;
            }
        }, [
            a
        ]);
        return c;
    },
    useTransition: function() {
        var a = Lh(Jh)[0];
        return [
            Th().current,
            a
        ];
    },
    useMutableSource: Ph,
    useOpaqueIdentifier: function() {
        return Lh(Jh)[0];
    },
    unstable_isNewReconciler: !1
}, ei = ra.ReactCurrentOwner, ug = !1;
function fi(a, b, c, d) {
    b.child = null === a ? Zg(b, null, c, d) : Yg(b, a.child, c, d);
}
function gi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    tg(b, e);
    d = Ch(a, b, c, d, f, e);
    if (null !== a && !ug) return b.updateQueue = a.updateQueue, b.flags &= -517, a.lanes &= ~e, hi(a, b, e);
    b.flags |= 1;
    fi(a, b, d, e);
    return b.child;
}
function ii(a, b, c, d, e, f) {
    if (null === a) {
        var g = c.type;
        if ("function" === typeof g && !ji(g) && void 0 === g.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = g, ki(a, b, g, d, e, f);
        a = Vg(c.type, null, d, b, b.mode, f);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    g = a.child;
    if (0 === (e & f) && (e = g.memoizedProps, c = c.compare, c = null !== c ? c : Je, c(e, d) && a.ref === b.ref)) return hi(a, b, f);
    b.flags |= 1;
    a = Tg(g, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function ki(a, b, c, d, e, f) {
    if (null !== a && Je(a.memoizedProps, d) && a.ref === b.ref) {
        if (ug = !1, 0 !== (f & e)) 0 !== (a.flags & 16384) && (ug = !0);
        else return b.lanes = a.lanes, hi(a, b, f);
    }
    return li(a, b, c, d, f);
}
function mi(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode || "unstable-defer-without-hiding" === d.mode) {
        if (0 === (b.mode & 4)) b.memoizedState = {
            baseLanes: 0
        }, ni(b, c);
        else if (0 !== (c & 1073741824)) b.memoizedState = {
            baseLanes: 0
        }, ni(b, null !== f ? f.baseLanes : c);
        else return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
            baseLanes: a
        }, ni(b, a), null;
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, ni(b, d);
    fi(a, b, e, c);
    return b.child;
}
function oi(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 128;
}
function li(a, b, c, d, e) {
    var f = Ff(c) ? Df : M.current;
    f = Ef(b, f);
    tg(b, e);
    c = Ch(a, b, c, d, f, e);
    if (null !== a && !ug) return b.updateQueue = a.updateQueue, b.flags &= -517, a.lanes &= ~e, hi(a, b, e);
    b.flags |= 1;
    fi(a, b, c, e);
    return b.child;
}
function pi(a, b, c, d, e) {
    if (Ff(c)) {
        var f = !0;
        Jf(b);
    } else f = !1;
    tg(b, e);
    if (null === b.stateNode) null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2), Mg(b, c, d), Og(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = vg(l) : (l = Ff(c) ? Df : M.current, l = Ef(b, l));
        var n = c.getDerivedStateFromProps, A = "function" === typeof n || "function" === typeof g.getSnapshotBeforeUpdate;
        A || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && Ng(b, g, d, l);
        wg = !1;
        var p = b.memoizedState;
        g.state = p;
        Cg(b, d, g, e);
        k = b.memoizedState;
        h !== d || p !== k || N.current || wg ? ("function" === typeof n && (Gg(b, c, n, d), k = b.memoizedState), (h = wg || Lg(b, c, h, d, p, k, l)) ? (A || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4)) : ("function" === typeof g.componentDidMount && (b.flags |= 4), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4), d = !1);
    } else {
        g = b.stateNode;
        yg(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : lg(b.type, h);
        g.props = l;
        A = b.pendingProps;
        p = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = vg(k) : (k = Ff(c) ? Df : M.current, k = Ef(b, k));
        var C = c.getDerivedStateFromProps;
        (n = "function" === typeof C || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== A || p !== k) && Ng(b, g, d, k);
        wg = !1;
        p = b.memoizedState;
        g.state = p;
        Cg(b, d, g, e);
        var x = b.memoizedState;
        h !== A || p !== x || N.current || wg ? ("function" === typeof C && (Gg(b, c, C, d), x = b.memoizedState), (l = wg || Lg(b, c, l, d, p, x, k)) ? (n || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, x, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, x, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 256)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && p === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && p === a.memoizedState || (b.flags |= 256), b.memoizedProps = d, b.memoizedState = x), g.props = d, g.state = x, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && p === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && p === a.memoizedState || (b.flags |= 256), d = !1);
    }
    return qi(a, b, c, d, f, e);
}
function qi(a, b, c, d, e, f) {
    oi(a, b);
    var g = 0 !== (b.flags & 64);
    if (!d && !g) return e && Kf(b, c, !1), hi(a, b, f);
    d = b.stateNode;
    ei.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = Yg(b, a.child, null, f), b.child = Yg(b, null, h, f)) : fi(a, b, h, f);
    b.memoizedState = d.state;
    e && Kf(b, c, !0);
    return b.child;
}
function ri(a) {
    var b = a.stateNode;
    b.pendingContext ? Hf(a, b.pendingContext, b.pendingContext !== b.context) : b.context && Hf(a, b.context, !1);
    eh(a, b.containerInfo);
}
var si = {
    dehydrated: null,
    retryLane: 0
};
function ti(a, b, c) {
    var d = b.pendingProps, e = P.current, f = !1, g;
    (g = 0 !== (b.flags & 64)) || (g = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    g ? (f = !0, b.flags &= -65) : null !== a && null === a.memoizedState || void 0 === d.fallback || !0 === d.unstable_avoidThisFallback || (e |= 1);
    I(P, e & 1);
    if (null === a) {
        void 0 !== d.fallback && ph(b);
        a = d.children;
        e = d.fallback;
        if (f) return a = ui(b, a, e, c), b.child.memoizedState = {
            baseLanes: c
        }, b.memoizedState = si, a;
        if ("number" === typeof d.unstable_expectedLoadTime) return a = ui(b, a, e, c), b.child.memoizedState = {
            baseLanes: c
        }, b.memoizedState = si, b.lanes = 33554432, a;
        c = vi({
            mode: "visible",
            children: a
        }, b.mode, c, null);
        c.return = b;
        return b.child = c;
    }
    if (null !== a.memoizedState) {
        if (f) return d = wi(a, b, d.children, d.fallback, c), f = b.child, e = a.child.memoizedState, f.memoizedState = null === e ? {
            baseLanes: c
        } : {
            baseLanes: e.baseLanes | c
        }, f.childLanes = a.childLanes & ~c, b.memoizedState = si, d;
        c = xi(a, b, d.children, c);
        b.memoizedState = null;
        return c;
    }
    if (f) return d = wi(a, b, d.children, d.fallback, c), f = b.child, e = a.child.memoizedState, f.memoizedState = null === e ? {
        baseLanes: c
    } : {
        baseLanes: e.baseLanes | c
    }, f.childLanes = a.childLanes & ~c, b.memoizedState = si, d;
    c = xi(a, b, d.children, c);
    b.memoizedState = null;
    return c;
}
function ui(a, b, c, d) {
    var e = a.mode, f = a.child;
    b = {
        mode: "hidden",
        children: b
    };
    0 === (e & 2) && null !== f ? (f.childLanes = 0, f.pendingProps = b) : f = vi(b, e, 0, null);
    c = Xg(c, e, d, null);
    f.return = a;
    c.return = a;
    f.sibling = c;
    a.child = f;
    return c;
}
function xi(a, b, c, d) {
    var e = a.child;
    a = e.sibling;
    c = Tg(e, {
        mode: "visible",
        children: c
    });
    0 === (b.mode & 2) && (c.lanes = d);
    c.return = b;
    c.sibling = null;
    null !== a && (a.nextEffect = null, a.flags = 8, b.firstEffect = b.lastEffect = a);
    return b.child = c;
}
function wi(a, b, c, d, e) {
    var f = b.mode, g = a.child;
    a = g.sibling;
    var h = {
        mode: "hidden",
        children: c
    };
    0 === (f & 2) && b.child !== g ? (c = b.child, c.childLanes = 0, c.pendingProps = h, g = c.lastEffect, null !== g ? (b.firstEffect = c.firstEffect, b.lastEffect = g, g.nextEffect = null) : b.firstEffect = b.lastEffect = null) : c = Tg(g, h);
    null !== a ? d = Tg(a, d) : (d = Xg(d, f, e, null), d.flags |= 2);
    d.return = b;
    c.return = b;
    c.sibling = d;
    b.child = c;
    return d;
}
function yi(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    sg(a.return, b);
}
function zi(a, b, c, d, e, f) {
    var g = a.memoizedState;
    null === g ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e,
        lastEffect: f
    } : (g.isBackwards = b, g.rendering = null, g.renderingStartTime = 0, g.last = d, g.tail = c, g.tailMode = e, g.lastEffect = f);
}
function Ai(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    fi(a, b, d.children, c);
    d = P.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 64;
    else {
        if (null !== a && 0 !== (a.flags & 64)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && yi(a, c);
            else if (19 === a.tag) yi(a, c);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    I(P, d);
    if (0 === (b.mode & 2)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === ih(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            zi(b, !1, e, c, f, b.lastEffect);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === ih(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            zi(b, !0, c, null, f, b.lastEffect);
            break;
        case "together":
            zi(b, !1, null, null, void 0, b.lastEffect);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function hi(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    Dg |= b.lanes;
    if (0 !== (c & b.childLanes)) {
        if (null !== a && b.child !== a.child) throw Error(y(153));
        if (null !== b.child) {
            a = b.child;
            c = Tg(a, a.pendingProps);
            b.child = c;
            for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = Tg(a, a.pendingProps), c.return = b;
            c.sibling = null;
        }
        return b.child;
    }
    return null;
}
var Bi, Ci, Di, Ei;
Bi = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
Ci = function() {};
Di = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        dh(ah.current);
        var f = null;
        switch(c){
            case "input":
                e = Ya(a, e);
                d = Ya(a, d);
                f = [];
                break;
            case "option":
                e = eb(a, e);
                d = eb(a, d);
                f = [];
                break;
            case "select":
                e = m({}, e, {
                    value: void 0
                });
                d = m({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = gb(a, e);
                d = gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = jf);
        }
        vb(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && (ca.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && (ca.hasOwnProperty(l) ? (null != k && "onScroll" === l && G("scroll", a), f || h === k || (f = [])) : "object" === typeof k && null !== k && k.$$typeof === Ga ? k.toString() : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
Ei = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function Fi(a, b) {
    if (!lh) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function Gi(a, b, c) {
    var d = b.pendingProps;
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return null;
        case 1:
            return Ff(b.type) && Gf(), null;
        case 3:
            fh();
            H(N);
            H(M);
            uh();
            d = b.stateNode;
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) rh(b) ? b.flags |= 4 : d.hydrate || (b.flags |= 256);
            Ci(b);
            return null;
        case 5:
            hh(b);
            var e = dh(ch.current);
            c = b.type;
            if (null !== a && null != b.stateNode) Di(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 128);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error(y(166));
                    return null;
                }
                a = dh(ah.current);
                if (rh(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[wf] = b;
                    d[xf] = f;
                    switch(c){
                        case "dialog":
                            G("cancel", d);
                            G("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            G("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(a = 0; a < Xe.length; a++)G(Xe[a], d);
                            break;
                        case "source":
                            G("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            G("error", d);
                            G("load", d);
                            break;
                        case "details":
                            G("toggle", d);
                            break;
                        case "input":
                            Za(d, f);
                            G("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            G("invalid", d);
                            break;
                        case "textarea":
                            hb(d, f), G("invalid", d);
                    }
                    vb(c, f);
                    a = null;
                    for(var g in f)f.hasOwnProperty(g) && (e = f[g], "children" === g ? "string" === typeof e ? d.textContent !== e && (a = [
                        "children",
                        e
                    ]) : "number" === typeof e && d.textContent !== "" + e && (a = [
                        "children",
                        "" + e
                    ]) : ca.hasOwnProperty(g) && null != e && "onScroll" === g && G("scroll", d));
                    switch(c){
                        case "input":
                            Va(d);
                            cb(d, f, !0);
                            break;
                        case "textarea":
                            Va(d);
                            jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = jf);
                    }
                    d = a;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    a === kb.html && (a = lb(c));
                    a === kb.html ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script></script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[wf] = b;
                    a[xf] = d;
                    Bi(a, b, !1, !1);
                    b.stateNode = a;
                    g = wb(c, d);
                    switch(c){
                        case "dialog":
                            G("cancel", a);
                            G("close", a);
                            e = d;
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            G("load", a);
                            e = d;
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < Xe.length; e++)G(Xe[e], a);
                            e = d;
                            break;
                        case "source":
                            G("error", a);
                            e = d;
                            break;
                        case "img":
                        case "image":
                        case "link":
                            G("error", a);
                            G("load", a);
                            e = d;
                            break;
                        case "details":
                            G("toggle", a);
                            e = d;
                            break;
                        case "input":
                            Za(a, d);
                            e = Ya(a, d);
                            G("invalid", a);
                            break;
                        case "option":
                            e = eb(a, d);
                            break;
                        case "select":
                            a._wrapperState = {
                                wasMultiple: !!d.multiple
                            };
                            e = m({}, d, {
                                value: void 0
                            });
                            G("invalid", a);
                            break;
                        case "textarea":
                            hb(a, d);
                            e = gb(a, d);
                            G("invalid", a);
                            break;
                        default:
                            e = d;
                    }
                    vb(c, e);
                    var h = e;
                    for(f in h)if (h.hasOwnProperty(f)) {
                        var k = h[f];
                        "style" === f ? tb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && ob(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && pb(a, k) : "number" === typeof k && pb(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && (ca.hasOwnProperty(f) ? null != k && "onScroll" === f && G("scroll", a) : null != k && qa(a, f, k, g));
                    }
                    switch(c){
                        case "input":
                            Va(a);
                            cb(a, d, !1);
                            break;
                        case "textarea":
                            Va(a);
                            jb(a);
                            break;
                        case "option":
                            null != d.value && a.setAttribute("value", "" + Sa(d.value));
                            break;
                        case "select":
                            a.multiple = !!d.multiple;
                            f = d.value;
                            null != f ? fb(a, !!d.multiple, f, !1) : null != d.defaultValue && fb(a, !!d.multiple, d.defaultValue, !0);
                            break;
                        default:
                            "function" === typeof e.onClick && (a.onclick = jf);
                    }
                    mf(c, d) && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 128);
            }
            return null;
        case 6:
            if (a && null != b.stateNode) Ei(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error(y(166));
                c = dh(ch.current);
                dh(ah.current);
                rh(b) ? (d = b.stateNode, c = b.memoizedProps, d[wf] = b, d.nodeValue !== c && (b.flags |= 4)) : (d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[wf] = b, b.stateNode = d);
            }
            return null;
        case 13:
            H(P);
            d = b.memoizedState;
            if (0 !== (b.flags & 64)) return b.lanes = c, b;
            d = null !== d;
            c = !1;
            null === a ? void 0 !== b.memoizedProps.fallback && rh(b) : c = null !== a.memoizedState;
            if (d && !c && 0 !== (b.mode & 2)) {
                if (null === a && !0 !== b.memoizedProps.unstable_avoidThisFallback || 0 !== (P.current & 1)) 0 === V && (V = 3);
                else {
                    if (0 === V || 3 === V) V = 4;
                    null === U || 0 === (Dg & 134217727) && 0 === (Hi & 134217727) || Ii(U, W);
                }
            }
            if (d || c) b.flags |= 4;
            return null;
        case 4:
            return fh(), Ci(b), null === a && cf(b.stateNode.containerInfo), null;
        case 10:
            return rg(b), null;
        case 17:
            return Ff(b.type) && Gf(), null;
        case 19:
            H(P);
            d = b.memoizedState;
            if (null === d) return null;
            f = 0 !== (b.flags & 64);
            g = d.rendering;
            if (null === g) {
                if (f) Fi(d, !1);
                else {
                    if (0 !== V || null !== a && 0 !== (a.flags & 64)) for(a = b.child; null !== a;){
                        g = ih(a);
                        if (null !== g) {
                            b.flags |= 64;
                            Fi(d, !1);
                            f = g.updateQueue;
                            null !== f && (b.updateQueue = f, b.flags |= 4);
                            null === d.lastEffect && (b.firstEffect = null);
                            b.lastEffect = d.lastEffect;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 2, f.nextEffect = null, f.firstEffect = null, f.lastEffect = null, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            I(P, P.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== d.tail && O() > Ji && (b.flags |= 64, f = !0, Fi(d, !1), b.lanes = 33554432);
                }
            } else {
                if (!f) {
                    if (a = ih(g), null !== a) {
                        if (b.flags |= 64, f = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), Fi(d, !0), null === d.tail && "hidden" === d.tailMode && !g.alternate && !lh) return b = b.lastEffect = d.lastEffect, null !== b && (b.nextEffect = null), null;
                    } else 2 * O() - d.renderingStartTime > Ji && 1073741824 !== c && (b.flags |= 64, f = !0, Fi(d, !1), b.lanes = 33554432);
                }
                d.isBackwards ? (g.sibling = b.child, b.child = g) : (c = d.last, null !== c ? c.sibling = g : b.child = g, d.last = g);
            }
            return null !== d.tail ? (c = d.tail, d.rendering = c, d.tail = c.sibling, d.lastEffect = b.lastEffect, d.renderingStartTime = O(), c.sibling = null, b = P.current, I(P, f ? b & 1 | 2 : b & 1), c) : null;
        case 23:
        case 24:
            return Ki(), null !== a && null !== a.memoizedState !== (null !== b.memoizedState) && "unstable-defer-without-hiding" !== d.mode && (b.flags |= 4), null;
    }
    throw Error(y(156, b.tag));
}
function Li(a) {
    switch(a.tag){
        case 1:
            Ff(a.type) && Gf();
            var b = a.flags;
            return b & 4096 ? (a.flags = b & -4097 | 64, a) : null;
        case 3:
            fh();
            H(N);
            H(M);
            uh();
            b = a.flags;
            if (0 !== (b & 64)) throw Error(y(285));
            a.flags = b & -4097 | 64;
            return a;
        case 5:
            return hh(a), null;
        case 13:
            return H(P), b = a.flags, b & 4096 ? (a.flags = b & -4097 | 64, a) : null;
        case 19:
            return H(P), null;
        case 4:
            return fh(), null;
        case 10:
            return rg(a), null;
        case 23:
        case 24:
            return Ki(), null;
        default:
            return null;
    }
}
function Mi(a, b) {
    try {
        var c = "", d = b;
        do c += Qa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e
    };
}
function Ni(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var Oi = "function" === typeof WeakMap ? WeakMap : Map;
function Pi(a, b, c) {
    c = zg(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        Qi || (Qi = !0, Ri = d);
        Ni(a, b);
    };
    return c;
}
function Si(a, b, c) {
    c = zg(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            Ni(a, b);
            return d(e);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        "function" !== typeof d && (null === Ti ? Ti = new Set([
            this
        ]) : Ti.add(this), Ni(a, b));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
var Ui = "function" === typeof WeakSet ? WeakSet : Set;
function Vi(a) {
    var b = a.ref;
    if (null !== b) {
        if ("function" === typeof b) try {
            b(null);
        } catch (c) {
            Wi(a, c);
        }
        else b.current = null;
    }
}
function Xi(a, b) {
    switch(b.tag){
        case 0:
        case 11:
        case 15:
        case 22:
            return;
        case 1:
            if (b.flags & 256 && null !== a) {
                var c = a.memoizedProps, d = a.memoizedState;
                a = b.stateNode;
                b = a.getSnapshotBeforeUpdate(b.elementType === b.type ? c : lg(b.type, c), d);
                a.__reactInternalSnapshotBeforeUpdate = b;
            }
            return;
        case 3:
            b.flags & 256 && qf(b.stateNode.containerInfo);
            return;
        case 5:
        case 6:
        case 4:
        case 17:
            return;
    }
    throw Error(y(163));
}
function Yi(a, b, c) {
    switch(c.tag){
        case 0:
        case 11:
        case 15:
        case 22:
            b = c.updateQueue;
            b = null !== b ? b.lastEffect : null;
            if (null !== b) {
                a = b = b.next;
                do {
                    if (3 === (a.tag & 3)) {
                        var d = a.create;
                        a.destroy = d();
                    }
                    a = a.next;
                }while (a !== b);
            }
            b = c.updateQueue;
            b = null !== b ? b.lastEffect : null;
            if (null !== b) {
                a = b = b.next;
                do {
                    var e = a;
                    d = e.next;
                    e = e.tag;
                    0 !== (e & 4) && 0 !== (e & 1) && (Zi(c, a), $i(c, a));
                    a = d;
                }while (a !== b);
            }
            return;
        case 1:
            a = c.stateNode;
            c.flags & 4 && (null === b ? a.componentDidMount() : (d = c.elementType === c.type ? b.memoizedProps : lg(c.type, b.memoizedProps), a.componentDidUpdate(d, b.memoizedState, a.__reactInternalSnapshotBeforeUpdate)));
            b = c.updateQueue;
            null !== b && Eg(c, b, a);
            return;
        case 3:
            b = c.updateQueue;
            if (null !== b) {
                a = null;
                if (null !== c.child) switch(c.child.tag){
                    case 5:
                        a = c.child.stateNode;
                        break;
                    case 1:
                        a = c.child.stateNode;
                }
                Eg(c, b, a);
            }
            return;
        case 5:
            a = c.stateNode;
            null === b && c.flags & 4 && mf(c.type, c.memoizedProps) && a.focus();
            return;
        case 6:
            return;
        case 4:
            return;
        case 12:
            return;
        case 13:
            null === c.memoizedState && (c = c.alternate, null !== c && (c = c.memoizedState, null !== c && (c = c.dehydrated, null !== c && Cc(c))));
            return;
        case 19:
        case 17:
        case 20:
        case 21:
        case 23:
        case 24:
            return;
    }
    throw Error(y(163));
}
function aj(a, b) {
    for(var c = a;;){
        if (5 === c.tag) {
            var d = c.stateNode;
            if (b) d = d.style, "function" === typeof d.setProperty ? d.setProperty("display", "none", "important") : d.display = "none";
            else {
                d = c.stateNode;
                var e = c.memoizedProps.style;
                e = void 0 !== e && null !== e && e.hasOwnProperty("display") ? e.display : null;
                d.style.display = sb("display", e);
            }
        } else if (6 === c.tag) c.stateNode.nodeValue = b ? "" : c.memoizedProps;
        else if ((23 !== c.tag && 24 !== c.tag || null === c.memoizedState || c === a) && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === a) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === a) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
}
function bj(a, b) {
    if (Mf && "function" === typeof Mf.onCommitFiberUnmount) try {
        Mf.onCommitFiberUnmount(Lf, b);
    } catch (f) {}
    switch(b.tag){
        case 0:
        case 11:
        case 14:
        case 15:
        case 22:
            a = b.updateQueue;
            if (null !== a && (a = a.lastEffect, null !== a)) {
                var c = a = a.next;
                do {
                    var d = c, e = d.destroy;
                    d = d.tag;
                    if (void 0 !== e) {
                        if (0 !== (d & 4)) Zi(b, c);
                        else {
                            d = b;
                            try {
                                e();
                            } catch (f) {
                                Wi(d, f);
                            }
                        }
                    }
                    c = c.next;
                }while (c !== a);
            }
            break;
        case 1:
            Vi(b);
            a = b.stateNode;
            if ("function" === typeof a.componentWillUnmount) try {
                a.props = b.memoizedProps, a.state = b.memoizedState, a.componentWillUnmount();
            } catch (f) {
                Wi(b, f);
            }
            break;
        case 5:
            Vi(b);
            break;
        case 4:
            cj(a, b);
    }
}
function dj(a) {
    a.alternate = null;
    a.child = null;
    a.dependencies = null;
    a.firstEffect = null;
    a.lastEffect = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.return = null;
    a.updateQueue = null;
}
function ej(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function fj(a) {
    a: {
        for(var b = a.return; null !== b;){
            if (ej(b)) break a;
            b = b.return;
        }
        throw Error(y(160));
    }
    var c = b;
    b = c.stateNode;
    switch(c.tag){
        case 5:
            var d = !1;
            break;
        case 3:
            b = b.containerInfo;
            d = !0;
            break;
        case 4:
            b = b.containerInfo;
            d = !0;
            break;
        default:
            throw Error(y(161));
    }
    c.flags & 16 && (pb(b, ""), c.flags &= -17);
    a: b: for(c = a;;){
        for(; null === c.sibling;){
            if (null === c.return || ej(c.return)) {
                c = null;
                break a;
            }
            c = c.return;
        }
        c.sibling.return = c.return;
        for(c = c.sibling; 5 !== c.tag && 6 !== c.tag && 18 !== c.tag;){
            if (c.flags & 2) continue b;
            if (null === c.child || 4 === c.tag) continue b;
            else c.child.return = c, c = c.child;
        }
        if (!(c.flags & 2)) {
            c = c.stateNode;
            break a;
        }
    }
    d ? gj(a, c, b) : hj(a, c, b);
}
function gj(a, b, c) {
    var d = a.tag, e = 5 === d || 6 === d;
    if (e) a = e ? a.stateNode : a.stateNode.instance, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = jf));
    else if (4 !== d && (a = a.child, null !== a)) for(gj(a, b, c), a = a.sibling; null !== a;)gj(a, b, c), a = a.sibling;
}
function hj(a, b, c) {
    var d = a.tag, e = 5 === d || 6 === d;
    if (e) a = e ? a.stateNode : a.stateNode.instance, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for(hj(a, b, c), a = a.sibling; null !== a;)hj(a, b, c), a = a.sibling;
}
function cj(a, b) {
    for(var c = b, d = !1, e, f;;){
        if (!d) {
            d = c.return;
            a: for(;;){
                if (null === d) throw Error(y(160));
                e = d.stateNode;
                switch(d.tag){
                    case 5:
                        f = !1;
                        break a;
                    case 3:
                        e = e.containerInfo;
                        f = !0;
                        break a;
                    case 4:
                        e = e.containerInfo;
                        f = !0;
                        break a;
                }
                d = d.return;
            }
            d = !0;
        }
        if (5 === c.tag || 6 === c.tag) {
            a: for(var g = a, h = c, k = h;;)if (bj(g, k), null !== k.child && 4 !== k.tag) k.child.return = k, k = k.child;
            else {
                if (k === h) break a;
                for(; null === k.sibling;){
                    if (null === k.return || k.return === h) break a;
                    k = k.return;
                }
                k.sibling.return = k.return;
                k = k.sibling;
            }
            f ? (g = e, h = c.stateNode, 8 === g.nodeType ? g.parentNode.removeChild(h) : g.removeChild(h)) : e.removeChild(c.stateNode);
        } else if (4 === c.tag) {
            if (null !== c.child) {
                e = c.stateNode.containerInfo;
                f = !0;
                c.child.return = c;
                c = c.child;
                continue;
            }
        } else if (bj(a, c), null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
            4 === c.tag && (d = !1);
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
}
function ij(a, b) {
    switch(b.tag){
        case 0:
        case 11:
        case 14:
        case 15:
        case 22:
            var c = b.updateQueue;
            c = null !== c ? c.lastEffect : null;
            if (null !== c) {
                var d = c = c.next;
                do 3 === (d.tag & 3) && (a = d.destroy, d.destroy = void 0, void 0 !== a && a()), d = d.next;
                while (d !== c);
            }
            return;
        case 1:
            return;
        case 5:
            c = b.stateNode;
            if (null != c) {
                d = b.memoizedProps;
                var e = null !== a ? a.memoizedProps : d;
                a = b.type;
                var f = b.updateQueue;
                b.updateQueue = null;
                if (null !== f) {
                    c[xf] = d;
                    "input" === a && "radio" === d.type && null != d.name && $a(c, d);
                    wb(a, e);
                    b = wb(a, d);
                    for(e = 0; e < f.length; e += 2){
                        var g = f[e], h = f[e + 1];
                        "style" === g ? tb(c, h) : "dangerouslySetInnerHTML" === g ? ob(c, h) : "children" === g ? pb(c, h) : qa(c, g, h, b);
                    }
                    switch(a){
                        case "input":
                            ab(c, d);
                            break;
                        case "textarea":
                            ib(c, d);
                            break;
                        case "select":
                            a = c._wrapperState.wasMultiple, c._wrapperState.wasMultiple = !!d.multiple, f = d.value, null != f ? fb(c, !!d.multiple, f, !1) : a !== !!d.multiple && (null != d.defaultValue ? fb(c, !!d.multiple, d.defaultValue, !0) : fb(c, !!d.multiple, d.multiple ? [] : "", !1));
                    }
                }
            }
            return;
        case 6:
            if (null === b.stateNode) throw Error(y(162));
            b.stateNode.nodeValue = b.memoizedProps;
            return;
        case 3:
            c = b.stateNode;
            c.hydrate && (c.hydrate = !1, Cc(c.containerInfo));
            return;
        case 12:
            return;
        case 13:
            null !== b.memoizedState && (jj = O(), aj(b.child, !0));
            kj(b);
            return;
        case 19:
            kj(b);
            return;
        case 17:
            return;
        case 23:
        case 24:
            aj(b, null !== b.memoizedState);
            return;
    }
    throw Error(y(163));
}
function kj(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new Ui);
        b.forEach(function(b) {
            var d = lj.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function mj(a, b) {
    return null !== a && (a = a.memoizedState, null === a || null !== a.dehydrated) ? (b = b.memoizedState, null !== b && null === b.dehydrated) : !1;
}
var nj = Math.ceil, oj = ra.ReactCurrentDispatcher, pj = ra.ReactCurrentOwner, X = 0, U = null, Y = null, W = 0, qj = 0, rj = Bf(0), V = 0, sj = null, tj = 0, Dg = 0, Hi = 0, uj = 0, vj = null, jj = 0, Ji = Infinity;
function wj() {
    Ji = O() + 500;
}
var Z = null, Qi = !1, Ri = null, Ti = null, xj = !1, yj = null, zj = 90, Aj = [], Bj = [], Cj = null, Dj = 0, Ej = null, Fj = -1, Gj = 0, Hj = 0, Ij = null, Jj = !1;
function Hg() {
    return 0 !== (X & 48) ? O() : -1 !== Fj ? Fj : Fj = O();
}
function Ig(a) {
    a = a.mode;
    if (0 === (a & 2)) return 1;
    if (0 === (a & 4)) return 99 === eg() ? 1 : 2;
    0 === Gj && (Gj = tj);
    if (0 !== kg.transition) {
        0 !== Hj && (Hj = null !== vj ? vj.pendingLanes : 0);
        a = Gj;
        var b = 4186112 & ~Hj;
        b &= -b;
        0 === b && (a = 4186112 & ~a, b = a & -a, 0 === b && (b = 8192));
        return b;
    }
    a = eg();
    0 !== (X & 4) && 98 === a ? a = Xc(12, Gj) : (a = Sc(a), a = Xc(a, Gj));
    return a;
}
function Jg(a, b, c) {
    if (50 < Dj) throw Dj = 0, Ej = null, Error(y(185));
    a = Kj(a, b);
    if (null === a) return null;
    $c(a, b, c);
    a === U && (Hi |= b, 4 === V && Ii(a, W));
    var d = eg();
    1 === b ? 0 !== (X & 8) && 0 === (X & 48) ? Lj(a) : (Mj(a, c), 0 === X && (wj(), ig())) : (0 === (X & 4) || 98 !== d && 99 !== d || (null === Cj ? Cj = new Set([
        a
    ]) : Cj.add(a)), Mj(a, c));
    vj = a;
}
function Kj(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
function Mj(a, b) {
    for(var c = a.callbackNode, d = a.suspendedLanes, e = a.pingedLanes, f = a.expirationTimes, g = a.pendingLanes; 0 < g;){
        var h = 31 - Vc(g), k = 1 << h, l = f[h];
        if (-1 === l) {
            if (0 === (k & d) || 0 !== (k & e)) {
                l = b;
                Rc(k);
                var n = F;
                f[h] = 10 <= n ? l + 250 : 6 <= n ? l + 5E3 : -1;
            }
        } else l <= b && (a.expiredLanes |= k);
        g &= ~k;
    }
    d = Uc(a, a === U ? W : 0);
    b = F;
    if (0 === d) null !== c && (c !== Zf && Pf(c), a.callbackNode = null, a.callbackPriority = 0);
    else {
        if (null !== c) {
            if (a.callbackPriority === b) return;
            c !== Zf && Pf(c);
        }
        15 === b ? (c = Lj.bind(null, a), null === ag ? (ag = [
            c
        ], bg = Of(Uf, jg)) : ag.push(c), c = Zf) : 14 === b ? c = hg(99, Lj.bind(null, a)) : (c = Tc(b), c = hg(c, Nj.bind(null, a)));
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function Nj(a) {
    Fj = -1;
    Hj = Gj = 0;
    if (0 !== (X & 48)) throw Error(y(327));
    var b = a.callbackNode;
    if (Oj() && a.callbackNode !== b) return null;
    var c = Uc(a, a === U ? W : 0);
    if (0 === c) return null;
    var d = c;
    var e = X;
    X |= 16;
    var f = Pj();
    if (U !== a || W !== d) wj(), Qj(a, d);
    for(;;)try {
        Rj();
        break;
    } catch (h) {
        Sj(a, h);
    }
    qg();
    oj.current = f;
    X = e;
    null !== Y ? d = 0 : (U = null, W = 0, d = V);
    if (0 !== (tj & Hi)) Qj(a, 0);
    else if (0 !== d) {
        2 === d && (X |= 64, a.hydrate && (a.hydrate = !1, qf(a.containerInfo)), c = Wc(a), 0 !== c && (d = Tj(a, c)));
        if (1 === d) throw b = sj, Qj(a, 0), Ii(a, c), Mj(a, O()), b;
        a.finishedWork = a.current.alternate;
        a.finishedLanes = c;
        switch(d){
            case 0:
            case 1:
                throw Error(y(345));
            case 2:
                Uj(a);
                break;
            case 3:
                Ii(a, c);
                if ((c & 62914560) === c && (d = jj + 500 - O(), 10 < d)) {
                    if (0 !== Uc(a, 0)) break;
                    e = a.suspendedLanes;
                    if ((e & c) !== c) {
                        Hg();
                        a.pingedLanes |= a.suspendedLanes & e;
                        break;
                    }
                    a.timeoutHandle = of(Uj.bind(null, a), d);
                    break;
                }
                Uj(a);
                break;
            case 4:
                Ii(a, c);
                if ((c & 4186112) === c) break;
                d = a.eventTimes;
                for(e = -1; 0 < c;){
                    var g = 31 - Vc(c);
                    f = 1 << g;
                    g = d[g];
                    g > e && (e = g);
                    c &= ~f;
                }
                c = e;
                c = O() - c;
                c = (120 > c ? 120 : 480 > c ? 480 : 1080 > c ? 1080 : 1920 > c ? 1920 : 3E3 > c ? 3E3 : 4320 > c ? 4320 : 1960 * nj(c / 1960)) - c;
                if (10 < c) {
                    a.timeoutHandle = of(Uj.bind(null, a), c);
                    break;
                }
                Uj(a);
                break;
            case 5:
                Uj(a);
                break;
            default:
                throw Error(y(329));
        }
    }
    Mj(a, O());
    return a.callbackNode === b ? Nj.bind(null, a) : null;
}
function Ii(a, b) {
    b &= ~uj;
    b &= ~Hi;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - Vc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function Lj(a) {
    if (0 !== (X & 48)) throw Error(y(327));
    Oj();
    if (a === U && 0 !== (a.expiredLanes & W)) {
        var b = W;
        var c = Tj(a, b);
        0 !== (tj & Hi) && (b = Uc(a, b), c = Tj(a, b));
    } else b = Uc(a, 0), c = Tj(a, b);
    0 !== a.tag && 2 === c && (X |= 64, a.hydrate && (a.hydrate = !1, qf(a.containerInfo)), b = Wc(a), 0 !== b && (c = Tj(a, b)));
    if (1 === c) throw c = sj, Qj(a, 0), Ii(a, b), Mj(a, O()), c;
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    Uj(a);
    Mj(a, O());
    return null;
}
function Vj() {
    if (null !== Cj) {
        var a = Cj;
        Cj = null;
        a.forEach(function(a) {
            a.expiredLanes |= 24 & a.pendingLanes;
            Mj(a, O());
        });
    }
    ig();
}
function Wj(a, b) {
    var c = X;
    X |= 1;
    try {
        return a(b);
    } finally{
        X = c, 0 === X && (wj(), ig());
    }
}
function Xj(a, b) {
    var c = X;
    X &= -2;
    X |= 8;
    try {
        return a(b);
    } finally{
        X = c, 0 === X && (wj(), ig());
    }
}
function ni(a, b) {
    I(rj, qj);
    qj |= b;
    tj |= b;
}
function Ki() {
    qj = rj.current;
    H(rj);
}
function Qj(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, pf(c));
    if (null !== Y) for(c = Y.return; null !== c;){
        var d = c;
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && Gf();
                break;
            case 3:
                fh();
                H(N);
                H(M);
                uh();
                break;
            case 5:
                hh(d);
                break;
            case 4:
                fh();
                break;
            case 13:
                H(P);
                break;
            case 19:
                H(P);
                break;
            case 10:
                rg(d);
                break;
            case 23:
            case 24:
                Ki();
        }
        c = c.return;
    }
    U = a;
    Y = Tg(a.current, null);
    W = qj = tj = b;
    V = 0;
    sj = null;
    uj = Hi = Dg = 0;
}
function Sj(a, b) {
    do {
        var c = Y;
        try {
            qg();
            vh.current = Gh;
            if (yh) {
                for(var d = R.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                yh = !1;
            }
            xh = 0;
            T = S = R = null;
            zh = !1;
            pj.current = null;
            if (null === c || null === c.return) {
                V = 1;
                sj = b;
                Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = W;
                h.flags |= 2048;
                h.firstEffect = h.lastEffect = null;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k;
                    if (0 === (h.mode & 2)) {
                        var n = h.alternate;
                        n ? (h.updateQueue = n.updateQueue, h.memoizedState = n.memoizedState, h.lanes = n.lanes) : (h.updateQueue = null, h.memoizedState = null);
                    }
                    var A = 0 !== (P.current & 1), p = g;
                    do {
                        var C;
                        if (C = 13 === p.tag) {
                            var x = p.memoizedState;
                            if (null !== x) C = null !== x.dehydrated ? !0 : !1;
                            else {
                                var w = p.memoizedProps;
                                C = void 0 === w.fallback ? !1 : !0 !== w.unstable_avoidThisFallback ? !0 : A ? !1 : !0;
                            }
                        }
                        if (C) {
                            var z = p.updateQueue;
                            if (null === z) {
                                var u = new Set;
                                u.add(l);
                                p.updateQueue = u;
                            } else z.add(l);
                            if (0 === (p.mode & 2)) {
                                p.flags |= 64;
                                h.flags |= 16384;
                                h.flags &= -2981;
                                if (1 === h.tag) {
                                    if (null === h.alternate) h.tag = 17;
                                    else {
                                        var t = zg(-1, 1);
                                        t.tag = 2;
                                        Ag(h, t);
                                    }
                                }
                                h.lanes |= 1;
                                break a;
                            }
                            k = void 0;
                            h = b;
                            var q = f.pingCache;
                            null === q ? (q = f.pingCache = new Oi, k = new Set, q.set(l, k)) : (k = q.get(l), void 0 === k && (k = new Set, q.set(l, k)));
                            if (!k.has(h)) {
                                k.add(h);
                                var v = Yj.bind(null, f, l, h);
                                l.then(v, v);
                            }
                            p.flags |= 4096;
                            p.lanes = b;
                            break a;
                        }
                        p = p.return;
                    }while (null !== p);
                    k = Error((Ra(h.type) || "A React component") + " suspended while rendering, but no fallback UI was specified.\n\nAdd a <Suspense fallback=...> component higher in the tree to provide a loading indicator or placeholder to display.");
                }
                5 !== V && (V = 2);
                k = Mi(k, h);
                p = g;
                do {
                    switch(p.tag){
                        case 3:
                            f = k;
                            p.flags |= 4096;
                            b &= -b;
                            p.lanes |= b;
                            var J = Pi(p, f, b);
                            Bg(p, J);
                            break a;
                        case 1:
                            f = k;
                            var K = p.type, Q = p.stateNode;
                            if (0 === (p.flags & 64) && ("function" === typeof K.getDerivedStateFromError || null !== Q && "function" === typeof Q.componentDidCatch && (null === Ti || !Ti.has(Q)))) {
                                p.flags |= 4096;
                                b &= -b;
                                p.lanes |= b;
                                var L = Si(p, f, b);
                                Bg(p, L);
                                break a;
                            }
                    }
                    p = p.return;
                }while (null !== p);
            }
            Zj(c);
        } catch (va) {
            b = va;
            Y === c && null !== c && (Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function Pj() {
    var a = oj.current;
    oj.current = Gh;
    return null === a ? Gh : a;
}
function Tj(a, b) {
    var c = X;
    X |= 16;
    var d = Pj();
    U === a && W === b || Qj(a, b);
    for(;;)try {
        ak();
        break;
    } catch (e) {
        Sj(a, e);
    }
    qg();
    X = c;
    oj.current = d;
    if (null !== Y) throw Error(y(261));
    U = null;
    W = 0;
    return V;
}
function ak() {
    for(; null !== Y;)bk(Y);
}
function Rj() {
    for(; null !== Y && !Qf();)bk(Y);
}
function bk(a) {
    var b = ck(a.alternate, a, qj);
    a.memoizedProps = a.pendingProps;
    null === b ? Zj(a) : Y = b;
    pj.current = null;
}
function Zj(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 2048)) {
            c = Gi(c, b, qj);
            if (null !== c) {
                Y = c;
                return;
            }
            c = b;
            if (24 !== c.tag && 23 !== c.tag || null === c.memoizedState || 0 !== (qj & 1073741824) || 0 === (c.mode & 4)) {
                for(var d = 0, e = c.child; null !== e;)d |= e.lanes | e.childLanes, e = e.sibling;
                c.childLanes = d;
            }
            null !== a && 0 === (a.flags & 2048) && (null === a.firstEffect && (a.firstEffect = b.firstEffect), null !== b.lastEffect && (null !== a.lastEffect && (a.lastEffect.nextEffect = b.firstEffect), a.lastEffect = b.lastEffect), 1 < b.flags && (null !== a.lastEffect ? a.lastEffect.nextEffect = b : a.firstEffect = b, a.lastEffect = b));
        } else {
            c = Li(b);
            if (null !== c) {
                c.flags &= 2047;
                Y = c;
                return;
            }
            null !== a && (a.firstEffect = a.lastEffect = null, a.flags |= 2048);
        }
        b = b.sibling;
        if (null !== b) {
            Y = b;
            return;
        }
        Y = b = a;
    }while (null !== b);
    0 === V && (V = 5);
}
function Uj(a) {
    var b = eg();
    gg(99, dk.bind(null, a, b));
    return null;
}
function dk(a, b) {
    do Oj();
    while (null !== yj);
    if (0 !== (X & 48)) throw Error(y(327));
    var c = a.finishedWork;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error(y(177));
    a.callbackNode = null;
    var d = c.lanes | c.childLanes, e = d, f = a.pendingLanes & ~e;
    a.pendingLanes = e;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= e;
    a.mutableReadLanes &= e;
    a.entangledLanes &= e;
    e = a.entanglements;
    for(var g = a.eventTimes, h = a.expirationTimes; 0 < f;){
        var k = 31 - Vc(f), l = 1 << k;
        e[k] = 0;
        g[k] = -1;
        h[k] = -1;
        f &= ~l;
    }
    null !== Cj && 0 === (d & 24) && Cj.has(a) && Cj.delete(a);
    a === U && (Y = U = null, W = 0);
    1 < c.flags ? null !== c.lastEffect ? (c.lastEffect.nextEffect = c, d = c.firstEffect) : d = c : d = c.firstEffect;
    if (null !== d) {
        e = X;
        X |= 32;
        pj.current = null;
        kf = fd;
        g = Ne();
        if (Oe(g)) {
            if ("selectionStart" in g) h = {
                start: g.selectionStart,
                end: g.selectionEnd
            };
            else a: if (h = (h = g.ownerDocument) && h.defaultView || window, (l = h.getSelection && h.getSelection()) && 0 !== l.rangeCount) {
                h = l.anchorNode;
                f = l.anchorOffset;
                k = l.focusNode;
                l = l.focusOffset;
                try {
                    h.nodeType, k.nodeType;
                } catch (va) {
                    h = null;
                    break a;
                }
                var n = 0, A = -1, p = -1, C = 0, x = 0, w = g, z = null;
                b: for(;;){
                    for(var u;;){
                        w !== h || 0 !== f && 3 !== w.nodeType || (A = n + f);
                        w !== k || 0 !== l && 3 !== w.nodeType || (p = n + l);
                        3 === w.nodeType && (n += w.nodeValue.length);
                        if (null === (u = w.firstChild)) break;
                        z = w;
                        w = u;
                    }
                    for(;;){
                        if (w === g) break b;
                        z === h && ++C === f && (A = n);
                        z === k && ++x === l && (p = n);
                        if (null !== (u = w.nextSibling)) break;
                        w = z;
                        z = w.parentNode;
                    }
                    w = u;
                }
                h = -1 === A || -1 === p ? null : {
                    start: A,
                    end: p
                };
            } else h = null;
            h = h || {
                start: 0,
                end: 0
            };
        } else h = null;
        lf = {
            focusedElem: g,
            selectionRange: h
        };
        fd = !1;
        Ij = null;
        Jj = !1;
        Z = d;
        do try {
            ek();
        } catch (va) {
            if (null === Z) throw Error(y(330));
            Wi(Z, va);
            Z = Z.nextEffect;
        }
        while (null !== Z);
        Ij = null;
        Z = d;
        do try {
            for(g = a; null !== Z;){
                var t = Z.flags;
                t & 16 && pb(Z.stateNode, "");
                if (t & 128) {
                    var q = Z.alternate;
                    if (null !== q) {
                        var v = q.ref;
                        null !== v && ("function" === typeof v ? v(null) : v.current = null);
                    }
                }
                switch(t & 1038){
                    case 2:
                        fj(Z);
                        Z.flags &= -3;
                        break;
                    case 6:
                        fj(Z);
                        Z.flags &= -3;
                        ij(Z.alternate, Z);
                        break;
                    case 1024:
                        Z.flags &= -1025;
                        break;
                    case 1028:
                        Z.flags &= -1025;
                        ij(Z.alternate, Z);
                        break;
                    case 4:
                        ij(Z.alternate, Z);
                        break;
                    case 8:
                        h = Z;
                        cj(g, h);
                        var J = h.alternate;
                        dj(h);
                        null !== J && dj(J);
                }
                Z = Z.nextEffect;
            }
        } catch (va) {
            if (null === Z) throw Error(y(330));
            Wi(Z, va);
            Z = Z.nextEffect;
        }
        while (null !== Z);
        v = lf;
        q = Ne();
        t = v.focusedElem;
        g = v.selectionRange;
        if (q !== t && t && t.ownerDocument && Me(t.ownerDocument.documentElement, t)) {
            null !== g && Oe(t) && (q = g.start, v = g.end, void 0 === v && (v = q), "selectionStart" in t ? (t.selectionStart = q, t.selectionEnd = Math.min(v, t.value.length)) : (v = (q = t.ownerDocument || document) && q.defaultView || window, v.getSelection && (v = v.getSelection(), h = t.textContent.length, J = Math.min(g.start, h), g = void 0 === g.end ? J : Math.min(g.end, h), !v.extend && J > g && (h = g, g = J, J = h), h = Le(t, J), f = Le(t, g), h && f && (1 !== v.rangeCount || v.anchorNode !== h.node || v.anchorOffset !== h.offset || v.focusNode !== f.node || v.focusOffset !== f.offset) && (q = q.createRange(), q.setStart(h.node, h.offset), v.removeAllRanges(), J > g ? (v.addRange(q), v.extend(f.node, f.offset)) : (q.setEnd(f.node, f.offset), v.addRange(q))))));
            q = [];
            for(v = t; v = v.parentNode;)1 === v.nodeType && q.push({
                element: v,
                left: v.scrollLeft,
                top: v.scrollTop
            });
            "function" === typeof t.focus && t.focus();
            for(t = 0; t < q.length; t++)v = q[t], v.element.scrollLeft = v.left, v.element.scrollTop = v.top;
        }
        fd = !!kf;
        lf = kf = null;
        a.current = c;
        Z = d;
        do try {
            for(t = a; null !== Z;){
                var K = Z.flags;
                K & 36 && Yi(t, Z.alternate, Z);
                if (K & 128) {
                    q = void 0;
                    var Q = Z.ref;
                    if (null !== Q) {
                        var L = Z.stateNode;
                        switch(Z.tag){
                            case 5:
                                q = L;
                                break;
                            default:
                                q = L;
                        }
                        "function" === typeof Q ? Q(q) : Q.current = q;
                    }
                }
                Z = Z.nextEffect;
            }
        } catch (va) {
            if (null === Z) throw Error(y(330));
            Wi(Z, va);
            Z = Z.nextEffect;
        }
        while (null !== Z);
        Z = null;
        $f();
        X = e;
    } else a.current = c;
    if (xj) xj = !1, yj = a, zj = b;
    else for(Z = d; null !== Z;)b = Z.nextEffect, Z.nextEffect = null, Z.flags & 8 && (K = Z, K.sibling = null, K.stateNode = null), Z = b;
    d = a.pendingLanes;
    0 === d && (Ti = null);
    1 === d ? a === Ej ? Dj++ : (Dj = 0, Ej = a) : Dj = 0;
    c = c.stateNode;
    if (Mf && "function" === typeof Mf.onCommitFiberRoot) try {
        Mf.onCommitFiberRoot(Lf, c, void 0, 64 === (c.current.flags & 64));
    } catch (va) {}
    Mj(a, O());
    if (Qi) throw Qi = !1, a = Ri, Ri = null, a;
    if (0 !== (X & 8)) return null;
    ig();
    return null;
}
function ek() {
    for(; null !== Z;){
        var a = Z.alternate;
        Jj || null === Ij || (0 !== (Z.flags & 8) ? dc(Z, Ij) && (Jj = !0) : 13 === Z.tag && mj(a, Z) && dc(Z, Ij) && (Jj = !0));
        var b = Z.flags;
        0 !== (b & 256) && Xi(a, Z);
        0 === (b & 512) || xj || (xj = !0, hg(97, function() {
            Oj();
            return null;
        }));
        Z = Z.nextEffect;
    }
}
function Oj() {
    if (90 !== zj) {
        var a = 97 < zj ? 97 : zj;
        zj = 90;
        return gg(a, fk);
    }
    return !1;
}
function $i(a, b) {
    Aj.push(b, a);
    xj || (xj = !0, hg(97, function() {
        Oj();
        return null;
    }));
}
function Zi(a, b) {
    Bj.push(b, a);
    xj || (xj = !0, hg(97, function() {
        Oj();
        return null;
    }));
}
function fk() {
    if (null === yj) return !1;
    var a = yj;
    yj = null;
    if (0 !== (X & 48)) throw Error(y(331));
    var b = X;
    X |= 32;
    var c = Bj;
    Bj = [];
    for(var d = 0; d < c.length; d += 2){
        var e = c[d], f = c[d + 1], g = e.destroy;
        e.destroy = void 0;
        if ("function" === typeof g) try {
            g();
        } catch (k) {
            if (null === f) throw Error(y(330));
            Wi(f, k);
        }
    }
    c = Aj;
    Aj = [];
    for(d = 0; d < c.length; d += 2){
        e = c[d];
        f = c[d + 1];
        try {
            var h = e.create;
            e.destroy = h();
        } catch (k) {
            if (null === f) throw Error(y(330));
            Wi(f, k);
        }
    }
    for(h = a.current.firstEffect; null !== h;)a = h.nextEffect, h.nextEffect = null, h.flags & 8 && (h.sibling = null, h.stateNode = null), h = a;
    X = b;
    ig();
    return !0;
}
function gk(a, b, c) {
    b = Mi(c, b);
    b = Pi(a, b, 1);
    Ag(a, b);
    b = Hg();
    a = Kj(a, 1);
    null !== a && ($c(a, 1, b), Mj(a, b));
}
function Wi(a, b) {
    if (3 === a.tag) gk(a, a, b);
    else for(var c = a.return; null !== c;){
        if (3 === c.tag) {
            gk(c, a, b);
            break;
        } else if (1 === c.tag) {
            var d = c.stateNode;
            if ("function" === typeof c.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === Ti || !Ti.has(d))) {
                a = Mi(b, a);
                var e = Si(c, a, 1);
                Ag(c, e);
                e = Hg();
                c = Kj(c, 1);
                if (null !== c) $c(c, 1, e), Mj(c, e);
                else if ("function" === typeof d.componentDidCatch && (null === Ti || !Ti.has(d))) try {
                    d.componentDidCatch(b, a);
                } catch (f) {}
                break;
            }
        }
        c = c.return;
    }
}
function Yj(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = Hg();
    a.pingedLanes |= a.suspendedLanes & c;
    U === a && (W & c) === c && (4 === V || 3 === V && (W & 62914560) === W && 500 > O() - jj ? Qj(a, 0) : uj |= c);
    Mj(a, b);
}
function lj(a, b) {
    var c = a.stateNode;
    null !== c && c.delete(b);
    b = 0;
    0 === b && (b = a.mode, 0 === (b & 2) ? b = 1 : 0 === (b & 4) ? b = 99 === eg() ? 1 : 2 : (0 === Gj && (Gj = tj), b = Yc(62914560 & ~Gj), 0 === b && (b = 4194304)));
    c = Hg();
    a = Kj(a, b);
    null !== a && ($c(a, b, c), Mj(a, c));
}
var ck;
ck = function(a, b, c) {
    var d = b.lanes;
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || N.current) ug = !0;
        else if (0 !== (c & d)) ug = 0 !== (a.flags & 16384) ? !0 : !1;
        else {
            ug = !1;
            switch(b.tag){
                case 3:
                    ri(b);
                    sh();
                    break;
                case 5:
                    gh(b);
                    break;
                case 1:
                    Ff(b.type) && Jf(b);
                    break;
                case 4:
                    eh(b, b.stateNode.containerInfo);
                    break;
                case 10:
                    d = b.memoizedProps.value;
                    var e = b.type._context;
                    I(mg, e._currentValue);
                    e._currentValue = d;
                    break;
                case 13:
                    if (null !== b.memoizedState) {
                        if (0 !== (c & b.child.childLanes)) return ti(a, b, c);
                        I(P, P.current & 1);
                        b = hi(a, b, c);
                        return null !== b ? b.sibling : null;
                    }
                    I(P, P.current & 1);
                    break;
                case 19:
                    d = 0 !== (c & b.childLanes);
                    if (0 !== (a.flags & 64)) {
                        if (d) return Ai(a, b, c);
                        b.flags |= 64;
                    }
                    e = b.memoizedState;
                    null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
                    I(P, P.current);
                    if (d) break;
                    else return null;
                case 23:
                case 24:
                    return b.lanes = 0, mi(a, b, c);
            }
            return hi(a, b, c);
        }
    } else ug = !1;
    b.lanes = 0;
    switch(b.tag){
        case 2:
            d = b.type;
            null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
            a = b.pendingProps;
            e = Ef(b, M.current);
            tg(b, c);
            e = Ch(null, b, d, a, e, c);
            b.flags |= 1;
            if ("object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof) {
                b.tag = 1;
                b.memoizedState = null;
                b.updateQueue = null;
                if (Ff(d)) {
                    var f = !0;
                    Jf(b);
                } else f = !1;
                b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null;
                xg(b);
                var g = d.getDerivedStateFromProps;
                "function" === typeof g && Gg(b, d, g, a);
                e.updater = Kg;
                b.stateNode = e;
                e._reactInternals = b;
                Og(b, d, a, c);
                b = qi(null, b, d, !0, f, c);
            } else b.tag = 0, fi(null, b, e, c), b = b.child;
            return b;
        case 16:
            e = b.elementType;
            a: {
                null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
                a = b.pendingProps;
                f = e._init;
                e = f(e._payload);
                b.type = e;
                f = b.tag = hk(e);
                a = lg(e, a);
                switch(f){
                    case 0:
                        b = li(null, b, e, a, c);
                        break a;
                    case 1:
                        b = pi(null, b, e, a, c);
                        break a;
                    case 11:
                        b = gi(null, b, e, a, c);
                        break a;
                    case 14:
                        b = ii(null, b, e, lg(e.type, a), d, c);
                        break a;
                }
                throw Error(y(306, e, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : lg(d, e), li(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : lg(d, e), pi(a, b, d, e, c);
        case 3:
            ri(b);
            d = b.updateQueue;
            if (null === a || null === d) throw Error(y(282));
            d = b.pendingProps;
            e = b.memoizedState;
            e = null !== e ? e.element : null;
            yg(a, b);
            Cg(b, d, null, c);
            d = b.memoizedState.element;
            if (d === e) sh(), b = hi(a, b, c);
            else {
                e = b.stateNode;
                if (f = e.hydrate) kh = rf(b.stateNode.containerInfo.firstChild), jh = b, f = lh = !0;
                if (f) {
                    a = e.mutableSourceEagerHydrationData;
                    if (null != a) for(e = 0; e < a.length; e += 2)f = a[e], f._workInProgressVersionPrimary = a[e + 1], th.push(f);
                    c = Zg(b, null, d, c);
                    for(b.child = c; c;)c.flags = c.flags & -3 | 1024, c = c.sibling;
                } else fi(a, b, d, c), sh();
                b = b.child;
            }
            return b;
        case 5:
            return gh(b), null === a && ph(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, nf(d, e) ? g = null : null !== f && nf(d, f) && (b.flags |= 16), oi(a, b), fi(a, b, g, c), b.child;
        case 6:
            return null === a && ph(b), null;
        case 13:
            return ti(a, b, c);
        case 4:
            return eh(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = Yg(b, null, d, c) : fi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : lg(d, e), gi(a, b, d, e, c);
        case 7:
            return fi(a, b, b.pendingProps, c), b.child;
        case 8:
            return fi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return fi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                g = b.memoizedProps;
                f = e.value;
                var h = b.type._context;
                I(mg, h._currentValue);
                h._currentValue = f;
                if (null !== g) {
                    if (h = g.value, f = He(h, f) ? 0 : ("function" === typeof d._calculateChangedBits ? d._calculateChangedBits(h, f) : 1073741823) | 0, 0 === f) {
                        if (g.children === e.children && !N.current) {
                            b = hi(a, b, c);
                            break a;
                        }
                    } else for(h = b.child, null !== h && (h.return = b); null !== h;){
                        var k = h.dependencies;
                        if (null !== k) {
                            g = h.child;
                            for(var l = k.firstContext; null !== l;){
                                if (l.context === d && 0 !== (l.observedBits & f)) {
                                    1 === h.tag && (l = zg(-1, c & -c), l.tag = 2, Ag(h, l));
                                    h.lanes |= c;
                                    l = h.alternate;
                                    null !== l && (l.lanes |= c);
                                    sg(h.return, c);
                                    k.lanes |= c;
                                    break;
                                }
                                l = l.next;
                            }
                        } else g = 10 === h.tag ? h.type === b.type ? null : h.child : h.child;
                        if (null !== g) g.return = h;
                        else for(g = h; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            h = g.sibling;
                            if (null !== h) {
                                h.return = g.return;
                                g = h;
                                break;
                            }
                            g = g.return;
                        }
                        h = g;
                    }
                }
                fi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, f = b.pendingProps, d = f.children, tg(b, c), e = vg(e, f.unstable_observedBits), d = d(e), b.flags |= 1, fi(a, b, d, c), b.child;
        case 14:
            return e = b.type, f = lg(e, b.pendingProps), f = lg(e.type, f), ii(a, b, e, f, d, c);
        case 15:
            return ki(a, b, b.type, b.pendingProps, d, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : lg(d, e), null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2), b.tag = 1, Ff(d) ? (a = !0, Jf(b)) : a = !1, tg(b, c), Mg(b, d, e), Og(b, d, e, c), qi(null, b, d, !0, a, c);
        case 19:
            return Ai(a, b, c);
        case 23:
            return mi(a, b, c);
        case 24:
            return mi(a, b, c);
    }
    throw Error(y(156, b.tag));
};
function ik(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.flags = 0;
    this.lastEffect = this.firstEffect = this.nextEffect = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function nh(a, b, c, d) {
    return new ik(a, b, c, d);
}
function ji(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function hk(a) {
    if ("function" === typeof a) return ji(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === Aa) return 11;
        if (a === Da) return 14;
    }
    return 2;
}
function Tg(a, b) {
    var c = a.alternate;
    null === c ? (c = nh(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.nextEffect = null, c.firstEffect = null, c.lastEffect = null);
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function Vg(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) ji(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case ua:
            return Xg(c.children, e, f, b);
        case Ha:
            g = 8;
            e |= 16;
            break;
        case wa:
            g = 8;
            e |= 1;
            break;
        case xa:
            return a = nh(12, c, b, e | 8), a.elementType = xa, a.type = xa, a.lanes = f, a;
        case Ba:
            return a = nh(13, c, b, e), a.type = Ba, a.elementType = Ba, a.lanes = f, a;
        case Ca:
            return a = nh(19, c, b, e), a.elementType = Ca, a.lanes = f, a;
        case Ia:
            return vi(c, e, f, b);
        case Ja:
            return a = nh(24, c, b, e), a.elementType = Ja, a.lanes = f, a;
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case ya:
                    g = 10;
                    break a;
                case za:
                    g = 9;
                    break a;
                case Aa:
                    g = 11;
                    break a;
                case Da:
                    g = 14;
                    break a;
                case Ea:
                    g = 16;
                    d = null;
                    break a;
                case Fa:
                    g = 22;
                    break a;
            }
            throw Error(y(130, null == a ? a : typeof a, ""));
    }
    b = nh(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function Xg(a, b, c, d) {
    a = nh(7, a, d, b);
    a.lanes = c;
    return a;
}
function vi(a, b, c, d) {
    a = nh(23, a, d, b);
    a.elementType = Ia;
    a.lanes = c;
    return a;
}
function Ug(a, b, c) {
    a = nh(6, a, null, b);
    a.lanes = c;
    return a;
}
function Wg(a, b, c) {
    b = nh(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function jk(a, b, c) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.pendingContext = this.context = null;
    this.hydrate = c;
    this.callbackNode = null;
    this.callbackPriority = 0;
    this.eventTimes = Zc(0);
    this.expirationTimes = Zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = Zc(0);
    this.mutableSourceEagerHydrationData = null;
}
function kk(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: ta,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function lk(a, b, c, d) {
    var e = b.current, f = Hg(), g = Ig(e);
    a: if (c) {
        c = c._reactInternals;
        b: {
            if (Zb(c) !== c || 1 !== c.tag) throw Error(y(170));
            var h = c;
            do {
                switch(h.tag){
                    case 3:
                        h = h.stateNode.context;
                        break b;
                    case 1:
                        if (Ff(h.type)) {
                            h = h.stateNode.__reactInternalMemoizedMergedChildContext;
                            break b;
                        }
                }
                h = h.return;
            }while (null !== h);
            throw Error(y(171));
        }
        if (1 === c.tag) {
            var k = c.type;
            if (Ff(k)) {
                c = If(c, k, h);
                break a;
            }
        }
        c = h;
    } else c = Cf;
    null === b.context ? b.context = c : b.pendingContext = c;
    b = zg(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    Ag(e, b);
    Jg(e, g, f);
    return g;
}
function mk(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function nk(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function ok(a, b) {
    nk(a, b);
    (a = a.alternate) && nk(a, b);
}
function pk() {
    return null;
}
function qk(a, b, c) {
    var d = null != c && null != c.hydrationOptions && c.hydrationOptions.mutableSources || null;
    c = new jk(a, b, null != c && !0 === c.hydrate);
    b = nh(3, null, null, 2 === b ? 7 : 1 === b ? 3 : 0);
    c.current = b;
    b.stateNode = c;
    xg(b);
    a[ff] = c.current;
    cf(8 === a.nodeType ? a.parentNode : a);
    if (d) for(a = 0; a < d.length; a++){
        b = d[a];
        var e = b._getVersion;
        e = e(b._source);
        null == c.mutableSourceEagerHydrationData ? c.mutableSourceEagerHydrationData = [
            b,
            e
        ] : c.mutableSourceEagerHydrationData.push(b, e);
    }
    this._internalRoot = c;
}
qk.prototype.render = function(a) {
    lk(a, this._internalRoot, null, null);
};
qk.prototype.unmount = function() {
    var a = this._internalRoot, b = a.containerInfo;
    lk(null, a, null, function() {
        b[ff] = null;
    });
};
function rk(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function sk(a, b) {
    b || (b = a ? 9 === a.nodeType ? a.documentElement : a.firstChild : null, b = !(!b || 1 !== b.nodeType || !b.hasAttribute("data-reactroot")));
    if (!b) for(var c; c = a.lastChild;)a.removeChild(c);
    return new qk(a, 0, b ? {
        hydrate: !0
    } : void 0);
}
function tk(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f._internalRoot;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = mk(g);
                h.call(a);
            };
        }
        lk(b, g, a, e);
    } else {
        f = c._reactRootContainer = sk(c, d);
        g = f._internalRoot;
        if ("function" === typeof e) {
            var k = e;
            e = function() {
                var a = mk(g);
                k.call(a);
            };
        }
        Xj(function() {
            lk(b, g, a, e);
        });
    }
    return mk(g);
}
ec = function(a) {
    if (13 === a.tag) {
        var b = Hg();
        Jg(a, 4, b);
        ok(a, 4);
    }
};
fc = function(a) {
    if (13 === a.tag) {
        var b = Hg();
        Jg(a, 67108864, b);
        ok(a, 67108864);
    }
};
gc = function(a) {
    if (13 === a.tag) {
        var b = Hg(), c = Ig(a);
        Jg(a, c, b);
        ok(a, c);
    }
};
hc = function(a, b) {
    return b();
};
yb = function(a, b, c) {
    switch(b){
        case "input":
            ab(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = Db(d);
                        if (!e) throw Error(y(90));
                        Wa(d);
                        ab(d, e);
                    }
                }
            }
            break;
        case "textarea":
            ib(a, c);
            break;
        case "select":
            b = c.value, null != b && fb(a, !!c.multiple, b, !1);
    }
};
Gb = Wj;
Hb = function(a, b, c, d, e) {
    var f = X;
    X |= 4;
    try {
        return gg(98, a.bind(null, b, c, d, e));
    } finally{
        X = f, 0 === X && (wj(), ig());
    }
};
Ib = function() {
    0 === (X & 49) && (Vj(), Oj());
};
Jb = function(a, b) {
    var c = X;
    X |= 2;
    try {
        return a(b);
    } finally{
        X = c, 0 === X && (wj(), ig());
    }
};
function uk(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!rk(b)) throw Error(y(200));
    return kk(a, b, null, c);
}
var vk = {
    Events: [
        Cb,
        ue,
        Db,
        Eb,
        Fb,
        Oj,
        {
            current: !1
        }
    ]
}, wk = {
    findFiberByHostInstance: wc,
    bundleType: 0,
    version: "17.0.2",
    rendererPackageName: "react-dom"
};
var xk = {
    bundleType: wk.bundleType,
    version: wk.version,
    rendererPackageName: wk.rendererPackageName,
    rendererConfig: wk.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: ra.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = cc(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: wk.findFiberByHostInstance || pk,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var yk = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!yk.isDisabled && yk.supportsFiber) try {
        Lf = yk.inject(xk), Mf = yk;
    } catch (a) {}
}
exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = vk;
exports.createPortal = uk;
exports.findDOMNode = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error(y(188));
        throw Error(y(268, Object.keys(a)));
    }
    a = cc(b);
    a = null === a ? null : a.stateNode;
    return a;
};
exports.flushSync = function(a, b) {
    var c = X;
    if (0 !== (c & 48)) return a(b);
    X |= 1;
    try {
        if (a) return gg(99, a.bind(null, b));
    } finally{
        X = c, ig();
    }
};
exports.hydrate = function(a, b, c) {
    if (!rk(b)) throw Error(y(200));
    return tk(null, a, b, !0, c);
};
exports.render = function(a, b, c) {
    if (!rk(b)) throw Error(y(200));
    return tk(null, a, b, !1, c);
};
exports.unmountComponentAtNode = function(a) {
    if (!rk(a)) throw Error(y(40));
    return a._reactRootContainer ? (Xj(function() {
        tk(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[ff] = null;
        });
    }), !0) : !1;
};
exports.unstable_batchedUpdates = Wj;
exports.unstable_createPortal = function(a, b) {
    return uk(a, b, 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null);
};
exports.unstable_renderSubtreeIntoContainer = function(a, b, c, d) {
    if (!rk(c)) throw Error(y(200));
    if (null == a || void 0 === a._reactInternals) throw Error(y(38));
    return tk(a, b, c, !1, d);
};
exports.version = "17.0.2";

},{"5393afc8c463ef07":"6uln9","dc13beaf0535b548":"hdgcG","ece50e903283a22f":"jNZm8"}],"jNZm8":[function(require,module,exports) {
"use strict";
module.exports = require("15840f0beed8ff36");

},{"15840f0beed8ff36":"izQ2Z"}],"izQ2Z":[function(require,module,exports) {
/** @license React v0.20.2
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var f, g, h, k;
if ("object" === typeof performance && "function" === typeof performance.now) {
    var l = performance;
    exports.unstable_now = function() {
        return l.now();
    };
} else {
    var p = Date, q = p.now();
    exports.unstable_now = function() {
        return p.now() - q;
    };
}
if ("undefined" === typeof window || "function" !== typeof MessageChannel) {
    var t = null, u = null, w = function() {
        if (null !== t) try {
            var a = exports.unstable_now();
            t(!0, a);
            t = null;
        } catch (b) {
            throw setTimeout(w, 0), b;
        }
    };
    f = function(a) {
        null !== t ? setTimeout(f, 0, a) : (t = a, setTimeout(w, 0));
    };
    g = function(a, b) {
        u = setTimeout(a, b);
    };
    h = function() {
        clearTimeout(u);
    };
    exports.unstable_shouldYield = function() {
        return !1;
    };
    k = exports.unstable_forceFrameRate = function() {};
} else {
    var x = window.setTimeout, y = window.clearTimeout;
    if ("undefined" !== typeof console) {
        var z = window.cancelAnimationFrame;
        "function" !== typeof window.requestAnimationFrame && console.error("This browser doesn't support requestAnimationFrame. Make sure that you load a polyfill in older browsers. https://reactjs.org/link/react-polyfills");
        "function" !== typeof z && console.error("This browser doesn't support cancelAnimationFrame. Make sure that you load a polyfill in older browsers. https://reactjs.org/link/react-polyfills");
    }
    var A = !1, B = null, C = -1, D = 5, E = 0;
    exports.unstable_shouldYield = function() {
        return exports.unstable_now() >= E;
    };
    k = function() {};
    exports.unstable_forceFrameRate = function(a) {
        0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : D = 0 < a ? Math.floor(1E3 / a) : 5;
    };
    var F = new MessageChannel, G = F.port2;
    F.port1.onmessage = function() {
        if (null !== B) {
            var a = exports.unstable_now();
            E = a + D;
            try {
                B(!0, a) ? G.postMessage(null) : (A = !1, B = null);
            } catch (b) {
                throw G.postMessage(null), b;
            }
        } else A = !1;
    };
    f = function(a) {
        B = a;
        A || (A = !0, G.postMessage(null));
    };
    g = function(a, b) {
        C = x(function() {
            a(exports.unstable_now());
        }, b);
    };
    h = function() {
        y(C);
        C = -1;
    };
}
function H(a, b) {
    var c = a.length;
    a.push(b);
    a: for(;;){
        var d = c - 1 >>> 1, e = a[d];
        if (void 0 !== e && 0 < I(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function J(a) {
    a = a[0];
    return void 0 === a ? null : a;
}
function K(a) {
    var b = a[0];
    if (void 0 !== b) {
        var c = a.pop();
        if (c !== b) {
            a[0] = c;
            a: for(var d = 0, e = a.length; d < e;){
                var m = 2 * (d + 1) - 1, n = a[m], v = m + 1, r = a[v];
                if (void 0 !== n && 0 > I(n, c)) void 0 !== r && 0 > I(r, n) ? (a[d] = r, a[v] = c, d = v) : (a[d] = n, a[m] = c, d = m);
                else if (void 0 !== r && 0 > I(r, c)) a[d] = r, a[v] = c, d = v;
                else break a;
            }
        }
        return b;
    }
    return null;
}
function I(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
var L = [], M = [], N = 1, O = null, P = 3, Q = !1, R = !1, S = !1;
function T(a) {
    for(var b = J(M); null !== b;){
        if (null === b.callback) K(M);
        else if (b.startTime <= a) K(M), b.sortIndex = b.expirationTime, H(L, b);
        else break;
        b = J(M);
    }
}
function U(a) {
    S = !1;
    T(a);
    if (!R) {
        if (null !== J(L)) R = !0, f(V);
        else {
            var b = J(M);
            null !== b && g(U, b.startTime - a);
        }
    }
}
function V(a, b) {
    R = !1;
    S && (S = !1, h());
    Q = !0;
    var c = P;
    try {
        T(b);
        for(O = J(L); null !== O && (!(O.expirationTime > b) || a && !exports.unstable_shouldYield());){
            var d = O.callback;
            if ("function" === typeof d) {
                O.callback = null;
                P = O.priorityLevel;
                var e = d(O.expirationTime <= b);
                b = exports.unstable_now();
                "function" === typeof e ? O.callback = e : O === J(L) && K(L);
                T(b);
            } else K(L);
            O = J(L);
        }
        if (null !== O) var m = !0;
        else {
            var n = J(M);
            null !== n && g(U, n.startTime - b);
            m = !1;
        }
        return m;
    } finally{
        O = null, P = c, Q = !1;
    }
}
var W = k;
exports.unstable_IdlePriority = 5;
exports.unstable_ImmediatePriority = 1;
exports.unstable_LowPriority = 4;
exports.unstable_NormalPriority = 3;
exports.unstable_Profiling = null;
exports.unstable_UserBlockingPriority = 2;
exports.unstable_cancelCallback = function(a) {
    a.callback = null;
};
exports.unstable_continueExecution = function() {
    R || Q || (R = !0, f(V));
};
exports.unstable_getCurrentPriorityLevel = function() {
    return P;
};
exports.unstable_getFirstCallbackNode = function() {
    return J(L);
};
exports.unstable_next = function(a) {
    switch(P){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = P;
    }
    var c = P;
    P = b;
    try {
        return a();
    } finally{
        P = c;
    }
};
exports.unstable_pauseExecution = function() {};
exports.unstable_requestPaint = W;
exports.unstable_runWithPriority = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = P;
    P = a;
    try {
        return b();
    } finally{
        P = c;
    }
};
exports.unstable_scheduleCallback = function(a, b, c) {
    var d = exports.unstable_now();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: N++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, H(M, a), null === J(L) && a === J(M) && (S ? h() : S = !0, g(U, c - d))) : (a.sortIndex = e, H(L, a), R || Q || (R = !0, f(V)));
    return a;
};
exports.unstable_wrapCallback = function(a) {
    var b = P;
    return function() {
        var c = P;
        P = b;
        try {
            return a.apply(this, arguments);
        } finally{
            P = c;
        }
    };
};

},{}],"5fzqq":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MemoryRouter", ()=>(0, _reactRouter.MemoryRouter));
parcelHelpers.export(exports, "Prompt", ()=>(0, _reactRouter.Prompt));
parcelHelpers.export(exports, "Redirect", ()=>(0, _reactRouter.Redirect));
parcelHelpers.export(exports, "Route", ()=>(0, _reactRouter.Route));
parcelHelpers.export(exports, "Router", ()=>(0, _reactRouter.Router));
parcelHelpers.export(exports, "StaticRouter", ()=>(0, _reactRouter.StaticRouter));
parcelHelpers.export(exports, "Switch", ()=>(0, _reactRouter.Switch));
parcelHelpers.export(exports, "generatePath", ()=>(0, _reactRouter.generatePath));
parcelHelpers.export(exports, "matchPath", ()=>(0, _reactRouter.matchPath));
parcelHelpers.export(exports, "useHistory", ()=>(0, _reactRouter.useHistory));
parcelHelpers.export(exports, "useLocation", ()=>(0, _reactRouter.useLocation));
parcelHelpers.export(exports, "useParams", ()=>(0, _reactRouter.useParams));
parcelHelpers.export(exports, "useRouteMatch", ()=>(0, _reactRouter.useRouteMatch));
parcelHelpers.export(exports, "withRouter", ()=>(0, _reactRouter.withRouter));
parcelHelpers.export(exports, "BrowserRouter", ()=>BrowserRouter);
parcelHelpers.export(exports, "HashRouter", ()=>HashRouter);
parcelHelpers.export(exports, "Link", ()=>Link);
parcelHelpers.export(exports, "NavLink", ()=>NavLink);
var _reactRouter = require("react-router");
var _inheritsLoose = require("@babel/runtime/helpers/esm/inheritsLoose");
var _inheritsLooseDefault = parcelHelpers.interopDefault(_inheritsLoose);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _history = require("history");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _tinyWarning = require("tiny-warning");
var _tinyWarningDefault = parcelHelpers.interopDefault(_tinyWarning);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _tinyInvariant = require("tiny-invariant");
var _tinyInvariantDefault = parcelHelpers.interopDefault(_tinyInvariant);
/**
 * The public API for a <Router> that uses HTML5 history.
 */ var BrowserRouter = /*#__PURE__*/ function(_React$Component) {
    (0, _inheritsLooseDefault.default)(BrowserRouter, _React$Component);
    function BrowserRouter() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.history = (0, _history.createBrowserHistory)(_this.props);
        return _this;
    }
    var _proto = BrowserRouter.prototype;
    _proto.render = function render() {
        return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactRouter.Router), {
            history: this.history,
            children: this.props.children
        });
    };
    return BrowserRouter;
}((0, _reactDefault.default).Component);
/**
 * The public API for a <Router> that uses window.location.hash.
 */ var HashRouter = /*#__PURE__*/ function(_React$Component) {
    (0, _inheritsLooseDefault.default)(HashRouter, _React$Component);
    function HashRouter() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.history = (0, _history.createHashHistory)(_this.props);
        return _this;
    }
    var _proto = HashRouter.prototype;
    _proto.render = function render() {
        return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactRouter.Router), {
            history: this.history,
            children: this.props.children
        });
    };
    return HashRouter;
}((0, _reactDefault.default).Component);
var resolveToLocation = function resolveToLocation(to, currentLocation) {
    return typeof to === "function" ? to(currentLocation) : to;
};
var normalizeToLocation = function normalizeToLocation(to, currentLocation) {
    return typeof to === "string" ? (0, _history.createLocation)(to, null, null, currentLocation) : to;
};
var forwardRefShim = function forwardRefShim(C) {
    return C;
};
var forwardRef = (0, _reactDefault.default).forwardRef;
if (typeof forwardRef === "undefined") forwardRef = forwardRefShim;
function isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
var LinkAnchor = forwardRef(function(_ref, forwardedRef) {
    var innerRef = _ref.innerRef, navigate = _ref.navigate, _onClick = _ref.onClick, rest = (0, _objectWithoutPropertiesLooseDefault.default)(_ref, [
        "innerRef",
        "navigate",
        "onClick"
    ]);
    var target = rest.target;
    var props = (0, _extendsDefault.default)({}, rest, {
        onClick: function onClick(event) {
            try {
                if (_onClick) _onClick(event);
            } catch (ex) {
                event.preventDefault();
                throw ex;
            }
            if (!event.defaultPrevented && // onClick prevented default
            event.button === 0 && (!target || target === "_self") && // let browser handle "target=_blank" etc.
            !isModifiedEvent(event) // ignore clicks with modifier keys
            ) {
                event.preventDefault();
                navigate();
            }
        }
    }); // React 15 compat
    if (forwardRefShim !== forwardRef) props.ref = forwardedRef || innerRef;
    else props.ref = innerRef;
    /* eslint-disable-next-line jsx-a11y/anchor-has-content */ return /*#__PURE__*/ (0, _reactDefault.default).createElement("a", props);
});
/**
 * The public API for rendering a history-aware <a>.
 */ var Link = forwardRef(function(_ref2, forwardedRef) {
    var _ref2$component = _ref2.component, component = _ref2$component === void 0 ? LinkAnchor : _ref2$component, replace = _ref2.replace, to = _ref2.to, innerRef = _ref2.innerRef, rest = (0, _objectWithoutPropertiesLooseDefault.default)(_ref2, [
        "component",
        "replace",
        "to",
        "innerRef"
    ]);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactRouter.__RouterContext).Consumer, null, function(context) {
        !context && (0, _tinyInvariantDefault.default)(false);
        var history = context.history;
        var location = normalizeToLocation(resolveToLocation(to, context.location), context.location);
        var href = location ? history.createHref(location) : "";
        var props = (0, _extendsDefault.default)({}, rest, {
            href: href,
            navigate: function navigate() {
                var location = resolveToLocation(to, context.location);
                var isDuplicateNavigation = (0, _history.createPath)(context.location) === (0, _history.createPath)(normalizeToLocation(location));
                var method = replace || isDuplicateNavigation ? history.replace : history.push;
                method(location);
            }
        }); // React 15 compat
        if (forwardRefShim !== forwardRef) props.ref = forwardedRef || innerRef;
        else props.innerRef = innerRef;
        return /*#__PURE__*/ (0, _reactDefault.default).createElement(component, props);
    });
});
var toType, refType;
var forwardRefShim$1 = function forwardRefShim(C) {
    return C;
};
var forwardRef$1 = (0, _reactDefault.default).forwardRef;
if (typeof forwardRef$1 === "undefined") forwardRef$1 = forwardRefShim$1;
function joinClassnames() {
    for(var _len = arguments.length, classnames = new Array(_len), _key = 0; _key < _len; _key++)classnames[_key] = arguments[_key];
    return classnames.filter(function(i) {
        return i;
    }).join(" ");
}
/**
 * A <Link> wrapper that knows if it's "active" or not.
 */ var NavLink = forwardRef$1(function(_ref, forwardedRef) {
    var _ref$ariaCurrent = _ref["aria-current"], ariaCurrent = _ref$ariaCurrent === void 0 ? "page" : _ref$ariaCurrent, _ref$activeClassName = _ref.activeClassName, activeClassName = _ref$activeClassName === void 0 ? "active" : _ref$activeClassName, activeStyle = _ref.activeStyle, classNameProp = _ref.className, exact = _ref.exact, isActiveProp = _ref.isActive, locationProp = _ref.location, sensitive = _ref.sensitive, strict = _ref.strict, styleProp = _ref.style, to = _ref.to, innerRef = _ref.innerRef, rest = (0, _objectWithoutPropertiesLooseDefault.default)(_ref, [
        "aria-current",
        "activeClassName",
        "activeStyle",
        "className",
        "exact",
        "isActive",
        "location",
        "sensitive",
        "strict",
        "style",
        "to",
        "innerRef"
    ]);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactRouter.__RouterContext).Consumer, null, function(context) {
        !context && (0, _tinyInvariantDefault.default)(false);
        var currentLocation = locationProp || context.location;
        var toLocation = normalizeToLocation(resolveToLocation(to, currentLocation), currentLocation);
        var path = toLocation.pathname; // Regex taken from: https://github.com/pillarjs/path-to-regexp/blob/master/index.js#L202
        var escapedPath = path && path.replace(/([.+*?=^!:${}()[\]|/\\])/g, "\\$1");
        var match = escapedPath ? (0, _reactRouter.matchPath)(currentLocation.pathname, {
            path: escapedPath,
            exact: exact,
            sensitive: sensitive,
            strict: strict
        }) : null;
        var isActive = !!(isActiveProp ? isActiveProp(match, currentLocation) : match);
        var className = typeof classNameProp === "function" ? classNameProp(isActive) : classNameProp;
        var style = typeof styleProp === "function" ? styleProp(isActive) : styleProp;
        if (isActive) {
            className = joinClassnames(className, activeClassName);
            style = (0, _extendsDefault.default)({}, style, activeStyle);
        }
        var props = (0, _extendsDefault.default)({
            "aria-current": isActive && ariaCurrent || null,
            className: className,
            style: style,
            to: toLocation
        }, rest); // React 15 compat
        if (forwardRefShim$1 !== forwardRef$1) props.ref = forwardedRef || innerRef;
        else props.innerRef = innerRef;
        return /*#__PURE__*/ (0, _reactDefault.default).createElement(Link, props);
    });
});
var ariaCurrentType;

},{"react-router":"i3TiW","@babel/runtime/helpers/esm/inheritsLoose":"9IZpV","react":"6uln9","history":"grwqf","prop-types":"6FKs7","tiny-warning":"328jC","@babel/runtime/helpers/esm/extends":"fW5l8","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"5R6Zx","tiny-invariant":"dPEnp","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"i3TiW":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MemoryRouter", ()=>MemoryRouter);
parcelHelpers.export(exports, "Prompt", ()=>Prompt);
parcelHelpers.export(exports, "Redirect", ()=>Redirect);
parcelHelpers.export(exports, "Route", ()=>Route);
parcelHelpers.export(exports, "Router", ()=>Router);
parcelHelpers.export(exports, "StaticRouter", ()=>StaticRouter);
parcelHelpers.export(exports, "Switch", ()=>Switch);
parcelHelpers.export(exports, "__HistoryContext", ()=>historyContext);
parcelHelpers.export(exports, "__RouterContext", ()=>context);
parcelHelpers.export(exports, "generatePath", ()=>generatePath);
parcelHelpers.export(exports, "matchPath", ()=>matchPath);
parcelHelpers.export(exports, "useHistory", ()=>useHistory);
parcelHelpers.export(exports, "useLocation", ()=>useLocation);
parcelHelpers.export(exports, "useParams", ()=>useParams);
parcelHelpers.export(exports, "useRouteMatch", ()=>useRouteMatch);
parcelHelpers.export(exports, "withRouter", ()=>withRouter);
var _inheritsLoose = require("@babel/runtime/helpers/esm/inheritsLoose");
var _inheritsLooseDefault = parcelHelpers.interopDefault(_inheritsLoose);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _history = require("history");
var _tinyWarning = require("tiny-warning");
var _tinyWarningDefault = parcelHelpers.interopDefault(_tinyWarning);
var _tinyInvariant = require("tiny-invariant");
var _tinyInvariantDefault = parcelHelpers.interopDefault(_tinyInvariant);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _pathToRegexp = require("path-to-regexp");
var _pathToRegexpDefault = parcelHelpers.interopDefault(_pathToRegexp);
var _reactIs = require("react-is");
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _hoistNonReactStatics = require("hoist-non-react-statics");
var _hoistNonReactStaticsDefault = parcelHelpers.interopDefault(_hoistNonReactStatics);
var global = arguments[3];
var MAX_SIGNED_31_BIT_INT = 1073741823;
var commonjsGlobal = typeof globalThis !== "undefined" // 'global proper'
 ? globalThis : typeof window !== "undefined" ? window // Browser
 : typeof global !== "undefined" ? global // node.js
 : {};
function getUniqueId() {
    var key = "__global_unique_id__";
    return commonjsGlobal[key] = (commonjsGlobal[key] || 0) + 1;
} // Inlined Object.is polyfill.
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
function objectIs(x, y) {
    if (x === y) return x !== 0 || 1 / x === 1 / y;
    else // eslint-disable-next-line no-self-compare
    return x !== x && y !== y;
}
function createEventEmitter(value) {
    var handlers = [];
    return {
        on: function on(handler) {
            handlers.push(handler);
        },
        off: function off(handler) {
            handlers = handlers.filter(function(h) {
                return h !== handler;
            });
        },
        get: function get() {
            return value;
        },
        set: function set(newValue, changedBits) {
            value = newValue;
            handlers.forEach(function(handler) {
                return handler(value, changedBits);
            });
        }
    };
}
function onlyChild(children) {
    return Array.isArray(children) ? children[0] : children;
}
function createReactContext(defaultValue, calculateChangedBits) {
    var _Provider$childContex, _Consumer$contextType;
    var contextProp = "__create-react-context-" + getUniqueId() + "__";
    var Provider = /*#__PURE__*/ function(_React$Component) {
        (0, _inheritsLooseDefault.default)(Provider, _React$Component);
        function Provider() {
            var _this;
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            _this = _React$Component.call.apply(_React$Component, [
                this
            ].concat(args)) || this;
            _this.emitter = createEventEmitter(_this.props.value);
            return _this;
        }
        var _proto = Provider.prototype;
        _proto.getChildContext = function getChildContext() {
            var _ref;
            return _ref = {}, _ref[contextProp] = this.emitter, _ref;
        };
        _proto.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
            if (this.props.value !== nextProps.value) {
                var oldValue = this.props.value;
                var newValue = nextProps.value;
                var changedBits;
                if (objectIs(oldValue, newValue)) changedBits = 0; // No change
                else {
                    changedBits = typeof calculateChangedBits === "function" ? calculateChangedBits(oldValue, newValue) : MAX_SIGNED_31_BIT_INT;
                    changedBits |= 0;
                    if (changedBits !== 0) this.emitter.set(nextProps.value, changedBits);
                }
            }
        };
        _proto.render = function render() {
            return this.props.children;
        };
        return Provider;
    }((0, _reactDefault.default).Component);
    Provider.childContextTypes = (_Provider$childContex = {}, _Provider$childContex[contextProp] = (0, _propTypesDefault.default).object.isRequired, _Provider$childContex);
    var Consumer = /*#__PURE__*/ function(_React$Component2) {
        (0, _inheritsLooseDefault.default)(Consumer, _React$Component2);
        function Consumer() {
            var _this2;
            for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
            _this2 = _React$Component2.call.apply(_React$Component2, [
                this
            ].concat(args)) || this;
            _this2.observedBits = void 0;
            _this2.state = {
                value: _this2.getValue()
            };
            _this2.onUpdate = function(newValue, changedBits) {
                var observedBits = _this2.observedBits | 0;
                if ((observedBits & changedBits) !== 0) _this2.setState({
                    value: _this2.getValue()
                });
            };
            return _this2;
        }
        var _proto2 = Consumer.prototype;
        _proto2.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
            var observedBits = nextProps.observedBits;
            this.observedBits = observedBits === undefined || observedBits === null ? MAX_SIGNED_31_BIT_INT // Subscribe to all changes by default
             : observedBits;
        };
        _proto2.componentDidMount = function componentDidMount() {
            if (this.context[contextProp]) this.context[contextProp].on(this.onUpdate);
            var observedBits = this.props.observedBits;
            this.observedBits = observedBits === undefined || observedBits === null ? MAX_SIGNED_31_BIT_INT // Subscribe to all changes by default
             : observedBits;
        };
        _proto2.componentWillUnmount = function componentWillUnmount() {
            if (this.context[contextProp]) this.context[contextProp].off(this.onUpdate);
        };
        _proto2.getValue = function getValue() {
            if (this.context[contextProp]) return this.context[contextProp].get();
            else return defaultValue;
        };
        _proto2.render = function render() {
            return onlyChild(this.props.children)(this.state.value);
        };
        return Consumer;
    }((0, _reactDefault.default).Component);
    Consumer.contextTypes = (_Consumer$contextType = {}, _Consumer$contextType[contextProp] = (0, _propTypesDefault.default).object, _Consumer$contextType);
    return {
        Provider: Provider,
        Consumer: Consumer
    };
}
// MIT License
var createContext = (0, _reactDefault.default).createContext || createReactContext;
// TODO: Replace with React.createContext once we can assume React 16+
var createNamedContext = function createNamedContext(name) {
    var context = createContext();
    context.displayName = name;
    return context;
};
var historyContext = /*#__PURE__*/ createNamedContext("Router-History");
var context = /*#__PURE__*/ createNamedContext("Router");
/**
 * The public API for putting history on context.
 */ var Router = /*#__PURE__*/ function(_React$Component) {
    (0, _inheritsLooseDefault.default)(Router, _React$Component);
    Router.computeRootMatch = function computeRootMatch(pathname) {
        return {
            path: "/",
            url: "/",
            params: {},
            isExact: pathname === "/"
        };
    };
    function Router(props) {
        var _this;
        _this = _React$Component.call(this, props) || this;
        _this.state = {
            location: props.history.location
        }; // This is a bit of a hack. We have to start listening for location
        // changes here in the constructor in case there are any <Redirect>s
        // on the initial render. If there are, they will replace/push when
        // they mount and since cDM fires in children before parents, we may
        // get a new location before the <Router> is mounted.
        _this._isMounted = false;
        _this._pendingLocation = null;
        if (!props.staticContext) _this.unlisten = props.history.listen(function(location) {
            _this._pendingLocation = location;
        });
        return _this;
    }
    var _proto = Router.prototype;
    _proto.componentDidMount = function componentDidMount() {
        var _this2 = this;
        this._isMounted = true;
        if (this.unlisten) // Any pre-mount location changes have been captured at
        // this point, so unregister the listener.
        this.unlisten();
        if (!this.props.staticContext) this.unlisten = this.props.history.listen(function(location) {
            if (_this2._isMounted) _this2.setState({
                location: location
            });
        });
        if (this._pendingLocation) this.setState({
            location: this._pendingLocation
        });
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        if (this.unlisten) {
            this.unlisten();
            this._isMounted = false;
            this._pendingLocation = null;
        }
    };
    _proto.render = function render() {
        return /*#__PURE__*/ (0, _reactDefault.default).createElement(context.Provider, {
            value: {
                history: this.props.history,
                location: this.state.location,
                match: Router.computeRootMatch(this.state.location.pathname),
                staticContext: this.props.staticContext
            }
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement(historyContext.Provider, {
            children: this.props.children || null,
            value: this.props.history
        }));
    };
    return Router;
}((0, _reactDefault.default).Component);
/**
 * The public API for a <Router> that stores location in memory.
 */ var MemoryRouter = /*#__PURE__*/ function(_React$Component) {
    (0, _inheritsLooseDefault.default)(MemoryRouter, _React$Component);
    function MemoryRouter() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.history = (0, _history.createMemoryHistory)(_this.props);
        return _this;
    }
    var _proto = MemoryRouter.prototype;
    _proto.render = function render() {
        return /*#__PURE__*/ (0, _reactDefault.default).createElement(Router, {
            history: this.history,
            children: this.props.children
        });
    };
    return MemoryRouter;
}((0, _reactDefault.default).Component);
var Lifecycle = /*#__PURE__*/ function(_React$Component) {
    (0, _inheritsLooseDefault.default)(Lifecycle, _React$Component);
    function Lifecycle() {
        return _React$Component.apply(this, arguments) || this;
    }
    var _proto = Lifecycle.prototype;
    _proto.componentDidMount = function componentDidMount() {
        if (this.props.onMount) this.props.onMount.call(this, this);
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        if (this.props.onUpdate) this.props.onUpdate.call(this, this, prevProps);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        if (this.props.onUnmount) this.props.onUnmount.call(this, this);
    };
    _proto.render = function render() {
        return null;
    };
    return Lifecycle;
}((0, _reactDefault.default).Component);
/**
 * The public API for prompting the user before navigating away from a screen.
 */ function Prompt(_ref) {
    var message = _ref.message, _ref$when = _ref.when, when = _ref$when === void 0 ? true : _ref$when;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(context.Consumer, null, function(context) {
        !context && (0, _tinyInvariantDefault.default)(false);
        if (!when || context.staticContext) return null;
        var method = context.history.block;
        return /*#__PURE__*/ (0, _reactDefault.default).createElement(Lifecycle, {
            onMount: function onMount(self) {
                self.release = method(message);
            },
            onUpdate: function onUpdate(self, prevProps) {
                if (prevProps.message !== message) {
                    self.release();
                    self.release = method(message);
                }
            },
            onUnmount: function onUnmount(self) {
                self.release();
            },
            message: message
        });
    });
}
var messageType;
var cache = {};
var cacheLimit = 10000;
var cacheCount = 0;
function compilePath(path) {
    if (cache[path]) return cache[path];
    var generator = (0, _pathToRegexpDefault.default).compile(path);
    if (cacheCount < cacheLimit) {
        cache[path] = generator;
        cacheCount++;
    }
    return generator;
}
/**
 * Public API for generating a URL pathname from a path and parameters.
 */ function generatePath(path, params) {
    if (path === void 0) path = "/";
    if (params === void 0) params = {};
    return path === "/" ? path : compilePath(path)(params, {
        pretty: true
    });
}
/**
 * The public API for navigating programmatically with a component.
 */ function Redirect(_ref) {
    var computedMatch = _ref.computedMatch, to = _ref.to, _ref$push = _ref.push, push = _ref$push === void 0 ? false : _ref$push;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(context.Consumer, null, function(context) {
        !context && (0, _tinyInvariantDefault.default)(false);
        var history = context.history, staticContext = context.staticContext;
        var method = push ? history.push : history.replace;
        var location = (0, _history.createLocation)(computedMatch ? typeof to === "string" ? generatePath(to, computedMatch.params) : (0, _extendsDefault.default)({}, to, {
            pathname: generatePath(to.pathname, computedMatch.params)
        }) : to); // When rendering in a static context,
        // set the new location immediately.
        if (staticContext) {
            method(location);
            return null;
        }
        return /*#__PURE__*/ (0, _reactDefault.default).createElement(Lifecycle, {
            onMount: function onMount() {
                method(location);
            },
            onUpdate: function onUpdate(self, prevProps) {
                var prevLocation = (0, _history.createLocation)(prevProps.to);
                if (!(0, _history.locationsAreEqual)(prevLocation, (0, _extendsDefault.default)({}, location, {
                    key: prevLocation.key
                }))) method(location);
            },
            to: to
        });
    });
}
var cache$1 = {};
var cacheLimit$1 = 10000;
var cacheCount$1 = 0;
function compilePath$1(path, options) {
    var cacheKey = "" + options.end + options.strict + options.sensitive;
    var pathCache = cache$1[cacheKey] || (cache$1[cacheKey] = {});
    if (pathCache[path]) return pathCache[path];
    var keys = [];
    var regexp = (0, _pathToRegexpDefault.default)(path, keys, options);
    var result = {
        regexp: regexp,
        keys: keys
    };
    if (cacheCount$1 < cacheLimit$1) {
        pathCache[path] = result;
        cacheCount$1++;
    }
    return result;
}
/**
 * Public API for matching a URL pathname to a path.
 */ function matchPath(pathname, options) {
    if (options === void 0) options = {};
    if (typeof options === "string" || Array.isArray(options)) options = {
        path: options
    };
    var _options = options, path = _options.path, _options$exact = _options.exact, exact = _options$exact === void 0 ? false : _options$exact, _options$strict = _options.strict, strict = _options$strict === void 0 ? false : _options$strict, _options$sensitive = _options.sensitive, sensitive = _options$sensitive === void 0 ? false : _options$sensitive;
    var paths = [].concat(path);
    return paths.reduce(function(matched, path) {
        if (!path && path !== "") return null;
        if (matched) return matched;
        var _compilePath = compilePath$1(path, {
            end: exact,
            strict: strict,
            sensitive: sensitive
        }), regexp = _compilePath.regexp, keys = _compilePath.keys;
        var match = regexp.exec(pathname);
        if (!match) return null;
        var url = match[0], values = match.slice(1);
        var isExact = pathname === url;
        if (exact && !isExact) return null;
        return {
            path: path,
            // the path used to match
            url: path === "/" && url === "" ? "/" : url,
            // the matched portion of the URL
            isExact: isExact,
            // whether or not we matched exactly
            params: keys.reduce(function(memo, key, index) {
                memo[key.name] = values[index];
                return memo;
            }, {})
        };
    }, null);
}
function isEmptyChildren(children) {
    return (0, _reactDefault.default).Children.count(children) === 0;
}
function evalChildrenDev(children, props, path) {
    var value = children(props);
    return value || null;
}
/**
 * The public API for matching a single path and rendering.
 */ var Route = /*#__PURE__*/ function(_React$Component) {
    (0, _inheritsLooseDefault.default)(Route, _React$Component);
    function Route() {
        return _React$Component.apply(this, arguments) || this;
    }
    var _proto = Route.prototype;
    _proto.render = function render() {
        var _this = this;
        return /*#__PURE__*/ (0, _reactDefault.default).createElement(context.Consumer, null, function(context$1) {
            !context$1 && (0, _tinyInvariantDefault.default)(false);
            var location = _this.props.location || context$1.location;
            var match = _this.props.computedMatch ? _this.props.computedMatch // <Switch> already computed the match for us
             : _this.props.path ? matchPath(location.pathname, _this.props) : context$1.match;
            var props = (0, _extendsDefault.default)({}, context$1, {
                location: location,
                match: match
            });
            var _this$props = _this.props, children = _this$props.children, component = _this$props.component, render = _this$props.render; // Preact uses an empty array as children by
            // default, so use null if that's the case.
            if (Array.isArray(children) && isEmptyChildren(children)) children = null;
            return /*#__PURE__*/ (0, _reactDefault.default).createElement(context.Provider, {
                value: props
            }, props.match ? children ? typeof children === "function" ? children(props) : children : component ? /*#__PURE__*/ (0, _reactDefault.default).createElement(component, props) : render ? render(props) : null : typeof children === "function" ? children(props) : null);
        });
    };
    return Route;
}((0, _reactDefault.default).Component);
function addLeadingSlash(path) {
    return path.charAt(0) === "/" ? path : "/" + path;
}
function addBasename(basename, location) {
    if (!basename) return location;
    return (0, _extendsDefault.default)({}, location, {
        pathname: addLeadingSlash(basename) + location.pathname
    });
}
function stripBasename(basename, location) {
    if (!basename) return location;
    var base = addLeadingSlash(basename);
    if (location.pathname.indexOf(base) !== 0) return location;
    return (0, _extendsDefault.default)({}, location, {
        pathname: location.pathname.substr(base.length)
    });
}
function createURL(location) {
    return typeof location === "string" ? location : (0, _history.createPath)(location);
}
function staticHandler(methodName) {
    return function() {
        (0, _tinyInvariantDefault.default)(false);
    };
}
function noop() {}
/**
 * The public top-level API for a "static" <Router>, so-called because it
 * can't actually change the current location. Instead, it just records
 * location changes in a context object. Useful mainly in testing and
 * server-rendering scenarios.
 */ var StaticRouter = /*#__PURE__*/ function(_React$Component) {
    (0, _inheritsLooseDefault.default)(StaticRouter, _React$Component);
    function StaticRouter() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.handlePush = function(location) {
            return _this.navigateTo(location, "PUSH");
        };
        _this.handleReplace = function(location) {
            return _this.navigateTo(location, "REPLACE");
        };
        _this.handleListen = function() {
            return noop;
        };
        _this.handleBlock = function() {
            return noop;
        };
        return _this;
    }
    var _proto = StaticRouter.prototype;
    _proto.navigateTo = function navigateTo(location, action) {
        var _this$props = this.props, _this$props$basename = _this$props.basename, basename = _this$props$basename === void 0 ? "" : _this$props$basename, _this$props$context = _this$props.context, context = _this$props$context === void 0 ? {} : _this$props$context;
        context.action = action;
        context.location = addBasename(basename, (0, _history.createLocation)(location));
        context.url = createURL(context.location);
    };
    _proto.render = function render() {
        var _this$props2 = this.props, _this$props2$basename = _this$props2.basename, basename = _this$props2$basename === void 0 ? "" : _this$props2$basename, _this$props2$context = _this$props2.context, context = _this$props2$context === void 0 ? {} : _this$props2$context, _this$props2$location = _this$props2.location, location = _this$props2$location === void 0 ? "/" : _this$props2$location, rest = (0, _objectWithoutPropertiesLooseDefault.default)(_this$props2, [
            "basename",
            "context",
            "location"
        ]);
        var history = {
            createHref: function createHref(path) {
                return addLeadingSlash(basename + createURL(path));
            },
            action: "POP",
            location: stripBasename(basename, (0, _history.createLocation)(location)),
            push: this.handlePush,
            replace: this.handleReplace,
            go: staticHandler("go"),
            goBack: staticHandler("goBack"),
            goForward: staticHandler("goForward"),
            listen: this.handleListen,
            block: this.handleBlock
        };
        return /*#__PURE__*/ (0, _reactDefault.default).createElement(Router, (0, _extendsDefault.default)({}, rest, {
            history: history,
            staticContext: context
        }));
    };
    return StaticRouter;
}((0, _reactDefault.default).Component);
/**
 * The public API for rendering the first <Route> that matches.
 */ var Switch = /*#__PURE__*/ function(_React$Component) {
    (0, _inheritsLooseDefault.default)(Switch, _React$Component);
    function Switch() {
        return _React$Component.apply(this, arguments) || this;
    }
    var _proto = Switch.prototype;
    _proto.render = function render() {
        var _this = this;
        return /*#__PURE__*/ (0, _reactDefault.default).createElement(context.Consumer, null, function(context) {
            !context && (0, _tinyInvariantDefault.default)(false);
            var location = _this.props.location || context.location;
            var element, match; // We use React.Children.forEach instead of React.Children.toArray().find()
            // here because toArray adds keys to all child elements and we do not want
            // to trigger an unmount/remount for two <Route>s that render the same
            // component at different URLs.
            (0, _reactDefault.default).Children.forEach(_this.props.children, function(child) {
                if (match == null && /*#__PURE__*/ (0, _reactDefault.default).isValidElement(child)) {
                    element = child;
                    var path = child.props.path || child.props.from;
                    match = path ? matchPath(location.pathname, (0, _extendsDefault.default)({}, child.props, {
                        path: path
                    })) : context.match;
                }
            });
            return match ? /*#__PURE__*/ (0, _reactDefault.default).cloneElement(element, {
                location: location,
                computedMatch: match
            }) : null;
        });
    };
    return Switch;
}((0, _reactDefault.default).Component);
/**
 * A public higher-order component to access the imperative API
 */ function withRouter(Component) {
    var displayName = "withRouter(" + (Component.displayName || Component.name) + ")";
    var C = function C(props) {
        var wrappedComponentRef = props.wrappedComponentRef, remainingProps = (0, _objectWithoutPropertiesLooseDefault.default)(props, [
            "wrappedComponentRef"
        ]);
        return /*#__PURE__*/ (0, _reactDefault.default).createElement(context.Consumer, null, function(context) {
            !context && (0, _tinyInvariantDefault.default)(false);
            return /*#__PURE__*/ (0, _reactDefault.default).createElement(Component, (0, _extendsDefault.default)({}, remainingProps, context, {
                ref: wrappedComponentRef
            }));
        });
    };
    C.displayName = displayName;
    C.WrappedComponent = Component;
    return (0, _hoistNonReactStaticsDefault.default)(C, Component);
}
var useContext = (0, _reactDefault.default).useContext;
function useHistory() {
    return useContext(historyContext);
}
function useLocation() {
    return useContext(context).location;
}
function useParams() {
    var match = useContext(context).match;
    return match ? match.params : {};
}
function useRouteMatch(path) {
    var location = useLocation();
    var match = useContext(context).match;
    return path ? matchPath(location.pathname, path) : match;
}
var global$1, key, buildNames, initialBuildName, secondaryBuildName;

},{"@babel/runtime/helpers/esm/inheritsLoose":"9IZpV","react":"6uln9","prop-types":"6FKs7","history":"grwqf","tiny-warning":"328jC","tiny-invariant":"dPEnp","@babel/runtime/helpers/esm/extends":"fW5l8","path-to-regexp":"ejAzl","react-is":"aUAsc","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"5R6Zx","hoist-non-react-statics":"3bvdc","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9IZpV":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_inheritsLoose);
var _setPrototypeOfJs = require("./setPrototypeOf.js");
var _setPrototypeOfJsDefault = parcelHelpers.interopDefault(_setPrototypeOfJs);
function _inheritsLoose(t, o) {
    t.prototype = Object.create(o.prototype), t.prototype.constructor = t, (0, _setPrototypeOfJsDefault.default)(t, o);
}

},{"./setPrototypeOf.js":"hT6Yn","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hT6Yn":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_setPrototypeOf);
function _setPrototypeOf(t, e) {
    return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, _setPrototypeOf(t, e);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6FKs7":[function(require,module,exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var ReactIs, throwOnDirectAccess;
// By explicitly using `prop-types` you are opting into new production behavior.
// http://fb.me/prop-types-in-prod
module.exports = require("e98516c5bab4526")();

},{"e98516c5bab4526":"7ziwC"}],"7ziwC":[function(require,module,exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var ReactPropTypesSecret = require("bf7f43a19ae1b960");
function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;
module.exports = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === ReactPropTypesSecret) // It is still safe when called from React.
        return;
        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        err.name = "Invariant Violation";
        throw err;
    }
    shim.isRequired = shim;
    function getShim() {
        return shim;
    }
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
        array: shim,
        bigint: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: emptyFunctionWithReset,
        resetWarningCache: emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

},{"bf7f43a19ae1b960":"4Cml4"}],"4Cml4":[function(require,module,exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var ReactPropTypesSecret = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
module.exports = ReactPropTypesSecret;

},{}],"grwqf":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createBrowserHistory", ()=>createBrowserHistory);
parcelHelpers.export(exports, "createHashHistory", ()=>createHashHistory);
parcelHelpers.export(exports, "createMemoryHistory", ()=>createMemoryHistory);
parcelHelpers.export(exports, "createLocation", ()=>createLocation);
parcelHelpers.export(exports, "locationsAreEqual", ()=>locationsAreEqual);
parcelHelpers.export(exports, "parsePath", ()=>parsePath);
parcelHelpers.export(exports, "createPath", ()=>createPath);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _resolvePathname = require("resolve-pathname");
var _resolvePathnameDefault = parcelHelpers.interopDefault(_resolvePathname);
var _valueEqual = require("value-equal");
var _valueEqualDefault = parcelHelpers.interopDefault(_valueEqual);
var _tinyWarning = require("tiny-warning");
var _tinyWarningDefault = parcelHelpers.interopDefault(_tinyWarning);
var _tinyInvariant = require("tiny-invariant");
var _tinyInvariantDefault = parcelHelpers.interopDefault(_tinyInvariant);
function addLeadingSlash(path) {
    return path.charAt(0) === "/" ? path : "/" + path;
}
function stripLeadingSlash(path) {
    return path.charAt(0) === "/" ? path.substr(1) : path;
}
function hasBasename(path, prefix) {
    return path.toLowerCase().indexOf(prefix.toLowerCase()) === 0 && "/?#".indexOf(path.charAt(prefix.length)) !== -1;
}
function stripBasename(path, prefix) {
    return hasBasename(path, prefix) ? path.substr(prefix.length) : path;
}
function stripTrailingSlash(path) {
    return path.charAt(path.length - 1) === "/" ? path.slice(0, -1) : path;
}
function parsePath(path) {
    var pathname = path || "/";
    var search = "";
    var hash = "";
    var hashIndex = pathname.indexOf("#");
    if (hashIndex !== -1) {
        hash = pathname.substr(hashIndex);
        pathname = pathname.substr(0, hashIndex);
    }
    var searchIndex = pathname.indexOf("?");
    if (searchIndex !== -1) {
        search = pathname.substr(searchIndex);
        pathname = pathname.substr(0, searchIndex);
    }
    return {
        pathname: pathname,
        search: search === "?" ? "" : search,
        hash: hash === "#" ? "" : hash
    };
}
function createPath(location) {
    var pathname = location.pathname, search = location.search, hash = location.hash;
    var path = pathname || "/";
    if (search && search !== "?") path += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") path += hash.charAt(0) === "#" ? hash : "#" + hash;
    return path;
}
function createLocation(path, state, key, currentLocation) {
    var location;
    if (typeof path === "string") {
        // Two-arg form: push(path, state)
        location = parsePath(path);
        location.state = state;
    } else {
        // One-arg form: push(location)
        location = (0, _extendsDefault.default)({}, path);
        if (location.pathname === undefined) location.pathname = "";
        if (location.search) {
            if (location.search.charAt(0) !== "?") location.search = "?" + location.search;
        } else location.search = "";
        if (location.hash) {
            if (location.hash.charAt(0) !== "#") location.hash = "#" + location.hash;
        } else location.hash = "";
        if (state !== undefined && location.state === undefined) location.state = state;
    }
    try {
        location.pathname = decodeURI(location.pathname);
    } catch (e) {
        if (e instanceof URIError) throw new URIError('Pathname "' + location.pathname + '" could not be decoded. ' + "This is likely caused by an invalid percent-encoding.");
        else throw e;
    }
    if (key) location.key = key;
    if (currentLocation) {
        // Resolve incomplete/relative pathname relative to current location.
        if (!location.pathname) location.pathname = currentLocation.pathname;
        else if (location.pathname.charAt(0) !== "/") location.pathname = (0, _resolvePathnameDefault.default)(location.pathname, currentLocation.pathname);
    } else // When there is no prior location and pathname is empty, set it to /
    if (!location.pathname) location.pathname = "/";
    return location;
}
function locationsAreEqual(a, b) {
    return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash && a.key === b.key && (0, _valueEqualDefault.default)(a.state, b.state);
}
function createTransitionManager() {
    var prompt = null;
    function setPrompt(nextPrompt) {
        prompt = nextPrompt;
        return function() {
            if (prompt === nextPrompt) prompt = null;
        };
    }
    function confirmTransitionTo(location, action, getUserConfirmation, callback) {
        // TODO: If another transition starts while we're still confirming
        // the previous one, we may end up in a weird state. Figure out the
        // best way to handle this.
        if (prompt != null) {
            var result = typeof prompt === "function" ? prompt(location, action) : prompt;
            if (typeof result === "string") {
                if (typeof getUserConfirmation === "function") getUserConfirmation(result, callback);
                else callback(true);
            } else // Return false from a transition hook to cancel the transition.
            callback(result !== false);
        } else callback(true);
    }
    var listeners = [];
    function appendListener(fn) {
        var isActive = true;
        function listener() {
            if (isActive) fn.apply(void 0, arguments);
        }
        listeners.push(listener);
        return function() {
            isActive = false;
            listeners = listeners.filter(function(item) {
                return item !== listener;
            });
        };
    }
    function notifyListeners() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        listeners.forEach(function(listener) {
            return listener.apply(void 0, args);
        });
    }
    return {
        setPrompt: setPrompt,
        confirmTransitionTo: confirmTransitionTo,
        appendListener: appendListener,
        notifyListeners: notifyListeners
    };
}
var canUseDOM = !!(typeof window !== "undefined" && window.document && window.document.createElement);
function getConfirmation(message, callback) {
    callback(window.confirm(message)); // eslint-disable-line no-alert
}
/**
 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
 *
 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
 * changed to avoid false negatives for Windows Phones: https://github.com/reactjs/react-router/issues/586
 */ function supportsHistory() {
    var ua = window.navigator.userAgent;
    if ((ua.indexOf("Android 2.") !== -1 || ua.indexOf("Android 4.0") !== -1) && ua.indexOf("Mobile Safari") !== -1 && ua.indexOf("Chrome") === -1 && ua.indexOf("Windows Phone") === -1) return false;
    return window.history && "pushState" in window.history;
}
/**
 * Returns true if browser fires popstate on hash change.
 * IE10 and IE11 do not.
 */ function supportsPopStateOnHashChange() {
    return window.navigator.userAgent.indexOf("Trident") === -1;
}
/**
 * Returns false if using go(n) with hash history causes a full page reload.
 */ function supportsGoWithoutReloadUsingHash() {
    return window.navigator.userAgent.indexOf("Firefox") === -1;
}
/**
 * Returns true if a given popstate event is an extraneous WebKit event.
 * Accounts for the fact that Chrome on iOS fires real popstate events
 * containing undefined state when pressing the back button.
 */ function isExtraneousPopstateEvent(event) {
    return event.state === undefined && navigator.userAgent.indexOf("CriOS") === -1;
}
var PopStateEvent = "popstate";
var HashChangeEvent = "hashchange";
function getHistoryState() {
    try {
        return window.history.state || {};
    } catch (e) {
        // IE 11 sometimes throws when accessing window.history.state
        // See https://github.com/ReactTraining/history/pull/289
        return {};
    }
}
/**
 * Creates a history object that uses the HTML5 history API including
 * pushState, replaceState, and the popstate event.
 */ function createBrowserHistory(props) {
    if (props === void 0) props = {};
    !canUseDOM && (0, _tinyInvariantDefault.default)(false);
    var globalHistory = window.history;
    var canUseHistory = supportsHistory();
    var needsHashChangeListener = !supportsPopStateOnHashChange();
    var _props = props, _props$forceRefresh = _props.forceRefresh, forceRefresh = _props$forceRefresh === void 0 ? false : _props$forceRefresh, _props$getUserConfirm = _props.getUserConfirmation, getUserConfirmation = _props$getUserConfirm === void 0 ? getConfirmation : _props$getUserConfirm, _props$keyLength = _props.keyLength, keyLength = _props$keyLength === void 0 ? 6 : _props$keyLength;
    var basename = props.basename ? stripTrailingSlash(addLeadingSlash(props.basename)) : "";
    function getDOMLocation(historyState) {
        var _ref = historyState || {}, key = _ref.key, state = _ref.state;
        var _window$location = window.location, pathname = _window$location.pathname, search = _window$location.search, hash = _window$location.hash;
        var path = pathname + search + hash;
        if (basename) path = stripBasename(path, basename);
        return createLocation(path, state, key);
    }
    function createKey() {
        return Math.random().toString(36).substr(2, keyLength);
    }
    var transitionManager = createTransitionManager();
    function setState(nextState) {
        (0, _extendsDefault.default)(history, nextState);
        history.length = globalHistory.length;
        transitionManager.notifyListeners(history.location, history.action);
    }
    function handlePopState(event) {
        // Ignore extraneous popstate events in WebKit.
        if (isExtraneousPopstateEvent(event)) return;
        handlePop(getDOMLocation(event.state));
    }
    function handleHashChange() {
        handlePop(getDOMLocation(getHistoryState()));
    }
    var forceNextPop = false;
    function handlePop(location) {
        if (forceNextPop) {
            forceNextPop = false;
            setState();
        } else {
            var action = "POP";
            transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
                if (ok) setState({
                    action: action,
                    location: location
                });
                else revertPop(location);
            });
        }
    }
    function revertPop(fromLocation) {
        var toLocation = history.location; // TODO: We could probably make this more reliable by
        // keeping a list of keys we've seen in sessionStorage.
        // Instead, we just default to 0 for keys we don't know.
        var toIndex = allKeys.indexOf(toLocation.key);
        if (toIndex === -1) toIndex = 0;
        var fromIndex = allKeys.indexOf(fromLocation.key);
        if (fromIndex === -1) fromIndex = 0;
        var delta = toIndex - fromIndex;
        if (delta) {
            forceNextPop = true;
            go(delta);
        }
    }
    var initialLocation = getDOMLocation(getHistoryState());
    var allKeys = [
        initialLocation.key
    ]; // Public interface
    function createHref(location) {
        return basename + createPath(location);
    }
    function push(path, state) {
        var action = "PUSH";
        var location = createLocation(path, state, createKey(), history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var href = createHref(location);
            var key = location.key, state = location.state;
            if (canUseHistory) {
                globalHistory.pushState({
                    key: key,
                    state: state
                }, null, href);
                if (forceRefresh) window.location.href = href;
                else {
                    var prevIndex = allKeys.indexOf(history.location.key);
                    var nextKeys = allKeys.slice(0, prevIndex + 1);
                    nextKeys.push(location.key);
                    allKeys = nextKeys;
                    setState({
                        action: action,
                        location: location
                    });
                }
            } else window.location.href = href;
        });
    }
    function replace(path, state) {
        var action = "REPLACE";
        var location = createLocation(path, state, createKey(), history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var href = createHref(location);
            var key = location.key, state = location.state;
            if (canUseHistory) {
                globalHistory.replaceState({
                    key: key,
                    state: state
                }, null, href);
                if (forceRefresh) window.location.replace(href);
                else {
                    var prevIndex = allKeys.indexOf(history.location.key);
                    if (prevIndex !== -1) allKeys[prevIndex] = location.key;
                    setState({
                        action: action,
                        location: location
                    });
                }
            } else window.location.replace(href);
        });
    }
    function go(n) {
        globalHistory.go(n);
    }
    function goBack() {
        go(-1);
    }
    function goForward() {
        go(1);
    }
    var listenerCount = 0;
    function checkDOMListeners(delta) {
        listenerCount += delta;
        if (listenerCount === 1 && delta === 1) {
            window.addEventListener(PopStateEvent, handlePopState);
            if (needsHashChangeListener) window.addEventListener(HashChangeEvent, handleHashChange);
        } else if (listenerCount === 0) {
            window.removeEventListener(PopStateEvent, handlePopState);
            if (needsHashChangeListener) window.removeEventListener(HashChangeEvent, handleHashChange);
        }
    }
    var isBlocked = false;
    function block(prompt) {
        if (prompt === void 0) prompt = false;
        var unblock = transitionManager.setPrompt(prompt);
        if (!isBlocked) {
            checkDOMListeners(1);
            isBlocked = true;
        }
        return function() {
            if (isBlocked) {
                isBlocked = false;
                checkDOMListeners(-1);
            }
            return unblock();
        };
    }
    function listen(listener) {
        var unlisten = transitionManager.appendListener(listener);
        checkDOMListeners(1);
        return function() {
            checkDOMListeners(-1);
            unlisten();
        };
    }
    var history = {
        length: globalHistory.length,
        action: "POP",
        location: initialLocation,
        createHref: createHref,
        push: push,
        replace: replace,
        go: go,
        goBack: goBack,
        goForward: goForward,
        block: block,
        listen: listen
    };
    return history;
}
var HashChangeEvent$1 = "hashchange";
var HashPathCoders = {
    hashbang: {
        encodePath: function encodePath(path) {
            return path.charAt(0) === "!" ? path : "!/" + stripLeadingSlash(path);
        },
        decodePath: function decodePath(path) {
            return path.charAt(0) === "!" ? path.substr(1) : path;
        }
    },
    noslash: {
        encodePath: stripLeadingSlash,
        decodePath: addLeadingSlash
    },
    slash: {
        encodePath: addLeadingSlash,
        decodePath: addLeadingSlash
    }
};
function stripHash(url) {
    var hashIndex = url.indexOf("#");
    return hashIndex === -1 ? url : url.slice(0, hashIndex);
}
function getHashPath() {
    // We can't use window.location.hash here because it's not
    // consistent across browsers - Firefox will pre-decode it!
    var href = window.location.href;
    var hashIndex = href.indexOf("#");
    return hashIndex === -1 ? "" : href.substring(hashIndex + 1);
}
function pushHashPath(path) {
    window.location.hash = path;
}
function replaceHashPath(path) {
    window.location.replace(stripHash(window.location.href) + "#" + path);
}
function createHashHistory(props) {
    if (props === void 0) props = {};
    !canUseDOM && (0, _tinyInvariantDefault.default)(false);
    var globalHistory = window.history;
    var canGoWithoutReload = supportsGoWithoutReloadUsingHash();
    var _props = props, _props$getUserConfirm = _props.getUserConfirmation, getUserConfirmation = _props$getUserConfirm === void 0 ? getConfirmation : _props$getUserConfirm, _props$hashType = _props.hashType, hashType = _props$hashType === void 0 ? "slash" : _props$hashType;
    var basename = props.basename ? stripTrailingSlash(addLeadingSlash(props.basename)) : "";
    var _HashPathCoders$hashT = HashPathCoders[hashType], encodePath = _HashPathCoders$hashT.encodePath, decodePath = _HashPathCoders$hashT.decodePath;
    function getDOMLocation() {
        var path = decodePath(getHashPath());
        if (basename) path = stripBasename(path, basename);
        return createLocation(path);
    }
    var transitionManager = createTransitionManager();
    function setState(nextState) {
        (0, _extendsDefault.default)(history, nextState);
        history.length = globalHistory.length;
        transitionManager.notifyListeners(history.location, history.action);
    }
    var forceNextPop = false;
    var ignorePath = null;
    function locationsAreEqual$$1(a, b) {
        return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash;
    }
    function handleHashChange() {
        var path = getHashPath();
        var encodedPath = encodePath(path);
        if (path !== encodedPath) // Ensure we always have a properly-encoded hash.
        replaceHashPath(encodedPath);
        else {
            var location = getDOMLocation();
            var prevLocation = history.location;
            if (!forceNextPop && locationsAreEqual$$1(prevLocation, location)) return; // A hashchange doesn't always == location change.
            if (ignorePath === createPath(location)) return; // Ignore this change; we already setState in push/replace.
            ignorePath = null;
            handlePop(location);
        }
    }
    function handlePop(location) {
        if (forceNextPop) {
            forceNextPop = false;
            setState();
        } else {
            var action = "POP";
            transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
                if (ok) setState({
                    action: action,
                    location: location
                });
                else revertPop(location);
            });
        }
    }
    function revertPop(fromLocation) {
        var toLocation = history.location; // TODO: We could probably make this more reliable by
        // keeping a list of paths we've seen in sessionStorage.
        // Instead, we just default to 0 for paths we don't know.
        var toIndex = allPaths.lastIndexOf(createPath(toLocation));
        if (toIndex === -1) toIndex = 0;
        var fromIndex = allPaths.lastIndexOf(createPath(fromLocation));
        if (fromIndex === -1) fromIndex = 0;
        var delta = toIndex - fromIndex;
        if (delta) {
            forceNextPop = true;
            go(delta);
        }
    } // Ensure the hash is encoded properly before doing anything else.
    var path = getHashPath();
    var encodedPath = encodePath(path);
    if (path !== encodedPath) replaceHashPath(encodedPath);
    var initialLocation = getDOMLocation();
    var allPaths = [
        createPath(initialLocation)
    ]; // Public interface
    function createHref(location) {
        var baseTag = document.querySelector("base");
        var href = "";
        if (baseTag && baseTag.getAttribute("href")) href = stripHash(window.location.href);
        return href + "#" + encodePath(basename + createPath(location));
    }
    function push(path, state) {
        var action = "PUSH";
        var location = createLocation(path, undefined, undefined, history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var path = createPath(location);
            var encodedPath = encodePath(basename + path);
            var hashChanged = getHashPath() !== encodedPath;
            if (hashChanged) {
                // We cannot tell if a hashchange was caused by a PUSH, so we'd
                // rather setState here and ignore the hashchange. The caveat here
                // is that other hash histories in the page will consider it a POP.
                ignorePath = path;
                pushHashPath(encodedPath);
                var prevIndex = allPaths.lastIndexOf(createPath(history.location));
                var nextPaths = allPaths.slice(0, prevIndex + 1);
                nextPaths.push(path);
                allPaths = nextPaths;
                setState({
                    action: action,
                    location: location
                });
            } else setState();
        });
    }
    function replace(path, state) {
        var action = "REPLACE";
        var location = createLocation(path, undefined, undefined, history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var path = createPath(location);
            var encodedPath = encodePath(basename + path);
            var hashChanged = getHashPath() !== encodedPath;
            if (hashChanged) {
                // We cannot tell if a hashchange was caused by a REPLACE, so we'd
                // rather setState here and ignore the hashchange. The caveat here
                // is that other hash histories in the page will consider it a POP.
                ignorePath = path;
                replaceHashPath(encodedPath);
            }
            var prevIndex = allPaths.indexOf(createPath(history.location));
            if (prevIndex !== -1) allPaths[prevIndex] = path;
            setState({
                action: action,
                location: location
            });
        });
    }
    function go(n) {
        globalHistory.go(n);
    }
    function goBack() {
        go(-1);
    }
    function goForward() {
        go(1);
    }
    var listenerCount = 0;
    function checkDOMListeners(delta) {
        listenerCount += delta;
        if (listenerCount === 1 && delta === 1) window.addEventListener(HashChangeEvent$1, handleHashChange);
        else if (listenerCount === 0) window.removeEventListener(HashChangeEvent$1, handleHashChange);
    }
    var isBlocked = false;
    function block(prompt) {
        if (prompt === void 0) prompt = false;
        var unblock = transitionManager.setPrompt(prompt);
        if (!isBlocked) {
            checkDOMListeners(1);
            isBlocked = true;
        }
        return function() {
            if (isBlocked) {
                isBlocked = false;
                checkDOMListeners(-1);
            }
            return unblock();
        };
    }
    function listen(listener) {
        var unlisten = transitionManager.appendListener(listener);
        checkDOMListeners(1);
        return function() {
            checkDOMListeners(-1);
            unlisten();
        };
    }
    var history = {
        length: globalHistory.length,
        action: "POP",
        location: initialLocation,
        createHref: createHref,
        push: push,
        replace: replace,
        go: go,
        goBack: goBack,
        goForward: goForward,
        block: block,
        listen: listen
    };
    return history;
}
function clamp(n, lowerBound, upperBound) {
    return Math.min(Math.max(n, lowerBound), upperBound);
}
/**
 * Creates a history object that stores locations in memory.
 */ function createMemoryHistory(props) {
    if (props === void 0) props = {};
    var _props = props, getUserConfirmation = _props.getUserConfirmation, _props$initialEntries = _props.initialEntries, initialEntries = _props$initialEntries === void 0 ? [
        "/"
    ] : _props$initialEntries, _props$initialIndex = _props.initialIndex, initialIndex = _props$initialIndex === void 0 ? 0 : _props$initialIndex, _props$keyLength = _props.keyLength, keyLength = _props$keyLength === void 0 ? 6 : _props$keyLength;
    var transitionManager = createTransitionManager();
    function setState(nextState) {
        (0, _extendsDefault.default)(history, nextState);
        history.length = history.entries.length;
        transitionManager.notifyListeners(history.location, history.action);
    }
    function createKey() {
        return Math.random().toString(36).substr(2, keyLength);
    }
    var index = clamp(initialIndex, 0, initialEntries.length - 1);
    var entries = initialEntries.map(function(entry) {
        return typeof entry === "string" ? createLocation(entry, undefined, createKey()) : createLocation(entry, undefined, entry.key || createKey());
    }); // Public interface
    var createHref = createPath;
    function push(path, state) {
        var action = "PUSH";
        var location = createLocation(path, state, createKey(), history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var prevIndex = history.index;
            var nextIndex = prevIndex + 1;
            var nextEntries = history.entries.slice(0);
            if (nextEntries.length > nextIndex) nextEntries.splice(nextIndex, nextEntries.length - nextIndex, location);
            else nextEntries.push(location);
            setState({
                action: action,
                location: location,
                index: nextIndex,
                entries: nextEntries
            });
        });
    }
    function replace(path, state) {
        var action = "REPLACE";
        var location = createLocation(path, state, createKey(), history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            history.entries[history.index] = location;
            setState({
                action: action,
                location: location
            });
        });
    }
    function go(n) {
        var nextIndex = clamp(history.index + n, 0, history.entries.length - 1);
        var action = "POP";
        var location = history.entries[nextIndex];
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (ok) setState({
                action: action,
                location: location,
                index: nextIndex
            });
            else // Mimic the behavior of DOM histories by
            // causing a render after a cancelled POP.
            setState();
        });
    }
    function goBack() {
        go(-1);
    }
    function goForward() {
        go(1);
    }
    function canGo(n) {
        var nextIndex = history.index + n;
        return nextIndex >= 0 && nextIndex < history.entries.length;
    }
    function block(prompt) {
        if (prompt === void 0) prompt = false;
        return transitionManager.setPrompt(prompt);
    }
    function listen(listener) {
        return transitionManager.appendListener(listener);
    }
    var history = {
        length: entries.length,
        action: "POP",
        location: entries[index],
        index: index,
        entries: entries,
        createHref: createHref,
        push: push,
        replace: replace,
        go: go,
        goBack: goBack,
        goForward: goForward,
        canGo: canGo,
        block: block,
        listen: listen
    };
    return history;
}

},{"@babel/runtime/helpers/esm/extends":"fW5l8","resolve-pathname":"0395z","value-equal":"1MFfb","tiny-warning":"328jC","tiny-invariant":"dPEnp","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"0395z":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function isAbsolute(pathname) {
    return pathname.charAt(0) === "/";
}
// About 1.5x faster than the two-arg version of Array#splice()
function spliceOne(list, index) {
    for(var i = index, k = i + 1, n = list.length; k < n; i += 1, k += 1)list[i] = list[k];
    list.pop();
}
// This implementation is based heavily on node's url.parse
function resolvePathname(to, from) {
    if (from === undefined) from = "";
    var toParts = to && to.split("/") || [];
    var fromParts = from && from.split("/") || [];
    var isToAbs = to && isAbsolute(to);
    var isFromAbs = from && isAbsolute(from);
    var mustEndAbs = isToAbs || isFromAbs;
    if (to && isAbsolute(to)) // to is absolute
    fromParts = toParts;
    else if (toParts.length) {
        // to is relative, drop the filename
        fromParts.pop();
        fromParts = fromParts.concat(toParts);
    }
    if (!fromParts.length) return "/";
    var hasTrailingSlash;
    if (fromParts.length) {
        var last = fromParts[fromParts.length - 1];
        hasTrailingSlash = last === "." || last === ".." || last === "";
    } else hasTrailingSlash = false;
    var up = 0;
    for(var i = fromParts.length; i >= 0; i--){
        var part = fromParts[i];
        if (part === ".") spliceOne(fromParts, i);
        else if (part === "..") {
            spliceOne(fromParts, i);
            up++;
        } else if (up) {
            spliceOne(fromParts, i);
            up--;
        }
    }
    if (!mustEndAbs) for(; up--; up)fromParts.unshift("..");
    if (mustEndAbs && fromParts[0] !== "" && (!fromParts[0] || !isAbsolute(fromParts[0]))) fromParts.unshift("");
    var result = fromParts.join("/");
    if (hasTrailingSlash && result.substr(-1) !== "/") result += "/";
    return result;
}
exports.default = resolvePathname;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1MFfb":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function valueOf(obj) {
    return obj.valueOf ? obj.valueOf() : Object.prototype.valueOf.call(obj);
}
function valueEqual(a, b) {
    // Test for strict equality first.
    if (a === b) return true;
    // Otherwise, if either of them == null they are not equal.
    if (a == null || b == null) return false;
    if (Array.isArray(a)) return Array.isArray(b) && a.length === b.length && a.every(function(item, index) {
        return valueEqual(item, b[index]);
    });
    if (typeof a === "object" || typeof b === "object") {
        var aValue = valueOf(a);
        var bValue = valueOf(b);
        if (aValue !== a || bValue !== b) return valueEqual(aValue, bValue);
        return Object.keys(Object.assign({}, a, b)).every(function(key) {
            return valueEqual(a[key], b[key]);
        });
    }
    return false;
}
exports.default = valueEqual;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"328jC":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var isProduction = true;
function warning(condition, message) {
    if (!isProduction) {
        if (condition) return;
        var text = "Warning: " + message;
        if (typeof console !== "undefined") console.warn(text);
        try {
            throw Error(text);
        } catch (x) {}
    }
}
exports.default = warning;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"dPEnp":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>invariant);
var isProduction = true;
var prefix = "Invariant failed";
function invariant(condition, message) {
    if (condition) return;
    if (isProduction) throw new Error(prefix);
    var provided = typeof message === "function" ? message() : message;
    var value = provided ? "".concat(prefix, ": ").concat(provided) : prefix;
    throw new Error(value);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"ejAzl":[function(require,module,exports) {
var isarray = require("828472a1e168de2b");
/**
 * Expose `pathToRegexp`.
 */ module.exports = pathToRegexp;
module.exports.parse = parse;
module.exports.compile = compile;
module.exports.tokensToFunction = tokensToFunction;
module.exports.tokensToRegExp = tokensToRegExp;
/**
 * The main path matching regexp utility.
 *
 * @type {RegExp}
 */ var PATH_REGEXP = new RegExp([
    // Match escaped characters that would otherwise appear in future matches.
    // This allows the user to escape special characters that won't transform.
    "(\\\\.)",
    // Match Express-style parameters and un-named parameters with a prefix
    // and optional suffixes. Matches appear as:
    //
    // "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
    // "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
    // "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
    "([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))"
].join("|"), "g");
/**
 * Parse a string for the raw tokens.
 *
 * @param  {string}  str
 * @param  {Object=} options
 * @return {!Array}
 */ function parse(str, options) {
    var tokens = [];
    var key = 0;
    var index = 0;
    var path = "";
    var defaultDelimiter = options && options.delimiter || "/";
    var res;
    while((res = PATH_REGEXP.exec(str)) != null){
        var m = res[0];
        var escaped = res[1];
        var offset = res.index;
        path += str.slice(index, offset);
        index = offset + m.length;
        // Ignore already escaped sequences.
        if (escaped) {
            path += escaped[1];
            continue;
        }
        var next = str[index];
        var prefix = res[2];
        var name = res[3];
        var capture = res[4];
        var group = res[5];
        var modifier = res[6];
        var asterisk = res[7];
        // Push the current path onto the tokens.
        if (path) {
            tokens.push(path);
            path = "";
        }
        var partial = prefix != null && next != null && next !== prefix;
        var repeat = modifier === "+" || modifier === "*";
        var optional = modifier === "?" || modifier === "*";
        var delimiter = res[2] || defaultDelimiter;
        var pattern = capture || group;
        tokens.push({
            name: name || key++,
            prefix: prefix || "",
            delimiter: delimiter,
            optional: optional,
            repeat: repeat,
            partial: partial,
            asterisk: !!asterisk,
            pattern: pattern ? escapeGroup(pattern) : asterisk ? ".*" : "[^" + escapeString(delimiter) + "]+?"
        });
    }
    // Match any characters still remaining.
    if (index < str.length) path += str.substr(index);
    // If the path exists, push it onto the end.
    if (path) tokens.push(path);
    return tokens;
}
/**
 * Compile a string to a template function for the path.
 *
 * @param  {string}             str
 * @param  {Object=}            options
 * @return {!function(Object=, Object=)}
 */ function compile(str, options) {
    return tokensToFunction(parse(str, options), options);
}
/**
 * Prettier encoding of URI path segments.
 *
 * @param  {string}
 * @return {string}
 */ function encodeURIComponentPretty(str) {
    return encodeURI(str).replace(/[\/?#]/g, function(c) {
        return "%" + c.charCodeAt(0).toString(16).toUpperCase();
    });
}
/**
 * Encode the asterisk parameter. Similar to `pretty`, but allows slashes.
 *
 * @param  {string}
 * @return {string}
 */ function encodeAsterisk(str) {
    return encodeURI(str).replace(/[?#]/g, function(c) {
        return "%" + c.charCodeAt(0).toString(16).toUpperCase();
    });
}
/**
 * Expose a method for transforming tokens into the path function.
 */ function tokensToFunction(tokens, options) {
    // Compile all the tokens into regexps.
    var matches = new Array(tokens.length);
    // Compile all the patterns before compilation.
    for(var i = 0; i < tokens.length; i++)if (typeof tokens[i] === "object") matches[i] = new RegExp("^(?:" + tokens[i].pattern + ")$", flags(options));
    return function(obj, opts) {
        var path = "";
        var data = obj || {};
        var options = opts || {};
        var encode = options.pretty ? encodeURIComponentPretty : encodeURIComponent;
        for(var i = 0; i < tokens.length; i++){
            var token = tokens[i];
            if (typeof token === "string") {
                path += token;
                continue;
            }
            var value = data[token.name];
            var segment;
            if (value == null) {
                if (token.optional) {
                    // Prepend partial segment prefixes.
                    if (token.partial) path += token.prefix;
                    continue;
                } else throw new TypeError('Expected "' + token.name + '" to be defined');
            }
            if (isarray(value)) {
                if (!token.repeat) throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + "`");
                if (value.length === 0) {
                    if (token.optional) continue;
                    else throw new TypeError('Expected "' + token.name + '" to not be empty');
                }
                for(var j = 0; j < value.length; j++){
                    segment = encode(value[j]);
                    if (!matches[i].test(segment)) throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + "`");
                    path += (j === 0 ? token.prefix : token.delimiter) + segment;
                }
                continue;
            }
            segment = token.asterisk ? encodeAsterisk(value) : encode(value);
            if (!matches[i].test(segment)) throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"');
            path += token.prefix + segment;
        }
        return path;
    };
}
/**
 * Escape a regular expression string.
 *
 * @param  {string} str
 * @return {string}
 */ function escapeString(str) {
    return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, "\\$1");
}
/**
 * Escape the capturing group by escaping special characters and meaning.
 *
 * @param  {string} group
 * @return {string}
 */ function escapeGroup(group) {
    return group.replace(/([=!:$\/()])/g, "\\$1");
}
/**
 * Attach the keys as a property of the regexp.
 *
 * @param  {!RegExp} re
 * @param  {Array}   keys
 * @return {!RegExp}
 */ function attachKeys(re, keys) {
    re.keys = keys;
    return re;
}
/**
 * Get the flags for a regexp from the options.
 *
 * @param  {Object} options
 * @return {string}
 */ function flags(options) {
    return options && options.sensitive ? "" : "i";
}
/**
 * Pull out keys from a regexp.
 *
 * @param  {!RegExp} path
 * @param  {!Array}  keys
 * @return {!RegExp}
 */ function regexpToRegexp(path, keys) {
    // Use a negative lookahead to match only capturing groups.
    var groups = path.source.match(/\((?!\?)/g);
    if (groups) for(var i = 0; i < groups.length; i++)keys.push({
        name: i,
        prefix: null,
        delimiter: null,
        optional: false,
        repeat: false,
        partial: false,
        asterisk: false,
        pattern: null
    });
    return attachKeys(path, keys);
}
/**
 * Transform an array into a regexp.
 *
 * @param  {!Array}  path
 * @param  {Array}   keys
 * @param  {!Object} options
 * @return {!RegExp}
 */ function arrayToRegexp(path, keys, options) {
    var parts = [];
    for(var i = 0; i < path.length; i++)parts.push(pathToRegexp(path[i], keys, options).source);
    var regexp = new RegExp("(?:" + parts.join("|") + ")", flags(options));
    return attachKeys(regexp, keys);
}
/**
 * Create a path regexp from string input.
 *
 * @param  {string}  path
 * @param  {!Array}  keys
 * @param  {!Object} options
 * @return {!RegExp}
 */ function stringToRegexp(path, keys, options) {
    return tokensToRegExp(parse(path, options), keys, options);
}
/**
 * Expose a function for taking tokens and returning a RegExp.
 *
 * @param  {!Array}          tokens
 * @param  {(Array|Object)=} keys
 * @param  {Object=}         options
 * @return {!RegExp}
 */ function tokensToRegExp(tokens, keys, options) {
    if (!isarray(keys)) {
        options = /** @type {!Object} */ keys || options;
        keys = [];
    }
    options = options || {};
    var strict = options.strict;
    var end = options.end !== false;
    var route = "";
    // Iterate over the tokens and create our regexp string.
    for(var i = 0; i < tokens.length; i++){
        var token = tokens[i];
        if (typeof token === "string") route += escapeString(token);
        else {
            var prefix = escapeString(token.prefix);
            var capture = "(?:" + token.pattern + ")";
            keys.push(token);
            if (token.repeat) capture += "(?:" + prefix + capture + ")*";
            if (token.optional) {
                if (!token.partial) capture = "(?:" + prefix + "(" + capture + "))?";
                else capture = prefix + "(" + capture + ")?";
            } else capture = prefix + "(" + capture + ")";
            route += capture;
        }
    }
    var delimiter = escapeString(options.delimiter || "/");
    var endsWithDelimiter = route.slice(-delimiter.length) === delimiter;
    // In non-strict mode we allow a slash at the end of match. If the path to
    // match already ends with a slash, we remove it for consistency. The slash
    // is valid at the end of a path match, not in the middle. This is important
    // in non-ending mode, where "/test/" shouldn't match "/test//route".
    if (!strict) route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + "(?:" + delimiter + "(?=$))?";
    if (end) route += "$";
    else // In non-ending mode, we need the capturing groups to match as much as
    // possible by using a positive lookahead to the end or next path segment.
    route += strict && endsWithDelimiter ? "" : "(?=" + delimiter + "|$)";
    return attachKeys(new RegExp("^" + route, flags(options)), keys);
}
/**
 * Normalize the given path string, returning a regular expression.
 *
 * An empty array can be passed in for the keys, which will hold the
 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
 *
 * @param  {(string|RegExp|Array)} path
 * @param  {(Array|Object)=}       keys
 * @param  {Object=}               options
 * @return {!RegExp}
 */ function pathToRegexp(path, keys, options) {
    if (!isarray(keys)) {
        options = /** @type {!Object} */ keys || options;
        keys = [];
    }
    options = options || {};
    if (path instanceof RegExp) return regexpToRegexp(path, /** @type {!Array} */ keys);
    if (isarray(path)) return arrayToRegexp(/** @type {!Array} */ path, /** @type {!Array} */ keys, options);
    return stringToRegexp(/** @type {string} */ path, /** @type {!Array} */ keys, options);
}

},{"828472a1e168de2b":"grrgb"}],"grrgb":[function(require,module,exports) {
module.exports = Array.isArray || function(arr) {
    return Object.prototype.toString.call(arr) == "[object Array]";
};

},{}],"5R6Zx":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_objectWithoutPropertiesLoose);
function _objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"h3ugb":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _reactRouterDom = require("react-router-dom");
var _login = require("../../../../shared/scenes/login");
var _loginDefault = parcelHelpers.interopDefault(_login);
var _dashboard = require("../dashboard");
var _dashboardDefault = parcelHelpers.interopDefault(_dashboard);
var _organizationList = require("../../../../shared/scenes/organizationList");
var _organizationListDefault = parcelHelpers.interopDefault(_organizationList);
var _css = require("@emotion/css");
var _acceptInvitation = require("../../../../shared/scenes/acceptInvitation");
var _acceptInvitationDefault = parcelHelpers.interopDefault(_acceptInvitation);
var _forgotPassword = require("../../../../shared/scenes/forgotPassword");
var _forgotPasswordDefault = parcelHelpers.interopDefault(_forgotPassword);
var _resetPassword = require("../../../../shared/scenes/resetPassword");
var _resetPasswordDefault = parcelHelpers.interopDefault(_resetPassword);
var _googleAuth = require("../../../../shared/scenes/googleAuth");
var _googleAuthDefault = parcelHelpers.interopDefault(_googleAuth);
var _amazonAuth = require("../../../../shared/scenes/amazonAuth");
var _amazonAuthDefault = parcelHelpers.interopDefault(_amazonAuth);
var _oAuthRedirect = require("../../../../shared/scenes/oAuthRedirect");
var _oAuthRedirectDefault = parcelHelpers.interopDefault(_oAuthRedirect);
var _microsoftAuth = require("../../../../shared/scenes/microsoftAuth");
var _microsoftAuthDefault = parcelHelpers.interopDefault(_microsoftAuth);
var _cookiesComponent = require("../../../../shared/components/general/CookiesComponent");
var _cookiesComponentDefault = parcelHelpers.interopDefault(_cookiesComponent);
var _singleSignOnLoginRedirect = require("../../../../shared/scenes/singleSignOnRedirect/SingleSignOnLoginRedirect");
var _singleSignOnLoginRedirectDefault = parcelHelpers.interopDefault(_singleSignOnLoginRedirect);
var _singleSignOnSignUpRedirect = require("../../../../shared/scenes/singleSignOnRedirect/SingleSignOnSignUpRedirect");
var _singleSignOnSignUpRedirectDefault = parcelHelpers.interopDefault(_singleSignOnSignUpRedirect);
var _acceptNewInvitation = require("../../../../shared/scenes/acceptInvitation/AcceptNewInvitation");
var _acceptNewInvitationDefault = parcelHelpers.interopDefault(_acceptNewInvitation);
var _newUserLogin = require("../../../../shared/scenes/login/NewUserLogin");
var _newUserLoginDefault = parcelHelpers.interopDefault(_newUserLogin);
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const layoutStyle = /*#__PURE__*/ (0, _css.css)({
    name: "13udsys",
    styles: "height:100%"
});
const Layout = ()=>{
    return (0, _react.jsx)("div", {
        className: layoutStyle
    }, (0, _react.jsx)((0, _reactRouterDom.Route), {
        path: "/login",
        exact: true,
        component: (0, _loginDefault.default)
    }), (0, _react.jsx)((0, _reactRouterDom.Route), {
        path: "/login/:invitationCode",
        exact: true,
        component: (0, _loginDefault.default)
    }), (0, _react.jsx)((0, _reactRouterDom.Route), {
        path: "/createAccount/:invitationCode",
        exact: true,
        component: (0, _newUserLoginDefault.default)
    }), (0, _react.jsx)((0, _reactRouterDom.Route), {
        path: "/orgs",
        exact: true,
        component: (0, _organizationListDefault.default)
    }), (0, _react.jsx)((0, _reactRouterDom.Route), {
        path: "/acceptInvitation/:invitationCode",
        exact: true,
        component: (0, _acceptInvitationDefault.default)
    }), (0, _react.jsx)((0, _reactRouterDom.Route), {
        path: "/acceptNewInvitation/:invitationCode",
        exact: true,
        component: (0, _acceptNewInvitationDefault.default)
    }), (0, _react.jsx)((0, _reactRouterDom.Route), {
        path: "/forgotPassword",
        exact: true,
        component: (0, _forgotPasswordDefault.default)
    }), (0, _react.jsx)((0, _reactRouterDom.Route), {
        path: "/setPassword/:resetToken",
        exact: true,
        component: (0, _resetPasswordDefault.default)
    }), (0, _react.jsx)((0, _reactRouterDom.Route), {
        path: "/googleAuthRedirect",
        component: (0, _googleAuthDefault.default)
    }), (0, _react.jsx)((0, _reactRouterDom.Route), {
        path: "/amazonAuthRedirect",
        component: (0, _amazonAuthDefault.default)
    }), (0, _react.jsx)((0, _reactRouterDom.Route), {
        path: "/microsoftAuthRedirect",
        component: (0, _microsoftAuthDefault.default)
    }), (0, _react.jsx)((0, _reactRouterDom.Route), {
        path: "/oAuthRedirect",
        component: (0, _oAuthRedirectDefault.default)
    }), (0, _react.jsx)((0, _reactRouterDom.Route), {
        path: "/singleSignOnRedirect",
        exact: true,
        component: (0, _singleSignOnLoginRedirectDefault.default)
    }), (0, _react.jsx)((0, _reactRouterDom.Route), {
        path: "/singleSignOnRedirect/:invitationCode",
        exact: true,
        component: (0, _singleSignOnLoginRedirectDefault.default)
    }), (0, _react.jsx)((0, _reactRouterDom.Route), {
        path: "/singleSignOnSignUpRedirect/:invitationCode",
        exact: true,
        component: (0, _singleSignOnSignUpRedirectDefault.default)
    }), (0, _react.jsx)((0, _reactRouterDom.Route), {
        path: "/revenue",
        exact: true,
        component: (0, _dashboardDefault.default)
    }), (0, _react.jsx)((0, _reactRouterDom.Route), {
        path: "/v",
        component: (0, _dashboardDefault.default)
    }), (0, _react.jsx)((0, _reactRouterDom.Route), {
        path: "/",
        exact: true,
        component: (0, _dashboardDefault.default)
    }), (0, _react.jsx)((0, _cookiesComponentDefault.default), null));
};
exports.default = Layout;

},{"@emotion/react":"djZKr","react":"6uln9","react-router-dom":"5fzqq","../../../../shared/scenes/login":"iE26Z","../dashboard":"5IqRY","../../../../shared/scenes/organizationList":"5XCm5","@emotion/css":"awUBr","../../../../shared/scenes/acceptInvitation":"hDPl8","../../../../shared/scenes/forgotPassword":"krCcZ","../../../../shared/scenes/resetPassword":"202ZC","../../../../shared/scenes/googleAuth":"gGzZh","../../../../shared/scenes/amazonAuth":"7mvfI","../../../../shared/scenes/oAuthRedirect":"9tVt4","../../../../shared/scenes/microsoftAuth":"b4Ylx","../../../../shared/components/general/CookiesComponent":"1nNyj","../../../../shared/scenes/singleSignOnRedirect/SingleSignOnLoginRedirect":"7qtwU","../../../../shared/scenes/singleSignOnRedirect/SingleSignOnSignUpRedirect":"3ttMK","../../../../shared/scenes/acceptInvitation/AcceptNewInvitation":"8TU93","../../../../shared/scenes/login/NewUserLogin":"4ljqB","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"iE26Z":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _unstated = require("unstated");
var _authContainer = require("../../state/containers/AuthContainer");
var _authContainerDefault = parcelHelpers.interopDefault(_authContainer);
var _loginForm = require("./components/LoginForm");
var _loginFormDefault = parcelHelpers.interopDefault(_loginForm);
var _reactRouter = require("react-router");
var _frontTabbedLayout = require("../../components/structure/FrontTabbedLayout");
var _frontTabbedLayoutDefault = parcelHelpers.interopDefault(_frontTabbedLayout);
var _reactTabs = require("react-tabs");
var _tabPanelBody = require("../../components/structure/TabPanelBody");
var _tabPanelBodyDefault = parcelHelpers.interopDefault(_tabPanelBody);
var _registerForm = require("./components/RegisterForm");
var _registerFormDefault = parcelHelpers.interopDefault(_registerForm);
var _userContainer = require("../../state/containers/UserContainer");
var _userContainerDefault = parcelHelpers.interopDefault(_userContainer);
var _landingContainer = require("../../components/structure/LandingContainer");
var _landingContainerDefault = parcelHelpers.interopDefault(_landingContainer);
var _singleSignOnForm = require("./components/SingleSignOnForm");
var _singleSignOnFormDefault = parcelHelpers.interopDefault(_singleSignOnForm);
var _createPasswordForm = require("./components/CreatePasswordForm");
var _createPasswordFormDefault = parcelHelpers.interopDefault(_createPasswordForm);
const Login = (props)=>{
    const query = new URLSearchParams(window.location.search);
    const { email, firstName, lastName, app: applicationId } = Object.fromEntries(query);
    if (applicationId) sessionStorage.setItem("invite_target_application_id", applicationId);
    const isFirstTime = window.location.pathname.includes("firstTime");
    return (0, _react.jsx)((0, _landingContainerDefault.default), null, (0, _react.jsx)((0, _unstated.Subscribe), {
        to: [
            (0, _authContainerDefault.default),
            (0, _userContainerDefault.default)
        ]
    }, (authContainer, userContainer)=>{
        // if we are logged in, go to root
        if (authContainer.state.isAuthenticated === true) return (0, _react.jsx)((0, _reactRouter.Redirect), {
            to: "/v"
        });
        let enteringPassword = userContainer.state.userRegistrationInformation.enteringPassword;
        if (email && firstName && lastName && sessionStorage.getItem("invite_target_application_id") && isFirstTime) enteringPassword = true;
        return (0, _react.jsx)((0, _frontTabbedLayoutDefault.default), {
            tabs: [
                "Login",
                "Login with SSO",
                "First time here?"
            ],
            selectedTabIndex: isFirstTime ? 2 : undefined
        }, (0, _react.jsx)((0, _reactTabs.TabPanel), null, (0, _react.jsx)((0, _tabPanelBodyDefault.default), null, (0, _react.jsx)((0, _loginFormDefault.default), {
            stateContainer: authContainer,
            userContainer: userContainer,
            invitationCode: props.match.params.invitationCode,
            email: email
        }))), (0, _react.jsx)((0, _reactTabs.TabPanel), null, (0, _react.jsx)((0, _tabPanelBodyDefault.default), null, (0, _react.jsx)((0, _singleSignOnFormDefault.default), {
            stateContainer: authContainer,
            userContainer: userContainer,
            invitationCode: props.match.params.invitationCode
        }))), (0, _react.jsx)((0, _reactTabs.TabPanel), null, (0, _react.jsx)((0, _tabPanelBodyDefault.default), null, enteringPassword ? (0, _react.jsx)((0, _createPasswordFormDefault.default), {
            stateContainer: userContainer,
            authContainer: authContainer,
            invitationCode: props.match.params.invitationCode,
            email: email,
            firstName: firstName,
            lastName: lastName
        }) : (0, _react.jsx)((0, _registerFormDefault.default), {
            stateContainer: userContainer,
            authContainer: authContainer,
            invitationCode: props.match.params.invitationCode
        }))));
    }));
};
exports.default = Login;

},{"@emotion/react":"djZKr","react":"6uln9","unstated":"grh7p","../../state/containers/AuthContainer":"cl1Qb","./components/LoginForm":"5DDKU","react-router":"i3TiW","../../components/structure/FrontTabbedLayout":"81aMg","react-tabs":"92Sgf","../../components/structure/TabPanelBody":"ePx7g","./components/RegisterForm":"7vD5Q","../../state/containers/UserContainer":"jDrDR","../../components/structure/LandingContainer":"l7sWG","./components/SingleSignOnForm":"1cD0x","./components/CreatePasswordForm":"kSoKM","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"grh7p":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Container", ()=>Container);
parcelHelpers.export(exports, "Subscribe", ()=>Subscribe);
parcelHelpers.export(exports, "Provider", ()=>Provider);
parcelHelpers.export(exports, "__SUPER_SECRET_CONTAINER_DEBUG_HOOK__", ()=>__SUPER_SECRET_CONTAINER_DEBUG_HOOK__);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _createReactContext = require("create-react-context");
var _createReactContextDefault = parcelHelpers.interopDefault(_createReactContext);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
    return typeof obj;
} : function(obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};
function _possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
var StateContext = (0, _createReactContextDefault.default)(null);
var Container = function() {
    function Container() {
        var _this = this;
        _classCallCheck(this, Container);
        this._listeners = [];
        CONTAINER_DEBUG_CALLBACKS.forEach(function(cb) {
            return cb(_this);
        });
    }
    Container.prototype.setState = function setState(updater, callback) {
        var _this2 = this;
        return Promise.resolve().then(function() {
            var nextState = void 0;
            if (typeof updater === "function") nextState = updater(_this2.state);
            else nextState = updater;
            if (nextState == null) {
                if (callback) callback();
                return;
            }
            _this2.state = Object.assign({}, _this2.state, nextState);
            var promises = _this2._listeners.map(function(listener) {
                return listener();
            });
            return Promise.all(promises).then(function() {
                if (callback) return callback();
            });
        });
    };
    Container.prototype.subscribe = function subscribe(fn) {
        this._listeners.push(fn);
    };
    Container.prototype.unsubscribe = function unsubscribe(fn) {
        this._listeners = this._listeners.filter(function(f) {
            return f !== fn;
        });
    };
    return Container;
}();
var DUMMY_STATE = {};
var Subscribe = function(_React$Component) {
    _inherits(Subscribe, _React$Component);
    function Subscribe() {
        var _temp, _this3, _ret;
        _classCallCheck(this, Subscribe);
        for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return _ret = (_temp = (_this3 = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [
            this
        ].concat(args))), _this3), _this3.state = {}, _this3.instances = [], _this3.unmounted = false, _this3.onUpdate = function() {
            return new Promise(function(resolve) {
                if (!_this3.unmounted) _this3.setState(DUMMY_STATE, resolve);
                else resolve();
            });
        }, _temp), _possibleConstructorReturn(_this3, _ret);
    }
    Subscribe.prototype.componentWillUnmount = function componentWillUnmount() {
        this.unmounted = true;
        this._unsubscribe();
    };
    Subscribe.prototype._unsubscribe = function _unsubscribe() {
        var _this4 = this;
        this.instances.forEach(function(container) {
            container.unsubscribe(_this4.onUpdate);
        });
    };
    Subscribe.prototype._createInstances = function _createInstances(map, containers) {
        var _this5 = this;
        this._unsubscribe();
        if (map === null) throw new Error("You must wrap your <Subscribe> components with a <Provider>");
        var safeMap = map;
        var instances = containers.map(function(ContainerItem) {
            var instance = void 0;
            if ((typeof ContainerItem === "undefined" ? "undefined" : _typeof(ContainerItem)) === "object" && ContainerItem instanceof Container) instance = ContainerItem;
            else {
                instance = safeMap.get(ContainerItem);
                if (!instance) {
                    instance = new ContainerItem();
                    safeMap.set(ContainerItem, instance);
                }
            }
            instance.unsubscribe(_this5.onUpdate);
            instance.subscribe(_this5.onUpdate);
            return instance;
        });
        this.instances = instances;
        return instances;
    };
    Subscribe.prototype.render = function render() {
        var _this6 = this;
        return (0, _reactDefault.default).createElement(StateContext.Consumer, null, function(map) {
            return _this6.props.children.apply(null, _this6._createInstances(map, _this6.props.to));
        });
    };
    return Subscribe;
}((0, _reactDefault.default).Component);
function Provider(props) {
    return (0, _reactDefault.default).createElement(StateContext.Consumer, null, function(parentMap) {
        var childMap = new Map(parentMap);
        if (props.inject) props.inject.forEach(function(instance) {
            childMap.set(instance.constructor, instance);
        });
        return (0, _reactDefault.default).createElement(StateContext.Provider, {
            value: childMap
        }, props.children);
    });
}
var CONTAINER_DEBUG_CALLBACKS = [];
// If your name isn't Sindre, this is not for you.
// I might ruin your day suddenly if you depend on this without talking to me.
function __SUPER_SECRET_CONTAINER_DEBUG_HOOK__(callback) {
    CONTAINER_DEBUG_CALLBACKS.push(callback);
}

},{"react":"6uln9","create-react-context":"i0Ge2","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"i0Ge2":[function(require,module,exports) {
"use strict";
exports.__esModule = true;
var _react = require("447bc02bf1f2efb1");
var _react2 = _interopRequireDefault(_react);
var _propTypes = require("37fbd298c0889c39");
var _propTypes2 = _interopRequireDefault(_propTypes);
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
function createEventEmitter(value) {
    var handlers = [];
    return {
        on: function on(handler) {
            handlers.push(handler);
        },
        off: function off(handler) {
            handlers = handlers.filter(function(h) {
                return h !== handler;
            });
        },
        get: function get() {
            return value;
        },
        set: function set(newValue) {
            value = newValue;
            handlers.forEach(function(handler) {
                return handler(value);
            });
        }
    };
}
function onlyChild(children) {
    return Array.isArray(children) ? children[0] : children;
}
var uniqueId = 0;
function createReactContext(defaultValue) {
    var _Provider$childContex, _Consumer$contextType;
    var contextProp = "__create-react-context-" + uniqueId++ + "__";
    var Provider = function(_Component) {
        _inherits(Provider, _Component);
        function Provider() {
            var _temp, _this, _ret;
            _classCallCheck(this, Provider);
            for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [
                this
            ].concat(args))), _this), _this.emitter = createEventEmitter(_this.props.value), _temp), _possibleConstructorReturn(_this, _ret);
        }
        Provider.prototype.getChildContext = function getChildContext() {
            var _ref;
            return _ref = {}, _ref[contextProp] = this.emitter, _ref;
        };
        Provider.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
            if (this.props.value !== nextProps.value) this.emitter.set(nextProps.value);
        };
        Provider.prototype.render = function render() {
            return this.props.children;
        };
        return Provider;
    }(_react.Component);
    Provider.childContextTypes = (_Provider$childContex = {}, _Provider$childContex[contextProp] = _propTypes2.default.object.isRequired, _Provider$childContex);
    var Consumer = function(_Component2) {
        _inherits(Consumer, _Component2);
        function Consumer() {
            var _temp2, _this2, _ret2;
            _classCallCheck(this, Consumer);
            for(var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
            return _ret2 = (_temp2 = (_this2 = _possibleConstructorReturn(this, _Component2.call.apply(_Component2, [
                this
            ].concat(args))), _this2), _this2.state = {
                value: _this2.getValue()
            }, _this2.onUpdate = function() {
                _this2.setState({
                    value: _this2.getValue()
                });
            }, _temp2), _possibleConstructorReturn(_this2, _ret2);
        }
        Consumer.prototype.componentDidMount = function componentDidMount() {
            if (this.context[contextProp]) this.context[contextProp].on(this.onUpdate);
        };
        Consumer.prototype.componentWillUnmount = function componentWillUnmount() {
            if (this.context[contextProp]) this.context[contextProp].off(this.onUpdate);
        };
        Consumer.prototype.getValue = function getValue() {
            if (this.context[contextProp]) return this.context[contextProp].get();
            else return defaultValue;
        };
        Consumer.prototype.render = function render() {
            return onlyChild(this.props.children)(this.state.value);
        };
        return Consumer;
    }(_react.Component);
    Consumer.contextTypes = (_Consumer$contextType = {}, _Consumer$contextType[contextProp] = _propTypes2.default.object, _Consumer$contextType);
    return {
        Provider: Provider,
        Consumer: Consumer
    };
}
exports.default = createReactContext;
module.exports = exports["default"];

},{"447bc02bf1f2efb1":"6uln9","37fbd298c0889c39":"6FKs7"}],"cl1Qb":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _defineProperty = require("@babel/runtime/helpers/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _unstated = require("unstated");
var _api = require("../../api");
var _keys = require("../../constants/Keys");
class AuthContainer extends (0, _unstated.Container) {
    constructor(){
        super();
        // If we have a refresh token on initialization, start the refresh timer
        (0, _definePropertyDefault.default)(this, "state", this.getInitialState());
        if (this.state.isAuthenticated && this.state.refreshToken) this.setRefreshTimer();
    }
    getInitialState() {
        // check local storage for initial state
        localStorage.removeItem((0, _keys.VOICIFY_ACCESS_TOKEN_STORE)); // remove any history of storing access in local storage
        const storedAccessToken = sessionStorage.getItem((0, _keys.VOICIFY_ACCESS_TOKEN_STORE));
        const storedRefreshToken = localStorage.getItem((0, _keys.VOICIFY_REFRESH_TOKEN_STORE));
        const storedExpiration = localStorage.getItem((0, _keys.VOICIFY_ACCESS_EXPIRATION));
        const storedRefreshExpiration = localStorage.getItem((0, _keys.VOICIFY_REFRESH_EXPIRATION));
        if (storedRefreshToken !== null && storedRefreshToken?.length) return {
            isAuthenticated: true,
            accessToken: storedAccessToken,
            refreshToken: storedRefreshToken,
            expirationDate: new Date(storedExpiration),
            refreshTokenExpirationDate: new Date(storedRefreshExpiration),
            errors: [],
            isLoading: false,
            apiKeyAuth: false
        };
        return {
            isAuthenticated: false,
            accessToken: "",
            refreshToken: "",
            errors: [],
            expirationDate: null,
            refreshTokenExpirationDate: null,
            isLoading: false,
            apiKeyAuth: false
        };
    }
    beginSingleSignOnSignIn(ssoRequest) {
        this.setState({
            ...this.state,
            isLoading: true
        });
        return this.beginSingleSignOn(_api.beginSingleSignOnSignIn(ssoRequest));
    }
    beginSingleSignOnSignUp(ssoRequest) {
        this.setState({
            ...this.state,
            isLoading: true
        });
        return this.beginSingleSignOn(_api.beginSingleSignOnSignUp(ssoRequest));
    }
    beginSingleSignOn(promise) {
        promise.then((ssoResult)=>{
            if (ssoResult.resultType == "Ok") window.location.href = ssoResult.data.redirectUrl;
            else this.setState({
                ...this.state,
                errors: ssoResult.errors,
                isLoading: false
            });
        }).catch((error)=>{
            this.setState({
                ...this.state,
                errors: [
                    ...error
                ],
                isLoading: false
            });
        });
        return promise;
    }
    updateLocalStorageAuth(email, authResult) {
        sessionStorage.setItem((0, _keys.VOICIFY_ACCESS_TOKEN_STORE), authResult.accessToken);
        localStorage.setItem((0, _keys.VOICIFY_REFRESH_TOKEN_STORE), authResult.refreshToken);
        localStorage.setItem((0, _keys.VOICIFY_EMAIL_STORE), email);
        localStorage.setItem((0, _keys.VOICIFY_ACCESS_EXPIRATION), authResult.accessTokenExpirationDate);
        localStorage.setItem((0, _keys.VOICIFY_REFRESH_EXPIRATION), authResult.refreshTokenExpirationDate);
        this.setRefreshTimer();
    }
    updateAuthWithAPIKey(apiKey) {
        sessionStorage.setItem((0, _keys.VOICIFY_API_KEY), apiKey);
        sessionStorage.setItem((0, _keys.VOICIFY_ACCESS_TOKEN_STORE), "");
        localStorage.setItem((0, _keys.VOICIFY_REFRESH_TOKEN_STORE), "");
        localStorage.setItem((0, _keys.VOICIFY_EMAIL_STORE), "");
        localStorage.setItem((0, _keys.VOICIFY_ACCESS_EXPIRATION), "");
        this.setState({
            ...this.state,
            isAuthenticated: true,
            apiKeyAuth: true
        });
    }
    signInWithSingleSignOn(email, refreshToken) {
        this.setState({
            ...this.state,
            isLoading: true
        });
        var promise = _api.refreshToken({
            email,
            refreshToken
        });
        promise.then((authResult)=>{
            if (authResult.resultType == "Ok") {
                this.setState({
                    ...this.state,
                    isAuthenticated: true,
                    accessToken: authResult.data.accessToken,
                    refreshToken: authResult.data.refreshToken,
                    expirationDate: new Date(authResult.data.accessTokenExpirationDate),
                    refreshTokenExpirationDate: new Date(authResult.data.refreshTokenExpirationDate),
                    errors: [],
                    isLoading: false
                });
                this.updateLocalStorageAuth(email, authResult.data);
            } else {
                this.setState({
                    ...this.state,
                    errors: authResult.errors,
                    isLoading: false
                });
                this.signOut();
                window.location.href = `${window.location.origin.toString()}/login`;
            }
        }).catch((error)=>{
            this.setState({
                ...this.state,
                errors: [
                    ...error
                ],
                isLoading: false
            });
        });
        return promise;
    }
    addError(error) {
        this.setState({
            ...this.state,
            errors: [
                ...this.state.errors,
                error
            ]
        });
    }
    clearErrors() {
        this.setState({
            ...this.state,
            errors: []
        });
    }
    signIn(email, password) {
        this.setState({
            ...this.state,
            isLoading: true
        });
        var promise = _api.signIn({
            email,
            password
        });
        promise.then((authResult)=>{
            if (authResult.resultType == "Ok") {
                this.setState({
                    ...this.state,
                    isAuthenticated: true,
                    accessToken: authResult.data.accessToken,
                    refreshToken: authResult.data.refreshToken,
                    expirationDate: new Date(authResult.data.accessTokenExpirationDate),
                    refreshTokenExpirationDate: new Date(authResult.data.refreshTokenExpirationDate),
                    errors: [],
                    isLoading: false
                });
                this.updateLocalStorageAuth(email, authResult.data);
            } else this.setState({
                ...this.state,
                errors: authResult.errors,
                isLoading: false
            });
        }).catch((error)=>{
            this.setState({
                ...this.state,
                errors: [
                    ...error
                ],
                isLoading: false
            });
        });
        return promise;
    }
    checkRefreshTokenExpiry() {
        // Always read from localStorage to get the latest token expiration
        // This ensures we don't use stale state if another tab refreshed the token
        const storedRefreshExpiration = localStorage.getItem((0, _keys.VOICIFY_REFRESH_EXPIRATION));
        if (!storedRefreshExpiration) return;
        const refreshExpiration = new Date(storedRefreshExpiration);
        const now = new Date();
        const timeUntilExpiry = refreshExpiration.getTime() - now.getTime();
        const thirtyMinutesInMs = 1800000;
        if (timeUntilExpiry <= 0) {
            // Refresh token is expired, logout
            this.signOut();
            window.location.href = `${window.location.origin.toString()}/login`;
        } else if (timeUntilExpiry <= thirtyMinutesInMs) // Within 30 minutes of expiry, try to refresh
        this.refreshToken();
        else {
            // Also check if the access token is expired or about to expire
            const storedAccessExpiration = localStorage.getItem((0, _keys.VOICIFY_ACCESS_EXPIRATION));
            if (storedAccessExpiration) {
                const accessExpiration = new Date(storedAccessExpiration);
                const fiveMinutesInMs = 300000;
                const timeUntilAccessExpiry = accessExpiration.getTime() - now.getTime();
                if (timeUntilAccessExpiry <= fiveMinutesInMs) // Access token expired or about to expire, refresh it
                this.refreshToken();
            }
        }
    }
    setRefreshTimer() {
        clearInterval(this.timerTaskId);
        this.checkRefreshTokenExpiry();
        // Check every 5 minutes 
        this.timerTaskId = setInterval(this.checkRefreshTokenExpiry.bind(this), 300000);
    }
    removeRefreshTimer() {
        clearInterval(this.timerTaskId);
    }
    cleanup() {
        // Clean up event listeners when container is destroyed
        this.removeRefreshTimer();
        if (this.storageListener) window.removeEventListener("storage", this.storageListener);
    }
    refreshToken() {
        var email = localStorage.getItem((0, _keys.VOICIFY_EMAIL_STORE));
        var refreshToken = localStorage.getItem((0, _keys.VOICIFY_REFRESH_TOKEN_STORE));
        if (refreshToken?.length) {
            this.setState({
                ...this.state,
                isLoading: true
            });
            var promise = _api.refreshToken({
                email,
                refreshToken
            });
            promise.then((authResult)=>{
                if (authResult.resultType == "Ok") {
                    this.setState({
                        ...this.state,
                        isAuthenticated: true,
                        accessToken: authResult.data.accessToken,
                        refreshToken: authResult.data.refreshToken,
                        expirationDate: new Date(authResult.data.accessTokenExpirationDate),
                        refreshTokenExpirationDate: new Date(authResult.data.refreshTokenExpirationDate),
                        errors: [],
                        isLoading: false
                    });
                    this.updateLocalStorageAuth(email, authResult.data);
                } else {
                    this.setState({
                        ...this.state,
                        errors: authResult.errors,
                        isLoading: false
                    });
                    this.signOut();
                    window.location.href = `${window.location.origin.toString()}/login`;
                }
            }).catch((error)=>{
                this.setState({
                    ...this.state,
                    errors: [
                        ...error
                    ],
                    isLoading: false
                });
            });
            return promise;
        }
    }
    signOut() {
        localStorage.clear();
        this.setState({
            ...this.state,
            isAuthenticated: false,
            accessToken: "",
            refreshToken: "",
            errors: []
        });
    }
}
exports.default = AuthContainer;

},{"@babel/runtime/helpers/defineProperty":"9sJxO","unstated":"grh7p","../../api":"loxM6","../../constants/Keys":"4iC9Z","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9sJxO":[function(require,module,exports) {
var toPropertyKey = require("29ac19868e7f119");
function _defineProperty(e, r, t) {
    return (r = toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
module.exports = _defineProperty, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{"29ac19868e7f119":"btEvn"}],"btEvn":[function(require,module,exports) {
var _typeof = require("a14bd529aa4ac1cd")["default"];
var toPrimitive = require("2713647ce51d8c75");
function toPropertyKey(t) {
    var i = toPrimitive(t, "string");
    return "symbol" == _typeof(i) ? i : i + "";
}
module.exports = toPropertyKey, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{"a14bd529aa4ac1cd":"lM7hb","2713647ce51d8c75":"QjLRy"}],"lM7hb":[function(require,module,exports) {
function _typeof(o) {
    "@babel/helpers - typeof";
    return module.exports = _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, _typeof(o);
}
module.exports = _typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{}],"QjLRy":[function(require,module,exports) {
var _typeof = require("e0211298897b2d31")["default"];
function toPrimitive(t, r) {
    if ("object" != _typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != _typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
module.exports = toPrimitive, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{"e0211298897b2d31":"lM7hb"}],"loxM6":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _authentication = require("./controllers/authentication");
parcelHelpers.exportAll(_authentication, exports);
var _organizations = require("./controllers/organizations");
parcelHelpers.exportAll(_organizations, exports);
var _applications = require("./controllers/applications");
parcelHelpers.exportAll(_applications, exports);
var _features = require("./controllers/features");
parcelHelpers.exportAll(_features, exports);
var _welcomeMessages = require("./controllers/welcomeMessages");
parcelHelpers.exportAll(_welcomeMessages, exports);
var _exitMessages = require("./controllers/exitMessages");
parcelHelpers.exportAll(_exitMessages, exports);
var _helpMessages = require("./controllers/helpMessages");
parcelHelpers.exportAll(_helpMessages, exports);
var _questionAnswers = require("./controllers/questionAnswers");
parcelHelpers.exportAll(_questionAnswers, exports);
var _modules = require("./controllers/modules");
parcelHelpers.exportAll(_modules, exports);
var _latestMessages = require("./controllers/latestMessages");
parcelHelpers.exportAll(_latestMessages, exports);
var _invitations = require("./controllers/invitations");
parcelHelpers.exportAll(_invitations, exports);
var _users = require("./controllers/users");
parcelHelpers.exportAll(_users, exports);
var _mediaItems = require("./controllers/mediaItems");
parcelHelpers.exportAll(_mediaItems, exports);
var _contentAnalytics = require("./controllers/contentAnalytics");
parcelHelpers.exportAll(_contentAnalytics, exports);
var _applicationAnalytics = require("./controllers/applicationAnalytics");
parcelHelpers.exportAll(_applicationAnalytics, exports);
var _webhooks = require("./controllers/webhooks");
parcelHelpers.exportAll(_webhooks, exports);
var _fallbackMessages = require("./controllers/fallbackMessages");
parcelHelpers.exportAll(_fallbackMessages, exports);
var _followUps = require("./controllers/followUps");
parcelHelpers.exportAll(_followUps, exports);
var _reprompts = require("./controllers/reprompts");
parcelHelpers.exportAll(_reprompts, exports);
var _mediaResponses = require("./controllers/mediaResponses");
parcelHelpers.exportAll(_mediaResponses, exports);
var _alexaSkill = require("./controllers/alexaSkill");
parcelHelpers.exportAll(_alexaSkill, exports);
var _dialogflowAgent = require("./controllers/dialogflowAgent");
parcelHelpers.exportAll(_dialogflowAgent, exports);
var _amazonAuthorization = require("./controllers/amazonAuthorization");
parcelHelpers.exportAll(_amazonAuthorization, exports);
var _microsoftAuthorization = require("./controllers/microsoftAuthorization");
parcelHelpers.exportAll(_microsoftAuthorization, exports);
var _googleAuthorization = require("./controllers/googleAuthorization");
parcelHelpers.exportAll(_googleAuthorization, exports);
var _interactionModel = require("./controllers/interactionModel");
parcelHelpers.exportAll(_interactionModel, exports);
var _integrations = require("./controllers/integrations");
parcelHelpers.exportAll(_integrations, exports);
var _deviceTarget = require("./controllers/deviceTarget");
parcelHelpers.exportAll(_deviceTarget, exports);
var _ssml = require("./controllers/ssml");
parcelHelpers.exportAll(_ssml, exports);
var _numberRange = require("./controllers/numberRange");
parcelHelpers.exportAll(_numberRange, exports);
var _simpleChoice = require("./controllers/simpleChoice");
parcelHelpers.exportAll(_simpleChoice, exports);
var _azureApplication = require("./controllers/azureApplication");
parcelHelpers.exportAll(_azureApplication, exports);
var _integrationSetup = require("./controllers/integrationSetup");
parcelHelpers.exportAll(_integrationSetup, exports);
var _terms = require("./controllers/terms");
parcelHelpers.exportAll(_terms, exports);
var _customRequests = require("./controllers/customRequests");
parcelHelpers.exportAll(_customRequests, exports);
var _customAssistant = require("./controllers/customAssistant");
parcelHelpers.exportAll(_customAssistant, exports);
var _contentLanguages = require("./controllers/contentLanguages");
parcelHelpers.exportAll(_contentLanguages, exports);
var _bulkContent = require("./controllers/bulkContent");
parcelHelpers.exportAll(_bulkContent, exports);
var _notifications = require("./controllers/notifications");
parcelHelpers.exportAll(_notifications, exports);
var _importExport = require("./controllers/importExport");
parcelHelpers.exportAll(_importExport, exports);
var _userProfile = require("./controllers/userProfile");
parcelHelpers.exportAll(_userProfile, exports);
var _templateConfigurations = require("./controllers/templateConfigurations");
parcelHelpers.exportAll(_templateConfigurations, exports);
var _appliedApplicationTemplates = require("./controllers/appliedApplicationTemplates");
parcelHelpers.exportAll(_appliedApplicationTemplates, exports);
var _applicationTemplating = require("./controllers/applicationTemplating");
parcelHelpers.exportAll(_applicationTemplating, exports);
var _userApplicationPreferences = require("./controllers/userApplicationPreferences");
parcelHelpers.exportAll(_userApplicationPreferences, exports);
var _conversationTracking = require("./controllers/conversationTracking");
parcelHelpers.exportAll(_conversationTracking, exports);
var _subscriptions = require("./controllers/subscriptions");
parcelHelpers.exportAll(_subscriptions, exports);
var _webhookFolders = require("./controllers/webhookFolders");
parcelHelpers.exportAll(_webhookFolders, exports);
var _apiKey = require("./controllers/apiKey");
parcelHelpers.exportAll(_apiKey, exports);
var _conditions = require("./controllers/conditions");
parcelHelpers.exportAll(_conditions, exports);
var _appliedTemplateSync = require("./controllers/appliedTemplateSync");
parcelHelpers.exportAll(_appliedTemplateSync, exports);
var _applicationFlags = require("./controllers/applicationFlags");
parcelHelpers.exportAll(_applicationFlags, exports);
var _archive = require("./controllers/archive");
parcelHelpers.exportAll(_archive, exports);
var _applicationEnvironment = require("./controllers/applicationEnvironment");
parcelHelpers.exportAll(_applicationEnvironment, exports);
var _applicationBackupVersion = require("./controllers/applicationBackupVersion");
parcelHelpers.exportAll(_applicationBackupVersion, exports);
var _environments = require("./controllers/environments");
parcelHelpers.exportAll(_environments, exports);
var _customAssistantConfiguration = require("./controllers/customAssistantConfiguration");
parcelHelpers.exportAll(_customAssistantConfiguration, exports);
var _applicationNlpEntity = require("./controllers/applicationNlpEntity");
parcelHelpers.exportAll(_applicationNlpEntity, exports);
var _voicifyMenuItems = require("./controllers/voicifyMenuItems");
parcelHelpers.exportAll(_voicifyMenuItems, exports);
var _telephonyDeployment = require("./controllers/telephonyDeployment");
parcelHelpers.exportAll(_telephonyDeployment, exports);
var _nlp = require("./controllers/nlp");
parcelHelpers.exportAll(_nlp, exports);
var _callRecordings = require("./controllers/callRecordings");
parcelHelpers.exportAll(_callRecordings, exports);
var _orgSetup = require("./controllers/orgSetup");
parcelHelpers.exportAll(_orgSetup, exports);
var _orgAnalytics = require("./controllers/orgAnalytics");
parcelHelpers.exportAll(_orgAnalytics, exports);
var _analyticsOrderState = require("./controllers/analyticsOrderState");
parcelHelpers.exportAll(_analyticsOrderState, exports);
var _engagementAnalyticsReporting = require("./controllers/engagementAnalyticsReporting");
parcelHelpers.exportAll(_engagementAnalyticsReporting, exports);
var _testCases = require("./controllers/testCases");
parcelHelpers.exportAll(_testCases, exports);
var _responses = require("./controllers/responses");
parcelHelpers.exportAll(_responses, exports);
var _applicationVariables = require("./controllers/applicationVariables");
parcelHelpers.exportAll(_applicationVariables, exports);
var _organizationVariables = require("./controllers/organizationVariables");
parcelHelpers.exportAll(_organizationVariables, exports);
var _medicalIntegrationConfiguration = require("./controllers/medicalIntegrationConfiguration");
parcelHelpers.exportAll(_medicalIntegrationConfiguration, exports);
var _revenueConfig = require("./controllers/revenueConfig");
parcelHelpers.exportAll(_revenueConfig, exports);

},{"./controllers/authentication":"dACq8","./controllers/organizations":"2aFbO","./controllers/applications":"1me18","./controllers/features":"kcXcW","./controllers/welcomeMessages":"6YWT2","./controllers/exitMessages":"bmhKU","./controllers/helpMessages":"3TIoF","./controllers/questionAnswers":"lYc3g","./controllers/modules":"e19Ul","./controllers/latestMessages":"3Av1r","./controllers/invitations":"kG7ZZ","./controllers/users":"1HhkM","./controllers/mediaItems":"XaqA6","./controllers/contentAnalytics":"bzTar","./controllers/applicationAnalytics":"kCQLR","./controllers/webhooks":"d3hYM","./controllers/fallbackMessages":"6D1gU","./controllers/followUps":"7MlqD","./controllers/reprompts":"b6Ie6","./controllers/mediaResponses":"3brAk","./controllers/alexaSkill":"jwyoo","./controllers/dialogflowAgent":"4wZlK","./controllers/amazonAuthorization":"86UFi","./controllers/microsoftAuthorization":"l7EsL","./controllers/googleAuthorization":"iV0if","./controllers/interactionModel":"e7vis","./controllers/integrations":"awLb3","./controllers/deviceTarget":"2NeNi","./controllers/ssml":"cOA3L","./controllers/numberRange":"7ukim","./controllers/simpleChoice":"ksHgK","./controllers/azureApplication":"cUnTL","./controllers/integrationSetup":"lt5ki","./controllers/terms":"b2naN","./controllers/customRequests":"1yMkz","./controllers/customAssistant":"lPl0O","./controllers/contentLanguages":"f5YJE","./controllers/bulkContent":"6RDXX","./controllers/notifications":"3d3Hg","./controllers/importExport":"dB0jz","./controllers/userProfile":"f85QB","./controllers/templateConfigurations":"3uWdd","./controllers/appliedApplicationTemplates":"66oOj","./controllers/applicationTemplating":"lVRFt","./controllers/userApplicationPreferences":"3pvyQ","./controllers/conversationTracking":"2XUkz","./controllers/subscriptions":"k92ch","./controllers/webhookFolders":"ixGyD","./controllers/apiKey":"leENw","./controllers/conditions":"iv4U3","./controllers/appliedTemplateSync":"i7FBj","./controllers/applicationFlags":"dxnKp","./controllers/archive":"7J0KR","./controllers/applicationEnvironment":"ifZqw","./controllers/applicationBackupVersion":"elCSm","./controllers/environments":"9KuKj","./controllers/customAssistantConfiguration":"8wFOX","./controllers/applicationNlpEntity":"bYAAd","./controllers/voicifyMenuItems":"e7R0I","./controllers/telephonyDeployment":"hKhC3","./controllers/nlp":"hvlUZ","./controllers/callRecordings":"bndPk","./controllers/orgSetup":"bhHHO","./controllers/orgAnalytics":"1xjRQ","./controllers/analyticsOrderState":"lNxyP","./controllers/engagementAnalyticsReporting":"7dGKa","./controllers/testCases":"3SuET","./controllers/responses":"jCvpY","./controllers/applicationVariables":"gTXEN","./controllers/organizationVariables":"dwUYf","./controllers/medicalIntegrationConfiguration":"kJ16E","./controllers/revenueConfig":"iyF3V","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"dACq8":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "signIn", ()=>signIn);
parcelHelpers.export(exports, "beginSingleSignOnSignIn", ()=>beginSingleSignOnSignIn);
parcelHelpers.export(exports, "beginSingleSignOnSignUp", ()=>beginSingleSignOnSignUp);
parcelHelpers.export(exports, "refreshToken", ()=>refreshToken);
var _urls = require("../../constants/Urls");
var _generic = require("./generic");
var _keys = require("../../constants/Keys");
const signIn = (model)=>{
    const authModel = {
        username: model.email,
        password: model.password,
        grant_type: "password",
        client_id: (0, _keys.VOICIFY_CLIENT_ID),
        client_secret: (0, _keys.getVoicifyClientSecret)()
    };
    return (0, _generic.sendPost)(`${(0, _urls.SIGN_IN)}/signIn`, authModel);
};
const beginSingleSignOnSignIn = (ssoRequest)=>{
    ssoRequest.clientId = (0, _keys.VOICIFY_CLIENT_ID);
    ssoRequest.clientSecret = (0, _keys.getVoicifyClientSecret)();
    return (0, _generic.sendPost)(`${(0, _urls.SINGLE_SIGN_ON)}/signIn`, ssoRequest);
};
const beginSingleSignOnSignUp = (ssoRequest)=>{
    ssoRequest.clientId = (0, _keys.VOICIFY_CLIENT_ID);
    ssoRequest.clientSecret = (0, _keys.getVoicifyClientSecret)();
    return (0, _generic.sendPost)(`${(0, _urls.SINGLE_SIGN_ON)}/signUp`, ssoRequest);
};
const refreshToken = (model)=>{
    const authModel = {
        username: model.email,
        grant_type: "refresh_token",
        client_id: (0, _keys.VOICIFY_CLIENT_ID),
        client_secret: (0, _keys.getVoicifyClientSecret)(),
        refresh_token: model.refreshToken
    };
    return (0, _generic.sendPost)(`${(0, _urls.SIGN_IN)}/token`, authModel);
};

},{"../../constants/Urls":"iTopY","./generic":"6oGDt","../../constants/Keys":"4iC9Z","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"iTopY":[function(require,module,exports) {
// contains constants for urls for voicify
// the base url is handled in the api calls from the env variable API_URL
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getBaseUrl", ()=>getBaseUrl);
parcelHelpers.export(exports, "getSparkBaseUrl", ()=>getSparkBaseUrl);
parcelHelpers.export(exports, "getSparkMainBaseUrl", ()=>getSparkMainBaseUrl);
parcelHelpers.export(exports, "getBaseApiUrl", ()=>getBaseApiUrl);
parcelHelpers.export(exports, "getAnalyticsApiUrl", ()=>getAnalyticsApiUrl);
parcelHelpers.export(exports, "getAnalyticsWebsocketApiUrl", ()=>getAnalyticsWebsocketApiUrl);
parcelHelpers.export(exports, "getWebsocketAssistantUrl", ()=>getWebsocketAssistantUrl);
parcelHelpers.export(exports, "getAssistantApiUrl", ()=>getAssistantApiUrl);
parcelHelpers.export(exports, "getBusinessManagementApiUrl", ()=>getBusinessManagementApiUrl);
parcelHelpers.export(exports, "getAssistantPreviewApiUrl", ()=>getAssistantPreviewApiUrl);
parcelHelpers.export(exports, "getSupportAssistantBaseUrl", ()=>getSupportAssistantBaseUrl);
parcelHelpers.export(exports, "getIntegrationsApiUrl", ()=>getIntegrationsApiUrl);
parcelHelpers.export(exports, "getNlpApiUrl", ()=>getNlpApiUrl);
parcelHelpers.export(exports, "getNlpModulesApiURL", ()=>getNlpModulesApiURL);
parcelHelpers.export(exports, "SIGN_IN", ()=>SIGN_IN);
parcelHelpers.export(exports, "SINGLE_SIGN_ON", ()=>SINGLE_SIGN_ON);
parcelHelpers.export(exports, "GET_ORGANIZATIONS", ()=>GET_ORGANIZATIONS);
parcelHelpers.export(exports, "GET_SUBSCRIPTIONS", ()=>GET_SUBSCRIPTIONS);
parcelHelpers.export(exports, "GET_APPLICATIONS", ()=>GET_APPLICATIONS);
parcelHelpers.export(exports, "GET_FEATURES", ()=>GET_FEATURES);
parcelHelpers.export(exports, "GET_WELCOMEMESSAGES", ()=>GET_WELCOMEMESSAGES);
parcelHelpers.export(exports, "ADD_WELCOMEMESSAGE", ()=>ADD_WELCOMEMESSAGE);
parcelHelpers.export(exports, "GET_EXITMESSAGES", ()=>GET_EXITMESSAGES);
parcelHelpers.export(exports, "ADD_EXITMESSAGES", ()=>ADD_EXITMESSAGES);
parcelHelpers.export(exports, "GET_HELPMESSAGES", ()=>GET_HELPMESSAGES);
parcelHelpers.export(exports, "ADD_HELPMESSAGE", ()=>ADD_HELPMESSAGE);
parcelHelpers.export(exports, "GET_LATESTMESSAGES", ()=>GET_LATESTMESSAGES);
parcelHelpers.export(exports, "GET_QUESTIONANSWER", ()=>GET_QUESTIONANSWER);
parcelHelpers.export(exports, "ADD_QUESTIONANSWER", ()=>ADD_QUESTIONANSWER);
parcelHelpers.export(exports, "GET_LATESTMESSAGES_FOR_MODULE", ()=>GET_LATESTMESSAGES_FOR_MODULE);
parcelHelpers.export(exports, "CREATE_LATESTMESSAGE", ()=>CREATE_LATESTMESSAGE);
parcelHelpers.export(exports, "CREATE_USER", ()=>CREATE_USER);
parcelHelpers.export(exports, "ACCEPT_INVITATION", ()=>ACCEPT_INVITATION);
parcelHelpers.export(exports, "RESET_PASSWORD", ()=>RESET_PASSWORD);
parcelHelpers.export(exports, "SET_PASSWORD", ()=>SET_PASSWORD);
parcelHelpers.export(exports, "GET_MEDIAITEMS", ()=>GET_MEDIAITEMS);
parcelHelpers.export(exports, "GET_UPLOAD_URL", ()=>GET_UPLOAD_URL);
parcelHelpers.export(exports, "GET_CURRENT_USER", ()=>GET_CURRENT_USER);
parcelHelpers.export(exports, "GET_USER_TERMS", ()=>GET_USER_TERMS);
parcelHelpers.export(exports, "GET_NOTIFICATIONS", ()=>GET_NOTIFICATIONS);
parcelHelpers.export(exports, "GET_SYSTEM_FEATURES", ()=>GET_SYSTEM_FEATURES);
parcelHelpers.export(exports, "UPDATE_USER_DETAILS", ()=>UPDATE_USER_DETAILS);
parcelHelpers.export(exports, "UPDATE_USER_IMAGE", ()=>UPDATE_USER_IMAGE);
parcelHelpers.export(exports, "GET_MEDIARESPONSES", ()=>GET_MEDIARESPONSES);
parcelHelpers.export(exports, "MEDIAVERIFICATION", ()=>MEDIAVERIFICATION);
parcelHelpers.export(exports, "COOKIE_TERMS_URL", ()=>COOKIE_TERMS_URL);
parcelHelpers.export(exports, "UPDATE_ENVIRONMENT", ()=>UPDATE_ENVIRONMENT);
parcelHelpers.export(exports, "PLATFORM_ALEXA_SKILL", ()=>PLATFORM_ALEXA_SKILL);
parcelHelpers.export(exports, "PLATFORM_AZURE", ()=>PLATFORM_AZURE);
parcelHelpers.export(exports, "PLATFORM_DIALOGFLOW", ()=>PLATFORM_DIALOGFLOW);
parcelHelpers.export(exports, "APPLICATION_NLP_ENTITY", ()=>APPLICATION_NLP_ENTITY);
parcelHelpers.export(exports, "APPLICATION_MENU_ITEM", ()=>APPLICATION_MENU_ITEM);
parcelHelpers.export(exports, "APPLICATION_TELEPHONY_DEPLOYMENT", ()=>APPLICATION_TELEPHONY_DEPLOYMENT);
parcelHelpers.export(exports, "APPLICATION_VARIABLE", ()=>APPLICATION_VARIABLE);
parcelHelpers.export(exports, "ORGANIZATION_VARIABLE", ()=>ORGANIZATION_VARIABLE);
parcelHelpers.export(exports, "SETUP_ORG_FOR_FEATURE", ()=>SETUP_ORG_FOR_FEATURE);
parcelHelpers.export(exports, "MANUAL_UPDATES", ()=>MANUAL_UPDATES);
parcelHelpers.export(exports, "VOICIFY_MENU", ()=>VOICIFY_MENU);
parcelHelpers.export(exports, "OUTBOUND_CALL", ()=>OUTBOUND_CALL);
parcelHelpers.export(exports, "OUTBOUND_CALL_Config", ()=>OUTBOUND_CALL_Config);
parcelHelpers.export(exports, "MEDICAL_INTEGRATION_CONFIGURATION", ()=>MEDICAL_INTEGRATION_CONFIGURATION);
const getBaseUrl = ()=>{
    if (window.location.href.includes("localhost:3000")) return "http://localhost:3000";
    else if (window.location.href.includes("localhost:1234")) return "http://localhost:1234";
    else return "https://app.voicify.com";
    return null;
};
const getSparkBaseUrl = ()=>{
    if (window.location.href.includes("localhost:4321")) return "http://localhost:4321";
    else if (window.location.href.includes("dev-spark")) return "https://dev-app.voicify.com";
    else if (window.location.href.includes("spark.voicify.com")) return "https://spark.voicify.com";
    return null;
};
const getSparkMainBaseUrl = ()=>{
    return "https://spark.voicify.com";
};
const getBaseApiUrl = ()=>{
    return "https://cms.voicify.com/api";
};
const getAnalyticsApiUrl = ()=>{
    return "https://analytics.voicify.com/api";
};
const getAnalyticsWebsocketApiUrl = ()=>{
    return "wss://analytics.voicify.com/api";
};
const getWebsocketAssistantUrl = ()=>{
    return "https://websocket-assistant.voicify.com/api";
};
const getAssistantApiUrl = ()=>{
    return "https://assistant.voicify.com/api";
};
const getBusinessManagementApiUrl = ()=>{
    return "https://bsm.voicify.com/api";
};
const getAssistantPreviewApiUrl = ()=>{
    return "https://assistant.voicify.com";
};
const getSupportAssistantBaseUrl = ()=>{
    return "https://assistant.voicify.com";
};
const getIntegrationsApiUrl = ()=>{
    return "https://integrations.voicify.com/api";
};
const getNlpApiUrl = ()=>{
    return "https://nlp.voicify.com/api";
};
const getNlpModulesApiURL = ()=>{
    return "https://nlp-modules.voicify.com/api";
};
const SIGN_IN = "/Authentication";
const SINGLE_SIGN_ON = "/SingleSignOn";
const GET_ORGANIZATIONS = "/Organization";
const GET_SUBSCRIPTIONS = "/Subscription";
const GET_APPLICATIONS = "/Application";
const GET_FEATURES = "/Feature";
const GET_WELCOMEMESSAGES = "/WelcomeMessage";
const ADD_WELCOMEMESSAGE = "/WelcomeMessage";
const GET_EXITMESSAGES = "/ExitMessage";
const ADD_EXITMESSAGES = "/ExitMessage";
const GET_HELPMESSAGES = "/HelpMessage";
const ADD_HELPMESSAGE = "/HelpMessage";
const GET_LATESTMESSAGES = "/LatestMessage";
const GET_QUESTIONANSWER = "/QuestionAnswer";
const ADD_QUESTIONANSWER = "/QuestionAnswer";
const GET_LATESTMESSAGES_FOR_MODULE = "/LatestMessage/module";
const CREATE_LATESTMESSAGE = "/LatestMessage";
const CREATE_USER = "/User";
const ACCEPT_INVITATION = "/Invitation/accept";
const RESET_PASSWORD = "/User/ResetPassword";
const SET_PASSWORD = "/User/SetPassword";
const GET_MEDIAITEMS = "/MediaItem";
const GET_UPLOAD_URL = "/MediaItem";
const GET_CURRENT_USER = "/User/me";
const GET_USER_TERMS = "/User/terms";
const GET_NOTIFICATIONS = "/VoicifyNotification";
const GET_SYSTEM_FEATURES = "/Feature/BuiltIn";
const UPDATE_USER_DETAILS = "/User/UpdateDetails";
const UPDATE_USER_IMAGE = "/user/UpdateImage";
const GET_MEDIARESPONSES = "/MediaResponse";
const MEDIAVERIFICATION = "/MediaVerification";
const COOKIE_TERMS_URL = `https://voicify.com/about-us/cookie-policy/`;
const UPDATE_ENVIRONMENT = "/ApplicationEnvironment";
const PLATFORM_ALEXA_SKILL = "/AlexaSkill";
const PLATFORM_AZURE = "/AzureApplication";
const PLATFORM_DIALOGFLOW = "/DialogflowAgent";
const APPLICATION_NLP_ENTITY = "/ApplicationNlpEntity";
const APPLICATION_MENU_ITEM = "/VoicifyMenuItem";
const APPLICATION_TELEPHONY_DEPLOYMENT = "/TelephonyDeployment";
const APPLICATION_VARIABLE = "/applicationVariable";
const ORGANIZATION_VARIABLE = "/organizationVariable";
const SETUP_ORG_FOR_FEATURE = "/Setup/setupOrgForFeature";
const MANUAL_UPDATES = "/ManualUpdates";
const VOICIFY_MENU = "/VoicifyMenu";
const OUTBOUND_CALL = "/OutboundCall";
const OUTBOUND_CALL_Config = "/outboundcallconfig";
const MEDICAL_INTEGRATION_CONFIGURATION = "/MedicalIntegrationConfiguration";

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6oGDt":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "sendPost", ()=>sendPost);
parcelHelpers.export(exports, "sendPostWithCustomHeaders", ()=>sendPostWithCustomHeaders);
parcelHelpers.export(exports, "sendPostForFile", ()=>sendPostForFile);
parcelHelpers.export(exports, "uploadFile", ()=>uploadFile);
parcelHelpers.export(exports, "putFile", ()=>putFile);
parcelHelpers.export(exports, "sendGet", ()=>sendGet);
parcelHelpers.export(exports, "connectWebsocket", ()=>connectWebsocket);
parcelHelpers.export(exports, "sendGetFile", ()=>sendGetFile);
parcelHelpers.export(exports, "sendPut", ()=>sendPut);
parcelHelpers.export(exports, "sendDelete", ()=>sendDelete);
parcelHelpers.export(exports, "queryStringSerialize", ()=>queryStringSerialize);
var _successResult = require("../../models/result/SuccessResult");
var _successResultDefault = parcelHelpers.interopDefault(_successResult);
var _invalidResult = require("../../models/result/InvalidResult");
var _invalidResultDefault = parcelHelpers.interopDefault(_invalidResult);
var _unauthorizedResult = require("../../models/result/UnauthorizedResult");
var _unauthorizedResultDefault = parcelHelpers.interopDefault(_unauthorizedResult);
var _unexpectedResult = require("../../models/result/UnexpectedResult");
var _unexpectedResultDefault = parcelHelpers.interopDefault(_unexpectedResult);
var _urls = require("../../constants/Urls");
var _keys = require("../../constants/Keys");
var _notFoundResult = require("../../models/result/NotFoundResult");
var _notFoundResultDefault = parcelHelpers.interopDefault(_notFoundResult);
const sendPost = async (url, body, baseUrl, tokenOverride = null)=>{
    const fullUrl = (baseUrl === undefined ? (0, _urls.getBaseApiUrl)() : baseUrl) + url;
    try {
        const headers = getHeaders(tokenOverride);
        const response = await fetch(fullUrl, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                ...headers
            },
            body: JSON.stringify(body)
        });
        return await handleFetchResponse(response);
    } catch (error) {
        console.error("Network error in sendPost:", error);
        return new (0, _unexpectedResultDefault.default)();
    }
};
const sendPostWithCustomHeaders = async (url, body, customHeaders, baseUrl)=>{
    const fullUrl = (baseUrl === undefined ? (0, _urls.getBaseApiUrl)() : baseUrl) + url;
    try {
        const response = await fetch(fullUrl, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                ...customHeaders
            },
            body: JSON.stringify(body)
        });
        return await handleFetchResponse(response);
    } catch (error) {
        console.error("Network error in sendPostWithCustomHeaders:", error);
        return new (0, _unexpectedResultDefault.default)();
    }
};
const sendPostForFile = async (url, body, baseUrl)=>{
    const fullUrl = (baseUrl === undefined ? (0, _urls.getBaseApiUrl)() : baseUrl) + url;
    try {
        const headers = getHeaders();
        const response = await fetch(fullUrl, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                ...headers
            },
            body: JSON.stringify(body)
        });
        return await handleFetchResponseBlob(response);
    } catch (error) {
        console.error("Network error in sendPostForFile:", error);
        return new (0, _unexpectedResultDefault.default)();
    }
};
const uploadFile = async (url, file, baseUrl)=>{
    const fullUrl = (baseUrl === undefined ? (0, _urls.getBaseApiUrl)() : baseUrl) + url;
    try {
        const headers = getHeaders();
        const formData = new FormData();
        formData.append("file", file);
        const response = await fetch(fullUrl, {
            method: "POST",
            headers: headers,
            body: formData
        });
        return await handleFetchResponse(response);
    } catch (error) {
        console.error("Network error in uploadFile:", error);
        return new (0, _unexpectedResultDefault.default)();
    }
};
const putFile = async (url, file, progressCallback)=>{
    try {
        return new Promise((resolve)=>{
            const xhr = new XMLHttpRequest();
            xhr.upload.onprogress = (event)=>{
                if (event.lengthComputable && progressCallback) {
                    const percentCompleted = Math.floor(event.loaded * 100 / event.total);
                    progressCallback(percentCompleted);
                }
            };
            xhr.onload = async ()=>{
                const mockResponse = {
                    status: xhr.status,
                    text: ()=>Promise.resolve(xhr.responseText),
                    json: ()=>Promise.resolve(xhr.responseText ? JSON.parse(xhr.responseText) : null),
                    blob: ()=>Promise.resolve(new Blob([
                            xhr.response
                        ]))
                };
                const result = await handleFetchResponse(mockResponse);
                resolve(result);
            };
            xhr.onerror = ()=>{
                console.error("Network error in putFile:", xhr.status, xhr.statusText);
                resolve(new (0, _unexpectedResultDefault.default)());
            };
            xhr.ontimeout = ()=>{
                console.error("Timeout error in putFile");
                resolve(new (0, _unexpectedResultDefault.default)());
            };
            xhr.open("PUT", url);
            xhr.setRequestHeader("Content-Type", getFileType(file.type));
            // Set timeout to prevent hanging requests
            xhr.timeout = 300000; // 5 minutes
            xhr.send(file);
        });
    } catch (error) {
        console.error("Error in putFile:", error);
        return new (0, _unexpectedResultDefault.default)();
    }
};
const getFileType = (fileType)=>{
    // override file type for content type since certain browsers just make up their own rules
    if (fileType == "audio/mpeg") return "audio/mp3";
    return fileType;
};
const sendGet = async (url, baseUrl)=>{
    const fullUrl = (baseUrl === undefined ? (0, _urls.getBaseApiUrl)() : baseUrl) + url;
    try {
        const headers = getHeaders();
        const response = await fetch(fullUrl, {
            method: "GET",
            headers: headers
        });
        return await handleFetchResponse(response);
    } catch (error) {
        console.error("Network error in sendGet:", error);
        return new (0, _unexpectedResultDefault.default)();
    }
};
const connectWebsocket = async (url, baseUrl)=>{
    const fullUrl = (baseUrl === undefined ? (0, _urls.getAnalyticsWebsocketApiUrl)() : baseUrl) + url;
    try {
        let accessToken = sessionStorage.getItem((0, _keys.VOICIFY_ACCESS_TOKEN_STORE));
        const ws = new WebSocket(fullUrl, [
            "voicify-client",
            `bearer-${accessToken}`
        ]);
        return ws;
    } catch (error) {
        return null;
    }
};
const sendGetFile = async (url, baseUrl)=>{
    const fullUrl = (baseUrl === undefined ? (0, _urls.getBaseApiUrl)() : baseUrl) + url;
    try {
        const headers = getHeaders();
        const response = await fetch(fullUrl, {
            method: "GET",
            headers: headers
        });
        return await handleFetchResponseBlob(response);
    } catch (error) {
        console.error("Network error in sendGetFile:", error);
        return new (0, _unexpectedResultDefault.default)();
    }
};
const sendPut = async (url, body, baseUrl)=>{
    const fullUrl = (baseUrl === undefined ? (0, _urls.getBaseApiUrl)() : baseUrl) + url;
    try {
        const headers = getHeaders();
        const response = await fetch(fullUrl, {
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                ...headers
            },
            body: body ? JSON.stringify(body) : undefined
        });
        return await handleFetchResponse(response);
    } catch (error) {
        console.error("Network error in sendPut:", error);
        return new (0, _unexpectedResultDefault.default)();
    }
};
const sendDelete = async (url, baseUrl)=>{
    const fullUrl = (baseUrl === undefined ? (0, _urls.getBaseApiUrl)() : baseUrl) + url;
    try {
        const headers = getHeaders();
        const response = await fetch(fullUrl, {
            method: "DELETE",
            headers: headers
        });
        return await handleFetchResponse(response);
    } catch (error) {
        console.error("Network error in sendDelete:", error);
        return new (0, _unexpectedResultDefault.default)();
    }
};
const queryStringSerialize = (model)=>{
    const stringArray = [];
    for(const property in model)if (model.hasOwnProperty(property) && model[property] != null) stringArray.push(encodeURIComponent(property) + "=" + encodeURIComponent(model[property]));
    return stringArray.join("&");
};
const getHeaders = (tokenOverride = null)=>{
    const headers = {
        "Access-Control-Allow-Origin": "*"
    };
    // pull token from local store
    let accessToken = sessionStorage.getItem((0, _keys.VOICIFY_ACCESS_TOKEN_STORE));
    if (accessToken?.length || tokenOverride?.length) {
        if (tokenOverride?.length) accessToken = tokenOverride;
        // set authorization header
        if (accessToken !== undefined) headers["Authorization"] = `Bearer ${accessToken}`;
    } else {
        let apiKey = sessionStorage.getItem((0, _keys.VOICIFY_API_KEY));
        if (apiKey?.length) // set api key header
        headers["X-Api-Key"] = apiKey;
    }
    return headers;
};
// maps a fetch response to a result
const handleFetchResponse = async (response)=>{
    if (!response) return new (0, _unexpectedResultDefault.default)();
    if (response.status === 200 || response.status === 204) try {
        // Handle empty responses
        if (response.status === 204) return new (0, _successResultDefault.default)(null);
        const text = await response.text();
        if (!text) return new (0, _successResultDefault.default)(null);
        const contentType = response.headers.get("content-type") || "";
        // If content-type indicates plain text, return as-is
        if (contentType.includes("text/plain")) return new (0, _successResultDefault.default)(text);
        // Try to parse as JSON (handles objects, arrays, and primitives like booleans, numbers)
        const trimmedText = text.trim();
        // Check if it looks like JSON (objects, arrays, or primitive JSON values)
        const looksLikeJson = trimmedText.startsWith("{") || trimmedText.startsWith("[") || trimmedText === "true" || trimmedText === "false" || trimmedText === "null" || !isNaN(Number(trimmedText));
        if (looksLikeJson) try {
            const data = JSON.parse(text);
            return new (0, _successResultDefault.default)(data);
        } catch  {
            // If JSON parsing fails, return as text
            return new (0, _successResultDefault.default)(text);
        }
        // Not JSON, return as text
        return new (0, _successResultDefault.default)(text);
    } catch (error) {
        console.error("Error parsing response:", error);
        console.error("Response URL:", response.url);
        console.error("Response status:", response.status);
        console.error("Response headers:", Object.fromEntries(response.headers.entries()));
        return new (0, _unexpectedResultDefault.default)();
    }
    else if (response.status === 400) try {
        const data = await response.json();
        const errors = data;
        let error = errors[0];
        if (error == undefined) {
            const attributeErrorNames = Object.getOwnPropertyNames(errors);
            if (attributeErrorNames[0] != undefined && errors[attributeErrorNames[0]] != null) error = errors[attributeErrorNames[0]];
            else error = data["Responses[0].Content"][0];
        }
        return new (0, _invalidResultDefault.default)(error);
    } catch (error) {
        return new (0, _invalidResultDefault.default)("Bad Request");
    }
    else if (response.status === 401) return new (0, _unauthorizedResultDefault.default)();
    else if (response.status === 404) return new (0, _notFoundResultDefault.default)();
    else if (response.status === 403) return new (0, _unauthorizedResultDefault.default)();
    return new (0, _unexpectedResultDefault.default)();
};
// maps a fetch response to a blob result
const handleFetchResponseBlob = async (response)=>{
    if (!response) return new (0, _unexpectedResultDefault.default)();
    if (response.status === 200 || response.status === 204) try {
        const blob = await response.blob();
        return new (0, _successResultDefault.default)(blob);
    } catch (error) {
        console.error("Error parsing blob response:", error);
        return new (0, _unexpectedResultDefault.default)();
    }
    else if (response.status === 400) try {
        const data = await response.json();
        const errors = data;
        let error = errors[0];
        if (error == undefined) {
            const attributeErrorNames = Object.getOwnPropertyNames(errors);
            if (attributeErrorNames[0] != undefined && errors[attributeErrorNames[0]] != null) error = errors[attributeErrorNames[0]];
            else error = data["Responses[0].Content"][0];
        }
        return new (0, _invalidResultDefault.default)(error);
    } catch (error) {
        return new (0, _invalidResultDefault.default)("Bad Request");
    }
    else if (response.status === 404) return new (0, _notFoundResultDefault.default)();
    else if (response.status === 403) return new (0, _unauthorizedResultDefault.default)();
    return new (0, _unexpectedResultDefault.default)();
};

},{"../../models/result/SuccessResult":"h4uNM","../../models/result/InvalidResult":"hpD5G","../../models/result/UnauthorizedResult":"lCE3z","../../models/result/UnexpectedResult":"kmg1F","../../constants/Urls":"iTopY","../../constants/Keys":"4iC9Z","../../models/result/NotFoundResult":"eHOkp","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"h4uNM":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _defineProperty = require("@babel/runtime/helpers/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
class SuccessResult {
    constructor(data){
        (0, _definePropertyDefault.default)(this, "resultType", "Ok");
        (0, _definePropertyDefault.default)(this, "errors", []);
        this.data = data;
    }
}
exports.default = SuccessResult;

},{"@babel/runtime/helpers/defineProperty":"9sJxO","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hpD5G":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _defineProperty = require("@babel/runtime/helpers/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
class InvalidResult {
    constructor(error){
        (0, _definePropertyDefault.default)(this, "data", null);
        (0, _definePropertyDefault.default)(this, "resultType", "Invalid");
        this.errors = [
            error
        ];
    }
}
exports.default = InvalidResult;

},{"@babel/runtime/helpers/defineProperty":"9sJxO","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"lCE3z":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _defineProperty = require("@babel/runtime/helpers/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
class UnauthorizedResult {
    constructor(error = "Your session has expired. Please sign in and try again."){
        (0, _definePropertyDefault.default)(this, "data", null);
        (0, _definePropertyDefault.default)(this, "resultType", "Unauthorized");
        this.errors = [
            error
        ];
    }
}
exports.default = UnauthorizedResult;

},{"@babel/runtime/helpers/defineProperty":"9sJxO","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"kmg1F":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _defineProperty = require("@babel/runtime/helpers/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
class UnexpectedResult {
    constructor(){
        (0, _definePropertyDefault.default)(this, "data", null);
        (0, _definePropertyDefault.default)(this, "resultType", "Unexpected");
        this.errors = [
            "An unexpected error has occurred. Please try again later."
        ];
    }
}
exports.default = UnexpectedResult;

},{"@babel/runtime/helpers/defineProperty":"9sJxO","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4iC9Z":[function(require,module,exports) {
// constants for keys
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "VOICIFY_CLIENT_ID", ()=>VOICIFY_CLIENT_ID);
parcelHelpers.export(exports, "VOICIFY_ACCESS_TOKEN_STORE", ()=>VOICIFY_ACCESS_TOKEN_STORE);
parcelHelpers.export(exports, "VOICIFY_API_KEY", ()=>VOICIFY_API_KEY);
parcelHelpers.export(exports, "VOICIFY_REFRESH_TOKEN_STORE", ()=>VOICIFY_REFRESH_TOKEN_STORE);
parcelHelpers.export(exports, "VOICIFY_EMAIL_STORE", ()=>VOICIFY_EMAIL_STORE);
parcelHelpers.export(exports, "VOICIFY_ACCESS_EXPIRATION", ()=>VOICIFY_ACCESS_EXPIRATION);
parcelHelpers.export(exports, "VOICIFY_REFRESH_EXPIRATION", ()=>VOICIFY_REFRESH_EXPIRATION);
parcelHelpers.export(exports, "VOICIFY_NLP_MODEL_TRAINING_STATE", ()=>VOICIFY_NLP_MODEL_TRAINING_STATE);
parcelHelpers.export(exports, "VOICIFY_SPARK_DEPLOYMENT_STATE", ()=>VOICIFY_SPARK_DEPLOYMENT_STATE);
parcelHelpers.export(exports, "ANALYTICS_ORDER_STATE", ()=>ANALYTICS_ORDER_STATE);
parcelHelpers.export(exports, "VOICIFY_MENU_SYNC_STATE", ()=>VOICIFY_MENU_SYNC_STATE);
parcelHelpers.export(exports, "getVoicifyClientSecret", ()=>getVoicifyClientSecret);
parcelHelpers.export(exports, "SUPPORT_APPLICATION_ID", ()=>SUPPORT_APPLICATION_ID);
parcelHelpers.export(exports, "SUPPORT_APPLICATION_SECRET", ()=>SUPPORT_APPLICATION_SECRET);
const VOICIFY_CLIENT_ID = "d3fd0f4d-89ef-4bfd-bc67-14b09f4af2f8";
const VOICIFY_ACCESS_TOKEN_STORE = "VOICIFY_ACCESS_TOKEN";
const VOICIFY_API_KEY = "VOICIFY_API_KEY";
const VOICIFY_REFRESH_TOKEN_STORE = "VOICIFY_REFRESH_TOKEN";
const VOICIFY_EMAIL_STORE = "VOICIFY_USER";
const VOICIFY_ACCESS_EXPIRATION = "VOICIFY_ACCESS_EXPIRATION";
const VOICIFY_REFRESH_EXPIRATION = "VOICIFY_REFRESH_EXPIRATION";
const VOICIFY_NLP_MODEL_TRAINING_STATE = "VOICIFY_NLP_MODEL_TRAINING_STATE";
const VOICIFY_SPARK_DEPLOYMENT_STATE = "VOICIFY_SPARK_DEPLOYMENT_STATE";
const ANALYTICS_ORDER_STATE = "ANALYTICS_ORDER_STATE";
const VOICIFY_MENU_SYNC_STATE = "VOICIFY_MENU_SYNC_STATE";
const getVoicifyClientSecret = ()=>{
    return "MjcyY2VjMWUtMWVhYi00ZmJjLTk3Y2QtNTJmMDcxM2RiYTE2LTk4OGNjMWQ2LTQ1OWItNDkyMy1iNTAwLWI2OTRkZjgxMTc3ZA==";
};
const SUPPORT_APPLICATION_ID = "dd805001-e1bf-4107-8e19-1b9ec4db575d";
const SUPPORT_APPLICATION_SECRET = "NjJlYWVhNTYtZWQwMy00MDBhLTlkYmYtZTVjNDhmZjEzMjlk";

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"eHOkp":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _defineProperty = require("@babel/runtime/helpers/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
class NotFoundResult {
    constructor(error = "Unable to find the given resource."){
        (0, _definePropertyDefault.default)(this, "data", null);
        (0, _definePropertyDefault.default)(this, "resultType", "NotFound");
        this.errors = [
            error
        ];
    }
}
exports.default = NotFoundResult;

},{"@babel/runtime/helpers/defineProperty":"9sJxO","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2aFbO":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getOrganizations", ()=>getOrganizations);
parcelHelpers.export(exports, "getMembers", ()=>getMembers);
parcelHelpers.export(exports, "getDetailedMemberships", ()=>getDetailedMemberships);
parcelHelpers.export(exports, "updateMemberRole", ()=>updateMemberRole);
parcelHelpers.export(exports, "removeMember", ()=>removeMember);
parcelHelpers.export(exports, "updateMemberReceivesAnalyticsEmail", ()=>updateMemberReceivesAnalyticsEmail);
parcelHelpers.export(exports, "updateOrganizationInfo", ()=>updateOrganizationInfo);
parcelHelpers.export(exports, "leaveOrganization", ()=>leaveOrganization);
var _urls = require("../../constants/Urls");
var _generic = require("./generic");
const getOrganizations = ()=>{
    return (0, _generic.sendGet)((0, _urls.GET_ORGANIZATIONS));
};
const getMembers = (organizationId)=>{
    return (0, _generic.sendGet)(`${(0, _urls.GET_ORGANIZATIONS)}/${organizationId}/members`);
};
const getDetailedMemberships = (organizationId)=>{
    return (0, _generic.sendGet)(`${(0, _urls.GET_ORGANIZATIONS)}/${organizationId}/members/detailed`);
};
const updateMemberRole = (organizationMemberId, userRoleId)=>{
    return (0, _generic.sendPut)(`/organization/members/${organizationMemberId}/role`, {
        roleId: userRoleId
    });
};
const removeMember = (organizationMemberId)=>{
    return (0, _generic.sendDelete)(`/organization/members/${organizationMemberId}/remove`);
};
const updateMemberReceivesAnalyticsEmail = (organizationMemberId, shouldReceiveAnalyticsEmails)=>{
    return (0, _generic.sendPut)(`/organization/members/${organizationMemberId}/receivesAnalyticsEmail`, {
        shouldReceiveAnalyticsEmails
    });
};
const updateOrganizationInfo = (organizationId, model)=>{
    return (0, _generic.sendPut)(`/organization/${organizationId}`, model);
};
const leaveOrganization = (organizationId)=>{
    return (0, _generic.sendDelete)(`/organization/${organizationId}/leave`);
};

},{"../../constants/Urls":"iTopY","./generic":"6oGDt","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1me18":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "findApplication", ()=>findApplication);
parcelHelpers.export(exports, "findApplicationWithFeatures", ()=>findApplicationWithFeatures);
parcelHelpers.export(exports, "getApplicationsForOrg", ()=>getApplicationsForOrg);
parcelHelpers.export(exports, "getApplicationsWithFeaturesForOrg", ()=>getApplicationsWithFeaturesForOrg);
parcelHelpers.export(exports, "searchForApplications", ()=>searchForApplications);
parcelHelpers.export(exports, "createEmptyApplication", ()=>createEmptyApplication);
parcelHelpers.export(exports, "createApplicationWithSamples", ()=>createApplicationWithSamples);
parcelHelpers.export(exports, "setApplicationImage", ()=>setApplicationImage);
parcelHelpers.export(exports, "addTemplateContentToApplication", ()=>addTemplateContentToApplication);
parcelHelpers.export(exports, "enableDetailedAnalytics", ()=>enableDetailedAnalytics);
parcelHelpers.export(exports, "disableDetailedAnalytics", ()=>disableDetailedAnalytics);
parcelHelpers.export(exports, "getApplicationMembers", ()=>getApplicationMembers);
parcelHelpers.export(exports, "addApplicationMember", ()=>addApplicationMember);
parcelHelpers.export(exports, "updateApplicationMemberRole", ()=>updateApplicationMemberRole);
parcelHelpers.export(exports, "removeApplicationMember", ()=>removeApplicationMember);
parcelHelpers.export(exports, "disableApplication", ()=>disableApplication);
parcelHelpers.export(exports, "getApplicationConversationCounts", ()=>getApplicationConversationCounts);
parcelHelpers.export(exports, "getApplicationCounts", ()=>getApplicationCounts);
parcelHelpers.export(exports, "getApplicationWebhookInstances", ()=>getApplicationWebhookInstances);
parcelHelpers.export(exports, "removeApplicationWebhook", ()=>removeApplicationWebhook);
parcelHelpers.export(exports, "addApplicationWebhook", ()=>addApplicationWebhook);
parcelHelpers.export(exports, "updateApplicationWebhook", ()=>updateApplicationWebhook);
parcelHelpers.export(exports, "bulkUpdateApplicationWebhookInstances", ()=>bulkUpdateApplicationWebhookInstances);
parcelHelpers.export(exports, "getApplicationFulfillmentEndpoints", ()=>getApplicationFulfillmentEndpoints);
parcelHelpers.export(exports, "updateApplication", ()=>updateApplication);
parcelHelpers.export(exports, "updateApplicationFeatureFlagSettings", ()=>updateApplicationFeatureFlagSettings);
parcelHelpers.export(exports, "copyApplication", ()=>copyApplication);
parcelHelpers.export(exports, "updateApplicationLanguages", ()=>updateApplicationLanguages);
parcelHelpers.export(exports, "syncNLPAndInteractionModel", ()=>syncNLPAndInteractionModel);
parcelHelpers.export(exports, "updateApplicationDefaultLanguage", ()=>updateApplicationDefaultLanguage);
parcelHelpers.export(exports, "updateGenerativeAIAssistantPrompt", ()=>updateGenerativeAIAssistantPrompt);
parcelHelpers.export(exports, "toggleAllowsTemplating", ()=>toggleAllowsTemplating);
parcelHelpers.export(exports, "getAssistantApplication", ()=>getAssistantApplication);
parcelHelpers.export(exports, "getFeatureFlags", ()=>getFeatureFlags);
parcelHelpers.export(exports, "getPOSConfig", ()=>getPOSConfig);
parcelHelpers.export(exports, "updatePOSConfig", ()=>updatePOSConfig);
parcelHelpers.export(exports, "refreshPOSCache", ()=>refreshPOSCache);
var _urls = require("../../constants/Urls");
var _generic = require("./generic");
const findApplication = (applicationId)=>{
    return (0, _generic.sendGet)(`${(0, _urls.GET_APPLICATIONS)}/find/${applicationId}`);
};
const findApplicationWithFeatures = (applicationId)=>{
    return (0, _generic.sendGet)(`${(0, _urls.GET_APPLICATIONS)}/find/${applicationId}/withfeatures`);
};
const getApplicationsForOrg = (organizationId)=>{
    return (0, _generic.sendGet)(`${(0, _urls.GET_APPLICATIONS)}/${organizationId}`);
};
const getApplicationsWithFeaturesForOrg = (organizationId)=>{
    return (0, _generic.sendGet)(`${(0, _urls.GET_APPLICATIONS)}/${organizationId}/withFeatures`);
};
const searchForApplications = (organizationId, skip, take, sortBy, search)=>{
    return (0, _generic.sendGet)(`${(0, _urls.GET_APPLICATIONS)}/${organizationId}/withMembers/search?take=${take}&skip=${skip}&sortBy=${sortBy}&search=${search}`);
};
const createEmptyApplication = (organizationId, model)=>{
    return (0, _generic.sendPost)(`${(0, _urls.GET_APPLICATIONS)}/${organizationId}`, model);
};
const createApplicationWithSamples = (organizationId, model)=>{
    return (0, _generic.sendPost)(`${(0, _urls.GET_APPLICATIONS)}/${organizationId}/withSamples`, model);
};
const setApplicationImage = (applicationId, mediaItemId)=>{
    return (0, _generic.sendPut)(`${(0, _urls.GET_APPLICATIONS)}/${applicationId}/setImage/${mediaItemId}`, null);
};
const addTemplateContentToApplication = (applicationId, templates)=>{
    return (0, _generic.sendPut)(`${(0, _urls.GET_APPLICATIONS)}/${applicationId}/addTemplates`, templates);
};
const enableDetailedAnalytics = (applicationId)=>{
    return (0, _generic.sendPut)(`${(0, _urls.GET_APPLICATIONS)}/${applicationId}/enableDetailedAnalytics`, null);
};
const disableDetailedAnalytics = (applicationId)=>{
    return (0, _generic.sendPut)(`${(0, _urls.GET_APPLICATIONS)}/${applicationId}/disableDetailedAnalytics`, null);
};
const getApplicationMembers = (applicationId)=>{
    return (0, _generic.sendGet)(`${(0, _urls.GET_APPLICATIONS)}/${applicationId}/members`);
};
const addApplicationMember = (applicationId, model)=>{
    return (0, _generic.sendPost)(`${(0, _urls.GET_APPLICATIONS)}/${applicationId}/members/bulkAdd`, model);
};
const updateApplicationMemberRole = (applicationMemberId, roleId)=>{
    return (0, _generic.sendPut)(`${(0, _urls.GET_APPLICATIONS)}/members/${applicationMemberId}`, {
        roleId
    });
};
const removeApplicationMember = (applicationMemberId)=>{
    return (0, _generic.sendDelete)(`${(0, _urls.GET_APPLICATIONS)}/members/${applicationMemberId}`);
};
const disableApplication = (applicationId)=>{
    return (0, _generic.sendDelete)(`${(0, _urls.GET_APPLICATIONS)}/${applicationId}/disable`);
};
const getApplicationConversationCounts = (organizationId)=>{
    return (0, _generic.sendGet)(`${(0, _urls.GET_APPLICATIONS)}/${organizationId}/apps/conversationCounts`);
};
const getApplicationCounts = (organizationId, appIds)=>{
    var queryString = appIds.join("&appIds=");
    queryString = `?appIds=${queryString}`;
    const url = `${(0, _urls.GET_APPLICATIONS)}/${organizationId}/conversationAndFeatureCounts${queryString}`;
    return (0, _generic.sendGet)(url);
};
const getApplicationWebhookInstances = (applicationId)=>{
    return (0, _generic.sendGet)(`/Application/${applicationId}/webhooks`);
};
const removeApplicationWebhook = (applicationWebhookId)=>{
    return (0, _generic.sendDelete)(`/Application/webhook/${applicationWebhookId}`);
};
const addApplicationWebhook = (applicationId, webhookId, defaultParameters, userDefinedParameters)=>{
    return (0, _generic.sendPost)(`/Application/${applicationId}/webhooks/${webhookId}`, {
        values: defaultParameters,
        userDefinedParameters: userDefinedParameters
    });
};
const updateApplicationWebhook = (applicationId, webhookInstanceId, defaultParameters, userDefinedParameters)=>{
    return (0, _generic.sendPut)(`/Application/${applicationId}/webhooks/${webhookInstanceId}`, {
        values: defaultParameters,
        userDefinedParameters: userDefinedParameters
    });
};
const bulkUpdateApplicationWebhookInstances = (applicationId, updateRequest)=>{
    return (0, _generic.sendPut)(`/Application/${applicationId}/webhooks/bulk`, updateRequest);
};
const getApplicationFulfillmentEndpoints = (applicationId)=>{
    return (0, _generic.sendGet)(`/Application/${applicationId}/fulfillmentEndpoints`);
};
const updateApplication = (applicationId, model)=>{
    return (0, _generic.sendPut)(`/application/${applicationId}`, model);
};
const updateApplicationFeatureFlagSettings = (applicationId, model)=>{
    return (0, _generic.sendPut)(`/application/${applicationId}/featureFlagSettings`, model);
};
const copyApplication = (organizationId, applicationId)=>{
    return (0, _generic.sendPost)(`${(0, _urls.GET_APPLICATIONS)}/${organizationId}/copy/${applicationId}`, null);
};
const updateApplicationLanguages = (applicationId, languageIds)=>{
    return (0, _generic.sendPut)(`/application/${applicationId}/languages`, languageIds);
};
const syncNLPAndInteractionModel = (applicationId, languageIds, sourceLanguageId)=>{
    return (0, _generic.sendPost)(`/application/${applicationId}/NLPAndInteractionModel/sync`, {
        languageIds,
        sourceLanguageId
    });
};
const updateApplicationDefaultLanguage = (applicationId, languageId)=>{
    return (0, _generic.sendPut)(`/application/${applicationId}/defaultlanguage/${languageId}`, languageId);
};
const updateGenerativeAIAssistantPrompt = (applicationId, generativeAIAssistantPrompt, featureFlag)=>{
    return (0, _generic.sendPut)(`/application/${applicationId}/generativeAIAssistantPrompt`, {
        generativeAIAssistantPrompt,
        featureFlag
    });
};
const toggleAllowsTemplating = (applicationId, allowsTemplating)=>{
    return (0, _generic.sendPut)(`/application/${applicationId}/toggleAllowsTemplate`, {
        isTemplate: allowsTemplating
    });
};
const getAssistantApplication = (applicatonId)=>{
    return (0, _generic.sendGet)(`/application/${applicatonId}/assistant`);
};
const getFeatureFlags = ()=>{
    return (0, _generic.sendGet)(`/application/featureFlags`);
};
const getPOSConfig = (applicationId)=>{
    return (0, _generic.sendGet)(`/application/${applicationId}/posConfig`);
};
const updatePOSConfig = (applicationId, newConfig)=>{
    return (0, _generic.sendPut)(`/application/${applicationId}/posConfig`, {
        data: newConfig
    });
};
const refreshPOSCache = (applicationId, storeId, apiKey, posType)=>{
    const posUrl = `https://${posType.toLowerCase()}.voicify.com`;
    return (0, _generic.sendPostWithCustomHeaders)(`/admin/refreshcache`, {
        applicationID: applicationId,
        storeId: storeId
    }, {
        "x-api-key": apiKey
    }, posUrl);
};

},{"../../constants/Urls":"iTopY","./generic":"6oGDt","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"kcXcW":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getFeaturesForApp", ()=>getFeaturesForApp);
parcelHelpers.export(exports, "getApplicationFeature", ()=>getApplicationFeature);
parcelHelpers.export(exports, "getSystemFeatures", ()=>getSystemFeatures);
parcelHelpers.export(exports, "addFeature", ()=>addFeature);
parcelHelpers.export(exports, "getFeatureTypes", ()=>getFeatureTypes);
parcelHelpers.export(exports, "disableApplicationFeature", ()=>disableApplicationFeature);
parcelHelpers.export(exports, "updateApplicationFeature", ()=>updateApplicationFeature);
parcelHelpers.export(exports, "getAppFeatureConversationCount", ()=>getAppFeatureConversationCount);
parcelHelpers.export(exports, "setFeatureOrder", ()=>setFeatureOrder);
parcelHelpers.export(exports, "setFeatureContentItemsOrder", ()=>setFeatureContentItemsOrder);
parcelHelpers.export(exports, "changeFeatureModule", ()=>changeFeatureModule);
parcelHelpers.export(exports, "getApplicationFeatureWebhooks", ()=>getApplicationFeatureWebhooks);
parcelHelpers.export(exports, "removeApplicationFeatureWebhook", ()=>removeApplicationFeatureWebhook);
parcelHelpers.export(exports, "addApplicationFeatureWebhook", ()=>addApplicationFeatureWebhook);
parcelHelpers.export(exports, "updateApplicationFeatureWebhook", ()=>updateApplicationFeatureWebhook);
parcelHelpers.export(exports, "getContentItemsForFeature", ()=>getContentItemsForFeature);
parcelHelpers.export(exports, "bulkUpdateFeatureWebhookInstances", ()=>bulkUpdateFeatureWebhookInstances);
parcelHelpers.export(exports, "getApplicationFeaturePublishHistory", ()=>getApplicationFeaturePublishHistory);
var _urls = require("../../constants/Urls");
var _generic = require("./generic");
const getFeaturesForApp = (applicationId)=>{
    return (0, _generic.sendGet)(`${(0, _urls.GET_FEATURES)}/${applicationId}/features`);
};
const getApplicationFeature = (appFeatureId)=>{
    return (0, _generic.sendGet)(`${(0, _urls.GET_FEATURES)}/${appFeatureId}`);
};
const getSystemFeatures = ()=>{
    return (0, _generic.sendGet)((0, _urls.GET_SYSTEM_FEATURES));
};
const addFeature = (applicationId, request)=>{
    return (0, _generic.sendPost)(`/feature/${applicationId}/AddFeature`, request);
};
const getFeatureTypes = ()=>{
    return (0, _generic.sendGet)("/Feature/types");
};
const disableApplicationFeature = (applicationFeatureId)=>{
    return (0, _generic.sendDelete)(`/Feature/${applicationFeatureId}/disable`);
};
const updateApplicationFeature = (applicationFeatureId, model)=>{
    return (0, _generic.sendPut)(`/Feature/${applicationFeatureId}/update`, model);
};
const getAppFeatureConversationCount = (applicationId)=>{
    return (0, _generic.sendGet)(`/Feature/${applicationId}/features/conversationCounts`);
};
const setFeatureOrder = (applicationId, parentApplicationFeatureId, applicationFeatureIds)=>{
    return (0, _generic.sendPut)(`/Feature/${applicationId}/reorderFeatures?parentApplicationFeatureId=${parentApplicationFeatureId ? parentApplicationFeatureId : ""}`, applicationFeatureIds);
};
const setFeatureContentItemsOrder = (applicationFeatureId, contentItems)=>{
    return (0, _generic.sendPut)(`/Feature/${applicationFeatureId}/reorderContentItems`, contentItems);
};
const changeFeatureModule = (applicationFeatureId, applicationModuleId)=>{
    return (0, _generic.sendPut)(`/Feature/${applicationFeatureId}/changeModule/${applicationModuleId}`, {});
};
const getApplicationFeatureWebhooks = (applicationFeatureId)=>{
    return (0, _generic.sendGet)(`/Feature/${applicationFeatureId}/webhooks`);
};
const removeApplicationFeatureWebhook = (applicationFeatureWebhookId)=>{
    return (0, _generic.sendDelete)(`/Feature/webhook/${applicationFeatureWebhookId}`);
};
const addApplicationFeatureWebhook = (applicationFeatureId, webhookId, string, defaultParameters, userDefinedParameters)=>{
    return (0, _generic.sendPost)(`/Feature/${applicationFeatureId}/webhooks/${webhookId}`, {
        values: defaultParameters,
        userDefinedParameters: userDefinedParameters
    });
};
const updateApplicationFeatureWebhook = (applicationFeatureId, webhookInstanceId, defaultParameters, userDefinedParameters)=>{
    return (0, _generic.sendPut)(`/Feature/${applicationFeatureId}/webhooks/${webhookInstanceId}`, {
        values: defaultParameters,
        userDefinedParameters: userDefinedParameters
    });
};
const getContentItemsForFeature = (applicationFeatureId)=>{
    return (0, _generic.sendGet)(`/Feature/${applicationFeatureId}/content`);
};
const bulkUpdateFeatureWebhookInstances = (appFeatureId, updateRequest)=>{
    return (0, _generic.sendPut)(`/Feature/${appFeatureId}/webhooks/bulk`, updateRequest);
};
const getApplicationFeaturePublishHistory = (applicationFeatureId, environmentId, conversationItemHistorySkip, conversationItemHistoryTake)=>{
    return (0, _generic.sendGet)(`/Feature/${applicationFeatureId}/publishes/forEnvironment/${environmentId}?conversationItemHistorySkip=${conversationItemHistorySkip}&conversationItemHistoryTake=${conversationItemHistoryTake}`);
};

},{"../../constants/Urls":"iTopY","./generic":"6oGDt","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6YWT2":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getWelcomeMessagesForApp", ()=>getWelcomeMessagesForApp);
parcelHelpers.export(exports, "getWelcomeMessagesForAppFeature", ()=>getWelcomeMessagesForAppFeature);
parcelHelpers.export(exports, "addWelcomeMessage", ()=>addWelcomeMessage);
parcelHelpers.export(exports, "addFullWelcomeMessage", ()=>addFullWelcomeMessage);
parcelHelpers.export(exports, "toggleWelcomeMessageLive", ()=>toggleWelcomeMessageLive);
parcelHelpers.export(exports, "toggleWelcomeMessageSync", ()=>toggleWelcomeMessageSync);
parcelHelpers.export(exports, "updateWelcomeMessage", ()=>updateWelcomeMessage);
parcelHelpers.export(exports, "updateFullWelcomeMessage", ()=>updateFullWelcomeMessage);
parcelHelpers.export(exports, "deleteWelcomeMessage", ()=>deleteWelcomeMessage);
parcelHelpers.export(exports, "findWelcomeMessage", ()=>findWelcomeMessage);
parcelHelpers.export(exports, "getWelcomeMessageWebhooks", ()=>getWelcomeMessageWebhooks);
parcelHelpers.export(exports, "removeWelcomeMessageWebhook", ()=>removeWelcomeMessageWebhook);
parcelHelpers.export(exports, "addWelcomeMessageWebhook", ()=>addWelcomeMessageWebhook);
parcelHelpers.export(exports, "updateWelcomeMessageWebhook", ()=>updateWelcomeMessageWebhook);
parcelHelpers.export(exports, "copyWelcomeMessage", ()=>copyWelcomeMessage);
parcelHelpers.export(exports, "bulkUpdateWelcomeMessageWebhookInstances", ()=>bulkUpdateWelcomeMessageWebhookInstances);
parcelHelpers.export(exports, "getWelcomeMessagePublishHistory", ()=>getWelcomeMessagePublishHistory);
var _urls = require("../../constants/Urls");
var _generic = require("./generic");
const getWelcomeMessagesForApp = (applicationId)=>{
    return (0, _generic.sendGet)(`${(0, _urls.GET_WELCOMEMESSAGES)}/${applicationId}`);
};
const getWelcomeMessagesForAppFeature = (applicationFeatureId)=>{
    return (0, _generic.sendGet)(`${(0, _urls.GET_WELCOMEMESSAGES)}/byFeature/${applicationFeatureId}`);
};
function addWelcomeMessage(applicationId, model) {
    return (0, _generic.sendPost)(`${(0, _urls.ADD_WELCOMEMESSAGE)}/${applicationId}`, model);
}
function addFullWelcomeMessage(model) {
    return (0, _generic.sendPost)(`${(0, _urls.ADD_WELCOMEMESSAGE)}/full`, model);
}
const toggleWelcomeMessageLive = (welcomeMessageId, isLive)=>{
    return (0, _generic.sendPut)(`/WelcomeMessage/${welcomeMessageId}/isLive`, {
        isLive
    });
};
const toggleWelcomeMessageSync = (welcomeMessageId, shouldNotSync)=>{
    return (0, _generic.sendPut)(`/WelcomeMessage/${welcomeMessageId}/shouldNotSync`, {
        shouldNotSync
    });
};
const updateWelcomeMessage = (welcomeMessageId, model)=>{
    return (0, _generic.sendPut)(`/WelcomeMessage/${welcomeMessageId}/update`, model);
};
const updateFullWelcomeMessage = (welcomeMessageId, model)=>{
    return (0, _generic.sendPut)(`/WelcomeMessage/${welcomeMessageId}/full`, model);
};
const deleteWelcomeMessage = (welcomeMessageId)=>{
    return (0, _generic.sendDelete)(`/WelcomeMessage/${welcomeMessageId}`);
};
const findWelcomeMessage = (welcomeMessageId)=>{
    return (0, _generic.sendGet)(`/WelcomeMessage/full/${welcomeMessageId}`);
};
const getWelcomeMessageWebhooks = (welcomeMessageId)=>{
    return (0, _generic.sendGet)(`/WelcomeMessage/${welcomeMessageId}/webhooks`);
};
const removeWelcomeMessageWebhook = (welcomeMessageWebhookId)=>{
    return (0, _generic.sendDelete)(`/WelcomeMessage/webhook/${welcomeMessageWebhookId}`);
};
const addWelcomeMessageWebhook = (welcomeMessageId, webhookId, defaultParameters, userDefinedParameters)=>{
    return (0, _generic.sendPost)(`/WelcomeMessage/${welcomeMessageId}/webhooks/${webhookId}`, {
        values: defaultParameters,
        userDefinedParameters: userDefinedParameters
    });
};
const updateWelcomeMessageWebhook = (welcomeMessageId, webhookInstanceId, defaultParameters, userDefinedParameters)=>{
    return (0, _generic.sendPut)(`/WelcomeMessage/${welcomeMessageId}/webhooks/${webhookInstanceId}`, {
        values: defaultParameters,
        userDefinedParameters: userDefinedParameters
    });
};
const copyWelcomeMessage = (contentItemId)=>{
    return (0, _generic.sendPost)(`/WelcomeMessage/${contentItemId}/copy`, null);
};
const bulkUpdateWelcomeMessageWebhookInstances = (contentItemId, updateRequest)=>{
    return (0, _generic.sendPut)(`/WelcomeMessage/${contentItemId}/webhooks/bulk`, updateRequest);
};
const getWelcomeMessagePublishHistory = (contentItemId, environmentId, skip, take)=>{
    return (0, _generic.sendGet)(`/WelcomeMessage/${contentItemId}/publishes/forenvironment/${environmentId}?skip=${skip}&take=${take}`);
};

},{"../../constants/Urls":"iTopY","./generic":"6oGDt","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"bmhKU":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getExitMessagesForApp", ()=>getExitMessagesForApp);
parcelHelpers.export(exports, "getExitMessagesForAppFeature", ()=>getExitMessagesForAppFeature);
parcelHelpers.export(exports, "addFullExitMessage", ()=>addFullExitMessage);
parcelHelpers.export(exports, "addExitMessage", ()=>addExitMessage);
parcelHelpers.export(exports, "toggleExitMessageLive", ()=>toggleExitMessageLive);
parcelHelpers.export(exports, "toggleExitMessageSync", ()=>toggleExitMessageSync);
parcelHelpers.export(exports, "updateFullExitMessage", ()=>updateFullExitMessage);
parcelHelpers.export(exports, "updateExitMessage", ()=>updateExitMessage);
parcelHelpers.export(exports, "deleteExitMessage", ()=>deleteExitMessage);
parcelHelpers.export(exports, "findExitMessage", ()=>findExitMessage);
parcelHelpers.export(exports, "getExitMessageWebhooks", ()=>getExitMessageWebhooks);
parcelHelpers.export(exports, "removeExitMessageWebhook", ()=>removeExitMessageWebhook);
parcelHelpers.export(exports, "addExitMessageWebhook", ()=>addExitMessageWebhook);
parcelHelpers.export(exports, "updateExitMessageWebhook", ()=>updateExitMessageWebhook);
parcelHelpers.export(exports, "copyExistMessage", ()=>copyExistMessage);
parcelHelpers.export(exports, "bulkUpdateExitMessageWebhookInstances", ()=>bulkUpdateExitMessageWebhookInstances);
parcelHelpers.export(exports, "getExitMessagePublishHistory", ()=>getExitMessagePublishHistory);
var _urls = require("../../constants/Urls");
var _generic = require("./generic");
const getExitMessagesForApp = (applicationId)=>{
    return (0, _generic.sendGet)(`${(0, _urls.GET_EXITMESSAGES)}/${applicationId}`);
};
const getExitMessagesForAppFeature = (applicationFeatureId)=>{
    return (0, _generic.sendGet)(`${(0, _urls.GET_EXITMESSAGES)}/byFeature/${applicationFeatureId}`);
};
const addFullExitMessage = (model)=>{
    return (0, _generic.sendPost)(`${(0, _urls.ADD_EXITMESSAGES)}/full`, model);
};
const addExitMessage = (applicationId, model)=>{
    return (0, _generic.sendPost)(`${(0, _urls.ADD_EXITMESSAGES)}/${applicationId}`, model);
};
const toggleExitMessageLive = (exitMessageId, isLive)=>{
    return (0, _generic.sendPut)(`/ExitMessage/${exitMessageId}/isLive`, {
        isLive
    });
};
const toggleExitMessageSync = (exitMessageId, shouldNotSync)=>{
    return (0, _generic.sendPut)(`/ExitMessage/${exitMessageId}/shouldNotSync`, {
        shouldNotSync
    });
};
const updateFullExitMessage = (exitMessageId, model)=>{
    return (0, _generic.sendPut)(`/ExitMessage/${exitMessageId}/full`, model);
};
const updateExitMessage = (exitMessageId, model)=>{
    return (0, _generic.sendPut)(`/ExitMessage/${exitMessageId}/update`, model);
};
const deleteExitMessage = (exitMessageId)=>{
    return (0, _generic.sendDelete)(`/ExitMessage/${exitMessageId}`);
};
const findExitMessage = (exitMessageId)=>{
    return (0, _generic.sendGet)(`/ExitMessage/full/${exitMessageId}`);
};
const getExitMessageWebhooks = (exitMessageId)=>{
    return (0, _generic.sendGet)(`/ExitMessage/${exitMessageId}/webhooks`);
};
const removeExitMessageWebhook = (exitMessageWebhookId)=>{
    return (0, _generic.sendDelete)(`/ExitMessage/webhook/${exitMessageWebhookId}`);
};
const addExitMessageWebhook = (exitMessageId, webhookId, defaultParameters, userDefinedParameters)=>{
    return (0, _generic.sendPost)(`/ExitMessage/${exitMessageId}/webhooks/${webhookId}`, {
        values: defaultParameters,
        userDefinedParameters: userDefinedParameters
    });
};
const updateExitMessageWebhook = (exitMessageId, webhookInstanceId, defaultParameters, userDefinedParameters)=>{
    return (0, _generic.sendPut)(`/ExitMessage/${exitMessageId}/webhooks/${webhookInstanceId}`, {
        values: defaultParameters,
        userDefinedParameters: userDefinedParameters
    });
};
const copyExistMessage = (contentItemId)=>{
    return (0, _generic.sendPost)(`/ExitMessage/${contentItemId}/copy`, null);
};
const bulkUpdateExitMessageWebhookInstances = (contentItemId, updateRequest)=>{
    return (0, _generic.sendPut)(`/ExitMessage/${contentItemId}/webhooks/bulk`, updateRequest);
};
const getExitMessagePublishHistory = (contentItemId, environmentId, skip, take)=>{
    return (0, _generic.sendGet)(`/ExitMessage/${contentItemId}/publishes/forenvironment/${environmentId}?skip=${skip}&take=${take}`);
};

},{"../../constants/Urls":"iTopY","./generic":"6oGDt","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3TIoF":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getHelpMessagesForApp", ()=>getHelpMessagesForApp);
parcelHelpers.export(exports, "getHelpMessagesForAppFeature", ()=>getHelpMessagesForAppFeature);
parcelHelpers.export(exports, "addHelpMessage", ()=>addHelpMessage);
parcelHelpers.export(exports, "addFullHelpMessage", ()=>addFullHelpMessage);
parcelHelpers.export(exports, "addHelpMessageStub", ()=>addHelpMessageStub);
parcelHelpers.export(exports, "toggleHelpMessageLive", ()=>toggleHelpMessageLive);
parcelHelpers.export(exports, "toggleHelpMessageSync", ()=>toggleHelpMessageSync);
parcelHelpers.export(exports, "updateFullHelpMessage", ()=>updateFullHelpMessage);
parcelHelpers.export(exports, "updateHelpMessage", ()=>updateHelpMessage);
parcelHelpers.export(exports, "updateHelpMessageStub", ()=>updateHelpMessageStub);
parcelHelpers.export(exports, "deleteHelpMessage", ()=>deleteHelpMessage);
parcelHelpers.export(exports, "findHelpMessage", ()=>findHelpMessage);
parcelHelpers.export(exports, "getHelpMessageWebhooks", ()=>getHelpMessageWebhooks);
parcelHelpers.export(exports, "removeHelpMessageWebhook", ()=>removeHelpMessageWebhook);
parcelHelpers.export(exports, "addHelpMessageWebhook", ()=>addHelpMessageWebhook);
parcelHelpers.export(exports, "updateHelpMessageWebhook", ()=>updateHelpMessageWebhook);
parcelHelpers.export(exports, "copyHelpMessage", ()=>copyHelpMessage);
parcelHelpers.export(exports, "bulkUpdateHelpMessageWebhookInstances", ()=>bulkUpdateHelpMessageWebhookInstances);
parcelHelpers.export(exports, "getHelpMessagePublishHistory", ()=>getHelpMessagePublishHistory);
var _urls = require("../../constants/Urls");
var _generic = require("./generic");
const getHelpMessagesForApp = (applicationId)=>{
    return (0, _generic.sendGet)(`${(0, _urls.GET_HELPMESSAGES)}/${applicationId}`);
};
const getHelpMessagesForAppFeature = (applicationFeatureId)=>{
    return (0, _generic.sendGet)(`${(0, _urls.GET_HELPMESSAGES)}/byFeature/${applicationFeatureId}`);
};
const addHelpMessage = (applicationId, model)=>{
    return (0, _generic.sendPost)(`${(0, _urls.ADD_HELPMESSAGE)}/${applicationId}`, model);
};
const addFullHelpMessage = (model)=>{
    return (0, _generic.sendPost)(`${(0, _urls.ADD_HELPMESSAGE)}/full`, model);
};
const addHelpMessageStub = (model)=>{
    return (0, _generic.sendPost)(`${(0, _urls.ADD_HELPMESSAGE)}/${model.applicationId}/stub`, model);
};
const toggleHelpMessageLive = (helpMessageId, isLive)=>{
    return (0, _generic.sendPut)(`/HelpMessage/${helpMessageId}/isLive`, {
        isLive
    });
};
const toggleHelpMessageSync = (helpMessageId, shouldNotSync)=>{
    return (0, _generic.sendPut)(`/HelpMessage/${helpMessageId}/shouldNotSync`, {
        shouldNotSync
    });
};
const updateFullHelpMessage = (helpMessageId, model)=>{
    return (0, _generic.sendPut)(`/HelpMessage/${helpMessageId}/full`, model);
};
const updateHelpMessage = (helpMessageId, model)=>{
    return (0, _generic.sendPut)(`/HelpMessage/${helpMessageId}/update`, model);
};
const updateHelpMessageStub = (helpMessageId, model)=>{
    return (0, _generic.sendPut)(`/HelpMessage/${helpMessageId}/update/stub`, model);
};
const deleteHelpMessage = (helpMessageId)=>{
    return (0, _generic.sendDelete)(`/HelpMessage/${helpMessageId}`);
};
const findHelpMessage = (helpMessageId)=>{
    return (0, _generic.sendGet)(`/HelpMessage/full/${helpMessageId}`);
};
const getHelpMessageWebhooks = (helpMessageId)=>{
    return (0, _generic.sendGet)(`/HelpMessage/${helpMessageId}/webhooks`);
};
const removeHelpMessageWebhook = (helpMessageWebhookId)=>{
    return (0, _generic.sendDelete)(`/HelpMessage/webhook/${helpMessageWebhookId}`);
};
const addHelpMessageWebhook = (helpMessageId, webhookId, defaultParameters, userDefinedParameters)=>{
    return (0, _generic.sendPost)(`/HelpMessage/${helpMessageId}/webhooks/${webhookId}`, {
        values: defaultParameters,
        userDefinedParameters: userDefinedParameters
    });
};
const updateHelpMessageWebhook = (helpMessageId, webhookInstanceId, defaultParameters, userDefinedParameters)=>{
    return (0, _generic.sendPut)(`/HelpMessage/${helpMessageId}/webhooks/${webhookInstanceId}`, {
        values: defaultParameters,
        userDefinedParameters: userDefinedParameters
    });
};
const copyHelpMessage = (contentItemId)=>{
    return (0, _generic.sendPost)(`/HelpMessage/${contentItemId}/copy`, null);
};
const bulkUpdateHelpMessageWebhookInstances = (contentItemId, updateRequest)=>{
    return (0, _generic.sendPut)(`/HelpMessage/${contentItemId}/webhooks/bulk`, updateRequest);
};
const getHelpMessagePublishHistory = (contentItemId, environmentId, skip, take)=>{
    return (0, _generic.sendGet)(`/HelpMessage/${contentItemId}/publishes/forenvironment/${environmentId}?skip=${skip}&take=${take}`);
};

},{"../../constants/Urls":"iTopY","./generic":"6oGDt","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"lYc3g":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createQuestionAnswer", ()=>createQuestionAnswer);
parcelHelpers.export(exports, "createFullQuestionAnswer", ()=>createFullQuestionAnswer);
parcelHelpers.export(exports, "createQuestionAnswerStub", ()=>createQuestionAnswerStub);
parcelHelpers.export(exports, "toggleQuestionAnswerLive", ()=>toggleQuestionAnswerLive);
parcelHelpers.export(exports, "toggleQuestionAnswerSync", ()=>toggleQuestionAnswerSync);
parcelHelpers.export(exports, "getQuestionAnswersForApp", ()=>getQuestionAnswersForApp);
parcelHelpers.export(exports, "getQuestionAnswersForAppFeature", ()=>getQuestionAnswersForAppFeature);
parcelHelpers.export(exports, "updateFullQuestionAnswer", ()=>updateFullQuestionAnswer);
parcelHelpers.export(exports, "bulkUpdateQuestionAnswer", ()=>bulkUpdateQuestionAnswer);
parcelHelpers.export(exports, "bulkUpdateQuestionAnswerStub", ()=>bulkUpdateQuestionAnswerStub);
parcelHelpers.export(exports, "deleteQuestionAnswer", ()=>deleteQuestionAnswer);
parcelHelpers.export(exports, "copyQuestionAnswer", ()=>copyQuestionAnswer);
parcelHelpers.export(exports, "findQuestionAnswer", ()=>findQuestionAnswer);
parcelHelpers.export(exports, "getQuestionAnswerWebhooks", ()=>getQuestionAnswerWebhooks);
parcelHelpers.export(exports, "removeQuestionAnswerWebhook", ()=>removeQuestionAnswerWebhook);
parcelHelpers.export(exports, "addQuestionAnswerWebhook", ()=>addQuestionAnswerWebhook);
parcelHelpers.export(exports, "updateQuestionAnswerWebhook", ()=>updateQuestionAnswerWebhook);
parcelHelpers.export(exports, "bulkUpdateQuestionAnswerWebhookInstances", ()=>bulkUpdateQuestionAnswerWebhookInstances);
parcelHelpers.export(exports, "getQuestionAnswerPublishHistory", ()=>getQuestionAnswerPublishHistory);
var _urls = require("../../constants/Urls");
var _generic = require("./generic");
const createQuestionAnswer = (request)=>{
    return (0, _generic.sendPost)((0, _urls.ADD_QUESTIONANSWER), request);
};
const createFullQuestionAnswer = (model)=>{
    return (0, _generic.sendPost)(`${(0, _urls.ADD_QUESTIONANSWER)}/full`, model);
};
const createQuestionAnswerStub = (request)=>{
    return (0, _generic.sendPost)(`${(0, _urls.ADD_QUESTIONANSWER)}/stub`, request);
};
const toggleQuestionAnswerLive = (questionAnswerId, isLive)=>{
    return (0, _generic.sendPut)(`/QuestionAnswer/${questionAnswerId}/isLive`, {
        isLive
    });
};
const toggleQuestionAnswerSync = (questionAnswerId, shouldNotSync)=>{
    return (0, _generic.sendPut)(`/QuestionAnswer/${questionAnswerId}/shouldNotSync`, {
        shouldNotSync
    });
};
const getQuestionAnswersForApp = (applicationId)=>{
    return (0, _generic.sendGet)(`${(0, _urls.GET_QUESTIONANSWER)}/${applicationId}/faqs`);
};
const getQuestionAnswersForAppFeature = (applicationFeatureId)=>{
    return (0, _generic.sendGet)(`${(0, _urls.GET_QUESTIONANSWER)}/byFeature/${applicationFeatureId}`);
};
const updateFullQuestionAnswer = (questionAnswerId, model)=>{
    return (0, _generic.sendPut)(`/QuestionAnswer/${questionAnswerId}/full`, model);
};
const bulkUpdateQuestionAnswer = (questionAnswerId, model)=>{
    return (0, _generic.sendPut)(`/QuestionAnswer/${questionAnswerId}/bulkUpdate`, model);
};
const bulkUpdateQuestionAnswerStub = (questionAnswerId, model)=>{
    return (0, _generic.sendPut)(`/QuestionAnswer/${questionAnswerId}/bulkUpdate/stub`, model);
};
const deleteQuestionAnswer = (questionAnswerId)=>{
    return (0, _generic.sendDelete)(`/QuestionAnswer/${questionAnswerId}`);
};
const copyQuestionAnswer = (questionAnswerId)=>{
    return (0, _generic.sendPost)(`/QuestionAnswer/${questionAnswerId}/copy`, null);
};
const findQuestionAnswer = (questionAnswerId)=>{
    return (0, _generic.sendGet)(`/QuestionAnswer/full/${questionAnswerId}`);
};
const getQuestionAnswerWebhooks = (questionAnswerId)=>{
    return (0, _generic.sendGet)(`/QuestionAnswer/${questionAnswerId}/webhooks`);
};
const removeQuestionAnswerWebhook = (questionAnswerWebhookId)=>{
    return (0, _generic.sendDelete)(`/QuestionAnswer/webhook/${questionAnswerWebhookId}`);
};
const addQuestionAnswerWebhook = (questionAnswerId, webhookId, defaultParameters, userDefinedParameters)=>{
    return (0, _generic.sendPost)(`/QuestionAnswer/${questionAnswerId}/webhooks/${webhookId}`, {
        values: defaultParameters,
        userDefinedParameters: userDefinedParameters
    });
};
const updateQuestionAnswerWebhook = (questionAnswerId, webhookInstanceId, defaultParameters, userDefinedParameters)=>{
    return (0, _generic.sendPut)(`/QuestionAnswer/${questionAnswerId}/webhooks/${webhookInstanceId}`, {
        values: defaultParameters,
        userDefinedParameters: userDefinedParameters
    });
};
const bulkUpdateQuestionAnswerWebhookInstances = (contentItemId, updateRequest)=>{
    return (0, _generic.sendPut)(`/QuestionAnswer/${contentItemId}/webhooks/bulk`, updateRequest);
};
const getQuestionAnswerPublishHistory = (contentItemId, environmentId, skip, take)=>{
    return (0, _generic.sendGet)(`/QuestionAnswer/${contentItemId}/publishes/forenvironment/${environmentId}?skip=${skip}&take=${take}`);
};

},{"../../constants/Urls":"iTopY","./generic":"6oGDt","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"e19Ul":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getModulesForApp", ()=>getModulesForApp);
parcelHelpers.export(exports, "addModulesToApp", ()=>addModulesToApp);
parcelHelpers.export(exports, "updateApplicationModule", ()=>updateApplicationModule);
parcelHelpers.export(exports, "disableApplicationModule", ()=>disableApplicationModule);
parcelHelpers.export(exports, "setModuleOrder", ()=>setModuleOrder);
var _generic = require("./generic");
const getModulesForApp = (applicationId)=>{
    return (0, _generic.sendGet)(`/Module/${applicationId}`);
};
const addModulesToApp = (applicationId, modules)=>{
    return (0, _generic.sendPut)(`/Module/addCustomModules/${applicationId}`, modules);
};
const updateApplicationModule = (applicationModuleId, name)=>{
    return (0, _generic.sendPut)(`/Module/${applicationModuleId}/update`, {
        name
    });
};
const disableApplicationModule = (applicationModuleId)=>{
    return (0, _generic.sendDelete)(`/Module/${applicationModuleId}/disable`);
};
const setModuleOrder = (applicationId, applicationModuleIds)=>{
    return (0, _generic.sendPut)(`/Module/reorderModules/${applicationId}`, applicationModuleIds);
};

},{"./generic":"6oGDt","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3Av1r":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getLatestMessagesForModule", ()=>getLatestMessagesForModule);
parcelHelpers.export(exports, "getLatestMessagesForApp", ()=>getLatestMessagesForApp);
parcelHelpers.export(exports, "getLatestMessagesForAppFeature", ()=>getLatestMessagesForAppFeature);
parcelHelpers.export(exports, "createFullLatestMessage", ()=>createFullLatestMessage);
parcelHelpers.export(exports, "createLatestMessage", ()=>createLatestMessage);
parcelHelpers.export(exports, "createLatestMessageStub", ()=>createLatestMessageStub);
parcelHelpers.export(exports, "toggleLatestMessageLive", ()=>toggleLatestMessageLive);
parcelHelpers.export(exports, "toggleLatestMessageSync", ()=>toggleLatestMessageSync);
parcelHelpers.export(exports, "updateFullLatestMessage", ()=>updateFullLatestMessage);
parcelHelpers.export(exports, "bulkUpdateLatestMessage", ()=>bulkUpdateLatestMessage);
parcelHelpers.export(exports, "bulkUpdateLatestMessageStub", ()=>bulkUpdateLatestMessageStub);
parcelHelpers.export(exports, "deleteLatestMessage", ()=>deleteLatestMessage);
parcelHelpers.export(exports, "findLatestMessage", ()=>findLatestMessage);
parcelHelpers.export(exports, "getLatestMessageWebhooks", ()=>getLatestMessageWebhooks);
parcelHelpers.export(exports, "removeLatestMessageWebhook", ()=>removeLatestMessageWebhook);
parcelHelpers.export(exports, "addLatestMessageWebhook", ()=>addLatestMessageWebhook);
parcelHelpers.export(exports, "updateLatestMessageWebhook", ()=>updateLatestMessageWebhook);
parcelHelpers.export(exports, "copyLatestMessage", ()=>copyLatestMessage);
parcelHelpers.export(exports, "bulkUpdateLatestMessageWebhookInstances", ()=>bulkUpdateLatestMessageWebhookInstances);
parcelHelpers.export(exports, "getLatestMessagePublishHistory", ()=>getLatestMessagePublishHistory);
var _urls = require("../../constants/Urls");
var _generic = require("./generic");
const getLatestMessagesForModule = (applicationModuleId)=>{
    return (0, _generic.sendGet)(`${(0, _urls.GET_LATESTMESSAGES_FOR_MODULE)}/${applicationModuleId}`);
};
const getLatestMessagesForApp = (applicationId)=>{
    return (0, _generic.sendGet)(`${(0, _urls.GET_LATESTMESSAGES)}/${applicationId}`);
};
const getLatestMessagesForAppFeature = (applicationFeatureId)=>{
    return (0, _generic.sendGet)(`${(0, _urls.GET_LATESTMESSAGES)}/byFeature/${applicationFeatureId}`);
};
const createFullLatestMessage = (request)=>{
    return (0, _generic.sendPost)(`${(0, _urls.CREATE_LATESTMESSAGE)}/full`, request);
};
const createLatestMessage = (request)=>{
    return (0, _generic.sendPost)(`${(0, _urls.CREATE_LATESTMESSAGE)}`, request);
};
const createLatestMessageStub = (request)=>{
    return (0, _generic.sendPost)(`${(0, _urls.CREATE_LATESTMESSAGE)}/stub`, request);
};
const toggleLatestMessageLive = (latestMessageId, isLive)=>{
    return (0, _generic.sendPut)(`/LatestMessage/${latestMessageId}/isLive`, {
        isLive
    });
};
const toggleLatestMessageSync = (latestMessageId, shouldNotSync)=>{
    return (0, _generic.sendPut)(`/LatestMessage/${latestMessageId}/shouldNotSync`, {
        shouldNotSync
    });
};
const updateFullLatestMessage = (latestMessageId, request)=>{
    return (0, _generic.sendPut)(`/LatestMessage/${latestMessageId}/full`, request);
};
const bulkUpdateLatestMessage = (latestMessageId, request)=>{
    return (0, _generic.sendPut)(`/LatestMessage/${latestMessageId}/bulkUpdate`, request);
};
const bulkUpdateLatestMessageStub = (latestMessageId, request)=>{
    return (0, _generic.sendPut)(`/LatestMessage/${latestMessageId}/bulkUpdate/stub`, request);
};
const deleteLatestMessage = (latestMessageId)=>{
    return (0, _generic.sendDelete)(`/LatestMessage/${latestMessageId}`);
};
const findLatestMessage = (latestMessageId)=>{
    return (0, _generic.sendGet)(`/LatestMessage/full/${latestMessageId}`);
};
const getLatestMessageWebhooks = (latestMessageId)=>{
    return (0, _generic.sendGet)(`/LatestMessage/${latestMessageId}/webhooks`);
};
const removeLatestMessageWebhook = (latestMessageWebhookId)=>{
    return (0, _generic.sendDelete)(`/LatestMessage/webhook/${latestMessageWebhookId}`);
};
const addLatestMessageWebhook = (latestMessageId, webhookId, defaultParameters, userDefinedParameters)=>{
    return (0, _generic.sendPost)(`/LatestMessage/${latestMessageId}/webhooks/${webhookId}`, {
        values: defaultParameters,
        userDefinedParameters: userDefinedParameters
    });
};
const updateLatestMessageWebhook = (latestMessageId, webhookInstanceId, defaultParameters, userDefinedParameters)=>{
    return (0, _generic.sendPut)(`/LatestMessage/${latestMessageId}/webhooks/${webhookInstanceId}`, {
        values: defaultParameters,
        userDefinedParameters: userDefinedParameters
    });
};
const copyLatestMessage = (contentItemId)=>{
    return (0, _generic.sendPost)(`/LatestMessage/${contentItemId}/copy`, null);
};
const bulkUpdateLatestMessageWebhookInstances = (contentItemId, updateRequest)=>{
    return (0, _generic.sendPut)(`/LatestMessage/${contentItemId}/webhooks/bulk`, updateRequest);
};
const getLatestMessagePublishHistory = (contentItemId, environmentId, skip, take)=>{
    return (0, _generic.sendGet)(`/LatestMessage/${contentItemId}/publishes/forenvironment/${environmentId}?skip=${skip}&take=${take}`);
};

},{"../../constants/Urls":"iTopY","./generic":"6oGDt","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"kG7ZZ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "acceptInvitation", ()=>acceptInvitation);
parcelHelpers.export(exports, "sendInvitation", ()=>sendInvitation);
parcelHelpers.export(exports, "sendSparkFormInvitation", ()=>sendSparkFormInvitation);
parcelHelpers.export(exports, "getInvitations", ()=>getInvitations);
parcelHelpers.export(exports, "revokeInvitation", ()=>revokeInvitation);
var _generic = require("./generic");
var _urls = require("../../constants/Urls");
const acceptInvitation = (invitationId)=>{
    return (0, _generic.sendPost)(`${(0, _urls.ACCEPT_INVITATION)}/${invitationId}`, null);
};
const sendInvitation = (organizationId, model)=>{
    return (0, _generic.sendPost)(`/invitation/${organizationId}`, model);
};
const sendSparkFormInvitation = (organizationId, model)=>{
    return (0, _generic.sendPost)(`/invitation/${organizationId}/sparkForm`, model);
};
const getInvitations = (organizationId)=>{
    return (0, _generic.sendGet)(`/invitation/${organizationId}`);
};
const revokeInvitation = (invitationId)=>{
    return (0, _generic.sendDelete)(`/invitation/${invitationId}`);
};

},{"./generic":"6oGDt","../../constants/Urls":"iTopY","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1HhkM":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createUser", ()=>createUser);
parcelHelpers.export(exports, "createApiUser", ()=>createApiUser);
parcelHelpers.export(exports, "requestPasswordReset", ()=>requestPasswordReset);
parcelHelpers.export(exports, "setPassword", ()=>setPassword);
parcelHelpers.export(exports, "getCurrentUser", ()=>getCurrentUser);
parcelHelpers.export(exports, "changePassword", ()=>changePassword);
parcelHelpers.export(exports, "checkIfUserUsesSso", ()=>checkIfUserUsesSso);
parcelHelpers.export(exports, "getCurrentUserTermsAgreement", ()=>getCurrentUserTermsAgreement);
parcelHelpers.export(exports, "updateUserDetails", ()=>updateUserDetails);
parcelHelpers.export(exports, "updateProfileImage", ()=>updateProfileImage);
parcelHelpers.export(exports, "getSystemUserRoles", ()=>getSystemUserRoles);
parcelHelpers.export(exports, "refreshReviewUser", ()=>refreshReviewUser);
var _generic = require("./generic");
var _urls = require("../../constants/Urls");
const createUser = (request)=>{
    return (0, _generic.sendPost)((0, _urls.CREATE_USER), request);
};
const createApiUser = (request)=>{
    return (0, _generic.sendPost)(`/User/ApiUser`, request);
};
const requestPasswordReset = (request)=>{
    return (0, _generic.sendPost)((0, _urls.RESET_PASSWORD), request);
};
const setPassword = (request)=>{
    return (0, _generic.sendPut)((0, _urls.SET_PASSWORD), request);
};
const getCurrentUser = ()=>{
    return (0, _generic.sendGet)((0, _urls.GET_CURRENT_USER));
};
const changePassword = (request)=>{
    return (0, _generic.sendPut)(`/User/ChangePassword`, request);
};
const checkIfUserUsesSso = (email)=>{
    return (0, _generic.sendGet)(`/User/useSso/${email}`);
};
const getCurrentUserTermsAgreement = ()=>{
    return (0, _generic.sendGet)((0, _urls.GET_USER_TERMS));
};
const updateUserDetails = (request)=>{
    return (0, _generic.sendPut)((0, _urls.UPDATE_USER_DETAILS), request);
};
const updateProfileImage = (file)=>{
    return (0, _generic.uploadFile)((0, _urls.UPDATE_USER_IMAGE), file);
};
const getSystemUserRoles = ()=>{
    return (0, _generic.sendGet)("/User/SystemRoles");
};
const refreshReviewUser = (request)=>{
    return (0, _generic.sendPost)("/User/RefreshReviewUser", request);
};

},{"./generic":"6oGDt","../../constants/Urls":"iTopY","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"XaqA6":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getMediaItemsForApplication", ()=>getMediaItemsForApplication);
parcelHelpers.export(exports, "getDisabledMediaItemsForApplication", ()=>getDisabledMediaItemsForApplication);
parcelHelpers.export(exports, "getContentItemsForMediaItem", ()=>getContentItemsForMediaItem);
parcelHelpers.export(exports, "disableMediaItem", ()=>disableMediaItem);
parcelHelpers.export(exports, "deleteMediaItem", ()=>deleteMediaItem);
parcelHelpers.export(exports, "uploadMediaItem", ()=>uploadMediaItem);
parcelHelpers.export(exports, "getUploadUrl", ()=>getUploadUrl);
parcelHelpers.export(exports, "getOrganizationUploadUrl", ()=>getOrganizationUploadUrl);
parcelHelpers.export(exports, "uploadDirect", ()=>uploadDirect);
parcelHelpers.export(exports, "updateMediaItem", ()=>updateMediaItem);
parcelHelpers.export(exports, "createMediaItem", ()=>createMediaItem);
parcelHelpers.export(exports, "convertAudioItemToSsml", ()=>convertAudioItemToSsml);
var _urls = require("../../constants/Urls");
var _generic = require("./generic");
const getMediaItemsForApplication = (applicationId)=>{
    return (0, _generic.sendGet)(`${(0, _urls.GET_MEDIAITEMS)}/${applicationId}`);
};
const getDisabledMediaItemsForApplication = (applicationId)=>{
    return (0, _generic.sendGet)(`${(0, _urls.GET_MEDIAITEMS)}/disabled/${applicationId}`);
};
const getContentItemsForMediaItem = (mediaItemId)=>{
    return (0, _generic.sendGet)(`${(0, _urls.MEDIAVERIFICATION)}/contentItems/${mediaItemId}`);
};
const disableMediaItem = (itemId)=>{
    return (0, _generic.sendDelete)(`${(0, _urls.GET_MEDIAITEMS)}/${itemId}/disable`);
};
const deleteMediaItem = (itemId)=>{
    return (0, _generic.sendDelete)(`${(0, _urls.GET_MEDIAITEMS)}/${itemId}`);
};
const uploadMediaItem = (applicationId, name, file)=>{
    return (0, _generic.uploadFile)(`${(0, _urls.GET_MEDIAITEMS)}/${applicationId}/upload?name=${escape(name)}`, file);
};
const getUploadUrl = (applicationId, fileName, displayName)=>{
    return (0, _generic.sendGet)(`${(0, _urls.GET_UPLOAD_URL)}/${applicationId}/uploadUrl?fileName=${escape(fileName)}&name=${escape(displayName)}`);
};
const getOrganizationUploadUrl = (organizationId, fileName, displayName)=>{
    return (0, _generic.sendGet)(`${(0, _urls.GET_UPLOAD_URL)}/${organizationId}/orgUploadUrl?fileName=${escape(fileName)}&name=${escape(displayName)}`);
};
const uploadDirect = (uploadUrl, file, progressCallback)=>{
    return (0, _generic.putFile)(uploadUrl, file, progressCallback);
};
const updateMediaItem = (mediaItemId, mediaItem)=>{
    return (0, _generic.sendPut)(`${(0, _urls.GET_UPLOAD_URL)}/${mediaItemId}`, mediaItem);
};
const createMediaItem = (applicationId, model)=>{
    return (0, _generic.sendPost)(`${(0, _urls.GET_MEDIAITEMS)}/${applicationId}`, model);
};
const convertAudioItemToSsml = (mediaItemId)=>{
    return (0, _generic.sendPost)(`/mediaitem/convert/ssml/${mediaItemId}`, "");
};

},{"../../constants/Urls":"iTopY","./generic":"6oGDt","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"bzTar":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getContentUserAggregateByAssistant", ()=>getContentUserAggregateByAssistant);
parcelHelpers.export(exports, "getContentUserAggregateByDeviceTarget", ()=>getContentUserAggregateByDeviceTarget);
parcelHelpers.export(exports, "getContentUserAggregateByInterfaceType", ()=>getContentUserAggregateByInterfaceType);
parcelHelpers.export(exports, "getContentUserAggregateByLanguage", ()=>getContentUserAggregateByLanguage);
parcelHelpers.export(exports, "getContentNewUserAggregateByAssistant", ()=>getContentNewUserAggregateByAssistant);
parcelHelpers.export(exports, "getContentNewUserAggregateByDeviceTarget", ()=>getContentNewUserAggregateByDeviceTarget);
parcelHelpers.export(exports, "getContentNewUserAggregateByInterfaceType", ()=>getContentNewUserAggregateByInterfaceType);
parcelHelpers.export(exports, "getContentNewUserAggregateByLanguage", ()=>getContentNewUserAggregateByLanguage);
parcelHelpers.export(exports, "getContentInteractionAggregateByAssistant", ()=>getContentInteractionAggregateByAssistant);
parcelHelpers.export(exports, "getContentInteractionAggregateByDeviceTarget", ()=>getContentInteractionAggregateByDeviceTarget);
parcelHelpers.export(exports, "getContentInteractionAggregateByInterfaceType", ()=>getContentInteractionAggregateByInterfaceType);
parcelHelpers.export(exports, "getContentInteractionAggregateByLanguage", ()=>getContentInteractionAggregateByLanguage);
parcelHelpers.export(exports, "getContentSessionAggregateByAssistant", ()=>getContentSessionAggregateByAssistant);
parcelHelpers.export(exports, "getContentSessionAggregateByDeviceTarget", ()=>getContentSessionAggregateByDeviceTarget);
parcelHelpers.export(exports, "getContentSessionAggregateByInterfaceType", ()=>getContentSessionAggregateByInterfaceType);
parcelHelpers.export(exports, "getContentSessionAggregateByLanguage", ()=>getContentSessionAggregateByLanguage);
parcelHelpers.export(exports, "getUserHistogramForContent", ()=>getUserHistogramForContent);
parcelHelpers.export(exports, "getNewUserHistogramForContent", ()=>getNewUserHistogramForContent);
parcelHelpers.export(exports, "getUsageHistogramForContent", ()=>getUsageHistogramForContent);
parcelHelpers.export(exports, "getSessionHistogramForContent", ()=>getSessionHistogramForContent);
parcelHelpers.export(exports, "getContentItemStats", ()=>getContentItemStats);
parcelHelpers.export(exports, "getContentItemSessionIds", ()=>getContentItemSessionIds);
var _generic = require("./generic");
var _urls = require("../../constants/Urls");
const getContentUserAggregateByAssistant = (applicationId, contentId, filter)=>aggregateRequest(applicationId, contentId, "users", "assistant", filter);
const getContentUserAggregateByDeviceTarget = (applicationId, contentId, filter)=>aggregateRequest(applicationId, contentId, "users", "deviceTarget", filter);
const getContentUserAggregateByInterfaceType = (applicationId, contentId, filter)=>aggregateRequest(applicationId, contentId, "users", "interfaceType", filter);
const getContentUserAggregateByLanguage = (applicationId, contentId, filter)=>aggregateRequest(applicationId, contentId, "users", "locale", filter);
const getContentNewUserAggregateByAssistant = (applicationId, contentId, filter)=>aggregateRequest(applicationId, contentId, "newUsers", "assistant", filter);
const getContentNewUserAggregateByDeviceTarget = (applicationId, contentId, filter)=>aggregateRequest(applicationId, contentId, "newUsers", "deviceTarget", filter);
const getContentNewUserAggregateByInterfaceType = (applicationId, contentId, filter)=>aggregateRequest(applicationId, contentId, "newUsers", "interfaceType", filter);
const getContentNewUserAggregateByLanguage = (applicationId, contentId, filter)=>aggregateRequest(applicationId, contentId, "newUsers", "locale", filter);
const getContentInteractionAggregateByAssistant = (applicationId, contentId, filter)=>aggregateRequest(applicationId, contentId, "interactions", "assistant", filter);
const getContentInteractionAggregateByDeviceTarget = (applicationId, contentId, filter)=>aggregateRequest(applicationId, contentId, "interactions", "deviceTarget", filter);
const getContentInteractionAggregateByInterfaceType = (applicationId, contentId, filter)=>aggregateRequest(applicationId, contentId, "interactions", "interfaceType", filter);
const getContentInteractionAggregateByLanguage = (applicationId, contentId, filter)=>aggregateRequest(applicationId, contentId, "interactions", "locale", filter);
const getContentSessionAggregateByAssistant = (applicationId, contentId, filter)=>aggregateRequest(applicationId, contentId, "sessions", "assistant", filter);
const getContentSessionAggregateByDeviceTarget = (applicationId, contentId, filter)=>aggregateRequest(applicationId, contentId, "sessions", "deviceTarget", filter);
const getContentSessionAggregateByInterfaceType = (applicationId, contentId, filter)=>aggregateRequest(applicationId, contentId, "sessions", "interfaceType", filter);
const getContentSessionAggregateByLanguage = (applicationId, contentId, filter)=>aggregateRequest(applicationId, contentId, "sessions", "locale", filter);
// abstract for halding api reqs for aggregated data
const aggregateRequest = (applicationId, contentId, type, aggkey, filter)=>(0, _generic.sendGet)(`/v2/content/${applicationId}/${contentId}/${type}/aggregation/${aggkey}?${buildQuery(filter)}`, (0, _urls.getAnalyticsApiUrl)());
const getUserHistogramForContent = (applicationId, contentId, interval, filter)=>histogramRequest(applicationId, contentId, "users", interval, filter);
const getNewUserHistogramForContent = (applicationId, contentId, interval, filter)=>histogramRequest(applicationId, contentId, "newusers", interval, filter);
const getUsageHistogramForContent = (applicationId, contentId, interval, filter)=>histogramRequest(applicationId, contentId, "interactions", interval, filter);
const getSessionHistogramForContent = (applicationId, contentId, interval, filter)=>histogramRequest(applicationId, contentId, "sessions", interval, filter);
// abstract for handling api reqs for histogram data
const histogramRequest = (applicationId, contentId, type, interval, filter)=>{
    const intervalString = interval.charAt(0).toUpperCase() + interval.substr(1);
    return (0, _generic.sendGet)(`/v2/content/${applicationId}/${contentId}/${type}/histogram?${buildQuery(filter)}&interval=${intervalString}`, (0, _urls.getAnalyticsApiUrl)());
};
const getContentItemStats = (applicationId, contentId, filter)=>{
    return (0, _generic.sendGet)(`/v2/content/${applicationId}/${contentId}/totals/usage?${buildQuery(filter)}`, (0, _urls.getAnalyticsApiUrl)());
};
const getContentItemSessionIds = (applicationId, contentId, filter)=>{
    return (0, _generic.sendGet)(`/v2/content/${applicationId}/${contentId}/sessions?${buildQuery(filter)}`, (0, _urls.getAnalyticsApiUrl)());
};
const buildQuery = (filter)=>{
    let query = `startDate=${filter.startDate}&endDate=${filter.endDate}`;
    if (filter.assistants?.length > 0) query += "&assistants=" + filter.assistants.join("&assistants=");
    if (filter.userIds?.length > 0) query += "&userIds=" + filter.userIds.join("&userIds=");
    if (filter.sessionIds?.length > 0) query += "&sessionIds=" + filter.sessionIds.join("&sessionIds=");
    if (filter.deviceTargetIds?.length > 0) query += "&deviceTargetIds=" + filter.deviceTargetIds.join("&deviceTargetIds=");
    if (filter.locales?.length > 0) query += "&locales=" + filter.locales.join("&locales=");
    return query;
};

},{"./generic":"6oGDt","../../constants/Urls":"iTopY","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"kCQLR":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getApplicationStats", ()=>getApplicationStats);
parcelHelpers.export(exports, "getApplicationMissStats", ()=>getApplicationMissStats);
parcelHelpers.export(exports, "getApplicationTopContentHits", ()=>getApplicationTopContentHits);
parcelHelpers.export(exports, "getApplicationTopContentMisses", ()=>getApplicationTopContentMisses);
parcelHelpers.export(exports, "getApplicationUniqueAssistants", ()=>getApplicationUniqueAssistants);
parcelHelpers.export(exports, "getContentHits", ()=>getContentHits);
parcelHelpers.export(exports, "getAggregatedInteractionsByFeatureType", ()=>getAggregatedInteractionsByFeatureType);
parcelHelpers.export(exports, "getUserAggregateByAssistant", ()=>getUserAggregateByAssistant);
parcelHelpers.export(exports, "getUserAggregateByFeatureType", ()=>getUserAggregateByFeatureType);
parcelHelpers.export(exports, "getUserAggregateByDeviceTarget", ()=>getUserAggregateByDeviceTarget);
parcelHelpers.export(exports, "getUserAggregateByInterfaceType", ()=>getUserAggregateByInterfaceType);
parcelHelpers.export(exports, "getUserAggregateByLanguage", ()=>getUserAggregateByLanguage);
parcelHelpers.export(exports, "getNewUserAggregateByAssistant", ()=>getNewUserAggregateByAssistant);
parcelHelpers.export(exports, "getNewUserAggregateByFeatureType", ()=>getNewUserAggregateByFeatureType);
parcelHelpers.export(exports, "getNewUserAggregateByDeviceTarget", ()=>getNewUserAggregateByDeviceTarget);
parcelHelpers.export(exports, "getNewUserAggregateByInterfaceType", ()=>getNewUserAggregateByInterfaceType);
parcelHelpers.export(exports, "getNewUserAggregateByLanguage", ()=>getNewUserAggregateByLanguage);
parcelHelpers.export(exports, "getInteractionAggregateByAssistant", ()=>getInteractionAggregateByAssistant);
parcelHelpers.export(exports, "getInteractionAggregateByFeatureType", ()=>getInteractionAggregateByFeatureType);
parcelHelpers.export(exports, "getInteractionAggregateByDeviceTarget", ()=>getInteractionAggregateByDeviceTarget);
parcelHelpers.export(exports, "getInteractionAggregateByInterfaceType", ()=>getInteractionAggregateByInterfaceType);
parcelHelpers.export(exports, "getInteractionAggregateByLanguage", ()=>getInteractionAggregateByLanguage);
parcelHelpers.export(exports, "getSessionAggregateByAssistant", ()=>getSessionAggregateByAssistant);
parcelHelpers.export(exports, "getSessionAggregateByFeatureType", ()=>getSessionAggregateByFeatureType);
parcelHelpers.export(exports, "getSessionAggregateByDeviceTarget", ()=>getSessionAggregateByDeviceTarget);
parcelHelpers.export(exports, "getSessionAggregateByInterfaceType", ()=>getSessionAggregateByInterfaceType);
parcelHelpers.export(exports, "getSessionAggregateByLanguage", ()=>getSessionAggregateByLanguage);
parcelHelpers.export(exports, "getFeatureMissAggregateByAssistant", ()=>getFeatureMissAggregateByAssistant);
parcelHelpers.export(exports, "getFeatureMissAggregateByFeatureType", ()=>getFeatureMissAggregateByFeatureType);
parcelHelpers.export(exports, "getFeatureMissAggregateByDeviceTarget", ()=>getFeatureMissAggregateByDeviceTarget);
parcelHelpers.export(exports, "getFeatureMissAggregateByInterfaceType", ()=>getFeatureMissAggregateByInterfaceType);
parcelHelpers.export(exports, "getFeatureMissAggregateByLanguage", ()=>getFeatureMissAggregateByLanguage);
parcelHelpers.export(exports, "getContentMissAggregateByAssistant", ()=>getContentMissAggregateByAssistant);
parcelHelpers.export(exports, "getContentMissAggregateByFeatureType", ()=>getContentMissAggregateByFeatureType);
parcelHelpers.export(exports, "getContentMissAggregateByDeviceTarget", ()=>getContentMissAggregateByDeviceTarget);
parcelHelpers.export(exports, "getContentMissAggregateByInterfaceType", ()=>getContentMissAggregateByInterfaceType);
parcelHelpers.export(exports, "getContentMissAggregateByLanguage", ()=>getContentMissAggregateByLanguage);
parcelHelpers.export(exports, "getSessionsByApplication", ()=>getSessionsByApplication);
parcelHelpers.export(exports, "getAllEventsForSession", ()=>getAllEventsForSession);
parcelHelpers.export(exports, "getCallStartedEventsByApplication", ()=>getCallStartedEventsByApplication);
parcelHelpers.export(exports, "getOrderPlacedEventsByApplication", ()=>getOrderPlacedEventsByApplication);
parcelHelpers.export(exports, "getItemAddedToOrderEventsByApplication", ()=>getItemAddedToOrderEventsByApplication);
parcelHelpers.export(exports, "getCallTransferredEventsByApplication", ()=>getCallTransferredEventsByApplication);
parcelHelpers.export(exports, "getImmediateTransferEventsByApplication", ()=>getImmediateTransferEventsByApplication);
parcelHelpers.export(exports, "getConversationalSuccessEventsByApplication", ()=>getConversationalSuccessEventsByApplication);
parcelHelpers.export(exports, "getOutboundCallAnsweredEventsByApplication", ()=>getOutboundCallAnsweredEventsByApplication);
parcelHelpers.export(exports, "getCallCompleteEventsByApplication", ()=>getCallCompleteEventsByApplication);
parcelHelpers.export(exports, "getUserHistogramForApplication", ()=>getUserHistogramForApplication);
parcelHelpers.export(exports, "getNewUserHistogramForApplication", ()=>getNewUserHistogramForApplication);
parcelHelpers.export(exports, "getUsageHistogramForApplication", ()=>getUsageHistogramForApplication);
parcelHelpers.export(exports, "getSessionHistogramForApplication", ()=>getSessionHistogramForApplication);
parcelHelpers.export(exports, "getFeatureMissHistogramForApplication", ()=>getFeatureMissHistogramForApplication);
parcelHelpers.export(exports, "getContentMissHistogramForApplication", ()=>getContentMissHistogramForApplication);
var _generic = require("./generic");
var _urls = require("../../constants/Urls");
const getApplicationStats = (applicationId, filter)=>{
    return (0, _generic.sendGet)(`/v2/Application/${applicationId}/totals/usage?${buildQuery(filter)}`, (0, _urls.getAnalyticsApiUrl)());
};
const getApplicationMissStats = (applicationId, filter)=>{
    return (0, _generic.sendGet)(`/v2/Application/${applicationId}/totals/misses?${buildQuery(filter)}`, (0, _urls.getAnalyticsApiUrl)());
};
const getApplicationTopContentHits = (applicationId, filter)=>{
    return (0, _generic.sendGet)(`/v2/Application/${applicationId}/totals/top/hits?${buildQuery(filter)}`, (0, _urls.getAnalyticsApiUrl)());
};
const getApplicationTopContentMisses = (applicationId, filter)=>{
    return (0, _generic.sendGet)(`/v2/Application/${applicationId}/totals/top/misses?${buildQuery(filter)}`, (0, _urls.getAnalyticsApiUrl)());
};
const getApplicationUniqueAssistants = (applicationId, filter)=>{
    return (0, _generic.sendGet)(`/v2/Application/${applicationId}/unique/assistants?${buildQuery(filter)}`, (0, _urls.getAnalyticsApiUrl)());
};
const getContentHits = (applicationId, filter, skip = 0, take = 0, latest = false, sessionId = "", featureTypeId = "")=>{
    let url = `/v2/Application/${applicationId}/events/contentHit?${buildQuery(filter)}&skip=${skip}&take=${take}&latest=${latest}`;
    if (sessionId?.length) url = `${url}&sessionIds=${sessionId}`;
    if (featureTypeId?.length) url = `${url}&featureTypeId=${featureTypeId}`;
    return (0, _generic.sendGet)(url, (0, _urls.getAnalyticsApiUrl)());
};
const getAggregatedInteractionsByFeatureType = (applicationId, filter, featureTypeId = null)=>{
    let url = `/v2/Application/${applicationId}/interactions/aggregation/featureType?${buildQuery(filter)}`;
    if (featureTypeId?.length) url = `${url}&featureTypeId=${featureTypeId}`;
    return (0, _generic.sendGet)(url, (0, _urls.getAnalyticsApiUrl)());
};
const getUserAggregateByAssistant = (applicationId, filter)=>aggregateRequest(applicationId, "users", "assistant", filter);
const getUserAggregateByFeatureType = (applicationId, filter)=>aggregateRequest(applicationId, "users", "featureType", filter);
const getUserAggregateByDeviceTarget = (applicationId, filter)=>aggregateRequest(applicationId, "users", "deviceTarget", filter);
const getUserAggregateByInterfaceType = (applicationId, filter)=>aggregateRequest(applicationId, "users", "interfaceType", filter);
const getUserAggregateByLanguage = (applicationId, filter)=>aggregateRequest(applicationId, "users", "locale", filter);
const getNewUserAggregateByAssistant = (applicationId, filter)=>aggregateRequest(applicationId, "newUsers", "assistant", filter);
const getNewUserAggregateByFeatureType = (applicationId, filter)=>aggregateRequest(applicationId, "newUsers", "featureType", filter);
const getNewUserAggregateByDeviceTarget = (applicationId, filter)=>aggregateRequest(applicationId, "newUsers", "deviceTarget", filter);
const getNewUserAggregateByInterfaceType = (applicationId, filter)=>aggregateRequest(applicationId, "newUsers", "interfaceType", filter);
const getNewUserAggregateByLanguage = (applicationId, filter)=>aggregateRequest(applicationId, "newUsers", "locale", filter);
const getInteractionAggregateByAssistant = (applicationId, filter)=>aggregateRequest(applicationId, "interactions", "assistant", filter);
const getInteractionAggregateByFeatureType = (applicationId, filter)=>aggregateRequest(applicationId, "interactions", "featureType", filter);
const getInteractionAggregateByDeviceTarget = (applicationId, filter)=>aggregateRequest(applicationId, "interactions", "deviceTarget", filter);
const getInteractionAggregateByInterfaceType = (applicationId, filter)=>aggregateRequest(applicationId, "interactions", "interfaceType", filter);
const getInteractionAggregateByLanguage = (applicationId, filter)=>aggregateRequest(applicationId, "interactions", "locale", filter);
const getSessionAggregateByAssistant = (applicationId, filter)=>aggregateRequest(applicationId, "sessions", "assistant", filter);
const getSessionAggregateByFeatureType = (applicationId, filter)=>aggregateRequest(applicationId, "sessions", "featureType", filter);
const getSessionAggregateByDeviceTarget = (applicationId, filter)=>aggregateRequest(applicationId, "sessions", "deviceTarget", filter);
const getSessionAggregateByInterfaceType = (applicationId, filter)=>aggregateRequest(applicationId, "sessions", "interfaceType", filter);
const getSessionAggregateByLanguage = (applicationId, filter)=>aggregateRequest(applicationId, "sessions", "locale", filter);
const getFeatureMissAggregateByAssistant = (applicationId, filter)=>aggregateRequest(applicationId, "featureMisses", "assistant", filter);
const getFeatureMissAggregateByFeatureType = (applicationId, filter)=>aggregateRequest(applicationId, "featureMisses", "featureType", filter);
const getFeatureMissAggregateByDeviceTarget = (applicationId, filter)=>aggregateRequest(applicationId, "featureMisses", "deviceTarget", filter);
const getFeatureMissAggregateByInterfaceType = (applicationId, filter)=>aggregateRequest(applicationId, "featureMisses", "interfaceType", filter);
const getFeatureMissAggregateByLanguage = (applicationId, filter)=>aggregateRequest(applicationId, "featureMisses", "locale", filter);
const getContentMissAggregateByAssistant = (applicationId, filter)=>aggregateRequest(applicationId, "contentMisses", "assistant", filter);
const getContentMissAggregateByFeatureType = (applicationId, filter)=>aggregateRequest(applicationId, "contentMisses", "featureType", filter);
const getContentMissAggregateByDeviceTarget = (applicationId, filter)=>aggregateRequest(applicationId, "contentMisses", "deviceTarget", filter);
const getContentMissAggregateByInterfaceType = (applicationId, filter)=>aggregateRequest(applicationId, "contentMisses", "interfaceType", filter);
const getContentMissAggregateByLanguage = (applicationId, filter)=>aggregateRequest(applicationId, "contentMisses", "locale", filter);
const getSessionsByApplication = (applicationId, filter)=>{
    return (0, _generic.sendGet)(`/v2/Application/${applicationId}/sessions?${buildDateFilter(filter)}`, (0, _urls.getAnalyticsApiUrl)());
};
const getAllEventsForSession = (applicationId, sessionId)=>(0, _generic.sendGet)(`/v2/Application/${applicationId}/session/${sessionId}`, (0, _urls.getAnalyticsApiUrl)());
const getCallStartedEventsByApplication = (applicationId, filter)=>(0, _generic.sendGet)(`/v2/Application/${applicationId}/callStarted?${buildDateFilter(filter)}`, (0, _urls.getAnalyticsApiUrl)());
const getOrderPlacedEventsByApplication = (applicationId, filter)=>(0, _generic.sendGet)(`/v2/Application/${applicationId}/orderPlaced?${buildDateFilter(filter)}`, (0, _urls.getAnalyticsApiUrl)());
const getItemAddedToOrderEventsByApplication = (applicationId, filter)=>(0, _generic.sendGet)(`/v2/Application/${applicationId}/itemAddedToOrder?${buildDateFilter(filter)}`, (0, _urls.getAnalyticsApiUrl)());
const getCallTransferredEventsByApplication = (applicationId, filter)=>(0, _generic.sendGet)(`/v2/Application/${applicationId}/callTransferred?${buildDateFilter(filter)}`, (0, _urls.getAnalyticsApiUrl)());
const getImmediateTransferEventsByApplication = (applicationId, filter)=>(0, _generic.sendGet)(`/v2/Application/${applicationId}/immediateTransfer?${buildDateFilter(filter)}`, (0, _urls.getAnalyticsApiUrl)());
const getConversationalSuccessEventsByApplication = (applicationId, filter)=>(0, _generic.sendGet)(`/v2/Application/${applicationId}/conversationalSuccess?${buildDateFilter(filter)}`, (0, _urls.getAnalyticsApiUrl)());
const getOutboundCallAnsweredEventsByApplication = (applicationId, filter)=>(0, _generic.sendGet)(`/v2/Application/${applicationId}/outboundCallAnswered?${buildDateFilter(filter)}`, (0, _urls.getAnalyticsApiUrl)());
const getCallCompleteEventsByApplication = (applicationId, filter)=>(0, _generic.sendGet)(`/v2/Application/${applicationId}/callComplete?${buildDateFilter(filter)}`, (0, _urls.getAnalyticsApiUrl)());
// abstract for halding api reqs for aggregated data
const aggregateRequest = (applicationId, type, aggkey, filter)=>(0, _generic.sendGet)(`/v2/Application/${applicationId}/${type}/aggregation/${aggkey}?${buildQuery(filter)}`, (0, _urls.getAnalyticsApiUrl)());
const getUserHistogramForApplication = (applicationId, interval, filter)=>histogramRequest(applicationId, "users", interval, filter);
const getNewUserHistogramForApplication = (applicationId, interval, filter)=>histogramRequest(applicationId, "newusers", interval, filter);
const getUsageHistogramForApplication = (applicationId, interval, filter)=>histogramRequest(applicationId, "interactions", interval, filter);
const getSessionHistogramForApplication = (applicationId, interval, filter)=>histogramRequest(applicationId, "sessions", interval, filter);
const getFeatureMissHistogramForApplication = (applicationId, interval, filter)=>histogramRequest(applicationId, "featuremisses", interval, filter);
const getContentMissHistogramForApplication = (applicationId, interval, filter)=>histogramRequest(applicationId, "contentmisses", interval, filter);
// abstract for handling api reqs for histogram data
const histogramRequest = (applicationId, type, interval, filter)=>{
    const intervalString = getApiInterval(interval);
    return (0, _generic.sendGet)(`/v2/Application/${applicationId}/${type}/histogram?interval=${intervalString}&${buildQuery(filter)}`, (0, _urls.getAnalyticsApiUrl)());
};
const buildQuery = (filter)=>{
    var startDate = new Date(filter.startDate).toISOString();
    var endDate = new Date(filter.endDate).toISOString();
    let query = `startDate=${startDate}&endDate=${endDate}`;
    if (filter.assistants?.length > 0) query += "&assistants=" + filter.assistants.join("&assistants=");
    if (filter.userIds?.length > 0) query += "&userIds=" + filter.userIds.join("&userIds=");
    if (filter.sessionIds?.length > 0) query += "&sessionIds=" + filter.sessionIds.join("&sessionIds=");
    if (filter.deviceTargetIds?.length > 0) query += "&deviceTargetIds=" + filter.deviceTargetIds.join("&deviceTargetIds=");
    if (filter.locales?.length > 0) query += "&locales=" + filter.locales.join("&locales=");
    return query;
};
const buildDateFilter = (filter)=>{
    const startDate = new Date(filter.startDate).toISOString();
    const endDate = new Date(filter.endDate).toISOString();
    let query = `startDate=${startDate}&endDate=${endDate}`;
    if (filter?.skip && filter.skip > -1 || filter?.take && filter.take > -1) query += `&skip=${filter.skip}&take=${filter.take}`;
    return query;
};
const getApiInterval = (interval)=>{
    let intervalString = interval.charAt(0).toUpperCase() + interval.substr(1);
    if (intervalString == "DayAndHour") intervalString = "Hour";
    return intervalString;
};

},{"./generic":"6oGDt","../../constants/Urls":"iTopY","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"d3hYM":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getWebhooksForOrg", ()=>getWebhooksForOrg);
parcelHelpers.export(exports, "getWebhooksForApp", ()=>getWebhooksForApp);
parcelHelpers.export(exports, "getWebhookTypes", ()=>getWebhookTypes);
parcelHelpers.export(exports, "createWebhook", ()=>createWebhook);
parcelHelpers.export(exports, "updateWebhook", ()=>updateWebhook);
parcelHelpers.export(exports, "removeOrganizationWebhook", ()=>removeOrganizationWebhook);
parcelHelpers.export(exports, "createFullWebhook", ()=>createFullWebhook);
parcelHelpers.export(exports, "updateFullWebhook", ()=>updateFullWebhook);
parcelHelpers.export(exports, "getWebhookAttachmentsForApplication", ()=>getWebhookAttachmentsForApplication);
parcelHelpers.export(exports, "generateSensitiveDataKey", ()=>generateSensitiveDataKey);
parcelHelpers.export(exports, "removeSensitiveDataKey", ()=>removeSensitiveDataKey);
var _generic = require("./generic");
const getWebhooksForOrg = (organizationId)=>{
    return (0, _generic.sendGet)(`/Webhook/fromOrganization/${organizationId}`);
};
const getWebhooksForApp = (appId)=>{
    return (0, _generic.sendGet)(`/Webhook/fromApplication/${appId}`);
};
const getWebhookTypes = ()=>{
    return (0, _generic.sendGet)("/Webhook/types");
};
const createWebhook = (organizationId, model)=>{
    return (0, _generic.sendPost)(`/Webhook/${organizationId}`, model);
};
const updateWebhook = (webhookId, model)=>{
    return (0, _generic.sendPut)(`/Webhook/${webhookId}`, model);
};
const removeOrganizationWebhook = (webhookId)=>{
    return (0, _generic.sendDelete)(`/Webhook/${webhookId}`);
};
const createFullWebhook = (model)=>{
    return (0, _generic.sendPost)(`/Webhook/full`, model);
};
const updateFullWebhook = (webhookId, model)=>{
    return (0, _generic.sendPut)(`/Webhook/${webhookId}/full`, model);
};
const getWebhookAttachmentsForApplication = (appId)=>{
    return (0, _generic.sendGet)(`/Webhook/application/${appId}/attachments`);
};
const generateSensitiveDataKey = (webhookId)=>{
    return (0, _generic.sendPut)(`/Webhook/${webhookId}/sensitiveDataKey`);
};
const removeSensitiveDataKey = (webhookId)=>{
    return (0, _generic.sendDelete)(`/Webhook/${webhookId}/sensitiveDataKey`);
};

},{"./generic":"6oGDt","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6D1gU":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getFallbackMessagesForApp", ()=>getFallbackMessagesForApp);
parcelHelpers.export(exports, "getFallbackMessagesForAppFeature", ()=>getFallbackMessagesForAppFeature);
parcelHelpers.export(exports, "addFullFallbackMessage", ()=>addFullFallbackMessage);
parcelHelpers.export(exports, "addFallbackMessage", ()=>addFallbackMessage);
parcelHelpers.export(exports, "addFallbackMessageStub", ()=>addFallbackMessageStub);
parcelHelpers.export(exports, "toggleFallbackMessageLive", ()=>toggleFallbackMessageLive);
parcelHelpers.export(exports, "toggleFallbackMessageSync", ()=>toggleFallbackMessageSync);
parcelHelpers.export(exports, "updateFullFallbackMessage", ()=>updateFullFallbackMessage);
parcelHelpers.export(exports, "updateFallbackMessage", ()=>updateFallbackMessage);
parcelHelpers.export(exports, "updateFallbackMessageStub", ()=>updateFallbackMessageStub);
parcelHelpers.export(exports, "deleteFallbackMessage", ()=>deleteFallbackMessage);
parcelHelpers.export(exports, "findFallbackMessage", ()=>findFallbackMessage);
parcelHelpers.export(exports, "getFallbackMessageWebhooks", ()=>getFallbackMessageWebhooks);
parcelHelpers.export(exports, "removeFallbackMessageWebhook", ()=>removeFallbackMessageWebhook);
parcelHelpers.export(exports, "addFallbackMessageWebhook", ()=>addFallbackMessageWebhook);
parcelHelpers.export(exports, "updateFallbackMessageWebhook", ()=>updateFallbackMessageWebhook);
parcelHelpers.export(exports, "getFallbackMessageCategories", ()=>getFallbackMessageCategories);
parcelHelpers.export(exports, "copyFallbackMessage", ()=>copyFallbackMessage);
parcelHelpers.export(exports, "bulkUpdateFallbackMessageWebhookInstances", ()=>bulkUpdateFallbackMessageWebhookInstances);
parcelHelpers.export(exports, "getFallbackMessagePublishHistory", ()=>getFallbackMessagePublishHistory);
var _generic = require("./generic");
const getFallbackMessagesForApp = (applicationId)=>{
    return (0, _generic.sendGet)(`/FallbackMessage/${applicationId}`);
};
const getFallbackMessagesForAppFeature = (applicationFeatureId)=>{
    return (0, _generic.sendGet)(`/FallbackMessage/byFeature/${applicationFeatureId}`);
};
const addFullFallbackMessage = (model)=>{
    return (0, _generic.sendPost)(`/FallbackMessage/full`, model);
};
const addFallbackMessage = (applicationId, model)=>{
    return (0, _generic.sendPost)(`/FallbackMessage/${applicationId}`, model);
};
const addFallbackMessageStub = (model)=>{
    return (0, _generic.sendPost)(`/FallbackMessage/${model.applicationId}/stub`, model);
};
const toggleFallbackMessageLive = (fallbackMessageId, isLive)=>{
    return (0, _generic.sendPut)(`/FallbackMessage/${fallbackMessageId}/isLive`, {
        isLive
    });
};
const toggleFallbackMessageSync = (fallbackMessageId, shouldNotSync)=>{
    return (0, _generic.sendPut)(`/FallbackMessage/${fallbackMessageId}/shouldNotSync`, {
        shouldNotSync
    });
};
const updateFullFallbackMessage = (fallbackMessageId, model)=>{
    return (0, _generic.sendPut)(`/FallbackMessage/${fallbackMessageId}/full`, model);
};
const updateFallbackMessage = (fallbackMessageId, model)=>{
    return (0, _generic.sendPut)(`/FallbackMessage/${fallbackMessageId}/update`, model);
};
const updateFallbackMessageStub = (fallbackMessageId, model)=>{
    return (0, _generic.sendPut)(`/FallbackMessage/${fallbackMessageId}/update/stub`, model);
};
const deleteFallbackMessage = (fallbackMessageId)=>{
    return (0, _generic.sendDelete)(`/FallbackMessage/${fallbackMessageId}`);
};
const findFallbackMessage = (fallbackMessageId)=>{
    return (0, _generic.sendGet)(`/FallbackMessage/full/${fallbackMessageId}`);
};
const getFallbackMessageWebhooks = (fallbackMessageId)=>{
    return (0, _generic.sendGet)(`/FallbackMessage/${fallbackMessageId}/webhooks`);
};
const removeFallbackMessageWebhook = (fallbackMessageWebhookId)=>{
    return (0, _generic.sendDelete)(`/FallbackMessage/webhook/${fallbackMessageWebhookId}`);
};
const addFallbackMessageWebhook = (fallbackMessageId, webhookId, defaultParameters, userDefinedParameters)=>{
    return (0, _generic.sendPost)(`/FallbackMessage/${fallbackMessageId}/webhooks/${webhookId}`, {
        values: defaultParameters,
        userDefinedParameters: userDefinedParameters
    });
};
const updateFallbackMessageWebhook = (fallbackMessageId, webhookInstanceId, defaultParameters, userDefinedParameters)=>{
    return (0, _generic.sendPut)(`/FallbackMessage/${fallbackMessageId}/webhooks/${webhookInstanceId}`, {
        values: defaultParameters,
        userDefinedParameters: userDefinedParameters
    });
};
const getFallbackMessageCategories = ()=>{
    return (0, _generic.sendGet)(`/Fallbackmessage/categories`);
};
const copyFallbackMessage = (contentItemId)=>{
    return (0, _generic.sendPost)(`/FallbackMessage/${contentItemId}/copy`, null);
};
const bulkUpdateFallbackMessageWebhookInstances = (contentItemId, updateRequest)=>{
    return (0, _generic.sendPut)(`/FallbackMessage/${contentItemId}/webhooks/bulk`, updateRequest);
};
const getFallbackMessagePublishHistory = (contentItemId, environmentId, skip, take)=>{
    return (0, _generic.sendGet)(`/FallbackMessage/${contentItemId}/publishes/forenvironment/${environmentId}?skip=${skip}&take=${take}`);
};

},{"./generic":"6oGDt","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7MlqD":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getFollowUpsForApp", ()=>getFollowUpsForApp);
parcelHelpers.export(exports, "addFollowUp", ()=>addFollowUp);
parcelHelpers.export(exports, "updateFollowUp", ()=>updateFollowUp);
parcelHelpers.export(exports, "deleteFollowUp", ()=>deleteFollowUp);
parcelHelpers.export(exports, "findFollowUpById", ()=>findFollowUpById);
parcelHelpers.export(exports, "getParentContentItems", ()=>getParentContentItems);
var _generic = require("./generic");
const getFollowUpsForApp = (applicationId)=>{
    return (0, _generic.sendGet)(`/FollowUp/${applicationId}`);
};
const addFollowUp = (applicationId, model)=>{
    return (0, _generic.sendPost)(`/FollowUp/${applicationId}`, model);
};
const updateFollowUp = (model)=>{
    return (0, _generic.sendPut)(`/FollowUp`, model);
};
const deleteFollowUp = (followUpId)=>{
    return (0, _generic.sendDelete)(`/FollowUp/${followUpId}`);
};
const findFollowUpById = (followUpId)=>{
    return (0, _generic.sendGet)(`/FollowUp/find/${followUpId}`);
};
const getParentContentItems = (featureTypeId, contentId)=>{
    return (0, _generic.sendGet)(`/FollowUp/parents/${featureTypeId}/${contentId}/content`);
};

},{"./generic":"6oGDt","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"b6Ie6":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getRepromptsForApp", ()=>getRepromptsForApp);
parcelHelpers.export(exports, "addReprompt", ()=>addReprompt);
parcelHelpers.export(exports, "updateReprompt", ()=>updateReprompt);
parcelHelpers.export(exports, "deleteReprompt", ()=>deleteReprompt);
var _generic = require("./generic");
const getRepromptsForApp = (applicationId)=>{
    return (0, _generic.sendGet)(`/Reprompt/${applicationId}`);
};
const addReprompt = (applicationId, model)=>{
    return (0, _generic.sendPost)(`/Reprompt/${applicationId}`, model);
};
const updateReprompt = (model)=>{
    return (0, _generic.sendPut)(`/Reprompt`, model);
};
const deleteReprompt = (repromptId)=>{
    return (0, _generic.sendDelete)(`/Reprompt/${repromptId}`);
};

},{"./generic":"6oGDt","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3brAk":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createMediaResponse", ()=>createMediaResponse);
parcelHelpers.export(exports, "createMediaResponseContainer", ()=>createMediaResponseContainer);
parcelHelpers.export(exports, "createBulkMediaResponseContainer", ()=>createBulkMediaResponseContainer);
parcelHelpers.export(exports, "getMediaResponseContainersForApplication", ()=>getMediaResponseContainersForApplication);
parcelHelpers.export(exports, "getMediaResponseContainerById", ()=>getMediaResponseContainerById);
parcelHelpers.export(exports, "getResponseTemplateTypesByAssistant", ()=>getResponseTemplateTypesByAssistant);
parcelHelpers.export(exports, "getEnabledResponseTemplates", ()=>getEnabledResponseTemplates);
parcelHelpers.export(exports, "getAllResponseTemplates", ()=>getAllResponseTemplates);
parcelHelpers.export(exports, "getResponseTemplateById", ()=>getResponseTemplateById);
parcelHelpers.export(exports, "updateMediaResponse", ()=>updateMediaResponse);
parcelHelpers.export(exports, "updateMediaResponseContainer", ()=>updateMediaResponseContainer);
parcelHelpers.export(exports, "updateBulkMediaResponseContainer", ()=>updateBulkMediaResponseContainer);
parcelHelpers.export(exports, "deleteMediaResponse", ()=>deleteMediaResponse);
parcelHelpers.export(exports, "deleteMediaResponseContainer", ()=>deleteMediaResponseContainer);
var _urls = require("../../constants/Urls");
var _generic = require("./generic");
const createMediaResponse = (model)=>{
    return (0, _generic.sendPost)(`${(0, _urls.GET_MEDIARESPONSES)}`, model);
};
const createMediaResponseContainer = (model)=>{
    return (0, _generic.sendPost)(`${(0, _urls.GET_MEDIARESPONSES)}/containers`, model);
};
const createBulkMediaResponseContainer = (model)=>{
    return (0, _generic.sendPost)(`${(0, _urls.GET_MEDIARESPONSES)}/containers/bulk`, model);
};
const getMediaResponseContainersForApplication = (applicationId)=>{
    return (0, _generic.sendGet)(`${(0, _urls.GET_MEDIARESPONSES)}/containers/forapp/${applicationId}`);
};
const getMediaResponseContainerById = (containerId)=>{
    return (0, _generic.sendGet)(`${(0, _urls.GET_MEDIARESPONSES)}/containers/${containerId}`);
};
const getResponseTemplateTypesByAssistant = (assistant)=>{
    return (0, _generic.sendGet)(`${(0, _urls.GET_MEDIARESPONSES)}/templateType/assistant/${assistant}`);
};
const getEnabledResponseTemplates = ()=>{
    return (0, _generic.sendGet)(`${(0, _urls.GET_MEDIARESPONSES)}/templateType/enabled`);
};
const getAllResponseTemplates = ()=>{
    return (0, _generic.sendGet)(`${(0, _urls.GET_MEDIARESPONSES)}/templateType`);
};
const getResponseTemplateById = (templateId)=>{
    return (0, _generic.sendGet)(`${(0, _urls.GET_MEDIARESPONSES)}/templateType/${templateId}`);
};
const updateMediaResponse = (responseId, model)=>{
    return (0, _generic.sendPut)(`${(0, _urls.GET_MEDIARESPONSES)}/${responseId}`, model);
};
const updateMediaResponseContainer = (containerId, model)=>{
    return (0, _generic.sendPut)(`${(0, _urls.GET_MEDIARESPONSES)}/containers/${containerId}`, model);
};
const updateBulkMediaResponseContainer = (containerId, model)=>{
    return (0, _generic.sendPut)(`${(0, _urls.GET_MEDIARESPONSES)}/containers/${containerId}/bulk`, model);
};
const deleteMediaResponse = (responseId)=>{
    return (0, _generic.sendDelete)(`${(0, _urls.GET_MEDIARESPONSES)}/${responseId}`);
};
const deleteMediaResponseContainer = (containerId)=>{
    return (0, _generic.sendDelete)(`${(0, _urls.GET_MEDIARESPONSES)}/containers/${containerId}`);
};

},{"../../constants/Urls":"iTopY","./generic":"6oGDt","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jwyoo":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getApplicationsLinkedToAmazon", ()=>getApplicationsLinkedToAmazon);
parcelHelpers.export(exports, "listSkills", ()=>listSkills);
parcelHelpers.export(exports, "getAlexaSkillCertifications", ()=>getAlexaSkillCertifications);
parcelHelpers.export(exports, "getEnvironmentDeploymentInfoForAmazon", ()=>getEnvironmentDeploymentInfoForAmazon);
parcelHelpers.export(exports, "unlinkAlexaSkillFromEnvironment", ()=>unlinkAlexaSkillFromEnvironment);
parcelHelpers.export(exports, "removeAmazonAuthTokenFromEnvironment", ()=>removeAmazonAuthTokenFromEnvironment);
parcelHelpers.export(exports, "removeAlexaVendorFromEnvironment", ()=>removeAlexaVendorFromEnvironment);
parcelHelpers.export(exports, "getEnvironmentAlexaVendors", ()=>getEnvironmentAlexaVendors);
parcelHelpers.export(exports, "linkAmazonTokenToEnvironment", ()=>linkAmazonTokenToEnvironment);
parcelHelpers.export(exports, "linkEnvironmentAlexaVendor", ()=>linkEnvironmentAlexaVendor);
parcelHelpers.export(exports, "createAndDeployEnvironmentNewAlexaSkill", ()=>createAndDeployEnvironmentNewAlexaSkill);
parcelHelpers.export(exports, "linkEnvironmentToAlexaSkill", ()=>linkEnvironmentToAlexaSkill);
var _generic = require("./generic");
var _urls = require("../../constants/Urls");
const getApplicationsLinkedToAmazon = (organizationId)=>{
    return (0, _generic.sendGet)(`${(0, _urls.PLATFORM_ALEXA_SKILL)}/organizationLinksToAmazon/${organizationId}`);
};
const listSkills = (vendorId, tokenId)=>{
    return (0, _generic.sendGet)(`${(0, _urls.PLATFORM_ALEXA_SKILL)}/Skills/${vendorId}/${tokenId}`);
};
const getAlexaSkillCertifications = (applicationId, environmentId, skillId)=>{
    return (0, _generic.sendGet)(`${(0, _urls.PLATFORM_ALEXA_SKILL)}/${applicationId}/environment/${environmentId}/${skillId}/Certifications`);
};
const getEnvironmentDeploymentInfoForAmazon = (applicationId, environmentId)=>{
    return (0, _generic.sendGet)(`${(0, _urls.PLATFORM_ALEXA_SKILL)}/${applicationId}/environment/${environmentId}/link`);
};
const unlinkAlexaSkillFromEnvironment = (applicationId, environmentId)=>{
    return (0, _generic.sendDelete)(`${(0, _urls.PLATFORM_ALEXA_SKILL)}/${applicationId}/environment/${environmentId}`);
};
const removeAmazonAuthTokenFromEnvironment = (applicationId, environmentId)=>{
    return (0, _generic.sendDelete)(`${(0, _urls.PLATFORM_ALEXA_SKILL)}/${applicationId}/environment/${environmentId}/authToken`);
};
const removeAlexaVendorFromEnvironment = (applicationId, environmentId)=>{
    return (0, _generic.sendDelete)(`${(0, _urls.PLATFORM_ALEXA_SKILL)}/${applicationId}/environment/${environmentId}/vendor`);
};
const getEnvironmentAlexaVendors = (applicationId, environmentId)=>{
    return (0, _generic.sendGet)(`${(0, _urls.PLATFORM_ALEXA_SKILL)}/${applicationId}/environment/${environmentId}/vendors`);
};
const linkAmazonTokenToEnvironment = (applicationId, environmentId, amazonAuthToken)=>{
    return (0, _generic.sendPut)(`${(0, _urls.PLATFORM_ALEXA_SKILL)}/${applicationId}/environment/${environmentId}/authToken/${amazonAuthToken}`, {});
};
const linkEnvironmentAlexaVendor = (applicationId, environmentId, vendorId)=>{
    return (0, _generic.sendPut)(`${(0, _urls.PLATFORM_ALEXA_SKILL)}/${applicationId}/environment/${environmentId}/vendor/${vendorId}`, {});
};
const createAndDeployEnvironmentNewAlexaSkill = (applicationId, environmentId)=>{
    return (0, _generic.sendPost)(`${(0, _urls.PLATFORM_ALEXA_SKILL)}/${applicationId}/environment/${environmentId}/createAndDeploy`, {});
};
const linkEnvironmentToAlexaSkill = (applicationId, environmentId, alexaSkillId)=>{
    return (0, _generic.sendPut)(`${(0, _urls.PLATFORM_ALEXA_SKILL)}/${applicationId}/environment/${environmentId}/link/${alexaSkillId}`, {});
};

},{"./generic":"6oGDt","../../constants/Urls":"iTopY","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4wZlK":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getApplicationsLinkedToDialogflow", ()=>getApplicationsLinkedToDialogflow);
parcelHelpers.export(exports, "listDialogflowAgents", ()=>listDialogflowAgents);
parcelHelpers.export(exports, "getEnvironmentDeploymentInfoForDialogflow", ()=>getEnvironmentDeploymentInfoForDialogflow);
parcelHelpers.export(exports, "linkEnvironmentToDialogflowAgent", ()=>linkEnvironmentToDialogflowAgent);
parcelHelpers.export(exports, "linkDialogflowTokenToEnvironment", ()=>linkDialogflowTokenToEnvironment);
parcelHelpers.export(exports, "unlinkDialogflowAgentFromEnvironment", ()=>unlinkDialogflowAgentFromEnvironment);
parcelHelpers.export(exports, "removeDialogflowAuthTokenFromEnvironment", ()=>removeDialogflowAuthTokenFromEnvironment);
var _generic = require("./generic");
var _urls = require("../../constants/Urls");
const getApplicationsLinkedToDialogflow = (organizationId)=>{
    return (0, _generic.sendGet)(`${(0, _urls.PLATFORM_DIALOGFLOW)}/organizationLinksToGoogle/${organizationId}`);
};
const listDialogflowAgents = (tokenId)=>{
    return (0, _generic.sendGet)(`${(0, _urls.PLATFORM_DIALOGFLOW)}/Agents/${tokenId}`);
};
const getEnvironmentDeploymentInfoForDialogflow = (applicationId, environmentId)=>{
    return (0, _generic.sendGet)(`${(0, _urls.PLATFORM_DIALOGFLOW)}/${applicationId}/environment/${environmentId}/link`);
};
const linkEnvironmentToDialogflowAgent = (applicationId, environmentId, dialogflowAgentId)=>{
    return (0, _generic.sendPut)(`${(0, _urls.PLATFORM_DIALOGFLOW)}/${applicationId}/environment/${environmentId}?dialogflowAgentId=${dialogflowAgentId}`, {});
};
const linkDialogflowTokenToEnvironment = (applicationId, environmentId, googleAuthTokenId)=>{
    return (0, _generic.sendPut)(`${(0, _urls.PLATFORM_DIALOGFLOW)}/${applicationId}/environment/${environmentId}/authToken/${googleAuthTokenId}`, {});
};
const unlinkDialogflowAgentFromEnvironment = (applicationId, environmentId)=>{
    return (0, _generic.sendDelete)(`${(0, _urls.PLATFORM_DIALOGFLOW)}/${applicationId}/environment/${environmentId}`);
};
const removeDialogflowAuthTokenFromEnvironment = (applicationId, environmentId)=>{
    return (0, _generic.sendDelete)(`${(0, _urls.PLATFORM_DIALOGFLOW)}/${applicationId}/environment/${environmentId}/authToken`);
};

},{"./generic":"6oGDt","../../constants/Urls":"iTopY","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"86UFi":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getAmazonAuthUrl", ()=>getAmazonAuthUrl);
parcelHelpers.export(exports, "amazonAuthCallback", ()=>amazonAuthCallback);
parcelHelpers.export(exports, "getAvailableAmazonCredentials", ()=>getAvailableAmazonCredentials);
parcelHelpers.export(exports, "removeAmazonCredentials", ()=>removeAmazonCredentials);
var _generic = require("./generic");
var _authSalt = require("../../services/authSalt");
var _authSaltDefault = parcelHelpers.interopDefault(_authSalt);
const getAmazonAuthUrl = (authUrlRequest)=>{
    var csrfToken = (0, _authSaltDefault.default)();
    localStorage.setItem("amazon-salt", csrfToken);
    return (0, _generic.sendGet)("/AmazonAuthorization/AuthorizationUrl?" + (0, _generic.queryStringSerialize)(authUrlRequest) + `&salt=${csrfToken}`);
};
const amazonAuthCallback = (query)=>{
    return (0, _generic.sendGet)(`/AmazonAuthorization/Callback${query}`);
};
const getAvailableAmazonCredentials = (organizationId)=>{
    return (0, _generic.sendGet)(`/AmazonAuthorization/Credentials/${organizationId}`);
};
const removeAmazonCredentials = (tokenId)=>{
    return (0, _generic.sendDelete)(`/AmazonAuthorization/Credentials/${tokenId}`);
};

},{"./generic":"6oGDt","../../services/authSalt":"aLTEF","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"aLTEF":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>salt);
function salt() {
    const validChars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    let array = new Uint8Array(40);
    window.crypto.getRandomValues(array);
    array = array.map((x)=>validChars.charCodeAt(x % validChars.length));
    const randomState = String.fromCharCode.apply(null, array);
    return randomState;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"l7EsL":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "microsoftAuthCallback", ()=>microsoftAuthCallback);
var _generic = require("./generic");
const microsoftAuthCallback = (query)=>{
    return (0, _generic.sendGet)(`/MicrosoftAuthorization/Callback${query}`);
};

},{"./generic":"6oGDt","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"iV0if":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getDialogflowAuthUrl", ()=>getDialogflowAuthUrl);
parcelHelpers.export(exports, "getAvailableDialogflowCredentials", ()=>getAvailableDialogflowCredentials);
parcelHelpers.export(exports, "googleAuthCallback", ()=>googleAuthCallback);
parcelHelpers.export(exports, "removeGoogleCredentials", ()=>removeGoogleCredentials);
var _generic = require("./generic");
var _authSalt = require("../../services/authSalt");
var _authSaltDefault = parcelHelpers.interopDefault(_authSalt);
const getDialogflowAuthUrl = (authUrlRequest)=>{
    var csrfToken = (0, _authSaltDefault.default)();
    localStorage.setItem("google-salt", csrfToken);
    return (0, _generic.sendGet)("/GoogleAuthorization/AuthorizationUrl/Dialogflow?" + (0, _generic.queryStringSerialize)(authUrlRequest) + `&salt=${csrfToken}`);
};
const getAvailableDialogflowCredentials = (organizationId)=>{
    return (0, _generic.sendGet)(`/GoogleAuthorization/Credentials/${organizationId}`);
};
const googleAuthCallback = (query)=>{
    return (0, _generic.sendGet)(`/GoogleAuthorization/Callback${query}`);
};
const removeGoogleCredentials = (tokenId)=>{
    return (0, _generic.sendDelete)(`/GoogleAuthorization/Credentials/${tokenId}`);
};

},{"./generic":"6oGDt","../../services/authSalt":"aLTEF","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"e7vis":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getInteractionModel", ()=>getInteractionModel);
parcelHelpers.export(exports, "getInteractionModelByLocale", ()=>getInteractionModelByLocale);
parcelHelpers.export(exports, "commitUpdateToInteractionModel", ()=>commitUpdateToInteractionModel);
parcelHelpers.export(exports, "updateNlpEntitiesAndInteractionModelForApplication", ()=>updateNlpEntitiesAndInteractionModelForApplication);
parcelHelpers.export(exports, "getInteractionModelStatusPerEnvironment", ()=>getInteractionModelStatusPerEnvironment);
parcelHelpers.export(exports, "queueDeployments", ()=>queueDeployments);
var _generic = require("./generic");
const getInteractionModel = (applicationId)=>{
    return (0, _generic.sendGet)(`/InteractionModel/${applicationId}`);
};
const getInteractionModelByLocale = (applicationId, locale)=>{
    return (0, _generic.sendGet)(`/InteractionModel/${applicationId}?locale=${locale}`);
};
const commitUpdateToInteractionModel = (applicationId, locale, update)=>{
    return (0, _generic.sendPut)(`/InteractionModel/${applicationId}/${locale}`, update);
};
const updateNlpEntitiesAndInteractionModelForApplication = (applicationId, update)=>{
    return (0, _generic.sendPut)(`/InteractionModel/${applicationId}/entitiesAndInteractionModel`, update);
};
const getInteractionModelStatusPerEnvironment = (applicationId, environmentId)=>{
    return (0, _generic.sendGet)(`/InteractionModel/${applicationId}/environment/${environmentId}/status`);
};
const queueDeployments = (applicationId)=>{
    return (0, _generic.sendPut)(`/InteractionModel/${applicationId}/queueDeployments`, {});
};

},{"./generic":"6oGDt","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"awLb3":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getIntegrationsListings", ()=>getIntegrationsListings);
parcelHelpers.export(exports, "addIntegrationListing", ()=>addIntegrationListing);
parcelHelpers.export(exports, "removeIntegrationListing", ()=>removeIntegrationListing);
var _generic = require("./generic");
var _urls = require("../../constants/Urls");
const getIntegrationsListings = (organizationId)=>{
    return (0, _generic.sendGet)(`/integrations/listings/${organizationId}`, (0, _urls.getIntegrationsApiUrl)());
};
const addIntegrationListing = (organizationId, request)=>{
    return (0, _generic.sendPost)(`/integrations/listings/${organizationId}`, request, (0, _urls.getIntegrationsApiUrl)());
};
const removeIntegrationListing = (integrationListingId)=>{
    return (0, _generic.sendDelete)(`/integrations/listings/${integrationListingId}`, (0, _urls.getIntegrationsApiUrl)());
};

},{"./generic":"6oGDt","../../constants/Urls":"iTopY","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2NeNi":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getAllDeviceTargets", ()=>getAllDeviceTargets);
parcelHelpers.export(exports, "getDeviceTargets", ()=>getDeviceTargets);
var _generic = require("./generic");
const getAllDeviceTargets = ()=>{
    return (0, _generic.sendGet)("/DeviceTarget/");
};
const getDeviceTargets = (id)=>{
    return (0, _generic.sendGet)(`/DeviceTarget/${id}`);
};

},{"./generic":"6oGDt","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"cOA3L":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "parseSsml", ()=>parseSsml);
parcelHelpers.export(exports, "buildSsml", ()=>buildSsml);
parcelHelpers.export(exports, "segmentSsml", ()=>segmentSsml);
parcelHelpers.export(exports, "segmentAndBuildSsml", ()=>segmentAndBuildSsml);
parcelHelpers.export(exports, "segmentAndBuildMultiSsml", ()=>segmentAndBuildMultiSsml);
parcelHelpers.export(exports, "ssmlToSpeech", ()=>ssmlToSpeech);
parcelHelpers.export(exports, "validateSsml", ()=>validateSsml);
var _generic = require("./generic");
const parseSsml = (request)=>{
    return (0, _generic.sendPost)(`/Ssml/parse`, request);
};
const buildSsml = (request)=>{
    return (0, _generic.sendPost)(`/Ssml/build`, request);
};
const segmentSsml = (request, tag)=>{
    return (0, _generic.sendPost)(`/Ssml/segment?tag=${tag}`, request);
};
const segmentAndBuildSsml = (request, tag)=>{
    return (0, _generic.sendPost)(`/Ssml/segmentAndBuild?tag=${tag}`, request);
};
const segmentAndBuildMultiSsml = (request, tags)=>{
    return (0, _generic.sendPost)(`/Ssml/segmentAndBuildMulti?${tags.map((t)=>"tag=" + t)}`, request);
};
const ssmlToSpeech = (request, assistant)=>{
    return (0, _generic.sendPost)(`/Ssml/toSpeech/${assistant}`, request);
};
const validateSsml = (request, assistant)=>{
    return (0, _generic.sendPost)(`/Ssml/toSpeech/${assistant}`, request);
};

},{"./generic":"6oGDt","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7ukim":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getNumberRangesForModule", ()=>getNumberRangesForModule);
parcelHelpers.export(exports, "getNumberRangesForApp", ()=>getNumberRangesForApp);
parcelHelpers.export(exports, "getNumberRangesForAppFeature", ()=>getNumberRangesForAppFeature);
parcelHelpers.export(exports, "createFullNumberRange", ()=>createFullNumberRange);
parcelHelpers.export(exports, "createNumberRange", ()=>createNumberRange);
parcelHelpers.export(exports, "createNumberRangeStub", ()=>createNumberRangeStub);
parcelHelpers.export(exports, "toggleNumberRangeLive", ()=>toggleNumberRangeLive);
parcelHelpers.export(exports, "toggleNumberRangeSync", ()=>toggleNumberRangeSync);
parcelHelpers.export(exports, "updateFullNumberRange", ()=>updateFullNumberRange);
parcelHelpers.export(exports, "bulkUpdateNumberRange", ()=>bulkUpdateNumberRange);
parcelHelpers.export(exports, "bulkUpdateNumberRangeStub", ()=>bulkUpdateNumberRangeStub);
parcelHelpers.export(exports, "deleteNumberRange", ()=>deleteNumberRange);
parcelHelpers.export(exports, "findNumberRange", ()=>findNumberRange);
parcelHelpers.export(exports, "getNumberRangeWebhooks", ()=>getNumberRangeWebhooks);
parcelHelpers.export(exports, "removeNumberRangeWebhook", ()=>removeNumberRangeWebhook);
parcelHelpers.export(exports, "addNumberRangeWebhook", ()=>addNumberRangeWebhook);
parcelHelpers.export(exports, "updateNumberRangeWebhook", ()=>updateNumberRangeWebhook);
parcelHelpers.export(exports, "copyNumberRange", ()=>copyNumberRange);
parcelHelpers.export(exports, "bulkUpdateNumberRangeWebhookInstances", ()=>bulkUpdateNumberRangeWebhookInstances);
parcelHelpers.export(exports, "getNumberRangePublishHistory", ()=>getNumberRangePublishHistory);
var _generic = require("./generic");
const getNumberRangesForModule = (applicationModuleId)=>{
    return (0, _generic.sendGet)(`/NumberRange/module/${applicationModuleId}`);
};
const getNumberRangesForApp = (applicationId)=>{
    return (0, _generic.sendGet)(`/NumberRange/${applicationId}`);
};
const getNumberRangesForAppFeature = (applicationFeatureId)=>{
    return (0, _generic.sendGet)(`/NumberRange/byFeature/${applicationFeatureId}`);
};
const createFullNumberRange = (request)=>{
    return (0, _generic.sendPost)(`/NumberRange/full`, request);
};
const createNumberRange = (request)=>{
    return (0, _generic.sendPost)(`/NumberRange`, request);
};
const createNumberRangeStub = (request)=>{
    return (0, _generic.sendPost)(`/NumberRange/stub`, request);
};
const toggleNumberRangeLive = (numberRangeId, isLive)=>{
    return (0, _generic.sendPut)(`/NumberRange/${numberRangeId}/isLive`, {
        isLive
    });
};
const toggleNumberRangeSync = (numberRangeId, shouldNotSync)=>{
    return (0, _generic.sendPut)(`/NumberRange/${numberRangeId}/shouldNotSync`, {
        shouldNotSync
    });
};
const updateFullNumberRange = (numberRangeId, request)=>{
    return (0, _generic.sendPut)(`/NumberRange/${numberRangeId}/full`, request);
};
const bulkUpdateNumberRange = (numberRangeId, request)=>{
    return (0, _generic.sendPut)(`/NumberRange/${numberRangeId}/bulkUpdate`, request);
};
const bulkUpdateNumberRangeStub = (numberRangeId, request)=>{
    return (0, _generic.sendPut)(`/NumberRange/${numberRangeId}/bulkUpdate/stub`, request);
};
const deleteNumberRange = (numberRangeId)=>{
    return (0, _generic.sendDelete)(`/NumberRange/${numberRangeId}`);
};
const findNumberRange = (numberRangeId)=>{
    return (0, _generic.sendGet)(`/NumberRange/full/${numberRangeId}`);
};
const getNumberRangeWebhooks = (numberRangeId)=>{
    return (0, _generic.sendGet)(`/NumberRange/${numberRangeId}/webhooks`);
};
const removeNumberRangeWebhook = (numberRangeWebhookId)=>{
    return (0, _generic.sendDelete)(`/NumberRange/webhook/${numberRangeWebhookId}`);
};
const addNumberRangeWebhook = (numberRangeId, webhookId, defaultParameters, userDefinedParameters)=>{
    return (0, _generic.sendPost)(`/NumberRange/${numberRangeId}/webhooks/${webhookId}`, {
        values: defaultParameters,
        userDefinedParameters: userDefinedParameters
    });
};
const updateNumberRangeWebhook = (numberRangeId, webhookInstanceId, defaultParameters, userDefinedParameters)=>{
    return (0, _generic.sendPut)(`/NumberRange/${numberRangeId}/webhooks/${webhookInstanceId}`, {
        values: defaultParameters,
        userDefinedParameters: userDefinedParameters
    });
};
const copyNumberRange = (contentItemId)=>{
    return (0, _generic.sendPost)(`/NumberRange/${contentItemId}/copy`, null);
};
const bulkUpdateNumberRangeWebhookInstances = (contentItemId, updateRequest)=>{
    return (0, _generic.sendPut)(`/NumberRange/${contentItemId}/webhooks/bulk`, updateRequest);
};
const getNumberRangePublishHistory = (contentItemId, environmentId, skip, take)=>{
    return (0, _generic.sendGet)(`/NumberRange/${contentItemId}/publishes/forenvironment/${environmentId}?skip=${skip}&take=${take}`);
};

},{"./generic":"6oGDt","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"ksHgK":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getSimpleChoicesForModule", ()=>getSimpleChoicesForModule);
parcelHelpers.export(exports, "getSimpleChoicesForApp", ()=>getSimpleChoicesForApp);
parcelHelpers.export(exports, "getSimpleChoicesForAppFeature", ()=>getSimpleChoicesForAppFeature);
parcelHelpers.export(exports, "createFullSimpleChoice", ()=>createFullSimpleChoice);
parcelHelpers.export(exports, "createSimpleChoice", ()=>createSimpleChoice);
parcelHelpers.export(exports, "createSimpleChoiceStub", ()=>createSimpleChoiceStub);
parcelHelpers.export(exports, "toggleSimpleChoiceLive", ()=>toggleSimpleChoiceLive);
parcelHelpers.export(exports, "toggleSimpleChoiceSync", ()=>toggleSimpleChoiceSync);
parcelHelpers.export(exports, "updateFullSimpleChoice", ()=>updateFullSimpleChoice);
parcelHelpers.export(exports, "bulkUpdateSimpleChoice", ()=>bulkUpdateSimpleChoice);
parcelHelpers.export(exports, "bulkUpdateSimpleChoiceStub", ()=>bulkUpdateSimpleChoiceStub);
parcelHelpers.export(exports, "deleteSimpleChoice", ()=>deleteSimpleChoice);
parcelHelpers.export(exports, "findSimpleChoice", ()=>findSimpleChoice);
parcelHelpers.export(exports, "getSimpleChoiceWebhooks", ()=>getSimpleChoiceWebhooks);
parcelHelpers.export(exports, "removeSimpleChoiceWebhook", ()=>removeSimpleChoiceWebhook);
parcelHelpers.export(exports, "addSimpleChoiceWebhook", ()=>addSimpleChoiceWebhook);
parcelHelpers.export(exports, "updateSimpleChoiceWebhook", ()=>updateSimpleChoiceWebhook);
parcelHelpers.export(exports, "copySimpleChoice", ()=>copySimpleChoice);
parcelHelpers.export(exports, "bulkUpdateSimpleChoiceWebhookInstances", ()=>bulkUpdateSimpleChoiceWebhookInstances);
parcelHelpers.export(exports, "getSimpleChoicePublishHistory", ()=>getSimpleChoicePublishHistory);
var _generic = require("./generic");
const getSimpleChoicesForModule = (applicationModuleId)=>{
    return (0, _generic.sendGet)(`/SimpleChoice/module/${applicationModuleId}`);
};
const getSimpleChoicesForApp = (applicationId)=>{
    return (0, _generic.sendGet)(`/SimpleChoice/${applicationId}`);
};
const getSimpleChoicesForAppFeature = (applicationFeatureId)=>{
    return (0, _generic.sendGet)(`/SimpleChoice/byFeature/${applicationFeatureId}`);
};
const createFullSimpleChoice = (request)=>{
    return (0, _generic.sendPost)(`/SimpleChoice/full`, request);
};
const createSimpleChoice = (request)=>{
    return (0, _generic.sendPost)(`/SimpleChoice`, request);
};
const createSimpleChoiceStub = (request)=>{
    return (0, _generic.sendPost)(`/SimpleChoice/stub`, request);
};
const toggleSimpleChoiceLive = (simpleChoiceId, isLive)=>{
    return (0, _generic.sendPut)(`/SimpleChoice/${simpleChoiceId}/isLive`, {
        isLive
    });
};
const toggleSimpleChoiceSync = (simpleChoiceId, shouldNotSync)=>{
    return (0, _generic.sendPut)(`/SimpleChoice/${simpleChoiceId}/shouldNotSync`, {
        shouldNotSync
    });
};
const updateFullSimpleChoice = (simpleChoiceId, request)=>{
    return (0, _generic.sendPut)(`/SimpleChoice/${simpleChoiceId}/full`, request);
};
const bulkUpdateSimpleChoice = (simpleChoiceId, request)=>{
    return (0, _generic.sendPut)(`/SimpleChoice/${simpleChoiceId}/bulkUpdate`, request);
};
const bulkUpdateSimpleChoiceStub = (simpleChoiceId, request)=>{
    return (0, _generic.sendPut)(`/SimpleChoice/${simpleChoiceId}/bulkUpdate/stub`, request);
};
const deleteSimpleChoice = (simpleChoiceId)=>{
    return (0, _generic.sendDelete)(`/SimpleChoice/${simpleChoiceId}`);
};
const findSimpleChoice = (simpleChoiceId)=>{
    return (0, _generic.sendGet)(`/SimpleChoice/full/${simpleChoiceId}`);
};
const getSimpleChoiceWebhooks = (simpleChoiceId)=>{
    return (0, _generic.sendGet)(`/SimpleChoice/${simpleChoiceId}/webhooks`);
};
const removeSimpleChoiceWebhook = (simpleChoiceWebhookId)=>{
    return (0, _generic.sendDelete)(`/SimpleChoice/webhook/${simpleChoiceWebhookId}`);
};
const addSimpleChoiceWebhook = (simpleChoiceId, webhookId, defaultParameters, userDefinedParameters)=>{
    return (0, _generic.sendPost)(`/SimpleChoice/${simpleChoiceId}/webhooks/${webhookId}`, {
        values: defaultParameters,
        userDefinedParameters: userDefinedParameters
    });
};
const updateSimpleChoiceWebhook = (simpleChoiceId, webhookInstanceId, defaultParameters, userDefinedParameters)=>{
    return (0, _generic.sendPut)(`/SimpleChoice/${simpleChoiceId}/webhooks/${webhookInstanceId}`, {
        values: defaultParameters,
        userDefinedParameters: userDefinedParameters
    });
};
const copySimpleChoice = (contentItemId)=>{
    return (0, _generic.sendPost)(`/SimpleChoice/${contentItemId}/copy`, null);
};
const bulkUpdateSimpleChoiceWebhookInstances = (contentItemId, updateRequest)=>{
    return (0, _generic.sendPut)(`/SimpleChoice/${contentItemId}/webhooks/bulk`, updateRequest);
};
const getSimpleChoicePublishHistory = (contentItemId, environmentId, skip, take)=>{
    return (0, _generic.sendGet)(`/SimpleChoice/${contentItemId}/publishes/forenvironment/${environmentId}?skip=${skip}&take=${take}`);
};

},{"./generic":"6oGDt","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"cUnTL":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "listLuisAppsForEnvironment", ()=>listLuisAppsForEnvironment);
parcelHelpers.export(exports, "getEnvironmentDeploymentInfoForMicrosoft", ()=>getEnvironmentDeploymentInfoForMicrosoft);
parcelHelpers.export(exports, "linkLuisPredictionResourcesToEnvironment", ()=>linkLuisPredictionResourcesToEnvironment);
parcelHelpers.export(exports, "linkLuisKeyToEnvironment", ()=>linkLuisKeyToEnvironment);
parcelHelpers.export(exports, "createAndDeployEnvironmentNewLuisApp", ()=>createAndDeployEnvironmentNewLuisApp);
parcelHelpers.export(exports, "linkLuisAppToEnvironment", ()=>linkLuisAppToEnvironment);
parcelHelpers.export(exports, "unlinkBotServiceFromEnvironment", ()=>unlinkBotServiceFromEnvironment);
parcelHelpers.export(exports, "unlinkLuisFromEnvironment", ()=>unlinkLuisFromEnvironment);
parcelHelpers.export(exports, "linkBotServiceToEnvironment", ()=>linkBotServiceToEnvironment);
var _generic = require("./generic");
var _urls = require("../../constants/Urls");
const defaultLuisRegion = "westus";
const listLuisAppsForEnvironment = (applicationId, environmentId)=>{
    return (0, _generic.sendGet)(`${(0, _urls.PLATFORM_AZURE)}/${applicationId}/environment/${environmentId}/luisApps`);
};
const getEnvironmentDeploymentInfoForMicrosoft = (applicationId, environmentId)=>{
    return (0, _generic.sendGet)(`${(0, _urls.PLATFORM_AZURE)}/${applicationId}/environment/${environmentId}/link`);
};
const linkLuisPredictionResourcesToEnvironment = (applicationId, environmentId, luisKey, luisRegion, luisEndpoint)=>{
    return (0, _generic.sendPut)(`${(0, _urls.PLATFORM_AZURE)}/${applicationId}/environment/${environmentId}/luisPredictionResources`, {
        luisPredictionKey: luisKey,
        luisPredictionRegion: luisRegion,
        luisPredictionEndpoint: luisEndpoint
    });
};
const linkLuisKeyToEnvironment = (applicationId, environmentId, luisKey)=>{
    return (0, _generic.sendPut)(`${(0, _urls.PLATFORM_AZURE)}/${applicationId}/environment/${environmentId}/luisKey/${luisKey}`, {});
};
const createAndDeployEnvironmentNewLuisApp = (applicationId, environmentId, luisRegion = defaultLuisRegion)=>{
    return (0, _generic.sendPost)(`${(0, _urls.PLATFORM_AZURE)}/${applicationId}/environment/${environmentId}/createAndDeploy?luisRegion=${luisRegion}`, {});
};
const linkLuisAppToEnvironment = (applicationId, environmentId, luisAppId, luisRegion)=>{
    return (0, _generic.sendPut)(`${(0, _urls.PLATFORM_AZURE)}/${applicationId}/environment/${environmentId}/${luisAppId}?luisRegion=${luisRegion}`, {});
};
const unlinkBotServiceFromEnvironment = (applicationId, environmentId)=>{
    return (0, _generic.sendDelete)(`${(0, _urls.PLATFORM_AZURE)}/${applicationId}/environment/${environmentId}/microsoftProject`);
};
const unlinkLuisFromEnvironment = (applicationId, environmentId)=>{
    return (0, _generic.sendDelete)(`${(0, _urls.PLATFORM_AZURE)}/${applicationId}/environment/${environmentId}/luisApp`);
};
const linkBotServiceToEnvironment = (applicationId, environmentId, botServiceName, microsoftAppId, microsoftAppPassword)=>{
    return (0, _generic.sendPut)(`${(0, _urls.PLATFORM_AZURE)}/${applicationId}/environment/${environmentId}/microsoftProject`, {
        microsoftAppId,
        microsoftAppPassword,
        botServiceName
    });
};

},{"./generic":"6oGDt","../../constants/Urls":"iTopY","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"lt5ki":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getIntegrationSetup", ()=>getIntegrationSetup);
parcelHelpers.export(exports, "sendIntegrationConfiguration", ()=>sendIntegrationConfiguration);
parcelHelpers.export(exports, "sendIntegrationOauthResult", ()=>sendIntegrationOauthResult);
var _generic = require("./generic");
var _urls = require("../../constants/Urls");
const getIntegrationSetup = (organizationId, integrationListingId)=>{
    return (0, _generic.sendGet)(`/setup/${organizationId}/${integrationListingId}`, (0, _urls.getIntegrationsApiUrl)());
};
const sendIntegrationConfiguration = (organizationId, integrationListingId, setupRequest)=>{
    return (0, _generic.sendPost)(`/setup/${organizationId}/${integrationListingId}/config`, setupRequest, (0, _urls.getIntegrationsApiUrl)());
};
const sendIntegrationOauthResult = (organizationId, request, search)=>{
    return (0, _generic.sendPost)(`/setup/${organizationId}/oAuth${search}`, request, (0, _urls.getIntegrationsApiUrl)());
};

},{"./generic":"6oGDt","../../constants/Urls":"iTopY","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"b2naN":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getLatestTerm", ()=>getLatestTerm);
parcelHelpers.export(exports, "createUserTerm", ()=>createUserTerm);
var _generic = require("./generic");
const getLatestTerm = ()=>{
    return (0, _generic.sendGet)(`/Term/latest`);
};
const createUserTerm = (model)=>{
    return (0, _generic.sendPost)(`/Term/agreement`, model);
};

},{"./generic":"6oGDt","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1yMkz":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getCustomRequestsForModule", ()=>getCustomRequestsForModule);
parcelHelpers.export(exports, "getCustomRequestsForApp", ()=>getCustomRequestsForApp);
parcelHelpers.export(exports, "getCustomRequestsForAppFeature", ()=>getCustomRequestsForAppFeature);
parcelHelpers.export(exports, "createFullCustomRequest", ()=>createFullCustomRequest);
parcelHelpers.export(exports, "createCustomRequest", ()=>createCustomRequest);
parcelHelpers.export(exports, "createCustomRequestStub", ()=>createCustomRequestStub);
parcelHelpers.export(exports, "toggleCustomRequestLive", ()=>toggleCustomRequestLive);
parcelHelpers.export(exports, "toggleCustomRequestSync", ()=>toggleCustomRequestSync);
parcelHelpers.export(exports, "updateFullCustomRequest", ()=>updateFullCustomRequest);
parcelHelpers.export(exports, "bulkUpdateCustomRequest", ()=>bulkUpdateCustomRequest);
parcelHelpers.export(exports, "bulkUpdateCustomRequestStub", ()=>bulkUpdateCustomRequestStub);
parcelHelpers.export(exports, "deleteCustomRequest", ()=>deleteCustomRequest);
parcelHelpers.export(exports, "findCustomRequest", ()=>findCustomRequest);
parcelHelpers.export(exports, "getCustomRequestWebhooks", ()=>getCustomRequestWebhooks);
parcelHelpers.export(exports, "removeCustomRequestWebhook", ()=>removeCustomRequestWebhook);
parcelHelpers.export(exports, "addCustomRequestWebhook", ()=>addCustomRequestWebhook);
parcelHelpers.export(exports, "updateCustomRequestWebhook", ()=>updateCustomRequestWebhook);
parcelHelpers.export(exports, "copyCustomRequest", ()=>copyCustomRequest);
parcelHelpers.export(exports, "bulkUpdateCustomRequestWebhookInstances", ()=>bulkUpdateCustomRequestWebhookInstances);
parcelHelpers.export(exports, "getCustomRequestPublishHistory", ()=>getCustomRequestPublishHistory);
var _generic = require("./generic");
const getCustomRequestsForModule = (applicationModuleId)=>{
    return (0, _generic.sendGet)(`/customRequest/module/${applicationModuleId}`);
};
const getCustomRequestsForApp = (applicationId)=>{
    return (0, _generic.sendGet)(`/customRequest/${applicationId}`);
};
const getCustomRequestsForAppFeature = (applicationFeatureId)=>{
    return (0, _generic.sendGet)(`/customRequest/byFeature/${applicationFeatureId}`);
};
const createFullCustomRequest = (request)=>{
    return (0, _generic.sendPost)(`/customRequest/full`, request);
};
const createCustomRequest = (request)=>{
    return (0, _generic.sendPost)(`/customRequest/`, request);
};
const createCustomRequestStub = (request)=>{
    return (0, _generic.sendPost)(`/customRequest/stub`, request);
};
const toggleCustomRequestLive = (customRequestId, isLive)=>{
    return (0, _generic.sendPut)(`/CustomRequest/${customRequestId}/isLive`, {
        isLive
    });
};
const toggleCustomRequestSync = (customRequestId, shouldNotSync)=>{
    return (0, _generic.sendPut)(`/CustomRequest/${customRequestId}/shouldNotSync`, {
        shouldNotSync
    });
};
const updateFullCustomRequest = (customRequestId, request)=>{
    return (0, _generic.sendPut)(`/CustomRequest/${customRequestId}/full`, request);
};
const bulkUpdateCustomRequest = (customRequestId, request)=>{
    return (0, _generic.sendPut)(`/CustomRequest/${customRequestId}/bulkUpdate`, request);
};
const bulkUpdateCustomRequestStub = (customRequestId, request)=>{
    return (0, _generic.sendPut)(`/CustomRequest/${customRequestId}/bulkUpdate/stub`, request);
};
const deleteCustomRequest = (customRequestId)=>{
    return (0, _generic.sendDelete)(`/CustomRequest/${customRequestId}`);
};
const findCustomRequest = (customRequestId)=>{
    return (0, _generic.sendGet)(`/CustomRequest/full/${customRequestId}`);
};
const getCustomRequestWebhooks = (customRequestId)=>{
    return (0, _generic.sendGet)(`/CustomRequest/${customRequestId}/webhooks`);
};
const removeCustomRequestWebhook = (customRequestWebhookId)=>{
    return (0, _generic.sendDelete)(`/CustomRequest/webhook/${customRequestWebhookId}`);
};
const addCustomRequestWebhook = (customRequestId, webhookId, defaultParameters, userDefinedParameters)=>{
    return (0, _generic.sendPost)(`/CustomRequest/${customRequestId}/webhooks/${webhookId}`, {
        values: defaultParameters,
        userDefinedParameters: userDefinedParameters
    });
};
const updateCustomRequestWebhook = (questionAnswerId, webhookInstanceId, defaultParameters, userDefinedParameters)=>{
    return (0, _generic.sendPut)(`/CustomRequest/${questionAnswerId}/webhooks/${webhookInstanceId}`, {
        values: defaultParameters,
        userDefinedParameters: userDefinedParameters
    });
};
const copyCustomRequest = (contentItemId)=>{
    return (0, _generic.sendPost)(`/CustomRequest/${contentItemId}/copy`, null);
};
const bulkUpdateCustomRequestWebhookInstances = (contentItemId, updateRequest)=>{
    return (0, _generic.sendPut)(`/CustomRequest/${contentItemId}/webhooks/bulk`, updateRequest);
};
const getCustomRequestPublishHistory = (contentItemId, environmentId, skip, take)=>{
    return (0, _generic.sendGet)(`/CustomRequest/${contentItemId}/publishes/forenvironment/${environmentId}?skip=${skip}&take=${take}`);
};

},{"./generic":"6oGDt","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"lPl0O":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "sendCustomAssistantRequest", ()=>sendCustomAssistantRequest);
parcelHelpers.export(exports, "generateSessionToken", ()=>generateSessionToken);
var _generic = require("./generic");
var _urls = require("../../constants/Urls");
const sendCustomAssistantRequest = (applicationId, applicationSecret, request, useDraftContent, includeSessionAttributes, includeNlp, includeUserAttributes)=>{
    return (0, _generic.sendPost)(`/CustomAssistant/HandleRequest?applicationId=${applicationId}&applicationSecret=${applicationSecret}&useDraftContent=${useDraftContent}&includeSessionAttributes=${includeSessionAttributes}&includeNlp=${includeNlp}&includeUserAttributes=${includeUserAttributes}`, request, (0, _urls.getAssistantApiUrl)());
};
const generateSessionToken = (applicationId, applicationSecret, environmentId, sessionId)=>{
    return (0, _generic.sendPost)(`/Token/GenerateForSession`, {
        applicationId: applicationId,
        applicationSecret: applicationSecret,
        environmentId: environmentId,
        sessionId: sessionId
    }, (0, _urls.getAssistantApiUrl)());
};

},{"./generic":"6oGDt","../../constants/Urls":"iTopY","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"f5YJE":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getAllLanguages", ()=>getAllLanguages);
var _generic = require("./generic");
const getAllLanguages = ()=>{
    return (0, _generic.sendGet)(`/ContentLanguage/all`);
};

},{"./generic":"6oGDt","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6RDXX":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "bulkMoveTo", ()=>bulkMoveTo);
parcelHelpers.export(exports, "bulkCopyTo", ()=>bulkCopyTo);
parcelHelpers.export(exports, "bulkDisableAndDelete", ()=>bulkDisableAndDelete);
parcelHelpers.export(exports, "bulkLoadDetails", ()=>bulkLoadDetails);
var _generic = require("./generic");
const bulkMoveTo = (applicationFeatureId, request)=>{
    return (0, _generic.sendPut)(`/BulkContent/MoveToFeature/${applicationFeatureId}`, request);
};
const bulkCopyTo = (applicationFeatureId, request)=>{
    return (0, _generic.sendPut)(`/BulkContent/CopyToFeature/${applicationFeatureId}`, request);
};
const bulkDisableAndDelete = (request)=>{
    return (0, _generic.sendPut)(`/BulkContent/Delete/`, request);
};
const bulkLoadDetails = (request)=>{
    return (0, _generic.sendPost)(`/BulkContent/LoadDetails/`, request);
};

},{"./generic":"6oGDt","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3d3Hg":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getAllNotifications", ()=>getAllNotifications);
parcelHelpers.export(exports, "markNotificationAsRead", ()=>markNotificationAsRead);
parcelHelpers.export(exports, "markAllNotificationsAsRead", ()=>markAllNotificationsAsRead);
var _generic = require("./generic");
var _urls = require("../../constants/Urls");
const getAllNotifications = ()=>{
    return (0, _generic.sendGet)(`${(0, _urls.GET_NOTIFICATIONS)}/all`);
};
const markNotificationAsRead = (notificationId)=>{
    return (0, _generic.sendPut)(`${(0, _urls.GET_NOTIFICATIONS)}/${notificationId}/read`, {});
};
const markAllNotificationsAsRead = ()=>{
    return (0, _generic.sendPut)(`${(0, _urls.GET_NOTIFICATIONS)}/read`, {});
};

},{"./generic":"6oGDt","../../constants/Urls":"iTopY","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"dB0jz":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "exportContentToFile", ()=>exportContentToFile);
parcelHelpers.export(exports, "exportWebhooksToFile", ()=>exportWebhooksToFile);
parcelHelpers.export(exports, "importToAppFeature", ()=>importToAppFeature);
parcelHelpers.export(exports, "importToWebhookFolder", ()=>importToWebhookFolder);
var _generic = require("./generic");
const exportContentToFile = (request)=>{
    return (0, _generic.sendPostForFile)(`/importExport/export/contentToFile`, request);
};
const exportWebhooksToFile = (request)=>{
    return (0, _generic.sendPostForFile)(`/importExport/export/webhooksToFile`, request);
};
const importToAppFeature = (applicationFeatureId, file)=>{
    return (0, _generic.uploadFile)(`/importExport/import/intoApplicationFeatureFromFile/${applicationFeatureId}`, file);
};
const importToWebhookFolder = (targetFolderId, applicationId, file)=>{
    return (0, _generic.uploadFile)(`/importExport/import/intoApplication/${applicationId}/intoWebhookFolderFromFile?folderId=${targetFolderId}`, file);
};

},{"./generic":"6oGDt","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"f85QB":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getSessionAttributes", ()=>getSessionAttributes);
var _urls = require("../../constants/Urls");
var _generic = require("./generic");
const getSessionAttributes = (sessionId, applicationId, applicationSecret)=>{
    return (0, _generic.sendGet)(`/UserProfile/session/${sessionId}?applicationId=${applicationId}&applicationSecret=${applicationSecret}`, (0, _urls.getAssistantApiUrl)());
};

},{"../../constants/Urls":"iTopY","./generic":"6oGDt","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3uWdd":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getAvailableTemplateConfigurations", ()=>getAvailableTemplateConfigurations);
parcelHelpers.export(exports, "getOrganizationTemplateConfigurations", ()=>getOrganizationTemplateConfigurations);
parcelHelpers.export(exports, "getPrivateTemplateConfigurations", ()=>getPrivateTemplateConfigurations);
parcelHelpers.export(exports, "createTemplateConfiguration", ()=>createTemplateConfiguration);
parcelHelpers.export(exports, "updateTemplateConfiguration", ()=>updateTemplateConfiguration);
parcelHelpers.export(exports, "disableTemplateConfiguration", ()=>disableTemplateConfiguration);
parcelHelpers.export(exports, "enableTemplateConfiguration", ()=>enableTemplateConfiguration);
parcelHelpers.export(exports, "getTemplateCategories", ()=>getTemplateCategories);
parcelHelpers.export(exports, "getTemplateIndustries", ()=>getTemplateIndustries);
parcelHelpers.export(exports, "getAppliedTemplateFormCounts", ()=>getAppliedTemplateFormCounts);
var _generic = require("./generic");
const getAvailableTemplateConfigurations = (organizationId, filter)=>{
    return (0, _generic.sendGet)(`/TemplateConfiguration/${organizationId}/available?${(0, _generic.queryStringSerialize)(filter)}`);
};
const getOrganizationTemplateConfigurations = (organizationId)=>{
    return (0, _generic.sendGet)(`/TemplateConfiguration/${organizationId}`);
};
const getPrivateTemplateConfigurations = (organizationId)=>{
    return (0, _generic.sendGet)(`/TemplateConfiguration/${organizationId}/private`);
};
const createTemplateConfiguration = (request)=>{
    return (0, _generic.sendPost)(`/TemplateConfiguration/`, request);
};
const updateTemplateConfiguration = (templateConfigurationId, request)=>{
    return (0, _generic.sendPut)(`/TemplateConfiguration/${templateConfigurationId}`, request);
};
const disableTemplateConfiguration = (templateConfigurationId)=>{
    return (0, _generic.sendPut)(`/TemplateConfiguration/${templateConfigurationId}/disable`, null);
};
const enableTemplateConfiguration = (templateConfigurationId)=>{
    return (0, _generic.sendPut)(`/TemplateConfiguration/${templateConfigurationId}/enable`, null);
};
const getTemplateCategories = ()=>{
    return (0, _generic.sendGet)(`/TemplateConfiguration/categories`);
};
const getTemplateIndustries = ()=>{
    return (0, _generic.sendGet)(`/TemplateConfiguration/industries`);
};
const getAppliedTemplateFormCounts = (templateConfigurationId)=>{
    return (0, _generic.sendGet)(`/TemplateConfiguration/${templateConfigurationId}/appliedTemplateFormCounts`);
};

},{"./generic":"6oGDt","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"66oOj":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getAppliedApplicationTemplatesForApp", ()=>getAppliedApplicationTemplatesForApp);
parcelHelpers.export(exports, "findAppliedApplicationTemplate", ()=>findAppliedApplicationTemplate);
parcelHelpers.export(exports, "deleteAppliedApplicationTemplate", ()=>deleteAppliedApplicationTemplate);
parcelHelpers.export(exports, "updateAppliedApplicationTemplate", ()=>updateAppliedApplicationTemplate);
parcelHelpers.export(exports, "addAppliedApplicationTemplate", ()=>addAppliedApplicationTemplate);
parcelHelpers.export(exports, "autoGenerateAppliedApplicationTemplateFieldValues", ()=>autoGenerateAppliedApplicationTemplateFieldValues);
parcelHelpers.export(exports, "finishTemplateSection", ()=>finishTemplateSection);
parcelHelpers.export(exports, "finalizeDynamicForm", ()=>finalizeDynamicForm);
var _generic = require("./generic");
const getAppliedApplicationTemplatesForApp = (applicationId)=>{
    return (0, _generic.sendGet)(`/AppliedApplicationTemplate/forApp/${applicationId}`);
};
const findAppliedApplicationTemplate = (appliedApplicationTemplateId)=>{
    return (0, _generic.sendGet)(`/AppliedApplicationTemplate/${appliedApplicationTemplateId}`);
};
const deleteAppliedApplicationTemplate = (appliedApplicationTemplateId)=>{
    return (0, _generic.sendDelete)(`/AppliedApplicationTemplate/${appliedApplicationTemplateId}`);
};
const updateAppliedApplicationTemplate = (appliedApplicationTemplateId, model)=>{
    return (0, _generic.sendPut)(`/AppliedApplicationTemplate/${appliedApplicationTemplateId}`, model);
};
const addAppliedApplicationTemplate = (applicationId, tempalteConfigId)=>{
    return (0, _generic.sendPost)(`/AppliedApplicationTemplate/${applicationId}/add/${tempalteConfigId}`, {});
};
const autoGenerateAppliedApplicationTemplateFieldValues = (applicationId, request)=>{
    return (0, _generic.sendPost)(`/AppliedApplicationTemplate/${applicationId}/answers/generate`, request);
};
const finishTemplateSection = (appliedApplicationTemplateId, request)=>{
    return (0, _generic.sendPut)(`/AppliedApplicationTemplate/${appliedApplicationTemplateId}/finishSection`, request);
};
const finalizeDynamicForm = (appliedApplicationTemplateId, request)=>{
    return (0, _generic.sendPut)(`/AppliedApplicationTemplate/${appliedApplicationTemplateId}/finalizeForm`, request);
};

},{"./generic":"6oGDt","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"lVRFt":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createApplicationFromTemplateForms", ()=>createApplicationFromTemplateForms);
parcelHelpers.export(exports, "updateApplicationFromTemplateForms", ()=>updateApplicationFromTemplateForms);
parcelHelpers.export(exports, "removeAppliedApplicationTemplate", ()=>removeAppliedApplicationTemplate);
var _generic = require("./generic");
const createApplicationFromTemplateForms = (request)=>{
    return (0, _generic.sendPost)(`/ApplicationTemplating/createFromForm`, request);
};
const updateApplicationFromTemplateForms = (applicationId, appliedTemplateFormId, request)=>{
    return (0, _generic.sendPut)(`/ApplicationTemplating/${applicationId}/UpdateAppliedApplicationTemplateForm/${appliedTemplateFormId}`, request);
};
const removeAppliedApplicationTemplate = (applicationId, appliedTemplateFormId)=>{
    return (0, _generic.sendDelete)(`/ApplicationTemplating/${applicationId}/RemoveAppliedApplicationTemplateForm/${appliedTemplateFormId}`);
};

},{"./generic":"6oGDt","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3pvyQ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getUserApplicationPreferences", ()=>getUserApplicationPreferences);
parcelHelpers.export(exports, "deleteSimulatorPinnedMessage", ()=>deleteSimulatorPinnedMessage);
parcelHelpers.export(exports, "addSimulatorPinnedMessage", ()=>addSimulatorPinnedMessage);
var _generic = require("./generic");
const getUserApplicationPreferences = (applicationId)=>{
    return (0, _generic.sendGet)(`/UserApplicationPreferences/${applicationId}`);
};
const deleteSimulatorPinnedMessage = (applicationId, pinnedMessageId)=>{
    return (0, _generic.sendDelete)(`/UserApplicationPreferences/application/${applicationId}/simulatorPinnedMessage/${pinnedMessageId}`);
};
const addSimulatorPinnedMessage = (request)=>{
    return (0, _generic.sendPost)(`/UserApplicationPreferences/SimulatorPinnedMessage`, request);
};

},{"./generic":"6oGDt","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2XUkz":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getApplicationConversationTracking", ()=>getApplicationConversationTracking);
parcelHelpers.export(exports, "getContentConversationTracking", ()=>getContentConversationTracking);
var _urls = require("../../constants/Urls");
var _generic = require("./generic");
const getApplicationConversationTracking = (applicationId, filter)=>{
    return (0, _generic.sendGet)(`/ConversationTracking/application/${applicationId}?${buildQuery(filter)}`, (0, _urls.getAnalyticsApiUrl)());
};
const getContentConversationTracking = (applicationId, contentId, filter)=>{
    return (0, _generic.sendGet)(`/ConversationTracking/content/${applicationId}/${contentId}?${buildQuery(filter)}`, (0, _urls.getAnalyticsApiUrl)());
};
const buildQuery = (filter)=>{
    var startDate = new Date(filter.startDate).toISOString();
    var endDate = new Date(filter.endDate).toISOString();
    let query = `startDate=${startDate}&endDate=${endDate}`;
    if (filter.assistants?.length > 0) query += "&assistants=" + filter.assistants.join("&assistants=");
    if (filter.userIds?.length > 0) query += "&userIds=" + filter.userIds.join("&userIds=");
    if (filter.sessionIds?.length > 0) query += "&sessionIds=" + filter.sessionIds.join("&sessionIds=");
    if (filter.deviceTargetIds?.length > 0) query += "&deviceTargetIds=" + filter.deviceTargetIds.join("&deviceTargetIds=");
    if (filter.languageIds?.length > 0) query += "&languageIds=" + filter.languageIds.join("&languageIds=");
    return query;
};

},{"../../constants/Urls":"iTopY","./generic":"6oGDt","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"k92ch":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getOrganizationSubscriptions", ()=>getOrganizationSubscriptions);
parcelHelpers.export(exports, "getOrganizationSubscription", ()=>getOrganizationSubscription);
var _urls = require("../../constants/Urls");
var _generic = require("./generic");
const getOrganizationSubscriptions = (organizationId)=>{
    return (0, _generic.sendGet)(`${(0, _urls.GET_SUBSCRIPTIONS)}/forOrganization/${organizationId}`);
};
const getOrganizationSubscription = (organizationId)=>{
    return (0, _generic.sendGet)(`${(0, _urls.GET_SUBSCRIPTIONS)}/${organizationId}/default`);
};

},{"../../constants/Urls":"iTopY","./generic":"6oGDt","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"ixGyD":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getWebhookFolder", ()=>getWebhookFolder);
parcelHelpers.export(exports, "getWebhookFoldersForApplication", ()=>getWebhookFoldersForApplication);
parcelHelpers.export(exports, "createWebhookFolder", ()=>createWebhookFolder);
parcelHelpers.export(exports, "updateWebhookFolder", ()=>updateWebhookFolder);
parcelHelpers.export(exports, "deleteWebhookFolder", ()=>deleteWebhookFolder);
parcelHelpers.export(exports, "setWebhookFolderOrder", ()=>setWebhookFolderOrder);
parcelHelpers.export(exports, "moveWebhooksAndFoldersToFolder", ()=>moveWebhooksAndFoldersToFolder);
parcelHelpers.export(exports, "copyWebhooksAndFoldersToFolder", ()=>copyWebhooksAndFoldersToFolder);
parcelHelpers.export(exports, "bulkDeleteWebhooksAndFolders", ()=>bulkDeleteWebhooksAndFolders);
var _generic = require("./generic");
const getWebhookFolder = (folderId)=>{
    return (0, _generic.sendGet)(`/WebhookFolder/${folderId}`);
};
const getWebhookFoldersForApplication = (applicationId)=>{
    return (0, _generic.sendGet)(`/WebhookFolder/forApplication/${applicationId}`);
};
const createWebhookFolder = (model)=>{
    return (0, _generic.sendPost)(`/WebhookFolder`, model);
};
const updateWebhookFolder = (folderId, model)=>{
    return (0, _generic.sendPut)(`/WebhookFolder/${folderId}`, model);
};
const deleteWebhookFolder = (folderId)=>{
    return (0, _generic.sendDelete)(`/WebhookFolder/${folderId}`);
};
const setWebhookFolderOrder = (applicationId, parentFolderId, folderIds)=>{
    return (0, _generic.sendPut)(`/WebhookFolder/${applicationId}/reorder?parentFolderId=${parentFolderId ? parentFolderId : ""}`, folderIds);
};
const moveWebhooksAndFoldersToFolder = (folderId, request)=>{
    return (0, _generic.sendPut)(`/WebhookFolder/moveToFolder?folderId=${folderId}`, request);
};
const copyWebhooksAndFoldersToFolder = (folderId, request)=>{
    return (0, _generic.sendPut)(`/WebhookFolder/copyToFolder?folderId=${folderId}`, request);
};
const bulkDeleteWebhooksAndFolders = (request)=>{
    return (0, _generic.sendPut)(`/WebhookFolder/bulkDelete`, request);
};

},{"./generic":"6oGDt","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"leENw":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createOrganizationAdminApiKey", ()=>createOrganizationAdminApiKey);
parcelHelpers.export(exports, "getOrganizationApiKeys", ()=>getOrganizationApiKeys);
parcelHelpers.export(exports, "deleteApiKey", ()=>deleteApiKey);
var _generic = require("./generic");
const createOrganizationAdminApiKey = (organizationId, request)=>{
    return (0, _generic.sendPost)(`/ApiKey/organization/${organizationId}/admin`, request);
};
const getOrganizationApiKeys = (organizationId)=>{
    return (0, _generic.sendGet)(`/ApiKey/organization/${organizationId}`);
};
const deleteApiKey = (apiKeyId)=>{
    return (0, _generic.sendDelete)(`/ApiKey/${apiKeyId}`);
};

},{"./generic":"6oGDt","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"iv4U3":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getConditions", ()=>getConditions);
var _generic = require("./generic");
const getConditions = ()=>{
    return (0, _generic.sendGet)(`/Condition`);
};

},{"./generic":"6oGDt","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"i7FBj":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "queueUpdateApplicationFromTemplateFormsSync", ()=>queueUpdateApplicationFromTemplateFormsSync);
parcelHelpers.export(exports, "queueUpdateApplicationFromTemplateFormsDynamicSync", ()=>queueUpdateApplicationFromTemplateFormsDynamicSync);
parcelHelpers.export(exports, "queueAddAppliedApplicationTemplateFormSync", ()=>queueAddAppliedApplicationTemplateFormSync);
parcelHelpers.export(exports, "queueAddAppliedApplicationTemplateFormDynamicSync", ()=>queueAddAppliedApplicationTemplateFormDynamicSync);
parcelHelpers.export(exports, "queueRemoveAppliedApplicationTemplateSync", ()=>queueRemoveAppliedApplicationTemplateSync);
parcelHelpers.export(exports, "getAppliedTemplateSync", ()=>getAppliedTemplateSync);
parcelHelpers.export(exports, "getAppliedTemplateSyncsForApplication", ()=>getAppliedTemplateSyncsForApplication);
var _generic = require("./generic");
const queueUpdateApplicationFromTemplateFormsSync = (applicationId, appliedApplicationTemplateId, request)=>{
    return (0, _generic.sendPut)(`/AppliedTemplateSync/${applicationId}/UpdateAppliedApplicationTemplateForm/${appliedApplicationTemplateId}`, request);
};
const queueUpdateApplicationFromTemplateFormsDynamicSync = (applicationId, appliedTemplateFormId, request)=>{
    return (0, _generic.sendPut)(`/AppliedTemplateSync/${applicationId}/UpdateAppliedApplicationTemplateForm/${appliedTemplateFormId}/Dynamic`, request);
};
const queueAddAppliedApplicationTemplateFormSync = (applicationId, appliedTemplateFormId, request)=>{
    return (0, _generic.sendPut)(`/AppliedTemplateSync/${applicationId}/addAppliedApplicationTemplateForm/${appliedTemplateFormId}`, request);
};
const queueAddAppliedApplicationTemplateFormDynamicSync = (applicationId, appliedTemplateFormId, request)=>{
    return (0, _generic.sendPut)(`/AppliedTemplateSync/${applicationId}/addAppliedApplicationTemplateForm/${appliedTemplateFormId}/Dynamic`, request);
};
const queueRemoveAppliedApplicationTemplateSync = (applicationId, appliedTemplateFormId)=>{
    return (0, _generic.sendDelete)(`/AppliedTemplateSync/${applicationId}/RemoveAppliedApplicationTemplateForm/${appliedTemplateFormId}`);
};
const getAppliedTemplateSync = (appliedtemplateSyncId)=>{
    return (0, _generic.sendGet)(`/AppliedTemplateSync/${appliedtemplateSyncId}`);
};
const getAppliedTemplateSyncsForApplication = (applicationId)=>{
    return (0, _generic.sendGet)(`/AppliedTemplateSync/${applicationId}/getAppliedTemplateSyncs`);
};

},{"./generic":"6oGDt","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"dxnKp":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getApplicationConversationFlags", ()=>getApplicationConversationFlags);
parcelHelpers.export(exports, "createApplicationConversationFlag", ()=>createApplicationConversationFlag);
parcelHelpers.export(exports, "updateApplicationConversationFlag", ()=>updateApplicationConversationFlag);
parcelHelpers.export(exports, "deleteApplicationConversationFlag", ()=>deleteApplicationConversationFlag);
var _generic = require("./generic");
const getApplicationConversationFlags = (applicationId)=>{
    return (0, _generic.sendGet)(`/applicationFlags/forApp/${applicationId}`);
};
const createApplicationConversationFlag = (model)=>{
    return (0, _generic.sendPost)(`/applicationFlags`, model);
};
const updateApplicationConversationFlag = (applicationConversationFlagId, model)=>{
    return (0, _generic.sendPut)(`/applicationFlags/${applicationConversationFlagId}`, model);
};
const deleteApplicationConversationFlag = (applicationConversationFlagId)=>{
    return (0, _generic.sendDelete)(`/applicationFlags/${applicationConversationFlagId}`);
};

},{"./generic":"6oGDt","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7J0KR":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "queueArchive", ()=>queueArchive);
parcelHelpers.export(exports, "getArchive", ()=>getArchive);
parcelHelpers.export(exports, "getArchiveFile", ()=>getArchiveFile);
var _generic = require("./generic");
const queueArchive = (request)=>{
    return (0, _generic.sendPost)(`/archive/queue`, request);
};
const getArchive = (archiveId)=>{
    return (0, _generic.sendGet)(`/archive/${archiveId}`);
};
const getArchiveFile = (fileUrl)=>{
    return (0, _generic.sendGetFile)("", fileUrl);
};

},{"./generic":"6oGDt","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"ifZqw":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getApplicationEnvironments", ()=>getApplicationEnvironments);
parcelHelpers.export(exports, "findEnvironmentPubishById", ()=>findEnvironmentPubishById);
parcelHelpers.export(exports, "getEnvironmentPublishes", ()=>getEnvironmentPublishes);
parcelHelpers.export(exports, "queuePublishToEnvironment", ()=>queuePublishToEnvironment);
parcelHelpers.export(exports, "unpublishContentItemsFromEnvironment", ()=>unpublishContentItemsFromEnvironment);
parcelHelpers.export(exports, "queueBackupAndPublishApplication", ()=>queueBackupAndPublishApplication);
parcelHelpers.export(exports, "queueBackupAndPublishPartialApplication", ()=>queueBackupAndPublishPartialApplication);
var _generic = require("./generic");
const getApplicationEnvironments = (applicationId)=>{
    return (0, _generic.sendGet)(`/applicationEnvironment/forApp/${applicationId}`);
};
const findEnvironmentPubishById = (applicationPublishId)=>{
    return (0, _generic.sendGet)(`/applicationEnvironment/publishes/${applicationPublishId}`);
};
const getEnvironmentPublishes = (applicationEnvironmentId, skip, take)=>{
    return (0, _generic.sendGet)(`/applicationEnvironment/publishes/forEnvironment/${applicationEnvironmentId}?skip=${skip}&take=${take}`);
};
const queuePublishToEnvironment = (applicationEnvironmentId, applicationBackupVersionId)=>{
    return (0, _generic.sendPost)(`/applicationEnvironment/publishes/forEnvironment/${applicationEnvironmentId}/queue/${applicationBackupVersionId}`, null);
};
const unpublishContentItemsFromEnvironment = (applicationEnvironmentId, request)=>{
    return (0, _generic.sendPost)(`/applicationEnvironment/publishes/forEnvironment/${applicationEnvironmentId}/unpublishContent`, request);
};
const queueBackupAndPublishApplication = (applicationId, applicationEnvironmentId, request)=>{
    return (0, _generic.sendPost)(`/applicationEnvironment/${applicationId}/backupAndPublish/full/forEnvironment/${applicationEnvironmentId}`, request);
};
const queueBackupAndPublishPartialApplication = (applicationId, applicationEnvironmentId, request)=>{
    return (0, _generic.sendPost)(`/applicationEnvironment/${applicationId}/backupAndPublish/partial/forEnvironment/${applicationEnvironmentId}`, request);
};

},{"./generic":"6oGDt","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"elCSm":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getApplicationBackupVersions", ()=>getApplicationBackupVersions);
parcelHelpers.export(exports, "findBackupVersionById", ()=>findBackupVersionById);
parcelHelpers.export(exports, "updateApplicationBackupVersion", ()=>updateApplicationBackupVersion);
parcelHelpers.export(exports, "disableApplicationBackupVersion", ()=>disableApplicationBackupVersion);
parcelHelpers.export(exports, "queueCreateNewBackupVersion", ()=>queueCreateNewBackupVersion);
parcelHelpers.export(exports, "queueCreateNewPartialBackupVersion", ()=>queueCreateNewPartialBackupVersion);
var _generic = require("./generic");
const getApplicationBackupVersions = (applicationId)=>{
    return (0, _generic.sendGet)(`/applicationBackupVersion/forApp/${applicationId}`);
};
const findBackupVersionById = (applicationVersionId)=>{
    return (0, _generic.sendGet)(`/applicationBackupVersion/${applicationVersionId}`);
};
const updateApplicationBackupVersion = (applicationVersionId, model)=>{
    return (0, _generic.sendPut)(`/applicationBackupVersion/${applicationVersionId}`, model);
};
const disableApplicationBackupVersion = (applicationVersionId)=>{
    return (0, _generic.sendDelete)(`/applicationBackupVersion/${applicationVersionId}/disable`);
};
const queueCreateNewBackupVersion = (applicationId, model)=>{
    return (0, _generic.sendPost)(`/applicationBackupVersion/create/${applicationId}/queue`, model);
};
const queueCreateNewPartialBackupVersion = (applicationId, model)=>{
    return (0, _generic.sendPost)(`/applicationBackupVersion/create/${applicationId}/partial/queue`, model);
};

},{"./generic":"6oGDt","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9KuKj":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "updateEnvironmentSettings", ()=>updateEnvironmentSettings);
var _generic = require("./generic");
var _urls = require("../../constants/Urls");
const updateEnvironmentSettings = (environmentId, model)=>{
    return (0, _generic.sendPut)(`${(0, _urls.UPDATE_ENVIRONMENT)}/${environmentId}`, model);
};

},{"./generic":"6oGDt","../../constants/Urls":"iTopY","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8wFOX":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getCustomAssistantConfigurations", ()=>getCustomAssistantConfigurations);
parcelHelpers.export(exports, "getCustomAssistantConfiguration", ()=>getCustomAssistantConfiguration);
parcelHelpers.export(exports, "getCustomAssistantConfigurationsForAppAndEnvironment", ()=>getCustomAssistantConfigurationsForAppAndEnvironment);
parcelHelpers.export(exports, "deleteCustomAssistantConfiguration", ()=>deleteCustomAssistantConfiguration);
parcelHelpers.export(exports, "createCustomAssistantConfiguration", ()=>createCustomAssistantConfiguration);
parcelHelpers.export(exports, "updateCustomAssistantConfiguration", ()=>updateCustomAssistantConfiguration);
var _generic = require("./generic");
const getCustomAssistantConfigurations = (applicationId)=>{
    return (0, _generic.sendGet)(`/CustomAssistantConfiguration/applicationId/${applicationId}`);
};
const getCustomAssistantConfiguration = (configurationId)=>{
    return (0, _generic.sendGet)(`/CustomAssistantConfiguration/${configurationId}`);
};
const getCustomAssistantConfigurationsForAppAndEnvironment = (applicationId, environmentId)=>{
    return (0, _generic.sendGet)(`/CustomAssistantConfiguration/applicationId/${applicationId}/environmentId/${environmentId}`);
};
const deleteCustomAssistantConfiguration = (configurationId)=>{
    return (0, _generic.sendDelete)(`/CustomAssistantConfiguration/${configurationId}`);
};
const createCustomAssistantConfiguration = (configuration)=>{
    return (0, _generic.sendPost)(`/CustomAssistantConfiguration`, configuration);
};
const updateCustomAssistantConfiguration = (configuration)=>{
    return (0, _generic.sendPut)(`/CustomAssistantConfiguration/${configuration.id}`, configuration);
};

},{"./generic":"6oGDt","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"bYAAd":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "addApplicationNlpEntity", ()=>addApplicationNlpEntity);
parcelHelpers.export(exports, "getApplicationNlpEntitiesInLocale", ()=>getApplicationNlpEntitiesInLocale);
parcelHelpers.export(exports, "getApplicationNlpEntities", ()=>getApplicationNlpEntities);
parcelHelpers.export(exports, "getApplicationNlpEntity", ()=>getApplicationNlpEntity);
parcelHelpers.export(exports, "updateApplicationNlpEntity", ()=>updateApplicationNlpEntity);
parcelHelpers.export(exports, "deleteApplicationNlpEntity", ()=>deleteApplicationNlpEntity);
parcelHelpers.export(exports, "copyApplicationNlpEntity", ()=>copyApplicationNlpEntity);
parcelHelpers.export(exports, "applyPreBuiltEntityToApplication", ()=>applyPreBuiltEntityToApplication);
parcelHelpers.export(exports, "getApplicationPrebuiltNlpEntitiesInLocale", ()=>getApplicationPrebuiltNlpEntitiesInLocale);
parcelHelpers.export(exports, "updateAllApplicationNlpEntities", ()=>updateAllApplicationNlpEntities);
var _generic = require("./generic");
var _urls = require("../../constants/Urls");
const addApplicationNlpEntity = (applicationId, request)=>{
    return (0, _generic.sendPost)(`${(0, _urls.APPLICATION_NLP_ENTITY)}/${applicationId}`, request);
};
const getApplicationNlpEntitiesInLocale = (applicationId, locale)=>{
    return (0, _generic.sendGet)(`${(0, _urls.APPLICATION_NLP_ENTITY)}/${applicationId}/locale/${locale}`);
};
const getApplicationNlpEntities = (applicationId)=>{
    return (0, _generic.sendGet)(`${(0, _urls.APPLICATION_NLP_ENTITY)}/${applicationId}`);
};
const getApplicationNlpEntity = (applicationId, nlpEntityId)=>{
    return (0, _generic.sendGet)(`${(0, _urls.APPLICATION_NLP_ENTITY)}/${applicationId}/${nlpEntityId}`);
};
const updateApplicationNlpEntity = (applicationId, nlpEntityId, request)=>{
    return (0, _generic.sendPut)(`${(0, _urls.APPLICATION_NLP_ENTITY)}/${applicationId}/${nlpEntityId}`, request);
};
const deleteApplicationNlpEntity = (applicationId, nlpEntityId)=>{
    return (0, _generic.sendDelete)(`${(0, _urls.APPLICATION_NLP_ENTITY)}/${applicationId}/${nlpEntityId}`);
};
const copyApplicationNlpEntity = (applicationId, nlpEntityId)=>{
    return (0, _generic.sendPost)(`${(0, _urls.APPLICATION_NLP_ENTITY)}/${applicationId}/${nlpEntityId}/copy`, null);
};
const applyPreBuiltEntityToApplication = (applicationId, prebuiltNlpEntityId)=>{
    return (0, _generic.sendPost)(`${(0, _urls.APPLICATION_NLP_ENTITY)}/${applicationId}/${prebuiltNlpEntityId}/applyPrebuiltToApplication`, null);
};
const getApplicationPrebuiltNlpEntitiesInLocale = (applicationId, locale)=>{
    return (0, _generic.sendGet)(`${(0, _urls.APPLICATION_NLP_ENTITY)}/${applicationId}/locale/${locale}/prebuilt`);
};
const updateAllApplicationNlpEntities = (applicationId, request)=>{
    return (0, _generic.sendPut)(`${(0, _urls.APPLICATION_NLP_ENTITY)}/${applicationId}/updateAllEntities`, request);
};

},{"./generic":"6oGDt","../../constants/Urls":"iTopY","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"e7R0I":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "addVoicifyMenuItem", ()=>addVoicifyMenuItem);
parcelHelpers.export(exports, "updateVoicifyMenuItem", ()=>updateVoicifyMenuItem);
parcelHelpers.export(exports, "deleteVoicifyMenuItem", ()=>deleteVoicifyMenuItem);
parcelHelpers.export(exports, "getVoicifyMenuItems", ()=>getVoicifyMenuItems);
parcelHelpers.export(exports, "updateVoicifyMenuItems", ()=>updateVoicifyMenuItems);
parcelHelpers.export(exports, "augmentMenu", ()=>augmentMenu);
parcelHelpers.export(exports, "initiateMenuUpdate", ()=>initiateMenuUpdate);
parcelHelpers.export(exports, "syncMenus", ()=>syncMenus);
parcelHelpers.export(exports, "getTransformedMenu", ()=>getTransformedMenu);
var _generic = require("./generic");
var _urls = require("../../constants/Urls");
const addVoicifyMenuItem = (applicationId, request)=>{
    return (0, _generic.sendPost)(`${(0, _urls.APPLICATION_MENU_ITEM)}/${applicationId}`, request);
};
const updateVoicifyMenuItem = (applicationId, request)=>{
    return (0, _generic.sendPut)(`${(0, _urls.APPLICATION_MENU_ITEM)}/${applicationId}`, request);
};
const deleteVoicifyMenuItem = (applicationId, menuItemId)=>{
    return (0, _generic.sendDelete)(`${(0, _urls.APPLICATION_MENU_ITEM)}/${applicationId}?menuItemId=${menuItemId}`);
};
const getVoicifyMenuItems = (applicationId, menuItemId)=>{
    let url = `${(0, _urls.APPLICATION_MENU_ITEM)}/${applicationId}`;
    if (menuItemId) url += `/?menuItemId=${menuItemId}`;
    return (0, _generic.sendGet)(url);
};
const updateVoicifyMenuItems = (applicationId, request)=>{
    return (0, _generic.sendPut)(`${(0, _urls.APPLICATION_MENU_ITEM)}/${applicationId}/setAll`, request);
};
const augmentMenu = (request)=>{
    return (0, _generic.sendPost)(`${(0, _urls.VOICIFY_MENU)}/augmentMenu`, request, (0, _urls.getNlpModulesApiURL)());
};
const initiateMenuUpdate = (request)=>{
    return (0, _generic.sendPost)(`${(0, _urls.VOICIFY_MENU)}/updateMenu`, request, (0, _urls.getNlpModulesApiURL)());
};
const syncMenus = (request)=>{
    return (0, _generic.sendPost)(`${(0, _urls.VOICIFY_MENU)}/syncMenus`, request, (0, _urls.getNlpModulesApiURL)());
};
const getTransformedMenu = (applicationId, posName, locationId)=>{
    return (0, _generic.sendGet)(`${(0, _urls.VOICIFY_MENU)}/transformedMenu/${applicationId}?posName=${posName}&locationId=${locationId}`, (0, _urls.getNlpModulesApiURL)());
};

},{"./generic":"6oGDt","../../constants/Urls":"iTopY","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hKhC3":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "addTelephonyDeploymentVonage", ()=>addTelephonyDeploymentVonage);
parcelHelpers.export(exports, "addTelephonyDeploymentTelnyx", ()=>addTelephonyDeploymentTelnyx);
parcelHelpers.export(exports, "getTelephonyDeployments", ()=>getTelephonyDeployments);
parcelHelpers.export(exports, "deleteTelephonyDeployment", ()=>deleteTelephonyDeployment);
parcelHelpers.export(exports, "updateTelephonyDeployment", ()=>updateTelephonyDeployment);
parcelHelpers.export(exports, "moveTelephonyDeployment", ()=>moveTelephonyDeployment);
var _urls = require("../../constants/Urls");
var _generic = require("./generic");
const addTelephonyDeploymentVonage = (applicationId, request)=>{
    return (0, _generic.sendPost)(`${(0, _urls.APPLICATION_TELEPHONY_DEPLOYMENT)}/${applicationId}/provision/vonage`, request);
};
const addTelephonyDeploymentTelnyx = (applicationId, request)=>{
    return (0, _generic.sendPost)(`${(0, _urls.APPLICATION_TELEPHONY_DEPLOYMENT)}/${applicationId}/provision/telnyx`, request);
};
const getTelephonyDeployments = (applicationId)=>{
    return (0, _generic.sendGet)(`${(0, _urls.APPLICATION_TELEPHONY_DEPLOYMENT)}/${applicationId}`);
};
const deleteTelephonyDeployment = (applicationId, phoneNumber)=>{
    return (0, _generic.sendDelete)(`${(0, _urls.APPLICATION_TELEPHONY_DEPLOYMENT)}/${applicationId}/phoneNumber/${phoneNumber}`);
};
const updateTelephonyDeployment = (applicationId, phoneNumber, request)=>{
    return (0, _generic.sendPut)(`${(0, _urls.APPLICATION_TELEPHONY_DEPLOYMENT)}/${applicationId}/phoneNumber/${phoneNumber}`, request);
};
const moveTelephonyDeployment = (applicationId, phoneNumber, targetApplicationId)=>{
    return (0, _generic.sendPut)(`${(0, _urls.APPLICATION_TELEPHONY_DEPLOYMENT)}/${applicationId}/phoneNumber/${phoneNumber}/moveTo/${targetApplicationId}`);
};

},{"../../constants/Urls":"iTopY","./generic":"6oGDt","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hvlUZ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "processNlp", ()=>processNlp);
var _generic = require("./generic");
var _urls = require("../../constants/Urls");
const processNlp = (text, modelId, sessionToken)=>{
    return (0, _generic.sendPost)(`/Nlp/Process`, {
        text: text,
        modelId: modelId
    }, (0, _urls.getNlpApiUrl)(), sessionToken);
};

},{"./generic":"6oGDt","../../constants/Urls":"iTopY","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"bndPk":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getCallRecording", ()=>getCallRecording);
var _generic = require("./generic");
const getCallRecording = (applicationId, sessionId, processed)=>{
    return (0, _generic.sendGet)(`/CallRecording/${applicationId}/${sessionId}?NoiseCancelledAudio=${processed}`);
};

},{"./generic":"6oGDt","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"bhHHO":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "setupOrgForFeature", ()=>setupOrgForFeature);
var _urls = require("../../constants/Urls");
var _generic = require("./generic");
const setupOrgForFeature = (orgSetupRequest)=>{
    return (0, _generic.sendPost)((0, _urls.SETUP_ORG_FOR_FEATURE), orgSetupRequest);
};

},{"../../constants/Urls":"iTopY","./generic":"6oGDt","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1xjRQ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getCallStatistics", ()=>getCallStatistics);
parcelHelpers.export(exports, "getCallTransferredEvents", ()=>getCallTransferredEvents);
parcelHelpers.export(exports, "getImmedirateCallTransferredEvents", ()=>getImmedirateCallTransferredEvents);
parcelHelpers.export(exports, "getTopIntents", ()=>getTopIntents);
parcelHelpers.export(exports, "getOrderPlacedEvents", ()=>getOrderPlacedEvents);
parcelHelpers.export(exports, "getOrgCallCompleteEvents", ()=>getOrgCallCompleteEvents);
parcelHelpers.export(exports, "getConversationalSuccessEvents", ()=>getConversationalSuccessEvents);
parcelHelpers.export(exports, "getItemAddedToOrderEvents", ()=>getItemAddedToOrderEvents);
parcelHelpers.export(exports, "getOrderTotalStatistics", ()=>getOrderTotalStatistics);
parcelHelpers.export(exports, "getOrderCompletionBreakDownPerApp", ()=>getOrderCompletionBreakDownPerApp);
parcelHelpers.export(exports, "getConversationalSuccessBreakdownPerApp", ()=>getConversationalSuccessBreakdownPerApp);
parcelHelpers.export(exports, "getCallTransferredBreakdownPerApp", ()=>getCallTransferredBreakdownPerApp);
parcelHelpers.export(exports, "getCallImmediateTransferredBreakdownPerApp", ()=>getCallImmediateTransferredBreakdownPerApp);
parcelHelpers.export(exports, "getAverageOrderTotalBreakdownPerApp", ()=>getAverageOrderTotalBreakdownPerApp);
parcelHelpers.export(exports, "getTopLocationsWithNumberOfOrdersPlaced", ()=>getTopLocationsWithNumberOfOrdersPlaced);
parcelHelpers.export(exports, "getItemAddedConversationalSuccessEvents", ()=>getItemAddedConversationalSuccessEvents);
parcelHelpers.export(exports, "getSessionsByOrganizationId", ()=>getSessionsByOrganizationId);
var _generic = require("./generic");
var _urls = require("../../constants/Urls");
const getCallStatistics = (organizationId, filter)=>{
    return (0, _generic.sendGet)(`/v2/Organization/${organizationId}/callStatistics?${buildDateFilter(filter)}`, (0, _urls.getAnalyticsApiUrl)());
};
const getCallTransferredEvents = (organizationId, filter)=>{
    const res = (0, _generic.sendGet)(`/v2/Organization/${organizationId}/callTransferred?${buildDateFilter(filter)}`, (0, _urls.getAnalyticsApiUrl)());
    return res;
};
const getImmedirateCallTransferredEvents = (organizationId, filter)=>{
    return (0, _generic.sendGet)(`/v2/Organization/${organizationId}/immediateTransfers?${buildDateFilter(filter)}`, (0, _urls.getAnalyticsApiUrl)());
};
const getTopIntents = (organizationId, filter)=>{
    return (0, _generic.sendGet)(`/v2/Organization/${organizationId}/topIntents?${buildDateFilter(filter)}`, (0, _urls.getAnalyticsApiUrl)());
};
const getOrderPlacedEvents = (organizationId, filter)=>{
    return (0, _generic.sendGet)(`/v2/Organization/${organizationId}/orderPlaced?${buildDateFilter(filter)}`, (0, _urls.getAnalyticsApiUrl)());
};
const getOrgCallCompleteEvents = (organizationId, filter)=>{
    return (0, _generic.sendGet)(`/v2/Organization/${organizationId}/callComplete?${buildDateFilter(filter)}`, (0, _urls.getAnalyticsApiUrl)());
};
const getConversationalSuccessEvents = (organizationId, filter)=>{
    return (0, _generic.sendGet)(`/v2/Organization/${organizationId}/conversationalSuccess?${buildDateFilter(filter)}`, (0, _urls.getAnalyticsApiUrl)());
};
const getItemAddedToOrderEvents = (organizationId, filter)=>{
    return (0, _generic.sendGet)(`/v2/Organization/${organizationId}/itemAddedToOrder?${buildDateFilter(filter)}`, (0, _urls.getAnalyticsApiUrl)());
};
const getOrderTotalStatistics = (organizationId, filter)=>{
    return (0, _generic.sendGet)(`/v2/Organization/${organizationId}/orderTotals?${buildDateFilter(filter)}`, (0, _urls.getAnalyticsApiUrl)());
};
const getOrderCompletionBreakDownPerApp = (organizationId, filter)=>{
    return (0, _generic.sendGet)(`/v2/Organization/${organizationId}/orderCompletionBreakDownPerApp?${buildDateFilter(filter)}`, (0, _urls.getAnalyticsApiUrl)());
};
const getConversationalSuccessBreakdownPerApp = (organizationId, filter)=>{
    return (0, _generic.sendGet)(`/v2/Organization/${organizationId}/conversationalSuccessBreakdownPerApp?${buildDateFilter(filter)}`, (0, _urls.getAnalyticsApiUrl)());
};
const getCallTransferredBreakdownPerApp = (organizationId, filter)=>{
    return (0, _generic.sendGet)(`/v2/Organization/${organizationId}/callTransferredBreakdownPerApp?${buildDateFilter(filter)}`, (0, _urls.getAnalyticsApiUrl)());
};
const getCallImmediateTransferredBreakdownPerApp = (organizationId, filter)=>{
    return (0, _generic.sendGet)(`/v2/Organization/${organizationId}/callImmediateTransferredBreakdownPerApp?${buildDateFilter(filter)}`, (0, _urls.getAnalyticsApiUrl)());
};
const getAverageOrderTotalBreakdownPerApp = (organizationId, filter)=>{
    return (0, _generic.sendGet)(`/v2/Organization/${organizationId}/averageOrderTotalBreakdownPerApp?${buildDateFilter(filter)}`, (0, _urls.getAnalyticsApiUrl)());
};
const getTopLocationsWithNumberOfOrdersPlaced = (organizationId, filter)=>{
    return (0, _generic.sendGet)(`/v2/Organization/${organizationId}/topLocationsWithNumberOfOrdersPlaced?${buildDateFilter(filter)}&top=${filter.count}`, (0, _urls.getAnalyticsApiUrl)());
};
const getItemAddedConversationalSuccessEvents = (organizationId, filter)=>{
    return (0, _generic.sendGet)(`/v2/Organization/${organizationId}/itemAddedToOrderConversationalSuccessEvents?${buildDateFilter(filter)}`, (0, _urls.getAnalyticsApiUrl)());
};
const getSessionsByOrganizationId = (organizationId, filter, skip = 0, take = -1)=>{
    return (0, _generic.sendGet)(`/v2/Organization/${organizationId}/sessions?${buildDateFilter(filter)}&skip=${skip}&take=${take}`, (0, _urls.getAnalyticsApiUrl)());
};
const buildDateFilter = (filter)=>{
    const startDate = new Date(filter.startDate).toISOString();
    const endDate = new Date(filter.endDate).toISOString();
    let query = `startDate=${startDate}&endDate=${endDate}`;
    if (filter?.skip !== undefined && filter.skip >= 0 || filter?.take !== undefined && filter.take >= 0) query += `&skip=${filter.skip ?? 0}&take=${filter.take ?? -1}`;
    return query;
};

},{"./generic":"6oGDt","../../constants/Urls":"iTopY","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"lNxyP":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "markOrderAsPlaced", ()=>markOrderAsPlaced);
parcelHelpers.export(exports, "markOrderAsConversationalSuccess", ()=>markOrderAsConversationalSuccess);
var _generic = require("./generic");
var _urls = require("../../constants/Urls");
const markOrderAsPlaced = (applicationId, sessionId, request)=>{
    return (0, _generic.sendPost)(`${(0, _urls.MANUAL_UPDATES)}/${applicationId}/${sessionId}/trackOrderPlaced`, request, (0, _urls.getAnalyticsApiUrl)());
};
const markOrderAsConversationalSuccess = (applicationId, sessionId, request)=>{
    return (0, _generic.sendPost)(`${(0, _urls.MANUAL_UPDATES)}/${applicationId}/${sessionId}/trackConversationalSuccess`, request, (0, _urls.getAnalyticsApiUrl)());
};

},{"./generic":"6oGDt","../../constants/Urls":"iTopY","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7dGKa":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getOrganizationEngagementsNotWorkingElasticsearch", ()=>getOrganizationEngagementsNotWorkingElasticsearch);
parcelHelpers.export(exports, "getOrganizationEngagements", ()=>getOrganizationEngagements);
parcelHelpers.export(exports, "getEngagementsForTagCombo", ()=>getEngagementsForTagCombo);
parcelHelpers.export(exports, "getTopLevelMetrics", ()=>getTopLevelMetrics);
parcelHelpers.export(exports, "getOrganizationTopLevelMetrics", ()=>getOrganizationTopLevelMetrics);
parcelHelpers.export(exports, "getAverageCallVolumeHistogram", ()=>getAverageCallVolumeHistogram);
parcelHelpers.export(exports, "getOrganizationAverageCallVolumeHistogram", ()=>getOrganizationAverageCallVolumeHistogram);
parcelHelpers.export(exports, "getAverageContainableCallVolumeHistogram", ()=>getAverageContainableCallVolumeHistogram);
parcelHelpers.export(exports, "getOrganizationAverageContainableCallVolumeHistogram", ()=>getOrganizationAverageContainableCallVolumeHistogram);
parcelHelpers.export(exports, "getAverageContainedCallVolumeHistogram", ()=>getAverageContainedCallVolumeHistogram);
parcelHelpers.export(exports, "getOrganizationAverageContainedCallVolumeHistogram", ()=>getOrganizationAverageContainedCallVolumeHistogram);
parcelHelpers.export(exports, "getCallVolumeHistogram", ()=>getCallVolumeHistogram);
parcelHelpers.export(exports, "getOrganizationCallVolumeHistogram", ()=>getOrganizationCallVolumeHistogram);
parcelHelpers.export(exports, "getContainableCallVolumeHistogram", ()=>getContainableCallVolumeHistogram);
parcelHelpers.export(exports, "getOrganizationContainableCallVolumeHistogram", ()=>getOrganizationContainableCallVolumeHistogram);
parcelHelpers.export(exports, "getContainedCallVolumeHistogram", ()=>getContainedCallVolumeHistogram);
parcelHelpers.export(exports, "getOrganizationContainedCallVolumeHistogram", ()=>getOrganizationContainedCallVolumeHistogram);
parcelHelpers.export(exports, "getOrderAttemptedVolume", ()=>getOrderAttemptedVolume);
parcelHelpers.export(exports, "getOrganizationOrderAttemptedVolume", ()=>getOrganizationOrderAttemptedVolume);
parcelHelpers.export(exports, "getOrderPlacedVolume", ()=>getOrderPlacedVolume);
parcelHelpers.export(exports, "getOrganizationOrderPlacedVolume", ()=>getOrganizationOrderPlacedVolume);
parcelHelpers.export(exports, "getSpanishCallVolumeHistogram", ()=>getSpanishCallVolumeHistogram);
parcelHelpers.export(exports, "getOrganizationSpanishCallVolumeHistogram", ()=>getOrganizationSpanishCallVolumeHistogram);
parcelHelpers.export(exports, "getSpanishContainableCallVolumeHistogram", ()=>getSpanishContainableCallVolumeHistogram);
parcelHelpers.export(exports, "getOrganizationSpanishContainableCallVolumeHistogram", ()=>getOrganizationSpanishContainableCallVolumeHistogram);
parcelHelpers.export(exports, "getSpanishContainedCallVolumeHistogram", ()=>getSpanishContainedCallVolumeHistogram);
parcelHelpers.export(exports, "getOrganizationSpanishContainedCallVolumeHistogram", ()=>getOrganizationSpanishContainedCallVolumeHistogram);
parcelHelpers.export(exports, "getConcurrentCallVolumeHistogram", ()=>getConcurrentCallVolumeHistogram);
parcelHelpers.export(exports, "getOrganizationConcurrentCallVolumeHistogram", ()=>getOrganizationConcurrentCallVolumeHistogram);
parcelHelpers.export(exports, "getOrganizationLevelTransferReasons", ()=>getOrganizationLevelTransferReasons);
parcelHelpers.export(exports, "getApplicationLevelTransferReasons", ()=>getApplicationLevelTransferReasons);
var _generic = require("./generic");
var _urls = require("../../constants/Urls");
// ==================== ENGAGEMENT ANALYTICS MODELS ====================
/**
 * App-level breakdown for metrics (used in tooltips and detailed views)
 */ /**
 * Individual engagement/call record from the organization
 * Matches the actual API response from getOrganizationEngagements and getEngagementsForTagCombo
 */ /**
 * Engagements grouped by applicationId
 * This is the actual response format from getOrganizationEngagements and getEngagementsForTagCombo endpoints
 */ /**
 * Individual histogram entry from organization-level histogram endpoints
 */ /**
 * Histogram data grouped by applicationId
 * This is the actual response format from organization-level histogram endpoints like
 * getOrganizationCallVolumeHistogram, getOrganizationContainableCallVolumeHistogram, etc.
 */ /**
 * Top-level metrics for KPI tiles
 * Maps to mockHealthcareMetrics structure
 */ /**
 * Filter for engagement analytics requests
 */ /**
 * Transfer reason data from the API
 * Maps to TransferCategoryData structure for the transfers chart
 */ /**
 * Individual transfer record for the transfers table/export
 * Maps to mockHealthcareTransferData / mockFoodOrderingTransferData
 */ /**
 * Aggregated transfer reasons response
 */ /**
 * Contained calls data by category (for bar charts)
 * Maps to ContainedCallData structure
 */ const buildEngagementDateFilter = (filter)=>{
    // Pass dates as-is - server will handle timezone conversion using the timezone parameter
    const startDate = encodeURIComponent(filter.startDate);
    const endDate = encodeURIComponent(filter.endDate);
    let queryString = `startDate=${startDate}&endDate=${endDate}`;
    // Include timezone if provided (from Intl.DateTimeFormat().resolvedOptions().timeZone)
    if (filter.timezone) queryString += `&timezone=${encodeURIComponent(filter.timezone)}`;
    return queryString;
};
const getOrganizationEngagementsNotWorkingElasticsearch = (organizationId, filter)=>{
    const skip = filter.skip ?? 0;
    const take = filter.take ?? 100;
    return (0, _generic.sendGet)(`/EngagementAnalyticsReporting/getOrganizationEngagements?organizationId=${organizationId}&${buildEngagementDateFilter(filter)}&skip=${skip}&take=${take}`, (0, _urls.getAnalyticsApiUrl)());
};
const getOrganizationEngagements = (organizationId, filter)=>{
    const skip = filter.skip ?? 0;
    const take = filter.take ?? 100;
    // This endpoint doesn't support timezone as a separate parameter - encode it in the date strings
    const startDate = encodeURIComponent(filter.timezone ? `${filter.startDate} ${filter.timezone}` : filter.startDate);
    const endDate = encodeURIComponent(filter.timezone ? `${filter.endDate} ${filter.timezone}` : filter.endDate);
    return (0, _generic.sendGet)(`/v2/Organization/${organizationId}/engagements?startDate=${startDate}&endDate=${endDate}&skip=${skip}&take=${take}`, (0, _urls.getAnalyticsApiUrl)());
};
const getEngagementsForTagCombo = (organizationId, filter, category, validTags = [], excludedTags = [])=>{
    const validTagsQuery = validTags.map((t)=>`validTags=${encodeURIComponent(t)}`).join("&");
    const excludedTagsQuery = excludedTags.map((t)=>`excludedTags=${encodeURIComponent(t)}`).join("&");
    let url = `/EngagementAnalyticsReporting/getEngagementsForTagCombo?organizationId=${organizationId}&${buildEngagementDateFilter(filter)}&category=${encodeURIComponent(category)}`;
    if (validTagsQuery) url += `&${validTagsQuery}`;
    if (excludedTagsQuery) url += `&${excludedTagsQuery}`;
    return (0, _generic.sendGet)(url, (0, _urls.getAnalyticsApiUrl)());
};
const getTopLevelMetrics = (applicationId, filter)=>{
    return (0, _generic.sendGet)(`/EngagementAnalyticsReporting/getTopLevelMetrics?applicationId=${applicationId}&${buildEngagementDateFilter(filter)}`, (0, _urls.getAnalyticsApiUrl)());
};
const getOrganizationTopLevelMetrics = (organizationId, filter)=>{
    return (0, _generic.sendGet)(`/EngagementAnalyticsReporting/getOrganizationTopLevelMetrics?organizationId=${organizationId}&${buildEngagementDateFilter(filter)}`, (0, _urls.getAnalyticsApiUrl)());
};
const getAverageCallVolumeHistogram = (applicationId, filter)=>{
    const interval = filter.interval ?? 0;
    return (0, _generic.sendGet)(`/EngagementAnalyticsReporting/getAverageCallVolumeHistogram?applicationId=${applicationId}&${buildEngagementDateFilter(filter)}&interval=${interval}`, (0, _urls.getAnalyticsApiUrl)());
};
const getOrganizationAverageCallVolumeHistogram = (organizationId, filter)=>{
    const interval = filter.interval ?? 0;
    return (0, _generic.sendGet)(`/EngagementAnalyticsReporting/getOrganizationAverageCallVolumeHistogram?organizationId=${organizationId}&${buildEngagementDateFilter(filter)}&interval=${interval}`, (0, _urls.getAnalyticsApiUrl)());
};
const getAverageContainableCallVolumeHistogram = (applicationId, filter)=>{
    const interval = filter.interval ?? 0;
    return (0, _generic.sendGet)(`/EngagementAnalyticsReporting/getAverageContainableCallVolumeHistogram?applicationId=${applicationId}&${buildEngagementDateFilter(filter)}&interval=${interval}`, (0, _urls.getAnalyticsApiUrl)());
};
const getOrganizationAverageContainableCallVolumeHistogram = (organizationId, filter)=>{
    const interval = filter.interval ?? 0;
    return (0, _generic.sendGet)(`/EngagementAnalyticsReporting/getOrganizationAverageContainableCallVolumeHistogram?organizationId=${organizationId}&${buildEngagementDateFilter(filter)}&interval=${interval}`, (0, _urls.getAnalyticsApiUrl)());
};
const getAverageContainedCallVolumeHistogram = (applicationId, filter)=>{
    const interval = filter.interval ?? 0;
    return (0, _generic.sendGet)(`/EngagementAnalyticsReporting/getAverageContainedCallVolumeHistogram?applicationId=${applicationId}&${buildEngagementDateFilter(filter)}&interval=${interval}`, (0, _urls.getAnalyticsApiUrl)());
};
const getOrganizationAverageContainedCallVolumeHistogram = (organizationId, filter)=>{
    const interval = filter.interval ?? 0;
    return (0, _generic.sendGet)(`/EngagementAnalyticsReporting/getOrganizationAverageContainedCallVolumeHistogram?organizationId=${organizationId}&${buildEngagementDateFilter(filter)}&interval=${interval}`, (0, _urls.getAnalyticsApiUrl)());
};
const getCallVolumeHistogram = (applicationId, filter)=>{
    const interval = filter.interval ?? 0;
    return (0, _generic.sendGet)(`/EngagementAnalyticsReporting/getCallVolumeHistogram?applicationId=${applicationId}&${buildEngagementDateFilter(filter)}&interval=${interval}`, (0, _urls.getAnalyticsApiUrl)());
};
const getOrganizationCallVolumeHistogram = (organizationId, filter)=>{
    const interval = filter.interval ?? 0;
    return (0, _generic.sendGet)(`/EngagementAnalyticsReporting/getOrganizationCallVolumeHistogram?organizationId=${organizationId}&${buildEngagementDateFilter(filter)}&interval=${interval}`, (0, _urls.getAnalyticsApiUrl)());
};
const getContainableCallVolumeHistogram = (applicationId, filter)=>{
    const interval = filter.interval ?? 0;
    return (0, _generic.sendGet)(`/EngagementAnalyticsReporting/getContainableCallVolumeHistogram?applicationId=${applicationId}&${buildEngagementDateFilter(filter)}&interval=${interval}`, (0, _urls.getAnalyticsApiUrl)());
};
const getOrganizationContainableCallVolumeHistogram = (organizationId, filter)=>{
    const interval = filter.interval ?? 0;
    return (0, _generic.sendGet)(`/EngagementAnalyticsReporting/getOrganizationContainableCallVolumeHistogram?organizationId=${organizationId}&${buildEngagementDateFilter(filter)}&interval=${interval}`, (0, _urls.getAnalyticsApiUrl)());
};
const getContainedCallVolumeHistogram = (applicationId, filter)=>{
    const interval = filter.interval ?? 0;
    return (0, _generic.sendGet)(`/EngagementAnalyticsReporting/getContainedCallVolumeHistogram?applicationId=${applicationId}&${buildEngagementDateFilter(filter)}&interval=${interval}`, (0, _urls.getAnalyticsApiUrl)());
};
const getOrganizationContainedCallVolumeHistogram = (organizationId, filter)=>{
    const interval = filter.interval ?? 0;
    return (0, _generic.sendGet)(`/EngagementAnalyticsReporting/getOrganizationContainedCallVolumeHistogram?organizationId=${organizationId}&${buildEngagementDateFilter(filter)}&interval=${interval}`, (0, _urls.getAnalyticsApiUrl)());
};
const getOrderAttemptedVolume = (applicationId, filter)=>{
    const interval = filter.interval ?? 0;
    return (0, _generic.sendGet)(`/EngagementAnalyticsReporting/getOrderAttemptedVolume?applicationId=${applicationId}&${buildEngagementDateFilter(filter)}&interval=${interval}`, (0, _urls.getAnalyticsApiUrl)());
};
const getOrganizationOrderAttemptedVolume = (organizationId, filter)=>{
    const interval = filter.interval ?? 0;
    return (0, _generic.sendGet)(`/EngagementAnalyticsReporting/getOrganizationOrderAttemptedVolume?organizationId=${organizationId}&${buildEngagementDateFilter(filter)}&interval=${interval}`, (0, _urls.getAnalyticsApiUrl)());
};
const getOrderPlacedVolume = (applicationId, filter)=>{
    const interval = filter.interval ?? 0;
    return (0, _generic.sendGet)(`/EngagementAnalyticsReporting/getOrderPlacedVolume?applicationId=${applicationId}&${buildEngagementDateFilter(filter)}&interval=${interval}`, (0, _urls.getAnalyticsApiUrl)());
};
const getOrganizationOrderPlacedVolume = (organizationId, filter)=>{
    const interval = filter.interval ?? 0;
    return (0, _generic.sendGet)(`/EngagementAnalyticsReporting/getOrganizationOrderPlacedVolume?organizationId=${organizationId}&${buildEngagementDateFilter(filter)}&interval=${interval}`, (0, _urls.getAnalyticsApiUrl)());
};
const getSpanishCallVolumeHistogram = (applicationId, filter)=>{
    const interval = filter.interval ?? 0;
    return (0, _generic.sendGet)(`/EngagementAnalyticsReporting/getSpanishCallVolumeHistogram?applicationId=${applicationId}&${buildEngagementDateFilter(filter)}&interval=${interval}`, (0, _urls.getAnalyticsApiUrl)());
};
const getOrganizationSpanishCallVolumeHistogram = (organizationId, filter)=>{
    const interval = filter.interval ?? 0;
    return (0, _generic.sendGet)(`/EngagementAnalyticsReporting/getOrganizationSpanishCallVolumeHistogram?organizationId=${organizationId}&${buildEngagementDateFilter(filter)}&interval=${interval}`, (0, _urls.getAnalyticsApiUrl)());
};
const getSpanishContainableCallVolumeHistogram = (applicationId, filter)=>{
    const interval = filter.interval ?? 0;
    return (0, _generic.sendGet)(`/EngagementAnalyticsReporting/getSpanishContainableCallVolumeHistogram?applicationId=${applicationId}&${buildEngagementDateFilter(filter)}&interval=${interval}`, (0, _urls.getAnalyticsApiUrl)());
};
const getOrganizationSpanishContainableCallVolumeHistogram = (organizationId, filter)=>{
    const interval = filter.interval ?? 0;
    return (0, _generic.sendGet)(`/EngagementAnalyticsReporting/getOrganizationSpanishContainableCallVolumeHistogram?organizationId=${organizationId}&${buildEngagementDateFilter(filter)}&interval=${interval}`, (0, _urls.getAnalyticsApiUrl)());
};
const getSpanishContainedCallVolumeHistogram = (applicationId, filter)=>{
    const interval = filter.interval ?? 0;
    return (0, _generic.sendGet)(`/EngagementAnalyticsReporting/getSpanishContainedCallVolumeHistogram?applicationId=${applicationId}&${buildEngagementDateFilter(filter)}&interval=${interval}`, (0, _urls.getAnalyticsApiUrl)());
};
const getOrganizationSpanishContainedCallVolumeHistogram = (organizationId, filter)=>{
    const interval = filter.interval ?? 0;
    return (0, _generic.sendGet)(`/EngagementAnalyticsReporting/getOrganizationSpanishContainedCallVolumeHistogram?organizationId=${organizationId}&${buildEngagementDateFilter(filter)}&interval=${interval}`, (0, _urls.getAnalyticsApiUrl)());
};
const getConcurrentCallVolumeHistogram = (applicationId, filter)=>{
    const interval = filter.interval ?? 0;
    return (0, _generic.sendGet)(`/EngagementAnalyticsReporting/getConcurrentCallVolumeHistogram?applicationId=${applicationId}&${buildEngagementDateFilter(filter)}&interval=${interval}`, (0, _urls.getAnalyticsApiUrl)());
};
const getOrganizationConcurrentCallVolumeHistogram = (organizationId, filter)=>{
    const interval = filter.interval ?? 0;
    return (0, _generic.sendGet)(`/EngagementAnalyticsReporting/getOrganizationConcurrentCallVolumeHistogram?organizationId=${organizationId}&${buildEngagementDateFilter(filter)}&interval=${interval}`, (0, _urls.getAnalyticsApiUrl)());
};
const getOrganizationLevelTransferReasons = (organizationId, filter, getPlanned = false)=>{
    return (0, _generic.sendGet)(`/EngagementAnalyticsReporting/getOrganizationLevelTransferReasons?organizationId=${organizationId}&${buildEngagementDateFilter(filter)}&getPlanned=${getPlanned}`, (0, _urls.getAnalyticsApiUrl)());
};
const getApplicationLevelTransferReasons = (applicationId, filter, getPlanned = false)=>{
    return (0, _generic.sendGet)(`/EngagementAnalyticsReporting/getApplicationLevelTransferReasons?applicationId=${applicationId}&${buildEngagementDateFilter(filter)}&getPlanned=${getPlanned}`, (0, _urls.getAnalyticsApiUrl)());
}; // #endregion

},{"./generic":"6oGDt","../../constants/Urls":"iTopY","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3SuET":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getTestCase", ()=>getTestCase);
parcelHelpers.export(exports, "getTestCases", ()=>getTestCases);
parcelHelpers.export(exports, "createTestCase", ()=>createTestCase);
parcelHelpers.export(exports, "updateTestCase", ()=>updateTestCase);
parcelHelpers.export(exports, "deleteTestCase", ()=>deleteTestCase);
parcelHelpers.export(exports, "deleteTestCasesForContentItem", ()=>deleteTestCasesForContentItem);
var _generic = require("./generic");
const getTestCase = (applicationId, name, contentItemId)=>{
    var url = `/TestCase/${applicationId}/loadTestCase`;
    if (name?.length) url += `?name=${name}`;
    if (contentItemId?.length) {
        if (url.indexOf("?") === -1) url += "?";
        else url += "&";
        url += `&contentItemId=${contentItemId}`;
    }
    return (0, _generic.sendGet)(url);
};
const getTestCases = (applicationId, contentItemId, includeContentItemTestCases)=>{
    var url = `/TestCase/${applicationId}/loadTestCases`;
    if (contentItemId?.length) url += `?contentItemId=${contentItemId}`;
    if (includeContentItemTestCases) {
        if (url.indexOf("?") === -1) url += "?";
        else url += "&";
        url += `&includeContentItemTestCases=${includeContentItemTestCases}`;
    }
    return (0, _generic.sendGet)(url);
};
const createTestCase = (applicationId, model)=>{
    return (0, _generic.sendPost)(`/TestCase/${applicationId}`, model);
};
const updateTestCase = (applicationId, model)=>{
    return (0, _generic.sendPut)(`/TestCase/${applicationId}`, model);
};
const deleteTestCase = (applicationId, name, contentItemId)=>{
    var url = `/TestCase/${applicationId}`;
    if (name?.length) url += `?name=${name}`;
    if (contentItemId?.length) {
        if (url.indexOf("?") === -1) url += "?";
        else url += "&";
        url += `&contentItemId=${contentItemId}`;
    }
    return (0, _generic.sendDelete)(url);
};
const deleteTestCasesForContentItem = (applicationId, contentItemId)=>{
    var url = `/TestCase/${applicationId}/deleteForContentItem`;
    if (contentItemId?.length) url += `?contentItemId=${contentItemId}`;
    return (0, _generic.sendDelete)(url);
};

},{"./generic":"6oGDt","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jCvpY":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getResponse", ()=>getResponse);
parcelHelpers.export(exports, "deleteResponse", ()=>deleteResponse);
parcelHelpers.export(exports, "getResponsesForApplication", ()=>getResponsesForApplication);
var _generic = require("./generic");
const getResponse = (responseId)=>{
    return (0, _generic.sendGet)("/Response/" + responseId);
};
const deleteResponse = (responseId)=>{
    return (0, _generic.sendDelete)("/Response/" + responseId);
};
const getResponsesForApplication = (appId, skip = 0, take = 200)=>{
    return (0, _generic.sendGet)("/Response/application/" + appId + "?skip=" + skip + "&take=" + take);
};

},{"./generic":"6oGDt","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"gTXEN":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getApplicationVariablesByApplicationId", ()=>getApplicationVariablesByApplicationId);
parcelHelpers.export(exports, "getApplicationVariableById", ()=>getApplicationVariableById);
parcelHelpers.export(exports, "createApplicationVariable", ()=>createApplicationVariable);
parcelHelpers.export(exports, "updateApplicationVariable", ()=>updateApplicationVariable);
parcelHelpers.export(exports, "deleteApplicationVariable", ()=>deleteApplicationVariable);
var _generic = require("./generic");
var _urls = require("../../constants/Urls");
const getApplicationVariablesByApplicationId = (applicationId)=>{
    return (0, _generic.sendGet)(`${(0, _urls.APPLICATION_VARIABLE)}/forApplication/${applicationId}`);
};
const getApplicationVariableById = (applicationVariableId)=>{
    return (0, _generic.sendGet)(`${(0, _urls.APPLICATION_VARIABLE)}/${applicationVariableId}`);
};
const createApplicationVariable = (model)=>{
    return (0, _generic.sendPost)(`${(0, _urls.APPLICATION_VARIABLE)}`, model);
};
const updateApplicationVariable = (applicationVariableId, model)=>{
    return (0, _generic.sendPut)(`${(0, _urls.APPLICATION_VARIABLE)}/${applicationVariableId}`, model);
};
const deleteApplicationVariable = (applicationVariableId)=>{
    return (0, _generic.sendDelete)(`${(0, _urls.APPLICATION_VARIABLE)}/${applicationVariableId}`);
};

},{"./generic":"6oGDt","../../constants/Urls":"iTopY","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"dwUYf":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getOrganizationVariablesByOrganizationId", ()=>getOrganizationVariablesByOrganizationId);
parcelHelpers.export(exports, "getOrganizationVariableById", ()=>getOrganizationVariableById);
parcelHelpers.export(exports, "createOrganizationVariable", ()=>createOrganizationVariable);
parcelHelpers.export(exports, "updateOrganizationVariable", ()=>updateOrganizationVariable);
parcelHelpers.export(exports, "deleteOrganizationVariable", ()=>deleteOrganizationVariable);
var _generic = require("./generic");
var _urls = require("../../constants/Urls");
const getOrganizationVariablesByOrganizationId = (organizationId)=>{
    return (0, _generic.sendGet)(`${(0, _urls.ORGANIZATION_VARIABLE)}/forOrganization/${organizationId}`);
};
const getOrganizationVariableById = (organizationVariableId)=>{
    return (0, _generic.sendGet)(`${(0, _urls.ORGANIZATION_VARIABLE)}/${organizationVariableId}`);
};
const createOrganizationVariable = (model)=>{
    return (0, _generic.sendPost)(`${(0, _urls.ORGANIZATION_VARIABLE)}`, model);
};
const updateOrganizationVariable = (organizationVariableId, model)=>{
    return (0, _generic.sendPut)(`${(0, _urls.ORGANIZATION_VARIABLE)}/${organizationVariableId}`, model);
};
const deleteOrganizationVariable = (organizationVariableId)=>{
    return (0, _generic.sendDelete)(`${(0, _urls.ORGANIZATION_VARIABLE)}/${organizationVariableId}`);
};

},{"./generic":"6oGDt","../../constants/Urls":"iTopY","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"kJ16E":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getMedicalIntegrationConfigsByOrganizationId", ()=>getMedicalIntegrationConfigsByOrganizationId);
parcelHelpers.export(exports, "createMedicalIntegrationConfig", ()=>createMedicalIntegrationConfig);
parcelHelpers.export(exports, "updateMedicalIntegrationConfig", ()=>updateMedicalIntegrationConfig);
var _generic = require("./generic");
var _urls = require("../../constants/Urls");
const getMedicalIntegrationConfigsByOrganizationId = (organizationId)=>{
    return (0, _generic.sendGet)(`${(0, _urls.MEDICAL_INTEGRATION_CONFIGURATION)}/${organizationId}`);
};
const createMedicalIntegrationConfig = (model)=>{
    return (0, _generic.sendPost)(`${(0, _urls.MEDICAL_INTEGRATION_CONFIGURATION)}`, model);
};
const updateMedicalIntegrationConfig = (configId, model)=>{
    return (0, _generic.sendPut)(`${(0, _urls.MEDICAL_INTEGRATION_CONFIGURATION)}/${configId}`, model);
};

},{"./generic":"6oGDt","../../constants/Urls":"iTopY","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"iyF3V":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getRevenueConfig", ()=>getRevenueConfig);
parcelHelpers.export(exports, "putRevenueConfig", ()=>putRevenueConfig);
var _generic = require("./generic");
var _urls = require("../../constants/Urls");
const getRevenueConfig = ()=>{
    return (0, _generic.sendGet)("/RevenueConfig", (0, _urls.getBaseApiUrl)());
};
const putRevenueConfig = (config)=>{
    return (0, _generic.sendPut)("/RevenueConfig", config, (0, _urls.getBaseApiUrl)());
};

},{"./generic":"6oGDt","../../constants/Urls":"iTopY","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"5DDKU":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _base = require("@emotion/styled/base");
var _baseDefault = parcelHelpers.interopDefault(_base);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _formik = require("formik");
var _yup = require("yup");
var _textField = require("../../../components/forms/TextField");
var _textFieldDefault = parcelHelpers.interopDefault(_textField);
var _button = require("../../../components/general/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _reactRouterDom = require("react-router-dom");
var _pageError = require("../../../components/general/PageError");
var _pageErrorDefault = parcelHelpers.interopDefault(_pageError);
var _breakpoints = require("../../../constants/breakpoints");
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const InnerForm = ({ handleSubmit, isSubmitting, values, handleChange, handleBlur, stateContainer, userContainer })=>(0, _react.jsx)("div", null, (0, _react.jsx)("form", {
        onSubmit: handleSubmit
    }, (0, _react.jsx)(StyledTextField, {
        disabled: isSubmitting,
        name: "email",
        value: values.email,
        label: "Email",
        placeholder: "Enter the email you signed up with",
        onChange: handleChange,
        onBlur: handleBlur
    }), (0, _react.jsx)(StyledTextField, {
        disabled: isSubmitting,
        name: "password",
        type: "password",
        value: values.password,
        label: "Password",
        placeholder: "Just to be sure it’s really you",
        onChange: handleChange,
        onBlur: handleBlur
    }), (0, _react.jsx)((0, _reactRouterDom.Link), {
        to: "forgotPassword",
        className: "forgot-password"
    }, "Forgot Password?"), (0, _react.jsx)((0, _buttonDefault.default), {
        themes: [
            "primary",
            "wide"
        ],
        type: "submit",
        loading: isSubmitting,
        disabled: isSubmitting,
        text: "Let's Go!",
        additionalClasses: buttonSplitStyle
    })), (0, _react.jsx)((0, _pageErrorDefault.default), {
        errors: [
            ...stateContainer.state.errors,
            ...userContainer.state.errors
        ]
    }));
const LoginForm = (0, _formik.withFormik)({
    mapPropsToValues: (props)=>({
            email: props.email ?? "",
            password: ""
        }),
    validationSchema: _yup.object().shape({
        email: _yup.string().email("Must be a valid email").required("You must enter your email"),
        password: _yup.string().required("You must enter your password")
    }),
    handleSubmit: async (values, { props, setSubmitting })=>{
        setSubmitting(true);
        const result = await props.stateContainer.signIn(values.email, values.password);
        setSubmitting(false);
        if (result.resultType == "Ok" && props.invitationCode !== undefined) props.userContainer.acceptInvitation(props.invitationCode);
    }
})(InnerForm);
const StyledTextField = /*#__PURE__*/ (0, _baseDefault.default)((0, _textFieldDefault.default), {
    target: "excufcs0"
})("&.textFieldStyles{", (0, _breakpoints.breakpoint_small), "{width:100%;}}");
const buttonSplitStyle = /*#__PURE__*/ (0, _css.css)({
    name: "i0nzy7",
    styles: "margin-bottom:-56px;margin-top:72px"
});
exports.default = LoginForm;

},{"@emotion/styled/base":"lSuFu","@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","formik":"3YnOK","yup":"j2SJU","../../../components/forms/TextField":"7a7bh","../../../components/general/Button":"6ymxN","react-router-dom":"5fzqq","../../../components/general/PageError":"ezFTm","../../../constants/breakpoints":"2F01A","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"lSuFu":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>createStyled);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("react");
var _isPropValid = require("@emotion/is-prop-valid");
var _isPropValidDefault = parcelHelpers.interopDefault(_isPropValid);
var _react1 = require("@emotion/react");
var _utils = require("@emotion/utils");
var _serialize = require("@emotion/serialize");
var _useInsertionEffectWithFallbacks = require("@emotion/use-insertion-effect-with-fallbacks");
var testOmitPropsOnStringTag = (0, _isPropValidDefault.default);
var testOmitPropsOnComponent = function testOmitPropsOnComponent(key) {
    return key !== "theme";
};
var getDefaultShouldForwardProp = function getDefaultShouldForwardProp(tag) {
    return typeof tag === "string" && // 96 is one less than the char code
    // for "a" so this is checking that
    // it's a lowercase character
    tag.charCodeAt(0) > 96 ? testOmitPropsOnStringTag : testOmitPropsOnComponent;
};
var composeShouldForwardProps = function composeShouldForwardProps(tag, options, isReal) {
    var shouldForwardProp;
    if (options) {
        var optionsShouldForwardProp = options.shouldForwardProp;
        shouldForwardProp = tag.__emotion_forwardProp && optionsShouldForwardProp ? function(propName) {
            return tag.__emotion_forwardProp(propName) && optionsShouldForwardProp(propName);
        } : optionsShouldForwardProp;
    }
    if (typeof shouldForwardProp !== "function" && isReal) shouldForwardProp = tag.__emotion_forwardProp;
    return shouldForwardProp;
};
var ILLEGAL_ESCAPE_SEQUENCE_ERROR = "You have illegal escape sequence in your template literal, most likely inside content's property value.\nBecause you write your CSS inside a JavaScript string you actually have to do double escaping, so for example \"content: '\\00d7';\" should become \"content: '\\\\00d7';\".\nYou can read more about this here:\nhttps://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences";
var Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serialized = _ref.serialized, isStringTag = _ref.isStringTag;
    (0, _utils.registerStyles)(cache, serialized, isStringTag);
    (0, _useInsertionEffectWithFallbacks.useInsertionEffectAlwaysWithSyncFallback)(function() {
        return (0, _utils.insertStyles)(cache, serialized, isStringTag);
    });
    return null;
};
var createStyled = function createStyled(tag, options) {
    var isReal = tag.__emotion_real === tag;
    var baseTag = isReal && tag.__emotion_base || tag;
    var identifierName;
    var targetClassName;
    if (options !== undefined) {
        identifierName = options.label;
        targetClassName = options.target;
    }
    var shouldForwardProp = composeShouldForwardProps(tag, options, isReal);
    var defaultShouldForwardProp = shouldForwardProp || getDefaultShouldForwardProp(baseTag);
    var shouldUseAs = !defaultShouldForwardProp("as");
    return function() {
        var args = arguments;
        var styles = isReal && tag.__emotion_styles !== undefined ? tag.__emotion_styles.slice(0) : [];
        if (identifierName !== undefined) styles.push("label:" + identifierName + ";");
        if (args[0] == null || args[0].raw === undefined) styles.push.apply(styles, args);
        else {
            styles.push(args[0][0]);
            var len = args.length;
            var i = 1;
            for(; i < len; i++)styles.push(args[i], args[0][i]);
        } // $FlowFixMe: we need to cast StatelessFunctionalComponent to our PrivateStyledComponent class
        var Styled = (0, _react1.withEmotionCache)(function(props, cache, ref) {
            var FinalTag = shouldUseAs && props.as || baseTag;
            var className = "";
            var classInterpolations = [];
            var mergedProps = props;
            if (props.theme == null) {
                mergedProps = {};
                for(var key in props)mergedProps[key] = props[key];
                mergedProps.theme = _react.useContext((0, _react1.ThemeContext));
            }
            if (typeof props.className === "string") className = (0, _utils.getRegisteredStyles)(cache.registered, classInterpolations, props.className);
            else if (props.className != null) className = props.className + " ";
            var serialized = (0, _serialize.serializeStyles)(styles.concat(classInterpolations), cache.registered, mergedProps);
            className += cache.key + "-" + serialized.name;
            if (targetClassName !== undefined) className += " " + targetClassName;
            var finalShouldForwardProp = shouldUseAs && shouldForwardProp === undefined ? getDefaultShouldForwardProp(FinalTag) : defaultShouldForwardProp;
            var newProps = {};
            for(var _key in props){
                if (shouldUseAs && _key === "as") continue;
                if (finalShouldForwardProp(_key)) newProps[_key] = props[_key];
            }
            newProps.className = className;
            newProps.ref = ref;
            return /*#__PURE__*/ _react.createElement(_react.Fragment, null, /*#__PURE__*/ _react.createElement(Insertion, {
                cache: cache,
                serialized: serialized,
                isStringTag: typeof FinalTag === "string"
            }), /*#__PURE__*/ _react.createElement(FinalTag, newProps));
        });
        Styled.displayName = identifierName !== undefined ? identifierName : "Styled(" + (typeof baseTag === "string" ? baseTag : baseTag.displayName || baseTag.name || "Component") + ")";
        Styled.defaultProps = tag.defaultProps;
        Styled.__emotion_real = Styled;
        Styled.__emotion_base = baseTag;
        Styled.__emotion_styles = styles;
        Styled.__emotion_forwardProp = shouldForwardProp;
        Object.defineProperty(Styled, "toString", {
            value: function value() {
                return "." + targetClassName;
            }
        });
        Styled.withComponent = function(nextTag, nextOptions) {
            return createStyled(nextTag, (0, _extendsDefault.default)({}, options, nextOptions, {
                shouldForwardProp: composeShouldForwardProps(Styled, nextOptions, true)
            })).apply(void 0, styles);
        };
        return Styled;
    };
};

},{"@babel/runtime/helpers/esm/extends":"fW5l8","react":"6uln9","@emotion/is-prop-valid":"8Sfn2","@emotion/react":"djZKr","@emotion/utils":"firjl","@emotion/serialize":"2Iv9c","@emotion/use-insertion-effect-with-fallbacks":"azNgR","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8Sfn2":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>isPropValid);
var _memoize = require("@emotion/memoize");
var _memoizeDefault = parcelHelpers.interopDefault(_memoize);
var reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|download|draggable|encType|enterKeyHint|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23
var isPropValid = /* #__PURE__ */ (0, _memoizeDefault.default)(function(prop) {
    return reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111 && prop.charCodeAt(1) === 110 && prop.charCodeAt(2) < 91;
});

},{"@emotion/memoize":"dMybP","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"azNgR":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useInsertionEffectAlwaysWithSyncFallback", ()=>useInsertionEffectAlwaysWithSyncFallback);
parcelHelpers.export(exports, "useInsertionEffectWithLayoutFallback", ()=>useInsertionEffectWithLayoutFallback);
var _react = require("react");
var syncFallback = function syncFallback(create) {
    return create();
};
var useInsertionEffect = _react["useInsertionEffect"] ? _react["useInsertionEffect"] : false;
var useInsertionEffectAlwaysWithSyncFallback = useInsertionEffect || syncFallback;
var useInsertionEffectWithLayoutFallback = useInsertionEffect || _react.useLayoutEffect;

},{"react":"6uln9","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"awUBr":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "cache", ()=>cache);
parcelHelpers.export(exports, "css", ()=>css);
parcelHelpers.export(exports, "cx", ()=>cx);
parcelHelpers.export(exports, "flush", ()=>flush);
parcelHelpers.export(exports, "getRegisteredStyles", ()=>getRegisteredStyles);
parcelHelpers.export(exports, "hydrate", ()=>hydrate);
parcelHelpers.export(exports, "injectGlobal", ()=>injectGlobal);
parcelHelpers.export(exports, "keyframes", ()=>keyframes);
parcelHelpers.export(exports, "merge", ()=>merge);
parcelHelpers.export(exports, "sheet", ()=>sheet);
var _emotionCssCreateInstanceEsmJs = require("../create-instance/dist/emotion-css-create-instance.esm.js");
var _emotionCssCreateInstanceEsmJsDefault = parcelHelpers.interopDefault(_emotionCssCreateInstanceEsmJs);
var _cache = require("@emotion/cache");
var _serialize = require("@emotion/serialize");
var _utils = require("@emotion/utils");
var _createEmotion = (0, _emotionCssCreateInstanceEsmJsDefault.default)({
    key: "css"
}), flush = _createEmotion.flush, hydrate = _createEmotion.hydrate, cx = _createEmotion.cx, merge = _createEmotion.merge, getRegisteredStyles = _createEmotion.getRegisteredStyles, injectGlobal = _createEmotion.injectGlobal, keyframes = _createEmotion.keyframes, css = _createEmotion.css, sheet = _createEmotion.sheet, cache = _createEmotion.cache;

},{"../create-instance/dist/emotion-css-create-instance.esm.js":"bmBhN","@emotion/cache":"dJbf5","@emotion/serialize":"2Iv9c","@emotion/utils":"firjl","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"bmBhN":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>createEmotion);
var _cache = require("@emotion/cache");
var _cacheDefault = parcelHelpers.interopDefault(_cache);
var _serialize = require("@emotion/serialize");
var _utils = require("@emotion/utils");
function insertWithoutScoping(cache, serialized) {
    if (cache.inserted[serialized.name] === undefined) return cache.insert("", serialized, cache.sheet, true);
}
function merge(registered, css, className) {
    var registeredStyles = [];
    var rawClassName = (0, _utils.getRegisteredStyles)(registered, registeredStyles, className);
    if (registeredStyles.length < 2) return className;
    return rawClassName + css(registeredStyles);
}
var createEmotion = function createEmotion(options) {
    var cache = (0, _cacheDefault.default)(options); // $FlowFixMe
    cache.sheet.speedy = function(value) {
        this.isSpeedy = value;
    };
    cache.compat = true;
    var css = function css() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        var serialized = (0, _serialize.serializeStyles)(args, cache.registered, undefined);
        (0, _utils.insertStyles)(cache, serialized, false);
        return cache.key + "-" + serialized.name;
    };
    var keyframes = function keyframes() {
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        var serialized = (0, _serialize.serializeStyles)(args, cache.registered);
        var animation = "animation-" + serialized.name;
        insertWithoutScoping(cache, {
            name: serialized.name,
            styles: "@keyframes " + animation + "{" + serialized.styles + "}"
        });
        return animation;
    };
    var injectGlobal = function injectGlobal() {
        for(var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++)args[_key3] = arguments[_key3];
        var serialized = (0, _serialize.serializeStyles)(args, cache.registered);
        insertWithoutScoping(cache, serialized);
    };
    var cx = function cx() {
        for(var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++)args[_key4] = arguments[_key4];
        return merge(cache.registered, css, classnames(args));
    };
    return {
        css: css,
        cx: cx,
        injectGlobal: injectGlobal,
        keyframes: keyframes,
        hydrate: function hydrate(ids) {
            ids.forEach(function(key) {
                cache.inserted[key] = true;
            });
        },
        flush: function flush() {
            cache.registered = {};
            cache.inserted = {};
            cache.sheet.flush();
        },
        // $FlowFixMe
        sheet: cache.sheet,
        cache: cache,
        getRegisteredStyles: (0, _utils.getRegisteredStyles).bind(null, cache.registered),
        merge: merge.bind(null, cache.registered, css)
    };
};
var classnames = function classnames(args) {
    var cls = "";
    for(var i = 0; i < args.length; i++){
        var arg = args[i];
        if (arg == null) continue;
        var toAdd = void 0;
        switch(typeof arg){
            case "boolean":
                break;
            case "object":
                if (Array.isArray(arg)) toAdd = classnames(arg);
                else {
                    toAdd = "";
                    for(var k in arg)if (arg[k] && k) {
                        toAdd && (toAdd += " ");
                        toAdd += k;
                    }
                }
                break;
            default:
                toAdd = arg;
        }
        if (toAdd) {
            cls && (cls += " ");
            cls += toAdd;
        }
    }
    return cls;
};

},{"@emotion/cache":"dJbf5","@emotion/serialize":"2Iv9c","@emotion/utils":"firjl","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3YnOK":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ErrorMessage", ()=>ErrorMessage);
parcelHelpers.export(exports, "FastField", ()=>FastField);
parcelHelpers.export(exports, "Field", ()=>Field);
parcelHelpers.export(exports, "FieldArray", ()=>FieldArray);
parcelHelpers.export(exports, "Form", ()=>Form);
parcelHelpers.export(exports, "Formik", ()=>Formik);
parcelHelpers.export(exports, "FormikConsumer", ()=>FormikConsumer);
parcelHelpers.export(exports, "FormikContext", ()=>FormikContext);
parcelHelpers.export(exports, "FormikProvider", ()=>FormikProvider);
parcelHelpers.export(exports, "connect", ()=>connect);
parcelHelpers.export(exports, "getActiveElement", ()=>getActiveElement);
parcelHelpers.export(exports, "getIn", ()=>getIn);
parcelHelpers.export(exports, "insert", ()=>insert);
parcelHelpers.export(exports, "isEmptyArray", ()=>isEmptyArray);
parcelHelpers.export(exports, "isEmptyChildren", ()=>isEmptyChildren);
parcelHelpers.export(exports, "isFunction", ()=>isFunction);
parcelHelpers.export(exports, "isInputEvent", ()=>isInputEvent);
parcelHelpers.export(exports, "isInteger", ()=>isInteger);
parcelHelpers.export(exports, "isNaN", ()=>isNaN$1);
parcelHelpers.export(exports, "isObject", ()=>isObject);
parcelHelpers.export(exports, "isPromise", ()=>isPromise);
parcelHelpers.export(exports, "isString", ()=>isString);
parcelHelpers.export(exports, "move", ()=>move);
parcelHelpers.export(exports, "prepareDataForValidation", ()=>prepareDataForValidation);
parcelHelpers.export(exports, "replace", ()=>replace);
parcelHelpers.export(exports, "setIn", ()=>setIn);
parcelHelpers.export(exports, "setNestedObjectValues", ()=>setNestedObjectValues);
parcelHelpers.export(exports, "swap", ()=>swap);
parcelHelpers.export(exports, "useField", ()=>useField);
parcelHelpers.export(exports, "useFormik", ()=>useFormik);
parcelHelpers.export(exports, "useFormikContext", ()=>useFormikContext);
parcelHelpers.export(exports, "validateYupSchema", ()=>validateYupSchema);
parcelHelpers.export(exports, "withFormik", ()=>withFormik);
parcelHelpers.export(exports, "yupToFormErrors", ()=>yupToFormErrors);
var _deepmerge = require("deepmerge");
var _deepmergeDefault = parcelHelpers.interopDefault(_deepmerge);
var _isPlainObject = require("lodash-es/isPlainObject");
var _isPlainObjectDefault = parcelHelpers.interopDefault(_isPlainObject);
var _react = require("react");
var _reactFastCompare = require("react-fast-compare");
var _reactFastCompareDefault = parcelHelpers.interopDefault(_reactFastCompare);
var _tinyWarning = require("tiny-warning");
var _tinyWarningDefault = parcelHelpers.interopDefault(_tinyWarning);
var _clone = require("lodash-es/clone");
var _cloneDefault = parcelHelpers.interopDefault(_clone);
var _toPath = require("lodash-es/toPath");
var _toPathDefault = parcelHelpers.interopDefault(_toPath);
var _hoistNonReactStatics = require("hoist-non-react-statics");
var _hoistNonReactStaticsDefault = parcelHelpers.interopDefault(_hoistNonReactStatics);
var _cloneDeep = require("lodash-es/cloneDeep");
var _cloneDeepDefault = parcelHelpers.interopDefault(_cloneDeep);
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
var FormikContext = /*#__PURE__*/ (0, _react.createContext)(undefined);
FormikContext.displayName = "FormikContext";
var FormikProvider = FormikContext.Provider;
var FormikConsumer = FormikContext.Consumer;
function useFormikContext() {
    var formik = (0, _react.useContext)(FormikContext);
    !!!formik && (0, _tinyWarningDefault.default)(false);
    return formik;
}
/** @private is the value an empty array? */ var isEmptyArray = function isEmptyArray(value) {
    return Array.isArray(value) && value.length === 0;
};
/** @private is the given object a Function? */ var isFunction = function isFunction(obj) {
    return typeof obj === "function";
};
/** @private is the given object an Object? */ var isObject = function isObject(obj) {
    return obj !== null && typeof obj === "object";
};
/** @private is the given object an integer? */ var isInteger = function isInteger(obj) {
    return String(Math.floor(Number(obj))) === obj;
};
/** @private is the given object a string? */ var isString = function isString(obj) {
    return Object.prototype.toString.call(obj) === "[object String]";
};
/** @private is the given object a NaN? */ // eslint-disable-next-line no-self-compare
var isNaN$1 = function isNaN1(obj) {
    return obj !== obj;
};
/** @private Does a React component have exactly 0 children? */ var isEmptyChildren = function isEmptyChildren(children) {
    return (0, _react.Children).count(children) === 0;
};
/** @private is the given object/value a promise? */ var isPromise = function isPromise(value) {
    return isObject(value) && isFunction(value.then);
};
/** @private is the given object/value a type of synthetic event? */ var isInputEvent = function isInputEvent(value) {
    return value && isObject(value) && isObject(value.target);
};
/**
 * Same as document.activeElement but wraps in a try-catch block. In IE it is
 * not safe to call document.activeElement if there is nothing focused.
 *
 * The activeElement will be null only if the document or document body is not
 * yet defined.
 *
 * @param {?Document} doc Defaults to current document.
 * @return {Element | null}
 * @see https://github.com/facebook/fbjs/blob/master/packages/fbjs/src/core/dom/getActiveElement.js
 */ function getActiveElement(doc) {
    doc = doc || (typeof document !== "undefined" ? document : undefined);
    if (typeof doc === "undefined") return null;
    try {
        return doc.activeElement || doc.body;
    } catch (e) {
        return doc.body;
    }
}
/**
 * Deeply get a value from an object via its path.
 */ function getIn(obj, key, def, p) {
    if (p === void 0) p = 0;
    var path = (0, _toPathDefault.default)(key);
    while(obj && p < path.length)obj = obj[path[p++]];
     // check if path is not in the end
    if (p !== path.length && !obj) return def;
    return obj === undefined ? def : obj;
}
/**
 * Deeply set a value from in object via it's path. If the value at `path`
 * has changed, return a shallow copy of obj with `value` set at `path`.
 * If `value` has not changed, return the original `obj`.
 *
 * Existing objects / arrays along `path` are also shallow copied. Sibling
 * objects along path retain the same internal js reference. Since new
 * objects / arrays are only created along `path`, we can test if anything
 * changed in a nested structure by comparing the object's reference in
 * the old and new object, similar to how russian doll cache invalidation
 * works.
 *
 * In earlier versions of this function, which used cloneDeep, there were
 * issues whereby settings a nested value would mutate the parent
 * instead of creating a new object. `clone` avoids that bug making a
 * shallow copy of the objects along the update path
 * so no object is mutated in place.
 *
 * Before changing this function, please read through the following
 * discussions.
 *
 * @see https://github.com/developit/linkstate
 * @see https://github.com/jaredpalmer/formik/pull/123
 */ function setIn(obj, path, value) {
    var res = (0, _cloneDefault.default)(obj); // this keeps inheritance when obj is a class
    var resVal = res;
    var i = 0;
    var pathArray = (0, _toPathDefault.default)(path);
    for(; i < pathArray.length - 1; i++){
        var currentPath = pathArray[i];
        var currentObj = getIn(obj, pathArray.slice(0, i + 1));
        if (currentObj && (isObject(currentObj) || Array.isArray(currentObj))) resVal = resVal[currentPath] = (0, _cloneDefault.default)(currentObj);
        else {
            var nextPath = pathArray[i + 1];
            resVal = resVal[currentPath] = isInteger(nextPath) && Number(nextPath) >= 0 ? [] : {};
        }
    } // Return original object if new value is the same as current
    if ((i === 0 ? obj : resVal)[pathArray[i]] === value) return obj;
    if (value === undefined) delete resVal[pathArray[i]];
    else resVal[pathArray[i]] = value;
     // If the path array has a single element, the loop did not run.
    // Deleting on `resVal` had no effect in this scenario, so we delete on the result instead.
    if (i === 0 && value === undefined) delete res[pathArray[i]];
    return res;
}
/**
 * Recursively a set the same value for all keys and arrays nested object, cloning
 * @param object
 * @param value
 * @param visited
 * @param response
 */ function setNestedObjectValues(object, value, visited, response) {
    if (visited === void 0) visited = new WeakMap();
    if (response === void 0) response = {};
    for(var _i = 0, _Object$keys = Object.keys(object); _i < _Object$keys.length; _i++){
        var k = _Object$keys[_i];
        var val = object[k];
        if (isObject(val)) {
            if (!visited.get(val)) {
                visited.set(val, true); // In order to keep array values consistent for both dot path  and
                // bracket syntax, we need to check if this is an array so that
                // this will output  { friends: [true] } and not { friends: { "0": true } }
                response[k] = Array.isArray(val) ? [] : {};
                setNestedObjectValues(val, value, visited, response[k]);
            }
        } else response[k] = value;
    }
    return response;
}
function formikReducer(state, msg) {
    switch(msg.type){
        case "SET_VALUES":
            return _extends({}, state, {
                values: msg.payload
            });
        case "SET_TOUCHED":
            return _extends({}, state, {
                touched: msg.payload
            });
        case "SET_ERRORS":
            if ((0, _reactFastCompareDefault.default)(state.errors, msg.payload)) return state;
            return _extends({}, state, {
                errors: msg.payload
            });
        case "SET_STATUS":
            return _extends({}, state, {
                status: msg.payload
            });
        case "SET_ISSUBMITTING":
            return _extends({}, state, {
                isSubmitting: msg.payload
            });
        case "SET_ISVALIDATING":
            return _extends({}, state, {
                isValidating: msg.payload
            });
        case "SET_FIELD_VALUE":
            return _extends({}, state, {
                values: setIn(state.values, msg.payload.field, msg.payload.value)
            });
        case "SET_FIELD_TOUCHED":
            return _extends({}, state, {
                touched: setIn(state.touched, msg.payload.field, msg.payload.value)
            });
        case "SET_FIELD_ERROR":
            return _extends({}, state, {
                errors: setIn(state.errors, msg.payload.field, msg.payload.value)
            });
        case "RESET_FORM":
            return _extends({}, state, msg.payload);
        case "SET_FORMIK_STATE":
            return msg.payload(state);
        case "SUBMIT_ATTEMPT":
            return _extends({}, state, {
                touched: setNestedObjectValues(state.values, true),
                isSubmitting: true,
                submitCount: state.submitCount + 1
            });
        case "SUBMIT_FAILURE":
            return _extends({}, state, {
                isSubmitting: false
            });
        case "SUBMIT_SUCCESS":
            return _extends({}, state, {
                isSubmitting: false
            });
        default:
            return state;
    }
} // Initial empty states // objects
var emptyErrors = {};
var emptyTouched = {};
function useFormik(_ref) {
    var _ref$validateOnChange = _ref.validateOnChange, validateOnChange = _ref$validateOnChange === void 0 ? true : _ref$validateOnChange, _ref$validateOnBlur = _ref.validateOnBlur, validateOnBlur = _ref$validateOnBlur === void 0 ? true : _ref$validateOnBlur, _ref$validateOnMount = _ref.validateOnMount, validateOnMount = _ref$validateOnMount === void 0 ? false : _ref$validateOnMount, isInitialValid = _ref.isInitialValid, _ref$enableReinitiali = _ref.enableReinitialize, enableReinitialize = _ref$enableReinitiali === void 0 ? false : _ref$enableReinitiali, onSubmit = _ref.onSubmit, rest = _objectWithoutPropertiesLoose(_ref, [
        "validateOnChange",
        "validateOnBlur",
        "validateOnMount",
        "isInitialValid",
        "enableReinitialize",
        "onSubmit"
    ]);
    var props = _extends({
        validateOnChange: validateOnChange,
        validateOnBlur: validateOnBlur,
        validateOnMount: validateOnMount,
        onSubmit: onSubmit
    }, rest);
    var initialValues = (0, _react.useRef)(props.initialValues);
    var initialErrors = (0, _react.useRef)(props.initialErrors || emptyErrors);
    var initialTouched = (0, _react.useRef)(props.initialTouched || emptyTouched);
    var initialStatus = (0, _react.useRef)(props.initialStatus);
    var isMounted = (0, _react.useRef)(false);
    var fieldRegistry = (0, _react.useRef)({});
    (0, _react.useEffect)(function() {
        isMounted.current = true;
        return function() {
            isMounted.current = false;
        };
    }, []);
    var _React$useState = (0, _react.useState)(0), setIteration = _React$useState[1];
    var stateRef = (0, _react.useRef)({
        values: props.initialValues,
        errors: props.initialErrors || emptyErrors,
        touched: props.initialTouched || emptyTouched,
        status: props.initialStatus,
        isSubmitting: false,
        isValidating: false,
        submitCount: 0
    });
    var state = stateRef.current;
    var dispatch = (0, _react.useCallback)(function(action) {
        var prev = stateRef.current;
        stateRef.current = formikReducer(prev, action); // force rerender
        if (prev !== stateRef.current) setIteration(function(x) {
            return x + 1;
        });
    }, []);
    var runValidateHandler = (0, _react.useCallback)(function(values, field) {
        return new Promise(function(resolve, reject) {
            var maybePromisedErrors = props.validate(values, field);
            if (maybePromisedErrors == null) // use loose null check here on purpose
            resolve(emptyErrors);
            else if (isPromise(maybePromisedErrors)) maybePromisedErrors.then(function(errors) {
                resolve(errors || emptyErrors);
            }, function(actualException) {
                reject(actualException);
            });
            else resolve(maybePromisedErrors);
        });
    }, [
        props.validate
    ]);
    /**
   * Run validation against a Yup schema and optionally run a function if successful
   */ var runValidationSchema = (0, _react.useCallback)(function(values, field) {
        var validationSchema = props.validationSchema;
        var schema = isFunction(validationSchema) ? validationSchema(field) : validationSchema;
        var promise = field && schema.validateAt ? schema.validateAt(field, values) : validateYupSchema(values, schema);
        return new Promise(function(resolve, reject) {
            promise.then(function() {
                resolve(emptyErrors);
            }, function(err) {
                // Yup will throw a validation error if validation fails. We catch those and
                // resolve them into Formik errors. We can sniff if something is a Yup error
                // by checking error.name.
                // @see https://github.com/jquense/yup#validationerrorerrors-string--arraystring-value-any-path-string
                if (err.name === "ValidationError") resolve(yupToFormErrors(err));
                else reject(err);
            });
        });
    }, [
        props.validationSchema
    ]);
    var runSingleFieldLevelValidation = (0, _react.useCallback)(function(field, value) {
        return new Promise(function(resolve) {
            return resolve(fieldRegistry.current[field].validate(value));
        });
    }, []);
    var runFieldLevelValidations = (0, _react.useCallback)(function(values) {
        var fieldKeysWithValidation = Object.keys(fieldRegistry.current).filter(function(f) {
            return isFunction(fieldRegistry.current[f].validate);
        }); // Construct an array with all of the field validation functions
        var fieldValidations = fieldKeysWithValidation.length > 0 ? fieldKeysWithValidation.map(function(f) {
            return runSingleFieldLevelValidation(f, getIn(values, f));
        }) : [
            Promise.resolve("DO_NOT_DELETE_YOU_WILL_BE_FIRED")
        ]; // use special case ;)
        return Promise.all(fieldValidations).then(function(fieldErrorsList) {
            return fieldErrorsList.reduce(function(prev, curr, index) {
                if (curr === "DO_NOT_DELETE_YOU_WILL_BE_FIRED") return prev;
                if (curr) prev = setIn(prev, fieldKeysWithValidation[index], curr);
                return prev;
            }, {});
        });
    }, [
        runSingleFieldLevelValidation
    ]); // Run all validations and return the result
    var runAllValidations = (0, _react.useCallback)(function(values) {
        return Promise.all([
            runFieldLevelValidations(values),
            props.validationSchema ? runValidationSchema(values) : {},
            props.validate ? runValidateHandler(values) : {}
        ]).then(function(_ref2) {
            var fieldErrors = _ref2[0], schemaErrors = _ref2[1], validateErrors = _ref2[2];
            var combinedErrors = (0, _deepmergeDefault.default).all([
                fieldErrors,
                schemaErrors,
                validateErrors
            ], {
                arrayMerge: arrayMerge
            });
            return combinedErrors;
        });
    }, [
        props.validate,
        props.validationSchema,
        runFieldLevelValidations,
        runValidateHandler,
        runValidationSchema
    ]); // Run all validations methods and update state accordingly
    var validateFormWithHighPriority = useEventCallback(function(values) {
        if (values === void 0) values = state.values;
        dispatch({
            type: "SET_ISVALIDATING",
            payload: true
        });
        return runAllValidations(values).then(function(combinedErrors) {
            if (!!isMounted.current) {
                dispatch({
                    type: "SET_ISVALIDATING",
                    payload: false
                });
                dispatch({
                    type: "SET_ERRORS",
                    payload: combinedErrors
                });
            }
            return combinedErrors;
        });
    });
    (0, _react.useEffect)(function() {
        if (validateOnMount && isMounted.current === true && (0, _reactFastCompareDefault.default)(initialValues.current, props.initialValues)) validateFormWithHighPriority(initialValues.current);
    }, [
        validateOnMount,
        validateFormWithHighPriority
    ]);
    var resetForm = (0, _react.useCallback)(function(nextState) {
        var values = nextState && nextState.values ? nextState.values : initialValues.current;
        var errors = nextState && nextState.errors ? nextState.errors : initialErrors.current ? initialErrors.current : props.initialErrors || {};
        var touched = nextState && nextState.touched ? nextState.touched : initialTouched.current ? initialTouched.current : props.initialTouched || {};
        var status = nextState && nextState.status ? nextState.status : initialStatus.current ? initialStatus.current : props.initialStatus;
        initialValues.current = values;
        initialErrors.current = errors;
        initialTouched.current = touched;
        initialStatus.current = status;
        var dispatchFn = function dispatchFn() {
            dispatch({
                type: "RESET_FORM",
                payload: {
                    isSubmitting: !!nextState && !!nextState.isSubmitting,
                    errors: errors,
                    touched: touched,
                    status: status,
                    values: values,
                    isValidating: !!nextState && !!nextState.isValidating,
                    submitCount: !!nextState && !!nextState.submitCount && typeof nextState.submitCount === "number" ? nextState.submitCount : 0
                }
            });
        };
        if (props.onReset) {
            var maybePromisedOnReset = props.onReset(state.values, imperativeMethods);
            if (isPromise(maybePromisedOnReset)) maybePromisedOnReset.then(dispatchFn);
            else dispatchFn();
        } else dispatchFn();
    }, [
        props.initialErrors,
        props.initialStatus,
        props.initialTouched
    ]);
    (0, _react.useEffect)(function() {
        if (isMounted.current === true && !(0, _reactFastCompareDefault.default)(initialValues.current, props.initialValues)) {
            if (enableReinitialize) {
                initialValues.current = props.initialValues;
                resetForm();
                if (validateOnMount) validateFormWithHighPriority(initialValues.current);
            }
        }
    }, [
        enableReinitialize,
        props.initialValues,
        resetForm,
        validateOnMount,
        validateFormWithHighPriority
    ]);
    (0, _react.useEffect)(function() {
        if (enableReinitialize && isMounted.current === true && !(0, _reactFastCompareDefault.default)(initialErrors.current, props.initialErrors)) {
            initialErrors.current = props.initialErrors || emptyErrors;
            dispatch({
                type: "SET_ERRORS",
                payload: props.initialErrors || emptyErrors
            });
        }
    }, [
        enableReinitialize,
        props.initialErrors
    ]);
    (0, _react.useEffect)(function() {
        if (enableReinitialize && isMounted.current === true && !(0, _reactFastCompareDefault.default)(initialTouched.current, props.initialTouched)) {
            initialTouched.current = props.initialTouched || emptyTouched;
            dispatch({
                type: "SET_TOUCHED",
                payload: props.initialTouched || emptyTouched
            });
        }
    }, [
        enableReinitialize,
        props.initialTouched
    ]);
    (0, _react.useEffect)(function() {
        if (enableReinitialize && isMounted.current === true && !(0, _reactFastCompareDefault.default)(initialStatus.current, props.initialStatus)) {
            initialStatus.current = props.initialStatus;
            dispatch({
                type: "SET_STATUS",
                payload: props.initialStatus
            });
        }
    }, [
        enableReinitialize,
        props.initialStatus,
        props.initialTouched
    ]);
    var validateField = useEventCallback(function(name) {
        // This will efficiently validate a single field by avoiding state
        // changes if the validation function is synchronous. It's different from
        // what is called when using validateForm.
        if (fieldRegistry.current[name] && isFunction(fieldRegistry.current[name].validate)) {
            var value = getIn(state.values, name);
            var maybePromise = fieldRegistry.current[name].validate(value);
            if (isPromise(maybePromise)) {
                // Only flip isValidating if the function is async.
                dispatch({
                    type: "SET_ISVALIDATING",
                    payload: true
                });
                return maybePromise.then(function(x) {
                    return x;
                }).then(function(error) {
                    dispatch({
                        type: "SET_FIELD_ERROR",
                        payload: {
                            field: name,
                            value: error
                        }
                    });
                    dispatch({
                        type: "SET_ISVALIDATING",
                        payload: false
                    });
                });
            } else {
                dispatch({
                    type: "SET_FIELD_ERROR",
                    payload: {
                        field: name,
                        value: maybePromise
                    }
                });
                return Promise.resolve(maybePromise);
            }
        } else if (props.validationSchema) {
            dispatch({
                type: "SET_ISVALIDATING",
                payload: true
            });
            return runValidationSchema(state.values, name).then(function(x) {
                return x;
            }).then(function(error) {
                dispatch({
                    type: "SET_FIELD_ERROR",
                    payload: {
                        field: name,
                        value: getIn(error, name)
                    }
                });
                dispatch({
                    type: "SET_ISVALIDATING",
                    payload: false
                });
            });
        }
        return Promise.resolve();
    });
    var registerField = (0, _react.useCallback)(function(name, _ref3) {
        var validate = _ref3.validate;
        fieldRegistry.current[name] = {
            validate: validate
        };
    }, []);
    var unregisterField = (0, _react.useCallback)(function(name) {
        delete fieldRegistry.current[name];
    }, []);
    var setTouched = useEventCallback(function(touched, shouldValidate) {
        dispatch({
            type: "SET_TOUCHED",
            payload: touched
        });
        var willValidate = shouldValidate === undefined ? validateOnBlur : shouldValidate;
        return willValidate ? validateFormWithHighPriority(state.values) : Promise.resolve();
    });
    var setErrors = (0, _react.useCallback)(function(errors) {
        dispatch({
            type: "SET_ERRORS",
            payload: errors
        });
    }, []);
    var setValues = useEventCallback(function(values, shouldValidate) {
        var resolvedValues = isFunction(values) ? values(state.values) : values;
        dispatch({
            type: "SET_VALUES",
            payload: resolvedValues
        });
        var willValidate = shouldValidate === undefined ? validateOnChange : shouldValidate;
        return willValidate ? validateFormWithHighPriority(resolvedValues) : Promise.resolve();
    });
    var setFieldError = (0, _react.useCallback)(function(field, value) {
        dispatch({
            type: "SET_FIELD_ERROR",
            payload: {
                field: field,
                value: value
            }
        });
    }, []);
    var setFieldValue = useEventCallback(function(field, value, shouldValidate) {
        dispatch({
            type: "SET_FIELD_VALUE",
            payload: {
                field: field,
                value: value
            }
        });
        var willValidate = shouldValidate === undefined ? validateOnChange : shouldValidate;
        return willValidate ? validateFormWithHighPriority(setIn(state.values, field, value)) : Promise.resolve();
    });
    var executeChange = (0, _react.useCallback)(function(eventOrTextValue, maybePath) {
        // By default, assume that the first argument is a string. This allows us to use
        // handleChange with React Native and React Native Web's onChangeText prop which
        // provides just the value of the input.
        var field = maybePath;
        var val = eventOrTextValue;
        var parsed; // If the first argument is not a string though, it has to be a synthetic React Event (or a fake one),
        // so we handle like we would a normal HTML change event.
        if (!isString(eventOrTextValue)) {
            // If we can, persist the event
            // @see https://reactjs.org/docs/events.html#event-pooling
            if (eventOrTextValue.persist) eventOrTextValue.persist();
            var target = eventOrTextValue.target ? eventOrTextValue.target : eventOrTextValue.currentTarget;
            var type = target.type, name = target.name, id = target.id, value = target.value, checked = target.checked, outerHTML = target.outerHTML, options = target.options, multiple = target.multiple;
            field = maybePath ? maybePath : name ? name : id;
            val = /number|range/.test(type) ? (parsed = parseFloat(value), isNaN(parsed) ? "" : parsed) : /checkbox/.test(type) // checkboxes
             ? getValueForCheckbox(getIn(state.values, field), checked, value) : options && multiple // <select multiple>
             ? getSelectedValues(options) : value;
        }
        if (field) // Set form fields by name
        setFieldValue(field, val);
    }, [
        setFieldValue,
        state.values
    ]);
    var handleChange = useEventCallback(function(eventOrPath) {
        if (isString(eventOrPath)) return function(event) {
            return executeChange(event, eventOrPath);
        };
        else executeChange(eventOrPath);
    });
    var setFieldTouched = useEventCallback(function(field, touched, shouldValidate) {
        if (touched === void 0) touched = true;
        dispatch({
            type: "SET_FIELD_TOUCHED",
            payload: {
                field: field,
                value: touched
            }
        });
        var willValidate = shouldValidate === undefined ? validateOnBlur : shouldValidate;
        return willValidate ? validateFormWithHighPriority(state.values) : Promise.resolve();
    });
    var executeBlur = (0, _react.useCallback)(function(e, path) {
        if (e.persist) e.persist();
        var _e$target = e.target, name = _e$target.name, id = _e$target.id, outerHTML = _e$target.outerHTML;
        var field = path ? path : name ? name : id;
        setFieldTouched(field, true);
    }, [
        setFieldTouched
    ]);
    var handleBlur = useEventCallback(function(eventOrString) {
        if (isString(eventOrString)) return function(event) {
            return executeBlur(event, eventOrString);
        };
        else executeBlur(eventOrString);
    });
    var setFormikState = (0, _react.useCallback)(function(stateOrCb) {
        if (isFunction(stateOrCb)) dispatch({
            type: "SET_FORMIK_STATE",
            payload: stateOrCb
        });
        else dispatch({
            type: "SET_FORMIK_STATE",
            payload: function payload() {
                return stateOrCb;
            }
        });
    }, []);
    var setStatus = (0, _react.useCallback)(function(status) {
        dispatch({
            type: "SET_STATUS",
            payload: status
        });
    }, []);
    var setSubmitting = (0, _react.useCallback)(function(isSubmitting) {
        dispatch({
            type: "SET_ISSUBMITTING",
            payload: isSubmitting
        });
    }, []);
    var submitForm = useEventCallback(function() {
        dispatch({
            type: "SUBMIT_ATTEMPT"
        });
        return validateFormWithHighPriority().then(function(combinedErrors) {
            // In case an error was thrown and passed to the resolved Promise,
            // `combinedErrors` can be an instance of an Error. We need to check
            // that and abort the submit.
            // If we don't do that, calling `Object.keys(new Error())` yields an
            // empty array, which causes the validation to pass and the form
            // to be submitted.
            var isInstanceOfError = combinedErrors instanceof Error;
            var isActuallyValid = !isInstanceOfError && Object.keys(combinedErrors).length === 0;
            if (isActuallyValid) {
                // Proceed with submit...
                //
                // To respect sync submit fns, we can't simply wrap executeSubmit in a promise and
                // _always_ dispatch SUBMIT_SUCCESS because isSubmitting would then always be false.
                // This would be fine in simple cases, but make it impossible to disable submit
                // buttons where people use callbacks or promises as side effects (which is basically
                // all of v1 Formik code). Instead, recall that we are inside of a promise chain already,
                //  so we can try/catch executeSubmit(), if it returns undefined, then just bail.
                // If there are errors, throw em. Otherwise, wrap executeSubmit in a promise and handle
                // cleanup of isSubmitting on behalf of the consumer.
                var promiseOrUndefined;
                try {
                    promiseOrUndefined = executeSubmit(); // Bail if it's sync, consumer is responsible for cleaning up
                    // via setSubmitting(false)
                    if (promiseOrUndefined === undefined) return;
                } catch (error) {
                    throw error;
                }
                return Promise.resolve(promiseOrUndefined).then(function(result) {
                    if (!!isMounted.current) dispatch({
                        type: "SUBMIT_SUCCESS"
                    });
                    return result;
                })["catch"](function(_errors) {
                    if (!!isMounted.current) {
                        dispatch({
                            type: "SUBMIT_FAILURE"
                        }); // This is a legit error rejected by the onSubmit fn
                        // so we don't want to break the promise chain
                        throw _errors;
                    }
                });
            } else if (!!isMounted.current) {
                // ^^^ Make sure Formik is still mounted before updating state
                dispatch({
                    type: "SUBMIT_FAILURE"
                }); // throw combinedErrors;
                if (isInstanceOfError) throw combinedErrors;
            }
            return;
        });
    });
    var handleSubmit = useEventCallback(function(e) {
        if (e && e.preventDefault && isFunction(e.preventDefault)) e.preventDefault();
        if (e && e.stopPropagation && isFunction(e.stopPropagation)) e.stopPropagation();
         // Warn if form submission is triggered by a <button> without a
        var activeElement;
        submitForm()["catch"](function(reason) {
            console.warn("Warning: An unhandled error was caught from submitForm()", reason);
        });
    });
    var imperativeMethods = {
        resetForm: resetForm,
        validateForm: validateFormWithHighPriority,
        validateField: validateField,
        setErrors: setErrors,
        setFieldError: setFieldError,
        setFieldTouched: setFieldTouched,
        setFieldValue: setFieldValue,
        setStatus: setStatus,
        setSubmitting: setSubmitting,
        setTouched: setTouched,
        setValues: setValues,
        setFormikState: setFormikState,
        submitForm: submitForm
    };
    var executeSubmit = useEventCallback(function() {
        return onSubmit(state.values, imperativeMethods);
    });
    var handleReset = useEventCallback(function(e) {
        if (e && e.preventDefault && isFunction(e.preventDefault)) e.preventDefault();
        if (e && e.stopPropagation && isFunction(e.stopPropagation)) e.stopPropagation();
        resetForm();
    });
    var getFieldMeta = (0, _react.useCallback)(function(name) {
        return {
            value: getIn(state.values, name),
            error: getIn(state.errors, name),
            touched: !!getIn(state.touched, name),
            initialValue: getIn(initialValues.current, name),
            initialTouched: !!getIn(initialTouched.current, name),
            initialError: getIn(initialErrors.current, name)
        };
    }, [
        state.errors,
        state.touched,
        state.values
    ]);
    var getFieldHelpers = (0, _react.useCallback)(function(name) {
        return {
            setValue: function setValue(value, shouldValidate) {
                return setFieldValue(name, value, shouldValidate);
            },
            setTouched: function setTouched(value, shouldValidate) {
                return setFieldTouched(name, value, shouldValidate);
            },
            setError: function setError(value) {
                return setFieldError(name, value);
            }
        };
    }, [
        setFieldValue,
        setFieldTouched,
        setFieldError
    ]);
    var getFieldProps = (0, _react.useCallback)(function(nameOrOptions) {
        var isAnObject = isObject(nameOrOptions);
        var name = isAnObject ? nameOrOptions.name : nameOrOptions;
        var valueState = getIn(state.values, name);
        var field = {
            name: name,
            value: valueState,
            onChange: handleChange,
            onBlur: handleBlur
        };
        if (isAnObject) {
            var type = nameOrOptions.type, valueProp = nameOrOptions.value, is = nameOrOptions.as, multiple = nameOrOptions.multiple;
            if (type === "checkbox") {
                if (valueProp === undefined) field.checked = !!valueState;
                else {
                    field.checked = !!(Array.isArray(valueState) && ~valueState.indexOf(valueProp));
                    field.value = valueProp;
                }
            } else if (type === "radio") {
                field.checked = valueState === valueProp;
                field.value = valueProp;
            } else if (is === "select" && multiple) {
                field.value = field.value || [];
                field.multiple = true;
            }
        }
        return field;
    }, [
        handleBlur,
        handleChange,
        state.values
    ]);
    var dirty = (0, _react.useMemo)(function() {
        return !(0, _reactFastCompareDefault.default)(initialValues.current, state.values);
    }, [
        initialValues.current,
        state.values
    ]);
    var isValid = (0, _react.useMemo)(function() {
        return typeof isInitialValid !== "undefined" ? dirty ? state.errors && Object.keys(state.errors).length === 0 : isInitialValid !== false && isFunction(isInitialValid) ? isInitialValid(props) : isInitialValid : state.errors && Object.keys(state.errors).length === 0;
    }, [
        isInitialValid,
        dirty,
        state.errors,
        props
    ]);
    var ctx = _extends({}, state, {
        initialValues: initialValues.current,
        initialErrors: initialErrors.current,
        initialTouched: initialTouched.current,
        initialStatus: initialStatus.current,
        handleBlur: handleBlur,
        handleChange: handleChange,
        handleReset: handleReset,
        handleSubmit: handleSubmit,
        resetForm: resetForm,
        setErrors: setErrors,
        setFormikState: setFormikState,
        setFieldTouched: setFieldTouched,
        setFieldValue: setFieldValue,
        setFieldError: setFieldError,
        setStatus: setStatus,
        setSubmitting: setSubmitting,
        setTouched: setTouched,
        setValues: setValues,
        submitForm: submitForm,
        validateForm: validateFormWithHighPriority,
        validateField: validateField,
        isValid: isValid,
        dirty: dirty,
        unregisterField: unregisterField,
        registerField: registerField,
        getFieldProps: getFieldProps,
        getFieldMeta: getFieldMeta,
        getFieldHelpers: getFieldHelpers,
        validateOnBlur: validateOnBlur,
        validateOnChange: validateOnChange,
        validateOnMount: validateOnMount
    });
    return ctx;
}
function Formik(props) {
    var formikbag = useFormik(props);
    var component = props.component, children = props.children, render = props.render, innerRef = props.innerRef; // This allows folks to pass a ref to <Formik />
    (0, _react.useImperativeHandle)(innerRef, function() {
        return formikbag;
    });
    return (0, _react.createElement)(FormikProvider, {
        value: formikbag
    }, component ? (0, _react.createElement)(component, formikbag) : render ? render(formikbag) : children // children come last, always called
     ? isFunction(children) ? children(formikbag) : !isEmptyChildren(children) ? (0, _react.Children).only(children) : null : null);
}
function warnAboutMissingIdentifier(_ref4) {
    var htmlContent = _ref4.htmlContent, documentationAnchorLink = _ref4.documentationAnchorLink, handlerName = _ref4.handlerName;
    console.warn("Warning: Formik called `" + handlerName + "`, but you forgot to pass an `id` or `name` attribute to your input:\n    " + htmlContent + "\n    Formik cannot determine which value to update. For more info see https://formik.org/docs/api/formik#" + documentationAnchorLink + "\n  ");
}
/**
 * Transform Yup ValidationError to a more usable object
 */ function yupToFormErrors(yupError) {
    var errors = {};
    if (yupError.inner) {
        if (yupError.inner.length === 0) return setIn(errors, yupError.path, yupError.message);
        for(var _iterator = yupError.inner, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;){
            var _ref5;
            if (_isArray) {
                if (_i >= _iterator.length) break;
                _ref5 = _iterator[_i++];
            } else {
                _i = _iterator.next();
                if (_i.done) break;
                _ref5 = _i.value;
            }
            var err = _ref5;
            if (!getIn(errors, err.path)) errors = setIn(errors, err.path, err.message);
        }
    }
    return errors;
}
/**
 * Validate a yup schema.
 */ function validateYupSchema(values, schema, sync, context) {
    if (sync === void 0) sync = false;
    var normalizedValues = prepareDataForValidation(values);
    return schema[sync ? "validateSync" : "validate"](normalizedValues, {
        abortEarly: false,
        context: context || normalizedValues
    });
}
/**
 * Recursively prepare values.
 */ function prepareDataForValidation(values) {
    var data = Array.isArray(values) ? [] : {};
    for(var k in values)if (Object.prototype.hasOwnProperty.call(values, k)) {
        var key = String(k);
        if (Array.isArray(values[key]) === true) data[key] = values[key].map(function(value) {
            if (Array.isArray(value) === true || (0, _isPlainObjectDefault.default)(value)) return prepareDataForValidation(value);
            else return value !== "" ? value : undefined;
        });
        else if ((0, _isPlainObjectDefault.default)(values[key])) data[key] = prepareDataForValidation(values[key]);
        else data[key] = values[key] !== "" ? values[key] : undefined;
    }
    return data;
}
/**
 * deepmerge array merging algorithm
 * https://github.com/KyleAMathews/deepmerge#combine-array
 */ function arrayMerge(target, source, options) {
    var destination = target.slice();
    source.forEach(function merge(e, i) {
        if (typeof destination[i] === "undefined") {
            var cloneRequested = options.clone !== false;
            var shouldClone = cloneRequested && options.isMergeableObject(e);
            destination[i] = shouldClone ? (0, _deepmergeDefault.default)(Array.isArray(e) ? [] : {}, e, options) : e;
        } else if (options.isMergeableObject(e)) destination[i] = (0, _deepmergeDefault.default)(target[i], e, options);
        else if (target.indexOf(e) === -1) destination.push(e);
    });
    return destination;
}
/** Return multi select values based on an array of options */ function getSelectedValues(options) {
    return Array.from(options).filter(function(el) {
        return el.selected;
    }).map(function(el) {
        return el.value;
    });
}
/** Return the next value for a checkbox */ function getValueForCheckbox(currentValue, checked, valueProp) {
    // If the current value was a boolean, return a boolean
    if (typeof currentValue === "boolean") return Boolean(checked);
     // If the currentValue was not a boolean we want to return an array
    var currentArrayOfValues = [];
    var isValueInArray = false;
    var index = -1;
    if (!Array.isArray(currentValue)) {
        // eslint-disable-next-line eqeqeq
        if (!valueProp || valueProp == "true" || valueProp == "false") return Boolean(checked);
    } else {
        // If the current value is already an array, use it
        currentArrayOfValues = currentValue;
        index = currentValue.indexOf(valueProp);
        isValueInArray = index >= 0;
    } // If the checkbox was checked and the value is not already present in the aray we want to add the new value to the array of values
    if (checked && valueProp && !isValueInArray) return currentArrayOfValues.concat(valueProp);
     // If the checkbox was unchecked and the value is not in the array, simply return the already existing array of values
    if (!isValueInArray) return currentArrayOfValues;
     // If the checkbox was unchecked and the value is in the array, remove the value and return the array
    return currentArrayOfValues.slice(0, index).concat(currentArrayOfValues.slice(index + 1));
} // React currently throws a warning when using useLayoutEffect on the server.
// To get around it, we can conditionally useEffect on the server (no-op) and
// useLayoutEffect in the browser.
// @see https://gist.github.com/gaearon/e7d97cdf38a2907924ea12e4ebdf3c85
var useIsomorphicLayoutEffect = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined" ? (0, _react.useLayoutEffect) : (0, _react.useEffect);
function useEventCallback(fn) {
    var ref = (0, _react.useRef)(fn); // we copy a ref to the callback scoped to the current state/props on each render
    useIsomorphicLayoutEffect(function() {
        ref.current = fn;
    });
    return (0, _react.useCallback)(function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return ref.current.apply(void 0, args);
    }, []);
}
function useField(propsOrFieldName) {
    var formik = useFormikContext();
    var getFieldProps = formik.getFieldProps, getFieldMeta = formik.getFieldMeta, getFieldHelpers = formik.getFieldHelpers, registerField = formik.registerField, unregisterField = formik.unregisterField;
    var isAnObject = isObject(propsOrFieldName); // Normalize propsOrFieldName to FieldHookConfig<Val>
    var props = isAnObject ? propsOrFieldName : {
        name: propsOrFieldName
    };
    var fieldName = props.name, validateFn = props.validate;
    (0, _react.useEffect)(function() {
        if (fieldName) registerField(fieldName, {
            validate: validateFn
        });
        return function() {
            if (fieldName) unregisterField(fieldName);
        };
    }, [
        registerField,
        unregisterField,
        fieldName,
        validateFn
    ]);
    !fieldName && (0, _tinyWarningDefault.default)(false);
    var fieldHelpers = (0, _react.useMemo)(function() {
        return getFieldHelpers(fieldName);
    }, [
        getFieldHelpers,
        fieldName
    ]);
    return [
        getFieldProps(props),
        getFieldMeta(fieldName),
        fieldHelpers
    ];
}
function Field(_ref) {
    var validate = _ref.validate, name = _ref.name, render = _ref.render, children = _ref.children, is = _ref.as, component = _ref.component, props = _objectWithoutPropertiesLoose(_ref, [
        "validate",
        "name",
        "render",
        "children",
        "as",
        "component"
    ]);
    var _useFormikContext = useFormikContext(), formik = _objectWithoutPropertiesLoose(_useFormikContext, [
        "validate",
        "validationSchema"
    ]);
    var registerField = formik.registerField, unregisterField = formik.unregisterField;
    (0, _react.useEffect)(function() {
        registerField(name, {
            validate: validate
        });
        return function() {
            unregisterField(name);
        };
    }, [
        registerField,
        unregisterField,
        name,
        validate
    ]);
    var field = formik.getFieldProps(_extends({
        name: name
    }, props));
    var meta = formik.getFieldMeta(name);
    var legacyBag = {
        field: field,
        form: formik
    };
    if (render) return render(_extends({}, legacyBag, {
        meta: meta
    }));
    if (isFunction(children)) return children(_extends({}, legacyBag, {
        meta: meta
    }));
    if (component) {
        // This behavior is backwards compat with earlier Formik 0.9 to 1.x
        if (typeof component === "string") {
            var innerRef = props.innerRef, rest = _objectWithoutPropertiesLoose(props, [
                "innerRef"
            ]);
            return (0, _react.createElement)(component, _extends({
                ref: innerRef
            }, field, rest), children);
        } // We don't pass `meta` for backwards compat
        return (0, _react.createElement)(component, _extends({
            field: field,
            form: formik
        }, props), children);
    } // default to input here so we can check for both `as` and `children` above
    var asElement = is || "input";
    if (typeof asElement === "string") {
        var _innerRef = props.innerRef, _rest = _objectWithoutPropertiesLoose(props, [
            "innerRef"
        ]);
        return (0, _react.createElement)(asElement, _extends({
            ref: _innerRef
        }, field, _rest), children);
    }
    return (0, _react.createElement)(asElement, _extends({}, field, props), children);
}
var Form = /*#__PURE__*/ (0, _react.forwardRef)(function(props, ref) {
    // iOS needs an "action" attribute for nice input: https://stackoverflow.com/a/39485162/406725
    // We default the action to "#" in case the preventDefault fails (just updates the URL hash)
    var action = props.action, rest = _objectWithoutPropertiesLoose(props, [
        "action"
    ]);
    var _action = action != null ? action : "#";
    var _useFormikContext = useFormikContext(), handleReset = _useFormikContext.handleReset, handleSubmit = _useFormikContext.handleSubmit;
    return (0, _react.createElement)("form", _extends({
        onSubmit: handleSubmit,
        ref: ref,
        onReset: handleReset,
        action: _action
    }, rest));
});
Form.displayName = "Form";
/**
 * A public higher-order component to access the imperative API
 */ function withFormik(_ref) {
    var _ref$mapPropsToValues = _ref.mapPropsToValues, mapPropsToValues = _ref$mapPropsToValues === void 0 ? function(vanillaProps) {
        var val = {};
        for(var k in vanillaProps)if (vanillaProps.hasOwnProperty(k) && typeof vanillaProps[k] !== "function") // @todo TypeScript fix
        val[k] = vanillaProps[k];
        return val;
    } : _ref$mapPropsToValues, config = _objectWithoutPropertiesLoose(_ref, [
        "mapPropsToValues"
    ]);
    return function createFormik(Component$1) {
        var componentDisplayName = Component$1.displayName || Component$1.name || Component$1.constructor && Component$1.constructor.name || "Component";
        /**
     * We need to use closures here for to provide the wrapped component's props to
     * the respective withFormik config methods.
     */ var C = /*#__PURE__*/ function(_React$Component) {
            _inheritsLoose(C, _React$Component);
            function C() {
                var _this;
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                _this = _React$Component.call.apply(_React$Component, [
                    this
                ].concat(args)) || this;
                _this.validate = function(values) {
                    return config.validate(values, _this.props);
                };
                _this.validationSchema = function() {
                    return isFunction(config.validationSchema) ? config.validationSchema(_this.props) : config.validationSchema;
                };
                _this.handleSubmit = function(values, actions) {
                    return config.handleSubmit(values, _extends({}, actions, {
                        props: _this.props
                    }));
                };
                _this.renderFormComponent = function(formikProps) {
                    return (0, _react.createElement)(Component$1, _extends({}, _this.props, formikProps));
                };
                return _this;
            }
            var _proto = C.prototype;
            _proto.render = function render() {
                var _this$props = this.props, props = _objectWithoutPropertiesLoose(_this$props, [
                    "children"
                ]);
                return (0, _react.createElement)(Formik, _extends({}, props, config, {
                    validate: config.validate && this.validate,
                    validationSchema: config.validationSchema && this.validationSchema,
                    initialValues: mapPropsToValues(this.props),
                    initialStatus: config.mapPropsToStatus && config.mapPropsToStatus(this.props),
                    initialErrors: config.mapPropsToErrors && config.mapPropsToErrors(this.props),
                    initialTouched: config.mapPropsToTouched && config.mapPropsToTouched(this.props),
                    onSubmit: this.handleSubmit,
                    children: this.renderFormComponent
                }));
            };
            return C;
        }((0, _react.Component));
        C.displayName = "WithFormik(" + componentDisplayName + ")";
        return (0, _hoistNonReactStaticsDefault.default)(C, Component$1 // cast type to ComponentClass (even if SFC)
        );
    };
}
/**
 * Connect any component to Formik context, and inject as a prop called `formik`;
 * @param Comp React Component
 */ function connect(Comp) {
    var C = function C(props) {
        return (0, _react.createElement)(FormikConsumer, null, function(formik) {
            !!!formik && (0, _tinyWarningDefault.default)(false);
            return (0, _react.createElement)(Comp, _extends({}, props, {
                formik: formik
            }));
        });
    };
    var componentDisplayName = Comp.displayName || Comp.name || Comp.constructor && Comp.constructor.name || "Component"; // Assign Comp to C.WrappedComponent so we can access the inner component in tests
    // For example, <Field.WrappedComponent /> gets us <FieldInner/>
    C.WrappedComponent = Comp;
    C.displayName = "FormikConnect(" + componentDisplayName + ")";
    return (0, _hoistNonReactStaticsDefault.default)(C, Comp // cast type to ComponentClass (even if SFC)
    );
}
/**
 * Some array helpers!
 */ var move = function move(array, from, to) {
    var copy = copyArrayLike(array);
    var value = copy[from];
    copy.splice(from, 1);
    copy.splice(to, 0, value);
    return copy;
};
var swap = function swap(arrayLike, indexA, indexB) {
    var copy = copyArrayLike(arrayLike);
    var a = copy[indexA];
    copy[indexA] = copy[indexB];
    copy[indexB] = a;
    return copy;
};
var insert = function insert(arrayLike, index, value) {
    var copy = copyArrayLike(arrayLike);
    copy.splice(index, 0, value);
    return copy;
};
var replace = function replace(arrayLike, index, value) {
    var copy = copyArrayLike(arrayLike);
    copy[index] = value;
    return copy;
};
var copyArrayLike = function copyArrayLike(arrayLike) {
    if (!arrayLike) return [];
    else if (Array.isArray(arrayLike)) return [].concat(arrayLike);
    else {
        var maxIndex = Object.keys(arrayLike).map(function(key) {
            return parseInt(key);
        }).reduce(function(max, el) {
            return el > max ? el : max;
        }, 0);
        return Array.from(_extends({}, arrayLike, {
            length: maxIndex + 1
        }));
    }
};
var createAlterationHandler = function createAlterationHandler(alteration, defaultFunction) {
    var fn = typeof alteration === "function" ? alteration : defaultFunction;
    return function(data) {
        if (Array.isArray(data) || isObject(data)) {
            var clone = copyArrayLike(data);
            return fn(clone);
        } // This can be assumed to be a primitive, which
        // is a case for top level validation errors
        return data;
    };
};
var FieldArrayInner = /*#__PURE__*/ function(_React$Component) {
    _inheritsLoose(FieldArrayInner, _React$Component);
    function FieldArrayInner(props) {
        var _this;
        _this = _React$Component.call(this, props) || this; // We need TypeScript generics on these, so we'll bind them in the constructor
        // @todo Fix TS 3.2.1
        _this.updateArrayField = function(fn, alterTouched, alterErrors) {
            var _this$props = _this.props, name = _this$props.name, setFormikState = _this$props.formik.setFormikState;
            setFormikState(function(prevState) {
                var updateErrors = createAlterationHandler(alterErrors, fn);
                var updateTouched = createAlterationHandler(alterTouched, fn); // values fn should be executed before updateErrors and updateTouched,
                // otherwise it causes an error with unshift.
                var values = setIn(prevState.values, name, fn(getIn(prevState.values, name)));
                var fieldError = alterErrors ? updateErrors(getIn(prevState.errors, name)) : undefined;
                var fieldTouched = alterTouched ? updateTouched(getIn(prevState.touched, name)) : undefined;
                if (isEmptyArray(fieldError)) fieldError = undefined;
                if (isEmptyArray(fieldTouched)) fieldTouched = undefined;
                return _extends({}, prevState, {
                    values: values,
                    errors: alterErrors ? setIn(prevState.errors, name, fieldError) : prevState.errors,
                    touched: alterTouched ? setIn(prevState.touched, name, fieldTouched) : prevState.touched
                });
            });
        };
        _this.push = function(value) {
            return _this.updateArrayField(function(arrayLike) {
                return [].concat(copyArrayLike(arrayLike), [
                    (0, _cloneDeepDefault.default)(value)
                ]);
            }, false, false);
        };
        _this.handlePush = function(value) {
            return function() {
                return _this.push(value);
            };
        };
        _this.swap = function(indexA, indexB) {
            return _this.updateArrayField(function(array) {
                return swap(array, indexA, indexB);
            }, true, true);
        };
        _this.handleSwap = function(indexA, indexB) {
            return function() {
                return _this.swap(indexA, indexB);
            };
        };
        _this.move = function(from, to) {
            return _this.updateArrayField(function(array) {
                return move(array, from, to);
            }, true, true);
        };
        _this.handleMove = function(from, to) {
            return function() {
                return _this.move(from, to);
            };
        };
        _this.insert = function(index, value) {
            return _this.updateArrayField(function(array) {
                return insert(array, index, value);
            }, function(array) {
                return insert(array, index, null);
            }, function(array) {
                return insert(array, index, null);
            });
        };
        _this.handleInsert = function(index, value) {
            return function() {
                return _this.insert(index, value);
            };
        };
        _this.replace = function(index, value) {
            return _this.updateArrayField(function(array) {
                return replace(array, index, value);
            }, false, false);
        };
        _this.handleReplace = function(index, value) {
            return function() {
                return _this.replace(index, value);
            };
        };
        _this.unshift = function(value) {
            var length = -1;
            _this.updateArrayField(function(array) {
                var arr = array ? [
                    value
                ].concat(array) : [
                    value
                ];
                length = arr.length;
                return arr;
            }, function(array) {
                return array ? [
                    null
                ].concat(array) : [
                    null
                ];
            }, function(array) {
                return array ? [
                    null
                ].concat(array) : [
                    null
                ];
            });
            return length;
        };
        _this.handleUnshift = function(value) {
            return function() {
                return _this.unshift(value);
            };
        };
        _this.handleRemove = function(index) {
            return function() {
                return _this.remove(index);
            };
        };
        _this.handlePop = function() {
            return function() {
                return _this.pop();
            };
        };
        _this.remove = _this.remove.bind(_assertThisInitialized(_this));
        _this.pop = _this.pop.bind(_assertThisInitialized(_this));
        return _this;
    }
    var _proto = FieldArrayInner.prototype;
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        if (this.props.validateOnChange && this.props.formik.validateOnChange && !(0, _reactFastCompareDefault.default)(getIn(prevProps.formik.values, prevProps.name), getIn(this.props.formik.values, this.props.name))) this.props.formik.validateForm(this.props.formik.values);
    };
    _proto.remove = function remove(index) {
        // We need to make sure we also remove relevant pieces of `touched` and `errors`
        var result;
        this.updateArrayField(function(array) {
            var copy = array ? copyArrayLike(array) : [];
            if (!result) result = copy[index];
            if (isFunction(copy.splice)) copy.splice(index, 1);
             // if the array only includes undefined values we have to return an empty array
            return isFunction(copy.every) ? copy.every(function(v) {
                return v === undefined;
            }) ? [] : copy : copy;
        }, true, true);
        return result;
    };
    _proto.pop = function pop() {
        // Remove relevant pieces of `touched` and `errors` too!
        var result;
        this.updateArrayField(function(array) {
            var tmp = array.slice();
            if (!result) result = tmp && tmp.pop && tmp.pop();
            return tmp;
        }, true, true);
        return result;
    };
    _proto.render = function render() {
        var arrayHelpers = {
            push: this.push,
            pop: this.pop,
            swap: this.swap,
            move: this.move,
            insert: this.insert,
            replace: this.replace,
            unshift: this.unshift,
            remove: this.remove,
            handlePush: this.handlePush,
            handlePop: this.handlePop,
            handleSwap: this.handleSwap,
            handleMove: this.handleMove,
            handleInsert: this.handleInsert,
            handleReplace: this.handleReplace,
            handleUnshift: this.handleUnshift,
            handleRemove: this.handleRemove
        };
        var _this$props2 = this.props, component = _this$props2.component, render = _this$props2.render, children = _this$props2.children, name = _this$props2.name, _this$props2$formik = _this$props2.formik, restOfFormik = _objectWithoutPropertiesLoose(_this$props2$formik, [
            "validate",
            "validationSchema"
        ]);
        var props = _extends({}, arrayHelpers, {
            form: restOfFormik,
            name: name
        });
        return component ? (0, _react.createElement)(component, props) : render ? render(props) : children // children come last, always called
         ? typeof children === "function" ? children(props) : !isEmptyChildren(children) ? (0, _react.Children).only(children) : null : null;
    };
    return FieldArrayInner;
}((0, _react.Component));
FieldArrayInner.defaultProps = {
    validateOnChange: true
};
var FieldArray = /*#__PURE__*/ connect(FieldArrayInner);
var ErrorMessageImpl = /*#__PURE__*/ function(_React$Component) {
    _inheritsLoose(ErrorMessageImpl, _React$Component);
    function ErrorMessageImpl() {
        return _React$Component.apply(this, arguments) || this;
    }
    var _proto = ErrorMessageImpl.prototype;
    _proto.shouldComponentUpdate = function shouldComponentUpdate(props) {
        if (getIn(this.props.formik.errors, this.props.name) !== getIn(props.formik.errors, this.props.name) || getIn(this.props.formik.touched, this.props.name) !== getIn(props.formik.touched, this.props.name) || Object.keys(this.props).length !== Object.keys(props).length) return true;
        else return false;
    };
    _proto.render = function render() {
        var _this$props = this.props, component = _this$props.component, formik = _this$props.formik, render = _this$props.render, children = _this$props.children, name = _this$props.name, rest = _objectWithoutPropertiesLoose(_this$props, [
            "component",
            "formik",
            "render",
            "children",
            "name"
        ]);
        var touch = getIn(formik.touched, name);
        var error = getIn(formik.errors, name);
        return !!touch && !!error ? render ? isFunction(render) ? render(error) : null : children ? isFunction(children) ? children(error) : null : component ? (0, _react.createElement)(component, rest, error) : error : null;
    };
    return ErrorMessageImpl;
}((0, _react.Component));
var ErrorMessage = /*#__PURE__*/ connect(ErrorMessageImpl);
/**
 * Custom Field component for quickly hooking into Formik
 * context and wiring up forms.
 */ var FastFieldInner = /*#__PURE__*/ function(_React$Component) {
    _inheritsLoose(FastFieldInner, _React$Component);
    function FastFieldInner(props) {
        var _this;
        _this = _React$Component.call(this, props) || this;
        var render = props.render, children = props.children, component = props.component, is = props.as, name = props.name;
        !!render && (0, _tinyWarningDefault.default)(false);
        !!(component && render) && (0, _tinyWarningDefault.default)(false);
        !!(is && children && isFunction(children)) && (0, _tinyWarningDefault.default)(false);
        !!(component && children && isFunction(children)) && (0, _tinyWarningDefault.default)(false);
        !!(render && children && !isEmptyChildren(children)) && (0, _tinyWarningDefault.default)(false);
        return _this;
    }
    var _proto = FastFieldInner.prototype;
    _proto.shouldComponentUpdate = function shouldComponentUpdate(props) {
        if (this.props.shouldUpdate) return this.props.shouldUpdate(props, this.props);
        else if (props.name !== this.props.name || getIn(props.formik.values, this.props.name) !== getIn(this.props.formik.values, this.props.name) || getIn(props.formik.errors, this.props.name) !== getIn(this.props.formik.errors, this.props.name) || getIn(props.formik.touched, this.props.name) !== getIn(this.props.formik.touched, this.props.name) || Object.keys(this.props).length !== Object.keys(props).length || props.formik.isSubmitting !== this.props.formik.isSubmitting) return true;
        else return false;
    };
    _proto.componentDidMount = function componentDidMount() {
        // Register the Field with the parent Formik. Parent will cycle through
        // registered Field's validate fns right prior to submit
        this.props.formik.registerField(this.props.name, {
            validate: this.props.validate
        });
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        if (this.props.name !== prevProps.name) {
            this.props.formik.unregisterField(prevProps.name);
            this.props.formik.registerField(this.props.name, {
                validate: this.props.validate
            });
        }
        if (this.props.validate !== prevProps.validate) this.props.formik.registerField(this.props.name, {
            validate: this.props.validate
        });
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.props.formik.unregisterField(this.props.name);
    };
    _proto.render = function render() {
        var _this$props = this.props, name = _this$props.name, render = _this$props.render, is = _this$props.as, children = _this$props.children, component = _this$props.component, formik = _this$props.formik, props = _objectWithoutPropertiesLoose(_this$props, [
            "validate",
            "name",
            "render",
            "as",
            "children",
            "component",
            "shouldUpdate",
            "formik"
        ]);
        var restOfFormik = _objectWithoutPropertiesLoose(formik, [
            "validate",
            "validationSchema"
        ]);
        var field = formik.getFieldProps(_extends({
            name: name
        }, props));
        var meta = {
            value: getIn(formik.values, name),
            error: getIn(formik.errors, name),
            touched: !!getIn(formik.touched, name),
            initialValue: getIn(formik.initialValues, name),
            initialTouched: !!getIn(formik.initialTouched, name),
            initialError: getIn(formik.initialErrors, name)
        };
        var bag = {
            field: field,
            meta: meta,
            form: restOfFormik
        };
        if (render) return render(bag);
        if (isFunction(children)) return children(bag);
        if (component) {
            // This behavior is backwards compat with earlier Formik 0.9 to 1.x
            if (typeof component === "string") {
                var innerRef = props.innerRef, rest = _objectWithoutPropertiesLoose(props, [
                    "innerRef"
                ]);
                return (0, _react.createElement)(component, _extends({
                    ref: innerRef
                }, field, rest), children);
            } // We don't pass `meta` for backwards compat
            return (0, _react.createElement)(component, _extends({
                field: field,
                form: formik
            }, props), children);
        } // default to input here so we can check for both `as` and `children` above
        var asElement = is || "input";
        if (typeof asElement === "string") {
            var _innerRef = props.innerRef, _rest = _objectWithoutPropertiesLoose(props, [
                "innerRef"
            ]);
            return (0, _react.createElement)(asElement, _extends({
                ref: _innerRef
            }, field, _rest), children);
        }
        return (0, _react.createElement)(asElement, _extends({}, field, props), children);
    };
    return FastFieldInner;
}((0, _react.Component));
var FastField = /*#__PURE__*/ connect(FastFieldInner);

},{"deepmerge":"kcKlC","lodash-es/isPlainObject":"bWMRe","react":"6uln9","react-fast-compare":"7oSaD","tiny-warning":"328jC","lodash-es/clone":"1jdBG","lodash-es/toPath":"3mvdy","hoist-non-react-statics":"3bvdc","lodash-es/cloneDeep":"01IM3","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"kcKlC":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var isMergeableObject = function isMergeableObject(value) {
    return isNonNullObject(value) && !isSpecial(value);
};
function isNonNullObject(value) {
    return !!value && typeof value === "object";
}
function isSpecial(value) {
    var stringValue = Object.prototype.toString.call(value);
    return stringValue === "[object RegExp]" || stringValue === "[object Date]" || isReactElement(value);
}
// see https://github.com/facebook/react/blob/b5ac963fb791d1298e7f396236383bc955f916c1/src/isomorphic/classic/element/ReactElement.js#L21-L25
var canUseSymbol = typeof Symbol === "function" && Symbol.for;
var REACT_ELEMENT_TYPE = canUseSymbol ? Symbol.for("react.element") : 0xeac7;
function isReactElement(value) {
    return value.$$typeof === REACT_ELEMENT_TYPE;
}
function emptyTarget(val) {
    return Array.isArray(val) ? [] : {};
}
function cloneUnlessOtherwiseSpecified(value, options) {
    return options.clone !== false && options.isMergeableObject(value) ? deepmerge(emptyTarget(value), value, options) : value;
}
function defaultArrayMerge(target, source, options) {
    return target.concat(source).map(function(element) {
        return cloneUnlessOtherwiseSpecified(element, options);
    });
}
function mergeObject(target, source, options) {
    var destination = {};
    if (options.isMergeableObject(target)) Object.keys(target).forEach(function(key) {
        destination[key] = cloneUnlessOtherwiseSpecified(target[key], options);
    });
    Object.keys(source).forEach(function(key) {
        if (!options.isMergeableObject(source[key]) || !target[key]) destination[key] = cloneUnlessOtherwiseSpecified(source[key], options);
        else destination[key] = deepmerge(target[key], source[key], options);
    });
    return destination;
}
function deepmerge(target, source, options) {
    options = options || {};
    options.arrayMerge = options.arrayMerge || defaultArrayMerge;
    options.isMergeableObject = options.isMergeableObject || isMergeableObject;
    var sourceIsArray = Array.isArray(source);
    var targetIsArray = Array.isArray(target);
    var sourceAndTargetTypesMatch = sourceIsArray === targetIsArray;
    if (!sourceAndTargetTypesMatch) return cloneUnlessOtherwiseSpecified(source, options);
    else if (sourceIsArray) return options.arrayMerge(target, source, options);
    else return mergeObject(target, source, options);
}
deepmerge.all = function deepmergeAll(array, options) {
    if (!Array.isArray(array)) throw new Error("first argument should be an array");
    return array.reduce(function(prev, next) {
        return deepmerge(prev, next, options);
    }, {});
};
var deepmerge_1 = deepmerge;
exports.default = deepmerge_1;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"bWMRe":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _baseGetTagJs = require("./_baseGetTag.js");
var _baseGetTagJsDefault = parcelHelpers.interopDefault(_baseGetTagJs);
var _getPrototypeJs = require("./_getPrototype.js");
var _getPrototypeJsDefault = parcelHelpers.interopDefault(_getPrototypeJs);
var _isObjectLikeJs = require("./isObjectLike.js");
var _isObjectLikeJsDefault = parcelHelpers.interopDefault(_isObjectLikeJs);
/** `Object#toString` result references. */ var objectTag = "[object Object]";
/** Used for built-in method references. */ var funcProto = Function.prototype, objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/** Used to infer the `Object` constructor. */ var objectCtorString = funcToString.call(Object);
/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */ function isPlainObject(value) {
    if (!(0, _isObjectLikeJsDefault.default)(value) || (0, _baseGetTagJsDefault.default)(value) != objectTag) return false;
    var proto = (0, _getPrototypeJsDefault.default)(value);
    if (proto === null) return true;
    var Ctor = hasOwnProperty.call(proto, "constructor") && proto.constructor;
    return typeof Ctor == "function" && Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString;
}
exports.default = isPlainObject;

},{"./_baseGetTag.js":"cZgKC","./_getPrototype.js":"blDI2","./isObjectLike.js":"hcFFR","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"cZgKC":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _symbolJs = require("./_Symbol.js");
var _symbolJsDefault = parcelHelpers.interopDefault(_symbolJs);
var _getRawTagJs = require("./_getRawTag.js");
var _getRawTagJsDefault = parcelHelpers.interopDefault(_getRawTagJs);
var _objectToStringJs = require("./_objectToString.js");
var _objectToStringJsDefault = parcelHelpers.interopDefault(_objectToStringJs);
/** `Object#toString` result references. */ var nullTag = "[object Null]", undefinedTag = "[object Undefined]";
/** Built-in value references. */ var symToStringTag = (0, _symbolJsDefault.default) ? (0, _symbolJsDefault.default).toStringTag : undefined;
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function baseGetTag(value) {
    if (value == null) return value === undefined ? undefinedTag : nullTag;
    return symToStringTag && symToStringTag in Object(value) ? (0, _getRawTagJsDefault.default)(value) : (0, _objectToStringJsDefault.default)(value);
}
exports.default = baseGetTag;

},{"./_Symbol.js":"xSCm6","./_getRawTag.js":"bWJbh","./_objectToString.js":"fQVkR","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"xSCm6":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _rootJs = require("./_root.js");
var _rootJsDefault = parcelHelpers.interopDefault(_rootJs);
/** Built-in value references. */ var Symbol = (0, _rootJsDefault.default).Symbol;
exports.default = Symbol;

},{"./_root.js":"cTEWZ","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"cTEWZ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _freeGlobalJs = require("./_freeGlobal.js");
var _freeGlobalJsDefault = parcelHelpers.interopDefault(_freeGlobalJs);
/** Detect free variable `self`. */ var freeSelf = typeof self == "object" && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var root = (0, _freeGlobalJsDefault.default) || freeSelf || Function("return this")();
exports.default = root;

},{"./_freeGlobal.js":"39xL9","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"39xL9":[function(require,module,exports) {
/** Detect free variable `global` from Node.js. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var global = arguments[3];
var freeGlobal = typeof global == "object" && global && global.Object === Object && global;
exports.default = freeGlobal;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"bWJbh":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _symbolJs = require("./_Symbol.js");
var _symbolJsDefault = parcelHelpers.interopDefault(_symbolJs);
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var nativeObjectToString = objectProto.toString;
/** Built-in value references. */ var symToStringTag = (0, _symbolJsDefault.default) ? (0, _symbolJsDefault.default).toStringTag : undefined;
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function getRawTag(value) {
    var isOwn = hasOwnProperty.call(value, symToStringTag), tag = value[symToStringTag];
    try {
        value[symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[symToStringTag] = tag;
        else delete value[symToStringTag];
    }
    return result;
}
exports.default = getRawTag;

},{"./_Symbol.js":"xSCm6","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"fQVkR":[function(require,module,exports) {
/** Used for built-in method references. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var nativeObjectToString = objectProto.toString;
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function objectToString(value) {
    return nativeObjectToString.call(value);
}
exports.default = objectToString;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"blDI2":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _overArgJs = require("./_overArg.js");
var _overArgJsDefault = parcelHelpers.interopDefault(_overArgJs);
/** Built-in value references. */ var getPrototype = (0, _overArgJsDefault.default)(Object.getPrototypeOf, Object);
exports.default = getPrototype;

},{"./_overArg.js":"3VPN2","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3VPN2":[function(require,module,exports) {
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
exports.default = overArg;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hcFFR":[function(require,module,exports) {
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function isObjectLike(value) {
    return value != null && typeof value == "object";
}
exports.default = isObjectLike;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7oSaD":[function(require,module,exports) {
"use strict";
var isArray = Array.isArray;
var keyList = Object.keys;
var hasProp = Object.prototype.hasOwnProperty;
var hasElementType = typeof Element !== "undefined";
function equal(a, b) {
    // fast-deep-equal index.js 2.0.1
    if (a === b) return true;
    if (a && b && typeof a == "object" && typeof b == "object") {
        var arrA = isArray(a), arrB = isArray(b), i, length, key;
        if (arrA && arrB) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (!equal(a[i], b[i])) return false;
            return true;
        }
        if (arrA != arrB) return false;
        var dateA = a instanceof Date, dateB = b instanceof Date;
        if (dateA != dateB) return false;
        if (dateA && dateB) return a.getTime() == b.getTime();
        var regexpA = a instanceof RegExp, regexpB = b instanceof RegExp;
        if (regexpA != regexpB) return false;
        if (regexpA && regexpB) return a.toString() == b.toString();
        var keys = keyList(a);
        length = keys.length;
        if (length !== keyList(b).length) return false;
        for(i = length; i-- !== 0;)if (!hasProp.call(b, keys[i])) return false;
        // end fast-deep-equal
        // start react-fast-compare
        // custom handling for DOM elements
        if (hasElementType && a instanceof Element && b instanceof Element) return a === b;
        // custom handling for React
        for(i = length; i-- !== 0;){
            key = keys[i];
            if (key === "_owner" && a.$$typeof) continue;
            else {
                // all other properties should be traversed as usual
                if (!equal(a[key], b[key])) return false;
            }
        }
        // end react-fast-compare
        // fast-deep-equal index.js 2.0.1
        return true;
    }
    return a !== a && b !== b;
}
// end fast-deep-equal
module.exports = function exportedEqual(a, b) {
    try {
        return equal(a, b);
    } catch (error) {
        if (error.message && error.message.match(/stack|recursion/i) || error.number === -2146828260) {
            // warn on circular references, don't crash
            // browsers give this different errors name and messages:
            // chrome/safari: "RangeError", "Maximum call stack size exceeded"
            // firefox: "InternalError", too much recursion"
            // edge: "Error", "Out of stack space"
            console.warn("Warning: react-fast-compare does not handle circular references.", error.name, error.message);
            return false;
        }
        // some other error. we should definitely know about these
        throw error;
    }
};

},{}],"1jdBG":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _baseCloneJs = require("./_baseClone.js");
var _baseCloneJsDefault = parcelHelpers.interopDefault(_baseCloneJs);
/** Used to compose bitmasks for cloning. */ var CLONE_SYMBOLS_FLAG = 4;
/**
 * Creates a shallow clone of `value`.
 *
 * **Note:** This method is loosely based on the
 * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
 * and supports cloning arrays, array buffers, booleans, date objects, maps,
 * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
 * arrays. The own enumerable properties of `arguments` objects are cloned
 * as plain objects. An empty object is returned for uncloneable values such
 * as error objects, functions, DOM nodes, and WeakMaps.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to clone.
 * @returns {*} Returns the cloned value.
 * @see _.cloneDeep
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var shallow = _.clone(objects);
 * console.log(shallow[0] === objects[0]);
 * // => true
 */ function clone(value) {
    return (0, _baseCloneJsDefault.default)(value, CLONE_SYMBOLS_FLAG);
}
exports.default = clone;

},{"./_baseClone.js":"ka5Mk","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"ka5Mk":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _stackJs = require("./_Stack.js");
var _stackJsDefault = parcelHelpers.interopDefault(_stackJs);
var _arrayEachJs = require("./_arrayEach.js");
var _arrayEachJsDefault = parcelHelpers.interopDefault(_arrayEachJs);
var _assignValueJs = require("./_assignValue.js");
var _assignValueJsDefault = parcelHelpers.interopDefault(_assignValueJs);
var _baseAssignJs = require("./_baseAssign.js");
var _baseAssignJsDefault = parcelHelpers.interopDefault(_baseAssignJs);
var _baseAssignInJs = require("./_baseAssignIn.js");
var _baseAssignInJsDefault = parcelHelpers.interopDefault(_baseAssignInJs);
var _cloneBufferJs = require("./_cloneBuffer.js");
var _cloneBufferJsDefault = parcelHelpers.interopDefault(_cloneBufferJs);
var _copyArrayJs = require("./_copyArray.js");
var _copyArrayJsDefault = parcelHelpers.interopDefault(_copyArrayJs);
var _copySymbolsJs = require("./_copySymbols.js");
var _copySymbolsJsDefault = parcelHelpers.interopDefault(_copySymbolsJs);
var _copySymbolsInJs = require("./_copySymbolsIn.js");
var _copySymbolsInJsDefault = parcelHelpers.interopDefault(_copySymbolsInJs);
var _getAllKeysJs = require("./_getAllKeys.js");
var _getAllKeysJsDefault = parcelHelpers.interopDefault(_getAllKeysJs);
var _getAllKeysInJs = require("./_getAllKeysIn.js");
var _getAllKeysInJsDefault = parcelHelpers.interopDefault(_getAllKeysInJs);
var _getTagJs = require("./_getTag.js");
var _getTagJsDefault = parcelHelpers.interopDefault(_getTagJs);
var _initCloneArrayJs = require("./_initCloneArray.js");
var _initCloneArrayJsDefault = parcelHelpers.interopDefault(_initCloneArrayJs);
var _initCloneByTagJs = require("./_initCloneByTag.js");
var _initCloneByTagJsDefault = parcelHelpers.interopDefault(_initCloneByTagJs);
var _initCloneObjectJs = require("./_initCloneObject.js");
var _initCloneObjectJsDefault = parcelHelpers.interopDefault(_initCloneObjectJs);
var _isArrayJs = require("./isArray.js");
var _isArrayJsDefault = parcelHelpers.interopDefault(_isArrayJs);
var _isBufferJs = require("./isBuffer.js");
var _isBufferJsDefault = parcelHelpers.interopDefault(_isBufferJs);
var _isMapJs = require("./isMap.js");
var _isMapJsDefault = parcelHelpers.interopDefault(_isMapJs);
var _isObjectJs = require("./isObject.js");
var _isObjectJsDefault = parcelHelpers.interopDefault(_isObjectJs);
var _isSetJs = require("./isSet.js");
var _isSetJsDefault = parcelHelpers.interopDefault(_isSetJs);
var _keysJs = require("./keys.js");
var _keysJsDefault = parcelHelpers.interopDefault(_keysJs);
var _keysInJs = require("./keysIn.js");
var _keysInJsDefault = parcelHelpers.interopDefault(_keysInJs);
/** Used to compose bitmasks for cloning. */ var CLONE_DEEP_FLAG = 1, CLONE_FLAT_FLAG = 2, CLONE_SYMBOLS_FLAG = 4;
/** `Object#toString` result references. */ var argsTag = "[object Arguments]", arrayTag = "[object Array]", boolTag = "[object Boolean]", dateTag = "[object Date]", errorTag = "[object Error]", funcTag = "[object Function]", genTag = "[object GeneratorFunction]", mapTag = "[object Map]", numberTag = "[object Number]", objectTag = "[object Object]", regexpTag = "[object RegExp]", setTag = "[object Set]", stringTag = "[object String]", symbolTag = "[object Symbol]", weakMapTag = "[object WeakMap]";
var arrayBufferTag = "[object ArrayBuffer]", dataViewTag = "[object DataView]", float32Tag = "[object Float32Array]", float64Tag = "[object Float64Array]", int8Tag = "[object Int8Array]", int16Tag = "[object Int16Array]", int32Tag = "[object Int32Array]", uint8Tag = "[object Uint8Array]", uint8ClampedTag = "[object Uint8ClampedArray]", uint16Tag = "[object Uint16Array]", uint32Tag = "[object Uint32Array]";
/** Used to identify `toStringTag` values supported by `_.clone`. */ var cloneableTags = {};
cloneableTags[argsTag] = cloneableTags[arrayTag] = cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] = cloneableTags[boolTag] = cloneableTags[dateTag] = cloneableTags[float32Tag] = cloneableTags[float64Tag] = cloneableTags[int8Tag] = cloneableTags[int16Tag] = cloneableTags[int32Tag] = cloneableTags[mapTag] = cloneableTags[numberTag] = cloneableTags[objectTag] = cloneableTags[regexpTag] = cloneableTags[setTag] = cloneableTags[stringTag] = cloneableTags[symbolTag] = cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] = cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
cloneableTags[errorTag] = cloneableTags[funcTag] = cloneableTags[weakMapTag] = false;
/**
 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
 * traversed objects.
 *
 * @private
 * @param {*} value The value to clone.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Deep clone
 *  2 - Flatten inherited properties
 *  4 - Clone symbols
 * @param {Function} [customizer] The function to customize cloning.
 * @param {string} [key] The key of `value`.
 * @param {Object} [object] The parent object of `value`.
 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
 * @returns {*} Returns the cloned value.
 */ function baseClone(value, bitmask, customizer, key, object, stack) {
    var result, isDeep = bitmask & CLONE_DEEP_FLAG, isFlat = bitmask & CLONE_FLAT_FLAG, isFull = bitmask & CLONE_SYMBOLS_FLAG;
    if (customizer) result = object ? customizer(value, key, object, stack) : customizer(value);
    if (result !== undefined) return result;
    if (!(0, _isObjectJsDefault.default)(value)) return value;
    var isArr = (0, _isArrayJsDefault.default)(value);
    if (isArr) {
        result = (0, _initCloneArrayJsDefault.default)(value);
        if (!isDeep) return (0, _copyArrayJsDefault.default)(value, result);
    } else {
        var tag = (0, _getTagJsDefault.default)(value), isFunc = tag == funcTag || tag == genTag;
        if ((0, _isBufferJsDefault.default)(value)) return (0, _cloneBufferJsDefault.default)(value, isDeep);
        if (tag == objectTag || tag == argsTag || isFunc && !object) {
            result = isFlat || isFunc ? {} : (0, _initCloneObjectJsDefault.default)(value);
            if (!isDeep) return isFlat ? (0, _copySymbolsInJsDefault.default)(value, (0, _baseAssignInJsDefault.default)(result, value)) : (0, _copySymbolsJsDefault.default)(value, (0, _baseAssignJsDefault.default)(result, value));
        } else {
            if (!cloneableTags[tag]) return object ? value : {};
            result = (0, _initCloneByTagJsDefault.default)(value, tag, isDeep);
        }
    }
    // Check for circular references and return its corresponding clone.
    stack || (stack = new (0, _stackJsDefault.default));
    var stacked = stack.get(value);
    if (stacked) return stacked;
    stack.set(value, result);
    if ((0, _isSetJsDefault.default)(value)) value.forEach(function(subValue) {
        result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
    });
    else if ((0, _isMapJsDefault.default)(value)) value.forEach(function(subValue, key) {
        result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
    });
    var keysFunc = isFull ? isFlat ? (0, _getAllKeysInJsDefault.default) : (0, _getAllKeysJsDefault.default) : isFlat ? (0, _keysInJsDefault.default) : (0, _keysJsDefault.default);
    var props = isArr ? undefined : keysFunc(value);
    (0, _arrayEachJsDefault.default)(props || value, function(subValue, key) {
        if (props) {
            key = subValue;
            subValue = value[key];
        }
        // Recursively populate clone (susceptible to call stack limits).
        (0, _assignValueJsDefault.default)(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
    });
    return result;
}
exports.default = baseClone;

},{"./_Stack.js":"adQXu","./_arrayEach.js":"6RpdW","./_assignValue.js":"gXgNV","./_baseAssign.js":"6QX2W","./_baseAssignIn.js":"i84Xm","./_cloneBuffer.js":"3oX4H","./_copyArray.js":"jFIQj","./_copySymbols.js":"cWfg4","./_copySymbolsIn.js":"4LJZu","./_getAllKeys.js":"gHjuN","./_getAllKeysIn.js":"94kax","./_getTag.js":"k5EiA","./_initCloneArray.js":"9eOVp","./_initCloneByTag.js":"6KWUZ","./_initCloneObject.js":"eNMyw","./isArray.js":"a5xfW","./isBuffer.js":"b6M7J","./isMap.js":"1dNMR","./isObject.js":"boUsC","./isSet.js":"eR5F5","./keys.js":"iu21I","./keysIn.js":"8m5FO","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"adQXu":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _listCacheJs = require("./_ListCache.js");
var _listCacheJsDefault = parcelHelpers.interopDefault(_listCacheJs);
var _stackClearJs = require("./_stackClear.js");
var _stackClearJsDefault = parcelHelpers.interopDefault(_stackClearJs);
var _stackDeleteJs = require("./_stackDelete.js");
var _stackDeleteJsDefault = parcelHelpers.interopDefault(_stackDeleteJs);
var _stackGetJs = require("./_stackGet.js");
var _stackGetJsDefault = parcelHelpers.interopDefault(_stackGetJs);
var _stackHasJs = require("./_stackHas.js");
var _stackHasJsDefault = parcelHelpers.interopDefault(_stackHasJs);
var _stackSetJs = require("./_stackSet.js");
var _stackSetJsDefault = parcelHelpers.interopDefault(_stackSetJs);
/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function Stack(entries) {
    var data = this.__data__ = new (0, _listCacheJsDefault.default)(entries);
    this.size = data.size;
}
// Add methods to `Stack`.
Stack.prototype.clear = (0, _stackClearJsDefault.default);
Stack.prototype["delete"] = (0, _stackDeleteJsDefault.default);
Stack.prototype.get = (0, _stackGetJsDefault.default);
Stack.prototype.has = (0, _stackHasJsDefault.default);
Stack.prototype.set = (0, _stackSetJsDefault.default);
exports.default = Stack;

},{"./_ListCache.js":"6ikFt","./_stackClear.js":"kdQMj","./_stackDelete.js":"4o6KY","./_stackGet.js":"lO42i","./_stackHas.js":"9rrOp","./_stackSet.js":"3P9IL","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6ikFt":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _listCacheClearJs = require("./_listCacheClear.js");
var _listCacheClearJsDefault = parcelHelpers.interopDefault(_listCacheClearJs);
var _listCacheDeleteJs = require("./_listCacheDelete.js");
var _listCacheDeleteJsDefault = parcelHelpers.interopDefault(_listCacheDeleteJs);
var _listCacheGetJs = require("./_listCacheGet.js");
var _listCacheGetJsDefault = parcelHelpers.interopDefault(_listCacheGetJs);
var _listCacheHasJs = require("./_listCacheHas.js");
var _listCacheHasJsDefault = parcelHelpers.interopDefault(_listCacheHasJs);
var _listCacheSetJs = require("./_listCacheSet.js");
var _listCacheSetJsDefault = parcelHelpers.interopDefault(_listCacheSetJs);
/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function ListCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `ListCache`.
ListCache.prototype.clear = (0, _listCacheClearJsDefault.default);
ListCache.prototype["delete"] = (0, _listCacheDeleteJsDefault.default);
ListCache.prototype.get = (0, _listCacheGetJsDefault.default);
ListCache.prototype.has = (0, _listCacheHasJsDefault.default);
ListCache.prototype.set = (0, _listCacheSetJsDefault.default);
exports.default = ListCache;

},{"./_listCacheClear.js":"cCOs4","./_listCacheDelete.js":"lcGNm","./_listCacheGet.js":"hDVIr","./_listCacheHas.js":"knPom","./_listCacheSet.js":"9MfZu","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"cCOs4":[function(require,module,exports) {
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function listCacheClear() {
    this.__data__ = [];
    this.size = 0;
}
exports.default = listCacheClear;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"lcGNm":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _assocIndexOfJs = require("./_assocIndexOf.js");
var _assocIndexOfJsDefault = parcelHelpers.interopDefault(_assocIndexOfJs);
/** Used for built-in method references. */ var arrayProto = Array.prototype;
/** Built-in value references. */ var splice = arrayProto.splice;
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function listCacheDelete(key) {
    var data = this.__data__, index = (0, _assocIndexOfJsDefault.default)(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else splice.call(data, index, 1);
    --this.size;
    return true;
}
exports.default = listCacheDelete;

},{"./_assocIndexOf.js":"fyoc9","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"fyoc9":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _eqJs = require("./eq.js");
var _eqJsDefault = parcelHelpers.interopDefault(_eqJs);
/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if ((0, _eqJsDefault.default)(array[length][0], key)) return length;
    }
    return -1;
}
exports.default = assocIndexOf;

},{"./eq.js":"gA93x","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"gA93x":[function(require,module,exports) {
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function eq(value, other) {
    return value === other || value !== value && other !== other;
}
exports.default = eq;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hDVIr":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _assocIndexOfJs = require("./_assocIndexOf.js");
var _assocIndexOfJsDefault = parcelHelpers.interopDefault(_assocIndexOfJs);
/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function listCacheGet(key) {
    var data = this.__data__, index = (0, _assocIndexOfJsDefault.default)(data, key);
    return index < 0 ? undefined : data[index][1];
}
exports.default = listCacheGet;

},{"./_assocIndexOf.js":"fyoc9","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"knPom":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _assocIndexOfJs = require("./_assocIndexOf.js");
var _assocIndexOfJsDefault = parcelHelpers.interopDefault(_assocIndexOfJs);
/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function listCacheHas(key) {
    return (0, _assocIndexOfJsDefault.default)(this.__data__, key) > -1;
}
exports.default = listCacheHas;

},{"./_assocIndexOf.js":"fyoc9","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9MfZu":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _assocIndexOfJs = require("./_assocIndexOf.js");
var _assocIndexOfJsDefault = parcelHelpers.interopDefault(_assocIndexOfJs);
/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function listCacheSet(key, value) {
    var data = this.__data__, index = (0, _assocIndexOfJsDefault.default)(data, key);
    if (index < 0) {
        ++this.size;
        data.push([
            key,
            value
        ]);
    } else data[index][1] = value;
    return this;
}
exports.default = listCacheSet;

},{"./_assocIndexOf.js":"fyoc9","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"kdQMj":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _listCacheJs = require("./_ListCache.js");
var _listCacheJsDefault = parcelHelpers.interopDefault(_listCacheJs);
/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */ function stackClear() {
    this.__data__ = new (0, _listCacheJsDefault.default);
    this.size = 0;
}
exports.default = stackClear;

},{"./_ListCache.js":"6ikFt","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4o6KY":[function(require,module,exports) {
/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function stackDelete(key) {
    var data = this.__data__, result = data["delete"](key);
    this.size = data.size;
    return result;
}
exports.default = stackDelete;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"lO42i":[function(require,module,exports) {
/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function stackGet(key) {
    return this.__data__.get(key);
}
exports.default = stackGet;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9rrOp":[function(require,module,exports) {
/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function stackHas(key) {
    return this.__data__.has(key);
}
exports.default = stackHas;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3P9IL":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _listCacheJs = require("./_ListCache.js");
var _listCacheJsDefault = parcelHelpers.interopDefault(_listCacheJs);
var _mapJs = require("./_Map.js");
var _mapJsDefault = parcelHelpers.interopDefault(_mapJs);
var _mapCacheJs = require("./_MapCache.js");
var _mapCacheJsDefault = parcelHelpers.interopDefault(_mapCacheJs);
/** Used as the size to enable large array optimizations. */ var LARGE_ARRAY_SIZE = 200;
/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */ function stackSet(key, value) {
    var data = this.__data__;
    if (data instanceof (0, _listCacheJsDefault.default)) {
        var pairs = data.__data__;
        if (!(0, _mapJsDefault.default) || pairs.length < LARGE_ARRAY_SIZE - 1) {
            pairs.push([
                key,
                value
            ]);
            this.size = ++data.size;
            return this;
        }
        data = this.__data__ = new (0, _mapCacheJsDefault.default)(pairs);
    }
    data.set(key, value);
    this.size = data.size;
    return this;
}
exports.default = stackSet;

},{"./_ListCache.js":"6ikFt","./_Map.js":"gBkLr","./_MapCache.js":"8Hi07","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"gBkLr":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _getNativeJs = require("./_getNative.js");
var _getNativeJsDefault = parcelHelpers.interopDefault(_getNativeJs);
var _rootJs = require("./_root.js");
var _rootJsDefault = parcelHelpers.interopDefault(_rootJs);
/* Built-in method references that are verified to be native. */ var Map = (0, _getNativeJsDefault.default)((0, _rootJsDefault.default), "Map");
exports.default = Map;

},{"./_getNative.js":"8XHOL","./_root.js":"cTEWZ","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8XHOL":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _baseIsNativeJs = require("./_baseIsNative.js");
var _baseIsNativeJsDefault = parcelHelpers.interopDefault(_baseIsNativeJs);
var _getValueJs = require("./_getValue.js");
var _getValueJsDefault = parcelHelpers.interopDefault(_getValueJs);
/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function getNative(object, key) {
    var value = (0, _getValueJsDefault.default)(object, key);
    return (0, _baseIsNativeJsDefault.default)(value) ? value : undefined;
}
exports.default = getNative;

},{"./_baseIsNative.js":"b0YwX","./_getValue.js":"2a88e","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"b0YwX":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _isFunctionJs = require("./isFunction.js");
var _isFunctionJsDefault = parcelHelpers.interopDefault(_isFunctionJs);
var _isMaskedJs = require("./_isMasked.js");
var _isMaskedJsDefault = parcelHelpers.interopDefault(_isMaskedJs);
var _isObjectJs = require("./isObject.js");
var _isObjectJsDefault = parcelHelpers.interopDefault(_isObjectJs);
var _toSourceJs = require("./_toSource.js");
var _toSourceJsDefault = parcelHelpers.interopDefault(_toSourceJs);
/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */ var reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used for built-in method references. */ var funcProto = Function.prototype, objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/** Used to detect if a method is native. */ var reIsNative = RegExp("^" + funcToString.call(hasOwnProperty).replace(reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function baseIsNative(value) {
    if (!(0, _isObjectJsDefault.default)(value) || (0, _isMaskedJsDefault.default)(value)) return false;
    var pattern = (0, _isFunctionJsDefault.default)(value) ? reIsNative : reIsHostCtor;
    return pattern.test((0, _toSourceJsDefault.default)(value));
}
exports.default = baseIsNative;

},{"./isFunction.js":"iuUS0","./_isMasked.js":"f3KVw","./isObject.js":"boUsC","./_toSource.js":"hV6pF","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"iuUS0":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _baseGetTagJs = require("./_baseGetTag.js");
var _baseGetTagJsDefault = parcelHelpers.interopDefault(_baseGetTagJs);
var _isObjectJs = require("./isObject.js");
var _isObjectJsDefault = parcelHelpers.interopDefault(_isObjectJs);
/** `Object#toString` result references. */ var asyncTag = "[object AsyncFunction]", funcTag = "[object Function]", genTag = "[object GeneratorFunction]", proxyTag = "[object Proxy]";
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function isFunction(value) {
    if (!(0, _isObjectJsDefault.default)(value)) return false;
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 9 which returns 'object' for typed arrays and other constructors.
    var tag = (0, _baseGetTagJsDefault.default)(value);
    return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}
exports.default = isFunction;

},{"./_baseGetTag.js":"cZgKC","./isObject.js":"boUsC","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"boUsC":[function(require,module,exports) {
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function isObject(value) {
    var type = typeof value;
    return value != null && (type == "object" || type == "function");
}
exports.default = isObject;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"f3KVw":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _coreJsDataJs = require("./_coreJsData.js");
var _coreJsDataJsDefault = parcelHelpers.interopDefault(_coreJsDataJs);
/** Used to detect methods masquerading as native. */ var maskSrcKey = function() {
    var uid = /[^.]+$/.exec((0, _coreJsDataJsDefault.default) && (0, _coreJsDataJsDefault.default).keys && (0, _coreJsDataJsDefault.default).keys.IE_PROTO || "");
    return uid ? "Symbol(src)_1." + uid : "";
}();
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function isMasked(func) {
    return !!maskSrcKey && maskSrcKey in func;
}
exports.default = isMasked;

},{"./_coreJsData.js":"c45s2","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"c45s2":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _rootJs = require("./_root.js");
var _rootJsDefault = parcelHelpers.interopDefault(_rootJs);
/** Used to detect overreaching core-js shims. */ var coreJsData = (0, _rootJsDefault.default)["__core-js_shared__"];
exports.default = coreJsData;

},{"./_root.js":"cTEWZ","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hV6pF":[function(require,module,exports) {
/** Used for built-in method references. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var funcProto = Function.prototype;
/** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */ function toSource(func) {
    if (func != null) {
        try {
            return funcToString.call(func);
        } catch (e) {}
        try {
            return func + "";
        } catch (e) {}
    }
    return "";
}
exports.default = toSource;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2a88e":[function(require,module,exports) {
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function getValue(object, key) {
    return object == null ? undefined : object[key];
}
exports.default = getValue;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8Hi07":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _mapCacheClearJs = require("./_mapCacheClear.js");
var _mapCacheClearJsDefault = parcelHelpers.interopDefault(_mapCacheClearJs);
var _mapCacheDeleteJs = require("./_mapCacheDelete.js");
var _mapCacheDeleteJsDefault = parcelHelpers.interopDefault(_mapCacheDeleteJs);
var _mapCacheGetJs = require("./_mapCacheGet.js");
var _mapCacheGetJsDefault = parcelHelpers.interopDefault(_mapCacheGetJs);
var _mapCacheHasJs = require("./_mapCacheHas.js");
var _mapCacheHasJsDefault = parcelHelpers.interopDefault(_mapCacheHasJs);
var _mapCacheSetJs = require("./_mapCacheSet.js");
var _mapCacheSetJsDefault = parcelHelpers.interopDefault(_mapCacheSetJs);
/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function MapCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `MapCache`.
MapCache.prototype.clear = (0, _mapCacheClearJsDefault.default);
MapCache.prototype["delete"] = (0, _mapCacheDeleteJsDefault.default);
MapCache.prototype.get = (0, _mapCacheGetJsDefault.default);
MapCache.prototype.has = (0, _mapCacheHasJsDefault.default);
MapCache.prototype.set = (0, _mapCacheSetJsDefault.default);
exports.default = MapCache;

},{"./_mapCacheClear.js":"4bONa","./_mapCacheDelete.js":"69i5D","./_mapCacheGet.js":"9E4Id","./_mapCacheHas.js":"MVfOy","./_mapCacheSet.js":"kkEsg","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4bONa":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _hashJs = require("./_Hash.js");
var _hashJsDefault = parcelHelpers.interopDefault(_hashJs);
var _listCacheJs = require("./_ListCache.js");
var _listCacheJsDefault = parcelHelpers.interopDefault(_listCacheJs);
var _mapJs = require("./_Map.js");
var _mapJsDefault = parcelHelpers.interopDefault(_mapJs);
/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function mapCacheClear() {
    this.size = 0;
    this.__data__ = {
        "hash": new (0, _hashJsDefault.default),
        "map": new ((0, _mapJsDefault.default) || (0, _listCacheJsDefault.default)),
        "string": new (0, _hashJsDefault.default)
    };
}
exports.default = mapCacheClear;

},{"./_Hash.js":"9hnnt","./_ListCache.js":"6ikFt","./_Map.js":"gBkLr","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9hnnt":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _hashClearJs = require("./_hashClear.js");
var _hashClearJsDefault = parcelHelpers.interopDefault(_hashClearJs);
var _hashDeleteJs = require("./_hashDelete.js");
var _hashDeleteJsDefault = parcelHelpers.interopDefault(_hashDeleteJs);
var _hashGetJs = require("./_hashGet.js");
var _hashGetJsDefault = parcelHelpers.interopDefault(_hashGetJs);
var _hashHasJs = require("./_hashHas.js");
var _hashHasJsDefault = parcelHelpers.interopDefault(_hashHasJs);
var _hashSetJs = require("./_hashSet.js");
var _hashSetJsDefault = parcelHelpers.interopDefault(_hashSetJs);
/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function Hash(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `Hash`.
Hash.prototype.clear = (0, _hashClearJsDefault.default);
Hash.prototype["delete"] = (0, _hashDeleteJsDefault.default);
Hash.prototype.get = (0, _hashGetJsDefault.default);
Hash.prototype.has = (0, _hashHasJsDefault.default);
Hash.prototype.set = (0, _hashSetJsDefault.default);
exports.default = Hash;

},{"./_hashClear.js":"6aMWM","./_hashDelete.js":"ipW9A","./_hashGet.js":"kGZuv","./_hashHas.js":"iIj7A","./_hashSet.js":"dLpOq","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6aMWM":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _nativeCreateJs = require("./_nativeCreate.js");
var _nativeCreateJsDefault = parcelHelpers.interopDefault(_nativeCreateJs);
/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function hashClear() {
    this.__data__ = (0, _nativeCreateJsDefault.default) ? (0, _nativeCreateJsDefault.default)(null) : {};
    this.size = 0;
}
exports.default = hashClear;

},{"./_nativeCreate.js":"e1Fvt","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"e1Fvt":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _getNativeJs = require("./_getNative.js");
var _getNativeJsDefault = parcelHelpers.interopDefault(_getNativeJs);
/* Built-in method references that are verified to be native. */ var nativeCreate = (0, _getNativeJsDefault.default)(Object, "create");
exports.default = nativeCreate;

},{"./_getNative.js":"8XHOL","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"ipW9A":[function(require,module,exports) {
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function hashDelete(key) {
    var result = this.has(key) && delete this.__data__[key];
    this.size -= result ? 1 : 0;
    return result;
}
exports.default = hashDelete;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"kGZuv":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _nativeCreateJs = require("./_nativeCreate.js");
var _nativeCreateJsDefault = parcelHelpers.interopDefault(_nativeCreateJs);
/** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = "__lodash_hash_undefined__";
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function hashGet(key) {
    var data = this.__data__;
    if (0, _nativeCreateJsDefault.default) {
        var result = data[key];
        return result === HASH_UNDEFINED ? undefined : result;
    }
    return hasOwnProperty.call(data, key) ? data[key] : undefined;
}
exports.default = hashGet;

},{"./_nativeCreate.js":"e1Fvt","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"iIj7A":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _nativeCreateJs = require("./_nativeCreate.js");
var _nativeCreateJsDefault = parcelHelpers.interopDefault(_nativeCreateJs);
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function hashHas(key) {
    var data = this.__data__;
    return (0, _nativeCreateJsDefault.default) ? data[key] !== undefined : hasOwnProperty.call(data, key);
}
exports.default = hashHas;

},{"./_nativeCreate.js":"e1Fvt","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"dLpOq":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _nativeCreateJs = require("./_nativeCreate.js");
var _nativeCreateJsDefault = parcelHelpers.interopDefault(_nativeCreateJs);
/** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = "__lodash_hash_undefined__";
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function hashSet(key, value) {
    var data = this.__data__;
    this.size += this.has(key) ? 0 : 1;
    data[key] = (0, _nativeCreateJsDefault.default) && value === undefined ? HASH_UNDEFINED : value;
    return this;
}
exports.default = hashSet;

},{"./_nativeCreate.js":"e1Fvt","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"69i5D":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _getMapDataJs = require("./_getMapData.js");
var _getMapDataJsDefault = parcelHelpers.interopDefault(_getMapDataJs);
/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function mapCacheDelete(key) {
    var result = (0, _getMapDataJsDefault.default)(this, key)["delete"](key);
    this.size -= result ? 1 : 0;
    return result;
}
exports.default = mapCacheDelete;

},{"./_getMapData.js":"aVkEX","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"aVkEX":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _isKeyableJs = require("./_isKeyable.js");
var _isKeyableJsDefault = parcelHelpers.interopDefault(_isKeyableJs);
/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function getMapData(map, key) {
    var data = map.__data__;
    return (0, _isKeyableJsDefault.default)(key) ? data[typeof key == "string" ? "string" : "hash"] : data.map;
}
exports.default = getMapData;

},{"./_isKeyable.js":"lb0dj","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"lb0dj":[function(require,module,exports) {
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function isKeyable(value) {
    var type = typeof value;
    return type == "string" || type == "number" || type == "symbol" || type == "boolean" ? value !== "__proto__" : value === null;
}
exports.default = isKeyable;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9E4Id":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _getMapDataJs = require("./_getMapData.js");
var _getMapDataJsDefault = parcelHelpers.interopDefault(_getMapDataJs);
/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function mapCacheGet(key) {
    return (0, _getMapDataJsDefault.default)(this, key).get(key);
}
exports.default = mapCacheGet;

},{"./_getMapData.js":"aVkEX","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"MVfOy":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _getMapDataJs = require("./_getMapData.js");
var _getMapDataJsDefault = parcelHelpers.interopDefault(_getMapDataJs);
/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function mapCacheHas(key) {
    return (0, _getMapDataJsDefault.default)(this, key).has(key);
}
exports.default = mapCacheHas;

},{"./_getMapData.js":"aVkEX","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"kkEsg":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _getMapDataJs = require("./_getMapData.js");
var _getMapDataJsDefault = parcelHelpers.interopDefault(_getMapDataJs);
/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function mapCacheSet(key, value) {
    var data = (0, _getMapDataJsDefault.default)(this, key), size = data.size;
    data.set(key, value);
    this.size += data.size == size ? 0 : 1;
    return this;
}
exports.default = mapCacheSet;

},{"./_getMapData.js":"aVkEX","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6RpdW":[function(require,module,exports) {
/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function arrayEach(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (iteratee(array[index], index, array) === false) break;
    }
    return array;
}
exports.default = arrayEach;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"gXgNV":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _baseAssignValueJs = require("./_baseAssignValue.js");
var _baseAssignValueJsDefault = parcelHelpers.interopDefault(_baseAssignValueJs);
var _eqJs = require("./eq.js");
var _eqJsDefault = parcelHelpers.interopDefault(_eqJs);
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function assignValue(object, key, value) {
    var objValue = object[key];
    if (!(hasOwnProperty.call(object, key) && (0, _eqJsDefault.default)(objValue, value)) || value === undefined && !(key in object)) (0, _baseAssignValueJsDefault.default)(object, key, value);
}
exports.default = assignValue;

},{"./_baseAssignValue.js":"k7RNM","./eq.js":"gA93x","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"k7RNM":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _definePropertyJs = require("./_defineProperty.js");
var _definePropertyJsDefault = parcelHelpers.interopDefault(_definePropertyJs);
/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function baseAssignValue(object, key, value) {
    if (key == "__proto__" && (0, _definePropertyJsDefault.default)) (0, _definePropertyJsDefault.default)(object, key, {
        "configurable": true,
        "enumerable": true,
        "value": value,
        "writable": true
    });
    else object[key] = value;
}
exports.default = baseAssignValue;

},{"./_defineProperty.js":"31EJg","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"31EJg":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _getNativeJs = require("./_getNative.js");
var _getNativeJsDefault = parcelHelpers.interopDefault(_getNativeJs);
var defineProperty = function() {
    try {
        var func = (0, _getNativeJsDefault.default)(Object, "defineProperty");
        func({}, "", {});
        return func;
    } catch (e) {}
}();
exports.default = defineProperty;

},{"./_getNative.js":"8XHOL","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6QX2W":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _copyObjectJs = require("./_copyObject.js");
var _copyObjectJsDefault = parcelHelpers.interopDefault(_copyObjectJs);
var _keysJs = require("./keys.js");
var _keysJsDefault = parcelHelpers.interopDefault(_keysJs);
/**
 * The base implementation of `_.assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */ function baseAssign(object, source) {
    return object && (0, _copyObjectJsDefault.default)(source, (0, _keysJsDefault.default)(source), object);
}
exports.default = baseAssign;

},{"./_copyObject.js":"9P6a2","./keys.js":"iu21I","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9P6a2":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _assignValueJs = require("./_assignValue.js");
var _assignValueJsDefault = parcelHelpers.interopDefault(_assignValueJs);
var _baseAssignValueJs = require("./_baseAssignValue.js");
var _baseAssignValueJsDefault = parcelHelpers.interopDefault(_baseAssignValueJs);
/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */ function copyObject(source, props, object, customizer) {
    var isNew = !object;
    object || (object = {});
    var index = -1, length = props.length;
    while(++index < length){
        var key = props[index];
        var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;
        if (newValue === undefined) newValue = source[key];
        if (isNew) (0, _baseAssignValueJsDefault.default)(object, key, newValue);
        else (0, _assignValueJsDefault.default)(object, key, newValue);
    }
    return object;
}
exports.default = copyObject;

},{"./_assignValue.js":"gXgNV","./_baseAssignValue.js":"k7RNM","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"iu21I":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _arrayLikeKeysJs = require("./_arrayLikeKeys.js");
var _arrayLikeKeysJsDefault = parcelHelpers.interopDefault(_arrayLikeKeysJs);
var _baseKeysJs = require("./_baseKeys.js");
var _baseKeysJsDefault = parcelHelpers.interopDefault(_baseKeysJs);
var _isArrayLikeJs = require("./isArrayLike.js");
var _isArrayLikeJsDefault = parcelHelpers.interopDefault(_isArrayLikeJs);
/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */ function keys(object) {
    return (0, _isArrayLikeJsDefault.default)(object) ? (0, _arrayLikeKeysJsDefault.default)(object) : (0, _baseKeysJsDefault.default)(object);
}
exports.default = keys;

},{"./_arrayLikeKeys.js":"2rSaZ","./_baseKeys.js":"kaIqL","./isArrayLike.js":"dGrFC","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2rSaZ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _baseTimesJs = require("./_baseTimes.js");
var _baseTimesJsDefault = parcelHelpers.interopDefault(_baseTimesJs);
var _isArgumentsJs = require("./isArguments.js");
var _isArgumentsJsDefault = parcelHelpers.interopDefault(_isArgumentsJs);
var _isArrayJs = require("./isArray.js");
var _isArrayJsDefault = parcelHelpers.interopDefault(_isArrayJs);
var _isBufferJs = require("./isBuffer.js");
var _isBufferJsDefault = parcelHelpers.interopDefault(_isBufferJs);
var _isIndexJs = require("./_isIndex.js");
var _isIndexJsDefault = parcelHelpers.interopDefault(_isIndexJs);
var _isTypedArrayJs = require("./isTypedArray.js");
var _isTypedArrayJsDefault = parcelHelpers.interopDefault(_isTypedArrayJs);
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */ function arrayLikeKeys(value, inherited) {
    var isArr = (0, _isArrayJsDefault.default)(value), isArg = !isArr && (0, _isArgumentsJsDefault.default)(value), isBuff = !isArr && !isArg && (0, _isBufferJsDefault.default)(value), isType = !isArr && !isArg && !isBuff && (0, _isTypedArrayJsDefault.default)(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? (0, _baseTimesJsDefault.default)(value.length, String) : [], length = result.length;
    for(var key in value)if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
    (key == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    isBuff && (key == "offset" || key == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    isType && (key == "buffer" || key == "byteLength" || key == "byteOffset") || // Skip index properties.
    (0, _isIndexJsDefault.default)(key, length)))) result.push(key);
    return result;
}
exports.default = arrayLikeKeys;

},{"./_baseTimes.js":"gX3UG","./isArguments.js":"dK8Bo","./isArray.js":"a5xfW","./isBuffer.js":"b6M7J","./_isIndex.js":"3TBPo","./isTypedArray.js":"11FzZ","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"gX3UG":[function(require,module,exports) {
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function baseTimes(n, iteratee) {
    var index = -1, result = Array(n);
    while(++index < n)result[index] = iteratee(index);
    return result;
}
exports.default = baseTimes;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"dK8Bo":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _baseIsArgumentsJs = require("./_baseIsArguments.js");
var _baseIsArgumentsJsDefault = parcelHelpers.interopDefault(_baseIsArgumentsJs);
var _isObjectLikeJs = require("./isObjectLike.js");
var _isObjectLikeJsDefault = parcelHelpers.interopDefault(_isObjectLikeJs);
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/** Built-in value references. */ var propertyIsEnumerable = objectProto.propertyIsEnumerable;
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ var isArguments = (0, _baseIsArgumentsJsDefault.default)(function() {
    return arguments;
}()) ? (0, _baseIsArgumentsJsDefault.default) : function(value) {
    return (0, _isObjectLikeJsDefault.default)(value) && hasOwnProperty.call(value, "callee") && !propertyIsEnumerable.call(value, "callee");
};
exports.default = isArguments;

},{"./_baseIsArguments.js":"bDM1I","./isObjectLike.js":"hcFFR","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"bDM1I":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _baseGetTagJs = require("./_baseGetTag.js");
var _baseGetTagJsDefault = parcelHelpers.interopDefault(_baseGetTagJs);
var _isObjectLikeJs = require("./isObjectLike.js");
var _isObjectLikeJsDefault = parcelHelpers.interopDefault(_isObjectLikeJs);
/** `Object#toString` result references. */ var argsTag = "[object Arguments]";
/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */ function baseIsArguments(value) {
    return (0, _isObjectLikeJsDefault.default)(value) && (0, _baseGetTagJsDefault.default)(value) == argsTag;
}
exports.default = baseIsArguments;

},{"./_baseGetTag.js":"cZgKC","./isObjectLike.js":"hcFFR","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"a5xfW":[function(require,module,exports) {
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var isArray = Array.isArray;
exports.default = isArray;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"b6M7J":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _rootJs = require("./_root.js");
var _rootJsDefault = parcelHelpers.interopDefault(_rootJs);
var _stubFalseJs = require("./stubFalse.js");
var _stubFalseJsDefault = parcelHelpers.interopDefault(_stubFalseJs);
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? (0, _rootJsDefault.default).Buffer : undefined;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */ var isBuffer = nativeIsBuffer || (0, _stubFalseJsDefault.default);
exports.default = isBuffer;

},{"./_root.js":"cTEWZ","./stubFalse.js":"fIoLd","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"fIoLd":[function(require,module,exports) {
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function stubFalse() {
    return false;
}
exports.default = stubFalse;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3TBPo":[function(require,module,exports) {
/** Used as references for various `Number` constants. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var MAX_SAFE_INTEGER = 9007199254740991;
/** Used to detect unsigned integer values. */ var reIsUint = /^(?:0|[1-9]\d*)$/;
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function isIndex(value, length) {
    var type = typeof value;
    length = length == null ? MAX_SAFE_INTEGER : length;
    return !!length && (type == "number" || type != "symbol" && reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
exports.default = isIndex;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"11FzZ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _baseIsTypedArrayJs = require("./_baseIsTypedArray.js");
var _baseIsTypedArrayJsDefault = parcelHelpers.interopDefault(_baseIsTypedArrayJs);
var _baseUnaryJs = require("./_baseUnary.js");
var _baseUnaryJsDefault = parcelHelpers.interopDefault(_baseUnaryJs);
var _nodeUtilJs = require("./_nodeUtil.js");
var _nodeUtilJsDefault = parcelHelpers.interopDefault(_nodeUtilJs);
/* Node.js helper references. */ var nodeIsTypedArray = (0, _nodeUtilJsDefault.default) && (0, _nodeUtilJsDefault.default).isTypedArray;
/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */ var isTypedArray = nodeIsTypedArray ? (0, _baseUnaryJsDefault.default)(nodeIsTypedArray) : (0, _baseIsTypedArrayJsDefault.default);
exports.default = isTypedArray;

},{"./_baseIsTypedArray.js":"kDuWV","./_baseUnary.js":"fwcjM","./_nodeUtil.js":"gwvhS","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"kDuWV":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _baseGetTagJs = require("./_baseGetTag.js");
var _baseGetTagJsDefault = parcelHelpers.interopDefault(_baseGetTagJs);
var _isLengthJs = require("./isLength.js");
var _isLengthJsDefault = parcelHelpers.interopDefault(_isLengthJs);
var _isObjectLikeJs = require("./isObjectLike.js");
var _isObjectLikeJsDefault = parcelHelpers.interopDefault(_isObjectLikeJs);
/** `Object#toString` result references. */ var argsTag = "[object Arguments]", arrayTag = "[object Array]", boolTag = "[object Boolean]", dateTag = "[object Date]", errorTag = "[object Error]", funcTag = "[object Function]", mapTag = "[object Map]", numberTag = "[object Number]", objectTag = "[object Object]", regexpTag = "[object RegExp]", setTag = "[object Set]", stringTag = "[object String]", weakMapTag = "[object WeakMap]";
var arrayBufferTag = "[object ArrayBuffer]", dataViewTag = "[object DataView]", float32Tag = "[object Float32Array]", float64Tag = "[object Float64Array]", int8Tag = "[object Int8Array]", int16Tag = "[object Int16Array]", int32Tag = "[object Int32Array]", uint8Tag = "[object Uint8Array]", uint8ClampedTag = "[object Uint8ClampedArray]", uint16Tag = "[object Uint16Array]", uint32Tag = "[object Uint32Array]";
/** Used to identify `toStringTag` values of typed arrays. */ var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */ function baseIsTypedArray(value) {
    return (0, _isObjectLikeJsDefault.default)(value) && (0, _isLengthJsDefault.default)(value.length) && !!typedArrayTags[(0, _baseGetTagJsDefault.default)(value)];
}
exports.default = baseIsTypedArray;

},{"./_baseGetTag.js":"cZgKC","./isLength.js":"b3AR7","./isObjectLike.js":"hcFFR","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"b3AR7":[function(require,module,exports) {
/** Used as references for various `Number` constants. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var MAX_SAFE_INTEGER = 9007199254740991;
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function isLength(value) {
    return typeof value == "number" && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}
exports.default = isLength;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"fwcjM":[function(require,module,exports) {
/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function baseUnary(func) {
    return function(value) {
        return func(value);
    };
}
exports.default = baseUnary;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"gwvhS":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _freeGlobalJs = require("./_freeGlobal.js");
var _freeGlobalJsDefault = parcelHelpers.interopDefault(_freeGlobalJs);
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && (0, _freeGlobalJsDefault.default).process;
/** Used to access faster Node.js helpers. */ var nodeUtil = function() {
    try {
        // Use `util.types` for Node.js 10+.
        var types = freeModule && freeModule.require && freeModule.require("util").types;
        if (types) return types;
        // Legacy `process.binding('util')` for Node.js < 10.
        return freeProcess && freeProcess.binding && freeProcess.binding("util");
    } catch (e) {}
}();
exports.default = nodeUtil;

},{"./_freeGlobal.js":"39xL9","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"kaIqL":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _isPrototypeJs = require("./_isPrototype.js");
var _isPrototypeJsDefault = parcelHelpers.interopDefault(_isPrototypeJs);
var _nativeKeysJs = require("./_nativeKeys.js");
var _nativeKeysJsDefault = parcelHelpers.interopDefault(_nativeKeysJs);
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function baseKeys(object) {
    if (!(0, _isPrototypeJsDefault.default)(object)) return (0, _nativeKeysJsDefault.default)(object);
    var result = [];
    for(var key in Object(object))if (hasOwnProperty.call(object, key) && key != "constructor") result.push(key);
    return result;
}
exports.default = baseKeys;

},{"./_isPrototype.js":"bwS2b","./_nativeKeys.js":"7bDiH","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"bwS2b":[function(require,module,exports) {
/** Used for built-in method references. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var objectProto = Object.prototype;
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */ function isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == "function" && Ctor.prototype || objectProto;
    return value === proto;
}
exports.default = isPrototype;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7bDiH":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _overArgJs = require("./_overArg.js");
var _overArgJsDefault = parcelHelpers.interopDefault(_overArgJs);
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeKeys = (0, _overArgJsDefault.default)(Object.keys, Object);
exports.default = nativeKeys;

},{"./_overArg.js":"3VPN2","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"dGrFC":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _isFunctionJs = require("./isFunction.js");
var _isFunctionJsDefault = parcelHelpers.interopDefault(_isFunctionJs);
var _isLengthJs = require("./isLength.js");
var _isLengthJsDefault = parcelHelpers.interopDefault(_isLengthJs);
/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function isArrayLike(value) {
    return value != null && (0, _isLengthJsDefault.default)(value.length) && !(0, _isFunctionJsDefault.default)(value);
}
exports.default = isArrayLike;

},{"./isFunction.js":"iuUS0","./isLength.js":"b3AR7","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"i84Xm":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _copyObjectJs = require("./_copyObject.js");
var _copyObjectJsDefault = parcelHelpers.interopDefault(_copyObjectJs);
var _keysInJs = require("./keysIn.js");
var _keysInJsDefault = parcelHelpers.interopDefault(_keysInJs);
/**
 * The base implementation of `_.assignIn` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */ function baseAssignIn(object, source) {
    return object && (0, _copyObjectJsDefault.default)(source, (0, _keysInJsDefault.default)(source), object);
}
exports.default = baseAssignIn;

},{"./_copyObject.js":"9P6a2","./keysIn.js":"8m5FO","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8m5FO":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _arrayLikeKeysJs = require("./_arrayLikeKeys.js");
var _arrayLikeKeysJsDefault = parcelHelpers.interopDefault(_arrayLikeKeysJs);
var _baseKeysInJs = require("./_baseKeysIn.js");
var _baseKeysInJsDefault = parcelHelpers.interopDefault(_baseKeysInJs);
var _isArrayLikeJs = require("./isArrayLike.js");
var _isArrayLikeJsDefault = parcelHelpers.interopDefault(_isArrayLikeJs);
/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */ function keysIn(object) {
    return (0, _isArrayLikeJsDefault.default)(object) ? (0, _arrayLikeKeysJsDefault.default)(object, true) : (0, _baseKeysInJsDefault.default)(object);
}
exports.default = keysIn;

},{"./_arrayLikeKeys.js":"2rSaZ","./_baseKeysIn.js":"bCuna","./isArrayLike.js":"dGrFC","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"bCuna":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _isObjectJs = require("./isObject.js");
var _isObjectJsDefault = parcelHelpers.interopDefault(_isObjectJs);
var _isPrototypeJs = require("./_isPrototype.js");
var _isPrototypeJsDefault = parcelHelpers.interopDefault(_isPrototypeJs);
var _nativeKeysInJs = require("./_nativeKeysIn.js");
var _nativeKeysInJsDefault = parcelHelpers.interopDefault(_nativeKeysInJs);
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function baseKeysIn(object) {
    if (!(0, _isObjectJsDefault.default)(object)) return (0, _nativeKeysInJsDefault.default)(object);
    var isProto = (0, _isPrototypeJsDefault.default)(object), result = [];
    for(var key in object)if (!(key == "constructor" && (isProto || !hasOwnProperty.call(object, key)))) result.push(key);
    return result;
}
exports.default = baseKeysIn;

},{"./isObject.js":"boUsC","./_isPrototype.js":"bwS2b","./_nativeKeysIn.js":"fh6Rh","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"fh6Rh":[function(require,module,exports) {
/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function nativeKeysIn(object) {
    var result = [];
    if (object != null) for(var key in Object(object))result.push(key);
    return result;
}
exports.default = nativeKeysIn;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3oX4H":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _rootJs = require("./_root.js");
var _rootJsDefault = parcelHelpers.interopDefault(_rootJs);
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? (0, _rootJsDefault.default).Buffer : undefined, allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;
/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */ function cloneBuffer(buffer, isDeep) {
    if (isDeep) return buffer.slice();
    var length = buffer.length, result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
    buffer.copy(result);
    return result;
}
exports.default = cloneBuffer;

},{"./_root.js":"cTEWZ","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jFIQj":[function(require,module,exports) {
/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function copyArray(source, array) {
    var index = -1, length = source.length;
    array || (array = Array(length));
    while(++index < length)array[index] = source[index];
    return array;
}
exports.default = copyArray;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"cWfg4":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _copyObjectJs = require("./_copyObject.js");
var _copyObjectJsDefault = parcelHelpers.interopDefault(_copyObjectJs);
var _getSymbolsJs = require("./_getSymbols.js");
var _getSymbolsJsDefault = parcelHelpers.interopDefault(_getSymbolsJs);
/**
 * Copies own symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */ function copySymbols(source, object) {
    return (0, _copyObjectJsDefault.default)(source, (0, _getSymbolsJsDefault.default)(source), object);
}
exports.default = copySymbols;

},{"./_copyObject.js":"9P6a2","./_getSymbols.js":"lSzEz","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"lSzEz":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _arrayFilterJs = require("./_arrayFilter.js");
var _arrayFilterJsDefault = parcelHelpers.interopDefault(_arrayFilterJs);
var _stubArrayJs = require("./stubArray.js");
var _stubArrayJsDefault = parcelHelpers.interopDefault(_stubArrayJs);
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Built-in value references. */ var propertyIsEnumerable = objectProto.propertyIsEnumerable;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeGetSymbols = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var getSymbols = !nativeGetSymbols ? (0, _stubArrayJsDefault.default) : function(object) {
    if (object == null) return [];
    object = Object(object);
    return (0, _arrayFilterJsDefault.default)(nativeGetSymbols(object), function(symbol) {
        return propertyIsEnumerable.call(object, symbol);
    });
};
exports.default = getSymbols;

},{"./_arrayFilter.js":"fYALk","./stubArray.js":"hqCdE","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"fYALk":[function(require,module,exports) {
/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function arrayFilter(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
    while(++index < length){
        var value = array[index];
        if (predicate(value, index, array)) result[resIndex++] = value;
    }
    return result;
}
exports.default = arrayFilter;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hqCdE":[function(require,module,exports) {
/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function stubArray() {
    return [];
}
exports.default = stubArray;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4LJZu":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _copyObjectJs = require("./_copyObject.js");
var _copyObjectJsDefault = parcelHelpers.interopDefault(_copyObjectJs);
var _getSymbolsInJs = require("./_getSymbolsIn.js");
var _getSymbolsInJsDefault = parcelHelpers.interopDefault(_getSymbolsInJs);
/**
 * Copies own and inherited symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */ function copySymbolsIn(source, object) {
    return (0, _copyObjectJsDefault.default)(source, (0, _getSymbolsInJsDefault.default)(source), object);
}
exports.default = copySymbolsIn;

},{"./_copyObject.js":"9P6a2","./_getSymbolsIn.js":"8mDQM","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8mDQM":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _arrayPushJs = require("./_arrayPush.js");
var _arrayPushJsDefault = parcelHelpers.interopDefault(_arrayPushJs);
var _getPrototypeJs = require("./_getPrototype.js");
var _getPrototypeJsDefault = parcelHelpers.interopDefault(_getPrototypeJs);
var _getSymbolsJs = require("./_getSymbols.js");
var _getSymbolsJsDefault = parcelHelpers.interopDefault(_getSymbolsJs);
var _stubArrayJs = require("./stubArray.js");
var _stubArrayJsDefault = parcelHelpers.interopDefault(_stubArrayJs);
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeGetSymbols = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own and inherited enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var getSymbolsIn = !nativeGetSymbols ? (0, _stubArrayJsDefault.default) : function(object) {
    var result = [];
    while(object){
        (0, _arrayPushJsDefault.default)(result, (0, _getSymbolsJsDefault.default)(object));
        object = (0, _getPrototypeJsDefault.default)(object);
    }
    return result;
};
exports.default = getSymbolsIn;

},{"./_arrayPush.js":"c8l8q","./_getPrototype.js":"blDI2","./_getSymbols.js":"lSzEz","./stubArray.js":"hqCdE","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"c8l8q":[function(require,module,exports) {
/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function arrayPush(array, values) {
    var index = -1, length = values.length, offset = array.length;
    while(++index < length)array[offset + index] = values[index];
    return array;
}
exports.default = arrayPush;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"gHjuN":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _baseGetAllKeysJs = require("./_baseGetAllKeys.js");
var _baseGetAllKeysJsDefault = parcelHelpers.interopDefault(_baseGetAllKeysJs);
var _getSymbolsJs = require("./_getSymbols.js");
var _getSymbolsJsDefault = parcelHelpers.interopDefault(_getSymbolsJs);
var _keysJs = require("./keys.js");
var _keysJsDefault = parcelHelpers.interopDefault(_keysJs);
/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function getAllKeys(object) {
    return (0, _baseGetAllKeysJsDefault.default)(object, (0, _keysJsDefault.default), (0, _getSymbolsJsDefault.default));
}
exports.default = getAllKeys;

},{"./_baseGetAllKeys.js":"d2Dcr","./_getSymbols.js":"lSzEz","./keys.js":"iu21I","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"d2Dcr":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _arrayPushJs = require("./_arrayPush.js");
var _arrayPushJsDefault = parcelHelpers.interopDefault(_arrayPushJs);
var _isArrayJs = require("./isArray.js");
var _isArrayJsDefault = parcelHelpers.interopDefault(_isArrayJs);
/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */ function baseGetAllKeys(object, keysFunc, symbolsFunc) {
    var result = keysFunc(object);
    return (0, _isArrayJsDefault.default)(object) ? result : (0, _arrayPushJsDefault.default)(result, symbolsFunc(object));
}
exports.default = baseGetAllKeys;

},{"./_arrayPush.js":"c8l8q","./isArray.js":"a5xfW","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"94kax":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _baseGetAllKeysJs = require("./_baseGetAllKeys.js");
var _baseGetAllKeysJsDefault = parcelHelpers.interopDefault(_baseGetAllKeysJs);
var _getSymbolsInJs = require("./_getSymbolsIn.js");
var _getSymbolsInJsDefault = parcelHelpers.interopDefault(_getSymbolsInJs);
var _keysInJs = require("./keysIn.js");
var _keysInJsDefault = parcelHelpers.interopDefault(_keysInJs);
/**
 * Creates an array of own and inherited enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function getAllKeysIn(object) {
    return (0, _baseGetAllKeysJsDefault.default)(object, (0, _keysInJsDefault.default), (0, _getSymbolsInJsDefault.default));
}
exports.default = getAllKeysIn;

},{"./_baseGetAllKeys.js":"d2Dcr","./_getSymbolsIn.js":"8mDQM","./keysIn.js":"8m5FO","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"k5EiA":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _dataViewJs = require("./_DataView.js");
var _dataViewJsDefault = parcelHelpers.interopDefault(_dataViewJs);
var _mapJs = require("./_Map.js");
var _mapJsDefault = parcelHelpers.interopDefault(_mapJs);
var _promiseJs = require("./_Promise.js");
var _promiseJsDefault = parcelHelpers.interopDefault(_promiseJs);
var _setJs = require("./_Set.js");
var _setJsDefault = parcelHelpers.interopDefault(_setJs);
var _weakMapJs = require("./_WeakMap.js");
var _weakMapJsDefault = parcelHelpers.interopDefault(_weakMapJs);
var _baseGetTagJs = require("./_baseGetTag.js");
var _baseGetTagJsDefault = parcelHelpers.interopDefault(_baseGetTagJs);
var _toSourceJs = require("./_toSource.js");
var _toSourceJsDefault = parcelHelpers.interopDefault(_toSourceJs);
/** `Object#toString` result references. */ var mapTag = "[object Map]", objectTag = "[object Object]", promiseTag = "[object Promise]", setTag = "[object Set]", weakMapTag = "[object WeakMap]";
var dataViewTag = "[object DataView]";
/** Used to detect maps, sets, and weakmaps. */ var dataViewCtorString = (0, _toSourceJsDefault.default)((0, _dataViewJsDefault.default)), mapCtorString = (0, _toSourceJsDefault.default)((0, _mapJsDefault.default)), promiseCtorString = (0, _toSourceJsDefault.default)((0, _promiseJsDefault.default)), setCtorString = (0, _toSourceJsDefault.default)((0, _setJsDefault.default)), weakMapCtorString = (0, _toSourceJsDefault.default)((0, _weakMapJsDefault.default));
/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ var getTag = (0, _baseGetTagJsDefault.default);
// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((0, _dataViewJsDefault.default) && getTag(new (0, _dataViewJsDefault.default)(new ArrayBuffer(1))) != dataViewTag || (0, _mapJsDefault.default) && getTag(new (0, _mapJsDefault.default)) != mapTag || (0, _promiseJsDefault.default) && getTag((0, _promiseJsDefault.default).resolve()) != promiseTag || (0, _setJsDefault.default) && getTag(new (0, _setJsDefault.default)) != setTag || (0, _weakMapJsDefault.default) && getTag(new (0, _weakMapJsDefault.default)) != weakMapTag) getTag = function(value) {
    var result = (0, _baseGetTagJsDefault.default)(value), Ctor = result == objectTag ? value.constructor : undefined, ctorString = Ctor ? (0, _toSourceJsDefault.default)(Ctor) : "";
    if (ctorString) switch(ctorString){
        case dataViewCtorString:
            return dataViewTag;
        case mapCtorString:
            return mapTag;
        case promiseCtorString:
            return promiseTag;
        case setCtorString:
            return setTag;
        case weakMapCtorString:
            return weakMapTag;
    }
    return result;
};
exports.default = getTag;

},{"./_DataView.js":"czDUC","./_Map.js":"gBkLr","./_Promise.js":"8FXqC","./_Set.js":"ezpvh","./_WeakMap.js":"bo2vf","./_baseGetTag.js":"cZgKC","./_toSource.js":"hV6pF","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"czDUC":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _getNativeJs = require("./_getNative.js");
var _getNativeJsDefault = parcelHelpers.interopDefault(_getNativeJs);
var _rootJs = require("./_root.js");
var _rootJsDefault = parcelHelpers.interopDefault(_rootJs);
/* Built-in method references that are verified to be native. */ var DataView = (0, _getNativeJsDefault.default)((0, _rootJsDefault.default), "DataView");
exports.default = DataView;

},{"./_getNative.js":"8XHOL","./_root.js":"cTEWZ","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8FXqC":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _getNativeJs = require("./_getNative.js");
var _getNativeJsDefault = parcelHelpers.interopDefault(_getNativeJs);
var _rootJs = require("./_root.js");
var _rootJsDefault = parcelHelpers.interopDefault(_rootJs);
/* Built-in method references that are verified to be native. */ var Promise = (0, _getNativeJsDefault.default)((0, _rootJsDefault.default), "Promise");
exports.default = Promise;

},{"./_getNative.js":"8XHOL","./_root.js":"cTEWZ","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"ezpvh":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _getNativeJs = require("./_getNative.js");
var _getNativeJsDefault = parcelHelpers.interopDefault(_getNativeJs);
var _rootJs = require("./_root.js");
var _rootJsDefault = parcelHelpers.interopDefault(_rootJs);
/* Built-in method references that are verified to be native. */ var Set = (0, _getNativeJsDefault.default)((0, _rootJsDefault.default), "Set");
exports.default = Set;

},{"./_getNative.js":"8XHOL","./_root.js":"cTEWZ","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"bo2vf":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _getNativeJs = require("./_getNative.js");
var _getNativeJsDefault = parcelHelpers.interopDefault(_getNativeJs);
var _rootJs = require("./_root.js");
var _rootJsDefault = parcelHelpers.interopDefault(_rootJs);
/* Built-in method references that are verified to be native. */ var WeakMap = (0, _getNativeJsDefault.default)((0, _rootJsDefault.default), "WeakMap");
exports.default = WeakMap;

},{"./_getNative.js":"8XHOL","./_root.js":"cTEWZ","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9eOVp":[function(require,module,exports) {
/** Used for built-in method references. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * Initializes an array clone.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the initialized clone.
 */ function initCloneArray(array) {
    var length = array.length, result = new array.constructor(length);
    // Add properties assigned by `RegExp#exec`.
    if (length && typeof array[0] == "string" && hasOwnProperty.call(array, "index")) {
        result.index = array.index;
        result.input = array.input;
    }
    return result;
}
exports.default = initCloneArray;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6KWUZ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _cloneArrayBufferJs = require("./_cloneArrayBuffer.js");
var _cloneArrayBufferJsDefault = parcelHelpers.interopDefault(_cloneArrayBufferJs);
var _cloneDataViewJs = require("./_cloneDataView.js");
var _cloneDataViewJsDefault = parcelHelpers.interopDefault(_cloneDataViewJs);
var _cloneRegExpJs = require("./_cloneRegExp.js");
var _cloneRegExpJsDefault = parcelHelpers.interopDefault(_cloneRegExpJs);
var _cloneSymbolJs = require("./_cloneSymbol.js");
var _cloneSymbolJsDefault = parcelHelpers.interopDefault(_cloneSymbolJs);
var _cloneTypedArrayJs = require("./_cloneTypedArray.js");
var _cloneTypedArrayJsDefault = parcelHelpers.interopDefault(_cloneTypedArrayJs);
/** `Object#toString` result references. */ var boolTag = "[object Boolean]", dateTag = "[object Date]", mapTag = "[object Map]", numberTag = "[object Number]", regexpTag = "[object RegExp]", setTag = "[object Set]", stringTag = "[object String]", symbolTag = "[object Symbol]";
var arrayBufferTag = "[object ArrayBuffer]", dataViewTag = "[object DataView]", float32Tag = "[object Float32Array]", float64Tag = "[object Float64Array]", int8Tag = "[object Int8Array]", int16Tag = "[object Int16Array]", int32Tag = "[object Int32Array]", uint8Tag = "[object Uint8Array]", uint8ClampedTag = "[object Uint8ClampedArray]", uint16Tag = "[object Uint16Array]", uint32Tag = "[object Uint32Array]";
/**
 * Initializes an object clone based on its `toStringTag`.
 *
 * **Note:** This function only supports cloning values with tags of
 * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
 *
 * @private
 * @param {Object} object The object to clone.
 * @param {string} tag The `toStringTag` of the object to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the initialized clone.
 */ function initCloneByTag(object, tag, isDeep) {
    var Ctor = object.constructor;
    switch(tag){
        case arrayBufferTag:
            return (0, _cloneArrayBufferJsDefault.default)(object);
        case boolTag:
        case dateTag:
            return new Ctor(+object);
        case dataViewTag:
            return (0, _cloneDataViewJsDefault.default)(object, isDeep);
        case float32Tag:
        case float64Tag:
        case int8Tag:
        case int16Tag:
        case int32Tag:
        case uint8Tag:
        case uint8ClampedTag:
        case uint16Tag:
        case uint32Tag:
            return (0, _cloneTypedArrayJsDefault.default)(object, isDeep);
        case mapTag:
            return new Ctor;
        case numberTag:
        case stringTag:
            return new Ctor(object);
        case regexpTag:
            return (0, _cloneRegExpJsDefault.default)(object);
        case setTag:
            return new Ctor;
        case symbolTag:
            return (0, _cloneSymbolJsDefault.default)(object);
    }
}
exports.default = initCloneByTag;

},{"./_cloneArrayBuffer.js":"afcWq","./_cloneDataView.js":"88vUS","./_cloneRegExp.js":"HUxDb","./_cloneSymbol.js":"87hUU","./_cloneTypedArray.js":"8IgLp","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"afcWq":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _uint8ArrayJs = require("./_Uint8Array.js");
var _uint8ArrayJsDefault = parcelHelpers.interopDefault(_uint8ArrayJs);
/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */ function cloneArrayBuffer(arrayBuffer) {
    var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
    new (0, _uint8ArrayJsDefault.default)(result).set(new (0, _uint8ArrayJsDefault.default)(arrayBuffer));
    return result;
}
exports.default = cloneArrayBuffer;

},{"./_Uint8Array.js":"aLmL3","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"aLmL3":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _rootJs = require("./_root.js");
var _rootJsDefault = parcelHelpers.interopDefault(_rootJs);
/** Built-in value references. */ var Uint8Array = (0, _rootJsDefault.default).Uint8Array;
exports.default = Uint8Array;

},{"./_root.js":"cTEWZ","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"88vUS":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _cloneArrayBufferJs = require("./_cloneArrayBuffer.js");
var _cloneArrayBufferJsDefault = parcelHelpers.interopDefault(_cloneArrayBufferJs);
/**
 * Creates a clone of `dataView`.
 *
 * @private
 * @param {Object} dataView The data view to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned data view.
 */ function cloneDataView(dataView, isDeep) {
    var buffer = isDeep ? (0, _cloneArrayBufferJsDefault.default)(dataView.buffer) : dataView.buffer;
    return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
}
exports.default = cloneDataView;

},{"./_cloneArrayBuffer.js":"afcWq","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"HUxDb":[function(require,module,exports) {
/** Used to match `RegExp` flags from their coerced string values. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var reFlags = /\w*$/;
/**
 * Creates a clone of `regexp`.
 *
 * @private
 * @param {Object} regexp The regexp to clone.
 * @returns {Object} Returns the cloned regexp.
 */ function cloneRegExp(regexp) {
    var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
    result.lastIndex = regexp.lastIndex;
    return result;
}
exports.default = cloneRegExp;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"87hUU":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _symbolJs = require("./_Symbol.js");
var _symbolJsDefault = parcelHelpers.interopDefault(_symbolJs);
/** Used to convert symbols to primitives and strings. */ var symbolProto = (0, _symbolJsDefault.default) ? (0, _symbolJsDefault.default).prototype : undefined, symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;
/**
 * Creates a clone of the `symbol` object.
 *
 * @private
 * @param {Object} symbol The symbol object to clone.
 * @returns {Object} Returns the cloned symbol object.
 */ function cloneSymbol(symbol) {
    return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
}
exports.default = cloneSymbol;

},{"./_Symbol.js":"xSCm6","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8IgLp":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _cloneArrayBufferJs = require("./_cloneArrayBuffer.js");
var _cloneArrayBufferJsDefault = parcelHelpers.interopDefault(_cloneArrayBufferJs);
/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */ function cloneTypedArray(typedArray, isDeep) {
    var buffer = isDeep ? (0, _cloneArrayBufferJsDefault.default)(typedArray.buffer) : typedArray.buffer;
    return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}
exports.default = cloneTypedArray;

},{"./_cloneArrayBuffer.js":"afcWq","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"eNMyw":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _baseCreateJs = require("./_baseCreate.js");
var _baseCreateJsDefault = parcelHelpers.interopDefault(_baseCreateJs);
var _getPrototypeJs = require("./_getPrototype.js");
var _getPrototypeJsDefault = parcelHelpers.interopDefault(_getPrototypeJs);
var _isPrototypeJs = require("./_isPrototype.js");
var _isPrototypeJsDefault = parcelHelpers.interopDefault(_isPrototypeJs);
/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */ function initCloneObject(object) {
    return typeof object.constructor == "function" && !(0, _isPrototypeJsDefault.default)(object) ? (0, _baseCreateJsDefault.default)((0, _getPrototypeJsDefault.default)(object)) : {};
}
exports.default = initCloneObject;

},{"./_baseCreate.js":"6wqeu","./_getPrototype.js":"blDI2","./_isPrototype.js":"bwS2b","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6wqeu":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _isObjectJs = require("./isObject.js");
var _isObjectJsDefault = parcelHelpers.interopDefault(_isObjectJs);
/** Built-in value references. */ var objectCreate = Object.create;
/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */ var baseCreate = function() {
    function object() {}
    return function(proto) {
        if (!(0, _isObjectJsDefault.default)(proto)) return {};
        if (objectCreate) return objectCreate(proto);
        object.prototype = proto;
        var result = new object;
        object.prototype = undefined;
        return result;
    };
}();
exports.default = baseCreate;

},{"./isObject.js":"boUsC","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1dNMR":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _baseIsMapJs = require("./_baseIsMap.js");
var _baseIsMapJsDefault = parcelHelpers.interopDefault(_baseIsMapJs);
var _baseUnaryJs = require("./_baseUnary.js");
var _baseUnaryJsDefault = parcelHelpers.interopDefault(_baseUnaryJs);
var _nodeUtilJs = require("./_nodeUtil.js");
var _nodeUtilJsDefault = parcelHelpers.interopDefault(_nodeUtilJs);
/* Node.js helper references. */ var nodeIsMap = (0, _nodeUtilJsDefault.default) && (0, _nodeUtilJsDefault.default).isMap;
/**
 * Checks if `value` is classified as a `Map` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 * @example
 *
 * _.isMap(new Map);
 * // => true
 *
 * _.isMap(new WeakMap);
 * // => false
 */ var isMap = nodeIsMap ? (0, _baseUnaryJsDefault.default)(nodeIsMap) : (0, _baseIsMapJsDefault.default);
exports.default = isMap;

},{"./_baseIsMap.js":"7LHNx","./_baseUnary.js":"fwcjM","./_nodeUtil.js":"gwvhS","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7LHNx":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _getTagJs = require("./_getTag.js");
var _getTagJsDefault = parcelHelpers.interopDefault(_getTagJs);
var _isObjectLikeJs = require("./isObjectLike.js");
var _isObjectLikeJsDefault = parcelHelpers.interopDefault(_isObjectLikeJs);
/** `Object#toString` result references. */ var mapTag = "[object Map]";
/**
 * The base implementation of `_.isMap` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 */ function baseIsMap(value) {
    return (0, _isObjectLikeJsDefault.default)(value) && (0, _getTagJsDefault.default)(value) == mapTag;
}
exports.default = baseIsMap;

},{"./_getTag.js":"k5EiA","./isObjectLike.js":"hcFFR","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"eR5F5":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _baseIsSetJs = require("./_baseIsSet.js");
var _baseIsSetJsDefault = parcelHelpers.interopDefault(_baseIsSetJs);
var _baseUnaryJs = require("./_baseUnary.js");
var _baseUnaryJsDefault = parcelHelpers.interopDefault(_baseUnaryJs);
var _nodeUtilJs = require("./_nodeUtil.js");
var _nodeUtilJsDefault = parcelHelpers.interopDefault(_nodeUtilJs);
/* Node.js helper references. */ var nodeIsSet = (0, _nodeUtilJsDefault.default) && (0, _nodeUtilJsDefault.default).isSet;
/**
 * Checks if `value` is classified as a `Set` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 * @example
 *
 * _.isSet(new Set);
 * // => true
 *
 * _.isSet(new WeakSet);
 * // => false
 */ var isSet = nodeIsSet ? (0, _baseUnaryJsDefault.default)(nodeIsSet) : (0, _baseIsSetJsDefault.default);
exports.default = isSet;

},{"./_baseIsSet.js":"hUzM8","./_baseUnary.js":"fwcjM","./_nodeUtil.js":"gwvhS","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hUzM8":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _getTagJs = require("./_getTag.js");
var _getTagJsDefault = parcelHelpers.interopDefault(_getTagJs);
var _isObjectLikeJs = require("./isObjectLike.js");
var _isObjectLikeJsDefault = parcelHelpers.interopDefault(_isObjectLikeJs);
/** `Object#toString` result references. */ var setTag = "[object Set]";
/**
 * The base implementation of `_.isSet` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 */ function baseIsSet(value) {
    return (0, _isObjectLikeJsDefault.default)(value) && (0, _getTagJsDefault.default)(value) == setTag;
}
exports.default = baseIsSet;

},{"./_getTag.js":"k5EiA","./isObjectLike.js":"hcFFR","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3mvdy":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _arrayMapJs = require("./_arrayMap.js");
var _arrayMapJsDefault = parcelHelpers.interopDefault(_arrayMapJs);
var _copyArrayJs = require("./_copyArray.js");
var _copyArrayJsDefault = parcelHelpers.interopDefault(_copyArrayJs);
var _isArrayJs = require("./isArray.js");
var _isArrayJsDefault = parcelHelpers.interopDefault(_isArrayJs);
var _isSymbolJs = require("./isSymbol.js");
var _isSymbolJsDefault = parcelHelpers.interopDefault(_isSymbolJs);
var _stringToPathJs = require("./_stringToPath.js");
var _stringToPathJsDefault = parcelHelpers.interopDefault(_stringToPathJs);
var _toKeyJs = require("./_toKey.js");
var _toKeyJsDefault = parcelHelpers.interopDefault(_toKeyJs);
var _toStringJs = require("./toString.js");
var _toStringJsDefault = parcelHelpers.interopDefault(_toStringJs);
/**
 * Converts `value` to a property path array.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Util
 * @param {*} value The value to convert.
 * @returns {Array} Returns the new property path array.
 * @example
 *
 * _.toPath('a.b.c');
 * // => ['a', 'b', 'c']
 *
 * _.toPath('a[0].b.c');
 * // => ['a', '0', 'b', 'c']
 */ function toPath(value) {
    if ((0, _isArrayJsDefault.default)(value)) return (0, _arrayMapJsDefault.default)(value, (0, _toKeyJsDefault.default));
    return (0, _isSymbolJsDefault.default)(value) ? [
        value
    ] : (0, _copyArrayJsDefault.default)((0, _stringToPathJsDefault.default)((0, _toStringJsDefault.default)(value)));
}
exports.default = toPath;

},{"./_arrayMap.js":"67DQC","./_copyArray.js":"jFIQj","./isArray.js":"a5xfW","./isSymbol.js":"bAp74","./_stringToPath.js":"123gg","./_toKey.js":"2HIrA","./toString.js":"dMOOR","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"67DQC":[function(require,module,exports) {
/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function arrayMap(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length, result = Array(length);
    while(++index < length)result[index] = iteratee(array[index], index, array);
    return result;
}
exports.default = arrayMap;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"bAp74":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _baseGetTagJs = require("./_baseGetTag.js");
var _baseGetTagJsDefault = parcelHelpers.interopDefault(_baseGetTagJs);
var _isObjectLikeJs = require("./isObjectLike.js");
var _isObjectLikeJsDefault = parcelHelpers.interopDefault(_isObjectLikeJs);
/** `Object#toString` result references. */ var symbolTag = "[object Symbol]";
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function isSymbol(value) {
    return typeof value == "symbol" || (0, _isObjectLikeJsDefault.default)(value) && (0, _baseGetTagJsDefault.default)(value) == symbolTag;
}
exports.default = isSymbol;

},{"./_baseGetTag.js":"cZgKC","./isObjectLike.js":"hcFFR","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"123gg":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _memoizeCappedJs = require("./_memoizeCapped.js");
var _memoizeCappedJsDefault = parcelHelpers.interopDefault(_memoizeCappedJs);
/** Used to match property names within property paths. */ var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
/** Used to match backslashes in property paths. */ var reEscapeChar = /\\(\\)?/g;
/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */ var stringToPath = (0, _memoizeCappedJsDefault.default)(function(string) {
    var result = [];
    if (string.charCodeAt(0) === 46 /* . */ ) result.push("");
    string.replace(rePropName, function(match, number, quote, subString) {
        result.push(quote ? subString.replace(reEscapeChar, "$1") : number || match);
    });
    return result;
});
exports.default = stringToPath;

},{"./_memoizeCapped.js":"kbviU","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"kbviU":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _memoizeJs = require("./memoize.js");
var _memoizeJsDefault = parcelHelpers.interopDefault(_memoizeJs);
/** Used as the maximum memoize cache size. */ var MAX_MEMOIZE_SIZE = 500;
/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */ function memoizeCapped(func) {
    var result = (0, _memoizeJsDefault.default)(func, function(key) {
        if (cache.size === MAX_MEMOIZE_SIZE) cache.clear();
        return key;
    });
    var cache = result.cache;
    return result;
}
exports.default = memoizeCapped;

},{"./memoize.js":"kSZfU","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"kSZfU":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _mapCacheJs = require("./_MapCache.js");
var _mapCacheJsDefault = parcelHelpers.interopDefault(_mapCacheJs);
/** Error message constants. */ var FUNC_ERROR_TEXT = "Expected a function";
/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */ function memoize(func, resolver) {
    if (typeof func != "function" || resolver != null && typeof resolver != "function") throw new TypeError(FUNC_ERROR_TEXT);
    var memoized = function() {
        var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
        if (cache.has(key)) return cache.get(key);
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
    };
    memoized.cache = new (memoize.Cache || (0, _mapCacheJsDefault.default));
    return memoized;
}
// Expose `MapCache`.
memoize.Cache = (0, _mapCacheJsDefault.default);
exports.default = memoize;

},{"./_MapCache.js":"8Hi07","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2HIrA":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _isSymbolJs = require("./isSymbol.js");
var _isSymbolJsDefault = parcelHelpers.interopDefault(_isSymbolJs);
/** Used as references for various `Number` constants. */ var INFINITY = 1 / 0;
/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */ function toKey(value) {
    if (typeof value == "string" || (0, _isSymbolJsDefault.default)(value)) return value;
    var result = value + "";
    return result == "0" && 1 / value == -INFINITY ? "-0" : result;
}
exports.default = toKey;

},{"./isSymbol.js":"bAp74","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"dMOOR":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _baseToStringJs = require("./_baseToString.js");
var _baseToStringJsDefault = parcelHelpers.interopDefault(_baseToStringJs);
/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */ function toString(value) {
    return value == null ? "" : (0, _baseToStringJsDefault.default)(value);
}
exports.default = toString;

},{"./_baseToString.js":"lffG9","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"lffG9":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _symbolJs = require("./_Symbol.js");
var _symbolJsDefault = parcelHelpers.interopDefault(_symbolJs);
var _arrayMapJs = require("./_arrayMap.js");
var _arrayMapJsDefault = parcelHelpers.interopDefault(_arrayMapJs);
var _isArrayJs = require("./isArray.js");
var _isArrayJsDefault = parcelHelpers.interopDefault(_isArrayJs);
var _isSymbolJs = require("./isSymbol.js");
var _isSymbolJsDefault = parcelHelpers.interopDefault(_isSymbolJs);
/** Used as references for various `Number` constants. */ var INFINITY = 1 / 0;
/** Used to convert symbols to primitives and strings. */ var symbolProto = (0, _symbolJsDefault.default) ? (0, _symbolJsDefault.default).prototype : undefined, symbolToString = symbolProto ? symbolProto.toString : undefined;
/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */ function baseToString(value) {
    // Exit early for strings to avoid a performance hit in some environments.
    if (typeof value == "string") return value;
    if ((0, _isArrayJsDefault.default)(value)) // Recursively convert values (susceptible to call stack limits).
    return (0, _arrayMapJsDefault.default)(value, baseToString) + "";
    if ((0, _isSymbolJsDefault.default)(value)) return symbolToString ? symbolToString.call(value) : "";
    var result = value + "";
    return result == "0" && 1 / value == -INFINITY ? "-0" : result;
}
exports.default = baseToString;

},{"./_Symbol.js":"xSCm6","./_arrayMap.js":"67DQC","./isArray.js":"a5xfW","./isSymbol.js":"bAp74","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"01IM3":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _baseCloneJs = require("./_baseClone.js");
var _baseCloneJsDefault = parcelHelpers.interopDefault(_baseCloneJs);
/** Used to compose bitmasks for cloning. */ var CLONE_DEEP_FLAG = 1, CLONE_SYMBOLS_FLAG = 4;
/**
 * This method is like `_.clone` except that it recursively clones `value`.
 *
 * @static
 * @memberOf _
 * @since 1.0.0
 * @category Lang
 * @param {*} value The value to recursively clone.
 * @returns {*} Returns the deep cloned value.
 * @see _.clone
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var deep = _.cloneDeep(objects);
 * console.log(deep[0] === objects[0]);
 * // => false
 */ function cloneDeep(value) {
    return (0, _baseCloneJsDefault.default)(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
}
exports.default = cloneDeep;

},{"./_baseClone.js":"ka5Mk","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"j2SJU":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "mixed", ()=>(0, _mixed.create));
parcelHelpers.export(exports, "bool", ()=>(0, _boolean.create));
parcelHelpers.export(exports, "boolean", ()=>(0, _boolean.create));
parcelHelpers.export(exports, "string", ()=>(0, _string.create));
parcelHelpers.export(exports, "number", ()=>(0, _number.create));
parcelHelpers.export(exports, "date", ()=>(0, _date.create));
parcelHelpers.export(exports, "object", ()=>(0, _object.create));
parcelHelpers.export(exports, "array", ()=>(0, _array.create));
parcelHelpers.export(exports, "ref", ()=>(0, _reference.create));
parcelHelpers.export(exports, "lazy", ()=>(0, _lazy.create));
parcelHelpers.export(exports, "reach", ()=>(0, _reachDefault.default));
parcelHelpers.export(exports, "isSchema", ()=>(0, _isSchemaDefault.default));
parcelHelpers.export(exports, "addMethod", ()=>addMethod);
parcelHelpers.export(exports, "setLocale", ()=>(0, _setLocaleDefault.default));
parcelHelpers.export(exports, "ValidationError", ()=>(0, _validationErrorDefault.default));
parcelHelpers.export(exports, "BaseSchema", ()=>(0, _schemaDefault.default));
parcelHelpers.export(exports, "MixedSchema", ()=>(0, _mixedDefault.default));
parcelHelpers.export(exports, "BooleanSchema", ()=>(0, _booleanDefault.default));
parcelHelpers.export(exports, "StringSchema", ()=>(0, _stringDefault.default));
parcelHelpers.export(exports, "NumberSchema", ()=>(0, _numberDefault.default));
parcelHelpers.export(exports, "DateSchema", ()=>(0, _dateDefault.default));
parcelHelpers.export(exports, "ObjectSchema", ()=>(0, _objectDefault.default));
parcelHelpers.export(exports, "ArraySchema", ()=>(0, _arrayDefault.default));
var _mixed = require("./mixed");
var _mixedDefault = parcelHelpers.interopDefault(_mixed);
var _boolean = require("./boolean");
var _booleanDefault = parcelHelpers.interopDefault(_boolean);
var _string = require("./string");
var _stringDefault = parcelHelpers.interopDefault(_string);
var _number = require("./number");
var _numberDefault = parcelHelpers.interopDefault(_number);
var _date = require("./date");
var _dateDefault = parcelHelpers.interopDefault(_date);
var _object = require("./object");
var _objectDefault = parcelHelpers.interopDefault(_object);
var _array = require("./array");
var _arrayDefault = parcelHelpers.interopDefault(_array);
var _reference = require("./Reference");
var _lazy = require("./Lazy");
var _validationError = require("./ValidationError");
var _validationErrorDefault = parcelHelpers.interopDefault(_validationError);
var _reach = require("./util/reach");
var _reachDefault = parcelHelpers.interopDefault(_reach);
var _isSchema = require("./util/isSchema");
var _isSchemaDefault = parcelHelpers.interopDefault(_isSchema);
var _setLocale = require("./setLocale");
var _setLocaleDefault = parcelHelpers.interopDefault(_setLocale);
var _schema = require("./schema");
var _schemaDefault = parcelHelpers.interopDefault(_schema);
function addMethod(schemaType, name, fn) {
    if (!schemaType || !(0, _isSchemaDefault.default)(schemaType.prototype)) throw new TypeError("You must provide a yup schema constructor function");
    if (typeof name !== "string") throw new TypeError("A Method name must be provided");
    if (typeof fn !== "function") throw new TypeError("Method function must be provided");
    schemaType.prototype[name] = fn;
}

},{"./mixed":"bkZ8R","./boolean":"cFehd","./string":"gaozq","./number":"bM9NP","./date":"l2PQH","./object":"bL9b5","./array":"79GJQ","./Reference":"cSTlF","./Lazy":"fisrl","./ValidationError":"5PgCn","./util/reach":"fRPEz","./util/isSchema":"1ifri","./setLocale":"7QEUR","./schema":"4TARM","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"bkZ8R":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "create", ()=>create) // XXX: this is using the Base schema so that `addMethod(mixed)` works as a base class
;
var _schema = require("./schema");
var _schemaDefault = parcelHelpers.interopDefault(_schema);
const Mixed = (0, _schemaDefault.default);
exports.default = Mixed;
function create() {
    return new Mixed();
}
create.prototype = Mixed.prototype;

},{"./schema":"4TARM","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4TARM":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// @ts-ignore
var _nanoclone = require("nanoclone");
var _nanocloneDefault = parcelHelpers.interopDefault(_nanoclone);
var _locale = require("./locale");
var _condition = require("./Condition");
var _conditionDefault = parcelHelpers.interopDefault(_condition);
var _runTests = require("./util/runTests");
var _runTestsDefault = parcelHelpers.interopDefault(_runTests);
var _createValidation = require("./util/createValidation");
var _createValidationDefault = parcelHelpers.interopDefault(_createValidation);
var _printValue = require("./util/printValue");
var _printValueDefault = parcelHelpers.interopDefault(_printValue);
var _reference = require("./Reference");
var _referenceDefault = parcelHelpers.interopDefault(_reference);
var _reach = require("./util/reach");
var _validationError = require("./ValidationError");
var _validationErrorDefault = parcelHelpers.interopDefault(_validationError);
var _referenceSet = require("./util/ReferenceSet");
var _referenceSetDefault = parcelHelpers.interopDefault(_referenceSet);
var _toArray = require("./util/toArray"); // const UNSET = 'unset' as const;
var _toArrayDefault = parcelHelpers.interopDefault(_toArray);
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
class BaseSchema {
    constructor(options){
        this.deps = [];
        this.tests = void 0;
        this.transforms = void 0;
        this.conditions = [];
        this._mutate = void 0;
        this._typeError = void 0;
        this._whitelist = new (0, _referenceSetDefault.default)();
        this._blacklist = new (0, _referenceSetDefault.default)();
        this.exclusiveTests = Object.create(null);
        this.spec = void 0;
        this.tests = [];
        this.transforms = [];
        this.withMutation(()=>{
            this.typeError((0, _locale.mixed).notType);
        });
        this.type = (options == null ? void 0 : options.type) || "mixed";
        this.spec = _extends({
            strip: false,
            strict: false,
            abortEarly: true,
            recursive: true,
            nullable: false,
            presence: "optional"
        }, options == null ? void 0 : options.spec);
    }
    get _type() {
        return this.type;
    }
    _typeCheck(_value) {
        return true;
    }
    clone(spec) {
        if (this._mutate) {
            if (spec) Object.assign(this.spec, spec);
            return this;
        } // if the nested value is a schema we can skip cloning, since
        // they are already immutable
        const next = Object.create(Object.getPrototypeOf(this)); // @ts-expect-error this is readonly
        next.type = this.type;
        next._typeError = this._typeError;
        next._whitelistError = this._whitelistError;
        next._blacklistError = this._blacklistError;
        next._whitelist = this._whitelist.clone();
        next._blacklist = this._blacklist.clone();
        next.exclusiveTests = _extends({}, this.exclusiveTests); // @ts-expect-error this is readonly
        next.deps = [
            ...this.deps
        ];
        next.conditions = [
            ...this.conditions
        ];
        next.tests = [
            ...this.tests
        ];
        next.transforms = [
            ...this.transforms
        ];
        next.spec = (0, _nanocloneDefault.default)(_extends({}, this.spec, spec));
        return next;
    }
    label(label) {
        let next = this.clone();
        next.spec.label = label;
        return next;
    }
    meta(...args) {
        if (args.length === 0) return this.spec.meta;
        let next = this.clone();
        next.spec.meta = Object.assign(next.spec.meta || {}, args[0]);
        return next;
    }
    //   TCast,
    //   TContext,
    //   TOutput
    // > {
    //   return this as any;
    // }
    withMutation(fn) {
        let before = this._mutate;
        this._mutate = true;
        let result = fn(this);
        this._mutate = before;
        return result;
    }
    concat(schema) {
        if (!schema || schema === this) return this;
        if (schema.type !== this.type && this.type !== "mixed") throw new TypeError(`You cannot \`concat()\` schema's of different types: ${this.type} and ${schema.type}`);
        let base = this;
        let combined = schema.clone();
        const mergedSpec = _extends({}, base.spec, combined.spec); // if (combined.spec.nullable === UNSET)
        //   mergedSpec.nullable = base.spec.nullable;
        // if (combined.spec.presence === UNSET)
        //   mergedSpec.presence = base.spec.presence;
        combined.spec = mergedSpec;
        combined._typeError || (combined._typeError = base._typeError);
        combined._whitelistError || (combined._whitelistError = base._whitelistError);
        combined._blacklistError || (combined._blacklistError = base._blacklistError); // manually merge the blacklist/whitelist (the other `schema` takes
        // precedence in case of conflicts)
        combined._whitelist = base._whitelist.merge(schema._whitelist, schema._blacklist);
        combined._blacklist = base._blacklist.merge(schema._blacklist, schema._whitelist); // start with the current tests
        combined.tests = base.tests;
        combined.exclusiveTests = base.exclusiveTests; // manually add the new tests to ensure
        // the deduping logic is consistent
        combined.withMutation((next)=>{
            schema.tests.forEach((fn)=>{
                next.test(fn.OPTIONS);
            });
        });
        combined.transforms = [
            ...base.transforms,
            ...combined.transforms
        ];
        return combined;
    }
    isType(v) {
        if (this.spec.nullable && v === null) return true;
        return this._typeCheck(v);
    }
    resolve(options) {
        let schema = this;
        if (schema.conditions.length) {
            let conditions = schema.conditions;
            schema = schema.clone();
            schema.conditions = [];
            schema = conditions.reduce((schema, condition)=>condition.resolve(schema, options), schema);
            schema = schema.resolve(options);
        }
        return schema;
    }
    /**
   *
   * @param {*} value
   * @param {Object} options
   * @param {*=} options.parent
   * @param {*=} options.context
   */ cast(value, options = {}) {
        let resolvedSchema = this.resolve(_extends({
            value
        }, options));
        let result = resolvedSchema._cast(value, options);
        if (value !== undefined && options.assert !== false && resolvedSchema.isType(result) !== true) {
            let formattedValue = (0, _printValueDefault.default)(value);
            let formattedResult = (0, _printValueDefault.default)(result);
            throw new TypeError(`The value of ${options.path || "field"} could not be cast to a value ` + `that satisfies the schema type: "${resolvedSchema._type}". \n\n` + `attempted value: ${formattedValue} \n` + (formattedResult !== formattedValue ? `result of cast: ${formattedResult}` : ""));
        }
        return result;
    }
    _cast(rawValue, _options) {
        let value = rawValue === undefined ? rawValue : this.transforms.reduce((value, fn)=>fn.call(this, value, rawValue, this), rawValue);
        if (value === undefined) value = this.getDefault();
        return value;
    }
    _validate(_value, options = {}, cb) {
        let { sync, path, from = [], originalValue = _value, strict = this.spec.strict, abortEarly = this.spec.abortEarly } = options;
        let value = _value;
        if (!strict) // this._validating = true;
        value = this._cast(value, _extends({
            assert: false
        }, options)); // this._validating = false;
         // value is cast, we can check if it meets type requirements
        let args = {
            value,
            path,
            options,
            originalValue,
            schema: this,
            label: this.spec.label,
            sync,
            from
        };
        let initialTests = [];
        if (this._typeError) initialTests.push(this._typeError);
        let finalTests = [];
        if (this._whitelistError) finalTests.push(this._whitelistError);
        if (this._blacklistError) finalTests.push(this._blacklistError);
        (0, _runTestsDefault.default)({
            args,
            value,
            path,
            sync,
            tests: initialTests,
            endEarly: abortEarly
        }, (err)=>{
            if (err) return void cb(err, value);
            (0, _runTestsDefault.default)({
                tests: this.tests.concat(finalTests),
                args,
                path,
                sync,
                value,
                endEarly: abortEarly
            }, cb);
        });
    }
    validate(value, options, maybeCb) {
        let schema = this.resolve(_extends({}, options, {
            value
        })); // callback case is for nested validations
        return typeof maybeCb === "function" ? schema._validate(value, options, maybeCb) : new Promise((resolve, reject)=>schema._validate(value, options, (err, value)=>{
                if (err) reject(err);
                else resolve(value);
            }));
    }
    validateSync(value, options) {
        let schema = this.resolve(_extends({}, options, {
            value
        }));
        let result;
        schema._validate(value, _extends({}, options, {
            sync: true
        }), (err, value)=>{
            if (err) throw err;
            result = value;
        });
        return result;
    }
    isValid(value, options) {
        return this.validate(value, options).then(()=>true, (err)=>{
            if ((0, _validationErrorDefault.default).isError(err)) return false;
            throw err;
        });
    }
    isValidSync(value, options) {
        try {
            this.validateSync(value, options);
            return true;
        } catch (err) {
            if ((0, _validationErrorDefault.default).isError(err)) return false;
            throw err;
        }
    }
    _getDefault() {
        let defaultValue = this.spec.default;
        if (defaultValue == null) return defaultValue;
        return typeof defaultValue === "function" ? defaultValue.call(this) : (0, _nanocloneDefault.default)(defaultValue);
    }
    getDefault(options) {
        let schema = this.resolve(options || {});
        return schema._getDefault();
    }
    default(def) {
        if (arguments.length === 0) return this._getDefault();
        let next = this.clone({
            default: def
        });
        return next;
    }
    strict(isStrict = true) {
        let next = this.clone();
        next.spec.strict = isStrict;
        return next;
    }
    _isPresent(value) {
        return value != null;
    }
    defined(message = (0, _locale.mixed).defined) {
        return this.test({
            message,
            name: "defined",
            exclusive: true,
            test (value) {
                return value !== undefined;
            }
        });
    }
    required(message = (0, _locale.mixed).required) {
        return this.clone({
            presence: "required"
        }).withMutation((s)=>s.test({
                message,
                name: "required",
                exclusive: true,
                test (value) {
                    return this.schema._isPresent(value);
                }
            }));
    }
    notRequired() {
        let next = this.clone({
            presence: "optional"
        });
        next.tests = next.tests.filter((test)=>test.OPTIONS.name !== "required");
        return next;
    }
    nullable(isNullable = true) {
        let next = this.clone({
            nullable: isNullable !== false
        });
        return next;
    }
    transform(fn) {
        let next = this.clone();
        next.transforms.push(fn);
        return next;
    }
    /**
   * Adds a test function to the schema's queue of tests.
   * tests can be exclusive or non-exclusive.
   *
   * - exclusive tests, will replace any existing tests of the same name.
   * - non-exclusive: can be stacked
   *
   * If a non-exclusive test is added to a schema with an exclusive test of the same name
   * the exclusive test is removed and further tests of the same name will be stacked.
   *
   * If an exclusive test is added to a schema with non-exclusive tests of the same name
   * the previous tests are removed and further tests of the same name will replace each other.
   */ test(...args) {
        let opts;
        if (args.length === 1) {
            if (typeof args[0] === "function") opts = {
                test: args[0]
            };
            else opts = args[0];
        } else if (args.length === 2) opts = {
            name: args[0],
            test: args[1]
        };
        else opts = {
            name: args[0],
            message: args[1],
            test: args[2]
        };
        if (opts.message === undefined) opts.message = (0, _locale.mixed).default;
        if (typeof opts.test !== "function") throw new TypeError("`test` is a required parameters");
        let next = this.clone();
        let validate = (0, _createValidationDefault.default)(opts);
        let isExclusive = opts.exclusive || opts.name && next.exclusiveTests[opts.name] === true;
        if (opts.exclusive) {
            if (!opts.name) throw new TypeError("Exclusive tests must provide a unique `name` identifying the test");
        }
        if (opts.name) next.exclusiveTests[opts.name] = !!opts.exclusive;
        next.tests = next.tests.filter((fn)=>{
            if (fn.OPTIONS.name === opts.name) {
                if (isExclusive) return false;
                if (fn.OPTIONS.test === validate.OPTIONS.test) return false;
            }
            return true;
        });
        next.tests.push(validate);
        return next;
    }
    when(keys, options) {
        if (!Array.isArray(keys) && typeof keys !== "string") {
            options = keys;
            keys = ".";
        }
        let next = this.clone();
        let deps = (0, _toArrayDefault.default)(keys).map((key)=>new (0, _referenceDefault.default)(key));
        deps.forEach((dep)=>{
            // @ts-ignore
            if (dep.isSibling) next.deps.push(dep.key);
        });
        next.conditions.push(new (0, _conditionDefault.default)(deps, options));
        return next;
    }
    typeError(message) {
        let next = this.clone();
        next._typeError = (0, _createValidationDefault.default)({
            message,
            name: "typeError",
            test (value) {
                if (value !== undefined && !this.schema.isType(value)) return this.createError({
                    params: {
                        type: this.schema._type
                    }
                });
                return true;
            }
        });
        return next;
    }
    oneOf(enums, message = (0, _locale.mixed).oneOf) {
        let next = this.clone();
        enums.forEach((val)=>{
            next._whitelist.add(val);
            next._blacklist.delete(val);
        });
        next._whitelistError = (0, _createValidationDefault.default)({
            message,
            name: "oneOf",
            test (value) {
                if (value === undefined) return true;
                let valids = this.schema._whitelist;
                let resolved = valids.resolveAll(this.resolve);
                return resolved.includes(value) ? true : this.createError({
                    params: {
                        values: valids.toArray().join(", "),
                        resolved
                    }
                });
            }
        });
        return next;
    }
    notOneOf(enums, message = (0, _locale.mixed).notOneOf) {
        let next = this.clone();
        enums.forEach((val)=>{
            next._blacklist.add(val);
            next._whitelist.delete(val);
        });
        next._blacklistError = (0, _createValidationDefault.default)({
            message,
            name: "notOneOf",
            test (value) {
                let invalids = this.schema._blacklist;
                let resolved = invalids.resolveAll(this.resolve);
                if (resolved.includes(value)) return this.createError({
                    params: {
                        values: invalids.toArray().join(", "),
                        resolved
                    }
                });
                return true;
            }
        });
        return next;
    }
    strip(strip = true) {
        let next = this.clone();
        next.spec.strip = strip;
        return next;
    }
    describe() {
        const next = this.clone();
        const { label, meta } = next.spec;
        const description = {
            meta,
            label,
            type: next.type,
            oneOf: next._whitelist.describe(),
            notOneOf: next._blacklist.describe(),
            tests: next.tests.map((fn)=>({
                    name: fn.OPTIONS.name,
                    params: fn.OPTIONS.params
                })).filter((n, idx, list)=>list.findIndex((c)=>c.name === n.name) === idx)
        };
        return description;
    }
} // eslint-disable-next-line @typescript-eslint/no-unused-vars
exports.default = BaseSchema;
// @ts-expect-error
BaseSchema.prototype.__isYupSchema__ = true;
for (const method of [
    "validate",
    "validateSync"
])BaseSchema.prototype[`${method}At`] = function(path, value, options = {}) {
    const { parent, parentPath, schema } = (0, _reach.getIn)(this, path, value, options.context);
    return schema[method](parent && parent[parentPath], _extends({}, options, {
        parent,
        path
    }));
};
for (const alias of [
    "equals",
    "is"
])BaseSchema.prototype[alias] = BaseSchema.prototype.oneOf;
for (const alias of [
    "not",
    "nope"
])BaseSchema.prototype[alias] = BaseSchema.prototype.notOneOf;
BaseSchema.prototype.optional = BaseSchema.prototype.notRequired;

},{"nanoclone":"d6wtB","./locale":"9pL0N","./Condition":"fceyU","./util/runTests":"2dXCk","./util/createValidation":"7CPUL","./util/printValue":"kxDKC","./Reference":"cSTlF","./util/reach":"fRPEz","./ValidationError":"5PgCn","./util/ReferenceSet":"fTQOC","./util/toArray":"8ucjw","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"d6wtB":[function(require,module,exports) {
// ES6 Map
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>clone);
var map;
try {
    map = Map;
} catch (_) {}
var set;
// ES6 Set
try {
    set = Set;
} catch (_) {}
function baseClone(src, circulars, clones) {
    // Null/undefined/functions/etc
    if (!src || typeof src !== "object" || typeof src === "function") return src;
    // DOM Node
    if (src.nodeType && "cloneNode" in src) return src.cloneNode(true);
    // Date
    if (src instanceof Date) return new Date(src.getTime());
    // RegExp
    if (src instanceof RegExp) return new RegExp(src);
    // Arrays
    if (Array.isArray(src)) return src.map(clone);
    // ES6 Maps
    if (map && src instanceof map) return new Map(Array.from(src.entries()));
    // ES6 Sets
    if (set && src instanceof set) return new Set(Array.from(src.values()));
    // Object
    if (src instanceof Object) {
        circulars.push(src);
        var obj = Object.create(src);
        clones.push(obj);
        for(var key in src){
            var idx = circulars.findIndex(function(i) {
                return i === src[key];
            });
            obj[key] = idx > -1 ? clones[idx] : baseClone(src[key], circulars, clones);
        }
        return obj;
    }
    // ???
    return src;
}
function clone(src) {
    return baseClone(src, [], []);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9pL0N":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "mixed", ()=>mixed);
parcelHelpers.export(exports, "string", ()=>string);
parcelHelpers.export(exports, "number", ()=>number);
parcelHelpers.export(exports, "date", ()=>date);
parcelHelpers.export(exports, "boolean", ()=>boolean);
parcelHelpers.export(exports, "object", ()=>object);
parcelHelpers.export(exports, "array", ()=>array);
var _printValue = require("./util/printValue");
var _printValueDefault = parcelHelpers.interopDefault(_printValue);
let mixed = {
    default: "${path} is invalid",
    required: "${path} is a required field",
    oneOf: "${path} must be one of the following values: ${values}",
    notOneOf: "${path} must not be one of the following values: ${values}",
    notType: ({ path, type, value, originalValue })=>{
        let isCast = originalValue != null && originalValue !== value;
        let msg = `${path} must be a \`${type}\` type, ` + `but the final value was: \`${(0, _printValueDefault.default)(value, true)}\`` + (isCast ? ` (cast from the value \`${(0, _printValueDefault.default)(originalValue, true)}\`).` : ".");
        if (value === null) msg += `\n If "null" is intended as an empty value be sure to mark the schema as \`.nullable()\``;
        return msg;
    },
    defined: "${path} must be defined"
};
let string = {
    length: "${path} must be exactly ${length} characters",
    min: "${path} must be at least ${min} characters",
    max: "${path} must be at most ${max} characters",
    matches: '${path} must match the following: "${regex}"',
    email: "${path} must be a valid email",
    url: "${path} must be a valid URL",
    uuid: "${path} must be a valid UUID",
    trim: "${path} must be a trimmed string",
    lowercase: "${path} must be a lowercase string",
    uppercase: "${path} must be a upper case string"
};
let number = {
    min: "${path} must be greater than or equal to ${min}",
    max: "${path} must be less than or equal to ${max}",
    lessThan: "${path} must be less than ${less}",
    moreThan: "${path} must be greater than ${more}",
    positive: "${path} must be a positive number",
    negative: "${path} must be a negative number",
    integer: "${path} must be an integer"
};
let date = {
    min: "${path} field must be later than ${min}",
    max: "${path} field must be at earlier than ${max}"
};
let boolean = {
    isValue: "${path} field must be ${value}"
};
let object = {
    noUnknown: "${path} field has unspecified keys: ${unknown}"
};
let array = {
    min: "${path} field must have at least ${min} items",
    max: "${path} field must have less than or equal to ${max} items",
    length: "${path} must have ${length} items"
};
exports.default = Object.assign(Object.create(null), {
    mixed,
    string,
    number,
    date,
    object,
    array,
    boolean
});

},{"./util/printValue":"kxDKC","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"kxDKC":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>printValue);
const toString = Object.prototype.toString;
const errorToString = Error.prototype.toString;
const regExpToString = RegExp.prototype.toString;
const symbolToString = typeof Symbol !== "undefined" ? Symbol.prototype.toString : ()=>"";
const SYMBOL_REGEXP = /^Symbol\((.*)\)(.*)$/;
function printNumber(val) {
    if (val != +val) return "NaN";
    const isNegativeZero = val === 0 && 1 / val < 0;
    return isNegativeZero ? "-0" : "" + val;
}
function printSimpleValue(val, quoteStrings = false) {
    if (val == null || val === true || val === false) return "" + val;
    const typeOf = typeof val;
    if (typeOf === "number") return printNumber(val);
    if (typeOf === "string") return quoteStrings ? `"${val}"` : val;
    if (typeOf === "function") return "[Function " + (val.name || "anonymous") + "]";
    if (typeOf === "symbol") return symbolToString.call(val).replace(SYMBOL_REGEXP, "Symbol($1)");
    const tag = toString.call(val).slice(8, -1);
    if (tag === "Date") return isNaN(val.getTime()) ? "" + val : val.toISOString(val);
    if (tag === "Error" || val instanceof Error) return "[" + errorToString.call(val) + "]";
    if (tag === "RegExp") return regExpToString.call(val);
    return null;
}
function printValue(value, quoteStrings) {
    let result = printSimpleValue(value, quoteStrings);
    if (result !== null) return result;
    return JSON.stringify(value, function(key, value) {
        let result = printSimpleValue(this[key], quoteStrings);
        if (result !== null) return result;
        return value;
    }, 2);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"fceyU":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _has = require("lodash/has");
var _hasDefault = parcelHelpers.interopDefault(_has);
var _isSchema = require("./util/isSchema");
var _isSchemaDefault = parcelHelpers.interopDefault(_isSchema);
class Condition {
    constructor(refs, options){
        this.fn = void 0;
        this.refs = refs;
        this.refs = refs;
        if (typeof options === "function") {
            this.fn = options;
            return;
        }
        if (!(0, _hasDefault.default)(options, "is")) throw new TypeError("`is:` is required for `when()` conditions");
        if (!options.then && !options.otherwise) throw new TypeError("either `then:` or `otherwise:` is required for `when()` conditions");
        let { is, then, otherwise } = options;
        let check = typeof is === "function" ? is : (...values)=>values.every((value)=>value === is);
        this.fn = function(...args) {
            let options = args.pop();
            let schema = args.pop();
            let branch = check(...args) ? then : otherwise;
            if (!branch) return undefined;
            if (typeof branch === "function") return branch(schema);
            return schema.concat(branch.resolve(options));
        };
    }
    resolve(base, options) {
        let values = this.refs.map((ref)=>ref.getValue(options == null ? void 0 : options.value, options == null ? void 0 : options.parent, options == null ? void 0 : options.context));
        let schema = this.fn.apply(base, values.concat(base, options));
        if (schema === undefined || schema === base) return base;
        if (!(0, _isSchemaDefault.default)(schema)) throw new TypeError("conditions must return a schema object");
        return schema.resolve(options);
    }
}
exports.default = Condition;

},{"lodash/has":"7IGwP","./util/isSchema":"1ifri","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7IGwP":[function(require,module,exports) {
var baseHas = require("adf86b651ea78123"), hasPath = require("d1ab8f0895b2d3d5");
/**
 * Checks if `path` is a direct property of `object`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = { 'a': { 'b': 2 } };
 * var other = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.has(object, 'a');
 * // => true
 *
 * _.has(object, 'a.b');
 * // => true
 *
 * _.has(object, ['a', 'b']);
 * // => true
 *
 * _.has(other, 'a');
 * // => false
 */ function has(object, path) {
    return object != null && hasPath(object, path, baseHas);
}
module.exports = has;

},{"adf86b651ea78123":"e7zWg","d1ab8f0895b2d3d5":"fgUQM"}],"e7zWg":[function(require,module,exports) {
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * The base implementation of `_.has` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */ function baseHas(object, key) {
    return object != null && hasOwnProperty.call(object, key);
}
module.exports = baseHas;

},{}],"fgUQM":[function(require,module,exports) {
var castPath = require("bdbd2cfd212d36f7"), isArguments = require("47ffafdab3ba0d6f"), isArray = require("93ebd263ff0131c1"), isIndex = require("252ef74480e01958"), isLength = require("23c2f64e75e90a2"), toKey = require("af5ade297cb685ee");
/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */ function hasPath(object, path, hasFunc) {
    path = castPath(path, object);
    var index = -1, length = path.length, result = false;
    while(++index < length){
        var key = toKey(path[index]);
        if (!(result = object != null && hasFunc(object, key))) break;
        object = object[key];
    }
    if (result || ++index != length) return result;
    length = object == null ? 0 : object.length;
    return !!length && isLength(length) && isIndex(key, length) && (isArray(object) || isArguments(object));
}
module.exports = hasPath;

},{"bdbd2cfd212d36f7":"Q3Xos","47ffafdab3ba0d6f":"asnYU","93ebd263ff0131c1":"2VsjV","252ef74480e01958":"9uPJ6","23c2f64e75e90a2":"g5LO3","af5ade297cb685ee":"e9p91"}],"Q3Xos":[function(require,module,exports) {
var isArray = require("26a856890198f45b"), isKey = require("e823e604d75f975b"), stringToPath = require("f5fff1c342107fbd"), toString = require("b04e8cc634273c23");
/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */ function castPath(value, object) {
    if (isArray(value)) return value;
    return isKey(value, object) ? [
        value
    ] : stringToPath(toString(value));
}
module.exports = castPath;

},{"26a856890198f45b":"2VsjV","e823e604d75f975b":"cGRli","f5fff1c342107fbd":"l2nFh","b04e8cc634273c23":"j8269"}],"2VsjV":[function(require,module,exports) {
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var isArray = Array.isArray;
module.exports = isArray;

},{}],"cGRli":[function(require,module,exports) {
var isArray = require("1efcc081e9a448a8"), isSymbol = require("4cdff6c9e9ff5d38");
/** Used to match property names within property paths. */ var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, reIsPlainProp = /^\w*$/;
/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */ function isKey(value, object) {
    if (isArray(value)) return false;
    var type = typeof value;
    if (type == "number" || type == "symbol" || type == "boolean" || value == null || isSymbol(value)) return true;
    return reIsPlainProp.test(value) || !reIsDeepProp.test(value) || object != null && value in Object(object);
}
module.exports = isKey;

},{"1efcc081e9a448a8":"2VsjV","4cdff6c9e9ff5d38":"3DsXL"}],"3DsXL":[function(require,module,exports) {
var baseGetTag = require("6118c0d5630f51ce"), isObjectLike = require("74644060ad1a1d3c");
/** `Object#toString` result references. */ var symbolTag = "[object Symbol]";
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function isSymbol(value) {
    return typeof value == "symbol" || isObjectLike(value) && baseGetTag(value) == symbolTag;
}
module.exports = isSymbol;

},{"6118c0d5630f51ce":"fQG2h","74644060ad1a1d3c":"5TH1N"}],"fQG2h":[function(require,module,exports) {
var Symbol = require("68a84eb98c5d3fa2"), getRawTag = require("9b2aaf31b7bdd837"), objectToString = require("46d5beb3375f8a28");
/** `Object#toString` result references. */ var nullTag = "[object Null]", undefinedTag = "[object Undefined]";
/** Built-in value references. */ var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function baseGetTag(value) {
    if (value == null) return value === undefined ? undefinedTag : nullTag;
    return symToStringTag && symToStringTag in Object(value) ? getRawTag(value) : objectToString(value);
}
module.exports = baseGetTag;

},{"68a84eb98c5d3fa2":"e0ngr","9b2aaf31b7bdd837":"5XmKh","46d5beb3375f8a28":"fT5CU"}],"e0ngr":[function(require,module,exports) {
var root = require("9ff1abd51ad45ac0");
/** Built-in value references. */ var Symbol = root.Symbol;
module.exports = Symbol;

},{"9ff1abd51ad45ac0":"iGWPT"}],"iGWPT":[function(require,module,exports) {
var freeGlobal = require("cd92e8811deaabf5");
/** Detect free variable `self`. */ var freeSelf = typeof self == "object" && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var root = freeGlobal || freeSelf || Function("return this")();
module.exports = root;

},{"cd92e8811deaabf5":"hw1wy"}],"hw1wy":[function(require,module,exports) {
/** Detect free variable `global` from Node.js. */ var global = arguments[3];
var freeGlobal = typeof global == "object" && global && global.Object === Object && global;
module.exports = freeGlobal;

},{}],"5XmKh":[function(require,module,exports) {
var Symbol = require("e9b4533b2a68f814");
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var nativeObjectToString = objectProto.toString;
/** Built-in value references. */ var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function getRawTag(value) {
    var isOwn = hasOwnProperty.call(value, symToStringTag), tag = value[symToStringTag];
    try {
        value[symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[symToStringTag] = tag;
        else delete value[symToStringTag];
    }
    return result;
}
module.exports = getRawTag;

},{"e9b4533b2a68f814":"e0ngr"}],"fT5CU":[function(require,module,exports) {
/** Used for built-in method references. */ var objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var nativeObjectToString = objectProto.toString;
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function objectToString(value) {
    return nativeObjectToString.call(value);
}
module.exports = objectToString;

},{}],"5TH1N":[function(require,module,exports) {
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function isObjectLike(value) {
    return value != null && typeof value == "object";
}
module.exports = isObjectLike;

},{}],"l2nFh":[function(require,module,exports) {
var memoizeCapped = require("55f565a895f455e5");
/** Used to match property names within property paths. */ var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
/** Used to match backslashes in property paths. */ var reEscapeChar = /\\(\\)?/g;
/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */ var stringToPath = memoizeCapped(function(string) {
    var result = [];
    if (string.charCodeAt(0) === 46 /* . */ ) result.push("");
    string.replace(rePropName, function(match, number, quote, subString) {
        result.push(quote ? subString.replace(reEscapeChar, "$1") : number || match);
    });
    return result;
});
module.exports = stringToPath;

},{"55f565a895f455e5":"5bPHz"}],"5bPHz":[function(require,module,exports) {
var memoize = require("cb456550b1f5dd0a");
/** Used as the maximum memoize cache size. */ var MAX_MEMOIZE_SIZE = 500;
/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */ function memoizeCapped(func) {
    var result = memoize(func, function(key) {
        if (cache.size === MAX_MEMOIZE_SIZE) cache.clear();
        return key;
    });
    var cache = result.cache;
    return result;
}
module.exports = memoizeCapped;

},{"cb456550b1f5dd0a":"ahhD4"}],"ahhD4":[function(require,module,exports) {
var MapCache = require("b34b26bf235f1cdd");
/** Error message constants. */ var FUNC_ERROR_TEXT = "Expected a function";
/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */ function memoize(func, resolver) {
    if (typeof func != "function" || resolver != null && typeof resolver != "function") throw new TypeError(FUNC_ERROR_TEXT);
    var memoized = function() {
        var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
        if (cache.has(key)) return cache.get(key);
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
    };
    memoized.cache = new (memoize.Cache || MapCache);
    return memoized;
}
// Expose `MapCache`.
memoize.Cache = MapCache;
module.exports = memoize;

},{"b34b26bf235f1cdd":"67IRc"}],"67IRc":[function(require,module,exports) {
var mapCacheClear = require("a5ffecfb6a8bdac1"), mapCacheDelete = require("d2967b0e32ccfa56"), mapCacheGet = require("ca21409ea89624c0"), mapCacheHas = require("f88fd07f8dd1f67d"), mapCacheSet = require("dbf3eae765642a3b");
/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function MapCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype["delete"] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;
module.exports = MapCache;

},{"a5ffecfb6a8bdac1":"bZLK5","d2967b0e32ccfa56":"kHXyp","ca21409ea89624c0":"hS1Js","f88fd07f8dd1f67d":"bP5Zp","dbf3eae765642a3b":"6Akd8"}],"bZLK5":[function(require,module,exports) {
var Hash = require("4ae82d88051cc92b"), ListCache = require("a07dcf3fd3097a0c"), Map = require("92c01c953ef00ded");
/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function mapCacheClear() {
    this.size = 0;
    this.__data__ = {
        "hash": new Hash,
        "map": new (Map || ListCache),
        "string": new Hash
    };
}
module.exports = mapCacheClear;

},{"4ae82d88051cc92b":"8N0eH","a07dcf3fd3097a0c":"ir7KE","92c01c953ef00ded":"lXR3t"}],"8N0eH":[function(require,module,exports) {
var hashClear = require("f47a1723b6e2d79b"), hashDelete = require("bc25d439ccd1fb47"), hashGet = require("f096b37295a92ab0"), hashHas = require("d88173cbc6a133c8"), hashSet = require("afb9b3bae0461cbf");
/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function Hash(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype["delete"] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;
module.exports = Hash;

},{"f47a1723b6e2d79b":"3EYtf","bc25d439ccd1fb47":"FE0rA","f096b37295a92ab0":"6U8zb","d88173cbc6a133c8":"ixguK","afb9b3bae0461cbf":"hrsbU"}],"3EYtf":[function(require,module,exports) {
var nativeCreate = require("dc294230a47ca365");
/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function hashClear() {
    this.__data__ = nativeCreate ? nativeCreate(null) : {};
    this.size = 0;
}
module.exports = hashClear;

},{"dc294230a47ca365":"fvAny"}],"fvAny":[function(require,module,exports) {
var getNative = require("12f496acdffb7cf7");
/* Built-in method references that are verified to be native. */ var nativeCreate = getNative(Object, "create");
module.exports = nativeCreate;

},{"12f496acdffb7cf7":"g9yTj"}],"g9yTj":[function(require,module,exports) {
var baseIsNative = require("63e3f1300cdc459f"), getValue = require("16db51a0e009bd8c");
/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function getNative(object, key) {
    var value = getValue(object, key);
    return baseIsNative(value) ? value : undefined;
}
module.exports = getNative;

},{"63e3f1300cdc459f":"gWgLs","16db51a0e009bd8c":"d6JxY"}],"gWgLs":[function(require,module,exports) {
var isFunction = require("2f9b4543c84c6692"), isMasked = require("cabbc2adfaeb27d9"), isObject = require("cbb5703fe1562e7f"), toSource = require("388b819f47a43aa5");
/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */ var reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used for built-in method references. */ var funcProto = Function.prototype, objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/** Used to detect if a method is native. */ var reIsNative = RegExp("^" + funcToString.call(hasOwnProperty).replace(reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function baseIsNative(value) {
    if (!isObject(value) || isMasked(value)) return false;
    var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
    return pattern.test(toSource(value));
}
module.exports = baseIsNative;

},{"2f9b4543c84c6692":"i4ymb","cabbc2adfaeb27d9":"g1GOZ","cbb5703fe1562e7f":"3TlAp","388b819f47a43aa5":"cLkAM"}],"i4ymb":[function(require,module,exports) {
var baseGetTag = require("5419308bd9194e11"), isObject = require("3cba3c966459d528");
/** `Object#toString` result references. */ var asyncTag = "[object AsyncFunction]", funcTag = "[object Function]", genTag = "[object GeneratorFunction]", proxyTag = "[object Proxy]";
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function isFunction(value) {
    if (!isObject(value)) return false;
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 9 which returns 'object' for typed arrays and other constructors.
    var tag = baseGetTag(value);
    return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}
module.exports = isFunction;

},{"5419308bd9194e11":"fQG2h","3cba3c966459d528":"3TlAp"}],"3TlAp":[function(require,module,exports) {
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function isObject(value) {
    var type = typeof value;
    return value != null && (type == "object" || type == "function");
}
module.exports = isObject;

},{}],"g1GOZ":[function(require,module,exports) {
var coreJsData = require("2fa6c734b0792bcf");
/** Used to detect methods masquerading as native. */ var maskSrcKey = function() {
    var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || "");
    return uid ? "Symbol(src)_1." + uid : "";
}();
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function isMasked(func) {
    return !!maskSrcKey && maskSrcKey in func;
}
module.exports = isMasked;

},{"2fa6c734b0792bcf":"jCWEv"}],"jCWEv":[function(require,module,exports) {
var root = require("2f0959b2c20d7fb0");
/** Used to detect overreaching core-js shims. */ var coreJsData = root["__core-js_shared__"];
module.exports = coreJsData;

},{"2f0959b2c20d7fb0":"iGWPT"}],"cLkAM":[function(require,module,exports) {
/** Used for built-in method references. */ var funcProto = Function.prototype;
/** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */ function toSource(func) {
    if (func != null) {
        try {
            return funcToString.call(func);
        } catch (e) {}
        try {
            return func + "";
        } catch (e) {}
    }
    return "";
}
module.exports = toSource;

},{}],"d6JxY":[function(require,module,exports) {
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function getValue(object, key) {
    return object == null ? undefined : object[key];
}
module.exports = getValue;

},{}],"FE0rA":[function(require,module,exports) {
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function hashDelete(key) {
    var result = this.has(key) && delete this.__data__[key];
    this.size -= result ? 1 : 0;
    return result;
}
module.exports = hashDelete;

},{}],"6U8zb":[function(require,module,exports) {
var nativeCreate = require("627211fa3e1596e1");
/** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = "__lodash_hash_undefined__";
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function hashGet(key) {
    var data = this.__data__;
    if (nativeCreate) {
        var result = data[key];
        return result === HASH_UNDEFINED ? undefined : result;
    }
    return hasOwnProperty.call(data, key) ? data[key] : undefined;
}
module.exports = hashGet;

},{"627211fa3e1596e1":"fvAny"}],"ixguK":[function(require,module,exports) {
var nativeCreate = require("52b3f0bfeddceb45");
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function hashHas(key) {
    var data = this.__data__;
    return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
}
module.exports = hashHas;

},{"52b3f0bfeddceb45":"fvAny"}],"hrsbU":[function(require,module,exports) {
var nativeCreate = require("67b7d10f53ccd515");
/** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = "__lodash_hash_undefined__";
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function hashSet(key, value) {
    var data = this.__data__;
    this.size += this.has(key) ? 0 : 1;
    data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED : value;
    return this;
}
module.exports = hashSet;

},{"67b7d10f53ccd515":"fvAny"}],"ir7KE":[function(require,module,exports) {
var listCacheClear = require("4b1a0d54aed80a7b"), listCacheDelete = require("b700cb849df2c166"), listCacheGet = require("d76dd90eead6cced"), listCacheHas = require("3d210628ba60ec8"), listCacheSet = require("76026bf2d4cfff93");
/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function ListCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype["delete"] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;
module.exports = ListCache;

},{"4b1a0d54aed80a7b":"aBOjQ","b700cb849df2c166":"h9Obe","d76dd90eead6cced":"54rSv","3d210628ba60ec8":"92w7f","76026bf2d4cfff93":"lyKsn"}],"aBOjQ":[function(require,module,exports) {
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function listCacheClear() {
    this.__data__ = [];
    this.size = 0;
}
module.exports = listCacheClear;

},{}],"h9Obe":[function(require,module,exports) {
var assocIndexOf = require("173cad7d48c35f4f");
/** Used for built-in method references. */ var arrayProto = Array.prototype;
/** Built-in value references. */ var splice = arrayProto.splice;
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function listCacheDelete(key) {
    var data = this.__data__, index = assocIndexOf(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else splice.call(data, index, 1);
    --this.size;
    return true;
}
module.exports = listCacheDelete;

},{"173cad7d48c35f4f":"2KENa"}],"2KENa":[function(require,module,exports) {
var eq = require("b38bfe408564f7a5");
/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if (eq(array[length][0], key)) return length;
    }
    return -1;
}
module.exports = assocIndexOf;

},{"b38bfe408564f7a5":"5Gmi2"}],"5Gmi2":[function(require,module,exports) {
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function eq(value, other) {
    return value === other || value !== value && other !== other;
}
module.exports = eq;

},{}],"54rSv":[function(require,module,exports) {
var assocIndexOf = require("c0bae780ed176e2c");
/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function listCacheGet(key) {
    var data = this.__data__, index = assocIndexOf(data, key);
    return index < 0 ? undefined : data[index][1];
}
module.exports = listCacheGet;

},{"c0bae780ed176e2c":"2KENa"}],"92w7f":[function(require,module,exports) {
var assocIndexOf = require("7ed3d4e3adbd64a4");
/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function listCacheHas(key) {
    return assocIndexOf(this.__data__, key) > -1;
}
module.exports = listCacheHas;

},{"7ed3d4e3adbd64a4":"2KENa"}],"lyKsn":[function(require,module,exports) {
var assocIndexOf = require("5be4035c2d7ca432");
/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function listCacheSet(key, value) {
    var data = this.__data__, index = assocIndexOf(data, key);
    if (index < 0) {
        ++this.size;
        data.push([
            key,
            value
        ]);
    } else data[index][1] = value;
    return this;
}
module.exports = listCacheSet;

},{"5be4035c2d7ca432":"2KENa"}],"lXR3t":[function(require,module,exports) {
var getNative = require("ed0752fe9f482107"), root = require("29224713b8d411e6");
/* Built-in method references that are verified to be native. */ var Map = getNative(root, "Map");
module.exports = Map;

},{"ed0752fe9f482107":"g9yTj","29224713b8d411e6":"iGWPT"}],"kHXyp":[function(require,module,exports) {
var getMapData = require("656d8c5510e0af84");
/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function mapCacheDelete(key) {
    var result = getMapData(this, key)["delete"](key);
    this.size -= result ? 1 : 0;
    return result;
}
module.exports = mapCacheDelete;

},{"656d8c5510e0af84":"63JpK"}],"63JpK":[function(require,module,exports) {
var isKeyable = require("adfdd2b4101370ed");
/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function getMapData(map, key) {
    var data = map.__data__;
    return isKeyable(key) ? data[typeof key == "string" ? "string" : "hash"] : data.map;
}
module.exports = getMapData;

},{"adfdd2b4101370ed":"bgeHb"}],"bgeHb":[function(require,module,exports) {
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ function isKeyable(value) {
    var type = typeof value;
    return type == "string" || type == "number" || type == "symbol" || type == "boolean" ? value !== "__proto__" : value === null;
}
module.exports = isKeyable;

},{}],"hS1Js":[function(require,module,exports) {
var getMapData = require("d345cdfee2b4007d");
/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function mapCacheGet(key) {
    return getMapData(this, key).get(key);
}
module.exports = mapCacheGet;

},{"d345cdfee2b4007d":"63JpK"}],"bP5Zp":[function(require,module,exports) {
var getMapData = require("29ebabd55e2d6074");
/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function mapCacheHas(key) {
    return getMapData(this, key).has(key);
}
module.exports = mapCacheHas;

},{"29ebabd55e2d6074":"63JpK"}],"6Akd8":[function(require,module,exports) {
var getMapData = require("21c5ffca56eeb737");
/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function mapCacheSet(key, value) {
    var data = getMapData(this, key), size = data.size;
    data.set(key, value);
    this.size += data.size == size ? 0 : 1;
    return this;
}
module.exports = mapCacheSet;

},{"21c5ffca56eeb737":"63JpK"}],"j8269":[function(require,module,exports) {
var baseToString = require("81fca33832a744d9");
/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */ function toString(value) {
    return value == null ? "" : baseToString(value);
}
module.exports = toString;

},{"81fca33832a744d9":"hnBbf"}],"hnBbf":[function(require,module,exports) {
var Symbol = require("16af83505444e42a"), arrayMap = require("8439a3a1551d0706"), isArray = require("4b12c9f502d3288a"), isSymbol = require("a0ebd327d618908a");
/** Used as references for various `Number` constants. */ var INFINITY = 1 / 0;
/** Used to convert symbols to primitives and strings. */ var symbolProto = Symbol ? Symbol.prototype : undefined, symbolToString = symbolProto ? symbolProto.toString : undefined;
/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */ function baseToString(value) {
    // Exit early for strings to avoid a performance hit in some environments.
    if (typeof value == "string") return value;
    if (isArray(value)) // Recursively convert values (susceptible to call stack limits).
    return arrayMap(value, baseToString) + "";
    if (isSymbol(value)) return symbolToString ? symbolToString.call(value) : "";
    var result = value + "";
    return result == "0" && 1 / value == -INFINITY ? "-0" : result;
}
module.exports = baseToString;

},{"16af83505444e42a":"e0ngr","8439a3a1551d0706":"fahvZ","4b12c9f502d3288a":"2VsjV","a0ebd327d618908a":"3DsXL"}],"fahvZ":[function(require,module,exports) {
/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function arrayMap(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length, result = Array(length);
    while(++index < length)result[index] = iteratee(array[index], index, array);
    return result;
}
module.exports = arrayMap;

},{}],"asnYU":[function(require,module,exports) {
var baseIsArguments = require("b56e5b7d86069686"), isObjectLike = require("bead821d6af018b5");
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/** Built-in value references. */ var propertyIsEnumerable = objectProto.propertyIsEnumerable;
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ var isArguments = baseIsArguments(function() {
    return arguments;
}()) ? baseIsArguments : function(value) {
    return isObjectLike(value) && hasOwnProperty.call(value, "callee") && !propertyIsEnumerable.call(value, "callee");
};
module.exports = isArguments;

},{"b56e5b7d86069686":"crxEa","bead821d6af018b5":"5TH1N"}],"crxEa":[function(require,module,exports) {
var baseGetTag = require("7e8612a4a451f2cc"), isObjectLike = require("b6cdbe52dcf709f8");
/** `Object#toString` result references. */ var argsTag = "[object Arguments]";
/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */ function baseIsArguments(value) {
    return isObjectLike(value) && baseGetTag(value) == argsTag;
}
module.exports = baseIsArguments;

},{"7e8612a4a451f2cc":"fQG2h","b6cdbe52dcf709f8":"5TH1N"}],"9uPJ6":[function(require,module,exports) {
/** Used as references for various `Number` constants. */ var MAX_SAFE_INTEGER = 9007199254740991;
/** Used to detect unsigned integer values. */ var reIsUint = /^(?:0|[1-9]\d*)$/;
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function isIndex(value, length) {
    var type = typeof value;
    length = length == null ? MAX_SAFE_INTEGER : length;
    return !!length && (type == "number" || type != "symbol" && reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
module.exports = isIndex;

},{}],"g5LO3":[function(require,module,exports) {
/** Used as references for various `Number` constants. */ var MAX_SAFE_INTEGER = 9007199254740991;
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function isLength(value) {
    return typeof value == "number" && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}
module.exports = isLength;

},{}],"e9p91":[function(require,module,exports) {
var isSymbol = require("2aed9f6fd4b7386");
/** Used as references for various `Number` constants. */ var INFINITY = 1 / 0;
/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */ function toKey(value) {
    if (typeof value == "string" || isSymbol(value)) return value;
    var result = value + "";
    return result == "0" && 1 / value == -INFINITY ? "-0" : result;
}
module.exports = toKey;

},{"2aed9f6fd4b7386":"3DsXL"}],"1ifri":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
const isSchema = (obj)=>obj && obj.__isYupSchema__;
exports.default = isSchema;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2dXCk":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>runTests);
var _validationError = require("../ValidationError");
var _validationErrorDefault = parcelHelpers.interopDefault(_validationError);
const once = (cb)=>{
    let fired = false;
    return (...args)=>{
        if (fired) return;
        fired = true;
        cb(...args);
    };
};
function runTests(options, cb) {
    let { endEarly, tests, args, value, errors, sort, path } = options;
    let callback = once(cb);
    let count = tests.length;
    const nestedErrors = [];
    errors = errors ? errors : [];
    if (!count) return errors.length ? callback(new (0, _validationErrorDefault.default)(errors, value, path)) : callback(null, value);
    for(let i = 0; i < tests.length; i++){
        const test = tests[i];
        test(args, function finishTestRun(err) {
            if (err) {
                // always return early for non validation errors
                if (!(0, _validationErrorDefault.default).isError(err)) return callback(err, value);
                if (endEarly) {
                    err.value = value;
                    return callback(err, value);
                }
                nestedErrors.push(err);
            }
            if (--count <= 0) {
                if (nestedErrors.length) {
                    if (sort) nestedErrors.sort(sort); //show parent errors after the nested ones: name.first, name
                    if (errors.length) nestedErrors.push(...errors);
                    errors = nestedErrors;
                }
                if (errors.length) {
                    callback(new (0, _validationErrorDefault.default)(errors, value, path), value);
                    return;
                }
                callback(null, value);
            }
        });
    }
}

},{"../ValidationError":"5PgCn","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"5PgCn":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _printValue = require("./util/printValue");
var _printValueDefault = parcelHelpers.interopDefault(_printValue);
var _toArray = require("./util/toArray");
var _toArrayDefault = parcelHelpers.interopDefault(_toArray);
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
let strReg = /\$\{\s*(\w+)\s*\}/g;
class ValidationError extends Error {
    static formatError(message, params) {
        const path = params.label || params.path || "this";
        if (path !== params.path) params = _extends({}, params, {
            path
        });
        if (typeof message === "string") return message.replace(strReg, (_, key)=>(0, _printValueDefault.default)(params[key]));
        if (typeof message === "function") return message(params);
        return message;
    }
    static isError(err) {
        return err && err.name === "ValidationError";
    }
    constructor(errorOrErrors, value, field, type){
        super();
        this.value = void 0;
        this.path = void 0;
        this.type = void 0;
        this.errors = void 0;
        this.params = void 0;
        this.inner = void 0;
        this.name = "ValidationError";
        this.value = value;
        this.path = field;
        this.type = type;
        this.errors = [];
        this.inner = [];
        (0, _toArrayDefault.default)(errorOrErrors).forEach((err)=>{
            if (ValidationError.isError(err)) {
                this.errors.push(...err.errors);
                this.inner = this.inner.concat(err.inner.length ? err.inner : err);
            } else this.errors.push(err);
        });
        this.message = this.errors.length > 1 ? `${this.errors.length} errors occurred` : this.errors[0];
        if (Error.captureStackTrace) Error.captureStackTrace(this, ValidationError);
    }
}
exports.default = ValidationError;

},{"./util/printValue":"kxDKC","./util/toArray":"8ucjw","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8ucjw":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>toArray);
function toArray(value) {
    return value == null ? [] : [].concat(value);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7CPUL":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>createValidation);
var _mapValues = require("lodash/mapValues");
var _mapValuesDefault = parcelHelpers.interopDefault(_mapValues);
var _validationError = require("../ValidationError");
var _validationErrorDefault = parcelHelpers.interopDefault(_validationError);
var _reference = require("../Reference");
var _referenceDefault = parcelHelpers.interopDefault(_reference);
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function createValidation(config) {
    function validate(_ref, cb) {
        let { value, path = "", label, options, originalValue, sync } = _ref, rest = _objectWithoutPropertiesLoose(_ref, [
            "value",
            "path",
            "label",
            "options",
            "originalValue",
            "sync"
        ]);
        const { name, test, params, message } = config;
        let { parent, context } = options;
        function resolve(item) {
            return (0, _referenceDefault.default).isRef(item) ? item.getValue(value, parent, context) : item;
        }
        function createError(overrides = {}) {
            const nextParams = (0, _mapValuesDefault.default)(_extends({
                value,
                originalValue,
                label,
                path: overrides.path || path
            }, params, overrides.params), resolve);
            const error = new (0, _validationErrorDefault.default)((0, _validationErrorDefault.default).formatError(overrides.message || message, nextParams), value, nextParams.path, overrides.type || name);
            error.params = nextParams;
            return error;
        }
        let ctx = _extends({
            path,
            parent,
            type: name,
            createError,
            resolve,
            options,
            originalValue
        }, rest);
        if (!sync) {
            try {
                Promise.resolve(test.call(ctx, value, ctx)).then((validOrError)=>{
                    if ((0, _validationErrorDefault.default).isError(validOrError)) cb(validOrError);
                    else if (!validOrError) cb(createError());
                    else cb(null, validOrError);
                }).catch(cb);
            } catch (err) {
                cb(err);
            }
            return;
        }
        let result;
        try {
            var _ref2;
            result = test.call(ctx, value, ctx);
            if (typeof ((_ref2 = result) == null ? void 0 : _ref2.then) === "function") throw new Error(`Validation test of type: "${ctx.type}" returned a Promise during a synchronous validate. ` + `This test will finish after the validate call has returned`);
        } catch (err) {
            cb(err);
            return;
        }
        if ((0, _validationErrorDefault.default).isError(result)) cb(result);
        else if (!result) cb(createError());
        else cb(null, result);
    }
    validate.OPTIONS = config;
    return validate;
}

},{"lodash/mapValues":"ebIrC","../ValidationError":"5PgCn","../Reference":"cSTlF","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"ebIrC":[function(require,module,exports) {
var baseAssignValue = require("a3dd03284854d1b5"), baseForOwn = require("3fe946fb5f45d4e9"), baseIteratee = require("8671a2b480ab95e2");
/**
 * Creates an object with the same keys as `object` and values generated
 * by running each own enumerable string keyed property of `object` thru
 * `iteratee`. The iteratee is invoked with three arguments:
 * (value, key, object).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Object} Returns the new mapped object.
 * @see _.mapKeys
 * @example
 *
 * var users = {
 *   'fred':    { 'user': 'fred',    'age': 40 },
 *   'pebbles': { 'user': 'pebbles', 'age': 1 }
 * };
 *
 * _.mapValues(users, function(o) { return o.age; });
 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
 *
 * // The `_.property` iteratee shorthand.
 * _.mapValues(users, 'age');
 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
 */ function mapValues(object, iteratee) {
    var result = {};
    iteratee = baseIteratee(iteratee, 3);
    baseForOwn(object, function(value, key, object) {
        baseAssignValue(result, key, iteratee(value, key, object));
    });
    return result;
}
module.exports = mapValues;

},{"a3dd03284854d1b5":"4b75V","3fe946fb5f45d4e9":"jQLMG","8671a2b480ab95e2":"l2cSI"}],"4b75V":[function(require,module,exports) {
var defineProperty = require("57c6267f904aee0a");
/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function baseAssignValue(object, key, value) {
    if (key == "__proto__" && defineProperty) defineProperty(object, key, {
        "configurable": true,
        "enumerable": true,
        "value": value,
        "writable": true
    });
    else object[key] = value;
}
module.exports = baseAssignValue;

},{"57c6267f904aee0a":"51SSX"}],"51SSX":[function(require,module,exports) {
var getNative = require("7565accd8c33cb8b");
var defineProperty = function() {
    try {
        var func = getNative(Object, "defineProperty");
        func({}, "", {});
        return func;
    } catch (e) {}
}();
module.exports = defineProperty;

},{"7565accd8c33cb8b":"g9yTj"}],"jQLMG":[function(require,module,exports) {
var baseFor = require("c7da20818a5fe3d6"), keys = require("1fb77c53defe5720");
/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */ function baseForOwn(object, iteratee) {
    return object && baseFor(object, iteratee, keys);
}
module.exports = baseForOwn;

},{"c7da20818a5fe3d6":"5bb9g","1fb77c53defe5720":"cu4o9"}],"5bb9g":[function(require,module,exports) {
var createBaseFor = require("178c767a7be60d59");
/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */ var baseFor = createBaseFor();
module.exports = baseFor;

},{"178c767a7be60d59":"j0gVu"}],"j0gVu":[function(require,module,exports) {
/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function createBaseFor(fromRight) {
    return function(object, iteratee, keysFunc) {
        var index = -1, iterable = Object(object), props = keysFunc(object), length = props.length;
        while(length--){
            var key = props[fromRight ? length : ++index];
            if (iteratee(iterable[key], key, iterable) === false) break;
        }
        return object;
    };
}
module.exports = createBaseFor;

},{}],"cu4o9":[function(require,module,exports) {
var arrayLikeKeys = require("4c73ca42c789e5ab"), baseKeys = require("e8453365fdacc8da"), isArrayLike = require("7760b47b02971dfa");
/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */ function keys(object) {
    return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}
module.exports = keys;

},{"4c73ca42c789e5ab":"2dYEW","e8453365fdacc8da":"cUzQF","7760b47b02971dfa":"5uWOF"}],"2dYEW":[function(require,module,exports) {
var baseTimes = require("7ed875a0e67be76f"), isArguments = require("9cdb51ffa56f149b"), isArray = require("38cd49f1e493b3d7"), isBuffer = require("b379831fe1873fed"), isIndex = require("f362a34cd8321bb7"), isTypedArray = require("c019db5297494469");
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */ function arrayLikeKeys(value, inherited) {
    var isArr = isArray(value), isArg = !isArr && isArguments(value), isBuff = !isArr && !isArg && isBuffer(value), isType = !isArr && !isArg && !isBuff && isTypedArray(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? baseTimes(value.length, String) : [], length = result.length;
    for(var key in value)if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
    (key == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    isBuff && (key == "offset" || key == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    isType && (key == "buffer" || key == "byteLength" || key == "byteOffset") || // Skip index properties.
    isIndex(key, length)))) result.push(key);
    return result;
}
module.exports = arrayLikeKeys;

},{"7ed875a0e67be76f":"gWKTt","9cdb51ffa56f149b":"asnYU","38cd49f1e493b3d7":"2VsjV","b379831fe1873fed":"kfeDT","f362a34cd8321bb7":"9uPJ6","c019db5297494469":"hUF8Z"}],"gWKTt":[function(require,module,exports) {
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */ function baseTimes(n, iteratee) {
    var index = -1, result = Array(n);
    while(++index < n)result[index] = iteratee(index);
    return result;
}
module.exports = baseTimes;

},{}],"kfeDT":[function(require,module,exports) {
var root = require("cef5ec6f0da1ab00"), stubFalse = require("a1e87b138cf75d1d");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? root.Buffer : undefined;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */ var isBuffer = nativeIsBuffer || stubFalse;
module.exports = isBuffer;

},{"cef5ec6f0da1ab00":"iGWPT","a1e87b138cf75d1d":"9OHNT"}],"9OHNT":[function(require,module,exports) {
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */ function stubFalse() {
    return false;
}
module.exports = stubFalse;

},{}],"hUF8Z":[function(require,module,exports) {
var baseIsTypedArray = require("75a26f037e65be61"), baseUnary = require("903f50eb1c16d257"), nodeUtil = require("fa49853a82034c30");
/* Node.js helper references. */ var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */ var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
module.exports = isTypedArray;

},{"75a26f037e65be61":"9IaoX","903f50eb1c16d257":"993qv","fa49853a82034c30":"ihImP"}],"9IaoX":[function(require,module,exports) {
var baseGetTag = require("67544c3df364a802"), isLength = require("f661b3a120d7a4cb"), isObjectLike = require("cdd86c83797c0618");
/** `Object#toString` result references. */ var argsTag = "[object Arguments]", arrayTag = "[object Array]", boolTag = "[object Boolean]", dateTag = "[object Date]", errorTag = "[object Error]", funcTag = "[object Function]", mapTag = "[object Map]", numberTag = "[object Number]", objectTag = "[object Object]", regexpTag = "[object RegExp]", setTag = "[object Set]", stringTag = "[object String]", weakMapTag = "[object WeakMap]";
var arrayBufferTag = "[object ArrayBuffer]", dataViewTag = "[object DataView]", float32Tag = "[object Float32Array]", float64Tag = "[object Float64Array]", int8Tag = "[object Int8Array]", int16Tag = "[object Int16Array]", int32Tag = "[object Int32Array]", uint8Tag = "[object Uint8Array]", uint8ClampedTag = "[object Uint8ClampedArray]", uint16Tag = "[object Uint16Array]", uint32Tag = "[object Uint32Array]";
/** Used to identify `toStringTag` values of typed arrays. */ var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */ function baseIsTypedArray(value) {
    return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}
module.exports = baseIsTypedArray;

},{"67544c3df364a802":"fQG2h","f661b3a120d7a4cb":"g5LO3","cdd86c83797c0618":"5TH1N"}],"993qv":[function(require,module,exports) {
/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */ function baseUnary(func) {
    return function(value) {
        return func(value);
    };
}
module.exports = baseUnary;

},{}],"ihImP":[function(require,module,exports) {
var freeGlobal = require("94e753dfbe54816e");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && freeGlobal.process;
/** Used to access faster Node.js helpers. */ var nodeUtil = function() {
    try {
        // Use `util.types` for Node.js 10+.
        var types = freeModule && freeModule.require && freeModule.require("util").types;
        if (types) return types;
        // Legacy `process.binding('util')` for Node.js < 10.
        return freeProcess && freeProcess.binding && freeProcess.binding("util");
    } catch (e) {}
}();
module.exports = nodeUtil;

},{"94e753dfbe54816e":"hw1wy"}],"cUzQF":[function(require,module,exports) {
var isPrototype = require("7da6298814f9bd95"), nativeKeys = require("3ec652610d8dd5d3");
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function baseKeys(object) {
    if (!isPrototype(object)) return nativeKeys(object);
    var result = [];
    for(var key in Object(object))if (hasOwnProperty.call(object, key) && key != "constructor") result.push(key);
    return result;
}
module.exports = baseKeys;

},{"7da6298814f9bd95":"hcjX5","3ec652610d8dd5d3":"2HmXG"}],"hcjX5":[function(require,module,exports) {
/** Used for built-in method references. */ var objectProto = Object.prototype;
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */ function isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == "function" && Ctor.prototype || objectProto;
    return value === proto;
}
module.exports = isPrototype;

},{}],"2HmXG":[function(require,module,exports) {
var overArg = require("aa3357c7a3889df");
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeKeys = overArg(Object.keys, Object);
module.exports = nativeKeys;

},{"aa3357c7a3889df":"5rEQb"}],"5rEQb":[function(require,module,exports) {
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
module.exports = overArg;

},{}],"5uWOF":[function(require,module,exports) {
var isFunction = require("bb060d4356645330"), isLength = require("f3db08d4d1110aaf");
/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function isArrayLike(value) {
    return value != null && isLength(value.length) && !isFunction(value);
}
module.exports = isArrayLike;

},{"bb060d4356645330":"i4ymb","f3db08d4d1110aaf":"g5LO3"}],"l2cSI":[function(require,module,exports) {
var baseMatches = require("30aeab910fab669"), baseMatchesProperty = require("4f010869f7b63154"), identity = require("28f06147d1eb9502"), isArray = require("3c56f88c4debf449"), property = require("aee920e0ef5bf111");
/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */ function baseIteratee(value) {
    // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
    // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
    if (typeof value == "function") return value;
    if (value == null) return identity;
    if (typeof value == "object") return isArray(value) ? baseMatchesProperty(value[0], value[1]) : baseMatches(value);
    return property(value);
}
module.exports = baseIteratee;

},{"30aeab910fab669":"1axkc","4f010869f7b63154":"4bdBt","28f06147d1eb9502":"71tSl","3c56f88c4debf449":"2VsjV","aee920e0ef5bf111":"hmrRQ"}],"1axkc":[function(require,module,exports) {
var baseIsMatch = require("e45515c903dc8f87"), getMatchData = require("89e9034a8071e297"), matchesStrictComparable = require("782598b150762386");
/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */ function baseMatches(source) {
    var matchData = getMatchData(source);
    if (matchData.length == 1 && matchData[0][2]) return matchesStrictComparable(matchData[0][0], matchData[0][1]);
    return function(object) {
        return object === source || baseIsMatch(object, source, matchData);
    };
}
module.exports = baseMatches;

},{"e45515c903dc8f87":"iJrlC","89e9034a8071e297":"352C8","782598b150762386":"1bMIB"}],"iJrlC":[function(require,module,exports) {
var Stack = require("ae43062900bf7e4d"), baseIsEqual = require("9003c0cc8ac007b6");
/** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */ function baseIsMatch(object, source, matchData, customizer) {
    var index = matchData.length, length = index, noCustomizer = !customizer;
    if (object == null) return !length;
    object = Object(object);
    while(index--){
        var data = matchData[index];
        if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) return false;
    }
    while(++index < length){
        data = matchData[index];
        var key = data[0], objValue = object[key], srcValue = data[1];
        if (noCustomizer && data[2]) {
            if (objValue === undefined && !(key in object)) return false;
        } else {
            var stack = new Stack;
            if (customizer) var result = customizer(objValue, srcValue, key, object, source, stack);
            if (!(result === undefined ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack) : result)) return false;
        }
    }
    return true;
}
module.exports = baseIsMatch;

},{"ae43062900bf7e4d":"l4EdS","9003c0cc8ac007b6":"dlEAt"}],"l4EdS":[function(require,module,exports) {
var ListCache = require("cfb30a39eead9e7e"), stackClear = require("ceda2a63c77c915"), stackDelete = require("91ee1b348d9d7172"), stackGet = require("3fe28318f65b9332"), stackHas = require("724ca4def8b84e06"), stackSet = require("e9ceacb40d9582bd");
/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function Stack(entries) {
    var data = this.__data__ = new ListCache(entries);
    this.size = data.size;
}
// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype["delete"] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;
module.exports = Stack;

},{"cfb30a39eead9e7e":"ir7KE","ceda2a63c77c915":"92jMT","91ee1b348d9d7172":"2g39u","3fe28318f65b9332":"92pwm","724ca4def8b84e06":"5tWRo","e9ceacb40d9582bd":"8ZwWL"}],"92jMT":[function(require,module,exports) {
var ListCache = require("8a0350213da984ae");
/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */ function stackClear() {
    this.__data__ = new ListCache;
    this.size = 0;
}
module.exports = stackClear;

},{"8a0350213da984ae":"ir7KE"}],"2g39u":[function(require,module,exports) {
/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function stackDelete(key) {
    var data = this.__data__, result = data["delete"](key);
    this.size = data.size;
    return result;
}
module.exports = stackDelete;

},{}],"92pwm":[function(require,module,exports) {
/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function stackGet(key) {
    return this.__data__.get(key);
}
module.exports = stackGet;

},{}],"5tWRo":[function(require,module,exports) {
/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function stackHas(key) {
    return this.__data__.has(key);
}
module.exports = stackHas;

},{}],"8ZwWL":[function(require,module,exports) {
var ListCache = require("4737651e99b917d2"), Map = require("1494efbafafa9552"), MapCache = require("6049e8027fe9407f");
/** Used as the size to enable large array optimizations. */ var LARGE_ARRAY_SIZE = 200;
/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */ function stackSet(key, value) {
    var data = this.__data__;
    if (data instanceof ListCache) {
        var pairs = data.__data__;
        if (!Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
            pairs.push([
                key,
                value
            ]);
            this.size = ++data.size;
            return this;
        }
        data = this.__data__ = new MapCache(pairs);
    }
    data.set(key, value);
    this.size = data.size;
    return this;
}
module.exports = stackSet;

},{"4737651e99b917d2":"ir7KE","1494efbafafa9552":"lXR3t","6049e8027fe9407f":"67IRc"}],"dlEAt":[function(require,module,exports) {
var baseIsEqualDeep = require("bd1d38ebd4028e5a"), isObjectLike = require("809bbb0c20650dbc");
/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */ function baseIsEqual(value, other, bitmask, customizer, stack) {
    if (value === other) return true;
    if (value == null || other == null || !isObjectLike(value) && !isObjectLike(other)) return value !== value && other !== other;
    return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
}
module.exports = baseIsEqual;

},{"bd1d38ebd4028e5a":"r2v0A","809bbb0c20650dbc":"5TH1N"}],"r2v0A":[function(require,module,exports) {
var Stack = require("60c73bca87468e58"), equalArrays = require("96bc8a1825db53a5"), equalByTag = require("8bdece495e87fb69"), equalObjects = require("bb94920432a68eca"), getTag = require("45495edff98e5837"), isArray = require("18256411ae9e2858"), isBuffer = require("e5ba7abf54247fc5"), isTypedArray = require("50d786bb5c7366af");
/** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1;
/** `Object#toString` result references. */ var argsTag = "[object Arguments]", arrayTag = "[object Array]", objectTag = "[object Object]";
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
    var objIsArr = isArray(object), othIsArr = isArray(other), objTag = objIsArr ? arrayTag : getTag(object), othTag = othIsArr ? arrayTag : getTag(other);
    objTag = objTag == argsTag ? objectTag : objTag;
    othTag = othTag == argsTag ? objectTag : othTag;
    var objIsObj = objTag == objectTag, othIsObj = othTag == objectTag, isSameTag = objTag == othTag;
    if (isSameTag && isBuffer(object)) {
        if (!isBuffer(other)) return false;
        objIsArr = true;
        objIsObj = false;
    }
    if (isSameTag && !objIsObj) {
        stack || (stack = new Stack);
        return objIsArr || isTypedArray(object) ? equalArrays(object, other, bitmask, customizer, equalFunc, stack) : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
    }
    if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && hasOwnProperty.call(object, "__wrapped__"), othIsWrapped = othIsObj && hasOwnProperty.call(other, "__wrapped__");
        if (objIsWrapped || othIsWrapped) {
            var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
            stack || (stack = new Stack);
            return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
    }
    if (!isSameTag) return false;
    stack || (stack = new Stack);
    return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}
module.exports = baseIsEqualDeep;

},{"60c73bca87468e58":"l4EdS","96bc8a1825db53a5":"bkKEb","8bdece495e87fb69":"9yVQH","bb94920432a68eca":"dyiCQ","45495edff98e5837":"4Ug8n","18256411ae9e2858":"2VsjV","e5ba7abf54247fc5":"kfeDT","50d786bb5c7366af":"hUF8Z"}],"bkKEb":[function(require,module,exports) {
var SetCache = require("9b110ce138e67ce5"), arraySome = require("1ee20de911db0cb0"), cacheHas = require("defff3d81be91b23");
/** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */ function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
    if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
    // Check that cyclic values are equal.
    var arrStacked = stack.get(array);
    var othStacked = stack.get(other);
    if (arrStacked && othStacked) return arrStacked == other && othStacked == array;
    var index = -1, result = true, seen = bitmask & COMPARE_UNORDERED_FLAG ? new SetCache : undefined;
    stack.set(array, other);
    stack.set(other, array);
    // Ignore non-index properties.
    while(++index < arrLength){
        var arrValue = array[index], othValue = other[index];
        if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
        if (compared !== undefined) {
            if (compared) continue;
            result = false;
            break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
            if (!arraySome(other, function(othValue, othIndex) {
                if (!cacheHas(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) return seen.push(othIndex);
            })) {
                result = false;
                break;
            }
        } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
            result = false;
            break;
        }
    }
    stack["delete"](array);
    stack["delete"](other);
    return result;
}
module.exports = equalArrays;

},{"9b110ce138e67ce5":"8LOJe","1ee20de911db0cb0":"hq9nh","defff3d81be91b23":"tTji9"}],"8LOJe":[function(require,module,exports) {
var MapCache = require("10fe37252553d0bd"), setCacheAdd = require("9a831e81e9a1f98c"), setCacheHas = require("1a2b6c8a7399c39f");
/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */ function SetCache(values) {
    var index = -1, length = values == null ? 0 : values.length;
    this.__data__ = new MapCache;
    while(++index < length)this.add(values[index]);
}
// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;
module.exports = SetCache;

},{"10fe37252553d0bd":"67IRc","9a831e81e9a1f98c":"2MVws","1a2b6c8a7399c39f":"1jkgz"}],"2MVws":[function(require,module,exports) {
/** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = "__lodash_hash_undefined__";
/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */ function setCacheAdd(value) {
    this.__data__.set(value, HASH_UNDEFINED);
    return this;
}
module.exports = setCacheAdd;

},{}],"1jkgz":[function(require,module,exports) {
/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */ function setCacheHas(value) {
    return this.__data__.has(value);
}
module.exports = setCacheHas;

},{}],"hq9nh":[function(require,module,exports) {
/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */ function arraySome(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (predicate(array[index], index, array)) return true;
    }
    return false;
}
module.exports = arraySome;

},{}],"tTji9":[function(require,module,exports) {
/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function cacheHas(cache, key) {
    return cache.has(key);
}
module.exports = cacheHas;

},{}],"9yVQH":[function(require,module,exports) {
var Symbol = require("474c1df4fc722b40"), Uint8Array = require("dbf6aa5033a0f48"), eq = require("539966708f906e61"), equalArrays = require("8142d4017f0a425f"), mapToArray = require("48cddf732eff33ba"), setToArray = require("9dc78b26c5daba20");
/** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
/** `Object#toString` result references. */ var boolTag = "[object Boolean]", dateTag = "[object Date]", errorTag = "[object Error]", mapTag = "[object Map]", numberTag = "[object Number]", regexpTag = "[object RegExp]", setTag = "[object Set]", stringTag = "[object String]", symbolTag = "[object Symbol]";
var arrayBufferTag = "[object ArrayBuffer]", dataViewTag = "[object DataView]";
/** Used to convert symbols to primitives and strings. */ var symbolProto = Symbol ? Symbol.prototype : undefined, symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;
/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
    switch(tag){
        case dataViewTag:
            if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
            object = object.buffer;
            other = other.buffer;
        case arrayBufferTag:
            if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array(object), new Uint8Array(other))) return false;
            return true;
        case boolTag:
        case dateTag:
        case numberTag:
            // Coerce booleans to `1` or `0` and dates to milliseconds.
            // Invalid dates are coerced to `NaN`.
            return eq(+object, +other);
        case errorTag:
            return object.name == other.name && object.message == other.message;
        case regexpTag:
        case stringTag:
            // Coerce regexes to strings and treat strings, primitives and objects,
            // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
            // for more details.
            return object == other + "";
        case mapTag:
            var convert = mapToArray;
        case setTag:
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
            convert || (convert = setToArray);
            if (object.size != other.size && !isPartial) return false;
            // Assume cyclic values are equal.
            var stacked = stack.get(object);
            if (stacked) return stacked == other;
            bitmask |= COMPARE_UNORDERED_FLAG;
            // Recursively compare objects (susceptible to call stack limits).
            stack.set(object, other);
            var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
            stack["delete"](object);
            return result;
        case symbolTag:
            if (symbolValueOf) return symbolValueOf.call(object) == symbolValueOf.call(other);
    }
    return false;
}
module.exports = equalByTag;

},{"474c1df4fc722b40":"e0ngr","dbf6aa5033a0f48":"5fXsE","539966708f906e61":"5Gmi2","8142d4017f0a425f":"bkKEb","48cddf732eff33ba":"fkuVq","9dc78b26c5daba20":"29rq3"}],"5fXsE":[function(require,module,exports) {
var root = require("f755339301d6568f");
/** Built-in value references. */ var Uint8Array = root.Uint8Array;
module.exports = Uint8Array;

},{"f755339301d6568f":"iGWPT"}],"fkuVq":[function(require,module,exports) {
/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */ function mapToArray(map) {
    var index = -1, result = Array(map.size);
    map.forEach(function(value, key) {
        result[++index] = [
            key,
            value
        ];
    });
    return result;
}
module.exports = mapToArray;

},{}],"29rq3":[function(require,module,exports) {
/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */ function setToArray(set) {
    var index = -1, result = Array(set.size);
    set.forEach(function(value) {
        result[++index] = value;
    });
    return result;
}
module.exports = setToArray;

},{}],"dyiCQ":[function(require,module,exports) {
var getAllKeys = require("b911593d305cf4a2");
/** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1;
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & COMPARE_PARTIAL_FLAG, objProps = getAllKeys(object), objLength = objProps.length, othProps = getAllKeys(other), othLength = othProps.length;
    if (objLength != othLength && !isPartial) return false;
    var index = objLength;
    while(index--){
        var key = objProps[index];
        if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) return false;
    }
    // Check that cyclic values are equal.
    var objStacked = stack.get(object);
    var othStacked = stack.get(other);
    if (objStacked && othStacked) return objStacked == other && othStacked == object;
    var result = true;
    stack.set(object, other);
    stack.set(other, object);
    var skipCtor = isPartial;
    while(++index < objLength){
        key = objProps[index];
        var objValue = object[key], othValue = other[key];
        if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
            result = false;
            break;
        }
        skipCtor || (skipCtor = key == "constructor");
    }
    if (result && !skipCtor) {
        var objCtor = object.constructor, othCtor = other.constructor;
        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor && "constructor" in object && "constructor" in other && !(typeof objCtor == "function" && objCtor instanceof objCtor && typeof othCtor == "function" && othCtor instanceof othCtor)) result = false;
    }
    stack["delete"](object);
    stack["delete"](other);
    return result;
}
module.exports = equalObjects;

},{"b911593d305cf4a2":"glOnZ"}],"glOnZ":[function(require,module,exports) {
var baseGetAllKeys = require("c3dbe402f6996a21"), getSymbols = require("aa79b69a13f924db"), keys = require("e3ad83e53433bc8a");
/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function getAllKeys(object) {
    return baseGetAllKeys(object, keys, getSymbols);
}
module.exports = getAllKeys;

},{"c3dbe402f6996a21":"b9Wvk","aa79b69a13f924db":"6Cz6a","e3ad83e53433bc8a":"cu4o9"}],"b9Wvk":[function(require,module,exports) {
var arrayPush = require("abfc70b400ed76c2"), isArray = require("148b85918856c33a");
/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */ function baseGetAllKeys(object, keysFunc, symbolsFunc) {
    var result = keysFunc(object);
    return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}
module.exports = baseGetAllKeys;

},{"abfc70b400ed76c2":"gD9AH","148b85918856c33a":"2VsjV"}],"gD9AH":[function(require,module,exports) {
/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */ function arrayPush(array, values) {
    var index = -1, length = values.length, offset = array.length;
    while(++index < length)array[offset + index] = values[index];
    return array;
}
module.exports = arrayPush;

},{}],"6Cz6a":[function(require,module,exports) {
var arrayFilter = require("7fe025254f0b7e4a"), stubArray = require("6b1c62cea92cdb9");
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Built-in value references. */ var propertyIsEnumerable = objectProto.propertyIsEnumerable;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeGetSymbols = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
    if (object == null) return [];
    object = Object(object);
    return arrayFilter(nativeGetSymbols(object), function(symbol) {
        return propertyIsEnumerable.call(object, symbol);
    });
};
module.exports = getSymbols;

},{"7fe025254f0b7e4a":"hZr2f","6b1c62cea92cdb9":"1ayha"}],"hZr2f":[function(require,module,exports) {
/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */ function arrayFilter(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
    while(++index < length){
        var value = array[index];
        if (predicate(value, index, array)) result[resIndex++] = value;
    }
    return result;
}
module.exports = arrayFilter;

},{}],"1ayha":[function(require,module,exports) {
/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */ function stubArray() {
    return [];
}
module.exports = stubArray;

},{}],"4Ug8n":[function(require,module,exports) {
var DataView = require("7f038695b2fdb86e"), Map = require("28e3344aae951f13"), Promise = require("b286298be5b1d9a4"), Set = require("3ae50c158f89813"), WeakMap = require("9f458755f627d456"), baseGetTag = require("8e9160b373d7fe66"), toSource = require("b210627dd951641f");
/** `Object#toString` result references. */ var mapTag = "[object Map]", objectTag = "[object Object]", promiseTag = "[object Promise]", setTag = "[object Set]", weakMapTag = "[object WeakMap]";
var dataViewTag = "[object DataView]";
/** Used to detect maps, sets, and weakmaps. */ var dataViewCtorString = toSource(DataView), mapCtorString = toSource(Map), promiseCtorString = toSource(Promise), setCtorString = toSource(Set), weakMapCtorString = toSource(WeakMap);
/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ var getTag = baseGetTag;
// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag || Map && getTag(new Map) != mapTag || Promise && getTag(Promise.resolve()) != promiseTag || Set && getTag(new Set) != setTag || WeakMap && getTag(new WeakMap) != weakMapTag) getTag = function(value) {
    var result = baseGetTag(value), Ctor = result == objectTag ? value.constructor : undefined, ctorString = Ctor ? toSource(Ctor) : "";
    if (ctorString) switch(ctorString){
        case dataViewCtorString:
            return dataViewTag;
        case mapCtorString:
            return mapTag;
        case promiseCtorString:
            return promiseTag;
        case setCtorString:
            return setTag;
        case weakMapCtorString:
            return weakMapTag;
    }
    return result;
};
module.exports = getTag;

},{"7f038695b2fdb86e":"lRQg2","28e3344aae951f13":"lXR3t","b286298be5b1d9a4":"gLnFZ","3ae50c158f89813":"9vgKa","9f458755f627d456":"86FKS","8e9160b373d7fe66":"fQG2h","b210627dd951641f":"cLkAM"}],"lRQg2":[function(require,module,exports) {
var getNative = require("a6517d0448dad786"), root = require("f83c375075418382");
/* Built-in method references that are verified to be native. */ var DataView = getNative(root, "DataView");
module.exports = DataView;

},{"a6517d0448dad786":"g9yTj","f83c375075418382":"iGWPT"}],"gLnFZ":[function(require,module,exports) {
var getNative = require("6940648d854355b5"), root = require("a5c6637bac681a0");
/* Built-in method references that are verified to be native. */ var Promise = getNative(root, "Promise");
module.exports = Promise;

},{"6940648d854355b5":"g9yTj","a5c6637bac681a0":"iGWPT"}],"9vgKa":[function(require,module,exports) {
var getNative = require("56b792d64741a4ff"), root = require("ca486d41cdf819d4");
/* Built-in method references that are verified to be native. */ var Set = getNative(root, "Set");
module.exports = Set;

},{"56b792d64741a4ff":"g9yTj","ca486d41cdf819d4":"iGWPT"}],"86FKS":[function(require,module,exports) {
var getNative = require("4507415bd8810d3c"), root = require("7a9a6581834a8452");
/* Built-in method references that are verified to be native. */ var WeakMap = getNative(root, "WeakMap");
module.exports = WeakMap;

},{"4507415bd8810d3c":"g9yTj","7a9a6581834a8452":"iGWPT"}],"352C8":[function(require,module,exports) {
var isStrictComparable = require("8ba18052e16e94fb"), keys = require("94ffded3a85af2f6");
/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */ function getMatchData(object) {
    var result = keys(object), length = result.length;
    while(length--){
        var key = result[length], value = object[key];
        result[length] = [
            key,
            value,
            isStrictComparable(value)
        ];
    }
    return result;
}
module.exports = getMatchData;

},{"8ba18052e16e94fb":"lmVXb","94ffded3a85af2f6":"cu4o9"}],"lmVXb":[function(require,module,exports) {
var isObject = require("be1941f960bbf057");
/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */ function isStrictComparable(value) {
    return value === value && !isObject(value);
}
module.exports = isStrictComparable;

},{"be1941f960bbf057":"3TlAp"}],"1bMIB":[function(require,module,exports) {
/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */ function matchesStrictComparable(key, srcValue) {
    return function(object) {
        if (object == null) return false;
        return object[key] === srcValue && (srcValue !== undefined || key in Object(object));
    };
}
module.exports = matchesStrictComparable;

},{}],"4bdBt":[function(require,module,exports) {
var baseIsEqual = require("cebe22f5ca0827a7"), get = require("d5ca180f7d6f956a"), hasIn = require("3462bb3f546fa1f7"), isKey = require("f5fef07966a1c4ee"), isStrictComparable = require("2a1cd212d48516"), matchesStrictComparable = require("885e72ee7fc6d296"), toKey = require("cd65eaf4a3af29f6");
/** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */ function baseMatchesProperty(path, srcValue) {
    if (isKey(path) && isStrictComparable(srcValue)) return matchesStrictComparable(toKey(path), srcValue);
    return function(object) {
        var objValue = get(object, path);
        return objValue === undefined && objValue === srcValue ? hasIn(object, path) : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
    };
}
module.exports = baseMatchesProperty;

},{"cebe22f5ca0827a7":"dlEAt","d5ca180f7d6f956a":"8z6tS","3462bb3f546fa1f7":"8Kjtp","f5fef07966a1c4ee":"cGRli","2a1cd212d48516":"lmVXb","885e72ee7fc6d296":"1bMIB","cd65eaf4a3af29f6":"e9p91"}],"8z6tS":[function(require,module,exports) {
var baseGet = require("446ba3c1be7939a3");
/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */ function get(object, path, defaultValue) {
    var result = object == null ? undefined : baseGet(object, path);
    return result === undefined ? defaultValue : result;
}
module.exports = get;

},{"446ba3c1be7939a3":"51EsY"}],"51EsY":[function(require,module,exports) {
var castPath = require("434ba191fc1dcf09"), toKey = require("c3296f04fad32769");
/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */ function baseGet(object, path) {
    path = castPath(path, object);
    var index = 0, length = path.length;
    while(object != null && index < length)object = object[toKey(path[index++])];
    return index && index == length ? object : undefined;
}
module.exports = baseGet;

},{"434ba191fc1dcf09":"Q3Xos","c3296f04fad32769":"e9p91"}],"8Kjtp":[function(require,module,exports) {
var baseHasIn = require("9fbd4bb192f3f572"), hasPath = require("b0aefd36de99e579");
/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */ function hasIn(object, path) {
    return object != null && hasPath(object, path, baseHasIn);
}
module.exports = hasIn;

},{"9fbd4bb192f3f572":"eYqz9","b0aefd36de99e579":"fgUQM"}],"eYqz9":[function(require,module,exports) {
/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */ function baseHasIn(object, key) {
    return object != null && key in Object(object);
}
module.exports = baseHasIn;

},{}],"71tSl":[function(require,module,exports) {
/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */ function identity(value) {
    return value;
}
module.exports = identity;

},{}],"hmrRQ":[function(require,module,exports) {
var baseProperty = require("c7f2d79ee4b1c16a"), basePropertyDeep = require("abf31da39349df22"), isKey = require("a387ef4a4373de2c"), toKey = require("9315973458389ae7");
/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */ function property(path) {
    return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
}
module.exports = property;

},{"c7f2d79ee4b1c16a":"1XbWK","abf31da39349df22":"2dhqt","a387ef4a4373de2c":"cGRli","9315973458389ae7":"e9p91"}],"1XbWK":[function(require,module,exports) {
/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */ function baseProperty(key) {
    return function(object) {
        return object == null ? undefined : object[key];
    };
}
module.exports = baseProperty;

},{}],"2dhqt":[function(require,module,exports) {
var baseGet = require("f0f9f03bc3030d02");
/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */ function basePropertyDeep(path) {
    return function(object) {
        return baseGet(object, path);
    };
}
module.exports = basePropertyDeep;

},{"f0f9f03bc3030d02":"51EsY"}],"cSTlF":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "create", ()=>create);
var _propertyExpr = require("property-expr");
const prefixes = {
    context: "$",
    value: "."
};
function create(key, options) {
    return new Reference(key, options);
}
class Reference {
    constructor(key, options = {}){
        this.key = void 0;
        this.isContext = void 0;
        this.isValue = void 0;
        this.isSibling = void 0;
        this.path = void 0;
        this.getter = void 0;
        this.map = void 0;
        if (typeof key !== "string") throw new TypeError("ref must be a string, got: " + key);
        this.key = key.trim();
        if (key === "") throw new TypeError("ref must be a non-empty string");
        this.isContext = this.key[0] === prefixes.context;
        this.isValue = this.key[0] === prefixes.value;
        this.isSibling = !this.isContext && !this.isValue;
        let prefix = this.isContext ? prefixes.context : this.isValue ? prefixes.value : "";
        this.path = this.key.slice(prefix.length);
        this.getter = this.path && (0, _propertyExpr.getter)(this.path, true);
        this.map = options.map;
    }
    getValue(value, parent, context) {
        let result = this.isContext ? context : this.isValue ? value : parent;
        if (this.getter) result = this.getter(result || {});
        if (this.map) result = this.map(result);
        return result;
    }
    /**
   *
   * @param {*} value
   * @param {Object} options
   * @param {Object=} options.context
   * @param {Object=} options.parent
   */ cast(value, options) {
        return this.getValue(value, options == null ? void 0 : options.parent, options == null ? void 0 : options.context);
    }
    resolve() {
        return this;
    }
    describe() {
        return {
            type: "ref",
            key: this.key
        };
    }
    toString() {
        return `Ref(${this.key})`;
    }
    static isRef(value) {
        return value && value.__isYupRef;
    }
} // @ts-ignore
exports.default = Reference;
Reference.prototype.__isYupRef = true;

},{"property-expr":"2ePwL","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2ePwL":[function(require,module,exports) {
/**
 * Based on Kendo UI Core expression code <https://github.com/telerik/kendo-ui-core#license-information>
 */ "use strict";
function Cache(maxSize) {
    this._maxSize = maxSize;
    this.clear();
}
Cache.prototype.clear = function() {
    this._size = 0;
    this._values = Object.create(null);
};
Cache.prototype.get = function(key) {
    return this._values[key];
};
Cache.prototype.set = function(key, value) {
    this._size >= this._maxSize && this.clear();
    if (!(key in this._values)) this._size++;
    return this._values[key] = value;
};
var SPLIT_REGEX = /[^.^\]^[]+|(?=\[\]|\.\.)/g, DIGIT_REGEX = /^\d+$/, LEAD_DIGIT_REGEX = /^\d/, SPEC_CHAR_REGEX = /[~`!#$%\^&*+=\-\[\]\\';,/{}|\\":<>\?]/g, CLEAN_QUOTES_REGEX = /^\s*(['"]?)(.*?)(\1)\s*$/, MAX_CACHE_SIZE = 512;
var pathCache = new Cache(MAX_CACHE_SIZE), setCache = new Cache(MAX_CACHE_SIZE), getCache = new Cache(MAX_CACHE_SIZE);
var config;
module.exports = {
    Cache: Cache,
    split: split,
    normalizePath: normalizePath,
    setter: function(path) {
        var parts = normalizePath(path);
        return setCache.get(path) || setCache.set(path, function setter(obj, value) {
            var index = 0;
            var len = parts.length;
            var data = obj;
            while(index < len - 1){
                var part = parts[index];
                if (part === "__proto__" || part === "constructor" || part === "prototype") return obj;
                data = data[parts[index++]];
            }
            data[parts[index]] = value;
        });
    },
    getter: function(path, safe) {
        var parts = normalizePath(path);
        return getCache.get(path) || getCache.set(path, function getter(data) {
            var index = 0, len = parts.length;
            while(index < len){
                if (data != null || !safe) data = data[parts[index++]];
                else return;
            }
            return data;
        });
    },
    join: function(segments) {
        return segments.reduce(function(path, part) {
            return path + (isQuoted(part) || DIGIT_REGEX.test(part) ? "[" + part + "]" : (path ? "." : "") + part);
        }, "");
    },
    forEach: function(path, cb, thisArg) {
        forEach(Array.isArray(path) ? path : split(path), cb, thisArg);
    }
};
function normalizePath(path) {
    return pathCache.get(path) || pathCache.set(path, split(path).map(function(part) {
        return part.replace(CLEAN_QUOTES_REGEX, "$2");
    }));
}
function split(path) {
    return path.match(SPLIT_REGEX) || [
        ""
    ];
}
function forEach(parts, iter, thisArg) {
    var len = parts.length, part, idx, isArray, isBracket;
    for(idx = 0; idx < len; idx++){
        part = parts[idx];
        if (part) {
            if (shouldBeQuoted(part)) part = '"' + part + '"';
            isBracket = isQuoted(part);
            isArray = !isBracket && /^\d+$/.test(part);
            iter.call(thisArg, part, isBracket, isArray, idx, parts);
        }
    }
}
function isQuoted(str) {
    return typeof str === "string" && str && [
        "'",
        '"'
    ].indexOf(str.charAt(0)) !== -1;
}
function hasLeadingNumber(part) {
    return part.match(LEAD_DIGIT_REGEX) && !part.match(DIGIT_REGEX);
}
function hasSpecialChars(part) {
    return SPEC_CHAR_REGEX.test(part);
}
function shouldBeQuoted(part) {
    return !isQuoted(part) && (hasLeadingNumber(part) || hasSpecialChars(part));
}

},{}],"fRPEz":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getIn", ()=>getIn);
var _propertyExpr = require("property-expr");
let trim = (part)=>part.substr(0, part.length - 1).substr(1);
function getIn(schema, path, value, context = value) {
    let parent, lastPart, lastPartDebug; // root path: ''
    if (!path) return {
        parent,
        parentPath: path,
        schema
    };
    (0, _propertyExpr.forEach)(path, (_part, isBracket, isArray)=>{
        let part = isBracket ? trim(_part) : _part;
        schema = schema.resolve({
            context,
            parent,
            value
        });
        if (schema.innerType) {
            let idx = isArray ? parseInt(part, 10) : 0;
            if (value && idx >= value.length) throw new Error(`Yup.reach cannot resolve an array item at index: ${_part}, in the path: ${path}. ` + `because there is no value at that index. `);
            parent = value;
            value = value && value[idx];
            schema = schema.innerType;
        } // sometimes the array index part of a path doesn't exist: "nested.arr.child"
        // in these cases the current part is the next schema and should be processed
        // in this iteration. For cases where the index signature is included this
        // check will fail and we'll handle the `child` part on the next iteration like normal
        if (!isArray) {
            if (!schema.fields || !schema.fields[part]) throw new Error(`The schema does not contain the path: ${path}. ` + `(failed at: ${lastPartDebug} which is a type: "${schema._type}")`);
            parent = value;
            value = value && value[part];
            schema = schema.fields[part];
        }
        lastPart = part;
        lastPartDebug = isBracket ? "[" + _part + "]" : "." + _part;
    });
    return {
        schema,
        parent,
        parentPath: lastPart
    };
}
const reach = (obj, path, value, context)=>getIn(obj, path, value, context).schema;
exports.default = reach;

},{"property-expr":"2ePwL","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"fTQOC":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _reference = require("../Reference");
var _referenceDefault = parcelHelpers.interopDefault(_reference);
class ReferenceSet {
    constructor(){
        this.list = void 0;
        this.refs = void 0;
        this.list = new Set();
        this.refs = new Map();
    }
    get size() {
        return this.list.size + this.refs.size;
    }
    describe() {
        const description = [];
        for (const item of this.list)description.push(item);
        for (const [, ref] of this.refs)description.push(ref.describe());
        return description;
    }
    toArray() {
        return Array.from(this.list).concat(Array.from(this.refs.values()));
    }
    resolveAll(resolve) {
        return this.toArray().reduce((acc, e)=>acc.concat((0, _referenceDefault.default).isRef(e) ? resolve(e) : e), []);
    }
    add(value) {
        (0, _referenceDefault.default).isRef(value) ? this.refs.set(value.key, value) : this.list.add(value);
    }
    delete(value) {
        (0, _referenceDefault.default).isRef(value) ? this.refs.delete(value.key) : this.list.delete(value);
    }
    clone() {
        const next = new ReferenceSet();
        next.list = new Set(this.list);
        next.refs = new Map(this.refs);
        return next;
    }
    merge(newItems, removeItems) {
        const next = this.clone();
        newItems.list.forEach((value)=>next.add(value));
        newItems.refs.forEach((value)=>next.add(value));
        removeItems.list.forEach((value)=>next.delete(value));
        removeItems.refs.forEach((value)=>next.delete(value));
        return next;
    }
}
exports.default = ReferenceSet;

},{"../Reference":"cSTlF","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"cFehd":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "create", ()=>create);
var _schema = require("./schema");
var _schemaDefault = parcelHelpers.interopDefault(_schema);
var _locale = require("./locale");
var _isAbsent = require("./util/isAbsent");
var _isAbsentDefault = parcelHelpers.interopDefault(_isAbsent);
function create() {
    return new BooleanSchema();
}
class BooleanSchema extends (0, _schemaDefault.default) {
    constructor(){
        super({
            type: "boolean"
        });
        this.withMutation(()=>{
            this.transform(function(value) {
                if (!this.isType(value)) {
                    if (/^(true|1)$/i.test(String(value))) return true;
                    if (/^(false|0)$/i.test(String(value))) return false;
                }
                return value;
            });
        });
    }
    _typeCheck(v) {
        if (v instanceof Boolean) v = v.valueOf();
        return typeof v === "boolean";
    }
    isTrue(message = (0, _locale.boolean).isValue) {
        return this.test({
            message,
            name: "is-value",
            exclusive: true,
            params: {
                value: "true"
            },
            test (value) {
                return (0, _isAbsentDefault.default)(value) || value === true;
            }
        });
    }
    isFalse(message = (0, _locale.boolean).isValue) {
        return this.test({
            message,
            name: "is-value",
            exclusive: true,
            params: {
                value: "false"
            },
            test (value) {
                return (0, _isAbsentDefault.default)(value) || value === false;
            }
        });
    }
}
exports.default = BooleanSchema;
create.prototype = BooleanSchema.prototype;

},{"./schema":"4TARM","./locale":"9pL0N","./util/isAbsent":"74wFR","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"74wFR":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
const isAbsent = (value)=>value == null;
exports.default = isAbsent;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"gaozq":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "create", ()=>create);
var _locale = require("./locale");
var _isAbsent = require("./util/isAbsent");
var _isAbsentDefault = parcelHelpers.interopDefault(_isAbsent);
var _schema = require("./schema"); // eslint-disable-next-line
var _schemaDefault = parcelHelpers.interopDefault(_schema);
let rEmail = /^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))$/i; // eslint-disable-next-line
let rUrl = /^((https?|ftp):)?\/\/(((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:)*@)?(((\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5]))|((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?)(:\d*)?)(\/((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)+(\/(([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)*)*)?)?(\?((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|[\uE000-\uF8FF]|\/|\?)*)?(\#((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|\/|\?)*)?$/i; // eslint-disable-next-line
let rUUID = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;
let isTrimmed = (value)=>(0, _isAbsentDefault.default)(value) || value === value.trim();
let objStringTag = ({}).toString();
function create() {
    return new StringSchema();
}
class StringSchema extends (0, _schemaDefault.default) {
    constructor(){
        super({
            type: "string"
        });
        this.withMutation(()=>{
            this.transform(function(value) {
                if (this.isType(value)) return value;
                if (Array.isArray(value)) return value;
                const strValue = value != null && value.toString ? value.toString() : value;
                if (strValue === objStringTag) return value;
                return strValue;
            });
        });
    }
    _typeCheck(value) {
        if (value instanceof String) value = value.valueOf();
        return typeof value === "string";
    }
    _isPresent(value) {
        return super._isPresent(value) && !!value.length;
    }
    length(length, message = (0, _locale.string).length) {
        return this.test({
            message,
            name: "length",
            exclusive: true,
            params: {
                length
            },
            test (value) {
                return (0, _isAbsentDefault.default)(value) || value.length === this.resolve(length);
            }
        });
    }
    min(min, message = (0, _locale.string).min) {
        return this.test({
            message,
            name: "min",
            exclusive: true,
            params: {
                min
            },
            test (value) {
                return (0, _isAbsentDefault.default)(value) || value.length >= this.resolve(min);
            }
        });
    }
    max(max, message = (0, _locale.string).max) {
        return this.test({
            name: "max",
            exclusive: true,
            message,
            params: {
                max
            },
            test (value) {
                return (0, _isAbsentDefault.default)(value) || value.length <= this.resolve(max);
            }
        });
    }
    matches(regex, options) {
        let excludeEmptyString = false;
        let message;
        let name;
        if (options) {
            if (typeof options === "object") ({ excludeEmptyString = false, message, name } = options);
            else message = options;
        }
        return this.test({
            name: name || "matches",
            message: message || (0, _locale.string).matches,
            params: {
                regex
            },
            test: (value)=>(0, _isAbsentDefault.default)(value) || value === "" && excludeEmptyString || value.search(regex) !== -1
        });
    }
    email(message = (0, _locale.string).email) {
        return this.matches(rEmail, {
            name: "email",
            message,
            excludeEmptyString: true
        });
    }
    url(message = (0, _locale.string).url) {
        return this.matches(rUrl, {
            name: "url",
            message,
            excludeEmptyString: true
        });
    }
    uuid(message = (0, _locale.string).uuid) {
        return this.matches(rUUID, {
            name: "uuid",
            message,
            excludeEmptyString: false
        });
    }
    ensure() {
        return this.default("").transform((val)=>val === null ? "" : val);
    }
    trim(message = (0, _locale.string).trim) {
        return this.transform((val)=>val != null ? val.trim() : val).test({
            message,
            name: "trim",
            test: isTrimmed
        });
    }
    lowercase(message = (0, _locale.string).lowercase) {
        return this.transform((value)=>!(0, _isAbsentDefault.default)(value) ? value.toLowerCase() : value).test({
            message,
            name: "string_case",
            exclusive: true,
            test: (value)=>(0, _isAbsentDefault.default)(value) || value === value.toLowerCase()
        });
    }
    uppercase(message = (0, _locale.string).uppercase) {
        return this.transform((value)=>!(0, _isAbsentDefault.default)(value) ? value.toUpperCase() : value).test({
            message,
            name: "string_case",
            exclusive: true,
            test: (value)=>(0, _isAbsentDefault.default)(value) || value === value.toUpperCase()
        });
    }
}
exports.default = StringSchema;
create.prototype = StringSchema.prototype; //
 // String Interfaces
 //

},{"./locale":"9pL0N","./util/isAbsent":"74wFR","./schema":"4TARM","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"bM9NP":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "create", ()=>create);
var _locale = require("./locale");
var _isAbsent = require("./util/isAbsent");
var _isAbsentDefault = parcelHelpers.interopDefault(_isAbsent);
var _schema = require("./schema");
var _schemaDefault = parcelHelpers.interopDefault(_schema);
let isNaN = (value)=>value != +value;
function create() {
    return new NumberSchema();
}
class NumberSchema extends (0, _schemaDefault.default) {
    constructor(){
        super({
            type: "number"
        });
        this.withMutation(()=>{
            this.transform(function(value) {
                let parsed = value;
                if (typeof parsed === "string") {
                    parsed = parsed.replace(/\s/g, "");
                    if (parsed === "") return NaN; // don't use parseFloat to avoid positives on alpha-numeric strings
                    parsed = +parsed;
                }
                if (this.isType(parsed)) return parsed;
                return parseFloat(parsed);
            });
        });
    }
    _typeCheck(value) {
        if (value instanceof Number) value = value.valueOf();
        return typeof value === "number" && !isNaN(value);
    }
    min(min, message = (0, _locale.number).min) {
        return this.test({
            message,
            name: "min",
            exclusive: true,
            params: {
                min
            },
            test (value) {
                return (0, _isAbsentDefault.default)(value) || value >= this.resolve(min);
            }
        });
    }
    max(max, message = (0, _locale.number).max) {
        return this.test({
            message,
            name: "max",
            exclusive: true,
            params: {
                max
            },
            test (value) {
                return (0, _isAbsentDefault.default)(value) || value <= this.resolve(max);
            }
        });
    }
    lessThan(less, message = (0, _locale.number).lessThan) {
        return this.test({
            message,
            name: "max",
            exclusive: true,
            params: {
                less
            },
            test (value) {
                return (0, _isAbsentDefault.default)(value) || value < this.resolve(less);
            }
        });
    }
    moreThan(more, message = (0, _locale.number).moreThan) {
        return this.test({
            message,
            name: "min",
            exclusive: true,
            params: {
                more
            },
            test (value) {
                return (0, _isAbsentDefault.default)(value) || value > this.resolve(more);
            }
        });
    }
    positive(msg = (0, _locale.number).positive) {
        return this.moreThan(0, msg);
    }
    negative(msg = (0, _locale.number).negative) {
        return this.lessThan(0, msg);
    }
    integer(message = (0, _locale.number).integer) {
        return this.test({
            name: "integer",
            message,
            test: (val)=>(0, _isAbsentDefault.default)(val) || Number.isInteger(val)
        });
    }
    truncate() {
        return this.transform((value)=>!(0, _isAbsentDefault.default)(value) ? value | 0 : value);
    }
    round(method) {
        var _method;
        let avail = [
            "ceil",
            "floor",
            "round",
            "trunc"
        ];
        method = ((_method = method) == null ? void 0 : _method.toLowerCase()) || "round"; // this exists for symemtry with the new Math.trunc
        if (method === "trunc") return this.truncate();
        if (avail.indexOf(method.toLowerCase()) === -1) throw new TypeError("Only valid options for round() are: " + avail.join(", "));
        return this.transform((value)=>!(0, _isAbsentDefault.default)(value) ? Math[method](value) : value);
    }
}
exports.default = NumberSchema;
create.prototype = NumberSchema.prototype; //
 // Number Interfaces
 //

},{"./locale":"9pL0N","./util/isAbsent":"74wFR","./schema":"4TARM","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"l2PQH":[function(require,module,exports) {
// @ts-ignore
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "create", ()=>create);
var _isodate = require("./util/isodate");
var _isodateDefault = parcelHelpers.interopDefault(_isodate);
var _locale = require("./locale");
var _isAbsent = require("./util/isAbsent");
var _isAbsentDefault = parcelHelpers.interopDefault(_isAbsent);
var _reference = require("./Reference");
var _referenceDefault = parcelHelpers.interopDefault(_reference);
var _schema = require("./schema");
var _schemaDefault = parcelHelpers.interopDefault(_schema);
let invalidDate = new Date("");
let isDate = (obj)=>Object.prototype.toString.call(obj) === "[object Date]";
function create() {
    return new DateSchema();
}
class DateSchema extends (0, _schemaDefault.default) {
    constructor(){
        super({
            type: "date"
        });
        this.withMutation(()=>{
            this.transform(function(value) {
                if (this.isType(value)) return value;
                value = (0, _isodateDefault.default)(value); // 0 is a valid timestamp equivalent to 1970-01-01T00:00:00Z(unix epoch) or before.
                return !isNaN(value) ? new Date(value) : invalidDate;
            });
        });
    }
    _typeCheck(v) {
        return isDate(v) && !isNaN(v.getTime());
    }
    prepareParam(ref, name) {
        let param;
        if (!(0, _referenceDefault.default).isRef(ref)) {
            let cast = this.cast(ref);
            if (!this._typeCheck(cast)) throw new TypeError(`\`${name}\` must be a Date or a value that can be \`cast()\` to a Date`);
            param = cast;
        } else param = ref;
        return param;
    }
    min(min, message = (0, _locale.date).min) {
        let limit = this.prepareParam(min, "min");
        return this.test({
            message,
            name: "min",
            exclusive: true,
            params: {
                min
            },
            test (value) {
                return (0, _isAbsentDefault.default)(value) || value >= this.resolve(limit);
            }
        });
    }
    max(max, message = (0, _locale.date).max) {
        let limit = this.prepareParam(max, "max");
        return this.test({
            message,
            name: "max",
            exclusive: true,
            params: {
                max
            },
            test (value) {
                return (0, _isAbsentDefault.default)(value) || value <= this.resolve(limit);
            }
        });
    }
}
exports.default = DateSchema;
DateSchema.INVALID_DATE = invalidDate;
create.prototype = DateSchema.prototype;
create.INVALID_DATE = invalidDate;

},{"./util/isodate":"k2PYD","./locale":"9pL0N","./util/isAbsent":"74wFR","./Reference":"cSTlF","./schema":"4TARM","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"k2PYD":[function(require,module,exports) {
/* eslint-disable */ /**
 *
 * Date.parse with progressive enhancement for ISO 8601 <https://github.com/csnover/js-iso8601>
 * NON-CONFORMANT EDITION.
 * © 2011 Colin Snover <http://zetafleet.com>
 * Released under MIT license.
 */ //              1 YYYY                 2 MM        3 DD              4 HH     5 mm        6 ss            7 msec         8 Z 9 ±    10 tzHH    11 tzmm
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>parseIsoDate);
var isoReg = /^(\d{4}|[+\-]\d{6})(?:-?(\d{2})(?:-?(\d{2}))?)?(?:[ T]?(\d{2}):?(\d{2})(?::?(\d{2})(?:[,\.](\d{1,}))?)?(?:(Z)|([+\-])(\d{2})(?::?(\d{2}))?)?)?$/;
function parseIsoDate(date) {
    var numericKeys = [
        1,
        4,
        5,
        6,
        7,
        10,
        11
    ], minutesOffset = 0, timestamp, struct;
    if (struct = isoReg.exec(date)) {
        // avoid NaN timestamps caused by “undefined” values being passed to Date.UTC
        for(var i = 0, k; k = numericKeys[i]; ++i)struct[k] = +struct[k] || 0; // allow undefined days and months
        struct[2] = (+struct[2] || 1) - 1;
        struct[3] = +struct[3] || 1; // allow arbitrary sub-second precision beyond milliseconds
        struct[7] = struct[7] ? String(struct[7]).substr(0, 3) : 0; // timestamps without timezone identifiers should be considered local time
        if ((struct[8] === undefined || struct[8] === "") && (struct[9] === undefined || struct[9] === "")) timestamp = +new Date(struct[1], struct[2], struct[3], struct[4], struct[5], struct[6], struct[7]);
        else {
            if (struct[8] !== "Z" && struct[9] !== undefined) {
                minutesOffset = struct[10] * 60 + struct[11];
                if (struct[9] === "+") minutesOffset = 0 - minutesOffset;
            }
            timestamp = Date.UTC(struct[1], struct[2], struct[3], struct[4], struct[5] + minutesOffset, struct[6], struct[7]);
        }
    } else timestamp = Date.parse ? Date.parse(date) : NaN;
    return timestamp;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"bL9b5":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "create", ()=>create);
var _has = require("lodash/has");
var _hasDefault = parcelHelpers.interopDefault(_has);
var _snakeCase = require("lodash/snakeCase");
var _snakeCaseDefault = parcelHelpers.interopDefault(_snakeCase);
var _camelCase = require("lodash/camelCase");
var _camelCaseDefault = parcelHelpers.interopDefault(_camelCase);
var _mapKeys = require("lodash/mapKeys");
var _mapKeysDefault = parcelHelpers.interopDefault(_mapKeys);
var _mapValues = require("lodash/mapValues");
var _mapValuesDefault = parcelHelpers.interopDefault(_mapValues);
var _propertyExpr = require("property-expr");
var _locale = require("./locale");
var _sortFields = require("./util/sortFields");
var _sortFieldsDefault = parcelHelpers.interopDefault(_sortFields);
var _sortByKeyOrder = require("./util/sortByKeyOrder");
var _sortByKeyOrderDefault = parcelHelpers.interopDefault(_sortByKeyOrder);
var _runTests = require("./util/runTests");
var _runTestsDefault = parcelHelpers.interopDefault(_runTests);
var _validationError = require("./ValidationError");
var _validationErrorDefault = parcelHelpers.interopDefault(_validationError);
var _schema = require("./schema");
var _schemaDefault = parcelHelpers.interopDefault(_schema);
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
let isObject = (obj)=>Object.prototype.toString.call(obj) === "[object Object]";
function unknown(ctx, value) {
    let known = Object.keys(ctx.fields);
    return Object.keys(value).filter((key)=>known.indexOf(key) === -1);
}
const defaultSort = (0, _sortByKeyOrderDefault.default)([]);
class ObjectSchema extends (0, _schemaDefault.default) {
    constructor(spec){
        super({
            type: "object"
        });
        this.fields = Object.create(null);
        this._sortErrors = defaultSort;
        this._nodes = [];
        this._excludedEdges = [];
        this.withMutation(()=>{
            this.transform(function coerce(value) {
                if (typeof value === "string") try {
                    value = JSON.parse(value);
                } catch (err) {
                    value = null;
                }
                if (this.isType(value)) return value;
                return null;
            });
            if (spec) this.shape(spec);
        });
    }
    _typeCheck(value) {
        return isObject(value) || typeof value === "function";
    }
    _cast(_value, options = {}) {
        var _options$stripUnknown;
        let value = super._cast(_value, options); //should ignore nulls here
        if (value === undefined) return this.getDefault();
        if (!this._typeCheck(value)) return value;
        let fields = this.fields;
        let strip = (_options$stripUnknown = options.stripUnknown) != null ? _options$stripUnknown : this.spec.noUnknown;
        let props = this._nodes.concat(Object.keys(value).filter((v)=>this._nodes.indexOf(v) === -1));
        let intermediateValue = {}; // is filled during the transform below
        let innerOptions = _extends({}, options, {
            parent: intermediateValue,
            __validating: options.__validating || false
        });
        let isChanged = false;
        for (const prop of props){
            let field = fields[prop];
            let exists = (0, _hasDefault.default)(value, prop);
            if (field) {
                let fieldValue;
                let inputValue = value[prop]; // safe to mutate since this is fired in sequence
                innerOptions.path = (options.path ? `${options.path}.` : "") + prop; // innerOptions.value = value[prop];
                field = field.resolve({
                    value: inputValue,
                    context: options.context,
                    parent: intermediateValue
                });
                let fieldSpec = "spec" in field ? field.spec : undefined;
                let strict = fieldSpec == null ? void 0 : fieldSpec.strict;
                if (fieldSpec == null ? void 0 : fieldSpec.strip) {
                    isChanged = isChanged || prop in value;
                    continue;
                }
                fieldValue = !options.__validating || !strict ? field.cast(value[prop], innerOptions) : value[prop];
                if (fieldValue !== undefined) intermediateValue[prop] = fieldValue;
            } else if (exists && !strip) intermediateValue[prop] = value[prop];
            if (intermediateValue[prop] !== value[prop]) isChanged = true;
        }
        return isChanged ? intermediateValue : value;
    }
    _validate(_value, opts = {}, callback) {
        let errors = [];
        let { sync, from = [], originalValue = _value, abortEarly = this.spec.abortEarly, recursive = this.spec.recursive } = opts;
        from = [
            {
                schema: this,
                value: originalValue
            },
            ...from
        ]; // this flag is needed for handling `strict` correctly in the context of
        // validation vs just casting. e.g strict() on a field is only used when validating
        opts.__validating = true;
        opts.originalValue = originalValue;
        opts.from = from;
        super._validate(_value, opts, (err, value)=>{
            if (err) {
                if (!(0, _validationErrorDefault.default).isError(err) || abortEarly) return void callback(err, value);
                errors.push(err);
            }
            if (!recursive || !isObject(value)) {
                callback(errors[0] || null, value);
                return;
            }
            originalValue = originalValue || value;
            let tests = this._nodes.map((key)=>(_, cb)=>{
                    let path = key.indexOf(".") === -1 ? (opts.path ? `${opts.path}.` : "") + key : `${opts.path || ""}["${key}"]`;
                    let field = this.fields[key];
                    if (field && "validate" in field) {
                        field.validate(value[key], _extends({}, opts, {
                            // @ts-ignore
                            path,
                            from,
                            // inner fields are always strict:
                            // 1. this isn't strict so the casting will also have cast inner values
                            // 2. this is strict in which case the nested values weren't cast either
                            strict: true,
                            parent: value,
                            originalValue: originalValue[key]
                        }), cb);
                        return;
                    }
                    cb(null);
                });
            (0, _runTestsDefault.default)({
                sync,
                tests,
                value,
                errors,
                endEarly: abortEarly,
                sort: this._sortErrors,
                path: opts.path
            }, callback);
        });
    }
    clone(spec) {
        const next = super.clone(spec);
        next.fields = _extends({}, this.fields);
        next._nodes = this._nodes;
        next._excludedEdges = this._excludedEdges;
        next._sortErrors = this._sortErrors;
        return next;
    }
    concat(schema) {
        let next = super.concat(schema);
        let nextFields = next.fields;
        for (let [field, schemaOrRef] of Object.entries(this.fields)){
            const target = nextFields[field];
            if (target === undefined) nextFields[field] = schemaOrRef;
            else if (target instanceof (0, _schemaDefault.default) && schemaOrRef instanceof (0, _schemaDefault.default)) nextFields[field] = schemaOrRef.concat(target);
        }
        return next.withMutation(()=>next.shape(nextFields, this._excludedEdges));
    }
    getDefaultFromShape() {
        let dft = {};
        this._nodes.forEach((key)=>{
            const field = this.fields[key];
            dft[key] = "default" in field ? field.getDefault() : undefined;
        });
        return dft;
    }
    _getDefault() {
        if ("default" in this.spec) return super._getDefault();
         // if there is no default set invent one
        if (!this._nodes.length) return undefined;
        return this.getDefaultFromShape();
    }
    shape(additions, excludes = []) {
        let next = this.clone();
        let fields = Object.assign(next.fields, additions);
        next.fields = fields;
        next._sortErrors = (0, _sortByKeyOrderDefault.default)(Object.keys(fields));
        if (excludes.length) {
            // this is a convenience for when users only supply a single pair
            if (!Array.isArray(excludes[0])) excludes = [
                excludes
            ];
            next._excludedEdges = [
                ...next._excludedEdges,
                ...excludes
            ];
        }
        next._nodes = (0, _sortFieldsDefault.default)(fields, next._excludedEdges);
        return next;
    }
    pick(keys) {
        const picked = {};
        for (const key of keys)if (this.fields[key]) picked[key] = this.fields[key];
        return this.clone().withMutation((next)=>{
            next.fields = {};
            return next.shape(picked);
        });
    }
    omit(keys) {
        const next = this.clone();
        const fields = next.fields;
        next.fields = {};
        for (const key of keys)delete fields[key];
        return next.withMutation(()=>next.shape(fields));
    }
    from(from, to, alias) {
        let fromGetter = (0, _propertyExpr.getter)(from, true);
        return this.transform((obj)=>{
            if (obj == null) return obj;
            let newObj = obj;
            if ((0, _hasDefault.default)(obj, from)) {
                newObj = _extends({}, obj);
                if (!alias) delete newObj[from];
                newObj[to] = fromGetter(obj);
            }
            return newObj;
        });
    }
    noUnknown(noAllow = true, message = (0, _locale.object).noUnknown) {
        if (typeof noAllow === "string") {
            message = noAllow;
            noAllow = true;
        }
        let next = this.test({
            name: "noUnknown",
            exclusive: true,
            message: message,
            test (value) {
                if (value == null) return true;
                const unknownKeys = unknown(this.schema, value);
                return !noAllow || unknownKeys.length === 0 || this.createError({
                    params: {
                        unknown: unknownKeys.join(", ")
                    }
                });
            }
        });
        next.spec.noUnknown = noAllow;
        return next;
    }
    unknown(allow = true, message = (0, _locale.object).noUnknown) {
        return this.noUnknown(!allow, message);
    }
    transformKeys(fn) {
        return this.transform((obj)=>obj && (0, _mapKeysDefault.default)(obj, (_, key)=>fn(key)));
    }
    camelCase() {
        return this.transformKeys((0, _camelCaseDefault.default));
    }
    snakeCase() {
        return this.transformKeys((0, _snakeCaseDefault.default));
    }
    constantCase() {
        return this.transformKeys((key)=>(0, _snakeCaseDefault.default)(key).toUpperCase());
    }
    describe() {
        let base = super.describe();
        base.fields = (0, _mapValuesDefault.default)(this.fields, (value)=>value.describe());
        return base;
    }
}
exports.default = ObjectSchema;
function create(spec) {
    return new ObjectSchema(spec);
}
create.prototype = ObjectSchema.prototype;

},{"lodash/has":"7IGwP","lodash/snakeCase":"afSe2","lodash/camelCase":"45Rkc","lodash/mapKeys":"fwGPN","lodash/mapValues":"ebIrC","property-expr":"2ePwL","./locale":"9pL0N","./util/sortFields":"kCL9L","./util/sortByKeyOrder":"lUKCI","./util/runTests":"2dXCk","./ValidationError":"5PgCn","./schema":"4TARM","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"afSe2":[function(require,module,exports) {
var createCompounder = require("ef91f217da7929bd");
/**
 * Converts `string` to
 * [snake case](https://en.wikipedia.org/wiki/Snake_case).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the snake cased string.
 * @example
 *
 * _.snakeCase('Foo Bar');
 * // => 'foo_bar'
 *
 * _.snakeCase('fooBar');
 * // => 'foo_bar'
 *
 * _.snakeCase('--FOO-BAR--');
 * // => 'foo_bar'
 */ var snakeCase = createCompounder(function(result, word, index) {
    return result + (index ? "_" : "") + word.toLowerCase();
});
module.exports = snakeCase;

},{"ef91f217da7929bd":"gjInq"}],"gjInq":[function(require,module,exports) {
var arrayReduce = require("cfc95c8ee08dfd6b"), deburr = require("b60ce6efa81a3cef"), words = require("40ddea9252aefad9");
/** Used to compose unicode capture groups. */ var rsApos = "['’]";
/** Used to match apostrophes. */ var reApos = RegExp(rsApos, "g");
/**
 * Creates a function like `_.camelCase`.
 *
 * @private
 * @param {Function} callback The function to combine each word.
 * @returns {Function} Returns the new compounder function.
 */ function createCompounder(callback) {
    return function(string) {
        return arrayReduce(words(deburr(string).replace(reApos, "")), callback, "");
    };
}
module.exports = createCompounder;

},{"cfc95c8ee08dfd6b":"jYE9T","b60ce6efa81a3cef":"aIVpe","40ddea9252aefad9":"1eYeu"}],"jYE9T":[function(require,module,exports) {
/**
 * A specialized version of `_.reduce` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @param {boolean} [initAccum] Specify using the first element of `array` as
 *  the initial value.
 * @returns {*} Returns the accumulated value.
 */ function arrayReduce(array, iteratee, accumulator, initAccum) {
    var index = -1, length = array == null ? 0 : array.length;
    if (initAccum && length) accumulator = array[++index];
    while(++index < length)accumulator = iteratee(accumulator, array[index], index, array);
    return accumulator;
}
module.exports = arrayReduce;

},{}],"aIVpe":[function(require,module,exports) {
var deburrLetter = require("86c70dfa448b37ae"), toString = require("f68583105b85d455");
/** Used to match Latin Unicode letters (excluding mathematical operators). */ var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
/** Used to compose unicode character classes. */ var rsComboMarksRange = "\\u0300-\\u036f", reComboHalfMarksRange = "\\ufe20-\\ufe2f", rsComboSymbolsRange = "\\u20d0-\\u20ff", rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange;
/** Used to compose unicode capture groups. */ var rsCombo = "[" + rsComboRange + "]";
/**
 * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
 * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
 */ var reComboMark = RegExp(rsCombo, "g");
/**
 * Deburrs `string` by converting
 * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
 * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
 * letters to basic Latin letters and removing
 * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to deburr.
 * @returns {string} Returns the deburred string.
 * @example
 *
 * _.deburr('déjà vu');
 * // => 'deja vu'
 */ function deburr(string) {
    string = toString(string);
    return string && string.replace(reLatin, deburrLetter).replace(reComboMark, "");
}
module.exports = deburr;

},{"86c70dfa448b37ae":"cvpVf","f68583105b85d455":"j8269"}],"cvpVf":[function(require,module,exports) {
var basePropertyOf = require("c95029d8b26d3cfc");
/** Used to map Latin Unicode letters to basic Latin letters. */ var deburredLetters = {
    // Latin-1 Supplement block.
    "\xc0": "A",
    "\xc1": "A",
    "\xc2": "A",
    "\xc3": "A",
    "\xc4": "A",
    "\xc5": "A",
    "\xe0": "a",
    "\xe1": "a",
    "\xe2": "a",
    "\xe3": "a",
    "\xe4": "a",
    "\xe5": "a",
    "\xc7": "C",
    "\xe7": "c",
    "\xd0": "D",
    "\xf0": "d",
    "\xc8": "E",
    "\xc9": "E",
    "\xca": "E",
    "\xcb": "E",
    "\xe8": "e",
    "\xe9": "e",
    "\xea": "e",
    "\xeb": "e",
    "\xcc": "I",
    "\xcd": "I",
    "\xce": "I",
    "\xcf": "I",
    "\xec": "i",
    "\xed": "i",
    "\xee": "i",
    "\xef": "i",
    "\xd1": "N",
    "\xf1": "n",
    "\xd2": "O",
    "\xd3": "O",
    "\xd4": "O",
    "\xd5": "O",
    "\xd6": "O",
    "\xd8": "O",
    "\xf2": "o",
    "\xf3": "o",
    "\xf4": "o",
    "\xf5": "o",
    "\xf6": "o",
    "\xf8": "o",
    "\xd9": "U",
    "\xda": "U",
    "\xdb": "U",
    "\xdc": "U",
    "\xf9": "u",
    "\xfa": "u",
    "\xfb": "u",
    "\xfc": "u",
    "\xdd": "Y",
    "\xfd": "y",
    "\xff": "y",
    "\xc6": "Ae",
    "\xe6": "ae",
    "\xde": "Th",
    "\xfe": "th",
    "\xdf": "ss",
    // Latin Extended-A block.
    "Ā": "A",
    "Ă": "A",
    "Ą": "A",
    "ā": "a",
    "ă": "a",
    "ą": "a",
    "Ć": "C",
    "Ĉ": "C",
    "Ċ": "C",
    "Č": "C",
    "ć": "c",
    "ĉ": "c",
    "ċ": "c",
    "č": "c",
    "Ď": "D",
    "Đ": "D",
    "ď": "d",
    "đ": "d",
    "Ē": "E",
    "Ĕ": "E",
    "Ė": "E",
    "Ę": "E",
    "Ě": "E",
    "ē": "e",
    "ĕ": "e",
    "ė": "e",
    "ę": "e",
    "ě": "e",
    "Ĝ": "G",
    "Ğ": "G",
    "Ġ": "G",
    "Ģ": "G",
    "ĝ": "g",
    "ğ": "g",
    "ġ": "g",
    "ģ": "g",
    "Ĥ": "H",
    "Ħ": "H",
    "ĥ": "h",
    "ħ": "h",
    "Ĩ": "I",
    "Ī": "I",
    "Ĭ": "I",
    "Į": "I",
    "İ": "I",
    "ĩ": "i",
    "ī": "i",
    "ĭ": "i",
    "į": "i",
    "ı": "i",
    "Ĵ": "J",
    "ĵ": "j",
    "Ķ": "K",
    "ķ": "k",
    "ĸ": "k",
    "Ĺ": "L",
    "Ļ": "L",
    "Ľ": "L",
    "Ŀ": "L",
    "Ł": "L",
    "ĺ": "l",
    "ļ": "l",
    "ľ": "l",
    "ŀ": "l",
    "ł": "l",
    "Ń": "N",
    "Ņ": "N",
    "Ň": "N",
    "Ŋ": "N",
    "ń": "n",
    "ņ": "n",
    "ň": "n",
    "ŋ": "n",
    "Ō": "O",
    "Ŏ": "O",
    "Ő": "O",
    "ō": "o",
    "ŏ": "o",
    "ő": "o",
    "Ŕ": "R",
    "Ŗ": "R",
    "Ř": "R",
    "ŕ": "r",
    "ŗ": "r",
    "ř": "r",
    "Ś": "S",
    "Ŝ": "S",
    "Ş": "S",
    "Š": "S",
    "ś": "s",
    "ŝ": "s",
    "ş": "s",
    "š": "s",
    "Ţ": "T",
    "Ť": "T",
    "Ŧ": "T",
    "ţ": "t",
    "ť": "t",
    "ŧ": "t",
    "Ũ": "U",
    "Ū": "U",
    "Ŭ": "U",
    "Ů": "U",
    "Ű": "U",
    "Ų": "U",
    "ũ": "u",
    "ū": "u",
    "ŭ": "u",
    "ů": "u",
    "ű": "u",
    "ų": "u",
    "Ŵ": "W",
    "ŵ": "w",
    "Ŷ": "Y",
    "ŷ": "y",
    "Ÿ": "Y",
    "Ź": "Z",
    "Ż": "Z",
    "Ž": "Z",
    "ź": "z",
    "ż": "z",
    "ž": "z",
    "Ĳ": "IJ",
    "ĳ": "ij",
    "Œ": "Oe",
    "œ": "oe",
    "ŉ": "'n",
    "ſ": "s"
};
/**
 * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
 * letters to basic Latin letters.
 *
 * @private
 * @param {string} letter The matched letter to deburr.
 * @returns {string} Returns the deburred letter.
 */ var deburrLetter = basePropertyOf(deburredLetters);
module.exports = deburrLetter;

},{"c95029d8b26d3cfc":"ltWl4"}],"ltWl4":[function(require,module,exports) {
/**
 * The base implementation of `_.propertyOf` without support for deep paths.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Function} Returns the new accessor function.
 */ function basePropertyOf(object) {
    return function(key) {
        return object == null ? undefined : object[key];
    };
}
module.exports = basePropertyOf;

},{}],"1eYeu":[function(require,module,exports) {
var asciiWords = require("14a2bcc60f9c8c58"), hasUnicodeWord = require("12a5a56673332993"), toString = require("efbc56b55844c665"), unicodeWords = require("e27193a0a134859e");
/**
 * Splits `string` into an array of its words.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to inspect.
 * @param {RegExp|string} [pattern] The pattern to match words.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Array} Returns the words of `string`.
 * @example
 *
 * _.words('fred, barney, & pebbles');
 * // => ['fred', 'barney', 'pebbles']
 *
 * _.words('fred, barney, & pebbles', /[^, ]+/g);
 * // => ['fred', 'barney', '&', 'pebbles']
 */ function words(string, pattern, guard) {
    string = toString(string);
    pattern = guard ? undefined : pattern;
    if (pattern === undefined) return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
    return string.match(pattern) || [];
}
module.exports = words;

},{"14a2bcc60f9c8c58":"eDLv1","12a5a56673332993":"idD7G","efbc56b55844c665":"j8269","e27193a0a134859e":"8cSQv"}],"eDLv1":[function(require,module,exports) {
/** Used to match words composed of alphanumeric characters. */ var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
/**
 * Splits an ASCII `string` into an array of its words.
 *
 * @private
 * @param {string} The string to inspect.
 * @returns {Array} Returns the words of `string`.
 */ function asciiWords(string) {
    return string.match(reAsciiWord) || [];
}
module.exports = asciiWords;

},{}],"idD7G":[function(require,module,exports) {
/** Used to detect strings that need a more robust regexp to match words. */ var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
/**
 * Checks if `string` contains a word composed of Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a word is found, else `false`.
 */ function hasUnicodeWord(string) {
    return reHasUnicodeWord.test(string);
}
module.exports = hasUnicodeWord;

},{}],"8cSQv":[function(require,module,exports) {
/** Used to compose unicode character classes. */ var rsAstralRange = "\ud800-\udfff", rsComboMarksRange = "\\u0300-\\u036f", reComboHalfMarksRange = "\\ufe20-\\ufe2f", rsComboSymbolsRange = "\\u20d0-\\u20ff", rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange, rsDingbatRange = "\\u2700-\\u27bf", rsLowerRange = "a-z\\xdf-\\xf6\\xf8-\\xff", rsMathOpRange = "\\xac\\xb1\\xd7\\xf7", rsNonCharRange = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf", rsPunctuationRange = "\\u2000-\\u206f", rsSpaceRange = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", rsUpperRange = "A-Z\\xc0-\\xd6\\xd8-\\xde", rsVarRange = "\\ufe0e\\ufe0f", rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;
/** Used to compose unicode capture groups. */ var rsApos = "['’]", rsBreak = "[" + rsBreakRange + "]", rsCombo = "[" + rsComboRange + "]", rsDigits = "\\d+", rsDingbat = "[" + rsDingbatRange + "]", rsLower = "[" + rsLowerRange + "]", rsMisc = "[^" + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + "]", rsFitz = "\ud83c[\udffb-\udfff]", rsModifier = "(?:" + rsCombo + "|" + rsFitz + ")", rsNonAstral = "[^" + rsAstralRange + "]", rsRegional = "(?:\ud83c[\udde6-\uddff]){2}", rsSurrPair = "[\ud800-\udbff][\udc00-\udfff]", rsUpper = "[" + rsUpperRange + "]", rsZWJ = "\\u200d";
/** Used to compose unicode regexes. */ var rsMiscLower = "(?:" + rsLower + "|" + rsMisc + ")", rsMiscUpper = "(?:" + rsUpper + "|" + rsMisc + ")", rsOptContrLower = "(?:" + rsApos + "(?:d|ll|m|re|s|t|ve))?", rsOptContrUpper = "(?:" + rsApos + "(?:D|LL|M|RE|S|T|VE))?", reOptMod = rsModifier + "?", rsOptVar = "[" + rsVarRange + "]?", rsOptJoin = "(?:" + rsZWJ + "(?:" + [
    rsNonAstral,
    rsRegional,
    rsSurrPair
].join("|") + ")" + rsOptVar + reOptMod + ")*", rsOrdLower = "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", rsOrdUpper = "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", rsSeq = rsOptVar + reOptMod + rsOptJoin, rsEmoji = "(?:" + [
    rsDingbat,
    rsRegional,
    rsSurrPair
].join("|") + ")" + rsSeq;
/** Used to match complex or compound words. */ var reUnicodeWord = RegExp([
    rsUpper + "?" + rsLower + "+" + rsOptContrLower + "(?=" + [
        rsBreak,
        rsUpper,
        "$"
    ].join("|") + ")",
    rsMiscUpper + "+" + rsOptContrUpper + "(?=" + [
        rsBreak,
        rsUpper + rsMiscLower,
        "$"
    ].join("|") + ")",
    rsUpper + "?" + rsMiscLower + "+" + rsOptContrLower,
    rsUpper + "+" + rsOptContrUpper,
    rsOrdUpper,
    rsOrdLower,
    rsDigits,
    rsEmoji
].join("|"), "g");
/**
 * Splits a Unicode `string` into an array of its words.
 *
 * @private
 * @param {string} The string to inspect.
 * @returns {Array} Returns the words of `string`.
 */ function unicodeWords(string) {
    return string.match(reUnicodeWord) || [];
}
module.exports = unicodeWords;

},{}],"45Rkc":[function(require,module,exports) {
var capitalize = require("d50c843a55705172"), createCompounder = require("9bc393a36713341a");
/**
 * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the camel cased string.
 * @example
 *
 * _.camelCase('Foo Bar');
 * // => 'fooBar'
 *
 * _.camelCase('--foo-bar--');
 * // => 'fooBar'
 *
 * _.camelCase('__FOO_BAR__');
 * // => 'fooBar'
 */ var camelCase = createCompounder(function(result, word, index) {
    word = word.toLowerCase();
    return result + (index ? capitalize(word) : word);
});
module.exports = camelCase;

},{"d50c843a55705172":"dRMZl","9bc393a36713341a":"gjInq"}],"dRMZl":[function(require,module,exports) {
var toString = require("94083a2fb0097719"), upperFirst = require("e8384184eda4212f");
/**
 * Converts the first character of `string` to upper case and the remaining
 * to lower case.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to capitalize.
 * @returns {string} Returns the capitalized string.
 * @example
 *
 * _.capitalize('FRED');
 * // => 'Fred'
 */ function capitalize(string) {
    return upperFirst(toString(string).toLowerCase());
}
module.exports = capitalize;

},{"94083a2fb0097719":"j8269","e8384184eda4212f":"bnMOy"}],"bnMOy":[function(require,module,exports) {
var createCaseFirst = require("9f71ec962d19127");
/**
 * Converts the first character of `string` to upper case.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.upperFirst('fred');
 * // => 'Fred'
 *
 * _.upperFirst('FRED');
 * // => 'FRED'
 */ var upperFirst = createCaseFirst("toUpperCase");
module.exports = upperFirst;

},{"9f71ec962d19127":"1K9kx"}],"1K9kx":[function(require,module,exports) {
var castSlice = require("6cc0e53be1623a5f"), hasUnicode = require("e28707473345265"), stringToArray = require("32980b84821a53a0"), toString = require("e00796f8e204e98");
/**
 * Creates a function like `_.lowerFirst`.
 *
 * @private
 * @param {string} methodName The name of the `String` case method to use.
 * @returns {Function} Returns the new case function.
 */ function createCaseFirst(methodName) {
    return function(string) {
        string = toString(string);
        var strSymbols = hasUnicode(string) ? stringToArray(string) : undefined;
        var chr = strSymbols ? strSymbols[0] : string.charAt(0);
        var trailing = strSymbols ? castSlice(strSymbols, 1).join("") : string.slice(1);
        return chr[methodName]() + trailing;
    };
}
module.exports = createCaseFirst;

},{"6cc0e53be1623a5f":"27qxl","e28707473345265":"1DrMq","32980b84821a53a0":"a3v2P","e00796f8e204e98":"j8269"}],"27qxl":[function(require,module,exports) {
var baseSlice = require("19fbc2ab8fa927cd");
/**
 * Casts `array` to a slice if it's needed.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {number} start The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the cast slice.
 */ function castSlice(array, start, end) {
    var length = array.length;
    end = end === undefined ? length : end;
    return !start && end >= length ? array : baseSlice(array, start, end);
}
module.exports = castSlice;

},{"19fbc2ab8fa927cd":"5Vnb5"}],"5Vnb5":[function(require,module,exports) {
/**
 * The base implementation of `_.slice` without an iteratee call guard.
 *
 * @private
 * @param {Array} array The array to slice.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the slice of `array`.
 */ function baseSlice(array, start, end) {
    var index = -1, length = array.length;
    if (start < 0) start = -start > length ? 0 : length + start;
    end = end > length ? length : end;
    if (end < 0) end += length;
    length = start > end ? 0 : end - start >>> 0;
    start >>>= 0;
    var result = Array(length);
    while(++index < length)result[index] = array[index + start];
    return result;
}
module.exports = baseSlice;

},{}],"1DrMq":[function(require,module,exports) {
/** Used to compose unicode character classes. */ var rsAstralRange = "\ud800-\udfff", rsComboMarksRange = "\\u0300-\\u036f", reComboHalfMarksRange = "\\ufe20-\\ufe2f", rsComboSymbolsRange = "\\u20d0-\\u20ff", rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange, rsVarRange = "\\ufe0e\\ufe0f";
/** Used to compose unicode capture groups. */ var rsZWJ = "\\u200d";
/** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */ var reHasUnicode = RegExp("[" + rsZWJ + rsAstralRange + rsComboRange + rsVarRange + "]");
/**
 * Checks if `string` contains Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a symbol is found, else `false`.
 */ function hasUnicode(string) {
    return reHasUnicode.test(string);
}
module.exports = hasUnicode;

},{}],"a3v2P":[function(require,module,exports) {
var asciiToArray = require("55ec07d60faf873c"), hasUnicode = require("d3e31b390208b2ca"), unicodeToArray = require("2a468ebcd49732b9");
/**
 * Converts `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */ function stringToArray(string) {
    return hasUnicode(string) ? unicodeToArray(string) : asciiToArray(string);
}
module.exports = stringToArray;

},{"55ec07d60faf873c":"dpPcY","d3e31b390208b2ca":"1DrMq","2a468ebcd49732b9":"9YZEy"}],"dpPcY":[function(require,module,exports) {
/**
 * Converts an ASCII `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */ function asciiToArray(string) {
    return string.split("");
}
module.exports = asciiToArray;

},{}],"9YZEy":[function(require,module,exports) {
/** Used to compose unicode character classes. */ var rsAstralRange = "\ud800-\udfff", rsComboMarksRange = "\\u0300-\\u036f", reComboHalfMarksRange = "\\ufe20-\\ufe2f", rsComboSymbolsRange = "\\u20d0-\\u20ff", rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange, rsVarRange = "\\ufe0e\\ufe0f";
/** Used to compose unicode capture groups. */ var rsAstral = "[" + rsAstralRange + "]", rsCombo = "[" + rsComboRange + "]", rsFitz = "\ud83c[\udffb-\udfff]", rsModifier = "(?:" + rsCombo + "|" + rsFitz + ")", rsNonAstral = "[^" + rsAstralRange + "]", rsRegional = "(?:\ud83c[\udde6-\uddff]){2}", rsSurrPair = "[\ud800-\udbff][\udc00-\udfff]", rsZWJ = "\\u200d";
/** Used to compose unicode regexes. */ var reOptMod = rsModifier + "?", rsOptVar = "[" + rsVarRange + "]?", rsOptJoin = "(?:" + rsZWJ + "(?:" + [
    rsNonAstral,
    rsRegional,
    rsSurrPair
].join("|") + ")" + rsOptVar + reOptMod + ")*", rsSeq = rsOptVar + reOptMod + rsOptJoin, rsSymbol = "(?:" + [
    rsNonAstral + rsCombo + "?",
    rsCombo,
    rsRegional,
    rsSurrPair,
    rsAstral
].join("|") + ")";
/** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */ var reUnicode = RegExp(rsFitz + "(?=" + rsFitz + ")|" + rsSymbol + rsSeq, "g");
/**
 * Converts a Unicode `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */ function unicodeToArray(string) {
    return string.match(reUnicode) || [];
}
module.exports = unicodeToArray;

},{}],"fwGPN":[function(require,module,exports) {
var baseAssignValue = require("e358a2257ea2e47c"), baseForOwn = require("1fef9dca3aa2f1c4"), baseIteratee = require("165885217aefb546");
/**
 * The opposite of `_.mapValues`; this method creates an object with the
 * same values as `object` and keys generated by running each own enumerable
 * string keyed property of `object` thru `iteratee`. The iteratee is invoked
 * with three arguments: (value, key, object).
 *
 * @static
 * @memberOf _
 * @since 3.8.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Object} Returns the new mapped object.
 * @see _.mapValues
 * @example
 *
 * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
 *   return key + value;
 * });
 * // => { 'a1': 1, 'b2': 2 }
 */ function mapKeys(object, iteratee) {
    var result = {};
    iteratee = baseIteratee(iteratee, 3);
    baseForOwn(object, function(value, key, object) {
        baseAssignValue(result, iteratee(value, key, object), value);
    });
    return result;
}
module.exports = mapKeys;

},{"e358a2257ea2e47c":"4b75V","1fef9dca3aa2f1c4":"jQLMG","165885217aefb546":"l2cSI"}],"kCL9L":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>sortFields);
var _has = require("lodash/has"); // @ts-expect-error
var _hasDefault = parcelHelpers.interopDefault(_has);
var _toposort = require("toposort");
var _toposortDefault = parcelHelpers.interopDefault(_toposort);
var _propertyExpr = require("property-expr");
var _reference = require("../Reference");
var _referenceDefault = parcelHelpers.interopDefault(_reference);
var _isSchema = require("./isSchema");
var _isSchemaDefault = parcelHelpers.interopDefault(_isSchema);
function sortFields(fields, excludedEdges = []) {
    let edges = [];
    let nodes = new Set();
    let excludes = new Set(excludedEdges.map(([a, b])=>`${a}-${b}`));
    function addNode(depPath, key) {
        let node = (0, _propertyExpr.split)(depPath)[0];
        nodes.add(node);
        if (!excludes.has(`${key}-${node}`)) edges.push([
            key,
            node
        ]);
    }
    for(const key in fields)if ((0, _hasDefault.default)(fields, key)) {
        let value = fields[key];
        nodes.add(key);
        if ((0, _referenceDefault.default).isRef(value) && value.isSibling) addNode(value.path, key);
        else if ((0, _isSchemaDefault.default)(value) && "deps" in value) value.deps.forEach((path)=>addNode(path, key));
    }
    return (0, _toposortDefault.default).array(Array.from(nodes), edges).reverse();
}

},{"lodash/has":"7IGwP","toposort":"gnd0B","property-expr":"2ePwL","../Reference":"cSTlF","./isSchema":"1ifri","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"gnd0B":[function(require,module,exports) {
/**
 * Topological sorting function
 *
 * @param {Array} edges
 * @returns {Array}
 */ module.exports = function(edges) {
    return toposort(uniqueNodes(edges), edges);
};
module.exports.array = toposort;
function toposort(nodes, edges) {
    var cursor = nodes.length, sorted = new Array(cursor), visited = {}, i = cursor, outgoingEdges = makeOutgoingEdges(edges), nodesHash = makeNodesHash(nodes);
    // check for unknown nodes
    edges.forEach(function(edge) {
        if (!nodesHash.has(edge[0]) || !nodesHash.has(edge[1])) throw new Error("Unknown node. There is an unknown node in the supplied edges.");
    });
    while(i--)if (!visited[i]) visit(nodes[i], i, new Set());
    return sorted;
    function visit(node, i, predecessors) {
        if (predecessors.has(node)) {
            var nodeRep;
            try {
                nodeRep = ", node was:" + JSON.stringify(node);
            } catch (e) {
                nodeRep = "";
            }
            throw new Error("Cyclic dependency" + nodeRep);
        }
        if (!nodesHash.has(node)) throw new Error("Found unknown node. Make sure to provided all involved nodes. Unknown node: " + JSON.stringify(node));
        if (visited[i]) return;
        visited[i] = true;
        var outgoing = outgoingEdges.get(node) || new Set();
        outgoing = Array.from(outgoing);
        if (i = outgoing.length) {
            predecessors.add(node);
            do {
                var child = outgoing[--i];
                visit(child, nodesHash.get(child), predecessors);
            }while (i);
            predecessors.delete(node);
        }
        sorted[--cursor] = node;
    }
}
function uniqueNodes(arr) {
    var res = new Set();
    for(var i = 0, len = arr.length; i < len; i++){
        var edge = arr[i];
        res.add(edge[0]);
        res.add(edge[1]);
    }
    return Array.from(res);
}
function makeOutgoingEdges(arr) {
    var edges = new Map();
    for(var i = 0, len = arr.length; i < len; i++){
        var edge = arr[i];
        if (!edges.has(edge[0])) edges.set(edge[0], new Set());
        if (!edges.has(edge[1])) edges.set(edge[1], new Set());
        edges.get(edge[0]).add(edge[1]);
    }
    return edges;
}
function makeNodesHash(arr) {
    var res = new Map();
    for(var i = 0, len = arr.length; i < len; i++)res.set(arr[i], i);
    return res;
}

},{}],"lUKCI":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>sortByKeyOrder);
function findIndex(arr, err) {
    let idx = Infinity;
    arr.some((key, ii)=>{
        var _err$path;
        if (((_err$path = err.path) == null ? void 0 : _err$path.indexOf(key)) !== -1) {
            idx = ii;
            return true;
        }
    });
    return idx;
}
function sortByKeyOrder(keys) {
    return (a, b)=>{
        return findIndex(keys, a) - findIndex(keys, b);
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"79GJQ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "create", ()=>create);
var _isAbsent = require("./util/isAbsent");
var _isAbsentDefault = parcelHelpers.interopDefault(_isAbsent);
var _isSchema = require("./util/isSchema");
var _isSchemaDefault = parcelHelpers.interopDefault(_isSchema);
var _printValue = require("./util/printValue");
var _printValueDefault = parcelHelpers.interopDefault(_printValue);
var _locale = require("./locale");
var _runTests = require("./util/runTests");
var _runTestsDefault = parcelHelpers.interopDefault(_runTests);
var _validationError = require("./ValidationError");
var _validationErrorDefault = parcelHelpers.interopDefault(_validationError);
var _schema = require("./schema");
var _schemaDefault = parcelHelpers.interopDefault(_schema);
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function create(type) {
    return new ArraySchema(type);
}
class ArraySchema extends (0, _schemaDefault.default) {
    constructor(type){
        super({
            type: "array"
        }); // `undefined` specifically means uninitialized, as opposed to
        // "no subtype"
        this.innerType = void 0;
        this.innerType = type;
        this.withMutation(()=>{
            this.transform(function(values) {
                if (typeof values === "string") try {
                    values = JSON.parse(values);
                } catch (err) {
                    values = null;
                }
                return this.isType(values) ? values : null;
            });
        });
    }
    _typeCheck(v) {
        return Array.isArray(v);
    }
    get _subType() {
        return this.innerType;
    }
    _cast(_value, _opts) {
        const value = super._cast(_value, _opts); //should ignore nulls here
        if (!this._typeCheck(value) || !this.innerType) return value;
        let isChanged = false;
        const castArray = value.map((v, idx)=>{
            const castElement = this.innerType.cast(v, _extends({}, _opts, {
                path: `${_opts.path || ""}[${idx}]`
            }));
            if (castElement !== v) isChanged = true;
            return castElement;
        });
        return isChanged ? castArray : value;
    }
    _validate(_value, options = {}, callback) {
        var _options$abortEarly, _options$recursive;
        let errors = [];
        let sync = options.sync;
        let path = options.path;
        let innerType = this.innerType;
        let endEarly = (_options$abortEarly = options.abortEarly) != null ? _options$abortEarly : this.spec.abortEarly;
        let recursive = (_options$recursive = options.recursive) != null ? _options$recursive : this.spec.recursive;
        let originalValue = options.originalValue != null ? options.originalValue : _value;
        super._validate(_value, options, (err, value)=>{
            if (err) {
                if (!(0, _validationErrorDefault.default).isError(err) || endEarly) return void callback(err, value);
                errors.push(err);
            }
            if (!recursive || !innerType || !this._typeCheck(value)) {
                callback(errors[0] || null, value);
                return;
            }
            originalValue = originalValue || value; // #950 Ensure that sparse array empty slots are validated
            let tests = new Array(value.length);
            for(let idx = 0; idx < value.length; idx++){
                let item = value[idx];
                let path = `${options.path || ""}[${idx}]`; // object._validate note for isStrict explanation
                let innerOptions = _extends({}, options, {
                    path,
                    strict: true,
                    parent: value,
                    index: idx,
                    originalValue: originalValue[idx]
                });
                tests[idx] = (_, cb)=>innerType.validate(item, innerOptions, cb);
            }
            (0, _runTestsDefault.default)({
                sync,
                path,
                value,
                errors,
                endEarly,
                tests
            }, callback);
        });
    }
    clone(spec) {
        const next = super.clone(spec);
        next.innerType = this.innerType;
        return next;
    }
    concat(schema) {
        let next = super.concat(schema);
        next.innerType = this.innerType;
        if (schema.innerType) next.innerType = next.innerType ? next.innerType.concat(schema.innerType) : schema.innerType;
        return next;
    }
    of(schema) {
        // FIXME: this should return a new instance of array without the default to be
        let next = this.clone();
        if (!(0, _isSchemaDefault.default)(schema)) throw new TypeError("`array.of()` sub-schema must be a valid yup schema not: " + (0, _printValueDefault.default)(schema)); // FIXME(ts):
        next.innerType = schema;
        return next;
    }
    length(length, message = (0, _locale.array).length) {
        return this.test({
            message,
            name: "length",
            exclusive: true,
            params: {
                length
            },
            test (value) {
                return (0, _isAbsentDefault.default)(value) || value.length === this.resolve(length);
            }
        });
    }
    min(min, message) {
        message = message || (0, _locale.array).min;
        return this.test({
            message,
            name: "min",
            exclusive: true,
            params: {
                min
            },
            // FIXME(ts): Array<typeof T>
            test (value) {
                return (0, _isAbsentDefault.default)(value) || value.length >= this.resolve(min);
            }
        });
    }
    max(max, message) {
        message = message || (0, _locale.array).max;
        return this.test({
            message,
            name: "max",
            exclusive: true,
            params: {
                max
            },
            test (value) {
                return (0, _isAbsentDefault.default)(value) || value.length <= this.resolve(max);
            }
        });
    }
    ensure() {
        return this.default(()=>[]).transform((val, original)=>{
            // We don't want to return `null` for nullable schema
            if (this._typeCheck(val)) return val;
            return original == null ? [] : [].concat(original);
        });
    }
    compact(rejector) {
        let reject = !rejector ? (v)=>!!v : (v, i, a)=>!rejector(v, i, a);
        return this.transform((values)=>values != null ? values.filter(reject) : values);
    }
    describe() {
        let base = super.describe();
        if (this.innerType) base.innerType = this.innerType.describe();
        return base;
    }
    nullable(isNullable = true) {
        return super.nullable(isNullable);
    }
    defined() {
        return super.defined();
    }
    required(msg) {
        return super.required(msg);
    }
}
exports.default = ArraySchema;
create.prototype = ArraySchema.prototype; //
 // Interfaces
 //

},{"./util/isAbsent":"74wFR","./util/isSchema":"1ifri","./util/printValue":"kxDKC","./locale":"9pL0N","./util/runTests":"2dXCk","./ValidationError":"5PgCn","./schema":"4TARM","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"fisrl":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "create", ()=>create);
var _isSchema = require("./util/isSchema");
var _isSchemaDefault = parcelHelpers.interopDefault(_isSchema);
function create(builder) {
    return new Lazy(builder);
}
class Lazy {
    constructor(builder){
        this.type = "lazy";
        this.__isYupSchema__ = true;
        this.__inputType = void 0;
        this.__outputType = void 0;
        this._resolve = (value, options = {})=>{
            let schema = this.builder(value, options);
            if (!(0, _isSchemaDefault.default)(schema)) throw new TypeError("lazy() functions must return a valid schema");
            return schema.resolve(options);
        };
        this.builder = builder;
    }
    resolve(options) {
        return this._resolve(options.value, options);
    }
    cast(value, options) {
        return this._resolve(value, options).cast(value, options);
    }
    validate(value, options, maybeCb) {
        // @ts-expect-error missing public callback on type
        return this._resolve(value, options).validate(value, options, maybeCb);
    }
    validateSync(value, options) {
        return this._resolve(value, options).validateSync(value, options);
    }
    validateAt(path, value, options) {
        return this._resolve(value, options).validateAt(path, value, options);
    }
    validateSyncAt(path, value, options) {
        return this._resolve(value, options).validateSyncAt(path, value, options);
    }
    describe() {
        return null;
    }
    isValid(value, options) {
        return this._resolve(value, options).isValid(value, options);
    }
    isValidSync(value, options) {
        return this._resolve(value, options).isValidSync(value, options);
    }
}
exports.default = Lazy;

},{"./util/isSchema":"1ifri","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7QEUR":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>setLocale);
var _locale = require("./locale");
var _localeDefault = parcelHelpers.interopDefault(_locale);
function setLocale(custom) {
    Object.keys(custom).forEach((type)=>{
        // @ts-ignore
        Object.keys(custom[type]).forEach((method)=>{
            // @ts-ignore
            (0, _localeDefault.default)[type][method] = custom[type][method];
        });
    });
}

},{"./locale":"9pL0N","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7a7bh":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _formik = require("formik");
var _colors = require("../../constants/colors");
var _fieldError = require("./FieldError");
var _fieldErrorDefault = parcelHelpers.interopDefault(_fieldError);
var _button = require("../general/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _iconTooltip = require("../general/IconTooltip");
var _iconTooltipDefault = parcelHelpers.interopDefault(_iconTooltip);
var _verticalSeparator = require("../structure/VerticalSeparator");
var _verticalSeparatorDefault = parcelHelpers.interopDefault(_verticalSeparator);
var _tooltipWrapper = require("../general/TooltipWrapper");
var _tooltipWrapperDefault = parcelHelpers.interopDefault(_tooltipWrapper);
var _breakpoints = require("../../constants/breakpoints");
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const deleteIcon = require("6ea6afe0e613f5d7");
// component used in building forms with consistent components for look and function
const TextField = (props)=>{
    const suggestionsStyle = /*#__PURE__*/ (0, _css.css)("position:absolute;margin-top:12px;background:white;width:400px;border-radius:8px;.suggestion{font-size:14px;line-height:20px;color:", (0, _colors.color_shades_darkest), ";border-bottom:1px solid ", (0, _colors.color_shades_dark), ";border-left:1px solid ", (0, _colors.color_shades_dark), ";border-right:1px solid ", (0, _colors.color_shades_dark), ";padding:14px 16px;background:white;cursor:pointer;&.first{border-top:1px solid ", (0, _colors.color_shades_dark), ";border-top-left-radius:8px;border-top-right-radius:8px;}&.last{border-bottom-left-radius:8px;border-bottom-right-radius:8px;}&.focused-suggestion{background:", (0, _colors.color_variants_ocean_light_opaque), ";}&:hover{background:", (0, _colors.color_variants_ocean_light_opaque), ";}}.arrow{border-left:solid 1px ", (0, _colors.color_shades_dark), ";background:white;border-top:solid 1px ", (0, _colors.color_shades_dark), ";transform:rotate(45deg);position:absolute;width:9px;height:9px;top:-4px;left:20px;&.hovered{background:", (0, _colors.color_variants_ocean_light_opaque), ";}}", "");
    const textFieldStyles = /*#__PURE__*/ (0, _css.css)("color:", (0, _colors.dark_grey_blue), ";font-family:Muli;font-size:", props?.fontSize ?? 14, "px;text-align:left;width:100%;border-radius:5px;border:none;padding:12px 16px;background:transparent;::placeholder{font-weight:normal;font-style:italic;letter-spacing:normal;color:", (0, _colors.color_shades_darker), ";}", "");
    const containerStyle = /*#__PURE__*/ (0, _css.css)({
        name: "11j4wuo",
        styles: "margin-bottom:24px;flex:1;&.tight{margin-bottom:16px;label{margin:8px 16px 0 16px;}}"
    });
    const labelStyle = /*#__PURE__*/ (0, _css.css)({
        name: "479ezy",
        styles: "font-family:Muli;font-size:14px;text-align:left;margin:0 16px"
    });
    const deleteIconStyle = /*#__PURE__*/ (0, _css.css)({
        name: "4z7pcv",
        styles: "height:14px;margin:0;img{height:14px;}"
    });
    const deleteLargeIconStyle = /*#__PURE__*/ (0, _css.css)({
        name: "st4yhz",
        styles: "height:32px;margin-left:24px;margin-right:0;img{height:32px;&.left-img{margin-right:0;}}"
    });
    const labelContainer = /*#__PURE__*/ (0, _css.css)("display:flex;align-items:center;", (0, _breakpoints.breakpoint_small), "{margin-left:12px;font-family:Muli;font-size:14px;font-weight:600;}", "");
    const labelsStyle = /*#__PURE__*/ (0, _css.css)({
        name: "unrh3l",
        styles: "display:flex;justify-content:space-between;width:100%"
    });
    const requiredLabelStyle = /*#__PURE__*/ (0, _css.css)("margin-right:0;margin-left:auto;margin-top:-14px;margin-bottom:-20px;font-family:Muli;font-size:24px;color:", (0, _colors.faded_red), ";", "");
    const fieldContainer = /*#__PURE__*/ (0, _css.css)("display:flex;justify-content:space-between;align-items:center;height:60px;width:100%;border-radius:8px;border:solid 1px ", (0, _colors.color_shades_dark), ";background:white;margin-top:8px;position:relative;img{margin:16px;}&.disabled{background:", (0, _colors.pale_grey), ";input{background:", (0, _colors.pale_grey), ";}}", "");
    const separatorStyle = /*#__PURE__*/ (0, _css.css)({
        name: "zdz8xi",
        styles: "height:30px"
    });
    const fieldWrapper = /*#__PURE__*/ (0, _css.css)({
        name: "fhxb3m",
        styles: "display:flex;flex-direction:row;align-items:center"
    });
    const resetButtonStyle = /*#__PURE__*/ (0, _css.css)("position:absolute;top:8px;right:8px;background:none;border:none;color:", (0, _colors.color_colors_ocean), ";font-family:Muli;font-size:12px;cursor:pointer;z-index:1;padding:4px 8px;border-radius:4px;text-decoration:none;&:hover{background-color:", (0, _colors.color_variants_ocean_light_1), ";}", "");
    const [focused, setFocused] = (0, _react1.useState)(false);
    const [suggestionArrowHovered, setSuggestionArrowHovered] = (0, _react1.useState)(false);
    const [focusedSuggestion, setFocusedSuggestion] = (0, _react1.useState)();
    const [availableSuggestions, setAvailableSuggestions] = (0, _react1.useState)([]);
    const handleDocumentClick = (e)=>{
        if (e.target.closest(`.suggestion`) || e.target.closest(`.${textFieldStyles}`) || e.target.closest(`.${suggestionsStyle}`)) return;
    };
    const getAvailableSuggestions = ()=>{
        const availableSuggestions = [];
        if (props.suggestions && focused) {
            const lowerValue = `${props.value}`.toLowerCase();
            props.suggestions.forEach((s)=>{
                if (!props.value || props.value == "") availableSuggestions.push(s);
                else if (s.toLowerCase().includes(lowerValue)) availableSuggestions.push(s);
            });
        }
        return availableSuggestions;
    };
    (0, _react1.useEffect)(()=>{
        document.addEventListener("click", handleDocumentClick, true);
        return ()=>{
            document.removeEventListener("click", handleDocumentClick, true);
        };
    }, []);
    (0, _react1.useEffect)(()=>{
        setSuggestionArrowHovered(false);
        const newAvailableSuggestions = getAvailableSuggestions();
        setAvailableSuggestions(newAvailableSuggestions);
    }, [
        props.value,
        focused
    ]);
    const onFocus = (e)=>{
        if (props.suggestions) setFocused(true);
        if (props.onFocus) props.onFocus(e);
    };
    const onBlur = (e)=>{
        if (props.suggestions) setFocused(false);
        if (props.onBlur) props.onBlur(e);
    };
    const onKeyDown = (e)=>{
        if (availableSuggestions.length > 0) {
            if (e.key == "Enter") {
                if (focusedSuggestion != null) props.onSuggestionClick(availableSuggestions[focusedSuggestion]);
                e.preventDefault();
            }
            if (e.key == "ArrowDown") {
                let newFocusedSuggestion = (focusedSuggestion ?? -1) + 1;
                if (newFocusedSuggestion == availableSuggestions.length) {
                    newFocusedSuggestion = availableSuggestions.length - 1;
                    setFocusedSuggestion(newFocusedSuggestion);
                }
            }
            if (e.key == "ArrowUp" && focusedSuggestion != null) {
                let newFocusedSuggestion = focusedSuggestion;
                if (newFocusedSuggestion == 0) newFocusedSuggestion = null;
                else newFocusedSuggestion = newFocusedSuggestion - 1;
                setFocusedSuggestion(newFocusedSuggestion);
            }
        }
    };
    const onSuggestionClick = (event, suggestion)=>{
        event.stopPropagation();
        props.onSuggestionClick(suggestion);
    };
    const onSuggestionMouseLeave = ()=>{
        setSuggestionArrowHovered(false);
    };
    const onSuggestionMouseEnter = (idx)=>{
        if (idx == 0) setSuggestionArrowHovered(true);
    };
    const showDeleteButton = props.canDelete && !props.canCopy && (props.deletePosition == undefined || props.deletePosition == "top");
    const showResetButton = props.defaultValue !== undefined && props.value !== props.defaultValue;
    const handleReset = ()=>{
        if (props.onReset) props.onReset();
        else if (props.onChange) {
            const syntheticEvent = {
                target: {
                    value: props.defaultValue,
                    name: props.name
                },
                currentTarget: {
                    value: props.defaultValue,
                    name: props.name
                }
            };
            props.onChange(syntheticEvent);
        }
    };
    return (0, _react.jsx)("div", {
        className: `${containerStyle} ${props.className}`
    }, (0, _react.jsx)("div", {
        className: labelsStyle
    }, (0, _react.jsx)("div", {
        className: labelContainer
    }, props.labelIcon && (0, _react.jsx)("img", {
        src: props.labelIcon
    }), props.label !== undefined ? (0, _react.jsx)("label", {
        htmlFor: props.name,
        className: `${props.labelStyle && props.labelStyle} labelStyle`
    }, props.label) : null, showDeleteButton ? (0, _react.jsx)((0, _buttonDefault.default), {
        additionalClasses: deleteIconStyle,
        type: "button",
        onClick: props.onDelete,
        themes: [
            "icon"
        ],
        icon: deleteIcon
    }) : null, props.required && (0, _react.jsx)((0, _tooltipWrapperDefault.default), {
        text: "Required field"
    }, (0, _react.jsx)("span", {
        className: props.customRequiredLabelStyle ? props.customRequiredLabelStyle : requiredLabelStyle
    }, "*")), props.tooltip && (0, _react.jsx)((0, _iconTooltipDefault.default), {
        text: props.tooltip,
        place: props.toolTipPosition ? props.toolTipPosition : "top",
        className: props.tooltipStyle
    })), (0, _react.jsx)("div", null, props.rightLabel !== undefined ? (0, _react.jsx)("label", {
        htmlFor: props.rightLabel,
        className: `${props.rightLabelStyle ? props.rightLabelStyle : labelStyle}`
    }, props.rightLabel) : null)), (0, _react.jsx)("div", {
        className: fieldWrapper
    }, (0, _react.jsx)("div", {
        className: `${fieldContainer} ${props.fieldContainerStyle}  ${props.disabled ? "disabled" : ""} field-container`
    }, showResetButton && (0, _react.jsx)("button", {
        className: resetButtonStyle,
        type: "button",
        onClick: handleReset
    }, "Reset to default"), props.iconPosition !== "right" && props.icon !== undefined ? (0, _react.jsx)("img", {
        src: props.icon
    }) : null, props.iconPosition !== "right" && props.icon !== undefined ? (0, _react.jsx)("div", {
        className: separatorStyle
    }, (0, _react.jsx)((0, _verticalSeparatorDefault.default), null)) : null, props.useForm === undefined || props.useForm == true ? (0, _react.jsx)((0, _formik.Field), {
        id: props.id,
        className: props.fieldStyle ? props.fieldStyle : textFieldStyles,
        type: props.type,
        name: props.name,
        autoFocus: props.autoFocus,
        placeholder: props.placeholder,
        value: props.value,
        defaultValue: props.defaultValue,
        onChange: props.onChange,
        onBlur: onBlur,
        onFocus: onFocus,
        disabled: props.disabled,
        onKeyDown: props.onKeyDown ? props.onKeyDown : onKeyDown,
        onKeyPress: props.onKeyPress,
        validate: props.validate
    }) : (0, _react.jsx)("input", {
        id: props.id,
        className: textFieldStyles,
        type: props.type,
        name: props.name,
        autoFocus: props.autoFocus,
        defaultValue: props.defaultValue?.toString(),
        placeholder: props.placeholder,
        value: props.value,
        onChange: props.onChange,
        onBlur: onBlur,
        readOnly: props.readOnly ?? false,
        onFocus: onFocus,
        onKeyPress: props.onKeyPress,
        onKeyDown: props.onKeyDown ? props.onKeyDown : onKeyDown,
        disabled: props.disabled
    }), props.iconPosition === "right" && (0, _react.jsx)((0, _reactDefault.default).Fragment, null, (0, _react.jsx)("div", {
        className: separatorStyle
    }, (0, _react.jsx)((0, _verticalSeparatorDefault.default), null)), (0, _react.jsx)("img", {
        src: props.icon
    }))), props.canDelete && props.deletePosition == "right" ? (0, _react.jsx)((0, _buttonDefault.default), {
        additionalClasses: deleteLargeIconStyle,
        type: "button",
        onClick: props.onDelete,
        themes: [
            "icon"
        ],
        icon: deleteIcon
    }) : null), availableSuggestions.length > 0 && (0, _react.jsx)("div", {
        className: `${suggestionsStyle} text-field-suggestions`
    }, (0, _react.jsx)("div", {
        className: `arrow ${suggestionArrowHovered || focusedSuggestion == 0 ? "hovered" : ""}`
    }), availableSuggestions.map((suggestion, idx)=>(0, _react.jsx)("div", {
            onMouseDown: (e)=>onSuggestionClick(e, suggestion),
            key: idx,
            onMouseEnter: ()=>onSuggestionMouseEnter(idx),
            onMouseLeave: onSuggestionMouseLeave,
            className: `suggestion ${idx == 0 ? "first" : ""} ${idx == availableSuggestions.length - 1 ? "last" : ""} ${focusedSuggestion == idx ? "focused-suggestion" : ""}`
        }, suggestion))), props.useForm === undefined || props.useForm == true ? (0, _react.jsx)((0, _fieldErrorDefault.default), {
        name: props.name
    }) : null);
};
exports.default = TextField;

},{"@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","formik":"3YnOK","../../constants/colors":"1p3OR","./FieldError":"fDxhz","../general/Button":"6ymxN","../general/IconTooltip":"3FODC","../structure/VerticalSeparator":"aNNRC","../general/TooltipWrapper":"53pWd","../../constants/breakpoints":"2F01A","6ea6afe0e613f5d7":"7eyKJ","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1p3OR":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "dark_grey_blue", ()=>dark_grey_blue);
parcelHelpers.export(exports, "cool_grey", ()=>cool_grey);
parcelHelpers.export(exports, "greeny_blue", ()=>greeny_blue);
parcelHelpers.export(exports, "dark_sky_blue", ()=>dark_sky_blue);
parcelHelpers.export(exports, "silver", ()=>silver);
parcelHelpers.export(exports, "customGreen", ()=>customGreen);
parcelHelpers.export(exports, "bluegreen", ()=>bluegreen);
parcelHelpers.export(exports, "ocean_blue", ()=>ocean_blue);
parcelHelpers.export(exports, "faded_red", ()=>faded_red);
parcelHelpers.export(exports, "pale_grey", ()=>pale_grey);
parcelHelpers.export(exports, "silver_two", ()=>silver_two);
parcelHelpers.export(exports, "silver_three", ()=>silver_three);
parcelHelpers.export(exports, "silver_four", ()=>silver_four);
parcelHelpers.export(exports, "pale_grey_two", ()=>pale_grey_two);
parcelHelpers.export(exports, "dark_grey_blue_10", ()=>dark_grey_blue_10);
parcelHelpers.export(exports, "dark_grey_blue_20", ()=>dark_grey_blue_20);
parcelHelpers.export(exports, "dark_grey_blue_30", ()=>dark_grey_blue_30);
parcelHelpers.export(exports, "dark_grey_blue_70", ()=>dark_grey_blue_70);
parcelHelpers.export(exports, "dark_grey_blue_80", ()=>dark_grey_blue_80);
parcelHelpers.export(exports, "twilight", ()=>twilight);
parcelHelpers.export(exports, "denim_blue", ()=>denim_blue);
parcelHelpers.export(exports, "faded_grey", ()=>faded_grey);
parcelHelpers.export(exports, "primary_gradient", ()=>primary_gradient);
parcelHelpers.export(exports, "faded_blue", ()=>faded_blue);
parcelHelpers.export(exports, "highlight_green", ()=>highlight_green);
parcelHelpers.export(exports, "highlight_blue", ()=>highlight_blue);
parcelHelpers.export(exports, "blue_white", ()=>blue_white);
parcelHelpers.export(exports, "highlight_blue_2", ()=>highlight_blue_2);
parcelHelpers.export(exports, "faded_blue_3", ()=>faded_blue_3);
parcelHelpers.export(exports, "faded_blue_2", ()=>faded_blue_2);
parcelHelpers.export(exports, "green_1", ()=>green_1);
parcelHelpers.export(exports, "text_blue", ()=>text_blue);
parcelHelpers.export(exports, "pastel_light_blue", ()=>pastel_light_blue);
parcelHelpers.export(exports, "pastel_blue", ()=>pastel_blue);
parcelHelpers.export(exports, "pastel_green", ()=>pastel_green);
parcelHelpers.export(exports, "pastel_purple", ()=>pastel_purple);
parcelHelpers.export(exports, "pastel_gold", ()=>pastel_gold);
parcelHelpers.export(exports, "pastel_pink", ()=>pastel_pink);
parcelHelpers.export(exports, "pastel_yellow", ()=>pastel_yellow);
parcelHelpers.export(exports, "pastel_red", ()=>pastel_red);
parcelHelpers.export(exports, "pastel_grey", ()=>pastel_grey);
parcelHelpers.export(exports, "shade_2_lighter", ()=>shade_2_lighter);
parcelHelpers.export(exports, "page_primary_background", ()=>page_primary_background);
parcelHelpers.export(exports, "light_gray", ()=>light_gray);
parcelHelpers.export(exports, "dark_red", ()=>dark_red);
parcelHelpers.export(exports, "charcoal_blue", ()=>charcoal_blue);
parcelHelpers.export(exports, "light_black", ()=>light_black);
parcelHelpers.export(exports, "color_defaults_black", ()=>color_defaults_black);
parcelHelpers.export(exports, "color_defaults_white", ()=>color_defaults_white);
parcelHelpers.export(exports, "color_defaults_spec", ()=>color_defaults_spec);
parcelHelpers.export(exports, "color_defaults_specbg", ()=>color_defaults_specbg);
parcelHelpers.export(exports, "color_shades_darkest", ()=>color_shades_darkest);
parcelHelpers.export(exports, "color_shades_darkest_transparent", ()=>color_shades_darkest_transparent);
parcelHelpers.export(exports, "color_shades_darker", ()=>color_shades_darker);
parcelHelpers.export(exports, "color_shades_dark", ()=>color_shades_dark);
parcelHelpers.export(exports, "color_shades_medium", ()=>color_shades_medium);
parcelHelpers.export(exports, "color_shades_light", ()=>color_shades_light);
parcelHelpers.export(exports, "color_shades_lighter", ()=>color_shades_lighter);
parcelHelpers.export(exports, "color_shades_lightest", ()=>color_shades_lightest);
parcelHelpers.export(exports, "color_colors_ocean", ()=>color_colors_ocean);
parcelHelpers.export(exports, "color_colors_light_ocean", ()=>color_colors_light_ocean);
parcelHelpers.export(exports, "color_colors_sky", ()=>color_colors_sky);
parcelHelpers.export(exports, "color_colors_royalty", ()=>color_colors_royalty);
parcelHelpers.export(exports, "color_colors_growth_background", ()=>color_colors_growth_background);
parcelHelpers.export(exports, "color_colors_growth", ()=>color_colors_growth);
parcelHelpers.export(exports, "color_colors_gold", ()=>color_colors_gold);
parcelHelpers.export(exports, "color_colors_gold_background", ()=>color_colors_gold_background);
parcelHelpers.export(exports, "color_colors_decline", ()=>color_colors_decline);
parcelHelpers.export(exports, "color_colors_light_blue", ()=>color_colors_light_blue);
parcelHelpers.export(exports, "color_variants_shadow_10", ()=>color_variants_shadow_10);
parcelHelpers.export(exports, "color_variants_shadow_20", ()=>color_variants_shadow_20);
parcelHelpers.export(exports, "color_variants_ocean_light_1", ()=>color_variants_ocean_light_1);
parcelHelpers.export(exports, "color_variants_ocean_light_2", ()=>color_variants_ocean_light_2);
parcelHelpers.export(exports, "color_variants_ocean_xlight", ()=>color_variants_ocean_xlight);
parcelHelpers.export(exports, "color_variants_blue_2", ()=>color_variants_blue_2);
parcelHelpers.export(exports, "color_variants_green_2", ()=>color_variants_green_2);
parcelHelpers.export(exports, "color_variants_red_2", ()=>color_variants_red_2);
parcelHelpers.export(exports, "color_variants_gold_light", ()=>color_variants_gold_light);
parcelHelpers.export(exports, "color_variants_gold_dark", ()=>color_variants_gold_dark);
parcelHelpers.export(exports, "color_variants_ocean_light_opaque", ()=>color_variants_ocean_light_opaque);
parcelHelpers.export(exports, "color_variants_ocean_light_opaque_2", ()=>color_variants_ocean_light_opaque_2);
parcelHelpers.export(exports, "color_variants_royalty_light_10", ()=>color_variants_royalty_light_10);
parcelHelpers.export(exports, "color_variants_royalty_light_20", ()=>color_variants_royalty_light_20);
parcelHelpers.export(exports, "color_variants_main_bg", ()=>color_variants_main_bg);
parcelHelpers.export(exports, "color_variants_decline_light_1", ()=>color_variants_decline_light_1);
parcelHelpers.export(exports, "color_gradients_blue_shift", ()=>color_gradients_blue_shift);
parcelHelpers.export(exports, "color_gradients_green_shift", ()=>color_gradients_green_shift);
parcelHelpers.export(exports, "color_gradients_green_shift_reverse", ()=>color_gradients_green_shift_reverse);
parcelHelpers.export(exports, "color_gradients_silver_shift", ()=>color_gradients_silver_shift);
parcelHelpers.export(exports, "color_gradients_silver_shift_reverse", ()=>color_gradients_silver_shift_reverse);
parcelHelpers.export(exports, "color_gradients_knight_shift", ()=>color_gradients_knight_shift);
parcelHelpers.export(exports, "color_highlights_green", ()=>color_highlights_green);
parcelHelpers.export(exports, "color_highlights_purple", ()=>color_highlights_purple);
parcelHelpers.export(exports, "color_highlights_pink", ()=>color_highlights_pink);
parcelHelpers.export(exports, "color_highlights_salmon", ()=>color_highlights_salmon);
parcelHelpers.export(exports, "color_highlights_gold", ()=>color_highlights_gold);
parcelHelpers.export(exports, "color_highlights_yellow", ()=>color_highlights_yellow);
parcelHelpers.export(exports, "color_highlights_cyan", ()=>color_highlights_cyan);
parcelHelpers.export(exports, "color_highlights_blue", ()=>color_highlights_blue);
parcelHelpers.export(exports, "color_text_default", ()=>color_text_default);
parcelHelpers.export(exports, "color_text_light", ()=>color_text_light);
parcelHelpers.export(exports, "color_text_xlight", ()=>color_text_xlight);
parcelHelpers.export(exports, "color_text_link", ()=>color_text_link);
parcelHelpers.export(exports, "color_text_inverse", ()=>color_text_inverse);
parcelHelpers.export(exports, "voicify_spark_lightest", ()=>voicify_spark_lightest);
parcelHelpers.export(exports, "voicify_spark_lighter", ()=>voicify_spark_lighter);
parcelHelpers.export(exports, "voicify_spark_light", ()=>voicify_spark_light);
parcelHelpers.export(exports, "voicify_spark_medium", ()=>voicify_spark_medium);
parcelHelpers.export(exports, "voicify_spark_dark", ()=>voicify_spark_dark);
parcelHelpers.export(exports, "voicify_spark_darker", ()=>voicify_spark_darker);
parcelHelpers.export(exports, "voicify_spark_darkest", ()=>voicify_spark_darkest);
parcelHelpers.export(exports, "chart_blue_1", ()=>chart_blue_1);
parcelHelpers.export(exports, "chart_blue_2", ()=>chart_blue_2);
parcelHelpers.export(exports, "chart_blue_3", ()=>chart_blue_3);
parcelHelpers.export(exports, "chart_blue_4", ()=>chart_blue_4);
parcelHelpers.export(exports, "chart_blue_5", ()=>chart_blue_5);
parcelHelpers.export(exports, "chart_blue_6", ()=>chart_blue_6);
parcelHelpers.export(exports, "chart_blue_7", ()=>chart_blue_7);
parcelHelpers.export(exports, "chart_blue_8", ()=>chart_blue_8);
parcelHelpers.export(exports, "chart_blue_9", ()=>chart_blue_9);
parcelHelpers.export(exports, "chart_blue_10", ()=>chart_blue_10);
parcelHelpers.export(exports, "chart_blue_11", ()=>chart_blue_11);
parcelHelpers.export(exports, "chart_blue_12", ()=>chart_blue_12);
parcelHelpers.export(exports, "chart_glass_blue_1", ()=>chart_glass_blue_1);
parcelHelpers.export(exports, "chart_glass_blue_2", ()=>chart_glass_blue_2);
parcelHelpers.export(exports, "chart_glass_blue_3", ()=>chart_glass_blue_3);
parcelHelpers.export(exports, "chart_glass_blue_4", ()=>chart_glass_blue_4);
parcelHelpers.export(exports, "chart_glass_blue_5", ()=>chart_glass_blue_5);
parcelHelpers.export(exports, "chart_glass_blue_6", ()=>chart_glass_blue_6);
parcelHelpers.export(exports, "chart_glass_blue_7", ()=>chart_glass_blue_7);
parcelHelpers.export(exports, "chart_glass_blue_8", ()=>chart_glass_blue_8);
parcelHelpers.export(exports, "chart_glass_blue_9", ()=>chart_glass_blue_9);
parcelHelpers.export(exports, "chart_glass_blue_10", ()=>chart_glass_blue_10);
parcelHelpers.export(exports, "chart_glass_blue_11", ()=>chart_glass_blue_11);
parcelHelpers.export(exports, "chart_glass_blue_12", ()=>chart_glass_blue_12);
parcelHelpers.export(exports, "chart_teal_1", ()=>chart_teal_1);
parcelHelpers.export(exports, "chart_teal_2", ()=>chart_teal_2);
parcelHelpers.export(exports, "chart_teal_glass", ()=>chart_teal_glass);
parcelHelpers.export(exports, "chart_indigo_1", ()=>chart_indigo_1);
parcelHelpers.export(exports, "chart_indigo_2", ()=>chart_indigo_2);
parcelHelpers.export(exports, "chart_indigo_glass", ()=>chart_indigo_glass);
parcelHelpers.export(exports, "chart_slate_1", ()=>chart_slate_1);
parcelHelpers.export(exports, "chart_slate_2", ()=>chart_slate_2);
parcelHelpers.export(exports, "chart_slate_glass", ()=>chart_slate_glass);
parcelHelpers.export(exports, "chart_sky_1", ()=>chart_sky_1);
parcelHelpers.export(exports, "chart_sky_2", ()=>chart_sky_2);
parcelHelpers.export(exports, "chart_sky_glass", ()=>chart_sky_glass);
parcelHelpers.export(exports, "chartSequentialBlues", ()=>chartSequentialBlues);
parcelHelpers.export(exports, "chartGlassBlues", ()=>chartGlassBlues);
parcelHelpers.export(exports, "chartBorderBlues", ()=>chartBorderBlues);
parcelHelpers.export(exports, "getChartColor", ()=>getChartColor);
parcelHelpers.export(exports, "getChartGlassColor", ()=>getChartGlassColor);
parcelHelpers.export(exports, "getChartBorderColor", ()=>getChartBorderColor);
parcelHelpers.export(exports, "chart_planned_fill", ()=>chart_planned_fill);
parcelHelpers.export(exports, "chart_planned_fill_light", ()=>chart_planned_fill_light);
parcelHelpers.export(exports, "chart_planned_fill_xlight", ()=>chart_planned_fill_xlight);
parcelHelpers.export(exports, "chart_planned_solid", ()=>chart_planned_solid);
parcelHelpers.export(exports, "chart_unplanned_fill", ()=>chart_unplanned_fill);
parcelHelpers.export(exports, "chart_unplanned_fill_light", ()=>chart_unplanned_fill_light);
parcelHelpers.export(exports, "chart_unplanned_fill_xlight", ()=>chart_unplanned_fill_xlight);
parcelHelpers.export(exports, "chart_unplanned_solid", ()=>chart_unplanned_solid);
parcelHelpers.export(exports, "button_dark_bg", ()=>button_dark_bg);
parcelHelpers.export(exports, "button_dark_bg_hover", ()=>button_dark_bg_hover);
parcelHelpers.export(exports, "button_shadow_light", ()=>button_shadow_light);
parcelHelpers.export(exports, "text_dark", ()=>text_dark);
parcelHelpers.export(exports, "shadow_sm", ()=>shadow_sm);
parcelHelpers.export(exports, "shadow_md", ()=>shadow_md);
parcelHelpers.export(exports, "shadow_md_alt", ()=>shadow_md_alt);
parcelHelpers.export(exports, "shadow_lg", ()=>shadow_lg);
parcelHelpers.export(exports, "shadow_xl", ()=>shadow_xl);
parcelHelpers.export(exports, "shadow_modal", ()=>shadow_modal);
parcelHelpers.export(exports, "overlay_bg", ()=>overlay_bg);
parcelHelpers.export(exports, "overlay_border", ()=>overlay_border);
parcelHelpers.export(exports, "overlay_white", ()=>overlay_white);
parcelHelpers.export(exports, "premium_gold", ()=>premium_gold);
parcelHelpers.export(exports, "premium_gold_light", ()=>premium_gold_light);
parcelHelpers.export(exports, "premium_gold_lightest", ()=>premium_gold_lightest);
parcelHelpers.export(exports, "premium_gold_gradient", ()=>premium_gold_gradient);
parcelHelpers.export(exports, "premium_gold_shadow", ()=>premium_gold_shadow);
parcelHelpers.export(exports, "premium_gold_shadow_hover", ()=>premium_gold_shadow_hover);
parcelHelpers.export(exports, "status_success", ()=>status_success);
parcelHelpers.export(exports, "status_success_bg", ()=>status_success_bg);
parcelHelpers.export(exports, "status_error", ()=>status_error);
parcelHelpers.export(exports, "status_error_bg", ()=>status_error_bg);
parcelHelpers.export(exports, "status_error_bg_light", ()=>status_error_bg_light);
parcelHelpers.export(exports, "status_error_bg_xlight", ()=>status_error_bg_xlight);
parcelHelpers.export(exports, "status_neutral", ()=>status_neutral);
parcelHelpers.export(exports, "status_neutral_bg", ()=>status_neutral_bg);
const dark_grey_blue = "#2c3d52";
const cool_grey = "#8e97a1";
const greeny_blue = "#4cb58f";
const dark_sky_blue = "#2ebbe1";
const silver = "#ebecec";
const customGreen = `#76b041`;
const bluegreen = `#17bebb`;
const ocean_blue = "#0074a6";
const faded_red = "#dd4e60";
const pale_grey = "#e9eaee";
const silver_two = "#cbd0d2";
const silver_three = "#e5e7e8";
const silver_four = "#cbccd2";
const pale_grey_two = "#fcfdfe";
const dark_grey_blue_10 = "rgba(44, 61, 82, 0.1)";
const dark_grey_blue_20 = "rgba(44, 61, 82, 0.2)";
const dark_grey_blue_30 = "rgba(44, 61, 82, 0.3)";
const dark_grey_blue_70 = "rgba(44, 61, 82, 0.7)";
const dark_grey_blue_80 = "rgba(44, 61, 82, 0.8)";
const twilight = "#624589";
const denim_blue = "#395994";
const faded_grey = "rgba(203, 208, 210, 0.5)";
const primary_gradient = "linear-gradient(257deg, #76c3b5, #3ea6ac 72%, #5296b3)";
const faded_blue = "#E6F0F5";
const highlight_green = "#EDF7F3";
const highlight_blue = "#EAF8FC";
const blue_white = "#fafcfd";
const highlight_blue_2 = "#4d9cbe";
const faded_blue_3 = "#E5F1F6";
const faded_blue_2 = "#99C7DB";
const green_1 = "#4EBE99";
const text_blue = "#1e7eb9;";
const pastel_light_blue = "#b3f1fe";
const pastel_blue = "#cfe3fa";
const pastel_green = "#89eac3";
const pastel_purple = "#d8cff8";
const pastel_gold = "#ffe9b1";
const pastel_pink = "#ffbfd9";
const pastel_yellow = "#fff656";
const pastel_red = "#ffb3a7";
const pastel_grey = "#e9eaee";
const shade_2_lighter = "#f4f4f6";
const page_primary_background = "#FAFCFD";
const light_gray = "#f9f9f9";
const dark_red = "#d8414d";
const charcoal_blue = "rgba(50, 70, 97, 0.1)";
const light_black = "rgba(0, 0, 0, 0.1)";
const color_defaults_black = "#000000";
const color_defaults_white = "#FFFFFF";
const color_defaults_spec = "#B42360";
const color_defaults_specbg = "rgba(180, 35, 96, 0.1)";
const color_shades_darkest = "#324661";
const color_shades_darkest_transparent = "rgb(50,70,97,.85)";
const color_shades_darker = "#8F97A1";
const color_shades_dark = "#CBCCD2";
const color_shades_medium = "#DCDDE2";
const color_shades_light = "#E9EAEE";
const color_shades_lighter = "#F4F4F6";
const color_shades_lightest = "#FCFDFE";
const color_colors_ocean = "#1E7EB9";
const color_colors_light_ocean = "rgba(30, 126, 185, 0.08)";
const color_colors_sky = "#36C4F2";
const color_colors_royalty = "#6C4C9F";
const color_colors_growth_background = "rgb(88,189,53,.1)";
const color_colors_growth = "#58BD99";
const color_colors_gold = "#F6A12F";
const color_colors_gold_background = "rgb(246,161,47,.1)";
const color_colors_decline = "#D8414D";
const color_colors_light_blue = "#2BA4D8";
const color_variants_shadow_10 = "rgba(50, 70, 97, 0.1)";
const color_variants_shadow_20 = "rgba(50, 70, 97, 0.2)";
const color_variants_ocean_light_1 = "rgba(30, 126, 185, 0.08)";
const color_variants_ocean_light_2 = "rgba(30, 126, 185, 0.12)";
const color_variants_ocean_xlight = "rgba(30, 126, 185, 0.04)";
const color_variants_blue_2 = "rgba(30, 126, 185, 0.2)";
const color_variants_green_2 = "rgba(88, 189, 153, 0.2)";
const color_variants_red_2 = "rgba(216, 65, 77, 0.2)";
const color_variants_gold_light = "rgb(246, 161, 47, 0.1)";
const color_variants_gold_dark = "rgb(246, 161, 47, 1)";
const color_variants_ocean_light_opaque = "#EDF5FA";
const color_variants_ocean_light_opaque_2 = "#E4EFF6";
const color_variants_royalty_light_10 = "#F0EDF5";
const color_variants_royalty_light_20 = "#E2DBEC";
const color_variants_main_bg = "#FAFCFD";
const color_variants_decline_light_1 = "#FCECEE";
const color_gradients_blue_shift = "linear-gradient(90deg, #1E7EB9 0%, #36C4F2 100%, #2BA5D8 100%)";
const color_gradients_green_shift = "linear-gradient(224.91deg, #76C3B5 3.06%, #3EA6AC 72.52%, #5296B3 100%)";
const color_gradients_green_shift_reverse = "linear-gradient(14.4deg, #76C3B5 0%, #3EA6AC 71.66%, #5296B3 100%)";
const color_gradients_silver_shift = "linear-gradient(224.91deg, #F5F9FC 3.06%, #FAFDFE 50.21%, #F4F5F5 100%)";
const color_gradients_silver_shift_reverse = "linear-gradient(16.95deg, #F5F9FC 0%, #FAFDFE 48.69%, #F4F5F5 100.09%)";
const color_gradients_knight_shift = "linear-gradient(224.91deg, #CBCCD2 3.06%, #A8A8A8 68.4%, #929292 100%)";
const color_highlights_green = "#89EAC3";
const color_highlights_purple = "#D8CFF8";
const color_highlights_pink = "#FFBFD9";
const color_highlights_salmon = "#FFB3A7";
const color_highlights_gold = "#FFE9B1";
const color_highlights_yellow = "#FFF656";
const color_highlights_cyan = "#B3F1FE";
const color_highlights_blue = "#CFE3FA";
const color_text_default = color_shades_darkest;
const color_text_light = color_shades_darker;
const color_text_xlight = color_shades_dark;
const color_text_link = color_colors_ocean;
const color_text_inverse = color_defaults_white;
const voicify_spark_lightest = "#f1f9fe";
const voicify_spark_lighter = "#e2f3fc";
const voicify_spark_light = "#bee7f9";
const voicify_spark_medium = "#85d3f4";
const voicify_spark_dark = "#44beec";
const voicify_spark_darker = "#1ba5dc";
const voicify_spark_darkest = "#0e85bb";
const chart_blue_1 = "#0a5f8a"; // Deep ocean
const chart_blue_2 = "#0e85bb"; // Voicify Spark darkest
const chart_blue_3 = "#1ba5dc"; // Voicify Spark darker
const chart_blue_4 = "#2eb8e8"; // Bright cyan-blue
const chart_blue_5 = "#44beec"; // Voicify Spark dark
const chart_blue_6 = "#5ec8ef"; // Soft cyan
const chart_blue_7 = "#78d2f3"; // Light cyan
const chart_blue_8 = "#85d3f4"; // Voicify Spark medium
const chart_blue_9 = "#a0dff7"; // Pale cyan
const chart_blue_10 = "#bee7f9"; // Voicify Spark light
const chart_blue_11 = "#d4f0fb"; // Very light cyan
const chart_blue_12 = "#e2f3fc"; // Voicify Spark lighter
const chart_glass_blue_1 = "rgba(10, 95, 138, 0.75)"; // Deep ocean glass
const chart_glass_blue_2 = "rgba(14, 133, 187, 0.70)"; // Voicify Spark darkest glass
const chart_glass_blue_3 = "rgba(27, 165, 220, 0.65)"; // Voicify Spark darker glass
const chart_glass_blue_4 = "rgba(46, 184, 232, 0.60)"; // Bright cyan glass
const chart_glass_blue_5 = "rgba(68, 190, 236, 0.55)"; // Voicify Spark dark glass
const chart_glass_blue_6 = "rgba(94, 200, 239, 0.50)"; // Soft cyan glass
const chart_glass_blue_7 = "rgba(120, 210, 243, 0.45)"; // Light cyan glass
const chart_glass_blue_8 = "rgba(133, 211, 244, 0.40)"; // Voicify Spark medium glass
const chart_glass_blue_9 = "rgba(160, 223, 247, 0.35)"; // Pale cyan glass
const chart_glass_blue_10 = "rgba(190, 231, 249, 0.30)"; // Voicify Spark light glass
const chart_glass_blue_11 = "rgba(212, 240, 251, 0.25)"; // Very light glass
const chart_glass_blue_12 = "rgba(226, 243, 252, 0.20)"; // Lightest glass
const chart_teal_1 = "#0f766e"; // Deep teal
const chart_teal_2 = "#14b8a6"; // Bright teal
const chart_teal_glass = "rgba(20, 184, 166, 0.55)";
const chart_indigo_1 = "#4338ca"; // Deep indigo
const chart_indigo_2 = "#6366f1"; // Bright indigo
const chart_indigo_glass = "rgba(99, 102, 241, 0.55)";
const chart_slate_1 = "#475569"; // Slate
const chart_slate_2 = "#64748b"; // Light slate
const chart_slate_glass = "rgba(100, 116, 139, 0.50)";
const chart_sky_1 = "#0284c7"; // Sky blue
const chart_sky_2 = "#38bdf8"; // Light sky
const chart_sky_glass = "rgba(56, 189, 248, 0.55)";
const chartSequentialBlues = [
    chart_blue_1,
    chart_blue_2,
    chart_blue_3,
    chart_blue_4,
    chart_blue_5,
    chart_blue_6,
    chart_blue_7,
    chart_blue_8,
    chart_blue_9,
    chart_blue_10,
    chart_blue_11,
    chart_blue_12
];
const chartGlassBlues = [
    chart_glass_blue_1,
    chart_glass_blue_2,
    chart_glass_blue_3,
    chart_glass_blue_4,
    chart_glass_blue_5,
    chart_glass_blue_6,
    chart_glass_blue_7,
    chart_glass_blue_8,
    chart_glass_blue_9,
    chart_glass_blue_10,
    chart_glass_blue_11,
    chart_glass_blue_12
];
const chartBorderBlues = [
    chart_blue_1,
    chart_blue_2,
    chart_blue_3,
    chart_blue_4,
    chart_blue_5,
    chart_blue_6,
    chart_blue_7,
    chart_blue_8,
    chart_blue_9,
    chart_blue_10,
    chart_blue_11,
    chart_blue_12
];
const getChartColor = (index)=>chartSequentialBlues[index % chartSequentialBlues.length];
const getChartGlassColor = (index)=>chartGlassBlues[index % chartGlassBlues.length];
const getChartBorderColor = (index)=>chartBorderBlues[index % chartBorderBlues.length];
const chart_planned_fill = "rgba(14, 133, 187, 0.75)";
const chart_planned_fill_light = "rgba(14, 133, 187, 0.15)";
const chart_planned_fill_xlight = "rgba(14, 133, 187, 0.1)";
const chart_planned_solid = "#0E85BB";
const chart_unplanned_fill = "rgba(71, 85, 105, 0.75)";
const chart_unplanned_fill_light = "rgba(71, 85, 105, 0.15)";
const chart_unplanned_fill_xlight = "rgba(71, 85, 105, 0.1)";
const chart_unplanned_solid = "#475569";
const button_dark_bg = "#2C3D52";
const button_dark_bg_hover = "#3a5068";
const button_shadow_light = "0 2px 8px rgba(0, 0, 0, 0.15)";
const text_dark = "#2D2D39";
const shadow_sm = "0 1px 3px rgba(0, 0, 0, 0.08)";
const shadow_md = "0 4px 12px rgba(0, 0, 0, 0.12)";
const shadow_md_alt = "0 4px 12px rgba(0, 0, 0, 0.15)";
const shadow_lg = "0 6px 16px rgba(0, 0, 0, 0.18)";
const shadow_xl = "0 8px 24px rgba(0, 0, 0, 0.15)";
const shadow_modal = "0 4px 16px rgba(0, 0, 0, 0.12)";
const overlay_bg = "rgba(44, 61, 82, 0.7)";
const overlay_border = "rgba(44, 61, 82, 0.8)";
const overlay_white = "rgba(255, 255, 255, 0.85)";
const premium_gold = "#D4A017";
const premium_gold_light = "#F4C430";
const premium_gold_lightest = "#FFEAA7";
const premium_gold_gradient = "linear-gradient(135deg, #E8B923 0%, #F4C430 50%, #FFEAA7 100%)";
const premium_gold_shadow = "0 3px 12px rgba(244, 196, 48, 0.3)";
const premium_gold_shadow_hover = "0 5px 16px rgba(244, 196, 48, 0.4)";
const status_success = "#16A34A";
const status_success_bg = "rgba(34, 197, 94, 0.15)";
const status_error = "#DC2626";
const status_error_bg = "rgba(220, 38, 38, 0.15)";
const status_error_bg_light = "rgba(220, 38, 38, 0.1)";
const status_error_bg_xlight = "rgba(220, 38, 38, 0.05)";
const status_neutral = "#6B7280";
const status_neutral_bg = "rgba(107, 114, 128, 0.15)";

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"fDxhz":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _base = require("@emotion/styled/base");
var _baseDefault = parcelHelpers.interopDefault(_base);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _formik = require("formik");
var _colors = require("../../constants/colors");
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const alertIcon = require("2ae525ce9b0c5d61");
const FieldError = ({ name, ignoreTouched })=>{
    return (0, _react.jsx)((0, _formik.Field), {
        name: name,
        render: ({ form })=>{
            const error = (0, _formik.getIn)(form.errors, name);
            const touch = ignoreTouched || (0, _formik.getIn)(form.touched, name);
            return touch && error ? (0, _react.jsx)(ErrorStyle, null, (0, _react.jsx)(AlertIconStyle, {
                src: alertIcon
            }), error) : null;
        }
    });
};
const ErrorStyle = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1051xv41"
})('display:flex;align-items:center;justify-content:flex-start;font-family:Muli,"sans-serif";font-weight:normal;color:', (0, _colors.color_shades_darkest), ";background-color:", (0, _colors.color_variants_decline_light_1), ";border:1px solid ", (0, _colors.color_colors_decline), ";border-radius:8px;flex-grow:1;padding:8px 16px;margin:8px 0;font-size:14px;");
const AlertIconStyle = /*#__PURE__*/ (0, _baseDefault.default)("img", {
    target: "e1051xv40"
})({
    name: "1oaeivz",
    styles: "margin-right:8px"
});
exports.default = FieldError;

},{"@emotion/styled/base":"lSuFu","@emotion/react":"djZKr","react":"6uln9","formik":"3YnOK","../../constants/colors":"1p3OR","2ae525ce9b0c5d61":"cRA6k","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"cRA6k":[function(require,module,exports) {
module.exports = require("ee0867626f43efec").getBundleURL("kVLro") + require("c0c57083d4583ce9").resolve("4JZhL");

},{"ee0867626f43efec":"c7Tr5","c0c57083d4583ce9":"fyJL2"}],"c7Tr5":[function(require,module,exports) {
"use strict";
var bundleURL = {};
function getBundleURLCached(id) {
    var value = bundleURL[id];
    if (!value) {
        value = getBundleURL();
        bundleURL[id] = value;
    }
    return value;
}
function getBundleURL() {
    try {
        throw new Error();
    } catch (err) {
        var matches = ("" + err.stack).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g);
        if (matches) // The first two stack frames will be this function and getBundleURLCached.
        // Use the 3rd one, which will be a runtime in the original bundle.
        return getBaseURL(matches[2]);
    }
    return "/";
}
function getBaseURL(url) {
    return ("" + url).replace(/^((?:https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/.+)\/[^/]+$/, "$1") + "/";
}
// TODO: Replace uses with `new URL(url).origin` when ie11 is no longer supported.
function getOrigin(url) {
    var matches = ("" + url).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^/]+/);
    if (!matches) throw new Error("Origin not found");
    return matches[0];
}
exports.getBundleURL = getBundleURLCached;
exports.getBaseURL = getBaseURL;
exports.getOrigin = getOrigin;

},{}],"6ymxN":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _base = require("@emotion/styled/base");
var _baseDefault = parcelHelpers.interopDefault(_base);
var _react = require("@emotion/react");
var _css = require("@emotion/css");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _colors = require("../../constants/colors");
var _secondaryLoader = require("./SecondaryLoader");
var _secondaryLoaderDefault = parcelHelpers.interopDefault(_secondaryLoader);
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// primary button with different theme styles
const getClassName = (theme)=>{
    switch(theme){
        case "primary":
            return primaryButton;
        case "primary-small":
            return primarySmallButton;
        case "secondary":
            return whiteButton;
        case "secondary-small":
            return whiteSmallButton;
        case "white-icon":
            return whiteIconButton;
        case "white":
            return whiteButton;
        case "end":
            return endButtonStyle;
        case "start":
            return startButtonStyle;
        case "start-tight":
            return startTightButtonStyle;
        case "hollow":
            return hollowBlueButton;
        case "light-text":
            return lightTextStyle;
        case "end-tight":
            return endTightStyle;
        case "wide":
            return wideStyle;
        case "secondary-medium":
            return secondaryMediumButton;
        case "medium-icon":
            return mediumIconStyle;
        case "icon":
            return iconOnlyStyle;
        case "icon-small":
            return iconSmallOnlyStyle;
        case "icon-large":
            return iconLargeOnlyStyle;
        case "white-small":
            return whiteSmallButton;
        case "black-small":
            return blackSmallButton;
        case "action-item":
            return actionItemStyle;
        case "flat":
            return flatStyle;
        case "destructive":
            return destructiveStyle;
        case "fat":
            return fatStyle;
        case "fill":
            return fillStyle;
        case "small-flat":
            return smallFlatStyle;
        case "small-circle":
            return smallCircle;
        case "blue-pill":
            return bluePill;
        case "no-shadow":
            return noShadow;
        case "inverse":
            return inverseStyle;
        case "white-pill":
            return whitePill;
    }
    return "";
};
const baseButtonStyle = /*#__PURE__*/ (0, _css.css)("position:relative;height:50px;white-space:nowrap;border-radius:40px;border:none;padding:0 40px;margin:16px;cursor:pointer;font-family:Muli;font-size:18px;font-weight:600;font-style:normal;font-stretch:normal;letter-spacing:0.4px;text-align:center;.left-img{margin-right:8px;}.right-img{margin-left:8px;}.spinner>div{background-color:", (0, _colors.dark_grey_blue), ";}.secondary-loader{position:absolute;opacity:1;top:50%;left:50%;margin-top:-20px;margin-left:-25px;.spinner{margin:0px;}}&:disabled{cursor:not-allowed;}", "");
const fatStyle = /*#__PURE__*/ (0, _css.css)({
    name: "10j0uqu",
    styles: "height:60px!important"
});
const fillStyle = /*#__PURE__*/ (0, _css.css)({
    name: "1d3w5wq",
    styles: "width:100%"
});
const noShadow = /*#__PURE__*/ (0, _css.css)({
    name: "1t90u8d",
    styles: "box-shadow:none"
});
const smallFlatStyle = /*#__PURE__*/ (0, _css.css)({
    name: "ma2b9a",
    styles: "margin:0 32px 16px 40px;font-family:Muli;font-size:12px;font-weight:600;font-style:normal;font-stretch:normal;line-height:normal;letter-spacing:normal;color:#007dbb;background:none;border:none;box-shadow:none;padding:0;.right-img{margin-left:4px;}"
});
const bluePill = /*#__PURE__*/ (0, _css.css)({
    name: "nimepr",
    styles: "background:transparent;border:1px solid #007dbb;color:#007dbb;border-radius:15px;height:32px;box-shadow:none;padding:0 12px;font-size:12px;font-weight:normal;font-style:normal;font-stretch:normal;line-height:normal;letter-spacing:0.7px;text-align:center;color:#007dbb;img{width:16px;height:16px;}"
});
const lightTextStyle = /*#__PURE__*/ (0, _css.css)({
    name: "lugakg",
    styles: "font-weight:normal"
});
const endButtonStyle = /*#__PURE__*/ (0, _css.css)({
    name: "1p8w9y8",
    styles: "margin-left:auto;margin-right:50px"
});
const endTightStyle = /*#__PURE__*/ (0, _css.css)({
    name: "14gdj5h",
    styles: "margin-left:auto;margin-right:0"
});
const startButtonStyle = /*#__PURE__*/ (0, _css.css)({
    name: "uxds7a",
    styles: "margin-left:50px;width:auto"
});
const startTightButtonStyle = /*#__PURE__*/ (0, _css.css)({
    name: "1crn9hd",
    styles: "margin-left:0;width:auto"
});
const whiteButton = /*#__PURE__*/ (0, _css.css)("background:", (0, _colors.color_gradients_silver_shift), ";color:", (0, _colors.color_text_default), ";border:solid 1px ", (0, _colors.color_shades_dark), ";&:disabled{background:", (0, _colors.color_shades_light), ";color:", (0, _colors.color_text_light), ";&:hover,&:active{background:", (0, _colors.color_shades_light), ";}}&:hover{background:", (0, _colors.color_gradients_silver_shift_reverse), ";}&:active{box-shadow:inset 0px 0px 32px rgba(0, 0, 0, 0.12);}", "");
const destructiveStyle = /*#__PURE__*/ (0, _css.css)({
    name: "4v368y",
    styles: "background-image:linear-gradient(258deg, #ea727a, #e35760 63%, #c7565d);color:white;.spinner>div{background-color:white;}"
});
const whiteSmallButton = /*#__PURE__*/ (0, _css.css)("height:32px;padding:0 24px;font-size:14px;font-weight:600;background:", (0, _colors.color_gradients_silver_shift), ";color:", (0, _colors.color_text_default), ";border:solid 1px ", (0, _colors.color_shades_dark), ";.secondary-loader{margin-top:-10px;}&:disabled{background:", (0, _colors.color_shades_light), ";color:", (0, _colors.color_text_light), ";&:hover,&:active{background:", (0, _colors.color_shades_light), ";}}&:hover{background:", (0, _colors.color_gradients_silver_shift_reverse), ";}&:active{box-shadow:inset 0px 0px 32px rgba(0, 0, 0, 0.12);}.spinner{height:20px;}", "");
const blackSmallButton = /*#__PURE__*/ (0, _css.css)("height:32px;padding:0 24px;font-size:14px;font-weight:600;background:", (0, _colors.color_shades_darkest), ";color:", (0, _colors.color_shades_light), ";border:solid 1px ", (0, _colors.color_shades_dark), ";.secondary-loader{margin-top:-10px;}&:disabled{background:", (0, _colors.color_shades_light), ";color:", (0, _colors.color_text_light), ";&:hover,&:active{background:", (0, _colors.color_shades_light), ";}}&:hover{color:white;}&:active{box-shadow:inset 0px 0px 32px rgba(0, 0, 0, 0.12);}.spinner{height:20px;}", "");
const whiteIconButton = /*#__PURE__*/ (0, _css.css)("height:32px;width:32px;padding:0;display:flex;align-items:center;justify-content:center;border-radius:50%;background:", (0, _colors.color_gradients_silver_shift), ";color:", (0, _colors.color_text_default), ";border:solid 1px ", (0, _colors.color_shades_dark), ";.secondary-loader{margin-top:-10px;}&:disabled{background:", (0, _colors.color_shades_light), ";color:", (0, _colors.color_text_light), ";&:hover,&:active{background:", (0, _colors.color_shades_light), ";}}&:hover{background:", (0, _colors.color_gradients_silver_shift_reverse), ";}&:active{box-shadow:inset 0px 0px 32px rgba(0, 0, 0, 0.12);}.spinner{height:20px;}.left-img{margin:0;}.right-img{margin:0;}", "");
const smallCircle = /*#__PURE__*/ (0, _css.css)("width:22px;height:22px;box-shadow:none;background:white;color:", (0, _colors.cool_grey), ";padding:0px;margin:0px;font-size:14px;font-weight:normal;border:solid 1px #cccccc;", "");
const primaryButton = /*#__PURE__*/ (0, _css.css)("color:white;background:", (0, _colors.color_gradients_green_shift), ";.loader .spinner>div{background-color:white;}&:disabled{background:", (0, _colors.color_gradients_knight_shift), ";&:hover,&:active{background:", (0, _colors.color_gradients_knight_shift), ";}}&:hover{background:", (0, _colors.color_gradients_green_shift_reverse), ";}&:active{box-shadow:inset 0px 0px 32px rgba(0, 0, 0, 0.25);}", "");
const inverseStyle = /*#__PURE__*/ (0, _css.css)("color:white;background:", (0, _colors.color_shades_darkest), ";border:1px solid white;.loader .spinner>div{background-color:white;}&:disabled{opacity:0.4;&:hover,&:active{background:", (0, _colors.color_shades_darkest), ";}}&:hover{background:rgba(255, 255, 255, 0.16);}&:active{box-shadow:inset 0px 0px 16px rgba(255, 255, 255, 0.5);}", "");
const primarySmallButton = /*#__PURE__*/ (0, _css.css)("color:white;background:", (0, _colors.color_gradients_green_shift), ";height:32px;padding:0 24px;font-size:14px;font-weight:normal;.loader .spinner>div{background-color:white;}.spinner{height:20px;}.secondary-loader{margin-top:-10px;}&:disabled{background:", (0, _colors.color_gradients_knight_shift), ";&:hover,&:active{background:", (0, _colors.color_gradients_knight_shift), ";}}&:hover{background:", (0, _colors.color_gradients_green_shift_reverse), ";}&:active{box-shadow:inset 0px 0px 32px rgba(0, 0, 0, 0.25);}", "");
const secondaryMediumButton = /*#__PURE__*/ (0, _css.css)("display:flex;justify-content:center;align-items:center;padding:0px;width:100%;height:48px;border:solid 1px ", (0, _colors.silver_four), ";border-radius:24px;color:", (0, _colors.color_shades_darkest), ";font-size:16px;line-height:24px;font-weight:600;margin:16px 0px;background:linear-gradient(224.91deg, #F5F9FC 3.06%, #FAFDFE 50.21%, #F4F5F5 100%);", "");
const hollowBlueButton = /*#__PURE__*/ (0, _css.css)("height:40px;border-radius:20px;border:dashed 1px ", (0, _colors.ocean_blue), ";color:", (0, _colors.ocean_blue), ";font-size:14px;background:transparent;box-shadow:none;margin-left:0px;padding:0;align-items:center;span{flex-grow:1;text-align:center;}", "");
const flatStyle = /*#__PURE__*/ (0, _css.css)("border:none;color:", (0, _colors.ocean_blue), ";background:transparent;", "");
const disabledStyle = /*#__PURE__*/ (0, _css.css)({
    name: "vpmk2w",
    styles: "opacity:.9"
});
const wideStyle = /*#__PURE__*/ (0, _css.css)({
    name: "gf7f9h",
    styles: "padding:14px 64px"
});
const mediumIconStyle = /*#__PURE__*/ (0, _css.css)({
    name: "8rcewz",
    styles: "height:25px;width:25px;background:transparent;box-shadow:none;border:none;margin:0 0 0 8px;padding:0"
});
const iconOnlyStyle = /*#__PURE__*/ (0, _css.css)({
    name: "1gf6a9o",
    styles: "background:transparent;box-shadow:none;border:none;width:auto;height:24px;padding:0;span{display:none;}img{margin-right:0;height:24px;width:auto;}"
});
const iconSmallOnlyStyle = /*#__PURE__*/ (0, _css.css)({
    name: "1oso7hu",
    styles: "background:transparent;box-shadow:none;border:none;width:24px;height:24px;padding:0;span{display:none;}img{margin-right:0;margin-top:-12px;height:18px;width:18px;}"
});
const iconLargeOnlyStyle = /*#__PURE__*/ (0, _css.css)({
    name: "1l3h09u",
    styles: "background:transparent;box-shadow:none;border:none;width:auto;height:42px;padding:0;span{display:none;}img{margin-right:0;height:42px;width:auto;}"
});
const actionItemStyle = /*#__PURE__*/ (0, _css.css)("width:124px;height:50px;border-radius:30px;border:solid 1px ", (0, _colors.ocean_blue), ";color:", (0, _colors.ocean_blue), ";background:transparent;font-family:Muli;font-size:12px;font-weight:600;font-style:normal;font-stretch:normal;line-height:normal;letter-spacing:normal;text-align:right;box-shadow:none;align-items:center;padding:0 24px;text-align:center;margin:0 16px;right-img{margin-left:0;}", "");
const whitePill = /*#__PURE__*/ (0, _css.css)("height:32px;padding:0 16px;font-size:14px;font-weight:400;line-height:20px;color:", (0, _colors.color_text_default), ";border:solid 1px ", (0, _colors.color_shades_dark), ";background:white;.secondary-loader{margin-top:-10px;}&:disabled{background:", (0, _colors.color_shades_light), ";color:", (0, _colors.color_text_light), ";&:hover,&:active{background:", (0, _colors.color_shades_light), ";}}&:hover{background:", (0, _colors.color_gradients_silver_shift_reverse), ";}.spinner{height:20px;}", "");
const contentStyle = /*#__PURE__*/ (0, _css.css)({
    name: "192s9p1",
    styles: "display:flex;flex-direction:row;justify-content:center;align-items:center"
});
const invisible = /*#__PURE__*/ (0, _css.css)({
    name: "mws4fn",
    styles: "opacity:0"
});
const borderHighlight = /*#__PURE__*/ (0, _css.css)("border:solid 2px ", (0, _colors.color_shades_darkest), ";", "");
const BorderHighlightCount = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e3g481u1"
})("background-color:", (0, _colors.color_shades_darkest), ";border-radius:50%;width:16px;height:16px;font-size:12px;line-height:16px;align-items:center;text-align:center;position:absolute;top:-8px;right:0px;");
const TwoDigitBorderHighlightCount = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e3g481u0"
})("background-color:", (0, _colors.color_shades_darkest), ";border-radius:50%;width:16px;height:16px;font-size:9px;line-height:16px;align-items:center;text-align:center;position:absolute;top:-8px;right:0px;");
const Button = (props)=>(0, _react.jsx)("button", {
        className: `${baseButtonStyle} ${props.borderHighlightCount?.length ? borderHighlight : ""} ${props.themes.map(getClassName).join(" ")} ${props.additionalClasses} ${props.disabled ? disabledStyle : null} ${props.className}`,
        type: props.type,
        onClick: props.onClick,
        disabled: props.disabled
    }, props.borderHighlightCount?.length === 1 && (0, _react.jsx)(BorderHighlightCount, null, props.borderHighlightCount), props.borderHighlightCount?.length > 1 && (0, _react.jsx)(TwoDigitBorderHighlightCount, null, props.borderHighlightCount), (0, _react.jsx)("div", {
        className: `${contentStyle} ${props.loading ? invisible : null}`
    }, props.icon !== undefined ? (0, _react.jsx)("img", {
        className: `left-img ${props.iconClassName}`,
        src: props.icon
    }) : null, props.leftComponent ? props.leftComponent() : null, props.text != null && (0, _react.jsx)("span", null, props.text), props.rightComponent ? props.rightComponent() : null, props.rightIcon !== undefined ? (0, _react.jsx)("img", {
        className: `right-img ${props.iconClassName}`,
        src: props.rightIcon
    }) : null), props.loading && (0, _react.jsx)((0, _secondaryLoaderDefault.default), {
        className: "secondary-loader"
    }));
exports.default = Button;

},{"@emotion/styled/base":"lSuFu","@emotion/react":"djZKr","@emotion/css":"awUBr","react":"6uln9","../../constants/colors":"1p3OR","./SecondaryLoader":"7zJiF","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7zJiF":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _colors = require("../../constants/colors");
const SecondaryLoader = (props)=>(0, _react.jsx)("div", {
        className: `${wrapperStyle} ${props.className} loader`
    }, (0, _react.jsx)("div", {
        className: "spinner"
    }, (0, _react.jsx)("div", {
        className: "rect1"
    }), (0, _react.jsx)("div", {
        className: "rect2"
    }), (0, _react.jsx)("div", {
        className: "rect3"
    }), (0, _react.jsx)("div", {
        className: "rect4"
    }), (0, _react.jsx)("div", {
        className: "rect5"
    })));
const wrapperStyle = /*#__PURE__*/ (0, _css.css)(".spinner{margin:0 auto;width:50px;height:40px;text-align:center;font-size:10px;}.spinner>div{background-color:white;height:100%;width:2px;margin-right:5px;display:inline-block;-webkit-animation:sk-stretchdelay 1.2s infinite ease-in-out;animation:sk-stretchdelay 1.2s infinite ease-in-out;}.spinner .rect2{-webkit-animation-delay:-1.1s;animation-delay:-1.1s;}.spinner .rect3{-webkit-animation-delay:-1.0s;animation-delay:-1.0s;}.spinner .rect4{-webkit-animation-delay:-0.9s;animation-delay:-0.9s;}.spinner .rect5{-webkit-animation-delay:-0.8s;animation-delay:-0.8s;}@-webkit-keyframes sk-stretchdelay{0%,40%,100%{-webkit-transform:scaleY(0.4);}20%{-webkit-transform:scaleY(1.0);}}@keyframes sk-stretchdelay{0%,40%,100%{transform:scaleY(0.4);-webkit-transform:scaleY(0.4);}20%{transform:scaleY(1.0);-webkit-transform:scaleY(1.0);}}&.grey{.spinner>div{background-color:", (0, _colors.cool_grey), ";}}", "");
exports.default = SecondaryLoader;

},{"@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","../../constants/colors":"1p3OR","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3FODC":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _bootstrapCss = require("rc-tooltip/assets/bootstrap.css");
var _tooltipWrapper = require("./TooltipWrapper");
var _tooltipWrapperDefault = parcelHelpers.interopDefault(_tooltipWrapper);
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const IconTooltip = (props)=>(0, _react.jsx)((0, _tooltipWrapperDefault.default), {
        place: props.place === undefined ? "top" : props.place,
        text: props.text,
        replacementContentStyle: props.replacementContentStyle
    }, (0, _react.jsx)("div", {
        className: `${tooltipStyle} ${props.className}`
    }, (0, _react.jsx)("span", null, "?")));
const tooltipStyle = /*#__PURE__*/ (0, _css.css)({
    name: "1rfftcc",
    styles: "width:17px;height:17px;border:solid 1px #007dbb;border-radius:50%;display:flex;align-items:center;justify-content:center;cursor:pointer;span{width:6px;height:17px;font-family:sans-serif;font-size:12px;font-style:normal;font-stretch:normal;line-height:17px;letter-spacing:0.5px;color:#007dbb;}"
});
exports.default = IconTooltip;

},{"@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","rc-tooltip/assets/bootstrap.css":"9MrrI","./TooltipWrapper":"53pWd","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9MrrI":[function() {},{}],"53pWd":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _rcTooltip = require("rc-tooltip");
var _rcTooltipDefault = parcelHelpers.interopDefault(_rcTooltip);
var _css = require("@emotion/css");
var _bootstrapCss = require("rc-tooltip/assets/bootstrap.css");
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const TooltipWrapper = (props)=>{
    const getTooltipStyle = ()=>{
        if (props.maxWidth) return /*#__PURE__*/ (0, _css.css)(".rc-tooltip-inner{font-family:Muli;font-size:14px;font-weight:normal;font-style:normal;letter-spacing:0.6px;z-index:120;color:white;background-color:#304562;box-shadow:-1px 4px 10px 0 rgba(48, 69, 98, 0.1);padding:8px;min-height:0;max-width:", typeof props.maxWidth === "number" ? `${props.maxWidth}px` : props.maxWidth, ";white-space:normal;word-wrap:break-word;}", "");
        return tooltipContentStyle;
    };
    return (0, _react.jsx)((0, _rcTooltipDefault.default), {
        mouseEnterDelay: props.mouseEnterDelay ? props.mouseEnterDelay : 0.5,
        overlayClassName: props.replacementContentStyle ? props.replacementContentStyle : getTooltipStyle() + " " + props.className,
        placement: props.place === undefined ? "top" : props.place,
        trigger: [
            "hover"
        ],
        overlay: (0, _react.jsx)("span", null, props.text)
    }, props.children);
};
const tooltipContentStyle = /*#__PURE__*/ (0, _css.css)({
    name: "11143my",
    styles: ".rc-tooltip-inner{font-family:Muli;font-size:14px;font-weight:normal;font-style:normal;letter-spacing:0.6px;z-index:120;color:white;background-color:#304562;box-shadow:-1px 4px 10px 0 rgba(48, 69, 98, 0.1);padding:8px;min-height:0;}"
});
exports.default = TooltipWrapper;

},{"@emotion/react":"djZKr","react":"6uln9","rc-tooltip":"fhD1R","@emotion/css":"awUBr","rc-tooltip/assets/bootstrap.css":"9MrrI","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"fhD1R":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _tooltip = require("./Tooltip");
var _tooltipDefault = parcelHelpers.interopDefault(_tooltip);
exports.default = (0, _tooltipDefault.default);

},{"./Tooltip":"fchOx","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"fchOx":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _extends = require("babel-runtime/helpers/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutProperties = require("babel-runtime/helpers/objectWithoutProperties");
var _objectWithoutPropertiesDefault = parcelHelpers.interopDefault(_objectWithoutProperties);
var _classCallCheck = require("babel-runtime/helpers/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _possibleConstructorReturn = require("babel-runtime/helpers/possibleConstructorReturn");
var _possibleConstructorReturnDefault = parcelHelpers.interopDefault(_possibleConstructorReturn);
var _inherits = require("babel-runtime/helpers/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _rcTrigger = require("rc-trigger");
var _rcTriggerDefault = parcelHelpers.interopDefault(_rcTrigger);
var _placements = require("./placements");
var _content = require("./Content");
var _contentDefault = parcelHelpers.interopDefault(_content);
var Tooltip = function(_Component) {
    (0, _inheritsDefault.default)(Tooltip, _Component);
    function Tooltip() {
        var _temp, _this, _ret;
        (0, _classCallCheckDefault.default)(this, Tooltip);
        for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return _ret = (_temp = (_this = (0, _possibleConstructorReturnDefault.default)(this, _Component.call.apply(_Component, [
            this
        ].concat(args))), _this), _this.getPopupElement = function() {
            var _this$props = _this.props, arrowContent = _this$props.arrowContent, overlay = _this$props.overlay, prefixCls = _this$props.prefixCls, id = _this$props.id;
            return [
                (0, _reactDefault.default).createElement("div", {
                    className: prefixCls + "-arrow",
                    key: "arrow"
                }, arrowContent),
                (0, _reactDefault.default).createElement((0, _contentDefault.default), {
                    key: "content",
                    trigger: _this.trigger,
                    prefixCls: prefixCls,
                    id: id,
                    overlay: overlay
                })
            ];
        }, _this.saveTrigger = function(node) {
            _this.trigger = node;
        }, _temp), (0, _possibleConstructorReturnDefault.default)(_this, _ret);
    }
    Tooltip.prototype.getPopupDomNode = function getPopupDomNode() {
        return this.trigger.getPopupDomNode();
    };
    Tooltip.prototype.render = function render() {
        var _props = this.props, overlayClassName = _props.overlayClassName, trigger = _props.trigger, mouseEnterDelay = _props.mouseEnterDelay, mouseLeaveDelay = _props.mouseLeaveDelay, overlayStyle = _props.overlayStyle, prefixCls = _props.prefixCls, children = _props.children, onVisibleChange = _props.onVisibleChange, afterVisibleChange = _props.afterVisibleChange, transitionName = _props.transitionName, animation = _props.animation, placement = _props.placement, align = _props.align, destroyTooltipOnHide = _props.destroyTooltipOnHide, defaultVisible = _props.defaultVisible, getTooltipContainer = _props.getTooltipContainer, restProps = (0, _objectWithoutPropertiesDefault.default)(_props, [
            "overlayClassName",
            "trigger",
            "mouseEnterDelay",
            "mouseLeaveDelay",
            "overlayStyle",
            "prefixCls",
            "children",
            "onVisibleChange",
            "afterVisibleChange",
            "transitionName",
            "animation",
            "placement",
            "align",
            "destroyTooltipOnHide",
            "defaultVisible",
            "getTooltipContainer"
        ]);
        var extraProps = (0, _extendsDefault.default)({}, restProps);
        if ("visible" in this.props) extraProps.popupVisible = this.props.visible;
        return (0, _reactDefault.default).createElement((0, _rcTriggerDefault.default), (0, _extendsDefault.default)({
            popupClassName: overlayClassName,
            ref: this.saveTrigger,
            prefixCls: prefixCls,
            popup: this.getPopupElement,
            action: trigger,
            builtinPlacements: (0, _placements.placements),
            popupPlacement: placement,
            popupAlign: align,
            getPopupContainer: getTooltipContainer,
            onPopupVisibleChange: onVisibleChange,
            afterPopupVisibleChange: afterVisibleChange,
            popupTransitionName: transitionName,
            popupAnimation: animation,
            defaultPopupVisible: defaultVisible,
            destroyPopupOnHide: destroyTooltipOnHide,
            mouseLeaveDelay: mouseLeaveDelay,
            popupStyle: overlayStyle,
            mouseEnterDelay: mouseEnterDelay
        }, extraProps), children);
    };
    return Tooltip;
}((0, _react.Component));
Tooltip.propTypes = {
    trigger: (0, _propTypesDefault.default).any,
    children: (0, _propTypesDefault.default).any,
    defaultVisible: (0, _propTypesDefault.default).bool,
    visible: (0, _propTypesDefault.default).bool,
    placement: (0, _propTypesDefault.default).string,
    transitionName: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).string,
        (0, _propTypesDefault.default).object
    ]),
    animation: (0, _propTypesDefault.default).any,
    onVisibleChange: (0, _propTypesDefault.default).func,
    afterVisibleChange: (0, _propTypesDefault.default).func,
    overlay: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).node,
        (0, _propTypesDefault.default).func
    ]).isRequired,
    overlayStyle: (0, _propTypesDefault.default).object,
    overlayClassName: (0, _propTypesDefault.default).string,
    prefixCls: (0, _propTypesDefault.default).string,
    mouseEnterDelay: (0, _propTypesDefault.default).number,
    mouseLeaveDelay: (0, _propTypesDefault.default).number,
    getTooltipContainer: (0, _propTypesDefault.default).func,
    destroyTooltipOnHide: (0, _propTypesDefault.default).bool,
    align: (0, _propTypesDefault.default).object,
    arrowContent: (0, _propTypesDefault.default).any,
    id: (0, _propTypesDefault.default).string
};
Tooltip.defaultProps = {
    prefixCls: "rc-tooltip",
    mouseEnterDelay: 0,
    destroyTooltipOnHide: false,
    mouseLeaveDelay: 0.1,
    align: {},
    placement: "right",
    trigger: [
        "hover"
    ],
    arrowContent: null
};
exports.default = Tooltip;

},{"babel-runtime/helpers/extends":"4sKqp","babel-runtime/helpers/objectWithoutProperties":"5ILj2","babel-runtime/helpers/classCallCheck":"aRpYz","babel-runtime/helpers/possibleConstructorReturn":"40Qb5","babel-runtime/helpers/inherits":"bitir","react":"6uln9","prop-types":"6FKs7","rc-trigger":"k2w8n","./placements":"k16CU","./Content":"jC08b","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4sKqp":[function(require,module,exports) {
"use strict";
exports.__esModule = true;
var _assign = require("e12f447c1087414c");
var _assign2 = _interopRequireDefault(_assign);
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
exports.default = _assign2.default || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};

},{"e12f447c1087414c":"6lYCG"}],"6lYCG":[function(require,module,exports) {
module.exports = {
    "default": require("7b76f2e705bf7177"),
    __esModule: true
};

},{"7b76f2e705bf7177":"a8aV5"}],"a8aV5":[function(require,module,exports) {
require("499732afec0c6473");
module.exports = require("e33f8ad42e6e7415").Object.assign;

},{"499732afec0c6473":"8zAEB","e33f8ad42e6e7415":"i8kQt"}],"8zAEB":[function(require,module,exports) {
// 19.1.3.1 Object.assign(target, source)
var $export = require("4587991bf938f407");
$export($export.S + $export.F, "Object", {
    assign: require("53844b2e03297d21")
});

},{"4587991bf938f407":"1OjY7","53844b2e03297d21":"hQzfA"}],"1OjY7":[function(require,module,exports) {
var global = require("280d898477400d74");
var core = require("675cdc75da15c6cc");
var ctx = require("b3e02d951b36329c");
var hide = require("ddc23a3c61502858");
var has = require("918e8739fa09f494");
var PROTOTYPE = "prototype";
var $export = function(type, name, source) {
    var IS_FORCED = type & $export.F;
    var IS_GLOBAL = type & $export.G;
    var IS_STATIC = type & $export.S;
    var IS_PROTO = type & $export.P;
    var IS_BIND = type & $export.B;
    var IS_WRAP = type & $export.W;
    var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
    var expProto = exports[PROTOTYPE];
    var target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE];
    var key, own, out;
    if (IS_GLOBAL) source = name;
    for(key in source){
        // contains in native
        own = !IS_FORCED && target && target[key] !== undefined;
        if (own && has(exports, key)) continue;
        // export native or passed
        out = own ? target[key] : source[key];
        // prevent global pollution for namespaces
        exports[key] = IS_GLOBAL && typeof target[key] != "function" ? source[key] : IS_BIND && own ? ctx(out, global) : IS_WRAP && target[key] == out ? function(C) {
            var F = function(a, b, c) {
                if (this instanceof C) {
                    switch(arguments.length){
                        case 0:
                            return new C();
                        case 1:
                            return new C(a);
                        case 2:
                            return new C(a, b);
                    }
                    return new C(a, b, c);
                }
                return C.apply(this, arguments);
            };
            F[PROTOTYPE] = C[PROTOTYPE];
            return F;
        // make static versions for prototype methods
        }(out) : IS_PROTO && typeof out == "function" ? ctx(Function.call, out) : out;
        // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
        if (IS_PROTO) {
            (exports.virtual || (exports.virtual = {}))[key] = out;
            // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
            if (type & $export.R && expProto && !expProto[key]) hide(expProto, key, out);
        }
    }
};
// type bitmap
$export.F = 1; // forced
$export.G = 2; // global
$export.S = 4; // static
$export.P = 8; // proto
$export.B = 16; // bind
$export.W = 32; // wrap
$export.U = 64; // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;

},{"280d898477400d74":"bV7oC","675cdc75da15c6cc":"i8kQt","b3e02d951b36329c":"iSPoi","ddc23a3c61502858":"i6BBP","918e8739fa09f494":"jZWXj"}],"bV7oC":[function(require,module,exports) {
// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != "undefined" && window.Math == Math ? window : typeof self != "undefined" && self.Math == Math ? self : Function("return this")();
if (typeof __g == "number") __g = global; // eslint-disable-line no-undef

},{}],"i8kQt":[function(require,module,exports) {
var core = module.exports = {
    version: "2.6.12"
};
if (typeof __e == "number") __e = core; // eslint-disable-line no-undef

},{}],"iSPoi":[function(require,module,exports) {
// optional / simple context binding
var aFunction = require("c33d1bc3a4957666");
module.exports = function(fn, that, length) {
    aFunction(fn);
    if (that === undefined) return fn;
    switch(length){
        case 1:
            return function(a) {
                return fn.call(that, a);
            };
        case 2:
            return function(a, b) {
                return fn.call(that, a, b);
            };
        case 3:
            return function(a, b, c) {
                return fn.call(that, a, b, c);
            };
    }
    return function() {
        return fn.apply(that, arguments);
    };
};

},{"c33d1bc3a4957666":"lyxzz"}],"lyxzz":[function(require,module,exports) {
module.exports = function(it) {
    if (typeof it != "function") throw TypeError(it + " is not a function!");
    return it;
};

},{}],"i6BBP":[function(require,module,exports) {
var dP = require("b50b81010811f779");
var createDesc = require("6ae41bf95c963be1");
module.exports = require("aca69a30f8d97bbf") ? function(object, key, value) {
    return dP.f(object, key, createDesc(1, value));
} : function(object, key, value) {
    object[key] = value;
    return object;
};

},{"b50b81010811f779":"5eLt9","6ae41bf95c963be1":"kXqBU","aca69a30f8d97bbf":"cWdn9"}],"5eLt9":[function(require,module,exports) {
var anObject = require("39c1614979b2c200");
var IE8_DOM_DEFINE = require("81b6a1862b6bb3f4");
var toPrimitive = require("23225402685cd00b");
var dP = Object.defineProperty;
exports.f = require("e768d3f130c18468") ? Object.defineProperty : function defineProperty(O, P, Attributes) {
    anObject(O);
    P = toPrimitive(P, true);
    anObject(Attributes);
    if (IE8_DOM_DEFINE) try {
        return dP(O, P, Attributes);
    } catch (e) {}
    if ("get" in Attributes || "set" in Attributes) throw TypeError("Accessors not supported!");
    if ("value" in Attributes) O[P] = Attributes.value;
    return O;
};

},{"39c1614979b2c200":"lKEVJ","81b6a1862b6bb3f4":"3CQhA","23225402685cd00b":"7WUHL","e768d3f130c18468":"cWdn9"}],"lKEVJ":[function(require,module,exports) {
var isObject = require("d1fa6c6d718b2af0");
module.exports = function(it) {
    if (!isObject(it)) throw TypeError(it + " is not an object!");
    return it;
};

},{"d1fa6c6d718b2af0":"5vzl3"}],"5vzl3":[function(require,module,exports) {
module.exports = function(it) {
    return typeof it === "object" ? it !== null : typeof it === "function";
};

},{}],"3CQhA":[function(require,module,exports) {
module.exports = !require("25e39c96b485a2d4") && !require("841f8f7344d52e3c")(function() {
    return Object.defineProperty(require("26ea8bab98f45102")("div"), "a", {
        get: function() {
            return 7;
        }
    }).a != 7;
});

},{"25e39c96b485a2d4":"cWdn9","841f8f7344d52e3c":"aH906","26ea8bab98f45102":"bEQp2"}],"cWdn9":[function(require,module,exports) {
// Thank's IE8 for his funny defineProperty
module.exports = !require("384e64392289cbf0")(function() {
    return Object.defineProperty({}, "a", {
        get: function() {
            return 7;
        }
    }).a != 7;
});

},{"384e64392289cbf0":"aH906"}],"aH906":[function(require,module,exports) {
module.exports = function(exec) {
    try {
        return !!exec();
    } catch (e) {
        return true;
    }
};

},{}],"bEQp2":[function(require,module,exports) {
var isObject = require("1c4f66d669be867c");
var document = require("382f8de20d058e56").document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function(it) {
    return is ? document.createElement(it) : {};
};

},{"1c4f66d669be867c":"5vzl3","382f8de20d058e56":"bV7oC"}],"7WUHL":[function(require,module,exports) {
// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = require("bdd1a0adae2b9200");
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function(it, S) {
    if (!isObject(it)) return it;
    var fn, val;
    if (S && typeof (fn = it.toString) == "function" && !isObject(val = fn.call(it))) return val;
    if (typeof (fn = it.valueOf) == "function" && !isObject(val = fn.call(it))) return val;
    if (!S && typeof (fn = it.toString) == "function" && !isObject(val = fn.call(it))) return val;
    throw TypeError("Can't convert object to primitive value");
};

},{"bdd1a0adae2b9200":"5vzl3"}],"kXqBU":[function(require,module,exports) {
module.exports = function(bitmap, value) {
    return {
        enumerable: !(bitmap & 1),
        configurable: !(bitmap & 2),
        writable: !(bitmap & 4),
        value: value
    };
};

},{}],"jZWXj":[function(require,module,exports) {
var hasOwnProperty = {}.hasOwnProperty;
module.exports = function(it, key) {
    return hasOwnProperty.call(it, key);
};

},{}],"hQzfA":[function(require,module,exports) {
"use strict";
// 19.1.2.1 Object.assign(target, source, ...)
var DESCRIPTORS = require("610643f9a7e845fd");
var getKeys = require("a6919a51acee1f44");
var gOPS = require("b8228437cef56ad1");
var pIE = require("d1effcc7f65e2eb9");
var toObject = require("ccff939573ec7392");
var IObject = require("eb5596891e1c7297");
var $assign = Object.assign;
// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || require("4776b0ffe2bd33b4")(function() {
    var A = {};
    var B = {};
    // eslint-disable-next-line no-undef
    var S = Symbol();
    var K = "abcdefghijklmnopqrst";
    A[S] = 7;
    K.split("").forEach(function(k) {
        B[k] = k;
    });
    return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join("") != K;
}) ? function assign(target, source) {
    var T = toObject(target);
    var aLen = arguments.length;
    var index = 1;
    var getSymbols = gOPS.f;
    var isEnum = pIE.f;
    while(aLen > index){
        var S = IObject(arguments[index++]);
        var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
        var length = keys.length;
        var j = 0;
        var key;
        while(length > j){
            key = keys[j++];
            if (!DESCRIPTORS || isEnum.call(S, key)) T[key] = S[key];
        }
    }
    return T;
} : $assign;

},{"610643f9a7e845fd":"cWdn9","a6919a51acee1f44":"4aWXn","b8228437cef56ad1":"hwRd3","d1effcc7f65e2eb9":"776i5","ccff939573ec7392":"9EHnZ","eb5596891e1c7297":"9PQ3Z","4776b0ffe2bd33b4":"aH906"}],"4aWXn":[function(require,module,exports) {
// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = require("83bf1dd0ae7b0622");
var enumBugKeys = require("aa7e0a358876d00c");
module.exports = Object.keys || function keys(O) {
    return $keys(O, enumBugKeys);
};

},{"83bf1dd0ae7b0622":"6yDxd","aa7e0a358876d00c":"V3uQX"}],"6yDxd":[function(require,module,exports) {
var has = require("19f1433d756f3251");
var toIObject = require("4626991d72c1fcd");
var arrayIndexOf = require("f81292748a921fda")(false);
var IE_PROTO = require("349910d3215930c1")("IE_PROTO");
module.exports = function(object, names) {
    var O = toIObject(object);
    var i = 0;
    var result = [];
    var key;
    for(key in O)if (key != IE_PROTO) has(O, key) && result.push(key);
    // Don't enum bug & hidden keys
    while(names.length > i)if (has(O, key = names[i++])) ~arrayIndexOf(result, key) || result.push(key);
    return result;
};

},{"19f1433d756f3251":"jZWXj","4626991d72c1fcd":"lvd6c","f81292748a921fda":"fqRit","349910d3215930c1":"7troK"}],"lvd6c":[function(require,module,exports) {
// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = require("76ab360111d1d2d9");
var defined = require("c62d0cb871c23bd7");
module.exports = function(it) {
    return IObject(defined(it));
};

},{"76ab360111d1d2d9":"9PQ3Z","c62d0cb871c23bd7":"2JLDG"}],"9PQ3Z":[function(require,module,exports) {
// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = require("10557191e79a9200");
// eslint-disable-next-line no-prototype-builtins
module.exports = Object("z").propertyIsEnumerable(0) ? Object : function(it) {
    return cof(it) == "String" ? it.split("") : Object(it);
};

},{"10557191e79a9200":"kIPjW"}],"kIPjW":[function(require,module,exports) {
var toString = {}.toString;
module.exports = function(it) {
    return toString.call(it).slice(8, -1);
};

},{}],"2JLDG":[function(require,module,exports) {
// 7.2.1 RequireObjectCoercible(argument)
module.exports = function(it) {
    if (it == undefined) throw TypeError("Can't call method on  " + it);
    return it;
};

},{}],"fqRit":[function(require,module,exports) {
// false -> Array#indexOf
// true  -> Array#includes
var toIObject = require("4aaea5637bd59385");
var toLength = require("2044469173066fde");
var toAbsoluteIndex = require("f86a3a55c2aa7910");
module.exports = function(IS_INCLUDES) {
    return function($this, el, fromIndex) {
        var O = toIObject($this);
        var length = toLength(O.length);
        var index = toAbsoluteIndex(fromIndex, length);
        var value;
        // Array#includes uses SameValueZero equality algorithm
        // eslint-disable-next-line no-self-compare
        if (IS_INCLUDES && el != el) while(length > index){
            value = O[index++];
            // eslint-disable-next-line no-self-compare
            if (value != value) return true;
        // Array#indexOf ignores holes, Array#includes - not
        }
        else for(; length > index; index++)if (IS_INCLUDES || index in O) {
            if (O[index] === el) return IS_INCLUDES || index || 0;
        }
        return !IS_INCLUDES && -1;
    };
};

},{"4aaea5637bd59385":"lvd6c","2044469173066fde":"1O25p","f86a3a55c2aa7910":"8PQfg"}],"1O25p":[function(require,module,exports) {
// 7.1.15 ToLength
var toInteger = require("d63df52ef85f45a2");
var min = Math.min;
module.exports = function(it) {
    return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};

},{"d63df52ef85f45a2":"hPN4G"}],"hPN4G":[function(require,module,exports) {
// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function(it) {
    return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};

},{}],"8PQfg":[function(require,module,exports) {
var toInteger = require("75f147d516ea7b5e");
var max = Math.max;
var min = Math.min;
module.exports = function(index, length) {
    index = toInteger(index);
    return index < 0 ? max(index + length, 0) : min(index, length);
};

},{"75f147d516ea7b5e":"hPN4G"}],"7troK":[function(require,module,exports) {
var shared = require("18917a110413abfe")("keys");
var uid = require("c3184fd773e126e");
module.exports = function(key) {
    return shared[key] || (shared[key] = uid(key));
};

},{"18917a110413abfe":"6JJsZ","c3184fd773e126e":"1UVZ8"}],"6JJsZ":[function(require,module,exports) {
var core = require("443054df79395d0d");
var global = require("1aebfd1372ec9222");
var SHARED = "__core-js_shared__";
var store = global[SHARED] || (global[SHARED] = {});
(module.exports = function(key, value) {
    return store[key] || (store[key] = value !== undefined ? value : {});
})("versions", []).push({
    version: core.version,
    mode: require("16256dc5906d6b84") ? "pure" : "global",
    copyright: "\xa9 2020 Denis Pushkarev (zloirock.ru)"
});

},{"443054df79395d0d":"i8kQt","1aebfd1372ec9222":"bV7oC","16256dc5906d6b84":"ie1W2"}],"ie1W2":[function(require,module,exports) {
module.exports = true;

},{}],"1UVZ8":[function(require,module,exports) {
var id = 0;
var px = Math.random();
module.exports = function(key) {
    return "Symbol(".concat(key === undefined ? "" : key, ")_", (++id + px).toString(36));
};

},{}],"V3uQX":[function(require,module,exports) {
// IE 8- don't enum bug keys
module.exports = "constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf".split(",");

},{}],"hwRd3":[function(require,module,exports) {
exports.f = Object.getOwnPropertySymbols;

},{}],"776i5":[function(require,module,exports) {
exports.f = ({}).propertyIsEnumerable;

},{}],"9EHnZ":[function(require,module,exports) {
// 7.1.13 ToObject(argument)
var defined = require("b3a9e0e833d52b9f");
module.exports = function(it) {
    return Object(defined(it));
};

},{"b3a9e0e833d52b9f":"2JLDG"}],"5ILj2":[function(require,module,exports) {
"use strict";
exports.__esModule = true;
exports.default = function(obj, keys) {
    var target = {};
    for(var i in obj){
        if (keys.indexOf(i) >= 0) continue;
        if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
        target[i] = obj[i];
    }
    return target;
};

},{}],"aRpYz":[function(require,module,exports) {
"use strict";
exports.__esModule = true;
exports.default = function(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
};

},{}],"40Qb5":[function(require,module,exports) {
"use strict";
exports.__esModule = true;
var _typeof2 = require("6909991043fbc889");
var _typeof3 = _interopRequireDefault(_typeof2);
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
exports.default = function(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && ((typeof call === "undefined" ? "undefined" : (0, _typeof3.default)(call)) === "object" || typeof call === "function") ? call : self;
};

},{"6909991043fbc889":"bOmQJ"}],"bOmQJ":[function(require,module,exports) {
"use strict";
exports.__esModule = true;
var _iterator = require("f41d4f4d4fa5a622");
var _iterator2 = _interopRequireDefault(_iterator);
var _symbol = require("ada2ef59a5a3c468");
var _symbol2 = _interopRequireDefault(_symbol);
var _typeof = typeof _symbol2.default === "function" && typeof _iterator2.default === "symbol" ? function(obj) {
    return typeof obj;
} : function(obj) {
    return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj;
};
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
exports.default = typeof _symbol2.default === "function" && _typeof(_iterator2.default) === "symbol" ? function(obj) {
    return typeof obj === "undefined" ? "undefined" : _typeof(obj);
} : function(obj) {
    return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof(obj);
};

},{"f41d4f4d4fa5a622":"cn4BZ","ada2ef59a5a3c468":"44gK3"}],"cn4BZ":[function(require,module,exports) {
module.exports = {
    "default": require("99c786451cb3b226"),
    __esModule: true
};

},{"99c786451cb3b226":"kflJA"}],"kflJA":[function(require,module,exports) {
require("44a00a76b46fb96c");
require("f93e3c969396bb1f");
module.exports = require("dd65d7f04b4d0db9").f("iterator");

},{"44a00a76b46fb96c":"iJCxM","f93e3c969396bb1f":"aRmhL","dd65d7f04b4d0db9":"3e3la"}],"iJCxM":[function(require,module,exports) {
"use strict";
var $at = require("8d07ae22087de20d")(true);
// 21.1.3.27 String.prototype[@@iterator]()
require("9e278c7f3efb7a96")(String, "String", function(iterated) {
    this._t = String(iterated); // target
    this._i = 0; // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function() {
    var O = this._t;
    var index = this._i;
    var point;
    if (index >= O.length) return {
        value: undefined,
        done: true
    };
    point = $at(O, index);
    this._i += point.length;
    return {
        value: point,
        done: false
    };
});

},{"8d07ae22087de20d":"hnu6p","9e278c7f3efb7a96":"kMwI6"}],"hnu6p":[function(require,module,exports) {
var toInteger = require("3f54fc3c8db55a01");
var defined = require("d06edc204c8b8769");
// true  -> String#at
// false -> String#codePointAt
module.exports = function(TO_STRING) {
    return function(that, pos) {
        var s = String(defined(that));
        var i = toInteger(pos);
        var l = s.length;
        var a, b;
        if (i < 0 || i >= l) return TO_STRING ? "" : undefined;
        a = s.charCodeAt(i);
        return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff ? TO_STRING ? s.charAt(i) : a : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
    };
};

},{"3f54fc3c8db55a01":"hPN4G","d06edc204c8b8769":"2JLDG"}],"kMwI6":[function(require,module,exports) {
"use strict";
var LIBRARY = require("6bb05d3465752b71");
var $export = require("e4f1cc3b9e2c0947");
var redefine = require("a02a43b9ed26fdd9");
var hide = require("9a19daf201bdba88");
var Iterators = require("cc1cd1fef5554b16");
var $iterCreate = require("afa8ddd96166b30");
var setToStringTag = require("fe3caee02c0d6524");
var getPrototypeOf = require("5a82d3fc3c956369");
var ITERATOR = require("5d579c9ff4dfb6b2")("iterator");
var BUGGY = !([].keys && "next" in [].keys()); // Safari has buggy iterators w/o `next`
var FF_ITERATOR = "@@iterator";
var KEYS = "keys";
var VALUES = "values";
var returnThis = function() {
    return this;
};
module.exports = function(Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
    $iterCreate(Constructor, NAME, next);
    var getMethod = function(kind) {
        if (!BUGGY && kind in proto) return proto[kind];
        switch(kind){
            case KEYS:
                return function keys() {
                    return new Constructor(this, kind);
                };
            case VALUES:
                return function values() {
                    return new Constructor(this, kind);
                };
        }
        return function entries() {
            return new Constructor(this, kind);
        };
    };
    var TAG = NAME + " Iterator";
    var DEF_VALUES = DEFAULT == VALUES;
    var VALUES_BUG = false;
    var proto = Base.prototype;
    var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
    var $default = $native || getMethod(DEFAULT);
    var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod("entries") : undefined;
    var $anyNative = NAME == "Array" ? proto.entries || $native : $native;
    var methods, key, IteratorPrototype;
    // Fix native
    if ($anyNative) {
        IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
        if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
            // Set @@toStringTag to native iterators
            setToStringTag(IteratorPrototype, TAG, true);
            // fix for some old engines
            if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != "function") hide(IteratorPrototype, ITERATOR, returnThis);
        }
    }
    // fix Array#{values, @@iterator}.name in V8 / FF
    if (DEF_VALUES && $native && $native.name !== VALUES) {
        VALUES_BUG = true;
        $default = function values() {
            return $native.call(this);
        };
    }
    // Define iterator
    if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) hide(proto, ITERATOR, $default);
    // Plug for library
    Iterators[NAME] = $default;
    Iterators[TAG] = returnThis;
    if (DEFAULT) {
        methods = {
            values: DEF_VALUES ? $default : getMethod(VALUES),
            keys: IS_SET ? $default : getMethod(KEYS),
            entries: $entries
        };
        if (FORCED) {
            for(key in methods)if (!(key in proto)) redefine(proto, key, methods[key]);
        } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
    }
    return methods;
};

},{"6bb05d3465752b71":"ie1W2","e4f1cc3b9e2c0947":"1OjY7","a02a43b9ed26fdd9":"9hsMK","9a19daf201bdba88":"i6BBP","cc1cd1fef5554b16":"3kquG","afa8ddd96166b30":"5c0HO","fe3caee02c0d6524":"4bIRS","5a82d3fc3c956369":"2Nq78","5d579c9ff4dfb6b2":"6tZlw"}],"9hsMK":[function(require,module,exports) {
module.exports = require("9ced2b686e442bb2");

},{"9ced2b686e442bb2":"i6BBP"}],"3kquG":[function(require,module,exports) {
module.exports = {};

},{}],"5c0HO":[function(require,module,exports) {
"use strict";
var create = require("e4ae83845828a2aa");
var descriptor = require("85d9ee9eb4c6ba27");
var setToStringTag = require("9e8e80d79938c7f8");
var IteratorPrototype = {};
// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
require("e3167c9ebe25a73d")(IteratorPrototype, require("ad3be10a7c36b1f9")("iterator"), function() {
    return this;
});
module.exports = function(Constructor, NAME, next) {
    Constructor.prototype = create(IteratorPrototype, {
        next: descriptor(1, next)
    });
    setToStringTag(Constructor, NAME + " Iterator");
};

},{"e4ae83845828a2aa":"02z79","85d9ee9eb4c6ba27":"kXqBU","9e8e80d79938c7f8":"4bIRS","e3167c9ebe25a73d":"i6BBP","ad3be10a7c36b1f9":"6tZlw"}],"02z79":[function(require,module,exports) {
// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject = require("1fa61a504d40b972");
var dPs = require("76cf3eba6ddc81d1");
var enumBugKeys = require("39d51ebc5541e860");
var IE_PROTO = require("2b78440fa37f8a95")("IE_PROTO");
var Empty = function() {};
var PROTOTYPE = "prototype";
// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function() {
    // Thrash, waste and sodomy: IE GC bug
    var iframe = require("8e35574987124799")("iframe");
    var i = enumBugKeys.length;
    var lt = "<";
    var gt = ">";
    var iframeDocument;
    iframe.style.display = "none";
    require("c37e267ee3dbf715").appendChild(iframe);
    iframe.src = "javascript:"; // eslint-disable-line no-script-url
    // createDict = iframe.contentWindow.Object;
    // html.removeChild(iframe);
    iframeDocument = iframe.contentWindow.document;
    iframeDocument.open();
    iframeDocument.write(lt + "script" + gt + "document.F=Object" + lt + "/script" + gt);
    iframeDocument.close();
    createDict = iframeDocument.F;
    while(i--)delete createDict[PROTOTYPE][enumBugKeys[i]];
    return createDict();
};
module.exports = Object.create || function create(O, Properties) {
    var result;
    if (O !== null) {
        Empty[PROTOTYPE] = anObject(O);
        result = new Empty();
        Empty[PROTOTYPE] = null;
        // add "__proto__" for Object.getPrototypeOf polyfill
        result[IE_PROTO] = O;
    } else result = createDict();
    return Properties === undefined ? result : dPs(result, Properties);
};

},{"1fa61a504d40b972":"lKEVJ","76cf3eba6ddc81d1":"7TXgc","39d51ebc5541e860":"V3uQX","2b78440fa37f8a95":"7troK","8e35574987124799":"bEQp2","c37e267ee3dbf715":"3o2JY"}],"7TXgc":[function(require,module,exports) {
var dP = require("b29612eb3fb18115");
var anObject = require("568312fac5f26994");
var getKeys = require("c34773372ab2df59");
module.exports = require("37f8dcade3828c33") ? Object.defineProperties : function defineProperties(O, Properties) {
    anObject(O);
    var keys = getKeys(Properties);
    var length = keys.length;
    var i = 0;
    var P;
    while(length > i)dP.f(O, P = keys[i++], Properties[P]);
    return O;
};

},{"b29612eb3fb18115":"5eLt9","568312fac5f26994":"lKEVJ","c34773372ab2df59":"4aWXn","37f8dcade3828c33":"cWdn9"}],"3o2JY":[function(require,module,exports) {
var document = require("921a406e1fdd4e6a").document;
module.exports = document && document.documentElement;

},{"921a406e1fdd4e6a":"bV7oC"}],"4bIRS":[function(require,module,exports) {
var def = require("a1c983a109140fbe").f;
var has = require("f776475192a542ec");
var TAG = require("e3b4e162022e1752")("toStringTag");
module.exports = function(it, tag, stat) {
    if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, {
        configurable: true,
        value: tag
    });
};

},{"a1c983a109140fbe":"5eLt9","f776475192a542ec":"jZWXj","e3b4e162022e1752":"6tZlw"}],"6tZlw":[function(require,module,exports) {
var store = require("ffb7e96c18d6e9d4")("wks");
var uid = require("1d0c13f10f895548");
var Symbol = require("289e8212e45173a3").Symbol;
var USE_SYMBOL = typeof Symbol == "function";
var $exports = module.exports = function(name) {
    return store[name] || (store[name] = USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)("Symbol." + name));
};
$exports.store = store;

},{"ffb7e96c18d6e9d4":"6JJsZ","1d0c13f10f895548":"1UVZ8","289e8212e45173a3":"bV7oC"}],"2Nq78":[function(require,module,exports) {
// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has = require("f7669a429bc0e42f");
var toObject = require("35e3083392839332");
var IE_PROTO = require("33d9c6376c04df78")("IE_PROTO");
var ObjectProto = Object.prototype;
module.exports = Object.getPrototypeOf || function(O) {
    O = toObject(O);
    if (has(O, IE_PROTO)) return O[IE_PROTO];
    if (typeof O.constructor == "function" && O instanceof O.constructor) return O.constructor.prototype;
    return O instanceof Object ? ObjectProto : null;
};

},{"f7669a429bc0e42f":"jZWXj","35e3083392839332":"9EHnZ","33d9c6376c04df78":"7troK"}],"aRmhL":[function(require,module,exports) {
require("1fd7ec5d057c5247");
var global = require("ea8afe01648d7536");
var hide = require("5963e4f6c05ce105");
var Iterators = require("ba2ce9e28b06eea5");
var TO_STRING_TAG = require("f5a73184ebec5e24")("toStringTag");
var DOMIterables = "CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,TextTrackList,TouchList".split(",");
for(var i = 0; i < DOMIterables.length; i++){
    var NAME = DOMIterables[i];
    var Collection = global[NAME];
    var proto = Collection && Collection.prototype;
    if (proto && !proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
    Iterators[NAME] = Iterators.Array;
}

},{"1fd7ec5d057c5247":"h3Yxv","ea8afe01648d7536":"bV7oC","5963e4f6c05ce105":"i6BBP","ba2ce9e28b06eea5":"3kquG","f5a73184ebec5e24":"6tZlw"}],"h3Yxv":[function(require,module,exports) {
"use strict";
var addToUnscopables = require("268ffafa857efe4f");
var step = require("1099941d287cfbcb");
var Iterators = require("9c9daaacf466cb4e");
var toIObject = require("4ad63f44d4753ff3");
// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = require("a1d7d0fd4fec9342")(Array, "Array", function(iterated, kind) {
    this._t = toIObject(iterated); // target
    this._i = 0; // next index
    this._k = kind; // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function() {
    var O = this._t;
    var kind = this._k;
    var index = this._i++;
    if (!O || index >= O.length) {
        this._t = undefined;
        return step(1);
    }
    if (kind == "keys") return step(0, index);
    if (kind == "values") return step(0, O[index]);
    return step(0, [
        index,
        O[index]
    ]);
}, "values");
// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;
addToUnscopables("keys");
addToUnscopables("values");
addToUnscopables("entries");

},{"268ffafa857efe4f":"eTvwk","1099941d287cfbcb":"jmLDf","9c9daaacf466cb4e":"3kquG","4ad63f44d4753ff3":"lvd6c","a1d7d0fd4fec9342":"kMwI6"}],"eTvwk":[function(require,module,exports) {
module.exports = function() {};

},{}],"jmLDf":[function(require,module,exports) {
module.exports = function(done, value) {
    return {
        value: value,
        done: !!done
    };
};

},{}],"3e3la":[function(require,module,exports) {
exports.f = require("36442f443e0c678e");

},{"36442f443e0c678e":"6tZlw"}],"44gK3":[function(require,module,exports) {
module.exports = {
    "default": require("fe3e8125a566ee6"),
    __esModule: true
};

},{"fe3e8125a566ee6":"eOZtx"}],"eOZtx":[function(require,module,exports) {
require("35c8a9b586da83d8");
require("d01406b32d8a3df7");
require("10e5729a448e7085");
require("f25948af0f515ecd");
module.exports = require("1c3d83d1a1a068f1").Symbol;

},{"35c8a9b586da83d8":"64FSq","d01406b32d8a3df7":"bRkbV","10e5729a448e7085":"yEqNl","f25948af0f515ecd":"fry5i","1c3d83d1a1a068f1":"i8kQt"}],"64FSq":[function(require,module,exports) {
"use strict";
// ECMAScript 6 symbols shim
var global = require("6b03afc78b8c4c70");
var has = require("7bc64c23acfd4e47");
var DESCRIPTORS = require("fd5270304c3f0774");
var $export = require("ad61dd5521512ac6");
var redefine = require("113ba1bdd5536e4b");
var META = require("a29c28b24568b6ec").KEY;
var $fails = require("4581c198aff27eba");
var shared = require("13f82a1b2217cc63");
var setToStringTag = require("4cab54a6c56f6e58");
var uid = require("51e0c16c77ad3321");
var wks = require("d94225328e698bc8");
var wksExt = require("fad4d9522c5826a8");
var wksDefine = require("97c920ef0685d428");
var enumKeys = require("4961a30da5bd6566");
var isArray = require("70fc4011502b1ae9");
var anObject = require("c960b31d18558c89");
var isObject = require("85c91fbac85c6d71");
var toObject = require("21841b548756ece4");
var toIObject = require("189591341b356ec9");
var toPrimitive = require("98eaeea0b1f5bec8");
var createDesc = require("e9054eef7ea66c49");
var _create = require("9455e7f4c539318a");
var gOPNExt = require("bdb90236d4143cf3");
var $GOPD = require("59b3cbbdbc5fbc05");
var $GOPS = require("d057ca8ec2679d1d");
var $DP = require("ef1182502c67a40b");
var $keys = require("85c8a448b554974d");
var gOPD = $GOPD.f;
var dP = $DP.f;
var gOPN = gOPNExt.f;
var $Symbol = global.Symbol;
var $JSON = global.JSON;
var _stringify = $JSON && $JSON.stringify;
var PROTOTYPE = "prototype";
var HIDDEN = wks("_hidden");
var TO_PRIMITIVE = wks("toPrimitive");
var isEnum = {}.propertyIsEnumerable;
var SymbolRegistry = shared("symbol-registry");
var AllSymbols = shared("symbols");
var OPSymbols = shared("op-symbols");
var ObjectProto = Object[PROTOTYPE];
var USE_NATIVE = typeof $Symbol == "function" && !!$GOPS.f;
var QObject = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;
// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDesc = DESCRIPTORS && $fails(function() {
    return _create(dP({}, "a", {
        get: function() {
            return dP(this, "a", {
                value: 7
            }).a;
        }
    })).a != 7;
}) ? function(it, key, D) {
    var protoDesc = gOPD(ObjectProto, key);
    if (protoDesc) delete ObjectProto[key];
    dP(it, key, D);
    if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
} : dP;
var wrap = function(tag) {
    var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
    sym._k = tag;
    return sym;
};
var isSymbol = USE_NATIVE && typeof $Symbol.iterator == "symbol" ? function(it) {
    return typeof it == "symbol";
} : function(it) {
    return it instanceof $Symbol;
};
var $defineProperty = function defineProperty(it, key, D) {
    if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
    anObject(it);
    key = toPrimitive(key, true);
    anObject(D);
    if (has(AllSymbols, key)) {
        if (!D.enumerable) {
            if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
            it[HIDDEN][key] = true;
        } else {
            if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
            D = _create(D, {
                enumerable: createDesc(0, false)
            });
        }
        return setSymbolDesc(it, key, D);
    }
    return dP(it, key, D);
};
var $defineProperties = function defineProperties(it, P) {
    anObject(it);
    var keys = enumKeys(P = toIObject(P));
    var i = 0;
    var l = keys.length;
    var key;
    while(l > i)$defineProperty(it, key = keys[i++], P[key]);
    return it;
};
var $create = function create(it, P) {
    return P === undefined ? _create(it) : $defineProperties(_create(it), P);
};
var $propertyIsEnumerable = function propertyIsEnumerable(key) {
    var E = isEnum.call(this, key = toPrimitive(key, true));
    if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
    return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
};
var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
    it = toIObject(it);
    key = toPrimitive(key, true);
    if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
    var D = gOPD(it, key);
    if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
    return D;
};
var $getOwnPropertyNames = function getOwnPropertyNames(it) {
    var names = gOPN(toIObject(it));
    var result = [];
    var i = 0;
    var key;
    while(names.length > i)if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
    return result;
};
var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
    var IS_OP = it === ObjectProto;
    var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
    var result = [];
    var i = 0;
    var key;
    while(names.length > i)if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
    return result;
};
// 19.4.1.1 Symbol([description])
if (!USE_NATIVE) {
    $Symbol = function Symbol() {
        if (this instanceof $Symbol) throw TypeError("Symbol is not a constructor!");
        var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
        var $set = function(value) {
            if (this === ObjectProto) $set.call(OPSymbols, value);
            if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
            setSymbolDesc(this, tag, createDesc(1, value));
        };
        if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, {
            configurable: true,
            set: $set
        });
        return wrap(tag);
    };
    redefine($Symbol[PROTOTYPE], "toString", function toString() {
        return this._k;
    });
    $GOPD.f = $getOwnPropertyDescriptor;
    $DP.f = $defineProperty;
    require("438aa939f38122d6").f = gOPNExt.f = $getOwnPropertyNames;
    require("fe8c974d994e4bf1").f = $propertyIsEnumerable;
    $GOPS.f = $getOwnPropertySymbols;
    if (DESCRIPTORS && !require("a67454d2c2af5d70")) redefine(ObjectProto, "propertyIsEnumerable", $propertyIsEnumerable, true);
    wksExt.f = function(name) {
        return wrap(wks(name));
    };
}
$export($export.G + $export.W + $export.F * !USE_NATIVE, {
    Symbol: $Symbol
});
for(var es6Symbols = // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
"hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables".split(","), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);
for(var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;)wksDefine(wellKnownSymbols[k++]);
$export($export.S + $export.F * !USE_NATIVE, "Symbol", {
    // 19.4.2.1 Symbol.for(key)
    "for": function(key) {
        return has(SymbolRegistry, key += "") ? SymbolRegistry[key] : SymbolRegistry[key] = $Symbol(key);
    },
    // 19.4.2.5 Symbol.keyFor(sym)
    keyFor: function keyFor(sym) {
        if (!isSymbol(sym)) throw TypeError(sym + " is not a symbol!");
        for(var key in SymbolRegistry)if (SymbolRegistry[key] === sym) return key;
    },
    useSetter: function() {
        setter = true;
    },
    useSimple: function() {
        setter = false;
    }
});
$export($export.S + $export.F * !USE_NATIVE, "Object", {
    // 19.1.2.2 Object.create(O [, Properties])
    create: $create,
    // 19.1.2.4 Object.defineProperty(O, P, Attributes)
    defineProperty: $defineProperty,
    // 19.1.2.3 Object.defineProperties(O, Properties)
    defineProperties: $defineProperties,
    // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
    getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
    // 19.1.2.7 Object.getOwnPropertyNames(O)
    getOwnPropertyNames: $getOwnPropertyNames,
    // 19.1.2.8 Object.getOwnPropertySymbols(O)
    getOwnPropertySymbols: $getOwnPropertySymbols
});
// Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
// https://bugs.chromium.org/p/v8/issues/detail?id=3443
var FAILS_ON_PRIMITIVES = $fails(function() {
    $GOPS.f(1);
});
$export($export.S + $export.F * FAILS_ON_PRIMITIVES, "Object", {
    getOwnPropertySymbols: function getOwnPropertySymbols(it) {
        return $GOPS.f(toObject(it));
    }
});
// 24.3.2 JSON.stringify(value [, replacer [, space]])
$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function() {
    var S = $Symbol();
    // MS Edge converts symbol values to JSON as {}
    // WebKit converts symbol values to JSON as null
    // V8 throws on boxed symbols
    return _stringify([
        S
    ]) != "[null]" || _stringify({
        a: S
    }) != "{}" || _stringify(Object(S)) != "{}";
})), "JSON", {
    stringify: function stringify(it) {
        var args = [
            it
        ];
        var i = 1;
        var replacer, $replacer;
        while(arguments.length > i)args.push(arguments[i++]);
        $replacer = replacer = args[1];
        if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
        if (!isArray(replacer)) replacer = function(key, value) {
            if (typeof $replacer == "function") value = $replacer.call(this, key, value);
            if (!isSymbol(value)) return value;
        };
        args[1] = replacer;
        return _stringify.apply($JSON, args);
    }
});
// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$Symbol[PROTOTYPE][TO_PRIMITIVE] || require("b8e0459aa6e4ef79")($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
setToStringTag($Symbol, "Symbol");
// 20.2.1.9 Math[@@toStringTag]
setToStringTag(Math, "Math", true);
// 24.3.3 JSON[@@toStringTag]
setToStringTag(global.JSON, "JSON", true);

},{"6b03afc78b8c4c70":"bV7oC","7bc64c23acfd4e47":"jZWXj","fd5270304c3f0774":"cWdn9","ad61dd5521512ac6":"1OjY7","113ba1bdd5536e4b":"9hsMK","a29c28b24568b6ec":"13T1O","4581c198aff27eba":"aH906","13f82a1b2217cc63":"6JJsZ","4cab54a6c56f6e58":"4bIRS","51e0c16c77ad3321":"1UVZ8","d94225328e698bc8":"6tZlw","fad4d9522c5826a8":"3e3la","97c920ef0685d428":"jaYy0","4961a30da5bd6566":"30r6J","70fc4011502b1ae9":"kSXLI","c960b31d18558c89":"lKEVJ","85c91fbac85c6d71":"5vzl3","21841b548756ece4":"9EHnZ","189591341b356ec9":"lvd6c","98eaeea0b1f5bec8":"7WUHL","e9054eef7ea66c49":"kXqBU","9455e7f4c539318a":"02z79","bdb90236d4143cf3":"XvwmU","59b3cbbdbc5fbc05":"h7TTV","d057ca8ec2679d1d":"hwRd3","ef1182502c67a40b":"5eLt9","85c8a448b554974d":"4aWXn","438aa939f38122d6":"77yYR","fe8c974d994e4bf1":"776i5","a67454d2c2af5d70":"ie1W2","b8e0459aa6e4ef79":"i6BBP"}],"13T1O":[function(require,module,exports) {
var META = require("6c863b4c84ac945e")("meta");
var isObject = require("f507c52ec11bbd21");
var has = require("522d888a3f255f15");
var setDesc = require("b6d2cad09a789ca7").f;
var id = 0;
var isExtensible = Object.isExtensible || function() {
    return true;
};
var FREEZE = !require("32967c891ce4c2c9")(function() {
    return isExtensible(Object.preventExtensions({}));
});
var setMeta = function(it) {
    setDesc(it, META, {
        value: {
            i: "O" + ++id,
            w: {} // weak collections IDs
        }
    });
};
var fastKey = function(it, create) {
    // return primitive with prefix
    if (!isObject(it)) return typeof it == "symbol" ? it : (typeof it == "string" ? "S" : "P") + it;
    if (!has(it, META)) {
        // can't set metadata to uncaught frozen object
        if (!isExtensible(it)) return "F";
        // not necessary to add metadata
        if (!create) return "E";
        // add missing metadata
        setMeta(it);
    // return object ID
    }
    return it[META].i;
};
var getWeak = function(it, create) {
    if (!has(it, META)) {
        // can't set metadata to uncaught frozen object
        if (!isExtensible(it)) return true;
        // not necessary to add metadata
        if (!create) return false;
        // add missing metadata
        setMeta(it);
    // return hash weak collections IDs
    }
    return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function(it) {
    if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
    return it;
};
var meta = module.exports = {
    KEY: META,
    NEED: false,
    fastKey: fastKey,
    getWeak: getWeak,
    onFreeze: onFreeze
};

},{"6c863b4c84ac945e":"1UVZ8","f507c52ec11bbd21":"5vzl3","522d888a3f255f15":"jZWXj","b6d2cad09a789ca7":"5eLt9","32967c891ce4c2c9":"aH906"}],"jaYy0":[function(require,module,exports) {
var global = require("3e3f2fb9520fff2f");
var core = require("9d30dd2031a5a37e");
var LIBRARY = require("a4c33e5488385b7e");
var wksExt = require("19466d06cd0ab428");
var defineProperty = require("56d9e1401f901ce9").f;
module.exports = function(name) {
    var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
    if (name.charAt(0) != "_" && !(name in $Symbol)) defineProperty($Symbol, name, {
        value: wksExt.f(name)
    });
};

},{"3e3f2fb9520fff2f":"bV7oC","9d30dd2031a5a37e":"i8kQt","a4c33e5488385b7e":"ie1W2","19466d06cd0ab428":"3e3la","56d9e1401f901ce9":"5eLt9"}],"30r6J":[function(require,module,exports) {
// all enumerable object keys, includes symbols
var getKeys = require("54718c9fee4390e7");
var gOPS = require("2315581cbcf72f2b");
var pIE = require("c95e69313467fbb0");
module.exports = function(it) {
    var result = getKeys(it);
    var getSymbols = gOPS.f;
    if (getSymbols) {
        var symbols = getSymbols(it);
        var isEnum = pIE.f;
        var i = 0;
        var key;
        while(symbols.length > i)if (isEnum.call(it, key = symbols[i++])) result.push(key);
    }
    return result;
};

},{"54718c9fee4390e7":"4aWXn","2315581cbcf72f2b":"hwRd3","c95e69313467fbb0":"776i5"}],"kSXLI":[function(require,module,exports) {
// 7.2.2 IsArray(argument)
var cof = require("e671e246311d915d");
module.exports = Array.isArray || function isArray(arg) {
    return cof(arg) == "Array";
};

},{"e671e246311d915d":"kIPjW"}],"XvwmU":[function(require,module,exports) {
// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var toIObject = require("2a7d518c1b488c7");
var gOPN = require("c8fa09933d49c9d3").f;
var toString = {}.toString;
var windowNames = typeof window == "object" && window && Object.getOwnPropertyNames ? Object.getOwnPropertyNames(window) : [];
var getWindowNames = function(it) {
    try {
        return gOPN(it);
    } catch (e) {
        return windowNames.slice();
    }
};
module.exports.f = function getOwnPropertyNames(it) {
    return windowNames && toString.call(it) == "[object Window]" ? getWindowNames(it) : gOPN(toIObject(it));
};

},{"2a7d518c1b488c7":"lvd6c","c8fa09933d49c9d3":"77yYR"}],"77yYR":[function(require,module,exports) {
// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $keys = require("b18ca9f7c432105d");
var hiddenKeys = require("8a0e64251fe9bc88").concat("length", "prototype");
exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
    return $keys(O, hiddenKeys);
};

},{"b18ca9f7c432105d":"6yDxd","8a0e64251fe9bc88":"V3uQX"}],"h7TTV":[function(require,module,exports) {
var pIE = require("d5a558c24b8e1111");
var createDesc = require("3e3528b31ccee3f1");
var toIObject = require("f145b11057eb832e");
var toPrimitive = require("9d9d089c028a4f6");
var has = require("d0da52509449f47b");
var IE8_DOM_DEFINE = require("c1ef886e6078476");
var gOPD = Object.getOwnPropertyDescriptor;
exports.f = require("9b4b8c45057bdd94") ? gOPD : function getOwnPropertyDescriptor(O, P) {
    O = toIObject(O);
    P = toPrimitive(P, true);
    if (IE8_DOM_DEFINE) try {
        return gOPD(O, P);
    } catch (e) {}
    if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
};

},{"d5a558c24b8e1111":"776i5","3e3528b31ccee3f1":"kXqBU","f145b11057eb832e":"lvd6c","9d9d089c028a4f6":"7WUHL","d0da52509449f47b":"jZWXj","c1ef886e6078476":"3CQhA","9b4b8c45057bdd94":"cWdn9"}],"bRkbV":[function(require,module,exports) {

},{}],"yEqNl":[function(require,module,exports) {
require("85e8dd51fbba2b7c")("asyncIterator");

},{"85e8dd51fbba2b7c":"jaYy0"}],"fry5i":[function(require,module,exports) {
require("9d3993318cd897e3")("observable");

},{"9d3993318cd897e3":"jaYy0"}],"bitir":[function(require,module,exports) {
"use strict";
exports.__esModule = true;
var _setPrototypeOf = require("87c1bc7f6799a236");
var _setPrototypeOf2 = _interopRequireDefault(_setPrototypeOf);
var _create = require("dc63738af576b854");
var _create2 = _interopRequireDefault(_create);
var _typeof2 = require("8745ca6044ab5fb2");
var _typeof3 = _interopRequireDefault(_typeof2);
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
exports.default = function(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, _typeof3.default)(superClass)));
    subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;
};

},{"87c1bc7f6799a236":"2CcwP","dc63738af576b854":"7tTa3","8745ca6044ab5fb2":"bOmQJ"}],"2CcwP":[function(require,module,exports) {
module.exports = {
    "default": require("641ca3718ec7174b"),
    __esModule: true
};

},{"641ca3718ec7174b":"dyw6Q"}],"dyw6Q":[function(require,module,exports) {
require("22b3443cf8136c8");
module.exports = require("eb83d575f016b314").Object.setPrototypeOf;

},{"22b3443cf8136c8":"2b4MV","eb83d575f016b314":"i8kQt"}],"2b4MV":[function(require,module,exports) {
// 19.1.3.19 Object.setPrototypeOf(O, proto)
var $export = require("13652ebae530d237");
$export($export.S, "Object", {
    setPrototypeOf: require("fdebe77c70e6513").set
});

},{"13652ebae530d237":"1OjY7","fdebe77c70e6513":"fXME5"}],"fXME5":[function(require,module,exports) {
// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */ var isObject = require("20a4fb390e4250b6");
var anObject = require("7d81f94927ed7384");
var check = function(O, proto) {
    anObject(O);
    if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
};
module.exports = {
    set: Object.setPrototypeOf || ("__proto__" in {} ? function(test, buggy, set) {
        try {
            set = require("a1f31461db483291")(Function.call, require("cf46c2e2d90f8b0c").f(Object.prototype, "__proto__").set, 2);
            set(test, []);
            buggy = !(test instanceof Array);
        } catch (e) {
            buggy = true;
        }
        return function setPrototypeOf(O, proto) {
            check(O, proto);
            if (buggy) O.__proto__ = proto;
            else set(O, proto);
            return O;
        };
    }({}, false) : undefined),
    check: check
};

},{"20a4fb390e4250b6":"5vzl3","7d81f94927ed7384":"lKEVJ","a1f31461db483291":"iSPoi","cf46c2e2d90f8b0c":"h7TTV"}],"7tTa3":[function(require,module,exports) {
module.exports = {
    "default": require("6eee693993964e86"),
    __esModule: true
};

},{"6eee693993964e86":"53XUb"}],"53XUb":[function(require,module,exports) {
require("202e191d1c041267");
var $Object = require("3180939eee2969b").Object;
module.exports = function create(P, D) {
    return $Object.create(P, D);
};

},{"202e191d1c041267":"66L28","3180939eee2969b":"i8kQt"}],"66L28":[function(require,module,exports) {
var $export = require("b4bf3a0491dad02b");
// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
$export($export.S, "Object", {
    create: require("5e1a510df2752b8e")
});

},{"b4bf3a0491dad02b":"1OjY7","5e1a510df2752b8e":"02z79"}],"k2w8n":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _extends = require("babel-runtime/helpers/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _classCallCheck = require("babel-runtime/helpers/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _possibleConstructorReturn = require("babel-runtime/helpers/possibleConstructorReturn");
var _possibleConstructorReturnDefault = parcelHelpers.interopDefault(_possibleConstructorReturn);
var _inherits = require("babel-runtime/helpers/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _reactDom = require("react-dom");
var _reactLifecyclesCompat = require("react-lifecycles-compat");
var _contains = require("rc-util/es/Dom/contains");
var _containsDefault = parcelHelpers.interopDefault(_contains);
var _addEventListener = require("rc-util/es/Dom/addEventListener");
var _addEventListenerDefault = parcelHelpers.interopDefault(_addEventListener);
var _containerRender = require("rc-util/es/ContainerRender");
var _containerRenderDefault = parcelHelpers.interopDefault(_containerRender);
var _portal = require("rc-util/es/Portal");
var _portalDefault = parcelHelpers.interopDefault(_portal);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _utils = require("./utils");
var _popup = require("./Popup");
var _popupDefault = parcelHelpers.interopDefault(_popup);
function noop() {}
function returnEmptyString() {
    return "";
}
function returnDocument() {
    return window.document;
}
var ALL_HANDLERS = [
    "onClick",
    "onMouseDown",
    "onTouchStart",
    "onMouseEnter",
    "onMouseLeave",
    "onFocus",
    "onBlur",
    "onContextMenu"
];
var IS_REACT_16 = !!(0, _reactDom.createPortal);
var contextTypes = {
    rcTrigger: (0, _propTypesDefault.default).shape({
        onPopupMouseDown: (0, _propTypesDefault.default).func
    })
};
var Trigger = function(_React$Component) {
    (0, _inheritsDefault.default)(Trigger, _React$Component);
    function Trigger(props) {
        (0, _classCallCheckDefault.default)(this, Trigger);
        var _this = (0, _possibleConstructorReturnDefault.default)(this, _React$Component.call(this, props));
        _initialiseProps.call(_this);
        var popupVisible = void 0;
        if ("popupVisible" in props) popupVisible = !!props.popupVisible;
        else popupVisible = !!props.defaultPopupVisible;
        _this.state = {
            prevPopupVisible: popupVisible,
            popupVisible: popupVisible
        };
        ALL_HANDLERS.forEach(function(h) {
            _this["fire" + h] = function(e) {
                _this.fireEvents(h, e);
            };
        });
        return _this;
    }
    Trigger.prototype.getChildContext = function getChildContext() {
        return {
            rcTrigger: {
                onPopupMouseDown: this.onPopupMouseDown
            }
        };
    };
    Trigger.prototype.componentDidMount = function componentDidMount() {
        this.componentDidUpdate({}, {
            popupVisible: this.state.popupVisible
        });
    };
    Trigger.prototype.componentDidUpdate = function componentDidUpdate(_, prevState) {
        var props = this.props;
        var state = this.state;
        var triggerAfterPopupVisibleChange = function triggerAfterPopupVisibleChange() {
            if (prevState.popupVisible !== state.popupVisible) props.afterPopupVisibleChange(state.popupVisible);
        };
        if (!IS_REACT_16) this.renderComponent(null, triggerAfterPopupVisibleChange);
        // We must listen to `mousedown` or `touchstart`, edge case:
        // https://github.com/ant-design/ant-design/issues/5804
        // https://github.com/react-component/calendar/issues/250
        // https://github.com/react-component/trigger/issues/50
        if (state.popupVisible) {
            var currentDocument = void 0;
            if (!this.clickOutsideHandler && (this.isClickToHide() || this.isContextMenuToShow())) {
                currentDocument = props.getDocument();
                this.clickOutsideHandler = (0, _addEventListenerDefault.default)(currentDocument, "mousedown", this.onDocumentClick);
            }
            // always hide on mobile
            if (!this.touchOutsideHandler) {
                currentDocument = currentDocument || props.getDocument();
                this.touchOutsideHandler = (0, _addEventListenerDefault.default)(currentDocument, "touchstart", this.onDocumentClick);
            }
            // close popup when trigger type contains 'onContextMenu' and document is scrolling.
            if (!this.contextMenuOutsideHandler1 && this.isContextMenuToShow()) {
                currentDocument = currentDocument || props.getDocument();
                this.contextMenuOutsideHandler1 = (0, _addEventListenerDefault.default)(currentDocument, "scroll", this.onContextMenuClose);
            }
            // close popup when trigger type contains 'onContextMenu' and window is blur.
            if (!this.contextMenuOutsideHandler2 && this.isContextMenuToShow()) this.contextMenuOutsideHandler2 = (0, _addEventListenerDefault.default)(window, "blur", this.onContextMenuClose);
            return;
        }
        this.clearOutsideHandler();
    };
    Trigger.prototype.componentWillUnmount = function componentWillUnmount() {
        this.clearDelayTimer();
        this.clearOutsideHandler();
        clearTimeout(this.mouseDownTimeout);
    };
    Trigger.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
        var popupVisible = _ref.popupVisible;
        var newState = {};
        if (popupVisible !== undefined && prevState.popupVisible !== popupVisible) {
            newState.popupVisible = popupVisible;
            newState.prevPopupVisible = prevState.popupVisible;
        }
        return newState;
    };
    Trigger.prototype.getPopupDomNode = function getPopupDomNode() {
        // for test
        if (this._component && this._component.getPopupDomNode) return this._component.getPopupDomNode();
        return null;
    };
    Trigger.prototype.getPopupAlign = function getPopupAlign() {
        var props = this.props;
        var popupPlacement = props.popupPlacement, popupAlign = props.popupAlign, builtinPlacements = props.builtinPlacements;
        if (popupPlacement && builtinPlacements) return (0, _utils.getAlignFromPlacement)(builtinPlacements, popupPlacement, popupAlign);
        return popupAlign;
    };
    /**
   * @param popupVisible    Show or not the popup element
   * @param event           SyntheticEvent, used for `pointAlign`
   */ Trigger.prototype.setPopupVisible = function setPopupVisible(popupVisible, event) {
        var alignPoint = this.props.alignPoint;
        var prevPopupVisible = this.state.popupVisible;
        this.clearDelayTimer();
        if (prevPopupVisible !== popupVisible) {
            if (!("popupVisible" in this.props)) this.setState({
                popupVisible: popupVisible,
                prevPopupVisible: prevPopupVisible
            });
            this.props.onPopupVisibleChange(popupVisible);
        }
        // Always record the point position since mouseEnterDelay will delay the show
        if (alignPoint && event) this.setPoint(event);
    };
    Trigger.prototype.delaySetPopupVisible = function delaySetPopupVisible(visible, delayS, event) {
        var _this2 = this;
        var delay = delayS * 1000;
        this.clearDelayTimer();
        if (delay) {
            var point = event ? {
                pageX: event.pageX,
                pageY: event.pageY
            } : null;
            this.delayTimer = setTimeout(function() {
                _this2.setPopupVisible(visible, point);
                _this2.clearDelayTimer();
            }, delay);
        } else this.setPopupVisible(visible, event);
    };
    Trigger.prototype.clearDelayTimer = function clearDelayTimer() {
        if (this.delayTimer) {
            clearTimeout(this.delayTimer);
            this.delayTimer = null;
        }
    };
    Trigger.prototype.clearOutsideHandler = function clearOutsideHandler() {
        if (this.clickOutsideHandler) {
            this.clickOutsideHandler.remove();
            this.clickOutsideHandler = null;
        }
        if (this.contextMenuOutsideHandler1) {
            this.contextMenuOutsideHandler1.remove();
            this.contextMenuOutsideHandler1 = null;
        }
        if (this.contextMenuOutsideHandler2) {
            this.contextMenuOutsideHandler2.remove();
            this.contextMenuOutsideHandler2 = null;
        }
        if (this.touchOutsideHandler) {
            this.touchOutsideHandler.remove();
            this.touchOutsideHandler = null;
        }
    };
    Trigger.prototype.createTwoChains = function createTwoChains(event) {
        var childPros = this.props.children.props;
        var props = this.props;
        if (childPros[event] && props[event]) return this["fire" + event];
        return childPros[event] || props[event];
    };
    Trigger.prototype.isClickToShow = function isClickToShow() {
        var _props = this.props, action = _props.action, showAction = _props.showAction;
        return action.indexOf("click") !== -1 || showAction.indexOf("click") !== -1;
    };
    Trigger.prototype.isContextMenuToShow = function isContextMenuToShow() {
        var _props2 = this.props, action = _props2.action, showAction = _props2.showAction;
        return action.indexOf("contextMenu") !== -1 || showAction.indexOf("contextMenu") !== -1;
    };
    Trigger.prototype.isClickToHide = function isClickToHide() {
        var _props3 = this.props, action = _props3.action, hideAction = _props3.hideAction;
        return action.indexOf("click") !== -1 || hideAction.indexOf("click") !== -1;
    };
    Trigger.prototype.isMouseEnterToShow = function isMouseEnterToShow() {
        var _props4 = this.props, action = _props4.action, showAction = _props4.showAction;
        return action.indexOf("hover") !== -1 || showAction.indexOf("mouseEnter") !== -1;
    };
    Trigger.prototype.isMouseLeaveToHide = function isMouseLeaveToHide() {
        var _props5 = this.props, action = _props5.action, hideAction = _props5.hideAction;
        return action.indexOf("hover") !== -1 || hideAction.indexOf("mouseLeave") !== -1;
    };
    Trigger.prototype.isFocusToShow = function isFocusToShow() {
        var _props6 = this.props, action = _props6.action, showAction = _props6.showAction;
        return action.indexOf("focus") !== -1 || showAction.indexOf("focus") !== -1;
    };
    Trigger.prototype.isBlurToHide = function isBlurToHide() {
        var _props7 = this.props, action = _props7.action, hideAction = _props7.hideAction;
        return action.indexOf("focus") !== -1 || hideAction.indexOf("blur") !== -1;
    };
    Trigger.prototype.forcePopupAlign = function forcePopupAlign() {
        if (this.state.popupVisible && this._component && this._component.alignInstance) this._component.alignInstance.forceAlign();
    };
    Trigger.prototype.fireEvents = function fireEvents(type, e) {
        var childCallback = this.props.children.props[type];
        if (childCallback) childCallback(e);
        var callback = this.props[type];
        if (callback) callback(e);
    };
    Trigger.prototype.close = function close() {
        this.setPopupVisible(false);
    };
    Trigger.prototype.render = function render() {
        var _this3 = this;
        var popupVisible = this.state.popupVisible;
        var _props8 = this.props, children = _props8.children, forceRender = _props8.forceRender, alignPoint = _props8.alignPoint, className = _props8.className;
        var child = (0, _reactDefault.default).Children.only(children);
        var newChildProps = {
            key: "trigger"
        };
        if (this.isContextMenuToShow()) newChildProps.onContextMenu = this.onContextMenu;
        else newChildProps.onContextMenu = this.createTwoChains("onContextMenu");
        if (this.isClickToHide() || this.isClickToShow()) {
            newChildProps.onClick = this.onClick;
            newChildProps.onMouseDown = this.onMouseDown;
            newChildProps.onTouchStart = this.onTouchStart;
        } else {
            newChildProps.onClick = this.createTwoChains("onClick");
            newChildProps.onMouseDown = this.createTwoChains("onMouseDown");
            newChildProps.onTouchStart = this.createTwoChains("onTouchStart");
        }
        if (this.isMouseEnterToShow()) {
            newChildProps.onMouseEnter = this.onMouseEnter;
            if (alignPoint) newChildProps.onMouseMove = this.onMouseMove;
        } else newChildProps.onMouseEnter = this.createTwoChains("onMouseEnter");
        if (this.isMouseLeaveToHide()) newChildProps.onMouseLeave = this.onMouseLeave;
        else newChildProps.onMouseLeave = this.createTwoChains("onMouseLeave");
        if (this.isFocusToShow() || this.isBlurToHide()) {
            newChildProps.onFocus = this.onFocus;
            newChildProps.onBlur = this.onBlur;
        } else {
            newChildProps.onFocus = this.createTwoChains("onFocus");
            newChildProps.onBlur = this.createTwoChains("onBlur");
        }
        var childrenClassName = (0, _classnamesDefault.default)(child && child.props && child.props.className, className);
        if (childrenClassName) newChildProps.className = childrenClassName;
        var trigger = (0, _reactDefault.default).cloneElement(child, newChildProps);
        if (!IS_REACT_16) return (0, _reactDefault.default).createElement((0, _containerRenderDefault.default), {
            parent: this,
            visible: popupVisible,
            autoMount: false,
            forceRender: forceRender,
            getComponent: this.getComponent,
            getContainer: this.getContainer
        }, function(_ref2) {
            var renderComponent = _ref2.renderComponent;
            _this3.renderComponent = renderComponent;
            return trigger;
        });
        var portal = void 0;
        // prevent unmounting after it's rendered
        if (popupVisible || this._component || forceRender) portal = (0, _reactDefault.default).createElement((0, _portalDefault.default), {
            key: "portal",
            getContainer: this.getContainer,
            didUpdate: this.handlePortalUpdate
        }, this.getComponent());
        return [
            trigger,
            portal
        ];
    };
    return Trigger;
}((0, _reactDefault.default).Component);
Trigger.propTypes = {
    children: (0, _propTypesDefault.default).any,
    action: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).string,
        (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).string)
    ]),
    showAction: (0, _propTypesDefault.default).any,
    hideAction: (0, _propTypesDefault.default).any,
    getPopupClassNameFromAlign: (0, _propTypesDefault.default).any,
    onPopupVisibleChange: (0, _propTypesDefault.default).func,
    afterPopupVisibleChange: (0, _propTypesDefault.default).func,
    popup: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).node,
        (0, _propTypesDefault.default).func
    ]).isRequired,
    popupStyle: (0, _propTypesDefault.default).object,
    prefixCls: (0, _propTypesDefault.default).string,
    popupClassName: (0, _propTypesDefault.default).string,
    className: (0, _propTypesDefault.default).string,
    popupPlacement: (0, _propTypesDefault.default).string,
    builtinPlacements: (0, _propTypesDefault.default).object,
    popupTransitionName: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).string,
        (0, _propTypesDefault.default).object
    ]),
    popupAnimation: (0, _propTypesDefault.default).any,
    mouseEnterDelay: (0, _propTypesDefault.default).number,
    mouseLeaveDelay: (0, _propTypesDefault.default).number,
    zIndex: (0, _propTypesDefault.default).number,
    focusDelay: (0, _propTypesDefault.default).number,
    blurDelay: (0, _propTypesDefault.default).number,
    getPopupContainer: (0, _propTypesDefault.default).func,
    getDocument: (0, _propTypesDefault.default).func,
    forceRender: (0, _propTypesDefault.default).bool,
    destroyPopupOnHide: (0, _propTypesDefault.default).bool,
    mask: (0, _propTypesDefault.default).bool,
    maskClosable: (0, _propTypesDefault.default).bool,
    onPopupAlign: (0, _propTypesDefault.default).func,
    popupAlign: (0, _propTypesDefault.default).object,
    popupVisible: (0, _propTypesDefault.default).bool,
    defaultPopupVisible: (0, _propTypesDefault.default).bool,
    maskTransitionName: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).string,
        (0, _propTypesDefault.default).object
    ]),
    maskAnimation: (0, _propTypesDefault.default).string,
    stretch: (0, _propTypesDefault.default).string,
    alignPoint: (0, _propTypesDefault.default).bool // Maybe we can support user pass position in the future
};
Trigger.contextTypes = contextTypes;
Trigger.childContextTypes = contextTypes;
Trigger.defaultProps = {
    prefixCls: "rc-trigger-popup",
    getPopupClassNameFromAlign: returnEmptyString,
    getDocument: returnDocument,
    onPopupVisibleChange: noop,
    afterPopupVisibleChange: noop,
    onPopupAlign: noop,
    popupClassName: "",
    mouseEnterDelay: 0,
    mouseLeaveDelay: 0.1,
    focusDelay: 0,
    blurDelay: 0.15,
    popupStyle: {},
    destroyPopupOnHide: false,
    popupAlign: {},
    defaultPopupVisible: false,
    mask: false,
    maskClosable: true,
    action: [],
    showAction: [],
    hideAction: []
};
var _initialiseProps = function _initialiseProps() {
    var _this4 = this;
    this.onMouseEnter = function(e) {
        var mouseEnterDelay = _this4.props.mouseEnterDelay;
        _this4.fireEvents("onMouseEnter", e);
        _this4.delaySetPopupVisible(true, mouseEnterDelay, mouseEnterDelay ? null : e);
    };
    this.onMouseMove = function(e) {
        _this4.fireEvents("onMouseMove", e);
        _this4.setPoint(e);
    };
    this.onMouseLeave = function(e) {
        _this4.fireEvents("onMouseLeave", e);
        _this4.delaySetPopupVisible(false, _this4.props.mouseLeaveDelay);
    };
    this.onPopupMouseEnter = function() {
        _this4.clearDelayTimer();
    };
    this.onPopupMouseLeave = function(e) {
        // https://github.com/react-component/trigger/pull/13
        // react bug?
        if (e.relatedTarget && !e.relatedTarget.setTimeout && _this4._component && _this4._component.getPopupDomNode && (0, _containsDefault.default)(_this4._component.getPopupDomNode(), e.relatedTarget)) return;
        _this4.delaySetPopupVisible(false, _this4.props.mouseLeaveDelay);
    };
    this.onFocus = function(e) {
        _this4.fireEvents("onFocus", e);
        // incase focusin and focusout
        _this4.clearDelayTimer();
        if (_this4.isFocusToShow()) {
            _this4.focusTime = Date.now();
            _this4.delaySetPopupVisible(true, _this4.props.focusDelay);
        }
    };
    this.onMouseDown = function(e) {
        _this4.fireEvents("onMouseDown", e);
        _this4.preClickTime = Date.now();
    };
    this.onTouchStart = function(e) {
        _this4.fireEvents("onTouchStart", e);
        _this4.preTouchTime = Date.now();
    };
    this.onBlur = function(e) {
        _this4.fireEvents("onBlur", e);
        _this4.clearDelayTimer();
        if (_this4.isBlurToHide()) _this4.delaySetPopupVisible(false, _this4.props.blurDelay);
    };
    this.onContextMenu = function(e) {
        e.preventDefault();
        _this4.fireEvents("onContextMenu", e);
        _this4.setPopupVisible(true, e);
    };
    this.onContextMenuClose = function() {
        if (_this4.isContextMenuToShow()) _this4.close();
    };
    this.onClick = function(event) {
        _this4.fireEvents("onClick", event);
        // focus will trigger click
        if (_this4.focusTime) {
            var preTime = void 0;
            if (_this4.preClickTime && _this4.preTouchTime) preTime = Math.min(_this4.preClickTime, _this4.preTouchTime);
            else if (_this4.preClickTime) preTime = _this4.preClickTime;
            else if (_this4.preTouchTime) preTime = _this4.preTouchTime;
            if (Math.abs(preTime - _this4.focusTime) < 20) return;
            _this4.focusTime = 0;
        }
        _this4.preClickTime = 0;
        _this4.preTouchTime = 0;
        // Only prevent default when all the action is click.
        // https://github.com/ant-design/ant-design/issues/17043
        // https://github.com/ant-design/ant-design/issues/17291
        if (_this4.isClickToShow() && (_this4.isClickToHide() || _this4.isBlurToHide()) && event && event.preventDefault) event.preventDefault();
        var nextVisible = !_this4.state.popupVisible;
        if (_this4.isClickToHide() && !nextVisible || nextVisible && _this4.isClickToShow()) _this4.setPopupVisible(!_this4.state.popupVisible, event);
    };
    this.onPopupMouseDown = function() {
        var _context$rcTrigger = _this4.context.rcTrigger, rcTrigger = _context$rcTrigger === undefined ? {} : _context$rcTrigger;
        _this4.hasPopupMouseDown = true;
        clearTimeout(_this4.mouseDownTimeout);
        _this4.mouseDownTimeout = setTimeout(function() {
            _this4.hasPopupMouseDown = false;
        }, 0);
        if (rcTrigger.onPopupMouseDown) rcTrigger.onPopupMouseDown.apply(rcTrigger, arguments);
    };
    this.onDocumentClick = function(event) {
        if (_this4.props.mask && !_this4.props.maskClosable) return;
        var target = event.target;
        var root = (0, _reactDom.findDOMNode)(_this4);
        if (!(0, _containsDefault.default)(root, target) && !_this4.hasPopupMouseDown) _this4.close();
    };
    this.getRootDomNode = function() {
        return (0, _reactDom.findDOMNode)(_this4);
    };
    this.getPopupClassNameFromAlign = function(align) {
        var className = [];
        var _props9 = _this4.props, popupPlacement = _props9.popupPlacement, builtinPlacements = _props9.builtinPlacements, prefixCls = _props9.prefixCls, alignPoint = _props9.alignPoint, getPopupClassNameFromAlign = _props9.getPopupClassNameFromAlign;
        if (popupPlacement && builtinPlacements) className.push((0, _utils.getAlignPopupClassName)(builtinPlacements, prefixCls, align, alignPoint));
        if (getPopupClassNameFromAlign) className.push(getPopupClassNameFromAlign(align));
        return className.join(" ");
    };
    this.getComponent = function() {
        var _props10 = _this4.props, prefixCls = _props10.prefixCls, destroyPopupOnHide = _props10.destroyPopupOnHide, popupClassName = _props10.popupClassName, action = _props10.action, onPopupAlign = _props10.onPopupAlign, popupAnimation = _props10.popupAnimation, popupTransitionName = _props10.popupTransitionName, popupStyle = _props10.popupStyle, mask = _props10.mask, maskAnimation = _props10.maskAnimation, maskTransitionName = _props10.maskTransitionName, zIndex = _props10.zIndex, popup = _props10.popup, stretch = _props10.stretch, alignPoint = _props10.alignPoint;
        var _state = _this4.state, popupVisible = _state.popupVisible, point = _state.point;
        var align = _this4.getPopupAlign();
        var mouseProps = {};
        if (_this4.isMouseEnterToShow()) mouseProps.onMouseEnter = _this4.onPopupMouseEnter;
        if (_this4.isMouseLeaveToHide()) mouseProps.onMouseLeave = _this4.onPopupMouseLeave;
        mouseProps.onMouseDown = _this4.onPopupMouseDown;
        mouseProps.onTouchStart = _this4.onPopupMouseDown;
        return (0, _reactDefault.default).createElement((0, _popupDefault.default), (0, _extendsDefault.default)({
            prefixCls: prefixCls,
            destroyPopupOnHide: destroyPopupOnHide,
            visible: popupVisible,
            point: alignPoint && point,
            className: popupClassName,
            action: action,
            align: align,
            onAlign: onPopupAlign,
            animation: popupAnimation,
            getClassNameFromAlign: _this4.getPopupClassNameFromAlign
        }, mouseProps, {
            stretch: stretch,
            getRootDomNode: _this4.getRootDomNode,
            style: popupStyle,
            mask: mask,
            zIndex: zIndex,
            transitionName: popupTransitionName,
            maskAnimation: maskAnimation,
            maskTransitionName: maskTransitionName,
            ref: _this4.savePopup
        }), typeof popup === "function" ? popup() : popup);
    };
    this.getContainer = function() {
        var props = _this4.props;
        var popupContainer = document.createElement("div");
        // Make sure default popup container will never cause scrollbar appearing
        // https://github.com/react-component/trigger/issues/41
        popupContainer.style.position = "absolute";
        popupContainer.style.top = "0";
        popupContainer.style.left = "0";
        popupContainer.style.width = "100%";
        var mountNode = props.getPopupContainer ? props.getPopupContainer((0, _reactDom.findDOMNode)(_this4)) : props.getDocument().body;
        mountNode.appendChild(popupContainer);
        return popupContainer;
    };
    this.setPoint = function(point) {
        var alignPoint = _this4.props.alignPoint;
        if (!alignPoint || !point) return;
        _this4.setState({
            point: {
                pageX: point.pageX,
                pageY: point.pageY
            }
        });
    };
    this.handlePortalUpdate = function() {
        if (_this4.state.prevPopupVisible !== _this4.state.popupVisible) _this4.props.afterPopupVisibleChange(_this4.state.popupVisible);
    };
    this.savePopup = function(node) {
        _this4._component = node;
    };
};
(0, _reactLifecyclesCompat.polyfill)(Trigger);
exports.default = Trigger;

},{"babel-runtime/helpers/extends":"4sKqp","babel-runtime/helpers/classCallCheck":"aRpYz","babel-runtime/helpers/possibleConstructorReturn":"40Qb5","babel-runtime/helpers/inherits":"bitir","react":"6uln9","prop-types":"6FKs7","react-dom":"b8T3j","react-lifecycles-compat":"jRjXN","rc-util/es/Dom/contains":"4uE9K","rc-util/es/Dom/addEventListener":"dHu4r","rc-util/es/ContainerRender":"kXMVr","rc-util/es/Portal":"2D1Me","classnames":"hVGzI","./utils":"fC9Ax","./Popup":"li3F1","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jRjXN":[function(require,module,exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "polyfill", ()=>polyfill);
function componentWillMount() {
    // Call this.constructor.gDSFP to support sub-classes.
    var state = this.constructor.getDerivedStateFromProps(this.props, this.state);
    if (state !== null && state !== undefined) this.setState(state);
}
function componentWillReceiveProps(nextProps) {
    // Call this.constructor.gDSFP to support sub-classes.
    // Use the setState() updater to ensure state isn't stale in certain edge cases.
    function updater(prevState) {
        var state = this.constructor.getDerivedStateFromProps(nextProps, prevState);
        return state !== null && state !== undefined ? state : null;
    }
    // Binding "this" is important for shallow renderer support.
    this.setState(updater.bind(this));
}
function componentWillUpdate(nextProps, nextState) {
    try {
        var prevProps = this.props;
        var prevState = this.state;
        this.props = nextProps;
        this.state = nextState;
        this.__reactInternalSnapshotFlag = true;
        this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(prevProps, prevState);
    } finally{
        this.props = prevProps;
        this.state = prevState;
    }
}
// React may warn about cWM/cWRP/cWU methods being deprecated.
// Add a flag to suppress these warnings for this special case.
componentWillMount.__suppressDeprecationWarning = true;
componentWillReceiveProps.__suppressDeprecationWarning = true;
componentWillUpdate.__suppressDeprecationWarning = true;
function polyfill(Component) {
    var prototype = Component.prototype;
    if (!prototype || !prototype.isReactComponent) throw new Error("Can only polyfill class components");
    if (typeof Component.getDerivedStateFromProps !== "function" && typeof prototype.getSnapshotBeforeUpdate !== "function") return Component;
    // If new component APIs are defined, "unsafe" lifecycles won't be called.
    // Error if any of these lifecycles are present,
    // Because they would work differently between older and newer (16.3+) versions of React.
    var foundWillMountName = null;
    var foundWillReceivePropsName = null;
    var foundWillUpdateName = null;
    if (typeof prototype.componentWillMount === "function") foundWillMountName = "componentWillMount";
    else if (typeof prototype.UNSAFE_componentWillMount === "function") foundWillMountName = "UNSAFE_componentWillMount";
    if (typeof prototype.componentWillReceiveProps === "function") foundWillReceivePropsName = "componentWillReceiveProps";
    else if (typeof prototype.UNSAFE_componentWillReceiveProps === "function") foundWillReceivePropsName = "UNSAFE_componentWillReceiveProps";
    if (typeof prototype.componentWillUpdate === "function") foundWillUpdateName = "componentWillUpdate";
    else if (typeof prototype.UNSAFE_componentWillUpdate === "function") foundWillUpdateName = "UNSAFE_componentWillUpdate";
    if (foundWillMountName !== null || foundWillReceivePropsName !== null || foundWillUpdateName !== null) {
        var componentName = Component.displayName || Component.name;
        var newApiName = typeof Component.getDerivedStateFromProps === "function" ? "getDerivedStateFromProps()" : "getSnapshotBeforeUpdate()";
        throw Error("Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n" + componentName + " uses " + newApiName + " but also contains the following legacy lifecycles:" + (foundWillMountName !== null ? "\n  " + foundWillMountName : "") + (foundWillReceivePropsName !== null ? "\n  " + foundWillReceivePropsName : "") + (foundWillUpdateName !== null ? "\n  " + foundWillUpdateName : "") + "\n\nThe above lifecycles should be removed. Learn more about this warning here:\n" + "https://fb.me/react-async-component-lifecycle-hooks");
    }
    // React <= 16.2 does not support static getDerivedStateFromProps.
    // As a workaround, use cWM and cWRP to invoke the new static lifecycle.
    // Newer versions of React will ignore these lifecycles if gDSFP exists.
    if (typeof Component.getDerivedStateFromProps === "function") {
        prototype.componentWillMount = componentWillMount;
        prototype.componentWillReceiveProps = componentWillReceiveProps;
    }
    // React <= 16.2 does not support getSnapshotBeforeUpdate.
    // As a workaround, use cWU to invoke the new lifecycle.
    // Newer versions of React will ignore that lifecycle if gSBU exists.
    if (typeof prototype.getSnapshotBeforeUpdate === "function") {
        if (typeof prototype.componentDidUpdate !== "function") throw new Error("Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype");
        prototype.componentWillUpdate = componentWillUpdate;
        var componentDidUpdate = prototype.componentDidUpdate;
        prototype.componentDidUpdate = function componentDidUpdatePolyfill(prevProps, prevState, maybeSnapshot) {
            // 16.3+ will not execute our will-update method;
            // It will pass a snapshot value to did-update though.
            // Older versions will require our polyfilled will-update value.
            // We need to handle both cases, but can't just check for the presence of "maybeSnapshot",
            // Because for <= 15.x versions this might be a "prevContext" object.
            // We also can't just check "__reactInternalSnapshot",
            // Because get-snapshot might return a falsy value.
            // So check for the explicit __reactInternalSnapshotFlag flag to determine behavior.
            var snapshot = this.__reactInternalSnapshotFlag ? this.__reactInternalSnapshot : maybeSnapshot;
            componentDidUpdate.call(this, prevProps, prevState, snapshot);
        };
    }
    return Component;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4uE9K":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>contains);
function contains(root, n) {
    var node = n;
    while(node){
        if (node === root) return true;
        node = node.parentNode;
    }
    return false;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"dHu4r":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>addEventListenerWrap);
var _addDomEventListener = require("add-dom-event-listener");
var _addDomEventListenerDefault = parcelHelpers.interopDefault(_addDomEventListener);
var _reactDom = require("react-dom");
var _reactDomDefault = parcelHelpers.interopDefault(_reactDom);
function addEventListenerWrap(target, eventType, cb, option) {
    /* eslint camelcase: 2 */ var callback = (0, _reactDomDefault.default).unstable_batchedUpdates ? function run(e) {
        (0, _reactDomDefault.default).unstable_batchedUpdates(cb, e);
    } : cb;
    return (0, _addDomEventListenerDefault.default)(target, eventType, callback, option);
}

},{"add-dom-event-listener":"51vRQ","react-dom":"b8T3j","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"51vRQ":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = addEventListener;
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
var _EventObject = require("2baccbcca62c3280");
var _EventObject2 = _interopRequireDefault(_EventObject);
function addEventListener(target, eventType, callback, option) {
    function wrapCallback(e) {
        var ne = new _EventObject2["default"](e);
        callback.call(target, ne);
    }
    if (target.addEventListener) {
        var _ret = function() {
            var useCapture = false;
            if (typeof option === "object") useCapture = option.capture || false;
            else if (typeof option === "boolean") useCapture = option;
            target.addEventListener(eventType, wrapCallback, option || false);
            return {
                v: {
                    remove: function remove() {
                        target.removeEventListener(eventType, wrapCallback, useCapture);
                    }
                }
            };
        }();
        if (typeof _ret === "object") return _ret.v;
    } else if (target.attachEvent) {
        target.attachEvent("on" + eventType, wrapCallback);
        return {
            remove: function remove() {
                target.detachEvent("on" + eventType, wrapCallback);
            }
        };
    }
}
module.exports = exports["default"];

},{"2baccbcca62c3280":"j4JTz"}],"j4JTz":[function(require,module,exports) {
/**
 * @ignore
 * event object for dom
 * @author yiminghe@gmail.com
 */ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
var _EventBaseObject = require("5977de7cae912c7c");
var _EventBaseObject2 = _interopRequireDefault(_EventBaseObject);
var _objectAssign = require("d4cad87a41e5d9ab");
var _objectAssign2 = _interopRequireDefault(_objectAssign);
var TRUE = true;
var FALSE = false;
var commonProps = [
    "altKey",
    "bubbles",
    "cancelable",
    "ctrlKey",
    "currentTarget",
    "eventPhase",
    "metaKey",
    "shiftKey",
    "target",
    "timeStamp",
    "view",
    "type"
];
function isNullOrUndefined(w) {
    return w === null || w === undefined;
}
var eventNormalizers = [
    {
        reg: /^key/,
        props: [
            "char",
            "charCode",
            "key",
            "keyCode",
            "which"
        ],
        fix: function fix(event, nativeEvent) {
            if (isNullOrUndefined(event.which)) event.which = !isNullOrUndefined(nativeEvent.charCode) ? nativeEvent.charCode : nativeEvent.keyCode;
            // add metaKey to non-Mac browsers (use ctrl for PC 's and Meta for Macs)
            if (event.metaKey === undefined) event.metaKey = event.ctrlKey;
        }
    },
    {
        reg: /^touch/,
        props: [
            "touches",
            "changedTouches",
            "targetTouches"
        ]
    },
    {
        reg: /^hashchange$/,
        props: [
            "newURL",
            "oldURL"
        ]
    },
    {
        reg: /^gesturechange$/i,
        props: [
            "rotation",
            "scale"
        ]
    },
    {
        reg: /^(mousewheel|DOMMouseScroll)$/,
        props: [],
        fix: function fix(event, nativeEvent) {
            var deltaX = undefined;
            var deltaY = undefined;
            var delta = undefined;
            var wheelDelta = nativeEvent.wheelDelta;
            var axis = nativeEvent.axis;
            var wheelDeltaY = nativeEvent.wheelDeltaY;
            var wheelDeltaX = nativeEvent.wheelDeltaX;
            var detail = nativeEvent.detail;
            // ie/webkit
            if (wheelDelta) delta = wheelDelta / 120;
            // gecko
            if (detail) // press control e.detail == 1 else e.detail == 3
            delta = 0 - (detail % 3 === 0 ? detail / 3 : detail);
            // Gecko
            if (axis !== undefined) {
                if (axis === event.HORIZONTAL_AXIS) {
                    deltaY = 0;
                    deltaX = 0 - delta;
                } else if (axis === event.VERTICAL_AXIS) {
                    deltaX = 0;
                    deltaY = delta;
                }
            }
            // Webkit
            if (wheelDeltaY !== undefined) deltaY = wheelDeltaY / 120;
            if (wheelDeltaX !== undefined) deltaX = -1 * wheelDeltaX / 120;
            // 默认 deltaY (ie)
            if (!deltaX && !deltaY) deltaY = delta;
            if (deltaX !== undefined) /**
       * deltaX of mousewheel event
       * @property deltaX
       * @member Event.DomEvent.Object
       */ event.deltaX = deltaX;
            if (deltaY !== undefined) /**
       * deltaY of mousewheel event
       * @property deltaY
       * @member Event.DomEvent.Object
       */ event.deltaY = deltaY;
            if (delta !== undefined) /**
       * delta of mousewheel event
       * @property delta
       * @member Event.DomEvent.Object
       */ event.delta = delta;
        }
    },
    {
        reg: /^mouse|contextmenu|click|mspointer|(^DOMMouseScroll$)/i,
        props: [
            "buttons",
            "clientX",
            "clientY",
            "button",
            "offsetX",
            "relatedTarget",
            "which",
            "fromElement",
            "toElement",
            "offsetY",
            "pageX",
            "pageY",
            "screenX",
            "screenY"
        ],
        fix: function fix(event, nativeEvent) {
            var eventDoc = undefined;
            var doc = undefined;
            var body = undefined;
            var target = event.target;
            var button = nativeEvent.button;
            // Calculate pageX/Y if missing and clientX/Y available
            if (target && isNullOrUndefined(event.pageX) && !isNullOrUndefined(nativeEvent.clientX)) {
                eventDoc = target.ownerDocument || document;
                doc = eventDoc.documentElement;
                body = eventDoc.body;
                event.pageX = nativeEvent.clientX + (doc && doc.scrollLeft || body && body.scrollLeft || 0) - (doc && doc.clientLeft || body && body.clientLeft || 0);
                event.pageY = nativeEvent.clientY + (doc && doc.scrollTop || body && body.scrollTop || 0) - (doc && doc.clientTop || body && body.clientTop || 0);
            }
            // which for click: 1 === left; 2 === middle; 3 === right
            // do not use button
            if (!event.which && button !== undefined) {
                if (button & 1) event.which = 1;
                else if (button & 2) event.which = 3;
                else if (button & 4) event.which = 2;
                else event.which = 0;
            }
            // add relatedTarget, if necessary
            if (!event.relatedTarget && event.fromElement) event.relatedTarget = event.fromElement === target ? event.toElement : event.fromElement;
            return event;
        }
    }
];
function retTrue() {
    return TRUE;
}
function retFalse() {
    return FALSE;
}
function DomEventObject(nativeEvent) {
    var type = nativeEvent.type;
    var isNative = typeof nativeEvent.stopPropagation === "function" || typeof nativeEvent.cancelBubble === "boolean";
    _EventBaseObject2["default"].call(this);
    this.nativeEvent = nativeEvent;
    // in case dom event has been mark as default prevented by lower dom node
    var isDefaultPrevented = retFalse;
    if ("defaultPrevented" in nativeEvent) isDefaultPrevented = nativeEvent.defaultPrevented ? retTrue : retFalse;
    else if ("getPreventDefault" in nativeEvent) // https://bugzilla.mozilla.org/show_bug.cgi?id=691151
    isDefaultPrevented = nativeEvent.getPreventDefault() ? retTrue : retFalse;
    else if ("returnValue" in nativeEvent) isDefaultPrevented = nativeEvent.returnValue === FALSE ? retTrue : retFalse;
    this.isDefaultPrevented = isDefaultPrevented;
    var fixFns = [];
    var fixFn = undefined;
    var l = undefined;
    var prop = undefined;
    var props = commonProps.concat();
    eventNormalizers.forEach(function(normalizer) {
        if (type.match(normalizer.reg)) {
            props = props.concat(normalizer.props);
            if (normalizer.fix) fixFns.push(normalizer.fix);
        }
    });
    l = props.length;
    // clone properties of the original event object
    while(l){
        prop = props[--l];
        this[prop] = nativeEvent[prop];
    }
    // fix target property, if necessary
    if (!this.target && isNative) this.target = nativeEvent.srcElement || document; // srcElement might not be defined either
    // check if target is a text node (safari)
    if (this.target && this.target.nodeType === 3) this.target = this.target.parentNode;
    l = fixFns.length;
    while(l){
        fixFn = fixFns[--l];
        fixFn(this, nativeEvent);
    }
    this.timeStamp = nativeEvent.timeStamp || Date.now();
}
var EventBaseObjectProto = _EventBaseObject2["default"].prototype;
(0, _objectAssign2["default"])(DomEventObject.prototype, EventBaseObjectProto, {
    constructor: DomEventObject,
    preventDefault: function preventDefault() {
        var e = this.nativeEvent;
        // if preventDefault exists run it on the original event
        if (e.preventDefault) e.preventDefault();
        else // otherwise set the returnValue property of the original event to FALSE (IE)
        e.returnValue = FALSE;
        EventBaseObjectProto.preventDefault.call(this);
    },
    stopPropagation: function stopPropagation() {
        var e = this.nativeEvent;
        // if stopPropagation exists run it on the original event
        if (e.stopPropagation) e.stopPropagation();
        else // otherwise set the cancelBubble property of the original event to TRUE (IE)
        e.cancelBubble = TRUE;
        EventBaseObjectProto.stopPropagation.call(this);
    }
});
exports["default"] = DomEventObject;
module.exports = exports["default"];

},{"5977de7cae912c7c":"dbv80","d4cad87a41e5d9ab":"hdgcG"}],"dbv80":[function(require,module,exports) {
/**
 * @ignore
 * base event object for custom and dom event.
 * @author yiminghe@gmail.com
 */ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function returnFalse() {
    return false;
}
function returnTrue() {
    return true;
}
function EventBaseObject() {
    this.timeStamp = Date.now();
    this.target = undefined;
    this.currentTarget = undefined;
}
EventBaseObject.prototype = {
    isEventObject: 1,
    constructor: EventBaseObject,
    isDefaultPrevented: returnFalse,
    isPropagationStopped: returnFalse,
    isImmediatePropagationStopped: returnFalse,
    preventDefault: function preventDefault() {
        this.isDefaultPrevented = returnTrue;
    },
    stopPropagation: function stopPropagation() {
        this.isPropagationStopped = returnTrue;
    },
    stopImmediatePropagation: function stopImmediatePropagation() {
        this.isImmediatePropagationStopped = returnTrue;
        // fixed 1.2
        // call stopPropagation implicitly
        this.stopPropagation();
    },
    halt: function halt(immediate) {
        if (immediate) this.stopImmediatePropagation();
        else this.stopPropagation();
        this.preventDefault();
    }
};
exports["default"] = EventBaseObject;
module.exports = exports["default"];

},{}],"kXMVr":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>ContainerRender);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactDom = require("react-dom");
var _reactDomDefault = parcelHelpers.interopDefault(_reactDom);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
function _typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") _typeof = function _typeof(obj) {
        return typeof obj;
    };
    else _typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return _typeof(obj);
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return _possibleConstructorReturn(this, result);
    };
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) return call;
    return _assertThisInitialized(self);
}
function _assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
var ContainerRender = /*#__PURE__*/ function(_React$Component) {
    _inherits(ContainerRender, _React$Component);
    var _super = _createSuper(ContainerRender);
    function ContainerRender() {
        var _this;
        _classCallCheck(this, ContainerRender);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        _this.removeContainer = function() {
            if (_this.container) {
                (0, _reactDomDefault.default).unmountComponentAtNode(_this.container);
                _this.container.parentNode.removeChild(_this.container);
                _this.container = null;
            }
        };
        _this.renderComponent = function(props, ready) {
            var _this$props = _this.props, visible = _this$props.visible, getComponent = _this$props.getComponent, forceRender = _this$props.forceRender, getContainer = _this$props.getContainer, parent = _this$props.parent;
            if (visible || parent._component || forceRender) {
                if (!_this.container) _this.container = getContainer();
                (0, _reactDomDefault.default).unstable_renderSubtreeIntoContainer(parent, getComponent(props), _this.container, function callback() {
                    if (ready) ready.call(this);
                });
            }
        };
        return _this;
    }
    _createClass(ContainerRender, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                if (this.props.autoMount) this.renderComponent();
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate() {
                if (this.props.autoMount) this.renderComponent();
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                if (this.props.autoDestroy) this.removeContainer();
            }
        },
        {
            key: "render",
            value: function render() {
                return this.props.children({
                    renderComponent: this.renderComponent,
                    removeContainer: this.removeContainer
                });
            }
        }
    ]);
    return ContainerRender;
}((0, _reactDefault.default).Component);
ContainerRender.propTypes = {
    autoMount: (0, _propTypesDefault.default).bool,
    autoDestroy: (0, _propTypesDefault.default).bool,
    visible: (0, _propTypesDefault.default).bool,
    forceRender: (0, _propTypesDefault.default).bool,
    parent: (0, _propTypesDefault.default).any,
    getComponent: (0, _propTypesDefault.default).func.isRequired,
    getContainer: (0, _propTypesDefault.default).func.isRequired,
    children: (0, _propTypesDefault.default).func.isRequired
};
ContainerRender.defaultProps = {
    autoMount: true,
    autoDestroy: true,
    forceRender: false
};

},{"react":"6uln9","react-dom":"b8T3j","prop-types":"6FKs7","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2D1Me":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Portal);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactDom = require("react-dom");
var _reactDomDefault = parcelHelpers.interopDefault(_reactDom);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
function _typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") _typeof = function _typeof(obj) {
        return typeof obj;
    };
    else _typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return _typeof(obj);
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return _possibleConstructorReturn(this, result);
    };
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) return call;
    return _assertThisInitialized(self);
}
function _assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
var Portal = /*#__PURE__*/ function(_React$Component) {
    _inherits(Portal, _React$Component);
    var _super = _createSuper(Portal);
    function Portal() {
        _classCallCheck(this, Portal);
        return _super.apply(this, arguments);
    }
    _createClass(Portal, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this.createContainer();
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps) {
                var didUpdate = this.props.didUpdate;
                if (didUpdate) didUpdate(prevProps);
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this.removeContainer();
            }
        },
        {
            key: "createContainer",
            value: function createContainer() {
                this._container = this.props.getContainer();
                this.forceUpdate();
            }
        },
        {
            key: "removeContainer",
            value: function removeContainer() {
                if (this._container) this._container.parentNode.removeChild(this._container);
            }
        },
        {
            key: "render",
            value: function render() {
                if (this._container) return (0, _reactDomDefault.default).createPortal(this.props.children, this._container);
                return null;
            }
        }
    ]);
    return Portal;
}((0, _reactDefault.default).Component);
Portal.propTypes = {
    getContainer: (0, _propTypesDefault.default).func.isRequired,
    children: (0, _propTypesDefault.default).node.isRequired,
    didUpdate: (0, _propTypesDefault.default).func
};

},{"react":"6uln9","react-dom":"b8T3j","prop-types":"6FKs7","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hVGzI":[function(require,module,exports) {
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/ /* global define */ (function() {
    "use strict";
    var hasOwn = {}.hasOwnProperty;
    var nativeCodeString = "[native code]";
    function classNames() {
        var classes = [];
        for(var i = 0; i < arguments.length; i++){
            var arg = arguments[i];
            if (!arg) continue;
            var argType = typeof arg;
            if (argType === "string" || argType === "number") classes.push(arg);
            else if (Array.isArray(arg)) {
                if (arg.length) {
                    var inner = classNames.apply(null, arg);
                    if (inner) classes.push(inner);
                }
            } else if (argType === "object") {
                if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes("[native code]")) {
                    classes.push(arg.toString());
                    continue;
                }
                for(var key in arg)if (hasOwn.call(arg, key) && arg[key]) classes.push(key);
            }
        }
        return classes.join(" ");
    }
    if (0, module.exports) {
        classNames.default = classNames;
        module.exports = classNames;
    } else if (typeof define === "function" && typeof define.amd === "object" && define.amd) // register as 'classnames', consistent with npm package name
    define("classnames", [], function() {
        return classNames;
    });
    else window.classNames = classNames;
})();

},{}],"fC9Ax":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getAlignFromPlacement", ()=>getAlignFromPlacement);
parcelHelpers.export(exports, "getAlignPopupClassName", ()=>getAlignPopupClassName);
parcelHelpers.export(exports, "saveRef", ()=>saveRef);
var _extends = require("babel-runtime/helpers/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
function isPointsEq(a1, a2, isAlignPoint) {
    if (isAlignPoint) return a1[0] === a2[0];
    return a1[0] === a2[0] && a1[1] === a2[1];
}
function getAlignFromPlacement(builtinPlacements, placementStr, align) {
    var baseAlign = builtinPlacements[placementStr] || {};
    return (0, _extendsDefault.default)({}, baseAlign, align);
}
function getAlignPopupClassName(builtinPlacements, prefixCls, align, isAlignPoint) {
    var points = align.points;
    for(var placement in builtinPlacements)if (builtinPlacements.hasOwnProperty(placement)) {
        if (isPointsEq(builtinPlacements[placement].points, points, isAlignPoint)) return prefixCls + "-placement-" + placement;
    }
    return "";
}
function saveRef(name, component) {
    this[name] = component;
}

},{"babel-runtime/helpers/extends":"4sKqp","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"li3F1":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _extends = require("babel-runtime/helpers/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _classCallCheck = require("babel-runtime/helpers/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _possibleConstructorReturn = require("babel-runtime/helpers/possibleConstructorReturn");
var _possibleConstructorReturnDefault = parcelHelpers.interopDefault(_possibleConstructorReturn);
var _inherits = require("babel-runtime/helpers/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _reactDom = require("react-dom");
var _reactDomDefault = parcelHelpers.interopDefault(_reactDom);
var _rcAlign = require("rc-align");
var _rcAlignDefault = parcelHelpers.interopDefault(_rcAlign);
var _rcAnimate = require("rc-animate");
var _rcAnimateDefault = parcelHelpers.interopDefault(_rcAnimate);
var _popupInner = require("./PopupInner");
var _popupInnerDefault = parcelHelpers.interopDefault(_popupInner);
var _lazyRenderBox = require("./LazyRenderBox");
var _lazyRenderBoxDefault = parcelHelpers.interopDefault(_lazyRenderBox);
var _utils = require("./utils");
var Popup = function(_Component) {
    (0, _inheritsDefault.default)(Popup, _Component);
    function Popup(props) {
        (0, _classCallCheckDefault.default)(this, Popup);
        var _this = (0, _possibleConstructorReturnDefault.default)(this, _Component.call(this, props));
        _initialiseProps.call(_this);
        _this.state = {
            // Used for stretch
            stretchChecked: false,
            targetWidth: undefined,
            targetHeight: undefined
        };
        _this.savePopupRef = (0, _utils.saveRef).bind(_this, "popupInstance");
        _this.saveAlignRef = (0, _utils.saveRef).bind(_this, "alignInstance");
        return _this;
    }
    Popup.prototype.componentDidMount = function componentDidMount() {
        this.rootNode = this.getPopupDomNode();
        this.setStretchSize();
    };
    Popup.prototype.componentDidUpdate = function componentDidUpdate() {
        this.setStretchSize();
    };
    // Record size if stretch needed
    Popup.prototype.getPopupDomNode = function getPopupDomNode() {
        return (0, _reactDomDefault.default).findDOMNode(this.popupInstance);
    };
    // `target` on `rc-align` can accept as a function to get the bind element or a point.
    // ref: https://www.npmjs.com/package/rc-align
    Popup.prototype.getMaskTransitionName = function getMaskTransitionName() {
        var props = this.props;
        var transitionName = props.maskTransitionName;
        var animation = props.maskAnimation;
        if (!transitionName && animation) transitionName = props.prefixCls + "-" + animation;
        return transitionName;
    };
    Popup.prototype.getTransitionName = function getTransitionName() {
        var props = this.props;
        var transitionName = props.transitionName;
        if (!transitionName && props.animation) transitionName = props.prefixCls + "-" + props.animation;
        return transitionName;
    };
    Popup.prototype.getClassName = function getClassName(currentAlignClassName) {
        return this.props.prefixCls + " " + this.props.className + " " + currentAlignClassName;
    };
    Popup.prototype.getPopupElement = function getPopupElement() {
        var _this2 = this;
        var savePopupRef = this.savePopupRef;
        var _state = this.state, stretchChecked = _state.stretchChecked, targetHeight = _state.targetHeight, targetWidth = _state.targetWidth;
        var _props = this.props, align = _props.align, visible = _props.visible, prefixCls = _props.prefixCls, style = _props.style, getClassNameFromAlign = _props.getClassNameFromAlign, destroyPopupOnHide = _props.destroyPopupOnHide, stretch = _props.stretch, children = _props.children, onMouseEnter = _props.onMouseEnter, onMouseLeave = _props.onMouseLeave, onMouseDown = _props.onMouseDown, onTouchStart = _props.onTouchStart;
        var className = this.getClassName(this.currentAlignClassName || getClassNameFromAlign(align));
        var hiddenClassName = prefixCls + "-hidden";
        if (!visible) this.currentAlignClassName = null;
        var sizeStyle = {};
        if (stretch) {
            // Stretch with target
            if (stretch.indexOf("height") !== -1) sizeStyle.height = targetHeight;
            else if (stretch.indexOf("minHeight") !== -1) sizeStyle.minHeight = targetHeight;
            if (stretch.indexOf("width") !== -1) sizeStyle.width = targetWidth;
            else if (stretch.indexOf("minWidth") !== -1) sizeStyle.minWidth = targetWidth;
            // Delay force align to makes ui smooth
            if (!stretchChecked) {
                sizeStyle.visibility = "hidden";
                setTimeout(function() {
                    if (_this2.alignInstance) _this2.alignInstance.forceAlign();
                }, 0);
            }
        }
        var newStyle = (0, _extendsDefault.default)({}, sizeStyle, style, this.getZIndexStyle());
        var popupInnerProps = {
            className: className,
            prefixCls: prefixCls,
            ref: savePopupRef,
            onMouseEnter: onMouseEnter,
            onMouseLeave: onMouseLeave,
            onMouseDown: onMouseDown,
            onTouchStart: onTouchStart,
            style: newStyle
        };
        if (destroyPopupOnHide) return (0, _reactDefault.default).createElement((0, _rcAnimateDefault.default), {
            component: "",
            exclusive: true,
            transitionAppear: true,
            transitionName: this.getTransitionName()
        }, visible ? (0, _reactDefault.default).createElement((0, _rcAlignDefault.default), {
            target: this.getAlignTarget(),
            key: "popup",
            ref: this.saveAlignRef,
            monitorWindowResize: true,
            align: align,
            onAlign: this.onAlign
        }, (0, _reactDefault.default).createElement((0, _popupInnerDefault.default), (0, _extendsDefault.default)({
            visible: true
        }, popupInnerProps), children)) : null);
        return (0, _reactDefault.default).createElement((0, _rcAnimateDefault.default), {
            component: "",
            exclusive: true,
            transitionAppear: true,
            transitionName: this.getTransitionName(),
            showProp: "xVisible"
        }, (0, _reactDefault.default).createElement((0, _rcAlignDefault.default), {
            target: this.getAlignTarget(),
            key: "popup",
            ref: this.saveAlignRef,
            monitorWindowResize: true,
            xVisible: visible,
            childrenProps: {
                visible: "xVisible"
            },
            disabled: !visible,
            align: align,
            onAlign: this.onAlign
        }, (0, _reactDefault.default).createElement((0, _popupInnerDefault.default), (0, _extendsDefault.default)({
            hiddenClassName: hiddenClassName
        }, popupInnerProps), children)));
    };
    Popup.prototype.getZIndexStyle = function getZIndexStyle() {
        var style = {};
        var props = this.props;
        if (props.zIndex !== undefined) style.zIndex = props.zIndex;
        return style;
    };
    Popup.prototype.getMaskElement = function getMaskElement() {
        var props = this.props;
        var maskElement = void 0;
        if (props.mask) {
            var maskTransition = this.getMaskTransitionName();
            maskElement = (0, _reactDefault.default).createElement((0, _lazyRenderBoxDefault.default), {
                style: this.getZIndexStyle(),
                key: "mask",
                className: props.prefixCls + "-mask",
                hiddenClassName: props.prefixCls + "-mask-hidden",
                visible: props.visible
            });
            if (maskTransition) maskElement = (0, _reactDefault.default).createElement((0, _rcAnimateDefault.default), {
                key: "mask",
                showProp: "visible",
                transitionAppear: true,
                component: "",
                transitionName: maskTransition
            }, maskElement);
        }
        return maskElement;
    };
    Popup.prototype.render = function render() {
        return (0, _reactDefault.default).createElement("div", null, this.getMaskElement(), this.getPopupElement());
    };
    return Popup;
}((0, _react.Component));
Popup.propTypes = {
    visible: (0, _propTypesDefault.default).bool,
    style: (0, _propTypesDefault.default).object,
    getClassNameFromAlign: (0, _propTypesDefault.default).func,
    onAlign: (0, _propTypesDefault.default).func,
    getRootDomNode: (0, _propTypesDefault.default).func,
    align: (0, _propTypesDefault.default).any,
    destroyPopupOnHide: (0, _propTypesDefault.default).bool,
    className: (0, _propTypesDefault.default).string,
    prefixCls: (0, _propTypesDefault.default).string,
    onMouseEnter: (0, _propTypesDefault.default).func,
    onMouseLeave: (0, _propTypesDefault.default).func,
    onMouseDown: (0, _propTypesDefault.default).func,
    onTouchStart: (0, _propTypesDefault.default).func,
    stretch: (0, _propTypesDefault.default).string,
    children: (0, _propTypesDefault.default).node,
    point: (0, _propTypesDefault.default).shape({
        pageX: (0, _propTypesDefault.default).number,
        pageY: (0, _propTypesDefault.default).number
    })
};
var _initialiseProps = function _initialiseProps() {
    var _this3 = this;
    this.onAlign = function(popupDomNode, align) {
        var props = _this3.props;
        var currentAlignClassName = props.getClassNameFromAlign(align);
        // FIX: https://github.com/react-component/trigger/issues/56
        // FIX: https://github.com/react-component/tooltip/issues/79
        if (_this3.currentAlignClassName !== currentAlignClassName) {
            _this3.currentAlignClassName = currentAlignClassName;
            popupDomNode.className = _this3.getClassName(currentAlignClassName);
        }
        props.onAlign(popupDomNode, align);
    };
    this.setStretchSize = function() {
        var _props2 = _this3.props, stretch = _props2.stretch, getRootDomNode = _props2.getRootDomNode, visible = _props2.visible;
        var _state2 = _this3.state, stretchChecked = _state2.stretchChecked, targetHeight = _state2.targetHeight, targetWidth = _state2.targetWidth;
        if (!stretch || !visible) {
            if (stretchChecked) _this3.setState({
                stretchChecked: false
            });
            return;
        }
        var $ele = getRootDomNode();
        if (!$ele) return;
        var height = $ele.offsetHeight;
        var width = $ele.offsetWidth;
        if (targetHeight !== height || targetWidth !== width || !stretchChecked) _this3.setState({
            stretchChecked: true,
            targetHeight: height,
            targetWidth: width
        });
    };
    this.getTargetElement = function() {
        return _this3.props.getRootDomNode();
    };
    this.getAlignTarget = function() {
        var point = _this3.props.point;
        if (point) return point;
        return _this3.getTargetElement;
    };
};
exports.default = Popup;

},{"babel-runtime/helpers/extends":"4sKqp","babel-runtime/helpers/classCallCheck":"aRpYz","babel-runtime/helpers/possibleConstructorReturn":"40Qb5","babel-runtime/helpers/inherits":"bitir","react":"6uln9","prop-types":"6FKs7","react-dom":"b8T3j","rc-align":"6BHy8","rc-animate":"7NqFA","./PopupInner":"36CCX","./LazyRenderBox":"5jeV2","./utils":"fC9Ax","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6BHy8":[function(require,module,exports) {
// export this package's api
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _align = require("./Align");
var _alignDefault = parcelHelpers.interopDefault(_align);
exports.default = (0, _alignDefault.default);

},{"./Align":"fEfj8","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"fEfj8":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _classCallCheck = require("babel-runtime/helpers/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("babel-runtime/helpers/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _possibleConstructorReturn = require("babel-runtime/helpers/possibleConstructorReturn");
var _possibleConstructorReturnDefault = parcelHelpers.interopDefault(_possibleConstructorReturn);
var _inherits = require("babel-runtime/helpers/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _reactDom = require("react-dom");
var _reactDomDefault = parcelHelpers.interopDefault(_reactDom);
var _domAlign = require("dom-align");
var _addEventListener = require("rc-util/es/Dom/addEventListener");
var _addEventListenerDefault = parcelHelpers.interopDefault(_addEventListener);
var _util = require("./util");
function getElement(func) {
    if (typeof func !== "function" || !func) return null;
    return func();
}
function getPoint(point) {
    if (typeof point !== "object" || !point) return null;
    return point;
}
var Align = function(_Component) {
    (0, _inheritsDefault.default)(Align, _Component);
    function Align() {
        var _ref;
        var _temp, _this, _ret;
        (0, _classCallCheckDefault.default)(this, Align);
        for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return _ret = (_temp = (_this = (0, _possibleConstructorReturnDefault.default)(this, (_ref = Align.__proto__ || Object.getPrototypeOf(Align)).call.apply(_ref, [
            this
        ].concat(args))), _this), _this.forceAlign = function() {
            var _this$props = _this.props, disabled = _this$props.disabled, target = _this$props.target, align = _this$props.align, onAlign = _this$props.onAlign;
            if (!disabled && target) {
                var source = (0, _reactDomDefault.default).findDOMNode(_this);
                var result = void 0;
                var element = getElement(target);
                var point = getPoint(target);
                // IE lose focus after element realign
                // We should record activeElement and restore later
                var activeElement = document.activeElement;
                if (element) result = (0, _domAlign.alignElement)(source, element, align);
                else if (point) result = (0, _domAlign.alignPoint)(source, point, align);
                (0, _util.restoreFocus)(activeElement, source);
                if (onAlign) onAlign(source, result);
            }
        }, _temp), (0, _possibleConstructorReturnDefault.default)(_this, _ret);
    }
    (0, _createClassDefault.default)(Align, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                var props = this.props;
                // if parent ref not attached .... use document.getElementById
                this.forceAlign();
                if (!props.disabled && props.monitorWindowResize) this.startMonitorWindowResize();
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps) {
                var reAlign = false;
                var props = this.props;
                if (!props.disabled) {
                    var source = (0, _reactDomDefault.default).findDOMNode(this);
                    var sourceRect = source ? source.getBoundingClientRect() : null;
                    if (prevProps.disabled) reAlign = true;
                    else {
                        var lastElement = getElement(prevProps.target);
                        var currentElement = getElement(props.target);
                        var lastPoint = getPoint(prevProps.target);
                        var currentPoint = getPoint(props.target);
                        if ((0, _util.isWindow)(lastElement) && (0, _util.isWindow)(currentElement)) // Skip if is window
                        reAlign = false;
                        else if (lastElement !== currentElement || // Element change
                        lastElement && !currentElement && currentPoint || // Change from element to point
                        lastPoint && currentPoint && currentElement || // Change from point to element
                        currentPoint && !(0, _util.isSamePoint)(lastPoint, currentPoint)) reAlign = true;
                        // If source element size changed
                        var preRect = this.sourceRect || {};
                        if (!reAlign && source && (!(0, _util.isSimilarValue)(preRect.width, sourceRect.width) || !(0, _util.isSimilarValue)(preRect.height, sourceRect.height))) reAlign = true;
                    }
                    this.sourceRect = sourceRect;
                }
                if (reAlign) this.forceAlign();
                if (props.monitorWindowResize && !props.disabled) this.startMonitorWindowResize();
                else this.stopMonitorWindowResize();
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this.stopMonitorWindowResize();
            }
        },
        {
            key: "startMonitorWindowResize",
            value: function startMonitorWindowResize() {
                if (!this.resizeHandler) {
                    this.bufferMonitor = (0, _util.buffer)(this.forceAlign, this.props.monitorBufferTime);
                    this.resizeHandler = (0, _addEventListenerDefault.default)(window, "resize", this.bufferMonitor);
                }
            }
        },
        {
            key: "stopMonitorWindowResize",
            value: function stopMonitorWindowResize() {
                if (this.resizeHandler) {
                    this.bufferMonitor.clear();
                    this.resizeHandler.remove();
                    this.resizeHandler = null;
                }
            }
        },
        {
            key: "render",
            value: function render() {
                var _this2 = this;
                var _props = this.props, childrenProps = _props.childrenProps, children = _props.children;
                var child = (0, _reactDefault.default).Children.only(children);
                if (childrenProps) {
                    var newProps = {};
                    var propList = Object.keys(childrenProps);
                    propList.forEach(function(prop) {
                        newProps[prop] = _this2.props[childrenProps[prop]];
                    });
                    return (0, _reactDefault.default).cloneElement(child, newProps);
                }
                return child;
            }
        }
    ]);
    return Align;
}((0, _react.Component));
Align.propTypes = {
    childrenProps: (0, _propTypesDefault.default).object,
    align: (0, _propTypesDefault.default).object.isRequired,
    target: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).func,
        (0, _propTypesDefault.default).shape({
            clientX: (0, _propTypesDefault.default).number,
            clientY: (0, _propTypesDefault.default).number,
            pageX: (0, _propTypesDefault.default).number,
            pageY: (0, _propTypesDefault.default).number
        })
    ]),
    onAlign: (0, _propTypesDefault.default).func,
    monitorBufferTime: (0, _propTypesDefault.default).number,
    monitorWindowResize: (0, _propTypesDefault.default).bool,
    disabled: (0, _propTypesDefault.default).bool,
    children: (0, _propTypesDefault.default).any
};
Align.defaultProps = {
    target: function target() {
        return window;
    },
    monitorBufferTime: 50,
    monitorWindowResize: false,
    disabled: false
};
exports.default = Align;

},{"babel-runtime/helpers/classCallCheck":"aRpYz","babel-runtime/helpers/createClass":"a0jaP","babel-runtime/helpers/possibleConstructorReturn":"40Qb5","babel-runtime/helpers/inherits":"bitir","react":"6uln9","prop-types":"6FKs7","react-dom":"b8T3j","dom-align":"dQ6FE","rc-util/es/Dom/addEventListener":"dHu4r","./util":"ltQDq","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"a0jaP":[function(require,module,exports) {
"use strict";
exports.__esModule = true;
var _defineProperty = require("4ee51b39fa0a487d");
var _defineProperty2 = _interopRequireDefault(_defineProperty);
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
exports.default = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            (0, _defineProperty2.default)(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();

},{"4ee51b39fa0a487d":"7ehbB"}],"7ehbB":[function(require,module,exports) {
module.exports = {
    "default": require("beda317bff3b8a5f"),
    __esModule: true
};

},{"beda317bff3b8a5f":"chjld"}],"chjld":[function(require,module,exports) {
require("c2cc92549895931b");
var $Object = require("5237c59f9173ada").Object;
module.exports = function defineProperty(it, key, desc) {
    return $Object.defineProperty(it, key, desc);
};

},{"c2cc92549895931b":"dhacH","5237c59f9173ada":"i8kQt"}],"dhacH":[function(require,module,exports) {
var $export = require("dd1ec35f4aa4c1c7");
// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
$export($export.S + $export.F * !require("b534d393740f7439"), "Object", {
    defineProperty: require("fd1e7314ba483aa1").f
});

},{"dd1ec35f4aa4c1c7":"1OjY7","b534d393740f7439":"cWdn9","fd1e7314ba483aa1":"5eLt9"}],"dQ6FE":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "alignElement", ()=>alignElement);
parcelHelpers.export(exports, "alignPoint", ()=>alignPoint);
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpread2(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? ownKeys(Object(source), !0).forEach(function(key) {
            _defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _typeof(obj) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, _typeof(obj);
}
function _defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var vendorPrefix;
var jsCssMap = {
    Webkit: "-webkit-",
    Moz: "-moz-",
    // IE did it wrong again ...
    ms: "-ms-",
    O: "-o-"
};
function getVendorPrefix() {
    if (vendorPrefix !== undefined) return vendorPrefix;
    vendorPrefix = "";
    var style = document.createElement("p").style;
    var testProp = "Transform";
    for(var key in jsCssMap)if (key + testProp in style) vendorPrefix = key;
    return vendorPrefix;
}
function getTransitionName() {
    return getVendorPrefix() ? "".concat(getVendorPrefix(), "TransitionProperty") : "transitionProperty";
}
function getTransformName() {
    return getVendorPrefix() ? "".concat(getVendorPrefix(), "Transform") : "transform";
}
function setTransitionProperty(node, value) {
    var name = getTransitionName();
    if (name) {
        node.style[name] = value;
        if (name !== "transitionProperty") node.style.transitionProperty = value;
    }
}
function setTransform(node, value) {
    var name = getTransformName();
    if (name) {
        node.style[name] = value;
        if (name !== "transform") node.style.transform = value;
    }
}
function getTransitionProperty(node) {
    return node.style.transitionProperty || node.style[getTransitionName()];
}
function getTransformXY(node) {
    var style = window.getComputedStyle(node, null);
    var transform = style.getPropertyValue("transform") || style.getPropertyValue(getTransformName());
    if (transform && transform !== "none") {
        var matrix = transform.replace(/[^0-9\-.,]/g, "").split(",");
        return {
            x: parseFloat(matrix[12] || matrix[4], 0),
            y: parseFloat(matrix[13] || matrix[5], 0)
        };
    }
    return {
        x: 0,
        y: 0
    };
}
var matrix2d = /matrix\((.*)\)/;
var matrix3d = /matrix3d\((.*)\)/;
function setTransformXY(node, xy) {
    var style = window.getComputedStyle(node, null);
    var transform = style.getPropertyValue("transform") || style.getPropertyValue(getTransformName());
    if (transform && transform !== "none") {
        var arr;
        var match2d = transform.match(matrix2d);
        if (match2d) {
            match2d = match2d[1];
            arr = match2d.split(",").map(function(item) {
                return parseFloat(item, 10);
            });
            arr[4] = xy.x;
            arr[5] = xy.y;
            setTransform(node, "matrix(".concat(arr.join(","), ")"));
        } else {
            var match3d = transform.match(matrix3d)[1];
            arr = match3d.split(",").map(function(item) {
                return parseFloat(item, 10);
            });
            arr[12] = xy.x;
            arr[13] = xy.y;
            setTransform(node, "matrix3d(".concat(arr.join(","), ")"));
        }
    } else setTransform(node, "translateX(".concat(xy.x, "px) translateY(").concat(xy.y, "px) translateZ(0)"));
}
var RE_NUM = /[\-+]?(?:\d*\.|)\d+(?:[eE][\-+]?\d+|)/.source;
var getComputedStyleX;
// https://stackoverflow.com/a/3485654/3040605
function forceRelayout(elem) {
    var originalStyle = elem.style.display;
    elem.style.display = "none";
    elem.offsetHeight; // eslint-disable-line
    elem.style.display = originalStyle;
}
function css(el, name, v) {
    var value = v;
    if (_typeof(name) === "object") {
        for(var i in name)if (name.hasOwnProperty(i)) css(el, i, name[i]);
        return undefined;
    }
    if (typeof value !== "undefined") {
        if (typeof value === "number") value = "".concat(value, "px");
        el.style[name] = value;
        return undefined;
    }
    return getComputedStyleX(el, name);
}
function getClientPosition(elem) {
    var box;
    var x;
    var y;
    var doc = elem.ownerDocument;
    var body = doc.body;
    var docElem = doc && doc.documentElement;
    // 根据 GBS 最新数据，A-Grade Browsers 都已支持 getBoundingClientRect 方法，不用再考虑传统的实现方式
    box = elem.getBoundingClientRect();
    // 注：jQuery 还考虑减去 docElem.clientLeft/clientTop
    // 但测试发现，这样反而会导致当 html 和 body 有边距/边框样式时，获取的值不正确
    // 此外，ie6 会忽略 html 的 margin 值，幸运地是没有谁会去设置 html 的 margin
    x = Math.floor(box.left);
    y = Math.floor(box.top);
    // In IE, most of the time, 2 extra pixels are added to the top and left
    // due to the implicit 2-pixel inset border.  In IE6/7 quirks mode and
    // IE6 standards mode, this border can be overridden by setting the
    // document element's border to zero -- thus, we cannot rely on the
    // offset always being 2 pixels.
    // In quirks mode, the offset can be determined by querying the body's
    // clientLeft/clientTop, but in standards mode, it is found by querying
    // the document element's clientLeft/clientTop.  Since we already called
    // getClientBoundingRect we have already forced a reflow, so it is not
    // too expensive just to query them all.
    // ie 下应该减去窗口的边框吧，毕竟默认 absolute 都是相对窗口定位的
    // 窗口边框标准是设 documentElement ,quirks 时设置 body
    // 最好禁止在 body 和 html 上边框 ，但 ie < 9 html 默认有 2px ，减去
    // 但是非 ie 不可能设置窗口边框，body html 也不是窗口 ,ie 可以通过 html,body 设置
    // 标准 ie 下 docElem.clientTop 就是 border-top
    // ie7 html 即窗口边框改变不了。永远为 2
    // 但标准 firefox/chrome/ie9 下 docElem.clientTop 是窗口边框，即使设了 border-top 也为 0
    x -= docElem.clientLeft || body.clientLeft || 0;
    y -= docElem.clientTop || body.clientTop || 0;
    return {
        left: x,
        top: y
    };
}
function getScroll(w, top) {
    var ret = w["page".concat(top ? "Y" : "X", "Offset")];
    var method = "scroll".concat(top ? "Top" : "Left");
    if (typeof ret !== "number") {
        var d = w.document;
        // ie6,7,8 standard mode
        ret = d.documentElement[method];
        if (typeof ret !== "number") // quirks mode
        ret = d.body[method];
    }
    return ret;
}
function getScrollLeft(w) {
    return getScroll(w);
}
function getScrollTop(w) {
    return getScroll(w, true);
}
function getOffset(el) {
    var pos = getClientPosition(el);
    var doc = el.ownerDocument;
    var w = doc.defaultView || doc.parentWindow;
    pos.left += getScrollLeft(w);
    pos.top += getScrollTop(w);
    return pos;
}
/**
 * A crude way of determining if an object is a window
 * @member util
 */ function isWindow(obj) {
    // must use == for ie8
    /* eslint eqeqeq:0 */ return obj !== null && obj !== undefined && obj == obj.window;
}
function getDocument(node) {
    if (isWindow(node)) return node.document;
    if (node.nodeType === 9) return node;
    return node.ownerDocument;
}
function _getComputedStyle(elem, name, cs) {
    var computedStyle = cs;
    var val = "";
    var d = getDocument(elem);
    computedStyle = computedStyle || d.defaultView.getComputedStyle(elem, null);
    // https://github.com/kissyteam/kissy/issues/61
    if (computedStyle) val = computedStyle.getPropertyValue(name) || computedStyle[name];
    return val;
}
var _RE_NUM_NO_PX = new RegExp("^(".concat(RE_NUM, ")(?!px)[a-z%]+$"), "i");
var RE_POS = /^(top|right|bottom|left)$/;
var CURRENT_STYLE = "currentStyle";
var RUNTIME_STYLE = "runtimeStyle";
var LEFT = "left";
var PX = "px";
function _getComputedStyleIE(elem, name) {
    // currentStyle maybe null
    // http://msdn.microsoft.com/en-us/library/ms535231.aspx
    var ret = elem[CURRENT_STYLE] && elem[CURRENT_STYLE][name];
    // 当 width/height 设置为百分比时，通过 pixelLeft 方式转换的 width/height 值
    // 一开始就处理了! CUSTOM_STYLE.height,CUSTOM_STYLE.width ,cssHook 解决@2011-08-19
    // 在 ie 下不对，需要直接用 offset 方式
    // borderWidth 等值也有问题，但考虑到 borderWidth 设为百分比的概率很小，这里就不考虑了
    // From the awesome hack by Dean Edwards
    // http://erik.eae.net/archives/2007/07/27/18.54.15/#comment-102291
    // If we're not dealing with a regular pixel number
    // but a number that has a weird ending, we need to convert it to pixels
    // exclude left right for relativity
    if (_RE_NUM_NO_PX.test(ret) && !RE_POS.test(name)) {
        // Remember the original values
        var style = elem.style;
        var left = style[LEFT];
        var rsLeft = elem[RUNTIME_STYLE][LEFT];
        // prevent flashing of content
        elem[RUNTIME_STYLE][LEFT] = elem[CURRENT_STYLE][LEFT];
        // Put in the new values to get a computed value out
        style[LEFT] = name === "fontSize" ? "1em" : ret || 0;
        ret = style.pixelLeft + PX;
        // Revert the changed values
        style[LEFT] = left;
        elem[RUNTIME_STYLE][LEFT] = rsLeft;
    }
    return ret === "" ? "auto" : ret;
}
if (typeof window !== "undefined") getComputedStyleX = window.getComputedStyle ? _getComputedStyle : _getComputedStyleIE;
function getOffsetDirection(dir, option) {
    if (dir === "left") return option.useCssRight ? "right" : dir;
    return option.useCssBottom ? "bottom" : dir;
}
function oppositeOffsetDirection(dir) {
    if (dir === "left") return "right";
    else if (dir === "right") return "left";
    else if (dir === "top") return "bottom";
    else if (dir === "bottom") return "top";
}
// 设置 elem 相对 elem.ownerDocument 的坐标
function setLeftTop(elem, offset, option) {
    // set position first, in-case top/left are set even on static elem
    if (css(elem, "position") === "static") elem.style.position = "relative";
    var presetH = -999;
    var presetV = -999;
    var horizontalProperty = getOffsetDirection("left", option);
    var verticalProperty = getOffsetDirection("top", option);
    var oppositeHorizontalProperty = oppositeOffsetDirection(horizontalProperty);
    var oppositeVerticalProperty = oppositeOffsetDirection(verticalProperty);
    if (horizontalProperty !== "left") presetH = 999;
    if (verticalProperty !== "top") presetV = 999;
    var originalTransition = "";
    var originalOffset = getOffset(elem);
    if ("left" in offset || "top" in offset) {
        originalTransition = getTransitionProperty(elem) || "";
        setTransitionProperty(elem, "none");
    }
    if ("left" in offset) {
        elem.style[oppositeHorizontalProperty] = "";
        elem.style[horizontalProperty] = "".concat(presetH, "px");
    }
    if ("top" in offset) {
        elem.style[oppositeVerticalProperty] = "";
        elem.style[verticalProperty] = "".concat(presetV, "px");
    }
    // force relayout
    forceRelayout(elem);
    var old = getOffset(elem);
    var originalStyle = {};
    for(var key in offset)if (offset.hasOwnProperty(key)) {
        var dir = getOffsetDirection(key, option);
        var preset = key === "left" ? presetH : presetV;
        var off = originalOffset[key] - old[key];
        if (dir === key) originalStyle[dir] = preset + off;
        else originalStyle[dir] = preset - off;
    }
    css(elem, originalStyle);
    // force relayout
    forceRelayout(elem);
    if ("left" in offset || "top" in offset) setTransitionProperty(elem, originalTransition);
    var ret = {};
    for(var _key in offset)if (offset.hasOwnProperty(_key)) {
        var _dir = getOffsetDirection(_key, option);
        var _off = offset[_key] - originalOffset[_key];
        if (_key === _dir) ret[_dir] = originalStyle[_dir] + _off;
        else ret[_dir] = originalStyle[_dir] - _off;
    }
    css(elem, ret);
}
function setTransform$1(elem, offset) {
    var originalOffset = getOffset(elem);
    var originalXY = getTransformXY(elem);
    var resultXY = {
        x: originalXY.x,
        y: originalXY.y
    };
    if ("left" in offset) resultXY.x = originalXY.x + offset.left - originalOffset.left;
    if ("top" in offset) resultXY.y = originalXY.y + offset.top - originalOffset.top;
    setTransformXY(elem, resultXY);
}
function setOffset(elem, offset, option) {
    if (option.ignoreShake) {
        var oriOffset = getOffset(elem);
        var oLeft = oriOffset.left.toFixed(0);
        var oTop = oriOffset.top.toFixed(0);
        var tLeft = offset.left.toFixed(0);
        var tTop = offset.top.toFixed(0);
        if (oLeft === tLeft && oTop === tTop) return;
    }
    if (option.useCssRight || option.useCssBottom) setLeftTop(elem, offset, option);
    else if (option.useCssTransform && getTransformName() in document.body.style) setTransform$1(elem, offset);
    else setLeftTop(elem, offset, option);
}
function each(arr, fn) {
    for(var i = 0; i < arr.length; i++)fn(arr[i]);
}
function isBorderBoxFn(elem) {
    return getComputedStyleX(elem, "boxSizing") === "border-box";
}
var BOX_MODELS = [
    "margin",
    "border",
    "padding"
];
var CONTENT_INDEX = -1;
var PADDING_INDEX = 2;
var BORDER_INDEX = 1;
var MARGIN_INDEX = 0;
function swap(elem, options, callback) {
    var old = {};
    var style = elem.style;
    var name;
    // Remember the old values, and insert the new ones
    for(name in options)if (options.hasOwnProperty(name)) {
        old[name] = style[name];
        style[name] = options[name];
    }
    callback.call(elem);
    // Revert the old values
    for(name in options)if (options.hasOwnProperty(name)) style[name] = old[name];
}
function getPBMWidth(elem, props, which) {
    var value = 0;
    var prop;
    var j;
    var i;
    for(j = 0; j < props.length; j++){
        prop = props[j];
        if (prop) for(i = 0; i < which.length; i++){
            var cssProp = void 0;
            if (prop === "border") cssProp = "".concat(prop).concat(which[i], "Width");
            else cssProp = prop + which[i];
            value += parseFloat(getComputedStyleX(elem, cssProp)) || 0;
        }
    }
    return value;
}
var domUtils = {
    getParent: function getParent(element) {
        var parent = element;
        do if (parent.nodeType === 11 && parent.host) parent = parent.host;
        else parent = parent.parentNode;
        while (parent && parent.nodeType !== 1 && parent.nodeType !== 9);
        return parent;
    }
};
each([
    "Width",
    "Height"
], function(name) {
    domUtils["doc".concat(name)] = function(refWin) {
        var d = refWin.document;
        return Math.max(// firefox chrome documentElement.scrollHeight< body.scrollHeight
        // ie standard mode : documentElement.scrollHeight> body.scrollHeight
        d.documentElement["scroll".concat(name)], // quirks : documentElement.scrollHeight 最大等于可视窗口多一点？
        d.body["scroll".concat(name)], domUtils["viewport".concat(name)](d));
    };
    domUtils["viewport".concat(name)] = function(win) {
        // pc browser includes scrollbar in window.innerWidth
        var prop = "client".concat(name);
        var doc = win.document;
        var body = doc.body;
        var documentElement = doc.documentElement;
        var documentElementProp = documentElement[prop];
        // 标准模式取 documentElement
        // backcompat 取 body
        return doc.compatMode === "CSS1Compat" && documentElementProp || body && body[prop] || documentElementProp;
    };
});
/*
 得到元素的大小信息
 @param elem
 @param name
 @param {String} [extra]  'padding' : (css width) + padding
 'border' : (css width) + padding + border
 'margin' : (css width) + padding + border + margin
 */ function getWH(elem, name, ex) {
    var extra = ex;
    if (isWindow(elem)) return name === "width" ? domUtils.viewportWidth(elem) : domUtils.viewportHeight(elem);
    else if (elem.nodeType === 9) return name === "width" ? domUtils.docWidth(elem) : domUtils.docHeight(elem);
    var which = name === "width" ? [
        "Left",
        "Right"
    ] : [
        "Top",
        "Bottom"
    ];
    var borderBoxValue = name === "width" ? Math.floor(elem.getBoundingClientRect().width) : Math.floor(elem.getBoundingClientRect().height);
    var isBorderBox = isBorderBoxFn(elem);
    var cssBoxValue = 0;
    if (borderBoxValue === null || borderBoxValue === undefined || borderBoxValue <= 0) {
        borderBoxValue = undefined;
        // Fall back to computed then un computed css if necessary
        cssBoxValue = getComputedStyleX(elem, name);
        if (cssBoxValue === null || cssBoxValue === undefined || Number(cssBoxValue) < 0) cssBoxValue = elem.style[name] || 0;
        // Normalize '', auto, and prepare for extra
        cssBoxValue = Math.floor(parseFloat(cssBoxValue)) || 0;
    }
    if (extra === undefined) extra = isBorderBox ? BORDER_INDEX : CONTENT_INDEX;
    var borderBoxValueOrIsBorderBox = borderBoxValue !== undefined || isBorderBox;
    var val = borderBoxValue || cssBoxValue;
    if (extra === CONTENT_INDEX) {
        if (borderBoxValueOrIsBorderBox) return val - getPBMWidth(elem, [
            "border",
            "padding"
        ], which);
        return cssBoxValue;
    } else if (borderBoxValueOrIsBorderBox) {
        if (extra === BORDER_INDEX) return val;
        return val + (extra === PADDING_INDEX ? -getPBMWidth(elem, [
            "border"
        ], which) : getPBMWidth(elem, [
            "margin"
        ], which));
    }
    return cssBoxValue + getPBMWidth(elem, BOX_MODELS.slice(extra), which);
}
var cssShow = {
    position: "absolute",
    visibility: "hidden",
    display: "block"
};
// fix #119 : https://github.com/kissyteam/kissy/issues/119
function getWHIgnoreDisplay() {
    for(var _len = arguments.length, args = new Array(_len), _key2 = 0; _key2 < _len; _key2++)args[_key2] = arguments[_key2];
    var val;
    var elem = args[0];
    // in case elem is window
    // elem.offsetWidth === undefined
    if (elem.offsetWidth !== 0) val = getWH.apply(undefined, args);
    else swap(elem, cssShow, function() {
        val = getWH.apply(undefined, args);
    });
    return val;
}
each([
    "width",
    "height"
], function(name) {
    var first = name.charAt(0).toUpperCase() + name.slice(1);
    domUtils["outer".concat(first)] = function(el, includeMargin) {
        return el && getWHIgnoreDisplay(el, name, includeMargin ? MARGIN_INDEX : BORDER_INDEX);
    };
    var which = name === "width" ? [
        "Left",
        "Right"
    ] : [
        "Top",
        "Bottom"
    ];
    domUtils[name] = function(elem, v) {
        var val = v;
        if (val !== undefined) {
            if (elem) {
                var isBorderBox = isBorderBoxFn(elem);
                if (isBorderBox) val += getPBMWidth(elem, [
                    "padding",
                    "border"
                ], which);
                return css(elem, name, val);
            }
            return undefined;
        }
        return elem && getWHIgnoreDisplay(elem, name, CONTENT_INDEX);
    };
});
function mix(to, from) {
    for(var i in from)if (from.hasOwnProperty(i)) to[i] = from[i];
    return to;
}
var utils = {
    getWindow: function getWindow(node) {
        if (node && node.document && node.setTimeout) return node;
        var doc = node.ownerDocument || node;
        return doc.defaultView || doc.parentWindow;
    },
    getDocument: getDocument,
    offset: function offset(el, value, option) {
        if (typeof value !== "undefined") setOffset(el, value, option || {});
        else return getOffset(el);
    },
    isWindow: isWindow,
    each: each,
    css: css,
    clone: function clone(obj) {
        var i;
        var ret = {};
        for(i in obj)if (obj.hasOwnProperty(i)) ret[i] = obj[i];
        var overflow = obj.overflow;
        if (overflow) {
            for(i in obj)if (obj.hasOwnProperty(i)) ret.overflow[i] = obj.overflow[i];
        }
        return ret;
    },
    mix: mix,
    getWindowScrollLeft: function getWindowScrollLeft(w) {
        return getScrollLeft(w);
    },
    getWindowScrollTop: function getWindowScrollTop(w) {
        return getScrollTop(w);
    },
    merge: function merge() {
        var ret = {};
        for(var i = 0; i < arguments.length; i++)utils.mix(ret, i < 0 || arguments.length <= i ? undefined : arguments[i]);
        return ret;
    },
    viewportWidth: 0,
    viewportHeight: 0
};
mix(utils, domUtils);
/**
 * 得到会导致元素显示不全的祖先元素
 */ var getParent = utils.getParent;
function getOffsetParent(element) {
    if (utils.isWindow(element) || element.nodeType === 9) return null;
    // ie 这个也不是完全可行
    /*
   <div style="width: 50px;height: 100px;overflow: hidden">
   <div style="width: 50px;height: 100px;position: relative;" id="d6">
   元素 6 高 100px 宽 50px<br/>
   </div>
   </div>
   */ // element.offsetParent does the right thing in ie7 and below. Return parent with layout!
    //  In other browsers it only includes elements with position absolute, relative or
    // fixed, not elements with overflow set to auto or scroll.
    //        if (UA.ie && ieMode < 8) {
    //            return element.offsetParent;
    //        }
    // 统一的 offsetParent 方法
    var doc = utils.getDocument(element);
    var body = doc.body;
    var parent;
    var positionStyle = utils.css(element, "position");
    var skipStatic = positionStyle === "fixed" || positionStyle === "absolute";
    if (!skipStatic) return element.nodeName.toLowerCase() === "html" ? null : getParent(element);
    for(parent = getParent(element); parent && parent !== body && parent.nodeType !== 9; parent = getParent(parent)){
        positionStyle = utils.css(parent, "position");
        if (positionStyle !== "static") return parent;
    }
    return null;
}
var getParent$1 = utils.getParent;
function isAncestorFixed(element) {
    if (utils.isWindow(element) || element.nodeType === 9) return false;
    var doc = utils.getDocument(element);
    var body = doc.body;
    var parent = null;
    for(parent = getParent$1(element); // 修复元素位于 document.documentElement 下导致崩溃问题
    parent && parent !== body && parent !== doc; parent = getParent$1(parent)){
        var positionStyle = utils.css(parent, "position");
        if (positionStyle === "fixed") return true;
    }
    return false;
}
/**
 * 获得元素的显示部分的区域
 */ function getVisibleRectForElement(element, alwaysByViewport) {
    var visibleRect = {
        left: 0,
        right: Infinity,
        top: 0,
        bottom: Infinity
    };
    var el = getOffsetParent(element);
    var doc = utils.getDocument(element);
    var win = doc.defaultView || doc.parentWindow;
    var body = doc.body;
    var documentElement = doc.documentElement;
    // Determine the size of the visible rect by climbing the dom accounting for
    // all scrollable containers.
    while(el){
        // clientWidth is zero for inline block elements in ie.
        if ((navigator.userAgent.indexOf("MSIE") === -1 || el.clientWidth !== 0) && // body may have overflow set on it, yet we still get the entire
        // viewport. In some browsers, el.offsetParent may be
        // document.documentElement, so check for that too.
        el !== body && el !== documentElement && utils.css(el, "overflow") !== "visible") {
            var pos = utils.offset(el);
            // add border
            pos.left += el.clientLeft;
            pos.top += el.clientTop;
            visibleRect.top = Math.max(visibleRect.top, pos.top);
            visibleRect.right = Math.min(visibleRect.right, // consider area without scrollBar
            pos.left + el.clientWidth);
            visibleRect.bottom = Math.min(visibleRect.bottom, pos.top + el.clientHeight);
            visibleRect.left = Math.max(visibleRect.left, pos.left);
        } else if (el === body || el === documentElement) break;
        el = getOffsetParent(el);
    }
    // Set element position to fixed
    // make sure absolute element itself don't affect it's visible area
    // https://github.com/ant-design/ant-design/issues/7601
    var originalPosition = null;
    if (!utils.isWindow(element) && element.nodeType !== 9) {
        originalPosition = element.style.position;
        var position = utils.css(element, "position");
        if (position === "absolute") element.style.position = "fixed";
    }
    var scrollX = utils.getWindowScrollLeft(win);
    var scrollY = utils.getWindowScrollTop(win);
    var viewportWidth = utils.viewportWidth(win);
    var viewportHeight = utils.viewportHeight(win);
    var documentWidth = documentElement.scrollWidth;
    var documentHeight = documentElement.scrollHeight;
    // scrollXXX on html is sync with body which means overflow: hidden on body gets wrong scrollXXX.
    // We should cut this ourself.
    var bodyStyle = window.getComputedStyle(body);
    if (bodyStyle.overflowX === "hidden") documentWidth = win.innerWidth;
    if (bodyStyle.overflowY === "hidden") documentHeight = win.innerHeight;
    // Reset element position after calculate the visible area
    if (element.style) element.style.position = originalPosition;
    if (alwaysByViewport || isAncestorFixed(element)) {
        // Clip by viewport's size.
        visibleRect.left = Math.max(visibleRect.left, scrollX);
        visibleRect.top = Math.max(visibleRect.top, scrollY);
        visibleRect.right = Math.min(visibleRect.right, scrollX + viewportWidth);
        visibleRect.bottom = Math.min(visibleRect.bottom, scrollY + viewportHeight);
    } else {
        // Clip by document's size.
        var maxVisibleWidth = Math.max(documentWidth, scrollX + viewportWidth);
        visibleRect.right = Math.min(visibleRect.right, maxVisibleWidth);
        var maxVisibleHeight = Math.max(documentHeight, scrollY + viewportHeight);
        visibleRect.bottom = Math.min(visibleRect.bottom, maxVisibleHeight);
    }
    return visibleRect.top >= 0 && visibleRect.left >= 0 && visibleRect.bottom > visibleRect.top && visibleRect.right > visibleRect.left ? visibleRect : null;
}
function adjustForViewport(elFuturePos, elRegion, visibleRect, overflow) {
    var pos = utils.clone(elFuturePos);
    var size = {
        width: elRegion.width,
        height: elRegion.height
    };
    if (overflow.adjustX && pos.left < visibleRect.left) pos.left = visibleRect.left;
    // Left edge inside and right edge outside viewport, try to resize it.
    if (overflow.resizeWidth && pos.left >= visibleRect.left && pos.left + size.width > visibleRect.right) size.width -= pos.left + size.width - visibleRect.right;
    // Right edge outside viewport, try to move it.
    if (overflow.adjustX && pos.left + size.width > visibleRect.right) // 保证左边界和可视区域左边界对齐
    pos.left = Math.max(visibleRect.right - size.width, visibleRect.left);
    // Top edge outside viewport, try to move it.
    if (overflow.adjustY && pos.top < visibleRect.top) pos.top = visibleRect.top;
    // Top edge inside and bottom edge outside viewport, try to resize it.
    if (overflow.resizeHeight && pos.top >= visibleRect.top && pos.top + size.height > visibleRect.bottom) size.height -= pos.top + size.height - visibleRect.bottom;
    // Bottom edge outside viewport, try to move it.
    if (overflow.adjustY && pos.top + size.height > visibleRect.bottom) // 保证上边界和可视区域上边界对齐
    pos.top = Math.max(visibleRect.bottom - size.height, visibleRect.top);
    return utils.mix(pos, size);
}
function getRegion(node) {
    var offset;
    var w;
    var h;
    if (!utils.isWindow(node) && node.nodeType !== 9) {
        offset = utils.offset(node);
        w = utils.outerWidth(node);
        h = utils.outerHeight(node);
    } else {
        var win = utils.getWindow(node);
        offset = {
            left: utils.getWindowScrollLeft(win),
            top: utils.getWindowScrollTop(win)
        };
        w = utils.viewportWidth(win);
        h = utils.viewportHeight(win);
    }
    offset.width = w;
    offset.height = h;
    return offset;
}
/**
 * 获取 node 上的 align 对齐点 相对于页面的坐标
 */ function getAlignOffset(region, align) {
    var V = align.charAt(0);
    var H = align.charAt(1);
    var w = region.width;
    var h = region.height;
    var x = region.left;
    var y = region.top;
    if (V === "c") y += h / 2;
    else if (V === "b") y += h;
    if (H === "c") x += w / 2;
    else if (H === "r") x += w;
    return {
        left: x,
        top: y
    };
}
function getElFuturePos(elRegion, refNodeRegion, points, offset, targetOffset) {
    var p1 = getAlignOffset(refNodeRegion, points[1]);
    var p2 = getAlignOffset(elRegion, points[0]);
    var diff = [
        p2.left - p1.left,
        p2.top - p1.top
    ];
    return {
        left: Math.round(elRegion.left - diff[0] + offset[0] - targetOffset[0]),
        top: Math.round(elRegion.top - diff[1] + offset[1] - targetOffset[1])
    };
}
/**
 * align dom node flexibly
 * @author yiminghe@gmail.com
 */ // http://yiminghe.iteye.com/blog/1124720
function isFailX(elFuturePos, elRegion, visibleRect) {
    return elFuturePos.left < visibleRect.left || elFuturePos.left + elRegion.width > visibleRect.right;
}
function isFailY(elFuturePos, elRegion, visibleRect) {
    return elFuturePos.top < visibleRect.top || elFuturePos.top + elRegion.height > visibleRect.bottom;
}
function isCompleteFailX(elFuturePos, elRegion, visibleRect) {
    return elFuturePos.left > visibleRect.right || elFuturePos.left + elRegion.width < visibleRect.left;
}
function isCompleteFailY(elFuturePos, elRegion, visibleRect) {
    return elFuturePos.top > visibleRect.bottom || elFuturePos.top + elRegion.height < visibleRect.top;
}
function flip(points, reg, map) {
    var ret = [];
    utils.each(points, function(p) {
        ret.push(p.replace(reg, function(m) {
            return map[m];
        }));
    });
    return ret;
}
function flipOffset(offset, index) {
    offset[index] = -offset[index];
    return offset;
}
function convertOffset(str, offsetLen) {
    var n;
    if (/%$/.test(str)) n = parseInt(str.substring(0, str.length - 1), 10) / 100 * offsetLen;
    else n = parseInt(str, 10);
    return n || 0;
}
function normalizeOffset(offset, el) {
    offset[0] = convertOffset(offset[0], el.width);
    offset[1] = convertOffset(offset[1], el.height);
}
/**
 * @param el
 * @param tgtRegion 参照节点所占的区域: { left, top, width, height }
 * @param align
 */ function doAlign(el, tgtRegion, align, isTgtRegionVisible) {
    var points = align.points;
    var offset = align.offset || [
        0,
        0
    ];
    var targetOffset = align.targetOffset || [
        0,
        0
    ];
    var overflow = align.overflow;
    var source = align.source || el;
    offset = [].concat(offset);
    targetOffset = [].concat(targetOffset);
    overflow = overflow || {};
    var newOverflowCfg = {};
    var fail = 0;
    var alwaysByViewport = !!(overflow && overflow.alwaysByViewport);
    // 当前节点可以被放置的显示区域
    var visibleRect = getVisibleRectForElement(source, alwaysByViewport);
    // 当前节点所占的区域, left/top/width/height
    var elRegion = getRegion(source);
    // 将 offset 转换成数值，支持百分比
    normalizeOffset(offset, elRegion);
    normalizeOffset(targetOffset, tgtRegion);
    // 当前节点将要被放置的位置
    var elFuturePos = getElFuturePos(elRegion, tgtRegion, points, offset, targetOffset);
    // 当前节点将要所处的区域
    var newElRegion = utils.merge(elRegion, elFuturePos);
    // 如果可视区域不能完全放置当前节点时允许调整
    if (visibleRect && (overflow.adjustX || overflow.adjustY) && isTgtRegionVisible) {
        if (overflow.adjustX) // 如果横向不能放下
        {
            if (isFailX(elFuturePos, elRegion, visibleRect)) {
                // 对齐位置反下
                var newPoints = flip(points, /[lr]/gi, {
                    l: "r",
                    r: "l"
                });
                // 偏移量也反下
                var newOffset = flipOffset(offset, 0);
                var newTargetOffset = flipOffset(targetOffset, 0);
                var newElFuturePos = getElFuturePos(elRegion, tgtRegion, newPoints, newOffset, newTargetOffset);
                if (!isCompleteFailX(newElFuturePos, elRegion, visibleRect)) {
                    fail = 1;
                    points = newPoints;
                    offset = newOffset;
                    targetOffset = newTargetOffset;
                }
            }
        }
        if (overflow.adjustY) // 如果纵向不能放下
        {
            if (isFailY(elFuturePos, elRegion, visibleRect)) {
                // 对齐位置反下
                var _newPoints = flip(points, /[tb]/gi, {
                    t: "b",
                    b: "t"
                });
                // 偏移量也反下
                var _newOffset = flipOffset(offset, 1);
                var _newTargetOffset = flipOffset(targetOffset, 1);
                var _newElFuturePos = getElFuturePos(elRegion, tgtRegion, _newPoints, _newOffset, _newTargetOffset);
                if (!isCompleteFailY(_newElFuturePos, elRegion, visibleRect)) {
                    fail = 1;
                    points = _newPoints;
                    offset = _newOffset;
                    targetOffset = _newTargetOffset;
                }
            }
        }
        // 如果失败，重新计算当前节点将要被放置的位置
        if (fail) {
            elFuturePos = getElFuturePos(elRegion, tgtRegion, points, offset, targetOffset);
            utils.mix(newElRegion, elFuturePos);
        }
        var isStillFailX = isFailX(elFuturePos, elRegion, visibleRect);
        var isStillFailY = isFailY(elFuturePos, elRegion, visibleRect);
        // 检查反下后的位置是否可以放下了，如果仍然放不下：
        // 1. 复原修改过的定位参数
        if (isStillFailX || isStillFailY) {
            var _newPoints2 = points;
            // 重置对应部分的翻转逻辑
            if (isStillFailX) _newPoints2 = flip(points, /[lr]/gi, {
                l: "r",
                r: "l"
            });
            if (isStillFailY) _newPoints2 = flip(points, /[tb]/gi, {
                t: "b",
                b: "t"
            });
            points = _newPoints2;
            offset = align.offset || [
                0,
                0
            ];
            targetOffset = align.targetOffset || [
                0,
                0
            ];
        }
        // 2. 只有指定了可以调整当前方向才调整
        newOverflowCfg.adjustX = overflow.adjustX && isStillFailX;
        newOverflowCfg.adjustY = overflow.adjustY && isStillFailY;
        // 确实要调整，甚至可能会调整高度宽度
        if (newOverflowCfg.adjustX || newOverflowCfg.adjustY) newElRegion = adjustForViewport(elFuturePos, elRegion, visibleRect, newOverflowCfg);
    }
    // need judge to in case set fixed with in css on height auto element
    if (newElRegion.width !== elRegion.width) utils.css(source, "width", utils.width(source) + newElRegion.width - elRegion.width);
    if (newElRegion.height !== elRegion.height) utils.css(source, "height", utils.height(source) + newElRegion.height - elRegion.height);
    // https://github.com/kissyteam/kissy/issues/190
    // 相对于屏幕位置没变，而 left/top 变了
    // 例如 <div 'relative'><el absolute></div>
    utils.offset(source, {
        left: newElRegion.left,
        top: newElRegion.top
    }, {
        useCssRight: align.useCssRight,
        useCssBottom: align.useCssBottom,
        useCssTransform: align.useCssTransform,
        ignoreShake: align.ignoreShake
    });
    return {
        points: points,
        offset: offset,
        targetOffset: targetOffset,
        overflow: newOverflowCfg
    };
}
/**
 *  2012-04-26 yiminghe@gmail.com
 *   - 优化智能对齐算法
 *   - 慎用 resizeXX
 *
 *  2011-07-13 yiminghe@gmail.com note:
 *   - 增加智能对齐，以及大小调整选项
 **/ function isOutOfVisibleRect(target, alwaysByViewport) {
    var visibleRect = getVisibleRectForElement(target, alwaysByViewport);
    var targetRegion = getRegion(target);
    return !visibleRect || targetRegion.left + targetRegion.width <= visibleRect.left || targetRegion.top + targetRegion.height <= visibleRect.top || targetRegion.left >= visibleRect.right || targetRegion.top >= visibleRect.bottom;
}
function alignElement(el, refNode, align) {
    var target = align.target || refNode;
    var refNodeRegion = getRegion(target);
    var isTargetNotOutOfVisible = !isOutOfVisibleRect(target, align.overflow && align.overflow.alwaysByViewport);
    return doAlign(el, refNodeRegion, align, isTargetNotOutOfVisible);
}
alignElement.__getOffsetParent = getOffsetParent;
alignElement.__getVisibleRectForElement = getVisibleRectForElement;
/**
 * `tgtPoint`: { pageX, pageY } or { clientX, clientY }.
 * If client position provided, will internal convert to page position.
 */ function alignPoint(el, tgtPoint, align) {
    var pageX;
    var pageY;
    var doc = utils.getDocument(el);
    var win = doc.defaultView || doc.parentWindow;
    var scrollX = utils.getWindowScrollLeft(win);
    var scrollY = utils.getWindowScrollTop(win);
    var viewportWidth = utils.viewportWidth(win);
    var viewportHeight = utils.viewportHeight(win);
    if ("pageX" in tgtPoint) pageX = tgtPoint.pageX;
    else pageX = scrollX + tgtPoint.clientX;
    if ("pageY" in tgtPoint) pageY = tgtPoint.pageY;
    else pageY = scrollY + tgtPoint.clientY;
    var tgtRegion = {
        left: pageX,
        top: pageY,
        width: 0,
        height: 0
    };
    var pointInView = pageX >= 0 && pageX <= scrollX + viewportWidth && pageY >= 0 && pageY <= scrollY + viewportHeight;
    // Provide default target point
    var points = [
        align.points[0],
        "cc"
    ];
    return doAlign(el, tgtRegion, _objectSpread2(_objectSpread2({}, align), {}, {
        points: points
    }), pointInView);
}
exports.default = alignElement;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"ltQDq":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "buffer", ()=>buffer);
parcelHelpers.export(exports, "isSamePoint", ()=>isSamePoint);
parcelHelpers.export(exports, "isWindow", ()=>isWindow);
parcelHelpers.export(exports, "isSimilarValue", ()=>isSimilarValue);
parcelHelpers.export(exports, "restoreFocus", ()=>restoreFocus);
var _contains = require("rc-util/es/Dom/contains");
var _containsDefault = parcelHelpers.interopDefault(_contains);
function buffer(fn, ms) {
    var timer = void 0;
    function clear() {
        if (timer) {
            clearTimeout(timer);
            timer = null;
        }
    }
    function bufferFn() {
        clear();
        timer = setTimeout(fn, ms);
    }
    bufferFn.clear = clear;
    return bufferFn;
}
function isSamePoint(prev, next) {
    if (prev === next) return true;
    if (!prev || !next) return false;
    if ("pageX" in next && "pageY" in next) return prev.pageX === next.pageX && prev.pageY === next.pageY;
    if ("clientX" in next && "clientY" in next) return prev.clientX === next.clientX && prev.clientY === next.clientY;
    return false;
}
function isWindow(obj) {
    return obj && typeof obj === "object" && obj.window === obj;
}
function isSimilarValue(val1, val2) {
    var int1 = Math.floor(val1);
    var int2 = Math.floor(val2);
    return Math.abs(int1 - int2) <= 1;
}
function restoreFocus(activeElement, container) {
    // Focus back if is in the container
    if (activeElement !== document.activeElement && (0, _containsDefault.default)(container, activeElement)) activeElement.focus();
}

},{"rc-util/es/Dom/contains":"4uE9K","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7NqFA":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _extends = require("babel-runtime/helpers/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _defineProperty = require("babel-runtime/helpers/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _classCallCheck = require("babel-runtime/helpers/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("babel-runtime/helpers/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _possibleConstructorReturn = require("babel-runtime/helpers/possibleConstructorReturn");
var _possibleConstructorReturnDefault = parcelHelpers.interopDefault(_possibleConstructorReturn);
var _inherits = require("babel-runtime/helpers/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _unsafeLifecyclesPolyfill = require("rc-util/es/unsafeLifecyclesPolyfill");
var _unsafeLifecyclesPolyfillDefault = parcelHelpers.interopDefault(_unsafeLifecyclesPolyfill);
var _childrenUtils = require("./ChildrenUtils");
var _animateChild = require("./AnimateChild");
var _animateChildDefault = parcelHelpers.interopDefault(_animateChild);
var _animate = require("./util/animate");
var _animateDefault = parcelHelpers.interopDefault(_animate);
var defaultKey = "rc_animate_" + Date.now();
function getChildrenFromProps(props) {
    var children = props.children;
    if ((0, _reactDefault.default).isValidElement(children)) {
        if (!children.key) return (0, _reactDefault.default).cloneElement(children, {
            key: defaultKey
        });
    }
    return children;
}
function noop() {}
var Animate = function(_React$Component) {
    (0, _inheritsDefault.default)(Animate, _React$Component);
    // eslint-disable-line
    function Animate(props) {
        (0, _classCallCheckDefault.default)(this, Animate);
        var _this = (0, _possibleConstructorReturnDefault.default)(this, (Animate.__proto__ || Object.getPrototypeOf(Animate)).call(this, props));
        _initialiseProps.call(_this);
        _this.currentlyAnimatingKeys = {};
        _this.keysToEnter = [];
        _this.keysToLeave = [];
        _this.state = {
            children: (0, _childrenUtils.toArrayChildren)(getChildrenFromProps(props))
        };
        _this.childrenRefs = {};
        return _this;
    }
    (0, _createClassDefault.default)(Animate, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                var _this2 = this;
                var showProp = this.props.showProp;
                var children = this.state.children;
                if (showProp) children = children.filter(function(child) {
                    return !!child.props[showProp];
                });
                children.forEach(function(child) {
                    if (child) _this2.performAppear(child.key);
                });
            }
        },
        {
            key: "componentWillReceiveProps",
            value: function componentWillReceiveProps(nextProps) {
                var _this3 = this;
                this.nextProps = nextProps;
                var nextChildren = (0, _childrenUtils.toArrayChildren)(getChildrenFromProps(nextProps));
                var props = this.props;
                // exclusive needs immediate response
                if (props.exclusive) Object.keys(this.currentlyAnimatingKeys).forEach(function(key) {
                    _this3.stop(key);
                });
                var showProp = props.showProp;
                var currentlyAnimatingKeys = this.currentlyAnimatingKeys;
                // last props children if exclusive
                var currentChildren = props.exclusive ? (0, _childrenUtils.toArrayChildren)(getChildrenFromProps(props)) : this.state.children;
                // in case destroy in showProp mode
                var newChildren = [];
                if (showProp) {
                    currentChildren.forEach(function(currentChild) {
                        var nextChild = currentChild && (0, _childrenUtils.findChildInChildrenByKey)(nextChildren, currentChild.key);
                        var newChild = void 0;
                        if ((!nextChild || !nextChild.props[showProp]) && currentChild.props[showProp]) newChild = (0, _reactDefault.default).cloneElement(nextChild || currentChild, (0, _definePropertyDefault.default)({}, showProp, true));
                        else newChild = nextChild;
                        if (newChild) newChildren.push(newChild);
                    });
                    nextChildren.forEach(function(nextChild) {
                        if (!nextChild || !(0, _childrenUtils.findChildInChildrenByKey)(currentChildren, nextChild.key)) newChildren.push(nextChild);
                    });
                } else newChildren = (0, _childrenUtils.mergeChildren)(currentChildren, nextChildren);
                // need render to avoid update
                this.setState({
                    children: newChildren
                });
                nextChildren.forEach(function(child) {
                    var key = child && child.key;
                    if (child && currentlyAnimatingKeys[key]) return;
                    var hasPrev = child && (0, _childrenUtils.findChildInChildrenByKey)(currentChildren, key);
                    if (showProp) {
                        var showInNext = child.props[showProp];
                        if (hasPrev) {
                            var showInNow = (0, _childrenUtils.findShownChildInChildrenByKey)(currentChildren, key, showProp);
                            if (!showInNow && showInNext) _this3.keysToEnter.push(key);
                        } else if (showInNext) _this3.keysToEnter.push(key);
                    } else if (!hasPrev) _this3.keysToEnter.push(key);
                });
                currentChildren.forEach(function(child) {
                    var key = child && child.key;
                    if (child && currentlyAnimatingKeys[key]) return;
                    var hasNext = child && (0, _childrenUtils.findChildInChildrenByKey)(nextChildren, key);
                    if (showProp) {
                        var showInNow = child.props[showProp];
                        if (hasNext) {
                            var showInNext = (0, _childrenUtils.findShownChildInChildrenByKey)(nextChildren, key, showProp);
                            if (!showInNext && showInNow) _this3.keysToLeave.push(key);
                        } else if (showInNow) _this3.keysToLeave.push(key);
                    } else if (!hasNext) _this3.keysToLeave.push(key);
                });
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate() {
                var keysToEnter = this.keysToEnter;
                this.keysToEnter = [];
                keysToEnter.forEach(this.performEnter);
                var keysToLeave = this.keysToLeave;
                this.keysToLeave = [];
                keysToLeave.forEach(this.performLeave);
            }
        },
        {
            key: "isValidChildByKey",
            value: function isValidChildByKey(currentChildren, key) {
                var showProp = this.props.showProp;
                if (showProp) return (0, _childrenUtils.findShownChildInChildrenByKey)(currentChildren, key, showProp);
                return (0, _childrenUtils.findChildInChildrenByKey)(currentChildren, key);
            }
        },
        {
            key: "stop",
            value: function stop(key) {
                delete this.currentlyAnimatingKeys[key];
                var component = this.childrenRefs[key];
                if (component) component.stop();
            }
        },
        {
            key: "render",
            value: function render() {
                var _this4 = this;
                var props = this.props;
                this.nextProps = props;
                var stateChildren = this.state.children;
                var children = null;
                if (stateChildren) children = stateChildren.map(function(child) {
                    if (child === null || child === undefined) return child;
                    if (!child.key) throw new Error("must set key for <rc-animate> children");
                    return (0, _reactDefault.default).createElement((0, _animateChildDefault.default), {
                        key: child.key,
                        ref: function ref(node) {
                            _this4.childrenRefs[child.key] = node;
                        },
                        animation: props.animation,
                        transitionName: props.transitionName,
                        transitionEnter: props.transitionEnter,
                        transitionAppear: props.transitionAppear,
                        transitionLeave: props.transitionLeave
                    }, child);
                });
                var Component = props.component;
                if (Component) {
                    var passedProps = props;
                    if (typeof Component === "string") passedProps = (0, _extendsDefault.default)({
                        className: props.className,
                        style: props.style
                    }, props.componentProps);
                    return (0, _reactDefault.default).createElement(Component, passedProps, children);
                }
                return children[0] || null;
            }
        }
    ]);
    return Animate;
}((0, _reactDefault.default).Component);
Animate.isAnimate = true;
Animate.propTypes = {
    className: (0, _propTypesDefault.default).string,
    style: (0, _propTypesDefault.default).object,
    component: (0, _propTypesDefault.default).any,
    componentProps: (0, _propTypesDefault.default).object,
    animation: (0, _propTypesDefault.default).object,
    transitionName: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).string,
        (0, _propTypesDefault.default).object
    ]),
    transitionEnter: (0, _propTypesDefault.default).bool,
    transitionAppear: (0, _propTypesDefault.default).bool,
    exclusive: (0, _propTypesDefault.default).bool,
    transitionLeave: (0, _propTypesDefault.default).bool,
    onEnd: (0, _propTypesDefault.default).func,
    onEnter: (0, _propTypesDefault.default).func,
    onLeave: (0, _propTypesDefault.default).func,
    onAppear: (0, _propTypesDefault.default).func,
    showProp: (0, _propTypesDefault.default).string,
    children: (0, _propTypesDefault.default).node
};
Animate.defaultProps = {
    animation: {},
    component: "span",
    componentProps: {},
    transitionEnter: true,
    transitionLeave: true,
    transitionAppear: false,
    onEnd: noop,
    onEnter: noop,
    onLeave: noop,
    onAppear: noop
};
var _initialiseProps = function _initialiseProps() {
    var _this5 = this;
    this.performEnter = function(key) {
        // may already remove by exclusive
        if (_this5.childrenRefs[key]) {
            _this5.currentlyAnimatingKeys[key] = true;
            _this5.childrenRefs[key].componentWillEnter(_this5.handleDoneAdding.bind(_this5, key, "enter"));
        }
    };
    this.performAppear = function(key) {
        if (_this5.childrenRefs[key]) {
            _this5.currentlyAnimatingKeys[key] = true;
            _this5.childrenRefs[key].componentWillAppear(_this5.handleDoneAdding.bind(_this5, key, "appear"));
        }
    };
    this.handleDoneAdding = function(key, type) {
        var props = _this5.props;
        delete _this5.currentlyAnimatingKeys[key];
        // if update on exclusive mode, skip check
        if (props.exclusive && props !== _this5.nextProps) return;
        var currentChildren = (0, _childrenUtils.toArrayChildren)(getChildrenFromProps(props));
        if (!_this5.isValidChildByKey(currentChildren, key)) // exclusive will not need this
        _this5.performLeave(key);
        else if (type === "appear") {
            if ((0, _animateDefault.default).allowAppearCallback(props)) {
                props.onAppear(key);
                props.onEnd(key, true);
            }
        } else if ((0, _animateDefault.default).allowEnterCallback(props)) {
            props.onEnter(key);
            props.onEnd(key, true);
        }
    };
    this.performLeave = function(key) {
        // may already remove by exclusive
        if (_this5.childrenRefs[key]) {
            _this5.currentlyAnimatingKeys[key] = true;
            _this5.childrenRefs[key].componentWillLeave(_this5.handleDoneLeaving.bind(_this5, key));
        }
    };
    this.handleDoneLeaving = function(key) {
        var props = _this5.props;
        delete _this5.currentlyAnimatingKeys[key];
        // if update on exclusive mode, skip check
        if (props.exclusive && props !== _this5.nextProps) return;
        var currentChildren = (0, _childrenUtils.toArrayChildren)(getChildrenFromProps(props));
        // in case state change is too fast
        if (_this5.isValidChildByKey(currentChildren, key)) _this5.performEnter(key);
        else {
            var end = function end() {
                if ((0, _animateDefault.default).allowLeaveCallback(props)) {
                    props.onLeave(key);
                    props.onEnd(key, false);
                }
            };
            if (!(0, _childrenUtils.isSameChildren)(_this5.state.children, currentChildren, props.showProp)) _this5.setState({
                children: currentChildren
            }, end);
            else end();
        }
    };
};
exports.default = (0, _unsafeLifecyclesPolyfillDefault.default)(Animate);

},{"babel-runtime/helpers/extends":"4sKqp","babel-runtime/helpers/defineProperty":"9vPv9","babel-runtime/helpers/classCallCheck":"aRpYz","babel-runtime/helpers/createClass":"a0jaP","babel-runtime/helpers/possibleConstructorReturn":"40Qb5","babel-runtime/helpers/inherits":"bitir","react":"6uln9","prop-types":"6FKs7","rc-util/es/unsafeLifecyclesPolyfill":"7YCom","./ChildrenUtils":"8WYnR","./AnimateChild":"l5ZgP","./util/animate":"ePmvV","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9vPv9":[function(require,module,exports) {
"use strict";
exports.__esModule = true;
var _defineProperty = require("f3f48dfa0faaaee6");
var _defineProperty2 = _interopRequireDefault(_defineProperty);
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
exports.default = function(obj, key, value) {
    if (key in obj) (0, _defineProperty2.default)(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
};

},{"f3f48dfa0faaaee6":"7ehbB"}],"7YCom":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var unsafeLifecyclesPolyfill = function unsafeLifecyclesPolyfill(Component) {
    var prototype = Component.prototype;
    if (!prototype || !prototype.isReactComponent) throw new Error("Can only polyfill class components");
     // only handle componentWillReceiveProps
    if (typeof prototype.componentWillReceiveProps !== "function") return Component;
     // In React 16.9, React.Profiler was introduced together with UNSAFE_componentWillReceiveProps
    // https://reactjs.org/blog/2019/08/08/react-v16.9.0.html#performance-measurements-with-reactprofiler
    if (!(0, _reactDefault.default).Profiler) return Component;
     // Here polyfill get started
    prototype.UNSAFE_componentWillReceiveProps = prototype.componentWillReceiveProps;
    delete prototype.componentWillReceiveProps;
    return Component;
};
exports.default = unsafeLifecyclesPolyfill;

},{"react":"6uln9","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8WYnR":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "toArrayChildren", ()=>toArrayChildren);
parcelHelpers.export(exports, "findChildInChildrenByKey", ()=>findChildInChildrenByKey);
parcelHelpers.export(exports, "findShownChildInChildrenByKey", ()=>findShownChildInChildrenByKey);
parcelHelpers.export(exports, "findHiddenChildInChildrenByKey", ()=>findHiddenChildInChildrenByKey);
parcelHelpers.export(exports, "isSameChildren", ()=>isSameChildren);
parcelHelpers.export(exports, "mergeChildren", ()=>mergeChildren);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
function toArrayChildren(children) {
    var ret = [];
    (0, _reactDefault.default).Children.forEach(children, function(child) {
        ret.push(child);
    });
    return ret;
}
function findChildInChildrenByKey(children, key) {
    var ret = null;
    if (children) children.forEach(function(child) {
        if (ret) return;
        if (child && child.key === key) ret = child;
    });
    return ret;
}
function findShownChildInChildrenByKey(children, key, showProp) {
    var ret = null;
    if (children) children.forEach(function(child) {
        if (child && child.key === key && child.props[showProp]) {
            if (ret) throw new Error("two child with same key for <rc-animate> children");
            ret = child;
        }
    });
    return ret;
}
function findHiddenChildInChildrenByKey(children, key, showProp) {
    var found = 0;
    if (children) children.forEach(function(child) {
        if (found) return;
        found = child && child.key === key && !child.props[showProp];
    });
    return found;
}
function isSameChildren(c1, c2, showProp) {
    var same = c1.length === c2.length;
    if (same) c1.forEach(function(child, index) {
        var child2 = c2[index];
        if (child && child2) {
            if (child && !child2 || !child && child2) same = false;
            else if (child.key !== child2.key) same = false;
            else if (showProp && child.props[showProp] !== child2.props[showProp]) same = false;
        }
    });
    return same;
}
function mergeChildren(prev, next) {
    var ret = [];
    // For each key of `next`, the list of keys to insert before that key in
    // the combined list
    var nextChildrenPending = {};
    var pendingChildren = [];
    prev.forEach(function(child) {
        if (child && findChildInChildrenByKey(next, child.key)) {
            if (pendingChildren.length) {
                nextChildrenPending[child.key] = pendingChildren;
                pendingChildren = [];
            }
        } else pendingChildren.push(child);
    });
    next.forEach(function(child) {
        if (child && Object.prototype.hasOwnProperty.call(nextChildrenPending, child.key)) ret = ret.concat(nextChildrenPending[child.key]);
        ret.push(child);
    });
    ret = ret.concat(pendingChildren);
    return ret;
}

},{"react":"6uln9","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"l5ZgP":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _classCallCheck = require("babel-runtime/helpers/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("babel-runtime/helpers/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _possibleConstructorReturn = require("babel-runtime/helpers/possibleConstructorReturn");
var _possibleConstructorReturnDefault = parcelHelpers.interopDefault(_possibleConstructorReturn);
var _inherits = require("babel-runtime/helpers/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactDom = require("react-dom");
var _reactDomDefault = parcelHelpers.interopDefault(_reactDom);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _cssAnimation = require("css-animation");
var _cssAnimationDefault = parcelHelpers.interopDefault(_cssAnimation);
var _animate = require("./util/animate");
var _animateDefault = parcelHelpers.interopDefault(_animate);
var transitionMap = {
    enter: "transitionEnter",
    appear: "transitionAppear",
    leave: "transitionLeave"
};
var AnimateChild = function(_React$Component) {
    (0, _inheritsDefault.default)(AnimateChild, _React$Component);
    function AnimateChild() {
        (0, _classCallCheckDefault.default)(this, AnimateChild);
        return (0, _possibleConstructorReturnDefault.default)(this, (AnimateChild.__proto__ || Object.getPrototypeOf(AnimateChild)).apply(this, arguments));
    }
    (0, _createClassDefault.default)(AnimateChild, [
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this.stop();
            }
        },
        {
            key: "componentWillEnter",
            value: function componentWillEnter(done) {
                if ((0, _animateDefault.default).isEnterSupported(this.props)) this.transition("enter", done);
                else done();
            }
        },
        {
            key: "componentWillAppear",
            value: function componentWillAppear(done) {
                if ((0, _animateDefault.default).isAppearSupported(this.props)) this.transition("appear", done);
                else done();
            }
        },
        {
            key: "componentWillLeave",
            value: function componentWillLeave(done) {
                if ((0, _animateDefault.default).isLeaveSupported(this.props)) this.transition("leave", done);
                else // always sync, do not interupt with react component life cycle
                // update hidden -> animate hidden ->
                // didUpdate -> animate leave -> unmount (if animate is none)
                done();
            }
        },
        {
            key: "transition",
            value: function transition(animationType, finishCallback) {
                var _this2 = this;
                var node = (0, _reactDomDefault.default).findDOMNode(this);
                var props = this.props;
                var transitionName = props.transitionName;
                var nameIsObj = typeof transitionName === "object";
                this.stop();
                var end = function end() {
                    _this2.stopper = null;
                    finishCallback();
                };
                if (((0, _cssAnimation.isCssAnimationSupported) || !props.animation[animationType]) && transitionName && props[transitionMap[animationType]]) {
                    var name = nameIsObj ? transitionName[animationType] : transitionName + "-" + animationType;
                    var activeName = name + "-active";
                    if (nameIsObj && transitionName[animationType + "Active"]) activeName = transitionName[animationType + "Active"];
                    this.stopper = (0, _cssAnimationDefault.default)(node, {
                        name: name,
                        active: activeName
                    }, end);
                } else this.stopper = props.animation[animationType](node, end);
            }
        },
        {
            key: "stop",
            value: function stop() {
                var stopper = this.stopper;
                if (stopper) {
                    this.stopper = null;
                    stopper.stop();
                }
            }
        },
        {
            key: "render",
            value: function render() {
                return this.props.children;
            }
        }
    ]);
    return AnimateChild;
}((0, _reactDefault.default).Component);
AnimateChild.propTypes = {
    children: (0, _propTypesDefault.default).any,
    animation: (0, _propTypesDefault.default).any,
    transitionName: (0, _propTypesDefault.default).any
};
exports.default = AnimateChild;

},{"babel-runtime/helpers/classCallCheck":"aRpYz","babel-runtime/helpers/createClass":"a0jaP","babel-runtime/helpers/possibleConstructorReturn":"40Qb5","babel-runtime/helpers/inherits":"bitir","react":"6uln9","react-dom":"b8T3j","prop-types":"6FKs7","css-animation":"fM9T5","./util/animate":"ePmvV","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"fM9T5":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isCssAnimationSupported", ()=>isCssAnimationSupported);
var _typeof = require("babel-runtime/helpers/typeof");
var _typeofDefault = parcelHelpers.interopDefault(_typeof);
var _event = require("./Event");
var _eventDefault = parcelHelpers.interopDefault(_event);
var _componentClasses = require("component-classes");
var _componentClassesDefault = parcelHelpers.interopDefault(_componentClasses);
var isCssAnimationSupported = (0, _eventDefault.default).endEvents.length !== 0;
var capitalPrefixes = [
    "Webkit",
    "Moz",
    "O",
    // ms is special .... !
    "ms"
];
var prefixes = [
    "-webkit-",
    "-moz-",
    "-o-",
    "ms-",
    ""
];
function getStyleProperty(node, name) {
    // old ff need null, https://developer.mozilla.org/en-US/docs/Web/API/Window/getComputedStyle
    var style = window.getComputedStyle(node, null);
    var ret = "";
    for(var i = 0; i < prefixes.length; i++){
        ret = style.getPropertyValue(prefixes[i] + name);
        if (ret) break;
    }
    return ret;
}
function fixBrowserByTimeout(node) {
    if (isCssAnimationSupported) {
        var transitionDelay = parseFloat(getStyleProperty(node, "transition-delay")) || 0;
        var transitionDuration = parseFloat(getStyleProperty(node, "transition-duration")) || 0;
        var animationDelay = parseFloat(getStyleProperty(node, "animation-delay")) || 0;
        var animationDuration = parseFloat(getStyleProperty(node, "animation-duration")) || 0;
        var time = Math.max(transitionDuration + transitionDelay, animationDuration + animationDelay);
        // sometimes, browser bug
        node.rcEndAnimTimeout = setTimeout(function() {
            node.rcEndAnimTimeout = null;
            if (node.rcEndListener) node.rcEndListener();
        }, time * 1000 + 200);
    }
}
function clearBrowserBugTimeout(node) {
    if (node.rcEndAnimTimeout) {
        clearTimeout(node.rcEndAnimTimeout);
        node.rcEndAnimTimeout = null;
    }
}
var cssAnimation = function cssAnimation(node, transitionName, endCallback) {
    var nameIsObj = (typeof transitionName === "undefined" ? "undefined" : (0, _typeofDefault.default)(transitionName)) === "object";
    var className = nameIsObj ? transitionName.name : transitionName;
    var activeClassName = nameIsObj ? transitionName.active : transitionName + "-active";
    var end = endCallback;
    var start = void 0;
    var active = void 0;
    var nodeClasses = (0, _componentClassesDefault.default)(node);
    if (endCallback && Object.prototype.toString.call(endCallback) === "[object Object]") {
        end = endCallback.end;
        start = endCallback.start;
        active = endCallback.active;
    }
    if (node.rcEndListener) node.rcEndListener();
    node.rcEndListener = function(e) {
        if (e && e.target !== node) return;
        if (node.rcAnimTimeout) {
            clearTimeout(node.rcAnimTimeout);
            node.rcAnimTimeout = null;
        }
        clearBrowserBugTimeout(node);
        nodeClasses.remove(className);
        nodeClasses.remove(activeClassName);
        (0, _eventDefault.default).removeEndEventListener(node, node.rcEndListener);
        node.rcEndListener = null;
        // Usually this optional end is used for informing an owner of
        // a leave animation and telling it to remove the child.
        if (end) end();
    };
    (0, _eventDefault.default).addEndEventListener(node, node.rcEndListener);
    if (start) start();
    nodeClasses.add(className);
    node.rcAnimTimeout = setTimeout(function() {
        node.rcAnimTimeout = null;
        nodeClasses.add(activeClassName);
        if (active) setTimeout(active, 0);
        fixBrowserByTimeout(node);
    // 30ms for firefox
    }, 30);
    return {
        stop: function stop() {
            if (node.rcEndListener) node.rcEndListener();
        }
    };
};
cssAnimation.style = function(node, style, callback) {
    if (node.rcEndListener) node.rcEndListener();
    node.rcEndListener = function(e) {
        if (e && e.target !== node) return;
        if (node.rcAnimTimeout) {
            clearTimeout(node.rcAnimTimeout);
            node.rcAnimTimeout = null;
        }
        clearBrowserBugTimeout(node);
        (0, _eventDefault.default).removeEndEventListener(node, node.rcEndListener);
        node.rcEndListener = null;
        // Usually this optional callback is used for informing an owner of
        // a leave animation and telling it to remove the child.
        if (callback) callback();
    };
    (0, _eventDefault.default).addEndEventListener(node, node.rcEndListener);
    node.rcAnimTimeout = setTimeout(function() {
        for(var s in style)if (style.hasOwnProperty(s)) node.style[s] = style[s];
        node.rcAnimTimeout = null;
        fixBrowserByTimeout(node);
    }, 0);
};
cssAnimation.setTransition = function(node, p, value) {
    var property = p;
    var v = value;
    if (value === undefined) {
        v = property;
        property = "";
    }
    property = property || "";
    capitalPrefixes.forEach(function(prefix) {
        node.style[prefix + "Transition" + property] = v;
    });
};
cssAnimation.isCssAnimationSupported = isCssAnimationSupported;
exports.default = cssAnimation;

},{"babel-runtime/helpers/typeof":"bOmQJ","./Event":"HDszo","component-classes":"kFG3u","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"HDszo":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var START_EVENT_NAME_MAP = {
    transitionstart: {
        transition: "transitionstart",
        WebkitTransition: "webkitTransitionStart",
        MozTransition: "mozTransitionStart",
        OTransition: "oTransitionStart",
        msTransition: "MSTransitionStart"
    },
    animationstart: {
        animation: "animationstart",
        WebkitAnimation: "webkitAnimationStart",
        MozAnimation: "mozAnimationStart",
        OAnimation: "oAnimationStart",
        msAnimation: "MSAnimationStart"
    }
};
var END_EVENT_NAME_MAP = {
    transitionend: {
        transition: "transitionend",
        WebkitTransition: "webkitTransitionEnd",
        MozTransition: "mozTransitionEnd",
        OTransition: "oTransitionEnd",
        msTransition: "MSTransitionEnd"
    },
    animationend: {
        animation: "animationend",
        WebkitAnimation: "webkitAnimationEnd",
        MozAnimation: "mozAnimationEnd",
        OAnimation: "oAnimationEnd",
        msAnimation: "MSAnimationEnd"
    }
};
var startEvents = [];
var endEvents = [];
function detectEvents() {
    var testEl = document.createElement("div");
    var style = testEl.style;
    if (!("AnimationEvent" in window)) {
        delete START_EVENT_NAME_MAP.animationstart.animation;
        delete END_EVENT_NAME_MAP.animationend.animation;
    }
    if (!("TransitionEvent" in window)) {
        delete START_EVENT_NAME_MAP.transitionstart.transition;
        delete END_EVENT_NAME_MAP.transitionend.transition;
    }
    function process(EVENT_NAME_MAP, events) {
        for(var baseEventName in EVENT_NAME_MAP)if (EVENT_NAME_MAP.hasOwnProperty(baseEventName)) {
            var baseEvents = EVENT_NAME_MAP[baseEventName];
            for(var styleName in baseEvents)if (styleName in style) {
                events.push(baseEvents[styleName]);
                break;
            }
        }
    }
    process(START_EVENT_NAME_MAP, startEvents);
    process(END_EVENT_NAME_MAP, endEvents);
}
if (typeof window !== "undefined" && typeof document !== "undefined") detectEvents();
function addEventListener(node, eventName, eventListener) {
    node.addEventListener(eventName, eventListener, false);
}
function removeEventListener(node, eventName, eventListener) {
    node.removeEventListener(eventName, eventListener, false);
}
var TransitionEvents = {
    // Start events
    startEvents: startEvents,
    addStartEventListener: function addStartEventListener(node, eventListener) {
        if (startEvents.length === 0) {
            window.setTimeout(eventListener, 0);
            return;
        }
        startEvents.forEach(function(startEvent) {
            addEventListener(node, startEvent, eventListener);
        });
    },
    removeStartEventListener: function removeStartEventListener(node, eventListener) {
        if (startEvents.length === 0) return;
        startEvents.forEach(function(startEvent) {
            removeEventListener(node, startEvent, eventListener);
        });
    },
    // End events
    endEvents: endEvents,
    addEndEventListener: function addEndEventListener(node, eventListener) {
        if (endEvents.length === 0) {
            window.setTimeout(eventListener, 0);
            return;
        }
        endEvents.forEach(function(endEvent) {
            addEventListener(node, endEvent, eventListener);
        });
    },
    removeEndEventListener: function removeEndEventListener(node, eventListener) {
        if (endEvents.length === 0) return;
        endEvents.forEach(function(endEvent) {
            removeEventListener(node, endEvent, eventListener);
        });
    }
};
exports.default = TransitionEvents;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"kFG3u":[function(require,module,exports) {
/**
 * Module dependencies.
 */ try {
    var index = require("47f3ec89ed49aa0e");
} catch (err) {
    var index = require("dccd49009d8c560f");
}
/**
 * Whitespace regexp.
 */ var re = /\s+/;
/**
 * toString reference.
 */ var toString = Object.prototype.toString;
/**
 * Wrap `el` in a `ClassList`.
 *
 * @param {Element} el
 * @return {ClassList}
 * @api public
 */ module.exports = function(el) {
    return new ClassList(el);
};
/**
 * Initialize a new ClassList for `el`.
 *
 * @param {Element} el
 * @api private
 */ function ClassList(el) {
    if (!el || !el.nodeType) throw new Error("A DOM element reference is required");
    this.el = el;
    this.list = el.classList;
}
/**
 * Add class `name` if not already present.
 *
 * @param {String} name
 * @return {ClassList}
 * @api public
 */ ClassList.prototype.add = function(name) {
    // classList
    if (this.list) {
        this.list.add(name);
        return this;
    }
    // fallback
    var arr = this.array();
    var i = index(arr, name);
    if (!~i) arr.push(name);
    this.el.className = arr.join(" ");
    return this;
};
/**
 * Remove class `name` when present, or
 * pass a regular expression to remove
 * any which match.
 *
 * @param {String|RegExp} name
 * @return {ClassList}
 * @api public
 */ ClassList.prototype.remove = function(name) {
    if ("[object RegExp]" == toString.call(name)) return this.removeMatching(name);
    // classList
    if (this.list) {
        this.list.remove(name);
        return this;
    }
    // fallback
    var arr = this.array();
    var i = index(arr, name);
    if (~i) arr.splice(i, 1);
    this.el.className = arr.join(" ");
    return this;
};
/**
 * Remove all classes matching `re`.
 *
 * @param {RegExp} re
 * @return {ClassList}
 * @api private
 */ ClassList.prototype.removeMatching = function(re) {
    var arr = this.array();
    for(var i = 0; i < arr.length; i++)if (re.test(arr[i])) this.remove(arr[i]);
    return this;
};
/**
 * Toggle class `name`, can force state via `force`.
 *
 * For browsers that support classList, but do not support `force` yet,
 * the mistake will be detected and corrected.
 *
 * @param {String} name
 * @param {Boolean} force
 * @return {ClassList}
 * @api public
 */ ClassList.prototype.toggle = function(name, force) {
    // classList
    if (this.list) {
        if ("undefined" !== typeof force) {
            if (force !== this.list.toggle(name, force)) this.list.toggle(name); // toggle again to correct
        } else this.list.toggle(name);
        return this;
    }
    // fallback
    if ("undefined" !== typeof force) {
        if (!force) this.remove(name);
        else this.add(name);
    } else if (this.has(name)) this.remove(name);
    else this.add(name);
    return this;
};
/**
 * Return an array of classes.
 *
 * @return {Array}
 * @api public
 */ ClassList.prototype.array = function() {
    var className = this.el.getAttribute("class") || "";
    var str = className.replace(/^\s+|\s+$/g, "");
    var arr = str.split(re);
    if ("" === arr[0]) arr.shift();
    return arr;
};
/**
 * Check if class `name` is present.
 *
 * @param {String} name
 * @return {ClassList}
 * @api public
 */ ClassList.prototype.has = ClassList.prototype.contains = function(name) {
    return this.list ? this.list.contains(name) : !!~index(this.array(), name);
};

},{"47f3ec89ed49aa0e":"8qYUh","dccd49009d8c560f":"8qYUh"}],"8qYUh":[function(require,module,exports) {
module.exports = function(arr, obj) {
    if (arr.indexOf) return arr.indexOf(obj);
    for(var i = 0; i < arr.length; ++i){
        if (arr[i] === obj) return i;
    }
    return -1;
};

},{}],"ePmvV":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var util = {
    isAppearSupported: function isAppearSupported(props) {
        return props.transitionName && props.transitionAppear || props.animation.appear;
    },
    isEnterSupported: function isEnterSupported(props) {
        return props.transitionName && props.transitionEnter || props.animation.enter;
    },
    isLeaveSupported: function isLeaveSupported(props) {
        return props.transitionName && props.transitionLeave || props.animation.leave;
    },
    allowAppearCallback: function allowAppearCallback(props) {
        return props.transitionAppear || props.animation.appear;
    },
    allowEnterCallback: function allowEnterCallback(props) {
        return props.transitionEnter || props.animation.enter;
    },
    allowLeaveCallback: function allowLeaveCallback(props) {
        return props.transitionLeave || props.animation.leave;
    }
};
exports.default = util;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"36CCX":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _classCallCheck = require("babel-runtime/helpers/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _possibleConstructorReturn = require("babel-runtime/helpers/possibleConstructorReturn");
var _possibleConstructorReturnDefault = parcelHelpers.interopDefault(_possibleConstructorReturn);
var _inherits = require("babel-runtime/helpers/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _lazyRenderBox = require("./LazyRenderBox");
var _lazyRenderBoxDefault = parcelHelpers.interopDefault(_lazyRenderBox);
var PopupInner = function(_Component) {
    (0, _inheritsDefault.default)(PopupInner, _Component);
    function PopupInner() {
        (0, _classCallCheckDefault.default)(this, PopupInner);
        return (0, _possibleConstructorReturnDefault.default)(this, _Component.apply(this, arguments));
    }
    PopupInner.prototype.render = function render() {
        var props = this.props;
        var className = props.className;
        if (!props.visible) className += " " + props.hiddenClassName;
        return (0, _reactDefault.default).createElement("div", {
            className: className,
            onMouseEnter: props.onMouseEnter,
            onMouseLeave: props.onMouseLeave,
            onMouseDown: props.onMouseDown,
            onTouchStart: props.onTouchStart,
            style: props.style
        }, (0, _reactDefault.default).createElement((0, _lazyRenderBoxDefault.default), {
            className: props.prefixCls + "-content",
            visible: props.visible
        }, props.children));
    };
    return PopupInner;
}((0, _react.Component));
PopupInner.propTypes = {
    hiddenClassName: (0, _propTypesDefault.default).string,
    className: (0, _propTypesDefault.default).string,
    prefixCls: (0, _propTypesDefault.default).string,
    onMouseEnter: (0, _propTypesDefault.default).func,
    onMouseLeave: (0, _propTypesDefault.default).func,
    onMouseDown: (0, _propTypesDefault.default).func,
    onTouchStart: (0, _propTypesDefault.default).func,
    children: (0, _propTypesDefault.default).any
};
exports.default = PopupInner;

},{"babel-runtime/helpers/classCallCheck":"aRpYz","babel-runtime/helpers/possibleConstructorReturn":"40Qb5","babel-runtime/helpers/inherits":"bitir","react":"6uln9","prop-types":"6FKs7","./LazyRenderBox":"5jeV2","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"5jeV2":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectWithoutProperties = require("babel-runtime/helpers/objectWithoutProperties");
var _objectWithoutPropertiesDefault = parcelHelpers.interopDefault(_objectWithoutProperties);
var _classCallCheck = require("babel-runtime/helpers/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _possibleConstructorReturn = require("babel-runtime/helpers/possibleConstructorReturn");
var _possibleConstructorReturnDefault = parcelHelpers.interopDefault(_possibleConstructorReturn);
var _inherits = require("babel-runtime/helpers/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var LazyRenderBox = function(_Component) {
    (0, _inheritsDefault.default)(LazyRenderBox, _Component);
    function LazyRenderBox() {
        (0, _classCallCheckDefault.default)(this, LazyRenderBox);
        return (0, _possibleConstructorReturnDefault.default)(this, _Component.apply(this, arguments));
    }
    LazyRenderBox.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
        return nextProps.hiddenClassName || nextProps.visible;
    };
    LazyRenderBox.prototype.render = function render() {
        var _props = this.props, hiddenClassName = _props.hiddenClassName, visible = _props.visible, props = (0, _objectWithoutPropertiesDefault.default)(_props, [
            "hiddenClassName",
            "visible"
        ]);
        if (hiddenClassName || (0, _reactDefault.default).Children.count(props.children) > 1) {
            if (!visible && hiddenClassName) props.className += " " + hiddenClassName;
            return (0, _reactDefault.default).createElement("div", props);
        }
        return (0, _reactDefault.default).Children.only(props.children);
    };
    return LazyRenderBox;
}((0, _react.Component));
LazyRenderBox.propTypes = {
    children: (0, _propTypesDefault.default).any,
    className: (0, _propTypesDefault.default).string,
    visible: (0, _propTypesDefault.default).bool,
    hiddenClassName: (0, _propTypesDefault.default).string
};
exports.default = LazyRenderBox;

},{"babel-runtime/helpers/objectWithoutProperties":"5ILj2","babel-runtime/helpers/classCallCheck":"aRpYz","babel-runtime/helpers/possibleConstructorReturn":"40Qb5","babel-runtime/helpers/inherits":"bitir","react":"6uln9","prop-types":"6FKs7","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"k16CU":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "placements", ()=>placements);
var autoAdjustOverflow = {
    adjustX: 1,
    adjustY: 1
};
var targetOffset = [
    0,
    0
];
var placements = {
    left: {
        points: [
            "cr",
            "cl"
        ],
        overflow: autoAdjustOverflow,
        offset: [
            -4,
            0
        ],
        targetOffset: targetOffset
    },
    right: {
        points: [
            "cl",
            "cr"
        ],
        overflow: autoAdjustOverflow,
        offset: [
            4,
            0
        ],
        targetOffset: targetOffset
    },
    top: {
        points: [
            "bc",
            "tc"
        ],
        overflow: autoAdjustOverflow,
        offset: [
            0,
            -4
        ],
        targetOffset: targetOffset
    },
    bottom: {
        points: [
            "tc",
            "bc"
        ],
        overflow: autoAdjustOverflow,
        offset: [
            0,
            4
        ],
        targetOffset: targetOffset
    },
    topLeft: {
        points: [
            "bl",
            "tl"
        ],
        overflow: autoAdjustOverflow,
        offset: [
            0,
            -4
        ],
        targetOffset: targetOffset
    },
    leftTop: {
        points: [
            "tr",
            "tl"
        ],
        overflow: autoAdjustOverflow,
        offset: [
            -4,
            0
        ],
        targetOffset: targetOffset
    },
    topRight: {
        points: [
            "br",
            "tr"
        ],
        overflow: autoAdjustOverflow,
        offset: [
            0,
            -4
        ],
        targetOffset: targetOffset
    },
    rightTop: {
        points: [
            "tl",
            "tr"
        ],
        overflow: autoAdjustOverflow,
        offset: [
            4,
            0
        ],
        targetOffset: targetOffset
    },
    bottomRight: {
        points: [
            "tr",
            "br"
        ],
        overflow: autoAdjustOverflow,
        offset: [
            0,
            4
        ],
        targetOffset: targetOffset
    },
    rightBottom: {
        points: [
            "bl",
            "br"
        ],
        overflow: autoAdjustOverflow,
        offset: [
            4,
            0
        ],
        targetOffset: targetOffset
    },
    bottomLeft: {
        points: [
            "tl",
            "bl"
        ],
        overflow: autoAdjustOverflow,
        offset: [
            0,
            4
        ],
        targetOffset: targetOffset
    },
    leftBottom: {
        points: [
            "br",
            "bl"
        ],
        overflow: autoAdjustOverflow,
        offset: [
            -4,
            0
        ],
        targetOffset: targetOffset
    }
};
exports.default = placements;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jC08b":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _classCallCheck = require("babel-runtime/helpers/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _possibleConstructorReturn = require("babel-runtime/helpers/possibleConstructorReturn");
var _possibleConstructorReturnDefault = parcelHelpers.interopDefault(_possibleConstructorReturn);
var _inherits = require("babel-runtime/helpers/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var Content = function(_React$Component) {
    (0, _inheritsDefault.default)(Content, _React$Component);
    function Content() {
        (0, _classCallCheckDefault.default)(this, Content);
        return (0, _possibleConstructorReturnDefault.default)(this, _React$Component.apply(this, arguments));
    }
    Content.prototype.componentDidUpdate = function componentDidUpdate() {
        var trigger = this.props.trigger;
        if (trigger) trigger.forcePopupAlign();
    };
    Content.prototype.render = function render() {
        var _props = this.props, overlay = _props.overlay, prefixCls = _props.prefixCls, id = _props.id;
        return (0, _reactDefault.default).createElement("div", {
            className: prefixCls + "-inner",
            id: id,
            role: "tooltip"
        }, typeof overlay === "function" ? overlay() : overlay);
    };
    return Content;
}((0, _reactDefault.default).Component);
Content.propTypes = {
    prefixCls: (0, _propTypesDefault.default).string,
    overlay: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).node,
        (0, _propTypesDefault.default).func
    ]).isRequired,
    id: (0, _propTypesDefault.default).string,
    trigger: (0, _propTypesDefault.default).any
};
exports.default = Content;

},{"babel-runtime/helpers/classCallCheck":"aRpYz","babel-runtime/helpers/possibleConstructorReturn":"40Qb5","babel-runtime/helpers/inherits":"bitir","react":"6uln9","prop-types":"6FKs7","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9MrrI":[function() {},{}],"aNNRC":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _colors = require("../../constants/colors");
const separatorStyle = /*#__PURE__*/ (0, _css.css)("height:100%;width:1px;background:", (0, _colors.silver_two), ";", "");
const flexStyle = /*#__PURE__*/ (0, _css.css)("width:1px;background:", (0, _colors.silver_two), ";height:auto;", "");
const VerticalSeparator = (props)=>(0, _react.jsx)("div", {
        className: `${props.fit ? flexStyle : separatorStyle} ${props.className}`
    });
exports.default = VerticalSeparator;

},{"@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","../../constants/colors":"1p3OR","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2F01A":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "breakpoint_small", ()=>breakpoint_small);
parcelHelpers.export(exports, "breakpoint_small_landscape", ()=>breakpoint_small_landscape);
parcelHelpers.export(exports, "breakpoint_medium", ()=>breakpoint_medium);
parcelHelpers.export(exports, "breakpoint_large", ()=>breakpoint_large);
parcelHelpers.export(exports, "breakpoint_xLarge", ()=>breakpoint_xLarge);
parcelHelpers.export(exports, "breakpoint_macbook_small", ()=>breakpoint_macbook_small);
parcelHelpers.export(exports, "breakpoint_macbook", ()=>breakpoint_macbook);
parcelHelpers.export(exports, "breakpoint_macbook_large", ()=>breakpoint_macbook_large);
const breakpoint_small = "@media (max-aspect-ratio: 1/1)"; // When width < height
const breakpoint_small_landscape = "@media (min-width: 640px) and (max-width: 767.98px)"; // Small phones in landscape mode
const breakpoint_medium = "@media (min-width: 768px) and (max-width: 1023.98px)"; // Tablets and small desktops
const breakpoint_large = "@media (min-width: 1024px) and (max-width: 1279.98px)"; // Laptops and larger tablets
const breakpoint_xLarge = "@media (min-width: 1280px)"; // Desktops and large screens
const breakpoint_macbook_small = "@media (min-width: 1280px) and (max-width: 1439.98px)"; // 13" MacBook at default scaling
const breakpoint_macbook = "@media (min-width: 1440px) and (max-width: 1679.98px)"; // 13" MacBook at "More Space" scaling
const breakpoint_macbook_large = "@media (min-width: 1680px) and (max-width: 1919.98px)"; // 14" MacBook / external displays

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7eyKJ":[function(require,module,exports) {
module.exports = require("1d27bc85b53792a3").getBundleURL("kVLro") + require("d24293d27a90b017").resolve("3DBty");

},{"1d27bc85b53792a3":"c7Tr5","d24293d27a90b017":"fyJL2"}],"ezFTm":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _base = require("@emotion/styled/base");
var _baseDefault = parcelHelpers.interopDefault(_base);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _colors = require("../../constants/colors");
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const alertIcon = require("2805a584d364d0df");
const checkIcon = require("1ae21a68187ab54c");
const PageError = ({ errors = [], onClear, className, type = "error" })=>{
    const [displayErrors, setDisplayErrors] = (0, _react1.useState)(errors);
    (0, _react1.useEffect)(()=>{
        setDisplayErrors(errors);
    }, [
        errors
    ]);
    const handleClick = ()=>{
        setDisplayErrors([]);
        if (onClear) onClear();
    };
    if (!displayErrors || displayErrors.length === 0) return null;
    const isSuccess = type === "success";
    return (0, _react.jsx)("div", {
        onClick: handleClick
    }, (0, _react.jsx)("div", {
        className: `${isSuccess ? successContainerStyle : containerStyle} ${className?.length ? className : ""}`
    }, (0, _react.jsx)(AlertIconStyle, {
        src: isSuccess ? checkIcon : alertIcon
    }), (0, _react.jsx)("div", null, displayErrors.map((e, i)=>(0, _react.jsx)("p", {
            className: isSuccess ? "success-text" : "error-text",
            key: i
        }, e?.toString() ?? "")))));
};
const containerStyle = /*#__PURE__*/ (0, _css.css)("display:flex;align-items:center;position:absolute;right:0;bottom:32;width:360px;background:", (0, _colors.color_variants_decline_light_1), ";border:1px solid ", (0, _colors.color_colors_decline), ";padding:16px;border-top-left-radius:8px;border-bottom-left-radius:8px;cursor:pointer;z-index:999;.error-text{color:", (0, _colors.color_shades_darkest), ";font-family:Muli;font-size:16px;font-weight:bold;line-height:1.5;}", "");
const successContainerStyle = /*#__PURE__*/ (0, _css.css)({
    name: "16d3bhx",
    styles: "display:flex;align-items:center;position:absolute;right:0;bottom:32;width:360px;background:#d4edda;border:1px solid #28a745;padding:16px;border-top-left-radius:8px;border-bottom-left-radius:8px;cursor:pointer;z-index:999;.success-text{color:#155724;font-family:Muli;font-size:16px;font-weight:bold;line-height:1.5;}"
});
const AlertIconStyle = /*#__PURE__*/ (0, _baseDefault.default)("img", {
    target: "e1kweal20"
})({
    name: "b82b4z",
    styles: "height:24px;width:24px;margin-right:8px"
});
exports.default = PageError;

},{"@emotion/styled/base":"lSuFu","@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","../../constants/colors":"1p3OR","2805a584d364d0df":"cRA6k","1ae21a68187ab54c":"3Js1w","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3Js1w":[function(require,module,exports) {
module.exports = require("bacaac068013d42a").getBundleURL("kVLro") + require("d7d0564dfbab6da3").resolve("5WkHh");

},{"bacaac068013d42a":"c7Tr5","d7d0564dfbab6da3":"fyJL2"}],"81aMg":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _reactTabs = require("react-tabs");
var _css = require("@emotion/css");
var _colors = require("../../constants/colors");
var _breakpoints = require("../../constants/breakpoints");
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const watermark = require("c90274d38fdca1e1");
const FrontTabbedLayout = (props)=>{
    function renderTab(name) {
        return (0, _react.jsx)((0, _reactTabs.Tab), {
            selectedClassName: activeTabStyle,
            className: tabStyle,
            key: name
        }, (0, _react.jsx)("span", null, name));
    }
    return (0, _react.jsx)((0, _reactTabs.Tabs), {
        className: tablayoutStyle,
        selectedIndex: props.selectedTabIndex
    }, (0, _react.jsx)((0, _reactTabs.TabList), {
        className: tabStripStyle
    }, (0, _react.jsx)("div", {
        className: tabSpacerFront
    }), props.tabs.map(renderTab), (0, _react.jsx)("div", {
        className: tabSpacerStyle
    })), (0, _react.jsx)("div", {
        className: tabBodyContainer
    }, props.children), (0, _react.jsx)("img", {
        className: "watermark",
        src: watermark
    }));
};
const tabStripStyle = /*#__PURE__*/ (0, _css.css)({
    name: "17ieow4",
    styles: "display:flex;flex-direction:row;height:65px;list-style:none"
});
const tabStyle = /*#__PURE__*/ (0, _css.css)("display:flex;flex-direction:column;width:22%;color:", (0, _colors.cool_grey), ";background:", (0, _colors.pale_grey), ";text-align:center;cursor:pointer;justify-content:center;span{font-family:Muli;font-size:20px;font-weight:400;font-style:normal;font-stretch:normal;line-height:normal;letter-spacing:normal;text-align:center;}", (0, _breakpoints.breakpoint_small), "{span{font-size:14px;}}", "");
const activeTabStyle = /*#__PURE__*/ (0, _css.css)({
    name: "11dme8a",
    styles: "color:white;background:transparent"
});
const tablayoutStyle = /*#__PURE__*/ (0, _css.css)("background:#0c6085;background:-moz-linear-gradient(45deg, #0c6085 0%, #0074a6 50%, #249fd4 100%);background:-webkit-linear-gradient(45deg, #0c6085 0%,#0074a6 50%,#249fd4 100%);background:linear-gradient(45deg, #0c6085 0%,#0074a6 50%,#249fd4 100%);margin-bottom:120px;label{color:white;}.watermark{position:absolute;right:64px;top:264px;}.forgot-password{color:white;text-decoration:none;font-family:Muli;font-size:14px;font-weight:400;font-style:normal;font-stretch:normal;line-height:normal;float:right;margin-bottom:64px;&:hover{font-weight:700;}}", (0, _breakpoints.breakpoint_small), "{display:flex;flex-direction:column;font-size:16px;.watermark{display:none;}}", "");
const tabSpacerStyle = /*#__PURE__*/ (0, _css.css)("flex-grow:2;background:", (0, _colors.pale_grey), ";", "");
const tabSpacerFront = /*#__PURE__*/ (0, _css.css)("width:120px;background:", (0, _colors.pale_grey), ";", "");
const tabBodyContainer = /*#__PURE__*/ (0, _css.css)("padding:40px 120px 0 120px;width:50%;div{height:auto;}", (0, _breakpoints.breakpoint_small), "{padding:12px;width:100%;}", "");
exports.default = FrontTabbedLayout;

},{"@emotion/react":"djZKr","react":"6uln9","react-tabs":"92Sgf","@emotion/css":"awUBr","../../constants/colors":"1p3OR","../../constants/breakpoints":"2F01A","c90274d38fdca1e1":"7FEZc","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"92Sgf":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Tabs", ()=>(0, _tabsDefault.default));
parcelHelpers.export(exports, "TabList", ()=>(0, _tabListDefault.default));
parcelHelpers.export(exports, "Tab", ()=>(0, _tabDefault.default));
parcelHelpers.export(exports, "TabPanel", ()=>(0, _tabPanelDefault.default));
parcelHelpers.export(exports, "resetIdCounter", ()=>(0, _uuid.reset));
var _tabs = require("./components/Tabs");
var _tabsDefault = parcelHelpers.interopDefault(_tabs);
var _tabList = require("./components/TabList");
var _tabListDefault = parcelHelpers.interopDefault(_tabList);
var _tab = require("./components/Tab");
var _tabDefault = parcelHelpers.interopDefault(_tab);
var _tabPanel = require("./components/TabPanel");
var _tabPanelDefault = parcelHelpers.interopDefault(_tabPanel);
var _uuid = require("./helpers/uuid");

},{"./components/Tabs":"3YIaV","./components/TabList":"1BkB0","./components/Tab":"k2KUn","./components/TabPanel":"bc3OB","./helpers/uuid":"be67v","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3YIaV":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Tabs);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes1 = require("../helpers/propTypes");
var _uncontrolledTabs = require("./UncontrolledTabs");
var _uncontrolledTabsDefault = parcelHelpers.interopDefault(_uncontrolledTabs);
var _count = require("../helpers/count");
var _excluded = [
    "children",
    "defaultIndex",
    "defaultFocus"
];
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
var MODE_CONTROLLED = 0;
var MODE_UNCONTROLLED = 1;
var Tabs = /*#__PURE__*/ function(_Component) {
    _inheritsLoose(Tabs, _Component);
    function Tabs(props) {
        var _this;
        _this = _Component.call(this, props) || this;
        _this.handleSelected = function(index, last, event) {
            var onSelect = _this.props.onSelect;
            var mode = _this.state.mode; // Call change event handler
            if (typeof onSelect === "function") {
                // Check if the change event handler cancels the tab change
                if (onSelect(index, last, event) === false) return;
            }
            var state = {
                // Set focus if the change was triggered from the keyboard
                focus: event.type === "keydown"
            };
            if (mode === MODE_UNCONTROLLED) // Update selected index
            state.selectedIndex = index;
            _this.setState(state);
        };
        _this.state = Tabs.copyPropsToState(_this.props, {}, props.defaultFocus);
        return _this;
    }
    Tabs.getDerivedStateFromProps = function getDerivedStateFromProps(props, state) {
        return Tabs.copyPropsToState(props, state);
    };
    Tabs.getModeFromProps = function getModeFromProps(props) {
        return props.selectedIndex === null ? MODE_UNCONTROLLED : MODE_CONTROLLED;
    };
    // preserve the existing selectedIndex from state.
    // If the state has not selectedIndex, default to the defaultIndex or 0
    Tabs.copyPropsToState = function copyPropsToState(props, state, focus) {
        if (focus === void 0) focus = false;
        var newState = {
            focus: focus,
            mode: Tabs.getModeFromProps(props)
        };
        if (newState.mode === MODE_UNCONTROLLED) {
            var maxTabIndex = Math.max(0, (0, _count.getTabsCount)(props.children) - 1);
            var selectedIndex = null;
            if (state.selectedIndex != null) selectedIndex = Math.min(state.selectedIndex, maxTabIndex);
            else selectedIndex = props.defaultIndex || 0;
            newState.selectedIndex = selectedIndex;
        }
        return newState;
    };
    var _proto = Tabs.prototype;
    _proto.render = function render() {
        var _this$props = this.props, children = _this$props.children, defaultIndex = _this$props.defaultIndex, defaultFocus = _this$props.defaultFocus, props = _objectWithoutPropertiesLoose(_this$props, _excluded);
        var _this$state = this.state, focus = _this$state.focus, selectedIndex = _this$state.selectedIndex;
        props.focus = focus;
        props.onSelect = this.handleSelected;
        if (selectedIndex != null) props.selectedIndex = selectedIndex;
        return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _uncontrolledTabsDefault.default), props, children);
    };
    return Tabs;
}((0, _react.Component));
Tabs.defaultProps = {
    defaultFocus: false,
    forceRenderTabPanel: false,
    selectedIndex: null,
    defaultIndex: null,
    environment: null,
    disableUpDownKeys: false
};
Tabs.propTypes = {};
Tabs.tabsRole = "Tabs";

},{"prop-types":"6FKs7","react":"6uln9","../helpers/propTypes":"kwq5c","./UncontrolledTabs":"kxl5G","../helpers/count":"2I2ic","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"kwq5c":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "childrenPropType", ()=>childrenPropType);
parcelHelpers.export(exports, "onSelectPropType", ()=>onSelectPropType);
parcelHelpers.export(exports, "selectedIndexPropType", ()=>selectedIndexPropType);
var _childrenDeepMap = require("./childrenDeepMap");
var _elementTypes = require("./elementTypes");
function childrenPropType(props, propName, componentName) {
    var error;
    var tabsCount = 0;
    var panelsCount = 0;
    var tabListFound = false;
    var listTabs = [];
    var children = props[propName];
    (0, _childrenDeepMap.deepForEach)(children, function(child) {
        if ((0, _elementTypes.isTabList)(child)) {
            if (child.props && child.props.children && typeof child.props.children === "object") (0, _childrenDeepMap.deepForEach)(child.props.children, function(listChild) {
                return listTabs.push(listChild);
            });
            if (tabListFound) error = new Error("Found multiple 'TabList' components inside 'Tabs'. Only one is allowed.");
            tabListFound = true;
        }
        if ((0, _elementTypes.isTab)(child)) {
            if (!tabListFound || listTabs.indexOf(child) === -1) error = new Error("Found a 'Tab' component outside of the 'TabList' component. 'Tab' components have to be inside the 'TabList' component.");
            tabsCount++;
        } else if ((0, _elementTypes.isTabPanel)(child)) panelsCount++;
    });
    if (!error && tabsCount !== panelsCount) error = new Error("There should be an equal number of 'Tab' and 'TabPanel' in `" + componentName + "`. " + ("Received " + tabsCount + " 'Tab' and " + panelsCount + " 'TabPanel'."));
    return error;
}
function onSelectPropType(props, propName, componentName, location, propFullName) {
    var prop = props[propName];
    var name = propFullName || propName;
    var error = null;
    if (prop && typeof prop !== "function") error = new Error("Invalid " + location + " `" + name + "` of type `" + typeof prop + "` supplied " + ("to `" + componentName + "`, expected `function`."));
    else if (props.selectedIndex != null && prop == null) error = new Error("The " + location + " `" + name + "` is marked as required in `" + componentName + "`, but " + "its value is `undefined` or `null`.\n" + "`onSelect` is required when `selectedIndex` is also set. Not doing so will " + "make the tabs not do anything, as `selectedIndex` indicates that you want to " + "handle the selected tab yourself.\n" + "If you only want to set the inital tab replace `selectedIndex` with `defaultIndex`.");
    return error;
}
function selectedIndexPropType(props, propName, componentName, location, propFullName) {
    var prop = props[propName];
    var name = propFullName || propName;
    var error = null;
    if (prop != null && typeof prop !== "number") error = new Error("Invalid " + location + " `" + name + "` of type `" + typeof prop + "` supplied to " + ("`" + componentName + "`, expected `number`."));
    else if (props.defaultIndex != null && prop != null) return new Error("The " + location + " `" + name + "` cannot be used together with `defaultIndex` " + ("in `" + componentName + "`.\n") + ("Either remove `" + name + "` to let `" + componentName + "` handle the selected ") + "tab internally or remove `defaultIndex` to handle it yourself.");
    return error;
}

},{"./childrenDeepMap":"bGO9j","./elementTypes":"2TXJx","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"bGO9j":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "deepMap", ()=>deepMap);
parcelHelpers.export(exports, "deepForEach", ()=>deepForEach);
var _react = require("react");
var _elementTypes = require("./elementTypes");
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function isTabChild(child) {
    return (0, _elementTypes.isTab)(child) || (0, _elementTypes.isTabList)(child) || (0, _elementTypes.isTabPanel)(child);
}
function deepMap(children, callback) {
    return (0, _react.Children).map(children, function(child) {
        // null happens when conditionally rendering TabPanel/Tab
        // see https://github.com/reactjs/react-tabs/issues/37
        if (child === null) return null;
        if (isTabChild(child)) return callback(child);
        if (child.props && child.props.children && typeof child.props.children === "object") // Clone the child that has children and map them too
        return /*#__PURE__*/ (0, _react.cloneElement)(child, _extends({}, child.props, {
            children: deepMap(child.props.children, callback)
        }));
        return child;
    });
}
function deepForEach(children, callback) {
    return (0, _react.Children).forEach(children, function(child) {
        // null happens when conditionally rendering TabPanel/Tab
        // see https://github.com/reactjs/react-tabs/issues/37
        if (child === null) return;
        if ((0, _elementTypes.isTab)(child) || (0, _elementTypes.isTabPanel)(child)) callback(child);
        else if (child.props && child.props.children && typeof child.props.children === "object") {
            if ((0, _elementTypes.isTabList)(child)) callback(child);
            deepForEach(child.props.children, callback);
        }
    });
}

},{"react":"6uln9","./elementTypes":"2TXJx","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2TXJx":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isTab", ()=>isTab);
parcelHelpers.export(exports, "isTabList", ()=>isTabList);
parcelHelpers.export(exports, "isTabPanel", ()=>isTabPanel);
function makeTypeChecker(tabsRole) {
    return function(element) {
        return !!element.type && element.type.tabsRole === tabsRole;
    };
}
var isTab = makeTypeChecker("Tab");
var isTabList = makeTypeChecker("TabList");
var isTabPanel = makeTypeChecker("TabPanel");

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"kxl5G":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>UncontrolledTabs);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _uuid = require("../helpers/uuid");
var _uuidDefault = parcelHelpers.interopDefault(_uuid);
var _propTypes1 = require("../helpers/propTypes");
var _count = require("../helpers/count");
var _childrenDeepMap = require("../helpers/childrenDeepMap");
var _elementTypes = require("../helpers/elementTypes");
var _excluded = [
    "children",
    "className",
    "disabledTabClassName",
    "domRef",
    "focus",
    "forceRenderTabPanel",
    "onSelect",
    "selectedIndex",
    "selectedTabClassName",
    "selectedTabPanelClassName",
    "environment",
    "disableUpDownKeys"
];
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
function isNode(node) {
    return node && "getAttribute" in node;
} // Determine if a node from event.target is a Tab element
function isTabNode(node) {
    return isNode(node) && node.getAttribute("data-rttab");
} // Determine if a tab node is disabled
function isTabDisabled(node) {
    return isNode(node) && node.getAttribute("aria-disabled") === "true";
}
var canUseActiveElement;
function determineCanUseActiveElement(environment) {
    var env = environment || (typeof window !== "undefined" ? window : undefined);
    try {
        canUseActiveElement = !!(typeof env !== "undefined" && env.document && env.document.activeElement);
    } catch (e) {
        // Work around for IE bug when accessing document.activeElement in an iframe
        // Refer to the following resources:
        // http://stackoverflow.com/a/10982960/369687
        // https://developer.microsoft.com/en-us/microsoft-edge/platform/issues/12733599
        canUseActiveElement = false;
    }
}
var UncontrolledTabs = /*#__PURE__*/ function(_Component) {
    _inheritsLoose(UncontrolledTabs, _Component);
    function UncontrolledTabs() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _Component.call.apply(_Component, [
            this
        ].concat(args)) || this;
        _this.tabNodes = [];
        _this.handleKeyDown = function(e) {
            var _this$props = _this.props, direction = _this$props.direction, disableUpDownKeys = _this$props.disableUpDownKeys;
            if (_this.isTabFromContainer(e.target)) {
                var index = _this.props.selectedIndex;
                var preventDefault = false;
                var useSelectedIndex = false;
                if (e.keyCode === 32 || e.keyCode === 13) {
                    preventDefault = true;
                    useSelectedIndex = false;
                    _this.handleClick(e);
                }
                if (e.keyCode === 37 || !disableUpDownKeys && e.keyCode === 38) {
                    // Select next tab to the left, validate if up arrow is not disabled
                    if (direction === "rtl") index = _this.getNextTab(index);
                    else index = _this.getPrevTab(index);
                    preventDefault = true;
                    useSelectedIndex = true;
                } else if (e.keyCode === 39 || !disableUpDownKeys && e.keyCode === 40) {
                    // Select next tab to the right, validate if down arrow is not disabled
                    if (direction === "rtl") index = _this.getPrevTab(index);
                    else index = _this.getNextTab(index);
                    preventDefault = true;
                    useSelectedIndex = true;
                } else if (e.keyCode === 35) {
                    // Select last tab (End key)
                    index = _this.getLastTab();
                    preventDefault = true;
                    useSelectedIndex = true;
                } else if (e.keyCode === 36) {
                    // Select first tab (Home key)
                    index = _this.getFirstTab();
                    preventDefault = true;
                    useSelectedIndex = true;
                } // This prevents scrollbars from moving around
                if (preventDefault) e.preventDefault();
                 // Only use the selected index in the state if we're not using the tabbed index
                if (useSelectedIndex) _this.setSelected(index, e);
            }
        };
        _this.handleClick = function(e) {
            var node = e.target;
            do if (_this.isTabFromContainer(node)) {
                if (isTabDisabled(node)) return;
                var index = [].slice.call(node.parentNode.children).filter(isTabNode).indexOf(node);
                _this.setSelected(index, e);
                return;
            }
            while ((node = node.parentNode) != null);
        };
        return _this;
    }
    var _proto = UncontrolledTabs.prototype;
    _proto.setSelected = function setSelected(index, event) {
        // Check index boundary
        if (index < 0 || index >= this.getTabsCount()) return;
        var _this$props2 = this.props, onSelect = _this$props2.onSelect, selectedIndex = _this$props2.selectedIndex; // Call change event handler
        onSelect(index, selectedIndex, event);
    };
    _proto.getNextTab = function getNextTab(index) {
        var count = this.getTabsCount(); // Look for non-disabled tab from index to the last tab on the right
        for(var i = index + 1; i < count; i++){
            if (!isTabDisabled(this.getTab(i))) return i;
        } // If no tab found, continue searching from first on left to index
        for(var _i = 0; _i < index; _i++){
            if (!isTabDisabled(this.getTab(_i))) return _i;
        } // No tabs are disabled, return index
        return index;
    };
    _proto.getPrevTab = function getPrevTab(index) {
        var i = index; // Look for non-disabled tab from index to first tab on the left
        while(i--){
            if (!isTabDisabled(this.getTab(i))) return i;
        } // If no tab found, continue searching from last tab on right to index
        i = this.getTabsCount();
        while(i-- > index){
            if (!isTabDisabled(this.getTab(i))) return i;
        } // No tabs are disabled, return index
        return index;
    };
    _proto.getFirstTab = function getFirstTab() {
        var count = this.getTabsCount(); // Look for non disabled tab from the first tab
        for(var i = 0; i < count; i++){
            if (!isTabDisabled(this.getTab(i))) return i;
        }
        return null;
    };
    _proto.getLastTab = function getLastTab() {
        var i = this.getTabsCount(); // Look for non disabled tab from the last tab
        while(i--){
            if (!isTabDisabled(this.getTab(i))) return i;
        }
        return null;
    };
    _proto.getTabsCount = function getTabsCount() {
        var children = this.props.children;
        return (0, _count.getTabsCount)(children);
    };
    _proto.getPanelsCount = function getPanelsCount() {
        var children = this.props.children;
        return (0, _count.getPanelsCount)(children);
    };
    _proto.getTab = function getTab(index) {
        return this.tabNodes["tabs-" + index];
    };
    _proto.getChildren = function getChildren() {
        var _this2 = this;
        var index = 0;
        var _this$props3 = this.props, children = _this$props3.children, disabledTabClassName = _this$props3.disabledTabClassName, focus = _this$props3.focus, forceRenderTabPanel = _this$props3.forceRenderTabPanel, selectedIndex = _this$props3.selectedIndex, selectedTabClassName = _this$props3.selectedTabClassName, selectedTabPanelClassName = _this$props3.selectedTabPanelClassName, environment = _this$props3.environment;
        this.tabIds = this.tabIds || [];
        this.panelIds = this.panelIds || [];
        var diff = this.tabIds.length - this.getTabsCount(); // Add ids if new tabs have been added
        // Don't bother removing ids, just keep them in case they are added again
        // This is more efficient, and keeps the uuid counter under control
        while(diff++ < 0){
            this.tabIds.push((0, _uuidDefault.default)());
            this.panelIds.push((0, _uuidDefault.default)());
        } // Map children to dynamically setup refs
        return (0, _childrenDeepMap.deepMap)(children, function(child) {
            var result = child; // Clone TabList and Tab components to have refs
            if ((0, _elementTypes.isTabList)(child)) {
                var listIndex = 0; // Figure out if the current focus in the DOM is set on a Tab
                // If it is we should keep the focus on the next selected tab
                var wasTabFocused = false;
                if (canUseActiveElement == null) determineCanUseActiveElement(environment);
                if (canUseActiveElement) wasTabFocused = (0, _reactDefault.default).Children.toArray(child.props.children).filter((0, _elementTypes.isTab)).some(function(tab, i) {
                    var env = environment || (typeof window !== "undefined" ? window : undefined);
                    return env && env.document.activeElement === _this2.getTab(i);
                });
                result = /*#__PURE__*/ (0, _react.cloneElement)(child, {
                    children: (0, _childrenDeepMap.deepMap)(child.props.children, function(tab) {
                        var key = "tabs-" + listIndex;
                        var selected = selectedIndex === listIndex;
                        var props = {
                            tabRef: function tabRef(node) {
                                _this2.tabNodes[key] = node;
                            },
                            id: _this2.tabIds[listIndex],
                            panelId: _this2.panelIds[listIndex],
                            selected: selected,
                            focus: selected && (focus || wasTabFocused)
                        };
                        if (selectedTabClassName) props.selectedClassName = selectedTabClassName;
                        if (disabledTabClassName) props.disabledClassName = disabledTabClassName;
                        listIndex++;
                        return /*#__PURE__*/ (0, _react.cloneElement)(tab, props);
                    })
                });
            } else if ((0, _elementTypes.isTabPanel)(child)) {
                var props = {
                    id: _this2.panelIds[index],
                    tabId: _this2.tabIds[index],
                    selected: selectedIndex === index
                };
                if (forceRenderTabPanel) props.forceRender = forceRenderTabPanel;
                if (selectedTabPanelClassName) props.selectedClassName = selectedTabPanelClassName;
                index++;
                result = /*#__PURE__*/ (0, _react.cloneElement)(child, props);
            }
            return result;
        });
    };
    /**
   * Determine if a node from event.target is a Tab element for the current Tabs container.
   * If the clicked element is not a Tab, it returns false.
   * If it finds another Tabs container between the Tab and `this`, it returns false.
   */ _proto.isTabFromContainer = function isTabFromContainer(node) {
        // return immediately if the clicked element is not a Tab.
        if (!isTabNode(node)) return false;
         // Check if the first occurrence of a Tabs container is `this` one.
        var nodeAncestor = node.parentElement;
        do {
            if (nodeAncestor === this.node) return true;
            if (nodeAncestor.getAttribute("data-rttabs")) break;
            nodeAncestor = nodeAncestor.parentElement;
        }while (nodeAncestor);
        return false;
    };
    _proto.render = function render() {
        var _this3 = this;
        // Delete all known props, so they don't get added to DOM
        var _this$props4 = this.props, children = _this$props4.children, className = _this$props4.className, disabledTabClassName = _this$props4.disabledTabClassName, domRef = _this$props4.domRef, focus = _this$props4.focus, forceRenderTabPanel = _this$props4.forceRenderTabPanel, onSelect = _this$props4.onSelect, selectedIndex = _this$props4.selectedIndex, selectedTabClassName = _this$props4.selectedTabClassName, selectedTabPanelClassName = _this$props4.selectedTabPanelClassName, environment = _this$props4.environment, disableUpDownKeys = _this$props4.disableUpDownKeys, attributes = _objectWithoutPropertiesLoose(_this$props4, _excluded);
        return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", _extends({}, attributes, {
            className: (0, _clsxDefault.default)(className),
            onClick: this.handleClick,
            onKeyDown: this.handleKeyDown,
            ref: function ref(node) {
                _this3.node = node;
                if (domRef) domRef(node);
            },
            "data-rttabs": true
        }), this.getChildren());
    };
    return UncontrolledTabs;
}((0, _react.Component));
UncontrolledTabs.defaultProps = {
    className: "react-tabs",
    focus: false
};
UncontrolledTabs.propTypes = {};

},{"prop-types":"6FKs7","react":"6uln9","clsx":"apzFw","../helpers/uuid":"be67v","../helpers/propTypes":"kwq5c","../helpers/count":"2I2ic","../helpers/childrenDeepMap":"bGO9j","../helpers/elementTypes":"2TXJx","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"apzFw":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "clsx", ()=>clsx);
function r(e) {
    var t, f, n = "";
    if ("string" == typeof e || "number" == typeof e) n += e;
    else if ("object" == typeof e) {
        if (Array.isArray(e)) for(t = 0; t < e.length; t++)e[t] && (f = r(e[t])) && (n && (n += " "), n += f);
        else for(t in e)e[t] && (n && (n += " "), n += t);
    }
    return n;
}
function clsx() {
    for(var e, t, f = 0, n = ""; f < arguments.length;)(e = arguments[f++]) && (t = r(e)) && (n && (n += " "), n += t);
    return n;
}
exports.default = clsx;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"be67v":[function(require,module,exports) {
// Get a universally unique identifier
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>uuid);
parcelHelpers.export(exports, "reset", ()=>reset);
var count = 0;
function uuid() {
    return "react-tabs-" + count++;
}
function reset() {
    count = 0;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2I2ic":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getTabsCount", ()=>getTabsCount);
parcelHelpers.export(exports, "getPanelsCount", ()=>getPanelsCount);
var _childrenDeepMap = require("./childrenDeepMap");
var _elementTypes = require("./elementTypes");
function getTabsCount(children) {
    var tabCount = 0;
    (0, _childrenDeepMap.deepForEach)(children, function(child) {
        if ((0, _elementTypes.isTab)(child)) tabCount++;
    });
    return tabCount;
}
function getPanelsCount(children) {
    var panelCount = 0;
    (0, _childrenDeepMap.deepForEach)(children, function(child) {
        if ((0, _elementTypes.isTabPanel)(child)) panelCount++;
    });
    return panelCount;
}

},{"./childrenDeepMap":"bGO9j","./elementTypes":"2TXJx","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1BkB0":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>TabList);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _excluded = [
    "children",
    "className"
];
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
var TabList = /*#__PURE__*/ function(_Component) {
    _inheritsLoose(TabList, _Component);
    function TabList() {
        return _Component.apply(this, arguments) || this;
    }
    var _proto = TabList.prototype;
    _proto.render = function render() {
        var _this$props = this.props, children = _this$props.children, className = _this$props.className, attributes = _objectWithoutPropertiesLoose(_this$props, _excluded);
        return /*#__PURE__*/ (0, _reactDefault.default).createElement("ul", _extends({}, attributes, {
            className: (0, _clsxDefault.default)(className),
            role: "tablist"
        }), children);
    };
    return TabList;
}((0, _react.Component));
TabList.defaultProps = {
    className: "react-tabs__tab-list"
};
TabList.propTypes = {};
TabList.tabsRole = "TabList";

},{"prop-types":"6FKs7","react":"6uln9","clsx":"apzFw","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"k2KUn":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Tab);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _excluded = [
    "children",
    "className",
    "disabled",
    "disabledClassName",
    "focus",
    "id",
    "panelId",
    "selected",
    "selectedClassName",
    "tabIndex",
    "tabRef"
];
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
var DEFAULT_CLASS = "react-tabs__tab";
var Tab = /*#__PURE__*/ function(_Component) {
    _inheritsLoose(Tab, _Component);
    function Tab() {
        return _Component.apply(this, arguments) || this;
    }
    var _proto = Tab.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.checkFocus();
    };
    _proto.componentDidUpdate = function componentDidUpdate() {
        this.checkFocus();
    };
    _proto.checkFocus = function checkFocus() {
        var _this$props = this.props, selected = _this$props.selected, focus = _this$props.focus;
        if (selected && focus) this.node.focus();
    };
    _proto.render = function render() {
        var _cx, _this = this;
        var _this$props2 = this.props, children = _this$props2.children, className = _this$props2.className, disabled = _this$props2.disabled, disabledClassName = _this$props2.disabledClassName, focus = _this$props2.focus, id = _this$props2.id, panelId = _this$props2.panelId, selected = _this$props2.selected, selectedClassName = _this$props2.selectedClassName, tabIndex = _this$props2.tabIndex, tabRef = _this$props2.tabRef, attributes = _objectWithoutPropertiesLoose(_this$props2, _excluded);
        return /*#__PURE__*/ (0, _reactDefault.default).createElement("li", _extends({}, attributes, {
            className: (0, _clsxDefault.default)(className, (_cx = {}, _cx[selectedClassName] = selected, _cx[disabledClassName] = disabled, _cx)),
            ref: function ref(node) {
                _this.node = node;
                if (tabRef) tabRef(node);
            },
            role: "tab",
            id: id,
            "aria-selected": selected ? "true" : "false",
            "aria-disabled": disabled ? "true" : "false",
            "aria-controls": panelId,
            tabIndex: tabIndex || (selected ? "0" : null),
            "data-rttab": true
        }), children);
    };
    return Tab;
}((0, _react.Component));
Tab.defaultProps = {
    className: DEFAULT_CLASS,
    disabledClassName: DEFAULT_CLASS + "--disabled",
    focus: false,
    id: null,
    panelId: null,
    selected: false,
    selectedClassName: DEFAULT_CLASS + "--selected"
};
Tab.propTypes = {};
Tab.tabsRole = "Tab";

},{"prop-types":"6FKs7","react":"6uln9","clsx":"apzFw","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"bc3OB":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>TabPanel);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _excluded = [
    "children",
    "className",
    "forceRender",
    "id",
    "selected",
    "selectedClassName",
    "tabId"
];
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
var DEFAULT_CLASS = "react-tabs__tab-panel";
var TabPanel = /*#__PURE__*/ function(_Component) {
    _inheritsLoose(TabPanel, _Component);
    function TabPanel() {
        return _Component.apply(this, arguments) || this;
    }
    var _proto = TabPanel.prototype;
    _proto.render = function render() {
        var _cx;
        var _this$props = this.props, children = _this$props.children, className = _this$props.className, forceRender = _this$props.forceRender, id = _this$props.id, selected = _this$props.selected, selectedClassName = _this$props.selectedClassName, tabId = _this$props.tabId, attributes = _objectWithoutPropertiesLoose(_this$props, _excluded);
        return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", _extends({}, attributes, {
            className: (0, _clsxDefault.default)(className, (_cx = {}, _cx[selectedClassName] = selected, _cx)),
            role: "tabpanel",
            id: id,
            "aria-labelledby": tabId
        }), forceRender || selected ? children : null);
    };
    return TabPanel;
}((0, _react.Component));
TabPanel.defaultProps = {
    className: DEFAULT_CLASS,
    forceRender: false,
    selectedClassName: DEFAULT_CLASS + "--selected"
};
TabPanel.propTypes = {};
TabPanel.tabsRole = "TabPanel";

},{"prop-types":"6FKs7","react":"6uln9","clsx":"apzFw","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7FEZc":[function(require,module,exports) {
module.exports = require("b126b439f324d755").getBundleURL("kVLro") + require("cb7a9138d689306d").resolve("la05P");

},{"b126b439f324d755":"c7Tr5","cb7a9138d689306d":"fyJL2"}],"ePx7g":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const bodyStyle = /*#__PURE__*/ (0, _css.css)({
    name: "xxaguh",
    styles: "padding:32px 0"
});
const TabPanelBody = (props)=>(0, _react.jsx)("div", {
        className: bodyStyle + " " + props.className
    }, props.children);
exports.default = TabPanelBody;

},{"@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7vD5Q":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _formik = require("formik");
var _yup = require("yup");
var _textField = require("../../../components/forms/TextField");
var _textFieldDefault = parcelHelpers.interopDefault(_textField);
var _button = require("../../../components/general/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _pageError = require("../../../components/general/PageError");
var _pageErrorDefault = parcelHelpers.interopDefault(_pageError);
var _termsContainer = require("../../../hooks/TermsContainer");
var _termsContainerDefault = parcelHelpers.interopDefault(_termsContainer);
var _breakpoints = require("../../../constants/breakpoints");
var _termsCondition = require("./TermsCondition");
var _termsConditionDefault = parcelHelpers.interopDefault(_termsCondition);
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const expandIcon = require("ffdd44305c93e6ba");
const InnerForm = ({ handleSubmit, isSubmitting, values, handleChange, handleBlur, stateContainer, authContainer })=>{
    const termsHook = (0, _termsContainerDefault.default).useContainer();
    (0, _react1.useEffect)(()=>{
        termsHook.loadLatestTerm();
    }, []);
    return (0, _react.jsx)("div", null, (0, _react.jsx)("form", {
        onSubmit: handleSubmit
    }, (0, _react.jsx)("div", null, (0, _react.jsx)((0, _textFieldDefault.default), {
        name: "firstName",
        value: values.firstName,
        label: "First Name",
        placeholder: "What name do you go by?",
        onChange: handleChange,
        onBlur: handleBlur,
        disabled: isSubmitting,
        className: textFieldStyle
    }), (0, _react.jsx)((0, _textFieldDefault.default), {
        name: "lastName",
        value: values.lastName,
        label: "Last Name",
        placeholder: "What's your family name?",
        onChange: handleChange,
        onBlur: handleBlur,
        disabled: isSubmitting,
        className: textFieldStyle
    }), (0, _react.jsx)((0, _textFieldDefault.default), {
        name: "email",
        value: values.email,
        label: "Email",
        placeholder: "Enter the email the invitation was sent to",
        onChange: handleChange,
        onBlur: handleBlur,
        disabled: isSubmitting,
        className: textFieldStyle
    }), (0, _react.jsx)((0, _termsConditionDefault.default), {
        handleChange: handleChange,
        isSubmitting: isSubmitting,
        handleBlur: handleBlur,
        termsAgreed: values.termsAgreed
    })), (0, _react.jsx)((0, _buttonDefault.default), {
        themes: [
            "primary",
            "wide"
        ],
        type: "submit",
        disabled: isSubmitting,
        text: "Continue",
        additionalClasses: buttonSplitStyle
    })), (0, _react.jsx)((0, _pageErrorDefault.default), {
        errors: [
            ...stateContainer.state.errors,
            ...authContainer.state.errors
        ]
    }));
};
const RegisterForm = (0, _formik.withFormik)({
    mapPropsToValues: (props)=>({
            firstName: "",
            lastName: "",
            email: "",
            termsAgreed: false
        }),
    validationSchema: _yup.object().shape({
        firstName: _yup.string().required("You must enter your first name"),
        lastName: _yup.string().required("You must enter your last name"),
        email: _yup.string().email("Must be a valid email").required("You must enter your email"),
        termsAgreed: _yup.bool().oneOf([
            true
        ], "You must agree to the Terms & Conditions")
    }),
    handleSubmit: async (values, { props, setSubmitting })=>{
        setSubmitting(true);
        if (props.invitationCode === undefined || props.invitationCode === null || props.invitationCode === "") {
            props.authContainer.addError("Invalid invitation code");
            setSubmitting(false);
            return;
        }
        const result = await props.stateContainer.checkIfUserUsesSso(values.email);
        if (result.data) {
            //this user uses sso                    
            const ssoRequest = {
                email: values.email,
                loginCompleteUrl: `${window.location.origin.toString()}/singleSignOnSignUpRedirect/${props.invitationCode}`,
                agreedToTerms: values.termsAgreed,
                firstName: values.firstName,
                lastName: values.lastName
            };
            await props.authContainer.beginSingleSignOnSignUp(ssoRequest);
            setSubmitting(false);
        } else {
            props.stateContainer.promptUserToCreatePassword(values.email, values.firstName, values.lastName, values.termsAgreed);
            setSubmitting(false);
        }
    }
})(InnerForm);
const textFieldStyle = /*#__PURE__*/ (0, _css.css)((0, _breakpoints.breakpoint_small), "{margin-bottom:14px;}", "");
const buttonSplitStyle = /*#__PURE__*/ (0, _css.css)({
    name: "1bt4s73",
    styles: "margin-bottom:-56px"
});
const termsContainer = /*#__PURE__*/ (0, _css.css)("border:solid 1px white;border-radius:8px;width:100%;height:100px;font-family:Muli;font-style:normal;font-stretch:normal;color:white;background:transparent;.row{display:flex;flex-direction:row;padding:20px;.titleText{padding-top:4px;color:white;padding-right:5px;}}.titleRow{font-size:16px;padding-bottom:0px;}.checkRow{font-size:14px;display:flex;flex-direction:row;justify-content:flex-start;}", (0, _breakpoints.breakpoint_small), "{padding:12px;.row{padding:0px;.titleText{padding-top:0px;}}}", "");
exports.default = RegisterForm;

},{"@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","formik":"3YnOK","yup":"j2SJU","../../../components/forms/TextField":"7a7bh","../../../components/general/Button":"6ymxN","../../../components/general/PageError":"ezFTm","../../../hooks/TermsContainer":"fiAWm","../../../constants/breakpoints":"2F01A","./TermsCondition":"25Cg3","ffdd44305c93e6ba":"j2acS","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"fiAWm":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _unstatedNext = require("unstated-next");
var _api = require("../api");
function useTermsContainer() {
    const [term, setTerm] = (0, _react.useState)([]);
    const [latestTerm, setLatestTerm] = (0, _react.useState)({
        id: "",
        url: ""
    });
    const [errors, setErrors] = (0, _react.useState)([]);
    const loadLatestTerm = async ()=>{
        try {
            const result = await _api.getLatestTerm();
            if (result.resultType == "Ok") setLatestTerm(result.data);
            else setErrors(result.errors);
            return result;
        } catch (e) {
            setErrors(e);
        }
    };
    const clearErrors = ()=>{
        setErrors([]);
    };
    return {
        term,
        setTerm,
        latestTerm,
        setLatestTerm,
        errors,
        setErrors,
        loadLatestTerm,
        clearErrors
    };
}
const TermsContainer = (0, _unstatedNext.createContainer)(useTermsContainer);
exports.default = TermsContainer;

},{"react":"6uln9","unstated-next":"61zE5","../api":"loxM6","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"61zE5":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createContainer", ()=>createContainer);
parcelHelpers.export(exports, "useContainer", ()=>useContainer);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
function createContainer(useHook) {
    var Context = (0, _reactDefault.default).createContext(null);
    function Provider(props) {
        var value = useHook(props.initialState);
        return (0, _reactDefault.default).createElement(Context.Provider, {
            value: value
        }, props.children);
    }
    function useContainer() {
        var value = (0, _reactDefault.default).useContext(Context);
        if (value === null) throw new Error("Component must be wrapped with <Container.Provider>");
        return value;
    }
    return {
        Provider: Provider,
        useContainer: useContainer
    };
}
function useContainer(container) {
    return container.useContainer();
}

},{"react":"6uln9","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"25Cg3":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _breakpoints = require("../../../constants/breakpoints");
var _termsContainer = require("../../../hooks/TermsContainer");
var _termsContainerDefault = parcelHelpers.interopDefault(_termsContainer);
var _checkboxField = require("../../../components/forms/CheckboxField");
var _checkboxFieldDefault = parcelHelpers.interopDefault(_checkboxField);
var _css = require("@emotion/css");
const expandIcon = require("342d6898a4eb26cf");
const TermsCondition = (props)=>{
    const termsHook = (0, _termsContainerDefault.default).useContainer();
    (0, _react1.useEffect)(()=>{
        termsHook.loadLatestTerm();
    }, []);
    return (0, _react.jsx)("div", {
        className: termsContainer
    }, (0, _react.jsx)("a", {
        target: "_blank",
        href: termsHook.latestTerm.url,
        className: `row titleRow`
    }, (0, _react.jsx)("span", {
        className: "titleText"
    }, `Terms & Conditions of use`), (0, _react.jsx)("img", {
        src: expandIcon
    })), (0, _react.jsx)("div", {
        className: `row checkRow`
    }, (0, _react.jsx)((0, _checkboxFieldDefault.default), {
        name: "termsAgreed",
        onChange: props.handleChange,
        onBlur: props.handleBlur,
        disabled: props.isSubmitting,
        checked: props.termsAgreed,
        required: true
    }), (0, _react.jsx)("span", {
        className: "acceptText"
    }, `I accept and agree to the terms and conditions`)));
};
const termsContainer = /*#__PURE__*/ (0, _css.css)("border:solid 1px white;border-radius:8px;width:100%;height:100px;font-family:Muli;font-style:normal;font-stretch:normal;color:white;background:transparent;.row{display:flex;flex-direction:row;padding:20px;.titleText{padding-top:4px;color:white;padding-right:5px;}}.titleRow{font-size:16px;padding-bottom:0px;}.checkRow{font-size:14px;display:flex;flex-direction:row;justify-content:flex-start;}", (0, _breakpoints.breakpoint_small), "{padding:12px;.row{padding:0px;.titleText{padding-top:0px;}}}", "");
exports.default = TermsCondition;

},{"@emotion/react":"djZKr","react":"6uln9","../../../constants/breakpoints":"2F01A","../../../hooks/TermsContainer":"fiAWm","../../../components/forms/CheckboxField":"3S5Oy","@emotion/css":"awUBr","342d6898a4eb26cf":"j2acS","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3S5Oy":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _fieldError = require("./FieldError");
var _fieldErrorDefault = parcelHelpers.interopDefault(_fieldError);
var _formik = require("formik");
var _iconTooltip = require("../general/IconTooltip");
var _iconTooltipDefault = parcelHelpers.interopDefault(_iconTooltip);
var _colors = require("../../constants/colors");
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
class CheckboxField extends (0, _reactDefault.default).Component {
    render() {
        const props = {
            ...this.props
        };
        return (0, _react.jsx)("div", null, (0, _react.jsx)("div", {
            className: `${containerStyle} ${props.className}`
        }, (0, _react.jsx)("label", {
            className: `${labelStyle} ${props?.labelStyle}`
        }, props.name ? (0, _react.jsx)((0, _formik.Field), {
            id: props.id,
            type: "checkbox",
            name: props.name,
            onChange: props.onChange,
            onBlur: props.onBlur,
            disabled: props.disabled,
            checked: props.checked,
            value: props.checked
        }) : (0, _react.jsx)("input", {
            id: props.id,
            type: "checkbox",
            name: props.name,
            onClick: props.onClick,
            onChange: props.onChange,
            onBlur: props.onBlur,
            disabled: props.disabled,
            checked: props.checked
        }), (0, _react.jsx)("span", {
            className: "checkmark"
        }), props.icon && (0, _react.jsx)("img", {
            src: props.icon
        }), (0, _react.jsx)("span", {
            className: "check-label"
        }, props.label)), props.labelExtension, props.tooltip && props.tooltip !== undefined ? (0, _react.jsx)((0, _iconTooltipDefault.default), {
            text: props.tooltip,
            className: `${props.tooltipStyle} tooltip ${tooltipStyle}`,
            place: props.tooltipPosition ? props.tooltipPosition : "top",
            replacementContentStyle: props.tooltipContentStyle && props.tooltipContentStyle
        }) : null), props.name && (0, _react.jsx)((0, _fieldErrorDefault.default), {
            name: props.name
        }));
    }
}
const containerStyle = /*#__PURE__*/ (0, _css.css)({
    name: "ho1qnd",
    styles: "display:flex;flex-direction:row"
});
const tooltipStyle = /*#__PURE__*/ (0, _css.css)({
    name: "3xaa4j",
    styles: "margin:0;margin-top:24px;margin-bottom:0"
});
const labelStyle = /*#__PURE__*/ (0, _css.css)("font-family:Muli;font-size:14px;font-weight:600;text-align:left;user-select:none;cursor:pointer;display:block;position:relative;padding-left:36px;margin-bottom:24px;line-height:22px;>img{margin-right:8px;}input{position:absolute;opacity:0;cursor:pointer;}.checkmark{position:absolute;top:0;left:0;width:20px;height:20px;border-radius:5px;background-color:#ffffff;border:solid 1px #cccccc;margin-right:16px;}&:hover input~.checkmark{background-color:", (0, _colors.color_variants_ocean_light_opaque), ";}input:checked~.checkmark{background:", (0, _colors.primary_gradient), ";}input:disabled~.checkmark{background:", (0, _colors.pale_grey), ';}.checkmark:after{content:"";position:absolute;display:none;}input:checked~.checkmark:after{display:block;}.checkmark:after{left:6px;top:2px;width:5px;height:10px;border:solid white;border-width:0 3px 3px 0;-webkit-transform:rotate(45deg);-ms-transform:rotate(45deg);transform:rotate(45deg);}', "");
exports.default = CheckboxField;

},{"@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","./FieldError":"fDxhz","formik":"3YnOK","../general/IconTooltip":"3FODC","../../constants/colors":"1p3OR","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"j2acS":[function(require,module,exports) {
module.exports = require("a8fcbf44268796a9").getBundleURL("kVLro") + require("65322936417df7ac").resolve("5DJPr");

},{"a8fcbf44268796a9":"c7Tr5","65322936417df7ac":"fyJL2"}],"jDrDR":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _defineProperty = require("@babel/runtime/helpers/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _unstated = require("unstated");
var _api = require("../../api");
class UserContainer extends (0, _unstated.Container) {
    constructor(...args){
        super(...args);
        // default state
        (0, _definePropertyDefault.default)(this, "state", {
            currentUser: null,
            currentUserTermsAgreement: {
                latestTerm: {
                    url: "",
                    id: ""
                },
                userTerms: [],
                hasAgreedToLatest: true
            },
            isLoading: false,
            errors: [],
            isResetRequestSent: false,
            isSetPasswordSent: false,
            userRegistrationInformation: {
                firstName: "",
                lastName: "",
                email: "",
                termsAgreed: false,
                enteringPassword: false
            }
        });
    }
    signUp(model) {
        this.setLoading(true);
        var promise = _api.createUser(model);
        promise.then((result)=>{
            if (result.resultType == "Ok") this.setState({
                ...this.state,
                currentUser: result.data,
                isLoading: false,
                userRegistrationInformation: {
                    firstName: "",
                    lastName: "",
                    email: "",
                    termsAgreed: false,
                    enteringPassword: false
                },
                errors: []
            });
            else this.setState({
                ...this.state,
                errors: result.errors,
                isLoading: false
            });
        }).catch((error)=>{
            this.setState({
                ...this.state,
                errors: [
                    error
                ],
                isLoading: false
            });
        });
        return promise;
    }
    checkIfUserUsesSso(email) {
        var promise = _api.checkIfUserUsesSso(email);
        promise.then((result)=>{
            if (result.resultType == "Ok") this.setState({
                ...this.state,
                isLoading: false,
                errors: []
            });
            else this.setState({
                ...this.state,
                errors: result.errors,
                isLoading: false
            });
        }).catch((error)=>{
            this.setState({
                ...this.state,
                errors: [
                    error
                ],
                isLoading: false
            });
        });
        return promise;
    }
    promptUserToCreatePassword(email, firstName, lastName, termsAgreed) {
        this.setState({
            ...this.state,
            userRegistrationInformation: {
                firstName: firstName,
                lastName: lastName,
                email: email,
                termsAgreed: termsAgreed,
                enteringPassword: true
            }
        });
    }
    acceptInvitation(invitationCode) {
        var promise = _api.acceptInvitation(invitationCode);
        promise.then((result)=>{
            if (result.resultType == "Ok") this.setState({
                ...this.state,
                isLoading: false,
                errors: []
            });
            else this.setState({
                ...this.state,
                errors: result.errors,
                isLoading: false
            });
        }).catch((error)=>{
            this.setState({
                ...this.state,
                errors: [
                    error
                ],
                isLoading: false
            });
        });
        return promise;
    }
    resetPassword(email) {
        this.setLoading(true);
        var promise = _api.requestPasswordReset({
            email: email
        });
        promise.then((result)=>{
            if (result.resultType == "Ok") this.setState({
                ...this.state,
                isResetRequestSent: true,
                isLoading: false
            });
            else this.setState({
                ...this.state,
                isLoading: false
            });
        }).catch((error)=>{
            this.setState({
                ...this.state,
                isLoading: false,
                errors: [
                    error
                ]
            });
        });
        return promise;
    }
    setPassword(request) {
        this.setLoading(true);
        var promise = _api.setPassword(request);
        promise.then((result)=>{
            if (result.resultType == "Ok") this.setState({
                ...this.state,
                isSetPasswordSent: true,
                isLoading: false
            });
            else this.setState({
                ...this.state,
                isLoading: false
            });
        }).catch((error)=>{
            this.setState({
                ...this.state,
                isLoading: false,
                errors: [
                    error
                ]
            });
        });
        return promise;
    }
    getCurrentUserTermsAgreement() {
        this.setState({
            ...this.state,
            isLoading: true
        });
        var promise = _api.getCurrentUserTermsAgreement();
        promise.then((result)=>{
            if (result.resultType == "Ok") this.setState({
                ...this.state,
                currentUserTermsAgreement: result.data,
                isLoading: false
            });
            else this.setState({
                ...this.state,
                isLoading: false
            });
        });
        return promise;
    }
    updateUserImage(imageFile) {
        this.setLoading(true);
        var promise = _api.updateProfileImage(imageFile);
        promise.then((imageResult)=>{
            if (imageResult.resultType == "Ok") this.setState({
                ...this.state,
                errors: [],
                currentUser: imageResult.data,
                isLoading: false
            });
            else this.setState({
                ...this.state,
                errors: imageResult.errors,
                isLoading: false
            });
        }).catch((error)=>{
            this.setState({
                ...this.state,
                errors: [
                    error
                ],
                isLoading: false
            });
        });
        return promise;
    }
    changeUserPassword(request) {
        this.setLoading(true);
        var promise = _api.changePassword(request);
        promise.then((imageResult)=>{
            if (imageResult.resultType == "Ok") this.setState({
                ...this.state,
                errors: [],
                isLoading: false
            });
            else this.setState({
                ...this.state,
                errors: imageResult.errors,
                isLoading: false
            });
        }).catch((error)=>{
            this.setState({
                ...this.state,
                errors: [
                    error
                ],
                isLoading: false
            });
        });
        return promise;
    }
    updateUserDetails(model, imageFile) {
        this.setLoading(true);
        var promise = _api.updateUserDetails(model);
        promise.then((result)=>{
            if (result.resultType == "Ok") {
                if (imageFile) _api.updateProfileImage(imageFile).then((imageResult)=>{
                    if (result.resultType == "Ok") this.setState({
                        ...this.state,
                        errors: [],
                        currentUser: imageResult.data,
                        isLoading: false
                    });
                    else this.setState({
                        ...this.state,
                        errors: result.errors,
                        isLoading: false
                    });
                }).catch((error)=>{
                    this.setState({
                        ...this.state,
                        errors: [
                            error
                        ],
                        isLoading: false
                    });
                });
                else this.setState({
                    ...this.state,
                    errors: [],
                    currentUser: result.data,
                    isLoading: false
                });
            } else this.setState({
                ...this.state,
                errors: result.errors,
                isLoading: false
            });
        }).catch((error)=>{
            this.setState({
                ...this.state,
                errors: [
                    error
                ],
                isLoading: false
            });
        });
        return promise;
    }
    resetPasswordResetRequest() {
        this.setState({
            ...this.state,
            isResetRequestSent: false
        });
    }
    clearErrors() {
        this.setState({
            ...this.state,
            errors: []
        });
    }
    resetPasswordSetRequest() {
        this.setState({
            ...this.state,
            isSetPasswordSent: false
        });
    }
    async getUser() {
        try {
            var result = await _api.getCurrentUser();
            if (result.resultType == "Ok") this.setState({
                ...this.state,
                currentUser: result.data
            });
            return result;
        } catch (e) {
            console.log(e);
        }
    }
    addUserTermAgreement(termId) {
        this.setState({
            ...this.state,
            isLoading: true
        });
        const promise = _api.createUserTerm({
            termId: termId,
            agreed: true
        });
        promise.then((result)=>{
            if (result.resultType == "Ok") {
                this.setState({
                    ...this.state,
                    isLoading: false
                });
                this.getCurrentUserTermsAgreement();
            } else this.setState({
                ...this.state,
                isLoading: false
            });
        });
        return promise;
    }
    setLoading(isLoading) {
        this.setState({
            ...this.state,
            isLoading: isLoading
        });
    }
}
exports.default = UserContainer;

},{"@babel/runtime/helpers/defineProperty":"9sJxO","unstated":"grh7p","../../api":"loxM6","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"l7sWG":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _base = require("@emotion/styled/base");
var _baseDefault = parcelHelpers.interopDefault(_base);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _breakpoints = require("../../constants/breakpoints");
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const logo = require("62e387be4a87f249");
const LandingContainer = (props)=>{
    return (0, _react.jsx)(LandingContainerWrapper, null, (0, _react.jsx)(LandingImage, {
        src: logo
    }), props.children);
};
const LandingImage = /*#__PURE__*/ (0, _baseDefault.default)("img", {
    target: "eufpw5b1"
})("width:300px;margin:42px 42px 42px 120px;", (0, _breakpoints.breakpoint_small), "{width:150px;margin:32px 42px;}");
const LandingContainerWrapper = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "eufpw5b0"
})({
    name: "1k9qr1t",
    styles: "display:flex;flex-direction:column;background:linear-gradient(to bottom, #f7f7f7, #eef0f1);max-height:100vh"
});
exports.default = LandingContainer;

},{"@emotion/styled/base":"lSuFu","@emotion/react":"djZKr","react":"6uln9","../../constants/breakpoints":"2F01A","62e387be4a87f249":"8bozS","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8bozS":[function(require,module,exports) {
module.exports = require("81711af7dcb9f6fe").getBundleURL("kVLro") + require("7f8ca7beaaee5470").resolve("hhNwx");

},{"81711af7dcb9f6fe":"c7Tr5","7f8ca7beaaee5470":"fyJL2"}],"1cD0x":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _formik = require("formik");
var _yup = require("yup");
var _textField = require("../../../components/forms/TextField");
var _textFieldDefault = parcelHelpers.interopDefault(_textField);
var _button = require("../../../components/general/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _pageError = require("../../../components/general/PageError");
var _pageErrorDefault = parcelHelpers.interopDefault(_pageError);
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const InnerForm = ({ handleSubmit, isSubmitting, values, handleChange, handleBlur, stateContainer })=>(0, _react.jsx)("div", null, (0, _react.jsx)("form", {
        onSubmit: handleSubmit
    }, (0, _react.jsx)("div", {
        className: explanation
    }, (0, _react.jsx)("div", {
        className: `row`
    }, (0, _react.jsx)("span", {
        className: "text"
    }, `Use Single Sign On if it has been configured for your organization.`))), (0, _react.jsx)((0, _textFieldDefault.default), {
        disabled: isSubmitting,
        name: "email",
        value: values.email,
        label: "Email",
        placeholder: "Enter the email associated with your account",
        onChange: handleChange,
        onBlur: handleBlur
    }), (0, _react.jsx)((0, _buttonDefault.default), {
        themes: [
            "primary",
            "wide"
        ],
        type: "submit",
        loading: isSubmitting,
        disabled: isSubmitting,
        text: "Let's Go!",
        additionalClasses: buttonSplitStyle
    })), (0, _react.jsx)((0, _pageErrorDefault.default), {
        errors: stateContainer.state.errors
    }));
const SingleSignOnForm = (0, _formik.withFormik)({
    mapPropsToValues: (props)=>({
            email: ""
        }),
    validationSchema: _yup.object().shape({
        email: _yup.string().email("Must be a valid email").required("You must enter your email")
    }),
    handleSubmit: async (values, { props, setSubmitting })=>{
        setSubmitting(true);
        const ssoRequest = {
            email: values.email,
            loginCompleteUrl: `${window.location.origin.toString()}/singleSignOnRedirect${props.invitationCode == null ? "" : `/${props.invitationCode}`}`
        };
        await props.stateContainer.beginSingleSignOnSignIn(ssoRequest);
        setSubmitting(false);
    }
})(InnerForm);
const buttonSplitStyle = /*#__PURE__*/ (0, _css.css)({
    name: "i0nzy7",
    styles: "margin-bottom:-56px;margin-top:72px"
});
const explanation = /*#__PURE__*/ (0, _css.css)({
    name: "yk9xoi",
    styles: "border:solid 1px white;border-radius:8px;width:100%;height:100px;font-family:Muli;font-style:normal;font-stretch:normal;color:white;background:transparent;margin-bottom:16px;.row{display:flex;flex-direction:row;padding:15px;font-size:16px;.text{color:white;padding-right:5px;}}"
});
exports.default = SingleSignOnForm;

},{"@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","formik":"3YnOK","yup":"j2SJU","../../../components/forms/TextField":"7a7bh","../../../components/general/Button":"6ymxN","../../../components/general/PageError":"ezFTm","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"kSoKM":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _formik = require("formik");
var _yup = require("yup");
var _textField = require("../../../components/forms/TextField");
var _textFieldDefault = parcelHelpers.interopDefault(_textField);
var _button = require("../../../components/general/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _pageError = require("../../../components/general/PageError");
var _pageErrorDefault = parcelHelpers.interopDefault(_pageError);
var _termsCondition = require("./TermsCondition");
var _termsConditionDefault = parcelHelpers.interopDefault(_termsCondition);
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const InnerForm = ({ handleSubmit, isSubmitting, values, handleChange, handleBlur, stateContainer, authContainer })=>{
    const isFirstTime = window.location.pathname.includes("firstTime");
    return (0, _react.jsx)("div", null, (0, _react.jsx)("form", {
        onSubmit: handleSubmit
    }, (0, _react.jsx)((0, _textFieldDefault.default), {
        name: "password",
        type: "password",
        value: values.password,
        label: "Password",
        placeholder: "It's a secret to everybody",
        onChange: handleChange,
        onBlur: handleBlur,
        disabled: isSubmitting
    }), (0, _react.jsx)((0, _textFieldDefault.default), {
        name: "confirmPassword",
        type: "password",
        value: values.confirmPassword,
        label: "Confirm Password",
        placeholder: "One more time",
        onChange: handleChange,
        onBlur: handleBlur,
        disabled: isSubmitting
    }), isFirstTime && (0, _react.jsx)((0, _termsConditionDefault.default), {
        handleChange: handleChange,
        isSubmitting: isSubmitting,
        handleBlur: handleBlur,
        termsAgreed: values.termsAgreed
    }), (0, _react.jsx)((0, _buttonDefault.default), {
        themes: [
            "primary",
            "wide"
        ],
        type: "submit",
        disabled: isSubmitting,
        text: "Let's Go!",
        additionalClasses: buttonSplitStyle
    })), (0, _react.jsx)((0, _pageErrorDefault.default), {
        errors: [
            ...stateContainer.state.errors,
            ...authContainer.state.errors
        ]
    }));
};
const CreatePasswordForm = (0, _formik.withFormik)({
    mapPropsToValues: (props)=>({
            password: "",
            confirmPassword: "",
            termsAgreed: false
        }),
    validationSchema: _yup.object().shape({
        password: _yup.string().required("You must enter your password"),
        confirmPassword: _yup.string().required("You must confirm your password"),
        termsAgreed: window.location.pathname.includes("firstTime") ? _yup.bool().oneOf([
            true
        ], "You must agree to the Terms & Conditions") : _yup.bool().notRequired()
    }),
    handleSubmit: async (values, { props, setSubmitting })=>{
        const isFirstTime = window.location.pathname.includes("firstTime");
        if (props.invitationCode === undefined || props.invitationCode === null || props.invitationCode === "") {
            props.authContainer.addError("Invalid invitation code");
            setSubmitting(false);
            return;
        }
        const userState = props.stateContainer.state.userRegistrationInformation;
        const result = await props.stateContainer.signUp({
            firstName: isFirstTime ? props.firstName : userState.firstName,
            lastName: isFirstTime ? props.lastName : userState.lastName,
            email: isFirstTime ? props.email : userState.email,
            password: values.password,
            confirmPassword: values.confirmPassword,
            agreedToTerms: isFirstTime ? values.termsAgreed : userState.termsAgreed
        });
        setSubmitting(false);
        if (result.resultType == "Ok") {
            const authResult = await props.authContainer.signIn(isFirstTime ? props.email : userState.email, values.password);
            if (authResult.resultType == "Ok") props.stateContainer.acceptInvitation(props.invitationCode);
        }
    }
})(InnerForm);
const buttonSplitStyle = /*#__PURE__*/ (0, _css.css)({
    name: "1bt4s73",
    styles: "margin-bottom:-56px"
});
exports.default = CreatePasswordForm;

},{"@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","formik":"3YnOK","yup":"j2SJU","../../../components/forms/TextField":"7a7bh","../../../components/general/Button":"6ymxN","../../../components/general/PageError":"ezFTm","./TermsCondition":"25Cg3","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"5IqRY":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _reactRouterDom = require("react-router-dom");
var _authContainer = require("../../../../shared/state/containers/AuthContainer");
var _authContainerDefault = parcelHelpers.interopDefault(_authContainer);
var _unstated = require("unstated");
var _css = require("@emotion/css");
var _organizationContainer = require("../../../../shared/state/containers/OrganizationContainer");
var _organizationContainerDefault = parcelHelpers.interopDefault(_organizationContainer);
var _splash = require("../../../../shared/scenes/splash");
var _splashDefault = parcelHelpers.interopDefault(_splash);
var _createExitMessage = require("../../../../shared/scenes/createExitMessage");
var _createExitMessageDefault = parcelHelpers.interopDefault(_createExitMessage);
var _editExitMessage = require("../../../../shared/scenes/editExitMessage");
var _editExitMessageDefault = parcelHelpers.interopDefault(_editExitMessage);
var _createHelpMessage = require("../../../../shared/scenes/createHelpMessage");
var _createHelpMessageDefault = parcelHelpers.interopDefault(_createHelpMessage);
var _editHelpMessage = require("../../../../shared/scenes/editHelpMessage");
var _editHelpMessageDefault = parcelHelpers.interopDefault(_editHelpMessage);
var _organizationDashboard = require("../../../../shared/scenes/organizationDashboard");
var _organizationDashboardDefault = parcelHelpers.interopDefault(_organizationDashboard);
var _applicationDashboard = require("../../../../shared/scenes/applicationDashboard");
var _applicationDashboardDefault = parcelHelpers.interopDefault(_applicationDashboard);
var _createWelcomeMessage = require("../../../../shared/scenes/createWelcomeMessage");
var _createWelcomeMessageDefault = parcelHelpers.interopDefault(_createWelcomeMessage);
var _editWelcomeMessage = require("../../../../shared/scenes/editWelcomeMessage");
var _editWelcomeMessageDefault = parcelHelpers.interopDefault(_editWelcomeMessage);
var _createQuestionAnswer = require("../../../../shared/scenes/createQuestionAnswer");
var _createQuestionAnswerDefault = parcelHelpers.interopDefault(_createQuestionAnswer);
var _editQuestionAnswer = require("../../../../shared/scenes/editQuestionAnswer");
var _editQuestionAnswerDefault = parcelHelpers.interopDefault(_editQuestionAnswer);
var _createLatestMessage = require("../../../../shared/scenes/createLatestMessage");
var _createLatestMessageDefault = parcelHelpers.interopDefault(_createLatestMessage);
var _editLatestMessage = require("../../../../shared/scenes/editLatestMessage");
var _editLatestMessageDefault = parcelHelpers.interopDefault(_editLatestMessage);
var _logout = require("../../../../shared/scenes/logout");
var _logoutDefault = parcelHelpers.interopDefault(_logout);
var _createApplication = require("../../../../shared/scenes/createApplication");
var _createApplicationDefault = parcelHelpers.interopDefault(_createApplication);
var _applicationContainer = require("../../../../shared/state/containers/ApplicationContainer");
var _applicationContainerDefault = parcelHelpers.interopDefault(_applicationContainer);
var _organizationMemberInvite = require("../../../../shared/scenes/organizationMemberInvite");
var _organizationMemberInviteDefault = parcelHelpers.interopDefault(_organizationMemberInvite);
var _addApplicationMember = require("../../../../shared/scenes/addApplicationMember");
var _addApplicationMemberDefault = parcelHelpers.interopDefault(_addApplicationMember);
var _editFallbackMessage = require("../../../../shared/scenes/editFallbackMessage");
var _editFallbackMessageDefault = parcelHelpers.interopDefault(_editFallbackMessage);
var _createFallbackMessage = require("../../../../shared/scenes/createFallbackMessage");
var _createFallbackMessageDefault = parcelHelpers.interopDefault(_createFallbackMessage);
var _createNumberRange = require("../../../../shared/scenes/createNumberRange");
var _createNumberRangeDefault = parcelHelpers.interopDefault(_createNumberRange);
var _editNumberRange = require("../../../../shared/scenes/editNumberRange");
var _editNumberRangeDefault = parcelHelpers.interopDefault(_editNumberRange);
var _createSimpleChoice = require("../../../../shared/scenes/createSimpleChoice");
var _createSimpleChoiceDefault = parcelHelpers.interopDefault(_createSimpleChoice);
var _editSimpleChoices = require("../../../../shared/scenes/editSimpleChoices");
var _editSimpleChoicesDefault = parcelHelpers.interopDefault(_editSimpleChoices);
var _userContainer = require("../../../../shared/state/containers/UserContainer");
var _userContainerDefault = parcelHelpers.interopDefault(_userContainer);
var _createCustomRequest = require("../../../../shared/scenes/createCustomRequest");
var _createCustomRequestDefault = parcelHelpers.interopDefault(_createCustomRequest);
var _editCustomRequest = require("../../../../shared/scenes/editCustomRequest");
var _editCustomRequestDefault = parcelHelpers.interopDefault(_editCustomRequest);
var _featureContainer = require("../../../../shared/state/containers/FeatureContainer");
var _featureContainerDefault = parcelHelpers.interopDefault(_featureContainer);
var _urgentNotificationSplash = require("../../../../shared/components/general/UrgentNotificationSplash");
var _urgentNotificationSplashDefault = parcelHelpers.interopDefault(_urgentNotificationSplash);
var _createTemplateConfiguration = require("../../../../shared/scenes/createTemplateConfiguration");
var _createTemplateConfigurationDefault = parcelHelpers.interopDefault(_createTemplateConfiguration);
var _editTemplateConfiguration = require("../../../../shared/scenes/editTemplateConfiguration");
var _editTemplateConfigurationDefault = parcelHelpers.interopDefault(_editTemplateConfiguration);
var _applicationAppliedTemplateManager = require("../../../../shared/scenes/applicationAppliedTemplateManager");
var _applicationAppliedTemplateManagerDefault = parcelHelpers.interopDefault(_applicationAppliedTemplateManager);
var _newTermsModal = require("../../../../shared/components/general/NewTermsModal");
var _newTermsModalDefault = parcelHelpers.interopDefault(_newTermsModal);
var _loader = require("../../../../shared/components/general/Loader");
var _loaderDefault = parcelHelpers.interopDefault(_loader);
var _revenueContainer = require("../../../../shared/state/containers/RevenueContainer");
var _revenueContainerDefault = parcelHelpers.interopDefault(_revenueContainer);
var _revenue = require("../../../../shared/scenes/revenue");
var _revenueDefault = parcelHelpers.interopDefault(_revenue);
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const Dashboard = (props)=>(0, _react.jsx)((0, _unstated.Subscribe), {
        to: [
            (0, _authContainerDefault.default),
            (0, _userContainerDefault.default),
            (0, _organizationContainerDefault.default),
            (0, _applicationContainerDefault.default),
            (0, _featureContainerDefault.default),
            (0, _revenueContainerDefault.default)
        ]
    }, (auth, userContainer, orgs, appContainer, featureContainer, revenueContainer)=>{
        // if we are logged in, go to root
        if (auth.state.isAuthenticated !== true || auth.state.expirationDate === undefined) return (0, _react.jsx)((0, _reactRouterDom.Redirect), {
            to: "/login"
        });
        // Revenue page: needs auth but not org selection
        if (props.location.pathname.toLowerCase().includes("/revenue")) {
            // Ensure we have an access token before rendering (same pattern as InnerDashboard)
            if (auth.state.isAuthenticated && !auth.state.accessToken) {
                auth.refreshToken();
                return (0, _react.jsx)((0, _loaderDefault.default), null);
            }
            if (auth.state.accessToken == null) return (0, _react.jsx)((0, _loaderDefault.default), null);
            return (0, _react.jsx)((0, _revenueDefault.default), {
                userContainer: userContainer,
                organizationContainer: orgs,
                revenueContainer: revenueContainer,
                authContainer: auth
            });
        }
        // if we have no current org, go to orgs page
        if (orgs.state.currentOrganization === null || auth.state.expirationDate < new Date() || featureContainer.state.systemFeatures.length == 0) return (0, _react.jsx)((0, _splashDefault.default), {
            authContainer: auth,
            orgContainer: orgs,
            appContainer: appContainer,
            featureContainer: featureContainer
        });
        return (0, _react.jsx)(InnerDashboard, {
            authContainer: auth,
            userContainer: userContainer
        });
    });
const InnerDashboard = ({ userContainer, authContainer })=>{
    (0, _react1.useEffect)(()=>{
        if (authContainer.state.isAuthenticated && !authContainer.state.accessToken) authContainer.refreshToken();
    }, []);
    if (authContainer.state.accessToken == null) return (0, _react.jsx)((0, _loaderDefault.default), null);
    return (0, _react.jsx)("div", {
        className: wrapperStyle
    }, (0, _react.jsx)("div", {
        className: pageStyle
    }, (0, _react.jsx)("div", {
        className: containerStyle
    }, (0, _react.jsx)((0, _reactRouterDom.Route), {
        exact: true,
        path: [
            "/v/apps/:applicationId",
            "/v/apps/:applicationId/templates",
            "/v/apps/:applicationId/analytics",
            "/v/apps/:applicationId/analytics/track",
            "/v/apps/:applicationId/analytics/activity",
            "/v/apps/:applicationId/analytics/users",
            "/v/apps/:applicationId/analytics/misses",
            "/v/apps/:applicationId/analytics/report",
            "/v/apps/:applicationId/analytics/sessions",
            "/v/apps/:applicationId/analytics/live",
            "/v/apps/:applicationId/participants",
            "/v/apps/:applicationId/appSettings/interactionmodel",
            "/v/apps/:applicationId/appSettings/nlp",
            "/v/apps/:applicationId/appSettings/appInfo",
            "/v/apps/:applicationId/appSettings/nlp/entities",
            "/v/apps/:applicationId/appSettings/nlp/intents",
            "/v/apps/:applicationId/appSettings/nlp/menu",
            "/v/apps/:applicationId/appSettings/nlp/optiongroups",
            "/v/apps/:applicationId/appSettings/nlp/featureSettings",
            "/v/apps/:applicationId/appSettings/deployments",
            "/v/apps/:applicationId/appSettings/deployments/:environmentId",
            "/v/apps/:applicationId/appSettings",
            "/v/apps/:applicationId/simulator",
            "/v/apps/:applicationId/modules",
            "/v/apps/:applicationId/modules/discover",
            "/v/apps/:applicationId/webhooks/:webhookFolderId?",
            "/v/apps/:applicationId/webhooks/:webhookFolderId?",
            "/v/apps/:applicationId/content/:applicationFeatureId",
            "/v/:applicationFeatureId/welcomemessages/:contentItemId",
            "/v/:applicationFeatureId/welcomemessages",
            "/v/:applicationFeatureId/new/welcomemessage",
            "/v/:applicationFeatureId/exitmessages/:contentItemId",
            "/v/:applicationFeatureId/exitmessages",
            "/v/:applicationFeatureId/new/exitmessage",
            "/v/:applicationFeatureId/latestmessages/:contentItemId",
            "/v/:applicationFeatureId/latestmessages",
            "/v/:applicationFeatureId/new/latestmessage",
            "/v/:applicationFeatureId/helpmessages/:contentItemId",
            "/v/:applicationFeatureId/helpmessages",
            "/v/:applicationFeatureId/new/helpmessage",
            "/v/:applicationFeatureId/fallbackmessages/:contentItemId",
            "/v/:applicationFeatureId/fallbackmessages",
            "/v/:applicationFeatureId/new/fallbackmessage",
            "/v/:applicationFeatureId/faqs/:contentItemId",
            "/v/:applicationFeatureId/faqs",
            "/v/:applicationFeatureId/new/faq",
            "/v/:applicationFeatureId/numberranges/:contentItemId",
            "/v/:applicationFeatureId/numberranges",
            "/v/:applicationFeatureId/new/numberrange",
            "/v/:applicationFeatureId/simplechoices/:contentItemId",
            "/v/:applicationFeatureId/simplechoices",
            "/v/:applicationFeatureId/new/simplechoice",
            "/v/:applicationFeatureId/customRequests/:contentItemId",
            "/v/:applicationFeatureId/customRequests",
            "/v/:applicationFeatureId/new/customRequest",
            "/v/:applicationFeatureId/content/:contentItemId",
            "/v/:applicationFeatureId/content",
            "/v/:applicationFeatureId/new/content"
        ],
        component: (0, _applicationDashboardDefault.default)
    }), (0, _react.jsx)((0, _reactRouterDom.Route), {
        exact: true,
        path: [
            "/v/apps/:applicationId/templates/:appliedAppTemplateId",
            "/v/apps/:applicationId/modules/applied/:appliedAppTemplateId",
            "/v/apps/:applicationId/templates/new/:templateConfigurationId",
            "/v/apps/:applicationId/modules/:templateConfigurationId/details"
        ],
        component: (0, _applicationAppliedTemplateManagerDefault.default)
    }), (0, _react.jsx)((0, _reactRouterDom.Route), {
        exact: true,
        path: [
            "/v/apps/:applicationId/members/add"
        ],
        component: (0, _addApplicationMemberDefault.default)
    }), (0, _react.jsx)((0, _reactRouterDom.Route), {
        exact: true,
        path: "/v/members/invite",
        component: (0, _organizationMemberInviteDefault.default)
    }), (0, _react.jsx)((0, _reactRouterDom.Route), {
        exact: true,
        path: [
            "/v",
            "/",
            "/v/members",
            "/v/templates",
            "/v/modules",
            "/v/integrations",
            "/v/orgSettings/apiKeys",
            "/v/orgSettings/credentials",
            "/v/orgSettings/constants",
            "/v/orgSettings/management",
            "/v/orgSettings/responseVariables",
            "/v/orgSettings/emails",
            "/v/orgSettings",
            "/v/orgAnalytics",
            "/v/orgAnalytics/applicationsPerformance",
            "/v/orgAnalytics/ordering"
        ],
        component: (0, _organizationDashboardDefault.default)
    }))), (0, _react.jsx)((0, _reactRouterDom.Route), {
        path: "/v/:applicationFeatureId/new/welcomemessage",
        exact: true,
        component: (0, _createWelcomeMessageDefault.default)
    }), (0, _react.jsx)((0, _reactRouterDom.Route), {
        path: "/v/:applicationFeatureId/welcomemessages/:welcomeMessageId",
        component: (0, _editWelcomeMessageDefault.default)
    }), (0, _react.jsx)((0, _reactRouterDom.Route), {
        path: "/v/:applicationFeatureId/exitmessages/:exitMessageId",
        component: (0, _editExitMessageDefault.default)
    }), (0, _react.jsx)((0, _reactRouterDom.Route), {
        path: "/v/:applicationFeatureId/new/exitmessage",
        exact: true,
        component: (0, _createExitMessageDefault.default)
    }), (0, _react.jsx)((0, _reactRouterDom.Route), {
        path: "/v/:applicationFeatureId/new/faq",
        exact: true,
        component: (0, _createQuestionAnswerDefault.default)
    }), (0, _react.jsx)((0, _reactRouterDom.Route), {
        path: "/v/:applicationFeatureId/faqs/:questionAnswerId",
        component: (0, _editQuestionAnswerDefault.default)
    }), (0, _react.jsx)((0, _reactRouterDom.Route), {
        path: "/v/:applicationFeatureId/new/latestMessage",
        exact: true,
        component: (0, _createLatestMessageDefault.default)
    }), (0, _react.jsx)((0, _reactRouterDom.Route), {
        path: "/v/:applicationFeatureId/latestMessages/:latestMessageId",
        component: (0, _editLatestMessageDefault.default)
    }), (0, _react.jsx)((0, _reactRouterDom.Route), {
        path: "/v/:applicationFeatureId/helpmessages/:helpMessageId",
        component: (0, _editHelpMessageDefault.default)
    }), (0, _react.jsx)((0, _reactRouterDom.Route), {
        path: "/v/:applicationFeatureId/new/helpmessage",
        exact: true,
        component: (0, _createHelpMessageDefault.default)
    }), (0, _react.jsx)((0, _reactRouterDom.Route), {
        path: "/v/:applicationFeatureId/fallbackmessages/:fallbackMessageId",
        component: (0, _editFallbackMessageDefault.default)
    }), (0, _react.jsx)((0, _reactRouterDom.Route), {
        path: "/v/:applicationFeatureId/new/fallbackmessage",
        exact: true,
        component: (0, _createFallbackMessageDefault.default)
    }), (0, _react.jsx)((0, _reactRouterDom.Route), {
        path: "/v/:applicationFeatureId/new/numberRange",
        exact: true,
        component: (0, _createNumberRangeDefault.default)
    }), (0, _react.jsx)((0, _reactRouterDom.Route), {
        path: "/v/:applicationFeatureId/numberRanges/:numberRangeId",
        component: (0, _editNumberRangeDefault.default)
    }), (0, _react.jsx)((0, _reactRouterDom.Route), {
        path: "/v/:applicationFeatureId/new/simplechoice",
        exact: true,
        component: (0, _createSimpleChoiceDefault.default)
    }), (0, _react.jsx)((0, _reactRouterDom.Route), {
        path: "/v/:applicationFeatureId/simplechoices/:simpleChoiceId",
        component: (0, _editSimpleChoicesDefault.default)
    }), (0, _react.jsx)((0, _reactRouterDom.Route), {
        path: "/v/:applicationFeatureId/new/customRequest",
        exact: true,
        component: (0, _createCustomRequestDefault.default)
    }), (0, _react.jsx)((0, _reactRouterDom.Route), {
        path: "/v/:applicationFeatureId/customRequests/:customRequestId",
        component: (0, _editCustomRequestDefault.default)
    }), (0, _react.jsx)((0, _reactRouterDom.Route), {
        path: "/v/templates/add",
        exact: true,
        component: (0, _createTemplateConfigurationDefault.default)
    }), (0, _react.jsx)((0, _reactRouterDom.Route), {
        path: "/v/modules/add",
        exact: true,
        component: (0, _createTemplateConfigurationDefault.default)
    }), (0, _react.jsx)((0, _reactRouterDom.Route), {
        path: "/v/modules/edit/:templateConfigurationId",
        exact: true,
        component: (0, _editTemplateConfigurationDefault.default)
    }), (0, _react.jsx)((0, _reactRouterDom.Route), {
        path: "/v/templates/edit/:templateConfigurationId",
        exact: true,
        component: (0, _editTemplateConfigurationDefault.default)
    }), (0, _react.jsx)((0, _reactRouterDom.Route), {
        path: "/v/create-app",
        exact: true,
        component: (0, _createApplicationDefault.default)
    }), (0, _react.jsx)((0, _reactRouterDom.Route), {
        path: "/v/logout",
        exact: true,
        component: (0, _logoutDefault.default)
    }), (0, _react.jsx)((0, _newTermsModalDefault.default), {
        userContainer: userContainer
    }), (0, _react.jsx)((0, _urgentNotificationSplashDefault.default), null));
};
const containerStyle = /*#__PURE__*/ (0, _css.css)({
    name: "d191a9",
    styles: "display:flex;flex-direction:row;max-height:100%;height:100%"
});
const pageStyle = /*#__PURE__*/ (0, _css.css)({
    name: "e98zog",
    styles: "position:fixed;width:100%;height:100%"
});
const wrapperStyle = /*#__PURE__*/ (0, _css.css)({
    name: "13udsys",
    styles: "height:100%"
});
exports.default = Dashboard;

},{"@emotion/react":"djZKr","react":"6uln9","react-router-dom":"5fzqq","../../../../shared/state/containers/AuthContainer":"cl1Qb","unstated":"grh7p","@emotion/css":"awUBr","../../../../shared/state/containers/OrganizationContainer":"dlbaM","../../../../shared/scenes/splash":"5FUTj","../../../../shared/scenes/createExitMessage":"5bpnB","../../../../shared/scenes/editExitMessage":"d04fQ","../../../../shared/scenes/createHelpMessage":"9Jasv","../../../../shared/scenes/editHelpMessage":"akYlo","../../../../shared/scenes/organizationDashboard":"86aVV","../../../../shared/scenes/applicationDashboard":"hoUpc","../../../../shared/scenes/createWelcomeMessage":"eIVVi","../../../../shared/scenes/editWelcomeMessage":"kD2Qe","../../../../shared/scenes/createQuestionAnswer":"8pmaC","../../../../shared/scenes/editQuestionAnswer":"esFpB","../../../../shared/scenes/createLatestMessage":"cM4pL","../../../../shared/scenes/editLatestMessage":"13xUA","../../../../shared/scenes/logout":"i62o6","../../../../shared/scenes/createApplication":"hUj9o","../../../../shared/state/containers/ApplicationContainer":"cuqi2","../../../../shared/scenes/organizationMemberInvite":"e8QPP","../../../../shared/scenes/addApplicationMember":"f6vgJ","../../../../shared/scenes/editFallbackMessage":"2uweN","../../../../shared/scenes/createFallbackMessage":"lVVZ5","../../../../shared/scenes/createNumberRange":"7eaNQ","../../../../shared/scenes/editNumberRange":"awMS8","../../../../shared/scenes/createSimpleChoice":"cbJPs","../../../../shared/scenes/editSimpleChoices":"kCKmE","../../../../shared/state/containers/UserContainer":"jDrDR","../../../../shared/scenes/createCustomRequest":"knHb3","../../../../shared/scenes/editCustomRequest":"kLQP9","../../../../shared/state/containers/FeatureContainer":"4ApGg","../../../../shared/components/general/UrgentNotificationSplash":"c9NJd","../../../../shared/scenes/createTemplateConfiguration":"1pTCS","../../../../shared/scenes/editTemplateConfiguration":"2kSTD","../../../../shared/scenes/applicationAppliedTemplateManager":"ckPOn","../../../../shared/components/general/NewTermsModal":"abrun","../../../../shared/components/general/Loader":"bnV5T","../../../../shared/state/containers/RevenueContainer":"dPp6x","../../../../shared/scenes/revenue":"dISN2","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"dlbaM":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _defineProperty = require("@babel/runtime/helpers/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _unstated = require("unstated");
var _api = require("../../api");
var _lodash = require("lodash");
var _lodashDefault = parcelHelpers.interopDefault(_lodash);
class OrganizationContainer extends (0, _unstated.Container) {
    constructor(...args){
        super(...args);
        // default state
        (0, _definePropertyDefault.default)(this, "state", this.getInitialState());
    }
    getInitialState() {
        // check local storage for initial state
        const storedOrganization = localStorage.getItem("CURRENT_ORG");
        if (!!storedOrganization && storedOrganization !== "undefined") return {
            organizations: [],
            currentOrganization: JSON.parse(storedOrganization),
            isLoadingOrgs: false,
            isLoadingRoles: false,
            isUpdating: false,
            systemRoles: [],
            errors: []
        };
        return {
            organizations: [],
            currentOrganization: null,
            isLoadingOrgs: false,
            isLoadingRoles: false,
            isUpdating: false,
            systemRoles: [],
            errors: []
        };
    }
    getSystemRoles() {
        if (this.state.systemRoles.length > 0) return new Promise((resolve)=>resolve({
                resultType: "Ok",
                errors: [],
                data: this.state.systemRoles
            }));
        this.setState({
            ...this.state,
            isLoadingRoles: true
        });
        var promise = _api.getSystemUserRoles();
        promise.then((result)=>{
            if (result.resultType == "Ok") this.setState({
                ...this.state,
                isLoadingRoles: false,
                systemRoles: result.data
            });
            else this.setState({
                ...this.state,
                isLoadingRoles: false
            });
        }).catch((error)=>{
            this.setState({
                ...this.state,
                isLoadingRoles: false
            });
        });
        return promise;
    }
    async setCurrentOrgById(id) {
        if (id === null) {
            await this.setState({
                ...this.state,
                currentOrganization: null
            });
            return;
        }
        let matchingOrgs = this.state.organizations.filter((o)=>o.id === id);
        if (matchingOrgs.length < 1) try {
            const orgs = await this.getOrganizations();
            matchingOrgs = [
                orgs.data.find((o)=>o.id === id)
            ];
        } catch (error) {
            console.log(error);
            return;
        }
        localStorage.setItem("CURRENT_ORG", JSON.stringify(matchingOrgs[0]));
        await this.setState({
            ...this.state,
            currentOrganization: matchingOrgs[0],
            isUpdating: false
        });
    }
    async getOrganizations() {
        this.setLoading(true);
        const organizationsResult = await _api.getOrganizations();
        if (organizationsResult.resultType == "Ok") {
            await this.setState({
                ...this.state,
                errors: [],
                organizations: (0, _lodashDefault.default).sortBy(organizationsResult.data, (o)=>o.name),
                isLoadingOrgs: false
            });
            // check the loaded orgs. If we have just one, set it to current
            if (organizationsResult.data.length === 1) await this.setCurrentOrgById(organizationsResult.data[0].id);
        } else await this.setState({
            ...this.state,
            errors: organizationsResult.errors,
            isLoadingOrgs: false
        });
        return organizationsResult;
    }
    updateOrganizationInfo(model) {
        if (this.state.currentOrganization) {
            this.setState({
                ...this.state,
                isUpdating: true
            });
            const promise = _api.updateOrganizationInfo(this.state.currentOrganization.id, model).then((result)=>{
                if (result.resultType == "Ok") {
                    // update orgs list
                    var orgs = this.state.organizations;
                    if (orgs) {
                        var currentOrgIndex = this.state.organizations.findIndex((o)=>o.id == result.data.id);
                        if (currentOrgIndex > -1) {
                            orgs[currentOrgIndex] = result.data;
                            this.setState({
                                ...this.state,
                                organizations: orgs,
                                isUpdating: false,
                                errors: []
                            });
                        }
                    }
                    // update current org
                    if (this.state.currentOrganization.id == result.data.id) this.setCurrentOrgById(result.data.id);
                } else this.setState({
                    ...this.state,
                    isUpdating: false,
                    errors: result.errors
                });
            }).catch((error)=>{
                this.setState({
                    ...this.state,
                    isUpdating: false,
                    errors: [
                        error
                    ]
                });
            });
            return promise;
        }
    }
    clearErrors() {
        this.setState({
            ...this.state,
            errors: []
        });
    }
    setLoading(isLoading) {
        this.setState({
            ...this.state,
            isLoadingOrgs: isLoading
        });
    }
}
exports.default = OrganizationContainer;

},{"@babel/runtime/helpers/defineProperty":"9sJxO","unstated":"grh7p","../../api":"loxM6","lodash":"3hMBK","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3hMBK":[function(require,module,exports) {
var global = arguments[3];
(function() {
    /** Used as a safe reference for `undefined` in pre-ES5 environments. */ var undefined;
    /** Used as the semantic version number. */ var VERSION = "4.17.21";
    /** Used as the size to enable large array optimizations. */ var LARGE_ARRAY_SIZE = 200;
    /** Error message constants. */ var CORE_ERROR_TEXT = "Unsupported core-js use. Try https://npms.io/search?q=ponyfill.", FUNC_ERROR_TEXT = "Expected a function", INVALID_TEMPL_VAR_ERROR_TEXT = "Invalid `variable` option passed into `_.template`";
    /** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = "__lodash_hash_undefined__";
    /** Used as the maximum memoize cache size. */ var MAX_MEMOIZE_SIZE = 500;
    /** Used as the internal argument placeholder. */ var PLACEHOLDER = "__lodash_placeholder__";
    /** Used to compose bitmasks for cloning. */ var CLONE_DEEP_FLAG = 1, CLONE_FLAT_FLAG = 2, CLONE_SYMBOLS_FLAG = 4;
    /** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
    /** Used to compose bitmasks for function metadata. */ var WRAP_BIND_FLAG = 1, WRAP_BIND_KEY_FLAG = 2, WRAP_CURRY_BOUND_FLAG = 4, WRAP_CURRY_FLAG = 8, WRAP_CURRY_RIGHT_FLAG = 16, WRAP_PARTIAL_FLAG = 32, WRAP_PARTIAL_RIGHT_FLAG = 64, WRAP_ARY_FLAG = 128, WRAP_REARG_FLAG = 256, WRAP_FLIP_FLAG = 512;
    /** Used as default options for `_.truncate`. */ var DEFAULT_TRUNC_LENGTH = 30, DEFAULT_TRUNC_OMISSION = "...";
    /** Used to detect hot functions by number of calls within a span of milliseconds. */ var HOT_COUNT = 800, HOT_SPAN = 16;
    /** Used to indicate the type of lazy iteratees. */ var LAZY_FILTER_FLAG = 1, LAZY_MAP_FLAG = 2, LAZY_WHILE_FLAG = 3;
    /** Used as references for various `Number` constants. */ var INFINITY = 1 / 0, MAX_SAFE_INTEGER = 9007199254740991, MAX_INTEGER = 1.7976931348623157e+308, NAN = 0 / 0;
    /** Used as references for the maximum length and index of an array. */ var MAX_ARRAY_LENGTH = 4294967295, MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1, HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;
    /** Used to associate wrap methods with their bit flags. */ var wrapFlags = [
        [
            "ary",
            WRAP_ARY_FLAG
        ],
        [
            "bind",
            WRAP_BIND_FLAG
        ],
        [
            "bindKey",
            WRAP_BIND_KEY_FLAG
        ],
        [
            "curry",
            WRAP_CURRY_FLAG
        ],
        [
            "curryRight",
            WRAP_CURRY_RIGHT_FLAG
        ],
        [
            "flip",
            WRAP_FLIP_FLAG
        ],
        [
            "partial",
            WRAP_PARTIAL_FLAG
        ],
        [
            "partialRight",
            WRAP_PARTIAL_RIGHT_FLAG
        ],
        [
            "rearg",
            WRAP_REARG_FLAG
        ]
    ];
    /** `Object#toString` result references. */ var argsTag = "[object Arguments]", arrayTag = "[object Array]", asyncTag = "[object AsyncFunction]", boolTag = "[object Boolean]", dateTag = "[object Date]", domExcTag = "[object DOMException]", errorTag = "[object Error]", funcTag = "[object Function]", genTag = "[object GeneratorFunction]", mapTag = "[object Map]", numberTag = "[object Number]", nullTag = "[object Null]", objectTag = "[object Object]", promiseTag = "[object Promise]", proxyTag = "[object Proxy]", regexpTag = "[object RegExp]", setTag = "[object Set]", stringTag = "[object String]", symbolTag = "[object Symbol]", undefinedTag = "[object Undefined]", weakMapTag = "[object WeakMap]", weakSetTag = "[object WeakSet]";
    var arrayBufferTag = "[object ArrayBuffer]", dataViewTag = "[object DataView]", float32Tag = "[object Float32Array]", float64Tag = "[object Float64Array]", int8Tag = "[object Int8Array]", int16Tag = "[object Int16Array]", int32Tag = "[object Int32Array]", uint8Tag = "[object Uint8Array]", uint8ClampedTag = "[object Uint8ClampedArray]", uint16Tag = "[object Uint16Array]", uint32Tag = "[object Uint32Array]";
    /** Used to match empty string literals in compiled template source. */ var reEmptyStringLeading = /\b__p \+= '';/g, reEmptyStringMiddle = /\b(__p \+=) '' \+/g, reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;
    /** Used to match HTML entities and HTML characters. */ var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g, reUnescapedHtml = /[&<>"']/g, reHasEscapedHtml = RegExp(reEscapedHtml.source), reHasUnescapedHtml = RegExp(reUnescapedHtml.source);
    /** Used to match template delimiters. */ var reEscape = /<%-([\s\S]+?)%>/g, reEvaluate = /<%([\s\S]+?)%>/g, reInterpolate = /<%=([\s\S]+?)%>/g;
    /** Used to match property names within property paths. */ var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, reIsPlainProp = /^\w*$/, rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
    /**
   * Used to match `RegExp`
   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
   */ var reRegExpChar = /[\\^$.*+?()[\]{}|]/g, reHasRegExpChar = RegExp(reRegExpChar.source);
    /** Used to match leading whitespace. */ var reTrimStart = /^\s+/;
    /** Used to match a single whitespace character. */ var reWhitespace = /\s/;
    /** Used to match wrap detail comments. */ var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/, reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/, reSplitDetails = /,? & /;
    /** Used to match words composed of alphanumeric characters. */ var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
    /**
   * Used to validate the `validate` option in `_.template` variable.
   *
   * Forbids characters which could potentially change the meaning of the function argument definition:
   * - "()," (modification of function parameters)
   * - "=" (default value)
   * - "[]{}" (destructuring of function parameters)
   * - "/" (beginning of a comment)
   * - whitespace
   */ var reForbiddenIdentifierChars = /[()=,{}\[\]\/\s]/;
    /** Used to match backslashes in property paths. */ var reEscapeChar = /\\(\\)?/g;
    /**
   * Used to match
   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
   */ var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;
    /** Used to match `RegExp` flags from their coerced string values. */ var reFlags = /\w*$/;
    /** Used to detect bad signed hexadecimal string values. */ var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
    /** Used to detect binary string values. */ var reIsBinary = /^0b[01]+$/i;
    /** Used to detect host constructors (Safari). */ var reIsHostCtor = /^\[object .+?Constructor\]$/;
    /** Used to detect octal string values. */ var reIsOctal = /^0o[0-7]+$/i;
    /** Used to detect unsigned integer values. */ var reIsUint = /^(?:0|[1-9]\d*)$/;
    /** Used to match Latin Unicode letters (excluding mathematical operators). */ var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
    /** Used to ensure capturing order of template delimiters. */ var reNoMatch = /($^)/;
    /** Used to match unescaped characters in compiled string literals. */ var reUnescapedString = /['\n\r\u2028\u2029\\]/g;
    /** Used to compose unicode character classes. */ var rsAstralRange = "\ud800-\udfff", rsComboMarksRange = "\\u0300-\\u036f", reComboHalfMarksRange = "\\ufe20-\\ufe2f", rsComboSymbolsRange = "\\u20d0-\\u20ff", rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange, rsDingbatRange = "\\u2700-\\u27bf", rsLowerRange = "a-z\\xdf-\\xf6\\xf8-\\xff", rsMathOpRange = "\\xac\\xb1\\xd7\\xf7", rsNonCharRange = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf", rsPunctuationRange = "\\u2000-\\u206f", rsSpaceRange = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", rsUpperRange = "A-Z\\xc0-\\xd6\\xd8-\\xde", rsVarRange = "\\ufe0e\\ufe0f", rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;
    /** Used to compose unicode capture groups. */ var rsApos = "['’]", rsAstral = "[" + rsAstralRange + "]", rsBreak = "[" + rsBreakRange + "]", rsCombo = "[" + rsComboRange + "]", rsDigits = "\\d+", rsDingbat = "[" + rsDingbatRange + "]", rsLower = "[" + rsLowerRange + "]", rsMisc = "[^" + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + "]", rsFitz = "\ud83c[\udffb-\udfff]", rsModifier = "(?:" + rsCombo + "|" + rsFitz + ")", rsNonAstral = "[^" + rsAstralRange + "]", rsRegional = "(?:\ud83c[\udde6-\uddff]){2}", rsSurrPair = "[\ud800-\udbff][\udc00-\udfff]", rsUpper = "[" + rsUpperRange + "]", rsZWJ = "\\u200d";
    /** Used to compose unicode regexes. */ var rsMiscLower = "(?:" + rsLower + "|" + rsMisc + ")", rsMiscUpper = "(?:" + rsUpper + "|" + rsMisc + ")", rsOptContrLower = "(?:" + rsApos + "(?:d|ll|m|re|s|t|ve))?", rsOptContrUpper = "(?:" + rsApos + "(?:D|LL|M|RE|S|T|VE))?", reOptMod = rsModifier + "?", rsOptVar = "[" + rsVarRange + "]?", rsOptJoin = "(?:" + rsZWJ + "(?:" + [
        rsNonAstral,
        rsRegional,
        rsSurrPair
    ].join("|") + ")" + rsOptVar + reOptMod + ")*", rsOrdLower = "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", rsOrdUpper = "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", rsSeq = rsOptVar + reOptMod + rsOptJoin, rsEmoji = "(?:" + [
        rsDingbat,
        rsRegional,
        rsSurrPair
    ].join("|") + ")" + rsSeq, rsSymbol = "(?:" + [
        rsNonAstral + rsCombo + "?",
        rsCombo,
        rsRegional,
        rsSurrPair,
        rsAstral
    ].join("|") + ")";
    /** Used to match apostrophes. */ var reApos = RegExp(rsApos, "g");
    /**
   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
   */ var reComboMark = RegExp(rsCombo, "g");
    /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */ var reUnicode = RegExp(rsFitz + "(?=" + rsFitz + ")|" + rsSymbol + rsSeq, "g");
    /** Used to match complex or compound words. */ var reUnicodeWord = RegExp([
        rsUpper + "?" + rsLower + "+" + rsOptContrLower + "(?=" + [
            rsBreak,
            rsUpper,
            "$"
        ].join("|") + ")",
        rsMiscUpper + "+" + rsOptContrUpper + "(?=" + [
            rsBreak,
            rsUpper + rsMiscLower,
            "$"
        ].join("|") + ")",
        rsUpper + "?" + rsMiscLower + "+" + rsOptContrLower,
        rsUpper + "+" + rsOptContrUpper,
        rsOrdUpper,
        rsOrdLower,
        rsDigits,
        rsEmoji
    ].join("|"), "g");
    /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */ var reHasUnicode = RegExp("[" + rsZWJ + rsAstralRange + rsComboRange + rsVarRange + "]");
    /** Used to detect strings that need a more robust regexp to match words. */ var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
    /** Used to assign default `context` object properties. */ var contextProps = [
        "Array",
        "Buffer",
        "DataView",
        "Date",
        "Error",
        "Float32Array",
        "Float64Array",
        "Function",
        "Int8Array",
        "Int16Array",
        "Int32Array",
        "Map",
        "Math",
        "Object",
        "Promise",
        "RegExp",
        "Set",
        "String",
        "Symbol",
        "TypeError",
        "Uint8Array",
        "Uint8ClampedArray",
        "Uint16Array",
        "Uint32Array",
        "WeakMap",
        "_",
        "clearTimeout",
        "isFinite",
        "parseInt",
        "setTimeout"
    ];
    /** Used to make template sourceURLs easier to identify. */ var templateCounter = -1;
    /** Used to identify `toStringTag` values of typed arrays. */ var typedArrayTags = {};
    typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
    typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
    /** Used to identify `toStringTag` values supported by `_.clone`. */ var cloneableTags = {};
    cloneableTags[argsTag] = cloneableTags[arrayTag] = cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] = cloneableTags[boolTag] = cloneableTags[dateTag] = cloneableTags[float32Tag] = cloneableTags[float64Tag] = cloneableTags[int8Tag] = cloneableTags[int16Tag] = cloneableTags[int32Tag] = cloneableTags[mapTag] = cloneableTags[numberTag] = cloneableTags[objectTag] = cloneableTags[regexpTag] = cloneableTags[setTag] = cloneableTags[stringTag] = cloneableTags[symbolTag] = cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] = cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
    cloneableTags[errorTag] = cloneableTags[funcTag] = cloneableTags[weakMapTag] = false;
    /** Used to map Latin Unicode letters to basic Latin letters. */ var deburredLetters = {
        // Latin-1 Supplement block.
        "\xc0": "A",
        "\xc1": "A",
        "\xc2": "A",
        "\xc3": "A",
        "\xc4": "A",
        "\xc5": "A",
        "\xe0": "a",
        "\xe1": "a",
        "\xe2": "a",
        "\xe3": "a",
        "\xe4": "a",
        "\xe5": "a",
        "\xc7": "C",
        "\xe7": "c",
        "\xd0": "D",
        "\xf0": "d",
        "\xc8": "E",
        "\xc9": "E",
        "\xca": "E",
        "\xcb": "E",
        "\xe8": "e",
        "\xe9": "e",
        "\xea": "e",
        "\xeb": "e",
        "\xcc": "I",
        "\xcd": "I",
        "\xce": "I",
        "\xcf": "I",
        "\xec": "i",
        "\xed": "i",
        "\xee": "i",
        "\xef": "i",
        "\xd1": "N",
        "\xf1": "n",
        "\xd2": "O",
        "\xd3": "O",
        "\xd4": "O",
        "\xd5": "O",
        "\xd6": "O",
        "\xd8": "O",
        "\xf2": "o",
        "\xf3": "o",
        "\xf4": "o",
        "\xf5": "o",
        "\xf6": "o",
        "\xf8": "o",
        "\xd9": "U",
        "\xda": "U",
        "\xdb": "U",
        "\xdc": "U",
        "\xf9": "u",
        "\xfa": "u",
        "\xfb": "u",
        "\xfc": "u",
        "\xdd": "Y",
        "\xfd": "y",
        "\xff": "y",
        "\xc6": "Ae",
        "\xe6": "ae",
        "\xde": "Th",
        "\xfe": "th",
        "\xdf": "ss",
        // Latin Extended-A block.
        "Ā": "A",
        "Ă": "A",
        "Ą": "A",
        "ā": "a",
        "ă": "a",
        "ą": "a",
        "Ć": "C",
        "Ĉ": "C",
        "Ċ": "C",
        "Č": "C",
        "ć": "c",
        "ĉ": "c",
        "ċ": "c",
        "č": "c",
        "Ď": "D",
        "Đ": "D",
        "ď": "d",
        "đ": "d",
        "Ē": "E",
        "Ĕ": "E",
        "Ė": "E",
        "Ę": "E",
        "Ě": "E",
        "ē": "e",
        "ĕ": "e",
        "ė": "e",
        "ę": "e",
        "ě": "e",
        "Ĝ": "G",
        "Ğ": "G",
        "Ġ": "G",
        "Ģ": "G",
        "ĝ": "g",
        "ğ": "g",
        "ġ": "g",
        "ģ": "g",
        "Ĥ": "H",
        "Ħ": "H",
        "ĥ": "h",
        "ħ": "h",
        "Ĩ": "I",
        "Ī": "I",
        "Ĭ": "I",
        "Į": "I",
        "İ": "I",
        "ĩ": "i",
        "ī": "i",
        "ĭ": "i",
        "į": "i",
        "ı": "i",
        "Ĵ": "J",
        "ĵ": "j",
        "Ķ": "K",
        "ķ": "k",
        "ĸ": "k",
        "Ĺ": "L",
        "Ļ": "L",
        "Ľ": "L",
        "Ŀ": "L",
        "Ł": "L",
        "ĺ": "l",
        "ļ": "l",
        "ľ": "l",
        "ŀ": "l",
        "ł": "l",
        "Ń": "N",
        "Ņ": "N",
        "Ň": "N",
        "Ŋ": "N",
        "ń": "n",
        "ņ": "n",
        "ň": "n",
        "ŋ": "n",
        "Ō": "O",
        "Ŏ": "O",
        "Ő": "O",
        "ō": "o",
        "ŏ": "o",
        "ő": "o",
        "Ŕ": "R",
        "Ŗ": "R",
        "Ř": "R",
        "ŕ": "r",
        "ŗ": "r",
        "ř": "r",
        "Ś": "S",
        "Ŝ": "S",
        "Ş": "S",
        "Š": "S",
        "ś": "s",
        "ŝ": "s",
        "ş": "s",
        "š": "s",
        "Ţ": "T",
        "Ť": "T",
        "Ŧ": "T",
        "ţ": "t",
        "ť": "t",
        "ŧ": "t",
        "Ũ": "U",
        "Ū": "U",
        "Ŭ": "U",
        "Ů": "U",
        "Ű": "U",
        "Ų": "U",
        "ũ": "u",
        "ū": "u",
        "ŭ": "u",
        "ů": "u",
        "ű": "u",
        "ų": "u",
        "Ŵ": "W",
        "ŵ": "w",
        "Ŷ": "Y",
        "ŷ": "y",
        "Ÿ": "Y",
        "Ź": "Z",
        "Ż": "Z",
        "Ž": "Z",
        "ź": "z",
        "ż": "z",
        "ž": "z",
        "Ĳ": "IJ",
        "ĳ": "ij",
        "Œ": "Oe",
        "œ": "oe",
        "ŉ": "'n",
        "ſ": "s"
    };
    /** Used to map characters to HTML entities. */ var htmlEscapes = {
        "&": "&amp;",
        "<": "&lt;",
        ">": "&gt;",
        '"': "&quot;",
        "'": "&#39;"
    };
    /** Used to map HTML entities to characters. */ var htmlUnescapes = {
        "&amp;": "&",
        "&lt;": "<",
        "&gt;": ">",
        "&quot;": '"',
        "&#39;": "'"
    };
    /** Used to escape characters for inclusion in compiled string literals. */ var stringEscapes = {
        "\\": "\\",
        "'": "'",
        "\n": "n",
        "\r": "r",
        "\u2028": "u2028",
        "\u2029": "u2029"
    };
    /** Built-in method references without a dependency on `root`. */ var freeParseFloat = parseFloat, freeParseInt = parseInt;
    /** Detect free variable `global` from Node.js. */ var freeGlobal = typeof global == "object" && global && global.Object === Object && global;
    /** Detect free variable `self`. */ var freeSelf = typeof self == "object" && self && self.Object === Object && self;
    /** Used as a reference to the global object. */ var root = freeGlobal || freeSelf || Function("return this")();
    /** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
    /** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
    /** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
    /** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && freeGlobal.process;
    /** Used to access faster Node.js helpers. */ var nodeUtil = function() {
        try {
            // Use `util.types` for Node.js 10+.
            var types = freeModule && freeModule.require && freeModule.require("util").types;
            if (types) return types;
            // Legacy `process.binding('util')` for Node.js < 10.
            return freeProcess && freeProcess.binding && freeProcess.binding("util");
        } catch (e) {}
    }();
    /* Node.js helper references. */ var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer, nodeIsDate = nodeUtil && nodeUtil.isDate, nodeIsMap = nodeUtil && nodeUtil.isMap, nodeIsRegExp = nodeUtil && nodeUtil.isRegExp, nodeIsSet = nodeUtil && nodeUtil.isSet, nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
    /*--------------------------------------------------------------------------*/ /**
   * A faster alternative to `Function#apply`, this function invokes `func`
   * with the `this` binding of `thisArg` and the arguments of `args`.
   *
   * @private
   * @param {Function} func The function to invoke.
   * @param {*} thisArg The `this` binding of `func`.
   * @param {Array} args The arguments to invoke `func` with.
   * @returns {*} Returns the result of `func`.
   */ function apply(func, thisArg, args) {
        switch(args.length){
            case 0:
                return func.call(thisArg);
            case 1:
                return func.call(thisArg, args[0]);
            case 2:
                return func.call(thisArg, args[0], args[1]);
            case 3:
                return func.call(thisArg, args[0], args[1], args[2]);
        }
        return func.apply(thisArg, args);
    }
    /**
   * A specialized version of `baseAggregator` for arrays.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} setter The function to set `accumulator` values.
   * @param {Function} iteratee The iteratee to transform keys.
   * @param {Object} accumulator The initial aggregated object.
   * @returns {Function} Returns `accumulator`.
   */ function arrayAggregator(array, setter, iteratee, accumulator) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            var value = array[index];
            setter(accumulator, value, iteratee(value), array);
        }
        return accumulator;
    }
    /**
   * A specialized version of `_.forEach` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */ function arrayEach(array, iteratee) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (iteratee(array[index], index, array) === false) break;
        }
        return array;
    }
    /**
   * A specialized version of `_.forEachRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */ function arrayEachRight(array, iteratee) {
        var length = array == null ? 0 : array.length;
        while(length--){
            if (iteratee(array[length], length, array) === false) break;
        }
        return array;
    }
    /**
   * A specialized version of `_.every` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if all elements pass the predicate check,
   *  else `false`.
   */ function arrayEvery(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (!predicate(array[index], index, array)) return false;
        }
        return true;
    }
    /**
   * A specialized version of `_.filter` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {Array} Returns the new filtered array.
   */ function arrayFilter(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
        while(++index < length){
            var value = array[index];
            if (predicate(value, index, array)) result[resIndex++] = value;
        }
        return result;
    }
    /**
   * A specialized version of `_.includes` for arrays without support for
   * specifying an index to search from.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */ function arrayIncludes(array, value) {
        var length = array == null ? 0 : array.length;
        return !!length && baseIndexOf(array, value, 0) > -1;
    }
    /**
   * This function is like `arrayIncludes` except that it accepts a comparator.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */ function arrayIncludesWith(array, value, comparator) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (comparator(value, array[index])) return true;
        }
        return false;
    }
    /**
   * A specialized version of `_.map` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the new mapped array.
   */ function arrayMap(array, iteratee) {
        var index = -1, length = array == null ? 0 : array.length, result = Array(length);
        while(++index < length)result[index] = iteratee(array[index], index, array);
        return result;
    }
    /**
   * Appends the elements of `values` to `array`.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {Array} values The values to append.
   * @returns {Array} Returns `array`.
   */ function arrayPush(array, values) {
        var index = -1, length = values.length, offset = array.length;
        while(++index < length)array[offset + index] = values[index];
        return array;
    }
    /**
   * A specialized version of `_.reduce` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the first element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */ function arrayReduce(array, iteratee, accumulator, initAccum) {
        var index = -1, length = array == null ? 0 : array.length;
        if (initAccum && length) accumulator = array[++index];
        while(++index < length)accumulator = iteratee(accumulator, array[index], index, array);
        return accumulator;
    }
    /**
   * A specialized version of `_.reduceRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the last element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */ function arrayReduceRight(array, iteratee, accumulator, initAccum) {
        var length = array == null ? 0 : array.length;
        if (initAccum && length) accumulator = array[--length];
        while(length--)accumulator = iteratee(accumulator, array[length], length, array);
        return accumulator;
    }
    /**
   * A specialized version of `_.some` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if any element passes the predicate check,
   *  else `false`.
   */ function arraySome(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (predicate(array[index], index, array)) return true;
        }
        return false;
    }
    /**
   * Gets the size of an ASCII `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */ var asciiSize = baseProperty("length");
    /**
   * Converts an ASCII `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function asciiToArray(string) {
        return string.split("");
    }
    /**
   * Splits an ASCII `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */ function asciiWords(string) {
        return string.match(reAsciiWord) || [];
    }
    /**
   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
   * without support for iteratee shorthands, which iterates over `collection`
   * using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the found element or its key, else `undefined`.
   */ function baseFindKey(collection, predicate, eachFunc) {
        var result;
        eachFunc(collection, function(value, key, collection) {
            if (predicate(value, key, collection)) {
                result = key;
                return false;
            }
        });
        return result;
    }
    /**
   * The base implementation of `_.findIndex` and `_.findLastIndex` without
   * support for iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {number} fromIndex The index to search from.
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseFindIndex(array, predicate, fromIndex, fromRight) {
        var length = array.length, index = fromIndex + (fromRight ? 1 : -1);
        while(fromRight ? index-- : ++index < length){
            if (predicate(array[index], index, array)) return index;
        }
        return -1;
    }
    /**
   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseIndexOf(array, value, fromIndex) {
        return value === value ? strictIndexOf(array, value, fromIndex) : baseFindIndex(array, baseIsNaN, fromIndex);
    }
    /**
   * This function is like `baseIndexOf` except that it accepts a comparator.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseIndexOfWith(array, value, fromIndex, comparator) {
        var index = fromIndex - 1, length = array.length;
        while(++index < length){
            if (comparator(array[index], value)) return index;
        }
        return -1;
    }
    /**
   * The base implementation of `_.isNaN` without support for number objects.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
   */ function baseIsNaN(value) {
        return value !== value;
    }
    /**
   * The base implementation of `_.mean` and `_.meanBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the mean.
   */ function baseMean(array, iteratee) {
        var length = array == null ? 0 : array.length;
        return length ? baseSum(array, iteratee) / length : NAN;
    }
    /**
   * The base implementation of `_.property` without support for deep paths.
   *
   * @private
   * @param {string} key The key of the property to get.
   * @returns {Function} Returns the new accessor function.
   */ function baseProperty(key) {
        return function(object) {
            return object == null ? undefined : object[key];
        };
    }
    /**
   * The base implementation of `_.propertyOf` without support for deep paths.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Function} Returns the new accessor function.
   */ function basePropertyOf(object) {
        return function(key) {
            return object == null ? undefined : object[key];
        };
    }
    /**
   * The base implementation of `_.reduce` and `_.reduceRight`, without support
   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} accumulator The initial value.
   * @param {boolean} initAccum Specify using the first or last element of
   *  `collection` as the initial value.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the accumulated value.
   */ function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
        eachFunc(collection, function(value, index, collection) {
            accumulator = initAccum ? (initAccum = false, value) : iteratee(accumulator, value, index, collection);
        });
        return accumulator;
    }
    /**
   * The base implementation of `_.sortBy` which uses `comparer` to define the
   * sort order of `array` and replaces criteria objects with their corresponding
   * values.
   *
   * @private
   * @param {Array} array The array to sort.
   * @param {Function} comparer The function to define sort order.
   * @returns {Array} Returns `array`.
   */ function baseSortBy(array, comparer) {
        var length = array.length;
        array.sort(comparer);
        while(length--)array[length] = array[length].value;
        return array;
    }
    /**
   * The base implementation of `_.sum` and `_.sumBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the sum.
   */ function baseSum(array, iteratee) {
        var result, index = -1, length = array.length;
        while(++index < length){
            var current = iteratee(array[index]);
            if (current !== undefined) result = result === undefined ? current : result + current;
        }
        return result;
    }
    /**
   * The base implementation of `_.times` without support for iteratee shorthands
   * or max array length checks.
   *
   * @private
   * @param {number} n The number of times to invoke `iteratee`.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the array of results.
   */ function baseTimes(n, iteratee) {
        var index = -1, result = Array(n);
        while(++index < n)result[index] = iteratee(index);
        return result;
    }
    /**
   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
   * of key-value pairs for `object` corresponding to the property names of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the key-value pairs.
   */ function baseToPairs(object, props) {
        return arrayMap(props, function(key) {
            return [
                key,
                object[key]
            ];
        });
    }
    /**
   * The base implementation of `_.trim`.
   *
   * @private
   * @param {string} string The string to trim.
   * @returns {string} Returns the trimmed string.
   */ function baseTrim(string) {
        return string ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, "") : string;
    }
    /**
   * The base implementation of `_.unary` without support for storing metadata.
   *
   * @private
   * @param {Function} func The function to cap arguments for.
   * @returns {Function} Returns the new capped function.
   */ function baseUnary(func) {
        return function(value) {
            return func(value);
        };
    }
    /**
   * The base implementation of `_.values` and `_.valuesIn` which creates an
   * array of `object` property values corresponding to the property names
   * of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the array of property values.
   */ function baseValues(object, props) {
        return arrayMap(props, function(key) {
            return object[key];
        });
    }
    /**
   * Checks if a `cache` value for `key` exists.
   *
   * @private
   * @param {Object} cache The cache to query.
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */ function cacheHas(cache, key) {
        return cache.has(key);
    }
    /**
   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the first unmatched string symbol.
   */ function charsStartIndex(strSymbols, chrSymbols) {
        var index = -1, length = strSymbols.length;
        while(++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1);
        return index;
    }
    /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the last unmatched string symbol.
   */ function charsEndIndex(strSymbols, chrSymbols) {
        var index = strSymbols.length;
        while(index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1);
        return index;
    }
    /**
   * Gets the number of `placeholder` occurrences in `array`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} placeholder The placeholder to search for.
   * @returns {number} Returns the placeholder count.
   */ function countHolders(array, placeholder) {
        var length = array.length, result = 0;
        while(length--)if (array[length] === placeholder) ++result;
        return result;
    }
    /**
   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
   * letters to basic Latin letters.
   *
   * @private
   * @param {string} letter The matched letter to deburr.
   * @returns {string} Returns the deburred letter.
   */ var deburrLetter = basePropertyOf(deburredLetters);
    /**
   * Used by `_.escape` to convert characters to HTML entities.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */ var escapeHtmlChar = basePropertyOf(htmlEscapes);
    /**
   * Used by `_.template` to escape characters for inclusion in compiled string literals.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */ function escapeStringChar(chr) {
        return "\\" + stringEscapes[chr];
    }
    /**
   * Gets the value at `key` of `object`.
   *
   * @private
   * @param {Object} [object] The object to query.
   * @param {string} key The key of the property to get.
   * @returns {*} Returns the property value.
   */ function getValue(object, key) {
        return object == null ? undefined : object[key];
    }
    /**
   * Checks if `string` contains Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
   */ function hasUnicode(string) {
        return reHasUnicode.test(string);
    }
    /**
   * Checks if `string` contains a word composed of Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a word is found, else `false`.
   */ function hasUnicodeWord(string) {
        return reHasUnicodeWord.test(string);
    }
    /**
   * Converts `iterator` to an array.
   *
   * @private
   * @param {Object} iterator The iterator to convert.
   * @returns {Array} Returns the converted array.
   */ function iteratorToArray(iterator) {
        var data, result = [];
        while(!(data = iterator.next()).done)result.push(data.value);
        return result;
    }
    /**
   * Converts `map` to its key-value pairs.
   *
   * @private
   * @param {Object} map The map to convert.
   * @returns {Array} Returns the key-value pairs.
   */ function mapToArray(map) {
        var index = -1, result = Array(map.size);
        map.forEach(function(value, key) {
            result[++index] = [
                key,
                value
            ];
        });
        return result;
    }
    /**
   * Creates a unary function that invokes `func` with its argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */ function overArg(func, transform) {
        return function(arg) {
            return func(transform(arg));
        };
    }
    /**
   * Replaces all `placeholder` elements in `array` with an internal placeholder
   * and returns an array of their indexes.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {*} placeholder The placeholder to replace.
   * @returns {Array} Returns the new array of placeholder indexes.
   */ function replaceHolders(array, placeholder) {
        var index = -1, length = array.length, resIndex = 0, result = [];
        while(++index < length){
            var value = array[index];
            if (value === placeholder || value === PLACEHOLDER) {
                array[index] = PLACEHOLDER;
                result[resIndex++] = index;
            }
        }
        return result;
    }
    /**
   * Converts `set` to an array of its values.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the values.
   */ function setToArray(set) {
        var index = -1, result = Array(set.size);
        set.forEach(function(value) {
            result[++index] = value;
        });
        return result;
    }
    /**
   * Converts `set` to its value-value pairs.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the value-value pairs.
   */ function setToPairs(set) {
        var index = -1, result = Array(set.size);
        set.forEach(function(value) {
            result[++index] = [
                value,
                value
            ];
        });
        return result;
    }
    /**
   * A specialized version of `_.indexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function strictIndexOf(array, value, fromIndex) {
        var index = fromIndex - 1, length = array.length;
        while(++index < length){
            if (array[index] === value) return index;
        }
        return -1;
    }
    /**
   * A specialized version of `_.lastIndexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function strictLastIndexOf(array, value, fromIndex) {
        var index = fromIndex + 1;
        while(index--){
            if (array[index] === value) return index;
        }
        return index;
    }
    /**
   * Gets the number of symbols in `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the string size.
   */ function stringSize(string) {
        return hasUnicode(string) ? unicodeSize(string) : asciiSize(string);
    }
    /**
   * Converts `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function stringToArray(string) {
        return hasUnicode(string) ? unicodeToArray(string) : asciiToArray(string);
    }
    /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
   * character of `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the index of the last non-whitespace character.
   */ function trimmedEndIndex(string) {
        var index = string.length;
        while(index-- && reWhitespace.test(string.charAt(index)));
        return index;
    }
    /**
   * Used by `_.unescape` to convert HTML entities to characters.
   *
   * @private
   * @param {string} chr The matched character to unescape.
   * @returns {string} Returns the unescaped character.
   */ var unescapeHtmlChar = basePropertyOf(htmlUnescapes);
    /**
   * Gets the size of a Unicode `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */ function unicodeSize(string) {
        var result = reUnicode.lastIndex = 0;
        while(reUnicode.test(string))++result;
        return result;
    }
    /**
   * Converts a Unicode `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function unicodeToArray(string) {
        return string.match(reUnicode) || [];
    }
    /**
   * Splits a Unicode `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */ function unicodeWords(string) {
        return string.match(reUnicodeWord) || [];
    }
    /*--------------------------------------------------------------------------*/ /**
   * Create a new pristine `lodash` function using the `context` object.
   *
   * @static
   * @memberOf _
   * @since 1.1.0
   * @category Util
   * @param {Object} [context=root] The context object.
   * @returns {Function} Returns a new `lodash` function.
   * @example
   *
   * _.mixin({ 'foo': _.constant('foo') });
   *
   * var lodash = _.runInContext();
   * lodash.mixin({ 'bar': lodash.constant('bar') });
   *
   * _.isFunction(_.foo);
   * // => true
   * _.isFunction(_.bar);
   * // => false
   *
   * lodash.isFunction(lodash.foo);
   * // => false
   * lodash.isFunction(lodash.bar);
   * // => true
   *
   * // Create a suped-up `defer` in Node.js.
   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
   */ var runInContext = function runInContext(context) {
        context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));
        /** Built-in constructor references. */ var Array1 = context.Array, Date = context.Date, Error = context.Error, Function1 = context.Function, Math = context.Math, Object1 = context.Object, RegExp1 = context.RegExp, String = context.String, TypeError = context.TypeError;
        /** Used for built-in method references. */ var arrayProto = Array1.prototype, funcProto = Function1.prototype, objectProto = Object1.prototype;
        /** Used to detect overreaching core-js shims. */ var coreJsData = context["__core-js_shared__"];
        /** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
        /** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
        /** Used to generate unique IDs. */ var idCounter = 0;
        /** Used to detect methods masquerading as native. */ var maskSrcKey = function() {
            var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || "");
            return uid ? "Symbol(src)_1." + uid : "";
        }();
        /**
     * Used to resolve the
     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
     * of values.
     */ var nativeObjectToString = objectProto.toString;
        /** Used to infer the `Object` constructor. */ var objectCtorString = funcToString.call(Object1);
        /** Used to restore the original `_` reference in `_.noConflict`. */ var oldDash = root._;
        /** Used to detect if a method is native. */ var reIsNative = RegExp1("^" + funcToString.call(hasOwnProperty).replace(reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
        /** Built-in value references. */ var Buffer = moduleExports ? context.Buffer : undefined, Symbol = context.Symbol, Uint8Array = context.Uint8Array, allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined, getPrototype = overArg(Object1.getPrototypeOf, Object1), objectCreate = Object1.create, propertyIsEnumerable = objectProto.propertyIsEnumerable, splice = arrayProto.splice, spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined, symIterator = Symbol ? Symbol.iterator : undefined, symToStringTag = Symbol ? Symbol.toStringTag : undefined;
        var defineProperty = function() {
            try {
                var func = getNative(Object1, "defineProperty");
                func({}, "", {});
                return func;
            } catch (e) {}
        }();
        /** Mocked built-ins. */ var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout, ctxNow = Date && Date.now !== root.Date.now && Date.now, ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;
        /* Built-in method references for those with the same name as other `lodash` methods. */ var nativeCeil = Math.ceil, nativeFloor = Math.floor, nativeGetSymbols = Object1.getOwnPropertySymbols, nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined, nativeIsFinite = context.isFinite, nativeJoin = arrayProto.join, nativeKeys = overArg(Object1.keys, Object1), nativeMax = Math.max, nativeMin = Math.min, nativeNow = Date.now, nativeParseInt = context.parseInt, nativeRandom = Math.random, nativeReverse = arrayProto.reverse;
        /* Built-in method references that are verified to be native. */ var DataView = getNative(context, "DataView"), Map = getNative(context, "Map"), Promise = getNative(context, "Promise"), Set = getNative(context, "Set"), WeakMap = getNative(context, "WeakMap"), nativeCreate = getNative(Object1, "create");
        /** Used to store function metadata. */ var metaMap = WeakMap && new WeakMap;
        /** Used to lookup unminified function names. */ var realNames = {};
        /** Used to detect maps, sets, and weakmaps. */ var dataViewCtorString = toSource(DataView), mapCtorString = toSource(Map), promiseCtorString = toSource(Promise), setCtorString = toSource(Set), weakMapCtorString = toSource(WeakMap);
        /** Used to convert symbols to primitives and strings. */ var symbolProto = Symbol ? Symbol.prototype : undefined, symbolValueOf = symbolProto ? symbolProto.valueOf : undefined, symbolToString = symbolProto ? symbolProto.toString : undefined;
        /*------------------------------------------------------------------------*/ /**
     * Creates a `lodash` object which wraps `value` to enable implicit method
     * chain sequences. Methods that operate on and return arrays, collections,
     * and functions can be chained together. Methods that retrieve a single value
     * or may return a primitive value will automatically end the chain sequence
     * and return the unwrapped value. Otherwise, the value must be unwrapped
     * with `_#value`.
     *
     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
     * enabled using `_.chain`.
     *
     * The execution of chained methods is lazy, that is, it's deferred until
     * `_#value` is implicitly or explicitly called.
     *
     * Lazy evaluation allows several methods to support shortcut fusion.
     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
     * the creation of intermediate arrays and can greatly reduce the number of
     * iteratee executions. Sections of a chain sequence qualify for shortcut
     * fusion if the section is applied to an array and iteratees accept only
     * one argument. The heuristic for whether a section qualifies for shortcut
     * fusion is subject to change.
     *
     * Chaining is supported in custom builds as long as the `_#value` method is
     * directly or indirectly included in the build.
     *
     * In addition to lodash methods, wrappers have `Array` and `String` methods.
     *
     * The wrapper `Array` methods are:
     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
     *
     * The wrapper `String` methods are:
     * `replace` and `split`
     *
     * The wrapper methods that support shortcut fusion are:
     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
     *
     * The chainable wrapper methods are:
     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
     * `zipObject`, `zipObjectDeep`, and `zipWith`
     *
     * The wrapper methods that are **not** chainable by default are:
     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
     * `upperFirst`, `value`, and `words`
     *
     * @name _
     * @constructor
     * @category Seq
     * @param {*} value The value to wrap in a `lodash` instance.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2, 3]);
     *
     * // Returns an unwrapped value.
     * wrapped.reduce(_.add);
     * // => 6
     *
     * // Returns a wrapped value.
     * var squares = wrapped.map(square);
     *
     * _.isArray(squares);
     * // => false
     *
     * _.isArray(squares.value());
     * // => true
     */ function lodash(value) {
            if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
                if (value instanceof LodashWrapper) return value;
                if (hasOwnProperty.call(value, "__wrapped__")) return wrapperClone(value);
            }
            return new LodashWrapper(value);
        }
        /**
     * The base implementation of `_.create` without support for assigning
     * properties to the created object.
     *
     * @private
     * @param {Object} proto The object to inherit from.
     * @returns {Object} Returns the new object.
     */ var baseCreate = function() {
            function object() {}
            return function(proto) {
                if (!isObject(proto)) return {};
                if (objectCreate) return objectCreate(proto);
                object.prototype = proto;
                var result = new object;
                object.prototype = undefined;
                return result;
            };
        }();
        /**
     * The function whose prototype chain sequence wrappers inherit from.
     *
     * @private
     */ function baseLodash() {
        // No operation performed.
        }
        /**
     * The base constructor for creating `lodash` wrapper objects.
     *
     * @private
     * @param {*} value The value to wrap.
     * @param {boolean} [chainAll] Enable explicit method chain sequences.
     */ function LodashWrapper(value, chainAll) {
            this.__wrapped__ = value;
            this.__actions__ = [];
            this.__chain__ = !!chainAll;
            this.__index__ = 0;
            this.__values__ = undefined;
        }
        /**
     * By default, the template delimiters used by lodash are like those in
     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
     * following template settings to use alternative delimiters.
     *
     * @static
     * @memberOf _
     * @type {Object}
     */ lodash.templateSettings = {
            /**
       * Used to detect `data` property values to be HTML-escaped.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ "escape": reEscape,
            /**
       * Used to detect code to be evaluated.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ "evaluate": reEvaluate,
            /**
       * Used to detect `data` property values to inject.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ "interpolate": reInterpolate,
            /**
       * Used to reference the data object in the template text.
       *
       * @memberOf _.templateSettings
       * @type {string}
       */ "variable": "",
            /**
       * Used to import variables into the compiled template.
       *
       * @memberOf _.templateSettings
       * @type {Object}
       */ "imports": {
                /**
         * A reference to the `lodash` function.
         *
         * @memberOf _.templateSettings.imports
         * @type {Function}
         */ "_": lodash
            }
        };
        // Ensure wrappers are instances of `baseLodash`.
        lodash.prototype = baseLodash.prototype;
        lodash.prototype.constructor = lodash;
        LodashWrapper.prototype = baseCreate(baseLodash.prototype);
        LodashWrapper.prototype.constructor = LodashWrapper;
        /*------------------------------------------------------------------------*/ /**
     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
     *
     * @private
     * @constructor
     * @param {*} value The value to wrap.
     */ function LazyWrapper(value) {
            this.__wrapped__ = value;
            this.__actions__ = [];
            this.__dir__ = 1;
            this.__filtered__ = false;
            this.__iteratees__ = [];
            this.__takeCount__ = MAX_ARRAY_LENGTH;
            this.__views__ = [];
        }
        /**
     * Creates a clone of the lazy wrapper object.
     *
     * @private
     * @name clone
     * @memberOf LazyWrapper
     * @returns {Object} Returns the cloned `LazyWrapper` object.
     */ function lazyClone() {
            var result = new LazyWrapper(this.__wrapped__);
            result.__actions__ = copyArray(this.__actions__);
            result.__dir__ = this.__dir__;
            result.__filtered__ = this.__filtered__;
            result.__iteratees__ = copyArray(this.__iteratees__);
            result.__takeCount__ = this.__takeCount__;
            result.__views__ = copyArray(this.__views__);
            return result;
        }
        /**
     * Reverses the direction of lazy iteration.
     *
     * @private
     * @name reverse
     * @memberOf LazyWrapper
     * @returns {Object} Returns the new reversed `LazyWrapper` object.
     */ function lazyReverse() {
            if (this.__filtered__) {
                var result = new LazyWrapper(this);
                result.__dir__ = -1;
                result.__filtered__ = true;
            } else {
                result = this.clone();
                result.__dir__ *= -1;
            }
            return result;
        }
        /**
     * Extracts the unwrapped value from its lazy wrapper.
     *
     * @private
     * @name value
     * @memberOf LazyWrapper
     * @returns {*} Returns the unwrapped value.
     */ function lazyValue() {
            var array = this.__wrapped__.value(), dir = this.__dir__, isArr = isArray(array), isRight = dir < 0, arrLength = isArr ? array.length : 0, view = getView(0, arrLength, this.__views__), start = view.start, end = view.end, length = end - start, index = isRight ? end : start - 1, iteratees = this.__iteratees__, iterLength = iteratees.length, resIndex = 0, takeCount = nativeMin(length, this.__takeCount__);
            if (!isArr || !isRight && arrLength == length && takeCount == length) return baseWrapperValue(array, this.__actions__);
            var result = [];
            outer: while(length-- && resIndex < takeCount){
                index += dir;
                var iterIndex = -1, value = array[index];
                while(++iterIndex < iterLength){
                    var data = iteratees[iterIndex], iteratee = data.iteratee, type = data.type, computed = iteratee(value);
                    if (type == LAZY_MAP_FLAG) value = computed;
                    else if (!computed) {
                        if (type == LAZY_FILTER_FLAG) continue outer;
                        else break outer;
                    }
                }
                result[resIndex++] = value;
            }
            return result;
        }
        // Ensure `LazyWrapper` is an instance of `baseLodash`.
        LazyWrapper.prototype = baseCreate(baseLodash.prototype);
        LazyWrapper.prototype.constructor = LazyWrapper;
        /*------------------------------------------------------------------------*/ /**
     * Creates a hash object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function Hash(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the hash.
     *
     * @private
     * @name clear
     * @memberOf Hash
     */ function hashClear() {
            this.__data__ = nativeCreate ? nativeCreate(null) : {};
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the hash.
     *
     * @private
     * @name delete
     * @memberOf Hash
     * @param {Object} hash The hash to modify.
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function hashDelete(key) {
            var result = this.has(key) && delete this.__data__[key];
            this.size -= result ? 1 : 0;
            return result;
        }
        /**
     * Gets the hash value for `key`.
     *
     * @private
     * @name get
     * @memberOf Hash
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function hashGet(key) {
            var data = this.__data__;
            if (nativeCreate) {
                var result = data[key];
                return result === HASH_UNDEFINED ? undefined : result;
            }
            return hasOwnProperty.call(data, key) ? data[key] : undefined;
        }
        /**
     * Checks if a hash value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Hash
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function hashHas(key) {
            var data = this.__data__;
            return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
        }
        /**
     * Sets the hash `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Hash
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the hash instance.
     */ function hashSet(key, value) {
            var data = this.__data__;
            this.size += this.has(key) ? 0 : 1;
            data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED : value;
            return this;
        }
        // Add methods to `Hash`.
        Hash.prototype.clear = hashClear;
        Hash.prototype["delete"] = hashDelete;
        Hash.prototype.get = hashGet;
        Hash.prototype.has = hashHas;
        Hash.prototype.set = hashSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates an list cache object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function ListCache(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the list cache.
     *
     * @private
     * @name clear
     * @memberOf ListCache
     */ function listCacheClear() {
            this.__data__ = [];
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the list cache.
     *
     * @private
     * @name delete
     * @memberOf ListCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function listCacheDelete(key) {
            var data = this.__data__, index = assocIndexOf(data, key);
            if (index < 0) return false;
            var lastIndex = data.length - 1;
            if (index == lastIndex) data.pop();
            else splice.call(data, index, 1);
            --this.size;
            return true;
        }
        /**
     * Gets the list cache value for `key`.
     *
     * @private
     * @name get
     * @memberOf ListCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function listCacheGet(key) {
            var data = this.__data__, index = assocIndexOf(data, key);
            return index < 0 ? undefined : data[index][1];
        }
        /**
     * Checks if a list cache value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf ListCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function listCacheHas(key) {
            return assocIndexOf(this.__data__, key) > -1;
        }
        /**
     * Sets the list cache `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf ListCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the list cache instance.
     */ function listCacheSet(key, value) {
            var data = this.__data__, index = assocIndexOf(data, key);
            if (index < 0) {
                ++this.size;
                data.push([
                    key,
                    value
                ]);
            } else data[index][1] = value;
            return this;
        }
        // Add methods to `ListCache`.
        ListCache.prototype.clear = listCacheClear;
        ListCache.prototype["delete"] = listCacheDelete;
        ListCache.prototype.get = listCacheGet;
        ListCache.prototype.has = listCacheHas;
        ListCache.prototype.set = listCacheSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates a map cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function MapCache(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the map.
     *
     * @private
     * @name clear
     * @memberOf MapCache
     */ function mapCacheClear() {
            this.size = 0;
            this.__data__ = {
                "hash": new Hash,
                "map": new (Map || ListCache),
                "string": new Hash
            };
        }
        /**
     * Removes `key` and its value from the map.
     *
     * @private
     * @name delete
     * @memberOf MapCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function mapCacheDelete(key) {
            var result = getMapData(this, key)["delete"](key);
            this.size -= result ? 1 : 0;
            return result;
        }
        /**
     * Gets the map value for `key`.
     *
     * @private
     * @name get
     * @memberOf MapCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function mapCacheGet(key) {
            return getMapData(this, key).get(key);
        }
        /**
     * Checks if a map value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf MapCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function mapCacheHas(key) {
            return getMapData(this, key).has(key);
        }
        /**
     * Sets the map `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf MapCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the map cache instance.
     */ function mapCacheSet(key, value) {
            var data = getMapData(this, key), size = data.size;
            data.set(key, value);
            this.size += data.size == size ? 0 : 1;
            return this;
        }
        // Add methods to `MapCache`.
        MapCache.prototype.clear = mapCacheClear;
        MapCache.prototype["delete"] = mapCacheDelete;
        MapCache.prototype.get = mapCacheGet;
        MapCache.prototype.has = mapCacheHas;
        MapCache.prototype.set = mapCacheSet;
        /*------------------------------------------------------------------------*/ /**
     *
     * Creates an array cache object to store unique values.
     *
     * @private
     * @constructor
     * @param {Array} [values] The values to cache.
     */ function SetCache(values) {
            var index = -1, length = values == null ? 0 : values.length;
            this.__data__ = new MapCache;
            while(++index < length)this.add(values[index]);
        }
        /**
     * Adds `value` to the array cache.
     *
     * @private
     * @name add
     * @memberOf SetCache
     * @alias push
     * @param {*} value The value to cache.
     * @returns {Object} Returns the cache instance.
     */ function setCacheAdd(value) {
            this.__data__.set(value, HASH_UNDEFINED);
            return this;
        }
        /**
     * Checks if `value` is in the array cache.
     *
     * @private
     * @name has
     * @memberOf SetCache
     * @param {*} value The value to search for.
     * @returns {number} Returns `true` if `value` is found, else `false`.
     */ function setCacheHas(value) {
            return this.__data__.has(value);
        }
        // Add methods to `SetCache`.
        SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
        SetCache.prototype.has = setCacheHas;
        /*------------------------------------------------------------------------*/ /**
     * Creates a stack cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function Stack(entries) {
            var data = this.__data__ = new ListCache(entries);
            this.size = data.size;
        }
        /**
     * Removes all key-value entries from the stack.
     *
     * @private
     * @name clear
     * @memberOf Stack
     */ function stackClear() {
            this.__data__ = new ListCache;
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the stack.
     *
     * @private
     * @name delete
     * @memberOf Stack
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function stackDelete(key) {
            var data = this.__data__, result = data["delete"](key);
            this.size = data.size;
            return result;
        }
        /**
     * Gets the stack value for `key`.
     *
     * @private
     * @name get
     * @memberOf Stack
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function stackGet(key) {
            return this.__data__.get(key);
        }
        /**
     * Checks if a stack value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Stack
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function stackHas(key) {
            return this.__data__.has(key);
        }
        /**
     * Sets the stack `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Stack
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the stack cache instance.
     */ function stackSet(key, value) {
            var data = this.__data__;
            if (data instanceof ListCache) {
                var pairs = data.__data__;
                if (!Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
                    pairs.push([
                        key,
                        value
                    ]);
                    this.size = ++data.size;
                    return this;
                }
                data = this.__data__ = new MapCache(pairs);
            }
            data.set(key, value);
            this.size = data.size;
            return this;
        }
        // Add methods to `Stack`.
        Stack.prototype.clear = stackClear;
        Stack.prototype["delete"] = stackDelete;
        Stack.prototype.get = stackGet;
        Stack.prototype.has = stackHas;
        Stack.prototype.set = stackSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates an array of the enumerable property names of the array-like `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @param {boolean} inherited Specify returning inherited property names.
     * @returns {Array} Returns the array of property names.
     */ function arrayLikeKeys(value, inherited) {
            var isArr = isArray(value), isArg = !isArr && isArguments(value), isBuff = !isArr && !isArg && isBuffer(value), isType = !isArr && !isArg && !isBuff && isTypedArray(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? baseTimes(value.length, String) : [], length = result.length;
            for(var key in value)if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
            (key == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
            isBuff && (key == "offset" || key == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
            isType && (key == "buffer" || key == "byteLength" || key == "byteOffset") || // Skip index properties.
            isIndex(key, length)))) result.push(key);
            return result;
        }
        /**
     * A specialized version of `_.sample` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @returns {*} Returns the random element.
     */ function arraySample(array) {
            var length = array.length;
            return length ? array[baseRandom(0, length - 1)] : undefined;
        }
        /**
     * A specialized version of `_.sampleSize` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */ function arraySampleSize(array, n) {
            return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
        }
        /**
     * A specialized version of `_.shuffle` for arrays.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */ function arrayShuffle(array) {
            return shuffleSelf(copyArray(array));
        }
        /**
     * This function is like `assignValue` except that it doesn't assign
     * `undefined` values.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function assignMergeValue(object, key, value) {
            if (value !== undefined && !eq(object[key], value) || value === undefined && !(key in object)) baseAssignValue(object, key, value);
        }
        /**
     * Assigns `value` to `key` of `object` if the existing value is not equivalent
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function assignValue(object, key, value) {
            var objValue = object[key];
            if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) || value === undefined && !(key in object)) baseAssignValue(object, key, value);
        }
        /**
     * Gets the index at which the `key` is found in `array` of key-value pairs.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {*} key The key to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     */ function assocIndexOf(array, key) {
            var length = array.length;
            while(length--){
                if (eq(array[length][0], key)) return length;
            }
            return -1;
        }
        /**
     * Aggregates elements of `collection` on `accumulator` with keys transformed
     * by `iteratee` and values set by `setter`.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform keys.
     * @param {Object} accumulator The initial aggregated object.
     * @returns {Function} Returns `accumulator`.
     */ function baseAggregator(collection, setter, iteratee, accumulator) {
            baseEach(collection, function(value, key, collection) {
                setter(accumulator, value, iteratee(value), collection);
            });
            return accumulator;
        }
        /**
     * The base implementation of `_.assign` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */ function baseAssign(object, source) {
            return object && copyObject(source, keys(source), object);
        }
        /**
     * The base implementation of `_.assignIn` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */ function baseAssignIn(object, source) {
            return object && copyObject(source, keysIn(source), object);
        }
        /**
     * The base implementation of `assignValue` and `assignMergeValue` without
     * value checks.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function baseAssignValue(object, key, value) {
            if (key == "__proto__" && defineProperty) defineProperty(object, key, {
                "configurable": true,
                "enumerable": true,
                "value": value,
                "writable": true
            });
            else object[key] = value;
        }
        /**
     * The base implementation of `_.at` without support for individual paths.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {string[]} paths The property paths to pick.
     * @returns {Array} Returns the picked elements.
     */ function baseAt(object, paths) {
            var index = -1, length = paths.length, result = Array1(length), skip = object == null;
            while(++index < length)result[index] = skip ? undefined : get(object, paths[index]);
            return result;
        }
        /**
     * The base implementation of `_.clamp` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     */ function baseClamp(number, lower, upper) {
            if (number === number) {
                if (upper !== undefined) number = number <= upper ? number : upper;
                if (lower !== undefined) number = number >= lower ? number : lower;
            }
            return number;
        }
        /**
     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
     * traversed objects.
     *
     * @private
     * @param {*} value The value to clone.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Deep clone
     *  2 - Flatten inherited properties
     *  4 - Clone symbols
     * @param {Function} [customizer] The function to customize cloning.
     * @param {string} [key] The key of `value`.
     * @param {Object} [object] The parent object of `value`.
     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
     * @returns {*} Returns the cloned value.
     */ function baseClone(value, bitmask, customizer, key, object, stack) {
            var result, isDeep = bitmask & CLONE_DEEP_FLAG, isFlat = bitmask & CLONE_FLAT_FLAG, isFull = bitmask & CLONE_SYMBOLS_FLAG;
            if (customizer) result = object ? customizer(value, key, object, stack) : customizer(value);
            if (result !== undefined) return result;
            if (!isObject(value)) return value;
            var isArr = isArray(value);
            if (isArr) {
                result = initCloneArray(value);
                if (!isDeep) return copyArray(value, result);
            } else {
                var tag = getTag(value), isFunc = tag == funcTag || tag == genTag;
                if (isBuffer(value)) return cloneBuffer(value, isDeep);
                if (tag == objectTag || tag == argsTag || isFunc && !object) {
                    result = isFlat || isFunc ? {} : initCloneObject(value);
                    if (!isDeep) return isFlat ? copySymbolsIn(value, baseAssignIn(result, value)) : copySymbols(value, baseAssign(result, value));
                } else {
                    if (!cloneableTags[tag]) return object ? value : {};
                    result = initCloneByTag(value, tag, isDeep);
                }
            }
            // Check for circular references and return its corresponding clone.
            stack || (stack = new Stack);
            var stacked = stack.get(value);
            if (stacked) return stacked;
            stack.set(value, result);
            if (isSet(value)) value.forEach(function(subValue) {
                result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
            });
            else if (isMap(value)) value.forEach(function(subValue, key) {
                result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
            });
            var keysFunc = isFull ? isFlat ? getAllKeysIn : getAllKeys : isFlat ? keysIn : keys;
            var props = isArr ? undefined : keysFunc(value);
            arrayEach(props || value, function(subValue, key) {
                if (props) {
                    key = subValue;
                    subValue = value[key];
                }
                // Recursively populate clone (susceptible to call stack limits).
                assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
            });
            return result;
        }
        /**
     * The base implementation of `_.conforms` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     */ function baseConforms(source) {
            var props = keys(source);
            return function(object) {
                return baseConformsTo(object, source, props);
            };
        }
        /**
     * The base implementation of `_.conformsTo` which accepts `props` to check.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     */ function baseConformsTo(object, source, props) {
            var length = props.length;
            if (object == null) return !length;
            object = Object1(object);
            while(length--){
                var key = props[length], predicate = source[key], value = object[key];
                if (value === undefined && !(key in object) || !predicate(value)) return false;
            }
            return true;
        }
        /**
     * The base implementation of `_.delay` and `_.defer` which accepts `args`
     * to provide to `func`.
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {Array} args The arguments to provide to `func`.
     * @returns {number|Object} Returns the timer id or timeout object.
     */ function baseDelay(func, wait, args) {
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            return setTimeout(function() {
                func.apply(undefined, args);
            }, wait);
        }
        /**
     * The base implementation of methods like `_.difference` without support
     * for excluding multiple arrays or iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Array} values The values to exclude.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     */ function baseDifference(array, values, iteratee, comparator) {
            var index = -1, includes = arrayIncludes, isCommon = true, length = array.length, result = [], valuesLength = values.length;
            if (!length) return result;
            if (iteratee) values = arrayMap(values, baseUnary(iteratee));
            if (comparator) {
                includes = arrayIncludesWith;
                isCommon = false;
            } else if (values.length >= LARGE_ARRAY_SIZE) {
                includes = cacheHas;
                isCommon = false;
                values = new SetCache(values);
            }
            outer: while(++index < length){
                var value = array[index], computed = iteratee == null ? value : iteratee(value);
                value = comparator || value !== 0 ? value : 0;
                if (isCommon && computed === computed) {
                    var valuesIndex = valuesLength;
                    while(valuesIndex--){
                        if (values[valuesIndex] === computed) continue outer;
                    }
                    result.push(value);
                } else if (!includes(values, computed, comparator)) result.push(value);
            }
            return result;
        }
        /**
     * The base implementation of `_.forEach` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */ var baseEach = createBaseEach(baseForOwn);
        /**
     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */ var baseEachRight = createBaseEach(baseForOwnRight, true);
        /**
     * The base implementation of `_.every` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`
     */ function baseEvery(collection, predicate) {
            var result = true;
            baseEach(collection, function(value, index, collection) {
                result = !!predicate(value, index, collection);
                return result;
            });
            return result;
        }
        /**
     * The base implementation of methods like `_.max` and `_.min` which accepts a
     * `comparator` to determine the extremum value.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The iteratee invoked per iteration.
     * @param {Function} comparator The comparator used to compare values.
     * @returns {*} Returns the extremum value.
     */ function baseExtremum(array, iteratee, comparator) {
            var index = -1, length = array.length;
            while(++index < length){
                var value = array[index], current = iteratee(value);
                if (current != null && (computed === undefined ? current === current && !isSymbol(current) : comparator(current, computed))) var computed = current, result = value;
            }
            return result;
        }
        /**
     * The base implementation of `_.fill` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     */ function baseFill(array, value, start, end) {
            var length = array.length;
            start = toInteger(start);
            if (start < 0) start = -start > length ? 0 : length + start;
            end = end === undefined || end > length ? length : toInteger(end);
            if (end < 0) end += length;
            end = start > end ? 0 : toLength(end);
            while(start < end)array[start++] = value;
            return array;
        }
        /**
     * The base implementation of `_.filter` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     */ function baseFilter(collection, predicate) {
            var result = [];
            baseEach(collection, function(value, index, collection) {
                if (predicate(value, index, collection)) result.push(value);
            });
            return result;
        }
        /**
     * The base implementation of `_.flatten` with support for restricting flattening.
     *
     * @private
     * @param {Array} array The array to flatten.
     * @param {number} depth The maximum recursion depth.
     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
     * @param {Array} [result=[]] The initial result value.
     * @returns {Array} Returns the new flattened array.
     */ function baseFlatten(array, depth, predicate, isStrict, result) {
            var index = -1, length = array.length;
            predicate || (predicate = isFlattenable);
            result || (result = []);
            while(++index < length){
                var value = array[index];
                if (depth > 0 && predicate(value)) {
                    if (depth > 1) // Recursively flatten arrays (susceptible to call stack limits).
                    baseFlatten(value, depth - 1, predicate, isStrict, result);
                    else arrayPush(result, value);
                } else if (!isStrict) result[result.length] = value;
            }
            return result;
        }
        /**
     * The base implementation of `baseForOwn` which iterates over `object`
     * properties returned by `keysFunc` and invokes `iteratee` for each property.
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */ var baseFor = createBaseFor();
        /**
     * This function is like `baseFor` except that it iterates over properties
     * in the opposite order.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */ var baseForRight = createBaseFor(true);
        /**
     * The base implementation of `_.forOwn` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */ function baseForOwn(object, iteratee) {
            return object && baseFor(object, iteratee, keys);
        }
        /**
     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */ function baseForOwnRight(object, iteratee) {
            return object && baseForRight(object, iteratee, keys);
        }
        /**
     * The base implementation of `_.functions` which creates an array of
     * `object` function property names filtered from `props`.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Array} props The property names to filter.
     * @returns {Array} Returns the function names.
     */ function baseFunctions(object, props) {
            return arrayFilter(props, function(key) {
                return isFunction(object[key]);
            });
        }
        /**
     * The base implementation of `_.get` without support for default values.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @returns {*} Returns the resolved value.
     */ function baseGet(object, path) {
            path = castPath(path, object);
            var index = 0, length = path.length;
            while(object != null && index < length)object = object[toKey(path[index++])];
            return index && index == length ? object : undefined;
        }
        /**
     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @param {Function} symbolsFunc The function to get the symbols of `object`.
     * @returns {Array} Returns the array of property names and symbols.
     */ function baseGetAllKeys(object, keysFunc, symbolsFunc) {
            var result = keysFunc(object);
            return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
        }
        /**
     * The base implementation of `getTag` without fallbacks for buggy environments.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */ function baseGetTag(value) {
            if (value == null) return value === undefined ? undefinedTag : nullTag;
            return symToStringTag && symToStringTag in Object1(value) ? getRawTag(value) : objectToString(value);
        }
        /**
     * The base implementation of `_.gt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     */ function baseGt(value, other) {
            return value > other;
        }
        /**
     * The base implementation of `_.has` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */ function baseHas(object, key) {
            return object != null && hasOwnProperty.call(object, key);
        }
        /**
     * The base implementation of `_.hasIn` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */ function baseHasIn(object, key) {
            return object != null && key in Object1(object);
        }
        /**
     * The base implementation of `_.inRange` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to check.
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     */ function baseInRange(number, start, end) {
            return number >= nativeMin(start, end) && number < nativeMax(start, end);
        }
        /**
     * The base implementation of methods like `_.intersection`, without support
     * for iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of shared values.
     */ function baseIntersection(arrays, iteratee, comparator) {
            var includes = comparator ? arrayIncludesWith : arrayIncludes, length = arrays[0].length, othLength = arrays.length, othIndex = othLength, caches = Array1(othLength), maxLength = Infinity, result = [];
            while(othIndex--){
                var array = arrays[othIndex];
                if (othIndex && iteratee) array = arrayMap(array, baseUnary(iteratee));
                maxLength = nativeMin(array.length, maxLength);
                caches[othIndex] = !comparator && (iteratee || length >= 120 && array.length >= 120) ? new SetCache(othIndex && array) : undefined;
            }
            array = arrays[0];
            var index = -1, seen = caches[0];
            outer: while(++index < length && result.length < maxLength){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                value = comparator || value !== 0 ? value : 0;
                if (!(seen ? cacheHas(seen, computed) : includes(result, computed, comparator))) {
                    othIndex = othLength;
                    while(--othIndex){
                        var cache = caches[othIndex];
                        if (!(cache ? cacheHas(cache, computed) : includes(arrays[othIndex], computed, comparator))) continue outer;
                    }
                    if (seen) seen.push(computed);
                    result.push(value);
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.invert` and `_.invertBy` which inverts
     * `object` with values transformed by `iteratee` and set by `setter`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform values.
     * @param {Object} accumulator The initial inverted object.
     * @returns {Function} Returns `accumulator`.
     */ function baseInverter(object, setter, iteratee, accumulator) {
            baseForOwn(object, function(value, key, object) {
                setter(accumulator, iteratee(value), key, object);
            });
            return accumulator;
        }
        /**
     * The base implementation of `_.invoke` without support for individual
     * method arguments.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {Array} args The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     */ function baseInvoke(object, path, args) {
            path = castPath(path, object);
            object = parent(object, path);
            var func = object == null ? object : object[toKey(last(path))];
            return func == null ? undefined : apply(func, object, args);
        }
        /**
     * The base implementation of `_.isArguments`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     */ function baseIsArguments(value) {
            return isObjectLike(value) && baseGetTag(value) == argsTag;
        }
        /**
     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     */ function baseIsArrayBuffer(value) {
            return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
        }
        /**
     * The base implementation of `_.isDate` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     */ function baseIsDate(value) {
            return isObjectLike(value) && baseGetTag(value) == dateTag;
        }
        /**
     * The base implementation of `_.isEqual` which supports partial comparisons
     * and tracks traversed objects.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Unordered comparison
     *  2 - Partial comparison
     * @param {Function} [customizer] The function to customize comparisons.
     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     */ function baseIsEqual(value, other, bitmask, customizer, stack) {
            if (value === other) return true;
            if (value == null || other == null || !isObjectLike(value) && !isObjectLike(other)) return value !== value && other !== other;
            return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
        }
        /**
     * A specialized version of `baseIsEqual` for arrays and objects which performs
     * deep comparisons and tracks traversed objects enabling objects with circular
     * references to be compared.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
            var objIsArr = isArray(object), othIsArr = isArray(other), objTag = objIsArr ? arrayTag : getTag(object), othTag = othIsArr ? arrayTag : getTag(other);
            objTag = objTag == argsTag ? objectTag : objTag;
            othTag = othTag == argsTag ? objectTag : othTag;
            var objIsObj = objTag == objectTag, othIsObj = othTag == objectTag, isSameTag = objTag == othTag;
            if (isSameTag && isBuffer(object)) {
                if (!isBuffer(other)) return false;
                objIsArr = true;
                objIsObj = false;
            }
            if (isSameTag && !objIsObj) {
                stack || (stack = new Stack);
                return objIsArr || isTypedArray(object) ? equalArrays(object, other, bitmask, customizer, equalFunc, stack) : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
            }
            if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
                var objIsWrapped = objIsObj && hasOwnProperty.call(object, "__wrapped__"), othIsWrapped = othIsObj && hasOwnProperty.call(other, "__wrapped__");
                if (objIsWrapped || othIsWrapped) {
                    var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
                    stack || (stack = new Stack);
                    return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
                }
            }
            if (!isSameTag) return false;
            stack || (stack = new Stack);
            return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
        }
        /**
     * The base implementation of `_.isMap` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     */ function baseIsMap(value) {
            return isObjectLike(value) && getTag(value) == mapTag;
        }
        /**
     * The base implementation of `_.isMatch` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Array} matchData The property names, values, and compare flags to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     */ function baseIsMatch(object, source, matchData, customizer) {
            var index = matchData.length, length = index, noCustomizer = !customizer;
            if (object == null) return !length;
            object = Object1(object);
            while(index--){
                var data = matchData[index];
                if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) return false;
            }
            while(++index < length){
                data = matchData[index];
                var key = data[0], objValue = object[key], srcValue = data[1];
                if (noCustomizer && data[2]) {
                    if (objValue === undefined && !(key in object)) return false;
                } else {
                    var stack = new Stack;
                    if (customizer) var result = customizer(objValue, srcValue, key, object, source, stack);
                    if (!(result === undefined ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack) : result)) return false;
                }
            }
            return true;
        }
        /**
     * The base implementation of `_.isNative` without bad shim checks.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     */ function baseIsNative(value) {
            if (!isObject(value) || isMasked(value)) return false;
            var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
            return pattern.test(toSource(value));
        }
        /**
     * The base implementation of `_.isRegExp` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     */ function baseIsRegExp(value) {
            return isObjectLike(value) && baseGetTag(value) == regexpTag;
        }
        /**
     * The base implementation of `_.isSet` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     */ function baseIsSet(value) {
            return isObjectLike(value) && getTag(value) == setTag;
        }
        /**
     * The base implementation of `_.isTypedArray` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     */ function baseIsTypedArray(value) {
            return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
        }
        /**
     * The base implementation of `_.iteratee`.
     *
     * @private
     * @param {*} [value=_.identity] The value to convert to an iteratee.
     * @returns {Function} Returns the iteratee.
     */ function baseIteratee(value) {
            // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
            // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
            if (typeof value == "function") return value;
            if (value == null) return identity;
            if (typeof value == "object") return isArray(value) ? baseMatchesProperty(value[0], value[1]) : baseMatches(value);
            return property(value);
        }
        /**
     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function baseKeys(object) {
            if (!isPrototype(object)) return nativeKeys(object);
            var result = [];
            for(var key in Object1(object))if (hasOwnProperty.call(object, key) && key != "constructor") result.push(key);
            return result;
        }
        /**
     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function baseKeysIn(object) {
            if (!isObject(object)) return nativeKeysIn(object);
            var isProto = isPrototype(object), result = [];
            for(var key in object)if (!(key == "constructor" && (isProto || !hasOwnProperty.call(object, key)))) result.push(key);
            return result;
        }
        /**
     * The base implementation of `_.lt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     */ function baseLt(value, other) {
            return value < other;
        }
        /**
     * The base implementation of `_.map` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     */ function baseMap(collection, iteratee) {
            var index = -1, result = isArrayLike(collection) ? Array1(collection.length) : [];
            baseEach(collection, function(value, key, collection) {
                result[++index] = iteratee(value, key, collection);
            });
            return result;
        }
        /**
     * The base implementation of `_.matches` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     */ function baseMatches(source) {
            var matchData = getMatchData(source);
            if (matchData.length == 1 && matchData[0][2]) return matchesStrictComparable(matchData[0][0], matchData[0][1]);
            return function(object) {
                return object === source || baseIsMatch(object, source, matchData);
            };
        }
        /**
     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
     *
     * @private
     * @param {string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */ function baseMatchesProperty(path, srcValue) {
            if (isKey(path) && isStrictComparable(srcValue)) return matchesStrictComparable(toKey(path), srcValue);
            return function(object) {
                var objValue = get(object, path);
                return objValue === undefined && objValue === srcValue ? hasIn(object, path) : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
            };
        }
        /**
     * The base implementation of `_.merge` without support for multiple sources.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} [customizer] The function to customize merged values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */ function baseMerge(object, source, srcIndex, customizer, stack) {
            if (object === source) return;
            baseFor(source, function(srcValue, key) {
                stack || (stack = new Stack);
                if (isObject(srcValue)) baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
                else {
                    var newValue = customizer ? customizer(safeGet(object, key), srcValue, key + "", object, source, stack) : undefined;
                    if (newValue === undefined) newValue = srcValue;
                    assignMergeValue(object, key, newValue);
                }
            }, keysIn);
        }
        /**
     * A specialized version of `baseMerge` for arrays and objects which performs
     * deep merges and tracks traversed objects enabling objects with circular
     * references to be merged.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {string} key The key of the value to merge.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} mergeFunc The function to merge values.
     * @param {Function} [customizer] The function to customize assigned values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */ function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
            var objValue = safeGet(object, key), srcValue = safeGet(source, key), stacked = stack.get(srcValue);
            if (stacked) {
                assignMergeValue(object, key, stacked);
                return;
            }
            var newValue = customizer ? customizer(objValue, srcValue, key + "", object, source, stack) : undefined;
            var isCommon = newValue === undefined;
            if (isCommon) {
                var isArr = isArray(srcValue), isBuff = !isArr && isBuffer(srcValue), isTyped = !isArr && !isBuff && isTypedArray(srcValue);
                newValue = srcValue;
                if (isArr || isBuff || isTyped) {
                    if (isArray(objValue)) newValue = objValue;
                    else if (isArrayLikeObject(objValue)) newValue = copyArray(objValue);
                    else if (isBuff) {
                        isCommon = false;
                        newValue = cloneBuffer(srcValue, true);
                    } else if (isTyped) {
                        isCommon = false;
                        newValue = cloneTypedArray(srcValue, true);
                    } else newValue = [];
                } else if (isPlainObject(srcValue) || isArguments(srcValue)) {
                    newValue = objValue;
                    if (isArguments(objValue)) newValue = toPlainObject(objValue);
                    else if (!isObject(objValue) || isFunction(objValue)) newValue = initCloneObject(srcValue);
                } else isCommon = false;
            }
            if (isCommon) {
                // Recursively merge objects and arrays (susceptible to call stack limits).
                stack.set(srcValue, newValue);
                mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
                stack["delete"](srcValue);
            }
            assignMergeValue(object, key, newValue);
        }
        /**
     * The base implementation of `_.nth` which doesn't coerce arguments.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {number} n The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     */ function baseNth(array, n) {
            var length = array.length;
            if (!length) return;
            n += n < 0 ? length : 0;
            return isIndex(n, length) ? array[n] : undefined;
        }
        /**
     * The base implementation of `_.orderBy` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
     * @param {string[]} orders The sort orders of `iteratees`.
     * @returns {Array} Returns the new sorted array.
     */ function baseOrderBy(collection, iteratees, orders) {
            if (iteratees.length) iteratees = arrayMap(iteratees, function(iteratee) {
                if (isArray(iteratee)) return function(value) {
                    return baseGet(value, iteratee.length === 1 ? iteratee[0] : iteratee);
                };
                return iteratee;
            });
            else iteratees = [
                identity
            ];
            var index = -1;
            iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
            var result = baseMap(collection, function(value, key, collection) {
                var criteria = arrayMap(iteratees, function(iteratee) {
                    return iteratee(value);
                });
                return {
                    "criteria": criteria,
                    "index": ++index,
                    "value": value
                };
            });
            return baseSortBy(result, function(object, other) {
                return compareMultiple(object, other, orders);
            });
        }
        /**
     * The base implementation of `_.pick` without support for individual
     * property identifiers.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @returns {Object} Returns the new object.
     */ function basePick(object, paths) {
            return basePickBy(object, paths, function(value, path) {
                return hasIn(object, path);
            });
        }
        /**
     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @param {Function} predicate The function invoked per property.
     * @returns {Object} Returns the new object.
     */ function basePickBy(object, paths, predicate) {
            var index = -1, length = paths.length, result = {};
            while(++index < length){
                var path = paths[index], value = baseGet(object, path);
                if (predicate(value, path)) baseSet(result, castPath(path, object), value);
            }
            return result;
        }
        /**
     * A specialized version of `baseProperty` which supports deep paths.
     *
     * @private
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     */ function basePropertyDeep(path) {
            return function(object) {
                return baseGet(object, path);
            };
        }
        /**
     * The base implementation of `_.pullAllBy` without support for iteratee
     * shorthands.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     */ function basePullAll(array, values, iteratee, comparator) {
            var indexOf = comparator ? baseIndexOfWith : baseIndexOf, index = -1, length = values.length, seen = array;
            if (array === values) values = copyArray(values);
            if (iteratee) seen = arrayMap(array, baseUnary(iteratee));
            while(++index < length){
                var fromIndex = 0, value = values[index], computed = iteratee ? iteratee(value) : value;
                while((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1){
                    if (seen !== array) splice.call(seen, fromIndex, 1);
                    splice.call(array, fromIndex, 1);
                }
            }
            return array;
        }
        /**
     * The base implementation of `_.pullAt` without support for individual
     * indexes or capturing the removed elements.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {number[]} indexes The indexes of elements to remove.
     * @returns {Array} Returns `array`.
     */ function basePullAt(array, indexes) {
            var length = array ? indexes.length : 0, lastIndex = length - 1;
            while(length--){
                var index = indexes[length];
                if (length == lastIndex || index !== previous) {
                    var previous = index;
                    if (isIndex(index)) splice.call(array, index, 1);
                    else baseUnset(array, index);
                }
            }
            return array;
        }
        /**
     * The base implementation of `_.random` without support for returning
     * floating-point numbers.
     *
     * @private
     * @param {number} lower The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the random number.
     */ function baseRandom(lower, upper) {
            return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
        }
        /**
     * The base implementation of `_.range` and `_.rangeRight` which doesn't
     * coerce arguments.
     *
     * @private
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @param {number} step The value to increment or decrement by.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the range of numbers.
     */ function baseRange(start, end, step, fromRight) {
            var index = -1, length = nativeMax(nativeCeil((end - start) / (step || 1)), 0), result = Array1(length);
            while(length--){
                result[fromRight ? length : ++index] = start;
                start += step;
            }
            return result;
        }
        /**
     * The base implementation of `_.repeat` which doesn't coerce arguments.
     *
     * @private
     * @param {string} string The string to repeat.
     * @param {number} n The number of times to repeat the string.
     * @returns {string} Returns the repeated string.
     */ function baseRepeat(string, n) {
            var result = "";
            if (!string || n < 1 || n > MAX_SAFE_INTEGER) return result;
            // Leverage the exponentiation by squaring algorithm for a faster repeat.
            // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
            do {
                if (n % 2) result += string;
                n = nativeFloor(n / 2);
                if (n) string += string;
            }while (n);
            return result;
        }
        /**
     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     */ function baseRest(func, start) {
            return setToString(overRest(func, start, identity), func + "");
        }
        /**
     * The base implementation of `_.sample`.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     */ function baseSample(collection) {
            return arraySample(values(collection));
        }
        /**
     * The base implementation of `_.sampleSize` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */ function baseSampleSize(collection, n) {
            var array = values(collection);
            return shuffleSelf(array, baseClamp(n, 0, array.length));
        }
        /**
     * The base implementation of `_.set`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */ function baseSet(object, path, value, customizer) {
            if (!isObject(object)) return object;
            path = castPath(path, object);
            var index = -1, length = path.length, lastIndex = length - 1, nested = object;
            while(nested != null && ++index < length){
                var key = toKey(path[index]), newValue = value;
                if (key === "__proto__" || key === "constructor" || key === "prototype") return object;
                if (index != lastIndex) {
                    var objValue = nested[key];
                    newValue = customizer ? customizer(objValue, key, nested) : undefined;
                    if (newValue === undefined) newValue = isObject(objValue) ? objValue : isIndex(path[index + 1]) ? [] : {};
                }
                assignValue(nested, key, newValue);
                nested = nested[key];
            }
            return object;
        }
        /**
     * The base implementation of `setData` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */ var baseSetData = !metaMap ? identity : function(func, data) {
            metaMap.set(func, data);
            return func;
        };
        /**
     * The base implementation of `setToString` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */ var baseSetToString = !defineProperty ? identity : function(func, string) {
            return defineProperty(func, "toString", {
                "configurable": true,
                "enumerable": false,
                "value": constant(string),
                "writable": true
            });
        };
        /**
     * The base implementation of `_.shuffle`.
     *
     * @private
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */ function baseShuffle(collection) {
            return shuffleSelf(values(collection));
        }
        /**
     * The base implementation of `_.slice` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */ function baseSlice(array, start, end) {
            var index = -1, length = array.length;
            if (start < 0) start = -start > length ? 0 : length + start;
            end = end > length ? length : end;
            if (end < 0) end += length;
            length = start > end ? 0 : end - start >>> 0;
            start >>>= 0;
            var result = Array1(length);
            while(++index < length)result[index] = array[index + start];
            return result;
        }
        /**
     * The base implementation of `_.some` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     */ function baseSome(collection, predicate) {
            var result;
            baseEach(collection, function(value, index, collection) {
                result = predicate(value, index, collection);
                return !result;
            });
            return !!result;
        }
        /**
     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
     * performs a binary search of `array` to determine the index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */ function baseSortedIndex(array, value, retHighest) {
            var low = 0, high = array == null ? low : array.length;
            if (typeof value == "number" && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
                while(low < high){
                    var mid = low + high >>> 1, computed = array[mid];
                    if (computed !== null && !isSymbol(computed) && (retHighest ? computed <= value : computed < value)) low = mid + 1;
                    else high = mid;
                }
                return high;
            }
            return baseSortedIndexBy(array, value, identity, retHighest);
        }
        /**
     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
     * which invokes `iteratee` for `value` and each element of `array` to compute
     * their sort ranking. The iteratee is invoked with one argument; (value).
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} iteratee The iteratee invoked per element.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */ function baseSortedIndexBy(array, value, iteratee, retHighest) {
            var low = 0, high = array == null ? 0 : array.length;
            if (high === 0) return 0;
            value = iteratee(value);
            var valIsNaN = value !== value, valIsNull = value === null, valIsSymbol = isSymbol(value), valIsUndefined = value === undefined;
            while(low < high){
                var mid = nativeFloor((low + high) / 2), computed = iteratee(array[mid]), othIsDefined = computed !== undefined, othIsNull = computed === null, othIsReflexive = computed === computed, othIsSymbol = isSymbol(computed);
                if (valIsNaN) var setLow = retHighest || othIsReflexive;
                else if (valIsUndefined) setLow = othIsReflexive && (retHighest || othIsDefined);
                else if (valIsNull) setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
                else if (valIsSymbol) setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
                else if (othIsNull || othIsSymbol) setLow = false;
                else setLow = retHighest ? computed <= value : computed < value;
                if (setLow) low = mid + 1;
                else high = mid;
            }
            return nativeMin(high, MAX_ARRAY_INDEX);
        }
        /**
     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
     * support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */ function baseSortedUniq(array, iteratee) {
            var index = -1, length = array.length, resIndex = 0, result = [];
            while(++index < length){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                if (!index || !eq(computed, seen)) {
                    var seen = computed;
                    result[resIndex++] = value === 0 ? 0 : value;
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.toNumber` which doesn't ensure correct
     * conversions of binary, hexadecimal, or octal string values.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     */ function baseToNumber(value) {
            if (typeof value == "number") return value;
            if (isSymbol(value)) return NAN;
            return +value;
        }
        /**
     * The base implementation of `_.toString` which doesn't convert nullish
     * values to empty strings.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {string} Returns the string.
     */ function baseToString(value) {
            // Exit early for strings to avoid a performance hit in some environments.
            if (typeof value == "string") return value;
            if (isArray(value)) // Recursively convert values (susceptible to call stack limits).
            return arrayMap(value, baseToString) + "";
            if (isSymbol(value)) return symbolToString ? symbolToString.call(value) : "";
            var result = value + "";
            return result == "0" && 1 / value == -INFINITY ? "-0" : result;
        }
        /**
     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */ function baseUniq(array, iteratee, comparator) {
            var index = -1, includes = arrayIncludes, length = array.length, isCommon = true, result = [], seen = result;
            if (comparator) {
                isCommon = false;
                includes = arrayIncludesWith;
            } else if (length >= LARGE_ARRAY_SIZE) {
                var set = iteratee ? null : createSet(array);
                if (set) return setToArray(set);
                isCommon = false;
                includes = cacheHas;
                seen = new SetCache;
            } else seen = iteratee ? [] : result;
            outer: while(++index < length){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                value = comparator || value !== 0 ? value : 0;
                if (isCommon && computed === computed) {
                    var seenIndex = seen.length;
                    while(seenIndex--){
                        if (seen[seenIndex] === computed) continue outer;
                    }
                    if (iteratee) seen.push(computed);
                    result.push(value);
                } else if (!includes(seen, computed, comparator)) {
                    if (seen !== result) seen.push(computed);
                    result.push(value);
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.unset`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The property path to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     */ function baseUnset(object, path) {
            path = castPath(path, object);
            object = parent(object, path);
            return object == null || delete object[toKey(last(path))];
        }
        /**
     * The base implementation of `_.update`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to update.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */ function baseUpdate(object, path, updater, customizer) {
            return baseSet(object, path, updater(baseGet(object, path)), customizer);
        }
        /**
     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
     * without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {Function} predicate The function invoked per iteration.
     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the slice of `array`.
     */ function baseWhile(array, predicate, isDrop, fromRight) {
            var length = array.length, index = fromRight ? length : -1;
            while((fromRight ? index-- : ++index < length) && predicate(array[index], index, array));
            return isDrop ? baseSlice(array, fromRight ? 0 : index, fromRight ? index + 1 : length) : baseSlice(array, fromRight ? index + 1 : 0, fromRight ? length : index);
        }
        /**
     * The base implementation of `wrapperValue` which returns the result of
     * performing a sequence of actions on the unwrapped `value`, where each
     * successive action is supplied the return value of the previous.
     *
     * @private
     * @param {*} value The unwrapped value.
     * @param {Array} actions Actions to perform to resolve the unwrapped value.
     * @returns {*} Returns the resolved value.
     */ function baseWrapperValue(value, actions) {
            var result = value;
            if (result instanceof LazyWrapper) result = result.value();
            return arrayReduce(actions, function(result, action) {
                return action.func.apply(action.thisArg, arrayPush([
                    result
                ], action.args));
            }, result);
        }
        /**
     * The base implementation of methods like `_.xor`, without support for
     * iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of values.
     */ function baseXor(arrays, iteratee, comparator) {
            var length = arrays.length;
            if (length < 2) return length ? baseUniq(arrays[0]) : [];
            var index = -1, result = Array1(length);
            while(++index < length){
                var array = arrays[index], othIndex = -1;
                while(++othIndex < length)if (othIndex != index) result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
            }
            return baseUniq(baseFlatten(result, 1), iteratee, comparator);
        }
        /**
     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
     *
     * @private
     * @param {Array} props The property identifiers.
     * @param {Array} values The property values.
     * @param {Function} assignFunc The function to assign values.
     * @returns {Object} Returns the new object.
     */ function baseZipObject(props, values, assignFunc) {
            var index = -1, length = props.length, valsLength = values.length, result = {};
            while(++index < length){
                var value = index < valsLength ? values[index] : undefined;
                assignFunc(result, props[index], value);
            }
            return result;
        }
        /**
     * Casts `value` to an empty array if it's not an array like object.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Array|Object} Returns the cast array-like object.
     */ function castArrayLikeObject(value) {
            return isArrayLikeObject(value) ? value : [];
        }
        /**
     * Casts `value` to `identity` if it's not a function.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Function} Returns cast function.
     */ function castFunction(value) {
            return typeof value == "function" ? value : identity;
        }
        /**
     * Casts `value` to a path array if it's not one.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {Object} [object] The object to query keys on.
     * @returns {Array} Returns the cast property path array.
     */ function castPath(value, object) {
            if (isArray(value)) return value;
            return isKey(value, object) ? [
                value
            ] : stringToPath(toString(value));
        }
        /**
     * A `baseRest` alias which can be replaced with `identity` by module
     * replacement plugins.
     *
     * @private
     * @type {Function}
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */ var castRest = baseRest;
        /**
     * Casts `array` to a slice if it's needed.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {number} start The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the cast slice.
     */ function castSlice(array, start, end) {
            var length = array.length;
            end = end === undefined ? length : end;
            return !start && end >= length ? array : baseSlice(array, start, end);
        }
        /**
     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
     *
     * @private
     * @param {number|Object} id The timer id or timeout object of the timer to clear.
     */ var clearTimeout = ctxClearTimeout || function(id) {
            return root.clearTimeout(id);
        };
        /**
     * Creates a clone of  `buffer`.
     *
     * @private
     * @param {Buffer} buffer The buffer to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Buffer} Returns the cloned buffer.
     */ function cloneBuffer(buffer, isDeep) {
            if (isDeep) return buffer.slice();
            var length = buffer.length, result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
            buffer.copy(result);
            return result;
        }
        /**
     * Creates a clone of `arrayBuffer`.
     *
     * @private
     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
     * @returns {ArrayBuffer} Returns the cloned array buffer.
     */ function cloneArrayBuffer(arrayBuffer) {
            var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
            new Uint8Array(result).set(new Uint8Array(arrayBuffer));
            return result;
        }
        /**
     * Creates a clone of `dataView`.
     *
     * @private
     * @param {Object} dataView The data view to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned data view.
     */ function cloneDataView(dataView, isDeep) {
            var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
            return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
        }
        /**
     * Creates a clone of `regexp`.
     *
     * @private
     * @param {Object} regexp The regexp to clone.
     * @returns {Object} Returns the cloned regexp.
     */ function cloneRegExp(regexp) {
            var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
            result.lastIndex = regexp.lastIndex;
            return result;
        }
        /**
     * Creates a clone of the `symbol` object.
     *
     * @private
     * @param {Object} symbol The symbol object to clone.
     * @returns {Object} Returns the cloned symbol object.
     */ function cloneSymbol(symbol) {
            return symbolValueOf ? Object1(symbolValueOf.call(symbol)) : {};
        }
        /**
     * Creates a clone of `typedArray`.
     *
     * @private
     * @param {Object} typedArray The typed array to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned typed array.
     */ function cloneTypedArray(typedArray, isDeep) {
            var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
            return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
        }
        /**
     * Compares values to sort them in ascending order.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {number} Returns the sort order indicator for `value`.
     */ function compareAscending(value, other) {
            if (value !== other) {
                var valIsDefined = value !== undefined, valIsNull = value === null, valIsReflexive = value === value, valIsSymbol = isSymbol(value);
                var othIsDefined = other !== undefined, othIsNull = other === null, othIsReflexive = other === other, othIsSymbol = isSymbol(other);
                if (!othIsNull && !othIsSymbol && !valIsSymbol && value > other || valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol || valIsNull && othIsDefined && othIsReflexive || !valIsDefined && othIsReflexive || !valIsReflexive) return 1;
                if (!valIsNull && !valIsSymbol && !othIsSymbol && value < other || othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol || othIsNull && valIsDefined && valIsReflexive || !othIsDefined && valIsReflexive || !othIsReflexive) return -1;
            }
            return 0;
        }
        /**
     * Used by `_.orderBy` to compare multiple properties of a value to another
     * and stable sort them.
     *
     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
     * specify an order of "desc" for descending or "asc" for ascending sort order
     * of corresponding values.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {boolean[]|string[]} orders The order to sort by for each property.
     * @returns {number} Returns the sort order indicator for `object`.
     */ function compareMultiple(object, other, orders) {
            var index = -1, objCriteria = object.criteria, othCriteria = other.criteria, length = objCriteria.length, ordersLength = orders.length;
            while(++index < length){
                var result = compareAscending(objCriteria[index], othCriteria[index]);
                if (result) {
                    if (index >= ordersLength) return result;
                    var order = orders[index];
                    return result * (order == "desc" ? -1 : 1);
                }
            }
            // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
            // that causes it, under certain circumstances, to provide the same value for
            // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
            // for more details.
            //
            // This also ensures a stable sort in V8 and other engines.
            // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
            return object.index - other.index;
        }
        /**
     * Creates an array that is the composition of partially applied arguments,
     * placeholders, and provided arguments into a single array of arguments.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to prepend to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */ function composeArgs(args, partials, holders, isCurried) {
            var argsIndex = -1, argsLength = args.length, holdersLength = holders.length, leftIndex = -1, leftLength = partials.length, rangeLength = nativeMax(argsLength - holdersLength, 0), result = Array1(leftLength + rangeLength), isUncurried = !isCurried;
            while(++leftIndex < leftLength)result[leftIndex] = partials[leftIndex];
            while(++argsIndex < holdersLength)if (isUncurried || argsIndex < argsLength) result[holders[argsIndex]] = args[argsIndex];
            while(rangeLength--)result[leftIndex++] = args[argsIndex++];
            return result;
        }
        /**
     * This function is like `composeArgs` except that the arguments composition
     * is tailored for `_.partialRight`.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to append to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */ function composeArgsRight(args, partials, holders, isCurried) {
            var argsIndex = -1, argsLength = args.length, holdersIndex = -1, holdersLength = holders.length, rightIndex = -1, rightLength = partials.length, rangeLength = nativeMax(argsLength - holdersLength, 0), result = Array1(rangeLength + rightLength), isUncurried = !isCurried;
            while(++argsIndex < rangeLength)result[argsIndex] = args[argsIndex];
            var offset = argsIndex;
            while(++rightIndex < rightLength)result[offset + rightIndex] = partials[rightIndex];
            while(++holdersIndex < holdersLength)if (isUncurried || argsIndex < argsLength) result[offset + holders[holdersIndex]] = args[argsIndex++];
            return result;
        }
        /**
     * Copies the values of `source` to `array`.
     *
     * @private
     * @param {Array} source The array to copy values from.
     * @param {Array} [array=[]] The array to copy values to.
     * @returns {Array} Returns `array`.
     */ function copyArray(source, array) {
            var index = -1, length = source.length;
            array || (array = Array1(length));
            while(++index < length)array[index] = source[index];
            return array;
        }
        /**
     * Copies properties of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy properties from.
     * @param {Array} props The property identifiers to copy.
     * @param {Object} [object={}] The object to copy properties to.
     * @param {Function} [customizer] The function to customize copied values.
     * @returns {Object} Returns `object`.
     */ function copyObject(source, props, object, customizer) {
            var isNew = !object;
            object || (object = {});
            var index = -1, length = props.length;
            while(++index < length){
                var key = props[index];
                var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;
                if (newValue === undefined) newValue = source[key];
                if (isNew) baseAssignValue(object, key, newValue);
                else assignValue(object, key, newValue);
            }
            return object;
        }
        /**
     * Copies own symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */ function copySymbols(source, object) {
            return copyObject(source, getSymbols(source), object);
        }
        /**
     * Copies own and inherited symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */ function copySymbolsIn(source, object) {
            return copyObject(source, getSymbolsIn(source), object);
        }
        /**
     * Creates a function like `_.groupBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} [initializer] The accumulator object initializer.
     * @returns {Function} Returns the new aggregator function.
     */ function createAggregator(setter, initializer) {
            return function(collection, iteratee) {
                var func = isArray(collection) ? arrayAggregator : baseAggregator, accumulator = initializer ? initializer() : {};
                return func(collection, setter, getIteratee(iteratee, 2), accumulator);
            };
        }
        /**
     * Creates a function like `_.assign`.
     *
     * @private
     * @param {Function} assigner The function to assign values.
     * @returns {Function} Returns the new assigner function.
     */ function createAssigner(assigner) {
            return baseRest(function(object, sources) {
                var index = -1, length = sources.length, customizer = length > 1 ? sources[length - 1] : undefined, guard = length > 2 ? sources[2] : undefined;
                customizer = assigner.length > 3 && typeof customizer == "function" ? (length--, customizer) : undefined;
                if (guard && isIterateeCall(sources[0], sources[1], guard)) {
                    customizer = length < 3 ? undefined : customizer;
                    length = 1;
                }
                object = Object1(object);
                while(++index < length){
                    var source = sources[index];
                    if (source) assigner(object, source, index, customizer);
                }
                return object;
            });
        }
        /**
     * Creates a `baseEach` or `baseEachRight` function.
     *
     * @private
     * @param {Function} eachFunc The function to iterate over a collection.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */ function createBaseEach(eachFunc, fromRight) {
            return function(collection, iteratee) {
                if (collection == null) return collection;
                if (!isArrayLike(collection)) return eachFunc(collection, iteratee);
                var length = collection.length, index = fromRight ? length : -1, iterable = Object1(collection);
                while(fromRight ? index-- : ++index < length){
                    if (iteratee(iterable[index], index, iterable) === false) break;
                }
                return collection;
            };
        }
        /**
     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */ function createBaseFor(fromRight) {
            return function(object, iteratee, keysFunc) {
                var index = -1, iterable = Object1(object), props = keysFunc(object), length = props.length;
                while(length--){
                    var key = props[fromRight ? length : ++index];
                    if (iteratee(iterable[key], key, iterable) === false) break;
                }
                return object;
            };
        }
        /**
     * Creates a function that wraps `func` to invoke it with the optional `this`
     * binding of `thisArg`.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createBind(func, bitmask, thisArg) {
            var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor(func);
            function wrapper() {
                var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                return fn.apply(isBind ? thisArg : this, arguments);
            }
            return wrapper;
        }
        /**
     * Creates a function like `_.lowerFirst`.
     *
     * @private
     * @param {string} methodName The name of the `String` case method to use.
     * @returns {Function} Returns the new case function.
     */ function createCaseFirst(methodName) {
            return function(string) {
                string = toString(string);
                var strSymbols = hasUnicode(string) ? stringToArray(string) : undefined;
                var chr = strSymbols ? strSymbols[0] : string.charAt(0);
                var trailing = strSymbols ? castSlice(strSymbols, 1).join("") : string.slice(1);
                return chr[methodName]() + trailing;
            };
        }
        /**
     * Creates a function like `_.camelCase`.
     *
     * @private
     * @param {Function} callback The function to combine each word.
     * @returns {Function} Returns the new compounder function.
     */ function createCompounder(callback) {
            return function(string) {
                return arrayReduce(words(deburr(string).replace(reApos, "")), callback, "");
            };
        }
        /**
     * Creates a function that produces an instance of `Ctor` regardless of
     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
     *
     * @private
     * @param {Function} Ctor The constructor to wrap.
     * @returns {Function} Returns the new wrapped function.
     */ function createCtor(Ctor) {
            return function() {
                // Use a `switch` statement to work with class constructors. See
                // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
                // for more details.
                var args = arguments;
                switch(args.length){
                    case 0:
                        return new Ctor;
                    case 1:
                        return new Ctor(args[0]);
                    case 2:
                        return new Ctor(args[0], args[1]);
                    case 3:
                        return new Ctor(args[0], args[1], args[2]);
                    case 4:
                        return new Ctor(args[0], args[1], args[2], args[3]);
                    case 5:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4]);
                    case 6:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
                    case 7:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
                }
                var thisBinding = baseCreate(Ctor.prototype), result = Ctor.apply(thisBinding, args);
                // Mimic the constructor's `return` behavior.
                // See https://es5.github.io/#x13.2.2 for more details.
                return isObject(result) ? result : thisBinding;
            };
        }
        /**
     * Creates a function that wraps `func` to enable currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {number} arity The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createCurry(func, bitmask, arity) {
            var Ctor = createCtor(func);
            function wrapper() {
                var length = arguments.length, args = Array1(length), index = length, placeholder = getHolder(wrapper);
                while(index--)args[index] = arguments[index];
                var holders = length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder ? [] : replaceHolders(args, placeholder);
                length -= holders.length;
                if (length < arity) return createRecurry(func, bitmask, createHybrid, wrapper.placeholder, undefined, args, holders, undefined, undefined, arity - length);
                var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                return apply(fn, this, args);
            }
            return wrapper;
        }
        /**
     * Creates a `_.find` or `_.findLast` function.
     *
     * @private
     * @param {Function} findIndexFunc The function to find the collection index.
     * @returns {Function} Returns the new find function.
     */ function createFind(findIndexFunc) {
            return function(collection, predicate, fromIndex) {
                var iterable = Object1(collection);
                if (!isArrayLike(collection)) {
                    var iteratee = getIteratee(predicate, 3);
                    collection = keys(collection);
                    predicate = function(key) {
                        return iteratee(iterable[key], key, iterable);
                    };
                }
                var index = findIndexFunc(collection, predicate, fromIndex);
                return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
            };
        }
        /**
     * Creates a `_.flow` or `_.flowRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new flow function.
     */ function createFlow(fromRight) {
            return flatRest(function(funcs) {
                var length = funcs.length, index = length, prereq = LodashWrapper.prototype.thru;
                if (fromRight) funcs.reverse();
                while(index--){
                    var func = funcs[index];
                    if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
                    if (prereq && !wrapper && getFuncName(func) == "wrapper") var wrapper = new LodashWrapper([], true);
                }
                index = wrapper ? index : length;
                while(++index < length){
                    func = funcs[index];
                    var funcName = getFuncName(func), data = funcName == "wrapper" ? getData(func) : undefined;
                    if (data && isLaziable(data[0]) && data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) && !data[4].length && data[9] == 1) wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
                    else wrapper = func.length == 1 && isLaziable(func) ? wrapper[funcName]() : wrapper.thru(func);
                }
                return function() {
                    var args = arguments, value = args[0];
                    if (wrapper && args.length == 1 && isArray(value)) return wrapper.plant(value).value();
                    var index = 0, result = length ? funcs[index].apply(this, args) : value;
                    while(++index < length)result = funcs[index].call(this, result);
                    return result;
                };
            });
        }
        /**
     * Creates a function that wraps `func` to invoke it with optional `this`
     * binding of `thisArg`, partial application, and currying.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [partialsRight] The arguments to append to those provided
     *  to the new function.
     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
            var isAry = bitmask & WRAP_ARY_FLAG, isBind = bitmask & WRAP_BIND_FLAG, isBindKey = bitmask & WRAP_BIND_KEY_FLAG, isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG), isFlip = bitmask & WRAP_FLIP_FLAG, Ctor = isBindKey ? undefined : createCtor(func);
            function wrapper() {
                var length = arguments.length, args = Array1(length), index = length;
                while(index--)args[index] = arguments[index];
                if (isCurried) var placeholder = getHolder(wrapper), holdersCount = countHolders(args, placeholder);
                if (partials) args = composeArgs(args, partials, holders, isCurried);
                if (partialsRight) args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
                length -= holdersCount;
                if (isCurried && length < arity) {
                    var newHolders = replaceHolders(args, placeholder);
                    return createRecurry(func, bitmask, createHybrid, wrapper.placeholder, thisArg, args, newHolders, argPos, ary, arity - length);
                }
                var thisBinding = isBind ? thisArg : this, fn = isBindKey ? thisBinding[func] : func;
                length = args.length;
                if (argPos) args = reorder(args, argPos);
                else if (isFlip && length > 1) args.reverse();
                if (isAry && ary < length) args.length = ary;
                if (this && this !== root && this instanceof wrapper) fn = Ctor || createCtor(fn);
                return fn.apply(thisBinding, args);
            }
            return wrapper;
        }
        /**
     * Creates a function like `_.invertBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} toIteratee The function to resolve iteratees.
     * @returns {Function} Returns the new inverter function.
     */ function createInverter(setter, toIteratee) {
            return function(object, iteratee) {
                return baseInverter(object, setter, toIteratee(iteratee), {});
            };
        }
        /**
     * Creates a function that performs a mathematical operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @param {number} [defaultValue] The value used for `undefined` arguments.
     * @returns {Function} Returns the new mathematical operation function.
     */ function createMathOperation(operator, defaultValue) {
            return function(value, other) {
                var result;
                if (value === undefined && other === undefined) return defaultValue;
                if (value !== undefined) result = value;
                if (other !== undefined) {
                    if (result === undefined) return other;
                    if (typeof value == "string" || typeof other == "string") {
                        value = baseToString(value);
                        other = baseToString(other);
                    } else {
                        value = baseToNumber(value);
                        other = baseToNumber(other);
                    }
                    result = operator(value, other);
                }
                return result;
            };
        }
        /**
     * Creates a function like `_.over`.
     *
     * @private
     * @param {Function} arrayFunc The function to iterate over iteratees.
     * @returns {Function} Returns the new over function.
     */ function createOver(arrayFunc) {
            return flatRest(function(iteratees) {
                iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
                return baseRest(function(args) {
                    var thisArg = this;
                    return arrayFunc(iteratees, function(iteratee) {
                        return apply(iteratee, thisArg, args);
                    });
                });
            });
        }
        /**
     * Creates the padding for `string` based on `length`. The `chars` string
     * is truncated if the number of characters exceeds `length`.
     *
     * @private
     * @param {number} length The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padding for `string`.
     */ function createPadding(length, chars) {
            chars = chars === undefined ? " " : baseToString(chars);
            var charsLength = chars.length;
            if (charsLength < 2) return charsLength ? baseRepeat(chars, length) : chars;
            var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
            return hasUnicode(chars) ? castSlice(stringToArray(result), 0, length).join("") : result.slice(0, length);
        }
        /**
     * Creates a function that wraps `func` to invoke it with the `this` binding
     * of `thisArg` and `partials` prepended to the arguments it receives.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {Array} partials The arguments to prepend to those provided to
     *  the new function.
     * @returns {Function} Returns the new wrapped function.
     */ function createPartial(func, bitmask, thisArg, partials) {
            var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor(func);
            function wrapper() {
                var argsIndex = -1, argsLength = arguments.length, leftIndex = -1, leftLength = partials.length, args = Array1(leftLength + argsLength), fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                while(++leftIndex < leftLength)args[leftIndex] = partials[leftIndex];
                while(argsLength--)args[leftIndex++] = arguments[++argsIndex];
                return apply(fn, isBind ? thisArg : this, args);
            }
            return wrapper;
        }
        /**
     * Creates a `_.range` or `_.rangeRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new range function.
     */ function createRange(fromRight) {
            return function(start, end, step) {
                if (step && typeof step != "number" && isIterateeCall(start, end, step)) end = step = undefined;
                // Ensure the sign of `-0` is preserved.
                start = toFinite(start);
                if (end === undefined) {
                    end = start;
                    start = 0;
                } else end = toFinite(end);
                step = step === undefined ? start < end ? 1 : -1 : toFinite(step);
                return baseRange(start, end, step, fromRight);
            };
        }
        /**
     * Creates a function that performs a relational operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @returns {Function} Returns the new relational operation function.
     */ function createRelationalOperation(operator) {
            return function(value, other) {
                if (!(typeof value == "string" && typeof other == "string")) {
                    value = toNumber(value);
                    other = toNumber(other);
                }
                return operator(value, other);
            };
        }
        /**
     * Creates a function that wraps `func` to continue currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {Function} wrapFunc The function to create the `func` wrapper.
     * @param {*} placeholder The placeholder value.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
            var isCurry = bitmask & WRAP_CURRY_FLAG, newHolders = isCurry ? holders : undefined, newHoldersRight = isCurry ? undefined : holders, newPartials = isCurry ? partials : undefined, newPartialsRight = isCurry ? undefined : partials;
            bitmask |= isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG;
            bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);
            if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
            var newData = [
                func,
                bitmask,
                thisArg,
                newPartials,
                newHolders,
                newPartialsRight,
                newHoldersRight,
                argPos,
                ary,
                arity
            ];
            var result = wrapFunc.apply(undefined, newData);
            if (isLaziable(func)) setData(result, newData);
            result.placeholder = placeholder;
            return setWrapToString(result, func, bitmask);
        }
        /**
     * Creates a function like `_.round`.
     *
     * @private
     * @param {string} methodName The name of the `Math` method to use when rounding.
     * @returns {Function} Returns the new round function.
     */ function createRound(methodName) {
            var func = Math[methodName];
            return function(number, precision) {
                number = toNumber(number);
                precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
                if (precision && nativeIsFinite(number)) {
                    // Shift with exponential notation to avoid floating-point issues.
                    // See [MDN](https://mdn.io/round#Examples) for more details.
                    var pair = (toString(number) + "e").split("e"), value = func(pair[0] + "e" + (+pair[1] + precision));
                    pair = (toString(value) + "e").split("e");
                    return +(pair[0] + "e" + (+pair[1] - precision));
                }
                return func(number);
            };
        }
        /**
     * Creates a set object of `values`.
     *
     * @private
     * @param {Array} values The values to add to the set.
     * @returns {Object} Returns the new set.
     */ var createSet = !(Set && 1 / setToArray(new Set([
            ,
            -0
        ]))[1] == INFINITY) ? noop : function(values) {
            return new Set(values);
        };
        /**
     * Creates a `_.toPairs` or `_.toPairsIn` function.
     *
     * @private
     * @param {Function} keysFunc The function to get the keys of a given object.
     * @returns {Function} Returns the new pairs function.
     */ function createToPairs(keysFunc) {
            return function(object) {
                var tag = getTag(object);
                if (tag == mapTag) return mapToArray(object);
                if (tag == setTag) return setToPairs(object);
                return baseToPairs(object, keysFunc(object));
            };
        }
        /**
     * Creates a function that either curries or invokes `func` with optional
     * `this` binding and partially applied arguments.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags.
     *    1 - `_.bind`
     *    2 - `_.bindKey`
     *    4 - `_.curry` or `_.curryRight` of a bound function
     *    8 - `_.curry`
     *   16 - `_.curryRight`
     *   32 - `_.partial`
     *   64 - `_.partialRight`
     *  128 - `_.rearg`
     *  256 - `_.ary`
     *  512 - `_.flip`
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to be partially applied.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
            var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
            if (!isBindKey && typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            var length = partials ? partials.length : 0;
            if (!length) {
                bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
                partials = holders = undefined;
            }
            ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
            arity = arity === undefined ? arity : toInteger(arity);
            length -= holders ? holders.length : 0;
            if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
                var partialsRight = partials, holdersRight = holders;
                partials = holders = undefined;
            }
            var data = isBindKey ? undefined : getData(func);
            var newData = [
                func,
                bitmask,
                thisArg,
                partials,
                holders,
                partialsRight,
                holdersRight,
                argPos,
                ary,
                arity
            ];
            if (data) mergeData(newData, data);
            func = newData[0];
            bitmask = newData[1];
            thisArg = newData[2];
            partials = newData[3];
            holders = newData[4];
            arity = newData[9] = newData[9] === undefined ? isBindKey ? 0 : func.length : nativeMax(newData[9] - length, 0);
            if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
            if (!bitmask || bitmask == WRAP_BIND_FLAG) var result = createBind(func, bitmask, thisArg);
            else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) result = createCurry(func, bitmask, arity);
            else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) result = createPartial(func, bitmask, thisArg, partials);
            else result = createHybrid.apply(undefined, newData);
            var setter = data ? baseSetData : setData;
            return setWrapToString(setter(result, newData), func, bitmask);
        }
        /**
     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
     * of source objects to the destination object for all destination properties
     * that resolve to `undefined`.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to assign.
     * @param {Object} object The parent object of `objValue`.
     * @returns {*} Returns the value to assign.
     */ function customDefaultsAssignIn(objValue, srcValue, key, object) {
            if (objValue === undefined || eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key)) return srcValue;
            return objValue;
        }
        /**
     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
     * objects into destination objects that are passed thru.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to merge.
     * @param {Object} object The parent object of `objValue`.
     * @param {Object} source The parent object of `srcValue`.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     * @returns {*} Returns the value to assign.
     */ function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
            if (isObject(objValue) && isObject(srcValue)) {
                // Recursively merge objects and arrays (susceptible to call stack limits).
                stack.set(srcValue, objValue);
                baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
                stack["delete"](srcValue);
            }
            return objValue;
        }
        /**
     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
     * objects.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {string} key The key of the property to inspect.
     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
     */ function customOmitClone(value) {
            return isPlainObject(value) ? undefined : value;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for arrays with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Array} array The array to compare.
     * @param {Array} other The other array to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `array` and `other` objects.
     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
     */ function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
            if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
            // Check that cyclic values are equal.
            var arrStacked = stack.get(array);
            var othStacked = stack.get(other);
            if (arrStacked && othStacked) return arrStacked == other && othStacked == array;
            var index = -1, result = true, seen = bitmask & COMPARE_UNORDERED_FLAG ? new SetCache : undefined;
            stack.set(array, other);
            stack.set(other, array);
            // Ignore non-index properties.
            while(++index < arrLength){
                var arrValue = array[index], othValue = other[index];
                if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
                if (compared !== undefined) {
                    if (compared) continue;
                    result = false;
                    break;
                }
                // Recursively compare arrays (susceptible to call stack limits).
                if (seen) {
                    if (!arraySome(other, function(othValue, othIndex) {
                        if (!cacheHas(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) return seen.push(othIndex);
                    })) {
                        result = false;
                        break;
                    }
                } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
                    result = false;
                    break;
                }
            }
            stack["delete"](array);
            stack["delete"](other);
            return result;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for comparing objects of
     * the same `toStringTag`.
     *
     * **Note:** This function only supports comparing values with tags of
     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {string} tag The `toStringTag` of the objects to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
            switch(tag){
                case dataViewTag:
                    if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
                    object = object.buffer;
                    other = other.buffer;
                case arrayBufferTag:
                    if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array(object), new Uint8Array(other))) return false;
                    return true;
                case boolTag:
                case dateTag:
                case numberTag:
                    // Coerce booleans to `1` or `0` and dates to milliseconds.
                    // Invalid dates are coerced to `NaN`.
                    return eq(+object, +other);
                case errorTag:
                    return object.name == other.name && object.message == other.message;
                case regexpTag:
                case stringTag:
                    // Coerce regexes to strings and treat strings, primitives and objects,
                    // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
                    // for more details.
                    return object == other + "";
                case mapTag:
                    var convert = mapToArray;
                case setTag:
                    var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
                    convert || (convert = setToArray);
                    if (object.size != other.size && !isPartial) return false;
                    // Assume cyclic values are equal.
                    var stacked = stack.get(object);
                    if (stacked) return stacked == other;
                    bitmask |= COMPARE_UNORDERED_FLAG;
                    // Recursively compare objects (susceptible to call stack limits).
                    stack.set(object, other);
                    var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
                    stack["delete"](object);
                    return result;
                case symbolTag:
                    if (symbolValueOf) return symbolValueOf.call(object) == symbolValueOf.call(other);
            }
            return false;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for objects with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG, objProps = getAllKeys(object), objLength = objProps.length, othProps = getAllKeys(other), othLength = othProps.length;
            if (objLength != othLength && !isPartial) return false;
            var index = objLength;
            while(index--){
                var key = objProps[index];
                if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) return false;
            }
            // Check that cyclic values are equal.
            var objStacked = stack.get(object);
            var othStacked = stack.get(other);
            if (objStacked && othStacked) return objStacked == other && othStacked == object;
            var result = true;
            stack.set(object, other);
            stack.set(other, object);
            var skipCtor = isPartial;
            while(++index < objLength){
                key = objProps[index];
                var objValue = object[key], othValue = other[key];
                if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
                // Recursively compare objects (susceptible to call stack limits).
                if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
                    result = false;
                    break;
                }
                skipCtor || (skipCtor = key == "constructor");
            }
            if (result && !skipCtor) {
                var objCtor = object.constructor, othCtor = other.constructor;
                // Non `Object` object instances with different constructors are not equal.
                if (objCtor != othCtor && "constructor" in object && "constructor" in other && !(typeof objCtor == "function" && objCtor instanceof objCtor && typeof othCtor == "function" && othCtor instanceof othCtor)) result = false;
            }
            stack["delete"](object);
            stack["delete"](other);
            return result;
        }
        /**
     * A specialized version of `baseRest` which flattens the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */ function flatRest(func) {
            return setToString(overRest(func, undefined, flatten), func + "");
        }
        /**
     * Creates an array of own enumerable property names and symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */ function getAllKeys(object) {
            return baseGetAllKeys(object, keys, getSymbols);
        }
        /**
     * Creates an array of own and inherited enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */ function getAllKeysIn(object) {
            return baseGetAllKeys(object, keysIn, getSymbolsIn);
        }
        /**
     * Gets metadata for `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {*} Returns the metadata for `func`.
     */ var getData = !metaMap ? noop : function(func) {
            return metaMap.get(func);
        };
        /**
     * Gets the name of `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {string} Returns the function name.
     */ function getFuncName(func) {
            var result = func.name + "", array = realNames[result], length = hasOwnProperty.call(realNames, result) ? array.length : 0;
            while(length--){
                var data = array[length], otherFunc = data.func;
                if (otherFunc == null || otherFunc == func) return data.name;
            }
            return result;
        }
        /**
     * Gets the argument placeholder value for `func`.
     *
     * @private
     * @param {Function} func The function to inspect.
     * @returns {*} Returns the placeholder value.
     */ function getHolder(func) {
            var object = hasOwnProperty.call(lodash, "placeholder") ? lodash : func;
            return object.placeholder;
        }
        /**
     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
     * this function returns the custom method, otherwise it returns `baseIteratee`.
     * If arguments are provided, the chosen function is invoked with them and
     * its result is returned.
     *
     * @private
     * @param {*} [value] The value to convert to an iteratee.
     * @param {number} [arity] The arity of the created iteratee.
     * @returns {Function} Returns the chosen function or its result.
     */ function getIteratee() {
            var result = lodash.iteratee || iteratee;
            result = result === iteratee ? baseIteratee : result;
            return arguments.length ? result(arguments[0], arguments[1]) : result;
        }
        /**
     * Gets the data for `map`.
     *
     * @private
     * @param {Object} map The map to query.
     * @param {string} key The reference key.
     * @returns {*} Returns the map data.
     */ function getMapData(map, key) {
            var data = map.__data__;
            return isKeyable(key) ? data[typeof key == "string" ? "string" : "hash"] : data.map;
        }
        /**
     * Gets the property names, values, and compare flags of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the match data of `object`.
     */ function getMatchData(object) {
            var result = keys(object), length = result.length;
            while(length--){
                var key = result[length], value = object[key];
                result[length] = [
                    key,
                    value,
                    isStrictComparable(value)
                ];
            }
            return result;
        }
        /**
     * Gets the native function at `key` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the method to get.
     * @returns {*} Returns the function if it's native, else `undefined`.
     */ function getNative(object, key) {
            var value = getValue(object, key);
            return baseIsNative(value) ? value : undefined;
        }
        /**
     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the raw `toStringTag`.
     */ function getRawTag(value) {
            var isOwn = hasOwnProperty.call(value, symToStringTag), tag = value[symToStringTag];
            try {
                value[symToStringTag] = undefined;
                var unmasked = true;
            } catch (e) {}
            var result = nativeObjectToString.call(value);
            if (unmasked) {
                if (isOwn) value[symToStringTag] = tag;
                else delete value[symToStringTag];
            }
            return result;
        }
        /**
     * Creates an array of the own enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */ var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
            if (object == null) return [];
            object = Object1(object);
            return arrayFilter(nativeGetSymbols(object), function(symbol) {
                return propertyIsEnumerable.call(object, symbol);
            });
        };
        /**
     * Creates an array of the own and inherited enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */ var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
            var result = [];
            while(object){
                arrayPush(result, getSymbols(object));
                object = getPrototype(object);
            }
            return result;
        };
        /**
     * Gets the `toStringTag` of `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */ var getTag = baseGetTag;
        // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
        if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag || Map && getTag(new Map) != mapTag || Promise && getTag(Promise.resolve()) != promiseTag || Set && getTag(new Set) != setTag || WeakMap && getTag(new WeakMap) != weakMapTag) getTag = function(value) {
            var result = baseGetTag(value), Ctor = result == objectTag ? value.constructor : undefined, ctorString = Ctor ? toSource(Ctor) : "";
            if (ctorString) switch(ctorString){
                case dataViewCtorString:
                    return dataViewTag;
                case mapCtorString:
                    return mapTag;
                case promiseCtorString:
                    return promiseTag;
                case setCtorString:
                    return setTag;
                case weakMapCtorString:
                    return weakMapTag;
            }
            return result;
        };
        /**
     * Gets the view, applying any `transforms` to the `start` and `end` positions.
     *
     * @private
     * @param {number} start The start of the view.
     * @param {number} end The end of the view.
     * @param {Array} transforms The transformations to apply to the view.
     * @returns {Object} Returns an object containing the `start` and `end`
     *  positions of the view.
     */ function getView(start, end, transforms) {
            var index = -1, length = transforms.length;
            while(++index < length){
                var data = transforms[index], size = data.size;
                switch(data.type){
                    case "drop":
                        start += size;
                        break;
                    case "dropRight":
                        end -= size;
                        break;
                    case "take":
                        end = nativeMin(end, start + size);
                        break;
                    case "takeRight":
                        start = nativeMax(start, end - size);
                        break;
                }
            }
            return {
                "start": start,
                "end": end
            };
        }
        /**
     * Extracts wrapper details from the `source` body comment.
     *
     * @private
     * @param {string} source The source to inspect.
     * @returns {Array} Returns the wrapper details.
     */ function getWrapDetails(source) {
            var match = source.match(reWrapDetails);
            return match ? match[1].split(reSplitDetails) : [];
        }
        /**
     * Checks if `path` exists on `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @param {Function} hasFunc The function to check properties.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     */ function hasPath(object, path, hasFunc) {
            path = castPath(path, object);
            var index = -1, length = path.length, result = false;
            while(++index < length){
                var key = toKey(path[index]);
                if (!(result = object != null && hasFunc(object, key))) break;
                object = object[key];
            }
            if (result || ++index != length) return result;
            length = object == null ? 0 : object.length;
            return !!length && isLength(length) && isIndex(key, length) && (isArray(object) || isArguments(object));
        }
        /**
     * Initializes an array clone.
     *
     * @private
     * @param {Array} array The array to clone.
     * @returns {Array} Returns the initialized clone.
     */ function initCloneArray(array) {
            var length = array.length, result = new array.constructor(length);
            // Add properties assigned by `RegExp#exec`.
            if (length && typeof array[0] == "string" && hasOwnProperty.call(array, "index")) {
                result.index = array.index;
                result.input = array.input;
            }
            return result;
        }
        /**
     * Initializes an object clone.
     *
     * @private
     * @param {Object} object The object to clone.
     * @returns {Object} Returns the initialized clone.
     */ function initCloneObject(object) {
            return typeof object.constructor == "function" && !isPrototype(object) ? baseCreate(getPrototype(object)) : {};
        }
        /**
     * Initializes an object clone based on its `toStringTag`.
     *
     * **Note:** This function only supports cloning values with tags of
     * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
     *
     * @private
     * @param {Object} object The object to clone.
     * @param {string} tag The `toStringTag` of the object to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the initialized clone.
     */ function initCloneByTag(object, tag, isDeep) {
            var Ctor = object.constructor;
            switch(tag){
                case arrayBufferTag:
                    return cloneArrayBuffer(object);
                case boolTag:
                case dateTag:
                    return new Ctor(+object);
                case dataViewTag:
                    return cloneDataView(object, isDeep);
                case float32Tag:
                case float64Tag:
                case int8Tag:
                case int16Tag:
                case int32Tag:
                case uint8Tag:
                case uint8ClampedTag:
                case uint16Tag:
                case uint32Tag:
                    return cloneTypedArray(object, isDeep);
                case mapTag:
                    return new Ctor;
                case numberTag:
                case stringTag:
                    return new Ctor(object);
                case regexpTag:
                    return cloneRegExp(object);
                case setTag:
                    return new Ctor;
                case symbolTag:
                    return cloneSymbol(object);
            }
        }
        /**
     * Inserts wrapper `details` in a comment at the top of the `source` body.
     *
     * @private
     * @param {string} source The source to modify.
     * @returns {Array} details The details to insert.
     * @returns {string} Returns the modified source.
     */ function insertWrapDetails(source, details) {
            var length = details.length;
            if (!length) return source;
            var lastIndex = length - 1;
            details[lastIndex] = (length > 1 ? "& " : "") + details[lastIndex];
            details = details.join(length > 2 ? ", " : " ");
            return source.replace(reWrapComment, "{\n/* [wrapped with " + details + "] */\n");
        }
        /**
     * Checks if `value` is a flattenable `arguments` object or array.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
     */ function isFlattenable(value) {
            return isArray(value) || isArguments(value) || !!(spreadableSymbol && value && value[spreadableSymbol]);
        }
        /**
     * Checks if `value` is a valid array-like index.
     *
     * @private
     * @param {*} value The value to check.
     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
     */ function isIndex(value, length) {
            var type = typeof value;
            length = length == null ? MAX_SAFE_INTEGER : length;
            return !!length && (type == "number" || type != "symbol" && reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
        }
        /**
     * Checks if the given arguments are from an iteratee call.
     *
     * @private
     * @param {*} value The potential iteratee value argument.
     * @param {*} index The potential iteratee index or key argument.
     * @param {*} object The potential iteratee object argument.
     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
     *  else `false`.
     */ function isIterateeCall(value, index, object) {
            if (!isObject(object)) return false;
            var type = typeof index;
            if (type == "number" ? isArrayLike(object) && isIndex(index, object.length) : type == "string" && index in object) return eq(object[index], value);
            return false;
        }
        /**
     * Checks if `value` is a property name and not a property path.
     *
     * @private
     * @param {*} value The value to check.
     * @param {Object} [object] The object to query keys on.
     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
     */ function isKey(value, object) {
            if (isArray(value)) return false;
            var type = typeof value;
            if (type == "number" || type == "symbol" || type == "boolean" || value == null || isSymbol(value)) return true;
            return reIsPlainProp.test(value) || !reIsDeepProp.test(value) || object != null && value in Object1(object);
        }
        /**
     * Checks if `value` is suitable for use as unique object key.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
     */ function isKeyable(value) {
            var type = typeof value;
            return type == "string" || type == "number" || type == "symbol" || type == "boolean" ? value !== "__proto__" : value === null;
        }
        /**
     * Checks if `func` has a lazy counterpart.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
     *  else `false`.
     */ function isLaziable(func) {
            var funcName = getFuncName(func), other = lodash[funcName];
            if (typeof other != "function" || !(funcName in LazyWrapper.prototype)) return false;
            if (func === other) return true;
            var data = getData(other);
            return !!data && func === data[0];
        }
        /**
     * Checks if `func` has its source masked.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
     */ function isMasked(func) {
            return !!maskSrcKey && maskSrcKey in func;
        }
        /**
     * Checks if `func` is capable of being masked.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
     */ var isMaskable = coreJsData ? isFunction : stubFalse;
        /**
     * Checks if `value` is likely a prototype object.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
     */ function isPrototype(value) {
            var Ctor = value && value.constructor, proto = typeof Ctor == "function" && Ctor.prototype || objectProto;
            return value === proto;
        }
        /**
     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` if suitable for strict
     *  equality comparisons, else `false`.
     */ function isStrictComparable(value) {
            return value === value && !isObject(value);
        }
        /**
     * A specialized version of `matchesProperty` for source values suitable
     * for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {string} key The key of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */ function matchesStrictComparable(key, srcValue) {
            return function(object) {
                if (object == null) return false;
                return object[key] === srcValue && (srcValue !== undefined || key in Object1(object));
            };
        }
        /**
     * A specialized version of `_.memoize` which clears the memoized function's
     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
     *
     * @private
     * @param {Function} func The function to have its output memoized.
     * @returns {Function} Returns the new memoized function.
     */ function memoizeCapped(func) {
            var result = memoize(func, function(key) {
                if (cache.size === MAX_MEMOIZE_SIZE) cache.clear();
                return key;
            });
            var cache = result.cache;
            return result;
        }
        /**
     * Merges the function metadata of `source` into `data`.
     *
     * Merging metadata reduces the number of wrappers used to invoke a function.
     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
     * may be applied regardless of execution order. Methods like `_.ary` and
     * `_.rearg` modify function arguments, making the order in which they are
     * executed important, preventing the merging of metadata. However, we make
     * an exception for a safe combined case where curried functions have `_.ary`
     * and or `_.rearg` applied.
     *
     * @private
     * @param {Array} data The destination metadata.
     * @param {Array} source The source metadata.
     * @returns {Array} Returns `data`.
     */ function mergeData(data, source) {
            var bitmask = data[1], srcBitmask = source[1], newBitmask = bitmask | srcBitmask, isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);
            var isCombo = srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_CURRY_FLAG || srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_REARG_FLAG && data[7].length <= source[8] || srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG) && source[7].length <= source[8] && bitmask == WRAP_CURRY_FLAG;
            // Exit early if metadata can't be merged.
            if (!(isCommon || isCombo)) return data;
            // Use source `thisArg` if available.
            if (srcBitmask & WRAP_BIND_FLAG) {
                data[2] = source[2];
                // Set when currying a bound function.
                newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
            }
            // Compose partial arguments.
            var value = source[3];
            if (value) {
                var partials = data[3];
                data[3] = partials ? composeArgs(partials, value, source[4]) : value;
                data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
            }
            // Compose partial right arguments.
            value = source[5];
            if (value) {
                partials = data[5];
                data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
                data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
            }
            // Use source `argPos` if available.
            value = source[7];
            if (value) data[7] = value;
            // Use source `ary` if it's smaller.
            if (srcBitmask & WRAP_ARY_FLAG) data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
            // Use source `arity` if one is not provided.
            if (data[9] == null) data[9] = source[9];
            // Use source `func` and merge bitmasks.
            data[0] = source[0];
            data[1] = newBitmask;
            return data;
        }
        /**
     * This function is like
     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * except that it includes inherited enumerable properties.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function nativeKeysIn(object) {
            var result = [];
            if (object != null) for(var key in Object1(object))result.push(key);
            return result;
        }
        /**
     * Converts `value` to a string using `Object.prototype.toString`.
     *
     * @private
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     */ function objectToString(value) {
            return nativeObjectToString.call(value);
        }
        /**
     * A specialized version of `baseRest` which transforms the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @param {Function} transform The rest array transform.
     * @returns {Function} Returns the new function.
     */ function overRest(func, start, transform) {
            start = nativeMax(start === undefined ? func.length - 1 : start, 0);
            return function() {
                var args = arguments, index = -1, length = nativeMax(args.length - start, 0), array = Array1(length);
                while(++index < length)array[index] = args[start + index];
                index = -1;
                var otherArgs = Array1(start + 1);
                while(++index < start)otherArgs[index] = args[index];
                otherArgs[start] = transform(array);
                return apply(func, this, otherArgs);
            };
        }
        /**
     * Gets the parent value at `path` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array} path The path to get the parent value of.
     * @returns {*} Returns the parent value.
     */ function parent(object, path) {
            return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
        }
        /**
     * Reorder `array` according to the specified indexes where the element at
     * the first index is assigned as the first element, the element at
     * the second index is assigned as the second element, and so on.
     *
     * @private
     * @param {Array} array The array to reorder.
     * @param {Array} indexes The arranged array indexes.
     * @returns {Array} Returns `array`.
     */ function reorder(array, indexes) {
            var arrLength = array.length, length = nativeMin(indexes.length, arrLength), oldArray = copyArray(array);
            while(length--){
                var index = indexes[length];
                array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
            }
            return array;
        }
        /**
     * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the property to get.
     * @returns {*} Returns the property value.
     */ function safeGet(object, key) {
            if (key === "constructor" && typeof object[key] === "function") return;
            if (key == "__proto__") return;
            return object[key];
        }
        /**
     * Sets metadata for `func`.
     *
     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
     * period of time, it will trip its breaker and transition to an identity
     * function to avoid garbage collection pauses in V8. See
     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
     * for more details.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */ var setData = shortOut(baseSetData);
        /**
     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @returns {number|Object} Returns the timer id or timeout object.
     */ var setTimeout = ctxSetTimeout || function(func, wait) {
            return root.setTimeout(func, wait);
        };
        /**
     * Sets the `toString` method of `func` to return `string`.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */ var setToString = shortOut(baseSetToString);
        /**
     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
     * with wrapper details in a comment at the top of the source body.
     *
     * @private
     * @param {Function} wrapper The function to modify.
     * @param {Function} reference The reference function.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Function} Returns `wrapper`.
     */ function setWrapToString(wrapper, reference, bitmask) {
            var source = reference + "";
            return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
        }
        /**
     * Creates a function that'll short out and invoke `identity` instead
     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
     * milliseconds.
     *
     * @private
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new shortable function.
     */ function shortOut(func) {
            var count = 0, lastCalled = 0;
            return function() {
                var stamp = nativeNow(), remaining = HOT_SPAN - (stamp - lastCalled);
                lastCalled = stamp;
                if (remaining > 0) {
                    if (++count >= HOT_COUNT) return arguments[0];
                } else count = 0;
                return func.apply(undefined, arguments);
            };
        }
        /**
     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @param {number} [size=array.length] The size of `array`.
     * @returns {Array} Returns `array`.
     */ function shuffleSelf(array, size) {
            var index = -1, length = array.length, lastIndex = length - 1;
            size = size === undefined ? length : size;
            while(++index < size){
                var rand = baseRandom(index, lastIndex), value = array[rand];
                array[rand] = array[index];
                array[index] = value;
            }
            array.length = size;
            return array;
        }
        /**
     * Converts `string` to a property path array.
     *
     * @private
     * @param {string} string The string to convert.
     * @returns {Array} Returns the property path array.
     */ var stringToPath = memoizeCapped(function(string) {
            var result = [];
            if (string.charCodeAt(0) === 46 /* . */ ) result.push("");
            string.replace(rePropName, function(match, number, quote, subString) {
                result.push(quote ? subString.replace(reEscapeChar, "$1") : number || match);
            });
            return result;
        });
        /**
     * Converts `value` to a string key if it's not a string or symbol.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {string|symbol} Returns the key.
     */ function toKey(value) {
            if (typeof value == "string" || isSymbol(value)) return value;
            var result = value + "";
            return result == "0" && 1 / value == -INFINITY ? "-0" : result;
        }
        /**
     * Converts `func` to its source code.
     *
     * @private
     * @param {Function} func The function to convert.
     * @returns {string} Returns the source code.
     */ function toSource(func) {
            if (func != null) {
                try {
                    return funcToString.call(func);
                } catch (e) {}
                try {
                    return func + "";
                } catch (e) {}
            }
            return "";
        }
        /**
     * Updates wrapper `details` based on `bitmask` flags.
     *
     * @private
     * @returns {Array} details The details to modify.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Array} Returns `details`.
     */ function updateWrapDetails(details, bitmask) {
            arrayEach(wrapFlags, function(pair) {
                var value = "_." + pair[0];
                if (bitmask & pair[1] && !arrayIncludes(details, value)) details.push(value);
            });
            return details.sort();
        }
        /**
     * Creates a clone of `wrapper`.
     *
     * @private
     * @param {Object} wrapper The wrapper to clone.
     * @returns {Object} Returns the cloned wrapper.
     */ function wrapperClone(wrapper) {
            if (wrapper instanceof LazyWrapper) return wrapper.clone();
            var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
            result.__actions__ = copyArray(wrapper.__actions__);
            result.__index__ = wrapper.__index__;
            result.__values__ = wrapper.__values__;
            return result;
        }
        /*------------------------------------------------------------------------*/ /**
     * Creates an array of elements split into groups the length of `size`.
     * If `array` can't be split evenly, the final chunk will be the remaining
     * elements.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to process.
     * @param {number} [size=1] The length of each chunk
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the new array of chunks.
     * @example
     *
     * _.chunk(['a', 'b', 'c', 'd'], 2);
     * // => [['a', 'b'], ['c', 'd']]
     *
     * _.chunk(['a', 'b', 'c', 'd'], 3);
     * // => [['a', 'b', 'c'], ['d']]
     */ function chunk(array, size, guard) {
            if (guard ? isIterateeCall(array, size, guard) : size === undefined) size = 1;
            else size = nativeMax(toInteger(size), 0);
            var length = array == null ? 0 : array.length;
            if (!length || size < 1) return [];
            var index = 0, resIndex = 0, result = Array1(nativeCeil(length / size));
            while(index < length)result[resIndex++] = baseSlice(array, index, index += size);
            return result;
        }
        /**
     * Creates an array with all falsey values removed. The values `false`, `null`,
     * `0`, `""`, `undefined`, and `NaN` are falsey.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to compact.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.compact([0, 1, false, 2, '', 3]);
     * // => [1, 2, 3]
     */ function compact(array) {
            var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
            while(++index < length){
                var value = array[index];
                if (value) result[resIndex++] = value;
            }
            return result;
        }
        /**
     * Creates a new array concatenating `array` with any additional arrays
     * and/or values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to concatenate.
     * @param {...*} [values] The values to concatenate.
     * @returns {Array} Returns the new concatenated array.
     * @example
     *
     * var array = [1];
     * var other = _.concat(array, 2, [3], [[4]]);
     *
     * console.log(other);
     * // => [1, 2, 3, [4]]
     *
     * console.log(array);
     * // => [1]
     */ function concat() {
            var length = arguments.length;
            if (!length) return [];
            var args = Array1(length - 1), array = arguments[0], index = length;
            while(index--)args[index - 1] = arguments[index];
            return arrayPush(isArray(array) ? copyArray(array) : [
                array
            ], baseFlatten(args, 1));
        }
        /**
     * Creates an array of `array` values not included in the other given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * **Note:** Unlike `_.pullAll`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.without, _.xor
     * @example
     *
     * _.difference([2, 1], [2, 3]);
     * // => [1]
     */ var difference = baseRest(function(array, values) {
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true)) : [];
        });
        /**
     * This method is like `_.difference` except that it accepts `iteratee` which
     * is invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */ var differenceBy = baseRest(function(array, values) {
            var iteratee = last(values);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2)) : [];
        });
        /**
     * This method is like `_.difference` except that it accepts `comparator`
     * which is invoked to compare elements of `array` to `values`. The order and
     * references of result values are determined by the first array. The comparator
     * is invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     *
     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }]
     */ var differenceWith = baseRest(function(array, values) {
            var comparator = last(values);
            if (isArrayLikeObject(comparator)) comparator = undefined;
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator) : [];
        });
        /**
     * Creates a slice of `array` with `n` elements dropped from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.drop([1, 2, 3]);
     * // => [2, 3]
     *
     * _.drop([1, 2, 3], 2);
     * // => [3]
     *
     * _.drop([1, 2, 3], 5);
     * // => []
     *
     * _.drop([1, 2, 3], 0);
     * // => [1, 2, 3]
     */ function drop(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            return baseSlice(array, n < 0 ? 0 : n, length);
        }
        /**
     * Creates a slice of `array` with `n` elements dropped from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.dropRight([1, 2, 3]);
     * // => [1, 2]
     *
     * _.dropRight([1, 2, 3], 2);
     * // => [1]
     *
     * _.dropRight([1, 2, 3], 5);
     * // => []
     *
     * _.dropRight([1, 2, 3], 0);
     * // => [1, 2, 3]
     */ function dropRight(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            n = length - n;
            return baseSlice(array, 0, n < 0 ? 0 : n);
        }
        /**
     * Creates a slice of `array` excluding elements dropped from the end.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.dropRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropRightWhile(users, ['active', false]);
     * // => objects for ['barney']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropRightWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */ function dropRightWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), true, true) : [];
        }
        /**
     * Creates a slice of `array` excluding elements dropped from the beginning.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.dropWhile(users, function(o) { return !o.active; });
     * // => objects for ['pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropWhile(users, ['active', false]);
     * // => objects for ['pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */ function dropWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), true) : [];
        }
        /**
     * Fills elements of `array` with `value` from `start` up to, but not
     * including, `end`.
     *
     * **Note:** This method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Array
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.fill(array, 'a');
     * console.log(array);
     * // => ['a', 'a', 'a']
     *
     * _.fill(Array(3), 2);
     * // => [2, 2, 2]
     *
     * _.fill([4, 6, 8, 10], '*', 1, 3);
     * // => [4, '*', '*', 10]
     */ function fill(array, value, start, end) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            if (start && typeof start != "number" && isIterateeCall(array, value, start)) {
                start = 0;
                end = length;
            }
            return baseFill(array, value, start, end);
        }
        /**
     * This method is like `_.find` except that it returns the index of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.findIndex(users, function(o) { return o.user == 'barney'; });
     * // => 0
     *
     * // The `_.matches` iteratee shorthand.
     * _.findIndex(users, { 'user': 'fred', 'active': false });
     * // => 1
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findIndex(users, ['active', false]);
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.findIndex(users, 'active');
     * // => 2
     */ function findIndex(array, predicate, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = fromIndex == null ? 0 : toInteger(fromIndex);
            if (index < 0) index = nativeMax(length + index, 0);
            return baseFindIndex(array, getIteratee(predicate, 3), index);
        }
        /**
     * This method is like `_.findIndex` except that it iterates over elements
     * of `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
     * // => 2
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
     * // => 0
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastIndex(users, ['active', false]);
     * // => 2
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastIndex(users, 'active');
     * // => 0
     */ function findLastIndex(array, predicate, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = length - 1;
            if (fromIndex !== undefined) {
                index = toInteger(fromIndex);
                index = fromIndex < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
            }
            return baseFindIndex(array, getIteratee(predicate, 3), index, true);
        }
        /**
     * Flattens `array` a single level deep.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flatten([1, [2, [3, [4]], 5]]);
     * // => [1, 2, [3, [4]], 5]
     */ function flatten(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseFlatten(array, 1) : [];
        }
        /**
     * Recursively flattens `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flattenDeep([1, [2, [3, [4]], 5]]);
     * // => [1, 2, 3, 4, 5]
     */ function flattenDeep(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseFlatten(array, INFINITY) : [];
        }
        /**
     * Recursively flatten `array` up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * var array = [1, [2, [3, [4]], 5]];
     *
     * _.flattenDepth(array, 1);
     * // => [1, 2, [3, [4]], 5]
     *
     * _.flattenDepth(array, 2);
     * // => [1, 2, 3, [4], 5]
     */ function flattenDepth(array, depth) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            depth = depth === undefined ? 1 : toInteger(depth);
            return baseFlatten(array, depth);
        }
        /**
     * The inverse of `_.toPairs`; this method returns an object composed
     * from key-value `pairs`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} pairs The key-value pairs.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.fromPairs([['a', 1], ['b', 2]]);
     * // => { 'a': 1, 'b': 2 }
     */ function fromPairs(pairs) {
            var index = -1, length = pairs == null ? 0 : pairs.length, result = {};
            while(++index < length){
                var pair = pairs[index];
                result[pair[0]] = pair[1];
            }
            return result;
        }
        /**
     * Gets the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias first
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the first element of `array`.
     * @example
     *
     * _.head([1, 2, 3]);
     * // => 1
     *
     * _.head([]);
     * // => undefined
     */ function head(array) {
            return array && array.length ? array[0] : undefined;
        }
        /**
     * Gets the index at which the first occurrence of `value` is found in `array`
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. If `fromIndex` is negative, it's used as the
     * offset from the end of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.indexOf([1, 2, 1, 2], 2);
     * // => 1
     *
     * // Search from the `fromIndex`.
     * _.indexOf([1, 2, 1, 2], 2, 2);
     * // => 3
     */ function indexOf(array, value, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = fromIndex == null ? 0 : toInteger(fromIndex);
            if (index < 0) index = nativeMax(length + index, 0);
            return baseIndexOf(array, value, index);
        }
        /**
     * Gets all but the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.initial([1, 2, 3]);
     * // => [1, 2]
     */ function initial(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseSlice(array, 0, -1) : [];
        }
        /**
     * Creates an array of unique values that are included in all given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersection([2, 1], [2, 3]);
     * // => [2]
     */ var intersection = baseRest(function(arrays) {
            var mapped = arrayMap(arrays, castArrayLikeObject);
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped) : [];
        });
        /**
     * This method is like `_.intersection` except that it accepts `iteratee`
     * which is invoked for each element of each `arrays` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [2.1]
     *
     * // The `_.property` iteratee shorthand.
     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }]
     */ var intersectionBy = baseRest(function(arrays) {
            var iteratee = last(arrays), mapped = arrayMap(arrays, castArrayLikeObject);
            if (iteratee === last(mapped)) iteratee = undefined;
            else mapped.pop();
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, getIteratee(iteratee, 2)) : [];
        });
        /**
     * This method is like `_.intersection` except that it accepts `comparator`
     * which is invoked to compare elements of `arrays`. The order and references
     * of result values are determined by the first array. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.intersectionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }]
     */ var intersectionWith = baseRest(function(arrays) {
            var comparator = last(arrays), mapped = arrayMap(arrays, castArrayLikeObject);
            comparator = typeof comparator == "function" ? comparator : undefined;
            if (comparator) mapped.pop();
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, undefined, comparator) : [];
        });
        /**
     * Converts all elements in `array` into a string separated by `separator`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to convert.
     * @param {string} [separator=','] The element separator.
     * @returns {string} Returns the joined string.
     * @example
     *
     * _.join(['a', 'b', 'c'], '~');
     * // => 'a~b~c'
     */ function join(array, separator) {
            return array == null ? "" : nativeJoin.call(array, separator);
        }
        /**
     * Gets the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the last element of `array`.
     * @example
     *
     * _.last([1, 2, 3]);
     * // => 3
     */ function last(array) {
            var length = array == null ? 0 : array.length;
            return length ? array[length - 1] : undefined;
        }
        /**
     * This method is like `_.indexOf` except that it iterates over elements of
     * `array` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.lastIndexOf([1, 2, 1, 2], 2);
     * // => 3
     *
     * // Search from the `fromIndex`.
     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
     * // => 1
     */ function lastIndexOf(array, value, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = length;
            if (fromIndex !== undefined) {
                index = toInteger(fromIndex);
                index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
            }
            return value === value ? strictLastIndexOf(array, value, index) : baseFindIndex(array, baseIsNaN, index, true);
        }
        /**
     * Gets the element at index `n` of `array`. If `n` is negative, the nth
     * element from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.11.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=0] The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     *
     * _.nth(array, 1);
     * // => 'b'
     *
     * _.nth(array, -2);
     * // => 'c';
     */ function nth(array, n) {
            return array && array.length ? baseNth(array, toInteger(n)) : undefined;
        }
        /**
     * Removes all given values from `array` using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
     * to remove elements from an array by predicate.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...*} [values] The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pull(array, 'a', 'c');
     * console.log(array);
     * // => ['b', 'b']
     */ var pull = baseRest(pullAll);
        /**
     * This method is like `_.pull` except that it accepts an array of values to remove.
     *
     * **Note:** Unlike `_.difference`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pullAll(array, ['a', 'c']);
     * console.log(array);
     * // => ['b', 'b']
     */ function pullAll(array, values) {
            return array && array.length && values && values.length ? basePullAll(array, values) : array;
        }
        /**
     * This method is like `_.pullAll` except that it accepts `iteratee` which is
     * invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The iteratee is invoked with one argument: (value).
     *
     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
     *
     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
     * console.log(array);
     * // => [{ 'x': 2 }]
     */ function pullAllBy(array, values, iteratee) {
            return array && array.length && values && values.length ? basePullAll(array, values, getIteratee(iteratee, 2)) : array;
        }
        /**
     * This method is like `_.pullAll` except that it accepts `comparator` which
     * is invoked to compare elements of `array` to `values`. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
     *
     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
     * console.log(array);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
     */ function pullAllWith(array, values, comparator) {
            return array && array.length && values && values.length ? basePullAll(array, values, undefined, comparator) : array;
        }
        /**
     * Removes elements from `array` corresponding to `indexes` and returns an
     * array of removed elements.
     *
     * **Note:** Unlike `_.at`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     * var pulled = _.pullAt(array, [1, 3]);
     *
     * console.log(array);
     * // => ['a', 'c']
     *
     * console.log(pulled);
     * // => ['b', 'd']
     */ var pullAt = flatRest(function(array, indexes) {
            var length = array == null ? 0 : array.length, result = baseAt(array, indexes);
            basePullAt(array, arrayMap(indexes, function(index) {
                return isIndex(index, length) ? +index : index;
            }).sort(compareAscending));
            return result;
        });
        /**
     * Removes all elements from `array` that `predicate` returns truthy for
     * and returns an array of the removed elements. The predicate is invoked
     * with three arguments: (value, index, array).
     *
     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
     * to pull elements from an array by value.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = [1, 2, 3, 4];
     * var evens = _.remove(array, function(n) {
     *   return n % 2 == 0;
     * });
     *
     * console.log(array);
     * // => [1, 3]
     *
     * console.log(evens);
     * // => [2, 4]
     */ function remove(array, predicate) {
            var result = [];
            if (!(array && array.length)) return result;
            var index = -1, indexes = [], length = array.length;
            predicate = getIteratee(predicate, 3);
            while(++index < length){
                var value = array[index];
                if (predicate(value, index, array)) {
                    result.push(value);
                    indexes.push(index);
                }
            }
            basePullAt(array, indexes);
            return result;
        }
        /**
     * Reverses `array` so that the first element becomes the last, the second
     * element becomes the second to last, and so on.
     *
     * **Note:** This method mutates `array` and is based on
     * [`Array#reverse`](https://mdn.io/Array/reverse).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.reverse(array);
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */ function reverse(array) {
            return array == null ? array : nativeReverse.call(array);
        }
        /**
     * Creates a slice of `array` from `start` up to, but not including, `end`.
     *
     * **Note:** This method is used instead of
     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
     * returned.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */ function slice(array, start, end) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            if (end && typeof end != "number" && isIterateeCall(array, start, end)) {
                start = 0;
                end = length;
            } else {
                start = start == null ? 0 : toInteger(start);
                end = end === undefined ? length : toInteger(end);
            }
            return baseSlice(array, start, end);
        }
        /**
     * Uses a binary search to determine the lowest index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedIndex([30, 50], 40);
     * // => 1
     */ function sortedIndex(array, value) {
            return baseSortedIndex(array, value);
        }
        /**
     * This method is like `_.sortedIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
     * // => 0
     */ function sortedIndexBy(array, value, iteratee) {
            return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
        }
        /**
     * This method is like `_.indexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
     * // => 1
     */ function sortedIndexOf(array, value) {
            var length = array == null ? 0 : array.length;
            if (length) {
                var index = baseSortedIndex(array, value);
                if (index < length && eq(array[index], value)) return index;
            }
            return -1;
        }
        /**
     * This method is like `_.sortedIndex` except that it returns the highest
     * index at which `value` should be inserted into `array` in order to
     * maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
     * // => 4
     */ function sortedLastIndex(array, value) {
            return baseSortedIndex(array, value, true);
        }
        /**
     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 1
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
     * // => 1
     */ function sortedLastIndexBy(array, value, iteratee) {
            return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
        }
        /**
     * This method is like `_.lastIndexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
     * // => 3
     */ function sortedLastIndexOf(array, value) {
            var length = array == null ? 0 : array.length;
            if (length) {
                var index = baseSortedIndex(array, value, true) - 1;
                if (eq(array[index], value)) return index;
            }
            return -1;
        }
        /**
     * This method is like `_.uniq` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniq([1, 1, 2]);
     * // => [1, 2]
     */ function sortedUniq(array) {
            return array && array.length ? baseSortedUniq(array) : [];
        }
        /**
     * This method is like `_.uniqBy` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
     * // => [1.1, 2.3]
     */ function sortedUniqBy(array, iteratee) {
            return array && array.length ? baseSortedUniq(array, getIteratee(iteratee, 2)) : [];
        }
        /**
     * Gets all but the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.tail([1, 2, 3]);
     * // => [2, 3]
     */ function tail(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseSlice(array, 1, length) : [];
        }
        /**
     * Creates a slice of `array` with `n` elements taken from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.take([1, 2, 3]);
     * // => [1]
     *
     * _.take([1, 2, 3], 2);
     * // => [1, 2]
     *
     * _.take([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.take([1, 2, 3], 0);
     * // => []
     */ function take(array, n, guard) {
            if (!(array && array.length)) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            return baseSlice(array, 0, n < 0 ? 0 : n);
        }
        /**
     * Creates a slice of `array` with `n` elements taken from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.takeRight([1, 2, 3]);
     * // => [3]
     *
     * _.takeRight([1, 2, 3], 2);
     * // => [2, 3]
     *
     * _.takeRight([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.takeRight([1, 2, 3], 0);
     * // => []
     */ function takeRight(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            n = length - n;
            return baseSlice(array, n < 0 ? 0 : n, length);
        }
        /**
     * Creates a slice of `array` with elements taken from the end. Elements are
     * taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.takeRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeRightWhile(users, ['active', false]);
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeRightWhile(users, 'active');
     * // => []
     */ function takeRightWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), false, true) : [];
        }
        /**
     * Creates a slice of `array` with elements taken from the beginning. Elements
     * are taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.takeWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeWhile(users, ['active', false]);
     * // => objects for ['barney', 'fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeWhile(users, 'active');
     * // => []
     */ function takeWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3)) : [];
        }
        /**
     * Creates an array of unique values, in order, from all given arrays using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.union([2], [1, 2]);
     * // => [2, 1]
     */ var union = baseRest(function(arrays) {
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
        });
        /**
     * This method is like `_.union` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which uniqueness is computed. Result values are chosen from the first
     * array in which the value occurs. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */ var unionBy = baseRest(function(arrays) {
            var iteratee = last(arrays);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
        });
        /**
     * This method is like `_.union` except that it accepts `comparator` which
     * is invoked to compare elements of `arrays`. Result values are chosen from
     * the first array in which the value occurs. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.unionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */ var unionWith = baseRest(function(arrays) {
            var comparator = last(arrays);
            comparator = typeof comparator == "function" ? comparator : undefined;
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
        });
        /**
     * Creates a duplicate-free version of an array, using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons, in which only the first occurrence of each element
     * is kept. The order of result values is determined by the order they occur
     * in the array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniq([2, 1, 2]);
     * // => [2, 1]
     */ function uniq(array) {
            return array && array.length ? baseUniq(array) : [];
        }
        /**
     * This method is like `_.uniq` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * uniqueness is computed. The order of result values is determined by the
     * order they occur in the array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */ function uniqBy(array, iteratee) {
            return array && array.length ? baseUniq(array, getIteratee(iteratee, 2)) : [];
        }
        /**
     * This method is like `_.uniq` except that it accepts `comparator` which
     * is invoked to compare elements of `array`. The order of result values is
     * determined by the order they occur in the array.The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.uniqWith(objects, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
     */ function uniqWith(array, comparator) {
            comparator = typeof comparator == "function" ? comparator : undefined;
            return array && array.length ? baseUniq(array, undefined, comparator) : [];
        }
        /**
     * This method is like `_.zip` except that it accepts an array of grouped
     * elements and creates an array regrouping the elements to their pre-zip
     * configuration.
     *
     * @static
     * @memberOf _
     * @since 1.2.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     *
     * _.unzip(zipped);
     * // => [['a', 'b'], [1, 2], [true, false]]
     */ function unzip(array) {
            if (!(array && array.length)) return [];
            var length = 0;
            array = arrayFilter(array, function(group) {
                if (isArrayLikeObject(group)) {
                    length = nativeMax(group.length, length);
                    return true;
                }
            });
            return baseTimes(length, function(index) {
                return arrayMap(array, baseProperty(index));
            });
        }
        /**
     * This method is like `_.unzip` except that it accepts `iteratee` to specify
     * how regrouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  regrouped values.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
     * // => [[1, 10, 100], [2, 20, 200]]
     *
     * _.unzipWith(zipped, _.add);
     * // => [3, 30, 300]
     */ function unzipWith(array, iteratee) {
            if (!(array && array.length)) return [];
            var result = unzip(array);
            if (iteratee == null) return result;
            return arrayMap(result, function(group) {
                return apply(iteratee, undefined, group);
            });
        }
        /**
     * Creates an array excluding all given values using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.pull`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...*} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.xor
     * @example
     *
     * _.without([2, 1, 2, 3], 1, 2);
     * // => [3]
     */ var without = baseRest(function(array, values) {
            return isArrayLikeObject(array) ? baseDifference(array, values) : [];
        });
        /**
     * Creates an array of unique values that is the
     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
     * of the given arrays. The order of result values is determined by the order
     * they occur in the arrays.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.without
     * @example
     *
     * _.xor([2, 1], [2, 3]);
     * // => [1, 3]
     */ var xor = baseRest(function(arrays) {
            return baseXor(arrayFilter(arrays, isArrayLikeObject));
        });
        /**
     * This method is like `_.xor` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which by which they're compared. The order of result values is determined
     * by the order they occur in the arrays. The iteratee is invoked with one
     * argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2, 3.4]
     *
     * // The `_.property` iteratee shorthand.
     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */ var xorBy = baseRest(function(arrays) {
            var iteratee = last(arrays);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
        });
        /**
     * This method is like `_.xor` except that it accepts `comparator` which is
     * invoked to compare elements of `arrays`. The order of result values is
     * determined by the order they occur in the arrays. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.xorWith(objects, others, _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */ var xorWith = baseRest(function(arrays) {
            var comparator = last(arrays);
            comparator = typeof comparator == "function" ? comparator : undefined;
            return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
        });
        /**
     * Creates an array of grouped elements, the first of which contains the
     * first elements of the given arrays, the second of which contains the
     * second elements of the given arrays, and so on.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     */ var zip = baseRest(unzip);
        /**
     * This method is like `_.fromPairs` except that it accepts two arrays,
     * one of property identifiers and one of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 0.4.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObject(['a', 'b'], [1, 2]);
     * // => { 'a': 1, 'b': 2 }
     */ function zipObject(props, values) {
            return baseZipObject(props || [], values || [], assignValue);
        }
        /**
     * This method is like `_.zipObject` except that it supports property paths.
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
     */ function zipObjectDeep(props, values) {
            return baseZipObject(props || [], values || [], baseSet);
        }
        /**
     * This method is like `_.zip` except that it accepts `iteratee` to specify
     * how grouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  grouped values.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
     *   return a + b + c;
     * });
     * // => [111, 222]
     */ var zipWith = baseRest(function(arrays) {
            var length = arrays.length, iteratee = length > 1 ? arrays[length - 1] : undefined;
            iteratee = typeof iteratee == "function" ? (arrays.pop(), iteratee) : undefined;
            return unzipWith(arrays, iteratee);
        });
        /*------------------------------------------------------------------------*/ /**
     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
     * chain sequences enabled. The result of such sequences must be unwrapped
     * with `_#value`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Seq
     * @param {*} value The value to wrap.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36 },
     *   { 'user': 'fred',    'age': 40 },
     *   { 'user': 'pebbles', 'age': 1 }
     * ];
     *
     * var youngest = _
     *   .chain(users)
     *   .sortBy('age')
     *   .map(function(o) {
     *     return o.user + ' is ' + o.age;
     *   })
     *   .head()
     *   .value();
     * // => 'pebbles is 1'
     */ function chain(value) {
            var result = lodash(value);
            result.__chain__ = true;
            return result;
        }
        /**
     * This method invokes `interceptor` and returns `value`. The interceptor
     * is invoked with one argument; (value). The purpose of this method is to
     * "tap into" a method chain sequence in order to modify intermediate results.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns `value`.
     * @example
     *
     * _([1, 2, 3])
     *  .tap(function(array) {
     *    // Mutate input array.
     *    array.pop();
     *  })
     *  .reverse()
     *  .value();
     * // => [2, 1]
     */ function tap(value, interceptor) {
            interceptor(value);
            return value;
        }
        /**
     * This method is like `_.tap` except that it returns the result of `interceptor`.
     * The purpose of this method is to "pass thru" values replacing intermediate
     * results in a method chain sequence.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns the result of `interceptor`.
     * @example
     *
     * _('  abc  ')
     *  .chain()
     *  .trim()
     *  .thru(function(value) {
     *    return [value];
     *  })
     *  .value();
     * // => ['abc']
     */ function thru(value, interceptor) {
            return interceptor(value);
        }
        /**
     * This method is the wrapper version of `_.at`.
     *
     * @name at
     * @memberOf _
     * @since 1.0.0
     * @category Seq
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _(object).at(['a[0].b.c', 'a[1]']).value();
     * // => [3, 4]
     */ var wrapperAt = flatRest(function(paths) {
            var length = paths.length, start = length ? paths[0] : 0, value = this.__wrapped__, interceptor = function(object) {
                return baseAt(object, paths);
            };
            if (length > 1 || this.__actions__.length || !(value instanceof LazyWrapper) || !isIndex(start)) return this.thru(interceptor);
            value = value.slice(start, +start + (length ? 1 : 0));
            value.__actions__.push({
                "func": thru,
                "args": [
                    interceptor
                ],
                "thisArg": undefined
            });
            return new LodashWrapper(value, this.__chain__).thru(function(array) {
                if (length && !array.length) array.push(undefined);
                return array;
            });
        });
        /**
     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
     *
     * @name chain
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * // A sequence without explicit chaining.
     * _(users).head();
     * // => { 'user': 'barney', 'age': 36 }
     *
     * // A sequence with explicit chaining.
     * _(users)
     *   .chain()
     *   .head()
     *   .pick('user')
     *   .value();
     * // => { 'user': 'barney' }
     */ function wrapperChain() {
            return chain(this);
        }
        /**
     * Executes the chain sequence and returns the wrapped result.
     *
     * @name commit
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2];
     * var wrapped = _(array).push(3);
     *
     * console.log(array);
     * // => [1, 2]
     *
     * wrapped = wrapped.commit();
     * console.log(array);
     * // => [1, 2, 3]
     *
     * wrapped.last();
     * // => 3
     *
     * console.log(array);
     * // => [1, 2, 3]
     */ function wrapperCommit() {
            return new LodashWrapper(this.value(), this.__chain__);
        }
        /**
     * Gets the next value on a wrapped object following the
     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
     *
     * @name next
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the next iterator value.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 1 }
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 2 }
     *
     * wrapped.next();
     * // => { 'done': true, 'value': undefined }
     */ function wrapperNext() {
            if (this.__values__ === undefined) this.__values__ = toArray(this.value());
            var done = this.__index__ >= this.__values__.length, value = done ? undefined : this.__values__[this.__index__++];
            return {
                "done": done,
                "value": value
            };
        }
        /**
     * Enables the wrapper to be iterable.
     *
     * @name Symbol.iterator
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the wrapper object.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped[Symbol.iterator]() === wrapped;
     * // => true
     *
     * Array.from(wrapped);
     * // => [1, 2]
     */ function wrapperToIterator() {
            return this;
        }
        /**
     * Creates a clone of the chain sequence planting `value` as the wrapped value.
     *
     * @name plant
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @param {*} value The value to plant.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2]).map(square);
     * var other = wrapped.plant([3, 4]);
     *
     * other.value();
     * // => [9, 16]
     *
     * wrapped.value();
     * // => [1, 4]
     */ function wrapperPlant(value) {
            var result, parent = this;
            while(parent instanceof baseLodash){
                var clone = wrapperClone(parent);
                clone.__index__ = 0;
                clone.__values__ = undefined;
                if (result) previous.__wrapped__ = clone;
                else result = clone;
                var previous = clone;
                parent = parent.__wrapped__;
            }
            previous.__wrapped__ = value;
            return result;
        }
        /**
     * This method is the wrapper version of `_.reverse`.
     *
     * **Note:** This method mutates the wrapped array.
     *
     * @name reverse
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _(array).reverse().value()
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */ function wrapperReverse() {
            var value = this.__wrapped__;
            if (value instanceof LazyWrapper) {
                var wrapped = value;
                if (this.__actions__.length) wrapped = new LazyWrapper(this);
                wrapped = wrapped.reverse();
                wrapped.__actions__.push({
                    "func": thru,
                    "args": [
                        reverse
                    ],
                    "thisArg": undefined
                });
                return new LodashWrapper(wrapped, this.__chain__);
            }
            return this.thru(reverse);
        }
        /**
     * Executes the chain sequence to resolve the unwrapped value.
     *
     * @name value
     * @memberOf _
     * @since 0.1.0
     * @alias toJSON, valueOf
     * @category Seq
     * @returns {*} Returns the resolved unwrapped value.
     * @example
     *
     * _([1, 2, 3]).value();
     * // => [1, 2, 3]
     */ function wrapperValue() {
            return baseWrapperValue(this.__wrapped__, this.__actions__);
        }
        /*------------------------------------------------------------------------*/ /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the number of times the key was returned by `iteratee`. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.countBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': 1, '6': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.countBy(['one', 'two', 'three'], 'length');
     * // => { '3': 2, '5': 1 }
     */ var countBy = createAggregator(function(result, value, key) {
            if (hasOwnProperty.call(result, key)) ++result[key];
            else baseAssignValue(result, key, 1);
        });
        /**
     * Checks if `predicate` returns truthy for **all** elements of `collection`.
     * Iteration is stopped once `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * **Note:** This method returns `true` for
     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
     * elements of empty collections.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`.
     * @example
     *
     * _.every([true, 1, null, 'yes'], Boolean);
     * // => false
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.every(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.every(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.every(users, 'active');
     * // => false
     */ function every(collection, predicate, guard) {
            var func = isArray(collection) ? arrayEvery : baseEvery;
            if (guard && isIterateeCall(collection, predicate, guard)) predicate = undefined;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Iterates over elements of `collection`, returning an array of all elements
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * **Note:** Unlike `_.remove`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.reject
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * _.filter(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, { 'age': 36, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.filter(users, 'active');
     * // => objects for ['barney']
     *
     * // Combining several predicates using `_.overEvery` or `_.overSome`.
     * _.filter(users, _.overSome([{ 'age': 36 }, ['age', 40]]));
     * // => objects for ['fred', 'barney']
     */ function filter(collection, predicate) {
            var func = isArray(collection) ? arrayFilter : baseFilter;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Iterates over elements of `collection`, returning the first element
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': true },
     *   { 'user': 'fred',    'age': 40, 'active': false },
     *   { 'user': 'pebbles', 'age': 1,  'active': true }
     * ];
     *
     * _.find(users, function(o) { return o.age < 40; });
     * // => object for 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.find(users, { 'age': 1, 'active': true });
     * // => object for 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.find(users, ['active', false]);
     * // => object for 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.find(users, 'active');
     * // => object for 'barney'
     */ var find = createFind(findIndex);
        /**
     * This method is like `_.find` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=collection.length-1] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * _.findLast([1, 2, 3, 4], function(n) {
     *   return n % 2 == 1;
     * });
     * // => 3
     */ var findLast = createFind(findLastIndex);
        /**
     * Creates a flattened array of values by running each element in `collection`
     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
     * with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [n, n];
     * }
     *
     * _.flatMap([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */ function flatMap(collection, iteratee) {
            return baseFlatten(map(collection, iteratee), 1);
        }
        /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDeep([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */ function flatMapDeep(collection, iteratee) {
            return baseFlatten(map(collection, iteratee), INFINITY);
        }
        /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDepth([1, 2], duplicate, 2);
     * // => [[1, 1], [2, 2]]
     */ function flatMapDepth(collection, iteratee, depth) {
            depth = depth === undefined ? 1 : toInteger(depth);
            return baseFlatten(map(collection, iteratee), depth);
        }
        /**
     * Iterates over elements of `collection` and invokes `iteratee` for each element.
     * The iteratee is invoked with three arguments: (value, index|key, collection).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * **Note:** As with other "Collections" methods, objects with a "length"
     * property are iterated like arrays. To avoid this behavior use `_.forIn`
     * or `_.forOwn` for object iteration.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias each
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEachRight
     * @example
     *
     * _.forEach([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `1` then `2`.
     *
     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */ function forEach(collection, iteratee) {
            var func = isArray(collection) ? arrayEach : baseEach;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.forEach` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @alias eachRight
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEach
     * @example
     *
     * _.forEachRight([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `2` then `1`.
     */ function forEachRight(collection, iteratee) {
            var func = isArray(collection) ? arrayEachRight : baseEachRight;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The order of grouped values
     * is determined by the order they occur in `collection`. The corresponding
     * value of each key is an array of elements responsible for generating the
     * key. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': [4.2], '6': [6.1, 6.3] }
     *
     * // The `_.property` iteratee shorthand.
     * _.groupBy(['one', 'two', 'three'], 'length');
     * // => { '3': ['one', 'two'], '5': ['three'] }
     */ var groupBy = createAggregator(function(result, value, key) {
            if (hasOwnProperty.call(result, key)) result[key].push(value);
            else baseAssignValue(result, key, [
                value
            ]);
        });
        /**
     * Checks if `value` is in `collection`. If `collection` is a string, it's
     * checked for a substring of `value`, otherwise
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * is used for equality comparisons. If `fromIndex` is negative, it's used as
     * the offset from the end of `collection`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {boolean} Returns `true` if `value` is found, else `false`.
     * @example
     *
     * _.includes([1, 2, 3], 1);
     * // => true
     *
     * _.includes([1, 2, 3], 1, 2);
     * // => false
     *
     * _.includes({ 'a': 1, 'b': 2 }, 1);
     * // => true
     *
     * _.includes('abcd', 'bc');
     * // => true
     */ function includes(collection, value, fromIndex, guard) {
            collection = isArrayLike(collection) ? collection : values(collection);
            fromIndex = fromIndex && !guard ? toInteger(fromIndex) : 0;
            var length = collection.length;
            if (fromIndex < 0) fromIndex = nativeMax(length + fromIndex, 0);
            return isString(collection) ? fromIndex <= length && collection.indexOf(value, fromIndex) > -1 : !!length && baseIndexOf(collection, value, fromIndex) > -1;
        }
        /**
     * Invokes the method at `path` of each element in `collection`, returning
     * an array of the results of each invoked method. Any additional arguments
     * are provided to each invoked method. If `path` is a function, it's invoked
     * for, and `this` bound to, each element in `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array|Function|string} path The path of the method to invoke or
     *  the function invoked per iteration.
     * @param {...*} [args] The arguments to invoke each method with.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
     * // => [[1, 5, 7], [1, 2, 3]]
     *
     * _.invokeMap([123, 456], String.prototype.split, '');
     * // => [['1', '2', '3'], ['4', '5', '6']]
     */ var invokeMap = baseRest(function(collection, path, args) {
            var index = -1, isFunc = typeof path == "function", result = isArrayLike(collection) ? Array1(collection.length) : [];
            baseEach(collection, function(value) {
                result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
            });
            return result;
        });
        /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the last element responsible for generating the key. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * var array = [
     *   { 'dir': 'left', 'code': 97 },
     *   { 'dir': 'right', 'code': 100 }
     * ];
     *
     * _.keyBy(array, function(o) {
     *   return String.fromCharCode(o.code);
     * });
     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
     *
     * _.keyBy(array, 'dir');
     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
     */ var keyBy = createAggregator(function(result, value, key) {
            baseAssignValue(result, key, value);
        });
        /**
     * Creates an array of values by running each element in `collection` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
     *
     * The guarded methods are:
     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * _.map([4, 8], square);
     * // => [16, 64]
     *
     * _.map({ 'a': 4, 'b': 8 }, square);
     * // => [16, 64] (iteration order is not guaranteed)
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, 'user');
     * // => ['barney', 'fred']
     */ function map(collection, iteratee) {
            var func = isArray(collection) ? arrayMap : baseMap;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.sortBy` except that it allows specifying the sort
     * orders of the iteratees to sort by. If `orders` is unspecified, all values
     * are sorted in ascending order. Otherwise, specify an order of "desc" for
     * descending or "asc" for ascending sort order of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @param {string[]} [orders] The sort orders of `iteratees`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 34 },
     *   { 'user': 'fred',   'age': 40 },
     *   { 'user': 'barney', 'age': 36 }
     * ];
     *
     * // Sort by `user` in ascending order and by `age` in descending order.
     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
     */ function orderBy(collection, iteratees, orders, guard) {
            if (collection == null) return [];
            if (!isArray(iteratees)) iteratees = iteratees == null ? [] : [
                iteratees
            ];
            orders = guard ? undefined : orders;
            if (!isArray(orders)) orders = orders == null ? [] : [
                orders
            ];
            return baseOrderBy(collection, iteratees, orders);
        }
        /**
     * Creates an array of elements split into two groups, the first of which
     * contains elements `predicate` returns truthy for, the second of which
     * contains elements `predicate` returns falsey for. The predicate is
     * invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of grouped elements.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': false },
     *   { 'user': 'fred',    'age': 40, 'active': true },
     *   { 'user': 'pebbles', 'age': 1,  'active': false }
     * ];
     *
     * _.partition(users, function(o) { return o.active; });
     * // => objects for [['fred'], ['barney', 'pebbles']]
     *
     * // The `_.matches` iteratee shorthand.
     * _.partition(users, { 'age': 1, 'active': false });
     * // => objects for [['pebbles'], ['barney', 'fred']]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.partition(users, ['active', false]);
     * // => objects for [['barney', 'pebbles'], ['fred']]
     *
     * // The `_.property` iteratee shorthand.
     * _.partition(users, 'active');
     * // => objects for [['fred'], ['barney', 'pebbles']]
     */ var partition = createAggregator(function(result, value, key) {
            result[key ? 0 : 1].push(value);
        }, function() {
            return [
                [],
                []
            ];
        });
        /**
     * Reduces `collection` to a value which is the accumulated result of running
     * each element in `collection` thru `iteratee`, where each successive
     * invocation is supplied the return value of the previous. If `accumulator`
     * is not given, the first element of `collection` is used as the initial
     * value. The iteratee is invoked with four arguments:
     * (accumulator, value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.reduce`, `_.reduceRight`, and `_.transform`.
     *
     * The guarded methods are:
     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
     * and `sortBy`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduceRight
     * @example
     *
     * _.reduce([1, 2], function(sum, n) {
     *   return sum + n;
     * }, 0);
     * // => 3
     *
     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     *   return result;
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
     */ function reduce(collection, iteratee, accumulator) {
            var func = isArray(collection) ? arrayReduce : baseReduce, initAccum = arguments.length < 3;
            return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
        }
        /**
     * This method is like `_.reduce` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduce
     * @example
     *
     * var array = [[0, 1], [2, 3], [4, 5]];
     *
     * _.reduceRight(array, function(flattened, other) {
     *   return flattened.concat(other);
     * }, []);
     * // => [4, 5, 2, 3, 0, 1]
     */ function reduceRight(collection, iteratee, accumulator) {
            var func = isArray(collection) ? arrayReduceRight : baseReduce, initAccum = arguments.length < 3;
            return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
        }
        /**
     * The opposite of `_.filter`; this method returns the elements of `collection`
     * that `predicate` does **not** return truthy for.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.filter
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': true }
     * ];
     *
     * _.reject(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.reject(users, { 'age': 40, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.reject(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.reject(users, 'active');
     * // => objects for ['barney']
     */ function reject(collection, predicate) {
            var func = isArray(collection) ? arrayFilter : baseFilter;
            return func(collection, negate(getIteratee(predicate, 3)));
        }
        /**
     * Gets a random element from `collection`.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     * @example
     *
     * _.sample([1, 2, 3, 4]);
     * // => 2
     */ function sample(collection) {
            var func = isArray(collection) ? arraySample : baseSample;
            return func(collection);
        }
        /**
     * Gets `n` random elements at unique keys from `collection` up to the
     * size of `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @param {number} [n=1] The number of elements to sample.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the random elements.
     * @example
     *
     * _.sampleSize([1, 2, 3], 2);
     * // => [3, 1]
     *
     * _.sampleSize([1, 2, 3], 4);
     * // => [2, 3, 1]
     */ function sampleSize(collection, n, guard) {
            if (guard ? isIterateeCall(collection, n, guard) : n === undefined) n = 1;
            else n = toInteger(n);
            var func = isArray(collection) ? arraySampleSize : baseSampleSize;
            return func(collection, n);
        }
        /**
     * Creates an array of shuffled values, using a version of the
     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     * @example
     *
     * _.shuffle([1, 2, 3, 4]);
     * // => [4, 1, 3, 2]
     */ function shuffle(collection) {
            var func = isArray(collection) ? arrayShuffle : baseShuffle;
            return func(collection);
        }
        /**
     * Gets the size of `collection` by returning its length for array-like
     * values or the number of own enumerable string keyed properties for objects.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @returns {number} Returns the collection size.
     * @example
     *
     * _.size([1, 2, 3]);
     * // => 3
     *
     * _.size({ 'a': 1, 'b': 2 });
     * // => 2
     *
     * _.size('pebbles');
     * // => 7
     */ function size(collection) {
            if (collection == null) return 0;
            if (isArrayLike(collection)) return isString(collection) ? stringSize(collection) : collection.length;
            var tag = getTag(collection);
            if (tag == mapTag || tag == setTag) return collection.size;
            return baseKeys(collection).length;
        }
        /**
     * Checks if `predicate` returns truthy for **any** element of `collection`.
     * Iteration is stopped once `predicate` returns truthy. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     * @example
     *
     * _.some([null, 0, 'yes', false], Boolean);
     * // => true
     *
     * var users = [
     *   { 'user': 'barney', 'active': true },
     *   { 'user': 'fred',   'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.some(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.some(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.some(users, 'active');
     * // => true
     */ function some(collection, predicate, guard) {
            var func = isArray(collection) ? arraySome : baseSome;
            if (guard && isIterateeCall(collection, predicate, guard)) predicate = undefined;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Creates an array of elements, sorted in ascending order by the results of
     * running each element in a collection thru each iteratee. This method
     * performs a stable sort, that is, it preserves the original sort order of
     * equal elements. The iteratees are invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 30 },
     *   { 'user': 'barney', 'age': 34 }
     * ];
     *
     * _.sortBy(users, [function(o) { return o.user; }]);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
     *
     * _.sortBy(users, ['user', 'age']);
     * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
     */ var sortBy = baseRest(function(collection, iteratees) {
            if (collection == null) return [];
            var length = iteratees.length;
            if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) iteratees = [];
            else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) iteratees = [
                iteratees[0]
            ];
            return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
        });
        /*------------------------------------------------------------------------*/ /**
     * Gets the timestamp of the number of milliseconds that have elapsed since
     * the Unix epoch (1 January 1970 00:00:00 UTC).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Date
     * @returns {number} Returns the timestamp.
     * @example
     *
     * _.defer(function(stamp) {
     *   console.log(_.now() - stamp);
     * }, _.now());
     * // => Logs the number of milliseconds it took for the deferred invocation.
     */ var now = ctxNow || function() {
            return root.Date.now();
        };
        /*------------------------------------------------------------------------*/ /**
     * The opposite of `_.before`; this method creates a function that invokes
     * `func` once it's called `n` or more times.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {number} n The number of calls before `func` is invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var saves = ['profile', 'settings'];
     *
     * var done = _.after(saves.length, function() {
     *   console.log('done saving!');
     * });
     *
     * _.forEach(saves, function(type) {
     *   asyncSave({ 'type': type, 'complete': done });
     * });
     * // => Logs 'done saving!' after the two async saves have completed.
     */ function after(n, func) {
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            n = toInteger(n);
            return function() {
                if (--n < 1) return func.apply(this, arguments);
            };
        }
        /**
     * Creates a function that invokes `func`, with up to `n` arguments,
     * ignoring any additional arguments.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @param {number} [n=func.length] The arity cap.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
     * // => [6, 8, 10]
     */ function ary(func, n, guard) {
            n = guard ? undefined : n;
            n = func && n == null ? func.length : n;
            return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
        }
        /**
     * Creates a function that invokes `func`, with the `this` binding and arguments
     * of the created function, while it's called less than `n` times. Subsequent
     * calls to the created function return the result of the last `func` invocation.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {number} n The number of calls at which `func` is no longer invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * jQuery(element).on('click', _.before(5, addContactToList));
     * // => Allows adding up to 4 contacts to the list.
     */ function before(n, func) {
            var result;
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            n = toInteger(n);
            return function() {
                if (--n > 0) result = func.apply(this, arguments);
                if (n <= 1) func = undefined;
                return result;
            };
        }
        /**
     * Creates a function that invokes `func` with the `this` binding of `thisArg`
     * and `partials` prepended to the arguments it receives.
     *
     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for partially applied arguments.
     *
     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
     * property of bound functions.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to bind.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * function greet(greeting, punctuation) {
     *   return greeting + ' ' + this.user + punctuation;
     * }
     *
     * var object = { 'user': 'fred' };
     *
     * var bound = _.bind(greet, object, 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bind(greet, object, _, '!');
     * bound('hi');
     * // => 'hi fred!'
     */ var bind = baseRest(function(func, thisArg, partials) {
            var bitmask = WRAP_BIND_FLAG;
            if (partials.length) {
                var holders = replaceHolders(partials, getHolder(bind));
                bitmask |= WRAP_PARTIAL_FLAG;
            }
            return createWrap(func, bitmask, thisArg, partials, holders);
        });
        /**
     * Creates a function that invokes the method at `object[key]` with `partials`
     * prepended to the arguments it receives.
     *
     * This method differs from `_.bind` by allowing bound functions to reference
     * methods that may be redefined or don't yet exist. See
     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
     * for more details.
     *
     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Function
     * @param {Object} object The object to invoke the method on.
     * @param {string} key The key of the method.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * var object = {
     *   'user': 'fred',
     *   'greet': function(greeting, punctuation) {
     *     return greeting + ' ' + this.user + punctuation;
     *   }
     * };
     *
     * var bound = _.bindKey(object, 'greet', 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * object.greet = function(greeting, punctuation) {
     *   return greeting + 'ya ' + this.user + punctuation;
     * };
     *
     * bound('!');
     * // => 'hiya fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bindKey(object, 'greet', _, '!');
     * bound('hi');
     * // => 'hiya fred!'
     */ var bindKey = baseRest(function(object, key, partials) {
            var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
            if (partials.length) {
                var holders = replaceHolders(partials, getHolder(bindKey));
                bitmask |= WRAP_PARTIAL_FLAG;
            }
            return createWrap(key, bitmask, object, partials, holders);
        });
        /**
     * Creates a function that accepts arguments of `func` and either invokes
     * `func` returning its result, if at least `arity` number of arguments have
     * been provided, or returns a function that accepts the remaining `func`
     * arguments, and so on. The arity of `func` may be specified if `func.length`
     * is not sufficient.
     *
     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curry(abc);
     *
     * curried(1)(2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(1)(_, 3)(2);
     * // => [1, 2, 3]
     */ function curry(func, arity, guard) {
            arity = guard ? undefined : arity;
            var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
            result.placeholder = curry.placeholder;
            return result;
        }
        /**
     * This method is like `_.curry` except that arguments are applied to `func`
     * in the manner of `_.partialRight` instead of `_.partial`.
     *
     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curryRight(abc);
     *
     * curried(3)(2)(1);
     * // => [1, 2, 3]
     *
     * curried(2, 3)(1);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(3)(1, _)(2);
     * // => [1, 2, 3]
     */ function curryRight(func, arity, guard) {
            arity = guard ? undefined : arity;
            var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
            result.placeholder = curryRight.placeholder;
            return result;
        }
        /**
     * Creates a debounced function that delays invoking `func` until after `wait`
     * milliseconds have elapsed since the last time the debounced function was
     * invoked. The debounced function comes with a `cancel` method to cancel
     * delayed `func` invocations and a `flush` method to immediately invoke them.
     * Provide `options` to indicate whether `func` should be invoked on the
     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
     * with the last arguments provided to the debounced function. Subsequent
     * calls to the debounced function return the result of the last `func`
     * invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the debounced function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.debounce` and `_.throttle`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to debounce.
     * @param {number} [wait=0] The number of milliseconds to delay.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=false]
     *  Specify invoking on the leading edge of the timeout.
     * @param {number} [options.maxWait]
     *  The maximum time `func` is allowed to be delayed before it's invoked.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new debounced function.
     * @example
     *
     * // Avoid costly calculations while the window size is in flux.
     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
     *
     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
     * jQuery(element).on('click', _.debounce(sendMail, 300, {
     *   'leading': true,
     *   'trailing': false
     * }));
     *
     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
     * var source = new EventSource('/stream');
     * jQuery(source).on('message', debounced);
     *
     * // Cancel the trailing debounced invocation.
     * jQuery(window).on('popstate', debounced.cancel);
     */ function debounce(func, wait, options) {
            var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            wait = toNumber(wait) || 0;
            if (isObject(options)) {
                leading = !!options.leading;
                maxing = "maxWait" in options;
                maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
                trailing = "trailing" in options ? !!options.trailing : trailing;
            }
            function invokeFunc(time) {
                var args = lastArgs, thisArg = lastThis;
                lastArgs = lastThis = undefined;
                lastInvokeTime = time;
                result = func.apply(thisArg, args);
                return result;
            }
            function leadingEdge(time) {
                // Reset any `maxWait` timer.
                lastInvokeTime = time;
                // Start the timer for the trailing edge.
                timerId = setTimeout(timerExpired, wait);
                // Invoke the leading edge.
                return leading ? invokeFunc(time) : result;
            }
            function remainingWait(time) {
                var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
                return maxing ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
            }
            function shouldInvoke(time) {
                var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
                // Either this is the first call, activity has stopped and we're at the
                // trailing edge, the system time has gone backwards and we're treating
                // it as the trailing edge, or we've hit the `maxWait` limit.
                return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
            }
            function timerExpired() {
                var time = now();
                if (shouldInvoke(time)) return trailingEdge(time);
                // Restart the timer.
                timerId = setTimeout(timerExpired, remainingWait(time));
            }
            function trailingEdge(time) {
                timerId = undefined;
                // Only invoke if we have `lastArgs` which means `func` has been
                // debounced at least once.
                if (trailing && lastArgs) return invokeFunc(time);
                lastArgs = lastThis = undefined;
                return result;
            }
            function cancel() {
                if (timerId !== undefined) clearTimeout(timerId);
                lastInvokeTime = 0;
                lastArgs = lastCallTime = lastThis = timerId = undefined;
            }
            function flush() {
                return timerId === undefined ? result : trailingEdge(now());
            }
            function debounced() {
                var time = now(), isInvoking = shouldInvoke(time);
                lastArgs = arguments;
                lastThis = this;
                lastCallTime = time;
                if (isInvoking) {
                    if (timerId === undefined) return leadingEdge(lastCallTime);
                    if (maxing) {
                        // Handle invocations in a tight loop.
                        clearTimeout(timerId);
                        timerId = setTimeout(timerExpired, wait);
                        return invokeFunc(lastCallTime);
                    }
                }
                if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
                return result;
            }
            debounced.cancel = cancel;
            debounced.flush = flush;
            return debounced;
        }
        /**
     * Defers invoking the `func` until the current call stack has cleared. Any
     * additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to defer.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.defer(function(text) {
     *   console.log(text);
     * }, 'deferred');
     * // => Logs 'deferred' after one millisecond.
     */ var defer = baseRest(function(func, args) {
            return baseDelay(func, 1, args);
        });
        /**
     * Invokes `func` after `wait` milliseconds. Any additional arguments are
     * provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.delay(function(text) {
     *   console.log(text);
     * }, 1000, 'later');
     * // => Logs 'later' after one second.
     */ var delay = baseRest(function(func, wait, args) {
            return baseDelay(func, toNumber(wait) || 0, args);
        });
        /**
     * Creates a function that invokes `func` with arguments reversed.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to flip arguments for.
     * @returns {Function} Returns the new flipped function.
     * @example
     *
     * var flipped = _.flip(function() {
     *   return _.toArray(arguments);
     * });
     *
     * flipped('a', 'b', 'c', 'd');
     * // => ['d', 'c', 'b', 'a']
     */ function flip(func) {
            return createWrap(func, WRAP_FLIP_FLAG);
        }
        /**
     * Creates a function that memoizes the result of `func`. If `resolver` is
     * provided, it determines the cache key for storing the result based on the
     * arguments provided to the memoized function. By default, the first argument
     * provided to the memoized function is used as the map cache key. The `func`
     * is invoked with the `this` binding of the memoized function.
     *
     * **Note:** The cache is exposed as the `cache` property on the memoized
     * function. Its creation may be customized by replacing the `_.memoize.Cache`
     * constructor with one whose instances implement the
     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to have its output memoized.
     * @param {Function} [resolver] The function to resolve the cache key.
     * @returns {Function} Returns the new memoized function.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     * var other = { 'c': 3, 'd': 4 };
     *
     * var values = _.memoize(_.values);
     * values(object);
     * // => [1, 2]
     *
     * values(other);
     * // => [3, 4]
     *
     * object.a = 2;
     * values(object);
     * // => [1, 2]
     *
     * // Modify the result cache.
     * values.cache.set(object, ['a', 'b']);
     * values(object);
     * // => ['a', 'b']
     *
     * // Replace `_.memoize.Cache`.
     * _.memoize.Cache = WeakMap;
     */ function memoize(func, resolver) {
            if (typeof func != "function" || resolver != null && typeof resolver != "function") throw new TypeError(FUNC_ERROR_TEXT);
            var memoized = function() {
                var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
                if (cache.has(key)) return cache.get(key);
                var result = func.apply(this, args);
                memoized.cache = cache.set(key, result) || cache;
                return result;
            };
            memoized.cache = new (memoize.Cache || MapCache);
            return memoized;
        }
        // Expose `MapCache`.
        memoize.Cache = MapCache;
        /**
     * Creates a function that negates the result of the predicate `func`. The
     * `func` predicate is invoked with the `this` binding and arguments of the
     * created function.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} predicate The predicate to negate.
     * @returns {Function} Returns the new negated function.
     * @example
     *
     * function isEven(n) {
     *   return n % 2 == 0;
     * }
     *
     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
     * // => [1, 3, 5]
     */ function negate(predicate) {
            if (typeof predicate != "function") throw new TypeError(FUNC_ERROR_TEXT);
            return function() {
                var args = arguments;
                switch(args.length){
                    case 0:
                        return !predicate.call(this);
                    case 1:
                        return !predicate.call(this, args[0]);
                    case 2:
                        return !predicate.call(this, args[0], args[1]);
                    case 3:
                        return !predicate.call(this, args[0], args[1], args[2]);
                }
                return !predicate.apply(this, args);
            };
        }
        /**
     * Creates a function that is restricted to invoking `func` once. Repeat calls
     * to the function return the value of the first invocation. The `func` is
     * invoked with the `this` binding and arguments of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var initialize = _.once(createApplication);
     * initialize();
     * initialize();
     * // => `createApplication` is invoked once
     */ function once(func) {
            return before(2, func);
        }
        /**
     * Creates a function that invokes `func` with its arguments transformed.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Function
     * @param {Function} func The function to wrap.
     * @param {...(Function|Function[])} [transforms=[_.identity]]
     *  The argument transforms.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function doubled(n) {
     *   return n * 2;
     * }
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var func = _.overArgs(function(x, y) {
     *   return [x, y];
     * }, [square, doubled]);
     *
     * func(9, 3);
     * // => [81, 6]
     *
     * func(10, 5);
     * // => [100, 10]
     */ var overArgs = castRest(function(func, transforms) {
            transforms = transforms.length == 1 && isArray(transforms[0]) ? arrayMap(transforms[0], baseUnary(getIteratee())) : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));
            var funcsLength = transforms.length;
            return baseRest(function(args) {
                var index = -1, length = nativeMin(args.length, funcsLength);
                while(++index < length)args[index] = transforms[index].call(this, args[index]);
                return apply(func, this, args);
            });
        });
        /**
     * Creates a function that invokes `func` with `partials` prepended to the
     * arguments it receives. This method is like `_.bind` except it does **not**
     * alter the `this` binding.
     *
     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 0.2.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var sayHelloTo = _.partial(greet, 'hello');
     * sayHelloTo('fred');
     * // => 'hello fred'
     *
     * // Partially applied with placeholders.
     * var greetFred = _.partial(greet, _, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     */ var partial = baseRest(function(func, partials) {
            var holders = replaceHolders(partials, getHolder(partial));
            return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
        });
        /**
     * This method is like `_.partial` except that partially applied arguments
     * are appended to the arguments it receives.
     *
     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var greetFred = _.partialRight(greet, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     *
     * // Partially applied with placeholders.
     * var sayHelloTo = _.partialRight(greet, 'hello', _);
     * sayHelloTo('fred');
     * // => 'hello fred'
     */ var partialRight = baseRest(function(func, partials) {
            var holders = replaceHolders(partials, getHolder(partialRight));
            return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
        });
        /**
     * Creates a function that invokes `func` with arguments arranged according
     * to the specified `indexes` where the argument value at the first index is
     * provided as the first argument, the argument value at the second index is
     * provided as the second argument, and so on.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to rearrange arguments for.
     * @param {...(number|number[])} indexes The arranged argument indexes.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var rearged = _.rearg(function(a, b, c) {
     *   return [a, b, c];
     * }, [2, 0, 1]);
     *
     * rearged('b', 'c', 'a')
     * // => ['a', 'b', 'c']
     */ var rearg = flatRest(function(func, indexes) {
            return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
        });
        /**
     * Creates a function that invokes `func` with the `this` binding of the
     * created function and arguments from `start` and beyond provided as
     * an array.
     *
     * **Note:** This method is based on the
     * [rest parameter](https://mdn.io/rest_parameters).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.rest(function(what, names) {
     *   return what + ' ' + _.initial(names).join(', ') +
     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
     * });
     *
     * say('hello', 'fred', 'barney', 'pebbles');
     * // => 'hello fred, barney, & pebbles'
     */ function rest(func, start) {
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            start = start === undefined ? start : toInteger(start);
            return baseRest(func, start);
        }
        /**
     * Creates a function that invokes `func` with the `this` binding of the
     * create function and an array of arguments much like
     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
     *
     * **Note:** This method is based on the
     * [spread operator](https://mdn.io/spread_operator).
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Function
     * @param {Function} func The function to spread arguments over.
     * @param {number} [start=0] The start position of the spread.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.spread(function(who, what) {
     *   return who + ' says ' + what;
     * });
     *
     * say(['fred', 'hello']);
     * // => 'fred says hello'
     *
     * var numbers = Promise.all([
     *   Promise.resolve(40),
     *   Promise.resolve(36)
     * ]);
     *
     * numbers.then(_.spread(function(x, y) {
     *   return x + y;
     * }));
     * // => a Promise of 76
     */ function spread(func, start) {
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            start = start == null ? 0 : nativeMax(toInteger(start), 0);
            return baseRest(function(args) {
                var array = args[start], otherArgs = castSlice(args, 0, start);
                if (array) arrayPush(otherArgs, array);
                return apply(func, this, otherArgs);
            });
        }
        /**
     * Creates a throttled function that only invokes `func` at most once per
     * every `wait` milliseconds. The throttled function comes with a `cancel`
     * method to cancel delayed `func` invocations and a `flush` method to
     * immediately invoke them. Provide `options` to indicate whether `func`
     * should be invoked on the leading and/or trailing edge of the `wait`
     * timeout. The `func` is invoked with the last arguments provided to the
     * throttled function. Subsequent calls to the throttled function return the
     * result of the last `func` invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the throttled function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.throttle` and `_.debounce`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to throttle.
     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=true]
     *  Specify invoking on the leading edge of the timeout.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new throttled function.
     * @example
     *
     * // Avoid excessively updating the position while scrolling.
     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
     *
     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
     * jQuery(element).on('click', throttled);
     *
     * // Cancel the trailing throttled invocation.
     * jQuery(window).on('popstate', throttled.cancel);
     */ function throttle(func, wait, options) {
            var leading = true, trailing = true;
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            if (isObject(options)) {
                leading = "leading" in options ? !!options.leading : leading;
                trailing = "trailing" in options ? !!options.trailing : trailing;
            }
            return debounce(func, wait, {
                "leading": leading,
                "maxWait": wait,
                "trailing": trailing
            });
        }
        /**
     * Creates a function that accepts up to one argument, ignoring any
     * additional arguments.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.unary(parseInt));
     * // => [6, 8, 10]
     */ function unary(func) {
            return ary(func, 1);
        }
        /**
     * Creates a function that provides `value` to `wrapper` as its first
     * argument. Any additional arguments provided to the function are appended
     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
     * binding of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {*} value The value to wrap.
     * @param {Function} [wrapper=identity] The wrapper function.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var p = _.wrap(_.escape, function(func, text) {
     *   return '<p>' + func(text) + '</p>';
     * });
     *
     * p('fred, barney, & pebbles');
     * // => '<p>fred, barney, &amp; pebbles</p>'
     */ function wrap(value, wrapper) {
            return partial(castFunction(wrapper), value);
        }
        /*------------------------------------------------------------------------*/ /**
     * Casts `value` as an array if it's not one.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Lang
     * @param {*} value The value to inspect.
     * @returns {Array} Returns the cast array.
     * @example
     *
     * _.castArray(1);
     * // => [1]
     *
     * _.castArray({ 'a': 1 });
     * // => [{ 'a': 1 }]
     *
     * _.castArray('abc');
     * // => ['abc']
     *
     * _.castArray(null);
     * // => [null]
     *
     * _.castArray(undefined);
     * // => [undefined]
     *
     * _.castArray();
     * // => []
     *
     * var array = [1, 2, 3];
     * console.log(_.castArray(array) === array);
     * // => true
     */ function castArray() {
            if (!arguments.length) return [];
            var value = arguments[0];
            return isArray(value) ? value : [
                value
            ];
        }
        /**
     * Creates a shallow clone of `value`.
     *
     * **Note:** This method is loosely based on the
     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
     * and supports cloning arrays, array buffers, booleans, date objects, maps,
     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
     * arrays. The own enumerable properties of `arguments` objects are cloned
     * as plain objects. An empty object is returned for uncloneable values such
     * as error objects, functions, DOM nodes, and WeakMaps.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to clone.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeep
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var shallow = _.clone(objects);
     * console.log(shallow[0] === objects[0]);
     * // => true
     */ function clone(value) {
            return baseClone(value, CLONE_SYMBOLS_FLAG);
        }
        /**
     * This method is like `_.clone` except that it accepts `customizer` which
     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
     * cloning is handled by the method instead. The `customizer` is invoked with
     * up to four arguments; (value [, index|key, object, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeepWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(false);
     *   }
     * }
     *
     * var el = _.cloneWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 0
     */ function cloneWith(value, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined;
            return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
        }
        /**
     * This method is like `_.clone` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @returns {*} Returns the deep cloned value.
     * @see _.clone
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var deep = _.cloneDeep(objects);
     * console.log(deep[0] === objects[0]);
     * // => false
     */ function cloneDeep(value) {
            return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
        }
        /**
     * This method is like `_.cloneWith` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the deep cloned value.
     * @see _.cloneWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(true);
     *   }
     * }
     *
     * var el = _.cloneDeepWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 20
     */ function cloneDeepWith(value, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined;
            return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
        }
        /**
     * Checks if `object` conforms to `source` by invoking the predicate
     * properties of `source` with the corresponding property values of `object`.
     *
     * **Note:** This method is equivalent to `_.conforms` when `source` is
     * partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
     * // => true
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
     * // => false
     */ function conformsTo(object, source) {
            return source == null || baseConformsTo(object, source, keys(source));
        }
        /**
     * Performs a
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * comparison between two values to determine if they are equivalent.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.eq(object, object);
     * // => true
     *
     * _.eq(object, other);
     * // => false
     *
     * _.eq('a', 'a');
     * // => true
     *
     * _.eq('a', Object('a'));
     * // => false
     *
     * _.eq(NaN, NaN);
     * // => true
     */ function eq(value, other) {
            return value === other || value !== value && other !== other;
        }
        /**
     * Checks if `value` is greater than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     * @see _.lt
     * @example
     *
     * _.gt(3, 1);
     * // => true
     *
     * _.gt(3, 3);
     * // => false
     *
     * _.gt(1, 3);
     * // => false
     */ var gt = createRelationalOperation(baseGt);
        /**
     * Checks if `value` is greater than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than or equal to
     *  `other`, else `false`.
     * @see _.lte
     * @example
     *
     * _.gte(3, 1);
     * // => true
     *
     * _.gte(3, 3);
     * // => true
     *
     * _.gte(1, 3);
     * // => false
     */ var gte = createRelationalOperation(function(value, other) {
            return value >= other;
        });
        /**
     * Checks if `value` is likely an `arguments` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     *  else `false`.
     * @example
     *
     * _.isArguments(function() { return arguments; }());
     * // => true
     *
     * _.isArguments([1, 2, 3]);
     * // => false
     */ var isArguments = baseIsArguments(function() {
            return arguments;
        }()) ? baseIsArguments : function(value) {
            return isObjectLike(value) && hasOwnProperty.call(value, "callee") && !propertyIsEnumerable.call(value, "callee");
        };
        /**
     * Checks if `value` is classified as an `Array` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
     * @example
     *
     * _.isArray([1, 2, 3]);
     * // => true
     *
     * _.isArray(document.body.children);
     * // => false
     *
     * _.isArray('abc');
     * // => false
     *
     * _.isArray(_.noop);
     * // => false
     */ var isArray = Array1.isArray;
        /**
     * Checks if `value` is classified as an `ArrayBuffer` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     * @example
     *
     * _.isArrayBuffer(new ArrayBuffer(2));
     * // => true
     *
     * _.isArrayBuffer(new Array(2));
     * // => false
     */ var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;
        /**
     * Checks if `value` is array-like. A value is considered array-like if it's
     * not a function and has a `value.length` that's an integer greater than or
     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
     * @example
     *
     * _.isArrayLike([1, 2, 3]);
     * // => true
     *
     * _.isArrayLike(document.body.children);
     * // => true
     *
     * _.isArrayLike('abc');
     * // => true
     *
     * _.isArrayLike(_.noop);
     * // => false
     */ function isArrayLike(value) {
            return value != null && isLength(value.length) && !isFunction(value);
        }
        /**
     * This method is like `_.isArrayLike` except that it also checks if `value`
     * is an object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array-like object,
     *  else `false`.
     * @example
     *
     * _.isArrayLikeObject([1, 2, 3]);
     * // => true
     *
     * _.isArrayLikeObject(document.body.children);
     * // => true
     *
     * _.isArrayLikeObject('abc');
     * // => false
     *
     * _.isArrayLikeObject(_.noop);
     * // => false
     */ function isArrayLikeObject(value) {
            return isObjectLike(value) && isArrayLike(value);
        }
        /**
     * Checks if `value` is classified as a boolean primitive or object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
     * @example
     *
     * _.isBoolean(false);
     * // => true
     *
     * _.isBoolean(null);
     * // => false
     */ function isBoolean(value) {
            return value === true || value === false || isObjectLike(value) && baseGetTag(value) == boolTag;
        }
        /**
     * Checks if `value` is a buffer.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
     * @example
     *
     * _.isBuffer(new Buffer(2));
     * // => true
     *
     * _.isBuffer(new Uint8Array(2));
     * // => false
     */ var isBuffer = nativeIsBuffer || stubFalse;
        /**
     * Checks if `value` is classified as a `Date` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     * @example
     *
     * _.isDate(new Date);
     * // => true
     *
     * _.isDate('Mon April 23 2012');
     * // => false
     */ var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;
        /**
     * Checks if `value` is likely a DOM element.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
     * @example
     *
     * _.isElement(document.body);
     * // => true
     *
     * _.isElement('<body>');
     * // => false
     */ function isElement(value) {
            return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
        }
        /**
     * Checks if `value` is an empty object, collection, map, or set.
     *
     * Objects are considered empty if they have no own enumerable string keyed
     * properties.
     *
     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
     * jQuery-like collections are considered empty if they have a `length` of `0`.
     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
     * @example
     *
     * _.isEmpty(null);
     * // => true
     *
     * _.isEmpty(true);
     * // => true
     *
     * _.isEmpty(1);
     * // => true
     *
     * _.isEmpty([1, 2, 3]);
     * // => false
     *
     * _.isEmpty({ 'a': 1 });
     * // => false
     */ function isEmpty(value) {
            if (value == null) return true;
            if (isArrayLike(value) && (isArray(value) || typeof value == "string" || typeof value.splice == "function" || isBuffer(value) || isTypedArray(value) || isArguments(value))) return !value.length;
            var tag = getTag(value);
            if (tag == mapTag || tag == setTag) return !value.size;
            if (isPrototype(value)) return !baseKeys(value).length;
            for(var key in value){
                if (hasOwnProperty.call(value, key)) return false;
            }
            return true;
        }
        /**
     * Performs a deep comparison between two values to determine if they are
     * equivalent.
     *
     * **Note:** This method supports comparing arrays, array buffers, booleans,
     * date objects, error objects, maps, numbers, `Object` objects, regexes,
     * sets, strings, symbols, and typed arrays. `Object` objects are compared
     * by their own, not inherited, enumerable properties. Functions and DOM
     * nodes are compared by strict equality, i.e. `===`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.isEqual(object, other);
     * // => true
     *
     * object === other;
     * // => false
     */ function isEqual(value, other) {
            return baseIsEqual(value, other);
        }
        /**
     * This method is like `_.isEqual` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with up to
     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, othValue) {
     *   if (isGreeting(objValue) && isGreeting(othValue)) {
     *     return true;
     *   }
     * }
     *
     * var array = ['hello', 'goodbye'];
     * var other = ['hi', 'goodbye'];
     *
     * _.isEqualWith(array, other, customizer);
     * // => true
     */ function isEqualWith(value, other, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined;
            var result = customizer ? customizer(value, other) : undefined;
            return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
        }
        /**
     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
     * `SyntaxError`, `TypeError`, or `URIError` object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
     * @example
     *
     * _.isError(new Error);
     * // => true
     *
     * _.isError(Error);
     * // => false
     */ function isError(value) {
            if (!isObjectLike(value)) return false;
            var tag = baseGetTag(value);
            return tag == errorTag || tag == domExcTag || typeof value.message == "string" && typeof value.name == "string" && !isPlainObject(value);
        }
        /**
     * Checks if `value` is a finite primitive number.
     *
     * **Note:** This method is based on
     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
     * @example
     *
     * _.isFinite(3);
     * // => true
     *
     * _.isFinite(Number.MIN_VALUE);
     * // => true
     *
     * _.isFinite(Infinity);
     * // => false
     *
     * _.isFinite('3');
     * // => false
     */ function isFinite(value) {
            return typeof value == "number" && nativeIsFinite(value);
        }
        /**
     * Checks if `value` is classified as a `Function` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
     * @example
     *
     * _.isFunction(_);
     * // => true
     *
     * _.isFunction(/abc/);
     * // => false
     */ function isFunction(value) {
            if (!isObject(value)) return false;
            // The use of `Object#toString` avoids issues with the `typeof` operator
            // in Safari 9 which returns 'object' for typed arrays and other constructors.
            var tag = baseGetTag(value);
            return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
        }
        /**
     * Checks if `value` is an integer.
     *
     * **Note:** This method is based on
     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
     * @example
     *
     * _.isInteger(3);
     * // => true
     *
     * _.isInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isInteger(Infinity);
     * // => false
     *
     * _.isInteger('3');
     * // => false
     */ function isInteger(value) {
            return typeof value == "number" && value == toInteger(value);
        }
        /**
     * Checks if `value` is a valid array-like length.
     *
     * **Note:** This method is loosely based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
     * @example
     *
     * _.isLength(3);
     * // => true
     *
     * _.isLength(Number.MIN_VALUE);
     * // => false
     *
     * _.isLength(Infinity);
     * // => false
     *
     * _.isLength('3');
     * // => false
     */ function isLength(value) {
            return typeof value == "number" && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
        }
        /**
     * Checks if `value` is the
     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
     * @example
     *
     * _.isObject({});
     * // => true
     *
     * _.isObject([1, 2, 3]);
     * // => true
     *
     * _.isObject(_.noop);
     * // => true
     *
     * _.isObject(null);
     * // => false
     */ function isObject(value) {
            var type = typeof value;
            return value != null && (type == "object" || type == "function");
        }
        /**
     * Checks if `value` is object-like. A value is object-like if it's not `null`
     * and has a `typeof` result of "object".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
     * @example
     *
     * _.isObjectLike({});
     * // => true
     *
     * _.isObjectLike([1, 2, 3]);
     * // => true
     *
     * _.isObjectLike(_.noop);
     * // => false
     *
     * _.isObjectLike(null);
     * // => false
     */ function isObjectLike(value) {
            return value != null && typeof value == "object";
        }
        /**
     * Checks if `value` is classified as a `Map` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     * @example
     *
     * _.isMap(new Map);
     * // => true
     *
     * _.isMap(new WeakMap);
     * // => false
     */ var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;
        /**
     * Performs a partial deep comparison between `object` and `source` to
     * determine if `object` contains equivalent property values.
     *
     * **Note:** This method is equivalent to `_.matches` when `source` is
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.isMatch(object, { 'b': 2 });
     * // => true
     *
     * _.isMatch(object, { 'b': 1 });
     * // => false
     */ function isMatch(object, source) {
            return object === source || baseIsMatch(object, source, getMatchData(source));
        }
        /**
     * This method is like `_.isMatch` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with five
     * arguments: (objValue, srcValue, index|key, object, source).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, srcValue) {
     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
     *     return true;
     *   }
     * }
     *
     * var object = { 'greeting': 'hello' };
     * var source = { 'greeting': 'hi' };
     *
     * _.isMatchWith(object, source, customizer);
     * // => true
     */ function isMatchWith(object, source, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined;
            return baseIsMatch(object, source, getMatchData(source), customizer);
        }
        /**
     * Checks if `value` is `NaN`.
     *
     * **Note:** This method is based on
     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
     * `undefined` and other non-number values.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
     * @example
     *
     * _.isNaN(NaN);
     * // => true
     *
     * _.isNaN(new Number(NaN));
     * // => true
     *
     * isNaN(undefined);
     * // => true
     *
     * _.isNaN(undefined);
     * // => false
     */ function isNaN(value) {
            // An `NaN` primitive is the only value that is not equal to itself.
            // Perform the `toStringTag` check first to avoid errors with some
            // ActiveX objects in IE.
            return isNumber(value) && value != +value;
        }
        /**
     * Checks if `value` is a pristine native function.
     *
     * **Note:** This method can't reliably detect native functions in the presence
     * of the core-js package because core-js circumvents this kind of detection.
     * Despite multiple requests, the core-js maintainer has made it clear: any
     * attempt to fix the detection will be obstructed. As a result, we're left
     * with little choice but to throw an error. Unfortunately, this also affects
     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
     * which rely on core-js.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     * @example
     *
     * _.isNative(Array.prototype.push);
     * // => true
     *
     * _.isNative(_);
     * // => false
     */ function isNative(value) {
            if (isMaskable(value)) throw new Error(CORE_ERROR_TEXT);
            return baseIsNative(value);
        }
        /**
     * Checks if `value` is `null`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
     * @example
     *
     * _.isNull(null);
     * // => true
     *
     * _.isNull(void 0);
     * // => false
     */ function isNull(value) {
            return value === null;
        }
        /**
     * Checks if `value` is `null` or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
     * @example
     *
     * _.isNil(null);
     * // => true
     *
     * _.isNil(void 0);
     * // => true
     *
     * _.isNil(NaN);
     * // => false
     */ function isNil(value) {
            return value == null;
        }
        /**
     * Checks if `value` is classified as a `Number` primitive or object.
     *
     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
     * classified as numbers, use the `_.isFinite` method.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
     * @example
     *
     * _.isNumber(3);
     * // => true
     *
     * _.isNumber(Number.MIN_VALUE);
     * // => true
     *
     * _.isNumber(Infinity);
     * // => true
     *
     * _.isNumber('3');
     * // => false
     */ function isNumber(value) {
            return typeof value == "number" || isObjectLike(value) && baseGetTag(value) == numberTag;
        }
        /**
     * Checks if `value` is a plain object, that is, an object created by the
     * `Object` constructor or one with a `[[Prototype]]` of `null`.
     *
     * @static
     * @memberOf _
     * @since 0.8.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * _.isPlainObject(new Foo);
     * // => false
     *
     * _.isPlainObject([1, 2, 3]);
     * // => false
     *
     * _.isPlainObject({ 'x': 0, 'y': 0 });
     * // => true
     *
     * _.isPlainObject(Object.create(null));
     * // => true
     */ function isPlainObject(value) {
            if (!isObjectLike(value) || baseGetTag(value) != objectTag) return false;
            var proto = getPrototype(value);
            if (proto === null) return true;
            var Ctor = hasOwnProperty.call(proto, "constructor") && proto.constructor;
            return typeof Ctor == "function" && Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString;
        }
        /**
     * Checks if `value` is classified as a `RegExp` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     * @example
     *
     * _.isRegExp(/abc/);
     * // => true
     *
     * _.isRegExp('/abc/');
     * // => false
     */ var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;
        /**
     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
     * double precision number which isn't the result of a rounded unsafe integer.
     *
     * **Note:** This method is based on
     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
     * @example
     *
     * _.isSafeInteger(3);
     * // => true
     *
     * _.isSafeInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isSafeInteger(Infinity);
     * // => false
     *
     * _.isSafeInteger('3');
     * // => false
     */ function isSafeInteger(value) {
            return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
        }
        /**
     * Checks if `value` is classified as a `Set` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     * @example
     *
     * _.isSet(new Set);
     * // => true
     *
     * _.isSet(new WeakSet);
     * // => false
     */ var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;
        /**
     * Checks if `value` is classified as a `String` primitive or object.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
     * @example
     *
     * _.isString('abc');
     * // => true
     *
     * _.isString(1);
     * // => false
     */ function isString(value) {
            return typeof value == "string" || !isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag;
        }
        /**
     * Checks if `value` is classified as a `Symbol` primitive or object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
     * @example
     *
     * _.isSymbol(Symbol.iterator);
     * // => true
     *
     * _.isSymbol('abc');
     * // => false
     */ function isSymbol(value) {
            return typeof value == "symbol" || isObjectLike(value) && baseGetTag(value) == symbolTag;
        }
        /**
     * Checks if `value` is classified as a typed array.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     * @example
     *
     * _.isTypedArray(new Uint8Array);
     * // => true
     *
     * _.isTypedArray([]);
     * // => false
     */ var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
        /**
     * Checks if `value` is `undefined`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
     * @example
     *
     * _.isUndefined(void 0);
     * // => true
     *
     * _.isUndefined(null);
     * // => false
     */ function isUndefined(value) {
            return value === undefined;
        }
        /**
     * Checks if `value` is classified as a `WeakMap` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
     * @example
     *
     * _.isWeakMap(new WeakMap);
     * // => true
     *
     * _.isWeakMap(new Map);
     * // => false
     */ function isWeakMap(value) {
            return isObjectLike(value) && getTag(value) == weakMapTag;
        }
        /**
     * Checks if `value` is classified as a `WeakSet` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
     * @example
     *
     * _.isWeakSet(new WeakSet);
     * // => true
     *
     * _.isWeakSet(new Set);
     * // => false
     */ function isWeakSet(value) {
            return isObjectLike(value) && baseGetTag(value) == weakSetTag;
        }
        /**
     * Checks if `value` is less than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     * @see _.gt
     * @example
     *
     * _.lt(1, 3);
     * // => true
     *
     * _.lt(3, 3);
     * // => false
     *
     * _.lt(3, 1);
     * // => false
     */ var lt = createRelationalOperation(baseLt);
        /**
     * Checks if `value` is less than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than or equal to
     *  `other`, else `false`.
     * @see _.gte
     * @example
     *
     * _.lte(1, 3);
     * // => true
     *
     * _.lte(3, 3);
     * // => true
     *
     * _.lte(3, 1);
     * // => false
     */ var lte = createRelationalOperation(function(value, other) {
            return value <= other;
        });
        /**
     * Converts `value` to an array.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Array} Returns the converted array.
     * @example
     *
     * _.toArray({ 'a': 1, 'b': 2 });
     * // => [1, 2]
     *
     * _.toArray('abc');
     * // => ['a', 'b', 'c']
     *
     * _.toArray(1);
     * // => []
     *
     * _.toArray(null);
     * // => []
     */ function toArray(value) {
            if (!value) return [];
            if (isArrayLike(value)) return isString(value) ? stringToArray(value) : copyArray(value);
            if (symIterator && value[symIterator]) return iteratorToArray(value[symIterator]());
            var tag = getTag(value), func = tag == mapTag ? mapToArray : tag == setTag ? setToArray : values;
            return func(value);
        }
        /**
     * Converts `value` to a finite number.
     *
     * @static
     * @memberOf _
     * @since 4.12.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted number.
     * @example
     *
     * _.toFinite(3.2);
     * // => 3.2
     *
     * _.toFinite(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toFinite(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toFinite('3.2');
     * // => 3.2
     */ function toFinite(value) {
            if (!value) return value === 0 ? value : 0;
            value = toNumber(value);
            if (value === INFINITY || value === -INFINITY) {
                var sign = value < 0 ? -1 : 1;
                return sign * MAX_INTEGER;
            }
            return value === value ? value : 0;
        }
        /**
     * Converts `value` to an integer.
     *
     * **Note:** This method is loosely based on
     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toInteger(3.2);
     * // => 3
     *
     * _.toInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toInteger(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toInteger('3.2');
     * // => 3
     */ function toInteger(value) {
            var result = toFinite(value), remainder = result % 1;
            return result === result ? remainder ? result - remainder : result : 0;
        }
        /**
     * Converts `value` to an integer suitable for use as the length of an
     * array-like object.
     *
     * **Note:** This method is based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toLength(3.2);
     * // => 3
     *
     * _.toLength(Number.MIN_VALUE);
     * // => 0
     *
     * _.toLength(Infinity);
     * // => 4294967295
     *
     * _.toLength('3.2');
     * // => 3
     */ function toLength(value) {
            return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
        }
        /**
     * Converts `value` to a number.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     * @example
     *
     * _.toNumber(3.2);
     * // => 3.2
     *
     * _.toNumber(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toNumber(Infinity);
     * // => Infinity
     *
     * _.toNumber('3.2');
     * // => 3.2
     */ function toNumber(value) {
            if (typeof value == "number") return value;
            if (isSymbol(value)) return NAN;
            if (isObject(value)) {
                var other = typeof value.valueOf == "function" ? value.valueOf() : value;
                value = isObject(other) ? other + "" : other;
            }
            if (typeof value != "string") return value === 0 ? value : +value;
            value = baseTrim(value);
            var isBinary = reIsBinary.test(value);
            return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
        }
        /**
     * Converts `value` to a plain object flattening inherited enumerable string
     * keyed properties of `value` to own properties of the plain object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Object} Returns the converted plain object.
     * @example
     *
     * function Foo() {
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.assign({ 'a': 1 }, new Foo);
     * // => { 'a': 1, 'b': 2 }
     *
     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
     * // => { 'a': 1, 'b': 2, 'c': 3 }
     */ function toPlainObject(value) {
            return copyObject(value, keysIn(value));
        }
        /**
     * Converts `value` to a safe integer. A safe integer can be compared and
     * represented correctly.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toSafeInteger(3.2);
     * // => 3
     *
     * _.toSafeInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toSafeInteger(Infinity);
     * // => 9007199254740991
     *
     * _.toSafeInteger('3.2');
     * // => 3
     */ function toSafeInteger(value) {
            return value ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER) : value === 0 ? value : 0;
        }
        /**
     * Converts `value` to a string. An empty string is returned for `null`
     * and `undefined` values. The sign of `-0` is preserved.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.toString(null);
     * // => ''
     *
     * _.toString(-0);
     * // => '-0'
     *
     * _.toString([1, 2, 3]);
     * // => '1,2,3'
     */ function toString(value) {
            return value == null ? "" : baseToString(value);
        }
        /*------------------------------------------------------------------------*/ /**
     * Assigns own enumerable string keyed properties of source objects to the
     * destination object. Source objects are applied from left to right.
     * Subsequent sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object` and is loosely based on
     * [`Object.assign`](https://mdn.io/Object/assign).
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assignIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assign({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'c': 3 }
     */ var assign = createAssigner(function(object, source) {
            if (isPrototype(source) || isArrayLike(source)) {
                copyObject(source, keys(source), object);
                return;
            }
            for(var key in source)if (hasOwnProperty.call(source, key)) assignValue(object, key, source[key]);
        });
        /**
     * This method is like `_.assign` except that it iterates over own and
     * inherited source properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extend
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assign
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
     */ var assignIn = createAssigner(function(object, source) {
            copyObject(source, keysIn(source), object);
        });
        /**
     * This method is like `_.assignIn` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extendWith
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignInWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
            copyObject(source, keysIn(source), object, customizer);
        });
        /**
     * This method is like `_.assign` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignInWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
            copyObject(source, keys(source), object, customizer);
        });
        /**
     * Creates an array of values corresponding to `paths` of `object`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Array} Returns the picked values.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _.at(object, ['a[0].b.c', 'a[1]']);
     * // => [3, 4]
     */ var at = flatRest(baseAt);
        /**
     * Creates an object that inherits from the `prototype` object. If a
     * `properties` object is given, its own enumerable string keyed properties
     * are assigned to the created object.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Object
     * @param {Object} prototype The object to inherit from.
     * @param {Object} [properties] The properties to assign to the object.
     * @returns {Object} Returns the new object.
     * @example
     *
     * function Shape() {
     *   this.x = 0;
     *   this.y = 0;
     * }
     *
     * function Circle() {
     *   Shape.call(this);
     * }
     *
     * Circle.prototype = _.create(Shape.prototype, {
     *   'constructor': Circle
     * });
     *
     * var circle = new Circle;
     * circle instanceof Circle;
     * // => true
     *
     * circle instanceof Shape;
     * // => true
     */ function create(prototype, properties) {
            var result = baseCreate(prototype);
            return properties == null ? result : baseAssign(result, properties);
        }
        /**
     * Assigns own and inherited enumerable string keyed properties of source
     * objects to the destination object for all destination properties that
     * resolve to `undefined`. Source objects are applied from left to right.
     * Once a property is set, additional values of the same property are ignored.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaultsDeep
     * @example
     *
     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var defaults = baseRest(function(object, sources) {
            object = Object1(object);
            var index = -1;
            var length = sources.length;
            var guard = length > 2 ? sources[2] : undefined;
            if (guard && isIterateeCall(sources[0], sources[1], guard)) length = 1;
            while(++index < length){
                var source = sources[index];
                var props = keysIn(source);
                var propsIndex = -1;
                var propsLength = props.length;
                while(++propsIndex < propsLength){
                    var key = props[propsIndex];
                    var value = object[key];
                    if (value === undefined || eq(value, objectProto[key]) && !hasOwnProperty.call(object, key)) object[key] = source[key];
                }
            }
            return object;
        });
        /**
     * This method is like `_.defaults` except that it recursively assigns
     * default properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaults
     * @example
     *
     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
     * // => { 'a': { 'b': 2, 'c': 3 } }
     */ var defaultsDeep = baseRest(function(args) {
            args.push(undefined, customDefaultsMerge);
            return apply(mergeWith, undefined, args);
        });
        /**
     * This method is like `_.find` except that it returns the key of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findKey(users, function(o) { return o.age < 40; });
     * // => 'barney' (iteration order is not guaranteed)
     *
     * // The `_.matches` iteratee shorthand.
     * _.findKey(users, { 'age': 1, 'active': true });
     * // => 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findKey(users, 'active');
     * // => 'barney'
     */ function findKey(object, predicate) {
            return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
        }
        /**
     * This method is like `_.findKey` except that it iterates over elements of
     * a collection in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findLastKey(users, function(o) { return o.age < 40; });
     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastKey(users, { 'age': 36, 'active': true });
     * // => 'barney'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastKey(users, 'active');
     * // => 'pebbles'
     */ function findLastKey(object, predicate) {
            return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
        }
        /**
     * Iterates over own and inherited enumerable string keyed properties of an
     * object and invokes `iteratee` for each property. The iteratee is invoked
     * with three arguments: (value, key, object). Iteratee functions may exit
     * iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forInRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forIn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
     */ function forIn(object, iteratee) {
            return object == null ? object : baseFor(object, getIteratee(iteratee, 3), keysIn);
        }
        /**
     * This method is like `_.forIn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forInRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
     */ function forInRight(object, iteratee) {
            return object == null ? object : baseForRight(object, getIteratee(iteratee, 3), keysIn);
        }
        /**
     * Iterates over own enumerable string keyed properties of an object and
     * invokes `iteratee` for each property. The iteratee is invoked with three
     * arguments: (value, key, object). Iteratee functions may exit iteration
     * early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwnRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */ function forOwn(object, iteratee) {
            return object && baseForOwn(object, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.forOwn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwnRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
     */ function forOwnRight(object, iteratee) {
            return object && baseForOwnRight(object, getIteratee(iteratee, 3));
        }
        /**
     * Creates an array of function property names from own enumerable properties
     * of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functionsIn
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functions(new Foo);
     * // => ['a', 'b']
     */ function functions(object) {
            return object == null ? [] : baseFunctions(object, keys(object));
        }
        /**
     * Creates an array of function property names from own and inherited
     * enumerable properties of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functions
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functionsIn(new Foo);
     * // => ['a', 'b', 'c']
     */ function functionsIn(object) {
            return object == null ? [] : baseFunctions(object, keysIn(object));
        }
        /**
     * Gets the value at `path` of `object`. If the resolved value is
     * `undefined`, the `defaultValue` is returned in its place.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.get(object, 'a[0].b.c');
     * // => 3
     *
     * _.get(object, ['a', '0', 'b', 'c']);
     * // => 3
     *
     * _.get(object, 'a.b.c', 'default');
     * // => 'default'
     */ function get(object, path, defaultValue) {
            var result = object == null ? undefined : baseGet(object, path);
            return result === undefined ? defaultValue : result;
        }
        /**
     * Checks if `path` is a direct property of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = { 'a': { 'b': 2 } };
     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.has(object, 'a');
     * // => true
     *
     * _.has(object, 'a.b');
     * // => true
     *
     * _.has(object, ['a', 'b']);
     * // => true
     *
     * _.has(other, 'a');
     * // => false
     */ function has(object, path) {
            return object != null && hasPath(object, path, baseHas);
        }
        /**
     * Checks if `path` is a direct or inherited property of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.hasIn(object, 'a');
     * // => true
     *
     * _.hasIn(object, 'a.b');
     * // => true
     *
     * _.hasIn(object, ['a', 'b']);
     * // => true
     *
     * _.hasIn(object, 'b');
     * // => false
     */ function hasIn(object, path) {
            return object != null && hasPath(object, path, baseHasIn);
        }
        /**
     * Creates an object composed of the inverted keys and values of `object`.
     * If `object` contains duplicate values, subsequent values overwrite
     * property assignments of previous values.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Object
     * @param {Object} object The object to invert.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invert(object);
     * // => { '1': 'c', '2': 'b' }
     */ var invert = createInverter(function(result, value, key) {
            if (value != null && typeof value.toString != "function") value = nativeObjectToString.call(value);
            result[value] = key;
        }, constant(identity));
        /**
     * This method is like `_.invert` except that the inverted object is generated
     * from the results of running each element of `object` thru `iteratee`. The
     * corresponding inverted value of each inverted key is an array of keys
     * responsible for generating the inverted value. The iteratee is invoked
     * with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Object
     * @param {Object} object The object to invert.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invertBy(object);
     * // => { '1': ['a', 'c'], '2': ['b'] }
     *
     * _.invertBy(object, function(value) {
     *   return 'group' + value;
     * });
     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
     */ var invertBy = createInverter(function(result, value, key) {
            if (value != null && typeof value.toString != "function") value = nativeObjectToString.call(value);
            if (hasOwnProperty.call(result, value)) result[value].push(key);
            else result[value] = [
                key
            ];
        }, getIteratee);
        /**
     * Invokes the method at `path` of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
     *
     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
     * // => [2, 3]
     */ var invoke = baseRest(baseInvoke);
        /**
     * Creates an array of the own enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects. See the
     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * for more details.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keys(new Foo);
     * // => ['a', 'b'] (iteration order is not guaranteed)
     *
     * _.keys('hi');
     * // => ['0', '1']
     */ function keys(object) {
            return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
        }
        /**
     * Creates an array of the own and inherited enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keysIn(new Foo);
     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
     */ function keysIn(object) {
            return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
        }
        /**
     * The opposite of `_.mapValues`; this method creates an object with the
     * same values as `object` and keys generated by running each own enumerable
     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
     * with three arguments: (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapValues
     * @example
     *
     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
     *   return key + value;
     * });
     * // => { 'a1': 1, 'b2': 2 }
     */ function mapKeys(object, iteratee) {
            var result = {};
            iteratee = getIteratee(iteratee, 3);
            baseForOwn(object, function(value, key, object) {
                baseAssignValue(result, iteratee(value, key, object), value);
            });
            return result;
        }
        /**
     * Creates an object with the same keys as `object` and values generated
     * by running each own enumerable string keyed property of `object` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapKeys
     * @example
     *
     * var users = {
     *   'fred':    { 'user': 'fred',    'age': 40 },
     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
     * };
     *
     * _.mapValues(users, function(o) { return o.age; });
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     *
     * // The `_.property` iteratee shorthand.
     * _.mapValues(users, 'age');
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     */ function mapValues(object, iteratee) {
            var result = {};
            iteratee = getIteratee(iteratee, 3);
            baseForOwn(object, function(value, key, object) {
                baseAssignValue(result, key, iteratee(value, key, object));
            });
            return result;
        }
        /**
     * This method is like `_.assign` except that it recursively merges own and
     * inherited enumerable string keyed properties of source objects into the
     * destination object. Source properties that resolve to `undefined` are
     * skipped if a destination value exists. Array and plain object properties
     * are merged recursively. Other objects and value types are overridden by
     * assignment. Source objects are applied from left to right. Subsequent
     * sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {
     *   'a': [{ 'b': 2 }, { 'd': 4 }]
     * };
     *
     * var other = {
     *   'a': [{ 'c': 3 }, { 'e': 5 }]
     * };
     *
     * _.merge(object, other);
     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
     */ var merge = createAssigner(function(object, source, srcIndex) {
            baseMerge(object, source, srcIndex);
        });
        /**
     * This method is like `_.merge` except that it accepts `customizer` which
     * is invoked to produce the merged values of the destination and source
     * properties. If `customizer` returns `undefined`, merging is handled by the
     * method instead. The `customizer` is invoked with six arguments:
     * (objValue, srcValue, key, object, source, stack).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} customizer The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   if (_.isArray(objValue)) {
     *     return objValue.concat(srcValue);
     *   }
     * }
     *
     * var object = { 'a': [1], 'b': [2] };
     * var other = { 'a': [3], 'b': [4] };
     *
     * _.mergeWith(object, other, customizer);
     * // => { 'a': [1, 3], 'b': [2, 4] }
     */ var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
            baseMerge(object, source, srcIndex, customizer);
        });
        /**
     * The opposite of `_.pick`; this method creates an object composed of the
     * own and inherited enumerable property paths of `object` that are not omitted.
     *
     * **Note:** This method is considerably slower than `_.pick`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to omit.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omit(object, ['a', 'c']);
     * // => { 'b': '2' }
     */ var omit = flatRest(function(object, paths) {
            var result = {};
            if (object == null) return result;
            var isDeep = false;
            paths = arrayMap(paths, function(path) {
                path = castPath(path, object);
                isDeep || (isDeep = path.length > 1);
                return path;
            });
            copyObject(object, getAllKeysIn(object), result);
            if (isDeep) result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
            var length = paths.length;
            while(length--)baseUnset(result, paths[length]);
            return result;
        });
        /**
     * The opposite of `_.pickBy`; this method creates an object composed of
     * the own and inherited enumerable string keyed properties of `object` that
     * `predicate` doesn't return truthy for. The predicate is invoked with two
     * arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omitBy(object, _.isNumber);
     * // => { 'b': '2' }
     */ function omitBy(object, predicate) {
            return pickBy(object, negate(getIteratee(predicate)));
        }
        /**
     * Creates an object composed of the picked `object` properties.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pick(object, ['a', 'c']);
     * // => { 'a': 1, 'c': 3 }
     */ var pick = flatRest(function(object, paths) {
            return object == null ? {} : basePick(object, paths);
        });
        /**
     * Creates an object composed of the `object` properties `predicate` returns
     * truthy for. The predicate is invoked with two arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pickBy(object, _.isNumber);
     * // => { 'a': 1, 'c': 3 }
     */ function pickBy(object, predicate) {
            if (object == null) return {};
            var props = arrayMap(getAllKeysIn(object), function(prop) {
                return [
                    prop
                ];
            });
            predicate = getIteratee(predicate);
            return basePickBy(object, props, function(value, path) {
                return predicate(value, path[0]);
            });
        }
        /**
     * This method is like `_.get` except that if the resolved value is a
     * function it's invoked with the `this` binding of its parent object and
     * its result is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to resolve.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
     *
     * _.result(object, 'a[0].b.c1');
     * // => 3
     *
     * _.result(object, 'a[0].b.c2');
     * // => 4
     *
     * _.result(object, 'a[0].b.c3', 'default');
     * // => 'default'
     *
     * _.result(object, 'a[0].b.c3', _.constant('default'));
     * // => 'default'
     */ function result(object, path, defaultValue) {
            path = castPath(path, object);
            var index = -1, length = path.length;
            // Ensure the loop is entered when path is empty.
            if (!length) {
                length = 1;
                object = undefined;
            }
            while(++index < length){
                var value = object == null ? undefined : object[toKey(path[index])];
                if (value === undefined) {
                    index = length;
                    value = defaultValue;
                }
                object = isFunction(value) ? value.call(object) : value;
            }
            return object;
        }
        /**
     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
     * it's created. Arrays are created for missing index properties while objects
     * are created for all other missing properties. Use `_.setWith` to customize
     * `path` creation.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.set(object, 'a[0].b.c', 4);
     * console.log(object.a[0].b.c);
     * // => 4
     *
     * _.set(object, ['x', '0', 'y', 'z'], 5);
     * console.log(object.x[0].y.z);
     * // => 5
     */ function set(object, path, value) {
            return object == null ? object : baseSet(object, path, value);
        }
        /**
     * This method is like `_.set` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.setWith(object, '[0][1]', 'a', Object);
     * // => { '0': { '1': 'a' } }
     */ function setWith(object, path, value, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined;
            return object == null ? object : baseSet(object, path, value, customizer);
        }
        /**
     * Creates an array of own enumerable string keyed-value pairs for `object`
     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
     * entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entries
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairs(new Foo);
     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
     */ var toPairs = createToPairs(keys);
        /**
     * Creates an array of own and inherited enumerable string keyed-value pairs
     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
     * or set, its entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entriesIn
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairsIn(new Foo);
     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
     */ var toPairsIn = createToPairs(keysIn);
        /**
     * An alternative to `_.reduce`; this method transforms `object` to a new
     * `accumulator` object which is the result of running each of its own
     * enumerable string keyed properties thru `iteratee`, with each invocation
     * potentially mutating the `accumulator` object. If `accumulator` is not
     * provided, a new object with the same `[[Prototype]]` will be used. The
     * iteratee is invoked with four arguments: (accumulator, value, key, object).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The custom accumulator value.
     * @returns {*} Returns the accumulated value.
     * @example
     *
     * _.transform([2, 3, 4], function(result, n) {
     *   result.push(n *= n);
     *   return n % 2 == 0;
     * }, []);
     * // => [4, 9]
     *
     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] }
     */ function transform(object, iteratee, accumulator) {
            var isArr = isArray(object), isArrLike = isArr || isBuffer(object) || isTypedArray(object);
            iteratee = getIteratee(iteratee, 4);
            if (accumulator == null) {
                var Ctor = object && object.constructor;
                if (isArrLike) accumulator = isArr ? new Ctor : [];
                else if (isObject(object)) accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
                else accumulator = {};
            }
            (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
                return iteratee(accumulator, value, index, object);
            });
            return accumulator;
        }
        /**
     * Removes the property at `path` of `object`.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
     * _.unset(object, 'a[0].b.c');
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     *
     * _.unset(object, ['a', '0', 'b', 'c']);
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     */ function unset(object, path) {
            return object == null ? true : baseUnset(object, path);
        }
        /**
     * This method is like `_.set` except that accepts `updater` to produce the
     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
     * is invoked with one argument: (value).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
     * console.log(object.a[0].b.c);
     * // => 9
     *
     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
     * console.log(object.x[0].y.z);
     * // => 0
     */ function update(object, path, updater) {
            return object == null ? object : baseUpdate(object, path, castFunction(updater));
        }
        /**
     * This method is like `_.update` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
     * // => { '0': { '1': 'a' } }
     */ function updateWith(object, path, updater, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined;
            return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
        }
        /**
     * Creates an array of the own enumerable string keyed property values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.values(new Foo);
     * // => [1, 2] (iteration order is not guaranteed)
     *
     * _.values('hi');
     * // => ['h', 'i']
     */ function values(object) {
            return object == null ? [] : baseValues(object, keys(object));
        }
        /**
     * Creates an array of the own and inherited enumerable string keyed property
     * values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.valuesIn(new Foo);
     * // => [1, 2, 3] (iteration order is not guaranteed)
     */ function valuesIn(object) {
            return object == null ? [] : baseValues(object, keysIn(object));
        }
        /*------------------------------------------------------------------------*/ /**
     * Clamps `number` within the inclusive `lower` and `upper` bounds.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Number
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     * @example
     *
     * _.clamp(-10, -5, 5);
     * // => -5
     *
     * _.clamp(10, -5, 5);
     * // => 5
     */ function clamp(number, lower, upper) {
            if (upper === undefined) {
                upper = lower;
                lower = undefined;
            }
            if (upper !== undefined) {
                upper = toNumber(upper);
                upper = upper === upper ? upper : 0;
            }
            if (lower !== undefined) {
                lower = toNumber(lower);
                lower = lower === lower ? lower : 0;
            }
            return baseClamp(toNumber(number), lower, upper);
        }
        /**
     * Checks if `n` is between `start` and up to, but not including, `end`. If
     * `end` is not specified, it's set to `start` with `start` then set to `0`.
     * If `start` is greater than `end` the params are swapped to support
     * negative ranges.
     *
     * @static
     * @memberOf _
     * @since 3.3.0
     * @category Number
     * @param {number} number The number to check.
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     * @see _.range, _.rangeRight
     * @example
     *
     * _.inRange(3, 2, 4);
     * // => true
     *
     * _.inRange(4, 8);
     * // => true
     *
     * _.inRange(4, 2);
     * // => false
     *
     * _.inRange(2, 2);
     * // => false
     *
     * _.inRange(1.2, 2);
     * // => true
     *
     * _.inRange(5.2, 4);
     * // => false
     *
     * _.inRange(-3, -2, -6);
     * // => true
     */ function inRange(number, start, end) {
            start = toFinite(start);
            if (end === undefined) {
                end = start;
                start = 0;
            } else end = toFinite(end);
            number = toNumber(number);
            return baseInRange(number, start, end);
        }
        /**
     * Produces a random number between the inclusive `lower` and `upper` bounds.
     * If only one argument is provided a number between `0` and the given number
     * is returned. If `floating` is `true`, or either `lower` or `upper` are
     * floats, a floating-point number is returned instead of an integer.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Number
     * @param {number} [lower=0] The lower bound.
     * @param {number} [upper=1] The upper bound.
     * @param {boolean} [floating] Specify returning a floating-point number.
     * @returns {number} Returns the random number.
     * @example
     *
     * _.random(0, 5);
     * // => an integer between 0 and 5
     *
     * _.random(5);
     * // => also an integer between 0 and 5
     *
     * _.random(5, true);
     * // => a floating-point number between 0 and 5
     *
     * _.random(1.2, 5.2);
     * // => a floating-point number between 1.2 and 5.2
     */ function random(lower, upper, floating) {
            if (floating && typeof floating != "boolean" && isIterateeCall(lower, upper, floating)) upper = floating = undefined;
            if (floating === undefined) {
                if (typeof upper == "boolean") {
                    floating = upper;
                    upper = undefined;
                } else if (typeof lower == "boolean") {
                    floating = lower;
                    lower = undefined;
                }
            }
            if (lower === undefined && upper === undefined) {
                lower = 0;
                upper = 1;
            } else {
                lower = toFinite(lower);
                if (upper === undefined) {
                    upper = lower;
                    lower = 0;
                } else upper = toFinite(upper);
            }
            if (lower > upper) {
                var temp = lower;
                lower = upper;
                upper = temp;
            }
            if (floating || lower % 1 || upper % 1) {
                var rand = nativeRandom();
                return nativeMin(lower + rand * (upper - lower + freeParseFloat("1e-" + ((rand + "").length - 1))), upper);
            }
            return baseRandom(lower, upper);
        }
        /*------------------------------------------------------------------------*/ /**
     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the camel cased string.
     * @example
     *
     * _.camelCase('Foo Bar');
     * // => 'fooBar'
     *
     * _.camelCase('--foo-bar--');
     * // => 'fooBar'
     *
     * _.camelCase('__FOO_BAR__');
     * // => 'fooBar'
     */ var camelCase = createCompounder(function(result, word, index) {
            word = word.toLowerCase();
            return result + (index ? capitalize(word) : word);
        });
        /**
     * Converts the first character of `string` to upper case and the remaining
     * to lower case.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to capitalize.
     * @returns {string} Returns the capitalized string.
     * @example
     *
     * _.capitalize('FRED');
     * // => 'Fred'
     */ function capitalize(string) {
            return upperFirst(toString(string).toLowerCase());
        }
        /**
     * Deburrs `string` by converting
     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
     * letters to basic Latin letters and removing
     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to deburr.
     * @returns {string} Returns the deburred string.
     * @example
     *
     * _.deburr('déjà vu');
     * // => 'deja vu'
     */ function deburr(string) {
            string = toString(string);
            return string && string.replace(reLatin, deburrLetter).replace(reComboMark, "");
        }
        /**
     * Checks if `string` ends with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=string.length] The position to search up to.
     * @returns {boolean} Returns `true` if `string` ends with `target`,
     *  else `false`.
     * @example
     *
     * _.endsWith('abc', 'c');
     * // => true
     *
     * _.endsWith('abc', 'b');
     * // => false
     *
     * _.endsWith('abc', 'b', 2);
     * // => true
     */ function endsWith(string, target, position) {
            string = toString(string);
            target = baseToString(target);
            var length = string.length;
            position = position === undefined ? length : baseClamp(toInteger(position), 0, length);
            var end = position;
            position -= target.length;
            return position >= 0 && string.slice(position, end) == target;
        }
        /**
     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
     * corresponding HTML entities.
     *
     * **Note:** No other characters are escaped. To escape additional
     * characters use a third-party library like [_he_](https://mths.be/he).
     *
     * Though the ">" character is escaped for symmetry, characters like
     * ">" and "/" don't need escaping in HTML and have no special meaning
     * unless they're part of a tag or unquoted attribute value. See
     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
     * (under "semi-related fun fact") for more details.
     *
     * When working with HTML you should always
     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
     * XSS vectors.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escape('fred, barney, & pebbles');
     * // => 'fred, barney, &amp; pebbles'
     */ function escape(string) {
            string = toString(string);
            return string && reHasUnescapedHtml.test(string) ? string.replace(reUnescapedHtml, escapeHtmlChar) : string;
        }
        /**
     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escapeRegExp('[lodash](https://lodash.com/)');
     * // => '\[lodash\]\(https://lodash\.com/\)'
     */ function escapeRegExp(string) {
            string = toString(string);
            return string && reHasRegExpChar.test(string) ? string.replace(reRegExpChar, "\\$&") : string;
        }
        /**
     * Converts `string` to
     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the kebab cased string.
     * @example
     *
     * _.kebabCase('Foo Bar');
     * // => 'foo-bar'
     *
     * _.kebabCase('fooBar');
     * // => 'foo-bar'
     *
     * _.kebabCase('__FOO_BAR__');
     * // => 'foo-bar'
     */ var kebabCase = createCompounder(function(result, word, index) {
            return result + (index ? "-" : "") + word.toLowerCase();
        });
        /**
     * Converts `string`, as space separated words, to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.lowerCase('--Foo-Bar--');
     * // => 'foo bar'
     *
     * _.lowerCase('fooBar');
     * // => 'foo bar'
     *
     * _.lowerCase('__FOO_BAR__');
     * // => 'foo bar'
     */ var lowerCase = createCompounder(function(result, word, index) {
            return result + (index ? " " : "") + word.toLowerCase();
        });
        /**
     * Converts the first character of `string` to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.lowerFirst('Fred');
     * // => 'fred'
     *
     * _.lowerFirst('FRED');
     * // => 'fRED'
     */ var lowerFirst = createCaseFirst("toLowerCase");
        /**
     * Pads `string` on the left and right sides if it's shorter than `length`.
     * Padding characters are truncated if they can't be evenly divided by `length`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.pad('abc', 8);
     * // => '  abc   '
     *
     * _.pad('abc', 8, '_-');
     * // => '_-abc_-_'
     *
     * _.pad('abc', 3);
     * // => 'abc'
     */ function pad(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            if (!length || strLength >= length) return string;
            var mid = (length - strLength) / 2;
            return createPadding(nativeFloor(mid), chars) + string + createPadding(nativeCeil(mid), chars);
        }
        /**
     * Pads `string` on the right side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padEnd('abc', 6);
     * // => 'abc   '
     *
     * _.padEnd('abc', 6, '_-');
     * // => 'abc_-_'
     *
     * _.padEnd('abc', 3);
     * // => 'abc'
     */ function padEnd(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            return length && strLength < length ? string + createPadding(length - strLength, chars) : string;
        }
        /**
     * Pads `string` on the left side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padStart('abc', 6);
     * // => '   abc'
     *
     * _.padStart('abc', 6, '_-');
     * // => '_-_abc'
     *
     * _.padStart('abc', 3);
     * // => 'abc'
     */ function padStart(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            return length && strLength < length ? createPadding(length - strLength, chars) + string : string;
        }
        /**
     * Converts `string` to an integer of the specified radix. If `radix` is
     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
     * hexadecimal, in which case a `radix` of `16` is used.
     *
     * **Note:** This method aligns with the
     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category String
     * @param {string} string The string to convert.
     * @param {number} [radix=10] The radix to interpret `value` by.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.parseInt('08');
     * // => 8
     *
     * _.map(['6', '08', '10'], _.parseInt);
     * // => [6, 8, 10]
     */ function parseInt1(string, radix, guard) {
            if (guard || radix == null) radix = 0;
            else if (radix) radix = +radix;
            return nativeParseInt(toString(string).replace(reTrimStart, ""), radix || 0);
        }
        /**
     * Repeats the given string `n` times.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to repeat.
     * @param {number} [n=1] The number of times to repeat the string.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the repeated string.
     * @example
     *
     * _.repeat('*', 3);
     * // => '***'
     *
     * _.repeat('abc', 2);
     * // => 'abcabc'
     *
     * _.repeat('abc', 0);
     * // => ''
     */ function repeat(string, n, guard) {
            if (guard ? isIterateeCall(string, n, guard) : n === undefined) n = 1;
            else n = toInteger(n);
            return baseRepeat(toString(string), n);
        }
        /**
     * Replaces matches for `pattern` in `string` with `replacement`.
     *
     * **Note:** This method is based on
     * [`String#replace`](https://mdn.io/String/replace).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to modify.
     * @param {RegExp|string} pattern The pattern to replace.
     * @param {Function|string} replacement The match replacement.
     * @returns {string} Returns the modified string.
     * @example
     *
     * _.replace('Hi Fred', 'Fred', 'Barney');
     * // => 'Hi Barney'
     */ function replace() {
            var args = arguments, string = toString(args[0]);
            return args.length < 3 ? string : string.replace(args[1], args[2]);
        }
        /**
     * Converts `string` to
     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the snake cased string.
     * @example
     *
     * _.snakeCase('Foo Bar');
     * // => 'foo_bar'
     *
     * _.snakeCase('fooBar');
     * // => 'foo_bar'
     *
     * _.snakeCase('--FOO-BAR--');
     * // => 'foo_bar'
     */ var snakeCase = createCompounder(function(result, word, index) {
            return result + (index ? "_" : "") + word.toLowerCase();
        });
        /**
     * Splits `string` by `separator`.
     *
     * **Note:** This method is based on
     * [`String#split`](https://mdn.io/String/split).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to split.
     * @param {RegExp|string} separator The separator pattern to split by.
     * @param {number} [limit] The length to truncate results to.
     * @returns {Array} Returns the string segments.
     * @example
     *
     * _.split('a-b-c', '-', 2);
     * // => ['a', 'b']
     */ function split(string, separator, limit) {
            if (limit && typeof limit != "number" && isIterateeCall(string, separator, limit)) separator = limit = undefined;
            limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
            if (!limit) return [];
            string = toString(string);
            if (string && (typeof separator == "string" || separator != null && !isRegExp(separator))) {
                separator = baseToString(separator);
                if (!separator && hasUnicode(string)) return castSlice(stringToArray(string), 0, limit);
            }
            return string.split(separator, limit);
        }
        /**
     * Converts `string` to
     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
     *
     * @static
     * @memberOf _
     * @since 3.1.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the start cased string.
     * @example
     *
     * _.startCase('--foo-bar--');
     * // => 'Foo Bar'
     *
     * _.startCase('fooBar');
     * // => 'Foo Bar'
     *
     * _.startCase('__FOO_BAR__');
     * // => 'FOO BAR'
     */ var startCase = createCompounder(function(result, word, index) {
            return result + (index ? " " : "") + upperFirst(word);
        });
        /**
     * Checks if `string` starts with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=0] The position to search from.
     * @returns {boolean} Returns `true` if `string` starts with `target`,
     *  else `false`.
     * @example
     *
     * _.startsWith('abc', 'a');
     * // => true
     *
     * _.startsWith('abc', 'b');
     * // => false
     *
     * _.startsWith('abc', 'b', 1);
     * // => true
     */ function startsWith(string, target, position) {
            string = toString(string);
            position = position == null ? 0 : baseClamp(toInteger(position), 0, string.length);
            target = baseToString(target);
            return string.slice(position, position + target.length) == target;
        }
        /**
     * Creates a compiled template function that can interpolate data properties
     * in "interpolate" delimiters, HTML-escape interpolated data properties in
     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
     * properties may be accessed as free variables in the template. If a setting
     * object is given, it takes precedence over `_.templateSettings` values.
     *
     * **Note:** In the development build `_.template` utilizes
     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
     * for easier debugging.
     *
     * For more information on precompiling templates see
     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
     *
     * For more information on Chrome extension sandboxes see
     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The template string.
     * @param {Object} [options={}] The options object.
     * @param {RegExp} [options.escape=_.templateSettings.escape]
     *  The HTML "escape" delimiter.
     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
     *  The "evaluate" delimiter.
     * @param {Object} [options.imports=_.templateSettings.imports]
     *  An object to import into the template as free variables.
     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
     *  The "interpolate" delimiter.
     * @param {string} [options.sourceURL='lodash.templateSources[n]']
     *  The sourceURL of the compiled template.
     * @param {string} [options.variable='obj']
     *  The data object variable name.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the compiled template function.
     * @example
     *
     * // Use the "interpolate" delimiter to create a compiled template.
     * var compiled = _.template('hello <%= user %>!');
     * compiled({ 'user': 'fred' });
     * // => 'hello fred!'
     *
     * // Use the HTML "escape" delimiter to escape data property values.
     * var compiled = _.template('<b><%- value %></b>');
     * compiled({ 'value': '<script>' });
     * // => '<b>&lt;script&gt;</b>'
     *
     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the internal `print` function in "evaluate" delimiters.
     * var compiled = _.template('<% print("hello " + user); %>!');
     * compiled({ 'user': 'barney' });
     * // => 'hello barney!'
     *
     * // Use the ES template literal delimiter as an "interpolate" delimiter.
     * // Disable support by replacing the "interpolate" delimiter.
     * var compiled = _.template('hello ${ user }!');
     * compiled({ 'user': 'pebbles' });
     * // => 'hello pebbles!'
     *
     * // Use backslashes to treat delimiters as plain text.
     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
     * compiled({ 'value': 'ignored' });
     * // => '<%- value %>'
     *
     * // Use the `imports` option to import `jQuery` as `jq`.
     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
     * compiled(data);
     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
     *
     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
     * compiled.source;
     * // => function(data) {
     * //   var __t, __p = '';
     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
     * //   return __p;
     * // }
     *
     * // Use custom template delimiters.
     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
     * var compiled = _.template('hello {{ user }}!');
     * compiled({ 'user': 'mustache' });
     * // => 'hello mustache!'
     *
     * // Use the `source` property to inline compiled templates for meaningful
     * // line numbers in error messages and stack traces.
     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
     *   var JST = {\
     *     "main": ' + _.template(mainText).source + '\
     *   };\
     * ');
     */ function template(string, options, guard) {
            // Based on John Resig's `tmpl` implementation
            // (http://ejohn.org/blog/javascript-micro-templating/)
            // and Laura Doktorova's doT.js (https://github.com/olado/doT).
            var settings = lodash.templateSettings;
            if (guard && isIterateeCall(string, options, guard)) options = undefined;
            string = toString(string);
            options = assignInWith({}, options, settings, customDefaultsAssignIn);
            var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn), importsKeys = keys(imports), importsValues = baseValues(imports, importsKeys);
            var isEscaping, isEvaluating, index = 0, interpolate = options.interpolate || reNoMatch, source = "__p += '";
            // Compile the regexp to match each delimiter.
            var reDelimiters = RegExp1((options.escape || reNoMatch).source + "|" + interpolate.source + "|" + (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + "|" + (options.evaluate || reNoMatch).source + "|$", "g");
            // Use a sourceURL for easier debugging.
            // The sourceURL gets injected into the source that's eval-ed, so be careful
            // to normalize all kinds of whitespace, so e.g. newlines (and unicode versions of it) can't sneak in
            // and escape the comment, thus injecting code that gets evaled.
            var sourceURL = "//# sourceURL=" + (hasOwnProperty.call(options, "sourceURL") ? (options.sourceURL + "").replace(/\s/g, " ") : "lodash.templateSources[" + ++templateCounter + "]") + "\n";
            string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
                interpolateValue || (interpolateValue = esTemplateValue);
                // Escape characters that can't be included in string literals.
                source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);
                // Replace delimiters with snippets.
                if (escapeValue) {
                    isEscaping = true;
                    source += "' +\n__e(" + escapeValue + ") +\n'";
                }
                if (evaluateValue) {
                    isEvaluating = true;
                    source += "';\n" + evaluateValue + ";\n__p += '";
                }
                if (interpolateValue) source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
                index = offset + match.length;
                // The JS engine embedded in Adobe products needs `match` returned in
                // order to produce the correct `offset` value.
                return match;
            });
            source += "';\n";
            // If `variable` is not specified wrap a with-statement around the generated
            // code to add the data object to the top of the scope chain.
            var variable = hasOwnProperty.call(options, "variable") && options.variable;
            if (!variable) source = "with (obj) {\n" + source + "\n}\n";
            else if (reForbiddenIdentifierChars.test(variable)) throw new Error(INVALID_TEMPL_VAR_ERROR_TEXT);
            // Cleanup code by stripping empty strings.
            source = (isEvaluating ? source.replace(reEmptyStringLeading, "") : source).replace(reEmptyStringMiddle, "$1").replace(reEmptyStringTrailing, "$1;");
            // Frame code as the function body.
            source = "function(" + (variable || "obj") + ") {\n" + (variable ? "" : "obj || (obj = {});\n") + "var __t, __p = ''" + (isEscaping ? ", __e = _.escape" : "") + (isEvaluating ? ", __j = Array.prototype.join;\nfunction print() { __p += __j.call(arguments, '') }\n" : ";\n") + source + "return __p\n}";
            var result = attempt(function() {
                return Function1(importsKeys, sourceURL + "return " + source).apply(undefined, importsValues);
            });
            // Provide the compiled function's source by its `toString` method or
            // the `source` property as a convenience for inlining compiled templates.
            result.source = source;
            if (isError(result)) throw result;
            return result;
        }
        /**
     * Converts `string`, as a whole, to lower case just like
     * [String#toLowerCase](https://mdn.io/toLowerCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.toLower('--Foo-Bar--');
     * // => '--foo-bar--'
     *
     * _.toLower('fooBar');
     * // => 'foobar'
     *
     * _.toLower('__FOO_BAR__');
     * // => '__foo_bar__'
     */ function toLower(value) {
            return toString(value).toLowerCase();
        }
        /**
     * Converts `string`, as a whole, to upper case just like
     * [String#toUpperCase](https://mdn.io/toUpperCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.toUpper('--foo-bar--');
     * // => '--FOO-BAR--'
     *
     * _.toUpper('fooBar');
     * // => 'FOOBAR'
     *
     * _.toUpper('__foo_bar__');
     * // => '__FOO_BAR__'
     */ function toUpper(value) {
            return toString(value).toUpperCase();
        }
        /**
     * Removes leading and trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trim('  abc  ');
     * // => 'abc'
     *
     * _.trim('-_-abc-_-', '_-');
     * // => 'abc'
     *
     * _.map(['  foo  ', '  bar  '], _.trim);
     * // => ['foo', 'bar']
     */ function trim(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return baseTrim(string);
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), chrSymbols = stringToArray(chars), start = charsStartIndex(strSymbols, chrSymbols), end = charsEndIndex(strSymbols, chrSymbols) + 1;
            return castSlice(strSymbols, start, end).join("");
        }
        /**
     * Removes trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimEnd('  abc  ');
     * // => '  abc'
     *
     * _.trimEnd('-_-abc-_-', '_-');
     * // => '-_-abc'
     */ function trimEnd(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return string.slice(0, trimmedEndIndex(string) + 1);
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;
            return castSlice(strSymbols, 0, end).join("");
        }
        /**
     * Removes leading whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimStart('  abc  ');
     * // => 'abc  '
     *
     * _.trimStart('-_-abc-_-', '_-');
     * // => 'abc-_-'
     */ function trimStart(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return string.replace(reTrimStart, "");
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), start = charsStartIndex(strSymbols, stringToArray(chars));
            return castSlice(strSymbols, start).join("");
        }
        /**
     * Truncates `string` if it's longer than the given maximum string length.
     * The last characters of the truncated string are replaced with the omission
     * string which defaults to "...".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to truncate.
     * @param {Object} [options={}] The options object.
     * @param {number} [options.length=30] The maximum string length.
     * @param {string} [options.omission='...'] The string to indicate text is omitted.
     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
     * @returns {string} Returns the truncated string.
     * @example
     *
     * _.truncate('hi-diddly-ho there, neighborino');
     * // => 'hi-diddly-ho there, neighbo...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': ' '
     * });
     * // => 'hi-diddly-ho there,...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': /,? +/
     * });
     * // => 'hi-diddly-ho there...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'omission': ' [...]'
     * });
     * // => 'hi-diddly-ho there, neig [...]'
     */ function truncate(string, options) {
            var length = DEFAULT_TRUNC_LENGTH, omission = DEFAULT_TRUNC_OMISSION;
            if (isObject(options)) {
                var separator = "separator" in options ? options.separator : separator;
                length = "length" in options ? toInteger(options.length) : length;
                omission = "omission" in options ? baseToString(options.omission) : omission;
            }
            string = toString(string);
            var strLength = string.length;
            if (hasUnicode(string)) {
                var strSymbols = stringToArray(string);
                strLength = strSymbols.length;
            }
            if (length >= strLength) return string;
            var end = length - stringSize(omission);
            if (end < 1) return omission;
            var result = strSymbols ? castSlice(strSymbols, 0, end).join("") : string.slice(0, end);
            if (separator === undefined) return result + omission;
            if (strSymbols) end += result.length - end;
            if (isRegExp(separator)) {
                if (string.slice(end).search(separator)) {
                    var match, substring = result;
                    if (!separator.global) separator = RegExp1(separator.source, toString(reFlags.exec(separator)) + "g");
                    separator.lastIndex = 0;
                    while(match = separator.exec(substring))var newEnd = match.index;
                    result = result.slice(0, newEnd === undefined ? end : newEnd);
                }
            } else if (string.indexOf(baseToString(separator), end) != end) {
                var index = result.lastIndexOf(separator);
                if (index > -1) result = result.slice(0, index);
            }
            return result + omission;
        }
        /**
     * The inverse of `_.escape`; this method converts the HTML entities
     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
     * their corresponding characters.
     *
     * **Note:** No other HTML entities are unescaped. To unescape additional
     * HTML entities use a third-party library like [_he_](https://mths.be/he).
     *
     * @static
     * @memberOf _
     * @since 0.6.0
     * @category String
     * @param {string} [string=''] The string to unescape.
     * @returns {string} Returns the unescaped string.
     * @example
     *
     * _.unescape('fred, barney, &amp; pebbles');
     * // => 'fred, barney, & pebbles'
     */ function unescape(string) {
            string = toString(string);
            return string && reHasEscapedHtml.test(string) ? string.replace(reEscapedHtml, unescapeHtmlChar) : string;
        }
        /**
     * Converts `string`, as space separated words, to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.upperCase('--foo-bar');
     * // => 'FOO BAR'
     *
     * _.upperCase('fooBar');
     * // => 'FOO BAR'
     *
     * _.upperCase('__foo_bar__');
     * // => 'FOO BAR'
     */ var upperCase = createCompounder(function(result, word, index) {
            return result + (index ? " " : "") + word.toUpperCase();
        });
        /**
     * Converts the first character of `string` to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.upperFirst('fred');
     * // => 'Fred'
     *
     * _.upperFirst('FRED');
     * // => 'FRED'
     */ var upperFirst = createCaseFirst("toUpperCase");
        /**
     * Splits `string` into an array of its words.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {RegExp|string} [pattern] The pattern to match words.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the words of `string`.
     * @example
     *
     * _.words('fred, barney, & pebbles');
     * // => ['fred', 'barney', 'pebbles']
     *
     * _.words('fred, barney, & pebbles', /[^, ]+/g);
     * // => ['fred', 'barney', '&', 'pebbles']
     */ function words(string, pattern, guard) {
            string = toString(string);
            pattern = guard ? undefined : pattern;
            if (pattern === undefined) return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
            return string.match(pattern) || [];
        }
        /*------------------------------------------------------------------------*/ /**
     * Attempts to invoke `func`, returning either the result or the caught error
     * object. Any additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Function} func The function to attempt.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {*} Returns the `func` result or error object.
     * @example
     *
     * // Avoid throwing errors for invalid selectors.
     * var elements = _.attempt(function(selector) {
     *   return document.querySelectorAll(selector);
     * }, '>_>');
     *
     * if (_.isError(elements)) {
     *   elements = [];
     * }
     */ var attempt = baseRest(function(func, args) {
            try {
                return apply(func, undefined, args);
            } catch (e) {
                return isError(e) ? e : new Error(e);
            }
        });
        /**
     * Binds methods of an object to the object itself, overwriting the existing
     * method.
     *
     * **Note:** This method doesn't set the "length" property of bound functions.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Object} object The object to bind and assign the bound methods to.
     * @param {...(string|string[])} methodNames The object method names to bind.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var view = {
     *   'label': 'docs',
     *   'click': function() {
     *     console.log('clicked ' + this.label);
     *   }
     * };
     *
     * _.bindAll(view, ['click']);
     * jQuery(element).on('click', view.click);
     * // => Logs 'clicked docs' when clicked.
     */ var bindAll = flatRest(function(object, methodNames) {
            arrayEach(methodNames, function(key) {
                key = toKey(key);
                baseAssignValue(object, key, bind(object[key], object));
            });
            return object;
        });
        /**
     * Creates a function that iterates over `pairs` and invokes the corresponding
     * function of the first predicate to return truthy. The predicate-function
     * pairs are invoked with the `this` binding and arguments of the created
     * function.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Array} pairs The predicate-function pairs.
     * @returns {Function} Returns the new composite function.
     * @example
     *
     * var func = _.cond([
     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
     *   [_.stubTrue,                      _.constant('no match')]
     * ]);
     *
     * func({ 'a': 1, 'b': 2 });
     * // => 'matches A'
     *
     * func({ 'a': 0, 'b': 1 });
     * // => 'matches B'
     *
     * func({ 'a': '1', 'b': '2' });
     * // => 'no match'
     */ function cond(pairs) {
            var length = pairs == null ? 0 : pairs.length, toIteratee = getIteratee();
            pairs = !length ? [] : arrayMap(pairs, function(pair) {
                if (typeof pair[1] != "function") throw new TypeError(FUNC_ERROR_TEXT);
                return [
                    toIteratee(pair[0]),
                    pair[1]
                ];
            });
            return baseRest(function(args) {
                var index = -1;
                while(++index < length){
                    var pair = pairs[index];
                    if (apply(pair[0], this, args)) return apply(pair[1], this, args);
                }
            });
        }
        /**
     * Creates a function that invokes the predicate properties of `source` with
     * the corresponding property values of a given object, returning `true` if
     * all predicates return truthy, else `false`.
     *
     * **Note:** The created function is equivalent to `_.conformsTo` with
     * `source` partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 2, 'b': 1 },
     *   { 'a': 1, 'b': 2 }
     * ];
     *
     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
     * // => [{ 'a': 1, 'b': 2 }]
     */ function conforms(source) {
            return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that returns `value`.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {*} value The value to return from the new function.
     * @returns {Function} Returns the new constant function.
     * @example
     *
     * var objects = _.times(2, _.constant({ 'a': 1 }));
     *
     * console.log(objects);
     * // => [{ 'a': 1 }, { 'a': 1 }]
     *
     * console.log(objects[0] === objects[1]);
     * // => true
     */ function constant(value) {
            return function() {
                return value;
            };
        }
        /**
     * Checks `value` to determine whether a default value should be returned in
     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
     * or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Util
     * @param {*} value The value to check.
     * @param {*} defaultValue The default value.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * _.defaultTo(1, 10);
     * // => 1
     *
     * _.defaultTo(undefined, 10);
     * // => 10
     */ function defaultTo(value, defaultValue) {
            return value == null || value !== value ? defaultValue : value;
        }
        /**
     * Creates a function that returns the result of invoking the given functions
     * with the `this` binding of the created function, where each successive
     * invocation is supplied the return value of the previous.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flowRight
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flow([_.add, square]);
     * addSquare(1, 2);
     * // => 9
     */ var flow = createFlow();
        /**
     * This method is like `_.flow` except that it creates a function that
     * invokes the given functions from right to left.
     *
     * @static
     * @since 3.0.0
     * @memberOf _
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flow
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flowRight([square, _.add]);
     * addSquare(1, 2);
     * // => 9
     */ var flowRight = createFlow(true);
        /**
     * This method returns the first argument it receives.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {*} value Any value.
     * @returns {*} Returns `value`.
     * @example
     *
     * var object = { 'a': 1 };
     *
     * console.log(_.identity(object) === object);
     * // => true
     */ function identity(value) {
            return value;
        }
        /**
     * Creates a function that invokes `func` with the arguments of the created
     * function. If `func` is a property name, the created function returns the
     * property value for a given element. If `func` is an array or object, the
     * created function returns `true` for elements that contain the equivalent
     * source properties, otherwise it returns `false`.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Util
     * @param {*} [func=_.identity] The value to convert to a callback.
     * @returns {Function} Returns the callback.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, _.iteratee(['user', 'fred']));
     * // => [{ 'user': 'fred', 'age': 40 }]
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, _.iteratee('user'));
     * // => ['barney', 'fred']
     *
     * // Create custom iteratee shorthands.
     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
     *     return func.test(string);
     *   };
     * });
     *
     * _.filter(['abc', 'def'], /ef/);
     * // => ['def']
     */ function iteratee(func) {
            return baseIteratee(typeof func == "function" ? func : baseClone(func, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that performs a partial deep comparison between a given
     * object and `source`, returning `true` if the given object has equivalent
     * property values, else `false`.
     *
     * **Note:** The created function is equivalent to `_.isMatch` with `source`
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matches({ 'a': 1 }), _.matches({ 'a': 4 })]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */ function matches(source) {
            return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that performs a partial deep comparison between the
     * value at `path` of a given object to `srcValue`, returning `true` if the
     * object value is equivalent, else `false`.
     *
     * **Note:** Partial comparisons will match empty array and empty object
     * `srcValue` values against any array or object value, respectively. See
     * `_.isEqual` for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.find(objects, _.matchesProperty('a', 4));
     * // => { 'a': 4, 'b': 5, 'c': 6 }
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matchesProperty('a', 1), _.matchesProperty('a', 4)]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */ function matchesProperty(path, srcValue) {
            return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that invokes the method at `path` of a given object.
     * Any additional arguments are provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': _.constant(2) } },
     *   { 'a': { 'b': _.constant(1) } }
     * ];
     *
     * _.map(objects, _.method('a.b'));
     * // => [2, 1]
     *
     * _.map(objects, _.method(['a', 'b']));
     * // => [2, 1]
     */ var method = baseRest(function(path, args) {
            return function(object) {
                return baseInvoke(object, path, args);
            };
        });
        /**
     * The opposite of `_.method`; this method creates a function that invokes
     * the method at a given path of `object`. Any additional arguments are
     * provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Object} object The object to query.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var array = _.times(3, _.constant),
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
     * // => [2, 0]
     */ var methodOf = baseRest(function(object, args) {
            return function(path) {
                return baseInvoke(object, path, args);
            };
        });
        /**
     * Adds all own enumerable string keyed function properties of a source
     * object to the destination object. If `object` is a function, then methods
     * are added to its prototype as well.
     *
     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
     * avoid conflicts caused by modifying the original.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Function|Object} [object=lodash] The destination object.
     * @param {Object} source The object of functions to add.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
     * @returns {Function|Object} Returns `object`.
     * @example
     *
     * function vowels(string) {
     *   return _.filter(string, function(v) {
     *     return /[aeiou]/i.test(v);
     *   });
     * }
     *
     * _.mixin({ 'vowels': vowels });
     * _.vowels('fred');
     * // => ['e']
     *
     * _('fred').vowels().value();
     * // => ['e']
     *
     * _.mixin({ 'vowels': vowels }, { 'chain': false });
     * _('fred').vowels();
     * // => ['e']
     */ function mixin(object, source, options) {
            var props = keys(source), methodNames = baseFunctions(source, props);
            if (options == null && !(isObject(source) && (methodNames.length || !props.length))) {
                options = source;
                source = object;
                object = this;
                methodNames = baseFunctions(source, keys(source));
            }
            var chain = !(isObject(options) && "chain" in options) || !!options.chain, isFunc = isFunction(object);
            arrayEach(methodNames, function(methodName) {
                var func = source[methodName];
                object[methodName] = func;
                if (isFunc) object.prototype[methodName] = function() {
                    var chainAll = this.__chain__;
                    if (chain || chainAll) {
                        var result = object(this.__wrapped__), actions = result.__actions__ = copyArray(this.__actions__);
                        actions.push({
                            "func": func,
                            "args": arguments,
                            "thisArg": object
                        });
                        result.__chain__ = chainAll;
                        return result;
                    }
                    return func.apply(object, arrayPush([
                        this.value()
                    ], arguments));
                };
            });
            return object;
        }
        /**
     * Reverts the `_` variable to its previous value and returns a reference to
     * the `lodash` function.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @returns {Function} Returns the `lodash` function.
     * @example
     *
     * var lodash = _.noConflict();
     */ function noConflict() {
            if (root._ === this) root._ = oldDash;
            return this;
        }
        /**
     * This method returns `undefined`.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Util
     * @example
     *
     * _.times(2, _.noop);
     * // => [undefined, undefined]
     */ function noop() {
        // No operation performed.
        }
        /**
     * Creates a function that gets the argument at index `n`. If `n` is negative,
     * the nth argument from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [n=0] The index of the argument to return.
     * @returns {Function} Returns the new pass-thru function.
     * @example
     *
     * var func = _.nthArg(1);
     * func('a', 'b', 'c', 'd');
     * // => 'b'
     *
     * var func = _.nthArg(-2);
     * func('a', 'b', 'c', 'd');
     * // => 'c'
     */ function nthArg(n) {
            n = toInteger(n);
            return baseRest(function(args) {
                return baseNth(args, n);
            });
        }
        /**
     * Creates a function that invokes `iteratees` with the arguments it receives
     * and returns their results.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to invoke.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.over([Math.max, Math.min]);
     *
     * func(1, 2, 3, 4);
     * // => [4, 1]
     */ var over = createOver(arrayMap);
        /**
     * Creates a function that checks if **all** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overEvery([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => false
     *
     * func(NaN);
     * // => false
     */ var overEvery = createOver(arrayEvery);
        /**
     * Creates a function that checks if **any** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overSome([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => true
     *
     * func(NaN);
     * // => false
     *
     * var matchesFunc = _.overSome([{ 'a': 1 }, { 'a': 2 }])
     * var matchesPropertyFunc = _.overSome([['a', 1], ['a', 2]])
     */ var overSome = createOver(arraySome);
        /**
     * Creates a function that returns the value at `path` of a given object.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': 2 } },
     *   { 'a': { 'b': 1 } }
     * ];
     *
     * _.map(objects, _.property('a.b'));
     * // => [2, 1]
     *
     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
     * // => [1, 2]
     */ function property(path) {
            return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
        }
        /**
     * The opposite of `_.property`; this method creates a function that returns
     * the value at a given path of `object`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} object The object to query.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var array = [0, 1, 2],
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
     * // => [2, 0]
     */ function propertyOf(object) {
            return function(path) {
                return object == null ? undefined : baseGet(object, path);
            };
        }
        /**
     * Creates an array of numbers (positive and/or negative) progressing from
     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
     * `start` is specified without an `end` or `step`. If `end` is not specified,
     * it's set to `start` with `start` then set to `0`.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.rangeRight
     * @example
     *
     * _.range(4);
     * // => [0, 1, 2, 3]
     *
     * _.range(-4);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 5);
     * // => [1, 2, 3, 4]
     *
     * _.range(0, 20, 5);
     * // => [0, 5, 10, 15]
     *
     * _.range(0, -4, -1);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.range(0);
     * // => []
     */ var range = createRange();
        /**
     * This method is like `_.range` except that it populates values in
     * descending order.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.range
     * @example
     *
     * _.rangeRight(4);
     * // => [3, 2, 1, 0]
     *
     * _.rangeRight(-4);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 5);
     * // => [4, 3, 2, 1]
     *
     * _.rangeRight(0, 20, 5);
     * // => [15, 10, 5, 0]
     *
     * _.rangeRight(0, -4, -1);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.rangeRight(0);
     * // => []
     */ var rangeRight = createRange(true);
        /**
     * This method returns a new empty array.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Array} Returns the new empty array.
     * @example
     *
     * var arrays = _.times(2, _.stubArray);
     *
     * console.log(arrays);
     * // => [[], []]
     *
     * console.log(arrays[0] === arrays[1]);
     * // => false
     */ function stubArray() {
            return [];
        }
        /**
     * This method returns `false`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `false`.
     * @example
     *
     * _.times(2, _.stubFalse);
     * // => [false, false]
     */ function stubFalse() {
            return false;
        }
        /**
     * This method returns a new empty object.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Object} Returns the new empty object.
     * @example
     *
     * var objects = _.times(2, _.stubObject);
     *
     * console.log(objects);
     * // => [{}, {}]
     *
     * console.log(objects[0] === objects[1]);
     * // => false
     */ function stubObject() {
            return {};
        }
        /**
     * This method returns an empty string.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {string} Returns the empty string.
     * @example
     *
     * _.times(2, _.stubString);
     * // => ['', '']
     */ function stubString() {
            return "";
        }
        /**
     * This method returns `true`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `true`.
     * @example
     *
     * _.times(2, _.stubTrue);
     * // => [true, true]
     */ function stubTrue() {
            return true;
        }
        /**
     * Invokes the iteratee `n` times, returning an array of the results of
     * each invocation. The iteratee is invoked with one argument; (index).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} n The number of times to invoke `iteratee`.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.times(3, String);
     * // => ['0', '1', '2']
     *
     *  _.times(4, _.constant(0));
     * // => [0, 0, 0, 0]
     */ function times(n, iteratee) {
            n = toInteger(n);
            if (n < 1 || n > MAX_SAFE_INTEGER) return [];
            var index = MAX_ARRAY_LENGTH, length = nativeMin(n, MAX_ARRAY_LENGTH);
            iteratee = getIteratee(iteratee);
            n -= MAX_ARRAY_LENGTH;
            var result = baseTimes(length, iteratee);
            while(++index < n)iteratee(index);
            return result;
        }
        /**
     * Converts `value` to a property path array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {*} value The value to convert.
     * @returns {Array} Returns the new property path array.
     * @example
     *
     * _.toPath('a.b.c');
     * // => ['a', 'b', 'c']
     *
     * _.toPath('a[0].b.c');
     * // => ['a', '0', 'b', 'c']
     */ function toPath(value) {
            if (isArray(value)) return arrayMap(value, toKey);
            return isSymbol(value) ? [
                value
            ] : copyArray(stringToPath(toString(value)));
        }
        /**
     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {string} [prefix=''] The value to prefix the ID with.
     * @returns {string} Returns the unique ID.
     * @example
     *
     * _.uniqueId('contact_');
     * // => 'contact_104'
     *
     * _.uniqueId();
     * // => '105'
     */ function uniqueId(prefix) {
            var id = ++idCounter;
            return toString(prefix) + id;
        }
        /*------------------------------------------------------------------------*/ /**
     * Adds two numbers.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {number} augend The first number in an addition.
     * @param {number} addend The second number in an addition.
     * @returns {number} Returns the total.
     * @example
     *
     * _.add(6, 4);
     * // => 10
     */ var add = createMathOperation(function(augend, addend) {
            return augend + addend;
        }, 0);
        /**
     * Computes `number` rounded up to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round up.
     * @param {number} [precision=0] The precision to round up to.
     * @returns {number} Returns the rounded up number.
     * @example
     *
     * _.ceil(4.006);
     * // => 5
     *
     * _.ceil(6.004, 2);
     * // => 6.01
     *
     * _.ceil(6040, -2);
     * // => 6100
     */ var ceil = createRound("ceil");
        /**
     * Divide two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} dividend The first number in a division.
     * @param {number} divisor The second number in a division.
     * @returns {number} Returns the quotient.
     * @example
     *
     * _.divide(6, 4);
     * // => 1.5
     */ var divide = createMathOperation(function(dividend, divisor) {
            return dividend / divisor;
        }, 1);
        /**
     * Computes `number` rounded down to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round down.
     * @param {number} [precision=0] The precision to round down to.
     * @returns {number} Returns the rounded down number.
     * @example
     *
     * _.floor(4.006);
     * // => 4
     *
     * _.floor(0.046, 2);
     * // => 0.04
     *
     * _.floor(4060, -2);
     * // => 4000
     */ var floor = createRound("floor");
        /**
     * Computes the maximum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * _.max([4, 2, 8, 6]);
     * // => 8
     *
     * _.max([]);
     * // => undefined
     */ function max(array) {
            return array && array.length ? baseExtremum(array, identity, baseGt) : undefined;
        }
        /**
     * This method is like `_.max` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.maxBy(objects, function(o) { return o.n; });
     * // => { 'n': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.maxBy(objects, 'n');
     * // => { 'n': 2 }
     */ function maxBy(array, iteratee) {
            return array && array.length ? baseExtremum(array, getIteratee(iteratee, 2), baseGt) : undefined;
        }
        /**
     * Computes the mean of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the mean.
     * @example
     *
     * _.mean([4, 2, 8, 6]);
     * // => 5
     */ function mean(array) {
            return baseMean(array, identity);
        }
        /**
     * This method is like `_.mean` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be averaged.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the mean.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.meanBy(objects, function(o) { return o.n; });
     * // => 5
     *
     * // The `_.property` iteratee shorthand.
     * _.meanBy(objects, 'n');
     * // => 5
     */ function meanBy(array, iteratee) {
            return baseMean(array, getIteratee(iteratee, 2));
        }
        /**
     * Computes the minimum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * _.min([4, 2, 8, 6]);
     * // => 2
     *
     * _.min([]);
     * // => undefined
     */ function min(array) {
            return array && array.length ? baseExtremum(array, identity, baseLt) : undefined;
        }
        /**
     * This method is like `_.min` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.minBy(objects, function(o) { return o.n; });
     * // => { 'n': 1 }
     *
     * // The `_.property` iteratee shorthand.
     * _.minBy(objects, 'n');
     * // => { 'n': 1 }
     */ function minBy(array, iteratee) {
            return array && array.length ? baseExtremum(array, getIteratee(iteratee, 2), baseLt) : undefined;
        }
        /**
     * Multiply two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} multiplier The first number in a multiplication.
     * @param {number} multiplicand The second number in a multiplication.
     * @returns {number} Returns the product.
     * @example
     *
     * _.multiply(6, 4);
     * // => 24
     */ var multiply = createMathOperation(function(multiplier, multiplicand) {
            return multiplier * multiplicand;
        }, 1);
        /**
     * Computes `number` rounded to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round.
     * @param {number} [precision=0] The precision to round to.
     * @returns {number} Returns the rounded number.
     * @example
     *
     * _.round(4.006);
     * // => 4
     *
     * _.round(4.006, 2);
     * // => 4.01
     *
     * _.round(4060, -2);
     * // => 4100
     */ var round = createRound("round");
        /**
     * Subtract two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {number} minuend The first number in a subtraction.
     * @param {number} subtrahend The second number in a subtraction.
     * @returns {number} Returns the difference.
     * @example
     *
     * _.subtract(6, 4);
     * // => 2
     */ var subtract = createMathOperation(function(minuend, subtrahend) {
            return minuend - subtrahend;
        }, 0);
        /**
     * Computes the sum of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the sum.
     * @example
     *
     * _.sum([4, 2, 8, 6]);
     * // => 20
     */ function sum(array) {
            return array && array.length ? baseSum(array, identity) : 0;
        }
        /**
     * This method is like `_.sum` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be summed.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the sum.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.sumBy(objects, function(o) { return o.n; });
     * // => 20
     *
     * // The `_.property` iteratee shorthand.
     * _.sumBy(objects, 'n');
     * // => 20
     */ function sumBy(array, iteratee) {
            return array && array.length ? baseSum(array, getIteratee(iteratee, 2)) : 0;
        }
        /*------------------------------------------------------------------------*/ // Add methods that return wrapped values in chain sequences.
        lodash.after = after;
        lodash.ary = ary;
        lodash.assign = assign;
        lodash.assignIn = assignIn;
        lodash.assignInWith = assignInWith;
        lodash.assignWith = assignWith;
        lodash.at = at;
        lodash.before = before;
        lodash.bind = bind;
        lodash.bindAll = bindAll;
        lodash.bindKey = bindKey;
        lodash.castArray = castArray;
        lodash.chain = chain;
        lodash.chunk = chunk;
        lodash.compact = compact;
        lodash.concat = concat;
        lodash.cond = cond;
        lodash.conforms = conforms;
        lodash.constant = constant;
        lodash.countBy = countBy;
        lodash.create = create;
        lodash.curry = curry;
        lodash.curryRight = curryRight;
        lodash.debounce = debounce;
        lodash.defaults = defaults;
        lodash.defaultsDeep = defaultsDeep;
        lodash.defer = defer;
        lodash.delay = delay;
        lodash.difference = difference;
        lodash.differenceBy = differenceBy;
        lodash.differenceWith = differenceWith;
        lodash.drop = drop;
        lodash.dropRight = dropRight;
        lodash.dropRightWhile = dropRightWhile;
        lodash.dropWhile = dropWhile;
        lodash.fill = fill;
        lodash.filter = filter;
        lodash.flatMap = flatMap;
        lodash.flatMapDeep = flatMapDeep;
        lodash.flatMapDepth = flatMapDepth;
        lodash.flatten = flatten;
        lodash.flattenDeep = flattenDeep;
        lodash.flattenDepth = flattenDepth;
        lodash.flip = flip;
        lodash.flow = flow;
        lodash.flowRight = flowRight;
        lodash.fromPairs = fromPairs;
        lodash.functions = functions;
        lodash.functionsIn = functionsIn;
        lodash.groupBy = groupBy;
        lodash.initial = initial;
        lodash.intersection = intersection;
        lodash.intersectionBy = intersectionBy;
        lodash.intersectionWith = intersectionWith;
        lodash.invert = invert;
        lodash.invertBy = invertBy;
        lodash.invokeMap = invokeMap;
        lodash.iteratee = iteratee;
        lodash.keyBy = keyBy;
        lodash.keys = keys;
        lodash.keysIn = keysIn;
        lodash.map = map;
        lodash.mapKeys = mapKeys;
        lodash.mapValues = mapValues;
        lodash.matches = matches;
        lodash.matchesProperty = matchesProperty;
        lodash.memoize = memoize;
        lodash.merge = merge;
        lodash.mergeWith = mergeWith;
        lodash.method = method;
        lodash.methodOf = methodOf;
        lodash.mixin = mixin;
        lodash.negate = negate;
        lodash.nthArg = nthArg;
        lodash.omit = omit;
        lodash.omitBy = omitBy;
        lodash.once = once;
        lodash.orderBy = orderBy;
        lodash.over = over;
        lodash.overArgs = overArgs;
        lodash.overEvery = overEvery;
        lodash.overSome = overSome;
        lodash.partial = partial;
        lodash.partialRight = partialRight;
        lodash.partition = partition;
        lodash.pick = pick;
        lodash.pickBy = pickBy;
        lodash.property = property;
        lodash.propertyOf = propertyOf;
        lodash.pull = pull;
        lodash.pullAll = pullAll;
        lodash.pullAllBy = pullAllBy;
        lodash.pullAllWith = pullAllWith;
        lodash.pullAt = pullAt;
        lodash.range = range;
        lodash.rangeRight = rangeRight;
        lodash.rearg = rearg;
        lodash.reject = reject;
        lodash.remove = remove;
        lodash.rest = rest;
        lodash.reverse = reverse;
        lodash.sampleSize = sampleSize;
        lodash.set = set;
        lodash.setWith = setWith;
        lodash.shuffle = shuffle;
        lodash.slice = slice;
        lodash.sortBy = sortBy;
        lodash.sortedUniq = sortedUniq;
        lodash.sortedUniqBy = sortedUniqBy;
        lodash.split = split;
        lodash.spread = spread;
        lodash.tail = tail;
        lodash.take = take;
        lodash.takeRight = takeRight;
        lodash.takeRightWhile = takeRightWhile;
        lodash.takeWhile = takeWhile;
        lodash.tap = tap;
        lodash.throttle = throttle;
        lodash.thru = thru;
        lodash.toArray = toArray;
        lodash.toPairs = toPairs;
        lodash.toPairsIn = toPairsIn;
        lodash.toPath = toPath;
        lodash.toPlainObject = toPlainObject;
        lodash.transform = transform;
        lodash.unary = unary;
        lodash.union = union;
        lodash.unionBy = unionBy;
        lodash.unionWith = unionWith;
        lodash.uniq = uniq;
        lodash.uniqBy = uniqBy;
        lodash.uniqWith = uniqWith;
        lodash.unset = unset;
        lodash.unzip = unzip;
        lodash.unzipWith = unzipWith;
        lodash.update = update;
        lodash.updateWith = updateWith;
        lodash.values = values;
        lodash.valuesIn = valuesIn;
        lodash.without = without;
        lodash.words = words;
        lodash.wrap = wrap;
        lodash.xor = xor;
        lodash.xorBy = xorBy;
        lodash.xorWith = xorWith;
        lodash.zip = zip;
        lodash.zipObject = zipObject;
        lodash.zipObjectDeep = zipObjectDeep;
        lodash.zipWith = zipWith;
        // Add aliases.
        lodash.entries = toPairs;
        lodash.entriesIn = toPairsIn;
        lodash.extend = assignIn;
        lodash.extendWith = assignInWith;
        // Add methods to `lodash.prototype`.
        mixin(lodash, lodash);
        /*------------------------------------------------------------------------*/ // Add methods that return unwrapped values in chain sequences.
        lodash.add = add;
        lodash.attempt = attempt;
        lodash.camelCase = camelCase;
        lodash.capitalize = capitalize;
        lodash.ceil = ceil;
        lodash.clamp = clamp;
        lodash.clone = clone;
        lodash.cloneDeep = cloneDeep;
        lodash.cloneDeepWith = cloneDeepWith;
        lodash.cloneWith = cloneWith;
        lodash.conformsTo = conformsTo;
        lodash.deburr = deburr;
        lodash.defaultTo = defaultTo;
        lodash.divide = divide;
        lodash.endsWith = endsWith;
        lodash.eq = eq;
        lodash.escape = escape;
        lodash.escapeRegExp = escapeRegExp;
        lodash.every = every;
        lodash.find = find;
        lodash.findIndex = findIndex;
        lodash.findKey = findKey;
        lodash.findLast = findLast;
        lodash.findLastIndex = findLastIndex;
        lodash.findLastKey = findLastKey;
        lodash.floor = floor;
        lodash.forEach = forEach;
        lodash.forEachRight = forEachRight;
        lodash.forIn = forIn;
        lodash.forInRight = forInRight;
        lodash.forOwn = forOwn;
        lodash.forOwnRight = forOwnRight;
        lodash.get = get;
        lodash.gt = gt;
        lodash.gte = gte;
        lodash.has = has;
        lodash.hasIn = hasIn;
        lodash.head = head;
        lodash.identity = identity;
        lodash.includes = includes;
        lodash.indexOf = indexOf;
        lodash.inRange = inRange;
        lodash.invoke = invoke;
        lodash.isArguments = isArguments;
        lodash.isArray = isArray;
        lodash.isArrayBuffer = isArrayBuffer;
        lodash.isArrayLike = isArrayLike;
        lodash.isArrayLikeObject = isArrayLikeObject;
        lodash.isBoolean = isBoolean;
        lodash.isBuffer = isBuffer;
        lodash.isDate = isDate;
        lodash.isElement = isElement;
        lodash.isEmpty = isEmpty;
        lodash.isEqual = isEqual;
        lodash.isEqualWith = isEqualWith;
        lodash.isError = isError;
        lodash.isFinite = isFinite;
        lodash.isFunction = isFunction;
        lodash.isInteger = isInteger;
        lodash.isLength = isLength;
        lodash.isMap = isMap;
        lodash.isMatch = isMatch;
        lodash.isMatchWith = isMatchWith;
        lodash.isNaN = isNaN;
        lodash.isNative = isNative;
        lodash.isNil = isNil;
        lodash.isNull = isNull;
        lodash.isNumber = isNumber;
        lodash.isObject = isObject;
        lodash.isObjectLike = isObjectLike;
        lodash.isPlainObject = isPlainObject;
        lodash.isRegExp = isRegExp;
        lodash.isSafeInteger = isSafeInteger;
        lodash.isSet = isSet;
        lodash.isString = isString;
        lodash.isSymbol = isSymbol;
        lodash.isTypedArray = isTypedArray;
        lodash.isUndefined = isUndefined;
        lodash.isWeakMap = isWeakMap;
        lodash.isWeakSet = isWeakSet;
        lodash.join = join;
        lodash.kebabCase = kebabCase;
        lodash.last = last;
        lodash.lastIndexOf = lastIndexOf;
        lodash.lowerCase = lowerCase;
        lodash.lowerFirst = lowerFirst;
        lodash.lt = lt;
        lodash.lte = lte;
        lodash.max = max;
        lodash.maxBy = maxBy;
        lodash.mean = mean;
        lodash.meanBy = meanBy;
        lodash.min = min;
        lodash.minBy = minBy;
        lodash.stubArray = stubArray;
        lodash.stubFalse = stubFalse;
        lodash.stubObject = stubObject;
        lodash.stubString = stubString;
        lodash.stubTrue = stubTrue;
        lodash.multiply = multiply;
        lodash.nth = nth;
        lodash.noConflict = noConflict;
        lodash.noop = noop;
        lodash.now = now;
        lodash.pad = pad;
        lodash.padEnd = padEnd;
        lodash.padStart = padStart;
        lodash.parseInt = parseInt1;
        lodash.random = random;
        lodash.reduce = reduce;
        lodash.reduceRight = reduceRight;
        lodash.repeat = repeat;
        lodash.replace = replace;
        lodash.result = result;
        lodash.round = round;
        lodash.runInContext = runInContext;
        lodash.sample = sample;
        lodash.size = size;
        lodash.snakeCase = snakeCase;
        lodash.some = some;
        lodash.sortedIndex = sortedIndex;
        lodash.sortedIndexBy = sortedIndexBy;
        lodash.sortedIndexOf = sortedIndexOf;
        lodash.sortedLastIndex = sortedLastIndex;
        lodash.sortedLastIndexBy = sortedLastIndexBy;
        lodash.sortedLastIndexOf = sortedLastIndexOf;
        lodash.startCase = startCase;
        lodash.startsWith = startsWith;
        lodash.subtract = subtract;
        lodash.sum = sum;
        lodash.sumBy = sumBy;
        lodash.template = template;
        lodash.times = times;
        lodash.toFinite = toFinite;
        lodash.toInteger = toInteger;
        lodash.toLength = toLength;
        lodash.toLower = toLower;
        lodash.toNumber = toNumber;
        lodash.toSafeInteger = toSafeInteger;
        lodash.toString = toString;
        lodash.toUpper = toUpper;
        lodash.trim = trim;
        lodash.trimEnd = trimEnd;
        lodash.trimStart = trimStart;
        lodash.truncate = truncate;
        lodash.unescape = unescape;
        lodash.uniqueId = uniqueId;
        lodash.upperCase = upperCase;
        lodash.upperFirst = upperFirst;
        // Add aliases.
        lodash.each = forEach;
        lodash.eachRight = forEachRight;
        lodash.first = head;
        mixin(lodash, function() {
            var source = {};
            baseForOwn(lodash, function(func, methodName) {
                if (!hasOwnProperty.call(lodash.prototype, methodName)) source[methodName] = func;
            });
            return source;
        }(), {
            "chain": false
        });
        /*------------------------------------------------------------------------*/ /**
     * The semantic version number.
     *
     * @static
     * @memberOf _
     * @type {string}
     */ lodash.VERSION = VERSION;
        // Assign default placeholders.
        arrayEach([
            "bind",
            "bindKey",
            "curry",
            "curryRight",
            "partial",
            "partialRight"
        ], function(methodName) {
            lodash[methodName].placeholder = lodash;
        });
        // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
        arrayEach([
            "drop",
            "take"
        ], function(methodName, index) {
            LazyWrapper.prototype[methodName] = function(n) {
                n = n === undefined ? 1 : nativeMax(toInteger(n), 0);
                var result = this.__filtered__ && !index ? new LazyWrapper(this) : this.clone();
                if (result.__filtered__) result.__takeCount__ = nativeMin(n, result.__takeCount__);
                else result.__views__.push({
                    "size": nativeMin(n, MAX_ARRAY_LENGTH),
                    "type": methodName + (result.__dir__ < 0 ? "Right" : "")
                });
                return result;
            };
            LazyWrapper.prototype[methodName + "Right"] = function(n) {
                return this.reverse()[methodName](n).reverse();
            };
        });
        // Add `LazyWrapper` methods that accept an `iteratee` value.
        arrayEach([
            "filter",
            "map",
            "takeWhile"
        ], function(methodName, index) {
            var type = index + 1, isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;
            LazyWrapper.prototype[methodName] = function(iteratee) {
                var result = this.clone();
                result.__iteratees__.push({
                    "iteratee": getIteratee(iteratee, 3),
                    "type": type
                });
                result.__filtered__ = result.__filtered__ || isFilter;
                return result;
            };
        });
        // Add `LazyWrapper` methods for `_.head` and `_.last`.
        arrayEach([
            "head",
            "last"
        ], function(methodName, index) {
            var takeName = "take" + (index ? "Right" : "");
            LazyWrapper.prototype[methodName] = function() {
                return this[takeName](1).value()[0];
            };
        });
        // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
        arrayEach([
            "initial",
            "tail"
        ], function(methodName, index) {
            var dropName = "drop" + (index ? "" : "Right");
            LazyWrapper.prototype[methodName] = function() {
                return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
            };
        });
        LazyWrapper.prototype.compact = function() {
            return this.filter(identity);
        };
        LazyWrapper.prototype.find = function(predicate) {
            return this.filter(predicate).head();
        };
        LazyWrapper.prototype.findLast = function(predicate) {
            return this.reverse().find(predicate);
        };
        LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
            if (typeof path == "function") return new LazyWrapper(this);
            return this.map(function(value) {
                return baseInvoke(value, path, args);
            });
        });
        LazyWrapper.prototype.reject = function(predicate) {
            return this.filter(negate(getIteratee(predicate)));
        };
        LazyWrapper.prototype.slice = function(start, end) {
            start = toInteger(start);
            var result = this;
            if (result.__filtered__ && (start > 0 || end < 0)) return new LazyWrapper(result);
            if (start < 0) result = result.takeRight(-start);
            else if (start) result = result.drop(start);
            if (end !== undefined) {
                end = toInteger(end);
                result = end < 0 ? result.dropRight(-end) : result.take(end - start);
            }
            return result;
        };
        LazyWrapper.prototype.takeRightWhile = function(predicate) {
            return this.reverse().takeWhile(predicate).reverse();
        };
        LazyWrapper.prototype.toArray = function() {
            return this.take(MAX_ARRAY_LENGTH);
        };
        // Add `LazyWrapper` methods to `lodash.prototype`.
        baseForOwn(LazyWrapper.prototype, function(func, methodName) {
            var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName), isTaker = /^(?:head|last)$/.test(methodName), lodashFunc = lodash[isTaker ? "take" + (methodName == "last" ? "Right" : "") : methodName], retUnwrapped = isTaker || /^find/.test(methodName);
            if (!lodashFunc) return;
            lodash.prototype[methodName] = function() {
                var value = this.__wrapped__, args = isTaker ? [
                    1
                ] : arguments, isLazy = value instanceof LazyWrapper, iteratee = args[0], useLazy = isLazy || isArray(value);
                var interceptor = function(value) {
                    var result = lodashFunc.apply(lodash, arrayPush([
                        value
                    ], args));
                    return isTaker && chainAll ? result[0] : result;
                };
                if (useLazy && checkIteratee && typeof iteratee == "function" && iteratee.length != 1) // Avoid lazy use if the iteratee has a "length" value other than `1`.
                isLazy = useLazy = false;
                var chainAll = this.__chain__, isHybrid = !!this.__actions__.length, isUnwrapped = retUnwrapped && !chainAll, onlyLazy = isLazy && !isHybrid;
                if (!retUnwrapped && useLazy) {
                    value = onlyLazy ? value : new LazyWrapper(this);
                    var result = func.apply(value, args);
                    result.__actions__.push({
                        "func": thru,
                        "args": [
                            interceptor
                        ],
                        "thisArg": undefined
                    });
                    return new LodashWrapper(result, chainAll);
                }
                if (isUnwrapped && onlyLazy) return func.apply(this, args);
                result = this.thru(interceptor);
                return isUnwrapped ? isTaker ? result.value()[0] : result.value() : result;
            };
        });
        // Add `Array` methods to `lodash.prototype`.
        arrayEach([
            "pop",
            "push",
            "shift",
            "sort",
            "splice",
            "unshift"
        ], function(methodName) {
            var func = arrayProto[methodName], chainName = /^(?:push|sort|unshift)$/.test(methodName) ? "tap" : "thru", retUnwrapped = /^(?:pop|shift)$/.test(methodName);
            lodash.prototype[methodName] = function() {
                var args = arguments;
                if (retUnwrapped && !this.__chain__) {
                    var value = this.value();
                    return func.apply(isArray(value) ? value : [], args);
                }
                return this[chainName](function(value) {
                    return func.apply(isArray(value) ? value : [], args);
                });
            };
        });
        // Map minified method names to their real names.
        baseForOwn(LazyWrapper.prototype, function(func, methodName) {
            var lodashFunc = lodash[methodName];
            if (lodashFunc) {
                var key = lodashFunc.name + "";
                if (!hasOwnProperty.call(realNames, key)) realNames[key] = [];
                realNames[key].push({
                    "name": methodName,
                    "func": lodashFunc
                });
            }
        });
        realNames[createHybrid(undefined, WRAP_BIND_KEY_FLAG).name] = [
            {
                "name": "wrapper",
                "func": undefined
            }
        ];
        // Add methods to `LazyWrapper`.
        LazyWrapper.prototype.clone = lazyClone;
        LazyWrapper.prototype.reverse = lazyReverse;
        LazyWrapper.prototype.value = lazyValue;
        // Add chain sequence methods to the `lodash` wrapper.
        lodash.prototype.at = wrapperAt;
        lodash.prototype.chain = wrapperChain;
        lodash.prototype.commit = wrapperCommit;
        lodash.prototype.next = wrapperNext;
        lodash.prototype.plant = wrapperPlant;
        lodash.prototype.reverse = wrapperReverse;
        lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;
        // Add lazy aliases.
        lodash.prototype.first = lodash.prototype.head;
        if (symIterator) lodash.prototype[symIterator] = wrapperToIterator;
        return lodash;
    };
    /*--------------------------------------------------------------------------*/ // Export lodash.
    var _ = runInContext();
    // Some AMD build optimizers, like r.js, check for condition patterns like:
    if (typeof define == "function" && typeof define.amd == "object" && define.amd) {
        // Expose Lodash on the global object to prevent errors when Lodash is
        // loaded by a script tag in the presence of an AMD loader.
        // See http://requirejs.org/docs/errors.html#mismatch for more details.
        // Use `_.noConflict` to remove Lodash from the global object.
        root._ = _;
        // Define as an anonymous module so, through path mapping, it can be
        // referenced as the "underscore" module.
        define(function() {
            return _;
        });
    } else if (freeModule) {
        // Export for Node.js.
        (freeModule.exports = _)._ = _;
        // Export for CommonJS support.
        freeExports._ = _;
    } else // Export to the global object.
    root._ = _;
}).call(this);

},{}],"5FUTj":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _reactRouter = require("react-router");
var _loader = require("../../components/general/Loader");
var _loaderDefault = parcelHelpers.interopDefault(_loader);
var _languageContainer = require("../../hooks/LanguageContainer");
var _languageContainerDefault = parcelHelpers.interopDefault(_languageContainer);
// responsbile for initial load and route set up
const Splash = (props)=>{
    const [isLoading, setIsLoading] = (0, _react1.useState)(true);
    const languagesContainer = (0, _languageContainerDefault.default).useContainer();
    (0, _react1.useEffect)(()=>{
        const asyncLoad = async ()=>{
            await props.authContainer.refreshToken();
            const promises = [];
            promises.push(languagesContainer.loadLanguages());
            promises.push(props.featureContainer.getSystemFeatures());
            promises.push(props.orgContainer.getOrganizations());
            await Promise.all(promises);
            setIsLoading(false);
        };
        asyncLoad();
        // Add cleanup to avoid Warning: Can't perform a React state update on an unmounted component.
        return ()=>{
            setIsLoading(false);
        };
    }, []);
    if (isLoading) return (0, _react.jsx)("div", null, (0, _react.jsx)((0, _loaderDefault.default), null));
    if (props.orgContainer.state.currentOrganization == null) {
        if (location.href != "/orgs") return (0, _react.jsx)((0, _reactRouter.Redirect), {
            to: "/orgs"
        });
    }
    return (0, _react.jsx)("div", null, (0, _react.jsx)((0, _loaderDefault.default), null));
};
exports.default = Splash;

},{"@emotion/react":"djZKr","react":"6uln9","react-router":"i3TiW","../../components/general/Loader":"bnV5T","../../hooks/LanguageContainer":"lchkU","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"bnV5T":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const logo = require("4048613aa840b62c");
const logoGreen = require("7dab78fb419f268a");
const Loader = (props)=>{
    if (props.static) return (0, _react.jsx)("img", {
        className: `${staticLoader} ${props.className ? props.className : ""}`,
        src: logo,
        alt: "loader"
    });
    if (props.greenStatic) return (0, _react.jsx)("img", {
        className: `${staticLoader} ${props.className ? props.className : ""}`,
        src: logoGreen,
        alt: "loader"
    });
    return (0, _react.jsx)("svg", {
        className: `${loaderStyle} ${props.className ? props.className : ""}`,
        width: "48",
        height: "48",
        viewBox: "0 0 48 48",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, (0, _react.jsx)("path", {
        className: "",
        d: "M19.255 43.1862C11.3467 43.1862 4.8825 36.722 4.8825 28.8138C4.8825 22.5559 8.9398 17.192 14.51 15.2665V10.2465C6.18909 12.3783 0 19.8739 0 28.8138C0 39.404 8.59596 48 19.1862 48C28.126 48 35.6905 41.8109 37.7535 33.49H32.7334C30.8079 39.1289 25.5128 43.1862 19.255 43.1862Z",
        fill: "url(#paint0_linear)"
    }), (0, _react.jsx)("path", {
        className: "path outer",
        d: "M19.2545 0V4.81374C32.4579 4.81374 43.1857 15.5415 43.1857 28.7449H47.9995C47.9995 12.9283 35.1399 0 19.2545 0Z",
        fill: "url(#paint1_linear)"
    }), (0, _react.jsx)("path", {
        className: "path middle",
        d: "M19.2545 9.55872V14.3725C27.1628 14.3725 33.627 20.8366 33.627 28.7449H38.4407C38.4407 18.2234 29.8448 9.55872 19.2545 9.55872Z",
        fill: "url(#paint2_linear)"
    }), (0, _react.jsx)("path", {
        className: "path inner",
        d: "M23.9307 28.814H28.7444C28.7444 23.5189 24.4808 19.2552 19.1857 19.2552V24.069C21.8676 24.069 23.9307 26.2008 23.9307 28.814Z",
        fill: "url(#paint3_linear)"
    }), (0, _react.jsx)("defs", null, (0, _react.jsx)("linearGradient", {
        id: "paint0_linear",
        x1: "38.9564",
        y1: "9.077",
        x2: "9.23599",
        y2: "38.7974",
        gradientUnits: "userSpaceOnUse"
    }, (0, _react.jsx)("stop", {
        stopColor: "#12C3F4"
    }), (0, _react.jsx)("stop", {
        offset: "1",
        stopColor: "#4EBE99"
    })), (0, _react.jsx)("linearGradient", {
        id: "paint1_linear",
        x1: "38.9558",
        y1: "9.07672",
        x2: "9.23535",
        y2: "38.7972",
        gradientUnits: "userSpaceOnUse"
    }, (0, _react.jsx)("stop", {
        stopColor: "#12C3F4"
    }), (0, _react.jsx)("stop", {
        offset: "1",
        stopColor: "#4EBE99"
    })), (0, _react.jsx)("linearGradient", {
        id: "paint2_linear",
        x1: "38.9558",
        y1: "9.07672",
        x2: "9.23536",
        y2: "38.7972",
        gradientUnits: "userSpaceOnUse"
    }, (0, _react.jsx)("stop", {
        stopColor: "#12C3F4"
    }), (0, _react.jsx)("stop", {
        offset: "1",
        stopColor: "#4EBE99"
    })), (0, _react.jsx)("linearGradient", {
        id: "paint3_linear",
        x1: "38.956",
        y1: "9.07721",
        x2: "9.23556",
        y2: "38.7977",
        gradientUnits: "userSpaceOnUse"
    }, (0, _react.jsx)("stop", {
        stopColor: "#12C3F4"
    }), (0, _react.jsx)("stop", {
        offset: "1",
        stopColor: "#4EBE99"
    }))));
};
const loaderStyle = /*#__PURE__*/ (0, _css.css)({
    name: "1v3zvrz",
    styles: "height:80px;width:80px;position:absolute;top:50%;left:50%;margin:-40px 0 0 -40px;.path{animation:blink .65s ease alternate infinite;}.path.inner{animation-delay:0.1s;}.path.middle{animation-delay:0.2s;}.path.outer{animation-delay:0.3s;}@keyframes blink{0%{opacity:0;}40%{opacity:1;}}"
});
const staticLoader = /*#__PURE__*/ (0, _css.css)({
    name: "dsnagb",
    styles: "height:80px;width:80px;position:absolute;top:50%;left:50%;margin:-40px 0 0 -40px"
});
exports.default = Loader;

},{"@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","4048613aa840b62c":"eqj0W","7dab78fb419f268a":"ifpGm","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"eqj0W":[function(require,module,exports) {
module.exports = require("5da74b9b93df0df7").getBundleURL("kVLro") + require("2bddc5021d8674d4").resolve("2I3Wx");

},{"5da74b9b93df0df7":"c7Tr5","2bddc5021d8674d4":"fyJL2"}],"ifpGm":[function(require,module,exports) {
module.exports = require("badd6f5f3299b0a8").getBundleURL("kVLro") + require("fe2f89206ca8a9de").resolve("5Slpg");

},{"badd6f5f3299b0a8":"c7Tr5","fe2f89206ca8a9de":"fyJL2"}],"lchkU":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _unstatedNext = require("unstated-next");
var _api = require("../api");
function useLanguageContainer() {
    const [languages, setLanguages] = (0, _react.useState)([]);
    const [isLoading, setIsLoading] = (0, _react.useState)(false);
    const [errors, setErrors] = (0, _react.useState)([]);
    const [currentSelectedLanguages, setCurrentSelectedLanguages] = (0, _react.useState)([]);
    const updateSelectedLanguages = (languages)=>{
        setCurrentSelectedLanguages(languages);
    };
    const loadLanguages = async ()=>{
        try {
            setIsLoading(true);
            const result = await _api.getAllLanguages();
            if (result.resultType == "Ok") {
                await setLanguages(result.data);
                setIsLoading(false);
            } else if (result.errors != null && result.errors.length > 0) {
                setErrors([
                    ...result.errors
                ]);
                setIsLoading(false);
            }
            return result;
        } catch (error) {
            setErrors([
                error
            ]);
            setIsLoading(false);
        }
    };
    return {
        languages,
        currentSelectedLanguages,
        updateSelectedLanguages,
        loadLanguages
    };
}
const LanguageContainer = (0, _unstatedNext.createContainer)(useLanguageContainer);
exports.default = LanguageContainer;

},{"react":"6uln9","unstated-next":"61zE5","../api":"loxM6","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"5bpnB":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _unstated = require("unstated");
var _exitMessageContentForm = require("./components/ExitMessageContentForm");
var _exitMessageContentFormDefault = parcelHelpers.interopDefault(_exitMessageContentForm);
var _exitMessageContainer = require("../../state/containers/ExitMessageContainer");
var _exitMessageContainerDefault = parcelHelpers.interopDefault(_exitMessageContainer);
var _applicationContainer = require("../../state/containers/ApplicationContainer");
var _applicationContainerDefault = parcelHelpers.interopDefault(_applicationContainer);
var _titleStateContainer = require("../../state/containers/TitleStateContainer");
var _titleStateContainerDefault = parcelHelpers.interopDefault(_titleStateContainer);
var _mediaResponseContainer = require("../../state/containers/MediaResponseContainer");
var _mediaResponseContainerDefault = parcelHelpers.interopDefault(_mediaResponseContainer);
var _genericCreateContentItemPage = require("../formScenes/GenericCreateContentItemPage");
var _genericCreateContentItemPageDefault = parcelHelpers.interopDefault(_genericCreateContentItemPage);
var _featureContainer = require("../../state/containers/FeatureContainer");
var _featureContainerDefault = parcelHelpers.interopDefault(_featureContainer);
var _featureTypeIds = require("../../constants/featureTypeIds");
var _repromptContainer = require("../../state/containers/RepromptContainer");
var _repromptContainerDefault = parcelHelpers.interopDefault(_repromptContainer);
var _followUpContainer = require("../../state/containers/FollowUpContainer");
var _followUpContainerDefault = parcelHelpers.interopDefault(_followUpContainer);
class CreateExitMessage extends (0, _reactDefault.default).Component {
    render() {
        return (0, _react.jsx)((0, _unstated.Subscribe), {
            to: [
                (0, _exitMessageContainerDefault.default),
                (0, _applicationContainerDefault.default),
                (0, _repromptContainerDefault.default),
                (0, _followUpContainerDefault.default),
                (0, _titleStateContainerDefault.default),
                (0, _mediaResponseContainerDefault.default),
                (0, _featureContainerDefault.default)
            ]
        }, (exitContainer, appContainer, repromptContainer, followUpContainer, titleContainer, responseContainer, featureContainer)=>{
            return (0, _react.jsx)((0, _genericCreateContentItemPageDefault.default), {
                stateContainer: exitContainer,
                titleContainer: titleContainer,
                applicationContainer: appContainer,
                defaultTitle: "New Exit Message",
                history: this.props.history,
                location: this.props.location,
                match: this.props.match,
                staticContext: this.props.staticContext,
                featureContainer: featureContainer,
                featureTypeId: (0, _featureTypeIds.ExitMessagesFeatureTypeId),
                formRender: (application, assistantApplication, onPublish, onSubmit, onAccessTypeChange)=>(0, _react.jsx)((0, _exitMessageContentFormDefault.default), {
                        appContainer: appContainer,
                        followUpContainer: followUpContainer,
                        repromptContainer: repromptContainer,
                        location: this.props.location,
                        applicationFeatureId: this.props.match.params.applicationFeatureId,
                        application: application,
                        stateContainer: exitContainer,
                        assistantApplication: assistantApplication,
                        responseStateContainer: responseContainer,
                        featureContainer: featureContainer,
                        history: this.props.history,
                        isSaving: exitContainer.state.isSaving,
                        onSubmit: onSubmit,
                        onShowPublishModal: onPublish,
                        onAccessTypeChange: onAccessTypeChange,
                        onToggleNavigation: ()=>{},
                        isTemplateOwned: false,
                        onToggleSync: null
                    })
            });
        });
    }
}
exports.default = CreateExitMessage;

},{"@emotion/react":"djZKr","react":"6uln9","unstated":"grh7p","./components/ExitMessageContentForm":"93Go8","../../state/containers/ExitMessageContainer":"lSKl8","../../state/containers/ApplicationContainer":"cuqi2","../../state/containers/TitleStateContainer":"2osOD","../../state/containers/MediaResponseContainer":"1ccrV","../formScenes/GenericCreateContentItemPage":"dUUA3","../../state/containers/FeatureContainer":"4ApGg","../../constants/featureTypeIds":"hPLMP","../../state/containers/RepromptContainer":"5vKMV","../../state/containers/FollowUpContainer":"rm9OA","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"93Go8":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _formik = require("formik");
var _yup = require("yup");
var _exitMessageForm = require("../../formScenes/ExitMessageForm");
var _exitMessageFormDefault = parcelHelpers.interopDefault(_exitMessageForm);
const ExitMessageContentForm = (0, _formik.withFormik)({
    mapPropsToValues: (props)=>({
            responses: [
                {
                    content: ""
                }
            ],
            title: "Untitled Exit Message",
            isLive: true,
            entryType: "open",
            requiresParent: false,
            sensitiveConversationChange: "None",
            languages: props.application?.languages.find((l)=>l.id == props.application?.defaultLanguageId) ? [
                props.application?.languages.find((l)=>l.id == props.application?.defaultLanguageId)
            ] : [],
            webhookChainingType: "NoChaining"
        }),
    validationSchema: _yup.object().shape({
        title: _yup.string().required("You must enter a title"),
        responses: _yup.array().of(_yup.object().shape({
            content: _yup.string().required("You must enter a response variation")
        })).required("You must enter at least 1 response variation").min(1, "You must enter at least 1 response variation")
    }),
    validateOnMount: true,
    handleSubmit: (values, { props, setStatus, setFieldValue })=>{
        setStatus({
            submitting: true
        });
        return props.onSubmit(props.stateContainer.mapFormDataToModel({
            applicationFeatureId: props.applicationFeatureId,
            applicationId: props.application?.id,
            responses: []
        }, values));
    }
})((0, _exitMessageFormDefault.default));
exports.default = ExitMessageContentForm;

},{"formik":"3YnOK","yup":"j2SJU","../../formScenes/ExitMessageForm":"g6YNd","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"g6YNd":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _defineProperty = require("@babel/runtime/helpers/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _pageContainer = require("../../components/structure/PageContainer");
var _pageContainerDefault = parcelHelpers.interopDefault(_pageContainer);
var _titleTextField = require("../../components/forms/TitleTextField");
var _titleTextFieldDefault = parcelHelpers.interopDefault(_titleTextField);
var _loader = require("../../components/general/Loader");
var _loaderDefault = parcelHelpers.interopDefault(_loader);
var _featureTypeIds = require("../../constants/featureTypeIds");
var _contentLanguageMultiSelector = require("../../components/forms/ContentLanguageMultiSelector");
var _contentLanguageMultiSelectorDefault = parcelHelpers.interopDefault(_contentLanguageMultiSelector);
var _contentPage = require("../contentPage");
var _contentPageDefault = parcelHelpers.interopDefault(_contentPage);
var _relatedContentMenu = require("../relatedContentMenu");
var _relatedContentMenuDefault = parcelHelpers.interopDefault(_relatedContentMenu);
var _scrollablePanelBody = require("../../components/structure/ScrollablePanelBody");
var _scrollablePanelBodyDefault = parcelHelpers.interopDefault(_scrollablePanelBody);
var _panelTitle = require("../contentPage/components/PanelTitle");
var _panelTitleDefault = parcelHelpers.interopDefault(_panelTitle);
var _contentCollapsingSection = require("../../components/structure/ContentCollapsingSection");
var _contentCollapsingSectionDefault = parcelHelpers.interopDefault(_contentCollapsingSection);
var _contentSectionTitle = require("../contentPage/components/ContentSectionTitle");
var _contentSectionTitleDefault = parcelHelpers.interopDefault(_contentSectionTitle);
var _extensions = require("../../models/extensions");
var _pageError = require("../../components/general/PageError");
var _pageErrorDefault = parcelHelpers.interopDefault(_pageError);
var _conversationItemActionButtonToolbar = require("./components/ConversationItemActionButtonToolbar");
var _conversationItemActionButtonToolbarDefault = parcelHelpers.interopDefault(_conversationItemActionButtonToolbar);
var _templateLockedBanner = require("../../components/general/TemplateLockedBanner");
var _templateLockedBannerDefault = parcelHelpers.interopDefault(_templateLockedBanner);
var _conversationItemFieldSet = require("../../components/forms/ConversationItemFieldSet");
var _conversationItemFieldSetDefault = parcelHelpers.interopDefault(_conversationItemFieldSet);
var _contentInfoOptions = require("../../components/structure/ContentInfoOptions");
var _contentInfoOptionsDefault = parcelHelpers.interopDefault(_contentInfoOptions);
var _responsesManager = require("../responsesManager");
var _responsesManagerDefault = parcelHelpers.interopDefault(_responsesManager);
var _dirtyFormPrompt = require("./components/DirtyFormPrompt");
var _followUpForm = require("../followUpForm");
var _followUpFormDefault = parcelHelpers.interopDefault(_followUpForm);
var _sensitiveDataOptions = require("../contentPage/components/SensitiveDataOptions");
var _sensitiveDataOptionsDefault = parcelHelpers.interopDefault(_sensitiveDataOptions);
var _disableForFeatureFlagOptions = require("../contentPage/components/DisableForFeatureFlagOptions");
var _disableForFeatureFlagOptionsDefault = parcelHelpers.interopDefault(_disableForFeatureFlagOptions);
var _contentItemTestCaseViewer = require("./ContentItemTestCaseViewer");
var _contentItemTestCaseViewerDefault = parcelHelpers.interopDefault(_contentItemTestCaseViewer);
const contentInfoIcon = require("10b33dcfca75fd74");
class ExitMessageForm extends (0, _followUpFormDefault.default) {
    componentDidUpdate(prevProps, prevState) {
        super.componentDidUpdate(prevProps, prevState);
    }
    constructor(props){
        super(props);
        (0, _definePropertyDefault.default)(this, "handleResponseIdFromSim", (id)=>{
            this.setState({
                simulatedResponseId: id
            });
        });
        this.state = {
            isRelinkOpen: false
        };
    }
    handleAsyncSubmit(onSuccess) {
        if (this.manualValidate()) return this.props?.onSubmit(this.props.stateContainer.mapFormDataToModel(this.props.exitMessage, this.props.values), onSuccess);
    }
    handleDiscardChanges() {
        this.handleFinish();
    }
    handleDelete() {
        const confirmed = confirm("Are you sure you want to delete this?");
        if (confirmed) this.props.stateContainer.delete(this.props.exitMessage?.id).then(()=>{
            this.handleFinish();
        });
    }
    handleCopy() {
        this.handleAsyncSubmit(()=>{
            this.props.stateContainer.copy(this.props.exitMessage?.id).then((r2)=>{
                if (r2.resultType == "Ok") this.props.history.push(`/v/${r2.data.applicationFeatureId}/exitmessages/${r2.data.id}`);
            });
        });
    }
    getMenuTreeRoots() {
        var roots = [
            this.getContentInfoTreeItem(),
            ...this.getResponsesTreeItems(this.props.values.responses)
        ];
        return roots;
    }
    getContentItem() {
        return this.props.exitMessage;
    }
    handleContentItemOptionSelected(option, event) {
        event.stopPropagation();
        if (option == "Manage Webhooks") this.showWebhookInstanceManager();
        else if (option == "Duplicate") this.handleCopy();
        else if (option == "Delete") this.handleDelete();
    }
    handleResponsesChange(responseGroups) {
        this.props.setFieldValue("responses", this.getResponsesFromGroups(responseGroups));
    }
    render() {
        const props = {
            ...this.props
        };
        const isLoading = props.stateContainer.state.isSaving;
        const isDisabled = isLoading || this.props.isTemplateOwned;
        const responseGroups = this.getResponseGroups(this.props.values.responses);
        const { simulatedResponseId } = this.state;
        if (this.props.responseStateContainer.state.isLoading || !this.props.application) return (0, _react.jsx)((0, _loaderDefault.default), null);
        return (0, _react.jsx)((0, _reactDefault.default).Fragment, null, (0, _react.jsx)("form", {
            onSubmit: props.handleSubmit
        }, (0, _react.jsx)((0, _dirtyFormPrompt.DirtyFormPrompt), {
            allowPrompt: props.status?.submitting != true
        }), (0, _react.jsx)((0, _contentPageDefault.default), {
            relatedContentRender: ()=>(0, _react.jsx)((0, _relatedContentMenuDefault.default), {
                    parentContentId: this.props.previousContentId,
                    conversationItem: {
                        ...this.props.exitMessage,
                        featureTypeId: (0, _featureTypeIds.ExitMessagesFeatureTypeId)
                    },
                    history: this.props.history,
                    featureTypeId: (0, _featureTypeIds.ExitMessagesFeatureTypeId),
                    followUp: null,
                    contentId: this.props.exitMessage?.id,
                    onClose: this.props.onToggleNavigation,
                    onSave: this.handleAsyncSubmit.bind(this)
                }),
            treeRender: this.renderTree.bind(this),
            formPanelRender: ()=>(0, _react.jsx)((0, _pageContainerDefault.default), {
                    fill: true
                }, (0, _react.jsx)((0, _conversationItemActionButtonToolbarDefault.default), {
                    errors: Object.values(props.errors),
                    validateForm: props.validateForm,
                    publishDisabled: this.props.assistantApplication == null,
                    saveDisabled: Object.keys(props.errors).length > 0,
                    contentItem: props.exitMessage,
                    isLoading: isLoading,
                    handleDiscardChanges: this.handleDiscardChanges.bind(this),
                    handlePublishing: this.handleSaveAndPublish.bind(this),
                    submitForm: props.submitForm
                }), props.exitMessage?.createdFromId && (0, _react.jsx)((0, _templateLockedBannerDefault.default), {
                    isLoading: props.stateContainer.state.isTogglingSync,
                    isLinked: props.isTemplateOwned,
                    onRelink: this.handleToggleRelinkModal.bind(this),
                    onUnlink: ()=>this.props.onToggleSync(this.props.exitMessage.id, true)
                }), (0, _react.jsx)((0, _conversationItemFieldSetDefault.default), {
                    disabled: isDisabled,
                    withBanner: props.exitMessage?.createdFromId != null
                }, (0, _react.jsx)((0, _scrollablePanelBodyDefault.default), {
                    className: "scrollable-body"
                }, (0, _react.jsx)((0, _panelTitleDefault.default), {
                    title: "Content Editing",
                    detail: "Here’s where you can fill in the info about this content and determine the course of the conversation by filling in the relevant details."
                }), (0, _react.jsx)((0, _contentCollapsingSectionDefault.default), {
                    title: "Content Info",
                    id: "contentInfo",
                    icon: contentInfoIcon,
                    titleRightRowComponent: (0, _react.jsx)((0, _contentInfoOptionsDefault.default), {
                        webhookCount: this.props.stateContainer.state.webhookUpdates?.webhookInstances?.length ?? this.props.stateContainer.state.attachedWebhooks?.length ?? 0,
                        options: this.getOptions(this.props.exitMessage != null),
                        optionSelected: this.handleContentItemOptionSelected.bind(this),
                        manageWebhooks: this.showWebhookInstanceManager.bind(this),
                        showSensitiveConversation: this.state.showSensitiveConversation,
                        toggleSensitiveConversation: ()=>{
                            this.toggleSensitiveConversation();
                        },
                        showDisabledForFeatures: this.state.showDisabledForFeatureFlags,
                        toggleDisabledForFeatures: ()=>{
                            this.toggleDisableForFeatureFlags();
                        },
                        flagsSelected: props.values.disabledForFeatureFlagIds?.length
                    })
                }, this.state.showSensitiveConversation && (0, _react.jsx)((0, _sensitiveDataOptionsDefault.default), {
                    selectedOption: props.values.sensitiveConversationChange ?? "None",
                    onChange: (value)=>{
                        props.setFieldValue("sensitiveConversationChange", value);
                    }
                }), this.state.showDisabledForFeatureFlags && (0, _react.jsx)((0, _disableForFeatureFlagOptionsDefault.default), {
                    appContainer: this.props.appContainer,
                    onChange: (value)=>{
                        props.setFieldValue("disabledForFeatureFlagIds", value);
                    },
                    selectedFeatureFlags: props.values.disabledForFeatureFlagIds
                }), (0, _react.jsx)((0, _contentSectionTitleDefault.default), {
                    title: "Exit Message Conversation",
                    icon: (0, _extensions.getFeatureTypeIcon)((0, _featureTypeIds.ExitMessagesFeatureTypeId), true)
                }), (0, _react.jsx)((0, _titleTextFieldDefault.default), {
                    id: "contentTitle",
                    disabled: isDisabled,
                    name: "title",
                    placeholder: "For display only",
                    value: props.values.title,
                    label: "Title",
                    onChange: props.handleChange,
                    onBlur: props.handleBlur
                }), (0, _react.jsx)((0, _contentLanguageMultiSelectorDefault.default), {
                    id: "contentLanguage",
                    disabled: isDisabled,
                    label: "Language / Region",
                    languages: props.application?.languages,
                    selectedLanguageIds: props.values.languages.map((l)=>l.id),
                    onChange: this.handleLanguagesChange.bind(this)
                }), this.renderOptions(false, isDisabled)), (0, _react.jsx)((0, _responsesManagerDefault.default), {
                    applicationId: this.props.application?.id,
                    applicationFeatureId: this.props.applicationFeatureId,
                    languages: this.props.values.languages,
                    responseGroups: responseGroups,
                    getConditionsKey: (c)=>this.getConditionsKey(c),
                    isDisabled: isDisabled,
                    onChange: this.handleResponsesChange.bind(this),
                    onBlur: this.props.handleBlur,
                    simulatedResponseId: simulatedResponseId,
                    showError: this.showError.bind(this),
                    hideFollowUp: true,
                    responseIdToNamesRef: this.responseIdToNamesRef,
                    contentItemTitle: this.props.values.title
                }))), (0, _react.jsx)((0, _pageErrorDefault.default), {
                    errors: this.props?.stateContainer?.state?.errors ?? [],
                    onClear: this.handleClearError.bind(this)
                })),
            testCasesRender: ()=>(0, _react.jsx)((0, _contentItemTestCaseViewerDefault.default), {
                    application: this.props.application,
                    contentItemId: this.props.exitMessage?.id,
                    getResponseId: this.handleResponseIdFromSim,
                    responseIdToNamesRef: this.responseIdToNamesRef
                })
        })), this.renderRelinkSyncWarning(), this.renderWebhookInstanceManager(this.props.application?.id, this.props.exitMessage?.id, (0, _featureTypeIds.ExitMessagesFeatureTypeId), this.props.values.webhookChainingType));
    }
}
exports.default = ExitMessageForm;

},{"@babel/runtime/helpers/defineProperty":"9sJxO","@emotion/react":"djZKr","react":"6uln9","../../components/structure/PageContainer":"hc1r8","../../components/forms/TitleTextField":"6fj1a","../../components/general/Loader":"bnV5T","../../constants/featureTypeIds":"hPLMP","../../components/forms/ContentLanguageMultiSelector":"4SbwP","../contentPage":"6VyMV","../relatedContentMenu":"aWiMy","../../components/structure/ScrollablePanelBody":"6LRg3","../contentPage/components/PanelTitle":"anVUR","../../components/structure/ContentCollapsingSection":"1CUms","../contentPage/components/ContentSectionTitle":"5RGHr","../../models/extensions":"7h01B","../../components/general/PageError":"ezFTm","./components/ConversationItemActionButtonToolbar":"TGPQ9","../../components/general/TemplateLockedBanner":"gMkKq","../../components/forms/ConversationItemFieldSet":"8a3oA","../../components/structure/ContentInfoOptions":"6Ozsc","../responsesManager":"jtCYo","./components/DirtyFormPrompt":"i9WDI","../followUpForm":"5HXc2","../contentPage/components/SensitiveDataOptions":"oXWpd","../contentPage/components/DisableForFeatureFlagOptions":"67JXM","./ContentItemTestCaseViewer":"6EkXj","10b33dcfca75fd74":"fKr4T","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hc1r8":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _colors = require("../../constants/colors");
var _breakpoints = require("../../constants/breakpoints");
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const getClassName = (props)=>{
    var style = containerStyle + " ";
    if (props.hidden) style = hiddenStyle;
    if (props.fill) style = fillStyle + " ";
    if (props.withFooter) style += bottomPadded;
    return style;
};
const PageContainer = (props)=>(0, _react.jsx)("div", {
        className: `${getClassName(props)}`
    }, props.children);
const containerStyle = /*#__PURE__*/ (0, _css.css)("padding:0 50px;flex-grow:1;h3{font-family:Muli;font-size:21px;font-weight:normal;font-style:normal;font-stretch:normal;line-height:normal;letter-spacing:normal;color:", (0, _colors.dark_grey_blue), ";margin-bottom:16px;margin-top:32px;}h4{font-family:Muli;font-size:18px;font-weight:normal;font-style:normal;font-stretch:normal;line-height:24px;letter-spacing:normal;color:", (0, _colors.dark_grey_blue), ";margin-bottom:16px;}p{font-family:Muli;font-size:14px;font-weight:normal;font-style:normal;font-stretch:normal;line-height:normal;letter-spacing:0.6px;color:", (0, _colors.dark_grey_blue), ";}", (0, _breakpoints.breakpoint_small), "{padding:0 32px;}", "");
const fillStyle = /*#__PURE__*/ (0, _css.css)({
    name: "3pye3b",
    styles: "padding:0;flex-grow:1"
});
const hiddenStyle = /*#__PURE__*/ (0, _css.css)({
    name: "eivff4",
    styles: "display:none"
});
const bottomPadded = /*#__PURE__*/ (0, _css.css)({
    name: "1sqqqs8",
    styles: "padding-bottom:90px"
});
exports.default = PageContainer;

},{"@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","../../constants/colors":"1p3OR","../../constants/breakpoints":"2F01A","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6fj1a":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _colors = require("../../constants/colors");
var _formik = require("formik");
var _fieldError = require("./FieldError");
var _fieldErrorDefault = parcelHelpers.interopDefault(_fieldError);
var _button = require("../general/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _iconTooltip = require("../general/IconTooltip");
var _iconTooltipDefault = parcelHelpers.interopDefault(_iconTooltip);
var _tooltipWrapper = require("../general/TooltipWrapper");
var _tooltipWrapperDefault = parcelHelpers.interopDefault(_tooltipWrapper);
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const deleteIcon = require("d7e76342d9fe8eaa");
// component used in building forms with consistent components for look and function
class TitleTextField extends (0, _reactDefault.default).Component {
    render() {
        const props = {
            ...this.props
        };
        return (0, _react.jsx)("div", {
            className: containerStyle
        }, (0, _react.jsx)("div", {
            className: labelContainer
        }, props.canDelete ? (0, _react.jsx)((0, _buttonDefault.default), {
            additionalClasses: deleteIconStyle,
            type: "button",
            onClick: props.onDelete,
            themes: [
                "icon"
            ],
            icon: deleteIcon
        }) : null, props.tooltip !== undefined ? (0, _react.jsx)((0, _iconTooltipDefault.default), {
            text: props.tooltip,
            className: tooltipStyle,
            place: "top"
        }) : null, props.required ? (0, _react.jsx)((0, _tooltipWrapperDefault.default), {
            text: "Required field"
        }, (0, _react.jsx)("span", {
            className: requiredLabelStyle
        }, "*")) : null), (0, _react.jsx)("label", {
            htmlFor: props.name,
            className: labelStyle
        }, props.label), (0, _react.jsx)("div", {
            className: fieldContainer
        }, (0, _react.jsx)((0, _formik.Field), {
            id: props.id,
            className: textFieldStyles,
            type: props.type,
            name: props.name,
            placeholder: props.placeholder,
            value: props.value,
            onChange: props.onChange,
            onBlur: props.onBlur,
            disabled: props.disabled
        })), (0, _react.jsx)((0, _fieldErrorDefault.default), {
            name: props.name
        }));
    }
}
const textFieldStyles = /*#__PURE__*/ (0, _css.css)("color:", (0, _colors.color_shades_darkest), ";text-align:left;background:transparent;border:none;height:60px;font-size:18px;line-height:24px;width:100%;padding:0 24px;font-family:Muli;::placeholder{font-weight:normal;font-style:italic;font-stretch:normal;letter-spacing:normal;color:", (0, _colors.cool_grey), ";}&:disabled{background:", (0, _colors.color_shades_light), ";}", "");
const containerStyle = /*#__PURE__*/ (0, _css.css)({
    name: "456bw7",
    styles: "margin:24px 0"
});
const labelStyle = /*#__PURE__*/ (0, _css.css)("font-style:normal;font-weight:400;font-size:18px;line-height:20px;color:", (0, _colors.color_text_default), ";margin:0 0 0 24px;", "");
const deleteIconStyle = /*#__PURE__*/ (0, _css.css)({
    name: "1if73ow",
    styles: "height:14px;margin:0;margin-top:24px;margin-bottom:0;img{height:14px;}"
});
const tooltipStyle = /*#__PURE__*/ (0, _css.css)({
    name: "3xaa4j",
    styles: "margin:0;margin-top:24px;margin-bottom:0"
});
const labelContainer = /*#__PURE__*/ (0, _css.css)({
    name: "s5xdrg",
    styles: "display:flex;align-items:center"
});
const fieldContainer = /*#__PURE__*/ (0, _css.css)("display:flex;align-items:center;height:64px;width:100%;border-radius:5px;border:solid 1px ", (0, _colors.silver_two), ";background:white;overflow:hidden;margin-top:8px;", "");
const requiredLabelStyle = /*#__PURE__*/ (0, _css.css)("margin-right:0;margin-left:auto;margin-top:14px;margin-bottom:-20px;font-family:Muli;font-size:24px;color:", (0, _colors.faded_red), ";", "");
exports.default = TitleTextField;

},{"@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","../../constants/colors":"1p3OR","formik":"3YnOK","./FieldError":"fDxhz","../general/Button":"6ymxN","../general/IconTooltip":"3FODC","../general/TooltipWrapper":"53pWd","d7e76342d9fe8eaa":"7eyKJ","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hPLMP":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "WelcomeMessagesFeatureTypeId", ()=>WelcomeMessagesFeatureTypeId);
parcelHelpers.export(exports, "ExitMessagesFeatureTypeId", ()=>ExitMessagesFeatureTypeId);
parcelHelpers.export(exports, "HelpMessagesFeatureTypeId", ()=>HelpMessagesFeatureTypeId);
parcelHelpers.export(exports, "QuestionAnswerFeatureTypeId", ()=>QuestionAnswerFeatureTypeId);
parcelHelpers.export(exports, "LatestMessagesFeatureTypeId", ()=>LatestMessagesFeatureTypeId);
parcelHelpers.export(exports, "FallbackFeatureTypeId", ()=>FallbackFeatureTypeId);
parcelHelpers.export(exports, "SimpleChoiceFeatureTypeId", ()=>SimpleChoiceFeatureTypeId);
parcelHelpers.export(exports, "NumberRangeFeatureTypeId", ()=>NumberRangeFeatureTypeId);
parcelHelpers.export(exports, "CustomRequestsFeatureTypeId", ()=>CustomRequestsFeatureTypeId);
parcelHelpers.export(exports, "SPARK_EXCLUDED_FEATURE_TYPE_IDS", ()=>SPARK_EXCLUDED_FEATURE_TYPE_IDS);
const WelcomeMessagesFeatureTypeId = "80170a3b-ea36-4901-9f40-b74c4749cde8";
const ExitMessagesFeatureTypeId = "f7f7914e-37ef-4a80-83b2-183ddac061cf";
const HelpMessagesFeatureTypeId = "3d997f5d-bf9c-4b9e-9d8c-431cb2102738";
const QuestionAnswerFeatureTypeId = "205ee1e2-bc1c-4308-b8b7-41b332d491a9";
const LatestMessagesFeatureTypeId = "cafc2ebd-ba7d-468d-b4d3-c951b938ceed";
const FallbackFeatureTypeId = "2048dbd5-3c48-4bca-a34b-66f48719cea7";
const SimpleChoiceFeatureTypeId = "69c02847-a647-4cd4-b0a8-22f385053354";
const NumberRangeFeatureTypeId = "53ca606b-577b-44a5-b860-df011677136b";
const CustomRequestsFeatureTypeId = "8154f972-d307-456b-bff5-d635d1fd7d47";
const SPARK_EXCLUDED_FEATURE_TYPE_IDS = [
    WelcomeMessagesFeatureTypeId,
    FallbackFeatureTypeId
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4SbwP":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _lodash = require("lodash");
var _lodashDefault = parcelHelpers.interopDefault(_lodash);
var _groupedMultiSelector = require("./GroupedMultiSelector");
var _groupedMultiSelectorDefault = parcelHelpers.interopDefault(_groupedMultiSelector);
var _languages = require("../../models/extensions/languages");
var _languageCollectionAvatar = require("../general/LanguageCollectionAvatar");
var _languageCollectionAvatarDefault = parcelHelpers.interopDefault(_languageCollectionAvatar);
var _colors = require("../../constants/colors");
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
class ContentLanguageMultiSelector extends (0, _reactDefault.default).Component {
    handleChange(selectedLanguages) {
        this.props.onChange(selectedLanguages);
    }
    getLanguageGroups() {
        var dict = (0, _lodashDefault.default).groupBy(this.props.languages, (l)=>l.languageGroupCode);
        var groups = Object.keys(dict).map((key)=>({
                key: key,
                label: `${key.toUpperCase()} - ${(0, _languages.getLanguageName)(key)}`,
                subItems: dict[key].map((lang)=>({
                        data: lang,
                        value: lang.id,
                        icon: (0, _languages.getFlagIconForLanguage)(lang),
                        label: (0, _languages.getRegionyNameForLanguage)(lang),
                        groupKey: key,
                        isSelected: this.props.selectedLanguageIds == null ? false : this.props.selectedLanguageIds.some((id)=>id == lang.id)
                    }))
            }));
        groups = (0, _lodashDefault.default).sortBy(groups, (group)=>group.key);
        return groups;
    }
    renderCollapsedSelection(selectedLangs) {
        return (0, _react.jsx)((0, _reactDefault.default).Fragment, null, selectedLangs && selectedLangs.length > 0 ? (0, _react.jsx)("div", {
            className: "avatar-container"
        }, (0, _react.jsx)((0, _languageCollectionAvatarDefault.default), {
            languages: selectedLangs,
            limit: 3
        }), (0, _react.jsx)("p", {
            className: "selected-text"
        }, selectedLangs[0].languageGroupCode.toUpperCase(), " ")) : (0, _react.jsx)("p", {
            className: "empty-text"
        }, "Select a language"));
    }
    renderFullSelection(selectedLangs) {
        return (0, _react.jsx)("div", {
            className: "full-language-selector"
        }, (0, _react.jsx)((0, _languageCollectionAvatarDefault.default), {
            languages: selectedLangs,
            limit: 3
        }), (0, _react.jsx)("p", {
            className: labelStyle
        }, selectedLangs.length > 0 ? selectedLangs.map((l)=>`${(0, _languages.getLanguageNameForLanguage)(l)} (${(0, _languages.getRegionyNameForLanguage)(l)})`).join(", ") : "Select a language"));
    }
    render() {
        const selectedLangs = this.props.languages.filter((l)=>this.props.selectedLanguageIds == null ? false : this.props.selectedLanguageIds.some((id)=>id == l.id));
        return (0, _react.jsx)("div", {
            id: this.props.id,
            className: `language-grouped-selector ${containerStyle} ${this.props.isCollapsed ? "minified" : "full"} ${this.props.disabled ? "disabled" : ""}`
        }, (0, _react.jsx)((0, _groupedMultiSelectorDefault.default), {
            groupToggle: groupToggleStyle,
            label: this.props.label,
            groups: this.getLanguageGroups(),
            onChange: (ids)=>this.handleChange(this.props.languages.filter((l)=>ids.some((id)=>id == l.id))),
            selectedValues: this.props.selectedLanguageIds,
            withGroupSelection: false,
            restrictGroups: false,
            position: this.props.position ?? "bottom",
            emptyText: "You must select at least one language for your app first.",
            disabled: this.props.disabled,
            innerSelectionRender: ()=>this.props.isCollapsed ? this.renderCollapsedSelection(selectedLangs) : this.renderFullSelection(selectedLangs)
        }));
    }
}
const groupToggleStyle = /*#__PURE__*/ (0, _css.css)({
    name: "14vfbk2",
    styles: "margin-left:auto;margin-right:0;height:8px;width:8px"
});
const labelStyle = /*#__PURE__*/ (0, _css.css)({
    name: "1qu8ll8",
    styles: "padding:0 8px"
});
const containerStyle = /*#__PURE__*/ (0, _css.css)("margin-left:auto;margin-right:0;flex:1;&.full{.field-wrapper{display:block;label{margin-left:16px;font-size:14px;color:", (0, _colors.color_shades_darkest), ";}.selection-section{margin-top:8px;}}}&.minified{.field{.selection{border:none;background:transparent;}}.field-wrapper{max-width:350px;margin-left:auto;}}&.bordered{border-right:1px solid #ccc;}&.disabled{.field .selection{background:", (0, _colors.color_shades_light), ";cursor:not-allowed;}}.field{.selection{border-radius:4px;.empty-text{text-align:right;margin-left:auto;margin-right:12px;width:100%;}}}.sub-item{img{border-radius:50%;border:1px solid ", (0, _colors.cool_grey), ";}}.avatar-container{margin-right:12px;margin-left:auto;width:100%;display:flex;align-items:center;justify-content:flex-end;.selected-text{margin:0 12px;}>div{justify-content:flex-end;}}.full-language-selector{display:flex;align-items:center;}", "");
exports.default = ContentLanguageMultiSelector;

},{"@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","lodash":"3hMBK","./GroupedMultiSelector":"51iZT","../../models/extensions/languages":"8E5Oo","../general/LanguageCollectionAvatar":"crbMk","../../constants/colors":"1p3OR","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"51iZT":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _defineProperty = require("@babel/runtime/helpers/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _base = require("@emotion/styled/base");
var _baseDefault = parcelHelpers.interopDefault(_base);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _colors = require("../../constants/colors");
var _toggleIndicator = require("../general/ToggleIndicator");
var _toggleIndicatorDefault = parcelHelpers.interopDefault(_toggleIndicator);
var _checkIndicator = require("./CheckIndicator");
var _checkIndicatorDefault = parcelHelpers.interopDefault(_checkIndicator);
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
class GroupedMultiSelector extends (0, _reactDefault.default).Component {
    constructor(props){
        super(props);
        (0, _definePropertyDefault.default)(this, "documentCloser", this.handleDocumentClick.bind(this));
        this.state = {
            isExpanded: false,
            expandedGroupKeys: []
        };
    }
    componentWillMount() {
        document.addEventListener("click", this.documentCloser, true);
    }
    componentWillUnmount() {
        document.removeEventListener("click", this.documentCloser, true);
    }
    handleDocumentClick(e) {
        if (e.target.closest(".selector-wrapper") || e.target.closest(".field")) return;
        this.setState({
            ...this.state,
            isExpanded: false
        });
    }
    handleOpenToggle() {
        if (!this.props.disabled) this.setState({
            ...this.state,
            isExpanded: !this.state.isExpanded
        });
    }
    handleToggleGroup(itemGroup) {
        if (this.props.treatGroupAsValue && !itemGroup.subItems?.length) {
            this.props.onChange([
                itemGroup.key
            ]);
            this.setState({
                ...this.state,
                isExpanded: false
            });
        } else {
            var expandedKeys = this.state.expandedGroupKeys == null ? [] : this.state.expandedGroupKeys;
            if (expandedKeys.some((l)=>l == itemGroup.key)) expandedKeys.splice(expandedKeys.indexOf(itemGroup.key), 1);
            else expandedKeys.push(itemGroup.key);
            this.setState({
                ...this.state,
                expandedGroupKeys: expandedKeys
            });
        }
    }
    handleSelectGroup(e, itemGroup) {
        e.stopPropagation();
        let isExpanded = true;
        if (this.props.treatGroupAsValue && !itemGroup.subItems?.length) {
            this.props.onChange([
                itemGroup.key
            ]);
            isExpanded = false;
        } else this.props.onChange(itemGroup.subItems.map((i)=>i.value));
        if (itemGroup.subItems?.length) {
            var expandedKeys = this.state.expandedGroupKeys == null ? [] : this.state.expandedGroupKeys;
            if (!expandedKeys.some((l)=>l == itemGroup.key)) expandedKeys.push(itemGroup.key);
        }
        this.setState({
            ...this.state,
            expandedGroupKeys: expandedKeys,
            isExpanded: isExpanded
        });
    }
    renderGroup(itemGroup, selectedOptions) {
        if (itemGroup.customRender) return itemGroup.customRender;
        selectedOptions = selectedOptions == null ? [] : selectedOptions;
        const expandedGroupKeys = this.state.expandedGroupKeys == null ? [] : this.state.expandedGroupKeys;
        const isExpanded = this.props.autoGroupExpand || this.state.expandedGroupKeys?.some((e)=>e == itemGroup?.key);
        const isSelected = selectedOptions?.some((l)=>l.groupKey == itemGroup.key);
        return (0, _react.jsx)("div", {
            key: itemGroup.key
        }, (0, _react.jsx)("div", {
            className: "item-group",
            onClick: this.handleToggleGroup.bind(this, itemGroup)
        }, itemGroup.image ? (0, _react.jsx)(GroupImage, {
            src: itemGroup.image
        }) : this.props.withGroupSelection ? (0, _react.jsx)("div", {
            className: "check-container",
            onClick: (e)=>this.handleSelectGroup(e, itemGroup)
        }, isSelected ? (0, _react.jsx)("div", {
            className: "selected-option"
        }) : null) : null, (0, _react.jsx)("span", {
            onClick: (e)=>this.handleSelectGroup(e, itemGroup)
        }, itemGroup.label), itemGroup.subItems.length > 0 && (0, _react.jsx)((0, _toggleIndicatorDefault.default), {
            className: this.props.groupToggle,
            direction: isExpanded ? "up" : "down"
        })), isExpanded ? (0, _react.jsx)("div", {
            className: "sub-item-container"
        }, itemGroup.subItems.map((l)=>this.renderOption(l, selectedOptions.some((s)=>s.value == l.value)))) : null);
    }
    handleToggleOption(option, isSelected) {
        var selectedValues = this.props.selectedValues == null ? [] : this.props.selectedValues;
        if (this.props.subItemCheckType === "radio" && this.props.restrictGroups) selectedValues = [
            option.value
        ];
        else if (isSelected) {
            // if we only allow selections within a group - remove the other ones
            if (this.props.restrictGroups) {
                const group = this.props.groups.find((g)=>g.subItems != null && g.subItems.some((i)=>i.value == option.value));
                selectedValues = selectedValues.filter((o)=>group.subItems.some((i)=>i.value == o));
            }
            selectedValues.push(option.value);
        } else selectedValues.splice(selectedValues.indexOf(option.value), 1);
        this.props.onChange(selectedValues);
        if (option.hideCheckbox) this.setState({
            ...this.state,
            isExpanded: false
        });
    }
    renderOption(option, isSelected) {
        return (0, _react.jsx)("div", {
            className: "sub-item",
            onClick: ()=>this.handleToggleOption(option, !isSelected),
            key: option.value
        }, option.hideCheckbox ? (0, _react.jsx)((0, _reactDefault.default).Fragment, null) : (0, _react.jsx)((0, _checkIndicatorDefault.default), {
            checkType: this.props.subItemCheckType ?? "check",
            checked: isSelected
        }), option.icon ? (0, _react.jsx)("img", {
            src: option.icon
        }) : null, (0, _react.jsx)("p", null, option.label));
    }
    getAllOptions() {
        if (this.props.groups && this.props.groups.length > 0) return this.props.groups.reduce((prev, current)=>({
                key: "",
                label: "",
                subItems: prev.subItems.concat(current.subItems)
            })).subItems;
        return [];
    }
    render() {
        const selectedOptions = this.getAllOptions().filter((l)=>this.props.selectedValues != null && this.props.selectedValues.some((id)=>id == l.value));
        return (0, _react.jsx)("div", {
            className: `${containerStyle} ${this.props.className ?? ""} `
        }, (0, _react.jsx)("div", {
            className: "field-wrapper"
        }, (0, _react.jsx)("label", null, this.props.label), (0, _react.jsx)("div", {
            className: "selection-section"
        }, this.state.isExpanded && this.props.position == "top" ? (0, _react.jsx)("div", {
            className: `${selectorWrapperStyle} selector-wrapper top ${this.props.selectorWrapperClassName ?? ""}`
        }, (0, _react.jsx)("div", {
            className: "inner-wrapper"
        }, this.props.groups && this.props.groups.length > 0 ? this.props.groups.map((group)=>this.renderGroup(group, selectedOptions)) : (0, _react.jsx)("div", {
            className: "item-group"
        }, (0, _react.jsx)("p", null, this.props.emptyText ? this.props.emptyText : "No options available"))), (0, _react.jsx)("div", {
            className: topTriangleStyle
        })) : null, (0, _react.jsx)("div", {
            className: "field"
        }, (0, _react.jsx)("div", {
            className: "selection",
            onClick: this.handleOpenToggle.bind(this)
        }, this.props.innerSelectionRender(), (0, _react.jsx)((0, _toggleIndicatorDefault.default), {
            className: this.props.groupToggle,
            direction: this.state.isExpanded ? "up" : "down"
        }))), this.state.isExpanded && this.props.position == "bottom" ? (0, _react.jsx)("div", {
            className: `${selectorWrapperStyle} selector-wrapper ${this.props.selectorWrapperClassName ?? ""}`
        }, (0, _react.jsx)("div", {
            className: triangleStyle
        }), (0, _react.jsx)("div", {
            className: "inner-wrapper"
        }, this.props.groups && this.props.groups.length > 0 ? this.props.groups.map((group)=>this.renderGroup(group, selectedOptions)) : (0, _react.jsx)("div", {
            className: "item-group"
        }, (0, _react.jsx)("p", null, this.props.emptyText ? this.props.emptyText : "No options available")))) : null)));
    }
}
const selectorWrapperStyle = /*#__PURE__*/ (0, _css.css)("z-index:1;position:absolute;display:flex;flex-direction:column;margin-left:0;margin-right:0;right:0;left:0;background:white;margin-bottom:120px;margin-top:12px;box-shadow:0 4px 4px 0 ", (0, _colors.dark_grey_blue_10), ";border-radius:10px;flex:1;border:solid 1px #cccccc;.inner-wrapper{overflow-y:auto;max-height:600px;}&.top{bottom:0;margin-bottom:72px;}", "");
const containerStyle = /*#__PURE__*/ (0, _css.css)("position:relative;min-width:350px;.field-wrapper{display:flex;align-items:center;label{font-family:Muli;font-size:18px;font-weight:normal;font-stretch:normal;font-style:normal;line-height:normal;letter-spacing:normal;color:#2c3d52;margin-right:12px;}.selection-section{flex:1;position:relative;}}.field{display:flex;align-items:center;.selection{height:48px;border-radius:22.5px;border:solid 1px #cccccc;background:white;display:flex;align-items:center;padding:0 16px;cursor:pointer;flex:1;span{margin:0 12px;user-select:none;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;}}}.item-group{cursor:pointer;display:flex;align-items:center;height:64px;padding:0 16px;border-bottom:1px solid #cccccc;.check-container{position:relative;min-width:30px;height:30px;border-radius:50%;background-color:#ffffff;border:solid 1px #cccccc;display:flex;align-items:center;justify-content:center;margin-right:16px;}.selected-option{width:16px;height:16px;border-radius:50%;background-image:linear-gradient(225deg, #76c3b5, #3ea6ac 72%, #5296b3);}}.sub-item{cursor:pointer;display:flex;align-items:center;height:64px;padding:0 32px;border-bottom:1px solid #cccccc;img{margin-right:16px;}&:hover .checkmark{background-color:#EDF5FA;}&.disabled .checkmark{background:", (0, _colors.pale_grey), ";}}.sub-item-container{border-bottom:1px solid #cccccc;}", "");
const triangleStyle = /*#__PURE__*/ (0, _css.css)({
    name: "81wlk",
    styles: "transform:rotate(45deg);width:12px;height:12px;margin-top:-7px;margin-bottom:-6px;border-top:solid 1px #cccccc;border-left:solid 1px #cccccc;background:white;margin-right:16px;margin-left:auto"
});
const topTriangleStyle = /*#__PURE__*/ (0, _css.css)({
    name: "9wk4po",
    styles: "transform:rotate(45deg);width:12px;height:12px;margin-top:-7px;margin-bottom:-6px;border-bottom:solid 1px #cccccc;border-right:solid 1px #cccccc;background:white;margin-left:16px;margin-right:auto"
});
const GroupImage = /*#__PURE__*/ (0, _baseDefault.default)("img", {
    target: "ea6318b0"
})({
    name: "1oaeivz",
    styles: "margin-right:8px"
});
exports.default = GroupedMultiSelector;

},{"@babel/runtime/helpers/defineProperty":"9sJxO","@emotion/styled/base":"lSuFu","@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","../../constants/colors":"1p3OR","../general/ToggleIndicator":"4eej1","./CheckIndicator":"8zBm6","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4eej1":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _colors = require("../../constants/colors");
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const disabledChevronStyle = /*#__PURE__*/ (0, _css.css)("width:4px;height:4px;border-left:solid 1px ", (0, _colors.color_shades_dark), ";border-top:solid 1px ", (0, _colors.color_shades_dark), ";&.down{transform:rotate(-135deg);}", "");
const chevronStyle = /*#__PURE__*/ (0, _css.css)("width:4px;height:4px;border-left:solid 1px ", (0, _colors.dark_grey_blue), ";border-top:solid 1px ", (0, _colors.dark_grey_blue), ";&.up{transform:rotate(45deg);}&.down{transform:rotate(-135deg);}&.left{transform:rotate(-45deg);}&.right{transform:rotate(135deg);}", "");
const triangleStyle = /*#__PURE__*/ (0, _css.css)({
    name: "1lgabcs",
    styles: ".down{width:0;height:0;border-left:3px solid transparent;border-right:3px solid transparent;border-top:3px solid #324661;}.up{width:0;height:0;border-left:3px solid transparent;border-right:3px solid transparent;border-bottom:3px solid #324661;}.right{width:0;height:0;border-top:3px solid transparent;border-bottom:3px solid transparent;border-left:3px solid #324661;margin-right:3px;}width:6px;height:6px"
});
const ToggleIndicator = (props)=>{
    const type = props.type ?? "chevron";
    switch(type){
        case "chevron":
            return (0, _react.jsx)("div", {
                className: `toggle-indicator ${props.disabled ? disabledChevronStyle : chevronStyle} ${props.direction} ${props.className}`,
                onClick: props.onClick
            });
        case "triangle":
            return (0, _react.jsx)("div", {
                className: `${triangleStyle} ${props.className}`,
                onClick: props.onClick
            }, (0, _react.jsx)("div", {
                className: props.direction
            }));
    }
};
exports.default = ToggleIndicator;

},{"@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","../../constants/colors":"1p3OR","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8zBm6":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _colors = require("../../constants/colors");
// default 'check';
const getCheckClass = (props)=>{
    var className = containerStyle;
    if (props.checkType == "radio") className += " radio";
    else className += " checkmark";
    if (props.checked) className += " selected";
    if (props.partial) className += " partial selected";
    if (props.disabled) className += " disabled";
    return className;
};
const CheckIndicator = (props)=>(0, _react.jsx)("span", {
        onClick: props.onClick,
        className: `${getCheckClass(props)} ${props.className ?? ""}`
    });
const containerStyle = /*#__PURE__*/ (0, _css.css)("width:20px;height:20px;margin-right:16px;width:20px;height:20px;border-radius:5px;background-color:#ffffff;border:solid 1px #cccccc;position:relative;cursor:pointer;box-sizing:content-box;&:hover{background-color:", (0, _colors.color_variants_ocean_light_opaque), ";}&.selected{background:white;}&.disabled{background:", (0, _colors.color_shades_lighter), ';}&.checkmark:after{content:"";position:absolute;display:none;}&.checkmark:after{left:6px;top:2px;width:5px;height:10px;border:solid white;border-image-source:linear-gradient(to top, #76c3b5, #3ea6ac, #5296b3);border-image-slice:1;border-width:0 3px 3px 0;-webkit-transform:rotate(45deg);-ms-transform:rotate(45deg);transform:rotate(45deg);}&.radio{border-radius:50%;}&.radio:after{content:"";position:absolute;display:none;}&.radio:after{width:10px;height:10px;top:5px;left:5px;border-radius:50%;background:', (0, _colors.color_gradients_green_shift), ";}&.selected:after{display:block;}&.partial:after{left:5px;top:9px;width:10px;height:2px;transform:none;border:none;background:linear-gradient(to top, #76c3b5, #3ea6ac, #5296b3);}&.disabled{background:", (0, _colors.color_shades_lighter), ";cursor:not-allowed;}", "");
exports.default = CheckIndicator;

},{"@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","../../constants/colors":"1p3OR","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8E5Oo":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getFlagIcon", ()=>getFlagIcon);
parcelHelpers.export(exports, "getFlagIconForLanguage", ()=>getFlagIconForLanguage);
parcelHelpers.export(exports, "getRegionName", ()=>getRegionName);
parcelHelpers.export(exports, "getRegionyNameForLanguage", ()=>getRegionyNameForLanguage);
parcelHelpers.export(exports, "getLanguageName", ()=>getLanguageName);
parcelHelpers.export(exports, "getLanguageNameForLanguage", ()=>getLanguageNameForLanguage);
const argentina = require("c96f1947a5dddbba");
const australia = require("4265ed35ab835763");
const belgium = require("fb8afdd81287add0");
const brazil = require("cbdea1438d8a84ab");
const canada = require("f114b5142e428540");
const china = require("cf8b365f3d09bee3");
const denmark = require("4b21f048af61445f");
const finland = require("861c65ef4ffaf9d6");
const france = require("29f1e15ca9205e5e");
const germany = require("e082bce98594e3ee");
const greece = require("fe2c30b021563d26");
const iceland = require("1f18a73df70085e3");
const india = require("d7b5996acce0095a");
const ireland = require("f73c5f016f655325");
const israel = require("f4251359243c8daf");
const italy = require("6615091b740aff96");
const japan = require("b792573564502d21");
const mexico = require("430d36e4264edfea");
const netherlands = require("b10d544beec15168");
const newZealand = require("4ea1819864823f80");
const norway = require("8ff032c4c9704460");
const poland = require("59f56b1b9ab9214");
const russia = require("4909c4af7b2f5116");
const southKorea = require("6477d933a413b72f");
const spain = require("7690d791ffaf3736");
const switzerland = require("776b0ad913de37b2");
const turkey = require("30934faefab6888");
const uk = require("9afe90bdefc406e3");
const us = require("aaf0c79d84d7bded");
const defaultFlag = require("ac7a6f0fc46c00b5");
const austria = require("d2efcfa825068acb");
const indonesia = require("8eff506b461235d7");
const latinAmerica = require("ebea0d6dfa79bc34");
const portugal = require("a3ed7ce4ac44d9af");
const singapore = require("2dd0888b13d122b2");
const sweden = require("44b9580c6b502e1c");
const thailand = require("712ba2def9acd09b");
const getFlagIcon = (regionCode)=>{
    switch(regionCode?.toLowerCase()){
        case "us":
            return us;
        case "gb":
            return uk;
        case "mx":
            return mexico;
        case "fr":
            return france;
        case "jp":
            return japan;
        case "es":
            return spain;
        case "au":
            return australia;
        case "in":
            return india;
        case "de":
            return germany;
        case "it":
            return italy;
        case "ca":
            return canada;
        case "419":
            return latinAmerica;
        case "cn":
            return china;
        case "hk":
            return china;
        case "tw":
            return china;
        case "dk":
            return denmark;
        case "nl":
            return netherlands;
        case "be":
            return belgium;
        case "ch":
            return switzerland;
        case "at":
            return austria;
        case "id":
            return indonesia;
        case "kr":
            return southKorea;
        case "no":
            return norway;
        case "pl":
            return poland;
        case "br":
            return brazil;
        case "ru":
            return russia;
        case "se":
            return sweden;
        case "th":
            return thailand;
        case "tr":
            return turkey;
        case "sg":
            return singapore;
    }
    return defaultFlag;
};
const getFlagIconForLanguage = (model)=>{
    if (!model) return "";
    return getFlagIcon(model?.regionCode);
};
const getRegionName = (regionCode)=>{
    switch(regionCode?.toLowerCase()){
        case "us":
            return "United States";
        case "gb":
            return "United Kingdom";
        case "mx":
            return "Mexico";
        case "fr":
            return "France";
        case "jp":
            return "Japan";
        case "es":
            return "Spain";
        case "au":
            return "Australia";
        case "in":
            return "India";
        case "de":
            return "Germany";
        case "it":
            return "Italy";
        case "ca":
            return "Canada";
        case "419":
            return "Latin America";
        case "cn":
            return "China";
        case "hk":
            return "Cantonese";
        case "tw":
            return "Traditional Chinese";
        case "dk":
            return "Denmark";
        case "nl":
            return "Netherlands";
        case "be":
            return "Belgium";
        case "ch":
            return "Switzerland";
        case "at":
            return "Austria";
        case "id":
            return "Indonesia";
        case "kr":
            return "Korea";
        case "no":
            return "Norway";
        case "pl":
            return "Poland";
        case "br":
            return "Brazil";
        case "ru":
            return "Russia";
        case "se":
            return "Sweden";
        case "th":
            return "Thailand";
        case "tr":
            return "Turkey";
        case "sg":
            return "Singapore";
    }
    return "";
};
const getRegionyNameForLanguage = (model)=>{
    if (!model) return "";
    return getRegionName(model?.regionCode);
};
const getLanguageName = (languageCode)=>{
    if (!languageCode) return "";
    switch(languageCode?.toLowerCase()){
        case "es":
            return "Spanish";
        case "en":
            return "English";
        case "fr":
            return "French";
        case "hi":
            return "Hindi";
        case "it":
            return "Italian";
        case "ja":
            return "Japanese";
        case "pt":
            return "Portuguese";
        case "tr":
            return "Turkish";
        case "th":
            return "Thai";
        case "sv":
            return "Swedish";
        case "ru":
            return "Russian";
        case "pl":
            return "Polish";
        case "no":
            return "Norwegian";
        case "ko":
            return "Korean";
        case "id":
            return "Indonesian";
        case "de":
            return "German";
        case "nl":
            return "Dutch";
        case "da":
            return "Danish";
        case "zh":
            return "Chinese";
    }
};
const getLanguageNameForLanguage = (model)=>{
    if (!model) return "";
    return getLanguageName(model?.languageGroupCode);
};

},{"c96f1947a5dddbba":"5S1C4","4265ed35ab835763":"2jNSF","fb8afdd81287add0":"5lUui","cbdea1438d8a84ab":"6N0MW","f114b5142e428540":"6vqYr","cf8b365f3d09bee3":"3OR1G","4b21f048af61445f":"1TySj","861c65ef4ffaf9d6":"5NTOp","29f1e15ca9205e5e":"ktysF","e082bce98594e3ee":"bhIc2","fe2c30b021563d26":"4UHGO","1f18a73df70085e3":"jRtmm","d7b5996acce0095a":"6sKOF","f73c5f016f655325":"4W2Ri","f4251359243c8daf":"jbZvY","6615091b740aff96":"b79bA","b792573564502d21":"7d4sl","430d36e4264edfea":"4Kcjc","b10d544beec15168":"7nHA9","4ea1819864823f80":"2rKPy","8ff032c4c9704460":"biKfT","59f56b1b9ab9214":"9dNRX","4909c4af7b2f5116":"cCWqe","6477d933a413b72f":"9h1mJ","7690d791ffaf3736":"hrckn","776b0ad913de37b2":"3hl6h","30934faefab6888":"5f3Kt","9afe90bdefc406e3":"51fMM","aaf0c79d84d7bded":"a8FBT","ac7a6f0fc46c00b5":"cJMqX","d2efcfa825068acb":"dLrXx","8eff506b461235d7":"ky2Ow","ebea0d6dfa79bc34":"btwK5","a3ed7ce4ac44d9af":"4hwX1","2dd0888b13d122b2":"iXpIo","44b9580c6b502e1c":"h7wL8","712ba2def9acd09b":"8NSdc","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"5S1C4":[function(require,module,exports) {
module.exports = require("759f3cdbc9694b55").getBundleURL("kVLro") + require("28255c000ca4a258").resolve("jkDmu");

},{"759f3cdbc9694b55":"c7Tr5","28255c000ca4a258":"fyJL2"}],"2jNSF":[function(require,module,exports) {
module.exports = require("bc4f6a8e52993dc5").getBundleURL("kVLro") + require("2d46241ed7e21ad1").resolve("ggXNE");

},{"bc4f6a8e52993dc5":"c7Tr5","2d46241ed7e21ad1":"fyJL2"}],"5lUui":[function(require,module,exports) {
module.exports = require("871ea5f63baeb9ba").getBundleURL("kVLro") + require("a5986dcb0add5b51").resolve("6NI5y");

},{"871ea5f63baeb9ba":"c7Tr5","a5986dcb0add5b51":"fyJL2"}],"6N0MW":[function(require,module,exports) {
module.exports = require("15d40af61e1ad6cf").getBundleURL("kVLro") + require("5dca4ca16db6c579").resolve("62G64");

},{"15d40af61e1ad6cf":"c7Tr5","5dca4ca16db6c579":"fyJL2"}],"6vqYr":[function(require,module,exports) {
module.exports = require("dcfc49ebe7859623").getBundleURL("kVLro") + require("58d5cf61d298efdb").resolve("kVlFs");

},{"dcfc49ebe7859623":"c7Tr5","58d5cf61d298efdb":"fyJL2"}],"3OR1G":[function(require,module,exports) {
module.exports = require("5877004f64fc235c").getBundleURL("kVLro") + require("68df0c3155903dfe").resolve("gBVmy");

},{"5877004f64fc235c":"c7Tr5","68df0c3155903dfe":"fyJL2"}],"1TySj":[function(require,module,exports) {
module.exports = require("99aed273eca67eb1").getBundleURL("kVLro") + require("5d7ced983c36a958").resolve("8b7ve");

},{"99aed273eca67eb1":"c7Tr5","5d7ced983c36a958":"fyJL2"}],"5NTOp":[function(require,module,exports) {
module.exports = require("258c07d34983db2f").getBundleURL("kVLro") + require("62810a81d48fe7fc").resolve("b0JAZ");

},{"258c07d34983db2f":"c7Tr5","62810a81d48fe7fc":"fyJL2"}],"ktysF":[function(require,module,exports) {
module.exports = require("b12e047661be6787").getBundleURL("kVLro") + require("e6b9275d5d199d7").resolve("8ZGgF");

},{"b12e047661be6787":"c7Tr5","e6b9275d5d199d7":"fyJL2"}],"bhIc2":[function(require,module,exports) {
module.exports = require("d247f1110d2ec20c").getBundleURL("kVLro") + require("f7190991ae043279").resolve("fXMd5");

},{"d247f1110d2ec20c":"c7Tr5","f7190991ae043279":"fyJL2"}],"4UHGO":[function(require,module,exports) {
module.exports = require("e6a0125a1bf69752").getBundleURL("kVLro") + require("650f1d9be85a5ca3").resolve("bzP9h");

},{"e6a0125a1bf69752":"c7Tr5","650f1d9be85a5ca3":"fyJL2"}],"jRtmm":[function(require,module,exports) {
module.exports = require("58e4ffed33549d07").getBundleURL("kVLro") + require("64c8cf60837ed734").resolve("iLQfW");

},{"58e4ffed33549d07":"c7Tr5","64c8cf60837ed734":"fyJL2"}],"6sKOF":[function(require,module,exports) {
module.exports = require("a3a63402006a74c").getBundleURL("kVLro") + require("dde56ab16d39a279").resolve("gHJ8h");

},{"a3a63402006a74c":"c7Tr5","dde56ab16d39a279":"fyJL2"}],"4W2Ri":[function(require,module,exports) {
module.exports = require("c84dac68cb229a6").getBundleURL("kVLro") + require("f1111906d901aa4b").resolve("6YWcY");

},{"c84dac68cb229a6":"c7Tr5","f1111906d901aa4b":"fyJL2"}],"jbZvY":[function(require,module,exports) {
module.exports = require("3e8958aac9956999").getBundleURL("kVLro") + require("4c5ab288a277603d").resolve("2L2R9");

},{"3e8958aac9956999":"c7Tr5","4c5ab288a277603d":"fyJL2"}],"b79bA":[function(require,module,exports) {
module.exports = require("81550d77e0862d11").getBundleURL("kVLro") + require("e1ce247b83541ec1").resolve("jxFEP");

},{"81550d77e0862d11":"c7Tr5","e1ce247b83541ec1":"fyJL2"}],"7d4sl":[function(require,module,exports) {
module.exports = require("86c996ab44ac2dee").getBundleURL("kVLro") + require("318d70831ab3e724").resolve("c68W1");

},{"86c996ab44ac2dee":"c7Tr5","318d70831ab3e724":"fyJL2"}],"4Kcjc":[function(require,module,exports) {
module.exports = require("c900814a5c37d3d2").getBundleURL("kVLro") + require("5115b2bb62701cc0").resolve("41dJp");

},{"c900814a5c37d3d2":"c7Tr5","5115b2bb62701cc0":"fyJL2"}],"7nHA9":[function(require,module,exports) {
module.exports = require("a4849ee008b72eda").getBundleURL("kVLro") + require("1bd6173cd5b4a7b7").resolve("l3Izz");

},{"a4849ee008b72eda":"c7Tr5","1bd6173cd5b4a7b7":"fyJL2"}],"2rKPy":[function(require,module,exports) {
module.exports = require("358acb6bbdf6ad61").getBundleURL("kVLro") + require("3febd8fc3edb34ac").resolve("eHosg");

},{"358acb6bbdf6ad61":"c7Tr5","3febd8fc3edb34ac":"fyJL2"}],"biKfT":[function(require,module,exports) {
module.exports = require("f30d01c86e1065ac").getBundleURL("kVLro") + require("df2b1fecb373d76").resolve("iEptU");

},{"f30d01c86e1065ac":"c7Tr5","df2b1fecb373d76":"fyJL2"}],"9dNRX":[function(require,module,exports) {
module.exports = require("32f7996c307713d4").getBundleURL("kVLro") + require("87c0d71262af06f5").resolve("99LMR");

},{"32f7996c307713d4":"c7Tr5","87c0d71262af06f5":"fyJL2"}],"cCWqe":[function(require,module,exports) {
module.exports = require("5e99793fd827099c").getBundleURL("kVLro") + require("fee2b4b2a82b62d8").resolve("2F67C");

},{"5e99793fd827099c":"c7Tr5","fee2b4b2a82b62d8":"fyJL2"}],"9h1mJ":[function(require,module,exports) {
module.exports = require("a6b963b41351ac31").getBundleURL("kVLro") + require("c007b593098d294e").resolve("b9mm4");

},{"a6b963b41351ac31":"c7Tr5","c007b593098d294e":"fyJL2"}],"hrckn":[function(require,module,exports) {
module.exports = require("1ba7ed517d742e4c").getBundleURL("kVLro") + require("432eed8c89ccc34d").resolve("voRb4");

},{"1ba7ed517d742e4c":"c7Tr5","432eed8c89ccc34d":"fyJL2"}],"3hl6h":[function(require,module,exports) {
module.exports = require("853abe80c3e99313").getBundleURL("kVLro") + require("fded07102d34579c").resolve("hPbAX");

},{"853abe80c3e99313":"c7Tr5","fded07102d34579c":"fyJL2"}],"5f3Kt":[function(require,module,exports) {
module.exports = require("40dd8dc6b3c05f3b").getBundleURL("kVLro") + require("b498200dd47b0497").resolve("buoR4");

},{"40dd8dc6b3c05f3b":"c7Tr5","b498200dd47b0497":"fyJL2"}],"51fMM":[function(require,module,exports) {
module.exports = require("2917284f295ce2ad").getBundleURL("kVLro") + require("3f4762408c292578").resolve("gd27w");

},{"2917284f295ce2ad":"c7Tr5","3f4762408c292578":"fyJL2"}],"a8FBT":[function(require,module,exports) {
module.exports = require("c48df751de7dbdf5").getBundleURL("kVLro") + require("927e8d6bb5d79c3").resolve("1j5F5");

},{"c48df751de7dbdf5":"c7Tr5","927e8d6bb5d79c3":"fyJL2"}],"cJMqX":[function(require,module,exports) {
module.exports = require("967401801e335cb7").getBundleURL("kVLro") + require("55d8a429a3c85ef0").resolve("jSTsS");

},{"967401801e335cb7":"c7Tr5","55d8a429a3c85ef0":"fyJL2"}],"dLrXx":[function(require,module,exports) {
module.exports = require("4e6f0b3f7176c906").getBundleURL("kVLro") + require("c1a61399e9f68150").resolve("ly1cC");

},{"4e6f0b3f7176c906":"c7Tr5","c1a61399e9f68150":"fyJL2"}],"ky2Ow":[function(require,module,exports) {
module.exports = require("2d1f60e9da82093d").getBundleURL("kVLro") + require("790b5dbc33530535").resolve("foabm");

},{"2d1f60e9da82093d":"c7Tr5","790b5dbc33530535":"fyJL2"}],"btwK5":[function(require,module,exports) {
module.exports = require("c88d8574815bb5ef").getBundleURL("kVLro") + require("d588b32cf68c09").resolve("bYPjU");

},{"c88d8574815bb5ef":"c7Tr5","d588b32cf68c09":"fyJL2"}],"4hwX1":[function(require,module,exports) {
module.exports = require("b9989c3a751e1ef8").getBundleURL("kVLro") + require("71021a2cd181345a").resolve("ikNsO");

},{"b9989c3a751e1ef8":"c7Tr5","71021a2cd181345a":"fyJL2"}],"iXpIo":[function(require,module,exports) {
module.exports = require("265c12f5a391252").getBundleURL("kVLro") + require("1c57bc4f307ecf79").resolve("NqF58");

},{"265c12f5a391252":"c7Tr5","1c57bc4f307ecf79":"fyJL2"}],"h7wL8":[function(require,module,exports) {
module.exports = require("d6c62bc5746aea6f").getBundleURL("kVLro") + require("bb2cf6d1ea4e117").resolve("loory");

},{"d6c62bc5746aea6f":"c7Tr5","bb2cf6d1ea4e117":"fyJL2"}],"8NSdc":[function(require,module,exports) {
module.exports = require("d80f7c91faa6ef25").getBundleURL("kVLro") + require("525cc6946373487").resolve("a1MdO");

},{"d80f7c91faa6ef25":"c7Tr5","525cc6946373487":"fyJL2"}],"crbMk":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _languages = require("../../models/extensions/languages");
var _tooltipWrapper = require("./TooltipWrapper");
var _tooltipWrapperDefault = parcelHelpers.interopDefault(_tooltipWrapper);
var _colors = require("../../constants/colors");
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const LanguageCollectionAvatar = (props)=>(0, _react.jsx)("div", {
        className: containerStyle + (props.className ? ` ${props.className}` : "")
    }, props.languages?.slice(0, props.limit).map((l, idx)=>(0, _react.jsx)((0, _tooltipWrapperDefault.default), {
            text: `${(0, _languages.getLanguageNameForLanguage)(l)} (${(0, _languages.getRegionyNameForLanguage)(l)})`,
            className: flagTooltip,
            key: idx
        }, (0, _react.jsx)("div", {
            className: "flag-item"
        }, (0, _react.jsx)("div", {
            className: "inner-flag"
        }, (0, _react.jsx)("img", {
            src: (0, _languages.getFlagIconForLanguage)(l)
        }))))), props.languages?.length === props.limit + 1 ? (0, _react.jsx)((0, _tooltipWrapperDefault.default), {
        text: props.languages.slice(props.limit).map((l)=>`${(0, _languages.getLanguageNameForLanguage)(l)} (${(0, _languages.getRegionyNameForLanguage)(l)})`).join(", "),
        className: flagTooltip
    }, (0, _react.jsx)("div", {
        className: "flag-item"
    }, (0, _react.jsx)("div", {
        className: "inner-flag"
    }, (0, _react.jsx)("img", {
        src: (0, _languages.getFlagIconForLanguage)(props.languages[props.limit])
    })))) : null, props.languages?.slice(props.limit).length > 1 ? (0, _react.jsx)((0, _tooltipWrapperDefault.default), {
        text: props.languages.slice(props.limit).map((l)=>`${(0, _languages.getLanguageNameForLanguage)(l)} (${(0, _languages.getRegionyNameForLanguage)(l)})`).join(", "),
        className: flagTooltip
    }, (0, _react.jsx)("div", {
        className: "flag-item"
    }, (0, _react.jsx)("div", {
        className: "inner-flag overflow-icon"
    }, (0, _react.jsx)("p", null, "+", props.languages.slice(props.limit).length)))) : null);
const containerStyle = /*#__PURE__*/ (0, _css.css)("display:flex;.inner-flag{border-radius:50%;border:1px solid ", (0, _colors.cool_grey), ";box-sizing:border-box;display:flex;align-items:center;justify-content:center;&.overflow-icon{width:24px;height:24px;max-height:24px;max-width:24px;}}.flag-item{padding:1px;width:24px;height:24px;max-height:24px;max-width:24px;margin-left:-12px;border-radius:50%;z-index:0;background:white;display:flex;align-items:center;justify-content:center;border:2px solid #ffffff;&:hover{z-index:1;}&:first-child{margin-left:0;}}", "");
const flagTooltip = /*#__PURE__*/ (0, _css.css)({
    name: "hrices",
    styles: ".rc-tooltip-inner{max-width:200px;}"
});
exports.default = LanguageCollectionAvatar;

},{"@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","../../models/extensions/languages":"8E5Oo","./TooltipWrapper":"53pWd","../../constants/colors":"1p3OR","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6VyMV":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _panelContainer = require("../../components/structure/Panels/PanelContainer");
var _panelContainerDefault = parcelHelpers.interopDefault(_panelContainer);
var _collapsingPanel = require("../../components/structure/Panels/CollapsingPanel");
var _collapsingPanelDefault = parcelHelpers.interopDefault(_collapsingPanel);
var _collapsedMenuPanel = require("../../components/structure/CollapsedMenuPanel");
var _collapsedMenuPanelDefault = parcelHelpers.interopDefault(_collapsedMenuPanel);
var _tabContainerPanel = require("../../components/structure/Panels/TabContainerPanel");
var _tabContainerPanelDefault = parcelHelpers.interopDefault(_tabContainerPanel);
var _reactTabs = require("react-tabs");
var _scrollablePanelBody = require("../../components/structure/ScrollablePanelBody");
var _scrollablePanelBodyDefault = parcelHelpers.interopDefault(_scrollablePanelBody);
var _colors = require("../../constants/colors");
var _expandedMenuPanel = require("../../components/structure/ExpandedMenuPanel");
var _expandedMenuPanelDefault = parcelHelpers.interopDefault(_expandedMenuPanel);
var _panelTitle = require("./components/PanelTitle");
var _panelTitleDefault = parcelHelpers.interopDefault(_panelTitle);
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const previewIcon = require("976c7b0fe6f1f971");
const previewBlueIcon = require("664fb64fb30ba76f");
const treeIcon = require("9f6421ec0d85f463");
const treeIconBlue = require("3fae1016cc528f9f");
const connectionsIcon = require("1d85373faeb7f666");
const connectionsIconBlue = require("b50b6f5274dd60f0");
class ContentPagePanel extends (0, _reactDefault.default).Component {
    constructor(props){
        super(props);
        this.state = {
            isLeftExpanded: localStorage.getItem("contentMenu") == "true",
            selectedMenuIndex: 0,
            selectedRightIndex: 0
        };
    }
    handleToggleExpandLeft(e, expanded) {
        this.setState({
            ...this.state,
            isLeftExpanded: expanded
        });
        localStorage.setItem("contentMenu", expanded?.toString());
        e?.stopPropagation();
    }
    setContentMenuIndex(index) {
        this.setState({
            ...this.state,
            selectedMenuIndex: index
        });
    }
    setRightMenuIndex(index) {
        this.setState({
            ...this.state,
            selectedRightIndex: index
        });
    }
    renderMenu() {
        return (0, _react.jsx)((0, _tabContainerPanelDefault.default), {
            tabs: [
                {
                    title: "Conversation",
                    icon: treeIcon,
                    selectedIcon: treeIconBlue,
                    className: "ac-content-menu-tab"
                },
                {
                    title: "Connections",
                    icon: connectionsIcon,
                    selectedIcon: connectionsIconBlue,
                    className: "ac-connections-menu-tab"
                }
            ],
            onTabSelected: (newIndex)=>{
                this.setContentMenuIndex(newIndex);
            },
            selectedIndex: this.state.selectedMenuIndex
        }, (0, _react.jsx)((0, _reactTabs.TabPanel), null, (0, _react.jsx)((0, _scrollablePanelBodyDefault.default), {
            className: panelBodyStyle
        }, this.props.treeRender())), (0, _react.jsx)((0, _reactTabs.TabPanel), null, (0, _react.jsx)((0, _scrollablePanelBodyDefault.default), {
            className: panelBodyStyle
        }, this.props.relatedContentRender())));
    }
    render() {
        const props = this.props;
        return (0, _react.jsx)((0, _panelContainerDefault.default), {
            className: containerStyle
        }, (0, _react.jsx)("div", {
            className: `${menuStyle} ${this.state.isLeftExpanded ? "expanded" : "collapsed"} ac-content-item-menu`
        }, (0, _react.jsx)("div", {
            className: "fixed-wrapper"
        }, (0, _react.jsx)((0, _collapsingPanelDefault.default), {
            isCollapsed: !this.state.isLeftExpanded,
            collapsedView: (0, _react.jsx)((0, _collapsedMenuPanelDefault.default), {
                onExpand: (e)=>this.handleToggleExpandLeft(e, true),
                expandedViewRender: this.renderMenu.bind(this)
            }),
            expandedView: (0, _react.jsx)((0, _expandedMenuPanelDefault.default), {
                onCollapse: (e)=>this.handleToggleExpandLeft(e, false),
                expandedViewRender: this.renderMenu.bind(this)
            })
        }))), (0, _react.jsx)((0, _panelContainerDefault.default), {
            className: formBodyStyle
        }, props.formPanelRender()), (0, _react.jsx)((0, _tabContainerPanelDefault.default), {
            tabs: [
                {
                    title: "Test Cases",
                    icon: previewIcon,
                    selectedIcon: previewBlueIcon,
                    className: "ac-content-preview-tab"
                }
            ],
            onTabSelected: (newIndex)=>{
                this.setRightMenuIndex(newIndex);
            },
            selectedIndex: this.state.selectedRightIndex
        }, (0, _react.jsx)((0, _reactTabs.TabPanel), null, (0, _react.jsx)((0, _scrollablePanelBodyDefault.default), {
            className: flowBodyStyle
        }, (0, _react.jsx)((0, _panelTitleDefault.default), {
            title: "Content Item Test Cases",
            detail: "Here's test cases to ensure expected behavior for different user inputs"
        }), props.testCasesRender()))));
    }
}
const containerStyle = /*#__PURE__*/ (0, _css.css)("background:", (0, _colors.color_variants_main_bg), ";", "");
const formBodyStyle = /*#__PURE__*/ (0, _css.css)("border-right:1px solid ", (0, _colors.color_shades_dark), ";box-sizing:border-box;.scrollable-body{padding-bottom:56px;}", "");
const flowBodyStyle = /*#__PURE__*/ (0, _css.css)({
    name: "a5q46z",
    styles: "padding-top:0;min-height:100%;padding-bottom:56px"
});
const panelBodyStyle = /*#__PURE__*/ (0, _css.css)({
    name: "xzst3i",
    styles: "min-height:100%;padding-top:0"
});
const menuStyle = /*#__PURE__*/ (0, _css.css)("z-index:2;bottom:0;position:relative;&.collapsed{width:80px;.fixed-wrapper{width:80px;}}&.expanded{width:288px;.fixed-wrapper{width:288px;}}.fixed-wrapper{position:fixed;bottom:0;height:calc(100vh - 80px);background:white;border-right:1px solid ", (0, _colors.color_shades_dark), ";box-sizing:border-box;}", "");
exports.default = ContentPagePanel;

},{"@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","../../components/structure/Panels/PanelContainer":"9R2lE","../../components/structure/Panels/CollapsingPanel":"jVPoD","../../components/structure/CollapsedMenuPanel":"1mVIj","../../components/structure/Panels/TabContainerPanel":"iDHIJ","react-tabs":"92Sgf","../../components/structure/ScrollablePanelBody":"6LRg3","../../constants/colors":"1p3OR","../../components/structure/ExpandedMenuPanel":"30h7k","./components/PanelTitle":"anVUR","976c7b0fe6f1f971":"e7QMc","664fb64fb30ba76f":"i9vjx","9f6421ec0d85f463":"ec3aw","3fae1016cc528f9f":"fqIap","1d85373faeb7f666":"7UQC6","b50b6f5274dd60f0":"4xPKU","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9R2lE":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const PanelContainer = (props)=>(0, _react.jsx)("div", {
        className: `${containerStyle} ${props.className ?? ""}`
    }, props.children);
const containerStyle = /*#__PURE__*/ (0, _css.css)({
    name: "dw0khf",
    styles: "display:flex;flex:1;height:100%"
});
exports.default = PanelContainer;

},{"@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jVPoD":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _base = require("@emotion/styled/base");
var _baseDefault = parcelHelpers.interopDefault(_base);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
const CollapsingPanel = (props)=>(0, _react.jsx)(CollapsingPanelWrapper, null, props.isCollapsed ? props.collapsedView : props.expandedView);
const CollapsingPanelWrapper = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1v6yaom0"
})("");
exports.default = CollapsingPanel;

},{"@emotion/styled/base":"lSuFu","@emotion/react":"djZKr","react":"6uln9","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1mVIj":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _menuCollapseToggle = require("./MenuCollapseToggle");
var _menuCollapseToggleDefault = parcelHelpers.interopDefault(_menuCollapseToggle);
var _colors = require("../../constants/colors");
var _slideInSlideOutComponent = require("./SlideInSlideOutComponent");
var _slideInSlideOutComponentDefault = parcelHelpers.interopDefault(_slideInSlideOutComponent);
var _useIsMobile = require("../../hooks/UseIsMobile");
var _useIsMobileDefault = parcelHelpers.interopDefault(_useIsMobile);
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const menuIcon = require("5183cc92de630162");
const CollapsedMenuPanel = (props)=>{
    const [contentExpanded, setContentExpanded] = (0, _react1.useState)(false);
    const isMobile = (0, _useIsMobileDefault.default)();
    const handleExpand = ()=>{
        setContentExpanded(true);
        addLeaveListener();
    };
    const addLeaveListener = ()=>{
        // we need to wait till the panel is expanded to start listening for mouse leave. 
        setTimeout(()=>{
            const element = document.getElementById("expanded-view");
            element.addEventListener("mouseleave", ()=>{
                handleMinimize();
            });
        }, 300);
    };
    const handleMinimize = ()=>{
        setContentExpanded(false);
    };
    return (0, _react.jsx)("div", {
        className: `${props.minimizedDrawer && minimizedDrawerStyle} ${containerStyle}`
    }, !contentExpanded && (0, _react.jsx)("div", {
        className: "header-container"
    }, (0, _react.jsx)((0, _menuCollapseToggleDefault.default), {
        isMinified: true,
        onToggle: props.onExpand,
        minimizedDrawer: props.minimizedDrawer && props.minimizedDrawer
    })), (0, _react.jsx)("div", {
        className: "menu-container"
    }, isMobile ? (0, _react.jsx)("div", {
        className: "menu-toggle",
        onPointerDown: props.onExpand
    }, (0, _react.jsx)("img", {
        src: menuIcon
    })) : (0, _react.jsx)("div", {
        className: "menu-toggle",
        onClick: handleExpand
    }, (0, _react.jsx)("img", {
        src: menuIcon
    })), (0, _react.jsx)((0, _slideInSlideOutComponentDefault.default), {
        direction: "right",
        showChildren: contentExpanded,
        styleName: "collapsedMenuSlide"
    }, (0, _react.jsx)("div", {
        id: "expanded-view",
        className: "floating-tree-container"
    }, props.expandedViewRender()))));
};
const minimizedDrawerStyle = /*#__PURE__*/ (0, _css.css)({
    name: "1xv8l6k",
    styles: "width:0px;.header-container{width:0px;}"
});
const containerStyle = /*#__PURE__*/ (0, _css.css)(".header-container{position:relative;width:80px;display:flex;}.menu-toggle{width:80px;height:56px;display:flex;align-items:center;justify-content:center;cursor:pointer;img{width:24px;height:24px;}}.highlighted{.inner - toggle{background:", (0, _colors.text_blue), ";}}.floating-tree-container{width:288px;position:absolute;top:0;bottom:0;background:white;border-right:1px solid ", (0, _colors.silver_four), ";}", "");
exports.default = CollapsedMenuPanel;

},{"@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","./MenuCollapseToggle":"d7R0v","../../constants/colors":"1p3OR","./SlideInSlideOutComponent":"bwTqS","../../hooks/UseIsMobile":"9Gz1L","5183cc92de630162":"dWwQJ","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"d7R0v":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _colors = require("../../constants/colors");
var _toggleIndicator = require("../general/ToggleIndicator");
var _toggleIndicatorDefault = parcelHelpers.interopDefault(_toggleIndicator);
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const MenuCollapseToggle = (props)=>{
    const combinedStyle = /*#__PURE__*/ (0, _css.css)(containerStyle, ";", props.minimizedDrawer && minimizedDrawerStyle, ";", props.expandedMinimizedDrawer && expandedMinimizedDrawerStyle, ";", "");
    return (0, _react.jsx)("div", {
        className: `${combinedStyle} ${props.className ?? ""}`,
        onClick: props.onToggle
    }, (0, _react.jsx)("div", {
        className: `border-container ${props.isMinified ? "collapsed-border" : "expanded-border"}`
    }, (0, _react.jsx)("div", {
        className: "inner-toggle ac-menu-toggle"
    }, (0, _react.jsx)((0, _toggleIndicatorDefault.default), {
        direction: "left"
    }), (0, _react.jsx)("div", {
        className: "separator"
    }))));
};
const expandedMinimizedDrawerStyle = /*#__PURE__*/ (0, _css.css)({
    name: "1qikfe3",
    styles: "right:18px"
});
const minimizedDrawerStyle = /*#__PURE__*/ (0, _css.css)({
    name: "fobkqv",
    styles: "left:15px"
});
const containerStyle = /*#__PURE__*/ (0, _css.css)("cursor:pointer;position:absolute;right:0;top:14px;z-index:3;.toggle-indicator{border-color:", (0, _colors.color_shades_darkest), ";}.border-container{border:1px solid ", (0, _colors.color_shades_dark), ";height:24px;width:9px;}.collapsed-border{transform:scaleX(-1);margin-right:-9px;border-radius:4px;}.expanded-border{border-radius:4px;}.inner-toggle{background:#FFFFFF;box-sizing:content-box;display:flex;align-items:center;justify-content:center;width:100%;height:100%;padding:0 4px 0 6px;border-radius:4px;width:12px;.separator{height:16px;width:1px;background:", (0, _colors.color_shades_dark), ";margin-right:0;margin-left:auto;}.separator-left{height:16px;width:1px;background:", (0, _colors.color_shades_dark), ";margin-left:0;margin-right:auto;}}", "");
exports.default = MenuCollapseToggle;

},{"@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","../../constants/colors":"1p3OR","../general/ToggleIndicator":"4eej1","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"bwTqS":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _reactTransitionGroup = require("react-transition-group");
var _css = require("@emotion/css");
class SlideInSlideOutComponent extends (0, _reactDefault.default).Component {
    constructor(props){
        super(props);
        this.state = {
            shouldRender: false
        };
    }
    componentDidMount() {
        if (this.props.showChildren == null) this.renderTimeout();
        this.setState({
            ...this.state,
            shouldRender: true
        });
    }
    renderTimeout() {
        setTimeout(()=>{
            this.setState({
                ...this.state,
                shouldRender: true
            });
        }, 100);
    }
    render() {
        const props = this.props;
        const showChildren = (props.showChildren ?? true) && this.state.shouldRender;
        const transitionTimeInTenths = props.transitionTimeMS == null ? 2 : props.transitionTimeMS * 100;
        const styleName = props.styleName ?? Math.random().toString(36).substring(2, 15);
        return (0, _react.jsx)((0, _reactTransitionGroup.CSSTransitionGroup), {
            className: generateSlideStyle(props.direction, styleName, props.slideType ?? "position", transitionTimeInTenths),
            transitionName: styleName,
            transitionEnterTimeout: transitionTimeInTenths * 100,
            transitionLeaveTimeout: transitionTimeInTenths * 100
        }, showChildren ? props.children : null);
    }
}
const generateSlideStyle = (direction, styleName, slideType, transitionTime)=>{
    const transitionStyle = `    
    .${styleName}-enter.${styleName}-enter-active {
        animation: ${styleName}-in .${transitionTime}s forwards;
    }

    .${styleName}-leave.${styleName}-leave-active {
        animation: ${styleName}-out .${transitionTime}s forwards;
    }
    `;
    // we have to call 'css' on the string so emotion builds the animation correctly. 
    if (slideType === "position") switch(direction){
        case "up":
            const upStyle = `
                @keyframes ${styleName}-in {
                    0% {
                        transform: translateY(100%);
                    }
                    100% {
                        transform: translateY(0%);
                    }
                }            
                @keyframes ${styleName}-out {
                    0% {
                        transform: translateY(0%);
                    }
                    100% {
                        transform: translateY(100%);
                    }
                }`;
            return /*#__PURE__*/ (0, _css.css)(transitionStyle, " ", upStyle, ";", "");
        case "down":
            const downStyle = `
                @keyframes ${styleName}-in {
                    0% {
                        transform: translateY(-100%);
                    }
                    100% {
                        transform: translateY(0%);
                    }
                }
                @keyframes ${styleName}-out {
                    0% {
                        transform: translateY(0%);
                    }
                    100% {
                        transform: translateY(-100%);
                    }
                }`;
            return /*#__PURE__*/ (0, _css.css)(transitionStyle, " ", downStyle, ";", "");
        case "left":
            const leftStyle = `
                @keyframes ${styleName}-in {
                    0% {
                        transform: translateX(100%);
                    }
                    100% {
                        transform: translateX(0%);
                    }
                }

                @keyframes ${styleName}-out {
                    0% {
                        transform: translateX(0%);
                    }
                    100% {
                        transform: translateX(100%);
                    }
                }`;
            return /*#__PURE__*/ (0, _css.css)(transitionStyle, " ", leftStyle, ";", "");
        case "right":
            const rightStyle = `
                @keyframes ${styleName}-in {
                    0% {
                        transform: translateX(-100%);
                    }
                    100% {
                        transform: translateX(0%);
                    }
                }
                @keyframes ${styleName}-out {
                    0% {
                        transform: translateX(0%);
                    }
                    100% {
                        transform: translateX(-100%);
                    }
                }`;
            return /*#__PURE__*/ (0, _css.css)(transitionStyle, " ", rightStyle, ";", "");
    }
    else switch(direction){
        case "up":
        case "down":
            const upDownStyle = `
                @keyframes ${styleName}-in {
                    from {
                        height: 0px;
                    }
                    to {
                        height:calc(100%);
                    }
                }
                @keyframes ${styleName}-out {
                    0% {
                        height:calc(100%);
                    }
                    100% {
                        height: 0px;
                    }
                }`;
            return /*#__PURE__*/ (0, _css.css)(transitionStyle, " ", upDownStyle, ";", "");
        case "left":
        case "right":
            const leftRightStyle = `
                @keyframes ${styleName}-in {
                    from {
                        width: 0px;
                    }
                    to {
                        width:calc(100%);
                    }
                }
                @keyframes ${styleName}-out {
                    0% {
                        width:calc(100%);
                    }
                    100% {
                        width: 0px;
                    }
                }`;
            return /*#__PURE__*/ (0, _css.css)(transitionStyle, " ", leftRightStyle, ";", "");
    }
};
exports.default = SlideInSlideOutComponent;

},{"@emotion/react":"djZKr","react":"6uln9","react-transition-group":"fV67y","@emotion/css":"awUBr","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"fV67y":[function(require,module,exports) {
"use strict";
var _CSSTransitionGroup = require("fda64a9c1892b828");
var _CSSTransitionGroup2 = _interopRequireDefault(_CSSTransitionGroup);
var _TransitionGroup = require("81aff2712114cc63");
var _TransitionGroup2 = _interopRequireDefault(_TransitionGroup);
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
module.exports = {
    TransitionGroup: _TransitionGroup2.default,
    CSSTransitionGroup: _CSSTransitionGroup2.default
};

},{"fda64a9c1892b828":"dXvSx","81aff2712114cc63":"kd3Qv"}],"dXvSx":[function(require,module,exports) {
"use strict";
exports.__esModule = true;
var _extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var _react = require("1e4f0fe92fa01146");
var _react2 = _interopRequireDefault(_react);
var _propTypes = require("aa73625069af1fc1");
var _propTypes2 = _interopRequireDefault(_propTypes);
var _TransitionGroup = require("570b8d3574de430a");
var _TransitionGroup2 = _interopRequireDefault(_TransitionGroup);
var _CSSTransitionGroupChild = require("50e167117fe5bc1c");
var _CSSTransitionGroupChild2 = _interopRequireDefault(_CSSTransitionGroupChild);
var _PropTypes = require("2bc54d644e5bba88");
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var propTypes = {
    transitionName: _PropTypes.nameShape.isRequired,
    transitionAppear: _propTypes2.default.bool,
    transitionEnter: _propTypes2.default.bool,
    transitionLeave: _propTypes2.default.bool,
    transitionAppearTimeout: (0, _PropTypes.transitionTimeout)("Appear"),
    transitionEnterTimeout: (0, _PropTypes.transitionTimeout)("Enter"),
    transitionLeaveTimeout: (0, _PropTypes.transitionTimeout)("Leave")
};
var defaultProps = {
    transitionAppear: false,
    transitionEnter: true,
    transitionLeave: true
};
var CSSTransitionGroup = function(_React$Component) {
    _inherits(CSSTransitionGroup, _React$Component);
    function CSSTransitionGroup() {
        var _temp, _this, _ret;
        _classCallCheck(this, CSSTransitionGroup);
        for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [
            this
        ].concat(args))), _this), _this._wrapChild = function(child) {
            return _react2.default.createElement(_CSSTransitionGroupChild2.default, {
                name: _this.props.transitionName,
                appear: _this.props.transitionAppear,
                enter: _this.props.transitionEnter,
                leave: _this.props.transitionLeave,
                appearTimeout: _this.props.transitionAppearTimeout,
                enterTimeout: _this.props.transitionEnterTimeout,
                leaveTimeout: _this.props.transitionLeaveTimeout
            }, child);
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }
    // We need to provide this childFactory so that
    // ReactCSSTransitionGroupChild can receive updates to name, enter, and
    // leave while it is leaving.
    CSSTransitionGroup.prototype.render = function render() {
        return _react2.default.createElement(_TransitionGroup2.default, _extends({}, this.props, {
            childFactory: this._wrapChild
        }));
    };
    return CSSTransitionGroup;
}(_react2.default.Component);
CSSTransitionGroup.displayName = "CSSTransitionGroup";
CSSTransitionGroup.propTypes = {};
CSSTransitionGroup.defaultProps = defaultProps;
exports.default = CSSTransitionGroup;
module.exports = exports["default"];

},{"1e4f0fe92fa01146":"6uln9","aa73625069af1fc1":"6FKs7","570b8d3574de430a":"kd3Qv","50e167117fe5bc1c":"iuqfx","2bc54d644e5bba88":"kFCQ6"}],"kd3Qv":[function(require,module,exports) {
"use strict";
exports.__esModule = true;
var _extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var _chainFunction = require("8dad941a73982007");
var _chainFunction2 = _interopRequireDefault(_chainFunction);
var _react = require("d1b31126d40f6b7f");
var _react2 = _interopRequireDefault(_react);
var _propTypes = require("ea71fdc70a8c26c7");
var _propTypes2 = _interopRequireDefault(_propTypes);
var _warning = require("7cc1bf5e7f565e38");
var _warning2 = _interopRequireDefault(_warning);
var _ChildMapping = require("32d15fa0a5e99493");
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var propTypes = {
    component: _propTypes2.default.any,
    childFactory: _propTypes2.default.func,
    children: _propTypes2.default.node
};
var defaultProps = {
    component: "span",
    childFactory: function childFactory(child) {
        return child;
    }
};
var TransitionGroup = function(_React$Component) {
    _inherits(TransitionGroup, _React$Component);
    function TransitionGroup(props, context) {
        _classCallCheck(this, TransitionGroup);
        var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));
        _this.performAppear = function(key, component) {
            _this.currentlyTransitioningKeys[key] = true;
            if (component.componentWillAppear) component.componentWillAppear(_this._handleDoneAppearing.bind(_this, key, component));
            else _this._handleDoneAppearing(key, component);
        };
        _this._handleDoneAppearing = function(key, component) {
            if (component.componentDidAppear) component.componentDidAppear();
            delete _this.currentlyTransitioningKeys[key];
            var currentChildMapping = (0, _ChildMapping.getChildMapping)(_this.props.children);
            if (!currentChildMapping || !currentChildMapping.hasOwnProperty(key)) // This was removed before it had fully appeared. Remove it.
            _this.performLeave(key, component);
        };
        _this.performEnter = function(key, component) {
            _this.currentlyTransitioningKeys[key] = true;
            if (component.componentWillEnter) component.componentWillEnter(_this._handleDoneEntering.bind(_this, key, component));
            else _this._handleDoneEntering(key, component);
        };
        _this._handleDoneEntering = function(key, component) {
            if (component.componentDidEnter) component.componentDidEnter();
            delete _this.currentlyTransitioningKeys[key];
            var currentChildMapping = (0, _ChildMapping.getChildMapping)(_this.props.children);
            if (!currentChildMapping || !currentChildMapping.hasOwnProperty(key)) // This was removed before it had fully entered. Remove it.
            _this.performLeave(key, component);
        };
        _this.performLeave = function(key, component) {
            _this.currentlyTransitioningKeys[key] = true;
            if (component.componentWillLeave) component.componentWillLeave(_this._handleDoneLeaving.bind(_this, key, component));
            else // Note that this is somewhat dangerous b/c it calls setState()
            // again, effectively mutating the component before all the work
            // is done.
            _this._handleDoneLeaving(key, component);
        };
        _this._handleDoneLeaving = function(key, component) {
            if (component.componentDidLeave) component.componentDidLeave();
            delete _this.currentlyTransitioningKeys[key];
            var currentChildMapping = (0, _ChildMapping.getChildMapping)(_this.props.children);
            if (currentChildMapping && currentChildMapping.hasOwnProperty(key)) // This entered again before it fully left. Add it again.
            _this.keysToEnter.push(key);
            else _this.setState(function(state) {
                var newChildren = _extends({}, state.children);
                delete newChildren[key];
                return {
                    children: newChildren
                };
            });
        };
        _this.childRefs = Object.create(null);
        _this.state = {
            children: (0, _ChildMapping.getChildMapping)(props.children)
        };
        return _this;
    }
    TransitionGroup.prototype.componentWillMount = function componentWillMount() {
        this.currentlyTransitioningKeys = {};
        this.keysToEnter = [];
        this.keysToLeave = [];
    };
    TransitionGroup.prototype.componentDidMount = function componentDidMount() {
        var initialChildMapping = this.state.children;
        for(var key in initialChildMapping)if (initialChildMapping[key]) this.performAppear(key, this.childRefs[key]);
    };
    TransitionGroup.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
        var nextChildMapping = (0, _ChildMapping.getChildMapping)(nextProps.children);
        var prevChildMapping = this.state.children;
        this.setState({
            children: (0, _ChildMapping.mergeChildMappings)(prevChildMapping, nextChildMapping)
        });
        for(var key in nextChildMapping){
            var hasPrev = prevChildMapping && prevChildMapping.hasOwnProperty(key);
            if (nextChildMapping[key] && !hasPrev && !this.currentlyTransitioningKeys[key]) this.keysToEnter.push(key);
        }
        for(var _key in prevChildMapping){
            var hasNext = nextChildMapping && nextChildMapping.hasOwnProperty(_key);
            if (prevChildMapping[_key] && !hasNext && !this.currentlyTransitioningKeys[_key]) this.keysToLeave.push(_key);
        }
    // If we want to someday check for reordering, we could do it here.
    };
    TransitionGroup.prototype.componentDidUpdate = function componentDidUpdate() {
        var _this2 = this;
        var keysToEnter = this.keysToEnter;
        this.keysToEnter = [];
        keysToEnter.forEach(function(key) {
            return _this2.performEnter(key, _this2.childRefs[key]);
        });
        var keysToLeave = this.keysToLeave;
        this.keysToLeave = [];
        keysToLeave.forEach(function(key) {
            return _this2.performLeave(key, _this2.childRefs[key]);
        });
    };
    TransitionGroup.prototype.render = function render() {
        var _this3 = this;
        // TODO: we could get rid of the need for the wrapper node
        // by cloning a single child
        var childrenToRender = [];
        var _loop = function _loop(key) {
            var child = _this3.state.children[key];
            if (child) {
                var isCallbackRef = typeof child.ref !== "string";
                var factoryChild = _this3.props.childFactory(child);
                var ref = function ref(r) {
                    _this3.childRefs[key] = r;
                };
                // Always chaining the refs leads to problems when the childFactory
                // wraps the child. The child ref callback gets called twice with the
                // wrapper and the child. So we only need to chain the ref if the
                // factoryChild is not different from child.
                if (factoryChild === child && isCallbackRef) ref = (0, _chainFunction2.default)(child.ref, ref);
                // You may need to apply reactive updates to a child as it is leaving.
                // The normal React way to do it won't work since the child will have
                // already been removed. In case you need this behavior you can provide
                // a childFactory function to wrap every child, even the ones that are
                // leaving.
                childrenToRender.push(_react2.default.cloneElement(factoryChild, {
                    key: key,
                    ref: ref
                }));
            }
        };
        for(var key in this.state.children)_loop(key);
        // Do not forward TransitionGroup props to primitive DOM nodes
        var props = _extends({}, this.props);
        delete props.transitionLeave;
        delete props.transitionName;
        delete props.transitionAppear;
        delete props.transitionEnter;
        delete props.childFactory;
        delete props.transitionLeaveTimeout;
        delete props.transitionEnterTimeout;
        delete props.transitionAppearTimeout;
        delete props.component;
        return _react2.default.createElement(this.props.component, props, childrenToRender);
    };
    return TransitionGroup;
}(_react2.default.Component);
TransitionGroup.displayName = "TransitionGroup";
TransitionGroup.propTypes = {};
TransitionGroup.defaultProps = defaultProps;
exports.default = TransitionGroup;
module.exports = exports["default"];

},{"8dad941a73982007":"f5PAF","d1b31126d40f6b7f":"6uln9","ea71fdc70a8c26c7":"6FKs7","7cc1bf5e7f565e38":"GFGAI","32d15fa0a5e99493":"eqyvC"}],"f5PAF":[function(require,module,exports) {
module.exports = function chain() {
    var len = arguments.length;
    var args = [];
    for(var i = 0; i < len; i++)args[i] = arguments[i];
    args = args.filter(function(fn) {
        return fn != null;
    });
    if (args.length === 0) return undefined;
    if (args.length === 1) return args[0];
    return args.reduce(function(current, next) {
        return function chainedFunction() {
            current.apply(this, arguments);
            next.apply(this, arguments);
        };
    });
};

},{}],"GFGAI":[function(require,module,exports) {
/**
 * Copyright 2014-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */ "use strict";
/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */ var warning = function() {};
module.exports = warning;

},{}],"eqyvC":[function(require,module,exports) {
"use strict";
exports.__esModule = true;
exports.getChildMapping = getChildMapping;
exports.mergeChildMappings = mergeChildMappings;
var _react = require("2eefadd3c8f0650c");
/**
 * Given `this.props.children`, return an object mapping key to child.
 *
 * @param {*} children `this.props.children`
 * @return {object} Mapping of key to child
 */ function getChildMapping(children) {
    if (!children) return children;
    var result = {};
    _react.Children.map(children, function(child) {
        return child;
    }).forEach(function(child) {
        result[child.key] = child;
    });
    return result;
}
/**
 * When you're adding or removing children some may be added or removed in the
 * same render pass. We want to show *both* since we want to simultaneously
 * animate elements in and out. This function takes a previous set of keys
 * and a new set of keys and merges them with its best guess of the correct
 * ordering. In the future we may expose some of the utilities in
 * ReactMultiChild to make this easy, but for now React itself does not
 * directly have this concept of the union of prevChildren and nextChildren
 * so we implement it here.
 *
 * @param {object} prev prev children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @param {object} next next children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @return {object} a key set that contains all keys in `prev` and all keys
 * in `next` in a reasonable order.
 */ function mergeChildMappings(prev, next) {
    prev = prev || {};
    next = next || {};
    function getValueForKey(key) {
        if (next.hasOwnProperty(key)) return next[key];
        return prev[key];
    }
    // For each key of `next`, the list of keys to insert before that key in
    // the combined list
    var nextKeysPending = {};
    var pendingKeys = [];
    for(var prevKey in prev){
        if (next.hasOwnProperty(prevKey)) {
            if (pendingKeys.length) {
                nextKeysPending[prevKey] = pendingKeys;
                pendingKeys = [];
            }
        } else pendingKeys.push(prevKey);
    }
    var i = void 0;
    var childMapping = {};
    for(var nextKey in next){
        if (nextKeysPending.hasOwnProperty(nextKey)) for(i = 0; i < nextKeysPending[nextKey].length; i++){
            var pendingNextKey = nextKeysPending[nextKey][i];
            childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
        }
        childMapping[nextKey] = getValueForKey(nextKey);
    }
    // Finally, add the keys which didn't appear before any key in `next`
    for(i = 0; i < pendingKeys.length; i++)childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
    return childMapping;
}

},{"2eefadd3c8f0650c":"6uln9"}],"iuqfx":[function(require,module,exports) {
"use strict";
exports.__esModule = true;
var _extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var _addClass = require("dc5d8bb261625282");
var _addClass2 = _interopRequireDefault(_addClass);
var _removeClass = require("c828e0e970b5bb46");
var _removeClass2 = _interopRequireDefault(_removeClass);
var _requestAnimationFrame = require("bbdf0fe415e02b8a");
var _requestAnimationFrame2 = _interopRequireDefault(_requestAnimationFrame);
var _properties = require("70d0890a950b3d3b");
var _react = require("4c374d77212e0d4c");
var _react2 = _interopRequireDefault(_react);
var _propTypes = require("931cf762d3756507");
var _propTypes2 = _interopRequireDefault(_propTypes);
var _reactDom = require("4320dd8f05bd3b1e");
var _PropTypes = require("715c04d31bd5ee9a");
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var events = [];
if (_properties.transitionEnd) events.push(_properties.transitionEnd);
if (_properties.animationEnd) events.push(_properties.animationEnd);
function addEndListener(node, listener) {
    if (events.length) events.forEach(function(e) {
        return node.addEventListener(e, listener, false);
    });
    else setTimeout(listener, 0);
    return function() {
        if (!events.length) return;
        events.forEach(function(e) {
            return node.removeEventListener(e, listener, false);
        });
    };
}
var propTypes = {
    children: _propTypes2.default.node,
    name: _PropTypes.nameShape.isRequired,
    // Once we require timeouts to be specified, we can remove the
    // boolean flags (appear etc.) and just accept a number
    // or a bool for the timeout flags (appearTimeout etc.)
    appear: _propTypes2.default.bool,
    enter: _propTypes2.default.bool,
    leave: _propTypes2.default.bool,
    appearTimeout: _propTypes2.default.number,
    enterTimeout: _propTypes2.default.number,
    leaveTimeout: _propTypes2.default.number
};
var CSSTransitionGroupChild = function(_React$Component) {
    _inherits(CSSTransitionGroupChild, _React$Component);
    function CSSTransitionGroupChild() {
        var _temp, _this, _ret;
        _classCallCheck(this, CSSTransitionGroupChild);
        for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [
            this
        ].concat(args))), _this), _this.componentWillAppear = function(done) {
            if (_this.props.appear) _this.transition("appear", done, _this.props.appearTimeout);
            else done();
        }, _this.componentWillEnter = function(done) {
            if (_this.props.enter) _this.transition("enter", done, _this.props.enterTimeout);
            else done();
        }, _this.componentWillLeave = function(done) {
            if (_this.props.leave) _this.transition("leave", done, _this.props.leaveTimeout);
            else done();
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }
    CSSTransitionGroupChild.prototype.componentWillMount = function componentWillMount() {
        this.classNameAndNodeQueue = [];
        this.transitionTimeouts = [];
    };
    CSSTransitionGroupChild.prototype.componentWillUnmount = function componentWillUnmount() {
        this.unmounted = true;
        if (this.timeout) clearTimeout(this.timeout);
        this.transitionTimeouts.forEach(function(timeout) {
            clearTimeout(timeout);
        });
        this.classNameAndNodeQueue.length = 0;
    };
    CSSTransitionGroupChild.prototype.transition = function transition(animationType, finishCallback, timeout) {
        var node = (0, _reactDom.findDOMNode)(this);
        if (!node) {
            if (finishCallback) finishCallback();
            return;
        }
        var className = this.props.name[animationType] || this.props.name + "-" + animationType;
        var activeClassName = this.props.name[animationType + "Active"] || className + "-active";
        var timer = null;
        var removeListeners = void 0;
        (0, _addClass2.default)(node, className);
        // Need to do this to actually trigger a transition.
        this.queueClassAndNode(activeClassName, node);
        // Clean-up the animation after the specified delay
        var finish = function finish(e) {
            if (e && e.target !== node) return;
            clearTimeout(timer);
            if (removeListeners) removeListeners();
            (0, _removeClass2.default)(node, className);
            (0, _removeClass2.default)(node, activeClassName);
            if (removeListeners) removeListeners();
            // Usually this optional callback is used for informing an owner of
            // a leave animation and telling it to remove the child.
            if (finishCallback) finishCallback();
        };
        if (timeout) {
            timer = setTimeout(finish, timeout);
            this.transitionTimeouts.push(timer);
        } else if (_properties.transitionEnd) removeListeners = addEndListener(node, finish);
    };
    CSSTransitionGroupChild.prototype.queueClassAndNode = function queueClassAndNode(className, node) {
        var _this2 = this;
        this.classNameAndNodeQueue.push({
            className: className,
            node: node
        });
        if (!this.rafHandle) this.rafHandle = (0, _requestAnimationFrame2.default)(function() {
            return _this2.flushClassNameAndNodeQueue();
        });
    };
    CSSTransitionGroupChild.prototype.flushClassNameAndNodeQueue = function flushClassNameAndNodeQueue() {
        if (!this.unmounted) this.classNameAndNodeQueue.forEach(function(obj) {
            // This is for to force a repaint,
            // which is necessary in order to transition styles when adding a class name.
            /* eslint-disable no-unused-expressions */ obj.node.scrollTop;
            /* eslint-enable no-unused-expressions */ (0, _addClass2.default)(obj.node, obj.className);
        });
        this.classNameAndNodeQueue.length = 0;
        this.rafHandle = null;
    };
    CSSTransitionGroupChild.prototype.render = function render() {
        var props = _extends({}, this.props);
        delete props.name;
        delete props.appear;
        delete props.enter;
        delete props.leave;
        delete props.appearTimeout;
        delete props.enterTimeout;
        delete props.leaveTimeout;
        delete props.children;
        return _react2.default.cloneElement(_react2.default.Children.only(this.props.children), props);
    };
    return CSSTransitionGroupChild;
}(_react2.default.Component);
CSSTransitionGroupChild.displayName = "CSSTransitionGroupChild";
CSSTransitionGroupChild.propTypes = {};
exports.default = CSSTransitionGroupChild;
module.exports = exports["default"];

},{"dc5d8bb261625282":"gmJxq","c828e0e970b5bb46":"9pRPv","bbdf0fe415e02b8a":"fwHlz","70d0890a950b3d3b":"iUGXU","4c374d77212e0d4c":"6uln9","931cf762d3756507":"6FKs7","4320dd8f05bd3b1e":"b8T3j","715c04d31bd5ee9a":"kFCQ6"}],"gmJxq":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("83d9c75d32c0a1d3");
exports.__esModule = true;
exports.default = addClass;
var _hasClass = _interopRequireDefault(require("24b3690f1e6a7032"));
function addClass(element, className) {
    if (element.classList) element.classList.add(className);
    else if (!(0, _hasClass.default)(element, className)) {
        if (typeof element.className === "string") element.className = element.className + " " + className;
        else element.setAttribute("class", (element.className && element.className.baseVal || "") + " " + className);
    }
}
module.exports = exports["default"];

},{"83d9c75d32c0a1d3":"9pqfn","24b3690f1e6a7032":"1WpQO"}],"9pqfn":[function(require,module,exports) {
function _interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
module.exports = _interopRequireDefault, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{}],"1WpQO":[function(require,module,exports) {
"use strict";
exports.__esModule = true;
exports.default = hasClass;
function hasClass(element, className) {
    if (element.classList) return !!className && element.classList.contains(className);
    else return (" " + (element.className.baseVal || element.className) + " ").indexOf(" " + className + " ") !== -1;
}
module.exports = exports["default"];

},{}],"9pRPv":[function(require,module,exports) {
"use strict";
function replaceClassName(origClass, classToRemove) {
    return origClass.replace(new RegExp("(^|\\s)" + classToRemove + "(?:\\s|$)", "g"), "$1").replace(/\s+/g, " ").replace(/^\s*|\s*$/g, "");
}
module.exports = function removeClass(element, className) {
    if (element.classList) element.classList.remove(className);
    else if (typeof element.className === "string") element.className = replaceClassName(element.className, className);
    else element.setAttribute("class", replaceClassName(element.className && element.className.baseVal || "", className));
};

},{}],"fwHlz":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("b74092849b68b140");
exports.__esModule = true;
exports.default = void 0;
var _inDOM = _interopRequireDefault(require("872bdb8db0d0054d"));
var vendors = [
    "",
    "webkit",
    "moz",
    "o",
    "ms"
];
var cancel = "clearTimeout";
var raf = fallback;
var compatRaf;
var getKey = function getKey(vendor, k) {
    return vendor + (!vendor ? k : k[0].toUpperCase() + k.substr(1)) + "AnimationFrame";
};
if (_inDOM.default) vendors.some(function(vendor) {
    var rafKey = getKey(vendor, "request");
    if (rafKey in window) {
        cancel = getKey(vendor, "cancel");
        return raf = function raf(cb) {
            return window[rafKey](cb);
        };
    }
});
/* https://github.com/component/raf */ var prev = new Date().getTime();
function fallback(fn) {
    var curr = new Date().getTime(), ms = Math.max(0, 16 - (curr - prev)), req = setTimeout(fn, ms);
    prev = curr;
    return req;
}
compatRaf = function compatRaf(cb) {
    return raf(cb);
};
compatRaf.cancel = function(id) {
    window[cancel] && typeof window[cancel] === "function" && window[cancel](id);
};
var _default = compatRaf;
exports.default = _default;
module.exports = exports["default"];

},{"b74092849b68b140":"9pqfn","872bdb8db0d0054d":"hbSCd"}],"hbSCd":[function(require,module,exports) {
"use strict";
exports.__esModule = true;
exports.default = void 0;
var _default = !!(typeof window !== "undefined" && window.document && window.document.createElement);
exports.default = _default;
module.exports = exports["default"];

},{}],"iUGXU":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("769e1c9083a8fa89");
exports.__esModule = true;
exports.default = exports.animationEnd = exports.animationDelay = exports.animationTiming = exports.animationDuration = exports.animationName = exports.transitionEnd = exports.transitionDuration = exports.transitionDelay = exports.transitionTiming = exports.transitionProperty = exports.transform = void 0;
var _inDOM = _interopRequireDefault(require("e25bb2d8f265a758"));
var transform = "transform";
exports.transform = transform;
var prefix, transitionEnd, animationEnd;
exports.animationEnd = animationEnd;
exports.transitionEnd = transitionEnd;
var transitionProperty, transitionDuration, transitionTiming, transitionDelay;
exports.transitionDelay = transitionDelay;
exports.transitionTiming = transitionTiming;
exports.transitionDuration = transitionDuration;
exports.transitionProperty = transitionProperty;
var animationName, animationDuration, animationTiming, animationDelay;
exports.animationDelay = animationDelay;
exports.animationTiming = animationTiming;
exports.animationDuration = animationDuration;
exports.animationName = animationName;
if (_inDOM.default) {
    var _getTransitionPropert = getTransitionProperties();
    prefix = _getTransitionPropert.prefix;
    exports.transitionEnd = transitionEnd = _getTransitionPropert.transitionEnd;
    exports.animationEnd = animationEnd = _getTransitionPropert.animationEnd;
    exports.transform = transform = prefix + "-" + transform;
    exports.transitionProperty = transitionProperty = prefix + "-transition-property";
    exports.transitionDuration = transitionDuration = prefix + "-transition-duration";
    exports.transitionDelay = transitionDelay = prefix + "-transition-delay";
    exports.transitionTiming = transitionTiming = prefix + "-transition-timing-function";
    exports.animationName = animationName = prefix + "-animation-name";
    exports.animationDuration = animationDuration = prefix + "-animation-duration";
    exports.animationTiming = animationTiming = prefix + "-animation-delay";
    exports.animationDelay = animationDelay = prefix + "-animation-timing-function";
}
var _default = {
    transform: transform,
    end: transitionEnd,
    property: transitionProperty,
    timing: transitionTiming,
    delay: transitionDelay,
    duration: transitionDuration
};
exports.default = _default;
function getTransitionProperties() {
    var style = document.createElement("div").style;
    var vendorMap = {
        O: function O(e) {
            return "o" + e.toLowerCase();
        },
        Moz: function Moz(e) {
            return e.toLowerCase();
        },
        Webkit: function Webkit(e) {
            return "webkit" + e;
        },
        ms: function ms(e) {
            return "MS" + e;
        }
    };
    var vendors = Object.keys(vendorMap);
    var transitionEnd, animationEnd;
    var prefix = "";
    for(var i = 0; i < vendors.length; i++){
        var vendor = vendors[i];
        if (vendor + "TransitionProperty" in style) {
            prefix = "-" + vendor.toLowerCase();
            transitionEnd = vendorMap[vendor]("TransitionEnd");
            animationEnd = vendorMap[vendor]("AnimationEnd");
            break;
        }
    }
    if (!transitionEnd && "transitionProperty" in style) transitionEnd = "transitionend";
    if (!animationEnd && "animationName" in style) animationEnd = "animationend";
    style = null;
    return {
        animationEnd: animationEnd,
        transitionEnd: transitionEnd,
        prefix: prefix
    };
}

},{"769e1c9083a8fa89":"9pqfn","e25bb2d8f265a758":"hbSCd"}],"kFCQ6":[function(require,module,exports) {
"use strict";
exports.__esModule = true;
exports.nameShape = undefined;
exports.transitionTimeout = transitionTimeout;
var _react = require("cbedbdf89cee590d");
var _react2 = _interopRequireDefault(_react);
var _propTypes = require("88979095401343ce");
var _propTypes2 = _interopRequireDefault(_propTypes);
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function transitionTimeout(transitionType) {
    var timeoutPropName = "transition" + transitionType + "Timeout";
    var enabledPropName = "transition" + transitionType;
    return function(props) {
        // If the transition is enabled
        if (props[enabledPropName]) {
            // If no timeout duration is provided
            if (props[timeoutPropName] == null) return new Error(timeoutPropName + " wasn't supplied to CSSTransitionGroup: " + "this can cause unreliable animations and won't be supported in " + "a future version of React. See " + "https://fb.me/react-animation-transition-group-timeout for more " + "information.");
            else if (typeof props[timeoutPropName] !== "number") return new Error(timeoutPropName + " must be a number (in milliseconds)");
        }
        return null;
    };
}
var nameShape = exports.nameShape = _propTypes2.default.oneOfType([
    _propTypes2.default.string,
    _propTypes2.default.shape({
        enter: _propTypes2.default.string,
        leave: _propTypes2.default.string,
        active: _propTypes2.default.string
    }),
    _propTypes2.default.shape({
        enter: _propTypes2.default.string,
        enterActive: _propTypes2.default.string,
        leave: _propTypes2.default.string,
        leaveActive: _propTypes2.default.string,
        appear: _propTypes2.default.string,
        appearActive: _propTypes2.default.string
    })
]);

},{"cbedbdf89cee590d":"6uln9","88979095401343ce":"6FKs7"}],"9Gz1L":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
const useIsMobile = ()=>{
    const [isMobile, setIsMobile] = (0, _react.useState)(false);
    (0, _react.useEffect)(()=>{
        const checkIsMobile = ()=>{
            setIsMobile(window.innerWidth < 768);
        };
        checkIsMobile();
        window.addEventListener("resize", checkIsMobile);
        return ()=>{
            window.removeEventListener("resize", checkIsMobile);
        };
    }, []);
    return isMobile;
};
exports.default = useIsMobile;

},{"react":"6uln9","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"dWwQJ":[function(require,module,exports) {
module.exports = require("c943b2d74d8f790c").getBundleURL("kVLro") + require("9c343738119c9010").resolve("i6RKu");

},{"c943b2d74d8f790c":"c7Tr5","9c343738119c9010":"fyJL2"}],"iDHIJ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _css = require("@emotion/css");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _reactTabs = require("react-tabs");
var _colors = require("../../../constants/colors");
var _panelHeaderContainer = require("./PanelHeaderContainer");
var _panelHeaderContainerDefault = parcelHelpers.interopDefault(_panelHeaderContainer);
var _panelIconTab = require("./PanelIconTab");
var _panelIconTabDefault = parcelHelpers.interopDefault(_panelIconTab);
// used for containing data in the form style card
const TabContainerPanel = (props)=>{
    function renderTab(tab, index) {
        return (0, _panelIconTabDefault.default)({
            tab: tab,
            index: index,
            selectedIndex: props.selectedIndex
        });
    }
    return (0, _react.jsx)("div", {
        className: `${panelStyle} ${props.className != null ? props.className : ""}`
    }, (0, _react.jsx)((0, _reactTabs.Tabs), {
        forceRenderTabPanel: props.forceRenderTabPanel,
        defaultIndex: props.selectedIndex,
        onSelect: props.onTabSelected
    }, (0, _react.jsx)((0, _panelHeaderContainerDefault.default), null, (0, _react.jsx)((0, _reactTabs.TabList), {
        className: "panel-tab-list"
    }, props.tabs.map(renderTab)), props.additionalHeaderContent ? props.additionalHeaderContent() : null), props.children));
};
const panelStyle = /*#__PURE__*/ (0, _css.css)("position:relative;font-family:Muli;font-weight:normal;font-style:normal;font-stretch:normal;line-height:normal;letter-spacing:normal;color:", (0, _colors.dark_grey_blue), ";overflow:hidden;flex:1;.panel-tab-list{color:white;list-style-type:none;display:flex;align-items:center;margin-left:28px;}", "");
exports.default = TabContainerPanel;

},{"@emotion/react":"djZKr","@emotion/css":"awUBr","react":"6uln9","react-tabs":"92Sgf","../../../constants/colors":"1p3OR","./PanelHeaderContainer":"hUotd","./PanelIconTab":"1Stt2","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hUotd":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _colors = require("../../../constants/colors");
const PanelHeaderContainer = (props)=>(0, _react.jsx)("div", {
        className: `${headerStyle} ${props.className ?? ""} panel-header`
    }, props.children);
const headerStyle = /*#__PURE__*/ (0, _css.css)("height:56px;width:100%;background-color:white;top:0;display:flex;align-items:center;justify-content:flex-start;z-index:100;border-bottom:1px solid ", (0, _colors.color_shades_dark), ";", "");
exports.default = PanelHeaderContainer;

},{"@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","../../../constants/colors":"1p3OR","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1Stt2":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _reactTabs = require("react-tabs");
var _colors = require("../../../constants/colors");
function PanelIconTab(props) {
    return (0, _react.jsx)((0, _reactTabs.Tab), {
        key: props.index,
        selectedClassName: activeTabStyle,
        className: `${tabStyle} ${props.className ? props.className : ""}`
    }, (0, _react.jsx)("div", {
        className: `tab-wrapper ${props.tab.className ?? ""}`
    }, (0, _react.jsx)("div", {
        className: "tab-content"
    }, (0, _react.jsx)("img", {
        className: "tab-icon",
        src: props.selectedIndex == props.index ? props.tab.selectedIcon : props.tab.icon
    }), (0, _react.jsx)("p", null, props.tab.title))));
}
const tabStyle = /*#__PURE__*/ (0, _css.css)("color:black;cursor:pointer;flex-grow:1;align-items:center;margin:0 4px;background:white;color:", (0, _colors.color_shades_darkest), ";min-width:80px;flex:0;.tab-wrapper{display:flex;align-items:center;}.tab-content{min-width:48px;flex-grow:1;display:flex;flex-direction:column;align-items:center;justify-content:center;height:54px;p{font-family:Muli;font-style:normal;font-weight:normal;font-size:10px;line-height:16px;color:", (0, _colors.color_text_default), ";text-align:center;}img{width:24px;height:auto;}}.tab-indicator{display:none;flex-grow:0;flex-shrink:0;}", "");
const activeTabStyle = /*#__PURE__*/ (0, _css.css)("background-color:", (0, _colors.color_variants_ocean_light_opaque), ";>.tab-indicator{display:block;}.tab-content{p{color:", (0, _colors.color_text_link), ";}}", "");
exports.default = PanelIconTab;

},{"@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","react-tabs":"92Sgf","../../../constants/colors":"1p3OR","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6LRg3":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _customScrollbars = require("./CustomScrollbars");
var _customScrollbarsDefault = parcelHelpers.interopDefault(_customScrollbars);
// note: .scrollable-panel is used for auto scroll, not css. Don't use it to override styles
const ScrollablePanelBody = (props)=>(0, _react.jsx)((0, _customScrollbarsDefault.default), {
        autoHide: true,
        autoHeight: props.autoHeight,
        autoHeightMax: props.autoHeightMax,
        className: "scrollable-panel"
    }, (0, _react.jsx)("div", {
        className: props.className
    }, props.children));
exports.default = ScrollablePanelBody;

},{"@emotion/react":"djZKr","react":"6uln9","./CustomScrollbars":"50vFq","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"50vFq":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _extends = require("@babel/runtime/helpers/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _reactCustomScrollbars = require("react-custom-scrollbars");
var _reactCustomScrollbarsDefault = parcelHelpers.interopDefault(_reactCustomScrollbars);
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const CustomScrollbars = /*#__PURE__*/ (0, _react1.forwardRef)((props, ref)=>{
    const { hideHorizontalScrollbar, ...scrollbarProps } = props;
    return (0, _react.jsx)((0, _reactCustomScrollbarsDefault.default), (0, _extendsDefault.default)({}, scrollbarProps, {
        ref: ref,
        style: props.style,
        autoHide: false,
        className: `${scrollBarStyle} ${props.autoHide === true ? "auto-hide" : ""} ${hideHorizontalScrollbar ? "hide-horizontal" : ""} ${props.className ?? ""} scrollbars-class`,
        renderTrackHorizontal: hideHorizontalScrollbar ? ()=>(0, _react.jsx)("div", {
                style: {
                    display: "none"
                }
            }) : scrollbarProps.renderTrackHorizontal
    }), props.children);
});
const scrollBarStyle = /*#__PURE__*/ (0, _css.css)({
    name: "5r6y9a",
    styles: "&.auto-hide>div:last-child{opacity:0;transition:opacity 200ms ease;}&.auto-hide:hover>div:last-child{opacity:1;}&.hide-horizontal{overflow-x:hidden;}&.hide-horizontal>div:first-child{overflow-x:hidden;}"
});
exports.default = CustomScrollbars;

},{"@babel/runtime/helpers/extends":"4iKIP","@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","react-custom-scrollbars":"f2YFt","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"f2YFt":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Scrollbars = undefined;
var _Scrollbars = require("103a7f8070172758");
var _Scrollbars2 = _interopRequireDefault(_Scrollbars);
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
exports["default"] = _Scrollbars2["default"];
exports.Scrollbars = _Scrollbars2["default"];

},{"103a7f8070172758":"jfOZ5"}],"jfOZ5":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var _createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
var _raf2 = require("d0b882c79745acde");
var _raf3 = _interopRequireDefault(_raf2);
var _domCss = require("d7082902849b5515");
var _domCss2 = _interopRequireDefault(_domCss);
var _react = require("5e12b9153aacfeb0");
var _propTypes = require("2424184a1a5de37d");
var _propTypes2 = _interopRequireDefault(_propTypes);
var _isString = require("60c48c25ec69da64");
var _isString2 = _interopRequireDefault(_isString);
var _getScrollbarWidth = require("5881d76f2c1baea7");
var _getScrollbarWidth2 = _interopRequireDefault(_getScrollbarWidth);
var _returnFalse = require("15ec1958ab6e1253");
var _returnFalse2 = _interopRequireDefault(_returnFalse);
var _getInnerWidth = require("1e932bba60e3d01");
var _getInnerWidth2 = _interopRequireDefault(_getInnerWidth);
var _getInnerHeight = require("7425d2b5c95904bf");
var _getInnerHeight2 = _interopRequireDefault(_getInnerHeight);
var _styles = require("ef274a620d3449c2");
var _defaultRenderElements = require("63b538f7d762960a");
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function _objectWithoutProperties(obj, keys) {
    var target = {};
    for(var i in obj){
        if (keys.indexOf(i) >= 0) continue;
        if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
        target[i] = obj[i];
    }
    return target;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var Scrollbars = function(_Component) {
    _inherits(Scrollbars, _Component);
    function Scrollbars(props) {
        var _ref;
        _classCallCheck(this, Scrollbars);
        for(var _len = arguments.length, rest = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)rest[_key - 1] = arguments[_key];
        var _this = _possibleConstructorReturn(this, (_ref = Scrollbars.__proto__ || Object.getPrototypeOf(Scrollbars)).call.apply(_ref, [
            this,
            props
        ].concat(rest)));
        _this.getScrollLeft = _this.getScrollLeft.bind(_this);
        _this.getScrollTop = _this.getScrollTop.bind(_this);
        _this.getScrollWidth = _this.getScrollWidth.bind(_this);
        _this.getScrollHeight = _this.getScrollHeight.bind(_this);
        _this.getClientWidth = _this.getClientWidth.bind(_this);
        _this.getClientHeight = _this.getClientHeight.bind(_this);
        _this.getValues = _this.getValues.bind(_this);
        _this.getThumbHorizontalWidth = _this.getThumbHorizontalWidth.bind(_this);
        _this.getThumbVerticalHeight = _this.getThumbVerticalHeight.bind(_this);
        _this.getScrollLeftForOffset = _this.getScrollLeftForOffset.bind(_this);
        _this.getScrollTopForOffset = _this.getScrollTopForOffset.bind(_this);
        _this.scrollLeft = _this.scrollLeft.bind(_this);
        _this.scrollTop = _this.scrollTop.bind(_this);
        _this.scrollToLeft = _this.scrollToLeft.bind(_this);
        _this.scrollToTop = _this.scrollToTop.bind(_this);
        _this.scrollToRight = _this.scrollToRight.bind(_this);
        _this.scrollToBottom = _this.scrollToBottom.bind(_this);
        _this.handleTrackMouseEnter = _this.handleTrackMouseEnter.bind(_this);
        _this.handleTrackMouseLeave = _this.handleTrackMouseLeave.bind(_this);
        _this.handleHorizontalTrackMouseDown = _this.handleHorizontalTrackMouseDown.bind(_this);
        _this.handleVerticalTrackMouseDown = _this.handleVerticalTrackMouseDown.bind(_this);
        _this.handleHorizontalThumbMouseDown = _this.handleHorizontalThumbMouseDown.bind(_this);
        _this.handleVerticalThumbMouseDown = _this.handleVerticalThumbMouseDown.bind(_this);
        _this.handleWindowResize = _this.handleWindowResize.bind(_this);
        _this.handleScroll = _this.handleScroll.bind(_this);
        _this.handleDrag = _this.handleDrag.bind(_this);
        _this.handleDragEnd = _this.handleDragEnd.bind(_this);
        _this.state = {
            didMountUniversal: false
        };
        return _this;
    }
    _createClass(Scrollbars, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this.addListeners();
                this.update();
                this.componentDidMountUniversal();
            }
        },
        {
            key: "componentDidMountUniversal",
            value: function componentDidMountUniversal() {
                // eslint-disable-line react/sort-comp
                var universal = this.props.universal;
                if (!universal) return;
                this.setState({
                    didMountUniversal: true
                });
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate() {
                this.update();
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this.removeListeners();
                (0, _raf2.cancel)(this.requestFrame);
                clearTimeout(this.hideTracksTimeout);
                clearInterval(this.detectScrollingInterval);
            }
        },
        {
            key: "getScrollLeft",
            value: function getScrollLeft() {
                if (!this.view) return 0;
                return this.view.scrollLeft;
            }
        },
        {
            key: "getScrollTop",
            value: function getScrollTop() {
                if (!this.view) return 0;
                return this.view.scrollTop;
            }
        },
        {
            key: "getScrollWidth",
            value: function getScrollWidth() {
                if (!this.view) return 0;
                return this.view.scrollWidth;
            }
        },
        {
            key: "getScrollHeight",
            value: function getScrollHeight() {
                if (!this.view) return 0;
                return this.view.scrollHeight;
            }
        },
        {
            key: "getClientWidth",
            value: function getClientWidth() {
                if (!this.view) return 0;
                return this.view.clientWidth;
            }
        },
        {
            key: "getClientHeight",
            value: function getClientHeight() {
                if (!this.view) return 0;
                return this.view.clientHeight;
            }
        },
        {
            key: "getValues",
            value: function getValues() {
                var _ref2 = this.view || {}, _ref2$scrollLeft = _ref2.scrollLeft, scrollLeft = _ref2$scrollLeft === undefined ? 0 : _ref2$scrollLeft, _ref2$scrollTop = _ref2.scrollTop, scrollTop = _ref2$scrollTop === undefined ? 0 : _ref2$scrollTop, _ref2$scrollWidth = _ref2.scrollWidth, scrollWidth = _ref2$scrollWidth === undefined ? 0 : _ref2$scrollWidth, _ref2$scrollHeight = _ref2.scrollHeight, scrollHeight = _ref2$scrollHeight === undefined ? 0 : _ref2$scrollHeight, _ref2$clientWidth = _ref2.clientWidth, clientWidth = _ref2$clientWidth === undefined ? 0 : _ref2$clientWidth, _ref2$clientHeight = _ref2.clientHeight, clientHeight = _ref2$clientHeight === undefined ? 0 : _ref2$clientHeight;
                return {
                    left: scrollLeft / (scrollWidth - clientWidth) || 0,
                    top: scrollTop / (scrollHeight - clientHeight) || 0,
                    scrollLeft: scrollLeft,
                    scrollTop: scrollTop,
                    scrollWidth: scrollWidth,
                    scrollHeight: scrollHeight,
                    clientWidth: clientWidth,
                    clientHeight: clientHeight
                };
            }
        },
        {
            key: "getThumbHorizontalWidth",
            value: function getThumbHorizontalWidth() {
                var _props = this.props, thumbSize = _props.thumbSize, thumbMinSize = _props.thumbMinSize;
                var _view = this.view, scrollWidth = _view.scrollWidth, clientWidth = _view.clientWidth;
                var trackWidth = (0, _getInnerWidth2["default"])(this.trackHorizontal);
                var width = Math.ceil(clientWidth / scrollWidth * trackWidth);
                if (trackWidth === width) return 0;
                if (thumbSize) return thumbSize;
                return Math.max(width, thumbMinSize);
            }
        },
        {
            key: "getThumbVerticalHeight",
            value: function getThumbVerticalHeight() {
                var _props2 = this.props, thumbSize = _props2.thumbSize, thumbMinSize = _props2.thumbMinSize;
                var _view2 = this.view, scrollHeight = _view2.scrollHeight, clientHeight = _view2.clientHeight;
                var trackHeight = (0, _getInnerHeight2["default"])(this.trackVertical);
                var height = Math.ceil(clientHeight / scrollHeight * trackHeight);
                if (trackHeight === height) return 0;
                if (thumbSize) return thumbSize;
                return Math.max(height, thumbMinSize);
            }
        },
        {
            key: "getScrollLeftForOffset",
            value: function getScrollLeftForOffset(offset) {
                var _view3 = this.view, scrollWidth = _view3.scrollWidth, clientWidth = _view3.clientWidth;
                var trackWidth = (0, _getInnerWidth2["default"])(this.trackHorizontal);
                var thumbWidth = this.getThumbHorizontalWidth();
                return offset / (trackWidth - thumbWidth) * (scrollWidth - clientWidth);
            }
        },
        {
            key: "getScrollTopForOffset",
            value: function getScrollTopForOffset(offset) {
                var _view4 = this.view, scrollHeight = _view4.scrollHeight, clientHeight = _view4.clientHeight;
                var trackHeight = (0, _getInnerHeight2["default"])(this.trackVertical);
                var thumbHeight = this.getThumbVerticalHeight();
                return offset / (trackHeight - thumbHeight) * (scrollHeight - clientHeight);
            }
        },
        {
            key: "scrollLeft",
            value: function scrollLeft() {
                var left = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
                if (!this.view) return;
                this.view.scrollLeft = left;
            }
        },
        {
            key: "scrollTop",
            value: function scrollTop() {
                var top = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
                if (!this.view) return;
                this.view.scrollTop = top;
            }
        },
        {
            key: "scrollToLeft",
            value: function scrollToLeft() {
                if (!this.view) return;
                this.view.scrollLeft = 0;
            }
        },
        {
            key: "scrollToTop",
            value: function scrollToTop() {
                if (!this.view) return;
                this.view.scrollTop = 0;
            }
        },
        {
            key: "scrollToRight",
            value: function scrollToRight() {
                if (!this.view) return;
                this.view.scrollLeft = this.view.scrollWidth;
            }
        },
        {
            key: "scrollToBottom",
            value: function scrollToBottom() {
                if (!this.view) return;
                this.view.scrollTop = this.view.scrollHeight;
            }
        },
        {
            key: "addListeners",
            value: function addListeners() {
                /* istanbul ignore if */ if (typeof document === "undefined" || !this.view) return;
                var view = this.view, trackHorizontal = this.trackHorizontal, trackVertical = this.trackVertical, thumbHorizontal = this.thumbHorizontal, thumbVertical = this.thumbVertical;
                view.addEventListener("scroll", this.handleScroll);
                if (!(0, _getScrollbarWidth2["default"])()) return;
                trackHorizontal.addEventListener("mouseenter", this.handleTrackMouseEnter);
                trackHorizontal.addEventListener("mouseleave", this.handleTrackMouseLeave);
                trackHorizontal.addEventListener("mousedown", this.handleHorizontalTrackMouseDown);
                trackVertical.addEventListener("mouseenter", this.handleTrackMouseEnter);
                trackVertical.addEventListener("mouseleave", this.handleTrackMouseLeave);
                trackVertical.addEventListener("mousedown", this.handleVerticalTrackMouseDown);
                thumbHorizontal.addEventListener("mousedown", this.handleHorizontalThumbMouseDown);
                thumbVertical.addEventListener("mousedown", this.handleVerticalThumbMouseDown);
                window.addEventListener("resize", this.handleWindowResize);
            }
        },
        {
            key: "removeListeners",
            value: function removeListeners() {
                /* istanbul ignore if */ if (typeof document === "undefined" || !this.view) return;
                var view = this.view, trackHorizontal = this.trackHorizontal, trackVertical = this.trackVertical, thumbHorizontal = this.thumbHorizontal, thumbVertical = this.thumbVertical;
                view.removeEventListener("scroll", this.handleScroll);
                if (!(0, _getScrollbarWidth2["default"])()) return;
                trackHorizontal.removeEventListener("mouseenter", this.handleTrackMouseEnter);
                trackHorizontal.removeEventListener("mouseleave", this.handleTrackMouseLeave);
                trackHorizontal.removeEventListener("mousedown", this.handleHorizontalTrackMouseDown);
                trackVertical.removeEventListener("mouseenter", this.handleTrackMouseEnter);
                trackVertical.removeEventListener("mouseleave", this.handleTrackMouseLeave);
                trackVertical.removeEventListener("mousedown", this.handleVerticalTrackMouseDown);
                thumbHorizontal.removeEventListener("mousedown", this.handleHorizontalThumbMouseDown);
                thumbVertical.removeEventListener("mousedown", this.handleVerticalThumbMouseDown);
                window.removeEventListener("resize", this.handleWindowResize);
                // Possibly setup by `handleDragStart`
                this.teardownDragging();
            }
        },
        {
            key: "handleScroll",
            value: function handleScroll(event) {
                var _this2 = this;
                var _props3 = this.props, onScroll = _props3.onScroll, onScrollFrame = _props3.onScrollFrame;
                if (onScroll) onScroll(event);
                this.update(function(values) {
                    var scrollLeft = values.scrollLeft, scrollTop = values.scrollTop;
                    _this2.viewScrollLeft = scrollLeft;
                    _this2.viewScrollTop = scrollTop;
                    if (onScrollFrame) onScrollFrame(values);
                });
                this.detectScrolling();
            }
        },
        {
            key: "handleScrollStart",
            value: function handleScrollStart() {
                var onScrollStart = this.props.onScrollStart;
                if (onScrollStart) onScrollStart();
                this.handleScrollStartAutoHide();
            }
        },
        {
            key: "handleScrollStartAutoHide",
            value: function handleScrollStartAutoHide() {
                var autoHide = this.props.autoHide;
                if (!autoHide) return;
                this.showTracks();
            }
        },
        {
            key: "handleScrollStop",
            value: function handleScrollStop() {
                var onScrollStop = this.props.onScrollStop;
                if (onScrollStop) onScrollStop();
                this.handleScrollStopAutoHide();
            }
        },
        {
            key: "handleScrollStopAutoHide",
            value: function handleScrollStopAutoHide() {
                var autoHide = this.props.autoHide;
                if (!autoHide) return;
                this.hideTracks();
            }
        },
        {
            key: "handleWindowResize",
            value: function handleWindowResize() {
                this.update();
            }
        },
        {
            key: "handleHorizontalTrackMouseDown",
            value: function handleHorizontalTrackMouseDown(event) {
                event.preventDefault();
                var target = event.target, clientX = event.clientX;
                var _target$getBoundingCl = target.getBoundingClientRect(), targetLeft = _target$getBoundingCl.left;
                var thumbWidth = this.getThumbHorizontalWidth();
                var offset = Math.abs(targetLeft - clientX) - thumbWidth / 2;
                this.view.scrollLeft = this.getScrollLeftForOffset(offset);
            }
        },
        {
            key: "handleVerticalTrackMouseDown",
            value: function handleVerticalTrackMouseDown(event) {
                event.preventDefault();
                var target = event.target, clientY = event.clientY;
                var _target$getBoundingCl2 = target.getBoundingClientRect(), targetTop = _target$getBoundingCl2.top;
                var thumbHeight = this.getThumbVerticalHeight();
                var offset = Math.abs(targetTop - clientY) - thumbHeight / 2;
                this.view.scrollTop = this.getScrollTopForOffset(offset);
            }
        },
        {
            key: "handleHorizontalThumbMouseDown",
            value: function handleHorizontalThumbMouseDown(event) {
                event.preventDefault();
                this.handleDragStart(event);
                var target = event.target, clientX = event.clientX;
                var offsetWidth = target.offsetWidth;
                var _target$getBoundingCl3 = target.getBoundingClientRect(), left = _target$getBoundingCl3.left;
                this.prevPageX = offsetWidth - (clientX - left);
            }
        },
        {
            key: "handleVerticalThumbMouseDown",
            value: function handleVerticalThumbMouseDown(event) {
                event.preventDefault();
                this.handleDragStart(event);
                var target = event.target, clientY = event.clientY;
                var offsetHeight = target.offsetHeight;
                var _target$getBoundingCl4 = target.getBoundingClientRect(), top = _target$getBoundingCl4.top;
                this.prevPageY = offsetHeight - (clientY - top);
            }
        },
        {
            key: "setupDragging",
            value: function setupDragging() {
                (0, _domCss2["default"])(document.body, _styles.disableSelectStyle);
                document.addEventListener("mousemove", this.handleDrag);
                document.addEventListener("mouseup", this.handleDragEnd);
                document.onselectstart = _returnFalse2["default"];
            }
        },
        {
            key: "teardownDragging",
            value: function teardownDragging() {
                (0, _domCss2["default"])(document.body, _styles.disableSelectStyleReset);
                document.removeEventListener("mousemove", this.handleDrag);
                document.removeEventListener("mouseup", this.handleDragEnd);
                document.onselectstart = undefined;
            }
        },
        {
            key: "handleDragStart",
            value: function handleDragStart(event) {
                this.dragging = true;
                event.stopImmediatePropagation();
                this.setupDragging();
            }
        },
        {
            key: "handleDrag",
            value: function handleDrag(event) {
                if (this.prevPageX) {
                    var clientX = event.clientX;
                    var _trackHorizontal$getB = this.trackHorizontal.getBoundingClientRect(), trackLeft = _trackHorizontal$getB.left;
                    var thumbWidth = this.getThumbHorizontalWidth();
                    var clickPosition = thumbWidth - this.prevPageX;
                    var offset = -trackLeft + clientX - clickPosition;
                    this.view.scrollLeft = this.getScrollLeftForOffset(offset);
                }
                if (this.prevPageY) {
                    var clientY = event.clientY;
                    var _trackVertical$getBou = this.trackVertical.getBoundingClientRect(), trackTop = _trackVertical$getBou.top;
                    var thumbHeight = this.getThumbVerticalHeight();
                    var _clickPosition = thumbHeight - this.prevPageY;
                    var _offset = -trackTop + clientY - _clickPosition;
                    this.view.scrollTop = this.getScrollTopForOffset(_offset);
                }
                return false;
            }
        },
        {
            key: "handleDragEnd",
            value: function handleDragEnd() {
                this.dragging = false;
                this.prevPageX = this.prevPageY = 0;
                this.teardownDragging();
                this.handleDragEndAutoHide();
            }
        },
        {
            key: "handleDragEndAutoHide",
            value: function handleDragEndAutoHide() {
                var autoHide = this.props.autoHide;
                if (!autoHide) return;
                this.hideTracks();
            }
        },
        {
            key: "handleTrackMouseEnter",
            value: function handleTrackMouseEnter() {
                this.trackMouseOver = true;
                this.handleTrackMouseEnterAutoHide();
            }
        },
        {
            key: "handleTrackMouseEnterAutoHide",
            value: function handleTrackMouseEnterAutoHide() {
                var autoHide = this.props.autoHide;
                if (!autoHide) return;
                this.showTracks();
            }
        },
        {
            key: "handleTrackMouseLeave",
            value: function handleTrackMouseLeave() {
                this.trackMouseOver = false;
                this.handleTrackMouseLeaveAutoHide();
            }
        },
        {
            key: "handleTrackMouseLeaveAutoHide",
            value: function handleTrackMouseLeaveAutoHide() {
                var autoHide = this.props.autoHide;
                if (!autoHide) return;
                this.hideTracks();
            }
        },
        {
            key: "showTracks",
            value: function showTracks() {
                clearTimeout(this.hideTracksTimeout);
                (0, _domCss2["default"])(this.trackHorizontal, {
                    opacity: 1
                });
                (0, _domCss2["default"])(this.trackVertical, {
                    opacity: 1
                });
            }
        },
        {
            key: "hideTracks",
            value: function hideTracks() {
                var _this3 = this;
                if (this.dragging) return;
                if (this.scrolling) return;
                if (this.trackMouseOver) return;
                var autoHideTimeout = this.props.autoHideTimeout;
                clearTimeout(this.hideTracksTimeout);
                this.hideTracksTimeout = setTimeout(function() {
                    (0, _domCss2["default"])(_this3.trackHorizontal, {
                        opacity: 0
                    });
                    (0, _domCss2["default"])(_this3.trackVertical, {
                        opacity: 0
                    });
                }, autoHideTimeout);
            }
        },
        {
            key: "detectScrolling",
            value: function detectScrolling() {
                var _this4 = this;
                if (this.scrolling) return;
                this.scrolling = true;
                this.handleScrollStart();
                this.detectScrollingInterval = setInterval(function() {
                    if (_this4.lastViewScrollLeft === _this4.viewScrollLeft && _this4.lastViewScrollTop === _this4.viewScrollTop) {
                        clearInterval(_this4.detectScrollingInterval);
                        _this4.scrolling = false;
                        _this4.handleScrollStop();
                    }
                    _this4.lastViewScrollLeft = _this4.viewScrollLeft;
                    _this4.lastViewScrollTop = _this4.viewScrollTop;
                }, 100);
            }
        },
        {
            key: "raf",
            value: function raf(callback) {
                var _this5 = this;
                if (this.requestFrame) _raf3["default"].cancel(this.requestFrame);
                this.requestFrame = (0, _raf3["default"])(function() {
                    _this5.requestFrame = undefined;
                    callback();
                });
            }
        },
        {
            key: "update",
            value: function update(callback) {
                var _this6 = this;
                this.raf(function() {
                    return _this6._update(callback);
                });
            }
        },
        {
            key: "_update",
            value: function _update(callback) {
                var _props4 = this.props, onUpdate = _props4.onUpdate, hideTracksWhenNotNeeded = _props4.hideTracksWhenNotNeeded;
                var values = this.getValues();
                if ((0, _getScrollbarWidth2["default"])()) {
                    var scrollLeft = values.scrollLeft, clientWidth = values.clientWidth, scrollWidth = values.scrollWidth;
                    var trackHorizontalWidth = (0, _getInnerWidth2["default"])(this.trackHorizontal);
                    var thumbHorizontalWidth = this.getThumbHorizontalWidth();
                    var thumbHorizontalX = scrollLeft / (scrollWidth - clientWidth) * (trackHorizontalWidth - thumbHorizontalWidth);
                    var thumbHorizontalStyle = {
                        width: thumbHorizontalWidth,
                        transform: "translateX(" + thumbHorizontalX + "px)"
                    };
                    var scrollTop = values.scrollTop, clientHeight = values.clientHeight, scrollHeight = values.scrollHeight;
                    var trackVerticalHeight = (0, _getInnerHeight2["default"])(this.trackVertical);
                    var thumbVerticalHeight = this.getThumbVerticalHeight();
                    var thumbVerticalY = scrollTop / (scrollHeight - clientHeight) * (trackVerticalHeight - thumbVerticalHeight);
                    var thumbVerticalStyle = {
                        height: thumbVerticalHeight,
                        transform: "translateY(" + thumbVerticalY + "px)"
                    };
                    if (hideTracksWhenNotNeeded) {
                        var trackHorizontalStyle = {
                            visibility: scrollWidth > clientWidth ? "visible" : "hidden"
                        };
                        var trackVerticalStyle = {
                            visibility: scrollHeight > clientHeight ? "visible" : "hidden"
                        };
                        (0, _domCss2["default"])(this.trackHorizontal, trackHorizontalStyle);
                        (0, _domCss2["default"])(this.trackVertical, trackVerticalStyle);
                    }
                    (0, _domCss2["default"])(this.thumbHorizontal, thumbHorizontalStyle);
                    (0, _domCss2["default"])(this.thumbVertical, thumbVerticalStyle);
                }
                if (onUpdate) onUpdate(values);
                if (typeof callback !== "function") return;
                callback(values);
            }
        },
        {
            key: "render",
            value: function render() {
                var _this7 = this;
                var scrollbarWidth = (0, _getScrollbarWidth2["default"])();
                /* eslint-disable no-unused-vars */ var _props5 = this.props, onScroll = _props5.onScroll, onScrollFrame = _props5.onScrollFrame, onScrollStart = _props5.onScrollStart, onScrollStop = _props5.onScrollStop, onUpdate = _props5.onUpdate, renderView = _props5.renderView, renderTrackHorizontal = _props5.renderTrackHorizontal, renderTrackVertical = _props5.renderTrackVertical, renderThumbHorizontal = _props5.renderThumbHorizontal, renderThumbVertical = _props5.renderThumbVertical, tagName = _props5.tagName, hideTracksWhenNotNeeded = _props5.hideTracksWhenNotNeeded, autoHide = _props5.autoHide, autoHideTimeout = _props5.autoHideTimeout, autoHideDuration = _props5.autoHideDuration, thumbSize = _props5.thumbSize, thumbMinSize = _props5.thumbMinSize, universal = _props5.universal, autoHeight = _props5.autoHeight, autoHeightMin = _props5.autoHeightMin, autoHeightMax = _props5.autoHeightMax, style = _props5.style, children = _props5.children, props = _objectWithoutProperties(_props5, [
                    "onScroll",
                    "onScrollFrame",
                    "onScrollStart",
                    "onScrollStop",
                    "onUpdate",
                    "renderView",
                    "renderTrackHorizontal",
                    "renderTrackVertical",
                    "renderThumbHorizontal",
                    "renderThumbVertical",
                    "tagName",
                    "hideTracksWhenNotNeeded",
                    "autoHide",
                    "autoHideTimeout",
                    "autoHideDuration",
                    "thumbSize",
                    "thumbMinSize",
                    "universal",
                    "autoHeight",
                    "autoHeightMin",
                    "autoHeightMax",
                    "style",
                    "children"
                ]);
                /* eslint-enable no-unused-vars */ var didMountUniversal = this.state.didMountUniversal;
                var containerStyle = _extends({}, _styles.containerStyleDefault, autoHeight && _extends({}, _styles.containerStyleAutoHeight, {
                    minHeight: autoHeightMin,
                    maxHeight: autoHeightMax
                }), style);
                var viewStyle = _extends({}, _styles.viewStyleDefault, {
                    // Hide scrollbars by setting a negative margin
                    marginRight: scrollbarWidth ? -scrollbarWidth : 0,
                    marginBottom: scrollbarWidth ? -scrollbarWidth : 0
                }, autoHeight && _extends({}, _styles.viewStyleAutoHeight, {
                    // Add scrollbarWidth to autoHeight in order to compensate negative margins
                    minHeight: (0, _isString2["default"])(autoHeightMin) ? "calc(" + autoHeightMin + " + " + scrollbarWidth + "px)" : autoHeightMin + scrollbarWidth,
                    maxHeight: (0, _isString2["default"])(autoHeightMax) ? "calc(" + autoHeightMax + " + " + scrollbarWidth + "px)" : autoHeightMax + scrollbarWidth
                }), autoHeight && universal && !didMountUniversal && {
                    minHeight: autoHeightMin,
                    maxHeight: autoHeightMax
                }, universal && !didMountUniversal && _styles.viewStyleUniversalInitial);
                var trackAutoHeightStyle = {
                    transition: "opacity " + autoHideDuration + "ms",
                    opacity: 0
                };
                var trackHorizontalStyle = _extends({}, _styles.trackHorizontalStyleDefault, autoHide && trackAutoHeightStyle, (!scrollbarWidth || universal && !didMountUniversal) && {
                    display: "none"
                });
                var trackVerticalStyle = _extends({}, _styles.trackVerticalStyleDefault, autoHide && trackAutoHeightStyle, (!scrollbarWidth || universal && !didMountUniversal) && {
                    display: "none"
                });
                return (0, _react.createElement)(tagName, _extends({}, props, {
                    style: containerStyle,
                    ref: function ref(_ref3) {
                        _this7.container = _ref3;
                    }
                }), [
                    (0, _react.cloneElement)(renderView({
                        style: viewStyle
                    }), {
                        key: "view",
                        ref: function ref(_ref4) {
                            _this7.view = _ref4;
                        }
                    }, children),
                    (0, _react.cloneElement)(renderTrackHorizontal({
                        style: trackHorizontalStyle
                    }), {
                        key: "trackHorizontal",
                        ref: function ref(_ref5) {
                            _this7.trackHorizontal = _ref5;
                        }
                    }, (0, _react.cloneElement)(renderThumbHorizontal({
                        style: _styles.thumbHorizontalStyleDefault
                    }), {
                        ref: function ref(_ref6) {
                            _this7.thumbHorizontal = _ref6;
                        }
                    })),
                    (0, _react.cloneElement)(renderTrackVertical({
                        style: trackVerticalStyle
                    }), {
                        key: "trackVertical",
                        ref: function ref(_ref7) {
                            _this7.trackVertical = _ref7;
                        }
                    }, (0, _react.cloneElement)(renderThumbVertical({
                        style: _styles.thumbVerticalStyleDefault
                    }), {
                        ref: function ref(_ref8) {
                            _this7.thumbVertical = _ref8;
                        }
                    }))
                ]);
            }
        }
    ]);
    return Scrollbars;
}(_react.Component);
exports["default"] = Scrollbars;
Scrollbars.propTypes = {
    onScroll: _propTypes2["default"].func,
    onScrollFrame: _propTypes2["default"].func,
    onScrollStart: _propTypes2["default"].func,
    onScrollStop: _propTypes2["default"].func,
    onUpdate: _propTypes2["default"].func,
    renderView: _propTypes2["default"].func,
    renderTrackHorizontal: _propTypes2["default"].func,
    renderTrackVertical: _propTypes2["default"].func,
    renderThumbHorizontal: _propTypes2["default"].func,
    renderThumbVertical: _propTypes2["default"].func,
    tagName: _propTypes2["default"].string,
    thumbSize: _propTypes2["default"].number,
    thumbMinSize: _propTypes2["default"].number,
    hideTracksWhenNotNeeded: _propTypes2["default"].bool,
    autoHide: _propTypes2["default"].bool,
    autoHideTimeout: _propTypes2["default"].number,
    autoHideDuration: _propTypes2["default"].number,
    autoHeight: _propTypes2["default"].bool,
    autoHeightMin: _propTypes2["default"].oneOfType([
        _propTypes2["default"].number,
        _propTypes2["default"].string
    ]),
    autoHeightMax: _propTypes2["default"].oneOfType([
        _propTypes2["default"].number,
        _propTypes2["default"].string
    ]),
    universal: _propTypes2["default"].bool,
    style: _propTypes2["default"].object,
    children: _propTypes2["default"].node
};
Scrollbars.defaultProps = {
    renderView: _defaultRenderElements.renderViewDefault,
    renderTrackHorizontal: _defaultRenderElements.renderTrackHorizontalDefault,
    renderTrackVertical: _defaultRenderElements.renderTrackVerticalDefault,
    renderThumbHorizontal: _defaultRenderElements.renderThumbHorizontalDefault,
    renderThumbVertical: _defaultRenderElements.renderThumbVerticalDefault,
    tagName: "div",
    thumbMinSize: 30,
    hideTracksWhenNotNeeded: false,
    autoHide: false,
    autoHideTimeout: 1000,
    autoHideDuration: 200,
    autoHeight: false,
    autoHeightMin: 0,
    autoHeightMax: 200,
    universal: false
};

},{"d0b882c79745acde":"9ySuv","d7082902849b5515":"lvbQ0","5e12b9153aacfeb0":"6uln9","2424184a1a5de37d":"6FKs7","60c48c25ec69da64":"6ZiRJ","5881d76f2c1baea7":"kGmUM","15ec1958ab6e1253":"cOjlz","1e932bba60e3d01":"bT29a","7425d2b5c95904bf":"gJXtG","ef274a620d3449c2":"jWHKo","63b538f7d762960a":"lHjdp"}],"9ySuv":[function(require,module,exports) {
var global = arguments[3];
var now = require("cf76948a525d1513"), root = typeof window === "undefined" ? global : window, vendors = [
    "moz",
    "webkit"
], suffix = "AnimationFrame", raf = root["request" + suffix], caf = root["cancel" + suffix] || root["cancelRequest" + suffix];
for(var i = 0; !raf && i < vendors.length; i++){
    raf = root[vendors[i] + "Request" + suffix];
    caf = root[vendors[i] + "Cancel" + suffix] || root[vendors[i] + "CancelRequest" + suffix];
}
// Some versions of FF have rAF but not cAF
if (!raf || !caf) {
    var last = 0, id = 0, queue = [], frameDuration = 1000 / 60;
    raf = function(callback) {
        if (queue.length === 0) {
            var _now = now(), next = Math.max(0, frameDuration - (_now - last));
            last = next + _now;
            setTimeout(function() {
                var cp = queue.slice(0);
                // Clear queue here to prevent
                // callbacks from appending listeners
                // to the current frame's queue
                queue.length = 0;
                for(var i = 0; i < cp.length; i++){
                    if (!cp[i].cancelled) try {
                        cp[i].callback(last);
                    } catch (e) {
                        setTimeout(function() {
                            throw e;
                        }, 0);
                    }
                }
            }, Math.round(next));
        }
        queue.push({
            handle: ++id,
            callback: callback,
            cancelled: false
        });
        return id;
    };
    caf = function(handle) {
        for(var i = 0; i < queue.length; i++)if (queue[i].handle === handle) queue[i].cancelled = true;
    };
}
module.exports = function(fn) {
    // Wrap in a new function to prevent
    // `cancel` potentially being assigned
    // to the native rAF function
    return raf.call(root, fn);
};
module.exports.cancel = function() {
    caf.apply(root, arguments);
};
module.exports.polyfill = function(object) {
    if (!object) object = root;
    object.requestAnimationFrame = raf;
    object.cancelAnimationFrame = caf;
};

},{"cf76948a525d1513":"2MJ1F"}],"2MJ1F":[function(require,module,exports) {
var process = require("f348cfb52b253442");
// Generated by CoffeeScript 1.12.2
(function() {
    var getNanoSeconds, hrtime, loadTime, moduleLoadTime, nodeLoadTime, upTime;
    if (typeof performance !== "undefined" && performance !== null && performance.now) module.exports = function() {
        return performance.now();
    };
    else if (typeof process !== "undefined" && process !== null && process.hrtime) {
        module.exports = function() {
            return (getNanoSeconds() - nodeLoadTime) / 1e6;
        };
        hrtime = process.hrtime;
        getNanoSeconds = function() {
            var hr;
            hr = hrtime();
            return hr[0] * 1e9 + hr[1];
        };
        moduleLoadTime = getNanoSeconds();
        upTime = process.uptime() * 1e9;
        nodeLoadTime = moduleLoadTime - upTime;
    } else if (Date.now) {
        module.exports = function() {
            return Date.now() - loadTime;
        };
        loadTime = Date.now();
    } else {
        module.exports = function() {
            return new Date().getTime() - loadTime;
        };
        loadTime = new Date().getTime();
    }
}).call(this);

},{"f348cfb52b253442":"5QIF0"}],"5QIF0":[function(require,module,exports) {
// shim for using process in browser
var process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var cachedSetTimeout;
var cachedClearTimeout;
function defaultSetTimout() {
    throw new Error("setTimeout has not been defined");
}
function defaultClearTimeout() {
    throw new Error("clearTimeout has not been defined");
}
(function() {
    try {
        if (typeof setTimeout === "function") cachedSetTimeout = setTimeout;
        else cachedSetTimeout = defaultSetTimout;
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === "function") cachedClearTimeout = clearTimeout;
        else cachedClearTimeout = defaultClearTimeout;
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
})();
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }
}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;
function cleanUpNextTick() {
    if (!draining || !currentQueue) return;
    draining = false;
    if (currentQueue.length) queue = currentQueue.concat(queue);
    else queueIndex = -1;
    if (queue.length) drainQueue();
}
function drainQueue() {
    if (draining) return;
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;
    var len = queue.length;
    while(len){
        currentQueue = queue;
        queue = [];
        while(++queueIndex < len)if (currentQueue) currentQueue[queueIndex].run();
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}
process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) runTimeout(drainQueue);
};
// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
process.title = "browser";
process.browser = true;
process.env = {};
process.argv = [];
process.version = ""; // empty string to avoid regexp issues
process.versions = {};
function noop() {}
process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;
process.listeners = function(name) {
    return [];
};
process.binding = function(name) {
    throw new Error("process.binding is not supported");
};
process.cwd = function() {
    return "/";
};
process.chdir = function(dir) {
    throw new Error("process.chdir is not supported");
};
process.umask = function() {
    return 0;
};

},{}],"lvbQ0":[function(require,module,exports) {
var prefix = require("f82d9e179254ed65");
var toCamelCase = require("54dd8237ac229303");
var cache = {
    "float": "cssFloat"
};
var addPxToStyle = require("f311eab0be300e13");
function style(element, property, value) {
    var camel = cache[property];
    if (typeof camel === "undefined") camel = detect(property);
    // may be false if CSS prop is unsupported
    if (camel) {
        if (value === undefined) return element.style[camel];
        element.style[camel] = addPxToStyle(camel, value);
    }
}
function each(element, properties) {
    for(var k in properties)if (properties.hasOwnProperty(k)) style(element, k, properties[k]);
}
function detect(cssProp) {
    var camel = toCamelCase(cssProp);
    var result = prefix(camel);
    cache[camel] = cache[cssProp] = cache[result] = result;
    return result;
}
function set() {
    if (arguments.length === 2) {
        if (typeof arguments[1] === "string") arguments[0].style.cssText = arguments[1];
        else each(arguments[0], arguments[1]);
    } else style(arguments[0], arguments[1], arguments[2]);
}
module.exports = set;
module.exports.set = set;
module.exports.get = function(element, properties) {
    if (Array.isArray(properties)) return properties.reduce(function(obj, prop) {
        obj[prop] = style(element, prop || "");
        return obj;
    }, {});
    else return style(element, properties || "");
};

},{"f82d9e179254ed65":"17VAF","54dd8237ac229303":"4UiN1","f311eab0be300e13":"ecXCG"}],"17VAF":[function(require,module,exports) {
var div = null;
var prefixes = [
    "Webkit",
    "Moz",
    "O",
    "ms"
];
module.exports = function prefixStyle(prop) {
    // re-use a dummy div
    if (!div) div = document.createElement("div");
    var style = div.style;
    // prop exists without prefix
    if (prop in style) return prop;
    // borderRadius -> BorderRadius
    var titleCase = prop.charAt(0).toUpperCase() + prop.slice(1);
    // find the vendor-prefixed prop
    for(var i = prefixes.length; i >= 0; i--){
        var name = prefixes[i] + titleCase;
        // e.g. WebkitBorderRadius or webkitBorderRadius
        if (name in style) return name;
    }
    return false;
};

},{}],"4UiN1":[function(require,module,exports) {
var space = require("8de4ebd3565a6381");
/**
 * Export.
 */ module.exports = toCamelCase;
/**
 * Convert a `string` to camel case.
 *
 * @param {String} string
 * @return {String}
 */ function toCamelCase(string) {
    return space(string).replace(/\s(\w)/g, function(matches, letter) {
        return letter.toUpperCase();
    });
}

},{"8de4ebd3565a6381":"71vS5"}],"71vS5":[function(require,module,exports) {
var clean = require("369dd27b42430c3f");
/**
 * Export.
 */ module.exports = toSpaceCase;
/**
 * Convert a `string` to space case.
 *
 * @param {String} string
 * @return {String}
 */ function toSpaceCase(string) {
    return clean(string).replace(/[\W_]+(.|$)/g, function(matches, match) {
        return match ? " " + match : "";
    }).trim();
}

},{"369dd27b42430c3f":"dPpFZ"}],"dPpFZ":[function(require,module,exports) {
/**
 * Export.
 */ module.exports = toNoCase;
/**
 * Test whether a string is camel-case.
 */ var hasSpace = /\s/;
var hasSeparator = /(_|-|\.|:)/;
var hasCamel = /([a-z][A-Z]|[A-Z][a-z])/;
/**
 * Remove any starting case from a `string`, like camel or snake, but keep
 * spaces and punctuation that may be important otherwise.
 *
 * @param {String} string
 * @return {String}
 */ function toNoCase(string) {
    if (hasSpace.test(string)) return string.toLowerCase();
    if (hasSeparator.test(string)) return (unseparate(string) || string).toLowerCase();
    if (hasCamel.test(string)) return uncamelize(string).toLowerCase();
    return string.toLowerCase();
}
/**
 * Separator splitter.
 */ var separatorSplitter = /[\W_]+(.|$)/g;
/**
 * Un-separate a `string`.
 *
 * @param {String} string
 * @return {String}
 */ function unseparate(string) {
    return string.replace(separatorSplitter, function(m, next) {
        return next ? " " + next : "";
    });
}
/**
 * Camelcase splitter.
 */ var camelSplitter = /(.)([A-Z]+)/g;
/**
 * Un-camelcase a `string`.
 *
 * @param {String} string
 * @return {String}
 */ function uncamelize(string) {
    return string.replace(camelSplitter, function(m, previous, uppers) {
        return previous + " " + uppers.toLowerCase().split("").join(" ");
    });
}

},{}],"ecXCG":[function(require,module,exports) {
/* The following list is defined in React's core */ var IS_UNITLESS = {
    animationIterationCount: true,
    boxFlex: true,
    boxFlexGroup: true,
    boxOrdinalGroup: true,
    columnCount: true,
    flex: true,
    flexGrow: true,
    flexPositive: true,
    flexShrink: true,
    flexNegative: true,
    flexOrder: true,
    gridRow: true,
    gridColumn: true,
    fontWeight: true,
    lineClamp: true,
    lineHeight: true,
    opacity: true,
    order: true,
    orphans: true,
    tabSize: true,
    widows: true,
    zIndex: true,
    zoom: true,
    // SVG-related properties
    fillOpacity: true,
    stopOpacity: true,
    strokeDashoffset: true,
    strokeOpacity: true,
    strokeWidth: true
};
module.exports = function(name, value) {
    if (typeof value === "number" && !IS_UNITLESS[name]) return value + "px";
    else return value;
};

},{}],"6ZiRJ":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = isString;
function isString(maybe) {
    return typeof maybe === "string";
}

},{}],"kGmUM":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = getScrollbarWidth;
var _domCss = require("131bd58d254121e6");
var _domCss2 = _interopRequireDefault(_domCss);
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
var scrollbarWidth = false;
function getScrollbarWidth() {
    if (scrollbarWidth !== false) return scrollbarWidth;
    /* istanbul ignore else */ if (typeof document !== "undefined") {
        var div = document.createElement("div");
        (0, _domCss2["default"])(div, {
            width: 100,
            height: 100,
            position: "absolute",
            top: -9999,
            overflow: "scroll",
            MsOverflowStyle: "scrollbar"
        });
        document.body.appendChild(div);
        scrollbarWidth = div.offsetWidth - div.clientWidth;
        document.body.removeChild(div);
    } else scrollbarWidth = 0;
    return scrollbarWidth || 0;
}

},{"131bd58d254121e6":"lvbQ0"}],"cOjlz":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = returnFalse;
function returnFalse() {
    return false;
}

},{}],"bT29a":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = getInnerWidth;
function getInnerWidth(el) {
    var clientWidth = el.clientWidth;
    var _getComputedStyle = getComputedStyle(el), paddingLeft = _getComputedStyle.paddingLeft, paddingRight = _getComputedStyle.paddingRight;
    return clientWidth - parseFloat(paddingLeft) - parseFloat(paddingRight);
}

},{}],"gJXtG":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = getInnerHeight;
function getInnerHeight(el) {
    var clientHeight = el.clientHeight;
    var _getComputedStyle = getComputedStyle(el), paddingTop = _getComputedStyle.paddingTop, paddingBottom = _getComputedStyle.paddingBottom;
    return clientHeight - parseFloat(paddingTop) - parseFloat(paddingBottom);
}

},{}],"jWHKo":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
var containerStyleDefault = exports.containerStyleDefault = {
    position: "relative",
    overflow: "hidden",
    width: "100%",
    height: "100%"
};
// Overrides containerStyleDefault properties
var containerStyleAutoHeight = exports.containerStyleAutoHeight = {
    height: "auto"
};
var viewStyleDefault = exports.viewStyleDefault = {
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    overflow: "scroll",
    WebkitOverflowScrolling: "touch"
};
// Overrides viewStyleDefault properties
var viewStyleAutoHeight = exports.viewStyleAutoHeight = {
    position: "relative",
    top: undefined,
    left: undefined,
    right: undefined,
    bottom: undefined
};
var viewStyleUniversalInitial = exports.viewStyleUniversalInitial = {
    overflow: "hidden",
    marginRight: 0,
    marginBottom: 0
};
var trackHorizontalStyleDefault = exports.trackHorizontalStyleDefault = {
    position: "absolute",
    height: 6
};
var trackVerticalStyleDefault = exports.trackVerticalStyleDefault = {
    position: "absolute",
    width: 6
};
var thumbHorizontalStyleDefault = exports.thumbHorizontalStyleDefault = {
    position: "relative",
    display: "block",
    height: "100%"
};
var thumbVerticalStyleDefault = exports.thumbVerticalStyleDefault = {
    position: "relative",
    display: "block",
    width: "100%"
};
var disableSelectStyle = exports.disableSelectStyle = {
    userSelect: "none"
};
var disableSelectStyleReset = exports.disableSelectStyleReset = {
    userSelect: ""
};

},{}],"lHjdp":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
exports.renderViewDefault = renderViewDefault;
exports.renderTrackHorizontalDefault = renderTrackHorizontalDefault;
exports.renderTrackVerticalDefault = renderTrackVerticalDefault;
exports.renderThumbHorizontalDefault = renderThumbHorizontalDefault;
exports.renderThumbVerticalDefault = renderThumbVerticalDefault;
var _react = require("888e25a1c1e4525c");
var _react2 = _interopRequireDefault(_react);
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function _objectWithoutProperties(obj, keys) {
    var target = {};
    for(var i in obj){
        if (keys.indexOf(i) >= 0) continue;
        if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
        target[i] = obj[i];
    }
    return target;
}
/* eslint-disable react/prop-types */ function renderViewDefault(props) {
    return _react2["default"].createElement("div", props);
}
function renderTrackHorizontalDefault(_ref) {
    var style = _ref.style, props = _objectWithoutProperties(_ref, [
        "style"
    ]);
    var finalStyle = _extends({}, style, {
        right: 2,
        bottom: 2,
        left: 2,
        borderRadius: 3
    });
    return _react2["default"].createElement("div", _extends({
        style: finalStyle
    }, props));
}
function renderTrackVerticalDefault(_ref2) {
    var style = _ref2.style, props = _objectWithoutProperties(_ref2, [
        "style"
    ]);
    var finalStyle = _extends({}, style, {
        right: 2,
        bottom: 2,
        top: 2,
        borderRadius: 3
    });
    return _react2["default"].createElement("div", _extends({
        style: finalStyle
    }, props));
}
function renderThumbHorizontalDefault(_ref3) {
    var style = _ref3.style, props = _objectWithoutProperties(_ref3, [
        "style"
    ]);
    var finalStyle = _extends({}, style, {
        cursor: "pointer",
        borderRadius: "inherit",
        backgroundColor: "rgba(0,0,0,.2)"
    });
    return _react2["default"].createElement("div", _extends({
        style: finalStyle
    }, props));
}
function renderThumbVerticalDefault(_ref4) {
    var style = _ref4.style, props = _objectWithoutProperties(_ref4, [
        "style"
    ]);
    var finalStyle = _extends({}, style, {
        cursor: "pointer",
        borderRadius: "inherit",
        backgroundColor: "rgba(0,0,0,.2)"
    });
    return _react2["default"].createElement("div", _extends({
        style: finalStyle
    }, props));
}

},{"888e25a1c1e4525c":"6uln9"}],"30h7k":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _base = require("@emotion/styled/base");
var _baseDefault = parcelHelpers.interopDefault(_base);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _colors = require("../../constants/colors");
var _menuCollapseToggle = require("./MenuCollapseToggle");
var _menuCollapseToggleDefault = parcelHelpers.interopDefault(_menuCollapseToggle);
var _useIsMobile = require("../../hooks/UseIsMobile");
var _useIsMobileDefault = parcelHelpers.interopDefault(_useIsMobile);
var _stylesValues = require("../../constants/stylesValues");
var _breakpoints = require("../../constants/breakpoints");
const ExpandedMenuPanel = (props)=>{
    const isMobile = (0, _useIsMobileDefault.default)();
    return (0, _react.jsx)(ExpandedMenuPanelWrapper, {
        isMobile: isMobile
    }, (0, _react.jsx)(HeaderWrapper, {
        isMobile: isMobile
    }, (0, _react.jsx)((0, _menuCollapseToggleDefault.default), {
        isMinified: false,
        onToggle: props.onCollapse,
        expandedMinimizedDrawer: props.minimizedDrawer
    })), (0, _react.jsx)(MenuWrapper, null, props.expandedViewRender()));
};
const HeaderWrapper = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e12m1gv02"
})("width:", ({ isMobile })=>isMobile ? "90vw" : "288px", ";position:relative;display:flex;align-items:center;");
const MenuWrapper = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e12m1gv01"
})("height:calc(100vh - 80px);border-right:", (0, _stylesValues.style_border_default), ";background:white;");
const ExpandedMenuPanelWrapper = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e12m1gv00"
})((0, _breakpoints.breakpoint_small), "{z-index:1;position:fixed;}width:", ({ isMobile })=>isMobile ? "90vw" : "288px", ";.panel-header{max-width:", ({ isMobile })=>isMobile ? "90vw" : "288px", ";}.menu-toggle{width:80px;height:56px;display:flex;align-items:center;justify-content:center;cursor:pointer;img{width:24px;height:24px;}}.highlighted{.inner-toggle{background:", (0, _colors.text_blue), ";}}");
exports.default = ExpandedMenuPanel;

},{"@emotion/styled/base":"lSuFu","@emotion/react":"djZKr","react":"6uln9","../../constants/colors":"1p3OR","./MenuCollapseToggle":"d7R0v","../../hooks/UseIsMobile":"9Gz1L","../../constants/stylesValues":"dHVVv","../../constants/breakpoints":"2F01A","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"dHVVv":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "style_border_default", ()=>style_border_default);
parcelHelpers.export(exports, "style_border_dotted", ()=>style_border_dotted);
parcelHelpers.export(exports, "style_shadow_default", ()=>style_shadow_default);
var _colors = require("./colors");
const style_border_default = `1px solid ${(0, _colors.color_shades_dark)}`;
const style_border_dotted = `1px dotted ${(0, _colors.color_shades_dark)}`;
const style_shadow_default = `0 2px 4px 0 ${(0, _colors.dark_grey_blue_10)}`;

},{"./colors":"1p3OR","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"anVUR":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _base = require("@emotion/styled/base");
var _baseDefault = parcelHelpers.interopDefault(_base);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _colors = require("../../../constants/colors");
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const PanelTitle = (props)=>(0, _react.jsx)("div", {
        className: containerStyle
    }, (0, _react.jsx)(PanelContainerWrapper, null, (0, _react.jsx)("div", {
        className: "title-container"
    }, (0, _react.jsx)(Title, {
        className: props.truncate ? "truncate" : ""
    }, props.title), (0, _react.jsx)("div", {
        className: "buttons"
    }, props.children)), props.subtitle && (0, _react.jsx)(Subtitle, null, props.subtitle)), (0, _react.jsx)("p", null, props.detail));
const Title = /*#__PURE__*/ (0, _baseDefault.default)("h3", {
    target: "e1ty63ln2"
})({
    name: "10j2cjc",
    styles: "&.truncate{white-space:nowrap;overflow:hidden;text-overflow:ellipsis;}"
});
const Subtitle = /*#__PURE__*/ (0, _baseDefault.default)("h4", {
    target: "e1ty63ln1"
})("");
const PanelContainerWrapper = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1ty63ln0"
})({
    name: "1fttcpj",
    styles: "display:flex;flex-direction:column"
});
const containerStyle = /*#__PURE__*/ (0, _css.css)("padding:16px 32px;.title-container{display:flex;align-items:center;.buttons{margin-right:0;margin-left:auto;display:flex;align-items:center;button{margin:0 16px;}}}h3{font-size:24px;line-height:32px;color:", (0, _colors.color_text_default), ";font-style:normal;font-weight:normal;}p{font-size:14px;line-height:20px;color:", (0, _colors.color_text_light), ";margin:16px 0;}", "");
exports.default = PanelTitle;

},{"@emotion/styled/base":"lSuFu","@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","../../../constants/colors":"1p3OR","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"e7QMc":[function(require,module,exports) {
module.exports = require("65b3e50ef3c88bde").getBundleURL("kVLro") + require("3a4b330df82b6425").resolve("a7w3B");

},{"65b3e50ef3c88bde":"c7Tr5","3a4b330df82b6425":"fyJL2"}],"i9vjx":[function(require,module,exports) {
module.exports = require("b67399a155158a74").getBundleURL("kVLro") + require("ec1cedca9c489444").resolve("eJXyL");

},{"b67399a155158a74":"c7Tr5","ec1cedca9c489444":"fyJL2"}],"ec3aw":[function(require,module,exports) {
module.exports = require("5bf9cfeb4611a90f").getBundleURL("kVLro") + require("679df3828a04fe20").resolve("7MWsd");

},{"5bf9cfeb4611a90f":"c7Tr5","679df3828a04fe20":"fyJL2"}],"fqIap":[function(require,module,exports) {
module.exports = require("22ab8585d4160f57").getBundleURL("kVLro") + require("65b2a55dca8bdf9d").resolve("kzVz2");

},{"22ab8585d4160f57":"c7Tr5","65b2a55dca8bdf9d":"fyJL2"}],"7UQC6":[function(require,module,exports) {
module.exports = require("d9b72b2c0da053d7").getBundleURL("kVLro") + require("9c102aee1fbcbf75").resolve("7zeo5");

},{"d9b72b2c0da053d7":"c7Tr5","9c102aee1fbcbf75":"fyJL2"}],"4xPKU":[function(require,module,exports) {
module.exports = require("3b7c46b04738dde6").getBundleURL("kVLro") + require("f9888e5a755505c5").resolve("7a2B3");

},{"3b7c46b04738dde6":"c7Tr5","f9888e5a755505c5":"fyJL2"}],"aWiMy":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _parentContentContainer = require("../../state/containers/ParentContentContainer");
var _parentContentContainerDefault = parcelHelpers.interopDefault(_parentContentContainer);
var _unstated = require("unstated");
var _followUpContainer = require("../../state/containers/FollowUpContainer");
var _followUpContainerDefault = parcelHelpers.interopDefault(_followUpContainer);
var _navigationMenu = require("./components/NavigationMenu");
var _navigationMenuDefault = parcelHelpers.interopDefault(_navigationMenu);
class RelatedContentMenu extends (0, _reactDefault.default).Component {
    render() {
        return (0, _react.jsx)((0, _unstated.Subscribe), {
            to: [
                (0, _parentContentContainerDefault.default),
                (0, _followUpContainerDefault.default)
            ]
        }, (parentContentContainer, followUpContainer)=>(0, _react.jsx)((0, _navigationMenuDefault.default), {
                featureTypeId: this.props.featureTypeId,
                contentId: this.props.contentId,
                followUp: this.props.followUp,
                parentContentContainer: parentContentContainer,
                followUpContainer: followUpContainer,
                conversationItem: this.props.conversationItem,
                onClose: this.props.onClose,
                history: this.props.history,
                onSave: this.props.onSave,
                parentContentId: this.props.parentContentId
            }));
    }
}
exports.default = RelatedContentMenu;

},{"@emotion/react":"djZKr","react":"6uln9","../../state/containers/ParentContentContainer":"jUmVo","unstated":"grh7p","../../state/containers/FollowUpContainer":"rm9OA","./components/NavigationMenu":"hWkZ5","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jUmVo":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _defineProperty = require("@babel/runtime/helpers/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _unstated = require("unstated");
var _api = require("../../api");
class ParentContentContainer extends (0, _unstated.Container) {
    constructor(...args){
        super(...args);
        // default state
        (0, _definePropertyDefault.default)(this, "state", {
            parentContentItems: [],
            isLoading: false,
            errors: []
        });
    }
    getParentContentItems(featureTypeId, contentId) {
        const cacheItem = this.state.parentContentItems.find((p)=>p.contentId == contentId && p.featureTypeId == featureTypeId);
        if (cacheItem) return new Promise((resolve)=>resolve({
                resultType: "Ok",
                errors: null,
                data: cacheItem.contentContainer
            }));
        this.setLoading(true);
        const promise = _api.getParentContentItems(featureTypeId, contentId);
        promise.then((result)=>{
            if (result.resultType == "Ok") {
                const parentContentItems = this.state.parentContentItems;
                parentContentItems.push({
                    contentContainer: result.data,
                    contentId,
                    featureTypeId
                });
                this.setState({
                    ...this.state,
                    errors: [],
                    isLoading: false,
                    parentContentItems
                });
            } else this.setState({
                ...this.state,
                errors: result.errors,
                isLoading: false
            });
        }).catch((error)=>{
            this.setState({
                ...this.state,
                errors: [
                    error
                ],
                isLoading: false
            });
        });
        return promise;
    }
    setLoading(isLoading) {
        this.setState({
            ...this.state,
            isLoading: isLoading
        });
    }
}
exports.default = ParentContentContainer;

},{"@babel/runtime/helpers/defineProperty":"9sJxO","unstated":"grh7p","../../api":"loxM6","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"rm9OA":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _defineProperty = require("@babel/runtime/helpers/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _unstated = require("unstated");
var _api = require("../../api");
class FollowUpContainer extends (0, _unstated.Container) {
    constructor(...args){
        super(...args);
        // default state
        (0, _definePropertyDefault.default)(this, "state", {
            followUps: [],
            isLoading: false,
            isLoadingOne: false,
            errors: [],
            isSaving: false
        });
    }
    clearErrors() {
        this.setState({
            ...this.state,
            errors: []
        });
    }
    getFromId(id) {
        const matched = this.state.followUps.filter((wm)=>wm.id == id);
        if (matched.length > 0) return matched[0];
    }
    findById(id) {
        this.setState({
            ...this.state,
            isLoadingOne: true
        });
        const promise = _api.findFollowUpById(id);
        promise.then((result)=>{
            if (result.resultType == "Ok") {
                const followUps = this.state.followUps;
                const existingFollowUp = followUps.find((f)=>f.id == id);
                if (existingFollowUp) followUps[followUps.indexOf(existingFollowUp)] = result.data;
                else followUps.push(result.data);
                this.setState({
                    ...this.state,
                    isLoadingOne: false,
                    errors: [],
                    followUps: followUps
                });
            } else this.setState({
                ...this.state,
                isLoadingOne: false,
                errors: result.errors
            });
        }).catch((error)=>{
            this.setState({
                ...this.state,
                isLoadingOne: false,
                errors: [
                    error
                ]
            });
        });
        return promise;
    }
    addFollowUp(applicationId, model) {
        this.setSaving(true);
        const addPromise = _api.addFollowUp(applicationId, model);
        addPromise.then((followUpResult)=>{
            if (followUpResult.resultType == "Ok") {
                // add the new message to state immutably;
                const updated = [
                    ...this.state.followUps,
                    followUpResult.data
                ];
                this.setState({
                    ...this.state,
                    followUps: updated,
                    isSaving: false
                });
            } else this.setState({
                ...this.state,
                errors: followUpResult.errors,
                isSaving: false
            });
        }).catch((error)=>{
            console.log(error);
        });
        return addPromise;
    }
    updateFollowUp(followUpId, model) {
        this.setSaving(true);
        var updatePromise = _api.updateFollowUp(model);
        updatePromise.then((followUpResult)=>{
            if (followUpResult.resultType == "Ok") {
                // get immutable copy of array
                const updated = [
                    ...this.state.followUps
                ];
                // now update the item
                updated[updated.findIndex((m)=>m.id == followUpId)] = followUpResult.data;
                this.setState({
                    ...this.state,
                    followUps: updated,
                    isSaving: false
                });
            } else this.setState({
                ...this.state,
                errors: followUpResult.errors,
                isSaving: false
            });
        }).catch((error)=>{
            this.setState({
                ...this.state,
                errors: [
                    error?.toString()
                ],
                isSaving: false
            });
        });
        return updatePromise;
    }
    deleteFollowUp(followUpId) {
        const deletePromise = _api.deleteFollowUp(followUpId);
        deletePromise.then((followUpResult)=>{
            if (followUpResult.resultType == "Ok") {
                // remove the message from state immutably;
                const updated = this.state.followUps.filter((w)=>w.id !== followUpId);
                this.setState({
                    ...this.state,
                    followUps: updated,
                    isSaving: false
                });
            } else this.setState({
                ...this.state,
                errors: followUpResult.errors,
                isSaving: false
            });
        }).catch((error)=>{
            console.log(error);
        });
        return deletePromise;
    }
    getFollowUpForApp(applicationId) {
        this.setLoading(true);
        var promise = _api.getFollowUpsForApp(applicationId);
        promise.then((followUpResult)=>{
            if (followUpResult.resultType == "Ok") this.setState({
                ...this.state,
                errors: [],
                followUps: followUpResult.data,
                isLoading: false
            });
            else this.setState({
                ...this.state,
                errors: followUpResult.errors,
                isLoading: false
            });
        }).catch((error)=>{
            console.log(error);
        });
        return promise;
    }
    setLoading(isLoading) {
        this.setState({
            ...this.state,
            isLoading: isLoading
        });
    }
    setSaving(isSaving) {
        this.setState({
            ...this.state,
            isSaving: isSaving
        });
    }
}
exports.default = FollowUpContainer;

},{"@babel/runtime/helpers/defineProperty":"9sJxO","unstated":"grh7p","../../api":"loxM6","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hWkZ5":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _defineProperty = require("@babel/runtime/helpers/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _parentConversationItemSelector = require("./ParentConversationItemSelector");
var _parentConversationItemSelectorDefault = parcelHelpers.interopDefault(_parentConversationItemSelector);
var _followUps = require("../../../models/extensions/followUps");
var _siblingConversationItemSelector = require("./SiblingConversationItemSelector");
var _siblingConversationItemSelectorDefault = parcelHelpers.interopDefault(_siblingConversationItemSelector);
var _childConversationItemSelector = require("./ChildConversationItemSelector");
var _childConversationItemSelectorDefault = parcelHelpers.interopDefault(_childConversationItemSelector);
var _extensions = require("../../../models/extensions");
class NavigationMenu extends (0, _reactDefault.default).Component {
    constructor(...args){
        super(...args);
        (0, _definePropertyDefault.default)(this, "state", {
            parentItems: null,
            siblingItems: [],
            isSaving: false
        });
    }
    componentDidMount() {
        this.loadParents();
    }
    componentDidUpdate(prevProps) {
        if (prevProps.parentContentId != this.props.parentContentId) this.setState({
            ...this.state,
            isSaving: false
        });
    }
    loadParents() {
        this.props.parentContentContainer.getParentContentItems(this.props.featureTypeId, this.props.contentId).then((result)=>{
            if (result.resultType == "Ok") this.setState({
                ...this.state,
                parentItems: (0, _followUps.mapContentContainerToGenericContentItemModels)(result.data)
            }, this.loadSiblings);
        });
    }
    loadSiblings() {
        if (this.state.parentItems && this.state.parentItems.length > 0) this.state.parentItems.forEach((c)=>{
            if (c.followUpId) this.props.followUpContainer.findById(c.followUpId).then((result)=>{
                if (result.resultType == "Ok") {
                    const siblingItems = this.state.siblingItems;
                    siblingItems.push({
                        parent: c,
                        children: (0, _followUps.mapContentContainerToGenericContentItemModels)(result.data.childContentContainer).filter((c)=>c.id != this.props.contentId)
                    });
                    this.setState({
                        ...this.state,
                        siblingItems: siblingItems
                    });
                }
            });
        });
    }
    navigateToItem(conversationItem) {
        this.props.history.push(`${(0, _extensions.getEditUrl)(conversationItem.id, conversationItem.applicationFeatureId, conversationItem.featureTypeId)}?previousContentId=${this.props.contentId}`);
    }
    handleItemSelected(conversationItem) {
        this.setState({
            ...this.state,
            isSaving: true
        });
        if (this.props.onSave) {
            const promise = this.props.onSave();
            if (!promise) this.setState({
                ...this.state,
                isSaving: false
            });
            else promise.then((result)=>{
                if (result?.resultType == "Ok") {
                    this.setState({
                        ...this.state,
                        isSaving: false
                    });
                    this.navigateToItem(conversationItem);
                } else this.setState({
                    ...this.state,
                    isSaving: false
                });
            }).catch(()=>{
                this.setState({
                    ...this.state,
                    isSaving: false
                });
            });
        } else this.navigateToItem(conversationItem);
    }
    getContextualParent() {
        if (this.state.parentItems && this.props.parentContentId) return this.state.parentItems.find((p)=>p.id == this.props.parentContentId);
        return null;
    }
    render() {
        return (0, _react.jsx)((0, _reactDefault.default).Fragment, null, (0, _react.jsx)((0, _parentConversationItemSelectorDefault.default), {
            currentConversationItem: this.getContextualParent(),
            conversationItems: this.state.parentItems,
            onSelect: this.handleItemSelected.bind(this),
            isLoading: this.props.parentContentContainer.state.isLoading,
            isSaving: this.state.isSaving
        }), (0, _react.jsx)((0, _siblingConversationItemSelectorDefault.default), {
            currentConversationItem: this.props.conversationItem,
            conversationItems: this.state.siblingItems,
            onSelect: this.handleItemSelected.bind(this),
            isLoading: this.props.followUpContainer.state.isLoadingOne,
            isSaving: this.state.isSaving
        }), (0, _react.jsx)((0, _childConversationItemSelectorDefault.default), {
            conversationItems: this.props.followUp?.childContentContainer?.contentItems,
            contextualHelp: this.props.followUp?.helpMessage,
            contextualFallback: this.props.followUp?.fallbackMessage,
            isLoading: this.props.followUpContainer.state.isLoadingOne,
            onSelect: this.handleItemSelected.bind(this),
            isSaving: this.state.isSaving
        }));
    }
}
exports.default = NavigationMenu;

},{"@babel/runtime/helpers/defineProperty":"9sJxO","@emotion/react":"djZKr","react":"6uln9","./ParentConversationItemSelector":"30Oj2","../../../models/extensions/followUps":"2RWn6","./SiblingConversationItemSelector":"6QVHS","./ChildConversationItemSelector":"5QyUq","../../../models/extensions":"7h01B","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"30Oj2":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _defineProperty = require("@babel/runtime/helpers/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _conversationItemSelector = require("./ConversationItemSelector");
var _conversationItemSelectorDefault = parcelHelpers.interopDefault(_conversationItemSelector);
var _secondaryLoader = require("../../../components/general/SecondaryLoader");
var _secondaryLoaderDefault = parcelHelpers.interopDefault(_secondaryLoader);
var _colors = require("../../../constants/colors");
var _navigationSelection = require("./NavigationSelection");
var _navigationSelectionDefault = parcelHelpers.interopDefault(_navigationSelection);
var _contentItemSection = require("./ContentItemSection");
var _contentItemSectionDefault = parcelHelpers.interopDefault(_contentItemSection);
const leadIcon = require("fa2db49c2f998150");
class ParentConversationItemSelector extends (0, _reactDefault.default).Component {
    constructor(...args){
        super(...args);
        (0, _definePropertyDefault.default)(this, "state", {
            isOpen: true
        });
    }
    handleToggle() {
        this.setState({
            ...this.state,
            isOpen: !this.state.isOpen
        });
    }
    render() {
        return (0, _react.jsx)("div", {
            className: `parent-selector ${containerStyle} ${this.state.isOpen ? "open" : ""}`
        }, this.props.isLoading ? (0, _react.jsx)("div", {
            className: "loader-container"
        }, (0, _react.jsx)((0, _secondaryLoaderDefault.default), null)) : (0, _react.jsx)((0, _navigationSelectionDefault.default), {
            isOpen: this.state.isOpen,
            title: "Preceeded by",
            icon: leadIcon,
            count: this.props.conversationItems ? this.props.conversationItems.length : 0,
            onClick: this.handleToggle.bind(this)
        }), this.state.isOpen && !this.props.isLoading ? (0, _react.jsx)((0, _contentItemSectionDefault.default), null, (0, _react.jsx)((0, _conversationItemSelectorDefault.default), {
            conversationItems: this.props.conversationItems,
            isSaving: this.props.isSaving,
            onSelect: this.props.onSelect
        })) : null);
    }
}
const containerStyle = /*#__PURE__*/ (0, _css.css)(".spinner>div{background:", (0, _colors.cool_grey), ";}.loader-container{display:flex;flex:1;align-items:center;justify-content:center;margin:8px;}", "");
exports.default = ParentConversationItemSelector;

},{"@babel/runtime/helpers/defineProperty":"9sJxO","@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","./ConversationItemSelector":"eNouU","../../../components/general/SecondaryLoader":"7zJiF","../../../constants/colors":"1p3OR","./NavigationSelection":"69Syc","./ContentItemSection":"7RnsX","fa2db49c2f998150":"dAasL","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"eNouU":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _colors = require("../../../constants/colors");
var _extensions = require("../../../models/extensions");
var _tooltipWrapper = require("../../../components/general/TooltipWrapper");
var _tooltipWrapperDefault = parcelHelpers.interopDefault(_tooltipWrapper);
const navigationCircle = require("55719349216b2e61");
const ConversationItemSelector = (props)=>(0, _react.jsx)("div", {
        className: containerStyle
    }, props.conversationItems && props.conversationItems.length > 0 ? props.conversationItems?.map((c, i)=>(0, _react.jsx)("div", {
            key: i,
            className: "conversation-item",
            onClick: ()=>props.onSelect(c)
        }, (0, _react.jsx)((0, _tooltipWrapperDefault.default), {
            text: (0, _extensions.getDefaultFeatureTypeName)(c.featureTypeId),
            place: "top"
        }, (0, _react.jsx)("img", {
            src: (0, _extensions.getFeatureTypeIcon)(c.featureTypeId)
        })), (0, _react.jsx)((0, _tooltipWrapperDefault.default), {
            text: c.title,
            place: "top"
        }, (0, _react.jsx)("p", {
            className: "content-title"
        }, (0, _react.jsx)("i", null, c.titleAttribute), c.title)), (0, _react.jsx)((0, _tooltipWrapperDefault.default), {
            text: "Click to save and go to this item",
            place: "top"
        }, (0, _react.jsx)("img", {
            className: "end",
            src: navigationCircle
        })))) : (0, _react.jsx)("p", {
        className: "empty-label"
    }, "No conversation items here"));
const containerStyle = /*#__PURE__*/ (0, _css.css)("background:", (0, _colors.color_shades_lighter), ";padding:16px;.empty-label{margin:0;background:white;font-size:12px;border:1px solid ", (0, _colors.color_shades_dark), ";padding:16px;border-radius:8px;}.conversation-item{border-bottom:1px solid ", (0, _colors.color_shades_dark), ";border-left:1px solid ", (0, _colors.color_shades_dark), ";border-right:1px solid ", (0, _colors.color_shades_dark), ";background:white;display:flex;align-items:center;padding:0 16px;height:48px;cursor:pointer;p{margin:0 12px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;}img{width:24px;height:24px;}.end{margin-right:0;margin-left:auto;}:first-child{border-top:1px solid ", (0, _colors.color_shades_dark), ";border-top-right-radius:8px;border-top-left-radius:8px;}:last-child{border-bottom-right-radius:8px;border-bottom-left-radius:8px;}}", "");
exports.default = ConversationItemSelector;

},{"@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","../../../constants/colors":"1p3OR","../../../models/extensions":"7h01B","../../../components/general/TooltipWrapper":"53pWd","55719349216b2e61":"lU5KX","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7h01B":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "addOrReplace", ()=>addOrReplace);
parcelHelpers.export(exports, "reorder", ()=>reorder);
var _applicationFeature = require("./applicationFeature");
parcelHelpers.exportAll(_applicationFeature, exports);
const addOrReplace = (array, item)=>{
    // (1)
    const i = array.findIndex((_item)=>_item.id === item.id);
    if (i > -1) array[i] = item; // (2)
    else array.push(item);
};
const reorder = (list, startIndex, endIndex)=>{
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);
    return result;
};

},{"./applicationFeature":"bfJBK","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"bfJBK":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getFeatureCreateUrl", ()=>getFeatureCreateUrl);
parcelHelpers.export(exports, "getFeatureTypeCreateUrl", ()=>getFeatureTypeCreateUrl);
parcelHelpers.export(exports, "getFeatureUrl", ()=>getFeatureUrl);
parcelHelpers.export(exports, "getFeatureContentUrl", ()=>getFeatureContentUrl);
parcelHelpers.export(exports, "getFeatureIdUrl", ()=>getFeatureIdUrl);
parcelHelpers.export(exports, "getEditUrl", ()=>getEditUrl);
parcelHelpers.export(exports, "getPrettyEditUrl", ()=>getPrettyEditUrl);
parcelHelpers.export(exports, "getDefaultFeatureTypeName", ()=>getDefaultFeatureTypeName);
parcelHelpers.export(exports, "getIcon", ()=>getIcon);
parcelHelpers.export(exports, "getFeatureIcon", ()=>getFeatureIcon);
parcelHelpers.export(exports, "getFeatureTypeIcon", ()=>getFeatureTypeIcon);
parcelHelpers.export(exports, "getSmallFeatureTypeIcon", ()=>getSmallFeatureTypeIcon);
parcelHelpers.export(exports, "getSmallLightFeatureTypeIcon", ()=>getSmallLightFeatureTypeIcon);
var _featureTypeIds = require("../../constants/featureTypeIds");
const faqIcon = require("bbbcf049c87bd645");
const latestMessagesIcon = require("f309a02bae25de41");
const simpleChoiceIcon = require("d7961d1192271d7a");
const rangeIcon = require("90899116ae185746");
const helpIcon = require("8556e881af4f2dd2");
const fallbackIcon = require("193b039d3d229c59");
const welcomeIcon = require("e17a3c39e0c4c51d");
const exitIcon = require("179471d64332a462");
const faqIconBlack = require("ba93b21909ca9ead");
const latestMessagesIconBlack = require("c6c4bbc18f18f7c6");
const simpleChoiceIconBlack = require("2a78b4c71f67f07a");
const rangeIconBlack = require("fec5be5a2ae827dc");
const helpIconBlack = require("fe783a53036fe37a");
const fallbackIconBlack = require("bc9f707f9a6fd57");
const welcomeIconBlack = require("c423226ea611c09c");
const exitIconBlack = require("de54896dd6cda145");
const customRequestIcon = require("245d36caf1bc044a");
const customRequestIconBlack = require("ca593a267547c12b");
const questionAnswerSmall = require("1e688b0bff367632");
const customSmall = require("8c13509ded126bba");
const exitSmall = require("ced191c992ee014a");
const fallbackSmall = require("f00e3258f97043c2");
const helpSmall = require("b2a7c86f8c53088f");
const latestSmall = require("53fb3f049caf3f8b");
const navigationSmall = require("b98d11cb51632341");
const numberSmall = require("6e900fe8d23d6bca");
const welcomeSmall = require("29e29001e51bb773");
const simpleChoiceSmall = require("400746264c74a4fe");
const questionAnswerSmallLight = require("d37722441cc0558");
const customSmallLight = require("682ba347f9d2ffb3");
const exitSmallLight = require("b7cd8dbea981d93b");
const fallbackSmallLight = require("b0dea0108308ad41");
const helpSmallLight = require("dbcf0a62df978d00");
const latestSmallLight = require("25fc8662554519bf");
const navigationSmallLight = require("f4a08638acfcab08");
const numberSmallLight = require("b31fd86577153f5d");
const welcomeSmallLight = require("dc94dd7fb56c5bbf");
const simpleChoiceSmallLight = require("c4315b1060b315de");
function getFeatureCreateUrl(applicationFeature) {
    return getFeatureTypeCreateUrl(applicationFeature.feature.featureType.id, applicationFeature.id);
}
function getFeatureTypeCreateUrl(featureTypeId, applicationFeatureId) {
    switch(featureTypeId){
        case 0, _featureTypeIds.WelcomeMessagesFeatureTypeId:
            return `/v/${applicationFeatureId}/new/welcomemessage/`;
        case 0, _featureTypeIds.QuestionAnswerFeatureTypeId:
            return `/v/${applicationFeatureId}/new/faq/`;
        case 0, _featureTypeIds.ExitMessagesFeatureTypeId:
            return `/v/${applicationFeatureId}/new/exitmessage/`;
        case 0, _featureTypeIds.LatestMessagesFeatureTypeId:
            return `/v/${applicationFeatureId}/new/latestmessage/`;
        case 0, _featureTypeIds.HelpMessagesFeatureTypeId:
            return `/v/${applicationFeatureId}/new/helpmessage/`;
        case 0, _featureTypeIds.FallbackFeatureTypeId:
            return `/v/${applicationFeatureId}/new/fallbackmessage/`;
        case 0, _featureTypeIds.NumberRangeFeatureTypeId:
            return `/v/${applicationFeatureId}/new/numberrange/`;
        case 0, _featureTypeIds.SimpleChoiceFeatureTypeId:
            return `/v/${applicationFeatureId}/new/simplechoice/`;
        case 0, _featureTypeIds.CustomRequestsFeatureTypeId:
            return `/v/${applicationFeatureId}/new/customRequest/`;
    }
}
function getFeatureUrl(applicationFeature) {
    return `/v/apps/${applicationFeature.applicationId}/content/${applicationFeature.id}`;
// return getFeatureIdUrl(applicationFeature.feature.featureType.id, applicationFeature.id);
}
function getFeatureContentUrl(applicationId, applicationFeatureId) {
    return `/v/apps/${applicationId}/content/${applicationFeatureId}`;
}
function getFeatureIdUrl(featureTypeId, applicationFeatureId) {
    switch(featureTypeId){
        case 0, _featureTypeIds.WelcomeMessagesFeatureTypeId:
            return `/v/${applicationFeatureId}/welcomemessages/`;
        case 0, _featureTypeIds.QuestionAnswerFeatureTypeId:
            return `/v/${applicationFeatureId}/faqs/`;
        case 0, _featureTypeIds.ExitMessagesFeatureTypeId:
            return `/v/${applicationFeatureId}/exitmessages/`;
        case 0, _featureTypeIds.LatestMessagesFeatureTypeId:
            return `/v/${applicationFeatureId}/latestmessages/`;
        case 0, _featureTypeIds.HelpMessagesFeatureTypeId:
            return `/v/${applicationFeatureId}/helpmessages/`;
        case 0, _featureTypeIds.FallbackFeatureTypeId:
            return `/v/${applicationFeatureId}/fallbackmessages/`;
        case 0, _featureTypeIds.NumberRangeFeatureTypeId:
            return `/v/${applicationFeatureId}/numberranges/`;
        case 0, _featureTypeIds.SimpleChoiceFeatureTypeId:
            return `/v/${applicationFeatureId}/simplechoices/`;
        case 0, _featureTypeIds.CustomRequestsFeatureTypeId:
            return `/v/${applicationFeatureId}/customrequests/`;
    }
}
function getEditUrl(contentId, applicationFeatureId, featureTypeId) {
    switch(featureTypeId){
        case 0, _featureTypeIds.WelcomeMessagesFeatureTypeId:
            return `/v/${applicationFeatureId}/welcomemessages/${contentId}/`;
        case 0, _featureTypeIds.QuestionAnswerFeatureTypeId:
            return `/v/${applicationFeatureId}/faqs/${contentId}/`;
        case 0, _featureTypeIds.ExitMessagesFeatureTypeId:
            return `/v/${applicationFeatureId}/exitmessages/${contentId}/`;
        case 0, _featureTypeIds.LatestMessagesFeatureTypeId:
            return `/v/${applicationFeatureId}/latestmessages/${contentId}/`;
        case 0, _featureTypeIds.HelpMessagesFeatureTypeId:
            return `/v/${applicationFeatureId}/helpmessages/${contentId}/`;
        case 0, _featureTypeIds.FallbackFeatureTypeId:
            return `/v/${applicationFeatureId}/fallbackmessages/${contentId}/`;
        case 0, _featureTypeIds.NumberRangeFeatureTypeId:
            return `/v/${applicationFeatureId}/numberranges/${contentId}/`;
        case 0, _featureTypeIds.SimpleChoiceFeatureTypeId:
            return `/v/${applicationFeatureId}/simplechoices/${contentId}/`;
        case 0, _featureTypeIds.CustomRequestsFeatureTypeId:
            return `/v/${applicationFeatureId}/customrequests/${contentId}/`;
    }
}
function getPrettyEditUrl(contentId, featureTypeId) {
    switch(featureTypeId){
        case 0, _featureTypeIds.WelcomeMessagesFeatureTypeId:
            return `Welcome Message: ${contentId}`;
        case 0, _featureTypeIds.QuestionAnswerFeatureTypeId:
            return `Question Answer: ${contentId}`;
        case 0, _featureTypeIds.ExitMessagesFeatureTypeId:
            return `Exit Message: ${contentId}`;
        case 0, _featureTypeIds.LatestMessagesFeatureTypeId:
            return `Latest Message: ${contentId}`;
        case 0, _featureTypeIds.HelpMessagesFeatureTypeId:
            return `Help Message: ${contentId}`;
        case 0, _featureTypeIds.FallbackFeatureTypeId:
            return `Fallback Message: ${contentId}`;
        case 0, _featureTypeIds.NumberRangeFeatureTypeId:
            return `Number Range: ${contentId}`;
        case 0, _featureTypeIds.SimpleChoiceFeatureTypeId:
            return `Simple Choice: ${contentId}`;
        case 0, _featureTypeIds.CustomRequestsFeatureTypeId:
            return `Custom Request: ${contentId}`;
    }
}
const getDefaultFeatureTypeName = (featureTypeId)=>{
    switch(featureTypeId){
        case 0, _featureTypeIds.WelcomeMessagesFeatureTypeId:
            return "Welcome Message";
        case 0, _featureTypeIds.QuestionAnswerFeatureTypeId:
            return "Question and Answer";
        case 0, _featureTypeIds.ExitMessagesFeatureTypeId:
            return "Exit Message";
        case 0, _featureTypeIds.LatestMessagesFeatureTypeId:
            return "Latest Message";
        case 0, _featureTypeIds.HelpMessagesFeatureTypeId:
            return "Help Message";
        case 0, _featureTypeIds.FallbackFeatureTypeId:
            return "Fallback Message";
        case 0, _featureTypeIds.NumberRangeFeatureTypeId:
            return "Number / Range";
        case 0, _featureTypeIds.SimpleChoiceFeatureTypeId:
            return "Simple Choice";
        case 0, _featureTypeIds.CustomRequestsFeatureTypeId:
            return "Custom Request";
    }
};
const getIcon = (appFeature)=>{
    return getFeatureIcon(appFeature.feature);
};
const getFeatureIcon = (feature)=>{
    return getFeatureTypeIcon(feature.featureType.id);
};
const getFeatureTypeIcon = (featureTypeId, blackVersion)=>{
    if (blackVersion == null || blackVersion === false) switch(featureTypeId){
        case 0, _featureTypeIds.QuestionAnswerFeatureTypeId:
            return faqIcon;
        case 0, _featureTypeIds.LatestMessagesFeatureTypeId:
            return latestMessagesIcon;
        case 0, _featureTypeIds.SimpleChoiceFeatureTypeId:
            return simpleChoiceIcon;
        case 0, _featureTypeIds.NumberRangeFeatureTypeId:
            return rangeIcon;
        case 0, _featureTypeIds.HelpMessagesFeatureTypeId:
            return helpIcon;
        case 0, _featureTypeIds.FallbackFeatureTypeId:
            return fallbackIcon;
        case 0, _featureTypeIds.WelcomeMessagesFeatureTypeId:
            return welcomeIcon;
        case 0, _featureTypeIds.ExitMessagesFeatureTypeId:
            return exitIcon;
        case 0, _featureTypeIds.CustomRequestsFeatureTypeId:
            return customRequestIcon;
    }
    else switch(featureTypeId){
        case 0, _featureTypeIds.QuestionAnswerFeatureTypeId:
            return faqIconBlack;
        case 0, _featureTypeIds.LatestMessagesFeatureTypeId:
            return latestMessagesIconBlack;
        case 0, _featureTypeIds.SimpleChoiceFeatureTypeId:
            return simpleChoiceIconBlack;
        case 0, _featureTypeIds.NumberRangeFeatureTypeId:
            return rangeIconBlack;
        case 0, _featureTypeIds.HelpMessagesFeatureTypeId:
            return helpIconBlack;
        case 0, _featureTypeIds.FallbackFeatureTypeId:
            return fallbackIconBlack;
        case 0, _featureTypeIds.WelcomeMessagesFeatureTypeId:
            return welcomeIconBlack;
        case 0, _featureTypeIds.ExitMessagesFeatureTypeId:
            return exitIconBlack;
        case 0, _featureTypeIds.CustomRequestsFeatureTypeId:
            return customRequestIconBlack;
    }
    return "";
};
const getSmallFeatureTypeIcon = (featureTypeId)=>{
    switch(featureTypeId){
        case 0, _featureTypeIds.QuestionAnswerFeatureTypeId:
            return questionAnswerSmall;
        case 0, _featureTypeIds.LatestMessagesFeatureTypeId:
            return latestSmall;
        case 0, _featureTypeIds.SimpleChoiceFeatureTypeId:
            return simpleChoiceSmall;
        case 0, _featureTypeIds.NumberRangeFeatureTypeId:
            return numberSmall;
        case 0, _featureTypeIds.HelpMessagesFeatureTypeId:
            return helpSmall;
        case 0, _featureTypeIds.FallbackFeatureTypeId:
            return fallbackSmall;
        case 0, _featureTypeIds.WelcomeMessagesFeatureTypeId:
            return welcomeSmall;
        case 0, _featureTypeIds.ExitMessagesFeatureTypeId:
            return exitSmall;
        case 0, _featureTypeIds.CustomRequestsFeatureTypeId:
            return customSmall;
    }
    return "";
};
const getSmallLightFeatureTypeIcon = (featureTypeId)=>{
    switch(featureTypeId){
        case 0, _featureTypeIds.QuestionAnswerFeatureTypeId:
            return questionAnswerSmallLight;
        case 0, _featureTypeIds.LatestMessagesFeatureTypeId:
            return latestSmallLight;
        case 0, _featureTypeIds.SimpleChoiceFeatureTypeId:
            return simpleChoiceSmallLight;
        case 0, _featureTypeIds.NumberRangeFeatureTypeId:
            return numberSmallLight;
        case 0, _featureTypeIds.HelpMessagesFeatureTypeId:
            return helpSmallLight;
        case 0, _featureTypeIds.FallbackFeatureTypeId:
            return fallbackSmallLight;
        case 0, _featureTypeIds.WelcomeMessagesFeatureTypeId:
            return welcomeSmallLight;
        case 0, _featureTypeIds.ExitMessagesFeatureTypeId:
            return exitSmallLight;
        case 0, _featureTypeIds.CustomRequestsFeatureTypeId:
            return customSmallLight;
    }
    return "";
};

},{"../../constants/featureTypeIds":"hPLMP","bbbcf049c87bd645":"8x0sd","f309a02bae25de41":"9kpOS","d7961d1192271d7a":"aOlKa","90899116ae185746":"2e7xv","8556e881af4f2dd2":"ap0m4","193b039d3d229c59":"konVt","e17a3c39e0c4c51d":"22Azq","179471d64332a462":"1Tmh3","ba93b21909ca9ead":"eMiAT","c6c4bbc18f18f7c6":"57f3W","2a78b4c71f67f07a":"dTz0Q","fec5be5a2ae827dc":"ifAm4","fe783a53036fe37a":"cIZRM","bc9f707f9a6fd57":"eam4y","c423226ea611c09c":"lHDr5","de54896dd6cda145":"9OCAY","245d36caf1bc044a":"cfwfL","ca593a267547c12b":"9YmgV","1e688b0bff367632":"fTrUY","8c13509ded126bba":"jLq4X","ced191c992ee014a":"5lS9R","f00e3258f97043c2":"itDcf","b2a7c86f8c53088f":"1LKfj","53fb3f049caf3f8b":"kmjIH","b98d11cb51632341":"707G5","6e900fe8d23d6bca":"ercEu","29e29001e51bb773":"918Z1","400746264c74a4fe":"8AHbS","d37722441cc0558":"6R8dG","682ba347f9d2ffb3":"ikRqQ","b7cd8dbea981d93b":"fu5ux","b0dea0108308ad41":"3sCot","dbcf0a62df978d00":"7IEel","25fc8662554519bf":"2EN93","f4a08638acfcab08":"iR60o","b31fd86577153f5d":"EHGOB","dc94dd7fb56c5bbf":"5C2kB","c4315b1060b315de":"aO3JF","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8x0sd":[function(require,module,exports) {
module.exports = require("8961e3807a98dd44").getBundleURL("kVLro") + require("6baa292b98942e53").resolve("eNuQS");

},{"8961e3807a98dd44":"c7Tr5","6baa292b98942e53":"fyJL2"}],"9kpOS":[function(require,module,exports) {
module.exports = require("798a46f85c6b5335").getBundleURL("kVLro") + require("911c7c9049c81d32").resolve("gLg3b");

},{"798a46f85c6b5335":"c7Tr5","911c7c9049c81d32":"fyJL2"}],"aOlKa":[function(require,module,exports) {
module.exports = require("2a3f4b86eda0229b").getBundleURL("kVLro") + require("391edae7769a366d").resolve("aJjMB");

},{"2a3f4b86eda0229b":"c7Tr5","391edae7769a366d":"fyJL2"}],"2e7xv":[function(require,module,exports) {
module.exports = require("1e24403501cacdcf").getBundleURL("kVLro") + require("39c029b1c0be0c62").resolve("694hi");

},{"1e24403501cacdcf":"c7Tr5","39c029b1c0be0c62":"fyJL2"}],"ap0m4":[function(require,module,exports) {
module.exports = require("c819f8876b5af355").getBundleURL("kVLro") + require("cef3ae350f745dc").resolve("6zFBz");

},{"c819f8876b5af355":"c7Tr5","cef3ae350f745dc":"fyJL2"}],"konVt":[function(require,module,exports) {
module.exports = require("6ff2af40de36b94").getBundleURL("kVLro") + require("17bd9ff24a2c8b6").resolve("4jT1c");

},{"6ff2af40de36b94":"c7Tr5","17bd9ff24a2c8b6":"fyJL2"}],"22Azq":[function(require,module,exports) {
module.exports = require("ef202c5e5b46bcdb").getBundleURL("kVLro") + require("1d918daff1bfca4f").resolve("hxJaI");

},{"ef202c5e5b46bcdb":"c7Tr5","1d918daff1bfca4f":"fyJL2"}],"1Tmh3":[function(require,module,exports) {
module.exports = require("944630b3f29dec89").getBundleURL("kVLro") + require("957851ee67d2396d").resolve("9lV3J");

},{"944630b3f29dec89":"c7Tr5","957851ee67d2396d":"fyJL2"}],"eMiAT":[function(require,module,exports) {
module.exports = require("4a41e610625e3d53").getBundleURL("kVLro") + require("eb3c1bef6ea3d0ee").resolve("1yJ2U");

},{"4a41e610625e3d53":"c7Tr5","eb3c1bef6ea3d0ee":"fyJL2"}],"57f3W":[function(require,module,exports) {
module.exports = require("ecda7063bd5b4c80").getBundleURL("kVLro") + require("d8f55e9a25c60536").resolve("5Qffr");

},{"ecda7063bd5b4c80":"c7Tr5","d8f55e9a25c60536":"fyJL2"}],"dTz0Q":[function(require,module,exports) {
module.exports = require("c79fda2595f44107").getBundleURL("kVLro") + require("29577bf85ea20e73").resolve("lfb82");

},{"c79fda2595f44107":"c7Tr5","29577bf85ea20e73":"fyJL2"}],"ifAm4":[function(require,module,exports) {
module.exports = require("82030adf0003746f").getBundleURL("kVLro") + require("fe25160fc13e61a4").resolve("94c9z");

},{"82030adf0003746f":"c7Tr5","fe25160fc13e61a4":"fyJL2"}],"cIZRM":[function(require,module,exports) {
module.exports = require("f083d47d2b22baf0").getBundleURL("kVLro") + require("15302a0441d4e039").resolve("ll3Wx");

},{"f083d47d2b22baf0":"c7Tr5","15302a0441d4e039":"fyJL2"}],"eam4y":[function(require,module,exports) {
module.exports = require("a43a836a47701ede").getBundleURL("kVLro") + require("86d63fff4604d221").resolve("hO2tL");

},{"a43a836a47701ede":"c7Tr5","86d63fff4604d221":"fyJL2"}],"lHDr5":[function(require,module,exports) {
module.exports = require("5cc9b8ec989e1b9").getBundleURL("kVLro") + require("e801655fbdf65000").resolve("jFtCF");

},{"5cc9b8ec989e1b9":"c7Tr5","e801655fbdf65000":"fyJL2"}],"9OCAY":[function(require,module,exports) {
module.exports = require("2b81338252abbe1f").getBundleURL("kVLro") + require("5554d46a7f3583c4").resolve("g9rFZ");

},{"2b81338252abbe1f":"c7Tr5","5554d46a7f3583c4":"fyJL2"}],"cfwfL":[function(require,module,exports) {
module.exports = require("a119f002e46065dc").getBundleURL("kVLro") + require("e1dde238ff146562").resolve("48tKu");

},{"a119f002e46065dc":"c7Tr5","e1dde238ff146562":"fyJL2"}],"9YmgV":[function(require,module,exports) {
module.exports = require("120352e5e888c16b").getBundleURL("kVLro") + require("b41c55f9d1b0a232").resolve("kB08S");

},{"120352e5e888c16b":"c7Tr5","b41c55f9d1b0a232":"fyJL2"}],"fTrUY":[function(require,module,exports) {
module.exports = require("6d53a76620666d27").getBundleURL("kVLro") + require("a68f240b97d9d81b").resolve("9fGwk");

},{"6d53a76620666d27":"c7Tr5","a68f240b97d9d81b":"fyJL2"}],"jLq4X":[function(require,module,exports) {
module.exports = require("e8d42b735c7ee253").getBundleURL("kVLro") + require("ff8915cd5736d29a").resolve("dnJgz");

},{"e8d42b735c7ee253":"c7Tr5","ff8915cd5736d29a":"fyJL2"}],"5lS9R":[function(require,module,exports) {
module.exports = require("672580efc8a1bbf9").getBundleURL("kVLro") + require("91392c6fdeb4a36c").resolve("VUPwi");

},{"672580efc8a1bbf9":"c7Tr5","91392c6fdeb4a36c":"fyJL2"}],"itDcf":[function(require,module,exports) {
module.exports = require("955df62c8f587305").getBundleURL("kVLro") + require("21f6e419272871f9").resolve("g6EQx");

},{"955df62c8f587305":"c7Tr5","21f6e419272871f9":"fyJL2"}],"1LKfj":[function(require,module,exports) {
module.exports = require("244e34dc32f2e87").getBundleURL("kVLro") + require("4ff4438ab90dc209").resolve("b5qwP");

},{"244e34dc32f2e87":"c7Tr5","4ff4438ab90dc209":"fyJL2"}],"kmjIH":[function(require,module,exports) {
module.exports = require("11b8529c4df08667").getBundleURL("kVLro") + require("43e71f1efa150368").resolve("iL3Aj");

},{"11b8529c4df08667":"c7Tr5","43e71f1efa150368":"fyJL2"}],"707G5":[function(require,module,exports) {
module.exports = require("b53ec36a1a9204f5").getBundleURL("kVLro") + require("8c6762b8b87cd4b4").resolve("gX2cM");

},{"b53ec36a1a9204f5":"c7Tr5","8c6762b8b87cd4b4":"fyJL2"}],"ercEu":[function(require,module,exports) {
module.exports = require("c8530364697962b9").getBundleURL("kVLro") + require("c6222f11cd243b80").resolve("co1Kx");

},{"c8530364697962b9":"c7Tr5","c6222f11cd243b80":"fyJL2"}],"918Z1":[function(require,module,exports) {
module.exports = require("8d7ddc4589b6718e").getBundleURL("kVLro") + require("1fcb6f84f1fdeadc").resolve("eqlSi");

},{"8d7ddc4589b6718e":"c7Tr5","1fcb6f84f1fdeadc":"fyJL2"}],"8AHbS":[function(require,module,exports) {
module.exports = require("ddc1687e7d280df").getBundleURL("kVLro") + require("5d3af5bda27fe9f8").resolve("g9pfy");

},{"ddc1687e7d280df":"c7Tr5","5d3af5bda27fe9f8":"fyJL2"}],"6R8dG":[function(require,module,exports) {
module.exports = require("eb8ade82c3065fe5").getBundleURL("kVLro") + require("4de66aca6763ed29").resolve("jquKo");

},{"eb8ade82c3065fe5":"c7Tr5","4de66aca6763ed29":"fyJL2"}],"ikRqQ":[function(require,module,exports) {
module.exports = require("870f66afa70e6caf").getBundleURL("kVLro") + require("9f4b1086c1bfb4ab").resolve("8El8z");

},{"870f66afa70e6caf":"c7Tr5","9f4b1086c1bfb4ab":"fyJL2"}],"fu5ux":[function(require,module,exports) {
module.exports = require("ff3433ee630cc494").getBundleURL("kVLro") + require("5cfbef14e78e067a").resolve("dKXQ2");

},{"ff3433ee630cc494":"c7Tr5","5cfbef14e78e067a":"fyJL2"}],"3sCot":[function(require,module,exports) {
module.exports = require("b0df2787510359e9").getBundleURL("kVLro") + require("87b12f37c030dd41").resolve("fYr1j");

},{"b0df2787510359e9":"c7Tr5","87b12f37c030dd41":"fyJL2"}],"7IEel":[function(require,module,exports) {
module.exports = require("c59bd538c905eb5c").getBundleURL("kVLro") + require("c4c183360dc885af").resolve("6eend");

},{"c59bd538c905eb5c":"c7Tr5","c4c183360dc885af":"fyJL2"}],"2EN93":[function(require,module,exports) {
module.exports = require("861d09343567d8c3").getBundleURL("kVLro") + require("b74f3fd1dfc2e24e").resolve("b9xfz");

},{"861d09343567d8c3":"c7Tr5","b74f3fd1dfc2e24e":"fyJL2"}],"iR60o":[function(require,module,exports) {
module.exports = require("4c4ee9e107ae349a").getBundleURL("kVLro") + require("29d32299ad138031").resolve("9dVPs");

},{"4c4ee9e107ae349a":"c7Tr5","29d32299ad138031":"fyJL2"}],"EHGOB":[function(require,module,exports) {
module.exports = require("fec4329963a2a3c").getBundleURL("kVLro") + require("7a4a1437f1f031c3").resolve("atgG8");

},{"fec4329963a2a3c":"c7Tr5","7a4a1437f1f031c3":"fyJL2"}],"5C2kB":[function(require,module,exports) {
module.exports = require("6b87acf92b6ef9e3").getBundleURL("kVLro") + require("ae19ef8a239e7d1").resolve("lnayU");

},{"6b87acf92b6ef9e3":"c7Tr5","ae19ef8a239e7d1":"fyJL2"}],"aO3JF":[function(require,module,exports) {
module.exports = require("31e06a1ccccccbac").getBundleURL("kVLro") + require("ac97cf0977fe0b2b").resolve("4kJbc");

},{"31e06a1ccccccbac":"c7Tr5","ac97cf0977fe0b2b":"fyJL2"}],"lU5KX":[function(require,module,exports) {
module.exports = require("53e07d498b6dd152").getBundleURL("kVLro") + require("c964392b66d8a120").resolve("9iHZF");

},{"53e07d498b6dd152":"c7Tr5","c964392b66d8a120":"fyJL2"}],"69Syc":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _colors = require("../../../constants/colors");
const NavigationSelection = (props)=>(0, _react.jsx)("div", {
        className: containerStyle,
        onClick: props.onClick
    }, (0, _react.jsx)("div", {
        className: "triangle-container"
    }, (0, _react.jsx)("div", {
        className: props.isOpen ? "triangle-down" : "triangle-right"
    })), (0, _react.jsx)("img", {
        src: props.icon
    }), (0, _react.jsx)("p", {
        className: "section-title"
    }, props.title), (0, _react.jsx)("div", {
        className: "count-wrapper"
    }, (0, _react.jsx)("p", {
        className: "count"
    }, props.count ?? "0")));
const containerStyle = /*#__PURE__*/ (0, _css.css)("display:flex;align-items:center;border-bottom:1px solid ", (0, _colors.color_shades_dark), ";height:48px;padding:0 32px 0 24px;cursor:pointer;.triangle-container{width:3px;height:3px;}.triangle-down{width:0;height:0;border-left:3px solid transparent;border-right:3px solid transparent;border-top:3px solid ", (0, _colors.color_shades_darkest), ";}.triangle-right{width:0;height:0;border-top:3px solid transparent;border-bottom:3px solid transparent;border-left:3px solid ", (0, _colors.color_shades_darkest), ";}img{margin:0 16px 0 12px;}.count-wrapper{display:flex;align-items:center;justify-content:center;border-radius:50%;background:", (0, _colors.color_shades_lighter), ";width:24px;height:24px;margin-left:auto;margin-right:0;}.p{color:", (0, _colors.color_text_default), ";font-size:14px;line-height:20px;}", "");
exports.default = NavigationSelection;

},{"@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","../../../constants/colors":"1p3OR","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7RnsX":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _colors = require("../../../constants/colors");
const containerStyle = /*#__PURE__*/ (0, _css.css)("border-bottom:1px solid ", (0, _colors.color_shades_dark), ";", "");
const ContentItemSection = (props)=>(0, _react.jsx)("div", {
        className: containerStyle
    }, props.children);
exports.default = ContentItemSection;

},{"@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","../../../constants/colors":"1p3OR","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"dAasL":[function(require,module,exports) {
module.exports = require("94d05a37ebacd7bc").getBundleURL("kVLro") + require("4ef6835140d06078").resolve("gHFTp");

},{"94d05a37ebacd7bc":"c7Tr5","4ef6835140d06078":"fyJL2"}],"2RWn6":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "mapFollowUpChildrenToIds", ()=>mapFollowUpChildrenToIds);
parcelHelpers.export(exports, "mapFollowUpChildrenToGenericContentItemModels", ()=>mapFollowUpChildrenToGenericContentItemModels);
parcelHelpers.export(exports, "mapContentContainerToGenericContentItemModels", ()=>mapContentContainerToGenericContentItemModels);
parcelHelpers.export(exports, "getNumberRangePrefix", ()=>getNumberRangePrefix);
parcelHelpers.export(exports, "mapGeneralItemsToIds", ()=>mapGeneralItemsToIds);
var _featureTypeIds = require("../../constants/featureTypeIds");
var _lodash = require("lodash");
var _lodashDefault = parcelHelpers.interopDefault(_lodash);
const mapFollowUpChildrenToIds = (followUp)=>{
    if (!followUp || !followUp.childContentContainer) return null;
    return {
        applicationId: followUp.childContentContainer.applicationId,
        isLimitedToChildren: followUp.childContentContainer.isLimitedToChildren,
        questionAnswerIds: followUp.childContentContainer.contentItems.filter((c)=>c.featureTypeId == (0, _featureTypeIds.QuestionAnswerFeatureTypeId)).map((r)=>r.id),
        latestMessageIds: followUp.childContentContainer.contentItems.filter((c)=>c.featureTypeId == (0, _featureTypeIds.LatestMessagesFeatureTypeId)).map((r)=>r.id),
        simpleChoiceIds: followUp.childContentContainer.contentItems.filter((c)=>c.featureTypeId == (0, _featureTypeIds.SimpleChoiceFeatureTypeId)).map((r)=>r.id),
        numberRangeIds: followUp.childContentContainer.contentItems.filter((c)=>c.featureTypeId == (0, _featureTypeIds.NumberRangeFeatureTypeId)).map((r)=>r.id),
        customRequestIds: followUp.childContentContainer.contentItems.filter((c)=>c.featureTypeId == (0, _featureTypeIds.CustomRequestsFeatureTypeId)).map((r)=>r.id)
    };
};
const mapFollowUpChildrenToGenericContentItemModels = (followUp)=>{
    if (!followUp || !followUp.childContentContainer) return null;
    const conversationItems = followUp.childContentContainer.contentItems.map((c)=>({
            ...c,
            isEditing: false
        }));
    return {
        conversationItems,
        isLimitedToChildren: followUp.childContentContainer.isLimitedToChildren,
        applicationId: followUp.applicationId
    };
};
const mapContentContainerToGenericContentItemModels = (contentContainer)=>{
    if (!contentContainer) return null;
    const conversationItems = contentContainer.contentItems.map((c)=>({
            ...c,
            isEditing: false
        }));
    return (0, _lodashDefault.default).uniqBy(conversationItems, "id");
};
function getNumberRangePrefix(min, max) {
    if (min != null && max != null) return min == max ? `${min}: ` : `${min}-${max}: `;
    if (min != null) return `>${min}: `;
    if (max != null) return `<${max}: `;
    return null;
}
const mapGeneralItemsToIds = (conversationItemsContainer)=>{
    if (!conversationItemsContainer || !conversationItemsContainer.contentItems) return;
    const { isLimitedToChildren, applicationId, contentItems } = conversationItemsContainer;
    return {
        isLimitedToChildren,
        applicationId,
        questionAnswerIds: contentItems.filter((c)=>c.featureTypeId == (0, _featureTypeIds.QuestionAnswerFeatureTypeId)).map((r)=>r.id),
        latestMessageIds: contentItems.filter((c)=>c.featureTypeId == (0, _featureTypeIds.LatestMessagesFeatureTypeId)).map((r)=>r.id),
        simpleChoiceIds: contentItems.filter((c)=>c.featureTypeId == (0, _featureTypeIds.SimpleChoiceFeatureTypeId)).map((r)=>r.id),
        numberRangeIds: contentItems.filter((c)=>c.featureTypeId == (0, _featureTypeIds.NumberRangeFeatureTypeId)).map((r)=>r.id),
        customRequestIds: contentItems.filter((c)=>c.featureTypeId == (0, _featureTypeIds.CustomRequestsFeatureTypeId)).map((r)=>r.id)
    };
};

},{"../../constants/featureTypeIds":"hPLMP","lodash":"3hMBK","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6QVHS":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _defineProperty = require("@babel/runtime/helpers/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _secondaryLoader = require("../../../components/general/SecondaryLoader");
var _secondaryLoaderDefault = parcelHelpers.interopDefault(_secondaryLoader);
var _colors = require("../../../constants/colors");
var _navigationSelection = require("./NavigationSelection");
var _navigationSelectionDefault = parcelHelpers.interopDefault(_navigationSelection);
var _groupedConversationItemSelector = require("./GroupedConversationItemSelector");
var _groupedConversationItemSelectorDefault = parcelHelpers.interopDefault(_groupedConversationItemSelector);
var _contentItemSection = require("./ContentItemSection");
var _contentItemSectionDefault = parcelHelpers.interopDefault(_contentItemSection);
const relatedIcon = require("e93b2403abe947e7");
class SiblingConversationItemSelector extends (0, _reactDefault.default).Component {
    constructor(...args){
        super(...args);
        (0, _definePropertyDefault.default)(this, "state", {
            isOpen: true
        });
    }
    handleToggle() {
        this.setState({
            ...this.state,
            isOpen: !this.state.isOpen
        });
    }
    handleClose() {
        this.setState({
            ...this.state,
            isOpen: false
        });
    }
    getCount() {
        return this.props.conversationItems && this.props.conversationItems.length > 0 ? this.props.conversationItems.map((c)=>c.children.length).reduce((p, c)=>p + c) : 0;
    }
    render() {
        return (0, _react.jsx)("div", {
            className: `sibling-selector ${containerStyle} ${this.state.isOpen ? "open" : ""}`
        }, this.props.isLoading ? (0, _react.jsx)("div", {
            className: "loader-container"
        }, (0, _react.jsx)((0, _secondaryLoaderDefault.default), null)) : (0, _react.jsx)((0, _navigationSelectionDefault.default), {
            isOpen: this.state.isOpen,
            title: "Related",
            icon: relatedIcon,
            count: this.props.conversationItems ? this.props.conversationItems.length : 0,
            onClick: this.handleToggle.bind(this)
        }), this.state.isOpen && !this.props.isLoading ? (0, _react.jsx)((0, _contentItemSectionDefault.default), null, (0, _react.jsx)((0, _groupedConversationItemSelectorDefault.default), {
            title: "Related Conversations",
            description: "Conversations at the same level",
            conversationItems: this.props.conversationItems,
            onSelect: this.props.onSelect,
            onClose: this.handleClose.bind(this),
            isSaving: this.props.isSaving
        })) : null);
    }
}
const containerStyle = /*#__PURE__*/ (0, _css.css)(".spinner>div{background:", (0, _colors.cool_grey), ";}.loader-container{display:flex;flex:1;align-items:center;justify-content:center;margin:8px;}", "");
exports.default = SiblingConversationItemSelector;

},{"@babel/runtime/helpers/defineProperty":"9sJxO","@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","../../../components/general/SecondaryLoader":"7zJiF","../../../constants/colors":"1p3OR","./NavigationSelection":"69Syc","./GroupedConversationItemSelector":"7LEbs","./ContentItemSection":"7RnsX","e93b2403abe947e7":"USexM","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7LEbs":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _colors = require("../../../constants/colors");
var _conversationItemSelector = require("./ConversationItemSelector");
var _conversationItemSelectorDefault = parcelHelpers.interopDefault(_conversationItemSelector);
const parentIcon = require("199597357324a029");
class GroupedConversationItemSelector extends (0, _reactDefault.default).Component {
    constructor(props){
        super(props);
        this.state = {
            expandedGroups: this.props.conversationItems.map((g)=>g.parent)
        };
    }
    componentDidUpdate(prevProps) {
        if (prevProps.conversationItems != this.props.conversationItems) this.setState({
            ...this.state,
            expandedGroups: this.props.conversationItems.map((g)=>g.parent)
        });
    }
    isGroupExpanded(parent) {
        return this.state.expandedGroups.some((c)=>c.id == parent.id);
    }
    handleToggleGroup(parent) {
        const expandedGroups = this.state.expandedGroups;
        if (this.isGroupExpanded(parent)) expandedGroups.splice(expandedGroups.indexOf(parent), 1);
        else expandedGroups.push(parent);
        this.setState({
            ...this.state,
            expandedGroups
        });
    }
    render() {
        const props = this.props;
        return (0, _react.jsx)("div", {
            className: containerStyle
        }, props.conversationItems && props.conversationItems.length > 0 ? props.conversationItems.filter((c)=>c.children.length > 0).map((g, gi)=>(0, _react.jsx)("div", {
                className: "conversation-group",
                key: gi
            }, (0, _react.jsx)("div", {
                className: "group-header",
                onClick: this.handleToggleGroup.bind(this, g.parent)
            }, (0, _react.jsx)("div", {
                className: "triangle-container"
            }, (0, _react.jsx)("div", {
                className: this.isGroupExpanded(g.parent) ? "triangle-down" : "triangle-right"
            })), (0, _react.jsx)("p", {
                className: "content-title"
            }, g.parent.title)), this.isGroupExpanded(g.parent) && (0, _react.jsx)("div", {
                className: "group-items"
            }, (0, _react.jsx)((0, _conversationItemSelectorDefault.default), {
                conversationItems: g.children,
                onSelect: props.onSelect,
                isSaving: props.isSaving
            })))) : (0, _react.jsx)("p", {
            className: "empty-label"
        }, "No conversation items here"));
    }
}
const containerStyle = /*#__PURE__*/ (0, _css.css)("background:", (0, _colors.color_shades_lighter), ";padding:16px 0;.triangle-container{width:3px;height:3px;}.triangle-down{width:0;height:0;border-left:3px solid transparent;border-right:3px solid transparent;border-top:3px solid ", (0, _colors.color_shades_darkest), ";}.triangle-right{width:0;height:0;border-top:3px solid transparent;border-bottom:3px solid transparent;border-left:3px solid ", (0, _colors.color_shades_darkest), ";}.empty-label{margin:0 12px;background:white;font-size:12px;border:1px solid ", (0, _colors.color_shades_dark), ";padding:16px;border-radius:8px;}.group-header{display:flex;align-items:center;cursor:pointer;margin:0 16px;>p{margin:0 8px;}}", "");
exports.default = GroupedConversationItemSelector;

},{"@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","../../../constants/colors":"1p3OR","./ConversationItemSelector":"eNouU","199597357324a029":"e1b1s","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"e1b1s":[function(require,module,exports) {
module.exports = require("97c2bd9af6286da8").getBundleURL("kVLro") + require("f8751f8533700d7").resolve("cZi1M");

},{"97c2bd9af6286da8":"c7Tr5","f8751f8533700d7":"fyJL2"}],"USexM":[function(require,module,exports) {
module.exports = require("619c6bbccf44d355").getBundleURL("kVLro") + require("375958ffa67a0940").resolve("iJJnz");

},{"619c6bbccf44d355":"c7Tr5","375958ffa67a0940":"fyJL2"}],"5QyUq":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _defineProperty = require("@babel/runtime/helpers/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _conversationItemSelector = require("./ConversationItemSelector");
var _conversationItemSelectorDefault = parcelHelpers.interopDefault(_conversationItemSelector);
var _secondaryLoader = require("../../../components/general/SecondaryLoader");
var _secondaryLoaderDefault = parcelHelpers.interopDefault(_secondaryLoader);
var _colors = require("../../../constants/colors");
var _navigationSelection = require("./NavigationSelection");
var _navigationSelectionDefault = parcelHelpers.interopDefault(_navigationSelection);
var _contentItemSection = require("./ContentItemSection");
var _contentItemSectionDefault = parcelHelpers.interopDefault(_contentItemSection);
var _featureTypeIds = require("../../../constants/featureTypeIds");
const leadOutIcon = require("c766ae4ec2b2323c");
class ChildConversationItemSelector extends (0, _reactDefault.default).Component {
    constructor(...args){
        super(...args);
        (0, _definePropertyDefault.default)(this, "state", {
            isOpen: true
        });
    }
    handleToggle() {
        this.setState({
            ...this.state,
            isOpen: !this.state.isOpen
        });
    }
    handleClose() {
        this.setState({
            ...this.state,
            isOpen: false
        });
    }
    render() {
        var conversationItems = [
            ...this.props.conversationItems ?? []
        ];
        if (this.props.contextualFallback) conversationItems.push({
            ...this.props.contextualFallback,
            featureTypeId: (0, _featureTypeIds.FallbackFeatureTypeId)
        });
        if (this.props.contextualHelp) conversationItems.push({
            ...this.props.contextualHelp,
            featureTypeId: (0, _featureTypeIds.HelpMessagesFeatureTypeId)
        });
        return (0, _react.jsx)("div", {
            className: `${containerStyle} ${this.state.isOpen ? "open" : ""}`
        }, this.props.isLoading ? (0, _react.jsx)("div", {
            className: "loader-container"
        }, (0, _react.jsx)((0, _secondaryLoaderDefault.default), null)) : (0, _react.jsx)((0, _navigationSelectionDefault.default), {
            isOpen: this.state.isOpen,
            title: "Followed by",
            icon: leadOutIcon,
            count: this.props.conversationItems ? conversationItems.length : 0,
            onClick: this.handleToggle.bind(this)
        }), this.state.isOpen && !this.props.isLoading ? (0, _react.jsx)((0, _contentItemSectionDefault.default), null, (0, _react.jsx)((0, _conversationItemSelectorDefault.default), {
            conversationItems: conversationItems,
            onSelect: this.props.onSelect,
            isSaving: this.props.isSaving
        })) : null);
    }
}
const containerStyle = /*#__PURE__*/ (0, _css.css)(".spinner>div{background:", (0, _colors.cool_grey), ";}.loader-container{display:flex;flex:1;align-items:center;justify-content:center;margin:8px;}", "");
exports.default = ChildConversationItemSelector;

},{"@babel/runtime/helpers/defineProperty":"9sJxO","@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","./ConversationItemSelector":"eNouU","../../../components/general/SecondaryLoader":"7zJiF","../../../constants/colors":"1p3OR","./NavigationSelection":"69Syc","./ContentItemSection":"7RnsX","../../../constants/featureTypeIds":"hPLMP","c766ae4ec2b2323c":"akdpr","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"akdpr":[function(require,module,exports) {
module.exports = require("b638a30f5bd5b94d").getBundleURL("kVLro") + require("57d898eebade792a").resolve("hAaWm");

},{"b638a30f5bd5b94d":"c7Tr5","57d898eebade792a":"fyJL2"}],"1CUms":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _colors = require("../../constants/colors");
var _toggleIndicator = require("../general/ToggleIndicator");
var _toggleIndicatorDefault = parcelHelpers.interopDefault(_toggleIndicator);
const onHoverIcon = require("7536cfe99bad8898");
const ContentCollapsingSection = (props)=>{
    const [isCollapsed, setIsCollapsed] = (0, _react1.useState)(props.isCollapsedByDefault ?? false);
    const padding = props.CardPadding ?? 24;
    (0, _react1.useEffect)(()=>{
        if (props.forceOpen) setIsCollapsed(false);
        else if (props.forceClose) setIsCollapsed(true);
    }, [
        props.forceOpen,
        props.forceClose
    ]);
    const sectionRef = (0, _react1.useRef)(null);
    (0, _react1.useEffect)(()=>{
        if (props.scrollDownOnClick && !isCollapsed && sectionRef.current) sectionRef.current.scrollIntoView({
            behavior: "instant",
            block: "end"
        });
    }, [
        isCollapsed,
        props.scrollDownOnClick
    ]);
    const toggleCollapse = ()=>{
        if (props.disabled === true) return;
        setIsCollapsed(!isCollapsed);
    };
    const cardStyle = /*#__PURE__*/ (0, _css.css)("&.draggable{cursor:auto;}&.draggable:hover .card-hover-icon{visibility:visible;}&.draggable:hover .card-title-container{cursor:grab;>img{cursor:pointer;}>h4{cursor:pointer;}}&.dragging{border:1px solid ", (0, _colors.color_shades_dark), ";.card-title-container .card-hover-icon{visibility:visible;}}border-top:solid 1px ", (0, _colors.color_shades_dark), ";flex-grow:0;.card-title-container{display:flex;flex-direction:row;align-items:center;justify-content:space-between;padding:", padding, "px ", padding, "px ", padding, "px 0;cursor:pointer;background:white;&.expanded{border-bottom:solid 1px ", (0, _colors.color_shades_dark), ";}&.bottom{&.collapsed{border-bottom:solid 1px ", (0, _colors.color_shades_dark), ";}}.left-content{display:flex;align-items:center;}.left-content>img{width:24px;height:24px;}.left-content>h4{font-family:Muli;font-style:normal;font-weight:normal;font-size:18px;color:", (0, _colors.color_text_default), ";margin:0 10px;}.toggle-indicator{margin:0 12px 0 0;}.card-hover-icon{width:8px;height:24px;margin:0 2px;visibility:hidden;}}.card-body{padding:32px;&.collapsed{padding:0;display:none;}}", "");
    return (0, _react.jsx)("div", {
        className: `${cardStyle} ${props.className ?? ""}`,
        ref: sectionRef,
        "data-response-id": props?.responseId
    }, (0, _react.jsx)("div", {
        className: `card-title-container ${props.bottom ? "bottom" : ""} ${isCollapsed ? "collapsed" : "expanded"}`,
        onClick: toggleCollapse
    }, (0, _react.jsx)("div", {
        className: "left-content"
    }, (0, _react.jsx)("img", {
        className: "card-hover-icon",
        src: onHoverIcon
    }), (0, _react.jsx)((0, _toggleIndicatorDefault.default), {
        direction: isCollapsed ? "up" : "down"
    }), props.icon && (0, _react.jsx)("img", {
        src: props.icon
    }), (0, _react.jsx)("h4", null, (0, _react.jsx)("a", {
        id: props.id ?? props.title?.replace(" ", "")
    }, props.title)), props.titleLeftAdditionalComponent && props.titleLeftAdditionalComponent), props.titleRightRowComponent ? props.titleRightRowComponent : null), (0, _react.jsx)("div", {
        className: `card-body ${isCollapsed ? "collapsed" : "expanded"}`
    }, props.children));
};
exports.default = ContentCollapsingSection;

},{"@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","../../constants/colors":"1p3OR","../general/ToggleIndicator":"4eej1","7536cfe99bad8898":"dsDQ4","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"dsDQ4":[function(require,module,exports) {
module.exports = require("49ddcedb36551536").getBundleURL("kVLro") + require("3cb5faa806d649c7").resolve("ckziX");

},{"49ddcedb36551536":"c7Tr5","3cb5faa806d649c7":"fyJL2"}],"5RGHr":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _colors = require("../../../constants/colors");
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const ContentSectionTitle = (props)=>(0, _react.jsx)("div", {
        className: containerStyle
    }, (0, _react.jsx)("img", {
        src: props.icon
    }), (0, _react.jsx)("h3", {
        className: styledTitle
    }, props.title));
const styledTitle = /*#__PURE__*/ (0, _css.css)({
    name: "w3xt6u",
    styles: "font-weight:400;font-size:18px;font-style:'Muli'"
});
const containerStyle = /*#__PURE__*/ (0, _css.css)("display:flex;align-items:center;border-bottom:1px solid ", (0, _colors.color_shades_dark), ";padding:12px 0;h4{font-size:18px;line-height:24px;font-weight:normal;color:", (0, _colors.color_text_default), ";}img{width:40px;height:40px;margin-right:16px;}", "");
exports.default = ContentSectionTitle;

},{"@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","../../../constants/colors":"1p3OR","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"TGPQ9":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "saveAndActivateStyle", ()=>saveAndActivateStyle);
parcelHelpers.export(exports, "saveStyle", ()=>saveStyle);
parcelHelpers.export(exports, "discardStyle", ()=>discardStyle);
parcelHelpers.export(exports, "expandCollapseStyle", ()=>expandCollapseStyle);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _panelHeaderContainer = require("../../../components/structure/Panels/PanelHeaderContainer");
var _panelHeaderContainerDefault = parcelHelpers.interopDefault(_panelHeaderContainer);
var _button = require("../../../components/general/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _lodash = require("lodash");
var _conditionalTooltipWrapper = require("../../../components/general/ConditionalTooltipWrapper");
var _conditionalTooltipWrapperDefault = parcelHelpers.interopDefault(_conditionalTooltipWrapper);
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const ConversationItemActionButtonToolbar = (props)=>{
    const isTemplateOwned = props.contentItem?.createdFromId && !props.contentItem?.shouldNotSync;
    const handleSaveAndPublish = async ()=>{
        // create forms need to "show publish" before saving in order to use the query string before navigating
        // this could be reworked if all the page state and form state was moved up to a higher level
        const errors = await props.validateForm();
        if ((0, _lodash.isEmpty)(errors)) {
            if (props.contentItem) {
                await props.submitForm();
                props.handlePublishing();
            } else {
                props.handlePublishing();
                await props.submitForm();
            }
        }
    };
    const errors = props.errors?.map((item)=>{
        if (typeof item === "string") return [
            item
        ];
        else return item.map((error)=>{
            return error?.content;
        });
    });
    const tooltipText = ()=>{
        if (props.saveDisabled && props.publishDisabled) return `The following fields are required: <br/>-You must perform a full app publish <br/>-${Array.prototype.concat.apply([], errors).join("<br/> -")}`;
        else return "You must perform a full app publish";
    };
    return (0, _react.jsx)((0, _reactDefault.default).Fragment, null, (0, _react.jsx)((0, _panelHeaderContainerDefault.default), null, (0, _react.jsx)((0, _conditionalTooltipWrapperDefault.default), {
        showTooltip: props.saveDisabled,
        place: "bottom",
        text: `The following fields are required: <br/> -${Array.prototype.concat.apply([], errors).join("<br/> -")}`
    }, (0, _react.jsx)("div", null, " ", (0, _react.jsx)((0, _buttonDefault.default), {
        className: `${saveStyle} ac-content-save`,
        loading: props.isLoading,
        disabled: props.isLoading || isTemplateOwned || props.saveDisabled,
        themes: [
            "primary-small",
            "start"
        ],
        text: "Save",
        type: "submit"
    }))), (0, _react.jsx)((0, _conditionalTooltipWrapperDefault.default), {
        showTooltip: props.publishDisabled || props.saveDisabled,
        place: "bottom",
        text: tooltipText()
    }, (0, _react.jsx)("div", null, (0, _react.jsx)((0, _buttonDefault.default), {
        className: `${saveAndActivateStyle} ac-content-save-activate`,
        loading: props.isLoading,
        disabled: props.isLoading || isTemplateOwned || props.publishDisabled || props.saveDisabled,
        themes: [
            "white-small"
        ],
        text: "Save & Publish",
        type: "button",
        onClick: handleSaveAndPublish
    }))), (0, _react.jsx)((0, _buttonDefault.default), {
        className: `${discardStyle} ac-content-discard`,
        loading: props.isLoading,
        disabled: props.isLoading || isTemplateOwned,
        themes: [
            "white-small",
            "end"
        ],
        text: "Discard Changes",
        type: "button",
        onClick: ()=>props.handleDiscardChanges()
    }), props.onToggleExpandAll && (0, _react.jsx)((0, _buttonDefault.default), {
        className: `${expandCollapseStyle} ac-expand-collapse`,
        loading: props.isLoading,
        disabled: props.isLoading,
        themes: [
            "white-small"
        ],
        text: props.isExpanded ? "Collapse All" : "Expand All",
        type: "button",
        onClick: props.onToggleExpandAll
    })));
};
const saveAndActivateStyle = /*#__PURE__*/ (0, _css.css)({
    name: "18qknme",
    styles: "margin-left:8px;margin-right:auto"
});
const saveStyle = /*#__PURE__*/ (0, _css.css)({
    name: "1qmfu9o",
    styles: "margin-left:32px;margin-right:8px"
});
const discardStyle = /*#__PURE__*/ (0, _css.css)({
    name: "91ztpb",
    styles: "margin-right:8px;margin-left:auto"
});
const expandCollapseStyle = /*#__PURE__*/ (0, _css.css)({
    name: "8t4m9g",
    styles: "margin-right:32px;margin-left:8px"
});
exports.default = ConversationItemActionButtonToolbar;

},{"@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","../../../components/structure/Panels/PanelHeaderContainer":"hUotd","../../../components/general/Button":"6ymxN","lodash":"3hMBK","../../../components/general/ConditionalTooltipWrapper":"92m0T","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"92m0T":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _bootstrapCss = require("rc-tooltip/assets/bootstrap.css");
var _tooltipWrapper = require("./TooltipWrapper");
var _tooltipWrapperDefault = parcelHelpers.interopDefault(_tooltipWrapper);
const ConditionalTooltipWrapper = (props)=>(0, _react.jsx)((0, _reactDefault.default).Fragment, null, props.showTooltip ? (0, _react.jsx)((0, _tooltipWrapperDefault.default), props, props.children) : props.children);
exports.default = ConditionalTooltipWrapper;

},{"@emotion/react":"djZKr","react":"6uln9","rc-tooltip/assets/bootstrap.css":"9MrrI","./TooltipWrapper":"53pWd","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9MrrI":[function() {},{}],"gMkKq":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _colors = require("../../constants/colors");
var _button = require("./Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
const icon = require("d5e146810296b5cd");
const TemplateLockedBanner = (props)=>(0, _react.jsx)("div", {
        className: `${containerStyle} ${props.isLinked ? "linked" : "unlinked"}`
    }, (0, _react.jsx)("img", {
        src: icon
    }), (0, _react.jsx)("p", null, props.isLinked ? "This content is managed via a module, and cannot be edited directly while linked" : "This content was generated via a module, but has been unlinked from it"), (0, _react.jsx)((0, _buttonDefault.default), {
        type: "button",
        themes: [
            "hollow",
            "end"
        ],
        onClick: props.isLinked ? props.onUnlink : props.onRelink,
        text: props.isLinked ? "Unlink" : "Re-link",
        disabled: props.isLoading,
        loading: props.isLoading
    }));
const containerStyle = /*#__PURE__*/ (0, _css.css)("height:72px;width:100%;display:flex;align-items:center;padding:0 32px;img{min-width:24px;min-height:24px;}p{padding:0 12px;font-style:normal;font-weight:normal;font-size:14px;line-height:20px;border-right:1px solid ", (0, _colors.color_shades_dark), ";flex:1;}button{border:none;color:", (0, _colors.color_text_link), ";margin-right:0;margin-left:24px;font-style:normal;font-weight:normal;font-size:14px;line-height:20px;}&.linked{background:rgba(246, 161, 47, 0.2);}&.unlinked{background:", (0, _colors.color_shades_lighter), ";}", "");
exports.default = TemplateLockedBanner;

},{"@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","../../constants/colors":"1p3OR","./Button":"6ymxN","d5e146810296b5cd":"bOjIf","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"bOjIf":[function(require,module,exports) {
module.exports = require("930833cb3f1c8574").getBundleURL("kVLro") + require("69ab927c0e076f56").resolve("4AWCR");

},{"930833cb3f1c8574":"c7Tr5","69ab927c0e076f56":"fyJL2"}],"8a3oA":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const ConversationItemFieldSet = (props)=>(0, _react.jsx)("fieldset", {
        disabled: props.disabled,
        className: `${containerStyle} ${props.withBanner ? withBannerStyle : ""}`
    }, props.children);
const withBannerStyle = /*#__PURE__*/ (0, _css.css)({
    name: "1jyfsag",
    styles: "padding-bottom:72px"
});
const containerStyle = /*#__PURE__*/ (0, _css.css)({
    name: "13udsys",
    styles: "height:100%"
});
exports.default = ConversationItemFieldSet;

},{"@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6Ozsc":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _base = require("@emotion/styled/base");
var _baseDefault = parcelHelpers.interopDefault(_base);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _largeOverflowMenu = require("../general/LargeOverflowMenu");
var _largeOverflowMenuDefault = parcelHelpers.interopDefault(_largeOverflowMenu);
var _countButton = require("../../scenes/contentPage/components/CountButton");
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const webhookIcon = require("7a203487c2208a8c");
const computerLockDark = require("31f3a4b986bc0997");
const computerLockBlue = require("ed9ab14387b6431");
const ContentInfoOptions = (props)=>(0, _react.jsx)("div", {
        className: containerStyle
    }, (0, _react.jsx)((0, _countButton.CountButton), {
        isActive: props.showSensitiveConversation,
        onClick: ()=>{
            props.toggleSensitiveConversation();
        },
        activeIcon: computerLockBlue,
        inactiveIcon: computerLockDark,
        showCount: false,
        text: "Secure Conversation"
    }), (0, _react.jsx)((0, _countButton.CountButton), {
        isActive: props.showDisabledForFeatures,
        onClick: ()=>{
            props.toggleDisabledForFeatures();
        },
        showCount: true,
        text: "Disabled for Features",
        count: props.flagsSelected
    }), (0, _react.jsx)(WebhookCountButton, {
        onClick: (e)=>{
            e.stopPropagation();
            props.manageWebhooks();
        },
        text: "Webhooks",
        showCount: true,
        count: props.webhookCount,
        inactiveIcon: webhookIcon
    }), (0, _react.jsx)((0, _largeOverflowMenuDefault.default), {
        className: "ac-content-info-overflow",
        isActive: false,
        onOptionSelected: props.optionSelected,
        options: props.options
    }));
const WebhookCountButton = /*#__PURE__*/ (0, _baseDefault.default)((0, _countButton.CountButton), {
    target: "e1yvtcfi0"
})({
    name: "s0vnfv",
    styles: "height:32px"
});
const containerStyle = /*#__PURE__*/ (0, _css.css)({
    name: "1izf10r",
    styles: "margin-left:auto;margin-right:8px;display:flex;flex-direction:row;align-items:center"
});
exports.default = ContentInfoOptions;

},{"@emotion/styled/base":"lSuFu","@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","../general/LargeOverflowMenu":"h9O0c","../../scenes/contentPage/components/CountButton":"dGBKj","7a203487c2208a8c":"e6PIG","31f3a4b986bc0997":"kBKD8","ed9ab14387b6431":"fVNU2","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"h9O0c":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _rcTooltip = require("rc-tooltip");
var _rcTooltipDefault = parcelHelpers.interopDefault(_rcTooltip);
var _colors = require("../../constants/colors");
var _overflowMenu = require("./overflowMenu/OverflowMenu");
var _overflowMenuDefault = parcelHelpers.interopDefault(_overflowMenu);
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const containerStyle = /*#__PURE__*/ (0, _css.css)({
    name: "bjn8wh",
    styles: "position:relative"
});
class LargeOverflowMenu extends (0, _reactDefault.default).Component {
    componentWillMount() {
        this.setState({
            ...this.state,
            isActive: false
        });
    }
    componentDidUpdate(prevProps) {
        if (prevProps.isActive != this.props.isActive) this.setState({
            ...this.state,
            isActive: this.props.isActive
        });
    }
    handleClick(e) {
        e.stopPropagation();
        this.setState({
            ...this.state,
            isActive: !this.state.isActive
        });
    }
    handleMenuClose() {
        this.setState({
            ...this.state,
            isActive: false
        });
    }
    render() {
        return (0, _react.jsx)("div", {
            className: `${containerStyle} ${this.props.className ?? ""}`
        }, (0, _react.jsx)((0, _rcTooltipDefault.default), {
            mouseEnterDelay: .5,
            overlayClassName: tooltipContentStyle,
            trigger: [
                "hover"
            ],
            placement: "top",
            overlay: (0, _react.jsx)("span", null, "Show options")
        }, this.props.icon ? (0, _react.jsx)("img", {
            className: "menu-icon",
            src: this.props.icon,
            onClick: this.handleClick.bind(this)
        }) : (0, _react.jsx)("div", {
            className: `${overflowButtonStyle} ${this.state.isActive ? "active" : ""}`,
            onClick: this.handleClick.bind(this)
        }, (0, _react.jsx)("div", {
            className: "circle"
        }), (0, _react.jsx)("div", {
            className: "circle"
        }), (0, _react.jsx)("div", {
            className: "circle"
        }))), this.state.isActive && (0, _react.jsx)((0, _overflowMenuDefault.default), {
            className: overflowMenuStyle,
            onClose: this.handleMenuClose.bind(this),
            onOptionSelected: (l, e)=>this.props.onOptionSelected(l, e),
            options: this.props.options
        }, this.props.children));
    }
}
const overflowMenuStyle = /*#__PURE__*/ (0, _css.css)({
    name: "5u1858",
    styles: ".triangle{margin-right:13px;}"
});
const overflowButtonStyle = /*#__PURE__*/ (0, _css.css)("border:1px solid ", (0, _colors.color_shades_dark), ";border-radius:50%;width:30px;height:30px;display:flex;flex-direction:row;align-items:center;justify-content:center;cursor:pointer;.circle{width:4px;height:4px;border-radius:50%;border:solid 1px ", (0, _colors.color_shades_dark), ";margin:2px;}&:hover,&.active{box-shadow:-1px 4px 10px 0 rgba(48, 69, 98, 0.1);border:solid 1px #007dbb;.circle{border:solid 1px #007dbb;}}&.active{background-color:rgba(0, 125, 187, 0.1);}", "");
const tooltipContentStyle = /*#__PURE__*/ (0, _css.css)({
    name: "11143my",
    styles: ".rc-tooltip-inner{font-family:Muli;font-size:14px;font-weight:normal;font-style:normal;letter-spacing:0.6px;z-index:120;color:white;background-color:#304562;box-shadow:-1px 4px 10px 0 rgba(48, 69, 98, 0.1);padding:8px;min-height:0;}"
});
exports.default = LargeOverflowMenu;

},{"@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","rc-tooltip":"fhD1R","../../constants/colors":"1p3OR","./overflowMenu/OverflowMenu":"2V2SB","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2V2SB":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _colors = require("../../../constants/colors");
var _menuItem = require("./MenuItem");
var _menuItemDefault = parcelHelpers.interopDefault(_menuItem);
var _horizontalSeparator = require("../../structure/HorizontalSeparator");
var _horizontalSeparatorDefault = parcelHelpers.interopDefault(_horizontalSeparator);
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const OverflowMenu = (props)=>{
    const handleDocumentClick = (e)=>{
        if (e.target.closest(`.${menuStyle}`)) return;
        e.stopPropagation();
        props.onClose();
    };
    const handleLinkClicked = (name, event)=>{
        if (event) event.stopPropagation();
        if (props.onOptionSelected && event) props.onOptionSelected(name, event);
        props.onClose();
    };
    const documentCloser = handleDocumentClick.bind(undefined);
    (0, _react1.useEffect)(()=>{
        document.addEventListener("click", documentCloser, true);
        return ()=>{
            document.removeEventListener("click", documentCloser, true);
        };
    }, []);
    return (0, _react.jsx)("div", {
        className: `${menuStyle} ${props.className}`
    }, (0, _react.jsx)("div", {
        className: `${triangleStyle} triangle`
    }), props.options.map((o, i)=>(0, _react.jsx)("div", {
            key: i
        }, (0, _react.jsx)((0, _menuItemDefault.default), {
            isDisabled: o.isDisabled,
            className: `${i === 0 ? `${topItemStyle} ${props.topOptionStyle ?? ""}` : null} ${i === props.options.length - 1 ? `${bottomItemStyle} ${props.bottomOptionStyle ?? ""}` : null} ${props.optionClassName}`,
            option: o,
            onClick: (event)=>{
                handleLinkClicked(o.label, event);
            },
            onSubClick: (label, event)=>{
                handleLinkClicked(label, event);
            }
        }), i < props.options.length - 1 ? (0, _react.jsx)((0, _horizontalSeparatorDefault.default), null) : null)), props.children);
};
const menuStyle = /*#__PURE__*/ (0, _css.css)("width:320px;border:solid 1px #cccccc;background:white;box-shadow:0 2px 8px - ", (0, _colors.dark_grey_blue_10), ";border-radius:12px;position:absolute;margin-left:-285px;margin-top:12px;box-shadow:0 4px 4px 0 ", (0, _colors.dark_grey_blue_10), ";z-index:99;", "");
const triangleStyle = /*#__PURE__*/ (0, _css.css)({
    name: "81wlk",
    styles: "transform:rotate(45deg);width:12px;height:12px;margin-top:-7px;margin-bottom:-6px;border-top:solid 1px #cccccc;border-left:solid 1px #cccccc;background:white;margin-right:16px;margin-left:auto"
});
const topItemStyle = /*#__PURE__*/ (0, _css.css)({
    name: "un4hki",
    styles: "border-top-right-radius:12px;border-top-left-radius:12px"
});
const bottomItemStyle = /*#__PURE__*/ (0, _css.css)({
    name: "ikk1ne",
    styles: "border-bottom-right-radius:12px;border-bottom-left-radius:12px"
});
exports.default = OverflowMenu;

},{"@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","../../../constants/colors":"1p3OR","./MenuItem":"bG9gY","../../structure/HorizontalSeparator":"Pw3HQ","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"bG9gY":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _colors = require("../../../constants/colors");
var _menuSubItem = require("./MenuSubItem");
var _menuSubItemDefault = parcelHelpers.interopDefault(_menuSubItem);
var _toggleIndicator = require("../ToggleIndicator");
var _toggleIndicatorDefault = parcelHelpers.interopDefault(_toggleIndicator);
var _conditionalTooltipWrapper = require("../ConditionalTooltipWrapper");
var _conditionalTooltipWrapperDefault = parcelHelpers.interopDefault(_conditionalTooltipWrapper);
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const MenuItem = (props)=>{
    const [isExpanded, setIsExpanded] = (0, _react1.useState)(false);
    const handleClick = (event)=>{
        if (props.option.isDisabled) return;
        if (props.option.subOptions) setIsExpanded(!isExpanded);
        else props.onClick(event);
    };
    return (0, _react.jsx)((0, _conditionalTooltipWrapperDefault.default), {
        showTooltip: !!props.option.tooltip,
        text: props.option.tooltip,
        place: "left"
    }, (0, _react.jsx)("div", null, (0, _react.jsx)("div", {
        className: `${menuItemStyle} ${props.option.isDestructive ? destructiveStyle : defaultStyle} ${props.option.isDisabled ? disabledStyle : ""} ${props.className}`,
        onClick: handleClick.bind(undefined)
    }, props.option.icon ? (0, _react.jsx)("img", {
        className: "icon",
        src: props.option.icon
    }) : null, props.option.hoverIcon ? (0, _react.jsx)("img", {
        className: "icon-hover",
        src: props.option.hoverIcon
    }) : null, (0, _react.jsx)("p", null, props.option.label), props.option.subOptions && (0, _react.jsx)((0, _toggleIndicatorDefault.default), {
        direction: isExpanded ? "down" : "up",
        className: "toggle-indicator"
    })), props.option.subOptions && isExpanded && props.option.subOptions.map((c, i)=>(0, _react.jsx)((0, _menuSubItemDefault.default), {
            key: i,
            option: c,
            onClick: (e)=>props.onSubClick(c.label, e)
        }))));
};
const menuItemStyle = /*#__PURE__*/ (0, _css.css)("height:64px;font-family:Muli;font-size:14px;font-weight:600;font-style:normal;font-stretch:normal;line-height:normal;letter-spacing:normal;z-index:99;color:", (0, _colors.dark_grey_blue), ";display:flex;align-items:center;cursor:pointer;border:1px solid transparent;position:relative;width:100%;.toggle-indicator{margin-right:16px;margin-left:auto;}p{color:", (0, _colors.color_shades_darkest), ";margin:0 12px;}img{width:24px;height:24px;margin-left:16px;}.icon-hover{display:none;}&:hover{.icon-hover{display:block;}.icon{display:none;}}", "");
const destructiveStyle = /*#__PURE__*/ (0, _css.css)({
    name: "1bk63pb",
    styles: "&:hover{background-color:rgba(221, 64, 74, 0.1);border:solid 1px #eb5862;}"
});
const disabledStyle = /*#__PURE__*/ (0, _css.css)("background:", (0, _colors.color_shades_medium), ";cursor:not-allowed;border-color:", (0, _colors.color_shades_dark), ";background-color:", (0, _colors.color_shades_lighter), ";&:hover{border-color:", (0, _colors.color_shades_dark), ";background-color:", (0, _colors.color_shades_lighter), ";}p{color:", (0, _colors.color_shades_dark), ";}", "");
const defaultStyle = /*#__PURE__*/ (0, _css.css)("&:hover{background-color:#E5F1F6;border:1px solid ", (0, _colors.ocean_blue), ";}", "");
exports.default = MenuItem;

},{"@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","../../../constants/colors":"1p3OR","./MenuSubItem":"7EhZo","../ToggleIndicator":"4eej1","../ConditionalTooltipWrapper":"92m0T","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7EhZo":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _colors = require("../../../constants/colors");
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const MenuSubItem = (props)=>(0, _react.jsx)("div", {
        className: `${menuItemStyle} ${props.option.isDestructive ? destructiveStyle : defaultStyle} ${props.className}`,
        onClick: (e)=>props.onClick(e)
    }, props.option.icon ? (0, _react.jsx)("img", {
        className: "icon",
        src: props.option.icon
    }) : null, props.option.hoverIcon ? (0, _react.jsx)("img", {
        className: "icon-hover",
        src: props.option.hoverIcon
    }) : null, (0, _react.jsx)("p", null, props.option.label));
const menuItemStyle = /*#__PURE__*/ (0, _css.css)("height:64px;font-family:Muli;font-size:14px;font-weight:600;font-style:normal;font-stretch:normal;line-height:normal;letter-spacing:normal;z-index:99;color:", (0, _colors.dark_grey_blue), ";display:flex;align-items:center;text-align:right;cursor:pointer;border:1px solid transparent;position:relative;padding-left:24px;p{margin:0 12px;}img{width:24px;height:24px;margin-left:16px;}.icon-hover{display:none;}&:hover{.icon-hover{display:block;}.icon{display:none;}}", "");
const destructiveStyle = /*#__PURE__*/ (0, _css.css)({
    name: "1bk63pb",
    styles: "&:hover{background-color:rgba(221, 64, 74, 0.1);border:solid 1px #eb5862;}"
});
const defaultStyle = /*#__PURE__*/ (0, _css.css)("&:hover{background-color:#E5F1F6;border:1px solid ", (0, _colors.ocean_blue), ";}", "");
exports.default = MenuSubItem;

},{"@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","../../../constants/colors":"1p3OR","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"Pw3HQ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _stylesValues = require("../../constants/stylesValues");
const HorizontalSeparator = (props)=>(0, _react.jsx)("div", {
        className: `${separatorStyle} ${props.className} horizontal-separator`
    });
const separatorStyle = /*#__PURE__*/ (0, _css.css)("width:100%;flex-grow:1;border-bottom:", (0, _stylesValues.style_border_default), ";", "");
exports.default = HorizontalSeparator;

},{"@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","../../constants/stylesValues":"dHVVv","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"dGBKj":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CountButton", ()=>CountButton);
var _base = require("@emotion/styled/base");
var _baseDefault = parcelHelpers.interopDefault(_base);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _colors = require("../../../constants/colors");
const CountButton = (props)=>{
    const hasImage = props.activeIcon || props.inactiveIcon;
    return (0, _react.jsx)(StyledButton, {
        type: "button",
        className: `${props.isActive ? "active" : "inactive"} ${props.className ?? ""}`,
        onClick: (e)=>{
            e.stopPropagation();
            props.onClick(e);
        }
    }, (0, _react.jsx)("p", null, props.text), props.showCount ? props.count > 0 ? (0, _react.jsx)("span", {
        className: "count-number"
    }, props.count) : hasImage ? (0, _react.jsx)("img", {
        src: props.isActive ? props.activeIcon : props.inactiveIcon
    }) : (0, _react.jsx)((0, _reactDefault.default).Fragment, null) : hasImage ? (0, _react.jsx)("img", {
        src: props.isActive ? props.activeIcon : props.inactiveIcon
    }) : (0, _react.jsx)((0, _reactDefault.default).Fragment, null));
};
const StyledButton = /*#__PURE__*/ (0, _baseDefault.default)("button", {
    target: "e18e8dza0"
})("border-radius:16px;border:1px solid ", (0, _colors.color_shades_dark), ";display:flex;flex-direction:row;align-items:center;margin-right:16px;cursor:pointer;padding:0 24px;background:", (0, _colors.color_variants_main_bg), ";font-family:'Muli';.count-number{color:white;border-radius:50%;width:16px;height:16px;font-weight:600;font-size:12px;line-height:16px;text-align:center;margin-top:3px;margin-left:8px;background:", (0, _colors.color_shades_darkest), ";font-family:'Muli';}img{margin-left:8px;}&.active{background:", (0, _colors.color_variants_ocean_light_opaque), ";border-color:", (0, _colors.color_colors_ocean), ";color:", (0, _colors.color_text_link), ";}");

},{"@emotion/styled/base":"lSuFu","@emotion/react":"djZKr","react":"6uln9","../../../constants/colors":"1p3OR","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"e6PIG":[function(require,module,exports) {
module.exports = require("9195c82963cca0b7").getBundleURL("kVLro") + require("65715b1eb733f444").resolve("7DxWa");

},{"9195c82963cca0b7":"c7Tr5","65715b1eb733f444":"fyJL2"}],"kBKD8":[function(require,module,exports) {
module.exports = require("f8957dc0d07f916a").getBundleURL("kVLro") + require("9b8605b4026d4b3d").resolve("9gtS2");

},{"f8957dc0d07f916a":"c7Tr5","9b8605b4026d4b3d":"fyJL2"}],"fVNU2":[function(require,module,exports) {
module.exports = require("db0a479254c395b0").getBundleURL("kVLro") + require("99c747d97f332261").resolve("6BaoW");

},{"db0a479254c395b0":"c7Tr5","99c747d97f332261":"fyJL2"}],"jtCYo":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _extends = require("@babel/runtime/helpers/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _unstated = require("unstated");
var _followUpContainer = require("../../state/containers/FollowUpContainer");
var _followUpContainerDefault = parcelHelpers.interopDefault(_followUpContainer);
var _repromptContainer = require("../../state/containers/RepromptContainer");
var _repromptContainerDefault = parcelHelpers.interopDefault(_repromptContainer);
var _featureContainer = require("../../state/containers/FeatureContainer");
var _featureContainerDefault = parcelHelpers.interopDefault(_featureContainer);
var _conditionsContainer = require("../../state/containers/ConditionsContainer");
var _conditionsContainerDefault = parcelHelpers.interopDefault(_conditionsContainer);
var _responses = require("./components/Responses");
var _responsesDefault = parcelHelpers.interopDefault(_responses);
var _mediaResponseContainer = require("../../state/containers/MediaResponseContainer");
var _mediaResponseContainerDefault = parcelHelpers.interopDefault(_mediaResponseContainer);
var _applicationFlagsContainer = require("../../state/containers/ApplicationFlagsContainer");
var _applicationFlagsContainerDefault = parcelHelpers.interopDefault(_applicationFlagsContainer);
const ResponsesManager = (props)=>(0, _react.jsx)("div", null, (0, _react.jsx)((0, _unstated.Subscribe), {
        to: [
            (0, _featureContainerDefault.default),
            (0, _followUpContainerDefault.default),
            (0, _repromptContainerDefault.default),
            (0, _conditionsContainerDefault.default),
            (0, _mediaResponseContainerDefault.default),
            (0, _applicationFlagsContainerDefault.default)
        ]
    }, (featureContainer, followUpContainer, repromptContainer, conditionsContainer, mediaResponseContainer, appFlagsContainer)=>(0, _react.jsx)((0, _responsesDefault.default), (0, _extendsDefault.default)({
            featureContainer: featureContainer,
            followUpContainer: followUpContainer,
            repromptContainer: repromptContainer,
            conditionsContainer: conditionsContainer,
            mediaResponseContainer: mediaResponseContainer,
            appFlagsContainer: appFlagsContainer
        }, props))));
exports.default = ResponsesManager;

},{"@babel/runtime/helpers/extends":"4iKIP","@emotion/react":"djZKr","react":"6uln9","unstated":"grh7p","../../state/containers/FollowUpContainer":"rm9OA","../../state/containers/RepromptContainer":"5vKMV","../../state/containers/FeatureContainer":"4ApGg","../../state/containers/ConditionsContainer":"cg7ga","./components/Responses":"9rh2U","../../state/containers/MediaResponseContainer":"1ccrV","../../state/containers/ApplicationFlagsContainer":"3cmia","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"5vKMV":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _defineProperty = require("@babel/runtime/helpers/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _unstated = require("unstated");
var _api = require("../../api");
class RepromptContainer extends (0, _unstated.Container) {
    constructor(...args){
        super(...args);
        // default state
        (0, _definePropertyDefault.default)(this, "state", {
            reprompt: [],
            isLoading: false,
            errors: [],
            isSaving: false
        });
    }
    clearErrors() {
        this.setState({
            ...this.state,
            errors: []
        });
    }
    getFromId(id) {
        var matched = this.state.reprompt.filter((wm)=>wm.id == id);
        if (matched.length > 0) return matched[0];
    }
    addReprompt(applicationId, model) {
        this.setSaving(true);
        const addPromise = _api.addReprompt(applicationId, model);
        addPromise.then((repromptResult)=>{
            if (repromptResult.resultType == "Ok") {
                // add the new message to state immutably;
                const updated = [
                    ...this.state.reprompt,
                    repromptResult.data
                ];
                this.setState({
                    ...this.state,
                    reprompt: updated,
                    isSaving: false
                });
            } else this.setState({
                ...this.state,
                errors: repromptResult.errors,
                isSaving: false
            });
        }).catch((error)=>{
            console.log(error);
        });
        return addPromise;
    }
    updateReprompt(repromptId, model) {
        this.setSaving(true);
        var updatePromise = _api.updateReprompt(model);
        updatePromise.then((repromptResult)=>{
            if (repromptResult.resultType == "Ok") {
                // get immutable copy of array
                const updated = [
                    ...this.state.reprompt
                ];
                // now update the item
                updated[updated.findIndex((m)=>m.id == repromptId)] = repromptResult.data;
                this.setState({
                    ...this.state,
                    reprompt: updated,
                    isSaving: false
                });
            } else this.setState({
                ...this.state,
                errors: repromptResult.errors,
                isSaving: false
            });
        }).catch((error)=>{
            this.setState({
                ...this.state,
                errors: [
                    error?.toString()
                ],
                isSaving: false
            });
        });
        return updatePromise;
    }
    deleteReprompt(repromptId) {
        const deletePromise = _api.deleteReprompt(repromptId);
        deletePromise.then((repromptResult)=>{
            if (repromptResult.resultType == "Ok") {
                // remove the message from state immutably;
                const updated = this.state.reprompt.filter((w)=>w.id !== repromptId);
                this.setState({
                    ...this.state,
                    reprompt: updated,
                    isSaving: false
                });
            } else this.setState({
                ...this.state,
                errors: repromptResult.errors,
                isSaving: false
            });
        }).catch((error)=>{
            console.log(error);
        });
        return deletePromise;
    }
    getRepromptForApp(applicationId) {
        this.setLoading(true);
        var promise = _api.getRepromptsForApp(applicationId);
        promise.then((repromptResult)=>{
            if (repromptResult.resultType == "Ok") this.setState({
                ...this.state,
                errors: [],
                reprompt: repromptResult.data,
                isLoading: false
            });
            else this.setState({
                ...this.state,
                errors: repromptResult.errors,
                isLoading: false
            });
        }).catch((error)=>{
            console.log(error);
        });
        return promise;
    }
    setLoading(isLoading) {
        this.setState({
            ...this.state,
            isLoading: isLoading
        });
    }
    setSaving(isSaving) {
        this.setState({
            ...this.state,
            isSaving: isSaving
        });
    }
}
exports.default = RepromptContainer;

},{"@babel/runtime/helpers/defineProperty":"9sJxO","unstated":"grh7p","../../api":"loxM6","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4ApGg":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _defineProperty = require("@babel/runtime/helpers/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _unstated = require("unstated");
var _api = require("../../api");
var _lodash = require("lodash");
var _lodashDefault = parcelHelpers.interopDefault(_lodash);
var _featureTypeIds = require("../../constants/featureTypeIds");
class FeatureContainer extends (0, _unstated.Container) {
    constructor(...args){
        super(...args);
        // default state
        (0, _definePropertyDefault.default)(this, "state", {
            allFeatures: [],
            systemFeatures: [],
            conversationCounts: [],
            generalContentItems: [],
            featureContentPublishStatus: [],
            loadedPublishHistoryFeatureId: "",
            isLoadingSystemFeatures: false,
            isLoadingFeatures: false,
            isAddingFeature: false,
            isDeleting: false,
            isMoving: false,
            isCopying: false,
            isDeletingModule: false,
            isLoadingBulkOperation: false,
            newApplicationFeatureId: null,
            loadingAppFeatureIds: [],
            currentTopicFeatureId: null,
            errors: []
        });
    }
    async clearErrors() {
        await this.setState({
            ...this.state,
            errors: []
        });
    }
    removeByKey(array, params) {
        array.some(function(item, index) {
            if (array[index][params.key] === params.value) {
                // found it!
                array.splice(index, 1);
                return true; // stops the loop
            }
            return false;
        });
        return array;
    }
    setCurrentTopicFeature(applicationFeatureId) {
        return this.setState({
            ...this.state,
            currentTopicFeatureId: applicationFeatureId
        });
    }
    getCurrentChildFeatures() {
        return this.state.allFeatures.filter((af)=>af.parentId == this.state.currentTopicFeatureId);
    }
    findFeatureById(applicationFeatureId) {
        return this.state.allFeatures.find((af)=>af.id == applicationFeatureId);
    }
    findTopicFeatureByChildId(applicationFeatureId) {
        const feature = this.findFeatureById(applicationFeatureId);
        if (!feature?.parentId) return feature;
        return this.findTopicFeatureByChildId(feature.parentId);
    }
    refreshForAppFeature(applicationId, applicationFeatureId, background = false) {
        if (!background) this.setState({
            ...this.state,
            loadingAppFeatureIds: [
                ...this.state.loadingAppFeatureIds,
                applicationFeatureId
            ],
            isLoadingFeatures: true
        });
        const getFeaturesPromise = _api.getFeaturesForApp(applicationId);
        const getContentPromise = _api.getContentItemsForFeature(applicationFeatureId);
        const promise = Promise.all([
            getFeaturesPromise,
            getContentPromise
        ]);
        promise.then((results)=>{
            const featuresResult = results[0];
            const contentResult = results[1];
            if (featuresResult.resultType == "Ok" && contentResult.resultType == "Ok") this.setState({
                ...this.state,
                errors: [],
                allFeatures: featuresResult.data,
                isLoadingFeatures: false,
                loadingAppFeatureIds: this.state.loadingAppFeatureIds.filter((s)=>s !== applicationFeatureId),
                generalContentItems: contentResult.data
            });
            else this.setState({
                ...this.state,
                errors: [
                    ...featuresResult.errors,
                    ...contentResult.errors
                ],
                loadingAppFeatureIds: this.state.loadingAppFeatureIds.filter((s)=>s !== applicationFeatureId)
            });
        });
        return promise;
    }
    getFeaturesForApp(applicationId) {
        this.setLoading(true);
        const promise = _api.getFeaturesForApp(applicationId);
        promise.then((featuresResult)=>{
            if (featuresResult.resultType == "Ok") this.setState({
                ...this.state,
                errors: [],
                allFeatures: featuresResult.data,
                isLoadingFeatures: false
            });
            else this.setState({
                ...this.state,
                errors: featuresResult.errors,
                isLoadingFeatures: false
            });
        }).catch((error)=>{
            console.log(error);
        });
        return promise;
    }
    async getApplicationFeature(applicationFeatureId) {
        try {
            return await _api.getApplicationFeature(applicationFeatureId);
        } catch (e) {
            this.setState({
                ...this.state,
                loadingAppFeatureIds: this.state.loadingAppFeatureIds.filter((s)=>s !== applicationFeatureId),
                errors: [
                    e.toString()
                ]
            });
        }
    }
    async getContentItemsForAppFeature(applicationFeatureId) {
        try {
            await this.setState({
                ...this.state,
                loadingAppFeatureIds: [
                    ...this.state.loadingAppFeatureIds,
                    applicationFeatureId
                ]
            });
            var result = await _api.getContentItemsForFeature(applicationFeatureId);
            if (result.resultType == "Ok") {
                const contentItems = this.state.generalContentItems.filter((c)=>c.applicationFeatureId != applicationFeatureId);
                contentItems.push(...result.data);
                await this.setState({
                    ...this.state,
                    loadingAppFeatureIds: this.state.loadingAppFeatureIds.filter((s)=>s !== applicationFeatureId),
                    generalContentItems: contentItems,
                    errors: []
                });
            } else await this.setState({
                ...this.state,
                loadingAppFeatureIds: this.state.loadingAppFeatureIds.filter((s)=>s !== applicationFeatureId),
                errors: result.errors
            });
        } catch (e) {
            this.setState({
                ...this.state,
                loadingAppFeatureIds: this.state.loadingAppFeatureIds.filter((s)=>s !== applicationFeatureId),
                errors: [
                    e.toString()
                ]
            });
        }
        return result;
    }
    findContentById(contentItemId) {
        return this.state.generalContentItems.find((c)=>c.id == contentItemId);
    }
    getContentByFeatureId(applicationFeatureId) {
        return this.state.generalContentItems.filter((c)=>c.applicationFeatureId == applicationFeatureId);
    }
    addContentItemToState(contentItem) {
        this.setState({
            ...this.state,
            generalContentItems: [
                contentItem,
                ...this.state.generalContentItems
            ]
        });
    }
    getFeaturesForParent(applicationFeatureId) {
        return (0, _lodashDefault.default).orderBy(this.state.allFeatures.filter((af)=>af.parentId == applicationFeatureId), (af)=>af.priority, "asc");
    }
    getRootFeature(applicationId) {
        return this.state.allFeatures.find((af)=>!af.parentId && af.applicationId == applicationId);
    }
    getTopLevelFeatures(applicationId) {
        const root = this.getRootFeature(applicationId);
        if (!root) return [];
        return (0, _lodashDefault.default).orderBy(this.state.allFeatures.filter((af)=>af.parentId == root.id), (af)=>af.priority, "asc");
    }
    getAllAncestors(applicationFeatureId) {
        const feature = this.findFeatureById(applicationFeatureId);
        if (!feature) return [];
        const output = [];
        output.push(feature);
        var parentId = feature.parentId;
        while(parentId){
            const parent = this.findFeatureById(parentId);
            output.push(parent);
            parentId = parent?.parentId;
        }
        return output;
    }
    getCurrentFeature() {
        return this.state.allFeatures.find((af)=>af.id == this.state.currentTopicFeatureId);
    }
    getTopFeature(applicationFeatureId) {
        var appFeature = this.findFeatureById(applicationFeatureId);
        while(!appFeature){
            if (!appFeature?.parentId) return appFeature;
            appFeature = this.findFeatureById(appFeature?.parentId);
        }
    }
    getTopLevelFeaturesForModule(applicationModuleId, applicationId) {
        return (0, _lodashDefault.default).sortBy(this.state.allFeatures.filter((af)=>af.applicationId == applicationId && af.applicationModuleId == applicationModuleId && !af.parentId), (af)=>af.priority);
    }
    findGeneralByFeatureType(featureTypeId) {
        const appFeature = this.state.allFeatures.find((a)=>a.feature.featureType.id == featureTypeId);
        return appFeature;
    }
    getConversationCounts(applicationId) {
        var promise = _api.getAppFeatureConversationCount(applicationId);
        promise.then((result)=>{
            if (result.resultType == "Ok") {
                var counts = this.state.conversationCounts;
                result.data.forEach((count)=>{
                    var existingCount = counts.find((c)=>c.applicationFeatureId == count.applicationFeatureId);
                    if (existingCount == null) counts.push(count);
                    else counts[counts.indexOf(existingCount)] = count;
                });
                this.setState({
                    ...this.state,
                    conversationCounts: counts
                });
            }
        });
        return promise;
    }
    getConversationCountForFeature(applicationFeatureId) {
        const appFeatureCount = this.state.conversationCounts.find((af)=>af.applicationFeatureId == applicationFeatureId);
        if (appFeatureCount === null || appFeatureCount === undefined) return 0;
        var count = appFeatureCount.conversationCount;
        this.getFeaturesForParent(applicationFeatureId)?.forEach((af)=>{
            count += this.getConversationCountForFeature(af.id) ?? 0;
        });
        return count;
    }
    getSystemFeatures() {
        if (this.state.systemFeatures.length > 0) return new Promise((resolve)=>resolve({
                data: this.state.systemFeatures,
                errors: null,
                resultType: "Ok"
            }));
        this.setState({
            ...this.state,
            isLoadingSystemFeatures: true
        });
        var promise = _api.getSystemFeatures();
        promise.then((result)=>{
            if (result.resultType == "Ok") this.setState({
                ...this.state,
                errors: [],
                systemFeatures: result.data,
                isLoadingSystemFeatures: false
            });
            else this.setState({
                ...this.state,
                errors: result.errors,
                isLoadingSystemFeatures: false
            });
        }).catch((error)=>{
            this.setState({
                ...this.state,
                errors: [
                    error
                ],
                isLoadingSystemFeatures: false
            });
        });
        return promise;
    }
    addApplicationFeature(applicationId, name, parentApplicationFeatureId) {
        this.setState({
            ...this.state,
            isAddingFeature: true
        });
        var promise = _api.addFeature(applicationId, {
            name,
            parentApplicationFeatureId
        });
        promise.then((result)=>{
            if (result.resultType == "Ok") {
                const features = this.state.allFeatures;
                features.unshift(result.data);
                this.setState({
                    ...this.state,
                    isAddingFeature: false,
                    errors: [],
                    allFeatures: features
                });
            } else this.setState({
                ...this.state,
                isAddingFeature: false,
                errors: result.errors
            });
        }).catch((e)=>{
            this.setState({
                ...this.state,
                isAddingFeature: false,
                errors: [
                    e.toString()
                ]
            });
        });
        return promise;
    }
    deleteApplicationFeature(applicationFeatureId) {
        this.setState({
            ...this.state,
            isDeleting: true
        });
        const promise = _api.disableApplicationFeature(applicationFeatureId);
        promise.then((result)=>{
            if (result.resultType == "Ok") {
                const features = this.state.allFeatures;
                features.splice(features.indexOf(this.findFeatureById(applicationFeatureId)), 1);
                this.setState({
                    ...this.state,
                    allFeatures: features,
                    isDeleting: false,
                    errors: result.errors
                });
            }
            this.setState({
                ...this.state,
                isDeleting: false
            });
        }).catch((error)=>{
            this.setState({
                ...this.state,
                isDeleting: false,
                errors: [
                    error
                ]
            });
        });
        return promise;
    }
    updateApplicationFeature(applicationFeatureId, model) {
        var existingFeature = this.findFeatureById(applicationFeatureId);
        existingFeature.name = model.name;
        this.setState({
            ...this.state,
            allFeatures: this.state.allFeatures // TODO: check if this works
        });
        const promise = _api.updateApplicationFeature(applicationFeatureId, model);
        promise.then((result)=>{
            if (result.resultType != "Ok") this.setState({
                ...this.state,
                errors: result.errors
            });
        }).catch((error)=>{
            this.setState({
                ...this.state,
                errors: [
                    error
                ]
            });
        });
        return promise;
    }
    moveFeatureUp(applicationFeatureId) {
        const feature = this.findFeatureById(applicationFeatureId);
        // sort locally
        var familyFeatures = (0, _lodashDefault.default).orderBy(this.state.allFeatures.filter((af)=>af.parentId == feature.parentId && af.applicationId == feature.applicationId), (af)=>af.priority, "asc").map((af)=>af.id);
        var originalIndex = familyFeatures.indexOf(feature.id);
        if (originalIndex <= 0) return;
        familyFeatures = this.moveFeatureInParent(familyFeatures, originalIndex, originalIndex - 1);
        this.setFeatureOrder(feature.applicationId, feature.parentId, familyFeatures);
    }
    moveFeatureDown(applicationFeatureId) {
        const feature = this.findFeatureById(applicationFeatureId);
        // sort locally
        var familyFeatures = (0, _lodashDefault.default).orderBy(this.state.allFeatures.filter((af)=>af.parentId == feature.parentId && af.applicationId == feature.applicationId), (af)=>af.priority, "asc").map((af)=>af.id);
        var originalIndex = familyFeatures.indexOf(feature.id);
        if (originalIndex >= familyFeatures.length) return;
        familyFeatures = this.moveFeatureInParent(familyFeatures, originalIndex, originalIndex + 1);
        this.setFeatureOrder(feature.applicationId, feature.parentId, familyFeatures);
    }
    setFeatureOrder(applicationId, parentApplicationFeatureId, sortedAppFeatureIds) {
        // set local state for perf, then call api
        const allFeatures = this.state.allFeatures;
        sortedAppFeatureIds.forEach((id, index)=>{
            const feature = allFeatures.find((af)=>af.id == id);
            feature.priority = index;
        });
        this.setState({
            ...this.state,
            allFeatures
        });
        // sort in api
        _api.setFeatureOrder(applicationId, parentApplicationFeatureId, sortedAppFeatureIds).then((result)=>{
            if (result.resultType != "Ok") this.setState({
                ...this.state,
                errors: result.errors
            });
        }).catch((e)=>{
            this.setState({
                ...this.state,
                errors: [
                    e.toString()
                ]
            });
        });
    }
    setFeatureContentItemsOrder(applicationFeatureId, sortedContentItems) {
        // set local state for perf, then call api
        let priority = 0;
        // Set new Priority based on order
        const itemsOrdered = sortedContentItems.map((item)=>{
            let itemWithPriority = item;
            itemWithPriority.priority = priority++;
            return itemWithPriority;
        });
        this.setState({
            ...this.state,
            generalContentItems: itemsOrdered
        });
        const contentItemsRequest = sortedContentItems.map((item)=>{
            const refItem = {
                contentId: item.id,
                featureTypeId: item.featureTypeId
            };
            return refItem;
        });
        // sort in api
        _api.setFeatureContentItemsOrder(applicationFeatureId, contentItemsRequest).then((result)=>{
            if (result.resultType != "Ok") this.setState({
                ...this.state,
                errors: result.errors
            });
        }).catch((e)=>{
            this.setState({
                ...this.state,
                errors: [
                    e.toString()
                ]
            });
        });
    }
    moveFeatureInParent(features, originalPosition, newPosition) {
        if (newPosition >= features.length) {
            var k = newPosition - features.length + 1;
            while(k--)features.push(undefined);
        }
        features.splice(newPosition, 0, features.splice(originalPosition, 1)[0]);
        return features;
    }
    bulkMoveToAppFeature(applicationFeatureId, request) {
        this.setState({
            ...this.state,
            isMoving: true
        });
        var returnPromise = this.bulkOperation(request.applicationId, _api.bulkMoveTo(applicationFeatureId, request));
        returnPromise.then(()=>{
            this.refreshForAppFeature(request.applicationId, applicationFeatureId);
            this.setState({
                ...this.state,
                isMoving: false
            });
        });
        return returnPromise;
    }
    bulkCopyToAppFeature(applicationFeatureId, request) {
        this.setState({
            ...this.state,
            isCopying: true
        });
        var returnPromise = this.bulkOperation(request.applicationId, _api.bulkCopyTo(applicationFeatureId, request));
        returnPromise.then(()=>{
            this.refreshForAppFeature(request.applicationId, applicationFeatureId);
            this.setState({
                ...this.state,
                isCopying: false
            });
        });
        return returnPromise;
    }
    bulkDeleteContent(applicationFeatureId, request) {
        this.setState({
            ...this.state,
            isDeleting: true
        });
        var returnPromise = this.bulkOperation(request.applicationId, _api.bulkDisableAndDelete(request));
        returnPromise.then((result)=>{
            if (result.resultType == "Ok") this.setState({
                ...this.state,
                generalContentItems: this.state.generalContentItems.filter((c)=>!request.content.some((rc)=>rc.id === c.id)),
                allFeatures: this.state.allFeatures.filter((c)=>!request.applicationFeatures.some((rf)=>rf.id === c.id)),
                isDeleting: false
            });
            else this.setState({
                ...this.state,
                isDeleting: false
            });
        });
        return returnPromise;
    }
    // After full update need to synchronize changes by updating feature's content items state
    addOrUpdateContentItem(contentItem, response, featureTypeId) {
        const generalContentItems = this.state.generalContentItems;
        const genericItem = generalContentItems.find((c)=>c.id == contentItem?.id);
        var newItem = {
            ...genericItem,
            ...contentItem,
            featureTypeId,
            hasAudio: response?.audio != null,
            hasBackgroundImage: response?.backgroundImage != null,
            hasForegroundImage: response?.largeImage != null,
            hasVideo: response?.video != null
        };
        if (!genericItem) // New content item
        generalContentItems.push(newItem);
        else // Edited content item
        generalContentItems[generalContentItems.indexOf(genericItem)] = newItem;
        this.setState({
            ...this.state,
            generalContentItems
        });
    }
    async bulkOperation(applicationId, promise) {
        this.setState({
            ...this.state,
            isLoadingBulkOperation: true
        });
        try {
            var result = await promise;
            if (result?.resultType == "Ok") {
                this.getConversationCounts(applicationId);
                this.setState({
                    ...this.state,
                    isLoadingBulkOperation: false,
                    errors: []
                });
            } else this.setState({
                ...this.state,
                isLoadingBulkOperation: false,
                errors: result.errors
            });
        } catch (e) {
            this.setState({
                ...this.state,
                isLoadingBulkOperation: false,
                errors: [
                    e?.toString()
                ]
            });
        }
        return promise;
    }
    getFeatureTypeById(id) {
        const feature = this.state.systemFeatures.find((f)=>f.featureType.id == id);
        if (!feature) return null;
        return feature.featureType;
    }
    toggleLive(contentId, featureTypeId, isLive) {
        var promise;
        switch(featureTypeId){
            case 0, _featureTypeIds.WelcomeMessagesFeatureTypeId:
                promise = _api.toggleWelcomeMessageLive(contentId, isLive);
                break;
            case 0, _featureTypeIds.FallbackFeatureTypeId:
                promise = _api.toggleFallbackMessageLive(contentId, isLive);
                break;
            case 0, _featureTypeIds.HelpMessagesFeatureTypeId:
                promise = _api.toggleHelpMessageLive(contentId, isLive);
                break;
            case 0, _featureTypeIds.ExitMessagesFeatureTypeId:
                promise = _api.toggleExitMessageLive(contentId, isLive);
                break;
            case 0, _featureTypeIds.QuestionAnswerFeatureTypeId:
                promise = _api.toggleQuestionAnswerLive(contentId, isLive);
                break;
            case 0, _featureTypeIds.LatestMessagesFeatureTypeId:
                promise = _api.toggleLatestMessageLive(contentId, isLive);
                break;
            case 0, _featureTypeIds.NumberRangeFeatureTypeId:
                promise = _api.toggleNumberRangeLive(contentId, isLive);
                break;
            case 0, _featureTypeIds.SimpleChoiceFeatureTypeId:
                promise = _api.toggleSimpleChoiceLive(contentId, isLive);
                break;
            case 0, _featureTypeIds.CustomRequestsFeatureTypeId:
                promise = _api.toggleCustomRequestLive(contentId, isLive);
                break;
        }
        const contentItems = this.state.generalContentItems;
        const contentItem = contentItems.find((c)=>c.id == contentId);
        if (contentItem) {
            contentItems[contentItems.indexOf(contentItem)] = {
                ...contentItem,
                isLive
            };
            this.setState({
                ...this.state,
                generalContentItems: contentItems
            });
        }
        return promise;
    }
    async getApplicationFeatureContentPublishStatus(appFeatureId, environmentId) {
        try {
            var result = await _api.getApplicationFeaturePublishHistory(appFeatureId, environmentId, 0, 1);
            if (result?.resultType == "Ok") this.setState({
                ...this.state,
                featureContentPublishStatus: result.data,
                loadedPublishHistoryFeatureId: appFeatureId,
                errors: []
            });
            else this.setState({
                ...this.state,
                errors: result.errors
            });
        } catch (e) {
            this.setState({
                ...this.state,
                isLoadingBulkOperation: false,
                errors: [
                    e?.toString()
                ]
            });
        }
        return result;
    }
    setLoading(isLoading) {
        this.setState({
            ...this.state,
            isLoadingFeatures: isLoading
        });
    }
}
exports.default = FeatureContainer;

},{"@babel/runtime/helpers/defineProperty":"9sJxO","unstated":"grh7p","../../api":"loxM6","lodash":"3hMBK","../../constants/featureTypeIds":"hPLMP","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"cg7ga":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _defineProperty = require("@babel/runtime/helpers/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _unstated = require("unstated");
var _api = require("../../api");
class ConditionsContainer extends (0, _unstated.Container) {
    constructor(...args){
        super(...args);
        (0, _definePropertyDefault.default)(this, "state", {
            conditions: [],
            isLoading: false,
            errors: []
        });
    }
    async getConditions() {
        if (this.state.conditions.length > 0) return {
            conditions: this.state.conditions,
            resultType: "Ok",
            errors: []
        };
        try {
            await this.setState({
                ...this.state,
                isLoading: true
            });
            const result = await _api.getConditions();
            await this.setState({
                ...this.state,
                conditions: result.data,
                errors: result.errors,
                isLoading: false
            });
            return result;
        } catch  {
            await this.setState({
                ...this.state,
                errors: [
                    "Unable to get conditions"
                ],
                isLoading: false
            });
        }
    }
}
exports.default = ConditionsContainer;

},{"@babel/runtime/helpers/defineProperty":"9sJxO","unstated":"grh7p","../../api":"loxM6","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9rh2U":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _extends = require("@babel/runtime/helpers/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _base = require("@emotion/styled/base");
var _baseDefault = parcelHelpers.interopDefault(_base);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _mediaSelectionCard = require("../../../components/forms/MediaSelectionCard");
var _mediaSelectionCardDefault = parcelHelpers.interopDefault(_mediaSelectionCard);
var _button = require("../../../components/general/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _contentCard = require("../../../components/structure/ContentCard");
var _contentCardDefault = parcelHelpers.interopDefault(_contentCard);
var _contentCollapsingSection = require("../../../components/structure/ContentCollapsingSection");
var _contentCollapsingSectionDefault = parcelHelpers.interopDefault(_contentCollapsingSection);
var _formFieldsContainer = require("../../../components/structure/FormFieldsContainer");
var _formFieldsContainerDefault = parcelHelpers.interopDefault(_formFieldsContainer);
var _mediaResponseManager = require("../../mediaResponseManager");
var _mediaResponseManagerDefault = parcelHelpers.interopDefault(_mediaResponseManager);
var _manageFollowUpForm = require("../../followUpForm/components/ManageFollowUpForm");
var _manageFollowUpFormDefault = parcelHelpers.interopDefault(_manageFollowUpForm);
var _manageRepromptForm = require("../../followUpForm/components/ManageRepromptForm");
var _manageRepromptFormDefault = parcelHelpers.interopDefault(_manageRepromptForm);
var _conditionsGroup = require("./ConditionsGroup");
var _conditionsGroupDefault = parcelHelpers.interopDefault(_conditionsGroup);
var _conditionManager = require("./ConditionManager");
var _conditionManagerDefault = parcelHelpers.interopDefault(_conditionManager);
var _lodash = require("lodash");
var _lodashDefault = parcelHelpers.interopDefault(_lodash);
var _addResponseSection = require("./AddResponseSection");
var _addResponseSectionDefault = parcelHelpers.interopDefault(_addResponseSection);
var _repromptManager = require("../../repromptManager");
var _repromptManagerDefault = parcelHelpers.interopDefault(_repromptManager);
var _followUpManager = require("../../followUpManager");
var _followUpManagerDefault = parcelHelpers.interopDefault(_followUpManager);
var _largeOverflowMenu = require("../../../components/general/LargeOverflowMenu");
var _largeOverflowMenuDefault = parcelHelpers.interopDefault(_largeOverflowMenu);
var _colors = require("../../../constants/colors");
var _stylesValues = require("../../../constants/stylesValues");
var _flagRulesGroup = require("./FlagRulesGroup");
var _flagRulesGroupDefault = parcelHelpers.interopDefault(_flagRulesGroup);
var _flagRuleCreator = require("./FlagRuleCreator");
var _flagRuleCreatorDefault = parcelHelpers.interopDefault(_flagRuleCreator);
var _horizontalSeparator = require("../../../components/structure/HorizontalSeparator");
var _horizontalSeparatorDefault = parcelHelpers.interopDefault(_horizontalSeparator);
var _extensions = require("../../../models/extensions");
var _reactBeautifulDnd = require("react-beautiful-dnd");
var _responseEffectsList = require("./ResponseEffectsList");
var _responseEffectsListDefault = parcelHelpers.interopDefault(_responseEffectsList);
var _effectManager = require("./EffectManager");
var _effectManagerDefault = parcelHelpers.interopDefault(_effectManager);
var _countButton = require("../../contentPage/components/CountButton");
var _switch = require("../../../components/forms/Switch");
var _switchDefault = parcelHelpers.interopDefault(_switch);
var _styledDropdown = require("../../applicationSettings/components/customAssistantConfigurations/StyledDropdown");
var _styledDropdownDefault = parcelHelpers.interopDefault(_styledDropdown);
var _response = require("./Response");
var _responseDefault = parcelHelpers.interopDefault(_response);
var _contentExplorer = require("../../contentExplorer");
var _contentExplorerDefault = parcelHelpers.interopDefault(_contentExplorer);
var _applicationFeature = require("../../../models/extensions/applicationFeature");
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const outputIcon = require("e918329189f4a0a8");
const shuffleIcon = require("b4f35cb2a751a4e3");
const decisionIcon = require("9a72bd7b619da51c");
const responseGroupIcon = require("b417313a0143d3f4");
const userFlagsIcon = require("154c4a16afe98509");
const userFlagsSmallIcon = require("6fe3f5d3e7899703");
const userFlagsSmallBlueIcon = require("72be1e63f37482cc");
const requiredStarIcon = require("941d4a39369595b4");
const upIcon = require("79d8632901a1f4d1");
const downIcon = require("71763b1e0f4711ce");
const deleteIcon = require("cea46f96d3cfda8b");
const duplicateIcon = require("ee84de82c49fda39");
const copyIcon = require("ee84de82c49fda39");
const effectIcon = require("f0ca8623f1300220");
const effectBlueIcon = require("a7868b25b49896b4");
const temperatureOptions = [
    {
        name: ".1",
        value: .1
    },
    {
        name: ".2",
        value: .2
    },
    {
        name: ".3",
        value: .3
    },
    {
        name: ".4",
        value: .4
    },
    {
        name: ".5",
        value: .5
    },
    {
        name: ".6",
        value: .6
    },
    {
        name: ".7",
        value: .7
    },
    {
        name: ".8",
        value: .8
    },
    {
        name: ".9",
        value: .9
    },
    {
        name: "1",
        value: 1
    }
];
class Responses extends (0, _reactDefault.default).Component {
    constructor(props){
        super(props);
        this.state = {
            isMediaToggled: false,
            isFollowUpToggled: false,
            isRepromptToggled: false,
            hasFollowUpChanges: false,
            isFlagsToggled: false,
            isEffectsToggled: false,
            editingEffect: null,
            isConditionToggled: false,
            isCloningDefault: false,
            editingResponseGroup: null,
            editingCondition: null,
            editingParentCondition: null,
            expandedFlagGroupKeys: [],
            expandedEffectGroupKeys: [],
            isCopyResponseGroupToggled: false,
            copyingResponseGroupIndex: null,
            selectedContentItemName: null
        };
    }
    componentDidMount() {
        this.props.conditionsContainer.getConditions();
        this.props.appFlagsContainer.loadApplicationFlags(this.props.applicationId);
        this.checkForCopiedResponseGroup();
    }
    checkForCopiedResponseGroup() {
        const copiedGroupDataStr = sessionStorage.getItem("voicify_copied_response_group");
        if (!copiedGroupDataStr) return;
        try {
            const copiedGroupData = JSON.parse(copiedGroupDataStr);
            // Check if the data is recent (within 5 minutes) to avoid stale data
            if (Date.now() - copiedGroupData.timestamp > 300000) {
                sessionStorage.removeItem("voicify_copied_response_group");
                return;
            }
            const responseGroupToCopy = copiedGroupData.responseGroup;
            if (!responseGroupToCopy || !responseGroupToCopy.key) return;
            const groups = [
                ...this.props.responseGroups
            ];
            const priority = groups.length;
            const copiedConditions = this.createDeepCopyOfConditions(responseGroupToCopy.conditions);
            const copiedResponses = this.createDeepCopyOfResponses(responseGroupToCopy, copiedConditions, priority, ` (Copied from ${copiedGroupData.sourceContentItemTitle})`);
            // Create the copied group with a unique key
            const copiedGroup = {
                key: this.props.getConditionsKey(copiedConditions) + "_copied_" + Date.now(),
                conditions: copiedConditions,
                responses: copiedResponses,
                firstResponse: copiedResponses[0],
                priority
            };
            groups.push(copiedGroup);
            groups.forEach((group, i)=>{
                group.priority = i;
                group.responses?.forEach((response)=>{
                    response.groupPriority = i;
                });
            });
            this.props.onChange(groups);
            sessionStorage.removeItem("voicify_copied_response_group");
        } catch (error) {
            console.warn("Failed to parse copied response group data:", error);
            sessionStorage.removeItem("voicify_copied_response_group");
        }
    }
    handleSsmlUpdate(ssml, responseGroup, index) {
        const groups = this.props.responseGroups;
        const editedGroup = groups.find((g)=>g.key == responseGroup.key);
        if (!editedGroup) return;
        editedGroup.responses[index].content = ssml;
        this.props.onChange(groups);
    }
    handleSystemPromptUpdate(s, responseGroup, index) {
        const groups = this.props.responseGroups;
        const editedGroup = groups.find((g)=>g.key == responseGroup.key);
        if (!editedGroup) return;
        editedGroup.responses[index].systemPrompt = s;
        this.props.onChange(groups);
    }
    handleConversationTurnsLimitUpdate(limit, responseGroup, index) {
        const groups = this.props.responseGroups;
        const editedGroup = groups.find((g)=>g.key == responseGroup.key);
        if (!editedGroup) return;
        //if the limit enetered is empty then we want to set it to 0 because its a number field
        if (limit === "" || limit === null) {
            editedGroup.responses[index].lastTurnsToInclude = 0;
            this.props.onChange(groups);
            return;
        }
        const numValue = parseInt(limit);
        if (!isNaN(numValue) && numValue >= 0) {
            editedGroup.responses[index].lastTurnsToInclude = numValue;
            this.props.onChange(groups);
        }
    }
    handleContextualSystemPrompt(s, responseGroup, index) {
        const groups = this.props.responseGroups;
        const editedGroup = groups.find((g)=>g.key == responseGroup.key);
        if (!editedGroup) return;
        editedGroup.responses[index].contextualSystemPrompt = s;
        this.props.onChange(groups);
    }
    handleTemperature(t, responseGroup, index) {
        const groups = this.props.responseGroups;
        const editedGroup = groups.find((g)=>g.key == responseGroup.key);
        if (!editedGroup) return;
        editedGroup.responses[index].temperature = t;
        this.props.onChange(groups);
    }
    handleToggleGenerativeResponse(responseGroup) {
        const groups = this.props.responseGroups;
        const editedGroup = groups.find((g)=>g.key == responseGroup.key);
        if (!editedGroup) return;
        const newBool = !editedGroup.responses[0].useEnhancedResponse;
        editedGroup.responses.forEach((r)=>r.useEnhancedResponse = newBool);
        this.props.onChange(groups);
    }
    handleToggleUseHistoryInSystemPrompt(responseGroup) {
        const groups = this.props.responseGroups;
        const editedGroup = groups.find((g)=>g.key == responseGroup.key);
        if (!editedGroup) return;
        const newBool = !editedGroup.responses[0].useHistoryInSystemPrompt;
        editedGroup.responses.forEach((r)=>r.useHistoryInSystemPrompt = newBool);
        this.props.onChange(groups);
    }
    handleToggleOnlyIncludeCurrentContentItemHistory(responseGroup) {
        const groups = this.props.responseGroups;
        const editedGroup = groups.find((g)=>g.key == responseGroup.key);
        if (!editedGroup) return;
        const newBool = !editedGroup.responses[0].onlyIncludeCurrentContentItemHistory;
        editedGroup.responses.forEach((r)=>r.onlyIncludeCurrentContentItemHistory = newBool);
        this.props.onChange(groups);
    }
    handleAddSsmlVariation(responseGroup) {
        const groups = this.props.responseGroups;
        const editedGroup = groups.find((g)=>g.key == responseGroup.key);
        if (!editedGroup) return;
        if (!editedGroup?.responses?.length) editedGroup.responses.push({
            conditions: responseGroup.conditions,
            content: ""
        });
        else {
            var firstResponse = editedGroup.responses[0];
            editedGroup.responses.push({
                ...firstResponse,
                conditions: responseGroup.conditions,
                content: ""
            });
        }
        this.props.onChange(groups);
    }
    handleRemoveVariation(responseGroup, index) {
        const groups = this.props.responseGroups;
        const editedGroup = groups.find((g)=>g.key == responseGroup.key);
        if (!editedGroup) return;
        editedGroup.responses.splice(index, 1);
        this.props.onChange(groups);
    }
    handleTitleChange(responseGroup, index, newTitle) {
        const groups = this.props.responseGroups;
        const editedGroup = groups.find((g)=>g.key == responseGroup.key);
        if (!editedGroup) return;
        editedGroup.responses[index].name = newTitle;
        this.props.onChange(groups);
    }
    handleUpdateFullResponse(responseGroup, index, newResponse) {
        const groups = this.props.responseGroups;
        const editedGroup = groups.find((g)=>g.key == responseGroup.key);
        if (!editedGroup) return;
        editedGroup.responses[index] = newResponse;
        this.props.onChange(groups);
    }
    handleCopyVariation(responseGroup, index) {
        const groups = this.props.responseGroups;
        const editedGroup = groups.find((g)=>g.key == responseGroup.key);
        if (!editedGroup) return;
        const newResponse = {
            ...responseGroup.responses[index]
        };
        newResponse.id = null;
        editedGroup.responses.splice(index, 0, newResponse);
        this.props.onChange(groups);
    }
    handleUploadMedia(responseGroup) {
        this.setState({
            ...this.state,
            isMediaToggled: true,
            editingResponseGroup: responseGroup
        });
    }
    handleUploadMediaClose() {
        this.setState({
            ...this.state,
            isMediaToggled: false,
            editingResponseGroup: null
        });
    }
    handleMediaSelected(data, responseGroup) {
        const groups = this.props.responseGroups;
        const editedResponseGroup = responseGroup ?? this.state.editingResponseGroup;
        const editedGroup = groups.find((g)=>g.key == editedResponseGroup.key);
        if (!editedGroup) return;
        editedGroup.responses.forEach((r)=>{
            r.audio = data.audioItem;
            r.backgroundImage = data.backgroundImageItem;
            r.displayTextOverride = data.displayTextOverride;
            r.displayTitleOverride = data.displayTitleOverride;
            r.largeImage = data.imageItem;
            r.mediaResponseContainerId = data.fullContainer?.id;
            r.mediaResponseContainer = data.fullContainer;
            r.video = data.videoItem;
        });
        this.props.onChange(groups);
        this.setState({
            ...this.state,
            isMediaToggled: false
        });
    }
    handleFollowUpChange(followUp, childItemContainer, responseGroup, isEndSession) {
        const groups = this.props.responseGroups;
        const editedResponseGroup = responseGroup ?? this.state.editingResponseGroup;
        const editedGroup = groups.find((g)=>g.key == editedResponseGroup.key);
        if (!editedGroup) return;
        if (followUp) followUp.childContentContainer = childItemContainer;
        editedGroup.firstResponse.followUp = followUp;
        editedGroup.firstResponse.followUpId = followUp?.id;
        editedGroup.responses.forEach((r)=>{
            r.followUp = followUp;
            r.followUpId = followUp?.id;
            // Set forceEndSession flag for fallback messages when endSession is selected
            if (isEndSession) r.forceEndSession = true;
            else r.forceEndSession = false;
        });
        this.props.onChange(groups);
        this.setState({
            ...this.state,
            hasFollowUpChanges: true,
            isFollowUpToggled: false
        });
    }
    handleRepromptChange(reprompt, responseGroup) {
        const groups = this.props.responseGroups;
        const editedResponseGroup = responseGroup ?? this.state.editingResponseGroup;
        const editedGroup = groups.find((g)=>g.key == editedResponseGroup.key);
        if (!editedGroup) return;
        editedGroup.firstResponse.reprompt = reprompt;
        editedGroup.responses.forEach((r)=>{
            r.reprompt = reprompt;
        });
        this.props.onChange(groups);
        this.setState({
            ...this.state,
            hasFollowUpChanges: true,
            isRepromptToggled: false
        });
    }
    handleRepromptClose() {
        this.setState({
            ...this.state,
            isRepromptToggled: false,
            editingResponseGroup: null
        });
    }
    handleFollowUpClose() {
        this.setState({
            ...this.state,
            isFollowUpToggled: false,
            editingResponseGroup: null
        });
    }
    handleToggleGroupFlags(responseGroup) {
        const flagGroups = this.state.expandedFlagGroupKeys;
        const effectGroups = this.state.expandedEffectGroupKeys;
        if (flagGroups.some((g)=>g == responseGroup.key)) (0, _lodashDefault.default).remove(flagGroups, (g)=>g == responseGroup.key);
        else flagGroups.push(responseGroup.key);
        if (effectGroups.some((g)=>g == responseGroup.key)) (0, _lodashDefault.default).remove(effectGroups, (g)=>g == responseGroup.key);
        this.setState({
            ...this.state,
            expandedFlagGroupKeys: flagGroups,
            expandedEffectGroupKeys: effectGroups
        });
    }
    handleToggleGroupEffects(responseGroup) {
        const effectGroups = this.state.expandedEffectGroupKeys;
        const flagGroups = this.state.expandedFlagGroupKeys;
        if (effectGroups.some((g)=>g == responseGroup.key)) (0, _lodashDefault.default).remove(effectGroups, (g)=>g == responseGroup.key);
        else effectGroups.push(responseGroup.key);
        if (flagGroups.some((g)=>g == responseGroup.key)) (0, _lodashDefault.default).remove(flagGroups, (g)=>g == responseGroup.key);
        this.setState({
            ...this.state,
            expandedEffectGroupKeys: effectGroups,
            expandedFlagGroupKeys: flagGroups
        });
    }
    handleEditFlags(responseGroup) {
        this.setState({
            ...this.state,
            isFlagsToggled: true,
            editingResponseGroup: responseGroup
        });
    }
    handleAddEffect(responseGroup) {
        this.setState({
            ...this.state,
            isEffectsToggled: true,
            editingEffect: null,
            editingResponseGroup: responseGroup
        });
    }
    handleEditEffect(responseGroup, effect) {
        this.setState({
            ...this.state,
            isEffectsToggled: true,
            editingEffect: effect,
            editingResponseGroup: responseGroup
        });
    }
    handleEditReprompt(responseGroup) {
        this.setState({
            ...this.state,
            isRepromptToggled: true,
            editingResponseGroup: responseGroup
        });
    }
    handleShowRepromptModal(responseGroup) {
        this.setState({
            ...this.state,
            isRepromptToggled: true,
            editingResponseGroup: responseGroup
        });
    }
    handleShowFollowUpModal(responseGroup) {
        this.setState({
            ...this.state,
            isFollowUpToggled: true,
            editingResponseGroup: responseGroup
        });
    }
    handleCancelCondition() {
        this.setState({
            ...this.state,
            isConditionToggled: false,
            editingCondition: null,
            editingParentCondition: null,
            editingResponseGroup: null
        });
    }
    handleCancelFlags() {
        this.setState({
            ...this.state,
            isFlagsToggled: false,
            editingResponseGroup: null
        });
    }
    handleCancelEffects() {
        this.setState({
            ...this.state,
            isEffectsToggled: false,
            editingResponseGroup: null
        });
    }
    handleAddFlagToGroup(flagRule) {
        const groups = this.props.responseGroups;
        const editedResponseGroup = this.state.editingResponseGroup;
        const editedGroup = groups.find((g)=>g.key == editedResponseGroup.key);
        if (!editedGroup) return;
        editedGroup.responses.forEach((r)=>{
            r.flagRules = [
                ...r.flagRules ?? [],
                flagRule
            ];
        });
        this.props.onChange(groups);
        this.setState({
            ...this.state,
            isFlagsToggled: false
        });
    }
    handleRemoveFlagFromGroup(flagRule, responseGroup) {
        const groups = this.props.responseGroups;
        if (!responseGroup) return;
        responseGroup.responses.forEach((r)=>{
            (0, _lodashDefault.default).remove(r.flagRules, (f)=>f == flagRule);
        });
        this.props.onChange(groups);
        this.setState({
            ...this.state,
            isFlagsToggled: false
        });
    }
    handleEffectManagerFinish(effect) {
        const groups = this.props.responseGroups;
        const editedResponseGroup = this.state.editingResponseGroup;
        const editedGroup = groups.find((g)=>g.key == editedResponseGroup.key);
        if (!editedGroup) return;
        const existingEffects = editedGroup.responses[0].effects;
        if (this.state.editingEffect) {
            const replaceIndex = existingEffects.findIndex((e)=>e === this.state.editingEffect);
            existingEffects[replaceIndex] = effect;
            editedGroup.responses.forEach((r)=>{
                r.effects = existingEffects;
            });
        } else {
            const priority = existingEffects?.length ?? 0;
            effect.priority = priority;
            editedGroup.responses.forEach((r)=>{
                r.effects = [
                    ...r.effects ?? [],
                    effect
                ];
            });
        }
        this.props.onChange(groups);
        this.setState({
            ...this.state,
            isEffectsToggled: false
        });
    }
    handleUpdateEffects(newEffects, responseGroupKey) {
        const groups = this.props.responseGroups;
        const editedResponseGroup = groups.find((g)=>g.key == responseGroupKey);
        if (!editedResponseGroup) return;
        editedResponseGroup.responses.forEach((r)=>{
            r.effects = newEffects;
        });
        this.props.onChange(groups);
    }
    handleRemoveEffectFromGroup(effect, responseGroup) {
        const groups = this.props.responseGroups;
        if (!responseGroup) return;
        //remove the effect from the first response
        (0, _lodashDefault.default).remove(responseGroup.responses[0].effects, (e)=>{
            return JSON.stringify({
                ...e,
                id: null
            }) === JSON.stringify({
                ...effect,
                id: null
            });
        });
        //make sure the alternatives response have the same effect array
        for(let i = 0; i < responseGroup.responses.length; i++)responseGroup.responses[i].effects = responseGroup.responses[0].effects;
        this.props.onChange(groups);
        this.setState({
            ...this.state,
            isEffectsToggled: false
        });
    }
    findConditionInstance(conditionInstanceId, conditionInstances) {
        let conditionInstance = null;
        const checkInstance = (ci)=>{
            if (ci.id == conditionInstanceId) return ci;
            if (ci.andCondition) return checkInstance(ci.andCondition);
            return null;
        };
        conditionInstances?.forEach((ci)=>{
            const matchedInstance = checkInstance(ci);
            if (matchedInstance != null) conditionInstance = matchedInstance;
        });
        return conditionInstance;
    }
    createDeepCopyOfResponses(responseGroup, conditions, priority, suffix) {
        return responseGroup.responses?.map((r)=>({
                ...r,
                id: null,
                responseId: null,
                followUpId: null,
                repromptId: null,
                mediaResponseContainerId: null,
                conditions: conditions || responseGroup.conditions,
                name: r.name && suffix ? `${r.name}${suffix}` : r.name,
                flagRules: r.flagRules?.map((f)=>({
                        ...f,
                        id: null
                    })) ?? [],
                followUp: r.followUp ? {
                    ...r.followUp,
                    id: null,
                    followUpId: null
                } : null,
                reprompt: r.reprompt ? {
                    ...r.reprompt,
                    id: null,
                    repromptId: null
                } : null,
                mediaResponseContainer: r.mediaResponseContainer ? {
                    ...r.mediaResponseContainer,
                    id: null,
                    mediaResponseContainerId: null,
                    responses: r.mediaResponseContainer?.responses?.map((mr)=>({
                            ...mr,
                            id: null
                        }))
                } : null,
                effects: r.effects?.map((e)=>({
                        ...e,
                        id: null
                    })) ?? [],
                groupPriority: priority
            })) || [];
    }
    createDeepCopyOfConditions(conditions, suffix) {
        return conditions?.map((condition)=>{
            const duplicateCondition = (ci)=>{
                const newCondition = {
                    ...ci,
                    id: null,
                    // Reset ID for new condition
                    value: ci.value && typeof ci.value === "string" && suffix ? `${ci.value}${suffix}` : ci.value,
                    andCondition: ci.andCondition ? duplicateCondition(ci.andCondition) : null
                };
                return newCondition;
            };
            return duplicateCondition(condition);
        }) || [];
    }
    duplicateGroup(responseGroup, conditionInstance, priority) {
        const responses = this.createDeepCopyOfResponses(responseGroup, [
            conditionInstance
        ], priority);
        const newGroup = {
            key: this.props.getConditionsKey([
                conditionInstance
            ]),
            conditions: [
                conditionInstance
            ],
            responses,
            firstResponse: responses?.[0],
            priority
        };
        return newGroup;
    }
    handleConditionChange(conditionInstance) {
        const { editingCondition, editingParentCondition, editingResponseGroup, isCloningDefault } = this.state;
        const groups = this.props.responseGroups;
        const priority = groups.length;
        // if there is no group, create a new group with an empty response and the condition
        if (!editingResponseGroup) {
            const defaultGroup = groups.find((g)=>!g.key);
            const newGroup = isCloningDefault ? this.duplicateGroup(defaultGroup, conditionInstance, priority) : {
                key: this.props.getConditionsKey([
                    conditionInstance
                ]),
                conditions: [
                    conditionInstance
                ],
                responses: [
                    {
                        content: ""
                    }
                ],
                firstResponse: {
                    content: ""
                },
                priority
            };
            groups.push(newGroup);
            // push to link to scroll to the new group
            location.href = `#g${groups.length - 1}deviceResponse`;
        } else {
            const editedGroup = groups.find((g)=>g.key == editingResponseGroup.key);
            // if there is no parent and no edit, add to the list
            if (!editingCondition && !editingParentCondition) editedGroup.conditions.push(conditionInstance);
            else if (!editingCondition) {
                const editedParent = this.findConditionInstance(editingParentCondition.id, editedGroup.conditions);
                editedParent.andCondition = conditionInstance;
            } else if (editingCondition) {
                const edited = this.findConditionInstance(editingCondition.id, editedGroup.conditions);
                edited.value = conditionInstance.value;
                edited.condition = conditionInstance.condition;
                edited.conditionId = conditionInstance.conditionId;
                edited.andCondition = conditionInstance.andCondition;
            }
        }
        this.props.onChange(groups);
        this.setState({
            ...this.state,
            isConditionToggled: false,
            editingCondition: null,
            editingParentCondition: null,
            editingResponseGroup: null
        });
    }
    handleRemoveCondition(conditionInstance, responseGroup) {
        // loop through the chain until we find by id, then remove and move the andCondition up to the parent
        const groups = this.props.responseGroups;
        const editedGroup = groups.find((g)=>g.key == responseGroup.key);
        const checkParent = (ci)=>{
            if (ci.andCondition?.id == conditionInstance.id) return ci;
            if (ci.andCondition) return checkParent(ci.andCondition);
            return null;
        };
        editedGroup?.conditions?.forEach((ci, i)=>{
            if (ci.id == conditionInstance.id) {
                // if you have an andCondition, rechain before removing it
                if (conditionInstance.andCondition) editedGroup.conditions.splice(i, 1, conditionInstance.andCondition);
                else editedGroup.conditions.splice(i, 1);
                return;
            }
            const matchedParent = checkParent(ci);
            if (matchedParent != null) matchedParent.andCondition = matchedParent.andCondition?.andCondition;
        });
        this.props.onChange(groups);
    }
    handleAddConditionResponse() {
        this.setState({
            ...this.state,
            isConditionToggled: true,
            isCloningDefault: false
        });
    }
    handleCloneConditionResponse() {
        this.setState({
            ...this.state,
            isConditionToggled: true,
            isCloningDefault: true
        });
    }
    handleEditCondition(conditionInstance, responseGroup) {
        this.setState({
            ...this.state,
            editingResponseGroup: responseGroup,
            editingCondition: conditionInstance,
            isConditionToggled: true
        });
    }
    handleAddConditionGroup(responseGroup) {
        this.setState({
            ...this.state,
            editingResponseGroup: responseGroup,
            isConditionToggled: true
        });
    }
    handleAddAndCondition(parentConditionInstance, responseGroup) {
        this.setState({
            ...this.state,
            editingResponseGroup: responseGroup,
            editingParentCondition: parentConditionInstance,
            editingCondition: null,
            isConditionToggled: true
        });
    }
    handleDeleteConditionalResponseGroup(groupIndex) {
        const groups = (0, _lodashDefault.default).orderBy(this.props.responseGroups, [
            "priority",
            "key"
        ]);
        groups.splice(groupIndex, 1);
        this.props.onChange(groups);
    }
    reorderGroups(sourceIndex, destIndex) {
        let groups = (0, _lodashDefault.default).orderBy(this.props.responseGroups, [
            "priority",
            "key"
        ]);
        // Non conditional response groups (currently only one - Default) should be above conditional response groups
        // Cannot reorder Default  group
        if (!groups[destIndex]?.key) return;
        groups = (0, _extensions.reorder)(groups, sourceIndex, destIndex);
        groups.forEach((group, i)=>{
            const groupPriority = i;
            group.priority = groupPriority;
            group.responses?.forEach((response)=>{
                response.groupPriority = groupPriority;
            });
        });
        this.props.onChange(groups);
    }
    handleConditionalResponseGroupDragEnd(result, provider) {
        // dropped outside the list
        if (!result.destination) return;
        const sourceIndex = result.source.index;
        const destIndex = result.destination.index;
        this.reorderGroups(sourceIndex, destIndex);
    }
    handleMoveUpConditionalResponseGroup(groupIndex) {
        const groups = (0, _lodashDefault.default).orderBy(this.props.responseGroups, [
            "priority",
            "key"
        ]);
        // Non conditional response groups (currently only one - Default) should be above conditional response groups
        // Cannot reorder Default  group
        if (!groups[groupIndex - 1]?.key) return;
        if (groupIndex > 0) this.reorderGroups(groupIndex, groupIndex - 1);
    }
    handleMoveDownConditionalResponseGroup(groupIndex) {
        const groups = (0, _lodashDefault.default).orderBy(this.props.responseGroups, [
            "priority",
            "key"
        ]);
        if (groupIndex < groups.length - 1) this.reorderGroups(groupIndex, groupIndex + 1);
    }
    handleDuplicateConditionalResponseGroup(groupIndex) {
        const groups = (0, _lodashDefault.default).orderBy(this.props.responseGroups, [
            "priority",
            "key"
        ]);
        const groupToDuplicate = groups[groupIndex];
        if (!groupToDuplicate || !groupToDuplicate.key) return; // Don't duplicate default response
        // Create deep copies of conditions without any suffix
        const duplicatedConditions = this.createDeepCopyOfConditions(groupToDuplicate.conditions);
        // Add a new "delete-me" condition to make the group unique
        const availableConditions = this.props.conditionsContainer?.state?.conditions || [];
        const platformCondition = availableConditions.find((c)=>c.groupName?.toLowerCase() === "platform");
        if (platformCondition) {
            const deleteMeCondition = {
                id: null,
                // Will be auto-generated
                value: "delete-me",
                andCondition: null,
                condition: platformCondition,
                conditionId: platformCondition.id
            };
            duplicatedConditions.push(deleteMeCondition);
        }
        // Calculate the priority for the new group (insert after the original)
        const newPriority = groupIndex + 1;
        // Create deep copied responses with "(Copy)" suffix for names
        const duplicatedResponses = this.createDeepCopyOfResponses(groupToDuplicate, duplicatedConditions, newPriority, " (Copy)");
        // Create the new duplicated group with a unique key
        const duplicatedGroup = {
            key: this.props.getConditionsKey(duplicatedConditions),
            conditions: duplicatedConditions,
            responses: duplicatedResponses,
            firstResponse: duplicatedResponses?.[0],
            priority: newPriority
        };
        groups.splice(groupIndex + 1, 0, duplicatedGroup);
        groups.forEach((group, i)=>{
            group.priority = i;
            group.responses?.forEach((response)=>{
                response.groupPriority = i;
            });
        });
        this.props.onChange(groups);
    }
    handleCopyResponseGroup(groupIndex) {
        this.setState({
            ...this.state,
            isCopyResponseGroupToggled: true,
            copyingResponseGroupIndex: groupIndex,
            selectedContentItemName: null
        });
    }
    handleCopyResponseGroupClose() {
        this.setState({
            ...this.state,
            isCopyResponseGroupToggled: false,
            copyingResponseGroupIndex: null,
            selectedContentItemName: null
        });
    }
    handleContentItemSelectionInCopyModal(contentItems, featureIds) {
        if (contentItems.length > 0) {
            const selectedItem = contentItems[0];
            const itemName = selectedItem.name || selectedItem.title || "Selected Content Item";
            this.setState({
                ...this.state,
                selectedContentItemName: itemName
            });
        } else this.setState({
            ...this.state,
            selectedContentItemName: null
        });
    }
    handleCopyResponseGroupSelect(contentItems, featureIds) {
        if (contentItems.length === 0) {
            this.handleCopyResponseGroupClose();
            return;
        }
        const selectedContentItem = contentItems[0];
        const copyingGroupIndex = this.state.copyingResponseGroupIndex;
        if (copyingGroupIndex === null) {
            this.handleCopyResponseGroupClose();
            return;
        }
        const groups = (0, _lodashDefault.default).orderBy(this.props.responseGroups, [
            "priority",
            "key"
        ]);
        const groupToCopy = groups[copyingGroupIndex];
        if (!groupToCopy) {
            this.handleCopyResponseGroupClose();
            return;
        }
        const copiedGroupData = {
            responseGroup: groupToCopy,
            sourceContentItemTitle: this.props.contentItemTitle || "Content Item",
            timestamp: Date.now()
        };
        sessionStorage.setItem("voicify_copied_response_group", JSON.stringify(copiedGroupData));
        this.handleCopyResponseGroupClose();
        if (selectedContentItem.featureTypeId) {
            const targetUrl = (0, _applicationFeature.getEditUrl)(selectedContentItem.id, selectedContentItem.applicationFeatureId, selectedContentItem.featureTypeId);
            window.location.href = targetUrl;
        } else {
            const targetUrl = `/v/apps/${this.props.applicationId}/content/${selectedContentItem.id}`;
            window.location.href = targetUrl;
        }
    }
    getDynamicCopySubtitle() {
        const sourceTitle = this.props.contentItemTitle || this.props.featureContainer?.findFeatureById(this.props.applicationFeatureId)?.name || this.props.featureContainer?.findFeatureById(this.props.applicationFeatureId)?.feature?.name || "Content Item";
        const baseSubtitle = `from ${sourceTitle} to`;
        if (this.state.selectedContentItemName) return `${baseSubtitle} ${this.state.selectedContentItemName}`;
        return `${baseSubtitle}:`;
    }
    getOptions(moveUpDisabled) {
        let options = [
            {
                label: "Duplicate Here",
                icon: duplicateIcon,
                hoverIcon: duplicateIcon
            },
            {
                label: "Copy to Another",
                icon: copyIcon,
                hoverIcon: copyIcon
            },
            {
                label: "Delete Response Group",
                icon: deleteIcon,
                hoverIcon: deleteIcon,
                isDestructive: true
            },
            {
                label: "Move Up",
                icon: upIcon,
                hoverIcon: upIcon
            },
            {
                label: "Move Down",
                icon: downIcon,
                hoverIcon: downIcon
            }
        ];
        if (moveUpDisabled) options = [
            {
                label: "Duplicate Here",
                icon: duplicateIcon,
                hoverIcon: duplicateIcon
            },
            {
                label: "Copy to Another",
                icon: copyIcon,
                hoverIcon: copyIcon
            },
            {
                label: "Delete Response Group",
                icon: deleteIcon,
                hoverIcon: deleteIcon,
                isDestructive: true
            },
            {
                label: "Move Down",
                icon: downIcon,
                hoverIcon: downIcon
            }
        ];
        return options;
    }
    handleGroupOptionSelected(optionName, index, e) {
        e.stopPropagation();
        if (optionName === "Duplicate Here") this.handleDuplicateConditionalResponseGroup(index);
        if (optionName === "Copy to Another") this.handleCopyResponseGroup(index);
        if (optionName === "Delete Response Group") this.handleDeleteConditionalResponseGroup(index);
        if (optionName === "Move Up") this.handleMoveUpConditionalResponseGroup(index);
        if (optionName === "Move Down") this.handleMoveDownConditionalResponseGroup(index);
    }
    renderDraggableResponseGroupContent(group, groupIndex, priorGroup) {
        return (0, _react.jsx)((0, _reactBeautifulDnd.Draggable), {
            draggableId: group.key,
            index: groupIndex,
            key: group.key
        }, (provided, snapshot)=>(0, _react.jsx)("div", (0, _extendsDefault.default)({
                ref: provided.innerRef
            }, provided.draggableProps, provided.dragHandleProps), this.renderResponseGroupContent(group, groupIndex, priorGroup, true, snapshot.isDragging)));
    }
    renderResponseGroupContent(group, groupIndex, priorGroup, isDraggable, isDragging) {
        const { onBlur, isDisabled, applicationId, featureContainer, followUpContainer, repromptContainer, conditionsContainer, hideFollowUp } = this.props;
        const isGroupFlagsActive = this.state.expandedFlagGroupKeys.some((g)=>g == group.key);
        const isGroupEffectsActive = this.state.expandedEffectGroupKeys.some((g)=>g == group.key);
        const moveUpDisabled = !priorGroup?.key;
        let displayTitle = group.key == "" ? "Default Response" : `Conditional Response ${groupIndex}`;
        let newTitle = "";
        let idsString = "";
        group.responses.forEach((r, i)=>{
            if (r?.name?.length) newTitle += (newTitle.length > 0 ? ", " : "") + r.name;
            if (r?.responseId?.length) {
                // first 8 of response id
                let firstEight = r.responseId.substring(0, 8);
                idsString += (idsString.length > 0 ? "," : "") + firstEight;
            }
        });
        if (newTitle.length > 0) displayTitle = newTitle;
        // Check if this is a duplicated group and add "(Copy)" to the title
        const isCopiedGroup = group.key.endsWith("_copy");
        if (isCopiedGroup) displayTitle = displayTitle + " (Copy)";
        if (displayTitle.length > 30) displayTitle = displayTitle.substring(0, 30) + "...";
        // Only add parentheses if there are response IDs
        if (idsString.length > 0) displayTitle = `(${idsString}) ${displayTitle}`;
        //Update response ids to names map
        const updatedResponseToNameMap = {
            ...this.props.responseIdToNamesRef.current
        };
        updatedResponseToNameMap[group.firstResponse.responseId] = displayTitle;
        this.props.responseIdToNamesRef.current = updatedResponseToNameMap;
        let className = group.key == "" ? "ac-default-response-section" : "ac-conditional-response-section";
        if (isDraggable) className = className + " draggable";
        if (isDragging) className = className + " dragging";
        return (0, _react.jsx)((0, _contentCollapsingSectionDefault.default), {
            key: group.key || "default",
            index: groupIndex,
            title: displayTitle,
            icon: outputIcon,
            className: className,
            id: `g${groupIndex}deviceResponse`,
            forceOpen: group.firstResponse.responseId == this.props.simulatedResponseId,
            responseId: group.firstResponse.responseId,
            titleRightRowComponent: (0, _react.jsx)("div", {
                className: menuWrapperStyle
            }, (0, _react.jsx)((0, _countButton.CountButton), {
                isActive: isGroupEffectsActive,
                onClick: ()=>this.handleToggleGroupEffects(group),
                activeIcon: effectBlueIcon,
                inactiveIcon: effectIcon,
                showCount: true,
                text: "Effects",
                count: group.firstResponse.effects?.length
            }), (0, _react.jsx)((0, _countButton.CountButton), {
                isActive: isGroupFlagsActive,
                onClick: ()=>this.handleToggleGroupFlags(group),
                activeIcon: userFlagsSmallBlueIcon,
                inactiveIcon: userFlagsSmallIcon,
                showCount: true,
                text: "User Flags",
                count: group.firstResponse.flagRules?.length
            }), (0, _react.jsx)("div", {
                onClick: (e)=>e.stopPropagation()
            }, group.key ? (0, _react.jsx)(ConditionalGenerativeSwitch, {
                label: "Generative",
                checked: group.firstResponse.useEnhancedResponse,
                onChange: ()=>this.handleToggleGenerativeResponse(group)
            }) : (0, _react.jsx)(GenerativeSwitch, {
                label: "Generative",
                checked: group.firstResponse.useEnhancedResponse,
                onChange: ()=>this.handleToggleGenerativeResponse(group)
            })), group.key && (0, _react.jsx)((0, _largeOverflowMenuDefault.default), {
                isActive: false,
                onOptionSelected: (o, e)=>this.handleGroupOptionSelected(o, groupIndex, e),
                options: this.getOptions(moveUpDisabled)
            }))
        }, isGroupFlagsActive && (0, _react.jsx)(HighlightSection, null, (0, _react.jsx)((0, _contentCardDefault.default), {
            title: "User Flags",
            icon: userFlagsIcon,
            id: `g${groupIndex}flags`
        }, (0, _react.jsx)((0, _flagRulesGroupDefault.default), {
            flagRules: group.firstResponse?.flagRules,
            onAddRule: ()=>this.handleEditFlags(group),
            onRemoveRule: (flagRule)=>this.handleRemoveFlagFromGroup(flagRule, group)
        }))), isGroupEffectsActive && (0, _react.jsx)(HighlightSection, null, (0, _react.jsx)((0, _contentCardDefault.default), {
            title: "Effects",
            icon: effectIcon,
            id: `g${groupIndex}flags`
        }, (0, _react.jsx)((0, _responseEffectsListDefault.default), {
            effects: group.firstResponse?.effects,
            updateEffects: (e)=>this.handleUpdateEffects(e, group.key),
            onAddEffect: ()=>this.handleAddEffect(group),
            onClickEffect: (effect)=>this.handleEditEffect(group, effect),
            onRemoveEffect: (effect)=>this.handleRemoveEffectFromGroup(effect, group)
        }))), group.conditions?.length > 0 && (0, _react.jsx)((0, _contentCardDefault.default), {
            title: "Conditions",
            icon: decisionIcon,
            id: `g${groupIndex}conditions`
        }, (0, _react.jsx)((0, _conditionsGroupDefault.default), {
            conditionInstances: group.conditions,
            conditions: conditionsContainer.state.conditions,
            deviceTypes: this.props.mediaResponseContainer?.state?.deviceTargets,
            onAddAndCondition: (parent)=>this.handleAddAndCondition(parent, group),
            onAddConditionGroup: ()=>this.handleAddConditionGroup(group),
            onEditCondition: (condition)=>this.handleEditCondition(condition, group),
            onRemoveCondition: (condition)=>this.handleRemoveCondition(condition, group),
            canDelete: group.conditions.length > 1 || group.conditions[0].andCondition != null
        })), (0, _react.jsx)((0, _contentCardDefault.default), {
            title: "Response Variations",
            className: "ac-response-card",
            icon: responseGroupIcon,
            id: "responseOptions",
            rightRender: ()=>(0, _react.jsx)((0, _reactDefault.default).Fragment, null, (0, _react.jsx)(RequiredContainer, null, (0, _react.jsx)(RequiredText, null, "At least one required"), (0, _react.jsx)(RequiredAsterixIcon, {
                    src: requiredStarIcon
                })))
        }, (0, _react.jsx)(ContentCardSubText, null, (0, _react.jsx)(SubTextIcon, {
            src: shuffleIcon
        }), (0, _react.jsx)("div", null, "Chosen at Random")), (0, _react.jsx)((0, _formFieldsContainerDefault.default), null, group.responses.map((answer, index)=>(0, _react.jsx)((0, _responseDefault.default), {
                index: index,
                answer: answer,
                handleTitleChange: (newTitle)=>this.handleTitleChange(group, index, newTitle),
                handleRemoveVariation: ()=>this.handleRemoveVariation(group, index),
                handleCopyVariation: ()=>this.handleCopyVariation(group, index),
                handleUpdateFullResponse: (newResponse)=>this.handleUpdateFullResponse(group, index, newResponse),
                groupIndex: groupIndex,
                group: group,
                isDisabled: isDisabled,
                onBlur: onBlur,
                showError: this.props.showError,
                handleSystemPromptUpdate: (value)=>this.handleSystemPromptUpdate(value, group, index),
                handleContextualSystemPrompt: (value)=>this.handleContextualSystemPrompt(value, group, index),
                applicationId: applicationId,
                handleToggleExcludeConversationHistoryForGenAI: ()=>this.handleToggleExcludeConversationHistoryForGenAI(group, index),
                handleConversationTurnsLimitUpdate: (value)=>this.handleConversationTurnsLimitUpdate(value, group, index),
                handleSsmlUpdate: (value)=>this.handleSsmlUpdate(value, group, index),
                handleTemperature: (value)=>this.handleTemperature(value, group, index),
                handleModelChange: (value)=>this.handleModelChange(value, group, index),
                handleToggleModelOverride: ()=>this.handleToggleModelOverride(group, index),
                handleToggleUseHistoryInSystemPrompt: ()=>this.handleToggleUseHistoryInSystemPrompt(group),
                handleToggleOnlyIncludeCurrentContentItemHistory: ()=>this.handleToggleOnlyIncludeCurrentContentItemHistory(group)
            })), (0, _react.jsx)((0, _horizontalSeparatorDefault.default), null), (0, _react.jsx)((0, _buttonDefault.default), {
            type: "button",
            disabled: isDisabled,
            themes: [
                "secondary-medium"
            ],
            text: "Add a Variation",
            onClick: ()=>this.handleAddSsmlVariation(group)
        }))), (0, _react.jsx)((0, _mediaSelectionCardDefault.default), {
            onClick: ()=>this.handleUploadMedia(group),
            hasBackground: group.firstResponse.backgroundImage != null,
            hasAudio: group.firstResponse.audio != null,
            hasImage: group.firstResponse.largeImage != null,
            hasVideo: group.firstResponse.video != null,
            disabled: isDisabled,
            anchor: `g${groupIndex}media`
        }), !hideFollowUp && (0, _react.jsx)((0, _manageFollowUpFormDefault.default), {
            followUp: group.firstResponse.followUp,
            stateContainer: followUpContainer,
            featureContainer: featureContainer,
            applicationId: this.props.applicationId,
            emptyOptionText: this.props.emptyFollowUpOptionText,
            applicationFeatureId: this.props.applicationFeatureId,
            emptyOptionIcon: this.props.emptyFollowUpOptionIcon,
            childContentContainer: group.firstResponse?.followUp?.childContentContainer,
            followUpContainer: this.props.followUpContainer,
            isLoading: followUpContainer.state.isLoadingOne || featureContainer.state.isLoadingSystemFeatures,
            onChange: (followUp, contentContainer, isEndSession)=>this.handleFollowUpChange(followUp, contentContainer, group, isEndSession),
            onManage: ()=>this.handleShowFollowUpModal(group),
            languageIds: this.props.languages?.map((l)=>l.id),
            disabled: isDisabled,
            groupIndex: groupIndex,
            showEndSessionOption: this.props.showEndSessionOption,
            responseGroup: group
        }), group.firstResponse.followUp && (0, _react.jsx)((0, _manageRepromptFormDefault.default), {
            applicationId: this.props.applicationId,
            repromptContainer: repromptContainer,
            onChange: (r)=>this.handleRepromptChange(r, group),
            reprompt: group.firstResponse.reprompt,
            onManage: ()=>this.handleShowRepromptModal(group),
            groupIndex: groupIndex
        }));
    }
    handleModelChange(model, responseGroup, index) {
        const groups = this.props.responseGroups;
        const editedGroup = groups.find((g)=>g.key == responseGroup.key);
        if (!editedGroup) return;
        editedGroup.responses[index].generativeAIModelOverride = model;
        this.props.onChange(groups);
    }
    handleToggleModelOverride(responseGroup, index) {
        const groups = this.props.responseGroups;
        const editedGroup = groups.find((g)=>g.key == responseGroup.key);
        if (!editedGroup) return;
        const newUseModelOverride = !editedGroup.responses[index].useModelOverride;
        editedGroup.responses[index].useModelOverride = newUseModelOverride;
        if (!newUseModelOverride) editedGroup.responses[index].generativeAIModelOverride = null;
        this.props.onChange(groups);
    }
    handleToggleExcludeConversationHistoryForGenAI(responseGroup, index) {
        const groups = this.props.responseGroups;
        const editedGroup = groups.find((g)=>g.key == responseGroup.key);
        if (!editedGroup) return;
        editedGroup.responses[index].excludeConversationHistoryForGenAI = !editedGroup.responses[index].excludeConversationHistoryForGenAI;
        this.props.onChange(groups);
    }
    render() {
        const { responseGroups } = this.props;
        const responseGroupsOrdered = (0, _lodashDefault.default).orderBy(responseGroups, [
            "priority",
            "key"
        ]);
        return (0, _react.jsx)((0, _reactDefault.default).Fragment, null, responseGroupsOrdered.map((group, groupIndex)=>{
            const priorGroup = responseGroupsOrdered[groupIndex - 1];
            const contentToRender = this.renderResponseGroupContent(group, groupIndex, priorGroup, false, false);
            return contentToRender;
        }), (0, _react.jsx)((0, _addResponseSectionDefault.default), {
            onAddNew: this.handleAddConditionResponse.bind(this),
            onCloneNew: this.handleCloneConditionResponse.bind(this)
        }), this.state.isMediaToggled ? (0, _react.jsx)((0, _mediaResponseManagerDefault.default), {
            isVisible: true,
            applicationId: this.props.applicationId,
            audioItem: this.state.editingResponseGroup?.firstResponse?.audio,
            videoItem: this.state.editingResponseGroup?.firstResponse?.video,
            imageItem: this.state.editingResponseGroup?.firstResponse?.largeImage,
            backgroundImageItem: this.state.editingResponseGroup?.firstResponse?.backgroundImage,
            displayTextOverride: this.state.editingResponseGroup?.firstResponse?.displayTextOverride,
            displayTitleOverride: this.state.editingResponseGroup?.firstResponse?.displayTitleOverride,
            container: this.state.editingResponseGroup?.firstResponse?.mediaResponseContainer,
            mediaResponseContainerId: this.state.editingResponseGroup?.firstResponse?.mediaResponseContainer?.id ?? this.state.editingResponseGroup?.firstResponse?.mediaResponseContainerId,
            onClose: this.handleUploadMediaClose.bind(this),
            onFinish: this.handleMediaSelected.bind(this)
        }) : null, this.state.isRepromptToggled && (0, _react.jsx)((0, _repromptManagerDefault.default), {
            applicationId: this.props.applicationId,
            onClose: this.handleRepromptClose.bind(this),
            onFinish: this.handleRepromptChange.bind(this),
            reprompt: this.state.editingResponseGroup?.firstResponse?.reprompt
        }), this.state.isFollowUpToggled && (0, _react.jsx)((0, _followUpManagerDefault.default), {
            applicationId: this.props.applicationId,
            onClose: this.handleFollowUpClose.bind(this),
            onFinish: (followUp)=>this.handleFollowUpChange(followUp, undefined, undefined, false),
            followUp: this.state.editingResponseGroup?.firstResponse?.followUp
        }), this.state.isConditionToggled && (0, _react.jsx)((0, _conditionManagerDefault.default), {
            onFinish: this.handleConditionChange.bind(this),
            onCancel: this.handleCancelCondition.bind(this),
            conditions: this.props.conditionsContainer.state.conditions,
            defaultConditionInstance: this.state.editingCondition,
            deviceTypes: this.props.mediaResponseContainer.state.deviceTargets,
            flags: this.props.appFlagsContainer.state.applicationFlags
        }), this.state.isFlagsToggled && (0, _react.jsx)((0, _flagRuleCreatorDefault.default), {
            onFinish: this.handleAddFlagToGroup.bind(this),
            onCancel: this.handleCancelFlags.bind(this),
            flags: this.props.appFlagsContainer.state.applicationFlags?.filter((f)=>f.applicationId == this.props.applicationId),
            applicationId: this.props.applicationId
        }), this.state.isEffectsToggled && (0, _react.jsx)((0, _effectManagerDefault.default), {
            onFinish: this.handleEffectManagerFinish.bind(this),
            onCancel: this.handleCancelEffects.bind(this),
            editingEffect: this.state.editingEffect
        }), this.state.isCopyResponseGroupToggled && (0, _react.jsx)((0, _contentExplorerDefault.default), {
            exploreType: "content-select",
            applicationId: this.props.applicationId,
            onSelect: this.handleCopyResponseGroupSelect.bind(this),
            onSelectionChange: this.handleContentItemSelectionInCopyModal.bind(this),
            onClose: this.handleCopyResponseGroupClose.bind(this),
            title: "Copy Response Group",
            subtitle: this.getDynamicCopySubtitle(),
            disabledFeatureIds: [],
            isLoading: false
        }));
    }
}
const RequiredContainer = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "eeaakyd12"
})({
    name: "pn8r9s",
    styles: "display:flex;align-items:center;line-height:16px"
});
const RequiredAsterixIcon = /*#__PURE__*/ (0, _baseDefault.default)("img", {
    target: "eeaakyd11"
})("color:", (0, _colors.color_colors_decline), ";width:10px;");
const RequiredText = /*#__PURE__*/ (0, _baseDefault.default)("p", {
    target: "eeaakyd10"
})("size:12px;margin-right:9px;color:", (0, _colors.color_shades_darkest), ";");
const ContentCardSubText = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "eeaakyd9"
})("display:flex;align-items:center;margin-top:8px;size:12px;line-height:16px;color:", (0, _colors.color_shades_darker), ";");
const SubTextIcon = /*#__PURE__*/ (0, _baseDefault.default)("img", {
    target: "eeaakyd8"
})({
    name: "1oaeivz",
    styles: "margin-right:8px"
});
const HighlightSection = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "eeaakyd7"
})(`
    padding: 32px 32px 0 32px;
    margin: -32px -32px 32px -32px;
    background: ${(0, _colors.color_variants_ocean_light_opaque)};
    border-bottom: ${(0, _stylesValues.style_border_default)};
`, "");
const GenerativeSwitch = /*#__PURE__*/ (0, _baseDefault.default)((0, _switchDefault.default), {
    target: "eeaakyd6"
})({
    name: "1q4vxyr",
    styles: "margin-left:8px"
});
const ConditionalGenerativeSwitch = /*#__PURE__*/ (0, _baseDefault.default)(GenerativeSwitch, {
    target: "eeaakyd5"
})({
    name: "1oaeivz",
    styles: "margin-right:8px"
});
const menuWrapperStyle = /*#__PURE__*/ (0, _css.css)("margin-right:8px;margin-left:auto;display:flex;align-items:center;.flags-button{height:32px;padding:0 24px;background:", (0, _colors.color_gradients_silver_shift), ";border:", (0, _stylesValues.style_border_default), ";box-shadow:none;border-radius:16px;box-sizing:border-box;color:", (0, _colors.color_text_default), ";margin-right:16px;font-size:14px;line-height:20px;cursor:pointer;display:flex;align-items:center;font-family:'Muli';.count-number{color:white;border-radius:50%;width:16px;height:16px;font-weight:600;font-size:12px;line-height:16px;text-align:center;margin-left:8px;background:", (0, _colors.color_shades_darkest), ";font-family:'Muli';}&.active{background:", (0, _colors.color_variants_ocean_light_opaque), ";border-color:", (0, _colors.color_colors_ocean), ";color:", (0, _colors.color_text_link), ";}img{margin-left:8px;}}", "");
const TempLabel = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "eeaakyd4"
})({
    name: "ho1qnd",
    styles: "display:flex;flex-direction:row"
});
const TempDescription = /*#__PURE__*/ (0, _baseDefault.default)("p", {
    target: "eeaakyd3"
})({
    name: "1cf5y6b",
    styles: "margin-bottom:16px;margin-left:16px;font-size:14px;font-weight:600;text-align:left;margin-right:8px"
});
const leftMarginLabelStyle = /*#__PURE__*/ (0, _css.css)({
    name: "eklkae",
    styles: "margin-left:16px;font-weight:600"
});
const SquareStyledDropdown = /*#__PURE__*/ (0, _baseDefault.default)((0, _styledDropdownDefault.default), {
    target: "eeaakyd2"
})({
    name: "1cfa65",
    styles: ".Select-control{border-radius:4px!important;height:48px!important;}.Select-menu-outer{border-radius:4px!important;}.Select-placeholder{line-height:48px!important;}.Select-value{line-height:48px!important;}margin-bottom:18px;margin-left:18px"
});
const ModelOverrideSwitch = /*#__PURE__*/ (0, _baseDefault.default)((0, _switchDefault.default), {
    target: "eeaakyd1"
})({
    name: "1gqdd25",
    styles: "padding-top:8px!important;margin-bottom:16px"
});
const ConversationTurnsLimitWrapper = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "eeaakyd0"
})({
    name: "1a2afmv",
    styles: "margin-left:10px"
});
exports.default = Responses;

},{"@babel/runtime/helpers/extends":"4iKIP","@emotion/styled/base":"lSuFu","@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","../../../components/forms/MediaSelectionCard":"eoxVg","../../../components/general/Button":"6ymxN","../../../components/structure/ContentCard":"hJsdJ","../../../components/structure/ContentCollapsingSection":"1CUms","../../../components/structure/FormFieldsContainer":"h3hzh","../../mediaResponseManager":"d4dHq","../../followUpForm/components/ManageFollowUpForm":"kfyfU","../../followUpForm/components/ManageRepromptForm":"bVYZ8","./ConditionsGroup":"2mZkh","./ConditionManager":"9wsb6","lodash":"3hMBK","./AddResponseSection":"3p5Wl","../../repromptManager":"3XOv8","../../followUpManager":"siWDj","../../../components/general/LargeOverflowMenu":"h9O0c","../../../constants/colors":"1p3OR","../../../constants/stylesValues":"dHVVv","./FlagRulesGroup":"46SnP","./FlagRuleCreator":"jvmfX","../../../components/structure/HorizontalSeparator":"Pw3HQ","../../../models/extensions":"7h01B","react-beautiful-dnd":"bkbSn","./ResponseEffectsList":"99zrE","./EffectManager":"axWjz","../../contentPage/components/CountButton":"dGBKj","../../../components/forms/Switch":"8kkL9","../../applicationSettings/components/customAssistantConfigurations/StyledDropdown":"hjrMo","./Response":"9QrZ0","../../contentExplorer":"k2ko3","../../../models/extensions/applicationFeature":"bfJBK","e918329189f4a0a8":"2nj1V","b4f35cb2a751a4e3":"5bpHt","9a72bd7b619da51c":"8Bko5","b417313a0143d3f4":"erpXi","154c4a16afe98509":"d0Yl2","6fe3f5d3e7899703":"dZpNy","72be1e63f37482cc":"hFwqT","941d4a39369595b4":"20G3l","79d8632901a1f4d1":"jk3D1","71763b1e0f4711ce":"kBbXd","cea46f96d3cfda8b":"f9rzT","ee84de82c49fda39":"lTxXn","f0ca8623f1300220":"djUH7","a7868b25b49896b4":"91DiF","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"eoxVg":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _contentCard = require("../structure/ContentCard");
var _contentCardDefault = parcelHelpers.interopDefault(_contentCard);
var _mediaIndicator = require("../general/MediaIndicator");
var _mediaIndicatorDefault = parcelHelpers.interopDefault(_mediaIndicator);
var _button = require("../general/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _formFieldsContainer = require("../structure/FormFieldsContainer");
var _formFieldsContainerDefault = parcelHelpers.interopDefault(_formFieldsContainer);
var _colors = require("../../constants/colors");
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const mediaIcon = require("50293bcc86767d18");
const isEmpty = (props)=>{
    if (props.hasVideo || props.hasAudio || props.hasBackground || props.hasImage) return false;
    return true;
};
const MediaSelectionCard = (props)=>(0, _react.jsx)((0, _contentCardDefault.default), {
        id: props.anchor ?? "media",
        title: "Attached Media",
        icon: mediaIcon,
        rightRender: ()=>(0, _react.jsx)((0, _buttonDefault.default), {
                themes: [
                    "primary-small",
                    "end-tight"
                ],
                className: "ac-add-media-button",
                type: "button",
                text: "Add/Edit Media",
                onClick: props.onClick,
                disabled: props.disabled
            })
    }, (0, _react.jsx)((0, _formFieldsContainerDefault.default), {
        className: containerStyle
    }, isEmpty(props) ? (0, _react.jsx)("p", {
        className: emptyLabelStyle
    }, "No items attached") : (0, _react.jsx)((0, _mediaIndicatorDefault.default), {
        hasBackground: props.hasBackground,
        hasAudio: props.hasAudio,
        hasImage: props.hasImage,
        hasVideo: props.hasVideo
    })));
const containerStyle = /*#__PURE__*/ (0, _css.css)({
    name: "18uqayh",
    styles: "margin-bottom:16px"
});
const emptyLabelStyle = /*#__PURE__*/ (0, _css.css)("font-style:italic;font-size:14px;line-height:20px;color:", (0, _colors.color_text_light), ";", "");
exports.default = MediaSelectionCard;

},{"@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","../structure/ContentCard":"hJsdJ","../general/MediaIndicator":"jYhvK","../general/Button":"6ymxN","../structure/FormFieldsContainer":"h3hzh","../../constants/colors":"1p3OR","50293bcc86767d18":"igpX4","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hJsdJ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "NoMarginContentCard", ()=>NoMarginContentCard);
var _base = require("@emotion/styled/base");
var _baseDefault = parcelHelpers.interopDefault(_base);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _colors = require("../../constants/colors");
var _horizontalSeparator = require("./HorizontalSeparator");
var _horizontalSeparatorDefault = parcelHelpers.interopDefault(_horizontalSeparator);
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// used for containing data in the form style card
const ContentCard = (props)=>(0, _react.jsx)("div", {
        className: `${cardStyle} ${props.className ?? ""}`
    }, props.title !== undefined ? (0, _react.jsx)(TitleWrapper, null, (0, _react.jsx)("div", {
        className: titleStyle
    }, (0, _react.jsx)("a", {
        id: props.id
    }), props.icon !== undefined ? (0, _react.jsx)("img", {
        src: props.icon
    }) : null, (0, _react.jsx)("span", null, props.title), (0, _react.jsx)("div", {
        className: "end"
    }, props.rightRender ? props.rightRender() : null)), (0, _react.jsx)(Subtitle, {
        className: props.subtitleStyle
    }, props.subtitle)) : null, props.title !== undefined ? (0, _react.jsx)((0, _horizontalSeparatorDefault.default), {
        className: horizontalSeparatorStyle
    }) : null, props.children);
const horizontalSeparatorStyle = /*#__PURE__*/ (0, _css.css)({
    name: "18uqayh",
    styles: "margin-bottom:16px"
});
const Subtitle = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1xvd2pg2"
})("color:", (0, _colors.color_text_light), ";margin-bottom:16px;");
const TitleWrapper = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1xvd2pg1"
})({
    name: "1fttcpj",
    styles: "display:flex;flex-direction:column"
});
const cardStyle = /*#__PURE__*/ (0, _css.css)("border-radius:10px;background-color:#ffffff;border:solid 1px ", (0, _colors.silver_two), ";padding:32px 32px 12px 32px;margin-bottom:32px;flex-grow:0;", "");
const NoMarginContentCard = /*#__PURE__*/ (0, _baseDefault.default)(ContentCard, {
    target: "e1xvd2pg0"
})({
    name: "1ykowef",
    styles: "margin-bottom:0"
});
const titleStyle = /*#__PURE__*/ (0, _css.css)({
    name: "19n9fc2",
    styles: "display:flex;flex-direction:row;align-items:center;margin-bottom:16px;>img{width:28px;height:28px;margin-right:10px;}>span{font-family:Muli;font-size:18px;line-height:24px;font-weight:normal;font-style:normal;font-stretch:normal;line-height:normal;letter-spacing:normal;text-align:left;color:#2c3d52;}.end{margin-right:0;margin-left:auto;button{margin:0;}}"
});
exports.default = ContentCard;

},{"@emotion/styled/base":"lSuFu","@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","../../constants/colors":"1p3OR","./HorizontalSeparator":"Pw3HQ","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jYhvK":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const imageIcon = require("6bac5131da3f8f39");
const backgroundIcon = require("4d4dec9b05788656");
const audioIcon = require("9dfaa02ecb4ee83d");
const videoIcon = require("c81e442ad1bb461a");
const indicatorStyle = /*#__PURE__*/ (0, _css.css)({
    name: "ud2uf0",
    styles: "display:flex;flex-direction:row;justify-content:center;align-items:center;img{width:22px;height:22px;margin:0 6px;}"
});
const MediaIndicator = (props)=>(0, _react.jsx)("div", {
        className: indicatorStyle
    }, props.hasAudio ? (0, _react.jsx)("img", {
        src: audioIcon
    }) : null, props.hasImage ? (0, _react.jsx)("img", {
        src: imageIcon
    }) : null, props.hasVideo ? (0, _react.jsx)("img", {
        src: videoIcon
    }) : null, props.hasBackground ? (0, _react.jsx)("img", {
        src: backgroundIcon
    }) : null);
exports.default = MediaIndicator;

},{"@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","6bac5131da3f8f39":"7XJJS","4d4dec9b05788656":"5pK2Y","9dfaa02ecb4ee83d":"lcYWS","c81e442ad1bb461a":"jbgUU","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7XJJS":[function(require,module,exports) {
module.exports = require("d9af937887693dfb").getBundleURL("kVLro") + require("1d93a35484699f33").resolve("3YQW7");

},{"d9af937887693dfb":"c7Tr5","1d93a35484699f33":"fyJL2"}],"5pK2Y":[function(require,module,exports) {
module.exports = require("2d8227226078c5c3").getBundleURL("kVLro") + require("81be836ae38289ed").resolve("icfNU");

},{"2d8227226078c5c3":"c7Tr5","81be836ae38289ed":"fyJL2"}],"lcYWS":[function(require,module,exports) {
module.exports = require("910b06325e15678a").getBundleURL("kVLro") + require("e8a219076452bf5a").resolve("O6ycS");

},{"910b06325e15678a":"c7Tr5","e8a219076452bf5a":"fyJL2"}],"jbgUU":[function(require,module,exports) {
module.exports = require("572e216c579931c5").getBundleURL("kVLro") + require("142477988907e5c2").resolve("6CB1N");

},{"572e216c579931c5":"c7Tr5","142477988907e5c2":"fyJL2"}],"h3hzh":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const FormFieldsContainer = (props)=>(0, _react.jsx)("div", {
        className: containerStyle + " " + props.className
    }, props.children);
const containerStyle = /*#__PURE__*/ (0, _css.css)({
    name: "yehwrb",
    styles: "margin-top:24px;width:100%"
});
exports.default = FormFieldsContainer;

},{"@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"igpX4":[function(require,module,exports) {
module.exports = require("704227caa570cfe4").getBundleURL("kVLro") + require("2fef60ee55ea4e84").resolve("iqode");

},{"704227caa570cfe4":"c7Tr5","2fef60ee55ea4e84":"fyJL2"}],"d4dHq":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _modalLayout = require("../../components/structure/ModalLayout");
var _modalLayoutDefault = parcelHelpers.interopDefault(_modalLayout);
var _mediaContainer = require("../../state/containers/MediaContainer");
var _mediaContainerDefault = parcelHelpers.interopDefault(_mediaContainer);
var _fullScreenLayout = require("../fullScreenLayout");
var _fullScreenLayoutDefault = parcelHelpers.interopDefault(_fullScreenLayout);
var _tabPanelBody = require("../../components/structure/TabPanelBody");
var _tabPanelBodyDefault = parcelHelpers.interopDefault(_tabPanelBody);
var _pageContainer = require("../../components/structure/PageContainer");
var _pageContainerDefault = parcelHelpers.interopDefault(_pageContainer);
var _unstated = require("unstated");
var _horizontalSeparator = require("../../components/structure/HorizontalSeparator");
var _horizontalSeparatorDefault = parcelHelpers.interopDefault(_horizontalSeparator);
var _mediaManagerForm = require("./components/MediaManagerForm");
var _mediaManagerFormDefault = parcelHelpers.interopDefault(_mediaManagerForm);
var _modalTitle = require("../../components/general/ModalTitle");
var _modalTitleDefault = parcelHelpers.interopDefault(_modalTitle);
var _button = require("../../components/general/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _horizontalContainer = require("../../components/structure/HorizontalContainer");
var _horizontalContainerDefault = parcelHelpers.interopDefault(_horizontalContainer);
var _mediaResponseContainer = require("../../state/containers/MediaResponseContainer");
var _mediaResponseContainerDefault = parcelHelpers.interopDefault(_mediaResponseContainer);
var _pageError = require("../../components/general/PageError");
var _pageErrorDefault = parcelHelpers.interopDefault(_pageError);
var _customScrollbars = require("../../components/structure/CustomScrollbars");
var _customScrollbarsDefault = parcelHelpers.interopDefault(_customScrollbars);
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const closeIcon = require("95e3933b743a0288");
class MediaResponseManager extends (0, _reactDefault.default).Component {
    componentWillMount() {
        this.setState({
            hasChanges: false
        });
    }
    handleChange() {
        this.setState({
            hasChanges: true
        });
    }
    handleClose() {
        if (this.state.hasChanges) {
            var confirmClose = confirm("You have unsaved changes. Are you sure you want to close?");
            if (!confirmClose) return;
        }
        if (this.props.onClose) this.props.onClose();
    }
    handleFinish(formData) {
        if (this.props.onFinish) {
            this.setState({
                hasChanges: false
            });
            this.props.onFinish(formData);
        }
    }
    render() {
        return (0, _react.jsx)((0, _modalLayoutDefault.default), {
            isVisible: this.props.isVisible,
            onClose: this.handleClose.bind(this)
        }, (0, _react.jsx)((0, _unstated.Subscribe), {
            to: [
                (0, _mediaContainerDefault.default),
                (0, _mediaResponseContainerDefault.default)
            ]
        }, (mediaContainer, mediaResponseContainer)=>{
            return (0, _react.jsx)((0, _fullScreenLayoutDefault.default), null, (0, _react.jsx)((0, _customScrollbarsDefault.default), {
                autoHide: true,
                className: scrollBarContainer
            }, (0, _react.jsx)((0, _pageContainerDefault.default), null, (0, _react.jsx)((0, _horizontalContainerDefault.default), null, (0, _react.jsx)((0, _modalTitleDefault.default), null, "Media-Rich Experience:"), (0, _react.jsx)((0, _buttonDefault.default), {
                themes: [
                    "end-tight",
                    "icon"
                ],
                icon: closeIcon,
                onClick: this.handleClose.bind(this)
            })), (0, _react.jsx)((0, _horizontalSeparatorDefault.default), null), (0, _react.jsx)((0, _tabPanelBodyDefault.default), null, (0, _react.jsx)((0, _mediaManagerFormDefault.default), {
                stateContainer: mediaResponseContainer,
                mediaContainer: mediaContainer,
                applicationId: this.props.applicationId,
                onClose: this.handleClose.bind(this),
                onFinish: this.handleFinish.bind(this),
                onChange: this.handleChange.bind(this),
                audioItem: this.props.audioItem,
                videoItem: this.props.videoItem,
                imageItem: this.props.imageItem,
                displayTextOverride: this.props.displayTextOverride,
                displayTitleOverride: this.props.displayTitleOverride,
                mediaResponseContainerId: this.props.mediaResponseContainerId,
                container: this.props.container,
                backgroundImageItem: this.props.backgroundImageItem
            })))), (0, _react.jsx)((0, _pageErrorDefault.default), {
                errors: mediaResponseContainer.state.errors
            }));
        }));
    }
}
const scrollBarContainer = /*#__PURE__*/ (0, _css.css)({
    name: "13udsys",
    styles: "height:100%"
});
exports.default = MediaResponseManager;

},{"@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","../../components/structure/ModalLayout":"b1cO3","../../state/containers/MediaContainer":"ch6Xu","../fullScreenLayout":"5mVdG","../../components/structure/TabPanelBody":"ePx7g","../../components/structure/PageContainer":"hc1r8","unstated":"grh7p","../../components/structure/HorizontalSeparator":"Pw3HQ","./components/MediaManagerForm":"2MQ37","../../components/general/ModalTitle":"hIp2B","../../components/general/Button":"6ymxN","../../components/structure/HorizontalContainer":"eJPfh","../../state/containers/MediaResponseContainer":"1ccrV","../../components/general/PageError":"ezFTm","../../components/structure/CustomScrollbars":"50vFq","95e3933b743a0288":"93VwA","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"b1cO3":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _colors = require("../../constants/colors");
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const ModalLayout = (props)=>{
    const baseZIndex = props.zIndex ?? 1000;
    const handleKeyUp = (e)=>{
        if (e.key === "Escape") props.onClose?.();
    };
    return (0, _react.jsx)("div", {
        className: props.isVisible ? "" : hiddenStyle,
        onKeyUp: (e)=>handleKeyUp(e),
        "aria-modal": "true"
    }, (0, _react.jsx)("div", {
        className: `${innerLayoutStyle(baseZIndex, props.allowOverflow)} ${props.className != null ? props.className : ""}`
    }, (0, _react.jsx)("div", {
        className: innerWrapperStyle(props.allowOverflow)
    }, props.children)), (0, _react.jsx)("div", {
        className: layoutStyle(baseZIndex, props.allowOverflow),
        onClick: ()=>props.onClose?.()
    }));
};
const layoutStyle = (z, allowOverflow)=>{
    return /*#__PURE__*/ (0, _css.css)("position:fixed;width:100vw;height:100vh;overflow-x:visible;background:", (0, _colors.dark_grey_blue_70), ";left:50%;top:50%;transform:translate(-50%, -50%);z-index:", z + 1, ";", allowOverflow ? "overflow: visible;" : "", ";", "");
};
const innerLayoutStyle = (z, allowOverflow)=>{
    return /*#__PURE__*/ (0, _css.css)("border-radius:20px;border:12px solid ", (0, _colors.dark_grey_blue_80), ";display:block;width:80%;max-width:100%;height:90%;max-height:calc(100vh - 20px);position:fixed;z-index:", z + 2, ";left:50%;top:50%;transform:translate(-50%, -50%);background:white;", allowOverflow ? "" : "overflow: hidden;", ";", "");
};
const innerWrapperStyle = (allowOverflow)=>{
    return /*#__PURE__*/ (0, _css.css)("border-radius:20px;height:100%;display:flex;flex-direction:column;", allowOverflow ? "overflow: visible;" : "overflow: hidden;", ";", "");
};
const hiddenStyle = /*#__PURE__*/ (0, _css.css)({
    name: "eivff4",
    styles: "display:none"
});
exports.default = ModalLayout;

},{"@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","../../constants/colors":"1p3OR","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"ch6Xu":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _defineProperty = require("@babel/runtime/helpers/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _unstated = require("unstated");
var _api = require("../../api");
class MediaContainer extends (0, _unstated.Container) {
    constructor(...args){
        super(...args);
        // default state
        (0, _definePropertyDefault.default)(this, "state", {
            mediaItems: [],
            isUploading: false,
            isLoading: false,
            errors: [],
            applicationId: "",
            hasUpdate: true,
            linkedContentCache: []
        });
    }
    deleteMediaItem(item) {
        var promise = new Promise((resolve, reject)=>{
            var deletePromise = item.isDisabled ? _api.deleteMediaItem(item.id) : _api.disableMediaItem(item.id);
            deletePromise.then((result)=>{
                if (result.resultType == "Ok") {
                    const index = this.state.mediaItems.findIndex((mi)=>mi.id === item.id);
                    this.setState({
                        ...this.state,
                        hasUpdate: true,
                        mediaItems: [
                            ...this.state.mediaItems.slice(0, index),
                            result.data,
                            ...this.state.mediaItems.slice(index + 1, this.state.mediaItems.length)
                        ],
                        errors: []
                    });
                    resolve(result);
                } else {
                    this.setState({
                        ...this.state,
                        errors: result.errors
                    });
                    reject(result.errors);
                }
            }).catch((error)=>{
                console.log(error);
                reject(error);
            });
        });
        return promise;
    }
    getMediaItems() {
        this.getMediaItemsForApp(this.state.applicationId);
    }
    getLinkedContent(mediaItemId) {
        var existingContent = this.state.linkedContentCache.find((c)=>{
            return mediaItemId == c.mediaItemId;
        });
        if (existingContent != null) return new Promise((resolve, reject)=>{
            resolve({
                data: existingContent,
                errors: [],
                resultType: "Ok"
            });
        });
        var promise = _api.getContentItemsForMediaItem(mediaItemId);
        promise.then((result)=>{
            if (result.resultType == "Ok") {
                const linkedContent = [
                    ...this.state.linkedContentCache
                ];
                linkedContent.push(result.data);
                this.setState({
                    ...this.state,
                    linkedContentCache: linkedContent
                });
            } else this.setState({
                ...this.state,
                errors: result.errors
            });
        });
        return promise;
    }
    resetMediaItems(applicationId) {
        this.setState({
            ...this.state,
            isLoading: true,
            applicationId: applicationId
        });
        var promise = new Promise((resolve, reject)=>{
            _api.getMediaItemsForApplication(applicationId).then((result)=>{
                if (result.resultType == "Ok") {
                    this.setState({
                        ...this.state,
                        errors: [],
                        mediaItems: result.data,
                        isLoading: false,
                        hasUpdate: false
                    });
                    resolve(result);
                } else {
                    this.setState({
                        ...this.state,
                        errors: result.errors,
                        isLoading: false
                    });
                    reject(result.errors);
                }
            }).catch((error)=>{
                console.log(error);
                reject(error);
            });
        });
        return promise;
    }
    getMediaItemsForApp(applicationId) {
        // if we already have apps for this org, just return them
        if (this.state.applicationId == applicationId && !this.state.hasUpdate) return new Promise((resolve, reject)=>{
            resolve({
                data: this.state.mediaItems,
                errors: [],
                resultType: "Ok"
            });
        });
        this.setState({
            ...this.state,
            isLoading: true,
            applicationId: applicationId
        });
        var promise = _api.getMediaItemsForApplication(applicationId);
        promise.then((result)=>{
            if (result.resultType == "Ok") this.setState({
                ...this.state,
                errors: [],
                mediaItems: result.data,
                isLoading: false,
                hasUpdate: false
            });
            else this.setState({
                ...this.state,
                errors: result.errors,
                isLoading: false
            });
        }).catch((error)=>{
            console.log(error);
        });
        return promise;
    }
    updateMediaItem(mediaItem) {
        var promise = new Promise((resolve, reject)=>{
            _api.updateMediaItem(mediaItem.id, mediaItem).then((result)=>{
                if (result.resultType === "Ok") {
                    //update is successful                
                    const index = this.state.mediaItems.findIndex((mi)=>mi.id === mediaItem.id);
                    this.setState({
                        ...this.state,
                        hasUpdate: true,
                        mediaItems: [
                            ...this.state.mediaItems.slice(0, index),
                            result.data,
                            ...this.state.mediaItems.slice(index + 1, this.state.mediaItems.length)
                        ]
                    });
                    resolve(result);
                } else {
                    //update is not successful
                    this.setState({
                        ...this.state,
                        errors: result.errors,
                        isUploading: false
                    });
                    reject(result.errors);
                }
            });
        });
        return promise;
    }
    uploadMediaItem(applicationId, name1, file, caption, progressCallback) {
        this.setUploading(true);
        var promise = new Promise((resolve, reject)=>{
            // first get the url
            _api.getUploadUrl(applicationId, file.name, name1).then((result)=>{
                if (result.resultType == "Ok") // we have the url, upload to s3
                _api.uploadDirect(result.data, file, progressCallback).then((uploadResult)=>{
                    if (uploadResult.resultType == "Ok") // upload is good, let's add the media item
                    _api.createMediaItem(applicationId, {
                        name: name1,
                        fileName: file.name,
                        url: result.data.split("?")[0],
                        caption: caption
                    }).then((createResult)=>{
                        this.setState({
                            ...this.state,
                            errors: [],
                            isUploading: false,
                            hasUpdate: true
                        });
                        resolve(createResult);
                    });
                    else {
                        this.setState({
                            ...this.state,
                            errors: result.errors,
                            isUploading: false
                        });
                        reject(result.errors);
                    }
                }).catch((error)=>{
                    this.setState({
                        ...this.state,
                        errors: [
                            error
                        ],
                        isUploading: false
                    });
                    reject(error);
                });
                else {
                    this.setState({
                        ...this.state,
                        errors: result.errors,
                        isUploading: false
                    });
                    reject(result.errors);
                }
            }).catch((error)=>{
                this.setState({
                    ...this.state,
                    errors: [
                        error
                    ],
                    isUploading: false
                });
                reject(error);
                console.log(error);
            });
        });
        return promise;
    }
    uploadOrganizationMedia(organizationId, name1, file, caption, progressCallback) {
        this.setUploading(true);
        var promise = new Promise((resolve, reject)=>{
            // first get the url
            _api.getOrganizationUploadUrl(organizationId, file.name, name1).then((result)=>{
                if (result.resultType == "Ok") // we have the url, upload to s3
                _api.uploadDirect(result.data, file, progressCallback).then((uploadResult)=>{
                    if (uploadResult.resultType == "Ok") resolve({
                        resultType: "Ok",
                        errors: [],
                        data: result.data.split("?")[0]
                    });
                    else {
                        this.setState({
                            ...this.state,
                            errors: result.errors,
                            isUploading: false
                        });
                        reject(result.errors);
                    }
                }).catch((error)=>{
                    this.setState({
                        ...this.state,
                        errors: [
                            error
                        ],
                        isUploading: false
                    });
                    reject(error);
                });
                else {
                    this.setState({
                        ...this.state,
                        errors: result.errors,
                        isUploading: false
                    });
                    reject(result.errors);
                }
            }).catch((error)=>{
                this.setState({
                    ...this.state,
                    errors: [
                        error
                    ],
                    isUploading: false
                });
                reject(error);
                console.log(error);
            });
        });
        return promise;
    }
    replaceMediaItem(applicationId, item, file) {
        this.setUploading(true);
        // first get the url
        var promise = new Promise((resolve, reject)=>{
            _api.getUploadUrl(applicationId, file.name, name).then((result)=>{
                if (result.resultType == "Ok") // we have the url, upload to s3
                _api.uploadDirect(result.data, file, (number)=>{}).then((uploadResult)=>{
                    if (uploadResult.resultType == "Ok") // upload is good, let's add the media item
                    _api.updateMediaItem(item.id, {
                        ...item,
                        name: file.name,
                        url: result.data.split("?")[0]
                    }).then((updateResult)=>{
                        if (updateResult.resultType === "Ok") {
                            //update is successful                
                            const index = this.state.mediaItems.findIndex((mi)=>mi.id === item.id);
                            this.setState({
                                ...this.state,
                                errors: [],
                                isUploading: false,
                                hasUpdate: true,
                                mediaItems: [
                                    ...this.state.mediaItems.slice(0, index),
                                    updateResult.data,
                                    ...this.state.mediaItems.slice(index + 1, this.state.mediaItems.length)
                                ]
                            });
                            resolve(updateResult);
                        } else {
                            //update is not successful
                            this.setState({
                                ...this.state,
                                errors: updateResult.errors,
                                isUploading: false
                            });
                            reject(updateResult.errors);
                        }
                    });
                    else {
                        this.setState({
                            ...this.state,
                            errors: result.errors,
                            isUploading: false
                        });
                        reject(result.errors);
                    }
                }).catch((error)=>{
                    this.setState({
                        ...this.state,
                        errors: [
                            error
                        ],
                        isUploading: false
                    });
                    reject(error);
                });
                else {
                    this.setState({
                        ...this.state,
                        errors: result.errors,
                        isUploading: false
                    });
                    reject(result.errors);
                }
            }).catch((error)=>{
                this.setState({
                    ...this.state,
                    errors: [
                        error
                    ],
                    isUploading: false
                });
                console.log(error);
                reject(error);
            });
        });
        return promise;
    }
    uploadSsmlItem(applicationId, name1, file, caption, progressCallback) {
        // validate file type
        if (!file.type.startsWith("audio")) {
            this.setState({
                ...this.state,
                errors: [
                    "Only audio files are allowed"
                ]
            });
            return new Promise((resolve, reject)=>{
                reject({
                    errors: [
                        "Only audio files are allowed"
                    ],
                    resultType: "Invalid"
                });
            });
        }
        this.setUploading(true);
        var promise = new Promise((resolve, reject)=>{
            // first get the url
            _api.getUploadUrl(applicationId, file.name, name1).then((result)=>{
                if (result.resultType == "Ok") // we have the url, upload to s3
                _api.uploadDirect(result.data, file, progressCallback).then((uploadResult)=>{
                    if (uploadResult.resultType == "Ok") // upload is good, let's add the media item
                    _api.createMediaItem(applicationId, {
                        name: name1,
                        fileName: file.name,
                        url: result.data.split("?")[0],
                        caption: caption
                    }).then((createResult)=>{
                        if (createResult.resultType == "Ok") // add is good, let's make the ssml conversion
                        _api.convertAudioItemToSsml(createResult.data.id).then((ssmlResult)=>{
                            if (ssmlResult.resultType == "Ok") {
                                this.setState({
                                    ...this.state,
                                    errors: [],
                                    isUploading: false
                                });
                                resolve(ssmlResult);
                            } else {
                                this.setState({
                                    ...this.state,
                                    errors: result.errors,
                                    isUploading: false
                                });
                                reject(result.errors);
                            }
                        }).catch((error)=>{
                            this.setState({
                                ...this.state,
                                isUploading: false,
                                errors: [
                                    error
                                ]
                            });
                        });
                    });
                    else {
                        this.setState({
                            ...this.state,
                            errors: result.errors,
                            isUploading: false
                        });
                        reject(result.errors);
                    }
                }).catch((error)=>{
                    this.setState({
                        ...this.state,
                        errors: [
                            error
                        ],
                        isUploading: false
                    });
                    reject(error);
                });
                else {
                    this.setState({
                        ...this.state,
                        errors: result.errors,
                        isUploading: false
                    });
                    reject(result.errors);
                }
            }).catch((error)=>{
                this.setState({
                    ...this.state,
                    errors: [
                        error
                    ],
                    isUploading: false
                });
                reject(error);
                console.log(error);
            });
        });
        return promise;
    }
    clearErrors() {
        this.setState({
            ...this.state,
            errors: []
        });
    }
    setLoading(isLoading) {
        this.setState({
            ...this.state,
            isLoading: isLoading
        });
    }
    setUploading(isUploading) {
        this.setState({
            ...this.state,
            isUploading: isUploading
        });
    }
}
exports.default = MediaContainer;

},{"@babel/runtime/helpers/defineProperty":"9sJxO","unstated":"grh7p","../../api":"loxM6","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"5mVdG":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// this is the layout that replaces the dashboard navigation for full screen pages
// such as creating / editing content items, templates, etc.
const FullScreenLayout = (props)=>(0, _react.jsx)("div", {
        className: `${fullPageStyle} ${props.className ? props.className : ""}`
    }, props.children);
const fullPageStyle = /*#__PURE__*/ (0, _css.css)({
    name: "1ie8whp",
    styles: "width:100%;height:100%;background:white;position:fixed;display:flex;flex-direction:column"
});
exports.default = FullScreenLayout;

},{"@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2MQ37":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _extends = require("@babel/runtime/helpers/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("@emotion/react");
var _formik = require("formik");
var _lodash = require("lodash");
var _lodashDefault = parcelHelpers.interopDefault(_lodash);
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _reactTabs = require("react-tabs");
var _yup = require("yup");
var _multiFileSelector = require("../../../components/forms/MultiFileSelector");
var _multiFileSelectorDefault = parcelHelpers.interopDefault(_multiFileSelector);
var _button = require("../../../components/general/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _loader = require("../../../components/general/Loader");
var _loaderDefault = parcelHelpers.interopDefault(_loader);
var _pageTitle = require("../../../components/general/PageTitle");
var _pageTitleDefault = parcelHelpers.interopDefault(_pageTitle);
var _footerBar = require("../../../components/structure/FooterBar");
var _footerBarDefault = parcelHelpers.interopDefault(_footerBar);
var _formContainer = require("../../../components/structure/FormContainer");
var _formContainerDefault = parcelHelpers.interopDefault(_formContainer);
var _horizontalContainer = require("../../../components/structure/HorizontalContainer");
var _horizontalContainerDefault = parcelHelpers.interopDefault(_horizontalContainer);
var _horizontalSeparator = require("../../../components/structure/HorizontalSeparator");
var _horizontalSeparatorDefault = parcelHelpers.interopDefault(_horizontalSeparator);
var _imageInnerTabs = require("../../../components/structure/ImageInnerTabs");
var _imageInnerTabsDefault = parcelHelpers.interopDefault(_imageInnerTabs);
var _pageContainer = require("../../../components/structure/PageContainer");
var _pageContainerDefault = parcelHelpers.interopDefault(_pageContainer);
var _splitContainer = require("../../../components/structure/SplitContainer");
var _splitContainerDefault = parcelHelpers.interopDefault(_splitContainer);
var _allowedMediaLabel = require("./AllowedMediaLabel");
var _allowedMediaLabelDefault = parcelHelpers.interopDefault(_allowedMediaLabel);
var _attachedMediaContainer = require("./AttachedMediaContainer");
var _audioResponseBuilder = require("./AudioResponseBuilder");
var _audioResponseBuilderDefault = parcelHelpers.interopDefault(_audioResponseBuilder);
var _chatResponseBuilder = require("./ChatResponseBuilder");
var _chatResponseBuilderDefault = parcelHelpers.interopDefault(_chatResponseBuilder);
var _fileStageCard = require("./FileStageCard");
var _fileStageCardDefault = parcelHelpers.interopDefault(_fileStageCard);
var _responseDetailContainer = require("./ResponseDetailContainer");
var _screenResponseBuilder = require("./ScreenResponseBuilder");
var _screenResponseBuilderDefault = parcelHelpers.interopDefault(_screenResponseBuilder);
var _css = require("@emotion/css");
var _tabPanelBody = require("../../../components/structure/TabPanelBody");
var _tabPanelBodyDefault = parcelHelpers.interopDefault(_tabPanelBody);
var _mediaLibraryTabbedLayout = require("../../../components/structure/MediaLibraryTabbedLayout");
var _mediaLibraryTabbedLayoutDefault = parcelHelpers.interopDefault(_mediaLibraryTabbedLayout);
var _mediaLibraryTab = require("./MediaLibraryTab");
var _mediaLibraryTabDefault = parcelHelpers.interopDefault(_mediaLibraryTab);
var _pageError = require("../../../components/general/PageError");
var _pageErrorDefault = parcelHelpers.interopDefault(_pageError);
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const outputIcon = require("8db84cf97895793e");
const speakerIcon = require("1e5c994bedcc1096");
const speakerSelectedIcon = require("e59f4b7a1bbc0051");
const screenIcon = require("2d03140896dfd381");
const screenSelectedIcon = require("c2171fb688508323");
const chatIcon = require("4a4ea91e4c83de53");
const chatSelectedIcon = require("555656d1eca6201c");
class InnerForm extends (0, _reactDefault.default).Component {
    componentWillMount() {
        this.setState({
            pendingFiles: [],
            mediaItems: []
        });
        this.loadContainer();
    }
    componentDidUpdate(prevProps) {
        if (this.props.mediaResponseContainerId != prevProps.mediaResponseContainerId) this.loadContainer();
    }
    loadCompatMediaItems() {
        const mediaItems = this.state.mediaItems;
        if (this.props.imageItem) {
            if (!mediaItems.some((m)=>m.id == this.props.imageItem.id)) mediaItems.push(this.props.imageItem);
        }
        if (this.props.backgroundImageItem) {
            if (!mediaItems.some((m)=>m.id == this.props.backgroundImageItem.id)) mediaItems.push(this.props.backgroundImageItem);
        }
        if (this.props.audioItem) {
            if (!mediaItems.some((m)=>m.id == this.props.audioItem.id)) mediaItems.push(this.props.audioItem);
        }
        if (this.props.videoItem) {
            if (!mediaItems.some((m)=>m.id == this.props.videoItem.id)) mediaItems.push(this.props.videoItem);
        }
        this.setState({
            ...this.state,
            mediaItems: mediaItems
        });
    }
    async loadContainer() {
        await this.props.mediaContainer.getMediaItemsForApp(this.props.applicationId);
        this.props.stateContainer.getDeviceTargets().then(()=>this.loadCompatMediaItems());
        if (this.props.container && this.props.container.responses.length > 0) {
            if (this.props.container.additionalMediaItems != null && this.props.container.additionalMediaItems.length > 0) this.setState({
                ...this.state,
                mediaItems: this.props.container.additionalMediaItems
            });
            this.props.setFieldValue("container", {
                ...this.props.container,
                additionalMediaItemIds: this.props.container.additionalMediaItems.map((m)=>m.id)
            });
        } else if (this.props.mediaResponseContainerId) await this.props.stateContainer.getMediaResponseContainer(this.props.mediaResponseContainerId).then((containerResult)=>{
            if (containerResult.resultType == "Ok") {
                if (containerResult.data.additionalMediaItems != null && containerResult.data.additionalMediaItems.length > 0) this.setState({
                    ...this.state,
                    mediaItems: containerResult.data.additionalMediaItems
                });
                this.props.setFieldValue("container", {
                    ...containerResult.data,
                    additionalMediaItemIds: []
                });
            }
        });
        else // create initial
        this.props.setFieldValue("container", {
            additionalMediaItemIds: [],
            responses: []
        });
    }
    handleDiscardChanges() {
        this.props.onClose();
    }
    handleStagedFileUpdate(file, name, caption) {
        var files = this.state.pendingFiles;
        const existingFile = files.find((f)=>f.file == file.file);
        if (existingFile) {
            existingFile.name = name;
            existingFile.caption = caption;
            files[files.findIndex((f)=>f.file == file.file)] = existingFile;
            this.setState({
                ...this.state,
                pendingFiles: files
            });
        }
    }
    handleUploadAll() {
        var filesToUpload = this.state.pendingFiles.filter((f)=>!f.isUploading);
        filesToUpload.forEach((file)=>this.handleStagedFileUpload(file));
        this.props.mediaContainer.getMediaItemsForApp(this.props.applicationId);
    }
    handleSingleFileUpload(file) {
        this.handleStagedFileUpload(file);
        this.props.mediaContainer.getMediaItemsForApp(this.props.applicationId);
    }
    handleStagedFileUpload(file) {
        var files = this.state.pendingFiles;
        const existingFile = files.find((f)=>f.file == file.file);
        if (existingFile) {
            existingFile.isUploading = true;
            files[files.findIndex((f)=>f.file == file.file)] = existingFile;
            this.setState({
                ...this.state,
                pendingFiles: files
            });
        }
        this.props.mediaContainer.uploadMediaItem(this.props.applicationId, file.name, file.file, file.caption, (number)=>this.handleProgressUpdate(file, number)).then((result)=>{
            if (result.resultType == "Ok") {
                this.handleRemoveStagedFile(file);
                var mediaItems = this.state.mediaItems;
                mediaItems.push(result.data);
                this.setState({
                    ...this.state,
                    mediaItems: mediaItems
                });
                this.updateContainerMediaItems();
            }
        });
    }
    attachMediaItem(item) {
        var newMediaItems = [
            ...this.state.mediaItems,
            item
        ];
        if (this.state.mediaItems.findIndex((i)=>i.id === item.id) < 0) {
            this.setState({
                ...this.state,
                mediaItems: newMediaItems
            });
            this.updateContainerMediaItems(newMediaItems);
        }
    }
    updateContainerMediaItems(mediaItems = []) {
        const container = this.props.values.container;
        if (mediaItems == null || mediaItems.length == 0) mediaItems = this.state.mediaItems;
        container.additionalMediaItemIds = mediaItems.map((m)=>m.id);
        this.onContainerChange(container);
    }
    handleProgressUpdate(file, progress) {
        var files = this.state.pendingFiles;
        const existingFile = files.find((f)=>f.file == file.file);
        if (existingFile) {
            existingFile.progress = progress;
            files[files.findIndex((f)=>f.file == file.file)] = existingFile;
            this.setState({
                ...this.state,
                pendingFiles: files
            });
        }
    }
    handleRemoveStagedFile(file) {
        const files = this.state.pendingFiles;
        (0, _lodashDefault.default).remove(files, (f)=>f.file == file.file);
        this.setState({
            ...this.state,
            pendingFiles: files
        });
    }
    handleFilesSelected(files) {
        var currentFiles = this.state.pendingFiles;
        currentFiles.push(...files.map((file)=>({
                name: file.name,
                file: file,
                caption: "",
                isUploading: false,
                progress: 0
            })));
        this.setState({
            ...this.state,
            pendingFiles: currentFiles
        });
    }
    handleMediaItemRemoved(mediaItem) {
        const mediaItems = this.state.mediaItems;
        (0, _lodashDefault.default).remove(mediaItems, (f)=>f.id == mediaItem.id);
        // remove from fields
        if (mediaItem.id == this.props.values.audioItem?.id) this.props.setFieldValue("audioItem", null);
        if (mediaItem.id == this.props.values.videoItem?.id) this.props.setFieldValue("videoItem", null);
        if (mediaItem.id == this.props.values.imageItem?.id) this.props.setFieldValue("imageItem", null);
        if (mediaItem.id == this.props.values.backgroundImageItem?.id) this.props.setFieldValue("backgroundImageItem", null);
        this.setState({
            ...this.state,
            mediaItems: mediaItems
        });
        this.updateContainerMediaItems();
    }
    handleScreenDefaultsChange(values) {
        this.props.setFieldValue("audioItem", values.audioItem);
        this.props.setFieldValue("videoItem", values.videoItem);
        this.props.setFieldValue("imageItem", values.imageItem);
        this.props.setFieldValue("backgroundImageItem", values.backgroundImageItem);
        this.props.setFieldValue("displayTextOverride", values.displayTextOverride);
        this.props.setFieldValue("displayTitleOverride", values.displayTitleOverride);
    }
    handleAudioDefaultsChange(values) {
        this.props.setFieldValue("audioItem", values.audioItem);
    }
    onContainerChange(container) {
        this.props.setFieldValue("container", container);
        this.props.onChange();
    }
    getCustomMediaIds() {
        const customResponses = this.props.values.container.responses;
        var imageIds = customResponses.filter((r)=>r.foregroundImageItemId).map((r)=>r.foregroundImageItemId);
        var backgroundIds = customResponses.filter((r)=>r.backgroundImageItemId).map((r)=>r.backgroundImageItemId);
        var audioIds = customResponses.filter((r)=>r.audioItemId).map((r)=>r.audioItemId);
        const videoIds = customResponses.filter((r)=>r.videoItemId).map((r)=>r.videoItemId);
        return [
            ...imageIds,
            ...backgroundIds,
            ...audioIds,
            ...videoIds
        ];
    }
    getAttachedMediaItems() {
        const returnItems = [];
        const mediaItems = this.props.mediaContainer.state.mediaItems;
        this.state.mediaItems.forEach((item)=>{
            const index = mediaItems.findIndex((i)=>i.id === item.id);
            if (index > -1) returnItems.push(mediaItems[index]);
            else returnItems.push(item);
        });
        return returnItems;
    }
    render() {
        const props = {
            ...this.props
        };
        if (props.stateContainer.state.isLoading || !props.values.container || props.stateContainer.state.deviceTargets.length == 0) return (0, _react.jsx)((0, _loaderDefault.default), null);
        return (0, _react.jsx)((0, _formContainerDefault.default), null, (0, _react.jsx)((0, _splitContainerDefault.default), null, (0, _react.jsx)((0, _pageContainerDefault.default), {
            fill: true
        }, (0, _react.jsx)((0, _pageTitleDefault.default), {
            text: "Files:",
            isSubtitle: true
        }), (0, _react.jsx)((0, _mediaLibraryTabbedLayoutDefault.default), {
            tabs: [
                "Upload",
                "Library"
            ]
        }, (0, _react.jsx)((0, _reactTabs.TabPanel), null, (0, _react.jsx)((0, _tabPanelBodyDefault.default), null, (0, _react.jsx)("div", null, (0, _react.jsx)((0, _multiFileSelectorDefault.default), {
            onSelected: this.handleFilesSelected.bind(this),
            accept: ".png,.mp3,.mp4,.jpeg,.jpg"
        })), (0, _react.jsx)((0, _allowedMediaLabelDefault.default), null), this.state.pendingFiles.length > 0 ? (0, _react.jsx)("div", null, (0, _react.jsx)((0, _horizontalContainerDefault.default), {
            className: "center"
        }, (0, _react.jsx)((0, _pageTitleDefault.default), {
            text: "Pending:",
            isSubtitle: true,
            tight: true
        }), (0, _react.jsx)((0, _buttonDefault.default), {
            text: "Upload & Attach All",
            type: "button",
            themes: [
                "primary-small",
                "end-tight"
            ],
            onClick: this.handleUploadAll.bind(this)
        })), (0, _react.jsx)((0, _horizontalSeparatorDefault.default), null), this.state.pendingFiles.map((file, i)=>(0, _react.jsx)((0, _fileStageCardDefault.default), {
                file: file,
                id: `file-card-${i}`,
                key: i,
                isUploading: file.isUploading,
                progress: file.progress,
                onRemove: this.handleRemoveStagedFile.bind(this),
                onUpload: this.handleSingleFileUpload.bind(this),
                onChange: this.handleStagedFileUpdate.bind(this)
            }))) : null)), (0, _react.jsx)((0, _reactTabs.TabPanel), null, (0, _react.jsx)((0, _tabPanelBodyDefault.default), null, (0, _react.jsx)((0, _mediaLibraryTabDefault.default), (0, _extendsDefault.default)({
            onAttachMediaItem: this.attachMediaItem.bind(this)
        }, this.props)))))), (0, _react.jsx)((0, _pageContainerDefault.default), {
            fill: true
        }, (0, _react.jsx)((0, _pageTitleDefault.default), {
            text: "Experience Builder:",
            isSubtitle: true
        }), (0, _react.jsx)((0, _attachedMediaContainer.AttachedMediaContainer), {
            mediaItems: this.getAttachedMediaItems(),
            customUsedItemIds: this.getCustomMediaIds(),
            onItemRemoved: this.handleMediaItemRemoved.bind(this)
        }), (0, _react.jsx)((0, _responseDetailContainer.ResponseDetailContainer), null, (0, _react.jsx)((0, _imageInnerTabsDefault.default), {
            tabs: [
                {
                    title: "Screen",
                    icon: screenIcon,
                    selectedIcon: screenSelectedIcon
                },
                {
                    title: "Audio",
                    icon: speakerIcon,
                    selectedIcon: speakerSelectedIcon
                },
                {
                    title: "Chat",
                    icon: chatIcon,
                    selectedIcon: chatSelectedIcon
                }
            ]
        }, (0, _react.jsx)((0, _reactTabs.TabPanel), null, (0, _react.jsx)((0, _screenResponseBuilderDefault.default), {
            deviceType: "Screen",
            applicationId: this.props.applicationId,
            onChange: this.onContainerChange.bind(this),
            container: props.values.container,
            targets: this.props.stateContainer.state.deviceTargets.filter((d)=>d.supportsForegroundImages),
            mediaItems: this.getAttachedMediaItems(),
            audioItem: this.props.values.audioItem,
            videoItem: this.props.values.videoItem,
            imageItem: this.props.values.imageItem,
            backgroundImageItem: this.props.values.backgroundImageItem,
            displayTextOverride: this.props.values.displayTextOverride,
            displayTitleOverride: this.props.values.displayTitleOverride,
            onDefaultsChange: this.handleScreenDefaultsChange.bind(this)
        })), (0, _react.jsx)((0, _reactTabs.TabPanel), null, (0, _react.jsx)((0, _audioResponseBuilderDefault.default), {
            deviceType: "Audio",
            applicationId: this.props.applicationId,
            targets: this.props.stateContainer.state.deviceTargets.filter((d)=>d.supportsSsml && !d.supportsDisplayText),
            onChange: this.onContainerChange.bind(this),
            container: props.values.container,
            mediaItems: this.getAttachedMediaItems(),
            audioItem: this.props.values.audioItem,
            onDefaultsChange: this.handleAudioDefaultsChange.bind(this)
        })), (0, _react.jsx)((0, _reactTabs.TabPanel), null, (0, _react.jsx)((0, _chatResponseBuilderDefault.default), {
            deviceType: "Chat",
            applicationId: this.props.applicationId,
            targets: this.props.stateContainer.state.deviceTargets.filter((d)=>!d.supportsSsml && d.supportsDisplayText),
            onChange: this.onContainerChange.bind(this),
            container: props.values.container,
            displayTextOverride: this.props.values.displayTextOverride,
            mediaItems: this.getAttachedMediaItems()
        })))))), (0, _react.jsx)((0, _pageErrorDefault.default), {
            errors: props.mediaContainer.state.errors
        }), (0, _react.jsx)((0, _footerBarDefault.default), {
            className: footerStyle
        }, (0, _react.jsx)((0, _buttonDefault.default), {
            themes: [
                "primary"
            ],
            text: "Save",
            type: "button",
            onClick: ()=>props.handleSubmit(null),
            disabled: this.props.stateContainer.state.isSaving,
            loading: this.props.stateContainer.state.isSaving
        }), (0, _react.jsx)((0, _buttonDefault.default), {
            themes: [
                "white",
                "end"
            ],
            text: "Discard",
            type: "button",
            onClick: this.handleDiscardChanges.bind(this),
            disabled: this.props.stateContainer.state.isSaving,
            loading: this.props.stateContainer.state.isSaving
        })));
    }
}
// note: some info on handling two submit buttons: https://github.com/jaredpalmer/formik/issues/214
// save creates the item and save and publish saves it and toggles the is live call
const MediaManagerForm = (0, _formik.withFormik)({
    mapPropsToValues: (props)=>({
            imageItem: props.imageItem,
            backgroundImageItem: props.backgroundImageItem,
            audioItem: props.audioItem,
            videoItem: props.videoItem,
            displayTextOverride: props.displayTextOverride,
            displayTitleOverride: props.displayTitleOverride
        }),
    validationSchema: _yup.object().shape({}),
    handleSubmit: (values, { props })=>{
        const output = {
            ...values
        };
        // create or update
        if (props.mediaResponseContainerId) props.stateContainer.updateResponseContainer(props.mediaResponseContainerId, values.container).then((result)=>{
            if (result.resultType == "Ok") {
                output.fullContainer = result.data;
                props.onFinish(output);
            }
        });
        else props.stateContainer.createResponseContainer({
            ...values.container,
            applicationId: props.applicationId
        }).then((result)=>{
            if (result.resultType == "Ok") {
                output.fullContainer = result.data;
                props.onFinish(output);
            }
        });
    }
})(InnerForm);
const footerStyle = /*#__PURE__*/ (0, _css.css)({
    name: "duudsh",
    styles: "position:fixed"
});
exports.default = MediaManagerForm;

},{"@babel/runtime/helpers/extends":"4iKIP","@emotion/react":"djZKr","formik":"3YnOK","lodash":"3hMBK","react":"6uln9","react-tabs":"92Sgf","yup":"j2SJU","../../../components/forms/MultiFileSelector":"gLA6m","../../../components/general/Button":"6ymxN","../../../components/general/Loader":"bnV5T","../../../components/general/PageTitle":"fKvvx","../../../components/structure/FooterBar":"bibRL","../../../components/structure/FormContainer":"4R4LR","../../../components/structure/HorizontalContainer":"eJPfh","../../../components/structure/HorizontalSeparator":"Pw3HQ","../../../components/structure/ImageInnerTabs":"a83gH","../../../components/structure/PageContainer":"hc1r8","../../../components/structure/SplitContainer":"bLpCE","./AllowedMediaLabel":"h5B9b","./AttachedMediaContainer":"hKAkT","./AudioResponseBuilder":"8KKdM","./ChatResponseBuilder":"53Szl","./FileStageCard":"apbrL","./ResponseDetailContainer":"2Ku9A","./ScreenResponseBuilder":"bM9LM","@emotion/css":"awUBr","../../../components/structure/TabPanelBody":"ePx7g","../../../components/structure/MediaLibraryTabbedLayout":"1DTJA","./MediaLibraryTab":"gAX0X","../../../components/general/PageError":"ezFTm","8db84cf97895793e":"2nj1V","1e5c994bedcc1096":"9pEQA","e59f4b7a1bbc0051":"2d2ic","2d03140896dfd381":"9l70Q","c2171fb688508323":"3WpRa","4a4ea91e4c83de53":"3u7X8","555656d1eca6201c":"2gFpb","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"gLA6m":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _reactDropzone = require("react-dropzone");
var _reactDropzoneDefault = parcelHelpers.interopDefault(_reactDropzone);
var _button = require("../general/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _colors = require("../../constants/colors");
var _uploadFileSize = require("../../constants/UploadFileSize");
const cloudIcon = require("decb985860335df3");
const dropzoneStyle = {
    borderRadius: 20,
    border: `dashed 5px ${(0, _colors.silver_two)}`,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    cursor: "pointer"
};
const dropzoneClass = /*#__PURE__*/ (0, _css.css)("flex-direction:column;padding:32px;.upload-label{font-size:18px;font-family:Muli;color:", (0, _colors.cool_grey), ";margin:12px;}.sub-detail{font-size:12px;font-family:Muli;color:", (0, _colors.cool_grey), ";}", "");
// Used in 1. Content Item Media File Upload 2. Backup import ".vfy, .zip"
class MultiFileSelector extends (0, _reactDefault.default).Component {
    handleFilePicked(files) {
        if (files.length > 0) {
            var hasErrors = false;
            files.forEach((file)=>{
                if (this.props.maxSizeOverrideMegabytes) {
                    if (file.size * (0, _uploadFileSize.BytesToMegabytesMultiplier) > this.props.maxSizeOverrideMegabytes) {
                        alert(`[${file.name}] file is too large. Please select a smaller file. The max file size allowed is ${this.props.maxSizeOverrideMegabytes} MB`);
                        hasErrors = true;
                    }
                    return;
                }
                const fileType = (0, _uploadFileSize.getFileTypeFromFileName)(file.name);
                if (fileType === "AudioFile" && file.size > (0, _uploadFileSize.MaxAudioBytesSize)) {
                    const audioSizeAllowed = Math.round((0, _uploadFileSize.MaxAudioBytesSize) * (0, _uploadFileSize.BytesToGigabytesMultiplier));
                    alert(`[${file.name}] file is too large. Please select a smaller audio file. The max file size allowed is ${audioSizeAllowed}GB`);
                    hasErrors = true;
                }
                if (fileType === "BackupFile" && file.size > (0, _uploadFileSize.MaxBackupBytesSize)) {
                    const backupSizeAllowed = Math.round((0, _uploadFileSize.MaxBackupBytesSize) * (0, _uploadFileSize.BytesToMegabytesMultiplier));
                    alert(`[${file.name}] file is too large. Please select a smaller backup file. The max file size allowed is ${backupSizeAllowed}MB`);
                    hasErrors = true;
                }
                if (fileType === "ImageFile" && file.size > (0, _uploadFileSize.MaxImageBytesSize)) {
                    const imageSizeAllowed = Math.round((0, _uploadFileSize.MaxImageBytesSize) * (0, _uploadFileSize.BytesToMegabytesMultiplier));
                    alert(`[${file.name}] image is too large. Please select a smaller image file. The max file size allowed is ${imageSizeAllowed}MB`);
                    hasErrors = true;
                }
                if (fileType === "VideoFile" && file.size > (0, _uploadFileSize.MaxVideoBytesSize)) {
                    const videoSizeAllowed = Math.round((0, _uploadFileSize.MaxVideoBytesSize) * (0, _uploadFileSize.BytesToGigabytesMultiplier));
                    alert(`[${file.name}] file is too large. Please select a smaller video file. The max file size allowed is ${videoSizeAllowed}GB`);
                    hasErrors = true;
                }
            });
            if (this.props.onSelected && !hasErrors) this.props.onSelected(files);
        }
    }
    render() {
        return (0, _react.jsx)("div", null, (0, _react.jsx)("div", null, (0, _react.jsx)((0, _reactDropzoneDefault.default), {
            onDrop: this.handleFilePicked.bind(this),
            className: dropzoneClass,
            style: dropzoneStyle,
            accept: this.props.accept,
            multiple: true
        }, (0, _react.jsx)("img", {
            src: cloudIcon
        }), (0, _react.jsx)("span", {
            className: "upload-label"
        }, this.props.uploadLabel || "Drag files here"), (0, _react.jsx)("span", {
            className: "sub-detail"
        }, "or"), (0, _react.jsx)((0, _buttonDefault.default), {
            themes: [
                "primary-small"
            ],
            text: this.props.uploadButtonText || "Select Local Files",
            type: "button"
        }))));
    }
}
exports.default = MultiFileSelector;

},{"@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","react-dropzone":"46RRi","../general/Button":"6ymxN","../../constants/colors":"1p3OR","../../constants/UploadFileSize":"5inYb","decb985860335df3":"fc0I5","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"46RRi":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/* eslint prefer-template: 0 */ var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _utils = require("./utils");
var _styles = require("./utils/styles");
var _stylesDefault = parcelHelpers.interopDefault(_styles);
var _extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var _createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
function _objectWithoutProperties(obj, keys) {
    var target = {};
    for(var i in obj){
        if (keys.indexOf(i) >= 0) continue;
        if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
        target[i] = obj[i];
    }
    return target;
}
function _toConsumableArray(arr) {
    if (Array.isArray(arr)) {
        for(var i = 0, arr2 = Array(arr.length); i < arr.length; i++)arr2[i] = arr[i];
        return arr2;
    } else return Array.from(arr);
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var Dropzone = function(_React$Component) {
    _inherits(Dropzone, _React$Component);
    function Dropzone(props, context) {
        _classCallCheck(this, Dropzone);
        var _this = _possibleConstructorReturn(this, (Dropzone.__proto__ || Object.getPrototypeOf(Dropzone)).call(this, props, context));
        _this.renderChildren = function(children, isDragActive, isDragAccept, isDragReject) {
            if (typeof children === "function") return children(_extends({}, _this.state, {
                isDragActive: isDragActive,
                isDragAccept: isDragAccept,
                isDragReject: isDragReject
            }));
            return children;
        };
        _this.composeHandlers = _this.composeHandlers.bind(_this);
        _this.onClick = _this.onClick.bind(_this);
        _this.onDocumentDrop = _this.onDocumentDrop.bind(_this);
        _this.onDragEnter = _this.onDragEnter.bind(_this);
        _this.onDragLeave = _this.onDragLeave.bind(_this);
        _this.onDragOver = _this.onDragOver.bind(_this);
        _this.onDragStart = _this.onDragStart.bind(_this);
        _this.onDrop = _this.onDrop.bind(_this);
        _this.onFileDialogCancel = _this.onFileDialogCancel.bind(_this);
        _this.onInputElementClick = _this.onInputElementClick.bind(_this);
        _this.setRef = _this.setRef.bind(_this);
        _this.setRefs = _this.setRefs.bind(_this);
        _this.isFileDialogActive = false;
        _this.state = {
            draggedFiles: [],
            acceptedFiles: [],
            rejectedFiles: []
        };
        return _this;
    }
    _createClass(Dropzone, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                var preventDropOnDocument = this.props.preventDropOnDocument;
                this.dragTargets = [];
                if (preventDropOnDocument) {
                    document.addEventListener("dragover", (0, _utils.onDocumentDragOver), false);
                    document.addEventListener("drop", this.onDocumentDrop, false);
                }
                this.fileInputEl.addEventListener("click", this.onInputElementClick, false);
                window.addEventListener("focus", this.onFileDialogCancel, false);
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                var preventDropOnDocument = this.props.preventDropOnDocument;
                if (preventDropOnDocument) {
                    document.removeEventListener("dragover", (0, _utils.onDocumentDragOver));
                    document.removeEventListener("drop", this.onDocumentDrop);
                }
                if (this.fileInputEl != null) this.fileInputEl.removeEventListener("click", this.onInputElementClick, false);
                window.removeEventListener("focus", this.onFileDialogCancel, false);
            }
        },
        {
            key: "composeHandlers",
            value: function composeHandlers(handler) {
                if (this.props.disabled) return null;
                return handler;
            }
        },
        {
            key: "onDocumentDrop",
            value: function onDocumentDrop(evt) {
                if (this.node && this.node.contains(evt.target)) // if we intercepted an event for our instance, let it propagate down to the instance's onDrop handler
                return;
                evt.preventDefault();
                this.dragTargets = [];
            }
        },
        {
            key: "onDragStart",
            value: function onDragStart(evt) {
                if (this.props.onDragStart) this.props.onDragStart.call(this, evt);
            }
        },
        {
            key: "onDragEnter",
            value: function onDragEnter(evt) {
                var _this2 = this;
                evt.preventDefault();
                // Count the dropzone and any children that are entered.
                if (this.dragTargets.indexOf(evt.target) === -1) this.dragTargets.push(evt.target);
                Promise.resolve(this.props.getDataTransferItems(evt)).then(function(draggedFiles) {
                    _this2.setState({
                        isDragActive: true,
                        draggedFiles: draggedFiles
                    });
                });
                if (this.props.onDragEnter) this.props.onDragEnter.call(this, evt);
            }
        },
        {
            key: "onDragOver",
            value: function onDragOver(evt) {
                // eslint-disable-line class-methods-use-this
                evt.preventDefault();
                evt.stopPropagation();
                try {
                    // The file dialog on Chrome allows users to drag files from the dialog onto
                    // the dropzone, causing the browser the crash when the file dialog is closed.
                    // A drop effect of 'none' prevents the file from being dropped
                    evt.dataTransfer.dropEffect = this.isFileDialogActive ? "none" : "copy"; // eslint-disable-line no-param-reassign
                } catch (err) {
                // continue regardless of error
                }
                if (this.props.onDragOver) this.props.onDragOver.call(this, evt);
                return false;
            }
        },
        {
            key: "onDragLeave",
            value: function onDragLeave(evt) {
                var _this3 = this;
                evt.preventDefault();
                // Only deactivate once the dropzone and all children have been left.
                this.dragTargets = this.dragTargets.filter(function(el) {
                    return el !== evt.target && _this3.node.contains(el);
                });
                if (this.dragTargets.length > 0) return;
                // Clear dragging files state
                this.setState({
                    isDragActive: false,
                    draggedFiles: []
                });
                if (this.props.onDragLeave) this.props.onDragLeave.call(this, evt);
            }
        },
        {
            key: "onDrop",
            value: function onDrop(evt) {
                var _this4 = this;
                var _props = this.props, onDrop = _props.onDrop, onDropAccepted = _props.onDropAccepted, onDropRejected = _props.onDropRejected, multiple = _props.multiple, disablePreview = _props.disablePreview, accept = _props.accept, getDataTransferItems = _props.getDataTransferItems;
                // Stop default browser behavior
                evt.preventDefault();
                // Reset the counter along with the drag on a drop.
                this.dragTargets = [];
                this.isFileDialogActive = false;
                // Clear files value
                this.draggedFiles = null;
                // Reset drag state
                this.setState({
                    isDragActive: false,
                    draggedFiles: []
                });
                Promise.resolve(getDataTransferItems(evt)).then(function(fileList) {
                    var acceptedFiles = [];
                    var rejectedFiles = [];
                    fileList.forEach(function(file) {
                        if (!disablePreview) try {
                            file.preview = window.URL.createObjectURL(file); // eslint-disable-line no-param-reassign
                        } catch (err) {}
                        if ((0, _utils.fileAccepted)(file, accept) && (0, _utils.fileMatchSize)(file, _this4.props.maxSize, _this4.props.minSize)) acceptedFiles.push(file);
                        else rejectedFiles.push(file);
                    });
                    if (!multiple) // if not in multi mode add any extra accepted files to rejected.
                    // This will allow end users to easily ignore a multi file drop in "single" mode.
                    rejectedFiles.push.apply(rejectedFiles, _toConsumableArray(acceptedFiles.splice(1)));
                    if (onDrop) onDrop.call(_this4, acceptedFiles, rejectedFiles, evt);
                    if (rejectedFiles.length > 0 && onDropRejected) onDropRejected.call(_this4, rejectedFiles, evt);
                    if (acceptedFiles.length > 0 && onDropAccepted) onDropAccepted.call(_this4, acceptedFiles, evt);
                });
            }
        },
        {
            key: "onClick",
            value: function onClick(evt) {
                var _props2 = this.props, onClick = _props2.onClick, disableClick = _props2.disableClick;
                if (!disableClick) {
                    evt.stopPropagation();
                    if (onClick) onClick.call(this, evt);
                    // in IE11/Edge the file-browser dialog is blocking, ensure this is behind setTimeout
                    // this is so react can handle state changes in the onClick prop above above
                    // see: https://github.com/react-dropzone/react-dropzone/issues/450
                    if ((0, _utils.isIeOrEdge)()) setTimeout(this.open.bind(this), 0);
                    else this.open();
                }
            }
        },
        {
            key: "onInputElementClick",
            value: function onInputElementClick(evt) {
                evt.stopPropagation();
                if (this.props.inputProps && this.props.inputProps.onClick) this.props.inputProps.onClick();
            }
        },
        {
            key: "onFileDialogCancel",
            value: function onFileDialogCancel() {
                var _this5 = this;
                // timeout will not recognize context of this method
                var onFileDialogCancel = this.props.onFileDialogCancel;
                // execute the timeout only if the FileDialog is opened in the browser
                if (this.isFileDialogActive) setTimeout(function() {
                    if (_this5.fileInputEl != null) {
                        // Returns an object as FileList
                        var files = _this5.fileInputEl.files;
                        if (!files.length) _this5.isFileDialogActive = false;
                    }
                    if (typeof onFileDialogCancel === "function") onFileDialogCancel();
                }, 300);
            }
        },
        {
            key: "setRef",
            value: function setRef(ref) {
                this.node = ref;
            }
        },
        {
            key: "setRefs",
            value: function setRefs(ref) {
                this.fileInputEl = ref;
            }
        },
        {
            key: "open",
            value: function open() {
                this.isFileDialogActive = true;
                this.fileInputEl.value = null;
                this.fileInputEl.click();
            }
        },
        {
            key: "render",
            value: function render() {
                var _props3 = this.props, accept = _props3.accept, acceptClassName = _props3.acceptClassName, activeClassName = _props3.activeClassName, children = _props3.children, disabled = _props3.disabled, disabledClassName = _props3.disabledClassName, inputProps = _props3.inputProps, multiple = _props3.multiple, name = _props3.name, rejectClassName = _props3.rejectClassName, rest = _objectWithoutProperties(_props3, [
                    "accept",
                    "acceptClassName",
                    "activeClassName",
                    "children",
                    "disabled",
                    "disabledClassName",
                    "inputProps",
                    "multiple",
                    "name",
                    "rejectClassName"
                ]);
                var acceptStyle = rest.acceptStyle, activeStyle = rest.activeStyle, _rest$className = rest.className, className = _rest$className === undefined ? "" : _rest$className, disabledStyle = rest.disabledStyle, rejectStyle = rest.rejectStyle, style = rest.style, props = _objectWithoutProperties(rest, [
                    "acceptStyle",
                    "activeStyle",
                    "className",
                    "disabledStyle",
                    "rejectStyle",
                    "style"
                ]);
                var _state = this.state, isDragActive = _state.isDragActive, draggedFiles = _state.draggedFiles;
                var filesCount = draggedFiles.length;
                var isMultipleAllowed = multiple || filesCount <= 1;
                var isDragAccept = filesCount > 0 && (0, _utils.allFilesAccepted)(draggedFiles, this.props.accept);
                var isDragReject = filesCount > 0 && (!isDragAccept || !isMultipleAllowed);
                var noStyles = !className && !style && !activeStyle && !acceptStyle && !rejectStyle && !disabledStyle;
                if (isDragActive && activeClassName) className += " " + activeClassName;
                if (isDragAccept && acceptClassName) className += " " + acceptClassName;
                if (isDragReject && rejectClassName) className += " " + rejectClassName;
                if (disabled && disabledClassName) className += " " + disabledClassName;
                if (noStyles) {
                    style = (0, _stylesDefault.default).default;
                    activeStyle = (0, _stylesDefault.default).active;
                    acceptStyle = (0, _stylesDefault.default).active;
                    rejectStyle = (0, _stylesDefault.default).rejected;
                    disabledStyle = (0, _stylesDefault.default).disabled;
                }
                var appliedStyle = _extends({
                    position: "relative"
                }, style);
                if (activeStyle && isDragActive) appliedStyle = _extends({}, appliedStyle, activeStyle);
                if (acceptStyle && isDragAccept) appliedStyle = _extends({}, appliedStyle, acceptStyle);
                if (rejectStyle && isDragReject) appliedStyle = _extends({}, appliedStyle, rejectStyle);
                if (disabledStyle && disabled) appliedStyle = _extends({}, appliedStyle, disabledStyle);
                var inputAttributes = {
                    accept: accept,
                    disabled: disabled,
                    type: "file",
                    style: _extends({
                        position: "absolute",
                        top: 0,
                        right: 0,
                        bottom: 0,
                        left: 0,
                        opacity: 0.00001,
                        pointerEvents: "none"
                    }, inputProps.style),
                    multiple: (0, _utils.supportMultiple) && multiple,
                    ref: this.setRefs,
                    onChange: this.onDrop,
                    autoComplete: "off"
                };
                if (name && name.length) inputAttributes.name = name;
                // Destructure custom props away from props used for the div element
                var acceptedFiles = props.acceptedFiles, preventDropOnDocument = props.preventDropOnDocument, disablePreview = props.disablePreview, disableClick = props.disableClick, onDropAccepted = props.onDropAccepted, onDropRejected = props.onDropRejected, onFileDialogCancel = props.onFileDialogCancel, maxSize = props.maxSize, minSize = props.minSize, getDataTransferItems = props.getDataTransferItems, divProps = _objectWithoutProperties(props, [
                    "acceptedFiles",
                    "preventDropOnDocument",
                    "disablePreview",
                    "disableClick",
                    "onDropAccepted",
                    "onDropRejected",
                    "onFileDialogCancel",
                    "maxSize",
                    "minSize",
                    "getDataTransferItems"
                ]);
                return (0, _reactDefault.default).createElement("div", _extends({
                    className: className,
                    style: appliedStyle
                }, divProps /* expand user provided props first so event handlers are never overridden */ , {
                    onClick: this.composeHandlers(this.onClick),
                    onDragStart: this.composeHandlers(this.onDragStart),
                    onDragEnter: this.composeHandlers(this.onDragEnter),
                    onDragOver: this.composeHandlers(this.onDragOver),
                    onDragLeave: this.composeHandlers(this.onDragLeave),
                    onDrop: this.composeHandlers(this.onDrop),
                    ref: this.setRef,
                    "aria-disabled": disabled
                }), this.renderChildren(children, isDragActive, isDragAccept, isDragReject), (0, _reactDefault.default).createElement("input", _extends({}, inputProps /* expand user provided inputProps first so inputAttributes override them */ , inputAttributes)));
            }
        }
    ]);
    return Dropzone;
}((0, _reactDefault.default).Component);
exports.default = Dropzone;
Dropzone.propTypes = {
    /**
   * Allow specific types of files. See https://github.com/okonet/attr-accept for more information.
   * Keep in mind that mime type determination is not reliable across platforms. CSV files,
   * for example, are reported as text/plain under macOS but as application/vnd.ms-excel under
   * Windows. In some cases there might not be a mime type set at all.
   * See: https://github.com/react-dropzone/react-dropzone/issues/276
   */ accept: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).string,
        (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).string)
    ]),
    /**
   * Contents of the dropzone
   */ children: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).node,
        (0, _propTypesDefault.default).func
    ]),
    /**
   * Disallow clicking on the dropzone container to open file dialog
   */ disableClick: (0, _propTypesDefault.default).bool,
    /**
   * Enable/disable the dropzone entirely
   */ disabled: (0, _propTypesDefault.default).bool,
    /**
   * Enable/disable preview generation
   */ disablePreview: (0, _propTypesDefault.default).bool,
    /**
   * If false, allow dropped items to take over the current browser window
   */ preventDropOnDocument: (0, _propTypesDefault.default).bool,
    /**
   * Pass additional attributes to the `<input type="file"/>` tag
   */ inputProps: (0, _propTypesDefault.default).object,
    /**
   * Allow dropping multiple files
   */ multiple: (0, _propTypesDefault.default).bool,
    /**
   * `name` attribute for the input tag
   */ name: (0, _propTypesDefault.default).string,
    /**
   * Maximum file size (in bytes)
   */ maxSize: (0, _propTypesDefault.default).number,
    /**
   * Minimum file size (in bytes)
   */ minSize: (0, _propTypesDefault.default).number,
    /**
   * className
   */ className: (0, _propTypesDefault.default).string,
    /**
   * className to apply when drag is active
   */ activeClassName: (0, _propTypesDefault.default).string,
    /**
   * className to apply when drop will be accepted
   */ acceptClassName: (0, _propTypesDefault.default).string,
    /**
   * className to apply when drop will be rejected
   */ rejectClassName: (0, _propTypesDefault.default).string,
    /**
   * className to apply when dropzone is disabled
   */ disabledClassName: (0, _propTypesDefault.default).string,
    /**
   * CSS styles to apply
   */ style: (0, _propTypesDefault.default).object,
    /**
   * CSS styles to apply when drag is active
   */ activeStyle: (0, _propTypesDefault.default).object,
    /**
   * CSS styles to apply when drop will be accepted
   */ acceptStyle: (0, _propTypesDefault.default).object,
    /**
   * CSS styles to apply when drop will be rejected
   */ rejectStyle: (0, _propTypesDefault.default).object,
    /**
   * CSS styles to apply when dropzone is disabled
   */ disabledStyle: (0, _propTypesDefault.default).object,
    /**
   * getDataTransferItems handler
   * @param {Event} event
   * @returns {Array} array of File objects
   */ getDataTransferItems: (0, _propTypesDefault.default).func,
    /**
   * onClick callback
   * @param {Event} event
   */ onClick: (0, _propTypesDefault.default).func,
    /**
   * onDrop callback
   */ onDrop: (0, _propTypesDefault.default).func,
    /**
   * onDropAccepted callback
   */ onDropAccepted: (0, _propTypesDefault.default).func,
    /**
   * onDropRejected callback
   */ onDropRejected: (0, _propTypesDefault.default).func,
    /**
   * onDragStart callback
   */ onDragStart: (0, _propTypesDefault.default).func,
    /**
   * onDragEnter callback
   */ onDragEnter: (0, _propTypesDefault.default).func,
    /**
   * onDragOver callback
   */ onDragOver: (0, _propTypesDefault.default).func,
    /**
   * onDragLeave callback
   */ onDragLeave: (0, _propTypesDefault.default).func,
    /**
   * Provide a callback on clicking the cancel button of the file dialog
   */ onFileDialogCancel: (0, _propTypesDefault.default).func
};
Dropzone.defaultProps = {
    preventDropOnDocument: true,
    disabled: false,
    disablePreview: false,
    disableClick: false,
    inputProps: {},
    multiple: true,
    maxSize: Infinity,
    minSize: 0,
    getDataTransferItems: (0, _utils.getDataTransferItems)
};

},{"react":"6uln9","prop-types":"6FKs7","./utils":"5A3CU","./utils/styles":"azjQL","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"5A3CU":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "supportMultiple", ()=>supportMultiple);
parcelHelpers.export(exports, "getDataTransferItems", ()=>getDataTransferItems);
// Firefox versions prior to 53 return a bogus MIME type for every file drag, so dragovers with
// that MIME type will always be accepted
parcelHelpers.export(exports, "fileAccepted", ()=>fileAccepted);
parcelHelpers.export(exports, "fileMatchSize", ()=>fileMatchSize);
parcelHelpers.export(exports, "allFilesAccepted", ()=>allFilesAccepted);
// allow the entire document to be a drag target
parcelHelpers.export(exports, "onDocumentDragOver", ()=>onDocumentDragOver);
parcelHelpers.export(exports, "isIeOrEdge", ()=>isIeOrEdge);
var _attrAccept = require("attr-accept");
var _attrAcceptDefault = parcelHelpers.interopDefault(_attrAccept);
var supportMultiple = typeof document !== "undefined" && document && document.createElement ? "multiple" in document.createElement("input") : true;
function getDataTransferItems(event) {
    var dataTransferItemsList = [];
    if (event.dataTransfer) {
        var dt = event.dataTransfer;
        if (dt.files && dt.files.length) dataTransferItemsList = dt.files;
        else if (dt.items && dt.items.length) // During the drag even the dataTransfer.files is null
        // but Chrome implements some drag store, which is accesible via dataTransfer.items
        dataTransferItemsList = dt.items;
    } else if (event.target && event.target.files) dataTransferItemsList = event.target.files;
    // Convert from DataTransferItemsList to the native Array
    return Array.prototype.slice.call(dataTransferItemsList);
}
function fileAccepted(file, accept) {
    return file.type === "application/x-moz-file" || (0, _attrAcceptDefault.default)(file, accept);
}
function fileMatchSize(file, maxSize, minSize) {
    return file.size <= maxSize && file.size >= minSize;
}
function allFilesAccepted(files, accept) {
    return files.every(function(file) {
        return fileAccepted(file, accept);
    });
}
function onDocumentDragOver(evt) {
    evt.preventDefault();
}
function isIe(userAgent) {
    return userAgent.indexOf("MSIE") !== -1 || userAgent.indexOf("Trident/") !== -1;
}
function isEdge(userAgent) {
    return userAgent.indexOf("Edge/") !== -1;
}
function isIeOrEdge() {
    var userAgent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window.navigator.userAgent;
    return isIe(userAgent) || isEdge(userAgent);
}

},{"attr-accept":"klLu2","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"klLu2":[function(require,module,exports) {
module.exports = function(t) {
    function n(e) {
        if (r[e]) return r[e].exports;
        var o = r[e] = {
            i: e,
            l: !1,
            exports: {}
        };
        return t[e].call(o.exports, o, o.exports, n), o.l = !0, o.exports;
    }
    var r = {};
    return n.m = t, n.c = r, n.d = function(t, r, e) {
        n.o(t, r) || Object.defineProperty(t, r, {
            configurable: !1,
            enumerable: !0,
            get: e
        });
    }, n.n = function(t) {
        var r = t && t.__esModule ? function() {
            return t.default;
        } : function() {
            return t;
        };
        return n.d(r, "a", r), r;
    }, n.o = function(t, n) {
        return Object.prototype.hasOwnProperty.call(t, n);
    }, n.p = "", n(n.s = 13);
}([
    function(t, n) {
        var r = t.exports = "undefined" != typeof window && window.Math == Math ? window : "undefined" != typeof self && self.Math == Math ? self : Function("return this")();
        "number" == typeof __g && (__g = r);
    },
    function(t, n) {
        t.exports = function(t) {
            return "object" == typeof t ? null !== t : "function" == typeof t;
        };
    },
    function(t, n) {
        var r = t.exports = {
            version: "2.5.0"
        };
        "number" == typeof __e && (__e = r);
    },
    function(t, n, r) {
        t.exports = !r(4)(function() {
            return 7 != Object.defineProperty({}, "a", {
                get: function() {
                    return 7;
                }
            }).a;
        });
    },
    function(t, n) {
        t.exports = function(t) {
            try {
                return !!t();
            } catch (t) {
                return !0;
            }
        };
    },
    function(t, n) {
        var r = {}.toString;
        t.exports = function(t) {
            return r.call(t).slice(8, -1);
        };
    },
    function(t, n, r) {
        var e = r(32)("wks"), o = r(9), i = r(0).Symbol, u = "function" == typeof i;
        (t.exports = function(t) {
            return e[t] || (e[t] = u && i[t] || (u ? i : o)("Symbol." + t));
        }).store = e;
    },
    function(t, n, r) {
        var e = r(0), o = r(2), i = r(8), u = r(22), c = r(10), f = function(t, n, r) {
            var a, s, p, l, v = t & f.F, y = t & f.G, h = t & f.S, d = t & f.P, x = t & f.B, g = y ? e : h ? e[n] || (e[n] = {}) : (e[n] || {}).prototype, m = y ? o : o[n] || (o[n] = {}), b = m.prototype || (m.prototype = {});
            y && (r = n);
            for(a in r)s = !v && g && void 0 !== g[a], p = (s ? g : r)[a], l = x && s ? c(p, e) : d && "function" == typeof p ? c(Function.call, p) : p, g && u(g, a, p, t & f.U), m[a] != p && i(m, a, l), d && b[a] != p && (b[a] = p);
        };
        e.core = o, f.F = 1, f.G = 2, f.S = 4, f.P = 8, f.B = 16, f.W = 32, f.U = 64, f.R = 128, t.exports = f;
    },
    function(t, n, r) {
        var e = r(16), o = r(21);
        t.exports = r(3) ? function(t, n, r) {
            return e.f(t, n, o(1, r));
        } : function(t, n, r) {
            return t[n] = r, t;
        };
    },
    function(t, n) {
        var r = 0, e = Math.random();
        t.exports = function(t) {
            return "Symbol(".concat(void 0 === t ? "" : t, ")_", (++r + e).toString(36));
        };
    },
    function(t, n, r) {
        var e = r(24);
        t.exports = function(t, n, r) {
            if (e(t), void 0 === n) return t;
            switch(r){
                case 1:
                    return function(r) {
                        return t.call(n, r);
                    };
                case 2:
                    return function(r, e) {
                        return t.call(n, r, e);
                    };
                case 3:
                    return function(r, e, o) {
                        return t.call(n, r, e, o);
                    };
            }
            return function() {
                return t.apply(n, arguments);
            };
        };
    },
    function(t, n) {
        t.exports = function(t) {
            if (void 0 == t) throw TypeError("Can't call method on  " + t);
            return t;
        };
    },
    function(t, n, r) {
        var e = r(28), o = Math.min;
        t.exports = function(t) {
            return t > 0 ? o(e(t), 9007199254740991) : 0;
        };
    },
    function(t, n, r) {
        "use strict";
        n.__esModule = !0, n.default = function(t, n) {
            if (t && n) {
                var r = Array.isArray(n) ? n : n.split(","), e = t.name || "", o = t.type || "", i = o.replace(/\/.*$/, "");
                return r.some(function(t) {
                    var n = t.trim();
                    return "." === n.charAt(0) ? e.toLowerCase().endsWith(n.toLowerCase()) : n.endsWith("/*") ? i === n.replace(/\/.*$/, "") : o === n;
                });
            }
            return !0;
        }, r(14), r(34);
    },
    function(t, n, r) {
        r(15), t.exports = r(2).Array.some;
    },
    function(t, n, r) {
        "use strict";
        var e = r(7), o = r(25)(3);
        e(e.P + e.F * !r(33)([].some, !0), "Array", {
            some: function(t) {
                return o(this, t, arguments[1]);
            }
        });
    },
    function(t, n, r) {
        var e = r(17), o = r(18), i = r(20), u = Object.defineProperty;
        n.f = r(3) ? Object.defineProperty : function(t, n, r) {
            if (e(t), n = i(n, !0), e(r), o) try {
                return u(t, n, r);
            } catch (t) {}
            if ("get" in r || "set" in r) throw TypeError("Accessors not supported!");
            return "value" in r && (t[n] = r.value), t;
        };
    },
    function(t, n, r) {
        var e = r(1);
        t.exports = function(t) {
            if (!e(t)) throw TypeError(t + " is not an object!");
            return t;
        };
    },
    function(t, n, r) {
        t.exports = !r(3) && !r(4)(function() {
            return 7 != Object.defineProperty(r(19)("div"), "a", {
                get: function() {
                    return 7;
                }
            }).a;
        });
    },
    function(t, n, r) {
        var e = r(1), o = r(0).document, i = e(o) && e(o.createElement);
        t.exports = function(t) {
            return i ? o.createElement(t) : {};
        };
    },
    function(t, n, r) {
        var e = r(1);
        t.exports = function(t, n) {
            if (!e(t)) return t;
            var r, o;
            if (n && "function" == typeof (r = t.toString) && !e(o = r.call(t))) return o;
            if ("function" == typeof (r = t.valueOf) && !e(o = r.call(t))) return o;
            if (!n && "function" == typeof (r = t.toString) && !e(o = r.call(t))) return o;
            throw TypeError("Can't convert object to primitive value");
        };
    },
    function(t, n) {
        t.exports = function(t, n) {
            return {
                enumerable: !(1 & t),
                configurable: !(2 & t),
                writable: !(4 & t),
                value: n
            };
        };
    },
    function(t, n, r) {
        var e = r(0), o = r(8), i = r(23), u = r(9)("src"), c = Function.toString, f = ("" + c).split("toString");
        r(2).inspectSource = function(t) {
            return c.call(t);
        }, (t.exports = function(t, n, r, c) {
            var a = "function" == typeof r;
            a && (i(r, "name") || o(r, "name", n)), t[n] !== r && (a && (i(r, u) || o(r, u, t[n] ? "" + t[n] : f.join(String(n)))), t === e ? t[n] = r : c ? t[n] ? t[n] = r : o(t, n, r) : (delete t[n], o(t, n, r)));
        })(Function.prototype, "toString", function() {
            return "function" == typeof this && this[u] || c.call(this);
        });
    },
    function(t, n) {
        var r = {}.hasOwnProperty;
        t.exports = function(t, n) {
            return r.call(t, n);
        };
    },
    function(t, n) {
        t.exports = function(t) {
            if ("function" != typeof t) throw TypeError(t + " is not a function!");
            return t;
        };
    },
    function(t, n, r) {
        var e = r(10), o = r(26), i = r(27), u = r(12), c = r(29);
        t.exports = function(t, n) {
            var r = 1 == t, f = 2 == t, a = 3 == t, s = 4 == t, p = 6 == t, l = 5 == t || p, v = n || c;
            return function(n, c, y) {
                for(var h, d, x = i(n), g = o(x), m = e(c, y, 3), b = u(g.length), _ = 0, w = r ? v(n, b) : f ? v(n, 0) : void 0; b > _; _++)if ((l || _ in g) && (h = g[_], d = m(h, _, x), t)) {
                    if (r) w[_] = d;
                    else if (d) switch(t){
                        case 3:
                            return !0;
                        case 5:
                            return h;
                        case 6:
                            return _;
                        case 2:
                            w.push(h);
                    }
                    else if (s) return !1;
                }
                return p ? -1 : a || s ? s : w;
            };
        };
    },
    function(t, n, r) {
        var e = r(5);
        t.exports = Object("z").propertyIsEnumerable(0) ? Object : function(t) {
            return "String" == e(t) ? t.split("") : Object(t);
        };
    },
    function(t, n, r) {
        var e = r(11);
        t.exports = function(t) {
            return Object(e(t));
        };
    },
    function(t, n) {
        var r = Math.ceil, e = Math.floor;
        t.exports = function(t) {
            return isNaN(t = +t) ? 0 : (t > 0 ? e : r)(t);
        };
    },
    function(t, n, r) {
        var e = r(30);
        t.exports = function(t, n) {
            return new (e(t))(n);
        };
    },
    function(t, n, r) {
        var e = r(1), o = r(31), i = r(6)("species");
        t.exports = function(t) {
            var n;
            return o(t) && (n = t.constructor, "function" != typeof n || n !== Array && !o(n.prototype) || (n = void 0), e(n) && null === (n = n[i]) && (n = void 0)), void 0 === n ? Array : n;
        };
    },
    function(t, n, r) {
        var e = r(5);
        t.exports = Array.isArray || function(t) {
            return "Array" == e(t);
        };
    },
    function(t, n, r) {
        var e = r(0), o = e["__core-js_shared__"] || (e["__core-js_shared__"] = {});
        t.exports = function(t) {
            return o[t] || (o[t] = {});
        };
    },
    function(t, n, r) {
        "use strict";
        var e = r(4);
        t.exports = function(t, n) {
            return !!t && e(function() {
                n ? t.call(null, function() {}, 1) : t.call(null);
            });
        };
    },
    function(t, n, r) {
        r(35), t.exports = r(2).String.endsWith;
    },
    function(t, n, r) {
        "use strict";
        var e = r(7), o = r(12), i = r(36), u = "".endsWith;
        e(e.P + e.F * r(38)("endsWith"), "String", {
            endsWith: function(t) {
                var n = i(this, t, "endsWith"), r = arguments.length > 1 ? arguments[1] : void 0, e = o(n.length), c = void 0 === r ? e : Math.min(o(r), e), f = String(t);
                return u ? u.call(n, f, c) : n.slice(c - f.length, c) === f;
            }
        });
    },
    function(t, n, r) {
        var e = r(37), o = r(11);
        t.exports = function(t, n, r) {
            if (e(n)) throw TypeError("String#" + r + " doesn't accept regex!");
            return String(o(t));
        };
    },
    function(t, n, r) {
        var e = r(1), o = r(5), i = r(6)("match");
        t.exports = function(t) {
            var n;
            return e(t) && (void 0 !== (n = t[i]) ? !!n : "RegExp" == o(t));
        };
    },
    function(t, n, r) {
        var e = r(6)("match");
        t.exports = function(t) {
            var n = /./;
            try {
                "/./"[t](n);
            } catch (r) {
                try {
                    return n[e] = !1, !"/./"[t](n);
                } catch (t) {}
            }
            return !0;
        };
    }
]);

},{}],"azjQL":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = {
    rejected: {
        borderStyle: "solid",
        borderColor: "#c66",
        backgroundColor: "#eee"
    },
    disabled: {
        opacity: 0.5
    },
    active: {
        borderStyle: "solid",
        borderColor: "#6c6",
        backgroundColor: "#eee"
    },
    default: {
        width: 200,
        height: 200,
        borderWidth: 2,
        borderColor: "#666",
        borderStyle: "dashed",
        borderRadius: 5
    }
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"5inYb":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BytesToMegabytesMultiplier", ()=>BytesToMegabytesMultiplier);
parcelHelpers.export(exports, "BytesToGigabytesMultiplier", ()=>BytesToGigabytesMultiplier);
parcelHelpers.export(exports, "MegabytesSize", ()=>MegabytesSize);
parcelHelpers.export(exports, "GigabytesSize", ()=>GigabytesSize);
parcelHelpers.export(exports, "MaxAudioBytesSize", ()=>MaxAudioBytesSize);
parcelHelpers.export(exports, "MaxBackupBytesSize", ()=>MaxBackupBytesSize);
parcelHelpers.export(exports, "MaxImageBytesSize", ()=>MaxImageBytesSize);
parcelHelpers.export(exports, "MaxVideoBytesSize", ()=>MaxVideoBytesSize);
parcelHelpers.export(exports, "getFileTypeFromFileName", ()=>getFileTypeFromFileName);
const BytesToMegabytesMultiplier = 9.537e-7;
const BytesToGigabytesMultiplier = 9.313225746154785e-10;
const MegabytesSize = 1048576;
const GigabytesSize = 1073741824;
const MaxAudioBytesSize = 2 * GigabytesSize; // 2GB
const MaxBackupBytesSize = 100 * MegabytesSize; // 100MB
const MaxImageBytesSize = 5 * MegabytesSize; // 5MB
const MaxVideoBytesSize = 2 * GigabytesSize; // 2GB
const getFileTypeFromFileName = (fileName)=>{
    if (!fileName) return null;
    const parts = fileName.split(".");
    const extension = parts[parts.length - 1].toLowerCase();
    switch(extension){
        case "mp3":
        case "mp4":
            return "VideoFile";
        case "vfy":
        case "zip":
            return "BackupFile";
        case "txt":
        case "csv":
            return "TextFile";
        case "png":
        case "jpg":
        case "jpeg":
        default:
            return "ImageFile";
    }
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"fc0I5":[function(require,module,exports) {
module.exports = require("1fa310658ee71663").getBundleURL("kVLro") + require("145364dbe9e124b2").resolve("36VrD");

},{"1fa310658ee71663":"c7Tr5","145364dbe9e124b2":"fyJL2"}],"fKvvx":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const titleStyle = /*#__PURE__*/ (0, _css.css)({
    name: "juhyzn",
    styles: 'font-size:28px;font-family:Muli,"sans-serif";margin:0 0 16px 0;font-weight:normal'
});
const subTitleStyle = /*#__PURE__*/ (0, _css.css)({
    name: "14is9qy",
    styles: "font-size:20px"
});
const tightStyle = /*#__PURE__*/ (0, _css.css)({
    name: "ti75j2",
    styles: "margin:0"
});
const PageTitle = (props)=>(0, _react.jsx)("h2", {
        className: `${titleStyle} ${props.isSubtitle ? subTitleStyle : ""} ${props.tight ? tightStyle : ""}`
    }, props.text);
exports.default = PageTitle;

},{"@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"bibRL":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _colors = require("../../constants/colors");
var _breakpoints = require("../../constants/breakpoints");
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// component for the bottom of the page as a fixed footer.
// used for content edit / add scenes
const FooterBar = (props)=>(0, _react.jsx)("div", {
        className: `footer-bar ${footerStyle} ${props.usedInModal ? modalFooterStyle : ""} ${props.small ? "small" : ""} ${props.className ?? ""}`
    }, props.children);
const modalFooterStyle = /*#__PURE__*/ (0, _css.css)({
    name: "u87wk4",
    styles: "border-bottom-right-radius:16px;border-bottom-left-radius:16px"
});
const footerStyle = /*#__PURE__*/ (0, _css.css)("position:absolute;bottom:0;left:0;width:100%;display:flex;flex-direction:row;align-items:center;z-index:110;height:80px;box-shadow:0 4px 20px 0 ", (0, _colors.dark_grey_blue_10), ";border-top:solid 1px ", (0, _colors.silver_two), ";background-color:", (0, _colors.pale_grey), ";&.small{height:70px;}", (0, _breakpoints.breakpoint_small), "{display:flex;flex-direction:row;justify-content:space-between;}", "");
exports.default = FooterBar;

},{"@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","../../constants/colors":"1p3OR","../../constants/breakpoints":"2F01A","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4R4LR":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const containerStyle = /*#__PURE__*/ (0, _css.css)({
    name: "1sqqqs8",
    styles: "padding-bottom:90px"
});
const FormContainer = (props)=>(0, _react.jsx)("div", {
        className: containerStyle
    }, props.children);
exports.default = FormContainer;

},{"@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"eJPfh":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const HorizontalContainer = (props)=>(0, _react.jsx)("div", {
        className: `${containerStyle} ${props.className}`
    }, props.children);
const containerStyle = /*#__PURE__*/ (0, _css.css)({
    name: "od09t4",
    styles: "display:flex;flex-direction:row;>div+*{margin-left:16px;}.end{margin-right:0;margin-left:auto;}&.center{align-items:center;}&.fill{width:100%;}"
});
exports.default = HorizontalContainer;

},{"@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"a83gH":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _reactTabs = require("react-tabs");
var _css = require("@emotion/css");
var _colors = require("../../constants/colors");
var _imageTab = require("./ImageTab");
var _imageTabDefault = parcelHelpers.interopDefault(_imageTab);
const tabStripStyle = /*#__PURE__*/ (0, _css.css)("display:flex;flex-direction:row;height:115px;list-style:none;border-bottom:solid 1px ", (0, _colors.silver_two), ";background:white;", "");
const ImageInnerTabs = (props)=>{
    function renderTab(tab, index) {
        return (0, _imageTabDefault.default)({
            tab,
            index,
            className: index < props.tabs.length - 1 ? "bordered" : ""
        });
    }
    return (0, _react.jsx)((0, _reactTabs.Tabs), {
        defaultIndex: props.defaultIndex
    }, (0, _react.jsx)((0, _reactTabs.TabList), {
        className: tabStripStyle
    }, props.tabs.map(renderTab)), props.children);
};
exports.default = ImageInnerTabs;

},{"@emotion/react":"djZKr","react":"6uln9","react-tabs":"92Sgf","@emotion/css":"awUBr","../../constants/colors":"1p3OR","./ImageTab":"ff8RD","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"ff8RD":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _reactTabs = require("react-tabs");
var _tabIndicator = require("./TabIndicator");
var _tabIndicatorDefault = parcelHelpers.interopDefault(_tabIndicator);
var _colors = require("../../constants/colors");
function ImageTab(props) {
    return (0, _react.jsx)((0, _reactTabs.Tab), {
        key: props.index,
        selectedClassName: activeTabStyle,
        className: `${tabStyle} ${props.className ? props.className : ""}`
    }, (0, _react.jsx)("div", {
        className: "tab-wrapper"
    }, (0, _react.jsx)("div", {
        className: "tab-content"
    }, (0, _react.jsx)("img", {
        className: "tab-icon",
        src: props.tab.icon
    }), (0, _react.jsx)("img", {
        className: "selected-tab-icon",
        src: props.tab.selectedIcon
    }), (0, _react.jsx)("span", null, props.tab.title))), (0, _react.jsx)((0, _tabIndicatorDefault.default), {
        className: "indicator",
        color: indicatorGradient
    }));
}
const indicatorGradient = `linear-gradient(267deg, ${(0, _colors.dark_sky_blue)}, ${(0, _colors.ocean_blue)});`;
const tabStyle = /*#__PURE__*/ (0, _css.css)("color:black;cursor:pointer;flex-grow:1;align-items:center;position:relative;.indicator{position:absolute;left:50%;bottom:-2px;z-index:4;margin-left:-25px;}&.bordered{.tab-content{border-right:1px solid ", (0, _colors.silver_two), ";}}.tab-wrapper{height:115px;display:flex;align-items:center;}.tab-content{min-width:80px;flex-grow:1;display:flex;flex-direction:column;align-items:center;justify-content:center;height:65px;span{font-family:Muli;font-size:14px;font-weight:normal;font-style:normal;letter-spacing:0.5px;}}.tab-indicator{display:none;flex-grow:0;flex-shrink:0;}.selected-tab-icon{display:none;}img{margin-bottom:16px;}", "");
const activeTabStyle = /*#__PURE__*/ (0, _css.css)("color:", (0, _colors.ocean_blue), ";span{color:", (0, _colors.ocean_blue), ";}>.tab-indicator{display:block;}.tab-icon{display:none;}.selected-tab-icon{display:block;}", "");
exports.default = ImageTab;

},{"@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","react-tabs":"92Sgf","./TabIndicator":"3Sj8d","../../constants/colors":"1p3OR","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3Sj8d":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _colors = require("../../constants/colors");
const TabIndicator = (props)=>{
    const indicatorStyle = /*#__PURE__*/ (0, _css.css)("background:", props.color, " height:3px;width:50px;display:block;", props.className === undefined ? `
        margin: 0 auto;` : "", " border-radius:2px;box-shadow:-1px 1px 4px 0 ", (0, _colors.dark_grey_blue_20), ",-1px 1px 2px 0 rgba(0, 116, 166, 0.1);", "");
    return (0, _react.jsx)("div", {
        className: `tab-indicator ${props.className} ${indicatorStyle}`
    });
};
exports.default = TabIndicator;

},{"@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","../../constants/colors":"1p3OR","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"bLpCE":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// layout component used for creating split views (aka 50%/50%)
const layoutStyle = /*#__PURE__*/ (0, _css.css)({
    name: "16qy96k",
    styles: "margin:32px 0;display:flex;flex-direction:row;align-items:stretch;justify-content:space-between;width:100%;>div{width:45%;flex:1;}>*+*{margin-left:50px;}"
});
const SplitContainer = (props)=>(0, _react.jsx)("div", {
        className: layoutStyle
    }, props.children);
exports.default = SplitContainer;

},{"@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"h5B9b":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _colors = require("../../../constants/colors");
const imageIcon = require("a32fa8920ba45825");
const audioIcon = require("9d8648b54a34b11e");
const videoIcon = require("69d8ad29d1011ddb");
const labelStyle = /*#__PURE__*/ (0, _css.css)("display:flex;color:", (0, _colors.cool_grey), ";font-family:Muli;font-size:12px;font-weight:normal;font-style:normal;font-stretch:normal;line-height:normal;letter-spacing:0.5px;img{height:14px;margin-right:2px;}>span+*{margin-left:12px;}margin:12px 0;", "");
const AllowedMediaLabel = (props)=>(0, _react.jsx)("div", {
        className: labelStyle
    }, (0, _react.jsx)("span", null, "File formats supported:  "), (0, _react.jsx)("img", {
        src: imageIcon
    }), (0, _react.jsx)("span", null, ".png, .jpg"), (0, _react.jsx)("img", {
        src: audioIcon
    }), (0, _react.jsx)("span", null, ".mp3"), (0, _react.jsx)("img", {
        src: videoIcon
    }), (0, _react.jsx)("span", null, ".mp4"));
exports.default = AllowedMediaLabel;

},{"@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","../../../constants/colors":"1p3OR","a32fa8920ba45825":"7XJJS","9d8648b54a34b11e":"lcYWS","69d8ad29d1011ddb":"jbgUU","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hKAkT":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AttachedMediaContainer", ()=>AttachedMediaContainer);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _colors = require("../../../constants/colors");
var _mediaItemChip = require("../../../components/general/MediaItemChip");
var _mediaItemChipDefault = parcelHelpers.interopDefault(_mediaItemChip);
const attachmentIcon = require("92d6166aea8a4b60");
const containerStyle = /*#__PURE__*/ (0, _css.css)("border-radius:10px 10px 0 0;border:1px solid ", (0, _colors.cool_grey), ";border-bottom:0;padding:32px;.section-label{font-family:Muli;font-size:16px;font-weight:600;font-style:normal;font-stretch:normal;line-height:normal;letter-spacing:normal;color:", (0, _colors.dark_grey_blue), ";margin-bottom:16px;display:flex;flex-align:center;img{margin-right:4px;}}", "");
const AttachedMediaContainer = (props)=>(0, _react.jsx)("div", {
        className: containerStyle
    }, (0, _react.jsx)("p", {
        className: "section-label"
    }, (0, _react.jsx)("img", {
        src: attachmentIcon
    }), (0, _react.jsx)("span", null, "Attached Files")), props.mediaItems.map((item, i)=>(0, _react.jsx)((0, _mediaItemChipDefault.default), {
            deleteDisabled: props.customUsedItemIds.some((i)=>i == item.id),
            deleteTooltip: props.customUsedItemIds.some((i)=>i == item.id) ? "This item cannot be removed because it is being used by a customized response." : null,
            fieldName: "attachedItem",
            mediaItem: item,
            key: i,
            canDelete: true,
            onDelete: (item)=>props.onItemRemoved(item)
        })));

},{"@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","../../../constants/colors":"1p3OR","../../../components/general/MediaItemChip":"5tgXS","92d6166aea8a4b60":"fDmmK","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"5tgXS":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _colors = require("../../constants/colors");
var _button = require("./Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _rcTooltip = require("rc-tooltip");
var _rcTooltipDefault = parcelHelpers.interopDefault(_rcTooltip);
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const audioIcon = require("60f803d55ca77c0a");
const videoIcon = require("c216ddcb3e485790");
const imageIcon = require("7dff288f91b577c9");
const backgroundIcon = require("c8f950618e0d8863");
const editIcon = require("3a04cab0df9ba3a3");
const closeIcon = require("6dcb9d9cfa58ecaf");
const videoDisabledIcon = require("ee203419b97de80b");
const audioDisabledIcon = require("fd79abaaa602a1bd");
const imageDisabledIcon = require("5e05e67c2ee7a0d");
const wrapperStyle = /*#__PURE__*/ (0, _css.css)("height:50px;border-radius:10px;border:solid 1px ", (0, _colors.silver_two), ";width:auto;display:flex;flex-direction:row;align-items:center;margin-bottom:12px;padding:0 12px 0 24px;>*+*{margin-left:16px;}img{width:28px;height:auto;fill:black;}.edit{height:28px;width:auto;margin-right:0;margin-left:auto;img{margin:0;}}span{font-family:Muli;font-size:14px;font-weight:normal;font-style:normal;font-stretch:normal;line-height:normal;letter-spacing:normal;color:", (0, _colors.dark_grey_blue), ";word-break:break-all;flex:1;}button:disabled{cursor:not-allowed;}", "");
const borderless = /*#__PURE__*/ (0, _css.css)({
    name: "1rznqq0",
    styles: "border:none;padding:0"
});
const tooltipContentStyle = /*#__PURE__*/ (0, _css.css)({
    name: "1lc622f",
    styles: ".rc-tooltip-inner{font-family:Muli;font-size:14px;font-weight:normal;font-style:normal;letter-spacing:0.6px;z-index:120;color:white;background-color:#304562;box-shadow:-1px 4px 10px 0 rgba(48, 69, 98, 0.1);padding:8px;min-height:20;}"
});
const getIcon = (mediaItem, fieldName)=>{
    if (fieldName == "backgroundImageItem") return backgroundIcon;
    switch(mediaItem.mediaType){
        case "AudioFile":
            return mediaItem.isDisabled == null || mediaItem.isDisabled === false ? audioIcon : audioDisabledIcon;
        case "VideoFile":
            return mediaItem.isDisabled == null || mediaItem.isDisabled === false ? videoIcon : videoDisabledIcon;
        default:
            return mediaItem.isDisabled == null || mediaItem.isDisabled === false ? imageIcon : imageDisabledIcon;
    }
};
const getMediaName = (mediaItem)=>{
    const mediaName = mediaItem != null ? mediaItem.name : "";
    if (mediaItem.isDisabled === true) switch(mediaItem.mediaType){
        case "AudioFile":
            return `Missing Audio File (${mediaName})`;
        case "VideoFile":
            return `Missing Video File (${mediaName})`;
        default:
            return `Missing Image File (${mediaName})`;
    }
    else return mediaName;
};
const MediaItemChip = (props)=>(0, _react.jsx)("div", {
        className: `${wrapperStyle} ${props.borderless ? borderless : ""}`
    }, (0, _react.jsx)("img", {
        src: props.mediaItem !== undefined ? getIcon(props.mediaItem, props.fieldName) : null
    }), (0, _react.jsx)("span", null, getMediaName(props.mediaItem)), props.canEdit ? (0, _react.jsx)((0, _buttonDefault.default), {
        themes: [
            "end-tight",
            "icon"
        ],
        icon: editIcon,
        additionalClasses: "edit",
        type: "button"
    }) : null, props.canDelete && !props.deleteTooltip ? (0, _react.jsx)((0, _buttonDefault.default), {
        themes: [
            "end-tight",
            "icon"
        ],
        disabled: props.deleteDisabled,
        icon: closeIcon,
        onClick: ()=>{
            return props.onDelete(props.mediaItem, props.fieldName);
        },
        additionalClasses: "edit",
        type: "button"
    }) : null, props.canDelete && props.deleteTooltip ? (0, _react.jsx)((0, _rcTooltipDefault.default), {
        overlayClassName: tooltipContentStyle,
        trigger: [
            "hover"
        ],
        placement: "left",
        overlay: (0, _react.jsx)("p", null, props.deleteTooltip)
    }, (0, _react.jsx)("div", null, (0, _react.jsx)((0, _buttonDefault.default), {
        themes: [
            "end-tight",
            "icon"
        ],
        disabled: props.deleteDisabled,
        icon: closeIcon,
        onClick: ()=>{
            return props.onDelete(props.mediaItem, props.fieldName);
        },
        additionalClasses: "edit",
        type: "button"
    }))) : null);
exports.default = MediaItemChip;

},{"@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","../../constants/colors":"1p3OR","./Button":"6ymxN","rc-tooltip":"fhD1R","60f803d55ca77c0a":"lcYWS","c216ddcb3e485790":"jbgUU","7dff288f91b577c9":"7XJJS","c8f950618e0d8863":"5pK2Y","3a04cab0df9ba3a3":"1dzFf","6dcb9d9cfa58ecaf":"igsne","ee203419b97de80b":"5Cfvw","fd79abaaa602a1bd":"9Ypdq","5e05e67c2ee7a0d":"f4Nk1","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1dzFf":[function(require,module,exports) {
module.exports = require("ad91789e291f27b").getBundleURL("kVLro") + require("4d9189cd9394ff10").resolve("9VdHa");

},{"ad91789e291f27b":"c7Tr5","4d9189cd9394ff10":"fyJL2"}],"igsne":[function(require,module,exports) {
module.exports = require("48efa3f68ada5107").getBundleURL("kVLro") + require("a33c51623978d61b").resolve("aDcea");

},{"48efa3f68ada5107":"c7Tr5","a33c51623978d61b":"fyJL2"}],"5Cfvw":[function(require,module,exports) {
module.exports = require("e467deb53dc028c6").getBundleURL("kVLro") + require("426a0d19b603b1f1").resolve("5BHpt");

},{"e467deb53dc028c6":"c7Tr5","426a0d19b603b1f1":"fyJL2"}],"9Ypdq":[function(require,module,exports) {
module.exports = require("3de4a2337e9030be").getBundleURL("kVLro") + require("f4824cd48b48aefe").resolve("jAwWs");

},{"3de4a2337e9030be":"c7Tr5","f4824cd48b48aefe":"fyJL2"}],"f4Nk1":[function(require,module,exports) {
module.exports = require("2d1ee8f2332d6bb1").getBundleURL("kVLro") + require("1072044e18c0336c").resolve("jLjvi");

},{"2d1ee8f2332d6bb1":"c7Tr5","1072044e18c0336c":"fyJL2"}],"fDmmK":[function(require,module,exports) {
module.exports = require("dd7ae8480eb1e72b").getBundleURL("kVLro") + require("186824dc3a232310").resolve("kGEze");

},{"dd7ae8480eb1e72b":"c7Tr5","186824dc3a232310":"fyJL2"}],"8KKdM":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _responseFieldCard = require("./ResponseFieldCard");
var _iconSelectField = require("../../../components/forms/IconSelectField");
var _iconSelectFieldDefault = parcelHelpers.interopDefault(_iconSelectField);
var _radioGroup = require("../../../components/forms/RadioGroup");
var _radioGroupDefault = parcelHelpers.interopDefault(_radioGroup);
var _lodash = require("lodash");
var _lodashDefault = parcelHelpers.interopDefault(_lodash);
var _button = require("../../../components/general/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _ssmlField = require("../../../components/forms/SsmlField/SsmlField");
var _ssmlFieldDefault = parcelHelpers.interopDefault(_ssmlField);
var _responseBuilderContainer = require("./ResponseBuilderContainer");
var _responseBuilderContainerDefault = parcelHelpers.interopDefault(_responseBuilderContainer);
const readoutIcon = require("447c50adc14f721a");
const audioIcon = require("68f4b7a78c36eeb8");
const textIcon = require("60353e325428cf7a");
const videoIcon = require("d1c6d1e158fb2b90");
const noVideoIcon = require("3f43143118afaf8f");
const imageIcon = require("b6429c90e031a886");
const noImageIcon = require("fbbd71417499bd82");
const resetIcon = require("15fc715ef485714c");
const customIcon = require("da5b84daff0add8f");
class AudioResponseBuilder extends (0, _reactDefault.default).Component {
    componentWillMount() {
        this.setState({
            ...this.state,
            deviceTarget: this.props.targets[0],
            customResponse: this.getCurrentResponse(this.props.targets[0].id),
            validationErrors: null,
            successMessage: null,
            hasCustomChanges: false
        });
    }
    componentDidUpdate(prevProps) {
        if (prevProps.deviceType != this.props.deviceType) this.setState({
            ...this.state,
            deviceTarget: this.props.targets[0],
            customResponse: this.getCurrentResponse(this.props.targets[0].id)
        });
        else if (this.props.audioItem != prevProps.audioItem || this.props.container.responses.length != prevProps.container.responses.length) this.setState({
            ...this.state,
            customResponse: this.getCurrentResponse(this.state.deviceTarget.id)
        });
    }
    getCurrentResponse(deviceTargetId) {
        if (!deviceTargetId) deviceTargetId = this.state.deviceTarget.id;
        const existingResponse = this.props.container.responses.find((r)=>r.deviceTargetId == deviceTargetId);
        if (existingResponse) return existingResponse;
        else return this.buildAudioResponseFromDefault(deviceTargetId);
    }
    buildAudioResponseFromDefault(deviceTargetId) {
        if (!deviceTargetId) deviceTargetId = this.state.deviceTarget.id;
        const target = this.props.targets.find((t)=>t.id == deviceTargetId);
        if (!target) return null;
        // if audio and target supports, set that template
        if (this.props.audioItem && target.supportsRichAudio) {
            const template = target.responseTemplates.find((t)=>t.usesAudio);
            if (template) return {
                audioItemId: this.props.audioItem.id,
                responseTemplateTypeId: template.id,
                applicationId: this.props.applicationId,
                deviceTargetId: deviceTargetId
            };
        }
        const template = target.responseTemplates.find((t)=>t.usesReadout);
        if (!template) return;
        return {
            responseTemplateTypeId: template.id,
            applicationId: this.props.applicationId,
            deviceTargetId: deviceTargetId
        };
    }
    handleTargetChange(selection) {
        const target = this.props.targets.find((t)=>t.id == selection.value);
        this.setState({
            ...this.state,
            deviceTarget: target,
            customResponse: this.getCurrentResponse(target.id),
            hasCustomChanges: false,
            validationErrors: null,
            successMessage: null
        });
    }
    handleDefaultAudioChange(option) {
        const propValues = {
            ...this.props
        };
        propValues.audioItem = option.value == "default" ? null : this.props.mediaItems.find((m)=>m.id == option.value);
        this.props.onDefaultsChange(propValues);
    }
    hasCustomResponse(deviceTargetId) {
        const isCustom = this.props.container.responses.some((r)=>r.deviceTargetId == deviceTargetId);
        return isCustom;
    }
    removeTargetResponse(deviceTargetId) {
        const container = this.props.container;
        (0, _lodashDefault.default).remove(container.responses, (r)=>r.deviceTargetId == deviceTargetId);
        this.props.onChange(container);
        // reset values
        this.setState({
            ...this.state,
            customResponse: this.getCurrentResponse(this.state.deviceTarget.id)
        });
    }
    handleSpeakerAudioSourceChange(option) {
        if (option.value == "default") {
            this.removeTargetResponse(this.state.deviceTarget.id);
            var existingResponse = this.state.customResponse;
            if (existingResponse) {
                existingResponse.readoutOverride = null;
                existingResponse.audioItemId = null;
                this.setState({
                    ...this.state,
                    customResponse: existingResponse,
                    hasCustomChanges: false
                });
            } else this.setState({
                ...this.state,
                hasCustomChanges: false
            });
        } else if (option.value == "custom") {
            var existingResponse = this.state.customResponse;
            if (existingResponse) {
                existingResponse.readoutOverride = "";
                existingResponse.audioItemId = null;
                this.setState({
                    ...this.state,
                    customResponse: existingResponse,
                    hasCustomChanges: true
                });
            }
        } else {
            var existingResponse = this.state.customResponse;
            if (existingResponse) {
                existingResponse.audioItemId = option.value;
                existingResponse.readoutOverride = null;
                this.setState({
                    ...this.state,
                    customResponse: existingResponse,
                    hasCustomChanges: true
                });
            }
        }
    }
    getMediaItems(type) {
        return this.props.mediaItems.filter((m)=>m.mediaType == type);
    }
    handleRemoveCustomization() {
        this.removeTargetResponse(this.state.deviceTarget.id);
    }
    handleReadoutTextChange(ssml) {
        var existingResponse = this.state.customResponse;
        if (existingResponse) {
            existingResponse.readoutOverride = ssml;
            this.setState({
                ...this.state,
                customResponse: existingResponse,
                hasCustomChanges: true
            });
        }
    }
    handleUpdateResponse() {
        const validationErrors = this.verifyCustomResponse();
        if (validationErrors) {
            this.setState({
                ...this.state,
                validationErrors: [
                    validationErrors
                ]
            });
            return;
        }
        const container = this.props.container;
        const existingResponse = container.responses.find((r)=>r.deviceTargetId == this.state.deviceTarget.id);
        if (existingResponse && (this.state.customResponse.audioItemId != null || this.state.customResponse.readoutOverride != null)) {
            const index = container.responses.indexOf(existingResponse);
            container.responses[index] = this.state.customResponse;
        } else if (existingResponse) {
            // default set, remove the customization
            this.handleRemoveCustomization();
            return;
        } else if (this.state.customResponse.audioItemId != null || this.state.customResponse.readoutOverride != null) container.responses.push(this.state.customResponse);
        this.props.onChange(container);
        this.setState({
            ...this.state,
            validationErrors: null,
            successMessage: "Saved",
            hasCustomChanges: false
        });
        // hide save message after delay
        setTimeout(()=>{
            this.setState({
                ...this.state,
                successMessage: null
            });
        }, 3000);
    }
    verifyCustomResponse() {
        const response = this.state.customResponse;
        if (!response) return "Invalid Response";
        const template = this.state.deviceTarget.responseTemplates.find((t)=>t.id == this.state.customResponse.responseTemplateTypeId);
        if (!template) return "Invalid template";
        if (template.requiresVideo && !response.videoItemId) return "This template requires a video";
        if (template.requiresAudio && !response.audioItemId) return "This template requires an audio file";
        if (template.requiresForegroundImage && !response.foregroundImageItemId) return "This template requires a foreground image";
        if (template.requiresBackgroundImage && !response.backgroundImageItemId) return "This template requires a background image";
        return null;
    }
    getAudioRadioValue() {
        if (this.state.customResponse.audioItemId) return this.state.customResponse.audioItemId;
        if (this.state.customResponse.readoutOverride != null) return "custom";
        return "default";
    }
    render() {
        return (0, _react.jsx)((0, _responseBuilderContainerDefault.default), null, (0, _react.jsx)("div", null, (0, _react.jsx)("h4", null, "Default Components"), (0, _react.jsx)("p", null, "This sets the underlying components used in a response. We will apply a best-fit solution for each device based on their respective capabilities. "), (0, _react.jsx)("div", null, (0, _react.jsx)((0, _responseFieldCard.ResponseFieldCard), {
            title: "Audio Source"
        }, (0, _react.jsx)((0, _radioGroupDefault.default), {
            options: [
                ...this.props.mediaItems.filter((m)=>m.mediaType == "AudioFile").map((item)=>({
                        icon: audioIcon,
                        value: item.id,
                        label: item.name
                    })),
                {
                    icon: readoutIcon,
                    value: "default",
                    label: "Device Readout"
                }
            ],
            onChange: this.handleDefaultAudioChange.bind(this),
            value: this.props.audioItem ? this.props.audioItem.id : "default"
        })))), (0, _react.jsx)("h4", null, "Custom Overrides"), (0, _react.jsx)("p", null, "Customizations made here will apply to the specific device-type and override the default settings"), this.props.targets.length > 1 ? (0, _react.jsx)("div", {
            className: "type-selector"
        }, (0, _react.jsx)((0, _iconSelectFieldDefault.default), {
            name: "deviceType",
            options: (0, _lodashDefault.default).sortBy(this.props.targets.map((t)=>({
                    value: t.id,
                    icon: t.iconUrl,
                    label: t.displayName,
                    rightIcon: this.hasCustomResponse(t.id) ? customIcon : null,
                    rightText: this.hasCustomResponse(t.id) ? "CUSTOM" : null
                })), (o)=>o.label),
            clearable: false,
            label: "Device-Type:",
            value: this.state.deviceTarget.id,
            onBlur: ()=>{},
            onChange: this.handleTargetChange.bind(this)
        })) : null, (0, _react.jsx)("div", null, this.hasCustomResponse(this.state.deviceTarget.id) ? (0, _react.jsx)((0, _buttonDefault.default), {
            themes: [
                "hollow",
                "end-tight"
            ],
            type: "button",
            onClick: this.handleRemoveCustomization.bind(this),
            additionalClasses: "reset-button",
            text: "Reset to default",
            icon: resetIcon
        }) : null, (0, _react.jsx)((0, _responseFieldCard.ResponseFieldCard), {
            title: "Audio Source"
        }, (0, _react.jsx)((0, _radioGroupDefault.default), {
            options: [
                {
                    icon: readoutIcon,
                    value: "default",
                    label: "Default Readout"
                },
                ...this.props.mediaItems.filter((m)=>m.mediaType == "AudioFile").map((item)=>({
                        icon: audioIcon,
                        value: item.id,
                        label: item.name
                    })),
                {
                    icon: readoutIcon,
                    value: "custom",
                    label: "Custom Readout"
                }
            ],
            onChange: this.handleSpeakerAudioSourceChange.bind(this),
            value: this.getAudioRadioValue()
        }), this.state.customResponse && this.state.customResponse.readoutOverride != null ? (0, _react.jsx)((0, _ssmlFieldDefault.default), {
            name: "readoutOverride",
            placeholder: "What do you want the assistant to say?",
            value: this.state.customResponse.readoutOverride,
            onChange: this.handleReadoutTextChange.bind(this),
            onBlur: ()=>{},
            applicationId: this.props.applicationId
        }) : null, (0, _react.jsx)("div", {
            className: "update-container"
        }, (0, _react.jsx)((0, _buttonDefault.default), {
            themes: [
                "primary-small"
            ],
            disabled: !this.state.hasCustomChanges,
            type: "button",
            onClick: this.handleUpdateResponse.bind(this),
            additionalClasses: "update-button",
            text: "Update"
        }), (0, _react.jsx)("p", {
            className: "error-label"
        }, this.state.validationErrors ? this.state.validationErrors.join(",") : null), (0, _react.jsx)("p", {
            className: "success-label"
        }, this.state.successMessage)))));
    }
}
exports.default = AudioResponseBuilder;

},{"@emotion/react":"djZKr","react":"6uln9","./ResponseFieldCard":"hUTbn","../../../components/forms/IconSelectField":"i0bA1","../../../components/forms/RadioGroup":"eiGrn","lodash":"3hMBK","../../../components/general/Button":"6ymxN","../../../components/forms/SsmlField/SsmlField":"cvL6K","./ResponseBuilderContainer":"g6NDi","447c50adc14f721a":"4qcoH","68f4b7a78c36eeb8":"3mfQB","60353e325428cf7a":"kyxnq","d1c6d1e158fb2b90":"ePf5J","3f43143118afaf8f":"346EV","b6429c90e031a886":"76Rwl","fbbd71417499bd82":"1WB1n","15fc715ef485714c":"8Nwsw","da5b84daff0add8f":"emEAy","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hUTbn":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ResponseFieldCard", ()=>ResponseFieldCard);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _colors = require("../../../constants/colors");
var _horizontalSeparator = require("../../../components/structure/HorizontalSeparator");
var _horizontalSeparatorDefault = parcelHelpers.interopDefault(_horizontalSeparator);
const cardStyle = /*#__PURE__*/ (0, _css.css)("background:white;border-radius:10px;border:1px solid ", (0, _colors.cool_grey), ";padding:16px 32px;margin:16px 0;.card-title{font-family:Muli;font-size:16px;font-weight:600;font-style:normal;font-stretch:normal;line-height:normal;letter-spacing:normal;color:", (0, _colors.dark_grey_blue), ";margin-bottom:16px;}", "");
const ResponseFieldCard = (props)=>(0, _react.jsx)("div", {
        className: cardStyle
    }, (0, _react.jsx)("p", {
        className: "card-title"
    }, props.title), (0, _react.jsx)((0, _horizontalSeparatorDefault.default), null), (0, _react.jsx)("div", null, props.children));

},{"@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","../../../constants/colors":"1p3OR","../../../components/structure/HorizontalSeparator":"Pw3HQ","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"i0bA1":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _defineProperty = require("@babel/runtime/helpers/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _reactSelect = require("react-select");
var _reactSelectDefault = parcelHelpers.interopDefault(_reactSelect);
var _colors = require("../../constants/colors");
// component used in building forms with consistent components for look and function
class IconOptionComponent extends (0, _reactDefault.default).Component {
    handleMouseDown(event) {
        event.preventDefault();
        event.stopPropagation();
        this.props.onSelect(this.props.option, event);
    }
    handleMouseEnter(event) {
        this.props.onFocus(this.props.option, event);
    }
    handleMouseMove(event) {
        if (this.props.isFocused) return;
        this.props.onFocus(this.props.option, event);
    }
    render() {
        return (0, _react.jsx)("div", {
            className: this.props.className,
            onMouseDown: this.handleMouseDown.bind(this),
            onMouseEnter: this.handleMouseEnter.bind(this),
            onMouseMove: this.handleMouseMove.bind(this),
            title: this.props.option.label
        }, (0, _react.jsx)("img", {
            src: this.props.option.icon
        }), (0, _react.jsx)("span", {
            className: "Select-value-label"
        }, this.props.children), this.props.option.rightText ? (0, _react.jsx)("span", {
            className: "detail-text"
        }, this.props.option.rightText) : null, this.props.option.rightIcon ? (0, _react.jsx)("img", {
            src: this.props.option.rightIcon,
            className: "detail-icon"
        }) : null);
    }
}
class IconValue extends (0, _reactDefault.default).Component {
    render() {
        return (0, _react.jsx)("div", {
            className: "Select-value",
            title: this.props.value.title
        }, (0, _react.jsx)("img", {
            src: this.props.value.icon
        }), (0, _react.jsx)("span", {
            className: "Select-value-label"
        }, this.props.children), this.props.value.rightText ? (0, _react.jsx)("span", {
            className: "detail-text"
        }, this.props.value.rightText) : null, this.props.value.rightIcon ? (0, _react.jsx)("img", {
            src: this.props.value.rightIcon,
            className: "detail-icon"
        }) : null);
    }
}
const selectStyle = /*#__PURE__*/ (0, _css.css)("font-family:Muli sans-serif;font-weight:normal;font-style:normal;font-stretch:normal;line-height:normal;letter-spacing:normal;text-align:left;flex:1;margin-left:0;margin-right:0;width:100%;.Select-control{border-radius:24px;min-height:48px;box-shadow:-1px 4px 10px 0 ", (0, _colors.dark_grey_blue_10), ";}.Select-placeholder,.Select-value{padding:0 26px 0 8px;font-family:Muli;font-size:14px;display:flex;align-items:center;}.Select-value-label{margin-left:16px;}.Select-menu-outer{border-bottom-right-radius:16px;border-bottom-left-radius:16px;}.Select-option,Select-noresults{height:48px;padding:0 26px 0 8px;font-family:Muli;font-size:14px;display:flex;align-items:center;}.Select-option:last-child{border-bottom-right-radius:24px;border-bottom-left-radius:24px;}", "");
const containerStyle = /*#__PURE__*/ (0, _css.css)("align-items:center;margin-left:auto;margin-right:0;flex:1;>*+*{margin-top:8px;}label{font-family:Muli;font-size:14px;font-weight:normal;font-style:normal;font-stretch:normal;line-height:normal;letter-spacing:normal;text-align:right;color:", (0, _colors.dark_grey_blue), ";margin-left:16px;}.detail-text{font-size:12px;font-weight:normal;font-style:normal;font-stretch:normal;line-height:normal;letter-spacing:0.7px;text-align:right;color:", (0, _colors.cool_grey), ";margin-right:8px;margin-left:auto;}.detail-icon{margin-right:32px;}", "");
class IconSelectField extends (0, _reactDefault.default).Component {
    constructor(...args){
        super(...args);
        (0, _definePropertyDefault.default)(this, "handleChange", (value)=>{
            // this is going to call setFieldValue and manually update values.topcis
            this.props.onChange(value);
        });
        (0, _definePropertyDefault.default)(this, "handleBlur", ()=>{
            // this is going to call setFieldTouched and manually update touched.topcis
            this.props.onBlur(true);
        });
    }
    render() {
        const props = {
            ...this.props
        };
        return (0, _react.jsx)("div", {
            className: containerStyle
        }, this.props.label !== undefined ? (0, _react.jsx)("label", null, this.props.label) : null, (0, _react.jsx)((0, _reactSelectDefault.default), {
            id: props.id,
            name: props.name,
            placeholder: props.placeholder,
            value: props.value,
            onChange: this.handleChange.bind(this),
            onBlur: this.handleBlur.bind(this),
            disabled: props.disabled,
            options: props.options,
            valueComponent: IconValue,
            clearable: props.clearable,
            optionComponent: IconOptionComponent,
            className: selectStyle
        }));
    }
}
exports.default = IconSelectField;

},{"@babel/runtime/helpers/defineProperty":"9sJxO","@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","react-select":"1numo","../../constants/colors":"1p3OR","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1numo":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Async", ()=>Async);
parcelHelpers.export(exports, "AsyncCreatable", ()=>AsyncCreatableSelect);
parcelHelpers.export(exports, "Creatable", ()=>CreatableSelect);
parcelHelpers.export(exports, "Value", ()=>Value);
parcelHelpers.export(exports, "Option", ()=>Option);
parcelHelpers.export(exports, "defaultMenuRenderer", ()=>menuRenderer);
parcelHelpers.export(exports, "defaultArrowRenderer", ()=>arrowRenderer);
parcelHelpers.export(exports, "defaultClearRenderer", ()=>clearRenderer);
parcelHelpers.export(exports, "defaultFilterOptions", ()=>filterOptions);
var _reactInputAutosize = require("react-input-autosize");
var _reactInputAutosizeDefault = parcelHelpers.interopDefault(_reactInputAutosize);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactDom = require("react-dom");
var arrowRenderer = function arrowRenderer(_ref) {
    var onMouseDown = _ref.onMouseDown;
    return (0, _reactDefault.default).createElement("span", {
        className: "Select-arrow",
        onMouseDown: onMouseDown
    });
};
arrowRenderer.propTypes = {
    onMouseDown: (0, _propTypesDefault.default).func
};
var clearRenderer = function clearRenderer() {
    return (0, _reactDefault.default).createElement("span", {
        className: "Select-clear",
        dangerouslySetInnerHTML: {
            __html: "&times;"
        }
    });
};
var map = [
    {
        "base": "A",
        "letters": /[\u0041\u24B6\uFF21\u00C0\u00C1\u00C2\u1EA6\u1EA4\u1EAA\u1EA8\u00C3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\u00C4\u01DE\u1EA2\u00C5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F]/g
    },
    {
        "base": "AA",
        "letters": /[\uA732]/g
    },
    {
        "base": "AE",
        "letters": /[\u00C6\u01FC\u01E2]/g
    },
    {
        "base": "AO",
        "letters": /[\uA734]/g
    },
    {
        "base": "AU",
        "letters": /[\uA736]/g
    },
    {
        "base": "AV",
        "letters": /[\uA738\uA73A]/g
    },
    {
        "base": "AY",
        "letters": /[\uA73C]/g
    },
    {
        "base": "B",
        "letters": /[\u0042\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0182\u0181]/g
    },
    {
        "base": "C",
        "letters": /[\u0043\u24B8\uFF23\u0106\u0108\u010A\u010C\u00C7\u1E08\u0187\u023B\uA73E]/g
    },
    {
        "base": "D",
        "letters": /[\u0044\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018B\u018A\u0189\uA779]/g
    },
    {
        "base": "DZ",
        "letters": /[\u01F1\u01C4]/g
    },
    {
        "base": "Dz",
        "letters": /[\u01F2\u01C5]/g
    },
    {
        "base": "E",
        "letters": /[\u0045\u24BA\uFF25\u00C8\u00C9\u00CA\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\u00CB\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E]/g
    },
    {
        "base": "F",
        "letters": /[\u0046\u24BB\uFF26\u1E1E\u0191\uA77B]/g
    },
    {
        "base": "G",
        "letters": /[\u0047\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E]/g
    },
    {
        "base": "H",
        "letters": /[\u0048\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D]/g
    },
    {
        "base": "I",
        "letters": /[\u0049\u24BE\uFF29\u00CC\u00CD\u00CE\u0128\u012A\u012C\u0130\u00CF\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197]/g
    },
    {
        "base": "J",
        "letters": /[\u004A\u24BF\uFF2A\u0134\u0248]/g
    },
    {
        "base": "K",
        "letters": /[\u004B\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2]/g
    },
    {
        "base": "L",
        "letters": /[\u004C\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780]/g
    },
    {
        "base": "LJ",
        "letters": /[\u01C7]/g
    },
    {
        "base": "Lj",
        "letters": /[\u01C8]/g
    },
    {
        "base": "M",
        "letters": /[\u004D\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C]/g
    },
    {
        "base": "N",
        "letters": /[\u004E\u24C3\uFF2E\u01F8\u0143\u00D1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u0220\u019D\uA790\uA7A4]/g
    },
    {
        "base": "NJ",
        "letters": /[\u01CA]/g
    },
    {
        "base": "Nj",
        "letters": /[\u01CB]/g
    },
    {
        "base": "O",
        "letters": /[\u004F\u24C4\uFF2F\u00D2\u00D3\u00D4\u1ED2\u1ED0\u1ED6\u1ED4\u00D5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\u00D6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\u00D8\u01FE\u0186\u019F\uA74A\uA74C]/g
    },
    {
        "base": "OI",
        "letters": /[\u01A2]/g
    },
    {
        "base": "OO",
        "letters": /[\uA74E]/g
    },
    {
        "base": "OU",
        "letters": /[\u0222]/g
    },
    {
        "base": "P",
        "letters": /[\u0050\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754]/g
    },
    {
        "base": "Q",
        "letters": /[\u0051\u24C6\uFF31\uA756\uA758\u024A]/g
    },
    {
        "base": "R",
        "letters": /[\u0052\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782]/g
    },
    {
        "base": "S",
        "letters": /[\u0053\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784]/g
    },
    {
        "base": "T",
        "letters": /[\u0054\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786]/g
    },
    {
        "base": "TZ",
        "letters": /[\uA728]/g
    },
    {
        "base": "U",
        "letters": /[\u0055\u24CA\uFF35\u00D9\u00DA\u00DB\u0168\u1E78\u016A\u1E7A\u016C\u00DC\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244]/g
    },
    {
        "base": "V",
        "letters": /[\u0056\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245]/g
    },
    {
        "base": "VY",
        "letters": /[\uA760]/g
    },
    {
        "base": "W",
        "letters": /[\u0057\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72]/g
    },
    {
        "base": "X",
        "letters": /[\u0058\u24CD\uFF38\u1E8A\u1E8C]/g
    },
    {
        "base": "Y",
        "letters": /[\u0059\u24CE\uFF39\u1EF2\u00DD\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE]/g
    },
    {
        "base": "Z",
        "letters": /[\u005A\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762]/g
    },
    {
        "base": "a",
        "letters": /[\u0061\u24D0\uFF41\u1E9A\u00E0\u00E1\u00E2\u1EA7\u1EA5\u1EAB\u1EA9\u00E3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\u00E4\u01DF\u1EA3\u00E5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250]/g
    },
    {
        "base": "aa",
        "letters": /[\uA733]/g
    },
    {
        "base": "ae",
        "letters": /[\u00E6\u01FD\u01E3]/g
    },
    {
        "base": "ao",
        "letters": /[\uA735]/g
    },
    {
        "base": "au",
        "letters": /[\uA737]/g
    },
    {
        "base": "av",
        "letters": /[\uA739\uA73B]/g
    },
    {
        "base": "ay",
        "letters": /[\uA73D]/g
    },
    {
        "base": "b",
        "letters": /[\u0062\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253]/g
    },
    {
        "base": "c",
        "letters": /[\u0063\u24D2\uFF43\u0107\u0109\u010B\u010D\u00E7\u1E09\u0188\u023C\uA73F\u2184]/g
    },
    {
        "base": "d",
        "letters": /[\u0064\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\uA77A]/g
    },
    {
        "base": "dz",
        "letters": /[\u01F3\u01C6]/g
    },
    {
        "base": "e",
        "letters": /[\u0065\u24D4\uFF45\u00E8\u00E9\u00EA\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\u00EB\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u025B\u01DD]/g
    },
    {
        "base": "f",
        "letters": /[\u0066\u24D5\uFF46\u1E1F\u0192\uA77C]/g
    },
    {
        "base": "g",
        "letters": /[\u0067\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\u1D79\uA77F]/g
    },
    {
        "base": "h",
        "letters": /[\u0068\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265]/g
    },
    {
        "base": "hv",
        "letters": /[\u0195]/g
    },
    {
        "base": "i",
        "letters": /[\u0069\u24D8\uFF49\u00EC\u00ED\u00EE\u0129\u012B\u012D\u00EF\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131]/g
    },
    {
        "base": "j",
        "letters": /[\u006A\u24D9\uFF4A\u0135\u01F0\u0249]/g
    },
    {
        "base": "k",
        "letters": /[\u006B\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3]/g
    },
    {
        "base": "l",
        "letters": /[\u006C\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747]/g
    },
    {
        "base": "lj",
        "letters": /[\u01C9]/g
    },
    {
        "base": "m",
        "letters": /[\u006D\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F]/g
    },
    {
        "base": "n",
        "letters": /[\u006E\u24DD\uFF4E\u01F9\u0144\u00F1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5]/g
    },
    {
        "base": "nj",
        "letters": /[\u01CC]/g
    },
    {
        "base": "o",
        "letters": /[\u006F\u24DE\uFF4F\u00F2\u00F3\u00F4\u1ED3\u1ED1\u1ED7\u1ED5\u00F5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\u00F6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\u00F8\u01FF\u0254\uA74B\uA74D\u0275]/g
    },
    {
        "base": "oi",
        "letters": /[\u01A3]/g
    },
    {
        "base": "ou",
        "letters": /[\u0223]/g
    },
    {
        "base": "oo",
        "letters": /[\uA74F]/g
    },
    {
        "base": "p",
        "letters": /[\u0070\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755]/g
    },
    {
        "base": "q",
        "letters": /[\u0071\u24E0\uFF51\u024B\uA757\uA759]/g
    },
    {
        "base": "r",
        "letters": /[\u0072\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783]/g
    },
    {
        "base": "s",
        "letters": /[\u0073\u24E2\uFF53\u00DF\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B]/g
    },
    {
        "base": "t",
        "letters": /[\u0074\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787]/g
    },
    {
        "base": "tz",
        "letters": /[\uA729]/g
    },
    {
        "base": "u",
        "letters": /[\u0075\u24E4\uFF55\u00F9\u00FA\u00FB\u0169\u1E79\u016B\u1E7B\u016D\u00FC\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289]/g
    },
    {
        "base": "v",
        "letters": /[\u0076\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C]/g
    },
    {
        "base": "vy",
        "letters": /[\uA761]/g
    },
    {
        "base": "w",
        "letters": /[\u0077\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73]/g
    },
    {
        "base": "x",
        "letters": /[\u0078\u24E7\uFF58\u1E8B\u1E8D]/g
    },
    {
        "base": "y",
        "letters": /[\u0079\u24E8\uFF59\u1EF3\u00FD\u0177\u1EF9\u0233\u1E8F\u00FF\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF]/g
    },
    {
        "base": "z",
        "letters": /[\u007A\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763]/g
    }
];
var stripDiacritics = function stripDiacritics(str) {
    for(var i = 0; i < map.length; i++)str = str.replace(map[i].letters, map[i].base);
    return str;
};
var trim = function trim(str) {
    return str.replace(/^\s+|\s+$/g, "");
};
var isValid = function isValid(value) {
    return typeof value !== "undefined" && value !== null && value !== "";
};
var filterOptions = function filterOptions(options, filterValue, excludeOptions, props) {
    if (props.ignoreAccents) filterValue = stripDiacritics(filterValue);
    if (props.ignoreCase) filterValue = filterValue.toLowerCase();
    if (props.trimFilter) filterValue = trim(filterValue);
    if (excludeOptions) excludeOptions = excludeOptions.map(function(i) {
        return i[props.valueKey];
    });
    return options.filter(function(option) {
        if (excludeOptions && excludeOptions.indexOf(option[props.valueKey]) > -1) return false;
        if (props.filterOption) return props.filterOption.call(undefined, option, filterValue);
        if (!filterValue) return true;
        var value = option[props.valueKey];
        var label = option[props.labelKey];
        var hasValue = isValid(value);
        var hasLabel = isValid(label);
        if (!hasValue && !hasLabel) return false;
        var valueTest = hasValue ? String(value) : null;
        var labelTest = hasLabel ? String(label) : null;
        if (props.ignoreAccents) {
            if (valueTest && props.matchProp !== "label") valueTest = stripDiacritics(valueTest);
            if (labelTest && props.matchProp !== "value") labelTest = stripDiacritics(labelTest);
        }
        if (props.ignoreCase) {
            if (valueTest && props.matchProp !== "label") valueTest = valueTest.toLowerCase();
            if (labelTest && props.matchProp !== "value") labelTest = labelTest.toLowerCase();
        }
        return props.matchPos === "start" ? valueTest && props.matchProp !== "label" && valueTest.substr(0, filterValue.length) === filterValue || labelTest && props.matchProp !== "value" && labelTest.substr(0, filterValue.length) === filterValue : valueTest && props.matchProp !== "label" && valueTest.indexOf(filterValue) >= 0 || labelTest && props.matchProp !== "value" && labelTest.indexOf(filterValue) >= 0;
    });
};
var menuRenderer = function menuRenderer(_ref) {
    var focusedOption = _ref.focusedOption, focusOption = _ref.focusOption, inputValue = _ref.inputValue, instancePrefix = _ref.instancePrefix, onFocus = _ref.onFocus, onOptionRef = _ref.onOptionRef, onSelect = _ref.onSelect, optionClassName = _ref.optionClassName, optionComponent = _ref.optionComponent, optionRenderer = _ref.optionRenderer, options = _ref.options, removeValue = _ref.removeValue, selectValue = _ref.selectValue, valueArray = _ref.valueArray, valueKey = _ref.valueKey;
    var Option = optionComponent;
    return options.map(function(option, i) {
        var isSelected = valueArray && valueArray.some(function(x) {
            return x[valueKey] === option[valueKey];
        });
        var isFocused = option === focusedOption;
        var optionClass = (0, _classnamesDefault.default)(optionClassName, {
            "Select-option": true,
            "is-selected": isSelected,
            "is-focused": isFocused,
            "is-disabled": option.disabled
        });
        return (0, _reactDefault.default).createElement(Option, {
            className: optionClass,
            focusOption: focusOption,
            inputValue: inputValue,
            instancePrefix: instancePrefix,
            isDisabled: option.disabled,
            isFocused: isFocused,
            isSelected: isSelected,
            key: "option-" + i + "-" + option[valueKey],
            onFocus: onFocus,
            onSelect: onSelect,
            option: option,
            optionIndex: i,
            ref: function ref(_ref2) {
                onOptionRef(_ref2, isFocused);
            },
            removeValue: removeValue,
            selectValue: selectValue
        }, optionRenderer(option, i, inputValue));
    });
};
menuRenderer.propTypes = {
    focusOption: (0, _propTypesDefault.default).func,
    focusedOption: (0, _propTypesDefault.default).object,
    inputValue: (0, _propTypesDefault.default).string,
    instancePrefix: (0, _propTypesDefault.default).string,
    onFocus: (0, _propTypesDefault.default).func,
    onOptionRef: (0, _propTypesDefault.default).func,
    onSelect: (0, _propTypesDefault.default).func,
    optionClassName: (0, _propTypesDefault.default).string,
    optionComponent: (0, _propTypesDefault.default).func,
    optionRenderer: (0, _propTypesDefault.default).func,
    options: (0, _propTypesDefault.default).array,
    removeValue: (0, _propTypesDefault.default).func,
    selectValue: (0, _propTypesDefault.default).func,
    valueArray: (0, _propTypesDefault.default).array,
    valueKey: (0, _propTypesDefault.default).string
};
var blockEvent = function(event) {
    event.preventDefault();
    event.stopPropagation();
    if (event.target.tagName !== "A" || !("href" in event.target)) return;
    if (event.target.target) window.open(event.target.href, event.target.target);
    else window.location.href = event.target.href;
};
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
    return typeof obj;
} : function(obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};
var asyncGenerator = function() {
    function AwaitValue(value) {
        this.value = value;
    }
    function AsyncGenerator(gen) {
        var front, back;
        function send(key, arg) {
            return new Promise(function(resolve, reject) {
                var request = {
                    key: key,
                    arg: arg,
                    resolve: resolve,
                    reject: reject,
                    next: null
                };
                if (back) back = back.next = request;
                else {
                    front = back = request;
                    resume(key, arg);
                }
            });
        }
        function resume(key, arg) {
            try {
                var result = gen[key](arg);
                var value = result.value;
                if (value instanceof AwaitValue) Promise.resolve(value.value).then(function(arg) {
                    resume("next", arg);
                }, function(arg) {
                    resume("throw", arg);
                });
                else settle(result.done ? "return" : "normal", result.value);
            } catch (err) {
                settle("throw", err);
            }
        }
        function settle(type, value) {
            switch(type){
                case "return":
                    front.resolve({
                        value: value,
                        done: true
                    });
                    break;
                case "throw":
                    front.reject(value);
                    break;
                default:
                    front.resolve({
                        value: value,
                        done: false
                    });
                    break;
            }
            front = front.next;
            if (front) resume(front.key, front.arg);
            else back = null;
        }
        this._invoke = send;
        if (typeof gen.return !== "function") this.return = undefined;
    }
    if (typeof Symbol === "function" && Symbol.asyncIterator) AsyncGenerator.prototype[Symbol.asyncIterator] = function() {
        return this;
    };
    AsyncGenerator.prototype.next = function(arg) {
        return this._invoke("next", arg);
    };
    AsyncGenerator.prototype.throw = function(arg) {
        return this._invoke("throw", arg);
    };
    AsyncGenerator.prototype.return = function(arg) {
        return this._invoke("return", arg);
    };
    return {
        wrap: function(fn) {
            return function() {
                return new AsyncGenerator(fn.apply(this, arguments));
            };
        },
        await: function(value) {
            return new AwaitValue(value);
        }
    };
}();
var classCallCheck = function(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
};
var createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
var defineProperty = function(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
};
var _extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var inherits = function(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};
var objectWithoutProperties = function(obj, keys) {
    var target = {};
    for(var i in obj){
        if (keys.indexOf(i) >= 0) continue;
        if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
        target[i] = obj[i];
    }
    return target;
};
var possibleConstructorReturn = function(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
};
var Option = function(_React$Component) {
    inherits(Option, _React$Component);
    function Option(props) {
        classCallCheck(this, Option);
        var _this = possibleConstructorReturn(this, (Option.__proto__ || Object.getPrototypeOf(Option)).call(this, props));
        _this.handleMouseDown = _this.handleMouseDown.bind(_this);
        _this.handleMouseEnter = _this.handleMouseEnter.bind(_this);
        _this.handleMouseMove = _this.handleMouseMove.bind(_this);
        _this.handleTouchStart = _this.handleTouchStart.bind(_this);
        _this.handleTouchEnd = _this.handleTouchEnd.bind(_this);
        _this.handleTouchMove = _this.handleTouchMove.bind(_this);
        _this.onFocus = _this.onFocus.bind(_this);
        return _this;
    }
    createClass(Option, [
        {
            key: "handleMouseDown",
            value: function handleMouseDown(event) {
                event.preventDefault();
                event.stopPropagation();
                this.props.onSelect(this.props.option, event);
            }
        },
        {
            key: "handleMouseEnter",
            value: function handleMouseEnter(event) {
                this.onFocus(event);
            }
        },
        {
            key: "handleMouseMove",
            value: function handleMouseMove(event) {
                this.onFocus(event);
            }
        },
        {
            key: "handleTouchEnd",
            value: function handleTouchEnd(event) {
                // Check if the view is being dragged, In this case
                // we don't want to fire the click event (because the user only wants to scroll)
                if (this.dragging) return;
                this.handleMouseDown(event);
            }
        },
        {
            key: "handleTouchMove",
            value: function handleTouchMove() {
                // Set a flag that the view is being dragged
                this.dragging = true;
            }
        },
        {
            key: "handleTouchStart",
            value: function handleTouchStart() {
                // Set a flag that the view is not being dragged
                this.dragging = false;
            }
        },
        {
            key: "onFocus",
            value: function onFocus(event) {
                if (!this.props.isFocused) this.props.onFocus(this.props.option, event);
            }
        },
        {
            key: "render",
            value: function render() {
                var _props = this.props, option = _props.option, instancePrefix = _props.instancePrefix, optionIndex = _props.optionIndex;
                var className = (0, _classnamesDefault.default)(this.props.className, option.className);
                return option.disabled ? (0, _reactDefault.default).createElement("div", {
                    className: className,
                    onMouseDown: blockEvent,
                    onClick: blockEvent
                }, this.props.children) : (0, _reactDefault.default).createElement("div", {
                    className: className,
                    style: option.style,
                    role: "option",
                    "aria-label": option.label,
                    onMouseDown: this.handleMouseDown,
                    onMouseEnter: this.handleMouseEnter,
                    onMouseMove: this.handleMouseMove,
                    onTouchStart: this.handleTouchStart,
                    onTouchMove: this.handleTouchMove,
                    onTouchEnd: this.handleTouchEnd,
                    id: instancePrefix + "-option-" + optionIndex,
                    title: option.title
                }, this.props.children);
            }
        }
    ]);
    return Option;
}((0, _reactDefault.default).Component);
Option.propTypes = {
    children: (0, _propTypesDefault.default).node,
    className: (0, _propTypesDefault.default).string,
    instancePrefix: (0, _propTypesDefault.default).string.isRequired,
    isDisabled: (0, _propTypesDefault.default).bool,
    isFocused: (0, _propTypesDefault.default).bool,
    isSelected: (0, _propTypesDefault.default).bool,
    onFocus: (0, _propTypesDefault.default).func,
    onSelect: (0, _propTypesDefault.default).func,
    onUnfocus: (0, _propTypesDefault.default).func,
    option: (0, _propTypesDefault.default).object.isRequired,
    optionIndex: (0, _propTypesDefault.default).number // index of the option, used to generate unique ids for aria
};
var Value = function(_React$Component) {
    inherits(Value, _React$Component);
    function Value(props) {
        classCallCheck(this, Value);
        var _this = possibleConstructorReturn(this, (Value.__proto__ || Object.getPrototypeOf(Value)).call(this, props));
        _this.handleMouseDown = _this.handleMouseDown.bind(_this);
        _this.onRemove = _this.onRemove.bind(_this);
        _this.handleTouchEndRemove = _this.handleTouchEndRemove.bind(_this);
        _this.handleTouchMove = _this.handleTouchMove.bind(_this);
        _this.handleTouchStart = _this.handleTouchStart.bind(_this);
        return _this;
    }
    createClass(Value, [
        {
            key: "handleMouseDown",
            value: function handleMouseDown(event) {
                if (event.type === "mousedown" && event.button !== 0) return;
                if (this.props.onClick) {
                    event.stopPropagation();
                    this.props.onClick(this.props.value, event);
                    return;
                }
                if (this.props.value.href) event.stopPropagation();
            }
        },
        {
            key: "onRemove",
            value: function onRemove(event) {
                event.preventDefault();
                event.stopPropagation();
                this.props.onRemove(this.props.value);
            }
        },
        {
            key: "handleTouchEndRemove",
            value: function handleTouchEndRemove(event) {
                // Check if the view is being dragged, In this case
                // we don't want to fire the click event (because the user only wants to scroll)
                if (this.dragging) return;
                // Fire the mouse events
                this.onRemove(event);
            }
        },
        {
            key: "handleTouchMove",
            value: function handleTouchMove() {
                // Set a flag that the view is being dragged
                this.dragging = true;
            }
        },
        {
            key: "handleTouchStart",
            value: function handleTouchStart() {
                // Set a flag that the view is not being dragged
                this.dragging = false;
            }
        },
        {
            key: "renderRemoveIcon",
            value: function renderRemoveIcon() {
                if (this.props.disabled || !this.props.onRemove) return;
                return (0, _reactDefault.default).createElement("span", {
                    className: "Select-value-icon",
                    "aria-hidden": "true",
                    onMouseDown: this.onRemove,
                    onTouchEnd: this.handleTouchEndRemove,
                    onTouchStart: this.handleTouchStart,
                    onTouchMove: this.handleTouchMove
                }, "\xd7");
            }
        },
        {
            key: "renderLabel",
            value: function renderLabel() {
                var className = "Select-value-label";
                return this.props.onClick || this.props.value.href ? (0, _reactDefault.default).createElement("a", {
                    className: className,
                    href: this.props.value.href,
                    target: this.props.value.target,
                    onMouseDown: this.handleMouseDown,
                    onTouchEnd: this.handleMouseDown
                }, this.props.children) : (0, _reactDefault.default).createElement("span", {
                    className: className,
                    role: "option",
                    "aria-selected": "true",
                    id: this.props.id
                }, this.props.children);
            }
        },
        {
            key: "render",
            value: function render() {
                return (0, _reactDefault.default).createElement("div", {
                    className: (0, _classnamesDefault.default)("Select-value", this.props.value.disabled ? "Select-value-disabled" : "", this.props.value.className),
                    style: this.props.value.style,
                    title: this.props.value.title
                }, this.renderRemoveIcon(), this.renderLabel());
            }
        }
    ]);
    return Value;
}((0, _reactDefault.default).Component);
Value.propTypes = {
    children: (0, _propTypesDefault.default).node,
    disabled: (0, _propTypesDefault.default).bool,
    id: (0, _propTypesDefault.default).string,
    onClick: (0, _propTypesDefault.default).func,
    onRemove: (0, _propTypesDefault.default).func,
    value: (0, _propTypesDefault.default).object.isRequired // the option object for this value
};
/*!
  Copyright (c) 2018 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/react-select
*/ var stringifyValue = function stringifyValue(value) {
    return typeof value === "string" ? value : value !== null && JSON.stringify(value) || "";
};
var stringOrNode = (0, _propTypesDefault.default).oneOfType([
    (0, _propTypesDefault.default).string,
    (0, _propTypesDefault.default).node
]);
var stringOrNumber = (0, _propTypesDefault.default).oneOfType([
    (0, _propTypesDefault.default).string,
    (0, _propTypesDefault.default).number
]);
var instanceId = 1;
var shouldShowValue = function shouldShowValue(state, props) {
    var inputValue = state.inputValue, isPseudoFocused = state.isPseudoFocused, isFocused = state.isFocused;
    var onSelectResetsInput = props.onSelectResetsInput;
    if (!inputValue) return true;
    if (!onSelectResetsInput) return !(!isFocused && isPseudoFocused || isFocused && !isPseudoFocused);
    return false;
};
var shouldShowPlaceholder = function shouldShowPlaceholder(state, props, isOpen) {
    var inputValue = state.inputValue, isPseudoFocused = state.isPseudoFocused, isFocused = state.isFocused;
    var onSelectResetsInput = props.onSelectResetsInput;
    return !inputValue || !onSelectResetsInput && !isOpen && !isPseudoFocused && !isFocused;
};
/**
 * Retrieve a value from the given options and valueKey
 * @param {String|Number|Array} value	- the selected value(s)
 * @param {Object}		 props	- the Select component's props (or nextProps)
 */ var expandValue = function expandValue(value, props) {
    var valueType = typeof value === "undefined" ? "undefined" : _typeof(value);
    if (valueType !== "string" && valueType !== "number" && valueType !== "boolean") return value;
    var options = props.options, valueKey = props.valueKey;
    if (!options) return;
    for(var i = 0; i < options.length; i++){
        if (String(options[i][valueKey]) === String(value)) return options[i];
    }
};
var handleRequired = function handleRequired(value, multi) {
    if (!value) return true;
    return multi ? value.length === 0 : Object.keys(value).length === 0;
};
var Select$1 = function(_React$Component) {
    inherits(Select, _React$Component);
    function Select(props) {
        classCallCheck(this, Select);
        var _this = possibleConstructorReturn(this, (Select.__proto__ || Object.getPrototypeOf(Select)).call(this, props));
        [
            "clearValue",
            "focusOption",
            "getOptionLabel",
            "handleInputBlur",
            "handleInputChange",
            "handleInputFocus",
            "handleInputValueChange",
            "handleKeyDown",
            "handleMenuScroll",
            "handleMouseDown",
            "handleMouseDownOnArrow",
            "handleMouseDownOnMenu",
            "handleTouchEnd",
            "handleTouchEndClearValue",
            "handleTouchMove",
            "handleTouchOutside",
            "handleTouchStart",
            "handleValueClick",
            "onOptionRef",
            "removeValue",
            "selectValue"
        ].forEach(function(fn) {
            return _this[fn] = _this[fn].bind(_this);
        });
        _this.state = {
            inputValue: "",
            isFocused: false,
            isOpen: false,
            isPseudoFocused: false,
            required: false
        };
        return _this;
    }
    createClass(Select, [
        {
            key: "componentWillMount",
            value: function componentWillMount() {
                this._instancePrefix = "react-select-" + (this.props.instanceId || ++instanceId) + "-";
                var valueArray = this.getValueArray(this.props.value);
                if (this.props.required) this.setState({
                    required: handleRequired(valueArray[0], this.props.multi)
                });
            }
        },
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                if (typeof this.props.autofocus !== "undefined" && typeof console !== "undefined") console.warn("Warning: The autofocus prop has changed to autoFocus, support will be removed after react-select@1.0");
                if (this.props.autoFocus || this.props.autofocus) this.focus();
            }
        },
        {
            key: "componentWillReceiveProps",
            value: function componentWillReceiveProps(nextProps) {
                var valueArray = this.getValueArray(nextProps.value, nextProps);
                if (nextProps.required) this.setState({
                    required: handleRequired(valueArray[0], nextProps.multi)
                });
                else if (this.props.required) // Used to be required but it's not any more
                this.setState({
                    required: false
                });
                if (this.state.inputValue && this.props.value !== nextProps.value && nextProps.onSelectResetsInput) this.setState({
                    inputValue: this.handleInputValueChange("")
                });
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps, prevState) {
                // focus to the selected option
                if (this.menu && this.focused && this.state.isOpen && !this.hasScrolledToOption) {
                    var focusedOptionNode = (0, _reactDom.findDOMNode)(this.focused);
                    var menuNode = (0, _reactDom.findDOMNode)(this.menu);
                    var scrollTop = menuNode.scrollTop;
                    var scrollBottom = scrollTop + menuNode.offsetHeight;
                    var optionTop = focusedOptionNode.offsetTop;
                    var optionBottom = optionTop + focusedOptionNode.offsetHeight;
                    if (scrollTop > optionTop || scrollBottom < optionBottom) menuNode.scrollTop = focusedOptionNode.offsetTop;
                    // We still set hasScrolledToOption to true even if we didn't
                    // actually need to scroll, as we've still confirmed that the
                    // option is in view.
                    this.hasScrolledToOption = true;
                } else if (!this.state.isOpen) this.hasScrolledToOption = false;
                if (this._scrollToFocusedOptionOnUpdate && this.focused && this.menu) {
                    this._scrollToFocusedOptionOnUpdate = false;
                    var focusedDOM = (0, _reactDom.findDOMNode)(this.focused);
                    var menuDOM = (0, _reactDom.findDOMNode)(this.menu);
                    var focusedRect = focusedDOM.getBoundingClientRect();
                    var menuRect = menuDOM.getBoundingClientRect();
                    if (focusedRect.bottom > menuRect.bottom) menuDOM.scrollTop = focusedDOM.offsetTop + focusedDOM.clientHeight - menuDOM.offsetHeight;
                    else if (focusedRect.top < menuRect.top) menuDOM.scrollTop = focusedDOM.offsetTop;
                }
                if (this.props.scrollMenuIntoView && this.menuContainer) {
                    var menuContainerRect = this.menuContainer.getBoundingClientRect();
                    if (window.innerHeight < menuContainerRect.bottom + this.props.menuBuffer) window.scrollBy(0, menuContainerRect.bottom + this.props.menuBuffer - window.innerHeight);
                }
                if (prevProps.disabled !== this.props.disabled) {
                    this.setState({
                        isFocused: false
                    }); // eslint-disable-line react/no-did-update-set-state
                    this.closeMenu();
                }
                if (prevState.isOpen !== this.state.isOpen) {
                    this.toggleTouchOutsideEvent(this.state.isOpen);
                    var handler = this.state.isOpen ? this.props.onOpen : this.props.onClose;
                    handler && handler();
                }
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this.toggleTouchOutsideEvent(false);
            }
        },
        {
            key: "toggleTouchOutsideEvent",
            value: function toggleTouchOutsideEvent(enabled) {
                var eventTogglerName = enabled ? document.addEventListener ? "addEventListener" : "attachEvent" : document.removeEventListener ? "removeEventListener" : "detachEvent";
                var pref = document.addEventListener ? "" : "on";
                document[eventTogglerName](pref + "touchstart", this.handleTouchOutside);
                document[eventTogglerName](pref + "mousedown", this.handleTouchOutside);
            }
        },
        {
            key: "handleTouchOutside",
            value: function handleTouchOutside(event) {
                // handle touch outside on ios to dismiss menu
                if (this.wrapper && !this.wrapper.contains(event.target)) this.closeMenu();
            }
        },
        {
            key: "focus",
            value: function focus() {
                if (!this.input) return;
                this.input.focus();
            }
        },
        {
            key: "blurInput",
            value: function blurInput() {
                if (!this.input) return;
                this.input.blur();
            }
        },
        {
            key: "handleTouchMove",
            value: function handleTouchMove() {
                // Set a flag that the view is being dragged
                this.dragging = true;
            }
        },
        {
            key: "handleTouchStart",
            value: function handleTouchStart() {
                // Set a flag that the view is not being dragged
                this.dragging = false;
            }
        },
        {
            key: "handleTouchEnd",
            value: function handleTouchEnd(event) {
                // Check if the view is being dragged, In this case
                // we don't want to fire the click event (because the user only wants to scroll)
                if (this.dragging) return;
                // Fire the mouse events
                this.handleMouseDown(event);
            }
        },
        {
            key: "handleTouchEndClearValue",
            value: function handleTouchEndClearValue(event) {
                // Check if the view is being dragged, In this case
                // we don't want to fire the click event (because the user only wants to scroll)
                if (this.dragging) return;
                // Clear the value
                this.clearValue(event);
            }
        },
        {
            key: "handleMouseDown",
            value: function handleMouseDown(event) {
                // if the event was triggered by a mousedown and not the primary
                // button, or if the component is disabled, ignore it.
                if (this.props.disabled || event.type === "mousedown" && event.button !== 0) return;
                if (event.target.tagName === "INPUT") {
                    if (!this.state.isFocused) {
                        this._openAfterFocus = this.props.openOnClick;
                        this.focus();
                    } else if (!this.state.isOpen) this.setState({
                        isOpen: true,
                        isPseudoFocused: false,
                        focusedOption: null
                    });
                    return;
                }
                // prevent default event handlers
                event.preventDefault();
                // for the non-searchable select, toggle the menu
                if (!this.props.searchable) {
                    // This code means that if a select is searchable, onClick the options menu will not appear, only on subsequent click will it open.
                    this.focus();
                    return this.setState({
                        isOpen: !this.state.isOpen,
                        focusedOption: null
                    });
                }
                if (this.state.isFocused) {
                    // On iOS, we can get into a state where we think the input is focused but it isn't really,
                    // since iOS ignores programmatic calls to input.focus() that weren't triggered by a click event.
                    // Call focus() again here to be safe.
                    this.focus();
                    var input = this.input;
                    var toOpen = true;
                    if (typeof input.getInput === "function") // Get the actual DOM input if the ref is an <AutosizeInput /> component
                    input = input.getInput();
                    // clears the value so that the cursor will be at the end of input when the component re-renders
                    input.value = "";
                    if (this._focusAfterClear) {
                        toOpen = false;
                        this._focusAfterClear = false;
                    }
                    // if the input is focused, ensure the menu is open
                    this.setState({
                        isOpen: toOpen,
                        isPseudoFocused: false,
                        focusedOption: null
                    });
                } else {
                    // otherwise, focus the input and open the menu
                    this._openAfterFocus = this.props.openOnClick;
                    this.focus();
                    this.setState({
                        focusedOption: null
                    });
                }
            }
        },
        {
            key: "handleMouseDownOnArrow",
            value: function handleMouseDownOnArrow(event) {
                // if the event was triggered by a mousedown and not the primary
                // button, or if the component is disabled, ignore it.
                if (this.props.disabled || event.type === "mousedown" && event.button !== 0) return;
                if (this.state.isOpen) {
                    // prevent default event handlers
                    event.stopPropagation();
                    event.preventDefault();
                    // close the menu
                    this.closeMenu();
                } else // If the menu isn't open, let the event bubble to the main handleMouseDown
                this.setState({
                    isOpen: true
                });
            }
        },
        {
            key: "handleMouseDownOnMenu",
            value: function handleMouseDownOnMenu(event) {
                // if the event was triggered by a mousedown and not the primary
                // button, or if the component is disabled, ignore it.
                if (this.props.disabled || event.type === "mousedown" && event.button !== 0) return;
                event.stopPropagation();
                event.preventDefault();
                this._openAfterFocus = true;
                this.focus();
            }
        },
        {
            key: "closeMenu",
            value: function closeMenu() {
                if (this.props.onCloseResetsInput) this.setState({
                    inputValue: this.handleInputValueChange(""),
                    isOpen: false,
                    isPseudoFocused: this.state.isFocused && !this.props.multi
                });
                else this.setState({
                    isOpen: false,
                    isPseudoFocused: this.state.isFocused && !this.props.multi
                });
                this.hasScrolledToOption = false;
            }
        },
        {
            key: "handleInputFocus",
            value: function handleInputFocus(event) {
                if (this.props.disabled) return;
                var toOpen = this.state.isOpen || this._openAfterFocus || this.props.openOnFocus;
                toOpen = this._focusAfterClear ? false : toOpen; //if focus happens after clear values, don't open dropdown yet.
                if (this.props.onFocus) this.props.onFocus(event);
                this.setState({
                    isFocused: true,
                    isOpen: !!toOpen
                });
                this._focusAfterClear = false;
                this._openAfterFocus = false;
            }
        },
        {
            key: "handleInputBlur",
            value: function handleInputBlur(event) {
                // The check for menu.contains(activeElement) is necessary to prevent IE11's scrollbar from closing the menu in certain contexts.
                if (this.menu && (this.menu === document.activeElement || this.menu.contains(document.activeElement))) {
                    this.focus();
                    return;
                }
                if (this.props.onBlur) this.props.onBlur(event);
                var onBlurredState = {
                    isFocused: false,
                    isOpen: false,
                    isPseudoFocused: false
                };
                if (this.props.onBlurResetsInput) onBlurredState.inputValue = this.handleInputValueChange("");
                this.setState(onBlurredState);
            }
        },
        {
            key: "handleInputChange",
            value: function handleInputChange(event) {
                var newInputValue = event.target.value;
                if (this.state.inputValue !== event.target.value) newInputValue = this.handleInputValueChange(newInputValue);
                this.setState({
                    inputValue: newInputValue,
                    isOpen: true,
                    isPseudoFocused: false
                });
            }
        },
        {
            key: "setInputValue",
            value: function setInputValue(newValue) {
                if (this.props.onInputChange) {
                    var nextState = this.props.onInputChange(newValue);
                    if (nextState != null && (typeof nextState === "undefined" ? "undefined" : _typeof(nextState)) !== "object") newValue = "" + nextState;
                }
                this.setState({
                    inputValue: newValue
                });
            }
        },
        {
            key: "handleInputValueChange",
            value: function handleInputValueChange(newValue) {
                if (this.props.onInputChange) {
                    var nextState = this.props.onInputChange(newValue);
                    // Note: != used deliberately here to catch undefined and null
                    if (nextState != null && (typeof nextState === "undefined" ? "undefined" : _typeof(nextState)) !== "object") newValue = "" + nextState;
                }
                return newValue;
            }
        },
        {
            key: "handleKeyDown",
            value: function handleKeyDown(event) {
                if (this.props.disabled) return;
                if (typeof this.props.onInputKeyDown === "function") {
                    this.props.onInputKeyDown(event);
                    if (event.defaultPrevented) return;
                }
                switch(event.keyCode){
                    case 8:
                        // backspace
                        if (!this.state.inputValue && this.props.backspaceRemoves) {
                            event.preventDefault();
                            this.popValue();
                        }
                        break;
                    case 9:
                        // tab
                        if (event.shiftKey || !this.state.isOpen || !this.props.tabSelectsValue) break;
                        event.preventDefault();
                        this.selectFocusedOption();
                        break;
                    case 13:
                        // enter
                        event.preventDefault();
                        event.stopPropagation();
                        if (this.state.isOpen) this.selectFocusedOption();
                        else this.focusNextOption();
                        break;
                    case 27:
                        // escape
                        event.preventDefault();
                        if (this.state.isOpen) {
                            this.closeMenu();
                            event.stopPropagation();
                        } else if (this.props.clearable && this.props.escapeClearsValue) {
                            this.clearValue(event);
                            event.stopPropagation();
                        }
                        break;
                    case 32:
                        // space
                        if (this.props.searchable) break;
                        event.preventDefault();
                        if (!this.state.isOpen) {
                            this.focusNextOption();
                            break;
                        }
                        event.stopPropagation();
                        this.selectFocusedOption();
                        break;
                    case 38:
                        // up
                        event.preventDefault();
                        this.focusPreviousOption();
                        break;
                    case 40:
                        // down
                        event.preventDefault();
                        this.focusNextOption();
                        break;
                    case 33:
                        // page up
                        event.preventDefault();
                        this.focusPageUpOption();
                        break;
                    case 34:
                        // page down
                        event.preventDefault();
                        this.focusPageDownOption();
                        break;
                    case 35:
                        // end key
                        if (event.shiftKey) break;
                        event.preventDefault();
                        this.focusEndOption();
                        break;
                    case 36:
                        // home key
                        if (event.shiftKey) break;
                        event.preventDefault();
                        this.focusStartOption();
                        break;
                    case 46:
                        // delete
                        if (!this.state.inputValue && this.props.deleteRemoves) {
                            event.preventDefault();
                            this.popValue();
                        }
                        break;
                }
            }
        },
        {
            key: "handleValueClick",
            value: function handleValueClick(option, event) {
                if (!this.props.onValueClick) return;
                this.props.onValueClick(option, event);
            }
        },
        {
            key: "handleMenuScroll",
            value: function handleMenuScroll(event) {
                if (!this.props.onMenuScrollToBottom) return;
                var target = event.target;
                if (target.scrollHeight > target.offsetHeight && target.scrollHeight - target.offsetHeight - target.scrollTop <= 0) this.props.onMenuScrollToBottom();
            }
        },
        {
            key: "getOptionLabel",
            value: function getOptionLabel(op) {
                return op[this.props.labelKey];
            }
        },
        {
            key: "getValueArray",
            value: function getValueArray(value) {
                var nextProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                /** support optionally passing in the `nextProps` so `componentWillReceiveProps` updates will function as expected */ var props = (typeof nextProps === "undefined" ? "undefined" : _typeof(nextProps)) === "object" ? nextProps : this.props;
                if (props.multi) {
                    if (typeof value === "string") value = value.split(props.delimiter);
                    if (!Array.isArray(value)) {
                        if (value === null || value === undefined) return [];
                        value = [
                            value
                        ];
                    }
                    return value.map(function(value) {
                        return expandValue(value, props);
                    }).filter(function(i) {
                        return i;
                    });
                }
                var expandedValue = expandValue(value, props);
                return expandedValue ? [
                    expandedValue
                ] : [];
            }
        },
        {
            key: "setValue",
            value: function setValue(value) {
                var _this2 = this;
                if (this.props.autoBlur) this.blurInput();
                if (this.props.required) {
                    var required = handleRequired(value, this.props.multi);
                    this.setState({
                        required: required
                    });
                }
                if (this.props.simpleValue && value) value = this.props.multi ? value.map(function(i) {
                    return i[_this2.props.valueKey];
                }).join(this.props.delimiter) : value[this.props.valueKey];
                if (this.props.onChange) this.props.onChange(value);
            }
        },
        {
            key: "selectValue",
            value: function selectValue(value) {
                var _this3 = this;
                // NOTE: we actually add/set the value in a callback to make sure the
                // input value is empty to avoid styling issues in Chrome
                if (this.props.closeOnSelect) this.hasScrolledToOption = false;
                var updatedValue = this.props.onSelectResetsInput ? "" : this.state.inputValue;
                if (this.props.multi) this.setState({
                    focusedIndex: null,
                    inputValue: this.handleInputValueChange(updatedValue),
                    isOpen: !this.props.closeOnSelect
                }, function() {
                    var valueArray = _this3.getValueArray(_this3.props.value);
                    if (valueArray.some(function(i) {
                        return i[_this3.props.valueKey] === value[_this3.props.valueKey];
                    })) _this3.removeValue(value);
                    else _this3.addValue(value);
                });
                else this.setState({
                    inputValue: this.handleInputValueChange(updatedValue),
                    isOpen: !this.props.closeOnSelect,
                    isPseudoFocused: this.state.isFocused
                }, function() {
                    _this3.setValue(value);
                });
            }
        },
        {
            key: "addValue",
            value: function addValue(value) {
                var valueArray = this.getValueArray(this.props.value);
                var visibleOptions = this._visibleOptions.filter(function(val) {
                    return !val.disabled;
                });
                var lastValueIndex = visibleOptions.indexOf(value);
                this.setValue(valueArray.concat(value));
                if (!this.props.closeOnSelect) return;
                if (visibleOptions.length - 1 === lastValueIndex) // the last option was selected; focus the second-last one
                this.focusOption(visibleOptions[lastValueIndex - 1]);
                else if (visibleOptions.length > lastValueIndex) // focus the option below the selected one
                this.focusOption(visibleOptions[lastValueIndex + 1]);
            }
        },
        {
            key: "popValue",
            value: function popValue() {
                var valueArray = this.getValueArray(this.props.value);
                if (!valueArray.length) return;
                if (valueArray[valueArray.length - 1].clearableValue === false) return;
                this.setValue(this.props.multi ? valueArray.slice(0, valueArray.length - 1) : null);
            }
        },
        {
            key: "removeValue",
            value: function removeValue(value) {
                var _this4 = this;
                var valueArray = this.getValueArray(this.props.value);
                this.setValue(valueArray.filter(function(i) {
                    return i[_this4.props.valueKey] !== value[_this4.props.valueKey];
                }));
                this.focus();
            }
        },
        {
            key: "clearValue",
            value: function clearValue(event) {
                // if the event was triggered by a mousedown and not the primary
                // button, ignore it.
                if (event && event.type === "mousedown" && event.button !== 0) return;
                event.preventDefault();
                this.setValue(this.getResetValue());
                this.setState({
                    inputValue: this.handleInputValueChange(""),
                    isOpen: false
                }, this.focus);
                this._focusAfterClear = true;
            }
        },
        {
            key: "getResetValue",
            value: function getResetValue() {
                if (this.props.resetValue !== undefined) return this.props.resetValue;
                else if (this.props.multi) return [];
                else return null;
            }
        },
        {
            key: "focusOption",
            value: function focusOption(option) {
                this.setState({
                    focusedOption: option
                });
            }
        },
        {
            key: "focusNextOption",
            value: function focusNextOption() {
                this.focusAdjacentOption("next");
            }
        },
        {
            key: "focusPreviousOption",
            value: function focusPreviousOption() {
                this.focusAdjacentOption("previous");
            }
        },
        {
            key: "focusPageUpOption",
            value: function focusPageUpOption() {
                this.focusAdjacentOption("page_up");
            }
        },
        {
            key: "focusPageDownOption",
            value: function focusPageDownOption() {
                this.focusAdjacentOption("page_down");
            }
        },
        {
            key: "focusStartOption",
            value: function focusStartOption() {
                this.focusAdjacentOption("start");
            }
        },
        {
            key: "focusEndOption",
            value: function focusEndOption() {
                this.focusAdjacentOption("end");
            }
        },
        {
            key: "focusAdjacentOption",
            value: function focusAdjacentOption(dir) {
                var options = this._visibleOptions.map(function(option, index) {
                    return {
                        option: option,
                        index: index
                    };
                }).filter(function(option) {
                    return !option.option.disabled;
                });
                this._scrollToFocusedOptionOnUpdate = true;
                if (!this.state.isOpen) {
                    var newState = {
                        focusedOption: this._focusedOption || (options.length ? options[dir === "next" ? 0 : options.length - 1].option : null),
                        isOpen: true
                    };
                    if (this.props.onSelectResetsInput) newState.inputValue = "";
                    this.setState(newState);
                    return;
                }
                if (!options.length) return;
                var focusedIndex = -1;
                for(var i = 0; i < options.length; i++)if (this._focusedOption === options[i].option) {
                    focusedIndex = i;
                    break;
                }
                if (dir === "next" && focusedIndex !== -1) focusedIndex = (focusedIndex + 1) % options.length;
                else if (dir === "previous") {
                    if (focusedIndex > 0) focusedIndex = focusedIndex - 1;
                    else focusedIndex = options.length - 1;
                } else if (dir === "start") focusedIndex = 0;
                else if (dir === "end") focusedIndex = options.length - 1;
                else if (dir === "page_up") {
                    var potentialIndex = focusedIndex - this.props.pageSize;
                    if (potentialIndex < 0) focusedIndex = 0;
                    else focusedIndex = potentialIndex;
                } else if (dir === "page_down") {
                    var _potentialIndex = focusedIndex + this.props.pageSize;
                    if (_potentialIndex > options.length - 1) focusedIndex = options.length - 1;
                    else focusedIndex = _potentialIndex;
                }
                if (focusedIndex === -1) focusedIndex = 0;
                this.setState({
                    focusedIndex: options[focusedIndex].index,
                    focusedOption: options[focusedIndex].option
                });
            }
        },
        {
            key: "getFocusedOption",
            value: function getFocusedOption() {
                return this._focusedOption;
            }
        },
        {
            key: "selectFocusedOption",
            value: function selectFocusedOption() {
                if (this._focusedOption) return this.selectValue(this._focusedOption);
            }
        },
        {
            key: "renderLoading",
            value: function renderLoading() {
                if (!this.props.isLoading) return;
                return (0, _reactDefault.default).createElement("span", {
                    className: "Select-loading-zone",
                    "aria-hidden": "true"
                }, (0, _reactDefault.default).createElement("span", {
                    className: "Select-loading"
                }));
            }
        },
        {
            key: "renderValue",
            value: function renderValue(valueArray, isOpen) {
                var _this5 = this;
                var renderLabel = this.props.valueRenderer || this.getOptionLabel;
                var ValueComponent = this.props.valueComponent;
                if (!valueArray.length) {
                    var showPlaceholder = shouldShowPlaceholder(this.state, this.props, isOpen);
                    return showPlaceholder ? (0, _reactDefault.default).createElement("div", {
                        className: "Select-placeholder"
                    }, this.props.placeholder) : null;
                }
                var onClick = this.props.onValueClick ? this.handleValueClick : null;
                if (this.props.multi) return valueArray.map(function(value, i) {
                    return (0, _reactDefault.default).createElement(ValueComponent, {
                        disabled: _this5.props.disabled || value.clearableValue === false,
                        id: _this5._instancePrefix + "-value-" + i,
                        instancePrefix: _this5._instancePrefix,
                        key: "value-" + i + "-" + value[_this5.props.valueKey],
                        onClick: onClick,
                        onRemove: _this5.removeValue,
                        placeholder: _this5.props.placeholder,
                        value: value,
                        values: valueArray
                    }, renderLabel(value, i), (0, _reactDefault.default).createElement("span", {
                        className: "Select-aria-only"
                    }, "\xa0"));
                });
                else if (shouldShowValue(this.state, this.props)) {
                    if (isOpen) onClick = null;
                    return (0, _reactDefault.default).createElement(ValueComponent, {
                        disabled: this.props.disabled,
                        id: this._instancePrefix + "-value-item",
                        instancePrefix: this._instancePrefix,
                        onClick: onClick,
                        placeholder: this.props.placeholder,
                        value: valueArray[0]
                    }, renderLabel(valueArray[0]));
                }
            }
        },
        {
            key: "renderInput",
            value: function renderInput(valueArray, focusedOptionIndex) {
                var _classNames, _this6 = this;
                var className = (0, _classnamesDefault.default)("Select-input", this.props.inputProps.className);
                var isOpen = this.state.isOpen;
                var ariaOwns = (0, _classnamesDefault.default)((_classNames = {}, defineProperty(_classNames, this._instancePrefix + "-list", isOpen), defineProperty(_classNames, this._instancePrefix + "-backspace-remove-message", this.props.multi && !this.props.disabled && this.state.isFocused && !this.state.inputValue), _classNames));
                var value = this.state.inputValue;
                if (value && !this.props.onSelectResetsInput && !this.state.isFocused) // it hides input value when it is not focused and was not reset on select
                value = "";
                var inputProps = _extends({}, this.props.inputProps, {
                    "aria-activedescendant": isOpen ? this._instancePrefix + "-option-" + focusedOptionIndex : this._instancePrefix + "-value",
                    "aria-describedby": this.props["aria-describedby"],
                    "aria-expanded": "" + isOpen,
                    "aria-haspopup": "" + isOpen,
                    "aria-label": this.props["aria-label"],
                    "aria-labelledby": this.props["aria-labelledby"],
                    "aria-owns": ariaOwns,
                    onBlur: this.handleInputBlur,
                    onChange: this.handleInputChange,
                    onFocus: this.handleInputFocus,
                    ref: function ref(_ref) {
                        return _this6.input = _ref;
                    },
                    role: "combobox",
                    required: this.state.required,
                    tabIndex: this.props.tabIndex,
                    value: value
                });
                if (this.props.inputRenderer) return this.props.inputRenderer(inputProps);
                if (this.props.disabled || !this.props.searchable) {
                    var divProps = objectWithoutProperties(this.props.inputProps, []);
                    var _ariaOwns = (0, _classnamesDefault.default)(defineProperty({}, this._instancePrefix + "-list", isOpen));
                    return (0, _reactDefault.default).createElement("div", _extends({}, divProps, {
                        "aria-expanded": isOpen,
                        "aria-owns": _ariaOwns,
                        "aria-activedescendant": isOpen ? this._instancePrefix + "-option-" + focusedOptionIndex : this._instancePrefix + "-value",
                        "aria-disabled": "" + this.props.disabled,
                        "aria-label": this.props["aria-label"],
                        "aria-labelledby": this.props["aria-labelledby"],
                        className: className,
                        onBlur: this.handleInputBlur,
                        onFocus: this.handleInputFocus,
                        ref: function ref(_ref2) {
                            return _this6.input = _ref2;
                        },
                        role: "combobox",
                        style: {
                            border: 0,
                            width: 1,
                            display: "inline-block"
                        },
                        tabIndex: this.props.tabIndex || 0
                    }));
                }
                if (this.props.autosize) return (0, _reactDefault.default).createElement((0, _reactInputAutosizeDefault.default), _extends({
                    id: this.props.id
                }, inputProps, {
                    className: className,
                    minWidth: "5"
                }));
                return (0, _reactDefault.default).createElement("div", {
                    className: className,
                    key: "input-wrap",
                    style: {
                        display: "inline-block"
                    }
                }, (0, _reactDefault.default).createElement("input", _extends({
                    id: this.props.id
                }, inputProps)));
            }
        },
        {
            key: "renderClear",
            value: function renderClear() {
                var valueArray = this.getValueArray(this.props.value);
                if (!this.props.clearable || !valueArray.length || this.props.disabled || this.props.isLoading) return;
                var ariaLabel = this.props.multi ? this.props.clearAllText : this.props.clearValueText;
                var clear = this.props.clearRenderer();
                return (0, _reactDefault.default).createElement("span", {
                    "aria-label": ariaLabel,
                    className: "Select-clear-zone",
                    onMouseDown: this.clearValue,
                    onTouchEnd: this.handleTouchEndClearValue,
                    onTouchMove: this.handleTouchMove,
                    onTouchStart: this.handleTouchStart,
                    title: ariaLabel
                }, clear);
            }
        },
        {
            key: "renderArrow",
            value: function renderArrow() {
                if (!this.props.arrowRenderer) return;
                var onMouseDown = this.handleMouseDownOnArrow;
                var isOpen = this.state.isOpen;
                var arrow = this.props.arrowRenderer({
                    onMouseDown: onMouseDown,
                    isOpen: isOpen
                });
                if (!arrow) return null;
                return (0, _reactDefault.default).createElement("span", {
                    className: "Select-arrow-zone",
                    onMouseDown: onMouseDown
                }, arrow);
            }
        },
        {
            key: "filterOptions",
            value: function filterOptions$$1(excludeOptions) {
                var filterValue = this.state.inputValue;
                var options = this.props.options || [];
                if (this.props.filterOptions) {
                    // Maintain backwards compatibility with boolean attribute
                    var filterOptions$$1 = typeof this.props.filterOptions === "function" ? this.props.filterOptions : filterOptions;
                    return filterOptions$$1(options, filterValue, excludeOptions, {
                        filterOption: this.props.filterOption,
                        ignoreAccents: this.props.ignoreAccents,
                        ignoreCase: this.props.ignoreCase,
                        labelKey: this.props.labelKey,
                        matchPos: this.props.matchPos,
                        matchProp: this.props.matchProp,
                        trimFilter: this.props.trimFilter,
                        valueKey: this.props.valueKey
                    });
                } else return options;
            }
        },
        {
            key: "onOptionRef",
            value: function onOptionRef(ref, isFocused) {
                if (isFocused) this.focused = ref;
            }
        },
        {
            key: "renderMenu",
            value: function renderMenu(options, valueArray, focusedOption) {
                if (options && options.length) return this.props.menuRenderer({
                    focusedOption: focusedOption,
                    focusOption: this.focusOption,
                    inputValue: this.state.inputValue,
                    instancePrefix: this._instancePrefix,
                    labelKey: this.props.labelKey,
                    onFocus: this.focusOption,
                    onOptionRef: this.onOptionRef,
                    onSelect: this.selectValue,
                    optionClassName: this.props.optionClassName,
                    optionComponent: this.props.optionComponent,
                    optionRenderer: this.props.optionRenderer || this.getOptionLabel,
                    options: options,
                    removeValue: this.removeValue,
                    selectValue: this.selectValue,
                    valueArray: valueArray,
                    valueKey: this.props.valueKey
                });
                else if (this.props.noResultsText) return (0, _reactDefault.default).createElement("div", {
                    className: "Select-noresults"
                }, this.props.noResultsText);
                else return null;
            }
        },
        {
            key: "renderHiddenField",
            value: function renderHiddenField(valueArray) {
                var _this7 = this;
                if (!this.props.name) return;
                if (this.props.joinValues) {
                    var value = valueArray.map(function(i) {
                        return stringifyValue(i[_this7.props.valueKey]);
                    }).join(this.props.delimiter);
                    return (0, _reactDefault.default).createElement("input", {
                        disabled: this.props.disabled,
                        name: this.props.name,
                        ref: function ref(_ref3) {
                            return _this7.value = _ref3;
                        },
                        type: "hidden",
                        value: value
                    });
                }
                return valueArray.map(function(item, index) {
                    return (0, _reactDefault.default).createElement("input", {
                        disabled: _this7.props.disabled,
                        key: "hidden." + index,
                        name: _this7.props.name,
                        ref: "value" + index,
                        type: "hidden",
                        value: stringifyValue(item[_this7.props.valueKey])
                    });
                });
            }
        },
        {
            key: "getFocusableOptionIndex",
            value: function getFocusableOptionIndex(selectedOption) {
                var options = this._visibleOptions;
                if (!options.length) return null;
                var valueKey = this.props.valueKey;
                var focusedOption = this.state.focusedOption || selectedOption;
                if (focusedOption && !focusedOption.disabled) {
                    var focusedOptionIndex = -1;
                    options.some(function(option, index) {
                        var isOptionEqual = option[valueKey] === focusedOption[valueKey];
                        if (isOptionEqual) focusedOptionIndex = index;
                        return isOptionEqual;
                    });
                    if (focusedOptionIndex !== -1) return focusedOptionIndex;
                }
                for(var i = 0; i < options.length; i++){
                    if (!options[i].disabled) return i;
                }
                return null;
            }
        },
        {
            key: "renderOuter",
            value: function renderOuter(options, valueArray, focusedOption) {
                var _this8 = this;
                var menu = this.renderMenu(options, valueArray, focusedOption);
                if (!menu) return null;
                return (0, _reactDefault.default).createElement("div", {
                    ref: function ref(_ref5) {
                        return _this8.menuContainer = _ref5;
                    },
                    className: "Select-menu-outer",
                    style: this.props.menuContainerStyle
                }, (0, _reactDefault.default).createElement("div", {
                    className: "Select-menu",
                    id: this._instancePrefix + "-list",
                    onMouseDown: this.handleMouseDownOnMenu,
                    onScroll: this.handleMenuScroll,
                    ref: function ref(_ref4) {
                        return _this8.menu = _ref4;
                    },
                    role: "listbox",
                    style: this.props.menuStyle,
                    tabIndex: -1
                }, menu));
            }
        },
        {
            key: "render",
            value: function render() {
                var _this9 = this;
                var valueArray = this.getValueArray(this.props.value);
                var options = this._visibleOptions = this.filterOptions(this.props.multi && this.props.removeSelected ? valueArray : null);
                var isOpen = this.state.isOpen;
                if (this.props.multi && !options.length && valueArray.length && !this.state.inputValue) isOpen = false;
                var focusedOptionIndex = this.getFocusableOptionIndex(valueArray[0]);
                var focusedOption = null;
                if (focusedOptionIndex !== null) focusedOption = this._focusedOption = options[focusedOptionIndex];
                else focusedOption = this._focusedOption = null;
                var className = (0, _classnamesDefault.default)("Select", this.props.className, {
                    "has-value": valueArray.length,
                    "is-clearable": this.props.clearable,
                    "is-disabled": this.props.disabled,
                    "is-focused": this.state.isFocused,
                    "is-loading": this.props.isLoading,
                    "is-open": isOpen,
                    "is-pseudo-focused": this.state.isPseudoFocused,
                    "is-searchable": this.props.searchable,
                    "Select--multi": this.props.multi,
                    "Select--rtl": this.props.rtl,
                    "Select--single": !this.props.multi
                });
                var removeMessage = null;
                if (this.props.multi && !this.props.disabled && valueArray.length && !this.state.inputValue && this.state.isFocused && this.props.backspaceRemoves) removeMessage = (0, _reactDefault.default).createElement("span", {
                    id: this._instancePrefix + "-backspace-remove-message",
                    className: "Select-aria-only",
                    "aria-live": "assertive"
                }, this.props.backspaceToRemoveMessage.replace("{label}", valueArray[valueArray.length - 1][this.props.labelKey]));
                return (0, _reactDefault.default).createElement("div", {
                    ref: function ref(_ref7) {
                        return _this9.wrapper = _ref7;
                    },
                    className: className,
                    style: this.props.wrapperStyle
                }, this.renderHiddenField(valueArray), (0, _reactDefault.default).createElement("div", {
                    ref: function ref(_ref6) {
                        return _this9.control = _ref6;
                    },
                    className: "Select-control",
                    onKeyDown: this.handleKeyDown,
                    onMouseDown: this.handleMouseDown,
                    onTouchEnd: this.handleTouchEnd,
                    onTouchMove: this.handleTouchMove,
                    onTouchStart: this.handleTouchStart,
                    style: this.props.style
                }, (0, _reactDefault.default).createElement("div", {
                    className: "Select-multi-value-wrapper",
                    id: this._instancePrefix + "-value"
                }, this.renderValue(valueArray, isOpen), this.renderInput(valueArray, focusedOptionIndex)), removeMessage, this.renderLoading(), this.renderClear(), this.renderArrow()), isOpen ? this.renderOuter(options, valueArray, focusedOption) : null);
            }
        }
    ]);
    return Select;
}((0, _reactDefault.default).Component);
Select$1.propTypes = {
    "aria-describedby": (0, _propTypesDefault.default).string,
    "aria-label": (0, _propTypesDefault.default).string,
    "aria-labelledby": (0, _propTypesDefault.default).string,
    arrowRenderer: (0, _propTypesDefault.default).func,
    autoBlur: (0, _propTypesDefault.default).bool,
    autoFocus: (0, _propTypesDefault.default).bool,
    autofocus: (0, _propTypesDefault.default).bool,
    autosize: (0, _propTypesDefault.default).bool,
    backspaceRemoves: (0, _propTypesDefault.default).bool,
    backspaceToRemoveMessage: (0, _propTypesDefault.default).string,
    className: (0, _propTypesDefault.default).string,
    clearAllText: stringOrNode,
    clearRenderer: (0, _propTypesDefault.default).func,
    clearValueText: stringOrNode,
    clearable: (0, _propTypesDefault.default).bool,
    closeOnSelect: (0, _propTypesDefault.default).bool,
    deleteRemoves: (0, _propTypesDefault.default).bool,
    delimiter: (0, _propTypesDefault.default).string,
    disabled: (0, _propTypesDefault.default).bool,
    escapeClearsValue: (0, _propTypesDefault.default).bool,
    filterOption: (0, _propTypesDefault.default).func,
    filterOptions: (0, _propTypesDefault.default).any,
    id: (0, _propTypesDefault.default).string,
    ignoreAccents: (0, _propTypesDefault.default).bool,
    ignoreCase: (0, _propTypesDefault.default).bool,
    inputProps: (0, _propTypesDefault.default).object,
    inputRenderer: (0, _propTypesDefault.default).func,
    instanceId: (0, _propTypesDefault.default).string,
    isLoading: (0, _propTypesDefault.default).bool,
    joinValues: (0, _propTypesDefault.default).bool,
    labelKey: (0, _propTypesDefault.default).string,
    matchPos: (0, _propTypesDefault.default).string,
    matchProp: (0, _propTypesDefault.default).string,
    menuBuffer: (0, _propTypesDefault.default).number,
    menuContainerStyle: (0, _propTypesDefault.default).object,
    menuRenderer: (0, _propTypesDefault.default).func,
    menuStyle: (0, _propTypesDefault.default).object,
    multi: (0, _propTypesDefault.default).bool,
    name: (0, _propTypesDefault.default).string,
    noResultsText: stringOrNode,
    onBlur: (0, _propTypesDefault.default).func,
    onBlurResetsInput: (0, _propTypesDefault.default).bool,
    onChange: (0, _propTypesDefault.default).func,
    onClose: (0, _propTypesDefault.default).func,
    onCloseResetsInput: (0, _propTypesDefault.default).bool,
    onFocus: (0, _propTypesDefault.default).func,
    onInputChange: (0, _propTypesDefault.default).func,
    onInputKeyDown: (0, _propTypesDefault.default).func,
    onMenuScrollToBottom: (0, _propTypesDefault.default).func,
    onOpen: (0, _propTypesDefault.default).func,
    onSelectResetsInput: (0, _propTypesDefault.default).bool,
    onValueClick: (0, _propTypesDefault.default).func,
    openOnClick: (0, _propTypesDefault.default).bool,
    openOnFocus: (0, _propTypesDefault.default).bool,
    optionClassName: (0, _propTypesDefault.default).string,
    optionComponent: (0, _propTypesDefault.default).func,
    optionRenderer: (0, _propTypesDefault.default).func,
    options: (0, _propTypesDefault.default).array,
    pageSize: (0, _propTypesDefault.default).number,
    placeholder: stringOrNode,
    removeSelected: (0, _propTypesDefault.default).bool,
    required: (0, _propTypesDefault.default).bool,
    resetValue: (0, _propTypesDefault.default).any,
    rtl: (0, _propTypesDefault.default).bool,
    scrollMenuIntoView: (0, _propTypesDefault.default).bool,
    searchable: (0, _propTypesDefault.default).bool,
    simpleValue: (0, _propTypesDefault.default).bool,
    style: (0, _propTypesDefault.default).object,
    tabIndex: stringOrNumber,
    tabSelectsValue: (0, _propTypesDefault.default).bool,
    trimFilter: (0, _propTypesDefault.default).bool,
    value: (0, _propTypesDefault.default).any,
    valueComponent: (0, _propTypesDefault.default).func,
    valueKey: (0, _propTypesDefault.default).string,
    valueRenderer: (0, _propTypesDefault.default).func,
    wrapperStyle: (0, _propTypesDefault.default).object // optional style to apply to the component wrapper
};
Select$1.defaultProps = {
    arrowRenderer: arrowRenderer,
    autosize: true,
    backspaceRemoves: true,
    backspaceToRemoveMessage: "Press backspace to remove {label}",
    clearable: true,
    clearAllText: "Clear all",
    clearRenderer: clearRenderer,
    clearValueText: "Clear value",
    closeOnSelect: true,
    deleteRemoves: true,
    delimiter: ",",
    disabled: false,
    escapeClearsValue: true,
    filterOptions: filterOptions,
    ignoreAccents: true,
    ignoreCase: true,
    inputProps: {},
    isLoading: false,
    joinValues: false,
    labelKey: "label",
    matchPos: "any",
    matchProp: "any",
    menuBuffer: 0,
    menuRenderer: menuRenderer,
    multi: false,
    noResultsText: "No results found",
    onBlurResetsInput: true,
    onCloseResetsInput: true,
    onSelectResetsInput: true,
    openOnClick: true,
    optionComponent: Option,
    pageSize: 5,
    placeholder: "Select...",
    removeSelected: true,
    required: false,
    rtl: false,
    scrollMenuIntoView: true,
    searchable: true,
    simpleValue: false,
    tabSelectsValue: true,
    trimFilter: true,
    valueComponent: Value,
    valueKey: "value"
};
var propTypes = {
    autoload: (0, _propTypesDefault.default).bool.isRequired,
    cache: (0, _propTypesDefault.default).any,
    children: (0, _propTypesDefault.default).func.isRequired,
    ignoreAccents: (0, _propTypesDefault.default).bool,
    ignoreCase: (0, _propTypesDefault.default).bool,
    loadOptions: (0, _propTypesDefault.default).func.isRequired,
    loadingPlaceholder: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).string,
        (0, _propTypesDefault.default).node
    ]),
    multi: (0, _propTypesDefault.default).bool,
    noResultsText: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).string,
        (0, _propTypesDefault.default).node
    ]),
    onChange: (0, _propTypesDefault.default).func,
    onInputChange: (0, _propTypesDefault.default).func,
    options: (0, _propTypesDefault.default).array.isRequired,
    placeholder: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).string,
        (0, _propTypesDefault.default).node
    ]),
    searchPromptText: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).string,
        (0, _propTypesDefault.default).node
    ]),
    value: (0, _propTypesDefault.default).any // initial field value
};
var defaultCache = {};
var defaultChildren = function defaultChildren(props) {
    return (0, _reactDefault.default).createElement(Select$1, props);
};
var defaultProps = {
    autoload: true,
    cache: defaultCache,
    children: defaultChildren,
    ignoreAccents: true,
    ignoreCase: true,
    loadingPlaceholder: "Loading...",
    options: [],
    searchPromptText: "Type to search"
};
var Async = function(_Component) {
    inherits(Async, _Component);
    function Async(props, context) {
        classCallCheck(this, Async);
        var _this = possibleConstructorReturn(this, (Async.__proto__ || Object.getPrototypeOf(Async)).call(this, props, context));
        _this._cache = props.cache === defaultCache ? {} : props.cache;
        _this.state = {
            inputValue: "",
            isLoading: false,
            options: props.options
        };
        _this.onInputChange = _this.onInputChange.bind(_this);
        return _this;
    }
    createClass(Async, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                var autoload = this.props.autoload;
                if (autoload) this.loadOptions("");
            }
        },
        {
            key: "componentWillReceiveProps",
            value: function componentWillReceiveProps(nextProps) {
                if (nextProps.options !== this.props.options) this.setState({
                    options: nextProps.options
                });
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this._callback = null;
            }
        },
        {
            key: "loadOptions",
            value: function loadOptions(inputValue) {
                var _this2 = this;
                var loadOptions = this.props.loadOptions;
                var cache = this._cache;
                if (cache && Object.prototype.hasOwnProperty.call(cache, inputValue)) {
                    this._callback = null;
                    this.setState({
                        isLoading: false,
                        options: cache[inputValue]
                    });
                    return;
                }
                var callback = function callback(error, data) {
                    var options = data && data.options || [];
                    if (cache) cache[inputValue] = options;
                    if (callback === _this2._callback) {
                        _this2._callback = null;
                        _this2.setState({
                            isLoading: false,
                            options: options
                        });
                    }
                };
                // Ignore all but the most recent request
                this._callback = callback;
                var promise = loadOptions(inputValue, callback);
                if (promise) promise.then(function(data) {
                    return callback(null, data);
                }, function(error) {
                    return callback(error);
                });
                if (this._callback && !this.state.isLoading) this.setState({
                    isLoading: true
                });
            }
        },
        {
            key: "onInputChange",
            value: function onInputChange(inputValue) {
                var _props = this.props, ignoreAccents = _props.ignoreAccents, ignoreCase = _props.ignoreCase, onInputChange = _props.onInputChange;
                var newInputValue = inputValue;
                if (onInputChange) {
                    var value = onInputChange(newInputValue);
                    // Note: != used deliberately here to catch undefined and null
                    if (value != null && (typeof value === "undefined" ? "undefined" : _typeof(value)) !== "object") newInputValue = "" + value;
                }
                var transformedInputValue = newInputValue;
                if (ignoreAccents) transformedInputValue = stripDiacritics(transformedInputValue);
                if (ignoreCase) transformedInputValue = transformedInputValue.toLowerCase();
                this.setState({
                    inputValue: newInputValue
                });
                this.loadOptions(transformedInputValue);
                // Return new input value, but without applying toLowerCase() to avoid modifying the user's view case of the input while typing.
                return newInputValue;
            }
        },
        {
            key: "noResultsText",
            value: function noResultsText() {
                var _props2 = this.props, loadingPlaceholder = _props2.loadingPlaceholder, noResultsText = _props2.noResultsText, searchPromptText = _props2.searchPromptText;
                var _state = this.state, inputValue = _state.inputValue, isLoading = _state.isLoading;
                if (isLoading) return loadingPlaceholder;
                if (inputValue && noResultsText) return noResultsText;
                return searchPromptText;
            }
        },
        {
            key: "focus",
            value: function focus() {
                this.select.focus();
            }
        },
        {
            key: "render",
            value: function render() {
                var _this3 = this;
                var _props3 = this.props, children = _props3.children, loadingPlaceholder = _props3.loadingPlaceholder, placeholder = _props3.placeholder;
                var _state2 = this.state, isLoading = _state2.isLoading, options = _state2.options;
                var props = {
                    noResultsText: this.noResultsText(),
                    placeholder: isLoading ? loadingPlaceholder : placeholder,
                    options: isLoading && loadingPlaceholder ? [] : options,
                    ref: function ref(_ref) {
                        return _this3.select = _ref;
                    }
                };
                return children(_extends({}, this.props, props, {
                    isLoading: isLoading,
                    onInputChange: this.onInputChange
                }));
            }
        }
    ]);
    return Async;
}((0, _react.Component));
Async.propTypes = propTypes;
Async.defaultProps = defaultProps;
var CreatableSelect = function(_React$Component) {
    inherits(CreatableSelect, _React$Component);
    function CreatableSelect(props, context) {
        classCallCheck(this, CreatableSelect);
        var _this = possibleConstructorReturn(this, (CreatableSelect.__proto__ || Object.getPrototypeOf(CreatableSelect)).call(this, props, context));
        _this.filterOptions = _this.filterOptions.bind(_this);
        _this.menuRenderer = _this.menuRenderer.bind(_this);
        _this.onInputKeyDown = _this.onInputKeyDown.bind(_this);
        _this.onInputChange = _this.onInputChange.bind(_this);
        _this.onOptionSelect = _this.onOptionSelect.bind(_this);
        return _this;
    }
    createClass(CreatableSelect, [
        {
            key: "createNewOption",
            value: function createNewOption() {
                var _props = this.props, isValidNewOption = _props.isValidNewOption, newOptionCreator = _props.newOptionCreator, onNewOptionClick = _props.onNewOptionClick, _props$options = _props.options, options = _props$options === undefined ? [] : _props$options;
                if (isValidNewOption({
                    label: this.inputValue
                })) {
                    var option = newOptionCreator({
                        label: this.inputValue,
                        labelKey: this.labelKey,
                        valueKey: this.valueKey
                    });
                    var _isOptionUnique = this.isOptionUnique({
                        option: option,
                        options: options
                    });
                    // Don't add the same option twice.
                    if (_isOptionUnique) {
                        if (onNewOptionClick) onNewOptionClick(option);
                        else {
                            options.unshift(option);
                            this.select.selectValue(option);
                        }
                    }
                }
            }
        },
        {
            key: "filterOptions",
            value: function filterOptions$$1() {
                var _props2 = this.props, filterOptions$$1 = _props2.filterOptions, isValidNewOption = _props2.isValidNewOption, promptTextCreator = _props2.promptTextCreator, showNewOptionAtTop = _props2.showNewOptionAtTop;
                // TRICKY Check currently selected options as well.
                // Don't display a create-prompt for a value that's selected.
                // This covers async edge-cases where a newly-created Option isn't yet in the async-loaded array.
                var excludeOptions = (arguments.length <= 2 ? undefined : arguments[2]) || [];
                var filteredOptions = filterOptions$$1.apply(undefined, arguments) || [];
                if (isValidNewOption({
                    label: this.inputValue
                })) {
                    var _newOptionCreator = this.props.newOptionCreator;
                    var option = _newOptionCreator({
                        label: this.inputValue,
                        labelKey: this.labelKey,
                        valueKey: this.valueKey
                    });
                    // TRICKY Compare to all options (not just filtered options) in case option has already been selected).
                    // For multi-selects, this would remove it from the filtered list.
                    var _isOptionUnique2 = this.isOptionUnique({
                        option: option,
                        options: excludeOptions.concat(filteredOptions)
                    });
                    if (_isOptionUnique2) {
                        var prompt = promptTextCreator(this.inputValue);
                        this._createPlaceholderOption = _newOptionCreator({
                            label: prompt,
                            labelKey: this.labelKey,
                            valueKey: this.valueKey
                        });
                        if (showNewOptionAtTop) filteredOptions.unshift(this._createPlaceholderOption);
                        else filteredOptions.push(this._createPlaceholderOption);
                    }
                }
                return filteredOptions;
            }
        },
        {
            key: "isOptionUnique",
            value: function isOptionUnique(_ref) {
                var option = _ref.option, options = _ref.options;
                var isOptionUnique = this.props.isOptionUnique;
                options = options || this.props.options;
                return isOptionUnique({
                    labelKey: this.labelKey,
                    option: option,
                    options: options,
                    valueKey: this.valueKey
                });
            }
        },
        {
            key: "menuRenderer",
            value: function menuRenderer$$1(params) {
                var menuRenderer$$1 = this.props.menuRenderer;
                return menuRenderer$$1(_extends({}, params, {
                    onSelect: this.onOptionSelect,
                    selectValue: this.onOptionSelect
                }));
            }
        },
        {
            key: "onInputChange",
            value: function onInputChange(input) {
                var onInputChange = this.props.onInputChange;
                // This value may be needed in between Select mounts (when this.select is null)
                this.inputValue = input;
                if (onInputChange) this.inputValue = onInputChange(input);
                return this.inputValue;
            }
        },
        {
            key: "onInputKeyDown",
            value: function onInputKeyDown(event) {
                var _props3 = this.props, shouldKeyDownEventCreateNewOption = _props3.shouldKeyDownEventCreateNewOption, onInputKeyDown = _props3.onInputKeyDown;
                var focusedOption = this.select.getFocusedOption();
                if (focusedOption && focusedOption === this._createPlaceholderOption && shouldKeyDownEventCreateNewOption(event)) {
                    this.createNewOption();
                    // Prevent decorated Select from doing anything additional with this keyDown event
                    event.preventDefault();
                } else if (onInputKeyDown) onInputKeyDown(event);
            }
        },
        {
            key: "onOptionSelect",
            value: function onOptionSelect(option) {
                if (option === this._createPlaceholderOption) this.createNewOption();
                else this.select.selectValue(option);
            }
        },
        {
            key: "focus",
            value: function focus() {
                this.select.focus();
            }
        },
        {
            key: "render",
            value: function render() {
                var _this2 = this;
                var _props4 = this.props, refProp = _props4.ref, restProps = objectWithoutProperties(_props4, [
                    "ref"
                ]);
                var children = this.props.children;
                // We can't use destructuring default values to set the children,
                // because it won't apply work if `children` is null. A falsy check is
                // more reliable in real world use-cases.
                if (!children) children = defaultChildren$2;
                var props = _extends({}, restProps, {
                    allowCreate: true,
                    filterOptions: this.filterOptions,
                    menuRenderer: this.menuRenderer,
                    onInputChange: this.onInputChange,
                    onInputKeyDown: this.onInputKeyDown,
                    ref: function ref(_ref2) {
                        _this2.select = _ref2;
                        // These values may be needed in between Select mounts (when this.select is null)
                        if (_ref2) {
                            _this2.labelKey = _ref2.props.labelKey;
                            _this2.valueKey = _ref2.props.valueKey;
                        }
                        if (refProp) refProp(_ref2);
                    }
                });
                return children(props);
            }
        }
    ]);
    return CreatableSelect;
}((0, _reactDefault.default).Component);
var defaultChildren$2 = function defaultChildren(props) {
    return (0, _reactDefault.default).createElement(Select$1, props);
};
var isOptionUnique = function isOptionUnique(_ref3) {
    var option = _ref3.option, options = _ref3.options, labelKey = _ref3.labelKey, valueKey = _ref3.valueKey;
    if (!options || !options.length) return true;
    return options.filter(function(existingOption) {
        return existingOption[labelKey] === option[labelKey] || existingOption[valueKey] === option[valueKey];
    }).length === 0;
};
var isValidNewOption = function isValidNewOption(_ref4) {
    var label = _ref4.label;
    return !!label;
};
var newOptionCreator = function newOptionCreator(_ref5) {
    var label = _ref5.label, labelKey = _ref5.labelKey, valueKey = _ref5.valueKey;
    var option = {};
    option[valueKey] = label;
    option[labelKey] = label;
    option.className = "Select-create-option-placeholder";
    return option;
};
var promptTextCreator = function promptTextCreator(label) {
    return 'Create option "' + label + '"';
};
var shouldKeyDownEventCreateNewOption = function shouldKeyDownEventCreateNewOption(_ref6) {
    var keyCode = _ref6.keyCode;
    switch(keyCode){
        case 9:
        case 13:
        case 188:
            // COMMA
            return true;
        default:
            return false;
    }
};
// Default prop methods
CreatableSelect.isOptionUnique = isOptionUnique;
CreatableSelect.isValidNewOption = isValidNewOption;
CreatableSelect.newOptionCreator = newOptionCreator;
CreatableSelect.promptTextCreator = promptTextCreator;
CreatableSelect.shouldKeyDownEventCreateNewOption = shouldKeyDownEventCreateNewOption;
CreatableSelect.defaultProps = {
    filterOptions: filterOptions,
    isOptionUnique: isOptionUnique,
    isValidNewOption: isValidNewOption,
    menuRenderer: menuRenderer,
    newOptionCreator: newOptionCreator,
    promptTextCreator: promptTextCreator,
    shouldKeyDownEventCreateNewOption: shouldKeyDownEventCreateNewOption,
    showNewOptionAtTop: true
};
CreatableSelect.propTypes = {
    // Child function responsible for creating the inner Select component
    // This component can be used to compose HOCs (eg Creatable and Async)
    // (props: Object): PropTypes.element
    children: (0, _propTypesDefault.default).func,
    // See Select.propTypes.filterOptions
    filterOptions: (0, _propTypesDefault.default).any,
    // Searches for any matching option within the set of options.
    // This function prevents duplicate options from being created.
    // ({ option: Object, options: Array, labelKey: string, valueKey: string }): boolean
    isOptionUnique: (0, _propTypesDefault.default).func,
    // Determines if the current input text represents a valid option.
    // ({ label: string }): boolean
    isValidNewOption: (0, _propTypesDefault.default).func,
    // See Select.propTypes.menuRenderer
    menuRenderer: (0, _propTypesDefault.default).any,
    // Factory to create new option.
    // ({ label: string, labelKey: string, valueKey: string }): Object
    newOptionCreator: (0, _propTypesDefault.default).func,
    // input change handler: function (inputValue) {}
    onInputChange: (0, _propTypesDefault.default).func,
    // input keyDown handler: function (event) {}
    onInputKeyDown: (0, _propTypesDefault.default).func,
    // new option click handler: function (option) {}
    onNewOptionClick: (0, _propTypesDefault.default).func,
    // See Select.propTypes.options
    options: (0, _propTypesDefault.default).array,
    // Creates prompt/placeholder option text.
    // (filterText: string): string
    promptTextCreator: (0, _propTypesDefault.default).func,
    ref: (0, _propTypesDefault.default).func,
    // Decides if a keyDown event (eg its `keyCode`) should result in the creation of a new option.
    shouldKeyDownEventCreateNewOption: (0, _propTypesDefault.default).func,
    // Where to show prompt/placeholder option text.
    // true: new option prompt at top of list (default)
    // false: new option prompt at bottom of list
    showNewOptionAtTop: (0, _propTypesDefault.default).bool
};
var AsyncCreatableSelect = function(_React$Component) {
    inherits(AsyncCreatableSelect, _React$Component);
    function AsyncCreatableSelect() {
        classCallCheck(this, AsyncCreatableSelect);
        return possibleConstructorReturn(this, (AsyncCreatableSelect.__proto__ || Object.getPrototypeOf(AsyncCreatableSelect)).apply(this, arguments));
    }
    createClass(AsyncCreatableSelect, [
        {
            key: "focus",
            value: function focus() {
                this.select.focus();
            }
        },
        {
            key: "render",
            value: function render() {
                var _this2 = this;
                return (0, _reactDefault.default).createElement(Async, this.props, function(_ref) {
                    var ref = _ref.ref, asyncProps = objectWithoutProperties(_ref, [
                        "ref"
                    ]);
                    var asyncRef = ref;
                    return (0, _reactDefault.default).createElement(CreatableSelect, asyncProps, function(_ref2) {
                        var ref = _ref2.ref, creatableProps = objectWithoutProperties(_ref2, [
                            "ref"
                        ]);
                        var creatableRef = ref;
                        return _this2.props.children(_extends({}, creatableProps, {
                            ref: function ref(select) {
                                creatableRef(select);
                                asyncRef(select);
                                _this2.select = select;
                            }
                        }));
                    });
                });
            }
        }
    ]);
    return AsyncCreatableSelect;
}((0, _reactDefault.default).Component);
var defaultChildren$1 = function defaultChildren(props) {
    return (0, _reactDefault.default).createElement(Select$1, props);
};
AsyncCreatableSelect.propTypes = {
    children: (0, _propTypesDefault.default).func.isRequired // Child function responsible for creating the inner Select component; (props: Object): PropTypes.element
};
AsyncCreatableSelect.defaultProps = {
    children: defaultChildren$1
};
Select$1.Async = Async;
Select$1.AsyncCreatable = AsyncCreatableSelect;
Select$1.Creatable = CreatableSelect;
Select$1.Value = Value;
Select$1.Option = Option;
exports.default = Select$1;

},{"react-input-autosize":"hyPWc","classnames":"hVGzI","prop-types":"6FKs7","react":"6uln9","react-dom":"b8T3j","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hyPWc":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var _createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
var _react = require("bc017ebd765baa05");
var _react2 = _interopRequireDefault(_react);
var _propTypes = require("ea09c2fc4454dd6d");
var _propTypes2 = _interopRequireDefault(_propTypes);
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _objectWithoutProperties(obj, keys) {
    var target = {};
    for(var i in obj){
        if (keys.indexOf(i) >= 0) continue;
        if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
        target[i] = obj[i];
    }
    return target;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var sizerStyle = {
    position: "absolute",
    top: 0,
    left: 0,
    visibility: "hidden",
    height: 0,
    overflow: "scroll",
    whiteSpace: "pre"
};
var INPUT_PROPS_BLACKLIST = [
    "extraWidth",
    "injectStyles",
    "inputClassName",
    "inputRef",
    "inputStyle",
    "minWidth",
    "onAutosize",
    "placeholderIsMinWidth"
];
var cleanInputProps = function cleanInputProps(inputProps) {
    INPUT_PROPS_BLACKLIST.forEach(function(field) {
        return delete inputProps[field];
    });
    return inputProps;
};
var copyStyles = function copyStyles(styles, node) {
    node.style.fontSize = styles.fontSize;
    node.style.fontFamily = styles.fontFamily;
    node.style.fontWeight = styles.fontWeight;
    node.style.fontStyle = styles.fontStyle;
    node.style.letterSpacing = styles.letterSpacing;
    node.style.textTransform = styles.textTransform;
};
var isIE = typeof window !== "undefined" && window.navigator ? /MSIE |Trident\/|Edge\//.test(window.navigator.userAgent) : false;
var generateId = function generateId() {
    // we only need an auto-generated ID for stylesheet injection, which is only
    // used for IE. so if the browser is not IE, this should return undefined.
    return isIE ? "_" + Math.random().toString(36).substr(2, 12) : undefined;
};
var AutosizeInput = function(_Component) {
    _inherits(AutosizeInput, _Component);
    function AutosizeInput(props) {
        _classCallCheck(this, AutosizeInput);
        var _this = _possibleConstructorReturn(this, (AutosizeInput.__proto__ || Object.getPrototypeOf(AutosizeInput)).call(this, props));
        _this.inputRef = function(el) {
            _this.input = el;
            if (typeof _this.props.inputRef === "function") _this.props.inputRef(el);
        };
        _this.placeHolderSizerRef = function(el) {
            _this.placeHolderSizer = el;
        };
        _this.sizerRef = function(el) {
            _this.sizer = el;
        };
        _this.state = {
            inputWidth: props.minWidth,
            inputId: props.id || generateId()
        };
        return _this;
    }
    _createClass(AutosizeInput, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this.mounted = true;
                this.copyInputStyles();
                this.updateInputWidth();
            }
        },
        {
            key: "UNSAFE_componentWillReceiveProps",
            value: function UNSAFE_componentWillReceiveProps(nextProps) {
                var id = nextProps.id;
                if (id !== this.props.id) this.setState({
                    inputId: id || generateId()
                });
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps, prevState) {
                if (prevState.inputWidth !== this.state.inputWidth) {
                    if (typeof this.props.onAutosize === "function") this.props.onAutosize(this.state.inputWidth);
                }
                this.updateInputWidth();
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this.mounted = false;
            }
        },
        {
            key: "copyInputStyles",
            value: function copyInputStyles() {
                if (!this.mounted || !window.getComputedStyle) return;
                var inputStyles = this.input && window.getComputedStyle(this.input);
                if (!inputStyles) return;
                copyStyles(inputStyles, this.sizer);
                if (this.placeHolderSizer) copyStyles(inputStyles, this.placeHolderSizer);
            }
        },
        {
            key: "updateInputWidth",
            value: function updateInputWidth() {
                if (!this.mounted || !this.sizer || typeof this.sizer.scrollWidth === "undefined") return;
                var newInputWidth = void 0;
                if (this.props.placeholder && (!this.props.value || this.props.value && this.props.placeholderIsMinWidth)) newInputWidth = Math.max(this.sizer.scrollWidth, this.placeHolderSizer.scrollWidth) + 2;
                else newInputWidth = this.sizer.scrollWidth + 2;
                // add extraWidth to the detected width. for number types, this defaults to 16 to allow for the stepper UI
                var extraWidth = this.props.type === "number" && this.props.extraWidth === undefined ? 16 : parseInt(this.props.extraWidth) || 0;
                newInputWidth += extraWidth;
                if (newInputWidth < this.props.minWidth) newInputWidth = this.props.minWidth;
                if (newInputWidth !== this.state.inputWidth) this.setState({
                    inputWidth: newInputWidth
                });
            }
        },
        {
            key: "getInput",
            value: function getInput() {
                return this.input;
            }
        },
        {
            key: "focus",
            value: function focus() {
                this.input.focus();
            }
        },
        {
            key: "blur",
            value: function blur() {
                this.input.blur();
            }
        },
        {
            key: "select",
            value: function select() {
                this.input.select();
            }
        },
        {
            key: "renderStyles",
            value: function renderStyles() {
                // this method injects styles to hide IE's clear indicator, which messes
                // with input size detection. the stylesheet is only injected when the
                // browser is IE, and can also be disabled by the `injectStyles` prop.
                var injectStyles = this.props.injectStyles;
                return isIE && injectStyles ? _react2.default.createElement("style", {
                    dangerouslySetInnerHTML: {
                        __html: "input#" + this.state.inputId + "::-ms-clear {display: none;}"
                    }
                }) : null;
            }
        },
        {
            key: "render",
            value: function render() {
                var sizerValue = [
                    this.props.defaultValue,
                    this.props.value,
                    ""
                ].reduce(function(previousValue, currentValue) {
                    if (previousValue !== null && previousValue !== undefined) return previousValue;
                    return currentValue;
                });
                var wrapperStyle = _extends({}, this.props.style);
                if (!wrapperStyle.display) wrapperStyle.display = "inline-block";
                var inputStyle = _extends({
                    boxSizing: "content-box",
                    width: this.state.inputWidth + "px"
                }, this.props.inputStyle);
                var inputProps = _objectWithoutProperties(this.props, []);
                cleanInputProps(inputProps);
                inputProps.className = this.props.inputClassName;
                inputProps.id = this.state.inputId;
                inputProps.style = inputStyle;
                return _react2.default.createElement("div", {
                    className: this.props.className,
                    style: wrapperStyle
                }, this.renderStyles(), _react2.default.createElement("input", _extends({}, inputProps, {
                    ref: this.inputRef
                })), _react2.default.createElement("div", {
                    ref: this.sizerRef,
                    style: sizerStyle
                }, sizerValue), this.props.placeholder ? _react2.default.createElement("div", {
                    ref: this.placeHolderSizerRef,
                    style: sizerStyle
                }, this.props.placeholder) : null);
            }
        }
    ]);
    return AutosizeInput;
}(_react.Component);
AutosizeInput.propTypes = {
    className: _propTypes2.default.string,
    defaultValue: _propTypes2.default.any,
    extraWidth: _propTypes2.default.oneOfType([
        _propTypes2.default.number,
        _propTypes2.default.string
    ]),
    id: _propTypes2.default.string,
    injectStyles: _propTypes2.default.bool,
    inputClassName: _propTypes2.default.string,
    inputRef: _propTypes2.default.func,
    inputStyle: _propTypes2.default.object,
    minWidth: _propTypes2.default.oneOfType([
        _propTypes2.default.number,
        _propTypes2.default.string
    ]),
    onAutosize: _propTypes2.default.func,
    onChange: _propTypes2.default.func,
    placeholder: _propTypes2.default.string,
    placeholderIsMinWidth: _propTypes2.default.bool,
    style: _propTypes2.default.object,
    value: _propTypes2.default.any // field value
};
AutosizeInput.defaultProps = {
    minWidth: 1,
    injectStyles: true
};
exports.default = AutosizeInput;

},{"bc017ebd765baa05":"6uln9","ea09c2fc4454dd6d":"6FKs7"}],"eiGrn":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _colors = require("../../constants/colors");
class RadioGroup extends (0, _reactDefault.default).Component {
    handleOptionSelected(option) {
        if (this.props.onChange) this.props.onChange(option);
    }
    render() {
        return (0, _react.jsx)("div", {
            className: `${containerStyle} ${this.props.disabled ? "disabled" : ""}`
        }, this.props.options.map((option, index)=>(0, _react.jsx)("div", {
                className: "radio-option",
                key: index,
                onClick: this.props.disabled ? undefined : this.handleOptionSelected.bind(this, option)
            }, (0, _react.jsx)("div", {
                className: this.props.checkContainerStyle ? this.props.checkContainerStyle : `check-container`
            }, option.value == this.props.value ? (0, _react.jsx)("div", {
                className: this.props.selectedOptionStyle ? this.props.selectedOptionStyle : `selected-option`
            }) : null), option.icon ? (0, _react.jsx)("img", {
                className: "option-icon",
                src: option.icon
            }) : null, option.label ? (0, _react.jsx)("p", {
                className: "label"
            }, option.label) : (0, _react.jsx)("div", {
                className: "label-filler"
            }), option.detailOverride && option.detailOverride())));
    }
}
const containerStyle = /*#__PURE__*/ (0, _css.css)("margin:16px 0;>*{}&.disabled{.radio-option{cursor:not-allowed;.selected-option{background:", (0, _colors.color_shades_dark), ";}}}.radio-option{margin:8px 0;display:flex;flex-direction:row;align-items:center;cursor:pointer;.check-container{position:relative;min-width:30px;height:30px;border-radius:50%;background-color:#ffffff;border:solid 1px #cccccc;display:flex;align-items:center;justify-content:center;}.selected-option{width:16px;height:16px;border-radius:50%;background-image:linear-gradient(225deg, #76c3b5, #3ea6ac 72%, #5296b3);}.label{font-family:Muli;font-size:14px;font-weight:normal;font-style:normal;font-stretch:normal;line-height:normal;letter-spacing:normal;color:", (0, _colors.dark_grey_blue), ";margin-left:16px;word-break:break-all;flex:1;}.label-filler{margin-left:16px;}.detail{font-size:14px;line-height:20px;margin-top:8px;margin-left:16px;}}.option-icon{margin-left:16px;}", "");
exports.default = RadioGroup;

},{"@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","../../constants/colors":"1p3OR","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"cvL6K":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _defineProperty = require("@babel/runtime/helpers/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _reactTextareaAutosize = require("react-textarea-autosize");
var _reactTextareaAutosizeDefault = parcelHelpers.interopDefault(_reactTextareaAutosize);
var _iconTooltip = require("../../general/IconTooltip");
var _iconTooltipDefault = parcelHelpers.interopDefault(_iconTooltip);
var _button = require("../../general/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _fieldError = require("../FieldError");
var _fieldErrorDefault = parcelHelpers.interopDefault(_fieldError);
var _responseVariableTestButton = require("../../general/ResponseVariableTestButton");
var _responseVariableTestButtonDefault = parcelHelpers.interopDefault(_responseVariableTestButton);
var _colors = require("../../../constants/colors");
var _ssmlManager = require("./SsmlManager");
var _ssmlManagerDefault = parcelHelpers.interopDefault(_ssmlManager);
var _ssmlPreviewer = require("./SsmlPreviewer");
var _ssmlPreviewerDefault = parcelHelpers.interopDefault(_ssmlPreviewer);
var _ssmlParseService = require("../../../services/ssmlParseService");
var _ssmlParseServiceDefault = parcelHelpers.interopDefault(_ssmlParseService);
var _tooltipWrapper = require("../../general/TooltipWrapper");
var _tooltipWrapperDefault = parcelHelpers.interopDefault(_tooltipWrapper);
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const ssmlIcon = require("2303b028fa2a729c");
const deleteIcon = require("e7f6a4f7f6c53ab4");
class SsmlField extends (0, _reactDefault.default).Component {
    constructor(...args){
        super(...args);
        (0, _definePropertyDefault.default)(this, "ssmlParser", new (0, _ssmlParseServiceDefault.default)());
        (0, _definePropertyDefault.default)(this, "currentEditingTree", null);
    }
    componentWillMount() {
        this.setState({
            isRaw: true,
            isModalOpen: false,
            cursorPosition: this.props.value ? this.props.value.length : 0,
            cursorEndPosition: this.props.value ? this.props.value.length : 0,
            currentObject: null,
            editingObject: null,
            ssmlObject: this.parseFromString(this.props.value)
        });
    }
    componentDidUpdate(prevProps) {
        if (prevProps.value != this.props.value) this.setState({
            ...this.state,
            ssmlObject: this.parseFromString(this.props.value)
        });
    }
    parseFromString(ssml) {
        return this.ssmlParser.ssmlToObject(ssml, [
            "say-as",
            "emphasis",
            "audio",
            "prosody",
            "break",
            "speak"
        ]);
    }
    toggleSsmlEditor(editingObject) {
        this.setState({
            ...this.state,
            isModalOpen: !this.state.isModalOpen,
            editingObject: editingObject ? editingObject : null
        });
    }
    togglePreviewer(error) {
        this.setState({
            ...this.state,
            isRaw: !this.state.isRaw,
            renderError: error
        });
    }
    handleSsmlElementSelected(ssmlId, currentTree) {
        const foundElement = this.searchTree(currentTree, ssmlId);
        this.toggleSsmlEditor(foundElement);
        this.currentEditingTree = currentTree;
    }
    searchTree(ssmlObject, id) {
        if (ssmlObject.id == id) return ssmlObject;
        else if (ssmlObject.children != null) {
            let i;
            let result = null;
            for(i = 0; result == null && i < ssmlObject.children.length; i++)result = this.searchTree(ssmlObject.children[i], id);
            return result;
        }
        return null;
    }
    updateSsmlObject(ssmlObject) {
        // find the object and replace it
        const tree = this.currentEditingTree;
        const existingObject = this.searchTree(tree, ssmlObject.id);
        existingObject.attributes = ssmlObject.attributes;
        existingObject.name = ssmlObject.name;
        this.setState({
            ...this.state,
            editingObject: null,
            ssmlObject: tree,
            isModalOpen: false
        });
        this.fireChange(tree);
    }
    updateSsml(ssml, ssmlClose, placeholder) {
        const currentValue = this.props.value ? this.props.value : "";
        placeholder = placeholder ? placeholder : "";
        ssmlClose = ssmlClose ? ssmlClose : "";
        if (this.state.currentObject == null) {
            let value = currentValue;
            if (!this.state.cursorPosition && !this.state.cursorEndPosition) value += ssml + placeholder + ssmlClose;
            else {
                if (ssmlClose) value = [
                    value.slice(0, this.state.cursorEndPosition),
                    this.state.cursorEndPosition == this.state.cursorPosition ? placeholder : "",
                    ssmlClose,
                    value.slice(this.state.cursorEndPosition)
                ].join("");
                value = [
                    value.slice(0, this.state.cursorPosition),
                    ssml,
                    value.slice(this.state.cursorPosition)
                ].join("");
            }
            this.props.onChange(value);
        } else {
            const tree = this.state.ssmlObject;
            const innerObject = this.searchTree(tree, this.state.currentObject.id);
            innerObject.value = [
                innerObject.value.slice(0, this.state.cursorPosition),
                ssml,
                innerObject.value.slice(this.state.cursorPosition)
            ].join("");
            this.setState({
                ...this.state,
                ssmlObject: tree
            });
            this.fireChange(tree);
        }
        this.setState({
            ...this.state,
            isModalOpen: false,
            cursorEndPosition: 0,
            cursorPosition: 0
        });
    }
    fireChange(ssmlObject) {
        if (!ssmlObject) ssmlObject = this.state.ssmlObject;
        this.props.onChange(this.ssmlParser.convertToString(ssmlObject));
    }
    handleSsmlObjectChange(ssmlObject) {
        this.setState({
            ...this.state,
            ssmlObject: ssmlObject
        });
        this.fireChange(ssmlObject);
    }
    handleTextAreaBlur(e) {
        // keep track of the last position for adding ssml
        this.setState({
            ...this.state,
            cursorPosition: e.target.selectionStart,
            cursorEndPosition: e.target.selectionEnd,
            currentObject: null
        });
        this.props.onBlur(e);
    }
    handlePreviewerBlur(e, ssmlObject) {
        e.target.name = this.props.name;
        this.setState({
            ...this.state,
            cursorPosition: document.getSelection().anchorOffset,
            currentObject: ssmlObject
        });
        this.props.onBlur(e);
    }
    handleDeleteObject(ssmlObject) {
        const tree = this.state.ssmlObject;
        this.ssmlParser.findDelete(ssmlObject, tree, true);
        this.setState({
            ...this.state,
            ssmlObject: tree,
            editingObject: null,
            isModalOpen: false
        });
        this.fireChange(tree);
    }
    handleTextAreaFocus(e) {
        // keep track of the last position for adding ssml
        this.setState({
            ...this.state,
            cursorPosition: e.target.selectionStart
        });
        if (this.props.onFocus) this.props.onFocus();
    }
    handleRichSelectionChange(start, end) {
        this.setState({
            ...this.state,
            cursorPosition: start,
            cursorEndPosition: end
        });
    }
    handleRichRenderError() {
        // only show the raw text and render an error to tell them to fix it
        this.togglePreviewer("Please include a valid SSML format to allow rich-view rendering");
    }
    renderViewer() {
        const props = {
            ...this.props
        };
        if (this.state.isRaw) return (0, _react.jsx)((0, _reactTextareaAutosizeDefault.default), {
            className: `${textFieldStyles} ${props.icon == null ? noBorder : ""}`,
            type: props.type,
            name: props.name,
            placeholder: props.placeholder,
            value: this.props.value,
            onChange: (e)=>props.onChange(e.target.value),
            onBlur: this.handleTextAreaBlur.bind(this),
            onFocus: this.handleTextAreaFocus.bind(this),
            disabled: props.disabled
        });
        else return (0, _react.jsx)((0, _ssmlPreviewerDefault.default), {
            className: props.icon == null ? noBorder : null,
            ssmlObject: this.state.ssmlObject,
            placeholder: props.placeholder,
            onChange: this.handleSsmlObjectChange.bind(this),
            onBlur: this.handlePreviewerBlur.bind(this),
            onFocus: this.props.onFocus,
            onSelectionChange: this.handleRichSelectionChange.bind(this),
            onElementSelected: this.handleSsmlElementSelected.bind(this),
            onRenderError: this.handleRichRenderError.bind(this),
            disabled: props.disabled
        });
    }
    render() {
        const props = {
            ...this.props
        };
        return (0, _react.jsx)("div", {
            className: `${containerStyle} ${props.className} ${props.disabled ? "disabled" : ""}`,
            id: props.id
        }, (0, _react.jsx)("div", {
            className: labelContainer
        }, (0, _react.jsx)("div", {
            className: labelSection
        }, props.label !== undefined ? (0, _react.jsx)("label", {
            htmlFor: props.name,
            onClick: ()=>props.onClickLabel(),
            className: labelStyle,
            style: {
                color: props.labelColor ?? undefined,
                cursor: props.clickableLabel ? "pointer" : undefined
            }
        }, props.label) : null, props.canDelete && (props.deletePosition == undefined || props.deletePosition == "top") ? (0, _react.jsx)((0, _buttonDefault.default), {
            additionalClasses: deleteIconStyle,
            type: "button",
            onClick: props.onDelete,
            themes: [
                "icon"
            ],
            icon: deleteIcon
        }) : null, props.tooltip !== undefined ? (0, _react.jsx)((0, _iconTooltipDefault.default), {
            text: props.tooltip,
            className: tooltipStyle,
            place: "top"
        }) : null, props.required ? (0, _react.jsx)((0, _tooltipWrapperDefault.default), {
            text: "Required field"
        }, (0, _react.jsx)("span", {
            className: requiredLabelStyle
        }, "*")) : null), (0, _react.jsx)((0, _responseVariableTestButtonDefault.default), null)), (0, _react.jsx)("div", {
            className: modalContainer
        }, this.state.isModalOpen ? (0, _react.jsx)((0, _ssmlManagerDefault.default), {
            applicationId: this.props.applicationId,
            onCancel: this.toggleSsmlEditor.bind(this, null),
            onAdd: this.updateSsml.bind(this),
            onUpdate: this.updateSsmlObject.bind(this),
            onRemove: this.handleDeleteObject.bind(this),
            ssml: this.state.editingObject ? this.ssmlParser.convertToString(this.state.editingObject) : "",
            ssmlObject: this.state.editingObject
        }) : null), (0, _react.jsx)("div", {
            className: `${fieldWrapper} ${props.disabled ? "disabled" : ""}`
        }, (0, _react.jsx)("div", {
            className: `${fieldContainer} ${props.disabled ? "disabled" : ""}`
        }, props.icon !== undefined ? (0, _react.jsx)("img", {
            className: "icon",
            src: props.icon
        }) : null, this.renderViewer(), (0, _react.jsx)("img", {
            className: "ssml-button",
            onClick: this.toggleSsmlEditor.bind(this, null),
            src: ssmlIcon
        })), props.canDelete && props.canCopy && props.deletePosition == "right" ? (0, _react.jsx)((0, _buttonDefault.default), {
            additionalClasses: deleteLargeIconStyle,
            type: "button",
            onClick: props.onDelete,
            themes: [
                "icon"
            ],
            icon: deleteIcon
        }) : null), (0, _react.jsx)("div", {
            className: "bottom-container"
        }, this.state.renderError ? (0, _react.jsx)("div", {
            className: "error-text"
        }, this.state.renderError) : null, (0, _react.jsx)("div", {
            className: "view-switch",
            onClick: this.togglePreviewer.bind(this, null)
        }, this.state.isRaw ? "Rich SSML" : "Plain SSML")), (0, _react.jsx)((0, _fieldErrorDefault.default), {
            name: props.name
        }));
    }
}
const noBorder = /*#__PURE__*/ (0, _css.css)({
    name: "ifofbd",
    styles: "border-left:none"
});
const textFieldStyles = /*#__PURE__*/ (0, _css.css)("color:", (0, _colors.dark_grey_blue), ";font-family:Muli;text-align:left;min-height:34px;line-height:32px;width:100%;border:none;padding:8px 16px;font-size:14px;margin:12px 0;resize:none;border-left:1px solid ", (0, _colors.silver_two), ";border-right:1px solid ", (0, _colors.silver_two), ";::placeholder{font-weight:normal;font-style:italic;font-stretch:normal;line-height:32px;letter-spacing:normal;color:", (0, _colors.cool_grey), ";}", "");
const containerStyle = /*#__PURE__*/ (0, _css.css)("margin-bottom:24px;flex:1;&.tight{margin-bottom:8px;label{margin:8px 16px 0 16px;}}.bottom-container{display:flex;margin:4px 2px;.error-text{color:", (0, _colors.faded_red), ";font-size:12px;flex:1;}.view-switch{color:", (0, _colors.color_colors_ocean), ";font-size:10px;text-align:right;margin:0 8px 0 auto;cursor:pointer;}}", "");
const modalContainer = /*#__PURE__*/ (0, _css.css)({
    name: "bjn8wh",
    styles: "position:relative"
});
const labelStyle = /*#__PURE__*/ (0, _css.css)({
    name: "1m6o4l9",
    styles: "font-family:Muli;font-size:14px;font-weight:600;text-align:left;margin:0 16px"
});
const deleteIconStyle = /*#__PURE__*/ (0, _css.css)({
    name: "1if73ow",
    styles: "height:14px;margin:0;margin-top:24px;margin-bottom:0;img{height:14px;}"
});
const deleteLargeIconStyle = /*#__PURE__*/ (0, _css.css)({
    name: "st4yhz",
    styles: "height:32px;margin-left:24px;margin-right:0;img{height:32px;&.left-img{margin-right:0;}}"
});
const tooltipStyle = /*#__PURE__*/ (0, _css.css)({
    name: "3xaa4j",
    styles: "margin:0;margin-top:24px;margin-bottom:0"
});
const labelContainer = /*#__PURE__*/ (0, _css.css)({
    name: "1x17g94",
    styles: "display:flex;align-items:center;width:100%"
});
const labelSection = /*#__PURE__*/ (0, _css.css)({
    name: "y37upr",
    styles: "display:flex;align-items:center;flex:1"
});
const fieldWrapper = /*#__PURE__*/ (0, _css.css)({
    name: "fhxb3m",
    styles: "display:flex;flex-direction:row;align-items:center"
});
const requiredLabelStyle = /*#__PURE__*/ (0, _css.css)("margin-right:0;margin-left:auto;margin-top:14px;margin-bottom:-20px;font-family:Muli;font-size:24px;color:", (0, _colors.faded_red), ";", "");
const fieldContainer = /*#__PURE__*/ (0, _css.css)("position:relative;display:flex;align-items:center;width:100%;border-radius:5px;border:solid 1px ", (0, _colors.silver_two), ";background:white;margin-top:8px;.icon{margin:16px;}.ssml-button{margin:18px 6px 0 6px;cursor:pointer;align-self:start;}&.disabled{background:", (0, _colors.color_shades_light), ";}", "");
exports.default = SsmlField;

},{"@babel/runtime/helpers/defineProperty":"9sJxO","@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","react-textarea-autosize":"6xuq0","../../general/IconTooltip":"3FODC","../../general/Button":"6ymxN","../FieldError":"fDxhz","../../general/ResponseVariableTestButton":"4kMKl","../../../constants/colors":"1p3OR","./SsmlManager":"8ZCCc","./SsmlPreviewer":"eiqAH","../../../services/ssmlParseService":"7FRoV","../../general/TooltipWrapper":"53pWd","2303b028fa2a729c":"1GCXR","e7f6a4f7f6c53ab4":"jrTqc","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6xuq0":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inheritsLoose = require("@babel/runtime/helpers/esm/inheritsLoose");
var _inheritsLooseDefault = parcelHelpers.interopDefault(_inheritsLoose);
var _react = require("react");
var _propTypes = require("prop-types");
var isIE = !!document.documentElement.currentStyle;
var HIDDEN_TEXTAREA_STYLE = {
    "min-height": "0",
    "max-height": "none",
    height: "0",
    visibility: "hidden",
    overflow: "hidden",
    position: "absolute",
    "z-index": "-1000",
    top: "0",
    right: "0"
};
var SIZING_STYLE = [
    "letter-spacing",
    "line-height",
    "font-family",
    "font-weight",
    "font-size",
    "font-style",
    "tab-size",
    "text-rendering",
    "text-transform",
    "width",
    "text-indent",
    "padding-top",
    "padding-right",
    "padding-bottom",
    "padding-left",
    "border-top-width",
    "border-right-width",
    "border-bottom-width",
    "border-left-width",
    "box-sizing"
];
var computedStyleCache = {};
var hiddenTextarea = document.createElement("textarea");
var forceHiddenStyles = function forceHiddenStyles(node) {
    Object.keys(HIDDEN_TEXTAREA_STYLE).forEach(function(key) {
        node.style.setProperty(key, HIDDEN_TEXTAREA_STYLE[key], "important");
    });
};
hiddenTextarea.setAttribute("tab-index", "-1");
hiddenTextarea.setAttribute("aria-hidden", "true");
forceHiddenStyles(hiddenTextarea);
function calculateNodeHeight(uiTextNode, uid, useCache, minRows, maxRows) {
    if (useCache === void 0) useCache = false;
    if (minRows === void 0) minRows = null;
    if (maxRows === void 0) maxRows = null;
    if (hiddenTextarea.parentNode === null) document.body.appendChild(hiddenTextarea);
     // Copy all CSS properties that have an impact on the height of the content in
    // the textbox
    var nodeStyling = calculateNodeStyling(uiTextNode, uid, useCache);
    if (nodeStyling === null) return null;
    var paddingSize = nodeStyling.paddingSize, borderSize = nodeStyling.borderSize, boxSizing = nodeStyling.boxSizing, sizingStyle = nodeStyling.sizingStyle; // Need to have the overflow attribute to hide the scrollbar otherwise
    // text-lines will not calculated properly as the shadow will technically be
    // narrower for content
    Object.keys(sizingStyle).forEach(function(key) {
        hiddenTextarea.style[key] = sizingStyle[key];
    });
    forceHiddenStyles(hiddenTextarea);
    hiddenTextarea.value = uiTextNode.value || uiTextNode.placeholder || "x";
    var minHeight = -Infinity;
    var maxHeight = Infinity;
    var height = hiddenTextarea.scrollHeight;
    if (boxSizing === "border-box") // border-box: add border, since height = content + padding + border
    height = height + borderSize;
    else if (boxSizing === "content-box") // remove padding, since height = content
    height = height - paddingSize;
     // measure height of a textarea with a single row
    hiddenTextarea.value = "x";
    var singleRowHeight = hiddenTextarea.scrollHeight - paddingSize; // Stores the value's rows count rendered in `hiddenTextarea`,
    // regardless if `maxRows` or `minRows` props are passed
    var valueRowCount = Math.floor(height / singleRowHeight);
    if (minRows !== null) {
        minHeight = singleRowHeight * minRows;
        if (boxSizing === "border-box") minHeight = minHeight + paddingSize + borderSize;
        height = Math.max(minHeight, height);
    }
    if (maxRows !== null) {
        maxHeight = singleRowHeight * maxRows;
        if (boxSizing === "border-box") maxHeight = maxHeight + paddingSize + borderSize;
        height = Math.min(maxHeight, height);
    }
    var rowCount = Math.floor(height / singleRowHeight);
    return {
        height: height,
        minHeight: minHeight,
        maxHeight: maxHeight,
        rowCount: rowCount,
        valueRowCount: valueRowCount
    };
}
function calculateNodeStyling(node, uid, useCache) {
    if (useCache === void 0) useCache = false;
    if (useCache && computedStyleCache[uid]) return computedStyleCache[uid];
    var style = window.getComputedStyle(node);
    if (style === null) return null;
    var sizingStyle = SIZING_STYLE.reduce(function(obj, name) {
        obj[name] = style.getPropertyValue(name);
        return obj;
    }, {});
    var boxSizing = sizingStyle["box-sizing"]; // probably node is detached from DOM, can't read computed dimensions
    if (boxSizing === "") return null;
     // IE (Edge has already correct behaviour) returns content width as computed width
    // so we need to add manually padding and border widths
    if (isIE && boxSizing === "border-box") sizingStyle.width = parseFloat(sizingStyle.width) + parseFloat(style["border-right-width"]) + parseFloat(style["border-left-width"]) + parseFloat(style["padding-right"]) + parseFloat(style["padding-left"]) + "px";
    var paddingSize = parseFloat(sizingStyle["padding-bottom"]) + parseFloat(sizingStyle["padding-top"]);
    var borderSize = parseFloat(sizingStyle["border-bottom-width"]) + parseFloat(sizingStyle["border-top-width"]);
    var nodeInfo = {
        sizingStyle: sizingStyle,
        paddingSize: paddingSize,
        borderSize: borderSize,
        boxSizing: boxSizing
    };
    if (useCache) computedStyleCache[uid] = nodeInfo;
    return nodeInfo;
}
var purgeCache = function purgeCache(uid) {
    delete computedStyleCache[uid];
};
var noop = function noop() {};
var uid = 0;
var TextareaAutosize = /*#__PURE__*/ function(_React$Component) {
    (0, _inheritsLooseDefault.default)(TextareaAutosize, _React$Component);
    function TextareaAutosize(props) {
        var _this;
        _this = _React$Component.call(this, props) || this;
        _this._onRef = function(node) {
            _this._ref = node;
            var inputRef = _this.props.inputRef;
            if (typeof inputRef === "function") {
                inputRef(node);
                return;
            }
            inputRef.current = node;
        };
        _this._onChange = function(event) {
            if (!_this._controlled) _this._resizeComponent();
            _this.props.onChange(event, (0, _assertThisInitializedDefault.default)(_this));
        };
        _this._resizeComponent = function(callback) {
            if (callback === void 0) callback = noop;
            var nodeHeight = calculateNodeHeight(_this._ref, _this._uid, _this.props.useCacheForDOMMeasurements, _this.props.minRows, _this.props.maxRows);
            if (nodeHeight === null) {
                callback();
                return;
            }
            var height = nodeHeight.height, minHeight = nodeHeight.minHeight, maxHeight = nodeHeight.maxHeight, rowCount = nodeHeight.rowCount, valueRowCount = nodeHeight.valueRowCount;
            _this.rowCount = rowCount;
            _this.valueRowCount = valueRowCount;
            if (_this.state.height !== height || _this.state.minHeight !== minHeight || _this.state.maxHeight !== maxHeight) {
                _this.setState({
                    height: height,
                    minHeight: minHeight,
                    maxHeight: maxHeight
                }, callback);
                return;
            }
            callback();
        };
        _this.state = {
            height: props.style && props.style.height || 0,
            minHeight: -Infinity,
            maxHeight: Infinity
        };
        _this._uid = uid++;
        _this._controlled = props.value !== undefined;
        _this._resizeLock = false;
        return _this;
    }
    var _proto = TextareaAutosize.prototype;
    _proto.render = function render() {
        var _this$props = this.props, _inputRef = _this$props.inputRef, _maxRows = _this$props.maxRows, _minRows = _this$props.minRows, _onHeightChange = _this$props.onHeightChange, _useCacheForDOMMeasurements = _this$props.useCacheForDOMMeasurements, props = (0, _objectWithoutPropertiesLooseDefault.default)(_this$props, [
            "inputRef",
            "maxRows",
            "minRows",
            "onHeightChange",
            "useCacheForDOMMeasurements"
        ]);
        props.style = (0, _extendsDefault.default)({}, props.style, {
            height: this.state.height
        });
        var maxHeight = Math.max(props.style.maxHeight || Infinity, this.state.maxHeight);
        if (maxHeight < this.state.height) props.style.overflow = "hidden";
        return (0, _react.createElement)("textarea", (0, _extendsDefault.default)({}, props, {
            onChange: this._onChange,
            ref: this._onRef
        }));
    };
    _proto.componentDidMount = function componentDidMount() {
        var _this2 = this;
        this._resizeComponent(); // Working around Firefox bug which runs resize listeners even when other JS is running at the same moment
        // causing competing rerenders (due to setState in the listener) in React.
        // More can be found here - facebook/react#6324
        this._resizeListener = function() {
            if (_this2._resizeLock) return;
            _this2._resizeLock = true;
            _this2._resizeComponent(function() {
                _this2._resizeLock = false;
            });
        };
        window.addEventListener("resize", this._resizeListener);
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
        if (prevProps !== this.props) this._resizeComponent();
        if (this.state.height !== prevState.height) this.props.onHeightChange(this.state.height, this);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        window.removeEventListener("resize", this._resizeListener);
        purgeCache(this._uid);
    };
    return TextareaAutosize;
}((0, _react.Component));
TextareaAutosize.defaultProps = {
    inputRef: noop,
    onChange: noop,
    onHeightChange: noop,
    useCacheForDOMMeasurements: false
};
exports.default = TextareaAutosize;

},{"@babel/runtime/helpers/esm/extends":"fW5l8","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"5R6Zx","@babel/runtime/helpers/esm/assertThisInitialized":"hqdCW","@babel/runtime/helpers/esm/inheritsLoose":"9IZpV","react":"6uln9","prop-types":"6FKs7","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hqdCW":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_assertThisInitialized);
function _assertThisInitialized(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4kMKl":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _base = require("@emotion/styled/base");
var _baseDefault = parcelHelpers.interopDefault(_base);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _colors = require("../../constants/colors");
var _responseVariableTestModal = require("./ResponseVariableTestModal");
var _responseVariableTestModalDefault = parcelHelpers.interopDefault(_responseVariableTestModal);
var _tooltipWrapper = require("./TooltipWrapper");
var _tooltipWrapperDefault = parcelHelpers.interopDefault(_tooltipWrapper);
const testIcon = require("3057f8344b5ecab3");
/**
 * A button that opens the Response Variable Test modal.
 * Use this next to text fields that support response variables to allow users to test them.
 * 
 * @example
 * <ResponseVariableTestButton textValue={myTextFieldValue} />
 */ const ResponseVariableTestButton = (props)=>{
    const [isModalOpen, setIsModalOpen] = (0, _react1.useState)(false);
    const button = (0, _react.jsx)(TestButton, {
        className: props.className,
        onClick: ()=>setIsModalOpen(true),
        type: "button",
        title: props.tooltip || "Test response variables"
    }, (0, _react.jsx)("img", {
        src: testIcon,
        alt: "Test Variables"
    }));
    return (0, _react.jsx)((0, _reactDefault.default).Fragment, null, props.tooltip ? (0, _react.jsx)((0, _tooltipWrapperDefault.default), {
        text: props.tooltip,
        place: "top"
    }, button) : button, (0, _react.jsx)((0, _responseVariableTestModalDefault.default), {
        isVisible: isModalOpen,
        onClose: ()=>setIsModalOpen(false),
        initialText: props.textValue
    }));
};
const TestButton = /*#__PURE__*/ (0, _baseDefault.default)("button", {
    target: "e1xcrg4o0"
})("display:flex;align-items:center;justify-content:center;width:32px;height:32px;padding:6px;border:1px solid ", (0, _colors.silver_two), ";background:white;border-radius:4px;cursor:pointer;transition:all 0.15s ease;img{width:18px;height:18px;}&:hover{background:", (0, _colors.pale_grey), ";border-color:", (0, _colors.color_colors_ocean), ";}");
exports.default = ResponseVariableTestButton;

},{"@emotion/styled/base":"lSuFu","@emotion/react":"djZKr","react":"6uln9","../../constants/colors":"1p3OR","./ResponseVariableTestModal":"9BoiM","./TooltipWrapper":"53pWd","3057f8344b5ecab3":"ixkJq","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9BoiM":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _extends = require("@babel/runtime/helpers/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _base = require("@emotion/styled/base");
var _baseDefault = parcelHelpers.interopDefault(_base);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _modalLayout = require("../structure/ModalLayout");
var _modalLayoutDefault = parcelHelpers.interopDefault(_modalLayout);
var _button = require("./Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _colors = require("../../constants/colors");
var _useResponseVariableTester = require("../../hooks/useResponseVariableTester");
var _responseVariableTesterUI = require("./ResponseVariableTesterUI");
var _responseVariableTesterUIDefault = parcelHelpers.interopDefault(_responseVariableTesterUI);
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const closeIcon = require("d7140584b10d8936");
const DOCS_URL = "https://dev.azure.com/voicify/Voicify-Api/_wiki/wikis/Voicify-Api.wiki/39/Response-Variables?anchor=nesting-and-combining-features";
const ResponseVariableTestModal = (props)=>{
    const tester = (0, _useResponseVariableTester.useResponseVariableTester)({
        initialText: props.initialText
    });
    // Reset state when modal opens with new initial text
    (0, _react1.useEffect)(()=>{
        if (props.isVisible) {
            tester.reset();
            if (props.initialText) tester.setInputText(props.initialText);
        }
    }, [
        props.isVisible,
        props.initialText
    ]);
    return (0, _react.jsx)((0, _modalLayoutDefault.default), {
        className: modalStyle,
        isVisible: props.isVisible,
        onClose: props.onClose,
        zIndex: 1010
    }, (0, _react.jsx)(ModalContainer, {
        onClick: (e)=>e.stopPropagation()
    }, (0, _react.jsx)(HeaderWrapper, null, (0, _react.jsx)("h2", null, "Test Response Variables"), (0, _react.jsx)((0, _buttonDefault.default), {
        className: "close-icon",
        themes: [
            "end-tight",
            "icon"
        ],
        icon: closeIcon,
        type: "button",
        onClick: props.onClose
    })), (0, _react.jsx)((0, _responseVariableTesterUIDefault.default), (0, _extendsDefault.default)({}, tester, {
        docsUrl: DOCS_URL
    }))));
};
// Styles
const modalStyle = /*#__PURE__*/ (0, _css.css)({
    name: "1ednost",
    styles: ".modal-content{width:900px;max-width:95vw;max-height:90vh;overflow-y:auto;}"
});
const ModalContainer = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "eivnx3o1"
})({
    name: "vxuddk",
    styles: "padding:24px"
});
const HeaderWrapper = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "eivnx3o0"
})("display:flex;justify-content:space-between;align-items:center;margin-bottom:16px;h2{font-size:20px;font-weight:600;color:", (0, _colors.color_shades_darkest), ";margin:0;}");
exports.default = ResponseVariableTestModal;

},{"@babel/runtime/helpers/extends":"4iKIP","@emotion/styled/base":"lSuFu","@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","../structure/ModalLayout":"b1cO3","./Button":"6ymxN","../../constants/colors":"1p3OR","../../hooks/useResponseVariableTester":"ataUW","./ResponseVariableTesterUI":"cuEg7","d7140584b10d8936":"93VwA","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"ataUW":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useResponseVariableTester", ()=>useResponseVariableTester);
var _react = require("react");
var _responseVariable = require("../api/controllers/responseVariable");
var _colors = require("../constants/colors");
const useResponseVariableTester = (options = {})=>{
    const { initialText = "", debounceMs = 500 } = options;
    const [inputText, setInputText] = (0, _react.useState)(initialText);
    const [variableValues, setVariableValues] = (0, _react.useState)(new Map());
    const [isLoading, setIsLoading] = (0, _react.useState)(false);
    const [replacedText, setReplacedText] = (0, _react.useState)(null);
    const [error, setError] = (0, _react.useState)(null);
    const debounceTimerRef = (0, _react.useRef)(null);
    /**
   * Detects response variables in the input text.
   * Variables follow the pattern: prefix.path where prefix can be:
   * - session, user, constant, variable, prompt, slot, nlp, feature
   * And path can contain dots, hyphens, and underscores
   */ const detectedVariables = (0, _react.useMemo)(()=>{
        if (!inputText) return [];
        const variablePattern = /\b(session|user|constant|variable|prompt|slot|nlp|feature)\.([a-zA-Z0-9_\-\.]+)/g;
        const variables = [];
        const seen = new Set();
        let match;
        while((match = variablePattern.exec(inputText)) !== null){
            const fullReference = match[0];
            if (!seen.has(fullReference)) {
                seen.add(fullReference);
                variables.push({
                    fullReference,
                    category: match[1],
                    path: match[2]
                });
            }
        }
        return variables;
    }, [
        inputText
    ]);
    // Initialize new variable values when detected variables change
    (0, _react.useEffect)(()=>{
        setVariableValues((prevValues)=>{
            const newValues = new Map(prevValues);
            // Add new variables with default state
            detectedVariables.forEach((variable)=>{
                if (!newValues.has(variable.fullReference)) newValues.set(variable.fullReference, {
                    state: "string",
                    stringValue: "",
                    numberValue: 0,
                    booleanValue: false
                });
            });
            // Remove variables that are no longer detected
            const currentRefs = new Set(detectedVariables.map((v)=>v.fullReference));
            for (const key of newValues.keys())if (!currentRefs.has(key)) newValues.delete(key);
            return newValues;
        });
    }, [
        detectedVariables
    ]);
    const handleValueStateChange = (0, _react.useCallback)((fullReference, state)=>{
        setVariableValues((prev)=>{
            const newValues = new Map(prev);
            const current = newValues.get(fullReference);
            newValues.set(fullReference, {
                state,
                stringValue: current?.stringValue || "",
                numberValue: current?.numberValue ?? 0,
                booleanValue: current?.booleanValue ?? false
            });
            return newValues;
        });
    }, []);
    const handleStringValueChange = (0, _react.useCallback)((fullReference, value)=>{
        setVariableValues((prev)=>{
            const newValues = new Map(prev);
            const current = newValues.get(fullReference);
            newValues.set(fullReference, {
                state: "string",
                stringValue: value,
                numberValue: current?.numberValue ?? 0,
                booleanValue: current?.booleanValue ?? false
            });
            return newValues;
        });
    }, []);
    const handleNumberValueChange = (0, _react.useCallback)((fullReference, value)=>{
        setVariableValues((prev)=>{
            const newValues = new Map(prev);
            const current = newValues.get(fullReference);
            newValues.set(fullReference, {
                state: "number",
                stringValue: current?.stringValue || "",
                numberValue: value,
                booleanValue: current?.booleanValue ?? false
            });
            return newValues;
        });
    }, []);
    const handleBooleanValueChange = (0, _react.useCallback)((fullReference, value)=>{
        setVariableValues((prev)=>{
            const newValues = new Map(prev);
            const current = newValues.get(fullReference);
            newValues.set(fullReference, {
                state: "boolean",
                stringValue: current?.stringValue || "",
                numberValue: current?.numberValue ?? 0,
                booleanValue: value
            });
            return newValues;
        });
    }, []);
    /**
   * Sets a nested value in an object using dot-notation path
   */ const setNestedValue = (obj, path, value)=>{
        const parts = path.split(".");
        let current = obj;
        for(let i = 0; i < parts.length - 1; i++){
            const part = parts[i];
            if (!current[part] || typeof current[part] !== "object") current[part] = {};
            current = current[part];
        }
        current[parts[parts.length - 1]] = value;
    };
    const buildRequest = (0, _react.useCallback)(()=>{
        const request = {
            text: inputText,
            variables: [],
            sessionAttributes: {},
            userAttributes: {},
            slots: {}
        };
        detectedVariables.forEach((variable)=>{
            const fieldValue = variableValues.get(variable.fullReference);
            if (!fieldValue) return;
            // Determine the actual value based on state
            let actualValue;
            if (fieldValue.state === "null") actualValue = null;
            else if (fieldValue.state === "undefined") // For undefined, we simply don't include the value
            return;
            else if (fieldValue.state === "number") actualValue = fieldValue.numberValue;
            else if (fieldValue.state === "boolean") actualValue = fieldValue.booleanValue;
            else actualValue = fieldValue.stringValue;
            // Route the value to the appropriate category
            switch(variable.category){
                case "constant":
                case "variable":
                case "prompt":
                    request.variables.push({
                        name: variable.path,
                        value: actualValue ?? ""
                    });
                    break;
                case "session":
                    setNestedValue(request.sessionAttributes, variable.path, actualValue);
                    break;
                case "user":
                    setNestedValue(request.userAttributes, variable.path, actualValue);
                    break;
                case "slot":
                    if (actualValue !== null) request.slots[variable.path] = actualValue;
                    break;
                default:
                    // For nlp, feature, or unknown - add to session attributes as fallback
                    setNestedValue(request.sessionAttributes, variable.fullReference, actualValue);
                    break;
            }
        });
        return request;
    }, [
        inputText,
        detectedVariables,
        variableValues
    ]);
    // Debounced auto-run effect
    (0, _react.useEffect)(()=>{
        if (debounceTimerRef.current) clearTimeout(debounceTimerRef.current);
        if (!inputText.trim()) {
            setReplacedText(null);
            return;
        }
        debounceTimerRef.current = setTimeout(async ()=>{
            setIsLoading(true);
            setError(null);
            try {
                const request = buildRequest();
                const result = await (0, _responseVariable.replaceResponseVariables)(request);
                if (result.resultType === "Ok" && result.data) setReplacedText(result.data.replacedText);
                else setError("Failed to perform variable replacement.");
            } catch (err) {
                setError("An error occurred while processing the request.");
                console.error("Response variable replacement error:", err);
            } finally{
                setIsLoading(false);
            }
        }, debounceMs);
        return ()=>{
            if (debounceTimerRef.current) clearTimeout(debounceTimerRef.current);
        };
    }, [
        inputText,
        variableValues,
        buildRequest,
        debounceMs
    ]);
    const getCategoryColor = (0, _react.useCallback)((category)=>{
        switch(category){
            case "session":
                return 0, _colors.color_colors_ocean;
            case "user":
                return 0, _colors.color_colors_royalty;
            case "constant":
            case "variable":
            case "prompt":
                return 0, _colors.color_colors_growth;
            case "slot":
                return 0, _colors.color_colors_decline;
            case "nlp":
                return 0, _colors.color_colors_gold;
            case "feature":
                return 0, _colors.color_colors_sky;
            default:
                return 0, _colors.color_shades_darker;
        }
    }, []);
    const reset = (0, _react.useCallback)(()=>{
        setInputText(initialText);
        setVariableValues(new Map());
        setReplacedText(null);
        setError(null);
    }, [
        initialText
    ]);
    return {
        inputText,
        setInputText,
        variableValues,
        isLoading,
        replacedText,
        error,
        detectedVariables,
        handleValueStateChange,
        handleStringValueChange,
        handleNumberValueChange,
        handleBooleanValueChange,
        getCategoryColor,
        reset
    };
};
exports.default = useResponseVariableTester;

},{"react":"6uln9","../api/controllers/responseVariable":"eNQvT","../constants/colors":"1p3OR","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"eNQvT":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "replaceResponseVariables", ()=>replaceResponseVariables);
parcelHelpers.export(exports, "chatWithResponseVariableAssistant", ()=>chatWithResponseVariableAssistant);
var _generic = require("./generic");
var _urls = require("../../constants/Urls");
const replaceResponseVariables = (request)=>{
    return (0, _generic.sendPost)(`/ResponseVariable/Replace`, request, (0, _urls.getAssistantApiUrl)());
};
const chatWithResponseVariableAssistant = (request)=>{
    return (0, _generic.sendPost)(`/responseVariable/chat`, request, (0, _urls.getAssistantApiUrl)());
};

},{"./generic":"6oGDt","../../constants/Urls":"iTopY","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"cuEg7":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _base = require("@emotion/styled/base");
var _baseDefault = parcelHelpers.interopDefault(_base);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _reactMarkdown = require("react-markdown");
var _reactMarkdownDefault = parcelHelpers.interopDefault(_reactMarkdown);
var _colors = require("../../constants/colors");
var _responseVariable = require("../../api/controllers/responseVariable");
var _useApplicationCredentials = require("../../hooks/useApplicationCredentials");
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const copyIcon = require("8efd31a832856254");
const sendIcon = require("58c8d898ab6f9072");
const ResponseVariableTesterUI = ({ inputText, setInputText, variableValues, isLoading, replacedText, error, detectedVariables, handleValueStateChange, handleStringValueChange, handleNumberValueChange, handleBooleanValueChange, getCategoryColor, placeholder = "Hello {{session.name}}, your order total is {{constant.currency}}{{session.order.total}}.", docsUrl })=>{
    // Get credentials automatically from the user's organizations/applications
    const { applicationId, applicationSecret } = (0, _useApplicationCredentials.useApplicationCredentials)();
    // AI Chat state
    const [chatHistory, setChatHistory] = (0, _react1.useState)([]);
    const [chatInput, setChatInput] = (0, _react1.useState)("");
    const [isChatLoading, setIsChatLoading] = (0, _react1.useState)(false);
    const chatHistoryRef = (0, _react1.useRef)(null);
    // Auto-scroll to bottom when chat history updates
    (0, _react1.useEffect)(()=>{
        if (chatHistoryRef.current) chatHistoryRef.current.scrollTop = chatHistoryRef.current.scrollHeight;
    }, [
        chatHistory
    ]);
    const handleSendMessage = async ()=>{
        if (!chatInput.trim() || isChatLoading || !applicationId || !applicationSecret) return;
        // Build the user message with context about current input/result/variables
        let messageText = chatInput.trim();
        const hasContext = inputText || replacedText || variableValues.size > 0;
        if (hasContext) {
            let context = "\n\n---\nContext:";
            if (inputText) context += `\nCurrent Input: ${inputText}`;
            if (replacedText) context += `\nCurrent Result: ${replacedText}`;
            if (variableValues.size > 0) {
                context += "\nConfigured Variables:";
                variableValues.forEach((fieldValue, varName)=>{
                    let valueDisplay;
                    switch(fieldValue.state){
                        case "string":
                            valueDisplay = `"${fieldValue.stringValue}"`;
                            break;
                        case "number":
                            valueDisplay = String(fieldValue.numberValue);
                            break;
                        case "boolean":
                            valueDisplay = String(fieldValue.booleanValue);
                            break;
                        case "null":
                            valueDisplay = "null";
                            break;
                        case "undefined":
                            valueDisplay = "undefined";
                            break;
                        default:
                            valueDisplay = "unknown";
                    }
                    context += `\n  - ${varName}: ${valueDisplay} (${fieldValue.state})`;
                });
            }
            messageText += context;
        }
        const userMessage = {
            role: "user",
            text: messageText
        };
        // Show only the user's question in the UI, not the context
        const displayMessage = {
            role: "user",
            text: chatInput.trim()
        };
        const newHistory = [
            ...chatHistory,
            displayMessage
        ];
        const historyForApi = [
            ...chatHistory,
            userMessage
        ];
        setChatHistory(newHistory);
        setChatInput("");
        setIsChatLoading(true);
        try {
            const response = await (0, _responseVariable.chatWithResponseVariableAssistant)({
                applicationId,
                applicationSecret,
                conversationHistory: historyForApi
            });
            if (response.data?.response) {
                const assistantMessage = {
                    role: "assistant",
                    text: response.data.response
                };
                setChatHistory([
                    ...newHistory,
                    assistantMessage
                ]);
            }
        } catch (err) {
            const errorMessage = {
                role: "assistant",
                text: "Sorry, I encountered an error. Please try again."
            };
            setChatHistory([
                ...newHistory,
                errorMessage
            ]);
        } finally{
            setIsChatLoading(false);
        }
    };
    const handleChatKeyDown = (e)=>{
        if (e.key === "Enter" && !e.shiftKey) {
            e.preventDefault();
            handleSendMessage();
        }
    };
    const formatChatHistory = ()=>{
        if (chatHistory.length === 0) return "Ask me anything about response variables...\n\nExamples:\n• How do I use session variables?\n• What's the syntax for nested objects?\n• How do constant variables work?";
        return chatHistory.map((turn)=>`${turn.role === "user" ? "You" : "Assistant"}: ${turn.text}`).join("\n\n");
    };
    const copyChatHistory = ()=>{
        navigator.clipboard.writeText(formatChatHistory());
    };
    return (0, _react.jsx)(Container, null, docsUrl && (0, _react.jsx)(DocsLink, {
        href: docsUrl,
        target: "_blank",
        rel: "noopener noreferrer"
    }, "View Response Variables Documentation →"), (0, _react.jsx)(TopSection, null, (0, _react.jsx)(ChatPane, null, (0, _react.jsx)(InputHeader, null, (0, _react.jsx)(SectionTitle, null, "AI Assistant"), (0, _react.jsx)(ChatHeaderButtons, null, (0, _react.jsx)(CopyButton, {
        onClick: ()=>setChatHistory([]),
        disabled: chatHistory.length === 0,
        title: "Start over"
    }, "Start Over"), (0, _react.jsx)(CopyButton, {
        onClick: copyChatHistory,
        disabled: chatHistory.length === 0,
        title: "Copy chat history"
    }, (0, _react.jsx)("img", {
        src: copyIcon,
        alt: "Copy"
    }), "Copy"))), (0, _react.jsx)(SectionDescription, null, "Ask AI how to use response variables."), (0, _react.jsx)(ChatHistoryBox, {
        ref: chatHistoryRef
    }, chatHistory.length === 0 ? (0, _react.jsx)(ChatPlaceholder, null, "Ask me anything about response variables...", (0, _react.jsx)("br", null), (0, _react.jsx)("br", null), "Examples:", (0, _react.jsx)("br", null), "• How do I use session variables?", (0, _react.jsx)("br", null), "• What's the syntax for nested objects?", (0, _react.jsx)("br", null), "• How do constant variables work?") : chatHistory.map((turn, index)=>(0, _react.jsx)(ChatMessage, {
            key: index,
            $isUser: turn.role === "user"
        }, (0, _react.jsx)(ChatMessageLabel, null, turn.role === "user" ? "You" : "Assistant"), turn.role === "assistant" ? (0, _react.jsx)(MarkdownContent, null, (0, _react.jsx)((0, _reactMarkdownDefault.default), {
            linkTarget: "_blank"
        }, turn.text)) : (0, _react.jsx)(UserMessageText, null, turn.text)))), (0, _react.jsx)(ChatInputRow, null, (0, _react.jsx)(ChatInput, {
        type: "text",
        value: chatInput,
        onChange: (e)=>setChatInput(e.target.value),
        onKeyDown: handleChatKeyDown,
        placeholder: "Ask about response variables...",
        disabled: isChatLoading
    }), (0, _react.jsx)(SendButton, {
        onClick: handleSendMessage,
        disabled: !chatInput.trim() || isChatLoading,
        title: "Send message"
    }, isChatLoading ? (0, _react.jsx)(LoadingSpinner, null) : (0, _react.jsx)("img", {
        src: sendIcon,
        alt: "Send"
    })))), (0, _react.jsx)(InputPane, null, (0, _react.jsx)(InputHeader, null, (0, _react.jsx)(SectionTitle, null, "Input Text"), (0, _react.jsx)(CopyButton, {
        onClick: ()=>navigator.clipboard.writeText(inputText),
        disabled: !inputText.trim(),
        title: "Copy to clipboard"
    }, (0, _react.jsx)("img", {
        src: copyIcon,
        alt: "Copy"
    }), "Copy")), (0, _react.jsx)(SectionDescription, null, "Enter text containing response variables. Variables are automatically detected."), (0, _react.jsx)(TextAreaInput, {
        value: inputText,
        onChange: (e)=>setInputText(e.target.value),
        placeholder: placeholder,
        rows: 6
    })), (0, _react.jsx)(ResultPane, null, (0, _react.jsx)(SectionTitle, null, "Result ", isLoading && (0, _react.jsx)(LoadingIndicator, null, "(updating...)")), (0, _react.jsx)(SectionDescription, null, "Replaced text will appear here automatically."), error ? (0, _react.jsx)(ErrorMessage, null, error) : replacedText !== null ? (0, _react.jsx)(ResultTextArea, {
        readOnly: true,
        value: replacedText,
        rows: 6
    }) : (0, _react.jsx)(ResultPlaceholder, null, "Enter text with variables to see the result..."))), detectedVariables.length > 0 && (0, _react.jsx)(Section, null, (0, _react.jsx)(SectionTitle, null, "Detected Variables (", detectedVariables.length, ")"), (0, _react.jsx)(SectionDescription, null, "Configure values for each detected variable."), (0, _react.jsx)(VariablesList, null, detectedVariables.map((variable)=>{
        const fieldValue = variableValues.get(variable.fullReference) || {
            state: "string",
            stringValue: "",
            numberValue: 0,
            booleanValue: false
        };
        return (0, _react.jsx)(VariableField, {
            key: variable.fullReference
        }, (0, _react.jsx)(VariableHeader, null, (0, _react.jsx)(CategoryBadge, {
            style: {
                backgroundColor: getCategoryColor(variable.category)
            }
        }, variable.category), (0, _react.jsx)(VariableName, null, variable.fullReference)), (0, _react.jsx)(VariableControls, null, (0, _react.jsx)(StateSelector, null, (0, _react.jsx)(StateButton, {
            className: fieldValue.state === "string" ? "active" : "",
            onClick: ()=>handleValueStateChange(variable.fullReference, "string")
        }, "String"), (0, _react.jsx)(StateButton, {
            className: fieldValue.state === "number" ? "active" : "",
            onClick: ()=>handleValueStateChange(variable.fullReference, "number")
        }, "Number"), (0, _react.jsx)(StateButton, {
            className: fieldValue.state === "boolean" ? "active" : "",
            onClick: ()=>handleValueStateChange(variable.fullReference, "boolean")
        }, "Boolean"), (0, _react.jsx)(StateButton, {
            className: fieldValue.state === "null" ? "active" : "",
            onClick: ()=>handleValueStateChange(variable.fullReference, "null")
        }, "null"), (0, _react.jsx)(StateButton, {
            className: fieldValue.state === "undefined" ? "active" : "",
            onClick: ()=>handleValueStateChange(variable.fullReference, "undefined")
        }, "undefined")), fieldValue.state === "string" && (0, _react.jsx)(ValueInput, {
            type: "text",
            value: fieldValue.stringValue,
            onChange: (e)=>handleStringValueChange(variable.fullReference, e.target.value),
            placeholder: "Enter value..."
        }), fieldValue.state === "number" && (0, _react.jsx)(ValueInput, {
            type: "number",
            value: fieldValue.numberValue,
            onChange: (e)=>handleNumberValueChange(variable.fullReference, parseFloat(e.target.value) || 0),
            placeholder: "Enter number..."
        }), fieldValue.state === "boolean" && (0, _react.jsx)(BooleanSelector, null, (0, _react.jsx)(BooleanButton, {
            className: fieldValue.booleanValue === true ? "active-true" : "",
            onClick: ()=>handleBooleanValueChange(variable.fullReference, true)
        }, "true"), (0, _react.jsx)(BooleanButton, {
            className: fieldValue.booleanValue === false ? "active-false" : "",
            onClick: ()=>handleBooleanValueChange(variable.fullReference, false)
        }, "false")), (fieldValue.state === "null" || fieldValue.state === "undefined") && (0, _react.jsx)(ValuePlaceholder, null, fieldValue.state === "null" ? "Value will be null" : "Value will be undefined (not sent)")));
    }))));
};
// Styles
const Container = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1fs3nki38"
})("");
const DocsLink = /*#__PURE__*/ (0, _baseDefault.default)("a", {
    target: "e1fs3nki37"
})("display:inline-block;margin-bottom:20px;font-size:14px;color:", (0, _colors.color_colors_ocean), ";text-decoration:none;font-weight:500;&:hover{text-decoration:underline;}");
const TopSection = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1fs3nki36"
})({
    name: "d03who",
    styles: "display:flex;gap:24px;margin-bottom:24px"
});
const InputPane = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1fs3nki35"
})({
    name: "fxp7t8",
    styles: "flex:1;min-width:0"
});
const ResultPane = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1fs3nki34"
})({
    name: "fxp7t8",
    styles: "flex:1;min-width:0"
});
const ChatPane = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1fs3nki33"
})({
    name: "6ey9w8",
    styles: "flex:1;min-width:0;display:flex;flex-direction:column"
});
const ChatHeaderButtons = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1fs3nki32"
})({
    name: "11jf4ye",
    styles: "display:flex;gap:8px"
});
const ChatHistoryBox = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1fs3nki31"
})("width:100%;min-height:100px;max-height:200px;padding:12px 16px;border:1px solid ", (0, _colors.silver_two), ";border-radius:8px;font-size:14px;color:", (0, _colors.color_shades_darkest), ";background:", (0, _colors.pale_grey), ";overflow-y:auto;overflow-x:hidden;box-sizing:border-box;flex:1;");
const ChatPlaceholder = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1fs3nki30"
})("color:", (0, _colors.color_shades_dark), ";font-style:italic;font-size:13px;");
const ChatMessage = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1fs3nki29"
})("margin-bottom:12px;padding-bottom:12px;border-bottom:1px solid ", (0, _colors.silver_two), ";&:last-child{margin-bottom:0;padding-bottom:0;border-bottom:none;}");
const ChatMessageLabel = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1fs3nki28"
})("font-size:11px;font-weight:600;color:", (0, _colors.color_shades_darker), ";text-transform:uppercase;letter-spacing:0.5px;margin-bottom:4px;");
const UserMessageText = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1fs3nki27"
})("font-size:14px;color:", (0, _colors.color_shades_darkest), ";");
const MarkdownContent = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1fs3nki26"
})("font-size:14px;color:", (0, _colors.color_shades_darkest), ";p{margin:0 0 8px 0;&:last-child{margin-bottom:0;}}code{background:white;padding:2px 6px;border-radius:4px;font-family:'Consolas','Monaco',monospace;font-size:13px;border:1px solid ", (0, _colors.silver_two), ";}pre{background:white;padding:12px;border-radius:6px;overflow-x:auto;border:1px solid ", (0, _colors.silver_two), ";margin:8px 0;code{background:none;padding:0;border:none;}}ul,ol{margin:8px 0;padding-left:20px;}li{margin-bottom:4px;}a{color:", (0, _colors.color_colors_ocean), ";text-decoration:none;&:hover{text-decoration:underline;}}strong{font-weight:600;}");
const ChatInputRow = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1fs3nki25"
})({
    name: "17qr8it",
    styles: "display:flex;gap:8px;margin-top:8px"
});
const ChatInput = /*#__PURE__*/ (0, _baseDefault.default)("input", {
    target: "e1fs3nki24"
})("flex:1;padding:10px 12px;border:1px solid ", (0, _colors.silver_two), ";border-radius:6px;font-size:14px;color:", (0, _colors.color_shades_darkest), ";background:white;box-sizing:border-box;&::placeholder{color:", (0, _colors.color_shades_dark), ";font-style:italic;}&:focus{outline:none;border-color:", (0, _colors.color_colors_ocean), ";}&:disabled{background:", (0, _colors.pale_grey), ";cursor:not-allowed;}");
const SendButton = /*#__PURE__*/ (0, _baseDefault.default)("button", {
    target: "e1fs3nki23"
})("display:flex;align-items:center;justify-content:center;width:40px;height:40px;border:1px solid ", (0, _colors.color_colors_ocean), ";background:", (0, _colors.color_colors_ocean), ";border-radius:6px;cursor:pointer;transition:all 0.15s ease;img{width:18px;height:18px;filter:brightness(0) invert(1);}&:hover:not(:disabled){background:", (0, _colors.color_shades_darkest), ";border-color:", (0, _colors.color_shades_darkest), ";}&:disabled{opacity:0.5;cursor:not-allowed;}");
const LoadingSpinner = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1fs3nki22"
})({
    name: "86gs48",
    styles: "width:18px;height:18px;border:2px solid white;border-top-color:transparent;border-radius:50%;animation:spin 0.8s linear infinite;@keyframes spin{to{transform:rotate(360deg);}}"
});
const InputHeader = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1fs3nki21"
})({
    name: "4bl220",
    styles: "display:flex;align-items:center;justify-content:space-between;margin-bottom:8px"
});
const CopyButton = /*#__PURE__*/ (0, _baseDefault.default)("button", {
    target: "e1fs3nki20"
})("display:flex;align-items:center;gap:6px;padding:6px 12px;border:1px solid ", (0, _colors.silver_two), ";background:white;border-radius:4px;font-size:12px;font-weight:500;color:", (0, _colors.color_shades_darker), ";cursor:pointer;transition:all 0.15s ease;img{width:14px;height:14px;}&:hover:not(:disabled){background:", (0, _colors.pale_grey), ";border-color:", (0, _colors.color_colors_ocean), ";color:", (0, _colors.color_colors_ocean), ";}&:disabled{opacity:0.5;cursor:not-allowed;}");
const Section = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1fs3nki19"
})({
    name: "omjb37",
    styles: "margin-bottom:24px;&:last-child{margin-bottom:0;}"
});
const SectionTitle = /*#__PURE__*/ (0, _baseDefault.default)("h4", {
    target: "e1fs3nki18"
})("font-size:16px;font-weight:600;color:", (0, _colors.color_shades_darkest), ";margin:0;");
const SectionDescription = /*#__PURE__*/ (0, _baseDefault.default)("p", {
    target: "e1fs3nki17"
})("font-size:14px;color:", (0, _colors.color_shades_darker), ";margin:8px 0 16px 0;");
const LoadingIndicator = /*#__PURE__*/ (0, _baseDefault.default)("span", {
    target: "e1fs3nki16"
})("font-size:12px;font-weight:400;color:", (0, _colors.color_shades_darker), ";font-style:italic;margin-left:8px;");
const TextAreaInput = /*#__PURE__*/ (0, _baseDefault.default)("textarea", {
    target: "e1fs3nki15"
})("width:100%;min-height:100px;padding:12px 16px;border:1px solid ", (0, _colors.silver_two), ";border-radius:8px;font-family:'Muli',sans-serif;font-size:14px;color:", (0, _colors.color_shades_darkest), ";resize:vertical;box-sizing:border-box;&::placeholder{color:", (0, _colors.color_shades_dark), ";font-style:italic;}&:focus{outline:none;border-color:", (0, _colors.color_colors_ocean), ";box-shadow:0 0 0 2px ", (0, _colors.color_variants_ocean_light_2), ";}");
const ResultTextArea = /*#__PURE__*/ (0, _baseDefault.default)("textarea", {
    target: "e1fs3nki14"
})("width:100%;min-height:100px;padding:12px 16px;border:1px solid ", (0, _colors.color_colors_growth), ";border-radius:8px;font-family:'Muli',sans-serif;font-size:14px;color:", (0, _colors.color_shades_darkest), ";background:", (0, _colors.color_colors_growth_background), ";resize:vertical;box-sizing:border-box;&:focus{outline:none;}");
const ResultPlaceholder = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1fs3nki13"
})("width:100%;min-height:100px;padding:12px 16px;border:1px dashed ", (0, _colors.silver_two), ";border-radius:8px;font-size:14px;color:", (0, _colors.color_shades_dark), ";font-style:italic;box-sizing:border-box;display:flex;align-items:center;justify-content:center;text-align:center;");
const ErrorMessage = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1fs3nki12"
})("padding:12px 16px;background:", (0, _colors.color_variants_decline_light_1), ";border:1px solid ", (0, _colors.color_variants_red_2), ";border-radius:8px;color:", (0, _colors.color_colors_decline), ";font-size:14px;");
const VariablesList = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1fs3nki11"
})({
    name: "pc30zn",
    styles: "display:flex;flex-direction:column;gap:12px;max-height:450px;overflow-y:auto"
});
const VariableField = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1fs3nki10"
})("background:", (0, _colors.pale_grey), ";border:1px solid ", (0, _colors.silver_two), ";border-radius:8px;padding:16px;");
const VariableHeader = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1fs3nki9"
})({
    name: "105pb9u",
    styles: "display:flex;align-items:center;gap:8px;margin-bottom:12px"
});
const CategoryBadge = /*#__PURE__*/ (0, _baseDefault.default)("span", {
    target: "e1fs3nki8"
})({
    name: "13gjofe",
    styles: "display:inline-block;padding:2px 8px;border-radius:4px;font-size:11px;font-weight:600;color:white;text-transform:uppercase;letter-spacing:0.5px"
});
const VariableName = /*#__PURE__*/ (0, _baseDefault.default)("span", {
    target: "e1fs3nki7"
})("font-family:'Consolas','Monaco',monospace;font-size:14px;font-weight:600;color:", (0, _colors.color_shades_darkest), ";");
const VariableControls = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1fs3nki6"
})({
    name: "3w0yoi",
    styles: "display:flex;flex-direction:column;gap:8px"
});
const StateSelector = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1fs3nki5"
})({
    name: "alyykf",
    styles: "display:flex;gap:4px;flex-wrap:wrap"
});
const StateButton = /*#__PURE__*/ (0, _baseDefault.default)("button", {
    target: "e1fs3nki4"
})("padding:6px 12px;border:1px solid ", (0, _colors.silver_two), ";background:white;border-radius:4px;font-size:12px;font-weight:500;color:", (0, _colors.color_shades_darker), ";cursor:pointer;transition:all 0.15s ease;&:hover{background:", (0, _colors.pale_grey), ";}&.active{background:", (0, _colors.color_colors_ocean), ";color:white;border-color:", (0, _colors.color_colors_ocean), ";}");
const BooleanSelector = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1fs3nki3"
})({
    name: "9i710i",
    styles: "display:flex;gap:8px;width:fit-content"
});
const BooleanButton = /*#__PURE__*/ (0, _baseDefault.default)("button", {
    target: "e1fs3nki2"
})("padding:10px 24px;border:1px solid ", (0, _colors.silver_two), ";background:white;border-radius:6px;font-size:14px;font-weight:600;color:", (0, _colors.color_shades_darker), ";cursor:pointer;transition:all 0.15s ease;font-family:'Consolas','Monaco',monospace;&:hover{background:", (0, _colors.pale_grey), ";}&.active-true{background:", (0, _colors.color_colors_growth), ";color:white;border-color:", (0, _colors.color_colors_growth), ";}&.active-false{background:", (0, _colors.color_colors_decline), ";color:white;border-color:", (0, _colors.color_colors_decline), ";}");
const ValueInput = /*#__PURE__*/ (0, _baseDefault.default)("input", {
    target: "e1fs3nki1"
})("width:100%;padding:10px 12px;border:1px solid ", (0, _colors.silver_two), ";border-radius:6px;font-size:14px;color:", (0, _colors.color_shades_darkest), ";background:white;box-sizing:border-box;&::placeholder{color:", (0, _colors.color_shades_dark), ";font-style:italic;}&:focus{outline:none;border-color:", (0, _colors.color_colors_ocean), ";}");
const ValuePlaceholder = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1fs3nki0"
})("padding:10px 12px;background:white;border:1px dashed ", (0, _colors.silver_two), ";border-radius:6px;font-size:14px;color:", (0, _colors.color_shades_dark), ";font-style:italic;");
exports.default = ResponseVariableTesterUI;

},{"@emotion/styled/base":"lSuFu","@emotion/react":"djZKr","react":"6uln9","react-markdown":"6G7AH","../../constants/colors":"1p3OR","../../api/controllers/responseVariable":"eNQvT","../../hooks/useApplicationCredentials":"1OvFL","8efd31a832856254":"1jL91","58c8d898ab6f9072":"7RJIh","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6G7AH":[function(require,module,exports) {
"use strict";
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance");
}
function _iterableToArray(iter) {
    if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) {
        for(var i = 0, arr2 = new Array(arr.length); i < arr.length; i++)arr2[i] = arr[i];
        return arr2;
    }
}
var xtend = require("75054909b34405ca");
var unified = require("a0e016b8b3250285");
var parse = require("1b0c7f4a5b92689c");
var PropTypes = require("60a00db6edafc769");
var addListMetadata = require("ee9edf4aef2e8577");
var naiveHtml = require("1d2aa43cd82e9f7");
var disallowNode = require("d98aabf7a601b19b");
var astToReact = require("7a1251062e09f00c");
var wrapTableRows = require("97f94a1cf6d71992");
var getDefinitions = require("2901eb57cee678a9");
var uriTransformer = require("cb5aace536ad2225");
var defaultRenderers = require("22b0334f08e56ac6");
var symbols = require("67e21bec666ab978");
var allTypes = Object.keys(defaultRenderers);
var ReactMarkdown = function ReactMarkdown(props) {
    var src = props.source || props.children || "";
    var parserOptions = props.parserOptions;
    if (props.allowedTypes && props.disallowedTypes) throw new Error("Only one of `allowedTypes` and `disallowedTypes` should be defined");
    var renderers = xtend(defaultRenderers, props.renderers);
    var plugins = [
        [
            parse,
            parserOptions
        ]
    ].concat(props.plugins || []);
    var parser = plugins.reduce(applyParserPlugin, unified());
    var rawAst = parser.parse(src);
    var renderProps = xtend(props, {
        renderers: renderers,
        definitions: getDefinitions(rawAst)
    });
    var astPlugins = determineAstPlugins(props); // eslint-disable-next-line no-sync
    var transformedAst = parser.runSync(rawAst);
    var ast = astPlugins.reduce(function(node, plugin) {
        return plugin(node, renderProps);
    }, transformedAst);
    return astToReact(ast, renderProps);
};
function applyParserPlugin(parser, plugin) {
    return Array.isArray(plugin) ? parser.use.apply(parser, _toConsumableArray(plugin)) : parser.use(plugin);
}
function determineAstPlugins(props) {
    var plugins = [
        wrapTableRows,
        addListMetadata()
    ];
    var disallowedTypes = props.disallowedTypes;
    if (props.allowedTypes) disallowedTypes = allTypes.filter(function(type) {
        return type !== "root" && props.allowedTypes.indexOf(type) === -1;
    });
    var removalMethod = props.unwrapDisallowed ? "unwrap" : "remove";
    if (disallowedTypes && disallowedTypes.length > 0) plugins.push(disallowNode.ofType(disallowedTypes, removalMethod));
    if (props.allowNode) plugins.push(disallowNode.ifNotMatch(props.allowNode, removalMethod));
    var renderHtml = !props.escapeHtml && !props.skipHtml;
    var hasHtmlParser = (props.astPlugins || []).some(function(item) {
        var plugin = Array.isArray(item) ? item[0] : item;
        return plugin.identity === symbols.HtmlParser;
    });
    if (renderHtml && !hasHtmlParser) plugins.push(naiveHtml);
    return props.astPlugins ? plugins.concat(props.astPlugins) : plugins;
}
ReactMarkdown.defaultProps = {
    renderers: {},
    escapeHtml: true,
    skipHtml: false,
    sourcePos: false,
    rawSourcePos: false,
    transformLinkUri: uriTransformer,
    astPlugins: [],
    plugins: [],
    parserOptions: {}
};
ReactMarkdown.propTypes = {
    className: PropTypes.string,
    source: PropTypes.string,
    children: PropTypes.string,
    sourcePos: PropTypes.bool,
    rawSourcePos: PropTypes.bool,
    escapeHtml: PropTypes.bool,
    skipHtml: PropTypes.bool,
    allowNode: PropTypes.func,
    allowedTypes: PropTypes.arrayOf(PropTypes.oneOf(allTypes)),
    disallowedTypes: PropTypes.arrayOf(PropTypes.oneOf(allTypes)),
    transformLinkUri: PropTypes.oneOfType([
        PropTypes.func,
        PropTypes.bool
    ]),
    linkTarget: PropTypes.oneOfType([
        PropTypes.func,
        PropTypes.string
    ]),
    transformImageUri: PropTypes.func,
    astPlugins: PropTypes.arrayOf(PropTypes.func),
    unwrapDisallowed: PropTypes.bool,
    renderers: PropTypes.object,
    plugins: PropTypes.array,
    parserOptions: PropTypes.object
};
ReactMarkdown.types = allTypes;
ReactMarkdown.renderers = defaultRenderers;
ReactMarkdown.uriTransformer = uriTransformer;
module.exports = ReactMarkdown;

},{"75054909b34405ca":"7rqcZ","a0e016b8b3250285":"cupGV","1b0c7f4a5b92689c":"OPYpa","60a00db6edafc769":"6FKs7","ee9edf4aef2e8577":"69XVC","1d2aa43cd82e9f7":"99Cle","d98aabf7a601b19b":"j2VJU","7a1251062e09f00c":"9swp3","97f94a1cf6d71992":"amENg","2901eb57cee678a9":"aE1fk","cb5aace536ad2225":"f9wUw","22b0334f08e56ac6":"01vav","67e21bec666ab978":"drybg"}],"7rqcZ":[function(require,module,exports) {
module.exports = extend;
var hasOwnProperty = Object.prototype.hasOwnProperty;
function extend() {
    var target = {};
    for(var i = 0; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
}

},{}],"cupGV":[function(require,module,exports) {
"use strict";
/* Dependencies. */ var extend = require("d8efe17a2a0e8fbe");
var bail = require("37f5c81790b92058");
var vfile = require("2b69af4bee67af62");
var trough = require("a4192a31b3aec9d1");
var string = require("a795af51b564d26d");
var plain = require("7d51dc61dfcf82b4");
/* Expose a frozen processor. */ module.exports = unified().freeze();
var slice = [].slice;
var own = {}.hasOwnProperty;
/* Process pipeline. */ var pipeline = trough().use(pipelineParse).use(pipelineRun).use(pipelineStringify);
function pipelineParse(p, ctx) {
    ctx.tree = p.parse(ctx.file);
}
function pipelineRun(p, ctx, next) {
    p.run(ctx.tree, ctx.file, done);
    function done(err, tree, file) {
        if (err) next(err);
        else {
            ctx.tree = tree;
            ctx.file = file;
            next();
        }
    }
}
function pipelineStringify(p, ctx) {
    ctx.file.contents = p.stringify(ctx.tree, ctx.file);
}
/* Function to create the first processor. */ function unified() {
    var attachers = [];
    var transformers = trough();
    var namespace = {};
    var frozen = false;
    var freezeIndex = -1;
    /* Data management. */ processor.data = data;
    /* Lock. */ processor.freeze = freeze;
    /* Plug-ins. */ processor.attachers = attachers;
    processor.use = use;
    /* API. */ processor.parse = parse;
    processor.stringify = stringify;
    processor.run = run;
    processor.runSync = runSync;
    processor.process = process;
    processor.processSync = processSync;
    /* Expose. */ return processor;
    /* Create a new processor based on the processor
   * in the current scope. */ function processor() {
        var destination = unified();
        var length = attachers.length;
        var index = -1;
        while(++index < length)destination.use.apply(null, attachers[index]);
        destination.data(extend(true, {}, namespace));
        return destination;
    }
    /* Freeze: used to signal a processor that has finished
   * configuration.
   *
   * For example, take unified itself.  It’s frozen.
   * Plug-ins should not be added to it.  Rather, it should
   * be extended, by invoking it, before modifying it.
   *
   * In essence, always invoke this when exporting a
   * processor. */ function freeze() {
        var values;
        var plugin;
        var options;
        var transformer;
        if (frozen) return processor;
        while(++freezeIndex < attachers.length){
            values = attachers[freezeIndex];
            plugin = values[0];
            options = values[1];
            transformer = null;
            if (options === false) continue;
            if (options === true) values[1] = undefined;
            transformer = plugin.apply(processor, values.slice(1));
            if (typeof transformer === "function") transformers.use(transformer);
        }
        frozen = true;
        freezeIndex = Infinity;
        return processor;
    }
    /* Data management.
   * Getter / setter for processor-specific informtion. */ function data(key, value) {
        if (string(key)) {
            /* Set `key`. */ if (arguments.length === 2) {
                assertUnfrozen("data", frozen);
                namespace[key] = value;
                return processor;
            }
            /* Get `key`. */ return own.call(namespace, key) && namespace[key] || null;
        }
        /* Set space. */ if (key) {
            assertUnfrozen("data", frozen);
            namespace = key;
            return processor;
        }
        /* Get space. */ return namespace;
    }
    /* Plug-in management.
   *
   * Pass it:
   * *   an attacher and options,
   * *   a preset,
   * *   a list of presets, attachers, and arguments (list
   *     of attachers and options). */ function use(value) {
        var settings;
        assertUnfrozen("use", frozen);
        if (value === null || value === undefined) ;
        else if (typeof value === "function") addPlugin.apply(null, arguments);
        else if (typeof value === "object") {
            if ("length" in value) addList(value);
            else addPreset(value);
        } else throw new Error("Expected usable value, not `" + value + "`");
        if (settings) namespace.settings = extend(namespace.settings || {}, settings);
        return processor;
        function addPreset(result) {
            addList(result.plugins);
            if (result.settings) settings = extend(settings || {}, result.settings);
        }
        function add(value) {
            if (typeof value === "function") addPlugin(value);
            else if (typeof value === "object") {
                if ("length" in value) addPlugin.apply(null, value);
                else addPreset(value);
            } else throw new Error("Expected usable value, not `" + value + "`");
        }
        function addList(plugins) {
            var length;
            var index;
            if (plugins === null || plugins === undefined) ;
            else if (typeof plugins === "object" && "length" in plugins) {
                length = plugins.length;
                index = -1;
                while(++index < length)add(plugins[index]);
            } else throw new Error("Expected a list of plugins, not `" + plugins + "`");
        }
        function addPlugin(plugin, value) {
            var entry = find(plugin);
            if (entry) {
                if (plain(entry[1]) && plain(value)) value = extend(entry[1], value);
                entry[1] = value;
            } else attachers.push(slice.call(arguments));
        }
    }
    function find(plugin) {
        var length = attachers.length;
        var index = -1;
        var entry;
        while(++index < length){
            entry = attachers[index];
            if (entry[0] === plugin) return entry;
        }
    }
    /* Parse a file (in string or VFile representation)
   * into a Unist node using the `Parser` on the
   * processor. */ function parse(doc) {
        var file = vfile(doc);
        var Parser;
        freeze();
        Parser = processor.Parser;
        assertParser("parse", Parser);
        if (newable(Parser)) return new Parser(String(file), file).parse();
        return Parser(String(file), file) // eslint-disable-line new-cap
        ;
    }
    /* Run transforms on a Unist node representation of a file
   * (in string or VFile representation), async. */ function run(node, file, cb) {
        assertNode(node);
        freeze();
        if (!cb && typeof file === "function") {
            cb = file;
            file = null;
        }
        if (!cb) return new Promise(executor);
        executor(null, cb);
        function executor(resolve, reject) {
            transformers.run(node, vfile(file), done);
            function done(err, tree, file) {
                tree = tree || node;
                if (err) reject(err);
                else if (resolve) resolve(tree);
                else cb(null, tree, file);
            }
        }
    }
    /* Run transforms on a Unist node representation of a file
   * (in string or VFile representation), sync. */ function runSync(node, file) {
        var complete = false;
        var result;
        run(node, file, done);
        assertDone("runSync", "run", complete);
        return result;
        function done(err, tree) {
            complete = true;
            bail(err);
            result = tree;
        }
    }
    /* Stringify a Unist node representation of a file
   * (in string or VFile representation) into a string
   * using the `Compiler` on the processor. */ function stringify(node, doc) {
        var file = vfile(doc);
        var Compiler;
        freeze();
        Compiler = processor.Compiler;
        assertCompiler("stringify", Compiler);
        assertNode(node);
        if (newable(Compiler)) return new Compiler(node, file).compile();
        return Compiler(node, file) // eslint-disable-line new-cap
        ;
    }
    /* Parse a file (in string or VFile representation)
   * into a Unist node using the `Parser` on the processor,
   * then run transforms on that node, and compile the
   * resulting node using the `Compiler` on the processor,
   * and store that result on the VFile. */ function process(doc, cb) {
        freeze();
        assertParser("process", processor.Parser);
        assertCompiler("process", processor.Compiler);
        if (!cb) return new Promise(executor);
        executor(null, cb);
        function executor(resolve, reject) {
            var file = vfile(doc);
            pipeline.run(processor, {
                file: file
            }, done);
            function done(err) {
                if (err) reject(err);
                else if (resolve) resolve(file);
                else cb(null, file);
            }
        }
    }
    /* Process the given document (in string or VFile
   * representation), sync. */ function processSync(doc) {
        var complete = false;
        var file;
        freeze();
        assertParser("processSync", processor.Parser);
        assertCompiler("processSync", processor.Compiler);
        file = vfile(doc);
        process(file, done);
        assertDone("processSync", "process", complete);
        return file;
        function done(err) {
            complete = true;
            bail(err);
        }
    }
}
/* Check if `func` is a constructor. */ function newable(value) {
    return typeof value === "function" && keys(value.prototype);
}
/* Check if `value` is an object with keys. */ function keys(value) {
    var key;
    for(key in value)return true;
    return false;
}
/* Assert a parser is available. */ function assertParser(name, Parser) {
    if (typeof Parser !== "function") throw new Error("Cannot `" + name + "` without `Parser`");
}
/* Assert a compiler is available. */ function assertCompiler(name, Compiler) {
    if (typeof Compiler !== "function") throw new Error("Cannot `" + name + "` without `Compiler`");
}
/* Assert the processor is not frozen. */ function assertUnfrozen(name, frozen) {
    if (frozen) throw new Error([
        "Cannot invoke `" + name + "` on a frozen processor.\nCreate a new ",
        "processor first, by invoking it: use `processor()` instead of ",
        "`processor`."
    ].join(""));
}
/* Assert `node` is a Unist node. */ function assertNode(node) {
    if (!node || !string(node.type)) throw new Error("Expected node, got `" + node + "`");
}
/* Assert that `complete` is `true`. */ function assertDone(name, asyncName, complete) {
    if (!complete) throw new Error("`" + name + "` finished async. Use `" + asyncName + "` instead");
}

},{"d8efe17a2a0e8fbe":"8nwKS","37f5c81790b92058":"3nc6A","2b69af4bee67af62":"2oE7o","a4192a31b3aec9d1":"k3ZOC","a795af51b564d26d":"g9hTy","7d51dc61dfcf82b4":"dLHFM"}],"8nwKS":[function(require,module,exports) {
"use strict";
var hasOwn = Object.prototype.hasOwnProperty;
var toStr = Object.prototype.toString;
var defineProperty = Object.defineProperty;
var gOPD = Object.getOwnPropertyDescriptor;
var isArray = function isArray(arr) {
    if (typeof Array.isArray === "function") return Array.isArray(arr);
    return toStr.call(arr) === "[object Array]";
};
var isPlainObject = function isPlainObject(obj) {
    if (!obj || toStr.call(obj) !== "[object Object]") return false;
    var hasOwnConstructor = hasOwn.call(obj, "constructor");
    var hasIsPrototypeOf = obj.constructor && obj.constructor.prototype && hasOwn.call(obj.constructor.prototype, "isPrototypeOf");
    // Not own constructor property must be Object
    if (obj.constructor && !hasOwnConstructor && !hasIsPrototypeOf) return false;
    // Own properties are enumerated firstly, so to speed up,
    // if last one is own, then all properties are own.
    var key;
    for(key in obj);
    return typeof key === "undefined" || hasOwn.call(obj, key);
};
// If name is '__proto__', and Object.defineProperty is available, define __proto__ as an own property on target
var setProperty = function setProperty(target, options) {
    if (defineProperty && options.name === "__proto__") defineProperty(target, options.name, {
        enumerable: true,
        configurable: true,
        value: options.newValue,
        writable: true
    });
    else target[options.name] = options.newValue;
};
// Return undefined instead of __proto__ if '__proto__' is not an own property
var getProperty = function getProperty(obj, name) {
    if (name === "__proto__") {
        if (!hasOwn.call(obj, name)) return void 0;
        else if (gOPD) // In early versions of node, obj['__proto__'] is buggy when obj has
        // __proto__ as an own property. Object.getOwnPropertyDescriptor() works.
        return gOPD(obj, name).value;
    }
    return obj[name];
};
module.exports = function extend() {
    var options, name, src, copy, copyIsArray, clone;
    var target = arguments[0];
    var i = 1;
    var length = arguments.length;
    var deep = false;
    // Handle a deep copy situation
    if (typeof target === "boolean") {
        deep = target;
        target = arguments[1] || {};
        // skip the boolean and the target
        i = 2;
    }
    if (target == null || typeof target !== "object" && typeof target !== "function") target = {};
    for(; i < length; ++i){
        options = arguments[i];
        // Only deal with non-null/undefined values
        if (options != null) // Extend the base object
        for(name in options){
            src = getProperty(target, name);
            copy = getProperty(options, name);
            // Prevent never-ending loop
            if (target !== copy) {
                // Recurse if we're merging plain objects or arrays
                if (deep && copy && (isPlainObject(copy) || (copyIsArray = isArray(copy)))) {
                    if (copyIsArray) {
                        copyIsArray = false;
                        clone = src && isArray(src) ? src : [];
                    } else clone = src && isPlainObject(src) ? src : {};
                    // Never move original objects, clone them
                    setProperty(target, {
                        name: name,
                        newValue: extend(deep, clone, copy)
                    });
                // Don't bring in undefined values
                } else if (typeof copy !== "undefined") setProperty(target, {
                    name: name,
                    newValue: copy
                });
            }
        }
    }
    // Return the modified object
    return target;
};

},{}],"3nc6A":[function(require,module,exports) {
"use strict";
module.exports = bail;
function bail(err) {
    if (err) throw err;
}

},{}],"2oE7o":[function(require,module,exports) {
"use strict";
var VMessage = require("3aa99da8684d196d");
var VFile = require("bdfcd3ac2728e3d9");
module.exports = VFile;
var proto = VFile.prototype;
proto.message = message;
proto.info = info;
proto.fail = fail;
/* Slight backwards compatibility.  Remove in the future. */ proto.warn = message;
/* Create a message with `reason` at `position`.
 * When an error is passed in as `reason`, copies the stack. */ function message(reason, position, origin) {
    var filePath = this.path;
    var message = new VMessage(reason, position, origin);
    if (filePath) {
        message.name = filePath + ":" + message.name;
        message.file = filePath;
    }
    message.fatal = false;
    this.messages.push(message);
    return message;
}
/* Fail. Creates a vmessage, associates it with the file,
 * and throws it. */ function fail() {
    var message = this.message.apply(this, arguments);
    message.fatal = true;
    throw message;
}
/* Info. Creates a vmessage, associates it with the file,
 * and marks the fatality as null. */ function info() {
    var message = this.message.apply(this, arguments);
    message.fatal = null;
    return message;
}

},{"3aa99da8684d196d":"cRnuN","bdfcd3ac2728e3d9":"kd1pT"}],"cRnuN":[function(require,module,exports) {
"use strict";
var stringify = require("5d5fcbe1ad759dc");
module.exports = VMessage;
// Inherit from `Error#`.
function VMessagePrototype() {}
VMessagePrototype.prototype = Error.prototype;
VMessage.prototype = new VMessagePrototype();
// Message properties.
var proto = VMessage.prototype;
proto.file = "";
proto.name = "";
proto.reason = "";
proto.message = "";
proto.stack = "";
proto.fatal = null;
proto.column = null;
proto.line = null;
// Construct a new VMessage.
//
// Note: We cannot invoke `Error` on the created context, as that adds readonly
// `line` and `column` attributes on Safari 9, thus throwing and failing the
// data.
function VMessage(reason, position, origin) {
    var parts;
    var range;
    var location;
    if (typeof position === "string") {
        origin = position;
        position = null;
    }
    parts = parseOrigin(origin);
    range = stringify(position) || "1:1";
    location = {
        start: {
            line: null,
            column: null
        },
        end: {
            line: null,
            column: null
        }
    };
    // Node.
    if (position && position.position) position = position.position;
    if (position) {
        // Position.
        if (position.start) {
            location = position;
            position = position.start;
        } else // Point.
        location.start = position;
    }
    if (reason.stack) {
        this.stack = reason.stack;
        reason = reason.message;
    }
    this.message = reason;
    this.name = range;
    this.reason = reason;
    this.line = position ? position.line : null;
    this.column = position ? position.column : null;
    this.location = location;
    this.source = parts[0];
    this.ruleId = parts[1];
}
function parseOrigin(origin) {
    var result = [
        null,
        null
    ];
    var index;
    if (typeof origin === "string") {
        index = origin.indexOf(":");
        if (index === -1) result[1] = origin;
        else {
            result[0] = origin.slice(0, index);
            result[1] = origin.slice(index + 1);
        }
    }
    return result;
}

},{"5d5fcbe1ad759dc":"3goVY"}],"3goVY":[function(require,module,exports) {
"use strict";
var own = {}.hasOwnProperty;
module.exports = stringify;
function stringify(value) {
    /* Nothing. */ if (!value || typeof value !== "object") return null;
    /* Node. */ if (own.call(value, "position") || own.call(value, "type")) return position(value.position);
    /* Position. */ if (own.call(value, "start") || own.call(value, "end")) return position(value);
    /* Point. */ if (own.call(value, "line") || own.call(value, "column")) return point(value);
    /* ? */ return null;
}
function point(point) {
    if (!point || typeof point !== "object") point = {};
    return index(point.line) + ":" + index(point.column);
}
function position(pos) {
    if (!pos || typeof pos !== "object") pos = {};
    return point(pos.start) + "-" + point(pos.end);
}
function index(value) {
    return value && typeof value === "number" ? value : 1;
}

},{}],"kd1pT":[function(require,module,exports) {
var process = require("47917bd00dd512f1");
"use strict";
var path = require("58859d7302c2a912");
var replace = require("a78b361d7d55b783");
var buffer = require("a26c6107a2d16da0");
module.exports = VFile;
var own = {}.hasOwnProperty;
var proto = VFile.prototype;
proto.toString = toString;
/* Order of setting (least specific to most), we need this because
 * otherwise `{stem: 'a', path: '~/b.js'}` would throw, as a path
 * is needed before a stem can be set. */ var order = [
    "history",
    "path",
    "basename",
    "stem",
    "extname",
    "dirname"
];
/* Construct a new file. */ function VFile(options) {
    var prop;
    var index;
    var length;
    if (!options) options = {};
    else if (typeof options === "string" || buffer(options)) options = {
        contents: options
    };
    else if ("message" in options && "messages" in options) return options;
    if (!(this instanceof VFile)) return new VFile(options);
    this.data = {};
    this.messages = [];
    this.history = [];
    this.cwd = process.cwd();
    /* Set path related properties in the correct order. */ index = -1;
    length = order.length;
    while(++index < length){
        prop = order[index];
        if (own.call(options, prop)) this[prop] = options[prop];
    }
    /* Set non-path related properties. */ for(prop in options)if (order.indexOf(prop) === -1) this[prop] = options[prop];
}
/* Access full path (`~/index.min.js`). */ Object.defineProperty(proto, "path", {
    get: function() {
        return this.history[this.history.length - 1];
    },
    set: function(path) {
        assertNonEmpty(path, "path");
        if (path !== this.path) this.history.push(path);
    }
});
/* Access parent path (`~`). */ Object.defineProperty(proto, "dirname", {
    get: function() {
        return typeof this.path === "string" ? path.dirname(this.path) : undefined;
    },
    set: function(dirname) {
        assertPath(this.path, "dirname");
        this.path = path.join(dirname || "", this.basename);
    }
});
/* Access basename (`index.min.js`). */ Object.defineProperty(proto, "basename", {
    get: function() {
        return typeof this.path === "string" ? path.basename(this.path) : undefined;
    },
    set: function(basename) {
        assertNonEmpty(basename, "basename");
        assertPart(basename, "basename");
        this.path = path.join(this.dirname || "", basename);
    }
});
/* Access extname (`.js`). */ Object.defineProperty(proto, "extname", {
    get: function() {
        return typeof this.path === "string" ? path.extname(this.path) : undefined;
    },
    set: function(extname) {
        var ext = extname || "";
        assertPart(ext, "extname");
        assertPath(this.path, "extname");
        if (ext) {
            if (ext.charAt(0) !== ".") throw new Error("`extname` must start with `.`");
            if (ext.indexOf(".", 1) !== -1) throw new Error("`extname` cannot contain multiple dots");
        }
        this.path = replace(this.path, ext);
    }
});
/* Access stem (`index.min`). */ Object.defineProperty(proto, "stem", {
    get: function() {
        return typeof this.path === "string" ? path.basename(this.path, this.extname) : undefined;
    },
    set: function(stem) {
        assertNonEmpty(stem, "stem");
        assertPart(stem, "stem");
        this.path = path.join(this.dirname || "", stem + (this.extname || ""));
    }
});
/* Get the value of the file. */ function toString(encoding) {
    var value = this.contents || "";
    return buffer(value) ? value.toString(encoding) : String(value);
}
/* Assert that `part` is not a path (i.e., does
 * not contain `path.sep`). */ function assertPart(part, name) {
    if (part.indexOf(path.sep) !== -1) throw new Error("`" + name + "` cannot be a path: did not expect `" + path.sep + "`");
}
/* Assert that `part` is not empty. */ function assertNonEmpty(part, name) {
    if (!part) throw new Error("`" + name + "` cannot be empty");
}
/* Assert `path` exists. */ function assertPath(path, name) {
    if (!path) throw new Error("Setting `" + name + "` requires `path` to be set too");
}

},{"47917bd00dd512f1":"5QIF0","58859d7302c2a912":"83T4s","a78b361d7d55b783":"aK82V","a26c6107a2d16da0":"d2PlB"}],"83T4s":[function(require,module,exports) {
// 'path' module extracted from Node.js v8.11.1 (only the posix part)
// transplited with Babel
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
var process = require("c0743715070b1b8a");
"use strict";
function assertPath(path) {
    if (typeof path !== "string") throw new TypeError("Path must be a string. Received " + JSON.stringify(path));
}
// Resolves . and .. elements in a path with directory names
function normalizeStringPosix(path, allowAboveRoot) {
    var res = "";
    var lastSegmentLength = 0;
    var lastSlash = -1;
    var dots = 0;
    var code;
    for(var i = 0; i <= path.length; ++i){
        if (i < path.length) code = path.charCodeAt(i);
        else if (code === 47 /*/*/ ) break;
        else code = 47 /*/*/ ;
        if (code === 47 /*/*/ ) {
            if (lastSlash === i - 1 || dots === 1) ;
            else if (lastSlash !== i - 1 && dots === 2) {
                if (res.length < 2 || lastSegmentLength !== 2 || res.charCodeAt(res.length - 1) !== 46 /*.*/  || res.charCodeAt(res.length - 2) !== 46 /*.*/ ) {
                    if (res.length > 2) {
                        var lastSlashIndex = res.lastIndexOf("/");
                        if (lastSlashIndex !== res.length - 1) {
                            if (lastSlashIndex === -1) {
                                res = "";
                                lastSegmentLength = 0;
                            } else {
                                res = res.slice(0, lastSlashIndex);
                                lastSegmentLength = res.length - 1 - res.lastIndexOf("/");
                            }
                            lastSlash = i;
                            dots = 0;
                            continue;
                        }
                    } else if (res.length === 2 || res.length === 1) {
                        res = "";
                        lastSegmentLength = 0;
                        lastSlash = i;
                        dots = 0;
                        continue;
                    }
                }
                if (allowAboveRoot) {
                    if (res.length > 0) res += "/..";
                    else res = "..";
                    lastSegmentLength = 2;
                }
            } else {
                if (res.length > 0) res += "/" + path.slice(lastSlash + 1, i);
                else res = path.slice(lastSlash + 1, i);
                lastSegmentLength = i - lastSlash - 1;
            }
            lastSlash = i;
            dots = 0;
        } else if (code === 46 /*.*/  && dots !== -1) ++dots;
        else dots = -1;
    }
    return res;
}
function _format(sep, pathObject) {
    var dir = pathObject.dir || pathObject.root;
    var base = pathObject.base || (pathObject.name || "") + (pathObject.ext || "");
    if (!dir) return base;
    if (dir === pathObject.root) return dir + base;
    return dir + sep + base;
}
var posix = {
    // path.resolve([from ...], to)
    resolve: function resolve() {
        var resolvedPath = "";
        var resolvedAbsolute = false;
        var cwd;
        for(var i = arguments.length - 1; i >= -1 && !resolvedAbsolute; i--){
            var path;
            if (i >= 0) path = arguments[i];
            else {
                if (cwd === undefined) cwd = process.cwd();
                path = cwd;
            }
            assertPath(path);
            // Skip empty entries
            if (path.length === 0) continue;
            resolvedPath = path + "/" + resolvedPath;
            resolvedAbsolute = path.charCodeAt(0) === 47 /*/*/ ;
        }
        // At this point the path should be resolved to a full absolute path, but
        // handle relative paths to be safe (might happen when process.cwd() fails)
        // Normalize the path
        resolvedPath = normalizeStringPosix(resolvedPath, !resolvedAbsolute);
        if (resolvedAbsolute) {
            if (resolvedPath.length > 0) return "/" + resolvedPath;
            else return "/";
        } else if (resolvedPath.length > 0) return resolvedPath;
        else return ".";
    },
    normalize: function normalize(path) {
        assertPath(path);
        if (path.length === 0) return ".";
        var isAbsolute = path.charCodeAt(0) === 47 /*/*/ ;
        var trailingSeparator = path.charCodeAt(path.length - 1) === 47 /*/*/ ;
        // Normalize the path
        path = normalizeStringPosix(path, !isAbsolute);
        if (path.length === 0 && !isAbsolute) path = ".";
        if (path.length > 0 && trailingSeparator) path += "/";
        if (isAbsolute) return "/" + path;
        return path;
    },
    isAbsolute: function isAbsolute(path) {
        assertPath(path);
        return path.length > 0 && path.charCodeAt(0) === 47 /*/*/ ;
    },
    join: function join() {
        if (arguments.length === 0) return ".";
        var joined;
        for(var i = 0; i < arguments.length; ++i){
            var arg = arguments[i];
            assertPath(arg);
            if (arg.length > 0) {
                if (joined === undefined) joined = arg;
                else joined += "/" + arg;
            }
        }
        if (joined === undefined) return ".";
        return posix.normalize(joined);
    },
    relative: function relative(from, to) {
        assertPath(from);
        assertPath(to);
        if (from === to) return "";
        from = posix.resolve(from);
        to = posix.resolve(to);
        if (from === to) return "";
        // Trim any leading backslashes
        var fromStart = 1;
        for(; fromStart < from.length; ++fromStart){
            if (from.charCodeAt(fromStart) !== 47 /*/*/ ) break;
        }
        var fromEnd = from.length;
        var fromLen = fromEnd - fromStart;
        // Trim any leading backslashes
        var toStart = 1;
        for(; toStart < to.length; ++toStart){
            if (to.charCodeAt(toStart) !== 47 /*/*/ ) break;
        }
        var toEnd = to.length;
        var toLen = toEnd - toStart;
        // Compare paths to find the longest common path from root
        var length = fromLen < toLen ? fromLen : toLen;
        var lastCommonSep = -1;
        var i = 0;
        for(; i <= length; ++i){
            if (i === length) {
                if (toLen > length) {
                    if (to.charCodeAt(toStart + i) === 47 /*/*/ ) // We get here if `from` is the exact base path for `to`.
                    // For example: from='/foo/bar'; to='/foo/bar/baz'
                    return to.slice(toStart + i + 1);
                    else if (i === 0) // We get here if `from` is the root
                    // For example: from='/'; to='/foo'
                    return to.slice(toStart + i);
                } else if (fromLen > length) {
                    if (from.charCodeAt(fromStart + i) === 47 /*/*/ ) // We get here if `to` is the exact base path for `from`.
                    // For example: from='/foo/bar/baz'; to='/foo/bar'
                    lastCommonSep = i;
                    else if (i === 0) // We get here if `to` is the root.
                    // For example: from='/foo'; to='/'
                    lastCommonSep = 0;
                }
                break;
            }
            var fromCode = from.charCodeAt(fromStart + i);
            var toCode = to.charCodeAt(toStart + i);
            if (fromCode !== toCode) break;
            else if (fromCode === 47 /*/*/ ) lastCommonSep = i;
        }
        var out = "";
        // Generate the relative path based on the path difference between `to`
        // and `from`
        for(i = fromStart + lastCommonSep + 1; i <= fromEnd; ++i)if (i === fromEnd || from.charCodeAt(i) === 47 /*/*/ ) {
            if (out.length === 0) out += "..";
            else out += "/..";
        }
        // Lastly, append the rest of the destination (`to`) path that comes after
        // the common path parts
        if (out.length > 0) return out + to.slice(toStart + lastCommonSep);
        else {
            toStart += lastCommonSep;
            if (to.charCodeAt(toStart) === 47 /*/*/ ) ++toStart;
            return to.slice(toStart);
        }
    },
    _makeLong: function _makeLong(path) {
        return path;
    },
    dirname: function dirname(path) {
        assertPath(path);
        if (path.length === 0) return ".";
        var code = path.charCodeAt(0);
        var hasRoot = code === 47 /*/*/ ;
        var end = -1;
        var matchedSlash = true;
        for(var i = path.length - 1; i >= 1; --i){
            code = path.charCodeAt(i);
            if (code === 47 /*/*/ ) {
                if (!matchedSlash) {
                    end = i;
                    break;
                }
            } else // We saw the first non-path separator
            matchedSlash = false;
        }
        if (end === -1) return hasRoot ? "/" : ".";
        if (hasRoot && end === 1) return "//";
        return path.slice(0, end);
    },
    basename: function basename(path, ext) {
        if (ext !== undefined && typeof ext !== "string") throw new TypeError('"ext" argument must be a string');
        assertPath(path);
        var start = 0;
        var end = -1;
        var matchedSlash = true;
        var i;
        if (ext !== undefined && ext.length > 0 && ext.length <= path.length) {
            if (ext.length === path.length && ext === path) return "";
            var extIdx = ext.length - 1;
            var firstNonSlashEnd = -1;
            for(i = path.length - 1; i >= 0; --i){
                var code = path.charCodeAt(i);
                if (code === 47 /*/*/ ) // If we reached a path separator that was not part of a set of path
                // separators at the end of the string, stop now
                {
                    if (!matchedSlash) {
                        start = i + 1;
                        break;
                    }
                } else {
                    if (firstNonSlashEnd === -1) {
                        // We saw the first non-path separator, remember this index in case
                        // we need it if the extension ends up not matching
                        matchedSlash = false;
                        firstNonSlashEnd = i + 1;
                    }
                    if (extIdx >= 0) {
                        // Try to match the explicit extension
                        if (code === ext.charCodeAt(extIdx)) {
                            if (--extIdx === -1) // We matched the extension, so mark this as the end of our path
                            // component
                            end = i;
                        } else {
                            // Extension does not match, so our result is the entire path
                            // component
                            extIdx = -1;
                            end = firstNonSlashEnd;
                        }
                    }
                }
            }
            if (start === end) end = firstNonSlashEnd;
            else if (end === -1) end = path.length;
            return path.slice(start, end);
        } else {
            for(i = path.length - 1; i >= 0; --i){
                if (path.charCodeAt(i) === 47 /*/*/ ) // If we reached a path separator that was not part of a set of path
                // separators at the end of the string, stop now
                {
                    if (!matchedSlash) {
                        start = i + 1;
                        break;
                    }
                } else if (end === -1) {
                    // We saw the first non-path separator, mark this as the end of our
                    // path component
                    matchedSlash = false;
                    end = i + 1;
                }
            }
            if (end === -1) return "";
            return path.slice(start, end);
        }
    },
    extname: function extname(path) {
        assertPath(path);
        var startDot = -1;
        var startPart = 0;
        var end = -1;
        var matchedSlash = true;
        // Track the state of characters (if any) we see before our first dot and
        // after any path separator we find
        var preDotState = 0;
        for(var i = path.length - 1; i >= 0; --i){
            var code = path.charCodeAt(i);
            if (code === 47 /*/*/ ) {
                // If we reached a path separator that was not part of a set of path
                // separators at the end of the string, stop now
                if (!matchedSlash) {
                    startPart = i + 1;
                    break;
                }
                continue;
            }
            if (end === -1) {
                // We saw the first non-path separator, mark this as the end of our
                // extension
                matchedSlash = false;
                end = i + 1;
            }
            if (code === 46 /*.*/ ) {
                // If this is our first dot, mark it as the start of our extension
                if (startDot === -1) startDot = i;
                else if (preDotState !== 1) preDotState = 1;
            } else if (startDot !== -1) // We saw a non-dot and non-path separator before our dot, so we should
            // have a good chance at having a non-empty extension
            preDotState = -1;
        }
        if (startDot === -1 || end === -1 || // We saw a non-dot character immediately before the dot
        preDotState === 0 || // The (right-most) trimmed path component is exactly '..'
        preDotState === 1 && startDot === end - 1 && startDot === startPart + 1) return "";
        return path.slice(startDot, end);
    },
    format: function format(pathObject) {
        if (pathObject === null || typeof pathObject !== "object") throw new TypeError('The "pathObject" argument must be of type Object. Received type ' + typeof pathObject);
        return _format("/", pathObject);
    },
    parse: function parse(path) {
        assertPath(path);
        var ret = {
            root: "",
            dir: "",
            base: "",
            ext: "",
            name: ""
        };
        if (path.length === 0) return ret;
        var code = path.charCodeAt(0);
        var isAbsolute = code === 47 /*/*/ ;
        var start;
        if (isAbsolute) {
            ret.root = "/";
            start = 1;
        } else start = 0;
        var startDot = -1;
        var startPart = 0;
        var end = -1;
        var matchedSlash = true;
        var i = path.length - 1;
        // Track the state of characters (if any) we see before our first dot and
        // after any path separator we find
        var preDotState = 0;
        // Get non-dir info
        for(; i >= start; --i){
            code = path.charCodeAt(i);
            if (code === 47 /*/*/ ) {
                // If we reached a path separator that was not part of a set of path
                // separators at the end of the string, stop now
                if (!matchedSlash) {
                    startPart = i + 1;
                    break;
                }
                continue;
            }
            if (end === -1) {
                // We saw the first non-path separator, mark this as the end of our
                // extension
                matchedSlash = false;
                end = i + 1;
            }
            if (code === 46 /*.*/ ) {
                // If this is our first dot, mark it as the start of our extension
                if (startDot === -1) startDot = i;
                else if (preDotState !== 1) preDotState = 1;
            } else if (startDot !== -1) // We saw a non-dot and non-path separator before our dot, so we should
            // have a good chance at having a non-empty extension
            preDotState = -1;
        }
        if (startDot === -1 || end === -1 || // We saw a non-dot character immediately before the dot
        preDotState === 0 || // The (right-most) trimmed path component is exactly '..'
        preDotState === 1 && startDot === end - 1 && startDot === startPart + 1) {
            if (end !== -1) {
                if (startPart === 0 && isAbsolute) ret.base = ret.name = path.slice(1, end);
                else ret.base = ret.name = path.slice(startPart, end);
            }
        } else {
            if (startPart === 0 && isAbsolute) {
                ret.name = path.slice(1, startDot);
                ret.base = path.slice(1, end);
            } else {
                ret.name = path.slice(startPart, startDot);
                ret.base = path.slice(startPart, end);
            }
            ret.ext = path.slice(startDot, end);
        }
        if (startPart > 0) ret.dir = path.slice(0, startPart - 1);
        else if (isAbsolute) ret.dir = "/";
        return ret;
    },
    sep: "/",
    delimiter: ":",
    win32: null,
    posix: null
};
posix.posix = posix;
module.exports = posix;

},{"c0743715070b1b8a":"5QIF0"}],"aK82V":[function(require,module,exports) {
"use strict";
var path = require("ef71866d5b0ac775");
function replaceExt(npath, ext) {
    if (typeof npath !== "string") return npath;
    if (npath.length === 0) return npath;
    var nFileName = path.basename(npath, path.extname(npath)) + ext;
    return path.join(path.dirname(npath), nFileName);
}
module.exports = replaceExt;

},{"ef71866d5b0ac775":"83T4s"}],"d2PlB":[function(require,module,exports) {
/*!
 * Determine if an object is a Buffer
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ // The _isBuffer check is for Safari 5-7 support, because it's missing
// Object.prototype.constructor. Remove this eventually
module.exports = function(obj) {
    return obj != null && (isBuffer(obj) || isSlowBuffer(obj) || !!obj._isBuffer);
};
function isBuffer(obj) {
    return !!obj.constructor && typeof obj.constructor.isBuffer === "function" && obj.constructor.isBuffer(obj);
}
// For Node v0.10 support. Remove this eventually.
function isSlowBuffer(obj) {
    return typeof obj.readFloatLE === "function" && typeof obj.slice === "function" && isBuffer(obj.slice(0, 0));
}

},{}],"k3ZOC":[function(require,module,exports) {
"use strict";
var wrap = require("737c848fb73f93a1");
module.exports = trough;
trough.wrap = wrap;
var slice = [].slice;
// Create new middleware.
function trough() {
    var fns = [];
    var middleware = {};
    middleware.run = run;
    middleware.use = use;
    return middleware;
    // Run `fns`.  Last argument must be a completion handler.
    function run() {
        var index = -1;
        var input = slice.call(arguments, 0, -1);
        var done = arguments[arguments.length - 1];
        if (typeof done !== "function") throw new Error("Expected function as last argument, not " + done);
        next.apply(null, [
            null
        ].concat(input));
        // Run the next `fn`, if any.
        function next(err) {
            var fn = fns[++index];
            var params = slice.call(arguments, 0);
            var values = params.slice(1);
            var length = input.length;
            var pos = -1;
            if (err) {
                done(err);
                return;
            }
            // Copy non-nully input into values.
            while(++pos < length)if (values[pos] === null || values[pos] === undefined) values[pos] = input[pos];
            input = values;
            // Next or done.
            if (fn) wrap(fn, next).apply(null, input);
            else done.apply(null, [
                null
            ].concat(input));
        }
    }
    // Add `fn` to the list.
    function use(fn) {
        if (typeof fn !== "function") throw new Error("Expected `fn` to be a function, not " + fn);
        fns.push(fn);
        return middleware;
    }
}

},{"737c848fb73f93a1":"4GWqT"}],"4GWqT":[function(require,module,exports) {
"use strict";
var slice = [].slice;
module.exports = wrap;
// Wrap `fn`.
// Can be sync or async; return a promise, receive a completion handler, return
// new values and errors.
function wrap(fn, callback) {
    var invoked;
    return wrapped;
    function wrapped() {
        var params = slice.call(arguments, 0);
        var callback = fn.length > params.length;
        var result;
        if (callback) params.push(done);
        try {
            result = fn.apply(null, params);
        } catch (error) {
            // Well, this is quite the pickle.
            // `fn` received a callback and invoked it (thus continuing the pipeline),
            // but later also threw an error.
            // We’re not about to restart the pipeline again, so the only thing left
            // to do is to throw the thing instead.
            if (callback && invoked) throw error;
            return done(error);
        }
        if (!callback) {
            if (result && typeof result.then === "function") result.then(then, done);
            else if (result instanceof Error) done(result);
            else then(result);
        }
    }
    // Invoke `next`, only once.
    function done() {
        if (!invoked) {
            invoked = true;
            callback.apply(null, arguments);
        }
    }
    // Invoke `done` with one value.
    // Tracks if an error is passed, too.
    function then(value) {
        done(null, value);
    }
}

},{}],"g9hTy":[function(require,module,exports) {
var toString = Object.prototype.toString;
module.exports = isString;
function isString(obj) {
    return toString.call(obj) === "[object String]";
}

},{}],"dLHFM":[function(require,module,exports) {
"use strict";
var toString = Object.prototype.toString;
module.exports = function(x) {
    var prototype;
    return toString.call(x) === "[object Object]" && (prototype = Object.getPrototypeOf(x), prototype === null || prototype === Object.getPrototypeOf({}));
};

},{}],"OPYpa":[function(require,module,exports) {
"use strict";
var unherit = require("eba12e823097e2c9");
var xtend = require("6c9e248bf465a83c");
var Parser = require("e874b7bfe7df7614");
module.exports = parse;
parse.Parser = Parser;
function parse(options) {
    var Local = unherit(Parser);
    Local.prototype.options = xtend(Local.prototype.options, this.data("settings"), options);
    this.Parser = Local;
}

},{"eba12e823097e2c9":"18ICG","6c9e248bf465a83c":"7rqcZ","e874b7bfe7df7614":"7TS3d"}],"18ICG":[function(require,module,exports) {
"use strict";
var xtend = require("1c6c8fabac2fa1b2");
var inherits = require("8aae5f25d287a9ee");
module.exports = unherit;
// Create a custom constructor which can be modified without affecting the
// original class.
function unherit(Super) {
    var result;
    var key;
    var value;
    inherits(Of, Super);
    inherits(From, Of);
    // Clone values.
    result = Of.prototype;
    for(key in result){
        value = result[key];
        if (value && typeof value === "object") result[key] = "concat" in value ? value.concat() : xtend(value);
    }
    return Of;
    // Constructor accepting a single argument, which itself is an `arguments`
    // object.
    function From(parameters) {
        return Super.apply(this, parameters);
    }
    // Constructor accepting variadic arguments.
    function Of() {
        if (!(this instanceof Of)) return new From(arguments);
        return Super.apply(this, arguments);
    }
}

},{"1c6c8fabac2fa1b2":"7rqcZ","8aae5f25d287a9ee":"8LxVj"}],"8LxVj":[function(require,module,exports) {
if (typeof Object.create === "function") // implementation from standard node.js 'util' module
module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
        ctor.super_ = superCtor;
        ctor.prototype = Object.create(superCtor.prototype, {
            constructor: {
                value: ctor,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
    }
};
else // old school shim for old browsers
module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
};

},{}],"7TS3d":[function(require,module,exports) {
"use strict";
var xtend = require("5535dca6e8cf22ff");
var toggle = require("792d5e9081eb5e2");
var vfileLocation = require("22ebd699ac35da38");
var unescape = require("7f64499cfc6948a4");
var decode = require("414a929a6b497f91");
var tokenizer = require("e1ae17e667655c90");
module.exports = Parser;
function Parser(doc, file) {
    this.file = file;
    this.offset = {};
    this.options = xtend(this.options);
    this.setOptions({});
    this.inList = false;
    this.inBlock = false;
    this.inLink = false;
    this.atStart = true;
    this.toOffset = vfileLocation(file).toOffset;
    this.unescape = unescape(this, "escape");
    this.decode = decode(this);
}
var proto = Parser.prototype;
/* Expose core. */ proto.setOptions = require("4987f1d03d54497b");
proto.parse = require("fc643429e6fab059");
/* Expose `defaults`. */ proto.options = require("a2a1699abd932c3d");
/* Enter and exit helpers. */ proto.exitStart = toggle("atStart", true);
proto.enterList = toggle("inList", false);
proto.enterLink = toggle("inLink", false);
proto.enterBlock = toggle("inBlock", false);
/* Nodes that can interupt a paragraph:
 *
 * ```markdown
 * A paragraph, followed by a thematic break.
 * ___
 * ```
 *
 * In the above example, the thematic break “interupts”
 * the paragraph. */ proto.interruptParagraph = [
    [
        "thematicBreak"
    ],
    [
        "atxHeading"
    ],
    [
        "fencedCode"
    ],
    [
        "blockquote"
    ],
    [
        "html"
    ],
    [
        "setextHeading",
        {
            commonmark: false
        }
    ],
    [
        "definition",
        {
            commonmark: false
        }
    ],
    [
        "footnote",
        {
            commonmark: false
        }
    ]
];
/* Nodes that can interupt a list:
 *
 * ```markdown
 * - One
 * ___
 * ```
 *
 * In the above example, the thematic break “interupts”
 * the list. */ proto.interruptList = [
    [
        "atxHeading",
        {
            pedantic: false
        }
    ],
    [
        "fencedCode",
        {
            pedantic: false
        }
    ],
    [
        "thematicBreak",
        {
            pedantic: false
        }
    ],
    [
        "definition",
        {
            commonmark: false
        }
    ],
    [
        "footnote",
        {
            commonmark: false
        }
    ]
];
/* Nodes that can interupt a blockquote:
 *
 * ```markdown
 * > A paragraph.
 * ___
 * ```
 *
 * In the above example, the thematic break “interupts”
 * the blockquote. */ proto.interruptBlockquote = [
    [
        "indentedCode",
        {
            commonmark: true
        }
    ],
    [
        "fencedCode",
        {
            commonmark: true
        }
    ],
    [
        "atxHeading",
        {
            commonmark: true
        }
    ],
    [
        "setextHeading",
        {
            commonmark: true
        }
    ],
    [
        "thematicBreak",
        {
            commonmark: true
        }
    ],
    [
        "html",
        {
            commonmark: true
        }
    ],
    [
        "list",
        {
            commonmark: true
        }
    ],
    [
        "definition",
        {
            commonmark: false
        }
    ],
    [
        "footnote",
        {
            commonmark: false
        }
    ]
];
/* Handlers. */ proto.blockTokenizers = {
    newline: require("3a27d4157f32dc8c"),
    indentedCode: require("aa8a39a2f057202e"),
    fencedCode: require("15432052496b8aa2"),
    blockquote: require("1d1382514518e8df"),
    atxHeading: require("586b2173b840aad6"),
    thematicBreak: require("86542a873fce45a8"),
    list: require("6ebafe279ff96e8a"),
    setextHeading: require("f49bae1345cce9ba"),
    html: require("2c8fc0fe90a057ef"),
    footnote: require("6ef38f3f7fecf33e"),
    definition: require("1e43057c74fa04b9"),
    table: require("f909d285d3603f90"),
    paragraph: require("e204e6b33bec2cc6")
};
proto.inlineTokenizers = {
    escape: require("6b5e02fcda19b45f"),
    autoLink: require("e78144e4b416ea3c"),
    url: require("7c683d5c1f235ddc"),
    html: require("dbd966c01f181104"),
    link: require("4c9b75be972d4ea"),
    reference: require("19f94e899ca2a359"),
    strong: require("c3cf485e2516a82c"),
    emphasis: require("c730dd14cf98d747"),
    deletion: require("641ee416040e2bb4"),
    code: require("d5b12aa2d15aafbc"),
    break: require("3593ef30876051ff"),
    text: require("34dab7322f2cd245")
};
/* Expose precedence. */ proto.blockMethods = keys(proto.blockTokenizers);
proto.inlineMethods = keys(proto.inlineTokenizers);
/* Tokenizers. */ proto.tokenizeBlock = tokenizer("block");
proto.tokenizeInline = tokenizer("inline");
proto.tokenizeFactory = tokenizer;
/* Get all keys in `value`. */ function keys(value) {
    var result = [];
    var key;
    for(key in value)result.push(key);
    return result;
}

},{"5535dca6e8cf22ff":"7rqcZ","792d5e9081eb5e2":"3E9h9","22ebd699ac35da38":"adNUO","7f64499cfc6948a4":"eOAav","414a929a6b497f91":"fFMPM","e1ae17e667655c90":"gxOY8","4987f1d03d54497b":"3fm8d","fc643429e6fab059":"1OMXJ","a2a1699abd932c3d":"7AsrG","3a27d4157f32dc8c":"g2ZeT","aa8a39a2f057202e":"8Gwqg","15432052496b8aa2":"4zLrc","1d1382514518e8df":"leArc","586b2173b840aad6":"7YWJH","86542a873fce45a8":"gc2LR","6ebafe279ff96e8a":"9UwZf","f49bae1345cce9ba":"7fhnM","2c8fc0fe90a057ef":"5mEUr","6ef38f3f7fecf33e":"8Vi29","1e43057c74fa04b9":"kXlp6","f909d285d3603f90":"l9sft","e204e6b33bec2cc6":"797JA","6b5e02fcda19b45f":"ai4nv","e78144e4b416ea3c":"cwyyB","7c683d5c1f235ddc":"3tVsG","dbd966c01f181104":"aRvvJ","4c9b75be972d4ea":"kczPT","19f94e899ca2a359":"cuzbh","c3cf485e2516a82c":"kxfF8","c730dd14cf98d747":"83xo3","641ee416040e2bb4":"9wOze","d5b12aa2d15aafbc":"aT8RH","3593ef30876051ff":"LYw44","34dab7322f2cd245":"fhPzJ"}],"3E9h9":[function(require,module,exports) {
"use strict";
module.exports = factory;
// Construct a state `toggler`: a function which inverses `property` in context
// based on its current value.
// The by `toggler` returned function restores that value.
function factory(key, state, ctx) {
    return enter;
    function enter() {
        var context = ctx || this;
        var current = context[key];
        context[key] = !state;
        return exit;
        function exit() {
            context[key] = current;
        }
    }
}

},{}],"adNUO":[function(require,module,exports) {
"use strict";
module.exports = factory;
function factory(file) {
    var contents = indices(String(file));
    return {
        toPosition: offsetToPositionFactory(contents),
        toOffset: positionToOffsetFactory(contents)
    };
}
// Factory to get the line and column-based `position` for `offset` in the bound
// indices.
function offsetToPositionFactory(indices) {
    return offsetToPosition;
    // Get the line and column-based `position` for `offset` in the bound indices.
    function offsetToPosition(offset) {
        var index = -1;
        var length = indices.length;
        if (offset < 0) return {};
        while(++index < length){
            if (indices[index] > offset) return {
                line: index + 1,
                column: offset - (indices[index - 1] || 0) + 1,
                offset: offset
            };
        }
        return {};
    }
}
// Factory to get the `offset` for a line and column-based `position` in the
// bound indices.
function positionToOffsetFactory(indices) {
    return positionToOffset;
    // Get the `offset` for a line and column-based `position` in the bound
    // indices.
    function positionToOffset(position) {
        var line = position && position.line;
        var column = position && position.column;
        if (!isNaN(line) && !isNaN(column) && line - 1 in indices) return (indices[line - 2] || 0) + column - 1 || 0;
        return -1;
    }
}
// Get indices of line-breaks in `value`.
function indices(value) {
    var result = [];
    var index = value.indexOf("\n");
    while(index !== -1){
        result.push(index + 1);
        index = value.indexOf("\n", index + 1);
    }
    result.push(value.length + 1);
    return result;
}

},{}],"eOAav":[function(require,module,exports) {
"use strict";
module.exports = factory;
/* Factory to de-escape a value, based on a list at `key`
 * in `ctx`. */ function factory(ctx, key) {
    return unescape;
    /* De-escape a string using the expression at `key`
   * in `ctx`. */ function unescape(value) {
        var prev = 0;
        var index = value.indexOf("\\");
        var escape = ctx[key];
        var queue = [];
        var character;
        while(index !== -1){
            queue.push(value.slice(prev, index));
            prev = index + 1;
            character = value.charAt(prev);
            /* If the following character is not a valid escape,
       * add the slash. */ if (!character || escape.indexOf(character) === -1) queue.push("\\");
            index = value.indexOf("\\", prev);
        }
        queue.push(value.slice(prev));
        return queue.join("");
    }
}

},{}],"fFMPM":[function(require,module,exports) {
"use strict";
var xtend = require("be41a18cb8443a9a");
var entities = require("2c6297aa20152e0c");
module.exports = factory;
/* Factory to create an entity decoder. */ function factory(ctx) {
    decoder.raw = decodeRaw;
    return decoder;
    /* Normalize `position` to add an `indent`. */ function normalize(position) {
        var offsets = ctx.offset;
        var line = position.line;
        var result = [];
        while(++line){
            if (!(line in offsets)) break;
            result.push((offsets[line] || 0) + 1);
        }
        return {
            start: position,
            indent: result
        };
    }
    /* Handle a warning.
   * See https://github.com/wooorm/parse-entities
   * for the warnings. */ function handleWarning(reason, position, code) {
        if (code === 3) return;
        ctx.file.message(reason, position);
    }
    /* Decode `value` (at `position`) into text-nodes. */ function decoder(value, position, handler) {
        entities(value, {
            position: normalize(position),
            warning: handleWarning,
            text: handler,
            reference: handler,
            textContext: ctx,
            referenceContext: ctx
        });
    }
    /* Decode `value` (at `position`) into a string. */ function decodeRaw(value, position, options) {
        return entities(value, xtend(options, {
            position: normalize(position),
            warning: handleWarning
        }));
    }
}

},{"be41a18cb8443a9a":"7rqcZ","2c6297aa20152e0c":"ezLBv"}],"ezLBv":[function(require,module,exports) {
"use strict";
var legacy = require("d167df7aadf55c55");
var invalid = require("1607d1218b697c57");
var decimal = require("a79eb8234d1c118a");
var hexadecimal = require("49130e28d9fb85c3");
var alphanumerical = require("d5d86fd6f6e87ed9");
var decodeEntity = require("5729f4b97642ca9d");
module.exports = parseEntities;
var own = {}.hasOwnProperty;
var fromCharCode = String.fromCharCode;
var noop = Function.prototype;
// Default settings.
var defaults = {
    warning: null,
    reference: null,
    text: null,
    warningContext: null,
    referenceContext: null,
    textContext: null,
    position: {},
    additional: null,
    attribute: false,
    nonTerminated: true
};
// Characters.
var tab = 9 // '\t'
;
var lineFeed = 10 // '\n'
;
var formFeed = 12 //  '\f'
;
var space = 32 // ' '
;
var ampersand = 38 //  '&'
;
var semicolon = 59 //  ';'
;
var lessThan = 60 //  '<'
;
var equalsTo = 61 //  '='
;
var numberSign = 35 //  '#'
;
var uppercaseX = 88 //  'X'
;
var lowercaseX = 120 //  'x'
;
var replacementCharacter = 65533 // '�'
;
// Reference types.
var name = "named";
var hexa = "hexadecimal";
var deci = "decimal";
// Map of bases.
var bases = {};
bases[hexa] = 16;
bases[deci] = 10;
// Map of types to tests.
// Each type of character reference accepts different characters.
// This test is used to detect whether a reference has ended (as the semicolon
// is not strictly needed).
var tests = {};
tests[name] = alphanumerical;
tests[deci] = decimal;
tests[hexa] = hexadecimal;
// Warning types.
var namedNotTerminated = 1;
var numericNotTerminated = 2;
var namedEmpty = 3;
var numericEmpty = 4;
var namedUnknown = 5;
var numericDisallowed = 6;
var numericProhibited = 7;
// Warning messages.
var messages = {};
messages[namedNotTerminated] = "Named character references must be terminated by a semicolon";
messages[numericNotTerminated] = "Numeric character references must be terminated by a semicolon";
messages[namedEmpty] = "Named character references cannot be empty";
messages[numericEmpty] = "Numeric character references cannot be empty";
messages[namedUnknown] = "Named character references must be known";
messages[numericDisallowed] = "Numeric character references cannot be disallowed";
messages[numericProhibited] = "Numeric character references cannot be outside the permissible Unicode range";
// Wrap to ensure clean parameters are given to `parse`.
function parseEntities(value, options) {
    var settings = {};
    var option;
    var key;
    if (!options) options = {};
    for(key in defaults){
        option = options[key];
        settings[key] = option === null || option === undefined ? defaults[key] : option;
    }
    if (settings.position.indent || settings.position.start) {
        settings.indent = settings.position.indent || [];
        settings.position = settings.position.start;
    }
    return parse(value, settings);
}
// Parse entities.
// eslint-disable-next-line complexity
function parse(value, settings) {
    var additional = settings.additional;
    var nonTerminated = settings.nonTerminated;
    var handleText = settings.text;
    var handleReference = settings.reference;
    var handleWarning = settings.warning;
    var textContext = settings.textContext;
    var referenceContext = settings.referenceContext;
    var warningContext = settings.warningContext;
    var pos = settings.position;
    var indent = settings.indent || [];
    var length = value.length;
    var index = 0;
    var lines = -1;
    var column = pos.column || 1;
    var line = pos.line || 1;
    var queue = "";
    var result = [];
    var entityCharacters;
    var namedEntity;
    var terminated;
    var characters;
    var character;
    var reference;
    var following;
    var warning;
    var reason;
    var output;
    var entity;
    var begin;
    var start;
    var type;
    var test;
    var prev;
    var next;
    var diff;
    var end;
    if (typeof additional === "string") additional = additional.charCodeAt(0);
    // Cache the current point.
    prev = now();
    // Wrap `handleWarning`.
    warning = handleWarning ? parseError : noop;
    // Ensure the algorithm walks over the first character and the end (inclusive).
    index--;
    length++;
    while(++index < length){
        // If the previous character was a newline.
        if (character === lineFeed) column = indent[lines] || 1;
        character = value.charCodeAt(index);
        if (character === ampersand) {
            following = value.charCodeAt(index + 1);
            // The behaviour depends on the identity of the next character.
            if (following === tab || following === lineFeed || following === formFeed || following === space || following === ampersand || following === lessThan || following !== following || additional && following === additional) {
                // Not a character reference.
                // No characters are consumed, and nothing is returned.
                // This is not an error, either.
                queue += fromCharCode(character);
                column++;
                continue;
            }
            start = index + 1;
            begin = start;
            end = start;
            if (following === numberSign) {
                // Numerical entity.
                end = ++begin;
                // The behaviour further depends on the next character.
                following = value.charCodeAt(end);
                if (following === uppercaseX || following === lowercaseX) {
                    // ASCII hex digits.
                    type = hexa;
                    end = ++begin;
                } else // ASCII digits.
                type = deci;
            } else // Named entity.
            type = name;
            entityCharacters = "";
            entity = "";
            characters = "";
            test = tests[type];
            end--;
            while(++end < length){
                following = value.charCodeAt(end);
                if (!test(following)) break;
                characters += fromCharCode(following);
                // Check if we can match a legacy named reference.
                // If so, we cache that as the last viable named reference.
                // This ensures we do not need to walk backwards later.
                if (type === name && own.call(legacy, characters)) {
                    entityCharacters = characters;
                    entity = legacy[characters];
                }
            }
            terminated = value.charCodeAt(end) === semicolon;
            if (terminated) {
                end++;
                namedEntity = type === name ? decodeEntity(characters) : false;
                if (namedEntity) {
                    entityCharacters = characters;
                    entity = namedEntity;
                }
            }
            diff = 1 + end - start;
            if (!terminated && !nonTerminated) ;
            else if (!characters) // An empty (possible) entity is valid, unless it’s numeric (thus an
            // ampersand followed by an octothorp).
            {
                if (type !== name) warning(numericEmpty, diff);
            } else if (type === name) {
                // An ampersand followed by anything unknown, and not terminated, is
                // invalid.
                if (terminated && !entity) warning(namedUnknown, 1);
                else {
                    // If theres something after an entity name which is not known, cap
                    // the reference.
                    if (entityCharacters !== characters) {
                        end = begin + entityCharacters.length;
                        diff = 1 + end - begin;
                        terminated = false;
                    }
                    // If the reference is not terminated, warn.
                    if (!terminated) {
                        reason = entityCharacters ? namedNotTerminated : namedEmpty;
                        if (settings.attribute) {
                            following = value.charCodeAt(end);
                            if (following === equalsTo) {
                                warning(reason, diff);
                                entity = null;
                            } else if (alphanumerical(following)) entity = null;
                            else warning(reason, diff);
                        } else warning(reason, diff);
                    }
                }
                reference = entity;
            } else {
                if (!terminated) // All non-terminated numeric entities are not rendered, and trigger a
                // warning.
                warning(numericNotTerminated, diff);
                // When terminated and number, parse as either hexadecimal or decimal.
                reference = parseInt(characters, bases[type]);
                // Trigger a warning when the parsed number is prohibited, and replace
                // with replacement character.
                if (prohibited(reference)) {
                    warning(numericProhibited, diff);
                    reference = fromCharCode(replacementCharacter);
                } else if (reference in invalid) {
                    // Trigger a warning when the parsed number is disallowed, and replace
                    // by an alternative.
                    warning(numericDisallowed, diff);
                    reference = invalid[reference];
                } else {
                    // Parse the number.
                    output = "";
                    // Trigger a warning when the parsed number should not be used.
                    if (disallowed(reference)) warning(numericDisallowed, diff);
                    // Stringify the number.
                    if (reference > 0xffff) {
                        reference -= 0x10000;
                        output += fromCharCode(reference >>> 10 | 0xd800);
                        reference = 0xdc00 | reference & 0x3ff;
                    }
                    reference = output + fromCharCode(reference);
                }
            }
            // Found it!
            // First eat the queued characters as normal text, then eat an entity.
            if (reference) {
                flush();
                prev = now();
                index = end - 1;
                column += end - start + 1;
                result.push(reference);
                next = now();
                next.offset++;
                if (handleReference) handleReference.call(referenceContext, reference, {
                    start: prev,
                    end: next
                }, value.slice(start - 1, end));
                prev = next;
            } else {
                // If we could not find a reference, queue the checked characters (as
                // normal characters), and move the pointer to their end.
                // This is possible because we can be certain neither newlines nor
                // ampersands are included.
                characters = value.slice(start - 1, end);
                queue += characters;
                column += characters.length;
                index = end - 1;
            }
        } else {
            // Handle anything other than an ampersand, including newlines and EOF.
            if (character === 10 // Line feed
            ) {
                line++;
                lines++;
                column = 0;
            }
            if (character === character) {
                queue += fromCharCode(character);
                column++;
            } else flush();
        }
    }
    // Return the reduced nodes, and any possible warnings.
    return result.join("");
    // Get current position.
    function now() {
        return {
            line: line,
            column: column,
            offset: index + (pos.offset || 0)
        };
    }
    // “Throw” a parse-error: a warning.
    function parseError(code, offset) {
        var position = now();
        position.column += offset;
        position.offset += offset;
        handleWarning.call(warningContext, messages[code], position, code);
    }
    // Flush `queue` (normal text).
    // Macro invoked before each entity and at the end of `value`.
    // Does nothing when `queue` is empty.
    function flush() {
        if (queue) {
            result.push(queue);
            if (handleText) handleText.call(textContext, queue, {
                start: prev,
                end: now()
            });
            queue = "";
        }
    }
}
// Check if `character` is outside the permissible unicode range.
function prohibited(code) {
    return code >= 0xd800 && code <= 0xdfff || code > 0x10ffff;
}
// Check if `character` is disallowed.
function disallowed(code) {
    return code >= 0x0001 && code <= 0x0008 || code === 0x000b || code >= 0x000d && code <= 0x001f || code >= 0x007f && code <= 0x009f || code >= 0xfdd0 && code <= 0xfdef || (code & 0xffff) === 0xffff || (code & 0xffff) === 0xfffe;
}

},{"d167df7aadf55c55":"k05gC","1607d1218b697c57":"3Jh2p","a79eb8234d1c118a":"9stpX","49130e28d9fb85c3":"aBBrG","d5d86fd6f6e87ed9":"lo23n","5729f4b97642ca9d":"jApy6"}],"k05gC":[function(require,module,exports) {
module.exports = JSON.parse('{"AElig":"\xc6","AMP":"&","Aacute":"\xc1","Acirc":"\xc2","Agrave":"\xc0","Aring":"\xc5","Atilde":"\xc3","Auml":"\xc4","COPY":"\xa9","Ccedil":"\xc7","ETH":"\xd0","Eacute":"\xc9","Ecirc":"\xca","Egrave":"\xc8","Euml":"\xcb","GT":">","Iacute":"\xcd","Icirc":"\xce","Igrave":"\xcc","Iuml":"\xcf","LT":"<","Ntilde":"\xd1","Oacute":"\xd3","Ocirc":"\xd4","Ograve":"\xd2","Oslash":"\xd8","Otilde":"\xd5","Ouml":"\xd6","QUOT":"\\"","REG":"\xae","THORN":"\xde","Uacute":"\xda","Ucirc":"\xdb","Ugrave":"\xd9","Uuml":"\xdc","Yacute":"\xdd","aacute":"\xe1","acirc":"\xe2","acute":"\xb4","aelig":"\xe6","agrave":"\xe0","amp":"&","aring":"\xe5","atilde":"\xe3","auml":"\xe4","brvbar":"\xa6","ccedil":"\xe7","cedil":"\xb8","cent":"\xa2","copy":"\xa9","curren":"\xa4","deg":"\xb0","divide":"\xf7","eacute":"\xe9","ecirc":"\xea","egrave":"\xe8","eth":"\xf0","euml":"\xeb","frac12":"\xbd","frac14":"\xbc","frac34":"\xbe","gt":">","iacute":"\xed","icirc":"\xee","iexcl":"\xa1","igrave":"\xec","iquest":"\xbf","iuml":"\xef","laquo":"\xab","lt":"<","macr":"\xaf","micro":"\xb5","middot":"\xb7","nbsp":"\xa0","not":"\xac","ntilde":"\xf1","oacute":"\xf3","ocirc":"\xf4","ograve":"\xf2","ordf":"\xaa","ordm":"\xba","oslash":"\xf8","otilde":"\xf5","ouml":"\xf6","para":"\xb6","plusmn":"\xb1","pound":"\xa3","quot":"\\"","raquo":"\xbb","reg":"\xae","sect":"\xa7","shy":"\xad","sup1":"\xb9","sup2":"\xb2","sup3":"\xb3","szlig":"\xdf","thorn":"\xfe","times":"\xd7","uacute":"\xfa","ucirc":"\xfb","ugrave":"\xf9","uml":"\xa8","uuml":"\xfc","yacute":"\xfd","yen":"\xa5","yuml":"\xff"}');

},{}],"3Jh2p":[function(require,module,exports) {
module.exports = JSON.parse('{"0":"�","128":"€","130":"‚","131":"ƒ","132":"„","133":"…","134":"†","135":"‡","136":"ˆ","137":"‰","138":"Š","139":"‹","140":"Œ","142":"Ž","145":"‘","146":"’","147":"“","148":"”","149":"•","150":"–","151":"—","152":"˜","153":"™","154":"š","155":"›","156":"œ","158":"ž","159":"Ÿ"}');

},{}],"9stpX":[function(require,module,exports) {
"use strict";
module.exports = decimal;
// Check if the given character code, or the character code at the first
// character, is decimal.
function decimal(character) {
    var code = typeof character === "string" ? character.charCodeAt(0) : character;
    return code >= 48 && code <= 57 /* 0-9 */ ;
}

},{}],"aBBrG":[function(require,module,exports) {
"use strict";
module.exports = hexadecimal;
// Check if the given character code, or the character code at the first
// character, is hexadecimal.
function hexadecimal(character) {
    var code = typeof character === "string" ? character.charCodeAt(0) : character;
    return code >= 97 /* a */  && code <= 102 || code >= 65 /* A */  && code <= 70 || code >= 48 /* A */  && code <= 57;
}

},{}],"lo23n":[function(require,module,exports) {
"use strict";
var alphabetical = require("f4a1a485073a6196");
var decimal = require("46639e8bcd15391a");
module.exports = alphanumerical;
// Check if the given character code, or the character code at the first
// character, is alphanumerical.
function alphanumerical(character) {
    return alphabetical(character) || decimal(character);
}

},{"f4a1a485073a6196":"j7DnA","46639e8bcd15391a":"9stpX"}],"j7DnA":[function(require,module,exports) {
"use strict";
module.exports = alphabetical;
// Check if the given character code, or the character code at the first
// character, is alphabetical.
function alphabetical(character) {
    var code = typeof character === "string" ? character.charCodeAt(0) : character;
    return code >= 97 && code <= 122 || code >= 65 && code <= 90;
}

},{}],"jApy6":[function(require,module,exports) {
"use strict";
/* eslint-env browser */ var el;
var semicolon = 59 //  ';'
;
module.exports = decodeEntity;
function decodeEntity(characters) {
    var entity = "&" + characters + ";";
    var char;
    el = el || document.createElement("i");
    el.innerHTML = entity;
    char = el.textContent;
    // Some entities do not require the closing semicolon (`&not` - for instance),
    // which leads to situations where parsing the assumed entity of &notit; will
    // result in the string `¬it;`.  When we encounter a trailing semicolon after
    // parsing and the entity to decode was not a semicolon (`&semi;`), we can
    // assume that the matching was incomplete
    if (char.charCodeAt(char.length - 1) === semicolon && characters !== "semi") return false;
    // If the decoded string is equal to the input, the entity was not valid
    return char === entity ? false : char;
}

},{}],"gxOY8":[function(require,module,exports) {
"use strict";
module.exports = factory;
var MERGEABLE_NODES = {
    text: mergeText,
    blockquote: mergeBlockquote
};
/* Check whether a node is mergeable with adjacent nodes. */ function mergeable(node) {
    var start;
    var end;
    if (node.type !== "text" || !node.position) return true;
    start = node.position.start;
    end = node.position.end;
    /* Only merge nodes which occupy the same size as their
   * `value`. */ return start.line !== end.line || end.column - start.column === node.value.length;
}
/* Merge two text nodes: `node` into `prev`. */ function mergeText(prev, node) {
    prev.value += node.value;
    return prev;
}
/* Merge two blockquotes: `node` into `prev`, unless in
 * CommonMark mode. */ function mergeBlockquote(prev, node) {
    if (this.options.commonmark) return node;
    prev.children = prev.children.concat(node.children);
    return prev;
}
/* Construct a tokenizer.  This creates both
 * `tokenizeInline` and `tokenizeBlock`. */ function factory(type) {
    return tokenize;
    /* Tokenizer for a bound `type`. */ function tokenize(value, location) {
        var self = this;
        var offset = self.offset;
        var tokens = [];
        var methods = self[type + "Methods"];
        var tokenizers = self[type + "Tokenizers"];
        var line = location.line;
        var column = location.column;
        var index;
        var length;
        var method;
        var name;
        var matched;
        var valueLength;
        /* Trim white space only lines. */ if (!value) return tokens;
        /* Expose on `eat`. */ eat.now = now;
        eat.file = self.file;
        /* Sync initial offset. */ updatePosition("");
        /* Iterate over `value`, and iterate over all
     * tokenizers.  When one eats something, re-iterate
     * with the remaining value.  If no tokenizer eats,
     * something failed (should not happen) and an
     * exception is thrown. */ while(value){
            index = -1;
            length = methods.length;
            matched = false;
            while(++index < length){
                name = methods[index];
                method = tokenizers[name];
                if (method && /* istanbul ignore next */ (!method.onlyAtStart || self.atStart) && (!method.notInList || !self.inList) && (!method.notInBlock || !self.inBlock) && (!method.notInLink || !self.inLink)) {
                    valueLength = value.length;
                    method.apply(self, [
                        eat,
                        value
                    ]);
                    matched = valueLength !== value.length;
                    if (matched) break;
                }
            }
            /* istanbul ignore if */ if (!matched) self.file.fail(new Error("Infinite loop"), eat.now());
        }
        self.eof = now();
        return tokens;
        /* Update line, column, and offset based on
     * `value`. */ function updatePosition(subvalue) {
            var lastIndex = -1;
            var index = subvalue.indexOf("\n");
            while(index !== -1){
                line++;
                lastIndex = index;
                index = subvalue.indexOf("\n", index + 1);
            }
            if (lastIndex === -1) column += subvalue.length;
            else column = subvalue.length - lastIndex;
            if (line in offset) {
                if (lastIndex !== -1) column += offset[line];
                else if (column <= offset[line]) column = offset[line] + 1;
            }
        }
        /* Get offset.  Called before the first character is
     * eaten to retrieve the range's offsets. */ function getOffset() {
            var indentation = [];
            var pos = line + 1;
            /* Done.  Called when the last character is
       * eaten to retrieve the range’s offsets. */ return function() {
                var last = line + 1;
                while(pos < last){
                    indentation.push((offset[pos] || 0) + 1);
                    pos++;
                }
                return indentation;
            };
        }
        /* Get the current position. */ function now() {
            var pos = {
                line: line,
                column: column
            };
            pos.offset = self.toOffset(pos);
            return pos;
        }
        /* Store position information for a node. */ function Position(start) {
            this.start = start;
            this.end = now();
        }
        /* Throw when a value is incorrectly eaten.
     * This shouldn’t happen but will throw on new,
     * incorrect rules. */ function validateEat(subvalue) {
            /* istanbul ignore if */ if (value.substring(0, subvalue.length) !== subvalue) /* Capture stack-trace. */ self.file.fail(new Error("Incorrectly eaten value: please report this warning on http://git.io/vg5Ft"), now());
        }
        /* Mark position and patch `node.position`. */ function position() {
            var before = now();
            return update;
            /* Add the position to a node. */ function update(node, indent) {
                var prev = node.position;
                var start = prev ? prev.start : before;
                var combined = [];
                var n = prev && prev.end.line;
                var l = before.line;
                node.position = new Position(start);
                /* If there was already a `position`, this
         * node was merged.  Fixing `start` wasn’t
         * hard, but the indent is different.
         * Especially because some information, the
         * indent between `n` and `l` wasn’t
         * tracked.  Luckily, that space is
         * (should be?) empty, so we can safely
         * check for it now. */ if (prev && indent && prev.indent) {
                    combined = prev.indent;
                    if (n < l) {
                        while(++n < l)combined.push((offset[n] || 0) + 1);
                        combined.push(before.column);
                    }
                    indent = combined.concat(indent);
                }
                node.position.indent = indent || [];
                return node;
            }
        }
        /* Add `node` to `parent`s children or to `tokens`.
     * Performs merges where possible. */ function add(node, parent) {
            var children = parent ? parent.children : tokens;
            var prev = children[children.length - 1];
            if (prev && node.type === prev.type && node.type in MERGEABLE_NODES && mergeable(prev) && mergeable(node)) node = MERGEABLE_NODES[node.type].call(self, prev, node);
            if (node !== prev) children.push(node);
            if (self.atStart && tokens.length !== 0) self.exitStart();
            return node;
        }
        /* Remove `subvalue` from `value`.
     * `subvalue` must be at the start of `value`. */ function eat(subvalue) {
            var indent = getOffset();
            var pos = position();
            var current = now();
            validateEat(subvalue);
            apply.reset = reset;
            reset.test = test;
            apply.test = test;
            value = value.substring(subvalue.length);
            updatePosition(subvalue);
            indent = indent();
            return apply;
            /* Add the given arguments, add `position` to
       * the returned node, and return the node. */ function apply(node, parent) {
                return pos(add(pos(node), parent), indent);
            }
            /* Functions just like apply, but resets the
       * content:  the line and column are reversed,
       * and the eaten value is re-added.
       * This is useful for nodes with a single
       * type of content, such as lists and tables.
       * See `apply` above for what parameters are
       * expected. */ function reset() {
                var node = apply.apply(null, arguments);
                line = current.line;
                column = current.column;
                value = subvalue + value;
                return node;
            }
            /* Test the position, after eating, and reverse
       * to a not-eaten state. */ function test() {
                var result = pos({});
                line = current.line;
                column = current.column;
                value = subvalue + value;
                return result.position;
            }
        }
    }
}

},{}],"3fm8d":[function(require,module,exports) {
"use strict";
var xtend = require("6298e5a3dbe7f908");
var escapes = require("ab6d57469b41b4f8");
var defaults = require("b96e2448d9696284");
module.exports = setOptions;
function setOptions(options) {
    var self = this;
    var current = self.options;
    var key;
    var value;
    if (options == null) options = {};
    else if (typeof options === "object") options = xtend(options);
    else throw new Error("Invalid value `" + options + "` " + "for setting `options`");
    for(key in defaults){
        value = options[key];
        if (value == null) value = current[key];
        if (key !== "blocks" && typeof value !== "boolean" || key === "blocks" && typeof value !== "object") throw new Error("Invalid value `" + value + "` for setting `options." + key + "`");
        options[key] = value;
    }
    self.options = options;
    self.escape = escapes(options);
    return self;
}

},{"6298e5a3dbe7f908":"7rqcZ","ab6d57469b41b4f8":"dtUmR","b96e2448d9696284":"7AsrG"}],"dtUmR":[function(require,module,exports) {
"use strict";
module.exports = escapes;
var defaults = [
    "\\",
    "`",
    "*",
    "{",
    "}",
    "[",
    "]",
    "(",
    ")",
    "#",
    "+",
    "-",
    ".",
    "!",
    "_",
    ">"
];
var gfm = defaults.concat([
    "~",
    "|"
]);
var commonmark = gfm.concat([
    "\n",
    '"',
    "$",
    "%",
    "&",
    "'",
    ",",
    "/",
    ":",
    ";",
    "<",
    "=",
    "?",
    "@",
    "^"
]);
escapes.default = defaults;
escapes.gfm = gfm;
escapes.commonmark = commonmark;
// Get markdown escapes.
function escapes(options) {
    var settings = options || {};
    if (settings.commonmark) return commonmark;
    return settings.gfm ? gfm : defaults;
}

},{}],"7AsrG":[function(require,module,exports) {
"use strict";
module.exports = {
    position: true,
    gfm: true,
    commonmark: false,
    footnotes: false,
    pedantic: false,
    blocks: require("d6e24628fa498b03")
};

},{"d6e24628fa498b03":"017Tb"}],"017Tb":[function(require,module,exports) {
module.exports = JSON.parse('["address","article","aside","base","basefont","blockquote","body","caption","center","col","colgroup","dd","details","dialog","dir","div","dl","dt","fieldset","figcaption","figure","footer","form","frame","frameset","h1","h2","h3","h4","h5","h6","head","header","hgroup","hr","html","iframe","legend","li","link","main","menu","menuitem","meta","nav","noframes","ol","optgroup","option","p","param","pre","section","source","title","summary","table","tbody","td","tfoot","th","thead","title","tr","track","ul"]');

},{}],"1OMXJ":[function(require,module,exports) {
"use strict";
var xtend = require("b8abcf45982ed98a");
var removePosition = require("6b67fab27749a2d");
module.exports = parse;
var C_NEWLINE = "\n";
var EXPRESSION_LINE_BREAKS = /\r\n|\r/g;
/* Parse the bound file. */ function parse() {
    var self = this;
    var value = String(self.file);
    var start = {
        line: 1,
        column: 1,
        offset: 0
    };
    var content = xtend(start);
    var node;
    /* Clean non-unix newlines: `\r\n` and `\r` are all
   * changed to `\n`.  This should not affect positional
   * information. */ value = value.replace(EXPRESSION_LINE_BREAKS, C_NEWLINE);
    if (value.charCodeAt(0) === 0xFEFF) {
        value = value.slice(1);
        content.column++;
        content.offset++;
    }
    node = {
        type: "root",
        children: self.tokenizeBlock(value, content),
        position: {
            start: start,
            end: self.eof || xtend(start)
        }
    };
    if (!self.options.position) removePosition(node, true);
    return node;
}

},{"b8abcf45982ed98a":"7rqcZ","6b67fab27749a2d":"kD2av"}],"kD2av":[function(require,module,exports) {
"use strict";
var visit = require("9306d3d3f69e3e94");
module.exports = removePosition;
function removePosition(node, force) {
    visit(node, force ? hard : soft);
    return node;
}
function hard(node) {
    delete node.position;
}
function soft(node) {
    node.position = undefined;
}

},{"9306d3d3f69e3e94":"bEiIa"}],"bEiIa":[function(require,module,exports) {
"use strict";
module.exports = visit;
var visitParents = require("98c2c5619c1e407a");
var CONTINUE = visitParents.CONTINUE;
var SKIP = visitParents.SKIP;
var EXIT = visitParents.EXIT;
visit.CONTINUE = CONTINUE;
visit.SKIP = SKIP;
visit.EXIT = EXIT;
function visit(tree, test, visitor, reverse) {
    if (typeof test === "function" && typeof visitor !== "function") {
        reverse = visitor;
        visitor = test;
        test = null;
    }
    visitParents(tree, test, overload, reverse);
    function overload(node, parents) {
        var parent = parents[parents.length - 1];
        var index = parent ? parent.children.indexOf(node) : null;
        return visitor(node, index, parent);
    }
}

},{"98c2c5619c1e407a":"8R93D"}],"8R93D":[function(require,module,exports) {
"use strict";
module.exports = visitParents;
var convert = require("90dfe6082d09bce9");
var CONTINUE = true;
var SKIP = "skip";
var EXIT = false;
visitParents.CONTINUE = CONTINUE;
visitParents.SKIP = SKIP;
visitParents.EXIT = EXIT;
function visitParents(tree, test, visitor, reverse) {
    var is;
    if (typeof test === "function" && typeof visitor !== "function") {
        reverse = visitor;
        visitor = test;
        test = null;
    }
    is = convert(test);
    one(tree, null, []);
    // Visit a single node.
    function one(node, index, parents) {
        var result = [];
        var subresult;
        if (!test || is(node, index, parents[parents.length - 1] || null)) {
            result = toResult(visitor(node, parents));
            if (result[0] === EXIT) return result;
        }
        if (node.children && result[0] !== SKIP) {
            subresult = toResult(all(node.children, parents.concat(node)));
            return subresult[0] === EXIT ? subresult : result;
        }
        return result;
    }
    // Visit children in `parent`.
    function all(children, parents) {
        var min = -1;
        var step = reverse ? -1 : 1;
        var index = (reverse ? children.length : min) + step;
        var result;
        while(index > min && index < children.length){
            result = one(children[index], index, parents);
            if (result[0] === EXIT) return result;
            index = typeof result[1] === "number" ? result[1] : index + step;
        }
    }
}
function toResult(value) {
    if (value !== null && typeof value === "object" && "length" in value) return value;
    if (typeof value === "number") return [
        CONTINUE,
        value
    ];
    return [
        value
    ];
}

},{"90dfe6082d09bce9":"9g7pf"}],"9g7pf":[function(require,module,exports) {
"use strict";
module.exports = convert;
function convert(test) {
    if (typeof test === "string") return typeFactory(test);
    if (test === null || test === undefined) return ok;
    if (typeof test === "object") return ("length" in test ? anyFactory : matchesFactory)(test);
    if (typeof test === "function") return test;
    throw new Error("Expected function, string, or object as test");
}
function convertAll(tests) {
    var results = [];
    var length = tests.length;
    var index = -1;
    while(++index < length)results[index] = convert(tests[index]);
    return results;
}
// Utility assert each property in `test` is represented in `node`, and each
// values are strictly equal.
function matchesFactory(test) {
    return matches;
    function matches(node) {
        var key;
        for(key in test){
            if (node[key] !== test[key]) return false;
        }
        return true;
    }
}
function anyFactory(tests) {
    var checks = convertAll(tests);
    var length = checks.length;
    return matches;
    function matches() {
        var index = -1;
        while(++index < length){
            if (checks[index].apply(this, arguments)) return true;
        }
        return false;
    }
}
// Utility to convert a string into a function which checks a given node’s type
// for said string.
function typeFactory(test) {
    return type;
    function type(node) {
        return Boolean(node && node.type === test);
    }
}
// Utility to return true.
function ok() {
    return true;
}

},{}],"g2ZeT":[function(require,module,exports) {
"use strict";
var whitespace = require("fe1c5eafc7b7c5b1");
module.exports = newline;
/* Tokenise newline. */ function newline(eat, value, silent) {
    var character = value.charAt(0);
    var length;
    var subvalue;
    var queue;
    var index;
    if (character !== "\n") return;
    /* istanbul ignore if - never used (yet) */ if (silent) return true;
    index = 1;
    length = value.length;
    subvalue = character;
    queue = "";
    while(index < length){
        character = value.charAt(index);
        if (!whitespace(character)) break;
        queue += character;
        if (character === "\n") {
            subvalue += queue;
            queue = "";
        }
        index++;
    }
    eat(subvalue);
}

},{"fe1c5eafc7b7c5b1":"eZxzQ"}],"eZxzQ":[function(require,module,exports) {
"use strict";
module.exports = whitespace;
var fromCode = String.fromCharCode;
var re = /\s/;
// Check if the given character code, or the character code at the first
// character, is a whitespace character.
function whitespace(character) {
    return re.test(typeof character === "number" ? fromCode(character) : character.charAt(0));
}

},{}],"8Gwqg":[function(require,module,exports) {
"use strict";
var repeat = require("fa66f6068913e60");
var trim = require("c9d20ac5617276ef");
module.exports = indentedCode;
var C_NEWLINE = "\n";
var C_TAB = "	";
var C_SPACE = " ";
var CODE_INDENT_COUNT = 4;
var CODE_INDENT = repeat(C_SPACE, CODE_INDENT_COUNT);
/* Tokenise indented code. */ function indentedCode(eat, value, silent) {
    var index = -1;
    var length = value.length;
    var subvalue = "";
    var content = "";
    var subvalueQueue = "";
    var contentQueue = "";
    var character;
    var blankQueue;
    var indent;
    while(++index < length){
        character = value.charAt(index);
        if (indent) {
            indent = false;
            subvalue += subvalueQueue;
            content += contentQueue;
            subvalueQueue = "";
            contentQueue = "";
            if (character === C_NEWLINE) {
                subvalueQueue = character;
                contentQueue = character;
            } else {
                subvalue += character;
                content += character;
                while(++index < length){
                    character = value.charAt(index);
                    if (!character || character === C_NEWLINE) {
                        contentQueue = character;
                        subvalueQueue = character;
                        break;
                    }
                    subvalue += character;
                    content += character;
                }
            }
        } else if (character === C_SPACE && value.charAt(index + 1) === character && value.charAt(index + 2) === character && value.charAt(index + 3) === character) {
            subvalueQueue += CODE_INDENT;
            index += 3;
            indent = true;
        } else if (character === C_TAB) {
            subvalueQueue += character;
            indent = true;
        } else {
            blankQueue = "";
            while(character === C_TAB || character === C_SPACE){
                blankQueue += character;
                character = value.charAt(++index);
            }
            if (character !== C_NEWLINE) break;
            subvalueQueue += blankQueue + character;
            contentQueue += character;
        }
    }
    if (content) {
        if (silent) return true;
        return eat(subvalue)({
            type: "code",
            lang: null,
            value: trim(content)
        });
    }
}

},{"fa66f6068913e60":"iLUu9","c9d20ac5617276ef":"h8Fli"}],"iLUu9":[function(require,module,exports) {
/*!
 * repeat-string <https://github.com/jonschlinkert/repeat-string>
 *
 * Copyright (c) 2014-2015, Jon Schlinkert.
 * Licensed under the MIT License.
 */ "use strict";
/**
 * Results cache
 */ var res = "";
var cache;
/**
 * Expose `repeat`
 */ module.exports = repeat;
/**
 * Repeat the given `string` the specified `number`
 * of times.
 *
 * **Example:**
 *
 * ```js
 * var repeat = require('repeat-string');
 * repeat('A', 5);
 * //=> AAAAA
 * ```
 *
 * @param {String} `string` The string to repeat
 * @param {Number} `number` The number of times to repeat the string
 * @return {String} Repeated string
 * @api public
 */ function repeat(str, num) {
    if (typeof str !== "string") throw new TypeError("expected a string");
    // cover common, quick use cases
    if (num === 1) return str;
    if (num === 2) return str + str;
    var max = str.length * num;
    if (cache !== str || typeof cache === "undefined") {
        cache = str;
        res = "";
    } else if (res.length >= max) return res.substr(0, max);
    while(max > res.length && num > 1){
        if (num & 1) res += str;
        num >>= 1;
        str += str;
    }
    res += str;
    res = res.substr(0, max);
    return res;
}

},{}],"h8Fli":[function(require,module,exports) {
"use strict";
module.exports = trimTrailingLines;
// Remove final newline characters from `value`.
function trimTrailingLines(value) {
    return String(value).replace(/\n+$/, "");
}

},{}],"4zLrc":[function(require,module,exports) {
"use strict";
var trim = require("d1b2c4d503f81d69");
module.exports = fencedCode;
var C_NEWLINE = "\n";
var C_TAB = "	";
var C_SPACE = " ";
var C_TILDE = "~";
var C_TICK = "`";
var MIN_FENCE_COUNT = 3;
var CODE_INDENT_COUNT = 4;
function fencedCode(eat, value, silent) {
    var self = this;
    var settings = self.options;
    var length = value.length + 1;
    var index = 0;
    var subvalue = "";
    var fenceCount;
    var marker;
    var character;
    var flag;
    var queue;
    var content;
    var exdentedContent;
    var closing;
    var exdentedClosing;
    var indent;
    var now;
    if (!settings.gfm) return;
    /* Eat initial spacing. */ while(index < length){
        character = value.charAt(index);
        if (character !== C_SPACE && character !== C_TAB) break;
        subvalue += character;
        index++;
    }
    indent = index;
    /* Eat the fence. */ character = value.charAt(index);
    if (character !== C_TILDE && character !== C_TICK) return;
    index++;
    marker = character;
    fenceCount = 1;
    subvalue += character;
    while(index < length){
        character = value.charAt(index);
        if (character !== marker) break;
        subvalue += character;
        fenceCount++;
        index++;
    }
    if (fenceCount < MIN_FENCE_COUNT) return;
    /* Eat spacing before flag. */ while(index < length){
        character = value.charAt(index);
        if (character !== C_SPACE && character !== C_TAB) break;
        subvalue += character;
        index++;
    }
    /* Eat flag. */ flag = "";
    queue = "";
    while(index < length){
        character = value.charAt(index);
        if (character === C_NEWLINE || character === C_TILDE || character === C_TICK) break;
        if (character === C_SPACE || character === C_TAB) queue += character;
        else {
            flag += queue + character;
            queue = "";
        }
        index++;
    }
    character = value.charAt(index);
    if (character && character !== C_NEWLINE) return;
    if (silent) return true;
    now = eat.now();
    now.column += subvalue.length;
    now.offset += subvalue.length;
    subvalue += flag;
    flag = self.decode.raw(self.unescape(flag), now);
    if (queue) subvalue += queue;
    queue = "";
    closing = "";
    exdentedClosing = "";
    content = "";
    exdentedContent = "";
    /* Eat content. */ while(index < length){
        character = value.charAt(index);
        content += closing;
        exdentedContent += exdentedClosing;
        closing = "";
        exdentedClosing = "";
        if (character !== C_NEWLINE) {
            content += character;
            exdentedClosing += character;
            index++;
            continue;
        }
        /* Add the newline to `subvalue` if its the first
     * character.  Otherwise, add it to the `closing`
     * queue. */ if (content) {
            closing += character;
            exdentedClosing += character;
        } else subvalue += character;
        queue = "";
        index++;
        while(index < length){
            character = value.charAt(index);
            if (character !== C_SPACE) break;
            queue += character;
            index++;
        }
        closing += queue;
        exdentedClosing += queue.slice(indent);
        if (queue.length >= CODE_INDENT_COUNT) continue;
        queue = "";
        while(index < length){
            character = value.charAt(index);
            if (character !== marker) break;
            queue += character;
            index++;
        }
        closing += queue;
        exdentedClosing += queue;
        if (queue.length < fenceCount) continue;
        queue = "";
        while(index < length){
            character = value.charAt(index);
            if (character !== C_SPACE && character !== C_TAB) break;
            closing += character;
            exdentedClosing += character;
            index++;
        }
        if (!character || character === C_NEWLINE) break;
    }
    subvalue += content + closing;
    return eat(subvalue)({
        type: "code",
        lang: flag || null,
        value: trim(exdentedContent)
    });
}

},{"d1b2c4d503f81d69":"h8Fli"}],"leArc":[function(require,module,exports) {
"use strict";
var trim = require("e0e682755122ab14");
var interrupt = require("b765916db79f39bf");
module.exports = blockquote;
var C_NEWLINE = "\n";
var C_TAB = "	";
var C_SPACE = " ";
var C_GT = ">";
/* Tokenise a blockquote. */ function blockquote(eat, value, silent) {
    var self = this;
    var offsets = self.offset;
    var tokenizers = self.blockTokenizers;
    var interruptors = self.interruptBlockquote;
    var now = eat.now();
    var currentLine = now.line;
    var length = value.length;
    var values = [];
    var contents = [];
    var indents = [];
    var add;
    var index = 0;
    var character;
    var rest;
    var nextIndex;
    var content;
    var line;
    var startIndex;
    var prefixed;
    var exit;
    while(index < length){
        character = value.charAt(index);
        if (character !== C_SPACE && character !== C_TAB) break;
        index++;
    }
    if (value.charAt(index) !== C_GT) return;
    if (silent) return true;
    index = 0;
    while(index < length){
        nextIndex = value.indexOf(C_NEWLINE, index);
        startIndex = index;
        prefixed = false;
        if (nextIndex === -1) nextIndex = length;
        while(index < length){
            character = value.charAt(index);
            if (character !== C_SPACE && character !== C_TAB) break;
            index++;
        }
        if (value.charAt(index) === C_GT) {
            index++;
            prefixed = true;
            if (value.charAt(index) === C_SPACE) index++;
        } else index = startIndex;
        content = value.slice(index, nextIndex);
        if (!prefixed && !trim(content)) {
            index = startIndex;
            break;
        }
        if (!prefixed) {
            rest = value.slice(index);
            /* Check if the following code contains a possible
       * block. */ if (interrupt(interruptors, tokenizers, self, [
                eat,
                rest,
                true
            ])) break;
        }
        line = startIndex === index ? content : value.slice(startIndex, nextIndex);
        indents.push(index - startIndex);
        values.push(line);
        contents.push(content);
        index = nextIndex + 1;
    }
    index = -1;
    length = indents.length;
    add = eat(values.join(C_NEWLINE));
    while(++index < length){
        offsets[currentLine] = (offsets[currentLine] || 0) + indents[index];
        currentLine++;
    }
    exit = self.enterBlock();
    contents = self.tokenizeBlock(contents.join(C_NEWLINE), now);
    exit();
    return add({
        type: "blockquote",
        children: contents
    });
}

},{"e0e682755122ab14":"3ZUw2","b765916db79f39bf":"8JNMb"}],"3ZUw2":[function(require,module,exports) {
exports = module.exports = trim;
function trim(str) {
    return str.replace(/^\s*|\s*$/g, "");
}
exports.left = function(str) {
    return str.replace(/^\s*/, "");
};
exports.right = function(str) {
    return str.replace(/\s*$/, "");
};

},{}],"8JNMb":[function(require,module,exports) {
"use strict";
module.exports = interrupt;
function interrupt(interruptors, tokenizers, ctx, params) {
    var bools = [
        "pedantic",
        "commonmark"
    ];
    var count = bools.length;
    var length = interruptors.length;
    var index = -1;
    var interruptor;
    var config;
    var fn;
    var offset;
    var bool;
    var ignore;
    while(++index < length){
        interruptor = interruptors[index];
        config = interruptor[1] || {};
        fn = interruptor[0];
        offset = -1;
        ignore = false;
        while(++offset < count){
            bool = bools[offset];
            if (config[bool] !== undefined && config[bool] !== ctx.options[bool]) {
                ignore = true;
                break;
            }
        }
        if (ignore) continue;
        if (tokenizers[fn].apply(ctx, params)) return true;
    }
    return false;
}

},{}],"7YWJH":[function(require,module,exports) {
"use strict";
module.exports = atxHeading;
var C_NEWLINE = "\n";
var C_TAB = "	";
var C_SPACE = " ";
var C_HASH = "#";
var MAX_ATX_COUNT = 6;
function atxHeading(eat, value, silent) {
    var self = this;
    var settings = self.options;
    var length = value.length + 1;
    var index = -1;
    var now = eat.now();
    var subvalue = "";
    var content = "";
    var character;
    var queue;
    var depth;
    /* Eat initial spacing. */ while(++index < length){
        character = value.charAt(index);
        if (character !== C_SPACE && character !== C_TAB) {
            index--;
            break;
        }
        subvalue += character;
    }
    /* Eat hashes. */ depth = 0;
    while(++index <= length){
        character = value.charAt(index);
        if (character !== C_HASH) {
            index--;
            break;
        }
        subvalue += character;
        depth++;
    }
    if (depth > MAX_ATX_COUNT) return;
    if (!depth || !settings.pedantic && value.charAt(index + 1) === C_HASH) return;
    length = value.length + 1;
    /* Eat intermediate white-space. */ queue = "";
    while(++index < length){
        character = value.charAt(index);
        if (character !== C_SPACE && character !== C_TAB) {
            index--;
            break;
        }
        queue += character;
    }
    /* Exit when not in pedantic mode without spacing. */ if (!settings.pedantic && queue.length === 0 && character && character !== C_NEWLINE) return;
    if (silent) return true;
    /* Eat content. */ subvalue += queue;
    queue = "";
    content = "";
    while(++index < length){
        character = value.charAt(index);
        if (!character || character === C_NEWLINE) break;
        if (character !== C_SPACE && character !== C_TAB && character !== C_HASH) {
            content += queue + character;
            queue = "";
            continue;
        }
        while(character === C_SPACE || character === C_TAB){
            queue += character;
            character = value.charAt(++index);
        }
        while(character === C_HASH){
            queue += character;
            character = value.charAt(++index);
        }
        while(character === C_SPACE || character === C_TAB){
            queue += character;
            character = value.charAt(++index);
        }
        index--;
    }
    now.column += subvalue.length;
    now.offset += subvalue.length;
    subvalue += content + queue;
    return eat(subvalue)({
        type: "heading",
        depth: depth,
        children: self.tokenizeInline(content, now)
    });
}

},{}],"gc2LR":[function(require,module,exports) {
"use strict";
module.exports = thematicBreak;
var C_NEWLINE = "\n";
var C_TAB = "	";
var C_SPACE = " ";
var C_ASTERISK = "*";
var C_UNDERSCORE = "_";
var C_DASH = "-";
var THEMATIC_BREAK_MARKER_COUNT = 3;
function thematicBreak(eat, value, silent) {
    var index = -1;
    var length = value.length + 1;
    var subvalue = "";
    var character;
    var marker;
    var markerCount;
    var queue;
    while(++index < length){
        character = value.charAt(index);
        if (character !== C_TAB && character !== C_SPACE) break;
        subvalue += character;
    }
    if (character !== C_ASTERISK && character !== C_DASH && character !== C_UNDERSCORE) return;
    marker = character;
    subvalue += character;
    markerCount = 1;
    queue = "";
    while(++index < length){
        character = value.charAt(index);
        if (character === marker) {
            markerCount++;
            subvalue += queue + marker;
            queue = "";
        } else if (character === C_SPACE) queue += character;
        else if (markerCount >= THEMATIC_BREAK_MARKER_COUNT && (!character || character === C_NEWLINE)) {
            subvalue += queue;
            if (silent) return true;
            return eat(subvalue)({
                type: "thematicBreak"
            });
        } else return;
    }
}

},{}],"9UwZf":[function(require,module,exports) {
"use strict";
/* eslint-disable max-params */ var trim = require("b7ba157cfb2fc8d6");
var repeat = require("aee8cca5d8e208cf");
var decimal = require("753fc757ef76bf8");
var getIndent = require("c13497a757f74c5c");
var removeIndent = require("7f6b2181b7c4cd5d");
var interrupt = require("bc1f8122b8c6599f");
module.exports = list;
var C_ASTERISK = "*";
var C_UNDERSCORE = "_";
var C_PLUS = "+";
var C_DASH = "-";
var C_DOT = ".";
var C_SPACE = " ";
var C_NEWLINE = "\n";
var C_TAB = "	";
var C_PAREN_CLOSE = ")";
var C_X_LOWER = "x";
var TAB_SIZE = 4;
var EXPRESSION_LOOSE_LIST_ITEM = /\n\n(?!\s*$)/;
var EXPRESSION_TASK_ITEM = /^\[([ \t]|x|X)][ \t]/;
var EXPRESSION_BULLET = /^([ \t]*)([*+-]|\d+[.)])( {1,4}(?! )| |\t|$|(?=\n))([^\n]*)/;
var EXPRESSION_PEDANTIC_BULLET = /^([ \t]*)([*+-]|\d+[.)])([ \t]+)/;
var EXPRESSION_INITIAL_INDENT = /^( {1,4}|\t)?/gm;
/* Map of characters which can be used to mark
 * list-items. */ var LIST_UNORDERED_MARKERS = {};
LIST_UNORDERED_MARKERS[C_ASTERISK] = true;
LIST_UNORDERED_MARKERS[C_PLUS] = true;
LIST_UNORDERED_MARKERS[C_DASH] = true;
/* Map of characters which can be used to mark
 * list-items after a digit. */ var LIST_ORDERED_MARKERS = {};
LIST_ORDERED_MARKERS[C_DOT] = true;
/* Map of characters which can be used to mark
 * list-items after a digit. */ var LIST_ORDERED_COMMONMARK_MARKERS = {};
LIST_ORDERED_COMMONMARK_MARKERS[C_DOT] = true;
LIST_ORDERED_COMMONMARK_MARKERS[C_PAREN_CLOSE] = true;
function list(eat, value, silent) {
    var self = this;
    var commonmark = self.options.commonmark;
    var pedantic = self.options.pedantic;
    var tokenizers = self.blockTokenizers;
    var interuptors = self.interruptList;
    var markers;
    var index = 0;
    var length = value.length;
    var start = null;
    var size = 0;
    var queue;
    var ordered;
    var character;
    var marker;
    var nextIndex;
    var startIndex;
    var prefixed;
    var currentMarker;
    var content;
    var line;
    var prevEmpty;
    var empty;
    var items;
    var allLines;
    var emptyLines;
    var item;
    var enterTop;
    var exitBlockquote;
    var isLoose;
    var node;
    var now;
    var end;
    var indented;
    while(index < length){
        character = value.charAt(index);
        if (character === C_TAB) size += TAB_SIZE - size % TAB_SIZE;
        else if (character === C_SPACE) size++;
        else break;
        index++;
    }
    if (size >= TAB_SIZE) return;
    character = value.charAt(index);
    markers = commonmark ? LIST_ORDERED_COMMONMARK_MARKERS : LIST_ORDERED_MARKERS;
    if (LIST_UNORDERED_MARKERS[character] === true) {
        marker = character;
        ordered = false;
    } else {
        ordered = true;
        queue = "";
        while(index < length){
            character = value.charAt(index);
            if (!decimal(character)) break;
            queue += character;
            index++;
        }
        character = value.charAt(index);
        if (!queue || markers[character] !== true) return;
        start = parseInt(queue, 10);
        marker = character;
    }
    character = value.charAt(++index);
    if (character !== C_SPACE && character !== C_TAB) return;
    if (silent) return true;
    index = 0;
    items = [];
    allLines = [];
    emptyLines = [];
    while(index < length){
        nextIndex = value.indexOf(C_NEWLINE, index);
        startIndex = index;
        prefixed = false;
        indented = false;
        if (nextIndex === -1) nextIndex = length;
        end = index + TAB_SIZE;
        size = 0;
        while(index < length){
            character = value.charAt(index);
            if (character === C_TAB) size += TAB_SIZE - size % TAB_SIZE;
            else if (character === C_SPACE) size++;
            else break;
            index++;
        }
        if (size >= TAB_SIZE) indented = true;
        if (item && size >= item.indent) indented = true;
        character = value.charAt(index);
        currentMarker = null;
        if (!indented) {
            if (LIST_UNORDERED_MARKERS[character] === true) {
                currentMarker = character;
                index++;
                size++;
            } else {
                queue = "";
                while(index < length){
                    character = value.charAt(index);
                    if (!decimal(character)) break;
                    queue += character;
                    index++;
                }
                character = value.charAt(index);
                index++;
                if (queue && markers[character] === true) {
                    currentMarker = character;
                    size += queue.length + 1;
                }
            }
            if (currentMarker) {
                character = value.charAt(index);
                if (character === C_TAB) {
                    size += TAB_SIZE - size % TAB_SIZE;
                    index++;
                } else if (character === C_SPACE) {
                    end = index + TAB_SIZE;
                    while(index < end){
                        if (value.charAt(index) !== C_SPACE) break;
                        index++;
                        size++;
                    }
                    if (index === end && value.charAt(index) === C_SPACE) {
                        index -= TAB_SIZE - 1;
                        size -= TAB_SIZE - 1;
                    }
                } else if (character !== C_NEWLINE && character !== "") currentMarker = null;
            }
        }
        if (currentMarker) {
            if (!pedantic && marker !== currentMarker) break;
            prefixed = true;
        } else {
            if (!commonmark && !indented && value.charAt(startIndex) === C_SPACE) indented = true;
            else if (commonmark && item) indented = size >= item.indent || size > TAB_SIZE;
            prefixed = false;
            index = startIndex;
        }
        line = value.slice(startIndex, nextIndex);
        content = startIndex === index ? line : value.slice(index, nextIndex);
        if (currentMarker === C_ASTERISK || currentMarker === C_UNDERSCORE || currentMarker === C_DASH) {
            if (tokenizers.thematicBreak.call(self, eat, line, true)) break;
        }
        prevEmpty = empty;
        empty = !trim(content).length;
        if (indented && item) {
            item.value = item.value.concat(emptyLines, line);
            allLines = allLines.concat(emptyLines, line);
            emptyLines = [];
        } else if (prefixed) {
            if (emptyLines.length !== 0) {
                item.value.push("");
                item.trail = emptyLines.concat();
            }
            item = {
                value: [
                    line
                ],
                indent: size,
                trail: []
            };
            items.push(item);
            allLines = allLines.concat(emptyLines, line);
            emptyLines = [];
        } else if (empty) {
            if (prevEmpty) break;
            emptyLines.push(line);
        } else {
            if (prevEmpty) break;
            if (interrupt(interuptors, tokenizers, self, [
                eat,
                line,
                true
            ])) break;
            item.value = item.value.concat(emptyLines, line);
            allLines = allLines.concat(emptyLines, line);
            emptyLines = [];
        }
        index = nextIndex + 1;
    }
    node = eat(allLines.join(C_NEWLINE)).reset({
        type: "list",
        ordered: ordered,
        start: start,
        loose: null,
        children: []
    });
    enterTop = self.enterList();
    exitBlockquote = self.enterBlock();
    isLoose = false;
    index = -1;
    length = items.length;
    while(++index < length){
        item = items[index].value.join(C_NEWLINE);
        now = eat.now();
        item = eat(item)(listItem(self, item, now), node);
        if (item.loose) isLoose = true;
        item = items[index].trail.join(C_NEWLINE);
        if (index !== length - 1) item += C_NEWLINE;
        eat(item);
    }
    enterTop();
    exitBlockquote();
    node.loose = isLoose;
    return node;
}
function listItem(ctx, value, position) {
    var offsets = ctx.offset;
    var fn = ctx.options.pedantic ? pedanticListItem : normalListItem;
    var checked = null;
    var task;
    var indent;
    value = fn.apply(null, arguments);
    if (ctx.options.gfm) {
        task = value.match(EXPRESSION_TASK_ITEM);
        if (task) {
            indent = task[0].length;
            checked = task[1].toLowerCase() === C_X_LOWER;
            offsets[position.line] += indent;
            value = value.slice(indent);
        }
    }
    return {
        type: "listItem",
        loose: EXPRESSION_LOOSE_LIST_ITEM.test(value) || value.charAt(value.length - 1) === C_NEWLINE,
        checked: checked,
        children: ctx.tokenizeBlock(value, position)
    };
}
/* Create a list-item using overly simple mechanics. */ function pedanticListItem(ctx, value, position) {
    var offsets = ctx.offset;
    var line = position.line;
    /* Remove the list-item’s bullet. */ value = value.replace(EXPRESSION_PEDANTIC_BULLET, replacer);
    /* The initial line was also matched by the below, so
   * we reset the `line`. */ line = position.line;
    return value.replace(EXPRESSION_INITIAL_INDENT, replacer);
    /* A simple replacer which removed all matches,
   * and adds their length to `offset`. */ function replacer($0) {
        offsets[line] = (offsets[line] || 0) + $0.length;
        line++;
        return "";
    }
}
/* Create a list-item using sane mechanics. */ function normalListItem(ctx, value, position) {
    var offsets = ctx.offset;
    var line = position.line;
    var max;
    var bullet;
    var rest;
    var lines;
    var trimmedLines;
    var index;
    var length;
    /* Remove the list-item’s bullet. */ value = value.replace(EXPRESSION_BULLET, replacer);
    lines = value.split(C_NEWLINE);
    trimmedLines = removeIndent(value, getIndent(max).indent).split(C_NEWLINE);
    /* We replaced the initial bullet with something
   * else above, which was used to trick
   * `removeIndentation` into removing some more
   * characters when possible.  However, that could
   * result in the initial line to be stripped more
   * than it should be. */ trimmedLines[0] = rest;
    offsets[line] = (offsets[line] || 0) + bullet.length;
    line++;
    index = 0;
    length = lines.length;
    while(++index < length){
        offsets[line] = (offsets[line] || 0) + lines[index].length - trimmedLines[index].length;
        line++;
    }
    return trimmedLines.join(C_NEWLINE);
    function replacer($0, $1, $2, $3, $4) {
        bullet = $1 + $2 + $3;
        rest = $4;
        /* Make sure that the first nine numbered list items
     * can indent with an extra space.  That is, when
     * the bullet did not receive an extra final space. */ if (Number($2) < 10 && bullet.length % 2 === 1) $2 = C_SPACE + $2;
        max = $1 + repeat(C_SPACE, $2.length) + $3;
        return max + rest;
    }
}

},{"b7ba157cfb2fc8d6":"3ZUw2","aee8cca5d8e208cf":"iLUu9","753fc757ef76bf8":"9stpX","c13497a757f74c5c":"2P2r8","7f6b2181b7c4cd5d":"e1TBr","bc1f8122b8c6599f":"8JNMb"}],"2P2r8":[function(require,module,exports) {
"use strict";
module.exports = indentation;
/* Map of characters, and their column length,
 * which can be used as indentation. */ var characters = {
    " ": 1,
    "	": 4
};
/* Gets indentation information for a line. */ function indentation(value) {
    var index = 0;
    var indent = 0;
    var character = value.charAt(index);
    var stops = {};
    var size;
    while(character in characters){
        size = characters[character];
        indent += size;
        if (size > 1) indent = Math.floor(indent / size) * size;
        stops[indent] = index;
        character = value.charAt(++index);
    }
    return {
        indent: indent,
        stops: stops
    };
}

},{}],"e1TBr":[function(require,module,exports) {
"use strict";
var trim = require("efbb0f29c7c6777e");
var repeat = require("343206d442eaa3ba");
var getIndent = require("baabbe265275f716");
module.exports = indentation;
var C_SPACE = " ";
var C_NEWLINE = "\n";
var C_TAB = "	";
/* Remove the minimum indent from every line in `value`.
 * Supports both tab, spaced, and mixed indentation (as
 * well as possible). */ function indentation(value, maximum) {
    var values = value.split(C_NEWLINE);
    var position = values.length + 1;
    var minIndent = Infinity;
    var matrix = [];
    var index;
    var indentation;
    var stops;
    var padding;
    values.unshift(repeat(C_SPACE, maximum) + "!");
    while(position--){
        indentation = getIndent(values[position]);
        matrix[position] = indentation.stops;
        if (trim(values[position]).length === 0) continue;
        if (indentation.indent) {
            if (indentation.indent > 0 && indentation.indent < minIndent) minIndent = indentation.indent;
        } else {
            minIndent = Infinity;
            break;
        }
    }
    if (minIndent !== Infinity) {
        position = values.length;
        while(position--){
            stops = matrix[position];
            index = minIndent;
            while(index && !(index in stops))index--;
            if (trim(values[position]).length !== 0 && minIndent && index !== minIndent) padding = C_TAB;
            else padding = "";
            values[position] = padding + values[position].slice(index in stops ? stops[index] + 1 : 0);
        }
    }
    values.shift();
    return values.join(C_NEWLINE);
}

},{"efbb0f29c7c6777e":"3ZUw2","343206d442eaa3ba":"iLUu9","baabbe265275f716":"2P2r8"}],"7fhnM":[function(require,module,exports) {
"use strict";
module.exports = setextHeading;
var C_NEWLINE = "\n";
var C_TAB = "	";
var C_SPACE = " ";
var C_EQUALS = "=";
var C_DASH = "-";
var MAX_HEADING_INDENT = 3;
/* Map of characters which can be used to mark setext
 * headers, mapping to their corresponding depth. */ var SETEXT_MARKERS = {};
SETEXT_MARKERS[C_EQUALS] = 1;
SETEXT_MARKERS[C_DASH] = 2;
function setextHeading(eat, value, silent) {
    var self = this;
    var now = eat.now();
    var length = value.length;
    var index = -1;
    var subvalue = "";
    var content;
    var queue;
    var character;
    var marker;
    var depth;
    /* Eat initial indentation. */ while(++index < length){
        character = value.charAt(index);
        if (character !== C_SPACE || index >= MAX_HEADING_INDENT) {
            index--;
            break;
        }
        subvalue += character;
    }
    /* Eat content. */ content = "";
    queue = "";
    while(++index < length){
        character = value.charAt(index);
        if (character === C_NEWLINE) {
            index--;
            break;
        }
        if (character === C_SPACE || character === C_TAB) queue += character;
        else {
            content += queue + character;
            queue = "";
        }
    }
    now.column += subvalue.length;
    now.offset += subvalue.length;
    subvalue += content + queue;
    /* Ensure the content is followed by a newline and a
   * valid marker. */ character = value.charAt(++index);
    marker = value.charAt(++index);
    if (character !== C_NEWLINE || !SETEXT_MARKERS[marker]) return;
    subvalue += character;
    /* Eat Setext-line. */ queue = marker;
    depth = SETEXT_MARKERS[marker];
    while(++index < length){
        character = value.charAt(index);
        if (character !== marker) {
            if (character !== C_NEWLINE) return;
            index--;
            break;
        }
        queue += character;
    }
    if (silent) return true;
    return eat(subvalue + queue)({
        type: "heading",
        depth: depth,
        children: self.tokenizeInline(content, now)
    });
}

},{}],"5mEUr":[function(require,module,exports) {
"use strict";
var openCloseTag = require("14554cbe693ae247").openCloseTag;
module.exports = blockHTML;
var C_TAB = "	";
var C_SPACE = " ";
var C_NEWLINE = "\n";
var C_LT = "<";
function blockHTML(eat, value, silent) {
    var self = this;
    var blocks = self.options.blocks;
    var length = value.length;
    var index = 0;
    var next;
    var line;
    var offset;
    var character;
    var count;
    var sequence;
    var subvalue;
    var sequences = [
        [
            /^<(script|pre|style)(?=(\s|>|$))/i,
            /<\/(script|pre|style)>/i,
            true
        ],
        [
            /^<!--/,
            /-->/,
            true
        ],
        [
            /^<\?/,
            /\?>/,
            true
        ],
        [
            /^<![A-Za-z]/,
            />/,
            true
        ],
        [
            /^<!\[CDATA\[/,
            /\]\]>/,
            true
        ],
        [
            new RegExp("^</?(" + blocks.join("|") + ")(?=(\\s|/?>|$))", "i"),
            /^$/,
            true
        ],
        [
            new RegExp(openCloseTag.source + "\\s*$"),
            /^$/,
            false
        ]
    ];
    /* Eat initial spacing. */ while(index < length){
        character = value.charAt(index);
        if (character !== C_TAB && character !== C_SPACE) break;
        index++;
    }
    if (value.charAt(index) !== C_LT) return;
    next = value.indexOf(C_NEWLINE, index + 1);
    next = next === -1 ? length : next;
    line = value.slice(index, next);
    offset = -1;
    count = sequences.length;
    while(++offset < count)if (sequences[offset][0].test(line)) {
        sequence = sequences[offset];
        break;
    }
    if (!sequence) return;
    if (silent) return sequence[2];
    index = next;
    if (!sequence[1].test(line)) while(index < length){
        next = value.indexOf(C_NEWLINE, index + 1);
        next = next === -1 ? length : next;
        line = value.slice(index + 1, next);
        if (sequence[1].test(line)) {
            if (line) index = next;
            break;
        }
        index = next;
    }
    subvalue = value.slice(0, index);
    return eat(subvalue)({
        type: "html",
        value: subvalue
    });
}

},{"14554cbe693ae247":"f7yZK"}],"f7yZK":[function(require,module,exports) {
"use strict";
var attributeName = "[a-zA-Z_:][a-zA-Z0-9:._-]*";
var unquoted = "[^\"'=<>`\\u0000-\\u0020]+";
var singleQuoted = "'[^']*'";
var doubleQuoted = '"[^"]*"';
var attributeValue = "(?:" + unquoted + "|" + singleQuoted + "|" + doubleQuoted + ")";
var attribute = "(?:\\s+" + attributeName + "(?:\\s*=\\s*" + attributeValue + ")?)";
var openTag = "<[A-Za-z][A-Za-z0-9\\-]*" + attribute + "*\\s*\\/?>";
var closeTag = "<\\/[A-Za-z][A-Za-z0-9\\-]*\\s*>";
var comment = "<!---->|<!--(?:-?[^>-])(?:-?[^-])*-->";
var processing = "<[?].*?[?]>";
var declaration = "<![A-Za-z]+\\s+[^>]*>";
var cdata = "<!\\[CDATA\\[[\\s\\S]*?\\]\\]>";
exports.openCloseTag = new RegExp("^(?:" + openTag + "|" + closeTag + ")");
exports.tag = new RegExp("^(?:" + openTag + "|" + closeTag + "|" + comment + "|" + processing + "|" + declaration + "|" + cdata + ")");

},{}],"8Vi29":[function(require,module,exports) {
"use strict";
var whitespace = require("268ce1444ed3b96d");
var normalize = require("66f24668cb039dd7");
module.exports = footnoteDefinition;
footnoteDefinition.notInList = true;
footnoteDefinition.notInBlock = true;
var C_BACKSLASH = "\\";
var C_NEWLINE = "\n";
var C_TAB = "	";
var C_SPACE = " ";
var C_BRACKET_OPEN = "[";
var C_BRACKET_CLOSE = "]";
var C_CARET = "^";
var C_COLON = ":";
var EXPRESSION_INITIAL_TAB = /^( {4}|\t)?/gm;
function footnoteDefinition(eat, value, silent) {
    var self = this;
    var offsets = self.offset;
    var index;
    var length;
    var subvalue;
    var now;
    var currentLine;
    var content;
    var queue;
    var subqueue;
    var character;
    var identifier;
    var add;
    var exit;
    if (!self.options.footnotes) return;
    index = 0;
    length = value.length;
    subvalue = "";
    now = eat.now();
    currentLine = now.line;
    while(index < length){
        character = value.charAt(index);
        if (!whitespace(character)) break;
        subvalue += character;
        index++;
    }
    if (value.charAt(index) !== C_BRACKET_OPEN || value.charAt(index + 1) !== C_CARET) return;
    subvalue += C_BRACKET_OPEN + C_CARET;
    index = subvalue.length;
    queue = "";
    while(index < length){
        character = value.charAt(index);
        if (character === C_BRACKET_CLOSE) break;
        else if (character === C_BACKSLASH) {
            queue += character;
            index++;
            character = value.charAt(index);
        }
        queue += character;
        index++;
    }
    if (!queue || value.charAt(index) !== C_BRACKET_CLOSE || value.charAt(index + 1) !== C_COLON) return;
    if (silent) return true;
    identifier = normalize(queue);
    subvalue += queue + C_BRACKET_CLOSE + C_COLON;
    index = subvalue.length;
    while(index < length){
        character = value.charAt(index);
        if (character !== C_TAB && character !== C_SPACE) break;
        subvalue += character;
        index++;
    }
    now.column += subvalue.length;
    now.offset += subvalue.length;
    queue = "";
    content = "";
    subqueue = "";
    while(index < length){
        character = value.charAt(index);
        if (character === C_NEWLINE) {
            subqueue = character;
            index++;
            while(index < length){
                character = value.charAt(index);
                if (character !== C_NEWLINE) break;
                subqueue += character;
                index++;
            }
            queue += subqueue;
            subqueue = "";
            while(index < length){
                character = value.charAt(index);
                if (character !== C_SPACE) break;
                subqueue += character;
                index++;
            }
            if (subqueue.length === 0) break;
            queue += subqueue;
        }
        if (queue) {
            content += queue;
            queue = "";
        }
        content += character;
        index++;
    }
    subvalue += content;
    content = content.replace(EXPRESSION_INITIAL_TAB, function(line) {
        offsets[currentLine] = (offsets[currentLine] || 0) + line.length;
        currentLine++;
        return "";
    });
    add = eat(subvalue);
    exit = self.enterBlock();
    content = self.tokenizeBlock(content, now);
    exit();
    return add({
        type: "footnoteDefinition",
        identifier: identifier,
        children: content
    });
}

},{"268ce1444ed3b96d":"eZxzQ","66f24668cb039dd7":"dHFtV"}],"dHFtV":[function(require,module,exports) {
"use strict";
var collapseWhiteSpace = require("bef742c20fb06354");
module.exports = normalize;
/* Normalize an identifier.  Collapses multiple white space
 * characters into a single space, and removes casing. */ function normalize(value) {
    return collapseWhiteSpace(value).toLowerCase();
}

},{"bef742c20fb06354":"bI1dD"}],"bI1dD":[function(require,module,exports) {
"use strict";
module.exports = collapse;
// `collapse(' \t\nbar \nbaz\t') // ' bar baz '`
function collapse(value) {
    return String(value).replace(/\s+/g, " ");
}

},{}],"kXlp6":[function(require,module,exports) {
"use strict";
var whitespace = require("e78166c96e31e2d8");
var normalize = require("7011aa6691bc4290");
module.exports = definition;
definition.notInList = true;
definition.notInBlock = true;
var C_DOUBLE_QUOTE = '"';
var C_SINGLE_QUOTE = "'";
var C_BACKSLASH = "\\";
var C_NEWLINE = "\n";
var C_TAB = "	";
var C_SPACE = " ";
var C_BRACKET_OPEN = "[";
var C_BRACKET_CLOSE = "]";
var C_PAREN_OPEN = "(";
var C_PAREN_CLOSE = ")";
var C_COLON = ":";
var C_LT = "<";
var C_GT = ">";
function definition(eat, value, silent) {
    var self = this;
    var commonmark = self.options.commonmark;
    var index = 0;
    var length = value.length;
    var subvalue = "";
    var beforeURL;
    var beforeTitle;
    var queue;
    var character;
    var test;
    var identifier;
    var url;
    var title;
    while(index < length){
        character = value.charAt(index);
        if (character !== C_SPACE && character !== C_TAB) break;
        subvalue += character;
        index++;
    }
    character = value.charAt(index);
    if (character !== C_BRACKET_OPEN) return;
    index++;
    subvalue += character;
    queue = "";
    while(index < length){
        character = value.charAt(index);
        if (character === C_BRACKET_CLOSE) break;
        else if (character === C_BACKSLASH) {
            queue += character;
            index++;
            character = value.charAt(index);
        }
        queue += character;
        index++;
    }
    if (!queue || value.charAt(index) !== C_BRACKET_CLOSE || value.charAt(index + 1) !== C_COLON) return;
    identifier = queue;
    subvalue += queue + C_BRACKET_CLOSE + C_COLON;
    index = subvalue.length;
    queue = "";
    while(index < length){
        character = value.charAt(index);
        if (character !== C_TAB && character !== C_SPACE && character !== C_NEWLINE) break;
        subvalue += character;
        index++;
    }
    character = value.charAt(index);
    queue = "";
    beforeURL = subvalue;
    if (character === C_LT) {
        index++;
        while(index < length){
            character = value.charAt(index);
            if (!isEnclosedURLCharacter(character)) break;
            queue += character;
            index++;
        }
        character = value.charAt(index);
        if (character === isEnclosedURLCharacter.delimiter) {
            subvalue += C_LT + queue + character;
            index++;
        } else {
            if (commonmark) return;
            index -= queue.length + 1;
            queue = "";
        }
    }
    if (!queue) {
        while(index < length){
            character = value.charAt(index);
            if (!isUnclosedURLCharacter(character)) break;
            queue += character;
            index++;
        }
        subvalue += queue;
    }
    if (!queue) return;
    url = queue;
    queue = "";
    while(index < length){
        character = value.charAt(index);
        if (character !== C_TAB && character !== C_SPACE && character !== C_NEWLINE) break;
        queue += character;
        index++;
    }
    character = value.charAt(index);
    test = null;
    if (character === C_DOUBLE_QUOTE) test = C_DOUBLE_QUOTE;
    else if (character === C_SINGLE_QUOTE) test = C_SINGLE_QUOTE;
    else if (character === C_PAREN_OPEN) test = C_PAREN_CLOSE;
    if (!test) {
        queue = "";
        index = subvalue.length;
    } else if (queue) {
        subvalue += queue + character;
        index = subvalue.length;
        queue = "";
        while(index < length){
            character = value.charAt(index);
            if (character === test) break;
            if (character === C_NEWLINE) {
                index++;
                character = value.charAt(index);
                if (character === C_NEWLINE || character === test) return;
                queue += C_NEWLINE;
            }
            queue += character;
            index++;
        }
        character = value.charAt(index);
        if (character !== test) return;
        beforeTitle = subvalue;
        subvalue += queue + character;
        index++;
        title = queue;
        queue = "";
    } else return;
    while(index < length){
        character = value.charAt(index);
        if (character !== C_TAB && character !== C_SPACE) break;
        subvalue += character;
        index++;
    }
    character = value.charAt(index);
    if (!character || character === C_NEWLINE) {
        if (silent) return true;
        beforeURL = eat(beforeURL).test().end;
        url = self.decode.raw(self.unescape(url), beforeURL, {
            nonTerminated: false
        });
        if (title) {
            beforeTitle = eat(beforeTitle).test().end;
            title = self.decode.raw(self.unescape(title), beforeTitle);
        }
        return eat(subvalue)({
            type: "definition",
            identifier: normalize(identifier),
            title: title || null,
            url: url
        });
    }
}
/* Check if `character` can be inside an enclosed URI. */ function isEnclosedURLCharacter(character) {
    return character !== C_GT && character !== C_BRACKET_OPEN && character !== C_BRACKET_CLOSE;
}
isEnclosedURLCharacter.delimiter = C_GT;
/* Check if `character` can be inside an unclosed URI. */ function isUnclosedURLCharacter(character) {
    return character !== C_BRACKET_OPEN && character !== C_BRACKET_CLOSE && !whitespace(character);
}

},{"e78166c96e31e2d8":"eZxzQ","7011aa6691bc4290":"dHFtV"}],"l9sft":[function(require,module,exports) {
"use strict";
var whitespace = require("d8da38b145607a10");
module.exports = table;
var C_BACKSLASH = "\\";
var C_TICK = "`";
var C_DASH = "-";
var C_PIPE = "|";
var C_COLON = ":";
var C_SPACE = " ";
var C_NEWLINE = "\n";
var C_TAB = "	";
var MIN_TABLE_COLUMNS = 1;
var MIN_TABLE_ROWS = 2;
var TABLE_ALIGN_LEFT = "left";
var TABLE_ALIGN_CENTER = "center";
var TABLE_ALIGN_RIGHT = "right";
var TABLE_ALIGN_NONE = null;
function table(eat, value, silent) {
    var self = this;
    var index;
    var alignments;
    var alignment;
    var subvalue;
    var row;
    var length;
    var lines;
    var queue;
    var character;
    var hasDash;
    var align;
    var cell;
    var preamble;
    var count;
    var opening;
    var now;
    var position;
    var lineCount;
    var line;
    var rows;
    var table;
    var lineIndex;
    var pipeIndex;
    var first;
    /* Exit when not in gfm-mode. */ if (!self.options.gfm) return;
    /* Get the rows.
   * Detecting tables soon is hard, so there are some
   * checks for performance here, such as the minimum
   * number of rows, and allowed characters in the
   * alignment row. */ index = 0;
    lineCount = 0;
    length = value.length + 1;
    lines = [];
    while(index < length){
        lineIndex = value.indexOf(C_NEWLINE, index);
        pipeIndex = value.indexOf(C_PIPE, index + 1);
        if (lineIndex === -1) lineIndex = value.length;
        if (pipeIndex === -1 || pipeIndex > lineIndex) {
            if (lineCount < MIN_TABLE_ROWS) return;
            break;
        }
        lines.push(value.slice(index, lineIndex));
        lineCount++;
        index = lineIndex + 1;
    }
    /* Parse the alignment row. */ subvalue = lines.join(C_NEWLINE);
    alignments = lines.splice(1, 1)[0] || [];
    index = 0;
    length = alignments.length;
    lineCount--;
    alignment = false;
    align = [];
    while(index < length){
        character = alignments.charAt(index);
        if (character === C_PIPE) {
            hasDash = null;
            if (alignment === false) {
                if (first === false) return;
            } else {
                align.push(alignment);
                alignment = false;
            }
            first = false;
        } else if (character === C_DASH) {
            hasDash = true;
            alignment = alignment || TABLE_ALIGN_NONE;
        } else if (character === C_COLON) {
            if (alignment === TABLE_ALIGN_LEFT) alignment = TABLE_ALIGN_CENTER;
            else if (hasDash && alignment === TABLE_ALIGN_NONE) alignment = TABLE_ALIGN_RIGHT;
            else alignment = TABLE_ALIGN_LEFT;
        } else if (!whitespace(character)) return;
        index++;
    }
    if (alignment !== false) align.push(alignment);
    /* Exit when without enough columns. */ if (align.length < MIN_TABLE_COLUMNS) return;
    /* istanbul ignore if - never used (yet) */ if (silent) return true;
    /* Parse the rows. */ position = -1;
    rows = [];
    table = eat(subvalue).reset({
        type: "table",
        align: align,
        children: rows
    });
    while(++position < lineCount){
        line = lines[position];
        row = {
            type: "tableRow",
            children: []
        };
        /* Eat a newline character when this is not the
     * first row. */ if (position) eat(C_NEWLINE);
        /* Eat the row. */ eat(line).reset(row, table);
        length = line.length + 1;
        index = 0;
        queue = "";
        cell = "";
        preamble = true;
        count = null;
        opening = null;
        while(index < length){
            character = line.charAt(index);
            if (character === C_TAB || character === C_SPACE) {
                if (cell) queue += character;
                else eat(character);
                index++;
                continue;
            }
            if (character === "" || character === C_PIPE) {
                if (preamble) eat(character);
                else {
                    if (character && opening) {
                        queue += character;
                        index++;
                        continue;
                    }
                    if ((cell || character) && !preamble) {
                        subvalue = cell;
                        if (queue.length > 1) {
                            if (character) {
                                subvalue += queue.slice(0, queue.length - 1);
                                queue = queue.charAt(queue.length - 1);
                            } else {
                                subvalue += queue;
                                queue = "";
                            }
                        }
                        now = eat.now();
                        eat(subvalue)({
                            type: "tableCell",
                            children: self.tokenizeInline(cell, now)
                        }, row);
                    }
                    eat(queue + character);
                    queue = "";
                    cell = "";
                }
            } else {
                if (queue) {
                    cell += queue;
                    queue = "";
                }
                cell += character;
                if (character === C_BACKSLASH && index !== length - 2) {
                    cell += line.charAt(index + 1);
                    index++;
                }
                if (character === C_TICK) {
                    count = 1;
                    while(line.charAt(index + 1) === character){
                        cell += character;
                        index++;
                        count++;
                    }
                    if (!opening) opening = count;
                    else if (count >= opening) opening = 0;
                }
            }
            preamble = false;
            index++;
        }
        /* Eat the alignment row. */ if (!position) eat(C_NEWLINE + alignments);
    }
    return table;
}

},{"d8da38b145607a10":"eZxzQ"}],"797JA":[function(require,module,exports) {
"use strict";
var trim = require("1433bf8f6cef3c88");
var decimal = require("af8de0b1f8f5401f");
var trimTrailingLines = require("52b9eb27edaadb04");
var interrupt = require("c7bb9e6fd531a2c9");
module.exports = paragraph;
var C_NEWLINE = "\n";
var C_TAB = "	";
var C_SPACE = " ";
var TAB_SIZE = 4;
/* Tokenise paragraph. */ function paragraph(eat, value, silent) {
    var self = this;
    var settings = self.options;
    var commonmark = settings.commonmark;
    var gfm = settings.gfm;
    var tokenizers = self.blockTokenizers;
    var interruptors = self.interruptParagraph;
    var index = value.indexOf(C_NEWLINE);
    var length = value.length;
    var position;
    var subvalue;
    var character;
    var size;
    var now;
    while(index < length){
        /* Eat everything if there’s no following newline. */ if (index === -1) {
            index = length;
            break;
        }
        /* Stop if the next character is NEWLINE. */ if (value.charAt(index + 1) === C_NEWLINE) break;
        /* In commonmark-mode, following indented lines
     * are part of the paragraph. */ if (commonmark) {
            size = 0;
            position = index + 1;
            while(position < length){
                character = value.charAt(position);
                if (character === C_TAB) {
                    size = TAB_SIZE;
                    break;
                } else if (character === C_SPACE) size++;
                else break;
                position++;
            }
            if (size >= TAB_SIZE) {
                index = value.indexOf(C_NEWLINE, index + 1);
                continue;
            }
        }
        subvalue = value.slice(index + 1);
        /* Check if the following code contains a possible
     * block. */ if (interrupt(interruptors, tokenizers, self, [
            eat,
            subvalue,
            true
        ])) break;
        /* Break if the following line starts a list, when
     * already in a list, or when in commonmark, or when
     * in gfm mode and the bullet is *not* numeric. */ if (tokenizers.list.call(self, eat, subvalue, true) && (self.inList || commonmark || gfm && !decimal(trim.left(subvalue).charAt(0)))) break;
        position = index;
        index = value.indexOf(C_NEWLINE, index + 1);
        if (index !== -1 && trim(value.slice(position, index)) === "") {
            index = position;
            break;
        }
    }
    subvalue = value.slice(0, index);
    if (trim(subvalue) === "") {
        eat(subvalue);
        return null;
    }
    /* istanbul ignore if - never used (yet) */ if (silent) return true;
    now = eat.now();
    subvalue = trimTrailingLines(subvalue);
    return eat(subvalue)({
        type: "paragraph",
        children: self.tokenizeInline(subvalue, now)
    });
}

},{"1433bf8f6cef3c88":"3ZUw2","af8de0b1f8f5401f":"9stpX","52b9eb27edaadb04":"h8Fli","c7bb9e6fd531a2c9":"8JNMb"}],"ai4nv":[function(require,module,exports) {
"use strict";
var locate = require("bb52ca4746a41b5d");
module.exports = escape;
escape.locator = locate;
function escape(eat, value, silent) {
    var self = this;
    var character;
    var node;
    if (value.charAt(0) === "\\") {
        character = value.charAt(1);
        if (self.escape.indexOf(character) !== -1) {
            /* istanbul ignore if - never used (yet) */ if (silent) return true;
            if (character === "\n") node = {
                type: "break"
            };
            else node = {
                type: "text",
                value: character
            };
            return eat("\\" + character)(node);
        }
    }
}

},{"bb52ca4746a41b5d":"ePchY"}],"ePchY":[function(require,module,exports) {
"use strict";
module.exports = locate;
function locate(value, fromIndex) {
    return value.indexOf("\\", fromIndex);
}

},{}],"cwyyB":[function(require,module,exports) {
"use strict";
var whitespace = require("ec675e6cf90ecbd5");
var decode = require("17892a5ad328bbe4");
var locate = require("613fbcb61130d971");
module.exports = autoLink;
autoLink.locator = locate;
autoLink.notInLink = true;
var C_LT = "<";
var C_GT = ">";
var C_AT_SIGN = "@";
var C_SLASH = "/";
var MAILTO = "mailto:";
var MAILTO_LENGTH = MAILTO.length;
/* Tokenise a link. */ function autoLink(eat, value, silent) {
    var self;
    var subvalue;
    var length;
    var index;
    var queue;
    var character;
    var hasAtCharacter;
    var link;
    var now;
    var content;
    var tokenizers;
    var exit;
    if (value.charAt(0) !== C_LT) return;
    self = this;
    subvalue = "";
    length = value.length;
    index = 0;
    queue = "";
    hasAtCharacter = false;
    link = "";
    index++;
    subvalue = C_LT;
    while(index < length){
        character = value.charAt(index);
        if (whitespace(character) || character === C_GT || character === C_AT_SIGN || character === ":" && value.charAt(index + 1) === C_SLASH) break;
        queue += character;
        index++;
    }
    if (!queue) return;
    link += queue;
    queue = "";
    character = value.charAt(index);
    link += character;
    index++;
    if (character === C_AT_SIGN) hasAtCharacter = true;
    else {
        if (character !== ":" || value.charAt(index + 1) !== C_SLASH) return;
        link += C_SLASH;
        index++;
    }
    while(index < length){
        character = value.charAt(index);
        if (whitespace(character) || character === C_GT) break;
        queue += character;
        index++;
    }
    character = value.charAt(index);
    if (!queue || character !== C_GT) return;
    /* istanbul ignore if - never used (yet) */ if (silent) return true;
    link += queue;
    content = link;
    subvalue += link + character;
    now = eat.now();
    now.column++;
    now.offset++;
    if (hasAtCharacter) {
        if (link.slice(0, MAILTO_LENGTH).toLowerCase() === MAILTO) {
            content = content.substr(MAILTO_LENGTH);
            now.column += MAILTO_LENGTH;
            now.offset += MAILTO_LENGTH;
        } else link = MAILTO + link;
    }
    /* Temporarily remove all tokenizers except text in autolinks. */ tokenizers = self.inlineTokenizers;
    self.inlineTokenizers = {
        text: tokenizers.text
    };
    exit = self.enterLink();
    content = self.tokenizeInline(content, now);
    self.inlineTokenizers = tokenizers;
    exit();
    return eat(subvalue)({
        type: "link",
        title: null,
        url: decode(link, {
            nonTerminated: false
        }),
        children: content
    });
}

},{"ec675e6cf90ecbd5":"eZxzQ","17892a5ad328bbe4":"ezLBv","613fbcb61130d971":"7CeWz"}],"7CeWz":[function(require,module,exports) {
"use strict";
module.exports = locate;
function locate(value, fromIndex) {
    return value.indexOf("<", fromIndex);
}

},{}],"3tVsG":[function(require,module,exports) {
"use strict";
var decode = require("5fe32ff01ce8b1b1");
var whitespace = require("d344bc34697eeb0e");
var locate = require("dd64c52e4aac651a");
module.exports = url;
url.locator = locate;
url.notInLink = true;
var C_BRACKET_OPEN = "[";
var C_BRACKET_CLOSE = "]";
var C_PAREN_OPEN = "(";
var C_PAREN_CLOSE = ")";
var C_LT = "<";
var C_AT_SIGN = "@";
var HTTP_PROTOCOL = "http://";
var HTTPS_PROTOCOL = "https://";
var MAILTO_PROTOCOL = "mailto:";
var PROTOCOLS = [
    HTTP_PROTOCOL,
    HTTPS_PROTOCOL,
    MAILTO_PROTOCOL
];
var PROTOCOLS_LENGTH = PROTOCOLS.length;
function url(eat, value, silent) {
    var self = this;
    var subvalue;
    var content;
    var character;
    var index;
    var position;
    var protocol;
    var match;
    var length;
    var queue;
    var parenCount;
    var nextCharacter;
    var exit;
    if (!self.options.gfm) return;
    subvalue = "";
    index = -1;
    length = PROTOCOLS_LENGTH;
    while(++index < length){
        protocol = PROTOCOLS[index];
        match = value.slice(0, protocol.length);
        if (match.toLowerCase() === protocol) {
            subvalue = match;
            break;
        }
    }
    if (!subvalue) return;
    index = subvalue.length;
    length = value.length;
    queue = "";
    parenCount = 0;
    while(index < length){
        character = value.charAt(index);
        if (whitespace(character) || character === C_LT) break;
        if (character === "." || character === "," || character === ":" || character === ";" || character === '"' || character === "'" || character === ")" || character === "]") {
            nextCharacter = value.charAt(index + 1);
            if (!nextCharacter || whitespace(nextCharacter)) break;
        }
        if (character === C_PAREN_OPEN || character === C_BRACKET_OPEN) parenCount++;
        if (character === C_PAREN_CLOSE || character === C_BRACKET_CLOSE) {
            parenCount--;
            if (parenCount < 0) break;
        }
        queue += character;
        index++;
    }
    if (!queue) return;
    subvalue += queue;
    content = subvalue;
    if (protocol === MAILTO_PROTOCOL) {
        position = queue.indexOf(C_AT_SIGN);
        if (position === -1 || position === length - 1) return;
        content = content.substr(MAILTO_PROTOCOL.length);
    }
    /* istanbul ignore if - never used (yet) */ if (silent) return true;
    exit = self.enterLink();
    content = self.tokenizeInline(content, eat.now());
    exit();
    return eat(subvalue)({
        type: "link",
        title: null,
        url: decode(subvalue, {
            nonTerminated: false
        }),
        children: content
    });
}

},{"5fe32ff01ce8b1b1":"ezLBv","d344bc34697eeb0e":"eZxzQ","dd64c52e4aac651a":"5wEjC"}],"5wEjC":[function(require,module,exports) {
"use strict";
module.exports = locate;
var PROTOCOLS = [
    "https://",
    "http://",
    "mailto:"
];
function locate(value, fromIndex) {
    var length = PROTOCOLS.length;
    var index = -1;
    var min = -1;
    var position;
    if (!this.options.gfm) return -1;
    while(++index < length){
        position = value.indexOf(PROTOCOLS[index], fromIndex);
        if (position !== -1 && (position < min || min === -1)) min = position;
    }
    return min;
}

},{}],"aRvvJ":[function(require,module,exports) {
"use strict";
var alphabetical = require("5505aeea3e04b648");
var locate = require("26407da2e671cd62");
var tag = require("35dca16a337c4f72").tag;
module.exports = inlineHTML;
inlineHTML.locator = locate;
var EXPRESSION_HTML_LINK_OPEN = /^<a /i;
var EXPRESSION_HTML_LINK_CLOSE = /^<\/a>/i;
function inlineHTML(eat, value, silent) {
    var self = this;
    var length = value.length;
    var character;
    var subvalue;
    if (value.charAt(0) !== "<" || length < 3) return;
    character = value.charAt(1);
    if (!alphabetical(character) && character !== "?" && character !== "!" && character !== "/") return;
    subvalue = value.match(tag);
    if (!subvalue) return;
    /* istanbul ignore if - not used yet. */ if (silent) return true;
    subvalue = subvalue[0];
    if (!self.inLink && EXPRESSION_HTML_LINK_OPEN.test(subvalue)) self.inLink = true;
    else if (self.inLink && EXPRESSION_HTML_LINK_CLOSE.test(subvalue)) self.inLink = false;
    return eat(subvalue)({
        type: "html",
        value: subvalue
    });
}

},{"5505aeea3e04b648":"j7DnA","26407da2e671cd62":"7CeWz","35dca16a337c4f72":"f7yZK"}],"kczPT":[function(require,module,exports) {
"use strict";
var whitespace = require("8bf452e4e14fe682");
var locate = require("ec435aa16ba6dfa5");
module.exports = link;
link.locator = locate;
var own = {}.hasOwnProperty;
var C_BACKSLASH = "\\";
var C_BRACKET_OPEN = "[";
var C_BRACKET_CLOSE = "]";
var C_PAREN_OPEN = "(";
var C_PAREN_CLOSE = ")";
var C_LT = "<";
var C_GT = ">";
var C_TICK = "`";
var C_DOUBLE_QUOTE = '"';
var C_SINGLE_QUOTE = "'";
/* Map of characters, which can be used to mark link
 * and image titles. */ var LINK_MARKERS = {};
LINK_MARKERS[C_DOUBLE_QUOTE] = C_DOUBLE_QUOTE;
LINK_MARKERS[C_SINGLE_QUOTE] = C_SINGLE_QUOTE;
/* Map of characters, which can be used to mark link
 * and image titles in commonmark-mode. */ var COMMONMARK_LINK_MARKERS = {};
COMMONMARK_LINK_MARKERS[C_DOUBLE_QUOTE] = C_DOUBLE_QUOTE;
COMMONMARK_LINK_MARKERS[C_SINGLE_QUOTE] = C_SINGLE_QUOTE;
COMMONMARK_LINK_MARKERS[C_PAREN_OPEN] = C_PAREN_CLOSE;
function link(eat, value, silent) {
    var self = this;
    var subvalue = "";
    var index = 0;
    var character = value.charAt(0);
    var pedantic = self.options.pedantic;
    var commonmark = self.options.commonmark;
    var gfm = self.options.gfm;
    var closed;
    var count;
    var opening;
    var beforeURL;
    var beforeTitle;
    var subqueue;
    var hasMarker;
    var markers;
    var isImage;
    var content;
    var marker;
    var length;
    var title;
    var depth;
    var queue;
    var url;
    var now;
    var exit;
    var node;
    /* Detect whether this is an image. */ if (character === "!") {
        isImage = true;
        subvalue = character;
        character = value.charAt(++index);
    }
    /* Eat the opening. */ if (character !== C_BRACKET_OPEN) return;
    /* Exit when this is a link and we’re already inside
   * a link. */ if (!isImage && self.inLink) return;
    subvalue += character;
    queue = "";
    index++;
    /* Eat the content. */ length = value.length;
    now = eat.now();
    depth = 0;
    now.column += index;
    now.offset += index;
    while(index < length){
        character = value.charAt(index);
        subqueue = character;
        if (character === C_TICK) {
            /* Inline-code in link content. */ count = 1;
            while(value.charAt(index + 1) === C_TICK){
                subqueue += character;
                index++;
                count++;
            }
            if (!opening) opening = count;
            else if (count >= opening) opening = 0;
        } else if (character === C_BACKSLASH) {
            /* Allow brackets to be escaped. */ index++;
            subqueue += value.charAt(index);
        /* In GFM mode, brackets in code still count.
     * In all other modes, they don’t.  This empty
     * block prevents the next statements are
     * entered. */ } else if ((!opening || gfm) && character === C_BRACKET_OPEN) depth++;
        else if ((!opening || gfm) && character === C_BRACKET_CLOSE) {
            if (depth) depth--;
            else {
                /* Allow white-space between content and
         * url in GFM mode. */ if (!pedantic) while(index < length){
                    character = value.charAt(index + 1);
                    if (!whitespace(character)) break;
                    subqueue += character;
                    index++;
                }
                if (value.charAt(index + 1) !== C_PAREN_OPEN) return;
                subqueue += C_PAREN_OPEN;
                closed = true;
                index++;
                break;
            }
        }
        queue += subqueue;
        subqueue = "";
        index++;
    }
    /* Eat the content closing. */ if (!closed) return;
    content = queue;
    subvalue += queue + subqueue;
    index++;
    /* Eat white-space. */ while(index < length){
        character = value.charAt(index);
        if (!whitespace(character)) break;
        subvalue += character;
        index++;
    }
    /* Eat the URL. */ character = value.charAt(index);
    markers = commonmark ? COMMONMARK_LINK_MARKERS : LINK_MARKERS;
    queue = "";
    beforeURL = subvalue;
    if (character === C_LT) {
        index++;
        beforeURL += C_LT;
        while(index < length){
            character = value.charAt(index);
            if (character === C_GT) break;
            if (commonmark && character === "\n") return;
            queue += character;
            index++;
        }
        if (value.charAt(index) !== C_GT) return;
        subvalue += C_LT + queue + C_GT;
        url = queue;
        index++;
    } else {
        character = null;
        subqueue = "";
        while(index < length){
            character = value.charAt(index);
            if (subqueue && own.call(markers, character)) break;
            if (whitespace(character)) {
                if (!pedantic) break;
                subqueue += character;
            } else {
                if (character === C_PAREN_OPEN) depth++;
                else if (character === C_PAREN_CLOSE) {
                    if (depth === 0) break;
                    depth--;
                }
                queue += subqueue;
                subqueue = "";
                if (character === C_BACKSLASH) {
                    queue += C_BACKSLASH;
                    character = value.charAt(++index);
                }
                queue += character;
            }
            index++;
        }
        subvalue += queue;
        url = queue;
        index = subvalue.length;
    }
    /* Eat white-space. */ queue = "";
    while(index < length){
        character = value.charAt(index);
        if (!whitespace(character)) break;
        queue += character;
        index++;
    }
    character = value.charAt(index);
    subvalue += queue;
    /* Eat the title. */ if (queue && own.call(markers, character)) {
        index++;
        subvalue += character;
        queue = "";
        marker = markers[character];
        beforeTitle = subvalue;
        /* In commonmark-mode, things are pretty easy: the
     * marker cannot occur inside the title.
     *
     * Non-commonmark does, however, support nested
     * delimiters. */ if (commonmark) {
            while(index < length){
                character = value.charAt(index);
                if (character === marker) break;
                if (character === C_BACKSLASH) {
                    queue += C_BACKSLASH;
                    character = value.charAt(++index);
                }
                index++;
                queue += character;
            }
            character = value.charAt(index);
            if (character !== marker) return;
            title = queue;
            subvalue += queue + character;
            index++;
            while(index < length){
                character = value.charAt(index);
                if (!whitespace(character)) break;
                subvalue += character;
                index++;
            }
        } else {
            subqueue = "";
            while(index < length){
                character = value.charAt(index);
                if (character === marker) {
                    if (hasMarker) {
                        queue += marker + subqueue;
                        subqueue = "";
                    }
                    hasMarker = true;
                } else if (!hasMarker) queue += character;
                else if (character === C_PAREN_CLOSE) {
                    subvalue += queue + marker + subqueue;
                    title = queue;
                    break;
                } else if (whitespace(character)) subqueue += character;
                else {
                    queue += marker + subqueue + character;
                    subqueue = "";
                    hasMarker = false;
                }
                index++;
            }
        }
    }
    if (value.charAt(index) !== C_PAREN_CLOSE) return;
    /* istanbul ignore if - never used (yet) */ if (silent) return true;
    subvalue += C_PAREN_CLOSE;
    url = self.decode.raw(self.unescape(url), eat(beforeURL).test().end, {
        nonTerminated: false
    });
    if (title) {
        beforeTitle = eat(beforeTitle).test().end;
        title = self.decode.raw(self.unescape(title), beforeTitle);
    }
    node = {
        type: isImage ? "image" : "link",
        title: title || null,
        url: url
    };
    if (isImage) node.alt = self.decode.raw(self.unescape(content), now) || null;
    else {
        exit = self.enterLink();
        node.children = self.tokenizeInline(content, now);
        exit();
    }
    return eat(subvalue)(node);
}

},{"8bf452e4e14fe682":"eZxzQ","ec435aa16ba6dfa5":"bXNWW"}],"bXNWW":[function(require,module,exports) {
"use strict";
module.exports = locate;
function locate(value, fromIndex) {
    var link = value.indexOf("[", fromIndex);
    var image = value.indexOf("![", fromIndex);
    if (image === -1) return link;
    /* Link can never be `-1` if an image is found, so we don’t need
   * to check for that :) */ return link < image ? link : image;
}

},{}],"cuzbh":[function(require,module,exports) {
"use strict";
var whitespace = require("e0722d2d2f97263c");
var locate = require("7920e78b80b70a86");
var normalize = require("c44c4958bd61f75");
module.exports = reference;
reference.locator = locate;
var T_LINK = "link";
var T_IMAGE = "image";
var T_FOOTNOTE = "footnote";
var REFERENCE_TYPE_SHORTCUT = "shortcut";
var REFERENCE_TYPE_COLLAPSED = "collapsed";
var REFERENCE_TYPE_FULL = "full";
var C_CARET = "^";
var C_BACKSLASH = "\\";
var C_BRACKET_OPEN = "[";
var C_BRACKET_CLOSE = "]";
function reference(eat, value, silent) {
    var self = this;
    var character = value.charAt(0);
    var index = 0;
    var length = value.length;
    var subvalue = "";
    var intro = "";
    var type = T_LINK;
    var referenceType = REFERENCE_TYPE_SHORTCUT;
    var content;
    var identifier;
    var now;
    var node;
    var exit;
    var queue;
    var bracketed;
    var depth;
    /* Check whether we’re eating an image. */ if (character === "!") {
        type = T_IMAGE;
        intro = character;
        character = value.charAt(++index);
    }
    if (character !== C_BRACKET_OPEN) return;
    index++;
    intro += character;
    queue = "";
    /* Check whether we’re eating a footnote. */ if (self.options.footnotes && value.charAt(index) === C_CARET) {
        /* Exit if `![^` is found, so the `!` will be seen as text after this,
     * and we’ll enter this function again when `[^` is found. */ if (type === T_IMAGE) return;
        intro += C_CARET;
        index++;
        type = T_FOOTNOTE;
    }
    /* Eat the text. */ depth = 0;
    while(index < length){
        character = value.charAt(index);
        if (character === C_BRACKET_OPEN) {
            bracketed = true;
            depth++;
        } else if (character === C_BRACKET_CLOSE) {
            if (!depth) break;
            depth--;
        }
        if (character === C_BACKSLASH) {
            queue += C_BACKSLASH;
            character = value.charAt(++index);
        }
        queue += character;
        index++;
    }
    subvalue = queue;
    content = queue;
    character = value.charAt(index);
    if (character !== C_BRACKET_CLOSE) return;
    index++;
    subvalue += character;
    queue = "";
    while(index < length){
        character = value.charAt(index);
        if (!whitespace(character)) break;
        queue += character;
        index++;
    }
    character = value.charAt(index);
    /* Inline footnotes cannot have an identifier. */ if (type !== T_FOOTNOTE && character === C_BRACKET_OPEN) {
        identifier = "";
        queue += character;
        index++;
        while(index < length){
            character = value.charAt(index);
            if (character === C_BRACKET_OPEN || character === C_BRACKET_CLOSE) break;
            if (character === C_BACKSLASH) {
                identifier += C_BACKSLASH;
                character = value.charAt(++index);
            }
            identifier += character;
            index++;
        }
        character = value.charAt(index);
        if (character === C_BRACKET_CLOSE) {
            referenceType = identifier ? REFERENCE_TYPE_FULL : REFERENCE_TYPE_COLLAPSED;
            queue += identifier + character;
            index++;
        } else identifier = "";
        subvalue += queue;
        queue = "";
    } else {
        if (!content) return;
        identifier = content;
    }
    /* Brackets cannot be inside the identifier. */ if (referenceType !== REFERENCE_TYPE_FULL && bracketed) return;
    subvalue = intro + subvalue;
    if (type === T_LINK && self.inLink) return null;
    /* istanbul ignore if - never used (yet) */ if (silent) return true;
    if (type === T_FOOTNOTE && content.indexOf(" ") !== -1) return eat(subvalue)({
        type: "footnote",
        children: this.tokenizeInline(content, eat.now())
    });
    now = eat.now();
    now.column += intro.length;
    now.offset += intro.length;
    identifier = referenceType === REFERENCE_TYPE_FULL ? identifier : content;
    node = {
        type: type + "Reference",
        identifier: normalize(identifier)
    };
    if (type === T_LINK || type === T_IMAGE) node.referenceType = referenceType;
    if (type === T_LINK) {
        exit = self.enterLink();
        node.children = self.tokenizeInline(content, now);
        exit();
    } else if (type === T_IMAGE) node.alt = self.decode.raw(self.unescape(content), now) || null;
    return eat(subvalue)(node);
}

},{"e0722d2d2f97263c":"eZxzQ","7920e78b80b70a86":"bXNWW","c44c4958bd61f75":"dHFtV"}],"kxfF8":[function(require,module,exports) {
"use strict";
var trim = require("64bc6875e8e1dd3c");
var whitespace = require("9b6672e9b843f459");
var locate = require("571778f2598c23b6");
module.exports = strong;
strong.locator = locate;
var C_ASTERISK = "*";
var C_UNDERSCORE = "_";
function strong(eat, value, silent) {
    var self = this;
    var index = 0;
    var character = value.charAt(index);
    var now;
    var pedantic;
    var marker;
    var queue;
    var subvalue;
    var length;
    var prev;
    if (character !== C_ASTERISK && character !== C_UNDERSCORE || value.charAt(++index) !== character) return;
    pedantic = self.options.pedantic;
    marker = character;
    subvalue = marker + marker;
    length = value.length;
    index++;
    queue = "";
    character = "";
    if (pedantic && whitespace(value.charAt(index))) return;
    while(index < length){
        prev = character;
        character = value.charAt(index);
        if (character === marker && value.charAt(index + 1) === marker && (!pedantic || !whitespace(prev))) {
            character = value.charAt(index + 2);
            if (character !== marker) {
                if (!trim(queue)) return;
                /* istanbul ignore if - never used (yet) */ if (silent) return true;
                now = eat.now();
                now.column += 2;
                now.offset += 2;
                return eat(subvalue + queue + subvalue)({
                    type: "strong",
                    children: self.tokenizeInline(queue, now)
                });
            }
        }
        if (!pedantic && character === "\\") {
            queue += character;
            character = value.charAt(++index);
        }
        queue += character;
        index++;
    }
}

},{"64bc6875e8e1dd3c":"3ZUw2","9b6672e9b843f459":"eZxzQ","571778f2598c23b6":"41HtM"}],"41HtM":[function(require,module,exports) {
"use strict";
module.exports = locate;
function locate(value, fromIndex) {
    var asterisk = value.indexOf("**", fromIndex);
    var underscore = value.indexOf("__", fromIndex);
    if (underscore === -1) return asterisk;
    if (asterisk === -1) return underscore;
    return underscore < asterisk ? underscore : asterisk;
}

},{}],"83xo3":[function(require,module,exports) {
"use strict";
var trim = require("2489f367f28aeaeb");
var word = require("17e61b27712e15ef");
var whitespace = require("d4427c959e96709e");
var locate = require("9a6bc6d0f798cd52");
module.exports = emphasis;
emphasis.locator = locate;
var C_ASTERISK = "*";
var C_UNDERSCORE = "_";
function emphasis(eat, value, silent) {
    var self = this;
    var index = 0;
    var character = value.charAt(index);
    var now;
    var pedantic;
    var marker;
    var queue;
    var subvalue;
    var length;
    var prev;
    if (character !== C_ASTERISK && character !== C_UNDERSCORE) return;
    pedantic = self.options.pedantic;
    subvalue = character;
    marker = character;
    length = value.length;
    index++;
    queue = "";
    character = "";
    if (pedantic && whitespace(value.charAt(index))) return;
    while(index < length){
        prev = character;
        character = value.charAt(index);
        if (character === marker && (!pedantic || !whitespace(prev))) {
            character = value.charAt(++index);
            if (character !== marker) {
                if (!trim(queue) || prev === marker) return;
                if (!pedantic && marker === C_UNDERSCORE && word(character)) {
                    queue += marker;
                    continue;
                }
                /* istanbul ignore if - never used (yet) */ if (silent) return true;
                now = eat.now();
                now.column++;
                now.offset++;
                return eat(subvalue + queue + marker)({
                    type: "emphasis",
                    children: self.tokenizeInline(queue, now)
                });
            }
            queue += marker;
        }
        if (!pedantic && character === "\\") {
            queue += character;
            character = value.charAt(++index);
        }
        queue += character;
        index++;
    }
}

},{"2489f367f28aeaeb":"3ZUw2","17e61b27712e15ef":"fTwry","d4427c959e96709e":"eZxzQ","9a6bc6d0f798cd52":"7zNiT"}],"fTwry":[function(require,module,exports) {
"use strict";
module.exports = wordCharacter;
var fromCode = String.fromCharCode;
var re = /\w/;
// Check if the given character code, or the character code at the first
// character, is a word character.
function wordCharacter(character) {
    return re.test(typeof character === "number" ? fromCode(character) : character.charAt(0));
}

},{}],"7zNiT":[function(require,module,exports) {
"use strict";
module.exports = locate;
function locate(value, fromIndex) {
    var asterisk = value.indexOf("*", fromIndex);
    var underscore = value.indexOf("_", fromIndex);
    if (underscore === -1) return asterisk;
    if (asterisk === -1) return underscore;
    return underscore < asterisk ? underscore : asterisk;
}

},{}],"9wOze":[function(require,module,exports) {
"use strict";
var whitespace = require("77d460d40057aff7");
var locate = require("985ef95de6823e96");
module.exports = strikethrough;
strikethrough.locator = locate;
var C_TILDE = "~";
var DOUBLE = "~~";
function strikethrough(eat, value, silent) {
    var self = this;
    var character = "";
    var previous = "";
    var preceding = "";
    var subvalue = "";
    var index;
    var length;
    var now;
    if (!self.options.gfm || value.charAt(0) !== C_TILDE || value.charAt(1) !== C_TILDE || whitespace(value.charAt(2))) return;
    index = 1;
    length = value.length;
    now = eat.now();
    now.column += 2;
    now.offset += 2;
    while(++index < length){
        character = value.charAt(index);
        if (character === C_TILDE && previous === C_TILDE && (!preceding || !whitespace(preceding))) {
            /* istanbul ignore if - never used (yet) */ if (silent) return true;
            return eat(DOUBLE + subvalue + DOUBLE)({
                type: "delete",
                children: self.tokenizeInline(subvalue, now)
            });
        }
        subvalue += previous;
        preceding = previous;
        previous = character;
    }
}

},{"77d460d40057aff7":"eZxzQ","985ef95de6823e96":"7Qrfj"}],"7Qrfj":[function(require,module,exports) {
"use strict";
module.exports = locate;
function locate(value, fromIndex) {
    return value.indexOf("~~", fromIndex);
}

},{}],"aT8RH":[function(require,module,exports) {
"use strict";
var whitespace = require("a5f920e06fca2c7b");
var locate = require("7066eff883f81887");
module.exports = inlineCode;
inlineCode.locator = locate;
var C_TICK = "`";
/* Tokenise inline code. */ function inlineCode(eat, value, silent) {
    var length = value.length;
    var index = 0;
    var queue = "";
    var tickQueue = "";
    var contentQueue;
    var subqueue;
    var count;
    var openingCount;
    var subvalue;
    var character;
    var found;
    var next;
    while(index < length){
        if (value.charAt(index) !== C_TICK) break;
        queue += C_TICK;
        index++;
    }
    if (!queue) return;
    subvalue = queue;
    openingCount = index;
    queue = "";
    next = value.charAt(index);
    count = 0;
    while(index < length){
        character = next;
        next = value.charAt(index + 1);
        if (character === C_TICK) {
            count++;
            tickQueue += character;
        } else {
            count = 0;
            queue += character;
        }
        if (count && next !== C_TICK) {
            if (count === openingCount) {
                subvalue += queue + tickQueue;
                found = true;
                break;
            }
            queue += tickQueue;
            tickQueue = "";
        }
        index++;
    }
    if (!found) {
        if (openingCount % 2 !== 0) return;
        queue = "";
    }
    /* istanbul ignore if - never used (yet) */ if (silent) return true;
    contentQueue = "";
    subqueue = "";
    length = queue.length;
    index = -1;
    while(++index < length){
        character = queue.charAt(index);
        if (whitespace(character)) {
            subqueue += character;
            continue;
        }
        if (subqueue) {
            if (contentQueue) contentQueue += subqueue;
            subqueue = "";
        }
        contentQueue += character;
    }
    return eat(subvalue)({
        type: "inlineCode",
        value: contentQueue
    });
}

},{"a5f920e06fca2c7b":"eZxzQ","7066eff883f81887":"aZ5VI"}],"aZ5VI":[function(require,module,exports) {
"use strict";
module.exports = locate;
function locate(value, fromIndex) {
    return value.indexOf("`", fromIndex);
}

},{}],"LYw44":[function(require,module,exports) {
"use strict";
var locate = require("4240a8e637181ed8");
module.exports = hardBreak;
hardBreak.locator = locate;
var MIN_BREAK_LENGTH = 2;
function hardBreak(eat, value, silent) {
    var length = value.length;
    var index = -1;
    var queue = "";
    var character;
    while(++index < length){
        character = value.charAt(index);
        if (character === "\n") {
            if (index < MIN_BREAK_LENGTH) return;
            /* istanbul ignore if - never used (yet) */ if (silent) return true;
            queue += character;
            return eat(queue)({
                type: "break"
            });
        }
        if (character !== " ") return;
        queue += character;
    }
}

},{"4240a8e637181ed8":"aRKty"}],"aRKty":[function(require,module,exports) {
"use strict";
module.exports = locate;
function locate(value, fromIndex) {
    var index = value.indexOf("\n", fromIndex);
    while(index > fromIndex){
        if (value.charAt(index - 1) !== " ") break;
        index--;
    }
    return index;
}

},{}],"fhPzJ":[function(require,module,exports) {
"use strict";
module.exports = text;
function text(eat, value, silent) {
    var self = this;
    var methods;
    var tokenizers;
    var index;
    var length;
    var subvalue;
    var position;
    var tokenizer;
    var name;
    var min;
    var now;
    /* istanbul ignore if - never used (yet) */ if (silent) return true;
    methods = self.inlineMethods;
    length = methods.length;
    tokenizers = self.inlineTokenizers;
    index = -1;
    min = value.length;
    while(++index < length){
        name = methods[index];
        if (name === "text" || !tokenizers[name]) continue;
        tokenizer = tokenizers[name].locator;
        if (!tokenizer) eat.file.fail("Missing locator: `" + name + "`");
        position = tokenizer.call(self, value, 1);
        if (position !== -1 && position < min) min = position;
    }
    subvalue = value.slice(0, min);
    now = eat.now();
    self.decode(subvalue, now, function(content, position, source) {
        eat(source || content)({
            type: "text",
            value: content
        });
    });
}

},{}],"69XVC":[function(require,module,exports) {
var visitWithParents = require("f37f7a21eb479075");
function addListMetadata() {
    return function(ast) {
        visitWithParents(ast, "list", function(listNode, parents) {
            var depth = 0, i, n;
            for(i = 0, n = parents.length; i < n; i++)if (parents[i].type === "list") depth += 1;
            for(i = 0, n = listNode.children.length; i < n; i++){
                var child = listNode.children[i];
                child.index = i;
                child.ordered = listNode.ordered;
            }
            listNode.depth = depth;
        });
        return ast;
    };
}
module.exports = addListMetadata;

},{"f37f7a21eb479075":"4uHzC"}],"4uHzC":[function(require,module,exports) {
"use strict";
/* Expose. */ module.exports = visitParents;
/* Visit. */ function visitParents(tree, type, visitor) {
    var stack = [];
    if (typeof type === "function") {
        visitor = type;
        type = null;
    }
    one(tree);
    /* Visit a single node. */ function one(node) {
        var result;
        if (!type || node.type === type) result = visitor(node, stack.concat());
        if (node.children && result !== false) return all(node.children, node);
        return result;
    }
    /* Visit children in `parent`. */ function all(children, parent) {
        var length = children.length;
        var index = -1;
        var child;
        stack.push(parent);
        while(++index < length){
            child = children[index];
            if (child && one(child) === false) return false;
        }
        stack.pop();
        return true;
    }
}

},{}],"99Cle":[function(require,module,exports) {
"use strict";
/**
 * Naive, simple plugin to match inline nodes without attributes
 * This allows say <strong>foo</strong>, but not <strong class="very">foo</strong>
 * For proper HTML support, you'll want a different plugin
 **/ var visit = require("bc6b1671fc8ab88e");
var type = "virtualHtml";
var selfClosingRe = /^<(area|base|br|col|embed|hr|img|input|keygen|link|meta|param|source|track|wbr)\s*\/?>$/i;
var simpleTagRe = /^<(\/?)([a-z]+)\s*>$/;
module.exports = function(tree) {
    var open;
    var currentParent;
    visit(tree, "html", function(node, index, parent) {
        if (currentParent !== parent) {
            open = [];
            currentParent = parent;
        }
        var selfClosing = getSelfClosing(node);
        if (selfClosing) {
            parent.children.splice(index, 1, {
                type: type,
                tag: selfClosing,
                position: node.position
            });
            return true;
        }
        var current = getSimpleTag(node, parent);
        if (!current) return true;
        var matching = findAndPull(open, current.tag);
        if (matching) parent.children.splice(index, 0, virtual(current, matching, parent));
        else if (!current.opening) open.push(current);
        return true;
    }, true // Iterate in reverse
    );
    return tree;
};
function findAndPull(open, matchingTag) {
    var i = open.length;
    while(i--){
        if (open[i].tag === matchingTag) return open.splice(i, 1)[0];
    }
    return false;
}
function getSimpleTag(node, parent) {
    var match = node.value.match(simpleTagRe);
    return match ? {
        tag: match[2],
        opening: !match[1],
        node: node
    } : false;
}
function getSelfClosing(node) {
    var match = node.value.match(selfClosingRe);
    return match ? match[1] : false;
}
function virtual(fromNode, toNode, parent) {
    var fromIndex = parent.children.indexOf(fromNode.node);
    var toIndex = parent.children.indexOf(toNode.node);
    var extracted = parent.children.splice(fromIndex, toIndex - fromIndex + 1);
    var children = extracted.slice(1, -1);
    return {
        type: type,
        children: children,
        tag: fromNode.tag,
        position: {
            start: fromNode.node.position.start,
            end: toNode.node.position.end,
            indent: []
        }
    };
}

},{"bc6b1671fc8ab88e":"bEiIa"}],"j2VJU":[function(require,module,exports) {
"use strict";
var visit = require("a1df3b3a3cbd363c");
exports.ofType = function(types, mode) {
    return function(node) {
        types.forEach(function(type) {
            return visit(node, type, disallow, true);
        });
        return node;
    };
    function disallow(node, index, parent) {
        if (parent) untangle(node, index, parent, mode);
    }
};
exports.ifNotMatch = function(allowNode, mode) {
    return function(node) {
        visit(node, disallow, true);
        return node;
    };
    function disallow(node, index, parent) {
        if (parent && !allowNode(node, index, parent)) untangle(node, index, parent, mode);
    }
};
function untangle(node, index, parent, mode) {
    if (mode === "remove") parent.children.splice(index, 1);
    else if (mode === "unwrap") {
        var args = [
            index,
            1
        ];
        if (node.children) args = args.concat(node.children);
        Array.prototype.splice.apply(parent.children, args);
    }
}

},{"a1df3b3a3cbd363c":"bEiIa"}],"9swp3":[function(require,module,exports) {
"use strict";
var React = require("a4e5faf4b026f8eb");
var xtend = require("b6c10519d21769b1");
var ReactIs = require("8440d29569ec75e3");
var defaultNodePosition = {
    start: {
        line: 1,
        column: 1,
        offset: 0
    },
    end: {
        line: 1,
        column: 1,
        offset: 0
    }
};
function astToReact(node, options) {
    var parent = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var index = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
    var renderer = options.renderers[node.type]; // nodes generated by plugins may not have position data
    // much of the code after this point will attempt to access properties of the node.position
    // this will set the node position to the parent node's position to prevent errors
    if (node.position === undefined) node.position = parent.node && parent.node.position || defaultNodePosition;
    var pos = node.position.start;
    var key = [
        node.type,
        pos.line,
        pos.column,
        index
    ].join("-");
    if (!ReactIs.isValidElementType(renderer)) throw new Error("Renderer for type `".concat(node.type, "` not defined or is not renderable"));
    var nodeProps = getNodeProps(node, key, options, renderer, parent, index);
    return React.createElement(renderer, nodeProps, nodeProps.children || resolveChildren() || undefined);
    function resolveChildren() {
        return node.children && node.children.map(function(childNode, i) {
            return astToReact(childNode, options, {
                node: node,
                props: nodeProps
            }, i);
        });
    }
} // eslint-disable-next-line max-params, complexity
function getNodeProps(node, key, opts, renderer, parent, index) {
    var props = {
        key: key
    };
    var isTagRenderer = typeof renderer === "string"; // `sourcePos` is true if the user wants source information (line/column info from markdown source)
    if (opts.sourcePos && node.position) props["data-sourcepos"] = flattenPosition(node.position);
    if (opts.rawSourcePos && !isTagRenderer) props.sourcePosition = node.position;
     // If `includeNodeIndex` is true, pass node index info to all non-tag renderers
    if (opts.includeNodeIndex && parent.node && parent.node.children && !isTagRenderer) {
        props.index = parent.node.children.indexOf(node);
        props.parentChildCount = parent.node.children.length;
    }
    var ref = node.identifier !== null && node.identifier !== undefined ? opts.definitions[node.identifier] || {} : null;
    switch(node.type){
        case "root":
            assignDefined(props, {
                className: opts.className
            });
            break;
        case "text":
            props.nodeKey = key;
            props.children = node.value;
            break;
        case "heading":
            props.level = node.depth;
            break;
        case "list":
            props.start = node.start;
            props.ordered = node.ordered;
            props.tight = !node.loose;
            props.depth = node.depth;
            break;
        case "listItem":
            props.checked = node.checked;
            props.tight = !node.loose;
            props.ordered = node.ordered;
            props.index = node.index;
            props.children = getListItemChildren(node, parent).map(function(childNode, i) {
                return astToReact(childNode, opts, {
                    node: node,
                    props: props
                }, i);
            });
            break;
        case "definition":
            assignDefined(props, {
                identifier: node.identifier,
                title: node.title,
                url: node.url
            });
            break;
        case "code":
            assignDefined(props, {
                language: node.lang && node.lang.split(/\s/, 1)[0]
            });
            break;
        case "inlineCode":
            props.children = node.value;
            props.inline = true;
            break;
        case "link":
            assignDefined(props, {
                title: node.title || undefined,
                target: typeof opts.linkTarget === "function" ? opts.linkTarget(node.url, node.children, node.title) : opts.linkTarget,
                href: opts.transformLinkUri ? opts.transformLinkUri(node.url, node.children, node.title) : node.url
            });
            break;
        case "image":
            assignDefined(props, {
                alt: node.alt || undefined,
                title: node.title || undefined,
                src: opts.transformImageUri ? opts.transformImageUri(node.url, node.children, node.title, node.alt) : node.url
            });
            break;
        case "linkReference":
            assignDefined(props, xtend(ref, {
                href: opts.transformLinkUri ? opts.transformLinkUri(ref.href) : ref.href
            }));
            break;
        case "imageReference":
            assignDefined(props, {
                src: opts.transformImageUri && ref.href ? opts.transformImageUri(ref.href, node.children, ref.title, node.alt) : ref.href,
                title: ref.title || undefined,
                alt: node.alt || undefined
            });
            break;
        case "table":
        case "tableHead":
        case "tableBody":
            props.columnAlignment = node.align;
            break;
        case "tableRow":
            props.isHeader = parent.node.type === "tableHead";
            props.columnAlignment = parent.props.columnAlignment;
            break;
        case "tableCell":
            assignDefined(props, {
                isHeader: parent.props.isHeader,
                align: parent.props.columnAlignment[index]
            });
            break;
        case "virtualHtml":
            props.tag = node.tag;
            break;
        case "html":
            // @todo find a better way than this
            props.isBlock = node.position.start.line !== node.position.end.line;
            props.escapeHtml = opts.escapeHtml;
            props.skipHtml = opts.skipHtml;
            break;
        case "parsedHtml":
            var parsedChildren;
            if (node.children) parsedChildren = node.children.map(function(child, i) {
                return astToReact(child, opts, {
                    node: node,
                    props: props
                }, i);
            });
            props.escapeHtml = opts.escapeHtml;
            props.skipHtml = opts.skipHtml;
            props.element = mergeNodeChildren(node, parsedChildren);
            break;
        default:
            assignDefined(props, xtend(node, {
                type: undefined,
                position: undefined,
                children: undefined
            }));
    }
    if (!isTagRenderer && node.value) props.value = node.value;
    return props;
}
function assignDefined(target, attrs) {
    for(var key in attrs)if (typeof attrs[key] !== "undefined") target[key] = attrs[key];
}
function mergeNodeChildren(node, parsedChildren) {
    var el = node.element;
    if (Array.isArray(el)) {
        var Fragment = React.Fragment || "div";
        return React.createElement(Fragment, null, el);
    }
    if (el.props.children || parsedChildren) {
        var children = React.Children.toArray(el.props.children).concat(parsedChildren);
        return React.cloneElement(el, null, children);
    }
    return React.cloneElement(el, null);
}
function flattenPosition(pos) {
    return [
        pos.start.line,
        ":",
        pos.start.column,
        "-",
        pos.end.line,
        ":",
        pos.end.column
    ].map(String).join("");
}
function getListItemChildren(node, parent) {
    if (node.loose) return node.children;
    if (parent.node && node.index > 0 && parent.node.children[node.index - 1].loose) return node.children;
    return unwrapParagraphs(node);
}
function unwrapParagraphs(node) {
    return node.children.reduce(function(array, child) {
        return array.concat(child.type === "paragraph" ? child.children || [] : [
            child
        ]);
    }, []);
}
module.exports = astToReact;

},{"a4e5faf4b026f8eb":"6uln9","b6c10519d21769b1":"7rqcZ","8440d29569ec75e3":"aUAsc"}],"amENg":[function(require,module,exports) {
"use strict";
var visit = require("dd2c285dfd2bc6b9");
module.exports = function(node) {
    visit(node, "table", wrap);
    return node;
};
function wrap(table) {
    var children = table.children;
    table.children = [
        {
            type: "tableHead",
            align: table.align,
            children: [
                children[0]
            ],
            position: children[0].position
        }
    ];
    if (children.length > 1) table.children.push({
        type: "tableBody",
        align: table.align,
        children: children.slice(1),
        position: {
            start: children[1].position.start,
            end: children[children.length - 1].position.end
        }
    });
}

},{"dd2c285dfd2bc6b9":"bEiIa"}],"aE1fk":[function(require,module,exports) {
"use strict";
module.exports = function getDefinitions(node) {
    var defs = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return (node.children || []).reduce(function(definitions, child) {
        if (child.type === "definition") definitions[child.identifier] = {
            href: child.url,
            title: child.title
        };
        return getDefinitions(child, definitions);
    }, defs);
};

},{}],"f9wUw":[function(require,module,exports) {
"use strict";
var protocols = [
    "http",
    "https",
    "mailto",
    "tel"
];
module.exports = function uriTransformer(uri) {
    var url = (uri || "").trim();
    var first = url.charAt(0);
    if (first === "#" || first === "/") return url;
    var colon = url.indexOf(":");
    if (colon === -1) return url;
    var length = protocols.length;
    var index = -1;
    while(++index < length){
        var protocol = protocols[index];
        if (colon === protocol.length && url.slice(0, protocol.length).toLowerCase() === protocol) return url;
    }
    index = url.indexOf("?");
    if (index !== -1 && colon > index) return url;
    index = url.indexOf("#");
    if (index !== -1 && colon > index) return url;
     // eslint-disable-next-line no-script-url
    return "javascript:void(0)";
};

},{}],"01vav":[function(require,module,exports) {
/* eslint-disable react/prop-types, react/no-multi-comp */ "use strict";
var xtend = require("e1b0e4a2442405fc");
var React = require("f4ba4569b89650b7");
var supportsStringRender = parseInt((React.version || "16").slice(0, 2), 10) >= 16;
var createElement = React.createElement;
module.exports = {
    break: "br",
    paragraph: "p",
    emphasis: "em",
    strong: "strong",
    thematicBreak: "hr",
    blockquote: "blockquote",
    delete: "del",
    link: "a",
    image: "img",
    linkReference: "a",
    imageReference: "img",
    table: SimpleRenderer.bind(null, "table"),
    tableHead: SimpleRenderer.bind(null, "thead"),
    tableBody: SimpleRenderer.bind(null, "tbody"),
    tableRow: SimpleRenderer.bind(null, "tr"),
    tableCell: TableCell,
    root: Root,
    text: TextRenderer,
    list: List,
    listItem: ListItem,
    definition: NullRenderer,
    heading: Heading,
    inlineCode: InlineCode,
    code: CodeBlock,
    html: Html,
    virtualHtml: VirtualHtml,
    parsedHtml: ParsedHtml
};
function TextRenderer(props) {
    return supportsStringRender ? props.children : createElement("span", null, props.children);
}
function Root(props) {
    var useFragment = !props.className;
    var root = useFragment ? React.Fragment || "div" : "div";
    return createElement(root, useFragment ? null : props, props.children);
}
function SimpleRenderer(tag, props) {
    return createElement(tag, getCoreProps(props), props.children);
}
function TableCell(props) {
    var style = props.align ? {
        textAlign: props.align
    } : undefined;
    var coreProps = getCoreProps(props);
    return createElement(props.isHeader ? "th" : "td", style ? xtend({
        style: style
    }, coreProps) : coreProps, props.children);
}
function Heading(props) {
    return createElement("h".concat(props.level), getCoreProps(props), props.children);
}
function List(props) {
    var attrs = getCoreProps(props);
    if (props.start !== null && props.start !== 1 && props.start !== undefined) attrs.start = props.start.toString();
    return createElement(props.ordered ? "ol" : "ul", attrs, props.children);
}
function ListItem(props) {
    var checkbox = null;
    if (props.checked !== null && props.checked !== undefined) {
        var checked = props.checked;
        checkbox = createElement("input", {
            type: "checkbox",
            checked: checked,
            readOnly: true
        });
    }
    return createElement("li", getCoreProps(props), checkbox, props.children);
}
function CodeBlock(props) {
    var className = props.language && "language-".concat(props.language);
    var code = createElement("code", className ? {
        className: className
    } : null, props.value);
    return createElement("pre", getCoreProps(props), code);
}
function InlineCode(props) {
    return createElement("code", getCoreProps(props), props.children);
}
function Html(props) {
    if (props.skipHtml) return null;
    var tag = props.isBlock ? "div" : "span";
    if (props.escapeHtml) {
        var comp = React.Fragment || tag;
        return createElement(comp, null, props.value);
    }
    var nodeProps = {
        dangerouslySetInnerHTML: {
            __html: props.value
        }
    };
    return createElement(tag, nodeProps);
}
function ParsedHtml(props) {
    return props["data-sourcepos"] ? React.cloneElement(props.element, {
        "data-sourcepos": props["data-sourcepos"]
    }) : props.element;
}
function VirtualHtml(props) {
    return createElement(props.tag, getCoreProps(props), props.children);
}
function NullRenderer() {
    return null;
}
function getCoreProps(props) {
    return props["data-sourcepos"] ? {
        "data-sourcepos": props["data-sourcepos"]
    } : {};
}

},{"e1b0e4a2442405fc":"7rqcZ","f4ba4569b89650b7":"6uln9"}],"drybg":[function(require,module,exports) {
"use strict";
var HtmlParser = "__RMD_HTML_PARSER__";
exports.HtmlParser = typeof Symbol === "undefined" ? HtmlParser : Symbol(HtmlParser);

},{}],"1OvFL":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Hook to get valid application credentials (id and secret) for the currently authenticated user.
 * Will automatically load credentials from the first available organization and application.
 * Credentials are cached at module level so they only need to be loaded once per session.
 * 
 * @returns ApplicationCredentials with applicationId, applicationSecret, and loading state
 */ parcelHelpers.export(exports, "useApplicationCredentials", ()=>useApplicationCredentials);
var _react = require("react");
var _organizations = require("../api/controllers/organizations");
var _applications = require("../api/controllers/applications");
// Cache credentials at module level so they persist across component instances
let cachedCredentials = null;
let loadingPromise = null;
function useApplicationCredentials() {
    const [credentials, setCredentials] = (0, _react.useState)({
        applicationId: cachedCredentials?.applicationId ?? null,
        applicationSecret: cachedCredentials?.applicationSecret ?? null,
        isLoading: !cachedCredentials
    });
    (0, _react.useEffect)(()=>{
        // If we already have cached credentials, use them
        if (cachedCredentials) {
            setCredentials({
                applicationId: cachedCredentials.applicationId,
                applicationSecret: cachedCredentials.applicationSecret,
                isLoading: false
            });
            return;
        }
        const loadCredentials = async ()=>{
            // If already loading, wait for that promise
            if (loadingPromise) {
                const result = await loadingPromise;
                if (result) setCredentials({
                    applicationId: result.applicationId,
                    applicationSecret: result.applicationSecret,
                    isLoading: false
                });
                else setCredentials({
                    applicationId: null,
                    applicationSecret: null,
                    isLoading: false
                });
                return;
            }
            // Start loading
            loadingPromise = (async ()=>{
                try {
                    // Get organizations for the current user
                    const orgsResult = await (0, _organizations.getOrganizations)();
                    if (orgsResult.resultType !== "Ok" || !orgsResult.data?.length) return null;
                    // Try each organization until we find one with applications
                    for (const org of orgsResult.data){
                        const appsResult = await (0, _applications.getApplicationsForOrg)(org.id);
                        if (appsResult.resultType === "Ok" && appsResult.data?.length > 0) {
                            const app = appsResult.data[0];
                            cachedCredentials = {
                                applicationId: app.id,
                                applicationSecret: app.secret
                            };
                            return cachedCredentials;
                        }
                    }
                    return null;
                } catch (error) {
                    console.error("Failed to load application credentials:", error);
                    return null;
                }
            })();
            const result = await loadingPromise;
            if (result) setCredentials({
                applicationId: result.applicationId,
                applicationSecret: result.applicationSecret,
                isLoading: false
            });
            else setCredentials({
                applicationId: null,
                applicationSecret: null,
                isLoading: false
            });
        };
        loadCredentials();
    }, []);
    return credentials;
}

},{"react":"6uln9","../api/controllers/organizations":"2aFbO","../api/controllers/applications":"1me18","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1jL91":[function(require,module,exports) {
module.exports = require("81fb9eaf5c89a799").getBundleURL("kVLro") + require("b1f20552d1e95075").resolve("gs2Ls");

},{"81fb9eaf5c89a799":"c7Tr5","b1f20552d1e95075":"fyJL2"}],"7RJIh":[function(require,module,exports) {
module.exports = require("b894ba5a4b597f11").getBundleURL("kVLro") + require("564ed14a3cc9bcf").resolve("6gDCy");

},{"b894ba5a4b597f11":"c7Tr5","564ed14a3cc9bcf":"fyJL2"}],"93VwA":[function(require,module,exports) {
module.exports = require("d497cb43d60e94bd").getBundleURL("kVLro") + require("f4c8c4008ca66094").resolve("7SIdT");

},{"d497cb43d60e94bd":"c7Tr5","f4c8c4008ca66094":"fyJL2"}],"ixkJq":[function(require,module,exports) {
module.exports = require("7b9d3f9928b4c446").getBundleURL("kVLro") + require("1cd56da0f1b48cd3").resolve("7lbh9");

},{"7b9d3f9928b4c446":"c7Tr5","1cd56da0f1b48cd3":"fyJL2"}],"8ZCCc":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _defineProperty = require("@babel/runtime/helpers/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _colors = require("../../../constants/colors");
var _footerBar = require("../../structure/FooterBar");
var _footerBarDefault = parcelHelpers.interopDefault(_footerBar);
var _button = require("../../general/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _ssmlDialog = require("./SsmlDialog");
var _ssmlDialogDefault = parcelHelpers.interopDefault(_ssmlDialog);
var _ssmlElementMenu = require("./SsmlElementMenu");
var _ssmlElementMenuDefault = parcelHelpers.interopDefault(_ssmlElementMenu);
var _sayAsMenu = require("./SayAsMenu");
var _sayAsMenuDefault = parcelHelpers.interopDefault(_sayAsMenu);
var _prosodyMenu = require("./ProsodyMenu");
var _prosodyMenuDefault = parcelHelpers.interopDefault(_prosodyMenu);
var _breakSelector = require("./BreakSelector");
var _breakSelectorDefault = parcelHelpers.interopDefault(_breakSelector);
var _audioSelector = require("./AudioSelector");
var _audioSelectorDefault = parcelHelpers.interopDefault(_audioSelector);
var _speedSelector = require("./SpeedSelector");
var _speedSelectorDefault = parcelHelpers.interopDefault(_speedSelector);
var _pitchSelector = require("./PitchSelector");
var _pitchSelectorDefault = parcelHelpers.interopDefault(_pitchSelector);
var _emphasisSelector = require("./EmphasisSelector");
var _emphasisSelectorDefault = parcelHelpers.interopDefault(_emphasisSelector);
var _volumeSelector = require("./VolumeSelector");
var _volumeSelectorDefault = parcelHelpers.interopDefault(_volumeSelector);
var _dateSelector = require("./DateSelector");
var _dateSelectorDefault = parcelHelpers.interopDefault(_dateSelector);
var _ssmlParseService = require("../../../services/ssmlParseService");
var _ssmlParseServiceDefault = parcelHelpers.interopDefault(_ssmlParseService);
const deleteIcon = require("17b3f15375cbd74e");
const ssmlIcon = require("e8ad8b1e95a660a8");
const cancelIcon = require("8abf9bfc4618a91");
const breakIcon = require("9e332968a568a16d");
const audioIcon = require("8f8d3198096d3034");
const sayAsIcon = require("584980ca54cc7b40");
const effectIcon = require("1d63efc0b4144c21");
const backIcon = require("98804ad1b419b2e7");
const speedIcon = require("d541fcca615c8f5d");
const pitchIcon = require("fb770b99d6ef00cd");
const emphasisIcon = require("e6df697844b66ee");
const volumeIcon = require("3368b2a092914997");
const containerStyle = /*#__PURE__*/ (0, _css.css)("position:absolute;width:100%;border-radius:5px;box-shadow:-1px 4px 10px 0 rgba(48, 69, 98, 0.1);background-color:#ffffff;bottom:2px;border:1px solid ", (0, _colors.silver_two), ";display:flex;flex-direction:column;.footer-bar{border-radius:0 0 5px 5px;}.modal-body{padding:22px;margin-bottom:70px;}.button-container{padding:0 22px;width:100%;display:flex;flex-direction:row;justify-content:center;flex:1;}.triangle{position:absolute;bottom:-5px;right:14px;width:10px;height:10px;border-bottom:1px solid ", (0, _colors.silver_two), ";border-right:1px solid ", (0, _colors.silver_two), ";transform:rotate(45deg);background-color:", (0, _colors.pale_grey), ";}", "");
class SsmlManager extends (0, _reactDefault.default).Component {
    constructor(...args){
        super(...args);
        (0, _definePropertyDefault.default)(this, "ssmlParser", new (0, _ssmlParseServiceDefault.default)());
    }
    componentWillMount() {
        this.setState({
            ...this.state,
            ssml: this.props.ssml,
            currentType: this.getTypeFromObject(this.props.ssmlObject),
            currentSubType: this.getSubTypeFromObject(this.props.ssmlObject),
            canGoBack: this.props.ssmlObject == null,
            placeholder: ""
        });
    }
    getTypeFromObject(ssmlObject) {
        if (ssmlObject == null) return null;
        if (ssmlObject.name == "emphasis") return "prosody";
        return ssmlObject.name;
    }
    getSubTypeFromObject(ssmlObject) {
        if (ssmlObject == null) return null;
        if (ssmlObject.name == "emphasis") return "emphasis";
        if (ssmlObject.name == "prosody") return ssmlObject.attributes[0].name;
        if (ssmlObject.name == "say-as") return ssmlObject.attributes.find((a)=>a.name == "interpret-as").value;
        return null;
    }
    handleSsmlElementSelected(element) {
        this.setState({
            ...this.state,
            currentType: element.value
        });
    }
    handleSayAsSelected(element) {
        if (element.value == "date") this.setState({
            ...this.state,
            currentType: "say-as",
            currentSubType: element.value
        });
        else this.setState({
            ...this.state,
            currentType: "say-as",
            currentSubType: element.value,
            ssml: `<say-as interpret-as="${element.value}">Spoken text</say-as> `,
            placeholder: "Spoken text"
        });
    }
    handleProsodySelected(element) {
        this.setState({
            ...this.state,
            currentType: "prosody",
            currentSubType: element.value
        });
    }
    handleSsmlChange(ssml, placeholder) {
        this.setState({
            ...this.state,
            ssml: ssml,
            placeholder
        });
    }
    handleCancelType() {
        this.setState({
            ...this.state,
            currentType: null,
            ssml: this.props.ssml
        });
        if (this.props.ssmlObject) this.props.onCancel();
    }
    handleCancelSubType() {
        this.setState({
            ...this.state,
            currentSubType: null,
            ssml: this.props.ssml
        });
    }
    handleSave() {
        if (this.props.ssmlObject) {
            // parse ssml, then update the base properties from the ssml object
            const ssmlObject = this.props.ssmlObject;
            const newBaseObject = this.ssmlParser.ssmlToObject(this.state.ssml).children[0];
            ssmlObject.name = newBaseObject.name;
            ssmlObject.attributes = newBaseObject.attributes;
            this.props.onUpdate(ssmlObject);
        } else // if not self-closing, add end
        if (this.state.ssml.endsWith("/>")) this.props.onAdd(this.state.ssml);
        else {
            const separated = this.state.placeholder ? this.state.ssml.split(`>${this.state.placeholder}<`) : this.state.ssml.split("> <");
            const start = separated[0] + ">";
            const end = "<" + separated[1];
            this.props.onAdd(start, end, this.state.placeholder);
        }
    }
    handleRemove() {
        const ssmlObject = this.props.ssmlObject;
        this.props.onRemove(ssmlObject);
    }
    getSsmlByType(tag) {
        if (!this.state.ssml) return null;
        if (!this.state.ssml.startsWith(`<${tag}`)) return null;
        return this.state.ssml;
    }
    renderInnerView() {
        if (this.state.currentType == null) return (0, _react.jsx)((0, _ssmlDialogDefault.default), {
            title: "Add SSML",
            onCancel: this.props.onCancel,
            cancelIcon: cancelIcon,
            titleIcon: ssmlIcon
        }, (0, _react.jsx)((0, _ssmlElementMenuDefault.default), {
            onElementSelected: this.handleSsmlElementSelected.bind(this)
        }));
        if (this.state.currentType == "break") return (0, _react.jsx)((0, _ssmlDialogDefault.default), {
            title: "Pause",
            onCancel: this.handleCancelType.bind(this),
            cancelIcon: backIcon,
            titleIcon: breakIcon
        }, (0, _react.jsx)((0, _breakSelectorDefault.default), {
            onChange: this.handleSsmlChange.bind(this),
            ssml: this.getSsmlByType("break")
        }));
        if (this.state.currentType == "audio") return (0, _react.jsx)((0, _ssmlDialogDefault.default), {
            title: "Audio",
            onCancel: this.handleCancelType.bind(this),
            cancelIcon: backIcon,
            titleIcon: audioIcon
        }, (0, _react.jsx)((0, _audioSelectorDefault.default), {
            applicationId: this.props.applicationId,
            onChange: this.handleSsmlChange.bind(this),
            ssml: this.getSsmlByType("audio")
        }));
        if (this.state.currentType == "say-as") {
            if (this.state.currentSubType == "date") return (0, _react.jsx)((0, _ssmlDialogDefault.default), {
                title: "Say As",
                onCancel: this.handleCancelType.bind(this),
                cancelIcon: backIcon,
                titleIcon: sayAsIcon
            }, (0, _react.jsx)((0, _dateSelectorDefault.default), {
                onChange: this.handleSsmlChange.bind(this),
                ssml: this.getSsmlByType("say-as")
            }));
            else return (0, _react.jsx)((0, _ssmlDialogDefault.default), {
                title: "Say As",
                onCancel: this.handleCancelType.bind(this),
                cancelIcon: backIcon,
                titleIcon: sayAsIcon
            }, (0, _react.jsx)((0, _sayAsMenuDefault.default), {
                selectedValue: this.state.currentSubType,
                onElementSelected: this.handleSayAsSelected.bind(this)
            }));
        }
        if (this.state.currentType == "prosody") {
            if (this.state.currentSubType == "rate") return (0, _react.jsx)((0, _ssmlDialogDefault.default), {
                title: "Speed",
                onCancel: this.handleCancelSubType.bind(this),
                cancelIcon: backIcon,
                titleIcon: pitchIcon
            }, (0, _react.jsx)((0, _speedSelectorDefault.default), {
                onChange: this.handleSsmlChange.bind(this),
                ssml: this.getSsmlByType("prosody")
            }));
            if (this.state.currentSubType == "pitch") return (0, _react.jsx)((0, _ssmlDialogDefault.default), {
                title: "Pitch",
                onCancel: this.handleCancelSubType.bind(this),
                cancelIcon: backIcon,
                titleIcon: speedIcon
            }, (0, _react.jsx)((0, _pitchSelectorDefault.default), {
                onChange: this.handleSsmlChange.bind(this),
                ssml: this.getSsmlByType("prosody")
            }));
            if (this.state.currentSubType == "emphasis") return (0, _react.jsx)((0, _ssmlDialogDefault.default), {
                title: "Emphasis",
                onCancel: this.handleCancelSubType.bind(this),
                cancelIcon: backIcon,
                titleIcon: emphasisIcon
            }, (0, _react.jsx)((0, _emphasisSelectorDefault.default), {
                onChange: this.handleSsmlChange.bind(this),
                ssml: this.getSsmlByType("emphasis")
            }));
            if (this.state.currentSubType == "volume") return (0, _react.jsx)((0, _ssmlDialogDefault.default), {
                title: "Volume",
                onCancel: this.handleCancelSubType.bind(this),
                cancelIcon: backIcon,
                titleIcon: volumeIcon
            }, (0, _react.jsx)((0, _volumeSelectorDefault.default), {
                onChange: this.handleSsmlChange.bind(this),
                ssml: this.getSsmlByType("prosody")
            }));
            else return (0, _react.jsx)((0, _ssmlDialogDefault.default), {
                title: "Effect",
                onCancel: this.handleCancelType.bind(this),
                cancelIcon: backIcon,
                titleIcon: effectIcon
            }, (0, _react.jsx)((0, _prosodyMenuDefault.default), {
                onElementSelected: this.handleProsodySelected.bind(this)
            }));
        }
        this.state.currentType;
        return null;
    }
    render() {
        return (0, _react.jsx)("div", {
            className: containerStyle
        }, (0, _react.jsx)("div", {
            className: "modal-body"
        }, this.renderInnerView()), (0, _react.jsx)((0, _footerBarDefault.default), {
            small: true
        }, (0, _react.jsx)("div", {
            className: "button-container"
        }, (0, _react.jsx)((0, _buttonDefault.default), {
            disabled: this.state.ssml == null || this.state.ssml.length <= 0,
            themes: [
                "primary-small",
                "start-tight"
            ],
            text: this.props.ssmlObject != null ? "Update" : "Add",
            type: "button",
            onClick: this.handleSave.bind(this)
        }), this.props.ssmlObject != null ? (0, _react.jsx)((0, _buttonDefault.default), {
            themes: [
                "white-small"
            ],
            text: "Remove",
            type: "button",
            onClick: this.handleRemove.bind(this)
        }) : null, (0, _react.jsx)((0, _buttonDefault.default), {
            themes: [
                "white-small",
                "end-tight"
            ],
            text: "Cancel",
            type: "button",
            onClick: this.props.onCancel
        }))), (0, _react.jsx)("div", {
            className: "triangle"
        }));
    }
}
exports.default = SsmlManager;

},{"@babel/runtime/helpers/defineProperty":"9sJxO","@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","../../../constants/colors":"1p3OR","../../structure/FooterBar":"bibRL","../../general/Button":"6ymxN","./SsmlDialog":"7wveJ","./SsmlElementMenu":"kGEVe","./SayAsMenu":"5PQW1","./ProsodyMenu":"2ZHwV","./BreakSelector":"fRzhr","./AudioSelector":"eA0OP","./SpeedSelector":"ghH8g","./PitchSelector":"hOldI","./EmphasisSelector":"6kO9g","./VolumeSelector":"2wJqY","./DateSelector":"dpgAy","../../../services/ssmlParseService":"7FRoV","17b3f15375cbd74e":"7eyKJ","e8ad8b1e95a660a8":"1GCXR","8abf9bfc4618a91":"agq6G","9e332968a568a16d":"83gJa","8f8d3198096d3034":"lNiiJ","584980ca54cc7b40":"gdpPx","1d63efc0b4144c21":"jf1xy","98804ad1b419b2e7":"hVLO9","d541fcca615c8f5d":"lw7Cw","fb770b99d6ef00cd":"unvpp","e6df697844b66ee":"fCgcP","3368b2a092914997":"dCUB7","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7wveJ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _colors = require("../../../constants/colors");
const containerStyle = /*#__PURE__*/ (0, _css.css)(".header-wrapper{display:flex;flex-direction:row;align-items:center;>*{margin-right:16px;margin-top:0;margin-bottom:0;}}.body-wrapper{margin-top:22px;}.close-button{width:19px;height:19px;cursor:pointer;}.separator{width:1px;background:", (0, _colors.silver_two), ";height:22px;}.title-icon{width:auto;height:19px;}h3{font-family:Muli;font-size:12px;font-weight:normal;font-style:normal;font-stretch:normal;line-height:normal;letter-spacing:normal;color:#304562;text-transform:uppercase;}", "");
const SsmlDialog = (props)=>(0, _react.jsx)("div", {
        className: containerStyle
    }, (0, _react.jsx)("div", {
        className: "header-wrapper"
    }, (0, _react.jsx)("img", {
        className: "close-button",
        src: props.cancelIcon,
        onClick: props.onCancel
    }), (0, _react.jsx)("div", {
        className: "separator"
    }), (0, _react.jsx)("img", {
        className: "title-icon",
        src: props.titleIcon
    }), (0, _react.jsx)("h3", null, props.title)), (0, _react.jsx)("div", {
        className: "body-wrapper"
    }, props.children));
exports.default = SsmlDialog;

},{"@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","../../../constants/colors":"1p3OR","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"kGEVe":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _ssmlElementSelector = require("./SsmlElementSelector");
var _ssmlElementSelectorDefault = parcelHelpers.interopDefault(_ssmlElementSelector);
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const breakIcon = require("e4968cf24f593152");
const audioIcon = require("e8471abfdb65c432");
const sayAsIcon = require("a7f40a222f2ec162");
const effectIcon = require("5ec547a2e35a3ddc");
const containerStyle = /*#__PURE__*/ (0, _css.css)({
    name: "5dvsdm",
    styles: "display:flex;flex-wrap:wrap;>*+*{margin-left:20px;}"
});
const SsmlElementMenu = (props)=>(0, _react.jsx)("div", {
        className: containerStyle
    }, (0, _react.jsx)((0, _ssmlElementSelectorDefault.default), {
        options: [
            {
                value: "break",
                name: "Pause",
                icon: breakIcon
            },
            {
                value: "audio",
                name: "Audio",
                icon: audioIcon
            }
        ],
        title: "insert",
        onOptionSelected: props.onElementSelected
    }), (0, _react.jsx)((0, _ssmlElementSelectorDefault.default), {
        options: [
            {
                value: "say-as",
                name: "Say as",
                icon: sayAsIcon
            },
            {
                value: "prosody",
                name: "Effect",
                icon: effectIcon
            }
        ],
        title: "alter",
        onOptionSelected: props.onElementSelected
    }));
exports.default = SsmlElementMenu;

},{"@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","./SsmlElementSelector":"5JpFh","e4968cf24f593152":"83gJa","e8471abfdb65c432":"lNiiJ","a7f40a222f2ec162":"gdpPx","5ec547a2e35a3ddc":"jf1xy","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"5JpFh":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _colors = require("../../../constants/colors");
const containerStyle = /*#__PURE__*/ (0, _css.css)("border:1px solid ", (0, _colors.silver_two), ";border-radius:5px;position:relative;height:80px;flex:1;margin-top:4px;.box-title{position:absolute;background:white;text-transform:uppercase;font-family:Muli;font-size:10px;font-weight:600;font-style:normal;font-stretch:normal;line-height:normal;letter-spacing:0.4px;color:", (0, _colors.cool_grey), ";padding:0 4px;top:-6px;left:0;right:0;margin:0 auto;width:40px;text-align:center;}.elements-wrapper{display:flex;flex-direction:row;align-items:center;height:100%;.separator{height:32px;}}.element{min-width:90px;flex:1;display:flex;flex-direction:row;align-items:center;}.ssml-element{height:60px;display:flex;flex-direction:column;align-items:center;justify-content:center;flex-grow:1;cursor:pointer;margin:6px;>img{height:24px;margin-right:0;}p{font-family:Muli;font-size:10px;font-weight:normal;font-style:normal;font-stretch:normal;line-height:normal;letter-spacing:0.4px;text-align:center;color:#304562;margin-top:4px;}&:hover{background-color:rgba(0, 125, 187, 0.1);border-radius:10px;}}", "");
const SsmlElementSelector = (props)=>(0, _react.jsx)("div", {
        className: containerStyle
    }, props.title ? (0, _react.jsx)("p", {
        className: "box-title"
    }, props.title) : null, (0, _react.jsx)("div", {
        className: "elements-wrapper"
    }, props.options.map((o, i)=>(0, _react.jsx)("div", {
            key: o.value,
            className: "element",
            onClick: ()=>props.onOptionSelected(o)
        }, i > 0 ? (0, _react.jsx)("div", {
            className: "separator"
        }) : null, (0, _react.jsx)("div", {
            className: "ssml-element"
        }, (0, _react.jsx)("img", {
            src: o.icon
        }), (0, _react.jsx)("p", null, o.name))))));
exports.default = SsmlElementSelector;

},{"@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","../../../constants/colors":"1p3OR","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"83gJa":[function(require,module,exports) {
module.exports = require("f2cf227834b68933").getBundleURL("kVLro") + require("3870126871808019").resolve("hrqZF");

},{"f2cf227834b68933":"c7Tr5","3870126871808019":"fyJL2"}],"lNiiJ":[function(require,module,exports) {
module.exports = require("666ef8f4c7e767eb").getBundleURL("kVLro") + require("f3eef1c285070a44").resolve("bt5HR");

},{"666ef8f4c7e767eb":"c7Tr5","f3eef1c285070a44":"fyJL2"}],"gdpPx":[function(require,module,exports) {
module.exports = require("8c3755fc2eb573d4").getBundleURL("kVLro") + require("864c4460031e198c").resolve("0lpfA");

},{"8c3755fc2eb573d4":"c7Tr5","864c4460031e198c":"fyJL2"}],"jf1xy":[function(require,module,exports) {
module.exports = require("cb5f08a161b5c13d").getBundleURL("kVLro") + require("b87c4bdd7a1b0947").resolve("fFgfb");

},{"cb5f08a161b5c13d":"c7Tr5","b87c4bdd7a1b0947":"fyJL2"}],"5PQW1":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _ssmlElementCarousel = require("./SsmlElementCarousel");
var _ssmlElementCarouselDefault = parcelHelpers.interopDefault(_ssmlElementCarousel);
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const spellOutIcon = require("740b7618065a3435");
const digitsIcon = require("8b54d9bbdf68227f");
const expletiveIcon = require("2169e91d2ba9d421");
const phoneIcon = require("f75025bab9fc1008");
const addressIcon = require("287c5f9ed6f624c1");
const cardinalIcon = require("c9673a7afc6e79fb");
const ordinalIcon = require("18ee42ec8edd60fe");
const fractionIcon = require("1173fe1c420b40a9");
const dateIcon = require("46b6dcee98d98486");
const timeIcon = require("1ba8f7a6cac20cd7");
const unitIcon = require("7c1e41250abcfd0");
const spellOutBlueIcon = require("5c29cc1b437cee5c");
const digitsBlueIcon = require("fcb03bc61495ff5d");
const expletiveBlueIcon = require("99c6eb8565d65deb");
const phoneBlueIcon = require("da407f38ed662fa1");
const addressBlueIcon = require("5f9d2395ca224d76");
const cardinalBlueIcon = require("65367ecc036e4f29");
const ordinalBlueIcon = require("dc0eda1d9fbaa6c8");
const fractionBlueIcon = require("b0506700fe48c2bb");
const dateBlueIcon = require("ee31a5a271de37f5");
const timeBlueIcon = require("fd5602374b07ae9c");
const unitBlueIcon = require("c1cbaca0171a377a");
const containerStyle = /*#__PURE__*/ (0, _css.css)({
    name: "5dvsdm",
    styles: "display:flex;flex-wrap:wrap;>*+*{margin-left:20px;}"
});
const SayAsMenu = (props)=>(0, _react.jsx)("div", {
        className: containerStyle
    }, (0, _react.jsx)((0, _ssmlElementCarouselDefault.default), {
        selectedValue: props.selectedValue,
        options: [
            {
                value: "characters",
                name: "Characters",
                icon: spellOutIcon,
                selectedIcon: spellOutBlueIcon
            },
            {
                value: "digits",
                name: "Digits",
                icon: digitsIcon,
                selectedIcon: digitsBlueIcon
            },
            {
                value: "expletive",
                name: "Censored",
                icon: expletiveIcon,
                selectedIcon: expletiveBlueIcon
            },
            {
                value: "telephone",
                name: "Phone #",
                icon: phoneIcon,
                selectedIcon: phoneBlueIcon
            },
            // { value: 'address', name: 'Address', icon: addressIcon }, // address is alexa only
            {
                value: "cardinal",
                name: "Cardinal",
                icon: cardinalIcon,
                selectedIcon: cardinalBlueIcon
            },
            {
                value: "ordinal",
                name: "Ordinal",
                icon: ordinalIcon,
                selectedIcon: ordinalBlueIcon
            },
            {
                value: "fraction",
                name: "Fraction",
                icon: fractionIcon,
                selectedIcon: fractionBlueIcon
            },
            {
                value: "date",
                name: "Date",
                icon: dateIcon,
                selectedIcon: dateBlueIcon
            },
            {
                value: "time",
                name: "Time",
                icon: timeIcon,
                selectedIcon: timeBlueIcon
            },
            {
                value: "unit",
                name: "Unit",
                icon: unitIcon,
                selectedIcon: unitBlueIcon
            }
        ],
        onOptionSelected: props.onElementSelected
    }));
exports.default = SayAsMenu;

},{"@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","./SsmlElementCarousel":"bPAVn","740b7618065a3435":"dK2qv","8b54d9bbdf68227f":"iB879","2169e91d2ba9d421":"ksgYJ","f75025bab9fc1008":"c3r3V","287c5f9ed6f624c1":"1OE6C","c9673a7afc6e79fb":"ae3tR","18ee42ec8edd60fe":"fu1RD","1173fe1c420b40a9":"9tQNK","46b6dcee98d98486":"f3KI1","1ba8f7a6cac20cd7":"k5sqa","7c1e41250abcfd0":"d8OYR","5c29cc1b437cee5c":"jx7oV","fcb03bc61495ff5d":"buHMH","99c6eb8565d65deb":"aXauR","da407f38ed662fa1":"diiJX","5f9d2395ca224d76":"iDzSB","65367ecc036e4f29":"eqJpH","dc0eda1d9fbaa6c8":"eMVHn","b0506700fe48c2bb":"8oZfD","ee31a5a271de37f5":"7qyo0","fd5602374b07ae9c":"7hnrM","c1cbaca0171a377a":"r2QR7","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"bPAVn":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _colors = require("../../../constants/colors");
var _horizontalScrollView = require("../../structure/HorizontalScrollView");
var _horizontalScrollViewDefault = parcelHelpers.interopDefault(_horizontalScrollView);
const indicatorIcon = require("cb357526b140a1f2");
const indicatorDisabledIcon = require("5c83ee29184a7d1e");
const containerStyle = /*#__PURE__*/ (0, _css.css)("width:100%;.wrapper{overflow:hidden;border:1px solid ", (0, _colors.silver_two), ";border-radius:5px;position:relative;height:80px;flex:1;margin-top:4px;background:white;}.box-title{position:absolute;background:white;text-transform:uppercase;font-family:Muli;font-size:10px;font-weight:600;font-style:normal;font-stretch:normal;line-height:normal;letter-spacing:0.4px;color:", (0, _colors.cool_grey), ";padding:0 4px;top:-6px;left:0;right:0;margin:0 auto;width:40px;text-align:center;}.elements-wrapper{display:flex;flex-direction:row;align-items:center;height:100%;margin-top:8px;.separator{height:32px;}}.element{min-width:90px;flex:1;display:flex;flex-direction:row;align-items:center;}.ssml-element{height:60px;display:flex;flex-direction:column;align-items:center;justify-content:center;flex-grow:1;cursor:pointer;margin:6px;.selected-icon{display:none;}img{height:24px;}p{font-family:Muli;font-size:10px;font-weight:normal;font-style:normal;font-stretch:normal;line-height:normal;letter-spacing:0.4px;text-align:center;color:#304562;margin-top:4px;}&:hover{background-color:rgba(0, 125, 187, 0.1);border-radius:10px;}&.selected{background-color:rgba(0, 125, 187, 0.1);border-radius:10px;p{color:", (0, _colors.ocean_blue), ";}.element-icon{display:none;}.selected-icon{display:block;}}}.indicator-wrapper{width:20px;height:50%;position:absolute;top:0;bottom:0;margin:auto 24px;cursor:pointer;display:flex;align-items:center;justify-content:center;.indicator{width:20px;height:20px;box-shadow:0 1px 4px 0 rgba(48, 69, 98, 0.1);background-color:#ffffff;border-radius:50%;display:flex;align-items:center;justify-content:center;margin-bottom:24px;img{margin:0;}}.indicator-icon-disabled{display:none;}&.disabled{.indicator-icon-disabled{display:block;}.indicator-icon{display:none;}}&.left{left:-10px;img{transform:rotate(180deg);}}&.right{right:-10px;}}.indicator-background-wrapper{width:40px;height:50%;position:absolute;top:0;bottom:0;margin:auto 24px;display:flex;align-items:center;justify-content:center;.indicator-background{border-radius:50%;background-color:rgba(48, 69, 98, 0.1);height:40px;width:40px;margin-bottom:24px;}&.left{left:-20px;}&.right{right:-20px;}&.disabled{display:none;}}", "");
class SsmlElementCarousel extends (0, _reactDefault.default).Component {
    componentWillMount() {
        this.setState({
            canScrollLeft: false,
            canScrollRight: true
        });
    }
    handleScrollLeft() {
        this.scrollView.scrollLeft(91);
    }
    handleScrollRight() {
        this.scrollView.scrollRight(91);
    }
    handleScrollPositionChanged(scrollLeft, isAtRight) {
        if (scrollLeft == 0) this.setState({
            ...this.state,
            canScrollLeft: false,
            canScrollRight: true
        });
        else if (isAtRight) this.setState({
            ...this.state,
            canScrollLeft: true,
            canScrollRight: false
        });
        else this.setState({
            ...this.state,
            canScrollLeft: true,
            canScrollRight: true
        });
    }
    render() {
        const props = {
            ...this.props
        };
        return (0, _react.jsx)("div", {
            className: containerStyle
        }, (0, _react.jsx)("div", {
            className: `indicator-background-wrapper left ${this.state.canScrollLeft ? "" : "disabled"}`
        }, (0, _react.jsx)("div", {
            className: "indicator-background"
        })), (0, _react.jsx)("div", {
            className: `indicator-background-wrapper right ${this.state.canScrollRight ? "" : "disabled"}`
        }, (0, _react.jsx)("div", {
            className: "indicator-background"
        })), (0, _react.jsx)("div", {
            className: "wrapper"
        }, props.title ? (0, _react.jsx)("p", {
            className: "box-title"
        }, props.title) : null, (0, _react.jsx)((0, _horizontalScrollViewDefault.default), {
            hideBar: true,
            ref: (view)=>this.scrollView = view,
            onScrollChange: this.handleScrollPositionChanged.bind(this)
        }, (0, _react.jsx)("div", {
            className: "elements-wrapper"
        }, props.options.map((o, i)=>(0, _react.jsx)("div", {
                key: o.value,
                className: "element",
                onClick: ()=>props.onOptionSelected(o)
            }, i > 0 ? (0, _react.jsx)("div", {
                className: "separator"
            }) : null, (0, _react.jsx)("div", {
                className: `ssml-element ${o.value == props.selectedValue ? "selected" : ""}`
            }, (0, _react.jsx)("img", {
                className: "element-icon",
                src: o.icon
            }), (0, _react.jsx)("img", {
                className: "selected-icon",
                src: o.selectedIcon
            }), (0, _react.jsx)("p", null, o.name))))))), (0, _react.jsx)("div", {
            className: `indicator-wrapper left ${this.state.canScrollLeft ? "" : "disabled"}`
        }, (0, _react.jsx)("div", {
            className: "indicator",
            onClick: this.handleScrollLeft.bind(this)
        }, (0, _react.jsx)("img", {
            className: "indicator-icon",
            src: indicatorIcon
        }), (0, _react.jsx)("img", {
            className: "indicator-icon-disabled",
            src: indicatorDisabledIcon
        }))), (0, _react.jsx)("div", {
            className: `indicator-wrapper right ${this.state.canScrollRight ? "" : "disabled"}`
        }, (0, _react.jsx)("div", {
            className: "indicator",
            onClick: this.handleScrollRight.bind(this)
        }, (0, _react.jsx)("img", {
            className: "indicator-icon",
            src: indicatorIcon
        }), (0, _react.jsx)("img", {
            className: "indicator-icon-disabled",
            src: indicatorDisabledIcon
        }))));
    }
}
exports.default = SsmlElementCarousel;

},{"@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","../../../constants/colors":"1p3OR","../../structure/HorizontalScrollView":"5GeAv","cb357526b140a1f2":"bKWlh","5c83ee29184a7d1e":"3BSZX","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"5GeAv":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _toggleIndicator = require("../general/ToggleIndicator");
var _toggleIndicatorDefault = parcelHelpers.interopDefault(_toggleIndicator);
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const scrollviewStyle = /*#__PURE__*/ (0, _css.css)({
    name: "1q5xxjy",
    styles: "height:auto;width:100%;height:100%;margin-bottom:80px;overflow-x:scroll;overflow-y:hidden;padding-bottom:0px;flex-grow:1"
});
const containerStyle = /*#__PURE__*/ (0, _css.css)({
    name: "181j08i",
    styles: "width:100%;height:100%;height:auto;overflow:hidden;display:flex;align-items:center;.left-indicator{margin-left:4px;margin-right:auto;}.right-indicator{margin-right:4px;margin-left:auto;}"
});
class HorizontalScrollView extends (0, _reactDefault.default).Component {
    scrollLeft(pixels) {
        this.container.scrollLeft -= pixels;
        this.updateScrollChange();
    }
    scrollRight(pixels) {
        this.container.scrollLeft += pixels;
        this.updateScrollChange();
    }
    handleScroll() {
        this.updateScrollChange();
    }
    updateScrollChange() {
        if (this.props.onScrollChange) {
            const isAtRight = this.container.scrollLeft + 5 + this.container.offsetWidth >= this.container.scrollWidth;
            this.props.onScrollChange(this.container.scrollLeft, isAtRight);
        }
    }
    render() {
        return (0, _react.jsx)("div", {
            className: containerStyle
        }, this.props.showIndicators ? (0, _react.jsx)((0, _toggleIndicatorDefault.default), {
            direction: "left",
            className: "left-indicator"
        }) : null, (0, _react.jsx)("div", {
            className: scrollviewStyle,
            onScroll: this.handleScroll.bind(this),
            ref: (view)=>this.container = view,
            style: {
                paddingBottom: this.props.hideBar ? 17 : 0
            }
        }, this.props.children), this.props.showIndicators ? (0, _react.jsx)((0, _toggleIndicatorDefault.default), {
            direction: "right",
            className: "right-indicator"
        }) : null);
    }
}
exports.default = HorizontalScrollView;

},{"@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","../general/ToggleIndicator":"4eej1","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"bKWlh":[function(require,module,exports) {
module.exports = require("88a324eb0db598ad").getBundleURL("kVLro") + require("355075d7200a380b").resolve("czJYH");

},{"88a324eb0db598ad":"c7Tr5","355075d7200a380b":"fyJL2"}],"3BSZX":[function(require,module,exports) {
module.exports = require("27d29cd396d0523").getBundleURL("kVLro") + require("908cb1b306cf94ee").resolve("he7QZ");

},{"27d29cd396d0523":"c7Tr5","908cb1b306cf94ee":"fyJL2"}],"dK2qv":[function(require,module,exports) {
module.exports = require("fa3602aabcc2edc0").getBundleURL("kVLro") + require("cedd773d7847b0aa").resolve("02inY");

},{"fa3602aabcc2edc0":"c7Tr5","cedd773d7847b0aa":"fyJL2"}],"iB879":[function(require,module,exports) {
module.exports = require("2363347479b960a").getBundleURL("kVLro") + require("18549eaa452f4e7").resolve("jguu9");

},{"2363347479b960a":"c7Tr5","18549eaa452f4e7":"fyJL2"}],"ksgYJ":[function(require,module,exports) {
module.exports = require("6864d5870c5f3ddd").getBundleURL("kVLro") + require("b472f4ca849e0f7c").resolve("lREZA");

},{"6864d5870c5f3ddd":"c7Tr5","b472f4ca849e0f7c":"fyJL2"}],"c3r3V":[function(require,module,exports) {
module.exports = require("cf4b613ea4614319").getBundleURL("kVLro") + require("8cde89b3c2577874").resolve("gRer8");

},{"cf4b613ea4614319":"c7Tr5","8cde89b3c2577874":"fyJL2"}],"1OE6C":[function(require,module,exports) {
module.exports = require("d11e70d440782456").getBundleURL("kVLro") + require("761fba37e5e8324f").resolve("9VtC2");

},{"d11e70d440782456":"c7Tr5","761fba37e5e8324f":"fyJL2"}],"ae3tR":[function(require,module,exports) {
module.exports = require("2e491c65e84e9b72").getBundleURL("kVLro") + require("6e1a5caa052497b8").resolve("30mx2");

},{"2e491c65e84e9b72":"c7Tr5","6e1a5caa052497b8":"fyJL2"}],"fu1RD":[function(require,module,exports) {
module.exports = require("f3556e603d7f122b").getBundleURL("kVLro") + require("83a491ec25fedfc6").resolve("lUjsg");

},{"f3556e603d7f122b":"c7Tr5","83a491ec25fedfc6":"fyJL2"}],"9tQNK":[function(require,module,exports) {
module.exports = require("9d270a29f0e8db4d").getBundleURL("kVLro") + require("15813a7781a57dc9").resolve("04J4H");

},{"9d270a29f0e8db4d":"c7Tr5","15813a7781a57dc9":"fyJL2"}],"f3KI1":[function(require,module,exports) {
module.exports = require("fe6fae17ad5fa70").getBundleURL("kVLro") + require("675a3f1b07406608").resolve("51G5z");

},{"fe6fae17ad5fa70":"c7Tr5","675a3f1b07406608":"fyJL2"}],"k5sqa":[function(require,module,exports) {
module.exports = require("c98a47b123975fd2").getBundleURL("kVLro") + require("caba11d2a6322561").resolve("bXAZG");

},{"c98a47b123975fd2":"c7Tr5","caba11d2a6322561":"fyJL2"}],"d8OYR":[function(require,module,exports) {
module.exports = require("432984de48fc6282").getBundleURL("kVLro") + require("460c8bb275ff57d8").resolve("bUPlt");

},{"432984de48fc6282":"c7Tr5","460c8bb275ff57d8":"fyJL2"}],"jx7oV":[function(require,module,exports) {
module.exports = require("890e1e235f4dfe55").getBundleURL("kVLro") + require("6842ef01e60eb967").resolve("9Ua8U");

},{"890e1e235f4dfe55":"c7Tr5","6842ef01e60eb967":"fyJL2"}],"buHMH":[function(require,module,exports) {
module.exports = require("da98c41e84493d6b").getBundleURL("kVLro") + require("19b559a8892e2a60").resolve("atJzJ");

},{"da98c41e84493d6b":"c7Tr5","19b559a8892e2a60":"fyJL2"}],"aXauR":[function(require,module,exports) {
module.exports = require("68772a4cb7eceed9").getBundleURL("kVLro") + require("eaa7395dfb0d4836").resolve("6pu6r");

},{"68772a4cb7eceed9":"c7Tr5","eaa7395dfb0d4836":"fyJL2"}],"diiJX":[function(require,module,exports) {
module.exports = require("2c1ccf9646eea1f2").getBundleURL("kVLro") + require("7377897e9005b85a").resolve("2jBUM");

},{"2c1ccf9646eea1f2":"c7Tr5","7377897e9005b85a":"fyJL2"}],"iDzSB":[function(require,module,exports) {
module.exports = require("dfe7eaf184e14a75").getBundleURL("kVLro") + require("cc2768c22c56338").resolve("kuA9W");

},{"dfe7eaf184e14a75":"c7Tr5","cc2768c22c56338":"fyJL2"}],"eqJpH":[function(require,module,exports) {
module.exports = require("487db4d950e163a8").getBundleURL("kVLro") + require("7654ca5964ce9afa").resolve("8dnOk");

},{"487db4d950e163a8":"c7Tr5","7654ca5964ce9afa":"fyJL2"}],"eMVHn":[function(require,module,exports) {
module.exports = require("74fca0d8f74f831c").getBundleURL("kVLro") + require("c29076c0322cd68d").resolve("1HBwM");

},{"74fca0d8f74f831c":"c7Tr5","c29076c0322cd68d":"fyJL2"}],"8oZfD":[function(require,module,exports) {
module.exports = require("5d214e6c0f102be").getBundleURL("kVLro") + require("63e5edbe45f77e39").resolve("ixxEO");

},{"5d214e6c0f102be":"c7Tr5","63e5edbe45f77e39":"fyJL2"}],"7qyo0":[function(require,module,exports) {
module.exports = require("f89891c5c3e7e823").getBundleURL("kVLro") + require("ef0c672b886f7a43").resolve("dlXVD");

},{"f89891c5c3e7e823":"c7Tr5","ef0c672b886f7a43":"fyJL2"}],"7hnrM":[function(require,module,exports) {
module.exports = require("c6e003daf3ba1311").getBundleURL("kVLro") + require("f6d9f92d04e2b2b9").resolve("7HqAy");

},{"c6e003daf3ba1311":"c7Tr5","f6d9f92d04e2b2b9":"fyJL2"}],"r2QR7":[function(require,module,exports) {
module.exports = require("d4144bee4622236").getBundleURL("kVLro") + require("8a3a5c51b033db8f").resolve("kJaZK");

},{"d4144bee4622236":"c7Tr5","8a3a5c51b033db8f":"fyJL2"}],"2ZHwV":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _ssmlElementSelector = require("./SsmlElementSelector");
var _ssmlElementSelectorDefault = parcelHelpers.interopDefault(_ssmlElementSelector);
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const speedIcon = require("ed7ac382d3c6a62f");
const pitchIcon = require("b45519eb50fceeed");
const emphasisIcon = require("b3762acfeae12b6e");
const volumeIcon = require("152368592a5742a5");
const containerStyle = /*#__PURE__*/ (0, _css.css)({
    name: "5dvsdm",
    styles: "display:flex;flex-wrap:wrap;>*+*{margin-left:20px;}"
});
const ProsodyMenu = (props)=>(0, _react.jsx)("div", {
        className: containerStyle
    }, (0, _react.jsx)((0, _ssmlElementSelectorDefault.default), {
        options: [
            {
                value: "rate",
                name: "Speed",
                icon: speedIcon
            },
            {
                value: "pitch",
                name: "Pitch",
                icon: pitchIcon
            },
            {
                value: "emphasis",
                name: "Emphasis",
                icon: emphasisIcon
            },
            {
                value: "volume",
                name: "Volume",
                icon: volumeIcon
            }
        ],
        onOptionSelected: props.onElementSelected
    }));
exports.default = ProsodyMenu;

},{"@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","./SsmlElementSelector":"5JpFh","ed7ac382d3c6a62f":"lw7Cw","b45519eb50fceeed":"unvpp","b3762acfeae12b6e":"fCgcP","152368592a5742a5":"dCUB7","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"lw7Cw":[function(require,module,exports) {
module.exports = require("ea5514f6738e853a").getBundleURL("kVLro") + require("9f5dc2b271f1abc5").resolve("i2JWW");

},{"ea5514f6738e853a":"c7Tr5","9f5dc2b271f1abc5":"fyJL2"}],"unvpp":[function(require,module,exports) {
module.exports = require("a13ce851de8ac105").getBundleURL("kVLro") + require("c06370089abbb83f").resolve("3eWJk");

},{"a13ce851de8ac105":"c7Tr5","c06370089abbb83f":"fyJL2"}],"fCgcP":[function(require,module,exports) {
module.exports = require("e7687416382dec3b").getBundleURL("kVLro") + require("2d9cc74a02198e66").resolve("bvhFf");

},{"e7687416382dec3b":"c7Tr5","2d9cc74a02198e66":"fyJL2"}],"dCUB7":[function(require,module,exports) {
module.exports = require("f7a6d9c4ff1d0cb").getBundleURL("kVLro") + require("314a375f221be246").resolve("lLtnO");

},{"f7a6d9c4ff1d0cb":"c7Tr5","314a375f221be246":"fyJL2"}],"fRzhr":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _defineProperty = require("@babel/runtime/helpers/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _levelSelector = require("./LevelSelector");
var _levelSelectorDefault = parcelHelpers.interopDefault(_levelSelector);
var _ssmlParseService = require("../../../services/ssmlParseService");
var _ssmlParseServiceDefault = parcelHelpers.interopDefault(_ssmlParseService);
class BreakSelector extends (0, _reactDefault.default).Component {
    constructor(...args){
        super(...args);
        (0, _definePropertyDefault.default)(this, "ssmlParser", new (0, _ssmlParseServiceDefault.default)());
        (0, _definePropertyDefault.default)(this, "options", [
            {
                name: "Very Short",
                value: 0.25
            },
            {
                name: "Short",
                value: 0.5
            },
            {
                name: "Normal",
                value: 1.0
            },
            {
                name: "Long",
                value: 1.5
            },
            {
                name: "Very Long",
                value: 2.0
            }
        ]);
    }
    componentWillMount() {
        this.setInitialState();
        // send out the default ssml when it is first added
        var ssml = this.props.ssml ? this.props.ssml : '<break time=".5s"/>';
        this.props.onChange(ssml);
    }
    setInitialState() {
        if (this.props.ssml) {
            // parse the break tag to set state
            const time = this.ssmlParser.getElementProperty(this.props.ssml, "break", "time");
            if (time) {
                this.setState({
                    ...this.state,
                    isCustomSelected: !this.options.some((o)=>o.value == time.replace("s", "")),
                    value: time.replace("s", "")
                });
                return;
            }
        }
        this.setState({
            ...this.state,
            value: 0.5,
            isCustomSelected: false
        });
    }
    buildSsml(value) {
        value = value ? value : this.state.value;
        const ssml = `<break time="${value}s"/>`;
        this.props.onChange(ssml);
    }
    handleCustomSelected() {
        this.setState({
            ...this.state,
            isCustomSelected: true
        });
        this.buildSsml();
    }
    handleOptionSelected(option) {
        this.setState({
            ...this.state,
            isCustomSelected: false,
            value: option.value
        });
        this.buildSsml(option.value);
    }
    handleCustomChanged(value) {
        this.setState({
            ...this.state,
            isCustomSelected: true,
            value: value
        });
        this.buildSsml(value);
    }
    render() {
        return (0, _react.jsx)("div", null, (0, _react.jsx)((0, _levelSelectorDefault.default), {
            options: this.options,
            onCustomSelected: this.handleCustomSelected.bind(this),
            onOptionSelected: this.handleOptionSelected.bind(this),
            onCustomValueChanged: this.handleCustomChanged.bind(this),
            value: this.state.value,
            unit: "sec",
            isCustom: this.state.isCustomSelected
        }));
    }
}
exports.default = BreakSelector;

},{"@babel/runtime/helpers/defineProperty":"9sJxO","@emotion/react":"djZKr","react":"6uln9","./LevelSelector":"gXIYq","../../../services/ssmlParseService":"7FRoV","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"gXIYq":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _colors = require("../../../constants/colors");
const containerStyle = /*#__PURE__*/ (0, _css.css)("border:1px solid ", (0, _colors.silver_two), ";border-radius:5px;position:relative;height:80px;flex:1;margin-top:4px;display:flex;flex-direction:row;align-items:center;padding:0 24px;.selector-wrapper{position:relative;flex:1;.items-wrapper{display:flex;}}.custom-wrapper{display:flex;flex-direction:row;align-items:center;}.radio-option{margin:8px 0;display:flex;flex-direction:column;align-items:center;cursor:pointer;flex:1;&.custom{flex:0;}.check-wrapper{display:flex;align-items:center;justify-content:center;width:100%;}.left-line,.right-line{height:1px;background:transparent;flex-grow:1;width:auto;}&.with-left-line{.left-line{background:", (0, _colors.silver_two), ";}}&.with-right-line{.right-line{background:", (0, _colors.silver_two), ";}}.check-container{position:relative;min-width:17px;height:17px;border-radius:50%;background-color:#ffffff;border:solid 1px #cccccc;display:flex;align-items:center;justify-content:center;padding:0;}.selected-option{width:10px;height:10px;border-radius:50%;background-image:linear-gradient(225deg, #76c3b5, #3ea6ac 72%, #5296b3);}span{font-family:Muli;font-size:10px;font-weight:normal;font-style:normal;font-stretch:normal;line-height:normal;letter-spacing:0.4px;text-align:center;color:#304562;margin-top:8px;}}.dash-separator{height:50%;width:1px;border-left:1px dashed ", (0, _colors.silver_two), ";margin:0 12px;}.unit-label{font-family:Muli;font-size:14px;font-weight:normal;font-style:normal;font-stretch:normal;line-height:normal;letter-spacing:normal;color:", (0, _colors.cool_grey), ";}.unit-detail-label{color:", (0, _colors.cool_grey), ";font-size:9px;}.text-field-wrapper{width:50px;height:40px;margin:0 12px;input{width:50px;height:40px;border-radius:5px;box-shadow:inset 0 1px 1px 0 rgba(44, 61, 82, 0.3);background-color:#ffffff;border:1px solid ", (0, _colors.silver_two), ";text-align:center;font-family:Muli;font-size:14px;font-weight:normal;font-style:normal;font-stretch:normal;line-height:normal;letter-spacing:normal;text-align:center;color:#304562;}input[type=number]::-webkit-inner-spin-button,input[type=number]::-webkit-outer-spin-button{-webkit-appearance:none;margin:0;}}", "");
const LevelSelector = (props)=>(0, _react.jsx)("div", {
        className: containerStyle
    }, (0, _react.jsx)("div", {
        className: "selector-wrapper"
    }, (0, _react.jsx)("div", {
        className: "items-wrapper"
    }, props.options.map((option, index)=>(0, _react.jsx)("div", {
            className: `${index > 0 ? "with-left-line" : ""} ${index < props.options.length - 1 ? "with-right-line" : ""} radio-option`,
            key: index,
            onClick: ()=>props.onOptionSelected(option)
        }, (0, _react.jsx)("div", {
            className: "check-wrapper"
        }, (0, _react.jsx)("div", {
            className: "left-line"
        }), (0, _react.jsx)("div", {
            className: "check-container"
        }, option.value == props.value && !props.isCustom ? (0, _react.jsx)("div", {
            className: "selected-option"
        }) : null), (0, _react.jsx)("div", {
            className: "right-line"
        })), (0, _react.jsx)("span", null, option.name))))), props.disableCustom ? null : (0, _react.jsx)("div", {
        className: "custom-wrapper"
    }, (0, _react.jsx)("div", {
        className: "dash-separator"
    }), (0, _react.jsx)("div", {
        className: "radio-option custom",
        onClick: ()=>props.onCustomSelected()
    }, (0, _react.jsx)("div", {
        className: "check-wrapper"
    }, (0, _react.jsx)("div", {
        className: "check-container"
    }, props.isCustom ? (0, _react.jsx)("div", {
        className: "selected-option"
    }) : null)), (0, _react.jsx)("span", null, "Custom")), (0, _react.jsx)("div", {
        className: "text-field-wrapper"
    }, (0, _react.jsx)("input", {
        type: "number",
        name: "value",
        disabled: !props.isCustom,
        value: props.value.toString(),
        onChange: (e)=>props.onCustomValueChanged(+e.target.value),
        onBlur: ()=>{}
    })), (0, _react.jsx)("div", null, (0, _react.jsx)("p", {
        className: "unit-label"
    }, props.unit), (0, _react.jsx)("p", {
        className: "unit-detail-label"
    }, props.unitDetail))));
exports.default = LevelSelector;

},{"@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","../../../constants/colors":"1p3OR","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7FRoV":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _defineProperty = require("@babel/runtime/helpers/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
class SsmlParseService {
    constructor(){
        (0, _definePropertyDefault.default)(this, "parser", new DOMParser());
    }
    getElementProperty(ssml, tag, property) {
        try {
            let xmlDoc = this.parser.parseFromString(ssml, "text/xml");
            return xmlDoc.getElementsByTagName(tag)[0].attributes[property].value;
        } catch  {
            return null;
        }
    }
    ssmlToObject(ssml, supportedTags) {
        if (!ssml || !ssml.startsWith("<speak>")) ssml = `<speak>${(ssml || "").trim()}</speak>`;
        let xmlDoc = this.parser.parseFromString(ssml, "application/xml");
        var json = this.xmlToJson(xmlDoc.documentElement, supportedTags, true);
        return json;
    }
    htmlToObject(html) {
        try {
            let xmlDoc = this.parser.parseFromString(html, "text/html");
            var htmlObject = this.xmlToJson(xmlDoc.documentElement, null);
            var ssmlObject = this.convertHtmlObjectToSsmlObject(htmlObject);
            return ssmlObject;
        } catch (e) {
            console.log(e);
        }
    }
    findFirstOfType(tree, elementName) {
        if (tree.name.toLowerCase() == elementName.toLowerCase()) return tree;
        if (tree.children) {
            var found = null;
            for(var i = 0; i < tree.children.length; i++){
                found = this.findFirstOfType(tree.children[i], elementName);
                if (found) return found;
            }
        }
        return null;
    }
    getIsInvalidProsody(xml) {
        if (xml.nodeName.toLowerCase() == "prosody") return xml.attributes.length > 1; // we can't support multi-attributed prosody
        return false;
    }
    getIsInvalidSayAs(xml) {
        if (xml.nodeName.toLowerCase() == "say-as") {
            const validInterpretAs = [
                "characters",
                "spell-out",
                "cardinal",
                "number",
                "ordinal",
                "digits",
                "fraction",
                "unit",
                "date",
                "time",
                "telephone",
                "expletive",
                "bleep"
            ];
            return !validInterpretAs.some((v)=>v == xml.attributes.item("interpret-as").nodeValue);
        }
        return false;
    }
    xmlToJson(xml, supportedTags, separateUnsupported) {
        var obj = {
            children: [],
            attributes: [],
            id: this.uuidv4()
        };
        if (xml.nodeType == 1) {
            // element
            // do attributes
            if (!supportedTags || supportedTags.some((t)=>t == xml.nodeName) && !this.getIsInvalidSayAs(xml) && !this.getIsInvalidProsody(xml)) {
                obj.name = xml.nodeName;
                if (xml.attributes.length > 0) for(var j = 0; j < xml.attributes.length; j++){
                    var attribute = xml.attributes.item(j);
                    obj.attributes.push({
                        name: attribute.nodeName,
                        value: attribute.nodeValue
                    });
                }
            } else {
                obj.name = "plain-text";
                obj.isUnsupportedElement = true;
                obj.value = this.elementToString(xml, true);
            }
        } else if (xml.nodeType == 3) {
            // text
            obj.name = "plain-text";
            obj.value = xml.nodeValue;
        }
        // do children
        if (xml.hasChildNodes()) for(var i = 0; i < xml.childNodes.length; i++){
            var item = xml.childNodes.item(i);
            obj.children.push(this.xmlToJson(item, supportedTags));
        }
        return obj;
    }
    getElementPropertyValue(ssml, tag, property) {
        try {
            let xmlDoc = this.parser.parseFromString(ssml, "text/xml");
            return xmlDoc.getElementsByTagName(tag)[0].attributes[property].value;
        } catch  {
            return null;
        }
    }
    convertToStringWithSelection(ssmlObject, current, builtSsml, selectedStartId, selectedStartOffset, selectedEndId, selectedEndOffset) {
        if (current == null) current = {
            ssml: ""
        };
        var output = "";
        const rule = this.getDisplayedRule(ssmlObject);
        if (ssmlObject.name == "plain-text") {
            output = ssmlObject.value;
            if (ssmlObject.id == selectedStartId || !selectedStartId) current.startIndex = builtSsml.replace("<speak>", "").length + selectedStartOffset;
            if (ssmlObject.id == selectedEndId || !selectedEndId) current.endIndex = builtSsml.replace("<speak>", "").length + selectedEndOffset;
        } else if (ssmlObject.children.length > 0 || rule && rule.hasChildren) {
            output += `<${ssmlObject.name}${ssmlObject.attributes.length > 0 ? " " + ssmlObject.attributes.map((a)=>a.name + "=" + '"' + a.value + '"').join(" ") : ""}>`;
            ssmlObject.children.forEach((c)=>{
                output += this.convertToStringWithSelection(c, current, builtSsml + output, selectedStartId, selectedStartOffset, selectedEndId, selectedEndOffset).ssml;
            });
            output += `</${ssmlObject.name}>`;
        } else if (ssmlObject.children.length == 0) output += `<${ssmlObject.name}${ssmlObject.attributes.length > 0 ? " " + ssmlObject.attributes.map((a)=>a.name + "=" + '"' + a.value + '"').join(" ") : ""}/>`;
        output = output.replace("<speak>", "").replace("</speak>", "").replace("<speak/>", "").replace("&nbsp;", " ");
        current.ssml = output;
        return current;
    }
    convertToString(ssmlObject) {
        var output = "";
        const rule = this.getDisplayedRule(ssmlObject);
        if (ssmlObject.name == "plain-text") output = ssmlObject.value;
        else if (ssmlObject.children.length > 0 || rule && rule.hasChildren) {
            output += `<${ssmlObject.name}${ssmlObject.attributes.length > 0 ? " " + ssmlObject.attributes.map((a)=>a.name + "=" + '"' + a.value + '"').join(" ") : ""}>`;
            ssmlObject.children.forEach((c)=>{
                output += this.convertToString(c);
            });
            output += `</${ssmlObject.name}>`;
        } else if (ssmlObject.children.length == 0) output += `<${ssmlObject.name}${ssmlObject.attributes.length > 0 ? " " + ssmlObject.attributes.map((a)=>a.name + "=" + '"' + a.value + '"').join(" ") : ""}/>`;
        output = output.replace("<speak>", "").replace("</speak>", "").replace("<speak/>", "").replace("&nbsp;", " ");
        return output;
    }
    convertHtmlObjectToSsmlObject(htmlObject) {
        var htmlRoot = this.findFirstOfType(htmlObject, "body");
        if (!htmlRoot) return null;
        var root = {
            id: "",
            name: "speak",
            children: [],
            attributes: []
        };
        // start converting
        htmlRoot.children.forEach((h)=>{
            var converted = this.mapSpanToSsml(h, root);
            if (converted) root.children.push(converted);
        });
        return root;
    }
    rotateMutableIds(tree) {
        tree.id = this.uuidv4();
        if (tree.children.length > 0) tree.children.forEach((n)=>this.rotateMutableIds(n));
        return tree;
    }
    mapSpanToSsml(htmlObject, parentObject) {
        if (!htmlObject || htmlObject.attributes.some((a)=>a.name == "data-ignore")) return null;
        // just straight plain text
        if (htmlObject.name == "plain-text") {
            var plainTextObject = htmlObject;
            plainTextObject.id = this.uuidv4();
            return plainTextObject;
        }
        // contains plain text
        if (htmlObject.name.toLowerCase() == "span" && !htmlObject.attributes.some((a)=>a.name == "data-ssml-element") && htmlObject.children.some((c)=>c.name == "plain-text" || c.name.toLowerCase() == "br")) {
            const plainTextObject = htmlObject.children.find((c)=>c.name == "plain-text");
            if (plainTextObject) {
                var idAttribute = htmlObject.attributes.find((a)=>a.name == "id");
                plainTextObject.id = idAttribute ? idAttribute.value : this.uuidv4();
                if (!htmlObject.attributes.some((a)=>a.name == "id")) plainTextObject.value = plainTextObject.value;
                return plainTextObject;
            }
            const breakObject = htmlObject.children.find((c)=>c.name.toLowerCase() == "br");
            if (breakObject) return {
                id: this.uuidv4(),
                attributes: [],
                value: "\n",
                children: [],
                name: "plain-text"
            };
        } else if (htmlObject.name.toLowerCase() == "br") return {
            id: this.uuidv4(),
            attributes: [],
            value: "\n",
            children: [],
            name: "plain-text"
        };
        else if (htmlObject.name.toLowerCase() == "span" && htmlObject.attributes.some((a)=>a.name == "data-ssml-element")) {
            const ssmlObject = {
                children: [],
                attributes: [],
                id: this.uuidv4()
            };
            ssmlObject.name = htmlObject.attributes.find((a)=>a.name == "data-ssml-element").value;
            ssmlObject.id = htmlObject.attributes.find((a)=>a.name == "id").value;
            if (htmlObject.attributes && htmlObject.attributes.some((a)=>a.name == "data-ssml-attributes")) ssmlObject.attributes = JSON.parse(htmlObject.attributes.find((a)=>a.name == "data-ssml-attributes").value.replace(/&quot;/g, '"'));
            htmlObject.children.forEach((h)=>{
                var converted = this.mapSpanToSsml(h, ssmlObject);
                if (converted) ssmlObject.children.push(converted);
            });
            return ssmlObject;
        } else if (htmlObject.name.toLowerCase() == "div" && !htmlObject.attributes || !htmlObject.attributes.some((a)=>a.name == "data-ignore")) {
            // new empty lines are <div><span><br></span></div> so lets skip the div and go right to the span
            // new lines with content are <div><span>text</span></div>
            htmlObject.children.forEach((h)=>{
                var converted = this.mapSpanToSsml(h, parentObject);
                if (converted) parentObject.children.push(converted);
            });
            return null;
        }
        return null;
    }
    uuidv4() {
        return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function(c) {
            var r = Math.random() * 16 | 0, v = c == "x" ? r : r & 0x3 | 0x8;
            return v.toString(16);
        });
    }
    stripTags(input) {
        const sourceArray = [
            ...input
        ];
        let output = "";
        let inside = false;
        for(let i = 0; i < sourceArray.length; ++i){
            let c = sourceArray[i];
            if (c === "<") {
                inside = true;
                continue;
            }
            if (c == ">") {
                inside = false;
                continue;
            }
            if (!inside) output += c;
        }
        return output;
    }
    elementToString(who, deep) {
        if (!who || !who.tagName) return "";
        var txt, ax, el = document.createElement("div");
        el.appendChild(who.cloneNode(false));
        txt = el.innerHTML;
        if (deep) {
            ax = txt.indexOf(">") + 1;
            txt = txt.substring(0, ax) + who.innerHTML + txt.substring(ax);
        }
        el = null;
        return txt;
    }
    findDelete(ssmlObject, parent, liftChildren) {
        if (ssmlObject.id == ssmlObject.id) {
            if (liftChildren && ssmlObject.children && ssmlObject.children.length > 0) // replace position of children too
            parent.children.splice(parent.children.indexOf(ssmlObject), 1, ...ssmlObject.children);
            else parent.children.splice(parent.children.indexOf(ssmlObject), 1);
            return ssmlObject;
        } else if (ssmlObject.children != null) {
            var i;
            var result = null;
            for(i = 0; result == null && i < ssmlObject.children.length; i++)result = this.findDelete(ssmlObject.children[i], ssmlObject, liftChildren);
            return result;
        }
    }
    getDisplayedSsmlRules() {
        // gets some general rules for different ssml elements
        return [
            {
                name: "prosody",
                attribute: "rate",
                unit: "%",
                max: 200,
                min: 20,
                hasChildren: true
            },
            {
                name: "prosody",
                attribute: "volume",
                unit: "dB",
                max: 4,
                min: -4,
                hasChildren: true
            },
            {
                name: "prosody",
                attribute: "pitch",
                unit: "%",
                max: 50,
                min: -33,
                hasChildren: true
            },
            {
                name: "break",
                attribute: "time",
                unit: "s",
                max: 2,
                min: 0.25,
                hasChildren: false
            },
            {
                name: "emphasis",
                attribute: "level",
                unit: "",
                max: 3,
                // mapped to string 'strong'
                min: 1,
                // mapped to string 'reduced'
                hasChildren: true
            },
            {
                name: "audio",
                attribute: "src",
                unit: "",
                hasChildren: true
            },
            {
                name: "say-as",
                attribute: "interpret-as",
                unit: "",
                hasChildren: true
            }
        ];
    }
    getDisplayedRule(ssmlObject) {
        return this.getDisplayedSsmlRules().find((r)=>r.name == ssmlObject.name && ssmlObject.attributes.length > 0 && r.attribute == ssmlObject.attributes[0].name);
    }
    getRawAttributeValue(ssmlObject) {
        var value = null;
        var rule = this.getDisplayedRule(ssmlObject);
        if (ssmlObject.name == "prosody" || ssmlObject.name == "break") value = Number.parseFloat(ssmlObject.attributes[0].value);
        else if (ssmlObject.name == "emphasis") switch(ssmlObject.attributes[0]?.value){
            case "strong":
                value = 3;
                break;
            case "moderate":
                value = 2;
                break;
            default:
                value = 1;
        }
        if (rule) {
            if (value < rule.min || value > rule.max) value = null;
        }
        return value;
    }
}
exports.default = SsmlParseService;

},{"@babel/runtime/helpers/defineProperty":"9sJxO","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"eA0OP":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _defineProperty = require("@babel/runtime/helpers/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _ssmlParseService = require("../../../services/ssmlParseService");
var _ssmlParseServiceDefault = parcelHelpers.interopDefault(_ssmlParseService);
var _audioUploader = require("./AudioUploader");
var _audioUploaderDefault = parcelHelpers.interopDefault(_audioUploader);
var _unstated = require("unstated");
var _mediaContainer = require("../../../state/containers/MediaContainer");
var _mediaContainerDefault = parcelHelpers.interopDefault(_mediaContainer);
var _horizontalSeparator = require("../../structure/HorizontalSeparator");
var _horizontalSeparatorDefault = parcelHelpers.interopDefault(_horizontalSeparator);
var _textField = require("../TextField");
var _textFieldDefault = parcelHelpers.interopDefault(_textField);
var _colors = require("../../../constants/colors");
const linkIcon = require("1cbaf13107757c74");
const containerStyle = /*#__PURE__*/ (0, _css.css)(".field-container{height:40px;}label{color:#304562;font-size:10px;font-weight:normal;font-style:normal;font-stretch:normal;line-height:normal;letter-spacing:0.4px;}p{font-size:12px;font-weight:normal;font-style:normal;font-stretch:normal;line-height:normal;letter-spacing:0.5px;color:", (0, _colors.cool_grey), ";}", "");
class AudioSelector extends (0, _reactDefault.default).Component {
    constructor(...args){
        super(...args);
        (0, _definePropertyDefault.default)(this, "ssmlParser", new (0, _ssmlParseServiceDefault.default)());
        (0, _definePropertyDefault.default)(this, "placeholder", "Text here is used for display");
    }
    componentWillMount() {
        this.setInitialState();
    }
    setInitialState() {
        if (this.props.ssml) {
            // parse the break tag to set state
            const src = this.ssmlParser.getElementProperty(this.props.ssml, "audio", "src");
            if (src) {
                this.setState({
                    ...this.state,
                    value: src
                });
                return;
            }
        }
        this.setState({
            ...this.state,
            value: ""
        });
    }
    handleUploadFinish(mediaItem) {
        this.setState({
            ...this.state,
            value: mediaItem.url
        });
        this.buildSsml(mediaItem.url);
    }
    handleUrlChange(e) {
        const value = e.target.value;
        this.setState({
            ...this.state,
            value: value
        });
        this.buildSsml(value);
    }
    buildSsml(value) {
        value = value ? value : this.state.value;
        const ssml = `<audio src="${value}">${this.placeholder}</audio>`;
        this.props.onChange(ssml, this.placeholder);
    }
    render() {
        return (0, _react.jsx)("div", {
            className: containerStyle
        }, (0, _react.jsx)("p", null, "Upload a new file or copy an existing URL below"), (0, _react.jsx)((0, _unstated.Subscribe), {
            to: [
                (0, _mediaContainerDefault.default)
            ]
        }, (mediaContainer)=>{
            return (0, _react.jsx)((0, _audioUploaderDefault.default), {
                onFinish: this.handleUploadFinish.bind(this),
                applicationId: this.props.applicationId,
                stateContainer: mediaContainer
            });
        }), (0, _react.jsx)((0, _horizontalSeparatorDefault.default), null), (0, _react.jsx)((0, _textFieldDefault.default), {
            icon: linkIcon,
            name: "src",
            value: this.state.value,
            label: "URL",
            placeholder: "The url of the .mp3 file",
            onChange: this.handleUrlChange.bind(this),
            onBlur: ()=>{}
        }));
    }
}
exports.default = AudioSelector;

},{"@babel/runtime/helpers/defineProperty":"9sJxO","@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","../../../services/ssmlParseService":"7FRoV","./AudioUploader":"fZPbf","unstated":"grh7p","../../../state/containers/MediaContainer":"ch6Xu","../../structure/HorizontalSeparator":"Pw3HQ","../TextField":"7a7bh","../../../constants/colors":"1p3OR","1cbaf13107757c74":"d1Oin","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"fZPbf":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _reactDropzone = require("react-dropzone");
var _reactDropzoneDefault = parcelHelpers.interopDefault(_reactDropzone);
var _button = require("../../general/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _progressBar = require("../../general/ProgressBar");
var _progressBarDefault = parcelHelpers.interopDefault(_progressBar);
var _pageError = require("../../general/PageError");
var _pageErrorDefault = parcelHelpers.interopDefault(_pageError);
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const dropzoneStyle = {
    height: "auto",
    width: `auto`,
    borderRadius: 20,
    border: "none",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    cursor: "pointer"
};
const containerStyle = /*#__PURE__*/ (0, _css.css)({
    name: "s5xdrg",
    styles: "display:flex;align-items:center"
});
const loaderWrapperStyle = /*#__PURE__*/ (0, _css.css)({
    name: "82a6rk",
    styles: "flex:1"
});
class AudioUploader extends (0, _reactDefault.default).Component {
    componentWillMount() {
        this.setState({
            progress: 0
        });
    }
    handleProgressUpdate(progress) {
        this.setState({
            ...this.state,
            progress: progress
        });
    }
    handleFilePicked(files) {
        files;
        if (files.length > 0) this.handleUpload(files[0]);
    }
    handleUpload(file) {
        var promise = this.props.stateContainer.uploadSsmlItem(this.props.applicationId, file.name, file, null, this.handleProgressUpdate.bind(this));
        promise.then((result)=>{
            this.handleProgressUpdate(0);
            if (result.resultType == "Ok") {
                "File uploaded";
                result.data;
                this.props.onFinish(result.data);
            }
        }).catch((error)=>{
            this.handleProgressUpdate(0);
        });
    }
    render() {
        return (0, _react.jsx)("div", {
            className: containerStyle
        }, (0, _react.jsx)((0, _reactDropzoneDefault.default), {
            ref: (node)=>{
                this.dropZone = node;
            },
            onDrop: this.handleFilePicked.bind(this),
            style: dropzoneStyle,
            accept: "audio/*",
            multiple: false
        }, (0, _react.jsx)((0, _buttonDefault.default), {
            themes: [
                "white",
                "white-small",
                "start-tight"
            ],
            text: "Select & Upload",
            type: "button"
        })), (0, _react.jsx)("div", {
            className: loaderWrapperStyle
        }, (0, _react.jsx)((0, _progressBarDefault.default), {
            percent: this.state.progress
        })), (0, _react.jsx)((0, _pageErrorDefault.default), {
            errors: this.props.stateContainer.state.errors
        }));
    }
}
exports.default = AudioUploader;

},{"@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","react-dropzone":"46RRi","../../general/Button":"6ymxN","../../general/ProgressBar":"6G42X","../../general/PageError":"ezFTm","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6G42X":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _colors = require("../../constants/colors");
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const outerStyle = /*#__PURE__*/ (0, _css.css)({
    name: "15o2h8k",
    styles: "height:24px;width:100%;border-radius:12px;background:#eeeeee"
});
const innerStyle = /*#__PURE__*/ (0, _css.css)("height:24px;border-radius:12px;background:", (0, _colors.primary_gradient), ";", "");
const wrapperStyle = /*#__PURE__*/ (0, _css.css)({
    name: "1d3w5wq",
    styles: "width:100%"
});
const ProgressBar = (props)=>(0, _react.jsx)("div", {
        className: wrapperStyle
    }, props.percent === 0 ? null : (0, _react.jsx)("div", {
        className: outerStyle
    }, (0, _react.jsx)("div", {
        className: innerStyle,
        style: {
            width: `${props.percent}%`
        }
    })));
exports.default = ProgressBar;

},{"@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","../../constants/colors":"1p3OR","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"d1Oin":[function(require,module,exports) {
module.exports = require("71d72d67bf017b4d").getBundleURL("kVLro") + require("f055a513cf73c297").resolve("9OE0Q");

},{"71d72d67bf017b4d":"c7Tr5","f055a513cf73c297":"fyJL2"}],"ghH8g":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _defineProperty = require("@babel/runtime/helpers/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _levelSelector = require("./LevelSelector");
var _levelSelectorDefault = parcelHelpers.interopDefault(_levelSelector);
var _ssmlParseService = require("../../../services/ssmlParseService");
var _ssmlParseServiceDefault = parcelHelpers.interopDefault(_ssmlParseService);
class SpeedSelector extends (0, _reactDefault.default).Component {
    constructor(...args){
        super(...args);
        (0, _definePropertyDefault.default)(this, "ssmlParser", new (0, _ssmlParseServiceDefault.default)());
        (0, _definePropertyDefault.default)(this, "placeholder", "Speed changed text");
        (0, _definePropertyDefault.default)(this, "options", [
            {
                name: "Very Slow",
                value: 20
            },
            {
                name: "Slow",
                value: 50
            },
            {
                name: "Medium",
                value: 100
            },
            {
                name: "Fast",
                value: 150
            },
            {
                name: "Very Fast",
                value: 200
            }
        ]);
    }
    componentWillMount() {
        this.setInitialState();
        // send out the default ssml when it is first added
        var ssml = this.props.ssml ? this.props.ssml : `<prosody rate="50%">${this.placeholder}</prosody>`;
        this.props.onChange(ssml, this.placeholder);
    }
    setInitialState() {
        if (this.props.ssml) {
            // parse the break tag to set state
            const rate = this.ssmlParser.getElementProperty(this.props.ssml, "prosody", "rate");
            if (rate) {
                this.setState({
                    ...this.state,
                    isCustomSelected: !this.options.some((o)=>o.value + "%" == rate),
                    value: rate.replace("%", "")
                });
                return;
            }
        }
        this.setState({
            ...this.state,
            value: 50,
            isCustomSelected: false
        });
    }
    buildSsml(value) {
        value = value ? value : this.state.value;
        const ssml = `<prosody rate="${value}%">${this.placeholder}</prosody>`;
        this.props.onChange(ssml, this.placeholder);
    }
    handleCustomSelected() {
        this.setState({
            ...this.state,
            isCustomSelected: true
        });
        this.buildSsml();
    }
    handleOptionSelected(option) {
        this.setState({
            ...this.state,
            isCustomSelected: false,
            value: option.value
        });
        this.buildSsml(option.value);
    }
    handleCustomChanged(value) {
        this.setState({
            ...this.state,
            isCustomSelected: true,
            value: value
        });
        this.buildSsml(value);
    }
    render() {
        return (0, _react.jsx)("div", null, (0, _react.jsx)((0, _levelSelectorDefault.default), {
            options: this.options,
            onCustomSelected: this.handleCustomSelected.bind(this),
            onOptionSelected: this.handleOptionSelected.bind(this),
            onCustomValueChanged: this.handleCustomChanged.bind(this),
            value: this.state.value,
            unit: "%",
            unitDetail: "Min. 20",
            isCustom: this.state.isCustomSelected
        }));
    }
}
exports.default = SpeedSelector;

},{"@babel/runtime/helpers/defineProperty":"9sJxO","@emotion/react":"djZKr","react":"6uln9","./LevelSelector":"gXIYq","../../../services/ssmlParseService":"7FRoV","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hOldI":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _defineProperty = require("@babel/runtime/helpers/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _levelSelector = require("./LevelSelector");
var _levelSelectorDefault = parcelHelpers.interopDefault(_levelSelector);
var _ssmlParseService = require("../../../services/ssmlParseService");
var _ssmlParseServiceDefault = parcelHelpers.interopDefault(_ssmlParseService);
class PitchSelector extends (0, _reactDefault.default).Component {
    constructor(...args){
        super(...args);
        (0, _definePropertyDefault.default)(this, "ssmlParser", new (0, _ssmlParseServiceDefault.default)());
        (0, _definePropertyDefault.default)(this, "placeholder", "Pitch changed text");
        (0, _definePropertyDefault.default)(this, "options", [
            {
                name: "Very Low",
                value: -33
            },
            {
                name: "Low",
                value: -10
            },
            {
                name: "Medium",
                value: 0
            },
            {
                name: "High",
                value: 25
            },
            {
                name: "Very High",
                value: 50
            }
        ]);
    }
    componentWillMount() {
        this.setInitialState();
        // send out the default ssml when it is first added
        var ssml = this.props.ssml ? this.props.ssml : `<prosody pitch="+25%">${this.placeholder}</prosody>`;
        this.props.onChange(ssml, this.placeholder);
    }
    setInitialState() {
        if (this.props.ssml) {
            // parse the break tag to set state
            const pitch = this.ssmlParser.getElementProperty(this.props.ssml, "prosody", "pitch");
            if (pitch) {
                this.setState({
                    ...this.state,
                    isCustomSelected: !this.options.some((o)=>o.value + "%" == pitch.replace("+", "")),
                    value: pitch.replace("%", "").replace("+", "")
                });
                return;
            }
        }
        this.setState({
            ...this.state,
            value: 25,
            isCustomSelected: false
        });
    }
    buildSsml(value) {
        value = value ? value : this.state.value;
        var valueLabel = "" + value;
        // need explicit "+"
        if (value > 0) valueLabel = "+" + valueLabel;
        const ssml = `<prosody pitch="${valueLabel}%">${this.placeholder}</prosody>`;
        this.props.onChange(ssml, this.placeholder);
    }
    handleCustomSelected() {
        this.setState({
            ...this.state,
            isCustomSelected: true
        });
        this.buildSsml();
    }
    handleOptionSelected(option) {
        this.setState({
            ...this.state,
            isCustomSelected: false,
            value: option.value
        });
        this.buildSsml(option.value);
    }
    handleCustomChanged(value) {
        this.setState({
            ...this.state,
            isCustomSelected: true,
            value: value
        });
        this.buildSsml(value);
    }
    render() {
        return (0, _react.jsx)("div", null, (0, _react.jsx)((0, _levelSelectorDefault.default), {
            options: this.options,
            onCustomSelected: this.handleCustomSelected.bind(this),
            onOptionSelected: this.handleOptionSelected.bind(this),
            onCustomValueChanged: this.handleCustomChanged.bind(this),
            value: this.state.value,
            unit: "%",
            isCustom: this.state.isCustomSelected
        }));
    }
}
exports.default = PitchSelector;

},{"@babel/runtime/helpers/defineProperty":"9sJxO","@emotion/react":"djZKr","react":"6uln9","./LevelSelector":"gXIYq","../../../services/ssmlParseService":"7FRoV","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6kO9g":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _defineProperty = require("@babel/runtime/helpers/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _levelSelector = require("./LevelSelector");
var _levelSelectorDefault = parcelHelpers.interopDefault(_levelSelector);
var _ssmlParseService = require("../../../services/ssmlParseService");
var _ssmlParseServiceDefault = parcelHelpers.interopDefault(_ssmlParseService);
class EmphasisSelector extends (0, _reactDefault.default).Component {
    constructor(...args){
        super(...args);
        (0, _definePropertyDefault.default)(this, "ssmlParser", new (0, _ssmlParseServiceDefault.default)());
        (0, _definePropertyDefault.default)(this, "placeholder", "Emphasis changed text");
        (0, _definePropertyDefault.default)(this, "options", [
            {
                name: "Reduced",
                value: 1
            },
            {
                name: "Moderate",
                value: 2
            },
            {
                name: "Strong",
                value: 3
            }
        ]);
    }
    componentWillMount() {
        this.setInitialState();
        // send out the default ssml when it is first added
        var ssml = this.props.ssml ? this.props.ssml : `<emphasis level="reduced">${this.placeholder}</emphasis>`;
        this.props.onChange(ssml, this.placeholder);
    }
    setInitialState() {
        if (this.props.ssml) {
            // parse the break tag to set state
            const level = this.ssmlParser.getElementProperty(this.props.ssml, "emphasis", "level");
            if (level) {
                const matchLevel = this.options.find((o)=>o.name.toLowerCase() == level);
                this.setState({
                    ...this.state,
                    isCustomSelected: !matchLevel,
                    value: matchLevel ? matchLevel.value : null
                });
                return;
            }
        }
        this.setState({
            ...this.state,
            value: 1,
            isCustomSelected: false
        });
    }
    getLevelFromNumber(value) {
        switch(value){
            case 1:
                return "reduced";
            case 2:
                return "moderate";
            case 3:
            default:
                return "strong";
        }
    }
    buildSsml(value) {
        value = value ? value : this.state.value;
        var valueLabel = this.getLevelFromNumber(value);
        const ssml = `<emphasis level="${valueLabel}">${this.placeholder}</emphasis>`;
        this.props.onChange(ssml, this.placeholder);
    }
    handleCustomSelected() {
        this.setState({
            ...this.state,
            isCustomSelected: true
        });
        this.buildSsml();
    }
    handleOptionSelected(option) {
        this.setState({
            ...this.state,
            isCustomSelected: false,
            value: option.value
        });
        this.buildSsml(option.value);
    }
    handleCustomChanged(value) {
        this.setState({
            ...this.state,
            isCustomSelected: true,
            value: value
        });
        this.buildSsml(value);
    }
    render() {
        return (0, _react.jsx)("div", null, (0, _react.jsx)((0, _levelSelectorDefault.default), {
            options: this.options,
            onOptionSelected: this.handleOptionSelected.bind(this),
            value: this.state.value,
            disableCustom: true,
            isCustom: false
        }));
    }
}
exports.default = EmphasisSelector;

},{"@babel/runtime/helpers/defineProperty":"9sJxO","@emotion/react":"djZKr","react":"6uln9","./LevelSelector":"gXIYq","../../../services/ssmlParseService":"7FRoV","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2wJqY":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _defineProperty = require("@babel/runtime/helpers/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _levelSelector = require("./LevelSelector");
var _levelSelectorDefault = parcelHelpers.interopDefault(_levelSelector);
var _ssmlParseService = require("../../../services/ssmlParseService");
var _ssmlParseServiceDefault = parcelHelpers.interopDefault(_ssmlParseService);
class VolumeSelector extends (0, _reactDefault.default).Component {
    constructor(...args){
        super(...args);
        (0, _definePropertyDefault.default)(this, "ssmlParser", new (0, _ssmlParseServiceDefault.default)());
        (0, _definePropertyDefault.default)(this, "placeholder", "Volume changed text");
        (0, _definePropertyDefault.default)(this, "options", [
            {
                name: "Silent",
                value: -100
            },
            {
                name: "Very Soft",
                value: -4
            },
            {
                name: "Soft",
                value: -2
            },
            {
                name: "Medium",
                value: 0.0
            },
            {
                name: "Loud",
                value: 2.0
            },
            {
                name: "Very Loud",
                value: 4.0
            }
        ]);
    }
    componentWillMount() {
        this.setInitialState();
        // send out the default ssml when it is first added
        var ssml = this.props.ssml ? this.props.ssml : `<prosody volume="-2.0dB">${this.placeholder}</prosody>`;
        this.props.onChange(ssml, this.placeholder);
    }
    setInitialState() {
        if (this.props.ssml) {
            // parse the break tag to set state
            const volume = this.ssmlParser.getElementProperty(this.props.ssml, "prosody", "volume");
            if (volume) {
                this.setState({
                    ...this.state,
                    isCustomSelected: volume != "silent" && !this.options.some((o)=>o.value + "dB" == volume.replace("+", "")),
                    value: volume == "silent" ? -100 : parseInt(volume.replace("dB", "").replace("+", ""))
                });
                return;
            }
        }
        this.setState({
            ...this.state,
            value: -2,
            isCustomSelected: false
        });
    }
    buildSsml(value) {
        value = value ? value : this.state.value;
        var valueLabel = "" + value + "dB";
        // need explicit "+"
        if (value > 0) valueLabel = "+" + valueLabel;
        if (value == -100) valueLabel = "silent";
        const ssml = `<prosody volume="${valueLabel}">${this.placeholder}</prosody>`;
        this.props.onChange(ssml, this.placeholder);
    }
    handleCustomSelected() {
        this.setState({
            ...this.state,
            isCustomSelected: true
        });
        this.buildSsml();
    }
    handleOptionSelected(option) {
        this.setState({
            ...this.state,
            isCustomSelected: false,
            value: option.value
        });
        this.buildSsml(option.value);
    }
    handleCustomChanged(value) {
        this.setState({
            ...this.state,
            isCustomSelected: true,
            value: value
        });
        this.buildSsml(value);
    }
    render() {
        return (0, _react.jsx)("div", null, (0, _react.jsx)((0, _levelSelectorDefault.default), {
            options: this.options,
            onCustomSelected: this.handleCustomSelected.bind(this),
            onOptionSelected: this.handleOptionSelected.bind(this),
            onCustomValueChanged: this.handleCustomChanged.bind(this),
            value: this.state.value,
            unit: "dB",
            isCustom: this.state.isCustomSelected
        }));
    }
}
exports.default = VolumeSelector;

},{"@babel/runtime/helpers/defineProperty":"9sJxO","@emotion/react":"djZKr","react":"6uln9","./LevelSelector":"gXIYq","../../../services/ssmlParseService":"7FRoV","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"dpgAy":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _defineProperty = require("@babel/runtime/helpers/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _ssmlParseService = require("../../../services/ssmlParseService");
var _ssmlParseServiceDefault = parcelHelpers.interopDefault(_ssmlParseService);
var _textField = require("../TextField");
var _textFieldDefault = parcelHelpers.interopDefault(_textField);
class DateSelector extends (0, _reactDefault.default).Component {
    constructor(...args){
        super(...args);
        (0, _definePropertyDefault.default)(this, "ssmlParser", new (0, _ssmlParseServiceDefault.default)());
    }
    componentWillMount() {
        this.setInitialState();
        // send out the default ssml when it is first added
        var ssml = this.props.ssml ? this.props.ssml : '<say-as interpret-as="date" format="dmy"> </say-as>';
        this.props.onChange(ssml);
    }
    setInitialState() {
        if (this.props.ssml) {
            // parse the break tag to set state
            const format = this.ssmlParser.getElementProperty(this.props.ssml, "say-as", "format");
            if (format) {
                this.setState({
                    ...this.state,
                    value: format ? format : "dmy"
                });
                return;
            }
        }
        this.setState({
            ...this.state,
            value: "dmy"
        });
    }
    buildSsml(value) {
        value = value ? value : this.state.value;
        const ssml = `<say-as interpret-as="date" format="${value}"> </say-as>`;
        this.props.onChange(ssml);
    }
    handleTextChange(e) {
        this.setState({
            ...this.state,
            value: e.target.value
        });
        this.buildSsml(e.target.value);
    }
    render() {
        return (0, _react.jsx)("div", null, (0, _react.jsx)((0, _textFieldDefault.default), {
            name: "format",
            placeholder: "date format (dmy)",
            value: this.state.value,
            onChange: this.handleTextChange.bind(this),
            onBlur: ()=>{},
            label: "Date Format"
        }));
    }
}
exports.default = DateSelector;

},{"@babel/runtime/helpers/defineProperty":"9sJxO","@emotion/react":"djZKr","react":"6uln9","../../../services/ssmlParseService":"7FRoV","../TextField":"7a7bh","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1GCXR":[function(require,module,exports) {
module.exports = require("b9f25a8457f51b60").getBundleURL("kVLro") + require("c06e3ecdafe3286f").resolve("fkzcC");

},{"b9f25a8457f51b60":"c7Tr5","c06e3ecdafe3286f":"fyJL2"}],"agq6G":[function(require,module,exports) {
module.exports = require("cb977b6016c0861a").getBundleURL("kVLro") + require("feded66656db92f").resolve("kA71o");

},{"cb977b6016c0861a":"c7Tr5","feded66656db92f":"fyJL2"}],"hVLO9":[function(require,module,exports) {
module.exports = require("ec29b4dd551c795e").getBundleURL("kVLro") + require("a90343c07d06bbb2").resolve("bYysE");

},{"ec29b4dd551c795e":"c7Tr5","a90343c07d06bbb2":"fyJL2"}],"eiqAH":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _defineProperty = require("@babel/runtime/helpers/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _ssmlParseService = require("../../../services/ssmlParseService");
var _ssmlParseServiceDefault = parcelHelpers.interopDefault(_ssmlParseService);
var _colors = require("../../../constants/colors");
var _ssmlPreviewElement = require("./SsmlPreviewElement");
var _ssmlPreviewElementDefault = parcelHelpers.interopDefault(_ssmlPreviewElement);
var _reactContenteditable = require("react-contenteditable");
var _reactContenteditableDefault = parcelHelpers.interopDefault(_reactContenteditable);
var _server = require("react-dom/server");
class SsmlPreviewer extends (0, _reactDefault.default).Component {
    constructor(...args){
        super(...args);
        (0, _definePropertyDefault.default)(this, "parser", new (0, _ssmlParseServiceDefault.default)());
        (0, _definePropertyDefault.default)(this, "updatedObject", this.props.ssmlObject);
        // same here
        (0, _definePropertyDefault.default)(this, "selectionChangeHandler", this.handleSelectionChange.bind(this));
        (0, _definePropertyDefault.default)(this, "pasteHandler", this.handleDivPaste.bind(this));
        (0, _definePropertyDefault.default)(this, "editable", null);
        (0, _definePropertyDefault.default)(this, "state", {
            isEditing: true,
            currentHoverId: null,
            compiledHtml: ""
        });
    }
    componentDidMount() {
        this.updatedObject = this.props.ssmlObject;
        const html = this.getRenderString(this.updatedObject);
        this.setState({
            ...this.state,
            compiledHtml: html
        });
        document.addEventListener("selectionchange", this.selectionChangeHandler, true);
        // needs the stuff rendered first
        if (this.editable) this.editable.setAttribute("placeholder", this.props.placeholder);
    }
    componentWillUnmount() {
        document?.removeEventListener("selectionchange", this.selectionChangeHandler, true);
    }
    rebindPaste() {
        var selector = document.querySelector('div[contenteditable="true"]');
        if (selector) {
            selector.removeEventListener("paste", this.pasteHandler, true);
            selector.addEventListener("paste", this.pasteHandler, true);
        }
    }
    componentDidUpdate(prevProps, prevState) {
        if (prevProps.ssmlObject != this.props.ssmlObject) {
            this.updatedObject = this.props.ssmlObject;
            const html = this.getRenderString(this.updatedObject);
            this.setState({
                ...this.state,
                compiledHtml: html
            });
        }
        prevProps.lastNewElement, this.props.lastNewElement;
        if (prevState.currentHoverId != this.state.currentHoverId) {
            this.rebindPaste();
            this.setSelectionToPrevious();
        }
    }
    getAllowsForChildren(name) {
        if (name == "break") return false;
        return true;
    }
    handleDivPaste(e) {
        e.preventDefault();
        // note: if we wanted to handle pasting copied ssml elements, this is where we should kick it off
        // const tree = this.updatedObject;
        // const rotated = this.parser.rotateMutableIds(tree);
        // var html = e.clipboardData.getData("text/html");
        // (html)
        var text = e.clipboardData.getData("text/plain");
        document.execCommand("insertHTML", false, text);
    }
    setSelectionToPrevious() {
        try {
            if (this.previousSelectionRange && this.previousSelectionRange.startId) {
                var selection = window.getSelection();
                if (!selection) return;
                const range = document.createRange();
                const startElement = document.getElementById(this.previousSelectionRange.startId);
                const endElement = document.getElementById(this.previousSelectionRange.endId);
                if (startElement && endElement && startElement.childNodes && endElement.childNodes) {
                    range.setStart(startElement.childNodes[0], this.previousSelectionRange.startOffset);
                    range.setEnd(endElement.childNodes[0], this.previousSelectionRange.endOffset);
                    selection.removeAllRanges();
                    selection.addRange(range);
                }
            }
        } catch (e) {
        // IE throws errors with empty messages that we should catch since we have to handle selection universally
        }
    }
    handleSelectionChange() {
        try {
            const selection = document.getSelection();
            if (selection == null || selection.rangeCount <= 0) return;
            const range = selection.getRangeAt(0);
            var startId = range.startContainer.parentElement.attributes["id"] ? range.startContainer.parentElement.attributes["id"].value : null;
            var startOffset = range.startOffset;
            var endId = range.endContainer.parentElement.attributes["id"] ? range.endContainer.parentElement.attributes["id"].value : null;
            var endOffset = range.endOffset;
            // this is used for the case where you are selecting managed text as well as the parent container text
            // such as the default ending &nbsp; to reselect the offset. Without this, the selection range is 0-1 and the
            // selection id's are null since it's within the entire parent.
            try {
                if (endId == null && startId != null) {
                    const endNode = range.endContainer.previousSibling;
                    if (endNode) {
                        endId = endNode.attributes["id"].value;
                        endOffset = endNode.lastChild.nodeValue.length;
                    }
                }
            } catch  {} // eat it 
            this.previousSelectionRange = {
                startOffset: startOffset,
                endOffset: endOffset,
                startId,
                endId
            };
            var ssmlParseResult = this.parser.convertToStringWithSelection(this.updatedObject, null, "", startId, startOffset, endId, endOffset);
            // TODO: figure out how to handle when all things are selected and there are a bunch of elements
            if (endId == null && startId == null && endOffset == 1 && startOffset == 1) {
                // in the end spacer - put stuff at the end
                this.startPosition = null;
                this.endPosition = null;
            } else if (endId == null && startId == null && this.updatedObject.children && this.updatedObject.children.length > 0) {
                // in new text but with previous children - select the start/end of the new text relative
                var totalLength = ssmlParseResult.ssml.length;
                var innerLength = this.updatedObject.children[this.updatedObject.children.length - 1].value.length;
                const otherLength = totalLength - innerLength;
                this.startPosition = otherLength + startOffset;
                this.endPosition = otherLength + endOffset;
            } else if (endId == null && startId == null) {
                // just in new text section
                this.startPosition = startOffset;
                this.endPosition = endOffset;
            } else {
                // normal case with already processed ids
                this.startPosition = ssmlParseResult.startIndex;
                this.endPosition = ssmlParseResult.endIndex;
            }
        } catch  {
        // global selection issues will throw here, so we should ignore them since they have nothing to do with our logic
        }
    }
    getAttributeValue(ssmlObject) {
        if (ssmlObject.name == "say-as" || ssmlObject.name == "audio") return null;
        return ssmlObject.attributes.filter((a)=>a.value).length > 0 ? ssmlObject.attributes[0].value : null;
    }
    startEditing() {
        this.setState({
            ...this.state,
            isEditing: true
        });
    }
    stopEditing() {
        this.setState({
            ...this.state,
            isEditing: false
        });
    }
    getRenderString(ssmlObject) {
        var html = (0, _server.renderToString)(this.renderSsmlElement(ssmlObject, 0, 0, null, true));
        if (html.includes("&lt;parsererror") && html.includes("parsererror&gt;")) {
            this.props.onRenderError();
            return "error";
        }
        return html ? html + "&nbsp;" : null;
    }
    handleElementClicked(e) {
        if (!e.target.hasAttribute("data-id")) {
            const openTarget = e.target;
            if (openTarget.hasAttribute("data-container")) {
                this.editable.focus();
                if (this.props.onFocus) this.props.onFocus();
            }
            return;
        }
        if (e.target.attributes["data-id"]) {
            this.setState({
                ...this.state,
                currentHoverId: null
            });
            this.props.onElementSelected(e.target.attributes["data-id"].value, this.updatedObject);
        }
    }
    handleElementLeave(e) {
        this.setState({
            ...this.state,
            currentHoverId: null
        });
    }
    handleMouseMove(e) {
        if (!e.target.hasAttribute("data-id") && this.state.currentHoverId != null) {
            this.setState({
                ...this.state,
                currentHoverId: null
            });
            this.setSelectionToPrevious();
            return;
        } else if (e.target.hasAttribute("data-id")) {
            var id = e.target.attributes["data-id"].value;
            if (id != this.state.currentHoverId) {
                this.setState({
                    ...this.state,
                    currentHoverId: id
                });
                this.setSelectionToPrevious();
            }
        }
    }
    handleMouseLeave() {
        // when we leave the entire div - clear hover states
        this.setState({
            ...this.state,
            currentHoverId: null
        });
    }
    handleHtmlChange(e) {
        const ssmlObject = this.parser.htmlToObject(e.target.value);
        this.updatedObject = ssmlObject;
    }
    handleBlur(ssmlObject, e) {
        this.props.onBlur(ssmlObject, e);
        this.props.onChange(this.updatedObject);
        this.props.onSelectionChange(this.startPosition, this.endPosition);
    }
    renderSsmlElement(ssmlObject, depth, index, parent, contentEditable) {
        if (!ssmlObject) return null;
        if (ssmlObject.name == "speak") return ssmlObject.children.length > 0 ? ssmlObject.children.map((c, i)=>this.renderSsmlElement(c, depth + 1, i, ssmlObject, contentEditable)) : null;
        else if (ssmlObject.name == "plain-text") {
            if (ssmlObject.isUnsupportedElement) return (0, _react.jsx)("span", {
                className: "ssml-element",
                key: ssmlObject.id,
                id: ssmlObject.id
            }, ssmlObject.value);
            else if (ssmlObject.value == "\n" || ssmlObject.value == "\r\n") return (0, _react.jsx)("div", {
                className: "new-line"
            }, (0, _react.jsx)("span", {
                key: ssmlObject.id,
                id: ssmlObject.id
            }, (0, _react.jsx)("br", null)));
            else return (0, _react.jsx)("span", {
                key: ssmlObject.id,
                id: ssmlObject.id
            }, ssmlObject.value);
        } else {
            var rule = this.parser.getDisplayedRule(ssmlObject);
            var digitValue = this.parser.getRawAttributeValue(ssmlObject);
            const allowsChildren = this.getAllowsForChildren(ssmlObject.name);
            return (0, _react.jsx)((0, _ssmlPreviewElementDefault.default), {
                onViewHover: this.startEditing.bind(this),
                onIconHover: this.stopEditing.bind(this),
                hoverActive: this.state.currentHoverId == ssmlObject.id,
                key: ssmlObject.id,
                ssmlObject: ssmlObject,
                minValue: rule ? rule.min : null,
                maxValue: rule ? rule.max : null,
                digitValue: digitValue,
                allowChildren: allowsChildren,
                contentEditable: contentEditable,
                attributeValue: this.getAttributeValue(ssmlObject)
            }, ssmlObject.children.length > 0 ? ssmlObject.children.map((c, i)=>this.renderSsmlElement(c, depth + 1, i, ssmlObject, contentEditable)) : (0, _react.jsx)("span", {
                className: allowsChildren ? "empty-tag" : ""
            }));
        }
    }
    render() {
        const html = this.getRenderString(this.updatedObject);
        return (0, _react.jsx)("div", {
            id: this.props.id,
            className: `${containerStyle} ${this.props.className} ${this.props.disabled ? "disabled" : ""}`,
            onClick: this.handleElementClicked.bind(this),
            onMouseMove: this.handleMouseMove.bind(this),
            "data-container": "true",
            suppressContentEditableWarning: true
        }, (0, _react.jsx)((0, _reactContenteditableDefault.default), {
            className: "editable",
            innerRef: (inner)=>this.editable = inner,
            onBlur: this.handleBlur.bind(this),
            html: html ? html : "",
            onChange: this.handleHtmlChange.bind(this),
            onPaste: this.handleDivPaste.bind(this),
            disabled: this.props.disabled
        }));
    }
}
const containerStyle = /*#__PURE__*/ (0, _css.css)("display:flex;flex-direction:row;flex-wrap:wrap;align-items:center;color:", (0, _colors.dark_grey_blue), ";font-family:Muli;text-align:left;min-height:34px;width:100%;border:none;padding:8px 16px;font-size:14px;margin:12px 0;resize:none;border-left:1px solid ", (0, _colors.silver_two), ";border-right:1px solid ", (0, _colors.silver_two), ";[contenteditable=true]:empty::before,editable:empty::before{content:attr(placeholder);font-weight:normal;font-style:italic;font-stretch:normal;line-height:normal;letter-spacing:normal;color:", (0, _colors.cool_grey), ";cursor:text;}.editable{line-height:32px;white-space:pre-wrap;width:100%;}&.disabled{background:", (0, _colors.color_shades_light), ";}.ssml-element{border-radius:20px;padding:6px;border:1px solid white;background:", (0, _colors.pastel_grey), ";&.say-as{background:", (0, _colors.pastel_red), ";}&.volume{background:", (0, _colors.pastel_light_blue), ";}&.pitch{background:", (0, _colors.pastel_blue), ";}&.emphasis{background:", (0, _colors.pastel_purple), ";}&.speed{background:", (0, _colors.pastel_green), ";}&.audio{background:", (0, _colors.pastel_pink), ";}&.break{background:", (0, _colors.pastel_yellow), ";}button{border:none;background:none;padding:0;margin:0;}.ssml-icon{cursor:pointer;padding:0 8px;margin:0 0 0 8px;margin:0 px;letter-spacing:12px;background-size:initial;background-repeat:no-repeat;background-position:initial;position:relative;display:inline-block;line-height:24px;}&.inner-padded{padding-right:16px;}}.new-line{display:block;}", "");
exports.default = SsmlPreviewer;

},{"@babel/runtime/helpers/defineProperty":"9sJxO","@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","../../../services/ssmlParseService":"7FRoV","../../../constants/colors":"1p3OR","./SsmlPreviewElement":"7fnMk","react-contenteditable":"5XHmM","react-dom/server":"acq5Z","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7fnMk":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _ssmlHoverTooltip = require("./SsmlHoverTooltip");
var _ssmlHoverTooltipDefault = parcelHelpers.interopDefault(_ssmlHoverTooltip);
var _ssmlValueMiniIndicator = require("./SsmlValueMiniIndicator");
var _ssmlValueMiniIndicatorDefault = parcelHelpers.interopDefault(_ssmlValueMiniIndicator);
const breakIcon = require("c62c8951f39b651");
const audioIcon = require("ae929a3c5fb1c09d");
const speedIcon = require("f4a0824a1ad58756");
const pitchIcon = require("be8fab3d578b8b9b");
const emphasisIcon = require("d2203877977256a7");
const volumeIcon = require("c21f513438f545e2");
const spellOutIcon = require("4324bb65b4a413fb");
const digitsIcon = require("f51b80bbf7edd71f");
const expletiveIcon = require("b12e0ac61cdcfe82");
const phoneIcon = require("de2a7a0fb3007440");
const addressIcon = require("361001acad1a641");
const cardinalIcon = require("3ae5138b50f99137");
const ordinalIcon = require("85c9d1e7029488f3");
const fractionIcon = require("be4666f210ac3244");
const dateIcon = require("3d1e30c1e87cfbba");
const timeIcon = require("f921546ddc919b4e");
const unitIcon = require("c63ebe4d36c86554");
const getIcon = (ssmlObject)=>{
    if (ssmlObject.name == "audio") return audioIcon;
    if (ssmlObject.name == "break") return breakIcon;
    if (ssmlObject.name == "emphasis") return emphasisIcon;
    if (ssmlObject.name == "say-as") {
        const subType = ssmlObject.attributes.find((a)=>a.name == "interpret-as");
        const subValue = subType ? subType.value : null;
        if (subValue == "characters" || subValue == "spell-out" || subValue == "verbatim") return spellOutIcon;
        if (subValue == "digits") return digitsIcon;
        if (subValue == "expletive") return expletiveIcon;
        if (subValue == "telephone") return phoneIcon;
        if (subValue == "cardinal") return cardinalIcon;
        if (subValue == "ordinal") return ordinalIcon;
        if (subValue == "fraction") return fractionIcon;
        if (subValue == "date") return dateIcon;
        if (subValue == "time") return timeIcon;
        if (subValue == "unit") return unitIcon;
        if (subValue == "address") return addressIcon;
    }
    if (ssmlObject.name == "prosody") {
        const isSpeed = ssmlObject.attributes.find((a)=>a.name == "rate");
        const isPitch = ssmlObject.attributes.find((a)=>a.name == "pitch");
        const isVolume = ssmlObject.attributes.find((a)=>a.name == "volume");
        if (isSpeed) return speedIcon;
        if (isPitch) return pitchIcon;
        if (isVolume) return volumeIcon;
    }
    return null;
};
const getDisplayName = (ssmlObject)=>{
    if (ssmlObject.name == "say-as") {
        const subType = ssmlObject.attributes.find((a)=>a.name == "interpret-as");
        return subType ? subType.value : ssmlObject.name;
    }
    if (ssmlObject.name == "prosody") {
        const isSpeed = ssmlObject.attributes.find((a)=>a.name == "rate");
        const isPitch = ssmlObject.attributes.find((a)=>a.name == "pitch");
        const isVolume = ssmlObject.attributes.find((a)=>a.name == "volume");
        if (isSpeed) return "Speed";
        if (isPitch) return "Pitch";
        if (isVolume) return "Volume";
    }
    return ssmlObject.name;
};
const getSsmlClass = (ssmlObject)=>{
    if (ssmlObject.name == "prosody") {
        const isSpeed = ssmlObject.attributes.find((a)=>a.name == "rate");
        const isPitch = ssmlObject.attributes.find((a)=>a.name == "pitch");
        const isVolume = ssmlObject.attributes.find((a)=>a.name == "volume");
        if (isSpeed) return "speed";
        if (isPitch) return "pitch";
        if (isVolume) return "volume";
    }
    return ssmlObject.name;
};
class SsmlPreviewElement extends (0, _reactDefault.default).Component {
    render() {
        const props = this.props;
        var ssmlClass = getSsmlClass(props.ssmlObject);
        if (props.allowChildren !== false) ssmlClass += " inner-padded";
        return (0, _react.jsx)((0, _reactDefault.default).Fragment, null, (0, _react.jsx)("span", {
            suppressContentEditableWarning: true,
            contentEditable: props.allowChildren && props.contentEditable,
            id: props.ssmlObject.id,
            "data-ssml-element": props.ssmlObject.name,
            "data-ssml-attributes": JSON.stringify(props.ssmlObject.attributes),
            className: "ssml-element " + ssmlClass
        }, (0, _react.jsx)("span", {
            contentEditable: false,
            style: {
                backgroundImage: `url('${getIcon(props.ssmlObject)}')`
            },
            className: "ssml-icon",
            "data-id": props.ssmlObject.id,
            "data-ignore": true
        }, props.hoverActive ? (0, _react.jsx)((0, _ssmlHoverTooltipDefault.default), {
            elementName: getDisplayName(props.ssmlObject),
            attributeValue: props.attributeValue,
            icon: getIcon(props.ssmlObject),
            dataId: props.ssmlObject.id
        }) : null, "\xa0", this.props.digitValue != null ? (0, _react.jsx)((0, _ssmlValueMiniIndicatorDefault.default), {
            min: this.props.minValue,
            max: this.props.maxValue,
            value: this.props.digitValue
        }) : null), props.children), (0, _react.jsx)("span", {
            "data-spacer": "true"
        }));
    }
}
exports.default = SsmlPreviewElement;

},{"@emotion/react":"djZKr","react":"6uln9","./SsmlHoverTooltip":"i7GcV","./SsmlValueMiniIndicator":"eRYAn","c62c8951f39b651":"83gJa","ae929a3c5fb1c09d":"lNiiJ","f4a0824a1ad58756":"lw7Cw","be8fab3d578b8b9b":"unvpp","d2203877977256a7":"fCgcP","c21f513438f545e2":"dCUB7","4324bb65b4a413fb":"dK2qv","f51b80bbf7edd71f":"iB879","b12e0ac61cdcfe82":"ksgYJ","de2a7a0fb3007440":"c3r3V","361001acad1a641":"1OE6C","3ae5138b50f99137":"ae3tR","85c9d1e7029488f3":"fu1RD","be4666f210ac3244":"9tQNK","3d1e30c1e87cfbba":"f3KI1","f921546ddc919b4e":"k5sqa","c63ebe4d36c86554":"d8OYR","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"i7GcV":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const container = /*#__PURE__*/ (0, _css.css)({
    name: "1w0kdxz",
    styles: "position:absolute;display:block;background:#304562;bottom:100%;left:50%;min-width:152px;letter-spacing:0.8px;margin-left:-80px;box-shadow:0 2px 4px 0 rgba(48, 69, 98, 0.1);border-radius:6px;padding:12px 16px;>*{color:white;}img{filter:brightness(100);}.triangle{box-shadow:0 2px 4px 0 rgba(48, 69, 98, 0.1);position:absolute;}.ssml-item-header{display:flex;align-items:baseline;justify-content:center;.ssml-element-name{font-size:12px;font-weight:600;letter-spacing:0.8px;color:#ffffff;text-transform:uppercase;color:white;margin:0 8px;}.ssml-attribute-value{font-family:Muli;font-size:18px;font-weight:600;text-align:right;text-transform:uppercase;color:white;margin-right:0;margin-left:auto;.attribute-unit{font-size:12px;}}}.ssml-separator{height:1px;background:white;margin:6px 0;}.ssml-action-text{font-size:12px;font-weight:600;text-align:center;color:white;white-space:nowrap;}"
});
const SsmlHoverTooltip = (props)=>(0, _react.jsx)("div", {
        contentEditable: false,
        className: container,
        "data-id": props.dataId
    }, (0, _react.jsx)("div", {
        "data-id": props.dataId
    }, (0, _react.jsx)("div", {
        className: "ssml-item-header",
        "data-id": props.dataId
    }, (0, _react.jsx)("img", {
        src: props.icon,
        "data-id": props.dataId
    }), (0, _react.jsx)("p", {
        className: "ssml-element-name",
        "data-id": props.dataId
    }, props.elementName), props.attributeValue ? (0, _react.jsx)("p", {
        className: "ssml-attribute-value",
        "data-id": props.dataId
    }, props.attributeValue, " ", props.attributeUnit ? (0, _react.jsx)("span", {
        className: "attribute-unit"
    }, props.attributeUnit) : null) : null), (0, _react.jsx)("div", {
        className: "ssml-separator",
        "data-id": props.dataId
    }), (0, _react.jsx)("p", {
        className: "ssml-action-text",
        "data-id": props.dataId
    }, "Click to edit or remove")));
exports.default = SsmlHoverTooltip;

},{"@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"eRYAn":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _colors = require("../../../constants/colors");
const container = /*#__PURE__*/ (0, _css.css)("align-items:baseline;display:inline-flex;vertical-align:middle;padding-left:8px;.bar{width:1px;height:20px;background:", (0, _colors.color_shades_darkest), ";}.triangle-wrapper{.triangle{width:0;height:0;margin-left:1px;border-top:2px solid transparent;border-right:2px solid ", (0, _colors.color_shades_darkest), ";border-bottom:2px solid transparent;}}", "");
const calculatePadding = (min, max, value)=>{
    if (min == null || max == null || value == null) return 0;
    return (value - min) / (max - min) * 16;
};
const SsmlValueMiniIndicator = (props)=>(0, _react.jsx)("div", {
        "data-ignore": "true",
        className: container
    }, (0, _react.jsx)("div", {
        className: "bar"
    }), (0, _react.jsx)("div", {
        className: "triangle-wrapper",
        style: {
            paddingBottom: calculatePadding(props.min, props.max, props.value)
        }
    }, (0, _react.jsx)("div", {
        className: "triangle"
    })));
exports.default = SsmlValueMiniIndicator;

},{"@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","../../../constants/colors":"1p3OR","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"5XHmM":[function(require,module,exports) {
"use strict";
var __extends = this && this.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var __assign = this && this.__assign || function() {
    __assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = this && this.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var __importStar = this && this.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    }
    __setModuleDefault(result, mod);
    return result;
};
var __rest = this && this.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var __importDefault = this && this.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(exports, "__esModule", {
    value: true
});
var React = __importStar(require("b0e90f3b7a3ac8f7"));
var fast_deep_equal_1 = __importDefault(require("7eb7ad566cdf902c"));
var PropTypes = __importStar(require("91bc9224e2bb927d"));
function normalizeHtml(str) {
    return str && str.replace(/&nbsp;|\u202F|\u00A0/g, " ").replace(/<br \/>/g, "<br>");
}
function replaceCaret(el) {
    // Place the caret at the end of the element
    var target = document.createTextNode("");
    el.appendChild(target);
    // do not move caret if element was not focused
    var isTargetFocused = document.activeElement === el;
    if (target !== null && target.nodeValue !== null && isTargetFocused) {
        var sel = window.getSelection();
        if (sel !== null) {
            var range = document.createRange();
            range.setStart(target, target.nodeValue.length);
            range.collapse(true);
            sel.removeAllRanges();
            sel.addRange(range);
        }
        if (el instanceof HTMLElement) el.focus();
    }
}
/**
 * A simple component for an html element with editable contents.
 */ var ContentEditable = /** @class */ function(_super) {
    __extends(ContentEditable, _super);
    function ContentEditable() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.lastHtml = _this.props.html;
        _this.el = typeof _this.props.innerRef === "function" ? {
            current: null
        } : React.createRef();
        _this.getEl = function() {
            return (_this.props.innerRef && typeof _this.props.innerRef !== "function" ? _this.props.innerRef : _this.el).current;
        };
        _this.emitChange = function(originalEvt) {
            var el = _this.getEl();
            if (!el) return;
            var html = el.innerHTML;
            if (_this.props.onChange && html !== _this.lastHtml) {
                // Clone event with Object.assign to avoid
                // "Cannot assign to read only property 'target' of object"
                var evt = Object.assign({}, originalEvt, {
                    target: {
                        value: html
                    }
                });
                _this.props.onChange(evt);
            }
            _this.lastHtml = html;
        };
        return _this;
    }
    ContentEditable.prototype.render = function() {
        var _this = this;
        var _a = this.props, tagName = _a.tagName, html = _a.html, innerRef = _a.innerRef, props = __rest(_a, [
            "tagName",
            "html",
            "innerRef"
        ]);
        return React.createElement(tagName || "div", __assign(__assign({}, props), {
            ref: typeof innerRef === "function" ? function(current) {
                innerRef(current);
                _this.el.current = current;
            } : innerRef || this.el,
            onInput: this.emitChange,
            onBlur: this.props.onBlur || this.emitChange,
            onKeyUp: this.props.onKeyUp || this.emitChange,
            onKeyDown: this.props.onKeyDown || this.emitChange,
            contentEditable: !this.props.disabled,
            dangerouslySetInnerHTML: {
                __html: html
            }
        }), this.props.children);
    };
    ContentEditable.prototype.shouldComponentUpdate = function(nextProps) {
        var props = this.props;
        var el = this.getEl();
        // We need not rerender if the change of props simply reflects the user's edits.
        // Rerendering in this case would make the cursor/caret jump
        // Rerender if there is no element yet... (somehow?)
        if (!el) return true;
        // ...or if html really changed... (programmatically, not by user edit)
        if (normalizeHtml(nextProps.html) !== normalizeHtml(el.innerHTML)) return true;
        // Handle additional properties
        return props.disabled !== nextProps.disabled || props.tagName !== nextProps.tagName || props.className !== nextProps.className || props.innerRef !== nextProps.innerRef || props.placeholder !== nextProps.placeholder || !(0, fast_deep_equal_1.default)(props.style, nextProps.style);
    };
    ContentEditable.prototype.componentDidUpdate = function() {
        var el = this.getEl();
        if (!el) return;
        // Perhaps React (whose VDOM gets outdated because we often prevent
        // rerendering) did not update the DOM. So we update it manually now.
        if (this.props.html !== el.innerHTML) el.innerHTML = this.props.html;
        this.lastHtml = this.props.html;
        replaceCaret(el);
    };
    ContentEditable.propTypes = {
        html: PropTypes.string.isRequired,
        onChange: PropTypes.func,
        disabled: PropTypes.bool,
        tagName: PropTypes.string,
        className: PropTypes.string,
        style: PropTypes.object,
        innerRef: PropTypes.oneOfType([
            PropTypes.object,
            PropTypes.func
        ])
    };
    return ContentEditable;
}(React.Component);
exports.default = ContentEditable;

},{"b0e90f3b7a3ac8f7":"6uln9","7eb7ad566cdf902c":"blc55","91bc9224e2bb927d":"6FKs7"}],"blc55":[function(require,module,exports) {
"use strict";
// do not edit .js files directly - edit src/index.jst
module.exports = function equal(a, b) {
    if (a === b) return true;
    if (a && b && typeof a == "object" && typeof b == "object") {
        if (a.constructor !== b.constructor) return false;
        var length, i, keys;
        if (Array.isArray(a)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (!equal(a[i], b[i])) return false;
            return true;
        }
        if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
        if (a.valueOf !== Object.prototype.valueOf) return a.valueOf() === b.valueOf();
        if (a.toString !== Object.prototype.toString) return a.toString() === b.toString();
        keys = Object.keys(a);
        length = keys.length;
        if (length !== Object.keys(b).length) return false;
        for(i = length; i-- !== 0;)if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
        for(i = length; i-- !== 0;){
            var key = keys[i];
            if (!equal(a[key], b[key])) return false;
        }
        return true;
    }
    // true if both NaN, false otherwise
    return a !== a && b !== b;
};

},{}],"acq5Z":[function(require,module,exports) {
"use strict";
module.exports = require("d38e18015ef6662b");

},{"d38e18015ef6662b":"4zgGz"}],"4zgGz":[function(require,module,exports) {
/** @license React v17.0.2
 * react-dom-server.browser.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var l = require("2a760a3bc04cb618"), m = require("25c06765b630fbbf");
function p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var q = 60106, r = 60107, u = 60108, z = 60114, B = 60109, aa = 60110, ba = 60112, D = 60113, ca = 60120, da = 60115, ea = 60116, fa = 60121, ha = 60117, ia = 60119, ja = 60129, ka = 60131;
if ("function" === typeof Symbol && Symbol.for) {
    var E = Symbol.for;
    q = E("react.portal");
    r = E("react.fragment");
    u = E("react.strict_mode");
    z = E("react.profiler");
    B = E("react.provider");
    aa = E("react.context");
    ba = E("react.forward_ref");
    D = E("react.suspense");
    ca = E("react.suspense_list");
    da = E("react.memo");
    ea = E("react.lazy");
    fa = E("react.block");
    ha = E("react.fundamental");
    ia = E("react.scope");
    ja = E("react.debug_trace_mode");
    ka = E("react.legacy_hidden");
}
function F(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case r:
            return "Fragment";
        case q:
            return "Portal";
        case z:
            return "Profiler";
        case u:
            return "StrictMode";
        case D:
            return "Suspense";
        case ca:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case aa:
            return (a.displayName || "Context") + ".Consumer";
        case B:
            return (a._context.displayName || "Context") + ".Provider";
        case ba:
            var b = a.render;
            b = b.displayName || b.name || "";
            return a.displayName || ("" !== b ? "ForwardRef(" + b + ")" : "ForwardRef");
        case da:
            return F(a.type);
        case fa:
            return F(a._render);
        case ea:
            b = a._payload;
            a = a._init;
            try {
                return F(a(b));
            } catch (c) {}
    }
    return null;
}
var la = m.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, ma = {};
function I(a, b) {
    for(var c = a._threadCount | 0; c <= b; c++)a[c] = a._currentValue2, a._threadCount = c + 1;
}
function na(a, b, c, d) {
    if (d && (d = a.contextType, "object" === typeof d && null !== d)) return I(d, c), d[c];
    if (a = a.contextTypes) {
        c = {};
        for(var f in a)c[f] = b[f];
        b = c;
    } else b = ma;
    return b;
}
for(var J = new Uint16Array(16), K = 0; 15 > K; K++)J[K] = K + 1;
J[15] = 0;
var oa = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, pa = Object.prototype.hasOwnProperty, qa = {}, ra = {};
function sa(a) {
    if (pa.call(ra, a)) return !0;
    if (pa.call(qa, a)) return !1;
    if (oa.test(a)) return ra[a] = !0;
    qa[a] = !0;
    return !1;
}
function ta(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function ua(a, b, c, d) {
    if (null === b || "undefined" === typeof b || ta(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function M(a, b, c, d, f, h, t) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = f;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = h;
    this.removeEmptyString = t;
}
var N = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    N[a] = new M(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    N[b] = new M(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    N[a] = new M(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    N[a] = new M(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    N[a] = new M(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    N[a] = new M(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    N[a] = new M(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    N[a] = new M(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    N[a] = new M(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var va = /[\-:]([a-z])/g;
function wa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace(va, wa);
    N[b] = new M(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace(va, wa);
    N[b] = new M(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace(va, wa);
    N[b] = new M(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    N[a] = new M(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
N.xlinkHref = new M("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    N[a] = new M(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
var xa = /["'&<>]/;
function O(a) {
    if ("boolean" === typeof a || "number" === typeof a) return "" + a;
    a = "" + a;
    var b = xa.exec(a);
    if (b) {
        var c = "", d, f = 0;
        for(d = b.index; d < a.length; d++){
            switch(a.charCodeAt(d)){
                case 34:
                    b = "&quot;";
                    break;
                case 38:
                    b = "&amp;";
                    break;
                case 39:
                    b = "&#x27;";
                    break;
                case 60:
                    b = "&lt;";
                    break;
                case 62:
                    b = "&gt;";
                    break;
                default:
                    continue;
            }
            f !== d && (c += a.substring(f, d));
            f = d + 1;
            c += b;
        }
        a = f !== d ? c + a.substring(f, d) : c;
    }
    return a;
}
function ya(a, b) {
    var c = N.hasOwnProperty(a) ? N[a] : null;
    var d;
    if (d = "style" !== a) d = null !== c ? 0 === c.type : !(2 < a.length) || "o" !== a[0] && "O" !== a[0] || "n" !== a[1] && "N" !== a[1] ? !1 : !0;
    if (d || ua(a, b, c, !1)) return "";
    if (null !== c) {
        a = c.attributeName;
        d = c.type;
        if (3 === d || 4 === d && !0 === b) return a + '=""';
        c.sanitizeURL && (b = "" + b);
        return a + '="' + (O(b) + '"');
    }
    return sa(a) ? a + '="' + (O(b) + '"') : "";
}
function za(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var Aa = "function" === typeof Object.is ? Object.is : za, P = null, Q = null, R = null, S = !1, T = !1, U = null, V = 0;
function W() {
    if (null === P) throw Error(p(321));
    return P;
}
function Ba() {
    if (0 < V) throw Error(p(312));
    return {
        memoizedState: null,
        queue: null,
        next: null
    };
}
function Ca() {
    null === R ? null === Q ? (S = !1, Q = R = Ba()) : (S = !0, R = Q) : null === R.next ? (S = !1, R = R.next = Ba()) : (S = !0, R = R.next);
    return R;
}
function Da(a, b, c, d) {
    for(; T;)T = !1, V += 1, R = null, c = a(b, d);
    Ea();
    return c;
}
function Ea() {
    P = null;
    T = !1;
    Q = null;
    V = 0;
    R = U = null;
}
function Fa(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function Ga(a, b, c) {
    P = W();
    R = Ca();
    if (S) {
        var d = R.queue;
        b = d.dispatch;
        if (null !== U && (c = U.get(d), void 0 !== c)) {
            U.delete(d);
            d = R.memoizedState;
            do d = a(d, c.action), c = c.next;
            while (null !== c);
            R.memoizedState = d;
            return [
                d,
                b
            ];
        }
        return [
            R.memoizedState,
            b
        ];
    }
    a = a === Fa ? "function" === typeof b ? b() : b : void 0 !== c ? c(b) : b;
    R.memoizedState = a;
    a = R.queue = {
        last: null,
        dispatch: null
    };
    a = a.dispatch = Ha.bind(null, P, a);
    return [
        R.memoizedState,
        a
    ];
}
function Ia(a, b) {
    P = W();
    R = Ca();
    b = void 0 === b ? null : b;
    if (null !== R) {
        var c = R.memoizedState;
        if (null !== c && null !== b) {
            var d = c[1];
            a: if (null === d) d = !1;
            else {
                for(var f = 0; f < d.length && f < b.length; f++)if (!Aa(b[f], d[f])) {
                    d = !1;
                    break a;
                }
                d = !0;
            }
            if (d) return c[0];
        }
    }
    a = a();
    R.memoizedState = [
        a,
        b
    ];
    return a;
}
function Ha(a, b, c) {
    if (!(25 > V)) throw Error(p(301));
    if (a === P) {
        if (T = !0, a = {
            action: c,
            next: null
        }, null === U && (U = new Map), c = U.get(b), void 0 === c) U.set(b, a);
        else {
            for(b = c; null !== b.next;)b = b.next;
            b.next = a;
        }
    }
}
function Ja() {}
var X = null, Ka = {
    readContext: function(a) {
        var b = X.threadID;
        I(a, b);
        return a[b];
    },
    useContext: function(a) {
        W();
        var b = X.threadID;
        I(a, b);
        return a[b];
    },
    useMemo: Ia,
    useReducer: Ga,
    useRef: function(a) {
        P = W();
        R = Ca();
        var b = R.memoizedState;
        return null === b ? (a = {
            current: a
        }, R.memoizedState = a) : b;
    },
    useState: function(a) {
        return Ga(Fa, a);
    },
    useLayoutEffect: function() {},
    useCallback: function(a, b) {
        return Ia(function() {
            return a;
        }, b);
    },
    useImperativeHandle: Ja,
    useEffect: Ja,
    useDebugValue: Ja,
    useDeferredValue: function(a) {
        W();
        return a;
    },
    useTransition: function() {
        W();
        return [
            function(a) {
                a();
            },
            !1
        ];
    },
    useOpaqueIdentifier: function() {
        return (X.identifierPrefix || "") + "R:" + (X.uniqueID++).toString(36);
    },
    useMutableSource: function(a, b) {
        W();
        return b(a._source);
    }
}, La = {
    html: "http://www.w3.org/1999/xhtml",
    mathml: "http://www.w3.org/1998/Math/MathML",
    svg: "http://www.w3.org/2000/svg"
};
function Ma(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
var Na = {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
}, Oa = l({
    menuitem: !0
}, Na), Y = {
    animationIterationCount: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, Pa = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys(Y).forEach(function(a) {
    Pa.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        Y[b] = Y[a];
    });
});
var Qa = /([A-Z])/g, Ra = /^ms-/, Z = m.Children.toArray, Sa = la.ReactCurrentDispatcher, Ta = {
    listing: !0,
    pre: !0,
    textarea: !0
}, Ua = /^[a-zA-Z][a-zA-Z:_\.\-\d]*$/, Va = {}, Wa = {};
function Xa(a) {
    if (void 0 === a || null === a) return a;
    var b = "";
    m.Children.forEach(a, function(a) {
        null != a && (b += a);
    });
    return b;
}
var Ya = Object.prototype.hasOwnProperty, Za = {
    children: null,
    dangerouslySetInnerHTML: null,
    suppressContentEditableWarning: null,
    suppressHydrationWarning: null
};
function $a(a, b) {
    if (void 0 === a) throw Error(p(152, F(b) || "Component"));
}
function ab(a, b, c) {
    function d(d, h) {
        var e = h.prototype && h.prototype.isReactComponent, f = na(h, b, c, e), t = [], g = !1, n = {
            isMounted: function() {
                return !1;
            },
            enqueueForceUpdate: function() {
                if (null === t) return null;
            },
            enqueueReplaceState: function(a, c) {
                g = !0;
                t = [
                    c
                ];
            },
            enqueueSetState: function(a, c) {
                if (null === t) return null;
                t.push(c);
            }
        };
        if (e) {
            if (e = new h(d.props, f, n), "function" === typeof h.getDerivedStateFromProps) {
                var k = h.getDerivedStateFromProps.call(null, d.props, e.state);
                null != k && (e.state = l({}, e.state, k));
            }
        } else if (P = {}, e = h(d.props, f, n), e = Da(h, d.props, e, f), null == e || null == e.render) {
            a = e;
            $a(a, h);
            return;
        }
        e.props = d.props;
        e.context = f;
        e.updater = n;
        n = e.state;
        void 0 === n && (e.state = n = null);
        if ("function" === typeof e.UNSAFE_componentWillMount || "function" === typeof e.componentWillMount) {
            if ("function" === typeof e.componentWillMount && "function" !== typeof h.getDerivedStateFromProps && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && "function" !== typeof h.getDerivedStateFromProps && e.UNSAFE_componentWillMount(), t.length) {
                n = t;
                var v = g;
                t = null;
                g = !1;
                if (v && 1 === n.length) e.state = n[0];
                else {
                    k = v ? n[0] : e.state;
                    var H = !0;
                    for(v = v ? 1 : 0; v < n.length; v++){
                        var x = n[v];
                        x = "function" === typeof x ? x.call(e, k, d.props, f) : x;
                        null != x && (H ? (H = !1, k = l({}, k, x)) : l(k, x));
                    }
                    e.state = k;
                }
            } else t = null;
        }
        a = e.render();
        $a(a, h);
        if ("function" === typeof e.getChildContext && (d = h.childContextTypes, "object" === typeof d)) {
            var y = e.getChildContext();
            for(var A in y)if (!(A in d)) throw Error(p(108, F(h) || "Unknown", A));
        }
        y && (b = l({}, b, y));
    }
    for(; m.isValidElement(a);){
        var f = a, h = f.type;
        if ("function" !== typeof h) break;
        d(f, h);
    }
    return {
        child: a,
        context: b
    };
}
var bb = function() {
    function a(a, b, f) {
        m.isValidElement(a) ? a.type !== r ? a = [
            a
        ] : (a = a.props.children, a = m.isValidElement(a) ? [
            a
        ] : Z(a)) : a = Z(a);
        a = {
            type: null,
            domNamespace: La.html,
            children: a,
            childIndex: 0,
            context: ma,
            footer: ""
        };
        var c = J[0];
        if (0 === c) {
            var d = J;
            c = d.length;
            var g = 2 * c;
            if (!(65536 >= g)) throw Error(p(304));
            var e = new Uint16Array(g);
            e.set(d);
            J = e;
            J[0] = c + 1;
            for(d = c; d < g - 1; d++)J[d] = d + 1;
            J[g - 1] = 0;
        } else J[0] = J[c];
        this.threadID = c;
        this.stack = [
            a
        ];
        this.exhausted = !1;
        this.currentSelectValue = null;
        this.previousWasTextNode = !1;
        this.makeStaticMarkup = b;
        this.suspenseDepth = 0;
        this.contextIndex = -1;
        this.contextStack = [];
        this.contextValueStack = [];
        this.uniqueID = 0;
        this.identifierPrefix = f && f.identifierPrefix || "";
    }
    var b = a.prototype;
    b.destroy = function() {
        if (!this.exhausted) {
            this.exhausted = !0;
            this.clearProviders();
            var a = this.threadID;
            J[a] = J[0];
            J[0] = a;
        }
    };
    b.pushProvider = function(a) {
        var b = ++this.contextIndex, c = a.type._context, h = this.threadID;
        I(c, h);
        var t = c[h];
        this.contextStack[b] = c;
        this.contextValueStack[b] = t;
        c[h] = a.props.value;
    };
    b.popProvider = function() {
        var a = this.contextIndex, b = this.contextStack[a], f = this.contextValueStack[a];
        this.contextStack[a] = null;
        this.contextValueStack[a] = null;
        this.contextIndex--;
        b[this.threadID] = f;
    };
    b.clearProviders = function() {
        for(var a = this.contextIndex; 0 <= a; a--)this.contextStack[a][this.threadID] = this.contextValueStack[a];
    };
    b.read = function(a) {
        if (this.exhausted) return null;
        var b = X;
        X = this;
        var c = Sa.current;
        Sa.current = Ka;
        try {
            for(var h = [
                ""
            ], t = !1; h[0].length < a;){
                if (0 === this.stack.length) {
                    this.exhausted = !0;
                    var g = this.threadID;
                    J[g] = J[0];
                    J[0] = g;
                    break;
                }
                var e = this.stack[this.stack.length - 1];
                if (t || e.childIndex >= e.children.length) {
                    var L = e.footer;
                    "" !== L && (this.previousWasTextNode = !1);
                    this.stack.pop();
                    if ("select" === e.type) this.currentSelectValue = null;
                    else if (null != e.type && null != e.type.type && e.type.type.$$typeof === B) this.popProvider(e.type);
                    else if (e.type === D) {
                        this.suspenseDepth--;
                        var G = h.pop();
                        if (t) {
                            t = !1;
                            var C = e.fallbackFrame;
                            if (!C) throw Error(p(303));
                            this.stack.push(C);
                            h[this.suspenseDepth] += "<!--$!-->";
                            continue;
                        } else h[this.suspenseDepth] += G;
                    }
                    h[this.suspenseDepth] += L;
                } else {
                    var n = e.children[e.childIndex++], k = "";
                    try {
                        k += this.render(n, e.context, e.domNamespace);
                    } catch (v) {
                        if (null != v && "function" === typeof v.then) throw Error(p(294));
                        throw v;
                    } finally{}
                    h.length <= this.suspenseDepth && h.push("");
                    h[this.suspenseDepth] += k;
                }
            }
            return h[0];
        } finally{
            Sa.current = c, X = b, Ea();
        }
    };
    b.render = function(a, b, f) {
        if ("string" === typeof a || "number" === typeof a) {
            f = "" + a;
            if ("" === f) return "";
            if (this.makeStaticMarkup) return O(f);
            if (this.previousWasTextNode) return "<!-- -->" + O(f);
            this.previousWasTextNode = !0;
            return O(f);
        }
        b = ab(a, b, this.threadID);
        a = b.child;
        b = b.context;
        if (null === a || !1 === a) return "";
        if (!m.isValidElement(a)) {
            if (null != a && null != a.$$typeof) {
                f = a.$$typeof;
                if (f === q) throw Error(p(257));
                throw Error(p(258, f.toString()));
            }
            a = Z(a);
            this.stack.push({
                type: null,
                domNamespace: f,
                children: a,
                childIndex: 0,
                context: b,
                footer: ""
            });
            return "";
        }
        var c = a.type;
        if ("string" === typeof c) return this.renderDOM(a, b, f);
        switch(c){
            case ka:
            case ja:
            case u:
            case z:
            case ca:
            case r:
                return a = Z(a.props.children), this.stack.push({
                    type: null,
                    domNamespace: f,
                    children: a,
                    childIndex: 0,
                    context: b,
                    footer: ""
                }), "";
            case D:
                throw Error(p(294));
            case ia:
                throw Error(p(343));
        }
        if ("object" === typeof c && null !== c) switch(c.$$typeof){
            case ba:
                P = {};
                var d = c.render(a.props, a.ref);
                d = Da(c.render, a.props, d, a.ref);
                d = Z(d);
                this.stack.push({
                    type: null,
                    domNamespace: f,
                    children: d,
                    childIndex: 0,
                    context: b,
                    footer: ""
                });
                return "";
            case da:
                return a = [
                    m.createElement(c.type, l({
                        ref: a.ref
                    }, a.props))
                ], this.stack.push({
                    type: null,
                    domNamespace: f,
                    children: a,
                    childIndex: 0,
                    context: b,
                    footer: ""
                }), "";
            case B:
                return c = Z(a.props.children), f = {
                    type: a,
                    domNamespace: f,
                    children: c,
                    childIndex: 0,
                    context: b,
                    footer: ""
                }, this.pushProvider(a), this.stack.push(f), "";
            case aa:
                c = a.type;
                d = a.props;
                var g = this.threadID;
                I(c, g);
                c = Z(d.children(c[g]));
                this.stack.push({
                    type: a,
                    domNamespace: f,
                    children: c,
                    childIndex: 0,
                    context: b,
                    footer: ""
                });
                return "";
            case ha:
                throw Error(p(338));
            case ea:
                return c = a.type, d = c._init, c = d(c._payload), a = [
                    m.createElement(c, l({
                        ref: a.ref
                    }, a.props))
                ], this.stack.push({
                    type: null,
                    domNamespace: f,
                    children: a,
                    childIndex: 0,
                    context: b,
                    footer: ""
                }), "";
        }
        throw Error(p(130, null == c ? c : typeof c, ""));
    };
    b.renderDOM = function(a, b, f) {
        var c = a.type.toLowerCase();
        f === La.html && Ma(c);
        if (!Va.hasOwnProperty(c)) {
            if (!Ua.test(c)) throw Error(p(65, c));
            Va[c] = !0;
        }
        var d = a.props;
        if ("input" === c) d = l({
            type: void 0
        }, d, {
            defaultChecked: void 0,
            defaultValue: void 0,
            value: null != d.value ? d.value : d.defaultValue,
            checked: null != d.checked ? d.checked : d.defaultChecked
        });
        else if ("textarea" === c) {
            var g = d.value;
            if (null == g) {
                g = d.defaultValue;
                var e = d.children;
                if (null != e) {
                    if (null != g) throw Error(p(92));
                    if (Array.isArray(e)) {
                        if (!(1 >= e.length)) throw Error(p(93));
                        e = e[0];
                    }
                    g = "" + e;
                }
                null == g && (g = "");
            }
            d = l({}, d, {
                value: void 0,
                children: "" + g
            });
        } else if ("select" === c) this.currentSelectValue = null != d.value ? d.value : d.defaultValue, d = l({}, d, {
            value: void 0
        });
        else if ("option" === c) {
            e = this.currentSelectValue;
            var L = Xa(d.children);
            if (null != e) {
                var G = null != d.value ? d.value + "" : L;
                g = !1;
                if (Array.isArray(e)) {
                    for(var C = 0; C < e.length; C++)if ("" + e[C] === G) {
                        g = !0;
                        break;
                    }
                } else g = "" + e === G;
                d = l({
                    selected: void 0,
                    children: void 0
                }, d, {
                    selected: g,
                    children: L
                });
            }
        }
        if (g = d) {
            if (Oa[c] && (null != g.children || null != g.dangerouslySetInnerHTML)) throw Error(p(137, c));
            if (null != g.dangerouslySetInnerHTML) {
                if (null != g.children) throw Error(p(60));
                if (!("object" === typeof g.dangerouslySetInnerHTML && "__html" in g.dangerouslySetInnerHTML)) throw Error(p(61));
            }
            if (null != g.style && "object" !== typeof g.style) throw Error(p(62));
        }
        g = d;
        e = this.makeStaticMarkup;
        L = 1 === this.stack.length;
        G = "<" + a.type;
        b: if (-1 === c.indexOf("-")) C = "string" === typeof g.is;
        else switch(c){
            case "annotation-xml":
            case "color-profile":
            case "font-face":
            case "font-face-src":
            case "font-face-uri":
            case "font-face-format":
            case "font-face-name":
            case "missing-glyph":
                C = !1;
                break b;
            default:
                C = !0;
        }
        for(w in g)if (Ya.call(g, w)) {
            var n = g[w];
            if (null != n) {
                if ("style" === w) {
                    var k = void 0, v = "", H = "";
                    for(k in n)if (n.hasOwnProperty(k)) {
                        var x = 0 === k.indexOf("--"), y = n[k];
                        if (null != y) {
                            if (x) var A = k;
                            else if (A = k, Wa.hasOwnProperty(A)) A = Wa[A];
                            else {
                                var cb = A.replace(Qa, "-$1").toLowerCase().replace(Ra, "-ms-");
                                A = Wa[A] = cb;
                            }
                            v += H + A + ":";
                            H = k;
                            x = null == y || "boolean" === typeof y || "" === y ? "" : x || "number" !== typeof y || 0 === y || Y.hasOwnProperty(H) && Y[H] ? ("" + y).trim() : y + "px";
                            v += x;
                            H = ";";
                        }
                    }
                    n = v || null;
                }
                k = null;
                C ? Za.hasOwnProperty(w) || (k = w, k = sa(k) && null != n ? k + '="' + (O(n) + '"') : "") : k = ya(w, n);
                k && (G += " " + k);
            }
        }
        e || L && (G += ' data-reactroot=""');
        var w = G;
        g = "";
        Na.hasOwnProperty(c) ? w += "/>" : (w += ">", g = "</" + a.type + ">");
        a: {
            e = d.dangerouslySetInnerHTML;
            if (null != e) {
                if (null != e.__html) {
                    e = e.__html;
                    break a;
                }
            } else if (e = d.children, "string" === typeof e || "number" === typeof e) {
                e = O(e);
                break a;
            }
            e = null;
        }
        null != e ? (d = [], Ta.hasOwnProperty(c) && "\n" === e.charAt(0) && (w += "\n"), w += e) : d = Z(d.children);
        a = a.type;
        f = null == f || "http://www.w3.org/1999/xhtml" === f ? Ma(a) : "http://www.w3.org/2000/svg" === f && "foreignObject" === a ? "http://www.w3.org/1999/xhtml" : f;
        this.stack.push({
            domNamespace: f,
            type: c,
            children: d,
            childIndex: 0,
            context: b,
            footer: g
        });
        this.previousWasTextNode = !1;
        return w;
    };
    return a;
}();
exports.renderToNodeStream = function() {
    throw Error(p(207));
};
exports.renderToStaticMarkup = function(a, b) {
    a = new bb(a, !0, b);
    try {
        return a.read(Infinity);
    } finally{
        a.destroy();
    }
};
exports.renderToStaticNodeStream = function() {
    throw Error(p(208));
};
exports.renderToString = function(a, b) {
    a = new bb(a, !1, b);
    try {
        return a.read(Infinity);
    } finally{
        a.destroy();
    }
};
exports.version = "17.0.2";

},{"2a760a3bc04cb618":"hdgcG","25c06765b630fbbf":"6uln9"}],"jrTqc":[function(require,module,exports) {
module.exports = require("f6ebeead1f98052").getBundleURL("kVLro") + require("219362ceb71db312").resolve("h5PEq");

},{"f6ebeead1f98052":"c7Tr5","219362ceb71db312":"fyJL2"}],"g6NDi":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _colors = require("../../../constants/colors");
const containerStyle = /*#__PURE__*/ (0, _css.css)("padding:32px;.type-selector{margin:16px 0;display:flex;flex-direction:row;align-items:center;.selector-label{font-family:Muli;font-size:18px;color:", (0, _colors.dark_grey_blue), ";margin-right:16px;flex:0;}.selector{margin:0;margin-left:auto;margin-right:0;width:100%;}.Select-value,.Select-option,.Select-control{height:48px;}}h4{font-family:Muli;font-size:18px;font-weight:normal;font-style:normal;font-stretch:normal;line-height:normal;letter-spacing:normal;color:#304562;margin-bottom:24px;}p{font-size:12px;font-weight:600;font-style:normal;font-stretch:normal;line-height:normal;letter-spacing:normal;color:#304562;}.update-button{width:130px;margin:0;}.reset-button{padding:0;border:none;margin-right:0;margin-left:auto;font-weight:normal;margin-top:0;margin-bottom:0;height:32px;img{margin-right:8px;}}.update-container{display:flex;align-items:center;p{margin-left:16px;}}.success-label{font-size:16px;font-weight:600;color:", (0, _colors.green_1), ";}.error-label{font-size:16px;font-weight:600;color:", (0, _colors.faded_red), ";}", "");
const ResponseBuilderContainer = (props)=>(0, _react.jsx)("div", {
        className: containerStyle
    }, props.children);
exports.default = ResponseBuilderContainer;

},{"@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","../../../constants/colors":"1p3OR","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4qcoH":[function(require,module,exports) {
module.exports = require("2492cc4feeff2d58").getBundleURL("kVLro") + require("9e46e1342c40dd2b").resolve("VKxqx");

},{"2492cc4feeff2d58":"c7Tr5","9e46e1342c40dd2b":"fyJL2"}],"3mfQB":[function(require,module,exports) {
module.exports = require("221de27a4b356262").getBundleURL("kVLro") + require("41e9cfab00a09e57").resolve("gN54l");

},{"221de27a4b356262":"c7Tr5","41e9cfab00a09e57":"fyJL2"}],"kyxnq":[function(require,module,exports) {
module.exports = require("d843f480305551ef").getBundleURL("kVLro") + require("fead1318f1528144").resolve("9sfMX");

},{"d843f480305551ef":"c7Tr5","fead1318f1528144":"fyJL2"}],"ePf5J":[function(require,module,exports) {
module.exports = require("2f47f69a7f554a1c").getBundleURL("kVLro") + require("cb0b376427410e9d").resolve("gvCDb");

},{"2f47f69a7f554a1c":"c7Tr5","cb0b376427410e9d":"fyJL2"}],"346EV":[function(require,module,exports) {
module.exports = require("b35bf0ada74250af").getBundleURL("kVLro") + require("834bb1dddabf013").resolve("gQ9rS");

},{"b35bf0ada74250af":"c7Tr5","834bb1dddabf013":"fyJL2"}],"76Rwl":[function(require,module,exports) {
module.exports = require("252e55edf5fc09ee").getBundleURL("kVLro") + require("61d8e1ab0ae7e521").resolve("7rSSa");

},{"252e55edf5fc09ee":"c7Tr5","61d8e1ab0ae7e521":"fyJL2"}],"1WB1n":[function(require,module,exports) {
module.exports = require("7144c2e7295d2727").getBundleURL("kVLro") + require("f1c3de04ff97428d").resolve("qAMDq");

},{"7144c2e7295d2727":"c7Tr5","f1c3de04ff97428d":"fyJL2"}],"8Nwsw":[function(require,module,exports) {
module.exports = require("643a3afc7d4114").getBundleURL("kVLro") + require("7940c158fed8627a").resolve("aXbsf");

},{"643a3afc7d4114":"c7Tr5","7940c158fed8627a":"fyJL2"}],"emEAy":[function(require,module,exports) {
module.exports = require("f2eb8334afc19e82").getBundleURL("kVLro") + require("858c05bd87ae7bcf").resolve("aFVs4");

},{"f2eb8334afc19e82":"c7Tr5","858c05bd87ae7bcf":"fyJL2"}],"53Szl":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _responseFieldCard = require("./ResponseFieldCard");
var _radioGroup = require("../../../components/forms/RadioGroup");
var _radioGroupDefault = parcelHelpers.interopDefault(_radioGroup);
var _formFieldsContainer = require("../../../components/structure/FormFieldsContainer");
var _formFieldsContainerDefault = parcelHelpers.interopDefault(_formFieldsContainer);
var _textAreaField = require("../../../components/forms/TextAreaField");
var _textAreaFieldDefault = parcelHelpers.interopDefault(_textAreaField);
var _lodash = require("lodash");
var _lodashDefault = parcelHelpers.interopDefault(_lodash);
var _button = require("../../../components/general/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _responseBuilderContainer = require("./ResponseBuilderContainer");
var _responseBuilderContainerDefault = parcelHelpers.interopDefault(_responseBuilderContainer);
const readoutIcon = require("769d774c311a2b4d");
const audioIcon = require("fcb9b10624f827ea");
const textIcon = require("c2e4f0ba0787ebb7");
const videoIcon = require("f2a0e5dfe1d20dbd");
const noVideoIcon = require("aa5642b3627162d9");
const imageIcon = require("9418d5095953420e");
const noImageIcon = require("ced4f2128304d047");
const resetIcon = require("e793ff5301af97d3");
const customIcon = require("faa7a54a84699d31");
class ChatResponseBuilder extends (0, _reactDefault.default).Component {
    componentWillMount() {
        this.setState({
            ...this.state,
            deviceTarget: this.props.targets[0],
            customResponse: this.getCurrentResponse(this.props.targets[0].id),
            validationErrors: null,
            successMessage: null,
            hasCustomChanges: false
        });
    }
    componentDidUpdate(prevProps) {
        if (prevProps.deviceType != this.props.deviceType) this.setState({
            ...this.state,
            deviceTarget: this.props.targets[0],
            customResponse: this.getCurrentResponse(this.props.targets[0].id)
        });
        else if (this.props.container.responses.length != prevProps.container.responses.length) this.setState({
            ...this.state,
            customResponse: this.getCurrentResponse(this.state.deviceTarget.id)
        });
    }
    getCurrentResponse(deviceTargetId) {
        if (!deviceTargetId) deviceTargetId = this.state.deviceTarget.id;
        const existingResponse = this.props.container.responses.find((r)=>r.deviceTargetId == deviceTargetId);
        if (existingResponse) return existingResponse;
        else return this.buildChatResponseFromDefault(deviceTargetId);
    }
    buildChatResponseFromDefault(deviceTargetId) {
        if (!deviceTargetId) deviceTargetId = this.state.deviceTarget.id;
        const target = this.props.targets.find((t)=>t.id == deviceTargetId);
        if (!target) return null;
        const template = target.responseTemplates.find((t)=>t.usesDisplayText);
        if (!template) return;
        return {
            responseTemplateTypeId: template.id,
            applicationId: this.props.applicationId,
            deviceTargetId: deviceTargetId
        };
    }
    removeTargetResponse(deviceTargetId) {
        const container = this.props.container;
        (0, _lodashDefault.default).remove(container.responses, (r)=>r.deviceTargetId == deviceTargetId);
        this.props.onChange(container);
    }
    handleChatTextOptionChange(option) {
        // if option is not readout
        const existingResponse = this.state.customResponse;
        if (option.value != "default") {
            if (existingResponse) {
                existingResponse.displayText = "";
                this.setState({
                    ...this.state,
                    customResponse: existingResponse,
                    hasCustomChanges: true
                });
            }
        } else {
            // if readout, remove response for targetvar existingResponse = this.state.customResponse;
            if (existingResponse) {
                existingResponse.displayText = null;
                this.setState({
                    ...this.state,
                    customResponse: existingResponse
                });
            }
            this.removeTargetResponse(this.state.deviceTarget.id);
        }
    }
    handleDisplayTextChange(e) {
        var existingResponse = this.state.customResponse;
        if (existingResponse) {
            existingResponse.displayText = e.target.value;
            this.setState({
                ...this.state,
                customResponse: existingResponse,
                hasCustomChanges: true
            });
        }
    }
    handleUpdateResponse() {
        const validationErrors = this.verifyCustomResponse();
        if (validationErrors) {
            this.setState({
                ...this.state,
                validationErrors: [
                    validationErrors
                ]
            });
            return;
        }
        const container = this.props.container;
        const existingResponse = container.responses.find((r)=>r.deviceTargetId == this.state.deviceTarget.id);
        if (existingResponse) {
            const index = container.responses.indexOf(existingResponse);
            container.responses[index] = this.state.customResponse;
        } else container.responses.push(this.state.customResponse);
        this.props.onChange(container);
        this.setState({
            ...this.state,
            validationErrors: null,
            successMessage: "Saved",
            hasCustomChanges: false
        });
        // hide save message after delay
        setTimeout(()=>{
            this.setState({
                ...this.state,
                successMessage: null
            });
        }, 3000);
    }
    verifyCustomResponse() {
        const response = this.state.customResponse;
        if (!response) return "Invalid Response";
        const template = this.state.deviceTarget.responseTemplates.find((t)=>t.id == this.state.customResponse.responseTemplateTypeId);
        if (!template) return "Invalid template";
        if (template.requiresVideo && !response.videoItemId) return "This template requires a video";
        if (template.requiresAudio && !response.audioItemId) return "This template requires an audio file";
        if (template.requiresForegroundImage && !response.foregroundImageItemId) return "This template requires a foreground image";
        if (template.requiresBackgroundImage && !response.backgroundImageItemId) return "This template requires a background image";
        return null;
    }
    render() {
        return (0, _react.jsx)((0, _responseBuilderContainerDefault.default), null, (0, _react.jsx)((0, _responseFieldCard.ResponseFieldCard), {
            title: "Display Text"
        }, (0, _react.jsx)((0, _formFieldsContainerDefault.default), null, (0, _react.jsx)((0, _radioGroupDefault.default), {
            options: [
                {
                    icon: textIcon,
                    value: "default",
                    label: "Same as Readout"
                },
                {
                    icon: textIcon,
                    value: "custom",
                    label: "Custom"
                }
            ],
            onChange: this.handleChatTextOptionChange.bind(this),
            value: this.state.customResponse && this.state.customResponse.displayText != null ? "custom" : "default"
        }), this.state.customResponse && this.state.customResponse.displayText != null ? (0, _react.jsx)((0, _textAreaFieldDefault.default), {
            name: "displayText",
            placeholder: "What should the display text be?",
            value: this.state.customResponse.displayText,
            onChange: this.handleDisplayTextChange.bind(this)
        }) : null, this.state.customResponse && this.state.customResponse.displayText != null ? (0, _react.jsx)("div", {
            className: "update-container"
        }, (0, _react.jsx)((0, _buttonDefault.default), {
            themes: [
                "primary-small"
            ],
            type: "button",
            onClick: this.handleUpdateResponse.bind(this),
            additionalClasses: "update-button",
            text: "Update"
        }), (0, _react.jsx)("p", {
            className: "error-label"
        }, this.state.validationErrors ? this.state.validationErrors.join(",") : null), (0, _react.jsx)("p", {
            className: "success-label"
        }, this.state.successMessage)) : null)));
    }
}
exports.default = ChatResponseBuilder;

},{"@emotion/react":"djZKr","react":"6uln9","./ResponseFieldCard":"hUTbn","../../../components/forms/RadioGroup":"eiGrn","../../../components/structure/FormFieldsContainer":"h3hzh","../../../components/forms/TextAreaField":"fE54C","lodash":"3hMBK","../../../components/general/Button":"6ymxN","./ResponseBuilderContainer":"g6NDi","769d774c311a2b4d":"4qcoH","fcb9b10624f827ea":"3mfQB","c2e4f0ba0787ebb7":"kyxnq","f2a0e5dfe1d20dbd":"ePf5J","aa5642b3627162d9":"346EV","9418d5095953420e":"76Rwl","ced4f2128304d047":"1WB1n","e793ff5301af97d3":"8Nwsw","faa7a54a84699d31":"emEAy","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"fE54C":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _base = require("@emotion/styled/base");
var _baseDefault = parcelHelpers.interopDefault(_base);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _colors = require("../../constants/colors");
var _fieldError = require("./FieldError");
var _fieldErrorDefault = parcelHelpers.interopDefault(_fieldError);
var _button = require("../general/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _iconTooltip = require("../general/IconTooltip");
var _iconTooltipDefault = parcelHelpers.interopDefault(_iconTooltip);
var _tooltipWrapper = require("../general/TooltipWrapper");
var _tooltipWrapperDefault = parcelHelpers.interopDefault(_tooltipWrapper);
var _currentApplicationContainer = require("../../hooks/CurrentApplicationContainer");
var _currentApplicationContainerDefault = parcelHelpers.interopDefault(_currentApplicationContainer);
var _applicationVariablesContainer = require("../../hooks/ApplicationVariablesContainer");
var _applicationVariablesContainerDefault = parcelHelpers.interopDefault(_applicationVariablesContainer);
var _confirmationDialog = require("../structure/ConfirmationDialog");
var _confirmationDialogDefault = parcelHelpers.interopDefault(_confirmationDialog);
var _responseVariableTestButton = require("../general/ResponseVariableTestButton");
var _responseVariableTestButtonDefault = parcelHelpers.interopDefault(_responseVariableTestButton);
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// Icons
const deleteIcon = require("ba750b60b4501f4d");
const editIcon = require("7fee731429587a2e");
// Types and Interfaces
const TextAreaField = (props)=>{
    // Container hooks
    const currentApplicationContainer = (0, _currentApplicationContainerDefault.default).useContainer();
    const appVariableContainer = (0, _applicationVariablesContainerDefault.default).useContainer();
    // State
    const [tooltip, setTooltip] = (0, _react1.useState)({
        text: "",
        x: 0,
        y: 0,
        visible: false,
        editable: false
    });
    const [unlinkConfirmation, setUnlinkConfirmation] = (0, _react1.useState)({
        isOpen: false,
        variableText: "",
        variableValue: "",
        variableName: ""
    });
    // Refs
    const contentEditableRef = (0, _react1.useRef)(null);
    const lastValueRef = (0, _react1.useRef)("");
    const tooltipTimeoutRef = (0, _react1.useRef)(null);
    const isHoveringTooltipRef = (0, _react1.useRef)(false);
    const isHoveringVariableRef = (0, _react1.useRef)(false);
    // Effects - moved to top
    (0, _react1.useEffect)(()=>{
        if (currentApplicationContainer.currentApplicationId) appVariableContainer.loadApplicationVariablesByApplicationId(currentApplicationContainer.currentApplicationId).catch((error)=>{
        // Error loading variables - silently fail
        });
    }, [
        currentApplicationContainer.currentApplicationId
    ]);
    (0, _react1.useEffect)(()=>{
        // Update content when value changes externally or when variables are loaded
        if (contentEditableRef.current && props.value !== lastValueRef.current) // Only update if the element doesn't have focus to avoid cursor jumping during typing
        {
            if (document.activeElement !== contentEditableRef.current) {
                contentEditableRef.current.innerHTML = generateHighlightedHTML(props.value || "");
                lastValueRef.current = props.value || "";
                attachTooltipEvents();
            }
        }
    }, [
        props.value,
        appVariableContainer.applicationVariables
    ]);
    (0, _react1.useEffect)(()=>{
        // Force re-render when variables are loaded to update highlighting
        if (contentEditableRef.current && lastValueRef.current && appVariableContainer.applicationVariables.length > 0) {
            // Save cursor position if element has focus
            const hasFocus = document.activeElement === contentEditableRef.current;
            const currentCursorPos = hasFocus ? saveCursorPosition() : 0;
            contentEditableRef.current.innerHTML = generateHighlightedHTML(lastValueRef.current);
            attachTooltipEvents();
            // Restore cursor if it had focus
            if (hasFocus) setTimeout(()=>{
                restoreCursorPosition(currentCursorPos);
            }, 0);
        }
    }, [
        appVariableContainer.applicationVariables
    ]);
    (0, _react1.useEffect)(()=>{
        // Initialize content on mount
        if (contentEditableRef.current && props.value) {
            contentEditableRef.current.innerHTML = generateHighlightedHTML(props.value);
            lastValueRef.current = props.value;
            attachTooltipEvents();
        }
        // Cleanup timeout on unmount
        return ()=>{
            if (tooltipTimeoutRef.current) clearTimeout(tooltipTimeoutRef.current);
        };
    }, []);
    // Computed values
    const showLabel = props.label !== undefined || props.canDelete || props.tooltip !== undefined || props.required;
    const showResetButton = props.defaultValue !== undefined && props.value !== props.defaultValue;
    // Event handlers
    const handleReset = ()=>{
        if (props.onReset) props.onReset();
        else if (props.onChange) {
            const syntheticEvent = {
                target: {
                    value: props.defaultValue,
                    name: props.name
                },
                currentTarget: {
                    value: props.defaultValue,
                    name: props.name
                }
            };
            props.onChange(syntheticEvent);
        }
    };
    // Utility functions for variable processing
    // Check if text contains variable references
    const hasVariableReferences = (text)=>{
        const regex = /\{\{(variable|prompt|constant)\.([A-Za-z0-9_]+)\}\}/;
        return regex.test(text);
    };
    // Recursively resolve nested variables to get the deepest value
    const resolveNestedVariables = (text, maxDepth = 10)=>{
        if (maxDepth <= 0) return text; // Prevent infinite recursion
        const constants = Array.isArray(appVariableContainer.applicationVariables) ? appVariableContainer.applicationVariables : [];
        const regex = /\{\{(variable|prompt|constant)\.([A-Za-z0-9_]+)\}\}/g;
        let hasVariables = false;
        const resolved = text.replace(regex, (match, prefix, variableName)=>{
            const variable = constants.find((v)=>v.name === variableName);
            if (variable && variable.value) {
                hasVariables = true;
                return variable.value;
            }
            return match; // Keep original if not found
        });
        // If we found and replaced variables, recursively resolve the result
        if (hasVariables && resolved !== text) return resolveNestedVariables(resolved, maxDepth - 1);
        return resolved;
    };
    // Resolve one level of variables (for unwrapping)
    const resolveOneLevel = (text)=>{
        const constants = Array.isArray(appVariableContainer.applicationVariables) ? appVariableContainer.applicationVariables : [];
        const regex = /\{\{(variable|prompt|constant)\.([A-Za-z0-9_]+)\}\}/g;
        return text.replace(regex, (match, prefix, variableName)=>{
            const variable = constants.find((v)=>v.name === variableName);
            if (variable && variable.value) return variable.value;
            return match; // Keep original if not found
        });
    };
    const findVariableReferences = (text)=>{
        const regex = /\{\{(variable|prompt|constant)\.([A-Za-z0-9_]+)\}\}/g;
        const references = [];
        let match;
        const constants = Array.isArray(appVariableContainer.applicationVariables) ? appVariableContainer.applicationVariables : [];
        while((match = regex.exec(text)) !== null){
            const prefix = match[1]; // "variable", "prompt", or "constant"
            const variableName = match[2];
            const appConstant = constants.find((v)=>v.name === variableName);
            references.push({
                start: match.index,
                end: match.index + match[0].length,
                text: match[0],
                prefix,
                variableName,
                variable: appConstant,
                isValid: !!appConstant
            });
        }
        return references;
    };
    // HTML/Text conversion utilities
    const generateHighlightedHTML = (text)=>{
        if (!text) return "";
        const references = findVariableReferences(text);
        // Helper function to escape HTML and preserve structure
        const escapeAndFormatText = (str)=>{
            return str.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/\n/g, "<br>");
        };
        if (references.length === 0) // No variables, just escape HTML and convert newlines
        return escapeAndFormatText(text);
        // Create a map of unique variable names to color indices
        const uniqueVarNames = new Set();
        references.forEach((ref)=>{
            if (ref.isValid) uniqueVarNames.add(ref.variableName);
        });
        const varNameToColorIndex = new Map();
        Array.from(uniqueVarNames).forEach((name, index)=>{
            varNameToColorIndex.set(name, index);
        });
        let html = "";
        let lastIndex = 0;
        references.forEach((ref)=>{
            // Add text before the variable
            if (ref.start > lastIndex) {
                const beforeText = text.substring(lastIndex, ref.start);
                html += escapeAndFormatText(beforeText);
            }
            // Get color index for this variable (alternate between 0 and 1)
            const colorIndex = ref.isValid ? varNameToColorIndex.get(ref.variableName) || 0 : 0;
            // Add the highlighted variable with color index (modulo 2 for alternating colors)
            const className = ref.isValid ? `highlighted-variable highlighted-variable-${colorIndex % 2}` : "invalid-variable";
            // For display: resolve all nested variables to show the deepest value
            const displayText = ref.variable ? resolveNestedVariables(ref.variable.value) : ref.text;
            // For tooltip: show the immediate next level (one level unwrapped)
            const nextLevelValue = ref.variable ? ref.variable.value : "";
            const tooltip = nextLevelValue.replace(/"/g, "&quot;");
            const escapedDisplayText = displayText.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/\n/g, "<br>");
            // Store the original variable text for editing functionality
            html += `<span class="${className}" data-tooltip="${tooltip}" data-variable-text="${ref.text.replace(/"/g, "&quot;")}">${escapedDisplayText}</span>`;
            lastIndex = ref.end;
        });
        // Add remaining text
        if (lastIndex < text.length) {
            const remainingText = text.substring(lastIndex);
            html += escapeAndFormatText(remainingText);
        }
        return html;
    };
    const htmlToText = (html)=>{
        if (!html) return "";
        // Create a temporary div to parse HTML properly
        const tempDiv = document.createElement("div");
        tempDiv.innerHTML = html;
        // Walk through all nodes and extract text content properly
        const extractText = (node, isFirstChild = false)=>{
            if (node.nodeType === Node.TEXT_NODE) return node.textContent || "";
            else if (node.nodeType === Node.ELEMENT_NODE) {
                const element = node;
                if (element.tagName === "BR") return "\n";
                else if (element.tagName === "DIV") {
                    // For DIV elements that contentEditable creates for new lines
                    // Check if the DIV is empty or contains only a BR
                    const hasOnlyBr = element.childNodes.length === 1 && element.firstChild?.nodeName === "BR";
                    if (hasOnlyBr || element.childNodes.length === 0) // Empty DIV or DIV with just BR - represents a newline
                    return isFirstChild ? "" : "\n";
                    const content = Array.from(element.childNodes).map((child, idx)=>extractText(child, idx === 0)).join("");
                    // Add newline before DIV content only if it's not the first element
                    return isFirstChild ? content : "\n" + content;
                } else if (element.tagName === "P") {
                    // For P elements, similar logic
                    const content = Array.from(element.childNodes).map((child, idx)=>extractText(child, idx === 0)).join("");
                    return isFirstChild ? content : "\n" + content;
                } else if (element.tagName === "SPAN") {
                    // For SPAN elements, check if it's a highlighted variable
                    // If so, return the original variable text (e.g., {{variable.name}})
                    // instead of the displayed resolved value
                    const variableText = element.getAttribute("data-variable-text");
                    if (variableText && (element.classList.contains("highlighted-variable") || element.classList.contains("invalid-variable"))) return variableText;
                    // For other spans, just extract content normally
                    return Array.from(element.childNodes).map((child, idx)=>extractText(child, idx === 0)).join("");
                } else // For other inline elements, just extract content
                return Array.from(element.childNodes).map((child, idx)=>extractText(child, idx === 0)).join("");
            }
            return "";
        };
        const result = Array.from(tempDiv.childNodes).map((node, idx)=>extractText(node, idx === 0)).join("");
        return result;
    };
    // Content change handler - just update value
    const handleContentChange = (e)=>{
        if (contentEditableRef.current && props.onChange) {
            const htmlContent = contentEditableRef.current.innerHTML;
            const textContent = htmlToText(htmlContent);
            // Update the lastValueRef immediately to prevent external updates
            lastValueRef.current = textContent;
            // Call onChange immediately for responsive UI
            const syntheticEvent = {
                target: {
                    value: textContent,
                    name: props.name
                },
                currentTarget: {
                    value: textContent,
                    name: props.name
                }
            };
            props.onChange(syntheticEvent);
        }
    };
    // Apply/update highlighting when field loses focus
    const handleBlur = (e)=>{
        if (contentEditableRef.current) {
            const currentHTML = contentEditableRef.current.innerHTML;
            const textContent = htmlToText(currentHTML);
            const newHTML = generateHighlightedHTML(textContent);
            // Verify that the round-trip conversion preserves the text exactly
            const verifyText = htmlToText(newHTML);
            // Only update if the text content is exactly the same (including newlines)
            if (verifyText === textContent && verifyText.length === textContent.length && (verifyText.match(/\n/g) || []).length === (textContent.match(/\n/g) || []).length) {
                // Update with highlighted content
                contentEditableRef.current.innerHTML = newHTML;
                lastValueRef.current = textContent;
                attachTooltipEvents();
            } else // If conversion would change content, just attach tooltips to existing HTML
            attachTooltipEvents();
        }
        // Call the original onBlur if provided
        if (props.onBlur) props.onBlur(e);
    };
    // Keep highlighting when gaining focus, just save cursor position
    const handleFocus = (e)=>{
        // Don't remove highlighting - just let the user type
        // The highlighting will be preserved until they blur
        // Call the original onFocus if provided
        if (props.onFocus) props.onFocus(e);
    };
    // Cursor position management utilities
    const saveCursorPosition = ()=>{
        if (!contentEditableRef.current) return 0;
        const selection = window.getSelection();
        if (!selection || selection.rangeCount === 0) return 0;
        const range = selection.getRangeAt(0);
        const preCaretRange = range.cloneRange();
        preCaretRange.selectNodeContents(contentEditableRef.current);
        preCaretRange.setEnd(range.startContainer, range.startOffset);
        // Create a temporary div to extract HTML from DocumentFragment
        const tempDiv = document.createElement("div");
        tempDiv.appendChild(preCaretRange.cloneContents());
        const textContent = htmlToText(tempDiv.innerHTML);
        return textContent.length;
    };
    const restoreCursorPosition = (position)=>{
        if (!contentEditableRef.current) return;
        const walker = document.createTreeWalker(contentEditableRef.current, NodeFilter.SHOW_TEXT | NodeFilter.SHOW_ELEMENT, {
            acceptNode: (node)=>{
                if (node.nodeType === Node.TEXT_NODE) return NodeFilter.FILTER_ACCEPT;
                if (node.nodeType === Node.ELEMENT_NODE && node.nodeName === "BR") return NodeFilter.FILTER_ACCEPT;
                return NodeFilter.FILTER_SKIP;
            }
        });
        let currentPosition = 0;
        let node;
        while(node = walker.nextNode()){
            if (node.nodeType === Node.TEXT_NODE) {
                const textLength = node.textContent?.length || 0;
                if (currentPosition + textLength >= position) {
                    const range = document.createRange();
                    const selection = window.getSelection();
                    try {
                        const offset = Math.min(Math.max(0, position - currentPosition), textLength);
                        range.setStart(node, offset);
                        range.collapse(true);
                        selection?.removeAllRanges();
                        selection?.addRange(range);
                        // Ensure the contentEditable div has focus
                        contentEditableRef.current?.focus();
                    } catch (e) {
                        // If we can't set the exact position, set it at the end
                        try {
                            const range = document.createRange();
                            const selection = window.getSelection();
                            range.selectNodeContents(contentEditableRef.current);
                            range.collapse(false);
                            selection?.removeAllRanges();
                            selection?.addRange(range);
                        } catch (fallbackError) {
                            // Final fallback - just focus the element
                            contentEditableRef.current?.focus();
                        }
                    }
                    return;
                }
                currentPosition += textLength;
            } else if (node.nodeName === "BR") {
                // <br> tags represent line breaks, count as 1 character
                if (currentPosition >= position) {
                    const range = document.createRange();
                    const selection = window.getSelection();
                    try {
                        range.setStartBefore(node);
                        range.collapse(true);
                        selection?.removeAllRanges();
                        selection?.addRange(range);
                        contentEditableRef.current?.focus();
                    } catch (e) {
                    // Could not restore cursor position at BR
                    }
                    return;
                }
                currentPosition += 1; // BR counts as one character (newline)
            }
        }
        // If position is beyond content, place cursor at end
        if (position >= currentPosition) try {
            const range = document.createRange();
            const selection = window.getSelection();
            range.selectNodeContents(contentEditableRef.current);
            range.collapse(false);
            selection?.removeAllRanges();
            selection?.addRange(range);
        } catch (e) {
            contentEditableRef.current?.focus();
        }
    };
    // Variable replacement functionality
    const replaceVariableWithValue = (variableText, variableValue)=>{
        if (!contentEditableRef.current || !props.onChange) return;
        // The value prop contains the actual stored text with variable syntax
        // We need to replace in that, not in the displayed HTML
        const currentText = props.value || "";
        // Save cursor position before replacing
        const currentCursorPos = saveCursorPosition();
        // Find the first occurrence of the variable pattern in the stored text
        const variableIndex = currentText.indexOf(variableText);
        if (variableIndex === -1) return; // Variable not found
        // Replace only the first occurrence with the actual value
        const newText = currentText.substring(0, variableIndex) + variableValue + currentText.substring(variableIndex + variableText.length);
        // Update the content
        const syntheticEvent = {
            target: {
                value: newText,
                name: props.name
            },
            currentTarget: {
                value: newText,
                name: props.name
            }
        };
        props.onChange(syntheticEvent);
        // Update the displayed content and restore cursor position
        setTimeout(()=>{
            if (contentEditableRef.current) {
                contentEditableRef.current.innerHTML = generateHighlightedHTML(newText);
                lastValueRef.current = newText;
                // Adjust cursor position accounting for the length difference
                const lengthDifference = variableValue.length - variableText.length;
                let newCursorPos = currentCursorPos;
                if (currentCursorPos > variableIndex) {
                    if (currentCursorPos <= variableIndex + variableText.length) // Cursor was inside the variable, place it at the end of the replacement
                    newCursorPos = variableIndex + variableValue.length;
                    else // Cursor was after the variable, adjust for the length difference
                    newCursorPos = currentCursorPos + lengthDifference;
                }
                restoreCursorPosition(newCursorPos);
                attachTooltipEvents();
            }
        }, 0);
        // Hide tooltip after replacing
        setTooltip((prev)=>({
                ...prev,
                visible: false,
                editable: false
            }));
    };
    // Show confirmation dialog before unlinking
    const handleUnlinkClick = (variableText, variableValue, variableName)=>{
        setUnlinkConfirmation({
            isOpen: true,
            variableText,
            variableValue,
            variableName
        });
        // Hide the tooltip when showing confirmation
        setTooltip((prev)=>({
                ...prev,
                visible: false,
                editable: false
            }));
    };
    // Handle confirmation dialog confirm
    const handleUnlinkConfirm = ()=>{
        if (unlinkConfirmation.variableText && unlinkConfirmation.variableValue) replaceVariableWithValue(unlinkConfirmation.variableText, unlinkConfirmation.variableValue);
        setUnlinkConfirmation({
            isOpen: false,
            variableText: "",
            variableValue: "",
            variableName: ""
        });
    };
    // Handle confirmation dialog cancel
    const handleUnlinkCancel = ()=>{
        setUnlinkConfirmation({
            isOpen: false,
            variableText: "",
            variableValue: "",
            variableName: ""
        });
    };
    // Tooltip event management
    const attachTooltipEvents = ()=>{
        if (!contentEditableRef.current) return;
        const highlightedElements = contentEditableRef.current.querySelectorAll(".highlighted-variable");
        highlightedElements.forEach((element)=>{
            const tooltipText = element.getAttribute("data-tooltip");
            if (tooltipText) {
                // Remove any existing event listeners to prevent duplicates
                const newElement = element.cloneNode(true);
                element.parentNode?.replaceChild(newElement, element);
                let timeoutId = null;
                const showTooltip = (e)=>{
                    isHoveringVariableRef.current = true;
                    if (tooltipTimeoutRef.current) {
                        clearTimeout(tooltipTimeoutRef.current);
                        tooltipTimeoutRef.current = null;
                    }
                    const rect = e.target.getBoundingClientRect();
                    const variableElement = e.target;
                    // Get the original variable text from data attribute
                    const variableText = variableElement.getAttribute("data-variable-text") || "";
                    // Extract variable name from the pattern {{prefix.variableName}}
                    const variableNameMatch = variableText.match(/\{\{(?:variable|prompt|constant)\.([A-Za-z0-9_]+)\}\}/);
                    const variableName = variableNameMatch ? variableNameMatch[1] : "";
                    setTooltip({
                        text: tooltipText,
                        x: rect.left + rect.width / 2,
                        // Center horizontally on the variable
                        y: rect.top + 2,
                        // Position just above the variable with minimal gap
                        visible: true,
                        editable: true,
                        variableText: variableText,
                        variableName: variableName
                    });
                };
                const hideTooltip = ()=>{
                    isHoveringVariableRef.current = false;
                    // Use a longer delay to allow moving to tooltip
                    const timeoutId = setTimeout(()=>{
                        // Only hide if not hovering over tooltip or variable
                        if (!isHoveringTooltipRef.current && !isHoveringVariableRef.current) setTooltip((prev)=>({
                                ...prev,
                                visible: false,
                                editable: false
                            }));
                    }, 200); // Longer delay for better UX
                    tooltipTimeoutRef.current = timeoutId;
                };
                newElement.addEventListener("mouseenter", showTooltip);
                newElement.addEventListener("mouseleave", hideTooltip);
            }
        });
    };
    // Render component
    return (0, _react.jsx)(OuterWrapper, {
        className: props.className,
        onClick: (e)=>{
            props.stopPropagation && e.stopPropagation();
        }
    }, showLabel && (0, _react.jsx)(LabelContainer, null, (0, _react.jsx)(LabelSection, null, props.label !== undefined && (0, _react.jsx)(Label, {
        htmlFor: props.name,
        className: props.labelClassName
    }, props.label), props.canDelete && (0, _react.jsx)((0, _buttonDefault.default), {
        additionalClasses: deleteIconStyle,
        type: "button",
        onClick: props.onDelete,
        themes: [
            "icon"
        ],
        icon: deleteIcon
    }), props.tooltip !== undefined && (0, _react.jsx)((0, _iconTooltipDefault.default), {
        text: props.tooltip,
        className: tooltipStyle,
        place: "top"
    }), props.required && (0, _react.jsx)((0, _tooltipWrapperDefault.default), {
        text: "Required field"
    }, (0, _react.jsx)(RequiredLabel, null, "*"))), props.showResponseVariableTest && (0, _react.jsx)((0, _responseVariableTestButtonDefault.default), null)), (0, _react.jsx)(FieldContainer, null, showResetButton && (0, _react.jsx)(ResetButton, {
        type: "button",
        onClick: handleReset
    }, "Reset to default"), props.icon !== undefined && (0, _react.jsx)("img", {
        src: props.icon
    }), (0, _react.jsx)(EditableTextField, {
        ref: contentEditableRef,
        contentEditable: !props.disabled,
        hasIcon: props.icon != null,
        onInput: handleContentChange,
        onBlur: handleBlur,
        onFocus: handleFocus,
        onKeyDown: (e)=>{
            if (e.key === "Enter") e.stopPropagation();
        },
        suppressContentEditableWarning: true,
        "data-placeholder": props.placeholder,
        style: {
            minHeight: `${(props.minRows || 1) * 1.5}em`
        }
    })), tooltip.visible && (0, _react.jsx)(TooltipPopup, {
        style: {
            left: Math.max(10, Math.min(tooltip.x, window.innerWidth - 420)),
            // Increased buffer for wider tooltip
            top: Math.max(10, tooltip.y),
            // Prevent going above viewport
            transform: "translateX(-50%) translateY(-100%)",
            position: "fixed"
        },
        onMouseEnter: ()=>{
            isHoveringTooltipRef.current = true;
            // Clear any pending hide timeout and keep tooltip visible
            if (tooltipTimeoutRef.current) {
                clearTimeout(tooltipTimeoutRef.current);
                tooltipTimeoutRef.current = null;
            }
            setTooltip((prev)=>({
                    ...prev,
                    visible: true
                }));
        },
        onMouseLeave: ()=>{
            isHoveringTooltipRef.current = false;
            // Use a longer delay and check both hover states
            const timeoutId = setTimeout(()=>{
                // Only hide if not hovering over tooltip or variable
                if (!isHoveringTooltipRef.current && !isHoveringVariableRef.current) setTooltip((prev)=>({
                        ...prev,
                        visible: false,
                        editable: false
                    }));
            }, 200);
            tooltipTimeoutRef.current = timeoutId;
        }
    }, (0, _react.jsx)(TooltipContentWrapper, null, (0, _react.jsx)(VariableName, null, tooltip.variableName), tooltip.editable && tooltip.variableText && (0, _react.jsx)((0, _reactDefault.default).Fragment, null, (0, _react.jsx)(EditButton, {
        type: "button",
        onClick: (e)=>{
            e.preventDefault();
            e.stopPropagation();
            handleUnlinkClick(tooltip.variableText, tooltip.text, tooltip.variableName || "");
        }
    }, (0, _react.jsx)(EditIcon, {
        src: editIcon,
        alt: "Edit"
    }), (0, _react.jsx)(EditButtonText, null, "Unlink & Edit")), (0, _react.jsx)(InfoText, null, "Unlinking keeps this content fixed. Linked content automatically receives the latest assistant improvements.")))), props.useForm && (0, _react.jsx)((0, _fieldErrorDefault.default), {
        name: props.name
    }), unlinkConfirmation.isOpen && (0, _react.jsx)((0, _confirmationDialogDefault.default), {
        title: "Unlink?",
        deleteText: "Unlink & Edit",
        warning: true,
        onConfirm: handleUnlinkConfirm,
        onClose: handleUnlinkCancel
    }, (0, _react.jsx)(ConfirmationContent, null, (0, _react.jsx)("p", null, "Are you sure you want to unlink ", (0, _react.jsx)("strong", null, unlinkConfirmation.variableName), "?"), (0, _react.jsx)("p", null, "This will replace the constant reference with its current value. The content will no longer update when the constant changes."))));
};
const OuterWrapper = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e9pd9d116"
})({
    name: "1qngu5x",
    styles: "margin-bottom:24px;&.tight{margin-bottom:8px;label{margin:8px 16px 0 16px;}}"
});
const ConfirmationContent = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e9pd9d115"
})("padding:24px;font-family:Muli;font-size:14px;line-height:1.6;color:", (0, _colors.dark_grey_blue), ";p{margin:0 0 16px 0;}p:last-child{margin-bottom:0;}strong{font-weight:600;color:", (0, _colors.color_colors_ocean), ";}");
const LabelContainer = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e9pd9d114"
})({
    name: "1x17g94",
    styles: "display:flex;align-items:center;width:100%"
});
const LabelSection = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e9pd9d113"
})({
    name: "y37upr",
    styles: "display:flex;align-items:center;flex:1"
});
const Label = /*#__PURE__*/ (0, _baseDefault.default)("label", {
    target: "e9pd9d112"
})({
    name: "1m6o4l9",
    styles: "font-family:Muli;font-size:14px;font-weight:600;text-align:left;margin:0 16px"
});
const RequiredLabel = /*#__PURE__*/ (0, _baseDefault.default)("span", {
    target: "e9pd9d111"
})("margin-right:0;margin-left:auto;margin-top:14px;margin-bottom:-20px;font-family:Muli;font-size:24px;color:", (0, _colors.faded_red), ";");
const FieldContainer = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e9pd9d110"
})("display:flex;align-items:center;width:100%;border-radius:5px;border:solid 1px ", (0, _colors.silver_two), ";background:white;margin-top:8px;position:relative;img{margin:16px;}");
const ResetButton = /*#__PURE__*/ (0, _baseDefault.default)("button", {
    target: "e9pd9d19"
})("position:absolute;top:8px;right:8px;background:none;border:none;color:", (0, _colors.color_colors_ocean), ";font-family:Muli;font-size:12px;cursor:pointer;z-index:1;padding:4px 8px;border-radius:4px;text-decoration:none;&:hover{background-color:", (0, _colors.color_variants_ocean_light_1), ";}");
const EditableTextField = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e9pd9d18"
})("color:", (0, _colors.dark_grey_blue), ";font-family:Muli;text-align:left;width:100%;border:none;padding:8px 16px;font-size:14px;margin:12px 0;border-left:", (props)=>props.hasIcon ? `1px solid ${0, _colors.silver_two}` : "none", ";background:white;outline:none;min-height:1.5em;white-space:pre-wrap;word-wrap:break-word;overflow-y:auto;max-height:300px;line-height:1.4;&:empty::before{content:attr(data-placeholder);color:", (0, _colors.cool_grey), ";font-style:italic;}.highlighted-variable{border-radius:3px;padding:1px 2px;cursor:pointer;white-space:pre-wrap;word-wrap:break-word;color:", (0, _colors.text_blue), ";}.highlighted-variable-0{background-color:", (0, _colors.color_variants_ocean_light_2), ";}.highlighted-variable-1{background-color:", (0, _colors.color_variants_ocean_xlight), ";}.invalid-variable{background-color:", (0, _colors.color_variants_red_2), ";color:", (0, _colors.color_colors_decline), ";border-radius:3px;padding:1px 2px;cursor:pointer;text-decoration:underline wavy ", (0, _colors.color_colors_decline), ";white-space:pre-wrap;word-wrap:break-word;}br{display:block;margin:0;line-height:1.4;}");
const TooltipPopup = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e9pd9d17"
})("position:fixed;background:", (0, _colors.color_shades_darkest), ";color:white;padding:8px;border-radius:6px;font-size:16px;font-family:Muli;z-index:1000;pointer-events:auto;box-shadow:0 4px 12px rgba(0, 0, 0, 0.3);&::after{content:'';position:absolute;top:100%;left:50%;transform:translateX(-50%);border:6px solid transparent;border-top-color:", (0, _colors.color_shades_darkest), ";}");
const TooltipContentWrapper = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e9pd9d16"
})({
    name: "ify09q",
    styles: "display:flex;flex-direction:column;gap:8px;align-items:center"
});
const VariableName = /*#__PURE__*/ (0, _baseDefault.default)("span", {
    target: "e9pd9d15"
})({
    name: "16z5lgo",
    styles: "font-family:'Courier New',monospace;font-size:13px;font-weight:600;padding:2px 6px;background:rgba(255, 255, 255, 0.15);border-radius:3px"
});
const EditButton = /*#__PURE__*/ (0, _baseDefault.default)("button", {
    target: "e9pd9d14"
})({
    name: "19hps0y",
    styles: "background:none;margin-top:4px;border:none;color:white;cursor:pointer;padding:8px 12px;border-radius:6px;font-size:14px;display:flex;align-items:center;justify-content:center;gap:8px;min-width:auto;width:auto;height:32px;flex-shrink:0;transition:background-color 0.2s;white-space:nowrap;&:hover{background-color:rgba(255, 255, 255, 0.2);}&:active{background-color:rgba(255, 255, 255, 0.3);}"
});
const EditIcon = /*#__PURE__*/ (0, _baseDefault.default)("img", {
    target: "e9pd9d13"
})({
    name: "1hygxsy",
    styles: "width:16px;height:16px;filter:brightness(0) invert(1)"
});
const EditButtonText = /*#__PURE__*/ (0, _baseDefault.default)("span", {
    target: "e9pd9d12"
})({
    name: "1fy4vzz",
    styles: "font-family:Muli;font-size:13px;font-weight:600"
});
const InfoText = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e9pd9d11"
})({
    name: "1jtl06o",
    styles: "font-family:Muli;font-size:11px;color:rgba(255, 255, 255, 0.85);text-align:center;line-height:1.4;max-width:280px"
});
const InlineVariableName = /*#__PURE__*/ (0, _baseDefault.default)("span", {
    target: "e9pd9d10"
})({
    name: "16z5lgo",
    styles: "font-family:'Courier New',monospace;font-size:13px;font-weight:600;padding:2px 6px;background:rgba(255, 255, 255, 0.15);border-radius:3px"
});
const deleteIconStyle = /*#__PURE__*/ (0, _css.css)({
    name: "1if73ow",
    styles: "height:14px;margin:0;margin-top:24px;margin-bottom:0;img{height:14px;}"
});
const tooltipStyle = /*#__PURE__*/ (0, _css.css)({
    name: "1q4vxyr",
    styles: "margin-left:8px"
});
exports.default = TextAreaField;

},{"@emotion/styled/base":"lSuFu","@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","../../constants/colors":"1p3OR","./FieldError":"fDxhz","../general/Button":"6ymxN","../general/IconTooltip":"3FODC","../general/TooltipWrapper":"53pWd","../../hooks/CurrentApplicationContainer":"4hT7h","../../hooks/ApplicationVariablesContainer":"65mmm","../structure/ConfirmationDialog":"kx7yK","../general/ResponseVariableTestButton":"4kMKl","ba750b60b4501f4d":"7eyKJ","7fee731429587a2e":"6jaPP","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4hT7h":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _unstatedNext = require("unstated-next");
function useCurrentApplicationContainer() {
    const [currentApplicationId, setCurrentApplicationId] = (0, _react.useState)(null);
    const setApplicationId = (applicationId)=>{
        setCurrentApplicationId(applicationId);
    };
    const clearApplicationId = ()=>{
        setCurrentApplicationId(null);
    };
    return {
        currentApplicationId,
        setApplicationId,
        clearApplicationId
    };
}
const CurrentApplicationContainer = (0, _unstatedNext.createContainer)(useCurrentApplicationContainer);
exports.default = CurrentApplicationContainer;

},{"react":"6uln9","unstated-next":"61zE5","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"65mmm":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _unstatedNext = require("unstated-next");
var _api = require("../api");
function useApplicationVariablesContainer() {
    const [applicationVariables, setApplicationVariables] = (0, _react.useState)([]);
    const [selectedApplicationVariable, setSelectedApplicationVariable] = (0, _react.useState)({});
    const [errors, setErrors] = (0, _react.useState)([]);
    const [currentAppId, setCurrentAppId] = (0, _react.useState)(null);
    const loadApplicationVariablesByApplicationId = async (applicationId)=>{
        try {
            const result = await _api.getApplicationVariablesByApplicationId(applicationId);
            if (result.resultType == "Ok") setApplicationVariables(result.data);
            else setErrors(result.errors);
            return result;
        } catch (e) {
            setErrors(e);
        }
    };
    const loadApplicationVariableById = async (applicationVariableId)=>{
        try {
            const result = await _api.getApplicationVariableById(applicationVariableId);
            if (result.resultType == "Ok") setSelectedApplicationVariable(result.data);
            else setErrors(result.errors);
            return result;
        } catch (e) {
            setErrors(e);
        }
    };
    const createApplicationVariable = async (model)=>{
        try {
            const result = await _api.createApplicationVariable(model);
            if (result.resultType == "Ok") setApplicationVariables([
                ...applicationVariables,
                result.data
            ]);
            else setErrors(result.errors);
            return result;
        } catch (e) {
            setErrors(e);
        }
    };
    const updateApplicationVariable = async (applicationVariableId, model)=>{
        try {
            const result = await _api.updateApplicationVariable(applicationVariableId, model);
            if (result.resultType == "Ok") {
                const updatedVariables = applicationVariables.map((variable)=>variable.id === applicationVariableId ? result.data : variable);
                setApplicationVariables(updatedVariables);
                setSelectedApplicationVariable(result.data);
            } else setErrors(result.errors);
            return result;
        } catch (e) {
            setErrors(e);
        }
    };
    const deleteApplicationVariable = async (applicationVariableId)=>{
        try {
            const result = await _api.deleteApplicationVariable(applicationVariableId);
            if (result.resultType == "Ok") {
                const filteredVariables = applicationVariables.filter((variable)=>variable.id !== applicationVariableId);
                setApplicationVariables(filteredVariables);
            } else setErrors(result.errors);
            return result;
        } catch (e) {
            setErrors(e);
        }
    };
    const clearErrors = ()=>{
        setErrors([]);
    };
    return {
        applicationVariables,
        setApplicationVariables,
        selectedApplicationVariable,
        setSelectedApplicationVariable,
        errors,
        setErrors,
        loadApplicationVariablesByApplicationId,
        loadApplicationVariableById,
        createApplicationVariable,
        updateApplicationVariable,
        deleteApplicationVariable,
        clearErrors,
        setCurrentAppId
    };
}
const ApplicationVariablesContainer = (0, _unstatedNext.createContainer)(useApplicationVariablesContainer);
exports.default = ApplicationVariablesContainer;

},{"react":"6uln9","unstated-next":"61zE5","../api":"loxM6","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"kx7yK":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _base = require("@emotion/styled/base");
var _baseDefault = parcelHelpers.interopDefault(_base);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _fullScreenLayout = require("../../scenes/fullScreenLayout");
var _fullScreenLayoutDefault = parcelHelpers.interopDefault(_fullScreenLayout);
var _pageContainer = require("./PageContainer");
var _pageContainerDefault = parcelHelpers.interopDefault(_pageContainer);
var _button = require("../general/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _footerBar = require("./FooterBar");
var _footerBarDefault = parcelHelpers.interopDefault(_footerBar);
var _modalHeader = require("../general/ModalHeader");
var _modalHeaderDefault = parcelHelpers.interopDefault(_modalHeader);
var _breakpoints = require("../../constants/breakpoints");
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const ConfirmationDialog = (props)=>{
    const containerRef = (0, _react1.useRef)(null);
    (0, _react1.useEffect)(()=>{
        containerRef.current.focus();
    }, []);
    const handleKeyUp = (e)=>{
        e.stopPropagation();
        if (props.isLoading || props.disabled) return;
        if (e.key === "Escape") props.onClose();
    };
    return (0, _react.jsx)("div", {
        ref: containerRef,
        tabIndex: -1,
        onKeyUp: (e)=>handleKeyUp(e)
    }, (0, _react.jsx)("div", {
        className: innerLayoutStyle
    }, (0, _react.jsx)("div", {
        className: innerWrapperStyle
    }, (0, _react.jsx)((0, _fullScreenLayoutDefault.default), null, (0, _react.jsx)((0, _pageContainerDefault.default), {
        fill: true,
        withFooter: true
    }, (0, _react.jsx)((0, _modalHeaderDefault.default), {
        title: props.title,
        onClose: props.onClose
    }), props.children, (0, _react.jsx)((0, _footerBarDefault.default), null, (0, _react.jsx)(StyledSubmitButton, {
        loading: props.isLoading,
        disabled: props.isLoading || props.disabled,
        themes: [
            props.warning ? "primary" : "destructive"
        ],
        text: props.deleteText,
        type: "button",
        onClick: props.onConfirm
    }), (0, _react.jsx)(StyledButton, {
        disabled: props.isLoading,
        themes: [
            "white",
            "secondary"
        ],
        text: "Cancel",
        type: "button",
        onClick: props.onClose
    })))))), (0, _react.jsx)("div", {
        className: layoutStyle,
        onClick: props.isLoading ? null : props.onClose
    }));
};
const StyledSubmitButton = /*#__PURE__*/ (0, _baseDefault.default)((0, _buttonDefault.default), {
    target: "egq51zj2"
})((0, _breakpoints.breakpoint_small), "{width:100px;span{font-size:12px;}}margin-right:auto;");
const StyledButton = /*#__PURE__*/ (0, _baseDefault.default)((0, _buttonDefault.default), {
    target: "egq51zj1"
})((0, _breakpoints.breakpoint_small), "{width:100px;span{font-size:12px;}}");
const layoutStyle = /*#__PURE__*/ (0, _css.css)({
    name: "zk6eko",
    styles: "overflow-x:visible;background:rgba(44,61,82, 0.7);padding:65px 115px;z-index:1003;position:fixed;width:100%;height:100%;top:0;left:0"
});
const innerLayoutStyle = /*#__PURE__*/ (0, _css.css)("border-radius:20px;border:12px solid rgba(44,61,82, 0.8);display:block;width:580px;height:520px;max-height:calc(100vh - 210px);position:fixed;z-index:1004;left:50%;top:50%;transform:translate(-50%, -50%);background:white;overflow:hidden;", (0, _breakpoints.breakpoint_small), "{width:90%;}", "");
const innerWrapperStyle = /*#__PURE__*/ (0, _css.css)({
    name: "1d508z5",
    styles: "border-radius:20px;button:disabled{background:linear-gradient(258deg, #c9c9c9, #a8a8a8 63%, #929292);cursor:not-allowed;}"
});
const SubmitButton = /*#__PURE__*/ (0, _baseDefault.default)((0, _buttonDefault.default), {
    target: "egq51zj0"
})({
    name: "1tx1l5v",
    styles: "margin-right:auto"
});
exports.default = ConfirmationDialog;

},{"@emotion/styled/base":"lSuFu","@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","../../scenes/fullScreenLayout":"5mVdG","./PageContainer":"hc1r8","../general/Button":"6ymxN","./FooterBar":"bibRL","../general/ModalHeader":"aUACx","../../constants/breakpoints":"2F01A","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"aUACx":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _colors = require("../../constants/colors");
var _button = require("./Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _breakpoints = require("../../constants/breakpoints");
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const closeIcon = require("86fc98e233838fae");
const ModalHeader = (props)=>(0, _react.jsx)("div", {
        className: props.className ? `${props.className} ${containerStyle}` : containerStyle
    }, (0, _react.jsx)("h2", null, props.title), (0, _react.jsx)("div", {
        className: rightSectionStyle
    }, props.rightText && (0, _react.jsx)("span", {
        className: props.rightTextClassName ? props.rightTextClassName : rightTextStyle
    }, props.rightText), (0, _react.jsx)((0, _buttonDefault.default), {
        themes: [
            "end-tight",
            "icon"
        ],
        icon: closeIcon,
        onClick: props.onClose
    })));
const containerStyle = /*#__PURE__*/ (0, _css.css)("display:flex;align-items:center;height:80px;border-bottom:1px solid ", (0, _colors.color_shades_dark), ";h2{font-style:normal;font-weight:normal;font-size:24px;line-height:32px;margin:0 32px;}button{border-left:1px solid ", (0, _colors.color_shades_dark), ";border-radius:0;padding:0 32px;height:48px;img{width:24px;height:24px;}", (0, _breakpoints.breakpoint_small), "{padding:0 16px;}}", (0, _breakpoints.breakpoint_small), "{h2{font-size:16px;margin:0 16px 0 32px;}p{font-size:14px;}}", "");
const rightSectionStyle = /*#__PURE__*/ (0, _css.css)({
    name: "mvkby9",
    styles: "display:flex;align-items:center;margin-left:auto"
});
const rightTextStyle = /*#__PURE__*/ (0, _css.css)("font-size:14px;color:", (0, _colors.color_shades_dark), ";margin-right:16px;", "");
exports.default = ModalHeader;

},{"@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","../../constants/colors":"1p3OR","./Button":"6ymxN","../../constants/breakpoints":"2F01A","86fc98e233838fae":"93VwA","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6jaPP":[function(require,module,exports) {
module.exports = require("496b156d080ca7f6").getBundleURL("kVLro") + require("c7fa9ce3151dd7b5").resolve("8sHiH");

},{"496b156d080ca7f6":"c7Tr5","c7fa9ce3151dd7b5":"fyJL2"}],"apbrL":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _colors = require("../../../constants/colors");
var _horizontalSeparator = require("../../../components/structure/HorizontalSeparator");
var _horizontalSeparatorDefault = parcelHelpers.interopDefault(_horizontalSeparator);
var _textField = require("../../../components/forms/TextField");
var _textFieldDefault = parcelHelpers.interopDefault(_textField);
var _textAreaField = require("../../../components/forms/TextAreaField");
var _textAreaFieldDefault = parcelHelpers.interopDefault(_textAreaField);
var _button = require("../../../components/general/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _pageContainer = require("../../../components/structure/PageContainer");
var _pageContainerDefault = parcelHelpers.interopDefault(_pageContainer);
var _headerProgressBar = require("../../../components/general/HeaderProgressBar");
var _headerProgressBarDefault = parcelHelpers.interopDefault(_headerProgressBar);
var _uploadFileSize = require("../../../constants/UploadFileSize");
const removeIcon = require("eaf72d5442399fb3");
const attachIcon = require("b82969b064b1a137");
const audioIcon = require("16f15c460a9b57d9");
const videoIcon = require("e1f12e7e64f1b2eb");
const imageIcon = require("1cf226ec480930df");
class FileStageCard extends (0, _reactDefault.default).Component {
    getMediaTypeFromFile(fileName) {
        if (!fileName) return null;
        var parts = fileName.split(".");
        var extension = parts[parts.length - 1];
        switch(extension){
            case "mp3":
                return "Audio File";
            case "mp4":
                return "Video File";
            case "png":
            case "jpg":
            case "jpeg":
            default:
                return "Image File";
        }
    }
    getFileIcon() {
        switch(this.getMediaTypeFromFile(this.props.file.name)){
            case "Audio File":
                return audioIcon;
            case "Video File":
                return videoIcon;
            case "Image File":
                return imageIcon;
        }
        return imageIcon;
    }
    onFileNameChange(e) {
        this.props.onChange(this.props.file, e.target.value, this.props.file.caption);
    }
    onCaptionChange(e) {
        this.props.onChange(this.props.file, this.props.file.name, e.target.value);
    }
    render() {
        return (0, _react.jsx)("div", {
            className: containerStyle,
            id: this.props.id
        }, (0, _react.jsx)("div", {
            className: "card-header"
        }, this.props.file.isUploading ? (0, _react.jsx)((0, _headerProgressBarDefault.default), {
            percent: this.props.file.progress
        }) : null, (0, _react.jsx)("div", {
            className: "header-container"
        }, (0, _react.jsx)("img", {
            className: "file-icon",
            src: this.getFileIcon()
        }), (0, _react.jsx)("div", null, (0, _react.jsx)("p", {
            className: "file-type-label"
        }, this.getMediaTypeFromFile(this.props.file.file.name)), (0, _react.jsx)("p", {
            className: "file-size-label"
        }, `${(this.props.file.file.size * (0, _uploadFileSize.BytesToMegabytesMultiplier)).toFixed(2)}MB`)), this.props.file.isUploading ? (0, _react.jsx)("div", {
            className: "end"
        }, (0, _react.jsx)("span", {
            className: "progress-label"
        }, `${this.props.file.progress}%`)) : (0, _react.jsx)("div", {
            className: "end"
        }, (0, _react.jsx)((0, _buttonDefault.default), {
            themes: [
                "icon",
                "hollow",
                "flat"
            ],
            type: "button",
            rightIcon: removeIcon,
            onClick: ()=>this.props.onRemove(this.props.file)
        }), (0, _react.jsx)("div", {
            className: "separator"
        }), (0, _react.jsx)((0, _buttonDefault.default), {
            themes: [
                "hollow",
                "flat"
            ],
            type: "button",
            icon: attachIcon,
            text: "Upload & Attach",
            onClick: ()=>this.props.onUpload(this.props.file)
        })))), (0, _react.jsx)((0, _horizontalSeparatorDefault.default), null), (0, _react.jsx)((0, _pageContainerDefault.default), null, (0, _react.jsx)((0, _textFieldDefault.default), {
            autoFocus: true,
            name: "name",
            label: "Filename",
            placeholder: "A name for your file",
            value: this.props.file.name,
            onChange: this.onFileNameChange.bind(this)
        }), this.getMediaTypeFromFile(this.props.file.name) == "Image File" ? (0, _react.jsx)((0, _textAreaFieldDefault.default), {
            name: "caption",
            label: "Include a caption",
            placeholder: "A caption for your file",
            value: this.props.file.caption,
            onChange: this.onCaptionChange.bind(this)
        }) : null));
    }
}
const containerStyle = /*#__PURE__*/ (0, _css.css)("overflow:hidden;margin:16px 0;border-radius:10px;border:1px solid ", (0, _colors.cool_grey), ";.card-header{position:relative;height:56px;overflow:hidden;display:flex;.header-container{display:flex;flex-direction:row;padding:0 24px;align-items:center;height:56px;position:absolute;flex:1;right:0;left:0;.end{margin-right:0;margin-left:auto;display:flex;flex-direction:row;align-items:center;}.separator{height:24px;width:1px;background:", (0, _colors.silver), ";margin-right:16px;}.file-icon{margin-right:16px;}.file-type-label{text-transform:uppercase;font-family:Muli;font-size:14px;font-weight:300;font-style:normal;font-stretch:normal;line-height:normal;letter-spacing:0.5px;color:", (0, _colors.dark_grey_blue), ";}.file-size-label{font-family:Muli;font-size:12px;font-weight:normal;font-style:normal;font-stretch:normal;line-height:normal;color:", (0, _colors.cool_grey), ";}}.progress-label{font-size:48px;color:", (0, _colors.faded_blue_2), ";}}", "");
exports.default = FileStageCard;

},{"@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","../../../constants/colors":"1p3OR","../../../components/structure/HorizontalSeparator":"Pw3HQ","../../../components/forms/TextField":"7a7bh","../../../components/forms/TextAreaField":"fE54C","../../../components/general/Button":"6ymxN","../../../components/structure/PageContainer":"hc1r8","../../../components/general/HeaderProgressBar":"b3TFE","../../../constants/UploadFileSize":"5inYb","eaf72d5442399fb3":"gol67","b82969b064b1a137":"iT0Wx","16f15c460a9b57d9":"lcYWS","e1f12e7e64f1b2eb":"jbgUU","1cf226ec480930df":"7XJJS","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"b3TFE":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _colors = require("../../constants/colors");
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const outerStyle = /*#__PURE__*/ (0, _css.css)({
    name: "171cz1j",
    styles: "height:56px;width:100%;background:transparent"
});
const innerStyle = /*#__PURE__*/ (0, _css.css)("height:56px;background:", (0, _colors.faded_blue_3), ";", "");
const wrapperStyle = /*#__PURE__*/ (0, _css.css)({
    name: "1duu0ib",
    styles: "width:100%;position:absolute"
});
const HeaderProgressBar = (props)=>(0, _react.jsx)("div", {
        className: wrapperStyle
    }, props.percent === 0 ? null : (0, _react.jsx)("div", {
        className: outerStyle
    }, (0, _react.jsx)("div", {
        className: innerStyle,
        style: {
            width: `${props.percent}%`
        }
    })));
exports.default = HeaderProgressBar;

},{"@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","../../constants/colors":"1p3OR","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"gol67":[function(require,module,exports) {
module.exports = require("34d7a701489ee5b6").getBundleURL("kVLro") + require("1a7eaac33906aed7").resolve("7DISG");

},{"34d7a701489ee5b6":"c7Tr5","1a7eaac33906aed7":"fyJL2"}],"iT0Wx":[function(require,module,exports) {
module.exports = require("fb5cdd75fa417c33").getBundleURL("kVLro") + require("beb237b1821bb3f6").resolve("dNP8Y");

},{"fb5cdd75fa417c33":"c7Tr5","beb237b1821bb3f6":"fyJL2"}],"2Ku9A":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ResponseDetailContainer", ()=>ResponseDetailContainer);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _colors = require("../../../constants/colors");
const containerStyle = /*#__PURE__*/ (0, _css.css)("border:1px solid ", (0, _colors.cool_grey), ";background:", (0, _colors.pale_grey), ";", "");
const ResponseDetailContainer = (props)=>(0, _react.jsx)("div", {
        className: containerStyle
    }, props.children);

},{"@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","../../../constants/colors":"1p3OR","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"bM9LM":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _lodash = require("lodash");
var _lodashDefault = parcelHelpers.interopDefault(_lodash);
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _iconSelectField = require("../../../components/forms/IconSelectField");
var _iconSelectFieldDefault = parcelHelpers.interopDefault(_iconSelectField);
var _radioGroup = require("../../../components/forms/RadioGroup");
var _radioGroupDefault = parcelHelpers.interopDefault(_radioGroup);
var _textAreaField = require("../../../components/forms/TextAreaField");
var _textAreaFieldDefault = parcelHelpers.interopDefault(_textAreaField);
var _button = require("../../../components/general/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _formFieldsContainer = require("../../../components/structure/FormFieldsContainer");
var _formFieldsContainerDefault = parcelHelpers.interopDefault(_formFieldsContainer);
var _compatabilityViewer = require("./CompatabilityViewer");
var _compatabilityViewerDefault = parcelHelpers.interopDefault(_compatabilityViewer);
var _responseFieldCard = require("./ResponseFieldCard");
var _responseTemplateSelector = require("./ResponseTemplateSelector");
var _responseTemplateSelectorDefault = parcelHelpers.interopDefault(_responseTemplateSelector);
var _responseBuilderContainer = require("./ResponseBuilderContainer");
var _responseBuilderContainerDefault = parcelHelpers.interopDefault(_responseBuilderContainer);
var _ssmlField = require("../../../components/forms/SsmlField/SsmlField");
var _ssmlFieldDefault = parcelHelpers.interopDefault(_ssmlField);
const readoutIcon = require("2c7a647f3590cb63");
const audioIcon = require("eb1f9ac353fb3edd");
const textIcon = require("3f119c4a4f227163");
const videoIcon = require("b31309378b8f6ef2");
const noVideoIcon = require("9bb2b9e966e0936d");
const imageIcon = require("38731cc7fa936ae2");
const noImageIcon = require("cc7c496b479531e5");
const resetIcon = require("e7469a292ce94ce4");
const customIcon = require("d270f9b8ed694782");
class ScreenResponseBuilder extends (0, _reactDefault.default).Component {
    componentWillMount() {
        this.setState({
            ...this.state,
            deviceTarget: this.props.targets[0],
            customResponse: this.getCurrentResponse(this.props.targets[0].id),
            validationErrors: null,
            successMessage: null,
            hasCustomChanges: false
        });
    }
    componentDidUpdate(prevProps) {
        if (prevProps.deviceType != this.props.deviceType) this.setState({
            ...this.state,
            deviceTarget: this.props.targets[0],
            customResponse: this.getCurrentResponse(this.props.targets[0].id)
        });
        else if (this.props.imageItem != prevProps.imageItem || this.props.backgroundImageItem != prevProps.backgroundImageItem || this.props.audioItem != prevProps.audioItem || this.props.videoItem != prevProps.videoItem || this.props.container.responses.length != prevProps.container.responses.length) this.setState({
            ...this.state,
            customResponse: this.getCurrentResponse(this.state.deviceTarget.id)
        });
    }
    getCurrentResponse(deviceTargetId) {
        if (!deviceTargetId) deviceTargetId = this.state.deviceTarget.id;
        const existingResponse = this.props.container.responses.find((r)=>r.deviceTargetId == deviceTargetId);
        if (existingResponse) return existingResponse;
        else return this.buildScreenResponseFromDefault(deviceTargetId);
    }
    buildScreenResponseFromDefault(deviceTargetId) {
        if (!deviceTargetId) deviceTargetId = this.state.deviceTarget.id;
        const target = this.props.targets.find((t)=>t.id == deviceTargetId);
        if (!target) return null;
        // if video and target supports, set that template
        if (this.props.videoItem && target.supportsVideo) {
            const template = target.responseTemplates.find((t)=>t.usesVideo);
            if (template) return {
                videoItemId: this.props.videoItem.id,
                responseTemplateTypeId: template.id,
                applicationId: this.props.applicationId,
                deviceTargetId: deviceTargetId
            };
        }
        // if audio and target supports, set that template
        if (this.props.audioItem && target.supportsRichAudio) {
            const template = target.responseTemplates.find((t)=>t.usesAudio);
            if (template) return {
                audioItemId: this.props.audioItem.id,
                foregroundImageItemId: this.props.imageItem ? this.props.imageItem.id : null,
                backgroundImageItemId: this.props.backgroundImageItem ? this.props.backgroundImageItem.id : null,
                displayText: this.props.displayTextOverride,
                displayTitle: this.props.displayTitleOverride,
                responseTemplateTypeId: template.id,
                applicationId: this.props.applicationId,
                deviceTargetId: deviceTargetId
            };
        }
        // if images and target supports, set that template
        if (this.props.imageItem && target.supportsForegroundImages) {
            const template = target.responseTemplates.find((t)=>t.usesForegroundImage && !t.usesAudio && t.usesDisplayText);
            if (template) return {
                foregroundImageItemId: this.props.imageItem ? this.props.imageItem.id : null,
                backgroundImageItemId: this.props.backgroundImageItem ? this.props.backgroundImageItem.id : null,
                displayText: this.props.displayTextOverride,
                displayTitle: this.props.displayTitleOverride,
                responseTemplateTypeId: template.id,
                applicationId: this.props.applicationId,
                deviceTargetId: deviceTargetId
            };
        }
        const template = target.responseTemplates.find((t)=>!t.usesForegroundImage && t.usesDisplayText && !t.usesAudio && !t.usesVideo && t.usesDisplayTitle);
        if (!template) return;
        return {
            backgroundImageItemId: this.props.backgroundImageItem ? this.props.backgroundImageItem.id : null,
            displayText: this.props.displayTextOverride,
            displayTitle: this.props.displayTitleOverride,
            responseTemplateTypeId: template.id,
            applicationId: this.props.applicationId,
            deviceTargetId: deviceTargetId
        };
    }
    handleTargetChange(selection) {
        const target = this.props.targets.find((t)=>t.id == selection.value);
        this.setState({
            ...this.state,
            deviceTarget: target,
            customResponse: this.getCurrentResponse(target.id),
            hasCustomChanges: false,
            validationErrors: null,
            successMessage: null
        });
    }
    handleDefaultDisplayTextChange(option) {
        const propValues = {
            ...this.props
        };
        propValues.displayTextOverride = option.value == "default" ? null : "";
        this.props.onDefaultsChange(propValues);
    }
    handleDefaultTextValueChange(e) {
        const propValues = {
            ...this.props
        };
        propValues.displayTextOverride = e.target.value;
        this.props.onDefaultsChange(propValues);
    }
    handleDefaultTitleValueChange(e) {
        const propValues = {
            ...this.props
        };
        propValues.displayTitleOverride = e.target.value;
        this.props.onDefaultsChange(propValues);
    }
    handleDefaultDisplayTitleChange(option) {
        const propValues = {
            ...this.props
        };
        propValues.displayTitleOverride = option.value == "default" ? null : "";
        this.props.onDefaultsChange(propValues);
    }
    handleDefaultVideoChange(option) {
        const propValues = {
            ...this.props
        };
        propValues.videoItem = option.value == "default" ? null : this.props.mediaItems.find((m)=>m.id == option.value);
        this.props.onDefaultsChange(propValues);
    }
    handleDefaultAudioChange(option) {
        const propValues = {
            ...this.props
        };
        propValues.audioItem = option.value == "default" ? null : this.props.mediaItems.find((m)=>m.id == option.value);
        this.props.onDefaultsChange(propValues);
    }
    handleDefaultForegroundImageChange(option) {
        const propValues = {
            ...this.props
        };
        propValues.imageItem = option.value == "default" ? null : this.props.mediaItems.find((m)=>m.id == option.value);
        this.props.onDefaultsChange(propValues);
    }
    handleDefaultBackgroundImageChange(option) {
        const propValues = {
            ...this.props
        };
        propValues.backgroundImageItem = option.value == "default" ? null : this.props.mediaItems.find((m)=>m.id == option.value);
        this.props.onDefaultsChange(propValues);
    }
    handleTemplateChange(template) {
        var existingResponse = this.state.customResponse;
        if (existingResponse) {
            existingResponse.responseTemplateTypeId = template.id;
            existingResponse.responseTemplateType = template;
            this.setState({
                ...this.state,
                customResponse: existingResponse,
                hasCustomChanges: true,
                validationErrors: null,
                successMessage: null
            });
        }
    }
    hasCustomResponse(deviceTargetId) {
        const isCustom = this.props.container.responses.some((r)=>r.deviceTargetId == deviceTargetId);
        return isCustom;
    }
    removeTargetResponse(deviceTargetId) {
        const container = this.props.container;
        (0, _lodashDefault.default).remove(container.responses, (r)=>r.deviceTargetId == deviceTargetId);
        this.props.onChange(container);
        // reset values
        this.setState({
            ...this.state,
            customResponse: this.getCurrentResponse(this.state.deviceTarget.id)
        });
    }
    handleAudioSourceChange(option) {
        if (option.value != "default") {
            var existingResponse = this.state.customResponse;
            if (existingResponse) {
                existingResponse.audioItemId = option.value;
                this.setState({
                    ...this.state,
                    customResponse: existingResponse,
                    hasCustomChanges: true
                });
            }
        } else // if readout, remove response for target
        this.removeTargetResponse(this.state.deviceTarget.id);
    }
    handleScreenVideoChange(option) {
        var existingResponse = this.state.customResponse;
        if (existingResponse) {
            existingResponse.videoItemId = option.value == "default" ? undefined : option.value;
            this.setState({
                ...this.state,
                customResponse: existingResponse,
                hasCustomChanges: true
            });
        }
    }
    handleScreenBackgroundImageChange(option) {
        var existingResponse = this.state.customResponse;
        if (existingResponse) {
            existingResponse.backgroundImageItemId = option.value == "default" ? undefined : option.value;
            this.setState({
                ...this.state,
                customResponse: existingResponse,
                hasCustomChanges: true
            });
        }
    }
    handleScreenForegroundImageChange(option) {
        var existingResponse = this.state.customResponse;
        if (existingResponse) {
            existingResponse.foregroundImageItemId = option.value == "default" ? undefined : option.value;
            this.setState({
                ...this.state,
                customResponse: existingResponse,
                hasCustomChanges: true
            });
        }
    }
    handleScreenDisplayTextOptionChange(option) {
        var existingResponse = this.state.customResponse;
        if (existingResponse) {
            existingResponse.displayText = option.value == "default" ? undefined : "";
            this.setState({
                ...this.state,
                customResponse: existingResponse,
                hasCustomChanges: true
            });
        }
    }
    handleScreenDisplayTitleOptionChange(option) {
        var existingResponse = this.state.customResponse;
        if (existingResponse) {
            existingResponse.displayTitle = option.value == "default" ? undefined : "";
            this.setState({
                ...this.state,
                customResponse: existingResponse,
                hasCustomChanges: true
            });
        }
    }
    handleReadoutChange(option) {
        var existingResponse = this.state.customResponse;
        if (existingResponse) {
            existingResponse.readoutOverride = option.value == "default" ? null : "";
            this.setState({
                ...this.state,
                customResponse: existingResponse,
                hasCustomChanges: true
            });
        }
    }
    getMediaItems(type) {
        return this.props.mediaItems.filter((m)=>m.mediaType == type);
    }
    getDisplayText() {
        if (this.state.customResponse && this.state.customResponse.displayText) return this.state.customResponse.displayText;
        return "";
    }
    getCustomMarkup() {
        if (this.state.customResponse && this.state.customResponse.customMarkup) return this.state.customResponse.customMarkup;
        return "";
    }
    getDisplayTitle() {
        if (this.state.customResponse && this.state.customResponse.displayTitle) return this.state.customResponse.displayTitle;
        return "";
    }
    getDefaultDisplayText() {
        if (this.props.displayTextOverride !== undefined && this.props.displayTextOverride !== null) return this.props.displayTextOverride;
        return "";
    }
    getDefaultDisplayTitle() {
        if (this.props.displayTitleOverride !== undefined && this.props.displayTitleOverride !== null) return this.props.displayTitleOverride;
        return "";
    }
    handleReadoutTextChange(ssml) {
        var existingResponse = this.state.customResponse;
        if (existingResponse) {
            existingResponse.readoutOverride = ssml;
            this.setState({
                ...this.state,
                customResponse: existingResponse,
                hasCustomChanges: true
            });
        }
    }
    handleDisplayTextChange(e) {
        var existingResponse = this.state.customResponse;
        if (existingResponse) {
            existingResponse.displayText = e.target.value;
            this.setState({
                ...this.state,
                customResponse: existingResponse,
                hasCustomChanges: true
            });
        }
    }
    handleCustomMarkupChange(e) {
        var existingResponse = this.state.customResponse;
        if (existingResponse) {
            existingResponse.customMarkup = e.target.value;
            this.setState({
                ...this.state,
                customResponse: existingResponse,
                hasCustomChanges: true
            });
        }
    }
    handleDisplayTitleChange(e) {
        var existingResponse = this.state.customResponse;
        if (existingResponse) {
            existingResponse.displayTitle = e.target.value;
            this.setState({
                ...this.state,
                customResponse: existingResponse,
                hasCustomChanges: true
            });
        }
    }
    getCurrentTemplate() {
        const response = this.state.customResponse;
        if (response) return this.state.deviceTarget.responseTemplates.find((r)=>r.id == response.responseTemplateTypeId);
        // just return the first template for the target
        return this.state.deviceTarget.responseTemplates[0];
    }
    handleRemoveCustomization() {
        this.removeTargetResponse(this.state.deviceTarget.id);
    }
    handleUpdateResponse() {
        const validationErrors = this.verifyCustomResponse();
        if (validationErrors) {
            this.setState({
                ...this.state,
                validationErrors: [
                    validationErrors
                ]
            });
            return;
        }
        const container = this.props.container;
        const existingResponse = container.responses.find((r)=>r.deviceTargetId == this.state.deviceTarget.id);
        if (existingResponse) {
            const index = container.responses.indexOf(existingResponse);
            container.responses[index] = this.state.customResponse;
        } else container.responses.push(this.state.customResponse);
        this.props.onChange(container);
        this.setState({
            ...this.state,
            validationErrors: null,
            successMessage: "Saved",
            hasCustomChanges: false
        });
        // hide save message after delay
        setTimeout(()=>{
            this.setState({
                ...this.state,
                successMessage: null
            });
        }, 3000);
    }
    verifyCustomResponse() {
        const response = this.state.customResponse;
        if (!response) return "Invalid Response";
        const template = this.state.deviceTarget.responseTemplates.find((t)=>t.id == this.state.customResponse.responseTemplateTypeId);
        if (!template) return "Invalid template";
        if (template.requiresVideo && !response.videoItemId) return "This template requires a video";
        if (template.requiresAudio && !response.audioItemId) return "This template requires an audio file";
        if (template.requiresForegroundImage && !response.foregroundImageItemId) return "This template requires a foreground image";
        if (template.requiresBackgroundImage && !response.backgroundImageItemId) return "This template requires a background image";
        if (template.requiresCustomMarkup && !response.customMarkup) return "This template requires custom markup";
        return null;
    }
    render() {
        const currentTemplate = this.getCurrentTemplate();
        return (0, _react.jsx)((0, _responseBuilderContainerDefault.default), null, (0, _react.jsx)("div", null, (0, _react.jsx)("h4", null, "Default Components"), (0, _react.jsx)("p", null, "This sets the underlying components used in a response. We will apply a best-fit solution for each device based on their respective capabilities. "), (0, _react.jsx)("div", null, this.props.mediaItems.some((m)=>m.mediaType == "VideoFile") ? (0, _react.jsx)((0, _responseFieldCard.ResponseFieldCard), {
            title: "Video File"
        }, (0, _react.jsx)((0, _radioGroupDefault.default), {
            options: [
                ...this.getMediaItems("VideoFile").map((item)=>({
                        icon: videoIcon,
                        value: item.id,
                        label: item.name
                    })),
                {
                    icon: noVideoIcon,
                    value: "default",
                    label: "None"
                }
            ],
            onChange: this.handleDefaultVideoChange.bind(this),
            value: this.props.videoItem ? this.props.videoItem.id : "default"
        }), (0, _react.jsx)((0, _compatabilityViewerDefault.default), {
            detailText: "Not all devices are capable of returning a response with a video.",
            supportedTargets: this.props.targets.filter((t)=>t.supportsVideo),
            unsupportedTargets: this.props.targets.filter((t)=>!t.supportsVideo)
        })) : null, this.props.mediaItems.some((m)=>m.mediaType == "AudioFile") ? (0, _react.jsx)((0, _responseFieldCard.ResponseFieldCard), {
            title: "Audio Source"
        }, (0, _react.jsx)((0, _radioGroupDefault.default), {
            options: [
                ...this.props.mediaItems.filter((m)=>m.mediaType == "AudioFile").map((item)=>({
                        icon: audioIcon,
                        value: item.id,
                        label: item.name
                    })),
                {
                    icon: readoutIcon,
                    value: "default",
                    label: "Device Readout"
                }
            ],
            onChange: this.handleDefaultAudioChange.bind(this),
            value: this.props.audioItem ? this.props.audioItem.id : "default"
        })) : null, this.props.mediaItems.some((m)=>m.mediaType == "ImageFile") ? (0, _react.jsx)((0, _responseFieldCard.ResponseFieldCard), {
            title: "Foreground Image"
        }, (0, _react.jsx)((0, _radioGroupDefault.default), {
            options: [
                ...this.getMediaItems("ImageFile").map((item)=>({
                        icon: imageIcon,
                        value: item.id,
                        label: item.name
                    })),
                {
                    icon: noImageIcon,
                    value: "default",
                    label: "None"
                }
            ],
            onChange: this.handleDefaultForegroundImageChange.bind(this),
            value: this.props.imageItem ? this.props.imageItem.id : "default"
        })) : null, this.props.mediaItems.some((m)=>m.mediaType == "ImageFile") ? (0, _react.jsx)((0, _responseFieldCard.ResponseFieldCard), {
            title: "Background Image"
        }, (0, _react.jsx)((0, _radioGroupDefault.default), {
            options: [
                ...this.getMediaItems("ImageFile").map((item)=>({
                        icon: imageIcon,
                        value: item.id,
                        label: item.name
                    })),
                {
                    icon: noImageIcon,
                    value: "default",
                    label: "None"
                }
            ],
            onChange: this.handleDefaultBackgroundImageChange.bind(this),
            value: this.props.backgroundImageItem ? this.props.backgroundImageItem.id : "default"
        }), (0, _react.jsx)((0, _compatabilityViewerDefault.default), {
            detailText: "Not all devices are capable of returning a response with a background image.",
            supportedTargets: this.props.targets.filter((t)=>t.supportsBackgroundImages),
            unsupportedTargets: this.props.targets.filter((t)=>!t.supportsBackgroundImages)
        })) : null, (0, _react.jsx)((0, _responseFieldCard.ResponseFieldCard), {
            title: "Display Text"
        }, (0, _react.jsx)((0, _formFieldsContainerDefault.default), null, (0, _react.jsx)((0, _radioGroupDefault.default), {
            options: [
                {
                    icon: textIcon,
                    value: "default",
                    label: "Same as Readout"
                },
                {
                    icon: textIcon,
                    value: "custom",
                    label: "Custom"
                }
            ],
            onChange: this.handleDefaultDisplayTextChange.bind(this),
            value: this.props.displayTextOverride != null ? "custom" : "default"
        }), this.props.displayTextOverride != null ? (0, _react.jsx)((0, _textAreaFieldDefault.default), {
            name: "displayText",
            placeholder: "New display text",
            value: this.getDefaultDisplayText(),
            onChange: this.handleDefaultTextValueChange.bind(this)
        }) : null)), (0, _react.jsx)((0, _responseFieldCard.ResponseFieldCard), {
            title: "Display Title"
        }, (0, _react.jsx)((0, _formFieldsContainerDefault.default), null, (0, _react.jsx)((0, _radioGroupDefault.default), {
            options: [
                {
                    icon: textIcon,
                    value: "default",
                    label: "Automatic"
                },
                {
                    icon: textIcon,
                    value: "custom",
                    label: "Custom"
                }
            ],
            onChange: this.handleDefaultDisplayTitleChange.bind(this),
            value: this.props.displayTitleOverride != null ? "custom" : "default"
        }), this.props.displayTitleOverride != null ? (0, _react.jsx)((0, _textAreaFieldDefault.default), {
            name: "displayTitle",
            placeholder: "Display title",
            value: this.getDefaultDisplayTitle(),
            onChange: this.handleDefaultTitleValueChange.bind(this)
        }) : null)))), (0, _react.jsx)("h4", null, "Custom Overrides"), (0, _react.jsx)("p", null, "Customizations made here will apply to the specific device-type and override the default settings"), this.props.targets.length > 1 ? (0, _react.jsx)("div", {
            className: "type-selector"
        }, (0, _react.jsx)((0, _iconSelectFieldDefault.default), {
            name: "deviceType",
            clearable: false,
            label: "Device-Type:",
            options: (0, _lodashDefault.default).sortBy(this.props.targets.map((t)=>({
                    value: t.id,
                    icon: t.iconUrl,
                    label: t.displayName,
                    rightIcon: this.hasCustomResponse(t.id) ? customIcon : null,
                    rightText: this.hasCustomResponse(t.id) ? "CUSTOM" : null
                })), (o)=>o.label),
            value: this.state.deviceTarget.id,
            onBlur: ()=>{},
            onChange: this.handleTargetChange.bind(this)
        })) : null, (0, _react.jsx)("div", {
            className: "update-container"
        }, (0, _react.jsx)((0, _buttonDefault.default), {
            themes: [
                "primary-small",
                "start-tight"
            ],
            disabled: !this.state.hasCustomChanges,
            type: "button",
            onClick: this.handleUpdateResponse.bind(this),
            additionalClasses: "update-button",
            text: "Update"
        }), (0, _react.jsx)("p", {
            className: "error-label"
        }, this.state.validationErrors ? this.state.validationErrors.join(",") : null), (0, _react.jsx)("p", {
            className: "success-label"
        }, this.state.successMessage), this.hasCustomResponse(this.state.deviceTarget.id) ? (0, _react.jsx)((0, _buttonDefault.default), {
            themes: [
                "hollow",
                "end-tight"
            ],
            type: "button",
            onClick: this.handleRemoveCustomization.bind(this),
            additionalClasses: "reset-button",
            text: "Reset to default",
            icon: resetIcon
        }) : null), (0, _react.jsx)("div", null, (0, _react.jsx)((0, _responseTemplateSelectorDefault.default), {
            templates: this.state.deviceTarget.responseTemplates,
            selectedTemplate: currentTemplate,
            onSelectionChange: this.handleTemplateChange.bind(this)
        }), (0, _react.jsx)("div", null, currentTemplate && currentTemplate.usesVideo ? (0, _react.jsx)((0, _responseFieldCard.ResponseFieldCard), {
            title: "Video File"
        }, (0, _react.jsx)((0, _radioGroupDefault.default), {
            options: [
                ...this.getMediaItems("VideoFile").map((item)=>({
                        icon: videoIcon,
                        value: item.id,
                        label: item.name
                    }))
            ],
            onChange: this.handleScreenVideoChange.bind(this),
            value: this.state.customResponse.videoItemId ? this.state.customResponse.videoItemId : "default"
        })) : null, currentTemplate && currentTemplate.usesAudio ? (0, _react.jsx)((0, _responseFieldCard.ResponseFieldCard), {
            title: "Audio File"
        }, (0, _react.jsx)((0, _radioGroupDefault.default), {
            options: [
                ...this.getMediaItems("AudioFile").map((item)=>({
                        icon: audioIcon,
                        value: item.id,
                        label: item.name
                    }))
            ],
            onChange: this.handleAudioSourceChange.bind(this),
            value: this.state.customResponse.audioItemId ? this.state.customResponse.audioItemId : "default"
        })) : null, currentTemplate && currentTemplate.usesReadout ? (0, _react.jsx)((0, _responseFieldCard.ResponseFieldCard), {
            title: "Output Speech"
        }, (0, _react.jsx)((0, _radioGroupDefault.default), {
            options: [
                {
                    icon: readoutIcon,
                    value: "default",
                    label: "Default Readout"
                },
                {
                    icon: readoutIcon,
                    value: "custom",
                    label: "Custom Readout"
                }
            ],
            onChange: this.handleReadoutChange.bind(this),
            value: this.state.customResponse.readoutOverride != null ? "custom" : "default"
        }), this.state.customResponse && this.state.customResponse.readoutOverride != null ? (0, _react.jsx)((0, _ssmlFieldDefault.default), {
            name: "readoutOverride",
            placeholder: "What do you want the assistant to say?",
            value: this.state.customResponse.readoutOverride,
            onChange: this.handleReadoutTextChange.bind(this),
            onBlur: ()=>{},
            applicationId: this.props.applicationId
        }) : null) : null, currentTemplate && currentTemplate.usesBackgroundImage ? (0, _react.jsx)((0, _responseFieldCard.ResponseFieldCard), {
            title: "Background Image"
        }, (0, _react.jsx)((0, _radioGroupDefault.default), {
            options: [
                ...this.getMediaItems("ImageFile").map((item)=>({
                        icon: imageIcon,
                        value: item.id,
                        label: item.name
                    })),
                {
                    icon: noImageIcon,
                    value: "default",
                    label: "None"
                }
            ],
            onChange: this.handleScreenBackgroundImageChange.bind(this),
            value: this.state.customResponse.backgroundImageItemId ? this.state.customResponse.backgroundImageItemId : "default"
        })) : null, currentTemplate && currentTemplate.usesForegroundImage ? (0, _react.jsx)((0, _responseFieldCard.ResponseFieldCard), {
            title: "Foreground Image"
        }, (0, _react.jsx)((0, _radioGroupDefault.default), {
            options: [
                ...this.getMediaItems("ImageFile").map((item)=>({
                        icon: imageIcon,
                        value: item.id,
                        label: item.name
                    })),
                {
                    icon: noImageIcon,
                    value: "default",
                    label: "None"
                }
            ],
            onChange: this.handleScreenForegroundImageChange.bind(this),
            value: this.state.customResponse.foregroundImageItemId ? this.state.customResponse.foregroundImageItemId : "default"
        })) : null, currentTemplate && currentTemplate.usesDisplayText ? (0, _react.jsx)((0, _responseFieldCard.ResponseFieldCard), {
            title: "Display Text"
        }, (0, _react.jsx)((0, _formFieldsContainerDefault.default), null, (0, _react.jsx)((0, _radioGroupDefault.default), {
            options: [
                {
                    icon: textIcon,
                    value: "default",
                    label: "Use Default"
                },
                {
                    icon: textIcon,
                    value: "custom",
                    label: "Custom"
                }
            ],
            onChange: this.handleScreenDisplayTextOptionChange.bind(this),
            value: this.state.customResponse && this.state.customResponse.displayText != null ? "custom" : "default"
        }), this.state.customResponse && this.state.customResponse.displayText != null ? (0, _react.jsx)((0, _textAreaFieldDefault.default), {
            name: "displayText",
            placeholder: "New display text",
            value: this.getDisplayText(),
            onChange: this.handleDisplayTextChange.bind(this)
        }) : null)) : null, currentTemplate && currentTemplate.usesDisplayTitle ? (0, _react.jsx)((0, _responseFieldCard.ResponseFieldCard), {
            title: "Display Title"
        }, (0, _react.jsx)((0, _formFieldsContainerDefault.default), null, (0, _react.jsx)((0, _radioGroupDefault.default), {
            options: [
                {
                    icon: textIcon,
                    value: "default",
                    label: "Use Default"
                },
                {
                    icon: textIcon,
                    value: "custom",
                    label: "Custom"
                }
            ],
            onChange: this.handleScreenDisplayTitleOptionChange.bind(this),
            value: this.state.customResponse && this.state.customResponse.displayTitle != null ? "custom" : "default"
        }), this.state.customResponse && this.state.customResponse.displayTitle != null ? (0, _react.jsx)((0, _textAreaFieldDefault.default), {
            name: "displayText",
            placeholder: "Display title",
            value: this.getDisplayTitle(),
            onChange: this.handleDisplayTitleChange.bind(this)
        }) : null)) : null, currentTemplate && currentTemplate.usesCustomMarkup ? (0, _react.jsx)((0, _responseFieldCard.ResponseFieldCard), {
            title: "Custom Markup"
        }, (0, _react.jsx)((0, _formFieldsContainerDefault.default), null, (0, _react.jsx)((0, _textAreaFieldDefault.default), {
            name: "customMarkup",
            placeholder: "Paste custom markup here",
            value: this.getCustomMarkup(),
            onChange: this.handleCustomMarkupChange.bind(this)
        }))) : null), (0, _react.jsx)("div", {
            className: "update-container"
        }, (0, _react.jsx)((0, _buttonDefault.default), {
            themes: [
                "primary-small"
            ],
            disabled: !this.state.hasCustomChanges,
            type: "button",
            onClick: this.handleUpdateResponse.bind(this),
            additionalClasses: "update-button",
            text: "Update"
        }), (0, _react.jsx)("p", {
            className: "error-label"
        }, this.state.validationErrors ? this.state.validationErrors.join(",") : null), (0, _react.jsx)("p", {
            className: "success-label"
        }, this.state.successMessage))));
    }
}
exports.default = ScreenResponseBuilder;

},{"@emotion/react":"djZKr","lodash":"3hMBK","react":"6uln9","../../../components/forms/IconSelectField":"i0bA1","../../../components/forms/RadioGroup":"eiGrn","../../../components/forms/TextAreaField":"fE54C","../../../components/general/Button":"6ymxN","../../../components/structure/FormFieldsContainer":"h3hzh","./CompatabilityViewer":"9Fd4Q","./ResponseFieldCard":"hUTbn","./ResponseTemplateSelector":"dfofs","./ResponseBuilderContainer":"g6NDi","../../../components/forms/SsmlField/SsmlField":"cvL6K","2c7a647f3590cb63":"4qcoH","eb1f9ac353fb3edd":"3mfQB","3f119c4a4f227163":"kyxnq","b31309378b8f6ef2":"ePf5J","9bb2b9e966e0936d":"346EV","38731cc7fa936ae2":"76Rwl","cc7c496b479531e5":"1WB1n","e7469a292ce94ce4":"8Nwsw","d270f9b8ed694782":"emEAy","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9Fd4Q":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _colors = require("../../../constants/colors");
var _toggleableSection = require("../../../components/structure/ToggleableSection");
var _toggleableSectionDefault = parcelHelpers.interopDefault(_toggleableSection);
var _horizontalSeparator = require("../../../components/structure/HorizontalSeparator");
var _horizontalSeparatorDefault = parcelHelpers.interopDefault(_horizontalSeparator);
var _rcTooltip = require("rc-tooltip");
var _rcTooltipDefault = parcelHelpers.interopDefault(_rcTooltip);
var _lodash = require("lodash");
var _lodashDefault = parcelHelpers.interopDefault(_lodash);
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const puzzleIcon = require("3f21f36a47997b96");
const allowIcon = require("570db4ce93654a2");
const deniedIcon = require("bcf2c3cc89be7a16");
const containerStyle = /*#__PURE__*/ (0, _css.css)(".title-container{display:flex;align-items:center;margin-bottom:8px;img{margin-right:12px;}}.compat-title{font-size:14px;font-weight:600;font-style:normal;font-stretch:normal;line-height:normal;letter-spacing:normal;color:#faa21b;}.detail{font-size:12px;font-weight:600;font-style:normal;font-stretch:normal;line-height:normal;letter-spacing:normal;color:", (0, _colors.cool_grey), ";}.detail-grouping{display:flex;flex-direction:row;flex-wrap:wrap;align-items:center;height:52px;.group-title{font-size:14px;font-weight:normal;font-style:normal;font-stretch:normal;line-height:normal;letter-spacing:normal;color:#304562;margin-left:8px;}.device-grouping{display:flex;flex-direction:row;flex-wrap:wrap;margin-right:0;margin-left:auto;img{height:30px;margin-left:6px;cursor:pointer;padding-left:11px;}}}", "");
const tooltipContentStyle = /*#__PURE__*/ (0, _css.css)({
    name: "11143my",
    styles: ".rc-tooltip-inner{font-family:Muli;font-size:14px;font-weight:normal;font-style:normal;letter-spacing:0.6px;z-index:120;color:white;background-color:#304562;box-shadow:-1px 4px 10px 0 rgba(48, 69, 98, 0.1);padding:8px;min-height:0;}"
});
const renderDevice = (target, index)=>(0, _react.jsx)("div", {
        key: target.id,
        className: "device-target"
    }, (0, _react.jsx)((0, _rcTooltipDefault.default), {
        mouseEnterDelay: .25,
        overlayClassName: tooltipContentStyle,
        mouseLeaveDelay: .5,
        trigger: [
            "hover",
            "click"
        ],
        placement: "top",
        overlay: (0, _react.jsx)("span", null, target.displayName)
    }, (0, _react.jsx)("img", {
        src: target.iconUrl
    })));
const CompatabilityViewer = (props)=>(0, _react.jsx)("div", {
        className: containerStyle
    }, (0, _react.jsx)("div", {
        className: "title-container"
    }, (0, _react.jsx)("img", {
        src: puzzleIcon
    }), (0, _react.jsx)("p", {
        className: "compat-title"
    }, "Limited Compatability")), (0, _react.jsx)("p", {
        className: "detail"
    }, props.detailText), (0, _react.jsx)((0, _toggleableSectionDefault.default), {
        showTitle: "Show Compatability Details",
        hideTitle: "Hide Compatability Details",
        isCollapsed: true
    }, (0, _react.jsx)("div", {
        className: "detail-grouping"
    }, (0, _react.jsx)("img", {
        src: allowIcon
    }), (0, _react.jsx)("p", {
        className: "group-title"
    }, "Will Likely Render"), (0, _react.jsx)("div", {
        className: "device-grouping"
    }, (0, _lodashDefault.default).sortBy(props.supportedTargets, (d)=>d.displayName).map(renderDevice))), (0, _react.jsx)((0, _horizontalSeparatorDefault.default), null), (0, _react.jsx)("div", {
        className: "detail-grouping"
    }, (0, _react.jsx)("img", {
        src: deniedIcon
    }), (0, _react.jsx)("p", {
        className: "group-title"
    }, "Not Compatible"), (0, _react.jsx)("div", {
        className: "device-grouping"
    }, (0, _lodashDefault.default).sortBy(props.unsupportedTargets, (d)=>d.displayName).map(renderDevice)))));
exports.default = CompatabilityViewer;

},{"@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","../../../constants/colors":"1p3OR","../../../components/structure/ToggleableSection":"f5pes","../../../components/structure/HorizontalSeparator":"Pw3HQ","rc-tooltip":"fhD1R","lodash":"3hMBK","3f21f36a47997b96":"dpHZM","570db4ce93654a2":"8jR3J","bcf2c3cc89be7a16":"bYytW","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"f5pes":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _horizontalSeparator = require("./HorizontalSeparator");
var _horizontalSeparatorDefault = parcelHelpers.interopDefault(_horizontalSeparator);
var _toggleIndicator = require("../general/ToggleIndicator");
var _toggleIndicatorDefault = parcelHelpers.interopDefault(_toggleIndicator);
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const containerStyle = /*#__PURE__*/ (0, _css.css)({
    name: "fp659c",
    styles: ".hidden{display:none;}.title-section{display:flex;align-items:center;cursor:pointer;margin:24px 8px;span{width:auto;margin:0 8px;font-family:Muli;font-size:14px;font-weight:normal;font-style:normal;font-stretch:normal;line-height:normal;letter-spacing:normal;color:#3885a6;}.toggle-indicator{border-color:#3885a6;margin:2px;}.line{flex:1;}}"
});
class ToggleableSection extends (0, _reactDefault.default).Component {
    componentWillMount() {
        this.setState({
            isCollapsed: this.props.isCollapsed
        });
    }
    componentDidUpdate(previousProps) {
        if (previousProps.isCollapsed != this.props.isCollapsed) this.setState({
            isCollapsed: this.props.isCollapsed
        });
    }
    handleToggle() {
        this.setState({
            isCollapsed: !this.state.isCollapsed
        });
    }
    render() {
        return (0, _react.jsx)("div", {
            className: `${containerStyle} ${this.props.className ?? ""}`
        }, (0, _react.jsx)("div", {
            className: "title-section",
            onClick: this.handleToggle.bind(this)
        }, (0, _react.jsx)((0, _toggleIndicatorDefault.default), {
            direction: this.state.isCollapsed ? "up" : "down",
            type: this.props.toggleType
        }), (0, _react.jsx)("span", null, this.state.isCollapsed ? this.props.showTitle : this.props.hideTitle), (0, _react.jsx)("div", {
            className: "line"
        }, (0, _react.jsx)((0, _horizontalSeparatorDefault.default), null))), (0, _react.jsx)("div", {
            className: this.state.isCollapsed ? "hidden" : ""
        }, this.props.children));
    }
}
exports.default = ToggleableSection;

},{"@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","./HorizontalSeparator":"Pw3HQ","../general/ToggleIndicator":"4eej1","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"dpHZM":[function(require,module,exports) {
module.exports = require("e18590cf7d4b4e2e").getBundleURL("kVLro") + require("53da0da01af6c080").resolve("104Ud");

},{"e18590cf7d4b4e2e":"c7Tr5","53da0da01af6c080":"fyJL2"}],"8jR3J":[function(require,module,exports) {
module.exports = require("fbf215a417c88a4a").getBundleURL("kVLro") + require("f27d47e9b56a6746").resolve("aIKaJ");

},{"fbf215a417c88a4a":"c7Tr5","f27d47e9b56a6746":"fyJL2"}],"bYytW":[function(require,module,exports) {
module.exports = require("a8c3087507ff946").getBundleURL("kVLro") + require("6d7643a7df12541a").resolve("kxF3X");

},{"a8c3087507ff946":"c7Tr5","6d7643a7df12541a":"fyJL2"}],"dfofs":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _defineProperty = require("@babel/runtime/helpers/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _responseTemplateListItem = require("./ResponseTemplateListItem");
var _toggleIndicator = require("../../../components/general/ToggleIndicator");
var _toggleIndicatorDefault = parcelHelpers.interopDefault(_toggleIndicator);
var _colors = require("../../../constants/colors");
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const containerStyle = /*#__PURE__*/ (0, _css.css)("margin-top:16px;position:relative;.selection-container{display:flex;flex-direction:row;align-items:stretch;border:solid 1px ", (0, _colors.cool_grey), ";border-radius:10px;cursor:pointer;background:white;overflow:hidden;.selection-toggle{display:flex;align-items:center;justify-content:center;width:52px;border-left:1px solid ", (0, _colors.cool_grey), ";}}.selector-wrapper{position:absolute;display:flex;flex-direction:column;margin-left:0;margin-right:0;background:white;margin-bottom:120px;border:solid 1px #cccccc;margin-top:12px;box-shadow:0 4px 4px 0 ", (0, _colors.dark_grey_blue_10), ";border-radius:10px;z-index:100;flex:1;width:100%;}", "");
const triangleStyle = /*#__PURE__*/ (0, _css.css)({
    name: "1164c54",
    styles: "transform:rotate(45deg);width:12px;height:12px;margin-top:-7px;margin-bottom:-6px;border-top:solid 1px #cccccc;border-left:solid 1px #cccccc;background:transparent;margin-right:16px;margin-left:auto"
});
class ResponseTemplateSelector extends (0, _reactDefault.default).Component {
    constructor(...args){
        super(...args);
        (0, _definePropertyDefault.default)(this, "documentCloser", this.handleDocumentClick.bind(this));
    }
    componentWillMount() {
        this.setState({
            isCollapsed: true
        });
        document.addEventListener("click", this.documentCloser, true);
    }
    componentWillUnmount() {
        document.removeEventListener("click", this.documentCloser, true);
    }
    handleDocumentClick(e) {
        if (e.target.closest(".selector-wrapper") || e.target.closest(".selection-container")) return;
        this.setState({
            ...this.state,
            isCollapsed: true
        });
    }
    handleToggle() {
        this.setState({
            isCollapsed: !this.state.isCollapsed
        });
    }
    handleSelectionChange(template) {
        this.handleToggle();
        this.props.onSelectionChange(template);
    }
    render() {
        return (0, _react.jsx)("div", {
            className: containerStyle
        }, (0, _react.jsx)("div", {
            className: "selection-container"
        }, (0, _react.jsx)((0, _responseTemplateListItem.ResponseTemplateListItem), {
            responseTemplate: this.props.selectedTemplate,
            viewOnly: true,
            isSelected: false,
            onSelected: this.handleToggle.bind(this)
        }), (0, _react.jsx)("div", {
            className: "selection-toggle",
            onClick: this.handleToggle.bind(this)
        }, (0, _react.jsx)((0, _toggleIndicatorDefault.default), {
            direction: this.state.isCollapsed ? "down" : "up"
        }))), this.state.isCollapsed ? null : (0, _react.jsx)("div", {
            className: "selector-wrapper"
        }, (0, _react.jsx)("div", {
            className: triangleStyle
        }), this.props.templates.map((template, i)=>(0, _react.jsx)((0, _responseTemplateListItem.ResponseTemplateListItem), {
                key: i,
                top: i == 0,
                bottom: i == this.props.templates.length - 1,
                responseTemplate: template,
                onSelected: this.handleSelectionChange.bind(this),
                isSelected: template.id == this.props.selectedTemplate.id
            }))));
    }
}
exports.default = ResponseTemplateSelector;

},{"@babel/runtime/helpers/defineProperty":"9sJxO","@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","./ResponseTemplateListItem":"70AYs","../../../components/general/ToggleIndicator":"4eej1","../../../constants/colors":"1p3OR","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"70AYs":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ResponseTemplateListItem", ()=>ResponseTemplateListItem);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _colors = require("../../../constants/colors");
const micIcon = require("ee7e1136db7d0660");
const containerStyle = /*#__PURE__*/ (0, _css.css)("background:white;display:flex;flex-direction:row;padding:24px 32px;font-family:Muli;font-style:normal;font-stretch:normal;line-height:normal;letter-spacing:normal;cursor:pointer;flex:1;align-items:stretch;&.selectable{border:1px solid ", (0, _colors.cool_grey), ";&:hover{background:", (0, _colors.silver), ";}&.top{border-radius:10px 10px 0 0;}&.bottom{border-radius:0 0 10px 10px;}}.template-icon{height:114px;width:auto;margin-right:24px;}&.selected{background-color:rgba(0, 125, 187, 0.1);border:1px solid ", (0, _colors.ocean_blue), ";}.template-title{font-size:14px;font-weight:600;color:#304562;margin-bottom:6px;}.template-description-title{font-size:11px;font-weight:normal;color:", (0, _colors.cool_grey), ";}.template-description{font-size:12px;font-weight:600;color:#304562;}.mic-indicator{display:flex;align-items:center;font-size:12px;font-weight:600;color:#faa21b;margin-top:32px;}", "");
const ResponseTemplateListItem = (props)=>{
    if (props.responseTemplate) return (0, _react.jsx)("div", {
        className: `${props.viewOnly ? "" : "selectable"} 
                     ${containerStyle} ${props.isSelected ? "selected" : ""}
                     ${props.top ? "top" : ""} ${props.bottom ? "bottom" : ""}
                    `,
        onClick: ()=>props.onSelected(props.responseTemplate)
    }, (0, _react.jsx)("img", {
        className: "template-icon",
        src: props.responseTemplate.iconUrl
    }), (0, _react.jsx)("div", null, (0, _react.jsx)("p", {
        className: "template-title"
    }, props.responseTemplate.name), (0, _react.jsx)("p", {
        className: "template-description-title"
    }, "COMPONENTS"), (0, _react.jsx)("p", {
        className: "template-description"
    }, props.responseTemplate.description), props.responseTemplate.usesAudio || props.responseTemplate.usesVideo ? (0, _react.jsx)("p", {
        className: "mic-indicator"
    }, (0, _react.jsx)("img", {
        src: micIcon
    }), (0, _react.jsx)("span", null, "Closes Mic")) : null));
    return null;
};

},{"@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","../../../constants/colors":"1p3OR","ee7e1136db7d0660":"4kEIg","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4kEIg":[function(require,module,exports) {
module.exports = require("56eadbabc7d27930").getBundleURL("kVLro") + require("e1d663f570ffee9f").resolve("eT9py");

},{"56eadbabc7d27930":"c7Tr5","e1d663f570ffee9f":"fyJL2"}],"1DTJA":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _reactTabs = require("react-tabs");
var _tabIndicator = require("./TabIndicator");
var _tabIndicatorDefault = parcelHelpers.interopDefault(_tabIndicator);
var _css = require("@emotion/css");
var _colors = require("../../constants/colors");
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const tabStripStyle = /*#__PURE__*/ (0, _css.css)("display:flex;flex-direction:row;line-height:65px;list-style:none;border-bottom:solid 1px ", (0, _colors.silver_two), ";", "");
const tabStyle = /*#__PURE__*/ (0, _css.css)("display:flex;flex-direction:column;width:50%;color:black;text-align:center;cursor:pointer;span{flex-grow:1;line-height:65px;font-family:Muli;font-size:18px;font-weight:normal;font-style:normal;letter-spacing:0.5px;color:", (0, _colors.dark_grey_blue), ";}div{display:none;flex-grow:0;flex-shrink:0;}", "");
const activeTabStyle = /*#__PURE__*/ (0, _css.css)("color:", (0, _colors.ocean_blue), ";div{display:block;position:relative;top:2;}", "");
const tabLayoutStyle = /*#__PURE__*/ (0, _css.css)({
    name: "pfjone",
    styles: "background:white"
});
const indicatorGradient = `linear-gradient(267deg, ${(0, _colors.dark_sky_blue)}, ${(0, _colors.ocean_blue)});`;
const MediaLibraryTabbedLayout = (props)=>{
    function renderTab(name) {
        return (0, _react.jsx)((0, _reactTabs.Tab), {
            className: tabStyle,
            selectedClassName: activeTabStyle,
            key: name
        }, (0, _react.jsx)("span", null, name), (0, _react.jsx)((0, _tabIndicatorDefault.default), {
            color: indicatorGradient
        }));
    }
    return (0, _react.jsx)((0, _reactTabs.Tabs), {
        className: tabLayoutStyle,
        defaultIndex: props.selectedIndex,
        onSelect: props.onTabSelected
    }, (0, _react.jsx)((0, _reactTabs.TabList), {
        className: tabStripStyle
    }, props.tabs.map(renderTab)), props.children);
};
exports.default = MediaLibraryTabbedLayout;

},{"@emotion/react":"djZKr","react":"6uln9","react-tabs":"92Sgf","./TabIndicator":"3Sj8d","@emotion/css":"awUBr","../../constants/colors":"1p3OR","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"gAX0X":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _searchField = require("../../../components/forms/SearchField");
var _searchFieldDefault = parcelHelpers.interopDefault(_searchField);
var _roundedSelectionRow = require("../../../components/general/RoundedSelectionRow");
var _roundedSelectionRowDefault = parcelHelpers.interopDefault(_roundedSelectionRow);
var _sortedPaginatedTable = require("../../../components/general/SortedPaginatedTable");
var _sortedPaginatedTableDefault = parcelHelpers.interopDefault(_sortedPaginatedTable);
var _tableCell = require("../../../components/general/TableCell");
var _tableCellDefault = parcelHelpers.interopDefault(_tableCell);
var _tableHeader = require("../../../components/general/TableHeader");
var _tableHeaderDefault = parcelHelpers.interopDefault(_tableHeader);
var _toggleIndicator = require("../../../components/general/ToggleIndicator");
var _toggleIndicatorDefault = parcelHelpers.interopDefault(_toggleIndicator);
var _colors = require("../../../constants/colors");
var _expandedMediaItem = require("./ExpandedMediaItem");
var _expandedMediaItemDefault = parcelHelpers.interopDefault(_expandedMediaItem);
var _confirmationDialog = require("../../../components/structure/ConfirmationDialog");
var _confirmationDialogDefault = parcelHelpers.interopDefault(_confirmationDialog);
var _removeConfirmation = require("../../../components/general/RemoveConfirmation");
var _removeConfirmationDefault = parcelHelpers.interopDefault(_removeConfirmation);
var _mediaGridPreview = require("./MediaGridPreview");
var _mediaGridPreviewDefault = parcelHelpers.interopDefault(_mediaGridPreview);
var _extensions = require("../../../models/extensions");
var _moment = require("moment");
var _momentDefault = parcelHelpers.interopDefault(_moment);
var _numberIncrementSelector = require("../../../components/forms/NumberIncrementSelector");
var _numberIncrementSelectorDefault = parcelHelpers.interopDefault(_numberIncrementSelector);
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const audioIconBlack = require("35c569b4042d6262");
const imageIconBlack = require("8044e6f4718fc9b6");
const videoIconBlack = require("b0edd2e27c5edf01");
const audioIconBlue = require("562c2ab142b29f8b");
const imageIconBlue = require("b7e205834cf0f1d0");
const videoIconBlue = require("23708cd97f6e0627");
const attachmentIcon = require("d56a4c23f41415d5");
const restoreIcon = require("99d7d9ceeec6f7ed");
const defaultState = {
    selectedMediaFilter: 0,
    page: 1,
    pageLimit: 1,
    recordsPerPage: 20,
    isDeleteLoading: false,
    searchValue: "",
    deletingItem: {},
    deletingItemLinkedContent: {},
    freezeWhenExpanded: true,
    sortMethod: "LastUpdated",
    expandedRows: {},
    reset: false,
    displayedItems: [],
    view: "table",
    showingDisabledItems: false,
    isDeleteModuleVisible: false
};
class MediaLibraryTab extends (0, _reactDefault.default).Component {
    constructor(props){
        // Required step: always call the parent class' constructor
        super(props);
        // Set the state directly. Use props if necessary.
        this.state = {
            ...defaultState
        };
    }
    componentWillMount() {
        this.resetDisplayedItems();
    }
    updateMediaItem(item, tableIndex) {
        this.props.mediaContainer.updateMediaItem(item);
    }
    handleSearch(searchEvent) {
        this.updateSearchValue(searchEvent.target.value);
    }
    toggleView() {
        this.setState({
            ...this.state,
            view: this.state.view.localeCompare("grid") === 0 ? "table" : "grid"
        });
    }
    resetDisplayedItems() {
        this.setState({
            ...this.state,
            freezeWhenExpanded: false,
            expandedRows: {}
        }, this.setDisplayedItemsFromState);
    }
    setDisplayedItemsFromState() {
        this.setDisplayedItems(this.state.selectedMediaFilter, this.state.searchValue, this.state.sortMethod, this.state.page);
    }
    setDisplayedItems(selectedFilter, searchValue, sortMethod, selectedPage) {
        this.props.mediaContainer.getMediaItemsForApp(this.props.applicationId).then((result)=>{
            var items = result.data;
            // 1. Filter Disabled
            items = this.filterDisabledMediaItems(items, this.state.showingDisabledItems);
            // 2. Filter Type
            items = this.filterMediaItems(items, selectedFilter);
            // 3. Search
            items = this.searchMediaItems(items, searchValue);
            // 4. Set new page and page limit based off of number of available items.
            const newPage = this.getNewPageLimit(items, selectedPage);
            // 5. Sort
            items = this.sortMediaItems(items, sortMethod);
            // 6. Get the Right page  
            items = this.pageMediaItems(items, newPage);
            this.setState({
                ...this.state,
                displayedItems: items,
                freezeWhenExpanded: true,
                reset: false
            });
        });
    }
    freezeRows() {
        this.setState({
            ...this.state,
            freezeWhenExpanded: true
        });
    }
    getNewPageLimit(items, newPage) {
        let newLimit = Math.ceil(items.length / this.state.recordsPerPage);
        newLimit = newLimit === 0 ? 1 : newLimit;
        if (newPage > newLimit) newPage = newLimit;
        if (this.state.pageLimit != newLimit) this.setState({
            ...this.state,
            pageLimit: newLimit,
            page: newPage
        });
        return newPage;
    }
    sortMediaItems(items, sortMethod) {
        let sortFunction = (item1, item2)=>{
            return 1;
        };
        switch(sortMethod){
            case "OldestUpdated":
                sortFunction = (item1, item2)=>{
                    return new Date(item1.modifiedDate).getTime() - new Date(item2.modifiedDate).getTime();
                };
                break;
            case "NameA2Z":
                sortFunction = (item1, item2)=>{
                    return item1.name.localeCompare(item2.name);
                };
                break;
            case "NameZ2A":
                sortFunction = (item1, item2)=>{
                    return -1 * item1.name.localeCompare(item2.name);
                };
                break;
            default:
                //also LatestUpdated            
                sortFunction = (item1, item2)=>{
                    return new Date(item2.modifiedDate).getTime() - new Date(item1.modifiedDate).getTime();
                };
                break;
        }
        return items.sort(sortFunction);
    }
    filterMediaItems(items, selectedFilter) {
        switch(selectedFilter){
            case 1:
                return items.filter((i)=>i.mediaType === "ImageFile");
            case 2:
                return items.filter((i)=>i.mediaType === "AudioFile");
            case 3:
                return items.filter((i)=>i.mediaType === "VideoFile");
            default:
                // return everything
                return items;
        }
    }
    filterDisabledMediaItems(items, disabled) {
        return items.filter((i)=>i.isDisabled == disabled);
    }
    pageMediaItems(items, selectedPage) {
        if (items == null) return [];
        const pageStart = (selectedPage - 1) * this.state.recordsPerPage;
        return items.slice(pageStart, pageStart + this.state.recordsPerPage);
    }
    searchMediaItems(items, searchValue) {
        const lowerSearch = searchValue.toLowerCase();
        const returnItems = items.filter((i)=>i.name.toLowerCase().includes(lowerSearch));
        return returnItems;
    }
    updateMediaLibraryFilter(optionId) {
        this.setState({
            ...this.state,
            selectedMediaFilter: optionId,
            freezeWhenExpanded: false,
            view: optionId === 1 ? "grid" : this.state.view
        }, this.resetExpansionGridView);
        this.setDisplayedItems(optionId, this.state.searchValue, this.state.sortMethod, this.state.page);
    }
    updatePageNumber(increment) {
        let newPage = this.state.page + (increment ? 1 : -1);
        if (newPage > this.state.pageLimit) newPage = this.state.pageLimit;
        else if (newPage < 1) newPage = 1;
        this.setState({
            ...this.state,
            page: newPage,
            freezeWhenExpanded: false
        }, this.resetExpansionGridView);
        this.setDisplayedItems(this.state.selectedMediaFilter, this.state.searchValue, this.state.sortMethod, newPage);
    }
    updateSortMethod(method) {
        this.setState({
            ...this.state,
            sortMethod: method.value,
            freezeWhenExpanded: false
        }, this.resetExpansionGridView);
        this.setDisplayedItems(this.state.selectedMediaFilter, this.state.searchValue, method.value, this.state.page);
    }
    replaceMediaItem(item, file, index) {
        const promise = this.props.mediaContainer.replaceMediaItem(this.props.applicationId, item, file);
        promise.then((result)=>{
            if (result.resultType == "Ok") {
                const expandedRows = {
                    ...this.state.expandedRows
                };
                expandedRows[index] = true;
                this.setState({
                    ...this.state,
                    displayedItems: [
                        ...this.state.displayedItems.slice(0, index),
                        {
                            ...this.state.displayedItems[index],
                            name: file.name,
                            url: URL.createObjectURL(file)
                        },
                        ...this.state.displayedItems.slice(index + 1, this.state.displayedItems.length)
                    ],
                    freezeWhenExpanded: false,
                    expandedRows: expandedRows
                }, this.freezeRows);
            }
        });
        return promise;
    }
    deleteMediaItem() {
        this.setState({
            ...this.state,
            freezeWhenExpanded: false,
            isDeleteLoading: true
        }, this.completeDelete);
    }
    completeDelete() {
        this.props.mediaContainer.deleteMediaItem(this.state.deletingItem).then((result)=>{
            if (result.resultType == "Ok") this.closeDeleteModal(this.resetDisplayedItems);
            else this.setState({
                ...this.state,
                isDeleteLoading: false
            });
        });
    }
    attemptDelete(item, linkedContent) {
        this.setState({
            ...this.state,
            isDeleteModuleVisible: true,
            deletingItem: item,
            deletingItemLinkedContent: linkedContent
        });
    }
    closeDeleteModal(callback) {
        this.setState({
            ...this.state,
            isDeleteModuleVisible: false,
            isDeleteLoading: false,
            deletingItem: {},
            reset: true,
            freezeWhenExpanded: true
        }, callback);
    }
    restoreMediaItem(item) {
        const newItem = {
            ...item,
            isDisabled: false
        };
        this.props.mediaContainer.updateMediaItem(newItem).then((result)=>{
            if (result.resultType == "Ok") this.resetDisplayedItems();
        });
    }
    updateSearchValue(searchValue) {
        this.setState({
            ...this.state,
            searchValue: searchValue,
            freezeWhenExpanded: false
        }, this.resetExpansionGridView);
        this.setDisplayedItems(this.state.selectedMediaFilter, searchValue, this.state.sortMethod, this.state.page);
    }
    renderPreviewItem(item, column) {
        return (0, _react.jsx)((0, _mediaGridPreviewDefault.default), {
            attachMediaItem: (item)=>{
                return item.isDisabled ? this.restoreMediaItem(item) : this.props.onAttachMediaItem(item);
            },
            item: item,
            column: column
        });
    }
    renderTopToolbar() {
        return this.state.showingDisabledItems ? (0, _react.jsx)("div", {
            className: disabledTopToolbar
        }, (0, _react.jsx)("div", {
            className: `viewWarningText`
        }, "NOW VIEWING ARCHIVED ITEMS"), (0, _react.jsx)("span", null), (0, _react.jsx)("div", {
            className: `toggleDisabled`,
            onClick: this.toggleDisabledView.bind(this)
        }, "Back to Normal View")) : null;
    }
    resetExpansionGridView(index) {
        this.setState({
            ...this.state,
            reset: true,
            expandedRows: {}
        }, this.resetExpansionGridViewCallback);
    }
    resetExpansionGridViewCallback() {
        this.setState({
            ...this.state,
            reset: false
        });
    }
    generateLinkedContentLinks(linkedContent) {
        const returnArray = [];
        if (linkedContent.contentItems != null) linkedContent.contentItems.forEach((item)=>{
            returnArray.push({
                name: item.name,
                url: (0, _extensions.getEditUrl)(item.contentItemId, item.applicationFeatureId, item.featureTypeId),
                icon: (0, _extensions.getFeatureTypeIcon)(item.featureTypeId, true)
            });
        });
        return returnArray;
    }
    toggleRow(index) {
        const expandedRows = {
            ...this.state.expandedRows
        };
        expandedRows[index] = !(expandedRows[index] === true);
        this.setState({
            ...this.state,
            expandedRows: expandedRows
        });
    }
    expandRow(index) {
        const expandedRows = {
            ...this.state.expandedRows
        };
        expandedRows[index] = true;
        this.setState({
            ...this.state,
            expandedRows: expandedRows
        });
    }
    collapseRow(index) {
        const expandedRows = {
            ...this.state.expandedRows
        };
        expandedRows[index] = false;
        this.setState({
            ...this.state,
            expandedRows: expandedRows
        }, this.resetDisplayedItems);
    }
    toggleDisabledView() {
        this.state.showingDisabledItems ? this.setState({
            ...this.state,
            showingDisabledItems: false
        }, this.resetDisplayedItems) : this.setState({
            ...this.state,
            showingDisabledItems: true
        }, this.resetDisplayedItems);
    }
    render() {
        const columns = [
            {
                id: "chevronCol",
                width: 20,
                Header: (0, _react.jsx)((0, _tableHeaderDefault.default), {
                    text: ""
                }),
                accessor: (item)=>item,
                Cell: (row)=>(0, _react.jsx)("div", {
                        className: expanderContainer
                    }, this.state.expandedRows[row.index] === true ? (0, _react.jsx)((0, _tableCellDefault.default), null, (0, _react.jsx)((0, _toggleIndicatorDefault.default), {
                        onClick: ()=>this.collapseRow(row.index),
                        className: chevronStyle,
                        direction: "up"
                    })) : (0, _react.jsx)((0, _tableCellDefault.default), null, (0, _react.jsx)((0, _toggleIndicatorDefault.default), {
                        onClick: ()=>this.expandRow(row.index),
                        className: chevronStyle,
                        direction: "down"
                    })))
            },
            {
                id: "typeCol",
                width: 50,
                Header: (0, _react.jsx)((0, _tableHeaderDefault.default), {
                    text: "TYPE"
                }),
                accessor: (item)=>item.mediaType,
                Cell: (row)=>(0, _react.jsx)((0, _tableCellDefault.default), {
                        key: "cell1"
                    }, (0, _react.jsx)("img", {
                        src: row.value === "AudioFile" ? audioIconBlack : row.value === "VideoFile" ? videoIconBlack : row.value === "ImageFile" ? imageIconBlack : imageIconBlack
                    }))
            },
            {
                id: "filenameCol",
                Header: (0, _react.jsx)((0, _tableHeaderDefault.default), {
                    text: "FILENAME"
                }),
                accessor: (item)=>item.name,
                Cell: (row)=>(0, _react.jsx)((0, _tableCellDefault.default), {
                        key: "cell2",
                        className: `${textStyle} ${fileDescriptionStyle}`
                    }, (0, _react.jsx)("span", {
                        onClick: ()=>this.toggleRow(row.index)
                    }, row.value ? row.value : "No Name"))
            },
            {
                id: "udpatedCol",
                width: 105,
                Header: (0, _react.jsx)((0, _tableHeaderDefault.default), {
                    text: "UPDATED"
                }),
                accessor: (item)=>{
                    return (0, _momentDefault.default)(item.modifiedDate).format("MMM DD, YYYY");
                },
                Cell: (row)=>(0, _react.jsx)((0, _tableCellDefault.default), {
                        key: "cell3",
                        className: textStyle
                    }, row.value ? row.value : "No Last Updated")
            },
            {
                id: "attachCol",
                width: 90,
                Header: (0, _react.jsx)((0, _tableHeaderDefault.default), {
                    text: ""
                }),
                accessor: (item)=>item,
                Cell: (row)=>(0, _react.jsx)((0, _tableCellDefault.default), {
                        key: "cell3",
                        className: `${textStyle} attach ${attachCell}`
                    }, this.state.showingDisabledItems ? (0, _react.jsx)("div", {
                        onClick: ()=>this.restoreMediaItem(row.value)
                    }, (0, _react.jsx)("span", {
                        className: blueText
                    }, "Restore"), (0, _react.jsx)("img", {
                        src: restoreIcon
                    })) : (0, _react.jsx)("div", {
                        onClick: ()=>this.props.onAttachMediaItem(row.value)
                    }, (0, _react.jsx)("span", {
                        className: blueText
                    }, "Attach"), (0, _react.jsx)("img", {
                        src: attachmentIcon
                    })))
            }
        ];
        const linkedContentData = this.generateLinkedContentLinks(this.state.deletingItemLinkedContent);
        return (0, _react.jsx)("div", {
            className: mediaLibraryTabStyle
        }, (0, _react.jsx)((0, _searchFieldDefault.default), {
            id: "1",
            name: "searchField",
            placeholder: "Search",
            disabled: false,
            onChange: this.handleSearch.bind(this)
        }), (0, _react.jsx)("div", {
            className: textStyle
        }, "Media-Type:"), (0, _react.jsx)((0, _roundedSelectionRowDefault.default), {
            options: [
                {
                    name: "All Media"
                },
                {
                    icon: imageIconBlack,
                    selectedIcon: imageIconBlue,
                    name: "Images"
                },
                {
                    icon: audioIconBlack,
                    selectedIcon: audioIconBlue,
                    name: "Audio"
                },
                {
                    icon: videoIconBlack,
                    selectedIcon: videoIconBlue,
                    name: "Video"
                }
            ],
            onClick: (num)=>this.updateMediaLibraryFilter(num),
            selectedFilter: this.state.selectedMediaFilter
        }), (0, _react.jsx)((0, _sortedPaginatedTableDefault.default), {
            columns: columns,
            renderTopToolbar: this.renderTopToolbar.bind(this),
            items: this.state.displayedItems,
            updateSortValue: (val)=>this.updateSortMethod(val),
            updatePageValue: (b)=>this.updatePageNumber(b),
            updateViewValue: this.toggleView.bind(this),
            view: this.state.view,
            page: this.state.page,
            showView: true,
            reset: this.state.reset,
            sortValue: this.state.sortMethod,
            itemRender: this.renderPreviewItem.bind(this),
            freezeWhenExpanded: this.state.freezeWhenExpanded,
            expandedRows: this.state.expandedRows,
            subComponent: (row)=>(0, _react.jsx)((0, _expandedMediaItemDefault.default), {
                    onUpdateMediaItem: (item, index)=>this.updateMediaItem(item, index),
                    key: row.index,
                    onReplaceMediaItem: this.replaceMediaItem.bind(this),
                    mediaItem: row.original,
                    index: row.index,
                    onDeleteItem: this.attemptDelete.bind(this),
                    onAttachMediaItem: this.props.onAttachMediaItem,
                    onRestoreMediaItem: this.restoreMediaItem.bind(this),
                    onCollapse: this.collapseRow.bind(this),
                    loadLinkedContent: (mediaItemId)=>{
                        return this.props.mediaContainer.getLinkedContent(mediaItemId);
                    },
                    generateLinkedContentLinks: this.generateLinkedContentLinks.bind(this)
                }),
            expandRender: (media, index, column)=>(0, _react.jsx)((0, _expandedMediaItemDefault.default), {
                    onUpdateMediaItem: (media, index)=>this.updateMediaItem(media, index),
                    onReplaceMediaItem: this.replaceMediaItem.bind(this),
                    mediaItem: media,
                    onRestoreMediaItem: this.restoreMediaItem.bind(this),
                    column: column,
                    index: index * 2 + column //we need to figure out the actual index in the displayed items arry.
                    ,
                    onDeleteItem: this.attemptDelete.bind(this),
                    onAttachMediaItem: this.props.onAttachMediaItem,
                    loadLinkedContent: (mediaItemId)=>{
                        return this.props.mediaContainer.getLinkedContent(mediaItemId);
                    },
                    generateLinkedContentLinks: this.generateLinkedContentLinks.bind(this),
                    onCollapse: this.resetExpansionGridView.bind(this)
                }),
            sortOptions: [
                {
                    value: "LastUpdated",
                    label: "Last Updated - Newest"
                },
                {
                    value: "OldestUpdated",
                    label: "Last Updated - Oldest"
                },
                {
                    value: "NameA2Z",
                    label: "Alphabetical - A-Z"
                },
                {
                    value: "NameZ2A",
                    label: "Alphabetical - Z-A"
                }
            ]
        }), this.state.isDeleteModuleVisible ? (0, _react.jsx)((0, _confirmationDialogDefault.default), {
            title: "Delete",
            isLoading: this.state.isDeleteLoading,
            deleteText: "Yes, Delete",
            onClose: ()=>this.closeDeleteModal(()=>{}),
            disabled: this.state.deletingItem.isDisabled === true && this.state.deletingItemLinkedContent.contentItems.length > 0,
            onConfirm: ()=>this.deleteMediaItem()
        }, (0, _react.jsx)((0, _removeConfirmationDefault.default), {
            customText: this.state.deletingItem.isDisabled ? linkedContentData.length > 0 ? (0, _react.jsx)("div", {
                className: deleteStyle
            }, "You are not currently able to permanently delete", (0, _react.jsx)("b", null, " ", this.state.deletingItem.name), ". You must first clear it from all linked content.", linkedContentData.length > 0 ? ` It is currently linked to ${linkedContentData.length} content items.` : "") : (0, _react.jsx)("div", {
                className: deleteStyle
            }, "Are you sure you want to permenantly delete", (0, _react.jsx)("b", null, " ", this.state.deletingItem.name), "?") : (0, _react.jsx)("div", {
                className: deleteStyle
            }, "Are you sure you want to delete", (0, _react.jsx)("b", null, " ", this.state.deletingItem.name), "? ", linkedContentData.length > 0 ? `It is currently linked to ${linkedContentData.length} content items.` : "")
        })) : null, (0, _react.jsx)("div", {
            className: bottomRow
        }, (0, _react.jsx)("div", {
            className: bottomToggle,
            onClick: this.toggleDisabledView.bind(this)
        }, this.state.showingDisabledItems ? "Back to Normal View" : "Show Archived Items"), (0, _react.jsx)((0, _numberIncrementSelectorDefault.default), {
            selectedNumber: this.state.page < 10 ? "0" + this.state.page : "" + this.state.page,
            updateValue: (b)=>this.updatePageNumber(b),
            showNumber: true
        })));
    }
}
const bottomRow = /*#__PURE__*/ (0, _css.css)({
    name: "1gj1t4f",
    styles: "padding-top:15px;padding-bottom:15px;display:flex;flex-direction:row;.page-container{margin-left:auto;margin-right:0px;}"
});
const bottomToggle = /*#__PURE__*/ (0, _css.css)("cursor:pointer;color:", (0, _colors.ocean_blue), ";font-size:14px;font-family:Muli;padding-top:10px;", "");
const disabledTopToolbar = /*#__PURE__*/ (0, _css.css)("display:flex;flex-direction:row;font-family:Muli;font-size:14px;padding-bottom:10px;font-weight:normal;font-style:normal;font-stretch:normal;line-height:normal;letter-spacing:0.5px;text-align:center;.toggleDisabled{color:", (0, _colors.ocean_blue), ";cursor:pointer;}span{flex-grow:1;}", "");
const deleteStyle = /*#__PURE__*/ (0, _css.css)({
    name: "qy2swf",
    styles: "font-family:Muli;font-size:14px;font-weight:normal;font-style:normal;font-stretch:normal;line-height:normal;letter-spacing:0.5px;text-align:center"
});
const attachCell = /*#__PURE__*/ (0, _css.css)({
    name: "z2if52",
    styles: "img{padding-top:5px;padding-right:10px;}"
});
const textStyle = /*#__PURE__*/ (0, _css.css)({
    name: "bazpk",
    styles: "font-family:Muli;font-size:14px;font-weight:normal;font-style:normal;cursor:pointer;font-stretch:normal;line-height:1.33;letter-spacing:normal;.attach{padding-top:5px;}"
});
const fileDescriptionStyle = /*#__PURE__*/ (0, _css.css)({
    name: "114oayd",
    styles: "white-space:normal;word-break:break-all"
});
const blueText = /*#__PURE__*/ (0, _css.css)("padding-right:10px;color:", (0, _colors.ocean_blue), ";top:-5px;position:relative;", "");
const mediaLibraryTabStyle = /*#__PURE__*/ (0, _css.css)({
    name: "1azakc",
    styles: "text-align:center"
});
const chevronStyle = /*#__PURE__*/ (0, _css.css)({
    name: "1qkltea",
    styles: "margin-left:5px"
});
const expanderContainer = /*#__PURE__*/ (0, _css.css)({
    name: "e0dnmk",
    styles: "cursor:pointer"
});
exports.default = MediaLibraryTab;

},{"@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","../../../components/forms/SearchField":"aU10T","../../../components/general/RoundedSelectionRow":"dUH5O","../../../components/general/SortedPaginatedTable":"7z5P9","../../../components/general/TableCell":"2zNzE","../../../components/general/TableHeader":"9EPgz","../../../components/general/ToggleIndicator":"4eej1","../../../constants/colors":"1p3OR","./ExpandedMediaItem":"gFi8C","../../../components/structure/ConfirmationDialog":"kx7yK","../../../components/general/RemoveConfirmation":"elIoY","./MediaGridPreview":"ja9KM","../../../models/extensions":"7h01B","moment":"2meyw","../../../components/forms/NumberIncrementSelector":"kU0zB","35c569b4042d6262":"dZ4mZ","8044e6f4718fc9b6":"ffCq8","b0edd2e27c5edf01":"4Elru","562c2ab142b29f8b":"5iZBB","b7e205834cf0f1d0":"a90NN","23708cd97f6e0627":"hx9zt","d56a4c23f41415d5":"iT0Wx","99d7d9ceeec6f7ed":"jMadF","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"aU10T":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _colors = require("../../constants/colors");
var _iconTooltip = require("../general/IconTooltip");
var _iconTooltipDefault = parcelHelpers.interopDefault(_iconTooltip);
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const searchImage = require("50f921e261992355");
const SearchField = (props)=>{
    let field;
    return (0, _react.jsx)("div", {
        className: `${containerStyle} ${props.className}`
    }, (0, _react.jsx)("div", {
        className: labelContainer
    }, props.label !== undefined ? (0, _react.jsx)("label", {
        htmlFor: props.name,
        className: labelStyle
    }, props.label) : null, props.tooltip !== undefined ? (0, _react.jsx)((0, _iconTooltipDefault.default), {
        text: props.tooltip,
        className: tooltipStyle,
        place: props.toolTipPosition ? props.toolTipPosition : "top"
    }) : null), (0, _react.jsx)("div", {
        className: fieldWrapper
    }, (0, _react.jsx)("div", {
        className: `${props.boxType === "square" ? squareFieldContainer : fieldContainer}  ${props.disabled ? "disabled" : ""} field-container`
    }, (0, _react.jsx)("img", {
        className: props.searchStyle,
        src: props.searchIcon ? props.searchIcon : searchImage
    }), (0, _react.jsx)("input", {
        id: props.id,
        className: props.boxType === "square" ? squareSearchFieldStyles : searchFieldStyles,
        type: props.type,
        name: props.name,
        ref: (input)=>field = input,
        placeholder: props.placeholder,
        value: props.value,
        onChange: props.onChange,
        onBlur: props.onBlur,
        onKeyDown: props.onKeyDown,
        disabled: props.disabled
    }), (0, _react.jsx)("img", {
        className: props.deleteStyle,
        src: props.deleteIcon && props.deleteIcon,
        onClick: props.handleClear
    }))));
};
const searchFieldStyles = /*#__PURE__*/ (0, _css.css)("color:", (0, _colors.dark_grey_blue), " font-family:Muli sans-serif;text-align:left;width:100%;border-radius:25px;border:none;padding:12px 16px;font-size:14px;background:transparent;::placeholder{font-weight:normal;font-style:italic;font-stretch:normal;letter-spacing:normal;color:", (0, _colors.cool_grey), ";}", "");
const squareSearchFieldStyles = /*#__PURE__*/ (0, _css.css)("color:", (0, _colors.dark_grey_blue), " font-family:Muli sans-serif;text-align:left;width:100%;border-radius:8px 8px 8px 8px;border:none;padding:12px 16px;font-size:14px;background:transparent;::placeholder{font-weight:normal;font-style:italic;font-stretch:normal;letter-spacing:normal;color:", (0, _colors.cool_grey), ";}", "");
const containerStyle = /*#__PURE__*/ (0, _css.css)({
    name: "11j4wuo",
    styles: "margin-bottom:24px;flex:1;&.tight{margin-bottom:16px;label{margin:8px 16px 0 16px;}}"
});
const labelStyle = /*#__PURE__*/ (0, _css.css)({
    name: "1uou4su",
    styles: "font-family:Muli;font-size:14px;font-weight:600;text-align:left;margin:24px 16px 0 16px"
});
const tooltipStyle = /*#__PURE__*/ (0, _css.css)({
    name: "3xaa4j",
    styles: "margin:0;margin-top:24px;margin-bottom:0"
});
const labelContainer = /*#__PURE__*/ (0, _css.css)({
    name: "s5xdrg",
    styles: "display:flex;align-items:center"
});
const fieldContainer = /*#__PURE__*/ (0, _css.css)("display:flex;align-items:center;height:45px;width:100%;border-radius:25px;border:solid 1px ", (0, _colors.silver_two), ";box-shadow:inset 0 1px 1px 0 ", (0, _colors.dark_grey_blue_30), ";background:white;margin-top:8px;img{margin:16px;margin-right:0px;}&.disabled{background:", (0, _colors.pale_grey), ";input{background:", (0, _colors.pale_grey), ";}}", "");
const squareFieldContainer = /*#__PURE__*/ (0, _css.css)("display:flex;align-items:center;height:45px;width:100%;border-radius:8px 8px 8px 8px;border:solid 1px ", (0, _colors.silver_two), ";box-shadow:inset 0 1px 1px 0 ", (0, _colors.dark_grey_blue_30), ";background:white;margin-top:8px;img{margin:16px;margin-right:0px;}&.disabled{background:", (0, _colors.pale_grey), ";input{background:", (0, _colors.pale_grey), ";}}", "");
const fieldWrapper = /*#__PURE__*/ (0, _css.css)({
    name: "fhxb3m",
    styles: "display:flex;flex-direction:row;align-items:center"
});
exports.default = SearchField;

},{"@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","../../constants/colors":"1p3OR","../general/IconTooltip":"3FODC","50f921e261992355":"6eytJ","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6eytJ":[function(require,module,exports) {
module.exports = require("c948aee1493972f9").getBundleURL("kVLro") + require("254141f2df889c4").resolve("b3SlJ");

},{"c948aee1493972f9":"c7Tr5","254141f2df889c4":"fyJL2"}],"dUH5O":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _colors = require("../../constants/colors");
var _roundedSelectionOption = require("./RoundedSelectionOption");
var _roundedSelectionOptionDefault = parcelHelpers.interopDefault(_roundedSelectionOption);
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// component used in building forms with consistent components for look and function
const RoundedSelectionRow = (props)=>(0, _react.jsx)("div", {
        className: `${fieldWrapper} ${props.className ?? ""}`
    }, (0, _react.jsx)("div", {
        className: selectorContainer
    }, props.options.map((filterOption, index)=>(0, _react.jsx)((0, _roundedSelectionOptionDefault.default), {
            onClick: ()=>props.onClick(index),
            selected: index === props.selectedFilter,
            selectedIcon: filterOption.selectedIcon,
            name: filterOption.name,
            icon: filterOption.icon,
            key: index,
            className: props.optionClassName,
            optionNumber: index,
            textStyle: props.optionTextClassName
        }))));
const selectorContainer = /*#__PURE__*/ (0, _css.css)("display:flex;align-items:center;width:100%;border-radius:50px;border:solid 1px ", (0, _colors.silver_two), ";background:white;margin-top:8px;box-sizing:border-box;", "");
const fieldWrapper = /*#__PURE__*/ (0, _css.css)({
    name: "110y2dl",
    styles: "display:flex;flex-direction:row;align-items:center;box-sizing:border-box;width:400px"
});
exports.default = RoundedSelectionRow;

},{"@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","../../constants/colors":"1p3OR","./RoundedSelectionOption":"kslYE","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"kslYE":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _colors = require("../../constants/colors");
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// component used in building forms with consistent components for look and function
class RoundedSelectionOption extends (0, _reactDefault.default).Component {
    render() {
        const props = {
            ...this.props
        };
        const buttonClassName = `${optionStyle} ${props.selected ? props.customSelectedStyle ?? selectedStyle : props.customDefaultStyle ?? defaultStyle} ${props.className ?? ""}`;
        return (0, _react.jsx)("button", {
            type: "button",
            className: buttonClassName,
            onClick: ()=>this.props.onClick(this.props.optionNumber)
        }, (0, _react.jsx)("div", {
            className: `${textIconContainer} ${props.textStyle ?? ""}`
        }, props.icon !== undefined ? (0, _react.jsx)("img", {
            src: props.selected ? props.selectedIcon ? props.selectedIcon : props.icon : props.icon,
            className: optionIconStyle
        }) : null, (0, _react.jsx)("span", {
            className: `${textStyle} ${props.selected && selectedTextStyle}`
        }, props.name)));
    }
}
const optionStyle = /*#__PURE__*/ (0, _css.css)({
    name: "n86g0c",
    styles: "display:inline-block;align-items:center;height:35px;width:100%;box-sizing:border-box;border-radius:50px;background:white;text-align:center;cursor:pointer;padding:0 14px 0 14px"
});
const textStyle = /*#__PURE__*/ (0, _css.css)({
    name: "1htpajv",
    styles: "font-family:Muli;font-size:14;font-weight:normal;font-style:normal;font-stretch:normal;line-height:1.33;letter-spacing:normal;box-sizing:border-box;color:var(--structure-color-inverted);position:relative;top:2px"
});
const selectedTextStyle = /*#__PURE__*/ (0, _css.css)("color:", (0, _colors.ocean_blue), ";", "");
const optionIconStyle = /*#__PURE__*/ (0, _css.css)({
    name: "1chr3to",
    styles: "width:20px;height:20px;margin-right:8px;vertical-align:middle;box-sizing:border-box"
});
const textIconContainer = /*#__PURE__*/ (0, _css.css)({
    name: "10th6wa",
    styles: "display:inline-block;box-sizing:border-box"
});
const selectedStyle = /*#__PURE__*/ (0, _css.css)("box-shadow:0 4px 20px 0 ", (0, _colors.color_variants_shadow_10), ";border:solid 1px ", (0, _colors.silver_two), ";", "");
const defaultStyle = /*#__PURE__*/ (0, _css.css)({
    name: "16xa7k7",
    styles: "border:0px;border-radius:2px;border:solid 1px transparent;background:transparent"
});
exports.default = RoundedSelectionOption;

},{"@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","../../constants/colors":"1p3OR","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7z5P9":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _reactTable = require("react-table");
var _reactTableDefault = parcelHelpers.interopDefault(_reactTable);
var _sortAndPageControl = require("./SortAndPageControl");
var _sortAndPageControlDefault = parcelHelpers.interopDefault(_sortAndPageControl);
var _expandableGrid = require("./ExpandableGrid");
var _expandableGridDefault = parcelHelpers.interopDefault(_expandableGrid);
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// component used in building forms with consistent components for look and function
const tableStyles = /*#__PURE__*/ (0, _css.css)({
    name: "1afnqsh",
    styles: "border-radius:10px;border:solid 1px #cccccc;overflow:hidden;.rt-table{background:white;width:100%;overflow:hidden;.rt-thead,.rt-thead -header{min-height:52px;box-shadow:none;border-bottom:solid 1px #cccccc;cursor:default;.rt-th{border:none;cursor:default;box-shadow:none;.rt-resizable-header-content{cursor:default;div{padding:0px;cursor:default;padding-top:12px;}}}}.rt-tbody{min-height:64px;overflow:hidden;.rt-tr-group{min-height:52px;width:100%;border-bottom:solid 1px #cccccc;.rt-tr{background:transparent;width:100%;min-height:52px;border:none;overflow:visible;}}}div.rt-td{background:transparent;align-self:center;overflow:visible;border-right:none;&.rt-expandable{display:none;}}}.rt-noData{padding-top:80px;background:transparent;}"
});
class SortedPaginatedTable extends (0, _reactDefault.default).Component {
    render() {
        return (0, _react.jsx)("div", {
            className: this.props.className
        }, (0, _react.jsx)((0, _sortAndPageControlDefault.default), {
            updatePageValue: this.props.updatePageValue,
            updateSortValue: this.props.updateSortValue,
            showView: this.props.showView,
            view: this.props.view,
            updateViewValue: this.props.updateViewValue,
            sortValue: this.props.sortValue,
            page: this.props.page < 10 ? "0" + this.props.page : "" + this.props.page,
            sortOptions: this.props.sortOptions
        }), this.props.renderTopToolbar(), this.props.view.localeCompare("table") === 0 ? (0, _react.jsx)((0, _reactTableDefault.default), {
            className: tableStyles,
            data: this.props.items,
            sortable: false,
            resizable: false,
            expanded: this.props.expandedRows,
            columns: this.props.columns,
            minRows: 1,
            showPagination: false,
            SubComponent: this.props.subComponent,
            freezeWhenExpanded: this.props.freezeWhenExpanded
        }) : (0, _react.jsx)((0, _expandableGridDefault.default), {
            itemRender: this.props.itemRender,
            expandRender: this.props.expandRender,
            data: this.props.items,
            enableExpand: true,
            reset: this.props.reset,
            columnCount: 2
        }));
    }
}
exports.default = SortedPaginatedTable;

},{"@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","react-table":"e4yqY","./SortAndPageControl":"1NDiI","./ExpandableGrid":"97U0d","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"e4yqY":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactTableDefaults", ()=>ReactTableDefaults);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
//
var _utils = require("./utils");
var _utilsDefault = parcelHelpers.interopDefault(_utils);
var _lifecycle = require("./lifecycle");
var _lifecycleDefault = parcelHelpers.interopDefault(_lifecycle);
var _methods = require("./methods");
var _methodsDefault = parcelHelpers.interopDefault(_methods);
var _defaultProps = require("./defaultProps");
var _defaultPropsDefault = parcelHelpers.interopDefault(_defaultProps);
var _propTypes = require("./propTypes");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _slicedToArray = function() {
    function sliceIterator(arr, i) {
        var _arr = [];
        var _n = true;
        var _d = false;
        var _e = undefined;
        try {
            for(var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true){
                _arr.push(_s.value);
                if (i && _arr.length === i) break;
            }
        } catch (err) {
            _d = true;
            _e = err;
        } finally{
            try {
                if (!_n && _i["return"]) _i["return"]();
            } finally{
                if (_d) throw _e;
            }
        }
        return _arr;
    }
    return function(arr, i) {
        if (Array.isArray(arr)) return arr;
        else if (Symbol.iterator in Object(arr)) return sliceIterator(arr, i);
        else throw new TypeError("Invalid attempt to destructure non-iterable instance");
    };
}();
var _extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var _createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var ReactTableDefaults = (0, _defaultPropsDefault.default);
var ReactTable = function(_Methods) {
    _inherits(ReactTable, _Methods);
    function ReactTable(props) {
        _classCallCheck(this, ReactTable);
        var _this = _possibleConstructorReturn(this, (ReactTable.__proto__ || Object.getPrototypeOf(ReactTable)).call(this, props));
        _this.getResolvedState = _this.getResolvedState.bind(_this);
        _this.getDataModel = _this.getDataModel.bind(_this);
        _this.getSortedData = _this.getSortedData.bind(_this);
        _this.fireFetchData = _this.fireFetchData.bind(_this);
        _this.getPropOrState = _this.getPropOrState.bind(_this);
        _this.getStateOrProp = _this.getStateOrProp.bind(_this);
        _this.filterData = _this.filterData.bind(_this);
        _this.sortData = _this.sortData.bind(_this);
        _this.getMinRows = _this.getMinRows.bind(_this);
        _this.onPageChange = _this.onPageChange.bind(_this);
        _this.onPageSizeChange = _this.onPageSizeChange.bind(_this);
        _this.sortColumn = _this.sortColumn.bind(_this);
        _this.filterColumn = _this.filterColumn.bind(_this);
        _this.resizeColumnStart = _this.resizeColumnStart.bind(_this);
        _this.resizeColumnEnd = _this.resizeColumnEnd.bind(_this);
        _this.resizeColumnMoving = _this.resizeColumnMoving.bind(_this);
        return _this;
    }
    _createClass(ReactTable, [
        {
            key: "render",
            value: function render() {
                var _this2 = this;
                var resolvedState = this.getResolvedState();
                var children = resolvedState.children, className = resolvedState.className, style = resolvedState.style, getProps = resolvedState.getProps, getTableProps = resolvedState.getTableProps, getTheadGroupProps = resolvedState.getTheadGroupProps, getTheadGroupTrProps = resolvedState.getTheadGroupTrProps, getTheadGroupThProps = resolvedState.getTheadGroupThProps, getTheadProps = resolvedState.getTheadProps, getTheadTrProps = resolvedState.getTheadTrProps, getTheadThProps = resolvedState.getTheadThProps, getTheadFilterProps = resolvedState.getTheadFilterProps, getTheadFilterTrProps = resolvedState.getTheadFilterTrProps, getTheadFilterThProps = resolvedState.getTheadFilterThProps, getTbodyProps = resolvedState.getTbodyProps, getTrGroupProps = resolvedState.getTrGroupProps, getTrProps = resolvedState.getTrProps, getTdProps = resolvedState.getTdProps, getTfootProps = resolvedState.getTfootProps, getTfootTrProps = resolvedState.getTfootTrProps, getTfootTdProps = resolvedState.getTfootTdProps, getPaginationProps = resolvedState.getPaginationProps, getLoadingProps = resolvedState.getLoadingProps, getNoDataProps = resolvedState.getNoDataProps, getResizerProps = resolvedState.getResizerProps, showPagination = resolvedState.showPagination, showPaginationTop = resolvedState.showPaginationTop, showPaginationBottom = resolvedState.showPaginationBottom, manual = resolvedState.manual, loadingText = resolvedState.loadingText, noDataText = resolvedState.noDataText, sortable = resolvedState.sortable, multiSort = resolvedState.multiSort, resizable = resolvedState.resizable, filterable = resolvedState.filterable, pivotIDKey = resolvedState.pivotIDKey, pivotValKey = resolvedState.pivotValKey, pivotBy = resolvedState.pivotBy, subRowsKey = resolvedState.subRowsKey, aggregatedKey = resolvedState.aggregatedKey, originalKey = resolvedState.originalKey, indexKey = resolvedState.indexKey, groupedByPivotKey = resolvedState.groupedByPivotKey, loading = resolvedState.loading, pageSize = resolvedState.pageSize, page = resolvedState.page, sorted = resolvedState.sorted, filtered = resolvedState.filtered, resized = resolvedState.resized, expanded = resolvedState.expanded, pages = resolvedState.pages, onExpandedChange = resolvedState.onExpandedChange, TableComponent = resolvedState.TableComponent, TheadComponent = resolvedState.TheadComponent, TbodyComponent = resolvedState.TbodyComponent, TrGroupComponent = resolvedState.TrGroupComponent, TrComponent = resolvedState.TrComponent, ThComponent = resolvedState.ThComponent, TdComponent = resolvedState.TdComponent, TfootComponent = resolvedState.TfootComponent, PaginationComponent = resolvedState.PaginationComponent, LoadingComponent = resolvedState.LoadingComponent, SubComponent = resolvedState.SubComponent, NoDataComponent = resolvedState.NoDataComponent, ResizerComponent = resolvedState.ResizerComponent, ExpanderComponent = resolvedState.ExpanderComponent, PivotValueComponent = resolvedState.PivotValueComponent, PivotComponent = resolvedState.PivotComponent, AggregatedComponent = resolvedState.AggregatedComponent, FilterComponent = resolvedState.FilterComponent, PadRowComponent = resolvedState.PadRowComponent, resolvedData = resolvedState.resolvedData, allVisibleColumns = resolvedState.allVisibleColumns, headerGroups = resolvedState.headerGroups, hasHeaderGroups = resolvedState.hasHeaderGroups, sortedData = resolvedState.sortedData, currentlyResizing = resolvedState.currentlyResizing;
                // Pagination
                var startRow = pageSize * page;
                var endRow = startRow + pageSize;
                var pageRows = manual ? resolvedData : sortedData.slice(startRow, endRow);
                var minRows = this.getMinRows();
                var padRows = (0, _utilsDefault.default).range(Math.max(minRows - pageRows.length, 0));
                var hasColumnFooter = allVisibleColumns.some(function(d) {
                    return d.Footer;
                });
                var hasFilters = filterable || allVisibleColumns.some(function(d) {
                    return d.filterable;
                });
                var recurseRowsViewIndex = function recurseRowsViewIndex(rows) {
                    var path = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
                    var index = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : -1;
                    return [
                        rows.map(function(row, i) {
                            index += 1;
                            var rowWithViewIndex = _extends({}, row, {
                                _viewIndex: index
                            });
                            var newPath = path.concat([
                                i
                            ]);
                            if (rowWithViewIndex[subRowsKey] && (0, _utilsDefault.default).get(expanded, newPath)) {
                                var _recurseRowsViewIndex = recurseRowsViewIndex(rowWithViewIndex[subRowsKey], newPath, index);
                                var _recurseRowsViewIndex2 = _slicedToArray(_recurseRowsViewIndex, 2);
                                rowWithViewIndex[subRowsKey] = _recurseRowsViewIndex2[0];
                                index = _recurseRowsViewIndex2[1];
                            }
                            return rowWithViewIndex;
                        }),
                        index
                    ];
                };
                var _recurseRowsViewIndex3 = recurseRowsViewIndex(pageRows);
                var _recurseRowsViewIndex4 = _slicedToArray(_recurseRowsViewIndex3, 1);
                pageRows = _recurseRowsViewIndex4[0];
                var canPrevious = page > 0;
                var canNext = page + 1 < pages;
                var rowMinWidth = (0, _utilsDefault.default).sum(allVisibleColumns.map(function(d) {
                    var resizedColumn = resized.find(function(x) {
                        return x.id === d.id;
                    }) || {};
                    return (0, _utilsDefault.default).getFirstDefined(resizedColumn.value, d.width, d.minWidth);
                }));
                var rowIndex = -1;
                var finalState = _extends({}, resolvedState, {
                    startRow: startRow,
                    endRow: endRow,
                    pageRows: pageRows,
                    minRows: minRows,
                    padRows: padRows,
                    hasColumnFooter: hasColumnFooter,
                    canPrevious: canPrevious,
                    canNext: canNext,
                    rowMinWidth: rowMinWidth
                });
                var rootProps = (0, _utilsDefault.default).splitProps(getProps(finalState, undefined, undefined, this));
                var tableProps = (0, _utilsDefault.default).splitProps(getTableProps(finalState, undefined, undefined, this));
                var tBodyProps = (0, _utilsDefault.default).splitProps(getTbodyProps(finalState, undefined, undefined, this));
                var loadingProps = getLoadingProps(finalState, undefined, undefined, this);
                var noDataProps = getNoDataProps(finalState, undefined, undefined, this);
                // Visual Components
                var makeHeaderGroup = function makeHeaderGroup(column, i) {
                    var resizedValue = function resizedValue(col) {
                        return (resized.find(function(x) {
                            return x.id === col.id;
                        }) || {}).value;
                    };
                    var flex = (0, _utilsDefault.default).sum(column.columns.map(function(col) {
                        return col.width || resizedValue(col) ? 0 : col.minWidth;
                    }));
                    var width = (0, _utilsDefault.default).sum(column.columns.map(function(col) {
                        return (0, _utilsDefault.default).getFirstDefined(resizedValue(col), col.width, col.minWidth);
                    }));
                    var maxWidth = (0, _utilsDefault.default).sum(column.columns.map(function(col) {
                        return (0, _utilsDefault.default).getFirstDefined(resizedValue(col), col.width, col.maxWidth);
                    }));
                    var theadGroupThProps = (0, _utilsDefault.default).splitProps(getTheadGroupThProps(finalState, undefined, column, _this2));
                    var columnHeaderProps = (0, _utilsDefault.default).splitProps(column.getHeaderProps(finalState, undefined, column, _this2));
                    var classes = [
                        column.headerClassName,
                        theadGroupThProps.className,
                        columnHeaderProps.className
                    ];
                    var styles = _extends({}, column.headerStyle, theadGroupThProps.style, columnHeaderProps.style);
                    var rest = _extends({}, theadGroupThProps.rest, columnHeaderProps.rest);
                    var flexStyles = {
                        flex: flex + " 0 auto",
                        width: (0, _utilsDefault.default).asPx(width),
                        maxWidth: (0, _utilsDefault.default).asPx(maxWidth)
                    };
                    return (0, _reactDefault.default).createElement(ThComponent, _extends({
                        key: i + "-" + column.id,
                        className: (0, _classnamesDefault.default)(classes),
                        style: _extends({}, styles, flexStyles)
                    }, rest), (0, _utilsDefault.default).normalizeComponent(column.Header, {
                        data: sortedData,
                        column: column
                    }));
                };
                var makeHeaderGroups = function makeHeaderGroups() {
                    var theadGroupProps = (0, _utilsDefault.default).splitProps(getTheadGroupProps(finalState, undefined, undefined, _this2));
                    var theadGroupTrProps = (0, _utilsDefault.default).splitProps(getTheadGroupTrProps(finalState, undefined, undefined, _this2));
                    return (0, _reactDefault.default).createElement(TheadComponent, _extends({
                        className: (0, _classnamesDefault.default)("-headerGroups", theadGroupProps.className),
                        style: _extends({}, theadGroupProps.style, {
                            minWidth: rowMinWidth + "px"
                        })
                    }, theadGroupProps.rest), (0, _reactDefault.default).createElement(TrComponent, _extends({
                        className: theadGroupTrProps.className,
                        style: theadGroupTrProps.style
                    }, theadGroupTrProps.rest), headerGroups.map(makeHeaderGroup)));
                };
                var makeHeader = function makeHeader(column, i) {
                    var resizedCol = resized.find(function(x) {
                        return x.id === column.id;
                    }) || {};
                    var sort = sorted.find(function(d) {
                        return d.id === column.id;
                    });
                    var show = typeof column.show === "function" ? column.show() : column.show;
                    var width = (0, _utilsDefault.default).getFirstDefined(resizedCol.value, column.width, column.minWidth);
                    var maxWidth = (0, _utilsDefault.default).getFirstDefined(resizedCol.value, column.width, column.maxWidth);
                    var theadThProps = (0, _utilsDefault.default).splitProps(getTheadThProps(finalState, undefined, column, _this2));
                    var columnHeaderProps = (0, _utilsDefault.default).splitProps(column.getHeaderProps(finalState, undefined, column, _this2));
                    var classes = [
                        column.headerClassName,
                        theadThProps.className,
                        columnHeaderProps.className
                    ];
                    var styles = _extends({}, column.headerStyle, theadThProps.style, columnHeaderProps.style);
                    var rest = _extends({}, theadThProps.rest, columnHeaderProps.rest);
                    var isResizable = (0, _utilsDefault.default).getFirstDefined(column.resizable, resizable, false);
                    var resizer = isResizable ? (0, _reactDefault.default).createElement(ResizerComponent, _extends({
                        onMouseDown: function onMouseDown(e) {
                            return _this2.resizeColumnStart(e, column, false);
                        },
                        onTouchStart: function onTouchStart(e) {
                            return _this2.resizeColumnStart(e, column, true);
                        }
                    }, getResizerProps("finalState", undefined, column, _this2))) : null;
                    var isSortable = (0, _utilsDefault.default).getFirstDefined(column.sortable, sortable, false);
                    return (0, _reactDefault.default).createElement(ThComponent, _extends({
                        key: i + "-" + column.id,
                        className: (0, _classnamesDefault.default)(classes, isResizable && "rt-resizable-header", sort ? sort.desc ? "-sort-desc" : "-sort-asc" : "", isSortable && "-cursor-pointer", !show && "-hidden", pivotBy && pivotBy.slice(0, -1).includes(column.id) && "rt-header-pivot"),
                        style: _extends({}, styles, {
                            flex: width + " 0 auto",
                            width: (0, _utilsDefault.default).asPx(width),
                            maxWidth: (0, _utilsDefault.default).asPx(maxWidth)
                        }),
                        toggleSort: function toggleSort(e) {
                            if (isSortable) _this2.sortColumn(column, multiSort ? e.shiftKey : false);
                        }
                    }, rest), (0, _reactDefault.default).createElement("div", {
                        className: (0, _classnamesDefault.default)(isResizable && "rt-resizable-header-content")
                    }, (0, _utilsDefault.default).normalizeComponent(column.Header, {
                        data: sortedData,
                        column: column
                    })), resizer);
                };
                var makeHeaders = function makeHeaders() {
                    var theadProps = (0, _utilsDefault.default).splitProps(getTheadProps(finalState, undefined, undefined, _this2));
                    var theadTrProps = (0, _utilsDefault.default).splitProps(getTheadTrProps(finalState, undefined, undefined, _this2));
                    return (0, _reactDefault.default).createElement(TheadComponent, _extends({
                        className: (0, _classnamesDefault.default)("-header", theadProps.className),
                        style: _extends({}, theadProps.style, {
                            minWidth: rowMinWidth + "px"
                        })
                    }, theadProps.rest), (0, _reactDefault.default).createElement(TrComponent, _extends({
                        className: theadTrProps.className,
                        style: theadTrProps.style
                    }, theadTrProps.rest), allVisibleColumns.map(makeHeader)));
                };
                var makeFilter = function makeFilter(column, i) {
                    var resizedCol = resized.find(function(x) {
                        return x.id === column.id;
                    }) || {};
                    var width = (0, _utilsDefault.default).getFirstDefined(resizedCol.value, column.width, column.minWidth);
                    var maxWidth = (0, _utilsDefault.default).getFirstDefined(resizedCol.value, column.width, column.maxWidth);
                    var theadFilterThProps = (0, _utilsDefault.default).splitProps(getTheadFilterThProps(finalState, undefined, column, _this2));
                    var columnHeaderProps = (0, _utilsDefault.default).splitProps(column.getHeaderProps(finalState, undefined, column, _this2));
                    var classes = [
                        column.headerClassName,
                        theadFilterThProps.className,
                        columnHeaderProps.className
                    ];
                    var styles = _extends({}, column.headerStyle, theadFilterThProps.style, columnHeaderProps.style);
                    var rest = _extends({}, theadFilterThProps.rest, columnHeaderProps.rest);
                    var filter = filtered.find(function(filter) {
                        return filter.id === column.id;
                    });
                    var ResolvedFilterComponent = column.Filter || FilterComponent;
                    var isFilterable = (0, _utilsDefault.default).getFirstDefined(column.filterable, filterable, false);
                    return (0, _reactDefault.default).createElement(ThComponent, _extends({
                        key: i + "-" + column.id,
                        className: (0, _classnamesDefault.default)(classes),
                        style: _extends({}, styles, {
                            flex: width + " 0 auto",
                            width: (0, _utilsDefault.default).asPx(width),
                            maxWidth: (0, _utilsDefault.default).asPx(maxWidth)
                        })
                    }, rest), isFilterable ? (0, _utilsDefault.default).normalizeComponent(ResolvedFilterComponent, {
                        column: column,
                        filter: filter,
                        onChange: function onChange(value) {
                            return _this2.filterColumn(column, value);
                        }
                    }, (0, _defaultPropsDefault.default).column.Filter) : null);
                };
                var makeFilters = function makeFilters() {
                    var theadFilterProps = (0, _utilsDefault.default).splitProps(getTheadFilterProps(finalState, undefined, undefined, _this2));
                    var theadFilterTrProps = (0, _utilsDefault.default).splitProps(getTheadFilterTrProps(finalState, undefined, undefined, _this2));
                    return (0, _reactDefault.default).createElement(TheadComponent, _extends({
                        className: (0, _classnamesDefault.default)("-filters", theadFilterProps.className),
                        style: _extends({}, theadFilterProps.style, {
                            minWidth: rowMinWidth + "px"
                        })
                    }, theadFilterProps.rest), (0, _reactDefault.default).createElement(TrComponent, _extends({
                        className: theadFilterTrProps.className,
                        style: theadFilterTrProps.style
                    }, theadFilterTrProps.rest), allVisibleColumns.map(makeFilter)));
                };
                var makePageRow = function makePageRow(row, i) {
                    var path = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
                    var rowInfo = {
                        original: row[originalKey],
                        row: row,
                        index: row[indexKey],
                        viewIndex: rowIndex += 1,
                        pageSize: pageSize,
                        page: page,
                        level: path.length,
                        nestingPath: path.concat([
                            i
                        ]),
                        aggregated: row[aggregatedKey],
                        groupedByPivot: row[groupedByPivotKey],
                        subRows: row[subRowsKey]
                    };
                    var isExpanded = (0, _utilsDefault.default).get(expanded, rowInfo.nestingPath);
                    var trGroupProps = getTrGroupProps(finalState, rowInfo, undefined, _this2);
                    var trProps = (0, _utilsDefault.default).splitProps(getTrProps(finalState, rowInfo, undefined, _this2));
                    return (0, _reactDefault.default).createElement(TrGroupComponent, _extends({
                        key: rowInfo.nestingPath.join("_")
                    }, trGroupProps), (0, _reactDefault.default).createElement(TrComponent, _extends({
                        className: (0, _classnamesDefault.default)(trProps.className, row._viewIndex % 2 ? "-even" : "-odd"),
                        style: trProps.style
                    }, trProps.rest), allVisibleColumns.map(function(column, i2) {
                        var resizedCol = resized.find(function(x) {
                            return x.id === column.id;
                        }) || {};
                        var show = typeof column.show === "function" ? column.show() : column.show;
                        var width = (0, _utilsDefault.default).getFirstDefined(resizedCol.value, column.width, column.minWidth);
                        var maxWidth = (0, _utilsDefault.default).getFirstDefined(resizedCol.value, column.width, column.maxWidth);
                        var tdProps = (0, _utilsDefault.default).splitProps(getTdProps(finalState, rowInfo, column, _this2));
                        var columnProps = (0, _utilsDefault.default).splitProps(column.getProps(finalState, rowInfo, column, _this2));
                        var classes = [
                            tdProps.className,
                            column.className,
                            columnProps.className
                        ];
                        var styles = _extends({}, tdProps.style, column.style, columnProps.style);
                        var cellInfo = _extends({}, rowInfo, {
                            isExpanded: isExpanded,
                            column: _extends({}, column),
                            value: rowInfo.row[column.id],
                            pivoted: column.pivoted,
                            expander: column.expander,
                            resized: resized,
                            show: show,
                            width: width,
                            maxWidth: maxWidth,
                            tdProps: tdProps,
                            columnProps: columnProps,
                            classes: classes,
                            styles: styles
                        });
                        var value = cellInfo.value;
                        var useOnExpanderClick = void 0;
                        var isBranch = void 0;
                        var isPreview = void 0;
                        var onExpanderClick = function onExpanderClick(e) {
                            var newExpanded = (0, _utilsDefault.default).clone(expanded);
                            if (isExpanded) newExpanded = (0, _utilsDefault.default).set(newExpanded, cellInfo.nestingPath, false);
                            else newExpanded = (0, _utilsDefault.default).set(newExpanded, cellInfo.nestingPath, {});
                            return _this2.setStateWithData({
                                expanded: newExpanded
                            }, function() {
                                return onExpandedChange && onExpandedChange(newExpanded, cellInfo.nestingPath, e, cellInfo);
                            });
                        };
                        // Default to a standard cell
                        var resolvedCell = (0, _utilsDefault.default).normalizeComponent(column.Cell, cellInfo, value);
                        // Resolve Renderers
                        var ResolvedAggregatedComponent = column.Aggregated || (!column.aggregate ? AggregatedComponent : column.Cell);
                        var ResolvedExpanderComponent = column.Expander || ExpanderComponent;
                        var ResolvedPivotValueComponent = column.PivotValue || PivotValueComponent;
                        var DefaultResolvedPivotComponent = PivotComponent || function(props) {
                            return (0, _reactDefault.default).createElement("div", null, (0, _reactDefault.default).createElement(ResolvedExpanderComponent, props), (0, _reactDefault.default).createElement(ResolvedPivotValueComponent, props));
                        };
                        var ResolvedPivotComponent = column.Pivot || DefaultResolvedPivotComponent;
                        // Is this cell expandable?
                        if (cellInfo.pivoted || cellInfo.expander) {
                            // Make it expandable by defualt
                            cellInfo.expandable = true;
                            useOnExpanderClick = true;
                            // If pivoted, has no subRows, and does not have a subComponent,
                            // do not make expandable
                            if (cellInfo.pivoted && !cellInfo.subRows && !SubComponent) cellInfo.expandable = false;
                        }
                        if (cellInfo.pivoted) {
                            // Is this column a branch?
                            isBranch = rowInfo.row[pivotIDKey] === column.id && cellInfo.subRows;
                            // Should this column be blank?
                            isPreview = pivotBy.indexOf(column.id) > pivotBy.indexOf(rowInfo.row[pivotIDKey]) && cellInfo.subRows;
                            // Pivot Cell Render Override
                            if (isBranch) // isPivot
                            resolvedCell = (0, _utilsDefault.default).normalizeComponent(ResolvedPivotComponent, _extends({}, cellInfo, {
                                value: row[pivotValKey]
                            }), row[pivotValKey]);
                            else if (isPreview) // Show the pivot preview
                            resolvedCell = (0, _utilsDefault.default).normalizeComponent(ResolvedAggregatedComponent, cellInfo, value);
                            else resolvedCell = null;
                        } else if (cellInfo.aggregated) resolvedCell = (0, _utilsDefault.default).normalizeComponent(ResolvedAggregatedComponent, cellInfo, value);
                        if (cellInfo.expander) {
                            resolvedCell = (0, _utilsDefault.default).normalizeComponent(ResolvedExpanderComponent, cellInfo, row[pivotValKey]);
                            if (pivotBy) {
                                if (cellInfo.groupedByPivot) resolvedCell = null;
                                if (!cellInfo.subRows && !SubComponent) resolvedCell = null;
                            }
                        }
                        var resolvedOnExpanderClick = useOnExpanderClick ? onExpanderClick : function() {};
                        // If there are multiple onClick events, make sure they don't
                        // override eachother. This should maybe be expanded to handle all
                        // function attributes
                        var interactionProps = {
                            onClick: resolvedOnExpanderClick
                        };
                        if (tdProps.rest.onClick) interactionProps.onClick = function(e) {
                            tdProps.rest.onClick(e, function() {
                                return resolvedOnExpanderClick(e);
                            });
                        };
                        if (columnProps.rest.onClick) interactionProps.onClick = function(e) {
                            columnProps.rest.onClick(e, function() {
                                return resolvedOnExpanderClick(e);
                            });
                        };
                        // Return the cell
                        return (0, _reactDefault.default).createElement(TdComponent, _extends({
                            key: i2 + "-" + column.id,
                            className: (0, _classnamesDefault.default)(classes, !cellInfo.expandable && !show && "hidden", cellInfo.expandable && "rt-expandable", (isBranch || isPreview) && "rt-pivot"),
                            style: _extends({}, styles, {
                                flex: width + " 0 auto",
                                width: (0, _utilsDefault.default).asPx(width),
                                maxWidth: (0, _utilsDefault.default).asPx(maxWidth)
                            })
                        }, tdProps.rest, columnProps.rest, interactionProps), resolvedCell);
                    })), rowInfo.subRows && isExpanded && rowInfo.subRows.map(function(d, i) {
                        return makePageRow(d, i, rowInfo.nestingPath);
                    }), SubComponent && !rowInfo.subRows && isExpanded && SubComponent(rowInfo, function() {
                        var newExpanded = (0, _utilsDefault.default).clone(expanded);
                        (0, _utilsDefault.default).set(newExpanded, rowInfo.nestingPath, false);
                    }));
                };
                var makePadColumn = function makePadColumn(column, i) {
                    var resizedCol = resized.find(function(x) {
                        return x.id === column.id;
                    }) || {};
                    var show = typeof column.show === "function" ? column.show() : column.show;
                    var width = (0, _utilsDefault.default).getFirstDefined(resizedCol.value, column.width, column.minWidth);
                    var flex = width;
                    var maxWidth = (0, _utilsDefault.default).getFirstDefined(resizedCol.value, column.width, column.maxWidth);
                    var tdProps = (0, _utilsDefault.default).splitProps(getTdProps(finalState, undefined, column, _this2));
                    var columnProps = (0, _utilsDefault.default).splitProps(column.getProps(finalState, undefined, column, _this2));
                    var classes = [
                        tdProps.className,
                        column.className,
                        columnProps.className
                    ];
                    var styles = _extends({}, tdProps.style, column.style, columnProps.style);
                    return (0, _reactDefault.default).createElement(TdComponent, _extends({
                        key: i + "-" + column.id,
                        className: (0, _classnamesDefault.default)(classes, !show && "hidden"),
                        style: _extends({}, styles, {
                            flex: flex + " 0 auto",
                            width: (0, _utilsDefault.default).asPx(width),
                            maxWidth: (0, _utilsDefault.default).asPx(maxWidth)
                        })
                    }, tdProps.rest), (0, _utilsDefault.default).normalizeComponent(PadRowComponent));
                };
                var makePadRow = function makePadRow(row, i) {
                    var trGroupProps = getTrGroupProps(finalState, undefined, undefined, _this2);
                    var trProps = (0, _utilsDefault.default).splitProps(getTrProps(finalState, undefined, undefined, _this2));
                    return (0, _reactDefault.default).createElement(TrGroupComponent, _extends({
                        key: "pad-" + i
                    }, trGroupProps), (0, _reactDefault.default).createElement(TrComponent, {
                        className: (0, _classnamesDefault.default)("-padRow", (pageRows.length + i) % 2 ? "-even" : "-odd", trProps.className),
                        style: trProps.style || {}
                    }, allVisibleColumns.map(makePadColumn)));
                };
                var makeColumnFooter = function makeColumnFooter(column, i) {
                    var resizedCol = resized.find(function(x) {
                        return x.id === column.id;
                    }) || {};
                    var show = typeof column.show === "function" ? column.show() : column.show;
                    var width = (0, _utilsDefault.default).getFirstDefined(resizedCol.value, column.width, column.minWidth);
                    var maxWidth = (0, _utilsDefault.default).getFirstDefined(resizedCol.value, column.width, column.maxWidth);
                    var tFootTdProps = (0, _utilsDefault.default).splitProps(getTfootTdProps(finalState, undefined, column, _this2));
                    var columnProps = (0, _utilsDefault.default).splitProps(column.getProps(finalState, undefined, column, _this2));
                    var columnFooterProps = (0, _utilsDefault.default).splitProps(column.getFooterProps(finalState, undefined, column, _this2));
                    var classes = [
                        tFootTdProps.className,
                        column.className,
                        columnProps.className,
                        columnFooterProps.className
                    ];
                    var styles = _extends({}, tFootTdProps.style, column.style, columnProps.style, columnFooterProps.style);
                    return (0, _reactDefault.default).createElement(TdComponent, _extends({
                        key: i + "-" + column.id,
                        className: (0, _classnamesDefault.default)(classes, !show && "hidden"),
                        style: _extends({}, styles, {
                            flex: width + " 0 auto",
                            width: (0, _utilsDefault.default).asPx(width),
                            maxWidth: (0, _utilsDefault.default).asPx(maxWidth)
                        })
                    }, columnProps.rest, tFootTdProps.rest, columnFooterProps.rest), (0, _utilsDefault.default).normalizeComponent(column.Footer, {
                        data: sortedData,
                        column: column
                    }));
                };
                var makeColumnFooters = function makeColumnFooters() {
                    var tFootProps = (0, _utilsDefault.default).splitProps(getTfootProps(finalState, undefined, undefined, _this2));
                    var tFootTrProps = (0, _utilsDefault.default).splitProps(getTfootTrProps(finalState, undefined, undefined, _this2));
                    return (0, _reactDefault.default).createElement(TfootComponent, _extends({
                        className: tFootProps.className,
                        style: _extends({}, tFootProps.style, {
                            minWidth: rowMinWidth + "px"
                        })
                    }, tFootProps.rest), (0, _reactDefault.default).createElement(TrComponent, _extends({
                        className: (0, _classnamesDefault.default)(tFootTrProps.className),
                        style: tFootTrProps.style
                    }, tFootTrProps.rest), allVisibleColumns.map(makeColumnFooter)));
                };
                var makePagination = function makePagination(isTop) {
                    var paginationProps = (0, _utilsDefault.default).splitProps(getPaginationProps(finalState, undefined, undefined, _this2));
                    return (0, _reactDefault.default).createElement(PaginationComponent, _extends({}, resolvedState, {
                        pages: pages,
                        canPrevious: canPrevious,
                        canNext: canNext,
                        onPageChange: _this2.onPageChange,
                        onPageSizeChange: _this2.onPageSizeChange,
                        className: paginationProps.className,
                        style: paginationProps.style,
                        isTop: isTop
                    }, paginationProps.rest));
                };
                var makeTable = function makeTable() {
                    return (0, _reactDefault.default).createElement("div", _extends({
                        className: (0, _classnamesDefault.default)("ReactTable", className, rootProps.className),
                        style: _extends({}, style, rootProps.style)
                    }, rootProps.rest), showPagination && showPaginationTop ? (0, _reactDefault.default).createElement("div", {
                        className: "pagination-top"
                    }, makePagination(true)) : null, (0, _reactDefault.default).createElement(TableComponent, _extends({
                        className: (0, _classnamesDefault.default)(tableProps.className, currentlyResizing ? "rt-resizing" : ""),
                        style: tableProps.style
                    }, tableProps.rest), hasHeaderGroups ? makeHeaderGroups() : null, makeHeaders(), hasFilters ? makeFilters() : null, (0, _reactDefault.default).createElement(TbodyComponent, _extends({
                        className: (0, _classnamesDefault.default)(tBodyProps.className),
                        style: _extends({}, tBodyProps.style, {
                            minWidth: rowMinWidth + "px"
                        })
                    }, tBodyProps.rest), pageRows.map(function(d, i) {
                        return makePageRow(d, i);
                    }), padRows.map(makePadRow)), hasColumnFooter ? makeColumnFooters() : null), showPagination && showPaginationBottom ? (0, _reactDefault.default).createElement("div", {
                        className: "pagination-bottom"
                    }, makePagination(false)) : null, !pageRows.length && (0, _reactDefault.default).createElement(NoDataComponent, noDataProps, (0, _utilsDefault.default).normalizeComponent(noDataText)), (0, _reactDefault.default).createElement(LoadingComponent, _extends({
                        loading: loading,
                        loadingText: loadingText
                    }, loadingProps)));
                };
                // childProps are optionally passed to a function-as-a-child
                return children ? children(finalState, makeTable, this) : makeTable();
            }
        }
    ]);
    return ReactTable;
}((0, _methodsDefault.default)((0, _lifecycleDefault.default)((0, _react.Component))));
ReactTable.propTypes = (0, _propTypesDefault.default);
ReactTable.defaultProps = (0, _defaultPropsDefault.default);
exports.default = ReactTable;

},{"react":"6uln9","classnames":"hVGzI","./utils":"dodeA","./lifecycle":"fPDNf","./methods":"4Troz","./defaultProps":"7HaSB","./propTypes":"cvmsq","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"dodeA":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _reactIs = require("react-is");
var _extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
function _objectWithoutProperties(obj, keys) {
    var target = {};
    for(var i in obj){
        if (keys.indexOf(i) >= 0) continue;
        if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
        target[i] = obj[i];
    }
    return target;
}
//
exports.default = {
    get: get,
    set: set,
    takeRight: takeRight,
    last: last,
    orderBy: orderBy,
    range: range,
    remove: remove,
    clone: clone,
    getFirstDefined: getFirstDefined,
    sum: sum,
    makeTemplateComponent: makeTemplateComponent,
    groupBy: groupBy,
    isArray: isArray,
    splitProps: splitProps,
    compactObject: compactObject,
    isSortingDesc: isSortingDesc,
    normalizeComponent: normalizeComponent,
    asPx: asPx
};
function get(obj, path, def) {
    if (!path) return obj;
    var pathObj = makePathArray(path);
    var val = void 0;
    try {
        val = pathObj.reduce(function(current, pathPart) {
            return current[pathPart];
        }, obj);
    } catch (e) {
    // continue regardless of error
    }
    return typeof val !== "undefined" ? val : def;
}
function set() {
    var obj = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var path = arguments[1];
    var value = arguments[2];
    var keys = makePathArray(path);
    var keyPart = void 0;
    var cursor = obj;
    while((keyPart = keys.shift()) && keys.length){
        if (!cursor[keyPart]) cursor[keyPart] = {};
        cursor = cursor[keyPart];
    }
    cursor[keyPart] = value;
    return obj;
}
function takeRight(arr, n) {
    var start = n > arr.length ? 0 : arr.length - n;
    return arr.slice(start);
}
function last(arr) {
    return arr[arr.length - 1];
}
function range(n) {
    var arr = [];
    for(var i = 0; i < n; i += 1)arr.push(n);
    return arr;
}
function orderBy(arr, funcs, dirs, indexKey) {
    return arr.sort(function(rowA, rowB) {
        for(var i = 0; i < funcs.length; i += 1){
            var comp = funcs[i];
            var desc = dirs[i] === false || dirs[i] === "desc";
            var sortInt = comp(rowA, rowB);
            if (sortInt) return desc ? -sortInt : sortInt;
        }
        // Use the row index for tie breakers
        return dirs[0] ? rowA[indexKey] - rowB[indexKey] : rowB[indexKey] - rowA[indexKey];
    });
}
function remove(a, b) {
    return a.filter(function(o, i) {
        var r = b(o);
        if (r) {
            a.splice(i, 1);
            return true;
        }
        return false;
    });
}
function clone(a) {
    try {
        return JSON.parse(JSON.stringify(a, function(key, value) {
            if (typeof value === "function") return value.toString();
            return value;
        }));
    } catch (e) {
        return a;
    }
}
function getFirstDefined() {
    for(var i = 0; i < arguments.length; i += 1){
        if (typeof (arguments.length <= i ? undefined : arguments[i]) !== "undefined") return arguments.length <= i ? undefined : arguments[i];
    }
}
function sum(arr) {
    return arr.reduce(function(a, b) {
        return a + b;
    }, 0);
}
function makeTemplateComponent(compClass, displayName) {
    if (!displayName) throw new Error("No displayName found for template component:", compClass);
    var cmp = function cmp(_ref) {
        var children = _ref.children, className = _ref.className, rest = _objectWithoutProperties(_ref, [
            "children",
            "className"
        ]);
        return (0, _reactDefault.default).createElement("div", _extends({
            className: (0, _classnamesDefault.default)(compClass, className)
        }, rest), children);
    };
    cmp.displayName = displayName;
    return cmp;
}
function groupBy(xs, key) {
    return xs.reduce(function(rv, x, i) {
        var resKey = typeof key === "function" ? key(x, i) : x[key];
        rv[resKey] = isArray(rv[resKey]) ? rv[resKey] : [];
        rv[resKey].push(x);
        return rv;
    }, {});
}
function asPx(value) {
    value = Number(value);
    return Number.isNaN(value) ? null : value + "px";
}
function isArray(a) {
    return Array.isArray(a);
}
// ########################################################################
// Non-exported Helpers
// ########################################################################
function makePathArray(obj) {
    return flattenDeep(obj).join(".").replace(/\[/g, ".").replace(/\]/g, "").split(".");
}
function flattenDeep(arr) {
    var newArr = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    if (!isArray(arr)) newArr.push(arr);
    else for(var i = 0; i < arr.length; i += 1)flattenDeep(arr[i], newArr);
    return newArr;
}
function splitProps(_ref2) {
    var className = _ref2.className, style = _ref2.style, rest = _objectWithoutProperties(_ref2, [
        "className",
        "style"
    ]);
    return {
        className: className,
        style: style,
        rest: rest || {}
    };
}
function compactObject(obj) {
    var newObj = {};
    if (obj) Object.keys(obj).map(function(key) {
        if (Object.prototype.hasOwnProperty.call(obj, key) && obj[key] !== undefined && typeof obj[key] !== "undefined") newObj[key] = obj[key];
        return true;
    });
    return newObj;
}
function isSortingDesc(d) {
    return !!(d.sort === "desc" || d.desc === true || d.asc === false);
}
function normalizeComponent(Comp, props) {
    var fallback = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : Comp;
    if (_reactIs.isElement(Comp) || typeof Comp === "string") return Comp;
    else if (_reactIs.isValidElementType(Comp)) return (0, _reactDefault.default).createElement(Comp, props);
    return fallback;
}

},{"react":"6uln9","classnames":"hVGzI","react-is":"aUAsc","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"fPDNf":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
exports.default = function(Base) {
    return function(_Base) {
        _inherits(_class, _Base);
        function _class(props) {
            _classCallCheck(this, _class);
            var _this = _possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).call(this, props));
            var defaultState = {
                page: props.defaultPage,
                pageSize: props.defaultPageSize,
                sorted: props.defaultSorted,
                expanded: props.defaultExpanded,
                filtered: props.defaultFiltered,
                resized: props.defaultResized,
                currentlyResizing: false,
                skipNextSort: false
            };
            var resolvedState = _this.getResolvedState(props, defaultState);
            var dataModel = _this.getDataModel(resolvedState, true);
            _this.state = _this.calculateNewResolvedState(dataModel);
            return _this;
        }
        _createClass(_class, [
            {
                key: "componentDidMount",
                value: function componentDidMount() {
                    this.fireFetchData();
                }
            },
            {
                key: "componentDidUpdate",
                value: function componentDidUpdate(prevProps, prevState) {
                    var oldState = this.getResolvedState(prevProps, prevState);
                    var newState = this.getResolvedState(this.props, this.state);
                    // Do a deep compare of new and old `defaultOption` and
                    // if they are different reset `option = defaultOption`
                    var defaultableOptions = [
                        "sorted",
                        "filtered",
                        "resized",
                        "expanded"
                    ];
                    defaultableOptions.forEach(function(x) {
                        var defaultName = "default" + (x.charAt(0).toUpperCase() + x.slice(1));
                        if (JSON.stringify(oldState[defaultName]) !== JSON.stringify(newState[defaultName])) newState[x] = newState[defaultName];
                    });
                    // If they change these table options, we need to reset defaults
                    // or else we could get into a state where the user has changed the UI
                    // and then disabled the ability to change it back.
                    // e.g. If `filterable` has changed, set `filtered = defaultFiltered`
                    var resettableOptions = [
                        "sortable",
                        "filterable",
                        "resizable"
                    ];
                    resettableOptions.forEach(function(x) {
                        if (oldState[x] !== newState[x]) {
                            var baseName = x.replace("able", "");
                            var optionName = baseName + "ed";
                            var defaultName = "default" + (optionName.charAt(0).toUpperCase() + optionName.slice(1));
                            newState[optionName] = newState[defaultName];
                        }
                    });
                    // Props that trigger a data update
                    if (oldState.data !== newState.data || oldState.columns !== newState.columns || oldState.pivotBy !== newState.pivotBy || oldState.sorted !== newState.sorted || oldState.filtered !== newState.filtered) this.setStateWithData(this.getDataModel(newState, oldState.data !== newState.data));
                }
            },
            {
                key: "calculateNewResolvedState",
                value: function calculateNewResolvedState(dataModel) {
                    var oldState = this.getResolvedState();
                    var newResolvedState = this.getResolvedState({}, dataModel);
                    var freezeWhenExpanded = newResolvedState.freezeWhenExpanded;
                    // Default to unfrozen state
                    newResolvedState.frozen = false;
                    // If freezeWhenExpanded is set, check for frozen conditions
                    if (freezeWhenExpanded) {
                        // if any rows are expanded, freeze the existing data and sorting
                        var keys = Object.keys(newResolvedState.expanded);
                        for(var i = 0; i < keys.length; i += 1)if (newResolvedState.expanded[keys[i]]) {
                            newResolvedState.frozen = true;
                            break;
                        }
                    }
                    // If the data isn't frozen and either the data or
                    // sorting model has changed, update the data
                    if (oldState.frozen && !newResolvedState.frozen || oldState.sorted !== newResolvedState.sorted || oldState.filtered !== newResolvedState.filtered || oldState.showFilters !== newResolvedState.showFilters || !newResolvedState.frozen && oldState.resolvedData !== newResolvedState.resolvedData) {
                        // Handle collapseOnsortedChange & collapseOnDataChange
                        if (oldState.sorted !== newResolvedState.sorted && this.props.collapseOnSortingChange || oldState.filtered !== newResolvedState.filtered || oldState.showFilters !== newResolvedState.showFilters || oldState.sortedData && !newResolvedState.frozen && oldState.resolvedData !== newResolvedState.resolvedData && this.props.collapseOnDataChange) newResolvedState.expanded = {};
                        Object.assign(newResolvedState, this.getSortedData(newResolvedState));
                    }
                    // Set page to 0 if filters change
                    if (oldState.filtered !== newResolvedState.filtered) newResolvedState.page = 0;
                    // Calculate pageSize all the time
                    if (newResolvedState.sortedData) {
                        newResolvedState.pages = newResolvedState.manual ? newResolvedState.pages : Math.ceil(newResolvedState.sortedData.length / newResolvedState.pageSize);
                        newResolvedState.page = newResolvedState.manual ? newResolvedState.page : Math.max(newResolvedState.page >= newResolvedState.pages ? newResolvedState.pages - 1 : newResolvedState.page, 0);
                    }
                    return newResolvedState;
                }
            },
            {
                key: "setStateWithData",
                value: function setStateWithData(dataModel, cb) {
                    var _this2 = this;
                    var oldState = this.getResolvedState();
                    var newResolvedState = this.calculateNewResolvedState(dataModel);
                    return this.setState(newResolvedState, function() {
                        if (cb) cb();
                        if (oldState.page !== newResolvedState.page || oldState.pageSize !== newResolvedState.pageSize || oldState.sorted !== newResolvedState.sorted || oldState.filtered !== newResolvedState.filtered) _this2.fireFetchData();
                    });
                }
            }
        ]);
        return _class;
    }(Base);
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4Troz":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _utils = require("./utils");
var _utilsDefault = parcelHelpers.interopDefault(_utils);
var _slicedToArray = function() {
    function sliceIterator(arr, i) {
        var _arr = [];
        var _n = true;
        var _d = false;
        var _e = undefined;
        try {
            for(var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true){
                _arr.push(_s.value);
                if (i && _arr.length === i) break;
            }
        } catch (err) {
            _d = true;
            _e = err;
        } finally{
            try {
                if (!_n && _i["return"]) _i["return"]();
            } finally{
                if (_d) throw _e;
            }
        }
        return _arr;
    }
    return function(arr, i) {
        if (Array.isArray(arr)) return arr;
        else if (Symbol.iterator in Object(arr)) return sliceIterator(arr, i);
        else throw new TypeError("Invalid attempt to destructure non-iterable instance");
    };
}();
var _extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var _createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
function _defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _toConsumableArray(arr) {
    if (Array.isArray(arr)) {
        for(var i = 0, arr2 = Array(arr.length); i < arr.length; i++)arr2[i] = arr[i];
        return arr2;
    } else return Array.from(arr);
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
exports.default = function(Base) {
    return function(_Base) {
        _inherits(_class, _Base);
        function _class() {
            _classCallCheck(this, _class);
            return _possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).apply(this, arguments));
        }
        _createClass(_class, [
            {
                key: "getResolvedState",
                value: function getResolvedState(props, state) {
                    var resolvedState = _extends({}, (0, _utilsDefault.default).compactObject(this.state), (0, _utilsDefault.default).compactObject(this.props), (0, _utilsDefault.default).compactObject(state), (0, _utilsDefault.default).compactObject(props));
                    return resolvedState;
                }
            },
            {
                key: "getDataModel",
                value: function getDataModel(newState, dataChanged) {
                    var _this2 = this;
                    var columns = newState.columns, _newState$pivotBy = newState.pivotBy, pivotBy = _newState$pivotBy === undefined ? [] : _newState$pivotBy, data = newState.data, resolveData = newState.resolveData, pivotIDKey = newState.pivotIDKey, pivotValKey = newState.pivotValKey, subRowsKey = newState.subRowsKey, aggregatedKey = newState.aggregatedKey, nestingLevelKey = newState.nestingLevelKey, originalKey = newState.originalKey, indexKey = newState.indexKey, groupedByPivotKey = newState.groupedByPivotKey, SubComponent = newState.SubComponent;
                    // Determine Header Groups
                    var hasHeaderGroups = false;
                    columns.forEach(function(column) {
                        if (column.columns) hasHeaderGroups = true;
                    });
                    var columnsWithExpander = [].concat(_toConsumableArray(columns));
                    var expanderColumn = columns.find(function(col) {
                        return col.expander || col.columns && col.columns.some(function(col2) {
                            return col2.expander;
                        });
                    });
                    // The actual expander might be in the columns field of a group column
                    if (expanderColumn && !expanderColumn.expander) expanderColumn = expanderColumn.columns.find(function(col) {
                        return col.expander;
                    });
                    // If we have SubComponent's we need to make sure we have an expander column
                    if (SubComponent && !expanderColumn) {
                        expanderColumn = {
                            expander: true
                        };
                        columnsWithExpander = [
                            expanderColumn
                        ].concat(_toConsumableArray(columnsWithExpander));
                    }
                    var makeDecoratedColumn = function makeDecoratedColumn(column, parentColumn) {
                        var dcol = void 0;
                        if (column.expander) dcol = _extends({}, _this2.props.column, _this2.props.expanderDefaults, column);
                        else dcol = _extends({}, _this2.props.column, column);
                        // Ensure minWidth is not greater than maxWidth if set
                        if (dcol.maxWidth < dcol.minWidth) dcol.minWidth = dcol.maxWidth;
                        if (parentColumn) dcol.parentColumn = parentColumn;
                        // First check for string accessor
                        if (typeof dcol.accessor === "string") {
                            dcol.id = dcol.id || dcol.accessor;
                            var accessorString = dcol.accessor;
                            dcol.accessor = function(row) {
                                return (0, _utilsDefault.default).get(row, accessorString);
                            };
                            return dcol;
                        }
                        // Fall back to functional accessor (but require an ID)
                        if (dcol.accessor && !dcol.id) {
                            console.warn(dcol);
                            throw new Error("A column id is required if using a non-string accessor for column above.");
                        }
                        // Fall back to an undefined accessor
                        if (!dcol.accessor) dcol.accessor = function() {
                            return undefined;
                        };
                        return dcol;
                    };
                    var allDecoratedColumns = [];
                    // Decorate the columns
                    var decorateAndAddToAll = function decorateAndAddToAll(column, parentColumn) {
                        var decoratedColumn = makeDecoratedColumn(column, parentColumn);
                        allDecoratedColumns.push(decoratedColumn);
                        return decoratedColumn;
                    };
                    var decoratedColumns = columnsWithExpander.map(function(column) {
                        if (column.columns) return _extends({}, column, {
                            columns: column.columns.map(function(d) {
                                return decorateAndAddToAll(d, column);
                            })
                        });
                        return decorateAndAddToAll(column);
                    });
                    // Build the visible columns, headers and flat column list
                    var visibleColumns = decoratedColumns.slice();
                    var allVisibleColumns = [];
                    visibleColumns = visibleColumns.map(function(column) {
                        if (column.columns) {
                            var visibleSubColumns = column.columns.filter(function(d) {
                                return pivotBy.indexOf(d.id) > -1 ? false : (0, _utilsDefault.default).getFirstDefined(d.show, true);
                            });
                            return _extends({}, column, {
                                columns: visibleSubColumns
                            });
                        }
                        return column;
                    });
                    visibleColumns = visibleColumns.filter(function(column) {
                        return column.columns ? column.columns.length : pivotBy.indexOf(column.id) > -1 ? false : (0, _utilsDefault.default).getFirstDefined(column.show, true);
                    });
                    // Find any custom pivot location
                    var pivotIndex = visibleColumns.findIndex(function(col) {
                        return col.pivot;
                    });
                    // Handle Pivot Columns
                    if (pivotBy.length) {
                        // Retrieve the pivot columns in the correct pivot order
                        var pivotColumns = [];
                        pivotBy.forEach(function(pivotID) {
                            var found = allDecoratedColumns.find(function(d) {
                                return d.id === pivotID;
                            });
                            if (found) pivotColumns.push(found);
                        });
                        var PivotParentColumn = pivotColumns.reduce(function(prev, current) {
                            return prev && prev === current.parentColumn && current.parentColumn;
                        }, pivotColumns[0].parentColumn);
                        var PivotGroupHeader = hasHeaderGroups && PivotParentColumn.Header;
                        PivotGroupHeader = PivotGroupHeader || function() {
                            return (0, _reactDefault.default).createElement("strong", null, "Pivoted");
                        };
                        var pivotColumnGroup = {
                            Header: PivotGroupHeader,
                            columns: pivotColumns.map(function(col) {
                                return _extends({}, _this2.props.pivotDefaults, col, {
                                    pivoted: true
                                });
                            })
                        };
                        if (pivotIndex >= 0) {
                            pivotColumnGroup = _extends({}, visibleColumns[pivotIndex], pivotColumnGroup);
                            visibleColumns.splice(pivotIndex, 1, pivotColumnGroup);
                        } else visibleColumns.unshift(pivotColumnGroup);
                    }
                    // Build Header Groups
                    var headerGroups = [];
                    var currentSpan = [];
                    // A convenience function to add a header and reset the currentSpan
                    var addHeader = function addHeader(columns, column) {
                        headerGroups.push(_extends({}, _this2.props.column, column, {
                            columns: columns
                        }));
                        currentSpan = [];
                    };
                    // Build flast list of allVisibleColumns and HeaderGroups
                    visibleColumns.forEach(function(column) {
                        if (column.columns) {
                            allVisibleColumns = allVisibleColumns.concat(column.columns);
                            if (currentSpan.length > 0) addHeader(currentSpan);
                            addHeader(column.columns, column);
                            return;
                        }
                        allVisibleColumns.push(column);
                        currentSpan.push(column);
                    });
                    if (hasHeaderGroups && currentSpan.length > 0) addHeader(currentSpan);
                    // Access the data
                    var accessRow = function accessRow(d, i) {
                        var _row;
                        var level = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
                        var row = (_row = {}, _defineProperty(_row, originalKey, d), _defineProperty(_row, indexKey, i), _defineProperty(_row, subRowsKey, d[subRowsKey]), _defineProperty(_row, nestingLevelKey, level), _row);
                        allDecoratedColumns.forEach(function(column) {
                            if (column.expander) return;
                            row[column.id] = column.accessor(d);
                        });
                        if (row[subRowsKey]) row[subRowsKey] = row[subRowsKey].map(function(d, i) {
                            return accessRow(d, i, level + 1);
                        });
                        return row;
                    };
                    // // If the data hasn't changed, just use the cached data
                    var resolvedData = this.resolvedData;
                    // If the data has changed, run the data resolver and cache the result
                    if (!this.resolvedData || dataChanged) {
                        resolvedData = resolveData(data);
                        this.resolvedData = resolvedData;
                    }
                    // Use the resolved data
                    resolvedData = resolvedData.map(function(d, i) {
                        return accessRow(d, i);
                    });
                    // TODO: Make it possible to fabricate nested rows without pivoting
                    var aggregatingColumns = allVisibleColumns.filter(function(d) {
                        return !d.expander && d.aggregate;
                    });
                    // If pivoting, recursively group the data
                    var aggregate = function aggregate(rows) {
                        var aggregationValues = {};
                        aggregatingColumns.forEach(function(column) {
                            var values = rows.map(function(d) {
                                return d[column.id];
                            });
                            aggregationValues[column.id] = column.aggregate(values, rows);
                        });
                        return aggregationValues;
                    };
                    if (pivotBy.length) {
                        var groupRecursively = function groupRecursively(rows, keys) {
                            var i = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
                            // This is the last level, just return the rows
                            if (i === keys.length) return rows;
                            // Group the rows together for this level
                            var groupedRows = Object.entries((0, _utilsDefault.default).groupBy(rows, keys[i])).map(function(_ref) {
                                var _ref3;
                                var _ref2 = _slicedToArray(_ref, 2), key = _ref2[0], value = _ref2[1];
                                return _ref3 = {}, _defineProperty(_ref3, pivotIDKey, keys[i]), _defineProperty(_ref3, pivotValKey, key), _defineProperty(_ref3, keys[i], key), _defineProperty(_ref3, subRowsKey, value), _defineProperty(_ref3, nestingLevelKey, i), _defineProperty(_ref3, groupedByPivotKey, true), _ref3;
                            });
                            // Recurse into the subRows
                            groupedRows = groupedRows.map(function(rowGroup) {
                                var _extends2;
                                var subRows = groupRecursively(rowGroup[subRowsKey], keys, i + 1);
                                return _extends({}, rowGroup, (_extends2 = {}, _defineProperty(_extends2, subRowsKey, subRows), _defineProperty(_extends2, aggregatedKey, true), _extends2), aggregate(subRows));
                            });
                            return groupedRows;
                        };
                        resolvedData = groupRecursively(resolvedData, pivotBy);
                    }
                    return _extends({}, newState, {
                        resolvedData: resolvedData,
                        allVisibleColumns: allVisibleColumns,
                        headerGroups: headerGroups,
                        allDecoratedColumns: allDecoratedColumns,
                        hasHeaderGroups: hasHeaderGroups
                    });
                }
            },
            {
                key: "getSortedData",
                value: function getSortedData(resolvedState) {
                    var manual = resolvedState.manual, sorted = resolvedState.sorted, filtered = resolvedState.filtered, defaultFilterMethod = resolvedState.defaultFilterMethod, resolvedData = resolvedState.resolvedData, allDecoratedColumns = resolvedState.allDecoratedColumns;
                    var sortMethodsByColumnID = {};
                    allDecoratedColumns.filter(function(col) {
                        return col.sortMethod;
                    }).forEach(function(col) {
                        sortMethodsByColumnID[col.id] = col.sortMethod;
                    });
                    // Resolve the data from either manual data or sorted data
                    return {
                        sortedData: manual ? resolvedData : this.sortData(this.filterData(resolvedData, filtered, defaultFilterMethod, allDecoratedColumns), sorted, sortMethodsByColumnID)
                    };
                }
            },
            {
                key: "fireFetchData",
                value: function fireFetchData() {
                    // determine the current state, preferring certain state values over props
                    var currentState = _extends({}, this.getResolvedState(), {
                        page: this.getStateOrProp("page"),
                        pageSize: this.getStateOrProp("pageSize"),
                        filtered: this.getStateOrProp("filtered")
                    });
                    this.props.onFetchData(currentState, this);
                }
            },
            {
                key: "getPropOrState",
                value: function getPropOrState(key) {
                    return (0, _utilsDefault.default).getFirstDefined(this.props[key], this.state[key]);
                }
            },
            {
                key: "getStateOrProp",
                value: function getStateOrProp(key) {
                    return (0, _utilsDefault.default).getFirstDefined(this.state[key], this.props[key]);
                }
            },
            {
                key: "filterData",
                value: function filterData(data, filtered, defaultFilterMethod, allVisibleColumns) {
                    var _this3 = this;
                    var filteredData = data;
                    if (filtered.length) {
                        filteredData = filtered.reduce(function(filteredSoFar, nextFilter) {
                            var column = allVisibleColumns.find(function(x) {
                                return x.id === nextFilter.id;
                            });
                            // Don't filter hidden columns or columns that have had their filters disabled
                            if (!column || column.filterable === false) return filteredSoFar;
                            var filterMethod = column.filterMethod || defaultFilterMethod;
                            // If 'filterAll' is set to true, pass the entire dataset to the filter method
                            if (column.filterAll) return filterMethod(nextFilter, filteredSoFar, column);
                            return filteredSoFar.filter(function(row) {
                                return filterMethod(nextFilter, row, column);
                            });
                        }, filteredData);
                        // Apply the filter to the subrows if we are pivoting, and then
                        // filter any rows without subcolumns because it would be strange to show
                        filteredData = filteredData.map(function(row) {
                            if (!row[_this3.props.subRowsKey]) return row;
                            return _extends({}, row, _defineProperty({}, _this3.props.subRowsKey, _this3.filterData(row[_this3.props.subRowsKey], filtered, defaultFilterMethod, allVisibleColumns)));
                        }).filter(function(row) {
                            if (!row[_this3.props.subRowsKey]) return true;
                            return row[_this3.props.subRowsKey].length > 0;
                        });
                    }
                    return filteredData;
                }
            },
            {
                key: "sortData",
                value: function sortData(data, sorted) {
                    var _this4 = this;
                    var sortMethodsByColumnID = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                    if (!sorted.length) return data;
                    var sortedData = (this.props.orderByMethod || (0, _utilsDefault.default).orderBy)(data, sorted.map(function(sort) {
                        // Support custom sorting methods for each column
                        if (sortMethodsByColumnID[sort.id]) return function(a, b) {
                            return sortMethodsByColumnID[sort.id](a[sort.id], b[sort.id], sort.desc);
                        };
                        return function(a, b) {
                            return _this4.props.defaultSortMethod(a[sort.id], b[sort.id], sort.desc);
                        };
                    }), sorted.map(function(d) {
                        return !d.desc;
                    }), this.props.indexKey);
                    sortedData.forEach(function(row) {
                        if (!row[_this4.props.subRowsKey]) return;
                        row[_this4.props.subRowsKey] = _this4.sortData(row[_this4.props.subRowsKey], sorted, sortMethodsByColumnID);
                    });
                    return sortedData;
                }
            },
            {
                key: "getMinRows",
                value: function getMinRows() {
                    return (0, _utilsDefault.default).getFirstDefined(this.props.minRows, this.getStateOrProp("pageSize"));
                }
            },
            {
                key: "onPageChange",
                value: function onPageChange(page) {
                    var _props = this.props, onPageChange = _props.onPageChange, collapseOnPageChange = _props.collapseOnPageChange;
                    var newState = {
                        page: page
                    };
                    if (collapseOnPageChange) newState.expanded = {};
                    this.setStateWithData(newState, function() {
                        return onPageChange && onPageChange(page);
                    });
                }
            },
            {
                key: "onPageSizeChange",
                value: function onPageSizeChange(newPageSize) {
                    var onPageSizeChange = this.props.onPageSizeChange;
                    var _getResolvedState = this.getResolvedState(), pageSize = _getResolvedState.pageSize, page = _getResolvedState.page;
                    // Normalize the page to display
                    var currentRow = pageSize * page;
                    var newPage = Math.floor(currentRow / newPageSize);
                    this.setStateWithData({
                        pageSize: newPageSize,
                        page: newPage
                    }, function() {
                        return onPageSizeChange && onPageSizeChange(newPageSize, newPage);
                    });
                }
            },
            {
                key: "sortColumn",
                value: function sortColumn(column, additive) {
                    var _getResolvedState2 = this.getResolvedState(), sorted = _getResolvedState2.sorted, skipNextSort = _getResolvedState2.skipNextSort, defaultSortDesc = _getResolvedState2.defaultSortDesc;
                    var firstSortDirection = Object.prototype.hasOwnProperty.call(column, "defaultSortDesc") ? column.defaultSortDesc : defaultSortDesc;
                    var secondSortDirection = !firstSortDirection;
                    // we can't stop event propagation from the column resize move handlers
                    // attached to the document because of react's synthetic events
                    // so we have to prevent the sort function from actually sorting
                    // if we click on the column resize element within a header.
                    if (skipNextSort) {
                        this.setStateWithData({
                            skipNextSort: false
                        });
                        return;
                    }
                    var onSortedChange = this.props.onSortedChange;
                    var newSorted = (0, _utilsDefault.default).clone(sorted || []).map(function(d) {
                        d.desc = (0, _utilsDefault.default).isSortingDesc(d);
                        return d;
                    });
                    if (!(0, _utilsDefault.default).isArray(column)) {
                        // Single-Sort
                        var existingIndex = newSorted.findIndex(function(d) {
                            return d.id === column.id;
                        });
                        if (existingIndex > -1) {
                            var existing = newSorted[existingIndex];
                            if (existing.desc === secondSortDirection) {
                                if (additive) newSorted.splice(existingIndex, 1);
                                else {
                                    existing.desc = firstSortDirection;
                                    newSorted = [
                                        existing
                                    ];
                                }
                            } else {
                                existing.desc = secondSortDirection;
                                if (!additive) newSorted = [
                                    existing
                                ];
                            }
                        } else if (additive) newSorted.push({
                            id: column.id,
                            desc: firstSortDirection
                        });
                        else newSorted = [
                            {
                                id: column.id,
                                desc: firstSortDirection
                            }
                        ];
                    } else {
                        // Multi-Sort
                        var _existingIndex = newSorted.findIndex(function(d) {
                            return d.id === column[0].id;
                        });
                        // Existing Sorted Column
                        if (_existingIndex > -1) {
                            var _existing = newSorted[_existingIndex];
                            if (_existing.desc === secondSortDirection) {
                                if (additive) newSorted.splice(_existingIndex, column.length);
                                else column.forEach(function(d, i) {
                                    newSorted[_existingIndex + i].desc = firstSortDirection;
                                });
                            } else column.forEach(function(d, i) {
                                newSorted[_existingIndex + i].desc = secondSortDirection;
                            });
                            if (!additive) newSorted = newSorted.slice(_existingIndex, column.length);
                        // New Sort Column
                        } else if (additive) newSorted = newSorted.concat(column.map(function(d) {
                            return {
                                id: d.id,
                                desc: firstSortDirection
                            };
                        }));
                        else newSorted = column.map(function(d) {
                            return {
                                id: d.id,
                                desc: firstSortDirection
                            };
                        });
                    }
                    this.setStateWithData({
                        page: !sorted.length && newSorted.length || !additive ? 0 : this.state.page,
                        sorted: newSorted
                    }, function() {
                        return onSortedChange && onSortedChange(newSorted, column, additive);
                    });
                }
            },
            {
                key: "filterColumn",
                value: function filterColumn(column, value) {
                    var _getResolvedState3 = this.getResolvedState(), filtered = _getResolvedState3.filtered;
                    var onFilteredChange = this.props.onFilteredChange;
                    // Remove old filter first if it exists
                    var newFiltering = (filtered || []).filter(function(x) {
                        return x.id !== column.id;
                    });
                    if (value !== "") newFiltering.push({
                        id: column.id,
                        value: value
                    });
                    this.setStateWithData({
                        filtered: newFiltering
                    }, function() {
                        return onFilteredChange && onFilteredChange(newFiltering, column, value);
                    });
                }
            },
            {
                key: "resizeColumnStart",
                value: function resizeColumnStart(event, column, isTouch) {
                    var _this5 = this;
                    event.stopPropagation();
                    var parentWidth = event.target.parentElement.getBoundingClientRect().width;
                    var pageX = void 0;
                    if (isTouch) pageX = event.changedTouches[0].pageX;
                    else pageX = event.pageX;
                    this.trapEvents = true;
                    this.setStateWithData({
                        currentlyResizing: {
                            id: column.id,
                            startX: pageX,
                            parentWidth: parentWidth
                        }
                    }, function() {
                        if (isTouch) {
                            document.addEventListener("touchmove", _this5.resizeColumnMoving);
                            document.addEventListener("touchcancel", _this5.resizeColumnEnd);
                            document.addEventListener("touchend", _this5.resizeColumnEnd);
                        } else {
                            document.addEventListener("mousemove", _this5.resizeColumnMoving);
                            document.addEventListener("mouseup", _this5.resizeColumnEnd);
                            document.addEventListener("mouseleave", _this5.resizeColumnEnd);
                        }
                    });
                }
            },
            {
                key: "resizeColumnMoving",
                value: function resizeColumnMoving(event) {
                    event.stopPropagation();
                    var _props2 = this.props, onResizedChange = _props2.onResizedChange, column = _props2.column;
                    var _getResolvedState4 = this.getResolvedState(), resized = _getResolvedState4.resized, currentlyResizing = _getResolvedState4.currentlyResizing, columns = _getResolvedState4.columns;
                    var currentColumn = columns.find(function(c) {
                        return c.accessor === currentlyResizing.id || c.id === currentlyResizing.id;
                    });
                    var minResizeWidth = currentColumn && currentColumn.minResizeWidth != null ? currentColumn.minResizeWidth : column.minResizeWidth;
                    // Delete old value
                    var newResized = resized.filter(function(x) {
                        return x.id !== currentlyResizing.id;
                    });
                    var pageX = void 0;
                    if (event.type === "touchmove") pageX = event.changedTouches[0].pageX;
                    else if (event.type === "mousemove") pageX = event.pageX;
                    var newWidth = Math.max(currentlyResizing.parentWidth + pageX - currentlyResizing.startX, minResizeWidth);
                    newResized.push({
                        id: currentlyResizing.id,
                        value: newWidth
                    });
                    this.setStateWithData({
                        resized: newResized
                    }, function() {
                        return onResizedChange && onResizedChange(newResized, event);
                    });
                }
            },
            {
                key: "resizeColumnEnd",
                value: function resizeColumnEnd(event) {
                    event.stopPropagation();
                    var isTouch = event.type === "touchend" || event.type === "touchcancel";
                    if (isTouch) {
                        document.removeEventListener("touchmove", this.resizeColumnMoving);
                        document.removeEventListener("touchcancel", this.resizeColumnEnd);
                        document.removeEventListener("touchend", this.resizeColumnEnd);
                    }
                    // If its a touch event clear the mouse one's as well because sometimes
                    // the mouseDown event gets called as well, but the mouseUp event doesn't
                    document.removeEventListener("mousemove", this.resizeColumnMoving);
                    document.removeEventListener("mouseup", this.resizeColumnEnd);
                    document.removeEventListener("mouseleave", this.resizeColumnEnd);
                    // The touch events don't propagate up to the sorting's onMouseDown event so
                    // no need to prevent it from happening or else the first click after a touch
                    // event resize will not sort the column.
                    if (!isTouch) this.setStateWithData({
                        skipNextSort: true,
                        currentlyResizing: false
                    });
                }
            }
        ]);
        return _class;
    }(Base);
};

},{"react":"6uln9","./utils":"dodeA","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7HaSB":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
//
var _utils = require("./utils");
var _utilsDefault = parcelHelpers.interopDefault(_utils);
var _pagination = require("./pagination");
var _paginationDefault = parcelHelpers.interopDefault(_pagination);
var _extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
function _objectWithoutProperties(obj, keys) {
    var target = {};
    for(var i in obj){
        if (keys.indexOf(i) >= 0) continue;
        if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
        target[i] = obj[i];
    }
    return target;
}
var emptyObj = function emptyObj() {
    return {};
};
exports.default = {
    // General
    data: [],
    resolveData: function resolveData(data) {
        return data;
    },
    loading: false,
    showPagination: true,
    showPaginationTop: false,
    showPaginationBottom: true,
    showPageSizeOptions: true,
    pageSizeOptions: [
        5,
        10,
        20,
        25,
        50,
        100
    ],
    defaultPage: 0,
    defaultPageSize: 20,
    showPageJump: true,
    collapseOnSortingChange: true,
    collapseOnPageChange: true,
    collapseOnDataChange: true,
    freezeWhenExpanded: false,
    sortable: true,
    multiSort: true,
    resizable: true,
    filterable: false,
    defaultSortDesc: false,
    defaultSorted: [],
    defaultFiltered: [],
    defaultResized: [],
    defaultExpanded: {},
    // eslint-disable-next-line no-unused-vars
    defaultFilterMethod: function defaultFilterMethod(filter, row, column) {
        var id = filter.pivotId || filter.id;
        return row[id] !== undefined ? String(row[id]).startsWith(filter.value) : true;
    },
    // eslint-disable-next-line no-unused-vars
    defaultSortMethod: function defaultSortMethod(a, b, desc) {
        // force null and undefined to the bottom
        a = a === null || a === undefined ? "" : a;
        b = b === null || b === undefined ? "" : b;
        // force any string values to lowercase
        a = typeof a === "string" ? a.toLowerCase() : a;
        b = typeof b === "string" ? b.toLowerCase() : b;
        // Return either 1 or -1 to indicate a sort priority
        if (a > b) return 1;
        if (a < b) return -1;
        // returning 0, undefined or any falsey value will use subsequent sorts or
        // the index as a tiebreaker
        return 0;
    },
    // Controlled State Props
    // page: undefined,
    // pageSize: undefined,
    // sorted: [],
    // filtered: [],
    // resized: [],
    // expanded: {},
    // Controlled State Callbacks
    onPageChange: undefined,
    onPageSizeChange: undefined,
    onSortedChange: undefined,
    onFilteredChange: undefined,
    onResizedChange: undefined,
    onExpandedChange: undefined,
    // Pivoting
    pivotBy: undefined,
    // Key Constants
    pivotValKey: "_pivotVal",
    pivotIDKey: "_pivotID",
    subRowsKey: "_subRows",
    aggregatedKey: "_aggregated",
    nestingLevelKey: "_nestingLevel",
    originalKey: "_original",
    indexKey: "_index",
    groupedByPivotKey: "_groupedByPivot",
    // Server-side Callbacks
    onFetchData: function onFetchData() {
        return null;
    },
    // Classes
    className: "",
    style: {},
    // Component decorators
    getProps: emptyObj,
    getTableProps: emptyObj,
    getTheadGroupProps: emptyObj,
    getTheadGroupTrProps: emptyObj,
    getTheadGroupThProps: emptyObj,
    getTheadProps: emptyObj,
    getTheadTrProps: emptyObj,
    getTheadThProps: emptyObj,
    getTheadFilterProps: emptyObj,
    getTheadFilterTrProps: emptyObj,
    getTheadFilterThProps: emptyObj,
    getTbodyProps: emptyObj,
    getTrGroupProps: emptyObj,
    getTrProps: emptyObj,
    getTdProps: emptyObj,
    getTfootProps: emptyObj,
    getTfootTrProps: emptyObj,
    getTfootTdProps: emptyObj,
    getPaginationProps: emptyObj,
    getLoadingProps: emptyObj,
    getNoDataProps: emptyObj,
    getResizerProps: emptyObj,
    // Global Column Defaults
    column: {
        // Renderers
        Cell: undefined,
        Header: undefined,
        Footer: undefined,
        Aggregated: undefined,
        Pivot: undefined,
        PivotValue: undefined,
        Expander: undefined,
        Filter: undefined,
        Placeholder: undefined,
        // All Columns
        sortable: undefined,
        resizable: undefined,
        filterable: undefined,
        show: true,
        minWidth: 100,
        minResizeWidth: 11,
        // Cells only
        className: "",
        style: {},
        getProps: emptyObj,
        // Pivot only
        aggregate: undefined,
        // Headers only
        headerClassName: "",
        headerStyle: {},
        getHeaderProps: emptyObj,
        // Footers only
        footerClassName: "",
        footerStyle: {},
        getFooterProps: emptyObj,
        filterMethod: undefined,
        filterAll: false,
        sortMethod: undefined
    },
    // Global Expander Column Defaults
    expanderDefaults: {
        sortable: false,
        resizable: false,
        filterable: false,
        width: 35
    },
    pivotDefaults: {
    },
    // Text
    previousText: "Previous",
    nextText: "Next",
    loadingText: "Loading...",
    noDataText: "No rows found",
    pageText: "Page",
    ofText: "of",
    rowsText: "rows",
    pageJumpText: "jump to page",
    rowsSelectorText: "rows per page",
    // Components
    TableComponent: function TableComponent(_ref) {
        var children = _ref.children, className = _ref.className, rest = _objectWithoutProperties(_ref, [
            "children",
            "className"
        ]);
        return (0, _reactDefault.default).createElement("div", _extends({
            className: (0, _classnamesDefault.default)("rt-table", className),
            role: "grid"
        }, rest), children);
    },
    TheadComponent: (0, _utilsDefault.default).makeTemplateComponent("rt-thead", "Thead"),
    TbodyComponent: (0, _utilsDefault.default).makeTemplateComponent("rt-tbody", "Tbody"),
    TrGroupComponent: function TrGroupComponent(_ref2) {
        var children = _ref2.children, className = _ref2.className, rest = _objectWithoutProperties(_ref2, [
            "children",
            "className"
        ]);
        return (0, _reactDefault.default).createElement("div", _extends({
            className: (0, _classnamesDefault.default)("rt-tr-group", className),
            role: "rowgroup"
        }, rest), children);
    },
    TrComponent: function TrComponent(_ref3) {
        var children = _ref3.children, className = _ref3.className, rest = _objectWithoutProperties(_ref3, [
            "children",
            "className"
        ]);
        return (0, _reactDefault.default).createElement("div", _extends({
            className: (0, _classnamesDefault.default)("rt-tr", className),
            role: "row"
        }, rest), children);
    },
    ThComponent: function ThComponent(_ref4) {
        var toggleSort = _ref4.toggleSort, className = _ref4.className, children = _ref4.children, rest = _objectWithoutProperties(_ref4, [
            "toggleSort",
            "className",
            "children"
        ]);
        return(// eslint-disable-next-line jsx-a11y/click-events-have-key-events
        (0, _reactDefault.default).createElement("div", _extends({
            className: (0, _classnamesDefault.default)("rt-th", className),
            onClick: function onClick(e) {
                return toggleSort && toggleSort(e);
            },
            role: "columnheader",
            tabIndex: "-1" // Resolves eslint issues without implementing keyboard navigation incorrectly
        }, rest), children));
    },
    TdComponent: function TdComponent(_ref5) {
        var toggleSort = _ref5.toggleSort, className = _ref5.className, children = _ref5.children, rest = _objectWithoutProperties(_ref5, [
            "toggleSort",
            "className",
            "children"
        ]);
        return (0, _reactDefault.default).createElement("div", _extends({
            className: (0, _classnamesDefault.default)("rt-td", className),
            role: "gridcell"
        }, rest), children);
    },
    TfootComponent: (0, _utilsDefault.default).makeTemplateComponent("rt-tfoot", "Tfoot"),
    FilterComponent: function FilterComponent(_ref6) {
        var filter = _ref6.filter, _onChange = _ref6.onChange, column = _ref6.column;
        return (0, _reactDefault.default).createElement("input", {
            type: "text",
            style: {
                width: "100%"
            },
            placeholder: column.Placeholder,
            value: filter ? filter.value : "",
            onChange: function onChange(event) {
                return _onChange(event.target.value);
            }
        });
    },
    ExpanderComponent: function ExpanderComponent(_ref7) {
        var isExpanded = _ref7.isExpanded;
        return (0, _reactDefault.default).createElement("div", {
            className: (0, _classnamesDefault.default)("rt-expander", isExpanded && "-open")
        }, "•");
    },
    PivotValueComponent: function PivotValueComponent(_ref8) {
        var subRows = _ref8.subRows, value = _ref8.value;
        return (0, _reactDefault.default).createElement("span", null, value, " ", subRows && "(" + subRows.length + ")");
    },
    AggregatedComponent: function AggregatedComponent(_ref9) {
        var subRows = _ref9.subRows, column = _ref9.column;
        var previewValues = subRows.filter(function(d) {
            return typeof d[column.id] !== "undefined";
        }).map(function(row, i) {
            return(// eslint-disable-next-line react/no-array-index-key
            (0, _reactDefault.default).createElement("span", {
                key: i
            }, row[column.id], i < subRows.length - 1 ? ", " : ""));
        });
        return (0, _reactDefault.default).createElement("span", null, previewValues);
    },
    PivotComponent: undefined,
    // the ExpanderComponent and PivotValueComponent at run-time in methods.js
    PaginationComponent: (0, _paginationDefault.default),
    PreviousComponent: undefined,
    NextComponent: undefined,
    LoadingComponent: function LoadingComponent(_ref10) {
        var className = _ref10.className, loading = _ref10.loading, loadingText = _ref10.loadingText, rest = _objectWithoutProperties(_ref10, [
            "className",
            "loading",
            "loadingText"
        ]);
        return (0, _reactDefault.default).createElement("div", _extends({
            className: (0, _classnamesDefault.default)("-loading", {
                "-active": loading
            }, className)
        }, rest), (0, _reactDefault.default).createElement("div", {
            className: "-loading-inner"
        }, loadingText));
    },
    NoDataComponent: (0, _utilsDefault.default).makeTemplateComponent("rt-noData", "NoData"),
    ResizerComponent: (0, _utilsDefault.default).makeTemplateComponent("rt-resizer", "Resizer"),
    PadRowComponent: function PadRowComponent() {
        return (0, _reactDefault.default).createElement("span", null, "\xa0");
    }
};

},{"react":"6uln9","classnames":"hVGzI","./utils":"dodeA","./pagination":"amQhX","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"amQhX":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
var _extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var defaultButton = function defaultButton(props) {
    return (0, _reactDefault.default).createElement("button", _extends({
        type: "button"
    }, props, {
        className: "-btn"
    }), props.children);
};
var ReactTablePagination = function(_Component) {
    _inherits(ReactTablePagination, _Component);
    function ReactTablePagination(props) {
        _classCallCheck(this, ReactTablePagination);
        var _this = _possibleConstructorReturn(this, (ReactTablePagination.__proto__ || Object.getPrototypeOf(ReactTablePagination)).call(this, props));
        _this.getSafePage = _this.getSafePage.bind(_this);
        _this.changePage = _this.changePage.bind(_this);
        _this.applyPage = _this.applyPage.bind(_this);
        _this.state = {
            page: props.page
        };
        return _this;
    }
    _createClass(ReactTablePagination, [
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps, prevState) {
                if (prevProps.page !== this.props.page && prevState.page !== this.state.page) // this is probably safe because we only update when old/new state.page are different
                // eslint-disable-next-line react/no-did-update-set-state
                this.setState({
                    page: this.props.page
                });
            }
        },
        {
            key: "getSafePage",
            value: function getSafePage(page) {
                if (Number.isNaN(page)) page = this.props.page;
                return Math.min(Math.max(page, 0), this.props.pages - 1);
            }
        },
        {
            key: "changePage",
            value: function changePage(page) {
                page = this.getSafePage(page);
                this.setState({
                    page: page
                });
                if (this.props.page !== page) this.props.onPageChange(page);
            }
        },
        {
            key: "applyPage",
            value: function applyPage(e) {
                if (e) e.preventDefault();
                var page = this.state.page;
                this.changePage(page === "" ? this.props.page : page);
            }
        },
        {
            key: "getPageJumpProperties",
            value: function getPageJumpProperties() {
                var _this2 = this;
                return {
                    onKeyPress: function onKeyPress(e) {
                        if (e.which === 13 || e.keyCode === 13) _this2.applyPage();
                    },
                    onBlur: this.applyPage,
                    value: this.state.page === "" ? "" : this.state.page + 1,
                    onChange: function onChange(e) {
                        var val = e.target.value;
                        var page = val - 1;
                        if (val === "") return _this2.setState({
                            page: val
                        });
                        _this2.setState({
                            page: _this2.getSafePage(page)
                        });
                    },
                    inputType: this.state.page === "" ? "text" : "number",
                    pageJumpText: this.props.pageJumpText
                };
            }
        },
        {
            key: "render",
            value: function render() {
                var _this3 = this;
                var _props = this.props, pages = _props.pages, page = _props.page, showPageSizeOptions = _props.showPageSizeOptions, pageSizeOptions = _props.pageSizeOptions, pageSize = _props.pageSize, showPageJump = _props.showPageJump, canPrevious = _props.canPrevious, canNext = _props.canNext, onPageSizeChange = _props.onPageSizeChange, className = _props.className, PreviousComponent = _props.PreviousComponent, NextComponent = _props.NextComponent, renderPageJump = _props.renderPageJump, renderCurrentPage = _props.renderCurrentPage, renderTotalPagesCount = _props.renderTotalPagesCount, renderPageSizeOptions = _props.renderPageSizeOptions;
                return (0, _reactDefault.default).createElement("div", {
                    className: (0, _classnamesDefault.default)(className, "-pagination"),
                    style: this.props.style
                }, (0, _reactDefault.default).createElement("div", {
                    className: "-previous"
                }, (0, _reactDefault.default).createElement(PreviousComponent, {
                    onClick: function onClick() {
                        if (!canPrevious) return;
                        _this3.changePage(page - 1);
                    },
                    disabled: !canPrevious
                }, this.props.previousText)), (0, _reactDefault.default).createElement("div", {
                    className: "-center"
                }, (0, _reactDefault.default).createElement("span", {
                    className: "-pageInfo"
                }, this.props.pageText, " ", showPageJump ? renderPageJump(this.getPageJumpProperties()) : renderCurrentPage(page), " ", this.props.ofText, " ", renderTotalPagesCount(pages)), showPageSizeOptions && renderPageSizeOptions({
                    pageSize: pageSize,
                    rowsSelectorText: this.props.rowsSelectorText,
                    pageSizeOptions: pageSizeOptions,
                    onPageSizeChange: onPageSizeChange,
                    rowsText: this.props.rowsText
                })), (0, _reactDefault.default).createElement("div", {
                    className: "-next"
                }, (0, _reactDefault.default).createElement(NextComponent, {
                    onClick: function onClick() {
                        if (!canNext) return;
                        _this3.changePage(page + 1);
                    },
                    disabled: !canNext
                }, this.props.nextText)));
            }
        }
    ]);
    return ReactTablePagination;
}((0, _react.Component));
ReactTablePagination.defaultProps = {
    PreviousComponent: defaultButton,
    NextComponent: defaultButton,
    renderPageJump: function renderPageJump(_ref) {
        var onChange = _ref.onChange, value = _ref.value, onBlur = _ref.onBlur, onKeyPress = _ref.onKeyPress, inputType = _ref.inputType, pageJumpText = _ref.pageJumpText;
        return (0, _reactDefault.default).createElement("div", {
            className: "-pageJump"
        }, (0, _reactDefault.default).createElement("input", {
            "aria-label": pageJumpText,
            type: inputType,
            onChange: onChange,
            value: value,
            onBlur: onBlur,
            onKeyPress: onKeyPress
        }));
    },
    renderCurrentPage: function renderCurrentPage(page) {
        return (0, _reactDefault.default).createElement("span", {
            className: "-currentPage"
        }, page + 1);
    },
    renderTotalPagesCount: function renderTotalPagesCount(pages) {
        return (0, _reactDefault.default).createElement("span", {
            className: "-totalPages"
        }, pages || 1);
    },
    renderPageSizeOptions: function renderPageSizeOptions(_ref2) {
        var pageSize = _ref2.pageSize, pageSizeOptions = _ref2.pageSizeOptions, rowsSelectorText = _ref2.rowsSelectorText, onPageSizeChange = _ref2.onPageSizeChange, rowsText = _ref2.rowsText;
        return (0, _reactDefault.default).createElement("span", {
            className: "select-wrap -pageSizeOptions"
        }, (0, _reactDefault.default).createElement("select", {
            "aria-label": rowsSelectorText,
            onChange: function onChange(e) {
                return onPageSizeChange(Number(e.target.value));
            },
            value: pageSize
        }, pageSizeOptions.map(function(option, i) {
            return(// eslint-disable-next-line react/no-array-index-key
            (0, _reactDefault.default).createElement("option", {
                key: i,
                value: option
            }, option + " " + rowsText));
        })));
    }
};
exports.default = ReactTablePagination;

},{"react":"6uln9","classnames":"hVGzI","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"cvmsq":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
exports.default = {
    // General
    data: (0, _propTypesDefault.default).any,
    loading: (0, _propTypesDefault.default).bool,
    showPagination: (0, _propTypesDefault.default).bool,
    showPaginationTop: (0, _propTypesDefault.default).bool,
    showPaginationBottom: (0, _propTypesDefault.default).bool,
    showPageSizeOptions: (0, _propTypesDefault.default).bool,
    pageSizeOptions: (0, _propTypesDefault.default).array,
    defaultPageSize: (0, _propTypesDefault.default).number,
    showPageJump: (0, _propTypesDefault.default).bool,
    collapseOnSortingChange: (0, _propTypesDefault.default).bool,
    collapseOnPageChange: (0, _propTypesDefault.default).bool,
    collapseOnDataChange: (0, _propTypesDefault.default).bool,
    freezeWhenExpanded: (0, _propTypesDefault.default).bool,
    sortable: (0, _propTypesDefault.default).bool,
    resizable: (0, _propTypesDefault.default).bool,
    filterable: (0, _propTypesDefault.default).bool,
    defaultSortDesc: (0, _propTypesDefault.default).bool,
    defaultSorted: (0, _propTypesDefault.default).array,
    defaultFiltered: (0, _propTypesDefault.default).array,
    defaultResized: (0, _propTypesDefault.default).array,
    defaultExpanded: (0, _propTypesDefault.default).object,
    defaultFilterMethod: (0, _propTypesDefault.default).func,
    defaultSortMethod: (0, _propTypesDefault.default).func,
    // Controlled State Callbacks
    onPageChange: (0, _propTypesDefault.default).func,
    onPageSizeChange: (0, _propTypesDefault.default).func,
    onSortedChange: (0, _propTypesDefault.default).func,
    onFilteredChange: (0, _propTypesDefault.default).func,
    onResizedChange: (0, _propTypesDefault.default).func,
    onExpandedChange: (0, _propTypesDefault.default).func,
    // Pivoting
    pivotBy: (0, _propTypesDefault.default).array,
    // Key Constants
    pivotValKey: (0, _propTypesDefault.default).string,
    pivotIDKey: (0, _propTypesDefault.default).string,
    subRowsKey: (0, _propTypesDefault.default).string,
    aggregatedKey: (0, _propTypesDefault.default).string,
    nestingLevelKey: (0, _propTypesDefault.default).string,
    originalKey: (0, _propTypesDefault.default).string,
    indexKey: (0, _propTypesDefault.default).string,
    groupedByPivotKey: (0, _propTypesDefault.default).string,
    // Server-side Callbacks
    onFetchData: (0, _propTypesDefault.default).func,
    // Classes
    className: (0, _propTypesDefault.default).string,
    style: (0, _propTypesDefault.default).object,
    // Component decorators
    getProps: (0, _propTypesDefault.default).func,
    getTableProps: (0, _propTypesDefault.default).func,
    getTheadGroupProps: (0, _propTypesDefault.default).func,
    getTheadGroupTrProps: (0, _propTypesDefault.default).func,
    getTheadGroupThProps: (0, _propTypesDefault.default).func,
    getTheadProps: (0, _propTypesDefault.default).func,
    getTheadTrProps: (0, _propTypesDefault.default).func,
    getTheadThProps: (0, _propTypesDefault.default).func,
    getTheadFilterProps: (0, _propTypesDefault.default).func,
    getTheadFilterTrProps: (0, _propTypesDefault.default).func,
    getTheadFilterThProps: (0, _propTypesDefault.default).func,
    getTbodyProps: (0, _propTypesDefault.default).func,
    getTrGroupProps: (0, _propTypesDefault.default).func,
    getTrProps: (0, _propTypesDefault.default).func,
    getTdProps: (0, _propTypesDefault.default).func,
    getTfootProps: (0, _propTypesDefault.default).func,
    getTfootTrProps: (0, _propTypesDefault.default).func,
    getTfootTdProps: (0, _propTypesDefault.default).func,
    getPaginationProps: (0, _propTypesDefault.default).func,
    getLoadingProps: (0, _propTypesDefault.default).func,
    getNoDataProps: (0, _propTypesDefault.default).func,
    getResizerProps: (0, _propTypesDefault.default).func,
    // Global Column Defaults
    columns: (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).shape({
        // Renderers
        Cell: (0, _propTypesDefault.default).oneOfType([
            (0, _propTypesDefault.default).element,
            (0, _propTypesDefault.default).string,
            (0, _propTypesDefault.default).elementType
        ]),
        Header: (0, _propTypesDefault.default).oneOfType([
            (0, _propTypesDefault.default).element,
            (0, _propTypesDefault.default).string,
            (0, _propTypesDefault.default).elementType
        ]),
        Footer: (0, _propTypesDefault.default).oneOfType([
            (0, _propTypesDefault.default).element,
            (0, _propTypesDefault.default).string,
            (0, _propTypesDefault.default).elementType
        ]),
        Aggregated: (0, _propTypesDefault.default).oneOfType([
            (0, _propTypesDefault.default).element,
            (0, _propTypesDefault.default).string,
            (0, _propTypesDefault.default).elementType
        ]),
        Pivot: (0, _propTypesDefault.default).oneOfType([
            (0, _propTypesDefault.default).element,
            (0, _propTypesDefault.default).string,
            (0, _propTypesDefault.default).elementType
        ]),
        PivotValue: (0, _propTypesDefault.default).oneOfType([
            (0, _propTypesDefault.default).element,
            (0, _propTypesDefault.default).string,
            (0, _propTypesDefault.default).elementType
        ]),
        Expander: (0, _propTypesDefault.default).oneOfType([
            (0, _propTypesDefault.default).element,
            (0, _propTypesDefault.default).string,
            (0, _propTypesDefault.default).elementType
        ]),
        Filter: (0, _propTypesDefault.default).oneOfType([
            (0, _propTypesDefault.default).element,
            (0, _propTypesDefault.default).elementType
        ]),
        // All Columns
        sortable: (0, _propTypesDefault.default).bool,
        resizable: (0, _propTypesDefault.default).bool,
        filterable: (0, _propTypesDefault.default).bool,
        show: (0, _propTypesDefault.default).bool,
        minWidth: (0, _propTypesDefault.default).number,
        minResizeWidth: (0, _propTypesDefault.default).number,
        // Cells only
        className: (0, _propTypesDefault.default).string,
        style: (0, _propTypesDefault.default).object,
        getProps: (0, _propTypesDefault.default).func,
        // Pivot only
        aggregate: (0, _propTypesDefault.default).func,
        // Headers only
        headerClassName: (0, _propTypesDefault.default).string,
        headerStyle: (0, _propTypesDefault.default).object,
        getHeaderProps: (0, _propTypesDefault.default).func,
        // Footers only
        footerClassName: (0, _propTypesDefault.default).string,
        footerStyle: (0, _propTypesDefault.default).object,
        getFooterProps: (0, _propTypesDefault.default).func,
        filterMethod: (0, _propTypesDefault.default).func,
        filterAll: (0, _propTypesDefault.default).bool,
        sortMethod: (0, _propTypesDefault.default).func
    })),
    // Global Expander Column Defaults
    expanderDefaults: (0, _propTypesDefault.default).shape({
        sortable: (0, _propTypesDefault.default).bool,
        resizable: (0, _propTypesDefault.default).bool,
        filterable: (0, _propTypesDefault.default).bool,
        width: (0, _propTypesDefault.default).number
    }),
    pivotDefaults: (0, _propTypesDefault.default).object,
    // Text
    previousText: (0, _propTypesDefault.default).node,
    nextText: (0, _propTypesDefault.default).node,
    loadingText: (0, _propTypesDefault.default).node,
    noDataText: (0, _propTypesDefault.default).node,
    pageText: (0, _propTypesDefault.default).node,
    ofText: (0, _propTypesDefault.default).node,
    rowsText: (0, _propTypesDefault.default).node,
    pageJumpText: (0, _propTypesDefault.default).node,
    rowsSelectorText: (0, _propTypesDefault.default).node,
    // Components
    TableComponent: (0, _propTypesDefault.default).elementType,
    TheadComponent: (0, _propTypesDefault.default).elementType,
    TbodyComponent: (0, _propTypesDefault.default).elementType,
    TrGroupComponent: (0, _propTypesDefault.default).elementType,
    TrComponent: (0, _propTypesDefault.default).elementType,
    ThComponent: (0, _propTypesDefault.default).elementType,
    TdComponent: (0, _propTypesDefault.default).elementType,
    TfootComponent: (0, _propTypesDefault.default).elementType,
    FilterComponent: (0, _propTypesDefault.default).elementType,
    ExpanderComponent: (0, _propTypesDefault.default).elementType,
    PivotValueComponent: (0, _propTypesDefault.default).elementType,
    AggregatedComponent: (0, _propTypesDefault.default).elementType,
    // this is a computed default generated using
    PivotComponent: (0, _propTypesDefault.default).elementType,
    // the ExpanderComponent and PivotValueComponent at run-time in methods.js
    PaginationComponent: (0, _propTypesDefault.default).elementType,
    PreviousComponent: (0, _propTypesDefault.default).elementType,
    NextComponent: (0, _propTypesDefault.default).elementType,
    LoadingComponent: (0, _propTypesDefault.default).elementType,
    NoDataComponent: (0, _propTypesDefault.default).elementType,
    ResizerComponent: (0, _propTypesDefault.default).elementType,
    PadRowComponent: (0, _propTypesDefault.default).elementType
};

},{"prop-types":"6FKs7","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1NDiI":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _defineProperty = require("@babel/runtime/helpers/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _colors = require("../../constants/colors");
var _roundedSelectField = require("../forms/RoundedSelectField");
var _roundedSelectFieldDefault = parcelHelpers.interopDefault(_roundedSelectField);
var _roundedTwoOptionButton = require("../forms/RoundedTwoOptionButton");
var _roundedTwoOptionButtonDefault = parcelHelpers.interopDefault(_roundedTwoOptionButton);
var _numberIncrementSelector = require("../forms/NumberIncrementSelector");
var _numberIncrementSelectorDefault = parcelHelpers.interopDefault(_numberIncrementSelector);
// component used in building forms with consistent components for look and function
const containerStyle = /*#__PURE__*/ (0, _css.css)("display:flex;flex-direction:row;align-items:center;padding-bottom:20px;.label{font-family:Muli;font-size:10px;font-weight:normal;font-style:normal;font-stretch:normal;line-height:1.6;letter-spacing:0.5px;color:", (0, _colors.dark_grey_blue), ";&.selector{padding-left:12px;}&.view{margin-left:-30px;}&.page{padding-right:10;}}.sort-container{width:50%;text-align:left;}.view-container{width:25%;text-align:center;}.page-container{width:25%;text-align:right;div{text-align:center;}}", "");
class SortAndPageControl extends (0, _reactDefault.default).Component {
    constructor(...args){
        super(...args);
        (0, _definePropertyDefault.default)(this, "handleSort", (value)=>{
            // this is going to call setFieldValue and manually update values.topcis
            this.props.updateSortValue(value);
        });
    }
    render() {
        return (0, _react.jsx)("div", {
            className: containerStyle
        }, (0, _react.jsx)((0, _roundedSelectFieldDefault.default), {
            options: this.props.sortOptions,
            onChange: this.handleSort.bind(this),
            value: this.props.sortValue,
            label: "SORT BY"
        }), this.props.showView ? (0, _react.jsx)((0, _roundedTwoOptionButtonDefault.default), {
            updateViewValue: this.props.updateViewValue,
            selectedOption: this.props.view.localeCompare("table") === 0,
            label: "VIEW"
        }) : null, (0, _react.jsx)((0, _numberIncrementSelectorDefault.default), {
            selectedNumber: this.props.page,
            updateValue: this.props.updatePageValue,
            label: "PAGE",
            showNumber: true
        }));
    }
}
exports.default = SortAndPageControl;

},{"@babel/runtime/helpers/defineProperty":"9sJxO","@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","../../constants/colors":"1p3OR","../forms/RoundedSelectField":"lAfbC","../forms/RoundedTwoOptionButton":"7kmUj","../forms/NumberIncrementSelector":"kU0zB","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"lAfbC":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _defineProperty = require("@babel/runtime/helpers/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _reactSelect = require("react-select");
var _reactSelectDefault = parcelHelpers.interopDefault(_reactSelect);
var _colors = require("../../constants/colors");
var _toggleIndicator = require("../general/ToggleIndicator");
var _toggleIndicatorDefault = parcelHelpers.interopDefault(_toggleIndicator);
// component used in building forms with consistent components for look and function
const selectStyle = /*#__PURE__*/ (0, _css.css)("height:30px;border:0px;width:120px;display:inline-block;flex-direction:row;font-family:Muli sans-serif;font-weight:normal;font-style:normal;font-stretch:normal;line-height:normal;letter-spacing:normal;text-align:left;width:100%;.Select-control{box-shadow:0 2px 4px 0 ", (0, _colors.color_variants_shadow_10), ";border:solid 1px ", (0, _colors.silver_four), ";border-radius:20px;background:white;max-height:30px;.Select-multi-value-wrapper.Select-input{max-height:30px;}}.Select-placeholder,.Select-value{font-family:Muli;font-size:12px;}span{max-height:30px;line-height:30px;div{max-height:30px;}}div{max-height:30px;}.Select-menu-outer{border-bottom-right-radius:20px;border-bottom-left-radius:20px;border:solid 1px ", (0, _colors.silver_four), ";max-height:120px;z-index:100;.Select-menu{max-height:120px;background:white;max-height:120px;border-bottom-right-radius:20px;border-bottom-left-radius:20px;.Select-option{border-top:solid 1px ", (0, _colors.silver_four), ";}}}.Select-option,Select-noresults{font-family:Muli;font-size:12px;}.Select-option:last-child{border-bottom-right-radius:20px;border-bottom-left-radius:20px;border-bottom:solid 1px ", (0, _colors.silver_four), ";}", "");
class RoundedSelectField extends (0, _reactDefault.default).Component {
    constructor(...args){
        super(...args);
        (0, _definePropertyDefault.default)(this, "handleChange", (value)=>{
            // this is going to call setFieldValue and manually update values.topcis
            this.props.onChange(value);
        });
    }
    render() {
        const props = {
            ...this.props
        };
        return (0, _react.jsx)("div", {
            className: `sort-container selector`
        }, this.props.label === undefined ? null : (0, _react.jsx)("div", {
            className: "label selector"
        }, this.props.label), (0, _react.jsx)((0, _reactSelectDefault.default), {
            id: props.id,
            name: props.name,
            clearable: false,
            searchable: false,
            value: props.value,
            onChange: this.handleChange.bind(this),
            disabled: props.disabled,
            options: props.options,
            className: selectStyle,
            arrowRenderer: (p)=>(0, _react.jsx)((0, _toggleIndicatorDefault.default), {
                    direction: p.isOpen ? "up" : "down"
                })
        }));
    }
}
exports.default = RoundedSelectField;

},{"@babel/runtime/helpers/defineProperty":"9sJxO","@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","react-select":"1numo","../../constants/colors":"1p3OR","../general/ToggleIndicator":"4eej1","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7kmUj":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _colors = require("../../constants/colors");
const gridViewIconBlack = require("9586c47ad985f5d8");
const gridViewIconLight = require("7a80a8b71347817b");
const tableViewIconBlack = require("4b08d2c59f9884b5");
const tableViewIconLight = require("8d00339d214b7fd6");
// component used in building forms with consistent components for look and function
const container = /*#__PURE__*/ (0, _css.css)("width:25%;align-items:center;cursor:pointer;.number-container{display:inline-block;box-shadow:0 2px 4px 0 ", (0, _colors.color_variants_shadow_10), ";border:solid 1px #cccccc;border-radius:15px;box-sizing:border-box;.flexer{box-sizing:border-box;display:flex;flex-direction:row;box-sizing:border-box;div{box-sizing:border-box;padding:5px;padding-left:13px;padding-right:13px;&.selected{background:", (0, _colors.color_shades_light), ";}&.left{border-top-left-radius:15px;border-bottom-left-radius:15px;}&.right{border-top-right-radius:15px;border-bottom-right-radius:15px;}}}}", "");
class RoundedTwoOptionButton extends (0, _reactDefault.default).Component {
    render() {
        return (0, _react.jsx)("div", {
            onClick: this.props.updateViewValue.bind(this),
            className: `${container} view-container selector`
        }, this.props.label === undefined ? null : (0, _react.jsx)("div", {
            className: "label view"
        }, this.props.label), !this.props.selectedOption ? (0, _react.jsx)("div", {
            className: "number-container"
        }, (0, _react.jsx)("div", {
            className: "flexer"
        }, (0, _react.jsx)("div", {
            className: "selected left"
        }, (0, _react.jsx)("img", {
            src: gridViewIconLight
        })), (0, _react.jsx)("div", {
            className: "right"
        }, (0, _react.jsx)("img", {
            src: tableViewIconBlack
        })))) : (0, _react.jsx)("div", {
            className: "number-container"
        }, (0, _react.jsx)("div", {
            className: "flexer"
        }, (0, _react.jsx)("div", {
            className: "left"
        }, (0, _react.jsx)("img", {
            src: gridViewIconBlack
        })), (0, _react.jsx)("div", {
            className: "selected right"
        }, (0, _react.jsx)("img", {
            src: tableViewIconLight
        })))));
    }
}
exports.default = RoundedTwoOptionButton;

},{"@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","../../constants/colors":"1p3OR","9586c47ad985f5d8":"jAv49","7a80a8b71347817b":"cJzCl","4b08d2c59f9884b5":"1XO4X","8d00339d214b7fd6":"kCVlm","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jAv49":[function(require,module,exports) {
module.exports = require("dd0aa2d22445e7be").getBundleURL("kVLro") + require("81ca987c5969045b").resolve("bC86m");

},{"dd0aa2d22445e7be":"c7Tr5","81ca987c5969045b":"fyJL2"}],"cJzCl":[function(require,module,exports) {
module.exports = require("f353d7963cfbd301").getBundleURL("kVLro") + require("e6d63451897ff5c6").resolve("kCcgq");

},{"f353d7963cfbd301":"c7Tr5","e6d63451897ff5c6":"fyJL2"}],"1XO4X":[function(require,module,exports) {
module.exports = require("431ff2cb050579bb").getBundleURL("kVLro") + require("9a988fd13e23f28d").resolve("ibNwr");

},{"431ff2cb050579bb":"c7Tr5","9a988fd13e23f28d":"fyJL2"}],"kCVlm":[function(require,module,exports) {
module.exports = require("300b115cc72c5f22").getBundleURL("kVLro") + require("981408b9be5cfc01").resolve("cVzNu");

},{"300b115cc72c5f22":"c7Tr5","981408b9be5cfc01":"fyJL2"}],"kU0zB":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _colors = require("../../constants/colors");
var _toggleIndicator = require("../general/ToggleIndicator");
var _toggleIndicatorDefault = parcelHelpers.interopDefault(_toggleIndicator);
var _verticalSeparator = require("../structure/VerticalSeparator");
var _verticalSeparatorDefault = parcelHelpers.interopDefault(_verticalSeparator);
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// component used in building forms with consistent components for look and function
const container = /*#__PURE__*/ (0, _css.css)({
    name: "174j21s",
    styles: "display:inline-block;text-align:center"
});
const verticalSeparatorStyle = /*#__PURE__*/ (0, _css.css)({
    name: "5lso0e",
    styles: "height:60%;margin-top:7px"
});
const pageSelector = /*#__PURE__*/ (0, _css.css)("height:30px;border:solid 1px ", (0, _colors.silver_four), ";border-radius:20px;background:white;width:120px;&.simple{width:75px;}display:inline-block;flex-direction:row;.left{margin-right:6px;}.right{margin-left:6px;}div{display:inline-block;}div .toggle-indicator{cursor:pointer;position:relative;top:13;}.toggleContainer{cursor:pointer;height:30px;width:30px;position:relative;top:-20;}.numberValue{padding-left:12px;font-size:12;padding-right:12px;position:relative;font-family:Muli;top:-4;}", "");
const boxShadow = /*#__PURE__*/ (0, _css.css)("box-shadow:0 2px 4px 0 ", (0, _colors.color_variants_shadow_10), ";", "");
class NumberIncrementSelector extends (0, _reactDefault.default).Component {
    render() {
        return (0, _react.jsx)("div", {
            className: `${container} page-container`
        }, this.props.label === undefined ? null : (0, _react.jsx)("div", {
            className: `label page`
        }, this.props.label), (0, _react.jsx)("div", {
            className: `${this.props.useShadow != false ? boxShadow : ""} ${pageSelector} ${this.props.showNumber == null || this.props.showNumber === true ? `` : `simple`}`
        }, (0, _react.jsx)("div", {
            onClick: ()=>this.props.updateValue(false),
            className: "toggleContainer"
        }, (0, _react.jsx)((0, _toggleIndicatorDefault.default), {
            direction: "left"
        })), (this.props.showNumber == null || this.props.showNumber === true) && (0, _react.jsx)((0, _verticalSeparatorDefault.default), {
            className: verticalSeparatorStyle
        }), (this.props.showNumber == null || this.props.showNumber === true) && (0, _react.jsx)("div", {
            className: "numberValue"
        }, this.props.selectedNumber), (0, _react.jsx)((0, _verticalSeparatorDefault.default), {
            className: verticalSeparatorStyle
        }), (0, _react.jsx)("div", {
            onClick: ()=>this.props.updateValue(true),
            className: "toggleContainer"
        }, (0, _react.jsx)((0, _toggleIndicatorDefault.default), {
            direction: "right"
        }))));
    }
}
exports.default = NumberIncrementSelector;

},{"@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","../../constants/colors":"1p3OR","../general/ToggleIndicator":"4eej1","../structure/VerticalSeparator":"aNNRC","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"97U0d":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const rowContainer = /*#__PURE__*/ (0, _css.css)({
    name: "1mxhcez",
    styles: "width:100%;box-sizing:border-box;div{box-sizing:border-box;}"
});
const noItems = /*#__PURE__*/ (0, _css.css)({
    name: "dphc0d",
    styles: "color:rgba(0,0,0,0.5);padding-top:30px"
});
class ExpandableGrid extends (0, _reactDefault.default).Component {
    constructor(props){
        // Required step: always call the parent class' constructor
        super(props);
        // Set the state directly. Use props if necessary.
        this.state = {
            expandedIndex: -1,
            expandedElement: (0, _react.jsx)("span", null),
            selectedItem: "",
            expandedColumn: 0
        };
    }
    componentDidUpdate() {
        if (this.props.reset === true && this.state.expandedIndex !== -1) this.setState({
            ...this.state,
            expandedIndex: -1,
            expandedElement: (0, _react.jsx)("span", null),
            selectedItem: "",
            expandedColumn: 0
        });
    }
    handleClick(item, columnIndex, index) {
        if (this.props.enableExpand) this.setState({
            ...this.state,
            expandedIndex: index,
            expandedElement: (0, _react.jsx)("span", null),
            selectedItem: item,
            expandedColumn: columnIndex
        }, this.renderExpand);
    }
    renderExpand() {
        this.setState({
            ...this.state,
            expandedElement: this.props.expandRender(this.state.selectedItem, this.state.expandedIndex, this.state.expandedColumn)
        });
    }
    render() {
        const data = this.props.data;
        const rowArray = [];
        const columnCount = this.props.columnCount == null ? 2 : this.props.columnCount;
        const rowStyle = /*#__PURE__*/ (0, _css.css)("display:flex;flex-direction:row;width:100%;.col{width:", 100 / columnCount, "%;}", "");
        for(var i = 0; i < data.length; i += columnCount){
            var row = [];
            for(var j = i; j < i + columnCount && j < data.length; j++)row.push(data[j]);
            rowArray.push(row);
        }
        return (0, _react.jsx)("div", null, rowArray == null || rowArray.length < 1 ? (0, _react.jsx)("div", {
            className: noItems
        }, "No Items in Library") : rowArray.map((itemRow, rowIndex)=>(0, _react.jsx)("div", {
                key: rowIndex,
                className: rowContainer
            }, (0, _react.jsx)("div", {
                className: `${rowStyle}`
            }, itemRow.map((item, columnIndex)=>(0, _react.jsx)("div", {
                    onClick: ()=>this.handleClick(item, columnIndex, rowIndex),
                    className: "col",
                    key: columnIndex
                }, this.props.itemRender(item, columnIndex)))), this.state.expandedIndex === rowIndex && this.props.enableExpand ? this.state.expandedElement : null)));
    }
}
exports.default = ExpandableGrid;

},{"@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2zNzE":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _colors = require("../../constants/colors");
const cellStyle = /*#__PURE__*/ (0, _css.css)("font-family:Muli;font-size:14px;font-weight:normal;font-style:normal;font-stretch:normal;line-height:normal;letter-spacing:normal;text-align:left;color:", (0, _colors.dark_grey_blue), ";display:flex;align-items:center;", "");
const TableCell = (props)=>(0, _react.jsx)("div", {
        className: `${cellStyle} ${props.className ? props.className : ""}`
    }, props.children);
exports.default = TableCell;

},{"@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","../../constants/colors":"1p3OR","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9EPgz":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _colors = require("../../constants/colors");
const headerStyle = /*#__PURE__*/ (0, _css.css)("font-family:Muli;font-size:14px;font-weight:normal;font-style:normal;font-stretch:normal;line-height:normal;letter-spacing:normal;text-align:left;color:", (0, _colors.dark_grey_blue), ";width:100%;vertical-align:center;padding:16px 0;", "");
const TableHeader = (props)=>(0, _react.jsx)("div", {
        className: headerStyle
    }, props.text);
exports.default = TableHeader;

},{"@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","../../constants/colors":"1p3OR","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"gFi8C":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _colors = require("../../../constants/colors");
var _multiFileAudioPlayer = require("../../../components/messagePreviews/MultiFileAudioPlayer");
var _multiFileAudioPlayerDefault = parcelHelpers.interopDefault(_multiFileAudioPlayer);
var _textField = require("../../../components/forms/TextField");
var _textFieldDefault = parcelHelpers.interopDefault(_textField);
var _textAreaField = require("../../../components/forms/TextAreaField");
var _textAreaFieldDefault = parcelHelpers.interopDefault(_textAreaField);
var _smallOverflowMenu = require("../../../components/general/overflowMenu/SmallOverflowMenu");
var _smallOverflowMenuDefault = parcelHelpers.interopDefault(_smallOverflowMenu);
var _toggleIndicator = require("../../../components/general/ToggleIndicator");
var _toggleIndicatorDefault = parcelHelpers.interopDefault(_toggleIndicator);
var _simplePaginatedList = require("../../../components/general/SimplePaginatedList");
var _simplePaginatedListDefault = parcelHelpers.interopDefault(_simplePaginatedList);
var _moment = require("moment");
var _momentDefault = parcelHelpers.interopDefault(_moment);
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const deleteIcon = require("9136145a12eefc9a");
const deleteCircleIcon = require("1e1a0814e61f4c90");
const yellowInfoIcon = require("945d2f569551ab75");
const deleteRedIcon = require("4d2ac1e78a339ee3");
const replaceIcon = require("c244300154194c83");
const attachmentIcon = require("4a52ff9b6fb1dadb");
const restoreIcon = require("c593cd75fd8a0c70");
const downloadIcon = require("ea11f1794bbf354c");
class ExpandedMediaItem extends (0, _reactDefault.default).Component {
    constructor(props){
        // Required step: always call the parent class' constructor
        super(props);
        // Set the state directly. Use props if necessary.
        this.state = {
            mediaURL: "",
            name: "",
            caption: "",
            potentialURL: "",
            potentialName: "",
            showEditWarning: true,
            linkedContent: {
                contentItems: [],
                mediaItemId: ""
            },
            showLinkedContentItems: false
        };
    }
    componentDidMount() {
        const item = this.props.mediaItem;
        this.props.loadLinkedContent(item.id).then((result)=>{
            if (result.resultType == "Ok") this.setState({
                ...this.state,
                showEditWarning: true,
                linkedContent: result.data
            });
        });
        this.setState({
            ...this.state,
            mediaURL: item.url,
            name: item.name,
            showEditWarning: true,
            caption: item.caption
        });
    }
    toggleShowLinkedContentItems() {
        if (this.state.linkedContent != null && this.state.linkedContent.contentItems.length > 0) this.setState({
            ...this.state,
            showLinkedContentItems: !this.state.showLinkedContentItems
        });
    }
    disableEditWarning() {
        this.setState({
            ...this.state,
            showEditWarning: false
        });
    }
    handleUpdateTitle(changeEvent) {
        const item = this.props.mediaItem;
        item.name = changeEvent.target.value;
        this.props.onUpdateMediaItem(item, this.props.index);
    }
    handleUpdateCaption(changeEvent) {
        const item = this.props.mediaItem;
        item.caption = changeEvent.target.value;
        this.props.onUpdateMediaItem(item, this.props.index);
    }
    handleChangeCaption(changeEvent) {
        this.setState({
            ...this.state,
            caption: changeEvent.target.value
        });
    }
    handleChangeTitle(changeEvent) {
        this.setState({
            ...this.state,
            name: changeEvent.target.value
        });
    }
    handleOptionSelected(option) {
        switch(option){
            case "Download":
                this.downloadItem();
                break;
            case "Delete":
                this.props.onDeleteItem(this.props.mediaItem, this.state.linkedContent);
                break;
            case "Replace with...":
                this.replaceItem();
                break;
        }
    }
    forceDownload(blob, filename) {
        var a = document.createElement("a");
        a.download = filename;
        a.href = blob;
        document.body.appendChild(a);
        a.click();
        a.remove();
    }
    downloadItem() {
        const item = this.props.mediaItem;
        fetch(item.url, {
            headers: new Headers({
                "Origin": location.origin
            }),
            mode: "cors"
        }).then((response)=>response.blob()).then((blob)=>{
            let blobUrl = window.URL.createObjectURL(blob);
            this.forceDownload(blobUrl, item.name);
        }).catch((e)=>console.error(e));
    }
    replaceItem() {
        var input = document.createElement("input");
        input.type = "file";
        switch(this.props.mediaItem.mediaType){
            case "ImageFile":
                input.accept = ".png, .jpg";
                break;
            case "AudioFile":
                input.accept = ".mp3";
                break;
            case "VideoFile":
                input.accept = ".mp4";
                break;
        }
        input.click();
        input.onchange = (e)=>{
            this.handleReplaceFileSelection(e);
        };
    }
    handleReplaceFileSelection(event) {
        var newURL = URL.createObjectURL(event.target.files[0]);
        this.setState({
            ...this.state,
            potentialURL: newURL,
            potentialName: event.target.files[0].name
        });
        this.props.onReplaceMediaItem(this.props.mediaItem, event.target.files[0], this.props.index).then((result)=>{
            this.setState({
                ...this.state,
                mediaURL: this.state.potentialURL,
                name: this.state.potentialName,
                potentialName: "",
                potentialURL: ""
            });
        }).catch((error)=>{});
    }
    renderMedia() {
        const item = this.props.mediaItem;
        switch(item.mediaType){
            case "ImageFile":
                return (0, _react.jsx)("div", {
                    className: mediaCSS
                }, (0, _react.jsx)("div", {
                    className: "col"
                }, (0, _react.jsx)("img", {
                    src: this.state.mediaURL
                })));
            case "AudioFile":
                return (0, _react.jsx)("div", {
                    className: audioPreview
                }, (0, _react.jsx)((0, _multiFileAudioPlayerDefault.default), {
                    src: [
                        this.state.mediaURL
                    ],
                    isLoading: false,
                    hasFile: true,
                    onLoad: ()=>null
                }));
            case "VideoFile":
                return (0, _react.jsx)("div", {
                    className: videoPreview
                }, (0, _react.jsx)("video", {
                    controls: true
                }, (0, _react.jsx)("source", {
                    src: this.state.mediaURL,
                    type: "video/mp4"
                }), "Your browser does not support videos."));
        }
    }
    render() {
        const item = this.props.mediaItem;
        const linkedContentData = this.props.generateLinkedContentLinks(this.state.linkedContent);
        const lastEditedDateString = (0, _momentDefault.default)(item.modifiedDate).format("MMM DD, YYYY");
        const modifiedUser = item.modifiedByUser == null || item.modifiedByUser.lastName == null ? {
            firstName: null,
            lastName: null,
            imageUrl: null
        } : item.modifiedByUser;
        return (0, _react.jsx)("div", {
            className: `${expandedContainer} ${this.props.column == null ? "" : "grid _" + this.props.column}`
        }, this.props.column != null ? (0, _react.jsx)("div", {
            className: `${triangleStyle} _${this.props.column}`
        }) : null, (0, _react.jsx)("div", {
            className: `${expandedInnerDiv} ${this.props.column == null ? "table" : ""}`
        }, (0, _react.jsx)("div", {
            className: topRow
        }, (0, _react.jsx)("div", {
            className: "collapse text",
            onClick: ()=>this.props.onCollapse(this.props.index)
        }, "Collapse"), (0, _react.jsx)("div", {
            className: "options"
        }, (0, _react.jsx)((0, _smallOverflowMenuDefault.default), {
            isActive: false,
            onOptionSelected: this.handleOptionSelected.bind(this),
            options: [
                {
                    label: "Delete",
                    icon: deleteIcon,
                    hoverIcon: deleteRedIcon,
                    isDestructive: true
                },
                {
                    label: "Replace with...",
                    icon: replaceIcon,
                    hoverIcon: replaceIcon
                },
                {
                    label: "Download",
                    icon: downloadIcon,
                    hoverIcon: downloadIcon
                }
            ],
            label: "Options"
        }))), linkedContentData.length > 1 && this.state.showEditWarning && (0, _react.jsx)("div", {
            className: editWarning
        }, (0, _react.jsx)("img", {
            className: `leftImage`,
            src: yellowInfoIcon
        }), (0, _react.jsx)("div", {
            className: `warningText`
        }, "Edits to this file will affect all instances of it"), (0, _react.jsx)("span", null), (0, _react.jsx)("img", {
            className: `rightImage`,
            onClick: this.disableEditWarning.bind(this),
            src: deleteCircleIcon
        })), (0, _react.jsx)("div", {
            className: contentItemCount
        }, (0, _react.jsx)("div", {
            onClick: this.toggleShowLinkedContentItems.bind(this),
            className: `count ${linkedContentData.length > 0 ? `` : `disabled`}`
        }, linkedContentData.length > 0 ? this.state.showLinkedContentItems ? (0, _react.jsx)((0, _toggleIndicatorDefault.default), {
            direction: "up"
        }) : (0, _react.jsx)((0, _toggleIndicatorDefault.default), {
            direction: "down"
        }) : null, `Used by ${linkedContentData.length} response${linkedContentData.length === 1 ? `` : `s`}`), (0, _react.jsx)("span", {
            className: `${fill} line`
        })), this.state.showLinkedContentItems ? (0, _react.jsx)("div", null, (0, _react.jsx)("div", {
            className: `new-tab ${unaccentedText}`
        }, "Opens in a new tab"), (0, _react.jsx)((0, _simplePaginatedListDefault.default), {
            pageSize: 5,
            displayInfo: linkedContentData
        })) : null, this.renderMedia(), (0, _react.jsx)("div", {
            className: `${inputContainer} title`
        }, (0, _react.jsx)((0, _textFieldDefault.default), {
            name: "name",
            value: this.state.name,
            label: "Title",
            placeholder: "Enter Title",
            useForm: false,
            onChange: this.handleChangeTitle.bind(this),
            disabled: item.isDisabled != null && item.isDisabled,
            onBlur: this.handleUpdateTitle.bind(this)
        })), (0, _react.jsx)("div", {
            className: inputContainer
        }, (0, _react.jsx)((0, _textAreaFieldDefault.default), {
            name: "name",
            value: this.state.caption,
            label: "Description - (Optional)",
            disabled: item.isDisabled != null && item.isDisabled,
            placeholder: "Enter Description",
            onChange: this.handleChangeCaption.bind(this),
            onBlur: this.handleUpdateCaption.bind(this)
        })), (0, _react.jsx)("div", {
            className: `${unaccentedText} ${lastEditedRow}`
        }, "Last edited on ", (0, _react.jsx)("span", {
            className: accentedText
        }, lastEditedDateString), " ", modifiedUser.firstName === null ? "" : " by", modifiedUser.firstName !== null && (0, _react.jsx)("div", {
            className: avatarStyle
        }, modifiedUser.imageUrl != null ? (0, _react.jsx)("img", {
            className: avatarImageStyle,
            src: modifiedUser.imageUrl
        }) : (0, _react.jsx)("div", {
            className: nameStyle
        }, (0, _react.jsx)("span", null, `${modifiedUser.firstName[0]} ${modifiedUser.lastName[0]}`))), modifiedUser.firstName !== null && (0, _react.jsx)("div", {
            className: accentedText
        }, `${modifiedUser.firstName} ${modifiedUser.lastName}`)), (0, _react.jsx)("div", {
            className: bottomRow
        }, (0, _react.jsx)("span", {
            className: fill
        }), item.isDisabled != null && item.isDisabled ? (0, _react.jsx)("div", {
            onClick: ()=>this.props.onRestoreMediaItem(item, this.props.index),
            className: "attach"
        }, (0, _react.jsx)("span", null, "Restore"), (0, _react.jsx)("img", {
            src: restoreIcon
        })) : (0, _react.jsx)("div", {
            onClick: ()=>this.props.onAttachMediaItem(item),
            className: "attach"
        }, (0, _react.jsx)("span", null, "Attach"), (0, _react.jsx)("img", {
            src: attachmentIcon
        })))));
    }
}
const nameStyle = /*#__PURE__*/ (0, _css.css)("border-radius:50%;color:white;background:", (0, _colors.denim_blue), ";font-family:Muli;font-size:12px;font-weight:600;font-style:normal;line-height:normal;letter-spacing:-1px;text-align:center;width:100%;height:100%;display:flex;align-items:center;justify-content:center;", "");
const avatarStyle = /*#__PURE__*/ (0, _css.css)("padding:4px;margin-left:10px;margin-right:10px;position:relative;top:-10;height:36px;width:36px;border-radius:50%;border:solid 1px ", (0, _colors.silver_three), ";box-shadow:0 4px 4px 0 ", (0, _colors.dark_grey_blue_10), ";", "");
const avatarImageStyle = /*#__PURE__*/ (0, _css.css)({
    name: "1cj4mj2",
    styles: "width:100%;height:100%;border-radius:50%"
});
const contentItemCount = /*#__PURE__*/ (0, _css.css)("display:flex;flex-direction:row;.count{font-family:Muli;font-size:14px;font-weight:normal;font-style:normal;padding-right:5px;font-stretch:normal;line-height:1.43;letter-spacing:normal;color:", (0, _colors.text_blue), ";cursor:pointer;text-align:left;flex-direction:row;display:flex;padding-bottom:15px;&.disabled{cursor:default;color:", (0, _colors.cool_grey), ";}div{margin-right:10px;margin-top:6px;}}", "");
const topRow = /*#__PURE__*/ (0, _css.css)("flex-direction:row;display:flex;.options{margin-left:auto;margin-right:0;}.collapse{margin-left:5px;padding-bottom:10px;cursor:pointer;text-align:left;}.text{font-family:Muli;font-size:14px;font-weight:normal;font-style:normal;padding-right:5px;font-stretch:normal;line-height:1.43;letter-spacing:normal;color:", (0, _colors.text_blue), ";}.triangle{margin-right:20px;}", "");
const lastEditedRow = /*#__PURE__*/ (0, _css.css)({
    name: "ho1qnd",
    styles: "display:flex;flex-direction:row"
});
const expandedContainer = /*#__PURE__*/ (0, _css.css)("padding:0px 25px 0px;&.grid{border-radius:4px;border:solid 1px #cccccc;box-shadow:0 2px 4px 0 ", (0, _colors.color_variants_shadow_10), ";}", "");
const editWarning = /*#__PURE__*/ (0, _css.css)({
    name: "v0l9kf",
    styles: "width:100%;padding-top:15px;padding-bottom:15px;border-radius:4px;border:solid 1px #f6a12f;background-color:rgb(246,161,47,.1);display:flex;margin-bottom:15px;flex-direction:row;.leftImage{padding-left:10px;padding-right:10px;}.rightImage{padding-right:10px;cursor:pointer;}.warningText{padding-top:9px;}span{flex-grow:1;}"
});
const triangleStyle = /*#__PURE__*/ (0, _css.css)({
    name: "1uk4qda",
    styles: "transform:rotate(45deg);width:12px;height:12px;margin-top:-7px;margin-bottom:-6px;border-top:solid 1px #cccccc;border-left:solid 1px #cccccc;background:white;margin-left:auto;&._0{margin-right:600px;}&._1{margin-right:30px;}"
});
const expandedInnerDiv = /*#__PURE__*/ (0, _css.css)({
    name: "q4up6p",
    styles: "padding:25px 0px 20px;&.table{border-top:1px solid #cccccc;}"
});
const videoPreview = /*#__PURE__*/ (0, _css.css)({
    name: "deup8w",
    styles: "video{width:100%;border-radius:4px;}"
});
const audioPreview = /*#__PURE__*/ (0, _css.css)({
    name: "182kokr",
    styles: "div{border-radius:4px;&.rc-slider-handle{border-radius:50%;}}"
});
const inputContainer = /*#__PURE__*/ (0, _css.css)({
    name: "xu3ngq",
    styles: "&.title{margin-top:16px;}width:100%;.field-container{height:45px;}label{font-size:12px;}textarea{height:95px!important;margin-right:3px;resize:none;margin-bottom:3px;margin-top:3px;}"
});
const unaccentedText = /*#__PURE__*/ (0, _css.css)("font-family:Muli;font-size:14px;font-weight:normal;font-style:normal;font-stretch:normal;text-align:left;letter-spacing:normal;padding-bottom:20px;color:", (0, _colors.cool_grey), ";&.new-tab{padding-bottom:10px;}", "");
const accentedText = /*#__PURE__*/ (0, _css.css)("color:", (0, _colors.dark_grey_blue), ";font-weight:bold;padding-left:3px;padding-right:5px;", "");
const bottomRow = /*#__PURE__*/ (0, _css.css)("display:flex;flex-direction:row;font-family:Muli;font-size:14px;font-weight:normal;font-style:normal;font-stretch:normal;letter-spacing:normal;color:", (0, _colors.ocean_blue), ";.attach{cursor:pointer;margin-right:-5px;span{position:relative;top:-5;}}span{padding-left:10px;padding-top:3px;}div{span{padding-right:10px;}}", "");
const fill = /*#__PURE__*/ (0, _css.css)({
    name: "ny7kau",
    styles: "flex:1;&.line{margin-left:5px;border-bottom:solid 1px #cccccc;margin-bottom:24px;}"
});
const mediaCSS = /*#__PURE__*/ (0, _css.css)({
    name: "1pq1078",
    styles: "width:100%;height:0px;background:black;padding-bottom:75%;position:relative;.col{position:absolute;top:0;left:0;height:100%;width:100%;text-align:center;display:flex;flex-direction:column;justify-content:center;img{max-height:100%;max-width:100%;min-height:100px;border-radius:4px;object-fit:contain;}}"
});
exports.default = ExpandedMediaItem;

},{"@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","../../../constants/colors":"1p3OR","../../../components/messagePreviews/MultiFileAudioPlayer":"6v3LY","../../../components/forms/TextField":"7a7bh","../../../components/forms/TextAreaField":"fE54C","../../../components/general/overflowMenu/SmallOverflowMenu":"YJYcI","../../../components/general/ToggleIndicator":"4eej1","../../../components/general/SimplePaginatedList":"iY6kj","moment":"2meyw","9136145a12eefc9a":"gol67","1e1a0814e61f4c90":"igsne","945d2f569551ab75":"k0Bys","4d2ac1e78a339ee3":"euMUu","c244300154194c83":"koblr","4a52ff9b6fb1dadb":"iT0Wx","c593cd75fd8a0c70":"jMadF","ea11f1794bbf354c":"7hamt","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6v3LY":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _defineProperty = require("@babel/runtime/helpers/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _rcSlider = require("rc-slider");
var _rcSliderDefault = parcelHelpers.interopDefault(_rcSlider);
var _indexCss = require("rc-slider/assets/index.css");
var _colors = require("../../constants/colors");
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const loadIcon = require("a43ecfb8a1e471ab");
const playIcon = require("22fd44e9017e2984");
const pauseIcon = require("7bc55bfb5b615a9e");
const fileStyle = /*#__PURE__*/ (0, _css.css)({
    name: "1qzciea",
    styles: "border-radius:0 0 5px 5px"
});
const ssmlStyle = /*#__PURE__*/ (0, _css.css)({
    name: "scsb0n",
    styles: "border-radius:5px"
});
const containerStyle = /*#__PURE__*/ (0, _css.css)("height:40px;margin-bottom:12px;background-color:", (0, _colors.cool_grey), ";display:flex;align-items:center;padding:0 12px;span{height:13px;font-size:10px;line-height:normal;letter-spacing:0.4px;text-align:center;color:white;&.listen{cursor:pointer;}}.separator{height:20px;width:1px;background:white;}>*{margin-right:8px;}>img{cursor:pointer;&.spin{-webkit-animation:spin 1s linear infinite;-moz-animation:spin 1s linear infinite;animation:spin 1s linear infinite;@-moz-keyframes spin{100%{-moz-transform:rotate(-360deg);}}@-webkit-keyframes spin{100%{-webkit-transform:rotate(-360deg);}}@keyframes spin{100%{-webkit-transform:rotate(-360deg);transform:rotate(-360deg);}}}}.rc-slider-handle{border:none;&:focus,&:hover,&:active{border:2px solid white;box-shadow:0 0 5px ", (0, _colors.highlight_blue), ";}}", "");
const sliderStyle = {
    flex: 1
};
const railStyle = {
    backgroundColor: "${color_shades_dark}"
};
const trackStyle = {
    backgroundColor: "white"
};
class MultiFileAudioPlayer extends (0, _reactDefault.default).Component {
    constructor(props){
        // Required step: always call the parent class' constructor
        super(props);
        // Set the state directly. Use props if necessary.
        (0, _definePropertyDefault.default)(this, "player", new Audio(""));
        this.state = {
            isPlaying: false,
            elapsedTime: 0,
            previousElapsedTime: 0,
            currentElapsedTime: 0,
            totalTime: 0,
            audioTimes: [],
            linkedAudioPlayers: null
        };
    }
    componentDidMount() {
        this.loadPlayers();
    }
    componentWillUnmount() {
        if (this.state.isPlaying == true) {
            this.player.pause();
            this.setState({
                ...this.state,
                isPlaying: false
            });
        }
    }
    setAudioDuration(duration, player) {
        const audioTimes = this.state.audioTimes;
        const audioTime = audioTimes.find((a)=>a.src == player.src);
        if (audioTime) audioTime.duration = duration;
        else audioTimes.push({
            src: player.src,
            duration: duration
        });
        this.setState({
            ...this.state,
            audioTimes: audioTimes
        });
    }
    getDuration(src) {
        const audioItem = this.state.audioTimes.find((a)=>a.src == src);
        if (audioItem) return audioItem.duration;
        return 0;
    }
    loadPlayers() {
        if (!this.props.src) return;
        const players = this.props.src.map((s)=>{
            const audioPlayer = new Audio(s);
            audioPlayer.preload = "metadata";
            audioPlayer.onloadedmetadata = ()=>{
                this.setAudioDuration(audioPlayer.duration, audioPlayer);
                this.setState({
                    ...this.state,
                    totalTime: players.map((p)=>p.duration).reduce((total, value)=>total + value)
                });
            };
            return audioPlayer;
        });
        this.setState({
            ...this.state,
            linkedAudioPlayers: this.createLinkedList(players),
            currentElapsedTime: 0,
            elapsedTime: 0,
            previousElapsedTime: 0,
            isPlaying: false
        });
    }
    componentDidUpdate(prevProps) {
        if (prevProps.src != this.props.src) // re-adjust total time
        this.loadPlayers();
    }
    createLinkedList(players) {
        var top = {};
        for(var i = players.length - 1; i >= 0; i--)if (i == players.length - 1) top = {
            src: players[i].src,
            next: null
        };
        else {
            var temp = {
                src: players[i].src,
                next: top
            };
            top = temp;
        }
        return top;
    }
    handleListenClick() {
        if (this.props.src) this.play(0);
        else this.props.onLoad();
    }
    play(startTime) {
        if (this.state.linkedAudioPlayers) {
            this.setState({
                ...this.state,
                isPlaying: true
            });
            var currentPlayer = this.state.linkedAudioPlayers;
            var innerTime = 0;
            var totalTraversedTime = 0;
            if (startTime > 0) // find the right item to play
            while(currentPlayer != null){
                var nextTraversedTime = totalTraversedTime + this.getDuration(currentPlayer.src);
                if (startTime <= nextTraversedTime) {
                    innerTime = startTime - totalTraversedTime;
                    this.setState({
                        ...this.state,
                        currentElapsedTime: innerTime,
                        previousElapsedTime: totalTraversedTime,
                        elapsedTime: startTime
                    });
                    break;
                } else currentPlayer = currentPlayer.next;
                totalTraversedTime = nextTraversedTime;
            }
            if (currentPlayer == null) currentPlayer = this.state.linkedAudioPlayers;
            this.player.src = currentPlayer.src;
            this.player.currentTime = innerTime;
            this.player.ontimeupdate = ()=>this.handleTimeChange(totalTraversedTime);
            this.player.onended = ()=>{
                if (currentPlayer.next) {
                    this.setState({
                        ...this.state,
                        currentElapsedTime: 0,
                        previousElapsedTime: this.state.elapsedTime
                    });
                    this.player.src = currentPlayer.next.src;
                    this.player.play();
                    currentPlayer = currentPlayer.next;
                } else if (this.state.elapsedTime == this.state.totalTime) this.setState({
                    ...this.state,
                    isPlaying: false,
                    currentElapsedTime: 0,
                    previousElapsedTime: 0,
                    elapsedTime: 0
                });
            };
            this.player.play();
            this.setState({
                ...this.state,
                isPlaying: true
            });
        } else alert("No audio to play");
    }
    handleTimeChange(totalTraversedTime) {
        var currentElapsedTime = this.player.currentTime;
        const previousTime = this.state.previousElapsedTime > 0 ? this.state.previousElapsedTime : totalTraversedTime;
        this.setState({
            ...this.state,
            currentElapsedTime: currentElapsedTime,
            elapsedTime: previousTime + currentElapsedTime
        });
    }
    pause() {
        this.player.pause();
        this.setState({
            ...this.state,
            isPlaying: false
        });
    }
    getElapsedTimeText() {
        if (this.state.elapsedTime > 0) {
            const minutes = Math.floor(this.state.elapsedTime / 60);
            const seconds = Math.floor(this.state.elapsedTime - minutes * 60);
            return `${("0" + minutes).slice(-2)}:${("0" + seconds).slice(-2)}`;
        } else return "--:--";
    }
    getTotalTimeText() {
        if (this.state.totalTime > 0) {
            const minutes = Math.floor(this.state.totalTime / 60);
            const seconds = Math.floor(this.state.totalTime - minutes * 60);
            return `${("0" + minutes).slice(-2)}:${("0" + seconds).slice(-2)}`;
        } else return "--:--";
    }
    handleSliderChange(value) {
        if (this.player) this.player.pause();
        this.setState({
            ...this.state,
            elapsedTime: value,
            currentElapsedTime: 0,
            previousElapsedTime: 0,
            isPlaying: false
        });
    }
    render() {
        return (0, _react.jsx)("div", {
            className: `${containerStyle} ${this.props.hasFile ? fileStyle : ssmlStyle}`
        }, (0, _react.jsx)("span", {
            className: "listen",
            onClick: this.handleListenClick.bind(this)
        }, "LISTEN"), (0, _react.jsx)("div", {
            className: "separator"
        }), this.props.src ? (0, _react.jsx)((0, _reactDefault.default).Fragment, null, this.state.isPlaying ? (0, _react.jsx)("img", {
            src: pauseIcon,
            onClick: this.pause.bind(this)
        }) : (0, _react.jsx)("img", {
            src: playIcon,
            onClick: ()=>this.play(this.state.elapsedTime)
        })) : (0, _react.jsx)("img", {
            src: loadIcon,
            className: this.props.isLoading ? "spin" : "",
            onClick: this.props.onLoad
        }), (0, _react.jsx)("span", null, this.getElapsedTimeText()), (0, _react.jsx)((0, _rcSliderDefault.default), {
            style: sliderStyle,
            railStyle: railStyle,
            trackStyle: [
                trackStyle
            ],
            onChange: this.handleSliderChange.bind(this),
            min: 0,
            step: 0.01,
            max: this.state.totalTime,
            value: this.state.elapsedTime
        }), (0, _react.jsx)("span", null, this.getTotalTimeText()));
    }
}
exports.default = MultiFileAudioPlayer;

},{"@babel/runtime/helpers/defineProperty":"9sJxO","@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","rc-slider":"iOLDT","rc-slider/assets/index.css":"hMXqn","../../constants/colors":"1p3OR","a43ecfb8a1e471ab":"j90Zy","22fd44e9017e2984":"hBznb","7bc55bfb5b615a9e":"2fvnO","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"iOLDT":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Range", ()=>(0, _rangeDefault.default));
parcelHelpers.export(exports, "Handle", ()=>(0, _handleDefault.default));
parcelHelpers.export(exports, "createSliderWithTooltip", ()=>(0, _createSliderWithTooltipDefault.default));
var _slider = require("./Slider");
var _sliderDefault = parcelHelpers.interopDefault(_slider);
var _range = require("./Range");
var _rangeDefault = parcelHelpers.interopDefault(_range);
var _handle = require("./Handle");
var _handleDefault = parcelHelpers.interopDefault(_handle);
var _createSliderWithTooltip = require("./createSliderWithTooltip");
var _createSliderWithTooltipDefault = parcelHelpers.interopDefault(_createSliderWithTooltip);
(0, _sliderDefault.default).Range = (0, _rangeDefault.default);
(0, _sliderDefault.default).Handle = (0, _handleDefault.default);
(0, _sliderDefault.default).createSliderWithTooltip = (0, _createSliderWithTooltipDefault.default);
exports.default = (0, _sliderDefault.default);

},{"./Slider":"cmoS3","./Range":"haO10","./Handle":"5ybBK","./createSliderWithTooltip":"3G15q","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"cmoS3":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _extends = require("babel-runtime/helpers/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _classCallCheck = require("babel-runtime/helpers/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("babel-runtime/helpers/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _possibleConstructorReturn = require("babel-runtime/helpers/possibleConstructorReturn");
var _possibleConstructorReturnDefault = parcelHelpers.interopDefault(_possibleConstructorReturn);
var _inherits = require("babel-runtime/helpers/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
/* eslint-disable react/prop-types */ var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _warning = require("warning");
var _warningDefault = parcelHelpers.interopDefault(_warning);
var _track = require("./common/Track");
var _trackDefault = parcelHelpers.interopDefault(_track);
var _createSlider = require("./common/createSlider");
var _createSliderDefault = parcelHelpers.interopDefault(_createSlider);
var _utils = require("./utils");
var Slider = function(_React$Component) {
    (0, _inheritsDefault.default)(Slider, _React$Component);
    function Slider(props) {
        (0, _classCallCheckDefault.default)(this, Slider);
        var _this = (0, _possibleConstructorReturnDefault.default)(this, (Slider.__proto__ || Object.getPrototypeOf(Slider)).call(this, props));
        _this.onEnd = function(force) {
            var dragging = _this.state.dragging;
            _this.removeDocumentEvents();
            if (dragging || force) _this.props.onAfterChange(_this.getValue());
            _this.setState({
                dragging: false
            });
        };
        var defaultValue = props.defaultValue !== undefined ? props.defaultValue : props.min;
        var value = props.value !== undefined ? props.value : defaultValue;
        _this.state = {
            value: _this.trimAlignValue(value),
            dragging: false
        };
        (0, _warningDefault.default)(!("minimumTrackStyle" in props), "minimumTrackStyle will be deprecated, please use trackStyle instead.");
        (0, _warningDefault.default)(!("maximumTrackStyle" in props), "maximumTrackStyle will be deprecated, please use railStyle instead.");
        return _this;
    }
    (0, _createClassDefault.default)(Slider, [
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps, prevState) {
                if (!("value" in this.props || "min" in this.props || "max" in this.props)) return;
                var _props = this.props, value = _props.value, onChange = _props.onChange;
                var theValue = value !== undefined ? value : prevState.value;
                var nextValue = this.trimAlignValue(theValue, this.props);
                if (nextValue !== prevState.value) {
                    // eslint-disable-next-line
                    this.setState({
                        value: nextValue
                    });
                    if (_utils.isValueOutOfRange(theValue, this.props)) onChange(nextValue);
                }
            }
        },
        {
            key: "onChange",
            value: function onChange(state) {
                var props = this.props;
                var isNotControlled = !("value" in props);
                var nextState = state.value > this.props.max ? (0, _extendsDefault.default)({}, state, {
                    value: this.props.max
                }) : state;
                if (isNotControlled) this.setState(nextState);
                var changedValue = nextState.value;
                props.onChange(changedValue);
            }
        },
        {
            key: "onStart",
            value: function onStart(position) {
                this.setState({
                    dragging: true
                });
                var props = this.props;
                var prevValue = this.getValue();
                props.onBeforeChange(prevValue);
                var value = this.calcValueByPos(position);
                this.startValue = value;
                this.startPosition = position;
                if (value === prevValue) return;
                this.prevMovedHandleIndex = 0;
                this.onChange({
                    value: value
                });
            }
        },
        {
            key: "onMove",
            value: function onMove(e, position) {
                _utils.pauseEvent(e);
                var oldValue = this.state.value;
                var value = this.calcValueByPos(position);
                if (value === oldValue) return;
                this.onChange({
                    value: value
                });
            }
        },
        {
            key: "onKeyboard",
            value: function onKeyboard(e) {
                var _props2 = this.props, reverse = _props2.reverse, vertical = _props2.vertical;
                var valueMutator = _utils.getKeyboardValueMutator(e, vertical, reverse);
                if (valueMutator) {
                    _utils.pauseEvent(e);
                    var state = this.state;
                    var oldValue = state.value;
                    var mutatedValue = valueMutator(oldValue, this.props);
                    var value = this.trimAlignValue(mutatedValue);
                    if (value === oldValue) return;
                    this.onChange({
                        value: value
                    });
                    this.props.onAfterChange(value);
                    this.onEnd();
                }
            }
        },
        {
            key: "getValue",
            value: function getValue() {
                return this.state.value;
            }
        },
        {
            key: "getLowerBound",
            value: function getLowerBound() {
                return this.props.min;
            }
        },
        {
            key: "getUpperBound",
            value: function getUpperBound() {
                return this.state.value;
            }
        },
        {
            key: "trimAlignValue",
            value: function trimAlignValue(v) {
                var nextProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                if (v === null) return null;
                var mergedProps = (0, _extendsDefault.default)({}, this.props, nextProps);
                var val = _utils.ensureValueInRange(v, mergedProps);
                return _utils.ensureValuePrecision(val, mergedProps);
            }
        },
        {
            key: "render",
            value: function render() {
                var _this2 = this;
                var _props3 = this.props, prefixCls = _props3.prefixCls, vertical = _props3.vertical, included = _props3.included, disabled = _props3.disabled, minimumTrackStyle = _props3.minimumTrackStyle, trackStyle = _props3.trackStyle, handleStyle = _props3.handleStyle, tabIndex = _props3.tabIndex, min = _props3.min, max = _props3.max, reverse = _props3.reverse, handleGenerator = _props3.handle;
                var _state = this.state, value = _state.value, dragging = _state.dragging;
                var offset = this.calcOffset(value);
                var handle = handleGenerator({
                    className: prefixCls + "-handle",
                    prefixCls: prefixCls,
                    vertical: vertical,
                    offset: offset,
                    value: value,
                    dragging: dragging,
                    disabled: disabled,
                    min: min,
                    max: max,
                    reverse: reverse,
                    index: 0,
                    tabIndex: tabIndex,
                    style: handleStyle[0] || handleStyle,
                    ref: function ref(h) {
                        return _this2.saveHandle(0, h);
                    }
                });
                var _trackStyle = trackStyle[0] || trackStyle;
                var track = (0, _reactDefault.default).createElement((0, _trackDefault.default), {
                    className: prefixCls + "-track",
                    vertical: vertical,
                    included: included,
                    offset: 0,
                    reverse: reverse,
                    length: offset,
                    style: (0, _extendsDefault.default)({}, minimumTrackStyle, _trackStyle)
                });
                return {
                    tracks: track,
                    handles: handle
                };
            }
        }
    ]);
    return Slider;
}((0, _reactDefault.default).Component);
Slider.propTypes = {
    defaultValue: (0, _propTypesDefault.default).number,
    value: (0, _propTypesDefault.default).number,
    disabled: (0, _propTypesDefault.default).bool,
    autoFocus: (0, _propTypesDefault.default).bool,
    tabIndex: (0, _propTypesDefault.default).number,
    reverse: (0, _propTypesDefault.default).bool,
    min: (0, _propTypesDefault.default).number,
    max: (0, _propTypesDefault.default).number
};
exports.default = (0, _createSliderDefault.default)(Slider);

},{"babel-runtime/helpers/extends":"4sKqp","babel-runtime/helpers/classCallCheck":"aRpYz","babel-runtime/helpers/createClass":"a0jaP","babel-runtime/helpers/possibleConstructorReturn":"40Qb5","babel-runtime/helpers/inherits":"bitir","react":"6uln9","prop-types":"6FKs7","warning":"cCKmo","./common/Track":"iXjPX","./common/createSlider":"h5A2C","./utils":"hQYgB","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"cCKmo":[function(require,module,exports) {
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */ var __DEV__ = false;
var warning = function() {};
if (__DEV__) {
    var printWarning = function printWarning(format, args) {
        var len = arguments.length;
        args = new Array(len > 1 ? len - 1 : 0);
        for(var key = 1; key < len; key++)args[key - 1] = arguments[key];
        var argIndex = 0;
        var message = "Warning: " + format.replace(/%s/g, function() {
            return args[argIndex++];
        });
        if (typeof console !== "undefined") console.error(message);
        try {
            // --- Welcome to debugging React ---
            // This error was thrown as a convenience so that you can use this stack
            // to find the callsite that caused this warning to fire.
            throw new Error(message);
        } catch (x) {}
    };
    warning = function(condition, format, args) {
        var len = arguments.length;
        args = new Array(len > 2 ? len - 2 : 0);
        for(var key = 2; key < len; key++)args[key - 2] = arguments[key];
        if (format === undefined) throw new Error("`warning(condition, format, ...args)` requires a warning message argument");
        if (!condition) printWarning.apply(null, [
            format
        ].concat(args));
    };
}
module.exports = warning;

},{}],"iXjPX":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _extends = require("babel-runtime/helpers/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _defineProperty = require("babel-runtime/helpers/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
/* eslint-disable react/prop-types */ var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var Track = function Track(props) {
    var _ref, _ref2;
    var className = props.className, included = props.included, vertical = props.vertical, offset = props.offset, length = props.length, style = props.style, reverse = props.reverse;
    var positonStyle = vertical ? (_ref = {}, (0, _definePropertyDefault.default)(_ref, reverse ? "top" : "bottom", offset + "%"), (0, _definePropertyDefault.default)(_ref, reverse ? "bottom" : "top", "auto"), (0, _definePropertyDefault.default)(_ref, "height", length + "%"), _ref) : (_ref2 = {}, (0, _definePropertyDefault.default)(_ref2, reverse ? "right" : "left", offset + "%"), (0, _definePropertyDefault.default)(_ref2, reverse ? "left" : "right", "auto"), (0, _definePropertyDefault.default)(_ref2, "width", length + "%"), _ref2);
    var elStyle = (0, _extendsDefault.default)({}, style, positonStyle);
    return included ? (0, _reactDefault.default).createElement("div", {
        className: className,
        style: elStyle
    }) : null;
};
exports.default = Track;

},{"babel-runtime/helpers/extends":"4sKqp","babel-runtime/helpers/defineProperty":"9vPv9","react":"6uln9","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"h5A2C":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>createSlider);
var _objectWithoutProperties = require("babel-runtime/helpers/objectWithoutProperties");
var _objectWithoutPropertiesDefault = parcelHelpers.interopDefault(_objectWithoutProperties);
var _extends = require("babel-runtime/helpers/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _defineProperty = require("babel-runtime/helpers/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _classCallCheck = require("babel-runtime/helpers/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("babel-runtime/helpers/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _possibleConstructorReturn = require("babel-runtime/helpers/possibleConstructorReturn");
var _possibleConstructorReturnDefault = parcelHelpers.interopDefault(_possibleConstructorReturn);
var _get = require("babel-runtime/helpers/get");
var _getDefault = parcelHelpers.interopDefault(_get);
var _inherits = require("babel-runtime/helpers/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _addEventListener = require("rc-util/es/Dom/addEventListener");
var _addEventListenerDefault = parcelHelpers.interopDefault(_addEventListener);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _warning = require("warning");
var _warningDefault = parcelHelpers.interopDefault(_warning);
var _steps = require("./Steps");
var _stepsDefault = parcelHelpers.interopDefault(_steps);
var _marks = require("./Marks");
var _marksDefault = parcelHelpers.interopDefault(_marks);
var _handle = require("../Handle");
var _handleDefault = parcelHelpers.interopDefault(_handle);
var _utils = require("../utils");
function noop() {}
function createSlider(Component) {
    var _class, _temp;
    return _temp = _class = function(_Component) {
        (0, _inheritsDefault.default)(ComponentEnhancer, _Component);
        function ComponentEnhancer(props) {
            (0, _classCallCheckDefault.default)(this, ComponentEnhancer);
            var _this = (0, _possibleConstructorReturnDefault.default)(this, (ComponentEnhancer.__proto__ || Object.getPrototypeOf(ComponentEnhancer)).call(this, props));
            _this.onMouseDown = function(e) {
                if (e.button !== 0) return;
                var isVertical = _this.props.vertical;
                var position = _utils.getMousePosition(isVertical, e);
                if (!_utils.isEventFromHandle(e, _this.handlesRefs)) _this.dragOffset = 0;
                else {
                    var handlePosition = _utils.getHandleCenterPosition(isVertical, e.target);
                    _this.dragOffset = position - handlePosition;
                    position = handlePosition;
                }
                _this.removeDocumentEvents();
                _this.onStart(position);
                _this.addDocumentMouseEvents();
            };
            _this.onTouchStart = function(e) {
                if (_utils.isNotTouchEvent(e)) return;
                var isVertical = _this.props.vertical;
                var position = _utils.getTouchPosition(isVertical, e);
                if (!_utils.isEventFromHandle(e, _this.handlesRefs)) _this.dragOffset = 0;
                else {
                    var handlePosition = _utils.getHandleCenterPosition(isVertical, e.target);
                    _this.dragOffset = position - handlePosition;
                    position = handlePosition;
                }
                _this.onStart(position);
                _this.addDocumentTouchEvents();
                _utils.pauseEvent(e);
            };
            _this.onFocus = function(e) {
                var _this$props = _this.props, onFocus = _this$props.onFocus, vertical = _this$props.vertical;
                if (_utils.isEventFromHandle(e, _this.handlesRefs)) {
                    var handlePosition = _utils.getHandleCenterPosition(vertical, e.target);
                    _this.dragOffset = 0;
                    _this.onStart(handlePosition);
                    _utils.pauseEvent(e);
                    if (onFocus) onFocus(e);
                }
            };
            _this.onBlur = function(e) {
                var onBlur = _this.props.onBlur;
                _this.onEnd();
                if (onBlur) onBlur(e);
            };
            _this.onMouseUp = function() {
                if (_this.handlesRefs[_this.prevMovedHandleIndex]) _this.handlesRefs[_this.prevMovedHandleIndex].clickFocus();
            };
            _this.onMouseMove = function(e) {
                if (!_this.sliderRef) {
                    _this.onEnd();
                    return;
                }
                var position = _utils.getMousePosition(_this.props.vertical, e);
                _this.onMove(e, position - _this.dragOffset);
            };
            _this.onTouchMove = function(e) {
                if (_utils.isNotTouchEvent(e) || !_this.sliderRef) {
                    _this.onEnd();
                    return;
                }
                var position = _utils.getTouchPosition(_this.props.vertical, e);
                _this.onMove(e, position - _this.dragOffset);
            };
            _this.onKeyDown = function(e) {
                if (_this.sliderRef && _utils.isEventFromHandle(e, _this.handlesRefs)) _this.onKeyboard(e);
            };
            _this.onClickMarkLabel = function(e, value) {
                e.stopPropagation();
                _this.onChange({
                    value: value
                });
                _this.setState({
                    value: value
                }, function() {
                    return _this.onEnd(true);
                });
            };
            _this.saveSlider = function(slider) {
                _this.sliderRef = slider;
            };
            var step = props.step, max = props.max, min = props.min;
            var isPointDiffEven = isFinite(max - min) ? (max - min) % step === 0 : true; // eslint-disable-line
            (0, _warningDefault.default)(step && Math.floor(step) === step ? isPointDiffEven : true, "Slider[max] - Slider[min] (%s) should be a multiple of Slider[step] (%s)", max - min, step);
            _this.handlesRefs = {};
            return _this;
        }
        (0, _createClassDefault.default)(ComponentEnhancer, [
            {
                key: "componentDidMount",
                value: function componentDidMount() {
                    // Snapshot testing cannot handle refs, so be sure to null-check this.
                    this.document = this.sliderRef && this.sliderRef.ownerDocument;
                    var _props = this.props, autoFocus = _props.autoFocus, disabled = _props.disabled;
                    if (autoFocus && !disabled) this.focus();
                }
            },
            {
                key: "componentWillUnmount",
                value: function componentWillUnmount() {
                    if ((0, _getDefault.default)(ComponentEnhancer.prototype.__proto__ || Object.getPrototypeOf(ComponentEnhancer.prototype), "componentWillUnmount", this)) (0, _getDefault.default)(ComponentEnhancer.prototype.__proto__ || Object.getPrototypeOf(ComponentEnhancer.prototype), "componentWillUnmount", this).call(this);
                    this.removeDocumentEvents();
                }
            },
            {
                key: "getSliderStart",
                value: function getSliderStart() {
                    var slider = this.sliderRef;
                    var _props2 = this.props, vertical = _props2.vertical, reverse = _props2.reverse;
                    var rect = slider.getBoundingClientRect();
                    if (vertical) return reverse ? rect.bottom : rect.top;
                    return window.pageXOffset + (reverse ? rect.right : rect.left);
                }
            },
            {
                key: "getSliderLength",
                value: function getSliderLength() {
                    var slider = this.sliderRef;
                    if (!slider) return 0;
                    var coords = slider.getBoundingClientRect();
                    return this.props.vertical ? coords.height : coords.width;
                }
            },
            {
                key: "addDocumentTouchEvents",
                value: function addDocumentTouchEvents() {
                    // just work for Chrome iOS Safari and Android Browser
                    this.onTouchMoveListener = (0, _addEventListenerDefault.default)(this.document, "touchmove", this.onTouchMove);
                    this.onTouchUpListener = (0, _addEventListenerDefault.default)(this.document, "touchend", this.onEnd);
                }
            },
            {
                key: "addDocumentMouseEvents",
                value: function addDocumentMouseEvents() {
                    this.onMouseMoveListener = (0, _addEventListenerDefault.default)(this.document, "mousemove", this.onMouseMove);
                    this.onMouseUpListener = (0, _addEventListenerDefault.default)(this.document, "mouseup", this.onEnd);
                }
            },
            {
                key: "removeDocumentEvents",
                value: function removeDocumentEvents() {
                    /* eslint-disable no-unused-expressions */ this.onTouchMoveListener && this.onTouchMoveListener.remove();
                    this.onTouchUpListener && this.onTouchUpListener.remove();
                    this.onMouseMoveListener && this.onMouseMoveListener.remove();
                    this.onMouseUpListener && this.onMouseUpListener.remove();
                /* eslint-enable no-unused-expressions */ }
            },
            {
                key: "focus",
                value: function focus() {
                    if (!this.props.disabled) this.handlesRefs[0].focus();
                }
            },
            {
                key: "blur",
                value: function blur() {
                    var _this2 = this;
                    if (!this.props.disabled) Object.keys(this.handlesRefs).forEach(function(key) {
                        if (_this2.handlesRefs[key] && _this2.handlesRefs[key].blur) _this2.handlesRefs[key].blur();
                    });
                }
            },
            {
                key: "calcValue",
                value: function calcValue(offset) {
                    var _props3 = this.props, vertical = _props3.vertical, min = _props3.min, max = _props3.max;
                    var ratio = Math.abs(Math.max(offset, 0) / this.getSliderLength());
                    var value = vertical ? (1 - ratio) * (max - min) + min : ratio * (max - min) + min;
                    return value;
                }
            },
            {
                key: "calcValueByPos",
                value: function calcValueByPos(position) {
                    var sign = this.props.reverse ? -1 : 1;
                    var pixelOffset = sign * (position - this.getSliderStart());
                    var nextValue = this.trimAlignValue(this.calcValue(pixelOffset));
                    return nextValue;
                }
            },
            {
                key: "calcOffset",
                value: function calcOffset(value) {
                    var _props4 = this.props, min = _props4.min, max = _props4.max;
                    var ratio = (value - min) / (max - min);
                    return ratio * 100;
                }
            },
            {
                key: "saveHandle",
                value: function saveHandle(index, handle) {
                    this.handlesRefs[index] = handle;
                }
            },
            {
                key: "render",
                value: function render() {
                    var _classNames;
                    var _props5 = this.props, prefixCls = _props5.prefixCls, className = _props5.className, marks = _props5.marks, dots = _props5.dots, step = _props5.step, included = _props5.included, disabled = _props5.disabled, vertical = _props5.vertical, reverse = _props5.reverse, min = _props5.min, max = _props5.max, children = _props5.children, maximumTrackStyle = _props5.maximumTrackStyle, style = _props5.style, railStyle = _props5.railStyle, dotStyle = _props5.dotStyle, activeDotStyle = _props5.activeDotStyle;
                    var _get$call = (0, _getDefault.default)(ComponentEnhancer.prototype.__proto__ || Object.getPrototypeOf(ComponentEnhancer.prototype), "render", this).call(this), tracks = _get$call.tracks, handles = _get$call.handles;
                    var sliderClassName = (0, _classnamesDefault.default)(prefixCls, (_classNames = {}, (0, _definePropertyDefault.default)(_classNames, prefixCls + "-with-marks", Object.keys(marks).length), (0, _definePropertyDefault.default)(_classNames, prefixCls + "-disabled", disabled), (0, _definePropertyDefault.default)(_classNames, prefixCls + "-vertical", vertical), (0, _definePropertyDefault.default)(_classNames, className, className), _classNames));
                    return (0, _reactDefault.default).createElement("div", {
                        ref: this.saveSlider,
                        className: sliderClassName,
                        onTouchStart: disabled ? noop : this.onTouchStart,
                        onMouseDown: disabled ? noop : this.onMouseDown,
                        onMouseUp: disabled ? noop : this.onMouseUp,
                        onKeyDown: disabled ? noop : this.onKeyDown,
                        onFocus: disabled ? noop : this.onFocus,
                        onBlur: disabled ? noop : this.onBlur,
                        style: style
                    }, (0, _reactDefault.default).createElement("div", {
                        className: prefixCls + "-rail",
                        style: (0, _extendsDefault.default)({}, maximumTrackStyle, railStyle)
                    }), tracks, (0, _reactDefault.default).createElement((0, _stepsDefault.default), {
                        prefixCls: prefixCls,
                        vertical: vertical,
                        reverse: reverse,
                        marks: marks,
                        dots: dots,
                        step: step,
                        included: included,
                        lowerBound: this.getLowerBound(),
                        upperBound: this.getUpperBound(),
                        max: max,
                        min: min,
                        dotStyle: dotStyle,
                        activeDotStyle: activeDotStyle
                    }), handles, (0, _reactDefault.default).createElement((0, _marksDefault.default), {
                        className: prefixCls + "-mark",
                        onClickLabel: disabled ? noop : this.onClickMarkLabel,
                        vertical: vertical,
                        marks: marks,
                        included: included,
                        lowerBound: this.getLowerBound(),
                        upperBound: this.getUpperBound(),
                        max: max,
                        min: min,
                        reverse: reverse
                    }), children);
                }
            }
        ]);
        return ComponentEnhancer;
    }(Component), _class.displayName = "ComponentEnhancer(" + Component.displayName + ")", _class.propTypes = (0, _extendsDefault.default)({}, Component.propTypes, {
        min: (0, _propTypesDefault.default).number,
        max: (0, _propTypesDefault.default).number,
        step: (0, _propTypesDefault.default).number,
        marks: (0, _propTypesDefault.default).object,
        included: (0, _propTypesDefault.default).bool,
        className: (0, _propTypesDefault.default).string,
        prefixCls: (0, _propTypesDefault.default).string,
        disabled: (0, _propTypesDefault.default).bool,
        children: (0, _propTypesDefault.default).any,
        onBeforeChange: (0, _propTypesDefault.default).func,
        onChange: (0, _propTypesDefault.default).func,
        onAfterChange: (0, _propTypesDefault.default).func,
        handle: (0, _propTypesDefault.default).func,
        dots: (0, _propTypesDefault.default).bool,
        vertical: (0, _propTypesDefault.default).bool,
        style: (0, _propTypesDefault.default).object,
        reverse: (0, _propTypesDefault.default).bool,
        minimumTrackStyle: (0, _propTypesDefault.default).object,
        maximumTrackStyle: (0, _propTypesDefault.default).object,
        handleStyle: (0, _propTypesDefault.default).oneOfType([
            (0, _propTypesDefault.default).object,
            (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).object)
        ]),
        trackStyle: (0, _propTypesDefault.default).oneOfType([
            (0, _propTypesDefault.default).object,
            (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).object)
        ]),
        railStyle: (0, _propTypesDefault.default).object,
        dotStyle: (0, _propTypesDefault.default).object,
        activeDotStyle: (0, _propTypesDefault.default).object,
        autoFocus: (0, _propTypesDefault.default).bool,
        onFocus: (0, _propTypesDefault.default).func,
        onBlur: (0, _propTypesDefault.default).func
    }), _class.defaultProps = (0, _extendsDefault.default)({}, Component.defaultProps, {
        prefixCls: "rc-slider",
        className: "",
        min: 0,
        max: 100,
        step: 1,
        marks: {},
        handle: function handle(_ref) {
            var index = _ref.index, restProps = (0, _objectWithoutPropertiesDefault.default)(_ref, [
                "index"
            ]);
            delete restProps.dragging;
            if (restProps.value === null) return null;
            return (0, _reactDefault.default).createElement((0, _handleDefault.default), (0, _extendsDefault.default)({}, restProps, {
                key: index
            }));
        },
        onBeforeChange: noop,
        onChange: noop,
        onAfterChange: noop,
        included: true,
        disabled: false,
        dots: false,
        vertical: false,
        reverse: false,
        trackStyle: [
            {}
        ],
        handleStyle: [
            {}
        ],
        railStyle: {},
        dotStyle: {},
        activeDotStyle: {}
    }), _temp;
}

},{"babel-runtime/helpers/objectWithoutProperties":"5ILj2","babel-runtime/helpers/extends":"4sKqp","babel-runtime/helpers/defineProperty":"9vPv9","babel-runtime/helpers/classCallCheck":"aRpYz","babel-runtime/helpers/createClass":"a0jaP","babel-runtime/helpers/possibleConstructorReturn":"40Qb5","babel-runtime/helpers/get":"eUVjZ","babel-runtime/helpers/inherits":"bitir","react":"6uln9","prop-types":"6FKs7","rc-util/es/Dom/addEventListener":"dHu4r","classnames":"hVGzI","warning":"cCKmo","./Steps":"eDFIS","./Marks":"9YDEp","../Handle":"5ybBK","../utils":"hQYgB","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"eUVjZ":[function(require,module,exports) {
"use strict";
exports.__esModule = true;
var _getPrototypeOf = require("862530c5cf99e705");
var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
var _getOwnPropertyDescriptor = require("1994b603c6d23d6d");
var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
exports.default = function get(object, property, receiver) {
    if (object === null) object = Function.prototype;
    var desc = (0, _getOwnPropertyDescriptor2.default)(object, property);
    if (desc === undefined) {
        var parent = (0, _getPrototypeOf2.default)(object);
        if (parent === null) return undefined;
        else return get(parent, property, receiver);
    } else if ("value" in desc) return desc.value;
    else {
        var getter = desc.get;
        if (getter === undefined) return undefined;
        return getter.call(receiver);
    }
};

},{"862530c5cf99e705":"1LYOd","1994b603c6d23d6d":"goATe"}],"1LYOd":[function(require,module,exports) {
module.exports = {
    "default": require("d2b80112dbcb481b"),
    __esModule: true
};

},{"d2b80112dbcb481b":"hzLHT"}],"hzLHT":[function(require,module,exports) {
require("4091db23e801b1e2");
module.exports = require("c3d201c8674de370").Object.getPrototypeOf;

},{"4091db23e801b1e2":"9ZHit","c3d201c8674de370":"i8kQt"}],"9ZHit":[function(require,module,exports) {
// 19.1.2.9 Object.getPrototypeOf(O)
var toObject = require("b5ac161fe733e960");
var $getPrototypeOf = require("dec7c099c1b019b5");
require("8a5d8aae975412f2")("getPrototypeOf", function() {
    return function getPrototypeOf(it) {
        return $getPrototypeOf(toObject(it));
    };
});

},{"b5ac161fe733e960":"9EHnZ","dec7c099c1b019b5":"2Nq78","8a5d8aae975412f2":"dukCp"}],"dukCp":[function(require,module,exports) {
// most Object methods by ES6 should accept primitives
var $export = require("8d53bd89f1cb80f2");
var core = require("efd27a88f7724aee");
var fails = require("6c0e21c17fc3d7fe");
module.exports = function(KEY, exec) {
    var fn = (core.Object || {})[KEY] || Object[KEY];
    var exp = {};
    exp[KEY] = exec(fn);
    $export($export.S + $export.F * fails(function() {
        fn(1);
    }), "Object", exp);
};

},{"8d53bd89f1cb80f2":"1OjY7","efd27a88f7724aee":"i8kQt","6c0e21c17fc3d7fe":"aH906"}],"goATe":[function(require,module,exports) {
module.exports = {
    "default": require("e863ef1557d100bc"),
    __esModule: true
};

},{"e863ef1557d100bc":"cV491"}],"cV491":[function(require,module,exports) {
require("48e45db32cd4ffa5");
var $Object = require("6d573f741c0f2754").Object;
module.exports = function getOwnPropertyDescriptor(it, key) {
    return $Object.getOwnPropertyDescriptor(it, key);
};

},{"48e45db32cd4ffa5":"6V2Ya","6d573f741c0f2754":"i8kQt"}],"6V2Ya":[function(require,module,exports) {
// 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
var toIObject = require("486c302357b61955");
var $getOwnPropertyDescriptor = require("3252a4704defe9b").f;
require("989e2f1820ee8ade")("getOwnPropertyDescriptor", function() {
    return function getOwnPropertyDescriptor(it, key) {
        return $getOwnPropertyDescriptor(toIObject(it), key);
    };
});

},{"486c302357b61955":"lvd6c","3252a4704defe9b":"h7TTV","989e2f1820ee8ade":"dukCp"}],"eDFIS":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _defineProperty = require("babel-runtime/helpers/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _extends = require("babel-runtime/helpers/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _warning = require("warning");
var _warningDefault = parcelHelpers.interopDefault(_warning);
var calcPoints = function calcPoints(vertical, marks, dots, step, min, max) {
    (0, _warningDefault.default)(dots ? step > 0 : true, "`Slider[step]` should be a positive number in order to make Slider[dots] work.");
    var points = Object.keys(marks).map(parseFloat).sort(function(a, b) {
        return a - b;
    });
    if (dots && step) {
        for(var i = min; i <= max; i += step)if (points.indexOf(i) === -1) points.push(i);
    }
    return points;
};
var Steps = function Steps(_ref) {
    var prefixCls = _ref.prefixCls, vertical = _ref.vertical, reverse = _ref.reverse, marks = _ref.marks, dots = _ref.dots, step = _ref.step, included = _ref.included, lowerBound = _ref.lowerBound, upperBound = _ref.upperBound, max = _ref.max, min = _ref.min, dotStyle = _ref.dotStyle, activeDotStyle = _ref.activeDotStyle;
    var range = max - min;
    var elements = calcPoints(vertical, marks, dots, step, min, max).map(function(point) {
        var _classNames;
        var offset = Math.abs(point - min) / range * 100 + "%";
        var isActived = !included && point === upperBound || included && point <= upperBound && point >= lowerBound;
        var style = vertical ? (0, _extendsDefault.default)({}, dotStyle, (0, _definePropertyDefault.default)({}, reverse ? "top" : "bottom", offset)) : (0, _extendsDefault.default)({}, dotStyle, (0, _definePropertyDefault.default)({}, reverse ? "right" : "left", offset));
        if (isActived) style = (0, _extendsDefault.default)({}, style, activeDotStyle);
        var pointClassName = (0, _classnamesDefault.default)((_classNames = {}, (0, _definePropertyDefault.default)(_classNames, prefixCls + "-dot", true), (0, _definePropertyDefault.default)(_classNames, prefixCls + "-dot-active", isActived), (0, _definePropertyDefault.default)(_classNames, prefixCls + "-dot-reverse", reverse), _classNames));
        return (0, _reactDefault.default).createElement("span", {
            className: pointClassName,
            style: style,
            key: point
        });
    });
    return (0, _reactDefault.default).createElement("div", {
        className: prefixCls + "-step"
    }, elements);
};
Steps.propTypes = {
    prefixCls: (0, _propTypesDefault.default).string,
    activeDotStyle: (0, _propTypesDefault.default).object,
    dotStyle: (0, _propTypesDefault.default).object,
    min: (0, _propTypesDefault.default).number,
    max: (0, _propTypesDefault.default).number,
    upperBound: (0, _propTypesDefault.default).number,
    lowerBound: (0, _propTypesDefault.default).number,
    included: (0, _propTypesDefault.default).bool,
    dots: (0, _propTypesDefault.default).bool,
    step: (0, _propTypesDefault.default).number,
    marks: (0, _propTypesDefault.default).object,
    vertical: (0, _propTypesDefault.default).bool,
    reverse: (0, _propTypesDefault.default).bool
};
exports.default = Steps;

},{"babel-runtime/helpers/defineProperty":"9vPv9","babel-runtime/helpers/extends":"4sKqp","react":"6uln9","prop-types":"6FKs7","classnames":"hVGzI","warning":"cCKmo","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9YDEp":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _extends = require("babel-runtime/helpers/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _defineProperty = require("babel-runtime/helpers/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var Marks = function Marks(_ref) {
    var className = _ref.className, vertical = _ref.vertical, reverse = _ref.reverse, marks = _ref.marks, included = _ref.included, upperBound = _ref.upperBound, lowerBound = _ref.lowerBound, max = _ref.max, min = _ref.min, onClickLabel = _ref.onClickLabel;
    var marksKeys = Object.keys(marks);
    var range = max - min;
    var elements = marksKeys.map(parseFloat).sort(function(a, b) {
        return a - b;
    }).map(function(point) {
        var _classNames;
        var markPoint = marks[point];
        var markPointIsObject = typeof markPoint === "object" && !(0, _reactDefault.default).isValidElement(markPoint);
        var markLabel = markPointIsObject ? markPoint.label : markPoint;
        if (!markLabel && markLabel !== 0) return null;
        var isActive = !included && point === upperBound || included && point <= upperBound && point >= lowerBound;
        var markClassName = (0, _classnamesDefault.default)((_classNames = {}, (0, _definePropertyDefault.default)(_classNames, className + "-text", true), (0, _definePropertyDefault.default)(_classNames, className + "-text-active", isActive), _classNames));
        var bottomStyle = (0, _definePropertyDefault.default)({
            marginBottom: "-50%"
        }, reverse ? "top" : "bottom", (point - min) / range * 100 + "%");
        var leftStyle = (0, _definePropertyDefault.default)({
            transform: "translateX(-50%)",
            msTransform: "translateX(-50%)"
        }, reverse ? "right" : "left", reverse ? (point - min / 4) / range * 100 + "%" : (point - min) / range * 100 + "%");
        var style = vertical ? bottomStyle : leftStyle;
        var markStyle = markPointIsObject ? (0, _extendsDefault.default)({}, style, markPoint.style) : style;
        return (0, _reactDefault.default).createElement("span", {
            className: markClassName,
            style: markStyle,
            key: point,
            onMouseDown: function onMouseDown(e) {
                return onClickLabel(e, point);
            },
            onTouchStart: function onTouchStart(e) {
                return onClickLabel(e, point);
            }
        }, markLabel);
    });
    return (0, _reactDefault.default).createElement("div", {
        className: className
    }, elements);
};
Marks.propTypes = {
    className: (0, _propTypesDefault.default).string,
    vertical: (0, _propTypesDefault.default).bool,
    reverse: (0, _propTypesDefault.default).bool,
    marks: (0, _propTypesDefault.default).object,
    included: (0, _propTypesDefault.default).bool,
    upperBound: (0, _propTypesDefault.default).number,
    lowerBound: (0, _propTypesDefault.default).number,
    max: (0, _propTypesDefault.default).number,
    min: (0, _propTypesDefault.default).number,
    onClickLabel: (0, _propTypesDefault.default).func
};
exports.default = Marks;

},{"babel-runtime/helpers/extends":"4sKqp","babel-runtime/helpers/defineProperty":"9vPv9","react":"6uln9","prop-types":"6FKs7","classnames":"hVGzI","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"5ybBK":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _extends = require("babel-runtime/helpers/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _defineProperty = require("babel-runtime/helpers/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _objectWithoutProperties = require("babel-runtime/helpers/objectWithoutProperties");
var _objectWithoutPropertiesDefault = parcelHelpers.interopDefault(_objectWithoutProperties);
var _classCallCheck = require("babel-runtime/helpers/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("babel-runtime/helpers/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _possibleConstructorReturn = require("babel-runtime/helpers/possibleConstructorReturn");
var _possibleConstructorReturnDefault = parcelHelpers.interopDefault(_possibleConstructorReturn);
var _inherits = require("babel-runtime/helpers/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _addEventListener = require("rc-util/es/Dom/addEventListener");
var _addEventListenerDefault = parcelHelpers.interopDefault(_addEventListener);
var Handle = function(_React$Component) {
    (0, _inheritsDefault.default)(Handle, _React$Component);
    function Handle() {
        var _ref;
        var _temp, _this, _ret;
        (0, _classCallCheckDefault.default)(this, Handle);
        for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return _ret = (_temp = (_this = (0, _possibleConstructorReturnDefault.default)(this, (_ref = Handle.__proto__ || Object.getPrototypeOf(Handle)).call.apply(_ref, [
            this
        ].concat(args))), _this), _this.state = {
            clickFocused: false
        }, _this.setHandleRef = function(node) {
            _this.handle = node;
        }, _this.handleMouseUp = function() {
            if (document.activeElement === _this.handle) _this.setClickFocus(true);
        }, _this.handleMouseDown = function() {
            // fix https://github.com/ant-design/ant-design/issues/15324
            _this.focus();
        }, _this.handleBlur = function() {
            _this.setClickFocus(false);
        }, _this.handleKeyDown = function() {
            _this.setClickFocus(false);
        }, _temp), (0, _possibleConstructorReturnDefault.default)(_this, _ret);
    }
    (0, _createClassDefault.default)(Handle, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                // mouseup won't trigger if mouse moved out of handle,
                // so we listen on document here.
                this.onMouseUpListener = (0, _addEventListenerDefault.default)(document, "mouseup", this.handleMouseUp);
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                if (this.onMouseUpListener) this.onMouseUpListener.remove();
            }
        },
        {
            key: "setClickFocus",
            value: function setClickFocus(focused) {
                this.setState({
                    clickFocused: focused
                });
            }
        },
        {
            key: "clickFocus",
            value: function clickFocus() {
                this.setClickFocus(true);
                this.focus();
            }
        },
        {
            key: "focus",
            value: function focus() {
                this.handle.focus();
            }
        },
        {
            key: "blur",
            value: function blur() {
                this.handle.blur();
            }
        },
        {
            key: "render",
            value: function render() {
                var _ref2, _ref3;
                var _props = this.props, prefixCls = _props.prefixCls, vertical = _props.vertical, reverse = _props.reverse, offset = _props.offset, style = _props.style, disabled = _props.disabled, min = _props.min, max = _props.max, value = _props.value, tabIndex = _props.tabIndex, restProps = (0, _objectWithoutPropertiesDefault.default)(_props, [
                    "prefixCls",
                    "vertical",
                    "reverse",
                    "offset",
                    "style",
                    "disabled",
                    "min",
                    "max",
                    "value",
                    "tabIndex"
                ]);
                var className = (0, _classnamesDefault.default)(this.props.className, (0, _definePropertyDefault.default)({}, prefixCls + "-handle-click-focused", this.state.clickFocused));
                var positionStyle = vertical ? (_ref2 = {}, (0, _definePropertyDefault.default)(_ref2, reverse ? "top" : "bottom", offset + "%"), (0, _definePropertyDefault.default)(_ref2, reverse ? "bottom" : "top", "auto"), (0, _definePropertyDefault.default)(_ref2, "transform", "translateY(+50%)"), _ref2) : (_ref3 = {}, (0, _definePropertyDefault.default)(_ref3, reverse ? "right" : "left", offset + "%"), (0, _definePropertyDefault.default)(_ref3, reverse ? "left" : "right", "auto"), (0, _definePropertyDefault.default)(_ref3, "transform", "translateX(" + (reverse ? "+" : "-") + "50%)"), _ref3);
                var elStyle = (0, _extendsDefault.default)({}, style, positionStyle);
                var _tabIndex = tabIndex || 0;
                if (disabled || tabIndex === null) _tabIndex = null;
                return (0, _reactDefault.default).createElement("div", (0, _extendsDefault.default)({
                    ref: this.setHandleRef,
                    tabIndex: _tabIndex
                }, restProps, {
                    className: className,
                    style: elStyle,
                    onBlur: this.handleBlur,
                    onKeyDown: this.handleKeyDown,
                    onMouseDown: this.handleMouseDown,
                    role: "slider",
                    "aria-valuemin": min,
                    "aria-valuemax": max,
                    "aria-valuenow": value,
                    "aria-disabled": !!disabled
                }));
            }
        }
    ]);
    return Handle;
}((0, _reactDefault.default).Component);
exports.default = Handle;
Handle.propTypes = {
    prefixCls: (0, _propTypesDefault.default).string,
    className: (0, _propTypesDefault.default).string,
    vertical: (0, _propTypesDefault.default).bool,
    offset: (0, _propTypesDefault.default).number,
    style: (0, _propTypesDefault.default).object,
    disabled: (0, _propTypesDefault.default).bool,
    min: (0, _propTypesDefault.default).number,
    max: (0, _propTypesDefault.default).number,
    value: (0, _propTypesDefault.default).number,
    tabIndex: (0, _propTypesDefault.default).number,
    reverse: (0, _propTypesDefault.default).bool
};

},{"babel-runtime/helpers/extends":"4sKqp","babel-runtime/helpers/defineProperty":"9vPv9","babel-runtime/helpers/objectWithoutProperties":"5ILj2","babel-runtime/helpers/classCallCheck":"aRpYz","babel-runtime/helpers/createClass":"a0jaP","babel-runtime/helpers/possibleConstructorReturn":"40Qb5","babel-runtime/helpers/inherits":"bitir","react":"6uln9","prop-types":"6FKs7","classnames":"hVGzI","rc-util/es/Dom/addEventListener":"dHu4r","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hQYgB":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isEventFromHandle", ()=>isEventFromHandle);
parcelHelpers.export(exports, "isValueOutOfRange", ()=>isValueOutOfRange);
parcelHelpers.export(exports, "isNotTouchEvent", ()=>isNotTouchEvent);
parcelHelpers.export(exports, "getClosestPoint", ()=>getClosestPoint);
parcelHelpers.export(exports, "getPrecision", ()=>getPrecision);
parcelHelpers.export(exports, "getMousePosition", ()=>getMousePosition);
parcelHelpers.export(exports, "getTouchPosition", ()=>getTouchPosition);
parcelHelpers.export(exports, "getHandleCenterPosition", ()=>getHandleCenterPosition);
parcelHelpers.export(exports, "ensureValueInRange", ()=>ensureValueInRange);
parcelHelpers.export(exports, "ensureValuePrecision", ()=>ensureValuePrecision);
parcelHelpers.export(exports, "pauseEvent", ()=>pauseEvent);
parcelHelpers.export(exports, "calculateNextValue", ()=>calculateNextValue);
parcelHelpers.export(exports, "getKeyboardValueMutator", ()=>getKeyboardValueMutator);
var _toConsumableArray = require("babel-runtime/helpers/toConsumableArray");
var _toConsumableArrayDefault = parcelHelpers.interopDefault(_toConsumableArray);
var _reactDom = require("react-dom");
var _keyCode = require("rc-util/es/KeyCode");
var _keyCodeDefault = parcelHelpers.interopDefault(_keyCode);
function isEventFromHandle(e, handles) {
    try {
        return Object.keys(handles).some(function(key) {
            return e.target === (0, _reactDom.findDOMNode)(handles[key]);
        });
    } catch (error) {
        return false;
    }
}
function isValueOutOfRange(value, _ref) {
    var min = _ref.min, max = _ref.max;
    return value < min || value > max;
}
function isNotTouchEvent(e) {
    return e.touches.length > 1 || e.type.toLowerCase() === "touchend" && e.touches.length > 0;
}
function getClosestPoint(val, _ref2) {
    var marks = _ref2.marks, step = _ref2.step, min = _ref2.min, max = _ref2.max;
    var points = Object.keys(marks).map(parseFloat);
    if (step !== null) {
        var maxSteps = Math.floor((max - min) / step);
        var steps = Math.min((val - min) / step, maxSteps);
        var closestStep = Math.round(steps) * step + min;
        points.push(closestStep);
    }
    var diffs = points.map(function(point) {
        return Math.abs(val - point);
    });
    return points[diffs.indexOf(Math.min.apply(Math, (0, _toConsumableArrayDefault.default)(diffs)))];
}
function getPrecision(step) {
    var stepString = step.toString();
    var precision = 0;
    if (stepString.indexOf(".") >= 0) precision = stepString.length - stepString.indexOf(".") - 1;
    return precision;
}
function getMousePosition(vertical, e) {
    return vertical ? e.clientY : e.pageX;
}
function getTouchPosition(vertical, e) {
    return vertical ? e.touches[0].clientY : e.touches[0].pageX;
}
function getHandleCenterPosition(vertical, handle) {
    var coords = handle.getBoundingClientRect();
    return vertical ? coords.top + coords.height * 0.5 : window.pageXOffset + coords.left + coords.width * 0.5;
}
function ensureValueInRange(val, _ref3) {
    var max = _ref3.max, min = _ref3.min;
    if (val <= min) return min;
    if (val >= max) return max;
    return val;
}
function ensureValuePrecision(val, props) {
    var step = props.step;
    var closestPoint = isFinite(getClosestPoint(val, props)) ? getClosestPoint(val, props) : 0; // eslint-disable-line
    return step === null ? closestPoint : parseFloat(closestPoint.toFixed(getPrecision(step)));
}
function pauseEvent(e) {
    e.stopPropagation();
    e.preventDefault();
}
function calculateNextValue(func, value, props) {
    var operations = {
        increase: function increase(a, b) {
            return a + b;
        },
        decrease: function decrease(a, b) {
            return a - b;
        }
    };
    var indexToGet = operations[func](Object.keys(props.marks).indexOf(JSON.stringify(value)), 1);
    var keyToGet = Object.keys(props.marks)[indexToGet];
    if (props.step) return operations[func](value, props.step);
    else if (!!Object.keys(props.marks).length && !!props.marks[keyToGet]) return props.marks[keyToGet];
    return value;
}
function getKeyboardValueMutator(e, vertical, reverse) {
    var increase = "increase";
    var decrease = "decrease";
    var method = increase;
    switch(e.keyCode){
        case (0, _keyCodeDefault.default).UP:
            method = vertical && reverse ? decrease : increase;
            break;
        case (0, _keyCodeDefault.default).RIGHT:
            method = !vertical && reverse ? decrease : increase;
            break;
        case (0, _keyCodeDefault.default).DOWN:
            method = vertical && reverse ? increase : decrease;
            break;
        case (0, _keyCodeDefault.default).LEFT:
            method = !vertical && reverse ? increase : decrease;
            break;
        case (0, _keyCodeDefault.default).END:
            return function(value, props) {
                return props.max;
            };
        case (0, _keyCodeDefault.default).HOME:
            return function(value, props) {
                return props.min;
            };
        case (0, _keyCodeDefault.default).PAGE_UP:
            return function(value, props) {
                return value + props.step * 2;
            };
        case (0, _keyCodeDefault.default).PAGE_DOWN:
            return function(value, props) {
                return value - props.step * 2;
            };
        default:
            return undefined;
    }
    return function(value, props) {
        return calculateNextValue(method, value, props);
    };
}

},{"babel-runtime/helpers/toConsumableArray":"hURnd","react-dom":"b8T3j","rc-util/es/KeyCode":"gn1Si","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hURnd":[function(require,module,exports) {
"use strict";
exports.__esModule = true;
var _from = require("ebf5314f09452a3");
var _from2 = _interopRequireDefault(_from);
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
exports.default = function(arr) {
    if (Array.isArray(arr)) {
        for(var i = 0, arr2 = Array(arr.length); i < arr.length; i++)arr2[i] = arr[i];
        return arr2;
    } else return (0, _from2.default)(arr);
};

},{"ebf5314f09452a3":"cppyx"}],"cppyx":[function(require,module,exports) {
module.exports = {
    "default": require("9ecd4bc4f71d2303"),
    __esModule: true
};

},{"9ecd4bc4f71d2303":"3kiF6"}],"3kiF6":[function(require,module,exports) {
require("11ce032b37e3d9f8");
require("8bfe1aa65d0eccb");
module.exports = require("96bc63ef270ee7f2").Array.from;

},{"11ce032b37e3d9f8":"iJCxM","8bfe1aa65d0eccb":"4VYm6","96bc63ef270ee7f2":"i8kQt"}],"4VYm6":[function(require,module,exports) {
"use strict";
var ctx = require("1b084e5486ffcad");
var $export = require("b9c071000a152a02");
var toObject = require("fd8819bcda1e912a");
var call = require("2b564b5c9a66e8fe");
var isArrayIter = require("358138533ef1d2c6");
var toLength = require("48e446a60ae680c9");
var createProperty = require("7b9c8dda7184e442");
var getIterFn = require("63e5ac19c5a8b6cd");
$export($export.S + $export.F * !require("e686eb2a3cda083e")(function(iter) {
    Array.from(iter);
}), "Array", {
    // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
    from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */ ) {
        var O = toObject(arrayLike);
        var C = typeof this == "function" ? this : Array;
        var aLen = arguments.length;
        var mapfn = aLen > 1 ? arguments[1] : undefined;
        var mapping = mapfn !== undefined;
        var index = 0;
        var iterFn = getIterFn(O);
        var length, result, step, iterator;
        if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
        // if object isn't iterable or it's array with default iterator - use simple case
        if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) for(iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++)createProperty(result, index, mapping ? call(iterator, mapfn, [
            step.value,
            index
        ], true) : step.value);
        else {
            length = toLength(O.length);
            for(result = new C(length); length > index; index++)createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
        }
        result.length = index;
        return result;
    }
});

},{"1b084e5486ffcad":"iSPoi","b9c071000a152a02":"1OjY7","fd8819bcda1e912a":"9EHnZ","2b564b5c9a66e8fe":"9sB4c","358138533ef1d2c6":"6JFM1","48e446a60ae680c9":"1O25p","7b9c8dda7184e442":"icdTS","63e5ac19c5a8b6cd":"7GiHr","e686eb2a3cda083e":"gEM4r"}],"9sB4c":[function(require,module,exports) {
// call something on iterator step with safe closing on error
var anObject = require("b2f9f6e9b6054fe3");
module.exports = function(iterator, fn, value, entries) {
    try {
        return entries ? fn(anObject(value)[0], value[1]) : fn(value);
    // 7.4.6 IteratorClose(iterator, completion)
    } catch (e) {
        var ret = iterator["return"];
        if (ret !== undefined) anObject(ret.call(iterator));
        throw e;
    }
};

},{"b2f9f6e9b6054fe3":"lKEVJ"}],"6JFM1":[function(require,module,exports) {
// check on default Array iterator
var Iterators = require("4d77230eebbb3c6");
var ITERATOR = require("43fbbdee559a652c")("iterator");
var ArrayProto = Array.prototype;
module.exports = function(it) {
    return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
};

},{"4d77230eebbb3c6":"3kquG","43fbbdee559a652c":"6tZlw"}],"icdTS":[function(require,module,exports) {
"use strict";
var $defineProperty = require("fae129e7da26b133");
var createDesc = require("ad23ebe345671a1c");
module.exports = function(object, index, value) {
    if (index in object) $defineProperty.f(object, index, createDesc(0, value));
    else object[index] = value;
};

},{"fae129e7da26b133":"5eLt9","ad23ebe345671a1c":"kXqBU"}],"7GiHr":[function(require,module,exports) {
var classof = require("63b9f08f43d7050");
var ITERATOR = require("bc4e4af4566a2425")("iterator");
var Iterators = require("ae97a7710c1d5056");
module.exports = require("3f516024d0dd5dc2").getIteratorMethod = function(it) {
    if (it != undefined) return it[ITERATOR] || it["@@iterator"] || Iterators[classof(it)];
};

},{"63b9f08f43d7050":"65ig5","bc4e4af4566a2425":"6tZlw","ae97a7710c1d5056":"3kquG","3f516024d0dd5dc2":"i8kQt"}],"65ig5":[function(require,module,exports) {
// getting tag from 19.1.3.6 Object.prototype.toString()
var cof = require("dff17c998b31a09b");
var TAG = require("444f5c1ad4ac69c6")("toStringTag");
// ES3 wrong here
var ARG = cof(function() {
    return arguments;
}()) == "Arguments";
// fallback for IE11 Script Access Denied error
var tryGet = function(it, key) {
    try {
        return it[key];
    } catch (e) {}
};
module.exports = function(it) {
    var O, T, B;
    return it === undefined ? "Undefined" : it === null ? "Null" : typeof (T = tryGet(O = Object(it), TAG)) == "string" ? T : ARG ? cof(O) : (B = cof(O)) == "Object" && typeof O.callee == "function" ? "Arguments" : B;
};

},{"dff17c998b31a09b":"kIPjW","444f5c1ad4ac69c6":"6tZlw"}],"gEM4r":[function(require,module,exports) {
var ITERATOR = require("c1c4fca51961666b")("iterator");
var SAFE_CLOSING = false;
try {
    var riter = [
        7
    ][ITERATOR]();
    riter["return"] = function() {
        SAFE_CLOSING = true;
    };
    // eslint-disable-next-line no-throw-literal
    Array.from(riter, function() {
        throw 2;
    });
} catch (e) {}
module.exports = function(exec, skipClosing) {
    if (!skipClosing && !SAFE_CLOSING) return false;
    var safe = false;
    try {
        var arr = [
            7
        ];
        var iter = arr[ITERATOR]();
        iter.next = function() {
            return {
                done: safe = true
            };
        };
        arr[ITERATOR] = function() {
            return iter;
        };
        exec(arr);
    } catch (e) {}
    return safe;
};

},{"c1c4fca51961666b":"6tZlw"}],"gn1Si":[function(require,module,exports) {
/**
 * @ignore
 * some key-codes definition and utils from closure-library
 * @author yiminghe@gmail.com
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var KeyCode = {
    /**
   * MAC_ENTER
   */ MAC_ENTER: 3,
    /**
   * BACKSPACE
   */ BACKSPACE: 8,
    /**
   * TAB
   */ TAB: 9,
    /**
   * NUMLOCK on FF/Safari Mac
   */ NUM_CENTER: 12,
    /**
   * ENTER
   */ ENTER: 13,
    /**
   * SHIFT
   */ SHIFT: 16,
    /**
   * CTRL
   */ CTRL: 17,
    /**
   * ALT
   */ ALT: 18,
    /**
   * PAUSE
   */ PAUSE: 19,
    /**
   * CAPS_LOCK
   */ CAPS_LOCK: 20,
    /**
   * ESC
   */ ESC: 27,
    /**
   * SPACE
   */ SPACE: 32,
    /**
   * PAGE_UP
   */ PAGE_UP: 33,
    /**
   * PAGE_DOWN
   */ PAGE_DOWN: 34,
    /**
   * END
   */ END: 35,
    /**
   * HOME
   */ HOME: 36,
    /**
   * LEFT
   */ LEFT: 37,
    /**
   * UP
   */ UP: 38,
    /**
   * RIGHT
   */ RIGHT: 39,
    /**
   * DOWN
   */ DOWN: 40,
    /**
   * PRINT_SCREEN
   */ PRINT_SCREEN: 44,
    /**
   * INSERT
   */ INSERT: 45,
    /**
   * DELETE
   */ DELETE: 46,
    /**
   * ZERO
   */ ZERO: 48,
    /**
   * ONE
   */ ONE: 49,
    /**
   * TWO
   */ TWO: 50,
    /**
   * THREE
   */ THREE: 51,
    /**
   * FOUR
   */ FOUR: 52,
    /**
   * FIVE
   */ FIVE: 53,
    /**
   * SIX
   */ SIX: 54,
    /**
   * SEVEN
   */ SEVEN: 55,
    /**
   * EIGHT
   */ EIGHT: 56,
    /**
   * NINE
   */ NINE: 57,
    /**
   * QUESTION_MARK
   */ QUESTION_MARK: 63,
    /**
   * A
   */ A: 65,
    /**
   * B
   */ B: 66,
    /**
   * C
   */ C: 67,
    /**
   * D
   */ D: 68,
    /**
   * E
   */ E: 69,
    /**
   * F
   */ F: 70,
    /**
   * G
   */ G: 71,
    /**
   * H
   */ H: 72,
    /**
   * I
   */ I: 73,
    /**
   * J
   */ J: 74,
    /**
   * K
   */ K: 75,
    /**
   * L
   */ L: 76,
    /**
   * M
   */ M: 77,
    /**
   * N
   */ N: 78,
    /**
   * O
   */ O: 79,
    /**
   * P
   */ P: 80,
    /**
   * Q
   */ Q: 81,
    /**
   * R
   */ R: 82,
    /**
   * S
   */ S: 83,
    /**
   * T
   */ T: 84,
    /**
   * U
   */ U: 85,
    /**
   * V
   */ V: 86,
    /**
   * W
   */ W: 87,
    /**
   * X
   */ X: 88,
    /**
   * Y
   */ Y: 89,
    /**
   * Z
   */ Z: 90,
    /**
   * META
   */ META: 91,
    /**
   * WIN_KEY_RIGHT
   */ WIN_KEY_RIGHT: 92,
    /**
   * CONTEXT_MENU
   */ CONTEXT_MENU: 93,
    /**
   * NUM_ZERO
   */ NUM_ZERO: 96,
    /**
   * NUM_ONE
   */ NUM_ONE: 97,
    /**
   * NUM_TWO
   */ NUM_TWO: 98,
    /**
   * NUM_THREE
   */ NUM_THREE: 99,
    /**
   * NUM_FOUR
   */ NUM_FOUR: 100,
    /**
   * NUM_FIVE
   */ NUM_FIVE: 101,
    /**
   * NUM_SIX
   */ NUM_SIX: 102,
    /**
   * NUM_SEVEN
   */ NUM_SEVEN: 103,
    /**
   * NUM_EIGHT
   */ NUM_EIGHT: 104,
    /**
   * NUM_NINE
   */ NUM_NINE: 105,
    /**
   * NUM_MULTIPLY
   */ NUM_MULTIPLY: 106,
    /**
   * NUM_PLUS
   */ NUM_PLUS: 107,
    /**
   * NUM_MINUS
   */ NUM_MINUS: 109,
    /**
   * NUM_PERIOD
   */ NUM_PERIOD: 110,
    /**
   * NUM_DIVISION
   */ NUM_DIVISION: 111,
    /**
   * F1
   */ F1: 112,
    /**
   * F2
   */ F2: 113,
    /**
   * F3
   */ F3: 114,
    /**
   * F4
   */ F4: 115,
    /**
   * F5
   */ F5: 116,
    /**
   * F6
   */ F6: 117,
    /**
   * F7
   */ F7: 118,
    /**
   * F8
   */ F8: 119,
    /**
   * F9
   */ F9: 120,
    /**
   * F10
   */ F10: 121,
    /**
   * F11
   */ F11: 122,
    /**
   * F12
   */ F12: 123,
    /**
   * NUMLOCK
   */ NUMLOCK: 144,
    /**
   * SEMICOLON
   */ SEMICOLON: 186,
    /**
   * DASH
   */ DASH: 189,
    /**
   * EQUALS
   */ EQUALS: 187,
    /**
   * COMMA
   */ COMMA: 188,
    /**
   * PERIOD
   */ PERIOD: 190,
    /**
   * SLASH
   */ SLASH: 191,
    /**
   * APOSTROPHE
   */ APOSTROPHE: 192,
    /**
   * SINGLE_QUOTE
   */ SINGLE_QUOTE: 222,
    /**
   * OPEN_SQUARE_BRACKET
   */ OPEN_SQUARE_BRACKET: 219,
    /**
   * BACKSLASH
   */ BACKSLASH: 220,
    /**
   * CLOSE_SQUARE_BRACKET
   */ CLOSE_SQUARE_BRACKET: 221,
    /**
   * WIN_KEY
   */ WIN_KEY: 224,
    /**
   * MAC_FF_META
   */ MAC_FF_META: 224,
    /**
   * WIN_IME
   */ WIN_IME: 229,
    // ======================== Function ========================
    /**
   * whether text and modified key is entered at the same time.
   */ isTextModifyingKeyEvent: function isTextModifyingKeyEvent(e) {
        var keyCode = e.keyCode;
        if (e.altKey && !e.ctrlKey || e.metaKey || // Function keys don't generate text
        keyCode >= KeyCode.F1 && keyCode <= KeyCode.F12) return false;
         // The following keys are quite harmless, even in combination with
        // CTRL, ALT or SHIFT.
        switch(keyCode){
            case KeyCode.ALT:
            case KeyCode.CAPS_LOCK:
            case KeyCode.CONTEXT_MENU:
            case KeyCode.CTRL:
            case KeyCode.DOWN:
            case KeyCode.END:
            case KeyCode.ESC:
            case KeyCode.HOME:
            case KeyCode.INSERT:
            case KeyCode.LEFT:
            case KeyCode.MAC_FF_META:
            case KeyCode.META:
            case KeyCode.NUMLOCK:
            case KeyCode.NUM_CENTER:
            case KeyCode.PAGE_DOWN:
            case KeyCode.PAGE_UP:
            case KeyCode.PAUSE:
            case KeyCode.PRINT_SCREEN:
            case KeyCode.RIGHT:
            case KeyCode.SHIFT:
            case KeyCode.UP:
            case KeyCode.WIN_KEY:
            case KeyCode.WIN_KEY_RIGHT:
                return false;
            default:
                return true;
        }
    },
    /**
   * whether character is entered.
   */ isCharacterKey: function isCharacterKey(keyCode) {
        if (keyCode >= KeyCode.ZERO && keyCode <= KeyCode.NINE) return true;
        if (keyCode >= KeyCode.NUM_ZERO && keyCode <= KeyCode.NUM_MULTIPLY) return true;
        if (keyCode >= KeyCode.A && keyCode <= KeyCode.Z) return true;
         // Safari sends zero key code for non-latin characters.
        if (window.navigator.userAgent.indexOf("WebKit") !== -1 && keyCode === 0) return true;
        switch(keyCode){
            case KeyCode.SPACE:
            case KeyCode.QUESTION_MARK:
            case KeyCode.NUM_PLUS:
            case KeyCode.NUM_MINUS:
            case KeyCode.NUM_PERIOD:
            case KeyCode.NUM_DIVISION:
            case KeyCode.SEMICOLON:
            case KeyCode.DASH:
            case KeyCode.EQUALS:
            case KeyCode.COMMA:
            case KeyCode.PERIOD:
            case KeyCode.SLASH:
            case KeyCode.APOSTROPHE:
            case KeyCode.SINGLE_QUOTE:
            case KeyCode.OPEN_SQUARE_BRACKET:
            case KeyCode.BACKSLASH:
            case KeyCode.CLOSE_SQUARE_BRACKET:
                return true;
            default:
                return false;
        }
    }
};
exports.default = KeyCode;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"haO10":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _defineProperty = require("babel-runtime/helpers/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _extends = require("babel-runtime/helpers/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _toConsumableArray = require("babel-runtime/helpers/toConsumableArray");
var _toConsumableArrayDefault = parcelHelpers.interopDefault(_toConsumableArray);
var _classCallCheck = require("babel-runtime/helpers/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("babel-runtime/helpers/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _possibleConstructorReturn = require("babel-runtime/helpers/possibleConstructorReturn");
var _possibleConstructorReturnDefault = parcelHelpers.interopDefault(_possibleConstructorReturn);
var _inherits = require("babel-runtime/helpers/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
/* eslint-disable react/prop-types */ var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _reactLifecyclesCompat = require("react-lifecycles-compat");
var _shallowequal = require("shallowequal");
var _shallowequalDefault = parcelHelpers.interopDefault(_shallowequal);
var _track = require("./common/Track");
var _trackDefault = parcelHelpers.interopDefault(_track);
var _createSlider = require("./common/createSlider");
var _createSliderDefault = parcelHelpers.interopDefault(_createSlider);
var _utils = require("./utils");
var _trimAlignValue = function _trimAlignValue(_ref) {
    var value = _ref.value, handle = _ref.handle, bounds = _ref.bounds, props = _ref.props;
    var allowCross = props.allowCross, pushable = props.pushable;
    var thershold = Number(pushable);
    var valInRange = _utils.ensureValueInRange(value, props);
    var valNotConflict = valInRange;
    if (!allowCross && handle != null && bounds !== undefined) {
        if (handle > 0 && valInRange <= bounds[handle - 1] + thershold) valNotConflict = bounds[handle - 1] + thershold;
        if (handle < bounds.length - 1 && valInRange >= bounds[handle + 1] - thershold) valNotConflict = bounds[handle + 1] - thershold;
    }
    return _utils.ensureValuePrecision(valNotConflict, props);
};
var Range = function(_React$Component) {
    (0, _inheritsDefault.default)(Range, _React$Component);
    function Range(props) {
        (0, _classCallCheckDefault.default)(this, Range);
        var _this = (0, _possibleConstructorReturnDefault.default)(this, (Range.__proto__ || Object.getPrototypeOf(Range)).call(this, props));
        _this.onEnd = function(force) {
            var handle = _this.state.handle;
            _this.removeDocumentEvents();
            if (handle !== null || force) _this.props.onAfterChange(_this.getValue());
            _this.setState({
                handle: null
            });
        };
        var count = props.count, min = props.min, max = props.max;
        var initialValue = Array.apply(undefined, (0, _toConsumableArrayDefault.default)(Array(count + 1))).map(function() {
            return min;
        });
        var defaultValue = "defaultValue" in props ? props.defaultValue : initialValue;
        var value = props.value !== undefined ? props.value : defaultValue;
        var bounds = value.map(function(v, i) {
            return _trimAlignValue({
                value: v,
                handle: i,
                props: props
            });
        });
        var recent = bounds[0] === max ? 0 : bounds.length - 1;
        _this.state = {
            handle: null,
            recent: recent,
            bounds: bounds
        };
        return _this;
    }
    (0, _createClassDefault.default)(Range, [
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps, prevState) {
                var _this2 = this;
                if (!("value" in this.props || "min" in this.props || "max" in this.props)) return;
                if (this.props.min === prevProps.min && this.props.max === prevProps.max && (0, _shallowequalDefault.default)(this.props.value, prevProps.value)) return;
                var _props = this.props, onChange = _props.onChange, value = _props.value;
                var currentValue = value || prevState.bounds;
                if (currentValue.some(function(v) {
                    return _utils.isValueOutOfRange(v, _this2.props);
                })) {
                    var newValues = currentValue.map(function(v) {
                        return _utils.ensureValueInRange(v, _this2.props);
                    });
                    onChange(newValues);
                }
            }
        },
        {
            key: "onChange",
            value: function onChange(state) {
                var props = this.props;
                var isNotControlled = !("value" in props);
                if (isNotControlled) this.setState(state);
                else {
                    var controlledState = {};
                    [
                        "handle",
                        "recent"
                    ].forEach(function(item) {
                        if (state[item] !== undefined) controlledState[item] = state[item];
                    });
                    if (Object.keys(controlledState).length) this.setState(controlledState);
                }
                var data = (0, _extendsDefault.default)({}, this.state, state);
                var changedValue = data.bounds;
                props.onChange(changedValue);
            }
        },
        {
            key: "onStart",
            value: function onStart(position) {
                var props = this.props;
                var state = this.state;
                var bounds = this.getValue();
                props.onBeforeChange(bounds);
                var value = this.calcValueByPos(position);
                this.startValue = value;
                this.startPosition = position;
                var closestBound = this.getClosestBound(value);
                this.prevMovedHandleIndex = this.getBoundNeedMoving(value, closestBound);
                this.setState({
                    handle: this.prevMovedHandleIndex,
                    recent: this.prevMovedHandleIndex
                });
                var prevValue = bounds[this.prevMovedHandleIndex];
                if (value === prevValue) return;
                var nextBounds = [].concat((0, _toConsumableArrayDefault.default)(state.bounds));
                nextBounds[this.prevMovedHandleIndex] = value;
                this.onChange({
                    bounds: nextBounds
                });
            }
        },
        {
            key: "onMove",
            value: function onMove(e, position) {
                _utils.pauseEvent(e);
                var state = this.state;
                var value = this.calcValueByPos(position);
                var oldValue = state.bounds[state.handle];
                if (value === oldValue) return;
                this.moveTo(value);
            }
        },
        {
            key: "onKeyboard",
            value: function onKeyboard(e) {
                var _props2 = this.props, reverse = _props2.reverse, vertical = _props2.vertical;
                var valueMutator = _utils.getKeyboardValueMutator(e, vertical, reverse);
                if (valueMutator) {
                    _utils.pauseEvent(e);
                    var state = this.state, props = this.props;
                    var bounds = state.bounds, handle = state.handle;
                    var oldValue = bounds[handle === null ? state.recent : handle];
                    var mutatedValue = valueMutator(oldValue, props);
                    var value = _trimAlignValue({
                        value: mutatedValue,
                        handle: handle,
                        bounds: state.bounds,
                        props: props
                    });
                    if (value === oldValue) return;
                    var isFromKeyboardEvent = true;
                    this.moveTo(value, isFromKeyboardEvent);
                }
            }
        },
        {
            key: "getValue",
            value: function getValue() {
                return this.state.bounds;
            }
        },
        {
            key: "getClosestBound",
            value: function getClosestBound(value) {
                var bounds = this.state.bounds;
                var closestBound = 0;
                for(var i = 1; i < bounds.length - 1; ++i)if (value >= bounds[i]) closestBound = i;
                if (Math.abs(bounds[closestBound + 1] - value) < Math.abs(bounds[closestBound] - value)) closestBound += 1;
                return closestBound;
            }
        },
        {
            key: "getBoundNeedMoving",
            value: function getBoundNeedMoving(value, closestBound) {
                var _state = this.state, bounds = _state.bounds, recent = _state.recent;
                var boundNeedMoving = closestBound;
                var isAtTheSamePoint = bounds[closestBound + 1] === bounds[closestBound];
                if (isAtTheSamePoint && bounds[recent] === bounds[closestBound]) boundNeedMoving = recent;
                if (isAtTheSamePoint && value !== bounds[closestBound + 1]) boundNeedMoving = value < bounds[closestBound + 1] ? closestBound : closestBound + 1;
                return boundNeedMoving;
            }
        },
        {
            key: "getLowerBound",
            value: function getLowerBound() {
                return this.state.bounds[0];
            }
        },
        {
            key: "getUpperBound",
            value: function getUpperBound() {
                var bounds = this.state.bounds;
                return bounds[bounds.length - 1];
            }
        },
        {
            key: "getPoints",
            value: function getPoints() {
                var _props3 = this.props, marks = _props3.marks, step = _props3.step, min = _props3.min, max = _props3.max;
                var cache = this._getPointsCache;
                if (!cache || cache.marks !== marks || cache.step !== step) {
                    var pointsObject = (0, _extendsDefault.default)({}, marks);
                    if (step !== null) for(var point = min; point <= max; point += step)pointsObject[point] = point;
                    var points = Object.keys(pointsObject).map(parseFloat);
                    points.sort(function(a, b) {
                        return a - b;
                    });
                    this._getPointsCache = {
                        marks: marks,
                        step: step,
                        points: points
                    };
                }
                return this._getPointsCache.points;
            }
        },
        {
            key: "moveTo",
            value: function moveTo(value, isFromKeyboardEvent) {
                var _this3 = this;
                var state = this.state, props = this.props;
                var nextBounds = [].concat((0, _toConsumableArrayDefault.default)(state.bounds));
                var handle = state.handle === null ? state.recent : state.handle;
                nextBounds[handle] = value;
                var nextHandle = handle;
                if (props.pushable !== false) this.pushSurroundingHandles(nextBounds, nextHandle);
                else if (props.allowCross) {
                    nextBounds.sort(function(a, b) {
                        return a - b;
                    });
                    nextHandle = nextBounds.indexOf(value);
                }
                this.onChange({
                    recent: nextHandle,
                    handle: nextHandle,
                    bounds: nextBounds
                });
                if (isFromKeyboardEvent) {
                    // known problem: because setState is async,
                    // so trigger focus will invoke handler's onEnd and another handler's onStart too early,
                    // cause onBeforeChange and onAfterChange receive wrong value.
                    // here use setState callback to hack，but not elegant
                    this.props.onAfterChange(nextBounds);
                    this.setState({}, function() {
                        _this3.handlesRefs[nextHandle].focus();
                    });
                    this.onEnd();
                }
            }
        },
        {
            key: "pushSurroundingHandles",
            value: function pushSurroundingHandles(bounds, handle) {
                var value = bounds[handle];
                var threshold = this.props.pushable;
                threshold = Number(threshold);
                var direction = 0;
                if (bounds[handle + 1] - value < threshold) direction = 1; // push to right
                if (value - bounds[handle - 1] < threshold) direction = -1; // push to left
                if (direction === 0) return;
                var nextHandle = handle + direction;
                var diffToNext = direction * (bounds[nextHandle] - value);
                if (!this.pushHandle(bounds, nextHandle, direction, threshold - diffToNext)) // revert to original value if pushing is impossible
                bounds[handle] = bounds[nextHandle] - direction * threshold;
            }
        },
        {
            key: "pushHandle",
            value: function pushHandle(bounds, handle, direction, amount) {
                var originalValue = bounds[handle];
                var currentValue = bounds[handle];
                while(direction * (currentValue - originalValue) < amount){
                    if (!this.pushHandleOnePoint(bounds, handle, direction)) {
                        // can't push handle enough to create the needed `amount` gap, so we
                        // revert its position to the original value
                        bounds[handle] = originalValue;
                        return false;
                    }
                    currentValue = bounds[handle];
                }
                // the handle was pushed enough to create the needed `amount` gap
                return true;
            }
        },
        {
            key: "pushHandleOnePoint",
            value: function pushHandleOnePoint(bounds, handle, direction) {
                var points = this.getPoints();
                var pointIndex = points.indexOf(bounds[handle]);
                var nextPointIndex = pointIndex + direction;
                if (nextPointIndex >= points.length || nextPointIndex < 0) // reached the minimum or maximum available point, can't push anymore
                return false;
                var nextHandle = handle + direction;
                var nextValue = points[nextPointIndex];
                var threshold = this.props.pushable;
                var diffToNext = direction * (bounds[nextHandle] - nextValue);
                if (!this.pushHandle(bounds, nextHandle, direction, threshold - diffToNext)) // couldn't push next handle, so we won't push this one either
                return false;
                // push the handle
                bounds[handle] = nextValue;
                return true;
            }
        },
        {
            key: "trimAlignValue",
            value: function trimAlignValue(value) {
                var _state2 = this.state, handle = _state2.handle, bounds = _state2.bounds;
                return _trimAlignValue({
                    value: value,
                    handle: handle,
                    bounds: bounds,
                    props: this.props
                });
            }
        },
        {
            key: "render",
            value: function render() {
                var _this4 = this;
                var _state3 = this.state, handle = _state3.handle, bounds = _state3.bounds;
                var _props4 = this.props, prefixCls = _props4.prefixCls, vertical = _props4.vertical, included = _props4.included, disabled = _props4.disabled, min = _props4.min, max = _props4.max, reverse = _props4.reverse, handleGenerator = _props4.handle, trackStyle = _props4.trackStyle, handleStyle = _props4.handleStyle, tabIndex = _props4.tabIndex;
                var offsets = bounds.map(function(v) {
                    return _this4.calcOffset(v);
                });
                var handleClassName = prefixCls + "-handle";
                var handles = bounds.map(function(v, i) {
                    var _classNames;
                    var _tabIndex = tabIndex[i] || 0;
                    if (disabled || tabIndex[i] === null) _tabIndex = null;
                    return handleGenerator({
                        className: (0, _classnamesDefault.default)((_classNames = {}, (0, _definePropertyDefault.default)(_classNames, handleClassName, true), (0, _definePropertyDefault.default)(_classNames, handleClassName + "-" + (i + 1), true), _classNames)),
                        prefixCls: prefixCls,
                        vertical: vertical,
                        offset: offsets[i],
                        value: v,
                        dragging: handle === i,
                        index: i,
                        tabIndex: _tabIndex,
                        min: min,
                        max: max,
                        reverse: reverse,
                        disabled: disabled,
                        style: handleStyle[i],
                        ref: function ref(h) {
                            return _this4.saveHandle(i, h);
                        }
                    });
                });
                var tracks = bounds.slice(0, -1).map(function(_, index) {
                    var _classNames2;
                    var i = index + 1;
                    var trackClassName = (0, _classnamesDefault.default)((_classNames2 = {}, (0, _definePropertyDefault.default)(_classNames2, prefixCls + "-track", true), (0, _definePropertyDefault.default)(_classNames2, prefixCls + "-track-" + i, true), _classNames2));
                    return (0, _reactDefault.default).createElement((0, _trackDefault.default), {
                        className: trackClassName,
                        vertical: vertical,
                        reverse: reverse,
                        included: included,
                        offset: offsets[i - 1],
                        length: offsets[i] - offsets[i - 1],
                        style: trackStyle[index],
                        key: i
                    });
                });
                return {
                    tracks: tracks,
                    handles: handles
                };
            }
        }
    ], [
        {
            key: "getDerivedStateFromProps",
            value: function getDerivedStateFromProps(props, state) {
                if ("value" in props || "min" in props || "max" in props) {
                    var value = props.value || state.bounds;
                    var nextBounds = value.map(function(v, i) {
                        return _trimAlignValue({
                            value: v,
                            handle: i,
                            bounds: state.bounds,
                            props: props
                        });
                    });
                    if (nextBounds.length === state.bounds.length && nextBounds.every(function(v, i) {
                        return v === state.bounds[i];
                    })) return null;
                    return (0, _extendsDefault.default)({}, state, {
                        bounds: nextBounds
                    });
                }
                return null;
            }
        }
    ]);
    return Range;
}((0, _reactDefault.default).Component);
Range.displayName = "Range";
Range.propTypes = {
    autoFocus: (0, _propTypesDefault.default).bool,
    defaultValue: (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).number),
    value: (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).number),
    count: (0, _propTypesDefault.default).number,
    pushable: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).bool,
        (0, _propTypesDefault.default).number
    ]),
    allowCross: (0, _propTypesDefault.default).bool,
    disabled: (0, _propTypesDefault.default).bool,
    reverse: (0, _propTypesDefault.default).bool,
    tabIndex: (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).number),
    min: (0, _propTypesDefault.default).number,
    max: (0, _propTypesDefault.default).number
};
Range.defaultProps = {
    count: 1,
    allowCross: true,
    pushable: false,
    tabIndex: []
};
(0, _reactLifecyclesCompat.polyfill)(Range);
exports.default = (0, _createSliderDefault.default)(Range);

},{"babel-runtime/helpers/defineProperty":"9vPv9","babel-runtime/helpers/extends":"4sKqp","babel-runtime/helpers/toConsumableArray":"hURnd","babel-runtime/helpers/classCallCheck":"aRpYz","babel-runtime/helpers/createClass":"a0jaP","babel-runtime/helpers/possibleConstructorReturn":"40Qb5","babel-runtime/helpers/inherits":"bitir","react":"6uln9","prop-types":"6FKs7","classnames":"hVGzI","react-lifecycles-compat":"jRjXN","shallowequal":"4Nq3A","./common/Track":"iXjPX","./common/createSlider":"h5A2C","./utils":"hQYgB","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4Nq3A":[function(require,module,exports) {
//
module.exports = function shallowEqual(objA, objB, compare, compareContext) {
    var ret = compare ? compare.call(compareContext, objA, objB) : void 0;
    if (ret !== void 0) return !!ret;
    if (objA === objB) return true;
    if (typeof objA !== "object" || !objA || typeof objB !== "object" || !objB) return false;
    var keysA = Object.keys(objA);
    var keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
    // Test for A's keys different from B.
    for(var idx = 0; idx < keysA.length; idx++){
        var key = keysA[idx];
        if (!bHasOwnProperty(key)) return false;
        var valueA = objA[key];
        var valueB = objB[key];
        ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;
        if (ret === false || ret === void 0 && valueA !== valueB) return false;
    }
    return true;
};

},{}],"3G15q":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>createSliderWithTooltip);
var _objectWithoutProperties = require("babel-runtime/helpers/objectWithoutProperties");
var _objectWithoutPropertiesDefault = parcelHelpers.interopDefault(_objectWithoutProperties);
var _defineProperty = require("babel-runtime/helpers/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _extends = require("babel-runtime/helpers/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _classCallCheck = require("babel-runtime/helpers/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("babel-runtime/helpers/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _possibleConstructorReturn = require("babel-runtime/helpers/possibleConstructorReturn");
var _possibleConstructorReturnDefault = parcelHelpers.interopDefault(_possibleConstructorReturn);
var _inherits = require("babel-runtime/helpers/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _rcTooltip = require("rc-tooltip");
var _rcTooltipDefault = parcelHelpers.interopDefault(_rcTooltip);
var _handle = require("./Handle");
var _handleDefault = parcelHelpers.interopDefault(_handle);
function createSliderWithTooltip(Component) {
    var _class, _temp2;
    return _temp2 = _class = function(_React$Component) {
        (0, _inheritsDefault.default)(ComponentWrapper, _React$Component);
        function ComponentWrapper() {
            var _ref;
            var _temp, _this, _ret;
            (0, _classCallCheckDefault.default)(this, ComponentWrapper);
            for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            return _ret = (_temp = (_this = (0, _possibleConstructorReturnDefault.default)(this, (_ref = ComponentWrapper.__proto__ || Object.getPrototypeOf(ComponentWrapper)).call.apply(_ref, [
                this
            ].concat(args))), _this), _this.state = {
                visibles: {}
            }, _this.handleTooltipVisibleChange = function(index, visible) {
                _this.setState(function(prevState) {
                    return {
                        visibles: (0, _extendsDefault.default)({}, prevState.visibles, (0, _definePropertyDefault.default)({}, index, visible))
                    };
                });
            }, _this.handleWithTooltip = function(_ref2) {
                var value = _ref2.value, dragging = _ref2.dragging, index = _ref2.index, disabled = _ref2.disabled, restProps = (0, _objectWithoutPropertiesDefault.default)(_ref2, [
                    "value",
                    "dragging",
                    "index",
                    "disabled"
                ]);
                var _this$props = _this.props, tipFormatter = _this$props.tipFormatter, tipProps = _this$props.tipProps, handleStyle = _this$props.handleStyle;
                var _tipProps$prefixCls = tipProps.prefixCls, prefixCls = _tipProps$prefixCls === undefined ? "rc-slider-tooltip" : _tipProps$prefixCls, _tipProps$overlay = tipProps.overlay, overlay = _tipProps$overlay === undefined ? tipFormatter(value) : _tipProps$overlay, _tipProps$placement = tipProps.placement, placement = _tipProps$placement === undefined ? "top" : _tipProps$placement, _tipProps$visible = tipProps.visible, visible = _tipProps$visible === undefined ? false : _tipProps$visible, restTooltipProps = (0, _objectWithoutPropertiesDefault.default)(tipProps, [
                    "prefixCls",
                    "overlay",
                    "placement",
                    "visible"
                ]);
                var handleStyleWithIndex = void 0;
                if (Array.isArray(handleStyle)) handleStyleWithIndex = handleStyle[index] || handleStyle[0];
                else handleStyleWithIndex = handleStyle;
                return (0, _reactDefault.default).createElement((0, _rcTooltipDefault.default), (0, _extendsDefault.default)({}, restTooltipProps, {
                    prefixCls: prefixCls,
                    overlay: overlay,
                    placement: placement,
                    visible: !disabled && (_this.state.visibles[index] || dragging) || visible,
                    key: index
                }), (0, _reactDefault.default).createElement((0, _handleDefault.default), (0, _extendsDefault.default)({}, restProps, {
                    style: (0, _extendsDefault.default)({}, handleStyleWithIndex),
                    value: value,
                    onMouseEnter: function onMouseEnter() {
                        return _this.handleTooltipVisibleChange(index, true);
                    },
                    onMouseLeave: function onMouseLeave() {
                        return _this.handleTooltipVisibleChange(index, false);
                    }
                })));
            }, _temp), (0, _possibleConstructorReturnDefault.default)(_this, _ret);
        }
        (0, _createClassDefault.default)(ComponentWrapper, [
            {
                key: "render",
                value: function render() {
                    return (0, _reactDefault.default).createElement(Component, (0, _extendsDefault.default)({}, this.props, {
                        handle: this.handleWithTooltip
                    }));
                }
            }
        ]);
        return ComponentWrapper;
    }((0, _reactDefault.default).Component), _class.propTypes = {
        tipFormatter: (0, _propTypesDefault.default).func,
        handleStyle: (0, _propTypesDefault.default).oneOfType([
            (0, _propTypesDefault.default).object,
            (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).object)
        ]),
        tipProps: (0, _propTypesDefault.default).object
    }, _class.defaultProps = {
        tipFormatter: function tipFormatter(value) {
            return value;
        },
        handleStyle: [
            {}
        ],
        tipProps: {}
    }, _temp2;
}

},{"babel-runtime/helpers/objectWithoutProperties":"5ILj2","babel-runtime/helpers/defineProperty":"9vPv9","babel-runtime/helpers/extends":"4sKqp","babel-runtime/helpers/classCallCheck":"aRpYz","babel-runtime/helpers/createClass":"a0jaP","babel-runtime/helpers/possibleConstructorReturn":"40Qb5","babel-runtime/helpers/inherits":"bitir","react":"6uln9","prop-types":"6FKs7","rc-tooltip":"fhD1R","./Handle":"5ybBK","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hMXqn":[function() {},{}],"j90Zy":[function(require,module,exports) {
module.exports = require("34b36398ae333230").getBundleURL("kVLro") + require("3e7a509a13cd7d6b").resolve("eTll0");

},{"34b36398ae333230":"c7Tr5","3e7a509a13cd7d6b":"fyJL2"}],"hBznb":[function(require,module,exports) {
module.exports = require("5ca4c91641118799").getBundleURL("kVLro") + require("135c24c9d5c773a3").resolve("8l9GT");

},{"5ca4c91641118799":"c7Tr5","135c24c9d5c773a3":"fyJL2"}],"2fvnO":[function(require,module,exports) {
module.exports = require("edf19127087c2f20").getBundleURL("kVLro") + require("f414e4892d767db9").resolve("16ZLq");

},{"edf19127087c2f20":"c7Tr5","f414e4892d767db9":"fyJL2"}],"YJYcI":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _rcTooltip = require("rc-tooltip");
var _rcTooltipDefault = parcelHelpers.interopDefault(_rcTooltip);
var _overflowMenu = require("./OverflowMenu");
var _overflowMenuDefault = parcelHelpers.interopDefault(_overflowMenu);
var _colors = require("../../../constants/colors");
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const SmallOverflowMenu = (props)=>{
    const [isActive, setIsActive] = (0, _react1.useState)(false);
    (0, _react1.useEffect)(()=>{
        if (props.isActive != isActive) {
            setIsActive(props.isActive);
            updateSetIsOverFlowMenuOption(props.isActive);
        }
    }, []);
    const handleClick = ()=>{
        setIsActive(!isActive);
        updateSetIsOverFlowMenuOption(!props.isActive);
    };
    const handleMenuClose = ()=>{
        setIsActive(false);
        updateSetIsOverFlowMenuOption(false);
    };
    const updateSetIsOverFlowMenuOption = (val)=>{
        if (props.setIsOverFlowMenuOpen) props.setIsOverFlowMenuOpen(val);
    };
    return (0, _react.jsx)("div", {
        className: `${rowCss} ${props.className}`
    }, props.label != null && (0, _react.jsx)("span", {
        onClick: handleClick.bind(undefined),
        className: "label"
    }, props.label), (0, _react.jsx)("div", {
        className: containerStyle
    }, (0, _react.jsx)((0, _rcTooltipDefault.default), {
        mouseEnterDelay: .5,
        overlayClassName: tooltipContentStyle,
        trigger: [
            "hover"
        ],
        placement: "top",
        overlay: (0, _react.jsx)("span", null, "Show options")
    }, (0, _react.jsx)("span", {
        onClick: handleClick.bind(undefined),
        className: `${overflowButtonStyle} ${isActive ? "active" : ""} ${props.buttonClassName}`
    }, (0, _react.jsx)("div", {
        className: "circle"
    }), (0, _react.jsx)("div", {
        className: "circle"
    }), (0, _react.jsx)("div", {
        className: "circle"
    }))), isActive ? (0, _react.jsx)((0, _overflowMenuDefault.default), {
        onClose: handleMenuClose.bind(undefined),
        onOptionSelected: props.onOptionSelected,
        options: props.options,
        optionClassName: props.optionClassName,
        className: props.menuClassName,
        topOptionStyle: props.topOptionStyle,
        bottomOptionStyle: props.bottomOptionStyle
    }, props.children) : null));
};
const rowCss = /*#__PURE__*/ (0, _css.css)("display:flex;flex-direction:row;.label{font-family:Muli;font-size:14px;font-weight:normal;font-style:normal;padding-right:5px;font-stretch:normal;line-height:1.43;letter-spacing:normal;cursor:pointer;color:", (0, _colors.text_blue), ";}border:0px;", "");
const overflowButtonStyle = /*#__PURE__*/ (0, _css.css)({
    name: "1cxrr4t",
    styles: "border:solid 1px #007dbb;border-radius:50%;width:20px;height:20px;display:flex;flex-direction:row;align-items:center;justify-content:center;cursor:pointer;.circle{width:2px;height:2px;border-radius:50%;border:solid 1px #007dbb;margin:1px;}&:hover,&.active{box-shadow:-1px 4px 10px 0 rgba(48, 69, 98, 0.1);border:solid 1px #007dbb;.circle{border:solid 1px #007dbb;}}&.active{background-color:rgba(0, 125, 187, 0.1);}"
});
const tooltipContentStyle = /*#__PURE__*/ (0, _css.css)({
    name: "11143my",
    styles: ".rc-tooltip-inner{font-family:Muli;font-size:14px;font-weight:normal;font-style:normal;letter-spacing:0.6px;z-index:120;color:white;background-color:#304562;box-shadow:-1px 4px 10px 0 rgba(48, 69, 98, 0.1);padding:8px;min-height:0;}"
});
const containerStyle = /*#__PURE__*/ (0, _css.css)({
    name: "bjn8wh",
    styles: "position:relative"
});
exports.default = SmallOverflowMenu;

},{"@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","rc-tooltip":"fhD1R","./OverflowMenu":"2V2SB","../../../constants/colors":"1p3OR","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"iY6kj":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _numberIncrementSelector = require("../forms/NumberIncrementSelector");
var _numberIncrementSelectorDefault = parcelHelpers.interopDefault(_numberIncrementSelector);
var _reactRouterDom = require("react-router-dom");
var _colors = require("../../constants/colors");
const navigateIcon = require("2c79f7ffa12aa1fb");
// component used in building forms with consistent components for look and function
class SimplePaginatedList extends (0, _reactDefault.default).Component {
    constructor(props){
        // Required step: always call the parent class' constructor
        super(props);
        // Set the state directly. Use props if necessary.
        this.state = {
            page: 1,
            maxPage: 1,
            shownInfo: [],
            currentPageString: ""
        };
    }
    componentDidMount() {
        const newMaxPage = Math.ceil(this.props.displayInfo.length / this.props.pageSize);
        this.setState({
            ...this.state,
            maxPage: newMaxPage
        }, this.updateDisplay);
    }
    updatePage(up) {
        const change = up ? 1 : -1;
        let newPage = this.state.page + change;
        if (newPage > this.state.maxPage) newPage = this.state.maxPage;
        else if (newPage < 1) newPage = 1;
        this.setState({
            ...this.state,
            page: newPage
        }, this.updateDisplay);
    }
    updateDisplay() {
        const pageStart = (this.state.page - 1) * this.props.pageSize;
        const newShownInfo = this.props.displayInfo.slice(pageStart, pageStart + this.props.pageSize);
        const pageEnd = pageStart + this.props.pageSize;
        const pageString = `${pageStart + 1}-${pageEnd > this.props.displayInfo.length ? this.props.displayInfo.length : pageEnd} of ${this.props.displayInfo.length}`;
        this.setState({
            ...this.state,
            shownInfo: newShownInfo,
            currentPageString: pageString
        });
    }
    render() {
        return (0, _react.jsx)("div", {
            className: container
        }, this.state.shownInfo.map((info, i)=>(0, _react.jsx)((0, _reactRouterDom.Link), {
                target: "_blank",
                to: info.url,
                key: i,
                className: `item ${i === 0 ? `top` : ``} ${i === this.state.shownInfo.length - 1 ? `bottom` : ``}`
            }, (0, _react.jsx)("img", {
                className: `icon`,
                src: info.icon
            }), (0, _react.jsx)("div", {
                className: `linkText`
            }, info.name), (0, _react.jsx)("span", null), (0, _react.jsx)("img", {
                className: `icon`,
                src: navigateIcon
            }))), (0, _react.jsx)("div", {
            className: `bottomRow`
        }, (0, _react.jsx)("div", {
            className: `pageString`
        }, this.state.currentPageString), (0, _react.jsx)("span", null), (0, _react.jsx)((0, _numberIncrementSelectorDefault.default), {
            updateValue: this.updatePage.bind(this),
            showNumber: false
        })));
    }
}
const container = /*#__PURE__*/ (0, _css.css)("font-family:Muli;font-size:16px;font-weight:normal;font-style:normal;font-stretch:normal;line-height:normal;letter-spacing:0.5px;text-align:center;width:100%;.item{border:1px solid #cccccc;border-bottom:0px;padding:0px;box-sizing:border-box;padding:10px;padding-top:15px;padding-bottom:15px;display:flex;flex-direction:row;.icon{padding-left:5px;padding-right:5px;max-width:30px;}.linkText{padding-top:3px;padding-left:5px;color:", (0, _colors.ocean_blue), ";}&.top{border-top-left-radius:5px;border-top-right-radius:5px;}&.bottom{border-bottom:1px solid #cccccc;border-bottom-left-radius:5px;border-bottom-right-radius:5px;margin-bottom:10px;}}span{flex-grow:1;}.bottomRow{display:flex;flex-direction:row;margin-bottom:10px;.pageString{padding-top:5px;}}", "");
exports.default = SimplePaginatedList;

},{"@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","../forms/NumberIncrementSelector":"kU0zB","react-router-dom":"5fzqq","../../constants/colors":"1p3OR","2c79f7ffa12aa1fb":"9Kd2o","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9Kd2o":[function(require,module,exports) {
module.exports = require("ffe25f242f0b9f0b").getBundleURL("kVLro") + require("408a99653e9bd19f").resolve("jyvss");

},{"ffe25f242f0b9f0b":"c7Tr5","408a99653e9bd19f":"fyJL2"}],"2meyw":[function(require,module,exports) {
//! moment.js
//! version : 2.29.4
//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
//! license : MIT
//! momentjs.com
(function(global, factory) {
    module.exports = factory();
})(this, function() {
    "use strict";
    var hookCallback;
    function hooks() {
        return hookCallback.apply(null, arguments);
    }
    // This is done to register the method called with moment()
    // without creating circular dependencies.
    function setHookCallback(callback) {
        hookCallback = callback;
    }
    function isArray(input) {
        return input instanceof Array || Object.prototype.toString.call(input) === "[object Array]";
    }
    function isObject(input) {
        // IE8 will treat undefined and null as object if it wasn't for
        // input != null
        return input != null && Object.prototype.toString.call(input) === "[object Object]";
    }
    function hasOwnProp(a, b) {
        return Object.prototype.hasOwnProperty.call(a, b);
    }
    function isObjectEmpty(obj) {
        if (Object.getOwnPropertyNames) return Object.getOwnPropertyNames(obj).length === 0;
        else {
            var k;
            for(k in obj){
                if (hasOwnProp(obj, k)) return false;
            }
            return true;
        }
    }
    function isUndefined(input) {
        return input === void 0;
    }
    function isNumber(input) {
        return typeof input === "number" || Object.prototype.toString.call(input) === "[object Number]";
    }
    function isDate(input) {
        return input instanceof Date || Object.prototype.toString.call(input) === "[object Date]";
    }
    function map(arr, fn) {
        var res = [], i, arrLen = arr.length;
        for(i = 0; i < arrLen; ++i)res.push(fn(arr[i], i));
        return res;
    }
    function extend(a, b) {
        for(var i in b)if (hasOwnProp(b, i)) a[i] = b[i];
        if (hasOwnProp(b, "toString")) a.toString = b.toString;
        if (hasOwnProp(b, "valueOf")) a.valueOf = b.valueOf;
        return a;
    }
    function createUTC(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, true).utc();
    }
    function defaultParsingFlags() {
        // We need to deep clone this object.
        return {
            empty: false,
            unusedTokens: [],
            unusedInput: [],
            overflow: -2,
            charsLeftOver: 0,
            nullInput: false,
            invalidEra: null,
            invalidMonth: null,
            invalidFormat: false,
            userInvalidated: false,
            iso: false,
            parsedDateParts: [],
            era: null,
            meridiem: null,
            rfc2822: false,
            weekdayMismatch: false
        };
    }
    function getParsingFlags(m) {
        if (m._pf == null) m._pf = defaultParsingFlags();
        return m._pf;
    }
    var some;
    if (Array.prototype.some) some = Array.prototype.some;
    else some = function(fun) {
        var t = Object(this), len = t.length >>> 0, i;
        for(i = 0; i < len; i++){
            if (i in t && fun.call(this, t[i], i, t)) return true;
        }
        return false;
    };
    function isValid(m) {
        if (m._isValid == null) {
            var flags = getParsingFlags(m), parsedParts = some.call(flags.parsedDateParts, function(i) {
                return i != null;
            }), isNowValid = !isNaN(m._d.getTime()) && flags.overflow < 0 && !flags.empty && !flags.invalidEra && !flags.invalidMonth && !flags.invalidWeekday && !flags.weekdayMismatch && !flags.nullInput && !flags.invalidFormat && !flags.userInvalidated && (!flags.meridiem || flags.meridiem && parsedParts);
            if (m._strict) isNowValid = isNowValid && flags.charsLeftOver === 0 && flags.unusedTokens.length === 0 && flags.bigHour === undefined;
            if (Object.isFrozen == null || !Object.isFrozen(m)) m._isValid = isNowValid;
            else return isNowValid;
        }
        return m._isValid;
    }
    function createInvalid(flags) {
        var m = createUTC(NaN);
        if (flags != null) extend(getParsingFlags(m), flags);
        else getParsingFlags(m).userInvalidated = true;
        return m;
    }
    // Plugins that add properties should also add the key here (null value),
    // so we can properly clone ourselves.
    var momentProperties = hooks.momentProperties = [], updateInProgress = false;
    function copyConfig(to, from) {
        var i, prop, val, momentPropertiesLen = momentProperties.length;
        if (!isUndefined(from._isAMomentObject)) to._isAMomentObject = from._isAMomentObject;
        if (!isUndefined(from._i)) to._i = from._i;
        if (!isUndefined(from._f)) to._f = from._f;
        if (!isUndefined(from._l)) to._l = from._l;
        if (!isUndefined(from._strict)) to._strict = from._strict;
        if (!isUndefined(from._tzm)) to._tzm = from._tzm;
        if (!isUndefined(from._isUTC)) to._isUTC = from._isUTC;
        if (!isUndefined(from._offset)) to._offset = from._offset;
        if (!isUndefined(from._pf)) to._pf = getParsingFlags(from);
        if (!isUndefined(from._locale)) to._locale = from._locale;
        if (momentPropertiesLen > 0) for(i = 0; i < momentPropertiesLen; i++){
            prop = momentProperties[i];
            val = from[prop];
            if (!isUndefined(val)) to[prop] = val;
        }
        return to;
    }
    // Moment prototype object
    function Moment(config) {
        copyConfig(this, config);
        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
        if (!this.isValid()) this._d = new Date(NaN);
        // Prevent infinite loop in case updateOffset creates new moment
        // objects.
        if (updateInProgress === false) {
            updateInProgress = true;
            hooks.updateOffset(this);
            updateInProgress = false;
        }
    }
    function isMoment(obj) {
        return obj instanceof Moment || obj != null && obj._isAMomentObject != null;
    }
    function warn(msg) {
        if (hooks.suppressDeprecationWarnings === false && typeof console !== "undefined" && console.warn) console.warn("Deprecation warning: " + msg);
    }
    function deprecate(msg, fn) {
        var firstTime = true;
        return extend(function() {
            if (hooks.deprecationHandler != null) hooks.deprecationHandler(null, msg);
            if (firstTime) {
                var args = [], arg, i, key, argLen = arguments.length;
                for(i = 0; i < argLen; i++){
                    arg = "";
                    if (typeof arguments[i] === "object") {
                        arg += "\n[" + i + "] ";
                        for(key in arguments[0])if (hasOwnProp(arguments[0], key)) arg += key + ": " + arguments[0][key] + ", ";
                        arg = arg.slice(0, -2); // Remove trailing comma and space
                    } else arg = arguments[i];
                    args.push(arg);
                }
                warn(msg + "\nArguments: " + Array.prototype.slice.call(args).join("") + "\n" + new Error().stack);
                firstTime = false;
            }
            return fn.apply(this, arguments);
        }, fn);
    }
    var deprecations = {};
    function deprecateSimple(name, msg) {
        if (hooks.deprecationHandler != null) hooks.deprecationHandler(name, msg);
        if (!deprecations[name]) {
            warn(msg);
            deprecations[name] = true;
        }
    }
    hooks.suppressDeprecationWarnings = false;
    hooks.deprecationHandler = null;
    function isFunction(input) {
        return typeof Function !== "undefined" && input instanceof Function || Object.prototype.toString.call(input) === "[object Function]";
    }
    function set(config) {
        var prop, i;
        for(i in config)if (hasOwnProp(config, i)) {
            prop = config[i];
            if (isFunction(prop)) this[i] = prop;
            else this["_" + i] = prop;
        }
        this._config = config;
        // Lenient ordinal parsing accepts just a number in addition to
        // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
        // TODO: Remove "ordinalParse" fallback in next major release.
        this._dayOfMonthOrdinalParseLenient = new RegExp((this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) + "|" + /\d{1,2}/.source);
    }
    function mergeConfigs(parentConfig, childConfig) {
        var res = extend({}, parentConfig), prop;
        for(prop in childConfig)if (hasOwnProp(childConfig, prop)) {
            if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
                res[prop] = {};
                extend(res[prop], parentConfig[prop]);
                extend(res[prop], childConfig[prop]);
            } else if (childConfig[prop] != null) res[prop] = childConfig[prop];
            else delete res[prop];
        }
        for(prop in parentConfig)if (hasOwnProp(parentConfig, prop) && !hasOwnProp(childConfig, prop) && isObject(parentConfig[prop])) // make sure changes to properties don't modify parent config
        res[prop] = extend({}, res[prop]);
        return res;
    }
    function Locale(config) {
        if (config != null) this.set(config);
    }
    var keys;
    if (Object.keys) keys = Object.keys;
    else keys = function(obj) {
        var i, res = [];
        for(i in obj)if (hasOwnProp(obj, i)) res.push(i);
        return res;
    };
    var defaultCalendar = {
        sameDay: "[Today at] LT",
        nextDay: "[Tomorrow at] LT",
        nextWeek: "dddd [at] LT",
        lastDay: "[Yesterday at] LT",
        lastWeek: "[Last] dddd [at] LT",
        sameElse: "L"
    };
    function calendar(key, mom, now) {
        var output = this._calendar[key] || this._calendar["sameElse"];
        return isFunction(output) ? output.call(mom, now) : output;
    }
    function zeroFill(number, targetLength, forceSign) {
        var absNumber = "" + Math.abs(number), zerosToFill = targetLength - absNumber.length, sign = number >= 0;
        return (sign ? forceSign ? "+" : "" : "-") + Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
    }
    var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g, localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g, formatFunctions = {}, formatTokenFunctions = {};
    // token:    'M'
    // padded:   ['MM', 2]
    // ordinal:  'Mo'
    // callback: function () { this.month() + 1 }
    function addFormatToken(token, padded, ordinal, callback) {
        var func = callback;
        if (typeof callback === "string") func = function() {
            return this[callback]();
        };
        if (token) formatTokenFunctions[token] = func;
        if (padded) formatTokenFunctions[padded[0]] = function() {
            return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
        };
        if (ordinal) formatTokenFunctions[ordinal] = function() {
            return this.localeData().ordinal(func.apply(this, arguments), token);
        };
    }
    function removeFormattingTokens(input) {
        if (input.match(/\[[\s\S]/)) return input.replace(/^\[|\]$/g, "");
        return input.replace(/\\/g, "");
    }
    function makeFormatFunction(format) {
        var array = format.match(formattingTokens), i, length;
        for(i = 0, length = array.length; i < length; i++)if (formatTokenFunctions[array[i]]) array[i] = formatTokenFunctions[array[i]];
        else array[i] = removeFormattingTokens(array[i]);
        return function(mom) {
            var output = "", i;
            for(i = 0; i < length; i++)output += isFunction(array[i]) ? array[i].call(mom, format) : array[i];
            return output;
        };
    }
    // format date using native date object
    function formatMoment(m, format) {
        if (!m.isValid()) return m.localeData().invalidDate();
        format = expandFormat(format, m.localeData());
        formatFunctions[format] = formatFunctions[format] || makeFormatFunction(format);
        return formatFunctions[format](m);
    }
    function expandFormat(format, locale) {
        var i = 5;
        function replaceLongDateFormatTokens(input) {
            return locale.longDateFormat(input) || input;
        }
        localFormattingTokens.lastIndex = 0;
        while(i >= 0 && localFormattingTokens.test(format)){
            format = format.replace(localFormattingTokens, replaceLongDateFormatTokens);
            localFormattingTokens.lastIndex = 0;
            i -= 1;
        }
        return format;
    }
    var defaultLongDateFormat = {
        LTS: "h:mm:ss A",
        LT: "h:mm A",
        L: "MM/DD/YYYY",
        LL: "MMMM D, YYYY",
        LLL: "MMMM D, YYYY h:mm A",
        LLLL: "dddd, MMMM D, YYYY h:mm A"
    };
    function longDateFormat(key) {
        var format = this._longDateFormat[key], formatUpper = this._longDateFormat[key.toUpperCase()];
        if (format || !formatUpper) return format;
        this._longDateFormat[key] = formatUpper.match(formattingTokens).map(function(tok) {
            if (tok === "MMMM" || tok === "MM" || tok === "DD" || tok === "dddd") return tok.slice(1);
            return tok;
        }).join("");
        return this._longDateFormat[key];
    }
    var defaultInvalidDate = "Invalid date";
    function invalidDate() {
        return this._invalidDate;
    }
    var defaultOrdinal = "%d", defaultDayOfMonthOrdinalParse = /\d{1,2}/;
    function ordinal(number) {
        return this._ordinal.replace("%d", number);
    }
    var defaultRelativeTime = {
        future: "in %s",
        past: "%s ago",
        s: "a few seconds",
        ss: "%d seconds",
        m: "a minute",
        mm: "%d minutes",
        h: "an hour",
        hh: "%d hours",
        d: "a day",
        dd: "%d days",
        w: "a week",
        ww: "%d weeks",
        M: "a month",
        MM: "%d months",
        y: "a year",
        yy: "%d years"
    };
    function relativeTime(number, withoutSuffix, string, isFuture) {
        var output = this._relativeTime[string];
        return isFunction(output) ? output(number, withoutSuffix, string, isFuture) : output.replace(/%d/i, number);
    }
    function pastFuture(diff, output) {
        var format = this._relativeTime[diff > 0 ? "future" : "past"];
        return isFunction(format) ? format(output) : format.replace(/%s/i, output);
    }
    var aliases = {};
    function addUnitAlias(unit, shorthand) {
        var lowerCase = unit.toLowerCase();
        aliases[lowerCase] = aliases[lowerCase + "s"] = aliases[shorthand] = unit;
    }
    function normalizeUnits(units) {
        return typeof units === "string" ? aliases[units] || aliases[units.toLowerCase()] : undefined;
    }
    function normalizeObjectUnits(inputObject) {
        var normalizedInput = {}, normalizedProp, prop;
        for(prop in inputObject)if (hasOwnProp(inputObject, prop)) {
            normalizedProp = normalizeUnits(prop);
            if (normalizedProp) normalizedInput[normalizedProp] = inputObject[prop];
        }
        return normalizedInput;
    }
    var priorities = {};
    function addUnitPriority(unit, priority) {
        priorities[unit] = priority;
    }
    function getPrioritizedUnits(unitsObj) {
        var units = [], u;
        for(u in unitsObj)if (hasOwnProp(unitsObj, u)) units.push({
            unit: u,
            priority: priorities[u]
        });
        units.sort(function(a, b) {
            return a.priority - b.priority;
        });
        return units;
    }
    function isLeapYear(year) {
        return year % 4 === 0 && year % 100 !== 0 || year % 400 === 0;
    }
    function absFloor(number) {
        if (number < 0) // -0 -> 0
        return Math.ceil(number) || 0;
        else return Math.floor(number);
    }
    function toInt(argumentForCoercion) {
        var coercedNumber = +argumentForCoercion, value = 0;
        if (coercedNumber !== 0 && isFinite(coercedNumber)) value = absFloor(coercedNumber);
        return value;
    }
    function makeGetSet(unit, keepTime) {
        return function(value) {
            if (value != null) {
                set$1(this, unit, value);
                hooks.updateOffset(this, keepTime);
                return this;
            } else return get(this, unit);
        };
    }
    function get(mom, unit) {
        return mom.isValid() ? mom._d["get" + (mom._isUTC ? "UTC" : "") + unit]() : NaN;
    }
    function set$1(mom, unit, value) {
        if (mom.isValid() && !isNaN(value)) {
            if (unit === "FullYear" && isLeapYear(mom.year()) && mom.month() === 1 && mom.date() === 29) {
                value = toInt(value);
                mom._d["set" + (mom._isUTC ? "UTC" : "") + unit](value, mom.month(), daysInMonth(value, mom.month()));
            } else mom._d["set" + (mom._isUTC ? "UTC" : "") + unit](value);
        }
    }
    // MOMENTS
    function stringGet(units) {
        units = normalizeUnits(units);
        if (isFunction(this[units])) return this[units]();
        return this;
    }
    function stringSet(units, value) {
        if (typeof units === "object") {
            units = normalizeObjectUnits(units);
            var prioritized = getPrioritizedUnits(units), i, prioritizedLen = prioritized.length;
            for(i = 0; i < prioritizedLen; i++)this[prioritized[i].unit](units[prioritized[i].unit]);
        } else {
            units = normalizeUnits(units);
            if (isFunction(this[units])) return this[units](value);
        }
        return this;
    }
    var match1 = /\d/, match2 = /\d\d/, match3 = /\d{3}/, match4 = /\d{4}/, match6 = /[+-]?\d{6}/, match1to2 = /\d\d?/, match3to4 = /\d\d\d\d?/, match5to6 = /\d\d\d\d\d\d?/, match1to3 = /\d{1,3}/, match1to4 = /\d{1,4}/, match1to6 = /[+-]?\d{1,6}/, matchUnsigned = /\d+/, matchSigned = /[+-]?\d+/, matchOffset = /Z|[+-]\d\d:?\d\d/gi, matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi, matchTimestamp = /[+-]?\d+(\.\d{1,3})?/, // any word (or two) characters or numbers including two/three word month in arabic.
    // includes scottish gaelic two word and hyphenated months
    matchWord = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i, regexes;
    regexes = {};
    function addRegexToken(token, regex, strictRegex) {
        regexes[token] = isFunction(regex) ? regex : function(isStrict, localeData) {
            return isStrict && strictRegex ? strictRegex : regex;
        };
    }
    function getParseRegexForToken(token, config) {
        if (!hasOwnProp(regexes, token)) return new RegExp(unescapeFormat(token));
        return regexes[token](config._strict, config._locale);
    }
    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
    function unescapeFormat(s) {
        return regexEscape(s.replace("\\", "").replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function(matched, p1, p2, p3, p4) {
            return p1 || p2 || p3 || p4;
        }));
    }
    function regexEscape(s) {
        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, "\\$&");
    }
    var tokens = {};
    function addParseToken(token, callback) {
        var i, func = callback, tokenLen;
        if (typeof token === "string") token = [
            token
        ];
        if (isNumber(callback)) func = function(input, array) {
            array[callback] = toInt(input);
        };
        tokenLen = token.length;
        for(i = 0; i < tokenLen; i++)tokens[token[i]] = func;
    }
    function addWeekParseToken(token, callback) {
        addParseToken(token, function(input, array, config, token) {
            config._w = config._w || {};
            callback(input, config._w, config, token);
        });
    }
    function addTimeToArrayFromToken(token, input, config) {
        if (input != null && hasOwnProp(tokens, token)) tokens[token](input, config._a, config, token);
    }
    var YEAR = 0, MONTH = 1, DATE = 2, HOUR = 3, MINUTE = 4, SECOND = 5, MILLISECOND = 6, WEEK = 7, WEEKDAY = 8;
    function mod(n, x) {
        return (n % x + x) % x;
    }
    var indexOf;
    if (Array.prototype.indexOf) indexOf = Array.prototype.indexOf;
    else indexOf = function(o) {
        // I know
        var i;
        for(i = 0; i < this.length; ++i){
            if (this[i] === o) return i;
        }
        return -1;
    };
    function daysInMonth(year, month) {
        if (isNaN(year) || isNaN(month)) return NaN;
        var modMonth = mod(month, 12);
        year += (month - modMonth) / 12;
        return modMonth === 1 ? isLeapYear(year) ? 29 : 28 : 31 - modMonth % 7 % 2;
    }
    // FORMATTING
    addFormatToken("M", [
        "MM",
        2
    ], "Mo", function() {
        return this.month() + 1;
    });
    addFormatToken("MMM", 0, 0, function(format) {
        return this.localeData().monthsShort(this, format);
    });
    addFormatToken("MMMM", 0, 0, function(format) {
        return this.localeData().months(this, format);
    });
    // ALIASES
    addUnitAlias("month", "M");
    // PRIORITY
    addUnitPriority("month", 8);
    // PARSING
    addRegexToken("M", match1to2);
    addRegexToken("MM", match1to2, match2);
    addRegexToken("MMM", function(isStrict, locale) {
        return locale.monthsShortRegex(isStrict);
    });
    addRegexToken("MMMM", function(isStrict, locale) {
        return locale.monthsRegex(isStrict);
    });
    addParseToken([
        "M",
        "MM"
    ], function(input, array) {
        array[MONTH] = toInt(input) - 1;
    });
    addParseToken([
        "MMM",
        "MMMM"
    ], function(input, array, config, token) {
        var month = config._locale.monthsParse(input, token, config._strict);
        // if we didn't find a month name, mark the date as invalid.
        if (month != null) array[MONTH] = month;
        else getParsingFlags(config).invalidMonth = input;
    });
    // LOCALES
    var defaultLocaleMonths = "January_February_March_April_May_June_July_August_September_October_November_December".split("_"), defaultLocaleMonthsShort = "Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_"), MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/, defaultMonthsShortRegex = matchWord, defaultMonthsRegex = matchWord;
    function localeMonths(m, format) {
        if (!m) return isArray(this._months) ? this._months : this._months["standalone"];
        return isArray(this._months) ? this._months[m.month()] : this._months[(this._months.isFormat || MONTHS_IN_FORMAT).test(format) ? "format" : "standalone"][m.month()];
    }
    function localeMonthsShort(m, format) {
        if (!m) return isArray(this._monthsShort) ? this._monthsShort : this._monthsShort["standalone"];
        return isArray(this._monthsShort) ? this._monthsShort[m.month()] : this._monthsShort[MONTHS_IN_FORMAT.test(format) ? "format" : "standalone"][m.month()];
    }
    function handleStrictParse(monthName, format, strict) {
        var i, ii, mom, llc = monthName.toLocaleLowerCase();
        if (!this._monthsParse) {
            // this is not used
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
            for(i = 0; i < 12; ++i){
                mom = createUTC([
                    2000,
                    i
                ]);
                this._shortMonthsParse[i] = this.monthsShort(mom, "").toLocaleLowerCase();
                this._longMonthsParse[i] = this.months(mom, "").toLocaleLowerCase();
            }
        }
        if (strict) {
            if (format === "MMM") {
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else if (format === "MMM") {
            ii = indexOf.call(this._shortMonthsParse, llc);
            if (ii !== -1) return ii;
            ii = indexOf.call(this._longMonthsParse, llc);
            return ii !== -1 ? ii : null;
        } else {
            ii = indexOf.call(this._longMonthsParse, llc);
            if (ii !== -1) return ii;
            ii = indexOf.call(this._shortMonthsParse, llc);
            return ii !== -1 ? ii : null;
        }
    }
    function localeMonthsParse(monthName, format, strict) {
        var i, mom, regex;
        if (this._monthsParseExact) return handleStrictParse.call(this, monthName, format, strict);
        if (!this._monthsParse) {
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
        }
        // TODO: add sorting
        // Sorting makes sure if one month (or abbr) is a prefix of another
        // see sorting in computeMonthsParse
        for(i = 0; i < 12; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                i
            ]);
            if (strict && !this._longMonthsParse[i]) {
                this._longMonthsParse[i] = new RegExp("^" + this.months(mom, "").replace(".", "") + "$", "i");
                this._shortMonthsParse[i] = new RegExp("^" + this.monthsShort(mom, "").replace(".", "") + "$", "i");
            }
            if (!strict && !this._monthsParse[i]) {
                regex = "^" + this.months(mom, "") + "|^" + this.monthsShort(mom, "");
                this._monthsParse[i] = new RegExp(regex.replace(".", ""), "i");
            }
            // test the regex
            if (strict && format === "MMMM" && this._longMonthsParse[i].test(monthName)) return i;
            else if (strict && format === "MMM" && this._shortMonthsParse[i].test(monthName)) return i;
            else if (!strict && this._monthsParse[i].test(monthName)) return i;
        }
    }
    // MOMENTS
    function setMonth(mom, value) {
        var dayOfMonth;
        if (!mom.isValid()) // No op
        return mom;
        if (typeof value === "string") {
            if (/^\d+$/.test(value)) value = toInt(value);
            else {
                value = mom.localeData().monthsParse(value);
                // TODO: Another silent failure?
                if (!isNumber(value)) return mom;
            }
        }
        dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));
        mom._d["set" + (mom._isUTC ? "UTC" : "") + "Month"](value, dayOfMonth);
        return mom;
    }
    function getSetMonth(value) {
        if (value != null) {
            setMonth(this, value);
            hooks.updateOffset(this, true);
            return this;
        } else return get(this, "Month");
    }
    function getDaysInMonth() {
        return daysInMonth(this.year(), this.month());
    }
    function monthsShortRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, "_monthsRegex")) computeMonthsParse.call(this);
            if (isStrict) return this._monthsShortStrictRegex;
            else return this._monthsShortRegex;
        } else {
            if (!hasOwnProp(this, "_monthsShortRegex")) this._monthsShortRegex = defaultMonthsShortRegex;
            return this._monthsShortStrictRegex && isStrict ? this._monthsShortStrictRegex : this._monthsShortRegex;
        }
    }
    function monthsRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, "_monthsRegex")) computeMonthsParse.call(this);
            if (isStrict) return this._monthsStrictRegex;
            else return this._monthsRegex;
        } else {
            if (!hasOwnProp(this, "_monthsRegex")) this._monthsRegex = defaultMonthsRegex;
            return this._monthsStrictRegex && isStrict ? this._monthsStrictRegex : this._monthsRegex;
        }
    }
    function computeMonthsParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }
        var shortPieces = [], longPieces = [], mixedPieces = [], i, mom;
        for(i = 0; i < 12; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                i
            ]);
            shortPieces.push(this.monthsShort(mom, ""));
            longPieces.push(this.months(mom, ""));
            mixedPieces.push(this.months(mom, ""));
            mixedPieces.push(this.monthsShort(mom, ""));
        }
        // Sorting makes sure if one month (or abbr) is a prefix of another it
        // will match the longer piece.
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        for(i = 0; i < 12; i++){
            shortPieces[i] = regexEscape(shortPieces[i]);
            longPieces[i] = regexEscape(longPieces[i]);
        }
        for(i = 0; i < 24; i++)mixedPieces[i] = regexEscape(mixedPieces[i]);
        this._monthsRegex = new RegExp("^(" + mixedPieces.join("|") + ")", "i");
        this._monthsShortRegex = this._monthsRegex;
        this._monthsStrictRegex = new RegExp("^(" + longPieces.join("|") + ")", "i");
        this._monthsShortStrictRegex = new RegExp("^(" + shortPieces.join("|") + ")", "i");
    }
    // FORMATTING
    addFormatToken("Y", 0, 0, function() {
        var y = this.year();
        return y <= 9999 ? zeroFill(y, 4) : "+" + y;
    });
    addFormatToken(0, [
        "YY",
        2
    ], 0, function() {
        return this.year() % 100;
    });
    addFormatToken(0, [
        "YYYY",
        4
    ], 0, "year");
    addFormatToken(0, [
        "YYYYY",
        5
    ], 0, "year");
    addFormatToken(0, [
        "YYYYYY",
        6,
        true
    ], 0, "year");
    // ALIASES
    addUnitAlias("year", "y");
    // PRIORITIES
    addUnitPriority("year", 1);
    // PARSING
    addRegexToken("Y", matchSigned);
    addRegexToken("YY", match1to2, match2);
    addRegexToken("YYYY", match1to4, match4);
    addRegexToken("YYYYY", match1to6, match6);
    addRegexToken("YYYYYY", match1to6, match6);
    addParseToken([
        "YYYYY",
        "YYYYYY"
    ], YEAR);
    addParseToken("YYYY", function(input, array) {
        array[YEAR] = input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
    });
    addParseToken("YY", function(input, array) {
        array[YEAR] = hooks.parseTwoDigitYear(input);
    });
    addParseToken("Y", function(input, array) {
        array[YEAR] = parseInt(input, 10);
    });
    // HELPERS
    function daysInYear(year) {
        return isLeapYear(year) ? 366 : 365;
    }
    // HOOKS
    hooks.parseTwoDigitYear = function(input) {
        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
    };
    // MOMENTS
    var getSetYear = makeGetSet("FullYear", true);
    function getIsLeapYear() {
        return isLeapYear(this.year());
    }
    function createDate(y, m, d, h, M, s, ms) {
        // can't just apply() to create a date:
        // https://stackoverflow.com/q/181348
        var date;
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            date = new Date(y + 400, m, d, h, M, s, ms);
            if (isFinite(date.getFullYear())) date.setFullYear(y);
        } else date = new Date(y, m, d, h, M, s, ms);
        return date;
    }
    function createUTCDate(y) {
        var date, args;
        // the Date.UTC function remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            args = Array.prototype.slice.call(arguments);
            // preserve leap years using a full 400 year cycle, then reset
            args[0] = y + 400;
            date = new Date(Date.UTC.apply(null, args));
            if (isFinite(date.getUTCFullYear())) date.setUTCFullYear(y);
        } else date = new Date(Date.UTC.apply(null, arguments));
        return date;
    }
    // start-of-first-week - start-of-year
    function firstWeekOffset(year, dow, doy) {
        var fwd = 7 + dow - doy, // first-week day local weekday -- which local weekday is fwd
        fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;
        return -fwdlw + fwd - 1;
    }
    // https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
        var localWeekday = (7 + weekday - dow) % 7, weekOffset = firstWeekOffset(year, dow, doy), dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset, resYear, resDayOfYear;
        if (dayOfYear <= 0) {
            resYear = year - 1;
            resDayOfYear = daysInYear(resYear) + dayOfYear;
        } else if (dayOfYear > daysInYear(year)) {
            resYear = year + 1;
            resDayOfYear = dayOfYear - daysInYear(year);
        } else {
            resYear = year;
            resDayOfYear = dayOfYear;
        }
        return {
            year: resYear,
            dayOfYear: resDayOfYear
        };
    }
    function weekOfYear(mom, dow, doy) {
        var weekOffset = firstWeekOffset(mom.year(), dow, doy), week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1, resWeek, resYear;
        if (week < 1) {
            resYear = mom.year() - 1;
            resWeek = week + weeksInYear(resYear, dow, doy);
        } else if (week > weeksInYear(mom.year(), dow, doy)) {
            resWeek = week - weeksInYear(mom.year(), dow, doy);
            resYear = mom.year() + 1;
        } else {
            resYear = mom.year();
            resWeek = week;
        }
        return {
            week: resWeek,
            year: resYear
        };
    }
    function weeksInYear(year, dow, doy) {
        var weekOffset = firstWeekOffset(year, dow, doy), weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
    }
    // FORMATTING
    addFormatToken("w", [
        "ww",
        2
    ], "wo", "week");
    addFormatToken("W", [
        "WW",
        2
    ], "Wo", "isoWeek");
    // ALIASES
    addUnitAlias("week", "w");
    addUnitAlias("isoWeek", "W");
    // PRIORITIES
    addUnitPriority("week", 5);
    addUnitPriority("isoWeek", 5);
    // PARSING
    addRegexToken("w", match1to2);
    addRegexToken("ww", match1to2, match2);
    addRegexToken("W", match1to2);
    addRegexToken("WW", match1to2, match2);
    addWeekParseToken([
        "w",
        "ww",
        "W",
        "WW"
    ], function(input, week, config, token) {
        week[token.substr(0, 1)] = toInt(input);
    });
    // HELPERS
    // LOCALES
    function localeWeek(mom) {
        return weekOfYear(mom, this._week.dow, this._week.doy).week;
    }
    var defaultLocaleWeek = {
        dow: 0,
        doy: 6
    };
    function localeFirstDayOfWeek() {
        return this._week.dow;
    }
    function localeFirstDayOfYear() {
        return this._week.doy;
    }
    // MOMENTS
    function getSetWeek(input) {
        var week = this.localeData().week(this);
        return input == null ? week : this.add((input - week) * 7, "d");
    }
    function getSetISOWeek(input) {
        var week = weekOfYear(this, 1, 4).week;
        return input == null ? week : this.add((input - week) * 7, "d");
    }
    // FORMATTING
    addFormatToken("d", 0, "do", "day");
    addFormatToken("dd", 0, 0, function(format) {
        return this.localeData().weekdaysMin(this, format);
    });
    addFormatToken("ddd", 0, 0, function(format) {
        return this.localeData().weekdaysShort(this, format);
    });
    addFormatToken("dddd", 0, 0, function(format) {
        return this.localeData().weekdays(this, format);
    });
    addFormatToken("e", 0, 0, "weekday");
    addFormatToken("E", 0, 0, "isoWeekday");
    // ALIASES
    addUnitAlias("day", "d");
    addUnitAlias("weekday", "e");
    addUnitAlias("isoWeekday", "E");
    // PRIORITY
    addUnitPriority("day", 11);
    addUnitPriority("weekday", 11);
    addUnitPriority("isoWeekday", 11);
    // PARSING
    addRegexToken("d", match1to2);
    addRegexToken("e", match1to2);
    addRegexToken("E", match1to2);
    addRegexToken("dd", function(isStrict, locale) {
        return locale.weekdaysMinRegex(isStrict);
    });
    addRegexToken("ddd", function(isStrict, locale) {
        return locale.weekdaysShortRegex(isStrict);
    });
    addRegexToken("dddd", function(isStrict, locale) {
        return locale.weekdaysRegex(isStrict);
    });
    addWeekParseToken([
        "dd",
        "ddd",
        "dddd"
    ], function(input, week, config, token) {
        var weekday = config._locale.weekdaysParse(input, token, config._strict);
        // if we didn't get a weekday name, mark the date as invalid
        if (weekday != null) week.d = weekday;
        else getParsingFlags(config).invalidWeekday = input;
    });
    addWeekParseToken([
        "d",
        "e",
        "E"
    ], function(input, week, config, token) {
        week[token] = toInt(input);
    });
    // HELPERS
    function parseWeekday(input, locale) {
        if (typeof input !== "string") return input;
        if (!isNaN(input)) return parseInt(input, 10);
        input = locale.weekdaysParse(input);
        if (typeof input === "number") return input;
        return null;
    }
    function parseIsoWeekday(input, locale) {
        if (typeof input === "string") return locale.weekdaysParse(input) % 7 || 7;
        return isNaN(input) ? null : input;
    }
    // LOCALES
    function shiftWeekdays(ws, n) {
        return ws.slice(n, 7).concat(ws.slice(0, n));
    }
    var defaultLocaleWeekdays = "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"), defaultLocaleWeekdaysShort = "Sun_Mon_Tue_Wed_Thu_Fri_Sat".split("_"), defaultLocaleWeekdaysMin = "Su_Mo_Tu_We_Th_Fr_Sa".split("_"), defaultWeekdaysRegex = matchWord, defaultWeekdaysShortRegex = matchWord, defaultWeekdaysMinRegex = matchWord;
    function localeWeekdays(m, format) {
        var weekdays = isArray(this._weekdays) ? this._weekdays : this._weekdays[m && m !== true && this._weekdays.isFormat.test(format) ? "format" : "standalone"];
        return m === true ? shiftWeekdays(weekdays, this._week.dow) : m ? weekdays[m.day()] : weekdays;
    }
    function localeWeekdaysShort(m) {
        return m === true ? shiftWeekdays(this._weekdaysShort, this._week.dow) : m ? this._weekdaysShort[m.day()] : this._weekdaysShort;
    }
    function localeWeekdaysMin(m) {
        return m === true ? shiftWeekdays(this._weekdaysMin, this._week.dow) : m ? this._weekdaysMin[m.day()] : this._weekdaysMin;
    }
    function handleStrictParse$1(weekdayName, format, strict) {
        var i, ii, mom, llc = weekdayName.toLocaleLowerCase();
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._minWeekdaysParse = [];
            for(i = 0; i < 7; ++i){
                mom = createUTC([
                    2000,
                    1
                ]).day(i);
                this._minWeekdaysParse[i] = this.weekdaysMin(mom, "").toLocaleLowerCase();
                this._shortWeekdaysParse[i] = this.weekdaysShort(mom, "").toLocaleLowerCase();
                this._weekdaysParse[i] = this.weekdays(mom, "").toLocaleLowerCase();
            }
        }
        if (strict) {
            if (format === "dddd") {
                ii = indexOf.call(this._weekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === "ddd") {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === "dddd") {
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === "ddd") {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }
    function localeWeekdaysParse(weekdayName, format, strict) {
        var i, mom, regex;
        if (this._weekdaysParseExact) return handleStrictParse$1.call(this, weekdayName, format, strict);
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._minWeekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._fullWeekdaysParse = [];
        }
        for(i = 0; i < 7; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                1
            ]).day(i);
            if (strict && !this._fullWeekdaysParse[i]) {
                this._fullWeekdaysParse[i] = new RegExp("^" + this.weekdays(mom, "").replace(".", "\\.?") + "$", "i");
                this._shortWeekdaysParse[i] = new RegExp("^" + this.weekdaysShort(mom, "").replace(".", "\\.?") + "$", "i");
                this._minWeekdaysParse[i] = new RegExp("^" + this.weekdaysMin(mom, "").replace(".", "\\.?") + "$", "i");
            }
            if (!this._weekdaysParse[i]) {
                regex = "^" + this.weekdays(mom, "") + "|^" + this.weekdaysShort(mom, "") + "|^" + this.weekdaysMin(mom, "");
                this._weekdaysParse[i] = new RegExp(regex.replace(".", ""), "i");
            }
            // test the regex
            if (strict && format === "dddd" && this._fullWeekdaysParse[i].test(weekdayName)) return i;
            else if (strict && format === "ddd" && this._shortWeekdaysParse[i].test(weekdayName)) return i;
            else if (strict && format === "dd" && this._minWeekdaysParse[i].test(weekdayName)) return i;
            else if (!strict && this._weekdaysParse[i].test(weekdayName)) return i;
        }
    }
    // MOMENTS
    function getSetDayOfWeek(input) {
        if (!this.isValid()) return input != null ? this : NaN;
        var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
        if (input != null) {
            input = parseWeekday(input, this.localeData());
            return this.add(input - day, "d");
        } else return day;
    }
    function getSetLocaleDayOfWeek(input) {
        if (!this.isValid()) return input != null ? this : NaN;
        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
        return input == null ? weekday : this.add(input - weekday, "d");
    }
    function getSetISODayOfWeek(input) {
        if (!this.isValid()) return input != null ? this : NaN;
        // behaves the same as moment#day except
        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
        // as a setter, sunday should belong to the previous week.
        if (input != null) {
            var weekday = parseIsoWeekday(input, this.localeData());
            return this.day(this.day() % 7 ? weekday : weekday - 7);
        } else return this.day() || 7;
    }
    function weekdaysRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, "_weekdaysRegex")) computeWeekdaysParse.call(this);
            if (isStrict) return this._weekdaysStrictRegex;
            else return this._weekdaysRegex;
        } else {
            if (!hasOwnProp(this, "_weekdaysRegex")) this._weekdaysRegex = defaultWeekdaysRegex;
            return this._weekdaysStrictRegex && isStrict ? this._weekdaysStrictRegex : this._weekdaysRegex;
        }
    }
    function weekdaysShortRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, "_weekdaysRegex")) computeWeekdaysParse.call(this);
            if (isStrict) return this._weekdaysShortStrictRegex;
            else return this._weekdaysShortRegex;
        } else {
            if (!hasOwnProp(this, "_weekdaysShortRegex")) this._weekdaysShortRegex = defaultWeekdaysShortRegex;
            return this._weekdaysShortStrictRegex && isStrict ? this._weekdaysShortStrictRegex : this._weekdaysShortRegex;
        }
    }
    function weekdaysMinRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, "_weekdaysRegex")) computeWeekdaysParse.call(this);
            if (isStrict) return this._weekdaysMinStrictRegex;
            else return this._weekdaysMinRegex;
        } else {
            if (!hasOwnProp(this, "_weekdaysMinRegex")) this._weekdaysMinRegex = defaultWeekdaysMinRegex;
            return this._weekdaysMinStrictRegex && isStrict ? this._weekdaysMinStrictRegex : this._weekdaysMinRegex;
        }
    }
    function computeWeekdaysParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }
        var minPieces = [], shortPieces = [], longPieces = [], mixedPieces = [], i, mom, minp, shortp, longp;
        for(i = 0; i < 7; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                1
            ]).day(i);
            minp = regexEscape(this.weekdaysMin(mom, ""));
            shortp = regexEscape(this.weekdaysShort(mom, ""));
            longp = regexEscape(this.weekdays(mom, ""));
            minPieces.push(minp);
            shortPieces.push(shortp);
            longPieces.push(longp);
            mixedPieces.push(minp);
            mixedPieces.push(shortp);
            mixedPieces.push(longp);
        }
        // Sorting makes sure if one weekday (or abbr) is a prefix of another it
        // will match the longer piece.
        minPieces.sort(cmpLenRev);
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        this._weekdaysRegex = new RegExp("^(" + mixedPieces.join("|") + ")", "i");
        this._weekdaysShortRegex = this._weekdaysRegex;
        this._weekdaysMinRegex = this._weekdaysRegex;
        this._weekdaysStrictRegex = new RegExp("^(" + longPieces.join("|") + ")", "i");
        this._weekdaysShortStrictRegex = new RegExp("^(" + shortPieces.join("|") + ")", "i");
        this._weekdaysMinStrictRegex = new RegExp("^(" + minPieces.join("|") + ")", "i");
    }
    // FORMATTING
    function hFormat() {
        return this.hours() % 12 || 12;
    }
    function kFormat() {
        return this.hours() || 24;
    }
    addFormatToken("H", [
        "HH",
        2
    ], 0, "hour");
    addFormatToken("h", [
        "hh",
        2
    ], 0, hFormat);
    addFormatToken("k", [
        "kk",
        2
    ], 0, kFormat);
    addFormatToken("hmm", 0, 0, function() {
        return "" + hFormat.apply(this) + zeroFill(this.minutes(), 2);
    });
    addFormatToken("hmmss", 0, 0, function() {
        return "" + hFormat.apply(this) + zeroFill(this.minutes(), 2) + zeroFill(this.seconds(), 2);
    });
    addFormatToken("Hmm", 0, 0, function() {
        return "" + this.hours() + zeroFill(this.minutes(), 2);
    });
    addFormatToken("Hmmss", 0, 0, function() {
        return "" + this.hours() + zeroFill(this.minutes(), 2) + zeroFill(this.seconds(), 2);
    });
    function meridiem(token, lowercase) {
        addFormatToken(token, 0, 0, function() {
            return this.localeData().meridiem(this.hours(), this.minutes(), lowercase);
        });
    }
    meridiem("a", true);
    meridiem("A", false);
    // ALIASES
    addUnitAlias("hour", "h");
    // PRIORITY
    addUnitPriority("hour", 13);
    // PARSING
    function matchMeridiem(isStrict, locale) {
        return locale._meridiemParse;
    }
    addRegexToken("a", matchMeridiem);
    addRegexToken("A", matchMeridiem);
    addRegexToken("H", match1to2);
    addRegexToken("h", match1to2);
    addRegexToken("k", match1to2);
    addRegexToken("HH", match1to2, match2);
    addRegexToken("hh", match1to2, match2);
    addRegexToken("kk", match1to2, match2);
    addRegexToken("hmm", match3to4);
    addRegexToken("hmmss", match5to6);
    addRegexToken("Hmm", match3to4);
    addRegexToken("Hmmss", match5to6);
    addParseToken([
        "H",
        "HH"
    ], HOUR);
    addParseToken([
        "k",
        "kk"
    ], function(input, array, config) {
        var kInput = toInt(input);
        array[HOUR] = kInput === 24 ? 0 : kInput;
    });
    addParseToken([
        "a",
        "A"
    ], function(input, array, config) {
        config._isPm = config._locale.isPM(input);
        config._meridiem = input;
    });
    addParseToken([
        "h",
        "hh"
    ], function(input, array, config) {
        array[HOUR] = toInt(input);
        getParsingFlags(config).bigHour = true;
    });
    addParseToken("hmm", function(input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken("hmmss", function(input, array, config) {
        var pos1 = input.length - 4, pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken("Hmm", function(input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
    });
    addParseToken("Hmmss", function(input, array, config) {
        var pos1 = input.length - 4, pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
    });
    // LOCALES
    function localeIsPM(input) {
        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
        // Using charAt should be more compatible.
        return (input + "").toLowerCase().charAt(0) === "p";
    }
    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i, // Setting the hour should keep the time, because the user explicitly
    // specified which hour they want. So trying to maintain the same hour (in
    // a new timezone) makes sense. Adding/subtracting hours does not follow
    // this rule.
    getSetHour = makeGetSet("Hours", true);
    function localeMeridiem(hours, minutes, isLower) {
        if (hours > 11) return isLower ? "pm" : "PM";
        else return isLower ? "am" : "AM";
    }
    var baseConfig = {
        calendar: defaultCalendar,
        longDateFormat: defaultLongDateFormat,
        invalidDate: defaultInvalidDate,
        ordinal: defaultOrdinal,
        dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
        relativeTime: defaultRelativeTime,
        months: defaultLocaleMonths,
        monthsShort: defaultLocaleMonthsShort,
        week: defaultLocaleWeek,
        weekdays: defaultLocaleWeekdays,
        weekdaysMin: defaultLocaleWeekdaysMin,
        weekdaysShort: defaultLocaleWeekdaysShort,
        meridiemParse: defaultLocaleMeridiemParse
    };
    // internal storage for locale config files
    var locales = {}, localeFamilies = {}, globalLocale;
    function commonPrefix(arr1, arr2) {
        var i, minl = Math.min(arr1.length, arr2.length);
        for(i = 0; i < minl; i += 1){
            if (arr1[i] !== arr2[i]) return i;
        }
        return minl;
    }
    function normalizeLocale(key) {
        return key ? key.toLowerCase().replace("_", "-") : key;
    }
    // pick the locale from the array
    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
    function chooseLocale(names) {
        var i = 0, j, next, locale, split;
        while(i < names.length){
            split = normalizeLocale(names[i]).split("-");
            j = split.length;
            next = normalizeLocale(names[i + 1]);
            next = next ? next.split("-") : null;
            while(j > 0){
                locale = loadLocale(split.slice(0, j).join("-"));
                if (locale) return locale;
                if (next && next.length >= j && commonPrefix(split, next) >= j - 1) break;
                j--;
            }
            i++;
        }
        return globalLocale;
    }
    function isLocaleNameSane(name) {
        // Prevent names that look like filesystem paths, i.e contain '/' or '\'
        return name.match("^[^/\\\\]*$") != null;
    }
    function loadLocale(name) {
        var oldLocale = null, aliasedRequire;
        // TODO: Find a better way to register and load all the locales in Node
        if (locales[name] === undefined && true && module && module.exports && isLocaleNameSane(name)) try {
            oldLocale = globalLocale._abbr;
            aliasedRequire = undefined;
            aliasedRequire("./locale/" + name);
            getSetGlobalLocale(oldLocale);
        } catch (e) {
            // mark as not found to avoid repeating expensive file require call causing high CPU
            // when trying to find en-US, en_US, en-us for every format call
            locales[name] = null; // null means not found
        }
        return locales[name];
    }
    // This function will load locale and then set the global locale.  If
    // no arguments are passed in, it will simply return the current global
    // locale key.
    function getSetGlobalLocale(key, values) {
        var data;
        if (key) {
            if (isUndefined(values)) data = getLocale(key);
            else data = defineLocale(key, values);
            if (data) // moment.duration._locale = moment._locale = data;
            globalLocale = data;
            else if (typeof console !== "undefined" && console.warn) //warn user if arguments are passed but the locale could not be set
            console.warn("Locale " + key + " not found. Did you forget to load it?");
        }
        return globalLocale._abbr;
    }
    function defineLocale(name, config) {
        if (config !== null) {
            var locale, parentConfig = baseConfig;
            config.abbr = name;
            if (locales[name] != null) {
                deprecateSimple("defineLocaleOverride", "use moment.updateLocale(localeName, config) to change an existing locale. moment.defineLocale(localeName, config) should only be used for creating a new locale See http://momentjs.com/guides/#/warnings/define-locale/ for more info.");
                parentConfig = locales[name]._config;
            } else if (config.parentLocale != null) {
                if (locales[config.parentLocale] != null) parentConfig = locales[config.parentLocale]._config;
                else {
                    locale = loadLocale(config.parentLocale);
                    if (locale != null) parentConfig = locale._config;
                    else {
                        if (!localeFamilies[config.parentLocale]) localeFamilies[config.parentLocale] = [];
                        localeFamilies[config.parentLocale].push({
                            name: name,
                            config: config
                        });
                        return null;
                    }
                }
            }
            locales[name] = new Locale(mergeConfigs(parentConfig, config));
            if (localeFamilies[name]) localeFamilies[name].forEach(function(x) {
                defineLocale(x.name, x.config);
            });
            // backwards compat for now: also set the locale
            // make sure we set the locale AFTER all child locales have been
            // created, so we won't end up with the child locale set.
            getSetGlobalLocale(name);
            return locales[name];
        } else {
            // useful for testing
            delete locales[name];
            return null;
        }
    }
    function updateLocale(name, config) {
        if (config != null) {
            var locale, tmpLocale, parentConfig = baseConfig;
            if (locales[name] != null && locales[name].parentLocale != null) // Update existing child locale in-place to avoid memory-leaks
            locales[name].set(mergeConfigs(locales[name]._config, config));
            else {
                // MERGE
                tmpLocale = loadLocale(name);
                if (tmpLocale != null) parentConfig = tmpLocale._config;
                config = mergeConfigs(parentConfig, config);
                if (tmpLocale == null) // updateLocale is called for creating a new locale
                // Set abbr so it will have a name (getters return
                // undefined otherwise).
                config.abbr = name;
                locale = new Locale(config);
                locale.parentLocale = locales[name];
                locales[name] = locale;
            }
            // backwards compat for now: also set the locale
            getSetGlobalLocale(name);
        } else // pass null for config to unupdate, useful for tests
        if (locales[name] != null) {
            if (locales[name].parentLocale != null) {
                locales[name] = locales[name].parentLocale;
                if (name === getSetGlobalLocale()) getSetGlobalLocale(name);
            } else if (locales[name] != null) delete locales[name];
        }
        return locales[name];
    }
    // returns locale data
    function getLocale(key) {
        var locale;
        if (key && key._locale && key._locale._abbr) key = key._locale._abbr;
        if (!key) return globalLocale;
        if (!isArray(key)) {
            //short-circuit everything else
            locale = loadLocale(key);
            if (locale) return locale;
            key = [
                key
            ];
        }
        return chooseLocale(key);
    }
    function listLocales() {
        return keys(locales);
    }
    function checkOverflow(m) {
        var overflow, a = m._a;
        if (a && getParsingFlags(m).overflow === -2) {
            overflow = a[MONTH] < 0 || a[MONTH] > 11 ? MONTH : a[DATE] < 1 || a[DATE] > daysInMonth(a[YEAR], a[MONTH]) ? DATE : a[HOUR] < 0 || a[HOUR] > 24 || a[HOUR] === 24 && (a[MINUTE] !== 0 || a[SECOND] !== 0 || a[MILLISECOND] !== 0) ? HOUR : a[MINUTE] < 0 || a[MINUTE] > 59 ? MINUTE : a[SECOND] < 0 || a[SECOND] > 59 ? SECOND : a[MILLISECOND] < 0 || a[MILLISECOND] > 999 ? MILLISECOND : -1;
            if (getParsingFlags(m)._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) overflow = DATE;
            if (getParsingFlags(m)._overflowWeeks && overflow === -1) overflow = WEEK;
            if (getParsingFlags(m)._overflowWeekday && overflow === -1) overflow = WEEKDAY;
            getParsingFlags(m).overflow = overflow;
        }
        return m;
    }
    // iso 8601 regex
    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
    var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/, basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/, tzRegex = /Z|[+-]\d\d(?::?\d\d)?/, isoDates = [
        [
            "YYYYYY-MM-DD",
            /[+-]\d{6}-\d\d-\d\d/
        ],
        [
            "YYYY-MM-DD",
            /\d{4}-\d\d-\d\d/
        ],
        [
            "GGGG-[W]WW-E",
            /\d{4}-W\d\d-\d/
        ],
        [
            "GGGG-[W]WW",
            /\d{4}-W\d\d/,
            false
        ],
        [
            "YYYY-DDD",
            /\d{4}-\d{3}/
        ],
        [
            "YYYY-MM",
            /\d{4}-\d\d/,
            false
        ],
        [
            "YYYYYYMMDD",
            /[+-]\d{10}/
        ],
        [
            "YYYYMMDD",
            /\d{8}/
        ],
        [
            "GGGG[W]WWE",
            /\d{4}W\d{3}/
        ],
        [
            "GGGG[W]WW",
            /\d{4}W\d{2}/,
            false
        ],
        [
            "YYYYDDD",
            /\d{7}/
        ],
        [
            "YYYYMM",
            /\d{6}/,
            false
        ],
        [
            "YYYY",
            /\d{4}/,
            false
        ]
    ], // iso time formats and regexes
    isoTimes = [
        [
            "HH:mm:ss.SSSS",
            /\d\d:\d\d:\d\d\.\d+/
        ],
        [
            "HH:mm:ss,SSSS",
            /\d\d:\d\d:\d\d,\d+/
        ],
        [
            "HH:mm:ss",
            /\d\d:\d\d:\d\d/
        ],
        [
            "HH:mm",
            /\d\d:\d\d/
        ],
        [
            "HHmmss.SSSS",
            /\d\d\d\d\d\d\.\d+/
        ],
        [
            "HHmmss,SSSS",
            /\d\d\d\d\d\d,\d+/
        ],
        [
            "HHmmss",
            /\d\d\d\d\d\d/
        ],
        [
            "HHmm",
            /\d\d\d\d/
        ],
        [
            "HH",
            /\d\d/
        ]
    ], aspNetJsonRegex = /^\/?Date\((-?\d+)/i, // RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
    rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/, obsOffsets = {
        UT: 0,
        GMT: 0,
        EDT: -240,
        EST: -300,
        CDT: -300,
        CST: -360,
        MDT: -360,
        MST: -420,
        PDT: -420,
        PST: -480
    };
    // date from iso format
    function configFromISO(config) {
        var i, l, string = config._i, match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string), allowTime, dateFormat, timeFormat, tzFormat, isoDatesLen = isoDates.length, isoTimesLen = isoTimes.length;
        if (match) {
            getParsingFlags(config).iso = true;
            for(i = 0, l = isoDatesLen; i < l; i++)if (isoDates[i][1].exec(match[1])) {
                dateFormat = isoDates[i][0];
                allowTime = isoDates[i][2] !== false;
                break;
            }
            if (dateFormat == null) {
                config._isValid = false;
                return;
            }
            if (match[3]) {
                for(i = 0, l = isoTimesLen; i < l; i++)if (isoTimes[i][1].exec(match[3])) {
                    // match[2] should be 'T' or space
                    timeFormat = (match[2] || " ") + isoTimes[i][0];
                    break;
                }
                if (timeFormat == null) {
                    config._isValid = false;
                    return;
                }
            }
            if (!allowTime && timeFormat != null) {
                config._isValid = false;
                return;
            }
            if (match[4]) {
                if (tzRegex.exec(match[4])) tzFormat = "Z";
                else {
                    config._isValid = false;
                    return;
                }
            }
            config._f = dateFormat + (timeFormat || "") + (tzFormat || "");
            configFromStringAndFormat(config);
        } else config._isValid = false;
    }
    function extractFromRFC2822Strings(yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr) {
        var result = [
            untruncateYear(yearStr),
            defaultLocaleMonthsShort.indexOf(monthStr),
            parseInt(dayStr, 10),
            parseInt(hourStr, 10),
            parseInt(minuteStr, 10)
        ];
        if (secondStr) result.push(parseInt(secondStr, 10));
        return result;
    }
    function untruncateYear(yearStr) {
        var year = parseInt(yearStr, 10);
        if (year <= 49) return 2000 + year;
        else if (year <= 999) return 1900 + year;
        return year;
    }
    function preprocessRFC2822(s) {
        // Remove comments and folding whitespace and replace multiple-spaces with a single space
        return s.replace(/\([^()]*\)|[\n\t]/g, " ").replace(/(\s\s+)/g, " ").replace(/^\s\s*/, "").replace(/\s\s*$/, "");
    }
    function checkWeekday(weekdayStr, parsedInput, config) {
        if (weekdayStr) {
            // TODO: Replace the vanilla JS Date object with an independent day-of-week check.
            var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr), weekdayActual = new Date(parsedInput[0], parsedInput[1], parsedInput[2]).getDay();
            if (weekdayProvided !== weekdayActual) {
                getParsingFlags(config).weekdayMismatch = true;
                config._isValid = false;
                return false;
            }
        }
        return true;
    }
    function calculateOffset(obsOffset, militaryOffset, numOffset) {
        if (obsOffset) return obsOffsets[obsOffset];
        else if (militaryOffset) // the only allowed military tz is Z
        return 0;
        else {
            var hm = parseInt(numOffset, 10), m = hm % 100, h = (hm - m) / 100;
            return h * 60 + m;
        }
    }
    // date and time from ref 2822 format
    function configFromRFC2822(config) {
        var match = rfc2822.exec(preprocessRFC2822(config._i)), parsedArray;
        if (match) {
            parsedArray = extractFromRFC2822Strings(match[4], match[3], match[2], match[5], match[6], match[7]);
            if (!checkWeekday(match[1], parsedArray, config)) return;
            config._a = parsedArray;
            config._tzm = calculateOffset(match[8], match[9], match[10]);
            config._d = createUTCDate.apply(null, config._a);
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
            getParsingFlags(config).rfc2822 = true;
        } else config._isValid = false;
    }
    // date from 1) ASP.NET, 2) ISO, 3) RFC 2822 formats, or 4) optional fallback if parsing isn't strict
    function configFromString(config) {
        var matched = aspNetJsonRegex.exec(config._i);
        if (matched !== null) {
            config._d = new Date(+matched[1]);
            return;
        }
        configFromISO(config);
        if (config._isValid === false) delete config._isValid;
        else return;
        configFromRFC2822(config);
        if (config._isValid === false) delete config._isValid;
        else return;
        if (config._strict) config._isValid = false;
        else // Final attempt, use Input Fallback
        hooks.createFromInputFallback(config);
    }
    hooks.createFromInputFallback = deprecate("value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are discouraged. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.", function(config) {
        config._d = new Date(config._i + (config._useUTC ? " UTC" : ""));
    });
    // Pick the first defined of two or three arguments.
    function defaults(a, b, c) {
        if (a != null) return a;
        if (b != null) return b;
        return c;
    }
    function currentDateArray(config) {
        // hooks is actually the exported moment object
        var nowValue = new Date(hooks.now());
        if (config._useUTC) return [
            nowValue.getUTCFullYear(),
            nowValue.getUTCMonth(),
            nowValue.getUTCDate()
        ];
        return [
            nowValue.getFullYear(),
            nowValue.getMonth(),
            nowValue.getDate()
        ];
    }
    // convert an array to a date.
    // the array should mirror the parameters below
    // note: all values past the year are optional and will default to the lowest possible value.
    // [year, month, day , hour, minute, second, millisecond]
    function configFromArray(config) {
        var i, date, input = [], currentDate, expectedWeekday, yearToUse;
        if (config._d) return;
        currentDate = currentDateArray(config);
        //compute day of the year from weeks and weekdays
        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) dayOfYearFromWeekInfo(config);
        //if the day of the year is set, figure out what it is
        if (config._dayOfYear != null) {
            yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);
            if (config._dayOfYear > daysInYear(yearToUse) || config._dayOfYear === 0) getParsingFlags(config)._overflowDayOfYear = true;
            date = createUTCDate(yearToUse, 0, config._dayOfYear);
            config._a[MONTH] = date.getUTCMonth();
            config._a[DATE] = date.getUTCDate();
        }
        // Default to current date.
        // * if no year, month, day of month are given, default to today
        // * if day of month is given, default month and year
        // * if month is given, default only year
        // * if year is given, don't default anything
        for(i = 0; i < 3 && config._a[i] == null; ++i)config._a[i] = input[i] = currentDate[i];
        // Zero out whatever was not defaulted, including time
        for(; i < 7; i++)config._a[i] = input[i] = config._a[i] == null ? i === 2 ? 1 : 0 : config._a[i];
        // Check for 24:00:00.000
        if (config._a[HOUR] === 24 && config._a[MINUTE] === 0 && config._a[SECOND] === 0 && config._a[MILLISECOND] === 0) {
            config._nextDay = true;
            config._a[HOUR] = 0;
        }
        config._d = (config._useUTC ? createUTCDate : createDate).apply(null, input);
        expectedWeekday = config._useUTC ? config._d.getUTCDay() : config._d.getDay();
        // Apply timezone offset from input. The actual utcOffset can be changed
        // with parseZone.
        if (config._tzm != null) config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
        if (config._nextDay) config._a[HOUR] = 24;
        // check for mismatching day of week
        if (config._w && typeof config._w.d !== "undefined" && config._w.d !== expectedWeekday) getParsingFlags(config).weekdayMismatch = true;
    }
    function dayOfYearFromWeekInfo(config) {
        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow, curWeek;
        w = config._w;
        if (w.GG != null || w.W != null || w.E != null) {
            dow = 1;
            doy = 4;
            // TODO: We need to take the current isoWeekYear, but that depends on
            // how we interpret now (local, utc, fixed offset). So create
            // a now version of current config (take local/utc/offset flags, and
            // create now).
            weekYear = defaults(w.GG, config._a[YEAR], weekOfYear(createLocal(), 1, 4).year);
            week = defaults(w.W, 1);
            weekday = defaults(w.E, 1);
            if (weekday < 1 || weekday > 7) weekdayOverflow = true;
        } else {
            dow = config._locale._week.dow;
            doy = config._locale._week.doy;
            curWeek = weekOfYear(createLocal(), dow, doy);
            weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);
            // Default to current week.
            week = defaults(w.w, curWeek.week);
            if (w.d != null) {
                // weekday -- low day numbers are considered next week
                weekday = w.d;
                if (weekday < 0 || weekday > 6) weekdayOverflow = true;
            } else if (w.e != null) {
                // local weekday -- counting starts from beginning of week
                weekday = w.e + dow;
                if (w.e < 0 || w.e > 6) weekdayOverflow = true;
            } else // default to beginning of week
            weekday = dow;
        }
        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) getParsingFlags(config)._overflowWeeks = true;
        else if (weekdayOverflow != null) getParsingFlags(config)._overflowWeekday = true;
        else {
            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
            config._a[YEAR] = temp.year;
            config._dayOfYear = temp.dayOfYear;
        }
    }
    // constant that refers to the ISO standard
    hooks.ISO_8601 = function() {};
    // constant that refers to the RFC 2822 form
    hooks.RFC_2822 = function() {};
    // date from string and format string
    function configFromStringAndFormat(config) {
        // TODO: Move this to another part of the creation flow to prevent circular deps
        if (config._f === hooks.ISO_8601) {
            configFromISO(config);
            return;
        }
        if (config._f === hooks.RFC_2822) {
            configFromRFC2822(config);
            return;
        }
        config._a = [];
        getParsingFlags(config).empty = true;
        // This array is used to make a Date, either with `new Date` or `Date.UTC`
        var string = "" + config._i, i, parsedInput, tokens, token, skipped, stringLength = string.length, totalParsedInputLength = 0, era, tokenLen;
        tokens = expandFormat(config._f, config._locale).match(formattingTokens) || [];
        tokenLen = tokens.length;
        for(i = 0; i < tokenLen; i++){
            token = tokens[i];
            parsedInput = (string.match(getParseRegexForToken(token, config)) || [])[0];
            if (parsedInput) {
                skipped = string.substr(0, string.indexOf(parsedInput));
                if (skipped.length > 0) getParsingFlags(config).unusedInput.push(skipped);
                string = string.slice(string.indexOf(parsedInput) + parsedInput.length);
                totalParsedInputLength += parsedInput.length;
            }
            // don't parse if it's not a known token
            if (formatTokenFunctions[token]) {
                if (parsedInput) getParsingFlags(config).empty = false;
                else getParsingFlags(config).unusedTokens.push(token);
                addTimeToArrayFromToken(token, parsedInput, config);
            } else if (config._strict && !parsedInput) getParsingFlags(config).unusedTokens.push(token);
        }
        // add remaining unparsed input length to the string
        getParsingFlags(config).charsLeftOver = stringLength - totalParsedInputLength;
        if (string.length > 0) getParsingFlags(config).unusedInput.push(string);
        // clear _12h flag if hour is <= 12
        if (config._a[HOUR] <= 12 && getParsingFlags(config).bigHour === true && config._a[HOUR] > 0) getParsingFlags(config).bigHour = undefined;
        getParsingFlags(config).parsedDateParts = config._a.slice(0);
        getParsingFlags(config).meridiem = config._meridiem;
        // handle meridiem
        config._a[HOUR] = meridiemFixWrap(config._locale, config._a[HOUR], config._meridiem);
        // handle era
        era = getParsingFlags(config).era;
        if (era !== null) config._a[YEAR] = config._locale.erasConvertYear(era, config._a[YEAR]);
        configFromArray(config);
        checkOverflow(config);
    }
    function meridiemFixWrap(locale, hour, meridiem) {
        var isPm;
        if (meridiem == null) // nothing to do
        return hour;
        if (locale.meridiemHour != null) return locale.meridiemHour(hour, meridiem);
        else if (locale.isPM != null) {
            // Fallback
            isPm = locale.isPM(meridiem);
            if (isPm && hour < 12) hour += 12;
            if (!isPm && hour === 12) hour = 0;
            return hour;
        } else // this is not supposed to happen
        return hour;
    }
    // date from string and array of format strings
    function configFromStringAndArray(config) {
        var tempConfig, bestMoment, scoreToBeat, i, currentScore, validFormatFound, bestFormatIsValid = false, configfLen = config._f.length;
        if (configfLen === 0) {
            getParsingFlags(config).invalidFormat = true;
            config._d = new Date(NaN);
            return;
        }
        for(i = 0; i < configfLen; i++){
            currentScore = 0;
            validFormatFound = false;
            tempConfig = copyConfig({}, config);
            if (config._useUTC != null) tempConfig._useUTC = config._useUTC;
            tempConfig._f = config._f[i];
            configFromStringAndFormat(tempConfig);
            if (isValid(tempConfig)) validFormatFound = true;
            // if there is any input that was not parsed add a penalty for that format
            currentScore += getParsingFlags(tempConfig).charsLeftOver;
            //or tokens
            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;
            getParsingFlags(tempConfig).score = currentScore;
            if (!bestFormatIsValid) {
                if (scoreToBeat == null || currentScore < scoreToBeat || validFormatFound) {
                    scoreToBeat = currentScore;
                    bestMoment = tempConfig;
                    if (validFormatFound) bestFormatIsValid = true;
                }
            } else if (currentScore < scoreToBeat) {
                scoreToBeat = currentScore;
                bestMoment = tempConfig;
            }
        }
        extend(config, bestMoment || tempConfig);
    }
    function configFromObject(config) {
        if (config._d) return;
        var i = normalizeObjectUnits(config._i), dayOrDate = i.day === undefined ? i.date : i.day;
        config._a = map([
            i.year,
            i.month,
            dayOrDate,
            i.hour,
            i.minute,
            i.second,
            i.millisecond
        ], function(obj) {
            return obj && parseInt(obj, 10);
        });
        configFromArray(config);
    }
    function createFromConfig(config) {
        var res = new Moment(checkOverflow(prepareConfig(config)));
        if (res._nextDay) {
            // Adding is smart enough around DST
            res.add(1, "d");
            res._nextDay = undefined;
        }
        return res;
    }
    function prepareConfig(config) {
        var input = config._i, format = config._f;
        config._locale = config._locale || getLocale(config._l);
        if (input === null || format === undefined && input === "") return createInvalid({
            nullInput: true
        });
        if (typeof input === "string") config._i = input = config._locale.preparse(input);
        if (isMoment(input)) return new Moment(checkOverflow(input));
        else if (isDate(input)) config._d = input;
        else if (isArray(format)) configFromStringAndArray(config);
        else if (format) configFromStringAndFormat(config);
        else configFromInput(config);
        if (!isValid(config)) config._d = null;
        return config;
    }
    function configFromInput(config) {
        var input = config._i;
        if (isUndefined(input)) config._d = new Date(hooks.now());
        else if (isDate(input)) config._d = new Date(input.valueOf());
        else if (typeof input === "string") configFromString(config);
        else if (isArray(input)) {
            config._a = map(input.slice(0), function(obj) {
                return parseInt(obj, 10);
            });
            configFromArray(config);
        } else if (isObject(input)) configFromObject(config);
        else if (isNumber(input)) // from milliseconds
        config._d = new Date(input);
        else hooks.createFromInputFallback(config);
    }
    function createLocalOrUTC(input, format, locale, strict, isUTC) {
        var c = {};
        if (format === true || format === false) {
            strict = format;
            format = undefined;
        }
        if (locale === true || locale === false) {
            strict = locale;
            locale = undefined;
        }
        if (isObject(input) && isObjectEmpty(input) || isArray(input) && input.length === 0) input = undefined;
        // object construction must be done this way.
        // https://github.com/moment/moment/issues/1423
        c._isAMomentObject = true;
        c._useUTC = c._isUTC = isUTC;
        c._l = locale;
        c._i = input;
        c._f = format;
        c._strict = strict;
        return createFromConfig(c);
    }
    function createLocal(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, false);
    }
    var prototypeMin = deprecate("moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/", function() {
        var other = createLocal.apply(null, arguments);
        if (this.isValid() && other.isValid()) return other < this ? this : other;
        else return createInvalid();
    }), prototypeMax = deprecate("moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/", function() {
        var other = createLocal.apply(null, arguments);
        if (this.isValid() && other.isValid()) return other > this ? this : other;
        else return createInvalid();
    });
    // Pick a moment m from moments so that m[fn](other) is true for all
    // other. This relies on the function fn to be transitive.
    //
    // moments should either be an array of moment objects or an array, whose
    // first element is an array of moment objects.
    function pickBy(fn, moments) {
        var res, i;
        if (moments.length === 1 && isArray(moments[0])) moments = moments[0];
        if (!moments.length) return createLocal();
        res = moments[0];
        for(i = 1; i < moments.length; ++i)if (!moments[i].isValid() || moments[i][fn](res)) res = moments[i];
        return res;
    }
    // TODO: Use [].sort instead?
    function min() {
        var args = [].slice.call(arguments, 0);
        return pickBy("isBefore", args);
    }
    function max() {
        var args = [].slice.call(arguments, 0);
        return pickBy("isAfter", args);
    }
    var now = function() {
        return Date.now ? Date.now() : +new Date();
    };
    var ordering = [
        "year",
        "quarter",
        "month",
        "week",
        "day",
        "hour",
        "minute",
        "second",
        "millisecond"
    ];
    function isDurationValid(m) {
        var key, unitHasDecimal = false, i, orderLen = ordering.length;
        for(key in m){
            if (hasOwnProp(m, key) && !(indexOf.call(ordering, key) !== -1 && (m[key] == null || !isNaN(m[key])))) return false;
        }
        for(i = 0; i < orderLen; ++i)if (m[ordering[i]]) {
            if (unitHasDecimal) return false; // only allow non-integers for smallest unit
            if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) unitHasDecimal = true;
        }
        return true;
    }
    function isValid$1() {
        return this._isValid;
    }
    function createInvalid$1() {
        return createDuration(NaN);
    }
    function Duration(duration) {
        var normalizedInput = normalizeObjectUnits(duration), years = normalizedInput.year || 0, quarters = normalizedInput.quarter || 0, months = normalizedInput.month || 0, weeks = normalizedInput.week || normalizedInput.isoWeek || 0, days = normalizedInput.day || 0, hours = normalizedInput.hour || 0, minutes = normalizedInput.minute || 0, seconds = normalizedInput.second || 0, milliseconds = normalizedInput.millisecond || 0;
        this._isValid = isDurationValid(normalizedInput);
        // representation for dateAddRemove
        this._milliseconds = +milliseconds + seconds * 1e3 + // 1000
        minutes * 6e4 + // 1000 * 60
        hours * 3600000; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
        // Because of dateAddRemove treats 24 hours as different from a
        // day when working around DST, we need to store them separately
        this._days = +days + weeks * 7;
        // It is impossible to translate months into days without knowing
        // which months you are are talking about, so we have to store
        // it separately.
        this._months = +months + quarters * 3 + years * 12;
        this._data = {};
        this._locale = getLocale();
        this._bubble();
    }
    function isDuration(obj) {
        return obj instanceof Duration;
    }
    function absRound(number) {
        if (number < 0) return Math.round(-1 * number) * -1;
        else return Math.round(number);
    }
    // compare two arrays, return the number of differences
    function compareArrays(array1, array2, dontConvert) {
        var len = Math.min(array1.length, array2.length), lengthDiff = Math.abs(array1.length - array2.length), diffs = 0, i;
        for(i = 0; i < len; i++)if (dontConvert && array1[i] !== array2[i] || !dontConvert && toInt(array1[i]) !== toInt(array2[i])) diffs++;
        return diffs + lengthDiff;
    }
    // FORMATTING
    function offset(token, separator) {
        addFormatToken(token, 0, 0, function() {
            var offset = this.utcOffset(), sign = "+";
            if (offset < 0) {
                offset = -offset;
                sign = "-";
            }
            return sign + zeroFill(~~(offset / 60), 2) + separator + zeroFill(~~offset % 60, 2);
        });
    }
    offset("Z", ":");
    offset("ZZ", "");
    // PARSING
    addRegexToken("Z", matchShortOffset);
    addRegexToken("ZZ", matchShortOffset);
    addParseToken([
        "Z",
        "ZZ"
    ], function(input, array, config) {
        config._useUTC = true;
        config._tzm = offsetFromString(matchShortOffset, input);
    });
    // HELPERS
    // timezone chunker
    // '+10:00' > ['10',  '00']
    // '-1530'  > ['-15', '30']
    var chunkOffset = /([\+\-]|\d\d)/gi;
    function offsetFromString(matcher, string) {
        var matches = (string || "").match(matcher), chunk, parts, minutes;
        if (matches === null) return null;
        chunk = matches[matches.length - 1] || [];
        parts = (chunk + "").match(chunkOffset) || [
            "-",
            0,
            0
        ];
        minutes = +(parts[1] * 60) + toInt(parts[2]);
        return minutes === 0 ? 0 : parts[0] === "+" ? minutes : -minutes;
    }
    // Return a moment from input, that is local/utc/zone equivalent to model.
    function cloneWithOffset(input, model) {
        var res, diff;
        if (model._isUTC) {
            res = model.clone();
            diff = (isMoment(input) || isDate(input) ? input.valueOf() : createLocal(input).valueOf()) - res.valueOf();
            // Use low-level api, because this fn is low-level api.
            res._d.setTime(res._d.valueOf() + diff);
            hooks.updateOffset(res, false);
            return res;
        } else return createLocal(input).local();
    }
    function getDateOffset(m) {
        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
        // https://github.com/moment/moment/pull/1871
        return -Math.round(m._d.getTimezoneOffset());
    }
    // HOOKS
    // This function will be called whenever a moment is mutated.
    // It is intended to keep the offset in sync with the timezone.
    hooks.updateOffset = function() {};
    // MOMENTS
    // keepLocalTime = true means only change the timezone, without
    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
    // +0200, so we adjust the time as needed, to be valid.
    //
    // Keeping the time actually adds/subtracts (one hour)
    // from the actual represented time. That is why we call updateOffset
    // a second time. In case it wants us to change the offset again
    // _changeInProgress == true case, then we have to adjust, because
    // there is no such time in the given timezone.
    function getSetOffset(input, keepLocalTime, keepMinutes) {
        var offset = this._offset || 0, localAdjust;
        if (!this.isValid()) return input != null ? this : NaN;
        if (input != null) {
            if (typeof input === "string") {
                input = offsetFromString(matchShortOffset, input);
                if (input === null) return this;
            } else if (Math.abs(input) < 16 && !keepMinutes) input = input * 60;
            if (!this._isUTC && keepLocalTime) localAdjust = getDateOffset(this);
            this._offset = input;
            this._isUTC = true;
            if (localAdjust != null) this.add(localAdjust, "m");
            if (offset !== input) {
                if (!keepLocalTime || this._changeInProgress) addSubtract(this, createDuration(input - offset, "m"), 1, false);
                else if (!this._changeInProgress) {
                    this._changeInProgress = true;
                    hooks.updateOffset(this, true);
                    this._changeInProgress = null;
                }
            }
            return this;
        } else return this._isUTC ? offset : getDateOffset(this);
    }
    function getSetZone(input, keepLocalTime) {
        if (input != null) {
            if (typeof input !== "string") input = -input;
            this.utcOffset(input, keepLocalTime);
            return this;
        } else return -this.utcOffset();
    }
    function setOffsetToUTC(keepLocalTime) {
        return this.utcOffset(0, keepLocalTime);
    }
    function setOffsetToLocal(keepLocalTime) {
        if (this._isUTC) {
            this.utcOffset(0, keepLocalTime);
            this._isUTC = false;
            if (keepLocalTime) this.subtract(getDateOffset(this), "m");
        }
        return this;
    }
    function setOffsetToParsedOffset() {
        if (this._tzm != null) this.utcOffset(this._tzm, false, true);
        else if (typeof this._i === "string") {
            var tZone = offsetFromString(matchOffset, this._i);
            if (tZone != null) this.utcOffset(tZone);
            else this.utcOffset(0, true);
        }
        return this;
    }
    function hasAlignedHourOffset(input) {
        if (!this.isValid()) return false;
        input = input ? createLocal(input).utcOffset() : 0;
        return (this.utcOffset() - input) % 60 === 0;
    }
    function isDaylightSavingTime() {
        return this.utcOffset() > this.clone().month(0).utcOffset() || this.utcOffset() > this.clone().month(5).utcOffset();
    }
    function isDaylightSavingTimeShifted() {
        if (!isUndefined(this._isDSTShifted)) return this._isDSTShifted;
        var c = {}, other;
        copyConfig(c, this);
        c = prepareConfig(c);
        if (c._a) {
            other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
            this._isDSTShifted = this.isValid() && compareArrays(c._a, other.toArray()) > 0;
        } else this._isDSTShifted = false;
        return this._isDSTShifted;
    }
    function isLocal() {
        return this.isValid() ? !this._isUTC : false;
    }
    function isUtcOffset() {
        return this.isValid() ? this._isUTC : false;
    }
    function isUtc() {
        return this.isValid() ? this._isUTC && this._offset === 0 : false;
    }
    // ASP.NET json date format regex
    var aspNetRegex = /^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/, // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
    // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
    // and further modified to allow for strings containing both week and day
    isoRegex = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;
    function createDuration(input, key) {
        var duration = input, // matching against regexp is expensive, do it on demand
        match = null, sign, ret, diffRes;
        if (isDuration(input)) duration = {
            ms: input._milliseconds,
            d: input._days,
            M: input._months
        };
        else if (isNumber(input) || !isNaN(+input)) {
            duration = {};
            if (key) duration[key] = +input;
            else duration.milliseconds = +input;
        } else if (match = aspNetRegex.exec(input)) {
            sign = match[1] === "-" ? -1 : 1;
            duration = {
                y: 0,
                d: toInt(match[DATE]) * sign,
                h: toInt(match[HOUR]) * sign,
                m: toInt(match[MINUTE]) * sign,
                s: toInt(match[SECOND]) * sign,
                ms: toInt(absRound(match[MILLISECOND] * 1000)) * sign
            };
        } else if (match = isoRegex.exec(input)) {
            sign = match[1] === "-" ? -1 : 1;
            duration = {
                y: parseIso(match[2], sign),
                M: parseIso(match[3], sign),
                w: parseIso(match[4], sign),
                d: parseIso(match[5], sign),
                h: parseIso(match[6], sign),
                m: parseIso(match[7], sign),
                s: parseIso(match[8], sign)
            };
        } else if (duration == null) // checks for null or undefined
        duration = {};
        else if (typeof duration === "object" && ("from" in duration || "to" in duration)) {
            diffRes = momentsDifference(createLocal(duration.from), createLocal(duration.to));
            duration = {};
            duration.ms = diffRes.milliseconds;
            duration.M = diffRes.months;
        }
        ret = new Duration(duration);
        if (isDuration(input) && hasOwnProp(input, "_locale")) ret._locale = input._locale;
        if (isDuration(input) && hasOwnProp(input, "_isValid")) ret._isValid = input._isValid;
        return ret;
    }
    createDuration.fn = Duration.prototype;
    createDuration.invalid = createInvalid$1;
    function parseIso(inp, sign) {
        // We'd normally use ~~inp for this, but unfortunately it also
        // converts floats to ints.
        // inp may be undefined, so careful calling replace on it.
        var res = inp && parseFloat(inp.replace(",", "."));
        // apply sign while we're at it
        return (isNaN(res) ? 0 : res) * sign;
    }
    function positiveMomentsDifference(base, other) {
        var res = {};
        res.months = other.month() - base.month() + (other.year() - base.year()) * 12;
        if (base.clone().add(res.months, "M").isAfter(other)) --res.months;
        res.milliseconds = +other - +base.clone().add(res.months, "M");
        return res;
    }
    function momentsDifference(base, other) {
        var res;
        if (!(base.isValid() && other.isValid())) return {
            milliseconds: 0,
            months: 0
        };
        other = cloneWithOffset(other, base);
        if (base.isBefore(other)) res = positiveMomentsDifference(base, other);
        else {
            res = positiveMomentsDifference(other, base);
            res.milliseconds = -res.milliseconds;
            res.months = -res.months;
        }
        return res;
    }
    // TODO: remove 'name' arg after deprecation is removed
    function createAdder(direction, name) {
        return function(val, period) {
            var dur, tmp;
            //invert the arguments, but complain about it
            if (period !== null && !isNaN(+period)) {
                deprecateSimple(name, "moment()." + name + "(period, number) is deprecated. Please use moment()." + name + "(number, period). " + "See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.");
                tmp = val;
                val = period;
                period = tmp;
            }
            dur = createDuration(val, period);
            addSubtract(this, dur, direction);
            return this;
        };
    }
    function addSubtract(mom, duration, isAdding, updateOffset) {
        var milliseconds = duration._milliseconds, days = absRound(duration._days), months = absRound(duration._months);
        if (!mom.isValid()) // No op
        return;
        updateOffset = updateOffset == null ? true : updateOffset;
        if (months) setMonth(mom, get(mom, "Month") + months * isAdding);
        if (days) set$1(mom, "Date", get(mom, "Date") + days * isAdding);
        if (milliseconds) mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
        if (updateOffset) hooks.updateOffset(mom, days || months);
    }
    var add = createAdder(1, "add"), subtract = createAdder(-1, "subtract");
    function isString(input) {
        return typeof input === "string" || input instanceof String;
    }
    // type MomentInput = Moment | Date | string | number | (number | string)[] | MomentInputObject | void; // null | undefined
    function isMomentInput(input) {
        return isMoment(input) || isDate(input) || isString(input) || isNumber(input) || isNumberOrStringArray(input) || isMomentInputObject(input) || input === null || input === undefined;
    }
    function isMomentInputObject(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input), propertyTest = false, properties = [
            "years",
            "year",
            "y",
            "months",
            "month",
            "M",
            "days",
            "day",
            "d",
            "dates",
            "date",
            "D",
            "hours",
            "hour",
            "h",
            "minutes",
            "minute",
            "m",
            "seconds",
            "second",
            "s",
            "milliseconds",
            "millisecond",
            "ms"
        ], i, property, propertyLen = properties.length;
        for(i = 0; i < propertyLen; i += 1){
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }
        return objectTest && propertyTest;
    }
    function isNumberOrStringArray(input) {
        var arrayTest = isArray(input), dataTypeTest = false;
        if (arrayTest) dataTypeTest = input.filter(function(item) {
            return !isNumber(item) && isString(input);
        }).length === 0;
        return arrayTest && dataTypeTest;
    }
    function isCalendarSpec(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input), propertyTest = false, properties = [
            "sameDay",
            "nextDay",
            "lastDay",
            "nextWeek",
            "lastWeek",
            "sameElse"
        ], i, property;
        for(i = 0; i < properties.length; i += 1){
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }
        return objectTest && propertyTest;
    }
    function getCalendarFormat(myMoment, now) {
        var diff = myMoment.diff(now, "days", true);
        return diff < -6 ? "sameElse" : diff < -1 ? "lastWeek" : diff < 0 ? "lastDay" : diff < 1 ? "sameDay" : diff < 2 ? "nextDay" : diff < 7 ? "nextWeek" : "sameElse";
    }
    function calendar$1(time, formats) {
        // Support for single parameter, formats only overload to the calendar function
        if (arguments.length === 1) {
            if (!arguments[0]) {
                time = undefined;
                formats = undefined;
            } else if (isMomentInput(arguments[0])) {
                time = arguments[0];
                formats = undefined;
            } else if (isCalendarSpec(arguments[0])) {
                formats = arguments[0];
                time = undefined;
            }
        }
        // We want to compare the start of today, vs this.
        // Getting start-of-today depends on whether we're local/utc/offset or not.
        var now = time || createLocal(), sod = cloneWithOffset(now, this).startOf("day"), format = hooks.calendarFormat(this, sod) || "sameElse", output = formats && (isFunction(formats[format]) ? formats[format].call(this, now) : formats[format]);
        return this.format(output || this.localeData().calendar(format, this, createLocal(now)));
    }
    function clone() {
        return new Moment(this);
    }
    function isAfter(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) return false;
        units = normalizeUnits(units) || "millisecond";
        if (units === "millisecond") return this.valueOf() > localInput.valueOf();
        else return localInput.valueOf() < this.clone().startOf(units).valueOf();
    }
    function isBefore(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) return false;
        units = normalizeUnits(units) || "millisecond";
        if (units === "millisecond") return this.valueOf() < localInput.valueOf();
        else return this.clone().endOf(units).valueOf() < localInput.valueOf();
    }
    function isBetween(from, to, units, inclusivity) {
        var localFrom = isMoment(from) ? from : createLocal(from), localTo = isMoment(to) ? to : createLocal(to);
        if (!(this.isValid() && localFrom.isValid() && localTo.isValid())) return false;
        inclusivity = inclusivity || "()";
        return (inclusivity[0] === "(" ? this.isAfter(localFrom, units) : !this.isBefore(localFrom, units)) && (inclusivity[1] === ")" ? this.isBefore(localTo, units) : !this.isAfter(localTo, units));
    }
    function isSame(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input), inputMs;
        if (!(this.isValid() && localInput.isValid())) return false;
        units = normalizeUnits(units) || "millisecond";
        if (units === "millisecond") return this.valueOf() === localInput.valueOf();
        else {
            inputMs = localInput.valueOf();
            return this.clone().startOf(units).valueOf() <= inputMs && inputMs <= this.clone().endOf(units).valueOf();
        }
    }
    function isSameOrAfter(input, units) {
        return this.isSame(input, units) || this.isAfter(input, units);
    }
    function isSameOrBefore(input, units) {
        return this.isSame(input, units) || this.isBefore(input, units);
    }
    function diff(input, units, asFloat) {
        var that, zoneDelta, output;
        if (!this.isValid()) return NaN;
        that = cloneWithOffset(input, this);
        if (!that.isValid()) return NaN;
        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;
        units = normalizeUnits(units);
        switch(units){
            case "year":
                output = monthDiff(this, that) / 12;
                break;
            case "month":
                output = monthDiff(this, that);
                break;
            case "quarter":
                output = monthDiff(this, that) / 3;
                break;
            case "second":
                output = (this - that) / 1e3;
                break; // 1000
            case "minute":
                output = (this - that) / 6e4;
                break; // 1000 * 60
            case "hour":
                output = (this - that) / 36e5;
                break; // 1000 * 60 * 60
            case "day":
                output = (this - that - zoneDelta) / 864e5;
                break; // 1000 * 60 * 60 * 24, negate dst
            case "week":
                output = (this - that - zoneDelta) / 6048e5;
                break; // 1000 * 60 * 60 * 24 * 7, negate dst
            default:
                output = this - that;
        }
        return asFloat ? output : absFloor(output);
    }
    function monthDiff(a, b) {
        if (a.date() < b.date()) // end-of-month calculations work correct when the start month has more
        // days than the end month.
        return -monthDiff(b, a);
        // difference in months
        var wholeMonthDiff = (b.year() - a.year()) * 12 + (b.month() - a.month()), // b is in (anchor - 1 month, anchor + 1 month)
        anchor = a.clone().add(wholeMonthDiff, "months"), anchor2, adjust;
        if (b - anchor < 0) {
            anchor2 = a.clone().add(wholeMonthDiff - 1, "months");
            // linear across the month
            adjust = (b - anchor) / (anchor - anchor2);
        } else {
            anchor2 = a.clone().add(wholeMonthDiff + 1, "months");
            // linear across the month
            adjust = (b - anchor) / (anchor2 - anchor);
        }
        //check for negative zero, return zero if negative zero
        return -(wholeMonthDiff + adjust) || 0;
    }
    hooks.defaultFormat = "YYYY-MM-DDTHH:mm:ssZ";
    hooks.defaultFormatUtc = "YYYY-MM-DDTHH:mm:ss[Z]";
    function toString() {
        return this.clone().locale("en").format("ddd MMM DD YYYY HH:mm:ss [GMT]ZZ");
    }
    function toISOString(keepOffset) {
        if (!this.isValid()) return null;
        var utc = keepOffset !== true, m = utc ? this.clone().utc() : this;
        if (m.year() < 0 || m.year() > 9999) return formatMoment(m, utc ? "YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]" : "YYYYYY-MM-DD[T]HH:mm:ss.SSSZ");
        if (isFunction(Date.prototype.toISOString)) {
            // native implementation is ~50x faster, use it when we can
            if (utc) return this.toDate().toISOString();
            else return new Date(this.valueOf() + this.utcOffset() * 60000).toISOString().replace("Z", formatMoment(m, "Z"));
        }
        return formatMoment(m, utc ? "YYYY-MM-DD[T]HH:mm:ss.SSS[Z]" : "YYYY-MM-DD[T]HH:mm:ss.SSSZ");
    }
    /**
     * Return a human readable representation of a moment that can
     * also be evaluated to get a new moment which is the same
     *
     * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
     */ function inspect() {
        if (!this.isValid()) return "moment.invalid(/* " + this._i + " */)";
        var func = "moment", zone = "", prefix, year, datetime, suffix;
        if (!this.isLocal()) {
            func = this.utcOffset() === 0 ? "moment.utc" : "moment.parseZone";
            zone = "Z";
        }
        prefix = "[" + func + '("]';
        year = 0 <= this.year() && this.year() <= 9999 ? "YYYY" : "YYYYYY";
        datetime = "-MM-DD[T]HH:mm:ss.SSS";
        suffix = zone + '[")]';
        return this.format(prefix + year + datetime + suffix);
    }
    function format(inputString) {
        if (!inputString) inputString = this.isUtc() ? hooks.defaultFormatUtc : hooks.defaultFormat;
        var output = formatMoment(this, inputString);
        return this.localeData().postformat(output);
    }
    function from(time, withoutSuffix) {
        if (this.isValid() && (isMoment(time) && time.isValid() || createLocal(time).isValid())) return createDuration({
            to: this,
            from: time
        }).locale(this.locale()).humanize(!withoutSuffix);
        else return this.localeData().invalidDate();
    }
    function fromNow(withoutSuffix) {
        return this.from(createLocal(), withoutSuffix);
    }
    function to(time, withoutSuffix) {
        if (this.isValid() && (isMoment(time) && time.isValid() || createLocal(time).isValid())) return createDuration({
            from: this,
            to: time
        }).locale(this.locale()).humanize(!withoutSuffix);
        else return this.localeData().invalidDate();
    }
    function toNow(withoutSuffix) {
        return this.to(createLocal(), withoutSuffix);
    }
    // If passed a locale key, it will set the locale for this
    // instance.  Otherwise, it will return the locale configuration
    // variables for this instance.
    function locale(key) {
        var newLocaleData;
        if (key === undefined) return this._locale._abbr;
        else {
            newLocaleData = getLocale(key);
            if (newLocaleData != null) this._locale = newLocaleData;
            return this;
        }
    }
    var lang = deprecate("moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.", function(key) {
        if (key === undefined) return this.localeData();
        else return this.locale(key);
    });
    function localeData() {
        return this._locale;
    }
    var MS_PER_SECOND = 1000, MS_PER_MINUTE = 60 * MS_PER_SECOND, MS_PER_HOUR = 60 * MS_PER_MINUTE, MS_PER_400_YEARS = 3506328 * MS_PER_HOUR;
    // actual modulo - handles negative numbers (for dates before 1970):
    function mod$1(dividend, divisor) {
        return (dividend % divisor + divisor) % divisor;
    }
    function localStartOfDate(y, m, d) {
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) // preserve leap years using a full 400 year cycle, then reset
        return new Date(y + 400, m, d) - MS_PER_400_YEARS;
        else return new Date(y, m, d).valueOf();
    }
    function utcStartOfDate(y, m, d) {
        // Date.UTC remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) // preserve leap years using a full 400 year cycle, then reset
        return Date.UTC(y + 400, m, d) - MS_PER_400_YEARS;
        else return Date.UTC(y, m, d);
    }
    function startOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === "millisecond" || !this.isValid()) return this;
        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
        switch(units){
            case "year":
                time = startOfDate(this.year(), 0, 1);
                break;
            case "quarter":
                time = startOfDate(this.year(), this.month() - this.month() % 3, 1);
                break;
            case "month":
                time = startOfDate(this.year(), this.month(), 1);
                break;
            case "week":
                time = startOfDate(this.year(), this.month(), this.date() - this.weekday());
                break;
            case "isoWeek":
                time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1));
                break;
            case "day":
            case "date":
                time = startOfDate(this.year(), this.month(), this.date());
                break;
            case "hour":
                time = this._d.valueOf();
                time -= mod$1(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR);
                break;
            case "minute":
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_MINUTE);
                break;
            case "second":
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_SECOND);
                break;
        }
        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }
    function endOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === "millisecond" || !this.isValid()) return this;
        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
        switch(units){
            case "year":
                time = startOfDate(this.year() + 1, 0, 1) - 1;
                break;
            case "quarter":
                time = startOfDate(this.year(), this.month() - this.month() % 3 + 3, 1) - 1;
                break;
            case "month":
                time = startOfDate(this.year(), this.month() + 1, 1) - 1;
                break;
            case "week":
                time = startOfDate(this.year(), this.month(), this.date() - this.weekday() + 7) - 1;
                break;
            case "isoWeek":
                time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1) + 7) - 1;
                break;
            case "day":
            case "date":
                time = startOfDate(this.year(), this.month(), this.date() + 1) - 1;
                break;
            case "hour":
                time = this._d.valueOf();
                time += MS_PER_HOUR - mod$1(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR) - 1;
                break;
            case "minute":
                time = this._d.valueOf();
                time += MS_PER_MINUTE - mod$1(time, MS_PER_MINUTE) - 1;
                break;
            case "second":
                time = this._d.valueOf();
                time += MS_PER_SECOND - mod$1(time, MS_PER_SECOND) - 1;
                break;
        }
        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }
    function valueOf() {
        return this._d.valueOf() - (this._offset || 0) * 60000;
    }
    function unix() {
        return Math.floor(this.valueOf() / 1000);
    }
    function toDate() {
        return new Date(this.valueOf());
    }
    function toArray() {
        var m = this;
        return [
            m.year(),
            m.month(),
            m.date(),
            m.hour(),
            m.minute(),
            m.second(),
            m.millisecond()
        ];
    }
    function toObject() {
        var m = this;
        return {
            years: m.year(),
            months: m.month(),
            date: m.date(),
            hours: m.hours(),
            minutes: m.minutes(),
            seconds: m.seconds(),
            milliseconds: m.milliseconds()
        };
    }
    function toJSON() {
        // new Date(NaN).toJSON() === null
        return this.isValid() ? this.toISOString() : null;
    }
    function isValid$2() {
        return isValid(this);
    }
    function parsingFlags() {
        return extend({}, getParsingFlags(this));
    }
    function invalidAt() {
        return getParsingFlags(this).overflow;
    }
    function creationData() {
        return {
            input: this._i,
            format: this._f,
            locale: this._locale,
            isUTC: this._isUTC,
            strict: this._strict
        };
    }
    addFormatToken("N", 0, 0, "eraAbbr");
    addFormatToken("NN", 0, 0, "eraAbbr");
    addFormatToken("NNN", 0, 0, "eraAbbr");
    addFormatToken("NNNN", 0, 0, "eraName");
    addFormatToken("NNNNN", 0, 0, "eraNarrow");
    addFormatToken("y", [
        "y",
        1
    ], "yo", "eraYear");
    addFormatToken("y", [
        "yy",
        2
    ], 0, "eraYear");
    addFormatToken("y", [
        "yyy",
        3
    ], 0, "eraYear");
    addFormatToken("y", [
        "yyyy",
        4
    ], 0, "eraYear");
    addRegexToken("N", matchEraAbbr);
    addRegexToken("NN", matchEraAbbr);
    addRegexToken("NNN", matchEraAbbr);
    addRegexToken("NNNN", matchEraName);
    addRegexToken("NNNNN", matchEraNarrow);
    addParseToken([
        "N",
        "NN",
        "NNN",
        "NNNN",
        "NNNNN"
    ], function(input, array, config, token) {
        var era = config._locale.erasParse(input, token, config._strict);
        if (era) getParsingFlags(config).era = era;
        else getParsingFlags(config).invalidEra = input;
    });
    addRegexToken("y", matchUnsigned);
    addRegexToken("yy", matchUnsigned);
    addRegexToken("yyy", matchUnsigned);
    addRegexToken("yyyy", matchUnsigned);
    addRegexToken("yo", matchEraYearOrdinal);
    addParseToken([
        "y",
        "yy",
        "yyy",
        "yyyy"
    ], YEAR);
    addParseToken([
        "yo"
    ], function(input, array, config, token) {
        var match;
        if (config._locale._eraYearOrdinalRegex) match = input.match(config._locale._eraYearOrdinalRegex);
        if (config._locale.eraYearOrdinalParse) array[YEAR] = config._locale.eraYearOrdinalParse(input, match);
        else array[YEAR] = parseInt(input, 10);
    });
    function localeEras(m, format) {
        var i, l, date, eras = this._eras || getLocale("en")._eras;
        for(i = 0, l = eras.length; i < l; ++i){
            switch(typeof eras[i].since){
                case "string":
                    // truncate time
                    date = hooks(eras[i].since).startOf("day");
                    eras[i].since = date.valueOf();
                    break;
            }
            switch(typeof eras[i].until){
                case "undefined":
                    eras[i].until = Infinity;
                    break;
                case "string":
                    // truncate time
                    date = hooks(eras[i].until).startOf("day").valueOf();
                    eras[i].until = date.valueOf();
                    break;
            }
        }
        return eras;
    }
    function localeErasParse(eraName, format, strict) {
        var i, l, eras = this.eras(), name, abbr, narrow;
        eraName = eraName.toUpperCase();
        for(i = 0, l = eras.length; i < l; ++i){
            name = eras[i].name.toUpperCase();
            abbr = eras[i].abbr.toUpperCase();
            narrow = eras[i].narrow.toUpperCase();
            if (strict) switch(format){
                case "N":
                case "NN":
                case "NNN":
                    if (abbr === eraName) return eras[i];
                    break;
                case "NNNN":
                    if (name === eraName) return eras[i];
                    break;
                case "NNNNN":
                    if (narrow === eraName) return eras[i];
                    break;
            }
            else if ([
                name,
                abbr,
                narrow
            ].indexOf(eraName) >= 0) return eras[i];
        }
    }
    function localeErasConvertYear(era, year) {
        var dir = era.since <= era.until ? 1 : -1;
        if (year === undefined) return hooks(era.since).year();
        else return hooks(era.since).year() + (year - era.offset) * dir;
    }
    function getEraName() {
        var i, l, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            // truncate time
            val = this.clone().startOf("day").valueOf();
            if (eras[i].since <= val && val <= eras[i].until) return eras[i].name;
            if (eras[i].until <= val && val <= eras[i].since) return eras[i].name;
        }
        return "";
    }
    function getEraNarrow() {
        var i, l, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            // truncate time
            val = this.clone().startOf("day").valueOf();
            if (eras[i].since <= val && val <= eras[i].until) return eras[i].narrow;
            if (eras[i].until <= val && val <= eras[i].since) return eras[i].narrow;
        }
        return "";
    }
    function getEraAbbr() {
        var i, l, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            // truncate time
            val = this.clone().startOf("day").valueOf();
            if (eras[i].since <= val && val <= eras[i].until) return eras[i].abbr;
            if (eras[i].until <= val && val <= eras[i].since) return eras[i].abbr;
        }
        return "";
    }
    function getEraYear() {
        var i, l, dir, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            dir = eras[i].since <= eras[i].until ? 1 : -1;
            // truncate time
            val = this.clone().startOf("day").valueOf();
            if (eras[i].since <= val && val <= eras[i].until || eras[i].until <= val && val <= eras[i].since) return (this.year() - hooks(eras[i].since).year()) * dir + eras[i].offset;
        }
        return this.year();
    }
    function erasNameRegex(isStrict) {
        if (!hasOwnProp(this, "_erasNameRegex")) computeErasParse.call(this);
        return isStrict ? this._erasNameRegex : this._erasRegex;
    }
    function erasAbbrRegex(isStrict) {
        if (!hasOwnProp(this, "_erasAbbrRegex")) computeErasParse.call(this);
        return isStrict ? this._erasAbbrRegex : this._erasRegex;
    }
    function erasNarrowRegex(isStrict) {
        if (!hasOwnProp(this, "_erasNarrowRegex")) computeErasParse.call(this);
        return isStrict ? this._erasNarrowRegex : this._erasRegex;
    }
    function matchEraAbbr(isStrict, locale) {
        return locale.erasAbbrRegex(isStrict);
    }
    function matchEraName(isStrict, locale) {
        return locale.erasNameRegex(isStrict);
    }
    function matchEraNarrow(isStrict, locale) {
        return locale.erasNarrowRegex(isStrict);
    }
    function matchEraYearOrdinal(isStrict, locale) {
        return locale._eraYearOrdinalRegex || matchUnsigned;
    }
    function computeErasParse() {
        var abbrPieces = [], namePieces = [], narrowPieces = [], mixedPieces = [], i, l, eras = this.eras();
        for(i = 0, l = eras.length; i < l; ++i){
            namePieces.push(regexEscape(eras[i].name));
            abbrPieces.push(regexEscape(eras[i].abbr));
            narrowPieces.push(regexEscape(eras[i].narrow));
            mixedPieces.push(regexEscape(eras[i].name));
            mixedPieces.push(regexEscape(eras[i].abbr));
            mixedPieces.push(regexEscape(eras[i].narrow));
        }
        this._erasRegex = new RegExp("^(" + mixedPieces.join("|") + ")", "i");
        this._erasNameRegex = new RegExp("^(" + namePieces.join("|") + ")", "i");
        this._erasAbbrRegex = new RegExp("^(" + abbrPieces.join("|") + ")", "i");
        this._erasNarrowRegex = new RegExp("^(" + narrowPieces.join("|") + ")", "i");
    }
    // FORMATTING
    addFormatToken(0, [
        "gg",
        2
    ], 0, function() {
        return this.weekYear() % 100;
    });
    addFormatToken(0, [
        "GG",
        2
    ], 0, function() {
        return this.isoWeekYear() % 100;
    });
    function addWeekYearFormatToken(token, getter) {
        addFormatToken(0, [
            token,
            token.length
        ], 0, getter);
    }
    addWeekYearFormatToken("gggg", "weekYear");
    addWeekYearFormatToken("ggggg", "weekYear");
    addWeekYearFormatToken("GGGG", "isoWeekYear");
    addWeekYearFormatToken("GGGGG", "isoWeekYear");
    // ALIASES
    addUnitAlias("weekYear", "gg");
    addUnitAlias("isoWeekYear", "GG");
    // PRIORITY
    addUnitPriority("weekYear", 1);
    addUnitPriority("isoWeekYear", 1);
    // PARSING
    addRegexToken("G", matchSigned);
    addRegexToken("g", matchSigned);
    addRegexToken("GG", match1to2, match2);
    addRegexToken("gg", match1to2, match2);
    addRegexToken("GGGG", match1to4, match4);
    addRegexToken("gggg", match1to4, match4);
    addRegexToken("GGGGG", match1to6, match6);
    addRegexToken("ggggg", match1to6, match6);
    addWeekParseToken([
        "gggg",
        "ggggg",
        "GGGG",
        "GGGGG"
    ], function(input, week, config, token) {
        week[token.substr(0, 2)] = toInt(input);
    });
    addWeekParseToken([
        "gg",
        "GG"
    ], function(input, week, config, token) {
        week[token] = hooks.parseTwoDigitYear(input);
    });
    // MOMENTS
    function getSetWeekYear(input) {
        return getSetWeekYearHelper.call(this, input, this.week(), this.weekday(), this.localeData()._week.dow, this.localeData()._week.doy);
    }
    function getSetISOWeekYear(input) {
        return getSetWeekYearHelper.call(this, input, this.isoWeek(), this.isoWeekday(), 1, 4);
    }
    function getISOWeeksInYear() {
        return weeksInYear(this.year(), 1, 4);
    }
    function getISOWeeksInISOWeekYear() {
        return weeksInYear(this.isoWeekYear(), 1, 4);
    }
    function getWeeksInYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
    }
    function getWeeksInWeekYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.weekYear(), weekInfo.dow, weekInfo.doy);
    }
    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
        var weeksTarget;
        if (input == null) return weekOfYear(this, dow, doy).year;
        else {
            weeksTarget = weeksInYear(input, dow, doy);
            if (week > weeksTarget) week = weeksTarget;
            return setWeekAll.call(this, input, week, weekday, dow, doy);
        }
    }
    function setWeekAll(weekYear, week, weekday, dow, doy) {
        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy), date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);
        this.year(date.getUTCFullYear());
        this.month(date.getUTCMonth());
        this.date(date.getUTCDate());
        return this;
    }
    // FORMATTING
    addFormatToken("Q", 0, "Qo", "quarter");
    // ALIASES
    addUnitAlias("quarter", "Q");
    // PRIORITY
    addUnitPriority("quarter", 7);
    // PARSING
    addRegexToken("Q", match1);
    addParseToken("Q", function(input, array) {
        array[MONTH] = (toInt(input) - 1) * 3;
    });
    // MOMENTS
    function getSetQuarter(input) {
        return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
    }
    // FORMATTING
    addFormatToken("D", [
        "DD",
        2
    ], "Do", "date");
    // ALIASES
    addUnitAlias("date", "D");
    // PRIORITY
    addUnitPriority("date", 9);
    // PARSING
    addRegexToken("D", match1to2);
    addRegexToken("DD", match1to2, match2);
    addRegexToken("Do", function(isStrict, locale) {
        // TODO: Remove "ordinalParse" fallback in next major release.
        return isStrict ? locale._dayOfMonthOrdinalParse || locale._ordinalParse : locale._dayOfMonthOrdinalParseLenient;
    });
    addParseToken([
        "D",
        "DD"
    ], DATE);
    addParseToken("Do", function(input, array) {
        array[DATE] = toInt(input.match(match1to2)[0]);
    });
    // MOMENTS
    var getSetDayOfMonth = makeGetSet("Date", true);
    // FORMATTING
    addFormatToken("DDD", [
        "DDDD",
        3
    ], "DDDo", "dayOfYear");
    // ALIASES
    addUnitAlias("dayOfYear", "DDD");
    // PRIORITY
    addUnitPriority("dayOfYear", 4);
    // PARSING
    addRegexToken("DDD", match1to3);
    addRegexToken("DDDD", match3);
    addParseToken([
        "DDD",
        "DDDD"
    ], function(input, array, config) {
        config._dayOfYear = toInt(input);
    });
    // HELPERS
    // MOMENTS
    function getSetDayOfYear(input) {
        var dayOfYear = Math.round((this.clone().startOf("day") - this.clone().startOf("year")) / 864e5) + 1;
        return input == null ? dayOfYear : this.add(input - dayOfYear, "d");
    }
    // FORMATTING
    addFormatToken("m", [
        "mm",
        2
    ], 0, "minute");
    // ALIASES
    addUnitAlias("minute", "m");
    // PRIORITY
    addUnitPriority("minute", 14);
    // PARSING
    addRegexToken("m", match1to2);
    addRegexToken("mm", match1to2, match2);
    addParseToken([
        "m",
        "mm"
    ], MINUTE);
    // MOMENTS
    var getSetMinute = makeGetSet("Minutes", false);
    // FORMATTING
    addFormatToken("s", [
        "ss",
        2
    ], 0, "second");
    // ALIASES
    addUnitAlias("second", "s");
    // PRIORITY
    addUnitPriority("second", 15);
    // PARSING
    addRegexToken("s", match1to2);
    addRegexToken("ss", match1to2, match2);
    addParseToken([
        "s",
        "ss"
    ], SECOND);
    // MOMENTS
    var getSetSecond = makeGetSet("Seconds", false);
    // FORMATTING
    addFormatToken("S", 0, 0, function() {
        return ~~(this.millisecond() / 100);
    });
    addFormatToken(0, [
        "SS",
        2
    ], 0, function() {
        return ~~(this.millisecond() / 10);
    });
    addFormatToken(0, [
        "SSS",
        3
    ], 0, "millisecond");
    addFormatToken(0, [
        "SSSS",
        4
    ], 0, function() {
        return this.millisecond() * 10;
    });
    addFormatToken(0, [
        "SSSSS",
        5
    ], 0, function() {
        return this.millisecond() * 100;
    });
    addFormatToken(0, [
        "SSSSSS",
        6
    ], 0, function() {
        return this.millisecond() * 1000;
    });
    addFormatToken(0, [
        "SSSSSSS",
        7
    ], 0, function() {
        return this.millisecond() * 10000;
    });
    addFormatToken(0, [
        "SSSSSSSS",
        8
    ], 0, function() {
        return this.millisecond() * 100000;
    });
    addFormatToken(0, [
        "SSSSSSSSS",
        9
    ], 0, function() {
        return this.millisecond() * 1000000;
    });
    // ALIASES
    addUnitAlias("millisecond", "ms");
    // PRIORITY
    addUnitPriority("millisecond", 16);
    // PARSING
    addRegexToken("S", match1to3, match1);
    addRegexToken("SS", match1to3, match2);
    addRegexToken("SSS", match1to3, match3);
    var token, getSetMillisecond;
    for(token = "SSSS"; token.length <= 9; token += "S")addRegexToken(token, matchUnsigned);
    function parseMs(input, array) {
        array[MILLISECOND] = toInt(("0." + input) * 1000);
    }
    for(token = "S"; token.length <= 9; token += "S")addParseToken(token, parseMs);
    getSetMillisecond = makeGetSet("Milliseconds", false);
    // FORMATTING
    addFormatToken("z", 0, 0, "zoneAbbr");
    addFormatToken("zz", 0, 0, "zoneName");
    // MOMENTS
    function getZoneAbbr() {
        return this._isUTC ? "UTC" : "";
    }
    function getZoneName() {
        return this._isUTC ? "Coordinated Universal Time" : "";
    }
    var proto = Moment.prototype;
    proto.add = add;
    proto.calendar = calendar$1;
    proto.clone = clone;
    proto.diff = diff;
    proto.endOf = endOf;
    proto.format = format;
    proto.from = from;
    proto.fromNow = fromNow;
    proto.to = to;
    proto.toNow = toNow;
    proto.get = stringGet;
    proto.invalidAt = invalidAt;
    proto.isAfter = isAfter;
    proto.isBefore = isBefore;
    proto.isBetween = isBetween;
    proto.isSame = isSame;
    proto.isSameOrAfter = isSameOrAfter;
    proto.isSameOrBefore = isSameOrBefore;
    proto.isValid = isValid$2;
    proto.lang = lang;
    proto.locale = locale;
    proto.localeData = localeData;
    proto.max = prototypeMax;
    proto.min = prototypeMin;
    proto.parsingFlags = parsingFlags;
    proto.set = stringSet;
    proto.startOf = startOf;
    proto.subtract = subtract;
    proto.toArray = toArray;
    proto.toObject = toObject;
    proto.toDate = toDate;
    proto.toISOString = toISOString;
    proto.inspect = inspect;
    if (typeof Symbol !== "undefined" && Symbol.for != null) proto[Symbol.for("nodejs.util.inspect.custom")] = function() {
        return "Moment<" + this.format() + ">";
    };
    proto.toJSON = toJSON;
    proto.toString = toString;
    proto.unix = unix;
    proto.valueOf = valueOf;
    proto.creationData = creationData;
    proto.eraName = getEraName;
    proto.eraNarrow = getEraNarrow;
    proto.eraAbbr = getEraAbbr;
    proto.eraYear = getEraYear;
    proto.year = getSetYear;
    proto.isLeapYear = getIsLeapYear;
    proto.weekYear = getSetWeekYear;
    proto.isoWeekYear = getSetISOWeekYear;
    proto.quarter = proto.quarters = getSetQuarter;
    proto.month = getSetMonth;
    proto.daysInMonth = getDaysInMonth;
    proto.week = proto.weeks = getSetWeek;
    proto.isoWeek = proto.isoWeeks = getSetISOWeek;
    proto.weeksInYear = getWeeksInYear;
    proto.weeksInWeekYear = getWeeksInWeekYear;
    proto.isoWeeksInYear = getISOWeeksInYear;
    proto.isoWeeksInISOWeekYear = getISOWeeksInISOWeekYear;
    proto.date = getSetDayOfMonth;
    proto.day = proto.days = getSetDayOfWeek;
    proto.weekday = getSetLocaleDayOfWeek;
    proto.isoWeekday = getSetISODayOfWeek;
    proto.dayOfYear = getSetDayOfYear;
    proto.hour = proto.hours = getSetHour;
    proto.minute = proto.minutes = getSetMinute;
    proto.second = proto.seconds = getSetSecond;
    proto.millisecond = proto.milliseconds = getSetMillisecond;
    proto.utcOffset = getSetOffset;
    proto.utc = setOffsetToUTC;
    proto.local = setOffsetToLocal;
    proto.parseZone = setOffsetToParsedOffset;
    proto.hasAlignedHourOffset = hasAlignedHourOffset;
    proto.isDST = isDaylightSavingTime;
    proto.isLocal = isLocal;
    proto.isUtcOffset = isUtcOffset;
    proto.isUtc = isUtc;
    proto.isUTC = isUtc;
    proto.zoneAbbr = getZoneAbbr;
    proto.zoneName = getZoneName;
    proto.dates = deprecate("dates accessor is deprecated. Use date instead.", getSetDayOfMonth);
    proto.months = deprecate("months accessor is deprecated. Use month instead", getSetMonth);
    proto.years = deprecate("years accessor is deprecated. Use year instead", getSetYear);
    proto.zone = deprecate("moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/", getSetZone);
    proto.isDSTShifted = deprecate("isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information", isDaylightSavingTimeShifted);
    function createUnix(input) {
        return createLocal(input * 1000);
    }
    function createInZone() {
        return createLocal.apply(null, arguments).parseZone();
    }
    function preParsePostFormat(string) {
        return string;
    }
    var proto$1 = Locale.prototype;
    proto$1.calendar = calendar;
    proto$1.longDateFormat = longDateFormat;
    proto$1.invalidDate = invalidDate;
    proto$1.ordinal = ordinal;
    proto$1.preparse = preParsePostFormat;
    proto$1.postformat = preParsePostFormat;
    proto$1.relativeTime = relativeTime;
    proto$1.pastFuture = pastFuture;
    proto$1.set = set;
    proto$1.eras = localeEras;
    proto$1.erasParse = localeErasParse;
    proto$1.erasConvertYear = localeErasConvertYear;
    proto$1.erasAbbrRegex = erasAbbrRegex;
    proto$1.erasNameRegex = erasNameRegex;
    proto$1.erasNarrowRegex = erasNarrowRegex;
    proto$1.months = localeMonths;
    proto$1.monthsShort = localeMonthsShort;
    proto$1.monthsParse = localeMonthsParse;
    proto$1.monthsRegex = monthsRegex;
    proto$1.monthsShortRegex = monthsShortRegex;
    proto$1.week = localeWeek;
    proto$1.firstDayOfYear = localeFirstDayOfYear;
    proto$1.firstDayOfWeek = localeFirstDayOfWeek;
    proto$1.weekdays = localeWeekdays;
    proto$1.weekdaysMin = localeWeekdaysMin;
    proto$1.weekdaysShort = localeWeekdaysShort;
    proto$1.weekdaysParse = localeWeekdaysParse;
    proto$1.weekdaysRegex = weekdaysRegex;
    proto$1.weekdaysShortRegex = weekdaysShortRegex;
    proto$1.weekdaysMinRegex = weekdaysMinRegex;
    proto$1.isPM = localeIsPM;
    proto$1.meridiem = localeMeridiem;
    function get$1(format, index, field, setter) {
        var locale = getLocale(), utc = createUTC().set(setter, index);
        return locale[field](utc, format);
    }
    function listMonthsImpl(format, index, field) {
        if (isNumber(format)) {
            index = format;
            format = undefined;
        }
        format = format || "";
        if (index != null) return get$1(format, index, field, "month");
        var i, out = [];
        for(i = 0; i < 12; i++)out[i] = get$1(format, i, field, "month");
        return out;
    }
    // ()
    // (5)
    // (fmt, 5)
    // (fmt)
    // (true)
    // (true, 5)
    // (true, fmt, 5)
    // (true, fmt)
    function listWeekdaysImpl(localeSorted, format, index, field) {
        if (typeof localeSorted === "boolean") {
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }
            format = format || "";
        } else {
            format = localeSorted;
            index = format;
            localeSorted = false;
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }
            format = format || "";
        }
        var locale = getLocale(), shift = localeSorted ? locale._week.dow : 0, i, out = [];
        if (index != null) return get$1(format, (index + shift) % 7, field, "day");
        for(i = 0; i < 7; i++)out[i] = get$1(format, (i + shift) % 7, field, "day");
        return out;
    }
    function listMonths(format, index) {
        return listMonthsImpl(format, index, "months");
    }
    function listMonthsShort(format, index) {
        return listMonthsImpl(format, index, "monthsShort");
    }
    function listWeekdays(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, "weekdays");
    }
    function listWeekdaysShort(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, "weekdaysShort");
    }
    function listWeekdaysMin(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, "weekdaysMin");
    }
    getSetGlobalLocale("en", {
        eras: [
            {
                since: "0001-01-01",
                until: Infinity,
                offset: 1,
                name: "Anno Domini",
                narrow: "AD",
                abbr: "AD"
            },
            {
                since: "0000-12-31",
                until: -Infinity,
                offset: 1,
                name: "Before Christ",
                narrow: "BC",
                abbr: "BC"
            }
        ],
        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
        ordinal: function(number) {
            var b = number % 10, output = toInt(number % 100 / 10) === 1 ? "th" : b === 1 ? "st" : b === 2 ? "nd" : b === 3 ? "rd" : "th";
            return number + output;
        }
    });
    // Side effect imports
    hooks.lang = deprecate("moment.lang is deprecated. Use moment.locale instead.", getSetGlobalLocale);
    hooks.langData = deprecate("moment.langData is deprecated. Use moment.localeData instead.", getLocale);
    var mathAbs = Math.abs;
    function abs() {
        var data = this._data;
        this._milliseconds = mathAbs(this._milliseconds);
        this._days = mathAbs(this._days);
        this._months = mathAbs(this._months);
        data.milliseconds = mathAbs(data.milliseconds);
        data.seconds = mathAbs(data.seconds);
        data.minutes = mathAbs(data.minutes);
        data.hours = mathAbs(data.hours);
        data.months = mathAbs(data.months);
        data.years = mathAbs(data.years);
        return this;
    }
    function addSubtract$1(duration, input, value, direction) {
        var other = createDuration(input, value);
        duration._milliseconds += direction * other._milliseconds;
        duration._days += direction * other._days;
        duration._months += direction * other._months;
        return duration._bubble();
    }
    // supports only 2.0-style add(1, 's') or add(duration)
    function add$1(input, value) {
        return addSubtract$1(this, input, value, 1);
    }
    // supports only 2.0-style subtract(1, 's') or subtract(duration)
    function subtract$1(input, value) {
        return addSubtract$1(this, input, value, -1);
    }
    function absCeil(number) {
        if (number < 0) return Math.floor(number);
        else return Math.ceil(number);
    }
    function bubble() {
        var milliseconds = this._milliseconds, days = this._days, months = this._months, data = this._data, seconds, minutes, hours, years, monthsFromDays;
        // if we have a mix of positive and negative values, bubble down first
        // check: https://github.com/moment/moment/issues/2166
        if (!(milliseconds >= 0 && days >= 0 && months >= 0 || milliseconds <= 0 && days <= 0 && months <= 0)) {
            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
            days = 0;
            months = 0;
        }
        // The following code bubbles up values, see the tests for
        // examples of what that means.
        data.milliseconds = milliseconds % 1000;
        seconds = absFloor(milliseconds / 1000);
        data.seconds = seconds % 60;
        minutes = absFloor(seconds / 60);
        data.minutes = minutes % 60;
        hours = absFloor(minutes / 60);
        data.hours = hours % 24;
        days += absFloor(hours / 24);
        // convert days to months
        monthsFromDays = absFloor(daysToMonths(days));
        months += monthsFromDays;
        days -= absCeil(monthsToDays(monthsFromDays));
        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;
        data.days = days;
        data.months = months;
        data.years = years;
        return this;
    }
    function daysToMonths(days) {
        // 400 years have 146097 days (taking into account leap year rules)
        // 400 years have 12 months === 4800
        return days * 4800 / 146097;
    }
    function monthsToDays(months) {
        // the reverse of daysToMonths
        return months * 146097 / 4800;
    }
    function as(units) {
        if (!this.isValid()) return NaN;
        var days, months, milliseconds = this._milliseconds;
        units = normalizeUnits(units);
        if (units === "month" || units === "quarter" || units === "year") {
            days = this._days + milliseconds / 864e5;
            months = this._months + daysToMonths(days);
            switch(units){
                case "month":
                    return months;
                case "quarter":
                    return months / 3;
                case "year":
                    return months / 12;
            }
        } else {
            // handle milliseconds separately because of floating point math errors (issue #1867)
            days = this._days + Math.round(monthsToDays(this._months));
            switch(units){
                case "week":
                    return days / 7 + milliseconds / 6048e5;
                case "day":
                    return days + milliseconds / 864e5;
                case "hour":
                    return days * 24 + milliseconds / 36e5;
                case "minute":
                    return days * 1440 + milliseconds / 6e4;
                case "second":
                    return days * 86400 + milliseconds / 1000;
                // Math.floor prevents floating point math errors here
                case "millisecond":
                    return Math.floor(days * 864e5) + milliseconds;
                default:
                    throw new Error("Unknown unit " + units);
            }
        }
    }
    // TODO: Use this.as('ms')?
    function valueOf$1() {
        if (!this.isValid()) return NaN;
        return this._milliseconds + this._days * 864e5 + this._months % 12 * 2592e6 + toInt(this._months / 12) * 31536e6;
    }
    function makeAs(alias) {
        return function() {
            return this.as(alias);
        };
    }
    var asMilliseconds = makeAs("ms"), asSeconds = makeAs("s"), asMinutes = makeAs("m"), asHours = makeAs("h"), asDays = makeAs("d"), asWeeks = makeAs("w"), asMonths = makeAs("M"), asQuarters = makeAs("Q"), asYears = makeAs("y");
    function clone$1() {
        return createDuration(this);
    }
    function get$2(units) {
        units = normalizeUnits(units);
        return this.isValid() ? this[units + "s"]() : NaN;
    }
    function makeGetter(name) {
        return function() {
            return this.isValid() ? this._data[name] : NaN;
        };
    }
    var milliseconds = makeGetter("milliseconds"), seconds = makeGetter("seconds"), minutes = makeGetter("minutes"), hours = makeGetter("hours"), days = makeGetter("days"), months = makeGetter("months"), years = makeGetter("years");
    function weeks() {
        return absFloor(this.days() / 7);
    }
    var round = Math.round, thresholds = {
        ss: 44,
        s: 45,
        m: 45,
        h: 22,
        d: 26,
        w: null,
        M: 11
    };
    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
    }
    function relativeTime$1(posNegDuration, withoutSuffix, thresholds, locale) {
        var duration = createDuration(posNegDuration).abs(), seconds = round(duration.as("s")), minutes = round(duration.as("m")), hours = round(duration.as("h")), days = round(duration.as("d")), months = round(duration.as("M")), weeks = round(duration.as("w")), years = round(duration.as("y")), a = seconds <= thresholds.ss && [
            "s",
            seconds
        ] || seconds < thresholds.s && [
            "ss",
            seconds
        ] || minutes <= 1 && [
            "m"
        ] || minutes < thresholds.m && [
            "mm",
            minutes
        ] || hours <= 1 && [
            "h"
        ] || hours < thresholds.h && [
            "hh",
            hours
        ] || days <= 1 && [
            "d"
        ] || days < thresholds.d && [
            "dd",
            days
        ];
        if (thresholds.w != null) a = a || weeks <= 1 && [
            "w"
        ] || weeks < thresholds.w && [
            "ww",
            weeks
        ];
        a = a || months <= 1 && [
            "M"
        ] || months < thresholds.M && [
            "MM",
            months
        ] || years <= 1 && [
            "y"
        ] || [
            "yy",
            years
        ];
        a[2] = withoutSuffix;
        a[3] = +posNegDuration > 0;
        a[4] = locale;
        return substituteTimeAgo.apply(null, a);
    }
    // This function allows you to set the rounding function for relative time strings
    function getSetRelativeTimeRounding(roundingFunction) {
        if (roundingFunction === undefined) return round;
        if (typeof roundingFunction === "function") {
            round = roundingFunction;
            return true;
        }
        return false;
    }
    // This function allows you to set a threshold for relative time strings
    function getSetRelativeTimeThreshold(threshold, limit) {
        if (thresholds[threshold] === undefined) return false;
        if (limit === undefined) return thresholds[threshold];
        thresholds[threshold] = limit;
        if (threshold === "s") thresholds.ss = limit - 1;
        return true;
    }
    function humanize(argWithSuffix, argThresholds) {
        if (!this.isValid()) return this.localeData().invalidDate();
        var withSuffix = false, th = thresholds, locale, output;
        if (typeof argWithSuffix === "object") {
            argThresholds = argWithSuffix;
            argWithSuffix = false;
        }
        if (typeof argWithSuffix === "boolean") withSuffix = argWithSuffix;
        if (typeof argThresholds === "object") {
            th = Object.assign({}, thresholds, argThresholds);
            if (argThresholds.s != null && argThresholds.ss == null) th.ss = argThresholds.s - 1;
        }
        locale = this.localeData();
        output = relativeTime$1(this, !withSuffix, th, locale);
        if (withSuffix) output = locale.pastFuture(+this, output);
        return locale.postformat(output);
    }
    var abs$1 = Math.abs;
    function sign(x) {
        return (x > 0) - (x < 0) || +x;
    }
    function toISOString$1() {
        // for ISO strings we do not use the normal bubbling rules:
        //  * milliseconds bubble up until they become hours
        //  * days do not bubble at all
        //  * months bubble up until they become years
        // This is because there is no context-free conversion between hours and days
        // (think of clock changes)
        // and also not between days and months (28-31 days per month)
        if (!this.isValid()) return this.localeData().invalidDate();
        var seconds = abs$1(this._milliseconds) / 1000, days = abs$1(this._days), months = abs$1(this._months), minutes, hours, years, s, total = this.asSeconds(), totalSign, ymSign, daysSign, hmsSign;
        if (!total) // this is the same as C#'s (Noda) and python (isodate)...
        // but not other JS (goog.date)
        return "P0D";
        // 3600 seconds -> 60 minutes -> 1 hour
        minutes = absFloor(seconds / 60);
        hours = absFloor(minutes / 60);
        seconds %= 60;
        minutes %= 60;
        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;
        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
        s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, "") : "";
        totalSign = total < 0 ? "-" : "";
        ymSign = sign(this._months) !== sign(total) ? "-" : "";
        daysSign = sign(this._days) !== sign(total) ? "-" : "";
        hmsSign = sign(this._milliseconds) !== sign(total) ? "-" : "";
        return totalSign + "P" + (years ? ymSign + years + "Y" : "") + (months ? ymSign + months + "M" : "") + (days ? daysSign + days + "D" : "") + (hours || minutes || seconds ? "T" : "") + (hours ? hmsSign + hours + "H" : "") + (minutes ? hmsSign + minutes + "M" : "") + (seconds ? hmsSign + s + "S" : "");
    }
    var proto$2 = Duration.prototype;
    proto$2.isValid = isValid$1;
    proto$2.abs = abs;
    proto$2.add = add$1;
    proto$2.subtract = subtract$1;
    proto$2.as = as;
    proto$2.asMilliseconds = asMilliseconds;
    proto$2.asSeconds = asSeconds;
    proto$2.asMinutes = asMinutes;
    proto$2.asHours = asHours;
    proto$2.asDays = asDays;
    proto$2.asWeeks = asWeeks;
    proto$2.asMonths = asMonths;
    proto$2.asQuarters = asQuarters;
    proto$2.asYears = asYears;
    proto$2.valueOf = valueOf$1;
    proto$2._bubble = bubble;
    proto$2.clone = clone$1;
    proto$2.get = get$2;
    proto$2.milliseconds = milliseconds;
    proto$2.seconds = seconds;
    proto$2.minutes = minutes;
    proto$2.hours = hours;
    proto$2.days = days;
    proto$2.weeks = weeks;
    proto$2.months = months;
    proto$2.years = years;
    proto$2.humanize = humanize;
    proto$2.toISOString = toISOString$1;
    proto$2.toString = toISOString$1;
    proto$2.toJSON = toISOString$1;
    proto$2.locale = locale;
    proto$2.localeData = localeData;
    proto$2.toIsoString = deprecate("toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)", toISOString$1);
    proto$2.lang = lang;
    // FORMATTING
    addFormatToken("X", 0, 0, "unix");
    addFormatToken("x", 0, 0, "valueOf");
    // PARSING
    addRegexToken("x", matchSigned);
    addRegexToken("X", matchTimestamp);
    addParseToken("X", function(input, array, config) {
        config._d = new Date(parseFloat(input) * 1000);
    });
    addParseToken("x", function(input, array, config) {
        config._d = new Date(toInt(input));
    });
    //! moment.js
    hooks.version = "2.29.4";
    setHookCallback(createLocal);
    hooks.fn = proto;
    hooks.min = min;
    hooks.max = max;
    hooks.now = now;
    hooks.utc = createUTC;
    hooks.unix = createUnix;
    hooks.months = listMonths;
    hooks.isDate = isDate;
    hooks.locale = getSetGlobalLocale;
    hooks.invalid = createInvalid;
    hooks.duration = createDuration;
    hooks.isMoment = isMoment;
    hooks.weekdays = listWeekdays;
    hooks.parseZone = createInZone;
    hooks.localeData = getLocale;
    hooks.isDuration = isDuration;
    hooks.monthsShort = listMonthsShort;
    hooks.weekdaysMin = listWeekdaysMin;
    hooks.defineLocale = defineLocale;
    hooks.updateLocale = updateLocale;
    hooks.locales = listLocales;
    hooks.weekdaysShort = listWeekdaysShort;
    hooks.normalizeUnits = normalizeUnits;
    hooks.relativeTimeRounding = getSetRelativeTimeRounding;
    hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
    hooks.calendarFormat = getCalendarFormat;
    hooks.prototype = proto;
    // currently HTML5 input type only supports 24-hour formats
    hooks.HTML5_FMT = {
        DATETIME_LOCAL: "YYYY-MM-DDTHH:mm",
        DATETIME_LOCAL_SECONDS: "YYYY-MM-DDTHH:mm:ss",
        DATETIME_LOCAL_MS: "YYYY-MM-DDTHH:mm:ss.SSS",
        DATE: "YYYY-MM-DD",
        TIME: "HH:mm",
        TIME_SECONDS: "HH:mm:ss",
        TIME_MS: "HH:mm:ss.SSS",
        WEEK: "GGGG-[W]WW",
        MONTH: "YYYY-MM"
    };
    return hooks;
});

},{}],"k0Bys":[function(require,module,exports) {
module.exports = require("a42ec4efa54320c1").getBundleURL("kVLro") + require("2c090dc62e7b46ff").resolve("lQU7W");

},{"a42ec4efa54320c1":"c7Tr5","2c090dc62e7b46ff":"fyJL2"}],"euMUu":[function(require,module,exports) {
module.exports = require("e89246f3c3dad2cc").getBundleURL("kVLro") + require("578a197cf50e3cdd").resolve("e2sFD");

},{"e89246f3c3dad2cc":"c7Tr5","578a197cf50e3cdd":"fyJL2"}],"koblr":[function(require,module,exports) {
module.exports = require("6b935b9cf17b3aa9").getBundleURL("kVLro") + require("302e45d33c2a1a03").resolve("844gv");

},{"6b935b9cf17b3aa9":"c7Tr5","302e45d33c2a1a03":"fyJL2"}],"jMadF":[function(require,module,exports) {
module.exports = require("90cef9c768229a22").getBundleURL("kVLro") + require("7af1f289d764f96b").resolve("2ZIRr");

},{"90cef9c768229a22":"c7Tr5","7af1f289d764f96b":"fyJL2"}],"7hamt":[function(require,module,exports) {
module.exports = require("6ff3e0ffaa0d5ebe").getBundleURL("kVLro") + require("2f4636bb0ae8a309").resolve("VSslQ");

},{"6ff3e0ffaa0d5ebe":"c7Tr5","2f4636bb0ae8a309":"fyJL2"}],"elIoY":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _colors = require("../../constants/colors");
const alertTriangle = require("7305b9a0b7989b8");
const containerStyle = /*#__PURE__*/ (0, _css.css)("display:flex;flex-direction:column;align-items:center;justify-content:center;margin:64px;img{width:82px;height:82px;margin-bottom:32px;}p{font-family:Muli;font-size:18px;font-weight:normal;font-style:normal;font-stretch:normal;line-height:normal;letter-spacing:0.5px;text-align:center;color:", (0, _colors.dark_grey_blue), ";}", "");
const RemoveConfirmation = (props)=>(0, _react.jsx)("div", {
        className: containerStyle
    }, props.showImage === undefined || props.showImage === true ? (0, _react.jsx)("img", {
        src: alertTriangle
    }) : null, props.customText === undefined ? (0, _react.jsx)("p", null, "Are you sure you want to remove", (0, _react.jsx)("b", null, " ", props.memberName, " "), "from ", props.removalTarget ?? "this organization", "?") : props.customText);
exports.default = RemoveConfirmation;

},{"@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","../../constants/colors":"1p3OR","7305b9a0b7989b8":"4UkG2","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4UkG2":[function(require,module,exports) {
module.exports = require("83d5c13595b9e020").getBundleURL("kVLro") + require("1e9790c7d21b809b").resolve("8X7GP");

},{"83d5c13595b9e020":"c7Tr5","1e9790c7d21b809b":"fyJL2"}],"ja9KM":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _colors = require("../../../constants/colors");
var _moment = require("moment");
var _momentDefault = parcelHelpers.interopDefault(_moment);
const audioIcon = require("2ab92e257175cff8");
const videoIcon = require("84867c0b626278e3");
const attachIcon = require("b85759649c27df0d");
const restoreIcon = require("add24340b82efec0");
class MediaGridPreview extends (0, _reactDefault.default).Component {
    renderMediaPreview(item) {
        switch(item.mediaType){
            case "AudioFile":
                return (0, _react.jsx)("img", {
                    src: audioIcon
                });
            case "VideoFile":
                return (0, _react.jsx)("img", {
                    src: videoIcon
                });
            case "ImageFile":
            default:
                return (0, _react.jsx)("img", {
                    src: item.url
                });
        }
    }
    render() {
        const item = this.props.item;
        const nameString = item.name.length > 25 ? item.name.substring(0, 13) + "..." + item.name.substring(item.name.length - 10, item.name.length) : item.name;
        const dateString = (0, _momentDefault.default)(item.modifiedDate).format("MMM DD, YYYY");
        return (0, _react.jsx)("div", {
            key: item.id,
            className: `${containerStyle} _${this.props.column}`
        }, (0, _react.jsx)("div", {
            onClick: (e)=>{
                this.props.attachMediaItem(item);
                e.stopPropagation();
            },
            className: "attach"
        }, (0, _react.jsx)("img", {
            src: item.isDisabled ? restoreIcon : attachIcon
        })), (0, _react.jsx)("div", {
            className: "image"
        }, (0, _react.jsx)("div", {
            className: "col"
        }, this.renderMediaPreview(item))), (0, _react.jsx)("div", {
            className: "name text"
        }, nameString), (0, _react.jsx)("div", {
            className: "date text"
        }, dateString));
    }
}
const containerStyle = /*#__PURE__*/ (0, _css.css)("border-radius:4px;border:solid 1px #cccccc;box-shadow:0 2px 4px 0 rgba(50, 70, 97, 0.1);padding:16px;flex-direction:column;cursor:pointer;position:relative;margin:16px;text-align:left;&._0{margin-left:0px;}&._1{margin-right:0px;}.name.text{color:", (0, _colors.dark_grey_blue), ";}.date.text{color:", (0, _colors.color_shades_darker), ";font-size:12px;}.text{padding-top:5px;text-align:left;font-family:Muli;width:100%;word-wrap:break-word;}.attach{z-index:90;width:35px;height:35px;position:absolute;top:25px;right:25px;background:rgba(255,255,255,.7);border-radius:50%;img{z-index:100;padding-top:5px;padding-left:5px;}}.image{width:100%;height:0px;background:black;padding-bottom:75%;position:relative;.col{position:absolute;top:0;left:0;height:100%;width:100%;justify-content:center;text-align:center;display:flex;flex-direction:column;img{max-height:100%;max-width:100%;min-height:100px;object-fit:contain;}}}", "");
exports.default = MediaGridPreview;

},{"@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","../../../constants/colors":"1p3OR","moment":"2meyw","2ab92e257175cff8":"5iZBB","84867c0b626278e3":"hx9zt","b85759649c27df0d":"iT0Wx","add24340b82efec0":"jMadF","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"5iZBB":[function(require,module,exports) {
module.exports = require("41abf024c76de2fd").getBundleURL("kVLro") + require("28546be6165d3d59").resolve("fmEJw");

},{"41abf024c76de2fd":"c7Tr5","28546be6165d3d59":"fyJL2"}],"hx9zt":[function(require,module,exports) {
module.exports = require("8672491d4a57109c").getBundleURL("kVLro") + require("305561a763e2cc1b").resolve("bykNQ");

},{"8672491d4a57109c":"c7Tr5","305561a763e2cc1b":"fyJL2"}],"dZ4mZ":[function(require,module,exports) {
module.exports = require("57ee96b94b32d5ee").getBundleURL("kVLro") + require("7acfaca9c8620d7b").resolve("4QZqZ");

},{"57ee96b94b32d5ee":"c7Tr5","7acfaca9c8620d7b":"fyJL2"}],"ffCq8":[function(require,module,exports) {
module.exports = require("ba45f6c85c9dca30").getBundleURL("kVLro") + require("5f5e3bcfcb1f096b").resolve("adL52");

},{"ba45f6c85c9dca30":"c7Tr5","5f5e3bcfcb1f096b":"fyJL2"}],"4Elru":[function(require,module,exports) {
module.exports = require("d9c347b47c9c8877").getBundleURL("kVLro") + require("88b5dc400b7118fc").resolve("gICJv");

},{"d9c347b47c9c8877":"c7Tr5","88b5dc400b7118fc":"fyJL2"}],"a90NN":[function(require,module,exports) {
module.exports = require("46d6761b2443440").getBundleURL("kVLro") + require("5d0f4f5aabca1db5").resolve("dNanN");

},{"46d6761b2443440":"c7Tr5","5d0f4f5aabca1db5":"fyJL2"}],"2nj1V":[function(require,module,exports) {
module.exports = require("5f613d2e8f41d865").getBundleURL("kVLro") + require("642cf9f272bf0f8f").resolve("eeMYe");

},{"5f613d2e8f41d865":"c7Tr5","642cf9f272bf0f8f":"fyJL2"}],"9pEQA":[function(require,module,exports) {
module.exports = require("c9f2530b0a868081").getBundleURL("kVLro") + require("22a06f1ef472c617").resolve("fWY0A");

},{"c9f2530b0a868081":"c7Tr5","22a06f1ef472c617":"fyJL2"}],"2d2ic":[function(require,module,exports) {
module.exports = require("7c83c2376f405b46").getBundleURL("kVLro") + require("71ee13b98ba654f8").resolve("cjhUZ");

},{"7c83c2376f405b46":"c7Tr5","71ee13b98ba654f8":"fyJL2"}],"9l70Q":[function(require,module,exports) {
module.exports = require("d6bfca8e87fbc7dd").getBundleURL("kVLro") + require("8bc57d2c3e57a096").resolve("1JnDy");

},{"d6bfca8e87fbc7dd":"c7Tr5","8bc57d2c3e57a096":"fyJL2"}],"3WpRa":[function(require,module,exports) {
module.exports = require("92a4612950531064").getBundleURL("kVLro") + require("f9b5c02cc0868e4a").resolve("eqeXZ");

},{"92a4612950531064":"c7Tr5","f9b5c02cc0868e4a":"fyJL2"}],"3u7X8":[function(require,module,exports) {
module.exports = require("3225c713bebf7c18").getBundleURL("kVLro") + require("94841b8af7c74e9f").resolve("3pHHy");

},{"3225c713bebf7c18":"c7Tr5","94841b8af7c74e9f":"fyJL2"}],"2gFpb":[function(require,module,exports) {
module.exports = require("be4d85e50278ab98").getBundleURL("kVLro") + require("acb0ad34d56a6d8b").resolve("k59A5");

},{"be4d85e50278ab98":"c7Tr5","acb0ad34d56a6d8b":"fyJL2"}],"hIp2B":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _colors = require("../../constants/colors");
var _breakpoints = require("../../constants/breakpoints");
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const ModalTitle = (props)=>(0, _react.jsx)("h2", {
        className: `${titleStyle} ${props.padded ? paddedStyle : ""} ${props.noMargin ? noMarginStyle : ""} ${props.subtitleStyle ? noBottomMarginStyle : ""}`
    }, props.children);
const titleStyle = /*#__PURE__*/ (0, _css.css)("font-family:Muli;font-size:24px;color:", (0, _colors.dark_grey_blue), ";font-weight:normal;font-style:normal;font-stretch:normal;line-height:normal;letter-spacing:normal;margin:26px 0;", (0, _breakpoints.breakpoint_small), "{font-size:16px;}", "");
const paddedStyle = /*#__PURE__*/ (0, _css.css)({
    name: "dgqivk",
    styles: "margin:26px"
});
const noMarginStyle = /*#__PURE__*/ (0, _css.css)({
    name: "ti75j2",
    styles: "margin:0"
});
const noBottomMarginStyle = /*#__PURE__*/ (0, _css.css)({
    name: "1ykowef",
    styles: "margin-bottom:0"
});
exports.default = ModalTitle;

},{"@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","../../constants/colors":"1p3OR","../../constants/breakpoints":"2F01A","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1ccrV":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _defineProperty = require("@babel/runtime/helpers/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _unstated = require("unstated");
var _api = require("../../api");
class MediaResponseStateContainer extends (0, _unstated.Container) {
    constructor(...args){
        super(...args);
        // default state
        (0, _definePropertyDefault.default)(this, "state", {
            mediaResponseContainers: [],
            responseTemplates: [],
            isSaving: false,
            isLoading: false,
            errors: [],
            applicationId: "",
            deviceTargets: []
        });
    }
    getMediaResponseContainer(containerId) {
        // if we already have container return it
        const existingContainer = this.state.mediaResponseContainers.find((c)=>c.id == containerId);
        if (existingContainer) return new Promise((resolve)=>{
            resolve({
                data: existingContainer,
                errors: [],
                resultType: "Ok"
            });
        });
        this.setLoading(true);
        var promise = _api.getMediaResponseContainerById(containerId);
        promise.then((result)=>{
            if (result.resultType == "Ok") {
                const containers = this.state.mediaResponseContainers;
                containers.push(result.data);
                this.setState({
                    ...this.state,
                    errors: [],
                    mediaResponseContainers: containers,
                    isLoading: false
                });
            } else this.setState({
                ...this.state,
                errors: result.errors,
                isLoading: false
            });
        }).catch((error)=>{
            this.setState({
                ...this.state,
                errors: [
                    error
                ],
                isLoading: false
            });
        });
        return promise;
    }
    getDeviceTargets() {
        // if we already have targets return them
        if (this.state.deviceTargets.length > 0) return new Promise((resolve)=>{
            resolve({
                data: this.state.deviceTargets,
                errors: [],
                resultType: "Ok"
            });
        });
        this.setLoading(true);
        var promise = _api.getAllDeviceTargets();
        promise.then((result)=>{
            if (result.resultType == "Ok") this.setState({
                ...this.state,
                errors: [],
                deviceTargets: result.data,
                isLoading: false
            });
            else this.setState({
                ...this.state,
                errors: result.errors,
                isLoading: false
            });
        }).catch((error)=>{
            this.setState({
                ...this.state,
                errors: [
                    error
                ],
                isLoading: false
            });
        });
        return promise;
    }
    getResponseTemplates() {
        // if we already have templates return them
        if (this.state.responseTemplates.length > 0) return new Promise((resolve)=>{
            resolve({
                data: this.state.responseTemplates,
                errors: [],
                resultType: "Ok"
            });
        });
        this.setLoading(true);
        var promise = _api.getAllResponseTemplates();
        promise.then((result)=>{
            if (result.resultType == "Ok") this.setState({
                ...this.state,
                errors: [],
                responseTemplates: result.data,
                isLoading: false
            });
            else this.setState({
                ...this.state,
                errors: result.errors,
                isLoading: false
            });
        }).catch((error)=>{
            this.setState({
                ...this.state,
                errors: [
                    error
                ],
                isLoading: false
            });
        });
        return promise;
    }
    createResponseContainer(model) {
        this.setSaving(true);
        var promise = _api.createBulkMediaResponseContainer(model);
        promise.then((result)=>{
            if (result.resultType == "Ok") {
                const containers = this.state.mediaResponseContainers;
                containers.push(result.data);
                this.setState({
                    ...this.state,
                    errors: [],
                    isSaving: false,
                    mediaResponseContainers: containers
                });
            } else this.setState({
                ...this.state,
                isSaving: false,
                errors: result.errors
            });
        }).catch((error)=>{
            this.setState({
                ...this.state,
                isSaving: false,
                errors: [
                    error
                ]
            });
        });
        return promise;
    }
    updateResponseContainer(containerId, model) {
        this.setSaving(true);
        var promise = _api.updateBulkMediaResponseContainer(containerId, model);
        promise.then((result)=>{
            if (result.resultType == "Ok") {
                const containers = this.state.mediaResponseContainers;
                const existingContainer = containers.find((c)=>c.id == containerId);
                if (existingContainer == null) containers.push(result.data);
                else containers[containers.findIndex((c)=>c.id == containerId)] = result.data;
                this.setState({
                    ...this.state,
                    errors: [],
                    isSaving: false,
                    mediaResponseContainers: containers
                });
            } else this.setState({
                ...this.state,
                isSaving: false,
                errors: result.errors
            });
        }).catch((error)=>{
            this.setState({
                ...this.state,
                isSaving: false,
                errors: [
                    error
                ]
            });
        });
        return promise;
    }
    clearErrors() {
        this.setState({
            ...this.state,
            errors: []
        });
    }
    setLoading(isLoading) {
        this.setState({
            ...this.state,
            isLoading
        });
    }
    setSaving(isSaving) {
        this.setState({
            ...this.state,
            isSaving
        });
    }
}
exports.default = MediaResponseStateContainer;

},{"@babel/runtime/helpers/defineProperty":"9sJxO","unstated":"grh7p","../../api":"loxM6","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"kfyfU":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "followUpCardIcon", ()=>followUpCardIcon);
parcelHelpers.export(exports, "ValidFollowUpFeatureTypes", ()=>ValidFollowUpFeatureTypes);
var _extends = require("@babel/runtime/helpers/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _lodash = require("lodash");
var _lodashDefault = parcelHelpers.interopDefault(_lodash);
var _radioCardGroup = require("../../../components/forms/RadioCardGroup");
var _radioCardGroupDefault = parcelHelpers.interopDefault(_radioCardGroup);
var _ssmlField = require("../../../components/forms/SsmlField/SsmlField");
var _ssmlFieldDefault = parcelHelpers.interopDefault(_ssmlField);
var _switch = require("../../../components/forms/Switch");
var _switchDefault = parcelHelpers.interopDefault(_switch);
var _button = require("../../../components/general/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _detailLabel = require("../../../components/general/DetailLabel");
var _detailLabelDefault = parcelHelpers.interopDefault(_detailLabel);
var _pageError = require("../../../components/general/PageError");
var _pageErrorDefault = parcelHelpers.interopDefault(_pageError);
var _secondaryLoader = require("../../../components/general/SecondaryLoader");
var _secondaryLoaderDefault = parcelHelpers.interopDefault(_secondaryLoader);
var _contentCard = require("../../../components/structure/ContentCard");
var _contentCardDefault = parcelHelpers.interopDefault(_contentCard);
var _formFieldsContainer = require("../../../components/structure/FormFieldsContainer");
var _formFieldsContainerDefault = parcelHelpers.interopDefault(_formFieldsContainer);
var _horizontalSeparator = require("../../../components/structure/HorizontalSeparator");
var _horizontalSeparatorDefault = parcelHelpers.interopDefault(_horizontalSeparator);
var _colors = require("../../../constants/colors");
var _featureTypeIds = require("../../../constants/featureTypeIds");
var _contentExplorer = require("../../contentExplorer");
var _contentExplorerDefault = parcelHelpers.interopDefault(_contentExplorer);
var _childItemContainer = require("./ChildItemContainer");
var _childItemContainerDefault = parcelHelpers.interopDefault(_childItemContainer);
var _conversationItemCard = require("./ConversationItemCard");
var _conversationItemCardDefault = parcelHelpers.interopDefault(_conversationItemCard);
var _conversationItemWrapper = require("./ConversationItemWrapper");
var _conversationItemWrapperDefault = parcelHelpers.interopDefault(_conversationItemWrapper);
var _reactBeautifulDnd = require("react-beautiful-dnd");
var _manageImplicitFollowUpForm = require("./ManageImplicitFollowUpForm");
var _manageImplicitFollowUpFormDefault = parcelHelpers.interopDefault(_manageImplicitFollowUpForm);
var _hintField = require("./HintField");
var _hintFieldDefault = parcelHelpers.interopDefault(_hintField);
var _extensions = require("../../../models/extensions");
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const endSessionIcon = require("18c6fee551045438");
const suggestIcon = require("63ef18f458d282c8");
const targetIcon = require("d683b043042d7291");
const addIcon = require("8e490b28f6e0919a");
const clearIcon = require("25488a118b569ca4");
const helpIcon = require("fd3e599b3f94ab2f");
const fallbackIcon = require("f3910937e00917ca");
const hintsIcon = require("a9d5eb76f0c80d38");
const followUpIcon = require("3c39665da3b2161b");
const pinIcon = require("4e989f813ed90d6");
const followUpCardIcon = require("93b774acaa2b5b50");
const ValidFollowUpFeatureTypes = [
    (0, _featureTypeIds.QuestionAnswerFeatureTypeId),
    (0, _featureTypeIds.LatestMessagesFeatureTypeId),
    (0, _featureTypeIds.SimpleChoiceFeatureTypeId),
    (0, _featureTypeIds.NumberRangeFeatureTypeId),
    (0, _featureTypeIds.CustomRequestsFeatureTypeId)
];
class ManageFollowUpForm extends (0, _reactDefault.default).Component {
    hasForceEndSession() {
        return this.props.responseGroup?.responses?.some((response)=>response.forceEndSession === true) || false;
    }
    constructor(props){
        super(props);
        var selectionType = "end";
        // Check if any response has forceEndSession: true, and if so, auto-select endSession
        if (this.hasForceEndSession() && props.showEndSessionOption) selectionType = "endSession";
        else if (props.followUp) selectionType = props.followUp.childContentContainer || props.childContentContainer ? "structured" : "suggest";
        this.state = {
            selection: selectionType,
            isSelectingContent: false,
            currentSlot: null,
            childSlots: this.getInitialChildSlots(),
            helpSlot: this.state?.helpSlot ?? (props.followUp && props.followUp.helpMessageId ? {
                featureTypeIdFilter: (0, _featureTypeIds.HelpMessagesFeatureTypeId),
                title: "Contextual Help Message",
                currentFeatureTypeId: (0, _featureTypeIds.HelpMessagesFeatureTypeId),
                conversationItem: {
                    ...this.props.followUp.helpMessage,
                    featureTypeId: (0, _featureTypeIds.HelpMessagesFeatureTypeId)
                },
                description: ""
            } : null),
            fallbackSlot: this.state?.fallbackSlot ?? (props.followUp && props.followUp.fallbackMessageId ? {
                featureTypeIdFilter: (0, _featureTypeIds.FallbackFeatureTypeId),
                title: "Contextual Fallback Message",
                currentFeatureTypeId: (0, _featureTypeIds.FallbackFeatureTypeId),
                conversationItem: {
                    ...props.followUp.fallbackMessage,
                    featureTypeId: (0, _featureTypeIds.FallbackFeatureTypeId)
                },
                description: ""
            } : null)
        };
    }
    componentDidMount() {
        if (this.props.groupIndex === 0) {
            this.props.featureContainer.getSystemFeatures();
            this.props.featureContainer.getFeaturesForApp(this.props.applicationId);
        }
    }
    componentDidUpdate(prevProps) {
        if (prevProps.followUp != this.props.followUp || prevProps.childContentContainer != this.props.childContentContainer) this.setSelection();
    }
    setSelection() {
        var selectionType = "end";
        // Check if any response has forceEndSession: true, and if so, auto-select endSession
        if (this.hasForceEndSession() && this.props.showEndSessionOption) selectionType = "endSession";
        else if (this.props.followUp) selectionType = this.props.followUp.childContentContainer || this.props.childContentContainer ? "structured" : "suggest";
        this.setState({
            selection: selectionType,
            isSelectingContent: false,
            currentSlot: null,
            childSlots: this.getInitialChildSlots(),
            helpSlot: this.state?.helpSlot ?? (this.props.followUp && this.props.followUp.helpMessageId ? {
                featureTypeIdFilter: (0, _featureTypeIds.HelpMessagesFeatureTypeId),
                title: "Contextual Help Message",
                currentFeatureTypeId: (0, _featureTypeIds.HelpMessagesFeatureTypeId),
                conversationItem: {
                    ...this.props.followUp.helpMessage,
                    featureTypeId: (0, _featureTypeIds.HelpMessagesFeatureTypeId)
                },
                description: ""
            } : null),
            fallbackSlot: this.state?.fallbackSlot ?? (this.props.followUp && this.props.followUp.fallbackMessageId ? {
                featureTypeIdFilter: (0, _featureTypeIds.FallbackFeatureTypeId),
                title: "Contextual Fallback Message",
                currentFeatureTypeId: (0, _featureTypeIds.FallbackFeatureTypeId),
                conversationItem: {
                    ...this.props.followUp.fallbackMessage,
                    featureTypeId: (0, _featureTypeIds.FallbackFeatureTypeId)
                },
                description: ""
            } : null)
        });
    }
    getInitialChildSlots() {
        return this.props.childContentContainer && this.props.childContentContainer.contentItems && this.props.childContentContainer.contentItems.length > 0 ? this.props.childContentContainer.contentItems.map((c, i)=>({
                featureTypeIdFilter: null,
                title: `Expected Response #${i + 1}`,
                description: "Where will this response take the user?",
                conversationItem: c,
                currentFeatureType: this.props.featureContainer.getFeatureTypeById(c.featureTypeId)
            })) : [
            {
                featureTypeIdFilter: null,
                title: "Expected Response #1",
                description: "Where will this response take the user?",
                conversationItem: null
            }
        ];
    }
    handleSelectionChange(option) {
        const selection = option.value;
        var slots = [];
        if (selection == "end") this.props.onChange(null, null, false);
        else if (selection == "endSession") // For endSession, we pass null followUp but signal this is endSession
        this.props.onChange(null, null, true);
        else if (selection == "structured") {
            this.props.onChange({
                content: this.props.followUp?.content ?? "",
                childContentContainer: {
                    id: null,
                    applicationId: this.props.applicationId,
                    isLimitedToChildren: false
                },
                followUpHints: this.props.followUp?.followUpHints ?? []
            }, {
                applicationId: this.props.applicationId,
                isLimitedToChildren: false,
                contentItems: [],
                id: null
            }, false);
            slots = [
                {
                    featureTypeIdFilter: null,
                    title: "Expected Response #1",
                    description: "Where will this response take the user?",
                    conversationItem: null
                }
            ];
        } else if (selection == "suggest") this.props.onChange({
            content: this.props.followUp?.content ?? "",
            childContentContainer: null,
            followUpHints: this.props.followUp?.followUpHints ?? []
        }, null, false);
        this.setState({
            ...this.state,
            selection: selection,
            childSlots: slots
        });
    }
    handleFollowUpTextChange(ssml) {
        const followUp = this.props.followUp;
        followUp.content = ssml;
        this.props.onChange(followUp, this.props.childContentContainer, false);
    }
    handleHintChange(e, index) {
        const followUp = this.props.followUp;
        var hints = followUp ? followUp.followUpHints : null;
        if (hints) hints[index].content = e.target.value;
        followUp.followUpHints = hints;
        this.props.onChange(followUp, this.props.childContentContainer, false);
    }
    handleAddHint() {
        const followUp = this.props.followUp;
        var hints = followUp ? followUp.followUpHints : null;
        if (hints) {
            var newPriority = hints.length + 1;
            hints.push({
                id: null,
                followUpId: undefined,
                content: "",
                priority: newPriority
            });
        } else hints = [
            {
                id: null,
                followUpId: undefined,
                content: "",
                priority: 0
            }
        ];
        followUp.followUpHints = hints;
        this.props.onChange(followUp, this.props.childContentContainer, false);
    }
    handleHintDelete(index) {
        const followUp = this.props.followUp;
        var hints = followUp ? followUp.followUpHints : null;
        if (hints) {
            hints.splice(index, 1);
            followUp.followUpHints = hints;
        }
        this.props.onChange(followUp, this.props.childContentContainer, false);
    }
    handleAddChild(slot, initialPage) {
        this.setState({
            ...this.state,
            isSelectingContent: true,
            currentSlot: slot,
            currentFeatureTypeFilter: slot?.featureTypeIdFilter ? [
                slot.featureTypeIdFilter
            ] : null,
            currentPropertyFilter: slot?.itemFilter,
            starterPage: initialPage
        });
    }
    handleEnforceChildren(checked) {
        const childContainer = this.props.childContentContainer;
        childContainer.isLimitedToChildren = checked;
        this.props.onChange(this.props.followUp, childContainer, false);
    }
    handleLimitIntents(checked) {
        const childContainer = this.props.childContentContainer;
        childContainer.limitIntentsToChildren = checked;
        this.props.onChange(this.props.followUp, childContainer, false);
    }
    handleConversationItemSelected(contentItems) {
        const childContentContainer = this.props.childContentContainer;
        if (contentItems.length == 0) {
            this.setState({
                ...this.state,
                isSelectingContent: false
            });
            return;
        }
        const slots = this.state.childSlots ?? [];
        const helpSlot = this.state.helpSlot;
        const fallbackSlot = this.state.fallbackSlot;
        const followUp = this.props.followUp;
        if (this.state.currentSlot && this.state.currentSlot.featureTypeIdFilter == (0, _featureTypeIds.HelpMessagesFeatureTypeId)) {
            helpSlot.conversationItem = contentItems[0];
            followUp.helpMessageId = contentItems[0]?.id;
        } else if (this.state.currentSlot && this.state.currentSlot.featureTypeIdFilter == (0, _featureTypeIds.FallbackFeatureTypeId)) {
            fallbackSlot.conversationItem = contentItems[0];
            followUp.fallbackMessageId = contentItems[0].id;
        } else if (this.state.currentSlot && contentItems.length == 1) {
            slots[slots.indexOf(this.state.currentSlot)].conversationItem = contentItems[0];
            slots[slots.indexOf(this.state.currentSlot)].currentFeatureTypeId = contentItems[0]?.featureTypeId;
            childContentContainer.contentItems?.push(contentItems[0]);
        } else {
            // remove the placeholder
            (0, _lodashDefault.default).remove(slots, (s)=>!s.conversationItem);
            contentItems.forEach((c)=>{
                slots.push({
                    featureTypeIdFilter: null,
                    conversationItem: c,
                    title: `Expected Response #${slots.length + 1}`,
                    description: "Where will this response take the user?",
                    currentFeatureTypeId: c.featureTypeId
                });
                childContentContainer.contentItems?.push(c);
            });
        }
        this.setState({
            ...this.state,
            isSelectingContent: false,
            currentSlot: null,
            childSlots: slots,
            helpSlot: helpSlot,
            fallbackSlot: fallbackSlot,
            starterPage: null
        });
        this.props.onChange(followUp, childContentContainer, false);
    }
    handleCloseExplorer() {
        this.setState({
            ...this.state,
            isSelectingContent: false,
            currentSlot: null,
            starterPage: null
        });
    }
    handleRemoveSlot(slot) {
        if (slot.conversationItem) {
            const childContentContainer = this.props.childContentContainer;
            (0, _lodashDefault.default).remove(childContentContainer.contentItems, (c)=>c.id == slot.conversationItem.id);
            this.props.onChange(this.props.followUp, childContentContainer, false);
        }
        var slots = this.state.childSlots;
        (0, _lodashDefault.default).remove(slots, (s)=>s == slot);
        this.setState({
            ...this.state,
            childSlots: slots
        });
    }
    handleAddOrRemoveHelp() {
        if (this.state.helpSlot) {
            this.setState({
                ...this.state,
                helpSlot: null
            });
            const followUp = this.props.followUp;
            followUp.helpMessageId = null;
            this.props.onChange(followUp, this.props.childContentContainer, false);
        } else this.setState({
            ...this.state,
            helpSlot: {
                featureTypeIdFilter: (0, _featureTypeIds.HelpMessagesFeatureTypeId),
                title: "Contextual Help Message",
                currentFeatureTypeId: (0, _featureTypeIds.HelpMessagesFeatureTypeId),
                conversationItem: null,
                description: ""
            }
        });
    }
    handleAddOrRemoveFallback() {
        if (this.state.fallbackSlot) {
            this.setState({
                ...this.state,
                fallbackSlot: null
            });
            const followUp = this.props.followUp;
            followUp.fallbackMessageId = null;
            this.props.onChange(followUp, this.props.childContentContainer, false);
        } else this.setState({
            ...this.state,
            fallbackSlot: {
                featureTypeIdFilter: (0, _featureTypeIds.FallbackFeatureTypeId),
                title: "Contextual Fallback Message",
                conversationItem: null,
                currentFeatureTypeId: (0, _featureTypeIds.FallbackFeatureTypeId),
                description: ""
            }
        });
    }
    handleSelectHelpMessage() {
        const appFeature = this.props.featureContainer.findGeneralByFeatureType((0, _featureTypeIds.HelpMessagesFeatureTypeId));
        this.handleAddChild(this.state.helpSlot, {
            pageType: "conversation-items",
            applicationFeature: appFeature,
            name: "Help Messages"
        });
    }
    handleSelectFallbackMessage() {
        const appFeature = this.props.featureContainer.findGeneralByFeatureType((0, _featureTypeIds.FallbackFeatureTypeId));
        this.handleAddChild(this.state.fallbackSlot, {
            pageType: "conversation-items",
            applicationFeature: appFeature,
            name: "Fallback Messages"
        });
    }
    handleAddTargetedResponse(slot) {
        const appFeature = this.props.featureContainer.findFeatureById(this.props.applicationFeatureId);
        this.handleAddChild(slot, {
            pageType: "conversation-items",
            applicationFeature: appFeature,
            name: "Conversation Items"
        });
    }
    handleAddOrClearHints() {
        const followUp = this.props.followUp;
        if (followUp && followUp.followUpHints && followUp.followUpHints.length > 0) followUp.followUpHints = []; // clear them
        else followUp.followUpHints.push({
            content: "",
            priority: 0
        });
        this.props.onChange(followUp, this.props.childContentContainer, false);
    }
    handleImplicitChange(followUp) {
        this.props.onChange(followUp, null, false);
    }
    handleDragEnd(result, provider) {
        // dropped outside the list
        if (!result.destination) return;
        const hints = (0, _lodashDefault.default).orderBy(this.props.followUp?.followUpHints, (af)=>af.priority, "asc");
        this.handleReorderHints(hints, result.source.index, result.destination.index);
    }
    handleMoveDown(index) {
        const hints = this.props.followUp?.followUpHints;
        if (index < hints.length - 1) this.handleReorderHints(hints, index, index + 1);
    }
    handleMoveUp(index) {
        const hints = this.props.followUp?.followUpHints;
        if (index > 0) this.handleReorderHints(hints, index, index - 1);
    }
    handleReorderHints(array, sourceIndex, endIndex) {
        let orderedHints = (0, _extensions.reorder)(array, sourceIndex, endIndex);
        orderedHints.forEach((h, idx)=>h.priority = idx);
        this.props.onChange({
            ...this.props.followUp,
            followUpHints: orderedHints
        }, this.props.childContentContainer, false);
    }
    renderHints() {
        const hints = (0, _lodashDefault.default).orderBy(this.props.followUp?.followUpHints ?? [], (h)=>h.priority, "asc");
        return (0, _react.jsx)("div", {
            className: subsectionContainer
        }, (0, _react.jsx)("div", {
            className: "inner-wrapper"
        }, (0, _react.jsx)("img", {
            className: "subsection-container-img",
            src: hintsIcon
        }), (0, _react.jsx)("div", null, (0, _react.jsx)("div", {
            className: "title-section",
            id: `g${this.props.groupIndex}on-screen-hint`
        }, (0, _react.jsx)("div", {
            className: "hints-header"
        }, (0, _react.jsx)("p", {
            className: "header"
        }, "On-screen Hint "), (0, _react.jsx)("p", {
            className: "detail"
        }, "A visible text snippet on screen devices that suggests something a user can say or navigate to")), this.props.followUp?.name == null && (0, _react.jsx)((0, _buttonDefault.default), {
            themes: [
                "blue-pill",
                "end",
                "end-tight"
            ],
            icon: this.props.followUp && !this.props.followUp.followUpHints.length ? addIcon : clearIcon,
            text: this.props.followUp && !this.props.followUp.followUpHints.length ? "ADD" : "CLEAR",
            type: "button",
            onClick: this.handleAddOrClearHints.bind(this)
        })), hints && hints.length > 0 ? (0, _react.jsx)((0, _reactDefault.default).Fragment, null, (0, _react.jsx)((0, _reactBeautifulDnd.DragDropContext), {
            onDragEnd: this.handleDragEnd.bind(this)
        }, (0, _react.jsx)((0, _reactBeautifulDnd.Droppable), {
            droppableId: "hints",
            type: "HINTS_SECTION"
        }, (provided, snapshot)=>(0, _react.jsx)("div", (0, _extendsDefault.default)({}, provided.droppableProps, {
                ref: provided.innerRef
            }), hints.map((hint, index)=>(0, _react.jsx)((0, _reactBeautifulDnd.Draggable), {
                    draggableId: index.toString(),
                    index: index,
                    key: index
                }, (provided, snapshot)=>(0, _react.jsx)("div", (0, _extendsDefault.default)({
                        key: index,
                        ref: provided.innerRef
                    }, provided.draggableProps, provided.dragHandleProps), (0, _react.jsx)((0, _hintFieldDefault.default), {
                        index: index,
                        isLast: index == hints.length - 1,
                        hint: hint,
                        followUp: this.props.followUp,
                        handleHintChange: this.handleHintChange.bind(this),
                        handleMoveDown: this.handleMoveDown.bind(this),
                        handleHintDelete: this.handleHintDelete.bind(this),
                        handleMoveUp: this.handleMoveUp.bind(this)
                    })))), provided.placeholder))), (0, _react.jsx)((0, _buttonDefault.default), {
            type: "button",
            themes: [
                "hollow",
                "fill"
            ],
            text: "Add an On-Screen Hint",
            onClick: ()=>this.handleAddHint()
        })) : null)));
    }
    render() {
        return (0, _react.jsx)((0, _contentCardDefault.default), {
            className: "ac-response-followup-card",
            title: "Conversation Follow-up",
            id: `g${this.props.groupIndex}followUp`,
            icon: followUpCardIcon
        }, this.props.isLoading ? (0, _react.jsx)("div", {
            className: loaderContainer
        }, (0, _react.jsx)((0, _secondaryLoaderDefault.default), null)) : (0, _react.jsx)((0, _reactDefault.default).Fragment, null, (0, _react.jsx)((0, _formFieldsContainerDefault.default), null, (0, _react.jsx)((0, _detailLabelDefault.default), {
            text: "Select what happens after the last response in this conversation"
        }), (0, _react.jsx)((0, _radioCardGroupDefault.default), {
            options: [
                {
                    value: "end",
                    label: this.props.emptyOptionText ? this.props.emptyOptionText : "End session",
                    icon: this.props.emptyOptionIcon ? this.props.emptyOptionIcon : endSessionIcon
                },
                {
                    value: "suggest",
                    label: "Suggest more content",
                    icon: suggestIcon
                },
                {
                    value: "structured",
                    label: "Targeted response",
                    icon: targetIcon
                },
                ...this.props.showEndSessionOption ? [
                    {
                        value: "endSession",
                        label: "End Session",
                        icon: endSessionIcon
                    }
                ] : []
            ],
            onChange: this.handleSelectionChange.bind(this),
            value: this.state.selection,
            disabled: this.props.disabled
        })), this.state.selection == "structured" && (0, _react.jsx)((0, _reactDefault.default).Fragment, null, (0, _react.jsx)((0, _horizontalSeparatorDefault.default), null), (0, _react.jsx)("div", {
            className: subsectionContainer,
            id: `g${this.props.groupIndex}guidance`
        }, (0, _react.jsx)("div", {
            className: "inner-wrapper"
        }, (0, _react.jsx)("img", {
            className: "subsection-container-img",
            src: followUpIcon
        }), (0, _react.jsx)("div", null, (0, _react.jsx)("p", {
            className: "header"
        }, "Guidance"), (0, _react.jsx)("p", {
            className: "detail"
        }, "Prompt the user with a question or statement and guide them to the next conversation"), (0, _react.jsx)((0, _ssmlFieldDefault.default), {
            applicationId: this.props.applicationId,
            name: "followUpContent",
            className: "follow-up-field",
            label: "Follow-up Language",
            value: this.props.followUp ? this.props.followUp.content : "",
            onBlur: ()=>{},
            onChange: this.handleFollowUpTextChange.bind(this),
            placeholder: "What do you want to ask the user?"
        })))), (0, _react.jsx)("div", {
            id: `g${this.props.groupIndex}destination`,
            className: `${subsectionContainer} tight`
        }, (0, _react.jsx)("div", {
            className: "inner-wrapper"
        }, (0, _react.jsx)("img", {
            className: "subsection-container-img",
            src: pinIcon
        }), (0, _react.jsx)("div", null, (0, _react.jsx)("p", {
            className: "header"
        }, "Destination"), (0, _react.jsx)("p", {
            className: "detail"
        }, "Where should the above guidance lead the user?")))), (0, _react.jsx)((0, _childItemContainerDefault.default), null, this.state.childSlots.map((slot, i)=>(0, _react.jsx)((0, _conversationItemCardDefault.default), {
                key: i,
                slot: slot,
                canDelete: slot.featureTypeIdFilter == null,
                onDelete: ()=>this.handleRemoveSlot(slot),
                onAddItem: ()=>this.handleAddTargetedResponse(slot)
            }))), (0, _react.jsx)((0, _buttonDefault.default), {
            type: "button",
            themes: [
                "hollow",
                "fill"
            ],
            text: "Add an Expected Response",
            onClick: ()=>this.handleAddTargetedResponse(null)
        }), (0, _react.jsx)((0, _horizontalSeparatorDefault.default), null), (0, _react.jsx)((0, _formFieldsContainerDefault.default), null, (0, _react.jsx)((0, _switchDefault.default), {
            className: switchContainer,
            checked: this.props.childContentContainer && this.props.childContentContainer.isLimitedToChildren,
            onChange: this.handleEnforceChildren.bind(this),
            label: "Enforce the above responses",
            detail: "The user will be required to say one of these options to continue"
        }), (0, _react.jsx)((0, _switchDefault.default), {
            className: switchContainer,
            checked: this.props.childContentContainer && this.props.childContentContainer.limitIntentsToChildren,
            onChange: this.handleLimitIntents.bind(this),
            label: "Limit intents to expected responses",
            detail: "Intents will only be available if they are represented by one of the above options"
        })), (0, _react.jsx)((0, _horizontalSeparatorDefault.default), null), this.renderHints(), this.props.childContentContainer && this.props.childContentContainer.isLimitedToChildren && (0, _react.jsx)((0, _reactDefault.default).Fragment, null, (0, _react.jsx)((0, _horizontalSeparatorDefault.default), null), (0, _react.jsx)("div", {
            className: subsectionContainer,
            id: `g${this.props.groupIndex}contextualFallback`
        }, (0, _react.jsx)("div", {
            className: "inner-wrapper"
        }, (0, _react.jsx)("img", {
            className: "subsection-container-img",
            src: fallbackIcon
        }), (0, _react.jsx)("div", null, (0, _react.jsx)("div", {
            className: "title-section"
        }, (0, _react.jsx)("div", null, (0, _react.jsx)("p", {
            className: "header"
        }, "Contextual Fallback "), (0, _react.jsx)("p", {
            className: "detail"
        }, "If the user says something that isn’t recognized as one of the available responses")), (0, _react.jsx)((0, _buttonDefault.default), {
            themes: [
                "blue-pill",
                "end",
                "end-tight"
            ],
            icon: this.state.fallbackSlot ? clearIcon : addIcon,
            text: this.state.fallbackSlot ? "CLEAR" : "ADD",
            type: "button",
            onClick: this.handleAddOrRemoveFallback.bind(this)
        })), this.state.fallbackSlot ? (0, _react.jsx)((0, _conversationItemWrapperDefault.default), {
            slot: this.state.fallbackSlot,
            onClick: this.handleSelectFallbackMessage.bind(this)
        }) : null))), (0, _react.jsx)((0, _horizontalSeparatorDefault.default), null), (0, _react.jsx)("div", {
            className: subsectionContainer,
            id: `g${this.props.groupIndex}contextualHelp`
        }, (0, _react.jsx)("div", {
            className: "inner-wrapper"
        }, (0, _react.jsx)("img", {
            className: "subsection-container-img",
            src: helpIcon
        }), (0, _react.jsx)("div", null, (0, _react.jsx)("div", {
            className: "title-section"
        }, (0, _react.jsx)("div", null, (0, _react.jsx)("p", {
            className: "header"
        }, "Contextual Help"), (0, _react.jsx)("p", {
            className: "detail"
        }, "If the user asks for help here")), (0, _react.jsx)((0, _buttonDefault.default), {
            themes: [
                "blue-pill",
                "end",
                "end-tight"
            ],
            icon: this.state.helpSlot ? clearIcon : addIcon,
            text: this.state.helpSlot ? "CLEAR" : "ADD",
            type: "button",
            onClick: this.handleAddOrRemoveHelp.bind(this)
        })), this.state.helpSlot ? (0, _react.jsx)((0, _conversationItemWrapperDefault.default), {
            slot: this.state.helpSlot,
            onClick: this.handleSelectHelpMessage.bind(this)
        }) : null))))), this.state.selection == "suggest" && (0, _react.jsx)((0, _manageImplicitFollowUpFormDefault.default), {
            followUp: this.props.followUp,
            followUpContainer: this.props.followUpContainer,
            applicationId: this.props.applicationId,
            onManage: this.props.onManage,
            onChange: this.handleImplicitChange.bind(this)
        }, this.renderHints()), this.state.isSelectingContent && (0, _react.jsx)((0, _contentExplorerDefault.default), {
            applicationId: this.props.applicationId,
            exploreType: this.state?.currentSlot?.featureTypeIdFilter == (0, _featureTypeIds.HelpMessagesFeatureTypeId) || this.state?.currentSlot?.featureTypeIdFilter == (0, _featureTypeIds.FallbackFeatureTypeId) ? "content-select" : "content-multi-select",
            onClose: this.handleCloseExplorer.bind(this),
            title: "Select Expected Conversation Items",
            disabledFeatureIds: [],
            featureTypeIdFilter: this.state.currentFeatureTypeFilter ?? ValidFollowUpFeatureTypes,
            propertyFilter: this.state.currentPropertyFilter,
            languageIdFilter: this.props.languageIds,
            onSelect: this.handleConversationItemSelected.bind(this),
            isLoading: this.props.featureContainer.state.isLoadingBulkOperation,
            initialPage: this.state.starterPage
        })), (0, _react.jsx)((0, _pageErrorDefault.default), {
            errors: this.props.followUpContainer.state.errors
        }));
    }
}
const loaderContainer = /*#__PURE__*/ (0, _css.css)("display:flex;align-items:center;justify-content:center;padding:32px;.spinner>div{background-color:", (0, _colors.dark_grey_blue), ";}", "");
const switchContainer = /*#__PURE__*/ (0, _css.css)({
    name: "1s22u92",
    styles: "margin-bottom:32px"
});
const subsectionContainer = /*#__PURE__*/ (0, _css.css)("padding:24px 0;&.tight{padding-top:0;}.inner-wrapper{display:flex;align-items:flex-start;>div{flex:1;}.selector{margin-top:24px;}}.title-section{display:flex;align-items:flex-start;}.subsection-container-img{margin-right:16px;}.header{font-family:Muli;font-size:18px;color:", (0, _colors.dark_grey_blue), ";}.detail{font-size:12px;letter-spacing:0.5px;color:", (0, _colors.cool_grey), ";margin-right:16px;}button{margin-top:0;margin-bottom:0;}.hints-header{margin-bottom:16px;}.follow-up-field{margin-top:16px;}", "");
exports.default = ManageFollowUpForm;

},{"@babel/runtime/helpers/extends":"4iKIP","@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","lodash":"3hMBK","../../../components/forms/RadioCardGroup":"ZeFLy","../../../components/forms/SsmlField/SsmlField":"cvL6K","../../../components/forms/Switch":"8kkL9","../../../components/general/Button":"6ymxN","../../../components/general/DetailLabel":"j3EnX","../../../components/general/PageError":"ezFTm","../../../components/general/SecondaryLoader":"7zJiF","../../../components/structure/ContentCard":"hJsdJ","../../../components/structure/FormFieldsContainer":"h3hzh","../../../components/structure/HorizontalSeparator":"Pw3HQ","../../../constants/colors":"1p3OR","../../../constants/featureTypeIds":"hPLMP","../../contentExplorer":"k2ko3","./ChildItemContainer":"hrN3F","./ConversationItemCard":"cDfgo","./ConversationItemWrapper":"6wsJj","react-beautiful-dnd":"bkbSn","./ManageImplicitFollowUpForm":"tK22E","./HintField":"ehQxT","../../../models/extensions":"7h01B","18c6fee551045438":"dQ7Ta","63ef18f458d282c8":"A1pLV","d683b043042d7291":"d40tP","8e490b28f6e0919a":"cl9rg","25488a118b569ca4":"h1HjT","fd3e599b3f94ab2f":"59An8","f3910937e00917ca":"lruiJ","a9d5eb76f0c80d38":"fE99M","3c39665da3b2161b":"ICQyO","4e989f813ed90d6":"3vnDf","93b774acaa2b5b50":"iy1lb","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"ZeFLy":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _colors = require("../../constants/colors");
var _breakpoints = require("../../constants/breakpoints");
const RadioCardGroup = (props)=>{
    const handleOptionSelected = (option)=>{
        if (props.onChange && !props.disabled) props.onChange(option);
    };
    return (0, _react.jsx)("div", {
        className: `${containerStyle} ${props.disabled ? "disabled" : ""}`
    }, props.options.map((option, index)=>(0, _react.jsx)("div", {
            className: `${radioOptionStyle} ${option.className ? option.className : ""}`,
            key: index,
            onClick: handleOptionSelected.bind(undefined, option)
        }, (0, _react.jsx)("div", {
            className: "check-container"
        }, option.value == props.value ? (0, _react.jsx)("div", {
            className: "selected-option"
        }) : null), (0, _react.jsx)("div", {
            className: "content-container"
        }, option.icon ? (0, _react.jsx)("img", {
            className: "option-icon",
            src: option.icon
        }) : null, (0, _react.jsx)("p", null, option.label), option.description ? (0, _react.jsx)("div", {
            className: "option-description"
        }, option.description) : null))));
};
const containerStyle = /*#__PURE__*/ (0, _css.css)("margin:16px 0;position:relative;display:flex;flex-wrap:wrap;padding:0 -8px;", (0, _breakpoints.breakpoint_small), "{flex-direction:column;}.option-icon{margin-left:16px;}.option-description{color:", (0, _colors.color_shades_darker), ";font-style:italic;font-size:14px;text-align:center;}&.disabled{.selected-option{background:", (0, _colors.color_shades_light), ";}}", "");
const radioOptionStyle = /*#__PURE__*/ (0, _css.css)("margin:8px;cursor:pointer;border-radius:5px;border:solid 1px ", (0, _colors.color_shades_dark), ";background-color:#ffffff;min-height:120px;min-width:120px;flex:1;position:relative;padding:8px;display:flex;.content-container{display:flex;flex-direction:column;align-items:center;justify-content:center;flex:1;}.check-container{position:absolute;min-width:30px;height:30px;border-radius:50%;background-color:#ffffff;border:solid 1px #cccccc;display:flex;align-items:center;justify-content:center;margin-top:6px;margin-left:6px;}.selected-option{width:16px;height:16px;border-radius:50%;background-image:linear-gradient(225deg, #76c3b5, #3ea6ac 72%, #5296b3);}p{font-family:Muli;font-size:14px;font-weight:normal;font-style:normal;font-stretch:normal;line-height:normal;letter-spacing:normal;color:", (0, _colors.dark_grey_blue), ";margin:16px;word-break:break-word;text-align:center;}", "");
exports.default = RadioCardGroup;

},{"@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","../../constants/colors":"1p3OR","../../constants/breakpoints":"2F01A","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8kkL9":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _colors = require("../../constants/colors");
var _secondaryLoader = require("../general/SecondaryLoader");
var _secondaryLoaderDefault = parcelHelpers.interopDefault(_secondaryLoader);
const Switch = (props)=>(0, _react.jsx)("div", {
        className: `${containerStyle} ${props.className ? props.className : ""} ${props.disabled ? "disabled" : ""}`,
        onClick: props.disabled ? ()=>{} : (e)=>{
            if (props.stopPropagation) e.stopPropagation();
            props.onChange(!props.checked);
        }
    }, props.leftOption && (0, _react.jsx)("div", {
        className: "label-container left-label"
    }, (0, _react.jsx)("p", {
        className: "primary-label"
    }, props.leftOption)), props.icon && (0, _react.jsx)("div", {
        className: "label-container left-label"
    }, (0, _react.jsx)("img", {
        src: props.icon
    })), (0, _react.jsx)("div", {
        className: `switch ${props.checked ? "switch-on" : "switch-off"}`
    }, (0, _react.jsx)("div", {
        className: "switch-container"
    }), (0, _react.jsx)("div", {
        className: "switch-indicator"
    })), (props.label || props.detail || props.loading) && (0, _react.jsx)("div", {
        className: "label-container"
    }, props.loading ? (0, _react.jsx)((0, _secondaryLoaderDefault.default), {
        className: "grey switch-loader"
    }) : (0, _react.jsx)((0, _reactDefault.default).Fragment, null, (0, _react.jsx)("p", {
        className: `${props.labelStyle ? props.labelStyle : "primary-label"}`
    }, props.label), props.detail ? (0, _react.jsx)("span", {
        className: "secondary-label"
    }, props.detail) : null)));
const containerStyle = /*#__PURE__*/ (0, _css.css)("display:flex;flex-direction:row;align-items:center;cursor:pointer;.switch{width:48px;height:26px;position:relative;.switch-container{border-radius:13px;height:100%;width:100%;position:absolute;}.switch-indicator{width:25px;height:25px;background-color:#ffffff;border-radius:50%;border:1px solid ", (0, _colors.silver_three), ";position:absolute;}&.switch-off{.switch-container{background:", (0, _colors.silver_three), ";}.switch-indicator{margin-left:0;transition:margin 200ms;}}&.switch-on{.switch-container{background:linear-gradient(242deg, #76c3b5, #3ea6ac 72%, #5296b3);}.switch-indicator{margin-left:25px;transition:margin 200ms;}}}.label-container{margin-left:12px;.primary-label{font-family:Muli;font-size:14px;font-weight:normal;font-style:normal;font-stretch:normal;line-height:normal;letter-spacing:normal;color:", (0, _colors.dark_grey_blue), ";}.secondary-label{font-family:Muli;font-size:12px;font-weight:normal;font-style:normal;font-stretch:normal;line-height:normal;letter-spacing:normal;color:", (0, _colors.cool_grey), ";}&.left-label{margin-left:0px;margin-right:12px;}&.right-container{margin-left:32px;}.switch-loader{.spinner{width:30px;height:20px;}.spinner>div{width:2px;margin-right:3px;}}}&.disabled{cursor:not-allowed;.switch{.switch-container{background:linear-gradient(242deg, #c9c9c9, #a8a8a8 63%, #929292);}.switch-indicator{background:", (0, _colors.pale_grey), ";}}}", "");
exports.default = Switch;

},{"@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","../../constants/colors":"1p3OR","../general/SecondaryLoader":"7zJiF","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"j3EnX":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _colors = require("../../constants/colors");
// component used for mid-page subheaders
const subheaderStyle = /*#__PURE__*/ (0, _css.css)("font-family:Muli;font-size:12px;font-weight:normal;font-style:normal;font-stretch:normal;line-height:normal;letter-spacing:0.5px;text-align:left;color:", (0, _colors.cool_grey), ";display:block;margin-bottom:24px;", "");
const DetailLabel = (props)=>(0, _react.jsx)("p", {
        className: subheaderStyle
    }, props.text);
exports.default = DetailLabel;

},{"@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","../../constants/colors":"1p3OR","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"k2ko3":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _base = require("@emotion/styled/base");
var _baseDefault = parcelHelpers.interopDefault(_base);
var _react = require("@emotion/react");
var _css = require("@emotion/css");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _unstated = require("unstated");
var _button = require("../../components/general/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _modalTitle = require("../../components/general/ModalTitle");
var _modalTitleDefault = parcelHelpers.interopDefault(_modalTitle);
var _horizontalSeparator = require("../../components/structure/HorizontalSeparator");
var _horizontalSeparatorDefault = parcelHelpers.interopDefault(_horizontalSeparator);
var _modalLayout = require("../../components/structure/ModalLayout");
var _modalLayoutDefault = parcelHelpers.interopDefault(_modalLayout);
var _pageContainer = require("../../components/structure/PageContainer");
var _pageContainerDefault = parcelHelpers.interopDefault(_pageContainer);
var _applicationContainer = require("../../state/containers/ApplicationContainer");
var _applicationContainerDefault = parcelHelpers.interopDefault(_applicationContainer);
var _featureContainer = require("../../state/containers/FeatureContainer");
var _featureContainerDefault = parcelHelpers.interopDefault(_featureContainer);
var _colors = require("../../constants/colors");
var _innerContentExplorer = require("./components/InnerContentExplorer");
var _innerContentExplorerDefault = parcelHelpers.interopDefault(_innerContentExplorer);
var _fullScreenLayout = require("../fullScreenLayout");
var _fullScreenLayoutDefault = parcelHelpers.interopDefault(_fullScreenLayout);
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const closeIcon = require("179cf8673d2fa595");
class ContentExplorer extends (0, _reactDefault.default).Component {
    handleClose() {
        this.props.onClose();
    }
    render() {
        return (0, _react.jsx)((0, _modalLayoutDefault.default), {
            isVisible: true,
            onClose: this.handleClose.bind(this)
        }, (0, _react.jsx)((0, _unstated.Subscribe), {
            to: [
                (0, _applicationContainerDefault.default),
                (0, _featureContainerDefault.default)
            ]
        }, (appContainer, featureContainer)=>(0, _react.jsx)((0, _fullScreenLayoutDefault.default), {
                className: containerStyle
            }, (0, _react.jsx)((0, _pageContainerDefault.default), {
                fill: true
            }, (0, _react.jsx)(TitleBarWrapper, {
                className: "header-wrapper"
            }, (0, _react.jsx)(TitleWrapper, null, (0, _react.jsx)((0, _modalTitleDefault.default), {
                subtitleStyle: true
            }, this.props.title), this.props.subtitle && (0, _react.jsx)(ModalSubtitle, null, this.props.subtitle)), (0, _react.jsx)((0, _buttonDefault.default), {
                themes: [
                    "end-tight",
                    "icon"
                ],
                icon: closeIcon,
                onClick: this.handleClose.bind(this)
            })), (0, _react.jsx)((0, _horizontalSeparatorDefault.default), null), (0, _react.jsx)((0, _innerContentExplorerDefault.default), {
                applicationId: this.props.applicationId,
                featureContainer: featureContainer,
                appContainer: appContainer,
                withNesting: false,
                initialApplicationFeatureId: this.props.initialPage?.applicationFeature?.id,
                exploreType: this.props.exploreType,
                onSelect: this.props.onSelect,
                onSelectionChange: this.props.onSelectionChange,
                isLoading: this.props.isLoading,
                initialFilter: this.props.initialFilter,
                disablingFilter: {
                    featureTypeIdFilter: this.props.featureTypeIdFilter,
                    languageIdFilter: this.props.languageIdFilter,
                    propertyFilter: this.props.propertyFilter,
                    disabledAppFeatureIds: this.props.disabledFeatureIds
                }
            })))));
    }
}
const TitleBarWrapper = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1p3g5ra2"
})({
    name: "bcffy2",
    styles: "display:flex;align-items:center;justify-content:space-between"
});
const TitleWrapper = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1p3g5ra1"
})({
    name: "zupemi",
    styles: "display:flex;flex-direction:column;margin-bottom:0"
});
const ModalSubtitle = /*#__PURE__*/ (0, _baseDefault.default)("h3", {
    target: "e1p3g5ra0"
})({
    name: "vrz31e",
    styles: "font-family:Muli;font-size:16px;color:#6e7a8a;margin-bottom:26px;margin-top:8px"
});
const containerStyle = /*#__PURE__*/ (0, _css.css)("background:", (0, _colors.blue_white), ";.header-wrapper{padding:0 50px;background:white;align-items:center;}", "");
exports.default = ContentExplorer;

},{"@emotion/styled/base":"lSuFu","@emotion/react":"djZKr","@emotion/css":"awUBr","react":"6uln9","unstated":"grh7p","../../components/general/Button":"6ymxN","../../components/general/ModalTitle":"hIp2B","../../components/structure/HorizontalSeparator":"Pw3HQ","../../components/structure/ModalLayout":"b1cO3","../../components/structure/PageContainer":"hc1r8","../../state/containers/ApplicationContainer":"cuqi2","../../state/containers/FeatureContainer":"4ApGg","../../constants/colors":"1p3OR","./components/InnerContentExplorer":"2pLJf","../fullScreenLayout":"5mVdG","179cf8673d2fa595":"93VwA","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"cuqi2":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _defineProperty = require("@babel/runtime/helpers/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _unstated = require("unstated");
var _api = require("../../api");
var _lodash = require("lodash");
var _lodashDefault = parcelHelpers.interopDefault(_lodash);
class ApplicationContainer extends (0, _unstated.Container) {
    constructor(...args){
        super(...args);
        // default state
        (0, _definePropertyDefault.default)(this, "state", this.getInitialState());
    }
    getInitialState() {
        // check local storage for initial state
        let state = {
            orgApplicationsList: [],
            cachedApplications: [],
            baseOrgApplications: [],
            applicationsCount: null,
            applicationEndpoints: [],
            currentApp: null,
            applicationListPreferences: {
                take: 50,
                view: "card",
                sortBy: "CreatedDateDescending"
            },
            isLoadingApps: false,
            isUpdatingFeatureFlagSettings: false,
            errors: [],
            createErrors: [],
            templates: [],
            conversationCounts: [],
            folderAndItemCounts: [],
            organizationId: "",
            isLoadingTemplates: false,
            isCreatingApplication: false,
            isAddingModules: false,
            isLoadingEndpoints: false,
            isSaving: false,
            isSyncingNLPAndInteractionModel: false,
            isLoadingCurrentApp: false,
            assistantApplication: null,
            featureFlags: [],
            posConfig: null
        };
        const storedPreferences = localStorage.getItem("APP_LIST_PREFERENCES");
        if (storedPreferences != null) state.applicationListPreferences = JSON.parse(storedPreferences);
        return state;
    }
    updateApplicationListPreferences(preferences) {
        this.setState({
            ...this.state,
            applicationListPreferences: preferences
        });
        localStorage.setItem("APP_LIST_PREFERENCES", JSON.stringify(preferences));
    }
    async setCurrentAppFromId(applicationId) {
        const app = this.state.cachedApplications?.find((a)=>a.id == applicationId);
        this.setState({
            ...this.state,
            currentApp: app
        });
    }
    updateWebhookInstancesForApplication(appId, webhookInstances) {
        const searchedApps = [
            ...this.state.orgApplicationsList
        ];
        const idx = searchedApps.findIndex((a)=>a.id == appId);
        const app = searchedApps[idx];
        app.webhookInstances = webhookInstances;
        searchedApps[idx] = app;
        this.setState({
            ...this.state,
            orgApplicationsList: searchedApps
        });
    }
    async loadFeatureFlags() {
        try {
            const result = await _api.getFeatureFlags();
            if (result.resultType == "Ok") this.setState({
                ...this.state,
                featureFlags: result.data
            });
        } catch (error) {
            this.setState({
                ...this.state,
                errors: [
                    error.toString()
                ]
            });
        }
    }
    async loadPOSConfig(applicationId) {
        try {
            const result = await _api.getPOSConfig(applicationId);
            if (result.resultType == "Ok") {
                let formattedConfig;
                try {
                    const parsedConfig = JSON.parse(result.data);
                    formattedConfig = JSON.stringify(parsedConfig, null, 4);
                } catch  {
                    formattedConfig = result.data;
                }
                this.setState({
                    ...this.state,
                    posConfig: formattedConfig
                });
            } else this.setState({
                ...this.state,
                posConfig: ""
            });
        } catch (error) {
            this.setState({
                ...this.state,
                errors: [
                    error.toString()
                ]
            });
        }
    }
    async loadCurrentAppById(applicationId) {
        try {
            while(this.state.isLoadingCurrentApp)await new Promise((r)=>setTimeout(r, 400));
            await this.setState({
                ...this.state,
                isLoadingCurrentApp: true
            });
            let app = this.state.currentApp;
            if (app?.id != applicationId) {
                // if we're switching apps then clear it out and force a reload
                app = null;
                this.setState({
                    ...this.state,
                    posConfig: null
                });
            }
            if (app == null) // is it an initial load or are we switching apps?
            app = this.state.cachedApplications?.find((a)=>a?.id == applicationId);
            if (app == null) {
                // no app in cache lets load it
                const appResult = await _api.findApplication(applicationId);
                if (appResult.resultType == "Ok") {
                    app = appResult.data;
                    this.setState({
                        ...this.state,
                        cachedApplications: [
                            ...this.state.cachedApplications,
                            {
                                ...app
                            }
                        ]
                    });
                } else this.setState({
                    ...this.state,
                    errors: appResult.errors,
                    isLoadingCurrentApp: false
                });
            }
            if (this.state?.assistantApplication?.id != applicationId || this.state?.assistantApplication == null) {
                const assistantAppResult = await _api.getAssistantApplication(app.id);
                if (assistantAppResult.resultType == "Ok") await this.setState({
                    ...this.state,
                    assistantApplication: assistantAppResult.data
                });
                else if (assistantAppResult.resultType == "NotFound") await this.setState({
                    ...this.state,
                    assistantApplication: null
                });
                else await this.setState({
                    ...this.state,
                    errors: assistantAppResult.errors,
                    isLoadingCurrentApp: false
                });
            }
            await this.setState({
                ...this.state,
                currentApp: app,
                isLoadingCurrentApp: false
            });
            return {
                data: app,
                resultType: "Ok",
                errors: []
            };
        } catch (error) {
            this.setState({
                ...this.state,
                errors: [
                    error.toString()
                ],
                isLoadingCurrentApp: false
            });
        }
    }
    copyApplication(applicationId) {
        this.setState({
            ...this.state,
            isLoadingApps: true
        });
        const promise = _api.copyApplication(this.state.organizationId, applicationId);
        promise.then((result)=>{
            if (result.resultType == "Ok") this.setState({
                ...this.state,
                errors: [],
                cachedApplications: [
                    ...this.state.cachedApplications,
                    result.data
                ],
                isLoadingApps: false
            });
            else this.setState({
                ...this.state,
                errors: result.errors,
                isLoadingApps: false
            });
        }).catch((error)=>{
            console.log(error);
        });
    }
    getConversationCounts(organizationId) {
        const promise = _api.getApplicationConversationCounts(organizationId);
        promise.then((result)=>{
            if (result.resultType == "Ok") {
                const counts = this.state.conversationCounts;
                result.data.forEach((count)=>{
                    const existingCount = counts.find((c)=>c.applicationId == count.applicationId);
                    if (existingCount == null) counts.push(count);
                    else counts[counts.indexOf(existingCount)] = count;
                });
                this.setState({
                    ...this.state,
                    conversationCounts: counts
                });
            }
        });
        return promise;
    }
    getFolderAndItemCountsForApplications(organizationId, appIds) {
        if (appIds == null || appIds.length < 1) return;
        var promise = _api.getApplicationCounts(organizationId, appIds);
        promise.then((result)=>{
            if (result.resultType == "Ok") {
                var counts = this.state.folderAndItemCounts;
                result.data.forEach((count)=>{
                    var existingCount = counts.find((c)=>c.applicationId == count.applicationId);
                    if (existingCount == null) counts.push(count);
                    else counts[counts.indexOf(existingCount)] = count;
                });
                this.setState({
                    ...this.state,
                    conversationCounts: counts
                });
            }
        });
        return promise;
    }
    getFolderAndItemCount(applicationId) {
        var count = this.state.folderAndItemCounts.find((a)=>a.applicationId == applicationId);
        if (count === null || count === undefined) return null;
        return count;
    }
    getConversationCount(applicationId) {
        var appCount = this.state.conversationCounts.find((a)=>a.applicationId == applicationId);
        if (appCount === null || appCount === undefined) return null;
        return appCount.conversationCount;
    }
    async getApplicationsForOrg(organizationId, forceRefresh, loadAll = false) {
        try {
            if (this.state.organizationId == organizationId && this.state.cachedApplications?.length > 0 && !forceRefresh) return new Promise((resolve, reject)=>{
                resolve({
                    data: (0, _lodashDefault.default).sortBy(this.state.cachedApplications, (a)=>a.name),
                    errors: [],
                    resultType: "Ok"
                });
            });
            if (organizationId != this.state.organizationId) await this.setState({
                ...this.state,
                cachedApplications: []
            });
            await this.setState({
                ...this.state,
                isLoadingApps: true,
                organizationId: organizationId
            });
            let applicationsResult = {
                resultType: "Ok",
                errors: [],
                data: {
                    applications: []
                }
            };
            const take = 30;
            let page = 1;
            const sortBy = "CreatedDateDescending";
            const search = "";
            if (loadAll) {
                let latestLoaded = take;
                while(latestLoaded === take){
                    const newAppsResult = await _api.searchForApplications(organizationId, (page - 1) * take, take, sortBy, search);
                    if (newAppsResult.resultType == "Ok") {
                        applicationsResult.data.applications.push(...newAppsResult.data.applications);
                        latestLoaded = newAppsResult.data.applications.length;
                    } else {
                        applicationsResult = newAppsResult;
                        break;
                    }
                    page = page + 1;
                }
            } else applicationsResult = await _api.searchForApplications(organizationId, (page - 1) * take, take, sortBy, search);
            if (applicationsResult.resultType == "Ok") this.setState({
                ...this.state,
                errors: [],
                cachedApplications: this.state.cachedApplications.map((a)=>applicationsResult.data.applications.some((ra)=>ra?.id == a?.id) ? applicationsResult.data.applications.find((ra)=>ra?.id == a?.id) : a),
                applicationsCount: applicationsResult.data.total,
                isLoadingApps: false
            });
            else this.setState({
                ...this.state,
                errors: applicationsResult.errors,
                isLoadingApps: false
            });
            return {
                data: applicationsResult.data.applications,
                resultType: "Ok",
                errors: null
            };
        } catch (error) {
            this.setState({
                ...this.state,
                errors: [
                    error.toString()
                ],
                isLoadingApps: false
            });
        }
    }
    async getBaseApplicationsForOrg(organizationId, forceRefresh) {
        try {
            if (this.state.organizationId == organizationId && this.state.baseOrgApplications?.length > 0 && !forceRefresh) return new Promise((resolve, reject)=>{
                resolve({
                    data: (0, _lodashDefault.default).sortBy(this.state.baseOrgApplications, (a)=>a.name),
                    errors: [],
                    resultType: "Ok"
                });
            });
            if (organizationId != this.state.organizationId) await this.setState({
                ...this.state,
                baseOrgApplications: []
            });
            await this.setState({
                ...this.state,
                isLoadingApps: true,
                organizationId: organizationId
            });
            let applicationsResult = await _api.getApplicationsForOrg(organizationId);
            if (applicationsResult.resultType == "Ok") this.setState({
                ...this.state,
                errors: [],
                baseOrgApplications: applicationsResult.data,
                cachedApplications: this.state.cachedApplications.map((a)=>applicationsResult.data.some((ra)=>ra?.id == a?.id) ? applicationsResult.data.find((ra)=>ra?.id == a?.id) : a),
                applicationsCount: applicationsResult.data.length,
                isLoadingApps: false
            });
            else this.setState({
                ...this.state,
                errors: applicationsResult.errors,
                isLoadingApps: false
            });
            return {
                data: applicationsResult.data,
                resultType: "Ok",
                errors: null
            };
        } catch (error) {
            this.setState({
                ...this.state,
                errors: [
                    error.toString()
                ],
                isLoadingApps: false
            });
        }
    }
    async searchForApplications(organizationId, page = 1, take = 30, sortBy = "CreatedDateDescending", search = "", loadAll = false) {
        try {
            if (organizationId != this.state.organizationId) await this.setState({
                ...this.state,
                cachedApplications: []
            });
            await this.setState({
                ...this.state,
                organizationId: organizationId
            });
            let applicationsResult = {
                resultType: "Ok",
                errors: [],
                data: {
                    applications: []
                }
            };
            if (loadAll) {
                let latestLoaded = take;
                while(latestLoaded === take){
                    const newAppsResult = await _api.searchForApplications(organizationId, (page - 1) * take, take, sortBy, search);
                    if (newAppsResult.resultType == "Ok") {
                        applicationsResult.data.applications.push(...newAppsResult.data.applications);
                        latestLoaded = newAppsResult.data.applications.length;
                    } else {
                        applicationsResult = newAppsResult;
                        break;
                    }
                    page = page + 1;
                }
            } else applicationsResult = await _api.searchForApplications(organizationId, (page - 1) * take, take, sortBy, search);
            if (applicationsResult.resultType == "Ok") this.setState({
                ...this.state,
                errors: [],
                cachedApplications: this.state.cachedApplications.map((a)=>applicationsResult.data.applications.some((ra)=>ra?.id == a?.id) ? applicationsResult.data.applications.find((ra)=>ra?.id == a?.id) : a)
            });
            else this.setState({
                ...this.state,
                errors: applicationsResult.errors
            });
            return applicationsResult;
        } catch (error) {
            this.setState({
                ...this.state,
                errors: [
                    error.toString()
                ],
                isLoadingApps: false
            });
        }
    }
    async searchForOrgApplications(organizationId, page = 1, take = 30, sortBy = "CreatedDateDescending", search = "", loadAll = false) {
        try {
            if (organizationId != this.state.organizationId) await this.setState({
                ...this.state,
                cachedApplications: []
            });
            await this.setState({
                ...this.state,
                isLoadingApps: true,
                organizationId: organizationId
            });
            let applicationsResult = {
                resultType: "Ok",
                errors: [],
                data: {
                    applications: []
                }
            };
            if (loadAll) {
                let latestLoaded = take;
                while(latestLoaded === take){
                    const newAppsResult = await _api.searchForApplications(organizationId, (page - 1) * take, take, sortBy, search);
                    if (newAppsResult.resultType == "Ok") {
                        applicationsResult.data.applications.push(...newAppsResult.data.applications);
                        latestLoaded = newAppsResult.data.applications.length;
                    } else {
                        applicationsResult = newAppsResult;
                        break;
                    }
                    page = page + 1;
                }
            } else applicationsResult = await _api.searchForApplications(organizationId, (page - 1) * take, take, sortBy, search);
            if (applicationsResult.resultType == "Ok") this.setState({
                ...this.state,
                errors: [],
                orgApplicationsList: applicationsResult.data.applications,
                cachedApplications: this.state.cachedApplications.map((cachedApp)=>{
                    const updated = applicationsResult.data.applications.find((appResult)=>appResult?.id == cachedApp?.id);
                    return updated ? {
                        ...cachedApp,
                        ...updated
                    } : cachedApp;
                }),
                applicationsCount: applicationsResult.data.total,
                isLoadingApps: false
            });
            else this.setState({
                ...this.state,
                errors: applicationsResult.errors,
                isLoadingApps: false
            });
            return applicationsResult;
        } catch (error) {
            this.setState({
                ...this.state,
                errors: [
                    error.toString()
                ],
                isLoadingApps: false
            });
        }
    }
    createApplication(organizationId, model) {
        this.setState({
            ...this.state,
            isCreatingApplication: true
        });
        return new Promise(async (resolve)=>{
            try {
                var requestModel = {
                    name: model.name,
                    description: model.description,
                    shortDescription: model.shortDescription,
                    invocationPhrase: model.invocationPhrase,
                    keywords: model.keywords,
                    defaultLanguageId: model.defaultLanguageId
                };
                const promise = model.withSamples ? _api.createApplicationWithSamples(organizationId, requestModel) : _api.createEmptyApplication(organizationId, requestModel);
                const result = await promise;
                if (result.resultType != "Ok") {
                    this.setState({
                        ...this.state,
                        isCreatingApplication: false,
                        createErrors: result.errors
                    });
                    resolve(result);
                    return;
                }
                // successfully created, kick off image upload and set as well as template creation   
                if (model.imageFile) {
                    const urlResult = await _api.getUploadUrl(result.data.id, model.imageFile.name, model.imageFile.name);
                    if (urlResult.resultType == "Ok") {
                        // we have the url, upload to s3
                        const uploadResult = await _api.uploadDirect(urlResult.data, model.imageFile, ()=>{});
                        if (uploadResult.resultType == "Ok") {
                            // upload is good, let's add the media item
                            const createResult = await _api.createMediaItem(result.data.id, {
                                name: model.imageFile.name,
                                fileName: model.imageFile.name,
                                url: urlResult.data.split("?")[0],
                                caption: "Application Avatar"
                            });
                            if (createResult.resultType == "Ok") // media item creation is good, lets set it as the application image. 
                            await _api.setApplicationImage(result.data.id, createResult.data.id);
                        }
                    }
                }
                if (model.templates.length > 0) {
                    const templateResult = await _api.addTemplateContentToApplication(result.data.id, model.templates);
                    if (templateResult.resultType == "Ok") {
                        this.setState({
                            ...this.state,
                            isCreatingApplication: false
                        });
                        resolve(templateResult);
                    }
                } else {
                    this.setState({
                        ...this.state,
                        isCreatingApplication: false
                    });
                    resolve(result);
                }
            } catch  {
                this.setState({
                    ...this.state,
                    isCreatingApplication: false
                });
            }
        });
    }
    disableApplication(applicationId) {
        this.setState({
            ...this.state,
            isLoadingApps: true
        });
        var promise = _api.disableApplication(applicationId);
        promise.then((result)=>{
            if (result.resultType != "Ok") this.setState({
                ...this.state,
                isCreatingApplication: false,
                errors: result.errors
            });
            else this.setState({
                ...this.state,
                isLoadingApps: false,
                errors: []
            });
        }).catch((error)=>{
            this.setState({
                ...this.state,
                isLoadingApps: false,
                errors: [
                    error.toString()
                ]
            });
        });
        return promise;
    }
    createApplicationWithTemplates(model, imageFile) {
        this.setState({
            ...this.state,
            isCreatingApplication: true
        });
        return new Promise((resolve)=>{
            const promise = _api.createApplicationFromTemplateForms(model);
            promise.then((result)=>{
                if (result.resultType != "Ok") {
                    this.setState({
                        ...this.state,
                        isCreatingApplication: false,
                        createErrors: result.errors
                    });
                    resolve(result);
                    return;
                }
                // successfully created, kick off image upload and set as well as template creation
                if (imageFile) _api.getUploadUrl(result.data.id, imageFile.name, imageFile.name).then((urlResult)=>{
                    if (urlResult.resultType == "Ok") // we have the url, upload to s3
                    _api.uploadDirect(urlResult.data, imageFile, ()=>{}).then((uploadResult)=>{
                        if (uploadResult.resultType == "Ok") // upload is good, let's add the media item
                        _api.createMediaItem(result.data.id, {
                            name: imageFile.name,
                            fileName: imageFile.name,
                            url: urlResult.data.split("?")[0],
                            caption: "Application Avatar"
                        }).then((createResult)=>{
                            if (createResult.resultType == "Ok") _api.setApplicationImage(result.data.id, createResult.data.id);
                        });
                    });
                });
                else {
                    this.setState({
                        ...this.state,
                        errors: result.errors,
                        isCreatingApplication: false
                    });
                    resolve(result);
                }
            }).catch((e)=>{
                this.setState({
                    ...this.state,
                    isCreatingApplication: false,
                    errors: [
                        e?.toString()
                    ]
                });
            });
        });
    }
    updateApplication(applicationId, model) {
        this.setState({
            ...this.state,
            isCreatingApplication: true
        });
        const promise = _api.updateApplication(applicationId, model);
        promise.then((result)=>{
            if (result.resultType != "Ok") this.setState({
                ...this.state,
                isCreatingApplication: false,
                errors: result.errors
            });
            else {
                // update the app locally
                const app = this.state.currentApp ? {
                    ...this.state.currentApp,
                    ...result.data
                } : result.data;
                // Also update the app in cached lists
                const updatedOrgApplicationsList = this.state.orgApplicationsList?.map((a)=>a.id === applicationId ? {
                        ...a,
                        ...result.data
                    } : a);
                const updatedCachedApplications = this.state.cachedApplications?.map((a)=>a.id === applicationId ? {
                        ...a,
                        ...result.data
                    } : a);
                this.setState({
                    ...this.state,
                    isCreatingApplication: false,
                    errors: [],
                    currentApp: app,
                    orgApplicationsList: updatedOrgApplicationsList,
                    cachedApplications: updatedCachedApplications
                });
            }
        }).catch((error)=>{
            this.setState({
                ...this.state,
                isCreatingApplication: false,
                errors: [
                    error.toString()
                ]
            });
        });
        return promise;
    }
    updateFeatureFlagSettings(applicationId, model) {
        this.setState({
            ...this.state,
            isUpdatingFeatureFlagSettings: true
        });
        const promise = _api.updateApplicationFeatureFlagSettings(applicationId, model);
        promise.then((result)=>{
            if (result.resultType != "Ok") this.setState({
                ...this.state,
                isUpdatingFeatureFlagSettings: false,
                errors: result.errors
            });
            else {
                // update the app locally
                const app = this.state.currentApp;
                if (app) app.featureFlags = result.data.featureFlags;
                this.setState({
                    ...this.state,
                    isUpdatingFeatureFlagSettings: false,
                    errors: [],
                    currentApp: app
                });
            }
        }).catch((error)=>{
            this.setState({
                ...this.state,
                isUpdatingFeatureFlagSettings: false,
                errors: [
                    error.toString()
                ]
            });
        });
        return promise;
    }
    async updateDetailedAnalytics(applicationId, enabled) {
        try {
            if (enabled) await _api.enableDetailedAnalytics(applicationId);
            else await _api.disableDetailedAnalytics(applicationId);
        } catch (error) {
            this.setState({
                ...this.state,
                errors: [
                    error.toString()
                ]
            });
        }
    }
    updateApplicationImage(applicationId, imageFile) {
        const promise = _api.uploadMediaItem(applicationId, "applicationAvatar", imageFile);
        promise.then((imgResult)=>{
            if (imgResult.resultType == "Ok") {
                const imageItemId = imgResult.data.id;
                _api.setApplicationImage(applicationId, imageItemId).then((result)=>{
                    if (result.resultType != "Ok") this.setState({
                        ...this.state,
                        isCreatingApplication: false,
                        errors: result.errors
                    });
                    else {
                        const imageUrl = result.data.imageUrl;
                        // update the app locally
                        let apps = [
                            ...this.state.cachedApplications
                        ];
                        let app = this.state.currentApp;
                        if (app) {
                            app.imageItemId = imageItemId;
                            app.imageUrl = imageUrl;
                            apps[apps.findIndex((a)=>a.id == applicationId)] = app;
                        }
                        this.setState({
                            ...this.state,
                            isCreatingApplication: false,
                            errors: [],
                            cachedApplications: apps,
                            currentApp: app
                        });
                    }
                }).catch((error)=>{
                    this.setState({
                        ...this.state,
                        isCreatingApplication: false,
                        errors: [
                            error.toString()
                        ]
                    });
                });
            } else this.setState({
                ...this.state,
                isCreatingApplication: false,
                errors: imgResult.errors
            });
        }).catch((error)=>{
            this.setState({
                ...this.state,
                isCreatingApplication: false,
                errors: [
                    error.toString()
                ]
            });
        });
        return promise;
    }
    addModulesAndTemplatesToApplication(applicationId, templates, modules) {
        this.setState({
            ...this.state,
            isAddingModules: true
        });
        return new Promise((resolve, reject)=>{
            if (templates.length == 0 && modules.length == 0) {
                resolve({
                    data: null,
                    resultType: "Ok",
                    errors: null
                });
                this.setState({
                    ...this.state,
                    isAddingModules: false
                });
            } else if (templates.length > 0 && modules.length > 0) _api.addTemplateContentToApplication(applicationId, templates).then((result)=>{
                if (result.resultType != "Ok") {
                    this.setState({
                        ...this.state,
                        isAddingModules: false
                    });
                    reject(result.errors);
                } else _api.addModulesToApp(applicationId, modules).then((modulesResult)=>{
                    this.setState({
                        ...this.state,
                        isAddingModules: false
                    });
                    resolve(modulesResult);
                });
            }).catch((error)=>{
                this.setState({
                    ...this.state,
                    isAddingModules: false
                });
                resolve(error);
            });
            else if (templates.length > 0) _api.addTemplateContentToApplication(applicationId, templates).then((result)=>{
                if (result.resultType != "Ok") {
                    this.setState({
                        ...this.state,
                        isAddingModules: false
                    });
                    reject(result.errors);
                } else resolve(result);
            }).catch((error)=>{
                this.setState({
                    ...this.state,
                    isAddingModules: false
                });
                resolve(error);
            });
            else _api.addModulesToApp(applicationId, modules).then((result)=>{
                if (result.resultType != "Ok") {
                    this.setState({
                        ...this.state,
                        isAddingModules: false
                    });
                    reject(result.errors);
                } else resolve(result);
            }).catch((error)=>{
                this.setState({
                    ...this.state,
                    isAddingModules: false
                });
                resolve(error);
            });
        });
    }
    getEndpoints(applicationId) {
        if (this.state.applicationEndpoints.some((a)=>a.applicationId == applicationId)) return new Promise((resolve)=>{
            resolve({
                errors: [],
                resultType: "Ok",
                data: this.state.applicationEndpoints.find((a)=>a.applicationId == applicationId)
            });
        });
        this.setState({
            ...this.state,
            isLoadingEndpoints: true
        });
        var promise = _api.getApplicationFulfillmentEndpoints(applicationId);
        promise.then((result)=>{
            if (result.resultType == "Ok") {
                const appEndpoints = this.state.applicationEndpoints;
                appEndpoints.push(result.data);
                this.setState({
                    ...this.state,
                    isLoadingEndpoints: false,
                    applicationEndpoints: appEndpoints
                });
            } else this.setState({
                ...this.state,
                isLoadingEndpoints: false,
                errors: result.errors
            });
        }).catch((error)=>{
            this.setState({
                ...this.state,
                isLoadingEndpoints: false,
                errors: [
                    error.toString()
                ]
            });
        });
        return promise;
    }
    updateApplicationLanguages(applicationId, languages) {
        const apps = [
            ...this.state.cachedApplications
        ];
        const app = this.state.currentApp;
        app.languages = languages;
        this.setState({
            ...this.state,
            cachedApplications: [
                ...apps
            ],
            currentApp: app
        });
        var promise = _api.updateApplicationLanguages(applicationId, languages.map((l)=>l.id));
        promise.then((result)=>{
            if (result.resultType != "Ok") // revert local change
            this.setState({
                ...this.state,
                errors: result.errors
            });
        }).catch((err)=>{
            this.setState({
                ...this.state,
                errors: [
                    err.toString()
                ]
            });
        });
        return promise;
    }
    syncNLPAndInteractionModel(applicationId, languageIds, sourceLanguageId) {
        const apps = [
            ...this.state.cachedApplications
        ];
        const app = this.state.currentApp;
        this.setState({
            ...this.state,
            isSyncingNLPAndInteractionModel: true
        });
        var promise = _api.syncNLPAndInteractionModel(applicationId, languageIds, sourceLanguageId);
        promise.then((result)=>{
            if (result.resultType != "Ok") // revert local change
            this.setState({
                ...this.state,
                errors: result.errors,
                isSyncingNLPAndInteractionModel: false
            });
            else this.setState({
                ...this.state,
                isSyncingNLPAndInteractionModel: false
            });
        }).catch((err)=>{
            this.setState({
                ...this.state,
                errors: [
                    err.toString()
                ],
                isSyncingNLPAndInteractionModel: false
            });
        });
        return promise;
    }
    updateApplicationDefaultLanguage(applicationId, languageId) {
        const apps = [
            ...this.state.cachedApplications
        ];
        const app = this.state.currentApp;
        app.defaultLanguageId = languageId;
        this.setState({
            ...this.state,
            cachedApplications: apps,
            currentApp: app
        });
        var promise = _api.updateApplicationDefaultLanguage(applicationId, languageId);
        promise.then((result)=>{
            if (result.resultType != "Ok") // revert local change
            this.setState({
                ...this.state,
                errors: result.errors
            });
        }).catch((err)=>{
            this.setState({
                ...this.state,
                errors: [
                    err.toString()
                ]
            });
        });
        return promise;
    }
    toggleTemplating(applicationId, allowsTemplating) {
        this.setState({
            ...this.state,
            isSaving: true
        });
        var promise = _api.toggleAllowsTemplating(applicationId, allowsTemplating);
        promise.then((result)=>{
            if (result.resultType != "Ok") this.setState({
                ...this.state,
                errors: result.errors,
                isSaving: false
            });
            else this.setState({
                ...this.state,
                isSaving: false
            });
        }).catch((err)=>{
            this.setState({
                ...this.state,
                errors: [
                    err.toString()
                ],
                isSaving: false
            });
        });
        return promise;
    }
    setLoading(isLoading) {
        this.setState({
            ...this.state,
            isLoadingApps: isLoading
        });
    }
    async clearErrors() {
        await this.setState({
            ...this.state,
            errors: []
        });
    }
}
exports.default = ApplicationContainer;

},{"@babel/runtime/helpers/defineProperty":"9sJxO","unstated":"grh7p","../../api":"loxM6","lodash":"3hMBK","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2pLJf":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _moment = require("moment");
var _momentDefault = parcelHelpers.interopDefault(_moment);
var _featureToolbar = require("../../featureContent/components/FeatureToolbar");
var _featureToolbarDefault = parcelHelpers.interopDefault(_featureToolbar);
var _footerBar = require("../../../components/structure/FooterBar");
var _footerBarDefault = parcelHelpers.interopDefault(_footerBar);
var _button = require("../../../components/general/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _css = require("@emotion/css");
var _featureContent = require("../../featureContent");
var _featureContentDefault = parcelHelpers.interopDefault(_featureContent);
var _customScrollbars = require("../../../components/structure/CustomScrollbars");
var _customScrollbarsDefault = parcelHelpers.interopDefault(_customScrollbars);
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
class InnerContentExplorer extends (0, _reactDefault.default).Component {
    constructor(props){
        super(props);
        const rootId = this.props.featureContainer.getRootFeature(this.props.applicationId)?.id;
        this.state = {
            filters: this.props.initialFilter ?? {},
            currentFeatureId: props.initialApplicationFeatureId ?? rootId,
            newStubFeatureTypeId: null,
            isAddingNewFeature: false,
            selectedContentItems: [],
            selectedFeatureIds: this.props.exploreType == "feature-select" ? [
                rootId
            ] : [],
            // default select the root when selecting a folder
            featureHistory: [],
            selectionText: "",
            isFilterExpanded: false
        };
    }
    componentWillMount() {
        this.loadContent();
    }
    componentDidUpdate(prevProps, prevState) {
        if (prevState.currentFeatureId != this.state.currentFeatureId) this.loadContent();
    }
    loadContent() {
        this.props.featureContainer.getContentItemsForAppFeature(this.state.currentFeatureId ?? this.props.featureContainer.state.currentTopicFeatureId);
    }
    handleStartAddNewFeature() {
        this.setState({
            ...this.state,
            isAddingNewFeature: true
        });
    }
    handleAddNewFeature(text, applicationFeatureId) {
        this.props.featureContainer.addApplicationFeature(this.props.applicationId, text, applicationFeatureId).then((result)=>{
            if (result.resultType == "Ok") this.setState({
                ...this.state,
                isAddingNewFeature: false
            });
        });
    }
    getBreadCrumbItems() {
        var ancestors = this.props.featureContainer.getAllAncestors(this.state.currentFeatureId);
        var crumbs = ancestors?.reverse()?.map((af)=>({
                id: af?.id,
                title: af?.name ?? af.feature?.name ?? af?.feature?.featureType?.name ?? "Untitled",
                link: "#",
                highlighted: this.state.selectedFeatureIds[0] == af?.id
            }));
        if (this.state.selectedFeatureIds[0] != this.state.currentFeatureId) {
            const af = this.props.featureContainer.findFeatureById(this.state.selectedFeatureIds[0]);
            if (af) crumbs.push({
                id: af.id,
                title: af?.name ?? af.feature?.name ?? af?.feature?.featureType?.name ?? "Untitled",
                highlighted: true,
                link: "#"
            });
        }
        return crumbs;
    }
    handleFilterChange(filters) {
        this.setState({
            ...this.state,
            filters
        });
    }
    getFilteredFeatures(applicationFeatureId) {
        var features = this.props.featureContainer.getFeaturesForParent(applicationFeatureId);
        if (this.state.filters.textFilter) features = features.filter((af)=>(af.name ?? af.feature.name)?.toLowerCase().indexOf(this.state.filters.textFilter.toLowerCase()) > -1);
        return features;
    }
    getFilteredContent(applicationFeatureId) {
        var content = this.props.featureContainer.getContentByFeatureId(applicationFeatureId);
        if (this.state.filters.textFilter) content = content.filter((c)=>(c.title ?? "untitled")?.toLowerCase().indexOf(this.state.filters.textFilter.toLowerCase()) > -1);
        if (this.state.filters.featureTypeIdsFilter && this.state.filters.featureTypeIdsFilter.length > 0) content = content.filter((c)=>this.state.filters.featureTypeIdsFilter.some((id)=>id == c.featureTypeId));
        if (this.state.filters.languageIdsFilter) content = content.filter((c)=>this.state.filters.languageIdsFilter?.some((id)=>c.languages?.some((l)=>l.id == id)));
        if (this.state.filters.daysFilter) content = content.filter((c)=>(0, _momentDefault.default)().diff((0, _momentDefault.default)(c.modifiedDate), "days") <= this.state.filters.daysFilter);
        if (this.state.filters.propertiesFilter) {
            const { hasImage, hasAudio, hasVideo, isActive, isInactive, isIncomplete } = this.state.filters.propertiesFilter;
            if (hasImage) content = content.filter((c)=>c.hasForegroundImage || c.hasBackgroundImage);
            if (hasAudio) content = content.filter((c)=>c.hasAudio);
            if (hasVideo) content = content.filter((c)=>c.hasVideo);
            // these need to be grouped
            content = content.filter((c)=>!isActive && !isInactive && !isIncomplete || isActive && c.isLive || isInactive && !c.isLive || isIncomplete && !c.isComplete);
        }
        return content;
    }
    handleContentItemSelectionChange(contentItem, isSelected) {
        const selectedContentItems = this.props.exploreType == "content-select" ? [] : this.state.selectedContentItems;
        if (isSelected) selectedContentItems.push(contentItem);
        else if (this.props.exploreType == "content-multi-select") selectedContentItems.splice(selectedContentItems.indexOf(contentItem), 1);
        this.setState({
            ...this.state,
            selectedContentItems: selectedContentItems
        }, ()=>{
            if (this.props.onSelectionChange) this.props.onSelectionChange(this.state.selectedContentItems, this.state.selectedFeatureIds);
        });
    }
    handleFeatureSelectionChange(applicationFeature, isSelected) {
        var selectedIds = this.state.selectedFeatureIds;
        if (isSelected) {
            if (this.props.exploreType == "feature-select") selectedIds = [
                applicationFeature?.id
            ];
            else selectedIds.push(applicationFeature?.id);
        } else {
            selectedIds.splice(selectedIds.indexOf(applicationFeature.id), 1);
            if (this.props.exploreType == "feature-select") selectedIds.push(this.state.currentFeatureId);
        }
        this.setState({
            ...this.state,
            selectedFeatureIds: selectedIds
        }, ()=>{
            if (this.props.onSelectionChange) this.props.onSelectionChange(this.state.selectedContentItems, this.state.selectedFeatureIds);
        });
    }
    handleClearSelections() {
        this.setState({
            ...this.state,
            selectedContentItems: [],
            selectedFeatureIds: []
        });
    }
    handleFeatureClick(applicationFeature) {
        const history = this.state.featureHistory;
        history.push(applicationFeature);
        this.setState({
            ...this.state,
            currentFeatureId: applicationFeature?.id,
            featureHistory: history,
            selectedFeatureIds: this.props.exploreType == "feature-select" ? [
                applicationFeature?.id
            ] : [] // select the folder we navigate to when using folder selection
        });
    }
    handleFinishSelection() {
        this.props.onSelect(this.state.selectedContentItems, this.state.selectedFeatureIds);
    }
    handleAddNewContent(featureTypeId) {
        this.setState({
            ...this.state,
            newStubFeatureTypeId: featureTypeId
        });
    }
    handleStubAdded(contentItem) {
        this.props.featureContainer.addContentItemToState(contentItem);
        this.setState({
            ...this.state,
            newStubFeatureTypeId: null
        });
    }
    handleBreadcrumbClick(item) {
        this.setState({
            ...this.state,
            currentFeatureId: item.id
        });
    }
    handleFilterToggle() {
        this.setState({
            ...this.state,
            isFilterExpanded: !this.state.isFilterExpanded
        });
    }
    render() {
        const feature = this.props.featureContainer.findFeatureById(this.state.currentFeatureId ?? this.props.featureContainer.state.currentTopicFeatureId);
        const application = this.props.appContainer.state.currentApp;
        const childContent = this.getFilteredContent(feature?.id);
        const childFeatures = this.getFilteredFeatures(feature?.id);
        const nonFilteredContent = this.props.featureContainer.getContentByFeatureId(feature?.id);
        const isContentFiltered = nonFilteredContent?.length > childContent?.length;
        return (0, _react.jsx)("div", {
            className: containerStyle
        }, (0, _react.jsx)((0, _featureToolbarDefault.default), {
            applicationFeatureId: feature?.id,
            application: application,
            filters: this.state.filters,
            isFilterExpanded: this.state.isFilterExpanded,
            onToggleFilters: this.handleFilterToggle.bind(this),
            onAddNewFeature: this.handleStartAddNewFeature.bind(this),
            onAddNewContent: this.handleAddNewContent.bind(this),
            breadCrumbs: this.getBreadCrumbItems(),
            onBreadCrumbItemClick: this.handleBreadcrumbClick.bind(this),
            featureContainer: this.props.featureContainer,
            onImport: ()=>null,
            groupSelectionState: "none",
            allowImport: false,
            disableCreateContent: this.props.exploreType == "feature-select",
            highlightedBreadcrumbId: this.state.selectedFeatureIds[0],
            history: null
        }), (0, _react.jsx)((0, _customScrollbarsDefault.default), {
            autoHide: true,
            className: "scrollable-container"
        }, (0, _react.jsx)((0, _featureContentDefault.default), {
            feature: feature,
            showContentItemStatus: false,
            handlePublish: null,
            handleUnpublish: null,
            webhookContainer: null,
            application: application,
            isAddingNewFeature: this.state.isAddingNewFeature,
            featureContainer: this.props.featureContainer,
            onFilterChange: this.handleFilterChange.bind(this),
            childFeatures: childFeatures,
            contentItems: childContent,
            handleAddNewFeature: this.handleAddNewFeature.bind(this),
            withNesting: this.props.withNesting,
            applicationId: this.props.applicationId,
            selectedContentItemIds: this.state.selectedContentItems?.map((c)=>c.id),
            selectedFeatureIds: this.state.selectedFeatureIds,
            onFeatureClick: this.handleFeatureClick.bind(this),
            onContentItemSelectionChange: this.handleContentItemSelectionChange.bind(this),
            onFeatureSelectionChange: this.handleFeatureSelectionChange.bind(this),
            selectableFeatures: this.props.exploreType == "feature-select",
            selectableContentItems: this.props.exploreType != "feature-select",
            showContentItems: this.props.exploreType != "feature-select",
            onStubAdded: this.handleStubAdded.bind(this),
            newStubFeatureTypeId: this.state.newStubFeatureTypeId,
            navigatingContentItems: false,
            disablingFilters: this.props.disablingFilter,
            droppableId: "features_modal",
            isSingleSelect: this.props.exploreType != "content-multi-select",
            filters: this.state.filters,
            isFilterExpanded: this.state.isFilterExpanded,
            isContentFiltered: isContentFiltered
        })), (0, _react.jsx)((0, _footerBarDefault.default), {
            small: true
        }, (0, _react.jsx)((0, _buttonDefault.default), {
            themes: [
                "primary"
            ],
            text: "Select",
            type: "button",
            loading: this.props.isLoading,
            disabled: this.props.isLoading || this.state.selectedContentItems.length < 1 && this.state.selectedFeatureIds.length < 1,
            onClick: this.handleFinishSelection.bind(this)
        })));
    }
}
const containerStyle = /*#__PURE__*/ (0, _css.css)({
    name: "865mlu",
    styles: "height:100%;padding-bottom:80px;display:flex;flex-direction:column;.scrollable-container{margin-bottom:120px;}"
});
exports.default = InnerContentExplorer;

},{"@emotion/react":"djZKr","react":"6uln9","moment":"2meyw","../../featureContent/components/FeatureToolbar":"avRgQ","../../../components/structure/FooterBar":"bibRL","../../../components/general/Button":"6ymxN","@emotion/css":"awUBr","../../featureContent":"cSo8d","../../../components/structure/CustomScrollbars":"50vFq","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"avRgQ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getFilterCount", ()=>getFilterCount);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _colors = require("../../../constants/colors");
var _button = require("../../../components/general/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _newFeatureOrContentPicker = require("./NewFeatureOrContentPicker");
var _newFeatureOrContentPickerDefault = parcelHelpers.interopDefault(_newFeatureOrContentPicker);
var _breadcrumb = require("../../../components/general/Breadcrumb");
var _breadcrumbDefault = parcelHelpers.interopDefault(_breadcrumb);
var _checkIndicator = require("../../../components/forms/CheckIndicator");
var _checkIndicatorDefault = parcelHelpers.interopDefault(_checkIndicator);
var _conditionalTooltipWrapper = require("../../../components/general/ConditionalTooltipWrapper");
var _conditionalTooltipWrapperDefault = parcelHelpers.interopDefault(_conditionalTooltipWrapper);
const filterIcon = require("96ee20814b8bafcd");
const filterBlueIcon = require("6bc4d627a800749f");
const addIcon = require("2f864e8a10e5610d");
const publishIcon = require("e8ec78a260ccde7e");
class FeatureToolbar extends (0, _reactDefault.default).Component {
    constructor(props){
        super(props);
        this.state = {
            isAddNewExpanded: false
        };
    }
    handleToggleAddNew() {
        this.setState({
            ...this.state,
            isAddNewExpanded: !this.state.isAddNewExpanded
        });
    }
    handleNewSelected(newContent) {
        if (newContent.type == "contentItem") this.props.onAddNewContent(newContent.feature.featureType.id);
        else if (newContent.type == "folder") this.props.onAddNewFeature();
        else if (newContent.type == "import") this.props.onImport();
        this.setState({
            ...this.state,
            isAddNewExpanded: !this.state.isAddNewExpanded
        });
    }
    renderFilterRight() {
        // if we have any active filters, show the number. Otherwise show the icon based on expanded state
        if (getFilterCount(this.props.filters) > 0) return (0, _react.jsx)("div", {
            className: "filter-right filter-count"
        }, (0, _react.jsx)("span", null, getFilterCount(this.props.filters)));
        else if (this.props.isFilterExpanded) return (0, _react.jsx)("div", {
            className: "filter-right"
        }, (0, _react.jsx)("img", {
            src: filterBlueIcon
        }));
        else return (0, _react.jsx)("div", {
            className: "filter-right"
        }, (0, _react.jsx)("img", {
            src: filterIcon
        }));
    }
    render() {
        return (0, _react.jsx)("div", {
            className: containerStyle
        }, (0, _react.jsx)("div", {
            className: "tool-bar-container"
        }, this.props.onSelectAll && (0, _react.jsx)("div", {
            className: "group-select-container"
        }, (0, _react.jsx)((0, _checkIndicatorDefault.default), {
            onClick: ()=>this.props.onSelectAll(),
            partial: this.props.groupSelectionState == "partial",
            checked: this.props.groupSelectionState == "all"
        }), (0, _react.jsx)("img", {
            src: this.props.icon
        })), (0, _react.jsx)((0, _breadcrumbDefault.default), {
            items: this.props.breadCrumbs,
            onItemClick: this.props.onBreadCrumbItemClick
        }), (0, _react.jsx)("div", {
            className: `filter-button ${getFilterCount(this.props.filters) > 0 ? "applied-filters" : ""}`
        }, (0, _react.jsx)((0, _buttonDefault.default), {
            themes: [
                "white-icon"
            ],
            text: "",
            onClick: this.props.onToggleFilters,
            additionalClasses: this.props.isFilterExpanded ? "expanded" : null,
            rightComponent: ()=>this.renderFilterRight()
        })), this.props.onFullPublish != null && (0, _react.jsx)((0, _conditionalTooltipWrapperDefault.default), {
            showTooltip: !this.props.isAppAdmin,
            place: "bottom",
            text: "Only App Admins can publish content"
        }, (0, _react.jsx)("div", {
            className: "publish-button"
        }, (0, _react.jsx)((0, _buttonDefault.default), {
            disabled: !this.props.isAppAdmin,
            themes: [
                "secondary-small"
            ],
            className: "ac-publish-all",
            text: "Publish",
            onClick: ()=>this.props.onFullPublish(),
            type: "button",
            rightIcon: publishIcon
        }))), (0, _react.jsx)("div", {
            className: "add-button"
        }, (0, _react.jsx)((0, _buttonDefault.default), {
            themes: [
                "primary-small"
            ],
            className: "ac-new-content-button",
            text: "Add New",
            onClick: this.handleToggleAddNew.bind(this),
            type: "button",
            rightIcon: addIcon
        }), this.state.isAddNewExpanded && (0, _react.jsx)((0, _newFeatureOrContentPickerDefault.default), {
            position: "right",
            allowImport: this.props.allowImport,
            featuresOnly: this.props.disableCreateContent,
            featureContainer: this.props.featureContainer,
            onClose: this.handleToggleAddNew.bind(this),
            onSelected: this.handleNewSelected.bind(this)
        }))));
    }
}
const getFilterCount = (filters)=>{
    var count = 0;
    if (filters.textFilter && filters.textFilter.length > 0) count++;
    if (filters.daysFilter) count++;
    if (filters.featureTypeIdsFilter && filters.featureTypeIdsFilter.length > 0) count++;
    if (filters.languageIdsFilter && filters.languageIdsFilter.length > 0) count++;
    if (filters.propertiesFilter) {
        var hasPropertyFilters = Object.keys(filters.propertiesFilter).map((key)=>filters.propertiesFilter[key]).filter((val)=>val === true).length > 0;
        if (hasPropertyFilters) count++;
    }
    return count;
};
const containerStyle = /*#__PURE__*/ (0, _css.css)("background:", (0, _colors.color_defaults_white), ";.tool-bar-container{border-bottom:1px solid ", (0, _colors.color_shades_dark), ";display:flex;align-items:center;padding:0 24px;height:56px;}.group-select-container{display:flex;align-items:center;padding:0 12px 0 8px;margin-right:12px;border-right:1px solid ", (0, _colors.color_shades_dark), ";}button{margin:0;&.expanded{background:linear-gradient(0deg, rgba(30, 126, 185, 0.07), rgba(30, 126, 185, 0.07)),#FFFFFF;border:1px solid ", (0, _colors.color_text_link), ";color:", (0, _colors.color_text_link), ";}&.search-button{margin:0 16px;padding:0 16px;.right-img{margin:0;}}.filter-right{width:20px;img{width:16px;height:16px;}}.filter-count{border-radius:50%;color:white;display:flex;align-items:center;justify-content:center;background:", (0, _colors.color_text_link), ";width:20px;height:20px;span{font-style:normal;font-weight:600;font-size:10px;line-height:16px;}}}.filter-button{margin-right:16px;margin-left:auto;&.applied-filter button{border:1px solid ", (0, _colors.color_text_link), ";color:", (0, _colors.color_text_link), ";}}.publish-button{margin-right:16px;}.add-button{margin-right:16px;margin-left:auto;position:relative;}", "");
exports.default = FeatureToolbar;

},{"@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","../../../constants/colors":"1p3OR","../../../components/general/Button":"6ymxN","./NewFeatureOrContentPicker":"9xXeV","../../../components/general/Breadcrumb":"euZw9","../../../components/forms/CheckIndicator":"8zBm6","../../../components/general/ConditionalTooltipWrapper":"92m0T","96ee20814b8bafcd":"12yk6","6bc4d627a800749f":"2CYnZ","2f864e8a10e5610d":"i0YpA","e8ec78a260ccde7e":"dL9sH","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9xXeV":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _defineProperty = require("@babel/runtime/helpers/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _colors = require("../../../constants/colors");
var _featureSelectListItem = require("./FeatureSelectListItem");
var _secondaryLoader = require("../../../components/general/SecondaryLoader");
var _secondaryLoaderDefault = parcelHelpers.interopDefault(_secondaryLoader);
var _customScrollbars = require("../../../components/structure/CustomScrollbars");
var _customScrollbarsDefault = parcelHelpers.interopDefault(_customScrollbars);
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const folderIcon = require("a5a0747930f57c21");
const importIcon = require("6efeaa656b4fd3e8");
class NewFeatureOrContentPicker extends (0, _reactDefault.default).Component {
    constructor(...args){
        super(...args);
        (0, _definePropertyDefault.default)(this, "documentCloser", this.handleDocumentClick.bind(this));
    }
    componentWillMount() {
        this.setState({
            isCollapsed: true
        });
        document.addEventListener("click", this.documentCloser, true);
        this.props.featureContainer.getSystemFeatures();
    }
    componentWillUnmount() {
        document.removeEventListener("click", this.documentCloser, true);
    }
    handleDocumentClick(e) {
        if (e.target.closest(".selector-wrapper") || e.target.closest(".selection-container")) return;
        this.props.onClose();
    }
    handleSelectionChange(feature) {
        this.props.onSelected({
            feature: feature,
            type: "contentItem"
        });
    }
    handleNewFolder() {
        this.props.onSelected({
            type: "folder"
        });
    }
    handleImport() {
        this.props.onSelected({
            type: "import"
        });
    }
    render() {
        const features = this.props.featureTypeIdsFilter && this.props.isFiltered && this.props.featureTypeIdsFilter.length > 0 ? this.props.featureContainer.state.systemFeatures.filter((s)=>this.props.featureTypeIdsFilter.some((id)=>id == s.featureType.id)) : this.props.featureContainer.state.systemFeatures;
        return (0, _react.jsx)("div", {
            className: containerStyle + " " + (this.props.position == "left" ? leftStyle : rightStyle)
        }, (0, _react.jsx)("div", {
            className: "selector-wrapper"
        }, (0, _react.jsx)("div", {
            className: triangleStyle
        }), (0, _react.jsx)((0, _customScrollbarsDefault.default), {
            autoHide: true,
            autoHeight: true,
            autoHeightMax: 600,
            className: "inner-wrapper"
        }, !this.props.contentOnly && (0, _react.jsx)("div", {
            className: `${listItemStyle} ac-new-folder`,
            onClick: ()=>this.handleNewFolder()
        }, (0, _react.jsx)("img", {
            src: folderIcon
        }), (0, _react.jsx)("p", null, "New Folder")), !this.props.featuresOnly && (0, _react.jsx)((0, _reactDefault.default).Fragment, null, this.props.featureContainer.state.isLoadingSystemFeatures ? (0, _react.jsx)("div", null, (0, _react.jsx)((0, _secondaryLoaderDefault.default), null)) : features.map((target, i)=>(0, _react.jsx)((0, _featureSelectListItem.FeatureSelectListItem), {
                key: i,
                top: this.props.contentOnly && i == 0,
                bottom: this.props.contentOnly && i == features.length - 1,
                feature: target,
                onSelected: this.handleSelectionChange.bind(this)
            }))), this.props.allowImport && (0, _react.jsx)("div", {
            className: `import ${listItemStyle}`,
            onClick: ()=>this.handleImport()
        }, (0, _react.jsx)("img", {
            src: importIcon
        }), (0, _react.jsx)("p", null, "Import Content")))));
    }
}
const listItemStyle = /*#__PURE__*/ (0, _css.css)("display:flex;flex-direction:row;align-items:center;padding:16px;cursor:pointer;background:white;&.import{border-top:1px solid ", (0, _colors.color_shades_dark), ";}img{width:32px;height:32px;margin:0 16px;}p{color:", (0, _colors.dark_grey_blue), ";font-size:16px;}", "");
const containerStyle = /*#__PURE__*/ (0, _css.css)("position:absolute;.selector-wrapper{width:340px;display:flex;flex-direction:column;margin-left:0;margin-right:0;background:white;margin-bottom:120px;margin-top:-12px;box-shadow:0 4px 4px 0 ", (0, _colors.dark_grey_blue_10), ";border-radius:10px;z-index:100;flex:1;position:absolute;.inner-wrapper{overflow-y:auto;max-height:600px;border:1px solid #cccccc;border-radius:10px;}}.field-label{font-size:14px;color:", (0, _colors.cool_grey), ";background:white;padding-left:32px;padding-top:16px;}", "");
const triangleStyle = /*#__PURE__*/ (0, _css.css)({
    name: "1qgg4j9",
    styles: "z-index:1;transform:rotate(45deg);width:12px;height:12px;margin-top:-14px;margin-bottom:-6px;border-top:solid 1px #cccccc;border-left:solid 1px #cccccc;background:white;margin-right:16px;margin-left:auto"
});
const rightStyle = /*#__PURE__*/ (0, _css.css)({
    name: "18c671m",
    styles: "right:374px;top:82px"
});
const leftStyle = /*#__PURE__*/ (0, _css.css)("top:42px;left:32px;.", triangleStyle, "{margin-left:16px;margin-right:auto;}", "");
exports.default = NewFeatureOrContentPicker;

},{"@babel/runtime/helpers/defineProperty":"9sJxO","@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","../../../constants/colors":"1p3OR","./FeatureSelectListItem":"9b00t","../../../components/general/SecondaryLoader":"7zJiF","../../../components/structure/CustomScrollbars":"50vFq","a5a0747930f57c21":"eLcxf","6efeaa656b4fd3e8":"jlgVO","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9b00t":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "FeatureSelectListItem", ()=>FeatureSelectListItem);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _colors = require("../../../constants/colors");
var _extensions = require("../../../models/extensions");
const containerStyle = /*#__PURE__*/ (0, _css.css)("display:flex;flex-direction:row;align-items:center;padding:16px;cursor:pointer;background:white;img{width:32px;height:32px;margin:0 16px;}p{color:", (0, _colors.dark_grey_blue), ";font-size:16px;}", "");
const FeatureSelectListItem = (props)=>{
    if (props.feature) return (0, _react.jsx)("div", {
        className: `${containerStyle} ${props.viewOnly ? "" : "selectable"} 
                     ${props.top ? "top" : ""} ${props.bottom ? "bottom" : ""}
                    ac-new-content-item ac-new-content-item-${props.feature?.featureType?.id}`,
        onClick: ()=>props.onSelected(props.feature)
    }, (0, _react.jsx)("img", {
        className: "template-icon",
        src: (0, _extensions.getFeatureIcon)(props.feature)
    }), (0, _react.jsx)("p", {
        className: "template-title"
    }, props.feature?.featureType?.name ?? props.feature?.name));
    return null;
};

},{"@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","../../../constants/colors":"1p3OR","../../../models/extensions":"7h01B","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"eLcxf":[function(require,module,exports) {
module.exports = require("a8bd5001f92b0e6a").getBundleURL("kVLro") + require("e8d0dc4fb77a34b6").resolve("inTlE");

},{"a8bd5001f92b0e6a":"c7Tr5","e8d0dc4fb77a34b6":"fyJL2"}],"jlgVO":[function(require,module,exports) {
module.exports = require("86ca2115edd99a33").getBundleURL("kVLro") + require("5fa1f389dd71796a").resolve("c2Cyo");

},{"86ca2115edd99a33":"c7Tr5","5fa1f389dd71796a":"fyJL2"}],"euZw9":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _reactRouterDom = require("react-router-dom");
var _colors = require("../../constants/colors");
const separatorIcon = require("9ddb8cb813ea7dc2");
const renderLink = (props, item, index)=>{
    let title = item.title;
    if (!props.useItemTitleAsHome && index == 0) title = "Home";
    if (props.onItemClick) return (0, _react.jsx)("p", {
        className: "item-link",
        onClick: props.onItemClick ? ()=>props.onItemClick(item) : null
    }, title);
    else return (0, _react.jsx)((0, _reactRouterDom.Link), {
        to: item.link,
        onClick: props.onItemClick ? ()=>props.onItemClick(item) : null
    }, title);
};
const Breadcrumb = (props)=>(0, _react.jsx)("div", {
        className: containerStyle
    }, props.items?.map((item, index)=>{
        const isLast = index >= props.items.length - 1;
        let title = item.title;
        if (!props.useItemTitleAsHome && index == 0) title = "Home";
        return (0, _react.jsx)("div", {
            className: `breadcrumb-item ${item.highlighted ? "highlighted" : ""}`,
            key: index
        }, isLast ? (0, _react.jsx)("p", null, title) : renderLink(props, item, index), !isLast && (0, _react.jsx)("img", {
            src: separatorIcon
        }));
    }));
const containerStyle = /*#__PURE__*/ (0, _css.css)("display:flex;align-items:center;flex:1;.breadcrumb-item{display:flex;align-items:center;img{margin:0 10px;}p,a{font-style:normal;font-weight:normal;font-size:14px;line-height:20px;}p{color:", (0, _colors.color_text_default), ";}a,.item-link{color:", (0, _colors.color_text_light), ";border-radius:5px;padding:0 4px;cursor:pointer;&:hover{color:", (0, _colors.color_text_link), ";background:", (0, _colors.color_variants_ocean_light_1), ";}}&.highlighted{color:", (0, _colors.color_text_link), ";background:", (0, _colors.color_variants_ocean_light_1), ";border-radius:5px;padding:0 4px;}}", "");
exports.default = Breadcrumb;

},{"@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","react-router-dom":"5fzqq","../../constants/colors":"1p3OR","9ddb8cb813ea7dc2":"cbrf2","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"cbrf2":[function(require,module,exports) {
module.exports = require("4c860638426ab2bb").getBundleURL("kVLro") + require("4c898cfec37e59e5").resolve("iPBf3");

},{"4c860638426ab2bb":"c7Tr5","4c898cfec37e59e5":"fyJL2"}],"12yk6":[function(require,module,exports) {
module.exports = require("4868ccd895a099c9").getBundleURL("kVLro") + require("bb1029ae8b1cd44b").resolve("4fIrH");

},{"4868ccd895a099c9":"c7Tr5","bb1029ae8b1cd44b":"fyJL2"}],"2CYnZ":[function(require,module,exports) {
module.exports = require("ccf5d4bf995bdbb8").getBundleURL("kVLro") + require("da6cf0e7d9e6f0fc").resolve("hoDWT");

},{"ccf5d4bf995bdbb8":"c7Tr5","da6cf0e7d9e6f0fc":"fyJL2"}],"i0YpA":[function(require,module,exports) {
module.exports = require("d66ebf7f19d03477").getBundleURL("kVLro") + require("e9a67989fad8d3bc").resolve("bsENy");

},{"d66ebf7f19d03477":"c7Tr5","e9a67989fad8d3bc":"fyJL2"}],"dL9sH":[function(require,module,exports) {
module.exports = require("66d77b19102ded46").getBundleURL("kVLro") + require("2274331baba9dd57").resolve("3CWmB");

},{"66d77b19102ded46":"c7Tr5","2274331baba9dd57":"fyJL2"}],"cSo8d":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _extends = require("@babel/runtime/helpers/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _reactBeautifulDnd = require("react-beautiful-dnd");
var _lodash = require("lodash");
var _lodashDefault = parcelHelpers.interopDefault(_lodash);
var _newFeatureItem = require("./components/NewFeatureItem");
var _newFeatureItemDefault = parcelHelpers.interopDefault(_newFeatureItem);
var _newStubContentItem = require("./components/NewStubContentItem");
var _newStubContentItemDefault = parcelHelpers.interopDefault(_newStubContentItem);
var _featureItem = require("./components/FeatureItem");
var _featureItemDefault = parcelHelpers.interopDefault(_featureItem);
var _contentListItem = require("./components/ContentListItem");
var _contentListItemDefault = parcelHelpers.interopDefault(_contentListItem);
var _colors = require("../../constants/colors");
var _secondaryLoader = require("../../components/general/SecondaryLoader");
var _secondaryLoaderDefault = parcelHelpers.interopDefault(_secondaryLoader);
var _emptyView = require("./components/EmptyView");
var _emptyViewDefault = parcelHelpers.interopDefault(_emptyView);
var _contentItemFilters = require("./components/filters/ContentItemFilters");
var _contentItemFiltersDefault = parcelHelpers.interopDefault(_contentItemFilters);
var _featureToolbar = require("./components/FeatureToolbar");
var _noResultsView = require("./components/NoResultsView");
var _noResultsViewDefault = parcelHelpers.interopDefault(_noResultsView);
var _extensions = require("../../models/extensions");
const FeatureContent = (props)=>{
    const handleCreateNewFeature = (text)=>{
        props.handleAddNewFeature(text, props.feature?.id);
    };
    const handleFoldersDragEnd = (result, provider)=>{
        // dropped outside the list
        if (!result.destination) return;
        const features = (0, _lodashDefault.default).orderBy(props.childFeatures, (af)=>af.priority, "asc");
        props.featureContainer.setFeatureOrder(props.applicationId, props.feature?.id, (0, _extensions.reorder)(features, result.source.index, result.destination.index).map((r)=>r.id));
    };
    const handleContentItemsDragEnd = (result, provider)=>{
        // dropped outside the list
        if (!result.destination) return;
        const items = (0, _lodashDefault.default).orderBy(props.contentItems, (item)=>{
            item.priority, item.createdDate;
        }, "asc");
        const itemsOrdered = (0, _extensions.reorder)(items, result.source.index, result.destination.index);
        props.featureContainer.setFeatureContentItemsOrder(props.feature?.id, itemsOrdered);
    };
    const getIsContentItemDisabled = (item)=>{
        const filters = props.disablingFilters;
        if (filters?.featureTypeIdFilter && filters?.featureTypeIdFilter.length > 0) {
            if (!filters.featureTypeIdFilter.some((id)=>id == item.featureTypeId)) return true;
        }
        if (filters?.languageIdFilter && filters?.languageIdFilter.length > 0) {
            if (!filters.languageIdFilter.some((id)=>item.languages.some((l)=>l.id == id)) && item.languages.length > 0) return true;
        }
        // properties filter?
        return false;
    };
    const renderEmpty = ()=>{
        if ((0, _featureToolbar.getFilterCount)(props.filters) == 0) return (0, _react.jsx)((0, _emptyViewDefault.default), null);
        return (0, _react.jsx)((0, _noResultsViewDefault.default), null);
    };
    return (0, _react.jsx)("div", {
        className: containerStyle
    }, props.isFilterExpanded && (0, _react.jsx)((0, _contentItemFiltersDefault.default), {
        featureTypes: props.featureContainer.state.systemFeatures.map((f)=>f.featureType),
        languages: props.application.languages,
        currentFilter: props.filters,
        onChange: props.onFilterChange
    }), (0, _react.jsx)("div", {
        className: "child-container"
    }, props.withNesting && (0, _react.jsx)("div", {
        className: "spacer"
    }), (0, _react.jsx)("div", {
        className: "child-content-container"
    }, props.isAddingNewFeature && (0, _react.jsx)((0, _newFeatureItemDefault.default), {
        isLoading: props.featureContainer.state.isAddingFeature,
        onFinish: handleCreateNewFeature.bind(undefined)
    }), props.featureContainer.state.isLoadingFeatures && !props.featureContainer.state.loadingAppFeatureIds.some((s)=>s === props.feature?.id) ? (0, _react.jsx)((0, _secondaryLoaderDefault.default), {
        className: "feature-loader"
    }) : (0, _react.jsx)((0, _reactBeautifulDnd.DragDropContext), {
        onDragEnd: handleFoldersDragEnd.bind(undefined)
    }, (0, _react.jsx)((0, _reactBeautifulDnd.Droppable), {
        droppableId: props.droppableId,
        type: "FEATURES_MAIN"
    }, (provided, snapshot)=>(0, _react.jsx)("div", (0, _extendsDefault.default)({}, provided.droppableProps, {
            ref: provided.innerRef
        }), (0, _lodashDefault.default).orderBy(props.childFeatures, (af)=>af.priority, "asc")?.map((af, i)=>(0, _react.jsx)((0, _reactBeautifulDnd.Draggable), {
                draggableId: af.id,
                index: i,
                key: af.id
            }, (provided, snapshot)=>(0, _react.jsx)("div", (0, _extendsDefault.default)({
                    ref: provided.innerRef
                }, provided.draggableProps, provided.dragHandleProps), (0, _react.jsx)((0, _featureItemDefault.default), {
                    key: "feature_item_" + af.id,
                    feature: af,
                    className: snapshot.isDragging ? "dragging" : "",
                    index: i,
                    selectable: props.selectableFeatures,
                    featureContainer: props.featureContainer,
                    childFeatures: props.featureContainer.getFeaturesForParent(af.id),
                    contentItems: props.featureContainer.getContentByFeatureId(af.id),
                    withNesting: props.withNesting,
                    applicationId: props.applicationId,
                    onSelectionChange: props.onFeatureSelectionChange,
                    onClick: props.onFeatureClick ? ()=>props.onFeatureClick(af) : null,
                    onManageWebhooks: props.onManageWebhooksForAppFeature,
                    isSelected: props.selectedFeatureIds?.some((id)=>id == af.id),
                    disabled: props.disablingFilters?.disabledAppFeatureIds?.some((id)=>id == af.id),
                    isSingleSelect: props.isSingleSelect,
                    webhookInstanceCount: props.webhookContainer ? props.webhookContainer.getAttachedWebhooksCount(af.id) : 0
                })))), provided.placeholder))), props.featureContainer.state.loadingAppFeatureIds.some((s)=>s === props.feature?.id) ? (0, _react.jsx)("div", {
        className: "content-loader"
    }, (0, _react.jsx)((0, _secondaryLoaderDefault.default), null)) : (0, _react.jsx)("div", {
        className: `child-content-items-container ${props.childFeatures == null || props.childFeatures?.length === 0 ? "only-content" : ""}`
    }, props.newStubFeatureTypeId && (0, _react.jsx)((0, _newStubContentItemDefault.default), {
        onFinish: props.onStubAdded,
        featureTypeId: props.newStubFeatureTypeId,
        applicationFeatureId: props.feature?.id,
        applicationId: props.applicationId
    }), props.showContentItems && (0, _react.jsx)((0, _reactBeautifulDnd.DragDropContext), {
        onDragEnd: handleContentItemsDragEnd.bind(undefined)
    }, (0, _react.jsx)((0, _reactBeautifulDnd.Droppable), {
        droppableId: "content_items_list",
        type: "CONTENT_ITEMS_MAIN"
    }, (provided, snapshot)=>(0, _react.jsx)("div", (0, _extendsDefault.default)({}, provided.droppableProps, {
            ref: provided.innerRef
        }), (0, _lodashDefault.default).orderBy(props.contentItems, (item)=>{
            item.priority, item.createdDate;
        }, "asc")?.map((c, i)=>{
            var publishHistory = props.contentPublishStatus?.find((p)=>p.contentItemId == c.id)?.publishes;
            let lastPublish = null;
            // Do not allow reordering of content items if they were filtered
            const className = props.isContentFiltered ? "" : "draggable ";
            if (publishHistory && publishHistory.length > 0) lastPublish = publishHistory[0];
            return (0, _react.jsx)((0, _reactBeautifulDnd.Draggable), {
                draggableId: c.id,
                index: i,
                key: c.id,
                isDragDisabled: props.isContentFiltered
            }, (provided, snapshot)=>(0, _react.jsx)("div", (0, _extendsDefault.default)({
                    ref: provided.innerRef
                }, provided.draggableProps, provided.dragHandleProps), (0, _react.jsx)((0, _contentListItemDefault.default), {
                    selectable: props.selectableContentItems,
                    key: "content_item_" + c.id,
                    className: className + (snapshot.isDragging ? "dragging" : ""),
                    index: i,
                    statusDropDownDisabled: props.statusDropDownDisabled,
                    contentItem: c,
                    handlePublish: ()=>props.handlePublish(c),
                    handleUnpublish: ()=>props.handleUnpublish(c),
                    lastPublish: lastPublish,
                    isPublishLoaded: props.contentPublishStatusLoaded,
                    showStatus: props.showContentItemStatus,
                    withLink: props.navigatingContentItems,
                    applicationFeature: props.feature,
                    featureContainer: props.featureContainer,
                    isSelected: props.selectedContentItemIds?.some((id)=>id == c.id),
                    onSelectionChange: props.onContentItemSelectionChange,
                    onManageWebhooks: props.onManageWebhooksForContentItem,
                    disabled: getIsContentItemDisabled(c),
                    isSingleSelect: props.isSingleSelect,
                    webhookInstanceCount: props.webhookContainer?.getAttachedWebhooksCount(c.id)
                })));
        }), provided.placeholder))), props.contentItems.length == 0 && props.childFeatures.length == 0 && !props.featureContainer.state.isLoadingFeatures && renderEmpty()))));
};
const containerStyle = /*#__PURE__*/ (0, _css.css)("background:", (0, _colors.color_variants_main_bg), ";padding-bottom:16px;.content-loader{margin:32px;margin-top:48px;.spinner>div{background:", (0, _colors.color_colors_growth), ";}}.feature-loader{margin-top:16px;}.child-container{display:flex;align-items:stretch;.spacer{width:32px;background:", (0, _colors.color_shades_light), ";border:1px solid ", (0, _colors.color_shades_dark), ";box-sizing:border-box;}.child-content-container{flex:1;padding:32px 0;.spinner>div{background:", (0, _colors.color_colors_growth), ";}}.child-content-items-container{padding:32px 0;margin-bottom:64px;&.only-content{padding:0px;}}}.triangle-down{width:0;height:0;border-left:3px solid transparent;border-right:3px solid transparent;border-top:3px solid ", (0, _colors.color_shades_darkest), ";}.triangle-right{width:0;height:0;border-top:3px solid transparent;border-bottom:3px solid transparent;border-left:3px solid ", (0, _colors.color_shades_darkest), ";}.triangle-container{width:3px;height:3px;margin-right:8px;}.check{margin-top:4px;}", "");
exports.default = FeatureContent;

},{"@babel/runtime/helpers/extends":"4iKIP","@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","react-beautiful-dnd":"bkbSn","lodash":"3hMBK","./components/NewFeatureItem":"c4Eiu","./components/NewStubContentItem":"3OxnU","./components/FeatureItem":"jPEkh","./components/ContentListItem":"bjl88","../../constants/colors":"1p3OR","../../components/general/SecondaryLoader":"7zJiF","./components/EmptyView":"j6GxB","./components/filters/ContentItemFilters":"jx4R2","./components/FeatureToolbar":"avRgQ","./components/NoResultsView":"7S5N9","../../models/extensions":"7h01B","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"bkbSn":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DragDropContext", ()=>DragDropContext);
parcelHelpers.export(exports, "Draggable", ()=>PublicDraggable);
parcelHelpers.export(exports, "Droppable", ()=>ConnectedDroppable);
parcelHelpers.export(exports, "resetServerContext", ()=>resetServerContext);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _useMemoOne = require("use-memo-one");
var _inheritsLoose = require("@babel/runtime-corejs2/helpers/esm/inheritsLoose");
var _inheritsLooseDefault = parcelHelpers.interopDefault(_inheritsLoose);
var _extends = require("@babel/runtime-corejs2/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _redux = require("redux");
var _reactRedux = require("react-redux");
var _cssBoxModel = require("css-box-model");
var _memoizeOne = require("memoize-one");
var _memoizeOneDefault = parcelHelpers.interopDefault(_memoizeOne);
var _values = require("@babel/runtime-corejs2/core-js/object/values");
var _valuesDefault = parcelHelpers.interopDefault(_values);
var _keys = require("@babel/runtime-corejs2/core-js/object/keys");
var _keysDefault = parcelHelpers.interopDefault(_keys);
var _rafSchd = require("raf-schd");
var _rafSchdDefault = parcelHelpers.interopDefault(_rafSchd);
var _now = require("@babel/runtime-corejs2/core-js/date/now");
var _nowDefault = parcelHelpers.interopDefault(_now);
var _assign = require("@babel/runtime-corejs2/core-js/object/assign");
var _assignDefault = parcelHelpers.interopDefault(_assign);
var _reactDom = require("react-dom");
var _reactDomDefault = parcelHelpers.interopDefault(_reactDom);
var _isInteger = require("@babel/runtime-corejs2/core-js/number/is-integer");
var _isIntegerDefault = parcelHelpers.interopDefault(_isInteger);
var isProduction = true;
var spacesAndTabs = /[ \t]{2,}/g;
var lineStartWithSpaces = /^[ \t]*/gm;
var clean = function clean(value) {
    return value.replace(spacesAndTabs, " ").replace(lineStartWithSpaces, "").trim();
};
var getDevMessage = function getDevMessage(message) {
    return clean("\n  %creact-beautiful-dnd\n\n  %c" + clean(message) + "\n\n  %c\uD83D\uDC77‍ This is a development only message. It will be removed in production builds.\n");
};
var getFormattedMessage = function getFormattedMessage(message) {
    return [
        getDevMessage(message),
        "color: #00C584; font-size: 1.2em; font-weight: bold;",
        "line-height: 1.5",
        "color: #723874;"
    ];
};
var isDisabledFlag = "__react-beautiful-dnd-disable-dev-warnings";
function log(type, message) {
    var _console;
    if (isProduction) return;
    if (typeof window !== "undefined" && window[isDisabledFlag]) return;
    (_console = console)[type].apply(_console, getFormattedMessage(message));
}
var warning = log.bind(null, "warn");
var error = log.bind(null, "error");
function noop() {}
function getOptions(shared, fromBinding) {
    return (0, _extendsDefault.default)({}, shared, fromBinding);
}
function bindEvents(el, bindings, sharedOptions) {
    var unbindings = bindings.map(function(binding) {
        var options = getOptions(sharedOptions, binding.options);
        el.addEventListener(binding.eventName, binding.fn, options);
        return function unbind() {
            el.removeEventListener(binding.eventName, binding.fn, options);
        };
    });
    return function unbindAll() {
        unbindings.forEach(function(unbind) {
            unbind();
        });
    };
}
var isProduction$1 = true;
var prefix = "Invariant failed";
function RbdInvariant(message) {
    this.message = message;
}
RbdInvariant.prototype.toString = function toString() {
    return this.message;
};
function invariant(condition, message) {
    if (condition) return;
    if (isProduction$1) throw new RbdInvariant(prefix);
    else throw new RbdInvariant(prefix + ": " + (message || ""));
}
var ErrorBoundary = function(_React$Component) {
    (0, _inheritsLooseDefault.default)(ErrorBoundary, _React$Component);
    function ErrorBoundary() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.callbacks = null;
        _this.unbind = noop;
        _this.onWindowError = function(event) {
            var callbacks = _this.getCallbacks();
            if (callbacks.isDragging()) callbacks.tryAbort();
            var err = event.error;
            if (err instanceof RbdInvariant) event.preventDefault();
        };
        _this.getCallbacks = function() {
            if (!_this.callbacks) throw new Error("Unable to find AppCallbacks in <ErrorBoundary/>");
            return _this.callbacks;
        };
        _this.setCallbacks = function(callbacks) {
            _this.callbacks = callbacks;
        };
        return _this;
    }
    var _proto = ErrorBoundary.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.unbind = bindEvents(window, [
            {
                eventName: "error",
                fn: this.onWindowError
            }
        ]);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.unbind();
    };
    _proto.componentDidCatch = function componentDidCatch(err) {
        if (err instanceof RbdInvariant) {
            this.setState({});
            return;
        }
        throw err;
    };
    _proto.render = function render() {
        return this.props.children(this.setCallbacks);
    };
    return ErrorBoundary;
}((0, _reactDefault.default).Component);
var liftInstruction = "Draggable item. Ensure your screen reader is not in browse mode and then press space bar to lift.";
var position = function position(index) {
    return index + 1;
};
var onDragStart = function onDragStart(start) {
    return "\n  You have lifted an item in position " + position(start.source.index) + ".\n  Use the arrow keys to move, space bar to drop, and escape to cancel.\n";
};
var withLocation = function withLocation(source, destination) {
    var isInHomeList = source.droppableId === destination.droppableId;
    var startPosition = position(source.index);
    var endPosition = position(destination.index);
    if (isInHomeList) return "\n      You have moved the item from position " + startPosition + "\n      to position " + endPosition + "\n    ";
    return "\n    You have moved the item from position " + startPosition + "\n    in list " + source.droppableId + "\n    to list " + destination.droppableId + "\n    in position " + endPosition + "\n  ";
};
var withCombine = function withCombine(id, source, combine) {
    var inHomeList = source.droppableId === combine.droppableId;
    if (inHomeList) return "\n      The item " + id + "\n      has been combined with " + combine.draggableId;
    return "\n      The item " + id + "\n      in list " + source.droppableId + "\n      has been combined with " + combine.draggableId + "\n      in list " + combine.droppableId + "\n    ";
};
var onDragUpdate = function onDragUpdate(update) {
    var location = update.destination;
    if (location) return withLocation(update.source, location);
    var combine = update.combine;
    if (combine) return withCombine(update.draggableId, update.source, combine);
    return "You are over an area that cannot be dropped on";
};
var returnedToStart = function returnedToStart(source) {
    return "\n  The item has returned to its starting position\n  of " + position(source.index) + "\n";
};
var onDragEnd = function onDragEnd(result) {
    if (result.reason === "CANCEL") return "\n      Movement cancelled.\n      " + returnedToStart(result.source) + "\n    ";
    var location = result.destination;
    var combine = result.combine;
    if (location) return "\n      You have dropped the item.\n      " + withLocation(result.source, location) + "\n    ";
    if (combine) return "\n      You have dropped the item.\n      " + withCombine(result.draggableId, result.source, combine) + "\n    ";
    return "\n    The item has been dropped while not over a drop area.\n    " + returnedToStart(result.source) + "\n  ";
};
var preset = {
    liftInstruction: liftInstruction,
    onDragStart: onDragStart,
    onDragUpdate: onDragUpdate,
    onDragEnd: onDragEnd
};
var origin = {
    x: 0,
    y: 0
};
var add = function add(point1, point2) {
    return {
        x: point1.x + point2.x,
        y: point1.y + point2.y
    };
};
var subtract = function subtract(point1, point2) {
    return {
        x: point1.x - point2.x,
        y: point1.y - point2.y
    };
};
var isEqual = function isEqual(point1, point2) {
    return point1.x === point2.x && point1.y === point2.y;
};
var negate = function negate(point) {
    return {
        x: point.x !== 0 ? -point.x : 0,
        y: point.y !== 0 ? -point.y : 0
    };
};
var patch = function patch(line, value, otherValue) {
    var _ref;
    if (otherValue === void 0) otherValue = 0;
    return _ref = {}, _ref[line] = value, _ref[line === "x" ? "y" : "x"] = otherValue, _ref;
};
var distance = function distance(point1, point2) {
    return Math.sqrt(Math.pow(point2.x - point1.x, 2) + Math.pow(point2.y - point1.y, 2));
};
var closest = function closest(target, points) {
    return Math.min.apply(Math, points.map(function(point) {
        return distance(target, point);
    }));
};
var apply = function apply(fn) {
    return function(point) {
        return {
            x: fn(point.x),
            y: fn(point.y)
        };
    };
};
var executeClip = function(frame, subject) {
    var result = (0, _cssBoxModel.getRect)({
        top: Math.max(subject.top, frame.top),
        right: Math.min(subject.right, frame.right),
        bottom: Math.min(subject.bottom, frame.bottom),
        left: Math.max(subject.left, frame.left)
    });
    if (result.width <= 0 || result.height <= 0) return null;
    return result;
};
var offsetByPosition = function offsetByPosition(spacing, point) {
    return {
        top: spacing.top + point.y,
        left: spacing.left + point.x,
        bottom: spacing.bottom + point.y,
        right: spacing.right + point.x
    };
};
var getCorners = function getCorners(spacing) {
    return [
        {
            x: spacing.left,
            y: spacing.top
        },
        {
            x: spacing.right,
            y: spacing.top
        },
        {
            x: spacing.left,
            y: spacing.bottom
        },
        {
            x: spacing.right,
            y: spacing.bottom
        }
    ];
};
var noSpacing = {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
};
var scroll = function scroll(target, frame) {
    if (!frame) return target;
    return offsetByPosition(target, frame.scroll.diff.displacement);
};
var increase = function increase(target, axis, withPlaceholder) {
    if (withPlaceholder && withPlaceholder.increasedBy) {
        var _extends2;
        return (0, _extendsDefault.default)({}, target, (_extends2 = {}, _extends2[axis.end] = target[axis.end] + withPlaceholder.increasedBy[axis.line], _extends2));
    }
    return target;
};
var clip = function clip(target, frame) {
    if (frame && frame.shouldClipSubject) return executeClip(frame.pageMarginBox, target);
    return (0, _cssBoxModel.getRect)(target);
};
var getSubject = function(_ref) {
    var page = _ref.page, withPlaceholder = _ref.withPlaceholder, axis = _ref.axis, frame = _ref.frame;
    var scrolled = scroll(page.marginBox, frame);
    var increased = increase(scrolled, axis, withPlaceholder);
    var clipped = clip(increased, frame);
    return {
        page: page,
        withPlaceholder: withPlaceholder,
        active: clipped
    };
};
var scrollDroppable = function(droppable, newScroll) {
    !droppable.frame && invariant(false);
    var scrollable = droppable.frame;
    var scrollDiff = subtract(newScroll, scrollable.scroll.initial);
    var scrollDisplacement = negate(scrollDiff);
    var frame = (0, _extendsDefault.default)({}, scrollable, {
        scroll: {
            initial: scrollable.scroll.initial,
            current: newScroll,
            diff: {
                value: scrollDiff,
                displacement: scrollDisplacement
            },
            max: scrollable.scroll.max
        }
    });
    var subject = getSubject({
        page: droppable.subject.page,
        withPlaceholder: droppable.subject.withPlaceholder,
        axis: droppable.axis,
        frame: frame
    });
    var result = (0, _extendsDefault.default)({}, droppable, {
        frame: frame,
        subject: subject
    });
    return result;
};
function values(map) {
    return (0, _valuesDefault.default)(map);
}
function findIndex(list, predicate) {
    if (list.findIndex) return list.findIndex(predicate);
    for(var i = 0; i < list.length; i++){
        if (predicate(list[i])) return i;
    }
    return -1;
}
function find(list, predicate) {
    if (list.find) return list.find(predicate);
    var index = findIndex(list, predicate);
    if (index !== -1) return list[index];
    return undefined;
}
function toArray(list) {
    return Array.prototype.slice.call(list);
}
var toDroppableMap = (0, _memoizeOneDefault.default)(function(droppables) {
    return droppables.reduce(function(previous, current) {
        previous[current.descriptor.id] = current;
        return previous;
    }, {});
});
var toDraggableMap = (0, _memoizeOneDefault.default)(function(draggables) {
    return draggables.reduce(function(previous, current) {
        previous[current.descriptor.id] = current;
        return previous;
    }, {});
});
var toDroppableList = (0, _memoizeOneDefault.default)(function(droppables) {
    return values(droppables);
});
var toDraggableList = (0, _memoizeOneDefault.default)(function(draggables) {
    return values(draggables);
});
var getDraggablesInsideDroppable = (0, _memoizeOneDefault.default)(function(droppableId, draggables) {
    var result = toDraggableList(draggables).filter(function(draggable) {
        return droppableId === draggable.descriptor.droppableId;
    }).sort(function(a, b) {
        return a.descriptor.index - b.descriptor.index;
    });
    return result;
});
function tryGetDestination(impact) {
    if (impact.at && impact.at.type === "REORDER") return impact.at.destination;
    return null;
}
function tryGetCombine(impact) {
    if (impact.at && impact.at.type === "COMBINE") return impact.at.combine;
    return null;
}
var removeDraggableFromList = (0, _memoizeOneDefault.default)(function(remove, list) {
    return list.filter(function(item) {
        return item.descriptor.id !== remove.descriptor.id;
    });
});
var moveToNextCombine = function(_ref) {
    var isMovingForward = _ref.isMovingForward, draggable = _ref.draggable, destination = _ref.destination, insideDestination = _ref.insideDestination, previousImpact = _ref.previousImpact;
    if (!destination.isCombineEnabled) return null;
    var location = tryGetDestination(previousImpact);
    if (!location) return null;
    function getImpact(target) {
        var at = {
            type: "COMBINE",
            combine: {
                draggableId: target,
                droppableId: destination.descriptor.id
            }
        };
        return (0, _extendsDefault.default)({}, previousImpact, {
            at: at
        });
    }
    var all = previousImpact.displaced.all;
    var closestId = all.length ? all[0] : null;
    if (isMovingForward) return closestId ? getImpact(closestId) : null;
    var withoutDraggable = removeDraggableFromList(draggable, insideDestination);
    if (!closestId) {
        if (!withoutDraggable.length) return null;
        var last = withoutDraggable[withoutDraggable.length - 1];
        return getImpact(last.descriptor.id);
    }
    var indexOfClosest = findIndex(withoutDraggable, function(d) {
        return d.descriptor.id === closestId;
    });
    !(indexOfClosest !== -1) && invariant(false);
    var proposedIndex = indexOfClosest - 1;
    if (proposedIndex < 0) return null;
    var before = withoutDraggable[proposedIndex];
    return getImpact(before.descriptor.id);
};
var isHomeOf = function(draggable, destination) {
    return draggable.descriptor.droppableId === destination.descriptor.id;
};
var noDisplacedBy = {
    point: origin,
    value: 0
};
var emptyGroups = {
    invisible: {},
    visible: {},
    all: []
};
var noImpact = {
    displaced: emptyGroups,
    displacedBy: noDisplacedBy,
    at: null
};
var isWithin = function(lowerBound, upperBound) {
    return function(value) {
        return lowerBound <= value && value <= upperBound;
    };
};
var isPartiallyVisibleThroughFrame = function(frame) {
    var isWithinVertical = isWithin(frame.top, frame.bottom);
    var isWithinHorizontal = isWithin(frame.left, frame.right);
    return function(subject) {
        var isContained = isWithinVertical(subject.top) && isWithinVertical(subject.bottom) && isWithinHorizontal(subject.left) && isWithinHorizontal(subject.right);
        if (isContained) return true;
        var isPartiallyVisibleVertically = isWithinVertical(subject.top) || isWithinVertical(subject.bottom);
        var isPartiallyVisibleHorizontally = isWithinHorizontal(subject.left) || isWithinHorizontal(subject.right);
        var isPartiallyContained = isPartiallyVisibleVertically && isPartiallyVisibleHorizontally;
        if (isPartiallyContained) return true;
        var isBiggerVertically = subject.top < frame.top && subject.bottom > frame.bottom;
        var isBiggerHorizontally = subject.left < frame.left && subject.right > frame.right;
        var isTargetBiggerThanFrame = isBiggerVertically && isBiggerHorizontally;
        if (isTargetBiggerThanFrame) return true;
        var isTargetBiggerOnOneAxis = isBiggerVertically && isPartiallyVisibleHorizontally || isBiggerHorizontally && isPartiallyVisibleVertically;
        return isTargetBiggerOnOneAxis;
    };
};
var isTotallyVisibleThroughFrame = function(frame) {
    var isWithinVertical = isWithin(frame.top, frame.bottom);
    var isWithinHorizontal = isWithin(frame.left, frame.right);
    return function(subject) {
        var isContained = isWithinVertical(subject.top) && isWithinVertical(subject.bottom) && isWithinHorizontal(subject.left) && isWithinHorizontal(subject.right);
        return isContained;
    };
};
var vertical = {
    direction: "vertical",
    line: "y",
    crossAxisLine: "x",
    start: "top",
    end: "bottom",
    size: "height",
    crossAxisStart: "left",
    crossAxisEnd: "right",
    crossAxisSize: "width"
};
var horizontal = {
    direction: "horizontal",
    line: "x",
    crossAxisLine: "y",
    start: "left",
    end: "right",
    size: "width",
    crossAxisStart: "top",
    crossAxisEnd: "bottom",
    crossAxisSize: "height"
};
var isTotallyVisibleThroughFrameOnAxis = function(axis) {
    return function(frame) {
        var isWithinVertical = isWithin(frame.top, frame.bottom);
        var isWithinHorizontal = isWithin(frame.left, frame.right);
        return function(subject) {
            if (axis === vertical) return isWithinVertical(subject.top) && isWithinVertical(subject.bottom);
            return isWithinHorizontal(subject.left) && isWithinHorizontal(subject.right);
        };
    };
};
var getDroppableDisplaced = function getDroppableDisplaced(target, destination) {
    var displacement = destination.frame ? destination.frame.scroll.diff.displacement : origin;
    return offsetByPosition(target, displacement);
};
var isVisibleInDroppable = function isVisibleInDroppable(target, destination, isVisibleThroughFrameFn) {
    if (!destination.subject.active) return false;
    return isVisibleThroughFrameFn(destination.subject.active)(target);
};
var isVisibleInViewport = function isVisibleInViewport(target, viewport, isVisibleThroughFrameFn) {
    return isVisibleThroughFrameFn(viewport)(target);
};
var isVisible = function isVisible(_ref) {
    var toBeDisplaced = _ref.target, destination = _ref.destination, viewport = _ref.viewport, withDroppableDisplacement = _ref.withDroppableDisplacement, isVisibleThroughFrameFn = _ref.isVisibleThroughFrameFn;
    var displacedTarget = withDroppableDisplacement ? getDroppableDisplaced(toBeDisplaced, destination) : toBeDisplaced;
    return isVisibleInDroppable(displacedTarget, destination, isVisibleThroughFrameFn) && isVisibleInViewport(displacedTarget, viewport, isVisibleThroughFrameFn);
};
var isPartiallyVisible = function isPartiallyVisible(args) {
    return isVisible((0, _extendsDefault.default)({}, args, {
        isVisibleThroughFrameFn: isPartiallyVisibleThroughFrame
    }));
};
var isTotallyVisible = function isTotallyVisible(args) {
    return isVisible((0, _extendsDefault.default)({}, args, {
        isVisibleThroughFrameFn: isTotallyVisibleThroughFrame
    }));
};
var isTotallyVisibleOnAxis = function isTotallyVisibleOnAxis(args) {
    return isVisible((0, _extendsDefault.default)({}, args, {
        isVisibleThroughFrameFn: isTotallyVisibleThroughFrameOnAxis(args.destination.axis)
    }));
};
var getShouldAnimate = function getShouldAnimate(id, last, forceShouldAnimate) {
    if (typeof forceShouldAnimate === "boolean") return forceShouldAnimate;
    if (!last) return true;
    var invisible = last.invisible, visible = last.visible;
    if (invisible[id]) return false;
    var previous = visible[id];
    return previous ? previous.shouldAnimate : true;
};
function getTarget(draggable, displacedBy) {
    var marginBox = draggable.page.marginBox;
    var expandBy = {
        top: displacedBy.point.y,
        right: 0,
        bottom: 0,
        left: displacedBy.point.x
    };
    return (0, _cssBoxModel.getRect)((0, _cssBoxModel.expand)(marginBox, expandBy));
}
function getDisplacementGroups(_ref) {
    var afterDragging = _ref.afterDragging, destination = _ref.destination, displacedBy = _ref.displacedBy, viewport = _ref.viewport, forceShouldAnimate = _ref.forceShouldAnimate, last = _ref.last;
    return afterDragging.reduce(function process(groups, draggable) {
        var target = getTarget(draggable, displacedBy);
        var id = draggable.descriptor.id;
        groups.all.push(id);
        var isVisible = isPartiallyVisible({
            target: target,
            destination: destination,
            viewport: viewport,
            withDroppableDisplacement: true
        });
        if (!isVisible) {
            groups.invisible[draggable.descriptor.id] = true;
            return groups;
        }
        var shouldAnimate = getShouldAnimate(id, last, forceShouldAnimate);
        var displacement = {
            draggableId: id,
            shouldAnimate: shouldAnimate
        };
        groups.visible[id] = displacement;
        return groups;
    }, {
        all: [],
        visible: {},
        invisible: {}
    });
}
function getIndexOfLastItem(draggables, options) {
    if (!draggables.length) return 0;
    var indexOfLastItem = draggables[draggables.length - 1].descriptor.index;
    return options.inHomeList ? indexOfLastItem : indexOfLastItem + 1;
}
function goAtEnd(_ref) {
    var insideDestination = _ref.insideDestination, inHomeList = _ref.inHomeList, displacedBy = _ref.displacedBy, destination = _ref.destination;
    var newIndex = getIndexOfLastItem(insideDestination, {
        inHomeList: inHomeList
    });
    return {
        displaced: emptyGroups,
        displacedBy: displacedBy,
        at: {
            type: "REORDER",
            destination: {
                droppableId: destination.descriptor.id,
                index: newIndex
            }
        }
    };
}
function calculateReorderImpact(_ref2) {
    var draggable = _ref2.draggable, insideDestination = _ref2.insideDestination, destination = _ref2.destination, viewport = _ref2.viewport, displacedBy = _ref2.displacedBy, last = _ref2.last, index = _ref2.index, forceShouldAnimate = _ref2.forceShouldAnimate;
    var inHomeList = isHomeOf(draggable, destination);
    if (index == null) return goAtEnd({
        insideDestination: insideDestination,
        inHomeList: inHomeList,
        displacedBy: displacedBy,
        destination: destination
    });
    var match = find(insideDestination, function(item) {
        return item.descriptor.index === index;
    });
    if (!match) return goAtEnd({
        insideDestination: insideDestination,
        inHomeList: inHomeList,
        displacedBy: displacedBy,
        destination: destination
    });
    var withoutDragging = removeDraggableFromList(draggable, insideDestination);
    var sliceFrom = insideDestination.indexOf(match);
    var impacted = withoutDragging.slice(sliceFrom);
    var displaced = getDisplacementGroups({
        afterDragging: impacted,
        destination: destination,
        displacedBy: displacedBy,
        last: last,
        viewport: viewport.frame,
        forceShouldAnimate: forceShouldAnimate
    });
    return {
        displaced: displaced,
        displacedBy: displacedBy,
        at: {
            type: "REORDER",
            destination: {
                droppableId: destination.descriptor.id,
                index: index
            }
        }
    };
}
function didStartAfterCritical(draggableId, afterCritical) {
    return Boolean(afterCritical.effected[draggableId]);
}
var fromCombine = function(_ref) {
    var isMovingForward = _ref.isMovingForward, destination = _ref.destination, draggables = _ref.draggables, combine = _ref.combine, afterCritical = _ref.afterCritical;
    if (!destination.isCombineEnabled) return null;
    var combineId = combine.draggableId;
    var combineWith = draggables[combineId];
    var combineWithIndex = combineWith.descriptor.index;
    var didCombineWithStartAfterCritical = didStartAfterCritical(combineId, afterCritical);
    if (didCombineWithStartAfterCritical) {
        if (isMovingForward) return combineWithIndex;
        return combineWithIndex - 1;
    }
    if (isMovingForward) return combineWithIndex + 1;
    return combineWithIndex;
};
var fromReorder = function(_ref) {
    var isMovingForward = _ref.isMovingForward, isInHomeList = _ref.isInHomeList, insideDestination = _ref.insideDestination, location = _ref.location;
    if (!insideDestination.length) return null;
    var currentIndex = location.index;
    var proposedIndex = isMovingForward ? currentIndex + 1 : currentIndex - 1;
    var firstIndex = insideDestination[0].descriptor.index;
    var lastIndex = insideDestination[insideDestination.length - 1].descriptor.index;
    var upperBound = isInHomeList ? lastIndex : lastIndex + 1;
    if (proposedIndex < firstIndex) return null;
    if (proposedIndex > upperBound) return null;
    return proposedIndex;
};
var moveToNextIndex = function(_ref) {
    var isMovingForward = _ref.isMovingForward, isInHomeList = _ref.isInHomeList, draggable = _ref.draggable, draggables = _ref.draggables, destination = _ref.destination, insideDestination = _ref.insideDestination, previousImpact = _ref.previousImpact, viewport = _ref.viewport, afterCritical = _ref.afterCritical;
    var wasAt = previousImpact.at;
    !wasAt && invariant(false);
    if (wasAt.type === "REORDER") {
        var _newIndex = fromReorder({
            isMovingForward: isMovingForward,
            isInHomeList: isInHomeList,
            location: wasAt.destination,
            insideDestination: insideDestination
        });
        if (_newIndex == null) return null;
        return calculateReorderImpact({
            draggable: draggable,
            insideDestination: insideDestination,
            destination: destination,
            viewport: viewport,
            last: previousImpact.displaced,
            displacedBy: previousImpact.displacedBy,
            index: _newIndex
        });
    }
    var newIndex = fromCombine({
        isMovingForward: isMovingForward,
        destination: destination,
        displaced: previousImpact.displaced,
        draggables: draggables,
        combine: wasAt.combine,
        afterCritical: afterCritical
    });
    if (newIndex == null) return null;
    return calculateReorderImpact({
        draggable: draggable,
        insideDestination: insideDestination,
        destination: destination,
        viewport: viewport,
        last: previousImpact.displaced,
        displacedBy: previousImpact.displacedBy,
        index: newIndex
    });
};
var getCombinedItemDisplacement = function(_ref) {
    var displaced = _ref.displaced, afterCritical = _ref.afterCritical, combineWith = _ref.combineWith, displacedBy = _ref.displacedBy;
    var isDisplaced = Boolean(displaced.visible[combineWith] || displaced.invisible[combineWith]);
    if (didStartAfterCritical(combineWith, afterCritical)) return isDisplaced ? origin : negate(displacedBy.point);
    return isDisplaced ? displacedBy.point : origin;
};
var whenCombining = function(_ref) {
    var afterCritical = _ref.afterCritical, impact = _ref.impact, draggables = _ref.draggables;
    var combine = tryGetCombine(impact);
    !combine && invariant(false);
    var combineWith = combine.draggableId;
    var center = draggables[combineWith].page.borderBox.center;
    var displaceBy = getCombinedItemDisplacement({
        displaced: impact.displaced,
        afterCritical: afterCritical,
        combineWith: combineWith,
        displacedBy: impact.displacedBy
    });
    return add(center, displaceBy);
};
var distanceFromStartToBorderBoxCenter = function distanceFromStartToBorderBoxCenter(axis, box) {
    return box.margin[axis.start] + box.borderBox[axis.size] / 2;
};
var distanceFromEndToBorderBoxCenter = function distanceFromEndToBorderBoxCenter(axis, box) {
    return box.margin[axis.end] + box.borderBox[axis.size] / 2;
};
var getCrossAxisBorderBoxCenter = function getCrossAxisBorderBoxCenter(axis, target, isMoving) {
    return target[axis.crossAxisStart] + isMoving.margin[axis.crossAxisStart] + isMoving.borderBox[axis.crossAxisSize] / 2;
};
var goAfter = function goAfter(_ref) {
    var axis = _ref.axis, moveRelativeTo = _ref.moveRelativeTo, isMoving = _ref.isMoving;
    return patch(axis.line, moveRelativeTo.marginBox[axis.end] + distanceFromStartToBorderBoxCenter(axis, isMoving), getCrossAxisBorderBoxCenter(axis, moveRelativeTo.marginBox, isMoving));
};
var goBefore = function goBefore(_ref2) {
    var axis = _ref2.axis, moveRelativeTo = _ref2.moveRelativeTo, isMoving = _ref2.isMoving;
    return patch(axis.line, moveRelativeTo.marginBox[axis.start] - distanceFromEndToBorderBoxCenter(axis, isMoving), getCrossAxisBorderBoxCenter(axis, moveRelativeTo.marginBox, isMoving));
};
var goIntoStart = function goIntoStart(_ref3) {
    var axis = _ref3.axis, moveInto = _ref3.moveInto, isMoving = _ref3.isMoving;
    return patch(axis.line, moveInto.contentBox[axis.start] + distanceFromStartToBorderBoxCenter(axis, isMoving), getCrossAxisBorderBoxCenter(axis, moveInto.contentBox, isMoving));
};
var whenReordering = function(_ref) {
    var impact = _ref.impact, draggable = _ref.draggable, draggables = _ref.draggables, droppable = _ref.droppable, afterCritical = _ref.afterCritical;
    var insideDestination = getDraggablesInsideDroppable(droppable.descriptor.id, draggables);
    var draggablePage = draggable.page;
    var axis = droppable.axis;
    if (!insideDestination.length) return goIntoStart({
        axis: axis,
        moveInto: droppable.page,
        isMoving: draggablePage
    });
    var displaced = impact.displaced, displacedBy = impact.displacedBy;
    var closestAfter = displaced.all[0];
    if (closestAfter) {
        var closest = draggables[closestAfter];
        if (didStartAfterCritical(closestAfter, afterCritical)) return goBefore({
            axis: axis,
            moveRelativeTo: closest.page,
            isMoving: draggablePage
        });
        var withDisplacement = (0, _cssBoxModel.offset)(closest.page, displacedBy.point);
        return goBefore({
            axis: axis,
            moveRelativeTo: withDisplacement,
            isMoving: draggablePage
        });
    }
    var last = insideDestination[insideDestination.length - 1];
    if (last.descriptor.id === draggable.descriptor.id) return draggablePage.borderBox.center;
    if (didStartAfterCritical(last.descriptor.id, afterCritical)) {
        var page = (0, _cssBoxModel.offset)(last.page, negate(afterCritical.displacedBy.point));
        return goAfter({
            axis: axis,
            moveRelativeTo: page,
            isMoving: draggablePage
        });
    }
    return goAfter({
        axis: axis,
        moveRelativeTo: last.page,
        isMoving: draggablePage
    });
};
var withDroppableDisplacement = function(droppable, point) {
    var frame = droppable.frame;
    if (!frame) return point;
    return add(point, frame.scroll.diff.displacement);
};
var getResultWithoutDroppableDisplacement = function getResultWithoutDroppableDisplacement(_ref) {
    var impact = _ref.impact, draggable = _ref.draggable, droppable = _ref.droppable, draggables = _ref.draggables, afterCritical = _ref.afterCritical;
    var original = draggable.page.borderBox.center;
    var at = impact.at;
    if (!droppable) return original;
    if (!at) return original;
    if (at.type === "REORDER") return whenReordering({
        impact: impact,
        draggable: draggable,
        draggables: draggables,
        droppable: droppable,
        afterCritical: afterCritical
    });
    return whenCombining({
        impact: impact,
        draggables: draggables,
        afterCritical: afterCritical
    });
};
var getPageBorderBoxCenterFromImpact = function(args) {
    var withoutDisplacement = getResultWithoutDroppableDisplacement(args);
    var droppable = args.droppable;
    var withDisplacement = droppable ? withDroppableDisplacement(droppable, withoutDisplacement) : withoutDisplacement;
    return withDisplacement;
};
var scrollViewport = function(viewport, newScroll) {
    var diff = subtract(newScroll, viewport.scroll.initial);
    var displacement = negate(diff);
    var frame = (0, _cssBoxModel.getRect)({
        top: newScroll.y,
        bottom: newScroll.y + viewport.frame.height,
        left: newScroll.x,
        right: newScroll.x + viewport.frame.width
    });
    var updated = {
        frame: frame,
        scroll: {
            initial: viewport.scroll.initial,
            max: viewport.scroll.max,
            current: newScroll,
            diff: {
                value: diff,
                displacement: displacement
            }
        }
    };
    return updated;
};
function getDraggables(ids, draggables) {
    return ids.map(function(id) {
        return draggables[id];
    });
}
function tryGetVisible(id, groups) {
    for(var i = 0; i < groups.length; i++){
        var displacement = groups[i].visible[id];
        if (displacement) return displacement;
    }
    return null;
}
var speculativelyIncrease = function(_ref) {
    var impact = _ref.impact, viewport = _ref.viewport, destination = _ref.destination, draggables = _ref.draggables, maxScrollChange = _ref.maxScrollChange;
    var scrolledViewport = scrollViewport(viewport, add(viewport.scroll.current, maxScrollChange));
    var scrolledDroppable = destination.frame ? scrollDroppable(destination, add(destination.frame.scroll.current, maxScrollChange)) : destination;
    var last = impact.displaced;
    var withViewportScroll = getDisplacementGroups({
        afterDragging: getDraggables(last.all, draggables),
        destination: destination,
        displacedBy: impact.displacedBy,
        viewport: scrolledViewport.frame,
        last: last,
        forceShouldAnimate: false
    });
    var withDroppableScroll = getDisplacementGroups({
        afterDragging: getDraggables(last.all, draggables),
        destination: scrolledDroppable,
        displacedBy: impact.displacedBy,
        viewport: viewport.frame,
        last: last,
        forceShouldAnimate: false
    });
    var invisible = {};
    var visible = {};
    var groups = [
        last,
        withViewportScroll,
        withDroppableScroll
    ];
    last.all.forEach(function(id) {
        var displacement = tryGetVisible(id, groups);
        if (displacement) {
            visible[id] = displacement;
            return;
        }
        invisible[id] = true;
    });
    var newImpact = (0, _extendsDefault.default)({}, impact, {
        displaced: {
            all: last.all,
            invisible: invisible,
            visible: visible
        }
    });
    return newImpact;
};
var withViewportDisplacement = function(viewport, point) {
    return add(viewport.scroll.diff.displacement, point);
};
var getClientFromPageBorderBoxCenter = function(_ref) {
    var pageBorderBoxCenter = _ref.pageBorderBoxCenter, draggable = _ref.draggable, viewport = _ref.viewport;
    var withoutPageScrollChange = withViewportDisplacement(viewport, pageBorderBoxCenter);
    var offset = subtract(withoutPageScrollChange, draggable.page.borderBox.center);
    return add(draggable.client.borderBox.center, offset);
};
var isTotallyVisibleInNewLocation = function(_ref) {
    var draggable = _ref.draggable, destination = _ref.destination, newPageBorderBoxCenter = _ref.newPageBorderBoxCenter, viewport = _ref.viewport, withDroppableDisplacement = _ref.withDroppableDisplacement, _ref$onlyOnMainAxis = _ref.onlyOnMainAxis, onlyOnMainAxis = _ref$onlyOnMainAxis === void 0 ? false : _ref$onlyOnMainAxis;
    var changeNeeded = subtract(newPageBorderBoxCenter, draggable.page.borderBox.center);
    var shifted = offsetByPosition(draggable.page.borderBox, changeNeeded);
    var args = {
        target: shifted,
        destination: destination,
        withDroppableDisplacement: withDroppableDisplacement,
        viewport: viewport
    };
    return onlyOnMainAxis ? isTotallyVisibleOnAxis(args) : isTotallyVisible(args);
};
var moveToNextPlace = function(_ref) {
    var isMovingForward = _ref.isMovingForward, draggable = _ref.draggable, destination = _ref.destination, draggables = _ref.draggables, previousImpact = _ref.previousImpact, viewport = _ref.viewport, previousPageBorderBoxCenter = _ref.previousPageBorderBoxCenter, previousClientSelection = _ref.previousClientSelection, afterCritical = _ref.afterCritical;
    if (!destination.isEnabled) return null;
    var insideDestination = getDraggablesInsideDroppable(destination.descriptor.id, draggables);
    var isInHomeList = isHomeOf(draggable, destination);
    var impact = moveToNextCombine({
        isMovingForward: isMovingForward,
        draggable: draggable,
        destination: destination,
        insideDestination: insideDestination,
        previousImpact: previousImpact
    }) || moveToNextIndex({
        isMovingForward: isMovingForward,
        isInHomeList: isInHomeList,
        draggable: draggable,
        draggables: draggables,
        destination: destination,
        insideDestination: insideDestination,
        previousImpact: previousImpact,
        viewport: viewport,
        afterCritical: afterCritical
    });
    if (!impact) return null;
    var pageBorderBoxCenter = getPageBorderBoxCenterFromImpact({
        impact: impact,
        draggable: draggable,
        droppable: destination,
        draggables: draggables,
        afterCritical: afterCritical
    });
    var isVisibleInNewLocation = isTotallyVisibleInNewLocation({
        draggable: draggable,
        destination: destination,
        newPageBorderBoxCenter: pageBorderBoxCenter,
        viewport: viewport.frame,
        withDroppableDisplacement: false,
        onlyOnMainAxis: true
    });
    if (isVisibleInNewLocation) {
        var clientSelection = getClientFromPageBorderBoxCenter({
            pageBorderBoxCenter: pageBorderBoxCenter,
            draggable: draggable,
            viewport: viewport
        });
        return {
            clientSelection: clientSelection,
            impact: impact,
            scrollJumpRequest: null
        };
    }
    var distance = subtract(pageBorderBoxCenter, previousPageBorderBoxCenter);
    var cautious = speculativelyIncrease({
        impact: impact,
        viewport: viewport,
        destination: destination,
        draggables: draggables,
        maxScrollChange: distance
    });
    return {
        clientSelection: previousClientSelection,
        impact: cautious,
        scrollJumpRequest: distance
    };
};
var getKnownActive = function getKnownActive(droppable) {
    var rect = droppable.subject.active;
    !rect && invariant(false);
    return rect;
};
var getBestCrossAxisDroppable = function(_ref) {
    var isMovingForward = _ref.isMovingForward, pageBorderBoxCenter = _ref.pageBorderBoxCenter, source = _ref.source, droppables = _ref.droppables, viewport = _ref.viewport;
    var active = source.subject.active;
    if (!active) return null;
    var axis = source.axis;
    var isBetweenSourceClipped = isWithin(active[axis.start], active[axis.end]);
    var candidates = toDroppableList(droppables).filter(function(droppable) {
        return droppable !== source;
    }).filter(function(droppable) {
        return droppable.isEnabled;
    }).filter(function(droppable) {
        return Boolean(droppable.subject.active);
    }).filter(function(droppable) {
        return isPartiallyVisibleThroughFrame(viewport.frame)(getKnownActive(droppable));
    }).filter(function(droppable) {
        var activeOfTarget = getKnownActive(droppable);
        if (isMovingForward) return active[axis.crossAxisEnd] < activeOfTarget[axis.crossAxisEnd];
        return activeOfTarget[axis.crossAxisStart] < active[axis.crossAxisStart];
    }).filter(function(droppable) {
        var activeOfTarget = getKnownActive(droppable);
        var isBetweenDestinationClipped = isWithin(activeOfTarget[axis.start], activeOfTarget[axis.end]);
        return isBetweenSourceClipped(activeOfTarget[axis.start]) || isBetweenSourceClipped(activeOfTarget[axis.end]) || isBetweenDestinationClipped(active[axis.start]) || isBetweenDestinationClipped(active[axis.end]);
    }).sort(function(a, b) {
        var first = getKnownActive(a)[axis.crossAxisStart];
        var second = getKnownActive(b)[axis.crossAxisStart];
        if (isMovingForward) return first - second;
        return second - first;
    }).filter(function(droppable, index, array) {
        return getKnownActive(droppable)[axis.crossAxisStart] === getKnownActive(array[0])[axis.crossAxisStart];
    });
    if (!candidates.length) return null;
    if (candidates.length === 1) return candidates[0];
    var contains = candidates.filter(function(droppable) {
        var isWithinDroppable = isWithin(getKnownActive(droppable)[axis.start], getKnownActive(droppable)[axis.end]);
        return isWithinDroppable(pageBorderBoxCenter[axis.line]);
    });
    if (contains.length === 1) return contains[0];
    if (contains.length > 1) return contains.sort(function(a, b) {
        return getKnownActive(a)[axis.start] - getKnownActive(b)[axis.start];
    })[0];
    return candidates.sort(function(a, b) {
        var first = closest(pageBorderBoxCenter, getCorners(getKnownActive(a)));
        var second = closest(pageBorderBoxCenter, getCorners(getKnownActive(b)));
        if (first !== second) return first - second;
        return getKnownActive(a)[axis.start] - getKnownActive(b)[axis.start];
    })[0];
};
var getCurrentPageBorderBoxCenter = function getCurrentPageBorderBoxCenter(draggable, afterCritical) {
    var original = draggable.page.borderBox.center;
    return didStartAfterCritical(draggable.descriptor.id, afterCritical) ? subtract(original, afterCritical.displacedBy.point) : original;
};
var getCurrentPageBorderBox = function getCurrentPageBorderBox(draggable, afterCritical) {
    var original = draggable.page.borderBox;
    return didStartAfterCritical(draggable.descriptor.id, afterCritical) ? offsetByPosition(original, negate(afterCritical.displacedBy.point)) : original;
};
var getClosestDraggable = function(_ref) {
    var pageBorderBoxCenter = _ref.pageBorderBoxCenter, viewport = _ref.viewport, destination = _ref.destination, insideDestination = _ref.insideDestination, afterCritical = _ref.afterCritical;
    var sorted = insideDestination.filter(function(draggable) {
        return isTotallyVisible({
            target: getCurrentPageBorderBox(draggable, afterCritical),
            destination: destination,
            viewport: viewport.frame,
            withDroppableDisplacement: true
        });
    }).sort(function(a, b) {
        var distanceToA = distance(pageBorderBoxCenter, withDroppableDisplacement(destination, getCurrentPageBorderBoxCenter(a, afterCritical)));
        var distanceToB = distance(pageBorderBoxCenter, withDroppableDisplacement(destination, getCurrentPageBorderBoxCenter(b, afterCritical)));
        if (distanceToA < distanceToB) return -1;
        if (distanceToB < distanceToA) return 1;
        return a.descriptor.index - b.descriptor.index;
    });
    return sorted[0] || null;
};
var getDisplacedBy = (0, _memoizeOneDefault.default)(function getDisplacedBy(axis, displaceBy) {
    var displacement = displaceBy[axis.line];
    return {
        value: displacement,
        point: patch(axis.line, displacement)
    };
});
var getRequiredGrowthForPlaceholder = function getRequiredGrowthForPlaceholder(droppable, placeholderSize, draggables) {
    var axis = droppable.axis;
    if (droppable.descriptor.mode === "virtual") return patch(axis.line, placeholderSize[axis.line]);
    var availableSpace = droppable.subject.page.contentBox[axis.size];
    var insideDroppable = getDraggablesInsideDroppable(droppable.descriptor.id, draggables);
    var spaceUsed = insideDroppable.reduce(function(sum, dimension) {
        return sum + dimension.client.marginBox[axis.size];
    }, 0);
    var requiredSpace = spaceUsed + placeholderSize[axis.line];
    var needsToGrowBy = requiredSpace - availableSpace;
    if (needsToGrowBy <= 0) return null;
    return patch(axis.line, needsToGrowBy);
};
var withMaxScroll = function withMaxScroll(frame, max) {
    return (0, _extendsDefault.default)({}, frame, {
        scroll: (0, _extendsDefault.default)({}, frame.scroll, {
            max: max
        })
    });
};
var addPlaceholder = function addPlaceholder(droppable, draggable, draggables) {
    var frame = droppable.frame;
    !!isHomeOf(draggable, droppable) && invariant(false);
    !!droppable.subject.withPlaceholder && invariant(false);
    var placeholderSize = getDisplacedBy(droppable.axis, draggable.displaceBy).point;
    var requiredGrowth = getRequiredGrowthForPlaceholder(droppable, placeholderSize, draggables);
    var added = {
        placeholderSize: placeholderSize,
        increasedBy: requiredGrowth,
        oldFrameMaxScroll: droppable.frame ? droppable.frame.scroll.max : null
    };
    if (!frame) {
        var _subject = getSubject({
            page: droppable.subject.page,
            withPlaceholder: added,
            axis: droppable.axis,
            frame: droppable.frame
        });
        return (0, _extendsDefault.default)({}, droppable, {
            subject: _subject
        });
    }
    var maxScroll = requiredGrowth ? add(frame.scroll.max, requiredGrowth) : frame.scroll.max;
    var newFrame = withMaxScroll(frame, maxScroll);
    var subject = getSubject({
        page: droppable.subject.page,
        withPlaceholder: added,
        axis: droppable.axis,
        frame: newFrame
    });
    return (0, _extendsDefault.default)({}, droppable, {
        subject: subject,
        frame: newFrame
    });
};
var removePlaceholder = function removePlaceholder(droppable) {
    var added = droppable.subject.withPlaceholder;
    !added && invariant(false);
    var frame = droppable.frame;
    if (!frame) {
        var _subject2 = getSubject({
            page: droppable.subject.page,
            axis: droppable.axis,
            frame: null,
            withPlaceholder: null
        });
        return (0, _extendsDefault.default)({}, droppable, {
            subject: _subject2
        });
    }
    var oldMaxScroll = added.oldFrameMaxScroll;
    !oldMaxScroll && invariant(false);
    var newFrame = withMaxScroll(frame, oldMaxScroll);
    var subject = getSubject({
        page: droppable.subject.page,
        axis: droppable.axis,
        frame: newFrame,
        withPlaceholder: null
    });
    return (0, _extendsDefault.default)({}, droppable, {
        subject: subject,
        frame: newFrame
    });
};
var moveToNewDroppable = function(_ref) {
    var previousPageBorderBoxCenter = _ref.previousPageBorderBoxCenter, moveRelativeTo = _ref.moveRelativeTo, insideDestination = _ref.insideDestination, draggable = _ref.draggable, draggables = _ref.draggables, destination = _ref.destination, viewport = _ref.viewport, afterCritical = _ref.afterCritical;
    if (!moveRelativeTo) {
        if (insideDestination.length) return null;
        var proposed = {
            displaced: emptyGroups,
            displacedBy: noDisplacedBy,
            at: {
                type: "REORDER",
                destination: {
                    droppableId: destination.descriptor.id,
                    index: 0
                }
            }
        };
        var proposedPageBorderBoxCenter = getPageBorderBoxCenterFromImpact({
            impact: proposed,
            draggable: draggable,
            droppable: destination,
            draggables: draggables,
            afterCritical: afterCritical
        });
        var withPlaceholder = isHomeOf(draggable, destination) ? destination : addPlaceholder(destination, draggable, draggables);
        var isVisibleInNewLocation = isTotallyVisibleInNewLocation({
            draggable: draggable,
            destination: withPlaceholder,
            newPageBorderBoxCenter: proposedPageBorderBoxCenter,
            viewport: viewport.frame,
            withDroppableDisplacement: false,
            onlyOnMainAxis: true
        });
        return isVisibleInNewLocation ? proposed : null;
    }
    var isGoingBeforeTarget = Boolean(previousPageBorderBoxCenter[destination.axis.line] <= moveRelativeTo.page.borderBox.center[destination.axis.line]);
    var proposedIndex = function() {
        var relativeTo = moveRelativeTo.descriptor.index;
        if (moveRelativeTo.descriptor.id === draggable.descriptor.id) return relativeTo;
        if (isGoingBeforeTarget) return relativeTo;
        return relativeTo + 1;
    }();
    var displacedBy = getDisplacedBy(destination.axis, draggable.displaceBy);
    return calculateReorderImpact({
        draggable: draggable,
        insideDestination: insideDestination,
        destination: destination,
        viewport: viewport,
        displacedBy: displacedBy,
        last: emptyGroups,
        index: proposedIndex
    });
};
var moveCrossAxis = function(_ref) {
    var isMovingForward = _ref.isMovingForward, previousPageBorderBoxCenter = _ref.previousPageBorderBoxCenter, draggable = _ref.draggable, isOver = _ref.isOver, draggables = _ref.draggables, droppables = _ref.droppables, viewport = _ref.viewport, afterCritical = _ref.afterCritical;
    var destination = getBestCrossAxisDroppable({
        isMovingForward: isMovingForward,
        pageBorderBoxCenter: previousPageBorderBoxCenter,
        source: isOver,
        droppables: droppables,
        viewport: viewport
    });
    if (!destination) return null;
    var insideDestination = getDraggablesInsideDroppable(destination.descriptor.id, draggables);
    var moveRelativeTo = getClosestDraggable({
        pageBorderBoxCenter: previousPageBorderBoxCenter,
        viewport: viewport,
        destination: destination,
        insideDestination: insideDestination,
        afterCritical: afterCritical
    });
    var impact = moveToNewDroppable({
        previousPageBorderBoxCenter: previousPageBorderBoxCenter,
        destination: destination,
        draggable: draggable,
        draggables: draggables,
        moveRelativeTo: moveRelativeTo,
        insideDestination: insideDestination,
        viewport: viewport,
        afterCritical: afterCritical
    });
    if (!impact) return null;
    var pageBorderBoxCenter = getPageBorderBoxCenterFromImpact({
        impact: impact,
        draggable: draggable,
        droppable: destination,
        draggables: draggables,
        afterCritical: afterCritical
    });
    var clientSelection = getClientFromPageBorderBoxCenter({
        pageBorderBoxCenter: pageBorderBoxCenter,
        draggable: draggable,
        viewport: viewport
    });
    return {
        clientSelection: clientSelection,
        impact: impact,
        scrollJumpRequest: null
    };
};
var whatIsDraggedOver = function(impact) {
    var at = impact.at;
    if (!at) return null;
    if (at.type === "REORDER") return at.destination.droppableId;
    return at.combine.droppableId;
};
var getDroppableOver = function getDroppableOver(impact, droppables) {
    var id = whatIsDraggedOver(impact);
    return id ? droppables[id] : null;
};
var moveInDirection = function(_ref) {
    var state = _ref.state, type = _ref.type;
    var isActuallyOver = getDroppableOver(state.impact, state.dimensions.droppables);
    var isMainAxisMovementAllowed = Boolean(isActuallyOver);
    var home = state.dimensions.droppables[state.critical.droppable.id];
    var isOver = isActuallyOver || home;
    var direction = isOver.axis.direction;
    var isMovingOnMainAxis = direction === "vertical" && (type === "MOVE_UP" || type === "MOVE_DOWN") || direction === "horizontal" && (type === "MOVE_LEFT" || type === "MOVE_RIGHT");
    if (isMovingOnMainAxis && !isMainAxisMovementAllowed) return null;
    var isMovingForward = type === "MOVE_DOWN" || type === "MOVE_RIGHT";
    var draggable = state.dimensions.draggables[state.critical.draggable.id];
    var previousPageBorderBoxCenter = state.current.page.borderBoxCenter;
    var _state$dimensions = state.dimensions, draggables = _state$dimensions.draggables, droppables = _state$dimensions.droppables;
    return isMovingOnMainAxis ? moveToNextPlace({
        isMovingForward: isMovingForward,
        previousPageBorderBoxCenter: previousPageBorderBoxCenter,
        draggable: draggable,
        destination: isOver,
        draggables: draggables,
        viewport: state.viewport,
        previousClientSelection: state.current.client.selection,
        previousImpact: state.impact,
        afterCritical: state.afterCritical
    }) : moveCrossAxis({
        isMovingForward: isMovingForward,
        previousPageBorderBoxCenter: previousPageBorderBoxCenter,
        draggable: draggable,
        isOver: isOver,
        draggables: draggables,
        droppables: droppables,
        viewport: state.viewport,
        afterCritical: state.afterCritical
    });
};
function isMovementAllowed(state) {
    return state.phase === "DRAGGING" || state.phase === "COLLECTING";
}
function isPositionInFrame(frame) {
    var isWithinVertical = isWithin(frame.top, frame.bottom);
    var isWithinHorizontal = isWithin(frame.left, frame.right);
    return function run(point) {
        return isWithinVertical(point.y) && isWithinHorizontal(point.x);
    };
}
function getHasOverlap(first, second) {
    return first.left < second.right && first.right > second.left && first.top < second.bottom && first.bottom > second.top;
}
function getFurthestAway(_ref) {
    var pageBorderBox = _ref.pageBorderBox, draggable = _ref.draggable, candidates = _ref.candidates;
    var startCenter = draggable.page.borderBox.center;
    var sorted = candidates.map(function(candidate) {
        var axis = candidate.axis;
        var target = patch(candidate.axis.line, pageBorderBox.center[axis.line], candidate.page.borderBox.center[axis.crossAxisLine]);
        return {
            id: candidate.descriptor.id,
            distance: distance(startCenter, target)
        };
    }).sort(function(a, b) {
        return b.distance - a.distance;
    });
    return sorted[0] ? sorted[0].id : null;
}
function getDroppableOver$1(_ref2) {
    var pageBorderBox = _ref2.pageBorderBox, draggable = _ref2.draggable, droppables = _ref2.droppables;
    var candidates = toDroppableList(droppables).filter(function(item) {
        if (!item.isEnabled) return false;
        var active = item.subject.active;
        if (!active) return false;
        if (!getHasOverlap(pageBorderBox, active)) return false;
        if (isPositionInFrame(active)(pageBorderBox.center)) return true;
        var axis = item.axis;
        var childCenter = active.center[axis.crossAxisLine];
        var crossAxisStart = pageBorderBox[axis.crossAxisStart];
        var crossAxisEnd = pageBorderBox[axis.crossAxisEnd];
        var isContained = isWithin(active[axis.crossAxisStart], active[axis.crossAxisEnd]);
        var isStartContained = isContained(crossAxisStart);
        var isEndContained = isContained(crossAxisEnd);
        if (!isStartContained && !isEndContained) return true;
        if (isStartContained) return crossAxisStart < childCenter;
        return crossAxisEnd > childCenter;
    });
    if (!candidates.length) return null;
    if (candidates.length === 1) return candidates[0].descriptor.id;
    return getFurthestAway({
        pageBorderBox: pageBorderBox,
        draggable: draggable,
        candidates: candidates
    });
}
var offsetRectByPosition = function offsetRectByPosition(rect, point) {
    return (0, _cssBoxModel.getRect)(offsetByPosition(rect, point));
};
var withDroppableScroll = function(droppable, area) {
    var frame = droppable.frame;
    if (!frame) return area;
    return offsetRectByPosition(area, frame.scroll.diff.value);
};
function getIsDisplaced(_ref) {
    var displaced = _ref.displaced, id = _ref.id;
    return Boolean(displaced.visible[id] || displaced.invisible[id]);
}
function atIndex(_ref) {
    var draggable = _ref.draggable, closest = _ref.closest, inHomeList = _ref.inHomeList;
    if (!closest) return null;
    if (!inHomeList) return closest.descriptor.index;
    if (closest.descriptor.index > draggable.descriptor.index) return closest.descriptor.index - 1;
    return closest.descriptor.index;
}
var getReorderImpact = function(_ref2) {
    var targetRect = _ref2.pageBorderBoxWithDroppableScroll, draggable = _ref2.draggable, destination = _ref2.destination, insideDestination = _ref2.insideDestination, last = _ref2.last, viewport = _ref2.viewport, afterCritical = _ref2.afterCritical;
    var axis = destination.axis;
    var displacedBy = getDisplacedBy(destination.axis, draggable.displaceBy);
    var displacement = displacedBy.value;
    var targetStart = targetRect[axis.start];
    var targetEnd = targetRect[axis.end];
    var withoutDragging = removeDraggableFromList(draggable, insideDestination);
    var closest = find(withoutDragging, function(child) {
        var id = child.descriptor.id;
        var childCenter = child.page.borderBox.center[axis.line];
        var didStartAfterCritical$1 = didStartAfterCritical(id, afterCritical);
        var isDisplaced = getIsDisplaced({
            displaced: last,
            id: id
        });
        if (didStartAfterCritical$1) {
            if (isDisplaced) return targetEnd <= childCenter;
            return targetStart < childCenter - displacement;
        }
        if (isDisplaced) return targetEnd <= childCenter + displacement;
        return targetStart < childCenter;
    });
    var newIndex = atIndex({
        draggable: draggable,
        closest: closest,
        inHomeList: isHomeOf(draggable, destination)
    });
    return calculateReorderImpact({
        draggable: draggable,
        insideDestination: insideDestination,
        destination: destination,
        viewport: viewport,
        last: last,
        displacedBy: displacedBy,
        index: newIndex
    });
};
var combineThresholdDivisor = 4;
var getCombineImpact = function(_ref) {
    var draggable = _ref.draggable, targetRect = _ref.pageBorderBoxWithDroppableScroll, previousImpact = _ref.previousImpact, destination = _ref.destination, insideDestination = _ref.insideDestination, afterCritical = _ref.afterCritical;
    if (!destination.isCombineEnabled) return null;
    var axis = destination.axis;
    var displacedBy = getDisplacedBy(destination.axis, draggable.displaceBy);
    var displacement = displacedBy.value;
    var targetStart = targetRect[axis.start];
    var targetEnd = targetRect[axis.end];
    var withoutDragging = removeDraggableFromList(draggable, insideDestination);
    var combineWith = find(withoutDragging, function(child) {
        var id = child.descriptor.id;
        var childRect = child.page.borderBox;
        var childSize = childRect[axis.size];
        var threshold = childSize / combineThresholdDivisor;
        var didStartAfterCritical$1 = didStartAfterCritical(id, afterCritical);
        var isDisplaced = getIsDisplaced({
            displaced: previousImpact.displaced,
            id: id
        });
        if (didStartAfterCritical$1) {
            if (isDisplaced) return targetEnd > childRect[axis.start] + threshold && targetEnd < childRect[axis.end] - threshold;
            return targetStart > childRect[axis.start] - displacement + threshold && targetStart < childRect[axis.end] - displacement - threshold;
        }
        if (isDisplaced) return targetEnd > childRect[axis.start] + displacement + threshold && targetEnd < childRect[axis.end] + displacement - threshold;
        return targetStart > childRect[axis.start] + threshold && targetStart < childRect[axis.end] - threshold;
    });
    if (!combineWith) return null;
    var impact = {
        displacedBy: displacedBy,
        displaced: previousImpact.displaced,
        at: {
            type: "COMBINE",
            combine: {
                draggableId: combineWith.descriptor.id,
                droppableId: destination.descriptor.id
            }
        }
    };
    return impact;
};
var getDragImpact = function(_ref) {
    var pageOffset = _ref.pageOffset, draggable = _ref.draggable, draggables = _ref.draggables, droppables = _ref.droppables, previousImpact = _ref.previousImpact, viewport = _ref.viewport, afterCritical = _ref.afterCritical;
    var pageBorderBox = offsetRectByPosition(draggable.page.borderBox, pageOffset);
    var destinationId = getDroppableOver$1({
        pageBorderBox: pageBorderBox,
        draggable: draggable,
        droppables: droppables
    });
    if (!destinationId) return noImpact;
    var destination = droppables[destinationId];
    var insideDestination = getDraggablesInsideDroppable(destination.descriptor.id, draggables);
    var pageBorderBoxWithDroppableScroll = withDroppableScroll(destination, pageBorderBox);
    return getCombineImpact({
        pageBorderBoxWithDroppableScroll: pageBorderBoxWithDroppableScroll,
        draggable: draggable,
        previousImpact: previousImpact,
        destination: destination,
        insideDestination: insideDestination,
        afterCritical: afterCritical
    }) || getReorderImpact({
        pageBorderBoxWithDroppableScroll: pageBorderBoxWithDroppableScroll,
        draggable: draggable,
        destination: destination,
        insideDestination: insideDestination,
        last: previousImpact.displaced,
        viewport: viewport,
        afterCritical: afterCritical
    });
};
var patchDroppableMap = function(droppables, updated) {
    var _extends2;
    return (0, _extendsDefault.default)({}, droppables, (_extends2 = {}, _extends2[updated.descriptor.id] = updated, _extends2));
};
var clearUnusedPlaceholder = function clearUnusedPlaceholder(_ref) {
    var previousImpact = _ref.previousImpact, impact = _ref.impact, droppables = _ref.droppables;
    var last = whatIsDraggedOver(previousImpact);
    var now = whatIsDraggedOver(impact);
    if (!last) return droppables;
    if (last === now) return droppables;
    var lastDroppable = droppables[last];
    if (!lastDroppable.subject.withPlaceholder) return droppables;
    var updated = removePlaceholder(lastDroppable);
    return patchDroppableMap(droppables, updated);
};
var recomputePlaceholders = function(_ref2) {
    var draggable = _ref2.draggable, draggables = _ref2.draggables, droppables = _ref2.droppables, previousImpact = _ref2.previousImpact, impact = _ref2.impact;
    var cleaned = clearUnusedPlaceholder({
        previousImpact: previousImpact,
        impact: impact,
        droppables: droppables
    });
    var isOver = whatIsDraggedOver(impact);
    if (!isOver) return cleaned;
    var droppable = droppables[isOver];
    if (isHomeOf(draggable, droppable)) return cleaned;
    if (droppable.subject.withPlaceholder) return cleaned;
    var patched = addPlaceholder(droppable, draggable, draggables);
    return patchDroppableMap(cleaned, patched);
};
var update = function(_ref) {
    var state = _ref.state, forcedClientSelection = _ref.clientSelection, forcedDimensions = _ref.dimensions, forcedViewport = _ref.viewport, forcedImpact = _ref.impact, scrollJumpRequest = _ref.scrollJumpRequest;
    var viewport = forcedViewport || state.viewport;
    var dimensions = forcedDimensions || state.dimensions;
    var clientSelection = forcedClientSelection || state.current.client.selection;
    var offset = subtract(clientSelection, state.initial.client.selection);
    var client = {
        offset: offset,
        selection: clientSelection,
        borderBoxCenter: add(state.initial.client.borderBoxCenter, offset)
    };
    var page = {
        selection: add(client.selection, viewport.scroll.current),
        borderBoxCenter: add(client.borderBoxCenter, viewport.scroll.current),
        offset: add(client.offset, viewport.scroll.diff.value)
    };
    var current = {
        client: client,
        page: page
    };
    if (state.phase === "COLLECTING") return (0, _extendsDefault.default)({
        phase: "COLLECTING"
    }, state, {
        dimensions: dimensions,
        viewport: viewport,
        current: current
    });
    var draggable = dimensions.draggables[state.critical.draggable.id];
    var newImpact = forcedImpact || getDragImpact({
        pageOffset: page.offset,
        draggable: draggable,
        draggables: dimensions.draggables,
        droppables: dimensions.droppables,
        previousImpact: state.impact,
        viewport: viewport,
        afterCritical: state.afterCritical
    });
    var withUpdatedPlaceholders = recomputePlaceholders({
        draggable: draggable,
        impact: newImpact,
        previousImpact: state.impact,
        draggables: dimensions.draggables,
        droppables: dimensions.droppables
    });
    var result = (0, _extendsDefault.default)({}, state, {
        current: current,
        dimensions: {
            draggables: dimensions.draggables,
            droppables: withUpdatedPlaceholders
        },
        impact: newImpact,
        viewport: viewport,
        scrollJumpRequest: scrollJumpRequest || null,
        forceShouldAnimate: scrollJumpRequest ? false : null
    });
    return result;
};
function getDraggables$1(ids, draggables) {
    return ids.map(function(id) {
        return draggables[id];
    });
}
var recompute = function(_ref) {
    var impact = _ref.impact, viewport = _ref.viewport, draggables = _ref.draggables, destination = _ref.destination, forceShouldAnimate = _ref.forceShouldAnimate;
    var last = impact.displaced;
    var afterDragging = getDraggables$1(last.all, draggables);
    var displaced = getDisplacementGroups({
        afterDragging: afterDragging,
        destination: destination,
        displacedBy: impact.displacedBy,
        viewport: viewport.frame,
        forceShouldAnimate: forceShouldAnimate,
        last: last
    });
    return (0, _extendsDefault.default)({}, impact, {
        displaced: displaced
    });
};
var getClientBorderBoxCenter = function(_ref) {
    var impact = _ref.impact, draggable = _ref.draggable, droppable = _ref.droppable, draggables = _ref.draggables, viewport = _ref.viewport, afterCritical = _ref.afterCritical;
    var pageBorderBoxCenter = getPageBorderBoxCenterFromImpact({
        impact: impact,
        draggable: draggable,
        draggables: draggables,
        droppable: droppable,
        afterCritical: afterCritical
    });
    return getClientFromPageBorderBoxCenter({
        pageBorderBoxCenter: pageBorderBoxCenter,
        draggable: draggable,
        viewport: viewport
    });
};
var refreshSnap = function(_ref) {
    var state = _ref.state, forcedDimensions = _ref.dimensions, forcedViewport = _ref.viewport;
    !(state.movementMode === "SNAP") && invariant(false);
    var needsVisibilityCheck = state.impact;
    var viewport = forcedViewport || state.viewport;
    var dimensions = forcedDimensions || state.dimensions;
    var draggables = dimensions.draggables, droppables = dimensions.droppables;
    var draggable = draggables[state.critical.draggable.id];
    var isOver = whatIsDraggedOver(needsVisibilityCheck);
    !isOver && invariant(false);
    var destination = droppables[isOver];
    var impact = recompute({
        impact: needsVisibilityCheck,
        viewport: viewport,
        destination: destination,
        draggables: draggables
    });
    var clientSelection = getClientBorderBoxCenter({
        impact: impact,
        draggable: draggable,
        droppable: destination,
        draggables: draggables,
        viewport: viewport,
        afterCritical: state.afterCritical
    });
    return update({
        impact: impact,
        clientSelection: clientSelection,
        state: state,
        dimensions: dimensions,
        viewport: viewport
    });
};
var getHomeLocation = function(descriptor) {
    return {
        index: descriptor.index,
        droppableId: descriptor.droppableId
    };
};
var getLiftEffect = function(_ref) {
    var draggable = _ref.draggable, home = _ref.home, draggables = _ref.draggables, viewport = _ref.viewport;
    var displacedBy = getDisplacedBy(home.axis, draggable.displaceBy);
    var insideHome = getDraggablesInsideDroppable(home.descriptor.id, draggables);
    var rawIndex = insideHome.indexOf(draggable);
    !(rawIndex !== -1) && invariant(false);
    var afterDragging = insideHome.slice(rawIndex + 1);
    var effected = afterDragging.reduce(function(previous, item) {
        previous[item.descriptor.id] = true;
        return previous;
    }, {});
    var afterCritical = {
        inVirtualList: home.descriptor.mode === "virtual",
        displacedBy: displacedBy,
        effected: effected
    };
    var displaced = getDisplacementGroups({
        afterDragging: afterDragging,
        destination: home,
        displacedBy: displacedBy,
        last: null,
        viewport: viewport.frame,
        forceShouldAnimate: false
    });
    var impact = {
        displaced: displaced,
        displacedBy: displacedBy,
        at: {
            type: "REORDER",
            destination: getHomeLocation(draggable.descriptor)
        }
    };
    return {
        impact: impact,
        afterCritical: afterCritical
    };
};
var patchDimensionMap = function(dimensions, updated) {
    return {
        draggables: dimensions.draggables,
        droppables: patchDroppableMap(dimensions.droppables, updated)
    };
};
var records = {};
var isEnabled = false;
var isTimingsEnabled = function isTimingsEnabled() {
    return isEnabled;
};
var start = function start(key) {
    var now;
};
var finish = function finish(key) {
    var now, previous, result, rounded, style;
};
var offsetDraggable = function(_ref) {
    var draggable = _ref.draggable, offset$1 = _ref.offset, initialWindowScroll = _ref.initialWindowScroll;
    var client = (0, _cssBoxModel.offset)(draggable.client, offset$1);
    var page = (0, _cssBoxModel.withScroll)(client, initialWindowScroll);
    var moved = (0, _extendsDefault.default)({}, draggable, {
        placeholder: (0, _extendsDefault.default)({}, draggable.placeholder, {
            client: client
        }),
        client: client,
        page: page
    });
    return moved;
};
var getFrame = function(droppable) {
    var frame = droppable.frame;
    !frame && invariant(false);
    return frame;
};
var adjustAdditionsForScrollChanges = function(_ref) {
    var additions = _ref.additions, updatedDroppables = _ref.updatedDroppables, viewport = _ref.viewport;
    var windowScrollChange = viewport.scroll.diff.value;
    return additions.map(function(draggable) {
        var droppableId = draggable.descriptor.droppableId;
        var modified = updatedDroppables[droppableId];
        var frame = getFrame(modified);
        var droppableScrollChange = frame.scroll.diff.value;
        var totalChange = add(windowScrollChange, droppableScrollChange);
        var moved = offsetDraggable({
            draggable: draggable,
            offset: totalChange,
            initialWindowScroll: viewport.scroll.initial
        });
        return moved;
    });
};
var timingsKey = "Processing dynamic changes";
var publishWhileDraggingInVirtual = function(_ref) {
    var _extends2, _extends3;
    var state = _ref.state, published = _ref.published;
    start(timingsKey);
    var withScrollChange = published.modified.map(function(update) {
        var existing = state.dimensions.droppables[update.droppableId];
        var scrolled = scrollDroppable(existing, update.scroll);
        return scrolled;
    });
    var droppables = (0, _extendsDefault.default)({}, state.dimensions.droppables, toDroppableMap(withScrollChange));
    var updatedAdditions = toDraggableMap(adjustAdditionsForScrollChanges({
        additions: published.additions,
        updatedDroppables: droppables,
        viewport: state.viewport
    }));
    var draggables = (0, _extendsDefault.default)({}, state.dimensions.draggables, updatedAdditions);
    published.removals.forEach(function(id) {
        delete draggables[id];
    });
    var dimensions = {
        droppables: droppables,
        draggables: draggables
    };
    var wasOverId = whatIsDraggedOver(state.impact);
    var wasOver = wasOverId ? dimensions.droppables[wasOverId] : null;
    var draggable = dimensions.draggables[state.critical.draggable.id];
    var home = dimensions.droppables[state.critical.droppable.id];
    var _getLiftEffect = getLiftEffect({
        draggable: draggable,
        home: home,
        draggables: draggables,
        viewport: state.viewport
    }), onLiftImpact = _getLiftEffect.impact, afterCritical = _getLiftEffect.afterCritical;
    var previousImpact = wasOver && wasOver.isCombineEnabled ? state.impact : onLiftImpact;
    var impact = getDragImpact({
        pageOffset: state.current.page.offset,
        draggable: dimensions.draggables[state.critical.draggable.id],
        draggables: dimensions.draggables,
        droppables: dimensions.droppables,
        previousImpact: previousImpact,
        viewport: state.viewport,
        afterCritical: afterCritical
    });
    finish(timingsKey);
    var draggingState = (0, _extendsDefault.default)({
        phase: "DRAGGING"
    }, state, (_extends2 = {}, _extends2["phase"] = "DRAGGING", _extends2.impact = impact, _extends2.onLiftImpact = onLiftImpact, _extends2.dimensions = dimensions, _extends2.afterCritical = afterCritical, _extends2.forceShouldAnimate = false, _extends2));
    if (state.phase === "COLLECTING") return draggingState;
    var dropPending = (0, _extendsDefault.default)({
        phase: "DROP_PENDING"
    }, draggingState, (_extends3 = {}, _extends3["phase"] = "DROP_PENDING", _extends3.reason = state.reason, _extends3.isWaiting = false, _extends3));
    return dropPending;
};
var isSnapping = function isSnapping(state) {
    return state.movementMode === "SNAP";
};
var postDroppableChange = function postDroppableChange(state, updated, isEnabledChanging) {
    var dimensions = patchDimensionMap(state.dimensions, updated);
    if (!isSnapping(state) || isEnabledChanging) return update({
        state: state,
        dimensions: dimensions
    });
    return refreshSnap({
        state: state,
        dimensions: dimensions
    });
};
function removeScrollJumpRequest(state) {
    if (state.isDragging && state.movementMode === "SNAP") return (0, _extendsDefault.default)({
        phase: "DRAGGING"
    }, state, {
        scrollJumpRequest: null
    });
    return state;
}
var idle = {
    phase: "IDLE",
    completed: null,
    shouldFlush: false
};
var reducer = function(state, action) {
    if (state === void 0) state = idle;
    if (action.type === "FLUSH") return (0, _extendsDefault.default)({}, idle, {
        shouldFlush: true
    });
    if (action.type === "INITIAL_PUBLISH") {
        !(state.phase === "IDLE") && invariant(false);
        var _action$payload = action.payload, critical = _action$payload.critical, clientSelection = _action$payload.clientSelection, viewport = _action$payload.viewport, dimensions = _action$payload.dimensions, movementMode = _action$payload.movementMode;
        var draggable = dimensions.draggables[critical.draggable.id];
        var home = dimensions.droppables[critical.droppable.id];
        var client = {
            selection: clientSelection,
            borderBoxCenter: draggable.client.borderBox.center,
            offset: origin
        };
        var initial = {
            client: client,
            page: {
                selection: add(client.selection, viewport.scroll.initial),
                borderBoxCenter: add(client.selection, viewport.scroll.initial),
                offset: add(client.selection, viewport.scroll.diff.value)
            }
        };
        var isWindowScrollAllowed = toDroppableList(dimensions.droppables).every(function(item) {
            return !item.isFixedOnPage;
        });
        var _getLiftEffect = getLiftEffect({
            draggable: draggable,
            home: home,
            draggables: dimensions.draggables,
            viewport: viewport
        }), impact = _getLiftEffect.impact, afterCritical = _getLiftEffect.afterCritical;
        var result = {
            phase: "DRAGGING",
            isDragging: true,
            critical: critical,
            movementMode: movementMode,
            dimensions: dimensions,
            initial: initial,
            current: initial,
            isWindowScrollAllowed: isWindowScrollAllowed,
            impact: impact,
            afterCritical: afterCritical,
            onLiftImpact: impact,
            viewport: viewport,
            scrollJumpRequest: null,
            forceShouldAnimate: null
        };
        return result;
    }
    if (action.type === "COLLECTION_STARTING") {
        var _extends2;
        if (state.phase === "COLLECTING" || state.phase === "DROP_PENDING") return state;
        !(state.phase === "DRAGGING") && invariant(false);
        var _result = (0, _extendsDefault.default)({
            phase: "COLLECTING"
        }, state, (_extends2 = {}, _extends2["phase"] = "COLLECTING", _extends2));
        return _result;
    }
    if (action.type === "PUBLISH_WHILE_DRAGGING") {
        !(state.phase === "COLLECTING" || state.phase === "DROP_PENDING") && invariant(false);
        return publishWhileDraggingInVirtual({
            state: state,
            published: action.payload
        });
    }
    if (action.type === "MOVE") {
        if (state.phase === "DROP_PENDING") return state;
        !isMovementAllowed(state) && invariant(false);
        var _clientSelection = action.payload.client;
        if (isEqual(_clientSelection, state.current.client.selection)) return state;
        return update({
            state: state,
            clientSelection: _clientSelection,
            impact: isSnapping(state) ? state.impact : null
        });
    }
    if (action.type === "UPDATE_DROPPABLE_SCROLL") {
        if (state.phase === "DROP_PENDING") return removeScrollJumpRequest(state);
        if (state.phase === "COLLECTING") return removeScrollJumpRequest(state);
        !isMovementAllowed(state) && invariant(false);
        var _action$payload2 = action.payload, id = _action$payload2.id, newScroll = _action$payload2.newScroll;
        var target = state.dimensions.droppables[id];
        if (!target) return state;
        var scrolled = scrollDroppable(target, newScroll);
        return postDroppableChange(state, scrolled, false);
    }
    if (action.type === "UPDATE_DROPPABLE_IS_ENABLED") {
        if (state.phase === "DROP_PENDING") return state;
        !isMovementAllowed(state) && invariant(false);
        var _action$payload3 = action.payload, _id = _action$payload3.id, isEnabled = _action$payload3.isEnabled;
        var _target = state.dimensions.droppables[_id];
        !_target && invariant(false);
        !(_target.isEnabled !== isEnabled) && invariant(false);
        var updated = (0, _extendsDefault.default)({}, _target, {
            isEnabled: isEnabled
        });
        return postDroppableChange(state, updated, true);
    }
    if (action.type === "UPDATE_DROPPABLE_IS_COMBINE_ENABLED") {
        if (state.phase === "DROP_PENDING") return state;
        !isMovementAllowed(state) && invariant(false);
        var _action$payload4 = action.payload, _id2 = _action$payload4.id, isCombineEnabled = _action$payload4.isCombineEnabled;
        var _target2 = state.dimensions.droppables[_id2];
        !_target2 && invariant(false);
        !(_target2.isCombineEnabled !== isCombineEnabled) && invariant(false);
        var _updated = (0, _extendsDefault.default)({}, _target2, {
            isCombineEnabled: isCombineEnabled
        });
        return postDroppableChange(state, _updated, true);
    }
    if (action.type === "MOVE_BY_WINDOW_SCROLL") {
        if (state.phase === "DROP_PENDING" || state.phase === "DROP_ANIMATING") return state;
        !isMovementAllowed(state) && invariant(false);
        !state.isWindowScrollAllowed && invariant(false);
        var _newScroll = action.payload.newScroll;
        if (isEqual(state.viewport.scroll.current, _newScroll)) return removeScrollJumpRequest(state);
        var _viewport = scrollViewport(state.viewport, _newScroll);
        if (isSnapping(state)) return refreshSnap({
            state: state,
            viewport: _viewport
        });
        return update({
            state: state,
            viewport: _viewport
        });
    }
    if (action.type === "UPDATE_VIEWPORT_MAX_SCROLL") {
        if (!isMovementAllowed(state)) return state;
        var maxScroll = action.payload.maxScroll;
        if (isEqual(maxScroll, state.viewport.scroll.max)) return state;
        var withMaxScroll = (0, _extendsDefault.default)({}, state.viewport, {
            scroll: (0, _extendsDefault.default)({}, state.viewport.scroll, {
                max: maxScroll
            })
        });
        return (0, _extendsDefault.default)({
            phase: "DRAGGING"
        }, state, {
            viewport: withMaxScroll
        });
    }
    if (action.type === "MOVE_UP" || action.type === "MOVE_DOWN" || action.type === "MOVE_LEFT" || action.type === "MOVE_RIGHT") {
        if (state.phase === "COLLECTING" || state.phase === "DROP_PENDING") return state;
        !(state.phase === "DRAGGING") && invariant(false);
        var _result2 = moveInDirection({
            state: state,
            type: action.type
        });
        if (!_result2) return state;
        return update({
            state: state,
            impact: _result2.impact,
            clientSelection: _result2.clientSelection,
            scrollJumpRequest: _result2.scrollJumpRequest
        });
    }
    if (action.type === "DROP_PENDING") {
        var _extends3;
        var reason = action.payload.reason;
        !(state.phase === "COLLECTING") && invariant(false);
        var newState = (0, _extendsDefault.default)({
            phase: "DROP_PENDING"
        }, state, (_extends3 = {}, _extends3["phase"] = "DROP_PENDING", _extends3.isWaiting = true, _extends3.reason = reason, _extends3));
        return newState;
    }
    if (action.type === "DROP_ANIMATE") {
        var _action$payload5 = action.payload, completed = _action$payload5.completed, dropDuration = _action$payload5.dropDuration, newHomeClientOffset = _action$payload5.newHomeClientOffset;
        !(state.phase === "DRAGGING" || state.phase === "DROP_PENDING") && invariant(false);
        var _result3 = {
            phase: "DROP_ANIMATING",
            completed: completed,
            dropDuration: dropDuration,
            newHomeClientOffset: newHomeClientOffset,
            dimensions: state.dimensions
        };
        return _result3;
    }
    if (action.type === "DROP_COMPLETE") {
        var _completed = action.payload.completed;
        return {
            phase: "IDLE",
            completed: _completed,
            shouldFlush: false
        };
    }
    return state;
};
var beforeInitialCapture = function beforeInitialCapture(args) {
    return {
        type: "BEFORE_INITIAL_CAPTURE",
        payload: args
    };
};
var lift = function lift(args) {
    return {
        type: "LIFT",
        payload: args
    };
};
var initialPublish = function initialPublish(args) {
    return {
        type: "INITIAL_PUBLISH",
        payload: args
    };
};
var publishWhileDragging = function publishWhileDragging(args) {
    return {
        type: "PUBLISH_WHILE_DRAGGING",
        payload: args
    };
};
var collectionStarting = function collectionStarting() {
    return {
        type: "COLLECTION_STARTING",
        payload: null
    };
};
var updateDroppableScroll = function updateDroppableScroll(args) {
    return {
        type: "UPDATE_DROPPABLE_SCROLL",
        payload: args
    };
};
var updateDroppableIsEnabled = function updateDroppableIsEnabled(args) {
    return {
        type: "UPDATE_DROPPABLE_IS_ENABLED",
        payload: args
    };
};
var updateDroppableIsCombineEnabled = function updateDroppableIsCombineEnabled(args) {
    return {
        type: "UPDATE_DROPPABLE_IS_COMBINE_ENABLED",
        payload: args
    };
};
var move = function move(args) {
    return {
        type: "MOVE",
        payload: args
    };
};
var moveByWindowScroll = function moveByWindowScroll(args) {
    return {
        type: "MOVE_BY_WINDOW_SCROLL",
        payload: args
    };
};
var updateViewportMaxScroll = function updateViewportMaxScroll(args) {
    return {
        type: "UPDATE_VIEWPORT_MAX_SCROLL",
        payload: args
    };
};
var moveUp = function moveUp() {
    return {
        type: "MOVE_UP",
        payload: null
    };
};
var moveDown = function moveDown() {
    return {
        type: "MOVE_DOWN",
        payload: null
    };
};
var moveRight = function moveRight() {
    return {
        type: "MOVE_RIGHT",
        payload: null
    };
};
var moveLeft = function moveLeft() {
    return {
        type: "MOVE_LEFT",
        payload: null
    };
};
var flush = function flush() {
    return {
        type: "FLUSH",
        payload: null
    };
};
var animateDrop = function animateDrop(args) {
    return {
        type: "DROP_ANIMATE",
        payload: args
    };
};
var completeDrop = function completeDrop(args) {
    return {
        type: "DROP_COMPLETE",
        payload: args
    };
};
var drop = function drop(args) {
    return {
        type: "DROP",
        payload: args
    };
};
var dropPending = function dropPending(args) {
    return {
        type: "DROP_PENDING",
        payload: args
    };
};
var dropAnimationFinished = function dropAnimationFinished() {
    return {
        type: "DROP_ANIMATION_FINISHED",
        payload: null
    };
};
function checkIndexes(insideDestination) {
    if (insideDestination.length <= 1) return;
    var indexes = insideDestination.map(function(d) {
        return d.descriptor.index;
    });
    var errors = {};
    for(var i = 1; i < indexes.length; i++){
        var current = indexes[i];
        var previous = indexes[i - 1];
        if (current !== previous + 1) errors[current] = true;
    }
    if (!(0, _keysDefault.default)(errors).length) return;
    var formatted = indexes.map(function(index) {
        var hasError = Boolean(errors[index]);
        return hasError ? "[\uD83D\uDD25" + index + "]" : "" + index;
    }).join(", ");
}
function validateDimensions(critical, dimensions) {
    var insideDestination;
}
var lift$1 = function(marshal) {
    return function(_ref) {
        var getState = _ref.getState, dispatch = _ref.dispatch;
        return function(next) {
            return function(action) {
                if (action.type !== "LIFT") {
                    next(action);
                    return;
                }
                var _action$payload = action.payload, id = _action$payload.id, clientSelection = _action$payload.clientSelection, movementMode = _action$payload.movementMode;
                var initial = getState();
                if (initial.phase === "DROP_ANIMATING") dispatch(completeDrop({
                    completed: initial.completed
                }));
                !(getState().phase === "IDLE") && invariant(false);
                dispatch(flush());
                dispatch(beforeInitialCapture({
                    draggableId: id,
                    movementMode: movementMode
                }));
                var scrollOptions = {
                    shouldPublishImmediately: movementMode === "SNAP"
                };
                var request = {
                    draggableId: id,
                    scrollOptions: scrollOptions
                };
                var _marshal$startPublish = marshal.startPublishing(request), critical = _marshal$startPublish.critical, dimensions = _marshal$startPublish.dimensions, viewport = _marshal$startPublish.viewport;
                validateDimensions(critical, dimensions);
                dispatch(initialPublish({
                    critical: critical,
                    dimensions: dimensions,
                    clientSelection: clientSelection,
                    movementMode: movementMode,
                    viewport: viewport
                }));
            };
        };
    };
};
var style = function(marshal) {
    return function() {
        return function(next) {
            return function(action) {
                if (action.type === "INITIAL_PUBLISH") marshal.dragging();
                if (action.type === "DROP_ANIMATE") marshal.dropping(action.payload.completed.result.reason);
                if (action.type === "FLUSH" || action.type === "DROP_COMPLETE") marshal.resting();
                next(action);
            };
        };
    };
};
var curves = {
    outOfTheWay: "cubic-bezier(0.2, 0, 0, 1)",
    drop: "cubic-bezier(.2,1,.1,1)"
};
var combine = {
    opacity: {
        drop: 0,
        combining: 0.7
    },
    scale: {
        drop: 0.75
    }
};
var timings = {
    outOfTheWay: 0.2,
    minDropTime: 0.33,
    maxDropTime: 0.55
};
var outOfTheWayTiming = timings.outOfTheWay + "s " + curves.outOfTheWay;
var transitions = {
    fluid: "opacity " + outOfTheWayTiming,
    snap: "transform " + outOfTheWayTiming + ", opacity " + outOfTheWayTiming,
    drop: function drop(duration) {
        var timing = duration + "s " + curves.drop;
        return "transform " + timing + ", opacity " + timing;
    },
    outOfTheWay: "transform " + outOfTheWayTiming,
    placeholder: "height " + outOfTheWayTiming + ", width " + outOfTheWayTiming + ", margin " + outOfTheWayTiming
};
var moveTo = function moveTo(offset) {
    return isEqual(offset, origin) ? null : "translate(" + offset.x + "px, " + offset.y + "px)";
};
var transforms = {
    moveTo: moveTo,
    drop: function drop(offset, isCombining) {
        var translate = moveTo(offset);
        if (!translate) return null;
        if (!isCombining) return translate;
        return translate + " scale(" + combine.scale.drop + ")";
    }
};
var minDropTime = timings.minDropTime, maxDropTime = timings.maxDropTime;
var dropTimeRange = maxDropTime - minDropTime;
var maxDropTimeAtDistance = 1500;
var cancelDropModifier = 0.6;
var getDropDuration = function(_ref) {
    var current = _ref.current, destination = _ref.destination, reason = _ref.reason;
    var distance$1 = distance(current, destination);
    if (distance$1 <= 0) return minDropTime;
    if (distance$1 >= maxDropTimeAtDistance) return maxDropTime;
    var percentage = distance$1 / maxDropTimeAtDistance;
    var duration = minDropTime + dropTimeRange * percentage;
    var withDuration = reason === "CANCEL" ? duration * cancelDropModifier : duration;
    return Number(withDuration.toFixed(2));
};
var getNewHomeClientOffset = function(_ref) {
    var impact = _ref.impact, draggable = _ref.draggable, dimensions = _ref.dimensions, viewport = _ref.viewport, afterCritical = _ref.afterCritical;
    var draggables = dimensions.draggables, droppables = dimensions.droppables;
    var droppableId = whatIsDraggedOver(impact);
    var destination = droppableId ? droppables[droppableId] : null;
    var home = droppables[draggable.descriptor.droppableId];
    var newClientCenter = getClientBorderBoxCenter({
        impact: impact,
        draggable: draggable,
        draggables: draggables,
        afterCritical: afterCritical,
        droppable: destination || home,
        viewport: viewport
    });
    var offset = subtract(newClientCenter, draggable.client.borderBox.center);
    return offset;
};
var getDropImpact = function(_ref) {
    var draggables = _ref.draggables, reason = _ref.reason, lastImpact = _ref.lastImpact, home = _ref.home, viewport = _ref.viewport, onLiftImpact = _ref.onLiftImpact;
    if (!lastImpact.at || reason !== "DROP") {
        var recomputedHomeImpact = recompute({
            draggables: draggables,
            impact: onLiftImpact,
            destination: home,
            viewport: viewport,
            forceShouldAnimate: true
        });
        return {
            impact: recomputedHomeImpact,
            didDropInsideDroppable: false
        };
    }
    if (lastImpact.at.type === "REORDER") return {
        impact: lastImpact,
        didDropInsideDroppable: true
    };
    var withoutMovement = (0, _extendsDefault.default)({}, lastImpact, {
        displaced: emptyGroups
    });
    return {
        impact: withoutMovement,
        didDropInsideDroppable: true
    };
};
var drop$1 = function(_ref) {
    var getState = _ref.getState, dispatch = _ref.dispatch;
    return function(next) {
        return function(action) {
            if (action.type !== "DROP") {
                next(action);
                return;
            }
            var state = getState();
            var reason = action.payload.reason;
            if (state.phase === "COLLECTING") {
                dispatch(dropPending({
                    reason: reason
                }));
                return;
            }
            if (state.phase === "IDLE") return;
            var isWaitingForDrop = state.phase === "DROP_PENDING" && state.isWaiting;
            !!isWaitingForDrop && invariant(false);
            !(state.phase === "DRAGGING" || state.phase === "DROP_PENDING") && invariant(false);
            var critical = state.critical;
            var dimensions = state.dimensions;
            var draggable = dimensions.draggables[state.critical.draggable.id];
            var _getDropImpact = getDropImpact({
                reason: reason,
                lastImpact: state.impact,
                afterCritical: state.afterCritical,
                onLiftImpact: state.onLiftImpact,
                home: state.dimensions.droppables[state.critical.droppable.id],
                viewport: state.viewport,
                draggables: state.dimensions.draggables
            }), impact = _getDropImpact.impact, didDropInsideDroppable = _getDropImpact.didDropInsideDroppable;
            var destination = didDropInsideDroppable ? tryGetDestination(impact) : null;
            var combine = didDropInsideDroppable ? tryGetCombine(impact) : null;
            var source = {
                index: critical.draggable.index,
                droppableId: critical.droppable.id
            };
            var result = {
                draggableId: draggable.descriptor.id,
                type: draggable.descriptor.type,
                source: source,
                reason: reason,
                mode: state.movementMode,
                destination: destination,
                combine: combine
            };
            var newHomeClientOffset = getNewHomeClientOffset({
                impact: impact,
                draggable: draggable,
                dimensions: dimensions,
                viewport: state.viewport,
                afterCritical: state.afterCritical
            });
            var completed = {
                critical: state.critical,
                afterCritical: state.afterCritical,
                result: result,
                impact: impact
            };
            var isAnimationRequired = !isEqual(state.current.client.offset, newHomeClientOffset) || Boolean(result.combine);
            if (!isAnimationRequired) {
                dispatch(completeDrop({
                    completed: completed
                }));
                return;
            }
            var dropDuration = getDropDuration({
                current: state.current.client.offset,
                destination: newHomeClientOffset,
                reason: reason
            });
            var args = {
                newHomeClientOffset: newHomeClientOffset,
                dropDuration: dropDuration,
                completed: completed
            };
            dispatch(animateDrop(args));
        };
    };
};
var getWindowScroll = function() {
    return {
        x: window.pageXOffset,
        y: window.pageYOffset
    };
};
function getWindowScrollBinding(update) {
    return {
        eventName: "scroll",
        options: {
            passive: true,
            capture: false
        },
        fn: function fn(event) {
            if (event.target !== window && event.target !== window.document) return;
            update();
        }
    };
}
function getScrollListener(_ref) {
    var onWindowScroll = _ref.onWindowScroll;
    function updateScroll() {
        onWindowScroll(getWindowScroll());
    }
    var scheduled = (0, _rafSchdDefault.default)(updateScroll);
    var binding = getWindowScrollBinding(scheduled);
    var unbind = noop;
    function isActive() {
        return unbind !== noop;
    }
    function start() {
        !!isActive() && invariant(false);
        unbind = bindEvents(window, [
            binding
        ]);
    }
    function stop() {
        !isActive() && invariant(false);
        scheduled.cancel();
        unbind();
        unbind = noop;
    }
    return {
        start: start,
        stop: stop,
        isActive: isActive
    };
}
var shouldEnd = function shouldEnd(action) {
    return action.type === "DROP_COMPLETE" || action.type === "DROP_ANIMATE" || action.type === "FLUSH";
};
var scrollListener = function(store) {
    var listener = getScrollListener({
        onWindowScroll: function onWindowScroll(newScroll) {
            store.dispatch(moveByWindowScroll({
                newScroll: newScroll
            }));
        }
    });
    return function(next) {
        return function(action) {
            if (!listener.isActive() && action.type === "INITIAL_PUBLISH") listener.start();
            if (listener.isActive() && shouldEnd(action)) listener.stop();
            next(action);
        };
    };
};
var getExpiringAnnounce = function(announce) {
    var wasCalled = false;
    var isExpired = false;
    var timeoutId = setTimeout(function() {
        isExpired = true;
    });
    var result = function result(message) {
        if (wasCalled) return;
        if (isExpired) return;
        wasCalled = true;
        announce(message);
        clearTimeout(timeoutId);
    };
    result.wasCalled = function() {
        return wasCalled;
    };
    return result;
};
var getAsyncMarshal = function() {
    var entries = [];
    var execute = function execute(timerId) {
        var index = findIndex(entries, function(item) {
            return item.timerId === timerId;
        });
        !(index !== -1) && invariant(false);
        var _entries$splice = entries.splice(index, 1), entry = _entries$splice[0];
        entry.callback();
    };
    var add = function add(fn) {
        var timerId = setTimeout(function() {
            return execute(timerId);
        });
        var entry = {
            timerId: timerId,
            callback: fn
        };
        entries.push(entry);
    };
    var flush = function flush() {
        if (!entries.length) return;
        var shallow = [].concat(entries);
        entries.length = 0;
        shallow.forEach(function(entry) {
            clearTimeout(entry.timerId);
            entry.callback();
        });
    };
    return {
        add: add,
        flush: flush
    };
};
var areLocationsEqual = function areLocationsEqual(first, second) {
    if (first == null && second == null) return true;
    if (first == null || second == null) return false;
    return first.droppableId === second.droppableId && first.index === second.index;
};
var isCombineEqual = function isCombineEqual(first, second) {
    if (first == null && second == null) return true;
    if (first == null || second == null) return false;
    return first.draggableId === second.draggableId && first.droppableId === second.droppableId;
};
var isCriticalEqual = function isCriticalEqual(first, second) {
    if (first === second) return true;
    var isDraggableEqual = first.draggable.id === second.draggable.id && first.draggable.droppableId === second.draggable.droppableId && first.draggable.type === second.draggable.type && first.draggable.index === second.draggable.index;
    var isDroppableEqual = first.droppable.id === second.droppable.id && first.droppable.type === second.droppable.type;
    return isDraggableEqual && isDroppableEqual;
};
var withTimings = function withTimings(key, fn) {
    start(key);
    fn();
    finish(key);
};
var getDragStart = function getDragStart(critical, mode) {
    return {
        draggableId: critical.draggable.id,
        type: critical.droppable.type,
        source: {
            droppableId: critical.droppable.id,
            index: critical.draggable.index
        },
        mode: mode
    };
};
var execute = function execute(responder, data, announce, getDefaultMessage) {
    if (!responder) {
        announce(getDefaultMessage(data));
        return;
    }
    var willExpire = getExpiringAnnounce(announce);
    var provided = {
        announce: willExpire
    };
    responder(data, provided);
    if (!willExpire.wasCalled()) announce(getDefaultMessage(data));
};
var getPublisher = function(getResponders, announce) {
    var asyncMarshal = getAsyncMarshal();
    var dragging = null;
    var beforeCapture = function beforeCapture(draggableId, mode) {
        !!dragging && invariant(false);
        withTimings("onBeforeCapture", function() {
            var fn = getResponders().onBeforeCapture;
            if (fn) {
                var before = {
                    draggableId: draggableId,
                    mode: mode
                };
                fn(before);
            }
        });
    };
    var beforeStart = function beforeStart(critical, mode) {
        !!dragging && invariant(false);
        withTimings("onBeforeDragStart", function() {
            var fn = getResponders().onBeforeDragStart;
            if (fn) fn(getDragStart(critical, mode));
        });
    };
    var start = function start(critical, mode) {
        !!dragging && invariant(false);
        var data = getDragStart(critical, mode);
        dragging = {
            mode: mode,
            lastCritical: critical,
            lastLocation: data.source,
            lastCombine: null
        };
        asyncMarshal.add(function() {
            withTimings("onDragStart", function() {
                return execute(getResponders().onDragStart, data, announce, preset.onDragStart);
            });
        });
    };
    var update = function update(critical, impact) {
        var location = tryGetDestination(impact);
        var combine = tryGetCombine(impact);
        !dragging && invariant(false);
        var hasCriticalChanged = !isCriticalEqual(critical, dragging.lastCritical);
        if (hasCriticalChanged) dragging.lastCritical = critical;
        var hasLocationChanged = !areLocationsEqual(dragging.lastLocation, location);
        if (hasLocationChanged) dragging.lastLocation = location;
        var hasGroupingChanged = !isCombineEqual(dragging.lastCombine, combine);
        if (hasGroupingChanged) dragging.lastCombine = combine;
        if (!hasCriticalChanged && !hasLocationChanged && !hasGroupingChanged) return;
        var data = (0, _extendsDefault.default)({}, getDragStart(critical, dragging.mode), {
            combine: combine,
            destination: location
        });
        asyncMarshal.add(function() {
            withTimings("onDragUpdate", function() {
                return execute(getResponders().onDragUpdate, data, announce, preset.onDragUpdate);
            });
        });
    };
    var flush = function flush() {
        !dragging && invariant(false);
        asyncMarshal.flush();
    };
    var drop = function drop(result) {
        !dragging && invariant(false);
        dragging = null;
        withTimings("onDragEnd", function() {
            return execute(getResponders().onDragEnd, result, announce, preset.onDragEnd);
        });
    };
    var abort = function abort() {
        if (!dragging) return;
        var result = (0, _extendsDefault.default)({}, getDragStart(dragging.lastCritical, dragging.mode), {
            combine: null,
            destination: null,
            reason: "CANCEL"
        });
        drop(result);
    };
    return {
        beforeCapture: beforeCapture,
        beforeStart: beforeStart,
        start: start,
        update: update,
        flush: flush,
        drop: drop,
        abort: abort
    };
};
var responders = function(getResponders, announce) {
    var publisher = getPublisher(getResponders, announce);
    return function(store) {
        return function(next) {
            return function(action) {
                if (action.type === "BEFORE_INITIAL_CAPTURE") {
                    publisher.beforeCapture(action.payload.draggableId, action.payload.movementMode);
                    return;
                }
                if (action.type === "INITIAL_PUBLISH") {
                    var critical = action.payload.critical;
                    publisher.beforeStart(critical, action.payload.movementMode);
                    next(action);
                    publisher.start(critical, action.payload.movementMode);
                    return;
                }
                if (action.type === "DROP_COMPLETE") {
                    var result = action.payload.completed.result;
                    publisher.flush();
                    next(action);
                    publisher.drop(result);
                    return;
                }
                next(action);
                if (action.type === "FLUSH") {
                    publisher.abort();
                    return;
                }
                var state = store.getState();
                if (state.phase === "DRAGGING") publisher.update(state.critical, state.impact);
            };
        };
    };
};
var dropAnimationFinish = function(store) {
    return function(next) {
        return function(action) {
            if (action.type !== "DROP_ANIMATION_FINISHED") {
                next(action);
                return;
            }
            var state = store.getState();
            !(state.phase === "DROP_ANIMATING") && invariant(false);
            store.dispatch(completeDrop({
                completed: state.completed
            }));
        };
    };
};
var dropAnimationFlushOnScroll = function(store) {
    var unbind = null;
    var frameId = null;
    function clear() {
        if (frameId) {
            cancelAnimationFrame(frameId);
            frameId = null;
        }
        if (unbind) {
            unbind();
            unbind = null;
        }
    }
    return function(next) {
        return function(action) {
            if (action.type === "FLUSH" || action.type === "DROP_COMPLETE" || action.type === "DROP_ANIMATION_FINISHED") clear();
            next(action);
            if (action.type !== "DROP_ANIMATE") return;
            var binding = {
                eventName: "scroll",
                options: {
                    capture: true,
                    passive: false,
                    once: true
                },
                fn: function flushDropAnimation() {
                    var state = store.getState();
                    if (state.phase === "DROP_ANIMATING") store.dispatch(dropAnimationFinished());
                }
            };
            frameId = requestAnimationFrame(function() {
                frameId = null;
                unbind = bindEvents(window, [
                    binding
                ]);
            });
        };
    };
};
var dimensionMarshalStopper = function(marshal) {
    return function() {
        return function(next) {
            return function(action) {
                if (action.type === "DROP_COMPLETE" || action.type === "FLUSH" || action.type === "DROP_ANIMATE") marshal.stopPublishing();
                next(action);
            };
        };
    };
};
var focus = function(marshal) {
    var isWatching = false;
    return function() {
        return function(next) {
            return function(action) {
                if (action.type === "INITIAL_PUBLISH") {
                    isWatching = true;
                    marshal.tryRecordFocus(action.payload.critical.draggable.id);
                    next(action);
                    marshal.tryRestoreFocusRecorded();
                    return;
                }
                next(action);
                if (!isWatching) return;
                if (action.type === "FLUSH") {
                    isWatching = false;
                    marshal.tryRestoreFocusRecorded();
                    return;
                }
                if (action.type === "DROP_COMPLETE") {
                    isWatching = false;
                    var result = action.payload.completed.result;
                    if (result.combine) marshal.tryShiftRecord(result.draggableId, result.combine.draggableId);
                    marshal.tryRestoreFocusRecorded();
                }
            };
        };
    };
};
var shouldStop = function shouldStop(action) {
    return action.type === "DROP_COMPLETE" || action.type === "DROP_ANIMATE" || action.type === "FLUSH";
};
var autoScroll = function(autoScroller) {
    return function(store) {
        return function(next) {
            return function(action) {
                if (shouldStop(action)) {
                    autoScroller.stop();
                    next(action);
                    return;
                }
                if (action.type === "INITIAL_PUBLISH") {
                    next(action);
                    var state = store.getState();
                    !(state.phase === "DRAGGING") && invariant(false);
                    autoScroller.start(state);
                    return;
                }
                next(action);
                autoScroller.scroll(store.getState());
            };
        };
    };
};
var pendingDrop = function(store) {
    return function(next) {
        return function(action) {
            next(action);
            if (action.type !== "PUBLISH_WHILE_DRAGGING") return;
            var postActionState = store.getState();
            if (postActionState.phase !== "DROP_PENDING") return;
            if (postActionState.isWaiting) return;
            store.dispatch(drop({
                reason: postActionState.reason
            }));
        };
    };
};
var composeEnhancers = (0, _redux.compose);
var createStore = function(_ref) {
    var dimensionMarshal = _ref.dimensionMarshal, focusMarshal = _ref.focusMarshal, styleMarshal = _ref.styleMarshal, getResponders = _ref.getResponders, announce = _ref.announce, autoScroller = _ref.autoScroller;
    return (0, _redux.createStore)(reducer, composeEnhancers((0, _redux.applyMiddleware)(style(styleMarshal), dimensionMarshalStopper(dimensionMarshal), lift$1(dimensionMarshal), drop$1, dropAnimationFinish, dropAnimationFlushOnScroll, pendingDrop, autoScroll(autoScroller), scrollListener, focus(focusMarshal), responders(getResponders, announce))));
};
var clean$1 = function clean() {
    return {
        additions: {},
        removals: {},
        modified: {}
    };
};
var timingKey = "Publish collection from DOM";
function createPublisher(_ref) {
    var registry = _ref.registry, callbacks = _ref.callbacks;
    var staging = clean$1();
    var frameId = null;
    var collect = function collect() {
        if (frameId) return;
        callbacks.collectionStarting();
        frameId = requestAnimationFrame(function() {
            frameId = null;
            start(timingKey);
            var _staging = staging, additions = _staging.additions, removals = _staging.removals, modified = _staging.modified;
            var added = (0, _keysDefault.default)(additions).map(function(id) {
                return registry.draggable.getById(id).getDimension(origin);
            }).sort(function(a, b) {
                return a.descriptor.index - b.descriptor.index;
            });
            var updated = (0, _keysDefault.default)(modified).map(function(id) {
                var entry = registry.droppable.getById(id);
                var scroll = entry.callbacks.getScrollWhileDragging();
                return {
                    droppableId: id,
                    scroll: scroll
                };
            });
            var result = {
                additions: added,
                removals: (0, _keysDefault.default)(removals),
                modified: updated
            };
            staging = clean$1();
            finish(timingKey);
            callbacks.publish(result);
        });
    };
    var add = function add(entry) {
        var id = entry.descriptor.id;
        staging.additions[id] = entry;
        staging.modified[entry.descriptor.droppableId] = true;
        if (staging.removals[id]) delete staging.removals[id];
        collect();
    };
    var remove = function remove(entry) {
        var descriptor = entry.descriptor;
        staging.removals[descriptor.id] = true;
        staging.modified[descriptor.droppableId] = true;
        if (staging.additions[descriptor.id]) delete staging.additions[descriptor.id];
        collect();
    };
    var stop = function stop() {
        if (!frameId) return;
        cancelAnimationFrame(frameId);
        frameId = null;
        staging = clean$1();
    };
    return {
        add: add,
        remove: remove,
        stop: stop
    };
}
var getMaxScroll = function(_ref) {
    var scrollHeight = _ref.scrollHeight, scrollWidth = _ref.scrollWidth, height = _ref.height, width = _ref.width;
    var maxScroll = subtract({
        x: scrollWidth,
        y: scrollHeight
    }, {
        x: width,
        y: height
    });
    var adjustedMaxScroll = {
        x: Math.max(0, maxScroll.x),
        y: Math.max(0, maxScroll.y)
    };
    return adjustedMaxScroll;
};
var getDocumentElement = function() {
    var doc = document.documentElement;
    !doc && invariant(false);
    return doc;
};
var getMaxWindowScroll = function() {
    var doc = getDocumentElement();
    var maxScroll = getMaxScroll({
        scrollHeight: doc.scrollHeight,
        scrollWidth: doc.scrollWidth,
        width: doc.clientWidth,
        height: doc.clientHeight
    });
    return maxScroll;
};
var getViewport = function() {
    var scroll = getWindowScroll();
    var maxScroll = getMaxWindowScroll();
    var top = scroll.y;
    var left = scroll.x;
    var doc = getDocumentElement();
    var width = doc.clientWidth;
    var height = doc.clientHeight;
    var right = left + width;
    var bottom = top + height;
    var frame = (0, _cssBoxModel.getRect)({
        top: top,
        left: left,
        right: right,
        bottom: bottom
    });
    var viewport = {
        frame: frame,
        scroll: {
            initial: scroll,
            current: scroll,
            max: maxScroll,
            diff: {
                value: origin,
                displacement: origin
            }
        }
    };
    return viewport;
};
var getInitialPublish = function(_ref) {
    var critical = _ref.critical, scrollOptions = _ref.scrollOptions, registry = _ref.registry;
    var timingKey = "Initial collection from DOM";
    start(timingKey);
    var viewport = getViewport();
    var windowScroll = viewport.scroll.current;
    var home = critical.droppable;
    var droppables = registry.droppable.getAllByType(home.type).map(function(entry) {
        return entry.callbacks.getDimensionAndWatchScroll(windowScroll, scrollOptions);
    });
    var draggables = registry.draggable.getAllByType(critical.draggable.type).map(function(entry) {
        return entry.getDimension(windowScroll);
    });
    var dimensions = {
        draggables: toDraggableMap(draggables),
        droppables: toDroppableMap(droppables)
    };
    finish(timingKey);
    var result = {
        dimensions: dimensions,
        critical: critical,
        viewport: viewport
    };
    return result;
};
function shouldPublishUpdate(registry, dragging, entry) {
    if (entry.descriptor.id === dragging.id) return false;
    if (entry.descriptor.type !== dragging.type) return false;
    var home = registry.droppable.getById(entry.descriptor.droppableId);
    if (home.descriptor.mode !== "virtual") return false;
    return true;
}
var createDimensionMarshal = function(registry, callbacks) {
    var collection = null;
    var publisher = createPublisher({
        callbacks: {
            publish: callbacks.publishWhileDragging,
            collectionStarting: callbacks.collectionStarting
        },
        registry: registry
    });
    var updateDroppableIsEnabled = function updateDroppableIsEnabled(id, isEnabled) {
        !registry.droppable.exists(id) && invariant(false);
        if (!collection) return;
        callbacks.updateDroppableIsEnabled({
            id: id,
            isEnabled: isEnabled
        });
    };
    var updateDroppableIsCombineEnabled = function updateDroppableIsCombineEnabled(id, isCombineEnabled) {
        if (!collection) return;
        !registry.droppable.exists(id) && invariant(false);
        callbacks.updateDroppableIsCombineEnabled({
            id: id,
            isCombineEnabled: isCombineEnabled
        });
    };
    var updateDroppableScroll = function updateDroppableScroll(id, newScroll) {
        if (!collection) return;
        !registry.droppable.exists(id) && invariant(false);
        callbacks.updateDroppableScroll({
            id: id,
            newScroll: newScroll
        });
    };
    var scrollDroppable = function scrollDroppable(id, change) {
        if (!collection) return;
        registry.droppable.getById(id).callbacks.scroll(change);
    };
    var stopPublishing = function stopPublishing() {
        if (!collection) return;
        publisher.stop();
        var home = collection.critical.droppable;
        registry.droppable.getAllByType(home.type).forEach(function(entry) {
            return entry.callbacks.dragStopped();
        });
        collection.unsubscribe();
        collection = null;
    };
    var subscriber = function subscriber(event) {
        !collection && invariant(false);
        var dragging = collection.critical.draggable;
        if (event.type === "ADDITION") {
            if (shouldPublishUpdate(registry, dragging, event.value)) publisher.add(event.value);
        }
        if (event.type === "REMOVAL") {
            if (shouldPublishUpdate(registry, dragging, event.value)) publisher.remove(event.value);
        }
    };
    var startPublishing = function startPublishing(request) {
        !!collection && invariant(false);
        var entry = registry.draggable.getById(request.draggableId);
        var home = registry.droppable.getById(entry.descriptor.droppableId);
        var critical = {
            draggable: entry.descriptor,
            droppable: home.descriptor
        };
        var unsubscribe = registry.subscribe(subscriber);
        collection = {
            critical: critical,
            unsubscribe: unsubscribe
        };
        return getInitialPublish({
            critical: critical,
            registry: registry,
            scrollOptions: request.scrollOptions
        });
    };
    var marshal = {
        updateDroppableIsEnabled: updateDroppableIsEnabled,
        updateDroppableIsCombineEnabled: updateDroppableIsCombineEnabled,
        scrollDroppable: scrollDroppable,
        updateDroppableScroll: updateDroppableScroll,
        startPublishing: startPublishing,
        stopPublishing: stopPublishing
    };
    return marshal;
};
var canStartDrag = function(state, id) {
    if (state.phase === "IDLE") return true;
    if (state.phase !== "DROP_ANIMATING") return false;
    if (state.completed.result.draggableId === id) return false;
    return state.completed.result.reason === "DROP";
};
var scrollWindow = function(change) {
    window.scrollBy(change.x, change.y);
};
var getScrollableDroppables = (0, _memoizeOneDefault.default)(function(droppables) {
    return toDroppableList(droppables).filter(function(droppable) {
        if (!droppable.isEnabled) return false;
        if (!droppable.frame) return false;
        return true;
    });
});
var getScrollableDroppableOver = function getScrollableDroppableOver(target, droppables) {
    var maybe = find(getScrollableDroppables(droppables), function(droppable) {
        !droppable.frame && invariant(false);
        return isPositionInFrame(droppable.frame.pageMarginBox)(target);
    });
    return maybe;
};
var getBestScrollableDroppable = function(_ref) {
    var center = _ref.center, destination = _ref.destination, droppables = _ref.droppables;
    if (destination) {
        var _dimension = droppables[destination];
        if (!_dimension.frame) return null;
        return _dimension;
    }
    var dimension = getScrollableDroppableOver(center, droppables);
    return dimension;
};
var config = {
    startFromPercentage: 0.25,
    maxScrollAtPercentage: 0.05,
    maxPixelScroll: 28,
    ease: function ease(percentage) {
        return Math.pow(percentage, 2);
    },
    durationDampening: {
        stopDampeningAt: 1200,
        accelerateAt: 360
    }
};
var getDistanceThresholds = function(container, axis) {
    var startScrollingFrom = container[axis.size] * config.startFromPercentage;
    var maxScrollValueAt = container[axis.size] * config.maxScrollAtPercentage;
    var thresholds = {
        startScrollingFrom: startScrollingFrom,
        maxScrollValueAt: maxScrollValueAt
    };
    return thresholds;
};
var getPercentage = function(_ref) {
    var startOfRange = _ref.startOfRange, endOfRange = _ref.endOfRange, current = _ref.current;
    var range = endOfRange - startOfRange;
    if (range === 0) return 0;
    var currentInRange = current - startOfRange;
    var percentage = currentInRange / range;
    return percentage;
};
var minScroll = 1;
var getValueFromDistance = function(distanceToEdge, thresholds) {
    if (distanceToEdge > thresholds.startScrollingFrom) return 0;
    if (distanceToEdge <= thresholds.maxScrollValueAt) return config.maxPixelScroll;
    if (distanceToEdge === thresholds.startScrollingFrom) return minScroll;
    var percentageFromMaxScrollValueAt = getPercentage({
        startOfRange: thresholds.maxScrollValueAt,
        endOfRange: thresholds.startScrollingFrom,
        current: distanceToEdge
    });
    var percentageFromStartScrollingFrom = 1 - percentageFromMaxScrollValueAt;
    var scroll = config.maxPixelScroll * config.ease(percentageFromStartScrollingFrom);
    return Math.ceil(scroll);
};
var accelerateAt = config.durationDampening.accelerateAt;
var stopAt = config.durationDampening.stopDampeningAt;
var dampenValueByTime = function(proposedScroll, dragStartTime) {
    var startOfRange = dragStartTime;
    var endOfRange = stopAt;
    var now = (0, _nowDefault.default)();
    var runTime = now - startOfRange;
    if (runTime >= stopAt) return proposedScroll;
    if (runTime < accelerateAt) return minScroll;
    var betweenAccelerateAtAndStopAtPercentage = getPercentage({
        startOfRange: accelerateAt,
        endOfRange: endOfRange,
        current: runTime
    });
    var scroll = proposedScroll * config.ease(betweenAccelerateAtAndStopAtPercentage);
    return Math.ceil(scroll);
};
var getValue = function(_ref) {
    var distanceToEdge = _ref.distanceToEdge, thresholds = _ref.thresholds, dragStartTime = _ref.dragStartTime, shouldUseTimeDampening = _ref.shouldUseTimeDampening;
    var scroll = getValueFromDistance(distanceToEdge, thresholds);
    if (scroll === 0) return 0;
    if (!shouldUseTimeDampening) return scroll;
    return Math.max(dampenValueByTime(scroll, dragStartTime), minScroll);
};
var getScrollOnAxis = function(_ref) {
    var container = _ref.container, distanceToEdges = _ref.distanceToEdges, dragStartTime = _ref.dragStartTime, axis = _ref.axis, shouldUseTimeDampening = _ref.shouldUseTimeDampening;
    var thresholds = getDistanceThresholds(container, axis);
    var isCloserToEnd = distanceToEdges[axis.end] < distanceToEdges[axis.start];
    if (isCloserToEnd) return getValue({
        distanceToEdge: distanceToEdges[axis.end],
        thresholds: thresholds,
        dragStartTime: dragStartTime,
        shouldUseTimeDampening: shouldUseTimeDampening
    });
    return -1 * getValue({
        distanceToEdge: distanceToEdges[axis.start],
        thresholds: thresholds,
        dragStartTime: dragStartTime,
        shouldUseTimeDampening: shouldUseTimeDampening
    });
};
var adjustForSizeLimits = function(_ref) {
    var container = _ref.container, subject = _ref.subject, proposedScroll = _ref.proposedScroll;
    var isTooBigVertically = subject.height > container.height;
    var isTooBigHorizontally = subject.width > container.width;
    if (!isTooBigHorizontally && !isTooBigVertically) return proposedScroll;
    if (isTooBigHorizontally && isTooBigVertically) return null;
    return {
        x: isTooBigHorizontally ? 0 : proposedScroll.x,
        y: isTooBigVertically ? 0 : proposedScroll.y
    };
};
var clean$2 = apply(function(value) {
    return value === 0 ? 0 : value;
});
var getScroll = function(_ref) {
    var dragStartTime = _ref.dragStartTime, container = _ref.container, subject = _ref.subject, center = _ref.center, shouldUseTimeDampening = _ref.shouldUseTimeDampening;
    var distanceToEdges = {
        top: center.y - container.top,
        right: container.right - center.x,
        bottom: container.bottom - center.y,
        left: center.x - container.left
    };
    var y = getScrollOnAxis({
        container: container,
        distanceToEdges: distanceToEdges,
        dragStartTime: dragStartTime,
        axis: vertical,
        shouldUseTimeDampening: shouldUseTimeDampening
    });
    var x = getScrollOnAxis({
        container: container,
        distanceToEdges: distanceToEdges,
        dragStartTime: dragStartTime,
        axis: horizontal,
        shouldUseTimeDampening: shouldUseTimeDampening
    });
    var required = clean$2({
        x: x,
        y: y
    });
    if (isEqual(required, origin)) return null;
    var limited = adjustForSizeLimits({
        container: container,
        subject: subject,
        proposedScroll: required
    });
    if (!limited) return null;
    return isEqual(limited, origin) ? null : limited;
};
var smallestSigned = apply(function(value) {
    if (value === 0) return 0;
    return value > 0 ? 1 : -1;
});
var getOverlap = function() {
    var getRemainder = function getRemainder(target, max) {
        if (target < 0) return target;
        if (target > max) return target - max;
        return 0;
    };
    return function(_ref) {
        var current = _ref.current, max = _ref.max, change = _ref.change;
        var targetScroll = add(current, change);
        var overlap = {
            x: getRemainder(targetScroll.x, max.x),
            y: getRemainder(targetScroll.y, max.y)
        };
        if (isEqual(overlap, origin)) return null;
        return overlap;
    };
}();
var canPartiallyScroll = function canPartiallyScroll(_ref2) {
    var rawMax = _ref2.max, current = _ref2.current, change = _ref2.change;
    var max = {
        x: Math.max(current.x, rawMax.x),
        y: Math.max(current.y, rawMax.y)
    };
    var smallestChange = smallestSigned(change);
    var overlap = getOverlap({
        max: max,
        current: current,
        change: smallestChange
    });
    if (!overlap) return true;
    if (smallestChange.x !== 0 && overlap.x === 0) return true;
    if (smallestChange.y !== 0 && overlap.y === 0) return true;
    return false;
};
var canScrollWindow = function canScrollWindow(viewport, change) {
    return canPartiallyScroll({
        current: viewport.scroll.current,
        max: viewport.scroll.max,
        change: change
    });
};
var getWindowOverlap = function getWindowOverlap(viewport, change) {
    if (!canScrollWindow(viewport, change)) return null;
    var max = viewport.scroll.max;
    var current = viewport.scroll.current;
    return getOverlap({
        current: current,
        max: max,
        change: change
    });
};
var canScrollDroppable = function canScrollDroppable(droppable, change) {
    var frame = droppable.frame;
    if (!frame) return false;
    return canPartiallyScroll({
        current: frame.scroll.current,
        max: frame.scroll.max,
        change: change
    });
};
var getDroppableOverlap = function getDroppableOverlap(droppable, change) {
    var frame = droppable.frame;
    if (!frame) return null;
    if (!canScrollDroppable(droppable, change)) return null;
    return getOverlap({
        current: frame.scroll.current,
        max: frame.scroll.max,
        change: change
    });
};
var getWindowScrollChange = function(_ref) {
    var viewport = _ref.viewport, subject = _ref.subject, center = _ref.center, dragStartTime = _ref.dragStartTime, shouldUseTimeDampening = _ref.shouldUseTimeDampening;
    var scroll = getScroll({
        dragStartTime: dragStartTime,
        container: viewport.frame,
        subject: subject,
        center: center,
        shouldUseTimeDampening: shouldUseTimeDampening
    });
    return scroll && canScrollWindow(viewport, scroll) ? scroll : null;
};
var getDroppableScrollChange = function(_ref) {
    var droppable = _ref.droppable, subject = _ref.subject, center = _ref.center, dragStartTime = _ref.dragStartTime, shouldUseTimeDampening = _ref.shouldUseTimeDampening;
    var frame = droppable.frame;
    if (!frame) return null;
    var scroll = getScroll({
        dragStartTime: dragStartTime,
        container: frame.pageMarginBox,
        subject: subject,
        center: center,
        shouldUseTimeDampening: shouldUseTimeDampening
    });
    return scroll && canScrollDroppable(droppable, scroll) ? scroll : null;
};
var scroll$1 = function(_ref) {
    var state = _ref.state, dragStartTime = _ref.dragStartTime, shouldUseTimeDampening = _ref.shouldUseTimeDampening, scrollWindow = _ref.scrollWindow, scrollDroppable = _ref.scrollDroppable;
    var center = state.current.page.borderBoxCenter;
    var draggable = state.dimensions.draggables[state.critical.draggable.id];
    var subject = draggable.page.marginBox;
    if (state.isWindowScrollAllowed) {
        var viewport = state.viewport;
        var _change = getWindowScrollChange({
            dragStartTime: dragStartTime,
            viewport: viewport,
            subject: subject,
            center: center,
            shouldUseTimeDampening: shouldUseTimeDampening
        });
        if (_change) {
            scrollWindow(_change);
            return;
        }
    }
    var droppable = getBestScrollableDroppable({
        center: center,
        destination: whatIsDraggedOver(state.impact),
        droppables: state.dimensions.droppables
    });
    if (!droppable) return;
    var change = getDroppableScrollChange({
        dragStartTime: dragStartTime,
        droppable: droppable,
        subject: subject,
        center: center,
        shouldUseTimeDampening: shouldUseTimeDampening
    });
    if (change) scrollDroppable(droppable.descriptor.id, change);
};
var createFluidScroller = function(_ref) {
    var scrollWindow = _ref.scrollWindow, scrollDroppable = _ref.scrollDroppable;
    var scheduleWindowScroll = (0, _rafSchdDefault.default)(scrollWindow);
    var scheduleDroppableScroll = (0, _rafSchdDefault.default)(scrollDroppable);
    var dragging = null;
    var tryScroll = function tryScroll(state) {
        !dragging && invariant(false);
        var _dragging = dragging, shouldUseTimeDampening = _dragging.shouldUseTimeDampening, dragStartTime = _dragging.dragStartTime;
        scroll$1({
            state: state,
            scrollWindow: scheduleWindowScroll,
            scrollDroppable: scheduleDroppableScroll,
            dragStartTime: dragStartTime,
            shouldUseTimeDampening: shouldUseTimeDampening
        });
    };
    var start$1 = function start$1(state) {
        start("starting fluid scroller");
        !!dragging && invariant(false);
        var dragStartTime = (0, _nowDefault.default)();
        var wasScrollNeeded = false;
        var fakeScrollCallback = function fakeScrollCallback() {
            wasScrollNeeded = true;
        };
        scroll$1({
            state: state,
            dragStartTime: 0,
            shouldUseTimeDampening: false,
            scrollWindow: fakeScrollCallback,
            scrollDroppable: fakeScrollCallback
        });
        dragging = {
            dragStartTime: dragStartTime,
            shouldUseTimeDampening: wasScrollNeeded
        };
        finish("starting fluid scroller");
        if (wasScrollNeeded) tryScroll(state);
    };
    var stop = function stop() {
        if (!dragging) return;
        scheduleWindowScroll.cancel();
        scheduleDroppableScroll.cancel();
        dragging = null;
    };
    return {
        start: start$1,
        stop: stop,
        scroll: tryScroll
    };
};
var createJumpScroller = function(_ref) {
    var move = _ref.move, scrollDroppable = _ref.scrollDroppable, scrollWindow = _ref.scrollWindow;
    var moveByOffset = function moveByOffset(state, offset) {
        var client = add(state.current.client.selection, offset);
        move({
            client: client
        });
    };
    var scrollDroppableAsMuchAsItCan = function scrollDroppableAsMuchAsItCan(droppable, change) {
        if (!canScrollDroppable(droppable, change)) return change;
        var overlap = getDroppableOverlap(droppable, change);
        if (!overlap) {
            scrollDroppable(droppable.descriptor.id, change);
            return null;
        }
        var whatTheDroppableCanScroll = subtract(change, overlap);
        scrollDroppable(droppable.descriptor.id, whatTheDroppableCanScroll);
        var remainder = subtract(change, whatTheDroppableCanScroll);
        return remainder;
    };
    var scrollWindowAsMuchAsItCan = function scrollWindowAsMuchAsItCan(isWindowScrollAllowed, viewport, change) {
        if (!isWindowScrollAllowed) return change;
        if (!canScrollWindow(viewport, change)) return change;
        var overlap = getWindowOverlap(viewport, change);
        if (!overlap) {
            scrollWindow(change);
            return null;
        }
        var whatTheWindowCanScroll = subtract(change, overlap);
        scrollWindow(whatTheWindowCanScroll);
        var remainder = subtract(change, whatTheWindowCanScroll);
        return remainder;
    };
    var jumpScroller = function jumpScroller(state) {
        var request = state.scrollJumpRequest;
        if (!request) return;
        var destination = whatIsDraggedOver(state.impact);
        !destination && invariant(false);
        var droppableRemainder = scrollDroppableAsMuchAsItCan(state.dimensions.droppables[destination], request);
        if (!droppableRemainder) return;
        var viewport = state.viewport;
        var windowRemainder = scrollWindowAsMuchAsItCan(state.isWindowScrollAllowed, viewport, droppableRemainder);
        if (!windowRemainder) return;
        moveByOffset(state, windowRemainder);
    };
    return jumpScroller;
};
var createAutoScroller = function(_ref) {
    var scrollDroppable = _ref.scrollDroppable, scrollWindow = _ref.scrollWindow, move = _ref.move;
    var fluidScroller = createFluidScroller({
        scrollWindow: scrollWindow,
        scrollDroppable: scrollDroppable
    });
    var jumpScroll = createJumpScroller({
        move: move,
        scrollWindow: scrollWindow,
        scrollDroppable: scrollDroppable
    });
    var scroll = function scroll(state) {
        if (state.phase !== "DRAGGING") return;
        if (state.movementMode === "FLUID") {
            fluidScroller.scroll(state);
            return;
        }
        if (!state.scrollJumpRequest) return;
        jumpScroll(state);
    };
    var scroller = {
        scroll: scroll,
        start: fluidScroller.start,
        stop: fluidScroller.stop
    };
    return scroller;
};
var prefix$1 = "data-rbd";
var dragHandle = function() {
    var base = prefix$1 + "-drag-handle";
    return {
        base: base,
        draggableId: base + "-draggable-id",
        contextId: base + "-context-id"
    };
}();
var draggable = function() {
    var base = prefix$1 + "-draggable";
    return {
        base: base,
        contextId: base + "-context-id",
        id: base + "-id"
    };
}();
var droppable = function() {
    var base = prefix$1 + "-droppable";
    return {
        base: base,
        contextId: base + "-context-id",
        id: base + "-id"
    };
}();
var scrollContainer = {
    contextId: prefix$1 + "-scroll-container-context-id"
};
var makeGetSelector = function makeGetSelector(context) {
    return function(attribute) {
        return "[" + attribute + '="' + context + '"]';
    };
};
var getStyles = function getStyles(rules, property) {
    return rules.map(function(rule) {
        var value = rule.styles[property];
        if (!value) return "";
        return rule.selector + " { " + value + " }";
    }).join(" ");
};
var noPointerEvents = "pointer-events: none;";
var getStyles$1 = function(contextId) {
    var getSelector = makeGetSelector(contextId);
    var dragHandle$1 = function() {
        var grabCursor = "\n      cursor: -webkit-grab;\n      cursor: grab;\n    ";
        return {
            selector: getSelector(dragHandle.contextId),
            styles: {
                always: "\n          -webkit-touch-callout: none;\n          -webkit-tap-highlight-color: rgba(0,0,0,0);\n          touch-action: manipulation;\n        ",
                resting: grabCursor,
                dragging: noPointerEvents,
                dropAnimating: grabCursor
            }
        };
    }();
    var draggable$1 = function() {
        var transition = "\n      transition: " + transitions.outOfTheWay + ";\n    ";
        return {
            selector: getSelector(draggable.contextId),
            styles: {
                dragging: transition,
                dropAnimating: transition,
                userCancel: transition
            }
        };
    }();
    var droppable$1 = {
        selector: getSelector(droppable.contextId),
        styles: {
            always: "overflow-anchor: none;"
        }
    };
    var body = {
        selector: "body",
        styles: {
            dragging: "\n        cursor: grabbing;\n        cursor: -webkit-grabbing;\n        user-select: none;\n        -webkit-user-select: none;\n        -moz-user-select: none;\n        -ms-user-select: none;\n        overflow-anchor: none;\n      "
        }
    };
    var rules = [
        draggable$1,
        dragHandle$1,
        droppable$1,
        body
    ];
    return {
        always: getStyles(rules, "always"),
        resting: getStyles(rules, "resting"),
        dragging: getStyles(rules, "dragging"),
        dropAnimating: getStyles(rules, "dropAnimating"),
        userCancel: getStyles(rules, "userCancel")
    };
};
var useIsomorphicLayoutEffect = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined" ? (0, _react.useLayoutEffect) : (0, _react.useEffect);
var getHead = function getHead() {
    var head = document.querySelector("head");
    !head && invariant(false);
    return head;
};
var createStyleEl = function createStyleEl(nonce) {
    var el = document.createElement("style");
    if (nonce) el.setAttribute("nonce", nonce);
    el.type = "text/css";
    return el;
};
function useStyleMarshal(contextId, nonce) {
    var styles = (0, _useMemoOne.useMemo)(function() {
        return getStyles$1(contextId);
    }, [
        contextId
    ]);
    var alwaysRef = (0, _react.useRef)(null);
    var dynamicRef = (0, _react.useRef)(null);
    var setDynamicStyle = (0, _useMemoOne.useCallback)((0, _memoizeOneDefault.default)(function(proposed) {
        var el = dynamicRef.current;
        !el && invariant(false);
        el.textContent = proposed;
    }), []);
    var setAlwaysStyle = (0, _useMemoOne.useCallback)(function(proposed) {
        var el = alwaysRef.current;
        !el && invariant(false);
        el.textContent = proposed;
    }, []);
    useIsomorphicLayoutEffect(function() {
        !(!alwaysRef.current && !dynamicRef.current) && invariant(false);
        var always = createStyleEl(nonce);
        var dynamic = createStyleEl(nonce);
        alwaysRef.current = always;
        dynamicRef.current = dynamic;
        always.setAttribute(prefix$1 + "-always", contextId);
        dynamic.setAttribute(prefix$1 + "-dynamic", contextId);
        getHead().appendChild(always);
        getHead().appendChild(dynamic);
        setAlwaysStyle(styles.always);
        setDynamicStyle(styles.resting);
        return function() {
            var remove = function remove(ref) {
                var current = ref.current;
                !current && invariant(false);
                getHead().removeChild(current);
                ref.current = null;
            };
            remove(alwaysRef);
            remove(dynamicRef);
        };
    }, [
        nonce,
        setAlwaysStyle,
        setDynamicStyle,
        styles.always,
        styles.resting,
        contextId
    ]);
    var dragging = (0, _useMemoOne.useCallback)(function() {
        return setDynamicStyle(styles.dragging);
    }, [
        setDynamicStyle,
        styles.dragging
    ]);
    var dropping = (0, _useMemoOne.useCallback)(function(reason) {
        if (reason === "DROP") {
            setDynamicStyle(styles.dropAnimating);
            return;
        }
        setDynamicStyle(styles.userCancel);
    }, [
        setDynamicStyle,
        styles.dropAnimating,
        styles.userCancel
    ]);
    var resting = (0, _useMemoOne.useCallback)(function() {
        if (!dynamicRef.current) return;
        setDynamicStyle(styles.resting);
    }, [
        setDynamicStyle,
        styles.resting
    ]);
    var marshal = (0, _useMemoOne.useMemo)(function() {
        return {
            dragging: dragging,
            dropping: dropping,
            resting: resting
        };
    }, [
        dragging,
        dropping,
        resting
    ]);
    return marshal;
}
var getWindowFromEl = function(el) {
    return el && el.ownerDocument ? el.ownerDocument.defaultView : window;
};
function isHtmlElement(el) {
    return el instanceof getWindowFromEl(el).HTMLElement;
}
function findDragHandle(contextId, draggableId) {
    var selector = "[" + dragHandle.contextId + '="' + contextId + '"]';
    var possible = toArray(document.querySelectorAll(selector));
    if (!possible.length) return null;
    var handle = find(possible, function(el) {
        return el.getAttribute(dragHandle.draggableId) === draggableId;
    });
    if (!handle) return null;
    if (!isHtmlElement(handle)) return null;
    return handle;
}
function useFocusMarshal(contextId) {
    var entriesRef = (0, _react.useRef)({});
    var recordRef = (0, _react.useRef)(null);
    var restoreFocusFrameRef = (0, _react.useRef)(null);
    var isMountedRef = (0, _react.useRef)(false);
    var register = (0, _useMemoOne.useCallback)(function register(id, focus) {
        var entry = {
            id: id,
            focus: focus
        };
        entriesRef.current[id] = entry;
        return function unregister() {
            var entries = entriesRef.current;
            var current = entries[id];
            if (current !== entry) delete entries[id];
        };
    }, []);
    var tryGiveFocus = (0, _useMemoOne.useCallback)(function tryGiveFocus(tryGiveFocusTo) {
        var handle = findDragHandle(contextId, tryGiveFocusTo);
        if (handle && handle !== document.activeElement) handle.focus();
    }, [
        contextId
    ]);
    var tryShiftRecord = (0, _useMemoOne.useCallback)(function tryShiftRecord(previous, redirectTo) {
        if (recordRef.current === previous) recordRef.current = redirectTo;
    }, []);
    var tryRestoreFocusRecorded = (0, _useMemoOne.useCallback)(function tryRestoreFocusRecorded() {
        if (restoreFocusFrameRef.current) return;
        if (!isMountedRef.current) return;
        restoreFocusFrameRef.current = requestAnimationFrame(function() {
            restoreFocusFrameRef.current = null;
            var record = recordRef.current;
            if (record) tryGiveFocus(record);
        });
    }, [
        tryGiveFocus
    ]);
    var tryRecordFocus = (0, _useMemoOne.useCallback)(function tryRecordFocus(id) {
        recordRef.current = null;
        var focused = document.activeElement;
        if (!focused) return;
        if (focused.getAttribute(dragHandle.draggableId) !== id) return;
        recordRef.current = id;
    }, []);
    useIsomorphicLayoutEffect(function() {
        isMountedRef.current = true;
        return function clearFrameOnUnmount() {
            isMountedRef.current = false;
            var frameId = restoreFocusFrameRef.current;
            if (frameId) cancelAnimationFrame(frameId);
        };
    }, []);
    var marshal = (0, _useMemoOne.useMemo)(function() {
        return {
            register: register,
            tryRecordFocus: tryRecordFocus,
            tryRestoreFocusRecorded: tryRestoreFocusRecorded,
            tryShiftRecord: tryShiftRecord
        };
    }, [
        register,
        tryRecordFocus,
        tryRestoreFocusRecorded,
        tryShiftRecord
    ]);
    return marshal;
}
function createRegistry() {
    var entries = {
        draggables: {},
        droppables: {}
    };
    var subscribers = [];
    function subscribe(cb) {
        subscribers.push(cb);
        return function unsubscribe() {
            var index = subscribers.indexOf(cb);
            if (index === -1) return;
            subscribers.splice(index, 1);
        };
    }
    function notify(event) {
        if (subscribers.length) subscribers.forEach(function(cb) {
            return cb(event);
        });
    }
    function findDraggableById(id) {
        return entries.draggables[id] || null;
    }
    function getDraggableById(id) {
        var entry = findDraggableById(id);
        !entry && invariant(false);
        return entry;
    }
    var draggableAPI = {
        register: function register(entry) {
            entries.draggables[entry.descriptor.id] = entry;
            notify({
                type: "ADDITION",
                value: entry
            });
        },
        update: function update(entry, last) {
            var current = entries.draggables[last.descriptor.id];
            if (!current) return;
            if (current.uniqueId !== entry.uniqueId) return;
            delete entries.draggables[last.descriptor.id];
            entries.draggables[entry.descriptor.id] = entry;
        },
        unregister: function unregister(entry) {
            var draggableId = entry.descriptor.id;
            var current = findDraggableById(draggableId);
            if (!current) return;
            if (entry.uniqueId !== current.uniqueId) return;
            delete entries.draggables[draggableId];
            notify({
                type: "REMOVAL",
                value: entry
            });
        },
        getById: getDraggableById,
        findById: findDraggableById,
        exists: function exists(id) {
            return Boolean(findDraggableById(id));
        },
        getAllByType: function getAllByType(type) {
            return values(entries.draggables).filter(function(entry) {
                return entry.descriptor.type === type;
            });
        }
    };
    function findDroppableById(id) {
        return entries.droppables[id] || null;
    }
    function getDroppableById(id) {
        var entry = findDroppableById(id);
        !entry && invariant(false);
        return entry;
    }
    var droppableAPI = {
        register: function register(entry) {
            entries.droppables[entry.descriptor.id] = entry;
        },
        unregister: function unregister(entry) {
            var current = findDroppableById(entry.descriptor.id);
            if (!current) return;
            if (entry.uniqueId !== current.uniqueId) return;
            delete entries.droppables[entry.descriptor.id];
        },
        getById: getDroppableById,
        findById: findDroppableById,
        exists: function exists(id) {
            return Boolean(findDroppableById(id));
        },
        getAllByType: function getAllByType(type) {
            return values(entries.droppables).filter(function(entry) {
                return entry.descriptor.type === type;
            });
        }
    };
    function clean() {
        entries.draggables = {};
        entries.droppables = {};
        subscribers.length = 0;
    }
    return {
        draggable: draggableAPI,
        droppable: droppableAPI,
        subscribe: subscribe,
        clean: clean
    };
}
function useRegistry() {
    var registry = (0, _useMemoOne.useMemo)(createRegistry, []);
    (0, _react.useEffect)(function() {
        return function unmount() {
            requestAnimationFrame(registry.clean);
        };
    }, [
        registry
    ]);
    return registry;
}
var StoreContext = (0, _reactDefault.default).createContext(null);
var getBodyElement = function() {
    var body = document.body;
    !body && invariant(false);
    return body;
};
var visuallyHidden = {
    position: "absolute",
    width: "1px",
    height: "1px",
    margin: "-1px",
    border: "0",
    padding: "0",
    overflow: "hidden",
    clip: "rect(0 0 0 0)",
    "clip-path": "inset(100%)"
};
var getId = function getId(contextId) {
    return "rbd-announcement-" + contextId;
};
function useAnnouncer(contextId) {
    var id = (0, _useMemoOne.useMemo)(function() {
        return getId(contextId);
    }, [
        contextId
    ]);
    var ref = (0, _react.useRef)(null);
    (0, _react.useEffect)(function setup() {
        var el = document.createElement("div");
        ref.current = el;
        el.id = id;
        el.setAttribute("aria-live", "assertive");
        el.setAttribute("role", "log");
        el.setAttribute("aria-atomic", "true");
        (0, _assignDefault.default)(el.style, visuallyHidden);
        getBodyElement().appendChild(el);
        return function cleanup() {
            setTimeout(function remove() {
                getBodyElement().removeChild(el);
                if (el === ref.current) ref.current = null;
            });
        };
    }, [
        id
    ]);
    var announce = (0, _useMemoOne.useCallback)(function(message) {
        var el = ref.current;
        if (el) {
            el.textContent = message;
            return;
        }
    }, []);
    return announce;
}
var getId$1 = function getId(contextId) {
    return "rbd-lift-instruction-" + contextId;
};
function useLiftInstruction(contextId, liftInstruction) {
    var id = (0, _useMemoOne.useMemo)(function() {
        return getId$1(contextId);
    }, [
        contextId
    ]);
    (0, _react.useEffect)(function mount() {
        var el = document.createElement("div");
        el.id = id;
        el.textContent = liftInstruction;
        (0, _assignDefault.default)(el.style, {
            display: "none"
        });
        getBodyElement().appendChild(el);
        return function unmount() {
            getBodyElement().removeChild(el);
        };
    }, [
        id,
        liftInstruction
    ]);
    return id;
}
var AppContext = (0, _reactDefault.default).createContext(null);
var peerDependencies = {
    react: "^16.8.5",
    "react-dom": "^16.8.5"
};
var semver = /(\d+)\.(\d+)\.(\d+)/;
var getVersion = function getVersion(value) {
    var result = semver.exec(value);
    !(result != null) && invariant(false);
    var major = Number(result[1]);
    var minor = Number(result[2]);
    var patch = Number(result[3]);
    return {
        major: major,
        minor: minor,
        patch: patch,
        raw: value
    };
};
var isSatisfied = function isSatisfied(expected, actual) {
    if (actual.major > expected.major) return true;
    if (actual.major < expected.major) return false;
    if (actual.minor > expected.minor) return true;
    if (actual.minor < expected.minor) return false;
    return actual.patch >= expected.patch;
};
var checkReactVersion = function(peerDepValue, actualValue) {
    var peerDep = getVersion(peerDepValue);
    var actual = getVersion(actualValue);
    if (isSatisfied(peerDep, actual)) return;
};
var suffix = "\n  We expect a html5 doctype: <!doctype html>\n  This is to ensure consistent browser layout and measurement\n\n  More information: https://github.com/atlassian/react-beautiful-dnd/blob/master/docs/guides/doctype.md\n";
var checkDoctype = function(doc) {
    var doctype = doc.doctype;
    if (!doctype) return;
    doctype.name.toLowerCase();
    doctype.publicId;
};
function useDev(useHook) {}
function useDevSetupWarning(fn, inputs) {
    useDev(function() {
        (0, _react.useEffect)(function() {
            try {
                fn();
            } catch (e) {
                error("\n          A setup problem was encountered.\n\n          > " + e.message + "\n        ");
            }
        }, inputs);
    });
}
function useStartupValidation() {
    useDevSetupWarning(function() {
        checkReactVersion(peerDependencies.react, (0, _reactDefault.default).version);
        checkDoctype(document);
    }, []);
}
function usePrevious(current) {
    var ref = (0, _react.useRef)(current);
    (0, _react.useEffect)(function() {
        ref.current = current;
    });
    return ref;
}
function create() {
    var lock = null;
    function isClaimed() {
        return Boolean(lock);
    }
    function isActive(value) {
        return value === lock;
    }
    function claim(abandon) {
        !!lock && invariant(false);
        var newLock = {
            abandon: abandon
        };
        lock = newLock;
        return newLock;
    }
    function release() {
        !lock && invariant(false);
        lock = null;
    }
    function tryAbandon() {
        if (lock) {
            lock.abandon();
            release();
        }
    }
    return {
        isClaimed: isClaimed,
        isActive: isActive,
        claim: claim,
        release: release,
        tryAbandon: tryAbandon
    };
}
var tab = 9;
var enter = 13;
var escape = 27;
var space = 32;
var pageUp = 33;
var pageDown = 34;
var end = 35;
var home = 36;
var arrowLeft = 37;
var arrowUp = 38;
var arrowRight = 39;
var arrowDown = 40;
var _preventedKeys;
var preventedKeys = (_preventedKeys = {}, _preventedKeys[enter] = true, _preventedKeys[tab] = true, _preventedKeys);
var preventStandardKeyEvents = function(event) {
    if (preventedKeys[event.keyCode]) event.preventDefault();
};
var supportedEventName = function() {
    var base = "visibilitychange";
    if (typeof document === "undefined") return base;
    var candidates = [
        base,
        "ms" + base,
        "webkit" + base,
        "moz" + base,
        "o" + base
    ];
    var supported = find(candidates, function(eventName) {
        return "on" + eventName in document;
    });
    return supported || base;
}();
var primaryButton = 0;
var sloppyClickThreshold = 5;
function isSloppyClickThresholdExceeded(original, current) {
    return Math.abs(current.x - original.x) >= sloppyClickThreshold || Math.abs(current.y - original.y) >= sloppyClickThreshold;
}
var idle$1 = {
    type: "IDLE"
};
function getCaptureBindings(_ref) {
    var cancel = _ref.cancel, completed = _ref.completed, getPhase = _ref.getPhase, setPhase = _ref.setPhase;
    return [
        {
            eventName: "mousemove",
            fn: function fn(event) {
                var button = event.button, clientX = event.clientX, clientY = event.clientY;
                if (button !== primaryButton) return;
                var point = {
                    x: clientX,
                    y: clientY
                };
                var phase = getPhase();
                if (phase.type === "DRAGGING") {
                    event.preventDefault();
                    phase.actions.move(point);
                    return;
                }
                !(phase.type === "PENDING") && invariant(false);
                var pending = phase.point;
                if (!isSloppyClickThresholdExceeded(pending, point)) return;
                event.preventDefault();
                var actions = phase.actions.fluidLift(point);
                setPhase({
                    type: "DRAGGING",
                    actions: actions
                });
            }
        },
        {
            eventName: "mouseup",
            fn: function fn(event) {
                var phase = getPhase();
                if (phase.type !== "DRAGGING") {
                    cancel();
                    return;
                }
                event.preventDefault();
                phase.actions.drop({
                    shouldBlockNextClick: true
                });
                completed();
            }
        },
        {
            eventName: "mousedown",
            fn: function fn(event) {
                if (getPhase().type === "DRAGGING") event.preventDefault();
                cancel();
            }
        },
        {
            eventName: "keydown",
            fn: function fn(event) {
                var phase = getPhase();
                if (phase.type === "PENDING") {
                    cancel();
                    return;
                }
                if (event.keyCode === escape) {
                    event.preventDefault();
                    cancel();
                    return;
                }
                preventStandardKeyEvents(event);
            }
        },
        {
            eventName: "resize",
            fn: cancel
        },
        {
            eventName: "scroll",
            options: {
                passive: true,
                capture: false
            },
            fn: function fn() {
                if (getPhase().type === "PENDING") cancel();
            }
        },
        {
            eventName: "webkitmouseforcedown",
            fn: function fn(event) {
                var phase = getPhase();
                !(phase.type !== "IDLE") && invariant(false);
                if (phase.actions.shouldRespectForcePress()) {
                    cancel();
                    return;
                }
                event.preventDefault();
            }
        },
        {
            eventName: supportedEventName,
            fn: cancel
        }
    ];
}
function useMouseSensor(api) {
    var phaseRef = (0, _react.useRef)(idle$1);
    var unbindEventsRef = (0, _react.useRef)(noop);
    var startCaptureBinding = (0, _useMemoOne.useMemo)(function() {
        return {
            eventName: "mousedown",
            fn: function onMouseDown(event) {
                if (event.defaultPrevented) return;
                if (event.button !== primaryButton) return;
                if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
                var draggableId = api.findClosestDraggableId(event);
                if (!draggableId) return;
                var actions = api.tryGetLock(draggableId, stop, {
                    sourceEvent: event
                });
                if (!actions) return;
                event.preventDefault();
                var point = {
                    x: event.clientX,
                    y: event.clientY
                };
                unbindEventsRef.current();
                startPendingDrag(actions, point);
            }
        };
    }, [
        api
    ]);
    var preventForcePressBinding = (0, _useMemoOne.useMemo)(function() {
        return {
            eventName: "webkitmouseforcewillbegin",
            fn: function fn(event) {
                if (event.defaultPrevented) return;
                var id = api.findClosestDraggableId(event);
                if (!id) return;
                var options = api.findOptionsForDraggable(id);
                if (!options) return;
                if (options.shouldRespectForcePress) return;
                if (!api.canGetLock(id)) return;
                event.preventDefault();
            }
        };
    }, [
        api
    ]);
    var listenForCapture = (0, _useMemoOne.useCallback)(function listenForCapture() {
        var options = {
            passive: false,
            capture: true
        };
        unbindEventsRef.current = bindEvents(window, [
            preventForcePressBinding,
            startCaptureBinding
        ], options);
    }, [
        preventForcePressBinding,
        startCaptureBinding
    ]);
    var stop = (0, _useMemoOne.useCallback)(function() {
        var current = phaseRef.current;
        if (current.type === "IDLE") return;
        phaseRef.current = idle$1;
        unbindEventsRef.current();
        listenForCapture();
    }, [
        listenForCapture
    ]);
    var cancel = (0, _useMemoOne.useCallback)(function() {
        var phase = phaseRef.current;
        stop();
        if (phase.type === "DRAGGING") phase.actions.cancel({
            shouldBlockNextClick: true
        });
        if (phase.type === "PENDING") phase.actions.abort();
    }, [
        stop
    ]);
    var bindCapturingEvents = (0, _useMemoOne.useCallback)(function bindCapturingEvents() {
        var options = {
            capture: true,
            passive: false
        };
        var bindings = getCaptureBindings({
            cancel: cancel,
            completed: stop,
            getPhase: function getPhase() {
                return phaseRef.current;
            },
            setPhase: function setPhase(phase) {
                phaseRef.current = phase;
            }
        });
        unbindEventsRef.current = bindEvents(window, bindings, options);
    }, [
        cancel,
        stop
    ]);
    var startPendingDrag = (0, _useMemoOne.useCallback)(function startPendingDrag(actions, point) {
        !(phaseRef.current.type === "IDLE") && invariant(false);
        phaseRef.current = {
            type: "PENDING",
            point: point,
            actions: actions
        };
        bindCapturingEvents();
    }, [
        bindCapturingEvents
    ]);
    useIsomorphicLayoutEffect(function mount() {
        listenForCapture();
        return function unmount() {
            unbindEventsRef.current();
        };
    }, [
        listenForCapture
    ]);
}
var _scrollJumpKeys;
function noop$1() {}
var scrollJumpKeys = (_scrollJumpKeys = {}, _scrollJumpKeys[pageDown] = true, _scrollJumpKeys[pageUp] = true, _scrollJumpKeys[home] = true, _scrollJumpKeys[end] = true, _scrollJumpKeys);
function getDraggingBindings(actions, stop) {
    function cancel() {
        stop();
        actions.cancel();
    }
    function drop() {
        stop();
        actions.drop();
    }
    return [
        {
            eventName: "keydown",
            fn: function fn(event) {
                if (event.keyCode === escape) {
                    event.preventDefault();
                    cancel();
                    return;
                }
                if (event.keyCode === space) {
                    event.preventDefault();
                    drop();
                    return;
                }
                if (event.keyCode === arrowDown) {
                    event.preventDefault();
                    actions.moveDown();
                    return;
                }
                if (event.keyCode === arrowUp) {
                    event.preventDefault();
                    actions.moveUp();
                    return;
                }
                if (event.keyCode === arrowRight) {
                    event.preventDefault();
                    actions.moveRight();
                    return;
                }
                if (event.keyCode === arrowLeft) {
                    event.preventDefault();
                    actions.moveLeft();
                    return;
                }
                if (scrollJumpKeys[event.keyCode]) {
                    event.preventDefault();
                    return;
                }
                preventStandardKeyEvents(event);
            }
        },
        {
            eventName: "mousedown",
            fn: cancel
        },
        {
            eventName: "mouseup",
            fn: cancel
        },
        {
            eventName: "click",
            fn: cancel
        },
        {
            eventName: "touchstart",
            fn: cancel
        },
        {
            eventName: "resize",
            fn: cancel
        },
        {
            eventName: "wheel",
            fn: cancel,
            options: {
                passive: true
            }
        },
        {
            eventName: supportedEventName,
            fn: cancel
        }
    ];
}
function useKeyboardSensor(api) {
    var unbindEventsRef = (0, _react.useRef)(noop$1);
    var startCaptureBinding = (0, _useMemoOne.useMemo)(function() {
        return {
            eventName: "keydown",
            fn: function onKeyDown(event) {
                if (event.defaultPrevented) return;
                if (event.keyCode !== space) return;
                var draggableId = api.findClosestDraggableId(event);
                if (!draggableId) return;
                var preDrag = api.tryGetLock(draggableId, stop, {
                    sourceEvent: event
                });
                if (!preDrag) return;
                event.preventDefault();
                var isCapturing = true;
                var actions = preDrag.snapLift();
                unbindEventsRef.current();
                function stop() {
                    !isCapturing && invariant(false);
                    isCapturing = false;
                    unbindEventsRef.current();
                    listenForCapture();
                }
                unbindEventsRef.current = bindEvents(window, getDraggingBindings(actions, stop), {
                    capture: true,
                    passive: false
                });
            }
        };
    }, [
        api
    ]);
    var listenForCapture = (0, _useMemoOne.useCallback)(function tryStartCapture() {
        var options = {
            passive: false,
            capture: true
        };
        unbindEventsRef.current = bindEvents(window, [
            startCaptureBinding
        ], options);
    }, [
        startCaptureBinding
    ]);
    useIsomorphicLayoutEffect(function mount() {
        listenForCapture();
        return function unmount() {
            unbindEventsRef.current();
        };
    }, [
        listenForCapture
    ]);
}
var idle$2 = {
    type: "IDLE"
};
var timeForLongPress = 120;
var forcePressThreshold = 0.15;
function getWindowBindings(_ref) {
    var cancel = _ref.cancel, getPhase = _ref.getPhase;
    return [
        {
            eventName: "orientationchange",
            fn: cancel
        },
        {
            eventName: "resize",
            fn: cancel
        },
        {
            eventName: "contextmenu",
            fn: function fn(event) {
                event.preventDefault();
            }
        },
        {
            eventName: "keydown",
            fn: function fn(event) {
                if (getPhase().type !== "DRAGGING") {
                    cancel();
                    return;
                }
                if (event.keyCode === escape) event.preventDefault();
                cancel();
            }
        },
        {
            eventName: supportedEventName,
            fn: cancel
        }
    ];
}
function getHandleBindings(_ref2) {
    var cancel = _ref2.cancel, completed = _ref2.completed, getPhase = _ref2.getPhase;
    return [
        {
            eventName: "touchmove",
            options: {
                capture: false
            },
            fn: function fn(event) {
                var phase = getPhase();
                if (phase.type !== "DRAGGING") {
                    cancel();
                    return;
                }
                phase.hasMoved = true;
                var _event$touches$ = event.touches[0], clientX = _event$touches$.clientX, clientY = _event$touches$.clientY;
                var point = {
                    x: clientX,
                    y: clientY
                };
                event.preventDefault();
                phase.actions.move(point);
            }
        },
        {
            eventName: "touchend",
            fn: function fn(event) {
                var phase = getPhase();
                if (phase.type !== "DRAGGING") {
                    cancel();
                    return;
                }
                event.preventDefault();
                phase.actions.drop({
                    shouldBlockNextClick: true
                });
                completed();
            }
        },
        {
            eventName: "touchcancel",
            fn: function fn(event) {
                if (getPhase().type !== "DRAGGING") {
                    cancel();
                    return;
                }
                event.preventDefault();
                cancel();
            }
        },
        {
            eventName: "touchforcechange",
            fn: function fn(event) {
                var phase = getPhase();
                !(phase.type !== "IDLE") && invariant(false);
                var touch = event.touches[0];
                if (!touch) return;
                var isForcePress = touch.force >= forcePressThreshold;
                if (!isForcePress) return;
                var shouldRespect = phase.actions.shouldRespectForcePress();
                if (phase.type === "PENDING") {
                    if (shouldRespect) cancel();
                    return;
                }
                if (shouldRespect) {
                    if (phase.hasMoved) {
                        event.preventDefault();
                        return;
                    }
                    cancel();
                    return;
                }
                event.preventDefault();
            }
        },
        {
            eventName: supportedEventName,
            fn: cancel
        }
    ];
}
function useMouseSensor$1(api) {
    var phaseRef = (0, _react.useRef)(idle$2);
    var unbindEventsRef = (0, _react.useRef)(noop);
    var getPhase = (0, _useMemoOne.useCallback)(function getPhase() {
        return phaseRef.current;
    }, []);
    var setPhase = (0, _useMemoOne.useCallback)(function setPhase(phase) {
        phaseRef.current = phase;
    }, []);
    var startCaptureBinding = (0, _useMemoOne.useMemo)(function() {
        return {
            eventName: "touchstart",
            fn: function onTouchStart(event) {
                if (event.defaultPrevented) return;
                var draggableId = api.findClosestDraggableId(event);
                if (!draggableId) return;
                var actions = api.tryGetLock(draggableId, stop, {
                    sourceEvent: event
                });
                if (!actions) return;
                var touch = event.touches[0];
                var clientX = touch.clientX, clientY = touch.clientY;
                var point = {
                    x: clientX,
                    y: clientY
                };
                unbindEventsRef.current();
                startPendingDrag(actions, point);
            }
        };
    }, [
        api
    ]);
    var listenForCapture = (0, _useMemoOne.useCallback)(function listenForCapture() {
        var options = {
            capture: true,
            passive: false
        };
        unbindEventsRef.current = bindEvents(window, [
            startCaptureBinding
        ], options);
    }, [
        startCaptureBinding
    ]);
    var stop = (0, _useMemoOne.useCallback)(function() {
        var current = phaseRef.current;
        if (current.type === "IDLE") return;
        if (current.type === "PENDING") clearTimeout(current.longPressTimerId);
        setPhase(idle$2);
        unbindEventsRef.current();
        listenForCapture();
    }, [
        listenForCapture,
        setPhase
    ]);
    var cancel = (0, _useMemoOne.useCallback)(function() {
        var phase = phaseRef.current;
        stop();
        if (phase.type === "DRAGGING") phase.actions.cancel({
            shouldBlockNextClick: true
        });
        if (phase.type === "PENDING") phase.actions.abort();
    }, [
        stop
    ]);
    var bindCapturingEvents = (0, _useMemoOne.useCallback)(function bindCapturingEvents() {
        var options = {
            capture: true,
            passive: false
        };
        var args = {
            cancel: cancel,
            completed: stop,
            getPhase: getPhase
        };
        var unbindTarget = bindEvents(window, getHandleBindings(args), options);
        var unbindWindow = bindEvents(window, getWindowBindings(args), options);
        unbindEventsRef.current = function unbindAll() {
            unbindTarget();
            unbindWindow();
        };
    }, [
        cancel,
        getPhase,
        stop
    ]);
    var startDragging = (0, _useMemoOne.useCallback)(function startDragging() {
        var phase = getPhase();
        !(phase.type === "PENDING") && invariant(false);
        var actions = phase.actions.fluidLift(phase.point);
        setPhase({
            type: "DRAGGING",
            actions: actions,
            hasMoved: false
        });
    }, [
        getPhase,
        setPhase
    ]);
    var startPendingDrag = (0, _useMemoOne.useCallback)(function startPendingDrag(actions, point) {
        !(getPhase().type === "IDLE") && invariant(false);
        var longPressTimerId = setTimeout(startDragging, timeForLongPress);
        setPhase({
            type: "PENDING",
            point: point,
            actions: actions,
            longPressTimerId: longPressTimerId
        });
        bindCapturingEvents();
    }, [
        bindCapturingEvents,
        getPhase,
        setPhase,
        startDragging
    ]);
    useIsomorphicLayoutEffect(function mount() {
        listenForCapture();
        return function unmount() {
            unbindEventsRef.current();
            var phase = getPhase();
            if (phase.type === "PENDING") {
                clearTimeout(phase.longPressTimerId);
                setPhase(idle$2);
            }
        };
    }, [
        getPhase,
        listenForCapture,
        setPhase
    ]);
    useIsomorphicLayoutEffect(function webkitHack() {
        var unbind = bindEvents(window, [
            {
                eventName: "touchmove",
                fn: function fn() {},
                options: {
                    capture: false,
                    passive: false
                }
            }
        ]);
        return unbind;
    }, []);
}
function useValidateSensorHooks(sensorHooks) {
    useDev(function() {
        var previousRef = usePrevious(sensorHooks);
        useDevSetupWarning(function() {
            !(previousRef.current.length === sensorHooks.length) && invariant(false);
        });
    });
}
var interactiveTagNames = {
    input: true,
    button: true,
    textarea: true,
    select: true,
    option: true,
    optgroup: true,
    video: true,
    audio: true
};
function isAnInteractiveElement(parent, current) {
    if (current == null) return false;
    var hasAnInteractiveTag = Boolean(interactiveTagNames[current.tagName.toLowerCase()]);
    if (hasAnInteractiveTag) return true;
    var attribute = current.getAttribute("contenteditable");
    if (attribute === "true" || attribute === "") return true;
    if (current === parent) return false;
    return isAnInteractiveElement(parent, current.parentElement);
}
function isEventInInteractiveElement(draggable, event) {
    var target = event.target;
    if (!isHtmlElement(target)) return false;
    return isAnInteractiveElement(draggable, target);
}
var getBorderBoxCenterPosition = function(el) {
    return (0, _cssBoxModel.getRect)(el.getBoundingClientRect()).center;
};
function isElement(el) {
    return el instanceof getWindowFromEl(el).Element;
}
var supportedMatchesName = function() {
    var base = "matches";
    if (typeof document === "undefined") return base;
    var candidates = [
        base,
        "msMatchesSelector",
        "webkitMatchesSelector"
    ];
    var value = find(candidates, function(name) {
        return name in Element.prototype;
    });
    return value || base;
}();
function closestPonyfill(el, selector) {
    if (el == null) return null;
    if (el[supportedMatchesName](selector)) return el;
    return closestPonyfill(el.parentElement, selector);
}
function closest$1(el, selector) {
    if (el.closest) return el.closest(selector);
    return closestPonyfill(el, selector);
}
function getSelector(contextId) {
    return "[" + dragHandle.contextId + '="' + contextId + '"]';
}
function findClosestDragHandleFromEvent(contextId, event) {
    var target = event.target;
    if (!isElement(target)) return null;
    var selector = getSelector(contextId);
    var handle = closest$1(target, selector);
    if (!handle) return null;
    if (!isHtmlElement(handle)) return null;
    return handle;
}
function tryGetClosestDraggableIdFromEvent(contextId, event) {
    var handle = findClosestDragHandleFromEvent(contextId, event);
    if (!handle) return null;
    return handle.getAttribute(dragHandle.draggableId);
}
function findDraggable(contextId, draggableId) {
    var selector = "[" + draggable.contextId + '="' + contextId + '"]';
    var possible = toArray(document.querySelectorAll(selector));
    var draggable$1 = find(possible, function(el) {
        return el.getAttribute(draggable.id) === draggableId;
    });
    if (!draggable$1) return null;
    if (!isHtmlElement(draggable$1)) return null;
    return draggable$1;
}
function preventDefault(event) {
    event.preventDefault();
}
function _isActive(_ref) {
    var expected = _ref.expected, phase = _ref.phase, isLockActive = _ref.isLockActive, shouldWarn = _ref.shouldWarn;
    if (!isLockActive()) {
        shouldWarn;
        return false;
    }
    if (expected !== phase) {
        shouldWarn;
        return false;
    }
    return true;
}
function canStart(_ref2) {
    var lockAPI = _ref2.lockAPI, store = _ref2.store, registry = _ref2.registry, draggableId = _ref2.draggableId;
    if (lockAPI.isClaimed()) return false;
    var entry = registry.draggable.findById(draggableId);
    if (!entry) return false;
    if (!entry.options.isEnabled) return false;
    if (!canStartDrag(store.getState(), draggableId)) return false;
    return true;
}
function tryStart(_ref3) {
    var lockAPI = _ref3.lockAPI, contextId = _ref3.contextId, store = _ref3.store, registry = _ref3.registry, draggableId = _ref3.draggableId, forceSensorStop = _ref3.forceSensorStop, sourceEvent = _ref3.sourceEvent;
    var shouldStart = canStart({
        lockAPI: lockAPI,
        store: store,
        registry: registry,
        draggableId: draggableId
    });
    if (!shouldStart) return null;
    var entry = registry.draggable.getById(draggableId);
    var el = findDraggable(contextId, entry.descriptor.id);
    if (!el) return null;
    if (sourceEvent && !entry.options.canDragInteractiveElements && isEventInInteractiveElement(el, sourceEvent)) return null;
    var lock = lockAPI.claim(forceSensorStop || noop);
    var phase = "PRE_DRAG";
    function getShouldRespectForcePress() {
        return entry.options.shouldRespectForcePress;
    }
    function isLockActive() {
        return lockAPI.isActive(lock);
    }
    function tryDispatch(expected, getAction) {
        if (_isActive({
            expected: expected,
            phase: phase,
            isLockActive: isLockActive,
            shouldWarn: true
        })) store.dispatch(getAction());
    }
    var tryDispatchWhenDragging = tryDispatch.bind(this, "DRAGGING");
    function lift$1(args) {
        function completed() {
            lockAPI.release();
            phase = "COMPLETED";
        }
        if (phase !== "PRE_DRAG") {
            completed();
            !(phase === "PRE_DRAG") && invariant(false);
        }
        store.dispatch(lift(args.liftActionArgs));
        phase = "DRAGGING";
        function finish(reason, options) {
            if (options === void 0) options = {
                shouldBlockNextClick: false
            };
            args.cleanup();
            if (options.shouldBlockNextClick) {
                var unbind = bindEvents(window, [
                    {
                        eventName: "click",
                        fn: preventDefault,
                        options: {
                            once: true,
                            passive: false,
                            capture: true
                        }
                    }
                ]);
                setTimeout(unbind);
            }
            completed();
            store.dispatch(drop({
                reason: reason
            }));
        }
        return (0, _extendsDefault.default)({
            isActive: function isActive() {
                return _isActive({
                    expected: "DRAGGING",
                    phase: phase,
                    isLockActive: isLockActive,
                    shouldWarn: false
                });
            },
            shouldRespectForcePress: getShouldRespectForcePress,
            drop: function drop(options) {
                return finish("DROP", options);
            },
            cancel: function cancel(options) {
                return finish("CANCEL", options);
            }
        }, args.actions);
    }
    function fluidLift(clientSelection) {
        var move$1 = (0, _rafSchdDefault.default)(function(client) {
            tryDispatchWhenDragging(function() {
                return move({
                    client: client
                });
            });
        });
        var api = lift$1({
            liftActionArgs: {
                id: draggableId,
                clientSelection: clientSelection,
                movementMode: "FLUID"
            },
            cleanup: function cleanup() {
                return move$1.cancel();
            },
            actions: {
                move: move$1
            }
        });
        return (0, _extendsDefault.default)({}, api, {
            move: move$1
        });
    }
    function snapLift() {
        var actions = {
            moveUp: function moveUp$1() {
                return tryDispatchWhenDragging(moveUp);
            },
            moveRight: function moveRight$1() {
                return tryDispatchWhenDragging(moveRight);
            },
            moveDown: function moveDown$1() {
                return tryDispatchWhenDragging(moveDown);
            },
            moveLeft: function moveLeft$1() {
                return tryDispatchWhenDragging(moveLeft);
            }
        };
        return lift$1({
            liftActionArgs: {
                id: draggableId,
                clientSelection: getBorderBoxCenterPosition(el),
                movementMode: "SNAP"
            },
            cleanup: noop,
            actions: actions
        });
    }
    function abortPreDrag() {
        var shouldRelease = _isActive({
            expected: "PRE_DRAG",
            phase: phase,
            isLockActive: isLockActive,
            shouldWarn: true
        });
        if (shouldRelease) lockAPI.release();
    }
    var preDrag = {
        isActive: function isActive() {
            return _isActive({
                expected: "PRE_DRAG",
                phase: phase,
                isLockActive: isLockActive,
                shouldWarn: false
            });
        },
        shouldRespectForcePress: getShouldRespectForcePress,
        fluidLift: fluidLift,
        snapLift: snapLift,
        abort: abortPreDrag
    };
    return preDrag;
}
var defaultSensors = [
    useMouseSensor,
    useKeyboardSensor,
    useMouseSensor$1
];
function useSensorMarshal(_ref4) {
    var contextId = _ref4.contextId, store = _ref4.store, registry = _ref4.registry, customSensors = _ref4.customSensors, enableDefaultSensors = _ref4.enableDefaultSensors;
    var useSensors = [].concat(enableDefaultSensors ? defaultSensors : [], customSensors || []);
    var lockAPI = (0, _react.useState)(function() {
        return create();
    })[0];
    var tryAbandonLock = (0, _useMemoOne.useCallback)(function tryAbandonLock(previous, current) {
        if (previous.isDragging && !current.isDragging) lockAPI.tryAbandon();
    }, [
        lockAPI
    ]);
    useIsomorphicLayoutEffect(function listenToStore() {
        var previous = store.getState();
        var unsubscribe = store.subscribe(function() {
            var current = store.getState();
            tryAbandonLock(previous, current);
            previous = current;
        });
        return unsubscribe;
    }, [
        lockAPI,
        store,
        tryAbandonLock
    ]);
    useIsomorphicLayoutEffect(function() {
        return lockAPI.tryAbandon;
    }, [
        lockAPI.tryAbandon
    ]);
    var canGetLock = (0, _useMemoOne.useCallback)(function(draggableId) {
        return canStart({
            lockAPI: lockAPI,
            registry: registry,
            store: store,
            draggableId: draggableId
        });
    }, [
        lockAPI,
        registry,
        store
    ]);
    var tryGetLock = (0, _useMemoOne.useCallback)(function(draggableId, forceStop, options) {
        return tryStart({
            lockAPI: lockAPI,
            registry: registry,
            contextId: contextId,
            store: store,
            draggableId: draggableId,
            forceSensorStop: forceStop,
            sourceEvent: options && options.sourceEvent ? options.sourceEvent : null
        });
    }, [
        contextId,
        lockAPI,
        registry,
        store
    ]);
    var findClosestDraggableId = (0, _useMemoOne.useCallback)(function(event) {
        return tryGetClosestDraggableIdFromEvent(contextId, event);
    }, [
        contextId
    ]);
    var findOptionsForDraggable = (0, _useMemoOne.useCallback)(function(id) {
        var entry = registry.draggable.findById(id);
        return entry ? entry.options : null;
    }, [
        registry.draggable
    ]);
    var tryReleaseLock = (0, _useMemoOne.useCallback)(lockAPI.tryAbandon, [
        lockAPI
    ]);
    var isLockClaimed = (0, _useMemoOne.useCallback)(lockAPI.isClaimed, [
        lockAPI
    ]);
    var api = (0, _useMemoOne.useMemo)(function() {
        return {
            canGetLock: canGetLock,
            tryGetLock: tryGetLock,
            findClosestDraggableId: findClosestDraggableId,
            findOptionsForDraggable: findOptionsForDraggable,
            tryReleaseLock: tryReleaseLock,
            isLockClaimed: isLockClaimed
        };
    }, [
        canGetLock,
        tryGetLock,
        findClosestDraggableId,
        findOptionsForDraggable,
        tryReleaseLock,
        isLockClaimed
    ]);
    useValidateSensorHooks(useSensors);
    for(var i = 0; i < useSensors.length; i++)useSensors[i](api);
}
var createResponders = function createResponders(props) {
    return {
        onBeforeCapture: props.onBeforeCapture,
        onBeforeDragStart: props.onBeforeDragStart,
        onDragStart: props.onDragStart,
        onDragEnd: props.onDragEnd,
        onDragUpdate: props.onDragUpdate
    };
};
function getStore(lazyRef) {
    !lazyRef.current && invariant(false);
    return lazyRef.current;
}
function App(props) {
    var contextId = props.contextId, setCallbacks = props.setCallbacks, sensors = props.sensors, nonce = props.nonce, liftInstruction = props.liftInstruction;
    var lazyStoreRef = (0, _react.useRef)(null);
    useStartupValidation();
    var lastPropsRef = usePrevious(props);
    var getResponders = (0, _useMemoOne.useCallback)(function() {
        return createResponders(lastPropsRef.current);
    }, [
        lastPropsRef
    ]);
    var announce = useAnnouncer(contextId);
    var liftInstructionId = useLiftInstruction(contextId, liftInstruction);
    var styleMarshal = useStyleMarshal(contextId, nonce);
    var lazyDispatch = (0, _useMemoOne.useCallback)(function(action) {
        getStore(lazyStoreRef).dispatch(action);
    }, []);
    var marshalCallbacks = (0, _useMemoOne.useMemo)(function() {
        return (0, _redux.bindActionCreators)({
            publishWhileDragging: publishWhileDragging,
            updateDroppableScroll: updateDroppableScroll,
            updateDroppableIsEnabled: updateDroppableIsEnabled,
            updateDroppableIsCombineEnabled: updateDroppableIsCombineEnabled,
            collectionStarting: collectionStarting
        }, lazyDispatch);
    }, [
        lazyDispatch
    ]);
    var registry = useRegistry();
    var dimensionMarshal = (0, _useMemoOne.useMemo)(function() {
        return createDimensionMarshal(registry, marshalCallbacks);
    }, [
        registry,
        marshalCallbacks
    ]);
    var autoScroller = (0, _useMemoOne.useMemo)(function() {
        return createAutoScroller((0, _extendsDefault.default)({
            scrollWindow: scrollWindow,
            scrollDroppable: dimensionMarshal.scrollDroppable
        }, (0, _redux.bindActionCreators)({
            move: move
        }, lazyDispatch)));
    }, [
        dimensionMarshal.scrollDroppable,
        lazyDispatch
    ]);
    var focusMarshal = useFocusMarshal(contextId);
    var store = (0, _useMemoOne.useMemo)(function() {
        return createStore({
            announce: announce,
            autoScroller: autoScroller,
            dimensionMarshal: dimensionMarshal,
            focusMarshal: focusMarshal,
            getResponders: getResponders,
            styleMarshal: styleMarshal
        });
    }, [
        announce,
        autoScroller,
        dimensionMarshal,
        focusMarshal,
        getResponders,
        styleMarshal
    ]);
    lazyStoreRef.current = store;
    var tryResetStore = (0, _useMemoOne.useCallback)(function() {
        var current = getStore(lazyStoreRef);
        var state = current.getState();
        if (state.phase !== "IDLE") current.dispatch(flush());
    }, []);
    var isDragging = (0, _useMemoOne.useCallback)(function() {
        var state = getStore(lazyStoreRef).getState();
        return state.isDragging || state.phase === "DROP_ANIMATING";
    }, []);
    var appCallbacks = (0, _useMemoOne.useMemo)(function() {
        return {
            isDragging: isDragging,
            tryAbort: tryResetStore
        };
    }, [
        isDragging,
        tryResetStore
    ]);
    setCallbacks(appCallbacks);
    var getCanLift = (0, _useMemoOne.useCallback)(function(id) {
        return canStartDrag(getStore(lazyStoreRef).getState(), id);
    }, []);
    var getIsMovementAllowed = (0, _useMemoOne.useCallback)(function() {
        return isMovementAllowed(getStore(lazyStoreRef).getState());
    }, []);
    var appContext = (0, _useMemoOne.useMemo)(function() {
        return {
            marshal: dimensionMarshal,
            focus: focusMarshal,
            contextId: contextId,
            canLift: getCanLift,
            isMovementAllowed: getIsMovementAllowed,
            liftInstructionId: liftInstructionId,
            registry: registry
        };
    }, [
        contextId,
        dimensionMarshal,
        focusMarshal,
        getCanLift,
        getIsMovementAllowed,
        liftInstructionId,
        registry
    ]);
    useSensorMarshal({
        contextId: contextId,
        store: store,
        registry: registry,
        customSensors: sensors,
        enableDefaultSensors: props.enableDefaultSensors !== false
    });
    (0, _react.useEffect)(function() {
        return tryResetStore;
    }, [
        tryResetStore
    ]);
    return (0, _reactDefault.default).createElement(AppContext.Provider, {
        value: appContext
    }, (0, _reactDefault.default).createElement((0, _reactRedux.Provider), {
        context: StoreContext,
        store: store
    }, props.children));
}
var instanceCount = 0;
function resetServerContext() {
    instanceCount = 0;
}
function DragDropContext(props) {
    var contextId = (0, _useMemoOne.useMemo)(function() {
        return "" + instanceCount++;
    }, []);
    var liftInstruction = props.liftInstruction || preset.liftInstruction;
    return (0, _reactDefault.default).createElement(ErrorBoundary, null, function(setCallbacks) {
        return (0, _reactDefault.default).createElement(App, {
            nonce: props.nonce,
            contextId: contextId,
            setCallbacks: setCallbacks,
            liftInstruction: liftInstruction,
            enableDefaultSensors: props.enableDefaultSensors,
            sensors: props.sensors,
            onBeforeCapture: props.onBeforeCapture,
            onBeforeDragStart: props.onBeforeDragStart,
            onDragStart: props.onDragStart,
            onDragUpdate: props.onDragUpdate,
            onDragEnd: props.onDragEnd
        }, props.children);
    });
}
var isEqual$1 = function isEqual(base) {
    return function(value) {
        return base === value;
    };
};
var isScroll = isEqual$1("scroll");
var isAuto = isEqual$1("auto");
var isVisible$1 = isEqual$1("visible");
var isEither = function isEither(overflow, fn) {
    return fn(overflow.overflowX) || fn(overflow.overflowY);
};
var isBoth = function isBoth(overflow, fn) {
    return fn(overflow.overflowX) && fn(overflow.overflowY);
};
var isElementScrollable = function isElementScrollable(el) {
    var style = window.getComputedStyle(el);
    var overflow = {
        overflowX: style.overflowX,
        overflowY: style.overflowY
    };
    return isEither(overflow, isScroll) || isEither(overflow, isAuto);
};
var isBodyScrollable = function isBodyScrollable() {
    var body, html, htmlStyle, htmlOverflow;
    return false;
};
var getClosestScrollable = function getClosestScrollable(el) {
    if (el == null) return null;
    if (el === document.body) return isBodyScrollable() ? el : null;
    if (el === document.documentElement) return null;
    if (!isElementScrollable(el)) return getClosestScrollable(el.parentElement);
    return el;
};
var checkForNestedScrollContainers = function(scrollable) {
    if (!scrollable) return;
    var anotherScrollParent = getClosestScrollable(scrollable.parentElement);
    if (!anotherScrollParent) return;
};
var getScroll$1 = function(el) {
    return {
        x: el.scrollLeft,
        y: el.scrollTop
    };
};
var getIsFixed = function getIsFixed(el) {
    if (!el) return false;
    var style = window.getComputedStyle(el);
    if (style.position === "fixed") return true;
    return getIsFixed(el.parentElement);
};
var getEnv = function(start) {
    var closestScrollable = getClosestScrollable(start);
    var isFixedOnPage = getIsFixed(start);
    return {
        closestScrollable: closestScrollable,
        isFixedOnPage: isFixedOnPage
    };
};
var getDroppableDimension = function(_ref) {
    var descriptor = _ref.descriptor, isEnabled = _ref.isEnabled, isCombineEnabled = _ref.isCombineEnabled, isFixedOnPage = _ref.isFixedOnPage, direction = _ref.direction, client = _ref.client, page = _ref.page, closest = _ref.closest;
    var frame = function() {
        if (!closest) return null;
        var scrollSize = closest.scrollSize, frameClient = closest.client;
        var maxScroll = getMaxScroll({
            scrollHeight: scrollSize.scrollHeight,
            scrollWidth: scrollSize.scrollWidth,
            height: frameClient.paddingBox.height,
            width: frameClient.paddingBox.width
        });
        return {
            pageMarginBox: closest.page.marginBox,
            frameClient: frameClient,
            scrollSize: scrollSize,
            shouldClipSubject: closest.shouldClipSubject,
            scroll: {
                initial: closest.scroll,
                current: closest.scroll,
                max: maxScroll,
                diff: {
                    value: origin,
                    displacement: origin
                }
            }
        };
    }();
    var axis = direction === "vertical" ? vertical : horizontal;
    var subject = getSubject({
        page: page,
        withPlaceholder: null,
        axis: axis,
        frame: frame
    });
    var dimension = {
        descriptor: descriptor,
        isCombineEnabled: isCombineEnabled,
        isFixedOnPage: isFixedOnPage,
        axis: axis,
        isEnabled: isEnabled,
        client: client,
        page: page,
        frame: frame,
        subject: subject
    };
    return dimension;
};
var getClient = function getClient(targetRef, closestScrollable) {
    var base = (0, _cssBoxModel.getBox)(targetRef);
    if (!closestScrollable) return base;
    if (targetRef !== closestScrollable) return base;
    var top = base.paddingBox.top - closestScrollable.scrollTop;
    var left = base.paddingBox.left - closestScrollable.scrollLeft;
    var bottom = top + closestScrollable.scrollHeight;
    var right = left + closestScrollable.scrollWidth;
    var paddingBox = {
        top: top,
        right: right,
        bottom: bottom,
        left: left
    };
    var borderBox = (0, _cssBoxModel.expand)(paddingBox, base.border);
    var client = (0, _cssBoxModel.createBox)({
        borderBox: borderBox,
        margin: base.margin,
        border: base.border,
        padding: base.padding
    });
    return client;
};
var getDimension = function(_ref) {
    var ref = _ref.ref, descriptor = _ref.descriptor, env = _ref.env, windowScroll = _ref.windowScroll, direction = _ref.direction, isDropDisabled = _ref.isDropDisabled, isCombineEnabled = _ref.isCombineEnabled, shouldClipSubject = _ref.shouldClipSubject;
    var closestScrollable = env.closestScrollable;
    var client = getClient(ref, closestScrollable);
    var page = (0, _cssBoxModel.withScroll)(client, windowScroll);
    var closest = function() {
        if (!closestScrollable) return null;
        var frameClient = (0, _cssBoxModel.getBox)(closestScrollable);
        var scrollSize = {
            scrollHeight: closestScrollable.scrollHeight,
            scrollWidth: closestScrollable.scrollWidth
        };
        return {
            client: frameClient,
            page: (0, _cssBoxModel.withScroll)(frameClient, windowScroll),
            scroll: getScroll$1(closestScrollable),
            scrollSize: scrollSize,
            shouldClipSubject: shouldClipSubject
        };
    }();
    var dimension = getDroppableDimension({
        descriptor: descriptor,
        isEnabled: !isDropDisabled,
        isCombineEnabled: isCombineEnabled,
        isFixedOnPage: env.isFixedOnPage,
        direction: direction,
        client: client,
        page: page,
        closest: closest
    });
    return dimension;
};
var immediate = {
    passive: false
};
var delayed = {
    passive: true
};
var getListenerOptions = function(options) {
    return options.shouldPublishImmediately ? immediate : delayed;
};
function useRequiredContext(Context) {
    var result = (0, _react.useContext)(Context);
    !result && invariant(false);
    return result;
}
var count = 0;
function useUniqueId(prefix) {
    var countRef = (0, _react.useRef)(count++);
    return prefix + "::" + countRef.current;
}
var getClosestScrollableFromDrag = function getClosestScrollableFromDrag(dragging) {
    return dragging && dragging.env.closestScrollable || null;
};
function useDroppablePublisher(args) {
    var whileDraggingRef = (0, _react.useRef)(null);
    var appContext = useRequiredContext(AppContext);
    var uniqueId = useUniqueId("droppable");
    var registry = appContext.registry, marshal = appContext.marshal;
    var previousRef = usePrevious(args);
    var descriptor = (0, _useMemoOne.useMemo)(function() {
        return {
            id: args.droppableId,
            type: args.type,
            mode: args.mode
        };
    }, [
        args.droppableId,
        args.mode,
        args.type
    ]);
    var publishedDescriptorRef = (0, _react.useRef)(descriptor);
    var memoizedUpdateScroll = (0, _useMemoOne.useMemo)(function() {
        return (0, _memoizeOneDefault.default)(function(x, y) {
            !whileDraggingRef.current && invariant(false);
            var scroll = {
                x: x,
                y: y
            };
            marshal.updateDroppableScroll(descriptor.id, scroll);
        });
    }, [
        descriptor.id,
        marshal
    ]);
    var getClosestScroll = (0, _useMemoOne.useCallback)(function() {
        var dragging = whileDraggingRef.current;
        if (!dragging || !dragging.env.closestScrollable) return origin;
        return getScroll$1(dragging.env.closestScrollable);
    }, []);
    var updateScroll = (0, _useMemoOne.useCallback)(function() {
        var scroll = getClosestScroll();
        memoizedUpdateScroll(scroll.x, scroll.y);
    }, [
        getClosestScroll,
        memoizedUpdateScroll
    ]);
    var scheduleScrollUpdate = (0, _useMemoOne.useMemo)(function() {
        return (0, _rafSchdDefault.default)(updateScroll);
    }, [
        updateScroll
    ]);
    var onClosestScroll = (0, _useMemoOne.useCallback)(function() {
        var dragging = whileDraggingRef.current;
        var closest = getClosestScrollableFromDrag(dragging);
        !(dragging && closest) && invariant(false);
        var options = dragging.scrollOptions;
        if (options.shouldPublishImmediately) {
            updateScroll();
            return;
        }
        scheduleScrollUpdate();
    }, [
        scheduleScrollUpdate,
        updateScroll
    ]);
    var getDimensionAndWatchScroll = (0, _useMemoOne.useCallback)(function(windowScroll, options) {
        !!whileDraggingRef.current && invariant(false);
        var previous = previousRef.current;
        var ref = previous.getDroppableRef();
        !ref && invariant(false);
        var env = getEnv(ref);
        var dragging = {
            ref: ref,
            descriptor: descriptor,
            env: env,
            scrollOptions: options
        };
        whileDraggingRef.current = dragging;
        var dimension = getDimension({
            ref: ref,
            descriptor: descriptor,
            env: env,
            windowScroll: windowScroll,
            direction: previous.direction,
            isDropDisabled: previous.isDropDisabled,
            isCombineEnabled: previous.isCombineEnabled,
            shouldClipSubject: !previous.ignoreContainerClipping
        });
        var scrollable = env.closestScrollable;
        if (scrollable) {
            scrollable.setAttribute(scrollContainer.contextId, appContext.contextId);
            scrollable.addEventListener("scroll", onClosestScroll, getListenerOptions(dragging.scrollOptions));
        }
        return dimension;
    }, [
        appContext.contextId,
        descriptor,
        onClosestScroll,
        previousRef
    ]);
    var getScrollWhileDragging = (0, _useMemoOne.useCallback)(function() {
        var dragging = whileDraggingRef.current;
        var closest = getClosestScrollableFromDrag(dragging);
        !(dragging && closest) && invariant(false);
        return getScroll$1(closest);
    }, []);
    var dragStopped = (0, _useMemoOne.useCallback)(function() {
        var dragging = whileDraggingRef.current;
        !dragging && invariant(false);
        var closest = getClosestScrollableFromDrag(dragging);
        whileDraggingRef.current = null;
        if (!closest) return;
        scheduleScrollUpdate.cancel();
        closest.removeAttribute(scrollContainer.contextId);
        closest.removeEventListener("scroll", onClosestScroll, getListenerOptions(dragging.scrollOptions));
    }, [
        onClosestScroll,
        scheduleScrollUpdate
    ]);
    var scroll = (0, _useMemoOne.useCallback)(function(change) {
        var dragging = whileDraggingRef.current;
        !dragging && invariant(false);
        var closest = getClosestScrollableFromDrag(dragging);
        !closest && invariant(false);
        closest.scrollTop += change.y;
        closest.scrollLeft += change.x;
    }, []);
    var callbacks = (0, _useMemoOne.useMemo)(function() {
        return {
            getDimensionAndWatchScroll: getDimensionAndWatchScroll,
            getScrollWhileDragging: getScrollWhileDragging,
            dragStopped: dragStopped,
            scroll: scroll
        };
    }, [
        dragStopped,
        getDimensionAndWatchScroll,
        getScrollWhileDragging,
        scroll
    ]);
    var entry = (0, _useMemoOne.useMemo)(function() {
        return {
            uniqueId: uniqueId,
            descriptor: descriptor,
            callbacks: callbacks
        };
    }, [
        callbacks,
        descriptor,
        uniqueId
    ]);
    useIsomorphicLayoutEffect(function() {
        publishedDescriptorRef.current = entry.descriptor;
        registry.droppable.register(entry);
        return function() {
            if (whileDraggingRef.current) dragStopped();
            registry.droppable.unregister(entry);
        };
    }, [
        callbacks,
        descriptor,
        dragStopped,
        entry,
        marshal,
        registry.droppable
    ]);
    useIsomorphicLayoutEffect(function() {
        if (!whileDraggingRef.current) return;
        marshal.updateDroppableIsEnabled(publishedDescriptorRef.current.id, !args.isDropDisabled);
    }, [
        args.isDropDisabled,
        marshal
    ]);
    useIsomorphicLayoutEffect(function() {
        if (!whileDraggingRef.current) return;
        marshal.updateDroppableIsCombineEnabled(publishedDescriptorRef.current.id, args.isCombineEnabled);
    }, [
        args.isCombineEnabled,
        marshal
    ]);
}
function noop$2() {}
var empty = {
    width: 0,
    height: 0,
    margin: noSpacing
};
var getSize = function getSize(_ref) {
    var isAnimatingOpenOnMount = _ref.isAnimatingOpenOnMount, placeholder = _ref.placeholder, animate = _ref.animate;
    if (isAnimatingOpenOnMount) return empty;
    if (animate === "close") return empty;
    return {
        height: placeholder.client.borderBox.height,
        width: placeholder.client.borderBox.width,
        margin: placeholder.client.margin
    };
};
var getStyle = function getStyle(_ref2) {
    var isAnimatingOpenOnMount = _ref2.isAnimatingOpenOnMount, placeholder = _ref2.placeholder, animate = _ref2.animate;
    var size = getSize({
        isAnimatingOpenOnMount: isAnimatingOpenOnMount,
        placeholder: placeholder,
        animate: animate
    });
    return {
        display: placeholder.display,
        boxSizing: "border-box",
        width: size.width,
        height: size.height,
        marginTop: size.margin.top,
        marginRight: size.margin.right,
        marginBottom: size.margin.bottom,
        marginLeft: size.margin.left,
        flexShrink: "0",
        flexGrow: "0",
        pointerEvents: "none",
        transition: animate !== "none" ? transitions.placeholder : null
    };
};
function Placeholder(props) {
    var animateOpenTimerRef = (0, _react.useRef)(null);
    var tryClearAnimateOpenTimer = (0, _useMemoOne.useCallback)(function() {
        if (!animateOpenTimerRef.current) return;
        clearTimeout(animateOpenTimerRef.current);
        animateOpenTimerRef.current = null;
    }, []);
    var animate = props.animate, onTransitionEnd = props.onTransitionEnd, onClose = props.onClose, contextId = props.contextId;
    var _useState = (0, _react.useState)(props.animate === "open"), isAnimatingOpenOnMount = _useState[0], setIsAnimatingOpenOnMount = _useState[1];
    (0, _react.useEffect)(function() {
        if (!isAnimatingOpenOnMount) return noop$2;
        if (animate !== "open") {
            tryClearAnimateOpenTimer();
            setIsAnimatingOpenOnMount(false);
            return noop$2;
        }
        if (animateOpenTimerRef.current) return noop$2;
        animateOpenTimerRef.current = setTimeout(function() {
            animateOpenTimerRef.current = null;
            setIsAnimatingOpenOnMount(false);
        });
        return tryClearAnimateOpenTimer;
    }, [
        animate,
        isAnimatingOpenOnMount,
        tryClearAnimateOpenTimer
    ]);
    var onSizeChangeEnd = (0, _useMemoOne.useCallback)(function(event) {
        if (event.propertyName !== "height") return;
        onTransitionEnd();
        if (animate === "close") onClose();
    }, [
        animate,
        onClose,
        onTransitionEnd
    ]);
    var style = getStyle({
        isAnimatingOpenOnMount: isAnimatingOpenOnMount,
        animate: props.animate,
        placeholder: props.placeholder
    });
    return (0, _reactDefault.default).createElement(props.placeholder.tagName, {
        style: style,
        "data-rbd-placeholder-context-id": contextId,
        onTransitionEnd: onSizeChangeEnd,
        ref: props.innerRef
    });
}
var Placeholder$1 = (0, _reactDefault.default).memo(Placeholder);
var DroppableContext = (0, _reactDefault.default).createContext(null);
function checkIsValidInnerRef(el) {
    !(el && isHtmlElement(el)) && invariant(false);
}
function isBoolean(value) {
    return typeof value === "boolean";
}
function runChecks(args, checks) {
    checks.forEach(function(check) {
        return check(args);
    });
}
var shared = [
    function required(_ref) {
        var props = _ref.props;
        !props.droppableId && invariant(false);
        !(typeof props.droppableId === "string") && invariant(false);
    },
    function _boolean(_ref2) {
        var props = _ref2.props;
        !isBoolean(props.isDropDisabled) && invariant(false);
        !isBoolean(props.isCombineEnabled) && invariant(false);
        !isBoolean(props.ignoreContainerClipping) && invariant(false);
    },
    function ref(_ref3) {
        var getDroppableRef = _ref3.getDroppableRef;
        checkIsValidInnerRef(getDroppableRef());
    }
];
var standard = [
    function placeholder(_ref4) {
        var props = _ref4.props, getPlaceholderRef = _ref4.getPlaceholderRef;
        if (!props.placeholder) return;
        var ref = getPlaceholderRef();
        if (ref) return;
    }
];
var virtual = [
    function hasClone(_ref5) {
        var props = _ref5.props;
        !props.renderClone && invariant(false);
    },
    function hasNoPlaceholder(_ref6) {
        var getPlaceholderRef = _ref6.getPlaceholderRef;
        !!getPlaceholderRef() && invariant(false);
    }
];
function useValidation(args) {
    useDevSetupWarning(function() {
        runChecks(args, shared);
        if (args.props.mode === "standard") runChecks(args, standard);
        if (args.props.mode === "virtual") runChecks(args, virtual);
    });
}
var AnimateInOut = function(_React$PureComponent) {
    (0, _inheritsLooseDefault.default)(AnimateInOut, _React$PureComponent);
    function AnimateInOut() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$PureComponent.call.apply(_React$PureComponent, [
            this
        ].concat(args)) || this;
        _this.state = {
            isVisible: Boolean(_this.props.on),
            data: _this.props.on,
            animate: _this.props.shouldAnimate && _this.props.on ? "open" : "none"
        };
        _this.onClose = function() {
            if (_this.state.animate !== "close") return;
            _this.setState({
                isVisible: false
            });
        };
        return _this;
    }
    AnimateInOut.getDerivedStateFromProps = function getDerivedStateFromProps(props, state) {
        if (!props.shouldAnimate) return {
            isVisible: Boolean(props.on),
            data: props.on,
            animate: "none"
        };
        if (props.on) return {
            isVisible: true,
            data: props.on,
            animate: "open"
        };
        if (state.isVisible) return {
            isVisible: true,
            data: state.data,
            animate: "close"
        };
        return {
            isVisible: false,
            animate: "close",
            data: null
        };
    };
    var _proto = AnimateInOut.prototype;
    _proto.render = function render() {
        if (!this.state.isVisible) return null;
        var provided = {
            onClose: this.onClose,
            data: this.state.data,
            animate: this.state.animate
        };
        return this.props.children(provided);
    };
    return AnimateInOut;
}((0, _reactDefault.default).PureComponent);
var zIndexOptions = {
    dragging: 5000,
    dropAnimating: 4500
};
var getDraggingTransition = function getDraggingTransition(shouldAnimateDragMovement, dropping) {
    if (dropping) return transitions.drop(dropping.duration);
    if (shouldAnimateDragMovement) return transitions.snap;
    return transitions.fluid;
};
var getDraggingOpacity = function getDraggingOpacity(isCombining, isDropAnimating) {
    if (!isCombining) return null;
    return isDropAnimating ? combine.opacity.drop : combine.opacity.combining;
};
var getShouldDraggingAnimate = function getShouldDraggingAnimate(dragging) {
    if (dragging.forceShouldAnimate != null) return dragging.forceShouldAnimate;
    return dragging.mode === "SNAP";
};
function getDraggingStyle(dragging) {
    var dimension = dragging.dimension;
    var box = dimension.client;
    var offset = dragging.offset, combineWith = dragging.combineWith, dropping = dragging.dropping;
    var isCombining = Boolean(combineWith);
    var shouldAnimate = getShouldDraggingAnimate(dragging);
    var isDropAnimating = Boolean(dropping);
    var transform = isDropAnimating ? transforms.drop(offset, isCombining) : transforms.moveTo(offset);
    var style = {
        position: "fixed",
        top: box.marginBox.top,
        left: box.marginBox.left,
        boxSizing: "border-box",
        width: box.borderBox.width,
        height: box.borderBox.height,
        transition: getDraggingTransition(shouldAnimate, dropping),
        transform: transform,
        opacity: getDraggingOpacity(isCombining, isDropAnimating),
        zIndex: isDropAnimating ? zIndexOptions.dropAnimating : zIndexOptions.dragging,
        pointerEvents: "none"
    };
    return style;
}
function getSecondaryStyle(secondary) {
    return {
        transform: transforms.moveTo(secondary.offset),
        transition: secondary.shouldAnimateDisplacement ? null : "none"
    };
}
function getStyle$1(mapped) {
    return mapped.type === "DRAGGING" ? getDraggingStyle(mapped) : getSecondaryStyle(mapped);
}
function getDimension$1(descriptor, el, windowScroll) {
    if (windowScroll === void 0) windowScroll = origin;
    var computedStyles = window.getComputedStyle(el);
    var borderBox = el.getBoundingClientRect();
    var client = (0, _cssBoxModel.calculateBox)(borderBox, computedStyles);
    var page = (0, _cssBoxModel.withScroll)(client, windowScroll);
    var placeholder = {
        client: client,
        tagName: el.tagName.toLowerCase(),
        display: computedStyles.display
    };
    var displaceBy = {
        x: client.marginBox.width,
        y: client.marginBox.height
    };
    var dimension = {
        descriptor: descriptor,
        placeholder: placeholder,
        displaceBy: displaceBy,
        client: client,
        page: page
    };
    return dimension;
}
function useDraggablePublisher(args) {
    var uniqueId = useUniqueId("draggable");
    var descriptor = args.descriptor, registry = args.registry, getDraggableRef = args.getDraggableRef, canDragInteractiveElements = args.canDragInteractiveElements, shouldRespectForcePress = args.shouldRespectForcePress, isEnabled = args.isEnabled;
    var options = (0, _useMemoOne.useMemo)(function() {
        return {
            canDragInteractiveElements: canDragInteractiveElements,
            shouldRespectForcePress: shouldRespectForcePress,
            isEnabled: isEnabled
        };
    }, [
        canDragInteractiveElements,
        isEnabled,
        shouldRespectForcePress
    ]);
    var getDimension = (0, _useMemoOne.useCallback)(function(windowScroll) {
        var el = getDraggableRef();
        !el && invariant(false);
        return getDimension$1(descriptor, el, windowScroll);
    }, [
        descriptor,
        getDraggableRef
    ]);
    var entry = (0, _useMemoOne.useMemo)(function() {
        return {
            uniqueId: uniqueId,
            descriptor: descriptor,
            options: options,
            getDimension: getDimension
        };
    }, [
        descriptor,
        getDimension,
        options,
        uniqueId
    ]);
    var publishedRef = (0, _react.useRef)(entry);
    var isFirstPublishRef = (0, _react.useRef)(true);
    useIsomorphicLayoutEffect(function() {
        registry.draggable.register(publishedRef.current);
        return function() {
            return registry.draggable.unregister(publishedRef.current);
        };
    }, [
        registry.draggable
    ]);
    useIsomorphicLayoutEffect(function() {
        if (isFirstPublishRef.current) {
            isFirstPublishRef.current = false;
            return;
        }
        var last = publishedRef.current;
        publishedRef.current = entry;
        registry.draggable.update(entry, last);
    }, [
        entry,
        registry.draggable
    ]);
}
function useValidation$1(props, contextId, getRef) {
    useDevSetupWarning(function() {
        function prefix(id) {
            return "Draggable[id: " + id + "]: ";
        }
        var id = props.draggableId;
        !id && invariant(false);
        !(typeof id === "string") && invariant(false);
        !(0, _isIntegerDefault.default)(props.index) && invariant(false);
        if (props.mapped.type === "DRAGGING") return;
        checkIsValidInnerRef(getRef());
        if (props.isEnabled) !findDragHandle(contextId, id) && invariant(false);
    });
}
function useClonePropValidation(isClone) {
    useDev(function() {
        var initialRef = (0, _react.useRef)(isClone);
        useDevSetupWarning(function() {
            !(isClone === initialRef.current) && invariant(false);
        }, [
            isClone
        ]);
    });
}
function preventHtml5Dnd(event) {
    event.preventDefault();
}
function Draggable(props) {
    var ref = (0, _react.useRef)(null);
    var setRef = (0, _useMemoOne.useCallback)(function(el) {
        ref.current = el;
    }, []);
    var getRef = (0, _useMemoOne.useCallback)(function() {
        return ref.current;
    }, []);
    var _useRequiredContext = useRequiredContext(AppContext), contextId = _useRequiredContext.contextId, liftInstructionId = _useRequiredContext.liftInstructionId, registry = _useRequiredContext.registry;
    var _useRequiredContext2 = useRequiredContext(DroppableContext), type = _useRequiredContext2.type, droppableId = _useRequiredContext2.droppableId;
    var descriptor = (0, _useMemoOne.useMemo)(function() {
        return {
            id: props.draggableId,
            index: props.index,
            type: type,
            droppableId: droppableId
        };
    }, [
        props.draggableId,
        props.index,
        type,
        droppableId
    ]);
    var children = props.children, draggableId = props.draggableId, isEnabled = props.isEnabled, shouldRespectForcePress = props.shouldRespectForcePress, canDragInteractiveElements = props.canDragInteractiveElements, isClone = props.isClone, mapped = props.mapped, dropAnimationFinishedAction = props.dropAnimationFinished;
    useValidation$1(props, contextId, getRef);
    useClonePropValidation(isClone);
    if (!isClone) {
        var forPublisher = (0, _useMemoOne.useMemo)(function() {
            return {
                descriptor: descriptor,
                registry: registry,
                getDraggableRef: getRef,
                canDragInteractiveElements: canDragInteractiveElements,
                shouldRespectForcePress: shouldRespectForcePress,
                isEnabled: isEnabled
            };
        }, [
            descriptor,
            registry,
            getRef,
            canDragInteractiveElements,
            shouldRespectForcePress,
            isEnabled
        ]);
        useDraggablePublisher(forPublisher);
    }
    var dragHandleProps = (0, _useMemoOne.useMemo)(function() {
        return isEnabled ? {
            tabIndex: 0,
            "data-rbd-drag-handle-draggable-id": draggableId,
            "data-rbd-drag-handle-context-id": contextId,
            "aria-labelledby": liftInstructionId,
            draggable: false,
            onDragStart: preventHtml5Dnd
        } : null;
    }, [
        contextId,
        draggableId,
        isEnabled,
        liftInstructionId
    ]);
    var onMoveEnd = (0, _useMemoOne.useCallback)(function(event) {
        if (mapped.type !== "DRAGGING") return;
        if (!mapped.dropping) return;
        if (event.propertyName !== "transform") return;
        dropAnimationFinishedAction();
    }, [
        dropAnimationFinishedAction,
        mapped
    ]);
    var provided = (0, _useMemoOne.useMemo)(function() {
        var style = getStyle$1(mapped);
        var onTransitionEnd = mapped.type === "DRAGGING" && mapped.dropping ? onMoveEnd : null;
        var result = {
            innerRef: setRef,
            draggableProps: {
                "data-rbd-draggable-context-id": contextId,
                "data-rbd-draggable-id": draggableId,
                style: style,
                onTransitionEnd: onTransitionEnd
            },
            dragHandleProps: dragHandleProps
        };
        return result;
    }, [
        contextId,
        dragHandleProps,
        draggableId,
        mapped,
        onMoveEnd,
        setRef
    ]);
    var rubric = (0, _useMemoOne.useMemo)(function() {
        return {
            draggableId: descriptor.id,
            type: descriptor.type,
            source: {
                index: descriptor.index,
                droppableId: descriptor.droppableId
            }
        };
    }, [
        descriptor.droppableId,
        descriptor.id,
        descriptor.index,
        descriptor.type
    ]);
    return children(provided, mapped.snapshot, rubric);
}
var isStrictEqual = function(a, b) {
    return a === b;
};
var whatIsDraggedOverFromResult = function(result) {
    var combine = result.combine, destination = result.destination;
    if (destination) return destination.droppableId;
    if (combine) return combine.droppableId;
    return null;
};
var getCombineWithFromResult = function getCombineWithFromResult(result) {
    return result.combine ? result.combine.draggableId : null;
};
var getCombineWithFromImpact = function getCombineWithFromImpact(impact) {
    return impact.at && impact.at.type === "COMBINE" ? impact.at.combine.draggableId : null;
};
function getDraggableSelector() {
    var memoizedOffset = (0, _memoizeOneDefault.default)(function(x, y) {
        return {
            x: x,
            y: y
        };
    });
    var getMemoizedSnapshot = (0, _memoizeOneDefault.default)(function(mode, isClone, draggingOver, combineWith, dropping) {
        return {
            isDragging: true,
            isClone: isClone,
            isDropAnimating: Boolean(dropping),
            dropAnimation: dropping,
            mode: mode,
            draggingOver: draggingOver,
            combineWith: combineWith,
            combineTargetFor: null
        };
    });
    var getMemoizedProps = (0, _memoizeOneDefault.default)(function(offset, mode, dimension, isClone, draggingOver, combineWith, forceShouldAnimate) {
        return {
            mapped: {
                type: "DRAGGING",
                dropping: null,
                draggingOver: draggingOver,
                combineWith: combineWith,
                mode: mode,
                offset: offset,
                dimension: dimension,
                forceShouldAnimate: forceShouldAnimate,
                snapshot: getMemoizedSnapshot(mode, isClone, draggingOver, combineWith, null)
            }
        };
    });
    var selector = function selector(state, ownProps) {
        if (state.isDragging) {
            if (state.critical.draggable.id !== ownProps.draggableId) return null;
            var offset = state.current.client.offset;
            var dimension = state.dimensions.draggables[ownProps.draggableId];
            var draggingOver = whatIsDraggedOver(state.impact);
            var combineWith = getCombineWithFromImpact(state.impact);
            var forceShouldAnimate = state.forceShouldAnimate;
            return getMemoizedProps(memoizedOffset(offset.x, offset.y), state.movementMode, dimension, ownProps.isClone, draggingOver, combineWith, forceShouldAnimate);
        }
        if (state.phase === "DROP_ANIMATING") {
            var completed = state.completed;
            if (completed.result.draggableId !== ownProps.draggableId) return null;
            var isClone = ownProps.isClone;
            var _dimension = state.dimensions.draggables[ownProps.draggableId];
            var result = completed.result;
            var mode = result.mode;
            var _draggingOver = whatIsDraggedOverFromResult(result);
            var _combineWith = getCombineWithFromResult(result);
            var duration = state.dropDuration;
            var dropping = {
                duration: duration,
                curve: curves.drop,
                moveTo: state.newHomeClientOffset,
                opacity: _combineWith ? combine.opacity.drop : null,
                scale: _combineWith ? combine.scale.drop : null
            };
            return {
                mapped: {
                    type: "DRAGGING",
                    offset: state.newHomeClientOffset,
                    dimension: _dimension,
                    dropping: dropping,
                    draggingOver: _draggingOver,
                    combineWith: _combineWith,
                    mode: mode,
                    forceShouldAnimate: null,
                    snapshot: getMemoizedSnapshot(mode, isClone, _draggingOver, _combineWith, dropping)
                }
            };
        }
        return null;
    };
    return selector;
}
function getSecondarySnapshot(combineTargetFor) {
    return {
        isDragging: false,
        isDropAnimating: false,
        isClone: false,
        dropAnimation: null,
        mode: null,
        draggingOver: null,
        combineTargetFor: combineTargetFor,
        combineWith: null
    };
}
var atRest = {
    mapped: {
        type: "SECONDARY",
        offset: origin,
        combineTargetFor: null,
        shouldAnimateDisplacement: true,
        snapshot: getSecondarySnapshot(null)
    }
};
function getSecondarySelector() {
    var memoizedOffset = (0, _memoizeOneDefault.default)(function(x, y) {
        return {
            x: x,
            y: y
        };
    });
    var getMemoizedSnapshot = (0, _memoizeOneDefault.default)(getSecondarySnapshot);
    var getMemoizedProps = (0, _memoizeOneDefault.default)(function(offset, combineTargetFor, shouldAnimateDisplacement) {
        if (combineTargetFor === void 0) combineTargetFor = null;
        return {
            mapped: {
                type: "SECONDARY",
                offset: offset,
                combineTargetFor: combineTargetFor,
                shouldAnimateDisplacement: shouldAnimateDisplacement,
                snapshot: getMemoizedSnapshot(combineTargetFor)
            }
        };
    });
    var getFallback = function getFallback(combineTargetFor) {
        return combineTargetFor ? getMemoizedProps(origin, combineTargetFor, true) : null;
    };
    var getProps = function getProps(ownId, draggingId, impact, afterCritical) {
        var visualDisplacement = impact.displaced.visible[ownId];
        var isAfterCriticalInVirtualList = Boolean(afterCritical.inVirtualList && afterCritical.effected[ownId]);
        var combine = tryGetCombine(impact);
        var combineTargetFor = combine && combine.draggableId === ownId ? draggingId : null;
        if (!visualDisplacement) {
            if (!isAfterCriticalInVirtualList) return getFallback(combineTargetFor);
            if (impact.displaced.invisible[ownId]) return null;
            var change = negate(afterCritical.displacedBy.point);
            var _offset = memoizedOffset(change.x, change.y);
            return getMemoizedProps(_offset, combineTargetFor, true);
        }
        if (isAfterCriticalInVirtualList) return getFallback(combineTargetFor);
        var displaceBy = impact.displacedBy.point;
        var offset = memoizedOffset(displaceBy.x, displaceBy.y);
        return getMemoizedProps(offset, combineTargetFor, visualDisplacement.shouldAnimate);
    };
    var selector = function selector(state, ownProps) {
        if (state.isDragging) {
            if (state.critical.draggable.id === ownProps.draggableId) return null;
            return getProps(ownProps.draggableId, state.critical.draggable.id, state.impact, state.afterCritical);
        }
        if (state.phase === "DROP_ANIMATING") {
            var completed = state.completed;
            if (completed.result.draggableId === ownProps.draggableId) return null;
            return getProps(ownProps.draggableId, completed.result.draggableId, completed.impact, completed.afterCritical);
        }
        return null;
    };
    return selector;
}
var makeMapStateToProps = function makeMapStateToProps() {
    var draggingSelector = getDraggableSelector();
    var secondarySelector = getSecondarySelector();
    var selector = function selector(state, ownProps) {
        return draggingSelector(state, ownProps) || secondarySelector(state, ownProps) || atRest;
    };
    return selector;
};
var mapDispatchToProps = {
    dropAnimationFinished: dropAnimationFinished
};
var ConnectedDraggable = (0, _reactRedux.connect)(makeMapStateToProps, mapDispatchToProps, null, {
    context: StoreContext,
    pure: true,
    areStatePropsEqual: isStrictEqual
})(Draggable);
function PrivateDraggable(props) {
    var droppableContext = useRequiredContext(DroppableContext);
    var isUsingCloneFor = droppableContext.isUsingCloneFor;
    if (isUsingCloneFor === props.draggableId && !props.isClone) return null;
    return (0, _reactDefault.default).createElement(ConnectedDraggable, props);
}
function PublicDraggable(props) {
    var isEnabled = typeof props.isDragDisabled === "boolean" ? !props.isDragDisabled : true;
    var canDragInteractiveElements = Boolean(props.disableInteractiveElementBlocking);
    var shouldRespectForcePress = Boolean(props.shouldRespectForcePress);
    return (0, _reactDefault.default).createElement(PrivateDraggable, (0, _extendsDefault.default)({}, props, {
        isClone: false,
        isEnabled: isEnabled,
        canDragInteractiveElements: canDragInteractiveElements,
        shouldRespectForcePress: shouldRespectForcePress
    }));
}
function Droppable(props) {
    var appContext = (0, _react.useContext)(AppContext);
    !appContext && invariant(false);
    var contextId = appContext.contextId, isMovementAllowed = appContext.isMovementAllowed;
    var droppableRef = (0, _react.useRef)(null);
    var placeholderRef = (0, _react.useRef)(null);
    var children = props.children, droppableId = props.droppableId, type = props.type, mode = props.mode, direction = props.direction, ignoreContainerClipping = props.ignoreContainerClipping, isDropDisabled = props.isDropDisabled, isCombineEnabled = props.isCombineEnabled, snapshot = props.snapshot, useClone = props.useClone, updateViewportMaxScroll = props.updateViewportMaxScroll, getContainerForClone = props.getContainerForClone;
    var getDroppableRef = (0, _useMemoOne.useCallback)(function() {
        return droppableRef.current;
    }, []);
    var setDroppableRef = (0, _useMemoOne.useCallback)(function(value) {
        droppableRef.current = value;
    }, []);
    var getPlaceholderRef = (0, _useMemoOne.useCallback)(function() {
        return placeholderRef.current;
    }, []);
    var setPlaceholderRef = (0, _useMemoOne.useCallback)(function(value) {
        placeholderRef.current = value;
    }, []);
    useValidation({
        props: props,
        getDroppableRef: getDroppableRef,
        getPlaceholderRef: getPlaceholderRef
    });
    var onPlaceholderTransitionEnd = (0, _useMemoOne.useCallback)(function() {
        if (isMovementAllowed()) updateViewportMaxScroll({
            maxScroll: getMaxWindowScroll()
        });
    }, [
        isMovementAllowed,
        updateViewportMaxScroll
    ]);
    useDroppablePublisher({
        droppableId: droppableId,
        type: type,
        mode: mode,
        direction: direction,
        isDropDisabled: isDropDisabled,
        isCombineEnabled: isCombineEnabled,
        ignoreContainerClipping: ignoreContainerClipping,
        getDroppableRef: getDroppableRef
    });
    var placeholder = (0, _reactDefault.default).createElement(AnimateInOut, {
        on: props.placeholder,
        shouldAnimate: props.shouldAnimatePlaceholder
    }, function(_ref) {
        var onClose = _ref.onClose, data = _ref.data, animate = _ref.animate;
        return (0, _reactDefault.default).createElement(Placeholder$1, {
            placeholder: data,
            onClose: onClose,
            innerRef: setPlaceholderRef,
            animate: animate,
            contextId: contextId,
            onTransitionEnd: onPlaceholderTransitionEnd
        });
    });
    var provided = (0, _useMemoOne.useMemo)(function() {
        return {
            innerRef: setDroppableRef,
            placeholder: placeholder,
            droppableProps: {
                "data-rbd-droppable-id": droppableId,
                "data-rbd-droppable-context-id": contextId
            }
        };
    }, [
        contextId,
        droppableId,
        placeholder,
        setDroppableRef
    ]);
    var isUsingCloneFor = useClone ? useClone.dragging.draggableId : null;
    var droppableContext = (0, _useMemoOne.useMemo)(function() {
        return {
            droppableId: droppableId,
            type: type,
            isUsingCloneFor: isUsingCloneFor
        };
    }, [
        droppableId,
        isUsingCloneFor,
        type
    ]);
    function getClone() {
        if (!useClone) return null;
        var dragging = useClone.dragging, render = useClone.render;
        var node = (0, _reactDefault.default).createElement(PrivateDraggable, {
            draggableId: dragging.draggableId,
            index: dragging.source.index,
            isClone: true,
            isEnabled: true,
            shouldRespectForcePress: false,
            canDragInteractiveElements: true
        }, function(draggableProvided, draggableSnapshot) {
            return render(draggableProvided, draggableSnapshot, dragging);
        });
        return (0, _reactDomDefault.default).createPortal(node, getContainerForClone());
    }
    return (0, _reactDefault.default).createElement(DroppableContext.Provider, {
        value: droppableContext
    }, children(provided, snapshot), getClone());
}
var isMatchingType = function isMatchingType(type, critical) {
    return type === critical.droppable.type;
};
var getDraggable = function getDraggable(critical, dimensions) {
    return dimensions.draggables[critical.draggable.id];
};
var makeMapStateToProps$1 = function makeMapStateToProps() {
    var idleWithAnimation = {
        placeholder: null,
        shouldAnimatePlaceholder: true,
        snapshot: {
            isDraggingOver: false,
            draggingOverWith: null,
            draggingFromThisWith: null,
            isUsingPlaceholder: false
        },
        useClone: null
    };
    var idleWithoutAnimation = (0, _extendsDefault.default)({}, idleWithAnimation, {
        shouldAnimatePlaceholder: false
    });
    var getDraggableRubric = (0, _memoizeOneDefault.default)(function(descriptor) {
        return {
            draggableId: descriptor.id,
            type: descriptor.type,
            source: {
                index: descriptor.index,
                droppableId: descriptor.droppableId
            }
        };
    });
    var getMapProps = (0, _memoizeOneDefault.default)(function(id, isEnabled, isDraggingOverForConsumer, isDraggingOverForImpact, dragging, renderClone) {
        var draggableId = dragging.descriptor.id;
        var isHome = dragging.descriptor.droppableId === id;
        if (isHome) {
            var useClone = renderClone ? {
                render: renderClone,
                dragging: getDraggableRubric(dragging.descriptor)
            } : null;
            var _snapshot = {
                isDraggingOver: isDraggingOverForConsumer,
                draggingOverWith: isDraggingOverForConsumer ? draggableId : null,
                draggingFromThisWith: draggableId,
                isUsingPlaceholder: true
            };
            return {
                placeholder: dragging.placeholder,
                shouldAnimatePlaceholder: false,
                snapshot: _snapshot,
                useClone: useClone
            };
        }
        if (!isEnabled) return idleWithoutAnimation;
        if (!isDraggingOverForImpact) return idleWithAnimation;
        var snapshot = {
            isDraggingOver: isDraggingOverForConsumer,
            draggingOverWith: draggableId,
            draggingFromThisWith: null,
            isUsingPlaceholder: true
        };
        return {
            placeholder: dragging.placeholder,
            shouldAnimatePlaceholder: true,
            snapshot: snapshot,
            useClone: null
        };
    });
    var selector = function selector(state, ownProps) {
        var id = ownProps.droppableId;
        var type = ownProps.type;
        var isEnabled = !ownProps.isDropDisabled;
        var renderClone = ownProps.renderClone;
        if (state.isDragging) {
            var critical = state.critical;
            if (!isMatchingType(type, critical)) return idleWithoutAnimation;
            var dragging = getDraggable(critical, state.dimensions);
            var isDraggingOver = whatIsDraggedOver(state.impact) === id;
            return getMapProps(id, isEnabled, isDraggingOver, isDraggingOver, dragging, renderClone);
        }
        if (state.phase === "DROP_ANIMATING") {
            var completed = state.completed;
            if (!isMatchingType(type, completed.critical)) return idleWithoutAnimation;
            var _dragging = getDraggable(completed.critical, state.dimensions);
            return getMapProps(id, isEnabled, whatIsDraggedOverFromResult(completed.result) === id, whatIsDraggedOver(completed.impact) === id, _dragging, renderClone);
        }
        if (state.phase === "IDLE" && state.completed && !state.shouldFlush) {
            var _completed = state.completed;
            if (!isMatchingType(type, _completed.critical)) return idleWithoutAnimation;
            var wasOver = whatIsDraggedOver(_completed.impact) === id;
            var wasCombining = Boolean(_completed.impact.at && _completed.impact.at.type === "COMBINE");
            var isHome = _completed.critical.droppable.id === id;
            if (wasOver) return wasCombining ? idleWithAnimation : idleWithoutAnimation;
            if (isHome) return idleWithAnimation;
            return idleWithoutAnimation;
        }
        return idleWithoutAnimation;
    };
    return selector;
};
var mapDispatchToProps$1 = {
    updateViewportMaxScroll: updateViewportMaxScroll
};
function getBody() {
    !document.body && invariant(false);
    return document.body;
}
var defaultProps = {
    mode: "standard",
    type: "DEFAULT",
    direction: "vertical",
    isDropDisabled: false,
    isCombineEnabled: false,
    ignoreContainerClipping: false,
    renderClone: null,
    getContainerForClone: getBody
};
var ConnectedDroppable = (0, _reactRedux.connect)(makeMapStateToProps$1, mapDispatchToProps$1, null, {
    context: StoreContext,
    pure: true,
    areStatePropsEqual: isStrictEqual
})(Droppable);
ConnectedDroppable.defaultProps = defaultProps;

},{"react":"6uln9","use-memo-one":"fIYPc","@babel/runtime-corejs2/helpers/esm/inheritsLoose":"hBsqk","@babel/runtime-corejs2/helpers/esm/extends":"f6kVy","redux":"ifE4h","react-redux":"aSGX4","css-box-model":"6hqau","memoize-one":"9ZyRf","@babel/runtime-corejs2/core-js/object/values":"2FtWs","@babel/runtime-corejs2/core-js/object/keys":"250cg","raf-schd":"amLmH","@babel/runtime-corejs2/core-js/date/now":"f22qq","@babel/runtime-corejs2/core-js/object/assign":"kTW7n","react-dom":"b8T3j","@babel/runtime-corejs2/core-js/number/is-integer":"aPsYS","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"fIYPc":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useCallback", ()=>useCallback);
parcelHelpers.export(exports, "useCallbackOne", ()=>useCallbackOne);
parcelHelpers.export(exports, "useMemo", ()=>useMemo);
parcelHelpers.export(exports, "useMemoOne", ()=>useMemoOne);
var _react = require("react");
function areInputsEqual(newInputs, lastInputs) {
    if (newInputs.length !== lastInputs.length) return false;
    for(var i = 0; i < newInputs.length; i++){
        if (newInputs[i] !== lastInputs[i]) return false;
    }
    return true;
}
function useMemoOne(getResult, inputs) {
    var initial = (0, _react.useState)(function() {
        return {
            inputs: inputs,
            result: getResult()
        };
    })[0];
    var isFirstRun = (0, _react.useRef)(true);
    var committed = (0, _react.useRef)(initial);
    var useCache = isFirstRun.current || Boolean(inputs && committed.current.inputs && areInputsEqual(inputs, committed.current.inputs));
    var cache = useCache ? committed.current : {
        inputs: inputs,
        result: getResult()
    };
    (0, _react.useEffect)(function() {
        isFirstRun.current = false;
        committed.current = cache;
    }, [
        cache
    ]);
    return cache.result;
}
function useCallbackOne(callback, inputs) {
    return useMemoOne(function() {
        return callback;
    }, inputs);
}
var useMemo = useMemoOne;
var useCallback = useCallbackOne;

},{"react":"6uln9","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hBsqk":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_inheritsLoose);
var _createJs = require("core-js/library/fn/object/create.js");
var _createJsDefault = parcelHelpers.interopDefault(_createJs);
var _setPrototypeOfJs = require("./setPrototypeOf.js");
var _setPrototypeOfJsDefault = parcelHelpers.interopDefault(_setPrototypeOfJs);
function _inheritsLoose(subClass, superClass) {
    subClass.prototype = (0, _createJsDefault.default)(superClass.prototype);
    subClass.prototype.constructor = subClass;
    (0, _setPrototypeOfJsDefault.default)(subClass, superClass);
}

},{"core-js/library/fn/object/create.js":"53XUb","./setPrototypeOf.js":"BtOiT","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"BtOiT":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_setPrototypeOf);
var _setPrototypeOfJs = require("core-js/library/fn/object/set-prototype-of.js");
var _setPrototypeOfJsDefault = parcelHelpers.interopDefault(_setPrototypeOfJs);
function _setPrototypeOf(o, p) {
    _setPrototypeOf = (0, _setPrototypeOfJsDefault.default) ? (0, _setPrototypeOfJsDefault.default).bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}

},{"core-js/library/fn/object/set-prototype-of.js":"dyw6Q","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"f6kVy":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_extends);
var _assignJs = require("core-js/library/fn/object/assign.js");
var _assignJsDefault = parcelHelpers.interopDefault(_assignJs);
function _extends() {
    _extends = (0, _assignJsDefault.default) ? (0, _assignJsDefault.default).bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}

},{"core-js/library/fn/object/assign.js":"a8aV5","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"ifE4h":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__DO_NOT_USE__ActionTypes", ()=>ActionTypes);
parcelHelpers.export(exports, "applyMiddleware", ()=>applyMiddleware);
parcelHelpers.export(exports, "bindActionCreators", ()=>bindActionCreators);
parcelHelpers.export(exports, "combineReducers", ()=>combineReducers);
parcelHelpers.export(exports, "compose", ()=>compose);
parcelHelpers.export(exports, "createStore", ()=>createStore);
parcelHelpers.export(exports, "legacy_createStore", ()=>legacy_createStore);
var _objectSpread2 = require("@babel/runtime/helpers/esm/objectSpread2");
var _objectSpread2Default = parcelHelpers.interopDefault(_objectSpread2);
/**
 * Adapted from React: https://github.com/facebook/react/blob/master/packages/shared/formatProdErrorMessage.js
 *
 * Do not require this module directly! Use normal throw error calls. These messages will be replaced with error codes
 * during build.
 * @param {number} code
 */ function formatProdErrorMessage(code) {
    return "Minified Redux error #" + code + "; visit https://redux.js.org/Errors?code=" + code + " for the full message or " + "use the non-minified dev environment for full errors. ";
}
// Inlined version of the `symbol-observable` polyfill
var $$observable = function() {
    return typeof Symbol === "function" && Symbol.observable || "@@observable";
}();
/**
 * These are private action types reserved by Redux.
 * For any unknown actions, you must return the current state.
 * If the current state is undefined, you must return the initial state.
 * Do not reference these action types directly in your code.
 */ var randomString = function randomString() {
    return Math.random().toString(36).substring(7).split("").join(".");
};
var ActionTypes = {
    INIT: "@@redux/INIT" + randomString(),
    REPLACE: "@@redux/REPLACE" + randomString(),
    PROBE_UNKNOWN_ACTION: function PROBE_UNKNOWN_ACTION() {
        return "@@redux/PROBE_UNKNOWN_ACTION" + randomString();
    }
};
/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */ function isPlainObject(obj) {
    if (typeof obj !== "object" || obj === null) return false;
    var proto = obj;
    while(Object.getPrototypeOf(proto) !== null)proto = Object.getPrototypeOf(proto);
    return Object.getPrototypeOf(obj) === proto;
}
// Inlined / shortened version of `kindOf` from https://github.com/jonschlinkert/kind-of
function miniKindOf(val) {
    if (val === void 0) return "undefined";
    if (val === null) return "null";
    var type = typeof val;
    switch(type){
        case "boolean":
        case "string":
        case "number":
        case "symbol":
        case "function":
            return type;
    }
    if (Array.isArray(val)) return "array";
    if (isDate(val)) return "date";
    if (isError(val)) return "error";
    var constructorName = ctorName(val);
    switch(constructorName){
        case "Symbol":
        case "Promise":
        case "WeakMap":
        case "WeakSet":
        case "Map":
        case "Set":
            return constructorName;
    } // other
    return type.slice(8, -1).toLowerCase().replace(/\s/g, "");
}
function ctorName(val) {
    return typeof val.constructor === "function" ? val.constructor.name : null;
}
function isError(val) {
    return val instanceof Error || typeof val.message === "string" && val.constructor && typeof val.constructor.stackTraceLimit === "number";
}
function isDate(val) {
    if (val instanceof Date) return true;
    return typeof val.toDateString === "function" && typeof val.getDate === "function" && typeof val.setDate === "function";
}
function kindOf(val) {
    var typeOfVal = typeof val;
    return typeOfVal;
}
/**
 * @deprecated
 *
 * **We recommend using the `configureStore` method
 * of the `@reduxjs/toolkit` package**, which replaces `createStore`.
 *
 * Redux Toolkit is our recommended approach for writing Redux logic today,
 * including store setup, reducers, data fetching, and more.
 *
 * **For more details, please read this Redux docs page:**
 * **https://redux.js.org/introduction/why-rtk-is-redux-today**
 *
 * `configureStore` from Redux Toolkit is an improved version of `createStore` that
 * simplifies setup and helps avoid common bugs.
 *
 * You should not be using the `redux` core package by itself today, except for learning purposes.
 * The `createStore` method from the core `redux` package will not be removed, but we encourage
 * all users to migrate to using Redux Toolkit for all Redux code.
 *
 * If you want to use `createStore` without this visual deprecation warning, use
 * the `legacy_createStore` import instead:
 *
 * `import { legacy_createStore as createStore} from 'redux'`
 *
 */ function createStore(reducer, preloadedState, enhancer) {
    var _ref2;
    if (typeof preloadedState === "function" && typeof enhancer === "function" || typeof enhancer === "function" && typeof arguments[3] === "function") throw new Error(formatProdErrorMessage(0));
    if (typeof preloadedState === "function" && typeof enhancer === "undefined") {
        enhancer = preloadedState;
        preloadedState = undefined;
    }
    if (typeof enhancer !== "undefined") {
        if (typeof enhancer !== "function") throw new Error(formatProdErrorMessage(1));
        return enhancer(createStore)(reducer, preloadedState);
    }
    if (typeof reducer !== "function") throw new Error(formatProdErrorMessage(2));
    var currentReducer = reducer;
    var currentState = preloadedState;
    var currentListeners = [];
    var nextListeners = currentListeners;
    var isDispatching = false;
    /**
   * This makes a shallow copy of currentListeners so we can use
   * nextListeners as a temporary list while dispatching.
   *
   * This prevents any bugs around consumers calling
   * subscribe/unsubscribe in the middle of a dispatch.
   */ function ensureCanMutateNextListeners() {
        if (nextListeners === currentListeners) nextListeners = currentListeners.slice();
    }
    /**
   * Reads the state tree managed by the store.
   *
   * @returns {any} The current state tree of your application.
   */ function getState() {
        if (isDispatching) throw new Error(formatProdErrorMessage(3));
        return currentState;
    }
    /**
   * Adds a change listener. It will be called any time an action is dispatched,
   * and some part of the state tree may potentially have changed. You may then
   * call `getState()` to read the current state tree inside the callback.
   *
   * You may call `dispatch()` from a change listener, with the following
   * caveats:
   *
   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
   * If you subscribe or unsubscribe while the listeners are being invoked, this
   * will not have any effect on the `dispatch()` that is currently in progress.
   * However, the next `dispatch()` call, whether nested or not, will use a more
   * recent snapshot of the subscription list.
   *
   * 2. The listener should not expect to see all state changes, as the state
   * might have been updated multiple times during a nested `dispatch()` before
   * the listener is called. It is, however, guaranteed that all subscribers
   * registered before the `dispatch()` started will be called with the latest
   * state by the time it exits.
   *
   * @param {Function} listener A callback to be invoked on every dispatch.
   * @returns {Function} A function to remove this change listener.
   */ function subscribe(listener) {
        if (typeof listener !== "function") throw new Error(formatProdErrorMessage(4));
        if (isDispatching) throw new Error(formatProdErrorMessage(5));
        var isSubscribed = true;
        ensureCanMutateNextListeners();
        nextListeners.push(listener);
        return function unsubscribe() {
            if (!isSubscribed) return;
            if (isDispatching) throw new Error(formatProdErrorMessage(6));
            isSubscribed = false;
            ensureCanMutateNextListeners();
            var index = nextListeners.indexOf(listener);
            nextListeners.splice(index, 1);
            currentListeners = null;
        };
    }
    /**
   * Dispatches an action. It is the only way to trigger a state change.
   *
   * The `reducer` function, used to create the store, will be called with the
   * current state tree and the given `action`. Its return value will
   * be considered the **next** state of the tree, and the change listeners
   * will be notified.
   *
   * The base implementation only supports plain object actions. If you want to
   * dispatch a Promise, an Observable, a thunk, or something else, you need to
   * wrap your store creating function into the corresponding middleware. For
   * example, see the documentation for the `redux-thunk` package. Even the
   * middleware will eventually dispatch plain object actions using this method.
   *
   * @param {Object} action A plain object representing “what changed”. It is
   * a good idea to keep actions serializable so you can record and replay user
   * sessions, or use the time travelling `redux-devtools`. An action must have
   * a `type` property which may not be `undefined`. It is a good idea to use
   * string constants for action types.
   *
   * @returns {Object} For convenience, the same action object you dispatched.
   *
   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
   * return something else (for example, a Promise you can await).
   */ function dispatch(action) {
        if (!isPlainObject(action)) throw new Error(formatProdErrorMessage(7));
        if (typeof action.type === "undefined") throw new Error(formatProdErrorMessage(8));
        if (isDispatching) throw new Error(formatProdErrorMessage(9));
        try {
            isDispatching = true;
            currentState = currentReducer(currentState, action);
        } finally{
            isDispatching = false;
        }
        var listeners = currentListeners = nextListeners;
        for(var i = 0; i < listeners.length; i++){
            var listener = listeners[i];
            listener();
        }
        return action;
    }
    /**
   * Replaces the reducer currently used by the store to calculate the state.
   *
   * You might need this if your app implements code splitting and you want to
   * load some of the reducers dynamically. You might also need this if you
   * implement a hot reloading mechanism for Redux.
   *
   * @param {Function} nextReducer The reducer for the store to use instead.
   * @returns {void}
   */ function replaceReducer(nextReducer) {
        if (typeof nextReducer !== "function") throw new Error(formatProdErrorMessage(10));
        currentReducer = nextReducer; // This action has a similiar effect to ActionTypes.INIT.
        // Any reducers that existed in both the new and old rootReducer
        // will receive the previous state. This effectively populates
        // the new state tree with any relevant data from the old one.
        dispatch({
            type: ActionTypes.REPLACE
        });
    }
    /**
   * Interoperability point for observable/reactive libraries.
   * @returns {observable} A minimal observable of state changes.
   * For more information, see the observable proposal:
   * https://github.com/tc39/proposal-observable
   */ function observable() {
        var _ref;
        var outerSubscribe = subscribe;
        return _ref = {
            /**
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */ subscribe: function subscribe(observer) {
                if (typeof observer !== "object" || observer === null) throw new Error(formatProdErrorMessage(11));
                function observeState() {
                    if (observer.next) observer.next(getState());
                }
                observeState();
                var unsubscribe = outerSubscribe(observeState);
                return {
                    unsubscribe: unsubscribe
                };
            }
        }, _ref[$$observable] = function() {
            return this;
        }, _ref;
    } // When a store is created, an "INIT" action is dispatched so that every
    // reducer returns their initial state. This effectively populates
    // the initial state tree.
    dispatch({
        type: ActionTypes.INIT
    });
    return _ref2 = {
        dispatch: dispatch,
        subscribe: subscribe,
        getState: getState,
        replaceReducer: replaceReducer
    }, _ref2[$$observable] = observable, _ref2;
}
/**
 * Creates a Redux store that holds the state tree.
 *
 * **We recommend using `configureStore` from the
 * `@reduxjs/toolkit` package**, which replaces `createStore`:
 * **https://redux.js.org/introduction/why-rtk-is-redux-today**
 *
 * The only way to change the data in the store is to call `dispatch()` on it.
 *
 * There should only be a single store in your app. To specify how different
 * parts of the state tree respond to actions, you may combine several reducers
 * into a single reducer function by using `combineReducers`.
 *
 * @param {Function} reducer A function that returns the next state tree, given
 * the current state tree and the action to handle.
 *
 * @param {any} [preloadedState] The initial state. You may optionally specify it
 * to hydrate the state from the server in universal apps, or to restore a
 * previously serialized user session.
 * If you use `combineReducers` to produce the root reducer function, this must be
 * an object with the same shape as `combineReducers` keys.
 *
 * @param {Function} [enhancer] The store enhancer. You may optionally specify it
 * to enhance the store with third-party capabilities such as middleware,
 * time travel, persistence, etc. The only store enhancer that ships with Redux
 * is `applyMiddleware()`.
 *
 * @returns {Store} A Redux store that lets you read the state, dispatch actions
 * and subscribe to changes.
 */ var legacy_createStore = createStore;
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */ function warning(message) {
    /* eslint-disable no-console */ if (typeof console !== "undefined" && typeof console.error === "function") console.error(message);
    /* eslint-enable no-console */ try {
        // This error was thrown as a convenience so that if you enable
        // "break on all exceptions" in your console,
        // it would pause the execution at this line.
        throw new Error(message);
    } catch (e) {} // eslint-disable-line no-empty
}
function getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
    var reducerKeys = Object.keys(reducers);
    var argumentName = action && action.type === ActionTypes.INIT ? "preloadedState argument passed to createStore" : "previous state received by the reducer";
    if (reducerKeys.length === 0) return "Store does not have a valid reducer. Make sure the argument passed to combineReducers is an object whose values are reducers.";
    if (!isPlainObject(inputState)) return "The " + argumentName + ' has unexpected type of "' + kindOf(inputState) + '". Expected argument to be an object with the following ' + ('keys: "' + reducerKeys.join('", "') + '"');
    var unexpectedKeys = Object.keys(inputState).filter(function(key) {
        return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
    });
    unexpectedKeys.forEach(function(key) {
        unexpectedKeyCache[key] = true;
    });
    if (action && action.type === ActionTypes.REPLACE) return;
    if (unexpectedKeys.length > 0) return "Unexpected " + (unexpectedKeys.length > 1 ? "keys" : "key") + " " + ('"' + unexpectedKeys.join('", "') + '" found in ' + argumentName + ". ") + "Expected to find one of the known reducer keys instead: " + ('"' + reducerKeys.join('", "') + '". Unexpected keys will be ignored.');
}
function assertReducerShape(reducers) {
    Object.keys(reducers).forEach(function(key) {
        var reducer = reducers[key];
        var initialState = reducer(undefined, {
            type: ActionTypes.INIT
        });
        if (typeof initialState === "undefined") throw new Error(formatProdErrorMessage(12));
        if (typeof reducer(undefined, {
            type: ActionTypes.PROBE_UNKNOWN_ACTION()
        }) === "undefined") throw new Error(formatProdErrorMessage(13));
    });
}
/**
 * Turns an object whose values are different reducer functions, into a single
 * reducer function. It will call every child reducer, and gather their results
 * into a single state object, whose keys correspond to the keys of the passed
 * reducer functions.
 *
 * @param {Object} reducers An object whose values correspond to different
 * reducer functions that need to be combined into one. One handy way to obtain
 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
 * undefined for any action. Instead, they should return their initial state
 * if the state passed to them was undefined, and the current state for any
 * unrecognized action.
 *
 * @returns {Function} A reducer function that invokes every reducer inside the
 * passed object, and builds a state object with the same shape.
 */ function combineReducers(reducers) {
    var reducerKeys = Object.keys(reducers);
    var finalReducers = {};
    for(var i = 0; i < reducerKeys.length; i++){
        var key = reducerKeys[i];
        if (typeof reducers[key] === "function") finalReducers[key] = reducers[key];
    }
    var finalReducerKeys = Object.keys(finalReducers); // This is used to make sure we don't warn about the same
    // keys multiple times.
    var unexpectedKeyCache;
    var shapeAssertionError;
    try {
        assertReducerShape(finalReducers);
    } catch (e) {
        shapeAssertionError = e;
    }
    return function combination(state, action) {
        if (state === void 0) state = {};
        if (shapeAssertionError) throw shapeAssertionError;
        var warningMessage;
        var hasChanged = false;
        var nextState = {};
        for(var _i = 0; _i < finalReducerKeys.length; _i++){
            var _key = finalReducerKeys[_i];
            var reducer = finalReducers[_key];
            var previousStateForKey = state[_key];
            var nextStateForKey = reducer(previousStateForKey, action);
            if (typeof nextStateForKey === "undefined") {
                var actionType = action && action.type;
                throw new Error(formatProdErrorMessage(14));
            }
            nextState[_key] = nextStateForKey;
            hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
        }
        hasChanged = hasChanged || finalReducerKeys.length !== Object.keys(state).length;
        return hasChanged ? nextState : state;
    };
}
function bindActionCreator(actionCreator, dispatch) {
    return function() {
        return dispatch(actionCreator.apply(this, arguments));
    };
}
/**
 * Turns an object whose values are action creators, into an object with the
 * same keys, but with every function wrapped into a `dispatch` call so they
 * may be invoked directly. This is just a convenience method, as you can call
 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
 *
 * For convenience, you can also pass an action creator as the first argument,
 * and get a dispatch wrapped function in return.
 *
 * @param {Function|Object} actionCreators An object whose values are action
 * creator functions. One handy way to obtain it is to use ES6 `import * as`
 * syntax. You may also pass a single function.
 *
 * @param {Function} dispatch The `dispatch` function available on your Redux
 * store.
 *
 * @returns {Function|Object} The object mimicking the original object, but with
 * every action creator wrapped into the `dispatch` call. If you passed a
 * function as `actionCreators`, the return value will also be a single
 * function.
 */ function bindActionCreators(actionCreators, dispatch) {
    if (typeof actionCreators === "function") return bindActionCreator(actionCreators, dispatch);
    if (typeof actionCreators !== "object" || actionCreators === null) throw new Error(formatProdErrorMessage(16));
    var boundActionCreators = {};
    for(var key in actionCreators){
        var actionCreator = actionCreators[key];
        if (typeof actionCreator === "function") boundActionCreators[key] = bindActionCreator(actionCreator, dispatch);
    }
    return boundActionCreators;
}
/**
 * Composes single-argument functions from right to left. The rightmost
 * function can take multiple arguments as it provides the signature for
 * the resulting composite function.
 *
 * @param {...Function} funcs The functions to compose.
 * @returns {Function} A function obtained by composing the argument functions
 * from right to left. For example, compose(f, g, h) is identical to doing
 * (...args) => f(g(h(...args))).
 */ function compose() {
    for(var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++)funcs[_key] = arguments[_key];
    if (funcs.length === 0) return function(arg) {
        return arg;
    };
    if (funcs.length === 1) return funcs[0];
    return funcs.reduce(function(a, b) {
        return function() {
            return a(b.apply(void 0, arguments));
        };
    });
}
/**
 * Creates a store enhancer that applies middleware to the dispatch method
 * of the Redux store. This is handy for a variety of tasks, such as expressing
 * asynchronous actions in a concise manner, or logging every action payload.
 *
 * See `redux-thunk` package as an example of the Redux middleware.
 *
 * Because middleware is potentially asynchronous, this should be the first
 * store enhancer in the composition chain.
 *
 * Note that each middleware will be given the `dispatch` and `getState` functions
 * as named arguments.
 *
 * @param {...Function} middlewares The middleware chain to be applied.
 * @returns {Function} A store enhancer applying the middleware.
 */ function applyMiddleware() {
    for(var _len = arguments.length, middlewares = new Array(_len), _key = 0; _key < _len; _key++)middlewares[_key] = arguments[_key];
    return function(createStore) {
        return function() {
            var store = createStore.apply(void 0, arguments);
            var _dispatch = function dispatch() {
                throw new Error(formatProdErrorMessage(15));
            };
            var middlewareAPI = {
                getState: store.getState,
                dispatch: function dispatch() {
                    return _dispatch.apply(void 0, arguments);
                }
            };
            var chain = middlewares.map(function(middleware) {
                return middleware(middlewareAPI);
            });
            _dispatch = compose.apply(void 0, chain)(store.dispatch);
            return (0, _objectSpread2Default.default)((0, _objectSpread2Default.default)({}, store), {}, {
                dispatch: _dispatch
            });
        };
    };
}

},{"@babel/runtime/helpers/esm/objectSpread2":"7Qvqo","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7Qvqo":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_objectSpread2);
var _definePropertyJs = require("./defineProperty.js");
var _definePropertyJsDefault = parcelHelpers.interopDefault(_definePropertyJs);
function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function _objectSpread2(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? ownKeys(Object(t), !0).forEach(function(r) {
            (0, _definePropertyJsDefault.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}

},{"./defineProperty.js":"5XpnH","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"5XpnH":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_defineProperty);
var _toPropertyKeyJs = require("./toPropertyKey.js");
var _toPropertyKeyJsDefault = parcelHelpers.interopDefault(_toPropertyKeyJs);
function _defineProperty(e, r, t) {
    return (r = (0, _toPropertyKeyJsDefault.default)(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}

},{"./toPropertyKey.js":"2D7VT","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2D7VT":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>toPropertyKey);
var _typeofJs = require("./typeof.js");
var _typeofJsDefault = parcelHelpers.interopDefault(_typeofJs);
var _toPrimitiveJs = require("./toPrimitive.js");
var _toPrimitiveJsDefault = parcelHelpers.interopDefault(_toPrimitiveJs);
function toPropertyKey(t) {
    var i = (0, _toPrimitiveJsDefault.default)(t, "string");
    return "symbol" == (0, _typeofJsDefault.default)(i) ? i : i + "";
}

},{"./typeof.js":"4ZfJH","./toPrimitive.js":"15sIk","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4ZfJH":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_typeof);
function _typeof(o) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, _typeof(o);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"15sIk":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>toPrimitive);
var _typeofJs = require("./typeof.js");
var _typeofJsDefault = parcelHelpers.interopDefault(_typeofJs);
function toPrimitive(t, r) {
    if ("object" != (0, _typeofJsDefault.default)(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (0, _typeofJsDefault.default)(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}

},{"./typeof.js":"4ZfJH","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"aSGX4":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "batch", ()=>(0, _reactBatchedUpdates.unstable_batchedUpdates));
var _exports = require("./exports");
parcelHelpers.exportAll(_exports, exports);
var _reactBatchedUpdates = require("./utils/reactBatchedUpdates");
var _batch = require("./utils/batch"); // Enable batched updates in our subscriptions for use
// with standard React renderers (ReactDOM, React Native)
(0, _batch.setBatch)((0, _reactBatchedUpdates.unstable_batchedUpdates));

},{"./exports":"4Zeyj","./utils/reactBatchedUpdates":"83jZe","./utils/batch":"03EVY","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4Zeyj":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Provider", ()=>(0, _providerDefault.default));
parcelHelpers.export(exports, "connectAdvanced", ()=>(0, _connectAdvancedDefault.default));
parcelHelpers.export(exports, "ReactReduxContext", ()=>(0, _context.ReactReduxContext));
parcelHelpers.export(exports, "connect", ()=>(0, _connectDefault.default));
parcelHelpers.export(exports, "useDispatch", ()=>(0, _useDispatch.useDispatch));
parcelHelpers.export(exports, "createDispatchHook", ()=>(0, _useDispatch.createDispatchHook));
parcelHelpers.export(exports, "useSelector", ()=>(0, _useSelector.useSelector));
parcelHelpers.export(exports, "createSelectorHook", ()=>(0, _useSelector.createSelectorHook));
parcelHelpers.export(exports, "useStore", ()=>(0, _useStore.useStore));
parcelHelpers.export(exports, "createStoreHook", ()=>(0, _useStore.createStoreHook));
parcelHelpers.export(exports, "shallowEqual", ()=>(0, _shallowEqualDefault.default));
var _provider = require("./components/Provider");
var _providerDefault = parcelHelpers.interopDefault(_provider);
var _connectAdvanced = require("./components/connectAdvanced");
var _connectAdvancedDefault = parcelHelpers.interopDefault(_connectAdvanced);
var _context = require("./components/Context");
var _connect = require("./connect/connect");
var _connectDefault = parcelHelpers.interopDefault(_connect);
var _useDispatch = require("./hooks/useDispatch");
var _useSelector = require("./hooks/useSelector");
var _useStore = require("./hooks/useStore");
var _shallowEqual = require("./utils/shallowEqual");
var _shallowEqualDefault = parcelHelpers.interopDefault(_shallowEqual);

},{"./components/Provider":"kmUop","./components/connectAdvanced":"6vIlB","./components/Context":"kDZAc","./connect/connect":"KFTfv","./hooks/useDispatch":"8dGqk","./hooks/useSelector":"8wADB","./hooks/useStore":"9ZMKr","./utils/shallowEqual":"NluBY","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"kmUop":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _context = require("./Context");
var _subscription = require("../utils/Subscription");
var _useIsomorphicLayoutEffect = require("../utils/useIsomorphicLayoutEffect");
function Provider(_ref) {
    var store = _ref.store, context = _ref.context, children = _ref.children;
    var contextValue = (0, _react.useMemo)(function() {
        var subscription = (0, _subscription.createSubscription)(store);
        return {
            store: store,
            subscription: subscription
        };
    }, [
        store
    ]);
    var previousState = (0, _react.useMemo)(function() {
        return store.getState();
    }, [
        store
    ]);
    (0, _useIsomorphicLayoutEffect.useIsomorphicLayoutEffect)(function() {
        var subscription = contextValue.subscription;
        subscription.onStateChange = subscription.notifyNestedSubs;
        subscription.trySubscribe();
        if (previousState !== store.getState()) subscription.notifyNestedSubs();
        return function() {
            subscription.tryUnsubscribe();
            subscription.onStateChange = null;
        };
    }, [
        contextValue,
        previousState
    ]);
    var Context = context || (0, _context.ReactReduxContext);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(Context.Provider, {
        value: contextValue
    }, children);
}
exports.default = Provider;

},{"react":"6uln9","prop-types":"6FKs7","./Context":"kDZAc","../utils/Subscription":"hafSY","../utils/useIsomorphicLayoutEffect":"bPnBR","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"kDZAc":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactReduxContext", ()=>ReactReduxContext);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var ReactReduxContext = /*#__PURE__*/ (0, _reactDefault.default).createContext(null);
exports.default = ReactReduxContext;

},{"react":"6uln9","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hafSY":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createSubscription", ()=>createSubscription);
var _batch = require("./batch"); // encapsulates the subscription logic for connecting a component to the redux store, as
// well as nesting subscriptions of descendant components, so that we can ensure the
// ancestor components re-render before descendants
function createListenerCollection() {
    var batch = (0, _batch.getBatch)();
    var first = null;
    var last = null;
    return {
        clear: function clear() {
            first = null;
            last = null;
        },
        notify: function notify() {
            batch(function() {
                var listener = first;
                while(listener){
                    listener.callback();
                    listener = listener.next;
                }
            });
        },
        get: function get() {
            var listeners = [];
            var listener = first;
            while(listener){
                listeners.push(listener);
                listener = listener.next;
            }
            return listeners;
        },
        subscribe: function subscribe(callback) {
            var isSubscribed = true;
            var listener = last = {
                callback: callback,
                next: null,
                prev: last
            };
            if (listener.prev) listener.prev.next = listener;
            else first = listener;
            return function unsubscribe() {
                if (!isSubscribed || first === null) return;
                isSubscribed = false;
                if (listener.next) listener.next.prev = listener.prev;
                else last = listener.prev;
                if (listener.prev) listener.prev.next = listener.next;
                else first = listener.next;
            };
        }
    };
}
var nullListeners = {
    notify: function notify() {},
    get: function get() {
        return [];
    }
};
function createSubscription(store, parentSub) {
    var unsubscribe;
    var listeners = nullListeners;
    function addNestedSub(listener) {
        trySubscribe();
        return listeners.subscribe(listener);
    }
    function notifyNestedSubs() {
        listeners.notify();
    }
    function handleChangeWrapper() {
        if (subscription.onStateChange) subscription.onStateChange();
    }
    function isSubscribed() {
        return Boolean(unsubscribe);
    }
    function trySubscribe() {
        if (!unsubscribe) {
            unsubscribe = parentSub ? parentSub.addNestedSub(handleChangeWrapper) : store.subscribe(handleChangeWrapper);
            listeners = createListenerCollection();
        }
    }
    function tryUnsubscribe() {
        if (unsubscribe) {
            unsubscribe();
            unsubscribe = undefined;
            listeners.clear();
            listeners = nullListeners;
        }
    }
    var subscription = {
        addNestedSub: addNestedSub,
        notifyNestedSubs: notifyNestedSubs,
        handleChangeWrapper: handleChangeWrapper,
        isSubscribed: isSubscribed,
        trySubscribe: trySubscribe,
        tryUnsubscribe: tryUnsubscribe,
        getListeners: function getListeners() {
            return listeners;
        }
    };
    return subscription;
}

},{"./batch":"03EVY","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"03EVY":[function(require,module,exports) {
// Default to a dummy "batch" implementation that just runs the callback
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "setBatch", ()=>setBatch);
parcelHelpers.export(exports, "getBatch", ()=>getBatch);
function defaultNoopBatch(callback) {
    callback();
}
var batch = defaultNoopBatch; // Allow injecting another batching function later
var setBatch = function setBatch(newBatch) {
    return batch = newBatch;
}; // Supply a getter just to skip dealing with ESM bindings
var getBatch = function getBatch() {
    return batch;
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"bPnBR":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useIsomorphicLayoutEffect", ()=>useIsomorphicLayoutEffect);
var _react = require("react"); // React currently throws a warning when using useLayoutEffect on the server.
var useIsomorphicLayoutEffect = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined" ? (0, _react.useLayoutEffect) : (0, _react.useEffect);

},{"react":"6uln9","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6vIlB":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>connectAdvanced);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _hoistNonReactStatics = require("hoist-non-react-statics");
var _hoistNonReactStaticsDefault = parcelHelpers.interopDefault(_hoistNonReactStatics);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactIs = require("react-is");
var _subscription = require("../utils/Subscription");
var _useIsomorphicLayoutEffect = require("../utils/useIsomorphicLayoutEffect");
var _context = require("./Context"); // Define some constant arrays just to avoid re-creating these
var _excluded = [
    "getDisplayName",
    "methodName",
    "renderCountProp",
    "shouldHandleStateChanges",
    "storeKey",
    "withRef",
    "forwardRef",
    "context"
], _excluded2 = [
    "reactReduxForwardedRef"
];
var EMPTY_ARRAY = [];
var NO_SUBSCRIPTION_ARRAY = [
    null,
    null
];
var stringifyComponent = function stringifyComponent(Comp) {
    try {
        return JSON.stringify(Comp);
    } catch (err) {
        return String(Comp);
    }
};
function storeStateUpdatesReducer(state, action) {
    var updateCount = state[1];
    return [
        action.payload,
        updateCount + 1
    ];
}
function useIsomorphicLayoutEffectWithArgs(effectFunc, effectArgs, dependencies) {
    (0, _useIsomorphicLayoutEffect.useIsomorphicLayoutEffect)(function() {
        return effectFunc.apply(void 0, effectArgs);
    }, dependencies);
}
function captureWrapperProps(lastWrapperProps, lastChildProps, renderIsScheduled, wrapperProps, actualChildProps, childPropsFromStoreUpdate, notifyNestedSubs) {
    // We want to capture the wrapper props and child props we used for later comparisons
    lastWrapperProps.current = wrapperProps;
    lastChildProps.current = actualChildProps;
    renderIsScheduled.current = false; // If the render was from a store update, clear out that reference and cascade the subscriber update
    if (childPropsFromStoreUpdate.current) {
        childPropsFromStoreUpdate.current = null;
        notifyNestedSubs();
    }
}
function subscribeUpdates(shouldHandleStateChanges, store, subscription, childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, childPropsFromStoreUpdate, notifyNestedSubs, forceComponentUpdateDispatch) {
    // If we're not subscribed to the store, nothing to do here
    if (!shouldHandleStateChanges) return; // Capture values for checking if and when this component unmounts
    var didUnsubscribe = false;
    var lastThrownError = null; // We'll run this callback every time a store subscription update propagates to this component
    var checkForUpdates = function checkForUpdates() {
        if (didUnsubscribe) // Don't run stale listeners.
        // Redux doesn't guarantee unsubscriptions happen until next dispatch.
        return;
        var latestStoreState = store.getState();
        var newChildProps, error;
        try {
            // Actually run the selector with the most recent store state and wrapper props
            // to determine what the child props should be
            newChildProps = childPropsSelector(latestStoreState, lastWrapperProps.current);
        } catch (e) {
            error = e;
            lastThrownError = e;
        }
        if (!error) lastThrownError = null;
         // If the child props haven't changed, nothing to do here - cascade the subscription update
        if (newChildProps === lastChildProps.current) {
            if (!renderIsScheduled.current) notifyNestedSubs();
        } else {
            // Save references to the new child props.  Note that we track the "child props from store update"
            // as a ref instead of a useState/useReducer because we need a way to determine if that value has
            // been processed.  If this went into useState/useReducer, we couldn't clear out the value without
            // forcing another re-render, which we don't want.
            lastChildProps.current = newChildProps;
            childPropsFromStoreUpdate.current = newChildProps;
            renderIsScheduled.current = true; // If the child props _did_ change (or we caught an error), this wrapper component needs to re-render
            forceComponentUpdateDispatch({
                type: "STORE_UPDATED",
                payload: {
                    error: error
                }
            });
        }
    }; // Actually subscribe to the nearest connected ancestor (or store)
    subscription.onStateChange = checkForUpdates;
    subscription.trySubscribe(); // Pull data from the store after first render in case the store has
    // changed since we began.
    checkForUpdates();
    var unsubscribeWrapper = function unsubscribeWrapper() {
        didUnsubscribe = true;
        subscription.tryUnsubscribe();
        subscription.onStateChange = null;
        if (lastThrownError) // It's possible that we caught an error due to a bad mapState function, but the
        // parent re-rendered without this component and we're about to unmount.
        // This shouldn't happen as long as we do top-down subscriptions correctly, but
        // if we ever do those wrong, this throw will surface the error in our tests.
        // In that case, throw the error from here so it doesn't get lost.
        throw lastThrownError;
    };
    return unsubscribeWrapper;
}
var initStateUpdates = function initStateUpdates() {
    return [
        null,
        0
    ];
};
function connectAdvanced(/*
  selectorFactory is a func that is responsible for returning the selector function used to
  compute new props from state, props, and dispatch. For example:
      export default connectAdvanced((dispatch, options) => (state, props) => ({
      thing: state.things[props.thingId],
      saveThing: fields => dispatch(actionCreators.saveThing(props.thingId, fields)),
    }))(YourComponent)
    Access to dispatch is provided to the factory so selectorFactories can bind actionCreators
  outside of their selector as an optimization. Options passed to connectAdvanced are passed to
  the selectorFactory, along with displayName and WrappedComponent, as the second argument.
    Note that selectorFactory is responsible for all caching/memoization of inbound and outbound
  props. Do not use connectAdvanced directly without memoizing results between calls to your
  selector, otherwise the Connect component will re-render on every state or props change.
*/ selectorFactory, _ref) {
    if (_ref === void 0) _ref = {};
    var _ref2 = _ref, _ref2$getDisplayName = _ref2.getDisplayName, getDisplayName = _ref2$getDisplayName === void 0 ? function(name) {
        return "ConnectAdvanced(" + name + ")";
    } : _ref2$getDisplayName, _ref2$methodName = _ref2.methodName, methodName = _ref2$methodName === void 0 ? "connectAdvanced" : _ref2$methodName, _ref2$renderCountProp = _ref2.renderCountProp, renderCountProp = _ref2$renderCountProp === void 0 ? undefined : _ref2$renderCountProp, _ref2$shouldHandleSta = _ref2.shouldHandleStateChanges, shouldHandleStateChanges = _ref2$shouldHandleSta === void 0 ? true : _ref2$shouldHandleSta, _ref2$storeKey = _ref2.storeKey, storeKey = _ref2$storeKey === void 0 ? "store" : _ref2$storeKey, _ref2$withRef = _ref2.withRef, withRef = _ref2$withRef === void 0 ? false : _ref2$withRef, _ref2$forwardRef = _ref2.forwardRef, forwardRef = _ref2$forwardRef === void 0 ? false : _ref2$forwardRef, _ref2$context = _ref2.context, context = _ref2$context === void 0 ? (0, _context.ReactReduxContext) : _ref2$context, connectOptions = (0, _objectWithoutPropertiesLooseDefault.default)(_ref2, _excluded);
    var customStoreWarningMessage;
    var Context = context;
    return function wrapWithConnect(WrappedComponent) {
        var wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || "Component";
        var displayName = getDisplayName(wrappedComponentName);
        var selectorFactoryOptions = (0, _extendsDefault.default)({}, connectOptions, {
            getDisplayName: getDisplayName,
            methodName: methodName,
            renderCountProp: renderCountProp,
            shouldHandleStateChanges: shouldHandleStateChanges,
            storeKey: storeKey,
            displayName: displayName,
            wrappedComponentName: wrappedComponentName,
            WrappedComponent: WrappedComponent
        });
        var pure = connectOptions.pure;
        function createChildSelector(store) {
            return selectorFactory(store.dispatch, selectorFactoryOptions);
        } // If we aren't running in "pure" mode, we don't want to memoize values.
        // To avoid conditionally calling hooks, we fall back to a tiny wrapper
        // that just executes the given callback immediately.
        var usePureOnlyMemo = pure ? (0, _react.useMemo) : function(callback) {
            return callback();
        };
        function ConnectFunction(props) {
            var _useMemo = (0, _react.useMemo)(function() {
                // Distinguish between actual "data" props that were passed to the wrapper component,
                // and values needed to control behavior (forwarded refs, alternate context instances).
                // To maintain the wrapperProps object reference, memoize this destructuring.
                var reactReduxForwardedRef = props.reactReduxForwardedRef, wrapperProps = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded2);
                return [
                    props.context,
                    reactReduxForwardedRef,
                    wrapperProps
                ];
            }, [
                props
            ]), propsContext = _useMemo[0], reactReduxForwardedRef = _useMemo[1], wrapperProps = _useMemo[2];
            var ContextToUse = (0, _react.useMemo)(function() {
                // Users may optionally pass in a custom context instance to use instead of our ReactReduxContext.
                // Memoize the check that determines which context instance we should use.
                return propsContext && propsContext.Consumer && (0, _reactIs.isContextConsumer)(/*#__PURE__*/ (0, _reactDefault.default).createElement(propsContext.Consumer, null)) ? propsContext : Context;
            }, [
                propsContext,
                Context
            ]); // Retrieve the store and ancestor subscription via context, if available
            var contextValue = (0, _react.useContext)(ContextToUse); // The store _must_ exist as either a prop or in context.
            // We'll check to see if it _looks_ like a Redux store first.
            // This allows us to pass through a `store` prop that is just a plain value.
            var didStoreComeFromProps = Boolean(props.store) && Boolean(props.store.getState) && Boolean(props.store.dispatch);
            var didStoreComeFromContext = Boolean(contextValue) && Boolean(contextValue.store);
            var store = didStoreComeFromProps ? props.store : contextValue.store;
            var childPropsSelector = (0, _react.useMemo)(function() {
                // The child props selector needs the store reference as an input.
                // Re-create this selector whenever the store changes.
                return createChildSelector(store);
            }, [
                store
            ]);
            var _useMemo2 = (0, _react.useMemo)(function() {
                if (!shouldHandleStateChanges) return NO_SUBSCRIPTION_ARRAY; // This Subscription's source should match where store came from: props vs. context. A component
                // connected to the store via props shouldn't use subscription from context, or vice versa.
                // This Subscription's source should match where store came from: props vs. context. A component
                // connected to the store via props shouldn't use subscription from context, or vice versa.
                var subscription = (0, _subscription.createSubscription)(store, didStoreComeFromProps ? null : contextValue.subscription); // `notifyNestedSubs` is duplicated to handle the case where the component is unmounted in
                // the middle of the notification loop, where `subscription` will then be null. This can
                // probably be avoided if Subscription's listeners logic is changed to not call listeners
                // that have been unsubscribed in the  middle of the notification loop.
                // `notifyNestedSubs` is duplicated to handle the case where the component is unmounted in
                // the middle of the notification loop, where `subscription` will then be null. This can
                // probably be avoided if Subscription's listeners logic is changed to not call listeners
                // that have been unsubscribed in the  middle of the notification loop.
                var notifyNestedSubs = subscription.notifyNestedSubs.bind(subscription);
                return [
                    subscription,
                    notifyNestedSubs
                ];
            }, [
                store,
                didStoreComeFromProps,
                contextValue
            ]), subscription = _useMemo2[0], notifyNestedSubs = _useMemo2[1]; // Determine what {store, subscription} value should be put into nested context, if necessary,
            // and memoize that value to avoid unnecessary context updates.
            var overriddenContextValue = (0, _react.useMemo)(function() {
                if (didStoreComeFromProps) // This component is directly subscribed to a store from props.
                // We don't want descendants reading from this store - pass down whatever
                // the existing context value is from the nearest connected ancestor.
                return contextValue;
                 // Otherwise, put this component's subscription instance into context, so that
                // connected descendants won't update until after this component is done
                return (0, _extendsDefault.default)({}, contextValue, {
                    subscription: subscription
                });
            }, [
                didStoreComeFromProps,
                contextValue,
                subscription
            ]); // We need to force this wrapper component to re-render whenever a Redux store update
            // causes a change to the calculated child component props (or we caught an error in mapState)
            var _useReducer = (0, _react.useReducer)(storeStateUpdatesReducer, EMPTY_ARRAY, initStateUpdates), _useReducer$ = _useReducer[0], previousStateUpdateResult = _useReducer$[0], forceComponentUpdateDispatch = _useReducer[1]; // Propagate any mapState/mapDispatch errors upwards
            if (previousStateUpdateResult && previousStateUpdateResult.error) throw previousStateUpdateResult.error;
             // Set up refs to coordinate values between the subscription effect and the render logic
            var lastChildProps = (0, _react.useRef)();
            var lastWrapperProps = (0, _react.useRef)(wrapperProps);
            var childPropsFromStoreUpdate = (0, _react.useRef)();
            var renderIsScheduled = (0, _react.useRef)(false);
            var actualChildProps = usePureOnlyMemo(function() {
                // Tricky logic here:
                // - This render may have been triggered by a Redux store update that produced new child props
                // - However, we may have gotten new wrapper props after that
                // If we have new child props, and the same wrapper props, we know we should use the new child props as-is.
                // But, if we have new wrapper props, those might change the child props, so we have to recalculate things.
                // So, we'll use the child props from store update only if the wrapper props are the same as last time.
                if (childPropsFromStoreUpdate.current && wrapperProps === lastWrapperProps.current) return childPropsFromStoreUpdate.current;
                 // TODO We're reading the store directly in render() here. Bad idea?
                // This will likely cause Bad Things (TM) to happen in Concurrent Mode.
                // Note that we do this because on renders _not_ caused by store updates, we need the latest store state
                // to determine what the child props should be.
                return childPropsSelector(store.getState(), wrapperProps);
            }, [
                store,
                previousStateUpdateResult,
                wrapperProps
            ]); // We need this to execute synchronously every time we re-render. However, React warns
            // about useLayoutEffect in SSR, so we try to detect environment and fall back to
            // just useEffect instead to avoid the warning, since neither will run anyway.
            useIsomorphicLayoutEffectWithArgs(captureWrapperProps, [
                lastWrapperProps,
                lastChildProps,
                renderIsScheduled,
                wrapperProps,
                actualChildProps,
                childPropsFromStoreUpdate,
                notifyNestedSubs
            ]); // Our re-subscribe logic only runs when the store/subscription setup changes
            useIsomorphicLayoutEffectWithArgs(subscribeUpdates, [
                shouldHandleStateChanges,
                store,
                subscription,
                childPropsSelector,
                lastWrapperProps,
                lastChildProps,
                renderIsScheduled,
                childPropsFromStoreUpdate,
                notifyNestedSubs,
                forceComponentUpdateDispatch
            ], [
                store,
                subscription,
                childPropsSelector
            ]); // Now that all that's done, we can finally try to actually render the child component.
            // We memoize the elements for the rendered child component as an optimization.
            var renderedWrappedComponent = (0, _react.useMemo)(function() {
                return /*#__PURE__*/ (0, _reactDefault.default).createElement(WrappedComponent, (0, _extendsDefault.default)({}, actualChildProps, {
                    ref: reactReduxForwardedRef
                }));
            }, [
                reactReduxForwardedRef,
                WrappedComponent,
                actualChildProps
            ]); // If React sees the exact same element reference as last time, it bails out of re-rendering
            // that child, same as if it was wrapped in React.memo() or returned false from shouldComponentUpdate.
            var renderedChild = (0, _react.useMemo)(function() {
                if (shouldHandleStateChanges) // If this component is subscribed to store updates, we need to pass its own
                // subscription instance down to our descendants. That means rendering the same
                // Context instance, and putting a different value into the context.
                return /*#__PURE__*/ (0, _reactDefault.default).createElement(ContextToUse.Provider, {
                    value: overriddenContextValue
                }, renderedWrappedComponent);
                return renderedWrappedComponent;
            }, [
                ContextToUse,
                renderedWrappedComponent,
                overriddenContextValue
            ]);
            return renderedChild;
        } // If we're in "pure" mode, ensure our wrapper component only re-renders when incoming props have changed.
        var Connect = pure ? (0, _reactDefault.default).memo(ConnectFunction) : ConnectFunction;
        Connect.WrappedComponent = WrappedComponent;
        Connect.displayName = ConnectFunction.displayName = displayName;
        if (forwardRef) {
            var forwarded = (0, _reactDefault.default).forwardRef(function forwardConnectRef(props, ref) {
                return /*#__PURE__*/ (0, _reactDefault.default).createElement(Connect, (0, _extendsDefault.default)({}, props, {
                    reactReduxForwardedRef: ref
                }));
            });
            forwarded.displayName = displayName;
            forwarded.WrappedComponent = WrappedComponent;
            return (0, _hoistNonReactStaticsDefault.default)(forwarded, WrappedComponent);
        }
        return (0, _hoistNonReactStaticsDefault.default)(Connect, WrappedComponent);
    };
}

},{"@babel/runtime/helpers/esm/extends":"fW5l8","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"5R6Zx","hoist-non-react-statics":"3bvdc","react":"6uln9","react-is":"80dO6","../utils/Subscription":"hafSY","../utils/useIsomorphicLayoutEffect":"bPnBR","./Context":"kDZAc","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"80dO6":[function(require,module,exports) {
"use strict";
module.exports = require("99eed460ea409d0");

},{"99eed460ea409d0":"abqI2"}],"abqI2":[function(require,module,exports) {
/** @license React v17.0.2
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var b = 60103, c = 60106, d = 60107, e = 60108, f = 60114, g = 60109, h = 60110, k = 60112, l = 60113, m = 60120, n = 60115, p = 60116, q = 60121, r = 60122, u = 60117, v = 60129, w = 60131;
if ("function" === typeof Symbol && Symbol.for) {
    var x = Symbol.for;
    b = x("react.element");
    c = x("react.portal");
    d = x("react.fragment");
    e = x("react.strict_mode");
    f = x("react.profiler");
    g = x("react.provider");
    h = x("react.context");
    k = x("react.forward_ref");
    l = x("react.suspense");
    m = x("react.suspense_list");
    n = x("react.memo");
    p = x("react.lazy");
    q = x("react.block");
    r = x("react.server.block");
    u = x("react.fundamental");
    v = x("react.debug_trace_mode");
    w = x("react.legacy_hidden");
}
function y(a) {
    if ("object" === typeof a && null !== a) {
        var t = a.$$typeof;
        switch(t){
            case b:
                switch(a = a.type, a){
                    case d:
                    case f:
                    case e:
                    case l:
                    case m:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case h:
                            case k:
                            case p:
                            case n:
                            case g:
                                return a;
                            default:
                                return t;
                        }
                }
            case c:
                return t;
        }
    }
}
var z = g, A = b, B = k, C = d, D = p, E = n, F = c, G = f, H = e, I = l;
exports.ContextConsumer = h;
exports.ContextProvider = z;
exports.Element = A;
exports.ForwardRef = B;
exports.Fragment = C;
exports.Lazy = D;
exports.Memo = E;
exports.Portal = F;
exports.Profiler = G;
exports.StrictMode = H;
exports.Suspense = I;
exports.isAsyncMode = function() {
    return !1;
};
exports.isConcurrentMode = function() {
    return !1;
};
exports.isContextConsumer = function(a) {
    return y(a) === h;
};
exports.isContextProvider = function(a) {
    return y(a) === g;
};
exports.isElement = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === b;
};
exports.isForwardRef = function(a) {
    return y(a) === k;
};
exports.isFragment = function(a) {
    return y(a) === d;
};
exports.isLazy = function(a) {
    return y(a) === p;
};
exports.isMemo = function(a) {
    return y(a) === n;
};
exports.isPortal = function(a) {
    return y(a) === c;
};
exports.isProfiler = function(a) {
    return y(a) === f;
};
exports.isStrictMode = function(a) {
    return y(a) === e;
};
exports.isSuspense = function(a) {
    return y(a) === l;
};
exports.isValidElementType = function(a) {
    return "string" === typeof a || "function" === typeof a || a === d || a === f || a === v || a === e || a === l || a === m || a === w || "object" === typeof a && null !== a && (a.$$typeof === p || a.$$typeof === n || a.$$typeof === g || a.$$typeof === h || a.$$typeof === k || a.$$typeof === u || a.$$typeof === q || a[0] === r) ? !0 : !1;
};
exports.typeOf = y;

},{}],"KFTfv":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// different options opens up some testing and extensibility scenarios
parcelHelpers.export(exports, "createConnect", ()=>createConnect);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _connectAdvanced = require("../components/connectAdvanced");
var _connectAdvancedDefault = parcelHelpers.interopDefault(_connectAdvanced);
var _shallowEqual = require("../utils/shallowEqual");
var _shallowEqualDefault = parcelHelpers.interopDefault(_shallowEqual);
var _mapDispatchToProps = require("./mapDispatchToProps");
var _mapDispatchToPropsDefault = parcelHelpers.interopDefault(_mapDispatchToProps);
var _mapStateToProps = require("./mapStateToProps");
var _mapStateToPropsDefault = parcelHelpers.interopDefault(_mapStateToProps);
var _mergeProps = require("./mergeProps");
var _mergePropsDefault = parcelHelpers.interopDefault(_mergeProps);
var _selectorFactory = require("./selectorFactory");
var _selectorFactoryDefault = parcelHelpers.interopDefault(_selectorFactory);
var _excluded = [
    "pure",
    "areStatesEqual",
    "areOwnPropsEqual",
    "areStatePropsEqual",
    "areMergedPropsEqual"
];
/*
  connect is a facade over connectAdvanced. It turns its args into a compatible
  selectorFactory, which has the signature:

    (dispatch, options) => (nextState, nextOwnProps) => nextFinalProps
  
  connect passes its args to connectAdvanced as options, which will in turn pass them to
  selectorFactory each time a Connect component instance is instantiated or hot reloaded.

  selectorFactory returns a final props selector from its mapStateToProps,
  mapStateToPropsFactories, mapDispatchToProps, mapDispatchToPropsFactories, mergeProps,
  mergePropsFactories, and pure args.

  The resulting final props selector is called by the Connect component instance whenever
  it receives new props or store state.
 */ function match(arg, factories, name) {
    for(var i = factories.length - 1; i >= 0; i--){
        var result = factories[i](arg);
        if (result) return result;
    }
    return function(dispatch, options) {
        throw new Error("Invalid value of type " + typeof arg + " for " + name + " argument when connecting component " + options.wrappedComponentName + ".");
    };
}
function strictEqual(a, b) {
    return a === b;
} // createConnect with default args builds the 'official' connect behavior. Calling it with
function createConnect(_temp) {
    var _ref = _temp === void 0 ? {} : _temp, _ref$connectHOC = _ref.connectHOC, connectHOC = _ref$connectHOC === void 0 ? (0, _connectAdvancedDefault.default) : _ref$connectHOC, _ref$mapStateToPropsF = _ref.mapStateToPropsFactories, mapStateToPropsFactories = _ref$mapStateToPropsF === void 0 ? (0, _mapStateToPropsDefault.default) : _ref$mapStateToPropsF, _ref$mapDispatchToPro = _ref.mapDispatchToPropsFactories, mapDispatchToPropsFactories = _ref$mapDispatchToPro === void 0 ? (0, _mapDispatchToPropsDefault.default) : _ref$mapDispatchToPro, _ref$mergePropsFactor = _ref.mergePropsFactories, mergePropsFactories = _ref$mergePropsFactor === void 0 ? (0, _mergePropsDefault.default) : _ref$mergePropsFactor, _ref$selectorFactory = _ref.selectorFactory, selectorFactory = _ref$selectorFactory === void 0 ? (0, _selectorFactoryDefault.default) : _ref$selectorFactory;
    return function connect(mapStateToProps, mapDispatchToProps, mergeProps, _ref2) {
        if (_ref2 === void 0) _ref2 = {};
        var _ref3 = _ref2, _ref3$pure = _ref3.pure, pure = _ref3$pure === void 0 ? true : _ref3$pure, _ref3$areStatesEqual = _ref3.areStatesEqual, areStatesEqual = _ref3$areStatesEqual === void 0 ? strictEqual : _ref3$areStatesEqual, _ref3$areOwnPropsEqua = _ref3.areOwnPropsEqual, areOwnPropsEqual = _ref3$areOwnPropsEqua === void 0 ? (0, _shallowEqualDefault.default) : _ref3$areOwnPropsEqua, _ref3$areStatePropsEq = _ref3.areStatePropsEqual, areStatePropsEqual = _ref3$areStatePropsEq === void 0 ? (0, _shallowEqualDefault.default) : _ref3$areStatePropsEq, _ref3$areMergedPropsE = _ref3.areMergedPropsEqual, areMergedPropsEqual = _ref3$areMergedPropsE === void 0 ? (0, _shallowEqualDefault.default) : _ref3$areMergedPropsE, extraOptions = (0, _objectWithoutPropertiesLooseDefault.default)(_ref3, _excluded);
        var initMapStateToProps = match(mapStateToProps, mapStateToPropsFactories, "mapStateToProps");
        var initMapDispatchToProps = match(mapDispatchToProps, mapDispatchToPropsFactories, "mapDispatchToProps");
        var initMergeProps = match(mergeProps, mergePropsFactories, "mergeProps");
        return connectHOC(selectorFactory, (0, _extendsDefault.default)({
            // used in error messages
            methodName: "connect",
            // used to compute Connect's displayName from the wrapped component's displayName.
            getDisplayName: function getDisplayName(name) {
                return "Connect(" + name + ")";
            },
            // if mapStateToProps is falsy, the Connect component doesn't subscribe to store state changes
            shouldHandleStateChanges: Boolean(mapStateToProps),
            // passed through to selectorFactory
            initMapStateToProps: initMapStateToProps,
            initMapDispatchToProps: initMapDispatchToProps,
            initMergeProps: initMergeProps,
            pure: pure,
            areStatesEqual: areStatesEqual,
            areOwnPropsEqual: areOwnPropsEqual,
            areStatePropsEqual: areStatePropsEqual,
            areMergedPropsEqual: areMergedPropsEqual
        }, extraOptions));
    };
}
exports.default = /*#__PURE__*/ createConnect();

},{"@babel/runtime/helpers/esm/extends":"fW5l8","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"5R6Zx","../components/connectAdvanced":"6vIlB","../utils/shallowEqual":"NluBY","./mapDispatchToProps":"kGEMF","./mapStateToProps":"g1i6e","./mergeProps":"aDaIM","./selectorFactory":"gRKJ2","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"NluBY":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>shallowEqual);
function is(x, y) {
    if (x === y) return x !== 0 || y !== 0 || 1 / x === 1 / y;
    else return x !== x && y !== y;
}
function shallowEqual(objA, objB) {
    if (is(objA, objB)) return true;
    if (typeof objA !== "object" || objA === null || typeof objB !== "object" || objB === null) return false;
    var keysA = Object.keys(objA);
    var keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    for(var i = 0; i < keysA.length; i++){
        if (!Object.prototype.hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) return false;
    }
    return true;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"kGEMF":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "whenMapDispatchToPropsIsFunction", ()=>whenMapDispatchToPropsIsFunction);
parcelHelpers.export(exports, "whenMapDispatchToPropsIsMissing", ()=>whenMapDispatchToPropsIsMissing);
parcelHelpers.export(exports, "whenMapDispatchToPropsIsObject", ()=>whenMapDispatchToPropsIsObject);
var _bindActionCreators = require("../utils/bindActionCreators");
var _bindActionCreatorsDefault = parcelHelpers.interopDefault(_bindActionCreators);
var _wrapMapToProps = require("./wrapMapToProps");
function whenMapDispatchToPropsIsFunction(mapDispatchToProps) {
    return typeof mapDispatchToProps === "function" ? (0, _wrapMapToProps.wrapMapToPropsFunc)(mapDispatchToProps, "mapDispatchToProps") : undefined;
}
function whenMapDispatchToPropsIsMissing(mapDispatchToProps) {
    return !mapDispatchToProps ? (0, _wrapMapToProps.wrapMapToPropsConstant)(function(dispatch) {
        return {
            dispatch: dispatch
        };
    }) : undefined;
}
function whenMapDispatchToPropsIsObject(mapDispatchToProps) {
    return mapDispatchToProps && typeof mapDispatchToProps === "object" ? (0, _wrapMapToProps.wrapMapToPropsConstant)(function(dispatch) {
        return (0, _bindActionCreatorsDefault.default)(mapDispatchToProps, dispatch);
    }) : undefined;
}
exports.default = [
    whenMapDispatchToPropsIsFunction,
    whenMapDispatchToPropsIsMissing,
    whenMapDispatchToPropsIsObject
];

},{"../utils/bindActionCreators":"hiC2W","./wrapMapToProps":"bjL3M","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hiC2W":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>bindActionCreators);
function bindActionCreators(actionCreators, dispatch) {
    var boundActionCreators = {};
    var _loop = function _loop(key) {
        var actionCreator = actionCreators[key];
        if (typeof actionCreator === "function") boundActionCreators[key] = function() {
            return dispatch(actionCreator.apply(void 0, arguments));
        };
    };
    for(var key in actionCreators)_loop(key);
    return boundActionCreators;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"bjL3M":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "wrapMapToPropsConstant", ()=>wrapMapToPropsConstant) // dependsOnOwnProps is used by createMapToPropsProxy to determine whether to pass props as args
;
// to the mapToProps function being wrapped. It is also used by makePurePropsSelector to determine
// whether mapToProps needs to be invoked when props have changed.
//
// A length of one signals that mapToProps does not depend on props from the parent component.
// A length of zero is assumed to mean mapToProps is getting args via arguments or ...args and
// therefore not reporting its length accurately..
parcelHelpers.export(exports, "getDependsOnOwnProps", ()=>getDependsOnOwnProps) // Used by whenMapStateToPropsIsFunction and whenMapDispatchToPropsIsFunction,
;
// this function wraps mapToProps in a proxy function which does several things:
//
//  * Detects whether the mapToProps function being called depends on props, which
//    is used by selectorFactory to decide if it should reinvoke on props changes.
//
//  * On first call, handles mapToProps if returns another function, and treats that
//    new function as the true mapToProps for subsequent calls.
//
//  * On first call, verifies the first result is a plain object, in order to warn
//    the developer that their mapToProps function is not returning a valid result.
//
parcelHelpers.export(exports, "wrapMapToPropsFunc", ()=>wrapMapToPropsFunc);
var _verifyPlainObject = require("../utils/verifyPlainObject");
var _verifyPlainObjectDefault = parcelHelpers.interopDefault(_verifyPlainObject);
function wrapMapToPropsConstant(getConstant) {
    return function initConstantSelector(dispatch, options) {
        var constant = getConstant(dispatch, options);
        function constantSelector() {
            return constant;
        }
        constantSelector.dependsOnOwnProps = false;
        return constantSelector;
    };
}
function getDependsOnOwnProps(mapToProps) {
    return mapToProps.dependsOnOwnProps !== null && mapToProps.dependsOnOwnProps !== undefined ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
}
function wrapMapToPropsFunc(mapToProps, methodName) {
    return function initProxySelector(dispatch, _ref) {
        var displayName = _ref.displayName;
        var proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
            return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch);
        }; // allow detectFactoryAndVerify to get ownProps
        proxy.dependsOnOwnProps = true;
        proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
            proxy.mapToProps = mapToProps;
            proxy.dependsOnOwnProps = getDependsOnOwnProps(mapToProps);
            var props = proxy(stateOrDispatch, ownProps);
            if (typeof props === "function") {
                proxy.mapToProps = props;
                proxy.dependsOnOwnProps = getDependsOnOwnProps(props);
                props = proxy(stateOrDispatch, ownProps);
            }
            return props;
        };
        return proxy;
    };
}

},{"../utils/verifyPlainObject":"5fQVU","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"5fQVU":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>verifyPlainObject);
var _isPlainObject = require("./isPlainObject");
var _isPlainObjectDefault = parcelHelpers.interopDefault(_isPlainObject);
var _warning = require("./warning");
var _warningDefault = parcelHelpers.interopDefault(_warning);
function verifyPlainObject(value, displayName, methodName) {
    if (!(0, _isPlainObjectDefault.default)(value)) (0, _warningDefault.default)(methodName + "() in " + displayName + " must return a plain object. Instead received " + value + ".");
}

},{"./isPlainObject":"dg4gI","./warning":"eA2jP","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"dg4gI":[function(require,module,exports) {
/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>isPlainObject);
function isPlainObject(obj) {
    if (typeof obj !== "object" || obj === null) return false;
    var proto = Object.getPrototypeOf(obj);
    if (proto === null) return true;
    var baseProto = proto;
    while(Object.getPrototypeOf(baseProto) !== null)baseProto = Object.getPrototypeOf(baseProto);
    return proto === baseProto;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"eA2jP":[function(require,module,exports) {
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>warning);
function warning(message) {
    /* eslint-disable no-console */ if (typeof console !== "undefined" && typeof console.error === "function") console.error(message);
    /* eslint-enable no-console */ try {
        // This error was thrown as a convenience so that if you enable
        // "break on all exceptions" in your console,
        // it would pause the execution at this line.
        throw new Error(message);
    /* eslint-disable no-empty */ } catch (e) {}
/* eslint-enable no-empty */ }

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"g1i6e":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "whenMapStateToPropsIsFunction", ()=>whenMapStateToPropsIsFunction);
parcelHelpers.export(exports, "whenMapStateToPropsIsMissing", ()=>whenMapStateToPropsIsMissing);
var _wrapMapToProps = require("./wrapMapToProps");
function whenMapStateToPropsIsFunction(mapStateToProps) {
    return typeof mapStateToProps === "function" ? (0, _wrapMapToProps.wrapMapToPropsFunc)(mapStateToProps, "mapStateToProps") : undefined;
}
function whenMapStateToPropsIsMissing(mapStateToProps) {
    return !mapStateToProps ? (0, _wrapMapToProps.wrapMapToPropsConstant)(function() {
        return {};
    }) : undefined;
}
exports.default = [
    whenMapStateToPropsIsFunction,
    whenMapStateToPropsIsMissing
];

},{"./wrapMapToProps":"bjL3M","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"aDaIM":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "defaultMergeProps", ()=>defaultMergeProps);
parcelHelpers.export(exports, "wrapMergePropsFunc", ()=>wrapMergePropsFunc);
parcelHelpers.export(exports, "whenMergePropsIsFunction", ()=>whenMergePropsIsFunction);
parcelHelpers.export(exports, "whenMergePropsIsOmitted", ()=>whenMergePropsIsOmitted);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _verifyPlainObject = require("../utils/verifyPlainObject");
var _verifyPlainObjectDefault = parcelHelpers.interopDefault(_verifyPlainObject);
function defaultMergeProps(stateProps, dispatchProps, ownProps) {
    return (0, _extendsDefault.default)({}, ownProps, stateProps, dispatchProps);
}
function wrapMergePropsFunc(mergeProps) {
    return function initMergePropsProxy(dispatch, _ref) {
        var displayName = _ref.displayName, pure = _ref.pure, areMergedPropsEqual = _ref.areMergedPropsEqual;
        var hasRunOnce = false;
        var mergedProps;
        return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
            var nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);
            if (hasRunOnce) {
                if (!pure || !areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
            } else {
                hasRunOnce = true;
                mergedProps = nextMergedProps;
            }
            return mergedProps;
        };
    };
}
function whenMergePropsIsFunction(mergeProps) {
    return typeof mergeProps === "function" ? wrapMergePropsFunc(mergeProps) : undefined;
}
function whenMergePropsIsOmitted(mergeProps) {
    return !mergeProps ? function() {
        return defaultMergeProps;
    } : undefined;
}
exports.default = [
    whenMergePropsIsFunction,
    whenMergePropsIsOmitted
];

},{"@babel/runtime/helpers/esm/extends":"fW5l8","../utils/verifyPlainObject":"5fQVU","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"gRKJ2":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "impureFinalPropsSelectorFactory", ()=>impureFinalPropsSelectorFactory);
parcelHelpers.export(exports, "pureFinalPropsSelectorFactory", ()=>pureFinalPropsSelectorFactory) // TODO: Add more comments
;
parcelHelpers.export(exports, "default", ()=>finalPropsSelectorFactory);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _verifySubselectors = require("./verifySubselectors");
var _verifySubselectorsDefault = parcelHelpers.interopDefault(_verifySubselectors);
var _excluded = [
    "initMapStateToProps",
    "initMapDispatchToProps",
    "initMergeProps"
];
function impureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch) {
    return function impureFinalPropsSelector(state, ownProps) {
        return mergeProps(mapStateToProps(state, ownProps), mapDispatchToProps(dispatch, ownProps), ownProps);
    };
}
function pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, _ref) {
    var areStatesEqual = _ref.areStatesEqual, areOwnPropsEqual = _ref.areOwnPropsEqual, areStatePropsEqual = _ref.areStatePropsEqual;
    var hasRunAtLeastOnce = false;
    var state;
    var ownProps;
    var stateProps;
    var dispatchProps;
    var mergedProps;
    function handleFirstCall(firstState, firstOwnProps) {
        state = firstState;
        ownProps = firstOwnProps;
        stateProps = mapStateToProps(state, ownProps);
        dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        hasRunAtLeastOnce = true;
        return mergedProps;
    }
    function handleNewPropsAndNewState() {
        stateProps = mapStateToProps(state, ownProps);
        if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleNewProps() {
        if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);
        if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleNewState() {
        var nextStateProps = mapStateToProps(state, ownProps);
        var statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
        stateProps = nextStateProps;
        if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleSubsequentCalls(nextState, nextOwnProps) {
        var propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
        var stateChanged = !areStatesEqual(nextState, state, nextOwnProps, ownProps);
        state = nextState;
        ownProps = nextOwnProps;
        if (propsChanged && stateChanged) return handleNewPropsAndNewState();
        if (propsChanged) return handleNewProps();
        if (stateChanged) return handleNewState();
        return mergedProps;
    }
    return function pureFinalPropsSelector(nextState, nextOwnProps) {
        return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
    };
}
function finalPropsSelectorFactory(dispatch, _ref2) {
    var initMapStateToProps = _ref2.initMapStateToProps, initMapDispatchToProps = _ref2.initMapDispatchToProps, initMergeProps = _ref2.initMergeProps, options = (0, _objectWithoutPropertiesLooseDefault.default)(_ref2, _excluded);
    var mapStateToProps = initMapStateToProps(dispatch, options);
    var mapDispatchToProps = initMapDispatchToProps(dispatch, options);
    var mergeProps = initMergeProps(dispatch, options);
    var selectorFactory = options.pure ? pureFinalPropsSelectorFactory : impureFinalPropsSelectorFactory;
    return selectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
}

},{"@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"5R6Zx","./verifySubselectors":"hOq5O","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hOq5O":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>verifySubselectors);
var _warning = require("../utils/warning");
var _warningDefault = parcelHelpers.interopDefault(_warning);
function verify(selector, methodName, displayName) {
    if (!selector) throw new Error("Unexpected value for " + methodName + " in " + displayName + ".");
    else if (methodName === "mapStateToProps" || methodName === "mapDispatchToProps") {
        if (!Object.prototype.hasOwnProperty.call(selector, "dependsOnOwnProps")) (0, _warningDefault.default)("The selector for " + methodName + " of " + displayName + " did not specify a value for dependsOnOwnProps.");
    }
}
function verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps, displayName) {
    verify(mapStateToProps, "mapStateToProps", displayName);
    verify(mapDispatchToProps, "mapDispatchToProps", displayName);
    verify(mergeProps, "mergeProps", displayName);
}

},{"../utils/warning":"eA2jP","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8dGqk":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Hook factory, which creates a `useDispatch` hook bound to a given context.
 *
 * @param {React.Context} [context=ReactReduxContext] Context passed to your `<Provider>`.
 * @returns {Function} A `useDispatch` hook bound to the specified context.
 */ parcelHelpers.export(exports, "createDispatchHook", ()=>createDispatchHook);
parcelHelpers.export(exports, "useDispatch", ()=>useDispatch);
var _context = require("../components/Context");
var _useStore = require("./useStore");
function createDispatchHook(context) {
    if (context === void 0) context = (0, _context.ReactReduxContext);
    var useStore = context === (0, _context.ReactReduxContext) ? (0, _useStore.useStore) : (0, _useStore.createStoreHook)(context);
    return function useDispatch() {
        var store = useStore();
        return store.dispatch;
    };
}
var useDispatch = /*#__PURE__*/ createDispatchHook();

},{"../components/Context":"kDZAc","./useStore":"9ZMKr","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9ZMKr":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Hook factory, which creates a `useStore` hook bound to a given context.
 *
 * @param {React.Context} [context=ReactReduxContext] Context passed to your `<Provider>`.
 * @returns {Function} A `useStore` hook bound to the specified context.
 */ parcelHelpers.export(exports, "createStoreHook", ()=>createStoreHook);
parcelHelpers.export(exports, "useStore", ()=>useStore);
var _react = require("react");
var _context = require("../components/Context");
var _useReduxContext = require("./useReduxContext");
function createStoreHook(context) {
    if (context === void 0) context = (0, _context.ReactReduxContext);
    var useReduxContext = context === (0, _context.ReactReduxContext) ? (0, _useReduxContext.useReduxContext) : function() {
        return (0, _react.useContext)(context);
    };
    return function useStore() {
        var _useReduxContext = useReduxContext(), store = _useReduxContext.store;
        return store;
    };
}
var useStore = /*#__PURE__*/ createStoreHook();

},{"react":"6uln9","../components/Context":"kDZAc","./useReduxContext":"fRs7q","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"fRs7q":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * A hook to access the value of the `ReactReduxContext`. This is a low-level
 * hook that you should usually not need to call directly.
 *
 * @returns {any} the value of the `ReactReduxContext`
 *
 * @example
 *
 * import React from 'react'
 * import { useReduxContext } from 'react-redux'
 *
 * export const CounterComponent = ({ value }) => {
 *   const { store } = useReduxContext()
 *   return <div>{store.getState()}</div>
 * }
 */ parcelHelpers.export(exports, "useReduxContext", ()=>useReduxContext);
var _react = require("react");
var _context = require("../components/Context");
function useReduxContext() {
    var contextValue = (0, _react.useContext)((0, _context.ReactReduxContext));
    return contextValue;
}

},{"react":"6uln9","../components/Context":"kDZAc","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8wADB":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Hook factory, which creates a `useSelector` hook bound to a given context.
 *
 * @param {React.Context} [context=ReactReduxContext] Context passed to your `<Provider>`.
 * @returns {Function} A `useSelector` hook bound to the specified context.
 */ parcelHelpers.export(exports, "createSelectorHook", ()=>createSelectorHook);
parcelHelpers.export(exports, "useSelector", ()=>useSelector);
var _react = require("react");
var _useReduxContext = require("./useReduxContext");
var _subscription = require("../utils/Subscription");
var _useIsomorphicLayoutEffect = require("../utils/useIsomorphicLayoutEffect");
var _context = require("../components/Context");
var refEquality = function refEquality(a, b) {
    return a === b;
};
function useSelectorWithStoreAndSubscription(selector, equalityFn, store, contextSub) {
    var _useReducer = (0, _react.useReducer)(function(s) {
        return s + 1;
    }, 0), forceRender = _useReducer[1];
    var subscription = (0, _react.useMemo)(function() {
        return (0, _subscription.createSubscription)(store, contextSub);
    }, [
        store,
        contextSub
    ]);
    var latestSubscriptionCallbackError = (0, _react.useRef)();
    var latestSelector = (0, _react.useRef)();
    var latestStoreState = (0, _react.useRef)();
    var latestSelectedState = (0, _react.useRef)();
    var storeState = store.getState();
    var selectedState;
    try {
        if (selector !== latestSelector.current || storeState !== latestStoreState.current || latestSubscriptionCallbackError.current) {
            var newSelectedState = selector(storeState); // ensure latest selected state is reused so that a custom equality function can result in identical references
            if (latestSelectedState.current === undefined || !equalityFn(newSelectedState, latestSelectedState.current)) selectedState = newSelectedState;
            else selectedState = latestSelectedState.current;
        } else selectedState = latestSelectedState.current;
    } catch (err) {
        if (latestSubscriptionCallbackError.current) err.message += "\nThe error may be correlated with this previous error:\n" + latestSubscriptionCallbackError.current.stack + "\n\n";
        throw err;
    }
    (0, _useIsomorphicLayoutEffect.useIsomorphicLayoutEffect)(function() {
        latestSelector.current = selector;
        latestStoreState.current = storeState;
        latestSelectedState.current = selectedState;
        latestSubscriptionCallbackError.current = undefined;
    });
    (0, _useIsomorphicLayoutEffect.useIsomorphicLayoutEffect)(function() {
        function checkForUpdates() {
            try {
                var newStoreState = store.getState(); // Avoid calling selector multiple times if the store's state has not changed
                if (newStoreState === latestStoreState.current) return;
                var _newSelectedState = latestSelector.current(newStoreState);
                if (equalityFn(_newSelectedState, latestSelectedState.current)) return;
                latestSelectedState.current = _newSelectedState;
                latestStoreState.current = newStoreState;
            } catch (err) {
                // we ignore all errors here, since when the component
                // is re-rendered, the selectors are called again, and
                // will throw again, if neither props nor store state
                // changed
                latestSubscriptionCallbackError.current = err;
            }
            forceRender();
        }
        subscription.onStateChange = checkForUpdates;
        subscription.trySubscribe();
        checkForUpdates();
        return function() {
            return subscription.tryUnsubscribe();
        };
    }, [
        store,
        subscription
    ]);
    return selectedState;
}
function createSelectorHook(context) {
    if (context === void 0) context = (0, _context.ReactReduxContext);
    var useReduxContext = context === (0, _context.ReactReduxContext) ? (0, _useReduxContext.useReduxContext) : function() {
        return (0, _react.useContext)(context);
    };
    return function useSelector(selector, equalityFn) {
        if (equalityFn === void 0) equalityFn = refEquality;
        var _useReduxContext = useReduxContext(), store = _useReduxContext.store, contextSub = _useReduxContext.subscription;
        var selectedState = useSelectorWithStoreAndSubscription(selector, equalityFn, store, contextSub);
        (0, _react.useDebugValue)(selectedState);
        return selectedState;
    };
}
var useSelector = /*#__PURE__*/ createSelectorHook();

},{"react":"6uln9","./useReduxContext":"fRs7q","../utils/Subscription":"hafSY","../utils/useIsomorphicLayoutEffect":"bPnBR","../components/Context":"kDZAc","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"83jZe":[function(require,module,exports) {
/* eslint-disable import/no-unresolved */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "unstable_batchedUpdates", ()=>(0, _reactDom.unstable_batchedUpdates));
var _reactDom = require("react-dom");

},{"react-dom":"b8T3j","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6hqau":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "calculateBox", ()=>calculateBox);
parcelHelpers.export(exports, "createBox", ()=>createBox);
parcelHelpers.export(exports, "expand", ()=>expand);
parcelHelpers.export(exports, "getBox", ()=>getBox);
parcelHelpers.export(exports, "getRect", ()=>getRect);
parcelHelpers.export(exports, "offset", ()=>offset);
parcelHelpers.export(exports, "shrink", ()=>shrink);
parcelHelpers.export(exports, "withScroll", ()=>withScroll);
var _tinyInvariant = require("tiny-invariant");
var _tinyInvariantDefault = parcelHelpers.interopDefault(_tinyInvariant);
var getRect = function getRect(_ref) {
    var top = _ref.top, right = _ref.right, bottom = _ref.bottom, left = _ref.left;
    var width = right - left;
    var height = bottom - top;
    var rect = {
        top: top,
        right: right,
        bottom: bottom,
        left: left,
        width: width,
        height: height,
        x: left,
        y: top,
        center: {
            x: (right + left) / 2,
            y: (bottom + top) / 2
        }
    };
    return rect;
};
var expand = function expand(target, expandBy) {
    return {
        top: target.top - expandBy.top,
        left: target.left - expandBy.left,
        bottom: target.bottom + expandBy.bottom,
        right: target.right + expandBy.right
    };
};
var shrink = function shrink(target, shrinkBy) {
    return {
        top: target.top + shrinkBy.top,
        left: target.left + shrinkBy.left,
        bottom: target.bottom - shrinkBy.bottom,
        right: target.right - shrinkBy.right
    };
};
var shift = function shift(target, shiftBy) {
    return {
        top: target.top + shiftBy.y,
        left: target.left + shiftBy.x,
        bottom: target.bottom + shiftBy.y,
        right: target.right + shiftBy.x
    };
};
var noSpacing = {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
};
var createBox = function createBox(_ref2) {
    var borderBox = _ref2.borderBox, _ref2$margin = _ref2.margin, margin = _ref2$margin === void 0 ? noSpacing : _ref2$margin, _ref2$border = _ref2.border, border = _ref2$border === void 0 ? noSpacing : _ref2$border, _ref2$padding = _ref2.padding, padding = _ref2$padding === void 0 ? noSpacing : _ref2$padding;
    var marginBox = getRect(expand(borderBox, margin));
    var paddingBox = getRect(shrink(borderBox, border));
    var contentBox = getRect(shrink(paddingBox, padding));
    return {
        marginBox: marginBox,
        borderBox: getRect(borderBox),
        paddingBox: paddingBox,
        contentBox: contentBox,
        margin: margin,
        border: border,
        padding: padding
    };
};
var parse = function parse(raw) {
    var value = raw.slice(0, -2);
    var suffix = raw.slice(-2);
    if (suffix !== "px") return 0;
    var result = Number(value);
    !!isNaN(result) && (0, _tinyInvariantDefault.default)(false);
    return result;
};
var getWindowScroll = function getWindowScroll() {
    return {
        x: window.pageXOffset,
        y: window.pageYOffset
    };
};
var offset = function offset(original, change) {
    var borderBox = original.borderBox, border = original.border, margin = original.margin, padding = original.padding;
    var shifted = shift(borderBox, change);
    return createBox({
        borderBox: shifted,
        border: border,
        margin: margin,
        padding: padding
    });
};
var withScroll = function withScroll(original, scroll) {
    if (scroll === void 0) scroll = getWindowScroll();
    return offset(original, scroll);
};
var calculateBox = function calculateBox(borderBox, styles) {
    var margin = {
        top: parse(styles.marginTop),
        right: parse(styles.marginRight),
        bottom: parse(styles.marginBottom),
        left: parse(styles.marginLeft)
    };
    var padding = {
        top: parse(styles.paddingTop),
        right: parse(styles.paddingRight),
        bottom: parse(styles.paddingBottom),
        left: parse(styles.paddingLeft)
    };
    var border = {
        top: parse(styles.borderTopWidth),
        right: parse(styles.borderRightWidth),
        bottom: parse(styles.borderBottomWidth),
        left: parse(styles.borderLeftWidth)
    };
    return createBox({
        borderBox: borderBox,
        margin: margin,
        padding: padding,
        border: border
    });
};
var getBox = function getBox(el) {
    var borderBox = el.getBoundingClientRect();
    var styles = window.getComputedStyle(el);
    return calculateBox(borderBox, styles);
};

},{"tiny-invariant":"dPEnp","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9ZyRf":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var safeIsNaN = Number.isNaN || function ponyfill(value) {
    return typeof value === "number" && value !== value;
};
function isEqual(first, second) {
    if (first === second) return true;
    if (safeIsNaN(first) && safeIsNaN(second)) return true;
    return false;
}
function areInputsEqual(newInputs, lastInputs) {
    if (newInputs.length !== lastInputs.length) return false;
    for(var i = 0; i < newInputs.length; i++){
        if (!isEqual(newInputs[i], lastInputs[i])) return false;
    }
    return true;
}
function memoizeOne(resultFn, isEqual) {
    if (isEqual === void 0) isEqual = areInputsEqual;
    var lastThis;
    var lastArgs = [];
    var lastResult;
    var calledOnce = false;
    function memoized() {
        var newArgs = [];
        for(var _i = 0; _i < arguments.length; _i++)newArgs[_i] = arguments[_i];
        if (calledOnce && lastThis === this && isEqual(newArgs, lastArgs)) return lastResult;
        lastResult = resultFn.apply(this, newArgs);
        calledOnce = true;
        lastThis = this;
        lastArgs = newArgs;
        return lastResult;
    }
    return memoized;
}
exports.default = memoizeOne;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2FtWs":[function(require,module,exports) {
module.exports = require("5fdad4115be7c1aa");

},{"5fdad4115be7c1aa":"6X6G2"}],"6X6G2":[function(require,module,exports) {
require("f845af62d4f7da43");
module.exports = require("31b6c6f010037f11").Object.values;

},{"f845af62d4f7da43":"1kugA","31b6c6f010037f11":"i8kQt"}],"1kugA":[function(require,module,exports) {
// https://github.com/tc39/proposal-object-values-entries
var $export = require("afad94f963cad049");
var $values = require("c935338fd8fb3965")(false);
$export($export.S, "Object", {
    values: function values(it) {
        return $values(it);
    }
});

},{"afad94f963cad049":"1OjY7","c935338fd8fb3965":"h98cp"}],"h98cp":[function(require,module,exports) {
var DESCRIPTORS = require("93c4c8b9a8034fa");
var getKeys = require("e680be775c5b77bf");
var toIObject = require("65fac980c844a8d4");
var isEnum = require("4ffc44ba1f0cf6f7").f;
module.exports = function(isEntries) {
    return function(it) {
        var O = toIObject(it);
        var keys = getKeys(O);
        var length = keys.length;
        var i = 0;
        var result = [];
        var key;
        while(length > i){
            key = keys[i++];
            if (!DESCRIPTORS || isEnum.call(O, key)) result.push(isEntries ? [
                key,
                O[key]
            ] : O[key]);
        }
        return result;
    };
};

},{"93c4c8b9a8034fa":"cWdn9","e680be775c5b77bf":"4aWXn","65fac980c844a8d4":"lvd6c","4ffc44ba1f0cf6f7":"776i5"}],"250cg":[function(require,module,exports) {
module.exports = require("390ff51aa5ab0cb5");

},{"390ff51aa5ab0cb5":"k6LFq"}],"k6LFq":[function(require,module,exports) {
require("fc7aaf10748563c0");
module.exports = require("e9ae71be40b6cd03").Object.keys;

},{"fc7aaf10748563c0":"eTjps","e9ae71be40b6cd03":"i8kQt"}],"eTjps":[function(require,module,exports) {
// 19.1.2.14 Object.keys(O)
var toObject = require("dbef3a280fbf169b");
var $keys = require("4207d0a02d7f0813");
require("f6e418d65a35e269")("keys", function() {
    return function keys(it) {
        return $keys(toObject(it));
    };
});

},{"dbef3a280fbf169b":"9EHnZ","4207d0a02d7f0813":"4aWXn","f6e418d65a35e269":"dukCp"}],"amLmH":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var rafSchd = function rafSchd(fn) {
    var lastArgs = [];
    var frameId = null;
    var wrapperFn = function wrapperFn() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        lastArgs = args;
        if (frameId) return;
        frameId = requestAnimationFrame(function() {
            frameId = null;
            fn.apply(void 0, lastArgs);
        });
    };
    wrapperFn.cancel = function() {
        if (!frameId) return;
        cancelAnimationFrame(frameId);
        frameId = null;
    };
    return wrapperFn;
};
exports.default = rafSchd;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"f22qq":[function(require,module,exports) {
module.exports = require("2cc1420316875d17");

},{"2cc1420316875d17":"2CgWP"}],"2CgWP":[function(require,module,exports) {
require("c67c14c050968f74");
module.exports = require("838a91104e19490b").Date.now;

},{"c67c14c050968f74":"5corS","838a91104e19490b":"i8kQt"}],"5corS":[function(require,module,exports) {
// 20.3.3.1 / 15.9.4.4 Date.now()
var $export = require("d695ec61578fd089");
$export($export.S, "Date", {
    now: function() {
        return new Date().getTime();
    }
});

},{"d695ec61578fd089":"1OjY7"}],"kTW7n":[function(require,module,exports) {
module.exports = require("d59d8ee201036f20");

},{"d59d8ee201036f20":"a8aV5"}],"aPsYS":[function(require,module,exports) {
module.exports = require("1e36ced9b06f142b");

},{"1e36ced9b06f142b":"gcnln"}],"gcnln":[function(require,module,exports) {
require("ff80967a0ee4deb9");
module.exports = require("916caf48d36556f7").Number.isInteger;

},{"ff80967a0ee4deb9":"9IKtL","916caf48d36556f7":"i8kQt"}],"9IKtL":[function(require,module,exports) {
// 20.1.2.3 Number.isInteger(number)
var $export = require("375379e0d721e9a6");
$export($export.S, "Number", {
    isInteger: require("dd211940f49a3d03")
});

},{"375379e0d721e9a6":"1OjY7","dd211940f49a3d03":"6XmpM"}],"6XmpM":[function(require,module,exports) {
// 20.1.2.3 Number.isInteger(number)
var isObject = require("7bcf6c561c3df85f");
var floor = Math.floor;
module.exports = function isInteger(it) {
    return !isObject(it) && isFinite(it) && floor(it) === it;
};

},{"7bcf6c561c3df85f":"5vzl3"}],"c4Eiu":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _colors = require("../../../constants/colors");
var _secondaryLoader = require("../../../components/general/SecondaryLoader");
var _secondaryLoaderDefault = parcelHelpers.interopDefault(_secondaryLoader);
const folderIcon = require("60925983dc011819");
class NewFeatureItem extends (0, _reactDefault.default).Component {
    constructor(props){
        super(props);
        this.state = {
            text: "New Folder"
        };
    }
    componentDidMount() {
        this.inputElement?.focus();
    }
    handleBlur() {
        if (this.state.text) this.props.onFinish(this.state.text);
    }
    handleEnterBlur(e) {
        if (e.charCode == 13) e.target.blur();
    }
    handleChange(e) {
        this.setState({
            ...this.state,
            text: e.target.value
        });
    }
    render() {
        return (0, _react.jsx)("div", {
            className: containerStyle
        }, this.props.isLoading && (0, _react.jsx)((0, _secondaryLoaderDefault.default), null), (0, _react.jsx)("div", {
            className: "feature-link"
        }, (0, _react.jsx)("img", {
            className: "folder-icon",
            src: folderIcon
        }), (0, _react.jsx)("input", {
            className: "feature-title",
            placeholder: "New Folder",
            value: this.state.text,
            disabled: this.props.isLoading,
            ref: (r)=>this.inputElement = r,
            onChange: this.handleChange.bind(this),
            onBlur: this.handleBlur.bind(this),
            onFocus: (e)=>e.target.select(),
            onKeyPress: (e)=>this.handleEnterBlur(e)
        })));
    }
}
const containerStyle = /*#__PURE__*/ (0, _css.css)("height:80px;background:#FFFFFF;border:1px solid ", (0, _colors.color_shades_dark), ";box-sizing:border-box;display:flex;align-items:center;padding:0 32px;cursor:pointer;.feature-link{display:flex;align-items:center;color:", (0, _colors.color_shades_darkest), ";}.folder-icon{width:56px;height:56px;}.feature-title{background:white;margin-left:-32px;margin-top:18px;font-family:Muli;font-style:normal;font-weight:600;font-size:18px;line-height:24px;padding-bottom:12px;border:none;color:", (0, _colors.color_text_default), ";}.spinner>div{background:", (0, _colors.color_text_link), ";}", "");
exports.default = NewFeatureItem;

},{"@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","../../../constants/colors":"1p3OR","../../../components/general/SecondaryLoader":"7zJiF","60925983dc011819":"khmlm","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"khmlm":[function(require,module,exports) {
module.exports = require("2ff6fc8f2442fae").getBundleURL("kVLro") + require("8dd40b1b06e952ea").resolve("9xpFu");

},{"2ff6fc8f2442fae":"c7Tr5","8dd40b1b06e952ea":"fyJL2"}],"3OxnU":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _colors = require("../../../constants/colors");
var _secondaryLoader = require("../../../components/general/SecondaryLoader");
var _secondaryLoaderDefault = parcelHelpers.interopDefault(_secondaryLoader);
var _subscribeToContentItem = require("../../../components/structure/ContentItems/SubscribeToContentItem");
var _subscribeToContentItemDefault = parcelHelpers.interopDefault(_subscribeToContentItem);
var _extensions = require("../../../models/extensions");
const folderIcon = require("1a4fe568745c52f7");
class NewStubContentItem extends (0, _reactDefault.default).Component {
    constructor(props){
        super(props);
        this.state = {
            text: "New Content"
        };
    }
    componentDidMount() {
        this.inputElement?.focus();
    }
    handleCreate(container) {
        container.addStub(this.props.applicationId, this.props.applicationFeatureId, this.state.text, this.props.additionalProperties).then((result)=>{
            if (result.resultType == "Ok") this.props.onFinish(result.data);
        });
    }
    handleChange(e) {
        this.setState({
            ...this.state,
            text: e.target.value
        });
    }
    handleEnterBlur(e, container) {
        if (e.charCode == 13) {
            e.preventDefault();
            this.handleCreate(container);
        }
    }
    render() {
        return (0, _react.jsx)((0, _subscribeToContentItemDefault.default), {
            featureTypeId: this.props.featureTypeId
        }, (container)=>(0, _react.jsx)("div", {
                className: containerStyle
            }, (0, _react.jsx)("div", {
                className: `content-item`
            }, container.state.isSavingStub && (0, _react.jsx)((0, _secondaryLoaderDefault.default), null), (0, _react.jsx)("img", {
                className: "content-item-icon",
                src: (0, _extensions.getFeatureTypeIcon)(this.props.featureTypeId)
            }), (0, _react.jsx)("div", {
                className: "content-item-title-container"
            }, (0, _react.jsx)("p", {
                className: "section-title"
            }, (0, _extensions.getDefaultFeatureTypeName)(this.props.featureTypeId)), (0, _react.jsx)("input", {
                className: "content-title",
                placeholder: "New Content",
                value: this.state.text,
                disabled: container.state.isSavingStub,
                ref: (r)=>this.inputElement = r,
                onChange: this.handleChange.bind(this),
                onBlur: this.handleCreate.bind(this, container),
                onFocus: (e)=>e.target.select(),
                onKeyPress: (e)=>this.handleEnterBlur(e, container)
            })))));
    }
}
const containerStyle = /*#__PURE__*/ (0, _css.css)("height:80px;padding:0 16px;background:", (0, _colors.color_shades_light), ";box-sizing:border-box;border-bottom:1px solid ", (0, _colors.color_shades_dark), ";&:first-child{border-top:1px solid ", (0, _colors.color_shades_dark), ";}.content-item{background:", (0, _colors.color_defaults_white), ";box-sizing:border-box;border-radius:4px;border-left:1px solid ", (0, _colors.color_shades_dark), ";border-right:1px solid ", (0, _colors.color_shades_dark), ";display:flex;align-items:center;padding:0 16px;height:100%;}.content-item-icon{width:48px;height:48px;margin-right:16px;}.section-title{font-family:Muli;font-style:normal;font-weight:normal;font-size:12px;line-height:16px;color:", (0, _colors.color_shades_darker), ";}.section-detail{font-style:normal;font-weight:normal;font-size:14px;line-height:20px;color:", (0, _colors.color_shades_darkest), ";}.content-item-title-container{flex:1;}.spinner>div{background:", (0, _colors.color_text_link), ";}.content-title{font-style:normal;font-weight:normal;font-size:14px;line-height:20px;color:#324661;}", "");
exports.default = NewStubContentItem;

},{"@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","../../../constants/colors":"1p3OR","../../../components/general/SecondaryLoader":"7zJiF","../../../components/structure/ContentItems/SubscribeToContentItem":"aquCt","../../../models/extensions":"7h01B","1a4fe568745c52f7":"khmlm","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"aquCt":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _unstated = require("unstated");
var _featureTypeIds = require("../../../constants/featureTypeIds");
var _questionAnswerContainer = require("../../../state/containers/QuestionAnswerContainer");
var _questionAnswerContainerDefault = parcelHelpers.interopDefault(_questionAnswerContainer);
var _latestMessageContainer = require("../../../state/containers/LatestMessageContainer");
var _latestMessageContainerDefault = parcelHelpers.interopDefault(_latestMessageContainer);
var _simpleChoiceContainer = require("../../../state/containers/SimpleChoiceContainer");
var _simpleChoiceContainerDefault = parcelHelpers.interopDefault(_simpleChoiceContainer);
var _numberRangeContainer = require("../../../state/containers/NumberRangeContainer");
var _numberRangeContainerDefault = parcelHelpers.interopDefault(_numberRangeContainer);
var _helpMessageContainer = require("../../../state/containers/HelpMessageContainer");
var _helpMessageContainerDefault = parcelHelpers.interopDefault(_helpMessageContainer);
var _fallbackMessageContainer = require("../../../state/containers/FallbackMessageContainer");
var _fallbackMessageContainerDefault = parcelHelpers.interopDefault(_fallbackMessageContainer);
var _customRequestContainer = require("../../../state/containers/CustomRequestContainer");
var _customRequestContainerDefault = parcelHelpers.interopDefault(_customRequestContainer);
var _welcomeMessageContainer = require("../../../state/containers/WelcomeMessageContainer");
var _welcomeMessageContainerDefault = parcelHelpers.interopDefault(_welcomeMessageContainer);
var _exitMessageContainer = require("../../../state/containers/ExitMessageContainer");
var _exitMessageContainerDefault = parcelHelpers.interopDefault(_exitMessageContainer);
const getContainer = (featureTypeId)=>{
    switch(featureTypeId){
        case 0, _featureTypeIds.QuestionAnswerFeatureTypeId:
            return 0, _questionAnswerContainerDefault.default;
        case 0, _featureTypeIds.LatestMessagesFeatureTypeId:
            return 0, _latestMessageContainerDefault.default;
        case 0, _featureTypeIds.SimpleChoiceFeatureTypeId:
            return 0, _simpleChoiceContainerDefault.default;
        case 0, _featureTypeIds.NumberRangeFeatureTypeId:
            return 0, _numberRangeContainerDefault.default;
        case 0, _featureTypeIds.HelpMessagesFeatureTypeId:
            return 0, _helpMessageContainerDefault.default;
        case 0, _featureTypeIds.FallbackFeatureTypeId:
            return 0, _fallbackMessageContainerDefault.default;
        case 0, _featureTypeIds.CustomRequestsFeatureTypeId:
            return 0, _customRequestContainerDefault.default;
        case 0, _featureTypeIds.WelcomeMessagesFeatureTypeId:
            return 0, _welcomeMessageContainerDefault.default;
        case 0, _featureTypeIds.ExitMessagesFeatureTypeId:
            return 0, _exitMessageContainerDefault.default;
    }
};
const SubscribeToContentItem = (props)=>(0, _react.jsx)((0, _unstated.Subscribe), {
        to: [
            getContainer(props.featureTypeId)
        ]
    }, props.children);
exports.default = SubscribeToContentItem;

},{"@emotion/react":"djZKr","react":"6uln9","unstated":"grh7p","../../../constants/featureTypeIds":"hPLMP","../../../state/containers/QuestionAnswerContainer":"hfasy","../../../state/containers/LatestMessageContainer":"1Hdqb","../../../state/containers/SimpleChoiceContainer":"hO0x5","../../../state/containers/NumberRangeContainer":"an6iC","../../../state/containers/HelpMessageContainer":"2oQaX","../../../state/containers/FallbackMessageContainer":"kKZMo","../../../state/containers/CustomRequestContainer":"aVO05","../../../state/containers/WelcomeMessageContainer":"j3orW","../../../state/containers/ExitMessageContainer":"lSKl8","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hfasy":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _defineProperty = require("@babel/runtime/helpers/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _api = require("../../api");
var _featureTypeIds = require("../../constants/featureTypeIds");
var _genericContentItemContainer = require("./GenericContentItemContainer");
var _genericContentItemContainerDefault = parcelHelpers.interopDefault(_genericContentItemContainer);
class QuestionAnswerContainer extends (0, _genericContentItemContainerDefault.default) {
    constructor(...args){
        super(...args);
        // default state
        (0, _definePropertyDefault.default)(this, "state", {
            contentItems: [],
            isLoading: false,
            errors: [],
            isSaving: false,
            isSavingStub: false,
            isPublishing: false,
            isLoadingWebhooks: false,
            isUpdatingWebhooks: false,
            isTogglingSync: false,
            attachedWebhooks: [],
            hasWebhookUpdate: false,
            webhookUpdates: null
        });
        (0, _definePropertyDefault.default)(this, "mapModelToGenericContentItemModel", (model)=>({
                ...model,
                hasAudio: model.responses.some((a)=>a.audio != null),
                hasVideo: model.responses.some((a)=>a.video != null),
                hasImage: model.responses.some((a)=>a.largeImage != null),
                hasBackgroundImage: model.responses.some((a)=>a.backgroundImage != null),
                featureTypeId: (0, _featureTypeIds.QuestionAnswerFeatureTypeId)
            }));
        (0, _definePropertyDefault.default)(this, "mapFormDataToModel", (originalModel, formData)=>{
            const finalModel = {
                ...originalModel,
                title: formData.title,
                requiresParent: formData.requiresParent,
                isLive: formData.isLive,
                languages: formData.languages,
                webhookChainingType: formData.webhookChainingType,
                sensitiveConversationChange: formData.sensitiveConversationChange,
                disabledForFeatureFlagIds: formData.disabledForFeatureFlagIds,
                questionSet: formData.questions.map((q)=>({
                        ...q,
                        id: q.questionId,
                        minimumConfidenceScore: formData.minimumConfidenceScore,
                        requiredPhrases: formData.requiredPhrases
                    })),
                responses: formData.responses
            };
            return finalModel;
        });
        (0, _definePropertyDefault.default)(this, "featureTypeId", (0, _featureTypeIds.QuestionAnswerFeatureTypeId));
        (0, _definePropertyDefault.default)(this, "getContentItemsByAppPromise", (applicationId)=>_api.getQuestionAnswersForApp(applicationId));
        (0, _definePropertyDefault.default)(this, "getContentItemsByAppModulePromise", (applicationModuleId)=>null);
        // not implemented
        (0, _definePropertyDefault.default)(this, "getContentItemsByAppFeaturePromise", (applicationFeatureId)=>_api.getQuestionAnswersForAppFeature(applicationFeatureId));
        (0, _definePropertyDefault.default)(this, "createPromise", (model)=>_api.createQuestionAnswer(model));
        (0, _definePropertyDefault.default)(this, "createStubPromise", (model)=>_api.createQuestionAnswerStub(model));
        (0, _definePropertyDefault.default)(this, "createFromModelPromise", (model)=>_api.createFullQuestionAnswer(model));
        (0, _definePropertyDefault.default)(this, "updatePromise", (contentItemId, model)=>_api.bulkUpdateQuestionAnswer(contentItemId, model));
        (0, _definePropertyDefault.default)(this, "updateStubPromise", (contentItemId, model)=>_api.bulkUpdateQuestionAnswerStub(contentItemId, model));
        (0, _definePropertyDefault.default)(this, "updateFromModelPromise", (model)=>_api.updateFullQuestionAnswer(model.id, model));
        (0, _definePropertyDefault.default)(this, "deletePromise", (contentItemId)=>_api.deleteQuestionAnswer(contentItemId));
        (0, _definePropertyDefault.default)(this, "toggleLivePromise", (contentItemId, isLive)=>_api.toggleQuestionAnswerLive(contentItemId, isLive));
        (0, _definePropertyDefault.default)(this, "toggleSyncPromise", (contentItemId, shouldNotSync)=>_api.toggleQuestionAnswerSync(contentItemId, shouldNotSync));
        (0, _definePropertyDefault.default)(this, "copyPromise", (contentItemId)=>_api.copyQuestionAnswer(contentItemId));
        (0, _definePropertyDefault.default)(this, "findFullByIdPromise", (contentItemId)=>_api.findQuestionAnswer(contentItemId));
        (0, _definePropertyDefault.default)(this, "getPublishHistoryPromise", (contentItemId, environmentId, skip, take)=>_api.getQuestionAnswerPublishHistory(contentItemId, environmentId, skip, take));
        (0, _definePropertyDefault.default)(this, "getWebhooksPromise", (contentItemId)=>_api.getQuestionAnswerWebhooks(contentItemId));
        (0, _definePropertyDefault.default)(this, "removeWebhookPromise", (contentItemWebhookId)=>_api.removeQuestionAnswerWebhook(contentItemWebhookId));
        (0, _definePropertyDefault.default)(this, "bulkUpdateWebhookInstancesPromise", (contentItemId, updateRequest)=>_api.bulkUpdateQuestionAnswerWebhookInstances(contentItemId, updateRequest));
        (0, _definePropertyDefault.default)(this, "addWebhookPromise", (id, webhookId, defaultParameters, userDefinedParameters)=>_api.addQuestionAnswerWebhook(id, webhookId, defaultParameters, userDefinedParameters));
        (0, _definePropertyDefault.default)(this, "updateWebhookPromise", (id, webhookInstanceId, defaultParameters, userDefinedParameters)=>_api.updateQuestionAnswerWebhook(id, webhookInstanceId, defaultParameters, userDefinedParameters));
        (0, _definePropertyDefault.default)(this, "getSimpleSampleFlows", (contentItem, application)=>[
                {
                    requests: contentItem.questionSet.map((q, index)=>({
                            content: q.content,
                            highlights: [
                                q.content
                            ],
                            id: `q${index}`
                        })),
                    followUp: contentItem.responses[0]?.followUp,
                    responses: contentItem.responses.map((a)=>({
                            content: a.content,
                            highlights: [],
                            id: a.content
                        })),
                    requestTitle: "User Says",
                    responseTitle: "Device Response"
                }
            ]);
    }
}
exports.default = QuestionAnswerContainer;

},{"@babel/runtime/helpers/defineProperty":"9sJxO","../../api":"loxM6","../../constants/featureTypeIds":"hPLMP","./GenericContentItemContainer":"bgJ2b","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"bgJ2b":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _unstated = require("unstated");
var _extensions = require("../../models/extensions");
class GenericContentItemContainer extends (0, _unstated.Container) {
    async findFullById(contentItemId) {
        try {
            await this.setState({
                ...this.state,
                isLoadingFull: true
            });
            const result = await this.findFullByIdPromise(contentItemId);
            if (result?.resultType == "Ok") {
                const contentItems = this.state.contentItems;
                const existingItem = contentItems.find((c)=>c.id == result.data.id);
                if (existingItem) contentItems[contentItems.indexOf(existingItem)] = result.data;
                else contentItems.push(result.data);
                await this.setState({
                    ...this.state,
                    contentItems,
                    isLoadingFull: false
                });
            } else await this.setState({
                ...this.state,
                isLoadingFull: false
            });
            return result;
        } catch (e) {
            await this.setState({
                ...this.state,
                isLoadingFull: false
            });
        }
    }
    setInitialCreateState() {
        this.setState({
            ...this.state,
            attachedWebhooks: [],
            hasWebhookUpdate: false,
            webhookUpdates: null
        });
    }
    getGenericContentItemModels(applicationFeatureId) {
        const promise = new Promise((resolve, error)=>{
            this.getByApplicationFeature(applicationFeatureId).then((result)=>{
                if (result.resultType == "Ok") resolve({
                    resultType: "Ok",
                    errors: [],
                    data: result.data.map((lm)=>this.mapModelToGenericContentItemModel(lm))
                });
                else resolve({
                    resultType: result.resultType,
                    errors: result.errors,
                    data: null
                });
            }).catch((e)=>{
                error(e);
            });
        });
        return promise;
    }
    async addStub(applicationId, applicationFeatureId, title, additionalProperties) {
        this.setState({
            ...this.state,
            isSavingStub: true
        });
        const promise = new Promise((resolve, error)=>{
            this.createStubPromise({
                applicationFeatureId: applicationFeatureId,
                applicationId: applicationId,
                title: title,
                ...additionalProperties
            }).then((result)=>{
                this.setState({
                    ...this.state,
                    isSavingStub: false
                });
                if (result.resultType == "Ok") resolve({
                    resultType: "Ok",
                    errors: [],
                    data: this.mapModelToGenericContentItemModel(result.data)
                });
                else resolve({
                    resultType: result.resultType,
                    errors: result.errors,
                    data: null
                });
            }).catch((e)=>{
                error(e);
                this.setState({
                    ...this.state,
                    isSavingStub: false
                });
            });
        });
        return promise;
    }
    updateStub(id, applicationId, title) {
        this.setState({
            ...this.state,
            isSavingStub: true
        });
        const promise = new Promise((resolve, error)=>{
            // get the original item, and just replace the title so we don't delete stub props created elsewhere
            const originalItem = this.state.contentItems.find((q)=>q.id == id);
            const model = originalItem ? {
                ...originalItem
            } : {
                title: title,
                applicationId
            };
            model.title = title;
            this.updateStubPromise(id, model).then((result)=>{
                this.setState({
                    ...this.state,
                    isSavingStub: false
                });
                if (result.resultType == "Ok") resolve({
                    resultType: "Ok",
                    errors: [],
                    data: this.mapModelToGenericContentItemModel(result.data)
                });
                else resolve({
                    resultType: result.resultType,
                    errors: result.errors,
                    data: null
                });
            }).catch((e)=>{
                error(e);
                this.setState({
                    ...this.state,
                    isSavingStub: false
                });
            });
        });
        return promise;
    }
    async getForApp(applicationId) {
        try {
            await this.setLoading(true);
            const result = await this.getContentItemsByAppPromise(applicationId);
            if (result.resultType == "Ok") await this.setState({
                ...this.state,
                errors: [],
                contentItems: result.data,
                isLoading: false
            });
            else await this.setState({
                ...this.state,
                errors: result.errors,
                isLoading: false
            });
            return result;
        } catch (e) {
            await this.setState({
                ...this.state,
                isSaving: false,
                errors: [
                    e.toString()
                ]
            });
        }
    }
    async getByApplicationFeature(applicationFeatureId) {
        try {
            await this.setLoading(true);
            const result = await this.getContentItemsByAppFeaturePromise(applicationFeatureId);
            if (result.resultType == "Ok") {
                const items = this.state.contentItems;
                result.data.forEach((item)=>{
                    (0, _extensions.addOrReplace)(items, item);
                });
                await this.setState({
                    ...this.state,
                    errors: [],
                    contentItems: items,
                    isLoading: false
                });
            } else await this.setState({
                ...this.state,
                errors: result.errors,
                isLoading: false
            });
            return result;
        } catch (e) {
            await this.setState({
                ...this.state,
                isSaving: false,
                errors: [
                    e.toString()
                ]
            });
        }
    }
    findById(contentItemId) {
        return this.state.contentItems.find((lm)=>lm.id == contentItemId);
    }
    async create(model) {
        try {
            await this.setSaving(true);
            const result = await this.createPromise(model);
            if (result.resultType == "Ok") {
                await this.setSaving(false);
                if (this.state.isPublishing) {
                    // toggle to live, then reset is publishing
                    await this.toggleLivePromise(result.data.id, true);
                    await this.setState({
                        ...this.state,
                        isPublishing: false
                    });
                }
            } else await this.setState({
                ...this.state,
                errors: result.errors,
                isSaving: false
            });
            return result;
        } catch (e) {
            await this.setState({
                ...this.state,
                isSaving: false,
                errors: [
                    e.toString()
                ]
            });
        }
    }
    async createFromModel(model) {
        try {
            await this.setSaving(true);
            const result = await this.createFromModelPromise(model);
            if (result.resultType == "Ok") await this.setSaving(false);
            else await this.setState({
                ...this.state,
                errors: result.errors,
                isSaving: false
            });
            return result;
        } catch (e) {
            await this.setState({
                ...this.state,
                isSaving: false,
                errors: [
                    e.toString()
                ]
            });
        }
    }
    async update(contentItemId, model) {
        try {
            await this.setSaving(true);
            const result = await this.updatePromise(contentItemId, model);
            if (result.resultType == "Ok") {
                this.setSaving(false);
                // replace the message in state
                const messages = this.state.contentItems;
                const existingMessage = messages.find((m)=>m.id == contentItemId);
                if (existingMessage != null) {
                    messages[messages.indexOf(existingMessage)] = result.data;
                    await this.setState({
                        ...this.state,
                        contentItems: messages,
                        isSaving: false
                    });
                }
                if (this.state.isPublishing) {
                    // toggle to live, then reset is publishing
                    await this.toggleLivePromise(result.data.id, true);
                    await this.setState({
                        ...this.state,
                        isPublishing: false
                    });
                }
            } else await this.setState({
                ...this.state,
                errors: result.errors,
                isSaving: false
            });
            return result;
        } catch (e) {
            console.log(e);
            await this.setState({
                ...this.state,
                isSaving: false,
                errors: [
                    e.toString()
                ]
            });
        }
    }
    async updateFromModel(model) {
        try {
            await this.setSaving(true);
            const result = await this.updateFromModelPromise(model);
            if (result.resultType == "Ok") {
                await this.setSaving(false);
                // replace the message in state
                const messages = this.state.contentItems;
                const existingMessage = messages.find((m)=>m.id == model.id);
                if (existingMessage != null) {
                    messages[messages.indexOf(existingMessage)] = result.data;
                    await this.setState({
                        ...this.state,
                        contentItems: messages,
                        isSaving: false
                    });
                }
            } else await this.setState({
                ...this.state,
                errors: result.errors,
                isSaving: false
            });
            return result;
        } catch (e) {
            await this.setState({
                ...this.state,
                isSaving: false,
                errors: [
                    e.toString()
                ]
            });
        }
    }
    copy(contentItemId) {
        const copyPromise = this.copyPromise(contentItemId);
        copyPromise.then((result)=>{
            if (result.resultType == "Ok") {
                const updatedMessages = [
                    ...this.state.contentItems,
                    result.data
                ];
                this.setState({
                    ...this.state,
                    contentItems: updatedMessages,
                    isSaving: false
                });
            } else this.setState({
                ...this.state,
                errors: result.errors,
                isSaving: false
            });
        }).catch((error)=>{
            console.log(error);
        });
        return copyPromise;
    }
    toggleLive(id, isLive) {
        return this.toggleLivePromise(id, isLive).then((liveResult)=>{
            this.setState({
                ...this.state
            });
        }).catch((error)=>console.log(error));
    }
    async toggleSync(id, shouldNotSync) {
        try {
            const items = this.state.contentItems;
            const item = items.find((c)=>c.id == id);
            if (item) {
                item.shouldNotSync = shouldNotSync;
                const index = items.findIndex((c)=>c.id == id);
                items[index] = item;
            }
            await this.setState({
                ...this.state,
                isTogglingSync: true,
                contentItems: items
            });
            const liveResult = await this.toggleSyncPromise(id, shouldNotSync);
            await this.setState({
                ...this.state,
                isTogglingSync: false
            });
            return liveResult;
        } catch (e) {
            await this.setState({
                ...this.state,
                isTogglingSync: false,
                errors: "Error while toggling sync"
            });
        }
    }
    delete(contentItemId) {
        const deletePromise = this.deletePromise(contentItemId);
        deletePromise.then((result)=>{
            if (result.resultType == "Ok") {
                // remove the message from state immutably;
                const updatedMessages = this.state.contentItems.filter((w)=>w.id !== contentItemId);
                this.setState({
                    ...this.state,
                    contentItems: updatedMessages,
                    isSaving: false
                });
            } else this.setState({
                ...this.state,
                errors: result.errors,
                isSaving: false
            });
        }).catch((error)=>{
            console.log(error);
        });
        return deletePromise;
    }
    async getContentWebhooks(id) {
        try {
            await this.setLoadingWebhooks(true);
            const result = await this.getWebhooksPromise(id);
            if (result.resultType == "Ok") await this.setState({
                ...this.state,
                isLoadingWebhooks: false,
                errors: [],
                attachedWebhooks: result.data
            });
            else await this.setState({
                ...this.state,
                isLoadingWebhooks: false,
                errors: result.errors
            });
            return result;
        } catch (e) {
            await this.setState({
                ...this.state,
                isLoadingWebhooks: false,
                errors: [
                    e.toString()
                ]
            });
        }
    }
    stageWebhookUpdates(updateRequest) {
        this.setState({
            ...this.state,
            hasWebhookUpdate: true,
            webhookUpdates: updateRequest
        });
    }
    async bulkUpdateContentItemWebhookInstances(contentItemId, updateRequest) {
        try {
            await this.setState({
                ...this.state,
                isUpdatingWebhooks: true
            });
            const result = await this.bulkUpdateWebhookInstancesPromise(contentItemId, updateRequest);
            if (result.resultType == "Ok") await this.setState({
                ...this.state,
                isUpdatingWebhooks: false,
                attachedWebhooks: result.data,
                hasWebhookUpdate: false,
                webhookUpdates: [],
                errors: []
            });
            else await this.setState({
                ...this.state,
                isUpdatingWebhooks: false,
                webhookUpdates: [],
                errors: result.errors
            });
            return result;
        } catch (error) {
            await this.setState({
                ...this.state,
                isUpdatingWebhooks: false,
                webhookUpdates: [],
                errors: [
                    error
                ]
            });
            return {
                resultType: "InternalError",
                data: null,
                errors: [
                    error
                ]
            };
        }
    }
    async setSaving(isSaving) {
        await this.setState({
            ...this.state,
            isSaving: isSaving
        });
    }
    async setLoading(isLoading) {
        await this.setState({
            ...this.state,
            isLoading: isLoading
        });
    }
    async setIsPublishing(isPublishing) {
        await this.setState({
            ...this.state,
            isPublishing: isPublishing
        });
    }
    async setLoadingWebhooks(isLoading) {
        await this.setState({
            ...this.state,
            isLoadingWebhooks: isLoading
        });
    }
    async clearErrors() {
        await this.setState({
            ...this.state,
            errors: []
        });
    }
    async setError(error) {
        await this.setState({
            ...this.state,
            errors: [
                error?.toString() ?? "Unexpected error"
            ]
        });
    }
    async loadPublishHistory(contentItemId, environmentId, skip = 0, take = 50, append = false) {
        try {
            const result = await this.getPublishHistoryPromise(contentItemId, environmentId, skip, take);
            return result;
        } catch (error) {
            await this.setState({
                ...this.state,
                errors: [
                    error.toString()
                ],
                isLoading: false
            });
        }
    }
}
exports.default = GenericContentItemContainer;

},{"unstated":"grh7p","../../models/extensions":"7h01B","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1Hdqb":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _defineProperty = require("@babel/runtime/helpers/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _api = require("../../api");
var _featureTypeIds = require("../../constants/featureTypeIds");
var _genericContentItemContainer = require("./GenericContentItemContainer");
var _genericContentItemContainerDefault = parcelHelpers.interopDefault(_genericContentItemContainer);
var _moment = require("moment");
var _momentDefault = parcelHelpers.interopDefault(_moment);
class LatestMessageContainer extends (0, _genericContentItemContainerDefault.default) {
    constructor(...args){
        super(...args);
        // default state
        (0, _definePropertyDefault.default)(this, "state", {
            contentItems: [],
            isLoading: false,
            errors: [],
            isSaving: false,
            isSavingStub: false,
            isPublishing: false,
            isLoadingWebhooks: false,
            isUpdatingWebhooks: false,
            isTogglingSync: false,
            attachedWebhooks: [],
            hasWebhookUpdate: false,
            webhookUpdates: null
        });
        (0, _definePropertyDefault.default)(this, "mapModelToGenericContentItemModel", (model)=>({
                ...model,
                hasAudio: model.responses.some((a)=>a.audio != null),
                hasVideo: model.responses.some((a)=>a.video != null),
                hasImage: model.responses.some((a)=>a.largeImage != null),
                hasBackgroundImage: model.responses.some((a)=>a.backgroundImage != null),
                featureTypeId: (0, _featureTypeIds.LatestMessagesFeatureTypeId)
            }));
        (0, _definePropertyDefault.default)(this, "mapFormDataToModel", (originalModel, formData)=>({
                ...originalModel,
                webhookChainingType: formData.webhookChainingType,
                title: formData.title,
                category: formData.category,
                requiresParent: formData.requiresParent,
                isLive: formData.isLive,
                languages: formData.languages,
                startDate: formData.startDate,
                endDate: formData.endDate,
                responses: formData.responses,
                sensitiveConversationChange: formData.sensitiveConversationChange,
                disabledForFeatureFlagIds: formData.disabledForFeatureFlagIds
            }));
        (0, _definePropertyDefault.default)(this, "featureTypeId", (0, _featureTypeIds.LatestMessagesFeatureTypeId));
        (0, _definePropertyDefault.default)(this, "getContentItemsByAppPromise", (applicationId)=>_api.getLatestMessagesForApp(applicationId));
        (0, _definePropertyDefault.default)(this, "getContentItemsByAppModulePromise", (applicationModuleId)=>null);
        // not implemented
        (0, _definePropertyDefault.default)(this, "getContentItemsByAppFeaturePromise", (applicationFeatureId)=>_api.getLatestMessagesForAppFeature(applicationFeatureId));
        (0, _definePropertyDefault.default)(this, "createPromise", (model)=>_api.createLatestMessage(model));
        (0, _definePropertyDefault.default)(this, "createStubPromise", (model)=>_api.createLatestMessageStub(model));
        (0, _definePropertyDefault.default)(this, "createFromModelPromise", (model)=>_api.createFullLatestMessage(model));
        (0, _definePropertyDefault.default)(this, "updatePromise", (contentItemId, model)=>_api.bulkUpdateLatestMessage(contentItemId, model));
        (0, _definePropertyDefault.default)(this, "updateStubPromise", (contentItemId, model)=>_api.bulkUpdateLatestMessageStub(contentItemId, model));
        (0, _definePropertyDefault.default)(this, "updateFromModelPromise", (model)=>_api.updateFullLatestMessage(model.id, model));
        (0, _definePropertyDefault.default)(this, "deletePromise", (contentItemId)=>_api.deleteLatestMessage(contentItemId));
        (0, _definePropertyDefault.default)(this, "toggleLivePromise", (contentItemId, isLive)=>_api.toggleLatestMessageLive(contentItemId, isLive));
        (0, _definePropertyDefault.default)(this, "toggleSyncPromise", (contentItemId, shouldNotSync)=>_api.toggleLatestMessageSync(contentItemId, shouldNotSync));
        (0, _definePropertyDefault.default)(this, "copyPromise", (contentItemId)=>_api.copyLatestMessage(contentItemId));
        (0, _definePropertyDefault.default)(this, "findFullByIdPromise", (contentItemId)=>_api.findLatestMessage(contentItemId));
        (0, _definePropertyDefault.default)(this, "getPublishHistoryPromise", (contentItemId, environmentId, skip, take)=>_api.getLatestMessagePublishHistory(contentItemId, environmentId, skip, take));
        (0, _definePropertyDefault.default)(this, "getWebhooksPromise", (contentItemId)=>_api.getLatestMessageWebhooks(contentItemId));
        (0, _definePropertyDefault.default)(this, "removeWebhookPromise", (contentItemWebhookId)=>_api.removeLatestMessageWebhook(contentItemWebhookId));
        (0, _definePropertyDefault.default)(this, "bulkUpdateWebhookInstancesPromise", (contentItemId, updateRequest)=>_api.bulkUpdateLatestMessageWebhookInstances(contentItemId, updateRequest));
        (0, _definePropertyDefault.default)(this, "addWebhookPromise", (id, webhookId, defaultParameters, userDefinedParameters)=>_api.addLatestMessageWebhook(id, webhookId, defaultParameters, userDefinedParameters));
        (0, _definePropertyDefault.default)(this, "updateWebhookPromise", (id, webhookInstanceId, defaultParameters, userDefinedParameters)=>_api.updateLatestMessageWebhook(id, webhookInstanceId, defaultParameters, userDefinedParameters));
        (0, _definePropertyDefault.default)(this, "getSimpleSampleFlows", (contentItem, application)=>[
                {
                    requests: [
                        {
                            content: `What's new with ${contentItem.category}?`,
                            highlights: [],
                            id: "1"
                        },
                        {
                            content: `What's the latest from ${contentItem.category}?`,
                            highlights: [],
                            id: "2"
                        },
                        {
                            content: `What's the daily message from ${contentItem.category}?`,
                            highlights: [],
                            id: "3"
                        },
                        {
                            content: `What was the message from ${contentItem.category} on ${(0, _momentDefault.default)(contentItem.startDate).format("MMMM Do")}?`,
                            highlights: [],
                            id: "4"
                        }
                    ],
                    followUp: contentItem.responses[0]?.followUp,
                    responses: contentItem.responses.map((a)=>({
                            content: a.content,
                            highlights: [],
                            id: a.content
                        })),
                    requestTitle: "User Says",
                    responseTitle: "Device Response"
                }
            ]);
    }
}
exports.default = LatestMessageContainer;

},{"@babel/runtime/helpers/defineProperty":"9sJxO","../../api":"loxM6","../../constants/featureTypeIds":"hPLMP","./GenericContentItemContainer":"bgJ2b","moment":"2meyw","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hO0x5":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _defineProperty = require("@babel/runtime/helpers/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _api = require("../../api");
var _featureTypeIds = require("../../constants/featureTypeIds");
var _genericContentItemContainer = require("./GenericContentItemContainer");
var _genericContentItemContainerDefault = parcelHelpers.interopDefault(_genericContentItemContainer);
class SimpleChoiceContainer extends (0, _genericContentItemContainerDefault.default) {
    constructor(...args){
        super(...args);
        // default state
        (0, _definePropertyDefault.default)(this, "state", {
            contentItems: [],
            isLoading: false,
            errors: [],
            isSaving: false,
            isSavingStub: false,
            isPublishing: false,
            isLoadingWebhooks: false,
            isUpdatingWebhooks: false,
            isTogglingSync: false,
            attachedWebhooks: [],
            hasWebhookUpdate: false,
            webhookUpdates: null
        });
        (0, _definePropertyDefault.default)(this, "mapModelToGenericContentItemModel", (model)=>({
                ...model,
                hasAudio: model.responses.some((a)=>a.audio != null),
                hasVideo: model.responses.some((a)=>a.video != null),
                hasImage: model.responses.some((a)=>a.largeImage != null),
                hasBackgroundImage: model.responses.some((a)=>a.backgroundImage != null),
                featureTypeId: (0, _featureTypeIds.SimpleChoiceFeatureTypeId),
                titleAttribute: model.choiceType ? `${model.choiceType}: ` : null
            }));
        (0, _definePropertyDefault.default)(this, "mapFormDataToModel", (originalModel, formData)=>({
                ...originalModel,
                title: formData.title,
                choiceType: formData.choiceType,
                requiresParent: formData.requiresParent,
                webhookChainingType: formData.webhookChainingType,
                isLive: formData.isLive,
                languages: formData.languages,
                responses: formData.responses,
                sensitiveConversationChange: formData.sensitiveConversationChange,
                disabledForFeatureFlagIds: formData.disabledForFeatureFlagIds
            }));
        (0, _definePropertyDefault.default)(this, "featureTypeId", (0, _featureTypeIds.SimpleChoiceFeatureTypeId));
        (0, _definePropertyDefault.default)(this, "getContentItemsByAppPromise", (applicationId)=>_api.getSimpleChoicesForApp(applicationId));
        (0, _definePropertyDefault.default)(this, "getContentItemsByAppModulePromise", (applicationModuleId)=>_api.getSimpleChoicesForModule(applicationModuleId));
        (0, _definePropertyDefault.default)(this, "getContentItemsByAppFeaturePromise", (applicationFeatureId)=>_api.getSimpleChoicesForAppFeature(applicationFeatureId));
        (0, _definePropertyDefault.default)(this, "createPromise", (model)=>_api.createSimpleChoice(model));
        (0, _definePropertyDefault.default)(this, "createStubPromise", (model)=>_api.createSimpleChoiceStub(model));
        (0, _definePropertyDefault.default)(this, "createFromModelPromise", (model)=>_api.createFullSimpleChoice(model));
        (0, _definePropertyDefault.default)(this, "updatePromise", (contentItemId, model)=>_api.bulkUpdateSimpleChoice(contentItemId, model));
        (0, _definePropertyDefault.default)(this, "updateStubPromise", (contentItemId, model)=>_api.bulkUpdateSimpleChoiceStub(contentItemId, model));
        (0, _definePropertyDefault.default)(this, "updateFromModelPromise", (model)=>_api.updateFullSimpleChoice(model.id, model));
        (0, _definePropertyDefault.default)(this, "deletePromise", (contentItemId)=>_api.deleteSimpleChoice(contentItemId));
        (0, _definePropertyDefault.default)(this, "toggleLivePromise", (contentItemId, isLive)=>_api.toggleSimpleChoiceLive(contentItemId, isLive));
        (0, _definePropertyDefault.default)(this, "toggleSyncPromise", (contentItemId, shouldNotSync)=>_api.toggleSimpleChoiceSync(contentItemId, shouldNotSync));
        (0, _definePropertyDefault.default)(this, "copyPromise", (contentItemId)=>_api.copySimpleChoice(contentItemId));
        (0, _definePropertyDefault.default)(this, "findFullByIdPromise", (contentItemId)=>_api.findSimpleChoice(contentItemId));
        (0, _definePropertyDefault.default)(this, "getPublishHistoryPromise", (contentItemId, environmentId, skip, take)=>_api.getSimpleChoicePublishHistory(contentItemId, environmentId, skip, take));
        (0, _definePropertyDefault.default)(this, "getWebhooksPromise", (contentItemId)=>_api.getSimpleChoiceWebhooks(contentItemId));
        (0, _definePropertyDefault.default)(this, "removeWebhookPromise", (contentItemWebhookId)=>_api.removeSimpleChoiceWebhook(contentItemWebhookId));
        (0, _definePropertyDefault.default)(this, "bulkUpdateWebhookInstancesPromise", (contentItemId, updateRequest)=>_api.bulkUpdateSimpleChoiceWebhookInstances(contentItemId, updateRequest));
        (0, _definePropertyDefault.default)(this, "addWebhookPromise", (id, webhookId, defaultParameters, userDefinedParameters)=>_api.addSimpleChoiceWebhook(id, webhookId, defaultParameters, userDefinedParameters));
        (0, _definePropertyDefault.default)(this, "updateWebhookPromise", (id, webhookInstanceId, defaultParameters, userDefinedParameters)=>_api.updateSimpleChoiceWebhook(id, webhookInstanceId, defaultParameters, userDefinedParameters));
        (0, _definePropertyDefault.default)(this, "getSimpleSampleFlows", (contentItem, application)=>{
            const getUserUtterances = ()=>{
                switch(contentItem.choiceType){
                    case "Yes":
                        return [
                            {
                                id: "1",
                                content: "Yes",
                                highlights: []
                            },
                            {
                                id: "2",
                                content: "Yeah",
                                highlights: []
                            },
                            {
                                id: "3",
                                content: "Sure",
                                highlights: []
                            },
                            {
                                id: "4",
                                content: "Yes please",
                                highlights: []
                            },
                            {
                                id: "5",
                                content: "Uh huh",
                                highlights: []
                            }
                        ];
                    case "No":
                        return [
                            {
                                id: "1",
                                content: "No",
                                highlights: []
                            },
                            {
                                id: "2",
                                content: "Nope",
                                highlights: []
                            },
                            {
                                id: "3",
                                content: "Nah",
                                highlights: []
                            },
                            {
                                id: "4",
                                content: "No thanks",
                                highlights: []
                            },
                            {
                                id: "5",
                                content: "Nuh uh",
                                highlights: []
                            }
                        ];
                }
                return [];
            };
            return [
                {
                    requests: getUserUtterances(),
                    followUp: contentItem.responses[0]?.followUp,
                    responses: contentItem.responses.map((a)=>({
                            content: a.content,
                            highlights: [],
                            id: a.content
                        })),
                    requestTitle: "User Says",
                    responseTitle: "Device Response"
                }
            ];
        });
    }
}
exports.default = SimpleChoiceContainer;

},{"@babel/runtime/helpers/defineProperty":"9sJxO","../../api":"loxM6","../../constants/featureTypeIds":"hPLMP","./GenericContentItemContainer":"bgJ2b","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"an6iC":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _defineProperty = require("@babel/runtime/helpers/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _api = require("../../api");
var _featureTypeIds = require("../../constants/featureTypeIds");
var _followUps = require("../../models/extensions/followUps");
var _genericContentItemContainer = require("./GenericContentItemContainer");
var _genericContentItemContainerDefault = parcelHelpers.interopDefault(_genericContentItemContainer);
class NumberRangeContainer extends (0, _genericContentItemContainerDefault.default) {
    constructor(...args){
        super(...args);
        // default state
        (0, _definePropertyDefault.default)(this, "state", {
            contentItems: [],
            isLoading: false,
            errors: [],
            isSaving: false,
            isPublishing: false,
            isSavingStub: false,
            isLoadingWebhooks: false,
            isUpdatingWebhooks: false,
            isTogglingSync: false,
            attachedWebhooks: [],
            hasWebhookUpdate: false,
            webhookUpdates: null
        });
        (0, _definePropertyDefault.default)(this, "mapModelToGenericContentItemModel", (model)=>({
                ...model,
                hasAudio: model.responses.some((a)=>a.audio != null),
                hasVideo: model.responses.some((a)=>a.video != null),
                hasImage: model.responses.some((a)=>a.largeImage != null),
                hasBackgroundImage: model.responses.some((a)=>a.backgroundImage != null),
                featureTypeId: (0, _featureTypeIds.NumberRangeFeatureTypeId),
                titleAttribute: (0, _followUps.getNumberRangePrefix)(model.minimumValue, model.maximumValue)
            }));
        (0, _definePropertyDefault.default)(this, "mapFormDataToModel", (originalModel, formData)=>({
                ...originalModel,
                webhookChainingType: formData.webhookChainingType,
                title: formData.title,
                minimumValue: formData.minimumValue,
                maximumValue: formData.maximumValue,
                requiresParent: formData.requiresParent,
                isLive: formData.isLive,
                languages: formData.languages,
                responses: formData.responses,
                sensitiveConversationChange: formData.sensitiveConversationChange,
                disabledForFeatureFlagIds: formData.disabledForFeatureFlagIds
            }));
        (0, _definePropertyDefault.default)(this, "featureTypeId", (0, _featureTypeIds.NumberRangeFeatureTypeId));
        (0, _definePropertyDefault.default)(this, "getContentItemsByAppPromise", (applicationId)=>_api.getNumberRangesForApp(applicationId));
        (0, _definePropertyDefault.default)(this, "getContentItemsByAppModulePromise", (applicationModuleId)=>_api.getNumberRangesForModule(applicationModuleId));
        (0, _definePropertyDefault.default)(this, "getContentItemsByAppFeaturePromise", (applicationFeatureId)=>_api.getNumberRangesForAppFeature(applicationFeatureId));
        (0, _definePropertyDefault.default)(this, "createPromise", (model)=>_api.createNumberRange(model));
        (0, _definePropertyDefault.default)(this, "createStubPromise", (model)=>_api.createNumberRangeStub(model));
        (0, _definePropertyDefault.default)(this, "createFromModelPromise", (model)=>_api.createFullNumberRange(model));
        (0, _definePropertyDefault.default)(this, "updatePromise", (contentItemId, model)=>_api.bulkUpdateNumberRange(contentItemId, model));
        (0, _definePropertyDefault.default)(this, "updateStubPromise", (contentItemId, model)=>_api.bulkUpdateNumberRangeStub(contentItemId, model));
        (0, _definePropertyDefault.default)(this, "updateFromModelPromise", (model)=>_api.updateFullNumberRange(model.id, model));
        (0, _definePropertyDefault.default)(this, "deletePromise", (contentItemId)=>_api.deleteNumberRange(contentItemId));
        (0, _definePropertyDefault.default)(this, "toggleLivePromise", (contentItemId, isLive)=>_api.toggleNumberRangeLive(contentItemId, isLive));
        (0, _definePropertyDefault.default)(this, "toggleSyncPromise", (contentItemId, shouldNotSync)=>_api.toggleNumberRangeSync(contentItemId, shouldNotSync));
        (0, _definePropertyDefault.default)(this, "copyPromise", (contentItemId)=>_api.copyNumberRange(contentItemId));
        (0, _definePropertyDefault.default)(this, "findFullByIdPromise", (contentItemId)=>_api.findNumberRange(contentItemId));
        (0, _definePropertyDefault.default)(this, "getPublishHistoryPromise", (contentItemId, environmentId, skip, take)=>_api.getNumberRangePublishHistory(contentItemId, environmentId, skip, take));
        (0, _definePropertyDefault.default)(this, "getWebhooksPromise", (contentItemId)=>_api.getNumberRangeWebhooks(contentItemId));
        (0, _definePropertyDefault.default)(this, "removeWebhookPromise", (contentItemWebhookId)=>_api.removeNumberRangeWebhook(contentItemWebhookId));
        (0, _definePropertyDefault.default)(this, "bulkUpdateWebhookInstancesPromise", (contentItemId, updateRequest)=>_api.bulkUpdateNumberRangeWebhookInstances(contentItemId, updateRequest));
        (0, _definePropertyDefault.default)(this, "addWebhookPromise", (id, webhookId, defaultParameters, userDefinedParameters)=>_api.addNumberRangeWebhook(id, webhookId, defaultParameters, userDefinedParameters));
        (0, _definePropertyDefault.default)(this, "updateWebhookPromise", (id, webhookInstanceId, defaultParameters, userDefinedParameters)=>_api.updateNumberRangeWebhook(id, webhookInstanceId, defaultParameters, userDefinedParameters));
        (0, _definePropertyDefault.default)(this, "getSimpleSampleFlows", (contentItem, application)=>{
            const getRangeType = (min, max)=>{
                if (min != null && max != null && min == max) return "equal";
                else if (min != null && max != null) return "between";
                else if (min != null) return "greater-than";
                else if (max != null) return "less-than";
                return "equal";
            };
            const getUserUtterances = ()=>{
                switch(getRangeType(contentItem.minimumValue, contentItem.maximumValue)){
                    case "equal":
                        return [
                            {
                                id: "equal",
                                content: contentItem.minimumValue?.toString(),
                                highlights: []
                            }
                        ];
                    case "between":
                        return [
                            {
                                id: "middle-random",
                                content: `[Value greater than ${contentItem.minimumValue} but less than ${contentItem.maximumValue}]`,
                                highlights: []
                            },
                            {
                                id: "lower",
                                content: contentItem.minimumValue?.toString(),
                                highlights: []
                            },
                            {
                                id: "upper",
                                content: contentItem.maximumValue?.toString(),
                                highlights: []
                            }
                        ];
                    case "greater-than":
                        return [
                            {
                                id: "middle-random",
                                content: `[Value greater than ${contentItem.minimumValue}]`,
                                highlights: []
                            },
                            {
                                id: "lower",
                                content: "" + contentItem.minimumValue?.toString(),
                                highlights: []
                            }
                        ];
                    case "less-than":
                        return [
                            {
                                id: "middle-random",
                                content: `[Value less than ${contentItem.maximumValue}]`,
                                highlights: []
                            },
                            {
                                id: "upper",
                                content: "" + contentItem.maximumValue?.toString(),
                                highlights: []
                            }
                        ];
                }
                return [];
            };
            return [
                {
                    requests: getUserUtterances(),
                    followUp: contentItem.responses[0]?.followUp,
                    responses: contentItem.responses.map((a)=>({
                            content: a.content,
                            highlights: [
                                a.content
                            ],
                            id: a.content
                        })),
                    requestTitle: "User Says",
                    responseTitle: "Device Response"
                }
            ];
        });
    }
}
exports.default = NumberRangeContainer;

},{"@babel/runtime/helpers/defineProperty":"9sJxO","../../api":"loxM6","../../constants/featureTypeIds":"hPLMP","../../models/extensions/followUps":"2RWn6","./GenericContentItemContainer":"bgJ2b","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2oQaX":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _defineProperty = require("@babel/runtime/helpers/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _api = require("../../api");
var _featureTypeIds = require("../../constants/featureTypeIds");
var _genericContentItemContainer = require("./GenericContentItemContainer");
var _genericContentItemContainerDefault = parcelHelpers.interopDefault(_genericContentItemContainer);
class HelpMessageContainer extends (0, _genericContentItemContainerDefault.default) {
    constructor(...args){
        super(...args);
        // default state
        (0, _definePropertyDefault.default)(this, "state", {
            contentItems: [],
            isLoading: false,
            errors: [],
            isSaving: false,
            isSavingStub: false,
            isPublishing: false,
            isLoadingWebhooks: false,
            isUpdatingWebhooks: false,
            isTogglingSync: false,
            attachedWebhooks: [],
            hasWebhookUpdate: false,
            webhookUpdates: null
        });
        (0, _definePropertyDefault.default)(this, "mapModelToGenericContentItemModel", (model)=>({
                ...model,
                hasAudio: model.audio != null,
                hasVideo: model.video != null,
                hasImage: model.largeImage != null,
                hasBackgroundImage: model.backgroundImage != null,
                featureTypeId: (0, _featureTypeIds.HelpMessagesFeatureTypeId)
            }));
        (0, _definePropertyDefault.default)(this, "mapFormDataToModel", (originalModel, formData)=>({
                ...originalModel,
                webhookChainingType: formData.webhookChainingType,
                title: formData.title,
                isLive: formData.isLive,
                requiresParent: formData.requiresParent,
                languages: formData.languages,
                responses: formData.responses,
                sensitiveConversationChange: formData.sensitiveConversationChange,
                disabledForFeatureFlagIds: formData.disabledForFeatureFlagIds,
                // we null these values out so they don't conflict with the responses field for variations        
                smallImage: null,
                largeImage: null,
                backgroundImage: null,
                audio: null,
                video: null,
                content: null,
                reprompt: null,
                followUp: null,
                mediaResponseContainer: null,
                mediaResponseContainerId: null,
                displayTitleOverride: null,
                displayTextOverride: null,
                followUpId: null,
                responseId: null
            }));
        (0, _definePropertyDefault.default)(this, "featureTypeId", (0, _featureTypeIds.HelpMessagesFeatureTypeId));
        (0, _definePropertyDefault.default)(this, "getContentItemsByAppPromise", (applicationId)=>_api.getHelpMessagesForApp(applicationId));
        (0, _definePropertyDefault.default)(this, "getContentItemsByAppModulePromise", (applicationModuleId)=>null);
        // not implemented
        (0, _definePropertyDefault.default)(this, "getContentItemsByAppFeaturePromise", (applicationFeatureId)=>_api.getHelpMessagesForAppFeature(applicationFeatureId));
        (0, _definePropertyDefault.default)(this, "createPromise", (model)=>_api.addHelpMessage(model.applicationId, model));
        (0, _definePropertyDefault.default)(this, "createStubPromise", (model)=>_api.addHelpMessageStub(model));
        (0, _definePropertyDefault.default)(this, "createFromModelPromise", (model)=>_api.addFullHelpMessage(model));
        (0, _definePropertyDefault.default)(this, "updatePromise", (contentItemId, model)=>_api.updateHelpMessage(contentItemId, model));
        (0, _definePropertyDefault.default)(this, "updateStubPromise", (contentItemId, model)=>_api.updateHelpMessageStub(contentItemId, model));
        (0, _definePropertyDefault.default)(this, "updateFromModelPromise", (model)=>_api.updateFullHelpMessage(model.id, model));
        (0, _definePropertyDefault.default)(this, "deletePromise", (contentItemId)=>_api.deleteHelpMessage(contentItemId));
        (0, _definePropertyDefault.default)(this, "toggleLivePromise", (contentItemId, isLive)=>_api.toggleHelpMessageLive(contentItemId, isLive));
        (0, _definePropertyDefault.default)(this, "toggleSyncPromise", (contentItemId, shouldNotSync)=>_api.toggleHelpMessageSync(contentItemId, shouldNotSync));
        (0, _definePropertyDefault.default)(this, "copyPromise", (contentItemId)=>_api.copyHelpMessage(contentItemId));
        (0, _definePropertyDefault.default)(this, "findFullByIdPromise", (contentItemId)=>_api.findHelpMessage(contentItemId));
        (0, _definePropertyDefault.default)(this, "getPublishHistoryPromise", (contentItemId, environmentId, skip, take)=>_api.getHelpMessagePublishHistory(contentItemId, environmentId, skip, take));
        (0, _definePropertyDefault.default)(this, "getWebhooksPromise", (contentItemId)=>_api.getHelpMessageWebhooks(contentItemId));
        (0, _definePropertyDefault.default)(this, "removeWebhookPromise", (contentItemWebhookId)=>_api.removeHelpMessageWebhook(contentItemWebhookId));
        (0, _definePropertyDefault.default)(this, "bulkUpdateWebhookInstancesPromise", (contentItemId, updateRequest)=>_api.bulkUpdateHelpMessageWebhookInstances(contentItemId, updateRequest));
        (0, _definePropertyDefault.default)(this, "addWebhookPromise", (id, webhookId, defaultParameters, userDefinedParameters)=>_api.addHelpMessageWebhook(id, webhookId, defaultParameters, userDefinedParameters));
        (0, _definePropertyDefault.default)(this, "updateWebhookPromise", (id, webhookInstanceId, defaultParameters, userDefinedParameters)=>_api.updateHelpMessageWebhook(id, webhookInstanceId, defaultParameters, userDefinedParameters));
        (0, _definePropertyDefault.default)(this, "getSimpleSampleFlows", (contentItem, application)=>[
                {
                    requests: [
                        {
                            content: "Help",
                            highlights: [],
                            id: "1"
                        },
                        {
                            content: "What can I do?",
                            highlights: [],
                            id: "2"
                        }
                    ],
                    followUp: contentItem.followUp,
                    responses: [
                        {
                            content: contentItem.content,
                            highlights: [],
                            id: "10"
                        }
                    ],
                    requestTitle: "User Says",
                    responseTitle: "Device Response"
                }
            ]);
    }
}
exports.default = HelpMessageContainer;

},{"@babel/runtime/helpers/defineProperty":"9sJxO","../../api":"loxM6","../../constants/featureTypeIds":"hPLMP","./GenericContentItemContainer":"bgJ2b","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"kKZMo":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _defineProperty = require("@babel/runtime/helpers/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _api = require("../../api");
var _featureTypeIds = require("../../constants/featureTypeIds");
var _genericContentItemContainer = require("./GenericContentItemContainer");
var _genericContentItemContainerDefault = parcelHelpers.interopDefault(_genericContentItemContainer);
class FallbackMessageContainer extends (0, _genericContentItemContainerDefault.default) {
    constructor(...args){
        super(...args);
        // default state
        (0, _definePropertyDefault.default)(this, "state", {
            contentItems: [],
            isLoading: false,
            errors: [],
            isSaving: false,
            isSavingStub: false,
            isPublishing: false,
            isLoadingWebhooks: false,
            isUpdatingWebhooks: false,
            isLoadingCategories: false,
            isLoadingFull: false,
            isTogglingSync: false,
            attachedWebhooks: [],
            categories: [],
            hasWebhookUpdate: false,
            webhookUpdates: null
        });
        (0, _definePropertyDefault.default)(this, "mapModelToGenericContentItemModel", (model)=>({
                ...model,
                hasAudio: model.audio != null,
                hasVideo: model.video != null,
                hasImage: model.largeImage != null,
                hasBackgroundImage: model.backgroundImage != null,
                featureTypeId: (0, _featureTypeIds.FallbackFeatureTypeId)
            }));
        (0, _definePropertyDefault.default)(this, "mapFormDataToModel", (originalModel, formData)=>({
                ...originalModel,
                webhookChainingType: formData.webhookChainingType,
                title: formData.title,
                category: this.state.categories.find((fc)=>fc.id == formData.categoryId),
                isLive: formData.isLive,
                languages: formData.languages,
                requiresParent: formData.requiresParent,
                responses: formData.responses,
                sensitiveConversationChange: formData.sensitiveConversationChange,
                disabledForFeatureFlagIds: formData.disabledForFeatureFlagIds,
                // we null these values out so they don't conflict with the responses field for variations        
                smallImage: null,
                largeImage: null,
                backgroundImage: null,
                audio: null,
                video: null,
                content: null,
                reprompt: null,
                followUp: null,
                mediaResponseContainer: null,
                mediaResponseContainerId: null,
                displayTitleOverride: null,
                displayTextOverride: null,
                followUpId: null,
                responseId: null
            }));
        (0, _definePropertyDefault.default)(this, "featureTypeId", (0, _featureTypeIds.FallbackFeatureTypeId));
        (0, _definePropertyDefault.default)(this, "getContentItemsByAppPromise", (applicationId)=>_api.getFallbackMessagesForApp(applicationId));
        (0, _definePropertyDefault.default)(this, "getContentItemsByAppModulePromise", (applicationModuleId)=>null);
        // not implemented
        (0, _definePropertyDefault.default)(this, "getContentItemsByAppFeaturePromise", (applicationFeatureId)=>_api.getFallbackMessagesForAppFeature(applicationFeatureId));
        (0, _definePropertyDefault.default)(this, "createPromise", (model)=>_api.addFallbackMessage(model.applicationId, model));
        (0, _definePropertyDefault.default)(this, "createStubPromise", (model)=>_api.addFallbackMessageStub(model));
        (0, _definePropertyDefault.default)(this, "createFromModelPromise", (model)=>_api.addFullFallbackMessage(model));
        (0, _definePropertyDefault.default)(this, "updatePromise", (contentItemId, model)=>_api.updateFallbackMessage(contentItemId, model));
        (0, _definePropertyDefault.default)(this, "updateStubPromise", (contentItemId, model)=>_api.updateFallbackMessageStub(contentItemId, model));
        (0, _definePropertyDefault.default)(this, "updateFromModelPromise", (model)=>_api.updateFullFallbackMessage(model.id, model));
        (0, _definePropertyDefault.default)(this, "deletePromise", (contentItemId)=>_api.deleteFallbackMessage(contentItemId));
        (0, _definePropertyDefault.default)(this, "toggleLivePromise", (contentItemId, isLive)=>_api.toggleFallbackMessageLive(contentItemId, isLive));
        (0, _definePropertyDefault.default)(this, "toggleSyncPromise", (contentItemId, shouldNotSync)=>_api.toggleFallbackMessageSync(contentItemId, shouldNotSync));
        (0, _definePropertyDefault.default)(this, "copyPromise", (contentItemId)=>_api.copyFallbackMessage(contentItemId));
        (0, _definePropertyDefault.default)(this, "findFullByIdPromise", (contentItemId)=>_api.findFallbackMessage(contentItemId));
        (0, _definePropertyDefault.default)(this, "getPublishHistoryPromise", (contentItemId, environmentId, skip, take)=>_api.getFallbackMessagePublishHistory(contentItemId, environmentId, skip, take));
        (0, _definePropertyDefault.default)(this, "getWebhooksPromise", (contentItemId)=>_api.getFallbackMessageWebhooks(contentItemId));
        (0, _definePropertyDefault.default)(this, "removeWebhookPromise", (contentItemWebhookId)=>_api.removeFallbackMessageWebhook(contentItemWebhookId));
        (0, _definePropertyDefault.default)(this, "addWebhookPromise", (id, webhookId, defaultParameters, userDefinedParameters)=>_api.addFallbackMessageWebhook(id, webhookId, defaultParameters, userDefinedParameters));
        (0, _definePropertyDefault.default)(this, "updateWebhookPromise", (id, webhookInstanceId, defaultParameters, userDefinedParameters)=>_api.updateFallbackMessageWebhook(id, webhookInstanceId, defaultParameters, userDefinedParameters));
        (0, _definePropertyDefault.default)(this, "bulkUpdateWebhookInstancesPromise", (contentItemId, updateRequest)=>_api.bulkUpdateFallbackMessageWebhookInstances(contentItemId, updateRequest));
        (0, _definePropertyDefault.default)(this, "getSimpleSampleFlows", (contentItem, application)=>[
                {
                    requests: [
                        {
                            content: "[Unhandled Response]",
                            highlights: [],
                            id: "1"
                        }
                    ],
                    followUp: contentItem.followUp,
                    responses: [
                        {
                            content: contentItem.content,
                            highlights: [],
                            id: "10"
                        }
                    ],
                    requestTitle: "User Says",
                    responseTitle: "Device Response"
                }
            ]);
    }
    getFallbackCategories() {
        // if we already have categories, we don't need to load again
        if (this.state.categories.length > 0) return;
        this.setState({
            ...this.state,
            isLoadingCategories: true
        });
        _api.getFallbackMessageCategories().then((result)=>{
            if (result.resultType == "Ok") this.setState({
                ...this.state,
                errors: [],
                categories: result.data,
                isLoadingCategories: false
            });
            else this.setState({
                ...this.state,
                errors: result.errors,
                isLoadingCategories: false
            });
        }).catch((error)=>{
            console.log(error);
            this.setState({
                ...this.state,
                errors: [
                    error
                ],
                isLoadingCategories: false
            });
        });
    }
}
exports.default = FallbackMessageContainer;

},{"@babel/runtime/helpers/defineProperty":"9sJxO","../../api":"loxM6","../../constants/featureTypeIds":"hPLMP","./GenericContentItemContainer":"bgJ2b","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"aVO05":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _defineProperty = require("@babel/runtime/helpers/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _api = require("../../api");
var _featureTypeIds = require("../../constants/featureTypeIds");
var _genericContentItemContainer = require("./GenericContentItemContainer");
var _genericContentItemContainerDefault = parcelHelpers.interopDefault(_genericContentItemContainer);
class CustomRequestContainer extends (0, _genericContentItemContainerDefault.default) {
    constructor(...args){
        super(...args);
        // default state
        (0, _definePropertyDefault.default)(this, "state", {
            contentItems: [],
            isLoading: false,
            errors: [],
            isSaving: false,
            isPublishing: false,
            isSavingStub: false,
            isLoadingWebhooks: false,
            isUpdatingWebhooks: false,
            isTogglingSync: false,
            attachedWebhooks: [],
            hasWebhookUpdate: false,
            webhookUpdates: null
        });
        (0, _definePropertyDefault.default)(this, "mapModelToGenericContentItemModel", (model)=>({
                ...model,
                hasAudio: model.responses.some((a)=>a.audio != null),
                hasVideo: model.responses.some((a)=>a.video != null),
                hasImage: model.responses.some((a)=>a.largeImage != null),
                hasBackgroundImage: model.responses.some((a)=>a.backgroundImage != null),
                featureTypeId: (0, _featureTypeIds.CustomRequestsFeatureTypeId)
            }));
        (0, _definePropertyDefault.default)(this, "mapFormDataToModel", (originalModel, formData)=>({
                ...originalModel,
                webhookChainingType: formData.webhookChainingType,
                id: originalModel.id,
                title: formData.title,
                requiresParent: formData.requiresParent,
                isLive: formData.isLive,
                requestTypes: formData.requestTypes,
                requestNames: formData.requestNames,
                platformFilter: formData.platformFilter,
                languages: formData.languages,
                responses: formData.responses,
                sensitiveConversationChange: formData.sensitiveConversationChange,
                disabledForFeatureFlagIds: formData.disabledForFeatureFlagIds,
                alwaysOpen: formData.alwaysOpen
            }));
        (0, _definePropertyDefault.default)(this, "featureTypeId", (0, _featureTypeIds.CustomRequestsFeatureTypeId));
        (0, _definePropertyDefault.default)(this, "getContentItemsByAppPromise", (applicationId)=>_api.getCustomRequestsForApp(applicationId));
        (0, _definePropertyDefault.default)(this, "getContentItemsByAppModulePromise", (applicationModuleId)=>null);
        // not implemented
        (0, _definePropertyDefault.default)(this, "getContentItemsByAppFeaturePromise", (applicationFeatureId)=>_api.getCustomRequestsForAppFeature(applicationFeatureId));
        (0, _definePropertyDefault.default)(this, "createPromise", (model)=>_api.createCustomRequest(model));
        (0, _definePropertyDefault.default)(this, "createStubPromise", (model)=>_api.createCustomRequestStub(model));
        (0, _definePropertyDefault.default)(this, "createFromModelPromise", (model)=>_api.createFullCustomRequest(model));
        (0, _definePropertyDefault.default)(this, "updatePromise", (contentItemId, model)=>_api.bulkUpdateCustomRequest(contentItemId, model));
        (0, _definePropertyDefault.default)(this, "updateStubPromise", (contentItemId, model)=>_api.bulkUpdateCustomRequestStub(contentItemId, model));
        (0, _definePropertyDefault.default)(this, "updateFromModelPromise", (model)=>_api.updateFullCustomRequest(model.id, model));
        (0, _definePropertyDefault.default)(this, "deletePromise", (contentItemId)=>_api.deleteCustomRequest(contentItemId));
        (0, _definePropertyDefault.default)(this, "toggleLivePromise", (contentItemId, isLive)=>_api.toggleCustomRequestLive(contentItemId, isLive));
        (0, _definePropertyDefault.default)(this, "toggleSyncPromise", (contentItemId, shouldNotSync)=>_api.toggleCustomRequestSync(contentItemId, shouldNotSync));
        (0, _definePropertyDefault.default)(this, "copyPromise", (contentItemId)=>_api.copyCustomRequest(contentItemId));
        (0, _definePropertyDefault.default)(this, "findFullByIdPromise", (contentItemId)=>_api.findCustomRequest(contentItemId));
        (0, _definePropertyDefault.default)(this, "getPublishHistoryPromise", (contentItemId, environmentId, skip, take)=>_api.getCustomRequestPublishHistory(contentItemId, environmentId, skip, take));
        (0, _definePropertyDefault.default)(this, "getWebhooksPromise", (contentItemId)=>_api.getCustomRequestWebhooks(contentItemId));
        (0, _definePropertyDefault.default)(this, "removeWebhookPromise", (contentItemWebhookId)=>_api.removeCustomRequestWebhook(contentItemWebhookId));
        (0, _definePropertyDefault.default)(this, "bulkUpdateWebhookInstancesPromise", (contentItemId, updateRequest)=>_api.bulkUpdateCustomRequestWebhookInstances(contentItemId, updateRequest));
        (0, _definePropertyDefault.default)(this, "addWebhookPromise", (id, webhookId, defaultParameters, userDefinedParameters)=>_api.addCustomRequestWebhook(id, webhookId, defaultParameters, userDefinedParameters));
        (0, _definePropertyDefault.default)(this, "updateWebhookPromise", (id, webhookInstanceId, defaultParameters, userDefinedParameters)=>_api.updateCustomRequestWebhook(id, webhookInstanceId, defaultParameters, userDefinedParameters));
        (0, _definePropertyDefault.default)(this, "getSimpleSampleFlows", (contentItem, application)=>[
                {
                    requests: [
                        {
                            content: `[Custom Request]`,
                            highlights: [],
                            id: "1"
                        }
                    ],
                    followUp: contentItem.responses[0]?.followUp,
                    responses: contentItem.responses.map((a)=>({
                            content: a.content,
                            highlights: [
                                a.content
                            ],
                            id: a.content
                        })),
                    requestTitle: "User Request",
                    responseTitle: "Device Response"
                }
            ]);
    }
}
exports.default = CustomRequestContainer;

},{"@babel/runtime/helpers/defineProperty":"9sJxO","../../api":"loxM6","../../constants/featureTypeIds":"hPLMP","./GenericContentItemContainer":"bgJ2b","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"j3orW":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _defineProperty = require("@babel/runtime/helpers/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _api = require("../../api");
var _genericContentItemContainer = require("./GenericContentItemContainer");
var _genericContentItemContainerDefault = parcelHelpers.interopDefault(_genericContentItemContainer);
var _featureTypeIds = require("../../constants/featureTypeIds");
class WelcomeMessageContainer extends (0, _genericContentItemContainerDefault.default) {
    constructor(...args){
        super(...args);
        // default state
        (0, _definePropertyDefault.default)(this, "state", {
            contentItems: [],
            isLoading: false,
            errors: [],
            isSaving: false,
            isSavingStub: false,
            isPublishing: false,
            isLoadingWebhooks: false,
            isUpdatingWebhooks: false,
            isTogglingSync: false,
            attachedWebhooks: [],
            hasWebhookUpdate: false,
            webhookUpdates: null
        });
        (0, _definePropertyDefault.default)(this, "mapModelToGenericContentItemModel", (model)=>({
                ...model,
                featureTypeId: this.featureTypeId
            }));
        (0, _definePropertyDefault.default)(this, "mapFormDataToModel", (originalModel, formData)=>({
                ...originalModel,
                webhookChainingType: formData.webhookChainingType,
                title: formData.title,
                isLive: formData.isLive,
                languages: formData.languages,
                responses: formData.responses,
                sensitiveConversationChange: formData.sensitiveConversationChange,
                disabledForFeatureFlagIds: formData.disabledForFeatureFlagIds,
                // we null these values out so they don't conflict with the responses field for variations        
                smallImage: null,
                largeImage: null,
                backgroundImage: null,
                audio: null,
                video: null,
                content: null,
                reprompt: null,
                followUp: null,
                mediaResponseContainer: null,
                mediaResponseContainerId: null,
                displayTitleOverride: null,
                displayTextOverride: null,
                followUpId: null,
                responseId: null
            }));
        (0, _definePropertyDefault.default)(this, "featureTypeId", (0, _featureTypeIds.WelcomeMessagesFeatureTypeId));
        (0, _definePropertyDefault.default)(this, "toggleLivePromise", (contentItemId, isLive)=>_api.toggleWelcomeMessageLive(contentItemId, isLive));
        (0, _definePropertyDefault.default)(this, "toggleSyncPromise", (contentItemId, shouldNotSync)=>_api.toggleWelcomeMessageSync(contentItemId, shouldNotSync));
        (0, _definePropertyDefault.default)(this, "copyPromise", (contentItemId)=>_api.copyWelcomeMessage(contentItemId));
        (0, _definePropertyDefault.default)(this, "deletePromise", (contentItemId)=>_api.deleteWelcomeMessage(contentItemId));
        (0, _definePropertyDefault.default)(this, "updatePromise", (contentItemId, model)=>_api.updateWelcomeMessage(contentItemId, model));
        (0, _definePropertyDefault.default)(this, "updateStubPromise", (contentItemId, model)=>_api.updateWelcomeMessage(contentItemId, model));
        (0, _definePropertyDefault.default)(this, "updateFromModelPromise", (model)=>_api.updateFullWelcomeMessage(model.id, model));
        (0, _definePropertyDefault.default)(this, "createPromise", (model)=>_api.addWelcomeMessage(model.applicationId, model));
        (0, _definePropertyDefault.default)(this, "createStubPromise", (model)=>_api.addWelcomeMessage(model.applicationId, model));
        (0, _definePropertyDefault.default)(this, "createFromModelPromise", (model)=>_api.addFullWelcomeMessage(model));
        (0, _definePropertyDefault.default)(this, "getContentItemsByAppFeaturePromise", (applicationFeatureId)=>_api.getWelcomeMessagesForAppFeature(applicationFeatureId));
        (0, _definePropertyDefault.default)(this, "getContentItemsByAppModulePromise", (applicationModuleId)=>null);
        // welcome messages don't have modules
        (0, _definePropertyDefault.default)(this, "getContentItemsByAppPromise", (applicationId)=>_api.getWelcomeMessagesForApp(applicationId));
        (0, _definePropertyDefault.default)(this, "findFullByIdPromise", (contentItemId)=>_api.findWelcomeMessage(contentItemId));
        (0, _definePropertyDefault.default)(this, "getPublishHistoryPromise", (contentItemId, environmentId, skip, take)=>_api.getWelcomeMessagePublishHistory(contentItemId, environmentId, skip, take));
        (0, _definePropertyDefault.default)(this, "getWebhooksPromise", (contentItemId)=>_api.getWelcomeMessageWebhooks(contentItemId));
        (0, _definePropertyDefault.default)(this, "removeWebhookPromise", (contentItemWebhookId)=>_api.removeWelcomeMessageWebhook(contentItemWebhookId));
        (0, _definePropertyDefault.default)(this, "bulkUpdateWebhookInstancesPromise", (contentItemId, updateRequest)=>_api.bulkUpdateWelcomeMessageWebhookInstances(contentItemId, updateRequest));
        (0, _definePropertyDefault.default)(this, "addWebhookPromise", (id, webhookId, defaultParameters, userDefinedParameters)=>_api.addWelcomeMessageWebhook(id, webhookId, defaultParameters, userDefinedParameters));
        (0, _definePropertyDefault.default)(this, "updateWebhookPromise", (id, webhookInstanceId, defaultParameters, userDefinedParameters)=>_api.updateWelcomeMessageWebhook(id, webhookInstanceId, defaultParameters, userDefinedParameters));
        (0, _definePropertyDefault.default)(this, "getSimpleSampleFlows", (contentItem, application)=>[
                {
                    requests: [
                        {
                            content: `Hello ${application.invocationPhrase}`,
                            highlights: [],
                            id: "1"
                        },
                        {
                            content: `Open ${application.invocationPhrase}`,
                            highlights: [],
                            id: "2"
                        },
                        {
                            content: `Start ${application.invocationPhrase}`,
                            highlights: [],
                            id: "3"
                        },
                        {
                            content: `Talk to ${application.invocationPhrase}`,
                            highlights: [],
                            id: "4"
                        }
                    ],
                    followUp: contentItem.followUp,
                    responses: [
                        {
                            content: contentItem.content,
                            highlights: [],
                            id: "10"
                        }
                    ],
                    requestTitle: "User Says",
                    responseTitle: "Device Response"
                }
            ]);
    }
}
exports.default = WelcomeMessageContainer;

},{"@babel/runtime/helpers/defineProperty":"9sJxO","../../api":"loxM6","./GenericContentItemContainer":"bgJ2b","../../constants/featureTypeIds":"hPLMP","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"lSKl8":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _defineProperty = require("@babel/runtime/helpers/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _api = require("../../api");
var _genericContentItemContainer = require("./GenericContentItemContainer");
var _genericContentItemContainerDefault = parcelHelpers.interopDefault(_genericContentItemContainer);
var _featureTypeIds = require("../../constants/featureTypeIds");
class ExitMessageContainer extends (0, _genericContentItemContainerDefault.default) {
    constructor(...args){
        super(...args);
        (0, _definePropertyDefault.default)(this, "getSimpleSampleFlows", (contentItem, application)=>[
                {
                    requests: [
                        {
                            content: "Exit",
                            highlights: [],
                            id: "1"
                        },
                        {
                            content: "Cancel",
                            highlights: [],
                            id: "2"
                        }
                    ],
                    reprompt: null,
                    followUp: null,
                    responses: [
                        {
                            content: contentItem.content,
                            highlights: [],
                            id: "10"
                        }
                    ],
                    requestTitle: "User Says",
                    responseTitle: "Device Response"
                }
            ]);
        // default state
        (0, _definePropertyDefault.default)(this, "state", {
            contentItems: [],
            isLoading: false,
            errors: [],
            isSaving: false,
            isSavingStub: false,
            isPublishing: false,
            isLoadingWebhooks: false,
            isUpdatingWebhooks: false,
            isTogglingSync: false,
            attachedWebhooks: [],
            hasWebhookUpdate: false,
            webhookUpdates: null
        });
        (0, _definePropertyDefault.default)(this, "mapModelToGenericContentItemModel", (model)=>({
                ...model,
                hasAudio: model.audio != null,
                hasVideo: model.video != null,
                hasImage: model.largeImage != null,
                hasBackgroundImage: model.backgroundImage != null,
                featureTypeId: (0, _featureTypeIds.ExitMessagesFeatureTypeId)
            }));
        (0, _definePropertyDefault.default)(this, "mapFormDataToModel", (originalModel, formData)=>({
                ...originalModel,
                webhookChainingType: formData.webhookChainingType,
                title: formData.title,
                isLive: formData.isLive,
                requiresParent: formData.requiresParent,
                languages: formData.languages,
                responses: formData.responses,
                sensitiveConversationChange: formData.sensitiveConversationChange,
                disabledForFeatureFlagIds: formData.disabledForFeatureFlagIds,
                // we null these values out so they don't conflict with the responses field for variations        
                smallImage: null,
                largeImage: null,
                backgroundImage: null,
                audio: null,
                video: null,
                content: null,
                reprompt: null,
                followUp: null,
                mediaResponseContainer: null,
                mediaResponseContainerId: null,
                displayTitleOverride: null,
                displayTextOverride: null,
                followUpId: null,
                responseId: null
            }));
        (0, _definePropertyDefault.default)(this, "featureTypeId", (0, _featureTypeIds.ExitMessagesFeatureTypeId));
        (0, _definePropertyDefault.default)(this, "getContentItemsByAppPromise", (applicationId)=>_api.getExitMessagesForApp(applicationId));
        (0, _definePropertyDefault.default)(this, "getContentItemsByAppModulePromise", (applicationModuleId)=>null);
        // not implemented
        (0, _definePropertyDefault.default)(this, "getContentItemsByAppFeaturePromise", (applicationFeatureId)=>_api.getExitMessagesForAppFeature(applicationFeatureId));
        (0, _definePropertyDefault.default)(this, "createPromise", (model)=>_api.addExitMessage(model.applicationId, model));
        (0, _definePropertyDefault.default)(this, "createStubPromise", (model)=>_api.addExitMessage(model.applicationId, model));
        (0, _definePropertyDefault.default)(this, "createFromModelPromise", (model)=>_api.addFullExitMessage(model));
        (0, _definePropertyDefault.default)(this, "updatePromise", (contentItemId, model)=>_api.updateExitMessage(contentItemId, model));
        (0, _definePropertyDefault.default)(this, "updateStubPromise", (contentItemId, model)=>_api.updateExitMessage(contentItemId, model));
        (0, _definePropertyDefault.default)(this, "updateFromModelPromise", (model)=>_api.updateFullExitMessage(model.id, model));
        (0, _definePropertyDefault.default)(this, "deletePromise", (contentItemId)=>_api.deleteExitMessage(contentItemId));
        (0, _definePropertyDefault.default)(this, "toggleLivePromise", (contentItemId, isLive)=>_api.toggleExitMessageLive(contentItemId, isLive));
        (0, _definePropertyDefault.default)(this, "toggleSyncPromise", (contentItemId, shouldNotSync)=>_api.toggleExitMessageSync(contentItemId, shouldNotSync));
        (0, _definePropertyDefault.default)(this, "copyPromise", (contentItemId)=>_api.copyExistMessage(contentItemId));
        (0, _definePropertyDefault.default)(this, "findFullByIdPromise", (contentItemId)=>_api.findExitMessage(contentItemId));
        (0, _definePropertyDefault.default)(this, "getPublishHistoryPromise", (contentItemId, environmentId, skip, take)=>_api.getExitMessagePublishHistory(contentItemId, environmentId, skip, take));
        (0, _definePropertyDefault.default)(this, "getWebhooksPromise", (contentItemId)=>_api.getExitMessageWebhooks(contentItemId));
        (0, _definePropertyDefault.default)(this, "removeWebhookPromise", (contentItemWebhookId)=>_api.removeExitMessageWebhook(contentItemWebhookId));
        (0, _definePropertyDefault.default)(this, "bulkUpdateWebhookInstancesPromise", (contentItemId, updateRequest)=>_api.bulkUpdateExitMessageWebhookInstances(contentItemId, updateRequest));
        (0, _definePropertyDefault.default)(this, "addWebhookPromise", (id, webhookId, defaultParameters, userDefinedParameters)=>_api.addExitMessageWebhook(id, webhookId, defaultParameters, userDefinedParameters));
        (0, _definePropertyDefault.default)(this, "updateWebhookPromise", (id, webhookInstanceId, defaultParameters, userDefinedParameters)=>_api.updateExitMessageWebhook(id, webhookInstanceId, defaultParameters, userDefinedParameters));
    }
}
exports.default = ExitMessageContainer;

},{"@babel/runtime/helpers/defineProperty":"9sJxO","../../api":"loxM6","./GenericContentItemContainer":"bgJ2b","../../constants/featureTypeIds":"hPLMP","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jPEkh":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _reactRouterDom = require("react-router-dom");
var _colors = require("../../../constants/colors");
var _largeOverflowMenu = require("../../../components/general/LargeOverflowMenu");
var _largeOverflowMenuDefault = parcelHelpers.interopDefault(_largeOverflowMenu);
var _checkIndicator = require("../../../components/forms/CheckIndicator");
var _checkIndicatorDefault = parcelHelpers.interopDefault(_checkIndicator);
var _confirmationDialog = require("../../../components/structure/ConfirmationDialog");
var _confirmationDialogDefault = parcelHelpers.interopDefault(_confirmationDialog);
var _deleteConfirmation = require("./DeleteConfirmation");
var _deleteConfirmationDefault = parcelHelpers.interopDefault(_deleteConfirmation);
var _webhookCountTag = require("../../../components/general/WebhookCountTag");
var _webhookCountTagDefault = parcelHelpers.interopDefault(_webhookCountTag);
const folderIcon = require("f9da1503673b49f1");
const deleteIcon = require("f4e9d278c6e69005");
const deleteRedIcon = require("641d2dc2430d6833");
const editIcon = require("acde70d4ca536dac");
const upIcon = require("957aa324e7c13711");
const downIcon = require("258003e56fe34d44");
const webhookIcon = require("a733a9a100767410");
const onHoverIcon = require("1caa40bc504d2124");
class FeatureItem extends (0, _reactDefault.default).Component {
    constructor(props){
        super(props);
        this.state = {
            isExpanded: false,
            isEditing: false,
            isDeleteConfirmationOpen: false,
            newName: this.props.feature?.name ?? this.props.feature?.feature?.name ?? "Untitled"
        };
    }
    handleToggleExpand() {
        if (!this.props.withNesting) return;
        this.setState({
            ...this.state,
            isExpanded: !this.state.isExpanded
        });
    }
    handleFinishRename() {
        if (this.state.newName) this.props.featureContainer.updateApplicationFeature(this.props.feature?.id, {
            name: this.state.newName
        }).then((result)=>{
            if (result.resultType == "Ok") this.setState({
                ...this.state,
                isEditing: false
            });
        });
        else this.setState({
            ...this.state,
            isEditing: false
        });
    }
    handleNameChange(e) {
        this.setState({
            ...this.state,
            newName: e.target.value
        });
    }
    handleOptionSelected(optionName) {
        if (optionName == "Rename") this.setState({
            ...this.state,
            isEditing: true
        }, ()=>this.inputElement?.focus());
        if (optionName == "Move Up") this.props.featureContainer.moveFeatureUp(this.props.feature?.id);
        if (optionName == "Move Down") this.props.featureContainer.moveFeatureDown(this.props.feature?.id);
        if (optionName == "Delete") this.setState({
            ...this.state,
            isDeleteConfirmationOpen: true
        });
        if (optionName == "Webhooks") this.props.onManageWebhooks(this.props.feature?.id);
    }
    handleDeleteConfirm() {
        this.props.featureContainer.deleteApplicationFeature(this.props.feature.id).then((result)=>{
            if (result.resultType == "Ok") this.setState({
                ...this.state,
                isDeleteConfirmationOpen: false
            });
        });
    }
    handleCloseModals() {
        this.setState({
            ...this.state,
            isDeleteConfirmationOpen: false
        });
    }
    handleEnterBlur(e) {
        if (e.charCode == 13) e.target.blur();
    }
    getOptions() {
        const options = [
            {
                label: "Rename",
                icon: editIcon,
                hoverIcon: editIcon
            },
            {
                label: "Delete",
                icon: deleteIcon,
                hoverIcon: deleteRedIcon,
                isDestructive: true
            }
        ];
        if (this.props.onManageWebhooks) options.push({
            label: "Webhooks",
            icon: webhookIcon,
            hoverIcon: webhookIcon
        });
        options.push({
            label: "Move Up",
            icon: upIcon,
            hoverIcon: upIcon
        });
        options.push({
            label: "Move Down",
            icon: downIcon,
            hoverIcon: downIcon
        });
        return options;
    }
    render() {
        const contentItemCount = this.props.featureContainer.getConversationCountForFeature(this.props.feature.id);
        const showWebhookCount = this.props.onManageWebhooks && (this.props.webhookInstanceCount ?? 0) > 0;
        return (0, _react.jsx)("div", {
            className: `${containerStyle} ${this.props.disabled ? "disabled" : ""} ${this.props.className ?? ""}`
        }, (0, _react.jsx)("div", {
            className: `feature-item ${this.props.index == 0 ? "top" : ""}`,
            onClick: this.handleToggleExpand.bind(this)
        }, (0, _react.jsx)("img", {
            className: "feature-item-hover-icon",
            src: onHoverIcon
        }), this.props.withNesting && (0, _react.jsx)("div", {
            className: "triangle-container"
        }, (0, _react.jsx)("div", {
            className: this.state.isExpanded ? "triangle-down" : "triangle-right"
        })), this.props.selectable && (0, _react.jsx)((0, _checkIndicatorDefault.default), {
            checkType: this.props.isSingleSelect ? "radio" : "check",
            checked: this.props.isSelected,
            onClick: this.props.disabled ? ()=>{} : ()=>this.props.onSelectionChange(this.props.feature, !this.props.isSelected),
            disabled: this.props.disabled,
            className: "ac-folder-check-box"
        }), this.state.isEditing ? (0, _react.jsx)("div", {
            className: "feature-link"
        }, (0, _react.jsx)("img", {
            className: "folder-icon",
            src: folderIcon
        }), (0, _react.jsx)("input", {
            className: "feature-title",
            placeholder: "New Folder",
            value: this.state.newName,
            ref: (r)=>this.inputElement = r,
            onChange: this.handleNameChange.bind(this),
            onBlur: this.handleFinishRename.bind(this),
            onKeyPress: (e)=>this.handleEnterBlur(e),
            onFocus: (e)=>e.target.select()
        })) : this.props.onClick ? (0, _react.jsx)("div", {
            className: "feature-link",
            onClick: this.props.disabled ? null : this.props.onClick
        }, (0, _react.jsx)("img", {
            className: "folder-icon",
            src: folderIcon
        }), (0, _react.jsx)("h4", {
            className: "feature-title ac-folder-title"
        }, this.props.feature.name ?? this.props.feature?.feature?.name ?? "Untitled")) : (0, _react.jsx)((0, _reactRouterDom.Link), {
            className: "feature-link",
            to: `/v/apps/${this.props.applicationId}/content/${this.props.feature.id}`
        }, (0, _react.jsx)("img", {
            className: "folder-icon",
            src: folderIcon
        }), (0, _react.jsx)("h4", {
            className: "feature-title ac-folder-title"
        }, this.props.feature.name ?? this.props.feature?.feature?.name ?? "Untitled")), showWebhookCount && (0, _react.jsx)((0, _webhookCountTagDefault.default), {
            className: "webhook-count",
            onClick: ()=>this.props.onManageWebhooks(this.props.feature.id),
            count: this.props.webhookInstanceCount
        }), (0, _react.jsx)("div", {
            className: `count-container ${showWebhookCount ? "no-margin-left" : ""} ac-folder-content-count`
        }, (0, _react.jsx)("h5", null, contentItemCount ?? "-"), (0, _react.jsx)("p", null, "CONVERSATIONS")), (0, _react.jsx)((0, _largeOverflowMenuDefault.default), {
            isActive: false,
            onOptionSelected: this.handleOptionSelected.bind(this),
            options: this.getOptions(),
            className: "ac-folder-overflow-menu"
        })), this.state.isDeleteConfirmationOpen && (0, _react.jsx)((0, _confirmationDialogDefault.default), {
            title: `Delete ${this.props.feature?.name ?? "Untitled"}`,
            deleteText: "Yes, Delete",
            isLoading: this.props.featureContainer.state.isDeleting,
            onClose: this.handleCloseModals.bind(this),
            onConfirm: this.handleDeleteConfirm.bind(this)
        }, (0, _react.jsx)((0, _deleteConfirmationDefault.default), {
            applicationFeatureCount: 1,
            contentItemCount: contentItemCount
        })));
    }
}
const containerStyle = /*#__PURE__*/ (0, _css.css)("&.dragging{.feature-item{border:1px solid ", (0, _colors.color_shades_dark), ";}.feature-item-hover-icon{visibility:visible;}}&.disabled{.feature-item{background:", (0, _colors.color_shades_lighter), ";cursor:not-allowed;.feature-title{background:", (0, _colors.color_shades_lighter), ";}}}.feature-item{height:80px;background:#FFFFFF;border-bottom:1px solid ", (0, _colors.color_shades_dark), ";box-sizing:border-box;display:flex;align-items:center;padding:0 32px 0 18px;&.top{border-top:1px solid ", (0, _colors.color_shades_dark), ";}.webhook-count{margin-left:auto;margin-right:16px;}.feature-link{cursor:pointer;display:flex;align-items:center;color:", (0, _colors.color_shades_darkest), ";}.folder-icon{width:56px;height:56px;}.feature-title{background:white;margin-left:-32px;margin-top:18px;font-family:Muli;font-style:normal;font-weight:600;font-size:18px;line-height:24px;padding-bottom:12px;border:none;color:", (0, _colors.color_text_default), ";white-space:nowrap;overflow:hidden;text-overflow:ellipsis;max-width:60vw;}.add-new-button-container{position:relative;}.count-container{text-align:right;margin-right:16px;margin-left:auto;border-right:1px solid ", (0, _colors.silver_four), ";padding:0 12px;&.no-margin-left{margin-left:0px;}h5{font-style:normal;font-weight:normal;font-size:18px;line-height:24px;}p{font-style:normal;font-weight:normal;font-size:12px;line-height:16px;color:", (0, _colors.color_shades_darker), ";}}.add-button{margin:0 24px;}}.feature-item-hover-icon{width:8px;height:24px;margin-right:6px;visibility:hidden;}.feature-item:hover .feature-item-hover-icon{visibility:visible;}.child-container{display:flex;align-items:stretch;.spacer{width:32px;background:#E9EAEE;border:1px solid ", (0, _colors.color_shades_dark), ";box-sizing:border-box;}.child-content-container{flex:1;}.child-content-items-container{padding:32px;background:", (0, _colors.color_shades_lighter), ";}.content-item{height:64px;padding:0 16px;display:flex;align-items:center;background:#FFFFFF;border:1px solid ", (0, _colors.color_shades_dark), ";box-sizing:border-box;border-radius:4px;.content-item-icon{width:24px;height:24px;margin-right:16px;}.feature-type-title{font-family:Muli;font-style:normal;font-weight:normal;font-size:12px;line-height:16px;color:", (0, _colors.color_shades_darker), ";}.content-title{font-style:normal;font-weight:normal;font-size:14px;line-height:20px;color:", (0, _colors.color_shades_darkest), ";}}}.triangle-down{width:0;height:0;border-left:3px solid transparent;border-right:3px solid transparent;border-top:3px solid ", (0, _colors.color_shades_darkest), ";}.triangle-right{width:0;height:0;border-top:3px solid transparent;border-bottom:3px solid transparent;border-left:3px solid ", (0, _colors.color_shades_darkest), ";}.triangle-container{width:3px;height:3px;margin-right:8px;}.check{margin-top:4px;}", "");
exports.default = FeatureItem;

},{"@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","react-router-dom":"5fzqq","../../../constants/colors":"1p3OR","../../../components/general/LargeOverflowMenu":"h9O0c","../../../components/forms/CheckIndicator":"8zBm6","../../../components/structure/ConfirmationDialog":"kx7yK","./DeleteConfirmation":"9xK2d","../../../components/general/WebhookCountTag":"94GuX","f9da1503673b49f1":"khmlm","f4e9d278c6e69005":"jrTqc","641d2dc2430d6833":"euMUu","acde70d4ca536dac":"1dzFf","957aa324e7c13711":"3qx1D","258003e56fe34d44":"iu0gE","a733a9a100767410":"e6PIG","1caa40bc504d2124":"dsDQ4","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9xK2d":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _colors = require("../../../constants/colors");
const bombIcon = require("6559ec2c5adf9e5f");
const containerStyle = /*#__PURE__*/ (0, _css.css)("display:flex;flex-direction:column;align-items:center;justify-content:center;margin:64px;img{width:82px;height:82px;margin-bottom:32px;}p{font-family:Muli;font-size:18px;font-weight:normal;font-style:normal;font-stretch:normal;line-height:normal;letter-spacing:0.5px;text-align:center;color:", (0, _colors.dark_grey_blue), ";}", "");
const getSelectionLabel = (applicationFeatureCount, contentItemCount)=>{
    var label = "";
    if (applicationFeatureCount > 0) label += ` ${applicationFeatureCount} Folder${applicationFeatureCount > 1 ? "s" : ""}`;
    if (contentItemCount > 0) {
        if (applicationFeatureCount > 0) label += " and ";
        label += ` ${contentItemCount} Conversation${contentItemCount > 1 ? "s" : ""}`;
    }
    return `${label}?`;
};
const DeleteConfirmation = (props)=>(0, _react.jsx)("div", {
        className: containerStyle
    }, (0, _react.jsx)("img", {
        src: bombIcon
    }), (0, _react.jsx)("p", null, "Are you sure you want to delete", (0, _react.jsx)("b", null, props.itemLabel ? ` ${props.itemLabel}` : getSelectionLabel(props.applicationFeatureCount, props.contentItemCount))));
exports.default = DeleteConfirmation;

},{"@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","../../../constants/colors":"1p3OR","6559ec2c5adf9e5f":"a89nH","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"a89nH":[function(require,module,exports) {
module.exports = require("af7e71793a6b0bb1").getBundleURL("kVLro") + require("1f229999364445c").resolve("6icML");

},{"af7e71793a6b0bb1":"c7Tr5","1f229999364445c":"fyJL2"}],"94GuX":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _css = require("@emotion/css");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _colors = require("../../constants/colors");
const webhookIcon = require("e6481b0e3352b386");
const WebhookCountTag = (props)=>(0, _react.jsx)("div", {
        onClick: props.onClick ?? null,
        className: `${webhookCountStyle} ${props.className ?? ""}`
    }, (0, _react.jsx)("img", {
        src: webhookIcon
    }), (0, _react.jsx)("div", null, props.count));
const webhookCountStyle = /*#__PURE__*/ (0, _css.css)("display:flex;width:45px;height:24px;border-radius:16px;padding:2px 8px;font-weight:normal;font-size:14px;line-height:20px;background:", (0, _colors.color_shades_lighter), ";color:", (0, _colors.color_shades_darkest), ";cursor:pointer;img{margin:2px 4px 0px 0px;height:16px;width:16px;}", "");
exports.default = WebhookCountTag;

},{"@emotion/react":"djZKr","@emotion/css":"awUBr","react":"6uln9","../../constants/colors":"1p3OR","e6481b0e3352b386":"e6PIG","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3qx1D":[function(require,module,exports) {
module.exports = require("4c7be50b2f78dfbf").getBundleURL("kVLro") + require("3f07a2b86600ec2e").resolve("59uHv");

},{"4c7be50b2f78dfbf":"c7Tr5","3f07a2b86600ec2e":"fyJL2"}],"iu0gE":[function(require,module,exports) {
module.exports = require("24d7178f8b593403").getBundleURL("kVLro") + require("f4f1f85b32ebd24c").resolve("3EVVl");

},{"24d7178f8b593403":"c7Tr5","f4f1f85b32ebd24c":"fyJL2"}],"bjl88":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _base = require("@emotion/styled/base");
var _baseDefault = parcelHelpers.interopDefault(_base);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _checkIndicator = require("../../../components/forms/CheckIndicator");
var _checkIndicatorDefault = parcelHelpers.interopDefault(_checkIndicator);
var _reactRouterDom = require("react-router-dom");
var _extensions = require("../../../models/extensions");
var _languageCollectionAvatar = require("../../../components/general/LanguageCollectionAvatar");
var _languageCollectionAvatarDefault = parcelHelpers.interopDefault(_languageCollectionAvatar);
var _colors = require("../../../constants/colors");
var _mediaIndicatorChip = require("../../../components/general/MediaIndicatorChip");
var _mediaIndicatorChipDefault = parcelHelpers.interopDefault(_mediaIndicatorChip);
var _moment = require("moment");
var _momentDefault = parcelHelpers.interopDefault(_moment);
var _webhookCountTag = require("../../../components/general/WebhookCountTag");
var _webhookCountTagDefault = parcelHelpers.interopDefault(_webhookCountTag);
var _contentItemListStatus = require("../../../components/general/ContentItemListStatus");
var _contentItemListStatusDefault = parcelHelpers.interopDefault(_contentItemListStatus);
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const noAccessImage = require("dbaa3506ee9dfd9e");
const targetedAccessImage = require("db877ff7cd4d0f25");
const onHoverIcon = require("92b69d310002ffc9");
const ContentListItem = (props)=>{
    const renderStatus = ()=>{
        return (0, _react.jsx)((0, _contentItemListStatusDefault.default), {
            dropDownDisabled: props.statusDropDownDisabled,
            isListView: true,
            handleUnpublish: props.handleUnpublish,
            handlePublish: props.handlePublish,
            loaded: props.isPublishLoaded,
            contentItem: props.contentItem,
            lastPublish: props.lastPublish
        });
    };
    const c = props.contentItem;
    const showWebhookCount = props.onManageWebhooks && (props.webhookInstanceCount ?? 0) > 0;
    const renderTitle = ()=>{
        return (0, _react.jsx)(ContentItemTitle, null, c.requiresParent && c.isLive && (0, _react.jsx)("img", {
            className: "ac-access-image",
            src: targetedAccessImage
        }), !c.isLive && (0, _react.jsx)("img", {
            className: "ac-access-image",
            src: noAccessImage
        }), (0, _react.jsx)("p", {
            className: `section-detail ac-content-list-item-title ${c.requiresParent && c.isLive || !c.isLive ? "with-image" : ""}`
        }, c.title ?? "Untitled"));
    };
    return (0, _react.jsx)("div", {
        className: `${containerStyle} ${props.disabled ? "disabled" : ""} ${props.className ?? ""} ${props.index == 0 ? "top" : ""}`
    }, (0, _react.jsx)("div", {
        className: `content-item ${props.index == 0 ? "top" : ""}`
    }, (0, _react.jsx)("img", {
        className: "content-item-hover-icon",
        src: onHoverIcon
    }), (0, _react.jsx)((0, _checkIndicatorDefault.default), {
        checkType: props.isSingleSelect ? "radio" : "check",
        checked: props.isSelected,
        onClick: props.disabled || !props.selectable ? ()=>{} : ()=>props.onSelectionChange(c, !props.isSelected),
        disabled: props.disabled || !props.selectable
    }), (0, _react.jsx)("img", {
        className: "content-item-icon",
        src: (0, _extensions.getFeatureTypeIcon)(c.featureTypeId)
    }), props.withLink ? (0, _react.jsx)((0, _reactRouterDom.Link), {
        key: c.id,
        to: (0, _extensions.getEditUrl)(c.id, props.applicationFeature.id, c.featureTypeId),
        className: "content-item-title-container"
    }, (0, _react.jsx)("p", {
        className: "section-title ac-content-list-item-type"
    }, (0, _extensions.getDefaultFeatureTypeName)(c.featureTypeId)), renderTitle()) : (0, _react.jsx)("div", {
        key: c.id,
        className: "content-item-title-container"
    }, (0, _react.jsx)("p", {
        className: "section-title"
    }, (0, _extensions.getDefaultFeatureTypeName)(c.featureTypeId)), renderTitle()), (0, _react.jsx)("div", {
        className: "content-details-container"
    }, (0, _react.jsx)("div", {
        className: "content-modified-container"
    }, (0, _react.jsx)("p", {
        className: "section-title"
    }, "Last Modified"), (0, _react.jsx)("p", {
        className: "section-detail"
    }, (0, _momentDefault.default)(c.modifiedDate).format("MMM DD, YYYY"))), (0, _react.jsx)("div", {
        className: "content-hits-container"
    }, (0, _react.jsx)("p", {
        className: "section-title"
    }, "Interactions"), (0, _react.jsx)("p", {
        className: "section-detail"
    }, c.hits)), (0, _react.jsx)("div", {
        className: "content-media-container ac-content-list-item-media"
    }, (0, _react.jsx)((0, _mediaIndicatorChipDefault.default), {
        hasAudio: c.hasAudio,
        hasImage: c.hasBackgroundImage || c.hasForegroundImage,
        hasVideo: c.hasVideo,
        hasBackground: false
    }))), showWebhookCount ? (0, _react.jsx)((0, _webhookCountTagDefault.default), {
        className: "webhook-count",
        onClick: ()=>props.onManageWebhooks(c),
        count: props.webhookInstanceCount
    }) : (0, _react.jsx)("span", {
        className: "webhook-count-filler"
    }), (0, _react.jsx)("div", {
        className: "content-item-languages-container"
    }, (0, _react.jsx)((0, _languageCollectionAvatarDefault.default), {
        languages: c.languages,
        limit: 3
    })), props.showStatus && (0, _react.jsx)("div", {
        className: "content-item-status-container"
    }, renderStatus())));
};
const ContentItemTitle = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1wim4iw0"
})({
    name: "1660rvd",
    styles: "display:flex;flex-direction:row;img{margin:2px 8px 0px 0px;}.with-image{margin-top:2px;}"
});
const containerStyle = /*#__PURE__*/ (0, _css.css)("&.draggable:hover .content-item-hover-icon{visibility:visible;}&.dragging{border:1px solid ", (0, _colors.color_shades_dark), ";.content-item-hover-icon{visibility:visible;}}&.disabled{.content-item{background:", (0, _colors.color_shades_lighter), ";cursor:not-allowed;}}height:80px;padding:0 16px;background:", (0, _colors.color_shades_light), ";box-sizing:border-box;&.top{border-top:1px solid ", (0, _colors.color_shades_dark), ";}border-bottom:1px solid ", (0, _colors.color_shades_dark), ";.webhook-count-filler{width:45px;}.content-item{background:", (0, _colors.color_defaults_white), ";box-sizing:border-box;border-radius:4px;border-left:1px solid ", (0, _colors.color_shades_dark), ";border-right:1px solid ", (0, _colors.color_shades_dark), ";display:flex;align-items:center;padding:0 16px 0 4px;height:100%;}.content-item-icon{width:48px;height:48px;margin-right:16px;}.content-item-hover-icon{width:8px;height:24px;margin-right:4px;visibility:hidden;}.section-title{font-family:Muli;font-style:normal;font-weight:normal;font-size:12px;line-height:16px;color:", (0, _colors.color_shades_darker), ";}.section-detail{font-style:normal;font-weight:normal;font-size:14px;line-height:20px;color:", (0, _colors.color_shades_darkest), ";}.content-item-title-container{flex:1;p{white-space:nowrap;overflow:hidden;text-overflow:ellipsis;max-width:25vw;}}.content-details-container{display:flex;align-items:center;margin-right:0;margin-left:auto;justify-content:flex-start;flex:1;}.content-modified-container,.content-hits-container,.content-media-container{padding:0 16px;}.content-hits-container{width:96px;}.content-modified-container{width:124px;}.content-item-status-container{margin-right:0;margin-left:0;width:124px;}.content-item-languages-container{margin-right:32px;margin-left:0;width:100px;>div{justify-content:flex-end;}}", "");
exports.default = ContentListItem;

},{"@emotion/styled/base":"lSuFu","@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","../../../components/forms/CheckIndicator":"8zBm6","react-router-dom":"5fzqq","../../../models/extensions":"7h01B","../../../components/general/LanguageCollectionAvatar":"crbMk","../../../constants/colors":"1p3OR","../../../components/general/MediaIndicatorChip":"f7ikb","moment":"2meyw","../../../components/general/WebhookCountTag":"94GuX","../../../components/general/ContentItemListStatus":"cSnWf","dbaa3506ee9dfd9e":"3hViE","db877ff7cd4d0f25":"c2eDa","92b69d310002ffc9":"dsDQ4","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"f7ikb":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _colors = require("../../constants/colors");
const imageIcon = require("2e82f1a45cdc861b");
const backgroundIcon = require("e0b3e65ee9f3097f");
const audioIcon = require("c74bde940f5bba14");
const videoIcon = require("c482d5bb16a409a9");
const attachIcon = require("6e61929f8a8e63f8");
const isEmpty = (props)=>{
    if (props.hasAudio) return false;
    if (props.hasVideo) return false;
    if (props.hasBackground) return false;
    if (props.hasImage) return false;
    return true;
};
const MediaIndicatorChip = (props)=>(0, _react.jsx)("div", {
        className: indicatorStyle
    }, (0, _react.jsx)("div", {
        className: "group-section-header"
    }, (0, _react.jsx)("p", null, "Media"), (0, _react.jsx)("img", {
        src: attachIcon
    })), props.hasAudio && (0, _react.jsx)("img", {
        src: audioIcon
    }), props.hasImage && (0, _react.jsx)("img", {
        src: imageIcon
    }), props.hasVideo && (0, _react.jsx)("img", {
        src: videoIcon
    }), props.hasBackground && (0, _react.jsx)("img", {
        src: backgroundIcon
    }), isEmpty(props) && (0, _react.jsx)("p", {
        className: "empty-label"
    }, "None"));
const indicatorStyle = /*#__PURE__*/ (0, _css.css)("display:flex;flex-direction:row;justify-content:center;align-items:center;border:1px solid ", (0, _colors.color_shades_dark), ";height:40px;box-sizing:border-box;border-radius:8px;padding:0 8px;.group-section-header{border-right:1px solid ", (0, _colors.color_shades_dark), ";display:flex;flex-direction:column;align-items:center;justify-content:center;margin-right:8px;padding-right:8px;img{width:16px;height:16px;}p{color:", (0, _colors.color_text_light), ";font-size:12px;line-height:16px;}}>img{width:22px;height:22px;margin:0 6px;}.empty-label{font-style:italic;font-weight:normal;font-size:12px;line-height:16px;color:", (0, _colors.color_text_light), ";}", "");
exports.default = MediaIndicatorChip;

},{"@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","../../constants/colors":"1p3OR","2e82f1a45cdc861b":"7XJJS","e0b3e65ee9f3097f":"5pK2Y","c74bde940f5bba14":"lcYWS","c482d5bb16a409a9":"jbgUU","6e61929f8a8e63f8":"iudLG","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"iudLG":[function(require,module,exports) {
module.exports = require("fcdd3aae0875b1d7").getBundleURL("kVLro") + require("84085e4ca86a3bf6").resolve("uSoeL");

},{"fcdd3aae0875b1d7":"c7Tr5","84085e4ca86a3bf6":"fyJL2"}],"cSnWf":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _base = require("@emotion/styled/base");
var _baseDefault = parcelHelpers.interopDefault(_base);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _colors = require("../../constants/colors");
var _moment = require("moment");
var _momentDefault = parcelHelpers.interopDefault(_moment);
var _analyticsDateFormat = require("../../models/analytics/AnalyticsDateFormat");
var _overflowMenu = require("./overflowMenu/OverflowMenu");
var _overflowMenuDefault = parcelHelpers.interopDefault(_overflowMenu);
var _toggleIndicator = require("./ToggleIndicator");
var _toggleIndicatorDefault = parcelHelpers.interopDefault(_toggleIndicator);
var _css = require("@emotion/css");
var _tooltipWrapper = require("./TooltipWrapper");
var _tooltipWrapperDefault = parcelHelpers.interopDefault(_tooltipWrapper);
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const greenCheck = require("e402f8308f9968bd");
const yellowUpdate = require("97aa60f9ee63927c");
const yellowDraft = require("f21eb562036c4a38");
const greyLoading = require("eedef365c893b751");
const syncedPublished = require("601b1b11c0efb4e7");
const syncedDraft = require("db58ea94c8d90d9a");
const syncedUpdated = require("b12f93588c61b864");
const incomplete = require("e57db9e12a50de0");
const PUBLISH = "Publish";
const PUBLISH_CHANGES = "Publish Changes";
const UNPUBLISH = "Unpublish";
const ContentItemListStatus = (props)=>{
    const [status, setStatus] = (0, _react1.useState)("unpublished");
    const [isOverflowExpanded, setIsOverflowExpanded] = (0, _react1.useState)(false);
    (0, _react1.useEffect)(()=>{
        const synced = props.contentItem?.createdFromId && !props.contentItem?.shouldNotSync;
        if (!props.loaded) setStatus("loading");
        else if (!props.contentItem?.isComplete) setStatus("incomplete");
        else if (!props.lastPublish || !props.contentItem || props.lastPublish.publishEventType == UNPUBLISH) {
            if (synced) setStatus("syncedUnpublished");
            else setStatus("unpublished");
        } else {
            const modifiedDate = (0, _momentDefault.default)(props.contentItem.modifiedDate, (0, _analyticsDateFormat.DATE_FORMAT));
            const publishDate = (0, _momentDefault.default)(props.lastPublish?.applicationEnvironmentPublish?.createdDate, (0, _analyticsDateFormat.DATE_FORMAT));
            if (modifiedDate.isAfter(publishDate)) {
                if (synced) setStatus("syncedUpdated");
                else setStatus("updated");
            } else if (synced) setStatus("syncedPublished");
            else setStatus("published");
        }
    }, [
        props.lastPublish,
        props.contentItem,
        props.loaded
    ]);
    const getStatusText = ()=>{
        if (props.isListView) switch(status){
            case "loading":
                return "Loading";
            case "unpublished":
            case "syncedUnpublished":
                return "Draft";
            case "published":
            case "syncedPublished":
                return "Published";
            case "updated":
            case "syncedUpdated":
                return "Updated";
            case "incomplete":
                return "Incomplete";
        }
        else switch(status){
            case "loading":
                return "Loading";
            case "unpublished":
                return "Draft";
            case "published":
                return "Published";
            case "updated":
                return "Updated";
            case "incomplete":
                return "Incomplete";
            case "syncedPublished":
                return "Synced & Published";
            case "syncedUnpublished":
                return "Synced Draft";
            case "syncedUpdated":
                return "Synced & Updated";
        }
    };
    const getStatusImage = ()=>{
        switch(status){
            case "loading":
                return greyLoading;
            case "unpublished":
                return yellowDraft;
            case "published":
                return greenCheck;
            case "updated":
                return yellowUpdate;
            case "syncedPublished":
                return syncedPublished;
            case "syncedUnpublished":
                return syncedDraft;
            case "syncedUpdated":
                return syncedUpdated;
            case "incomplete":
                return incomplete;
        }
    };
    const getOptions = ()=>{
        switch(status){
            case "loading":
                return [];
            case "unpublished":
                return [
                    {
                        label: PUBLISH,
                        isDisabled: props.optionsDisabled
                    }
                ];
            case "published":
                return [
                    {
                        label: UNPUBLISH,
                        isDisabled: props.optionsDisabled
                    }
                ];
            case "updated":
                return [
                    {
                        label: PUBLISH_CHANGES,
                        isDisabled: props.optionsDisabled
                    },
                    {
                        label: UNPUBLISH,
                        isDisabled: props.optionsDisabled
                    }
                ];
            case "syncedUnpublished":
                return [
                    {
                        label: PUBLISH,
                        isDisabled: props.optionsDisabled
                    }
                ];
            case "syncedPublished":
                return [
                    {
                        label: UNPUBLISH,
                        isDisabled: props.optionsDisabled
                    }
                ];
            case "syncedUpdated":
                return [
                    {
                        label: PUBLISH_CHANGES,
                        isDisabled: props.optionsDisabled
                    },
                    {
                        label: UNPUBLISH,
                        isDisabled: props.optionsDisabled
                    }
                ];
        }
    };
    const handleOptionSelected = async (label, event)=>{
        switch(label){
            case PUBLISH:
            case PUBLISH_CHANGES:
                props.handlePublish();
                break;
            case UNPUBLISH:
                props.handleUnpublish();
                break;
        }
    };
    const handleClick = ()=>{
        if (props.dropDownDisabled || status == "loading" || status == "incomplete") return;
        setIsOverflowExpanded(!isOverflowExpanded);
    };
    const renderListView = ()=>{
        return (0, _react.jsx)(ListViewContainer, {
            className: status,
            onClick: handleClick
        }, status.includes("synced") ? (0, _react.jsx)("div", {
            className: "text"
        }, (0, _react.jsx)("p", {
            className: "synced-text"
        }, "SYNCED"), (0, _react.jsx)("p", null, getStatusText())) : (0, _react.jsx)("p", null, getStatusText()), status == "incomplete" ? (0, _react.jsx)("div", {
            className: "incomplete"
        }, (0, _react.jsx)("div", {
            className: "incomplete-left"
        }), (0, _react.jsx)("img", {
            className: status,
            src: getStatusImage()
        }), (0, _react.jsx)("div", {
            className: "incomplete-right"
        })) : (0, _react.jsx)((0, _reactDefault.default).Fragment, null, (0, _react.jsx)("img", {
            className: status,
            src: getStatusImage()
        }), (0, _react.jsx)((0, _toggleIndicatorDefault.default), {
            disabled: props.dropDownDisabled,
            type: "chevron",
            direction: isOverflowExpanded ? "up" : "down"
        })), isOverflowExpanded && status != "loading" && (0, _react.jsx)(ListViewCustomOverflow, {
            className: listViewOverflowStyle,
            optionClassName: overflowOptionStyle,
            topOptionStyle: topOptionStyle,
            bottomOptionStyle: bottomOptionStyle,
            onClose: ()=>setIsOverflowExpanded(false),
            onOptionSelected: handleOptionSelected,
            options: getOptions()
        }));
    };
    const renderFormView = ()=>{
        return (0, _react.jsx)(FormViewContainer, null, (0, _react.jsx)("div", {
            className: "text"
        }, (0, _react.jsx)("p", null, "STATUS"), (0, _react.jsx)("p", {
            className: "status-text"
        }, getStatusText())), (0, _react.jsx)("div", {
            className: "status",
            onClick: handleClick
        }, (0, _react.jsx)("img", {
            className: status,
            src: getStatusImage()
        }), (0, _react.jsx)((0, _toggleIndicatorDefault.default), {
            disabled: props.dropDownDisabled || status == "incomplete",
            type: "chevron",
            direction: isOverflowExpanded ? "up" : "down"
        }), isOverflowExpanded && status != "loading" && (0, _react.jsx)(FormViewCustomOverflow, {
            className: formViewOverflowStyle,
            optionClassName: overflowOptionStyle,
            topOptionStyle: topOptionStyle,
            bottomOptionStyle: bottomOptionStyle,
            onClose: ()=>setIsOverflowExpanded(false),
            onOptionSelected: handleOptionSelected,
            options: getOptions()
        })));
    };
    return props.isListView ? props.dropDownDisabled ? (0, _react.jsx)((0, _tooltipWrapperDefault.default), {
        text: "Please run a full <br /> publish of your app <br /> before starting any <br /> partial publishes to <br /> avoid errors",
        place: "bottom"
    }, renderListView()) : renderListView() : props.dropDownDisabled ? (0, _react.jsx)((0, _tooltipWrapperDefault.default), {
        text: "Please run a full <br /> publish of your app <br /> before starting any <br /> partial publishes to <br /> avoid errors",
        place: "bottom"
    }, renderFormView()) : renderFormView();
};
const listViewOverflowStyle = /*#__PURE__*/ (0, _css.css)({
    name: "1j3casl",
    styles: "width:132px;margin-left:-122px;border-radius:4px"
});
const formViewOverflowStyle = /*#__PURE__*/ (0, _css.css)({
    name: "1l63hnt",
    styles: "width:204px;margin-left:-122px;border-radius:4px"
});
const topOptionStyle = /*#__PURE__*/ (0, _css.css)({
    name: "1l2mocu",
    styles: "border-top-right-radius:2px;border-top-left-radius:2px"
});
const bottomOptionStyle = /*#__PURE__*/ (0, _css.css)({
    name: "7uqlfu",
    styles: "border-bottom-right-radius:2px;border-bottom-left-radius:2px"
});
const overflowOptionStyle = /*#__PURE__*/ (0, _css.css)({
    name: "1vpqo4d",
    styles: "height:32px;p{font-size:12px;line-height:16px;margin:0 11px;}"
});
const ListViewCustomOverflow = /*#__PURE__*/ (0, _baseDefault.default)((0, _overflowMenuDefault.default), {
    target: "eif4hio3"
})({
    name: "1qepubj",
    styles: "position:absolute;top:24px;right:-20"
});
const FormViewCustomOverflow = /*#__PURE__*/ (0, _baseDefault.default)((0, _overflowMenuDefault.default), {
    target: "eif4hio2"
})({
    name: "15hz4d0",
    styles: "position:absolute;top:28px;right:-13"
});
const ListViewContainer = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "eif4hio1"
})("display:flex;align-items:center;margin-left:auto;justify-content:flex-end;cursor:pointer;position:relative;.incomplete{display:flex;flex-direction:row;.incomplete-left{border-left:1px solid ", (0, _colors.color_shades_dark), ";height:18px;margin-right:6px;}.incomplete-right{border-right:1px solid ", (0, _colors.color_shades_dark), ";height:18px;margin-left:-2px;}}.text{text-align:right;.synced-text{color:", (0, _colors.color_shades_darker), ";font-size:10px;}}&.loading{cursor:default;}flex:1;p{font-style:normal;font-weight:normal;font-size:14px;align-items:flex-end;text-align:right;margin-right:8px;}img{margin-right:8px;height:19px;width:20px;&.loading{animation:rotation 2s infinite linear;}}@keyframes rotation{from{transform:rotate(0deg);}to{transform:rotate(359deg);}}");
const FormViewContainer = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "eif4hio0"
})({
    name: "15pirp7",
    styles: "display:flex;flex-direction:row;align-items:center;.text{font-size:10px;text-align:right;margin-right:16px;.status-text{font-size:14px;}}.status{width:48px;height:28px;display:flex;border-radius:20px;background-color:white;align-items:center;margin-left:auto;justify-content:center;cursor:pointer;position:relative;&.loading{cursor:default;}p{font-style:normal;font-weight:normal;font-size:14px;display:flex;align-items:flex-end;text-align:right;margin-right:8px;}img{margin-right:8px;height:19px;width:20px;&.loading{animation:rotation 2s infinite linear;}}@keyframes rotation{from{transform:rotate(0deg);}to{transform:rotate(359deg);}}}"
});
exports.default = ContentItemListStatus;

},{"@emotion/styled/base":"lSuFu","@emotion/react":"djZKr","react":"6uln9","../../constants/colors":"1p3OR","moment":"2meyw","../../models/analytics/AnalyticsDateFormat":"ia5MW","./overflowMenu/OverflowMenu":"2V2SB","./ToggleIndicator":"4eej1","@emotion/css":"awUBr","./TooltipWrapper":"53pWd","e402f8308f9968bd":"2XYSM","97aa60f9ee63927c":"8yrG0","f21eb562036c4a38":"63StV","eedef365c893b751":"kopds","601b1b11c0efb4e7":"d72i6","db58ea94c8d90d9a":"h8Sjn","b12f93588c61b864":"eS4FM","e57db9e12a50de0":"cCzgp","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"ia5MW":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DATE_FORMAT", ()=>DATE_FORMAT);
parcelHelpers.export(exports, "SESSION_DATE_FORMAT", ()=>SESSION_DATE_FORMAT);
parcelHelpers.export(exports, "REVIEW_SESSION_DATE_FORMAT", ()=>REVIEW_SESSION_DATE_FORMAT);
const DATE_FORMAT = "YYYY-MM-DD hh:mm a";
const SESSION_DATE_FORMAT = "ddd, MMM Do hh:mm a";
const REVIEW_SESSION_DATE_FORMAT = "Do h:mm a";

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2XYSM":[function(require,module,exports) {
module.exports = require("ceaf58c8509f53cc").getBundleURL("kVLro") + require("670568ee58f273e5").resolve("di2LI");

},{"ceaf58c8509f53cc":"c7Tr5","670568ee58f273e5":"fyJL2"}],"8yrG0":[function(require,module,exports) {
module.exports = require("eaff2b8c70436de").getBundleURL("kVLro") + require("3419fcba7312e2d3").resolve("aSAYe");

},{"eaff2b8c70436de":"c7Tr5","3419fcba7312e2d3":"fyJL2"}],"63StV":[function(require,module,exports) {
module.exports = require("e5e373cda1ca8860").getBundleURL("kVLro") + require("4ca29d648577835a").resolve("fqIbe");

},{"e5e373cda1ca8860":"c7Tr5","4ca29d648577835a":"fyJL2"}],"kopds":[function(require,module,exports) {
module.exports = require("8e6d7121ff939cce").getBundleURL("kVLro") + require("933f39500c00f8c1").resolve("bdMIh");

},{"8e6d7121ff939cce":"c7Tr5","933f39500c00f8c1":"fyJL2"}],"d72i6":[function(require,module,exports) {
module.exports = require("f325a402d4fc9840").getBundleURL("kVLro") + require("ef40e289e7a7f5a7").resolve("26gES");

},{"f325a402d4fc9840":"c7Tr5","ef40e289e7a7f5a7":"fyJL2"}],"h8Sjn":[function(require,module,exports) {
module.exports = require("f53f888db2798c99").getBundleURL("kVLro") + require("b2b94c8539da61b0").resolve("j72IO");

},{"f53f888db2798c99":"c7Tr5","b2b94c8539da61b0":"fyJL2"}],"eS4FM":[function(require,module,exports) {
module.exports = require("5adecb1aa70aafb").getBundleURL("kVLro") + require("a46cf46848e18fdc").resolve("dKTbI");

},{"5adecb1aa70aafb":"c7Tr5","a46cf46848e18fdc":"fyJL2"}],"cCzgp":[function(require,module,exports) {
module.exports = require("d48bb14d0a63aa55").getBundleURL("kVLro") + require("2a2c07ac586490dc").resolve("ag4dY");

},{"d48bb14d0a63aa55":"c7Tr5","2a2c07ac586490dc":"fyJL2"}],"3hViE":[function(require,module,exports) {
module.exports = require("4446ac7aa7602ae5").getBundleURL("kVLro") + require("5989618787550a8").resolve("6q7H9");

},{"4446ac7aa7602ae5":"c7Tr5","5989618787550a8":"fyJL2"}],"c2eDa":[function(require,module,exports) {
module.exports = require("f028a402ca64a519").getBundleURL("kVLro") + require("65acb54741a118f").resolve("2eQSF");

},{"f028a402ca64a519":"c7Tr5","65acb54741a118f":"fyJL2"}],"j6GxB":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _colors = require("../../../constants/colors");
const emptyImage = require("177516ddcf9e607e");
const EmptyView = (props)=>(0, _react.jsx)("div", {
        className: containerStyle
    }, (0, _react.jsx)("img", {
        src: emptyImage
    }), (0, _react.jsx)("h4", null, props.text ?? "It's quiet in here!"), (0, _react.jsx)("p", null, props.subtext ?? "Try adding some new content"));
const containerStyle = /*#__PURE__*/ (0, _css.css)("display:flex;flex-direction:column;align-items:center;h4{font-size:24px;line-height:32px;margin-top:32px;color:", (0, _colors.color_text_default), ";text-align:center;}p{font-size:14px;line-height:20px;text-align:center;color:", (0, _colors.color_text_light), ";}", "");
exports.default = EmptyView;

},{"@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","../../../constants/colors":"1p3OR","177516ddcf9e607e":"3LAUC","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3LAUC":[function(require,module,exports) {
module.exports = require("7b5a831e2af9bab2").getBundleURL("kVLro") + require("4293e21dca4d3313").resolve("6hxzr");

},{"7b5a831e2af9bab2":"c7Tr5","4293e21dca4d3313":"fyJL2"}],"jx4R2":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _featureTypeFilter = require("./FeatureTypeFilter");
var _featureTypeFilterDefault = parcelHelpers.interopDefault(_featureTypeFilter);
var _modifiedDateFilter = require("./ModifiedDateFilter");
var _modifiedDateFilterDefault = parcelHelpers.interopDefault(_modifiedDateFilter);
var _filterWrapper = require("./FilterWrapper");
var _filterWrapperDefault = parcelHelpers.interopDefault(_filterWrapper);
var _miscellaneousFilter = require("./MiscellaneousFilter");
var _miscellaneousFilterDefault = parcelHelpers.interopDefault(_miscellaneousFilter);
var _languageFilter = require("./LanguageFilter");
var _languageFilterDefault = parcelHelpers.interopDefault(_languageFilter);
var _colors = require("../../../../constants/colors");
const searchIcon = require("df3e003e33c82982");
class ContentItemFilters extends (0, _reactDefault.default).Component {
    componentDidMount() {
        this.searchRef?.focus();
    }
    handleLanguageFilterChange(languageIds) {
        this.props.onChange({
            ...this.props.currentFilter,
            languageIdsFilter: languageIds
        });
    }
    handleFeatureFilterChange(featureTypeIds) {
        this.props.onChange({
            ...this.props.currentFilter,
            featureTypeIdsFilter: featureTypeIds
        });
    }
    handleModifiedDateRangeChange(days) {
        this.props.onChange({
            ...this.props.currentFilter,
            daysFilter: days
        });
    }
    handleMiscFilterChange(properties) {
        this.props.onChange({
            ...this.props.currentFilter,
            propertiesFilter: properties
        });
    }
    handleSearchTextChange(e) {
        this.props.onChange({
            ...this.props.currentFilter,
            textFilter: e.target.value
        });
    }
    render() {
        return (0, _react.jsx)("div", {
            className: containerStyle
        }, (0, _react.jsx)("div", {
            className: "search-bar"
        }, (0, _react.jsx)("label", null, "Filter by Title"), (0, _react.jsx)("div", {
            className: "input-wrapper"
        }, (0, _react.jsx)("img", {
            src: searchIcon
        }), (0, _react.jsx)("input", {
            ref: (search)=>this.searchRef = search,
            value: this.props.currentFilter?.textFilter ?? "",
            placeholder: "Filter by Title",
            onChange: this.handleSearchTextChange.bind(this)
        }))), (0, _react.jsx)("div", {
            className: "filters-wrapper"
        }, (0, _react.jsx)((0, _filterWrapperDefault.default), null, (0, _react.jsx)((0, _featureTypeFilterDefault.default), {
            onChange: this.handleFeatureFilterChange.bind(this),
            featureTypeIds: this.props.currentFilter?.featureTypeIdsFilter,
            featureTypes: this.props.featureTypes
        })), (0, _react.jsx)((0, _filterWrapperDefault.default), null, (0, _react.jsx)((0, _languageFilterDefault.default), {
            onChange: this.handleLanguageFilterChange.bind(this),
            languageIds: this.props.currentFilter?.languageIdsFilter,
            languages: this.props.languages
        })), (0, _react.jsx)((0, _filterWrapperDefault.default), null, (0, _react.jsx)((0, _modifiedDateFilterDefault.default), {
            onChange: this.handleModifiedDateRangeChange.bind(this),
            days: this.props.currentFilter?.daysFilter
        })), (0, _react.jsx)((0, _filterWrapperDefault.default), null, (0, _react.jsx)((0, _miscellaneousFilterDefault.default), {
            onChange: this.handleMiscFilterChange.bind(this),
            propertiesFilter: this.props.currentFilter?.propertiesFilter
        }))));
    }
}
const containerStyle = /*#__PURE__*/ (0, _css.css)("border-bottom:1px solid ", (0, _colors.color_shades_dark), ";background:", (0, _colors.color_shades_lighter), ";padding:16px 16px 24px 16px;.search-bar{display:flex;align-items:center;padding-bottom:16px;margin:0 16px;border-bottom:1px solid ", (0, _colors.color_shades_dark), ";label{color:", (0, _colors.color_text_default), ";font-size:16px;line-height:24px;}.input-wrapper{background:white;border-radius:8px;border:1px solid ", (0, _colors.color_shades_dark), ";margin-left:12px;flex:1;display:flex;align-items:center;height:48px;padding:0 16px;img{margin-right:12px;}&:focus-within{border:1px solid ", (0, _colors.color_colors_ocean), ";}}input{border:none;background:transparent;flex:1;color:", (0, _colors.color_text_default), ";line-height:20px;font-size:14px;::placeholder{font-style:italic;color:", (0, _colors.color_text_light), ";font-weight:normal;line-height:20px;font-size:14px;}}}.filters-wrapper{display:flex;justify-content:stretch;max-width:100%;flex-basis:0;}", "");
exports.default = ContentItemFilters;

},{"@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","./FeatureTypeFilter":"hPsbA","./ModifiedDateFilter":"8A5a8","./FilterWrapper":"14Hzc","./MiscellaneousFilter":"bjlLO","./LanguageFilter":"1PgH5","../../../../constants/colors":"1p3OR","df3e003e33c82982":"6eytJ","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hPsbA":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _filterSelector = require("./FilterSelector");
var _filterSelectorDefault = parcelHelpers.interopDefault(_filterSelector);
var _filterOption = require("./FilterOption");
var _filterOptionDefault = parcelHelpers.interopDefault(_filterOption);
var _extensions = require("../../../../models/extensions");
var _customScrollbars = require("../../../../components/structure/CustomScrollbars");
var _customScrollbarsDefault = parcelHelpers.interopDefault(_customScrollbars);
const featureTypeIconLight = require("48d917c404c0915a");
const featureTypeIcon = require("b9a7f6d9d64a80d7");
class FeatureTypeFilter extends (0, _reactDefault.default).Component {
    handleToggleFeatureType(featureTypeId) {
        var featureTypeIds = this.props.featureTypeIds ?? [];
        if (featureTypeIds.some((l)=>l == featureTypeId)) featureTypeIds.splice(featureTypeIds.indexOf(featureTypeId), 1);
        else featureTypeIds.push(featureTypeId);
        this.props.onChange(featureTypeIds);
    }
    handleClear() {
        this.props.onChange(null);
    }
    render() {
        const props = this.props;
        const selectedText = props.featureTypes.filter((f)=>props.featureTypeIds?.some((id)=>id == f.id))?.map((f)=>f.name)?.join(", ");
        return (0, _react.jsx)((0, _filterSelectorDefault.default), {
            label: "Interaction Type",
            icon: selectedText ? featureTypeIcon : featureTypeIconLight,
            placeholder: "All Interaction Types",
            selectedText: selectedText,
            onClear: this.handleClear.bind(this)
        }, (0, _react.jsx)((0, _customScrollbarsDefault.default), {
            autoHide: true,
            autoHeight: true,
            autoHeightMax: 400
        }, (0, _react.jsx)((0, _filterOptionDefault.default), {
            title: "- Select All / None -",
            onClick: ()=>props.onChange([]),
            isSelected: !props.featureTypeIds,
            isPartialSelected: true,
            optionType: "check"
        }), props.featureTypes.map((f)=>(0, _react.jsx)((0, _filterOptionDefault.default), {
                key: f.id,
                title: f.name,
                icon: (0, _extensions.getFeatureTypeIcon)(f.id, true),
                selectedIcon: (0, _extensions.getFeatureTypeIcon)(f.id),
                isSelected: props.featureTypeIds?.some((id)=>id == f.id),
                optionType: "check",
                onClick: ()=>this.handleToggleFeatureType(f.id)
            }))));
    }
}
exports.default = FeatureTypeFilter;

},{"@emotion/react":"djZKr","react":"6uln9","./FilterSelector":"gM8wu","./FilterOption":"bAS9P","../../../../models/extensions":"7h01B","../../../../components/structure/CustomScrollbars":"50vFq","48d917c404c0915a":"9TLNI","b9a7f6d9d64a80d7":"4sFzt","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"gM8wu":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _defineProperty = require("@babel/runtime/helpers/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _toggleIndicator = require("../../../../components/general/ToggleIndicator");
var _toggleIndicatorDefault = parcelHelpers.interopDefault(_toggleIndicator);
var _colors = require("../../../../constants/colors");
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
class FilterSelector extends (0, _reactDefault.default).Component {
    constructor(props){
        super(props);
        (0, _definePropertyDefault.default)(this, "documentCloser", this.handleDocumentClick.bind(this));
        this.state = {
            isExpanded: false
        };
    }
    componentWillMount() {
        document.addEventListener("click", this.documentCloser, true);
    }
    componentWillUnmount() {
        document.removeEventListener("click", this.documentCloser, true);
    }
    handleDocumentClick(e) {
        if (e.target.closest(".filter-options") || e.target.closest(".filter-field")) return;
        this.setState({
            ...this.state,
            isExpanded: false
        });
    }
    handleToggle() {
        this.setState({
            ...this.state,
            isExpanded: !this.state.isExpanded
        });
    }
    render() {
        return (0, _react.jsx)("div", {
            className: containerStyle
        }, (0, _react.jsx)("div", {
            className: "label-container"
        }, (0, _react.jsx)("label", null, this.props.label), this.props.selectedText && (0, _react.jsx)("button", {
            type: "button",
            onClick: this.props.onClear
        }, "Clear")), (0, _react.jsx)("div", {
            className: "filter-field",
            onClick: this.handleToggle.bind(this)
        }, (0, _react.jsx)("img", {
            src: this.props.icon
        }), this.props.selectedText ? (0, _react.jsx)("p", {
            className: "selection-value"
        }, this.props.selectedText) : (0, _react.jsx)("p", {
            className: "placeholder"
        }, this.props.placeholder), (0, _react.jsx)((0, _toggleIndicatorDefault.default), {
            direction: this.state.isExpanded ? "up" : "down"
        })), this.state.isExpanded && (0, _react.jsx)("div", {
            className: "filter-options"
        }, (0, _react.jsx)("div", {
            className: triangleStyle
        }), (0, _react.jsx)("div", {
            className: "inner-options"
        }, this.props.children)));
    }
}
const containerStyle = /*#__PURE__*/ (0, _css.css)("position:relative;min-width:248px;.label-container{display:flex;align-items:center;margin-bottom:8px;label{font-size:12px;margin-left:16px;}button{color:", (0, _colors.color_text_link), ";border:none;background:none;margin-left:auto;margin-right:16px;font-style:normal;font-weight:normal;font-size:12px;cursor:pointer;}}.filter-field{background:white;border:1px solid ", (0, _colors.color_shades_dark), ";box-sizing:border-box;border-radius:4px;height:48px;display:flex;align-items:center;padding:0 16px;cursor:pointer;.placeholder{font-style:italic;font-weight:normal;font-size:14px;line-height:20px;color:#8F97A1;}.toggle-indicator{margin-right:0;margin-left:auto;}p{white-space:nowrap;overflow:hidden;text-overflow:ellipsis;}img{margin-right:12px;}}.filter-options{position:absolute;margin-top:12px;width:100%;.inner-options{position:relative;z-index:1;overflow-x:hidden;border:1px solid ", (0, _colors.color_shades_dark), ";border-radius:8px;width:100%;box-shadow:0 4px 4px 0 ", (0, _colors.dark_grey_blue_10), ";background:white;}}", "");
const triangleStyle = /*#__PURE__*/ (0, _css.css)({
    name: "n2w3ez",
    styles: "transform:rotate(45deg);width:12px;height:12px;margin-top:-7px;margin-bottom:-6px;border-top:solid 1px #cccccc;border-left:solid 1px #cccccc;background:white;margin-right:16px;margin-left:auto;z-index:2"
});
exports.default = FilterSelector;

},{"@babel/runtime/helpers/defineProperty":"9sJxO","@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","../../../../components/general/ToggleIndicator":"4eej1","../../../../constants/colors":"1p3OR","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"bAS9P":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _colors = require("../../../../constants/colors");
var _checkIndicator = require("../../../../components/forms/CheckIndicator");
var _checkIndicatorDefault = parcelHelpers.interopDefault(_checkIndicator);
var _toggleIndicator = require("../../../../components/general/ToggleIndicator");
var _toggleIndicatorDefault = parcelHelpers.interopDefault(_toggleIndicator);
const FilterOption = (props)=>(0, _react.jsx)("div", {
        className: `${containerStyle} ${props.isChild ? "child" : ""} ${props.isSelected ? "selected" : ""}`,
        onClick: props.onClick
    }, props.optionType == "check" && (0, _react.jsx)((0, _checkIndicatorDefault.default), {
        checked: props.isSelected,
        partial: props.isPartialSelected,
        onClick: (event)=>{
            event.stopPropagation();
            if (props.onCheckClick == null) props.onClick();
            else props.onCheckClick();
        }
    }), props.icon && (0, _react.jsx)("img", {
        className: "option-icon",
        src: props.isSelected ? props.selectedIcon : props.icon
    }), (0, _react.jsx)("p", null, props.title), props.hasChildren && (0, _react.jsx)((0, _toggleIndicatorDefault.default), {
        direction: props.isExpanded ? "up" : "down"
    }));
const containerStyle = /*#__PURE__*/ (0, _css.css)("display:flex;align-items:center;padding:0 16px;height:48px;background:white;border-bottom:1px solid ", (0, _colors.silver_four), ";cursor:pointer;.option-icon{width:24px;height:24px;margin:0 8px 0 0;}&.child{padding-left:45px;border-left:2px solid ", (0, _colors.silver_four), ";background:#FCFDFE;}.toggle-indicator{margi-right:0;margin-left:auto;}&.selected{p{color:#1E7EB9;}}", "");
exports.default = FilterOption;

},{"@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","../../../../constants/colors":"1p3OR","../../../../components/forms/CheckIndicator":"8zBm6","../../../../components/general/ToggleIndicator":"4eej1","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9TLNI":[function(require,module,exports) {
module.exports = require("83a255548083ba94").getBundleURL("kVLro") + require("5dd86eca75d5029d").resolve("jf227");

},{"83a255548083ba94":"c7Tr5","5dd86eca75d5029d":"fyJL2"}],"4sFzt":[function(require,module,exports) {
module.exports = require("89835ad119c721f4").getBundleURL("kVLro") + require("db0df7fc8091e765").resolve("kYqGP");

},{"89835ad119c721f4":"c7Tr5","db0df7fc8091e765":"fyJL2"}],"8A5a8":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _filterSelector = require("./FilterSelector");
var _filterSelectorDefault = parcelHelpers.interopDefault(_filterSelector);
var _filterOption = require("./FilterOption");
var _filterOptionDefault = parcelHelpers.interopDefault(_filterOption);
const dateIconLight = require("95923710d3f0f601");
const dateIcon = require("17499193100015d7");
const ModifiedDateFilter = (props)=>(0, _react.jsx)((0, _filterSelectorDefault.default), {
        label: "Last Updated",
        icon: props.days ? dateIcon : dateIconLight,
        placeholder: "All Time",
        selectedText: props.days ? `Past ${props.days} days` : null,
        onClear: ()=>props.onChange(null)
    }, (0, _react.jsx)((0, _filterOptionDefault.default), {
        title: "All Time",
        onClick: ()=>props.onChange(null),
        isSelected: !props.days,
        optionType: "check"
    }), (0, _react.jsx)((0, _filterOptionDefault.default), {
        title: "Past 7 Days",
        onClick: ()=>props.onChange(7),
        isSelected: props.days == 7,
        optionType: "check"
    }), (0, _react.jsx)((0, _filterOptionDefault.default), {
        title: "Past 30 Days",
        onClick: ()=>props.onChange(30),
        isSelected: props.days == 30,
        optionType: "check"
    }), (0, _react.jsx)((0, _filterOptionDefault.default), {
        title: "Past 90 Days",
        onClick: ()=>props.onChange(90),
        isSelected: props.days == 90,
        optionType: "check"
    }), (0, _react.jsx)((0, _filterOptionDefault.default), {
        title: "Past Year",
        onClick: ()=>props.onChange(365),
        isSelected: props.days == 365,
        optionType: "check"
    }));
exports.default = ModifiedDateFilter;

},{"@emotion/react":"djZKr","react":"6uln9","./FilterSelector":"gM8wu","./FilterOption":"bAS9P","95923710d3f0f601":"kiBJZ","17499193100015d7":"j7r8s","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"kiBJZ":[function(require,module,exports) {
module.exports = require("431c8f3c0ebc4d33").getBundleURL("kVLro") + require("7b06c00fe4376bfa").resolve("7rycF");

},{"431c8f3c0ebc4d33":"c7Tr5","7b06c00fe4376bfa":"fyJL2"}],"j7r8s":[function(require,module,exports) {
module.exports = require("5acc30d40ef0884").getBundleURL("kVLro") + require("6eac6740dd799b1d").resolve("8p6ir");

},{"5acc30d40ef0884":"c7Tr5","6eac6740dd799b1d":"fyJL2"}],"14Hzc":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// used to manage and manipulate the inner styles of the filters 
// against the grouped multi selector
const FilterWrapper = (props)=>(0, _react.jsx)("div", {
        className: wrapperStyle
    }, props.children);
const wrapperStyle = /*#__PURE__*/ (0, _css.css)({
    name: "1t8nlpd",
    styles: "margin:16px 16px 0 16px;flex:1;max-width:24%"
});
exports.default = FilterWrapper;

},{"@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"bjlLO":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _filterSelector = require("./FilterSelector");
var _filterSelectorDefault = parcelHelpers.interopDefault(_filterSelector);
var _filterOption = require("./FilterOption");
var _filterOptionDefault = parcelHelpers.interopDefault(_filterOption);
const propertiesIconLight = require("b034d38c64e13011");
const propertiesIcon = require("d6c1b8cdeba0a8fd");
const MiscellaneousFilter = (props)=>{
    const [isMediaExpanded, setIsMediaExpanded] = (0, _react1.useState)(true);
    const [isPublishedExpanded, setIsPublishedExpanded] = (0, _react1.useState)(true);
    const handleToggleMedia = ()=>{
        setIsMediaExpanded(!isMediaExpanded);
    };
    const handleTogglePublished = ()=>{
        setIsPublishedExpanded(!isPublishedExpanded);
    };
    const getSelectedText = (props)=>{
        const propertiesFilter = props.propertiesFilter;
        let label = "";
        if (propertiesFilter?.hasAudio) label += "Has Audio, ";
        if (propertiesFilter?.hasVideo) label += "Has Video, ";
        if (propertiesFilter?.hasImage) label += "Has Image, ";
        if (propertiesFilter?.isPublished) label += "Publish Status: Published, ";
        if (propertiesFilter?.isDraft) label += "Publish Status: Draft, ";
        if (propertiesFilter?.isUpdated) label += "Publish Status: Updated, ";
        if (propertiesFilter?.isIncomplete) label += "Publish Status: Incomplete, ";
        if (propertiesFilter?.isSyncedAndPublished) label += "Publish Status: Synced & Published";
        if (propertiesFilter?.isSyncedDraft) label += "Publish Status: Synced Draft";
        if (propertiesFilter?.isSyncedAndUpdated) label += "Publish Status: Synced & Updated";
        return label;
    };
    const getIsMediaPartiallySelected = (props)=>{
        const propertiesFilter = props?.propertiesFilter;
        return (propertiesFilter?.hasAudio || propertiesFilter?.hasVideo || propertiesFilter?.hasImage) && !getIsMediaSelected(props);
    };
    const getIsMediaSelected = (props)=>{
        const propertiesFilter = props?.propertiesFilter;
        return propertiesFilter?.hasAudio && propertiesFilter?.hasVideo && propertiesFilter?.hasImage;
    };
    const getIsStatusPartiallySelected = (props)=>{
        const propertiesFilter = props?.propertiesFilter;
        return propertiesFilter?.isPublished || propertiesFilter?.isDraft || propertiesFilter?.isUpdated || propertiesFilter?.IsIncomplete || propertiesFilter?.isSyncedAndPublished || propertiesFilter?.isSyncedDraft || propertiesFilter?.isSyncedAndUpdated && !getIsStatusSelected(props);
    };
    const getIsStatusSelected = (props)=>{
        const propertiesFilter = props?.propertiesFilter;
        return propertiesFilter?.isPublished && propertiesFilter?.isDraft && propertiesFilter?.isUpdated && propertiesFilter?.IsIncomplete && propertiesFilter?.isSyncedAndPublished && propertiesFilter?.isSyncedDraft && propertiesFilter?.isSyncedAndUpdated;
    };
    const handleMediaGroupToggle = (props, getIsMediaSelected)=>{
        if (getIsMediaSelected()) props.onChange({
            ...props.propertiesFilter,
            hasImage: false,
            hasAudio: false,
            hasVideo: false
        });
        else props.onChange({
            ...props.propertiesFilter,
            hasImage: true,
            hasAudio: true,
            hasVideo: true
        });
    };
    const handleStatusGroupToggle = (props, getIsStatusSelected)=>{
        if (getIsStatusSelected()) props.onChange({
            ...props.propertiesFilter,
            isPublished: false,
            isDraft: false,
            isUpdated: false,
            isIncomplete: false,
            isSyncedAndPublished: false,
            isSyncedDraft: false,
            isSyncedAndUpdated: false
        });
        else props.onChange({
            ...props.propertiesFilter,
            isPublished: true,
            isDraft: true,
            isUpdated: true,
            isIncomplete: true,
            isSyncedAndPublished: true,
            isSyncedDraft: true,
            isSyncedAndUpdated: true
        });
    };
    const handleClear = (props)=>{
        props.onChange(null);
    };
    const selectedText = getSelectedText(props);
    return (0, _react.jsx)((0, _filterSelectorDefault.default), {
        label: "Properties",
        icon: selectedText ? propertiesIcon : propertiesIconLight,
        placeholder: "Any Properties",
        selectedText: selectedText,
        onClear: handleClear.bind(undefined)
    }, (0, _react.jsx)((0, _filterOptionDefault.default), {
        isPartialSelected: getIsMediaPartiallySelected(props),
        isSelected: getIsMediaSelected(props),
        hasChildren: true,
        isExpanded: isMediaExpanded,
        onClick: handleToggleMedia.bind(undefined),
        onCheckClick: handleMediaGroupToggle.bind(undefined),
        title: "Has Media",
        optionType: "check"
    }), isMediaExpanded && (0, _react.jsx)((0, _reactDefault.default).Fragment, null, (0, _react.jsx)((0, _filterOptionDefault.default), {
        isSelected: props.propertiesFilter?.hasImage,
        onClick: ()=>props.onChange({
                ...props.propertiesFilter,
                hasImage: !props.propertiesFilter?.hasImage ?? true
            }),
        title: "Image",
        optionType: "check",
        isChild: true
    }), (0, _react.jsx)((0, _filterOptionDefault.default), {
        isSelected: props.propertiesFilter?.hasAudio,
        onClick: ()=>props.onChange({
                ...props.propertiesFilter,
                hasAudio: !props.propertiesFilter?.hasAudio ?? true
            }),
        title: "Audio",
        optionType: "check",
        isChild: true
    }), (0, _react.jsx)((0, _filterOptionDefault.default), {
        isSelected: props.propertiesFilter?.hasVideo,
        onClick: ()=>props.onChange({
                ...props.propertiesFilter,
                hasVideo: !props.propertiesFilter?.hasVideo ?? true
            }),
        title: "Video",
        optionType: "check",
        isChild: true
    })), (0, _react.jsx)((0, _filterOptionDefault.default), {
        isPartialSelected: getIsStatusPartiallySelected(props),
        isSelected: getIsStatusSelected(props),
        hasChildren: true,
        isExpanded: isPublishedExpanded,
        onClick: handleTogglePublished.bind(undefined),
        onCheckClick: handleStatusGroupToggle.bind(undefined),
        title: "Publish Status",
        optionType: "check"
    }), isPublishedExpanded && (0, _react.jsx)((0, _reactDefault.default).Fragment, null, (0, _react.jsx)((0, _filterOptionDefault.default), {
        isSelected: props.propertiesFilter?.isPublished,
        onClick: ()=>props.onChange({
                ...props.propertiesFilter,
                isPublished: !props.propertiesFilter?.isPublished ?? true
            }),
        title: "Published",
        optionType: "check",
        isChild: true
    }), (0, _react.jsx)((0, _filterOptionDefault.default), {
        isSelected: props.propertiesFilter?.isDraft,
        onClick: ()=>props.onChange({
                ...props.propertiesFilter,
                isDraft: !props.propertiesFilter?.isDraft ?? true
            }),
        title: "Draft",
        optionType: "check",
        isChild: true
    }), (0, _react.jsx)((0, _filterOptionDefault.default), {
        isSelected: props.propertiesFilter?.isUpdated,
        onClick: ()=>props.onChange({
                ...props.propertiesFilter,
                isUpdated: !props.propertiesFilter?.isUpdated ?? true
            }),
        title: "Updated",
        optionType: "check",
        isChild: true
    }), (0, _react.jsx)((0, _filterOptionDefault.default), {
        isSelected: props.propertiesFilter?.isIncomplete,
        onClick: ()=>props.onChange({
                ...props.propertiesFilter,
                isIncomplete: !props.propertiesFilter?.isIncomplete ?? true
            }),
        title: "Incomplete",
        optionType: "check",
        isChild: true
    }), (0, _react.jsx)((0, _filterOptionDefault.default), {
        isSelected: props.propertiesFilter?.isSyncedAndPublished,
        onClick: ()=>props.onChange({
                ...props.propertiesFilter,
                isSyncedAndPublished: !props.propertiesFilter?.isSyncedAndPublished ?? true
            }),
        title: "Synced & Published",
        optionType: "check",
        isChild: true
    }), (0, _react.jsx)((0, _filterOptionDefault.default), {
        isSelected: props.propertiesFilter?.isSyncedDraft,
        onClick: ()=>props.onChange({
                ...props.propertiesFilter,
                isSyncedDraft: !props.propertiesFilter?.isSyncedDraft ?? true
            }),
        title: "Synced Draft",
        optionType: "check",
        isChild: true
    }), (0, _react.jsx)((0, _filterOptionDefault.default), {
        isSelected: props.propertiesFilter?.isSyncedAndUpdated,
        onClick: ()=>props.onChange({
                ...props.propertiesFilter,
                isSyncedAndUpdated: !props.propertiesFilter?.isSyncedAndUpdated ?? true
            }),
        title: "Synced & Updated",
        optionType: "check",
        isChild: true
    })));
};
exports.default = MiscellaneousFilter;

},{"@emotion/react":"djZKr","react":"6uln9","./FilterSelector":"gM8wu","./FilterOption":"bAS9P","b034d38c64e13011":"gKSgy","d6c1b8cdeba0a8fd":"aqGQe","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"gKSgy":[function(require,module,exports) {
module.exports = require("915aac5f982007b6").getBundleURL("kVLro") + require("de795760ac911b86").resolve("aqEjp");

},{"915aac5f982007b6":"c7Tr5","de795760ac911b86":"fyJL2"}],"aqGQe":[function(require,module,exports) {
module.exports = require("eabd503260cf85b9").getBundleURL("kVLro") + require("a43712d188615f22").resolve("4k0KT");

},{"eabd503260cf85b9":"c7Tr5","a43712d188615f22":"fyJL2"}],"1PgH5":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _filterSelector = require("./FilterSelector");
var _filterSelectorDefault = parcelHelpers.interopDefault(_filterSelector);
var _filterOption = require("./FilterOption");
var _filterOptionDefault = parcelHelpers.interopDefault(_filterOption);
var _languages = require("../../../../models/extensions/languages");
var _lodash = require("lodash");
var _lodashDefault = parcelHelpers.interopDefault(_lodash);
var _customScrollbars = require("../../../../components/structure/CustomScrollbars");
var _customScrollbarsDefault = parcelHelpers.interopDefault(_customScrollbars);
const flagIconLight = require("5bd27ebf9f801c44");
const flagIcon = require("3a504cd65b03e214");
class LanguageFilter extends (0, _reactDefault.default).Component {
    constructor(props){
        super(props);
        this.state = {
            expandedLanguageIds: []
        };
    }
    getSelectedText() {
        const selectedLangs = this.props.languages?.filter((l)=>this.props.languageIds?.some((id)=>l.id == id));
        return selectedLangs?.map((l)=>l.shortCode)?.join(", ");
    }
    getLanguageGroups() {
        var dict = (0, _lodashDefault.default).groupBy(this.props.languages, (l)=>l.languageGroupCode);
        var groups = Object.keys(dict).map((key)=>({
                key: key,
                label: `${key.toUpperCase()} - ${(0, _languages.getLanguageName)(key)}`,
                subItems: dict[key].map((lang)=>({
                        data: lang,
                        value: lang.id,
                        icon: (0, _languages.getFlagIconForLanguage)(lang),
                        label: (0, _languages.getRegionyNameForLanguage)(lang),
                        groupKey: key,
                        isSelected: this.props.languageIds?.some((id)=>id == lang.id)
                    }))
            }));
        groups = (0, _lodashDefault.default).sortBy(groups, (group)=>group.key);
        return groups;
    }
    handleToggleExpandGroup(key) {
        var expandedKeys = this.state.expandedLanguageIds == null ? [] : this.state.expandedLanguageIds;
        if (expandedKeys.some((l)=>l == key)) expandedKeys.splice(expandedKeys.indexOf(key), 1);
        else expandedKeys.push(key);
        this.setState({
            ...this.state,
            expandedLanguageIds: expandedKeys
        });
    }
    handleToggleSelectGroup(key, group) {
        var languages = this.props.languages?.filter((lang)=>lang.languageGroupCode == key);
        var languageIds = this.props.languageIds ?? [];
        if (group?.subItems?.some((s)=>s.isSelected) && !group?.subItems?.some((s)=>!s.isSelected)) // all languages are selected we should deselect everything in this group
        {
            var newLanguages = languageIds.filter((lId)=>!languages?.some((l)=>l.id == lId));
            this.props.onChange(newLanguages);
        } else this.props.onChange([
            ...languageIds,
            ...languages?.map((l)=>l.id) ?? []
        ]);
    }
    handleToggleLanguage(languageId) {
        var languageIds = this.props.languageIds ?? [];
        if (languageIds.some((l)=>l == languageId)) languageIds.splice(languageIds.indexOf(languageId), 1);
        else languageIds.push(languageId);
        this.props.onChange(languageIds);
    }
    handleClear() {
        this.props.onChange(null);
    }
    render() {
        const groups = this.getLanguageGroups();
        const selectedText = this.getSelectedText();
        return (0, _react.jsx)((0, _filterSelectorDefault.default), {
            label: "Languages",
            icon: selectedText ? flagIcon : flagIconLight,
            placeholder: "Any Languages",
            selectedText: selectedText,
            onClear: this.handleClear.bind(this)
        }, (0, _react.jsx)((0, _customScrollbarsDefault.default), {
            autoHide: true,
            autoHeight: true,
            autoHeightMax: 400
        }, groups.map((group)=>(0, _react.jsx)((0, _reactDefault.default).Fragment, {
                key: group.key
            }, (0, _react.jsx)((0, _filterOptionDefault.default), {
                title: group.label,
                key: group.key,
                onClick: ()=>this.handleToggleExpandGroup(group.key),
                onCheckClick: ()=>this.handleToggleSelectGroup(group.key, group),
                isPartialSelected: group?.subItems?.some((s)=>s.isSelected) && group?.subItems?.some((s)=>!s.isSelected),
                isSelected: !group.subItems.some((s)=>!s.isSelected),
                isExpanded: this.state.expandedLanguageIds.some((id)=>id == group.key),
                hasChildren: true,
                optionType: "check"
            }), this.state.expandedLanguageIds.some((id)=>id == group.key) && group.subItems.map((item)=>(0, _react.jsx)((0, _filterOptionDefault.default), {
                    title: item.label,
                    icon: item.icon,
                    selectedIcon: item.icon,
                    onClick: ()=>this.handleToggleLanguage(item.value),
                    isSelected: item.isSelected,
                    key: item.value,
                    isChild: true,
                    optionType: "check"
                })))) ?? (0, _react.jsx)("p", null, "No languages available")));
    }
}
exports.default = LanguageFilter;

},{"@emotion/react":"djZKr","react":"6uln9","./FilterSelector":"gM8wu","./FilterOption":"bAS9P","../../../../models/extensions/languages":"8E5Oo","lodash":"3hMBK","../../../../components/structure/CustomScrollbars":"50vFq","5bd27ebf9f801c44":"fbI6P","3a504cd65b03e214":"i5oyw","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"fbI6P":[function(require,module,exports) {
module.exports = require("f03682b742bc4c58").getBundleURL("kVLro") + require("f348de04c2e78578").resolve("11HUt");

},{"f03682b742bc4c58":"c7Tr5","f348de04c2e78578":"fyJL2"}],"i5oyw":[function(require,module,exports) {
module.exports = require("c9628f274566eb63").getBundleURL("kVLro") + require("73599e53d866edb8").resolve("iQvwv");

},{"c9628f274566eb63":"c7Tr5","73599e53d866edb8":"fyJL2"}],"7S5N9":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _colors = require("../../../constants/colors");
const NoResultsView = ()=>(0, _react.jsx)("div", {
        className: containerStyle
    }, (0, _react.jsx)("p", null, "No matching results"));
const containerStyle = /*#__PURE__*/ (0, _css.css)("height:64px;border:1px solid ", (0, _colors.color_shades_dark), ";border-radius:8px;display:flex;align-items:center;margin:0 32px;padding:0 32px;p{font-style:italic;font-weight:normal;font-size:18px;line-height:24px;color:", (0, _colors.color_text_light), ";}", "");
exports.default = NoResultsView;

},{"@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","../../../constants/colors":"1p3OR","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hrN3F":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _colors = require("../../../constants/colors");
const containerStyle = /*#__PURE__*/ (0, _css.css)("border:solid 1px #c7cfd2;background:", (0, _colors.pale_grey), ";padding:16px 8px;margin:0 -32px;p{margin:0;font-family:Muli;font-size:14px;font-weight:normal;font-style:normal;font-stretch:normal;line-height:normal;letter-spacing:0.6px;color:#304562;margin-left:32px;}", "");
const ChildItemContainer = (props)=>(0, _react.jsx)("div", {
        className: containerStyle
    }, (0, _react.jsx)("p", null, "These options will be available to the user."), props.children);
exports.default = ChildItemContainer;

},{"@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","../../../constants/colors":"1p3OR","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"cDfgo":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _colors = require("../../../constants/colors");
var _horizontalSeparator = require("../../../components/structure/HorizontalSeparator");
var _horizontalSeparatorDefault = parcelHelpers.interopDefault(_horizontalSeparator);
var _conversationItemWrapper = require("./ConversationItemWrapper");
var _conversationItemWrapperDefault = parcelHelpers.interopDefault(_conversationItemWrapper);
const deleteIcon = require("8b5277ec6dd7fa15");
const containerStyle = /*#__PURE__*/ (0, _css.css)("background:white;border-radius:10px;border:solid 1px #c7cfd2;padding:20px;margin:16px 24px;.title-container{display:flex;align-items:center;.title{font-family:Muli;font-size:18px;font-weight:normal;font-style:normal;font-stretch:normal;line-height:normal;letter-spacing:normal;color:", (0, _colors.dark_grey_blue), ";margin-bottom:20px;flex:1;}.delete{cursor:pointer;margin-right:0;margin-left:auto;}}.detail{font-family:Muli;font-size:12px;font-weight:normal;font-style:normal;font-stretch:normal;line-height:normal;letter-spacing:0.5px;color:", (0, _colors.cool_grey), ";margin-top:20px;margin-left:0;}", "");
const ConversationItemCard = (props)=>(0, _react.jsx)("div", {
        className: containerStyle
    }, (0, _react.jsx)("div", {
        className: "title-container"
    }, (0, _react.jsx)("h5", {
        className: "title"
    }, props.slot.title), props.canDelete ? (0, _react.jsx)("img", {
        src: deleteIcon,
        className: "delete",
        onClick: props.onDelete
    }) : null), (0, _react.jsx)((0, _horizontalSeparatorDefault.default), null), (0, _react.jsx)("p", {
        className: "detail"
    }, props.slot.description), (0, _react.jsx)((0, _conversationItemWrapperDefault.default), {
        slot: props.slot,
        onClick: props.onAddItem
    }));
exports.default = ConversationItemCard;

},{"@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","../../../constants/colors":"1p3OR","../../../components/structure/HorizontalSeparator":"Pw3HQ","./ConversationItemWrapper":"6wsJj","8b5277ec6dd7fa15":"7eyKJ","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6wsJj":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _colors = require("../../../constants/colors");
var _extensions = require("../../../models/extensions");
var _verticalSeparator = require("../../../components/structure/VerticalSeparator");
var _verticalSeparatorDefault = parcelHelpers.interopDefault(_verticalSeparator);
var _toggleIndicator = require("../../../components/general/ToggleIndicator");
var _toggleIndicatorDefault = parcelHelpers.interopDefault(_toggleIndicator);
var _incompleteIndicator = require("../../../components/general/IncompleteIndicator");
var _incompleteIndicatorDefault = parcelHelpers.interopDefault(_incompleteIndicator);
const containerStyle = /*#__PURE__*/ (0, _css.css)("height:64px;border-radius:5px;border:solid 1px #007dbb;background:white;display:flex;align-items:center;padding:12px;margin-top:16px;cursor:pointer;.incomplete-indicator{margin:0 12px;}.conversation-item-details{flex:1;display:flex;align-items:center;margin-left:16px;>div{flex:1;}img{height:32px;width:32px;margin-right:12px;}.content-title{font-family:Muli;font-size:14px;font-weight:600;font-style:normal;font-stretch:normal;line-height:normal;letter-spacing:0.6px;color:#304562;margin-left:0;}.feature-title{font-family:Muli;font-size:12px;font-weight:normal;font-style:normal;font-stretch:normal;line-height:normal;letter-spacing:normal;color:", (0, _colors.cool_grey), ";margin-left:0;}}.empty-text{font-family:Muli;font-size:14px;font-weight:600;font-style:italic;font-stretch:normal;line-height:normal;letter-spacing:0.6px;color:", (0, _colors.cool_grey), ";flex:1;}.select-wrapper{display:flex;flex-direction:column;align-items:center;margin-left:12px;margin-top:10px;.indicator{border-color:#007dbb;width:8px;height:8px;margin-right:4px;}.select-text{font-family:Muli;font-size:12px;font-weight:normal;font-style:normal;font-stretch:normal;line-height:normal;letter-spacing:0.7px;text-align:center;color:#007dbb;margin-top:8px;margin-left:0;}}", "");
const ConversationItemWrapper = (props)=>(0, _react.jsx)("div", {
        className: `${containerStyle} conversation-item-wrapper`,
        onClick: props.onClick
    }, props.slot.conversationItem ? (0, _react.jsx)("div", {
        className: "conversation-item-details"
    }, (0, _react.jsx)("img", {
        src: (0, _extensions.getFeatureTypeIcon)(props.slot.conversationItem.featureTypeId)
    }), (0, _react.jsx)("div", null, (0, _react.jsx)("p", {
        className: "feature-title"
    }, (0, _extensions.getDefaultFeatureTypeName)(props.slot.conversationItem?.featureTypeId ?? props.slot.currentFeatureTypeId)), (0, _react.jsx)("p", {
        className: "content-title"
    }, (0, _react.jsx)("i", null, props.slot.conversationItem.titleAttribute), props.slot.conversationItem.title))) : (0, _react.jsx)("p", {
        className: "empty-text"
    }, "Select a response"), props.slot.conversationItem && !props.slot.conversationItem.isComplete ? (0, _react.jsx)((0, _incompleteIndicatorDefault.default), null) : null, (0, _react.jsx)((0, _verticalSeparatorDefault.default), null), (0, _react.jsx)("div", {
        className: "select-wrapper"
    }, (0, _react.jsx)((0, _toggleIndicatorDefault.default), {
        direction: "right",
        className: "indicator"
    }), (0, _react.jsx)("p", {
        className: "select-text"
    }, "SELECT")));
exports.default = ConversationItemWrapper;

},{"@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","../../../constants/colors":"1p3OR","../../../models/extensions":"7h01B","../../../components/structure/VerticalSeparator":"aNNRC","../../../components/general/ToggleIndicator":"4eej1","../../../components/general/IncompleteIndicator":"jOJ8X","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jOJ8X":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _colors = require("../../constants/colors");
const icon = require("7792c0efdc0a858a");
const IncompleteIndicatorInverse = (props)=>(0, _react.jsx)("div", {
        className: "incomplete-indicator " + containerStyle
    }, (0, _react.jsx)("span", null, "Incomplete"), (0, _react.jsx)("img", {
        src: icon
    }));
const containerStyle = /*#__PURE__*/ (0, _css.css)("display:flex;align-items:center;justify-content:flex-end;flex:1;img{margin-left:8px;}span{font-family:Muli;font-size:14px;font-weight:normal;font-style:normal;font-stretch:normal;line-height:normal;letter-spacing:normal;text-align:right;color:", (0, _colors.dark_grey_blue), ";}", "");
exports.default = IncompleteIndicatorInverse;

},{"@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","../../constants/colors":"1p3OR","7792c0efdc0a858a":"cCzgp","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"tK22E":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _formFieldsContainer = require("../../../components/structure/FormFieldsContainer");
var _formFieldsContainerDefault = parcelHelpers.interopDefault(_formFieldsContainer);
var _selectField = require("../../../components/forms/SelectField");
var _selectFieldDefault = parcelHelpers.interopDefault(_selectField);
var _fieldError = require("../../../components/forms/FieldError");
var _fieldErrorDefault = parcelHelpers.interopDefault(_fieldError);
var _secondaryLoader = require("../../../components/general/SecondaryLoader");
var _secondaryLoaderDefault = parcelHelpers.interopDefault(_secondaryLoader);
var _colors = require("../../../constants/colors");
var _ssmlField = require("../../../components/forms/SsmlField/SsmlField");
var _ssmlFieldDefault = parcelHelpers.interopDefault(_ssmlField);
var _button = require("../../../components/general/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _horizontalContainer = require("../../../components/structure/HorizontalContainer");
var _horizontalContainerDefault = parcelHelpers.interopDefault(_horizontalContainer);
var _horizontalSeparator = require("../../../components/structure/HorizontalSeparator");
var _horizontalSeparatorDefault = parcelHelpers.interopDefault(_horizontalSeparator);
var _ssmlParseService = require("../../../services/ssmlParseService");
var _ssmlParseServiceDefault = parcelHelpers.interopDefault(_ssmlParseService);
const followUpIcon = require("8ae807bdda0be70f");
class ManageImplicitFollowUpForm extends (0, _reactDefault.default).Component {
    componentWillMount() {
        this.props.followUpContainer.getFollowUpForApp(this.props.applicationId);
    }
    handleSelectionChange(e) {
        const finalValue = e?.value;
        var followUp = null;
        if (finalValue == "new") followUp = {
            content: "",
            followUpHints: []
        };
        else if (finalValue && finalValue.length > 0) followUp = this.props.followUpContainer.state.followUps.find((f)=>f.id == finalValue);
        if (this.props.onChange) this.props.onChange(followUp);
    }
    getSelectedFollowUp() {
        if (this.props.followUp) {
            if (this.props.followUp.name) return this.props.followUp.id;
            else return "new";
        }
        return "";
    }
    handleFollowUpTextChange(ssml) {
        const followUp = this.props.followUp;
        followUp.content = ssml;
        this.props.onChange(followUp);
    }
    handleDuplicate(followUp) {
        this.props.onChange({
            content: followUp.content,
            followUpHints: followUp.followUpHints.map((f)=>({
                    content: f.content
                }))
        });
    }
    render() {
        if (this.props.followUpContainer.state.isLoading) return (0, _react.jsx)((0, _secondaryLoaderDefault.default), null);
        var ssmlParser = new (0, _ssmlParseServiceDefault.default)();
        return (0, _react.jsx)("div", {
            className: containerStyle
        }, (0, _react.jsx)("p", {
            className: "detail"
        }, "Select an existing follow-up configuration or create a new, custom one"), (0, _react.jsx)((0, _formFieldsContainerDefault.default), null, (0, _react.jsx)((0, _selectFieldDefault.default), {
            options: [
                {
                    value: "new",
                    label: "- Custom / New -"
                },
                ...this.props.followUpContainer.state.followUps.filter((f)=>f.name != undefined).map((f)=>({
                        value: f.id,
                        label: f.name
                    }))
            ],
            value: this.getSelectedFollowUp(),
            onBlur: ()=>{},
            onChange: this.handleSelectionChange.bind(this),
            useFormTheme: true,
            label: "Select a follow-up:",
            placeholder: "- None -",
            clearValueText: "- None -",
            clearable: false,
            name: "existingFollowUp"
        }), this.props.followUp ? (0, _react.jsx)((0, _reactDefault.default).Fragment, null, (0, _react.jsx)("p", {
            className: "header sub-header"
        }, (0, _react.jsx)("i", null, "Follow-Up:"), " ", this.props.followUp.name ? this.props.followUp.name : "Untitled"), (0, _react.jsx)((0, _horizontalSeparatorDefault.default), null), (0, _react.jsx)("div", {
            className: "inner-wrapper",
            id: "guidance"
        }, (0, _react.jsx)("img", {
            className: "inner-wrapper-img",
            src: followUpIcon
        }), (0, _react.jsx)("div", null, (0, _react.jsx)("p", {
            className: "header"
        }, "Guidance"), (0, _react.jsx)("p", {
            className: "detail"
        }, "Prompt the user with a question or statement and guide them to the next conversation"), this.props.followUp.name ? (0, _react.jsx)("div", null, (0, _react.jsx)("p", {
            className: "label"
        }, "Follow-up Language"), (0, _react.jsx)("p", {
            className: "preview"
        }, (0, _react.jsx)("i", null, ssmlParser.stripTags(this.props.followUp.content)))) : (0, _react.jsx)((0, _ssmlFieldDefault.default), {
            placeholder: "What should the device say?",
            value: this.props.followUp ? this.props.followUp.content : "",
            label: "Follow-up Language:",
            applicationId: this.props.applicationId,
            onChange: this.handleFollowUpTextChange.bind(this),
            onBlur: ()=>{},
            className: "follow-up-field",
            name: "followUpContent"
        }), (0, _react.jsx)((0, _fieldErrorDefault.default), {
            name: "followUp"
        }))), this.props.children, (0, _react.jsx)((0, _horizontalSeparatorDefault.default), null), this.getSelectedFollowUp() == "new" ? (0, _react.jsx)((0, _buttonDefault.default), {
            themes: [
                "hollow",
                "flat"
            ],
            text: "Save as...",
            type: "button",
            onClick: this.props.onManage
        }) : (0, _react.jsx)((0, _horizontalContainerDefault.default), {
            className: "fill"
        }, (0, _react.jsx)((0, _buttonDefault.default), {
            themes: [
                "hollow",
                "flat"
            ],
            text: "Edit",
            type: "button",
            disabled: !this.props.followUp,
            onClick: this.props.onManage
        }), (0, _react.jsx)("div", {
            style: {
                marginLeft: "auto",
                marginRight: 0
            }
        }, (0, _react.jsx)((0, _buttonDefault.default), {
            themes: [
                "hollow",
                "flat"
            ],
            text: "Duplicate",
            type: "button",
            disabled: !this.props.followUp,
            onClick: this.handleDuplicate.bind(this, this.props.followUp)
        })))) : null));
    }
}
const containerStyle = /*#__PURE__*/ (0, _css.css)(".detail{font-size:12px;letter-spacing:0.5px;color:", (0, _colors.cool_grey), ";margin-right:16px;}.header{font-family:Muli;font-size:18px;color:", (0, _colors.dark_grey_blue), ";}.sub-header{margin-top:16px;margin-bottom:16px;}.inner-wrapper{display:flex;align-items:flex-start;margin-top:24px;.inner-wrapper-img{margin-right:16px;}>div{flex:1;}.check-container{display:flex;align-items:center;margin:24px 0;}.label{margin:16px 0;font-size:14px;font-weight:600;font-style:normal;font-stretch:normal;line-height:normal;letter-spacing:normal;color:", (0, _colors.dark_grey_blue), ";}.preview{font-size:14px;font-weight:normal;font-style:italic;font-stretch:normal;line-height:normal;letter-spacing:normal;color:", (0, _colors.dark_grey_blue), ";}}.follow-up-field{margin-top:16px;}", "");
exports.default = ManageImplicitFollowUpForm;

},{"@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","../../../components/structure/FormFieldsContainer":"h3hzh","../../../components/forms/SelectField":"405B3","../../../components/forms/FieldError":"fDxhz","../../../components/general/SecondaryLoader":"7zJiF","../../../constants/colors":"1p3OR","../../../components/forms/SsmlField/SsmlField":"cvL6K","../../../components/general/Button":"6ymxN","../../../components/structure/HorizontalContainer":"eJPfh","../../../components/structure/HorizontalSeparator":"Pw3HQ","../../../services/ssmlParseService":"7FRoV","8ae807bdda0be70f":"ICQyO","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"405B3":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _defineProperty = require("@babel/runtime/helpers/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _reactSelect = require("react-select");
var _reactSelectDefault = parcelHelpers.interopDefault(_reactSelect);
var _fieldError = require("./FieldError");
var _fieldErrorDefault = parcelHelpers.interopDefault(_fieldError);
var _colors = require("../../constants/colors");
var _verticalSeparator = require("../structure/VerticalSeparator");
var _verticalSeparatorDefault = parcelHelpers.interopDefault(_verticalSeparator);
var _stylesValues = require("../../constants/stylesValues");
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// component used in building forms with consistent components for look and function
class SelectField extends (0, _reactDefault.default).Component {
    constructor(...args){
        super(...args);
        (0, _definePropertyDefault.default)(this, "handleChange", (value)=>{
            // this is going to call setFieldValue and manually update values.topcis
            this.props.onChange(value);
        });
        (0, _definePropertyDefault.default)(this, "handleBlur", ()=>{
            // this is going to call setFieldTouched and manually update touched.topcis
            if (this.props.onBlur) this.props.onBlur(true);
        });
    }
    render() {
        const props = {
            ...this.props
        };
        return (0, _react.jsx)("div", {
            className: `${props.hideLabel ? containerStyleNoMargin : containerStyle} ${props.className} ${props.hidden ? hiddenStyle : ""} selector`
        }, !props.hideLabel && (0, _react.jsx)("div", {
            className: labelContainer
        }, props.labelIcon && (0, _react.jsx)("img", {
            src: props.labelIcon
        }), props.label !== undefined ? (0, _react.jsx)("label", {
            htmlFor: props.name,
            className: `${labelStyle} ${props.labelStyle}`
        }, props.label) : null), props.useFormTheme ? (0, _react.jsx)("div", {
            className: fieldContainer
        }, props.icon !== undefined ? (0, _react.jsx)("img", {
            src: props.icon
        }) : null, props.icon !== undefined ? (0, _react.jsx)("div", {
            className: separatorStyle
        }, (0, _react.jsx)((0, _verticalSeparatorDefault.default), null)) : null, (0, _react.jsx)((0, _reactSelectDefault.default), {
            id: props.id,
            name: props.name,
            placeholder: props.placeholder,
            value: props.value,
            onChange: this.handleChange.bind(this),
            onBlur: this.handleBlur.bind(this),
            disabled: props.disabled,
            options: props.options,
            clearValueText: props.clearValueText,
            clearable: props.clearable,
            className: props.customClassName || (props.useFormTheme ? formSelectStyle : selectStyle)
        })) : (0, _react.jsx)((0, _reactSelectDefault.default), {
            id: props.id,
            clearable: props.clearable,
            name: props.name,
            placeholder: props.placeholder,
            value: props.value,
            onChange: this.handleChange.bind(this),
            onBlur: this.handleBlur.bind(this),
            disabled: props.disabled,
            options: props.options,
            className: props.customClassName || (props.useFormTheme ? formSelectStyle : selectStyle)
        }), props.useForm === undefined || props.useForm == true ? (0, _react.jsx)((0, _fieldErrorDefault.default), {
            name: props.name
        }) : null);
    }
}
const labelContainer = /*#__PURE__*/ (0, _css.css)({
    name: "shwixj",
    styles: "display:flex;align-items:center;height:22px"
});
const containerStyle = /*#__PURE__*/ (0, _css.css)({
    name: "1fgdcyd",
    styles: "margin-bottom:24px"
});
const containerStyleNoMargin = /*#__PURE__*/ (0, _css.css)({
    name: "1ykowef",
    styles: "margin-bottom:0"
});
const labelStyle = /*#__PURE__*/ (0, _css.css)({
    name: "nj3mqm",
    styles: "font-family:Muli;font-size:14px;font-weight:600;font-style:normal;font-stretch:normal;line-height:normal;letter-spacing:normal;text-align:left;margin:24px 16px 25px 16px"
});
const selectStyle = /*#__PURE__*/ (0, _css.css)({
    name: "m5glhw",
    styles: "font-family:Muli sans-serif;font-weight:normal;font-style:normal;font-stretch:normal;line-height:normal;letter-spacing:normal;text-align:left;width:100%;margin-top:8px;.Select-control{border-radius:30px;min-height:56px;}.Select-placeholder,.Select-value{padding:12px 26px;font-family:Muli;font-size:14px;}.Select-value-label{margin-left:16px;}.Select-menu-outer{border-bottom-right-radius:30px;border-bottom-left-radius:30px;}.Select-option,Select-noresults{height:56px;padding:24px 26px;font-family:Muli;font-size:14px;}.Select-option:last-child{border-bottom-right-radius:30px;border-bottom-left-radius:30px;}.Select-input{margin:16px;font-family:Muli,sans-serif;}"
});
const formSelectStyle = /*#__PURE__*/ (0, _css.css)("font-family:Muli sans-serif;font-weight:normal;font-style:normal;font-stretch:normal;line-height:normal;letter-spacing:normal;text-align:left;width:100%;.Select-control{border-radius:8px;min-height:56px;border:none;}.Select-placeholder,.Select-value{padding:12px 26px;font-family:Muli;font-size:14px;}.Select-value-label{margin-left:16px;}.Select-menu-outer{border-bottom-right-radius:10px;border-bottom-left-radius:10px;}.Select-option,Select-noresults{height:56px;padding:24px 26px;font-family:Muli;font-size:14px;}.Select-option:last-child{border-bottom-right-radius:8px;border-bottom-left-radius:8px;}.Select-input{margin:12px 26px;}&.is-open{.Select-control{.Select-arrow{width:8px;height:8px;border:none;border-left:solid 1px ", (0, _colors.dark_grey_blue), ";border-top:solid 1px ", (0, _colors.dark_grey_blue), ";transform:rotate(45deg);border-radius:0;margin-right:16px;}}}.Select-arrow{width:8px;height:8px;border:none;border-left:solid 1px ", (0, _colors.dark_grey_blue), ";border-top:solid 1px ", (0, _colors.dark_grey_blue), ";transform:rotate(-135deg);border-radius:0;margin-right:16px;}", "");
const hiddenStyle = /*#__PURE__*/ (0, _css.css)({
    name: "eivff4",
    styles: "display:none"
});
const fieldContainer = /*#__PURE__*/ (0, _css.css)("display:flex;align-items:center;height:60px;width:100%;background:#FFFFFF;border:", (0, _stylesValues.style_border_default), ";box-sizing:border-box;box-shadow:0px 1px 2px rgba(50, 70, 97, 0.1);border-radius:8px;margin-top:8px;img{margin:16px;}", "");
const separatorStyle = /*#__PURE__*/ (0, _css.css)({
    name: "zdz8xi",
    styles: "height:30px"
});
exports.default = SelectField;

},{"@babel/runtime/helpers/defineProperty":"9sJxO","@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","react-select":"1numo","./FieldError":"fDxhz","../../constants/colors":"1p3OR","../structure/VerticalSeparator":"aNNRC","../../constants/stylesValues":"dHVVv","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"ICQyO":[function(require,module,exports) {
module.exports = require("fbb2f6a7d4d6b128").getBundleURL("kVLro") + require("753949d03c6aa0a6").resolve("4m0cN");

},{"fbb2f6a7d4d6b128":"c7Tr5","753949d03c6aa0a6":"fyJL2"}],"ehQxT":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _textField = require("../../../components/forms/TextField");
var _textFieldDefault = parcelHelpers.interopDefault(_textField);
var _css = require("@emotion/css");
var _colors = require("../../../constants/colors");
const downArrowIcon = require("b619a7e2ea9c8287");
const upArrowIcon = require("13633996bc5b78b2");
const trashIcon = require("aec4d8e533ade426");
const moveableIcon = require("d97ee97c5266b02d");
const disabledUpArrowIcon = require("8528770564843bdc");
const disabledDownArrowIcon = require("87a7853b4bd4698c");
const HintField = ({ index, isLast, hint, followUp, handleMoveDown, handleMoveUp, handleHintDelete, handleHintChange })=>{
    const [isHovered, setIsHovered] = (0, _react1.useState)(false);
    return (0, _react.jsx)("div", {
        key: index,
        onMouseEnter: ()=>setIsHovered(true),
        onMouseLeave: ()=>setIsHovered(false)
    }, (0, _react.jsx)("div", {
        className: hintNavigation
    }, isHovered ? (0, _react.jsx)("img", {
        className: "moveable-icon",
        src: moveableIcon
    }) : (0, _react.jsx)("div", {
        className: "spacer-bar left"
    }), (0, _react.jsx)("p", null, "Hint ", index + 1), (0, _react.jsx)("div", {
        className: "spacer-bar right"
    }), (0, _react.jsx)("img", {
        className: "hints-field-image right-margin",
        onClick: ()=>handleMoveDown(index),
        src: isLast ? disabledDownArrowIcon : downArrowIcon
    }), (0, _react.jsx)("img", {
        className: "hints-field-image right-margin",
        onClick: ()=>handleMoveUp(index),
        src: index == 0 ? disabledUpArrowIcon : upArrowIcon
    }), (0, _react.jsx)("img", {
        className: "hints-field-image",
        onClick: ()=>handleHintDelete(index),
        src: trashIcon
    })), (0, _react.jsx)((0, _textFieldDefault.default), {
        key: index,
        name: `followUpHints.${index}.content`,
        placeholder: "Something the user can say",
        onChange: (e)=>handleHintChange(e, index),
        onBlur: ()=>{},
        value: hint.content,
        disabled: followUp.name != null
    }));
};
const hintNavigation = /*#__PURE__*/ (0, _css.css)("display:flex;p{white-space:nowrap;}.hints-field-image{cursor:pointer;&.right-margin{margin-right:14px;}}.moveable-icon{cursor:grab;margin-right:10px;}.spacer-bar{width:100%;height:1px;background:", (0, _colors.color_shades_dark), ";margin-top:10px;&.left{margin-right:8px;width:11px;}&.right{margin-left:8px;margin-right:8px;}}", "");
exports.default = HintField;

},{"@emotion/react":"djZKr","react":"6uln9","../../../components/forms/TextField":"7a7bh","@emotion/css":"awUBr","../../../constants/colors":"1p3OR","b619a7e2ea9c8287":"kj6Av","13633996bc5b78b2":"44uuX","aec4d8e533ade426":"7eyKJ","d97ee97c5266b02d":"dsDQ4","8528770564843bdc":"fEpOJ","87a7853b4bd4698c":"49dfr","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"kj6Av":[function(require,module,exports) {
module.exports = require("7a5d08163c62f043").getBundleURL("kVLro") + require("f95ccb8ac4b4718f").resolve("gTmph");

},{"7a5d08163c62f043":"c7Tr5","f95ccb8ac4b4718f":"fyJL2"}],"44uuX":[function(require,module,exports) {
module.exports = require("3fb105041ec5e948").getBundleURL("kVLro") + require("b580e5337f093da0").resolve("L6VRu");

},{"3fb105041ec5e948":"c7Tr5","b580e5337f093da0":"fyJL2"}],"fEpOJ":[function(require,module,exports) {
module.exports = require("586b97819d5ba6b4").getBundleURL("kVLro") + require("c52d5a55b7432341").resolve("jcCBQ");

},{"586b97819d5ba6b4":"c7Tr5","c52d5a55b7432341":"fyJL2"}],"49dfr":[function(require,module,exports) {
module.exports = require("255687aa7e865e1c").getBundleURL("kVLro") + require("c84a9dc8d9ed094c").resolve("eXdvP");

},{"255687aa7e865e1c":"c7Tr5","c84a9dc8d9ed094c":"fyJL2"}],"dQ7Ta":[function(require,module,exports) {
module.exports = require("bb459c8f4507dff8").getBundleURL("kVLro") + require("7101aa31067d8856").resolve("fKDdy");

},{"bb459c8f4507dff8":"c7Tr5","7101aa31067d8856":"fyJL2"}],"A1pLV":[function(require,module,exports) {
module.exports = require("51ba874f1c552015").getBundleURL("kVLro") + require("5df5b28bf885ccc8").resolve("ec0Lr");

},{"51ba874f1c552015":"c7Tr5","5df5b28bf885ccc8":"fyJL2"}],"d40tP":[function(require,module,exports) {
module.exports = require("27a971ab0b567b47").getBundleURL("kVLro") + require("e2424d9c3c9eb3c5").resolve("jLs0Y");

},{"27a971ab0b567b47":"c7Tr5","e2424d9c3c9eb3c5":"fyJL2"}],"cl9rg":[function(require,module,exports) {
module.exports = require("85759b5fbef9f313").getBundleURL("kVLro") + require("5507f63227e9d6b9").resolve("b5ZDE");

},{"85759b5fbef9f313":"c7Tr5","5507f63227e9d6b9":"fyJL2"}],"h1HjT":[function(require,module,exports) {
module.exports = require("7ad65f0db054351f").getBundleURL("kVLro") + require("7c8f5b3b3bbb6b62").resolve("PoXzk");

},{"7ad65f0db054351f":"c7Tr5","7c8f5b3b3bbb6b62":"fyJL2"}],"59An8":[function(require,module,exports) {
module.exports = require("2cf98efe49717d58").getBundleURL("kVLro") + require("8711843a34a5099d").resolve("amZ8A");

},{"2cf98efe49717d58":"c7Tr5","8711843a34a5099d":"fyJL2"}],"lruiJ":[function(require,module,exports) {
module.exports = require("ad18652ec858af89").getBundleURL("kVLro") + require("a5d8fcdedc25feb1").resolve("kbbfl");

},{"ad18652ec858af89":"c7Tr5","a5d8fcdedc25feb1":"fyJL2"}],"fE99M":[function(require,module,exports) {
module.exports = require("15f1563ce7b9e1f6").getBundleURL("kVLro") + require("84e8ff2a14d110e").resolve("eOAeB");

},{"15f1563ce7b9e1f6":"c7Tr5","84e8ff2a14d110e":"fyJL2"}],"3vnDf":[function(require,module,exports) {
module.exports = require("696be7b6cb17af22").getBundleURL("kVLro") + require("25da1fcfec5b5040").resolve("3XL48");

},{"696be7b6cb17af22":"c7Tr5","25da1fcfec5b5040":"fyJL2"}],"iy1lb":[function(require,module,exports) {
module.exports = require("f9e7b38111c48b2c").getBundleURL("kVLro") + require("3bdc5890ee94b94e").resolve("7NqC1");

},{"f9e7b38111c48b2c":"c7Tr5","3bdc5890ee94b94e":"fyJL2"}],"bVYZ8":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _formFieldsContainer = require("../../../components/structure/FormFieldsContainer");
var _formFieldsContainerDefault = parcelHelpers.interopDefault(_formFieldsContainer);
var _selectField = require("../../../components/forms/SelectField");
var _selectFieldDefault = parcelHelpers.interopDefault(_selectField);
var _checkboxField = require("../../../components/forms/CheckboxField");
var _checkboxFieldDefault = parcelHelpers.interopDefault(_checkboxField);
var _fieldError = require("../../../components/forms/FieldError");
var _fieldErrorDefault = parcelHelpers.interopDefault(_fieldError);
var _secondaryLoader = require("../../../components/general/SecondaryLoader");
var _secondaryLoaderDefault = parcelHelpers.interopDefault(_secondaryLoader);
var _colors = require("../../../constants/colors");
var _ssmlField = require("../../../components/forms/SsmlField/SsmlField");
var _ssmlFieldDefault = parcelHelpers.interopDefault(_ssmlField);
var _button = require("../../../components/general/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _horizontalContainer = require("../../../components/structure/HorizontalContainer");
var _horizontalContainerDefault = parcelHelpers.interopDefault(_horizontalContainer);
var _horizontalSeparator = require("../../../components/structure/HorizontalSeparator");
var _horizontalSeparatorDefault = parcelHelpers.interopDefault(_horizontalSeparator);
var _pageError = require("../../../components/general/PageError");
var _pageErrorDefault = parcelHelpers.interopDefault(_pageError);
var _contentCard = require("../../../components/structure/ContentCard");
var _contentCardDefault = parcelHelpers.interopDefault(_contentCard);
const repromptCardIcon = require("d5dc7ded055c40d9");
const checkIcon = require("9fb2e11ac6bd5d91");
class ManageRepromptForm extends (0, _reactDefault.default).Component {
    componentDidMount() {
        if (this.props.groupIndex === 0) this.props.repromptContainer.getRepromptForApp(this.props.applicationId);
    }
    handleSelectionChange(e) {
        const finalValue = e === null ? null : e.value;
        var reprompt = null;
        if (finalValue == "new") reprompt = {
            content: "",
            includeFollowUp: false
        };
        else if (finalValue) reprompt = this.props.repromptContainer.state.reprompt.find((f)=>f.id == finalValue);
        if (this.props.onChange) this.props.onChange(reprompt);
    }
    getSelectedReprompt() {
        if (this.props.reprompt) {
            if (this.props.reprompt.name) return this.props.reprompt.id;
            else return "new";
        }
        return "";
    }
    handleRepromptTextChange(ssml) {
        const reprompt = this.props.reprompt;
        reprompt.content = ssml;
        this.props.onChange(reprompt);
    }
    handleIncludeFollowUpChange(e) {
        const reprompt = this.props.reprompt;
        reprompt.includeFollowUp = e.target.checked;
        this.props.onChange(reprompt);
    }
    handleDuplicate(reprompt) {
        this.props.onChange({
            content: reprompt.content,
            includeFollowUp: reprompt.includeFollowUp
        });
    }
    render() {
        if (this.props.repromptContainer.state.isLoading) return (0, _react.jsx)((0, _secondaryLoaderDefault.default), null);
        return (0, _react.jsx)("div", {
            className: containerStyle
        }, (0, _react.jsx)((0, _contentCardDefault.default), {
            title: "Reprompt",
            icon: repromptCardIcon
        }, (0, _react.jsx)("div", {
            className: "inner-wrapper",
            id: `g${this.props.groupIndex}reprompt`
        }, (0, _react.jsx)("div", null, (0, _react.jsx)("p", {
            className: "detail"
        }, "If the user doesn’t say anything after a period of time (several seconds)"), (0, _react.jsx)((0, _formFieldsContainerDefault.default), null, (0, _react.jsx)((0, _selectFieldDefault.default), {
            options: [
                {
                    value: null,
                    label: "- None -"
                },
                {
                    value: "new",
                    label: "- Custom / New -"
                },
                ...this.props.repromptContainer.state.reprompt.filter((f)=>f.name != undefined).map((f)=>({
                        value: f.id,
                        label: f.name
                    }))
            ],
            value: this.getSelectedReprompt(),
            onBlur: ()=>{},
            onChange: this.handleSelectionChange.bind(this),
            useFormTheme: true,
            label: "Select a reprompt:",
            placeholder: "- None -",
            clearValueText: "- None -",
            clearable: true,
            name: "existingReprompt"
        }), this.props.reprompt ? (0, _react.jsx)((0, _reactDefault.default).Fragment, null, (0, _react.jsx)((0, _horizontalSeparatorDefault.default), null), (0, _react.jsx)("p", {
            className: "header sub-header"
        }, (0, _react.jsx)("i", null, "Reprompt:"), " ", this.props.reprompt.name ? this.props.reprompt.name : "Untitled"), this.props.reprompt.name ? (0, _react.jsx)("div", null, (0, _react.jsx)("p", {
            className: "label"
        }, "Reprompt Language"), (0, _react.jsx)("p", {
            className: "preview"
        }, (0, _react.jsx)("i", null, this.props.reprompt.content))) : (0, _react.jsx)((0, _ssmlFieldDefault.default), {
            placeholder: "What should the device say?",
            value: this.props.reprompt ? this.props.reprompt.content : "",
            label: "Reprompt Language:",
            applicationId: this.props.applicationId,
            onChange: this.handleRepromptTextChange.bind(this),
            onBlur: ()=>{},
            name: "repromptContent"
        }), this.props.reprompt.name ? (0, _react.jsx)("div", {
            className: "check-container"
        }, (0, _react.jsx)("img", {
            src: checkIcon
        }), (0, _react.jsx)("p", null, "Repeat follow-up")) : (0, _react.jsx)((0, _checkboxFieldDefault.default), {
            name: "includeFollowUp",
            checked: this.props.reprompt ? this.props.reprompt.includeFollowUp : false,
            onChange: this.handleIncludeFollowUpChange.bind(this),
            label: "Then repeat previous Follow-up"
        }), (0, _react.jsx)((0, _fieldErrorDefault.default), {
            name: "reprompt"
        }), (0, _react.jsx)((0, _horizontalSeparatorDefault.default), null), this.getSelectedReprompt() == "new" ? (0, _react.jsx)((0, _buttonDefault.default), {
            themes: [
                "hollow",
                "flat"
            ],
            text: "Save as...",
            type: "button",
            onClick: this.props.onManage
        }) : (0, _react.jsx)((0, _horizontalContainerDefault.default), {
            className: "fill"
        }, (0, _react.jsx)((0, _buttonDefault.default), {
            themes: [
                "hollow",
                "flat"
            ],
            text: "Edit",
            type: "button",
            disabled: !this.props.reprompt,
            onClick: this.props.onManage
        }), (0, _react.jsx)("div", {
            style: {
                marginLeft: "auto",
                marginRight: 0
            }
        }, (0, _react.jsx)((0, _buttonDefault.default), {
            themes: [
                "hollow",
                "flat"
            ],
            text: "Duplicate",
            type: "button",
            disabled: !this.props.reprompt,
            onClick: this.handleDuplicate.bind(this, this.props.reprompt)
        })))) : null))), (0, _react.jsx)((0, _pageErrorDefault.default), {
            errors: this.props.repromptContainer.state.errors
        })));
    }
}
const containerStyle = /*#__PURE__*/ (0, _css.css)(".inner-wrapper{display:flex;align-items:flex-start;img{margin-right:16px;}.header{font-family:Muli;font-size:18px;color:", (0, _colors.dark_grey_blue), ";}.sub-header{margin-top:16px;margin-bottom:16px;}.detail{font-size:12px;letter-spacing:0.5px;color:", (0, _colors.cool_grey), ";margin-right:16px;}>div{flex:1;}.check-container{display:flex;align-items:center;margin:24px 0;}.label{margin:16px 0;font-size:14px;font-weight:600;font-style:normal;font-stretch:normal;line-height:normal;letter-spacing:normal;color:", (0, _colors.dark_grey_blue), ";}.preview{font-size:14px;font-weight:normal;font-style:italic;font-stretch:normal;line-height:normal;letter-spacing:normal;color:", (0, _colors.dark_grey_blue), ";}}", "");
exports.default = ManageRepromptForm;

},{"@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","../../../components/structure/FormFieldsContainer":"h3hzh","../../../components/forms/SelectField":"405B3","../../../components/forms/CheckboxField":"3S5Oy","../../../components/forms/FieldError":"fDxhz","../../../components/general/SecondaryLoader":"7zJiF","../../../constants/colors":"1p3OR","../../../components/forms/SsmlField/SsmlField":"cvL6K","../../../components/general/Button":"6ymxN","../../../components/structure/HorizontalContainer":"eJPfh","../../../components/structure/HorizontalSeparator":"Pw3HQ","../../../components/general/PageError":"ezFTm","../../../components/structure/ContentCard":"hJsdJ","d5dc7ded055c40d9":"jWvhb","9fb2e11ac6bd5d91":"3Js1w","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jWvhb":[function(require,module,exports) {
module.exports = require("b840435560b3c1f").getBundleURL("kVLro") + require("6c3e5568e573351b").resolve("dyjK4");

},{"b840435560b3c1f":"c7Tr5","6c3e5568e573351b":"fyJL2"}],"2mZkh":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _colors = require("../../../constants/colors");
var _stylesValues = require("../../../constants/stylesValues");
var _button = require("../../../components/general/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _tooltipWrapper = require("../../../components/general/TooltipWrapper");
var _tooltipWrapperDefault = parcelHelpers.interopDefault(_tooltipWrapper);
const addIcon = require("f0d1a3d465767757");
const equalsIcon = require("ff1040b1a617006a");
const notEqualsIcon = require("78c96999cd5aedb1");
const containsIcon = require("da77b23ae037fa");
const notContainsIcon = require("263270d2fc6744ee");
const editIcon = require("33566dbe0d0d7163");
const deleteIcon = require("14336029f3f2fdf9");
const ConditionsGroup = (props)=>{
    const capabilityOptions = [
        {
            value: "HasAudio",
            label: "Supports Audio"
        },
        {
            value: "SupportsVideo",
            label: "Supports Video"
        },
        {
            value: "HasDisplay",
            label: "Supports Display"
        }
    ];
    const getTitleForCondition = (conditionId)=>{
        return props.conditions.find((c)=>c.id == conditionId)?.groupName;
    };
    const getQualifierIcon = (conditionId)=>{
        const qualifier = props.conditions?.find((c)=>c.id == conditionId)?.comparisonType;
        switch(qualifier){
            case "Contains":
                return containsIcon;
            case "DoesNotContain":
                return notContainsIcon;
            case "Equals":
                return equalsIcon;
            case "NotEquals":
                return notEqualsIcon;
        }
        return "";
    };
    const getQualifierLabel = (conditionId)=>{
        const qualifier = props.conditions?.find((c)=>c.id == conditionId)?.comparisonType;
        switch(qualifier){
            case "Contains":
                return "Includes";
            case "DoesNotContain":
                return "Excludes";
            case "Equals":
                return "Equals";
            case "NotEquals":
                return "Does not equal";
        }
        return "";
    };
    const getDisplayValue = (conditionInstance)=>{
        const condition = props.conditions.find((c)=>c.id == conditionInstance?.conditionId);
        if (condition?.groupName?.toLocaleLowerCase() == "device type") return props.deviceTypes?.find((d)=>d.id == conditionInstance?.value)?.displayName;
        if (condition?.groupName?.toLocaleLowerCase() == "device capability") return capabilityOptions.find((d)=>d.value == conditionInstance?.value)?.label;
        return conditionInstance?.value;
    };
    const addAndCondition = (parent)=>{
        const getLeaf = (instance)=>{
            if (!instance.andCondition) return instance;
            return getLeaf(instance.andCondition);
        };
        props.onAddAndCondition(getLeaf(parent));
    };
    const renderSingleCondition = (conditionInstance, isFirst)=>{
        return (0, _react.jsx)((0, _reactDefault.default).Fragment, null, (0, _react.jsx)("div", {
            className: "condition-item"
        }, (0, _react.jsx)("div", {
            className: "condition-handle"
        }, !isFirst && "&"), (0, _react.jsx)("div", {
            className: "condition-content ac-condition-content"
        }, (0, _react.jsx)("p", null, getTitleForCondition(conditionInstance.conditionId)), (0, _react.jsx)((0, _tooltipWrapperDefault.default), {
            text: getQualifierLabel(conditionInstance.conditionId),
            place: "top"
        }, (0, _react.jsx)("img", {
            src: getQualifierIcon(conditionInstance.conditionId)
        })), (0, _react.jsx)("p", null, getDisplayValue(conditionInstance)), (0, _react.jsx)("div", {
            className: "condition-buttons"
        }, (0, _react.jsx)((0, _buttonDefault.default), {
            icon: editIcon,
            type: "button",
            themes: [
                "icon"
            ],
            onClick: ()=>props.onEditCondition(conditionInstance)
        }), props.canDelete && (0, _react.jsx)((0, _buttonDefault.default), {
            icon: deleteIcon,
            type: "button",
            themes: [
                "icon"
            ],
            onClick: ()=>props.onRemoveCondition(conditionInstance)
        })))), conditionInstance.andCondition && renderSingleCondition(conditionInstance.andCondition, false));
    };
    return (0, _react.jsx)("div", {
        className: containerStyle
    }, (0, _react.jsx)("div", {
        className: "condition-groups"
    }, props.conditionInstances?.map((c, i)=>(0, _react.jsx)((0, _reactDefault.default).Fragment, {
            key: i
        }, i > 0 && (0, _react.jsx)("div", {
            className: "or-row-wrapper"
        }, (0, _react.jsx)("div", {
            className: "or-line"
        }), (0, _react.jsx)("div", {
            className: "or-row"
        }, (0, _react.jsx)("p", {
            className: "or"
        }, "Or"), (0, _react.jsx)("p", {
            className: "or-detail"
        }, "This may also be true"))), (0, _react.jsx)("div", {
            className: "condition-group",
            key: c.id
        }, (0, _react.jsx)("div", {
            className: "condition-items"
        }, renderSingleCondition(c, true)), (0, _react.jsx)("button", {
            type: "button",
            className: "new-condition-item",
            onClick: ()=>addAndCondition(c)
        }, (0, _react.jsx)("span", {
            className: "new-condition-handle"
        }, (0, _react.jsx)("img", {
            src: addIcon
        })), (0, _react.jsx)("span", {
            className: "new-condition-label ac-new-condition-label"
        }, "Add a condition refinement (AND)")))))), (0, _react.jsx)((0, _buttonDefault.default), {
        className: "add-condition-group ac-add-condition-group",
        type: "button",
        themes: [
            "secondary",
            "fill"
        ],
        text: "Add a Condition (OR)",
        onClick: ()=>props.onAddConditionGroup()
    }));
};
const containerStyle = /*#__PURE__*/ (0, _css.css)(".condition-groups{padding:24px 0;border-bottom:", (0, _stylesValues.style_border_default), ";font-family:Muli;.condition-group{width:100%;.condition-item{display:flex;align-items:center;min-height:32px;width:100%;border-bottom:none;&:first-child{.condition-handle{border-top-left-radius:8px;}}&:first-child{.condition-content{border-top-right-radius:8px;}}&:last-child{.condition-content{border-bottom-right-radius:8px;border-bottom:1px solid ", (0, _colors.color_colors_royalty), ";}}.condition-handle{min-height:42px;background:", (0, _colors.color_colors_royalty), ";width:24px;display:flex;align-items:center;justify-content:center;color:white;font-weight:lighter;}.condition-content{min-height:42px;flex:1;padding:0 16px;display:flex;align-items:center;background:", (0, _colors.color_variants_royalty_light_20), ";border-top:1px solid ", (0, _colors.color_colors_royalty), ";border-right:1px solid ", (0, _colors.color_colors_royalty), ";img{margin:0 8px;}>p{font-style:normal;font-weight:normal;font-size:14px;line-height:20px;}}.condition-buttons{display:flex;align-items:center;padding-left:8px;border-left:1px solid white;margin-right:0;margin-left:auto;button{margin:0;width:24px;height:24px;padding:0;&:first-child{margin-right:8px;}}}}.new-condition-item{display:flex;align-items:center;border:none;background:none;box-shadow:none;padding:0;margin:0;cursor:pointer;.new-condition-handle{background:", (0, _colors.color_colors_royalty), ";width:24px;min-height:32px;display:flex;align-items:center;justify-content:center;color:white;font-weight:lighter;font-size:32px;border-radius:0 0 12px 12px;img{width:12px;height:12px;}}.new-condition-label{margin:4px 16px 0 16px;color:", (0, _colors.color_text_link), ";font-size:14px;line-height:20px;}}}.or-row-wrapper{position:relative;height:40px;.or-line{height:100%;width:1px;background:", (0, _colors.color_colors_royalty), ";position:absolute;left:12px;top:0;bottom:0;}.or-row{position:absolute;display:flex;align-items:center;left:1px;top:12px;background:white;.or{border:1px solid ", (0, _colors.color_colors_royalty), ";font-size:10px;line-height:16px;text-align:center;letter-spacing:0.05em;text-transform:uppercase;width:24px;height:16px;box-sizing:border-box;border-radius:4px;}.or-detail{font-style:italic;font-weight:normal;font-size:12px;line-height:16px;margin:0 8px;color:", (0, _colors.color_text_light), ";}}}}.add-condition-group{margin-left:0;margin-top:24px;}", "");
exports.default = ConditionsGroup;

},{"@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","../../../constants/colors":"1p3OR","../../../constants/stylesValues":"dHVVv","../../../components/general/Button":"6ymxN","../../../components/general/TooltipWrapper":"53pWd","f0d1a3d465767757":"kzzGR","ff1040b1a617006a":"c7C0Z","78c96999cd5aedb1":"auWhI","da77b23ae037fa":"1pH1E","263270d2fc6744ee":"91AUv","33566dbe0d0d7163":"4SNEL","14336029f3f2fdf9":"1DD4j","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"kzzGR":[function(require,module,exports) {
module.exports = require("8010f379731ac950").getBundleURL("kVLro") + require("f5f92c0ab7e52eb").resolve("ikgQm");

},{"8010f379731ac950":"c7Tr5","f5f92c0ab7e52eb":"fyJL2"}],"c7C0Z":[function(require,module,exports) {
module.exports = require("df79c65c13c7a349").getBundleURL("kVLro") + require("b714f6e69e69827a").resolve("6UfFG");

},{"df79c65c13c7a349":"c7Tr5","b714f6e69e69827a":"fyJL2"}],"auWhI":[function(require,module,exports) {
module.exports = require("c68c8d859de31ecd").getBundleURL("kVLro") + require("74363b45aa97f4a1").resolve("1f4Me");

},{"c68c8d859de31ecd":"c7Tr5","74363b45aa97f4a1":"fyJL2"}],"1pH1E":[function(require,module,exports) {
module.exports = require("233550d459fb2620").getBundleURL("kVLro") + require("19297b8a2e97ceb").resolve("8umXa");

},{"233550d459fb2620":"c7Tr5","19297b8a2e97ceb":"fyJL2"}],"91AUv":[function(require,module,exports) {
module.exports = require("52df7ae414059acb").getBundleURL("kVLro") + require("33ccd2b0332f9fee").resolve("c9CPd");

},{"52df7ae414059acb":"c7Tr5","33ccd2b0332f9fee":"fyJL2"}],"4SNEL":[function(require,module,exports) {
module.exports = require("37397667814b3f9e").getBundleURL("kVLro") + require("fd4ed0214ab502e3").resolve("39PHn");

},{"37397667814b3f9e":"c7Tr5","fd4ed0214ab502e3":"fyJL2"}],"1DD4j":[function(require,module,exports) {
module.exports = require("d8f081ddaff93b35").getBundleURL("kVLro") + require("8c365a0df76843ff").resolve("1snot");

},{"d8f081ddaff93b35":"c7Tr5","8c365a0df76843ff":"fyJL2"}],"9wsb6":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _defineProperty = require("@babel/runtime/helpers/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _base = require("@emotion/styled/base");
var _baseDefault = parcelHelpers.interopDefault(_base);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _smallModalLayout = require("../../../components/structure/SmallModalLayout");
var _smallModalLayoutDefault = parcelHelpers.interopDefault(_smallModalLayout);
var _horizontalContainer = require("../../../components/structure/HorizontalContainer");
var _horizontalContainerDefault = parcelHelpers.interopDefault(_horizontalContainer);
var _modalTitle = require("../../../components/general/ModalTitle");
var _modalTitleDefault = parcelHelpers.interopDefault(_modalTitle);
var _button = require("../../../components/general/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _stylesValues = require("../../../constants/stylesValues");
var _colors = require("../../../constants/colors");
var _footerBar = require("../../../components/structure/FooterBar");
var _footerBarDefault = parcelHelpers.interopDefault(_footerBar);
var _selectField = require("../../../components/forms/SelectField");
var _selectFieldDefault = parcelHelpers.interopDefault(_selectField);
var _textField = require("../../../components/forms/TextField");
var _textFieldDefault = parcelHelpers.interopDefault(_textField);
var _guids = require("../../../services/guids");
var _guidsDefault = parcelHelpers.interopDefault(_guids);
var _lodash = require("lodash");
var _lodashDefault = parcelHelpers.interopDefault(_lodash);
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const closeIcon = require("f6a06598a2e64b43");
const decisionIcon = require("88b034852dbeb694");
const equalsIcon = require("f7d3fb4595e3fd75");
const notEqualsIcon = require("e25eefaf94a0b954");
const containsIcon = require("7da91615c0799fe9");
const notContainsIcon = require("de7dc7589495c09a");
const BooleanConditionGroupNames = [
    "New User",
    "Account Linked",
    "Positive Sentiment",
    "Negative Sentiment"
];
class ConditionManager extends (0, _reactDefault.default).Component {
    constructor(props){
        super(props);
        (0, _definePropertyDefault.default)(this, "capabilityOptions", [
            {
                value: "HasAudio",
                label: "Supports Audio"
            },
            {
                value: "SupportsVideo",
                label: "Supports Video"
            },
            {
                value: "HasDisplay",
                label: "Supports Display"
            }
        ]);
        const condition = props.defaultConditionInstance?.conditionId ? props.conditions.find((c)=>c.id == props.defaultConditionInstance.conditionId) : null;
        this.state = {
            groupName: condition?.groupName ?? "",
            qualifier: condition?.comparisonType ?? "Equals",
            value: props.defaultConditionInstance?.value ?? "",
            canChangeValue: condition != null
        };
    }
    getValueSuggestions() {
        if (this.state.groupName?.toLocaleLowerCase() == "platform") return [
            "Alexa",
            "GoogleAssistant",
            "Dialogflow"
        ];
        if (this.state.groupName?.toLocaleLowerCase() == "user flags" || this.state.groupName?.toLocaleLowerCase() == "session flags") return (0, _lodashDefault.default).uniqBy(this.props.flags ?? [], (f)=>f.name)?.map((f)=>f.name) ?? [];
        return null;
    }
    isBooleanCondition(value) {
        return BooleanConditionGroupNames.includes(value);
    }
    handleVariableChange(e) {
        let newValue = "";
        if (this.isBooleanCondition(e.value)) newValue = "true";
        this.setState({
            ...this.state,
            groupName: e.value,
            qualifier: this.props.conditions?.find((c)=>c.groupName == e.value && (c.comparisonType == "Equals" || c.comparisonType == "Contains"))?.comparisonType ?? "Equals",
            canChangeValue: !this.isBooleanCondition(e.value),
            value: newValue
        });
    }
    handleValueChange(e) {
        this.setState({
            ...this.state,
            value: e.target.value
        });
    }
    hanldeSelectValueChange(e) {
        this.setState({
            ...this.state,
            value: e.value
        });
    }
    getQualifierLabel(qualifier) {
        switch(qualifier){
            case "Contains":
                return "Includes";
            case "DoesNotContain":
                return "Excludes";
            case "Equals":
                return "Equals";
            case "NotEquals":
                return "Does not equal";
        }
        return "";
    }
    getQualifierIcon(qualifier) {
        switch(qualifier){
            case "Contains":
                return containsIcon;
            case "DoesNotContain":
                return notContainsIcon;
            case "Equals":
                return equalsIcon;
            case "NotEquals":
                return notEqualsIcon;
        }
        return "";
    }
    getQualifiers() {
        const conditions = this.props.conditions?.filter((c)=>c.groupName == this.state.groupName);
        return conditions?.map((c)=>({
                label: this.getQualifierLabel(c.comparisonType),
                value: c.comparisonType
            }));
    }
    handleQualifierChange(e) {
        this.setState({
            ...this.state,
            qualifier: e.value,
            canChangeValue: this.state.groupName != "New User" && this.state.groupName != "Account Linked",
            value: this.state.groupName != "New User" && this.state.groupName != "Account Linked" ? this.state.value : "true"
        });
    }
    getConditionGroups() {
        const conditionGroups = [];
        this.props.conditions?.forEach((c)=>{
            const group = conditionGroups.find((g)=>g.groupName == c.groupName);
            if (group) group.conditions.push(c);
            else conditionGroups.push({
                groupName: c.groupName,
                conditions: [
                    c
                ]
            });
        });
        return conditionGroups;
    }
    getInstanceFromState() {
        const condition = this.props.conditions.find((c)=>c.groupName == this.state.groupName && c.comparisonType == this.state.qualifier);
        return {
            id: (0, _guidsDefault.default)(),
            andCondition: null,
            value: this.state.value,
            conditionId: condition.id,
            condition
        };
    }
    handleEnterPress(e) {
        if (e.charCode == 13) {
            this.props.onFinish(this.getInstanceFromState());
            e.stopPropogation();
        }
    }
    renderValueField() {
        // device type show dropdown
        if (this.state.groupName?.toLocaleLowerCase() == "device type") return (0, _react.jsx)((0, _selectFieldDefault.default), {
            useFormTheme: true,
            clearable: false,
            className: valueSelectStyle,
            options: this.props.deviceTypes?.map((d)=>({
                    value: d.id,
                    label: d.displayName
                })),
            placeholder: "- Select a Value -",
            label: "Value",
            value: this.state?.value ?? "",
            onChange: this.hanldeSelectValueChange.bind(this),
            disabled: !this.state.groupName || !this.state.canChangeValue,
            name: "value"
        });
        // capability show dropdown
        if (this.state.groupName?.toLocaleLowerCase() == "device capability") return (0, _react.jsx)((0, _selectFieldDefault.default), {
            useFormTheme: true,
            clearable: false,
            className: valueSelectStyle,
            options: this.capabilityOptions,
            placeholder: "- Select a Value -",
            label: "Value",
            value: this.state?.value ?? "",
            onChange: this.hanldeSelectValueChange.bind(this),
            disabled: !this.state.groupName || !this.state.canChangeValue,
            name: "value"
        });
        // default text field
        return (0, _react.jsx)((0, _textFieldDefault.default), {
            className: valueTextStyle,
            onKeyPress: this.handleEnterPress.bind(this),
            suggestions: this.getValueSuggestions(),
            onSuggestionClick: this.handleSuggestionClick.bind(this),
            placeholder: "- Enter a Value -",
            label: "Value",
            value: this.state?.value ?? "",
            onChange: this.handleValueChange.bind(this),
            disabled: !this.state.groupName || !this.state.canChangeValue,
            name: "value"
        });
    }
    handleSuggestionClick(text) {
        this.setState({
            ...this.state,
            value: text
        });
    }
    getDisplayValue() {
        if (this.state.groupName?.toLocaleLowerCase() == "device type") return this.props.deviceTypes?.find((d)=>d.id == this.state.value)?.displayName;
        if (this.state.groupName?.toLocaleLowerCase() == "device capability") return this.capabilityOptions.find((d)=>d.value == this.state.value)?.label;
        return this.state.value;
    }
    render() {
        return (0, _react.jsx)((0, _smallModalLayoutDefault.default), {
            className: overflowVisibleStyle,
            isVisible: true,
            onClose: this.props.onCancel
        }, (0, _react.jsx)("div", {
            className: wrapperStyle
        }, (0, _react.jsx)((0, _horizontalContainerDefault.default), {
            className: titleContainer
        }, (0, _react.jsx)(TitleWrapper, null, (0, _react.jsx)("img", {
            src: decisionIcon
        }), (0, _react.jsx)((0, _modalTitleDefault.default), null, "Add a Condition")), (0, _react.jsx)(CloseButtonWrapper, null, (0, _react.jsx)((0, _buttonDefault.default), {
            className: closeButton,
            themes: [
                "start-tight",
                "icon"
            ],
            icon: closeIcon,
            onClick: this.props.onCancel
        }))), (0, _react.jsx)("div", {
            className: bodyContainer
        }, (0, _react.jsx)((0, _selectFieldDefault.default), {
            clearable: false,
            placeholder: "- Select a Variable -",
            label: "Variable",
            value: this.state.groupName,
            options: this.getConditionGroups().map((c)=>({
                    label: c.groupName,
                    value: c.groupName
                })),
            onChange: this.handleVariableChange.bind(this),
            useFormTheme: true,
            name: "variable",
            onBlur: ()=>{}
        }), (0, _react.jsx)((0, _selectFieldDefault.default), {
            clearable: false,
            placeholder: "- Select a Qualifier -",
            label: "Qualifier",
            value: this.state.qualifier,
            options: this.getQualifiers(),
            disabled: !this.state.groupName,
            onChange: this.handleQualifierChange.bind(this),
            useFormTheme: true,
            name: "qualifier",
            onBlur: ()=>{}
        }), this.renderValueField()), this.state.groupName && (0, _react.jsx)("div", {
            className: conditionPreviewStyle
        }, (0, _react.jsx)("p", null, this.state.groupName), (0, _react.jsx)("img", {
            src: this.getQualifierIcon(this.state.qualifier)
        }), (0, _react.jsx)("p", null, this.getDisplayValue() ?? "...")), (0, _react.jsx)((0, _footerBarDefault.default), {
            className: footerStyle
        }, (0, _react.jsx)((0, _buttonDefault.default), {
            themes: [
                "primary",
                "start-tight"
            ],
            text: "Save",
            type: "button",
            disabled: !this.state.groupName,
            onClick: ()=>this.props.onFinish(this.getInstanceFromState())
        }), (0, _react.jsx)((0, _buttonDefault.default), {
            themes: [
                "white",
                "end-tight"
            ],
            text: "Cancel",
            type: "button",
            onClick: this.props.onCancel
        }))));
    }
}
const TitleWrapper = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e9xcyq11"
})({
    name: "s5xdrg",
    styles: "display:flex;align-items:center"
});
const CloseButtonWrapper = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e9xcyq10"
})("display:flex;padding-left:28.5px;border-left:", (0, _stylesValues.style_border_default), ";");
const closeButton = /*#__PURE__*/ (0, _css.css)({
    name: "xjgief",
    styles: "margin-right:-8px;margin-left:0"
});
const wrapperStyle = /*#__PURE__*/ (0, _css.css)({
    name: "2sb7p4",
    styles: "display:flex;flex-direction:column;align-items:stretch;height:580px;overflow:visible"
});
const titleContainer = /*#__PURE__*/ (0, _css.css)("background:white;padding:0 32px;justify-content:space-between;align-items:center;border-top-right-radius:20px;border-top-left-radius:20px;border-bottom:", (0, _stylesValues.style_border_default), ";img{margin-right:16px;}", "");
const bodyContainer = /*#__PURE__*/ (0, _css.css)("padding:32px;background:", (0, _colors.color_variants_main_bg), ";flex:1;border-bottom-right-radius:20px;border-bottom-left-radius:20px;", "");
const conditionPreviewStyle = /*#__PURE__*/ (0, _css.css)("display:flex;align-items:center;position:absolute;bottom:80px;left:0;right:0;background:", (0, _colors.color_variants_royalty_light_20), ";height:40px;border-top:", (0, _stylesValues.style_border_default), ";padding:0 32px;font-style:normal;font-weight:normal;font-size:14px;line-height:20px;img{margin:0 8px;}", "");
const footerStyle = /*#__PURE__*/ (0, _css.css)({
    name: "joji84",
    styles: "position:fixed;border-bottom-right-radius:20px;border-bottom-left-radius:20px;padding:0 32px"
});
const valueSelectStyle = /*#__PURE__*/ (0, _css.css)({
    name: "156m0z0",
    styles: ".Select-menu-outer{z-index:111;overflow:hidden;}"
});
const valueTextStyle = /*#__PURE__*/ (0, _css.css)({
    name: "p7xwq7",
    styles: ".text-field-suggestions{z-index:111;}"
});
const overflowVisibleStyle = /*#__PURE__*/ (0, _css.css)({
    name: "1h8nup8",
    styles: "overflow:visible"
});
exports.default = ConditionManager;

},{"@babel/runtime/helpers/defineProperty":"9sJxO","@emotion/styled/base":"lSuFu","@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","../../../components/structure/SmallModalLayout":"khwvt","../../../components/structure/HorizontalContainer":"eJPfh","../../../components/general/ModalTitle":"hIp2B","../../../components/general/Button":"6ymxN","../../../constants/stylesValues":"dHVVv","../../../constants/colors":"1p3OR","../../../components/structure/FooterBar":"bibRL","../../../components/forms/SelectField":"405B3","../../../components/forms/TextField":"7a7bh","../../../services/guids":"jvaYQ","lodash":"3hMBK","f6a06598a2e64b43":"93VwA","88b034852dbeb694":"9ujmQ","f7d3fb4595e3fd75":"c7C0Z","e25eefaf94a0b954":"auWhI","7da91615c0799fe9":"1pH1E","de7dc7589495c09a":"91AUv","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"khwvt":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const layoutStyle = /*#__PURE__*/ (0, _css.css)({
    name: "1f9iswt",
    styles: "width:100%;height:100%;overflow-x:visible;background:rgba(44,61,82, 0.7);padding:65px 115px;z-index:1001;position:fixed;top:0;left:0"
});
const innerLayoutStyle = /*#__PURE__*/ (0, _css.css)({
    name: "i8ar6b",
    styles: "border-radius:20px;border:12px solid rgba(44,61,82, 0.8);display:block;width:80%;max-width:900px;min-height:580px;max-height:calc(100vh - 20px);position:fixed;z-index:1002;left:50%;top:50%;transform:translate(-50%, -50%);background:white;overflow:hidden"
});
const innerWrapperStyle = /*#__PURE__*/ (0, _css.css)({
    name: "1677pwn",
    styles: "border-radius:20px;height:100%"
});
const hiddenStyle = /*#__PURE__*/ (0, _css.css)({
    name: "eivff4",
    styles: "display:none"
});
const SmallModalLayout = (props)=>(0, _react.jsx)("div", {
        className: props.isVisible ? "" : hiddenStyle
    }, (0, _react.jsx)("div", {
        className: `${innerLayoutStyle} ${props.className ?? ""}`
    }, (0, _react.jsx)("div", {
        className: `${innerWrapperStyle} ${props.innerClassName ?? ""}`
    }, props.children)), (0, _react.jsx)("div", {
        className: layoutStyle,
        onClick: props.onClose
    }));
exports.default = SmallModalLayout;

},{"@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jvaYQ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
const generateGuid = ()=>{
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function(c) {
        var r = Math.random() * 16 | 0, v = c == "x" ? r : r & 0x3 | 0x8;
        return v.toString(16);
    });
};
exports.default = generateGuid;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9ujmQ":[function(require,module,exports) {
module.exports = require("6f9792e42cf82afc").getBundleURL("kVLro") + require("70b009408691e99d").resolve("cjuwu");

},{"6f9792e42cf82afc":"c7Tr5","70b009408691e99d":"fyJL2"}],"3p5Wl":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _defineProperty = require("@babel/runtime/helpers/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _toggleIndicator = require("../../../components/general/ToggleIndicator");
var _toggleIndicatorDefault = parcelHelpers.interopDefault(_toggleIndicator);
var _colors = require("../../../constants/colors");
var _stylesValues = require("../../../constants/stylesValues");
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const addIcon = require("7b56c17417bec2ba");
class AddResponseSection extends (0, _reactDefault.default).Component {
    constructor(props){
        super(props);
        (0, _definePropertyDefault.default)(this, "documentCloser", this.handleDocumentClick.bind(this));
        this.state = {
            isOptionsExpanded: false
        };
    }
    componentDidMount() {
        document.addEventListener("click", this.documentCloser, true);
    }
    componentWillUnmount() {
        document.removeEventListener("click", this.documentCloser, true);
    }
    handleDocumentClick(e) {
        if (e.target.closest(".card-title-container") || e.target.closest(".add-options")) return;
        this.setState({
            ...this.state,
            isOptionsExpanded: false
        });
    }
    toggleOptions() {
        this.setState({
            ...this.state,
            isOptionsExpanded: !this.state.isOptionsExpanded
        });
    }
    render() {
        const { titleRightRowComponent } = this.props;
        return (0, _react.jsx)("div", {
            className: `${cardStyle} ac-add-response-group`,
            id: "addConditionalResponse"
        }, (0, _react.jsx)("div", {
            className: "card-title-container",
            onClick: this.toggleOptions.bind(this)
        }, (0, _react.jsx)("img", {
            src: addIcon
        }), (0, _react.jsx)("h4", null, "Add a Conditional Response"), (0, _react.jsx)((0, _toggleIndicatorDefault.default), {
            direction: this.state.isOptionsExpanded ? "up" : "down",
            className: toggleIndicatorStyle
        }), titleRightRowComponent), this.state.isOptionsExpanded && (0, _react.jsx)("div", {
            className: "add-options"
        }, (0, _react.jsx)("button", {
            type: "button",
            onClick: this.props.onCloneNew
        }, "Duplicate the Default Response"), (0, _react.jsx)("button", {
            type: "button",
            onClick: this.props.onAddNew
        }, "Start a New Blank Response"), (0, _react.jsx)("div", {
            className: "triangle"
        })));
    }
}
const cardStyle = /*#__PURE__*/ (0, _css.css)("border-top:solid 1px ", (0, _colors.color_shades_dark), ";flex-grow:0;position:relative;.card-title-container{display:flex;flex-direction:row;align-items:center;border-bottom:solid 1px ", (0, _colors.color_shades_dark), ";padding:24px 24px 24px 0;cursor:pointer;background:white;>img{width:24px;height:24px;margin-left:32px;}>h4{font-family:Muli;font-style:normal;font-weight:normal;font-size:18px;color:", (0, _colors.color_text_default), ";margin:0 10px;}.toggle-indicator{margin:0 4px;}}.card-body{padding:32px;&.collapsed{padding:0;display:none;}}.add-options{position:absolute;margin-top:-172px;margin-left:124px;border:", (0, _stylesValues.style_border_default), ";border-radius:8px;background:white;box-shadow:0 4px 4px 0 ", (0, _colors.dark_grey_blue_10), ";display:flex;flex-direction:column;button{border:none;background:none;box-shadow:none;color:", (0, _colors.color_text_link), ";height:48px;padding:0 16px;text-align:left;font-family:'Muli';font-size:14px;cursor:pointer;&:first-child{border-bottom:", (0, _stylesValues.style_border_default), ";}}.triangle{position:absolute;bottom:-5px;right:14px;width:10px;height:10px;border-bottom:", (0, _stylesValues.style_border_default), ";border-right:", (0, _stylesValues.style_border_default), ";transform:rotate(45deg);background-color:white;}}", "");
const toggleIndicatorStyle = /*#__PURE__*/ (0, _css.css)({
    name: "11f9gim",
    styles: "height:8px;width:8px"
});
exports.default = AddResponseSection;

},{"@babel/runtime/helpers/defineProperty":"9sJxO","@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","../../../components/general/ToggleIndicator":"4eej1","../../../constants/colors":"1p3OR","../../../constants/stylesValues":"dHVVv","7b56c17417bec2ba":"6cI2N","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6cI2N":[function(require,module,exports) {
module.exports = require("90925c6ef74fcfa3").getBundleURL("kVLro") + require("4d5539444aad0a1e").resolve("2WyYM");

},{"90925c6ef74fcfa3":"c7Tr5","4d5539444aad0a1e":"fyJL2"}],"3XOv8":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _unstated = require("unstated");
var _repromptContainer = require("../../state/containers/RepromptContainer");
var _repromptContainerDefault = parcelHelpers.interopDefault(_repromptContainer);
var _scrollView = require("../../components/structure/ScrollView");
var _scrollViewDefault = parcelHelpers.interopDefault(_scrollView);
var _fullScreenLayout = require("../fullScreenLayout");
var _fullScreenLayoutDefault = parcelHelpers.interopDefault(_fullScreenLayout);
var _pageContainer = require("../../components/structure/PageContainer");
var _pageContainerDefault = parcelHelpers.interopDefault(_pageContainer);
var _horizontalContainer = require("../../components/structure/HorizontalContainer");
var _horizontalContainerDefault = parcelHelpers.interopDefault(_horizontalContainer);
var _modalTitle = require("../../components/general/ModalTitle");
var _modalTitleDefault = parcelHelpers.interopDefault(_modalTitle);
var _button = require("../../components/general/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _horizontalSeparator = require("../../components/structure/HorizontalSeparator");
var _horizontalSeparatorDefault = parcelHelpers.interopDefault(_horizontalSeparator);
var _tabPanelBody = require("../../components/structure/TabPanelBody");
var _tabPanelBodyDefault = parcelHelpers.interopDefault(_tabPanelBody);
var _repromptForm = require("./components/RepromptForm");
var _repromptFormDefault = parcelHelpers.interopDefault(_repromptForm);
var _smallModalLayout = require("../../components/structure/SmallModalLayout");
var _smallModalLayoutDefault = parcelHelpers.interopDefault(_smallModalLayout);
const closeIcon = require("36f0d1f11abdea60");
class RepromptManager extends (0, _reactDefault.default).Component {
    componentWillMount() {
        this.setState({
            hasChanges: false
        });
    }
    handleClose() {
        if (this.state.hasChanges) {
            var confirmClose = confirm("You have unsaved changes. Are you sure you want to close?");
            if (!confirmClose) return;
        }
        if (this.props.onClose) this.props.onClose();
    }
    handleFinish(reprompt) {
        this.setState({
            hasChanges: false
        });
        if (this.props.onFinish) this.props.onFinish(reprompt);
    }
    handleChange() {
        this.setState({
            hasChanges: true
        });
    }
    render() {
        return (0, _react.jsx)((0, _smallModalLayoutDefault.default), {
            onClose: this.handleClose.bind(this),
            isVisible: true
        }, (0, _react.jsx)((0, _unstated.Subscribe), {
            to: [
                (0, _repromptContainerDefault.default)
            ]
        }, (repromptContainer)=>{
            return (0, _react.jsx)((0, _fullScreenLayoutDefault.default), null, (0, _react.jsx)((0, _scrollViewDefault.default), null, (0, _react.jsx)((0, _pageContainerDefault.default), null, (0, _react.jsx)((0, _horizontalContainerDefault.default), null, (0, _react.jsx)((0, _modalTitleDefault.default), null, "Reprompt:"), (0, _react.jsx)((0, _buttonDefault.default), {
                themes: [
                    "end-tight",
                    "icon"
                ],
                icon: closeIcon,
                onClick: this.handleClose.bind(this)
            })), (0, _react.jsx)((0, _horizontalSeparatorDefault.default), null), (0, _react.jsx)((0, _tabPanelBodyDefault.default), null, (0, _react.jsx)((0, _repromptFormDefault.default), {
                reprompt: this.props.reprompt,
                applicationId: this.props.applicationId,
                repromptContainer: repromptContainer,
                onFinish: this.handleFinish.bind(this),
                onChange: this.handleChange.bind(this),
                onClose: this.handleClose.bind(this)
            })))));
        }));
    }
}
exports.default = RepromptManager;

},{"@emotion/react":"djZKr","react":"6uln9","unstated":"grh7p","../../state/containers/RepromptContainer":"5vKMV","../../components/structure/ScrollView":"53ath","../fullScreenLayout":"5mVdG","../../components/structure/PageContainer":"hc1r8","../../components/structure/HorizontalContainer":"eJPfh","../../components/general/ModalTitle":"hIp2B","../../components/general/Button":"6ymxN","../../components/structure/HorizontalSeparator":"Pw3HQ","../../components/structure/TabPanelBody":"ePx7g","./components/RepromptForm":"jwe1Q","../../components/structure/SmallModalLayout":"khwvt","36f0d1f11abdea60":"93VwA","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"53ath":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const scrollviewStyle = /*#__PURE__*/ (0, _css.css)({
    name: "11lqsdn",
    styles: "height:100%;width:100%;overflow-y:auto"
});
const ScrollView = (props)=>(0, _react.jsx)("div", {
        className: `${scrollviewStyle} ${props.className}`
    }, props.children);
exports.default = ScrollView;

},{"@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jwe1Q":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _formik = require("formik");
var _yup = require("yup");
var _formFieldsContainer = require("../../../components/structure/FormFieldsContainer");
var _formFieldsContainerDefault = parcelHelpers.interopDefault(_formFieldsContainer);
var _textField = require("../../../components/forms/TextField");
var _textFieldDefault = parcelHelpers.interopDefault(_textField);
var _footerBar = require("../../../components/structure/FooterBar");
var _footerBarDefault = parcelHelpers.interopDefault(_footerBar);
var _button = require("../../../components/general/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _detailLabel = require("../../../components/general/DetailLabel");
var _detailLabelDefault = parcelHelpers.interopDefault(_detailLabel);
var _checkboxField = require("../../../components/forms/CheckboxField");
var _checkboxFieldDefault = parcelHelpers.interopDefault(_checkboxField);
var _ssmlField = require("../../../components/forms/SsmlField/SsmlField");
var _ssmlFieldDefault = parcelHelpers.interopDefault(_ssmlField);
class InnerForm extends (0, _reactDefault.default).Component {
    handleCheckboxToggle(e) {
        this.props.setFieldValue("includeFollowUp", e.target.checked);
    }
    handleSsmlUpdate(value) {
        this.props.setFieldValue("content", value);
    }
    render() {
        const props = {
            ...this.props
        };
        const isLoading = props.repromptContainer.state.isLoading || props.repromptContainer.state.isSaving;
        return (0, _react.jsx)((0, _reactDefault.default).Fragment, null, (0, _react.jsx)((0, _detailLabelDefault.default), {
            text: "If the user doesn’t respond to what the device says, you can re-prompt them for a response."
        }), (0, _react.jsx)((0, _formFieldsContainerDefault.default), null, (0, _react.jsx)((0, _textFieldDefault.default), {
            className: "tight",
            name: "name",
            required: true,
            value: props.values.name,
            label: "Name:",
            placeholder: "What do you want to call this message?",
            onChange: props.handleChange,
            onBlur: props.handleBlur,
            disabled: isLoading
        }), (0, _react.jsx)((0, _ssmlFieldDefault.default), {
            applicationId: this.props.applicationId,
            className: "tight",
            name: "content",
            required: true,
            value: props.values.content,
            label: "Reprompt language:",
            placeholder: "What do you want the device to say?",
            onChange: this.handleSsmlUpdate.bind(this),
            onBlur: props.handleBlur,
            disabled: isLoading
        }), (0, _react.jsx)((0, _checkboxFieldDefault.default), {
            name: "includeFollowUp",
            checked: props.values.includeFollowUp,
            label: "Then repeat previous Follow-up",
            onChange: this.handleCheckboxToggle.bind(this)
        })), (0, _react.jsx)((0, _footerBarDefault.default), null, (0, _react.jsx)((0, _buttonDefault.default), {
            loading: isLoading,
            disabled: isLoading,
            themes: [
                "primary",
                "wide"
            ],
            text: "Save",
            type: "button",
            onClick: props.handleSubmit
        }), (0, _react.jsx)((0, _buttonDefault.default), {
            disabled: isLoading,
            themes: [
                "white",
                "end"
            ],
            text: "Cancel",
            type: "button",
            onClick: props.onClose
        })));
    }
}
const RepromptForm = (0, _formik.withFormik)({
    mapPropsToValues: (props)=>({
            name: props.reprompt ? props.reprompt.name ? props.reprompt.name : "" : "",
            content: props.reprompt ? props.reprompt.content : "",
            includeFollowUp: true
        }),
    validationSchema: _yup.object().shape({
        name: _yup.string().required("You must enter a name"),
        content: _yup.string().required("You must enter your message")
    }),
    handleSubmit: (values, { props })=>{
        if (props.reprompt && props.reprompt.id) // updating an existing one
        props.repromptContainer.updateReprompt(props.reprompt.id, {
            id: props.reprompt.id,
            name: values.name,
            content: values.content,
            includeFollowUp: values.includeFollowUp
        }).then((result)=>{
            if (result.resultType == "Ok") props.onFinish(result.data);
        });
        else // creating a new one
        props.repromptContainer.addReprompt(props.applicationId, {
            name: values.name,
            content: values.content,
            includeFollowUp: values.includeFollowUp
        }).then((result)=>{
            if (result.resultType == "Ok") props.onFinish(result.data);
        });
    }
})(InnerForm);
exports.default = RepromptForm;

},{"@emotion/react":"djZKr","react":"6uln9","formik":"3YnOK","yup":"j2SJU","../../../components/structure/FormFieldsContainer":"h3hzh","../../../components/forms/TextField":"7a7bh","../../../components/structure/FooterBar":"bibRL","../../../components/general/Button":"6ymxN","../../../components/general/DetailLabel":"j3EnX","../../../components/forms/CheckboxField":"3S5Oy","../../../components/forms/SsmlField/SsmlField":"cvL6K","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"siWDj":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _unstated = require("unstated");
var _followUpContainer = require("../../state/containers/FollowUpContainer");
var _followUpContainerDefault = parcelHelpers.interopDefault(_followUpContainer);
var _scrollView = require("../../components/structure/ScrollView");
var _scrollViewDefault = parcelHelpers.interopDefault(_scrollView);
var _fullScreenLayout = require("../fullScreenLayout");
var _fullScreenLayoutDefault = parcelHelpers.interopDefault(_fullScreenLayout);
var _pageContainer = require("../../components/structure/PageContainer");
var _pageContainerDefault = parcelHelpers.interopDefault(_pageContainer);
var _horizontalContainer = require("../../components/structure/HorizontalContainer");
var _horizontalContainerDefault = parcelHelpers.interopDefault(_horizontalContainer);
var _modalTitle = require("../../components/general/ModalTitle");
var _modalTitleDefault = parcelHelpers.interopDefault(_modalTitle);
var _button = require("../../components/general/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _horizontalSeparator = require("../../components/structure/HorizontalSeparator");
var _horizontalSeparatorDefault = parcelHelpers.interopDefault(_horizontalSeparator);
var _tabPanelBody = require("../../components/structure/TabPanelBody");
var _tabPanelBodyDefault = parcelHelpers.interopDefault(_tabPanelBody);
var _followUpForm = require("./components/FollowUpForm");
var _followUpFormDefault = parcelHelpers.interopDefault(_followUpForm);
var _smallModalLayout = require("../../components/structure/SmallModalLayout");
var _smallModalLayoutDefault = parcelHelpers.interopDefault(_smallModalLayout);
const closeIcon = require("e9bf92bdc6ebabfe");
class FollowUpManager extends (0, _reactDefault.default).Component {
    componentWillMount() {
        this.setState({
            hasChanges: false
        });
    }
    handleClose() {
        if (this.state.hasChanges) {
            var confirmClose = confirm("You have unsaved changes. Are you sure you want to close?");
            if (!confirmClose) return;
        }
        if (this.props.onClose) this.props.onClose();
    }
    handleFinish(followUp) {
        this.setState({
            hasChanges: false
        });
        if (this.props.onFinish) this.props.onFinish(followUp);
    }
    handleChange() {
        this.setState({
            hasChanges: true
        });
    }
    render() {
        return (0, _react.jsx)((0, _smallModalLayoutDefault.default), {
            onClose: this.handleClose.bind(this),
            isVisible: true
        }, (0, _react.jsx)((0, _unstated.Subscribe), {
            to: [
                (0, _followUpContainerDefault.default)
            ]
        }, (followUpContainer)=>{
            return (0, _react.jsx)((0, _fullScreenLayoutDefault.default), null, (0, _react.jsx)((0, _scrollViewDefault.default), null, (0, _react.jsx)((0, _pageContainerDefault.default), null, (0, _react.jsx)((0, _horizontalContainerDefault.default), null, (0, _react.jsx)((0, _modalTitleDefault.default), null, "Add a Follow-up Message:"), (0, _react.jsx)((0, _buttonDefault.default), {
                themes: [
                    "end-tight",
                    "icon"
                ],
                icon: closeIcon,
                onClick: this.handleClose.bind(this)
            })), (0, _react.jsx)((0, _horizontalSeparatorDefault.default), null), (0, _react.jsx)((0, _tabPanelBodyDefault.default), null, (0, _react.jsx)((0, _followUpFormDefault.default), {
                followUp: this.props.followUp,
                applicationId: this.props.applicationId,
                followUpContainer: followUpContainer,
                onFinish: this.handleFinish.bind(this),
                onChange: this.handleChange.bind(this),
                onClose: this.handleClose.bind(this)
            })))));
        }));
    }
}
exports.default = FollowUpManager;

},{"@emotion/react":"djZKr","react":"6uln9","unstated":"grh7p","../../state/containers/FollowUpContainer":"rm9OA","../../components/structure/ScrollView":"53ath","../fullScreenLayout":"5mVdG","../../components/structure/PageContainer":"hc1r8","../../components/structure/HorizontalContainer":"eJPfh","../../components/general/ModalTitle":"hIp2B","../../components/general/Button":"6ymxN","../../components/structure/HorizontalSeparator":"Pw3HQ","../../components/structure/TabPanelBody":"ePx7g","./components/FollowUpForm":"jIGhL","../../components/structure/SmallModalLayout":"khwvt","e9bf92bdc6ebabfe":"93VwA","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jIGhL":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _formik = require("formik");
var _yup = require("yup");
var _formFieldsContainer = require("../../../components/structure/FormFieldsContainer");
var _formFieldsContainerDefault = parcelHelpers.interopDefault(_formFieldsContainer);
var _textField = require("../../../components/forms/TextField");
var _textFieldDefault = parcelHelpers.interopDefault(_textField);
var _footerBar = require("../../../components/structure/FooterBar");
var _footerBarDefault = parcelHelpers.interopDefault(_footerBar);
var _button = require("../../../components/general/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _detailLabel = require("../../../components/general/DetailLabel");
var _detailLabelDefault = parcelHelpers.interopDefault(_detailLabel);
var _formContainer = require("../../../components/structure/FormContainer");
var _formContainerDefault = parcelHelpers.interopDefault(_formContainer);
var _ssmlField = require("../../../components/forms/SsmlField/SsmlField");
var _ssmlFieldDefault = parcelHelpers.interopDefault(_ssmlField);
class InnerForm extends (0, _reactDefault.default).Component {
    handleSsmlUpdate(value) {
        this.props.setFieldValue("content", value);
    }
    render() {
        const props = {
            ...this.props
        };
        const isLoading = props.followUpContainer.state.isLoading || props.followUpContainer.state.isSaving;
        return (0, _react.jsx)((0, _reactDefault.default).Fragment, null, (0, _react.jsx)((0, _formContainerDefault.default), null, (0, _react.jsx)((0, _detailLabelDefault.default), {
            text: "Update your follow-up dialogue"
        }), (0, _react.jsx)((0, _formFieldsContainerDefault.default), null, (0, _react.jsx)((0, _textFieldDefault.default), {
            className: "tight",
            name: "name",
            required: true,
            value: props.values.name,
            label: "Name:",
            placeholder: "What do you want to call this message?",
            onChange: props.handleChange,
            onBlur: props.handleBlur,
            disabled: isLoading
        }), (0, _react.jsx)((0, _ssmlFieldDefault.default), {
            applicationId: this.props.applicationId,
            className: "tight",
            name: "content",
            required: true,
            value: props.values.content,
            label: "Follow-up dialogue:",
            placeholder: "What do you want the device to say?",
            onChange: this.handleSsmlUpdate.bind(this),
            onBlur: props.handleBlur,
            disabled: isLoading
        }), (0, _react.jsx)((0, _formik.FieldArray), {
            validateOnChange: false,
            name: "followUpHints",
            render: (arrayHelpers)=>(0, _react.jsx)("div", null, props.values.followUpHints.map((response, index)=>(0, _react.jsx)("div", {
                        key: index
                    }, (0, _react.jsx)((0, _textFieldDefault.default), {
                        disabled: isLoading,
                        canDelete: index > 0,
                        onDelete: ()=>arrayHelpers.remove(index),
                        deletePosition: "right",
                        name: `followUpHints.${index}.content`,
                        placeholder: "Something the user can say",
                        label: `On-Screen Hint ${index > 0 ? "#" + (index + 1) : ""}`,
                        onChange: props.handleChange,
                        onBlur: props.handleBlur,
                        value: response.content,
                        tooltip: index == 0 ? `Hints are used on screen devices like the Echo Show and Google Home Hub. 
                                    On Alexa, this appears as a phrase at the bottom such as 'Try "Alexa, {hint}"', 
                                    and on Google Assistant they are tappable chips. Only hints with under 20 characters will appear on Google, 
                                    and Alexa can only show one hint at a time.` : undefined
                    }))), (0, _react.jsx)((0, _buttonDefault.default), {
                    type: "button",
                    themes: [
                        "hollow",
                        "fill"
                    ],
                    text: "Add an On-Screen Hint",
                    onClick: ()=>arrayHelpers.push({
                            content: ""
                        })
                }))
        }))), (0, _react.jsx)((0, _footerBarDefault.default), null, (0, _react.jsx)((0, _buttonDefault.default), {
            loading: isLoading,
            disabled: isLoading,
            themes: [
                "primary",
                "wide"
            ],
            text: "Save",
            type: "button",
            onClick: props.handleSubmit
        }), (0, _react.jsx)((0, _buttonDefault.default), {
            disabled: isLoading,
            themes: [
                "white",
                "end"
            ],
            text: "Cancel",
            type: "button",
            onClick: this.props.onClose
        })));
    }
}
const FollowUpForm = (0, _formik.withFormik)({
    mapPropsToValues: (props)=>({
            name: props.followUp ? props.followUp.name : "",
            content: props.followUp ? props.followUp.content : "",
            followUpHints: props.followUp.followUpHints ? props.followUp.followUpHints.map((f)=>({
                    id: f.id,
                    content: f.content
                })) : [
                {
                    content: ""
                }
            ]
        }),
    validationSchema: _yup.object().shape({
        name: _yup.string().required("You must enter a name"),
        content: _yup.string().required("You must enter your message")
    }),
    handleSubmit: (values, { props })=>{
        if (props.followUp && props.followUp.id) // updating an existing one
        props.followUpContainer.updateFollowUp(props.followUp.id, {
            id: props.followUp.id,
            name: values.name,
            content: values.content,
            followUpHints: values.followUpHints.filter((f)=>f.content && f.content.length > 0)
        }).then((result)=>{
            if (result.resultType == "Ok") props.onFinish(result.data);
        });
        else // creating a new one
        props.followUpContainer.addFollowUp(props.applicationId, {
            name: values.name,
            content: values.content,
            followUpHints: values.followUpHints
        }).then((result)=>{
            if (result.resultType == "Ok") props.onFinish(result.data);
        });
    }
})(InnerForm);
exports.default = FollowUpForm;

},{"@emotion/react":"djZKr","react":"6uln9","formik":"3YnOK","yup":"j2SJU","../../../components/structure/FormFieldsContainer":"h3hzh","../../../components/forms/TextField":"7a7bh","../../../components/structure/FooterBar":"bibRL","../../../components/general/Button":"6ymxN","../../../components/general/DetailLabel":"j3EnX","../../../components/structure/FormContainer":"4R4LR","../../../components/forms/SsmlField/SsmlField":"cvL6K","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"46SnP":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _base = require("@emotion/styled/base");
var _baseDefault = parcelHelpers.interopDefault(_base);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _horizontalSeparator = require("../../../components/structure/HorizontalSeparator");
var _horizontalSeparatorDefault = parcelHelpers.interopDefault(_horizontalSeparator);
var _button = require("../../../components/general/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _css = require("@emotion/css");
var _colors = require("../../../constants/colors");
var _stylesValues = require("../../../constants/stylesValues");
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const addFlagIcon = require("57cf14192fe04d9d");
const removeFlagIcon = require("2dd9d158da59783a");
const deleteIcon = require("678030520f10690f");
const sessionFlagIcon = require("b4b030108b841d74");
const FlagRulesGroup = ({ flagRules, onAddRule, onRemoveRule })=>{
    return (0, _react.jsx)((0, _reactDefault.default).Fragment, null, (0, _react.jsx)(DetailLabel, null, "Sometimes a particular response signifies a special circumstance that has occured. Here you may add or remove flags to help identify those cirucmstances."), flagRules?.length > 0 ? (0, _react.jsx)(FlagList, null, flagRules?.map((f)=>(0, _react.jsx)(FlagListItem, null, (0, _react.jsx)("img", {
            src: f.ruleType == "Remove" ? removeFlagIcon : addFlagIcon
        }), (0, _react.jsx)("p", null, f.applicationConversationFlag?.name), f.flagScope == "Session" && (0, _react.jsx)("img", {
            className: "session-icon",
            src: sessionFlagIcon
        }), (0, _react.jsx)("button", {
            className: "remove-button",
            type: "button",
            onClick: ()=>onRemoveRule(f)
        }, (0, _react.jsx)("img", {
            src: deleteIcon
        }))))) : (0, _react.jsx)(EmptyFlagContainer, null, (0, _react.jsx)("p", null, "No changes to User Flags")), (0, _react.jsx)((0, _horizontalSeparatorDefault.default), null), (0, _react.jsx)((0, _buttonDefault.default), {
        themes: [
            "secondary"
        ],
        className: addButtonStyle,
        type: "button",
        onClick: ()=>onAddRule(),
        text: "Add / Remove a Flag"
    }));
};
const DetailLabel = /*#__PURE__*/ (0, _baseDefault.default)("p", {
    target: "e2yzuei3"
})(`
    margin: 16px 0;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 20px;
    color: ${(0, _colors.color_text_light)};
`, "");
const FlagList = /*#__PURE__*/ (0, _baseDefault.default)("ul", {
    target: "e2yzuei2"
})(`
    list-type: none;
`, "");
const FlagListItem = /*#__PURE__*/ (0, _baseDefault.default)("li", {
    target: "e2yzuei1"
})(`
    height: 52px;
    border: ${(0, _stylesValues.style_border_default)};
    border-radius: 8px;
    display: flex;
    align-items: center;
    padding: 0 24px;
    margin-bottom: 8px;
    img {
        height: 24px;
        width: 24px;
        &.session-icon {
            width: 20px;
            height: 20px;
        }
    }
    p {
        margin: 0 12px;
        font-style: normal;
        font-weight: normal;
        font-size: 14px;
        line-height: 20px;
    }
    .remove-button {
        border: none;
        background: none;
        box-shadow: none;
        padding: 0;
        margin-right: 0;
        margin-left: auto;
    cursor: pointer;
    }
`, "");
const EmptyFlagContainer = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e2yzuei0"
})(`
    background: white;
    border: ${(0, _stylesValues.style_border_default)};
    border-radius: 8px;
    padding: 16px 24px;
    margin-bottom: 24px;
    p {
        color: ${(0, _colors.color_text_light)};
        font-style: italic;
        font-weight: normal;
        font-size: 16px;
        line-height: 24px;
    }
`, "");
const addButtonStyle = /*#__PURE__*/ (0, _css.css)({
    name: "e3xe1s",
    styles: "margin:24px 0;width:100%;cursor:pointer"
});
exports.default = FlagRulesGroup;

},{"@emotion/styled/base":"lSuFu","@emotion/react":"djZKr","react":"6uln9","../../../components/structure/HorizontalSeparator":"Pw3HQ","../../../components/general/Button":"6ymxN","@emotion/css":"awUBr","../../../constants/colors":"1p3OR","../../../constants/stylesValues":"dHVVv","57cf14192fe04d9d":"jxSE1","2dd9d158da59783a":"7BfXS","678030520f10690f":"1DD4j","b4b030108b841d74":"kTaUx","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jxSE1":[function(require,module,exports) {
module.exports = require("92a6f1c1a68de9a6").getBundleURL("kVLro") + require("a9f002d8670000c8").resolve("8NF5m");

},{"92a6f1c1a68de9a6":"c7Tr5","a9f002d8670000c8":"fyJL2"}],"7BfXS":[function(require,module,exports) {
module.exports = require("b430584623b9c2b9").getBundleURL("kVLro") + require("86c381eff43c4dc").resolve("3C83r");

},{"b430584623b9c2b9":"c7Tr5","86c381eff43c4dc":"fyJL2"}],"kTaUx":[function(require,module,exports) {
module.exports = require("5a7428fd11e8b9f0").getBundleURL("kVLro") + require("75dd4d2b34a4d5ce").resolve("4XO0O");

},{"5a7428fd11e8b9f0":"c7Tr5","75dd4d2b34a4d5ce":"fyJL2"}],"jvmfX":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _base = require("@emotion/styled/base");
var _baseDefault = parcelHelpers.interopDefault(_base);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _smallModalLayout = require("../../../components/structure/SmallModalLayout");
var _smallModalLayoutDefault = parcelHelpers.interopDefault(_smallModalLayout);
var _horizontalContainer = require("../../../components/structure/HorizontalContainer");
var _horizontalContainerDefault = parcelHelpers.interopDefault(_horizontalContainer);
var _css = require("@emotion/css");
var _selectField = require("../../../components/forms/SelectField");
var _selectFieldDefault = parcelHelpers.interopDefault(_selectField);
var _button = require("../../../components/general/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _modalTitle = require("../../../components/general/ModalTitle");
var _modalTitleDefault = parcelHelpers.interopDefault(_modalTitle);
var _footerBar = require("../../../components/structure/FooterBar");
var _footerBarDefault = parcelHelpers.interopDefault(_footerBar);
var _stylesValues = require("../../../constants/stylesValues");
var _roundedSelectionRow = require("../../../components/general/RoundedSelectionRow");
var _roundedSelectionRowDefault = parcelHelpers.interopDefault(_roundedSelectionRow);
var _colors = require("../../../constants/colors");
var _textField = require("../../../components/forms/TextField");
var _textFieldDefault = parcelHelpers.interopDefault(_textField);
var _checkboxField = require("../../../components/forms/CheckboxField");
var _checkboxFieldDefault = parcelHelpers.interopDefault(_checkboxField);
var _pageError = require("../../../components/general/PageError");
var _pageErrorDefault = parcelHelpers.interopDefault(_pageError);
var _lodash = require("lodash");
var _lodashDefault = parcelHelpers.interopDefault(_lodash);
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const closeIcon = require("a4373805a6da90d3");
const userFlagsIcon = require("7f742280ba16a494");
const addFlagIcon = require("3caf1e233b0992e6");
const removeFlagIcon = require("f165426011c72ffd");
const addFlagBlueIcon = require("d947f186167c7781");
const removeFlagBlueIcon = require("eda806db2683dd3a");
const sessionFlagIcon = require("b1c66c85a8c68a71");
const FlagRuleCreator = ({ onFinish, onCancel, applicationId, flags })=>{
    const [ruleType, setRuleType] = (0, _react1.useState)("Add");
    const [flagId, setFlagId] = (0, _react1.useState)("new");
    const [flagName, setFlagName] = (0, _react1.useState)("");
    const [isSessionFlag, setIsSessionFlag] = (0, _react1.useState)(false);
    const [error, setError] = (0, _react1.useState)(null);
    const mapToFlagRule = ()=>{
        // if add, then map all the values properly
        if (ruleType == "Remove") return {
            ruleType,
            flagScope: isSessionFlag ? "Session" : "UserProfile",
            applicationConversationFlagId: flagId,
            applicationConversationFlag: flags.find((f)=>f.id == flagId)
        };
        else return {
            ruleType,
            flagScope: isSessionFlag ? "Session" : "UserProfile",
            applicationConversationFlagId: flagId != "new" ? flagId : null,
            applicationConversationFlag: flagId != "new" ? flags.find((f)=>f.id == flagId) : {
                applicationId: applicationId,
                name: flagName
            }
        };
    };
    const handleFinish = ()=>{
        // validate
        if (flagId == "new" && flagName.length < 1 || flagId.length < 1) {
            setError("You must provide a flag name.");
            return;
        }
        const flagRule = mapToFlagRule();
        onFinish(flagRule);
    };
    return (0, _react.jsx)((0, _smallModalLayoutDefault.default), {
        className: overflowVisibleStyle,
        isVisible: true,
        onClose: onCancel
    }, (0, _react.jsx)(FlagRuleCreatorBody, null, (0, _react.jsx)((0, _horizontalContainerDefault.default), {
        className: titleContainer
    }, (0, _react.jsx)("img", {
        src: userFlagsIcon
    }), (0, _react.jsx)((0, _modalTitleDefault.default), null, "Add/Remove a Flag"), (0, _react.jsx)((0, _buttonDefault.default), {
        themes: [
            "end-tight",
            "icon"
        ],
        icon: closeIcon,
        onClick: onCancel
    })), (0, _react.jsx)(SelectionContainer, null, (0, _react.jsx)((0, _roundedSelectionRowDefault.default), {
        options: [
            {
                name: "Add User Flag",
                icon: addFlagIcon,
                selectedIcon: addFlagBlueIcon
            },
            {
                name: "Remove User Flag",
                icon: removeFlagIcon,
                selectedIcon: removeFlagBlueIcon
            }
        ],
        onClick: (num)=>setRuleType(num == 1 ? "Remove" : "Add"),
        selectedFilter: ruleType == "Remove" ? 1 : 0
    })), ruleType == "Add" && (0, _react.jsx)(FlagRuleFormFields, null, (0, _react.jsx)("p", null, "Add a flag to any user that hits this response:"), (0, _react.jsx)((0, _selectFieldDefault.default), {
        name: "flags",
        label: "Select a User Flag",
        value: flagId,
        options: [
            {
                label: "- Create a new Flag -",
                value: "new"
            },
            ...(0, _lodashDefault.default).uniqBy(flags ?? [], (f)=>f.name)?.map((f)=>({
                    label: f.name,
                    value: f.id
                }))
        ],
        onChange: (e)=>setFlagId(e.value),
        onBlur: ()=>{},
        className: valueSelectStyle,
        useFormTheme: true
    }), flagId == "new" && (0, _react.jsx)((0, _textFieldDefault.default), {
        className: valueTextStyle,
        placeholder: "Flag name...",
        name: "flagValue",
        label: "Name of User Flag",
        value: flagName,
        onBlur: ()=>{},
        onChange: (e)=>setFlagName(e.target.value)
    }), (0, _react.jsx)((0, _checkboxFieldDefault.default), {
        checked: isSessionFlag,
        onChange: (e)=>setIsSessionFlag(e.target.checked),
        icon: sessionFlagIcon,
        label: "Flag expires when session is over"
    })), ruleType == "Remove" && (0, _react.jsx)(FlagRuleFormFields, null, (0, _react.jsx)("p", null, "Remove a flag from any user that hits this response:"), (0, _react.jsx)((0, _selectFieldDefault.default), {
        name: "flags",
        label: "Select a User Flag",
        value: flagId,
        options: (0, _lodashDefault.default).uniqBy(flags ?? [], (f)=>f.name)?.map((f)=>({
                label: f.name,
                value: f.id
            })),
        placeholder: "Select one of your flags to remove",
        onChange: (e)=>setFlagId(e.value),
        onBlur: ()=>{},
        className: valueSelectStyle,
        useFormTheme: true
    }), (0, _react.jsx)((0, _checkboxFieldDefault.default), {
        checked: isSessionFlag,
        onChange: (e)=>setIsSessionFlag(e.target.checked),
        icon: sessionFlagIcon,
        label: "Flag expires when session is over"
    })), (0, _react.jsx)((0, _footerBarDefault.default), {
        className: footerStyle
    }, (0, _react.jsx)((0, _buttonDefault.default), {
        themes: [
            "primary",
            "start-tight"
        ],
        text: "Apply",
        type: "button",
        disabled: flagId == "new" && flagName == null,
        onClick: ()=>handleFinish()
    }), (0, _react.jsx)((0, _buttonDefault.default), {
        themes: [
            "white",
            "end-tight"
        ],
        text: "Cancel",
        type: "button",
        onClick: onCancel
    })), (0, _react.jsx)((0, _pageErrorDefault.default), {
        errors: error ? [
            error
        ] : [],
        onClear: ()=>setError(null)
    })));
};
const FlagRuleFormFields = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e184xej2"
})(`
    padding: 24px;
    flex: 1;
    margin-bottom: 80px;
    > p {
        color: ${(0, _colors.color_text_light)};
        font-style: normal;
        font-weight: normal;
        font-size: 14px;
        line-height: 20px;
        margin-bottom: 24px;
    }
    .check-label {
        font-weight: normal;
    }
`, "");
const SelectionContainer = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e184xej1"
})(`
    border-bottom: ${(0, _stylesValues.style_border_default)};
    margin: 0 24px;
    padding: 24px 0;
`, "");
const FlagRuleCreatorBody = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e184xej0"
})(`
    display: flex;
    flex-direction: column;
    align-items: stretch;
    height: 580px;
    overflow: visible;
`, "");
const titleContainer = /*#__PURE__*/ (0, _css.css)("background:white;padding:0 32px;align-items:center;border-top-right-radius:20px;border-top-left-radius:20px;border-bottom:", (0, _stylesValues.style_border_default), ";img{margin-right:16px;}", "");
const footerStyle = /*#__PURE__*/ (0, _css.css)({
    name: "joji84",
    styles: "position:fixed;border-bottom-right-radius:20px;border-bottom-left-radius:20px;padding:0 32px"
});
const valueSelectStyle = /*#__PURE__*/ (0, _css.css)({
    name: "156m0z0",
    styles: ".Select-menu-outer{z-index:111;overflow:hidden;}"
});
const valueTextStyle = /*#__PURE__*/ (0, _css.css)({
    name: "p7xwq7",
    styles: ".text-field-suggestions{z-index:111;}"
});
const overflowVisibleStyle = /*#__PURE__*/ (0, _css.css)({
    name: "1ru1und",
    styles: "overflow:visible;min-height:624px"
});
exports.default = FlagRuleCreator;

},{"@emotion/styled/base":"lSuFu","@emotion/react":"djZKr","react":"6uln9","../../../components/structure/SmallModalLayout":"khwvt","../../../components/structure/HorizontalContainer":"eJPfh","@emotion/css":"awUBr","../../../components/forms/SelectField":"405B3","../../../components/general/Button":"6ymxN","../../../components/general/ModalTitle":"hIp2B","../../../components/structure/FooterBar":"bibRL","../../../constants/stylesValues":"dHVVv","../../../components/general/RoundedSelectionRow":"dUH5O","../../../constants/colors":"1p3OR","../../../components/forms/TextField":"7a7bh","../../../components/forms/CheckboxField":"3S5Oy","../../../components/general/PageError":"ezFTm","lodash":"3hMBK","a4373805a6da90d3":"93VwA","7f742280ba16a494":"d0Yl2","3caf1e233b0992e6":"jxSE1","f165426011c72ffd":"7BfXS","d947f186167c7781":"j16uy","eda806db2683dd3a":"1kBPP","b1c66c85a8c68a71":"8VhS4","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"d0Yl2":[function(require,module,exports) {
module.exports = require("685c8a67080c7509").getBundleURL("kVLro") + require("c215f6874bb6abac").resolve("hPT2F");

},{"685c8a67080c7509":"c7Tr5","c215f6874bb6abac":"fyJL2"}],"j16uy":[function(require,module,exports) {
module.exports = require("9bc3732609a006f0").getBundleURL("kVLro") + require("c612ca708beb3761").resolve("6ax2x");

},{"9bc3732609a006f0":"c7Tr5","c612ca708beb3761":"fyJL2"}],"1kBPP":[function(require,module,exports) {
module.exports = require("ce387ca43c80e4df").getBundleURL("kVLro") + require("7bccc41f5802831c").resolve("1tkWs");

},{"ce387ca43c80e4df":"c7Tr5","7bccc41f5802831c":"fyJL2"}],"8VhS4":[function(require,module,exports) {
module.exports = require("7a8a9fde05bec49f").getBundleURL("kVLro") + require("6849211f381b4a6f").resolve("jRmTX");

},{"7a8a9fde05bec49f":"c7Tr5","6849211f381b4a6f":"fyJL2"}],"99zrE":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _extends = require("@babel/runtime/helpers/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _base = require("@emotion/styled/base");
var _baseDefault = parcelHelpers.interopDefault(_base);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _horizontalSeparator = require("../../../components/structure/HorizontalSeparator");
var _horizontalSeparatorDefault = parcelHelpers.interopDefault(_horizontalSeparator);
var _button = require("../../../components/general/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _css = require("@emotion/css");
var _colors = require("../../../constants/colors");
var _stylesValues = require("../../../constants/stylesValues");
var _lodash = require("lodash");
var _lodashDefault = parcelHelpers.interopDefault(_lodash);
var _reactBeautifulDnd = require("react-beautiful-dnd");
var _extensions = require("../../../models/extensions");
var _effectManager = require("./EffectManager");
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const deleteIcon = require("b1fa3c20cfcb3119");
const moveableIcon = require("ebeab3ef1b913aab");
const effectIcon = require("4da917ca1121ce76");
const ResponseEffectsList = ({ effects, onAddEffect, onRemoveEffect, updateEffects, onClickEffect })=>{
    const renderEffects = (0, _lodashDefault.default).orderBy(effects, [
        "priority"
    ]);
    const handleDragEnd = (result, provider)=>{
        // dropped outside the list
        if (!result.destination) return;
        const orderedEffects = (0, _lodashDefault.default).sortBy(effects ?? [], (s)=>s.priority);
        const newEffects = (0, _extensions.reorder)(orderedEffects, result.source.index, result.destination.index);
        newEffects.forEach((e, i)=>{
            e.priority = i;
        });
        updateEffects(newEffects);
    };
    return (0, _react.jsx)((0, _reactDefault.default).Fragment, null, (0, _react.jsx)(DetailLabel, null, "Here you can add or modify effects triggered by this response."), renderEffects?.length > 0 ? (0, _react.jsx)((0, _reactBeautifulDnd.DragDropContext), {
        onDragEnd: handleDragEnd
    }, (0, _react.jsx)((0, _reactBeautifulDnd.Droppable), {
        droppableId: "sections",
        type: "TEMPLATE_SECTION"
    }, (provided, snapshot)=>(0, _react.jsx)("div", (0, _extendsDefault.default)({}, provided.droppableProps, {
            ref: provided.innerRef
        }), (0, _lodashDefault.default).sortBy(effects ?? [], (s)=>s.priority)?.map((e, i)=>(0, _react.jsx)((0, _reactBeautifulDnd.Draggable), {
                draggableId: `${e.name}${e.id}`,
                index: i,
                key: `${e.name}${e.id}`
            }, (provided, snapshot)=>(0, _react.jsx)(EffectListItem, (0, _extendsDefault.default)({
                    ref: provided.innerRef,
                    onClick: ()=>onClickEffect(e)
                }, provided.draggableProps, provided.dragHandleProps), (0, _react.jsx)(DraggableIcon, {
                    src: moveableIcon
                }), (0, _react.jsx)(Priority, null, (0, _react.jsx)("span", null, (e.priority ?? 0) + 1)), (0, _react.jsx)("img", {
                    src: effectIcon
                }), (0, _react.jsx)("p", null, (0, _effectManager.getEffectLabel)(e?.name)), (0, _react.jsx)("button", {
                    className: "remove-button",
                    type: "button",
                    onClick: (effect)=>{
                        effect.stopPropagation();
                        onRemoveEffect(e);
                    }
                }, (0, _react.jsx)("img", {
                    src: deleteIcon
                }))))), provided.placeholder))) : (0, _react.jsx)(NoEffectsContainer, null, (0, _react.jsx)("p", null, "No effects configured")), (0, _react.jsx)((0, _horizontalSeparatorDefault.default), null), (0, _react.jsx)((0, _buttonDefault.default), {
        themes: [
            "secondary"
        ],
        className: addButtonStyle,
        type: "button",
        onClick: ()=>onAddEffect(),
        text: "Add / Remove an Effect"
    }));
};
const DetailLabel = /*#__PURE__*/ (0, _baseDefault.default)("p", {
    target: "eiji6rq4"
})(`
    margin: 16px 0;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 20px;
    color: ${(0, _colors.color_text_light)};
`, "");
const EffectListItem = /*#__PURE__*/ (0, _baseDefault.default)("li", {
    target: "eiji6rq3"
})(`
    height: 52px;
    border: ${(0, _stylesValues.style_border_default)};
    border-radius: 8px;
    display: flex;
    align-items: center;
    padding: 0 24px;
    margin-bottom: 8px;
    background: white;
    img {
        max-height: 24px;
        max-width: 24px;
        &.session-icon {
            width: 20px;
            height: 20px;
        }
    }
    p {
        margin: 0 12px;
        font-style: normal;
        font-weight: normal;
        font-size: 14px;
        line-height: 20px;
        cursor: pointer;
    }
    .remove-button {
        border: none;
        background: none;
        box-shadow: none;
        padding: 0;
        margin-right: 0;
        margin-left: auto;
    cursor: pointer;
    }
`, "");
const NoEffectsContainer = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "eiji6rq2"
})(`
    background: white;
    border: ${(0, _stylesValues.style_border_default)};
    border-radius: 8px;
    padding: 16px 24px;
    margin-bottom: 24px;
    p {
        color: ${(0, _colors.color_text_light)};
        font-style: italic;
        font-weight: normal;
        font-size: 16px;
        line-height: 24px;
    }
`, "");
const addButtonStyle = /*#__PURE__*/ (0, _css.css)({
    name: "e3xe1s",
    styles: "margin:24px 0;width:100%;cursor:pointer"
});
const DraggableIcon = /*#__PURE__*/ (0, _baseDefault.default)("img", {
    target: "eiji6rq1"
})({
    name: "1gqra6",
    styles: "cursor:grab;margin-right:8px;height:24px;width:10px"
});
const Priority = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "eiji6rq0"
})("border:1px solid ", (0, _colors.color_shades_darkest), ";color:", (0, _colors.color_shades_darkest), ";border-radius:50%;margin-right:12px;height:24px;width:24px;span{padding-left:7px;}");
exports.default = ResponseEffectsList;

},{"@babel/runtime/helpers/extends":"4iKIP","@emotion/styled/base":"lSuFu","@emotion/react":"djZKr","react":"6uln9","../../../components/structure/HorizontalSeparator":"Pw3HQ","../../../components/general/Button":"6ymxN","@emotion/css":"awUBr","../../../constants/colors":"1p3OR","../../../constants/stylesValues":"dHVVv","lodash":"3hMBK","react-beautiful-dnd":"bkbSn","../../../models/extensions":"7h01B","./EffectManager":"axWjz","b1fa3c20cfcb3119":"1DD4j","ebeab3ef1b913aab":"dsDQ4","4da917ca1121ce76":"djUH7","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"axWjz":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getEffectLabel", ()=>getEffectLabel);
var _base = require("@emotion/styled/base");
var _baseDefault = parcelHelpers.interopDefault(_base);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _horizontalContainer = require("../../../components/structure/HorizontalContainer");
var _horizontalContainerDefault = parcelHelpers.interopDefault(_horizontalContainer);
var _css = require("@emotion/css");
var _selectField = require("../../../components/forms/SelectField");
var _selectFieldDefault = parcelHelpers.interopDefault(_selectField);
var _button = require("../../../components/general/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _modalTitle = require("../../../components/general/ModalTitle");
var _modalTitleDefault = parcelHelpers.interopDefault(_modalTitle);
var _footerBar = require("../../../components/structure/FooterBar");
var _footerBarDefault = parcelHelpers.interopDefault(_footerBar);
var _stylesValues = require("../../../constants/stylesValues");
var _pageError = require("../../../components/general/PageError");
var _pageErrorDefault = parcelHelpers.interopDefault(_pageError);
var _textField = require("../../../components/forms/TextField");
var _textFieldDefault = parcelHelpers.interopDefault(_textField);
var _switch = require("../../../components/forms/Switch");
var _switchDefault = parcelHelpers.interopDefault(_switch);
var _modalLayout = require("../../../components/structure/ModalLayout");
var _modalLayoutDefault = parcelHelpers.interopDefault(_modalLayout);
var _customScrollbars = require("../../../components/structure/CustomScrollbars");
var _customScrollbarsDefault = parcelHelpers.interopDefault(_customScrollbars);
var _useWindowSize = require("../../../hooks/UseWindowSize");
var _useWindowSizeDefault = parcelHelpers.interopDefault(_useWindowSize);
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const closeIcon = require("7ac172ee7f65ae49");
const effectIcon = require("6a00aa76108986b3");
const effectTypeOptions = [
    {
        label: "Custom",
        value: "custom"
    },
    {
        label: "Navigate(Web)",
        value: "navigateWeb"
    },
    {
        label: "Navigate(Mobile)",
        value: "navigateMobile"
    },
    {
        label: "Click/Tap",
        value: "clickTap"
    },
    {
        label: "Scroll to",
        value: "scrollTo"
    },
    {
        label: "Close Assistant",
        value: "closeAssistant"
    },
    {
        label: "Use Tool",
        value: "useTool"
    }
];
const voicifyToolTypeOptions = [
    {
        label: "Static Tool Response",
        value: "staticToolResponse"
    }
];
const getEffectLabel = (val)=>{
    var option = effectTypeOptions.find((e)=>e.value === val);
    if (option) return option.label;
    return val;
};
const EffectManager = ({ onFinish, onCancel, editingEffect })=>{
    const [name, setName] = (0, _react1.useState)("");
    const [effectType, setEffectType] = (0, _react1.useState)(null);
    const [error, setError] = (0, _react1.useState)(null);
    const [effectData, setEffectData] = (0, _react1.useState)([]);
    const [url, setUrl] = (0, _react1.useState)("");
    const [pageName, setPageName] = (0, _react1.useState)("");
    const [elementId, setElementId] = (0, _react1.useState)("");
    const [elementName, setElementName] = (0, _react1.useState)("");
    const [querySelector, setQuerySelector] = (0, _react1.useState)("");
    const [openInNewTab, setOpenInNewTab] = (0, _react1.useState)(false);
    const [fireBeforeTextToSpeech, setFireBeforeTextToSpeech] = (0, _react1.useState)(false);
    const [fireAfterMilliseconds, setFireAfterMilliseconds] = (0, _react1.useState)(0);
    const [voicifyToolType, setVoicifyToolType] = (0, _react1.useState)("staticToolResponse");
    const [toolName, setToolName] = (0, _react1.useState)("");
    const [toolDescription, setToolDescription] = (0, _react1.useState)("");
    const [toolStaticResponse, setToolStaticResponse] = (0, _react1.useState)("");
    const windowSize = (0, _useWindowSizeDefault.default)();
    (0, _react1.useEffect)(()=>{
        if (editingEffect) {
            setName(editingEffect.name);
            const data = editingEffect.data;
            if (data) {
                if ("fireAfterMilliseconds" in data) setFireAfterMilliseconds(data.fireAfterMilliseconds);
                if ("fireBeforeTextToSpeech" in data) setFireBeforeTextToSpeech(data.fireBeforeTextToSpeech);
                switch(editingEffect.name){
                    case "navigateWeb":
                        setEffectType("navigateWeb");
                        if ("url" in data) setUrl(data.url);
                        if ("openInNewTab" in data) setOpenInNewTab(data.openInNewTab);
                        break;
                    case "navigateMobile":
                        setEffectType("navigateMobile");
                        if ("url" in data) setUrl(data.url);
                        if ("pageName" in data) setPageName(data.pageName);
                        if ("openInNewTab" in data) setOpenInNewTab(data.openInNewTab);
                        break;
                    case "clickTap":
                        setEffectType("clickTap");
                        if ("elementId" in data) setElementId(data.elementId);
                        if ("elementName" in data) setElementName(data.elementName);
                        if ("querySelector" in data) setQuerySelector(data.querySelector);
                        break;
                    case "scrollTo":
                        setEffectType("scrollTo");
                        if ("elementId" in data) setElementId(data.elementId);
                        if ("elementName" in data) setElementName(data.elementName);
                        if ("querySelector" in data) setQuerySelector(data.querySelector);
                        break;
                    case "closeAssistant":
                        setEffectType("scrollTo");
                        break;
                    case "useTool":
                        setEffectType("useTool");
                        if ("voicifyToolType" in data) setVoicifyToolType(data.voicifyToolType);
                        if ("toolName" in data) setToolName(data.toolName);
                        if ("toolDescription" in data) setToolDescription(data.toolDescription);
                        if ("toolStaticResponse" in data) setToolStaticResponse(data.toolStaticResponse);
                        break;
                    default:
                        setEffectType("custom");
                        const keys = Object.keys(data);
                        const newData = [];
                        if (keys?.length) keys.forEach((k, i)=>{
                            newData.push({
                                [k]: data[k]
                            });
                        });
                        setEffectData(newData);
                }
            }
        }
    }, []);
    const handleFinish = ()=>{
        let newEffectData = {};
        if (effectType === "custom") effectData.forEach((d)=>{
            const keys = Object.keys(d);
            if (keys?.length) newEffectData[keys[0]] = d[keys[0]];
        });
        else {
            newEffectData.fireAfterMilliseconds = fireAfterMilliseconds;
            newEffectData.fireBeforeTextToSpeech = fireBeforeTextToSpeech;
            switch(effectType){
                case "navigateWeb":
                    newEffectData.url = url;
                    newEffectData.openInNewTab = openInNewTab;
                    break;
                case "navigateMobile":
                    newEffectData.url = url;
                    newEffectData.pageName = pageName;
                    newEffectData.openInNewTab = openInNewTab;
                    break;
                case "clickTap":
                case "scrollTo":
                    newEffectData.elementId = elementId;
                    newEffectData.elementName = elementName;
                    newEffectData.querySelector = querySelector;
                    break;
                case "useTool":
                    newEffectData.voicifyToolType = voicifyToolType;
                    newEffectData.toolName = toolName;
                    newEffectData.toolDescription = toolDescription;
                    if (voicifyToolType === "staticToolResponse") newEffectData.toolStaticResponse = toolStaticResponse;
                    break;
            }
        }
        const effect = {
            id: editingEffect?.id,
            name: name,
            data: newEffectData,
            priority: editingEffect?.priority
        };
        onFinish(effect);
    };
    const clearFields = ()=>{
        setUrl("");
        setOpenInNewTab(false);
        setFireBeforeTextToSpeech(false);
        setPageName("");
        setElementId("");
        setElementName("");
        setQuerySelector("");
        setEffectData([
            {
                "": ""
            }
        ]);
        setVoicifyToolType("staticToolResponse");
        setToolName("");
        setToolDescription("");
        setToolStaticResponse("");
    };
    const handleEffectTypeChange = (effectTypeVal)=>{
        setEffectType(effectTypeVal);
        switch(effectTypeVal){
            case "custom":
                setName("");
                break;
            default:
                setName(effectTypeVal);
        }
        clearFields();
    };
    const handleKey = (e)=>{
        e.stopPropagation();
        if (e.key === "Enter") handleFinish();
        if (e.key === "Escape") onCancel();
    };
    const renderCustomFields = ()=>{
        return (0, _react.jsx)((0, _reactDefault.default).Fragment, null, effectData?.length && effectData.map((o, i)=>{
            const key = Object.keys(o)[0];
            const val = o[key];
            return (0, _react.jsx)(CustomDataProperty, {
                key: `effectdatakey${i}`
            }, (0, _react.jsx)(KeyField, {
                name: `key${i}`,
                placeholder: "Enter key",
                label: "Key",
                value: key,
                onChange: (e)=>updateEffectData(i, e.target.value, val)
            }), (0, _react.jsx)(ValueField, {
                name: `value${i}`,
                placeholder: "Enter value",
                label: "Value",
                value: val,
                onChange: (e)=>updateEffectData(i, key, e.target.value)
            }));
        }), (0, _react.jsx)((0, _buttonDefault.default), {
            type: "button",
            themes: [
                "secondary-medium"
            ],
            text: "Add a Data Property",
            onClick: ()=>addDataProperty(Object.entries(effectData)?.length ?? 1)
        }));
    };
    const updateEffectData = (index, key, val)=>{
        const newEffectData = [
            ...effectData
        ];
        newEffectData[index] = {
            [key]: val
        };
        setEffectData(newEffectData);
    };
    const addDataProperty = (i)=>{
        const newEffectData = [
            ...effectData
        ];
        newEffectData.push({
            "": ""
        });
        setEffectData(newEffectData);
    };
    const renderUrl = ()=>{
        return (0, _react.jsx)((0, _textFieldDefault.default), {
            name: "url",
            placeholder: "Enter URL",
            label: "URL",
            value: url,
            onChange: (e)=>setUrl(e.target.value)
        });
    };
    const renderPageName = ()=>{
        return (0, _react.jsx)((0, _textFieldDefault.default), {
            name: "pageName",
            placeholder: "Enter page name",
            label: "Page Name",
            value: pageName,
            onChange: (e)=>setPageName(e.target.value)
        });
    };
    const renderElementId = ()=>{
        return (0, _react.jsx)((0, _textFieldDefault.default), {
            name: "elementId",
            placeholder: "Specify element ID",
            label: "Element ID",
            value: elementId,
            onChange: (e)=>setElementId(e.target.value)
        });
    };
    const renderElementName = ()=>{
        return (0, _react.jsx)((0, _textFieldDefault.default), {
            name: "elementName",
            placeholder: "Specify element name",
            label: "Element name",
            value: elementName,
            onChange: (e)=>setElementName(e.target.value)
        });
    };
    const renderQuerySelector = ()=>{
        return (0, _react.jsx)((0, _textFieldDefault.default), {
            name: "querySelector",
            placeholder: "Specify query selector",
            label: "Query selector",
            value: querySelector,
            onChange: (e)=>setQuerySelector(e.target.value)
        });
    };
    const renderOpenInNewTab = ()=>{
        return (0, _react.jsx)(StyledSwitch, {
            checked: openInNewTab,
            onChange: ()=>setOpenInNewTab(!openInNewTab),
            label: "Open in new tab"
        });
    };
    const renderFireBeforeTextToSpeech = ()=>{
        return (0, _react.jsx)(StyledSwitch, {
            checked: fireBeforeTextToSpeech,
            onChange: ()=>setFireBeforeTextToSpeech(!fireBeforeTextToSpeech),
            label: "Fire before text to speech"
        });
    };
    const renderFireAfterMilliseconds = ()=>{
        return (0, _react.jsx)((0, _textFieldDefault.default), {
            name: "fireAfterMilliseconds",
            placeholder: "Enter number of milliseconds",
            label: "Fire effect after specified milliseconds",
            value: fireAfterMilliseconds,
            type: "number",
            onChange: (e)=>setFireAfterMilliseconds(e.target.value)
        });
    };
    const renderNavigateWebFields = ()=>{
        return (0, _react.jsx)((0, _reactDefault.default).Fragment, null, renderUrl(), renderOpenInNewTab(), renderFireBeforeTextToSpeech(), renderFireAfterMilliseconds());
    };
    const renderNavigateMobileFields = ()=>{
        return (0, _react.jsx)((0, _reactDefault.default).Fragment, null, renderUrl(), renderPageName(), renderOpenInNewTab(), renderFireBeforeTextToSpeech(), renderFireAfterMilliseconds());
    };
    const renderClickTapFields = ()=>{
        return (0, _react.jsx)((0, _reactDefault.default).Fragment, null, renderElementId(), renderElementName(), renderQuerySelector(), renderFireBeforeTextToSpeech(), renderFireAfterMilliseconds());
    };
    const renderScrollToFields = ()=>{
        return (0, _react.jsx)((0, _reactDefault.default).Fragment, null, renderElementId(), renderElementName(), renderQuerySelector(), renderFireBeforeTextToSpeech(), renderFireAfterMilliseconds());
    };
    const renderCloseAssistantFields = ()=>{
        return (0, _react.jsx)((0, _reactDefault.default).Fragment, null, renderFireBeforeTextToSpeech(), renderFireAfterMilliseconds());
    };
    const renderUseToolFields = ()=>{
        return (0, _react.jsx)((0, _reactDefault.default).Fragment, null, (0, _react.jsx)((0, _selectFieldDefault.default), {
            name: "voicifyToolType",
            label: "Voicify Tool Type",
            value: voicifyToolType,
            options: voicifyToolTypeOptions,
            onChange: (e)=>setVoicifyToolType(e.value),
            onBlur: ()=>{}
        }), (0, _react.jsx)((0, _textFieldDefault.default), {
            name: "toolName",
            placeholder: "Enter tool name",
            label: "Tool Name",
            value: toolName,
            onChange: (e)=>setToolName(e.target.value)
        }), (0, _react.jsx)((0, _textFieldDefault.default), {
            name: "toolDescription",
            placeholder: "Enter tool description",
            label: "Tool Description",
            value: toolDescription,
            onChange: (e)=>setToolDescription(e.target.value)
        }), voicifyToolType === "staticToolResponse" && (0, _react.jsx)((0, _textFieldDefault.default), {
            name: "toolStaticResponse",
            placeholder: "Enter static response",
            label: "Tool Static Response",
            value: toolStaticResponse,
            onChange: (e)=>setToolStaticResponse(e.target.value)
        }), renderFireBeforeTextToSpeech(), renderFireAfterMilliseconds());
    };
    const renderEffectFields = ()=>{
        switch(effectType){
            case "navigateWeb":
                return renderNavigateWebFields();
            case "navigateMobile":
                return renderNavigateMobileFields();
            case "clickTap":
                return renderClickTapFields();
            case "scrollTo":
                return renderScrollToFields();
            case "closeAssistant":
                return renderCloseAssistantFields();
            case "useTool":
                return renderUseToolFields();
            case "custom":
                return renderCustomFields();
            default:
                return (0, _react.jsx)((0, _reactDefault.default).Fragment, null);
        }
    };
    return (0, _react.jsx)(StyledModal, {
        className: overflowVisibleStyle,
        isVisible: true,
        onClose: onCancel
    }, (0, _react.jsx)(EffectManagerBody, {
        onKeyPress: (e)=>handleKey(e),
        onKeyDown: (e)=>handleKey(e),
        onKeyUp: (e)=>handleKey(e)
    }, (0, _react.jsx)((0, _horizontalContainerDefault.default), {
        className: titleContainer
    }, (0, _react.jsx)("img", {
        src: effectIcon
    }), (0, _react.jsx)((0, _modalTitleDefault.default), null, "Effect"), (0, _react.jsx)((0, _buttonDefault.default), {
        themes: [
            "end-tight",
            "icon"
        ],
        icon: closeIcon,
        onClick: onCancel
    })), (0, _react.jsx)((0, _customScrollbarsDefault.default), {
        autoHide: true,
        autoHeight: true,
        autoHeightMin: windowSize.windowSize.innerHeight * .9 - 190,
        autoHeightMax: windowSize.windowSize.innerHeight * .9 - 290
    }, (0, _react.jsx)(FormWrapper, null, (0, _react.jsx)((0, _selectFieldDefault.default), {
        name: "flags",
        label: "Select an Effect",
        value: effectType,
        options: effectTypeOptions,
        onChange: (e)=>handleEffectTypeChange(e.value),
        onBlur: ()=>{},
        className: valueSelectStyle
    }), (0, _react.jsx)((0, _textFieldDefault.default), {
        name: "effectName",
        placeholder: "Enter custom effect name",
        disabled: effectType !== "custom",
        label: "Effect Name",
        value: name,
        onChange: (e)=>setName(e.target.value)
    }), renderEffectFields())), (0, _react.jsx)((0, _footerBarDefault.default), {
        className: footerStyle
    }, (0, _react.jsx)((0, _buttonDefault.default), {
        themes: [
            "primary",
            "start-tight"
        ],
        text: "Save",
        type: "button",
        onClick: ()=>handleFinish()
    }), (0, _react.jsx)((0, _buttonDefault.default), {
        themes: [
            "white",
            "end-tight"
        ],
        text: "Cancel",
        type: "button",
        onClick: onCancel
    })), (0, _react.jsx)((0, _pageErrorDefault.default), {
        errors: error ? [
            error
        ] : [],
        onClear: ()=>setError(null)
    })));
};
const StyledModal = /*#__PURE__*/ (0, _baseDefault.default)((0, _modalLayoutDefault.default), {
    target: "eglwnhp6"
})({
    name: "owlll0",
    styles: "min-width:30%;min-height:30%"
});
const FormWrapper = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "eglwnhp5"
})({
    name: "18d63h3",
    styles: "margin:32px"
});
const EffectManagerBody = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "eglwnhp4"
})(`
    display: flex;
    flex-direction: column;
    align-items: stretch;
    height: 580px;
    overflow: visible;
`, "");
const titleContainer = /*#__PURE__*/ (0, _css.css)("background:white;padding:0 32px;align-items:center;border-top-right-radius:20px;border-top-left-radius:20px;border-bottom:", (0, _stylesValues.style_border_default), ";img{margin-right:16px;}", "");
const footerStyle = /*#__PURE__*/ (0, _css.css)({
    name: "joji84",
    styles: "position:fixed;border-bottom-right-radius:20px;border-bottom-left-radius:20px;padding:0 32px"
});
const valueSelectStyle = /*#__PURE__*/ (0, _css.css)({
    name: "156m0z0",
    styles: ".Select-menu-outer{z-index:111;overflow:hidden;}"
});
const StyledSwitch = /*#__PURE__*/ (0, _baseDefault.default)((0, _switchDefault.default), {
    target: "eglwnhp3"
})({
    name: "1u0qmvp",
    styles: "margin:16px"
});
const overflowVisibleStyle = /*#__PURE__*/ (0, _css.css)({
    name: "1ru1und",
    styles: "overflow:visible;min-height:624px"
});
const CustomDataProperty = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "eglwnhp2"
})({
    name: "ho1qnd",
    styles: "display:flex;flex-direction:row"
});
const KeyField = /*#__PURE__*/ (0, _baseDefault.default)((0, _textFieldDefault.default), {
    target: "eglwnhp1"
})({
    name: "1oaeivz",
    styles: "margin-right:8px"
});
const ValueField = /*#__PURE__*/ (0, _baseDefault.default)((0, _textFieldDefault.default), {
    target: "eglwnhp0"
})({
    name: "1q4vxyr",
    styles: "margin-left:8px"
});
exports.default = EffectManager;

},{"@emotion/styled/base":"lSuFu","@emotion/react":"djZKr","react":"6uln9","../../../components/structure/HorizontalContainer":"eJPfh","@emotion/css":"awUBr","../../../components/forms/SelectField":"405B3","../../../components/general/Button":"6ymxN","../../../components/general/ModalTitle":"hIp2B","../../../components/structure/FooterBar":"bibRL","../../../constants/stylesValues":"dHVVv","../../../components/general/PageError":"ezFTm","../../../components/forms/TextField":"7a7bh","../../../components/forms/Switch":"8kkL9","../../../components/structure/ModalLayout":"b1cO3","../../../components/structure/CustomScrollbars":"50vFq","../../../hooks/UseWindowSize":"43j9z","7ac172ee7f65ae49":"93VwA","6a00aa76108986b3":"djUH7","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"43j9z":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
function getWindowSize() {
    const { innerWidth, innerHeight } = window;
    return {
        innerWidth,
        innerHeight
    };
}
function useWindowSize() {
    const [windowSize, setWindowSize] = (0, _react.useState)(getWindowSize());
    (0, _react.useEffect)(()=>{
        function handleWindowResize() {
            setWindowSize(getWindowSize());
        }
        window.addEventListener("resize", handleWindowResize);
        return ()=>{
            window.removeEventListener("resize", handleWindowResize);
        };
    }, []);
    return {
        windowSize
    };
}
exports.default = useWindowSize;

},{"react":"6uln9","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"djUH7":[function(require,module,exports) {
module.exports = require("b6b245c2a52760a3").getBundleURL("kVLro") + require("da52267afff8e733").resolve("cpKFM");

},{"b6b245c2a52760a3":"c7Tr5","da52267afff8e733":"fyJL2"}],"hjrMo":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _base = require("@emotion/styled/base");
var _baseDefault = parcelHelpers.interopDefault(_base);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _dropDownSelectField = require("../../../../components/forms/DropDownSelectField");
var _dropDownSelectFieldDefault = parcelHelpers.interopDefault(_dropDownSelectField);
var _stylesValues = require("../../../../constants/stylesValues");
var _colors = require("../../../../constants/colors");
var _iconTooltip = require("../../../../components/general/IconTooltip");
var _iconTooltipDefault = parcelHelpers.interopDefault(_iconTooltip);
var _dropdownPortalMenu = require("./DropdownPortalMenu");
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const StyledDropdown = (props)=>{
    const anchorRef = (0, _react1.useRef)(null);
    // filter options once per render
    const getFiltered = (inputValue)=>{
        let options = props.options ?? [];
        if (props.searchable && inputValue?.length) {
            const q = inputValue.toLowerCase();
            options = options.filter((option)=>option.label.toLowerCase().includes(q));
        }
        return options;
    };
    return (0, _react.jsx)(Wrapper, {
        ref: anchorRef
    }, (props.label || props.tooltip) && (0, _react.jsx)(LabelWrapper, {
        className: props.labelStyle
    }, props.label && (0, _react.jsx)(Label, null, props.label), props.tooltip && (0, _react.jsx)(StyledIconTooltip, {
        text: props.tooltip
    })), (0, _react.jsx)((0, _dropDownSelectFieldDefault.default), {
        placeholder: props.placeholder ? props.placeholder : "Select",
        disabled: props.disabled,
        className: props.className,
        name: props.fieldName,
        size: props.size,
        value: props.value,
        onChange: (e)=>{
            props.handleOnChange?.(props.fieldName, e.value);
        },
        options: props.options,
        clearable: false,
        searchable: props.searchable ?? false,
        menuRenderer: (menuProps)=>{
            const options = getFiltered(menuProps.inputValue);
            return (0, _react.jsx)((0, _dropdownPortalMenu.PortalMenu), {
                anchorEl: anchorRef.current,
                openAbove: props?.openMenuAbove ?? false,
                zIndex: 99999,
                matchWidth: true
            }, (0, _react.jsx)(MenuContainer, {
                role: "listbox",
                "aria-label": "dropdown options"
            }, (0, _react.jsx)(Triangle, null), options.map((option, index)=>(0, _react.jsx)(SelectOptionMedium, {
                    key: `${option.value}-${index}`,
                    onClick: ()=>menuProps.selectValue(option),
                    role: "option"
                }, (0, _react.jsx)(CustomSelectOptionLabelMedium, null, (0, _react.jsx)("div", null, (0, _react.jsx)("p", null, option.label)))))));
        }
    }));
};
const Wrapper = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e4txqg47"
})({
    name: "bjn8wh",
    styles: "position:relative"
});
const LabelWrapper = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e4txqg46"
})({
    name: "1a9pxps",
    styles: "display:flex;margin-bottom:8px"
});
const Label = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e4txqg45"
})("");
const StyledIconTooltip = /*#__PURE__*/ (0, _baseDefault.default)((0, _iconTooltipDefault.default), {
    target: "e4txqg44"
})({
    name: "1q4vxyr",
    styles: "margin-left:8px"
});
const MenuContainer = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e4txqg43"
})("margin-top:8px;background:#fff;border:", (0, _stylesValues.style_border_default), ";border-radius:8px;box-shadow:0 12px 32px rgba(0, 0, 0, 0.12);max-height:320px;overflow:auto;");
const Triangle = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e4txqg42"
})("transform:rotate(45deg);width:12px;height:12px;border-top:", (0, _stylesValues.style_border_default), ";border-left:", (0, _stylesValues.style_border_default), ";background:white;margin-top:-7px;right:15px;position:absolute;");
const SelectOptionMedium = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e4txqg41"
})("height:48px;:hover{background-color:", (0, _colors.color_variants_ocean_xlight), ";cursor:pointer;}");
const CustomSelectOptionLabelMedium = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e4txqg40"
})("div{display:flex;align-items:center;padding-left:16px;height:48px;border-bottom:", (0, _stylesValues.style_border_default), ";}p{color:", (0, _colors.color_shades_darkest), ";font-weight:400;font-size:14px;}.option-selected{color:", (0, _colors.color_colors_ocean), ";}");
exports.default = StyledDropdown;

},{"@emotion/styled/base":"lSuFu","@emotion/react":"djZKr","react":"6uln9","../../../../components/forms/DropDownSelectField":"kFCJA","../../../../constants/stylesValues":"dHVVv","../../../../constants/colors":"1p3OR","../../../../components/general/IconTooltip":"3FODC","./DropdownPortalMenu":"hDr5S","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"kFCJA":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _extends = require("@babel/runtime/helpers/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _base = require("@emotion/styled/base");
var _baseDefault = parcelHelpers.interopDefault(_base);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _reactSelect = require("react-select");
var _reactSelectDefault = parcelHelpers.interopDefault(_reactSelect);
var _colors = require("../../constants/colors");
var _toggleIndicator = require("../general/ToggleIndicator");
var _toggleIndicatorDefault = parcelHelpers.interopDefault(_toggleIndicator);
var _stylesValues = require("../../constants/stylesValues");
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const getSelectField = (props, menuProps)=>{
    return (0, _react.jsx)((0, _reactDefault.default).Fragment, null, (0, _react.jsx)(Triangle, null), props.options.map((option, index)=>(0, _react.jsx)("div", {
            key: index
        }, (0, _react.jsx)(CustomSelectOption, {
            className: "user-entry-option",
            onClick: ()=>menuProps.selectValue(option)
        }, option.image ? (0, _react.jsx)("img", {
            className: props.optionImageStyle ?? "",
            src: option.image
        }) : null, (0, _react.jsx)("div", {
            className: menuProps.valueArray && menuProps.valueArray.length > 0 && menuProps.valueArray[0].value == option.value ? "option-selected" : undefined,
            onMouseOver: ()=>menuProps.focusOption(option)
        }, option.label)), index != menuProps.options.length - 1 ? (0, _react.jsx)(Divider, null) : null)));
};
const DropDownSelectField = (props)=>{
    // Convert string value to option object for react-select
    const getValueForSelect = ()=>{
        if (!props.value) return null;
        // If value is already an option object, use it
        if (typeof props.value === "object" && props.value !== null) return props.value;
        // If value is a string, find the matching option
        const matchingOption = props.options.find((option)=>option.value === props.value);
        return matchingOption || null;
    };
    // Handle onChange to call props.onChange with the selected option
    const handleChange = (selectedOption)=>{
        if (props.onChange) props.onChange(selectedOption);
    };
    const selectProps = {
        ...props,
        value: getValueForSelect(),
        onChange: handleChange
    };
    // Use default menu renderer when searchable is true to preserve search functionality
    // Custom menu renderer overrides react-select's built-in search functionality
    const shouldUseCustomMenu = !props.searchable && !props.menuRenderer;
    const menuRenderer = shouldUseCustomMenu ? (menuProps)=>(0, _react.jsx)(MenuOptionsWrapper, null, getSelectField(props, menuProps)) : props.menuRenderer;
    return (0, _react.jsx)((0, _reactDefault.default).Fragment, null, props.size === "medium" ? (0, _react.jsx)(CustomSelectMedium, (0, _extendsDefault.default)({}, selectProps, {
        arrowRenderer: props.arrowRenderer ? props.arrowRenderer : (p)=>(0, _react.jsx)(Arrow, {
                direction: p.isOpen ? "up" : "down"
            }),
        menuRenderer: menuRenderer
    })) : props.size === "small" ? (0, _react.jsx)(CustomSelectSmall, (0, _extendsDefault.default)({}, selectProps, {
        arrowRenderer: props.arrowRenderer ? props.arrowRenderer : (p)=>(0, _react.jsx)(Arrow, {
                direction: p.isOpen ? "up" : "down"
            }),
        menuRenderer: menuRenderer
    })) : (0, _react.jsx)(CustomSelect, (0, _extendsDefault.default)({}, selectProps, {
        arrowRenderer: props.arrowRenderer ? props.arrowRenderer : (p)=>(0, _react.jsx)(Arrow, {
                direction: p.isOpen ? "up" : "down"
            }),
        menuRenderer: menuRenderer
    })));
};
const Arrow = /*#__PURE__*/ (0, _baseDefault.default)((0, _toggleIndicatorDefault.default), {
    target: "e1iliuqk7"
})({
    name: "18yym20",
    styles: "height:6px;width:6px"
});
const Divider = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1iliuqk6"
})("display:block;height:1px;border:0;border-top:1px solid ", (0, _colors.color_shades_dark), ";padding:0;");
const CustomSelectOption = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1iliuqk5"
})("display:flex;flex-direction:row;line-height:36px;padding-left:15px;&.user-entry-option:hover{background-color:", (0, _colors.color_variants_ocean_xlight), ";cursor:pointer;}div{margin-left:10px;color:", (0, _colors.color_shades_darkest), ";&.option-selected{color:", (0, _colors.color_colors_ocean), ";}}");
const MenuOptionsWrapper = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1iliuqk4"
})({
    name: "hkh81z",
    styles: "margin-top:8px"
});
const Triangle = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1iliuqk3"
})("transform:rotate(45deg);width:8px;height:8px;border-top:solid 1px ", (0, _colors.color_shades_dark), ";border-left:solid 1px ", (0, _colors.color_shades_dark), ";background:white;margin-top:-5px;margin-left:112px;position:absolute;");
const CustomSelect = /*#__PURE__*/ (0, _baseDefault.default)((0, _reactSelectDefault.default), {
    target: "e1iliuqk2"
})(".Select-control{border-radius:20px;}.Select-menu{margin-top:-8px;}.Select-menu-outer{margin-top:21px;border-radius:6px;border-top-color:", (0, _colors.color_shades_dark), ";}.Select-value:hover{cursor:pointer;}.Select-input{padding:8px 12px;font-size:14px;}.Select-option{padding:8px 15px;cursor:pointer;&:hover{background-color:", (0, _colors.color_variants_ocean_xlight), ";}&.is-focused{background-color:", (0, _colors.color_variants_ocean_xlight), ";}}&.is-open{.Select-control{border-bottom-right-radius:20px;border-bottom-left-radius:20px;border-color:", (0, _colors.color_shades_dark), ";}}");
const CustomSelectSmall = /*#__PURE__*/ (0, _baseDefault.default)((0, _reactSelectDefault.default), {
    target: "e1iliuqk1"
})("flex-grow:1;.Select-placeholder{padding:10px;display:flex;align-items:center;}.Select-control{height:32px;flex-grow:1;border:", (0, _stylesValues.style_border_default), ";box-shadow:0px 1px 2px rgba(50, 70, 97, 0.1);border-radius:4px;display:flex;align-items:center;justify-content:space-between;cursor:pointer;font-size:12px;font-weight:400;}.Select-control .Select-multi-value-wrapper .Select-value{display:flex;align-items:center;margin-left:8px;}.Select-menu{margin-top:-8px;}.Select-menu-outer{margin-top:12px;border-radius:4px;border:", (0, _stylesValues.style_border_default), ";}.Select-input{padding:4px 8px;font-size:12px;}.Select-option{padding:6px 12px;cursor:pointer;font-size:12px;&:hover{background-color:", (0, _colors.color_variants_ocean_xlight), ";}&.is-focused{background-color:", (0, _colors.color_variants_ocean_xlight), ";}}&.is-open{.Select-control{border-bottom-right-radius:4px;border-bottom-left-radius:4px;border:", (0, _stylesValues.style_border_default), ";}}");
const CustomSelectMedium = /*#__PURE__*/ (0, _baseDefault.default)((0, _reactSelectDefault.default), {
    target: "e1iliuqk0"
})("flex-grow:1;.Select-placeholder{padding:16px;display:flex;align-items:center;}.Select-control{height:48px;flex-grow:1;border:", (0, _stylesValues.style_border_default), ";box-shadow:0px 1px 2px rgba(50, 70, 97, 0.1);border-radius:8px;display:flex;align-items:center;justify-content:space-between;cursor:pointer;font-size:14px;font-weight:400;}.Select-control .Select-multi-value-wrapper .Select-value{display:flex;align-items:center;margin-left:8px;}.Select-menu{margin-top:-8px;margin-bottom:-8px;padding-bottom:8px;}.Select-menu-outer{margin-top:12px;border-radius:8px;border:", (0, _stylesValues.style_border_default), ";}.Select-input{padding:8px 12px;font-size:14px;}.Select-option{padding:8px 15px;cursor:pointer;&:hover{background-color:", (0, _colors.color_variants_ocean_xlight), ";}&.is-focused{background-color:", (0, _colors.color_variants_ocean_xlight), ";}}&.is-open{.Select-control{border-bottom-right-radius:8px;border-bottom-left-radius:8px;border:", (0, _stylesValues.style_border_default), ";}}");
exports.default = DropDownSelectField;

},{"@babel/runtime/helpers/extends":"4iKIP","@emotion/styled/base":"lSuFu","@emotion/react":"djZKr","react":"6uln9","react-select":"1numo","../../constants/colors":"1p3OR","../general/ToggleIndicator":"4eej1","../../constants/stylesValues":"dHVVv","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hDr5S":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PortalMenu", ()=>PortalMenu);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _reactDom = require("react-dom");
var _reactDomDefault = parcelHelpers.interopDefault(_reactDom);
const PortalMenu = ({ anchorEl, children, openAbove = true, zIndex = 99999, matchWidth = true })=>{
    const [rect, setRect] = (0, _react1.useState)(null);
    const menuRef = (0, _react1.useRef)(null);
    const updateRect = ()=>{
        if (!anchorEl) return;
        const r = anchorEl.getBoundingClientRect();
        setRect(r);
    };
    (0, _react1.useLayoutEffect)(()=>{
        updateRect();
        const onScroll = ()=>updateRect();
        const onResize = ()=>updateRect();
        window.addEventListener("scroll", onScroll, true);
        window.addEventListener("resize", onResize);
        return ()=>{
            window.removeEventListener("scroll", onScroll, true);
            window.removeEventListener("resize", onResize);
        };
    }, [
        anchorEl
    ]);
    if (!anchorEl || !rect) return null;
    const style = {
        position: "fixed",
        left: rect.left,
        top: openAbove ? rect.top : rect.bottom,
        width: matchWidth ? rect.width : undefined,
        transform: openAbove ? "translateY(-8px) translateY(-100%)" : "translateY(8px)",
        zIndex
    };
    return /*#__PURE__*/ (0, _reactDomDefault.default).createPortal((0, _react.jsx)("div", {
        ref: menuRef,
        style: style
    }, children), document.body);
};

},{"@emotion/react":"djZKr","react":"6uln9","react-dom":"b8T3j","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9QrZ0":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _base = require("@emotion/styled/base");
var _baseDefault = parcelHelpers.interopDefault(_base);
var _react = require("@emotion/react");
var _css = require("@emotion/css");
var _ssmlField = require("../../../components/forms/SsmlField/SsmlField");
var _ssmlFieldDefault = parcelHelpers.interopDefault(_ssmlField);
var _colors = require("../../../constants/colors");
var _textFieldSubtitle = require("../../../components/forms/TextFieldSubtitle");
var _textFieldSubtitleDefault = parcelHelpers.interopDefault(_textFieldSubtitle);
var _textAreaField = require("../../../components/forms/TextAreaField");
var _textAreaFieldDefault = parcelHelpers.interopDefault(_textAreaField);
var _textField = require("../../../components/forms/TextField");
var _textFieldDefault = parcelHelpers.interopDefault(_textField);
var _switch = require("../../../components/forms/Switch");
var _switchDefault = parcelHelpers.interopDefault(_switch);
var _horizontalOptionsSelector = require("../../../components/forms/HorizontalOptionsSelector");
var _horizontalOptionsSelectorDefault = parcelHelpers.interopDefault(_horizontalOptionsSelector);
var _iconTooltip = require("../../../components/general/IconTooltip");
var _iconTooltipDefault = parcelHelpers.interopDefault(_iconTooltip);
var _genAiModels = require("../../../constants/genAiModels");
var _styledDropdown = require("../../applicationSettings/components/customAssistantConfigurations/StyledDropdown");
var _styledDropdownDefault = parcelHelpers.interopDefault(_styledDropdown);
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _responsesContainer = require("../../../hooks/ResponsesContainer");
var _responsesContainerDefault = parcelHelpers.interopDefault(_responsesContainer);
var _responseChooser = require("./ResponseChooser");
var _responseChooserDefault = parcelHelpers.interopDefault(_responseChooser);
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const temperatureOptions = [
    {
        name: ".1",
        value: .1
    },
    {
        name: ".2",
        value: .2
    },
    {
        name: ".3",
        value: .3
    },
    {
        name: ".4",
        value: .4
    },
    {
        name: ".5",
        value: .5
    },
    {
        name: ".6",
        value: .6
    },
    {
        name: ".7",
        value: .7
    },
    {
        name: ".8",
        value: .8
    },
    {
        name: ".9",
        value: .9
    },
    {
        name: "1",
        value: 1
    }
];
const Response = (props)=>{
    const responseContainer = (0, _responsesContainerDefault.default).useContainer();
    const [showChooser, setShowChooser] = (0, _reactDefault.default).useState(false);
    const [responseTitle, setResponseTitle] = (0, _reactDefault.default).useState(props.answer?.name);
    const [showUsage, setShowUsage] = (0, _reactDefault.default).useState(false);
    (0, _react1.useEffect)(()=>{
        if (props.applicationId?.length && props.groupIndex === 0 && props.index === 0) responseContainer.loadApplicationResponses(props.applicationId);
    }, [
        props.applicationId,
        props.groupIndex,
        props.index
    ]);
    (0, _react1.useEffect)(()=>{
        if (props?.answer?.responseId?.length) responseContainer.loadResponse(props.answer.responseId);
    }, [
        props?.answer?.responseId
    ]);
    const clickLabel = ()=>{
        setShowUsage(true);
        setShowChooser(true);
    };
    const chooseResponse = async (responseId)=>{
        const chosenResponse = await responseContainer.loadResponse(responseId, true);
        if (chosenResponse) {
            const newResponse = {
                ...props.answer,
                ...chosenResponse
            };
            newResponse.responseId = chosenResponse.id;
            newResponse.id = undefined;
            props.handleUpdateFullResponse(newResponse);
            setResponseTitle(chosenResponse.name);
        }
    };
    const handleTitleBlur = ()=>{
        const existingResponse = responseContainer.responses.find((r)=>props.answer?.responseId?.length && r?.id !== props.answer?.responseId && r?.name?.length && r?.name === responseTitle);
        if (existingResponse) {
            props.showError(`A response with the name "${responseTitle}" already exists. Please choose a different name.`);
            setResponseTitle(null);
        } else props.handleTitleChange(responseTitle);
    };
    let usedInArr = responseContainer.responseInfos.find((r)=>r?.id === props.answer?.responseId)?.usedIn;
    usedInArr = usedInArr?.filter((u)=>u?.contentItemId?.length);
    const usedIn = usedInArr?.length ?? 0;
    return (0, _react.jsx)((0, _react1.Fragment), {
        key: "a" + props.index
    }, (0, _react.jsx)((0, _textFieldSubtitleDefault.default), {
        titleText: responseTitle ?? `Variation #${props.index + 1}`,
        canCopy: true,
        canSelect: props.group?.responses?.length < 2,
        editableTitle: props.group?.responses?.length < 2,
        canDelete: props.index > 0,
        onChangeTitle: (newTitle)=>setResponseTitle(newTitle),
        titlePlaceholder: `Variation #${props.index + 1}`,
        onDelete: ()=>props.handleRemoveVariation(),
        onSelect: ()=>{
            setShowUsage(false);
            setShowChooser(!showChooser);
        },
        onCopy: ()=>props.handleCopyVariation(),
        onTitleBlur: ()=>{
            handleTitleBlur();
        },
        selectCount: usedIn
    }), (0, _react.jsx)(HolderDiv, {
        key: "s" + props.index
    }, props.answer.useEnhancedResponse ? (0, _react.jsx)((0, _reactDefault.default).Fragment, null, (0, _react.jsx)((0, _textAreaFieldDefault.default), {
        id: `g${props.groupIndex}systemPrompt${props.index}`,
        disabled: props.isDisabled,
        name: `responses.${props.index}.systemPrompt`,
        value: props.answer?.systemPrompt ?? "",
        placeholder: "A system prompt for this response.",
        label: `System Prompt`,
        tooltip: "A system level prompt given to the generative AI model<br />\r that describes how it should respond.<br />\r This is optional and added before the conversation history.",
        onChange: (e)=>props.handleSystemPromptUpdate(e.target.value),
        onBlur: props.onBlur,
        showResponseVariableTest: true,
        className: "ac-response-ssml"
    }), (0, _react.jsx)((0, _textAreaFieldDefault.default), {
        id: `g${props.groupIndex}contextualSystemPrompt${props.index}`,
        disabled: props.isDisabled,
        name: `responses.${props.index}.contextualSystemPrompt`,
        value: props.answer?.contextualSystemPrompt ?? "",
        placeholder: "A prompt given to the Generative AI right before this turn of the conversation.",
        label: `Contextual System Prompt`,
        showResponseVariableTest: true,
        tooltip: "A system prompt given to the generative AI model<br />\r right before the most recent turn of the conversation.<br />\r Can be more specific for the current conversation turn.",
        onChange: (e)=>props.handleContextualSystemPrompt(e.target.value),
        onBlur: props.onBlur,
        className: "ac-response-ssml"
    }), (0, _react.jsx)((0, _ssmlFieldDefault.default), {
        id: `g${props.groupIndex}response${props.index}`,
        applicationId: props.applicationId,
        disabled: props.isDisabled,
        name: `responses.${props.index}.content`,
        value: props.answer.content,
        placeholder: "A Phrase",
        labelColor: usedIn > 1 ? (0, _colors.dark_red) : undefined,
        clickableLabel: usedIn > 1,
        onClickLabel: usedIn > 1 ? ()=>clickLabel() : undefined,
        label: usedIn > 1 ? `Response used in ${usedIn} places!` : props.answer.useEnhancedResponse ? `Backup Response` : `Response`,
        onChange: (value)=>props.handleSsmlUpdate(value),
        onBlur: props.onBlur,
        className: "ac-response-ssml"
    }), (0, _react.jsx)((0, _reactDefault.default).Fragment, null, (0, _react.jsx)(TempLabel, null, (0, _react.jsx)(TempDescription, null, "Temperature"), (0, _react.jsx)((0, _iconTooltipDefault.default), {
        text: "Higher temperatures result in more creative responses<br />at the risk of less consistent and controlled output."
    })), (0, _react.jsx)((0, _horizontalOptionsSelectorDefault.default), {
        name: `responses.${props.index}.temperature`,
        options: temperatureOptions,
        value: props.answer.temperature ?? .1,
        isCustom: false,
        onChange: (value)=>{
            props.handleTemperature(value);
        }
    })), (0, _react.jsx)(ModelOverrideSwitch, {
        label: "Include Conversation History",
        checked: !props.answer?.excludeConversationHistoryForGenAI,
        onChange: ()=>props.handleToggleExcludeConversationHistoryForGenAI()
    }), !props.answer?.excludeConversationHistoryForGenAI && (0, _react.jsx)(ConversationTurnsLimitWrapper, null, (0, _react.jsx)((0, _textFieldDefault.default), {
        id: `g${props.groupIndex}conversationTurnsLimit${props.index}`,
        disabled: props.isDisabled || props.answer.excludeConversationHistoryForGenAI == true,
        name: `responses.${props.index}.lastTurnsToInclude`,
        value: props.answer?.lastTurnsToInclude !== undefined && props.answer?.lastTurnsToInclude !== 0 ? props.answer.lastTurnsToInclude.toString() : "10",
        placeholder: "Enter a number",
        label: `Limit to last N conversation turns`,
        tooltip: "Limits the conversation history to the specified number of most recent turns. Leave empty to use the entire conversation.",
        onChange: (e)=>props.handleConversationTurnsLimitUpdate(e.target.value),
        onBlur: props.onBlur,
        className: "ac-response-ssml",
        type: "number"
    })), (0, _react.jsx)(ModelOverrideSwitch, {
        label: "Enable Model Override",
        checked: props.answer?.useModelOverride || props.answer?.generativeAIModelOverride != null,
        onChange: ()=>props.handleToggleModelOverride()
    }), (props.answer?.useModelOverride || props.answer?.generativeAIModelOverride != null) && (0, _react.jsx)(SquareStyledDropdown, {
        className: "ac-response-ssml",
        fieldName: "generativeResponseModel",
        label: "Generative AI Model Override",
        labelStyle: leftMarginLabelStyle,
        handleOnChange: (_, value)=>props.handleModelChange(value),
        value: props.answer?.generativeAIModelOverride,
        searchable: false,
        placeholder: "Select AI Model",
        options: (0, _genAiModels.GenAIModels)
    }), (0, _react.jsx)(ModelOverrideSwitch, {
        label: "Use History in System Prompt",
        checked: props.answer?.useHistoryInSystemPrompt,
        onChange: ()=>props.handleToggleUseHistoryInSystemPrompt()
    }), (0, _react.jsx)(ModelOverrideSwitch, {
        label: "Only Include Current Content Item History",
        checked: props.answer?.onlyIncludeCurrentContentItemHistory,
        onChange: ()=>props.handleToggleOnlyIncludeCurrentContentItemHistory()
    })) : (0, _react.jsx)((0, _ssmlFieldDefault.default), {
        id: `g${props.groupIndex}response${props.index}`,
        applicationId: props.applicationId,
        disabled: props.isDisabled,
        name: `responses.${props.index}.content`,
        value: props.answer.content,
        placeholder: "A Phrase",
        labelColor: usedIn > 1 ? (0, _colors.dark_red) : undefined,
        clickableLabel: usedIn > 1,
        onClickLabel: usedIn > 1 ? ()=>clickLabel() : undefined,
        label: usedIn > 1 ? `Response used in ${usedIn} places!` : props.answer.useEnhancedResponse ? `Backup Response` : `Response`,
        onChange: (value)=>props.handleSsmlUpdate(value),
        onBlur: props.onBlur,
        className: "ac-response-ssml"
    }), showChooser ? (0, _react.jsx)((0, _responseChooserDefault.default), {
        currentResponseId: props.answer?.responseId,
        showUsage: showUsage,
        chooseResponse: (responseId)=>{
            chooseResponse(responseId);
            setShowChooser(false);
        },
        appId: props.applicationId
    }) : (0, _react.jsx)((0, _reactDefault.default).Fragment, null)));
};
const HolderDiv = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e18jjni85"
})({
    name: "bjn8wh",
    styles: "position:relative"
});
const TempLabel = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e18jjni84"
})({
    name: "ho1qnd",
    styles: "display:flex;flex-direction:row"
});
const TempDescription = /*#__PURE__*/ (0, _baseDefault.default)("p", {
    target: "e18jjni83"
})({
    name: "1cf5y6b",
    styles: "margin-bottom:16px;margin-left:16px;font-size:14px;font-weight:600;text-align:left;margin-right:8px"
});
const leftMarginLabelStyle = /*#__PURE__*/ (0, _css.css)({
    name: "eklkae",
    styles: "margin-left:16px;font-weight:600"
});
const SquareStyledDropdown = /*#__PURE__*/ (0, _baseDefault.default)((0, _styledDropdownDefault.default), {
    target: "e18jjni82"
})({
    name: "1cfa65",
    styles: ".Select-control{border-radius:4px!important;height:48px!important;}.Select-menu-outer{border-radius:4px!important;}.Select-placeholder{line-height:48px!important;}.Select-value{line-height:48px!important;}margin-bottom:18px;margin-left:18px"
});
const ModelOverrideSwitch = /*#__PURE__*/ (0, _baseDefault.default)((0, _switchDefault.default), {
    target: "e18jjni81"
})({
    name: "1gqdd25",
    styles: "padding-top:8px!important;margin-bottom:16px"
});
const ConversationTurnsLimitWrapper = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e18jjni80"
})({
    name: "1a2afmv",
    styles: "margin-left:10px"
});
exports.default = Response;

},{"@emotion/styled/base":"lSuFu","@emotion/react":"djZKr","@emotion/css":"awUBr","../../../components/forms/SsmlField/SsmlField":"cvL6K","../../../constants/colors":"1p3OR","../../../components/forms/TextFieldSubtitle":"lJGWV","../../../components/forms/TextAreaField":"fE54C","../../../components/forms/TextField":"7a7bh","../../../components/forms/Switch":"8kkL9","../../../components/forms/HorizontalOptionsSelector":"6A3ab","../../../components/general/IconTooltip":"3FODC","../../../constants/genAiModels":"7j9RQ","../../applicationSettings/components/customAssistantConfigurations/StyledDropdown":"hjrMo","react":"6uln9","../../../hooks/ResponsesContainer":"dMnYo","./ResponseChooser":"k8EwE","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"lJGWV":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _base = require("@emotion/styled/base");
var _baseDefault = parcelHelpers.interopDefault(_base);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _colors = require("../../constants/colors");
var _button = require("../general/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _tooltipWrapper = require("../general/TooltipWrapper");
var _tooltipWrapperDefault = parcelHelpers.interopDefault(_tooltipWrapper);
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const deleteIcon = require("a42a26897b51429");
const duplicateIcon = require("e83a0de183e6e58f");
const arrowIcon = require("d70ca73a00548a60");
const TextFieldSubtitle = ({ selectCount, titleText, canDelete, canCopy, deletePosition, canSelect, editableTitle, titlePlaceholder, onTitleBlur, onDelete, onSelect, onCopy, onChangeTitle })=>{
    return (0, _react.jsx)((0, _reactDefault.default).Fragment, null, (0, _react.jsx)(TitleContainer, null, (0, _react.jsx)(TitleLineBefore, null), !editableTitle ? (0, _react.jsx)(TitleText, null, titleText) : (0, _react.jsx)(StyledTextField, {
        type: "text",
        placeholder: titlePlaceholder,
        value: titleText,
        onBlur: (e)=>onTitleBlur(),
        onChange: (e)=>onChangeTitle(e.target.value)
    }), (0, _react.jsx)(TitleLineAfter, null), (0, _react.jsx)(TitleIconContainer, null, canDelete && (deletePosition == undefined || deletePosition == "top") ? (0, _react.jsx)((0, _buttonDefault.default), {
        type: "button",
        onClick: onDelete,
        themes: [
            "medium-icon"
        ],
        icon: deleteIcon
    }) : null, canCopy && (0, _react.jsx)((0, _buttonDefault.default), {
        type: "button",
        onClick: onCopy,
        themes: [
            "medium-icon"
        ],
        icon: duplicateIcon
    }), canSelect ? selectCount && selectCount > 1 ? (0, _react.jsx)((0, _tooltipWrapperDefault.default), {
        place: "top",
        text: `Response used in ${selectCount} places`
    }, (0, _react.jsx)(StyledCount, {
        onClick: onSelect
    }, selectCount)) : (0, _react.jsx)((0, _tooltipWrapperDefault.default), {
        place: "top",
        text: `Use existing named response`
    }, (0, _react.jsx)(StyledArrow, {
        type: "button",
        onClick: onSelect,
        themes: [
            "medium-icon"
        ],
        icon: arrowIcon
    })) : (0, _react.jsx)((0, _reactDefault.default).Fragment, null))));
};
const StyledArrow = /*#__PURE__*/ (0, _baseDefault.default)((0, _buttonDefault.default), {
    target: "ehtq6ce7"
})({
    name: "16dzwbu",
    styles: "transform:rotate(90deg);margin-top:8px"
});
const StyledCount = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "ehtq6ce6"
})("height:24px;width:24px;border-radius:50%;background-color:", (0, _colors.color_shades_darkest), ";color:white;text-align:center;font-size:12px;padding-top:4px;cursor:pointer;");
const StyledTextField = /*#__PURE__*/ (0, _baseDefault.default)("input", {
    target: "ehtq6ce5"
})("height:30px;margin-left:8px;border:1px solid ", (0, _colors.silver_four), ";color:", (0, _colors.dark_grey_blue), ";border-radius:4px;padding-left:8px;");
const TitleContainer = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "ehtq6ce4"
})({
    name: "1ffh64q",
    styles: "height:20px;display:flex;align-items:center;margin:12px 0"
});
const TitleText = /*#__PURE__*/ (0, _baseDefault.default)("h4", {
    target: "ehtq6ce3"
})("font-weight:400;size:16px;line-height:24px;color:", (0, _colors.color_shades_darkest), ";padding:0 8px;");
const TitleLineBefore = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "ehtq6ce2"
})("border-bottom:1px solid ", (0, _colors.silver_four), ";width:8px;");
const TitleLineAfter = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "ehtq6ce1"
})("border-bottom:1px solid ", (0, _colors.silver_four), ";flex-grow:1;margin-left:8px;");
const TitleIconContainer = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "ehtq6ce0"
})({
    name: "s5xdrg",
    styles: "display:flex;align-items:center"
});
exports.default = TextFieldSubtitle;

},{"@emotion/styled/base":"lSuFu","@emotion/react":"djZKr","react":"6uln9","../../constants/colors":"1p3OR","../general/Button":"6ymxN","../general/TooltipWrapper":"53pWd","a42a26897b51429":"dJ0AJ","e83a0de183e6e58f":"8rvGy","d70ca73a00548a60":"g6080","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"dJ0AJ":[function(require,module,exports) {
module.exports = require("c34932aafae4aeb5").getBundleURL("kVLro") + require("54794bc2291439ed").resolve("1lfW7");

},{"c34932aafae4aeb5":"c7Tr5","54794bc2291439ed":"fyJL2"}],"8rvGy":[function(require,module,exports) {
module.exports = require("c6a1d7812f6e52ff").getBundleURL("kVLro") + require("ac1d6abca1b87766").resolve("erT28");

},{"c6a1d7812f6e52ff":"c7Tr5","ac1d6abca1b87766":"fyJL2"}],"g6080":[function(require,module,exports) {
module.exports = require("dfba75e5ece8302b").getBundleURL("kVLro") + require("6666d359313905a5").resolve("aK23Q");

},{"dfba75e5ece8302b":"c7Tr5","6666d359313905a5":"fyJL2"}],"6A3ab":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _colors = require("../../constants/colors");
var _fieldError = require("./FieldError");
var _fieldErrorDefault = parcelHelpers.interopDefault(_fieldError);
var _stylesValues = require("../../constants/stylesValues");
const HorizontalOptionsSelector = (props)=>{
    const [isCustomSelected, setIsCustomSelected] = (0, _react1.useState)(false);
    (0, _react1.useEffect)(()=>{
        if (props.value && !props.options.some((o)=>o.value === props.value)) setIsCustomSelected(true);
    }, []);
    const handleCustomSelected = ()=>{
        setIsCustomSelected(true);
    };
    const handleOptionSelected = (option)=>{
        setIsCustomSelected(false);
        props.onChange(option.value);
    };
    const handleCustomChanged = (customValue)=>{
        let customValueNumber = null;
        if (customValue != null && customValue.length > 0) customValueNumber = +customValue;
        setIsCustomSelected(true);
        props.onChange(customValueNumber);
    };
    return (0, _react.jsx)((0, _reactDefault.default).Fragment, null, (0, _react.jsx)("div", {
        className: containerStyle
    }, (0, _react.jsx)("div", {
        className: "selector-wrapper"
    }, (0, _react.jsx)("div", {
        className: "items-wrapper"
    }, props.options.map((option, index)=>(0, _react.jsx)("div", {
            className: `${index > 0 ? "with-left-line" : ""} ${index < props.options.length - 1 ? "with-right-line" : ""} radio-option`,
            key: index,
            onClick: ()=>handleOptionSelected(option)
        }, (0, _react.jsx)("div", {
            className: "check-wrapper"
        }, (0, _react.jsx)("div", {
            className: "left-line"
        }), (0, _react.jsx)("div", {
            className: "check-container"
        }, option.value == props.value && !isCustomSelected ? (0, _react.jsx)("div", {
            className: "selected-option"
        }) : (0, _react.jsx)((0, _reactDefault.default).Fragment, null)), (0, _react.jsx)("div", {
            className: "right-line"
        })), (0, _react.jsx)("span", null, option.name))))), props.disableCustom ? (0, _react.jsx)((0, _reactDefault.default).Fragment, null) : (0, _react.jsx)("div", {
        className: "custom-wrapper"
    }, (0, _react.jsx)("div", {
        className: "dash-separator"
    }), (0, _react.jsx)("div", {
        className: "radio-option custom",
        onClick: ()=>handleCustomSelected()
    }, (0, _react.jsx)("div", {
        className: "check-wrapper"
    }, (0, _react.jsx)("div", {
        className: "check-container"
    }, isCustomSelected ? (0, _react.jsx)("div", {
        className: "selected-option"
    }) : (0, _react.jsx)((0, _reactDefault.default).Fragment, null))), (0, _react.jsx)("span", null, "Custom")), (0, _react.jsx)("div", {
        className: "text-field-wrapper"
    }, (0, _react.jsx)("input", {
        type: "number",
        name: props.name,
        value: props.value,
        onChange: (e)=>handleCustomChanged(e.target.value),
        onBlur: ()=>{}
    })))), (0, _react.jsx)((0, _fieldErrorDefault.default), {
        name: props.name
    }));
};
const containerStyle = /*#__PURE__*/ (0, _css.css)("border:", (0, _stylesValues.style_border_default), ";border-radius:5px;position:relative;height:80px;flex:1;margin:4px 0 16px 0;display:flex;flex-direction:row;align-items:center;padding:0 24px;.selector-wrapper{position:relative;flex:1;.items-wrapper{display:flex;}}.custom-wrapper{display:flex;flex-direction:row;align-items:center;border-left:", (0, _stylesValues.style_border_default), ";}.radio-option{margin:8px 0;display:flex;flex-direction:column;align-items:center;cursor:pointer;flex:1;&.custom{flex:0;}.check-wrapper{display:flex;align-items:center;justify-content:center;width:100%;}.left-line,.right-line{height:1px;background:transparent;flex-grow:1;width:auto;}&.with-left-line{.left-line{background:", (0, _colors.silver_two), ";}}&.with-right-line{.right-line{background:", (0, _colors.silver_two), ";}}.check-container{position:relative;min-width:17px;height:17px;border-radius:50%;background-color:#ffffff;border:solid 1px #cccccc;display:flex;align-items:center;justify-content:center;padding:0;}.selected-option{width:10px;height:10px;border-radius:50%;background-image:linear-gradient(225deg, #76c3b5, #3ea6ac 72%, #5296b3);}span{font-family:Muli;font-size:10px;font-weight:normal;font-style:normal;font-stretch:normal;line-height:normal;letter-spacing:0.4px;text-align:center;color:#304562;margin-top:8px;}}.dash-separator{height:50%;width:1px;border-left:1px dashed ", (0, _colors.silver_two), ";margin:0 12px;}.unit-label{font-family:Muli;font-size:14px;font-weight:normal;font-style:normal;font-stretch:normal;line-height:normal;letter-spacing:normal;color:", (0, _colors.cool_grey), ";}.unit-detail-label{color:", (0, _colors.cool_grey), ";font-size:9px;}.text-field-wrapper{width:50px;height:40px;margin:0 12px;input{width:50px;height:40px;border-radius:5px;box-shadow:inset 0 1px 1px 0 rgba(44, 61, 82, 0.3);background-color:#ffffff;border:1px solid ", (0, _colors.silver_two), ";text-align:right;font-family:Muli;font-size:14px;color:#304562;padding-right:10px;}input[type=number]::-webkit-inner-spin-button,input[type=number]::-webkit-outer-spin-button{-webkit-appearance:none;margin:0;}}", "");
exports.default = HorizontalOptionsSelector;

},{"@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","../../constants/colors":"1p3OR","./FieldError":"fDxhz","../../constants/stylesValues":"dHVVv","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7j9RQ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "GenAIModels", ()=>GenAIModels);
const GenAIModels = [
    {
        label: "GPT-4o",
        value: "GPT-4o"
    },
    {
        label: "GROK2",
        value: "GROK2"
    },
    {
        label: "GROK3",
        value: "grok-3"
    },
    {
        label: "gemini-2.0-flash",
        value: "gemini-2.0-flash"
    },
    {
        label: "Open AI GPT 4.1",
        value: "openai-gpt-4.1"
    },
    {
        label: "Open AI GPT 4.1 Mini",
        value: "openai-gpt-4.1-mini"
    },
    {
        label: "gemini-2.5-flash",
        value: "gemini-2.5-flash"
    },
    {
        label: "gemini-2.5-flash-preview-04-17",
        value: "gemini-2.5-flash-preview-04-17"
    },
    {
        label: "gemini-2.5-flash-preview-05-20",
        value: "gemini-2.5-flash-preview-05-20"
    },
    {
        label: "gemini-3-flash-preview",
        value: "gemini-3-flash-preview"
    },
    {
        label: "gemini-3-flash",
        value: "gemini-3-flash"
    }
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"dMnYo":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _unstatedNext = require("unstated-next");
var _api = require("../api");
// base representation of a term
function useResponsesContainer() {
    const [responseInfos, setResponseInfos] = (0, _react.useState)([]);
    const [responses, setResponses] = (0, _react.useState)([]);
    const [currentApp, setCurrentApp] = (0, _react.useState)("");
    const [loadingApplicationResponses, setLoadingAppResponses] = (0, _react.useState)(false);
    const [loading, setLoading] = (0, _react.useState)(false);
    const loadResponse = async (responseId, withFollowUp = false)=>{
        try {
            setLoading(true);
            const newResponses = responseInfos.filter((response)=>response.id !== responseId);
            const response = await _api.getResponse(responseId);
            setLoading(false);
            if (response.resultType === "Ok") {
                if (withFollowUp) {
                    const followUpResponse = await _api.findFollowUpById(response.data.followUpId);
                    if (followUpResponse.resultType === "Ok") response.data.followUp = followUpResponse.data;
                    if (followUpResponse.resultType === "Ok") response.data.followUp = followUpResponse.data;
                }
                newResponses.push({
                    id: response.data.id,
                    usedIn: response.data.usedIn
                });
                setResponseInfos(newResponses);
                return response.data;
            }
            return null;
        } catch (e) {}
    };
    const loadApplicationResponses = async (applicationId, force = false)=>{
        try {
            if (!force && (loadingApplicationResponses || currentApp === applicationId)) return;
            setLoading(true);
            setLoadingAppResponses(true);
            const allResponses = [];
            let skip = 0;
            const take = 200;
            while(true){
                const response = await _api.getResponsesForApplication(applicationId, skip, take);
                if (response.resultType === "Ok") {
                    if (response.data.length) allResponses.push(...response.data);
                    if (response.data.length === 0) break;
                    skip += take;
                }
            }
            setLoading(false);
            setResponses(allResponses);
            setLoadingAppResponses(false);
            setCurrentApp(applicationId);
        } catch (e) {}
    };
    const deleteResponse = async (responseId)=>{
        try {
            setLoading(true);
            const response = await _api.deleteResponse(responseId);
            setLoading(false);
        } catch (e) {}
    };
    return {
        responseInfos,
        responses,
        loadResponse,
        loadApplicationResponses,
        deleteResponse,
        loading
    };
}
const ResponsesContainer = (0, _unstatedNext.createContainer)(useResponsesContainer);
exports.default = ResponsesContainer;

},{"react":"6uln9","unstated-next":"61zE5","../api":"loxM6","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"k8EwE":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _base = require("@emotion/styled/base");
var _baseDefault = parcelHelpers.interopDefault(_base);
var _react = require("@emotion/react");
var _colors = require("../../../constants/colors");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _responsesContainer = require("../../../hooks/ResponsesContainer");
var _responsesContainerDefault = parcelHelpers.interopDefault(_responsesContainer);
var _customScrollbars = require("../../../components/structure/CustomScrollbars");
var _customScrollbarsDefault = parcelHelpers.interopDefault(_customScrollbars);
var _searchField = require("../../../components/forms/SearchField");
var _searchFieldDefault = parcelHelpers.interopDefault(_searchField);
var _button = require("../../../components/general/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _loader = require("../../../components/general/Loader");
var _loaderDefault = parcelHelpers.interopDefault(_loader);
var _tooltipWrapper = require("../../../components/general/TooltipWrapper");
var _tooltipWrapperDefault = parcelHelpers.interopDefault(_tooltipWrapper);
var _extensions = require("../../../models/extensions");
var _reactRouterDom = require("react-router-dom");
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const deleteIcon = require("f10cf34e3d6218df");
const ResponseChooser = (props)=>{
    const responseContainer = (0, _responsesContainerDefault.default).useContainer();
    const [areYouSureIds, setAreYouSureIds] = (0, _reactDefault.default).useState([]);
    const [search, setSearch] = (0, _reactDefault.default).useState("");
    const [usedIn, setUsedIn] = (0, _reactDefault.default).useState(null);
    (0, _react1.useEffect)(()=>{
        if (props.appId?.length) responseContainer.loadApplicationResponses(props.appId, true);
    }, [
        props.appId
    ]);
    (0, _react1.useEffect)(()=>{
        if (props.currentResponseId?.length && props.showUsage) responseContainer.loadResponse(props.currentResponseId, true).then((response)=>{
            if (response?.usedIn?.length) setUsedIn(response.usedIn?.filter((i)=>i?.contentItemId?.length) ?? []);
            else setUsedIn([]);
        });
    }, [
        props.currentResponseId,
        props.showUsage
    ]);
    const responsesToRender = responseContainer.responses.filter((r)=>r?.name?.length && (!search?.length || r.name.toLowerCase().includes(search.toLowerCase())));
    return (0, _react.jsx)(ContentContainer, null, (0, _react.jsx)(ParentDiv, {
        autoHeightMax: "50vh",
        autoHeightMin: "50vh"
    }, (0, _react.jsx)(InnerContentContainer, null, responseContainer.loading || props.showUsage && usedIn === null ? (0, _react.jsx)((0, _loaderDefault.default), null) : props.showUsage ? (0, _react.jsx)((0, _reactDefault.default).Fragment, null, (0, _react.jsx)("div", {
        style: {
            color: (0, _colors.color_shades_darkest),
            marginBottom: "8px"
        }
    }, "Used in:"), usedIn.length === 0 ? (0, _react.jsx)("div", {
        style: {
            color: (0, _colors.color_shades_darkest)
        }
    }, "Not used") : null, usedIn.map((item, index)=>{
        return (0, _react.jsx)(ResponsePill, {
            key: index
        }, (0, _react.jsx)(StyledCILink, {
            target: "_blank",
            to: (0, _extensions.getEditUrl)(item.contentItemId, item.applicationFeatureId, item.featureTypeId)
        }, `${(0, _extensions.getPrettyEditUrl)(item.contentItemId, item.featureTypeId)}`));
    })) : (0, _react.jsx)((0, _reactDefault.default).Fragment, null, (0, _react.jsx)((0, _searchFieldDefault.default), {
        value: search,
        onChange: (e)=>{
            setSearch(e.target.value);
        },
        boxType: "square"
    }), !responsesToRender?.length && (0, _react.jsx)("div", {
        style: {
            color: (0, _colors.color_shades_darkest)
        }
    }, "No responses found"), responsesToRender?.map((response, index)=>{
        let tooltipText = response?.systemPrompt ?? response?.content ?? "No content yet";
        // only first 20 characters
        const tooltipLength = 100;
        if (tooltipText?.length > tooltipLength) tooltipText = tooltipText.substring(0, tooltipLength) + "...";
        return (0, _react.jsx)((0, _tooltipWrapperDefault.default), {
            place: "top",
            text: tooltipText,
            key: index
        }, (0, _react.jsx)(ResponsePill, {
            onClick: ()=>{
                props.chooseResponse(response.id);
            },
            key: index
        }, (0, _react.jsx)(ResponseName, null, response.name), (0, _react.jsx)(RightOfPill, null, areYouSureIds.includes(response.id) ? (0, _react.jsx)(AreYouSureDiv, {
            onClick: (e)=>{
                e.stopPropagation();
                setAreYouSureIds(areYouSureIds.filter((id)=>id !== response.id));
            }
        }, "Are you sure?") : (0, _react.jsx)((0, _reactDefault.default).Fragment, null), (0, _react.jsx)((0, _buttonDefault.default), {
            type: "button",
            onClick: (e)=>{
                e.stopPropagation();
                if (areYouSureIds.includes(response.id)) responseContainer.deleteResponse(response.id).then(()=>{
                    responseContainer.loadApplicationResponses(props.appId, true);
                });
                else setAreYouSureIds([
                    ...areYouSureIds,
                    response.id
                ]);
            },
            themes: [
                "medium-icon",
                "end"
            ],
            icon: deleteIcon
        }))));
    })))));
};
// stop from wrapping text
const ResponseName = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1b1f8qp7"
})({
    name: "1osxbp9",
    styles: "max-width:60%;text-overflow:ellipsis;overflow:hidden;white-space:nowrap"
});
const StyledCILink = /*#__PURE__*/ (0, _baseDefault.default)((0, _reactRouterDom.Link), {
    target: "e1b1f8qp6"
})("text-overflow:ellipsis;overflow:hidden;white-space:nowrap;color:", (0, _colors.color_text_link), ";");
const ParentDiv = /*#__PURE__*/ (0, _baseDefault.default)((0, _customScrollbarsDefault.default), {
    target: "e1b1f8qp5"
})("");
const AreYouSureDiv = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1b1f8qp4"
})({
    name: "1gtfvzk",
    styles: "margin-right:8px;cursor:pointer;margin-top:4px"
});
const RightOfPill = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1b1f8qp3"
})({
    name: "1k9qz8b",
    styles: "margin-left:auto;display:flex;flex-direction:row"
});
const ContentContainer = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1b1f8qp2"
})("right:0;z-index:100;height:50vh;background-color:white;border-radius:8px;top:0;position:absolute;width:30vw;border:1px solid ", (0, _colors.color_shades_dark), ";");
const InnerContentContainer = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1b1f8qp1"
})({
    name: "hfziu3",
    styles: "padding:16px;padding-top:16px;padding-bottom:16px"
});
const ResponsePill = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1b1f8qp0"
})("height:32px;border:1px solid ", (0, _colors.color_shades_dark), ";border-radius:8px;margin:0 0px 8px 0px;padding:16px;cursor:pointer;background:", (0, _colors.color_shades_lighter), ";display:flex;flex-direction:row;align-items:center;font-size:14px;");
exports.default = ResponseChooser;

},{"@emotion/styled/base":"lSuFu","@emotion/react":"djZKr","../../../constants/colors":"1p3OR","react":"6uln9","../../../hooks/ResponsesContainer":"dMnYo","../../../components/structure/CustomScrollbars":"50vFq","../../../components/forms/SearchField":"aU10T","../../../components/general/Button":"6ymxN","../../../components/general/Loader":"bnV5T","../../../components/general/TooltipWrapper":"53pWd","../../../models/extensions":"7h01B","react-router-dom":"5fzqq","f10cf34e3d6218df":"dJ0AJ","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"5bpHt":[function(require,module,exports) {
module.exports = require("a7bfe4a0baec981a").getBundleURL("kVLro") + require("4c8c15834d719a5c").resolve("dmpf2");

},{"a7bfe4a0baec981a":"c7Tr5","4c8c15834d719a5c":"fyJL2"}],"8Bko5":[function(require,module,exports) {
module.exports = require("b016736e2ddb2b65").getBundleURL("kVLro") + require("2ad37bdf6ab3d4d3").resolve("54VFN");

},{"b016736e2ddb2b65":"c7Tr5","2ad37bdf6ab3d4d3":"fyJL2"}],"erpXi":[function(require,module,exports) {
module.exports = require("ba95e427da379538").getBundleURL("kVLro") + require("98726f4bfa56356b").resolve("9isuy");

},{"ba95e427da379538":"c7Tr5","98726f4bfa56356b":"fyJL2"}],"dZpNy":[function(require,module,exports) {
module.exports = require("826b129cf2539c7e").getBundleURL("kVLro") + require("d99f5769309a55fe").resolve("gOYHl");

},{"826b129cf2539c7e":"c7Tr5","d99f5769309a55fe":"fyJL2"}],"hFwqT":[function(require,module,exports) {
module.exports = require("443fdbb4d37e5fcc").getBundleURL("kVLro") + require("195df28e7fc5068d").resolve("ehz1r");

},{"443fdbb4d37e5fcc":"c7Tr5","195df28e7fc5068d":"fyJL2"}],"20G3l":[function(require,module,exports) {
module.exports = require("13829df904d90e3").getBundleURL("kVLro") + require("15cdd9f1037827ab").resolve("bIqTt");

},{"13829df904d90e3":"c7Tr5","15cdd9f1037827ab":"fyJL2"}],"jk3D1":[function(require,module,exports) {
module.exports = require("92f1ba334e4775b6").getBundleURL("kVLro") + require("d0b733ede023bf0").resolve("lyxxp");

},{"92f1ba334e4775b6":"c7Tr5","d0b733ede023bf0":"fyJL2"}],"kBbXd":[function(require,module,exports) {
module.exports = require("a48cfe94f609bcb6").getBundleURL("kVLro") + require("272c20532ae8502a").resolve("8KCfq");

},{"a48cfe94f609bcb6":"c7Tr5","272c20532ae8502a":"fyJL2"}],"f9rzT":[function(require,module,exports) {
module.exports = require("ee24d8a8fa25f20b").getBundleURL("kVLro") + require("d9a6e41d509e6db").resolve("lgVjp");

},{"ee24d8a8fa25f20b":"c7Tr5","d9a6e41d509e6db":"fyJL2"}],"lTxXn":[function(require,module,exports) {
module.exports = require("fb5be4783e0b388f").getBundleURL("kVLro") + require("7748acfdee0bbf6e").resolve("9uoIh");

},{"fb5be4783e0b388f":"c7Tr5","7748acfdee0bbf6e":"fyJL2"}],"91DiF":[function(require,module,exports) {
module.exports = require("e4cdee37095ba30c").getBundleURL("kVLro") + require("ab3f7b490b4d6891").resolve("eQ6Dj");

},{"e4cdee37095ba30c":"c7Tr5","ab3f7b490b4d6891":"fyJL2"}],"3cmia":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _defineProperty = require("@babel/runtime/helpers/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _unstated = require("unstated");
var _api = require("../../api");
class ApplicationFlagsContainer extends (0, _unstated.Container) {
    constructor(...args){
        super(...args);
        // default state
        (0, _definePropertyDefault.default)(this, "state", this.getInitialState());
    }
    getInitialState() {
        return {
            isLoading: false,
            applicationFlags: [],
            errors: []
        };
    }
    async loadApplicationFlags(applicationId) {
        await this.setLoading(true);
        try {
            const result = await _api.getApplicationConversationFlags(applicationId);
            if (result?.resultType == "Ok") await this.setState({
                ...this.state,
                errors: [],
                isLoading: false,
                applicationFlags: result.data
            });
            else await this.setState({
                ...this.state,
                isLoading: false,
                errors: result.errors
            });
            return result;
        } catch (e) {
            await this.setState({
                ...this.state,
                isLoading: false,
                errors: [
                    e?.toString() ?? "Unexpected error"
                ]
            });
        }
    }
    async setLoading(isLoading) {
        await this.setState({
            ...this.state,
            isLoading: isLoading
        });
    }
}
exports.default = ApplicationFlagsContainer;

},{"@babel/runtime/helpers/defineProperty":"9sJxO","unstated":"grh7p","../../api":"loxM6","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"i9WDI":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DirtyFormPrompt", ()=>DirtyFormPrompt);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _reactRouterDom = require("react-router-dom");
var _formik = require("formik");
const DirtyFormPrompt = (props)=>{
    const prompt = (location)=>{
        if (location?.hash) return true;
        return "You have unsaved changes. Are you sure you want to leave?";
    };
    return (0, _react.jsx)((0, _formik.FormikConsumer), null, (formik)=>(0, _react.jsx)((0, _reactRouterDom.Prompt), {
            when: formik.dirty && props.allowPrompt == true,
            message: (l)=>props.promptOverride ? props.promptOverride(l) : prompt(l)
        }));
};

},{"@emotion/react":"djZKr","react":"6uln9","react-router-dom":"5fzqq","formik":"3YnOK","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"5HXc2":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _defineProperty = require("@babel/runtime/helpers/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _conversationAccessSelector = require("../../components/structure/ConversationAccessSelector");
var _conversationAccessSelectorDefault = parcelHelpers.interopDefault(_conversationAccessSelector);
var _contentItems = require("../../models/extensions/contentItems");
var _baseConversationItemForm = require("../formScenes/BaseConversationItemForm");
var _baseConversationItemFormDefault = parcelHelpers.interopDefault(_baseConversationItemForm);
class FollowUpWithRepromptForm extends (0, _baseConversationItemFormDefault.default) {
    constructor(...args){
        super(...args);
        (0, _definePropertyDefault.default)(this, "responseIdToNamesRef", {
            current: {}
        });
    }
    componentWillMount() {
        this.props.followUpContainer.clearErrors();
        this.props.repromptContainer.clearErrors();
        this.setState({
            ...this.state,
            isRelinkOpen: false
        });
    }
    componentDidUpdate(_, prev) {
        window.requestAnimationFrame(()=>{
            const id = this.state.simulatedResponseId;
            const selector = `[data-response-id="${id}"]`;
            const el = document.querySelector(selector);
            el?.scrollIntoView({
                behavior: "smooth",
                block: "start"
            });
        });
        if (this.state.simulatedResponseId != null) {
            clearTimeout(this.clearTimer);
            this.clearTimer = window.setTimeout(()=>this.setState({
                    simulatedResponseId: null
                }), 300);
        }
    }
    showError(error) {
        this.props.stateContainer.setError(error);
    }
    renderOptions(alwaysTargeted, isDisabled, neverTargeted, alwaysOpenAvailable = false) {
        return (0, _react.jsx)((0, _conversationAccessSelectorDefault.default), {
            disabled: isDisabled,
            neverTargetedAccess: neverTargeted,
            neverOpenAccess: alwaysTargeted,
            alwaysOpenAvailable: alwaysOpenAvailable,
            value: (0, _contentItems.getAccessType)(this.props.values.isLive, this.props.values.requiresParent, alwaysOpenAvailable ? this.props.values.alwaysOpen : false),
            onChange: (v)=>this.handleAccessTypeChange(v, alwaysOpenAvailable)
        });
    }
    handleAccessTypeChange(value, alwaysOpenAvailable) {
        if (value.value == "open") {
            this.props.setFieldValue("isLive", true);
            this.props.setFieldValue("requiresParent", false);
            if (alwaysOpenAvailable) this.props.setFieldValue("alwaysOpen", false);
        } else if (value.value == "targeted") {
            this.props.setFieldValue("isLive", true);
            this.props.setFieldValue("requiresParent", true);
            if (alwaysOpenAvailable) this.props.setFieldValue("alwaysOpen", false);
        } else if (value.value == "alwaysOpen") {
            this.props.setFieldValue("isLive", true);
            this.props.setFieldValue("requiresParent", false);
            this.props.setFieldValue("alwaysOpen", true);
        } else {
            this.props.setFieldValue("isLive", false);
            this.props.setFieldValue("requiresParent", false);
            if (alwaysOpenAvailable) this.props.setFieldValue("alwaysOpen", false);
        }
        this.props.onAccessTypeChange(value.value);
    }
}
exports.default = FollowUpWithRepromptForm;

},{"@babel/runtime/helpers/defineProperty":"9sJxO","@emotion/react":"djZKr","react":"6uln9","../../components/structure/ConversationAccessSelector":"1Tuto","../../models/extensions/contentItems":"5ICLt","../formScenes/BaseConversationItemForm":"akSVo","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1Tuto":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _base = require("@emotion/styled/base");
var _baseDefault = parcelHelpers.interopDefault(_base);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _colors = require("../../constants/colors");
var _toggleIndicator = require("../general/ToggleIndicator");
var _toggleIndicatorDefault = parcelHelpers.interopDefault(_toggleIndicator);
var _dropDownSelectField = require("../forms/DropDownSelectField");
var _dropDownSelectFieldDefault = parcelHelpers.interopDefault(_dropDownSelectField);
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const doorUnlocked = require("ff353536a1215261");
const targetedLock = require("d4beaf7608395d2f");
const doorLocked = require("72063a7083efafb8");
const doorUnlockedSelected = require("c48f2c0283a369e6");
const targetedLockSelected = require("eee857a7b87b2b07");
const doorLockedSelected = require("76da4bac0ccd7c7");
const options = [
    {
        value: "open",
        label: "Open",
        image: doorUnlocked,
        description: "Anyone can trigger this conversation item at any point during a session",
        selectedImage: doorUnlockedSelected
    },
    {
        value: "targeted",
        label: "Targeted Access",
        image: targetedLock,
        description: "Only accessible via a targeted follow-up from another conversation item",
        selectedImage: targetedLockSelected
    },
    {
        value: "closed",
        label: "No Access",
        image: doorLocked,
        description: "This conversation item exists within Voicify but is not meant to be hit by users",
        selectedImage: doorLockedSelected
    }
];
const alwaysOpenOption = {
    value: "alwaysOpen",
    label: "Always Open",
    image: doorUnlocked,
    description: "Always available even when context is limted but maintains prior conversation context",
    selectedImage: doorUnlockedSelected
};
const formatValueLabel = ({ label, image })=>(0, _react.jsx)(CustomSelectChosenOption, null, (0, _react.jsx)("img", {
        src: image
    }), (0, _react.jsx)("p", null, label));
const getMenuOptions = (alwaysTargeted, NeverTargeted, alwaysOpen)=>{
    let returnList = [];
    if (alwaysTargeted) returnList = options.filter((option)=>option.value == "targeted" || option.value == "closed");
    else if (NeverTargeted) returnList = options.filter((option)=>option.value == "open" || option.value == "closed");
    else returnList = options;
    if (alwaysOpen && returnList.findIndex((option)=>option.value === "alwaysOpen") == -1) returnList.push(alwaysOpenOption);
    return returnList;
};
const ConversationAccessSelector = (props)=>{
    const menuPropOptions = getMenuOptions(props.neverOpenAccess, props.neverTargetedAccess, props.alwaysOpenAvailable);
    return (0, _react.jsx)(ConversationAccessSelectorWrapper, null, (0, _react.jsx)("p", {
        className: "user-entry"
    }, "Conversation Access"), (0, _react.jsx)(CustomDropDownSelect, {
        className: "ac-access",
        clearable: false,
        searchable: false,
        valueRenderer: formatValueLabel,
        options: options,
        onChange: props.onChange,
        disabled: props.disabled,
        value: props.value,
        key: "user-entry-selector",
        arrowRenderer: (p)=>(0, _react.jsx)(Arrow, {
                direction: p.isOpen ? "up" : "down"
            }),
        menuRenderer: (menuProps)=>{
            return (0, _react.jsx)(MenuOptionsWrapper, null, (0, _react.jsx)(Triangle, null), menuPropOptions.map((option, index)=>(0, _react.jsx)(SelectOption, {
                    key: index,
                    className: "user-entry-option",
                    onClick: ()=>menuProps.selectValue(option)
                }, (0, _react.jsx)(CustomSelectOptionLabel, null, option.image ? (0, _react.jsx)(ConversationAccessIcon, {
                    src: menuProps.valueArray[0]?.value == option.value ? option.selectedImage : option.image
                }) : null, (0, _react.jsx)("div", null, (0, _react.jsx)("p", {
                    className: menuProps.valueArray[0]?.value == option.value ? "option-selected" : ""
                }, option.label), (0, _react.jsx)("p", {
                    className: menuProps.valueArray[0]?.value == option.value ? "option-description-selected" : "option-description"
                }, option.description))), index != menuProps.options.length - 1 && (0, _react.jsx)(Divider, null))));
        }
    }));
};
const Arrow = /*#__PURE__*/ (0, _baseDefault.default)((0, _toggleIndicatorDefault.default), {
    target: "e1oyc3cs9"
})({
    name: "11f9gim",
    styles: "height:8px;width:8px"
});
const ConversationAccessIcon = /*#__PURE__*/ (0, _baseDefault.default)("img", {
    target: "e1oyc3cs8"
})({
    name: "bmozya",
    styles: "height:24px;width:24px;margin-top:4px"
});
const SelectOption = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1oyc3cs7"
})("&.user-entry-option:hover{background-color:", (0, _colors.color_variants_ocean_xlight), ";cursor:pointer;}");
const MenuOptionsWrapper = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1oyc3cs6"
})({
    name: "hkh81z",
    styles: "margin-top:8px"
});
const CustomSelectChosenOption = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1oyc3cs5"
})("display:flex;flex-direction:row;padding-left:6px;p{color:", (0, _colors.color_shades_darkest), ";margin-left:10px;}img{height:24px;width:24px;margin-top:4px;}");
const Divider = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1oyc3cs4"
})("display:block;height:1px;border:0;border-top:1px solid ", (0, _colors.color_shades_dark), ";padding:0;");
const CustomSelectOptionLabel = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1oyc3cs3"
})("display:flex;flex-direction:row;padding-left:15px;padding-top:12px;padding-bottom:12px;div{line-height:normal;margin-left:10px;color:", (0, _colors.color_shades_darkest), ";}.option-selected{color:", (0, _colors.color_colors_ocean), ";}.option-description{font-size:14px;color:", (0, _colors.color_shades_darker), ";}.option-description-selected{font-size:14px;color:", (0, _colors.color_colors_ocean), ";}");
const Triangle = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1oyc3cs2"
})("transform:rotate(45deg);width:12px;height:12px;border-top:solid 1px ", (0, _colors.color_shades_dark), ";border-left:solid 1px ", (0, _colors.color_shades_dark), ";background:white;margin-top:-7px;right:15px;position:absolute;");
const ConversationAccessSelectorWrapper = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1oyc3cs1"
})("margin-top:24px;.user-entry{margin-left:16px;font-size:14px;color:", (0, _colors.color_shades_darkest), ";}");
const CustomDropDownSelect = /*#__PURE__*/ (0, _baseDefault.default)((0, _dropDownSelectFieldDefault.default), {
    target: "e1oyc3cs0"
})("margin-top:4px;.Select-multi-value-wrapper{height:48px;}.Select-menu-outer{border-top-color:", (0, _colors.color_shades_dark), ";}.Select-value{margin-top:8px;}.Select-control{border-radius:4px;}&.is-open{.Select-control{border-bottom-right-radius:4px;border-bottom-left-radius:4px;border-color:", (0, _colors.color_shades_dark), ";}}");
exports.default = ConversationAccessSelector;

},{"@emotion/styled/base":"lSuFu","@emotion/react":"djZKr","react":"6uln9","../../constants/colors":"1p3OR","../general/ToggleIndicator":"4eej1","../forms/DropDownSelectField":"kFCJA","ff353536a1215261":"2hCDL","d4beaf7608395d2f":"768wE","72063a7083efafb8":"1vDlO","c48f2c0283a369e6":"kokyD","eee857a7b87b2b07":"a8PLs","76da4bac0ccd7c7":"6UoZd","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2hCDL":[function(require,module,exports) {
module.exports = require("b22a8d48e11a036").getBundleURL("kVLro") + require("a9cf50e7efb3c3d9").resolve("dClF2");

},{"b22a8d48e11a036":"c7Tr5","a9cf50e7efb3c3d9":"fyJL2"}],"768wE":[function(require,module,exports) {
module.exports = require("f87b8037ead41929").getBundleURL("kVLro") + require("b0b3577810e60dba").resolve("fQNsS");

},{"f87b8037ead41929":"c7Tr5","b0b3577810e60dba":"fyJL2"}],"1vDlO":[function(require,module,exports) {
module.exports = require("21c4b49c52eff67f").getBundleURL("kVLro") + require("178336808b7ebe95").resolve("ip4Dz");

},{"21c4b49c52eff67f":"c7Tr5","178336808b7ebe95":"fyJL2"}],"kokyD":[function(require,module,exports) {
module.exports = require("3c8576125e696e5c").getBundleURL("kVLro") + require("52fc3d9ab3cecaf4").resolve("jPA31");

},{"3c8576125e696e5c":"c7Tr5","52fc3d9ab3cecaf4":"fyJL2"}],"a8PLs":[function(require,module,exports) {
module.exports = require("500e7dec5d5e55b8").getBundleURL("kVLro") + require("5153dab54c323b49").resolve("7mdyw");

},{"500e7dec5d5e55b8":"c7Tr5","5153dab54c323b49":"fyJL2"}],"6UoZd":[function(require,module,exports) {
module.exports = require("aa74a742403f949c").getBundleURL("kVLro") + require("c4f4cd7c4c2aedac").resolve("2V8RG");

},{"aa74a742403f949c":"c7Tr5","c4f4cd7c4c2aedac":"fyJL2"}],"5ICLt":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "contentItemTitleSort", ()=>contentItemTitleSort);
parcelHelpers.export(exports, "contentItemLanguagesSort", ()=>contentItemLanguagesSort);
parcelHelpers.export(exports, "contentItemLiveSort", ()=>contentItemLiveSort);
parcelHelpers.export(exports, "contentItemDateSort", ()=>contentItemDateSort);
parcelHelpers.export(exports, "getContentItemAccessType", ()=>getContentItemAccessType);
parcelHelpers.export(exports, "getAccessType", ()=>getAccessType);
var _moment = require("moment");
var _momentDefault = parcelHelpers.interopDefault(_moment);
const contentItemTitleSort = (a, b)=>{
    return a.title.localeCompare(b.title);
};
const contentItemLanguagesSort = (a, b)=>{
    if (a.languages.length == 0 && b.languages.length == 0) return 0;
    if (a.languages.length == 0) return 1;
    if (b.languages.length == 0) return -1;
    var aLang = a.languages[0].languageGroupCode;
    var bLang = b.languages[0].languageGroupCode;
    return aLang.localeCompare(bLang);
};
const contentItemLiveSort = (a, b)=>{
    if (a.isLive == b.isLive) return 0;
    if (a.isLive) return 1;
    if (b.isLive) return -1;
};
const contentItemDateSort = (a, b)=>{
    var aDate = (0, _momentDefault.default)(a).format("YYYYMMDD");
    var bDate = (0, _momentDefault.default)(b).format("YYYYMMDD");
    return aDate.localeCompare(bDate);
};
const getContentItemAccessType = (contentItem)=>{
    return getAccessType(contentItem.isLive, contentItem.requiresParent, false);
};
const getAccessType = (isLive, requiresParent, alwaysOpen)=>{
    if (alwaysOpen) return "alwaysOpen";
    if (isLive && !requiresParent) return "open";
    else if (isLive && requiresParent) return "targeted";
    else return "closed";
};

},{"moment":"2meyw","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"akSVo":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "HighlightSection", ()=>HighlightSection);
var _base = require("@emotion/styled/base");
var _baseDefault = parcelHelpers.interopDefault(_base);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _nestedTree = require("../../components/structure/NestedTree/NestedTree");
var _nestedTreeDefault = parcelHelpers.interopDefault(_nestedTree);
var _extensions = require("../../models/extensions");
var _confirmationDialog = require("../../components/structure/ConfirmationDialog");
var _confirmationDialogDefault = parcelHelpers.interopDefault(_confirmationDialog);
var _relinkConfirmation = require("../../components/forms/RelinkConfirmation");
var _relinkConfirmationDefault = parcelHelpers.interopDefault(_relinkConfirmation);
var _webhookInstanceManager = require("../webhookInstanceManager");
var _webhookInstanceManagerDefault = parcelHelpers.interopDefault(_webhookInstanceManager);
var _lodash = require("lodash");
var _lodashDefault = parcelHelpers.interopDefault(_lodash);
var _applicationHistoryToolbar = require("../applicationContentMenuPanel/components/ApplicationHistoryToolbar");
var _applicationHistoryToolbarDefault = parcelHelpers.interopDefault(_applicationHistoryToolbar);
var _applicationHistoryPanel = require("../applicationHistoryPanel");
var _applicationHistoryPanelDefault = parcelHelpers.interopDefault(_applicationHistoryPanel);
var _colors = require("../../constants/colors");
var _stylesValues = require("../../constants/stylesValues");
const contentInfoIcon = require("2fcea42dd4880cfd");
const titleIcon = require("53becf2a891ed161");
const langIcon = require("8c7321bd76c142e7");
const webhookIcon = require("6404bacae5c9fcfa");
const deleteIcon = require("16cb296a664d6d7d");
const duplicateIcon = require("6b4243d6d04c66fb");
const inputGroupIcon = require("81ebb8bfb20d9fb2");
const inputIcon = require("acd4fa78a93b62b");
const responseGroupIcon = require("4b52a48ee13424fe");
const mediaIcon = require("2312be898686a4f7");
const outputIcon = require("ceaac654110840ff");
const conditionalResponseIcon = require("673ee51159536148");
const decisionIcon = require("ec26ba426d606169");
const guidanceIcon = require("a33ae4aa1fdb3618");
const hintsIcon = require("478d085f563a3b7");
const destinationIcon = require("27b85016cebd74b8");
const helpIcon = require("cd83424e89d64810");
const fallbackIcon = require("440d8440208b5fef");
const repromptIcon = require("680d353ee472661b");
const followUpCardIcon = require("76f59d6360558358");
const addIcon = require("2f93d0b1405018ed");
class BaseConversationItemForm extends (0, _reactDefault.default).Component {
    componentDidMount() {
        // handle anchor link scrolling
        this.props.history?.listen((location)=>{
            const { hash } = location;
            if (hash !== "") // Push onto callback queue so it runs after the DOM is updated,
            // this is required when navigating from a different page so that
            // the element is rendered on the page before trying to getElementById.
            setTimeout(()=>{
                const id = hash.replace("#", "");
                const element = document.getElementById(id);
                if (element) {
                    const scrollable = element.closest(".scrollable-panel").children[0];
                    if (scrollable) scrollable.scrollTop = element.offsetTop - 30; // header offset values
                }
            }, 0);
        });
        this.handleTreeExpandChange(this.getAllExpandableIds(this.getMenuTreeRoots()));
    }
    toggleSensitiveConversation() {
        this.setState({
            ...this.state,
            showSensitiveConversation: !this.state.showSensitiveConversation
        });
    }
    toggleDisableForFeatureFlags() {
        this.setState({
            ...this.state,
            showDisabledForFeatureFlags: !this.state.showDisabledForFeatureFlags
        });
    }
    closeSensitiveConversation() {
        this.setState({
            ...this.state,
            showSensitiveConversation: false
        });
    }
    handleSaveAndPublish() {
        this.props.onShowPublishModal();
    }
    expandContentNavigationTree() {
        this.handleTreeExpandChange(this.getAllExpandableIds(this.getMenuTreeRoots()));
    }
    getAllExpandableIds(items) {
        const ids = [];
        items?.forEach((item)=>{
            if (item.canExpand) ids.push(item.id);
            if (item.children != null && item.children.length > 0) this.getAllExpandableIds(item.children).forEach((id)=>ids.push(id));
        });
        return ids;
    }
    handleLanguagesChange(languages) {
        this.props.setFieldValue("languages", languages);
    }
    handleTreeExpandChange(expandedIds) {
        this.setState({
            ...this.state,
            expandedTreeNodeIds: expandedIds
        });
    }
    handleTreeItemClick(item) {
        if (item.canExpand) {
            const expandedIds = this.state.expandedTreeNodeIds ?? [];
            if (expandedIds.some((id)=>id == item.id)) expandedIds.splice(expandedIds.indexOf(item.id), 1);
            else expandedIds.push(item.id);
            this.handleTreeExpandChange(expandedIds);
        }
    }
    handleFinish(url = null) {
        if (url == null) {
            if (this.props.history.location.key) //https://github.com/ReactTraining/history/issues/582
            this.props.history.goBack();
            else {
                const featureUrl = (0, _extensions.getFeatureContentUrl)(this.props.application?.id, this.props.applicationFeatureId);
                this.props.history.push(featureUrl);
            }
        } else this.props.history.push(url);
    }
    getContentInfoTreeItem() {
        return {
            id: "content-info",
            title: "Content Info",
            isExpanded: this.isItemExpanded("content-info"),
            canExpand: true,
            linkTo: "#contentInfo",
            icon: contentInfoIcon,
            children: [
                {
                    id: "title",
                    title: "Title",
                    linkTo: "#contentTitle",
                    icon: titleIcon
                },
                {
                    id: "language",
                    title: "Language-Region",
                    linkTo: "#contentLanguage",
                    icon: langIcon
                }
            ]
        };
    }
    // Generate response's unique key based on all conditions ids recursively
    getConditionsKey(conditions) {
        // builds the conditions key used for grouping responses
        const keys = [];
        (0, _lodashDefault.default).orderBy(conditions ?? [], [
            "conditionId"
        ])?.forEach((c, i)=>{
            keys.push(c.conditionId + c.value);
            if (c.andCondition) keys.push(this.getConditionsKey([
                c.andCondition
            ]));
        });
        return keys.sort().join();
    }
    // Generate responses groups array based on all responses grouped by response conditions ordered by group's priority
    // Response Group is a helpful construct generated by UI code and does not exist in back end
    getResponseGroups(responses) {
        const responseGroups = [];
        const minGroupPriority = Math.min.apply(Math, responses?.map((response)=>response.groupPriority ?? 0));
        responses?.forEach((response)=>{
            const key = this.getConditionsKey(response.conditions);
            const group = responseGroups.find((g)=>g.key == key);
            if (group) group.responses.push(response);
            else {
                // Calculate responses group priority; if response has no conditions the key will be empty
                let groupPriority = key ? responseGroups.length + 1 : 0;
                // If we already have responses group priority then use it
                groupPriority = response.groupPriority ?? groupPriority;
                // Default group should be first and have minimum group priority, let's double check
                if (!key && groupPriority != minGroupPriority) groupPriority = minGroupPriority - 1;
                const newGroup = {
                    key,
                    conditions: response.conditions,
                    responses: [
                        response
                    ],
                    firstResponse: response,
                    priority: groupPriority
                };
                responseGroups.push(newGroup);
            }
            for (const responseGroup of responseGroups)if (responseGroup?.responses?.length && responseGroup.responses.length > 1) {
                if (responseGroup?.responses[0]?.followUp) {
                    if (responseGroup?.responses?.some((r)=>!r?.followUp)) {
                        for(let i = 1; i < responseGroup?.responses.length; i++)if (!responseGroup?.responses[i]?.followUp) responseGroup.responses[i].followUp = responseGroup?.responses[0]?.followUp;
                    }
                }
            }
        });
        const responseGroupsOrdered = (0, _lodashDefault.default).orderBy(responseGroups, [
            "priority",
            "key"
        ]);
        return responseGroupsOrdered;
    }
    getResponsesFromGroups(responseGroups) {
        const responseInstances = [];
        responseGroups?.forEach((group)=>{
            responseInstances.push(...group?.responses?.map((response)=>({
                    ...response,
                    conditions: group.conditions,
                    groupPriority: group.priority
                })));
        });
        return responseInstances;
    }
    /// builds the tree of responses based on the form data
    getResponsesTreeItems(responses) {
        // Response groups are ordered by group priority and key
        const responseGroups = this.getResponseGroups(responses);
        return [
            ...responseGroups?.map((group, index)=>({
                    id: `device-response-${index}`,
                    title: group.key ? `Conditional Response ${index}` : "Default Response",
                    isExpanded: this.isItemExpanded(`device-response-${index}`),
                    canExpand: true,
                    icon: group.key ? conditionalResponseIcon : outputIcon,
                    linkTo: `#g${index}deviceResponse`,
                    children: group.key ? [
                        {
                            id: `g${index}conditions`,
                            title: "Conditions",
                            canExpand: false,
                            icon: decisionIcon,
                            linkTo: `#g${index}deviceResponse`
                        },
                        {
                            id: `g${index}response-options`,
                            title: "Response Variations",
                            canExpand: true,
                            isExpanded: this.isItemExpanded(`g${index}response-options`),
                            icon: responseGroupIcon,
                            linkTo: `#g${index}responseOptions`,
                            children: group.responses?.map((q, i)=>({
                                    id: `g${index}r${i}`,
                                    title: `Variation ${i + 1}`,
                                    canExpand: false,
                                    icon: inputIcon,
                                    linkTo: `#g${index}response${i}`,
                                    name: q?.name ?? ""
                                }))
                        },
                        {
                            id: `g${index}media`,
                            title: "Attached Media",
                            icon: mediaIcon,
                            linkTo: `#g${index}media`
                        },
                        this.getFollowUpTreeItem(index, group.firstResponse?.followUp)
                    ] : [
                        {
                            id: `g${index}response-options`,
                            title: "Response Variations",
                            canExpand: true,
                            isExpanded: this.isItemExpanded(`g${index}response-options`),
                            icon: responseGroupIcon,
                            linkTo: `#g${index}responseOptions`,
                            children: group.responses?.map((q, i)=>({
                                    id: `g${index}r${i}`,
                                    title: `Variation ${i + 1}`,
                                    canExpand: false,
                                    icon: inputIcon,
                                    linkTo: `#g${index}response${i}`
                                }))
                        },
                        {
                            id: `g${index}media`,
                            title: "Attached Media",
                            icon: mediaIcon,
                            linkTo: `#g${index}media`
                        },
                        this.getFollowUpTreeItem(index, group.firstResponse?.followUp)
                    ]
                })),
            {
                id: "add-conditional-response",
                title: "Add a Conditional Response",
                linkTo: "#addConditionalResponse",
                canExpand: false,
                icon: addIcon
            }
        ];
    }
    getFollowUpTreeItem(groupIndex, followUp) {
        const children = [];
        if (followUp) {
            children.push({
                id: `g${groupIndex}guidance`,
                title: "Guidance",
                icon: guidanceIcon,
                linkTo: `#g${groupIndex}guidance`,
                canExpand: false
            });
            if (followUp?.childContentContainer) children.push({
                id: `g${groupIndex}destination`,
                title: "Destination",
                icon: destinationIcon,
                linkTo: `#g${groupIndex}destination`,
                canExpand: false
            });
            children.push({
                id: `g${groupIndex}on-screen-hint`,
                title: "On-screen Hint",
                icon: hintsIcon,
                linkTo: `#g${groupIndex}on-screen-hint`,
                canExpand: false
            });
            if (followUp.childContentContainer?.isLimitedToChildren) {
                children.push({
                    id: `g${groupIndex}contextualFallback`,
                    title: "Contextual Fallback",
                    icon: fallbackIcon,
                    linkTo: `#g${groupIndex}contextualFallback`,
                    canExpand: false
                });
                children.push({
                    id: `g${groupIndex}contextualHelp`,
                    title: "Contextual Help",
                    icon: helpIcon,
                    linkTo: `#g${groupIndex}contextualHelp`,
                    canExpand: false
                });
            }
            children.push({
                id: `g${groupIndex}reprompt`,
                title: "Reprompt",
                icon: repromptIcon,
                linkTo: `#g${groupIndex}reprompt`,
                canExpand: false
            });
        }
        const treeItem = {
            id: `g${groupIndex}follow-up`,
            title: "Follow-Up",
            icon: followUpCardIcon,
            canExpand: children.length > 0,
            isExpanded: this.isItemExpanded(`g${groupIndex}follow-up`),
            linkTo: `#g${groupIndex}followUp`,
            children: children
        };
        return treeItem;
    }
    isItemExpanded(id) {
        return this.state?.expandedTreeNodeIds?.some((i)=>i == id);
    }
    renderTree() {
        const contentId = this.getContentItem()?.id;
        if (!contentId) return this.getMenuTreeRoots()?.map((t, i)=>(0, _react.jsx)((0, _nestedTreeDefault.default), {
                key: i,
                root: t,
                onItemClick: this.handleTreeItemClick.bind(this)
            }));
        return (0, _react.jsx)((0, _reactDefault.default).Fragment, null, (0, _react.jsx)((0, _applicationHistoryToolbarDefault.default), {
            onToggle: ()=>this.setState({
                    ...this.state,
                    isHistoryExpanded: !this.state?.isHistoryExpanded
                }),
            isExpanded: this.state?.isHistoryExpanded
        }), this.state?.isHistoryExpanded ? (0, _react.jsx)("div", {
            className: "tree-container"
        }, (0, _react.jsx)((0, _applicationHistoryPanelDefault.default), {
            contentId: contentId,
            contentItemContainer: this.props.stateContainer,
            applicationId: this.props.application?.id,
            onClose: ()=>this.setState({
                    ...this.state,
                    isHistoryExpanded: false
                })
        })) : this.getMenuTreeRoots()?.map((t, i)=>(0, _react.jsx)((0, _nestedTreeDefault.default), {
                key: i,
                root: t,
                onItemClick: this.handleTreeItemClick.bind(this)
            })));
    }
    manualValidate() {
        var isValid = Object.keys(this.props.errors).length == 0; //In Formik 1.x isValid is not true by default, and so some forms validated against initialValues would have isValid=false. See https://github.com/ReactTraining/history/issues/582
        if (!isValid) this.props.stateContainer?.setError("You have incomplete required fields.");
        return isValid;
    }
    handleToggleRelinkModal() {
        this.setState({
            ...this.state,
            isRelinkOpen: !this.state?.isRelinkOpen
        });
    }
    handleRelink() {
        this.props.onToggleSync(this.getContentItem()?.id, false).then((_)=>{
            this.setState({
                ...this.state,
                isRelinkOpen: false
            });
        });
    }
    renderRelinkSyncWarning() {
        if (this.state?.isRelinkOpen) return (0, _react.jsx)((0, _confirmationDialogDefault.default), {
            title: "Re-Link to Template",
            deleteText: "Re-Link",
            isLoading: this.props.stateContainer.state.isTogglingSync,
            onClose: this.handleToggleRelinkModal.bind(this),
            warning: true,
            onConfirm: this.handleRelink.bind(this)
        }, (0, _react.jsx)((0, _relinkConfirmationDefault.default), null));
        return null;
    }
    closeWebhookInstanceManager() {
        this.setState({
            ...this.state,
            isWebhookInstanceManagerOpen: false
        });
    }
    showWebhookInstanceManager() {
        this.setState({
            ...this.state,
            isWebhookInstanceManagerOpen: true
        });
    }
    stageWebhookUpdates(updateRequest) {
        this.props.stateContainer.stageWebhookUpdates(updateRequest);
        this.props.setFieldValue("webhookChainingType", updateRequest.webhookChainingType);
    }
    getOptions(isEditing) {
        let overflowOptions = [
            {
                icon: webhookIcon,
                hoverIcon: webhookIcon,
                label: "Manage Webhooks"
            }
        ];
        if (isEditing) {
            overflowOptions.push({
                label: "Duplicate",
                icon: duplicateIcon,
                hoverIcon: duplicateIcon
            });
            overflowOptions.push({
                label: "Delete",
                isDestructive: true,
                icon: deleteIcon,
                hoverIcon: deleteIcon
            });
        }
        return overflowOptions;
    }
    getPreviewResponses(responses) {
        // Response groups are ordered by group priority and key
        const responseGroups = this.getResponseGroups(responses);
        return responseGroups.map((group, index)=>({
                responseTitle: group.key ? `Conditional Response ${index}` : "Default Response",
                followUp: group.firstResponse?.followUp,
                reprompt: group.firstResponse?.reprompt,
                responses: group.responses.map((response)=>({
                        content: response.content,
                        highlights: [
                            response.content
                        ],
                        id: response.content,
                        mediaResponseContainer: response.mediaResponseContainer,
                        displayTextOverride: response.displayTextOverride,
                        displayTitleOverride: response.displayTitleOverride,
                        audioItem: response.audio,
                        videoItem: response.video,
                        imageItem: response.largeImage,
                        backgroundImageItem: response.backgroundImage
                    }))
            }));
    }
    renderWebhookInstanceManager(appId, contentItemId, featureTypeId, webhookChainingType) {
        return (0, _react.jsx)((0, _webhookInstanceManagerDefault.default), {
            show: this?.state?.isWebhookInstanceManagerOpen,
            webhookContainerId: contentItemId ?? "",
            shouldNotLoad: contentItemId == null || this.props.stateContainer.state.hasWebhookUpdate,
            stagedUpdate: this.props.stateContainer.state.hasWebhookUpdate ? this.props.stateContainer.state.webhookUpdates : null,
            featureTypeId: featureTypeId,
            applicationId: appId,
            webhookInstanceScope: "Content",
            existingWebhookChainingType: webhookChainingType,
            onClose: this.closeWebhookInstanceManager.bind(this),
            manualSave: this.stageWebhookUpdates.bind(this)
        });
    }
    handleClearError() {
        this.props.stateContainer?.clearErrors();
    }
}
const HighlightSection = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1bgwh510"
})("padding:32px 32px 0 32px;margin:-32px -32px 32px -32px;background:", (0, _colors.color_variants_ocean_light_opaque), ";border-bottom:", (0, _stylesValues.style_border_default), ";");
exports.default = BaseConversationItemForm;

},{"@emotion/styled/base":"lSuFu","@emotion/react":"djZKr","react":"6uln9","../../components/structure/NestedTree/NestedTree":"fhYq0","../../models/extensions":"7h01B","../../components/structure/ConfirmationDialog":"kx7yK","../../components/forms/RelinkConfirmation":"5xG2f","../webhookInstanceManager":"1EIek","lodash":"3hMBK","../applicationContentMenuPanel/components/ApplicationHistoryToolbar":"5SuoU","../applicationHistoryPanel":"aqO4p","../../constants/colors":"1p3OR","../../constants/stylesValues":"dHVVv","2fcea42dd4880cfd":"fKr4T","53becf2a891ed161":"4Yzsw","8c7321bd76c142e7":"k7cZ6","6404bacae5c9fcfa":"e6PIG","16cb296a664d6d7d":"bG6Op","6b4243d6d04c66fb":"1S0DP","81ebb8bfb20d9fb2":"a8FLc","acd4fa78a93b62b":"iZ56c","4b52a48ee13424fe":"erpXi","2312be898686a4f7":"igpX4","ceaac654110840ff":"e3D4F","673ee51159536148":"5MQWD","ec26ba426d606169":"2iYkb","a33ae4aa1fdb3618":"ICQyO","478d085f563a3b7":"fE99M","27b85016cebd74b8":"3vnDf","cd83424e89d64810":"59An8","440d8440208b5fef":"lruiJ","680d353ee472661b":"eqeII","76f59d6360558358":"iy1lb","2f93d0b1405018ed":"6cI2N","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"fhYq0":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _colors = require("../../../constants/colors");
var _reactRouterDom = require("react-router-dom");
var _toggleIndicator = require("../../general/ToggleIndicator");
var _toggleIndicatorDefault = parcelHelpers.interopDefault(_toggleIndicator);
const loadingIcon = require("301c368d9076d267");
const ghostIcon = require("f188283967867387");
const getImage = (root)=>{
    if (root.isLoadingChildren) return loadingIcon;
    if (root.isExpanded) return root.expandedIcon ?? root.icon;
    return root.icon;
};
const getExpandedView = (props, level)=>{
    if (props.root?.isExpanded) {
        if (props.root?.children?.length === 0) {
            if (props.root?.isLoadingChildren) // node is expanded, but nothing is loaded yet and we're loading. Show nothing
            return null;
            else // node is expanded, nothing is loaded in and we're not loading. Show the no content item.
            return (0, _react.jsx)("div", {
                className: `${noContentStyle} ${getPaddingCssForLevel(level + 1, 22)}`
            }, (0, _react.jsx)("img", {
                src: ghostIcon
            }), " ", props.emptyText ?? "No Content Found Here");
        }
        // we're expanded and we have content to render. 
        return (0, _react.jsx)("div", {
            className: "tree-item-container"
        }, props.root?.children?.map((c)=>(0, _react.jsx)(NestedTree, {
                emptyText: props.emptyText,
                isRootHidden: false,
                level: level + 1,
                key: c.id,
                root: c,
                onItemClick: props.onItemClick
            })));
    }
    // the node isn't expanded render nothing. 
    return null;
};
const getPaddingCssForLevel = (level, extra)=>{
    const extraPadding = extra ?? 0;
    return /*#__PURE__*/ (0, _css.css)("padding-left:", level * 16 + extraPadding, "px;", "");
};
const NestedTree = (props)=>{
    const level = props.isRootHidden === true ? -1 : props.level ?? 0;
    return (0, _react.jsx)("div", {
        className: `${containerStyle}${props.root.isHighlighted ? " highlighted" : ""}${props.isRootHidden === true ? " root-hidden" : ""}`
    }, !props.isRootHidden && (0, _react.jsx)("div", {
        className: `${getPaddingCssForLevel(level, props.root?.canExpand ? 8 : 14)} tree-item-title ${props.root?.canExpand ? "expandable" : ""}`,
        onClick: ()=>props.onItemClick(props.root)
    }, props.root?.canExpand && (0, _react.jsx)((0, _toggleIndicatorDefault.default), {
        type: "triangle",
        direction: props.root.isExpanded ? "down" : "right"
    }), (0, _react.jsx)("img", {
        className: props.root.isLoadingChildren ? "rotating" : undefined,
        src: getImage(props.root)
    }), props.root.linkTo ? (0, _react.jsx)((0, _reactRouterDom.Link), {
        to: props.root.linkTo
    }, props.root?.title) : (0, _react.jsx)("p", null, props.root?.title)), getExpandedView(props, level));
};
const noContentStyle = /*#__PURE__*/ (0, _css.css)("display:flex;flex-direction:row;font-family:Muli;font-style:italic;font-weight:normal;font-size:14px;line-height:20px;color:", (0, _colors.color_text_light), ";padding-top:8px;padding-bottom:8px;img{margin-right:8px;}", "");
const containerStyle = /*#__PURE__*/ (0, _css.css)(".tree-item-title{display:flex;align-items:center;cursor:pointer;height:32px;img{margin:0 8px;height:16px;width:16px;min-height:16px;min-width:16px;}p,a{white-space:nowrap;overflow:hidden;text-overflow:ellipsis;}.rotating{-webkit-animation:spin 1s linear infinite;-moz-animation:spin 1s linear infinite;animation:spin 1s linear infinite;@-moz-keyframes spin{100%{-moz-transform:rotate(-360deg);}}@-webkit-keyframes spin{100%{-webkit-transform:rotate(-360deg);}}@keyframes spin{100%{-webkit-transform:rotate(-360deg);transform:rotate(-360deg);}}}}a,p{color:", (0, _colors.color_shades_darkest), ";}&.highlighted{>.tree-item-title{background:", (0, _colors.color_variants_ocean_light_1), ";}>.tree-item-container{background:", (0, _colors.color_variants_ocean_xlight), ";}}&.root-hidden{padding-left:0xp;>.tree-item-container{padding-left:0px;}}", "");
exports.default = NestedTree;

},{"@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","../../../constants/colors":"1p3OR","react-router-dom":"5fzqq","../../general/ToggleIndicator":"4eej1","301c368d9076d267":"cs7NF","f188283967867387":"98yKe","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"cs7NF":[function(require,module,exports) {
module.exports = require("c4659b4b4ba49116").getBundleURL("kVLro") + require("c02fdc9bf6e906e7").resolve("dYdrs");

},{"c4659b4b4ba49116":"c7Tr5","c02fdc9bf6e906e7":"fyJL2"}],"98yKe":[function(require,module,exports) {
module.exports = require("cfa2efd1f8e5d1d").getBundleURL("kVLro") + require("1539c2af71a11926").resolve("gXeCP");

},{"cfa2efd1f8e5d1d":"c7Tr5","1539c2af71a11926":"fyJL2"}],"5xG2f":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _colors = require("../../constants/colors");
const bombIcon = require("fc11ae3e3f7802fc");
const RelinkConfirmation = ()=>(0, _react.jsx)("div", {
        className: containerStyle
    }, (0, _react.jsx)("img", {
        src: bombIcon
    }), (0, _react.jsx)("p", null, "Restoring the link to the template will remove any changes or customizations you have made. Making edits to this content will then be managed from the template."));
const containerStyle = /*#__PURE__*/ (0, _css.css)("display:flex;flex-direction:column;align-items:center;justify-content:center;margin:64px;img{width:82px;height:82px;margin-bottom:32px;}p{font-family:Muli;font-size:18px;font-weight:normal;font-style:normal;font-stretch:normal;line-height:normal;letter-spacing:0.5px;text-align:center;color:", (0, _colors.dark_grey_blue), ";}", "");
exports.default = RelinkConfirmation;

},{"@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","../../constants/colors":"1p3OR","fc11ae3e3f7802fc":"4UkG2","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1EIek":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _extends = require("@babel/runtime/helpers/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _organizationContainer = require("../../state/containers/OrganizationContainer");
var _organizationContainerDefault = parcelHelpers.interopDefault(_organizationContainer);
var _unstated = require("unstated");
var _webhookContainer = require("../../state/containers/WebhookContainer");
var _webhookContainerDefault = parcelHelpers.interopDefault(_webhookContainer);
var _featureWebhookContainer = require("../../state/containers/FeatureWebhookContainer");
var _featureWebhookContainerDefault = parcelHelpers.interopDefault(_featureWebhookContainer);
var _questionAnswerContainer = require("../../state/containers/QuestionAnswerContainer");
var _questionAnswerContainerDefault = parcelHelpers.interopDefault(_questionAnswerContainer);
var _customRequestContainer = require("../../state/containers/CustomRequestContainer");
var _customRequestContainerDefault = parcelHelpers.interopDefault(_customRequestContainer);
var _exitMessageContainer = require("../../state/containers/ExitMessageContainer");
var _exitMessageContainerDefault = parcelHelpers.interopDefault(_exitMessageContainer);
var _fallbackMessageContainer = require("../../state/containers/FallbackMessageContainer");
var _fallbackMessageContainerDefault = parcelHelpers.interopDefault(_fallbackMessageContainer);
var _helpMessageContainer = require("../../state/containers/HelpMessageContainer");
var _helpMessageContainerDefault = parcelHelpers.interopDefault(_helpMessageContainer);
var _latestMessageContainer = require("../../state/containers/LatestMessageContainer");
var _latestMessageContainerDefault = parcelHelpers.interopDefault(_latestMessageContainer);
var _numberRangeContainer = require("../../state/containers/NumberRangeContainer");
var _numberRangeContainerDefault = parcelHelpers.interopDefault(_numberRangeContainer);
var _simpleChoiceContainer = require("../../state/containers/SimpleChoiceContainer");
var _simpleChoiceContainerDefault = parcelHelpers.interopDefault(_simpleChoiceContainer);
var _welcomeMessageContainer = require("../../state/containers/WelcomeMessageContainer");
var _welcomeMessageContainerDefault = parcelHelpers.interopDefault(_welcomeMessageContainer);
var _webhookInstanceFormParent = require("./components/WebhookInstanceFormParent");
var _webhookInstanceFormParentDefault = parcelHelpers.interopDefault(_webhookInstanceFormParent);
class WebhookInstanceManager extends (0, _reactDefault.default).Component {
    render() {
        return (0, _react.jsx)((0, _unstated.Subscribe), {
            to: [
                (0, _webhookContainerDefault.default),
                (0, _featureWebhookContainerDefault.default),
                (0, _questionAnswerContainerDefault.default),
                (0, _customRequestContainerDefault.default),
                (0, _exitMessageContainerDefault.default),
                (0, _fallbackMessageContainerDefault.default),
                (0, _helpMessageContainerDefault.default),
                (0, _latestMessageContainerDefault.default),
                (0, _numberRangeContainerDefault.default),
                (0, _simpleChoiceContainerDefault.default),
                (0, _organizationContainerDefault.default),
                (0, _welcomeMessageContainerDefault.default)
            ]
        }, (webhookContainer, featureWebhookContainer, questionAnswerContainer, customRequestContainer, exitMessageContainer, fallbackMessageContainer, helpMessageContainer, latestMessageContainer, numberRangeContainer, simpleChoiceContainer, organizationContainer, welcomeMessageContainer)=>{
            return (0, _react.jsx)((0, _webhookInstanceFormParentDefault.default), (0, _extendsDefault.default)({}, this.props, {
                webhookContainer: webhookContainer,
                featureWebhookContainer: featureWebhookContainer,
                questionAnswerContainer: questionAnswerContainer,
                customRequestContainer: customRequestContainer,
                exitMessageContainer: exitMessageContainer,
                fallbackMessageContainer: fallbackMessageContainer,
                helpMessageContainer: helpMessageContainer,
                organizationContainer: organizationContainer,
                latestMessageContainer: latestMessageContainer,
                numberRangeContainer: numberRangeContainer,
                simpleChoiceContainer: simpleChoiceContainer,
                welcomeMessageContainer: welcomeMessageContainer
            }));
        });
    }
}
exports.default = WebhookInstanceManager;

},{"@babel/runtime/helpers/extends":"4iKIP","@emotion/react":"djZKr","react":"6uln9","../../state/containers/OrganizationContainer":"dlbaM","unstated":"grh7p","../../state/containers/WebhookContainer":"4VCcR","../../state/containers/FeatureWebhookContainer":"hq0ej","../../state/containers/QuestionAnswerContainer":"hfasy","../../state/containers/CustomRequestContainer":"aVO05","../../state/containers/ExitMessageContainer":"lSKl8","../../state/containers/FallbackMessageContainer":"kKZMo","../../state/containers/HelpMessageContainer":"2oQaX","../../state/containers/LatestMessageContainer":"1Hdqb","../../state/containers/NumberRangeContainer":"an6iC","../../state/containers/SimpleChoiceContainer":"hO0x5","../../state/containers/WelcomeMessageContainer":"j3orW","./components/WebhookInstanceFormParent":"awGxI","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4VCcR":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _defineProperty = require("@babel/runtime/helpers/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _unstated = require("unstated");
var _api = require("../../api");
var _lodash = require("lodash");
var _lodashDefault = parcelHelpers.interopDefault(_lodash);
class WebhookContainer extends (0, _unstated.Container) {
    constructor(...args){
        super(...args);
        (0, _definePropertyDefault.default)(this, "state", {
            isLoading: false,
            isUpdating: false,
            webhooks: [],
            organizationWebhooks: [],
            webhookTypes: [],
            applicationWebhookInstances: [],
            webhookAttachments: [],
            errors: [],
            webhookSensitiveData: {}
        });
    }
    async clearErrors() {
        await this.setState({
            ...this.state,
            errors: []
        });
    }
    async updateFullWebhook(model) {
        try {
            await this.setState({
                ...this.state,
                isLoading: true
            });
            const result = await _api.updateFullWebhook(model.id, model);
            if (result.resultType == "Ok") {
                const idx = this.state.webhooks.findIndex((wf)=>wf.id == model.id);
                const newWebhooks = [
                    ...this.state.webhooks
                ];
                newWebhooks[idx] = model;
                await this.setState({
                    ...this.state,
                    isLoading: false,
                    webhooks: newWebhooks
                });
            } else await this.setState({
                ...this.state,
                isLoading: false,
                errors: result.errors
            });
        } catch (error) {
            return {
                resultType: "InternalError",
                data: null,
                errors: [
                    error
                ]
            };
        }
    }
    async createFullWebhook(model) {
        try {
            await this.setState({
                ...this.state,
                isLoading: true
            });
            const result = await _api.createFullWebhook(model);
            if (result.resultType == "Ok") {
                const newWebhooks = [
                    ...this.state.webhooks,
                    result.data
                ];
                await this.setState({
                    ...this.state,
                    isLoading: false,
                    webhooks: newWebhooks
                });
            } else await this.setState({
                ...this.state,
                isLoading: false,
                errors: result.errors
            });
        } catch (error) {
            return {
                resultType: "InternalError",
                data: null,
                errors: [
                    error
                ]
            };
        }
    }
    getWebhooksForOrganization(organizationId) {
        this.setLoading(true);
        const promise = _api.getWebhooksForOrg(organizationId);
        promise.then((result)=>{
            if (result.resultType == "Ok") this.setState({
                ...this.state,
                isLoading: false,
                errors: [],
                organizationWebhooks: result.data
            });
            else this.setState({
                ...this.state,
                isLoading: false,
                errors: result.errors
            });
        }).catch((error)=>{
            this.setState({
                ...this.state,
                isLoading: false,
                errors: [
                    error
                ]
            });
        });
        return promise;
    }
    getWebhookAttachmentsForApplication(applicationId) {
        const promise = _api.getWebhookAttachmentsForApplication(applicationId);
        promise.then((result)=>{
            if (result.resultType == "Ok") this.setState({
                ...this.state,
                errors: [],
                webhookAttachments: result.data
            });
            else this.setState({
                ...this.state,
                errors: result.errors
            });
        }).catch((error)=>{
            this.setState({
                ...this.state,
                errors: [
                    error
                ]
            });
        });
        return promise;
    }
    getAttachedWebhooksCount(webhookContainerId) {
        let count = 0;
        (this.state.webhookAttachments ?? []).forEach((wa)=>{
            (wa.applicationFeatureIds ?? []).forEach((id)=>{
                if (id == webhookContainerId) count++;
            });
            (wa.applicationIds ?? []).forEach((id)=>{
                if (id == webhookContainerId) count++;
            });
            (wa.customRequestIds ?? []).forEach((id)=>{
                if (id == webhookContainerId) count++;
            });
            (wa.questionAnswerIds ?? []).forEach((id)=>{
                if (id == webhookContainerId) count++;
            });
            (wa.numberRangeIds ?? []).forEach((id)=>{
                if (id == webhookContainerId) count++;
            });
            (wa.simpleChoiceIds ?? []).forEach((id)=>{
                if (id == webhookContainerId) count++;
            });
            (wa.welcomeMessageIds ?? []).forEach((id)=>{
                if (id == webhookContainerId) count++;
            });
            (wa.exitMessageIds ?? []).forEach((id)=>{
                if (id == webhookContainerId) count++;
            });
            (wa.latestMessageIds ?? []).forEach((id)=>{
                if (id == webhookContainerId) count++;
            });
            (wa.helpMessageIds ?? []).forEach((id)=>{
                if (id == webhookContainerId) count++;
            });
            (wa.fallbackMessageIds ?? []).forEach((id)=>{
                if (id == webhookContainerId) count++;
            });
        });
        return count;
    }
    getWebhooksForApplication(applicationId) {
        this.setLoading(true);
        const promise = _api.getWebhooksForApp(applicationId);
        promise.then((result)=>{
            if (result.resultType == "Ok") this.setState({
                ...this.state,
                isLoading: false,
                errors: [],
                webhooks: result.data
            });
            else this.setState({
                ...this.state,
                isLoading: false,
                errors: result.errors
            });
        }).catch((error)=>{
            this.setState({
                ...this.state,
                isLoading: false,
                errors: [
                    error
                ]
            });
        });
        return promise;
    }
    async getApplicationWebhookInstances(applicationId) {
        try {
            this.setLoading(true);
            const result = await _api.getApplicationWebhookInstances(applicationId);
            if (result.resultType == "Ok") await this.setState({
                ...this.state,
                isLoading: false,
                errors: [],
                applicationWebhookInstances: result.data
            });
            else await this.setState({
                ...this.state,
                isLoading: false,
                errors: result.errors
            });
            return result;
        } catch (error) {
            return {
                resultType: "InternalError",
                data: null,
                errors: [
                    error
                ]
            };
        }
    }
    addOrUpdateApplicationWebhook(id, webhook, defaultParameters, userDefinedParameters) {
        this.setState({
            ...this.state,
            isUpdating: true
        });
        let promise = webhook.instanceId == null ? _api.addApplicationWebhook(id, webhook.id, defaultParameters, userDefinedParameters) : _api.updateApplicationWebhook(id, webhook.instanceId, defaultParameters, userDefinedParameters);
        promise.then((result)=>{
            if (result.resultType == "Ok") {
                const webhooks = [
                    ...this.state.applicationWebhookInstances
                ];
                const model = result.data;
                const existing = webhooks.find((w)=>w.id === model.id);
                if (existing == null) webhooks.push(model);
                else {
                    const idx = webhooks.indexOf(existing);
                    webhooks.splice(idx, 1, model);
                }
                this.setState({
                    ...this.state,
                    isUpdating: false,
                    errors: [],
                    applicationWebhookInstances: webhooks
                });
            } else this.setState({
                ...this.state,
                isUpdating: false,
                errors: result.errors
            });
        }).catch((error)=>{
            this.setState({
                ...this.state,
                isUpdating: false,
                errors: [
                    error
                ]
            });
        });
        return promise;
    }
    async bulkUpdateApplicationWebhookInstances(applicationId, updateRequest) {
        try {
            await this.setState({
                ...this.state,
                isUpdating: true
            });
            var result = await _api.bulkUpdateApplicationWebhookInstances(applicationId, updateRequest);
            if (result.resultType == "Ok") await this.setState({
                ...this.state,
                isUpdating: false,
                applicationWebhookInstances: result.data,
                errors: []
            });
            else await this.setState({
                ...this.state,
                isUpdating: false,
                errors: result.errors
            });
            return result;
        } catch (error) {
            return {
                resultType: "InternalError",
                data: null,
                errors: [
                    error
                ]
            };
        }
    }
    createWebhook(organizationId, model) {
        this.setState({
            ...this.state,
            isUpdating: true
        });
        const promise = _api.createWebhook(organizationId, model);
        promise.then((result)=>{
            if (result.resultType == "Ok") {
                const webhooks = this.state.webhooks;
                webhooks.push(result.data);
                this.setState({
                    ...this.state,
                    isUpdating: false,
                    errors: [],
                    webhooks: webhooks
                });
            } else this.setState({
                ...this.state,
                isUpdating: false,
                errors: result.errors
            });
        }).catch((error)=>{
            this.setState({
                ...this.state,
                isUpdating: false,
                errors: [
                    error
                ]
            });
        });
        return promise;
    }
    removeApplicationWebhook(applicationWebhookId) {
        this.setState({
            ...this.state,
            isUpdating: true
        });
        const promise = _api.removeApplicationWebhook(applicationWebhookId);
        promise.then((result)=>{
            if (result.resultType == "Ok") {
                var webhooks = this.state.applicationWebhookInstances;
                (0, _lodashDefault.default).remove(webhooks, (w)=>w.id == applicationWebhookId);
                this.setState({
                    ...this.state,
                    isUpdating: false,
                    errors: [],
                    applicationWebhookInstances: webhooks
                });
            } else this.setState({
                ...this.state,
                isUpdating: false,
                errors: result.errors
            });
        }).catch((error)=>{
            this.setState({
                ...this.state,
                isUpdating: false,
                errors: [
                    error
                ]
            });
        });
        return promise;
    }
    updateWebhook(webhookId, model) {
        this.setState({
            ...this.state,
            isUpdating: true
        });
        const promise = _api.updateWebhook(webhookId, model);
        promise.then((result)=>{
            if (result.resultType == "Ok") {
                const webhooks = this.state.webhooks;
                // find webhook
                const webhook = webhooks.find((w)=>w.id == webhookId);
                webhooks[webhooks.indexOf(webhook)] = result.data;
                this.setState({
                    ...this.state,
                    isUpdating: false,
                    errors: [],
                    webhooks: webhooks
                });
            } else this.setState({
                ...this.state,
                isUpdating: false,
                errors: result.errors
            });
        }).catch((error)=>{
            this.setState({
                ...this.state,
                isUpdating: false,
                errors: [
                    error
                ]
            });
        });
        return promise;
    }
    removeOrganizationWebhook(webhookId) {
        this.setState({
            ...this.state,
            isUpdating: true
        });
        return _api.removeOrganizationWebhook(webhookId).then((res)=>{
            if (res.resultType == "Ok") {
                const webhooks = this.state.webhooks;
                const webhook = webhooks.find((w)=>w ? w.id == webhookId : false);
                delete webhooks[webhooks.indexOf(webhook)];
                this.setState({
                    ...this.state,
                    isUpdating: false,
                    webhooks
                });
            } else this.setState({
                ...this.state,
                isUpdating: false,
                errors: res.errors
            });
        }).catch((err)=>{
            this.setState({
                ...this.state,
                isUpdating: false,
                errors: [
                    err
                ]
            });
        });
    }
    getWebhookTypes() {
        if (this.state.webhookTypes == null || this.state.webhookTypes.length == 0) {
            this.setLoading(true);
            const promise = _api.getWebhookTypes();
            promise.then((result)=>{
                if (result.resultType == "Ok") this.setState({
                    ...this.state,
                    isLoading: false,
                    errors: [],
                    webhookTypes: result.data
                });
                else this.setState({
                    ...this.state,
                    isLoading: false,
                    errors: result.errors
                });
            }).catch((error)=>{
                this.setState({
                    ...this.state,
                    isLoading: false,
                    errors: [
                        error
                    ]
                });
            });
            return promise;
        }
    }
    async generateSensitiveDataKey(webhookId) {
        try {
            await this.setState({
                ...this.state,
                isLoading: true
            });
            const result = await _api.generateSensitiveDataKey(webhookId);
            if (result.resultType == "Ok") {
                const idx = this.state.webhooks.findIndex((wf)=>wf.id == webhookId);
                const webhook = this.state.webhooks[idx];
                webhook.hasSensitiveDataKey = true;
                await this.setState({
                    ...this.state,
                    isLoading: false,
                    webhookSensitiveData: result.data
                });
            } else await this.setState({
                ...this.state,
                isLoading: false,
                errors: result.errors
            });
        } catch (error) {
            return {
                resultType: "InternalError",
                data: null,
                errors: [
                    error
                ]
            };
        }
    }
    async removeSensitiveDataKey(webhookId) {
        this.setState({
            ...this.state,
            isUpdating: true
        });
        try {
            const res = await _api.removeSensitiveDataKey(webhookId);
            if (res.resultType == "Ok") {
                const webhooks = this.state.webhooks;
                const webhook = webhooks.find((w)=>w ? w.id == webhookId : false);
                webhook.hasSensitiveDataKey = false;
                this.setState({
                    ...this.state,
                    isUpdating: false,
                    webhooks
                });
            } else this.setState({
                ...this.state,
                isUpdating: false,
                errors: res.errors
            });
        } catch (err) {
            this.setState({
                ...this.state,
                isUpdating: false,
                errors: [
                    err
                ]
            });
        }
    }
    setLoading(isLoading) {
        this.setState({
            ...this.state,
            isLoading
        });
    }
}
exports.default = WebhookContainer;

},{"@babel/runtime/helpers/defineProperty":"9sJxO","unstated":"grh7p","../../api":"loxM6","lodash":"3hMBK","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hq0ej":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _defineProperty = require("@babel/runtime/helpers/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _unstated = require("unstated");
var _api = require("../../api");
var _lodash = require("lodash");
var _lodashDefault = parcelHelpers.interopDefault(_lodash);
class FeatureWebhookContainer extends (0, _unstated.Container) {
    constructor(...args){
        super(...args);
        (0, _definePropertyDefault.default)(this, "state", {
            isLoading: false,
            isUpdating: false,
            webhooks: [],
            webhookTypes: [],
            applicationFeatureWebhooks: [],
            errors: []
        });
    }
    getApplicationFeatureWebhooks(applicationFeatureId) {
        this.setLoading(true);
        const promise = _api.getApplicationFeatureWebhooks(applicationFeatureId);
        promise.then((result)=>{
            if (result.resultType == "Ok") this.setState({
                ...this.state,
                isLoading: false,
                errors: [],
                applicationFeatureWebhooks: result.data
            });
            else this.setState({
                ...this.state,
                isLoading: false,
                errors: result.errors
            });
        }).catch((error)=>{
            this.setState({
                ...this.state,
                isLoading: false,
                errors: [
                    error
                ]
            });
        });
        return promise;
    }
    addApplicationFeatureWebhook(id, webhook, defaultParameters, userDefinedParameters) {
        this.setState({
            ...this.state,
            isUpdating: true
        });
        let promise = webhook.instanceId == null ? _api.addApplicationFeatureWebhook(id, webhook.id, defaultParameters, userDefinedParameters) : _api.updateApplicationFeatureWebhook(id, webhook.instanceId, defaultParameters, userDefinedParameters);
        promise.then((result)=>{
            if (result.resultType == "Ok") {
                const webhooks = [
                    ...this.state.applicationFeatureWebhooks
                ];
                const model = result.data;
                const existing = webhooks.find((w)=>w.id === model.id);
                if (existing == null) webhooks.push(model);
                else {
                    const idx = webhooks.indexOf(existing);
                    webhooks.splice(idx, 1, model);
                }
                this.setState({
                    ...this.state,
                    isUpdating: false,
                    errors: [],
                    applicationFeatureWebhooks: webhooks
                });
            } else this.setState({
                ...this.state,
                isUpdating: false,
                errors: result.errors
            });
        }).catch((error)=>{
            this.setState({
                ...this.state,
                isUpdating: false,
                errors: [
                    error
                ]
            });
        });
        return promise;
    }
    async bulkUpdateFeatureWebhookInstances(appFeatureId, updateRequest) {
        try {
            this.setState({
                ...this.state,
                isUpdating: true
            });
            var result = await _api.bulkUpdateFeatureWebhookInstances(appFeatureId, updateRequest);
            if (result.resultType == "Ok") this.setState({
                ...this.state,
                isUpdating: false,
                applicationFeatureWebhooks: result.data,
                errors: []
            });
            else this.setState({
                ...this.state,
                isUpdating: false,
                errors: result.errors
            });
            return result;
        } catch (error) {
            return {
                resultType: "InternalError",
                data: null,
                errors: [
                    error
                ]
            };
        }
    }
    removeApplicationFeatureWebhook(applicationFeatureWebhookId) {
        this.setState({
            ...this.state,
            isUpdating: true
        });
        const promise = _api.removeApplicationFeatureWebhook(applicationFeatureWebhookId);
        promise.then((result)=>{
            if (result.resultType == "Ok") {
                var webhooks = this.state.applicationFeatureWebhooks;
                (0, _lodashDefault.default).remove(webhooks, (w)=>w.id == applicationFeatureWebhookId);
                this.setState({
                    ...this.state,
                    isUpdating: false,
                    errors: [],
                    applicationFeatureWebhooks: webhooks
                });
            } else this.setState({
                ...this.state,
                isUpdating: false,
                errors: result.errors
            });
        }).catch((error)=>{
            this.setState({
                ...this.state,
                isUpdating: false,
                errors: [
                    error
                ]
            });
        });
        return promise;
    }
    setLoading(isLoading) {
        this.setState({
            ...this.state,
            isLoading
        });
    }
}
exports.default = FeatureWebhookContainer;

},{"@babel/runtime/helpers/defineProperty":"9sJxO","unstated":"grh7p","../../api":"loxM6","lodash":"3hMBK","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"awGxI":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _featureTypeIds = require("../../../constants/featureTypeIds");
var _webhookInstanceForm = require("./WebhookInstanceForm");
var _webhookInstanceFormDefault = parcelHelpers.interopDefault(_webhookInstanceForm);
class WebhookInstanceFormParent extends (0, _reactDefault.default).Component {
    constructor(props){
        super(props);
        this.state = {
            existingWebhookInstances: null,
            formIsLoaded: false
        };
    }
    async componentDidUpdate(prevProps) {
        if (!prevProps.show && this.props.show) this.load();
    }
    async load() {
        if (this.props.shouldNotLoad != true) {
            var result = await this.getExistingWebhookInstances();
            if (result.resultType == "Ok") this.setState({
                ...this.state,
                existingWebhookInstances: result.data ?? [],
                formIsLoaded: true
            });
        }
        if (this.props.stagedUpdate) this.setState({
            ...this.state,
            existingWebhookInstances: null,
            formIsLoaded: true
        });
        else this.setState({
            ...this.state,
            existingWebhookInstances: [],
            formIsLoaded: true
        });
    }
    async handleSubmitForm(updateRequest) {
        if (!this.props.manualSave) {
            const result = await this.bulkUpdate(this.props.webhookContainerId, updateRequest);
            if (result.resultType == "Ok") {
                this.props.onFinish(result.data);
                this.close();
            }
        } else {
            this.props.manualSave(updateRequest);
            this.close();
        }
    }
    close() {
        this.setState({
            ...this.state,
            formIsLoaded: false,
            existingWebhookInstances: null
        });
        this.props.onClose();
    }
    async getExistingWebhookInstances() {
        if (this.props.webhookInstanceScope == "Application") return await this.props.webhookContainer.getApplicationWebhookInstances(this.props.webhookContainerId);
        if (this.props.webhookInstanceScope == "ApplicationFeature") return await this.props.featureWebhookContainer.getApplicationFeatureWebhooks(this.props.webhookContainerId);
        switch(this.props.featureTypeId){
            case 0, _featureTypeIds.WelcomeMessagesFeatureTypeId:
                return this.props.welcomeMessageContainer.getContentWebhooks(this.props.webhookContainerId);
            case 0, _featureTypeIds.QuestionAnswerFeatureTypeId:
                return this.props.questionAnswerContainer.getContentWebhooks(this.props.webhookContainerId);
            case 0, _featureTypeIds.ExitMessagesFeatureTypeId:
                return this.props.exitMessageContainer.getContentWebhooks(this.props.webhookContainerId);
            case 0, _featureTypeIds.LatestMessagesFeatureTypeId:
                return this.props.latestMessageContainer.getContentWebhooks(this.props.webhookContainerId);
            case 0, _featureTypeIds.HelpMessagesFeatureTypeId:
                return this.props.helpMessageContainer.getContentWebhooks(this.props.webhookContainerId);
            case 0, _featureTypeIds.FallbackFeatureTypeId:
                return this.props.fallbackMessageContainer.getContentWebhooks(this.props.webhookContainerId);
            case 0, _featureTypeIds.NumberRangeFeatureTypeId:
                return this.props.numberRangeContainer.getContentWebhooks(this.props.webhookContainerId);
            case 0, _featureTypeIds.SimpleChoiceFeatureTypeId:
                return this.props.simpleChoiceContainer.getContentWebhooks(this.props.webhookContainerId);
            case 0, _featureTypeIds.CustomRequestsFeatureTypeId:
                return this.props.customRequestContainer.getContentWebhooks(this.props.webhookContainerId);
        }
    }
    bulkUpdate(webhookContainerId, updateRequest) {
        if (this.props.webhookInstanceScope == "Application") return this.props.webhookContainer.bulkUpdateApplicationWebhookInstances(webhookContainerId, updateRequest);
        if (this.props.webhookInstanceScope == "ApplicationFeature") return this.props.featureWebhookContainer.bulkUpdateFeatureWebhookInstances(webhookContainerId, updateRequest);
        switch(this.props.featureTypeId){
            case 0, _featureTypeIds.WelcomeMessagesFeatureTypeId:
                return this.props.welcomeMessageContainer.bulkUpdateContentItemWebhookInstances(webhookContainerId, updateRequest);
            case 0, _featureTypeIds.QuestionAnswerFeatureTypeId:
                return this.props.questionAnswerContainer.bulkUpdateContentItemWebhookInstances(webhookContainerId, updateRequest);
            case 0, _featureTypeIds.ExitMessagesFeatureTypeId:
                return this.props.exitMessageContainer.bulkUpdateContentItemWebhookInstances(webhookContainerId, updateRequest);
            case 0, _featureTypeIds.LatestMessagesFeatureTypeId:
                return this.props.latestMessageContainer.bulkUpdateContentItemWebhookInstances(webhookContainerId, updateRequest);
            case 0, _featureTypeIds.HelpMessagesFeatureTypeId:
                return this.props.helpMessageContainer.bulkUpdateContentItemWebhookInstances(webhookContainerId, updateRequest);
            case 0, _featureTypeIds.FallbackFeatureTypeId:
                return this.props.fallbackMessageContainer.bulkUpdateContentItemWebhookInstances(webhookContainerId, updateRequest);
            case 0, _featureTypeIds.NumberRangeFeatureTypeId:
                return this.props.numberRangeContainer.bulkUpdateContentItemWebhookInstances(webhookContainerId, updateRequest);
            case 0, _featureTypeIds.SimpleChoiceFeatureTypeId:
                return this.props.simpleChoiceContainer.bulkUpdateContentItemWebhookInstances(webhookContainerId, updateRequest);
            case 0, _featureTypeIds.CustomRequestsFeatureTypeId:
                return this.props.customRequestContainer.bulkUpdateContentItemWebhookInstances(webhookContainerId, updateRequest);
        }
    }
    getIsLoading() {
        if (this.props.webhookInstanceScope == "Application") return this.props.webhookContainer.state.isUpdating;
        if (this.props.webhookInstanceScope == "ApplicationFeature") return this.props.featureWebhookContainer.state.isUpdating;
        switch(this.props.featureTypeId){
            case 0, _featureTypeIds.WelcomeMessagesFeatureTypeId:
                return this.props.welcomeMessageContainer.state.isUpdatingWebhooks;
            case 0, _featureTypeIds.QuestionAnswerFeatureTypeId:
                return this.props.questionAnswerContainer.state.isUpdatingWebhooks;
            case 0, _featureTypeIds.ExitMessagesFeatureTypeId:
                return this.props.exitMessageContainer.state.isUpdatingWebhooks;
            case 0, _featureTypeIds.LatestMessagesFeatureTypeId:
                return this.props.latestMessageContainer.state.isUpdatingWebhooks;
            case 0, _featureTypeIds.HelpMessagesFeatureTypeId:
                return this.props.helpMessageContainer.state.isUpdatingWebhooks;
            case 0, _featureTypeIds.FallbackFeatureTypeId:
                return this.props.fallbackMessageContainer.state.isUpdatingWebhooks;
            case 0, _featureTypeIds.NumberRangeFeatureTypeId:
                return this.props.numberRangeContainer.state.isUpdatingWebhooks;
            case 0, _featureTypeIds.SimpleChoiceFeatureTypeId:
                return this.props.simpleChoiceContainer.state.isUpdatingWebhooks;
            case 0, _featureTypeIds.CustomRequestsFeatureTypeId:
                return this.props.customRequestContainer.state.isUpdatingWebhooks;
        }
    }
    render() {
        if (!this.props.show) return null;
        return (0, _react.jsx)((0, _webhookInstanceFormDefault.default), {
            existingWebhookInstances: this.state.existingWebhookInstances,
            existingWebhookChainingType: this.props.existingWebhookChainingType ?? "NoChaining",
            stagedUpdate: this.props.stagedUpdate,
            applicationId: this.props.applicationId,
            webhookInstanceScope: this.props.webhookInstanceScope,
            webhookContainer: this.props.webhookContainer,
            onClose: this.close.bind(this),
            organizationId: this.props.organizationContainer.state.currentOrganization?.id,
            isLoading: this.getIsLoading() || !this.state.formIsLoaded,
            onFinish: this.handleSubmitForm.bind(this)
        });
    }
}
exports.default = WebhookInstanceFormParent;

},{"@emotion/react":"djZKr","react":"6uln9","../../../constants/featureTypeIds":"hPLMP","./WebhookInstanceForm":"4xAHo","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4xAHo":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _extends = require("@babel/runtime/helpers/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _formik = require("formik");
var _yup = require("yup");
var _css = require("@emotion/css");
var _colors = require("../../../constants/colors");
var _lodash = require("lodash");
var _lodashDefault = parcelHelpers.interopDefault(_lodash);
var _modalLayout = require("../../../components/structure/ModalLayout");
var _modalLayoutDefault = parcelHelpers.interopDefault(_modalLayout);
var _fullScreenLayout = require("../../fullScreenLayout");
var _fullScreenLayoutDefault = parcelHelpers.interopDefault(_fullScreenLayout);
var _pageContainer = require("../../../components/structure/PageContainer");
var _pageContainerDefault = parcelHelpers.interopDefault(_pageContainer);
var _horizontalContainer = require("../../../components/structure/HorizontalContainer");
var _horizontalContainerDefault = parcelHelpers.interopDefault(_horizontalContainer);
var _modalTitle = require("../../../components/general/ModalTitle");
var _modalTitleDefault = parcelHelpers.interopDefault(_modalTitle);
var _button = require("../../../components/general/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _customScrollbars = require("../../../components/structure/CustomScrollbars");
var _customScrollbarsDefault = parcelHelpers.interopDefault(_customScrollbars);
var _selectField = require("../../../components/forms/SelectField");
var _selectFieldDefault = parcelHelpers.interopDefault(_selectField);
var _attachedWebhookCard = require("./AttachedWebhookCard");
var _attachedWebhookCardDefault = parcelHelpers.interopDefault(_attachedWebhookCard);
var _reactBeautifulDnd = require("react-beautiful-dnd");
var _textOverflowMenu = require("../../../components/general/overflowMenu/TextOverflowMenu");
var _textOverflowMenuDefault = parcelHelpers.interopDefault(_textOverflowMenu);
var _footerBar = require("../../../components/structure/FooterBar");
var _footerBarDefault = parcelHelpers.interopDefault(_footerBar);
var _loader = require("../../../components/general/Loader");
var _loaderDefault = parcelHelpers.interopDefault(_loader);
var _useWindowSize = require("../../../hooks/UseWindowSize");
var _useWindowSizeDefault = parcelHelpers.interopDefault(_useWindowSize);
var _tooltipWrapper = require("../../../components/general/TooltipWrapper");
var _tooltipWrapperDefault = parcelHelpers.interopDefault(_tooltipWrapper);
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const closeIcon = require("524261a619eca24a");
const questionMarkIcon = require("bef850c9ffd95d53");
const WEBHOOK_CHAINING_ENABLED = "Enabled";
const WEBHOOK_CHAINING_DISABLED = "Disabled";
const groupWebhooksByPriority = (webhooks)=>{
    const grouped = webhooks.reduce((acc, webhook)=>{
        const priority = webhook.priority || 1;
        if (!acc[priority]) acc[priority] = [];
        acc[priority].push(webhook);
        return acc;
    }, {});
    return Object.keys(grouped).map((priority)=>({
            priority: parseInt(priority),
            webhooks: grouped[parseInt(priority)]
        })).sort((a, b)=>a.priority - b.priority);
};
const WebhookInstanceFormComponent = (props)=>{
    const [selectedWebhook, setSelectedWebhook] = (0, _react1.useState)({});
    const [availableWebhooks, setAvailableWebhooks] = (0, _react1.useState)([]);
    const [eventWebhooks, setEventWebhooks] = (0, _react1.useState)([]);
    const [preResponseWebhoooks, setPreResponseWebhooks] = (0, _react1.useState)([]);
    const [loaded, setLoaded] = (0, _react1.useState)(false);
    const windowSize = (0, _useWindowSizeDefault.default)();
    (0, _react1.useEffect)(()=>{
        const asyncLoad = async ()=>{
            var applicationWebhooksResult = await props.webhookContainer.getWebhooksForApplication(props.applicationId);
            const applicationWebhooks = applicationWebhooksResult.data.filter((w)=>w.webhookType.webhookScopes.some((as)=>as.name == props.webhookInstanceScope));
            if (applicationWebhooksResult.resultType != "Ok") return;
            await setAvailableWebhooks(applicationWebhooks);
            await setLoaded(true);
        };
        asyncLoad();
    }, [
        props.applicationId
    ]);
    (0, _react1.useEffect)(()=>{
        let newEventWebhooks = [];
        let newPreResponseWebhooks = [];
        for(let i = 0; i < props.values.eventWebhookInstances.length; i++){
            // pre response webhooks are coming through as event webhooks into this component, lets separate them out. 
            const whToCheck = props.values.eventWebhookInstances[i];
            whToCheck.instanceName = `eventWebhookInstances.${i}`;
            whToCheck.eventWebhookIndex = i;
            if (whToCheck.webhook.webhookType.typeName === "PreResponse") {
                if (whToCheck.priority === null || whToCheck.priority === undefined || whToCheck.priority < 0) {
                    whToCheck.priority = newPreResponseWebhooks.length + 1;
                    props.setFieldValue(`${whToCheck.instanceName}.priority`, whToCheck.priority);
                }
                newPreResponseWebhooks.push(whToCheck);
            } else newEventWebhooks.push(whToCheck);
        }
        setEventWebhooks(newEventWebhooks);
        // order by pre response priority
        newPreResponseWebhooks = (0, _lodashDefault.default).orderBy(newPreResponseWebhooks, (af)=>af.priority, "asc");
        setPreResponseWebhooks(newPreResponseWebhooks);
    }, [
        props.values.eventWebhookInstances
    ]);
    (0, _react1.useEffect)(()=>{
        if (props.stagedUpdate != null && loaded) {
            var eventWebhooks = [];
            var responseRespolverWebhooks = [];
            var sessionStartWebhooks = [];
            props.stagedUpdate.webhookInstances.forEach((wi)=>{
                const newParameterValues = [];
                const webhook = availableWebhooks.find((w)=>w.id == wi.webhookId);
                const filledParameters = {
                    ...wi.parameters
                };
                webhook.parameters.forEach((p)=>{
                    if (p.isRequired) {
                        const existingValue = filledParameters[p.name];
                        newParameterValues.push({
                            key: p.name,
                            value: existingValue ?? p.defaultValue ?? "",
                            isRequired: true
                        });
                        delete filledParameters[p.name];
                    }
                });
                for(let key in filledParameters)newParameterValues.push({
                    key: key,
                    value: filledParameters[key],
                    isRequired: false
                });
                if (webhook.webhookType.typeName == "ResponseResolver") responseRespolverWebhooks.push({
                    webhook: {
                        ...webhook
                    },
                    priority: wi.priority,
                    formParameterValues: newParameterValues
                });
                else if (webhook.webhookType.typeName == "SessionStart") sessionStartWebhooks.push({
                    webhook: {
                        ...webhook
                    },
                    formParameterValues: newParameterValues
                });
                else eventWebhooks.push({
                    webhook: {
                        ...webhook
                    },
                    formParameterValues: newParameterValues
                });
            });
            props.setFieldValue("eventWebhookInstances", eventWebhooks);
            props.setFieldValue("sessionStartWebhookInstances", sessionStartWebhooks);
            props.setFieldValue("responseResolverWebhookInstances", (0, _lodashDefault.default).orderBy(responseRespolverWebhooks, (af)=>af.priority, "asc"));
            props.setFieldValue("webhookChainingType", props.stagedUpdate.webhookChainingType == "NoChaining" ? WEBHOOK_CHAINING_DISABLED : WEBHOOK_CHAINING_ENABLED);
        }
    }, [
        props.stagedUpdate,
        loaded
    ]);
    (0, _react1.useEffect)(()=>{
        if (props.existingWebhookInstances && props.existingWebhookInstances.length > 0 && props.values.sessionStartWebhookInstances.length == 0 && props.values.responseResolverWebhookInstances.length == 0 && props.values.eventWebhookInstances.length == 0) {
            var eventWebhooks = [];
            var sessionStartWebhooks = [];
            var responseRespolverWebhooks = [];
            props.existingWebhookInstances.forEach((wi)=>{
                const newParameterValues = [];
                wi.webhook.parameters.forEach((p)=>{
                    if (p.isRequired) {
                        const existingValue = wi.parameterValues.find((pv)=>pv.webhookParameter.name == p.name)?.value;
                        newParameterValues.push({
                            key: p.name,
                            value: existingValue ?? p.defaultValue ?? "",
                            isRequired: true
                        });
                    }
                });
                wi.parameterValues.forEach((pv)=>{
                    if (newParameterValues.some((npv)=>npv.key == pv.webhookParameter.name)) return;
                    newParameterValues.push({
                        key: pv.webhookParameter.name ?? pv.userDefinedKey,
                        value: pv.value,
                        isRequired: false
                    });
                });
                if (wi.webhook.webhookType.typeName == "ResponseResolver") responseRespolverWebhooks.push({
                    ...wi,
                    priority: wi.priority ?? responseRespolverWebhooks.length + 1,
                    formParameterValues: newParameterValues
                });
                else if (wi.webhook.webhookType.typeName == "SessionStart") sessionStartWebhooks.push({
                    ...wi,
                    formParameterValues: newParameterValues
                });
                else eventWebhooks.push({
                    ...wi,
                    formParameterValues: newParameterValues
                });
            });
            props.setFieldValue("sessionStartWebhookInstances", sessionStartWebhooks);
            props.setFieldValue("eventWebhookInstances", eventWebhooks);
            props.setFieldValue("webhookChainingType", props.existingWebhookChainingType == "NoChaining" ? WEBHOOK_CHAINING_DISABLED : WEBHOOK_CHAINING_ENABLED);
            props.setFieldValue("responseResolverWebhookInstances", (0, _lodashDefault.default).orderBy(responseRespolverWebhooks, (af)=>af.priority, "asc"));
        }
    }, [
        props.existingWebhookInstances,
        props.values.sessionStartWebhookInstances,
        props.values.eventWebhookInstances,
        props.values.responseResolverWebhookInstances
    ]);
    const handleWebhookChange = (value)=>{
        const id = value === null ? null : value.value;
        const webhook = availableWebhooks?.find((w)=>w.id == id);
        setSelectedWebhook(webhook);
    };
    const removeResponseResolver = (idx)=>{
        const webhookInstances = [
            ...props.values.responseResolverWebhookInstances
        ];
        webhookInstances.splice(idx, 1);
        props.setFieldValue("responseResolverWebhookInstances", webhookInstances);
    };
    const removeEventInstance = (idx)=>{
        const webhookInstances = [
            ...props.values.eventWebhookInstances
        ];
        webhookInstances.splice(idx, 1);
        props.setFieldValue("eventWebhookInstances", webhookInstances);
    };
    const removeSessionStartInstance = (idx)=>{
        const webhookInstances = [
            ...props.values.eventWebhookInstances
        ];
        webhookInstances.splice(idx, 1);
        props.setFieldValue("sessionStartWebhookInstances", webhookInstances);
    };
    const getNextPriority = (webhookTypeName)=>{
        let existingPriorities = [];
        if (webhookTypeName === "ResponseResolver") existingPriorities = props.values.responseResolverWebhookInstances.map((wi)=>wi.priority).filter((p)=>p !== null && p !== undefined);
        else if (webhookTypeName === "PreResponse") existingPriorities = preResponseWebhoooks.map((wi)=>wi.priority).filter((p)=>p !== null && p !== undefined);
        return existingPriorities.length > 0 ? Math.max(...existingPriorities) + 1 : 1;
    };
    const handleAddAttachWebhook = ()=>{
        var webhookInstances = selectedWebhook?.webhookType?.typeName == "ResponseResolver" ? props.values.responseResolverWebhookInstances : props.values.eventWebhookInstances;
        const newParameterValues = [];
        selectedWebhook?.parameters?.forEach((p)=>{
            if (p.isRequired) newParameterValues.push({
                key: p.name,
                value: p.defaultValue ?? "",
                isRequired: true
            });
        });
        let newPriority = null;
        if (selectedWebhook?.webhookType?.typeName == "ResponseResolver" && props.webhookInstanceScope == "Content") newPriority = getNextPriority("ResponseResolver");
        else if (selectedWebhook?.webhookType?.typeName == "PreResponse") newPriority = getNextPriority("PreResponse");
        const newWebhookInstance = {
            webhook: selectedWebhook,
            formParameterValues: newParameterValues,
            priority: newPriority
        };
        webhookInstances = [
            ...webhookInstances,
            newWebhookInstance
        ];
        if (newWebhookInstance.webhook.webhookType.typeName == "ResponseResolver") props.setFieldValue("responseResolverWebhookInstances", webhookInstances);
        else if (newWebhookInstance.webhook.webhookType.typeName == "SessionStart") props.setFieldValue("sessionStartWebhookInstances", webhookInstances);
        else props.setFieldValue("eventWebhookInstances", webhookInstances);
    };
    const handleResponseResolverDragEnd = (result, provider)=>{
        // dropped outside the list
        if (!result.destination) return;
        let webhookInstances = [
            ...props.values.responseResolverWebhookInstances
        ];
        const reorder = (list, startIndex, endIndex)=>{
            const result = Array.from(list);
            const [removed] = result.splice(startIndex, 1);
            result.splice(endIndex, 0, removed);
            return result;
        };
        webhookInstances = reorder(webhookInstances, result.source.index, result.destination.index);
        webhookInstances.forEach((wi, idx)=>{
            wi.priority = idx + 1;
        });
        props.setFieldValue("responseResolverWebhookInstances", webhookInstances);
    };
    const handlePreResponseDragEnd = (result, provider)=>{
        // dropped outside the list
        if (!result.destination) return;
        let webhookInstances = [
            ...preResponseWebhoooks
        ];
        const reorder = (list, startIndex, endIndex)=>{
            const result = Array.from(list);
            const [removed] = result.splice(startIndex, 1);
            result.splice(endIndex, 0, removed);
            return result;
        };
        webhookInstances = reorder(webhookInstances, result.source.index, result.destination.index);
        webhookInstances.forEach((wi, idx)=>{
            wi.priority = idx + 1;
            props.setFieldValue(`${wi.instanceName}.priority`, wi.priority);
        });
        setPreResponseWebhooks(webhookInstances);
    };
    const isLoading = props.isLoading || availableWebhooks == null;
    return (0, _react.jsx)((0, _modalLayoutDefault.default), {
        className: modalStyle,
        isVisible: true,
        onClose: props.onClose
    }, (0, _react.jsx)("form", {
        onSubmit: props.handleSubmit
    }, (0, _react.jsx)((0, _fullScreenLayoutDefault.default), {
        className: containerStyle
    }, (0, _react.jsx)((0, _pageContainerDefault.default), {
        fill: true
    }, (0, _react.jsx)((0, _horizontalContainerDefault.default), {
        className: "header-wrapper"
    }, (0, _react.jsx)((0, _modalTitleDefault.default), null, "Webhook Instances"), (0, _react.jsx)((0, _buttonDefault.default), {
        type: "button",
        className: "close-icon",
        themes: [
            "end-tight",
            "icon"
        ],
        icon: closeIcon,
        onClick: props.onClose
    })), !loaded && (0, _react.jsx)((0, _loaderDefault.default), null), loaded && (0, _react.jsx)((0, _customScrollbarsDefault.default), {
        autoHide: true,
        autoHeight: true,
        autoHeightMin: windowSize.windowSize.innerHeight * .9 - 188,
        autoHeightMax: windowSize.windowSize.innerHeight * .9 - 188
    }, (0, _react.jsx)("div", {
        className: "form-container"
    }, (0, _react.jsx)("div", {
        className: "sub-heading"
    }, "Attach a Webhook"), (0, _react.jsx)((0, _horizontalContainerDefault.default), {
        className: "attach-container"
    }, (0, _react.jsx)((0, _selectFieldDefault.default), {
        className: selectorStyle,
        options: availableWebhooks?.map((o)=>{
            return {
                value: o.id,
                label: o.title
            };
        }),
        value: selectedWebhook?.id,
        onBlur: ()=>null,
        onChange: handleWebhookChange.bind(undefined),
        disabled: isLoading,
        label: "Select an existing webhook",
        placeholder: "- Select a webhook -",
        clearValueText: "- Select a webhook -",
        name: "available-webhooks",
        clearable: true
    }), (0, _react.jsx)((0, _buttonDefault.default), {
        onClick: handleAddAttachWebhook.bind(undefined),
        type: "button",
        className: "attach-button",
        loading: isLoading,
        disabled: isLoading,
        themes: [
            "primary",
            "wide"
        ],
        text: "Attach"
    })), (props.values.responseResolverWebhookInstances.length > 0 || props.values.eventWebhookInstances.length > 0) && (0, _react.jsx)("div", {
        className: "sub-heading"
    }, "Existing Webhooks"), props.values.sessionStartWebhookInstances.length > 0 && (0, _react.jsx)((0, _reactDefault.default).Fragment, null, (0, _react.jsx)("div", {
        className: "sub-heading-upper"
    }, "Session Start Webhook"), props.values.sessionStartWebhookInstances.map((wi, idx)=>(0, _react.jsx)((0, _attachedWebhookCardDefault.default), {
            webhookInstance: wi,
            index: idx,
            handleBlur: props.handleBlur,
            handleChange: props.handleChange,
            setFieldValue: props.setFieldValue,
            onRemove: ()=>removeSessionStartInstance(idx),
            instanceName: `sessionStartWebhookInstances.${idx}`
        }))), preResponseWebhoooks.length > 0 && (0, _react.jsx)((0, _reactDefault.default).Fragment, null, (0, _react.jsx)("div", {
        className: "sub-heading-upper response"
    }, (0, _react.jsx)("div", null, "Pre Response Webhooks")), preResponseWebhoooks.length > 1 ? (0, _react.jsx)((0, _reactBeautifulDnd.DragDropContext), {
        onDragEnd: handlePreResponseDragEnd.bind(undefined)
    }, (0, _react.jsx)((0, _reactBeautifulDnd.Droppable), {
        droppableId: "prWebhookInstance",
        type: "P_R_WEBHOOK_INSTANCES"
    }, (provided, snapshot)=>(0, _react.jsx)("div", (0, _extendsDefault.default)({}, provided.droppableProps, {
            ref: provided.innerRef
        }), groupWebhooksByPriority(preResponseWebhoooks).map((group)=>(0, _react.jsx)("div", {
                key: `priority-group-${group.priority}`,
                className: `priority-group-wrapper ${group.webhooks.length > 1 ? "has-multiple" : ""}`
            }, group.webhooks.length > 1 && (0, _react.jsx)("div", {
                className: "priority-group-header"
            }, (0, _react.jsx)("div", {
                className: "parallel-icon"
            }, (0, _react.jsx)("span", null, "Run in Parallel"), (0, _react.jsx)((0, _tooltipWrapperDefault.default), {
                text: "When webhooks run in parallel, results from one webhook are not sent to another webhook",
                place: "top",
                maxWidth: 300
            }, (0, _react.jsx)("img", {
                src: questionMarkIcon,
                className: questionMarkIconStyle
            })))), group.webhooks.map((wi, idx)=>{
                const originalIndex = preResponseWebhoooks.findIndex((w)=>w === wi);
                return (0, _react.jsx)((0, _reactBeautifulDnd.Draggable), {
                    draggableId: `pre-response-webhook-instance${originalIndex}`,
                    index: originalIndex,
                    key: `pre-response-webhook-instance${originalIndex}`
                }, (provided, snapshot)=>(0, _react.jsx)("div", (0, _extendsDefault.default)({
                        ref: provided.innerRef
                    }, provided.draggableProps), (0, _react.jsx)((0, _attachedWebhookCardDefault.default), {
                        className: `${snapshot.isDragging ? "dragging" : ""} ${group.webhooks.length > 1 ? "priority-group" : ""}`,
                        webhookInstance: wi,
                        index: originalIndex,
                        showPriority: true,
                        dragHandleProps: provided.dragHandleProps,
                        handleBlur: props.handleBlur,
                        handleChange: props.handleChange,
                        setFieldValue: props.setFieldValue,
                        onRemove: ()=>removeEventInstance(wi.eventWebhookIndex),
                        instanceName: wi.instanceName,
                        isInPriorityGroup: true,
                        allWebhooks: preResponseWebhoooks
                    })));
            }))), provided.placeholder))) : preResponseWebhoooks.map((wi, idx)=>(0, _react.jsx)((0, _attachedWebhookCardDefault.default), {
            webhookInstance: wi,
            index: idx,
            handleBlur: props.handleBlur,
            handleChange: props.handleChange,
            setFieldValue: props.setFieldValue,
            onRemove: ()=>removeEventInstance(wi.eventWebhookIndex),
            instanceName: wi.instanceName,
            isInPriorityGroup: true,
            allWebhooks: preResponseWebhoooks
        }))), props.values.responseResolverWebhookInstances.length > 0 && (0, _react.jsx)((0, _reactDefault.default).Fragment, null, (0, _react.jsx)("div", {
        className: "sub-heading-upper response"
    }, (0, _react.jsx)("div", null, "Response Resolver Webhooks"), props.webhookInstanceScope == "Content" && (0, _react.jsx)((0, _textOverflowMenuDefault.default), {
        clickableText: props.values.webhookChainingType,
        className: "webhook-chaining-select",
        label: "Webhook Chaining: ",
        onOptionSelected: (option)=>props.setFieldValue("webhookChainingType", option),
        options: [
            {
                label: WEBHOOK_CHAINING_ENABLED
            },
            {
                label: WEBHOOK_CHAINING_DISABLED
            }
        ]
    })), props.webhookInstanceScope == "Content" && props.values.webhookChainingType == WEBHOOK_CHAINING_ENABLED ? (0, _react.jsx)((0, _reactBeautifulDnd.DragDropContext), {
        onDragEnd: handleResponseResolverDragEnd.bind(undefined)
    }, (0, _react.jsx)((0, _reactBeautifulDnd.Droppable), {
        droppableId: "webhookInstances",
        type: "WEBHOOK_INSTANCES"
    }, (provided, snapshot)=>(0, _react.jsx)("div", (0, _extendsDefault.default)({}, provided.droppableProps, {
            ref: provided.innerRef
        }), props.values.responseResolverWebhookInstances.map((wi, idx)=>{
            return (0, _react.jsx)((0, _reactBeautifulDnd.Draggable), {
                draggableId: `webhook-instance${idx}`,
                index: idx,
                key: `webhook-instance${idx}`
            }, (provided, snapshot)=>(0, _react.jsx)("div", (0, _extendsDefault.default)({
                    ref: provided.innerRef
                }, provided.draggableProps), (0, _react.jsx)((0, _attachedWebhookCardDefault.default), {
                    className: snapshot.isDragging ? "dragging" : "",
                    webhookInstance: wi,
                    index: idx,
                    showPriority: true,
                    dragHandleProps: provided.dragHandleProps,
                    handleBlur: props.handleBlur,
                    handleChange: props.handleChange,
                    setFieldValue: props.setFieldValue,
                    onRemove: ()=>removeResponseResolver(idx),
                    instanceName: `responseResolverWebhookInstances.${idx}`,
                    isInPriorityGroup: true,
                    allWebhooks: props.values.responseResolverWebhookInstances
                })));
        }), provided.placeholder))) : props.values.responseResolverWebhookInstances.map((wi, idx)=>(0, _react.jsx)((0, _attachedWebhookCardDefault.default), {
            webhookInstance: wi,
            index: idx,
            handleBlur: props.handleBlur,
            handleChange: props.handleChange,
            setFieldValue: props.setFieldValue,
            onRemove: ()=>removeResponseResolver(idx),
            instanceName: `responseResolverWebhookInstances.${idx}`,
            isInPriorityGroup: true,
            allWebhooks: props.values.responseResolverWebhookInstances
        }))), eventWebhooks.length > 0 && (0, _react.jsx)((0, _reactDefault.default).Fragment, null, (0, _react.jsx)("div", {
        className: "sub-heading-upper"
    }, "Event Webhooks"), eventWebhooks.map((wi, idx)=>(0, _react.jsx)((0, _attachedWebhookCardDefault.default), {
            webhookInstance: wi,
            index: idx,
            handleBlur: props.handleBlur,
            handleChange: props.handleChange,
            setFieldValue: props.setFieldValue,
            onRemove: ()=>removeEventInstance(wi.eventWebhookIndex),
            instanceName: wi.instanceName
        }))))), (0, _react.jsx)((0, _footerBarDefault.default), null, (0, _react.jsx)((0, _buttonDefault.default), {
        className: "submit-button",
        loading: isLoading,
        disabled: isLoading || !loaded,
        themes: [
            "primary",
            "wide"
        ],
        text: "Save",
        type: "submit"
    }), (0, _react.jsx)((0, _buttonDefault.default), {
        className: "cancel-button",
        disabled: isLoading || !loaded,
        themes: [
            "white",
            "end"
        ],
        text: "Cancel",
        type: "button",
        onClick: props.onClose.bind(undefined)
    }))))));
};
const webhookInstanceObjectValidation = _yup.object().shape({
    formParameterValues: _yup.array().of(_yup.object().shape({
        key: _yup.string().required("You must specify a parameter key"),
        value: _yup.string().when("isRequired", {
            is: true,
            then: _yup.string().required("This parameter is required, please specify a value.")
        }),
        isRequired: _yup.boolean()
    }))
});
const WebhookInstanceForm = (0, _formik.withFormik)({
    mapPropsToValues: (props)=>{
        return {
            sessionStartWebhookInstances: [],
            eventWebhookInstances: [],
            responseResolverWebhookInstances: [],
            webhookChainingType: WEBHOOK_CHAINING_DISABLED
        };
    },
    validationSchema: _yup.object().shape({
        sessionStartWebhookInstances: _yup.array().of(webhookInstanceObjectValidation),
        eventWebhookInstances: _yup.array().of(webhookInstanceObjectValidation),
        responseResolverWebhookInstances: _yup.array().of(webhookInstanceObjectValidation),
        webhookChainingType: _yup.string()
    }),
    handleSubmit: (values, { props })=>{
        var allInstances = [
            ...values.eventWebhookInstances,
            ...values.responseResolverWebhookInstances,
            ...values.sessionStartWebhookInstances
        ];
        const instances = [];
        allInstances.forEach((e)=>{
            const parameters = {};
            e.formParameterValues.forEach((f)=>{
                let val = f.value;
                if (val == "" || val == null) {
                    const parameterValues = e.webhook.parameters?.filter((p)=>p.name == f.key) ?? [];
                    if (parameterValues.length > 0) val = parameterValues[0].defaultValue ?? "";
                }
                parameters[f.key] = val;
            });
            instances.push({
                webhookId: e.webhook.id,
                parameters: parameters,
                priority: e.priority
            });
        });
        props.onFinish({
            webhookInstances: instances,
            webhookChainingType: values.webhookChainingType == WEBHOOK_CHAINING_ENABLED ? "InstanceLevelChaining" : "NoChaining"
        });
    }
})(WebhookInstanceFormComponent);
exports.default = WebhookInstanceForm;
const modalStyle = /*#__PURE__*/ (0, _css.css)({
    name: "hu0fsu",
    styles: "width:70vw;height:90vh"
});
const containerStyle = /*#__PURE__*/ (0, _css.css)(".header-wrapper{border-bottom:solid 1px ", (0, _colors.color_shades_dark), ";.close-icon{margin-right:32px;margin-top:28px;}h2{margin-left:32px;}}.form-container{margin:32px;}.submit-button{margin-left:32px;}.cancel-button{margin-right:32px;}.attach-button{margin-top:32px;margin-right:0px;}.sub-heading{font-style:normal;font-weight:normal;font-size:18px;line-height:24px;color:", (0, _colors.color_shades_darkest), ";margin-bottom:16px;}.sub-heading-upper{font-style:normal;font-weight:normal;font-size:14px;line-height:16px;letter-spacing:0.1em;text-transform:uppercase;color:", (0, _colors.color_shades_darkest), ";margin-top:32px;&.response{display:flex;.webhook-chaining-select{margin-left:auto;margin-right:8px;text-transform:none;}}}.attach-container{border-bottom:solid 1px ", (0, _colors.color_shades_dark), ";padding-bottom:24px;margin-bottom:24px;}.priority-group-wrapper{margin:16px 0px;&.has-multiple{border:2px solid ", (0, _colors.color_shades_dark), ";border-radius:8px;padding:12px;}.priority-group-header{display:flex;justify-content:space-between;align-items:center;padding:8px 12px;margin-bottom:8px;background:white;border-radius:6px;border:1px solid ", (0, _colors.color_shades_dark), ";.priority-label{font-size:14px;color:", (0, _colors.color_shades_darkest), ";text-transform:uppercase;}.parallel-icon{display:flex;align-items:center;font-size:12px;color:", (0, _colors.color_shades_darkest), ";}}}", "");
const questionMarkIconStyle = /*#__PURE__*/ (0, _css.css)({
    name: "1cas5gx",
    styles: "margin-left:8px;cursor:pointer;width:16px;height:16px"
});
const selectorStyle = /*#__PURE__*/ (0, _css.css)({
    name: "1dvcceb",
    styles: "margin-left:0px;width:100%;&.left{padding-right:8px;}&.right{padding-left:8px;}.Select-control{border-radius:8px;height:60px;}.Select-input{margin:0px;}"
});

},{"@babel/runtime/helpers/extends":"4iKIP","@emotion/react":"djZKr","react":"6uln9","formik":"3YnOK","yup":"j2SJU","@emotion/css":"awUBr","../../../constants/colors":"1p3OR","lodash":"3hMBK","../../../components/structure/ModalLayout":"b1cO3","../../fullScreenLayout":"5mVdG","../../../components/structure/PageContainer":"hc1r8","../../../components/structure/HorizontalContainer":"eJPfh","../../../components/general/ModalTitle":"hIp2B","../../../components/general/Button":"6ymxN","../../../components/structure/CustomScrollbars":"50vFq","../../../components/forms/SelectField":"405B3","./AttachedWebhookCard":"4Oc3K","react-beautiful-dnd":"bkbSn","../../../components/general/overflowMenu/TextOverflowMenu":"iiFcw","../../../components/structure/FooterBar":"bibRL","../../../components/general/Loader":"bnV5T","../../../hooks/UseWindowSize":"43j9z","../../../components/general/TooltipWrapper":"53pWd","524261a619eca24a":"93VwA","bef850c9ffd95d53":"iHZUj","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4Oc3K":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _extends = require("@babel/runtime/helpers/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("@emotion/react");
var _css = require("@emotion/css");
var _formik = require("formik");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _textField = require("../../../components/forms/TextField");
var _textFieldDefault = parcelHelpers.interopDefault(_textField);
var _horizontalContainer = require("../../../components/structure/HorizontalContainer");
var _horizontalContainerDefault = parcelHelpers.interopDefault(_horizontalContainer);
var _colors = require("../../../constants/colors");
var _tooltipWrapper = require("../../../components/general/TooltipWrapper");
var _tooltipWrapperDefault = parcelHelpers.interopDefault(_tooltipWrapper);
const linkOutIcon = require("c670ffb9a6103cc0");
const settingsBoxBlue = require("7b5044e91f5d3082");
const settingsBoxDark = require("746ae560a8a56736");
const draggableInstance = require("10fbd929f64f2c37");
const deleteIcon = require("972daf229baf0217");
const descriptionIcon = require("56021efa52245bd9");
const typeIcon = require("440fe63356345c32");
const linkIcon = require("94d24df7af281521");
const keyIcon = require("a3c6ad7819cf6193");
const removeParameterIcon = require("41ae477b2193231f");
const requiredStarIcon = require("c04c59b4820d9fb6");
class AttachedWebhookCard extends (0, _reactDefault.default).Component {
    constructor(props){
        super(props);
        this.state = {
            configExpanded: false
        };
    }
    toggleExpandConfig() {
        this.setState({
            ...this.state,
            configExpanded: !this.state.configExpanded
        });
    }
    renderWebhookConfigField(label, icon, value, first) {
        return (0, _react.jsx)("div", {
            key: label,
            className: `${webhookConfigFieldStyle} ${first ? "" : "extra-margin-top"}`
        }, (0, _react.jsx)("div", {
            className: "label"
        }, label), (0, _react.jsx)((0, _horizontalContainerDefault.default), {
            className: "line-two"
        }, icon && (0, _react.jsx)("img", {
            src: icon
        }), (0, _react.jsx)("div", {
            className: "value"
        }, value)));
    }
    render() {
        const webhookInstance = this.props.webhookInstance;
        const suggestions = webhookInstance.webhook.parameters?.filter((p)=>!p.isRequired && !webhookInstance.formParameterValues.some((fpv)=>fpv.key == p.name))?.map((p)=>p.name) ?? [];
        const isInPriorityGroup = this.props.isInPriorityGroup && this.props.allWebhooks && this.props.allWebhooks.filter((w)=>w.priority === webhookInstance.priority).length > 1;
        return (0, _react.jsx)("div", {
            key: this.props.index,
            className: `${attachedWebhookStyle} ${this.props.className ?? ""} ${isInPriorityGroup ? "priority-group" : ""}`
        }, (0, _react.jsx)((0, _horizontalContainerDefault.default), {
            className: "top"
        }, this.props.showPriority && (0, _react.jsx)("div", {
            className: "webhook-priority"
        }, (0, _react.jsx)("div", (0, _extendsDefault.default)({}, this.props.dragHandleProps, {
            className: "drag-handle"
        }), (0, _react.jsx)("img", {
            src: draggableInstance
        })), (0, _react.jsx)((0, _tooltipWrapperDefault.default), {
            text: "Execution priority"
        }, (0, _react.jsx)("span", null, (0, _react.jsx)((0, _textFieldDefault.default), {
            className: "priority-field",
            name: `${this.props.instanceName}.priority`,
            value: this.props.webhookInstance.priority?.toString() || "",
            placeholder: "1",
            onChange: this.props.handleChange,
            onBlur: this.props.handleBlur,
            type: "number"
        })))), (0, _react.jsx)("span", {
            className: "title"
        }, webhookInstance.webhook.title), (0, _react.jsx)("a", {
            target: "_blank",
            className: "link-out-icon",
            href: `/v/apps/${webhookInstance.webhook.applicationId}/webhooks/${webhookInstance.webhook.webhookFolderId ?? ""}?webhookId=${webhookInstance.webhook.id}`
        }, (0, _react.jsx)("img", {
            src: linkOutIcon
        })), (0, _react.jsx)("div", {
            onClick: this.toggleExpandConfig.bind(this),
            className: `show-config ${this.state.configExpanded ? "expanded" : ""}`
        }, (0, _react.jsx)("span", null, this.state.configExpanded ? "Hide Config" : "Show Config"), (0, _react.jsx)("img", {
            src: this.state.configExpanded ? settingsBoxBlue : settingsBoxDark
        })), (0, _react.jsx)("img", {
            onClick: ()=>this.props.onRemove(),
            className: "delete",
            src: deleteIcon
        })), this.state.configExpanded && (0, _react.jsx)("div", {
            className: "config"
        }, (0, _react.jsx)("div", {
            className: "arrow"
        }), (0, _react.jsx)((0, _horizontalContainerDefault.default), null, this.renderWebhookConfigField("Description", descriptionIcon, webhookInstance.webhook.description, true), this.renderWebhookConfigField("Type", typeIcon, webhookInstance.webhook.webhookType.typeName, true)), (0, _react.jsx)((0, _horizontalContainerDefault.default), null, this.renderWebhookConfigField("URL", linkIcon, webhookInstance.webhook.url, false), this.renderWebhookConfigField("Token", keyIcon, webhookInstance.webhook.accessToken ?? "Empty", false)), webhookInstance.webhook.configurationParameters && webhookInstance.webhook.configurationParameters.map((p, idx)=>(0, _react.jsx)((0, _horizontalContainerDefault.default), {
                key: idx
            }, this.renderWebhookConfigField("key", null, p.key, false), this.renderWebhookConfigField("value", null, p.value, false)))), (0, _react.jsx)((0, _formik.FieldArray), {
            validateOnChange: false,
            name: `${this.props.instanceName}.formParameterValues`,
            render: (arrayHelpers)=>(0, _react.jsx)("div", {
                    key: "params"
                }, (0, _react.jsx)("div", {
                    className: "parameters"
                }, (0, _react.jsx)((0, _horizontalContainerDefault.default), null, (0, _react.jsx)("div", {
                    className: "cap-sub-heading"
                }, "Parameters"), (0, _react.jsx)("div", {
                    onClick: ()=>{
                        arrayHelpers.push({
                            key: "",
                            value: "",
                            isRequired: false
                        });
                    },
                    className: "add-parameter"
                }, "+ Add a Parameter")), webhookInstance.formParameterValues && webhookInstance.formParameterValues.map((p, idx)=>(0, _react.jsx)("div", {
                        key: idx
                    }, (0, _react.jsx)((0, _horizontalContainerDefault.default), {
                        className: "remove-parameter"
                    }, (0, _react.jsx)("span", {
                        className: "left"
                    }), (0, _react.jsx)("div", null, p.key ? p.key : "Parameter"), (0, _react.jsx)("span", {
                        className: "right"
                    }), p.isRequired ? (0, _react.jsx)((0, _horizontalContainerDefault.default), {
                        className: "required"
                    }, (0, _react.jsx)("div", null, "Required"), (0, _react.jsx)("img", {
                        src: requiredStarIcon
                    })) : (0, _react.jsx)("img", {
                        src: removeParameterIcon,
                        onClick: ()=>{
                            arrayHelpers.remove(idx);
                        }
                    })), (0, _react.jsx)((0, _horizontalContainerDefault.default), null, (0, _react.jsx)((0, _textFieldDefault.default), {
                        className: "parameter-field left",
                        name: `${this.props.instanceName}.formParameterValues.${idx}.key`,
                        value: p.key,
                        disabled: p.isRequired,
                        placeholder: "Enter key",
                        label: `Key`,
                        onChange: this.props.handleChange,
                        onSuggestionClick: (suggestion)=>this.props.setFieldValue(`${this.props.instanceName}.formParameterValues.${idx}.key`, suggestion),
                        suggestions: suggestions,
                        onBlur: this.props.handleBlur
                    }), (0, _react.jsx)((0, _textFieldDefault.default), {
                        className: "parameter-field right",
                        name: `${this.props.instanceName}.formParameterValues.${idx}.value`,
                        value: p.value,
                        placeholder: "Enter value",
                        label: `Value`,
                        onChange: this.props.handleChange,
                        onBlur: this.props.handleBlur
                    }))))))
        }));
    }
}
const webhookConfigFieldStyle = /*#__PURE__*/ (0, _css.css)("width:50%;&.extra-margin-top{margin-top:32px;}.label{color:", (0, _colors.color_shades_darkest), ";text-transform:uppercase;}.value{font-size:14px;line-height:20px;color:", (0, _colors.color_shades_darkest), ";overflow-wrap:break-word;width:95%;}.line-two{margin-top:12px;img{margin-right:12px;height:24px;width:24px;}}", "");
const attachedWebhookStyle = /*#__PURE__*/ (0, _css.css)("&.dragging{margin-left:-350px;margin-top:-50px;}background:white;border:solid 1px ", (0, _colors.color_shades_dark), ";border-radius:8px;color:", (0, _colors.color_shades_darkest), ";font-style:normal;font-weight:normal;margin:12px 0px;overflow:hidden;.cap-sub-heading{font-style:normal;font-weight:normal;font-size:14px;line-height:16px;letter-spacing:0.1em;text-transform:uppercase;color:", (0, _colors.color_shades_darkest), ";}.delete{width:40px;border-left:1px solid ", (0, _colors.color_shades_dark), ";padding-left:16px;cursor:pointer;}.top{padding:16px;}.title{font-size:18px;line-height:24px;margin:4px 0px 0 8px;display:flex;align-items:center;height:24px;}.link-out-icon{margin-left:8px;margin-right:auto;img{width:20px;margin-top:6px;}}.show-config{font-size:14px;line-height:20px;display:flex;flex-direction:row;cursor:pointer;width:124px;span{padding:6px 0px 4px 8px;}img{padding:4px;margin-left:auto;}&.expanded{color:", (0, _colors.color_colors_ocean), ";background:", (0, _colors.color_variants_ocean_light_2), ";border-radius:8px;}}.config{background:", (0, _colors.color_shades_lighter), ";width:100%;padding:32px;position:relative;border-top:1px solid ", (0, _colors.color_shades_dark), ";.arrow{border-left:solid 1px ", (0, _colors.color_shades_dark), ";background:", (0, _colors.color_shades_lighter), ";border-top:solid 1px ", (0, _colors.color_shades_dark), ";transform:rotate(45deg);position:absolute;width:9px;height:9px;top:-5px;right:122px;}}.remove-parameter{margin:16px 0px 16px 0px;display:flex;flex-direction:row;font-style:normal;font-weight:normal;color:", (0, _colors.color_shades_darkest), ";div{font-size:16px;line-height:24px;display:flex;flex-direction:row;}img{cursor:pointer;}.required{font-size:14px;line-height:20px;img{margin:2px 0 0 8px;}}span{border-bottom:solid 1px ", (0, _colors.color_shades_dark), ";margin-bottom:10px;&.left{width:10px;margin-right:8px;}&.right{margin-left:8px;flex-grow:1;margin-right:8px;}}}.parameters{border-top:1px solid ", (0, _colors.color_shades_dark), ";padding:24px;.parameter-field{margin-left:0px;&.left{margin-right:8px;}&.right{margin-left:8px;}}.add-parameter{font-style:normal;font-weight:normal;font-size:14px;line-height:20px;color:", (0, _colors.color_colors_ocean), ";margin-left:auto;cursor:pointer;}}.webhook-priority{display:flex;flex-direction:row;align-items:center;margin-top:3px;margin-right:8px;.drag-handle{display:flex;align-items:center;img{margin-right:8px;}}.priority-field{width:40px;margin:0;padding:0;margin-left:4px;input{height:24px!important;padding:2px 6px!important;font-size:12px!important;border-radius:4px;border:1px solid ", (0, _colors.color_shades_dark), ";line-height:20px;}.field-container{height:24px;min-height:24px;margin:0;padding:0;}label{display:none;}}}", "");
exports.default = AttachedWebhookCard;

},{"@babel/runtime/helpers/extends":"4iKIP","@emotion/react":"djZKr","@emotion/css":"awUBr","formik":"3YnOK","react":"6uln9","../../../components/forms/TextField":"7a7bh","../../../components/structure/HorizontalContainer":"eJPfh","../../../constants/colors":"1p3OR","../../../components/general/TooltipWrapper":"53pWd","c670ffb9a6103cc0":"9mnp5","7b5044e91f5d3082":"2sguY","746ae560a8a56736":"d8fHW","10fbd929f64f2c37":"7gUIb","972daf229baf0217":"bG6Op","56021efa52245bd9":"bIMKD","440fe63356345c32":"8l5ha","94d24df7af281521":"11YUE","a3c6ad7819cf6193":"craWh","41ae477b2193231f":"aDy6h","c04c59b4820d9fb6":"20G3l","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9mnp5":[function(require,module,exports) {
module.exports = require("48f903850ac67cd6").getBundleURL("kVLro") + require("a23532bc5923d9b2").resolve("9O2G7");

},{"48f903850ac67cd6":"c7Tr5","a23532bc5923d9b2":"fyJL2"}],"2sguY":[function(require,module,exports) {
module.exports = require("67a18648229b10e3").getBundleURL("kVLro") + require("46dadfc7117aca6f").resolve("bNhv7");

},{"67a18648229b10e3":"c7Tr5","46dadfc7117aca6f":"fyJL2"}],"d8fHW":[function(require,module,exports) {
module.exports = require("d1c42128cf0033ff").getBundleURL("kVLro") + require("12caab2a317adba0").resolve("56AcK");

},{"d1c42128cf0033ff":"c7Tr5","12caab2a317adba0":"fyJL2"}],"7gUIb":[function(require,module,exports) {
module.exports = require("1111009cae0a5c0e").getBundleURL("kVLro") + require("d205beab028dd976").resolve("ggP9e");

},{"1111009cae0a5c0e":"c7Tr5","d205beab028dd976":"fyJL2"}],"bG6Op":[function(require,module,exports) {
module.exports = require("1da7dd45860ac130").getBundleURL("kVLro") + require("b114b4cb5172105e").resolve("dWxIG");

},{"1da7dd45860ac130":"c7Tr5","b114b4cb5172105e":"fyJL2"}],"bIMKD":[function(require,module,exports) {
module.exports = require("8592fc8e7ca72a7f").getBundleURL("kVLro") + require("1b74639e4c18a0e1").resolve("Idl6v");

},{"8592fc8e7ca72a7f":"c7Tr5","1b74639e4c18a0e1":"fyJL2"}],"8l5ha":[function(require,module,exports) {
module.exports = require("923bbc379e856758").getBundleURL("kVLro") + require("ff3cfb97ec8ff646").resolve("jMNKr");

},{"923bbc379e856758":"c7Tr5","ff3cfb97ec8ff646":"fyJL2"}],"11YUE":[function(require,module,exports) {
module.exports = require("1d3b54f4988dd75d").getBundleURL("kVLro") + require("e5de05238982e4f8").resolve("hgFj5");

},{"1d3b54f4988dd75d":"c7Tr5","e5de05238982e4f8":"fyJL2"}],"craWh":[function(require,module,exports) {
module.exports = require("25e73911f403124a").getBundleURL("kVLro") + require("2d6bb831b32895db").resolve("4dmqz");

},{"25e73911f403124a":"c7Tr5","2d6bb831b32895db":"fyJL2"}],"aDy6h":[function(require,module,exports) {
module.exports = require("560eb4fd055bffda").getBundleURL("kVLro") + require("bc1271ed883aadb4").resolve("3nGWC");

},{"560eb4fd055bffda":"c7Tr5","bc1271ed883aadb4":"fyJL2"}],"iiFcw":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _overflowMenu = require("./OverflowMenu");
var _overflowMenuDefault = parcelHelpers.interopDefault(_overflowMenu);
var _colors = require("../../../constants/colors");
var _toggleIndicator = require("../ToggleIndicator");
var _toggleIndicatorDefault = parcelHelpers.interopDefault(_toggleIndicator);
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
class TextOverflowMenu extends (0, _reactDefault.default).Component {
    componentWillMount() {
        this.setState({
            ...this.state,
            isActive: false
        });
    }
    componentDidUpdate(prevProps) {
        if (prevProps.isActive != this.props.isActive) this.setState({
            ...this.state,
            isActive: this.props.isActive
        });
    }
    handleClick(e) {
        e.stopPropagation();
        this.setState({
            ...this.state,
            isActive: !this.state.isActive
        });
    }
    handleMenuClose() {
        this.setState({
            ...this.state,
            isActive: false
        });
    }
    render() {
        return (0, _react.jsx)("div", {
            className: `${containerCss} ${this.props.className}`
        }, (0, _react.jsx)("div", {
            onClick: this.handleClick.bind(this),
            className: expandTextStyle
        }, this.props.label != null && (0, _react.jsx)("span", {
            onClick: this.handleClick.bind(this),
            className: "label"
        }, this.props.label), (0, _react.jsx)("div", null, this.props.clickableText), (0, _react.jsx)((0, _toggleIndicatorDefault.default), {
            className: `${toggleStyle} ${this.props.toggleClassName ?? ""}`,
            direction: this.state.isActive ? "up" : "down"
        })), this.state.isActive ? (0, _react.jsx)((0, _overflowMenuDefault.default), {
            onClose: this.handleMenuClose.bind(this),
            onOptionSelected: this.props.onOptionSelected,
            options: this.props.options,
            optionClassName: `${optionCss} ${this.props.optionClassName ?? ""}`,
            className: `${menuCss} ${this.props.menuClassName ?? ""}`
        }, this.props.children) : null);
    }
}
const toggleStyle = /*#__PURE__*/ (0, _css.css)("margin:4px 0px 0px 8px;border-left:1px solid ", (0, _colors.color_shades_darker), ";border-top:1px solid ", (0, _colors.color_shades_darker), ";", "");
const optionCss = /*#__PURE__*/ (0, _css.css)({
    name: "um5c5f",
    styles: "height:32px;font-style:normal;font-weight:normal;font-size:12px;line-height:16px;width:150px"
});
const menuCss = /*#__PURE__*/ (0, _css.css)({
    name: "1r967n6",
    styles: "margin-left:70px;width:150px;margin-top:26px"
});
const containerCss = /*#__PURE__*/ (0, _css.css)({
    name: "pmntxt",
    styles: "display:flex;flex-direction:row;border:0px;position:relative"
});
const expandTextStyle = /*#__PURE__*/ (0, _css.css)("cursor:pointer;color:", (0, _colors.color_shades_darker), ";font-style:italic;font-weight:normal;font-size:12px;line-height:16px;display:flex;.label{margin-right:8px;}", "");
exports.default = TextOverflowMenu;

},{"@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","./OverflowMenu":"2V2SB","../../../constants/colors":"1p3OR","../ToggleIndicator":"4eej1","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"iHZUj":[function(require,module,exports) {
module.exports = require("585bf9533cd5d37c").getBundleURL("kVLro") + require("688bf98c7285ca9c").resolve("2aqPd");

},{"585bf9533cd5d37c":"c7Tr5","688bf98c7285ca9c":"fyJL2"}],"5SuoU":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _base = require("@emotion/styled/base");
var _baseDefault = parcelHelpers.interopDefault(_base);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _stylesValues = require("../../../constants/stylesValues");
var _toggleIndicator = require("../../../components/general/ToggleIndicator");
var _toggleIndicatorDefault = parcelHelpers.interopDefault(_toggleIndicator);
var _tooltipWrapper = require("../../../components/general/TooltipWrapper");
var _tooltipWrapperDefault = parcelHelpers.interopDefault(_tooltipWrapper);
var _secondaryLoader = require("../../../components/general/SecondaryLoader");
var _secondaryLoaderDefault = parcelHelpers.interopDefault(_secondaryLoader);
var _colors = require("../../../constants/colors");
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const backupIcon = require("bcb50a9ab04407b4");
const ApplicationHistoryToolbar = ({ isExpanded, isLoading, onToggle, onSaveBackup })=>{
    return (0, _react.jsx)(Container, null, (0, _react.jsx)(ToggleButton, {
        type: "button",
        onClick: onToggle,
        className: `${onSaveBackup == null ? "no-backup" : ""} ac-explorer-history-button`
    }, (0, _react.jsx)("p", null, "History"), (0, _react.jsx)((0, _toggleIndicatorDefault.default), {
        direction: isExpanded ? "up" : "down"
    })), onSaveBackup != null && (0, _react.jsx)((0, _reactDefault.default).Fragment, null, isLoading ? (0, _react.jsx)((0, _secondaryLoaderDefault.default), null) : (0, _react.jsx)((0, _tooltipWrapperDefault.default), {
        text: "Save a backup",
        place: "bottom"
    }, (0, _react.jsx)(SaveBackupButton, {
        onClick: onSaveBackup,
        disabled: isLoading
    }, (0, _react.jsx)("p", null, "Backup"), (0, _react.jsx)("img", {
        src: backupIcon
    })))));
};
const Container = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e2hhkev2"
})("display:flex;align-items:center;height:48px;border-bottom:", (0, _stylesValues.style_border_default), ";padding:0 24px;p{color:", (0, _colors.color_shades_darkest), ";font-size:14px;line-height:20px;}");
const ToggleButton = /*#__PURE__*/ (0, _baseDefault.default)("button", {
    target: "e2hhkev1"
})("display:flex;align-items:center;cursor:pointer;flex:1;border:none;background-color:transparent;cursor:pointer;text-align:left;padding:0;border-right:", (0, _stylesValues.style_border_default), ";margin-right:16px;&.no-backup{margin-right:0;border-right:none;}p{margin-right:4px;}");
const SaveBackupButton = /*#__PURE__*/ (0, _baseDefault.default)("button", {
    target: "e2hhkev0"
})({
    name: "1on4vlg",
    styles: "display:flex;align-items:center;justify-content:center;height:16px;border:none;background-color:transparent;cursor:pointer;padding:0;p{margin-right:8px;}"
});
exports.default = ApplicationHistoryToolbar;

},{"@emotion/styled/base":"lSuFu","@emotion/react":"djZKr","react":"6uln9","../../../constants/stylesValues":"dHVVv","../../../components/general/ToggleIndicator":"4eej1","../../../components/general/TooltipWrapper":"53pWd","../../../components/general/SecondaryLoader":"7zJiF","../../../constants/colors":"1p3OR","bcb50a9ab04407b4":"cY8IH","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"cY8IH":[function(require,module,exports) {
module.exports = require("bfe1f10f9a5ce64c").getBundleURL("kVLro") + require("7c484983ac4d453a").resolve("hL7ub");

},{"bfe1f10f9a5ce64c":"c7Tr5","7c484983ac4d453a":"fyJL2"}],"aqO4p":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _unstated = require("unstated");
var _applicationBackupVersionsContainer = require("../../state/containers/ApplicationBackupVersionsContainer");
var _applicationBackupVersionsContainerDefault = parcelHelpers.interopDefault(_applicationBackupVersionsContainer);
var _applicationEnvironmentsContainer = require("../../state/containers/ApplicationEnvironmentsContainer");
var _applicationEnvironmentsContainerDefault = parcelHelpers.interopDefault(_applicationEnvironmentsContainer);
var _memberContainer = require("../../state/containers/MemberContainer");
var _memberContainerDefault = parcelHelpers.interopDefault(_memberContainer);
var _organizationContainer = require("../../state/containers/OrganizationContainer");
var _organizationContainerDefault = parcelHelpers.interopDefault(_organizationContainer);
var _publishHistory = require("./components/PublishHistory");
var _publishHistoryDefault = parcelHelpers.interopDefault(_publishHistory);
const PublishHistoryPanel = (props)=>(0, _react.jsx)((0, _unstated.Subscribe), {
        to: [
            (0, _applicationBackupVersionsContainerDefault.default),
            (0, _memberContainerDefault.default),
            (0, _applicationEnvironmentsContainerDefault.default),
            (0, _organizationContainerDefault.default)
        ]
    }, (backupVersionsContainer, memberContainer, environmentContainer, orgContainer)=>(0, _react.jsx)((0, _publishHistoryDefault.default), {
            onClose: props.onClose,
            contentId: props.contentId,
            contentItemContainer: props.contentItemContainer,
            applicationId: props.applicationId,
            organizationId: orgContainer.state.currentOrganization?.id,
            backupsContainer: backupVersionsContainer,
            memberContainer: memberContainer,
            environmentsContainer: environmentContainer
        }));
exports.default = PublishHistoryPanel;

},{"@emotion/react":"djZKr","react":"6uln9","unstated":"grh7p","../../state/containers/ApplicationBackupVersionsContainer":"6rA1P","../../state/containers/ApplicationEnvironmentsContainer":"jCULY","../../state/containers/MemberContainer":"iYQOb","../../state/containers/OrganizationContainer":"dlbaM","./components/PublishHistory":"9ekQI","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6rA1P":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _defineProperty = require("@babel/runtime/helpers/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _unstated = require("unstated");
var _api = require("../../api");
class ApplicationBackupVersionsContainer extends (0, _unstated.Container) {
    constructor(...args){
        super(...args);
        (0, _definePropertyDefault.default)(this, "state", {
            backupVersions: [],
            errors: [],
            isLoading: false,
            isCreating: false,
            isDeleting: false,
            pollingIds: []
        });
    }
    async loadBackupVersions(applicationId) {
        try {
            await this.setState({
                ...this.state,
                isLoading: true
            });
            const result = await _api.getApplicationBackupVersions(applicationId);
            if (result.resultType == "Ok") await this.setState({
                ...this.state,
                backupVersions: result.data,
                isLoading: false,
                errors: []
            });
            else await this.setState({
                ...this.state,
                errors: result.errors,
                isLoading: false
            });
            return result;
        } catch (error) {
            await this.setState({
                ...this.state,
                errors: [
                    error.toString()
                ],
                isLoading: false
            });
        }
    }
    async queueCreateFullBackup(applicationId, model) {
        try {
            await this.setState({
                ...this.state,
                isCreating: true
            });
            const result = await _api.queueCreateNewBackupVersion(applicationId, model);
            if (result.resultType == "Ok") await this.setState({
                ...this.state,
                backupVersions: [
                    result.data,
                    ...this.state.backupVersions
                ],
                isCreating: false,
                errors: []
            });
            else await this.setState({
                ...this.state,
                errors: result.errors,
                isCreating: false
            });
            return result;
        } catch (error) {
            await this.setState({
                ...this.state,
                errors: [
                    error.toString()
                ],
                isCreating: false
            });
        }
    }
    async queueCreatePartialBackup(applicationId, model) {
        try {
            await this.setState({
                ...this.state,
                isCreating: true
            });
            const result = await _api.queueCreateNewPartialBackupVersion(applicationId, model);
            if (result.resultType == "Ok") await this.setState({
                ...this.state,
                backupVersions: [
                    result.data,
                    ...this.state.backupVersions
                ],
                isCreating: false,
                errors: []
            });
            else await this.setState({
                ...this.state,
                errors: result.errors,
                isCreating: false
            });
            return result;
        } catch (error) {
            await this.setState({
                ...this.state,
                errors: [
                    error.toString()
                ],
                isCreating: false
            });
        }
    }
    async updateApplicationBackupVersion(applicationVersionId, model) {
        await this.setState({
            ...this.state,
            backupVersions: this.state.backupVersions.map((b)=>b.id == applicationVersionId ? {
                    ...b,
                    name: model.name
                } : b)
        });
        const result = await _api.updateApplicationBackupVersion(applicationVersionId, model);
        if (result.resultType == "Ok") await this.setState({
            ...this.state,
            backupVersions: this.state.backupVersions.map((b)=>b.id == applicationVersionId ? result.data : b),
            errors: []
        });
        else await this.setState({
            ...this.state,
            errors: result.errors
        });
        return result;
    }
    async reloadBackupVersion(applicationVersionId) {
        try {
            const result = await _api.findBackupVersionById(applicationVersionId);
            if (result.resultType == "Ok") await this.setState({
                ...this.state,
                backupVersions: this.state.backupVersions.map((b)=>b.id == applicationVersionId ? result.data : b),
                errors: []
            });
            else await this.setState({
                ...this.state,
                errors: result.errors
            });
            return result;
        } catch (error) {
            await this.setState({
                ...this.state,
                errors: [
                    error.toString()
                ]
            });
        }
    }
    async deleteBackupVersion(applicationVersionId) {
        await this.setState({
            ...this.state,
            isDeleting: true
        });
        try {
            const result = await _api.disableApplicationBackupVersion(applicationVersionId);
            if (result.resultType == "Ok") await this.setState({
                ...this.state,
                backupVersions: this.state.backupVersions.filter((b)=>b.id != applicationVersionId),
                errors: [],
                isDeleting: false
            });
            else await this.setState({
                ...this.state,
                errors: result.errors,
                isDeleting: false
            });
            return result;
        } catch (error) {
            await this.setState({
                ...this.state,
                errors: [
                    error.toString()
                ],
                isDeleting: false
            });
        }
    }
    async downloadArchive(applicationArchiveId) {
        try {
            const result = await _api.getArchive(applicationArchiveId);
            if (result.resultType == "Ok") window.open(result.data.fileUrl, "_blank").focus();
            return result;
        } catch (error) {
            await this.setState({
                ...this.state,
                errors: [
                    error.toString()
                ]
            });
        }
    }
    async clearErrors() {
        await this.setState({
            ...this.state,
            errors: []
        });
    }
    async addBackup(backup) {
        await this.setState({
            ...this.state,
            backupVersions: [
                backup,
                ...this.state.backupVersions
            ]
        });
    }
    async waitForBackup(backupId) {
        try {
            let checking = true;
            let checkCount = 0;
            if (this.state.pollingIds.some((s)=>s == backupId)) return;
            else await this.setState({
                ...this.state,
                pollingIds: [
                    ...this.state.pollingIds,
                    backupId
                ]
            });
            // 450 loops, 2 second pause per loop = ~ 15 minutes of polling (which matches lambda timeout)
            while(checking && checkCount < 450){
                const result = await _api.findBackupVersionById(backupId);
                checkCount++;
                if (result.resultType == "Ok") {
                    const backup = result.data;
                    await this.setState({
                        ...this.state,
                        backupVersions: this.state.backupVersions.map((b)=>b.id == backup.id ? backup : b)
                    });
                    switch(backup?.applicationArchive?.stage){
                        case "Processing":
                        case "Queued":
                            await new Promise((r)=>setTimeout(r, 2000));
                            break;
                        case "Complete":
                            if (backup?.applicationArchive?.error) {
                                await this.setState({
                                    ...this.state,
                                    isLoading: false,
                                    pollingIds: this.state.pollingIds.filter((i)=>i != backupId),
                                    errors: [
                                        backup?.applicationArchive?.error
                                    ]
                                });
                                return {
                                    data: null,
                                    resultType: "Invalid",
                                    errors: [
                                        backup?.applicationArchive?.stage
                                    ]
                                };
                            } else {
                                await this.setState({
                                    ...this.state,
                                    isLoading: false,
                                    pollingIds: this.state.pollingIds.filter((i)=>i != backupId),
                                    errors: []
                                });
                                return result;
                            }
                            break;
                        default:
                            await this.setState({
                                ...this.state,
                                isLoading: false,
                                pollingIds: this.state.pollingIds.filter((i)=>i != backupId),
                                errors: [
                                    "Unknown issue with backup"
                                ]
                            });
                            return {
                                data: null,
                                resultType: "Invalid",
                                errors: [
                                    "Unknown issue with backup"
                                ]
                            };
                    }
                } else this.setState({
                    ...this.state,
                    isLoading: false,
                    errors: result.errors
                });
            }
            // we've timed out.
            await this.setState({
                ...this.state,
                isLoading: false,
                pollingIds: this.state.pollingIds.filter((i)=>i != backupId),
                errors: [
                    "Backup timed out"
                ]
            });
        } catch (e) {
            await this.setState({
                ...this.state,
                isLoading: false,
                errors: [
                    e?.toString()
                ]
            });
        }
    }
}
exports.default = ApplicationBackupVersionsContainer;

},{"@babel/runtime/helpers/defineProperty":"9sJxO","unstated":"grh7p","../../api":"loxM6","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jCULY":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _defineProperty = require("@babel/runtime/helpers/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _unstated = require("unstated");
var _api = require("../../api");
class ApplicationEnvironmentsContainer extends (0, _unstated.Container) {
    constructor(...args){
        super(...args);
        (0, _definePropertyDefault.default)(this, "state", {
            publishes: [],
            environments: [],
            errors: [],
            isLoading: false,
            isCreating: false,
            pollingIds: [],
            currentAppId: ""
        });
    }
    // If Application's environments were alreday retrieved, then get them from state
    // If not - retrieve Application's environments and set state 
    // If no environemnts found at all set errors
    async loadEnvironments(applicationId, force = false) {
        try {
            if (this.state.currentAppId == applicationId && this.state.environments?.length > 0 && !force) {
                const applicationEnvironments = this.state.environments;
                return {
                    data: applicationEnvironments,
                    resultType: "Ok",
                    errors: []
                };
            }
            this.setState({
                isLoading: true,
                environments: [],
                currentAppId: applicationId
            });
            const result = await _api.getApplicationEnvironments(applicationId);
            if (result.resultType == "Ok") {
                const applicationEnvironments = result.data;
                if (applicationEnvironments?.length > 0) await this.setState({
                    environments: applicationEnvironments,
                    isLoading: false
                });
                else await this.setState({
                    isLoading: false,
                    errors: [
                        "No environments found."
                    ]
                });
            } else await this.setState({
                isLoading: false,
                errors: result.errors
            });
            return result;
        } catch (error) {
            this.setState({
                errors: [
                    error.message
                ],
                isLoading: false,
                currentAppId: applicationId
            });
        }
    }
    // If we have Live/Production environment then return it, if not return Draft environment
    // All apps are suppose to have Production environment
    findPrimaryEnvironment(applicationId) {
        let env = this.findLiveEnvironment(applicationId);
        if (!env) env = this.findDraftEnvironment(applicationId);
        if (!env) this.setState({
            ...this.state,
            errors: [
                ...this.state.errors,
                "Unable to find application's Primary environment."
            ]
        });
        return env;
    }
    findLiveEnvironment(applicationId) {
        return this.state.environments.find((e)=>e.applicationId === applicationId && !e.isCustom && !e.isDraft);
    }
    findDraftEnvironment(applicationId) {
        return this.state.environments.find((e)=>e.applicationId === applicationId && !e.isCustom && e.isDraft);
    }
    findEnvironmentByOption(applicationId, environmentOption) {
        if (environmentOption === "live") {
            const env = this.findLiveEnvironment(applicationId);
            if (!env) this.setState({
                ...this.state,
                errors: [
                    ...this.state.errors,
                    "Unable to find application's Live(Production) environment."
                ]
            });
            return env;
        }
        if (environmentOption === "draft") {
            const env = this.findDraftEnvironment(applicationId);
            if (!env) this.setState({
                ...this.state,
                errors: [
                    ...this.state.errors,
                    "Unable to find application's Draft(Test) environment."
                ]
            });
            return env;
        }
        this.setState({
            ...this.state,
            errors: [
                ...this.state.errors,
                "Invalid environment option"
            ]
        });
        return null;
    }
    // Update Application Environment Settings
    updateEnvironmentSettings(applicationId, environmentId, model) {
        this.setState({
            ...this.state,
            isCreating: true
        });
        var promise = _api.updateEnvironmentSettings(environmentId, model);
        promise.then((result)=>{
            if (result.resultType != "Ok") this.setState({
                ...this.state,
                isCreating: false,
                errors: result.errors
            });
            else {
                const appEnvironments = this.state.environments;
                // update the environment locally
                const updatedEnvironment = appEnvironments?.find((e)=>e.applicationId === applicationId && e.id === environmentId);
                if (updatedEnvironment) {
                    updatedEnvironment.applicationInformationItems = result.data.applicationInformationItems;
                    updatedEnvironment.name = result.data.name; // Environment Name
                    updatedEnvironment.applicationName = result.data.applicationName;
                    updatedEnvironment.imageItemId = result.data.imageItemId;
                    updatedEnvironment.invocationPhrase = result.data.invocationPhrase;
                    updatedEnvironment.description = result.data.description;
                    updatedEnvironment.shortDescription = result.data.shortDescription;
                    updatedEnvironment.keywords = result.data.keywords;
                    updatedEnvironment.imageItemId = result.data.imageItemId;
                } else appEnvironments.push(result.data);
                this.setState({
                    ...this.state,
                    isCreating: false,
                    environments: appEnvironments,
                    errors: [],
                    currentAppId: applicationId
                });
            }
        }).catch((error)=>{
            this.setState({
                ...this.state,
                isCreating: false,
                errors: [
                    error.toString()
                ]
            });
        });
        return promise;
    }
    buildPublishCacheKey(skip, take) {
        return `${skip}-${take}`;
    }
    async loadPublishes(applicationId, skip = 0, take = 50, append = false) {
        try {
            if (this.state.currentAppId != applicationId || skip == 0) await this.setState({
                ...this.state,
                publishes: [],
                environments: []
            });
            await this.setState({
                ...this.state,
                isLoading: true
            });
            let environments = this.state.environments;
            if (this.state.environments.length == 0) {
                var environmentResults = await _api.getApplicationEnvironments(applicationId);
                if (environmentResults.resultType == "Ok") {
                    await this.setState({
                        ...this.state,
                        environments: environmentResults.data,
                        isLoading: false
                    });
                    environments = environmentResults.data;
                } else await this.setState({
                    ...this.state,
                    errors: environmentResults.errors,
                    isLoading: false
                });
            }
            const result = await _api.getEnvironmentPublishes(environments.find((e)=>!e.isDraft && !e.isCustom).id, skip, take);
            if (result.resultType == "Ok") {
                skip = 0;
                if (append) {
                    const newPublishes = [
                        ...this.state.publishes,
                        ...result.data
                    ];
                    await this.setState({
                        ...this.state,
                        publishes: [
                            ...this.state.publishes,
                            ...result.data
                        ],
                        isLoading: false,
                        errors: [],
                        currentAppId: applicationId
                    });
                } else await this.setState({
                    ...this.state,
                    publishes: result.data,
                    isLoading: false,
                    errors: []
                });
            } else await this.setState({
                ...this.state,
                errors: result.errors,
                isLoading: false
            });
            return result;
        } catch (error) {
            await this.setState({
                ...this.state,
                errors: [
                    error.toString()
                ],
                isLoading: false
            });
        }
    }
    async queuePublishBackup(applicationEnvironmentId, backupVersionId) {
        try {
            await this.setState({
                ...this.state,
                isCreating: true
            });
            const result = await _api.queuePublishToEnvironment(applicationEnvironmentId, backupVersionId);
            if (result.resultType == "Ok") await this.setState({
                ...this.state,
                publishes: [
                    result.data,
                    ...this.state.publishes
                ],
                isCreating: false,
                errors: []
            });
            else await this.setState({
                ...this.state,
                errors: result.errors,
                isCreating: false
            });
            return result;
        } catch (error) {
            await this.setState({
                ...this.state,
                errors: [
                    error.toString()
                ],
                isCreating: false
            });
        }
    }
    async queueFullBackupAndPublish(applicationId, applicationEnvironmentId, model) {
        try {
            await this.setState({
                ...this.state,
                isCreating: true
            });
            const result = await _api.queueBackupAndPublishApplication(applicationId, applicationEnvironmentId, model);
            if (result.resultType == "Ok") await this.setState({
                ...this.state,
                isCreating: false,
                errors: []
            });
            else await this.setState({
                ...this.state,
                errors: result.errors,
                isCreating: false
            });
            return result;
        } catch (error) {
            await this.setState({
                ...this.state,
                errors: [
                    error.toString()
                ],
                isCreating: false
            });
        }
    }
    async queuePartialBackupAndPublish(applicationId, applicationEnvironmentId, model) {
        try {
            await this.setState({
                ...this.state,
                isCreating: true
            });
            const result = await _api.queueBackupAndPublishPartialApplication(applicationId, applicationEnvironmentId, model);
            if (result.resultType == "Ok") await this.setState({
                ...this.state,
                isCreating: false,
                errors: []
            });
            else await this.setState({
                ...this.state,
                errors: result.errors,
                isCreating: false
            });
            return result;
        } catch (error) {
            await this.setState({
                ...this.state,
                errors: [
                    error.toString()
                ],
                isCreating: false
            });
        }
    }
    async unpublishContentItems(applicationEnvironmentId, request) {
        try {
            await this.setState({
                ...this.state,
                isLoading: true
            });
            const result = await _api.unpublishContentItemsFromEnvironment(applicationEnvironmentId, request);
            if (result.resultType == "Ok") await this.setState({
                ...this.state,
                isLoading: false,
                errors: []
            });
            else await this.setState({
                ...this.state,
                errors: result.errors,
                isLoading: false
            });
            return result;
        } catch (error) {
            await this.setState({
                ...this.state,
                errors: [
                    error.toString()
                ],
                isCreating: false
            });
        }
    }
    async addPublish(publish) {
        await this.setState({
            ...this.state,
            publishes: [
                publish,
                ...this.state.publishes
            ]
        });
    }
    async waitForPublish(publishId) {
        try {
            let checking = true;
            let checkCount = 0;
            if (this.state.pollingIds.some((s)=>s == publishId)) return;
            else await this.setState({
                ...this.state,
                pollingIds: [
                    ...this.state.pollingIds,
                    publishId
                ]
            });
            // 900 loops, 2 second pause per loop = ~ 30 minutes of polling (which matches lambda timeout of a potential backup and publish 2x15min)
            while(checking && checkCount < 900){
                const result = await _api.findEnvironmentPubishById(publishId);
                checkCount++;
                if (result.resultType == "Ok") {
                    const publish = result.data;
                    await this.setState({
                        ...this.state,
                        publishes: this.state.publishes.map((p)=>p.id == publish.id ? publish : p)
                    });
                    switch(publish.stage){
                        case "Processing":
                        case "Queued":
                            await new Promise((r)=>setTimeout(r, 2000));
                            break;
                        case "Complete":
                            if (publish.error) {
                                await this.setState({
                                    ...this.state,
                                    pollingIds: this.state.pollingIds.filter((i)=>i != publishId),
                                    errors: [
                                        publish.error
                                    ]
                                });
                                return {
                                    data: null,
                                    resultType: "Invalid",
                                    errors: [
                                        publish.error
                                    ]
                                };
                            } else {
                                await this.setState({
                                    ...this.state,
                                    pollingIds: this.state.pollingIds.filter((i)=>i != publishId),
                                    errors: []
                                });
                                return result;
                            }
                            break;
                        default:
                            await this.setState({
                                ...this.state,
                                pollingIds: this.state.pollingIds.filter((i)=>i != publishId),
                                errors: [
                                    "Unknown issue with publish"
                                ]
                            });
                            return {
                                data: null,
                                resultType: "Invalid",
                                errors: [
                                    "Unknown issue with publish"
                                ]
                            };
                    }
                } else this.setState({
                    ...this.state,
                    isLoading: false,
                    errors: result.errors
                });
            }
            // we've timed out.
            await this.setState({
                ...this.state,
                isLoading: false,
                pollingIds: this.state.pollingIds.filter((i)=>i != publishId),
                errors: [
                    "Publish timed out"
                ]
            });
        } catch (e) {
            await this.setState({
                ...this.state,
                isLoading: false,
                errors: [
                    e?.toString()
                ]
            });
        }
    }
    async clearErrors() {
        await this.setState({
            ...this.state,
            errors: []
        });
    }
}
exports.default = ApplicationEnvironmentsContainer;

},{"@babel/runtime/helpers/defineProperty":"9sJxO","unstated":"grh7p","../../api":"loxM6","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"iYQOb":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _defineProperty = require("@babel/runtime/helpers/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _unstated = require("unstated");
var _api = require("../../api");
class MemberContainer extends (0, _unstated.Container) {
    constructor(...args){
        super(...args);
        // default state
        (0, _definePropertyDefault.default)(this, "state", this.getInitialState());
    }
    getInitialState() {
        // check local storage for initial state
        const state = {
            members: [],
            invitations: [],
            isLoadingMembers: false,
            isLoading: false,
            isUpdating: false,
            isOrgAdmin: false,
            errors: [],
            organizationMemberListPreferences: null
        };
        const storedPreferences = localStorage.getItem("ORG_MEMBER_LIST_PREFERENCES");
        if (storedPreferences != null) state.organizationMemberListPreferences = JSON.parse(storedPreferences);
        return state;
    }
    updateOrganizationMemberListPreferences(preferences) {
        this.setState({
            ...this.state,
            organizationMemberListPreferences: preferences
        });
        localStorage.setItem("ORG_MEMBER_LIST_PREFERENCES", JSON.stringify(preferences));
    }
    getInvitations(organizationId) {
        if (this.state.members.length > 0) return new Promise((resolve)=>{
            resolve({
                resultType: "Ok",
                errors: [],
                data: this.state.members
            });
        });
        this.setLoadingMembers(true);
        const promise = _api.getInvitations(organizationId);
        promise.then((invitationsResult)=>{
            if (invitationsResult.resultType == "Ok") this.setState({
                ...this.state,
                errors: [],
                invitations: invitationsResult.data,
                isLoading: false
            });
            else this.setState({
                ...this.state,
                errors: invitationsResult.errors,
                isLoading: false
            });
        }).catch((error)=>{
            console.log(error);
        });
        return promise;
    }
    async getMembers(organizationId) {
        try {
            if (this.state.members.length > 0) return new Promise((resolve)=>{
                resolve({
                    resultType: "Ok",
                    errors: [],
                    data: this.state.members
                });
            });
            await this.setState({
                ...this.state,
                isLoadingMembers: false
            });
            this.setLoadingMembers(true);
            const membersResult = await _api.getDetailedMemberships(organizationId);
            if (membersResult.resultType == "Ok") {
                var members = membersResult.data?.filter((m)=>m.email?.endsWith("review-user.com") !== true);
                await this.setState({
                    ...this.state,
                    errors: [],
                    members: members,
                    isLoadingMembers: false
                });
            } else await this.setState({
                ...this.state,
                errors: membersResult.errors,
                isLoadingMembers: false
            });
            return membersResult;
        } catch (error) {
            console.log(error);
        }
    }
    inviteMember(organizationId, request) {
        this.setState({
            ...this.state,
            isLoading: true
        });
        var promise = _api.sendInvitation(organizationId, request);
        promise.then((result)=>{
            if (result.resultType == "Ok") this.setState({
                ...this.state,
                isLoading: false,
                errors: [],
                invitations: [
                    ...this.state.invitations,
                    result.data
                ]
            });
            else this.setState({
                ...this.state,
                isLoading: false,
                errors: result.errors
            });
        }).catch((error)=>{
            this.setState({
                ...this.state,
                isLoading: false,
                errors: [
                    error
                ]
            });
        });
        return promise;
    }
    async inviteSparkForm(organizationId, request) {
        this.setState({
            ...this.state,
            isLoading: true
        });
        const result = await _api.sendSparkFormInvitation(organizationId, request);
        if (result.resultType !== "Ok") this.setState({
            ...this.state,
            isLoading: false,
            errors: result.errors
        });
        else this.setState({
            ...this.state,
            isLoading: false,
            errors: [],
            invitations: [
                ...this.state.invitations,
                result.data
            ]
        });
        return result;
    }
    async checkIsOrgAdmin(organizationId, userId) {
        let members = this.state.members;
        if (members == null || members.length == 0) {
            const memberResult = await this.getMembers(organizationId);
            members = memberResult.data;
        }
        var currentMember = members?.find((m)=>m.userId == userId);
        const isOrgAdmin = currentMember?.isAdmin ?? false;
        this.setState({
            ...this.state,
            isOrgAdmin
        });
        return isOrgAdmin;
    }
    async updateMemberReceivesAnalyticsEmail(organizationMemberId, shouldReceiveAnalyticsEmails) {
        try {
            await this.setState({
                ...this.state,
                isLoading: true
            });
            var result = await _api.updateMemberReceivesAnalyticsEmail(organizationMemberId, shouldReceiveAnalyticsEmails);
            if (result.resultType == "Ok") {
                const index = this.state.members.findIndex((i)=>i.id == organizationMemberId);
                const newMembers = [
                    ...this.state.members
                ];
                newMembers[index].receivesAnalyticsEmail = result.data.receivesAnalyticsEmail;
                this.setState({
                    ...this.state,
                    errors: [],
                    members: newMembers
                });
            } else this.setState({
                ...this.state,
                errors: result.errors
            });
        } catch (e) {
            await this.setState({
                ...this.state,
                isLoading: false,
                errors: [
                    e?.toString()
                ]
            });
            return {
                errors: [
                    "Unexpected error"
                ],
                data: null,
                resultType: "Unexpected"
            };
        }
    }
    async revokeInvitation(invitationId) {
        try {
            await this.setState({
                ...this.state,
                isLoading: true
            });
            var result = await _api.revokeInvitation(invitationId);
            if (result.resultType == "Ok") {
                let invitations = [
                    ...this.state.invitations
                ];
                const idx = invitations.findIndex((i)=>i.id == invitationId);
                if (idx > -1) {
                    invitations.splice(idx, 1);
                    await this.setState({
                        ...this.state,
                        isLoading: false,
                        invitations: invitations
                    });
                }
            } else await this.setState({
                ...this.state,
                isLoading: false,
                errors: result.errors
            });
            return result;
        } catch (e) {
            await this.setState({
                ...this.state,
                isLoading: false,
                errors: [
                    e?.toString()
                ]
            });
            return {
                errors: [
                    "Unexpected error"
                ],
                data: null,
                resultType: "Unexpected"
            };
        }
    }
    resendInvitation(organizationid, invitation) {
        this.setState({
            ...this.state,
            isLoading: true
        });
        var promise = _api.revokeInvitation(invitation.id);
        promise.then((result)=>{
            if (result.resultType == "Ok") {
                var newPromise = _api.sendInvitation(organizationid, {
                    email: invitation.email,
                    isAdmin: invitation.isAdmin,
                    isAddedToApplications: invitation.isAddedToApplications,
                    applicationRoleId: invitation.roleId
                });
                newPromise.then((result)=>{
                    if (result.resultType == "Ok") {
                        const index = this.state.invitations.findIndex((i)=>i.id == invitation.id);
                        const newInvitations = [
                            ...this.state.invitations
                        ];
                        newInvitations[index] = result.data;
                        this.setState({
                            ...this.state,
                            isLoading: false,
                            errors: [],
                            invitations: newInvitations
                        });
                    } else this.setState({
                        ...this.state,
                        isLoading: false,
                        errors: result.errors
                    });
                }).catch((error)=>{
                    this.setState({
                        ...this.state,
                        isLoading: false,
                        errors: [
                            error
                        ]
                    });
                });
            } else this.setState({
                ...this.state,
                isLoading: false,
                errors: result.errors
            });
        }).catch((error)=>{
            this.setState({
                ...this.state,
                isLoading: false,
                errors: [
                    error
                ]
            });
        });
        return promise;
    }
    updateMemberRole(organizationMemberId, userRoleId) {
        var promise = _api.updateMemberRole(organizationMemberId, userRoleId);
        promise.then((result)=>{
            if (result.resultType == "Ok") {
                const index = this.state.members.findIndex((i)=>i.id == organizationMemberId);
                const newMembers = [
                    ...this.state.members
                ];
                newMembers[index].isAdmin = result.data.isAdmin;
                this.setState({
                    ...this.state,
                    errors: [],
                    members: newMembers
                });
            } else this.setState({
                ...this.state,
                errors: result.errors
            });
        }).catch((error)=>{
            this.setState({
                ...this.state,
                errors: [
                    error
                ]
            });
        });
        return promise;
    }
    removeMemberFromOrg(organizationMemberId) {
        this.setState({
            ...this.state,
            isUpdating: true
        });
        var promise = _api.removeMember(organizationMemberId);
        promise.then((result)=>{
            if (result.resultType == "Ok") this.setState({
                ...this.state,
                isUpdating: false,
                members: this.state.members.filter((m)=>m.id != organizationMemberId)
            });
            else this.setState({
                ...this.state,
                isUpdating: false,
                errors: result.errors
            });
        }).catch((error)=>{
            this.setState({
                ...this.state,
                isUpdating: false,
                errors: [
                    error
                ]
            });
        });
        return promise;
    }
    leaveOrganization(organizationMemberId, organizationId) {
        this.setState({
            ...this.state,
            isUpdating: true
        });
        var promise = _api.leaveOrganization(organizationId);
        promise.then((result)=>{
            if (result.resultType == "Ok") this.setState({
                ...this.state,
                isUpdating: false,
                members: this.state.members.filter((m)=>m.id != organizationMemberId)
            });
            else this.setState({
                ...this.state,
                isUpdating: false,
                errors: result.errors
            });
        }).catch((error)=>{
            this.setState({
                ...this.state,
                isUpdating: false,
                errors: [
                    error
                ]
            });
        });
        return promise;
    }
    setLoadingMembers(isLoading) {
        this.setState({
            ...this.state,
            isLoadingMembers: isLoading
        });
    }
    setLoading(isLoading) {
        this.setState({
            ...this.state,
            isLoading: isLoading
        });
    }
}
exports.default = MemberContainer;

},{"@babel/runtime/helpers/defineProperty":"9sJxO","unstated":"grh7p","../../api":"loxM6","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9ekQI":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _base = require("@emotion/styled/base");
var _baseDefault = parcelHelpers.interopDefault(_base);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _secondaryLoader = require("../../../components/general/SecondaryLoader");
var _secondaryLoaderDefault = parcelHelpers.interopDefault(_secondaryLoader);
var _stylesValues = require("../../../constants/stylesValues");
var _colors = require("../../../constants/colors");
var _css = require("@emotion/css");
var _userAvatar = require("../../../components/general/UserAvatar");
var _userAvatarDefault = parcelHelpers.interopDefault(_userAvatar);
var _smallOverflowMenu = require("../../../components/general/overflowMenu/SmallOverflowMenu");
var _smallOverflowMenuDefault = parcelHelpers.interopDefault(_smallOverflowMenu);
var _confirmationDialog = require("../../../components/structure/ConfirmationDialog");
var _confirmationDialogDefault = parcelHelpers.interopDefault(_confirmationDialog);
var _deleteConfirmation = require("../../featureContent/components/DeleteConfirmation");
var _deleteConfirmationDefault = parcelHelpers.interopDefault(_deleteConfirmation);
var _warningConfirmation = require("../../../components/general/WarningConfirmation");
var _warningConfirmationDefault = parcelHelpers.interopDefault(_warningConfirmation);
var _lodash = require("lodash");
var _lodashDefault = parcelHelpers.interopDefault(_lodash);
var _moment = require("moment");
var _momentDefault = parcelHelpers.interopDefault(_moment);
var _publishDetailsModal = require("./PublishDetailsModal");
var _publishDetailsModalDefault = parcelHelpers.interopDefault(_publishDetailsModal);
var _tooltipWrapper = require("../../../components/general/TooltipWrapper");
var _tooltipWrapperDefault = parcelHelpers.interopDefault(_tooltipWrapper);
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const closeIcon = require("800fca2bad86f3b");
const fullPublishIcon = require("7e5ea82dc440644c");
const unpublishIcon = require("2f0f86925909e1fb");
const errorIcon = require("76927ed4bd44335f");
const partialPublishIcon = require("d2344c8c86964e8b");
const backupCloudIcon = require("f3700cfa74dc1ce5");
const RenameLabel = "Rename";
const DeleteLabel = "Delete from history";
const PublishLabel = "Publish this version";
const DownloadLabel = "Download";
const ViewDetailsLabel = "View publishing details";
const DATE_FORMAT = "YYYY-MM-DDThh:mm:ss";
const PublishHistory = ({ backupsContainer, memberContainer, environmentsContainer, applicationId, organizationId, onClose, contentItemContainer, contentId })=>{
    const [renameItem, setRenameItem] = (0, _react1.useState)(null);
    const [renameItemValue, setRenameItemValue] = (0, _react1.useState)("");
    const [deletingItem, setDeletingItem] = (0, _react1.useState)(null);
    const [publishingItem, setPublishingItem] = (0, _react1.useState)(null);
    const [detailsItem, setDetailsItem] = (0, _react1.useState)(null);
    const [componentLoaded, setComponentLoaded] = (0, _react1.useState)(false);
    const [items, setItems] = (0, _react1.useState)([]);
    const [latestFullPublish, setLatestFullPublish] = (0, _react1.useState)("");
    const isLoading = !componentLoaded || backupsContainer.state.isLoading || environmentsContainer.state.isLoading || memberContainer.state.isLoading;
    (0, _react1.useEffect)(()=>{
        const applicationHistoryLoad = async ()=>{
            const utcThirtyMinutesAgo = (0, _momentDefault.default).utc().subtract(30, "minutes");
            const backupsResult = await backupsContainer.loadBackupVersions(applicationId);
            let skip = 0;
            let publishResult = await environmentsContainer.loadPublishes(applicationId, skip, 50, false);
            let loadedPublishes = [
                ...publishResult.data
            ];
            while(publishResult && publishResult.data.length > 49){
                skip = skip + 50;
                publishResult = await environmentsContainer.loadPublishes(applicationId, skip, 50, true);
                loadedPublishes = [
                    ...loadedPublishes,
                    ...publishResult.data
                ];
            }
            backupsResult.data?.forEach((b)=>{
                if (b?.applicationArchive?.stage && b.applicationArchive.stage != "Complete" && (0, _momentDefault.default)(b.applicationArchive.createdDate, DATE_FORMAT).isAfter(utcThirtyMinutesAgo)) backupsContainer.waitForBackup(b.id);
            });
            loadedPublishes?.forEach((p)=>{
                if (p?.stage && p.stage != "Complete" && (0, _momentDefault.default)(p.createdDate, DATE_FORMAT).isAfter(utcThirtyMinutesAgo)) environmentsContainer.waitForPublish(p.id);
            });
            const builtItems = buildApplicationHistoryItems(loadedPublishes, backupsResult.data);
            setItems(builtItems);
            setComponentLoaded(true);
        };
        const contentItemLoad = async ()=>{
            let skip = 0;
            let environments = environmentsContainer.state.environments;
            if (environments.length == 0) {
                var environmentResult = await environmentsContainer.loadEnvironments(applicationId);
                environments = environmentResult.data;
            }
            if (memberContainer.state.members.length == 0) await memberContainer.getMembers(organizationId);
            const envId = environments[0]?.id;
            let publishResult = await contentItemContainer.loadPublishHistory(contentId, envId, skip, 50);
            let loadedPublishes = [
                ...publishResult.data
            ];
            while(publishResult && publishResult.data.length > 49){
                skip = skip + 50;
                publishResult = await contentItemContainer.loadPublishHistory(contentId, envId, skip, 50);
                loadedPublishes = [
                    ...loadedPublishes,
                    ...publishResult.data
                ];
            }
            const builtItems = loadedPublishes.map((publish)=>{
                return {
                    publishType: publish?.publishEventType == "Publish" ? "Full Publish" : "Unpublish",
                    name: publish?.publishEventType == "Unpublish" ? publish.name ?? "Unpublished" : publish.applicationEnvironmentPublish?.applicationBackupVersion?.name ?? "Publish",
                    user: buildUser(publish.createdByUserId),
                    createdDate: publish?.applicationEnvironmentPublish?.createdDate ?? publish?.date,
                    processing: false,
                    id: publish.id,
                    backupId: publish?.applicationEnvironmentPublish?.applicationBackupVersion?.id,
                    archiveId: publish?.applicationEnvironmentPublish?.applicationBackupVersion?.applicationArchiveId,
                    processingText: "Publishing"
                };
            });
            setItems(builtItems);
            setComponentLoaded(true);
        };
        if (contentId) contentItemLoad();
        else applicationHistoryLoad();
    }, []);
    (0, _react1.useEffect)(()=>{
        if (items?.length > 0) {
            const publishedDate = items?.filter((item)=>item.publishType === "Full Publish")?.reduce((prevDateString, currItem)=>{
                const itemPublishDateString = currItem.createdDate;
                if (!prevDateString) return itemPublishDateString;
                const itemPublishDate = (0, _momentDefault.default)(itemPublishDateString, DATE_FORMAT);
                const prevPublishDate = (0, _momentDefault.default)(prevDateString, DATE_FORMAT);
                const isLater = itemPublishDate.isAfter(prevPublishDate);
                if (isLater) return itemPublishDateString;
                return prevDateString;
            }, "");
            setLatestFullPublish(publishedDate);
        }
    }, [
        items
    ]);
    (0, _react1.useEffect)(()=>{
        if (!contentId && componentLoaded) {
            const builtItems = buildApplicationHistoryItems(environmentsContainer.state.publishes, backupsContainer.state.backupVersions);
            setItems(builtItems);
            setComponentLoaded(true);
        }
        memberContainer.getMembers(organizationId);
    }, [
        environmentsContainer.state.publishes,
        backupsContainer.state.backupVersions
    ]);
    (0, _react1.useEffect)(()=>{
        memberContainer.getMembers(organizationId);
    }, [
        organizationId
    ]);
    const buildUser = (userId)=>{
        // If publish created user id is null then it was generated by internal Voicify logic 
        if (!userId) return {
            id: null,
            email: null,
            firstName: "AUTOMATED",
            lastName: ""
        };
        const user = memberContainer.state.members.find((m)=>m.userId === userId);
        return user ?? {
            id: null,
            email: null,
            firstName: "Unknown",
            lastName: "Member"
        };
    };
    const buildApplicationHistoryItems = (publishes, backups)=>{
        const utcThirtyMinutesAgo = (0, _momentDefault.default)().subtract(30, "minutes");
        const backupsHistory = backups.map((backup)=>{
            const complete = backup?.applicationArchive?.stage == "Complete";
            let isTimedOut = false;
            if (!complete) isTimedOut = (0, _momentDefault.default).utc(backup.applicationArchive?.createdDate, DATE_FORMAT).isBefore(utcThirtyMinutesAgo);
            return {
                publishType: backup.applicationArchive?.archiveType == "FullApplication" ? "Full Backup" : "Partial Backup",
                name: backup.name,
                user: buildUser(backup.applicationArchive?.createdByUserId),
                createdDate: backup.createdDate,
                processing: !complete,
                id: backup.id,
                backupId: backup.id,
                archiveId: backup.applicationArchiveId,
                processingText: "Backing Up",
                error: isTimedOut ? "Backup timed out" : backup?.applicationArchive?.error ? backup.applicationArchive.error : null
            };
        });
        const publishesHistory = publishes.map((publish)=>{
            const backup = backupsHistory.find((b)=>b.backupId === publish.applicationBackupVersionId);
            const complete = publish.stage == "Complete";
            let isTimedOut = false;
            if (!complete) isTimedOut = (0, _momentDefault.default).utc(publish.createdDate, DATE_FORMAT).isBefore(utcThirtyMinutesAgo);
            return {
                publishType: backup?.publishType == "Full Backup" ? "Full Publish" : "Partial Publish",
                name: backup?.name ?? "Unknown",
                user: buildUser(publish.createdByUserId),
                createdDate: publish.createdDate,
                processing: !complete,
                id: publish.id,
                backupId: backup?.id,
                archiveId: backup?.archiveId,
                processingText: "Publishing",
                error: isTimedOut ? "Publish timed out" : publish?.error ? publish.error : null
            };
        });
        return (0, _lodashDefault.default).sortBy(backupsHistory.filter((b)=>b.publishType == "Full Backup").concat(publishesHistory), (item)=>item.createdDate).reverse();
    };
    const getItemIcon = (item)=>{
        if (item.error) return errorIcon;
        switch(item.publishType){
            case "Full Publish":
                return fullPublishIcon;
            case "Partial Publish":
                return partialPublishIcon;
            case "Full Backup":
                return backupCloudIcon;
            case "Unpublish":
                return unpublishIcon;
        }
    };
    const handleOptionOnItem = async (item, option)=>{
        switch(option){
            case RenameLabel:
                setRenameItem(item);
                setRenameItemValue(item.name);
                break;
            case DeleteLabel:
                setDeletingItem(item);
                break;
            case PublishLabel:
                setPublishingItem(item);
                break;
            case DownloadLabel:
                await backupsContainer.downloadArchive(item.archiveId);
                break;
            case ViewDetailsLabel:
                setDetailsItem(item);
                break;
            default:
                alert("Not implemented yet");
        }
    };
    const handleBlurRename = ()=>{
        if (renameItemValue) {
            backupsContainer.updateApplicationBackupVersion(renameItem.backupId, {
                name: renameItemValue
            });
            setRenameItem(null);
        }
        setRenameItem(null);
    };
    const handleKeyDownRename = (e)=>{
        if (e.key === "Enter") handleBlurRename();
    };
    const handleDeleteItem = async ()=>{
        if (deletingItem.publishType === "Full Backup" || deletingItem.publishType === "Partial Backup") await backupsContainer.deleteBackupVersion(deletingItem.backupId);
        // note: not allowing deleting publish events
        setDeletingItem(null);
    };
    const handlePublishItem = async ()=>{
        var publishResult = await environmentsContainer.queuePublishBackup(environmentsContainer.findPrimaryEnvironment(applicationId).id, publishingItem.backupId);
        if (publishResult.resultType == "Ok") environmentsContainer.waitForPublish(publishResult.data.id);
        setPublishingItem(null);
    };
    const getMenuOptions = (item)=>{
        switch(item.publishType){
            case "Full Publish":
            case "Partial Publish":
                return item.backupId ? [
                    {
                        label: DownloadLabel
                    },
                    {
                        label: RenameLabel
                    }
                ] : [];
            case "Full Backup":
            case "Partial Backup":
                return [
                    {
                        label: DownloadLabel
                    },
                    {
                        label: PublishLabel
                    },
                    {
                        label: RenameLabel
                    },
                    {
                        label: DeleteLabel,
                        isDestructive: true
                    }
                ];
        }
        return [];
    };
    const getCircleClassName = (item)=>{
        const publishedDate = (0, _momentDefault.default)(item.createdDate, DATE_FORMAT);
        if (item.publishType === "Partial Publish" && publishedDate.isAfter((0, _momentDefault.default)(latestFullPublish, DATE_FORMAT))) return "latest-partial-publish-circle";
        if (item.publishType === "Full Publish" && publishedDate.isSame((0, _momentDefault.default)(latestFullPublish, DATE_FORMAT))) return "latest-full-publish-circle";
        switch(item.publishType){
            case "Full Publish":
            case "Partial Publish":
                return "publish-circle";
            case "Full Backup":
            case "Partial Backup":
                return "backup-circle";
        }
        return "";
    };
    return (0, _react.jsx)("div", null, (0, _react.jsx)(PanelHeader, null, (0, _react.jsx)(TimelineHeader, null, "Timeline"), (0, _react.jsx)(CloseButton, {
        onClick: ()=>onClose()
    }, (0, _react.jsx)("span", null, "Close"), " ", (0, _react.jsx)("img", {
        src: closeIcon,
        alt: "close"
    }))), isLoading && items.length < 1 && (0, _react.jsx)((0, _secondaryLoaderDefault.default), {
        className: spinnerStyle
    }), !isLoading && items.length == 0 && (0, _react.jsx)((0, _reactDefault.default).Fragment, null, (0, _react.jsx)(EmptyLabelHeader, null, "No Timeline Entries Yet"), (0, _react.jsx)(EmptyLabel, null, "Saving a backup or publishing content will create a copy of your app that can be accessed here")), items.length != 0 && (0, _react.jsx)(Timeline, null, items.map((historyItem)=>{
        return (0, _react.jsx)(TimelineItem, {
            key: historyItem.id,
            className: `timeline-item ${historyItem.publishType == "Partial Publish" || historyItem.publishType == "Partial Backup" ? "partial" : ""}`
        }, (0, _react.jsx)("div", {
            className: "item-header"
        }, (0, _react.jsx)("div", {
            className: "partial-line"
        }), (0, _react.jsx)("span", {
            className: getCircleClassName(historyItem)
        }), (0, _react.jsx)("p", {
            className: "item-name"
        }, historyItem.error ? (0, _react.jsx)((0, _tooltipWrapperDefault.default), {
            place: "right",
            text: historyItem.error
        }, (0, _react.jsx)("img", {
            src: getItemIcon(historyItem),
            alt: "history item"
        })) : (0, _react.jsx)("img", {
            src: getItemIcon(historyItem),
            alt: "history item"
        }), renameItem?.id != null && renameItem?.id == historyItem?.id ? (0, _react.jsx)("input", {
            value: renameItemValue,
            type: "text",
            autoFocus: true,
            onFocus: (e)=>e.target.select(),
            onKeyDown: handleKeyDownRename,
            onBlur: (e)=>handleBlurRename(),
            onChange: (e)=>setRenameItemValue(e.target.value)
        }) : (0, _react.jsx)("span", {
            className: historyItem.error ? "error" : historyItem.processing ? "processing" : ""
        }, historyItem.error ? "Error" : historyItem.processing ? historyItem.processingText : historyItem.name)), !historyItem.error && !historyItem.processing && getMenuOptions(historyItem).length > 0 && (0, _react.jsx)((0, _smallOverflowMenuDefault.default), {
            menuClassName: overflowOptionsStyle,
            optionClassName: overflowOptionStyle,
            buttonClassName: overflowButtonStyle,
            className: overflowStyle,
            options: getMenuOptions(historyItem),
            onOptionSelected: (o)=>handleOptionOnItem(historyItem, o),
            topOptionStyle: topOptionStyle,
            bottomOptionStyle: bottomOptionStyle
        })), (0, _react.jsx)("p", {
            className: "item-date"
        }, (0, _momentDefault.default).utc(historyItem.createdDate, DATE_FORMAT).local().format("MM/DD/YYYY hh:mm a")), (0, _react.jsx)("div", {
            className: "item-user"
        }, historyItem.user.id && (0, _react.jsx)((0, _userAvatarDefault.default), {
            noBackground: true,
            size: 16,
            src: historyItem.user.imageUrl,
            firstName: historyItem.user.firstName,
            lastName: historyItem.user.lastName
        }), (0, _react.jsx)("span", null, historyItem.user.firstName, " ", historyItem.user.lastName)));
    }), isLoading && items.length > 10 && (0, _react.jsx)((0, _secondaryLoaderDefault.default), {
        className: spinnerStyle
    })), deletingItem != null && (0, _react.jsx)((0, _confirmationDialogDefault.default), {
        title: `Delete From History`,
        deleteText: "Yes, Delete",
        isLoading: backupsContainer.state.isDeleting,
        onClose: ()=>setDeletingItem(null),
        onConfirm: ()=>handleDeleteItem()
    }, (0, _react.jsx)((0, _deleteConfirmationDefault.default), {
        itemLabel: `${deletingItem.name}?`
    })), publishingItem != null && (0, _react.jsx)((0, _confirmationDialogDefault.default), {
        title: `Publish Previous Version`,
        deleteText: "Publish",
        warning: true,
        isLoading: environmentsContainer.state.isCreating,
        onClose: ()=>setPublishingItem(null),
        onConfirm: ()=>handlePublishItem()
    }, (0, _react.jsx)((0, _warningConfirmationDefault.default), {
        text: `Restoring ${publishingItem.name} will override any previously published changes.`
    })), detailsItem != null && (0, _react.jsx)((0, _publishDetailsModalDefault.default), {
        applicationId: applicationId,
        publishId: detailsItem.id,
        backupsContainer: backupsContainer,
        environmentsContainer: environmentsContainer,
        onClose: ()=>setDetailsItem(null)
    }));
};
const overflowStyle = /*#__PURE__*/ (0, _css.css)({
    name: "6lsjyp",
    styles: "margin-right:0;margin-left:auto"
});
const overflowButtonStyle = /*#__PURE__*/ (0, _css.css)("border:none;width:24px;height:24px;.circle{width:4px;height:4px;border-color:", (0, _colors.color_text_default), ";}&:hover,&.active{border:1px solid ", (0, _colors.color_colors_ocean), ";.circle{width:4px;height:4px;border-color:", (0, _colors.color_colors_ocean), ";}}", "");
const overflowOptionsStyle = /*#__PURE__*/ (0, _css.css)({
    name: "1umtvie",
    styles: "width:156px;margin-left:-122px;border-radius:4px"
});
const topOptionStyle = /*#__PURE__*/ (0, _css.css)({
    name: "1qqe0i1",
    styles: "border-top-right-radius:4px;border-top-left-radius:4px"
});
const bottomOptionStyle = /*#__PURE__*/ (0, _css.css)({
    name: "sx4vbo",
    styles: "border-bottom-right-radius:4px;border-bottom-left-radius:4px"
});
const overflowOptionStyle = /*#__PURE__*/ (0, _css.css)({
    name: "1bqjeg7",
    styles: "height:32px;border-radius:none;p{font-size:12px;line-height:16px;margin:0 11px;}"
});
const EmptyLabelHeader = /*#__PURE__*/ (0, _baseDefault.default)("p", {
    target: "el4tfpc6"
})("margin:8px 24px 8px;font-style:italic;font-size:14px;color:", (0, _colors.color_shades_darkest), ";");
const EmptyLabel = /*#__PURE__*/ (0, _baseDefault.default)("p", {
    target: "el4tfpc5"
})("margin:8px 24px;font-size:12px;color:", (0, _colors.color_shades_darker), ";");
const PanelHeader = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "el4tfpc4"
})({
    name: "k8xojc",
    styles: "display:flex;align-items:center;margin-bottom:12px"
});
const spinnerStyle = /*#__PURE__*/ (0, _css.css)("flex:1;.spinner>div{background:", (0, _colors.color_colors_ocean), ";}", "");
const TimelineHeader = /*#__PURE__*/ (0, _baseDefault.default)("p", {
    target: "el4tfpc3"
})("flex:1;color:", (0, _colors.color_text_light), ";font-style:normal;font-weight:normal;font-size:14px;line-height:20px;margin:16px 24px 8px;");
const Timeline = /*#__PURE__*/ (0, _baseDefault.default)("ul", {
    target: "el4tfpc2"
})("list-style:none;border-left:", (0, _stylesValues.style_border_default), ";margin:12px 24px 0 24px;padding:12px 0 250px 0;");
const TimelineItem = /*#__PURE__*/ (0, _baseDefault.default)("li", {
    target: "el4tfpc1"
})("padding-left:16px;margin-bottom:24px;&:first-child{margin-top:-24px;}&.partial{margin-left:24px;.partial-line{display:block;width:12px;border-bottom:1px dashed ", (0, _colors.color_shades_dark), ";margin-left:-40px;margin-right:24px;}.latest-partial-publish-circle{width:6px;height:6px;border-radius:50%;border:1px solid ", (0, _colors.color_colors_growth), ";background:transparent;margin-left:-19px;margin-right:12px;box-sizing:border-box;}.item-name{>span{max-width:154px;}}}.partial-line{display:none;}.backup-circle{width:6px;height:6px;border-radius:50%;border:", (0, _stylesValues.style_border_default), ";margin-left:-19px;margin-right:12px;background:white;box-sizing:border-box;}.publish-circle{width:6px;height:6px;border-radius:50%;background:", (0, _colors.color_colors_growth), ";margin-left:-19px;margin-right:12px;box-sizing:border-box;&.latest{background:", (0, _colors.color_colors_growth), ";}}.latest-full-publish-circle{width:6px;height:6px;border-radius:50%;background:", (0, _colors.color_colors_growth), ";margin-left:-19px;margin-right:12px;display:inline-block;box-sizing:border-box;}.item-header{display:flex;align-items:center;}.item-name{display:flex;align-items:center;>span{margin-left:8px;font-style:normal;font-weight:normal;font-size:14px;line-height:20px;color:", (0, _colors.color_text_default), ";overflow:hidden;text-overflow:ellipsis;white-space:nowrap;max-width:164px;&.processing{color:", (0, _colors.color_colors_growth), ";}&.processing:after{animation:dots steps(1,end) 1s infinite;content:'';}&.error{color:", (0, _colors.color_colors_decline), ";}}>input{margin-left:8px;font-size:14px;line-height:20px;}}.item-date{color:", (0, _colors.color_text_light), ";font-style:normal;font-weight:normal;font-size:10px;line-height:16px;margin-top:6px;}.item-user{display:flex;align-items:center;color:", (0, _colors.color_text_default), ";font-style:normal;font-weight:normal;font-size:12px;line-height:16px;margin-top:4px;>span{margin-left:8px;}}~.timeline-item{&.partial{.publish-circle{background:transparent;border:", (0, _stylesValues.style_border_default), ";}}.publish-circle{background:", (0, _colors.color_shades_dark), ";}}@keyframes dots{0%{content:'';}25%{content:' .';}50%{content:' ..';}75%{content:' ...';}100%{content:'';}}");
const CloseButton = /*#__PURE__*/ (0, _baseDefault.default)("button", {
    target: "el4tfpc0"
})("background:none;border:none;display:flex;align-items:center;margin-right:24px;margin-left:auto;margin-top:10px;cursor:pointer;padding:0;span{font-family:Muli;text-align:right;color:", (0, _colors.color_text_default), ";font-style:normal;font-weight:normal;font-size:12px;line-height:16px;margin-right:4px;}");
exports.default = PublishHistory;

},{"@emotion/styled/base":"lSuFu","@emotion/react":"djZKr","react":"6uln9","../../../components/general/SecondaryLoader":"7zJiF","../../../constants/stylesValues":"dHVVv","../../../constants/colors":"1p3OR","@emotion/css":"awUBr","../../../components/general/UserAvatar":"avuDP","../../../components/general/overflowMenu/SmallOverflowMenu":"YJYcI","../../../components/structure/ConfirmationDialog":"kx7yK","../../featureContent/components/DeleteConfirmation":"9xK2d","../../../components/general/WarningConfirmation":"9OccO","lodash":"3hMBK","moment":"2meyw","./PublishDetailsModal":"6q65B","../../../components/general/TooltipWrapper":"53pWd","800fca2bad86f3b":"bnIFY","7e5ea82dc440644c":"dL9sH","2f0f86925909e1fb":"jETFB","76927ed4bd44335f":"cRA6k","d2344c8c86964e8b":"7n4DG","f3700cfa74dc1ce5":"cKBOl","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"avuDP":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _colors = require("../../constants/colors");
const UserAvatar = (props)=>(0, _react.jsx)("div", {
        className: `${containerStyle} ${props.noShadow == true ? "" : shadowStyle} ${props.className ?? ""}`,
        style: {
            width: props.size,
            height: props.size,
            minWidth: props.size,
            minHeight: props.size
        }
    }, props.src ? (0, _react.jsx)("img", {
        className: generateIconStyle(props),
        src: props.src
    }) : (0, _react.jsx)("div", {
        className: generateNameStyle(props)
    }, (0, _react.jsx)("span", null, props.noImageText ?? `${props.firstName == null ? "N" : props.firstName[0]} ${props.lastName == null ? "A" : props.lastName[0]}`)));
const containerStyle = /*#__PURE__*/ (0, _css.css)("border-radius:50%;border:solid 1px ", (0, _colors.silver_three), ";display:flex;align-items:center;justify-content:center;background:white;box-sizing:border-box;", "");
const shadowStyle = /*#__PURE__*/ (0, _css.css)("box-shadow:0 2px 4px 0 ", (0, _colors.dark_grey_blue_10), ";", "");
const generateIconStyle = (props)=>{
    var size = props.size - 8; //size is 8 less than container
    if (props.noBackground) size = props.size;
    return /*#__PURE__*/ (0, _css.css)("border-radius:50%;width:", size, "px;height:", size, "px;box-sizing:border-box;", "");
};
const generateNameStyle = (props)=>{
    var size = props.size - 8; //size is 8 less than container
    if (props.noBackground) size = props.size;
    return /*#__PURE__*/ (0, _css.css)("border-radius:50%;color:", (0, _colors.color_text_default), ";background:", (0, _colors.color_highlights_blue), ";font-family:Muli;font-size:", size / 3, "px;font-weight:600;font-style:normal;font-stretch:normal;line-height:normal;letter-spacing:-1px;text-align:center;width:", size, "px;height:", size, "px;display:flex;align-items:center;justify-content:center;box-sizing:border-box;", "");
};
exports.default = UserAvatar;

},{"@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","../../constants/colors":"1p3OR","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9OccO":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _base = require("@emotion/styled/base");
var _baseDefault = parcelHelpers.interopDefault(_base);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _colors = require("../../constants/colors");
var _breakpoints = require("../../constants/breakpoints");
var _customScrollbars = require("../structure/CustomScrollbars");
var _customScrollbarsDefault = parcelHelpers.interopDefault(_customScrollbars);
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const redAlertTriangle = require("2965ebc3dcf0354");
const yellowAlertTriangle = require("f0fe0c922126b9b9");
const WarningConfirmation = (props)=>{
    return props.additionalText ? (0, _react.jsx)((0, _customScrollbarsDefault.default), {
        autoHide: true,
        autoHeight: true,
        autoHeightMax: "calc(100vh - 550px)"
    }, (0, _react.jsx)(WarningConfirmationWrapper, null, (0, _react.jsx)(SubtitleWrapper, null, (0, _react.jsx)(Subtitle, null, "Are you sure?"), props.showImage === undefined || props.showImage === true ? (0, _react.jsx)(StyledImage, {
        src: props.useWarningColor ? yellowAlertTriangle : redAlertTriangle
    }) : null, (0, _react.jsx)(Text, null, props.text)), (0, _react.jsx)(AdditionalTextWrapper, null, props.additionalText))) : (0, _react.jsx)("div", {
        className: `${containerStyle} ${props.className && props.className}`
    }, (0, _react.jsx)("p", null, "Are you sure?"), props.showImage === undefined || props.showImage === true ? (0, _react.jsx)("img", {
        src: props.useWarningColor ? yellowAlertTriangle : redAlertTriangle
    }) : null, (0, _react.jsx)("p", null, props.text));
};
const AdditionalTextWrapper = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1uwtnrj5"
})({
    name: "1k6141t",
    styles: "margin:16px 0"
});
const StyledImage = /*#__PURE__*/ (0, _baseDefault.default)("img", {
    target: "e1uwtnrj4"
})({
    name: "1kojf0v",
    styles: "width:50px;margin-top:16px"
});
const Text = /*#__PURE__*/ (0, _baseDefault.default)("p", {
    target: "e1uwtnrj3"
})({
    name: "1qxt18i",
    styles: "margin-top:16px;text-align:center"
});
const SubtitleWrapper = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1uwtnrj2"
})({
    name: "1xusmb0",
    styles: "display:flex;flex-direction:column;margin-bottom:16px;justify-content:center;align-items:center;margin:32px"
});
const Subtitle = /*#__PURE__*/ (0, _baseDefault.default)("h2", {
    target: "e1uwtnrj1"
})("");
const WarningConfirmationWrapper = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1uwtnrj0"
})({
    name: "1fttcpj",
    styles: "display:flex;flex-direction:column"
});
const containerStyle = /*#__PURE__*/ (0, _css.css)("display:flex;flex-direction:column;align-items:center;justify-content:center;margin:64px;img{width:82px;height:82px;margin:32px 0;}p{font-family:Muli;font-size:18px;font-weight:normal;font-style:normal;font-stretch:normal;line-height:normal;letter-spacing:0.5px;text-align:center;color:", (0, _colors.dark_grey_blue), ";}", (0, _breakpoints.breakpoint_small), "{margin:32px;p{font-size:14px;}}", "");
exports.default = WarningConfirmation;

},{"@emotion/styled/base":"lSuFu","@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","../../constants/colors":"1p3OR","../../constants/breakpoints":"2F01A","../structure/CustomScrollbars":"50vFq","2965ebc3dcf0354":"4UkG2","f0fe0c922126b9b9":"eBsTw","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"eBsTw":[function(require,module,exports) {
module.exports = require("fc697fe4f53efa").getBundleURL("kVLro") + require("353719d2c8c73873").resolve("7oMsH");

},{"fc697fe4f53efa":"c7Tr5","353719d2c8c73873":"fyJL2"}],"6q65B":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _base = require("@emotion/styled/base");
var _baseDefault = parcelHelpers.interopDefault(_base);
var _react = require("@emotion/react");
var _css = require("@emotion/css");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _button = require("../../../components/general/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _modalHeader = require("../../../components/general/ModalHeader");
var _modalHeaderDefault = parcelHelpers.interopDefault(_modalHeader);
var _pageError = require("../../../components/general/PageError");
var _pageErrorDefault = parcelHelpers.interopDefault(_pageError);
var _footerBar = require("../../../components/structure/FooterBar");
var _footerBarDefault = parcelHelpers.interopDefault(_footerBar);
var _smallModalLayout = require("../../../components/structure/SmallModalLayout");
var _smallModalLayoutDefault = parcelHelpers.interopDefault(_smallModalLayout);
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const PublishDetailsModal = (props)=>(0, _react.jsx)((0, _smallModalLayoutDefault.default), {
        isVisible: true,
        onClose: props.onClose,
        className: customModalInner
    }, (0, _react.jsx)(ModalBody, null, (0, _react.jsx)((0, _modalHeaderDefault.default), {
        title: "Publish Details",
        onClose: props.onClose
    }), (0, _react.jsx)("div", {
        className: "modal-body"
    }, (0, _react.jsx)("p", null, "Review Publishing Details")), (0, _react.jsx)((0, _footerBarDefault.default), null, (0, _react.jsx)((0, _buttonDefault.default), {
        type: "button",
        themes: [
            "primary",
            "start"
        ],
        text: "Close",
        onClick: ()=>props.onClose()
    }))), (0, _react.jsx)((0, _pageErrorDefault.default), {
        errors: props.backupsContainer.state.errors ?? [],
        onClear: ()=>props.backupsContainer.clearErrors()
    }));
const customModalInner = /*#__PURE__*/ (0, _css.css)({
    name: "1mw49wb",
    styles: "height:416px;min-height:416px"
});
const ModalBody = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1s2pxbz0"
})({
    name: "11585cm",
    styles: "min-height:416px;height:416px;padding-bottom:64px;.modal-body{padding:0 32px;margin-bottom:180px;height:100%;flex:1;>h4{font-style:normal;font-weight:normal;font-size:18px;line-height:24px;}>p{font-style:normal;font-weight:normal;font-size:14px;line-height:20px;margin:24px 0;}}"
});
exports.default = PublishDetailsModal;

},{"@emotion/styled/base":"lSuFu","@emotion/react":"djZKr","@emotion/css":"awUBr","react":"6uln9","../../../components/general/Button":"6ymxN","../../../components/general/ModalHeader":"aUACx","../../../components/general/PageError":"ezFTm","../../../components/structure/FooterBar":"bibRL","../../../components/structure/SmallModalLayout":"khwvt","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"bnIFY":[function(require,module,exports) {
module.exports = require("e5b7ed6ecde509c3").getBundleURL("kVLro") + require("ac1cbc59a87f4184").resolve("2STeE");

},{"e5b7ed6ecde509c3":"c7Tr5","ac1cbc59a87f4184":"fyJL2"}],"jETFB":[function(require,module,exports) {
module.exports = require("346a2dca442a76c6").getBundleURL("kVLro") + require("91c3f740f1038260").resolve("bfbPW");

},{"346a2dca442a76c6":"c7Tr5","91c3f740f1038260":"fyJL2"}],"7n4DG":[function(require,module,exports) {
module.exports = require("5c0d1804cac6d85e").getBundleURL("kVLro") + require("192ef9a4bf56425e").resolve("jBpgH");

},{"5c0d1804cac6d85e":"c7Tr5","192ef9a4bf56425e":"fyJL2"}],"cKBOl":[function(require,module,exports) {
module.exports = require("139a32e9059de618").getBundleURL("kVLro") + require("558f853c6d92ab14").resolve("eSL17");

},{"139a32e9059de618":"c7Tr5","558f853c6d92ab14":"fyJL2"}],"fKr4T":[function(require,module,exports) {
module.exports = require("cb9620abde8671ce").getBundleURL("kVLro") + require("90ba9590edd2f512").resolve("edRqx");

},{"cb9620abde8671ce":"c7Tr5","90ba9590edd2f512":"fyJL2"}],"4Yzsw":[function(require,module,exports) {
module.exports = require("4571f52312603a07").getBundleURL("kVLro") + require("6b348ccbff8f2871").resolve("7k740");

},{"4571f52312603a07":"c7Tr5","6b348ccbff8f2871":"fyJL2"}],"k7cZ6":[function(require,module,exports) {
module.exports = require("c4955d03a085a55f").getBundleURL("kVLro") + require("d9f59b18ec79201c").resolve("8nZ7L");

},{"c4955d03a085a55f":"c7Tr5","d9f59b18ec79201c":"fyJL2"}],"1S0DP":[function(require,module,exports) {
module.exports = require("d6f4535f00d5b81e").getBundleURL("kVLro") + require("5c26e6e20ec2ef8e").resolve("1QbLP");

},{"d6f4535f00d5b81e":"c7Tr5","5c26e6e20ec2ef8e":"fyJL2"}],"a8FLc":[function(require,module,exports) {
module.exports = require("38cc7baee3942fd9").getBundleURL("kVLro") + require("d8f55965c4fe162f").resolve("b3c4m");

},{"38cc7baee3942fd9":"c7Tr5","d8f55965c4fe162f":"fyJL2"}],"iZ56c":[function(require,module,exports) {
module.exports = require("12d2e999f69c0a2b").getBundleURL("kVLro") + require("f6da5ebb33a1a080").resolve("8MQyF");

},{"12d2e999f69c0a2b":"c7Tr5","f6da5ebb33a1a080":"fyJL2"}],"e3D4F":[function(require,module,exports) {
module.exports = require("760786f217354b11").getBundleURL("kVLro") + require("752381e3d3a9adf6").resolve("4QO16");

},{"760786f217354b11":"c7Tr5","752381e3d3a9adf6":"fyJL2"}],"5MQWD":[function(require,module,exports) {
module.exports = require("ee0021a9c2b96488").getBundleURL("kVLro") + require("ad4ba4c99cb3840").resolve("aYPx5");

},{"ee0021a9c2b96488":"c7Tr5","ad4ba4c99cb3840":"fyJL2"}],"2iYkb":[function(require,module,exports) {
module.exports = require("f73781e2734df9dc").getBundleURL("kVLro") + require("718ab125bb0d5763").resolve("8cUOH");

},{"f73781e2734df9dc":"c7Tr5","718ab125bb0d5763":"fyJL2"}],"eqeII":[function(require,module,exports) {
module.exports = require("7a0f4ac25e748c30").getBundleURL("kVLro") + require("3fce065e74121b2c").resolve("4cUKY");

},{"7a0f4ac25e748c30":"c7Tr5","3fce065e74121b2c":"fyJL2"}],"oXWpd":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _base = require("@emotion/styled/base");
var _baseDefault = parcelHelpers.interopDefault(_base);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _dropDownSelectField = require("../../../components/forms/DropDownSelectField");
var _dropDownSelectFieldDefault = parcelHelpers.interopDefault(_dropDownSelectField);
var _contentCard = require("../../../components/structure/ContentCard");
var _contentCardDefault = parcelHelpers.interopDefault(_contentCard);
var _formFieldsContainer = require("../../../components/structure/FormFieldsContainer");
var _formFieldsContainerDefault = parcelHelpers.interopDefault(_formFieldsContainer);
var _colors = require("../../../constants/colors");
var _baseConversationItemForm = require("../../formScenes/BaseConversationItemForm");
var _toggleIndicator = require("../../../components/general/ToggleIndicator");
var _toggleIndicatorDefault = parcelHelpers.interopDefault(_toggleIndicator);
var _tooltipWrapper = require("../../../components/general/TooltipWrapper");
var _tooltipWrapperDefault = parcelHelpers.interopDefault(_tooltipWrapper);
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const computerLockDark = require("dba2c59bd4d47ba2");
const noChangeDark = require("f4118fdf4770bd96");
const computerLockSideDark = require("4efe09f9f19d838a");
const computerLockSideBlue = require("eab4a002a06590cb");
const computerWarningDark = require("60acab69324b2fc9");
const computerWarningBlue = require("550f217d95390a5");
const helpIcon = require("f3e8f8c041db7bd4");
const noChangeBlue = require("28fc02609cc76711");
const options = [
    {
        selectedImage: noChangeBlue,
        value: "None",
        label: "No change",
        image: noChangeDark,
        description: "No change to secure conversation state (default)."
    },
    {
        value: "StartSensitiveConversation",
        label: "Start Secure Conversation",
        image: computerLockSideDark,
        description: "Marks session as containing potentially sensitive data.",
        selectedImage: computerLockSideBlue
    },
    {
        value: "EndSensitiveConversation",
        label: "End Secure Conversation",
        image: computerWarningDark,
        description: "Ends session's secure conversation state.",
        selectedImage: computerWarningBlue
    }
];
const SensitiveDataOptions = (props)=>{
    const formatValueLabel = ({ label, image })=>(0, _react.jsx)(CustomSelectChosenOption, null, (0, _react.jsx)("img", {
            src: image
        }), (0, _react.jsx)("p", null, label));
    return (0, _react.jsx)((0, _baseConversationItemForm.HighlightSection), null, (0, _react.jsx)((0, _contentCardDefault.default), {
        title: "Secure Conversation",
        icon: computerLockDark
    }, (0, _react.jsx)((0, _formFieldsContainerDefault.default), null, (0, _react.jsx)(Description, null, "Manage if this item represents the start or end of a secure conversation.", (0, _react.jsx)((0, _tooltipWrapperDefault.default), {
        place: "right",
        text: "If this content item is hit you can mark the user session<br />as a secure conversation. Conversations marked as sensitive<br />track no user input in your analytics and send all user input<br />related data to your webhooks encrypted with your webhook's<br />encrypted key. This continues until the user reaches a content<br />item that ends the secure conversation."
    }, (0, _react.jsx)(HelpIcon, {
        src: helpIcon
    }))), (0, _react.jsx)(CustomDropDownSelect, {
        className: "ac-access",
        clearable: false,
        searchable: false,
        valueRenderer: formatValueLabel,
        options: options,
        onChange: (value)=>{
            props.onChange(value.value);
        },
        disabled: false,
        value: props.selectedOption,
        key: "user-entry-selector",
        arrowRenderer: (p)=>(0, _react.jsx)(Arrow, {
                direction: p.isOpen ? "up" : "down"
            }),
        menuRenderer: (menuProps)=>{
            return (0, _react.jsx)(MenuOptionsWrapper, null, (0, _react.jsx)(Triangle, null), options.map((option, index)=>(0, _react.jsx)(SelectOption, {
                    key: index,
                    className: "user-entry-option",
                    onClick: ()=>menuProps.selectValue(option)
                }, (0, _react.jsx)(CustomSelectOptionLabel, null, option.image ? (0, _react.jsx)(ConversationAccessIcon, {
                    src: menuProps.valueArray[0].value == option.value ? option.selectedImage : option.image
                }) : null, (0, _react.jsx)("div", null, (0, _react.jsx)("p", {
                    className: menuProps.valueArray[0].value == option.value ? "option-selected" : ""
                }, option.label), (0, _react.jsx)("p", {
                    className: menuProps.valueArray[0].value == option.value ? "option-description-selected" : "option-description"
                }, option.description))), index != menuProps.options.length - 1 && (0, _react.jsx)(Divider, null))));
        }
    }))));
};
const Description = /*#__PURE__*/ (0, _baseDefault.default)("p", {
    target: "ey2rpb410"
})({
    name: "xzzfh1",
    styles: "margin-bottom:32px;display:flex"
});
const Arrow = /*#__PURE__*/ (0, _baseDefault.default)((0, _toggleIndicatorDefault.default), {
    target: "ey2rpb49"
})({
    name: "11f9gim",
    styles: "height:8px;width:8px"
});
const MenuOptionsWrapper = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "ey2rpb48"
})({
    name: "hkh81z",
    styles: "margin-top:8px"
});
const SelectOption = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "ey2rpb47"
})("&.user-entry-option:hover{background-color:", (0, _colors.color_variants_ocean_xlight), ";cursor:pointer;}");
const CustomDropDownSelect = /*#__PURE__*/ (0, _baseDefault.default)((0, _dropDownSelectFieldDefault.default), {
    target: "ey2rpb46"
})("margin-top:4px;margin-bottom:16px;.Select-multi-value-wrapper{height:48px;}.Select-menu-outer{border-top-color:", (0, _colors.color_shades_dark), ";}.Select-value{margin-top:8px;}.Select-control{border-radius:4px;}&.is-open{.Select-control{border-bottom-right-radius:4px;border-bottom-left-radius:4px;border-color:", (0, _colors.color_shades_dark), ";}}");
const CustomSelectChosenOption = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "ey2rpb45"
})("display:flex;flex-direction:row;padding-left:6px;p{color:", (0, _colors.color_shades_darkest), ";margin-left:10px;}img{height:24px;width:24px;margin-top:4px;}");
const Triangle = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "ey2rpb44"
})("transform:rotate(45deg);width:12px;height:12px;border-top:solid 1px ", (0, _colors.color_shades_dark), ";border-left:solid 1px ", (0, _colors.color_shades_dark), ";background:white;margin-top:-7px;right:15px;position:absolute;");
const ConversationAccessIcon = /*#__PURE__*/ (0, _baseDefault.default)("img", {
    target: "ey2rpb43"
})({
    name: "bmozya",
    styles: "height:24px;width:24px;margin-top:4px"
});
const Divider = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "ey2rpb42"
})("display:block;height:1px;border:0;border-top:1px solid ", (0, _colors.color_shades_dark), ";padding:0;");
const CustomSelectOptionLabel = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "ey2rpb41"
})("display:flex;flex-direction:row;padding-left:15px;padding-top:12px;padding-bottom:12px;div{line-height:normal;margin-left:10px;color:", (0, _colors.color_shades_darkest), ";}.option-selected{color:", (0, _colors.color_colors_ocean), ";}.option-description{font-size:14px;color:", (0, _colors.color_shades_darker), ";}.option-description-selected{font-size:14px;color:", (0, _colors.color_colors_ocean), ";}");
const HelpIcon = /*#__PURE__*/ (0, _baseDefault.default)("img", {
    target: "ey2rpb40"
})({
    name: "1q4vxyr",
    styles: "margin-left:8px"
});
exports.default = SensitiveDataOptions;

},{"@emotion/styled/base":"lSuFu","@emotion/react":"djZKr","react":"6uln9","../../../components/forms/DropDownSelectField":"kFCJA","../../../components/structure/ContentCard":"hJsdJ","../../../components/structure/FormFieldsContainer":"h3hzh","../../../constants/colors":"1p3OR","../../formScenes/BaseConversationItemForm":"akSVo","../../../components/general/ToggleIndicator":"4eej1","../../../components/general/TooltipWrapper":"53pWd","dba2c59bd4d47ba2":"kBKD8","f4118fdf4770bd96":"b0W6c","4efe09f9f19d838a":"lyz7r","eab4a002a06590cb":"5pVH3","60acab69324b2fc9":"4FJnD","550f217d95390a5":"3vVDI","f3e8f8c041db7bd4":"iHZUj","28fc02609cc76711":"3aXWm","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"b0W6c":[function(require,module,exports) {
module.exports = require("6ca3663ad0bc6b97").getBundleURL("kVLro") + require("7f81782ffbf16d15").resolve("leXtM");

},{"6ca3663ad0bc6b97":"c7Tr5","7f81782ffbf16d15":"fyJL2"}],"lyz7r":[function(require,module,exports) {
module.exports = require("47b71f1f6ff976ea").getBundleURL("kVLro") + require("7c642c0f221c9d24").resolve("d2TJc");

},{"47b71f1f6ff976ea":"c7Tr5","7c642c0f221c9d24":"fyJL2"}],"5pVH3":[function(require,module,exports) {
module.exports = require("c8ccdff557e259d3").getBundleURL("kVLro") + require("9c54acfe05d35a9").resolve("ac5Me");

},{"c8ccdff557e259d3":"c7Tr5","9c54acfe05d35a9":"fyJL2"}],"4FJnD":[function(require,module,exports) {
module.exports = require("cd03765be810214c").getBundleURL("kVLro") + require("7f0196636020f7d5").resolve("Cz7cs");

},{"cd03765be810214c":"c7Tr5","7f0196636020f7d5":"fyJL2"}],"3vVDI":[function(require,module,exports) {
module.exports = require("e83e65ae78c13783").getBundleURL("kVLro") + require("34d353f2ca33277").resolve("bOXa2");

},{"e83e65ae78c13783":"c7Tr5","34d353f2ca33277":"fyJL2"}],"3aXWm":[function(require,module,exports) {
module.exports = require("e225d4d02cebd094").getBundleURL("kVLro") + require("53c2843ca5fb7073").resolve("3Jv2Z");

},{"e225d4d02cebd094":"c7Tr5","53c2843ca5fb7073":"fyJL2"}],"67JXM":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _base = require("@emotion/styled/base");
var _baseDefault = parcelHelpers.interopDefault(_base);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _contentCard = require("../../../components/structure/ContentCard");
var _contentCardDefault = parcelHelpers.interopDefault(_contentCard);
var _formFieldsContainer = require("../../../components/structure/FormFieldsContainer");
var _formFieldsContainerDefault = parcelHelpers.interopDefault(_formFieldsContainer);
var _baseConversationItemForm = require("../../formScenes/BaseConversationItemForm");
var _checkboxField = require("../../../components/forms/CheckboxField");
var _checkboxFieldDefault = parcelHelpers.interopDefault(_checkboxField);
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const DisableForFeatureFlagOptions = (props)=>{
    (0, _react1.useEffect)(()=>{
        props.appContainer.loadFeatureFlags();
    }, []);
    const allFeatureFlags = props.appContainer.state.featureFlags;
    const handleFeatureFlagsChange = (flag)=>{
        // manage check box
        const flagsCopy = [
            ...props.selectedFeatureFlags ?? []
        ];
        if (flagsCopy.includes(flag.id)) flagsCopy.splice(flagsCopy.indexOf(flag.id), 1);
        else flagsCopy.push(flag.id);
        props.onChange(flagsCopy);
    };
    return (0, _react.jsx)((0, _baseConversationItemForm.HighlightSection), null, (0, _react.jsx)((0, _contentCardDefault.default), {
        title: props.titleOverride ?? "Disable this item if feature flags are present"
    }, (0, _react.jsx)((0, _formFieldsContainerDefault.default), null, (0, _react.jsx)(Description, null, props.descriptionOverride ?? "If a checked feature flag is present in this application, this content item will be disabled.")), allFeatureFlags.map((flag, index)=>{
        return (0, _react.jsx)((0, _reactDefault.default).Fragment, null, (0, _react.jsx)((0, _checkboxFieldDefault.default), {
            key: `KEY ${index}`,
            name: flag.name,
            label: flag.name,
            checked: props.selectedFeatureFlags?.includes(flag.id),
            onChange: ()=>handleFeatureFlagsChange(flag)
        }));
    })));
};
const Description = /*#__PURE__*/ (0, _baseDefault.default)("p", {
    target: "ewa22v10"
})({
    name: "xzzfh1",
    styles: "margin-bottom:32px;display:flex"
});
exports.default = DisableForFeatureFlagOptions;

},{"@emotion/styled/base":"lSuFu","@emotion/react":"djZKr","react":"6uln9","../../../components/structure/ContentCard":"hJsdJ","../../../components/structure/FormFieldsContainer":"h3hzh","../../formScenes/BaseConversationItemForm":"akSVo","../../../components/forms/CheckboxField":"3S5Oy","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6EkXj":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _base = require("@emotion/styled/base");
var _baseDefault = parcelHelpers.interopDefault(_base);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _reactRouter = require("react-router");
var _contentItemTestCasesPanel = require("../simulator/components/ContentItemTestCasesPanel");
var _contentItemTestCasesPanelDefault = parcelHelpers.interopDefault(_contentItemTestCasesPanel);
var _testCaseHistoryViewer = require("../../components/forms/TestCaseHistoryViewer");
var _testCaseHistoryViewerDefault = parcelHelpers.interopDefault(_testCaseHistoryViewer);
var _testCaseContainer = require("../../hooks/TestCaseContainer");
var _testCaseContainerDefault = parcelHelpers.interopDefault(_testCaseContainer);
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const ContentItemTestCaseViewer = ({ application, contentItemId, getResponseId, responseIdToNamesRef })=>{
    const [runningTestCase, setRunningTestCase] = (0, _react1.useState)(null);
    const testCaseContainer = (0, _testCaseContainerDefault.default).useContainer();
    const history = (0, _reactRouter.useHistory)();
    const runTestCase = async (testCase)=>{
        try {
            setRunningTestCase(testCase);
            const response = await testCaseContainer.simulateTestCase(testCase);
            getResponseId(response.responseId);
            return response;
        } catch (error) {
            console.log(error);
        }
    };
    const simulateTestCase = async (testCase)=>{
        sessionStorage.setItem("testCaseToSimulate", JSON.stringify(testCase));
        history.push(`/v/apps/${application.id}/simulator`);
    };
    return (0, _react.jsx)("div", null, (0, _react.jsx)(StyledContainer, null, (0, _react.jsx)((0, _contentItemTestCasesPanelDefault.default), {
        application: application,
        contentItemId: contentItemId,
        runTestCase: runTestCase,
        simulateTestCase: simulateTestCase,
        responseIdToNamesRef: responseIdToNamesRef
    })), runningTestCase != null && (0, _react.jsx)(StyledContainer, null, (0, _react.jsx)(StyledLabel, null, "Current Test Case: ", runningTestCase.name), (0, _react.jsx)((0, _testCaseHistoryViewerDefault.default), {
        currentTestCase: runningTestCase
    })));
};
const StyledContainer = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e93wvs71"
})({
    name: "1n5m579",
    styles: "padding:16px;width:100%;display:block;justify-content:flex-start"
});
const StyledLabel = /*#__PURE__*/ (0, _baseDefault.default)("h3", {
    target: "e93wvs70"
})("");
exports.default = ContentItemTestCaseViewer;

},{"@emotion/styled/base":"lSuFu","@emotion/react":"djZKr","react":"6uln9","react-router":"i3TiW","../simulator/components/ContentItemTestCasesPanel":"6BpiD","../../components/forms/TestCaseHistoryViewer":"lvjRC","../../hooks/TestCaseContainer":"cLg3U","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6BpiD":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _base = require("@emotion/styled/base");
var _baseDefault = parcelHelpers.interopDefault(_base);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _colors = require("../../../constants/colors");
var _button = require("../../../components/general/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _customScrollbars = require("../../../components/structure/CustomScrollbars");
var _customScrollbarsDefault = parcelHelpers.interopDefault(_customScrollbars);
var _useWindowSize = require("../../../hooks/UseWindowSize");
var _useWindowSizeDefault = parcelHelpers.interopDefault(_useWindowSize);
var _testCaseContainer = require("../../../hooks/TestCaseContainer");
var _testCaseContainerDefault = parcelHelpers.interopDefault(_testCaseContainer);
var _editTestCase = require("../../../components/forms/EditTestCase");
var _editTestCaseDefault = parcelHelpers.interopDefault(_editTestCase);
var _secondaryLoader = require("../../../components/general/SecondaryLoader");
var _secondaryLoaderDefault = parcelHelpers.interopDefault(_secondaryLoader);
var _searchField = require("../../../components/forms/SearchField");
var _searchFieldDefault = parcelHelpers.interopDefault(_searchField);
var _checkboxField = require("../../../components/forms/CheckboxField");
var _checkboxFieldDefault = parcelHelpers.interopDefault(_checkboxField);
var _tooltipWrapper = require("../../../components/general/TooltipWrapper");
var _tooltipWrapperDefault = parcelHelpers.interopDefault(_tooltipWrapper);
var _deleteConfirmation = require("../../featureContent/components/DeleteConfirmation");
var _deleteConfirmationDefault = parcelHelpers.interopDefault(_deleteConfirmation);
var _confirmationDialog = require("../../../components/structure/ConfirmationDialog");
var _confirmationDialogDefault = parcelHelpers.interopDefault(_confirmationDialog);
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const removeIcon = require("e23b8ae25c4f1bef");
const copyIcon = require("ebc70959001284f2");
const arrowRight = require("8b35befb63b13c72");
const refresh = require("d3906f26721ba7a7");
const greenPowerIcon = require("7c84f02e00b65476");
const ContentItemTestCasesPanel = (props)=>{
    const windowSize = (0, _useWindowSizeDefault.default)();
    const testCaseContainer = (0, _testCaseContainerDefault.default).useContainer();
    const [testCase, setTestCase] = (0, _react1.useState)(null);
    const [checkedCases, setCheckedCases] = (0, _react1.useState)([]);
    const [search, setSearch] = (0, _react1.useState)("");
    const [nameToDelete, setNameToDelete] = (0, _react1.useState)("");
    const [responseNamesForDisplay, setResponseNamesForDisplay] = (0, _react1.useState)({});
    (0, _react1.useEffect)(()=>{
        testCaseContainer.setApplication(props.application);
        if (props.contentItemId?.length > 0) testCaseContainer.loadAppLevelTestCases(props.application.id, props.contentItemId);
        else testCaseContainer.loadAppLevelTestCases(props.application.id);
        var updatedResponseNamesList = {};
        setResponseNamesForDisplay(updatedResponseNamesList);
    }, []);
    const confirmDelete = ()=>{
        if (nameToDelete) testCaseContainer.deleteAppLevelTestCase(props.application.id, nameToDelete, props.contentItemId).then(()=>{
            setNameToDelete("");
            testCaseContainer.loadAppLevelTestCases(props.application.id);
        });
    };
    const closeDeleteConfirmation = ()=>{
        setNameToDelete("");
    };
    const runTestCase = async (name1, contentItemId)=>{
        const testCase = await testCaseContainer.loadAppLevelTestCase(props.application.id, name1, contentItemId);
        if (testCase) props.runTestCase(testCase);
    };
    const simulateTestCase = async (name1, contentItemId)=>{
        const testCase = await testCaseContainer.loadAppLevelTestCase(props.application.id, name1, contentItemId);
        if (testCase) props.simulateTestCase(testCase);
    };
    const editTestCase = async (name1, contentItemId)=>{
        const testCase = await testCaseContainer.loadAppLevelTestCase(props.application.id, name1, contentItemId);
        if (testCase) setTestCase(testCase);
    };
    const getTestCaseColor = (name1)=>{
        const testCaseResults = testCaseContainer.testCaseResults;
        if (testCaseResults && testCaseResults[name1]) {
            if (Object.keys(testCaseResults[name1]).some((k)=>testCaseResults[name1][k]?.toLowerCase() !== "true")) return "red";
            return "green";
        } else return "";
    };
    const isLoadingCase = (name1)=>{
        if (testCaseContainer.runningTests?.length && testCaseContainer.runningTests.includes(name1)) {
            const testCaseResults = testCaseContainer.testCaseResults;
            if (testCaseResults && testCaseResults[name1]) return false;
            return true;
        } else return false;
    };
    const handleSearch = (searchEvent)=>{
        setSearch(searchEvent.target.value);
    };
    const contentItemTestCases = testCaseContainer.availableTestCases?.contentItemTestCases ?? {};
    let testCases = props.contentItemId in contentItemTestCases ? contentItemTestCases[props.contentItemId] : [];
    if (search?.length) {
        testCases = [];
        const searchableTestCases = props.contentItemId in contentItemTestCases ? contentItemTestCases[props.contentItemId] : [];
        for (const c of searchableTestCases)if (c.toLowerCase().includes(search.toLowerCase())) testCases.push(c);
    }
    // alphabetically sort test casess
    testCases = testCases.sort((a, b)=>a.localeCompare(b));
    return (0, _react.jsx)("div", {
        className: containerStyle
    }, (0, _react.jsx)(TestCaseHeadingWrapper, null, (0, _react.jsx)("div", {
        className: "title-container"
    }, (0, _react.jsx)("div", {
        className: "title"
    }, "Test Cases")), (0, _react.jsx)(StyledTopButton, {
        themes: [
            "white-pill"
        ],
        text: "Run All",
        onClick: async ()=>{
            const responses = await testCaseContainer.runAppLevelTestCases();
            var updatedResponseNamesList = {};
            for(const tcname in responses)updatedResponseNamesList[tcname] = props.responseIdToNamesRef.current[responses[tcname]?.responseId];
            setResponseNamesForDisplay(updatedResponseNamesList);
        }
    }), checkedCases?.length ? (0, _react.jsx)(StyledTopButton, {
        themes: [
            "white-pill"
        ],
        text: "Run Checked",
        onClick: async ()=>{
            const responses = await testCaseContainer.runAppLevelTestCases(checkedCases);
            var updatedResponseNamesList = {};
            for(const tcname in responses){
                const updatedResponse = checkedCases.includes(tcname) ? props.responseIdToNamesRef.current[responses[tcname]?.responseId] : "";
                updatedResponseNamesList[tcname] = updatedResponse;
            }
            setResponseNamesForDisplay(updatedResponseNamesList);
        }
    }) : (0, _react.jsx)((0, _reactDefault.default).Fragment, null), (0, _react.jsx)(SearchRow, null, (0, _react.jsx)(SearchCheckbox, {
        key: `check.${name}`,
        checked: testCases?.length && testCases.every((tc)=>checkedCases.includes(tc)),
        onClick: (e)=>{
            if (testCases?.length) {
                if (testCases.every((tc)=>checkedCases.includes(tc))) setCheckedCases([]);
                else setCheckedCases([
                    ...testCases
                ]);
            }
        },
        label: ""
    }), (0, _react.jsx)(CustomSearch, {
        id: "1",
        name: "searchField",
        placeholder: "Search for a test case",
        disabled: false,
        onChange: handleSearch
    }))), (0, _react.jsx)((0, _customScrollbarsDefault.default), {
        autoHide: true,
        autoHeight: true,
        autoHeightMax: windowSize.windowSize.innerHeight * .9 - 175
    }, (0, _react.jsx)(Phrases, null, testCases.map((name1, idx)=>(0, _react.jsx)("div", null, (0, _react.jsx)(Phrase, {
            key: idx
        }, (0, _react.jsx)(StyledCheckbox, {
            key: `check.${name1}`,
            checked: checkedCases.includes(name1),
            onClick: (e)=>{
                if (checkedCases.includes(name1)) setCheckedCases(checkedCases.filter((c)=>c !== name1));
                else setCheckedCases([
                    ...checkedCases,
                    name1
                ]);
            },
            label: ""
        }), isLoadingCase(name1) ? (0, _react.jsx)(TestCaseChip, {
            className: getTestCaseColor(name1),
            onClick: ()=>editTestCase(name1, props.contentItemId)
        }, (0, _react.jsx)((0, _secondaryLoaderDefault.default), null)) : (0, _react.jsx)(TestCaseChip, {
            className: getTestCaseColor(name1),
            onClick: ()=>editTestCase(name1, props.contentItemId)
        }, name1.length > 30 ? name1.substring(0, 30) + "..." : name1), (0, _react.jsx)((0, _tooltipWrapperDefault.default), {
            place: "top",
            text: "Delete"
        }, (0, _react.jsx)("div", {
            className: "remove-thumbtack",
            onClick: ()=>{
                setNameToDelete(name1);
            }
        }, (0, _react.jsx)("img", {
            src: removeIcon
        }))), (0, _react.jsx)((0, _tooltipWrapperDefault.default), {
            place: "top",
            text: "Copy"
        }, (0, _react.jsx)("div", {
            className: "remove-thumbtack",
            onClick: async ()=>{
                const testCase = await testCaseContainer.loadAppLevelTestCase(props.application.id, name1, props.contentItemId);
                if (testCase) {
                    testCase.name = testCase.name + "-copy";
                    testCaseContainer.createTestCase(props.application.id, testCase);
                    const newAvailableTestCases = {
                        ...testCaseContainer.availableTestCases,
                        contentItemTestCases: {
                            ...testCaseContainer.availableTestCases?.contentItemTestCases,
                            [props.contentItemId]: [
                                ...testCaseContainer.availableTestCases.contentItemTestCases[props.contentItemId],
                                testCase.name
                            ]
                        }
                    };
                    testCaseContainer.setAvailableTestCases(newAvailableTestCases);
                }
            }
        }, (0, _react.jsx)("img", {
            src: copyIcon
        }))), (0, _react.jsx)((0, _tooltipWrapperDefault.default), {
            place: "top",
            text: "Run"
        }, (0, _react.jsx)("div", {
            className: "remove-thumbtack",
            onClick: async ()=>{
                await runTestCase(name1, props?.contentItemId);
            }
        }, (0, _react.jsx)("img", {
            src: refresh
        }))), (0, _react.jsx)((0, _tooltipWrapperDefault.default), {
            place: "top",
            text: "Simulate response"
        }, (0, _react.jsx)("div", {
            className: "remove-thumbtack",
            onClick: async ()=>{
                await simulateTestCase(name1, props?.contentItemId);
            }
        }, (0, _react.jsx)("img", {
            src: arrowRight
        })))), (0, _react.jsx)(Phrase, null, (0, _react.jsx)(TestCaseLabel, null, responseNamesForDisplay[name1])))))), testCase != null ? (0, _react.jsx)((0, _editTestCaseDefault.default), {
        initialValue: testCase,
        onSave: async (tc)=>{
            await testCaseContainer.deleteAppLevelTestCase(props.application.id, testCase.name);
            await testCaseContainer.createTestCase(props.application.id, tc);
            testCaseContainer.loadAppLevelTestCases(props.application.id);
            setTestCase(null);
        },
        onClose: ()=>setTestCase(null),
        isContentItemView: true
    }) : (0, _react.jsx)((0, _reactDefault.default).Fragment, null), nameToDelete?.length ? (0, _react.jsx)((0, _confirmationDialogDefault.default), {
        title: "Delete",
        deleteText: "Yes, Delete",
        isLoading: testCaseContainer.loading,
        onClose: ()=>closeDeleteConfirmation(),
        onConfirm: ()=>confirmDelete()
    }, (0, _react.jsx)((0, _deleteConfirmationDefault.default), {
        itemLabel: ` this test case? ${nameToDelete}`
    })) : (0, _react.jsx)((0, _reactDefault.default).Fragment, null));
};
const SearchRow = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1tdxpfl10"
})({
    name: "ho1qnd",
    styles: "display:flex;flex-direction:row"
});
const TestCaseHeadingWrapper = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1tdxpfl9"
})({
    name: "edg7se",
    styles: "padding:0 20px 0px 24px"
});
const Phrases = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1tdxpfl8"
})({
    name: "1ooga0k",
    styles: "padding:0 24px;padding-bottom:40px;width:100%"
});
const Phrase = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1tdxpfl7"
})({
    name: "1xvh0rl",
    styles: "display:flex;flex-direction:row;width:100%;margin:8px 0;cursor:pointer;.remove-thumbtack{width:24px;margin-left:8px;img{width:100%;margin-top:10px;}}&:first-of-type{margin-top:16px;}&:last-of-type{margin-bottom:16px;}"
});
const CustomSearch = /*#__PURE__*/ (0, _baseDefault.default)((0, _searchFieldDefault.default), {
    target: "e1tdxpfl6"
})({
    name: "xkolyu",
    styles: "margin-bottom:0px;div>.field-container{height:32px;box-shadow:none;border-radius:8px;}"
});
const StyledTopButton = /*#__PURE__*/ (0, _baseDefault.default)((0, _buttonDefault.default), {
    target: "e1tdxpfl5"
})({
    name: "1j4g0ki",
    styles: "margin-top:0px;margin-bottom:8px;margin-right:8px;margin-left:0px"
});
const TestCaseChip = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1tdxpfl4"
})("&.red{background:", (0, _colors.pastel_red), ";}&.green{background:", (0, _colors.pastel_green), ";}overflow:hidden;background:white;border:1px solid ", (0, _colors.silver_four), ";border-radius:8px;width:100%;height:32px;padding:6px 16px;font-size:14px;line-height:20px;font-weight:400;.spinner>div{background-color:", (0, _colors.color_colors_ocean), ";}.spinner{height:24px;margin-top:-3px;}");
const TestCaseLabel = /*#__PURE__*/ (0, _baseDefault.default)("label", {
    target: "e1tdxpfl3"
})("font-size:14px;line-height:20px;font-weight:300;color:", (0, _colors.color_shades_darker), ";padding-left:4px;white-space:nowrap;text-overflow:ellipsis;display:inline-block;margin-left:32px;");
const StyledCheckbox = /*#__PURE__*/ (0, _baseDefault.default)((0, _checkboxFieldDefault.default), {
    target: "e1tdxpfl2"
})({
    name: "1soh0gv",
    styles: "margin-top:4px"
});
const SearchCheckbox = /*#__PURE__*/ (0, _baseDefault.default)((0, _checkboxFieldDefault.default), {
    target: "e1tdxpfl1"
})({
    name: "xda5ep",
    styles: "margin-top:12px"
});
const containerStyle = /*#__PURE__*/ (0, _css.css)("padding-top:32px;max-width:432px;font-family:Muli;font-style:normal;font-weight:normal;.title-container{.title{font-size:18px;line-height:24px;padding-bottom:18px;color:", (0, _colors.color_text_default), ";}.subtitle{font-size:14px;line-height:20px;padding-bottom:12px;color:", (0, _colors.color_text_light), ";}}", "");
const RestartButton = /*#__PURE__*/ (0, _baseDefault.default)(StyledTopButton, {
    target: "e1tdxpfl0"
})("color:", (0, _colors.color_colors_growth), ";");
exports.default = ContentItemTestCasesPanel;

},{"@emotion/styled/base":"lSuFu","@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","../../../constants/colors":"1p3OR","../../../components/general/Button":"6ymxN","../../../components/structure/CustomScrollbars":"50vFq","../../../hooks/UseWindowSize":"43j9z","../../../hooks/TestCaseContainer":"cLg3U","../../../components/forms/EditTestCase":"ePcs7","../../../components/general/SecondaryLoader":"7zJiF","../../../components/forms/SearchField":"aU10T","../../../components/forms/CheckboxField":"3S5Oy","../../../components/general/TooltipWrapper":"53pWd","../../featureContent/components/DeleteConfirmation":"9xK2d","../../../components/structure/ConfirmationDialog":"kx7yK","e23b8ae25c4f1bef":"agq6G","ebc70959001284f2":"1S0DP","8b35befb63b13c72":"4D83Y","d3906f26721ba7a7":"9akQy","7c84f02e00b65476":"8RZxX","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"cLg3U":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _unstatedNext = require("unstated-next");
var _api = require("../api");
var _invalidResult = require("../models/result/InvalidResult");
var _invalidResultDefault = parcelHelpers.interopDefault(_invalidResult);
var _guids = require("../services/guids");
var _guidsDefault = parcelHelpers.interopDefault(_guids);
function useTestCaseContainer() {
    const [error, setError] = (0, _react.useState)("");
    const [loading, setLoading] = (0, _react.useState)(false);
    const [availableTestCases, setAvailableTestCases] = (0, _react.useState)(null);
    const [assertions, setAssertions] = (0, _react.useState)({});
    const [application, setApplication] = (0, _react.useState)();
    const [testCaseResults, setTestCaseResults] = (0, _react.useState)({});
    const [singleTestCaseListener, setSingleTestCaseListener] = (0, _react.useState)(null);
    const [runningTests, setRunningTests] = (0, _react.useState)([]);
    const [fullResponses, setFullResponses] = (0, _react.useState)({});
    (0, _react.useEffect)(()=>{
        if (!singleTestCaseListener) return;
        const keys = Object.keys(singleTestCaseListener);
        if (keys?.length) {
            const key = keys[0];
            if (runningTests?.length && runningTests.includes(key)) {
                const newRunningTests = runningTests.filter((tc)=>tc != key);
                setRunningTests(newRunningTests);
            }
            const newTestCaseResults = {
                ...testCaseResults,
                [key]: singleTestCaseListener[key].assertions
            };
            setTestCaseResults(newTestCaseResults);
            setFullResponses({
                ...fullResponses,
                [key]: singleTestCaseListener[key]
            });
            setSingleTestCaseListener(null);
        }
    }, [
        singleTestCaseListener
    ]);
    const getTestDevice = ()=>{
        return {
            id: "voicify-client-tester",
            name: "Voicify Test Case Runner",
            supportsAudio: true,
            supportsBackgroundImage: true,
            supportsDisplayText: true,
            supportsForegroundImage: true,
            supportsSsml: true,
            supportsTextInput: true,
            supportsVideo: true,
            supportsVoiceInput: true
        };
    };
    const buildAssistantRequest = (testCase)=>{
        if (testCase.sessionState.sessionAttributes["conversationTurnHistoryState"]) {
            testCase.sessionState.sessionAttributes["ConversationTurnHistoryState"] = testCase.sessionState.sessionAttributes["conversationTurnHistoryState"];
            delete testCase.sessionState.sessionAttributes["conversationTurnHistoryState"];
        }
        const userId = (0, _guidsDefault.default)();
        testCase.userProfile.id = userId;
        testCase.userProfile.userId = userId;
        const sessionId = (0, _guidsDefault.default)();
        testCase.sessionState.id = sessionId;
        const intentRequest = {
            requestId: (0, _guidsDefault.default)(),
            user: {
                id: userId
            },
            device: getTestDevice(),
            context: {
                sessionId: sessionId,
                requestName: null,
                requestType: "IntentRequest",
                requiresLanguageUnderstanding: true,
                originalInput: testCase.text,
                noTracking: true,
                locale: testCase?.locale?.length ? testCase.locale : "en-US",
                channel: "Voicify Test Case Runner"
            },
            testCase: testCase
        };
        return intentRequest;
    };
    const createTestCase = async (appId, testCase)=>{
        try {
            testCase.applicationId = appId;
            if (testCase.sessionState.sessionAttributes["conversationTurnHistoryState"]) {
                testCase.sessionState.sessionAttributes["ConversationTurnHistoryState"] = testCase.sessionState.sessionAttributes["conversationTurnHistoryState"];
                delete testCase.sessionState.sessionAttributes["conversationTurnHistoryState"];
            }
            const result = await _api.createTestCase(appId, testCase);
        } catch (e) {
            setError(e.message);
            return new (0, _invalidResultDefault.default)(e.message);
        }
    };
    const simulateTestCase = async (testCase)=>{
        setLoading(true);
        setError("");
        setRunningTests([
            ...new Set([
                testCase.name
            ])
        ]);
        const request = buildAssistantRequest(testCase);
        const response = await sendAndHandleSingleRequest(application.id, application.secret, request);
        setLoading(false);
        return response;
    };
    const gatherAllTestCases = ()=>{
        let appLevelTestCases = availableTestCases?.applicationTestCases ?? [];
        let contentLevelTestCases = Object.values(availableTestCases?.contentItemTestCases ?? {}).flat();
        return appLevelTestCases.concat(contentLevelTestCases);
    };
    const getContentItemIdList = (numAppTestCases, contentItemTestCaseMap)=>{
        var idList = Array(numAppTestCases).fill(null);
        for(const contentId in contentItemTestCaseMap){
            const ids = Array(contentItemTestCaseMap[contentId].length).fill(contentId);
            idList = idList.concat(ids);
        }
        return idList;
    };
    const runAllTestCases = async (names = [])=>{
        setLoading(true);
        setError("");
        const concurrency = 3;
        const topLevelTestCases = gatherAllTestCases() ?? [];
        const topLevelContentIds = getContentItemIdList(availableTestCases?.applicationTestCases?.length ?? 0, availableTestCases?.contentItemTestCases ?? {});
        var filteredPairs = topLevelTestCases.map((tc, index)=>({
                tc,
                id: topLevelContentIds[index]
            }));
        if (names?.length) filteredPairs = filteredPairs.filter((pair)=>names.includes(pair.tc));
        const finalList = [];
        var finalIdsList = [];
        for(let i = 0; i < filteredPairs.length; i++)if (!runningTests.includes(filteredPairs[i].tc)) {
            finalList.push(filteredPairs[i].tc);
            finalIdsList.push(filteredPairs[i].id);
        }
        const newRunningTests = [
            ...runningTests,
            ...finalList
        ];
        // unique
        const uniqueRunningTests = [
            ...new Set(newRunningTests)
        ];
        setRunningTests(uniqueRunningTests);
        let newTestCaseResults = {
            ...testCaseResults
        };
        const namesToDeleteSet = new Set(finalList);
        finalList.forEach((name)=>{
            delete newTestCaseResults[name];
        });
        finalIdsList.filter((_, index)=>!namesToDeleteSet.has(finalList[index]));
        setTestCaseResults(newTestCaseResults);
        const lists = [];
        const idLists = [];
        for(let i = 0; i < concurrency; i++){
            lists.push([]);
            idLists.push([]);
        }
        for(let i = 0; i < finalList.length; i++){
            lists[i % concurrency].push(finalList[i]);
            idLists[i % concurrency].push(finalIdsList[i]);
        }
        let tasks = [];
        let newFullResponses = {
            ...fullResponses
        };
        const runList = async (list, ids)=>{
            if (!list?.length) return;
            for(let i = 0; i < list.length; i++){
                const response = await simulateTestCaseByName(list[i], ids[i]);
                if (response) newFullResponses[list[i]] = response;
            }
        };
        for(let i = 0; i < lists.length; i++)tasks.push(runList(lists[i], idLists[i]));
        await Promise.all(tasks);
        setLoading(false);
        setFullResponses(newFullResponses);
        return newFullResponses;
    };
    const simulateTestCaseByName = async (name, contentItemId)=>{
        const testCase = await loadTestCase(application.id, name, contentItemId);
        const request = buildAssistantRequest(testCase);
        const result = await _api.sendCustomAssistantRequest(application.id, application.secret, request, false, true, true, true);
        const newTestCaseResults = {};
        let response = null;
        if (result.resultType == "Ok") {
            response = result.data;
            newTestCaseResults[name] = response;
        }
        setSingleTestCaseListener(newTestCaseResults);
        return response;
    };
    const sendAndHandleSingleRequest = async (applicationId, applicationSecret, request)=>{
        try {
            if (request.testCase.sessionState.sessionAttributes["conversationTurnHistoryState"]) {
                request.testCase.sessionState.sessionAttributes["ConversationTurnHistoryState"] = request.testCase.sessionState.sessionAttributes["conversationTurnHistoryState"];
                delete request.testCase.sessionState.sessionAttributes["conversationTurnHistoryState"];
            }
            const result = await _api.sendCustomAssistantRequest(applicationId, applicationSecret, request, false, true, true, true);
            if (result.resultType == "Ok") {
                const response = result.data;
                if (response) {
                    setAssertions(response.assertions);
                    setSingleTestCaseListener({
                        [request.testCase.name]: response
                    });
                    return response;
                } else setAssertions({});
            } else setError(result.errors[0]);
        } catch (error) {
            setError(error.message);
        }
    };
    const loadTestCases = async (appId, contentItemId)=>{
        try {
            setLoading(true);
            const result = await _api.getTestCases(appId, contentItemId, true);
            if (result.resultType === "Ok") {
                setLoading(false);
                setAvailableTestCases(result.data);
                return result.data;
            } else {
                setLoading(false);
                setError(result.errors[0]);
                return null;
            }
        } catch (e) {
            setError(e.message);
            return null;
        }
    };
    const loadTestCase = async (appId, name, contentItemId)=>{
        try {
            setLoading(true);
            const result = await _api.getTestCase(appId, name, contentItemId);
            if (result.resultType === "Ok") {
                setLoading(false);
                return result.data;
            } else {
                setLoading(false);
                setError(result.errors[0]);
                return null;
            }
        } catch (e) {
            setError(e.message);
            return null;
        }
    };
    const deleteTestCase = async (appId, name, contentItemId)=>{
        try {
            setLoading(true);
            const result = await _api.deleteTestCase(appId, name, contentItemId);
            if (result.resultType === "Ok") {
                setLoading(false);
                return result.data;
            } else {
                setLoading(false);
                setError(result.errors[0]);
                return null;
            }
        } catch (e) {
            setError(e.message);
            return null;
        }
    };
    return {
        loading,
        availableTestCases,
        assertions,
        testCaseResults,
        runningTests,
        fullResponses,
        setLoading,
        createTestCase,
        loadAppLevelTestCases: loadTestCases,
        loadAppLevelTestCase: loadTestCase,
        deleteAppLevelTestCase: deleteTestCase,
        simulateTestCase,
        setApplication,
        setAvailableTestCases,
        runAppLevelTestCases: runAllTestCases,
        simulateTestCaseByName,
        setRunningTests,
        setTestCaseResults,
        gatherAllTestCases,
        getContentItemIdList
    };
}
const TestCaseContainer = (0, _unstatedNext.createContainer)(useTestCaseContainer);
exports.default = TestCaseContainer;

},{"react":"6uln9","unstated-next":"61zE5","../api":"loxM6","../models/result/InvalidResult":"hpD5G","../services/guids":"jvaYQ","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"ePcs7":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _base = require("@emotion/styled/base");
var _baseDefault = parcelHelpers.interopDefault(_base);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _modalLayout = require("../structure/ModalLayout");
var _modalLayoutDefault = parcelHelpers.interopDefault(_modalLayout);
var _modalHeader = require("../general/ModalHeader");
var _modalHeaderDefault = parcelHelpers.interopDefault(_modalHeader);
var _footerBar = require("../structure/FooterBar");
var _footerBarDefault = parcelHelpers.interopDefault(_footerBar);
var _customScrollbars = require("../structure/CustomScrollbars");
var _customScrollbarsDefault = parcelHelpers.interopDefault(_customScrollbars);
var _button = require("../general/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _testCaseContainer = require("../../hooks/TestCaseContainer");
var _testCaseContainerDefault = parcelHelpers.interopDefault(_testCaseContainer);
var _textField = require("./TextField");
var _textFieldDefault = parcelHelpers.interopDefault(_textField);
var _jsoneditorReact = require("jsoneditor-react");
var _colors = require("../../constants/colors");
var _useWindowSize = require("../../hooks/UseWindowSize");
var _useWindowSizeDefault = parcelHelpers.interopDefault(_useWindowSize);
var _checkboxField = require("./CheckboxField");
var _checkboxFieldDefault = parcelHelpers.interopDefault(_checkboxField);
var _testCaseHistoryViewer = require("./TestCaseHistoryViewer");
var _testCaseHistoryViewerDefault = parcelHelpers.interopDefault(_testCaseHistoryViewer);
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const TestCaseEditingModal = ({ initialValue, onSave, onClose, isContentItemView })=>{
    const [testCase, setTestCase] = (0, _react1.useState)(JSON.parse(JSON.stringify(initialValue)));
    const [fallbackId, setFallbackId] = (0, _react1.useState)(null);
    const [assistantResponse, setAssistantResponse] = (0, _react1.useState)("");
    const [turns, setTurns] = (0, _react1.useState)([]);
    const [isContentItemTestCase, setIsContentItemTestCase] = (0, _react1.useState)(testCase.contentItemId?.length > 0);
    const testCaseContainer = (0, _testCaseContainerDefault.default).useContainer();
    const windowSize = (0, _useWindowSizeDefault.default)();
    const MODAL_SCROLLBAR_SUBTRACTION = 185;
    const subScrollbarRef = (0, _react1.useRef)(null);
    (0, _react1.useEffect)(()=>{
        if (subScrollbarRef?.current) subScrollbarRef?.current.scrollToBottom();
    }, [
        turns
    ]);
    (0, _react1.useEffect)(()=>{
        if (testCaseContainer?.fullResponses[testCase.name]?.outputSpeech?.length) {
            setAssistantResponse(testCaseContainer?.fullResponses[testCase.name]?.outputSpeech);
            if (subScrollbarRef?.current) subScrollbarRef?.current.scrollToBottom();
        }
    }, [
        testCaseContainer?.fullResponses
    ]);
    (0, _react1.useEffect)(()=>{
        let tc = testCase;
        if (!testCase) tc = initialValue;
        var turnHistoryState = tc.sessionState.sessionAttributes["ConversationTurnHistoryState"];
        if (!turnHistoryState) turnHistoryState = tc.sessionState.sessionAttributes["conversationTurnHistoryState"];
        if (turnHistoryState?.TurnHistory?.length) {
            const newTurns = [];
            for (const turn of turnHistoryState.TurnHistory)newTurns.push({
                user: turn.UserInput,
                assistant: turn.AssistantResponse
            });
            setTurns(newTurns);
            if (subScrollbarRef?.current) subScrollbarRef?.current.scrollToBottom();
        }
    }, [
        initialValue,
        testCase
    ]);
    const windowHeight = windowSize.windowSize.innerHeight * .9 - MODAL_SCROLLBAR_SUBTRACTION;
    const CustomEditorWrapper = /*#__PURE__*/ (0, _baseDefault.default)("div", {
        target: "e1gftrmh31"
    })("height:", windowHeight, ";");
    const importTestCaseFromClipboard = async ()=>{
        const clipboardText = await navigator.clipboard.readText();
        try {
            const parsedTestCase = JSON.parse(clipboardText);
            if (parsedTestCase.sessionState) setTestCase(parsedTestCase);
        } catch (error) {
            console.error("Failed to parse clipboard text as TestCase:", error);
        }
    };
    const copyTestCaseToClipboard = async ()=>{
        const testCaseToCopy = {
            ...testCase
        };
        testCaseToCopy.name = `${testCaseToCopy.name}-copied`;
        const testCaseString = JSON.stringify(testCaseToCopy, null, 2);
        await navigator.clipboard.writeText(testCaseString);
    };
    const handleChange = (field, value)=>{
        if (field === "sessionState" || field === "userProfile") setTestCase((prev)=>({
                ...prev,
                [field]: JSON.parse(value)
            }));
        else setTestCase((prev)=>({
                ...prev,
                [field]: value
            }));
    };
    const setTestCaseContentItem = ()=>{
        const updatedTestCase = testCase;
        const sessionAttributes = updatedTestCase?.sessionState?.sessionAttributes;
        const sessionHistory = "conversationTurnHistoryState" in sessionAttributes ? sessionAttributes["conversationTurnHistoryState"] : null;
        const lastTurn = sessionHistory !== null ? sessionHistory["TurnHistory"].at(-1) : null;
        const contentId = lastTurn !== null && "ContentId" in lastTurn ? lastTurn["ContentId"] : null;
        const currentFallbackId = lastTurn !== null && "FallbackMessageId" in lastTurn ? lastTurn["FallbackMessageId"] : null;
        if (isContentItemTestCase) {
            updatedTestCase.contentItemId = null;
            setIsContentItemTestCase(false);
            setFallbackId(null);
        } else {
            updatedTestCase.contentItemId = contentId;
            setFallbackId(currentFallbackId);
            setIsContentItemTestCase(true);
        }
        setTestCase(updatedTestCase);
    };
    const handleClose = ()=>{
        if (viewResponseJson || editSessionState || editUserProfile) {
            setViewResponseJson(false);
            setEditSessionState(false);
            setEditUserProfile(false);
        } else onClose();
    };
    const simulate = async ()=>{
        await testCaseContainer.simulateTestCase(testCase);
    };
    const updateAssertion = (idx, value)=>{
        const next = [
            ...testCase.assertions ?? []
        ];
        next[idx] = value;
        handleChange("assertions", next);
    };
    const addAssertion = ()=>handleChange("assertions", [
            ...testCase.assertions ?? [],
            ""
        ]);
    const removeAssertion = (idx)=>{
        let next = [
            ...testCase.assertions ?? []
        ];
        next.splice(idx, 1);
        if (testCase.assertions?.length === 1 || testCase.assertions?.length === 0) next = [];
        handleChange("assertions", next);
    };
    const handleSave = ()=>{
        if (testCase.name?.length > 0) {
            onSave({
                ...testCase
            });
            if (fallbackId !== null) {
                const testCaseCopy = {
                    ...testCase
                };
                testCaseCopy.name = `${testCase.name}-fallback`;
                testCaseCopy.contentItemId = fallbackId;
                onSave({
                    ...testCaseCopy
                });
            }
            onClose();
        }
    };
    const sessionStateEditorRef = (0, _react1.useRef)(null);
    const userStateEditorReft = (0, _react1.useRef)(null);
    const responseJsonEditorRef = (0, _react1.useRef)(null);
    (0, _react1.useEffect)(()=>{
        if (sessionStateEditorRef.current !== null) sessionStateEditorRef.current.set(testCase.sessionState ? testCase.sessionState : {});
    }, [
        testCase.sessionState
    ]);
    (0, _react1.useEffect)(()=>{
        if (userStateEditorReft.current !== null) userStateEditorReft.current.set(testCase.userProfile ? testCase.userProfile : {});
    }, [
        testCase.userProfile
    ]);
    const setSessionRef = (instance)=>{
        if (instance) sessionStateEditorRef.current = instance.jsonEditor;
        else sessionStateEditorRef.current = null;
    };
    const setUserRef = (instance)=>{
        if (instance) userStateEditorReft.current = instance.jsonEditor;
        else userStateEditorReft.current = null;
    };
    const setResponseJsonRef = (instance)=>{
        if (instance) responseJsonEditorRef.current = instance.jsonEditor;
        else responseJsonEditorRef.current = null;
    };
    const getAssertionText = (assertion)=>{
        const keys = Object.keys(testCaseContainer?.fullResponses);
        if (!assertion?.length || !keys?.length || !testCase?.name?.length || !keys.includes(testCase?.name)) return "?";
        if (testCaseContainer?.fullResponses[testCase?.name]) {
            const asserts = testCaseContainer?.fullResponses[testCase?.name]?.assertions;
            if (!asserts) return "?";
            const assertionKeys = Object.keys(asserts);
            if (!assertionKeys?.length) return "?";
            if (!assertionKeys.includes(assertion)) return "?";
            return testCaseContainer?.fullResponses[testCase?.name].assertions[assertion];
        }
        return "?";
    };
    const [editSessionState, setEditSessionState] = (0, _react1.useState)(false);
    const [editUserProfile, setEditUserProfile] = (0, _react1.useState)(false);
    const [viewResponseJson, setViewResponseJson] = (0, _react1.useState)(false);
    const renderSession = ()=>{
        return (0, _react.jsx)(CustomEditorWrapper, null, (0, _react.jsx)(CustomEditor, null, (0, _react.jsx)((0, _jsoneditorReact.JsonEditor), {
            ref: setSessionRef,
            value: testCase.sessionState,
            onChange: (value)=>null,
            enableTransform: false,
            enableSort: false,
            mode: "tree",
            allowedModes: [
                "tree",
                "code"
            ],
            sortObjectKeys: true
        })));
    };
    const renderUserProfile = ()=>{
        return (0, _react.jsx)(CustomEditorWrapper, null, (0, _react.jsx)(CustomEditor, null, (0, _react.jsx)((0, _jsoneditorReact.JsonEditor), {
            ref: setUserRef,
            value: testCase.userProfile,
            onChange: (value)=>null,
            enableTransform: false,
            enableSort: false,
            mode: "tree",
            allowedModes: [
                "tree",
                "code"
            ],
            sortObjectKeys: true
        })));
    };
    const renderResponseJson = ()=>{
        return (0, _react.jsx)(CustomEditorWrapper, null, (0, _react.jsx)(CustomEditor, null, (0, _react.jsx)((0, _jsoneditorReact.JsonEditor), {
            ref: setResponseJsonRef,
            value: testCaseContainer?.fullResponses[testCase?.name],
            onChange: ()=>{},
            enableTransform: false,
            enableSort: false,
            mode: "tree",
            allowedModes: [
                "tree",
                "code"
            ],
            sortObjectKeys: true
        })));
    };
    return (0, _react.jsx)((0, _modalLayoutDefault.default), {
        isVisible: true
    }, (0, _react.jsx)((0, _modalHeaderDefault.default), {
        title: testCase.name?.length > 0 ? `Edit ${testCase.name}` : "Create new Test Case",
        onClose: ()=>handleClose()
    }), !(editSessionState || editUserProfile || viewResponseJson) ? (0, _react.jsx)((0, _customScrollbarsDefault.default), {
        autoHide: true,
        autoHeight: true,
        autoHeightMax: windowSize.windowSize.innerHeight * .9 - MODAL_SCROLLBAR_SUBTRACTION
    }, (0, _react.jsx)(Body, {
        minHeight: windowSize.windowSize.innerHeight * .9 - MODAL_SCROLLBAR_SUBTRACTION
    }, (0, _react.jsx)(HistoryViewerButtons, null, (0, _react.jsx)(HistoryButton, {
        type: "button",
        themes: [
            "secondary-small",
            "end"
        ],
        text: "Session State",
        onClick: ()=>setEditSessionState(true)
    }), (0, _react.jsx)(HistoryButton, {
        type: "button",
        themes: [
            "secondary-small",
            "end"
        ],
        text: "User Profile",
        onClick: ()=>setEditUserProfile(true)
    })), (0, _react.jsx)(Center, null, (0, _react.jsx)(SectionCard, null, (0, _react.jsx)(TopRow, null, (0, _react.jsx)(ThinTextField, {
        useForm: false,
        label: "Name of test case",
        id: "test-case-name",
        type: "text",
        value: testCase.name,
        placeholder: "Enter a name for your test case… (Required)",
        onChange: (e)=>handleChange("name", e.target.value),
        autoFocus: true
    }), (0, _react.jsx)(TopRowButton, {
        type: "button",
        themes: [
            "start",
            "secondary-small"
        ],
        text: "Copy to Clipboard",
        onClick: ()=>copyTestCaseToClipboard()
    }), (0, _react.jsx)(TopRowButton, {
        type: "button",
        themes: [
            "start",
            "secondary-small"
        ],
        text: "Paste from Clipboard",
        onClick: ()=>importTestCaseFromClipboard()
    }), !isContentItemView && (0, _react.jsx)(DetailedSimpleCheckbox, {
        id: "simpleView",
        label: "Content Item Test",
        checked: isContentItemTestCase,
        onChange: ()=>setTestCaseContentItem()
    })))), (0, _react.jsx)((0, _testCaseHistoryViewerDefault.default), {
        currentTestCase: testCase
    }), (0, _react.jsx)(Center, null, (0, _react.jsx)(SectionCard, null, (0, _react.jsx)(InputOutputRow, null, (0, _react.jsx)(InputTextField, {
        useForm: false,
        label: "Input (The most recent user utterance)",
        type: "text",
        value: testCase.text,
        placeholder: "input text here",
        onChange: (e)=>handleChange("text", e.target.value),
        autoFocus: true
    }), (0, _react.jsx)(OutputRow, null, (0, _react.jsx)(OutputTextField, {
        useForm: false,
        disabled: true,
        label: "Output",
        type: "text",
        value: assistantResponse,
        placeholder: "not simulated yet",
        onChange: ()=>{}
    }), (0, _react.jsx)(ResponseJsonButton, {
        disabled: !testCaseContainer?.fullResponses[testCase?.name]?.outputSpeech?.length,
        type: "button",
        themes: [
            "secondary-small",
            "end"
        ],
        text: "Response JSON",
        onClick: ()=>setViewResponseJson(true)
    }))), (0, _react.jsx)(Table, null, (testCase.assertions ?? []).map((c, i)=>{
        const assertionText = getAssertionText(c);
        const variant = assertionText.toLowerCase() === "true" ? "success" : assertionText.toLowerCase() === "false" ? "failure" : "default";
        return (0, _react.jsx)(Row, {
            key: i
        }, (0, _react.jsx)(AssertionPreText, null, "The assistant response should "), (0, _react.jsx)(AssertionInput, {
            onChange: (e)=>updateAssertion(i, e.currentTarget.value),
            variant: variant,
            value: c
        }), (0, _react.jsx)(AssertionPostText, null, getAssertionText(c)), (0, _react.jsx)(RowButton, {
            type: "button",
            themes: [
                "secondary-small",
                "end"
            ],
            text: "✕",
            onClick: ()=>removeAssertion(i)
        }));
    })), (0, _react.jsx)(AddAssertionButton, {
        type: "button",
        themes: [
            "start",
            "white-pill"
        ],
        text: "+ Add Assertion",
        onClick: addAssertion
    }))))) : editSessionState ? renderSession() : editUserProfile ? renderUserProfile() : viewResponseJson ? renderResponseJson() : (0, _react.jsx)((0, _reactDefault.default).Fragment, null), (0, _react.jsx)((0, _footerBarDefault.default), null, !(editSessionState || editUserProfile || viewResponseJson) ? (0, _react.jsx)((0, _reactDefault.default).Fragment, null, (0, _react.jsx)((0, _buttonDefault.default), {
        disabled: false,
        loading: testCaseContainer.loading,
        type: "button",
        themes: [
            "secondary",
            "start"
        ],
        text: "Simulate",
        onClick: ()=>simulate()
    }), (0, _react.jsx)((0, _buttonDefault.default), {
        disabled: false,
        loading: testCaseContainer.loading,
        type: "button",
        themes: [
            "primary",
            "end"
        ],
        text: "Save & Close",
        onClick: ()=>handleSave()
    })) : editSessionState ? (0, _react.jsx)((0, _buttonDefault.default), {
        type: "button",
        themes: [
            "primary",
            "end"
        ],
        text: "Save and go back",
        onClick: ()=>{
            handleChange("sessionState", sessionStateEditorRef.current.getText());
            setEditSessionState(false);
        }
    }) : editUserProfile ? (0, _react.jsx)((0, _buttonDefault.default), {
        type: "button",
        themes: [
            "primary",
            "end"
        ],
        text: "Save and go back",
        onClick: ()=>{
            handleChange("userProfile", userStateEditorReft.current.getText());
            setEditUserProfile(false);
        }
    }) : viewResponseJson ? (0, _react.jsx)((0, _buttonDefault.default), {
        type: "button",
        themes: [
            "primary",
            "end"
        ],
        text: "Back",
        onClick: ()=>setViewResponseJson(false)
    }) : (0, _react.jsx)((0, _reactDefault.default).Fragment, null)));
};
exports.default = TestCaseEditingModal;
const Body = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1gftrmh30"
})("position:relative;min-height:", (props)=>props.minHeight ? `${props.minHeight}px` : "auto", ";");
const InputOutputRow = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1gftrmh29"
})({
    name: "fhxb3m",
    styles: "display:flex;flex-direction:row;align-items:center"
});
const OutputRow = /*#__PURE__*/ (0, _baseDefault.default)(InputOutputRow, {
    target: "e1gftrmh28"
})({
    name: "tpoopg",
    styles: "display:flex;flex-direction:row;align-items:center;width:50%"
});
const ThinTextField = /*#__PURE__*/ (0, _baseDefault.default)((0, _textFieldDefault.default), {
    target: "e1gftrmh27"
})({
    name: "1abw47n",
    styles: "height:32px;.field-container{height:32px;}.field-container input{height:32px;padding:0px 8px;}"
});
const InputTextField = /*#__PURE__*/ (0, _baseDefault.default)(ThinTextField, {
    target: "e1gftrmh26"
})({
    name: "1b56iil",
    styles: "margin-right:8px;width:50%"
});
const OutputTextField = /*#__PURE__*/ (0, _baseDefault.default)(ThinTextField, {
    target: "e1gftrmh25"
})({
    name: "1q4vxyr",
    styles: "margin-left:8px"
});
const AssertionPreText = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1gftrmh24"
})({
    name: "1qa3j9f",
    styles: "font-style:italic;font-size:14px;width:300px"
});
const AssertionPostText = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1gftrmh23"
})({
    name: "1uy5bnz",
    styles: "font-size:14px;width:50px"
});
const Table = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1gftrmh22"
})({
    name: "1br09b8",
    styles: "display:flex;flex-direction:column;gap:8px;margin-top:16px"
});
const Row = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1gftrmh21"
})({
    name: "197tvr9",
    styles: "display:flex;gap:8px;align-items:center"
});
const RowButton = /*#__PURE__*/ (0, _baseDefault.default)((0, _buttonDefault.default), {
    target: "e1gftrmh20"
})({
    name: "1h28fa9",
    styles: "margin:0px;margin-right:auto;margin-left:30px;padding-bottom:2px"
});
const HistoryButton = /*#__PURE__*/ (0, _baseDefault.default)((0, _buttonDefault.default), {
    target: "e1gftrmh19"
})({
    name: "13l0a4q",
    styles: "margin:0px 8px 8px 0px;z-index:10"
});
const ResponseJsonButton = /*#__PURE__*/ (0, _baseDefault.default)((0, _buttonDefault.default), {
    target: "e1gftrmh18"
})({
    name: "17r9leg",
    styles: "margin-right:0px;margin-left:16px;top:15px"
});
const CustomEditor = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1gftrmh17"
})("font-family:Muli;*.jsoneditor-mode-tree{border:1px solid ", (0, _colors.color_shades_dark), ";font-family:Muli;}div.jsoneditor-menu{background-color:", (0, _colors.color_shades_darkest), ";border-bottom:none;}ul.jsoneditor-menu{background-color:white;}*.jsoneditor-navigation-bar{font-family:Muli;}.div.jsoneditor-field,div.jsoneditor-value,div.jsoneditor td,div.jsoneditor th,div.jsoneditor textarea,pre.jsoneditor-preview,.jsoneditor-schema-error,.jsoneditor-popover{font-family:Muli;}div.jsoneditor-tree div.jsoneditor-color{display:none;}");
const LabelWrapper = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1gftrmh16"
})({
    name: "ho1qnd",
    styles: "display:flex;flex-direction:row"
});
const Label = /*#__PURE__*/ (0, _baseDefault.default)("p", {
    target: "e1gftrmh15"
})("font-weight:400;font-size:16px;color:", (0, _colors.color_shades_darkest), ";margin:0 0 4px 0px;");
const SmallLabel = /*#__PURE__*/ (0, _baseDefault.default)("p", {
    target: "e1gftrmh14"
})("font-weight:400;font-size:14px;color:", (0, _colors.color_shades_darkest), ";margin:0 0 4px 0px;");
const BoldSmallLabel = /*#__PURE__*/ (0, _baseDefault.default)(SmallLabel, {
    target: "e1gftrmh13"
})("font-weight:bold;color:", (0, _colors.color_defaults_black), ";");
const InfoLabel = /*#__PURE__*/ (0, _baseDefault.default)("p", {
    target: "e1gftrmh12"
})("font-weight:300;font-size:14px;font-style:italic;color:", (0, _colors.color_shades_darker), ";margin:0 0 4px 0px;");
const BoldInfoLabel = /*#__PURE__*/ (0, _baseDefault.default)(InfoLabel, {
    target: "e1gftrmh11"
})("font-weight:bold;color:", (0, _colors.color_defaults_black), ";");
const FinalTurnWrapper = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1gftrmh10"
})("");
const Center = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1gftrmh9"
})({
    name: "e3viwr",
    styles: "display:flex;justify-content:center;width:100%"
});
const SectionCard = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1gftrmh8"
})({
    name: "1n5m579",
    styles: "padding:16px;width:100%;display:block;justify-content:flex-start"
});
const TopRow = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1gftrmh7"
})({
    name: "4c6dm7",
    styles: "display:flex;flex-direction:row;justify-content:space-between"
});
const TopRowButton = /*#__PURE__*/ (0, _baseDefault.default)((0, _buttonDefault.default), {
    target: "e1gftrmh6"
})({
    name: "2ldqey",
    styles: "margin:28px 0px 0px 16px"
});
const HistoryViewer = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1gftrmh5"
})("border-radius:8px;display:block;background-color:", (0, _colors.color_shades_lighter), ";height:250px;margin:0px 16px;");
const HistoryViewerInScroll = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1gftrmh4"
})({
    name: "q9jxqs",
    styles: "padding:16px 0px;margin:0 16px"
});
const HistoryViewerButtons = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1gftrmh3"
})({
    name: "1ywwaez",
    styles: "position:absolute;top:120px;right:24px;display:flex;flex-direction:column"
});
const AddAssertionButton = /*#__PURE__*/ (0, _baseDefault.default)((0, _buttonDefault.default), {
    target: "e1gftrmh2"
})({
    name: "k7irkt",
    styles: "margin-left:0px;margin-top:16px"
});
const bgMap = {
    default: "white",
    success: (0, _colors.color_variants_green_2),
    failure: (0, _colors.color_variants_red_2)
};
const AssertionInput = /*#__PURE__*/ (0, _baseDefault.default)("input", {
    target: "e1gftrmh1"
})("padding:8px 12px;border:1px solid ", (0, _colors.color_shades_dark), ";border-radius:6px;font-family:Muli;font-size:14px;width:100%;background-color:", ({ variant = "default" })=>bgMap[variant], ";");
const DetailedSimpleCheckbox = /*#__PURE__*/ (0, _baseDefault.default)((0, _checkboxFieldDefault.default), {
    target: "e1gftrmh0"
})({
    name: "lrrrcl",
    styles: "margin-top:33px;margin-left:8px"
});

},{"@emotion/styled/base":"lSuFu","@emotion/react":"djZKr","react":"6uln9","../structure/ModalLayout":"b1cO3","../general/ModalHeader":"aUACx","../structure/FooterBar":"bibRL","../structure/CustomScrollbars":"50vFq","../general/Button":"6ymxN","../../hooks/TestCaseContainer":"cLg3U","./TextField":"7a7bh","jsoneditor-react":"5EVpf","../../constants/colors":"1p3OR","../../hooks/UseWindowSize":"43j9z","./CheckboxField":"3S5Oy","./TestCaseHistoryViewer":"lvjRC","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"5EVpf":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "JsonEditor", ()=>Editor);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _jsoneditorMinimalist = require("jsoneditor/dist/jsoneditor-minimalist");
var _jsoneditorMinimalistDefault = parcelHelpers.interopDefault(_jsoneditorMinimalist);
var _jsoneditorCss = require("jsoneditor/dist/jsoneditor.css");
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpread2(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) ownKeys(Object(source), true).forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function _possibleConstructorReturn(self, call) {
    if (call && (typeof call === "object" || typeof call === "function")) return call;
    return _assertThisInitialized(self);
}
/**
 * @typedef {{
 * tree: string,
 * view: string,
 * form: string,
 * code: string,
 * text: string,
 * allValues: Array<string>
 * }} TJsonEditorModes
 */ var modes = {
    tree: "tree",
    view: "view",
    form: "form",
    code: "code",
    text: "text"
};
var values = Object.values(modes);
modes.allValues = values;
/**
 * @type {object}
 * @property {object} [value]
 * @property {string} [mode='tree'] - Set the editor mode.
 * @property {string} [name=undefined] - Initial field name for the root node
 * @property {object} [schema] - Validate the JSON object against a JSON schema.
 * @property {object} [schemaRefs] - Schemas that are referenced using
 * the $ref property
 * @property {Function} [onChange] - Set a callback function
 * triggered when json in the JSONEditor change.
 * Will only be triggered on changes made by the user.
 * @property {Function} [onError] - Set a callback function triggered when an error occurs.
 * Invoked with the error as first argument.
 * The callback is only invoked for errors triggered by a users action,
 * like switching from code mode to tree mode or clicking
 * the Format button whilst the editor doesn't contain valid JSON.
 * @property {Function} [onModeChange] - Set a callback function
 * triggered right after the mode is changed by the user.
 * @property {object} [ace] - Provide a version of the Ace editor.
 * Only applicable when mode is code
 * @property {object} [ajv] - Provide a instance of ajv,
 * the library used for JSON schema validation.
 * @property {string} [theme] - Set the Ace editor theme,
 * uses included 'ace/theme/jsoneditor' by default.
 * @property {boolean} [history=false] - Enables history,
 * adds a button Undo and Redo to the menu of the JSONEditor. Only applicable when
 * mode is 'tree' or 'form'
 * @property {boolean} [navigationBar=true] - Adds navigation bar to the menu
 * the navigation bar visualize the current position on the
 * tree structure as well as allows breadcrumbs navigation.
 * @property {boolean} [statusBar=true] - Adds status bar to the buttom of the editor
 * the status bar shows the cursor position and a count of the selected characters.
 * Only applicable when mode is 'code' or 'text'.
 * @property {boolean} [search=true] - Enables a search box in
 * the upper right corner of the JSONEditor.
 * @property {Array<string>} [allowedModes] - Create a box in the editor menu where
 * the user can switch between the specified modes.
 * @property {(string|PropTypes.elementType)} [tag='div'] - Html element, or react element to render
 * @property {object} [htmlElementProps] - html element custom props
 * @property {Function} [innerRef] - callback to get html element reference
 * @property {boolean} [sortObjectKeys=false] If true, object keys in 'tree',
 * 'view' or 'form' mode list be listed alphabetically instead by their insertion order..
 */ var Editor = /*#__PURE__*/ function(_Component) {
    _inherits(Editor, _Component);
    function Editor(props) {
        var _this;
        _classCallCheck(this, Editor);
        _this = _possibleConstructorReturn(this, _getPrototypeOf(Editor).call(this, props));
        _this.htmlElementRef = null;
        _this.jsonEditor = null;
        _this.handleChange = _this.handleChange.bind(_assertThisInitialized(_this));
        _this.setRef = _this.setRef.bind(_assertThisInitialized(_this));
        _this.collapseAll = _this.collapseAll.bind(_assertThisInitialized(_this));
        _this.expandAll = _this.expandAll.bind(_assertThisInitialized(_this));
        _this.focus = _this.focus.bind(_assertThisInitialized(_this));
        return _this;
    }
    _createClass(Editor, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                var _this$props = this.props, allowedModes = _this$props.allowedModes, innerRef = _this$props.innerRef, htmlElementProps = _this$props.htmlElementProps, tag = _this$props.tag, onChange = _this$props.onChange, rest = _objectWithoutProperties(_this$props, [
                    "allowedModes",
                    "innerRef",
                    "htmlElementProps",
                    "tag",
                    "onChange"
                ]);
                this.createEditor(_objectSpread2({}, rest, {
                    modes: allowedModes
                }));
            } // eslint-disable-next-line react/sort-comp
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(_ref) {
                var allowedModes = _ref.allowedModes, schema = _ref.schema, name = _ref.name, theme = _ref.theme, schemaRefs = _ref.schemaRefs, innerRef = _ref.innerRef, htmlElementProps = _ref.htmlElementProps, tag = _ref.tag, onChange = _ref.onChange, rest = _objectWithoutProperties(_ref, [
                    "allowedModes",
                    "schema",
                    "name",
                    "theme",
                    "schemaRefs",
                    "innerRef",
                    "htmlElementProps",
                    "tag",
                    "onChange"
                ]);
                if (this.jsonEditor) {
                    if (theme !== this.props.theme) this.createEditor(_objectSpread2({}, rest, {
                        theme: theme,
                        modes: allowedModes
                    }));
                    else {
                        if (schema !== this.props.schema || schemaRefs !== this.props.schemaRefs) this.jsonEditor.setSchema(schema, schemaRefs);
                        if (name !== this.jsonEditor.getName()) this.jsonEditor.setName(name);
                    }
                }
            }
        },
        {
            key: "shouldComponentUpdate",
            value: function shouldComponentUpdate(_ref2) {
                var htmlElementProps = _ref2.htmlElementProps;
                return htmlElementProps !== this.props.htmlElementProps;
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                if (this.jsonEditor) {
                    this.jsonEditor.destroy();
                    this.jsonEditor = null;
                }
            }
        },
        {
            key: "setRef",
            value: function setRef(element) {
                this.htmlElementRef = element;
                if (this.props.innerRef) this.props.innerRef(element);
            }
        },
        {
            key: "createEditor",
            value: function createEditor(_ref3) {
                var value = _ref3.value, rest = _objectWithoutProperties(_ref3, [
                    "value"
                ]);
                if (this.jsonEditor) this.jsonEditor.destroy();
                this.jsonEditor = new (0, _jsoneditorMinimalistDefault.default)(this.htmlElementRef, _objectSpread2({
                    onChange: this.handleChange
                }, rest));
                this.jsonEditor.set(value);
            }
        },
        {
            key: "handleChange",
            value: function handleChange() {
                if (this.props.onChange) try {
                    this.err = null;
                    var text = this.jsonEditor.getText();
                    if (text === "") this.props.onChange(null);
                    var currentJson = this.jsonEditor.get();
                    if (this.props.value !== currentJson) this.props.onChange(currentJson);
                } catch (err) {
                    this.err = err;
                }
            }
        },
        {
            key: "collapseAll",
            value: function collapseAll() {
                if (this.jsonEditor) this.jsonEditor.collapseAll();
            }
        },
        {
            key: "expandAll",
            value: function expandAll() {
                if (this.jsonEditor) this.jsonEditor.expandAll();
            }
        },
        {
            key: "focus",
            value: function focus() {
                if (this.jsonEditor) this.jsonEditor.focus();
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$props2 = this.props, htmlElementProps = _this$props2.htmlElementProps, tag = _this$props2.tag;
                return (0, _reactDefault.default).createElement(tag, _objectSpread2({}, htmlElementProps, {
                    ref: this.setRef
                }));
            }
        }
    ]);
    return Editor;
}((0, _react.Component));
Editor.propTypes = {
    //  jsoneditor props
    value: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).object,
        (0, _propTypesDefault.default).array,
        (0, _propTypesDefault.default).string,
        (0, _propTypesDefault.default).bool,
        (0, _propTypesDefault.default).number
    ]),
    mode: (0, _propTypesDefault.default).oneOf(values),
    name: (0, _propTypesDefault.default).string,
    schema: (0, _propTypesDefault.default).object,
    schemaRefs: (0, _propTypesDefault.default).object,
    sortObjectKeys: (0, _propTypesDefault.default).bool,
    onChange: (0, _propTypesDefault.default).func,
    onError: (0, _propTypesDefault.default).func,
    onModeChange: (0, _propTypesDefault.default).func,
    ace: (0, _propTypesDefault.default).object,
    ajv: (0, _propTypesDefault.default).object,
    theme: (0, _propTypesDefault.default).string,
    history: (0, _propTypesDefault.default).bool,
    navigationBar: (0, _propTypesDefault.default).bool,
    statusBar: (0, _propTypesDefault.default).bool,
    search: (0, _propTypesDefault.default).bool,
    allowedModes: (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).oneOf(values)),
    //  custom props
    tag: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).string,
        (0, _propTypesDefault.default).elementType
    ]),
    htmlElementProps: (0, _propTypesDefault.default).object,
    innerRef: (0, _propTypesDefault.default).func
};
Editor.defaultProps = {
    tag: "div",
    mode: modes.tree,
    history: false,
    search: true,
    navigationBar: true,
    statusBar: true,
    sortObjectKeys: false
};
/**
 * @type TJsonEditorModes
 */ Editor.modes = modes;

},{"react":"6uln9","prop-types":"6FKs7","jsoneditor/dist/jsoneditor-minimalist":"bLeGC","jsoneditor/dist/jsoneditor.css":"XQLmh","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"bLeGC":[function(require,module,exports) {
/*!
 * jsoneditor.js
 *
 * @brief
 * JSONEditor is a web-based tool to view, edit, format, and validate JSON.
 * It has various modes such as a tree editor, a code editor, and a plain text
 * editor.
 *
 * Supported browsers: Chrome, Firefox, Safari, Opera, Internet Explorer 8+
 *
 * @license
 * Licensed under the Apache License, Version 2.0 (the "License"); you may not
 * use this file except in compliance with the License. You may obtain a copy
 * of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied. See the
 * License for the specific language governing permissions and limitations under
 * the License.
 *
 * Copyright (c) 2011-2023 Jos de Jong, http://jsoneditoronline.org
 *
 * @author  Jos de Jong, <wjosdejong@gmail.com>
 * @version 9.10.2
 * @date    2023-05-15
 */ (function webpackUniversalModuleDefinition(root, factory) {
    module.exports = factory();
})(self, function() {
    return /******/ function() {
        /******/ var __webpack_modules__ = {
            /***/ 897: /***/ function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {
                "use strict";
                /* harmony export */ __webpack_require__.d(__webpack_exports__, {
                    /* harmony export */ "x": function() {
                        return /* binding */ ContextMenu;
                    }
                });
                /* harmony import */ var _createAbsoluteAnchor__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(602);
                /* harmony import */ var _util__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(791);
                /* harmony import */ var _i18n__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(907);
                function _typeof(obj) {
                    "@babel/helpers - typeof";
                    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
                        return typeof obj;
                    } : function(obj) {
                        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
                    }, _typeof(obj);
                }
                function _classCallCheck(instance, Constructor) {
                    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
                }
                function _defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
                    }
                }
                function _createClass(Constructor, protoProps, staticProps) {
                    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) _defineProperties(Constructor, staticProps);
                    Object.defineProperty(Constructor, "prototype", {
                        writable: false
                    });
                    return Constructor;
                }
                function _toPropertyKey(arg) {
                    var key = _toPrimitive(arg, "string");
                    return _typeof(key) === "symbol" ? key : String(key);
                }
                function _toPrimitive(input, hint) {
                    if (_typeof(input) !== "object" || input === null) return input;
                    var prim = input[Symbol.toPrimitive];
                    if (prim !== undefined) {
                        var res = prim.call(input, hint || "default");
                        if (_typeof(res) !== "object") return res;
                        throw new TypeError("@@toPrimitive must return a primitive value.");
                    }
                    return (hint === "string" ? String : Number)(input);
                }
                /**
 * A context menu
 * @param {Object[]} items    Array containing the menu structure
 *                            TODO: describe structure
 * @param {Object} [options]  Object with options. Available options:
 *                            {function} close        Callback called when the
 *                                                    context menu is being closed.
 *                            {boolean} limitHeight   Whether ContextMenu height should be
 *                                                    limited or not.
 * @constructor
 */ var ContextMenu = /*#__PURE__*/ function() {
                    function ContextMenu(items, options) {
                        _classCallCheck(this, ContextMenu);
                        this.dom = {};
                        var me = this;
                        var dom = this.dom;
                        this.anchor = undefined;
                        this.items = items;
                        this.eventListeners = {};
                        this.selection = undefined; // holds the selection before the menu was opened
                        this.onClose = options ? options.close : undefined;
                        this.limitHeight = options ? options.limitHeight : false;
                        // create root element
                        var root = document.createElement("div");
                        root.className = "jsoneditor-contextmenu-root";
                        dom.root = root;
                        // create a container element
                        var menu = document.createElement("div");
                        menu.className = "jsoneditor-contextmenu";
                        dom.menu = menu;
                        root.appendChild(menu);
                        // create a list to hold the menu items
                        var list = document.createElement("ul");
                        list.className = "jsoneditor-menu";
                        menu.appendChild(list);
                        dom.list = list;
                        dom.items = []; // list with all buttons
                        // create a (non-visible) button to set the focus to the menu
                        var focusButton = document.createElement("button");
                        focusButton.type = "button";
                        dom.focusButton = focusButton;
                        var li = document.createElement("li");
                        li.style.overflow = "hidden";
                        li.style.height = "0";
                        li.appendChild(focusButton);
                        list.appendChild(li);
                        function createMenuItems(list, domItems, items) {
                            items.forEach(function(item) {
                                if (item.type === "separator") {
                                    // create a separator
                                    var separator = document.createElement("div");
                                    separator.className = "jsoneditor-separator";
                                    var _li = document.createElement("li");
                                    _li.appendChild(separator);
                                    list.appendChild(_li);
                                } else {
                                    var domItem = {};
                                    // create a menu item
                                    var _li2 = document.createElement("li");
                                    list.appendChild(_li2);
                                    // create a button in the menu item
                                    var button = document.createElement("button");
                                    button.type = "button";
                                    button.className = item.className;
                                    domItem.button = button;
                                    if (item.title) button.title = item.title;
                                    if (item.click) button.onclick = function(event) {
                                        event.preventDefault();
                                        me.hide();
                                        item.click();
                                    };
                                    _li2.appendChild(button);
                                    // create the contents of the button
                                    if (item.submenu) {
                                        // add the icon to the button
                                        var divIcon = document.createElement("div");
                                        divIcon.className = "jsoneditor-icon";
                                        button.appendChild(divIcon);
                                        var divText = document.createElement("div");
                                        divText.className = "jsoneditor-text" + (item.click ? "" : " jsoneditor-right-margin");
                                        divText.appendChild(document.createTextNode(item.text));
                                        button.appendChild(divText);
                                        var buttonSubmenu;
                                        if (item.click) {
                                            // submenu and a button with a click handler
                                            button.className += " jsoneditor-default";
                                            var buttonExpand = document.createElement("button");
                                            buttonExpand.type = "button";
                                            domItem.buttonExpand = buttonExpand;
                                            buttonExpand.className = "jsoneditor-expand";
                                            var buttonExpandInner = document.createElement("div");
                                            buttonExpandInner.className = "jsoneditor-expand";
                                            buttonExpand.appendChild(buttonExpandInner);
                                            _li2.appendChild(buttonExpand);
                                            if (item.submenuTitle) buttonExpand.title = item.submenuTitle;
                                            buttonSubmenu = buttonExpand;
                                        } else {
                                            // submenu and a button without a click handler
                                            var divExpand = document.createElement("div");
                                            divExpand.className = "jsoneditor-expand";
                                            button.appendChild(divExpand);
                                            buttonSubmenu = button;
                                        }
                                        // attach a handler to expand/collapse the submenu
                                        buttonSubmenu.onclick = function(event) {
                                            event.preventDefault();
                                            me._onExpandItem(domItem);
                                            buttonSubmenu.focus();
                                        };
                                        // create the submenu
                                        var domSubItems = [];
                                        domItem.subItems = domSubItems;
                                        var ul = document.createElement("ul");
                                        domItem.ul = ul;
                                        ul.className = "jsoneditor-menu";
                                        ul.style.height = "0";
                                        _li2.appendChild(ul);
                                        createMenuItems(ul, domSubItems, item.submenu);
                                    } else {
                                        // no submenu, just a button with clickhandler
                                        var icon = document.createElement("div");
                                        icon.className = "jsoneditor-icon";
                                        button.appendChild(icon);
                                        var text = document.createElement("div");
                                        text.className = "jsoneditor-text";
                                        text.appendChild(document.createTextNode((0, _i18n__WEBPACK_IMPORTED_MODULE_2__ /* .translate */ .Iu)(item.text)));
                                        button.appendChild(text);
                                    }
                                    domItems.push(domItem);
                                }
                            });
                        }
                        createMenuItems(list, this.dom.items, items);
                        // TODO: when the editor is small, show the submenu on the right instead of inline?
                        // calculate the max height of the menu with one submenu expanded
                        this.maxHeight = 0; // height in pixels
                        items.forEach(function(item) {
                            var height = (items.length + (item.submenu ? item.submenu.length : 0)) * 24;
                            me.maxHeight = Math.max(me.maxHeight, height);
                        });
                    }
                    /**
   * Get the currently visible buttons
   * @return {Array.<HTMLElement>} buttons
   * @private
   */ _createClass(ContextMenu, [
                        {
                            key: "_getVisibleButtons",
                            value: function _getVisibleButtons() {
                                var buttons = [];
                                var me = this;
                                this.dom.items.forEach(function(item) {
                                    buttons.push(item.button);
                                    if (item.buttonExpand) buttons.push(item.buttonExpand);
                                    if (item.subItems && item === me.expandedItem) item.subItems.forEach(function(subItem) {
                                        buttons.push(subItem.button);
                                        if (subItem.buttonExpand) buttons.push(subItem.buttonExpand);
                                    // TODO: change to fully recursive method
                                    });
                                });
                                return buttons;
                            }
                        },
                        {
                            key: "show",
                            value: function show(anchor, frame, ignoreParent) {
                                this.hide();
                                // determine whether to display the menu below or above the anchor
                                var showBelow = true;
                                var parent = anchor.parentNode;
                                var anchorRect = anchor.getBoundingClientRect();
                                var parentRect = parent.getBoundingClientRect();
                                var frameRect = frame.getBoundingClientRect();
                                var me = this;
                                this.dom.absoluteAnchor = (0, _createAbsoluteAnchor__WEBPACK_IMPORTED_MODULE_0__ /* .createAbsoluteAnchor */ .w)(anchor, frame, function() {
                                    me.hide();
                                });
                                if (anchorRect.bottom + this.maxHeight < frameRect.bottom) ;
                                else if (anchorRect.top - this.maxHeight > frameRect.top) // fits above -> show above
                                showBelow = false;
                                var topGap = ignoreParent ? 0 : anchorRect.top - parentRect.top;
                                // position the menu
                                if (showBelow) {
                                    // display the menu below the anchor
                                    var anchorHeight = anchor.offsetHeight;
                                    this.dom.menu.style.left = "0";
                                    this.dom.menu.style.top = topGap + anchorHeight + "px";
                                    this.dom.menu.style.bottom = "";
                                } else {
                                    // display the menu above the anchor
                                    this.dom.menu.style.left = "0";
                                    this.dom.menu.style.top = "";
                                    this.dom.menu.style.bottom = "0px";
                                }
                                if (this.limitHeight) {
                                    var margin = 10; // make sure there is a little margin left
                                    var maxPossibleMenuHeight = showBelow ? frameRect.bottom - anchorRect.bottom - margin : anchorRect.top - frameRect.top - margin;
                                    this.dom.list.style.maxHeight = maxPossibleMenuHeight + "px";
                                    this.dom.list.style.overflowY = "auto";
                                }
                                // attach the menu to the temporary, absolute anchor
                                // parent.insertBefore(this.dom.root, anchor);
                                this.dom.absoluteAnchor.appendChild(this.dom.root);
                                // move focus to the first button in the context menu
                                this.selection = (0, _util__WEBPACK_IMPORTED_MODULE_1__.getSelection)();
                                this.anchor = anchor;
                                setTimeout(function() {
                                    me.dom.focusButton.focus();
                                }, 0);
                                if (ContextMenu.visibleMenu) ContextMenu.visibleMenu.hide();
                                ContextMenu.visibleMenu = this;
                            }
                        },
                        {
                            key: "hide",
                            value: function hide() {
                                // remove temporary absolutely positioned anchor
                                if (this.dom.absoluteAnchor) {
                                    this.dom.absoluteAnchor.destroy();
                                    delete this.dom.absoluteAnchor;
                                }
                                // remove the menu from the DOM
                                if (this.dom.root.parentNode) {
                                    this.dom.root.parentNode.removeChild(this.dom.root);
                                    if (this.onClose) this.onClose();
                                }
                                if (ContextMenu.visibleMenu === this) ContextMenu.visibleMenu = undefined;
                            }
                        },
                        {
                            key: "_onExpandItem",
                            value: function _onExpandItem(domItem) {
                                var me = this;
                                var alreadyVisible = domItem === this.expandedItem;
                                // hide the currently visible submenu
                                var expandedItem = this.expandedItem;
                                if (expandedItem) {
                                    // var ul = expandedItem.ul;
                                    expandedItem.ul.style.height = "0";
                                    expandedItem.ul.style.padding = "";
                                    setTimeout(function() {
                                        if (me.expandedItem !== expandedItem) {
                                            expandedItem.ul.style.display = "";
                                            (0, _util__WEBPACK_IMPORTED_MODULE_1__.removeClassName)(expandedItem.ul.parentNode, "jsoneditor-selected");
                                        }
                                    }, 300); // timeout duration must match the css transition duration
                                    this.expandedItem = undefined;
                                }
                                if (!alreadyVisible) {
                                    var ul = domItem.ul;
                                    ul.style.display = "block";
                                    // eslint-disable-next-line no-unused-expressions
                                    ul.clientHeight; // force a reflow in Firefox
                                    setTimeout(function() {
                                        if (me.expandedItem === domItem) {
                                            var childsHeight = 0;
                                            for(var i = 0; i < ul.childNodes.length; i++)childsHeight += ul.childNodes[i].clientHeight;
                                            ul.style.height = childsHeight + "px";
                                            ul.style.padding = "5px 10px";
                                        }
                                    }, 0);
                                    (0, _util__WEBPACK_IMPORTED_MODULE_1__.addClassName)(ul.parentNode, "jsoneditor-selected");
                                    this.expandedItem = domItem;
                                }
                            }
                        },
                        {
                            key: "_onKeyDown",
                            value: function _onKeyDown(event) {
                                var target = event.target;
                                var keynum = event.which;
                                var handled = false;
                                var buttons, targetIndex, prevButton, nextButton;
                                if (keynum === 27) {
                                    // ESC
                                    // hide the menu on ESC key
                                    // restore previous selection and focus
                                    if (this.selection) (0, _util__WEBPACK_IMPORTED_MODULE_1__.setSelection)(this.selection);
                                    if (this.anchor) this.anchor.focus();
                                    this.hide();
                                    handled = true;
                                } else if (keynum === 9) {
                                    // Tab
                                    if (!event.shiftKey) {
                                        // Tab
                                        buttons = this._getVisibleButtons();
                                        targetIndex = buttons.indexOf(target);
                                        if (targetIndex === buttons.length - 1) {
                                            // move to first button
                                            buttons[0].focus();
                                            handled = true;
                                        }
                                    } else {
                                        // Shift+Tab
                                        buttons = this._getVisibleButtons();
                                        targetIndex = buttons.indexOf(target);
                                        if (targetIndex === 0) {
                                            // move to last button
                                            buttons[buttons.length - 1].focus();
                                            handled = true;
                                        }
                                    }
                                } else if (keynum === 37) {
                                    // Arrow Left
                                    if (target.className === "jsoneditor-expand") {
                                        buttons = this._getVisibleButtons();
                                        targetIndex = buttons.indexOf(target);
                                        prevButton = buttons[targetIndex - 1];
                                        if (prevButton) prevButton.focus();
                                    }
                                    handled = true;
                                } else if (keynum === 38) {
                                    // Arrow Up
                                    buttons = this._getVisibleButtons();
                                    targetIndex = buttons.indexOf(target);
                                    prevButton = buttons[targetIndex - 1];
                                    if (prevButton && prevButton.className === "jsoneditor-expand") // skip expand button
                                    prevButton = buttons[targetIndex - 2];
                                    if (!prevButton) // move to last button
                                    prevButton = buttons[buttons.length - 1];
                                    if (prevButton) prevButton.focus();
                                    handled = true;
                                } else if (keynum === 39) {
                                    // Arrow Right
                                    buttons = this._getVisibleButtons();
                                    targetIndex = buttons.indexOf(target);
                                    nextButton = buttons[targetIndex + 1];
                                    if (nextButton && nextButton.className === "jsoneditor-expand") nextButton.focus();
                                    handled = true;
                                } else if (keynum === 40) {
                                    // Arrow Down
                                    buttons = this._getVisibleButtons();
                                    targetIndex = buttons.indexOf(target);
                                    nextButton = buttons[targetIndex + 1];
                                    if (nextButton && nextButton.className === "jsoneditor-expand") // skip expand button
                                    nextButton = buttons[targetIndex + 2];
                                    if (!nextButton) // move to first button
                                    nextButton = buttons[0];
                                    if (nextButton) {
                                        nextButton.focus();
                                        handled = true;
                                    }
                                    handled = true;
                                }
                                // TODO: arrow left and right
                                if (handled) {
                                    event.stopPropagation();
                                    event.preventDefault();
                                }
                            }
                        }
                    ]);
                    return ContextMenu;
                }();
                // currently displayed context menu, a singleton. We may only have one visible context menu
                ContextMenu.visibleMenu = undefined;
            /***/ },
            /***/ 436: /***/ function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {
                "use strict";
                /* harmony export */ __webpack_require__.d(__webpack_exports__, {
                    /* harmony export */ "Q": function() {
                        return /* binding */ ErrorTable;
                    }
                });
                function _typeof(obj) {
                    "@babel/helpers - typeof";
                    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
                        return typeof obj;
                    } : function(obj) {
                        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
                    }, _typeof(obj);
                }
                function _classCallCheck(instance, Constructor) {
                    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
                }
                function _defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
                    }
                }
                function _createClass(Constructor, protoProps, staticProps) {
                    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) _defineProperties(Constructor, staticProps);
                    Object.defineProperty(Constructor, "prototype", {
                        writable: false
                    });
                    return Constructor;
                }
                function _toPropertyKey(arg) {
                    var key = _toPrimitive(arg, "string");
                    return _typeof(key) === "symbol" ? key : String(key);
                }
                function _toPrimitive(input, hint) {
                    if (_typeof(input) !== "object" || input === null) return input;
                    var prim = input[Symbol.toPrimitive];
                    if (prim !== undefined) {
                        var res = prim.call(input, hint || "default");
                        if (_typeof(res) !== "object") return res;
                        throw new TypeError("@@toPrimitive must return a primitive value.");
                    }
                    return (hint === "string" ? String : Number)(input);
                }
                /**
 * Show errors and schema warnings in a clickable table view
 * @param {Object} config
 * @property {boolean} errorTableVisible
 * @property {function (boolean) : void} onToggleVisibility
 * @property {function (number)} [onFocusLine]
 * @property {function (number)} onChangeHeight
 * @constructor
 */ var ErrorTable = /*#__PURE__*/ function() {
                    function ErrorTable(config) {
                        _classCallCheck(this, ErrorTable);
                        this.errorTableVisible = config.errorTableVisible;
                        this.onToggleVisibility = config.onToggleVisibility;
                        this.onFocusLine = config.onFocusLine || function() {};
                        this.onChangeHeight = config.onChangeHeight;
                        this.dom = {};
                        var validationErrorsContainer = document.createElement("div");
                        validationErrorsContainer.className = "jsoneditor-validation-errors-container";
                        this.dom.validationErrorsContainer = validationErrorsContainer;
                        var additionalErrorsIndication = document.createElement("div");
                        additionalErrorsIndication.style.display = "none";
                        additionalErrorsIndication.className = "jsoneditor-additional-errors fadein";
                        additionalErrorsIndication.textContent = "Scroll for more ▿";
                        this.dom.additionalErrorsIndication = additionalErrorsIndication;
                        validationErrorsContainer.appendChild(additionalErrorsIndication);
                        var validationErrorIcon = document.createElement("span");
                        validationErrorIcon.className = "jsoneditor-validation-error-icon";
                        validationErrorIcon.style.display = "none";
                        this.dom.validationErrorIcon = validationErrorIcon;
                        var validationErrorCount = document.createElement("span");
                        validationErrorCount.className = "jsoneditor-validation-error-count";
                        validationErrorCount.style.display = "none";
                        this.dom.validationErrorCount = validationErrorCount;
                        this.dom.parseErrorIndication = document.createElement("span");
                        this.dom.parseErrorIndication.className = "jsoneditor-parse-error-icon";
                        this.dom.parseErrorIndication.style.display = "none";
                    }
                    _createClass(ErrorTable, [
                        {
                            key: "getErrorTable",
                            value: function getErrorTable() {
                                return this.dom.validationErrorsContainer;
                            }
                        },
                        {
                            key: "getErrorCounter",
                            value: function getErrorCounter() {
                                return this.dom.validationErrorCount;
                            }
                        },
                        {
                            key: "getWarningIcon",
                            value: function getWarningIcon() {
                                return this.dom.validationErrorIcon;
                            }
                        },
                        {
                            key: "getErrorIcon",
                            value: function getErrorIcon() {
                                return this.dom.parseErrorIndication;
                            }
                        },
                        {
                            key: "toggleTableVisibility",
                            value: function toggleTableVisibility() {
                                this.errorTableVisible = !this.errorTableVisible;
                                this.onToggleVisibility(this.errorTableVisible);
                            }
                        },
                        {
                            key: "setErrors",
                            value: function setErrors(errors, errorLocations) {
                                var _this = this;
                                // clear any previous errors
                                if (this.dom.validationErrors) {
                                    this.dom.validationErrors.parentNode.removeChild(this.dom.validationErrors);
                                    this.dom.validationErrors = null;
                                    this.dom.additionalErrorsIndication.style.display = "none";
                                }
                                // create the table with errors
                                // keep default behavior for parse errors
                                if (this.errorTableVisible && errors.length > 0) {
                                    var validationErrors = document.createElement("div");
                                    validationErrors.className = "jsoneditor-validation-errors";
                                    var table = document.createElement("table");
                                    table.className = "jsoneditor-text-errors";
                                    validationErrors.appendChild(table);
                                    var tbody = document.createElement("tbody");
                                    table.appendChild(tbody);
                                    errors.forEach(function(error) {
                                        var line;
                                        if (!isNaN(error.line)) line = error.line;
                                        else if (error.dataPath) {
                                            var errLoc = errorLocations.find(function(loc) {
                                                return loc.path === error.dataPath;
                                            });
                                            if (errLoc) line = errLoc.line + 1;
                                        }
                                        var trEl = document.createElement("tr");
                                        trEl.className = !isNaN(line) ? "jump-to-line" : "";
                                        if (error.type === "error") trEl.className += " parse-error";
                                        else trEl.className += " validation-error";
                                        var td1 = document.createElement("td");
                                        var button = document.createElement("button");
                                        button.className = "jsoneditor-schema-error";
                                        td1.appendChild(button);
                                        trEl.appendChild(td1);
                                        var td2 = document.createElement("td");
                                        td2.style = "white-space: nowrap;";
                                        td2.textContent = !isNaN(line) ? "Ln " + line : "";
                                        trEl.appendChild(td2);
                                        if (typeof error === "string") {
                                            var td34 = document.createElement("td");
                                            td34.colSpan = 2;
                                            var pre = document.createElement("pre");
                                            pre.appendChild(document.createTextNode(error));
                                            td34.appendChild(pre);
                                            trEl.appendChild(td34);
                                        } else {
                                            var td3 = document.createElement("td");
                                            td3.appendChild(document.createTextNode(error.dataPath || ""));
                                            trEl.appendChild(td3);
                                            var td4 = document.createElement("td");
                                            var _pre = document.createElement("pre");
                                            _pre.appendChild(document.createTextNode(error.message.replace(/<br>/gi, "\n")));
                                            td4.appendChild(_pre);
                                            trEl.appendChild(td4);
                                        }
                                        trEl.onclick = function() {
                                            _this.onFocusLine(line);
                                        };
                                        tbody.appendChild(trEl);
                                    });
                                    this.dom.validationErrors = validationErrors;
                                    this.dom.validationErrorsContainer.appendChild(validationErrors);
                                    this.dom.additionalErrorsIndication.title = errors.length + " errors total";
                                    if (this.dom.validationErrorsContainer.clientHeight < this.dom.validationErrorsContainer.scrollHeight) {
                                        this.dom.additionalErrorsIndication.style.display = "block";
                                        this.dom.validationErrorsContainer.onscroll = function() {
                                            _this.dom.additionalErrorsIndication.style.display = _this.dom.validationErrorsContainer.clientHeight > 0 && _this.dom.validationErrorsContainer.scrollTop === 0 ? "block" : "none";
                                        };
                                    } else this.dom.validationErrorsContainer.onscroll = undefined;
                                    var height = this.dom.validationErrorsContainer.clientHeight + (this.dom.statusBar ? this.dom.statusBar.clientHeight : 0);
                                    // this.content.style.marginBottom = (-height) + 'px';
                                    // this.content.style.paddingBottom = height + 'px';
                                    this.onChangeHeight(height);
                                } else this.onChangeHeight(0);
                                // update the status bar
                                var validationErrorsCount = errors.filter(function(error) {
                                    return error.type !== "error";
                                }).length;
                                if (validationErrorsCount > 0) {
                                    this.dom.validationErrorCount.style.display = "inline";
                                    this.dom.validationErrorCount.innerText = validationErrorsCount;
                                    this.dom.validationErrorCount.onclick = this.toggleTableVisibility.bind(this);
                                    this.dom.validationErrorIcon.style.display = "inline";
                                    this.dom.validationErrorIcon.title = validationErrorsCount + " schema validation error(s) found";
                                    this.dom.validationErrorIcon.onclick = this.toggleTableVisibility.bind(this);
                                } else {
                                    this.dom.validationErrorCount.style.display = "none";
                                    this.dom.validationErrorIcon.style.display = "none";
                                }
                                // update the parse error icon
                                var hasParseErrors = errors.some(function(error) {
                                    return error.type === "error";
                                });
                                if (hasParseErrors) {
                                    var line = errors[0].line;
                                    this.dom.parseErrorIndication.style.display = "block";
                                    this.dom.parseErrorIndication.title = !isNaN(line) ? "parse error on line " + line : "parse error - check that the json is valid";
                                    this.dom.parseErrorIndication.onclick = this.toggleTableVisibility.bind(this);
                                } else this.dom.parseErrorIndication.style.display = "none";
                            }
                        }
                    ]);
                    return ErrorTable;
                }();
            /***/ },
            /***/ 474: /***/ function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {
                "use strict";
                /* harmony export */ __webpack_require__.d(__webpack_exports__, {
                    /* harmony export */ "R": function() {
                        return /* binding */ FocusTracker;
                    }
                });
                /**
 * @constructor FocusTracker
 * A custom focus tracker for a DOM element with complex internal DOM structure
 * @param  {[Object]} config    A set of configurations for the FocusTracker
 *                {DOM Object} target *    The DOM object to track (required)
 *                {Function}   onFocus     onFocus callback
 *                {Function}   onBlur      onBlur callback
 *
 * @return
 */ function _typeof(obj) {
                    "@babel/helpers - typeof";
                    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
                        return typeof obj;
                    } : function(obj) {
                        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
                    }, _typeof(obj);
                }
                function _classCallCheck(instance, Constructor) {
                    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
                }
                function _defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
                    }
                }
                function _createClass(Constructor, protoProps, staticProps) {
                    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) _defineProperties(Constructor, staticProps);
                    Object.defineProperty(Constructor, "prototype", {
                        writable: false
                    });
                    return Constructor;
                }
                function _toPropertyKey(arg) {
                    var key = _toPrimitive(arg, "string");
                    return _typeof(key) === "symbol" ? key : String(key);
                }
                function _toPrimitive(input, hint) {
                    if (_typeof(input) !== "object" || input === null) return input;
                    var prim = input[Symbol.toPrimitive];
                    if (prim !== undefined) {
                        var res = prim.call(input, hint || "default");
                        if (_typeof(res) !== "object") return res;
                        throw new TypeError("@@toPrimitive must return a primitive value.");
                    }
                    return (hint === "string" ? String : Number)(input);
                }
                var FocusTracker = /*#__PURE__*/ function() {
                    function FocusTracker(config) {
                        _classCallCheck(this, FocusTracker);
                        this.target = config.target || null;
                        if (!this.target) throw new Error('FocusTracker constructor called without a "target" to track.');
                        this.onFocus = typeof config.onFocus === "function" ? config.onFocus : null;
                        this.onBlur = typeof config.onBlur === "function" ? config.onBlur : null;
                        this._onClick = this._onEvent.bind(this);
                        this._onKeyUp = (function(event) {
                            if (event.which === 9 || event.keyCode === 9) this._onEvent(event);
                        }).bind(this);
                        this._onBlur = this._onEvent.bind(this);
                        this.focusFlag = false;
                        this.firstEventFlag = true;
                        /*
      Adds required (click and keyup) event listeners to the 'document' object
      to track the focus of the given 'target'
     */ if (this.onFocus || this.onBlur) {
                            document.addEventListener("click", this._onClick);
                            document.addEventListener("keyup", this._onKeyUp);
                            document.addEventListener("blur", this._onBlur);
                        }
                    }
                    /**
     * Removes the event listeners on the 'document' object
     * that were added to track the focus of the given 'target'
     */ _createClass(FocusTracker, [
                        {
                            key: "destroy",
                            value: function destroy() {
                                document.removeEventListener("click", this._onClick);
                                document.removeEventListener("keyup", this._onKeyUp);
                                document.removeEventListener("blur", this._onBlur);
                                this._onEvent({
                                    target: document.body
                                }); // calling _onEvent with body element in the hope that the FocusTracker is added to an element inside the body tag
                            }
                        },
                        {
                            key: "_onEvent",
                            value: function _onEvent(event) {
                                var target = event.target;
                                var focusFlag;
                                if (target === this.target) focusFlag = true;
                                else if (this.target.contains(target) || this.target.contains(document.activeElement)) focusFlag = true;
                                else focusFlag = false;
                                if (focusFlag) {
                                    if (!this.focusFlag) {
                                        // trigger the onFocus callback
                                        if (this.onFocus) this.onFocus({
                                            type: "focus",
                                            target: this.target
                                        });
                                        this.focusFlag = true;
                                    }
                                } else if (this.focusFlag || this.firstEventFlag) {
                                    // trigger the onBlur callback
                                    if (this.onBlur) this.onBlur({
                                        type: "blur",
                                        target: this.target
                                    });
                                    this.focusFlag = false;
                                    /*
            When switching from one mode to another in the editor, the FocusTracker gets recreated.
            At that time, this.focusFlag will be init to 'false' and will fail the above if condition, when blur occurs
            this.firstEventFlag is added to overcome that issue
           */ if (this.firstEventFlag) this.firstEventFlag = false;
                                }
                            }
                        }
                    ]);
                    return FocusTracker;
                }();
            /***/ },
            /***/ 161: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var ace = __webpack_require__(170); // may be undefined in case of minimalist bundle
                var VanillaPicker = __webpack_require__(37); // may be undefined in case of minimalist bundle
                var _require = __webpack_require__(38), treeModeMixins = _require.treeModeMixins;
                var _require2 = __webpack_require__(458), textModeMixins = _require2.textModeMixins;
                var _require3 = __webpack_require__(341), previewModeMixins = _require3.previewModeMixins;
                var _require4 = __webpack_require__(791), clear = _require4.clear, extend = _require4.extend, getInnerText = _require4.getInnerText, getInternetExplorerVersion = _require4.getInternetExplorerVersion, parse = _require4.parse;
                var _require5 = __webpack_require__(744), tryRequireAjv = _require5.tryRequireAjv;
                var _require6 = __webpack_require__(558), showTransformModal = _require6.showTransformModal;
                var _require7 = __webpack_require__(210), showSortModal = _require7.showSortModal;
                var Ajv = tryRequireAjv();
                if (typeof Promise === "undefined") console.error("Promise undefined. Please load a Promise polyfill in the browser in order to use JSONEditor");
                /**
 * @constructor JSONEditor
 * @param {Element} container    Container element
 * @param {Object}  [options]    Object with options. available options:
 *                               {String} mode        Editor mode. Available values:
 *                                                    'tree' (default), 'view',
 *                                                    'form', 'text', and 'code'.
 *                               {function} onChange  Callback method, triggered
 *                                                    on change of contents.
 *                                                    Does not pass the contents itself.
 *                                                    See also `onChangeJSON` and
 *                                                    `onChangeText`.
 *                               {function} onChangeJSON  Callback method, triggered
 *                                                        in modes on change of contents,
 *                                                        passing the changed contents
 *                                                        as JSON.
 *                                                        Only applicable for modes
 *                                                        'tree', 'view', and 'form'.
 *                               {function} onChangeText  Callback method, triggered
 *                                                        in modes on change of contents,
 *                                                        passing the changed contents
 *                                                        as stringified JSON.
 *                               {function} onError   Callback method, triggered
 *                                                    when an error occurs
 *                               {Boolean} search     Enable search box.
 *                                                    True by default
 *                                                    Only applicable for modes
 *                                                    'tree', 'view', and 'form'
 *                               {Boolean} history    Enable history (undo/redo).
 *                                                    True by default
 *                                                    Only applicable for modes
 *                                                    'tree', 'view', and 'form'
 *                               {String} name        Field name for the root node.
 *                                                    Only applicable for modes
 *                                                    'tree', 'view', and 'form'
 *                               {Number} indentation     Number of indentation
 *                                                        spaces. 4 by default.
 *                                                        Only applicable for
 *                                                        modes 'text' and 'code'
 *                               {boolean} escapeUnicode  If true, unicode
 *                                                        characters are escaped.
 *                                                        false by default.
 *                               {boolean} sortObjectKeys If true, object keys are
 *                                                        sorted before display.
 *                                                        false by default.
 *                               {function} onSelectionChange Callback method,
 *                                                            triggered on node selection change
 *                                                            Only applicable for modes
 *                                                            'tree', 'view', and 'form'
 *                               {function} onTextSelectionChange Callback method,
 *                                                                triggered on text selection change
 *                                                                Only applicable for modes
 *                               {HTMLElement} modalAnchor        The anchor element to apply an
 *                                                                overlay and display the modals in a
 *                                                                centered location.
 *                                                                Defaults to document.body
 *                                                                'text' and 'code'
 *                               {function} onEvent Callback method, triggered
 *                                                  when an event occurs in
 *                                                  a JSON field or value.
 *                                                  Only applicable for
 *                                                  modes 'form', 'tree' and
 *                                                  'view'
 *                               {function} onFocus  Callback method, triggered
 *                                                   when the editor comes into focus,
 *                                                   passing an object {type, target},
 *                                                   Applicable for all modes
 *                               {function} onBlur   Callback method, triggered
 *                                                   when the editor goes out of focus,
 *                                                   passing an object {type, target},
 *                                                   Applicable for all modes
 *                               {function} onClassName Callback method, triggered
 *                                                  when a Node DOM is rendered. Function returns
 *                                                  a css class name to be set on a node.
 *                                                  Only applicable for
 *                                                  modes 'form', 'tree' and
 *                                                  'view'
 *                               {Number} maxVisibleChilds Number of children allowed for a node
 *                                                         in 'tree', 'view', or 'form' mode before
 *                                                         the "show more/show all" buttons appear.
 *                                                         100 by default.
 *
 * @param {Object | undefined} json JSON object
 */ function JSONEditor(container, options, json) {
                    if (!(this instanceof JSONEditor)) throw new Error('JSONEditor constructor called without "new".');
                    // check for unsupported browser (IE8 and older)
                    var ieVersion = getInternetExplorerVersion();
                    if (ieVersion !== -1 && ieVersion < 9) throw new Error("Unsupported browser, IE9 or newer required. Please install the newest version of your browser.");
                    if (options) {
                        // check for deprecated options
                        if (options.error) {
                            console.warn('Option "error" has been renamed to "onError"');
                            options.onError = options.error;
                            delete options.error;
                        }
                        if (options.change) {
                            console.warn('Option "change" has been renamed to "onChange"');
                            options.onChange = options.change;
                            delete options.change;
                        }
                        if (options.editable) {
                            console.warn('Option "editable" has been renamed to "onEditable"');
                            options.onEditable = options.editable;
                            delete options.editable;
                        }
                        // warn if onChangeJSON is used when mode can be `text` or `code`
                        if (options.onChangeJSON) {
                            if (options.mode === "text" || options.mode === "code" || options.modes && (options.modes.indexOf("text") !== -1 || options.modes.indexOf("code") !== -1)) console.warn('Option "onChangeJSON" is not applicable to modes "text" and "code". Use "onChangeText" or "onChange" instead.');
                        }
                        // validate options
                        if (options) Object.keys(options).forEach(function(option) {
                            if (JSONEditor.VALID_OPTIONS.indexOf(option) === -1) console.warn('Unknown option "' + option + '". This option will be ignored');
                        });
                    }
                    if (arguments.length) this._create(container, options, json);
                }
                /**
 * Configuration for all registered modes. Example:
 * {
 *     tree: {
 *         mixin: TreeEditor,
 *         data: 'json'
 *     },
 *     text: {
 *         mixin: TextEditor,
 *         data: 'text'
 *     }
 * }
 *
 * @type { Object.<String, {mixin: Object, data: String} > }
 */ JSONEditor.modes = {};
                // debounce interval for JSON schema validation in milliseconds
                JSONEditor.prototype.DEBOUNCE_INTERVAL = 150;
                JSONEditor.VALID_OPTIONS = [
                    "ajv",
                    "schema",
                    "schemaRefs",
                    "templates",
                    "ace",
                    "theme",
                    "autocomplete",
                    "onChange",
                    "onChangeJSON",
                    "onChangeText",
                    "onExpand",
                    "onEditable",
                    "onError",
                    "onEvent",
                    "onModeChange",
                    "onNodeName",
                    "onValidate",
                    "onCreateMenu",
                    "onSelectionChange",
                    "onTextSelectionChange",
                    "onClassName",
                    "onFocus",
                    "onBlur",
                    "colorPicker",
                    "onColorPicker",
                    "timestampTag",
                    "timestampFormat",
                    "escapeUnicode",
                    "history",
                    "search",
                    "mode",
                    "modes",
                    "name",
                    "indentation",
                    "sortObjectKeys",
                    "navigationBar",
                    "statusBar",
                    "mainMenuBar",
                    "languages",
                    "language",
                    "enableSort",
                    "enableTransform",
                    "limitDragging",
                    "maxVisibleChilds",
                    "onValidationError",
                    "modalAnchor",
                    "popupAnchor",
                    "createQuery",
                    "executeQuery",
                    "queryDescription",
                    "allowSchemaSuggestions",
                    "showErrorTable"
                ];
                /**
 * Create the JSONEditor
 * @param {Element} container    Container element
 * @param {Object}  [options]    See description in constructor
 * @param {Object | undefined} json JSON object
 * @private
 */ JSONEditor.prototype._create = function(container, options, json) {
                    this.container = container;
                    this.options = options || {};
                    this.json = json || {};
                    var mode = this.options.mode || this.options.modes && this.options.modes[0] || "tree";
                    this.setMode(mode);
                };
                /**
 * Destroy the editor. Clean up DOM, event listeners, and web workers.
 */ JSONEditor.prototype.destroy = function() {};
                /**
 * Set JSON object in editor
 * @param {Object | undefined} json      JSON data
 */ JSONEditor.prototype.set = function(json) {
                    this.json = json;
                };
                /**
 * Get JSON from the editor
 * @returns {Object} json
 */ JSONEditor.prototype.get = function() {
                    return this.json;
                };
                /**
 * Set string containing JSON for the editor
 * @param {String | undefined} jsonText
 */ JSONEditor.prototype.setText = function(jsonText) {
                    this.json = parse(jsonText);
                };
                /**
 * Get stringified JSON contents from the editor
 * @returns {String} jsonText
 */ JSONEditor.prototype.getText = function() {
                    return JSON.stringify(this.json);
                };
                /**
 * Set a field name for the root node.
 * @param {String | undefined} name
 */ JSONEditor.prototype.setName = function(name) {
                    if (!this.options) this.options = {};
                    this.options.name = name;
                };
                /**
 * Get the field name for the root node.
 * @return {String | undefined} name
 */ JSONEditor.prototype.getName = function() {
                    return this.options && this.options.name;
                };
                /**
 * Change the mode of the editor.
 * JSONEditor will be extended with all methods needed for the chosen mode.
 * @param {String} mode     Available modes: 'tree' (default), 'view', 'form',
 *                          'text', and 'code'.
 */ JSONEditor.prototype.setMode = function(mode) {
                    // if the mode is the same as current mode (and it's not the first time), do nothing.
                    if (mode === this.options.mode && this.create) return;
                    var container = this.container;
                    var options = extend({}, this.options);
                    var oldMode = options.mode;
                    options.mode = mode;
                    var config = JSONEditor.modes[mode];
                    if (!config) throw new Error('Unknown mode "' + options.mode + '"');
                    var asText = config.data === "text";
                    var name = this.getName();
                    var data = this[asText ? "getText" : "get"](); // get text or json
                    this.destroy();
                    clear(this);
                    extend(this, config.mixin);
                    this.create(container, options);
                    this.setName(name);
                    this[asText ? "setText" : "set"](data); // set text or json
                    if (typeof config.load === "function") try {
                        config.load.call(this);
                    } catch (err) {
                        console.error(err);
                    }
                    if (typeof options.onModeChange === "function" && mode !== oldMode) try {
                        options.onModeChange(mode, oldMode);
                    } catch (err) {
                        console.error(err);
                    }
                };
                /**
 * Get the current mode
 * @return {string}
 */ JSONEditor.prototype.getMode = function() {
                    return this.options.mode;
                };
                /**
 * Throw an error. If an error callback is configured in options.error, this
 * callback will be invoked. Else, a basic alert window with the error message
 * will be shown to the user.
 * @param {Error} err
 * @private
 */ JSONEditor.prototype._onError = function(err) {
                    if (this.options && typeof this.options.onError === "function") this.options.onError(err);
                    else window.alert(err.toString());
                };
                /**
 * Set a JSON schema for validation of the JSON object.
 * To remove the schema, call JSONEditor.setSchema(null)
 * @param {Object | null} schema
 * @param {Object.<string, Object>=} schemaRefs Schemas that are referenced using the `$ref` property from the JSON schema that are set in the `schema` option,
 +  the object structure in the form of `{reference_key: schemaObject}`
 */ JSONEditor.prototype.setSchema = function(schema, schemaRefs) {
                    // compile a JSON schema validator if a JSON schema is provided
                    if (schema) {
                        var ajv;
                        try {
                            // grab ajv from options if provided, else create a new instance
                            if (this.options.ajv) ajv = this.options.ajv;
                            else {
                                ajv = Ajv({
                                    allErrors: true,
                                    verbose: true,
                                    schemaId: "auto",
                                    $data: true
                                });
                                // support both draft-04 and draft-06 alongside the latest draft-07
                                ajv.addMetaSchema(__webpack_require__(Object(function webpackMissingModule() {
                                    var e = new Error("Cannot find module 'ajv/lib/refs/json-schema-draft-04.json'");
                                    e.code = "MODULE_NOT_FOUND";
                                    throw e;
                                }())));
                                ajv.addMetaSchema(__webpack_require__(Object(function webpackMissingModule() {
                                    var e = new Error("Cannot find module 'ajv/lib/refs/json-schema-draft-06.json'");
                                    e.code = "MODULE_NOT_FOUND";
                                    throw e;
                                }())));
                            }
                        } catch (err) {
                            console.warn("Failed to create an instance of Ajv, JSON Schema validation is not available. Please use a JSONEditor bundle including Ajv, or pass an instance of Ajv as via the configuration option `ajv`.");
                        }
                        if (ajv) {
                            if (schemaRefs) {
                                for(var ref in schemaRefs){
                                    ajv.removeSchema(ref); // When updating a schema - old refs has to be removed first
                                    if (schemaRefs[ref]) ajv.addSchema(schemaRefs[ref], ref);
                                }
                                this.options.schemaRefs = schemaRefs;
                            }
                            this.validateSchema = ajv.compile(schema);
                            // add schema to the options, so that when switching to an other mode,
                            // the set schema is not lost
                            this.options.schema = schema;
                            this.options.schemaRefs = schemaRefs;
                            // validate now
                            this.validate();
                        }
                        this.refresh(); // update DOM
                    } else {
                        // remove current schema
                        this.validateSchema = null;
                        this.options.schema = null;
                        this.options.schemaRefs = null;
                        this.validate(); // to clear current error messages
                        this.refresh(); // update DOM
                    }
                    if (typeof this._onSchemaChange === "function") this._onSchemaChange(schema, schemaRefs);
                };
                /**
 * Validate current JSON object against the configured JSON schema
 * Throws an exception when no JSON schema is configured
 */ JSONEditor.prototype.validate = function() {
                // must be implemented by treemode and textmode
                };
                /**
 * Refresh the rendered contents
 */ JSONEditor.prototype.refresh = function() {
                // can be implemented by treemode and textmode
                };
                /**
 * Register a plugin with one ore multiple modes for the JSON Editor.
 *
 * A mode is described as an object with properties:
 *
 * - `mode: String`           The name of the mode.
 * - `mixin: Object`          An object containing the mixin functions which
 *                            will be added to the JSONEditor. Must contain functions
 *                            create, get, getText, set, and setText. May have
 *                            additional functions.
 *                            When the JSONEditor switches to a mixin, all mixin
 *                            functions are added to the JSONEditor, and then
 *                            the function `create(container, options)` is executed.
 * - `data: 'text' | 'json'`  The type of data that will be used to load the mixin.
 * - `[load: function]`       An optional function called after the mixin
 *                            has been loaded.
 *
 * @param {Object | Array} mode  A mode object or an array with multiple mode objects.
 */ JSONEditor.registerMode = function(mode) {
                    var i, prop;
                    if (Array.isArray(mode)) // multiple modes
                    for(i = 0; i < mode.length; i++)JSONEditor.registerMode(mode[i]);
                    else {
                        // validate the new mode
                        if (!("mode" in mode)) throw new Error('Property "mode" missing');
                        if (!("mixin" in mode)) throw new Error('Property "mixin" missing');
                        if (!("data" in mode)) throw new Error('Property "data" missing');
                        var name = mode.mode;
                        if (name in JSONEditor.modes) throw new Error('Mode "' + name + '" already registered');
                        // validate the mixin
                        if (typeof mode.mixin.create !== "function") throw new Error('Required function "create" missing on mixin');
                        var reserved = [
                            "setMode",
                            "registerMode",
                            "modes"
                        ];
                        for(i = 0; i < reserved.length; i++){
                            prop = reserved[i];
                            if (prop in mode.mixin) throw new Error('Reserved property "' + prop + '" not allowed in mixin');
                        }
                        JSONEditor.modes[name] = mode;
                    }
                };
                // register tree, text, and preview modes
                JSONEditor.registerMode(treeModeMixins);
                JSONEditor.registerMode(textModeMixins);
                JSONEditor.registerMode(previewModeMixins);
                // expose some of the libraries that can be used customized
                JSONEditor.ace = ace;
                JSONEditor.Ajv = Ajv;
                JSONEditor.VanillaPicker = VanillaPicker;
                // expose some utils (this is undocumented, unofficial)
                JSONEditor.showTransformModal = showTransformModal;
                JSONEditor.showSortModal = showSortModal;
                JSONEditor.getInnerText = getInnerText;
                // default export for TypeScript ES6 projects
                JSONEditor["default"] = JSONEditor;
                module1.exports = JSONEditor;
            /***/ },
            /***/ 617: /***/ function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {
                "use strict";
                /* harmony export */ __webpack_require__.d(__webpack_exports__, {
                    /* harmony export */ "x": function() {
                        return /* binding */ ModeSwitcher;
                    }
                });
                /* harmony import */ var _ContextMenu__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(897);
                /* harmony import */ var _i18n__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(907);
                function _typeof(obj) {
                    "@babel/helpers - typeof";
                    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
                        return typeof obj;
                    } : function(obj) {
                        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
                    }, _typeof(obj);
                }
                function _classCallCheck(instance, Constructor) {
                    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
                }
                function _defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
                    }
                }
                function _createClass(Constructor, protoProps, staticProps) {
                    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) _defineProperties(Constructor, staticProps);
                    Object.defineProperty(Constructor, "prototype", {
                        writable: false
                    });
                    return Constructor;
                }
                function _toPropertyKey(arg) {
                    var key = _toPrimitive(arg, "string");
                    return _typeof(key) === "symbol" ? key : String(key);
                }
                function _toPrimitive(input, hint) {
                    if (_typeof(input) !== "object" || input === null) return input;
                    var prim = input[Symbol.toPrimitive];
                    if (prim !== undefined) {
                        var res = prim.call(input, hint || "default");
                        if (_typeof(res) !== "object") return res;
                        throw new TypeError("@@toPrimitive must return a primitive value.");
                    }
                    return (hint === "string" ? String : Number)(input);
                }
                /**
 * Create a select box to be used in the editor menu's, which allows to switch mode
 * @param {HTMLElement} container
 * @param {String[]} modes  Available modes: 'code', 'form', 'text', 'tree', 'view', 'preview'
 * @param {String} current  Available modes: 'code', 'form', 'text', 'tree', 'view', 'preview'
 * @param {function(mode: string)} onSwitch  Callback invoked on switch
 * @constructor
 */ var ModeSwitcher = /*#__PURE__*/ function() {
                    function ModeSwitcher(container, modes, current, onSwitch) {
                        _classCallCheck(this, ModeSwitcher);
                        // available modes
                        var availableModes = {
                            code: {
                                text: (0, _i18n__WEBPACK_IMPORTED_MODULE_1__ /* .translate */ .Iu)("modeCodeText"),
                                title: (0, _i18n__WEBPACK_IMPORTED_MODULE_1__ /* .translate */ .Iu)("modeCodeTitle"),
                                click: function click() {
                                    onSwitch("code");
                                }
                            },
                            form: {
                                text: (0, _i18n__WEBPACK_IMPORTED_MODULE_1__ /* .translate */ .Iu)("modeFormText"),
                                title: (0, _i18n__WEBPACK_IMPORTED_MODULE_1__ /* .translate */ .Iu)("modeFormTitle"),
                                click: function click() {
                                    onSwitch("form");
                                }
                            },
                            text: {
                                text: (0, _i18n__WEBPACK_IMPORTED_MODULE_1__ /* .translate */ .Iu)("modeTextText"),
                                title: (0, _i18n__WEBPACK_IMPORTED_MODULE_1__ /* .translate */ .Iu)("modeTextTitle"),
                                click: function click() {
                                    onSwitch("text");
                                }
                            },
                            tree: {
                                text: (0, _i18n__WEBPACK_IMPORTED_MODULE_1__ /* .translate */ .Iu)("modeTreeText"),
                                title: (0, _i18n__WEBPACK_IMPORTED_MODULE_1__ /* .translate */ .Iu)("modeTreeTitle"),
                                click: function click() {
                                    onSwitch("tree");
                                }
                            },
                            view: {
                                text: (0, _i18n__WEBPACK_IMPORTED_MODULE_1__ /* .translate */ .Iu)("modeViewText"),
                                title: (0, _i18n__WEBPACK_IMPORTED_MODULE_1__ /* .translate */ .Iu)("modeViewTitle"),
                                click: function click() {
                                    onSwitch("view");
                                }
                            },
                            preview: {
                                text: (0, _i18n__WEBPACK_IMPORTED_MODULE_1__ /* .translate */ .Iu)("modePreviewText"),
                                title: (0, _i18n__WEBPACK_IMPORTED_MODULE_1__ /* .translate */ .Iu)("modePreviewTitle"),
                                click: function click() {
                                    onSwitch("preview");
                                }
                            }
                        };
                        // list the selected modes
                        var items = [];
                        for(var i = 0; i < modes.length; i++){
                            var mode = modes[i];
                            var item = availableModes[mode];
                            if (!item) throw new Error('Unknown mode "' + mode + '"');
                            item.className = "jsoneditor-type-modes" + (current === mode ? " jsoneditor-selected" : "");
                            items.push(item);
                        }
                        // retrieve the title of current mode
                        var currentMode = availableModes[current];
                        if (!currentMode) throw new Error('Unknown mode "' + current + '"');
                        var currentTitle = currentMode.text;
                        // create the html element
                        var box = document.createElement("button");
                        box.type = "button";
                        box.className = "jsoneditor-modes jsoneditor-separator";
                        box.textContent = currentTitle + " ▾";
                        box.title = (0, _i18n__WEBPACK_IMPORTED_MODULE_1__ /* .translate */ .Iu)("modeEditorTitle");
                        box.onclick = function() {
                            var menu = new _ContextMenu__WEBPACK_IMPORTED_MODULE_0__ /* .ContextMenu */ .x(items);
                            menu.show(box, container);
                        };
                        var frame = document.createElement("div");
                        frame.className = "jsoneditor-modes";
                        frame.style.position = "relative";
                        frame.appendChild(box);
                        container.appendChild(frame);
                        this.dom = {
                            container: container,
                            box: box,
                            frame: frame
                        };
                    }
                    /**
   * Set focus to switcher
   */ _createClass(ModeSwitcher, [
                        {
                            key: "focus",
                            value: function focus() {
                                this.dom.box.focus();
                            }
                        },
                        {
                            key: "destroy",
                            value: function destroy() {
                                if (this.dom && this.dom.frame && this.dom.frame.parentNode) this.dom.frame.parentNode.removeChild(this.dom.frame);
                                this.dom = null;
                            }
                        }
                    ]);
                    return ModeSwitcher;
                }();
            /***/ },
            /***/ 170: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                var ace;
                if (window.ace) // use the already loaded instance of Ace
                ace = window.ace;
                else try {
                    // load Ace editor
                    ace = __webpack_require__(Object(function webpackMissingModule() {
                        var e = new Error("Cannot find module 'ace-builds/src-noconflict/ace'");
                        e.code = "MODULE_NOT_FOUND";
                        throw e;
                    }()));
                    // load required Ace plugins
                    __webpack_require__(Object(function webpackMissingModule() {
                        var e = new Error("Cannot find module 'ace-builds/src-noconflict/mode-json'");
                        e.code = "MODULE_NOT_FOUND";
                        throw e;
                    }()));
                    __webpack_require__(Object(function webpackMissingModule() {
                        var e = new Error("Cannot find module 'ace-builds/src-noconflict/ext-searchbox'");
                        e.code = "MODULE_NOT_FOUND";
                        throw e;
                    }()));
                    __webpack_require__(Object(function webpackMissingModule() {
                        var e = new Error("Cannot find module 'ace-builds/src-noconflict/ext-language_tools'");
                        e.code = "MODULE_NOT_FOUND";
                        throw e;
                    }()));
                    // embed Ace json worker
                    // https://github.com/ajaxorg/ace/issues/3913
                    var jsonWorkerDataUrl = __webpack_require__(Object(function webpackMissingModule() {
                        var e = new Error("Cannot find module '../generated/worker-json-data-url'");
                        e.code = "MODULE_NOT_FOUND";
                        throw e;
                    }()));
                    ace.config.setModuleUrl("ace/mode/json_worker", jsonWorkerDataUrl);
                } catch (err) {
                // failed to load Ace (can be minimalist bundle).
                // No worries, the editor will fall back to plain text if needed.
                }
                module1.exports = ace;
            /***/ },
            /***/ 864: /***/ function() {
                /* ***** BEGIN LICENSE BLOCK *****
 * Distributed under the BSD license:
 *
 * Copyright (c) 2010, Ajax.org B.V.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are permitted provided that the following conditions are met:
 *     * Redistributions of source code must retain the above copyright
 *       notice, this list of conditions and the following disclaimer.
 *     * Redistributions in binary form must reproduce the above copyright
 *       notice, this list of conditions and the following disclaimer in the
 *       documentation and/or other materials provided with the distribution.
 *     * Neither the name of Ajax.org B.V. nor the
 *       names of its contributors may be used to endorse or promote products
 *       derived from this software without specific prior written permission.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND
 * ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL AJAX.ORG B.V. BE LIABLE FOR ANY
 * DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
 * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES;
 * LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND
 * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
 * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
 * SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 *
 * ***** END LICENSE BLOCK ***** */ window.ace.define("ace/theme/jsoneditor", [
                    "require",
                    "exports",
                    "module",
                    "ace/lib/dom"
                ], function(acequire, exports, module1) {
                    exports.isDark = false;
                    exports.cssClass = "ace-jsoneditor";
                    exports.cssText = '.ace-jsoneditor .ace_gutter {\nbackground: #ebebeb;\ncolor: #333\n}\n\n.ace-jsoneditor.ace_editor {\nline-height: 1.3;\nbackground-color: #fff;\n}\n.ace-jsoneditor .ace_print-margin {\nwidth: 1px;\nbackground: #e8e8e8\n}\n.ace-jsoneditor .ace_scroller {\nbackground-color: #FFFFFF\n}\n.ace-jsoneditor .ace_text-layer {\ncolor: gray\n}\n.ace-jsoneditor .ace_variable {\ncolor: #1a1a1a\n}\n.ace-jsoneditor .ace_cursor {\nborder-left: 2px solid #000000\n}\n.ace-jsoneditor .ace_overwrite-cursors .ace_cursor {\nborder-left: 0px;\nborder-bottom: 1px solid #000000\n}\n.ace-jsoneditor .ace_marker-layer .ace_selection {\nbackground: lightgray\n}\n.ace-jsoneditor.ace_multiselect .ace_selection.ace_start {\nbox-shadow: 0 0 3px 0px #FFFFFF;\nborder-radius: 2px\n}\n.ace-jsoneditor .ace_marker-layer .ace_step {\nbackground: rgb(255, 255, 0)\n}\n.ace-jsoneditor .ace_marker-layer .ace_bracket {\nmargin: -1px 0 0 -1px;\nborder: 1px solid #BFBFBF\n}\n.ace-jsoneditor .ace_marker-layer .ace_active-line {\nbackground: #FFFBD1\n}\n.ace-jsoneditor .ace_gutter-active-line {\nbackground-color : #dcdcdc\n}\n.ace-jsoneditor .ace_marker-layer .ace_selected-word {\nborder: 1px solid lightgray\n}\n.ace-jsoneditor .ace_invisible {\ncolor: #BFBFBF\n}\n.ace-jsoneditor .ace_keyword,\n.ace-jsoneditor .ace_meta,\n.ace-jsoneditor .ace_support.ace_constant.ace_property-value {\ncolor: #AF956F\n}\n.ace-jsoneditor .ace_keyword.ace_operator {\ncolor: #484848\n}\n.ace-jsoneditor .ace_keyword.ace_other.ace_unit {\ncolor: #96DC5F\n}\n.ace-jsoneditor .ace_constant.ace_language {\ncolor: darkorange\n}\n.ace-jsoneditor .ace_constant.ace_numeric {\ncolor: red\n}\n.ace-jsoneditor .ace_constant.ace_character.ace_entity {\ncolor: #BF78CC\n}\n.ace-jsoneditor .ace_invalid {\ncolor: #FFFFFF;\nbackground-color: #FF002A;\n}\n.ace-jsoneditor .ace_fold {\nbackground-color: #AF956F;\nborder-color: #000000\n}\n.ace-jsoneditor .ace_storage,\n.ace-jsoneditor .ace_support.ace_class,\n.ace-jsoneditor .ace_support.ace_function,\n.ace-jsoneditor .ace_support.ace_other,\n.ace-jsoneditor .ace_support.ace_type {\ncolor: #C52727\n}\n.ace-jsoneditor .ace_string {\ncolor: green\n}\n.ace-jsoneditor .ace_comment {\ncolor: #BCC8BA\n}\n.ace-jsoneditor .ace_entity.ace_name.ace_tag,\n.ace-jsoneditor .ace_entity.ace_other.ace_attribute-name {\ncolor: #606060\n}\n.ace-jsoneditor .ace_markup.ace_underline {\ntext-decoration: underline\n}\n.ace-jsoneditor .ace_indent-guide {\nbackground: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAACCAYAAACZgbYnAAAAE0lEQVQImWP4////f4bLly//BwAmVgd1/w11/gAAAABJRU5ErkJggg==") right repeat-y\n}';
                    var dom = acequire("../lib/dom");
                    dom.importCssString(exports.cssText, exports.cssClass);
                });
            /***/ },
            /***/ 589: /***/ function(__unused_webpack_module, exports) {
                /* Jison generated parser */ var jsonlint = function() {
                    var parser = {
                        trace: function trace() {},
                        yy: {},
                        symbols_: {
                            "error": 2,
                            "JSONString": 3,
                            "STRING": 4,
                            "JSONNumber": 5,
                            "NUMBER": 6,
                            "JSONNullLiteral": 7,
                            "NULL": 8,
                            "JSONBooleanLiteral": 9,
                            "TRUE": 10,
                            "FALSE": 11,
                            "JSONText": 12,
                            "JSONValue": 13,
                            "EOF": 14,
                            "JSONObject": 15,
                            "JSONArray": 16,
                            "{": 17,
                            "}": 18,
                            "JSONMemberList": 19,
                            "JSONMember": 20,
                            ":": 21,
                            ",": 22,
                            "[": 23,
                            "]": 24,
                            "JSONElementList": 25,
                            "$accept": 0,
                            "$end": 1
                        },
                        terminals_: {
                            2: "error",
                            4: "STRING",
                            6: "NUMBER",
                            8: "NULL",
                            10: "TRUE",
                            11: "FALSE",
                            14: "EOF",
                            17: "{",
                            18: "}",
                            21: ":",
                            22: ",",
                            23: "[",
                            24: "]"
                        },
                        productions_: [
                            0,
                            [
                                3,
                                1
                            ],
                            [
                                5,
                                1
                            ],
                            [
                                7,
                                1
                            ],
                            [
                                9,
                                1
                            ],
                            [
                                9,
                                1
                            ],
                            [
                                12,
                                2
                            ],
                            [
                                13,
                                1
                            ],
                            [
                                13,
                                1
                            ],
                            [
                                13,
                                1
                            ],
                            [
                                13,
                                1
                            ],
                            [
                                13,
                                1
                            ],
                            [
                                13,
                                1
                            ],
                            [
                                15,
                                2
                            ],
                            [
                                15,
                                3
                            ],
                            [
                                20,
                                3
                            ],
                            [
                                19,
                                1
                            ],
                            [
                                19,
                                3
                            ],
                            [
                                16,
                                2
                            ],
                            [
                                16,
                                3
                            ],
                            [
                                25,
                                1
                            ],
                            [
                                25,
                                3
                            ]
                        ],
                        performAction: function anonymous(yytext, yyleng, yylineno, yy, yystate, $$, _$) {
                            var $0 = $$.length - 1;
                            switch(yystate){
                                case 1:
                                    // replace escaped characters with actual character
                                    this.$ = yytext.replace(/\\(\\|")/g, "$1").replace(/\\n/g, "\n").replace(/\\r/g, "\r").replace(/\\t/g, "	").replace(/\\v/g, "\v").replace(/\\f/g, "\f").replace(/\\b/g, "\b");
                                    break;
                                case 2:
                                    this.$ = Number(yytext);
                                    break;
                                case 3:
                                    this.$ = null;
                                    break;
                                case 4:
                                    this.$ = true;
                                    break;
                                case 5:
                                    this.$ = false;
                                    break;
                                case 6:
                                    return this.$ = $$[$0 - 1];
                                case 13:
                                    this.$ = {};
                                    break;
                                case 14:
                                    this.$ = $$[$0 - 1];
                                    break;
                                case 15:
                                    this.$ = [
                                        $$[$0 - 2],
                                        $$[$0]
                                    ];
                                    break;
                                case 16:
                                    this.$ = {};
                                    this.$[$$[$0][0]] = $$[$0][1];
                                    break;
                                case 17:
                                    this.$ = $$[$0 - 2];
                                    $$[$0 - 2][$$[$0][0]] = $$[$0][1];
                                    break;
                                case 18:
                                    this.$ = [];
                                    break;
                                case 19:
                                    this.$ = $$[$0 - 1];
                                    break;
                                case 20:
                                    this.$ = [
                                        $$[$0]
                                    ];
                                    break;
                                case 21:
                                    this.$ = $$[$0 - 2];
                                    $$[$0 - 2].push($$[$0]);
                                    break;
                            }
                        },
                        table: [
                            {
                                3: 5,
                                4: [
                                    1,
                                    12
                                ],
                                5: 6,
                                6: [
                                    1,
                                    13
                                ],
                                7: 3,
                                8: [
                                    1,
                                    9
                                ],
                                9: 4,
                                10: [
                                    1,
                                    10
                                ],
                                11: [
                                    1,
                                    11
                                ],
                                12: 1,
                                13: 2,
                                15: 7,
                                16: 8,
                                17: [
                                    1,
                                    14
                                ],
                                23: [
                                    1,
                                    15
                                ]
                            },
                            {
                                1: [
                                    3
                                ]
                            },
                            {
                                14: [
                                    1,
                                    16
                                ]
                            },
                            {
                                14: [
                                    2,
                                    7
                                ],
                                18: [
                                    2,
                                    7
                                ],
                                22: [
                                    2,
                                    7
                                ],
                                24: [
                                    2,
                                    7
                                ]
                            },
                            {
                                14: [
                                    2,
                                    8
                                ],
                                18: [
                                    2,
                                    8
                                ],
                                22: [
                                    2,
                                    8
                                ],
                                24: [
                                    2,
                                    8
                                ]
                            },
                            {
                                14: [
                                    2,
                                    9
                                ],
                                18: [
                                    2,
                                    9
                                ],
                                22: [
                                    2,
                                    9
                                ],
                                24: [
                                    2,
                                    9
                                ]
                            },
                            {
                                14: [
                                    2,
                                    10
                                ],
                                18: [
                                    2,
                                    10
                                ],
                                22: [
                                    2,
                                    10
                                ],
                                24: [
                                    2,
                                    10
                                ]
                            },
                            {
                                14: [
                                    2,
                                    11
                                ],
                                18: [
                                    2,
                                    11
                                ],
                                22: [
                                    2,
                                    11
                                ],
                                24: [
                                    2,
                                    11
                                ]
                            },
                            {
                                14: [
                                    2,
                                    12
                                ],
                                18: [
                                    2,
                                    12
                                ],
                                22: [
                                    2,
                                    12
                                ],
                                24: [
                                    2,
                                    12
                                ]
                            },
                            {
                                14: [
                                    2,
                                    3
                                ],
                                18: [
                                    2,
                                    3
                                ],
                                22: [
                                    2,
                                    3
                                ],
                                24: [
                                    2,
                                    3
                                ]
                            },
                            {
                                14: [
                                    2,
                                    4
                                ],
                                18: [
                                    2,
                                    4
                                ],
                                22: [
                                    2,
                                    4
                                ],
                                24: [
                                    2,
                                    4
                                ]
                            },
                            {
                                14: [
                                    2,
                                    5
                                ],
                                18: [
                                    2,
                                    5
                                ],
                                22: [
                                    2,
                                    5
                                ],
                                24: [
                                    2,
                                    5
                                ]
                            },
                            {
                                14: [
                                    2,
                                    1
                                ],
                                18: [
                                    2,
                                    1
                                ],
                                21: [
                                    2,
                                    1
                                ],
                                22: [
                                    2,
                                    1
                                ],
                                24: [
                                    2,
                                    1
                                ]
                            },
                            {
                                14: [
                                    2,
                                    2
                                ],
                                18: [
                                    2,
                                    2
                                ],
                                22: [
                                    2,
                                    2
                                ],
                                24: [
                                    2,
                                    2
                                ]
                            },
                            {
                                3: 20,
                                4: [
                                    1,
                                    12
                                ],
                                18: [
                                    1,
                                    17
                                ],
                                19: 18,
                                20: 19
                            },
                            {
                                3: 5,
                                4: [
                                    1,
                                    12
                                ],
                                5: 6,
                                6: [
                                    1,
                                    13
                                ],
                                7: 3,
                                8: [
                                    1,
                                    9
                                ],
                                9: 4,
                                10: [
                                    1,
                                    10
                                ],
                                11: [
                                    1,
                                    11
                                ],
                                13: 23,
                                15: 7,
                                16: 8,
                                17: [
                                    1,
                                    14
                                ],
                                23: [
                                    1,
                                    15
                                ],
                                24: [
                                    1,
                                    21
                                ],
                                25: 22
                            },
                            {
                                1: [
                                    2,
                                    6
                                ]
                            },
                            {
                                14: [
                                    2,
                                    13
                                ],
                                18: [
                                    2,
                                    13
                                ],
                                22: [
                                    2,
                                    13
                                ],
                                24: [
                                    2,
                                    13
                                ]
                            },
                            {
                                18: [
                                    1,
                                    24
                                ],
                                22: [
                                    1,
                                    25
                                ]
                            },
                            {
                                18: [
                                    2,
                                    16
                                ],
                                22: [
                                    2,
                                    16
                                ]
                            },
                            {
                                21: [
                                    1,
                                    26
                                ]
                            },
                            {
                                14: [
                                    2,
                                    18
                                ],
                                18: [
                                    2,
                                    18
                                ],
                                22: [
                                    2,
                                    18
                                ],
                                24: [
                                    2,
                                    18
                                ]
                            },
                            {
                                22: [
                                    1,
                                    28
                                ],
                                24: [
                                    1,
                                    27
                                ]
                            },
                            {
                                22: [
                                    2,
                                    20
                                ],
                                24: [
                                    2,
                                    20
                                ]
                            },
                            {
                                14: [
                                    2,
                                    14
                                ],
                                18: [
                                    2,
                                    14
                                ],
                                22: [
                                    2,
                                    14
                                ],
                                24: [
                                    2,
                                    14
                                ]
                            },
                            {
                                3: 20,
                                4: [
                                    1,
                                    12
                                ],
                                20: 29
                            },
                            {
                                3: 5,
                                4: [
                                    1,
                                    12
                                ],
                                5: 6,
                                6: [
                                    1,
                                    13
                                ],
                                7: 3,
                                8: [
                                    1,
                                    9
                                ],
                                9: 4,
                                10: [
                                    1,
                                    10
                                ],
                                11: [
                                    1,
                                    11
                                ],
                                13: 30,
                                15: 7,
                                16: 8,
                                17: [
                                    1,
                                    14
                                ],
                                23: [
                                    1,
                                    15
                                ]
                            },
                            {
                                14: [
                                    2,
                                    19
                                ],
                                18: [
                                    2,
                                    19
                                ],
                                22: [
                                    2,
                                    19
                                ],
                                24: [
                                    2,
                                    19
                                ]
                            },
                            {
                                3: 5,
                                4: [
                                    1,
                                    12
                                ],
                                5: 6,
                                6: [
                                    1,
                                    13
                                ],
                                7: 3,
                                8: [
                                    1,
                                    9
                                ],
                                9: 4,
                                10: [
                                    1,
                                    10
                                ],
                                11: [
                                    1,
                                    11
                                ],
                                13: 31,
                                15: 7,
                                16: 8,
                                17: [
                                    1,
                                    14
                                ],
                                23: [
                                    1,
                                    15
                                ]
                            },
                            {
                                18: [
                                    2,
                                    17
                                ],
                                22: [
                                    2,
                                    17
                                ]
                            },
                            {
                                18: [
                                    2,
                                    15
                                ],
                                22: [
                                    2,
                                    15
                                ]
                            },
                            {
                                22: [
                                    2,
                                    21
                                ],
                                24: [
                                    2,
                                    21
                                ]
                            }
                        ],
                        defaultActions: {
                            16: [
                                2,
                                6
                            ]
                        },
                        parseError: function parseError(str, hash) {
                            throw new Error(str);
                        },
                        parse: function parse(input) {
                            var self1 = this, stack = [
                                0
                            ], vstack = [
                                null
                            ], // semantic value stack
                            lstack = [], // location stack
                            table = this.table, yytext = "", yylineno = 0, yyleng = 0, recovering = 0, TERROR = 2, EOF = 1;
                            //this.reductionCount = this.shiftCount = 0;
                            this.lexer.setInput(input);
                            this.lexer.yy = this.yy;
                            this.yy.lexer = this.lexer;
                            if (typeof this.lexer.yylloc == "undefined") this.lexer.yylloc = {};
                            var yyloc = this.lexer.yylloc;
                            lstack.push(yyloc);
                            if (typeof this.yy.parseError === "function") this.parseError = this.yy.parseError;
                            function popStack(n) {
                                stack.length = stack.length - 2 * n;
                                vstack.length = vstack.length - n;
                                lstack.length = lstack.length - n;
                            }
                            function lex() {
                                var token;
                                token = self1.lexer.lex() || 1; // $end = 1
                                // if token isn't its numeric value, convert
                                if (typeof token !== "number") token = self1.symbols_[token] || token;
                                return token;
                            }
                            var symbol, preErrorSymbol, state, action, a, r, yyval = {}, p, len, newState, expected;
                            while(true){
                                // retreive state number from top of stack
                                state = stack[stack.length - 1];
                                // use default actions if available
                                if (this.defaultActions[state]) action = this.defaultActions[state];
                                else {
                                    if (symbol == null) symbol = lex();
                                    // read action for current state and first input
                                    action = table[state] && table[state][symbol];
                                }
                                // handle parse error
                                _handle_error: if (typeof action === "undefined" || !action.length || !action[0]) {
                                    if (!recovering) {
                                        // Report error
                                        expected = [];
                                        for(p in table[state])if (this.terminals_[p] && p > 2) expected.push("'" + this.terminals_[p] + "'");
                                        var errStr = "";
                                        if (this.lexer.showPosition) errStr = "Parse error on line " + (yylineno + 1) + ":\n" + this.lexer.showPosition() + "\nExpecting " + expected.join(", ") + ", got '" + this.terminals_[symbol] + "'";
                                        else errStr = "Parse error on line " + (yylineno + 1) + ": Unexpected " + (symbol == 1 /*EOF*/  ? "end of input" : "'" + (this.terminals_[symbol] || symbol) + "'");
                                        this.parseError(errStr, {
                                            text: this.lexer.match,
                                            token: this.terminals_[symbol] || symbol,
                                            line: this.lexer.yylineno,
                                            loc: yyloc,
                                            expected: expected
                                        });
                                    }
                                    // just recovered from another error
                                    if (recovering == 3) {
                                        if (symbol == EOF) throw new Error(errStr || "Parsing halted.");
                                        // discard current lookahead and grab another
                                        yyleng = this.lexer.yyleng;
                                        yytext = this.lexer.yytext;
                                        yylineno = this.lexer.yylineno;
                                        yyloc = this.lexer.yylloc;
                                        symbol = lex();
                                    }
                                    // try to recover from error
                                    while(true){
                                        // check for error recovery rule in this state
                                        if (TERROR.toString() in table[state]) break;
                                        if (state == 0) throw new Error(errStr || "Parsing halted.");
                                        popStack(1);
                                        state = stack[stack.length - 1];
                                    }
                                    preErrorSymbol = symbol; // save the lookahead token
                                    symbol = TERROR; // insert generic error symbol as new lookahead
                                    state = stack[stack.length - 1];
                                    action = table[state] && table[state][TERROR];
                                    recovering = 3; // allow 3 real symbols to be shifted before reporting a new error
                                }
                                // this shouldn't happen, unless resolve defaults are off
                                if (action[0] instanceof Array && action.length > 1) throw new Error("Parse Error: multiple actions possible at state: " + state + ", token: " + symbol);
                                switch(action[0]){
                                    case 1:
                                        // shift
                                        //this.shiftCount++;
                                        stack.push(symbol);
                                        vstack.push(this.lexer.yytext);
                                        lstack.push(this.lexer.yylloc);
                                        stack.push(action[1]); // push state
                                        symbol = null;
                                        if (!preErrorSymbol) {
                                            // normal execution/no error
                                            yyleng = this.lexer.yyleng;
                                            yytext = this.lexer.yytext;
                                            yylineno = this.lexer.yylineno;
                                            yyloc = this.lexer.yylloc;
                                            if (recovering > 0) recovering--;
                                        } else {
                                            // error just occurred, resume old lookahead f/ before error
                                            symbol = preErrorSymbol;
                                            preErrorSymbol = null;
                                        }
                                        break;
                                    case 2:
                                        // reduce
                                        //this.reductionCount++;
                                        len = this.productions_[action[1]][1];
                                        // perform semantic action
                                        yyval.$ = vstack[vstack.length - len]; // default to $$ = $1
                                        // default location, uses first token for firsts, last for lasts
                                        yyval._$ = {
                                            first_line: lstack[lstack.length - (len || 1)].first_line,
                                            last_line: lstack[lstack.length - 1].last_line,
                                            first_column: lstack[lstack.length - (len || 1)].first_column,
                                            last_column: lstack[lstack.length - 1].last_column
                                        };
                                        r = this.performAction.call(yyval, yytext, yyleng, yylineno, this.yy, action[1], vstack, lstack);
                                        if (typeof r !== "undefined") return r;
                                        // pop off stack
                                        if (len) {
                                            stack = stack.slice(0, -1 * len * 2);
                                            vstack = vstack.slice(0, -1 * len);
                                            lstack = lstack.slice(0, -1 * len);
                                        }
                                        stack.push(this.productions_[action[1]][0]); // push nonterminal (reduce)
                                        vstack.push(yyval.$);
                                        lstack.push(yyval._$);
                                        // goto new state = table[STATE][NONTERMINAL]
                                        newState = table[stack[stack.length - 2]][stack[stack.length - 1]];
                                        stack.push(newState);
                                        break;
                                    case 3:
                                        // accept
                                        return true;
                                }
                            }
                            return true;
                        }
                    };
                    /* Jison generated lexer */ var lexer = function() {
                        var lexer = {
                            EOF: 1,
                            parseError: function parseError(str, hash) {
                                if (this.yy.parseError) this.yy.parseError(str, hash);
                                else throw new Error(str);
                            },
                            setInput: function setInput(input) {
                                this._input = input;
                                this._more = this._less = this.done = false;
                                this.yylineno = this.yyleng = 0;
                                this.yytext = this.matched = this.match = "";
                                this.conditionStack = [
                                    "INITIAL"
                                ];
                                this.yylloc = {
                                    first_line: 1,
                                    first_column: 0,
                                    last_line: 1,
                                    last_column: 0
                                };
                                return this;
                            },
                            input: function input() {
                                var ch = this._input[0];
                                this.yytext += ch;
                                this.yyleng++;
                                this.match += ch;
                                this.matched += ch;
                                var lines = ch.match(/\n/);
                                if (lines) this.yylineno++;
                                this._input = this._input.slice(1);
                                return ch;
                            },
                            unput: function unput(ch) {
                                this._input = ch + this._input;
                                return this;
                            },
                            more: function more() {
                                this._more = true;
                                return this;
                            },
                            less: function less(n) {
                                this._input = this.match.slice(n) + this._input;
                            },
                            pastInput: function pastInput() {
                                var past = this.matched.substr(0, this.matched.length - this.match.length);
                                return (past.length > 20 ? "..." : "") + past.substr(-20).replace(/\n/g, "");
                            },
                            upcomingInput: function upcomingInput() {
                                var next = this.match;
                                if (next.length < 20) next += this._input.substr(0, 20 - next.length);
                                return (next.substr(0, 20) + (next.length > 20 ? "..." : "")).replace(/\n/g, "");
                            },
                            showPosition: function showPosition() {
                                var pre = this.pastInput();
                                var c = new Array(pre.length + 1).join("-");
                                return pre + this.upcomingInput() + "\n" + c + "^";
                            },
                            next: function next() {
                                if (this.done) return this.EOF;
                                if (!this._input) this.done = true;
                                var token, match, tempMatch, index, col, lines;
                                if (!this._more) {
                                    this.yytext = "";
                                    this.match = "";
                                }
                                var rules = this._currentRules();
                                for(var i = 0; i < rules.length; i++){
                                    tempMatch = this._input.match(this.rules[rules[i]]);
                                    if (tempMatch && (!match || tempMatch[0].length > match[0].length)) {
                                        match = tempMatch;
                                        index = i;
                                        if (!this.options.flex) break;
                                    }
                                }
                                if (match) {
                                    lines = match[0].match(/\n.*/g);
                                    if (lines) this.yylineno += lines.length;
                                    this.yylloc = {
                                        first_line: this.yylloc.last_line,
                                        last_line: this.yylineno + 1,
                                        first_column: this.yylloc.last_column,
                                        last_column: lines ? lines[lines.length - 1].length - 1 : this.yylloc.last_column + match[0].length
                                    };
                                    this.yytext += match[0];
                                    this.match += match[0];
                                    this.yyleng = this.yytext.length;
                                    this._more = false;
                                    this._input = this._input.slice(match[0].length);
                                    this.matched += match[0];
                                    token = this.performAction.call(this, this.yy, this, rules[index], this.conditionStack[this.conditionStack.length - 1]);
                                    if (this.done && this._input) this.done = false;
                                    if (token) return token;
                                    else return;
                                }
                                if (this._input === "") return this.EOF;
                                else this.parseError("Lexical error on line " + (this.yylineno + 1) + ". Unrecognized text.\n" + this.showPosition(), {
                                    text: "",
                                    token: null,
                                    line: this.yylineno
                                });
                            },
                            lex: function lex() {
                                var r = this.next();
                                if (typeof r !== "undefined") return r;
                                else return this.lex();
                            },
                            begin: function begin(condition) {
                                this.conditionStack.push(condition);
                            },
                            popState: function popState() {
                                return this.conditionStack.pop();
                            },
                            _currentRules: function _currentRules() {
                                return this.conditions[this.conditionStack[this.conditionStack.length - 1]].rules;
                            },
                            topState: function topState() {
                                return this.conditionStack[this.conditionStack.length - 2];
                            },
                            pushState: function begin(condition) {
                                this.begin(condition);
                            }
                        };
                        lexer.options = {};
                        lexer.performAction = function anonymous(yy, yy_, $avoiding_name_collisions, YY_START) {
                            var YYSTATE = YY_START;
                            switch($avoiding_name_collisions){
                                case 0:
                                    break;
                                case 1:
                                    return 6;
                                case 2:
                                    yy_.yytext = yy_.yytext.substr(1, yy_.yyleng - 2);
                                    return 4;
                                case 3:
                                    return 17;
                                case 4:
                                    return 18;
                                case 5:
                                    return 23;
                                case 6:
                                    return 24;
                                case 7:
                                    return 22;
                                case 8:
                                    return 21;
                                case 9:
                                    return 10;
                                case 10:
                                    return 11;
                                case 11:
                                    return 8;
                                case 12:
                                    return 14;
                                case 13:
                                    return "INVALID";
                            }
                        };
                        lexer.rules = [
                            /^(?:\s+)/,
                            /^(?:(-?([0-9]|[1-9][0-9]+))(\.[0-9]+)?([eE][-+]?[0-9]+)?\b)/,
                            /^(?:"(?:\\[\\"bfnrt/]|\\u[a-fA-F0-9]{4}|[^\\\0-\x09\x0a-\x1f"])*")/,
                            /^(?:\{)/,
                            /^(?:\})/,
                            /^(?:\[)/,
                            /^(?:\])/,
                            /^(?:,)/,
                            /^(?::)/,
                            /^(?:true\b)/,
                            /^(?:false\b)/,
                            /^(?:null\b)/,
                            /^(?:$)/,
                            /^(?:.)/
                        ];
                        lexer.conditions = {
                            "INITIAL": {
                                "rules": [
                                    0,
                                    1,
                                    2,
                                    3,
                                    4,
                                    5,
                                    6,
                                    7,
                                    8,
                                    9,
                                    10,
                                    11,
                                    12,
                                    13
                                ],
                                "inclusive": true
                            }
                        };
                        return lexer;
                    }();
                    parser.lexer = lexer;
                    return parser;
                }();
                exports.parser = jsonlint;
                exports.parse = jsonlint.parse.bind(jsonlint);
            /***/ },
            /***/ 879: /***/ function(module1) {
                "use strict";
                /*!
 * Selectr 2.4.13
 * http://mobius.ovh/docs/selectr
 *
 * Released under the MIT license
 */ /**
 * Event Emitter
 */ var Events = function Events() {};
                /**
 * Event Prototype
 * @type {Object}
 */ Events.prototype = {
                    /**
   * Add custom event listener
   * @param  {String} event Event type
   * @param  {Function} func   Callback
   * @return {Void}
   */ on: function on(event, func) {
                        this._events = this._events || {};
                        this._events[event] = this._events[event] || [];
                        this._events[event].push(func);
                    },
                    /**
   * Remove custom event listener
   * @param  {String} event Event type
   * @param  {Function} func   Callback
   * @return {Void}
   */ off: function off(event, func) {
                        this._events = this._events || {};
                        if (event in this._events === false) return;
                        this._events[event].splice(this._events[event].indexOf(func), 1);
                    },
                    /**
   * Fire a custom event
   * @param  {String} event Event type
   * @return {Void}
   */ emit: function emit(event /* , args... */ ) {
                        this._events = this._events || {};
                        if (event in this._events === false) return;
                        for(var i = 0; i < this._events[event].length; i++)this._events[event][i].apply(this, Array.prototype.slice.call(arguments, 1));
                    }
                };
                /**
 * Event mixin
 * @param  {Object} obj
 * @return {Object}
 */ Events.mixin = function(obj) {
                    var props = [
                        "on",
                        "off",
                        "emit"
                    ];
                    for(var i = 0; i < props.length; i++)if (typeof obj === "function") obj.prototype[props[i]] = Events.prototype[props[i]];
                    else obj[props[i]] = Events.prototype[props[i]];
                    return obj;
                };
                /**
 * Helpers
 * @type {Object}
 */ var util = {
                    escapeRegExp: function escapeRegExp(str) {
                        // source from lodash 3.0.0
                        var _reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
                        var _reHasRegExpChar = new RegExp(_reRegExpChar.source);
                        return str && _reHasRegExpChar.test(str) ? str.replace(_reRegExpChar, "\\$&") : str;
                    },
                    extend: function extend(src, props) {
                        for(var prop in props)if (props.hasOwnProperty(prop)) {
                            var val = props[prop];
                            if (val && Object.prototype.toString.call(val) === "[object Object]") {
                                src[prop] = src[prop] || {};
                                util.extend(src[prop], val);
                            } else src[prop] = val;
                        }
                        return src;
                    },
                    each: function each(a, b, c) {
                        if ("[object Object]" === Object.prototype.toString.call(a)) {
                            for(var d in a)if (Object.prototype.hasOwnProperty.call(a, d)) b.call(c, d, a[d], a);
                        } else for(var e = 0, f = a.length; e < f; e++)b.call(c, e, a[e], a);
                    },
                    createElement: function createElement(e, a) {
                        var d = document, el = d.createElement(e);
                        if (a && "[object Object]" === Object.prototype.toString.call(a)) {
                            var i;
                            for(i in a)if (i in el) el[i] = a[i];
                            else if ("html" === i) el.innerHTML = a[i];
                            else el.setAttribute(i, a[i]);
                        }
                        return el;
                    },
                    hasClass: function hasClass(a, b) {
                        if (a) return a.classList ? a.classList.contains(b) : !!a.className && !!a.className.match(new RegExp("(\\s|^)" + b + "(\\s|$)"));
                    },
                    addClass: function addClass(a, b) {
                        if (!util.hasClass(a, b)) {
                            if (a.classList) a.classList.add(b);
                            else a.className = a.className.trim() + " " + b;
                        }
                    },
                    removeClass: function removeClass(a, b) {
                        if (util.hasClass(a, b)) {
                            if (a.classList) a.classList.remove(b);
                            else a.className = a.className.replace(new RegExp("(^|\\s)" + b.split(" ").join("|") + "(\\s|$)", "gi"), " ");
                        }
                    },
                    closest: function closest(el, fn) {
                        return el && el !== document.body && (fn(el) ? el : util.closest(el.parentNode, fn));
                    },
                    isInt: function isInt(val) {
                        return typeof val === "number" && isFinite(val) && Math.floor(val) === val;
                    },
                    debounce: function debounce(a, b, c) {
                        var d;
                        return function() {
                            var e = this, f = arguments, g = function g() {
                                d = null;
                                if (!c) a.apply(e, f);
                            }, h = c && !d;
                            clearTimeout(d);
                            d = setTimeout(g, b);
                            if (h) a.apply(e, f);
                        };
                    },
                    rect: function rect(el, abs) {
                        var w = window;
                        var r = el.getBoundingClientRect();
                        var x = abs ? w.pageXOffset : 0;
                        var y = abs ? w.pageYOffset : 0;
                        return {
                            bottom: r.bottom + y,
                            height: r.height,
                            left: r.left + x,
                            right: r.right + x,
                            top: r.top + y,
                            width: r.width
                        };
                    },
                    includes: function includes(a, b) {
                        return a.indexOf(b) > -1;
                    },
                    startsWith: function startsWith(a, b) {
                        return a.substr(0, b.length) === b;
                    },
                    truncate: function truncate(el) {
                        while(el.firstChild)el.removeChild(el.firstChild);
                    }
                };
                function isset(obj, prop) {
                    return obj.hasOwnProperty(prop) && (obj[prop] === true || obj[prop].length);
                }
                /**
 * Append an item to the list
 * @param  {Object} item
 * @param  {Object} custom
 * @return {Void}
 */ function appendItem(item, parent, custom) {
                    if (item.parentNode) {
                        if (!item.parentNode.parentNode) parent.appendChild(item.parentNode);
                    } else parent.appendChild(item);
                    util.removeClass(item, "excluded");
                    if (!custom) // remove any <span> highlighting, without xss
                    item.textContent = item.textContent;
                }
                /**
 * Render the item list
 * @return {Void}
 */ var render = function render() {
                    if (this.items.length) {
                        var f = document.createDocumentFragment();
                        if (this.config.pagination) {
                            var pages = this.pages.slice(0, this.pageIndex);
                            util.each(pages, function(i, items) {
                                util.each(items, function(j, item) {
                                    appendItem(item, f, this.customOption);
                                }, this);
                            }, this);
                        } else util.each(this.items, function(i, item) {
                            appendItem(item, f, this.customOption);
                        }, this);
                        // highlight first selected option if any; first option otherwise
                        if (f.childElementCount) {
                            util.removeClass(this.items[this.navIndex], "active");
                            this.navIndex = (f.querySelector(".selectr-option.selected") || f.querySelector(".selectr-option")).idx;
                            util.addClass(this.items[this.navIndex], "active");
                        }
                        this.tree.appendChild(f);
                    }
                };
                /**
 * Dismiss / close the dropdown
 * @param  {obj} e
 * @return {void}
 */ var dismiss = function dismiss(e) {
                    var target = e.target;
                    if (!this.container.contains(target) && (this.opened || util.hasClass(this.container, "notice"))) this.close();
                };
                /**
 * Build a list item from the HTMLOptionElement
 * @param  {int} i      HTMLOptionElement index
 * @param  {HTMLOptionElement} option
 * @param  {bool} group  Has parent optgroup
 * @return {void}
 */ var createItem = function createItem(option, data) {
                    data = data || option;
                    var elementData = {
                        "class": "selectr-option",
                        role: "treeitem",
                        "aria-selected": false
                    };
                    if (this.customOption) elementData.html = this.config.renderOption(data); // asume xss prevention in custom render function
                    else elementData.textContent = option.textContent; // treat all as plain text
                    var opt = util.createElement("li", elementData);
                    opt.idx = option.idx;
                    this.items.push(opt);
                    if (option.defaultSelected) this.defaultSelected.push(option.idx);
                    if (option.disabled) {
                        opt.disabled = true;
                        util.addClass(opt, "disabled");
                    }
                    return opt;
                };
                /**
 * Build the container
 * @return {Void}
 */ var build = function build() {
                    this.requiresPagination = this.config.pagination && this.config.pagination > 0;
                    // Set width
                    if (isset(this.config, "width")) {
                        if (util.isInt(this.config.width)) this.width = this.config.width + "px";
                        else {
                            if (this.config.width === "auto") this.width = "100%";
                            else if (util.includes(this.config.width, "%")) this.width = this.config.width;
                        }
                    }
                    this.container = util.createElement("div", {
                        "class": "selectr-container"
                    });
                    // Custom className
                    if (this.config.customClass) util.addClass(this.container, this.config.customClass);
                    // Mobile device
                    if (this.mobileDevice) util.addClass(this.container, "selectr-mobile");
                    else util.addClass(this.container, "selectr-desktop");
                    // Hide the HTMLSelectElement and prevent focus
                    this.el.tabIndex = -1;
                    // Native dropdown
                    if (this.config.nativeDropdown || this.mobileDevice) util.addClass(this.el, "selectr-visible");
                    else util.addClass(this.el, "selectr-hidden");
                    this.selected = util.createElement("div", {
                        "class": "selectr-selected",
                        disabled: this.disabled,
                        tabIndex: 0,
                        "aria-expanded": false
                    });
                    this.label = util.createElement(this.el.multiple ? "ul" : "span", {
                        "class": "selectr-label"
                    });
                    var dropdown = util.createElement("div", {
                        "class": "selectr-options-container"
                    });
                    this.tree = util.createElement("ul", {
                        "class": "selectr-options",
                        role: "tree",
                        "aria-hidden": true,
                        "aria-expanded": false
                    });
                    this.notice = util.createElement("div", {
                        "class": "selectr-notice"
                    });
                    this.el.setAttribute("aria-hidden", true);
                    if (this.disabled) this.el.disabled = true;
                    if (this.el.multiple) {
                        util.addClass(this.label, "selectr-tags");
                        util.addClass(this.container, "multiple");
                        // Collection of tags
                        this.tags = [];
                        // Collection of selected values
                        // #93 defaultSelected = false did not work as expected
                        this.selectedValues = this.config.defaultSelected ? this.getSelectedProperties("value") : [];
                        // Collection of selected indexes
                        this.selectedIndexes = this.getSelectedProperties("idx");
                    } else {
                        // #93 defaultSelected = false did not work as expected
                        // these values were undefined
                        this.selectedValue = null;
                        this.selectedIndex = -1;
                    }
                    this.selected.appendChild(this.label);
                    if (this.config.clearable) {
                        this.selectClear = util.createElement("button", {
                            "class": "selectr-clear",
                            type: "button"
                        });
                        this.container.appendChild(this.selectClear);
                        util.addClass(this.container, "clearable");
                    }
                    if (this.config.taggable) {
                        var li = util.createElement("li", {
                            "class": "input-tag"
                        });
                        this.input = util.createElement("input", {
                            "class": "selectr-tag-input",
                            placeholder: this.config.tagPlaceholder,
                            tagIndex: 0,
                            autocomplete: "off",
                            autocorrect: "off",
                            autocapitalize: "off",
                            spellcheck: "false",
                            role: "textbox",
                            type: "search"
                        });
                        li.appendChild(this.input);
                        this.label.appendChild(li);
                        util.addClass(this.container, "taggable");
                        this.tagSeperators = [
                            ","
                        ];
                        if (this.config.tagSeperators) {
                            this.tagSeperators = this.tagSeperators.concat(this.config.tagSeperators);
                            var _aTempEscapedSeperators = [];
                            for(var _nTagSeperatorStepCount = 0; _nTagSeperatorStepCount < this.tagSeperators.length; _nTagSeperatorStepCount++)_aTempEscapedSeperators.push(util.escapeRegExp(this.tagSeperators[_nTagSeperatorStepCount]));
                            this.tagSeperatorsRegex = new RegExp(_aTempEscapedSeperators.join("|"), "i");
                        } else this.tagSeperatorsRegex = new RegExp(",", "i");
                    }
                    if (this.config.searchable) {
                        this.input = util.createElement("input", {
                            "class": "selectr-input",
                            tagIndex: -1,
                            autocomplete: "off",
                            autocorrect: "off",
                            autocapitalize: "off",
                            spellcheck: "false",
                            role: "textbox",
                            type: "search",
                            placeholder: this.config.messages.searchPlaceholder
                        });
                        this.inputClear = util.createElement("button", {
                            "class": "selectr-input-clear",
                            type: "button"
                        });
                        this.inputContainer = util.createElement("div", {
                            "class": "selectr-input-container"
                        });
                        this.inputContainer.appendChild(this.input);
                        this.inputContainer.appendChild(this.inputClear);
                        dropdown.appendChild(this.inputContainer);
                    }
                    dropdown.appendChild(this.notice);
                    dropdown.appendChild(this.tree);
                    // List of items for the dropdown
                    this.items = [];
                    // Establish options
                    this.options = [];
                    // Check for options in the element
                    if (this.el.options.length) this.options = [].slice.call(this.el.options);
                    // Element may have optgroups so
                    // iterate element.children instead of element.options
                    var group = false, j = 0;
                    if (this.el.children.length) util.each(this.el.children, function(i, element) {
                        if (element.nodeName === "OPTGROUP") {
                            group = util.createElement("ul", {
                                "class": "selectr-optgroup",
                                role: "group",
                                html: "<li class='selectr-optgroup--label'>" + element.label + "</li>"
                            });
                            util.each(element.children, function(x, el) {
                                el.idx = j;
                                group.appendChild(createItem.call(this, el, group));
                                j++;
                            }, this);
                        } else {
                            element.idx = j;
                            createItem.call(this, element);
                            j++;
                        }
                    }, this);
                    // Options defined by the data option
                    if (this.config.data && Array.isArray(this.config.data)) {
                        this.data = [];
                        var optgroup = false, option;
                        group = false;
                        j = 0;
                        util.each(this.config.data, function(i, opt) {
                            // Check for group options
                            if (isset(opt, "children")) {
                                optgroup = util.createElement("optgroup", {
                                    label: opt.text
                                });
                                group = util.createElement("ul", {
                                    "class": "selectr-optgroup",
                                    role: "group",
                                    html: "<li class='selectr-optgroup--label'>" + opt.text + "</li>"
                                });
                                util.each(opt.children, function(x, data) {
                                    option = new Option(data.text, data.value, false, data.hasOwnProperty("selected") && data.selected === true);
                                    option.disabled = isset(data, "disabled");
                                    this.options.push(option);
                                    optgroup.appendChild(option);
                                    option.idx = j;
                                    group.appendChild(createItem.call(this, option, data));
                                    this.data[j] = data;
                                    j++;
                                }, this);
                                this.el.appendChild(optgroup);
                            } else {
                                option = new Option(opt.text, opt.value, false, opt.hasOwnProperty("selected") && opt.selected === true);
                                option.disabled = isset(opt, "disabled");
                                this.options.push(option);
                                option.idx = j;
                                createItem.call(this, option, opt);
                                this.data[j] = opt;
                                j++;
                            }
                        }, this);
                    }
                    this.setSelected(true);
                    var first;
                    this.navIndex = 0;
                    for(var i = 0; i < this.items.length; i++){
                        first = this.items[i];
                        if (!util.hasClass(first, "disabled")) {
                            util.addClass(first, "active");
                            this.navIndex = i;
                            break;
                        }
                    }
                    // Check for pagination / infinite scroll
                    if (this.requiresPagination) {
                        this.pageIndex = 1;
                        // Create the pages
                        this.paginate();
                    }
                    this.container.appendChild(this.selected);
                    this.container.appendChild(dropdown);
                    this.placeEl = util.createElement("div", {
                        "class": "selectr-placeholder"
                    });
                    // Set the placeholder
                    this.setPlaceholder();
                    this.selected.appendChild(this.placeEl);
                    // Disable if required
                    if (this.disabled) this.disable();
                    this.el.parentNode.insertBefore(this.container, this.el);
                    this.container.appendChild(this.el);
                };
                /**
 * Navigate through the dropdown
 * @param  {obj} e
 * @return {void}
 */ var navigate = function navigate(e) {
                    e = e || window.event;
                    // Filter out the keys we don"t want
                    if (!this.items.length || !this.opened || !util.includes([
                        13,
                        38,
                        40
                    ], e.which)) {
                        this.navigating = false;
                        return;
                    }
                    e.preventDefault();
                    if (e.which === 13) {
                        if (this.noResults || this.config.taggable && this.input.value.length > 0) return false;
                        return this.change(this.navIndex);
                    }
                    var direction, prevEl = this.items[this.navIndex];
                    var lastIndex = this.navIndex;
                    switch(e.which){
                        case 38:
                            direction = 0;
                            if (this.navIndex > 0) this.navIndex--;
                            break;
                        case 40:
                            direction = 1;
                            if (this.navIndex < this.items.length - 1) this.navIndex++;
                    }
                    this.navigating = true;
                    // Instead of wasting memory holding a copy of this.items
                    // with disabled / excluded options omitted, skip them instead
                    while(util.hasClass(this.items[this.navIndex], "disabled") || util.hasClass(this.items[this.navIndex], "excluded")){
                        if (this.navIndex > 0 && this.navIndex < this.items.length - 1) {
                            if (direction) this.navIndex++;
                            else this.navIndex--;
                        } else {
                            this.navIndex = lastIndex;
                            break;
                        }
                        if (this.searching) {
                            if (this.navIndex > this.tree.lastElementChild.idx) {
                                this.navIndex = this.tree.lastElementChild.idx;
                                break;
                            } else if (this.navIndex < this.tree.firstElementChild.idx) {
                                this.navIndex = this.tree.firstElementChild.idx;
                                break;
                            }
                        }
                    }
                    // Autoscroll the dropdown during navigation
                    var r = util.rect(this.items[this.navIndex]);
                    if (!direction) {
                        if (this.navIndex === 0) this.tree.scrollTop = 0;
                        else if (r.top - this.optsRect.top < 0) this.tree.scrollTop = this.tree.scrollTop + (r.top - this.optsRect.top);
                    } else {
                        if (this.navIndex === 0) this.tree.scrollTop = 0;
                        else if (r.top + r.height > this.optsRect.top + this.optsRect.height) this.tree.scrollTop = this.tree.scrollTop + (r.top + r.height - (this.optsRect.top + this.optsRect.height));
                        // Load another page if needed
                        if (this.navIndex === this.tree.childElementCount - 1 && this.requiresPagination) load.call(this);
                    }
                    if (prevEl) util.removeClass(prevEl, "active");
                    util.addClass(this.items[this.navIndex], "active");
                };
                /**
 * Add a tag
 * @param  {HTMLElement} item
 */ var addTag = function addTag(item) {
                    var that = this, r;
                    var docFrag = document.createDocumentFragment();
                    var option = this.options[item.idx];
                    var data = this.data ? this.data[item.idx] : option;
                    var elementData = {
                        "class": "selectr-tag"
                    };
                    if (this.customSelected) elementData.html = this.config.renderSelection(data); // asume xss prevention in custom render function
                    else elementData.textContent = option.textContent;
                    var tag = util.createElement("li", elementData);
                    var btn = util.createElement("button", {
                        "class": "selectr-tag-remove",
                        type: "button"
                    });
                    tag.appendChild(btn);
                    // Set property to check against later
                    tag.idx = item.idx;
                    tag.tag = option.value;
                    this.tags.push(tag);
                    if (this.config.sortSelected) {
                        var tags = this.tags.slice();
                        // Deal with values that contain numbers
                        r = function r(val, arr) {
                            val.replace(/(\d+)|(\D+)/g, function(that, $1, $2) {
                                arr.push([
                                    $1 || Infinity,
                                    $2 || ""
                                ]);
                            });
                        };
                        tags.sort(function(a, b) {
                            var x = [], y = [], ac, bc;
                            if (that.config.sortSelected === true) {
                                ac = a.tag;
                                bc = b.tag;
                            } else if (that.config.sortSelected === "text") {
                                ac = a.textContent;
                                bc = b.textContent;
                            }
                            r(ac, x);
                            r(bc, y);
                            while(x.length && y.length){
                                var ax = x.shift();
                                var by = y.shift();
                                var nn = ax[0] - by[0] || ax[1].localeCompare(by[1]);
                                if (nn) return nn;
                            }
                            return x.length - y.length;
                        });
                        util.each(tags, function(i, tg) {
                            docFrag.appendChild(tg);
                        });
                        this.label.innerHTML = "";
                    } else docFrag.appendChild(tag);
                    if (this.config.taggable) this.label.insertBefore(docFrag, this.input.parentNode);
                    else this.label.appendChild(docFrag);
                };
                /**
 * Remove a tag
 * @param  {HTMLElement} item
 * @return {void}
 */ var removeTag = function removeTag(item) {
                    var tag = false;
                    util.each(this.tags, function(i, t) {
                        if (t.idx === item.idx) tag = t;
                    }, this);
                    if (tag) {
                        this.label.removeChild(tag);
                        this.tags.splice(this.tags.indexOf(tag), 1);
                    }
                };
                /**
 * Load the next page of items
 * @return {void}
 */ var load = function load() {
                    var tree = this.tree;
                    var scrollTop = tree.scrollTop;
                    var scrollHeight = tree.scrollHeight;
                    var offsetHeight = tree.offsetHeight;
                    var atBottom = scrollTop >= scrollHeight - offsetHeight;
                    if (atBottom && this.pageIndex < this.pages.length) {
                        var f = document.createDocumentFragment();
                        util.each(this.pages[this.pageIndex], function(i, item) {
                            appendItem(item, f, this.customOption);
                        }, this);
                        tree.appendChild(f);
                        this.pageIndex++;
                        this.emit("selectr.paginate", {
                            items: this.items.length,
                            total: this.data.length,
                            page: this.pageIndex,
                            pages: this.pages.length
                        });
                    }
                };
                /**
 * Clear a search
 * @return {void}
 */ var clearSearch = function clearSearch() {
                    if (this.config.searchable || this.config.taggable) {
                        this.input.value = null;
                        this.searching = false;
                        if (this.config.searchable) util.removeClass(this.inputContainer, "active");
                        if (util.hasClass(this.container, "notice")) {
                            util.removeClass(this.container, "notice");
                            util.addClass(this.container, "open");
                            this.input.focus();
                        }
                        util.each(this.items, function(i, item) {
                            // Items that didn't match need the class
                            // removing to make them visible again
                            util.removeClass(item, "excluded");
                            // Remove the span element for underlining matched items
                            if (!this.customOption) // without xss
                            item.textContent = item.textContent;
                        }, this);
                    }
                };
                /**
 * Query matching for searches.
 * Wraps matching text in a span.selectr-match.
 *
 * @param  {string} query
 * @param  {HTMLOptionElement} option element
 * @return {bool} true if matched; false otherwise
 */ var match = function match(query, option) {
                    var text = option.textContent;
                    var RX = new RegExp(query, "ig");
                    var result = RX.exec(text);
                    if (result) {
                        // #102 stop xss
                        option.innerHTML = "";
                        var span = document.createElement("span");
                        span.classList.add("selectr-match");
                        span.textContent = result[0];
                        option.appendChild(document.createTextNode(text.substring(0, result.index)));
                        option.appendChild(span);
                        option.appendChild(document.createTextNode(text.substring(RX.lastIndex)));
                        return true;
                    }
                    return false;
                };
                // Main Lib
                var Selectr = function Selectr(el, config) {
                    if (!el) throw new Error("You must supply either a HTMLSelectElement or a CSS3 selector string.");
                    this.el = el;
                    // CSS3 selector string
                    if (typeof el === "string") this.el = document.querySelector(el);
                    if (this.el === null) throw new Error("The element you passed to Selectr can not be found.");
                    if (this.el.nodeName.toLowerCase() !== "select") throw new Error("The element you passed to Selectr is not a HTMLSelectElement.");
                    this.render(config);
                };
                /**
 * Render the instance
 * @param  {object} config
 * @return {void}
 */ Selectr.prototype.render = function(config) {
                    if (this.rendered) return;
                    /**
   * Default configuration options
   * @type {Object}
   */ var defaultConfig = {
                        /**
     * Emulates browser behaviour by selecting the first option by default
     * @type {Boolean}
     */ defaultSelected: true,
                        /**
     * Sets the width of the container
     * @type {String}
     */ width: "auto",
                        /**
     * Enables/ disables the container
     * @type {Boolean}
     */ disabled: false,
                        /**
     * Enables/ disables logic for mobile
     * @type {Boolean}
     */ disabledMobile: false,
                        /**
     * Enables / disables the search function
     * @type {Boolean}
     */ searchable: true,
                        /**
     * Enable disable the clear button
     * @type {Boolean}
     */ clearable: false,
                        /**
     * Sort the tags / multiselect options
     * @type {Boolean}
     */ sortSelected: false,
                        /**
     * Allow deselecting of select-one options
     * @type {Boolean}
     */ allowDeselect: false,
                        /**
     * Close the dropdown when scrolling (@AlexanderReiswich, #11)
     * @type {Boolean}
     */ closeOnScroll: false,
                        /**
     * Allow the use of the native dropdown (@jonnyscholes, #14)
     * @type {Boolean}
     */ nativeDropdown: false,
                        /**
     * Allow the use of native typing behavior for toggling, searching, selecting
     * @type {boolean}
     */ nativeKeyboard: false,
                        /**
     * Set the main placeholder
     * @type {String}
     */ placeholder: "Select an option...",
                        /**
     * Allow the tagging feature
     * @type {Boolean}
     */ taggable: false,
                        /**
     * Set the tag input placeholder (@labikmartin, #21, #22)
     * @type {String}
     */ tagPlaceholder: "Enter a tag...",
                        messages: {
                            noResults: "No results.",
                            noOptions: "No options available.",
                            maxSelections: "A maximum of {max} items can be selected.",
                            tagDuplicate: "That tag is already in use.",
                            searchPlaceholder: "Search options..."
                        }
                    };
                    // add instance reference (#87)
                    this.el.selectr = this;
                    // Merge defaults with user set config
                    this.config = util.extend(defaultConfig, config);
                    // Store type
                    this.originalType = this.el.type;
                    // Store tabIndex
                    this.originalIndex = this.el.tabIndex;
                    // Store defaultSelected options for form reset
                    this.defaultSelected = [];
                    // Store the original option count
                    this.originalOptionCount = this.el.options.length;
                    if (this.config.multiple || this.config.taggable) this.el.multiple = true;
                    // Disabled?
                    this.disabled = isset(this.config, "disabled");
                    this.opened = false;
                    if (this.config.taggable) this.config.searchable = false;
                    this.navigating = false;
                    this.mobileDevice = false;
                    if (!this.config.disabledMobile && /Android|webOS|iPhone|iPad|BlackBerry|Windows Phone|Opera Mini|IEMobile|Mobile/i.test(navigator.userAgent)) this.mobileDevice = true;
                    this.customOption = this.config.hasOwnProperty("renderOption") && typeof this.config.renderOption === "function";
                    this.customSelected = this.config.hasOwnProperty("renderSelection") && typeof this.config.renderSelection === "function";
                    this.supportsEventPassiveOption = this.detectEventPassiveOption();
                    // Enable event emitter
                    Events.mixin(this);
                    build.call(this);
                    this.bindEvents();
                    this.update();
                    this.optsRect = util.rect(this.tree);
                    this.rendered = true;
                    // Fixes macOS Safari bug #28
                    if (!this.el.multiple) this.el.selectedIndex = this.selectedIndex;
                    var that = this;
                    setTimeout(function() {
                        that.emit("selectr.init");
                    }, 20);
                };
                Selectr.prototype.getSelected = function() {
                    var selected = this.el.querySelectorAll("option:checked");
                    return selected;
                };
                Selectr.prototype.getSelectedProperties = function(prop) {
                    var selected = this.getSelected();
                    var values = [].slice.call(selected).map(function(option) {
                        return option[prop];
                    }).filter(function(i) {
                        return i !== null && i !== undefined;
                    });
                    return values;
                };
                /**
 * Feature detection: addEventListener passive option
 * https://dom.spec.whatwg.org/#dom-addeventlisteneroptions-passive
 * https://github.com/WICG/EventListenerOptions/blob/gh-pages/explainer.md
 */ Selectr.prototype.detectEventPassiveOption = function() {
                    var supportsPassiveOption = false;
                    try {
                        var opts = Object.defineProperty({}, "passive", {
                            get: function get() {
                                supportsPassiveOption = true;
                            }
                        });
                        window.addEventListener("test", null, opts);
                    } catch (e) {}
                    return supportsPassiveOption;
                };
                /**
 * Attach the required event listeners
 */ Selectr.prototype.bindEvents = function() {
                    var that = this;
                    this.events = {};
                    this.events.dismiss = dismiss.bind(this);
                    this.events.navigate = navigate.bind(this);
                    this.events.reset = this.reset.bind(this);
                    if (this.config.nativeDropdown || this.mobileDevice) {
                        this.container.addEventListener("touchstart", function(e) {
                            if (e.changedTouches[0].target === that.el) that.toggle();
                        }, this.supportsEventPassiveOption ? {
                            passive: true
                        } : false);
                        this.container.addEventListener("click", function(e) {
                            if (e.target === that.el) that.toggle();
                        });
                        var getChangedOptions = function getChangedOptions(last, current) {
                            var added = [], removed = last.slice(0);
                            var idx;
                            for(var i = 0; i < current.length; i++){
                                idx = removed.indexOf(current[i]);
                                if (idx > -1) removed.splice(idx, 1);
                                else added.push(current[i]);
                            }
                            return [
                                added,
                                removed
                            ];
                        };
                        // Listen for the change on the native select
                        // and update accordingly
                        this.el.addEventListener("change", function(e) {
                            if (e.__selfTriggered) return;
                            if (that.el.multiple) {
                                var indexes = that.getSelectedProperties("idx");
                                var changes = getChangedOptions(that.selectedIndexes, indexes);
                                util.each(changes[0], function(i, idx) {
                                    that.select(idx);
                                }, that);
                                util.each(changes[1], function(i, idx) {
                                    that.deselect(idx);
                                }, that);
                            } else if (that.el.selectedIndex > -1) that.select(that.el.selectedIndex);
                        });
                    }
                    // Open the dropdown with Enter key if focused
                    if (this.config.nativeDropdown) this.container.addEventListener("keydown", function(e) {
                        if (e.key === "Enter" && that.selected === document.activeElement) {
                            // show native dropdown
                            that.toggle();
                            // focus on it
                            setTimeout(function() {
                                that.el.focus();
                            }, 200);
                        }
                    });
                    // Non-native dropdown
                    this.selected.addEventListener("click", function(e) {
                        if (!that.disabled) that.toggle();
                        e.preventDefault();
                    });
                    if (this.config.nativeKeyboard) {
                        var typing = "";
                        var typingTimeout = null;
                        this.selected.addEventListener("keydown", function(e) {
                            // Do nothing if disabled, not focused, or modifier keys are pressed
                            if (that.disabled || that.selected !== document.activeElement || e.altKey || e.ctrlKey || e.metaKey) return;
                            // Open the dropdown on [enter], [ ], [↓], and [↑] keys
                            if (e.key === " " || !that.opened && [
                                "Enter",
                                "ArrowUp",
                                "ArrowDown"
                            ].indexOf(e.key) > -1) {
                                that.toggle();
                                e.preventDefault();
                                e.stopPropagation();
                                return;
                            }
                            // Type to search if multiple; type to select otherwise
                            // make sure e.key is a single, printable character
                            // .length check is a short-circut to skip checking keys like "ArrowDown", etc.
                            // prefer "codePoint" methods; they work with the full range of unicode
                            if (e.key.length <= 2 && String[String.fromCodePoint ? "fromCodePoint" : "fromCharCode"](e.key[String.codePointAt ? "codePointAt" : "charCodeAt"](0)) === e.key) {
                                if (that.config.multiple) {
                                    that.open();
                                    if (that.config.searchable) {
                                        that.input.value = e.key;
                                        that.input.focus();
                                        that.search(null, true);
                                    }
                                } else {
                                    if (typingTimeout) clearTimeout(typingTimeout);
                                    typing += e.key;
                                    var found = that.search(typing, true);
                                    if (found && found.length) {
                                        that.clear();
                                        that.setValue(found[0].value);
                                    }
                                    setTimeout(function() {
                                        typing = "";
                                    }, 1000);
                                }
                                e.preventDefault();
                                e.stopPropagation();
                                return;
                            }
                        });
                        // Close the dropdown on [esc] key
                        this.container.addEventListener("keyup", function(e) {
                            if (that.opened && e.key === "Escape") {
                                that.close();
                                e.stopPropagation();
                                // keep focus so we can re-open easily if desired
                                that.selected.focus();
                            }
                        });
                    }
                    // Remove tag
                    this.label.addEventListener("click", function(e) {
                        if (util.hasClass(e.target, "selectr-tag-remove")) that.deselect(e.target.parentNode.idx);
                    });
                    // Clear input
                    if (this.selectClear) this.selectClear.addEventListener("click", this.clear.bind(this));
                    // Prevent text selection
                    this.tree.addEventListener("mousedown", function(e) {
                        e.preventDefault();
                    });
                    // Select / deselect items
                    this.tree.addEventListener("click", function(e) {
                        var item = util.closest(e.target, function(el) {
                            return el && util.hasClass(el, "selectr-option");
                        });
                        if (item) {
                            if (!util.hasClass(item, "disabled")) {
                                if (util.hasClass(item, "selected")) {
                                    if (that.el.multiple || !that.el.multiple && that.config.allowDeselect) that.deselect(item.idx);
                                } else that.select(item.idx);
                                if (that.opened && !that.el.multiple) that.close();
                            }
                        }
                        e.preventDefault();
                        e.stopPropagation();
                    });
                    // Mouseover list items
                    this.tree.addEventListener("mouseover", function(e) {
                        if (util.hasClass(e.target, "selectr-option")) {
                            if (!util.hasClass(e.target, "disabled")) {
                                util.removeClass(that.items[that.navIndex], "active");
                                util.addClass(e.target, "active");
                                that.navIndex = [].slice.call(that.items).indexOf(e.target);
                            }
                        }
                    });
                    // Searchable
                    if (this.config.searchable) {
                        // Show / hide the search input clear button
                        this.input.addEventListener("focus", function(e) {
                            that.searching = true;
                        });
                        this.input.addEventListener("blur", function(e) {
                            that.searching = false;
                        });
                        this.input.addEventListener("keyup", function(e) {
                            that.search();
                            if (!that.config.taggable) {
                                // Show / hide the search input clear button
                                if (this.value.length) util.addClass(this.parentNode, "active");
                                else util.removeClass(this.parentNode, "active");
                            }
                        });
                        // Clear the search input
                        this.inputClear.addEventListener("click", function(e) {
                            that.input.value = null;
                            clearSearch.call(that);
                            if (!that.tree.childElementCount) render.call(that);
                        });
                    }
                    if (this.config.taggable) this.input.addEventListener("keyup", function(e) {
                        that.search();
                        if (that.config.taggable && this.value.length) {
                            var _sVal = this.value.trim();
                            if (_sVal.length && (e.which === 13 || that.tagSeperatorsRegex.test(_sVal))) {
                                var _sGrabbedTagValue = _sVal.replace(that.tagSeperatorsRegex, "");
                                _sGrabbedTagValue = util.escapeRegExp(_sGrabbedTagValue);
                                _sGrabbedTagValue = _sGrabbedTagValue.trim();
                                var _oOption;
                                if (_sGrabbedTagValue.length) _oOption = that.add({
                                    value: _sGrabbedTagValue,
                                    textContent: _sGrabbedTagValue,
                                    selected: true
                                }, true);
                                if (_oOption) {
                                    that.close();
                                    clearSearch.call(that);
                                } else {
                                    this.value = "";
                                    that.setMessage(that.config.messages.tagDuplicate);
                                }
                            }
                        }
                    });
                    this.update = util.debounce(function() {
                        // Optionally close dropdown on scroll / resize (#11)
                        if (that.opened && that.config.closeOnScroll) that.close();
                        if (that.width) that.container.style.width = that.width;
                        that.invert();
                    }, 50);
                    if (this.requiresPagination) {
                        this.paginateItems = util.debounce(function() {
                            load.call(this);
                        }, 50);
                        this.tree.addEventListener("scroll", this.paginateItems.bind(this));
                    }
                    // Dismiss when clicking outside the container
                    document.addEventListener("click", this.events.dismiss);
                    window.addEventListener("keydown", this.events.navigate);
                    window.addEventListener("resize", this.update);
                    window.addEventListener("scroll", this.update);
                    // remove event listeners on destroy()
                    this.on("selectr.destroy", function() {
                        document.removeEventListener("click", this.events.dismiss);
                        window.removeEventListener("keydown", this.events.navigate);
                        window.removeEventListener("resize", this.update);
                        window.removeEventListener("scroll", this.update);
                    });
                    // Listen for form.reset() (@ambrooks, #13)
                    if (this.el.form) {
                        this.el.form.addEventListener("reset", this.events.reset);
                        // remove listener on destroy()
                        this.on("selectr.destroy", function() {
                            this.el.form.removeEventListener("reset", this.events.reset);
                        });
                    }
                };
                /**
 * Check for selected options
 * @param {bool} reset
 */ Selectr.prototype.setSelected = function(reset) {
                    // Select first option as with a native select-one element - #21, #24
                    if (!this.config.data && !this.el.multiple && this.el.options.length) {
                        // Browser has selected the first option by default
                        if (this.el.selectedIndex === 0) {
                            if (!this.el.options[0].defaultSelected && !this.config.defaultSelected) this.el.selectedIndex = -1;
                        }
                        this.selectedIndex = this.el.selectedIndex;
                        if (this.selectedIndex > -1) this.select(this.selectedIndex);
                    }
                    // If we're changing a select-one to select-multiple via the config
                    // and there are no selected options, the first option will be selected by the browser
                    // Let's prevent that here.
                    if (this.config.multiple && this.originalType === "select-one" && !this.config.data) {
                        if (this.el.options[0].selected && !this.el.options[0].defaultSelected) this.el.options[0].selected = false;
                    }
                    util.each(this.options, function(i, option) {
                        if (option.selected && option.defaultSelected) this.select(option.idx);
                    }, this);
                    if (this.config.selectedValue) this.setValue(this.config.selectedValue);
                    if (this.config.data) {
                        if (!this.el.multiple && this.config.defaultSelected && this.el.selectedIndex < 0 && this.config.data.length > 0) this.select(0);
                        var j = 0;
                        util.each(this.config.data, function(i, opt) {
                            // Check for group options
                            if (isset(opt, "children")) util.each(opt.children, function(x, item) {
                                if (item.hasOwnProperty("selected") && item.selected === true) this.select(j);
                                j++;
                            }, this);
                            else {
                                if (opt.hasOwnProperty("selected") && opt.selected === true) this.select(j);
                                j++;
                            }
                        }, this);
                    }
                };
                /**
 * Destroy the instance
 * @return {void}
 */ Selectr.prototype.destroy = function() {
                    if (!this.rendered) return;
                    this.emit("selectr.destroy");
                    // Revert to select-single if programtically set to multiple
                    if (this.originalType === "select-one") this.el.multiple = false;
                    if (this.config.data) this.el.innerHTML = "";
                    // Remove the className from select element
                    util.removeClass(this.el, "selectr-hidden");
                    // Replace the container with the original select element
                    this.container.parentNode.replaceChild(this.el, this.container);
                    this.rendered = false;
                    // remove reference
                    delete this.el.selectr;
                };
                /**
 * Change an options state
 * @param  {Number} index
 * @return {void}
 */ Selectr.prototype.change = function(index) {
                    var item = this.items[index], option = this.options[index];
                    if (option.disabled) return;
                    if (option.selected && util.hasClass(item, "selected")) this.deselect(index);
                    else this.select(index);
                    if (this.opened && !this.el.multiple) this.close();
                };
                /**
 * Select an option
 * @param  {Number} index
 * @return {void}
 */ Selectr.prototype.select = function(index) {
                    var item = this.items[index], options = [].slice.call(this.el.options), option = this.options[index];
                    if (this.el.multiple) {
                        if (util.includes(this.selectedIndexes, index)) return false;
                        if (this.config.maxSelections && this.tags.length === this.config.maxSelections) {
                            this.setMessage(this.config.messages.maxSelections.replace("{max}", this.config.maxSelections), true);
                            return false;
                        }
                        this.selectedValues.push(option.value);
                        this.selectedIndexes.push(index);
                        addTag.call(this, item);
                    } else {
                        var data = this.data ? this.data[index] : option;
                        if (this.customSelected) this.label.innerHTML = this.config.renderSelection(data);
                        else // no xss
                        this.label.textContent = option.textContent;
                        this.selectedValue = option.value;
                        this.selectedIndex = index;
                        util.each(this.options, function(i, o) {
                            var opt = this.items[i];
                            if (i !== index) {
                                if (opt) util.removeClass(opt, "selected");
                                o.selected = false;
                                o.removeAttribute("selected");
                            }
                        }, this);
                    }
                    if (!util.includes(options, option)) this.el.add(option);
                    item.setAttribute("aria-selected", true);
                    util.addClass(item, "selected");
                    util.addClass(this.container, "has-selected");
                    option.selected = true;
                    option.setAttribute("selected", "");
                    this.emit("selectr.change", option);
                    this.emit("selectr.select", option);
                    // fire native change event
                    if ("createEvent" in document) {
                        var evt = document.createEvent("HTMLEvents");
                        evt.initEvent("change", true, true);
                        evt.__selfTriggered = true;
                        this.el.dispatchEvent(evt);
                    } else this.el.fireEvent("onchange");
                };
                /**
 * Deselect an option
 * @param  {Number} index
 * @return {void}
 */ Selectr.prototype.deselect = function(index, force) {
                    var item = this.items[index], option = this.options[index];
                    if (this.el.multiple) {
                        var selIndex = this.selectedIndexes.indexOf(index);
                        this.selectedIndexes.splice(selIndex, 1);
                        var valIndex = this.selectedValues.indexOf(option.value);
                        this.selectedValues.splice(valIndex, 1);
                        removeTag.call(this, item);
                        if (!this.tags.length) util.removeClass(this.container, "has-selected");
                    } else {
                        if (!force && !this.config.clearable && !this.config.allowDeselect) return false;
                        this.label.innerHTML = "";
                        this.selectedValue = null;
                        this.el.selectedIndex = this.selectedIndex = -1;
                        util.removeClass(this.container, "has-selected");
                    }
                    this.items[index].setAttribute("aria-selected", false);
                    util.removeClass(this.items[index], "selected");
                    option.selected = false;
                    option.removeAttribute("selected");
                    this.emit("selectr.change", null);
                    this.emit("selectr.deselect", option);
                    // fire native change event
                    if ("createEvent" in document) {
                        var evt = document.createEvent("HTMLEvents");
                        evt.initEvent("change", true, true);
                        evt.__selfTriggered = true;
                        this.el.dispatchEvent(evt);
                    } else this.el.fireEvent("onchange");
                };
                /**
 * Programmatically set selected values
 * @param {String|Array} value - A string or an array of strings
 */ Selectr.prototype.setValue = function(value) {
                    var isArray = Array.isArray(value);
                    if (!isArray) value = value.toString().trim();
                    // Can't pass array to select-one
                    if (!this.el.multiple && isArray) return false;
                    util.each(this.options, function(i, option) {
                        if (isArray && value.indexOf(option.value) > -1 || option.value === value) this.change(option.idx);
                    }, this);
                };
                /**
 * Set the selected value(s)
 * @param  {bool} toObject Return only the raw values or an object
 * @param  {bool} toJson   Return the object as a JSON string
 * @return {mixed}         Array or String
 */ Selectr.prototype.getValue = function(toObject, toJson) {
                    var value;
                    if (this.el.multiple) {
                        if (toObject) {
                            if (this.selectedIndexes.length) {
                                value = {};
                                value.values = [];
                                util.each(this.selectedIndexes, function(i, index) {
                                    var option = this.options[index];
                                    value.values[i] = {
                                        value: option.value,
                                        text: option.textContent
                                    };
                                }, this);
                            }
                        } else value = this.selectedValues.slice();
                    } else if (toObject) {
                        var option = this.options[this.selectedIndex];
                        value = {
                            value: option.value,
                            text: option.textContent
                        };
                    } else value = this.selectedValue;
                    if (toObject && toJson) value = JSON.stringify(value);
                    return value;
                };
                /**
 * Add a new option or options
 * @param {object} data
 */ Selectr.prototype.add = function(data, checkDuplicate) {
                    if (data) {
                        this.data = this.data || [];
                        this.items = this.items || [];
                        this.options = this.options || [];
                        if (Array.isArray(data)) // We have an array on items
                        util.each(data, function(i, obj) {
                            this.add(obj, checkDuplicate);
                        }, this);
                        else if ("[object Object]" === Object.prototype.toString.call(data)) {
                            if (checkDuplicate) {
                                var dupe = false;
                                util.each(this.options, function(i, option) {
                                    if (option.value.toLowerCase() === data.value.toLowerCase()) dupe = true;
                                });
                                if (dupe) return false;
                            }
                            var option = util.createElement("option", data);
                            this.data.push(data);
                            // fix for native iOS dropdown otherwise the native dropdown will be empty
                            if (this.mobileDevice) this.el.add(option);
                            // Add the new option to the list
                            this.options.push(option);
                            // Add the index for later use
                            option.idx = this.options.length > 0 ? this.options.length - 1 : 0;
                            // Create a new item
                            createItem.call(this, option);
                            // Select the item if required
                            if (data.selected) this.select(option.idx);
                            // We may have had an empty select so update
                            // the placeholder to reflect the changes.
                            this.setPlaceholder();
                            return option;
                        }
                        // Recount the pages
                        if (this.config.pagination) this.paginate();
                        return true;
                    }
                };
                /**
 * Remove an option or options
 * @param  {Mixed} o Array, integer (index) or string (value)
 * @return {Void}
 */ Selectr.prototype.remove = function(o) {
                    var options = [];
                    if (Array.isArray(o)) util.each(o, function(i, opt) {
                        if (util.isInt(opt)) options.push(this.getOptionByIndex(opt));
                        else if (typeof opt === "string") options.push(this.getOptionByValue(opt));
                    }, this);
                    else if (util.isInt(o)) options.push(this.getOptionByIndex(o));
                    else if (typeof o === "string") options.push(this.getOptionByValue(o));
                    if (options.length) {
                        var index;
                        util.each(options, function(i, option) {
                            index = option.idx;
                            // Remove the HTMLOptionElement
                            this.el.remove(option);
                            // Remove the reference from the option array
                            this.options.splice(index, 1);
                            // If the item has a parentNode (group element) it needs to be removed
                            // otherwise the render function will still append it to the dropdown
                            var parentNode = this.items[index].parentNode;
                            if (parentNode) parentNode.removeChild(this.items[index]);
                            // Remove reference from the items array
                            this.items.splice(index, 1);
                            // Reset the indexes
                            util.each(this.options, function(i, opt) {
                                opt.idx = i;
                                this.items[i].idx = i;
                            }, this);
                        }, this);
                        // We may have had an empty select now so update
                        // the placeholder to reflect the changes.
                        this.setPlaceholder();
                        // Recount the pages
                        if (this.config.pagination) this.paginate();
                    }
                };
                /**
 * Remove all options
 */ Selectr.prototype.removeAll = function() {
                    // Clear any selected options
                    this.clear(true);
                    // Remove the HTMLOptionElements
                    util.each(this.el.options, function(i, option) {
                        this.el.remove(option);
                    }, this);
                    // Empty the dropdown
                    util.truncate(this.tree);
                    // Reset variables
                    this.items = [];
                    this.options = [];
                    this.data = [];
                    this.navIndex = 0;
                    if (this.requiresPagination) {
                        this.requiresPagination = false;
                        this.pageIndex = 1;
                        this.pages = [];
                    }
                    // Update the placeholder
                    this.setPlaceholder();
                };
                /**
 * Perform a search
 * @param {string}|{null} query The query string (taken from user input if null)
 * @param {boolean} anchor Anchor search to beginning of strings (defaults to false)?
 * @return {Array} Search results, as an array of {text, value} objects
 */ Selectr.prototype.search = function(string, anchor) {
                    if (this.navigating) return;
                    // we're only going to alter the DOM for "live" searches
                    var live = false;
                    if (!string) {
                        string = this.input.value;
                        live = true;
                        // Remove message and clear dropdown
                        this.removeMessage();
                        util.truncate(this.tree);
                    }
                    var results = [];
                    var f = document.createDocumentFragment();
                    string = string.trim().toLowerCase();
                    if (string.length > 0) {
                        var compare = anchor ? util.startsWith : util.includes;
                        util.each(this.options, function(i, option) {
                            var item = this.items[option.idx];
                            var matches = compare(option.textContent.trim().toLowerCase(), string);
                            if (matches && !option.disabled) {
                                results.push({
                                    text: option.textContent,
                                    value: option.value
                                });
                                if (live) {
                                    appendItem(item, f, this.customOption);
                                    util.removeClass(item, "excluded");
                                    // Underline the matching results
                                    if (!this.customOption) match(string, option);
                                }
                            } else if (live) util.addClass(item, "excluded");
                        }, this);
                        if (live) {
                            // Append results
                            if (!f.childElementCount) {
                                if (!this.config.taggable) {
                                    this.noResults = true;
                                    this.setMessage(this.config.messages.noResults);
                                }
                            } else {
                                // Highlight top result (@binary-koan #26)
                                var prevEl = this.items[this.navIndex];
                                var firstEl = f.querySelector(".selectr-option:not(.excluded)");
                                this.noResults = false;
                                util.removeClass(prevEl, "active");
                                this.navIndex = firstEl.idx;
                                util.addClass(firstEl, "active");
                            }
                            this.tree.appendChild(f);
                        }
                    } else render.call(this);
                    return results;
                };
                /**
 * Toggle the dropdown
 * @return {void}
 */ Selectr.prototype.toggle = function() {
                    if (!this.disabled) {
                        if (this.opened) this.close();
                        else this.open();
                    }
                };
                /**
 * Open the dropdown
 * @return {void}
 */ Selectr.prototype.open = function() {
                    var that = this;
                    if (!this.options.length) return false;
                    if (!this.opened) this.emit("selectr.open");
                    this.opened = true;
                    if (this.mobileDevice || this.config.nativeDropdown) {
                        util.addClass(this.container, "native-open");
                        if (this.config.data) // Dump the options into the select
                        // otherwise the native dropdown will be empty
                        util.each(this.options, function(i, option) {
                            this.el.add(option);
                        }, this);
                        return;
                    }
                    util.addClass(this.container, "open");
                    render.call(this);
                    this.invert();
                    this.tree.scrollTop = 0;
                    util.removeClass(this.container, "notice");
                    this.selected.setAttribute("aria-expanded", true);
                    this.tree.setAttribute("aria-hidden", false);
                    this.tree.setAttribute("aria-expanded", true);
                    if (this.config.searchable && !this.config.taggable) setTimeout(function() {
                        that.input.focus();
                        // Allow tab focus
                        that.input.tabIndex = 0;
                    }, 10);
                };
                /**
 * Close the dropdown
 * @return {void}
 */ Selectr.prototype.close = function() {
                    if (this.opened) this.emit("selectr.close");
                    this.opened = false;
                    this.navigating = false;
                    if (this.mobileDevice || this.config.nativeDropdown) {
                        util.removeClass(this.container, "native-open");
                        return;
                    }
                    var notice = util.hasClass(this.container, "notice");
                    if (this.config.searchable && !notice) {
                        this.input.blur();
                        // Disable tab focus
                        this.input.tabIndex = -1;
                        this.searching = false;
                    }
                    if (notice) {
                        util.removeClass(this.container, "notice");
                        this.notice.textContent = "";
                    }
                    util.removeClass(this.container, "open");
                    util.removeClass(this.container, "native-open");
                    this.selected.setAttribute("aria-expanded", false);
                    this.tree.setAttribute("aria-hidden", true);
                    this.tree.setAttribute("aria-expanded", false);
                    util.truncate(this.tree);
                    clearSearch.call(this);
                };
                /**
 * Enable the element
 * @return {void}
 */ Selectr.prototype.enable = function() {
                    this.disabled = false;
                    this.el.disabled = false;
                    this.selected.tabIndex = this.originalIndex;
                    if (this.el.multiple) util.each(this.tags, function(i, t) {
                        t.lastElementChild.tabIndex = 0;
                    });
                    util.removeClass(this.container, "selectr-disabled");
                };
                /**
 * Disable the element
 * @param  {boolean} container Disable the container only (allow value submit with form)
 * @return {void}
 */ Selectr.prototype.disable = function(container) {
                    if (!container) this.el.disabled = true;
                    this.selected.tabIndex = -1;
                    if (this.el.multiple) util.each(this.tags, function(i, t) {
                        t.lastElementChild.tabIndex = -1;
                    });
                    this.disabled = true;
                    util.addClass(this.container, "selectr-disabled");
                };
                /**
 * Reset to initial state
 * @return {void}
 */ Selectr.prototype.reset = function() {
                    if (!this.disabled) {
                        this.clear();
                        this.setSelected(true);
                        util.each(this.defaultSelected, function(i, idx) {
                            this.select(idx);
                        }, this);
                        this.emit("selectr.reset");
                    }
                };
                /**
 * Clear all selections
 * @return {void}
 */ Selectr.prototype.clear = function(force, isClearLast) {
                    if (this.el.multiple) // Loop over the selectedIndexes so we don't have to loop over all the options
                    // which can be costly if there are a lot of them
                    {
                        if (this.selectedIndexes.length) {
                            // Copy the array or we'll get an error
                            var indexes = this.selectedIndexes.slice();
                            if (isClearLast) this.deselect(indexes.slice(-1)[0]);
                            else util.each(indexes, function(i, idx) {
                                this.deselect(idx);
                            }, this);
                        }
                    } else if (this.selectedIndex > -1) this.deselect(this.selectedIndex, force);
                    this.emit("selectr.clear");
                };
                /**
 * Return serialised data
 * @param  {boolean} toJson
 * @return {mixed} Returns either an object or JSON string
 */ Selectr.prototype.serialise = function(toJson) {
                    var data = [];
                    util.each(this.options, function(i, option) {
                        var obj = {
                            value: option.value,
                            text: option.textContent
                        };
                        if (option.selected) obj.selected = true;
                        if (option.disabled) obj.disabled = true;
                        data[i] = obj;
                    });
                    return toJson ? JSON.stringify(data) : data;
                };
                /**
 * Localised version of serialise() method
 */ Selectr.prototype.serialize = function(toJson) {
                    return this.serialise(toJson);
                };
                /**
 * Sets the placeholder
 * @param {String} placeholder
 */ Selectr.prototype.setPlaceholder = function(placeholder) {
                    // Set the placeholder
                    placeholder = placeholder || this.config.placeholder || this.el.getAttribute("placeholder");
                    if (!this.options.length) placeholder = this.config.messages.noOptions;
                    this.placeEl.innerHTML = placeholder;
                };
                /**
 * Paginate the option list
 * @return {Array}
 */ Selectr.prototype.paginate = function() {
                    if (this.items.length) {
                        var that = this;
                        this.pages = this.items.map(function(v, i) {
                            return i % that.config.pagination === 0 ? that.items.slice(i, i + that.config.pagination) : null;
                        }).filter(function(pages) {
                            return pages;
                        });
                        return this.pages;
                    }
                };
                /**
 * Display a message
 * @param  {String} message The message
 */ Selectr.prototype.setMessage = function(message, close) {
                    if (close) this.close();
                    util.addClass(this.container, "notice");
                    this.notice.textContent = message;
                };
                /**
 * Dismiss the current message
 */ Selectr.prototype.removeMessage = function() {
                    util.removeClass(this.container, "notice");
                    this.notice.innerHTML = "";
                };
                /**
 * Keep the dropdown within the window
 * @return {void}
 */ Selectr.prototype.invert = function() {
                    var rt = util.rect(this.selected), oh = this.tree.parentNode.offsetHeight, wh = window.innerHeight, doInvert = rt.top + rt.height + oh > wh;
                    if (doInvert) {
                        util.addClass(this.container, "inverted");
                        this.isInverted = true;
                    } else {
                        util.removeClass(this.container, "inverted");
                        this.isInverted = false;
                    }
                    this.optsRect = util.rect(this.tree);
                };
                /**
 * Get an option via it's index
 * @param  {Integer} index The index of the HTMLOptionElement required
 * @return {HTMLOptionElement}
 */ Selectr.prototype.getOptionByIndex = function(index) {
                    return this.options[index];
                };
                /**
 * Get an option via it's value
 * @param  {String} value The value of the HTMLOptionElement required
 * @return {HTMLOptionElement}
 */ Selectr.prototype.getOptionByValue = function(value) {
                    var option = false;
                    for(var i = 0, l = this.options.length; i < l; i++)if (this.options[i].value.trim() === value.toString().trim()) {
                        option = this.options[i];
                        break;
                    }
                    return option;
                };
                module1.exports = Selectr;
            /***/ },
            /***/ 188: /***/ function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {
                "use strict";
                /* harmony export */ __webpack_require__.d(__webpack_exports__, {
                    /* harmony export */ "EX": function() {
                        return /* binding */ SIZE_LARGE;
                    },
                    /* harmony export */ "WF": function() {
                        return /* binding */ MAX_PREVIEW_CHARACTERS;
                    },
                    /* harmony export */ "oW": function() {
                        return /* binding */ PREVIEW_HISTORY_LIMIT;
                    },
                    /* harmony export */ "qD": function() {
                        return /* binding */ DEFAULT_MODAL_ANCHOR;
                    }
                });
                var DEFAULT_MODAL_ANCHOR = document.body;
                var SIZE_LARGE = 10485760; // 10 MB
                var MAX_PREVIEW_CHARACTERS = 20000;
                var PREVIEW_HISTORY_LIMIT = 2147483648; // 2 GB
            /***/ },
            /***/ 602: /***/ function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {
                "use strict";
                /* harmony export */ __webpack_require__.d(__webpack_exports__, {
                    /* harmony export */ "w": function() {
                        return /* binding */ createAbsoluteAnchor;
                    }
                });
                /* harmony import */ var _util__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(791);
                /**
 * Create an anchor element absolutely positioned in the `parent`
 * element.
 * @param {HTMLElement} anchor
 * @param {HTMLElement} parent
 * @param {function(HTMLElement)} [onDestroy]  Callback when the anchor is destroyed
 * @param {boolean} [destroyOnMouseOut=false] If true, anchor will be removed on mouse out
 * @returns {HTMLElement}
 */ function createAbsoluteAnchor(anchor, parent, onDestroy) {
                    var destroyOnMouseOut = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
                    var root = getRootNode(anchor);
                    var eventListeners = {};
                    var anchorRect = anchor.getBoundingClientRect();
                    var parentRect = parent.getBoundingClientRect();
                    var absoluteAnchor = document.createElement("div");
                    absoluteAnchor.className = "jsoneditor-anchor";
                    absoluteAnchor.style.position = "absolute";
                    absoluteAnchor.style.left = anchorRect.left - parentRect.left + "px";
                    absoluteAnchor.style.top = anchorRect.top - parentRect.top + "px";
                    absoluteAnchor.style.width = anchorRect.width - 2 + "px";
                    absoluteAnchor.style.height = anchorRect.height - 2 + "px";
                    absoluteAnchor.style.boxSizing = "border-box";
                    parent.appendChild(absoluteAnchor);
                    function destroy() {
                        // remove temporary absolutely positioned anchor
                        if (absoluteAnchor && absoluteAnchor.parentNode) {
                            absoluteAnchor.parentNode.removeChild(absoluteAnchor);
                            // remove all event listeners
                            // all event listeners are supposed to be attached to document.
                            for(var name in eventListeners)if (hasOwnProperty1(eventListeners, name)) {
                                var fn = eventListeners[name];
                                if (fn) (0, _util__WEBPACK_IMPORTED_MODULE_0__.removeEventListener)(root, name, fn);
                                delete eventListeners[name];
                            }
                            if (typeof onDestroy === "function") onDestroy(anchor);
                        }
                    }
                    function isOutside(target) {
                        return target !== absoluteAnchor && !(0, _util__WEBPACK_IMPORTED_MODULE_0__.isChildOf)(target, absoluteAnchor);
                    }
                    // create and attach event listeners
                    function destroyIfOutside(event) {
                        if (isOutside(event.target)) destroy();
                    }
                    eventListeners.mousedown = (0, _util__WEBPACK_IMPORTED_MODULE_0__.addEventListener)(root, "mousedown", destroyIfOutside);
                    eventListeners.mousewheel = (0, _util__WEBPACK_IMPORTED_MODULE_0__.addEventListener)(root, "mousewheel", destroyIfOutside);
                    if (destroyOnMouseOut) {
                        var destroyTimer = null;
                        absoluteAnchor.onmouseover = function() {
                            clearTimeout(destroyTimer);
                            destroyTimer = null;
                        };
                        absoluteAnchor.onmouseout = function() {
                            if (!destroyTimer) destroyTimer = setTimeout(destroy, 200);
                        };
                    }
                    absoluteAnchor.destroy = destroy;
                    return absoluteAnchor;
                }
                /**
 * Node.getRootNode shim
 * @param  {HTMLElement} node node to check
 * @return {HTMLElement}      node's rootNode or `window` if there is ShadowDOM is not supported.
 */ function getRootNode(node) {
                    return typeof node.getRootNode === "function" ? node.getRootNode() : window;
                }
                function hasOwnProperty1(object, key) {
                    return Object.prototype.hasOwnProperty.call(object, key);
                }
            /***/ },
            /***/ 907: /***/ function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {
                "use strict";
                /* harmony export */ __webpack_require__.d(__webpack_exports__, {
                    /* harmony export */ "Iu": function() {
                        return /* binding */ translate;
                    },
                    /* harmony export */ "cC": function() {
                        return /* binding */ setLanguages;
                    },
                    /* harmony export */ "m0": function() {
                        return /* binding */ setLanguage;
                    }
                });
                /* harmony import */ var _polyfills__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(987);
                /* harmony import */ var _polyfills__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/ __webpack_require__.n(_polyfills__WEBPACK_IMPORTED_MODULE_0__);
                /* eslint-disable no-template-curly-in-string */ var _defs = {
                    en: {
                        array: "Array",
                        auto: "Auto",
                        appendText: "Append",
                        appendTitle: "Append a new field with type 'auto' after this field (Ctrl+Shift+Ins)",
                        appendSubmenuTitle: "Select the type of the field to be appended",
                        appendTitleAuto: "Append a new field with type 'auto' (Ctrl+Shift+Ins)",
                        ascending: "Ascending",
                        ascendingTitle: "Sort the childs of this ${type} in ascending order",
                        actionsMenu: "Click to open the actions menu (Ctrl+M)",
                        cannotParseFieldError: "Cannot parse field into JSON",
                        cannotParseValueError: "Cannot parse value into JSON",
                        collapseAll: "Collapse all fields",
                        compactTitle: "Compact JSON data, remove all whitespaces (Ctrl+Shift+I)",
                        descending: "Descending",
                        descendingTitle: "Sort the childs of this ${type} in descending order",
                        drag: "Drag to move this field (Alt+Shift+Arrows)",
                        duplicateKey: "duplicate key",
                        duplicateText: "Duplicate",
                        duplicateTitle: "Duplicate selected fields (Ctrl+D)",
                        duplicateField: "Duplicate this field (Ctrl+D)",
                        duplicateFieldError: "Duplicate field name",
                        empty: "empty",
                        expandAll: "Expand all fields",
                        expandTitle: "Click to expand/collapse this field (Ctrl+E). \nCtrl+Click to expand/collapse including all childs.",
                        formatTitle: "Format JSON data, with proper indentation and line feeds (Ctrl+I)",
                        insert: "Insert",
                        insertTitle: "Insert a new field with type 'auto' before this field (Ctrl+Ins)",
                        insertSub: "Select the type of the field to be inserted",
                        object: "Object",
                        ok: "Ok",
                        redo: "Redo (Ctrl+Shift+Z)",
                        removeText: "Remove",
                        removeTitle: "Remove selected fields (Ctrl+Del)",
                        removeField: "Remove this field (Ctrl+Del)",
                        repairTitle: "Repair JSON: fix quotes and escape characters, remove comments and JSONP notation, turn JavaScript objects into JSON.",
                        searchTitle: "Search fields and values",
                        searchNextResultTitle: "Next result (Enter)",
                        searchPreviousResultTitle: "Previous result (Shift + Enter)",
                        selectNode: "Select a node...",
                        showAll: "show all",
                        showMore: "show more",
                        showMoreStatus: "displaying ${visibleChilds} of ${totalChilds} items.",
                        sort: "Sort",
                        sortTitle: "Sort the childs of this ${type}",
                        sortTitleShort: "Sort contents",
                        sortFieldLabel: "Field:",
                        sortDirectionLabel: "Direction:",
                        sortFieldTitle: "Select the nested field by which to sort the array or object",
                        sortAscending: "Ascending",
                        sortAscendingTitle: "Sort the selected field in ascending order",
                        sortDescending: "Descending",
                        sortDescendingTitle: "Sort the selected field in descending order",
                        string: "String",
                        transform: "Transform",
                        transformTitle: "Filter, sort, or transform the childs of this ${type}",
                        transformTitleShort: "Filter, sort, or transform contents",
                        extract: "Extract",
                        extractTitle: "Extract this ${type}",
                        transformQueryTitle: "Enter a JMESPath query",
                        transformWizardLabel: "Wizard",
                        transformWizardFilter: "Filter",
                        transformWizardSortBy: "Sort by",
                        transformWizardSelectFields: "Select fields",
                        transformQueryLabel: "Query",
                        transformPreviewLabel: "Preview",
                        type: "Type",
                        typeTitle: "Change the type of this field",
                        openUrl: "Ctrl+Click or Ctrl+Enter to open url in new window",
                        undo: "Undo last action (Ctrl+Z)",
                        validationCannotMove: "Cannot move a field into a child of itself",
                        autoType: 'Field type "auto". The field type is automatically determined from the value and can be a string, number, boolean, or null.',
                        objectType: 'Field type "object". An object contains an unordered set of key/value pairs.',
                        arrayType: 'Field type "array". An array contains an ordered collection of values.',
                        stringType: 'Field type "string". Field type is not determined from the value, but always returned as string.',
                        modeEditorTitle: "Switch Editor Mode",
                        modeCodeText: "Code",
                        modeCodeTitle: "Switch to code highlighter",
                        modeFormText: "Form",
                        modeFormTitle: "Switch to form editor",
                        modeTextText: "Text",
                        modeTextTitle: "Switch to plain text editor",
                        modeTreeText: "Tree",
                        modeTreeTitle: "Switch to tree editor",
                        modeViewText: "View",
                        modeViewTitle: "Switch to tree view",
                        modePreviewText: "Preview",
                        modePreviewTitle: "Switch to preview mode",
                        examples: "Examples",
                        "default": "Default",
                        containsInvalidProperties: "Contains invalid properties",
                        containsInvalidItems: "Contains invalid items"
                    },
                    es: {
                        array: "Matriz",
                        auto: "Auto",
                        appendText: "Agregar",
                        appendTitle: "Agregue un nuevo campo con el tipo 'auto' despu\xe9s de este campo (Ctrl + Shift + Ins)",
                        appendSubmenuTitle: "Seleccione el tipo de campo que se agregar\xe1",
                        appendTitleAuto: "Agregue un nuevo campo con el tipo 'auto' (Ctrl + Shift + Ins)",
                        ascending: "Ascendente",
                        ascendingTitle: "Ordene los elementos secundarios de este ${type} en orden ascendente",
                        actionsMenu: "Haga clic para abrir el men\xfa de acciones (Ctrl + M)",
                        cannotParseFieldError: "No se puede parsear el campo en JSON",
                        cannotParseValueError: "No se puede parsear el valor en JSON",
                        collapseAll: "Contraer todos los campos",
                        compactTitle: "Compactar datos JSON, eliminar todos los espacios en blanco (Ctrl + Shift + I)",
                        descending: "Descendente",
                        descendingTitle: "Ordene los hijos de este ${type} en orden descendente",
                        drag: "Arrastre para mover este campo (Alt + May\xfas + Flechas)",
                        duplicateKey: "llave duplicada",
                        duplicateText: "Duplicar",
                        duplicateTitle: "Duplicar campos seleccionados (Ctrl + D)",
                        duplicateField: "Duplicar este campo (Ctrl + D)",
                        duplicateFieldError: "Nombre de campo duplicado",
                        empty: "vacio",
                        expandAll: "Expandir todos los campos",
                        expandTitle: "Haga clic para expandir/contraer este campo (Ctrl + E). \n  Ctrl+Clic para expandir/contraer incluyendo todos los ni\xf1os.",
                        formatTitle: "Formatee los datos JSON, con la sangr\xeda y los avances de l\xednea adecuados (Ctrl + I)",
                        insert: "Insertar",
                        insertTitle: "Inserte un nuevo campo con el tipo 'auto' antes de este campo (Ctrl + Ins)",
                        insertSub: "Seleccione el tipo de campo a insertar",
                        object: "Objeto",
                        ok: "Ok",
                        redo: "Rehacer (Ctrl+May\xfas+Z)",
                        removeText: "Eliminar",
                        removeTitle: "Eliminar campos seleccionados (Ctrl+Supr)",
                        removeField: "Eliminar este campo (Ctrl+Supr)",
                        repairTitle: "Reparar JSON: corrija comillas y caracteres de escape, elimine comentarios y notaci\xf3n JSONP, convierta objetos JavaScript en JSON.",
                        searchTitle: "Campos de b\xfasqueda y valores",
                        searchNextResultTitle: "Siguiente resultado (Entrar)",
                        searchPreviousResultTitle: "Resultado anterior (Shift + Enter)",
                        selectNode: "Seleccione un nodo...",
                        showAll: "mostrar todo",
                        showMore: "mostrar m\xe1s",
                        showMoreStatus: "mostrando ${visibleChilds} de ${totalChilds} elementos.",
                        sort: "Ordenar",
                        sortTitle: "Ordene los hijos de este ${type}",
                        sortTitleShort: "Ordenar contenidos",
                        sortFieldLabel: "Campo:",
                        sortDirectionLabel: "Direcci\xf3n:",
                        sortFieldTitle: "Seleccione el campo anidado por el cual ordenar la matriz u objeto",
                        sortAscending: "Ascendente",
                        sortAscendingTitle: "Ordenar el campo seleccionado en orden ascendente",
                        sortDescending: "Descendente",
                        sortDescendingTitle: "Ordenar por el campo seleccionado, en orden descendente",
                        string: "Texto",
                        transform: "Transformar",
                        transformTitle: "Filtrar, ordenar o transformar los hijos de este ${type}",
                        transformTitleShort: "Filtrar, ordenar o transformar contenidos",
                        extract: "Extraer",
                        extractTitle: "Extrae este ${type}",
                        transformQueryTitle: "Ingrese una consulta JMESPath",
                        transformWizardLabel: "Wizard",
                        transformWizardFilter: "Filtro",
                        transformWizardSortBy: "Ordenar por",
                        transformWizardSelectFields: "Seleccione un campo",
                        transformQueryLabel: "Consulta",
                        transformPreviewLabel: "Vista Previa",
                        type: "Tipo",
                        typeTitle: "Cambiar el tipo de campo",
                        openUrl: "Ctrl+Click o Ctrl+Enter para abrir la URL en una nueva ventana",
                        undo: "Deshacer la \xfaltima acci\xf3n (Ctrl+Z)",
                        validationCannotMove: "No se puede mover un campo a un hijo de s\xed mismo.",
                        autoType: 'Field type "auto". The field type is automatically determined from the value and can be a string, number, boolean, or null.',
                        objectType: 'Tipo de campo "objeto".  Un objeto contiene un conjunto desordenado de pares clave/valor.',
                        arrayType: 'Tipo de campo "matriz".  Una matriz contiene una colecci\xf3n ordenada de valores.',
                        stringType: 'Tipo de campo "cadena".  El tipo de campo no se determina a partir del valor,  pero siempre se devuelve como una cadena.',
                        modeEditorTitle: "Cambiar modo de editor",
                        modeCodeText: "Codigo",
                        modeCodeTitle: "Cambiar al resaltador de c\xf3digo",
                        modeFormText: "Formulario",
                        modeFormTitle: "Cambiar al editor de formularios",
                        modeTextText: "Texto",
                        modeTextTitle: "Cambiar al editor de texto sin formato",
                        modeTreeText: "Arbol",
                        modeTreeTitle: "Cambiar al editor de \xe1rbol",
                        modeViewText: "Vista",
                        modeViewTitle: "Cambiar a la vista de \xe1rbol",
                        modePreviewText: "Vista Previa",
                        modePreviewTitle: "Cambiar al modo de vista previa",
                        examples: "Ejemplos",
                        "default": "Predeterminado",
                        containsInvalidProperties: "Contiene propiedades no validas",
                        containsInvalidItems: "Contiene items no validos"
                    },
                    "zh-CN": {
                        array: "数组",
                        auto: "自动",
                        appendText: "追加",
                        appendTitle: "在此字段后追加一个类型为“auto”的新字段 (Ctrl+Shift+Ins)",
                        appendSubmenuTitle: "选择要追加的字段类型",
                        appendTitleAuto: "追加类型为“auto”的新字段 (Ctrl+Shift+Ins)",
                        ascending: "升序",
                        ascendingTitle: "升序排列${type}的子节点",
                        actionsMenu: "点击打开动作菜单(Ctrl+M)",
                        cannotParseFieldError: "无法将字段解析为JSON",
                        cannotParseValueError: "无法将值解析为JSON",
                        collapseAll: "缩进所有字段",
                        compactTitle: "压缩JSON数据，删除所有空格 (Ctrl+Shift+I)",
                        descending: "降序",
                        descendingTitle: "降序排列${type}的子节点",
                        drag: "拖拽移动该节点(Alt+Shift+Arrows)",
                        duplicateKey: "重复键",
                        duplicateText: "复制",
                        duplicateTitle: "复制选中字段(Ctrl+D)",
                        duplicateField: "复制该字段(Ctrl+D)",
                        duplicateFieldError: "重复的字段名称",
                        empty: "清空",
                        expandAll: "展开所有字段",
                        expandTitle: "点击 展开/收缩 该字段(Ctrl+E). \nCtrl+Click 展开/收缩 包含所有子节点.",
                        formatTitle: "使用适当的缩进和换行符格式化JSON数据 (Ctrl+I)",
                        insert: "插入",
                        insertTitle: "在此字段前插入类型为“auto”的新字段 (Ctrl+Ins)",
                        insertSub: "选择要插入的字段类型",
                        object: "对象",
                        ok: "Ok",
                        redo: "重做 (Ctrl+Shift+Z)",
                        removeText: "移除",
                        removeTitle: "移除选中字段 (Ctrl+Del)",
                        removeField: "移除该字段 (Ctrl+Del)",
                        repairTitle: "修复JSON：修复引号和转义符，删除注释和JSONP表示法，将JavaScript对象转换为JSON。",
                        selectNode: "选择一个节点...",
                        showAll: "展示全部",
                        showMore: "展示更多",
                        showMoreStatus: "显示${totalChilds}的${visibleChilds}项目.",
                        sort: "排序",
                        sortTitle: "排序${type}的子节点",
                        sortTitleShort: "内容排序",
                        sortFieldLabel: "字段：",
                        sortDirectionLabel: "方向：",
                        sortFieldTitle: "选择用于对数组或对象排序的嵌套字段",
                        sortAscending: "升序排序",
                        sortAscendingTitle: "按照该字段升序排序",
                        sortDescending: "降序排序",
                        sortDescendingTitle: "按照该字段降序排序",
                        string: "字符串",
                        transform: "变换",
                        transformTitle: "筛选，排序，或者转换${type}的子节点",
                        transformTitleShort: "筛选，排序，或者转换内容",
                        extract: "提取",
                        extractTitle: "提取这个 ${type}",
                        transformQueryTitle: "输入JMESPath查询",
                        transformWizardLabel: "向导",
                        transformWizardFilter: "筛选",
                        transformWizardSortBy: "排序",
                        transformWizardSelectFields: "选择字段",
                        transformQueryLabel: "查询",
                        transformPreviewLabel: "预览",
                        type: "类型",
                        typeTitle: "更改字段类型",
                        openUrl: "Ctrl+Click 或者 Ctrl+Enter 在新窗口打开链接",
                        undo: "撤销上次动作 (Ctrl+Z)",
                        validationCannotMove: "无法将字段移入其子节点",
                        autoType: '字段类型 "auto". 字段类型由值自动确定 可以为 string，number，boolean，或者 null.',
                        objectType: '字段类型 "object". 对象包含一组无序的键/值对.',
                        arrayType: '字段类型 "array". 数组包含值的有序集合.',
                        stringType: '字段类型 "string". 字段类型由值自动确定，但始终作为字符串返回.',
                        modeCodeText: "代码",
                        modeCodeTitle: "切换至代码高亮",
                        modeFormText: "表单",
                        modeFormTitle: "切换至表单编辑",
                        modeTextText: "文本",
                        modeTextTitle: "切换至文本编辑",
                        modeTreeText: "树",
                        modeTreeTitle: "切换至树编辑",
                        modeViewText: "视图",
                        modeViewTitle: "切换至树视图",
                        modePreviewText: "预览",
                        modePreviewTitle: "切换至预览模式",
                        examples: "例子",
                        "default": "缺省",
                        containsInvalidProperties: "包含无效的属性",
                        containsInvalidItems: "包含无效项目"
                    },
                    "pt-BR": {
                        array: "Lista",
                        auto: "Automatico",
                        appendText: "Adicionar",
                        appendTitle: "Adicionar novo campo com tipo 'auto' depois deste campo (Ctrl+Shift+Ins)",
                        appendSubmenuTitle: "Selecione o tipo do campo a ser adicionado",
                        appendTitleAuto: "Adicionar novo campo com tipo 'auto' (Ctrl+Shift+Ins)",
                        ascending: "Ascendente",
                        ascendingTitle: "Organizar filhor do tipo ${type} em crescente",
                        actionsMenu: "Clique para abrir o menu de a\xe7\xf5es (Ctrl+M)",
                        cannotParseFieldError: "N\xe3o \xe9 poss\xedvel analisar o campo no JSON",
                        cannotParseValueError: "N\xe3o \xe9 poss\xedvel analisar o valor em JSON",
                        collapseAll: "Fechar todos campos",
                        compactTitle: "Dados JSON compactos, remova todos os espa\xe7os em branco (Ctrl+Shift+I)",
                        descending: "Descendente",
                        descendingTitle: "Organizar o filhos do tipo ${type} em decrescente",
                        duplicateKey: "chave duplicada",
                        drag: "Arraste para mover este campo (Alt+Shift+Arrows)",
                        duplicateText: "Duplicar",
                        duplicateTitle: "Duplicar campos selecionados (Ctrl+D)",
                        duplicateField: "Duplicar este campo (Ctrl+D)",
                        duplicateFieldError: "Nome do campo duplicado",
                        empty: "vazio",
                        expandAll: "Expandir todos campos",
                        expandTitle: "Clique para expandir/encolher este campo (Ctrl+E). \nCtrl+Click para expandir/encolher incluindo todos os filhos.",
                        formatTitle: "Formate dados JSON, com recuo e feeds de linha adequados (Ctrl+I)",
                        insert: "Inserir",
                        insertTitle: "Inserir um novo campo do tipo 'auto' antes deste campo (Ctrl+Ins)",
                        insertSub: "Selecionar o tipo de campo a ser inserido",
                        object: "Objeto",
                        ok: "Ok",
                        redo: "Refazer (Ctrl+Shift+Z)",
                        removeText: "Remover",
                        removeTitle: "Remover campos selecionados (Ctrl+Del)",
                        removeField: "Remover este campo (Ctrl+Del)",
                        repairTitle: "Repare JSON: corrija aspas e caracteres de escape, remova coment\xe1rios e nota\xe7\xe3o JSONP, transforme objetos JavaScript em JSON.",
                        selectNode: "Selecione um n\xf3dulo...",
                        showAll: "mostrar todos",
                        showMore: "mostrar mais",
                        showMoreStatus: "exibindo ${visibleChilds} de ${totalChilds} itens.",
                        sort: "Organizar",
                        sortTitle: "Organizar os filhos deste ${type}",
                        sortTitleShort: "Organizar os filhos",
                        sortFieldLabel: "Campo:",
                        sortDirectionLabel: "Dire\xe7\xe3o:",
                        sortFieldTitle: "Selecione um campo filho pelo qual ordenar o array ou objeto",
                        sortAscending: "Ascendente",
                        sortAscendingTitle: "Ordenar o campo selecionado por ordem ascendente",
                        sortDescending: "Descendente",
                        sortDescendingTitle: "Ordenar o campo selecionado por ordem descendente",
                        string: "Texto",
                        transform: "Transformar",
                        transformTitle: "Filtrar, ordenar ou transformar os filhos deste ${type}",
                        transformTitleShort: "Filtrar, ordenar ou transformar conte\xfados",
                        transformQueryTitle: "Insira uma express\xe3o JMESPath",
                        transformWizardLabel: "Assistente",
                        transformWizardFilter: "Filtro",
                        transformWizardSortBy: "Ordenar por",
                        transformWizardSelectFields: "Selecionar campos",
                        transformQueryLabel: "Express\xe3o",
                        transformPreviewLabel: "Visualizar",
                        type: "Tipo",
                        typeTitle: "Mudar o tipo deste campo",
                        openUrl: "Ctrl+Click ou Ctrl+Enter para abrir link em nova janela",
                        undo: "Desfazer \xfaltimo a\xe7\xe3o (Ctrl+Z)",
                        validationCannotMove: "N\xe3o pode mover um campo como filho dele mesmo",
                        autoType: 'Campo do tipo "auto". O tipo do campo \xe9 determinao automaticamente a partir do seu valor e pode ser texto, n\xfamero, verdade/falso ou nulo.',
                        objectType: 'Campo do tipo "objeto". Um objeto cont\xe9m uma lista de pares com chave e valor.',
                        arrayType: 'Campo do tipo "lista". Uma lista contem uma cole\xe7\xe3o de valores ordenados.',
                        stringType: 'Campo do tipo "string". Campo do tipo nao \xe9 determinado atrav\xe9s do seu valor, mas sempre retornara um texto.',
                        examples: "Exemplos",
                        "default": "Revelia",
                        containsInvalidProperties: "Cont\xe9m propriedades inv\xe1lidas",
                        containsInvalidItems: "Cont\xe9m itens inv\xe1lidos"
                    },
                    tr: {
                        array: "Dizin",
                        auto: "Otomatik",
                        appendText: "Ekle",
                        appendTitle: "Bu alanın altına 'otomatik' tipinde yeni bir alan ekle (Ctrl+Shift+Ins)",
                        appendSubmenuTitle: "Eklenecek alanın tipini se\xe7",
                        appendTitleAuto: "'Otomatik' tipinde yeni bir alan ekle (Ctrl+Shift+Ins)",
                        ascending: "Artan",
                        ascendingTitle: "${type}'ın alt tiplerini artan d\xfczende sırala",
                        actionsMenu: "Aksiyon men\xfcs\xfcn\xfc a\xe7mak i\xe7in tıklayın (Ctrl+M)",
                        collapseAll: "T\xfcm alanları kapat",
                        descending: "Azalan",
                        descendingTitle: "${type}'ın alt tiplerini azalan d\xfczende sırala",
                        drag: "Bu alanı taşımak i\xe7in s\xfcr\xfckleyin (Alt+Shift+Arrows)",
                        duplicateKey: "Var olan anahtar",
                        duplicateText: "Aşağıya kopyala",
                        duplicateTitle: "Se\xe7ili alanlardan bir daha oluştur (Ctrl+D)",
                        duplicateField: "Bu alandan bir daha oluştur (Ctrl+D)",
                        duplicateFieldError: "Duplicate field name",
                        cannotParseFieldError: "Alan JSON'a ayrıştırılamıyor",
                        cannotParseValueError: "JSON'a değer ayrıştırılamıyor",
                        empty: "boş",
                        expandAll: "T\xfcm alanları a\xe7",
                        expandTitle: "Bu alanı a\xe7mak/kapatmak i\xe7in tıkla (Ctrl+E). \nAlt alanlarda dahil t\xfcm alanları a\xe7mak i\xe7in Ctrl+Click ",
                        insert: "Ekle",
                        insertTitle: "Bu alanın \xfcst\xfcne 'otomatik' tipinde yeni bir alan ekle (Ctrl+Ins)",
                        insertSub: "Araya eklenecek alanın tipini se\xe7",
                        object: "Nesne",
                        ok: "Tamam",
                        redo: "Yeniden yap (Ctrl+Shift+Z)",
                        removeText: "Kaldır",
                        removeTitle: "Se\xe7ilen alanları kaldır (Ctrl+Del)",
                        removeField: "Bu alanı kaldır (Ctrl+Del)",
                        selectNode: "Bir nesne se\xe7...",
                        showAll: "t\xfcm\xfcn\xfc g\xf6ster",
                        showMore: "daha fazla g\xf6ster",
                        showMoreStatus: "${totalChilds} alanın ${visibleChilds} alt alanları g\xf6steriliyor",
                        sort: "Sırala",
                        sortTitle: "${type}'ın alt alanlarını sırala",
                        sortTitleShort: "İ\xe7erikleri sırala",
                        sortFieldLabel: "Alan:",
                        sortDirectionLabel: "Y\xf6n:",
                        sortFieldTitle: "Diziyi veya nesneyi sıralamak i\xe7in i\xe7 i\xe7e ge\xe7miş alanı se\xe7in",
                        sortAscending: "Artan",
                        sortAscendingTitle: "Se\xe7ili alanı artan d\xfczende sırala",
                        sortDescending: "Azalan",
                        sortDescendingTitle: "Se\xe7ili alanı azalan d\xfczende sırala",
                        string: "Karakter Dizisi",
                        transform: "D\xf6n\xfcşt\xfcr",
                        transformTitle: "${type}'ın alt alanlarını filtrele, sırala veya d\xf6n\xfcşt\xfcr",
                        transformTitleShort: "İ\xe7erikleri filterele, sırala veya d\xf6n\xfcşt\xfcr",
                        transformQueryTitle: "JMESPath sorgusu gir",
                        transformWizardLabel: "Sihirbaz",
                        transformWizardFilter: "Filtre",
                        transformWizardSortBy: "Sırala",
                        transformWizardSelectFields: "Alanları se\xe7",
                        transformQueryLabel: "Sorgu",
                        transformPreviewLabel: "\xd6nizleme",
                        type: "Tip",
                        typeTitle: "Bu alanın tipini değiştir",
                        openUrl: "URL'i yeni bir pencerede a\xe7mak i\xe7in Ctrl+Click veya Ctrl+Enter",
                        undo: "Son değişikliği geri al (Ctrl+Z)",
                        validationCannotMove: "Alt alan olarak taşınamıyor",
                        autoType: 'Alan tipi "otomatik". Alan t\xfcr\xfc otomatik olarak değerden belirlenirve bir dize, sayı, boolean veya null olabilir.',
                        objectType: 'Alan tipi "nesne". Bir nesne, sıralanmamış bir anahtar / değer \xe7ifti k\xfcmesi i\xe7erir.',
                        arrayType: 'Alan tipi "dizi". Bir dizi, d\xfczenli değerler koleksiyonu i\xe7erir.',
                        stringType: 'Alan tipi "karakter dizisi". Alan t\xfcr\xfc değerden belirlenmez,ancak her zaman karakter dizisi olarak d\xf6nd\xfcr\xfcl\xfcr.',
                        modeCodeText: "Kod",
                        modeCodeTitle: "Kod vurgulayıcıya ge\xe7",
                        modeFormText: "Form",
                        modeFormTitle: "Form d\xfczenleyiciye ge\xe7",
                        modeTextText: "Metin",
                        modeTextTitle: "D\xfcz metin d\xfczenleyiciye ge\xe7",
                        modeTreeText: "Ağa\xe7",
                        modeTreeTitle: "Ağa\xe7 d\xfczenleyiciye ge\xe7",
                        modeViewText: "G\xf6r\xfcn\xfcm",
                        modeViewTitle: "Ağa\xe7 g\xf6r\xfcn\xfcm\xfcne ge\xe7",
                        examples: "\xd6rnekler",
                        "default": "Varsayılan",
                        containsInvalidProperties: "Ge\xe7ersiz \xf6zellikler i\xe7eriyor",
                        containsInvalidItems: "Ge\xe7ersiz \xf6ğeler i\xe7eriyor"
                    },
                    ja: {
                        array: "配列",
                        auto: "オート",
                        appendText: "追加",
                        appendTitle: '次のフィールドに"オート"のフィールドを追加 (Ctrl+Shift+Ins)',
                        appendSubmenuTitle: "追加するフィールドの型を選択してください",
                        appendTitleAuto: '"オート"のフィールドを追加 (Ctrl+Shift+Ins)',
                        ascending: "昇順",
                        ascendingTitle: "${type}の子要素を昇順に並べ替え",
                        actionsMenu: "クリックしてアクションメニューを開く (Ctrl+M)",
                        collapseAll: "すべてを折りたたむ",
                        descending: "降順",
                        descendingTitle: "${type}の子要素を降順に並べ替え",
                        drag: "ドラッグして選択中のフィールドを移動 (Alt+Shift+Arrows)",
                        duplicateKey: "複製キー",
                        duplicateText: "複製",
                        duplicateTitle: "選択中のフィールドを複製 (Ctrl+D)",
                        duplicateField: "選択中のフィールドを複製 (Ctrl+D)",
                        duplicateFieldError: "フィールド名が重複しています",
                        cannotParseFieldError: "JSONのフィールドを解析できません",
                        cannotParseValueError: "JSONの値を解析できません",
                        empty: "空",
                        expandAll: "すべてを展開",
                        expandTitle: "クリックしてフィールドを展開/折りたたむ (Ctrl+E). \nCtrl+Click ですべての子要素を展開/折りたたむ",
                        insert: "挿入",
                        insertTitle: "選択中のフィールドの前に新しいフィールドを挿入 (Ctrl+Ins)",
                        insertSub: "挿入するフィールドの型を選択",
                        object: "オブジェクト",
                        ok: "実行",
                        redo: "やり直す (Ctrl+Shift+Z)",
                        removeText: "削除",
                        removeTitle: "選択中のフィールドを削除 (Ctrl+Del)",
                        removeField: "選択中のフィールドを削除 (Ctrl+Del)",
                        selectNode: "ノードを選択...",
                        showAll: "すべてを表示",
                        showMore: "もっと見る",
                        showMoreStatus: "${totalChilds}個のアイテムのうち ${visibleChilds}個を表示しています。",
                        sort: "並べ替え",
                        sortTitle: "${type}の子要素を並べ替え",
                        sortTitleShort: "並べ替え",
                        sortFieldLabel: "フィールド:",
                        sortDirectionLabel: "順序:",
                        sortFieldTitle: "配列またはオブジェクトを並び替えるためのフィールドを選択",
                        sortAscending: "昇順",
                        sortAscendingTitle: "選択中のフィールドを昇順に並び替え",
                        sortDescending: "降順",
                        sortDescendingTitle: "選択中のフィールドを降順に並び替え",
                        string: "文字列",
                        transform: "変換",
                        transformTitle: "${type}の子要素をフィルター・並び替え・変換する",
                        transformTitleShort: "内容をフィルター・並び替え・変換する",
                        extract: "抽出",
                        extractTitle: "${type}を抽出",
                        transformQueryTitle: "JMESPathクエリを入力",
                        transformWizardLabel: "ウィザード",
                        transformWizardFilter: "フィルター",
                        transformWizardSortBy: "並び替え",
                        transformWizardSelectFields: "フィールドを選択",
                        transformQueryLabel: "クエリ",
                        transformPreviewLabel: "プレビュー",
                        type: "型",
                        typeTitle: "選択中のフィールドの型を変更",
                        openUrl: "Ctrl+Click または Ctrl+Enter で 新規ウィンドウでURLを開く",
                        undo: "元に戻す (Ctrl+Z)",
                        validationCannotMove: "子要素に移動できません ",
                        autoType: "オート： フィールドの型は値から自動的に決定されます。 (文字列・数値・ブール・null)",
                        objectType: "オブジェクト： オブジェクトは順序が決まっていないキーと値のペア組み合わせです。",
                        arrayType: "配列： 配列は順序が決まっている値の集合体です。",
                        stringType: "文字列： フィールド型は値から決定されませんが、常に文字列として返されます。",
                        modeCodeText: "コードモード",
                        modeCodeTitle: "ハイライトモードに切り替え",
                        modeFormText: "フォームモード",
                        modeFormTitle: "フォームモードに切り替え",
                        modeTextText: "テキストモード",
                        modeTextTitle: "テキストモードに切り替え",
                        modeTreeText: "ツリーモード",
                        modeTreeTitle: "ツリーモードに切り替え",
                        modeViewText: "ビューモード",
                        modeViewTitle: "ビューモードに切り替え",
                        modePreviewText: "プレビュー",
                        modePreviewTitle: "プレビューに切り替え",
                        examples: "例",
                        "default": "デフォルト",
                        containsInvalidProperties: "無効なプロパティが含まれています",
                        containsInvalidItems: "無効なアイテムが含まれています"
                    },
                    "fr-FR": {
                        array: "Liste",
                        auto: "Auto",
                        appendText: "Ajouter",
                        appendTitle: "Ajouter un champ de type 'auto' apr\xe8s ce champ (Ctrl+Shift+Ins)",
                        appendSubmenuTitle: "S\xe9lectionner le type du champ \xe0 ajouter",
                        appendTitleAuto: "Ajouter un champ de type 'auto' (Ctrl+Shift+Ins)",
                        ascending: "Ascendant",
                        ascendingTitle: "Trier les enfants de ce ${type} par ordre ascendant",
                        actionsMenu: "Ouvrir le menu des actions (Ctrl+M)",
                        collapseAll: "Regrouper",
                        descending: "Descendant",
                        descendingTitle: "Trier les enfants de ce ${type} par ordre descendant",
                        drag: "D\xe9placer (Alt+Shift+Arrows)",
                        duplicateKey: "Dupliquer la cl\xe9",
                        duplicateText: "Dupliquer",
                        duplicateTitle: "Dupliquer les champs s\xe9lectionn\xe9s (Ctrl+D)",
                        duplicateField: "Dupliquer ce champ (Ctrl+D)",
                        duplicateFieldError: "Dupliquer le nom de champ",
                        cannotParseFieldError: "Champ impossible \xe0 parser en JSON",
                        cannotParseValueError: "Valeur impossible \xe0 parser en JSON",
                        empty: "vide",
                        expandAll: "\xc9tendre",
                        expandTitle: "\xc9tendre/regrouper ce champ (Ctrl+E). \nCtrl+Click pour \xe9tendre/regrouper avec tous les champs.",
                        insert: "Ins\xe9rer",
                        insertTitle: "Ins\xe9rer un champ de type 'auto' avant ce champ (Ctrl+Ins)",
                        insertSub: "S\xe9lectionner le type de champ \xe0 ins\xe9rer",
                        object: "Objet",
                        ok: "Ok",
                        redo: "Rejouer (Ctrl+Shift+Z)",
                        removeText: "Supprimer",
                        removeTitle: "Supprimer les champs s\xe9lectionn\xe9s (Ctrl+Del)",
                        removeField: "Supprimer ce champ (Ctrl+Del)",
                        searchTitle: "Rechercher champs et valeurs",
                        searchNextResultTitle: "R\xe9sultat suivant (Enter)",
                        searchPreviousResultTitle: "R\xe9sultat pr\xe9c\xe9dent (Shift + Enter)",
                        selectNode: "S\xe9lectionner un nœud...",
                        showAll: "voir tout",
                        showMore: "voir plus",
                        showMoreStatus: "${visibleChilds} \xe9l\xe9ments affich\xe9s de ${totalChilds}.",
                        sort: "Trier",
                        sortTitle: "Trier les champs de ce ${type}",
                        sortTitleShort: "Trier",
                        sortFieldLabel: "Champ:",
                        sortDirectionLabel: "Direction:",
                        sortFieldTitle: "S\xe9lectionner les champs permettant de trier les listes et objet",
                        sortAscending: "Ascendant",
                        sortAscendingTitle: "Trier les champs s\xe9lectionn\xe9s par ordre ascendant",
                        sortDescending: "Descendant",
                        sortDescendingTitle: "Trier les champs s\xe9lectionn\xe9s par ordre descendant",
                        string: "Cha\xeene",
                        transform: "Transformer",
                        transformTitle: "Filtrer, trier, or transformer les enfants de ce ${type}",
                        transformTitleShort: "Filtrer, trier ou transformer le contenu",
                        extract: "Extraire",
                        extractTitle: "Extraire ce ${type}",
                        transformQueryTitle: "Saisir une requ\xeate JMESPath",
                        transformWizardLabel: "Assistant",
                        transformWizardFilter: "Filtrer",
                        transformWizardSortBy: "Trier par",
                        transformWizardSelectFields: "S\xe9lectionner les champs",
                        transformQueryLabel: "Requ\xeate",
                        transformPreviewLabel: "Pr\xe9visualisation",
                        type: "Type",
                        typeTitle: "Changer le type de ce champ",
                        openUrl: "Ctrl+Click ou Ctrl+Enter pour ouvrir l'url dans une autre fen\xeatre",
                        undo: "Annuler la derni\xe8re action (Ctrl+Z)",
                        validationCannotMove: "Cannot move a field into a child of itself",
                        autoType: 'Champe de type "auto". Ce type de champ est automatiquement d\xe9termin\xe9 en fonction de la valeur et peut \xeatre de type "cha\xeene", "nombre", "bool\xe9en" ou null.',
                        objectType: 'Champ de type "objet". Un objet contient un ensemble non ordonn\xe9 de paires cl\xe9/valeur.',
                        arrayType: 'Champ de type "liste". Une liste contient une collection ordonn\xe9e de valeurs.',
                        stringType: 'Champ de type "cha\xeene". Ce type de champ n\'est pas d\xe9termin\xe9 en fonction de la valeur, mais retourne syst\xe9matiquement une cha\xeene de caract\xe8res.',
                        modeEditorTitle: "Changer mode d'\xe9dition",
                        modeCodeText: "Code",
                        modeCodeTitle: "Activer surlignage code",
                        modeFormText: "Formulaire",
                        modeFormTitle: "Activer formulaire",
                        modeTextText: "Texte",
                        modeTextTitle: "Activer \xe9diteur texte",
                        modeTreeText: "Arbre",
                        modeTreeTitle: "Activer \xe9diteur arbre",
                        modeViewText: "Lecture seule",
                        modeViewTitle: "Activer vue arbre",
                        modePreviewText: "Pr\xe9visualisation",
                        modePreviewTitle: "Activer mode pr\xe9visualiser",
                        examples: "Exemples",
                        "default": "D\xe9faut",
                        containsInvalidProperties: "Contient des propri\xe9t\xe9s non valides",
                        containsInvalidItems: "Contient des \xe9l\xe9ments invalides"
                    },
                    de: {
                        array: "Auflistung",
                        auto: "Auto",
                        appendText: "anh\xe4ngen",
                        appendTitle: "F\xfcgen Sie nach diesem Feld ein neues Feld mit dem Typ 'auto' ein (Strg+Umschalt+Ein)",
                        appendSubmenuTitle: "W\xe4hlen Sie den Typ des neuen Feldes",
                        appendTitleAuto: "Ein neues Feld vom Typ 'auto' hinzuf\xfcgen (Strg+Umschalt+Ein)",
                        ascending: "Aufsteigend",
                        ascendingTitle: "Sortieren Sie die Elemente dieses ${type} in aufsteigender Reihenfolge",
                        actionsMenu: "Klicken Sie zum \xd6ffnen des Aktionsmen\xfcs (Strg+M)",
                        cannotParseFieldError: "Feld kann nicht in JSON geparst werden",
                        cannotParseValueError: "Wert kann nicht in JSON geparst werden",
                        collapseAll: "Alle Felder zuklappen",
                        compactTitle: "JSON-Daten verdichten, alle Leerzeichen entfernen (Strg+Umschalt+\\)",
                        descending: "Absteigend",
                        descendingTitle: "Sortieren Sie die Elemente dieses ${type} in absteigender Reihenfolge",
                        drag: "Ziehen, um dieses Feld zu verschieben (Alt+Umschalt+Pfeile)",
                        duplicateKey: "Doppelter Schl\xfcssel",
                        duplicateText: "Duplikat",
                        duplicateTitle: "Ausgew\xe4hlte Felder duplizieren (Strg+D)",
                        duplicateField: "Dieses Feld duplizieren (Strg+D)",
                        duplicateFieldError: "Doppelter Feldname",
                        empty: "leer",
                        expandAll: "Alle Felder anzeigen",
                        expandTitle: "Klicken Sie, um dieses Feld zu erweitern/zu kollabieren (Strg+E). \nStrg+Klicken Sie, um dieses Feld einschlie\xdflich aller Elemente zu erweitern/zu kollabieren.",
                        formatTitle: "JSON-Daten mit korrekter Einr\xfcckung und Zeilenvorsch\xfcben formatieren (Strg+\\)",
                        insert: "einf\xfcgen",
                        insertTitle: "F\xfcgen Sie vor diesem Feld ein neues Feld mit dem Typ 'auto' ein (Strg+Einfg)",
                        insertSub: "W\xe4hlen Sie den Typ des neuen Feldes",
                        object: "Objekt",
                        ok: "Ok",
                        redo: "Wiederholen (Strg+Umschalt+Z)",
                        removeText: "entfernen",
                        removeTitle: "Ausgew\xe4hlte Felder entfernen (Strg+Entf)",
                        removeField: "Dieses Feld entfernen (Strg+Entf)",
                        repairTitle: "JSON reparieren: Anf\xfchrungszeichen und Escape-Zeichen korrigieren, Kommentare und JSONP-Notation entfernen, JavaScript-Objekte in JSON umwandeln.",
                        searchTitle: "Suchfelder und Werte",
                        searchNextResultTitle: "N\xe4chstes Ergebnis (Enter)",
                        searchPreviousResultTitle: "Vorheriges Ergebnis (Umschalt + Eingabe)",
                        selectNode: "W\xe4hlen Sie einen Knoten aus...",
                        showAll: "alle anzeigen",
                        showMore: "mehr anzeigen",
                        showMoreStatus: "Anzeige von ${visibleChilds} von ${totalChilds}-Elementen.",
                        sort: "Sortieren",
                        sortTitle: "Sortieren Sie die Elemente dieses ${type}",
                        sortTitleShort: "Inhalt sortieren",
                        sortFieldLabel: "Feld:",
                        sortDirectionLabel: "Richtung:",
                        sortFieldTitle: "W\xe4hlen Sie das verschachtelte Feld, nach dem das Array oder Objekt sortiert werden soll.",
                        sortAscending: "Aufsteigend",
                        sortAscendingTitle: "Sortieren Sie das ausgew\xe4hlte Feld in aufsteigender Reihenfolge",
                        sortDescending: "Absteigend",
                        sortDescendingTitle: "Sortieren Sie das ausgew\xe4hlte Feld in absteigender Reihenfolge",
                        string: "Zeichenfolge",
                        transform: "Verwandeln",
                        transformTitle: "Die Elemente dieses ${type} filtern, sortieren oder transformieren",
                        transformTitleShort: "Inhalte filtern, sortieren oder transformieren",
                        extract: "Auszug",
                        extractTitle: "Extrahieren Sie diesen ${type}",
                        transformQueryTitle: "Eine JMESPath-Abfrage eingeben",
                        transformWizardLabel: "Zauberer",
                        transformWizardFilter: "Filter",
                        transformWizardSortBy: "Sortieren nach",
                        transformWizardSelectFields: "Felder ausw\xe4hlen",
                        transformQueryLabel: "Anfrage",
                        transformPreviewLabel: "Vorschau",
                        type: "Geben Sie  ein.",
                        typeTitle: "\xc4ndern Sie den Typ dieses Feldes",
                        openUrl: "Strg+Klicken oder Strg+Eingabe, um die URL in einem neuen Fenster zu \xf6ffnen",
                        undo: "Letzte Aktion r\xfcckg\xe4ngig machen (Strg+Z)",
                        validationCannotMove: "Kann ein Feld nicht in ein Kind seiner selbst verschieben",
                        autoType: 'Feldtyp "auto". Der Feldtyp wird automatisch aus dem Wert bestimmt und kann ein String, eine Zahl, boolesch oder null sein.',
                        objectType: 'Feldtyp "Objekt". Ein Objekt enth\xe4lt eine ungeordnete Menge von Schl\xfcssel/Wert-Paaren.',
                        arrayType: 'Feldtyp "Array". Ein Array enth\xe4lt eine geordnete Sammlung von Werten.',
                        stringType: 'Feldtyp "Zeichenfolge". Der Feldtyp wird nicht aus dem Wert bestimmt, sondern immer als Zeichenfolge zur\xfcckgegeben.',
                        modeEditorTitle: "Editor-Modus umschalten",
                        modeCodeText: "Code",
                        modeCodeTitle: "Umschalten auf Code-Highlighter",
                        modeFormText: "Formular",
                        modeFormTitle: "Zum Formular-Editor wechseln",
                        modeTextText: "Text",
                        modeTextTitle: "Zum Editor f\xfcr einfachen Text wechseln",
                        modeTreeText: "Baum",
                        modeTreeTitle: "Zum Baum-Editor wechseln",
                        modeViewText: "Siehe",
                        modeViewTitle: "Zur Baumansicht wechseln",
                        modePreviewText: "Vorschau",
                        modePreviewTitle: "In den Vorschau-Modus wechseln",
                        examples: "Beispiele",
                        "default": "Standardm\xe4\xdfig",
                        containsInvalidProperties: "Enth\xe4lt ung\xfcltige Eigenschaften",
                        containsInvalidItems: "Enth\xe4lt ung\xfcltige Elemente"
                    },
                    ru: {
                        array: "Массив",
                        auto: "Авто",
                        appendText: "Добавить",
                        appendTitle: "Добавить новое поле с типом 'авто' после этого поля (Ctrl+Shift+Ins)",
                        appendSubmenuTitle: "Выбрать тип поля для добавления",
                        appendTitleAuto: "Добавить новое поле с типом 'авто' (Ctrl+Shift+Ins)",
                        ascending: "По возрастанию",
                        ascendingTitle: "Сортировать ${type} по возрастанию",
                        actionsMenu: "Нажмите для открытия меню действий (Ctrl+M)",
                        cannotParseFieldError: "Невозможно преобразовать поле в JSON",
                        cannotParseValueError: "Невозможно преобразовать значение в JSON",
                        collapseAll: "Свернуть все",
                        compactTitle: "Минификация JSON (Ctrl+Shift+I)",
                        descending: "По убыванию",
                        descendingTitle: "Сортировать ${type} по убыванию",
                        drag: "Потяните для перемещения этого поля (Alt+Shift+Arrows)",
                        duplicateKey: "повторяющийся ключ",
                        duplicateText: "Дублировать",
                        duplicateTitle: "Дублирование полей (Ctrl+D)",
                        duplicateField: "Дублировать поле (Ctrl+D)",
                        duplicateFieldError: "Дублирование названия поля",
                        empty: "пустой",
                        expandAll: "Развернуть все",
                        expandTitle: "Нажмите для раскрытия/скрытия поля (Ctrl+E)\nили Ctrl+Click для раскрытия/скрытия всех потомков.",
                        formatTitle: "Форматирование JSON (Ctrl+I)",
                        insert: "Вставить",
                        insertTitle: "Вставить новое поле с типом 'авто' перед этим полем (Ctrl+Ins)",
                        insertSub: "Выбрать тип поля для вставки",
                        object: "Объект",
                        ok: "ОК",
                        redo: "Повторить (Ctrl+Shift+Z)",
                        removeText: "Удалить",
                        removeTitle: "Удалить выбранные поля (Ctrl+Del)",
                        removeField: "Удалить поле (Ctrl+Del)",
                        repairTitle: "Восстановите JSON: исправьте кавычки и escape-символы, удалите комментарии и нотацию JSONP, модифицируйте объекты JavaScript в JSON.",
                        searchTitle: "Поиск",
                        searchNextResultTitle: "Следующий результат (Enter)",
                        searchPreviousResultTitle: "Предыдущий результат (Shift + Enter)",
                        selectNode: "Выбор узла...",
                        showAll: "показать все",
                        showMore: "больше",
                        showMoreStatus: "${visibleChilds} из ${totalChilds}",
                        sort: "Сортировка",
                        sortTitle: "Сортировка потомков типа ${type}",
                        sortTitleShort: "Сортировка содержимого",
                        sortFieldLabel: "Поле:",
                        sortDirectionLabel: "Направление:",
                        sortFieldTitle: "Выберите поле для сортировки массива или объекта",
                        sortAscending: "По возрастанию",
                        sortAscendingTitle: "Сортировка выбранного поря по возрастанию",
                        sortDescending: "По убыванию",
                        sortDescendingTitle: "Сортировка выбранного поря по убыванию",
                        string: "Строка",
                        transform: "Модификация",
                        transformTitle: "Фильтрация, сортировка или модификация данных типа ${type}",
                        transformTitleShort: "Фильтрация, сортировка или модификация данных",
                        extract: "Извлечение",
                        extractTitle: "Извлечь тип ${type}",
                        transformQueryTitle: "Введите JMESpath запрос",
                        transformWizardLabel: "Мастер",
                        transformWizardFilter: "Фильтр",
                        transformWizardSortBy: "Сортировка",
                        transformWizardSelectFields: "Поля",
                        transformQueryLabel: "Запрос",
                        transformPreviewLabel: "Просмотр",
                        type: "Тип",
                        typeTitle: "Изменить тип этого поля",
                        openUrl: "Ctrl+Click или Ctrl+Enter для открытия url в новом окне",
                        undo: "Отменить (Ctrl+Z)",
                        validationCannotMove: "Поле не может быть перемещено в потомка",
                        autoType: "Тип поля автоматически определяется по значению и может быть строкой, числом, логическим значением или null.",
                        objectType: "Объект содержит неупорядоченный набор пар ключ/значение.",
                        arrayType: "Массив содержит упорядоченный набор значений.",
                        stringType: "Тип поля не определяется из значения, но всегда возвращается как строка.",
                        modeEditorTitle: "Переключение режима редактора",
                        modeCodeText: "Код",
                        modeCodeTitle: "Переключить в режим редактора кода",
                        modeFormText: "Форма",
                        modeFormTitle: "Переключить в режим формы",
                        modeTextText: "Текст",
                        modeTextTitle: "Переключить в режим редактора текста",
                        modeTreeText: "Дерево",
                        modeTreeTitle: "Переключить в режим редактора дерева",
                        modeViewText: "Просмотр дерева",
                        modeViewTitle: "Переключить в режим просмотра дерева",
                        modePreviewText: "Просмотр",
                        modePreviewTitle: "Переключить в режим просмотра",
                        examples: "Примеры",
                        "default": "По умолчанию",
                        containsInvalidProperties: "Содержит недопустимые свойства",
                        containsInvalidItems: "Содержит недопустимые элементы"
                    },
                    ko: {
                        array: "배열",
                        auto: "자동",
                        appendText: "추가",
                        appendTitle: '선택한 요소 아래에 "자동" 요소를 추가합니다. (Ctrl + Shift + Ins)',
                        appendSubmenuTitle: "추가할 요소의 유형을 선택해주세요.",
                        appendTitleAuto: '"자동" 요소를 추가합니다. (Ctrl + Shift + Ins)',
                        ascending: "오름차순",
                        ascendingTitle: "선택한 ${type}의 하위 요소를 오름차순 정렬합니다.",
                        actionsMenu: "메뉴 열기 (Ctrl + M)",
                        cannotParseFieldError: "JSON의 요소를 해석할 수 없습니다.",
                        cannotParseValueError: "JSON의 값을 해석할 수 없습니다.",
                        collapseAll: "모두 접기",
                        compactTitle: "모든 공백을 제거하여 JSON 데이터를 작게 만듭니다. (Ctrl + Shift + I)",
                        descending: "내림차순",
                        descendingTitle: "선택한 ${type}의 하위 요소를 내림차순으로 정렬",
                        drag: "드래그하여 요소를 이동합니다. (Alt + Shift + Arrows)",
                        duplicateKey: "복제키",
                        duplicateText: "복제",
                        duplicateTitle: "선택한 요소를 복제합니다. (Ctrl + D)",
                        duplicateField: "선택한 요소를 복제합니다. (Ctrl + D)",
                        duplicateFieldError: "요소 이름이 중복되었습니다.",
                        empty: "비어있음",
                        expandAll: "모두 열기",
                        expandTitle: "클릭하여 요소를 열거나 닫습니다. (Ctrl + E) \nCtrl + Click으로 모든 하위 요소를 열거나 닫습니다.",
                        formatTitle: "적절한 들여쓰기 및 줄바꿈으로 JSON 데이터를 정형화합니다. (Ctrl + I)",
                        insert: "삽입",
                        insertTitle: "선택한 요소 위에 새요소를 삽입합니다. (Ctrl + Ins)",
                        insertSub: "삽입할 요소의 유형을 선택해주세요.",
                        object: "객체",
                        ok: "확인",
                        redo: "다시 실행 (Ctrl + Shift + Z)",
                        removeText: "삭제",
                        removeTitle: "선택한 요소를 삭제합니다. (Ctrl + Del)",
                        removeField: "선택한 요소를 삭제합니다. (Ctrl + Del)",
                        repairTitle: "JSON 교정: JSON 내의 주석과 JSONP 표기법을 지우고 따옴표와 이스케이프 문자를 수정합니다.",
                        searchTitle: "요소 또는 값 찾기",
                        searchNextResultTitle: "다음으로 찾기 (Enter)",
                        searchPreviousResultTitle: "이전으로 찾기 (Shift + Enter)",
                        selectNode: "요소를 선택해주세요...",
                        showAll: "모두보기",
                        showMore: "더보기",
                        showMoreStatus: "${totalChilds} 개의 항목 중 ${visibleChilds} 개를 표시합니다.",
                        sort: "정렬",
                        sortTitle: "선택한 ${type}의 하위 요소를 정렬합니다.",
                        sortTitleShort: "정렬",
                        sortFieldLabel: "요소:",
                        sortDirectionLabel: "순서:",
                        sortFieldTitle: "배열이나 객체를 정렬하는 요소를 선택해주세요.",
                        sortAscending: "오름차순",
                        sortAscendingTitle: "선택한 요소를 오름차순으로 정렬합니다.",
                        sortDescending: "내림차순",
                        sortDescendingTitle: "선택한 요소를 내림차순으로 정렬합니다.",
                        string: "문자",
                        transform: "변환",
                        transformTitle: "선택한 ${type}의 하위 요소를 필터하거나 정렬 또는 변환합니다.",
                        transformTitleShort: "내용을 필터하거나 정렬 또는 변환합니다.",
                        extract: "추출",
                        extractTitle: "선택한 ${type}의 값을 최상위에 위치시킵니다.",
                        transformQueryTitle: "JMESPath 쿼리를 입력해주세요.",
                        transformWizardLabel: "마법사",
                        transformWizardFilter: "필터",
                        transformWizardSortBy: "정렬",
                        transformWizardSelectFields: "요소를 선택해주세요.",
                        transformQueryLabel: "쿼리",
                        transformPreviewLabel: "미리보기",
                        type: "유형",
                        typeTitle: "선택한 요소의 유형을 변경합니다.",
                        openUrl: "Ctrl + Click 또는 Ctrl + Enter로 새 창에서 URL 열기",
                        undo: "실행 취소 (Ctrl + Z)",
                        validationCannotMove: "하위 요소로 이동할 수 없습니다.",
                        autoType: "자동: 요소의 형식이 값의 유형으로 결정됩니다. 문자, 숫자, 부울, 또는 null만 허용됩니다.",
                        objectType: "객체: 순서대로 나열되지 않은 이름/값 쌍으로 이루어진 집합입니다.",
                        arrayType: "배열: 순서대로 나열된 값의 집합입니다.",
                        stringType: "문자: 요소의 유형이 값에서 결정되지 않지만 항상 문자로 반환됩니다.",
                        modeEditorTitle: "편집기 유형 변경",
                        modeCodeText: "코드",
                        modeCodeTitle: "형식 교정을 도와주는 기능이 포함된 문자 편집기",
                        modeFormText: "입력 양식",
                        modeFormTitle: "정해진 요소에 값을 입력하는 편집기",
                        modeTextText: "문자",
                        modeTextTitle: "단순 문자 편집기",
                        modeTreeText: "트리",
                        modeTreeTitle: "트리 구조로 표시되는 편집기",
                        modeViewText: "보기",
                        modeViewTitle: "읽기전용 트리 구조로 JSON을 표시",
                        modePreviewText: "미리보기",
                        modePreviewTitle: "읽기전용 문자로 JSON을 표시",
                        examples: "예제",
                        "default": "기본값",
                        containsInvalidProperties: "잘못된 속성이 포함되어 있습니다.",
                        containsInvalidItems: "잘못된 항목이 포함되어 있습니다"
                    }
                };
                var _locales = Object.keys(_defs);
                var _defaultLang = "en";
                var userLang = typeof navigator !== "undefined" ? navigator.language || navigator.userLanguage : undefined;
                var _lang = _locales.find(function(l) {
                    return l === userLang;
                }) || _defaultLang;
                function setLanguage(lang) {
                    if (!lang) return;
                    var langFound = _locales.find(function(l) {
                        return l === lang;
                    });
                    if (langFound) _lang = langFound;
                    else console.error("Language not found");
                }
                function setLanguages(languages) {
                    if (!languages) return;
                    var _loop = function _loop(language) {
                        var langFound = _locales.find(function(l) {
                            return l === language;
                        });
                        if (!langFound) _locales.push(language);
                        _defs[language] = Object.assign({}, _defs[_defaultLang], _defs[language], languages[language]);
                    };
                    for(var language in languages)_loop(language);
                }
                function translate(key, data, lang) {
                    if (!lang) lang = _lang;
                    var text = _defs[lang][key] || _defs[_defaultLang][key] || key;
                    if (data) for(var dataKey in data)text = text.replace("${" + dataKey + "}", data[dataKey]);
                    return text;
                }
            /***/ },
            /***/ 56: /***/ function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {
                "use strict";
                /* harmony export */ __webpack_require__.d(__webpack_exports__, {
                    /* harmony export */ "J": function() {
                        return /* binding */ executeQuery;
                    },
                    /* harmony export */ "r": function() {
                        return /* binding */ createQuery;
                    }
                });
                /* harmony import */ var jmespath__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(156);
                /* harmony import */ var jmespath__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/ __webpack_require__.n(jmespath__WEBPACK_IMPORTED_MODULE_0__);
                /* harmony import */ var _util__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(791);
                /**
 * Build a JMESPath query based on query options coming from the wizard
 * @param {JSON} json   The JSON document for which to build the query.
 *                      Used for context information like determining
 *                      the type of values (string or number)
 * @param {QueryOptions} queryOptions
 * @return {string} Returns a query (as string)
 */ function createQuery(json, queryOptions) {
                    var sort = queryOptions.sort, filter = queryOptions.filter, projection = queryOptions.projection;
                    var query = "";
                    if (filter) {
                        var examplePath = filter.field !== "@" ? [
                            "0"
                        ].concat((0, _util__WEBPACK_IMPORTED_MODULE_1__.parsePath)("." + filter.field)) : [
                            "0"
                        ];
                        var exampleValue = (0, _util__WEBPACK_IMPORTED_MODULE_1__.get)(json, examplePath);
                        var value1 = typeof exampleValue === "string" ? filter.value : (0, _util__WEBPACK_IMPORTED_MODULE_1__.parseString)(filter.value);
                        query += "[? " + filter.field + " " + filter.relation + " " + "`" + JSON.stringify(value1) + "`" + "]";
                    } else query += Array.isArray(json) ? "[*]" : "@";
                    if (sort) {
                        if (sort.direction === "desc") query += " | reverse(sort_by(@, &" + sort.field + "))";
                        else query += " | sort_by(@, &" + sort.field + ")";
                    }
                    if (projection) {
                        if (query[query.length - 1] !== "]") query += " | [*]";
                        if (projection.fields.length === 1) query += "." + projection.fields[0];
                        else if (projection.fields.length > 1) query += ".{" + projection.fields.map(function(value) {
                            var parts = value.split(".");
                            var last = parts[parts.length - 1];
                            return last + ": " + value;
                        }).join(", ") + "}";
                    }
                    return query;
                }
                /**
 * Execute a JMESPath query
 * @param {JSON} json
 * @param {string} query
 * @return {JSON} Returns the transformed JSON
 */ function executeQuery(json, query) {
                    return jmespath__WEBPACK_IMPORTED_MODULE_0___default().search(json, query);
                }
            /***/ },
            /***/ 987: /***/ function() {
                if (typeof Element !== "undefined") // Polyfill for array remove
                (function() {
                    function polyfill(item) {
                        if (typeof item !== "undefined") {
                            if ("remove" in item) return;
                            Object.defineProperty(item, "remove", {
                                configurable: true,
                                enumerable: true,
                                writable: true,
                                value: function remove() {
                                    if (this.parentNode !== undefined) this.parentNode.removeChild(this);
                                }
                            });
                        }
                    }
                    if (typeof window.Element !== "undefined") polyfill(window.Element.prototype);
                    if (typeof window.CharacterData !== "undefined") polyfill(window.CharacterData.prototype);
                    if (typeof window.DocumentType !== "undefined") polyfill(window.DocumentType.prototype);
                })();
                // simple polyfill for Array.findIndex
                if (!Array.prototype.findIndex) // eslint-disable-next-line no-extend-native
                Object.defineProperty(Array.prototype, "findIndex", {
                    value: function value(predicate) {
                        for(var i = 0; i < this.length; i++){
                            var element = this[i];
                            if (predicate.call(this, element, i, this)) return i;
                        }
                        return -1;
                    },
                    configurable: true,
                    writable: true
                });
                // Polyfill for Array.find
                if (!Array.prototype.find) // eslint-disable-next-line no-extend-native
                Object.defineProperty(Array.prototype, "find", {
                    value: function value(predicate) {
                        var i = this.findIndex(predicate);
                        return this[i];
                    },
                    configurable: true,
                    writable: true
                });
                // Polyfill for String.trim
                if (!String.prototype.trim) // eslint-disable-next-line no-extend-native
                String.prototype.trim = function() {
                    return this.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
                };
            /***/ },
            /***/ 341: /***/ function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {
                "use strict";
                // ESM COMPAT FLAG
                __webpack_require__.r(__webpack_exports__);
                // EXPORTS
                __webpack_require__.d(__webpack_exports__, {
                    "previewModeMixins": function() {
                        return /* binding */ previewModeMixins;
                    }
                });
                // EXTERNAL MODULE: ./node_modules/jsonrepair/lib/esm/jsonrepair.js + 2 modules
                var jsonrepair = __webpack_require__(262);
                // EXTERNAL MODULE: ./src/js/constants.js
                var constants = __webpack_require__(188);
                // EXTERNAL MODULE: ./src/js/ErrorTable.js
                var ErrorTable = __webpack_require__(436);
                // EXTERNAL MODULE: ./src/js/FocusTracker.js
                var FocusTracker = __webpack_require__(474);
                function _typeof(obj) {
                    "@babel/helpers - typeof";
                    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
                        return typeof obj;
                    } : function(obj) {
                        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
                    }, _typeof(obj);
                }
                function _classCallCheck(instance, Constructor) {
                    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
                }
                function _defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
                    }
                }
                function _createClass(Constructor, protoProps, staticProps) {
                    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) _defineProperties(Constructor, staticProps);
                    Object.defineProperty(Constructor, "prototype", {
                        writable: false
                    });
                    return Constructor;
                }
                function _toPropertyKey(arg) {
                    var key = _toPrimitive(arg, "string");
                    return _typeof(key) === "symbol" ? key : String(key);
                }
                function _toPrimitive(input, hint) {
                    if (_typeof(input) !== "object" || input === null) return input;
                    var prim = input[Symbol.toPrimitive];
                    if (prim !== undefined) {
                        var res = prim.call(input, hint || "default");
                        if (_typeof(res) !== "object") return res;
                        throw new TypeError("@@toPrimitive must return a primitive value.");
                    }
                    return (hint === "string" ? String : Number)(input);
                }
                /**
 * Keep track on any history, be able
 * @param {function} onChange
 * @param {function} calculateItemSize
 * @param {number} limit    Maximum size of all items in history
 * @constructor
 */ var History = /*#__PURE__*/ function() {
                    function History(onChange, calculateItemSize, limit) {
                        _classCallCheck(this, History);
                        this.onChange = onChange;
                        this.calculateItemSize = calculateItemSize || function() {
                            return 1;
                        };
                        this.limit = limit;
                        this.items = [];
                        this.index = -1;
                    }
                    _createClass(History, [
                        {
                            key: "add",
                            value: function add(item) {
                                // limit number of items in history so that the total size doesn't
                                // always keep at least one item in memory
                                while(this._calculateHistorySize() > this.limit && this.items.length > 1){
                                    this.items.shift();
                                    this.index--;
                                }
                                // cleanup any redo action that are not valid anymore
                                this.items = this.items.slice(0, this.index + 1);
                                this.items.push(item);
                                this.index++;
                                this.onChange();
                            }
                        },
                        {
                            key: "_calculateHistorySize",
                            value: function _calculateHistorySize() {
                                var calculateItemSize = this.calculateItemSize;
                                var totalSize = 0;
                                this.items.forEach(function(item) {
                                    totalSize += calculateItemSize(item);
                                });
                                return totalSize;
                            }
                        },
                        {
                            key: "undo",
                            value: function undo() {
                                if (!this.canUndo()) return;
                                this.index--;
                                this.onChange();
                                return this.items[this.index];
                            }
                        },
                        {
                            key: "redo",
                            value: function redo() {
                                if (!this.canRedo()) return;
                                this.index++;
                                this.onChange();
                                return this.items[this.index];
                            }
                        },
                        {
                            key: "canUndo",
                            value: function canUndo() {
                                return this.index > 0;
                            }
                        },
                        {
                            key: "canRedo",
                            value: function canRedo() {
                                return this.index < this.items.length - 1;
                            }
                        },
                        {
                            key: "clear",
                            value: function clear() {
                                this.items = [];
                                this.index = -1;
                                this.onChange();
                            }
                        }
                    ]);
                    return History;
                }();
                // EXTERNAL MODULE: ./src/js/i18n.js
                var i18n = __webpack_require__(907);
                // EXTERNAL MODULE: ./src/js/jmespathQuery.js
                var jmespathQuery = __webpack_require__(56);
                // EXTERNAL MODULE: ./src/js/ModeSwitcher.js
                var ModeSwitcher = __webpack_require__(617);
                // EXTERNAL MODULE: ./src/js/showSortModal.js
                var showSortModal = __webpack_require__(210);
                // EXTERNAL MODULE: ./src/js/showTransformModal.js + 1 modules
                var showTransformModal = __webpack_require__(558);
                // EXTERNAL MODULE: ./src/js/textmode.js + 2 modules
                var textmode = __webpack_require__(458);
                // EXTERNAL MODULE: ./src/js/util.js
                var util = __webpack_require__(791);
                var previewmode_textmode = textmode.textModeMixins[0].mixin;
                // create a mixin with the functions for text mode
                var previewmode = {};
                /**
 * Create a JSON document preview, suitable for processing of large documents
 * @param {Element} container
 * @param {Object} [options]   Object with options. See docs for details.
 * @private
 */ previewmode.create = function(container) {
                    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                    if (typeof options.statusBar === "undefined") options.statusBar = true;
                    // setting default for previewmode
                    options.mainMenuBar = options.mainMenuBar !== false;
                    options.enableSort = options.enableSort !== false;
                    options.enableTransform = options.enableTransform !== false;
                    options.createQuery = options.createQuery || jmespathQuery /* createQuery */ .r;
                    options.executeQuery = options.executeQuery || jmespathQuery /* executeQuery */ .J;
                    this.options = options;
                    // indentation
                    if (typeof options.indentation === "number") this.indentation = Number(options.indentation);
                    else this.indentation = 2; // number of spaces
                    // language
                    (0, i18n /* setLanguages */ .cC)(this.options.languages);
                    (0, i18n /* setLanguage */ .m0)(this.options.language);
                    // determine mode
                    this.mode = "preview";
                    var me = this;
                    this.container = container;
                    this.dom = {};
                    this.json = undefined;
                    this.text = "";
                    // TODO: JSON Schema support
                    // create a debounced validate function
                    this._debouncedValidate = (0, util.debounce)(this.validate.bind(this), this.DEBOUNCE_INTERVAL);
                    this.width = container.clientWidth;
                    this.height = container.clientHeight;
                    this.frame = document.createElement("div");
                    this.frame.className = "jsoneditor jsoneditor-mode-preview";
                    this.frame.onclick = function(event) {
                        // prevent default submit action when the editor is located inside a form
                        event.preventDefault();
                    };
                    // setting the FocusTracker on 'this.frame' to track the editor's focus event
                    var focusTrackerConfig = {
                        target: this.frame,
                        onFocus: this.options.onFocus || null,
                        onBlur: this.options.onBlur || null
                    };
                    this.frameFocusTracker = new FocusTracker /* FocusTracker */ .R(focusTrackerConfig);
                    this.content = document.createElement("div");
                    this.content.className = "jsoneditor-outer";
                    this.dom.busy = document.createElement("div");
                    this.dom.busy.className = "jsoneditor-busy";
                    this.dom.busyContent = document.createElement("span");
                    this.dom.busyContent.textContent = "busy...";
                    this.dom.busy.appendChild(this.dom.busyContent);
                    this.content.appendChild(this.dom.busy);
                    this.dom.previewContent = document.createElement("pre");
                    this.dom.previewContent.className = "jsoneditor-preview";
                    this.dom.previewText = document.createTextNode("");
                    this.dom.previewContent.appendChild(this.dom.previewText);
                    this.content.appendChild(this.dom.previewContent);
                    if (this.options.mainMenuBar) {
                        (0, util.addClassName)(this.content, "has-main-menu-bar");
                        // create menu
                        this.menu = document.createElement("div");
                        this.menu.className = "jsoneditor-menu";
                        this.frame.appendChild(this.menu);
                        // create format button
                        var buttonFormat = document.createElement("button");
                        buttonFormat.type = "button";
                        buttonFormat.className = "jsoneditor-format";
                        buttonFormat.title = (0, i18n /* translate */ .Iu)("formatTitle");
                        this.menu.appendChild(buttonFormat);
                        buttonFormat.onclick = function handleFormat() {
                            me.executeWithBusyMessage(function() {
                                try {
                                    me.format();
                                } catch (err) {
                                    me._onError(err);
                                }
                            }, "formatting...");
                        };
                        // create compact button
                        var buttonCompact = document.createElement("button");
                        buttonCompact.type = "button";
                        buttonCompact.className = "jsoneditor-compact";
                        buttonCompact.title = (0, i18n /* translate */ .Iu)("compactTitle");
                        this.menu.appendChild(buttonCompact);
                        buttonCompact.onclick = function handleCompact() {
                            me.executeWithBusyMessage(function() {
                                try {
                                    me.compact();
                                } catch (err) {
                                    me._onError(err);
                                }
                            }, "compacting...");
                        };
                        // create sort button
                        if (this.options.enableSort) {
                            var _sort = document.createElement("button");
                            _sort.type = "button";
                            _sort.className = "jsoneditor-sort";
                            _sort.title = (0, i18n /* translate */ .Iu)("sortTitleShort");
                            _sort.onclick = function() {
                                me._showSortModal();
                            };
                            this.menu.appendChild(_sort);
                        }
                        // create transform button
                        if (this.options.enableTransform) {
                            var transform = document.createElement("button");
                            transform.type = "button";
                            transform.title = (0, i18n /* translate */ .Iu)("transformTitleShort");
                            transform.className = "jsoneditor-transform";
                            transform.onclick = function() {
                                me._showTransformModal();
                            };
                            this.dom.transform = transform;
                            this.menu.appendChild(transform);
                        }
                        // create repair button
                        var buttonRepair = document.createElement("button");
                        buttonRepair.type = "button";
                        buttonRepair.className = "jsoneditor-repair";
                        buttonRepair.title = (0, i18n /* translate */ .Iu)("repairTitle");
                        this.menu.appendChild(buttonRepair);
                        buttonRepair.onclick = function() {
                            if (me.json === undefined) // only repair if we don't have valid JSON
                            me.executeWithBusyMessage(function() {
                                try {
                                    me.repair();
                                } catch (err) {
                                    me._onError(err);
                                }
                            }, "repairing...");
                        };
                        // create history and undo/redo buttons
                        if (this.options.history !== false) {
                            // default option value is true
                            var onHistoryChange = function onHistoryChange() {
                                me.dom.undo.disabled = !me.history.canUndo();
                                me.dom.redo.disabled = !me.history.canRedo();
                            };
                            var calculateItemSize = function calculateItemSize(item) {
                                return(// times two to account for the json object
                                item.text.length * 2);
                            };
                            this.history = new History(onHistoryChange, calculateItemSize, constants /* PREVIEW_HISTORY_LIMIT */ .oW);
                            // create undo button
                            var undo = document.createElement("button");
                            undo.type = "button";
                            undo.className = "jsoneditor-undo jsoneditor-separator";
                            undo.title = (0, i18n /* translate */ .Iu)("undo");
                            undo.onclick = function() {
                                var action = me.history.undo();
                                if (action) me._applyHistory(action);
                            };
                            this.menu.appendChild(undo);
                            this.dom.undo = undo;
                            // create redo button
                            var redo = document.createElement("button");
                            redo.type = "button";
                            redo.className = "jsoneditor-redo";
                            redo.title = (0, i18n /* translate */ .Iu)("redo");
                            redo.onclick = function() {
                                var action = me.history.redo();
                                if (action) me._applyHistory(action);
                            };
                            this.menu.appendChild(redo);
                            this.dom.redo = redo;
                            // force enabling/disabling the undo/redo button
                            this.history.onChange();
                        }
                        // create mode box
                        if (this.options && this.options.modes && this.options.modes.length) this.modeSwitcher = new ModeSwitcher /* ModeSwitcher */ .x(this.menu, this.options.modes, this.options.mode, function onSwitch(mode) {
                            // switch mode and restore focus
                            try {
                                me.setMode(mode);
                                me.modeSwitcher.focus();
                            } catch (err) {
                                me._onError(err);
                            }
                        });
                    }
                    var errorTableVisible = Array.isArray(this.options.showErrorTable) ? this.options.showErrorTable.includes(this.mode) : this.options.showErrorTable === true;
                    this.errorTable = new ErrorTable /* ErrorTable */ .Q({
                        errorTableVisible: errorTableVisible,
                        onToggleVisibility: function onToggleVisibility() {
                            me.validate();
                        },
                        onFocusLine: null,
                        onChangeHeight: function onChangeHeight(height) {
                            // TODO: change CSS to using flex box, remove setting height using JavaScript
                            var statusBarHeight = me.dom.statusBar ? me.dom.statusBar.clientHeight : 0;
                            var totalHeight = height + statusBarHeight + 1;
                            me.content.style.marginBottom = -totalHeight + "px";
                            me.content.style.paddingBottom = totalHeight + "px";
                        }
                    });
                    this.frame.appendChild(this.content);
                    this.frame.appendChild(this.errorTable.getErrorTable());
                    this.container.appendChild(this.frame);
                    if (options.statusBar) {
                        (0, util.addClassName)(this.content, "has-status-bar");
                        var statusBar = document.createElement("div");
                        this.dom.statusBar = statusBar;
                        statusBar.className = "jsoneditor-statusbar";
                        this.frame.appendChild(statusBar);
                        this.dom.fileSizeInfo = document.createElement("span");
                        this.dom.fileSizeInfo.className = "jsoneditor-size-info";
                        this.dom.fileSizeInfo.innerText = "";
                        statusBar.appendChild(this.dom.fileSizeInfo);
                        this.dom.arrayInfo = document.createElement("span");
                        this.dom.arrayInfo.className = "jsoneditor-size-info";
                        this.dom.arrayInfo.innerText = "";
                        statusBar.appendChild(this.dom.arrayInfo);
                        statusBar.appendChild(this.errorTable.getErrorCounter());
                        statusBar.appendChild(this.errorTable.getWarningIcon());
                        statusBar.appendChild(this.errorTable.getErrorIcon());
                    }
                    this._renderPreview();
                    this.setSchema(this.options.schema, this.options.schemaRefs);
                };
                previewmode._renderPreview = function() {
                    var text = this.getText();
                    this.dom.previewText.nodeValue = (0, util.limitCharacters)(text, constants /* MAX_PREVIEW_CHARACTERS */ .WF);
                    if (this.dom.fileSizeInfo) this.dom.fileSizeInfo.innerText = "Size: " + (0, util.formatSize)(text.length);
                    if (this.dom.arrayInfo) {
                        if (Array.isArray(this.json)) this.dom.arrayInfo.innerText = "Array: " + this.json.length + " items";
                        else this.dom.arrayInfo.innerText = "";
                    }
                };
                /**
 * Handle a change:
 * - Validate JSON schema
 * - Send a callback to the onChange listener if provided
 * @private
 */ previewmode._onChange = function() {
                    // validate JSON schema (if configured)
                    this._debouncedValidate();
                    // trigger the onChange callback
                    if (this.options.onChange) try {
                        this.options.onChange();
                    } catch (err) {
                        console.error("Error in onChange callback: ", err);
                    }
                    // trigger the onChangeJSON callback
                    if (this.options.onChangeJSON) try {
                        this.options.onChangeJSON(this.get());
                    } catch (err) {
                        console.error("Error in onChangeJSON callback: ", err);
                    }
                    // trigger the onChangeText callback
                    if (this.options.onChangeText) try {
                        this.options.onChangeText(this.getText());
                    } catch (err) {
                        console.error("Error in onChangeText callback: ", err);
                    }
                };
                /**
 * Open a sort modal
 * @private
 */ previewmode._showSortModal = function() {
                    var me = this;
                    function onSort(json, sortedBy) {
                        if (Array.isArray(json)) {
                            var sortedArray = (0, util.sort)(json, sortedBy.path, sortedBy.direction);
                            me.sortedBy = sortedBy;
                            me._setAndFireOnChange(sortedArray);
                        }
                        if ((0, util.isObject)(json)) {
                            var sortedObject = (0, util.sortObjectKeys)(json, sortedBy.direction);
                            me.sortedBy = sortedBy;
                            me._setAndFireOnChange(sortedObject);
                        }
                    }
                    this.executeWithBusyMessage(function() {
                        var container = me.options.modalAnchor || constants /* DEFAULT_MODAL_ANCHOR */ .qD;
                        var json = me.get();
                        me._renderPreview(); // update array count
                        (0, showSortModal.showSortModal)(container, json, function(sortedBy) {
                            me.executeWithBusyMessage(function() {
                                onSort(json, sortedBy);
                            }, "sorting...");
                        }, me.sortedBy);
                    }, "parsing...");
                };
                /**
 * Open a transform modal
 * @private
 */ previewmode._showTransformModal = function() {
                    var _this = this;
                    this.executeWithBusyMessage(function() {
                        var _this$options = _this.options, createQuery = _this$options.createQuery, executeQuery = _this$options.executeQuery, modalAnchor = _this$options.modalAnchor, queryDescription = _this$options.queryDescription;
                        var json = _this.get();
                        _this._renderPreview(); // update array count
                        (0, showTransformModal.showTransformModal)({
                            container: modalAnchor || constants /* DEFAULT_MODAL_ANCHOR */ .qD,
                            json: json,
                            queryDescription: queryDescription,
                            // can be undefined
                            createQuery: createQuery,
                            executeQuery: executeQuery,
                            onTransform: function onTransform(query) {
                                _this.executeWithBusyMessage(function() {
                                    var updatedJson = executeQuery(json, query);
                                    _this._setAndFireOnChange(updatedJson);
                                }, "transforming...");
                            }
                        });
                    }, "parsing...");
                };
                /**
 * Destroy the editor. Clean up DOM, event listeners, and web workers.
 */ previewmode.destroy = function() {
                    if (this.frame && this.container && this.frame.parentNode === this.container) this.container.removeChild(this.frame);
                    if (this.modeSwitcher) {
                        this.modeSwitcher.destroy();
                        this.modeSwitcher = null;
                    }
                    this._debouncedValidate = null;
                    if (this.history) {
                        this.history.clear();
                        this.history = null;
                    }
                    // Removing the FocusTracker set to track the editor's focus event
                    this.frameFocusTracker.destroy();
                };
                /**
 * Compact the code in the text editor
 */ previewmode.compact = function() {
                    var json = this.get();
                    var text = JSON.stringify(json);
                    // we know that in this case the json is still the same, so we pass json too
                    this._setTextAndFireOnChange(text, json);
                };
                /**
 * Format the code in the text editor
 */ previewmode.format = function() {
                    var json = this.get();
                    var text = JSON.stringify(json, null, this.indentation);
                    // we know that in this case the json is still the same, so we pass json too
                    this._setTextAndFireOnChange(text, json);
                };
                /**
 * Repair the code in the text editor
 */ previewmode.repair = function() {
                    var text = this.getText();
                    try {
                        var repairedText = (0, jsonrepair /* jsonrepair */ .K)(text);
                        this._setTextAndFireOnChange(repairedText);
                    } catch (err) {
                    // repair was not successful, do nothing
                    }
                };
                /**
 * Set focus to the editor
 */ previewmode.focus = function() {
                    // we don't really have a place to focus,
                    // let's focus on the transform button
                    this.dom.transform.focus();
                };
                /**
 * Set json data in the editor
 * @param {*} json
 */ previewmode.set = function(json) {
                    if (this.history) this.history.clear();
                    this._set(json);
                };
                /**
 * Update data. Same as calling `set` in text/code mode.
 * @param {*} json
 */ previewmode.update = function(json) {
                    this._set(json);
                };
                /**
 * Set json data
 * @param {*} json
 */ previewmode._set = function(json) {
                    this.text = undefined;
                    this.json = json;
                    this._renderPreview();
                    this._pushHistory();
                    // validate JSON schema
                    this._debouncedValidate();
                };
                previewmode._setAndFireOnChange = function(json) {
                    this._set(json);
                    this._onChange();
                };
                /**
 * Get json data
 * @return {*} json
 */ previewmode.get = function() {
                    if (this.json === undefined) {
                        var text = this.getText();
                        this.json = (0, util.parse)(text); // this can throw an error
                    }
                    return this.json;
                };
                /**
 * Get the text contents of the editor
 * @return {String} jsonText
 */ previewmode.getText = function() {
                    if (this.text === undefined) {
                        this.text = JSON.stringify(this.json, null, this.indentation);
                        if (this.options.escapeUnicode === true) this.text = (0, util.escapeUnicodeChars)(this.text);
                    }
                    return this.text;
                };
                /**
 * Set the text contents of the editor
 * @param {String} jsonText
 */ previewmode.setText = function(jsonText) {
                    if (this.history) this.history.clear();
                    this._setText(jsonText);
                };
                /**
 * Update the text contents
 * @param {string} jsonText
 */ previewmode.updateText = function(jsonText) {
                    // don't update if there are no changes
                    if (this.getText() === jsonText) return;
                    this._setText(jsonText);
                };
                /**
 * Set the text contents of the editor
 * @param {string} jsonText
 * @param {*} [json] Optional JSON instance of the text
 * @private
 */ previewmode._setText = function(jsonText, json) {
                    if (this.options.escapeUnicode === true) this.text = (0, util.escapeUnicodeChars)(jsonText);
                    else this.text = jsonText;
                    this.json = json;
                    this._renderPreview();
                    if (this.json === undefined) {
                        var me = this;
                        this.executeWithBusyMessage(function() {
                            try {
                                // force parsing the json now, else it will be done in validate without feedback
                                me.json = me.get();
                                me._renderPreview();
                                me._pushHistory();
                            } catch (err) {
                            // no need to throw an error, validation will show an error
                            }
                        }, "parsing...");
                    } else this._pushHistory();
                    this._debouncedValidate();
                };
                /**
 * Set text and fire onChange callback
 * @param {string} jsonText
 * @param {*} [json] Optional JSON instance of the text
 * @private
 */ previewmode._setTextAndFireOnChange = function(jsonText, json) {
                    this._setText(jsonText, json);
                    this._onChange();
                };
                /**
 * Apply history to the current state
 * @param {{json?: JSON, text?: string}} action
 * @private
 */ previewmode._applyHistory = function(action) {
                    this.json = action.json;
                    this.text = action.text;
                    this._renderPreview();
                    this._debouncedValidate();
                };
                /**
 * Push the current state to history
 * @private
 */ previewmode._pushHistory = function() {
                    if (!this.history) return;
                    var action = {
                        text: this.text,
                        json: this.json
                    };
                    this.history.add(action);
                };
                /**
 * Execute a heavy, blocking action.
 * Before starting the action, show a message on screen like "parsing..."
 * @param {function} fn
 * @param {string} message
 */ previewmode.executeWithBusyMessage = function(fn, message) {
                    var size = this.getText().length;
                    if (size > constants /* SIZE_LARGE */ .EX) {
                        var me = this;
                        (0, util.addClassName)(me.frame, "busy");
                        me.dom.busyContent.innerText = message;
                        setTimeout(function() {
                            fn();
                            (0, util.removeClassName)(me.frame, "busy");
                            me.dom.busyContent.innerText = "";
                        }, 100);
                    } else fn();
                };
                // TODO: refactor into composable functions instead of this shaky mixin-like structure
                previewmode.validate = previewmode_textmode.validate;
                previewmode._renderErrors = previewmode_textmode._renderErrors;
                // define modes
                var previewModeMixins = [
                    {
                        mode: "preview",
                        mixin: previewmode,
                        data: "json"
                    }
                ];
            /***/ },
            /***/ 210: /***/ function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {
                "use strict";
                __webpack_require__.r(__webpack_exports__);
                /* harmony export */ __webpack_require__.d(__webpack_exports__, {
                    /* harmony export */ "showSortModal": function() {
                        return /* binding */ showSortModal;
                    }
                });
                /* harmony import */ var picomodal__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(483);
                /* harmony import */ var picomodal__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/ __webpack_require__.n(picomodal__WEBPACK_IMPORTED_MODULE_0__);
                /* harmony import */ var _i18n__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(907);
                /* harmony import */ var _util__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(791);
                /**
 * Show advanced sorting modal
 * @param {HTMLElement} container   The container where to center
 *                                  the modal and create an overlay
 * @param {JSON} json               The JSON data to be sorted.
 * @param {function} onSort         Callback function, invoked with
 *                                  an object containing the selected
 *                                  path and direction
 * @param {Object} options
 *            Available options:
 *                - {string} path              The selected path
 *                - {'asc' | 'desc'} direction The selected direction
 */ function showSortModal(container, json, onSort, options) {
                    var paths = Array.isArray(json) ? (0, _util__WEBPACK_IMPORTED_MODULE_2__.getChildPaths)(json) : [
                        ""
                    ];
                    var selectedPath = options && options.path && (0, _util__WEBPACK_IMPORTED_MODULE_2__.contains)(paths, options.path) ? options.path : paths[0];
                    var selectedDirection = options && options.direction || "asc";
                    var content = '<div class="pico-modal-contents"><div class="pico-modal-header">' + (0, _i18n__WEBPACK_IMPORTED_MODULE_1__ /* .translate */ .Iu)("sort") + "</div>" + "<form>" + "<table>" + "<tbody>" + "<tr>" + "  <td>" + (0, _i18n__WEBPACK_IMPORTED_MODULE_1__ /* .translate */ .Iu)("sortFieldLabel") + " </td>" + '  <td class="jsoneditor-modal-input">' + '  <div class="jsoneditor-select-wrapper">' + '    <select id="field" title="' + (0, _i18n__WEBPACK_IMPORTED_MODULE_1__ /* .translate */ .Iu)("sortFieldTitle") + '">' + "    </select>" + "  </div>" + "  </td>" + "</tr>" + "<tr>" + "  <td>" + (0, _i18n__WEBPACK_IMPORTED_MODULE_1__ /* .translate */ .Iu)("sortDirectionLabel") + " </td>" + '  <td class="jsoneditor-modal-input">' + '  <div id="direction" class="jsoneditor-button-group">' + '<input type="button" ' + 'value="' + (0, _i18n__WEBPACK_IMPORTED_MODULE_1__ /* .translate */ .Iu)("sortAscending") + '" ' + 'title="' + (0, _i18n__WEBPACK_IMPORTED_MODULE_1__ /* .translate */ .Iu)("sortAscendingTitle") + '" ' + 'data-value="asc" ' + 'class="jsoneditor-button-first jsoneditor-button-asc"/>' + '<input type="button" ' + 'value="' + (0, _i18n__WEBPACK_IMPORTED_MODULE_1__ /* .translate */ .Iu)("sortDescending") + '" ' + 'title="' + (0, _i18n__WEBPACK_IMPORTED_MODULE_1__ /* .translate */ .Iu)("sortDescendingTitle") + '" ' + 'data-value="desc" ' + 'class="jsoneditor-button-last jsoneditor-button-desc"/>' + "  </div>" + "  </td>" + "</tr>" + "<tr>" + '<td colspan="2" class="jsoneditor-modal-input jsoneditor-modal-actions">' + '  <input type="submit" id="ok" value="' + (0, _i18n__WEBPACK_IMPORTED_MODULE_1__ /* .translate */ .Iu)("ok") + '" />' + "</td>" + "</tr>" + "</tbody>" + "</table>" + "</form>" + "</div>";
                    picomodal__WEBPACK_IMPORTED_MODULE_0___default()({
                        parent: container,
                        content: content,
                        overlayClass: "jsoneditor-modal-overlay",
                        overlayStyles: {
                            backgroundColor: "rgb(1,1,1)",
                            opacity: 0.3
                        },
                        modalClass: "jsoneditor-modal jsoneditor-modal-sort"
                    }).afterCreate(function(modal) {
                        var form = modal.modalElem().querySelector("form");
                        var ok = modal.modalElem().querySelector("#ok");
                        var field = modal.modalElem().querySelector("#field");
                        var direction = modal.modalElem().querySelector("#direction");
                        function preprocessPath(path) {
                            return path === "" ? "@" : path[0] === "." ? path.slice(1) : path;
                        }
                        paths.forEach(function(path) {
                            var option = document.createElement("option");
                            option.text = preprocessPath(path);
                            option.value = path;
                            field.appendChild(option);
                        });
                        function setDirection(value) {
                            direction.value = value;
                            direction.className = "jsoneditor-button-group jsoneditor-button-group-value-" + direction.value;
                        }
                        field.value = selectedPath || paths[0];
                        setDirection(selectedDirection || "asc");
                        direction.onclick = function(event) {
                            setDirection(event.target.getAttribute("data-value"));
                        };
                        ok.onclick = function(event) {
                            event.preventDefault();
                            event.stopPropagation();
                            modal.close();
                            onSort({
                                path: field.value,
                                direction: direction.value
                            });
                        };
                        if (form) // form is not available when JSONEditor is created inside a form
                        form.onsubmit = ok.onclick;
                    }).afterClose(function(modal) {
                        modal.destroy();
                    }).show();
                }
            /***/ },
            /***/ 558: /***/ function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {
                "use strict";
                // ESM COMPAT FLAG
                __webpack_require__.r(__webpack_exports__);
                // EXPORTS
                __webpack_require__.d(__webpack_exports__, {
                    "showTransformModal": function() {
                        return /* binding */ showTransformModal;
                    }
                });
                // EXTERNAL MODULE: ./node_modules/picomodal/src/picoModal.js
                var picoModal = __webpack_require__(483);
                var picoModal_default = /*#__PURE__*/ __webpack_require__.n(picoModal);
                // EXTERNAL MODULE: ./src/js/assets/selectr/selectr.js
                var selectr = __webpack_require__(879);
                var selectr_default = /*#__PURE__*/ __webpack_require__.n(selectr);
                // EXTERNAL MODULE: ./src/js/i18n.js
                var i18n = __webpack_require__(907);
                /**
 * Convert part of a JSON object to a JSON string.
 * Use case is to stringify a small part of a large JSON object so you can see
 * a preview.
 *
 * @param {*} value
 * The value to convert to a JSON string.
 *
 * @param {number | string | null} [space]
 * A String or Number object that's used to insert white space into the output
 * JSON string for readability purposes. If this is a Number, it indicates the
 * number of space characters to use as white space; this number is capped at 10
 * if it's larger than that. Values less than 1 indicate that no space should be
 * used. If this is a String, the string (or the first 10 characters of the string,
 * if it's longer than that) is used as white space. If this parameter is not
 * provided (or is null), no white space is used.
 *
 * @param {number} [limit] Maximum size of the string output.
 *
 * @returns {string | undefined} Returns the string representation of the JSON object.
 */ function _typeof(obj) {
                    "@babel/helpers - typeof";
                    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
                        return typeof obj;
                    } : function(obj) {
                        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
                    }, _typeof(obj);
                }
                function stringifyPartial(value, space, limit) {
                    var _space; // undefined by default
                    if (typeof space === "number") {
                        if (space > 10) _space = repeat(" ", 10);
                        else if (space >= 1) _space = repeat(" ", space);
                    // else ignore
                    } else if (typeof space === "string" && space !== "") _space = space;
                    var output = stringifyValue(value, _space, "", limit);
                    return output.length > limit ? slice(output, limit) + "..." : output;
                }
                /**
 * Stringify a value
 * @param {*} value
 * @param {string} space
 * @param {string} indent
 * @param {number} limit
 * @return {string | undefined}
 */ function stringifyValue(value, space, indent, limit) {
                    // boolean, null, number, string, or date
                    if (typeof value === "boolean" || value instanceof Boolean || value === null || typeof value === "number" || value instanceof Number || typeof value === "string" || value instanceof String || value instanceof Date) return JSON.stringify(value);
                    // array
                    if (Array.isArray(value)) return stringifyArray(value, space, indent, limit);
                    // object (test lastly!)
                    if (value && _typeof(value) === "object") return stringifyObject(value, space, indent, limit);
                    return undefined;
                }
                /**
 * Stringify an array
 * @param {Array} array
 * @param {string} space
 * @param {string} indent
 * @param {number} limit
 * @return {string}
 */ function stringifyArray(array, space, indent, limit) {
                    var childIndent = space ? indent + space : undefined;
                    var str = space ? "[\n" : "[";
                    for(var i = 0; i < array.length; i++){
                        var item = array[i];
                        if (space) str += childIndent;
                        if (typeof item !== "undefined" && typeof item !== "function") str += stringifyValue(item, space, childIndent, limit);
                        else str += "null";
                        if (i < array.length - 1) str += space ? ",\n" : ",";
                        // stop as soon as we're exceeding the limit
                        if (str.length > limit) return str + "...";
                    }
                    str += space ? "\n" + indent + "]" : "]";
                    return str;
                }
                /**
 * Stringify an object
 * @param {Object} object
 * @param {string} space
 * @param {string} indent
 * @param {number} limit
 * @return {string}
 */ function stringifyObject(object, space, indent, limit) {
                    var childIndent = space ? indent + space : undefined;
                    var first = true;
                    var str = space ? "{\n" : "{";
                    if (typeof object.toJSON === "function") return stringifyValue(object.toJSON(), space, indent, limit);
                    for(var key in object)if (jsonUtils_hasOwnProperty(object, key)) {
                        var value = object[key];
                        if (first) first = false;
                        else str += space ? ",\n" : ",";
                        str += space ? childIndent + '"' + key + '": ' : '"' + key + '":';
                        str += stringifyValue(value, space, childIndent, limit);
                        // stop as soon as we're exceeding the limit
                        if (str.length > limit) return str + "...";
                    }
                    str += space ? "\n" + indent + "}" : "}";
                    return str;
                }
                /**
 * Repeat a string a number of times.
 * Simple linear solution, we only need up to 10 iterations in practice
 * @param {string} text
 * @param {number} times
 * @return {string}
 */ function repeat(text, times) {
                    var res = "";
                    while(times-- > 0)res += text;
                    return res;
                }
                /**
 * Limit the length of text
 * @param {string} text
 * @param {number} [limit]
 * @return {string}
 */ function slice(text, limit) {
                    return typeof limit === "number" ? text.slice(0, limit) : text;
                }
                /**
 * Test whether some text contains a JSON array, i.e. the first
 * non-white space character is a [
 * @param {string} jsonText
 * @return {boolean}
 */ function containsArray(jsonText) {
                    return /^\s*\[/.test(jsonText);
                }
                function jsonUtils_hasOwnProperty(object, key) {
                    return Object.prototype.hasOwnProperty.call(object, key);
                }
                // EXTERNAL MODULE: ./src/js/util.js
                var util = __webpack_require__(791);
                // EXTERNAL MODULE: ./src/js/constants.js
                var constants = __webpack_require__(188);
                var DEFAULT_DESCRIPTION = 'Enter a <a href="http://jmespath.org" target="_blank">JMESPath</a> query to filter, sort, or transform the JSON data.<br/>To learn JMESPath, go to <a href="http://jmespath.org/tutorial.html" target="_blank">the interactive tutorial</a>.';
                /**
 * Show advanced filter and transform modal using JMESPath
 * @param {Object} params
 * @property {HTMLElement} container   The container where to center
 *                                     the modal and create an overlay
 * @property {JSON} json               The json data to be transformed
 * @property {string} [queryDescription] Optional custom description explaining
 *                                       the transform functionality
 * @property {function} createQuery    Function called to create a query
 *                                     from the wizard form
 * @property {function} executeQuery   Execute a query for the preview pane
 * @property {function} onTransform    Callback invoked with the created
 *                                     query as callback
 */ function showTransformModal(_ref) {
                    var container = _ref.container, json = _ref.json, _ref$queryDescription = _ref.queryDescription, queryDescription = _ref$queryDescription === void 0 ? DEFAULT_DESCRIPTION : _ref$queryDescription, createQuery = _ref.createQuery, executeQuery = _ref.executeQuery, onTransform = _ref.onTransform;
                    var value = json;
                    var content = '<label class="pico-modal-contents"><div class="pico-modal-header">' + (0, i18n /* translate */ .Iu)("transform") + "</div>" + "<p>" + queryDescription + "</p>" + '<div class="jsoneditor-jmespath-label">' + (0, i18n /* translate */ .Iu)("transformWizardLabel") + " </div>" + '<div id="wizard" class="jsoneditor-jmespath-block jsoneditor-jmespath-wizard">' + '  <table class="jsoneditor-jmespath-wizard-table">' + "    <tbody>" + "      <tr>" + "        <th>" + (0, i18n /* translate */ .Iu)("transformWizardFilter") + "</th>" + '        <td class="jsoneditor-jmespath-filter">' + '          <div class="jsoneditor-inline jsoneditor-jmespath-filter-field" >' + '            <select id="filterField">' + "            </select>" + "          </div>" + '          <div class="jsoneditor-inline jsoneditor-jmespath-filter-relation" >' + '            <select id="filterRelation">' + '              <option value="==">==</option>' + '              <option value="!=">!=</option>' + '              <option value="<">&lt;</option>' + '              <option value="<=">&lt;=</option>' + '              <option value=">">&gt;</option>' + '              <option value=">=">&gt;=</option>' + "            </select>" + "          </div>" + '          <div class="jsoneditor-inline jsoneditor-jmespath-filter-value" >' + '            <input type="text" class="value" placeholder="value..." id="filterValue" />' + "          </div>" + "        </td>" + "      </tr>" + "      <tr>" + "        <th>" + (0, i18n /* translate */ .Iu)("transformWizardSortBy") + "</th>" + '        <td class="jsoneditor-jmespath-filter">' + '          <div class="jsoneditor-inline jsoneditor-jmespath-sort-field">' + '            <select id="sortField">' + "            </select>" + "          </div>" + '          <div class="jsoneditor-inline jsoneditor-jmespath-sort-order" >' + '            <select id="sortOrder">' + '              <option value="asc">Ascending</option>' + '              <option value="desc">Descending</option>' + "            </select>" + "          </div>" + "        </td>" + "      </tr>" + '      <tr id="selectFieldsPart">' + "        <th>" + (0, i18n /* translate */ .Iu)("transformWizardSelectFields") + "</th>" + '        <td class="jsoneditor-jmespath-filter">' + '          <select class="jsoneditor-jmespath-select-fields" id="selectFields" multiple></select>' + "        </td>" + "      </tr>" + "    </tbody>" + "  </table>" + "</div>" + '<div class="jsoneditor-jmespath-label">' + (0, i18n /* translate */ .Iu)("transformQueryLabel") + " </div>" + '<div class="jsoneditor-jmespath-block">' + '  <textarea id="query" ' + '            rows="4" ' + '            autocomplete="off" ' + '            autocorrect="off" ' + '            autocapitalize="off" ' + '            spellcheck="false"' + '            title="' + (0, i18n /* translate */ .Iu)("transformQueryTitle") + '">[*]</textarea>' + "</div>" + '<div class="jsoneditor-jmespath-label">' + (0, i18n /* translate */ .Iu)("transformPreviewLabel") + " </div>" + '<div class="jsoneditor-jmespath-block">' + '  <textarea id="preview" ' + '      class="jsoneditor-transform-preview"' + "      readonly> </textarea>" + "</div>" + '<div class="jsoneditor-jmespath-block jsoneditor-modal-actions">' + '  <input type="submit" id="ok" value="' + (0, i18n /* translate */ .Iu)("ok") + '" autofocus />' + "</div>" + "</div>";
                    picoModal_default()({
                        parent: container,
                        content: content,
                        overlayClass: "jsoneditor-modal-overlay",
                        overlayStyles: {
                            backgroundColor: "rgb(1,1,1)",
                            opacity: 0.3
                        },
                        modalClass: "jsoneditor-modal jsoneditor-modal-transform",
                        focus: false
                    }).afterCreate(function(modal) {
                        var elem = modal.modalElem();
                        var wizard = elem.querySelector("#wizard");
                        var ok = elem.querySelector("#ok");
                        var filterField = elem.querySelector("#filterField");
                        var filterRelation = elem.querySelector("#filterRelation");
                        var filterValue = elem.querySelector("#filterValue");
                        var sortField = elem.querySelector("#sortField");
                        var sortOrder = elem.querySelector("#sortOrder");
                        var selectFields = elem.querySelector("#selectFields");
                        var query = elem.querySelector("#query");
                        var preview = elem.querySelector("#preview");
                        if (!Array.isArray(value)) {
                            wizard.style.fontStyle = "italic";
                            wizard.textContent = "(wizard not available for objects, only for arrays)";
                        }
                        var sortablePaths = (0, util.getChildPaths)(json);
                        sortablePaths.forEach(function(path) {
                            var formattedPath = preprocessPath(path);
                            var filterOption = document.createElement("option");
                            filterOption.text = formattedPath;
                            filterOption.value = formattedPath;
                            filterField.appendChild(filterOption);
                            var sortOption = document.createElement("option");
                            sortOption.text = formattedPath;
                            sortOption.value = formattedPath;
                            sortField.appendChild(sortOption);
                        });
                        var selectablePaths = (0, util.getChildPaths)(json, true).filter(function(path) {
                            return path !== "";
                        });
                        if (selectablePaths.length > 0) selectablePaths.forEach(function(path) {
                            var formattedPath = preprocessPath(path);
                            var option = document.createElement("option");
                            option.text = formattedPath;
                            option.value = formattedPath;
                            selectFields.appendChild(option);
                        });
                        else {
                            var selectFieldsPart = elem.querySelector("#selectFieldsPart");
                            if (selectFieldsPart) selectFieldsPart.style.display = "none";
                        }
                        var selectrFilterField = new (selectr_default())(filterField, {
                            defaultSelected: false,
                            clearable: true,
                            allowDeselect: true,
                            placeholder: "field..."
                        });
                        var selectrFilterRelation = new (selectr_default())(filterRelation, {
                            defaultSelected: false,
                            clearable: true,
                            allowDeselect: true,
                            placeholder: "compare..."
                        });
                        var selectrSortField = new (selectr_default())(sortField, {
                            defaultSelected: false,
                            clearable: true,
                            allowDeselect: true,
                            placeholder: "field..."
                        });
                        var selectrSortOrder = new (selectr_default())(sortOrder, {
                            defaultSelected: false,
                            clearable: true,
                            allowDeselect: true,
                            placeholder: "order..."
                        });
                        var selectrSelectFields = new (selectr_default())(selectFields, {
                            multiple: true,
                            clearable: true,
                            defaultSelected: false,
                            placeholder: "select fields..."
                        });
                        selectrFilterField.on("selectr.change", generateQueryFromWizard);
                        selectrFilterRelation.on("selectr.change", generateQueryFromWizard);
                        filterValue.oninput = generateQueryFromWizard;
                        selectrSortField.on("selectr.change", generateQueryFromWizard);
                        selectrSortOrder.on("selectr.change", generateQueryFromWizard);
                        selectrSelectFields.on("selectr.change", generateQueryFromWizard);
                        elem.querySelector(".pico-modal-contents").onclick = function(event) {
                            // prevent the first clear button (in any select box) from getting
                            // focus when clicking anywhere in the modal. Only allow clicking links.
                            if (event.target.nodeName !== "A") event.preventDefault();
                        };
                        function preprocessPath(path) {
                            return path === "" ? "@" : path[0] === "." ? path.slice(1) : path;
                        }
                        function updatePreview() {
                            try {
                                var transformed = executeQuery(value, query.value);
                                preview.className = "jsoneditor-transform-preview";
                                preview.value = stringifyPartial(transformed, 2, constants /* MAX_PREVIEW_CHARACTERS */ .WF);
                                ok.disabled = false;
                            } catch (err) {
                                preview.className = "jsoneditor-transform-preview jsoneditor-error";
                                preview.value = err.toString();
                                ok.disabled = true;
                            }
                        }
                        var debouncedUpdatePreview = (0, util.debounce)(updatePreview, 300);
                        function tryCreateQuery(json, queryOptions) {
                            try {
                                query.value = createQuery(json, queryOptions);
                                ok.disabled = false;
                                debouncedUpdatePreview();
                            } catch (err) {
                                var message = 'Error: an error happened when executing "createQuery": ' + (err.message || err.toString());
                                query.value = "";
                                ok.disabled = true;
                                preview.className = "jsoneditor-transform-preview jsoneditor-error";
                                preview.value = message;
                            }
                        }
                        function generateQueryFromWizard() {
                            var queryOptions = {};
                            if (filterField.value && filterRelation.value && filterValue.value) queryOptions.filter = {
                                field: filterField.value,
                                relation: filterRelation.value,
                                value: filterValue.value
                            };
                            if (sortField.value && sortOrder.value) queryOptions.sort = {
                                field: sortField.value,
                                direction: sortOrder.value
                            };
                            if (selectFields.value) {
                                var fields = [];
                                for(var i = 0; i < selectFields.options.length; i++)if (selectFields.options[i].selected) {
                                    var selectedField = selectFields.options[i].value;
                                    fields.push(selectedField);
                                }
                                queryOptions.projection = {
                                    fields: fields
                                };
                            }
                            tryCreateQuery(json, queryOptions);
                        }
                        query.oninput = debouncedUpdatePreview;
                        ok.onclick = function(event) {
                            event.preventDefault();
                            event.stopPropagation();
                            modal.close();
                            onTransform(query.value);
                        };
                        // initialize with empty query
                        tryCreateQuery(json, {});
                        setTimeout(function() {
                            query.select();
                            query.focus();
                            query.selectionStart = 3;
                            query.selectionEnd = 3;
                        });
                    }).afterClose(function(modal) {
                        modal.destroy();
                    }).show();
                }
            /***/ },
            /***/ 458: /***/ function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {
                "use strict";
                // ESM COMPAT FLAG
                __webpack_require__.r(__webpack_exports__);
                // EXPORTS
                __webpack_require__.d(__webpack_exports__, {
                    "textModeMixins": function() {
                        return /* binding */ textModeMixins;
                    }
                });
                // EXTERNAL MODULE: ./node_modules/jsonrepair/lib/esm/jsonrepair.js + 2 modules
                var jsonrepair = __webpack_require__(262);
                // EXTERNAL MODULE: ./src/js/ace/index.js
                var ace = __webpack_require__(170);
                var ace_default = /*#__PURE__*/ __webpack_require__.n(ace);
                // EXTERNAL MODULE: ./src/js/constants.js
                var constants = __webpack_require__(188);
                // EXTERNAL MODULE: ./src/js/ErrorTable.js
                var ErrorTable = __webpack_require__(436);
                // EXTERNAL MODULE: ./src/js/FocusTracker.js
                var FocusTracker = __webpack_require__(474);
                // EXTERNAL MODULE: ./src/js/i18n.js
                var i18n = __webpack_require__(907);
                // EXTERNAL MODULE: ./src/js/jmespathQuery.js
                var jmespathQuery = __webpack_require__(56);
                // EXTERNAL MODULE: ./src/js/ModeSwitcher.js
                var ModeSwitcher = __webpack_require__(617);
                // EXTERNAL MODULE: ./src/js/showSortModal.js
                var showSortModal = __webpack_require__(210);
                // EXTERNAL MODULE: ./src/js/showTransformModal.js + 1 modules
                var showTransformModal = __webpack_require__(558);
                // EXTERNAL MODULE: ./src/js/tryRequireThemeJsonEditor.js
                var tryRequireThemeJsonEditor = __webpack_require__(49);
                // EXTERNAL MODULE: ./node_modules/json-source-map/index.js
                var json_source_map = __webpack_require__(26);
                // EXTERNAL MODULE: ./src/js/util.js
                var util = __webpack_require__(791);
                function _typeof(obj) {
                    "@babel/helpers - typeof";
                    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
                        return typeof obj;
                    } : function(obj) {
                        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
                    }, _typeof(obj);
                }
                function _classCallCheck(instance, Constructor) {
                    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
                }
                function _defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
                    }
                }
                function _createClass(Constructor, protoProps, staticProps) {
                    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) _defineProperties(Constructor, staticProps);
                    Object.defineProperty(Constructor, "prototype", {
                        writable: false
                    });
                    return Constructor;
                }
                function _toPropertyKey(arg) {
                    var key = _toPrimitive(arg, "string");
                    return _typeof(key) === "symbol" ? key : String(key);
                }
                function _toPrimitive(input, hint) {
                    if (_typeof(input) !== "object" || input === null) return input;
                    var prim = input[Symbol.toPrimitive];
                    if (prim !== undefined) {
                        var res = prim.call(input, hint || "default");
                        if (_typeof(res) !== "object") return res;
                        throw new TypeError("@@toPrimitive must return a primitive value.");
                    }
                    return (hint === "string" ? String : Number)(input);
                }
                /**
 * SchemaTextCompleter class implements the ace ext-language_tools completer API,
 * and suggests completions for the text editor that are relative
 * to the cursor position and the json schema
 */ var SchemaTextCompleter = /*#__PURE__*/ function() {
                    function SchemaTextCompleter(schema, schemaRefs) {
                        _classCallCheck(this, SchemaTextCompleter);
                        this.schema = schema;
                        this.schemaRefs = schemaRefs || {};
                        this.suggestions = {};
                        this.suggestionsRefs = {};
                        this._buildSuggestions();
                    }
                    _createClass(SchemaTextCompleter, [
                        {
                            key: "_buildSuggestions",
                            value: function _buildSuggestions() {
                                this._handleSchemaEntry("", this.schema, this.suggestions);
                                for(var refName in this.schemaRefs){
                                    this.suggestionsRefs[refName] = {};
                                    this._handleSchemaEntry("", this.schemaRefs[refName], this.suggestionsRefs[refName]);
                                }
                            }
                        },
                        {
                            key: "_handleRef",
                            value: function _handleRef(currectPath, refName, suggestionsObj) {
                                suggestionsObj[currectPath] = suggestionsObj[currectPath] || {};
                                suggestionsObj[currectPath].refs = suggestionsObj[currectPath].refs || [];
                                suggestionsObj[currectPath].refs = (0, util.uniqueMergeArrays)(suggestionsObj[currectPath].refs, [
                                    refName
                                ]);
                            }
                        },
                        {
                            key: "_handleSchemaEntry",
                            value: function _handleSchemaEntry(currectPath, schemaNode, suggestionsObj) {
                                if (!schemaNode) {
                                    console.error("SchemaTextCompleter: schema node is missing for path", currectPath);
                                    return;
                                }
                                if (schemaNode.$ref) {
                                    this._handleRef(currectPath, schemaNode.$ref, suggestionsObj);
                                    return;
                                }
                                var ofConditionEntry = this._checkOfConditon(schemaNode);
                                if (ofConditionEntry) {
                                    this._handleOfCondition(currectPath, schemaNode[ofConditionEntry], suggestionsObj);
                                    return;
                                }
                                switch(schemaNode.type){
                                    case "object":
                                        this._handleObject(currectPath, schemaNode, suggestionsObj);
                                        break;
                                    case "string":
                                    case "number":
                                    case "integer":
                                        this._handlePrimitive(currectPath, schemaNode, suggestionsObj);
                                        break;
                                    case "boolean":
                                        this._handleBoolean(currectPath, schemaNode, suggestionsObj);
                                        break;
                                    case "array":
                                        this._handleArray(currectPath, schemaNode, suggestionsObj);
                                }
                            }
                        },
                        {
                            key: "_handleObject",
                            value: function _handleObject(currectPath, schemaNode, suggestionsObj) {
                                var _this = this;
                                if ((0, util.isObject)(schemaNode.properties)) {
                                    var props = Object.keys(schemaNode.properties);
                                    suggestionsObj[currectPath] = suggestionsObj[currectPath] || {};
                                    suggestionsObj[currectPath].props = suggestionsObj[currectPath].props || [];
                                    suggestionsObj[currectPath].props = (0, util.uniqueMergeArrays)(suggestionsObj[currectPath].props, props);
                                    props.forEach(function(prop) {
                                        (0, util.asyncExec)(function() {
                                            _this._handleSchemaEntry("".concat(currectPath, "/").concat(prop), schemaNode.properties[prop], suggestionsObj);
                                        });
                                    });
                                }
                            }
                        },
                        {
                            key: "_handlePrimitive",
                            value: function _handlePrimitive(currectPath, schemaNode, suggestionsObj) {
                                suggestionsObj[currectPath] = suggestionsObj[currectPath] || {};
                                if ((0, util.isArray)(schemaNode.examples)) {
                                    suggestionsObj[currectPath].examples = suggestionsObj[currectPath].examples || [];
                                    suggestionsObj[currectPath].examples = (0, util.uniqueMergeArrays)(suggestionsObj[currectPath].examples, schemaNode.examples);
                                }
                                if ((0, util.isArray)(schemaNode["enum"])) {
                                    suggestionsObj[currectPath]["enum"] = suggestionsObj[currectPath]["enum"] || [];
                                    suggestionsObj[currectPath]["enum"] = (0, util.uniqueMergeArrays)(suggestionsObj[currectPath]["enum"], schemaNode["enum"]);
                                }
                            }
                        },
                        {
                            key: "_handleBoolean",
                            value: function _handleBoolean(currectPath, schemaNode, suggestionsObj) {
                                if (!suggestionsObj[currectPath]) suggestionsObj[currectPath] = {
                                    bool: [
                                        true,
                                        false
                                    ]
                                };
                            }
                        },
                        {
                            key: "_handleArray",
                            value: function _handleArray(currectPath, schemaNode, suggestionsObj) {
                                var _this2 = this;
                                if (schemaNode.items) (0, util.asyncExec)(function() {
                                    _this2._handleSchemaEntry("".concat(currectPath, "/\\d+"), schemaNode.items, suggestionsObj);
                                });
                            }
                        },
                        {
                            key: "_handleOfCondition",
                            value: function _handleOfCondition(currectPath, schemaNode, suggestionsObj) {
                                var _this3 = this;
                                if (schemaNode && schemaNode.length) schemaNode.forEach(function(schemaEntry) {
                                    (0, util.asyncExec)(function() {
                                        _this3._handleSchemaEntry(currectPath, schemaEntry, suggestionsObj);
                                    });
                                });
                            }
                        },
                        {
                            key: "_checkOfConditon",
                            value: function _checkOfConditon(entry) {
                                if (!entry) return;
                                if (entry.oneOf) return "oneOf";
                                if (entry.anyOf) return "anyOf";
                                if (entry.allOf) return "allOf";
                            }
                        },
                        {
                            key: "getCompletions",
                            value: function getCompletions(editor, session, pos, prefix, callback) {
                                var _this4 = this;
                                try {
                                    var map = json_source_map.parse(session.getValue());
                                    var pointers = map.pointers || {};
                                    var processCompletionsCallback = function processCompletionsCallback(suggestions) {
                                        var completions = [];
                                        var score = 0;
                                        var appendSuggesions = function appendSuggesions(type) {
                                            var _suggestions$type;
                                            var typeTitle = {
                                                props: "property",
                                                "enum": "enum",
                                                bool: "boolean",
                                                examples: "examples"
                                            };
                                            if (suggestions && (_suggestions$type = suggestions[type]) !== null && _suggestions$type !== void 0 && _suggestions$type.length) completions = completions.concat(suggestions[type].map(function(term) {
                                                return {
                                                    caption: term + "",
                                                    meta: "schema [".concat(typeTitle[type], "]"),
                                                    score: score++,
                                                    value: term + ""
                                                };
                                            }));
                                        };
                                        appendSuggesions("props");
                                        appendSuggesions("enum");
                                        appendSuggesions("bool");
                                        appendSuggesions("examples");
                                        if (completions.length) callback(null, completions);
                                    };
                                    Object.keys(pointers).forEach(function(ptr) {
                                        (0, util.asyncExec)(function() {
                                            var _pointers$ptr$key, _pointers$ptr$value, _pointers$ptr$value2, _pointers$ptr$valueEn;
                                            var matchPointersToPath = function matchPointersToPath(pointer, currentSuggestions, path) {
                                                var option = Object.keys(currentSuggestions).reduce(function(last, key) {
                                                    if (new RegExp("^".concat(path).concat(key)).test(pointer)) {
                                                        if (!last || last.length < key.length) return key;
                                                    }
                                                    return last;
                                                });
                                                if (typeof option === "string") {
                                                    var _currentSuggestions$o, _currentSuggestions$o2;
                                                    if ((_currentSuggestions$o = currentSuggestions[option]) !== null && _currentSuggestions$o !== void 0 && (_currentSuggestions$o2 = _currentSuggestions$o.refs) !== null && _currentSuggestions$o2 !== void 0 && _currentSuggestions$o2.length) {
                                                        var mergedSuggestions = {};
                                                        for(var idx in currentSuggestions[option].refs){
                                                            var refName = currentSuggestions[option].refs[idx];
                                                            if (_this4.suggestionsRefs[refName]) {
                                                                var refSuggestion = matchPointersToPath(pointer, _this4.suggestionsRefs[refName], "".concat(path).concat(option));
                                                                if (refSuggestion !== null && refSuggestion !== void 0 && refSuggestion["enum"]) mergedSuggestions["enum"] = (0, util.uniqueMergeArrays)(mergedSuggestions["enum"], refSuggestion["enum"]);
                                                                if (refSuggestion !== null && refSuggestion !== void 0 && refSuggestion.examples) mergedSuggestions.examples = (0, util.uniqueMergeArrays)(mergedSuggestions.examples, refSuggestion.examples);
                                                                if (refSuggestion !== null && refSuggestion !== void 0 && refSuggestion.bool) mergedSuggestions.bool = (0, util.uniqueMergeArrays)(mergedSuggestions.bool, refSuggestion.bool);
                                                                if (refSuggestion !== null && refSuggestion !== void 0 && refSuggestion.props) mergedSuggestions.props = (0, util.uniqueMergeArrays)(mergedSuggestions.props, refSuggestion.props);
                                                            }
                                                        }
                                                        return mergedSuggestions;
                                                    } else if (new RegExp("^".concat(path).concat(option, "$")).test(pointer)) // console.log('SchemaTextCompleter: Text suggestion match', { path: pointer, schemaPath: `${path}${option}`, suggestions: currentSuggestions[option] })
                                                    return currentSuggestions[option];
                                                }
                                            };
                                            var selectedPtr;
                                            if (((_pointers$ptr$key = pointers[ptr].key) === null || _pointers$ptr$key === void 0 ? void 0 : _pointers$ptr$key.line) === pos.row) {
                                                if (pos.column >= pointers[ptr].key.column && pos.column <= pointers[ptr].keyEnd.column) selectedPtr = ptr.slice(0, ptr.lastIndexOf("/"));
                                            }
                                            if (((_pointers$ptr$value = pointers[ptr].value) === null || _pointers$ptr$value === void 0 ? void 0 : _pointers$ptr$value.line) === pos.row && ((_pointers$ptr$value2 = pointers[ptr].value) === null || _pointers$ptr$value2 === void 0 ? void 0 : _pointers$ptr$value2.line) === ((_pointers$ptr$valueEn = pointers[ptr].valueEnd) === null || _pointers$ptr$valueEn === void 0 ? void 0 : _pointers$ptr$valueEn.line)) // multiline values are objects
                                            {
                                                if (pos.column >= pointers[ptr].value.column && pos.column <= pointers[ptr].valueEnd.column) selectedPtr = ptr;
                                            }
                                            if (selectedPtr) {
                                                var chosenCompletions = matchPointersToPath(selectedPtr, _this4.suggestions, "");
                                                processCompletionsCallback(chosenCompletions);
                                            }
                                        });
                                    });
                                } catch (e) {
                                // probably not valid json, ignore.
                                }
                            }
                        }
                    ]);
                    return SchemaTextCompleter;
                }();
                /**
 * Execute custom validation if configured.
 *
 * Returns a promise resolving with the custom errors (or an empty array).
 */ function validateCustom(json, onValidate) {
                    if (!onValidate) return Promise.resolve([]);
                    try {
                        var customValidateResults = onValidate(json);
                        var resultPromise = (0, util.isPromise)(customValidateResults) ? customValidateResults : Promise.resolve(customValidateResults);
                        return resultPromise.then(function(customValidationPathErrors) {
                            if (Array.isArray(customValidationPathErrors)) return customValidationPathErrors.filter(function(error) {
                                var valid = (0, util.isValidValidationError)(error);
                                if (!valid) console.warn('Ignoring a custom validation error with invalid structure. Expected structure: {path: [...], message: "..."}. Actual error:', error);
                                return valid;
                            }).map(function(error) {
                                return(// change data structure into the structure matching the JSON schema errors
                                {
                                    dataPath: (0, util.stringifyPath)(error.path),
                                    message: error.message,
                                    type: "customValidation"
                                });
                            });
                            else return [];
                        });
                    } catch (err) {
                        return Promise.reject(err);
                    }
                }
                function textmode_typeof(obj) {
                    "@babel/helpers - typeof";
                    return textmode_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
                        return typeof obj;
                    } : function(obj) {
                        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
                    }, textmode_typeof(obj);
                }
                // create a mixin with the functions for text mode
                var textmode = {};
                var DEFAULT_THEME = "ace/theme/jsoneditor";
                /**
 * Create a text editor
 * @param {Element} container
 * @param {Object} [options]   Object with options. See docs for details.
 * @private
 */ textmode.create = function(container) {
                    var _this = this;
                    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                    if (typeof options.statusBar === "undefined") options.statusBar = true;
                    // setting default for textmode
                    options.mainMenuBar = options.mainMenuBar !== false;
                    options.enableSort = options.enableSort !== false;
                    options.enableTransform = options.enableTransform !== false;
                    options.createQuery = options.createQuery || jmespathQuery /* createQuery */ .r;
                    options.executeQuery = options.executeQuery || jmespathQuery /* executeQuery */ .J;
                    options.showErrorTable = options.showErrorTable !== undefined ? options.showErrorTable : [
                        "text",
                        "preview"
                    ];
                    this.options = options;
                    // indentation
                    if (typeof options.indentation === "number") this.indentation = Number(options.indentation);
                    else this.indentation = 2; // number of spaces
                    // language
                    (0, i18n /* setLanguages */ .cC)(this.options.languages);
                    (0, i18n /* setLanguage */ .m0)(this.options.language);
                    // grab ace from options if provided
                    var _ace = options.ace ? options.ace : ace_default();
                    // TODO: make the option options.ace deprecated, it's not needed anymore (see #309)
                    // determine mode
                    this.mode = options.mode === "code" ? "code" : "text";
                    if (this.mode === "code") // verify whether Ace editor is available and supported
                    {
                        if (typeof _ace === "undefined") {
                            this.mode = "text";
                            console.warn("Failed to load Ace editor, falling back to plain text mode. Please use a JSONEditor bundle including Ace, or pass Ace as via the configuration option `ace`.");
                        }
                    }
                    // determine theme
                    this.theme = options.theme || DEFAULT_THEME;
                    if (this.theme === DEFAULT_THEME && _ace) (0, tryRequireThemeJsonEditor /* tryRequireThemeJsonEditor */ .O)();
                    if (options.onTextSelectionChange) this.onTextSelectionChange(options.onTextSelectionChange);
                    var me = this;
                    this.container = container;
                    this.dom = {};
                    this.aceEditor = undefined; // ace code editor
                    this.textarea = undefined; // plain text editor (fallback when Ace is not available)
                    this.validateSchema = null;
                    this.annotations = [];
                    this.lastSchemaErrors = undefined;
                    // create a debounced validate function
                    this._debouncedValidate = (0, util.debounce)(this._validateAndCatch.bind(this), this.DEBOUNCE_INTERVAL);
                    this.width = container.clientWidth;
                    this.height = container.clientHeight;
                    this.frame = document.createElement("div");
                    this.frame.className = "jsoneditor jsoneditor-mode-" + this.options.mode;
                    this.frame.onclick = function(event) {
                        // prevent default submit action when the editor is located inside a form
                        event.preventDefault();
                    };
                    this.frame.onkeydown = function(event) {
                        me._onKeyDown(event);
                    };
                    // setting the FocusTracker on 'this.frame' to track the editor's focus event
                    var focusTrackerConfig = {
                        target: this.frame,
                        onFocus: this.options.onFocus || null,
                        onBlur: this.options.onBlur || null
                    };
                    this.frameFocusTracker = new FocusTracker /* FocusTracker */ .R(focusTrackerConfig);
                    this.content = document.createElement("div");
                    this.content.className = "jsoneditor-outer";
                    if (this.options.mainMenuBar) {
                        (0, util.addClassName)(this.content, "has-main-menu-bar");
                        // create menu
                        this.menu = document.createElement("div");
                        this.menu.className = "jsoneditor-menu";
                        this.frame.appendChild(this.menu);
                        // create format button
                        var buttonFormat = document.createElement("button");
                        buttonFormat.type = "button";
                        buttonFormat.className = "jsoneditor-format";
                        buttonFormat.title = (0, i18n /* translate */ .Iu)("formatTitle");
                        this.menu.appendChild(buttonFormat);
                        buttonFormat.onclick = function() {
                            try {
                                me.format();
                                me._onChange();
                            } catch (err) {
                                me._onError(err);
                            }
                        };
                        // create compact button
                        var buttonCompact = document.createElement("button");
                        buttonCompact.type = "button";
                        buttonCompact.className = "jsoneditor-compact";
                        buttonCompact.title = (0, i18n /* translate */ .Iu)("compactTitle");
                        this.menu.appendChild(buttonCompact);
                        buttonCompact.onclick = function() {
                            try {
                                me.compact();
                                me._onChange();
                            } catch (err) {
                                me._onError(err);
                            }
                        };
                        // create sort button
                        if (this.options.enableSort) {
                            var _sort = document.createElement("button");
                            _sort.type = "button";
                            _sort.className = "jsoneditor-sort";
                            _sort.title = (0, i18n /* translate */ .Iu)("sortTitleShort");
                            _sort.onclick = function() {
                                me._showSortModal();
                            };
                            this.menu.appendChild(_sort);
                        }
                        // create transform button
                        if (this.options.enableTransform) {
                            var transform = document.createElement("button");
                            transform.type = "button";
                            transform.title = (0, i18n /* translate */ .Iu)("transformTitleShort");
                            transform.className = "jsoneditor-transform";
                            transform.onclick = function() {
                                me._showTransformModal();
                            };
                            this.menu.appendChild(transform);
                        }
                        // create repair button
                        var buttonRepair = document.createElement("button");
                        buttonRepair.type = "button";
                        buttonRepair.className = "jsoneditor-repair";
                        buttonRepair.title = (0, i18n /* translate */ .Iu)("repairTitle");
                        this.menu.appendChild(buttonRepair);
                        buttonRepair.onclick = function() {
                            try {
                                me.repair();
                                me._onChange();
                            } catch (err) {
                                me._onError(err);
                            }
                        };
                        // create undo/redo buttons
                        if (this.mode === "code") {
                            // create undo button
                            var undo = document.createElement("button");
                            undo.type = "button";
                            undo.className = "jsoneditor-undo jsoneditor-separator";
                            undo.title = (0, i18n /* translate */ .Iu)("undo");
                            undo.onclick = function() {
                                _this.aceEditor.getSession().getUndoManager().undo();
                            };
                            this.menu.appendChild(undo);
                            this.dom.undo = undo;
                            // create redo button
                            var redo = document.createElement("button");
                            redo.type = "button";
                            redo.className = "jsoneditor-redo";
                            redo.title = (0, i18n /* translate */ .Iu)("redo");
                            redo.onclick = function() {
                                _this.aceEditor.getSession().getUndoManager().redo();
                            };
                            this.menu.appendChild(redo);
                            this.dom.redo = redo;
                        }
                        // create mode box
                        if (this.options && this.options.modes && this.options.modes.length) this.modeSwitcher = new ModeSwitcher /* ModeSwitcher */ .x(this.menu, this.options.modes, this.options.mode, function onSwitch(mode) {
                            // switch mode and restore focus
                            try {
                                me.setMode(mode);
                                me.modeSwitcher.focus();
                            } catch (err) {
                                me._onError(err);
                            }
                        });
                        if (this.mode === "code") {
                            var poweredBy = document.createElement("a");
                            poweredBy.appendChild(document.createTextNode("powered by ace"));
                            poweredBy.href = "https://ace.c9.io/";
                            poweredBy.target = "_blank";
                            poweredBy.className = "jsoneditor-poweredBy";
                            poweredBy.onclick = function() {
                                // TODO: this anchor falls below the margin of the content,
                                // therefore the normal a.href does not work. We use a click event
                                // for now, but this should be fixed.
                                window.open(poweredBy.href, poweredBy.target, "noreferrer");
                            };
                            this.menu.appendChild(poweredBy);
                        }
                    }
                    var emptyNode = {};
                    var isReadOnly = this.options.onEditable && textmode_typeof(this.options.onEditable === "function") && !this.options.onEditable(emptyNode);
                    this.frame.appendChild(this.content);
                    this.container.appendChild(this.frame);
                    if (this.mode === "code") {
                        this.editorDom = document.createElement("div");
                        this.editorDom.style.height = "100%"; // TODO: move to css
                        this.editorDom.style.width = "100%"; // TODO: move to css
                        this.content.appendChild(this.editorDom);
                        var aceEditor = _ace.edit(this.editorDom);
                        var aceSession = aceEditor.getSession();
                        aceEditor.$blockScrolling = Infinity;
                        aceEditor.setTheme(this.theme);
                        aceEditor.setOptions({
                            readOnly: isReadOnly
                        });
                        aceEditor.setShowPrintMargin(false);
                        aceEditor.setFontSize("14px");
                        aceSession.setMode("ace/mode/json");
                        aceSession.setTabSize(this.indentation);
                        aceSession.setUseSoftTabs(true);
                        aceSession.setUseWrapMode(true);
                        // replace ace setAnnotations with custom function that also covers jsoneditor annotations
                        var originalSetAnnotations = aceSession.setAnnotations;
                        aceSession.setAnnotations = function(annotations) {
                            originalSetAnnotations.call(this, annotations && annotations.length ? annotations : me.annotations);
                        };
                        // disable Ctrl+L quickkey of Ace (is used by the browser to select the address bar)
                        aceEditor.commands.bindKey("Ctrl-L", null);
                        aceEditor.commands.bindKey("Command-L", null);
                        // disable the quickkeys we want to use for Format and Compact
                        aceEditor.commands.bindKey("Ctrl-\\", null);
                        aceEditor.commands.bindKey("Command-\\", null);
                        aceEditor.commands.bindKey("Ctrl-Shift-\\", null);
                        aceEditor.commands.bindKey("Command-Shift-\\", null);
                        this.aceEditor = aceEditor;
                        // register onchange event
                        aceEditor.on("change", this._onChange.bind(this));
                        aceEditor.on("changeSelection", this._onSelect.bind(this));
                    } else {
                        // load a plain text textarea
                        var textarea = document.createElement("textarea");
                        textarea.className = "jsoneditor-text";
                        textarea.spellcheck = false;
                        this.content.appendChild(textarea);
                        this.textarea = textarea;
                        this.textarea.readOnly = isReadOnly;
                        // register onchange event
                        if (this.textarea.oninput === null) this.textarea.oninput = this._onChange.bind(this);
                        else // oninput is undefined. For IE8-
                        this.textarea.onchange = this._onChange.bind(this);
                        textarea.onselect = this._onSelect.bind(this);
                        textarea.onmousedown = this._onMouseDown.bind(this);
                        textarea.onblur = this._onBlur.bind(this);
                    }
                    this._updateHistoryButtons();
                    var errorTableVisible = Array.isArray(this.options.showErrorTable) ? this.options.showErrorTable.includes(this.mode) : this.options.showErrorTable === true;
                    this.errorTable = new ErrorTable /* ErrorTable */ .Q({
                        errorTableVisible: errorTableVisible,
                        onToggleVisibility: function onToggleVisibility() {
                            me._validateAndCatch();
                        },
                        onFocusLine: function onFocusLine(line) {
                            me.isFocused = true;
                            if (!isNaN(line)) me.setTextSelection({
                                row: line,
                                column: 1
                            }, {
                                row: line,
                                column: 1000
                            });
                        },
                        onChangeHeight: function onChangeHeight(height) {
                            // TODO: change CSS to using flex box, remove setting height using JavaScript
                            var statusBarHeight = me.dom.statusBar ? me.dom.statusBar.clientHeight : 0;
                            var totalHeight = height + statusBarHeight + 1;
                            me.content.style.marginBottom = -totalHeight + "px";
                            me.content.style.paddingBottom = totalHeight + "px";
                        }
                    });
                    this.frame.appendChild(this.errorTable.getErrorTable());
                    if (options.statusBar) {
                        (0, util.addClassName)(this.content, "has-status-bar");
                        this.curserInfoElements = {};
                        var statusBar = document.createElement("div");
                        this.dom.statusBar = statusBar;
                        statusBar.className = "jsoneditor-statusbar";
                        this.frame.appendChild(statusBar);
                        var lnLabel = document.createElement("span");
                        lnLabel.className = "jsoneditor-curserinfo-label";
                        lnLabel.innerText = "Ln:";
                        var lnVal = document.createElement("span");
                        lnVal.className = "jsoneditor-curserinfo-val";
                        lnVal.innerText = "1";
                        statusBar.appendChild(lnLabel);
                        statusBar.appendChild(lnVal);
                        var colLabel = document.createElement("span");
                        colLabel.className = "jsoneditor-curserinfo-label";
                        colLabel.innerText = "Col:";
                        var colVal = document.createElement("span");
                        colVal.className = "jsoneditor-curserinfo-val";
                        colVal.innerText = "1";
                        statusBar.appendChild(colLabel);
                        statusBar.appendChild(colVal);
                        this.curserInfoElements.colVal = colVal;
                        this.curserInfoElements.lnVal = lnVal;
                        var countLabel = document.createElement("span");
                        countLabel.className = "jsoneditor-curserinfo-label";
                        countLabel.innerText = "characters selected";
                        countLabel.style.display = "none";
                        var countVal = document.createElement("span");
                        countVal.className = "jsoneditor-curserinfo-count";
                        countVal.innerText = "0";
                        countVal.style.display = "none";
                        this.curserInfoElements.countLabel = countLabel;
                        this.curserInfoElements.countVal = countVal;
                        statusBar.appendChild(countVal);
                        statusBar.appendChild(countLabel);
                        statusBar.appendChild(this.errorTable.getErrorCounter());
                        statusBar.appendChild(this.errorTable.getWarningIcon());
                        statusBar.appendChild(this.errorTable.getErrorIcon());
                    }
                    this.setSchema(this.options.schema, this.options.schemaRefs);
                };
                textmode._onSchemaChange = function(schema, schemaRefs) {
                    if (!this.aceEditor) return;
                    if (this.options.allowSchemaSuggestions && schema) {
                        this.aceEditor.setOption("enableBasicAutocompletion", [
                            new SchemaTextCompleter(schema, schemaRefs)
                        ]);
                        this.aceEditor.setOption("enableLiveAutocompletion", true);
                    } else {
                        this.aceEditor.setOption("enableBasicAutocompletion", undefined);
                        this.aceEditor.setOption("enableLiveAutocompletion", false);
                    }
                };
                /**
 * Handle a change:
 * - Validate JSON schema
 * - Send a callback to the onChange listener if provided
 * @private
 */ textmode._onChange = function() {
                    var _this2 = this;
                    if (this.onChangeDisabled) return;
                    // enable/disable undo/redo buttons
                    setTimeout(function() {
                        if (_this2._updateHistoryButtons) _this2._updateHistoryButtons();
                    });
                    // validate JSON schema (if configured)
                    this._debouncedValidate();
                    // trigger the onChange callback
                    if (this.options.onChange) try {
                        this.options.onChange();
                    } catch (err) {
                        console.error("Error in onChange callback: ", err);
                    }
                    // trigger the onChangeText callback
                    if (this.options.onChangeText) try {
                        this.options.onChangeText(this.getText());
                    } catch (err) {
                        console.error("Error in onChangeText callback: ", err);
                    }
                };
                textmode._updateHistoryButtons = function() {
                    if (this.aceEditor && this.dom.undo && this.dom.redo) {
                        var undoManager = this.aceEditor.getSession().getUndoManager();
                        if (undoManager && undoManager.hasUndo && undoManager.hasRedo) {
                            this.dom.undo.disabled = !undoManager.hasUndo();
                            this.dom.redo.disabled = !undoManager.hasRedo();
                        }
                    }
                };
                /**
 * Open a sort modal
 * @private
 */ textmode._showSortModal = function() {
                    try {
                        var onSort = function onSort(sortedBy) {
                            if (Array.isArray(json)) {
                                var sortedJson = (0, util.sort)(json, sortedBy.path, sortedBy.direction);
                                me.sortedBy = sortedBy;
                                me.update(sortedJson);
                            }
                            if ((0, util.isObject)(json)) {
                                var _sortedJson = (0, util.sortObjectKeys)(json, sortedBy.direction);
                                me.sortedBy = sortedBy;
                                me.update(_sortedJson);
                            }
                        };
                        var me = this;
                        var container = this.options.modalAnchor || constants /* DEFAULT_MODAL_ANCHOR */ .qD;
                        var json = this.get();
                        (0, showSortModal.showSortModal)(container, json, onSort, me.sortedBy);
                    } catch (err) {
                        this._onError(err);
                    }
                };
                /**
 * Open a transform modal
 * @private
 */ textmode._showTransformModal = function() {
                    var _this3 = this;
                    try {
                        var _this$options = this.options, modalAnchor = _this$options.modalAnchor, _createQuery = _this$options.createQuery, _executeQuery = _this$options.executeQuery, queryDescription = _this$options.queryDescription;
                        var json = this.get();
                        (0, showTransformModal.showTransformModal)({
                            container: modalAnchor || constants /* DEFAULT_MODAL_ANCHOR */ .qD,
                            json: json,
                            queryDescription: queryDescription,
                            // can be undefined
                            createQuery: _createQuery,
                            executeQuery: _executeQuery,
                            onTransform: function onTransform(query) {
                                var updatedJson = _executeQuery(json, query);
                                _this3.update(updatedJson);
                            }
                        });
                    } catch (err) {
                        this._onError(err);
                    }
                };
                /**
 * Handle text selection
 * Calculates the cursor position and selection range and updates menu
 * @private
 */ textmode._onSelect = function() {
                    this._updateCursorInfo();
                    this._emitSelectionChange();
                };
                /**
 * Event handler for keydown. Handles shortcut keys
 * @param {Event} event
 * @private
 */ textmode._onKeyDown = function(event) {
                    var keynum = event.which || event.keyCode;
                    var handled = false;
                    if (keynum === 73 && event.ctrlKey) {
                        if (event.shiftKey) {
                            // Ctrl+Shift+I
                            this.compact();
                            this._onChange();
                        } else {
                            // Ctrl+I
                            this.format();
                            this._onChange();
                        }
                        handled = true;
                    }
                    if (handled) {
                        event.preventDefault();
                        event.stopPropagation();
                    }
                    this._updateCursorInfo();
                    this._emitSelectionChange();
                };
                /**
 * Event handler for mousedown.
 * @private
 */ textmode._onMouseDown = function() {
                    this._updateCursorInfo();
                    this._emitSelectionChange();
                };
                /**
 * Event handler for blur.
 * @private
 */ textmode._onBlur = function() {
                    var me = this;
                    // this allows to avoid blur when clicking inner elements (like the errors panel)
                    // just make sure to set the isFocused to true on the inner element onclick callback
                    setTimeout(function() {
                        if (!me.isFocused) {
                            me._updateCursorInfo();
                            me._emitSelectionChange();
                        }
                        me.isFocused = false;
                    });
                };
                /**
 * Update the cursor info and the status bar, if presented
 */ textmode._updateCursorInfo = function() {
                    var me = this;
                    var line, col, count;
                    if (this.textarea) setTimeout(function() {
                        // this to verify we get the most updated textarea cursor selection
                        var selectionRange = (0, util.getInputSelection)(me.textarea);
                        if (selectionRange.startIndex !== selectionRange.endIndex) count = selectionRange.endIndex - selectionRange.startIndex;
                        if (count && me.cursorInfo && me.cursorInfo.line === selectionRange.end.row && me.cursorInfo.column === selectionRange.end.column) {
                            line = selectionRange.start.row;
                            col = selectionRange.start.column;
                        } else {
                            line = selectionRange.end.row;
                            col = selectionRange.end.column;
                        }
                        me.cursorInfo = {
                            line: line,
                            column: col,
                            count: count
                        };
                        if (me.options.statusBar) updateDisplay();
                    }, 0);
                    else if (this.aceEditor && this.curserInfoElements) {
                        var curserPos = this.aceEditor.getCursorPosition();
                        var selectedText = this.aceEditor.getSelectedText();
                        line = curserPos.row + 1;
                        col = curserPos.column + 1;
                        count = selectedText.length;
                        me.cursorInfo = {
                            line: line,
                            column: col,
                            count: count
                        };
                        if (this.options.statusBar) updateDisplay();
                    }
                    function updateDisplay() {
                        if (me.curserInfoElements.countVal.innerText !== count) {
                            me.curserInfoElements.countVal.innerText = count;
                            me.curserInfoElements.countVal.style.display = count ? "inline" : "none";
                            me.curserInfoElements.countLabel.style.display = count ? "inline" : "none";
                        }
                        me.curserInfoElements.lnVal.innerText = line;
                        me.curserInfoElements.colVal.innerText = col;
                    }
                };
                /**
 * emits selection change callback, if given
 * @private
 */ textmode._emitSelectionChange = function() {
                    if (this._selectionChangedHandler) {
                        var currentSelection = this.getTextSelection();
                        this._selectionChangedHandler(currentSelection.start, currentSelection.end, currentSelection.text);
                    }
                };
                /**
 * refresh ERROR annotations state
 * error annotations are handled by the ace json mode (ace/mode/json)
 * validation annotations are handled by this mode
 * therefore in order to refresh we send only the annotations of error type in order to maintain its state
 * @private
 */ textmode._refreshAnnotations = function() {
                    var session = this.aceEditor && this.aceEditor.getSession();
                    if (session) {
                        var errEnnotations = session.getAnnotations().filter(function(annotation) {
                            return annotation.type === "error";
                        });
                        session.setAnnotations(errEnnotations);
                    }
                };
                /**
 * Destroy the editor. Clean up DOM, event listeners, and web workers.
 */ textmode.destroy = function() {
                    // remove old ace editor
                    if (this.aceEditor) {
                        this.aceEditor.destroy();
                        this.aceEditor = null;
                    }
                    if (this.frame && this.container && this.frame.parentNode === this.container) this.container.removeChild(this.frame);
                    if (this.modeSwitcher) {
                        this.modeSwitcher.destroy();
                        this.modeSwitcher = null;
                    }
                    this.textarea = null;
                    this._debouncedValidate = null;
                    // Removing the FocusTracker set to track the editor's focus event
                    this.frameFocusTracker.destroy();
                };
                /**
 * Compact the code in the text editor
 */ textmode.compact = function() {
                    var json = this.get();
                    var text = JSON.stringify(json);
                    this.updateText(text);
                };
                /**
 * Format the code in the text editor
 */ textmode.format = function() {
                    var json = this.get();
                    var text = JSON.stringify(json, null, this.indentation);
                    this.updateText(text);
                };
                /**
 * Repair the code in the text editor
 */ textmode.repair = function() {
                    var text = this.getText();
                    try {
                        var repairedText = (0, jsonrepair /* jsonrepair */ .K)(text);
                        this.updateText(repairedText);
                    } catch (err) {
                    // repair was not successful, do nothing
                    }
                };
                /**
 * Set focus to the formatter
 */ textmode.focus = function() {
                    if (this.textarea) this.textarea.focus();
                    if (this.aceEditor) this.aceEditor.focus();
                };
                /**
 * Resize the formatter
 */ textmode.resize = function() {
                    if (this.aceEditor) {
                        var force = false;
                        this.aceEditor.resize(force);
                    }
                };
                /**
 * Set json data in the formatter
 * @param {*} json
 */ textmode.set = function(json) {
                    this.setText(JSON.stringify(json, null, this.indentation));
                };
                /**
 * Update data. Same as calling `set` in text/code mode.
 * @param {*} json
 */ textmode.update = function(json) {
                    this.updateText(JSON.stringify(json, null, this.indentation));
                };
                /**
 * Get json data from the formatter
 * @return {*} json
 */ textmode.get = function() {
                    var text = this.getText();
                    return (0, util.parse)(text); // this can throw an error
                };
                /**
 * Get the text contents of the editor
 * @return {String} jsonText
 */ textmode.getText = function() {
                    if (this.textarea) return this.textarea.value;
                    if (this.aceEditor) return this.aceEditor.getValue();
                    return "";
                };
                /**
 * Set the text contents of the editor and optionally clear the history
 * @param {String} jsonText
 * @param {boolean} clearHistory   Only applicable for mode 'code'
 * @private
 */ textmode._setText = function(jsonText, clearHistory) {
                    var _this4 = this;
                    var text = this.options.escapeUnicode === true ? (0, util.escapeUnicodeChars)(jsonText) : jsonText;
                    if (this.textarea) this.textarea.value = text;
                    if (this.aceEditor) {
                        // prevent emitting onChange events while setting new text
                        this.onChangeDisabled = true;
                        this.aceEditor.setValue(text, -1);
                        this.onChangeDisabled = false;
                        if (clearHistory) {
                            // prevent initial undo action clearing the initial contents
                            var me = this;
                            setTimeout(function() {
                                if (me.aceEditor) me.aceEditor.session.getUndoManager().reset();
                            });
                        }
                        setTimeout(function() {
                            if (_this4._updateHistoryButtons) _this4._updateHistoryButtons();
                        });
                    }
                    // validate JSON schema
                    this._debouncedValidate();
                };
                /**
 * Set the text contents of the editor
 * @param {String} jsonText
 */ textmode.setText = function(jsonText) {
                    this._setText(jsonText, true);
                };
                /**
 * Update the text contents
 * @param {string} jsonText
 */ textmode.updateText = function(jsonText) {
                    // don't update if there are no changes
                    if (this.getText() === jsonText) return;
                    this._setText(jsonText, false);
                };
                /**
 * Validate current JSON object against the configured JSON schema
 * Throws an exception when no JSON schema is configured
 */ textmode.validate = function() {
                    var _this5 = this;
                    var schemaErrors = [];
                    var parseErrors = [];
                    var json;
                    try {
                        json = this.get(); // this can fail when there is no valid json
                        // execute JSON schema validation (ajv)
                        if (this.validateSchema) {
                            var valid = this.validateSchema(json);
                            if (!valid) schemaErrors = this.validateSchema.errors.map(function(error) {
                                error.type = "validation";
                                return (0, util.improveSchemaError)(error);
                            });
                        }
                        // execute custom validation and after than merge and render all errors
                        // TODO: implement a better mechanism for only using the last validation action
                        this.validationSequence = (this.validationSequence || 0) + 1;
                        var me = this;
                        var seq = this.validationSequence;
                        return validateCustom(json, this.options.onValidate).then(function(customValidationErrors) {
                            // only apply when there was no other validation started whilst resolving async results
                            if (seq === me.validationSequence) {
                                var errors = schemaErrors.concat(parseErrors).concat(customValidationErrors);
                                me._renderErrors(errors);
                                if (typeof _this5.options.onValidationError === "function" && (0, util.isValidationErrorChanged)(errors, _this5.lastSchemaErrors)) _this5.options.onValidationError.call(_this5, errors);
                                _this5.lastSchemaErrors = errors;
                            }
                            return _this5.lastSchemaErrors;
                        });
                    } catch (err) {
                        if (this.getText()) {
                            // try to extract the line number from the jsonlint error message
                            var match = /\w*line\s*(\d+)\w*/g.exec(err.message);
                            var line;
                            if (match) line = +match[1];
                            parseErrors = [
                                {
                                    type: "error",
                                    message: err.message.replace(/\n/g, "<br>"),
                                    line: line
                                }
                            ];
                        }
                        this._renderErrors(parseErrors);
                        if (typeof this.options.onValidationError === "function" && (0, util.isValidationErrorChanged)(parseErrors, this.lastSchemaErrors)) this.options.onValidationError.call(this, parseErrors);
                        this.lastSchemaErrors = parseErrors;
                        return Promise.resolve(this.lastSchemaErrors);
                    }
                };
                textmode._validateAndCatch = function() {
                    this.validate()["catch"](function(err) {
                        console.error("Error running validation:", err);
                    });
                };
                textmode._renderErrors = function(errors) {
                    var jsonText = this.getText();
                    var errorPaths = [];
                    errors.reduce(function(acc, curr) {
                        if (typeof curr.dataPath === "string" && acc.indexOf(curr.dataPath) === -1) acc.push(curr.dataPath);
                        return acc;
                    }, errorPaths);
                    var errorLocations = (0, util.getPositionForPath)(jsonText, errorPaths);
                    // render annotations in Ace Editor (if any)
                    if (this.aceEditor) {
                        this.annotations = errorLocations.map(function(errLoc) {
                            var validationErrors = errors.filter(function(err) {
                                return err.dataPath === errLoc.path;
                            });
                            var message = validationErrors.map(function(err) {
                                return err.message;
                            }).join("\n");
                            if (message) return {
                                row: errLoc.line,
                                column: errLoc.column,
                                text: "Schema validation error" + (validationErrors.length !== 1 ? "s" : "") + ": \n" + message,
                                type: "warning",
                                source: "jsoneditor"
                            };
                            return {};
                        });
                        this._refreshAnnotations();
                    }
                    // render errors in the errors table (if any)
                    this.errorTable.setErrors(errors, errorLocations);
                    // update the height of the ace editor
                    if (this.aceEditor) {
                        var force = false;
                        this.aceEditor.resize(force);
                    }
                };
                /**
 * Get the selection details
 * @returns {{start:{row:Number, column:Number},end:{row:Number, column:Number},text:String}}
 */ textmode.getTextSelection = function() {
                    var selection = {};
                    if (this.textarea) {
                        var selectionRange = (0, util.getInputSelection)(this.textarea);
                        if (this.cursorInfo && this.cursorInfo.line === selectionRange.end.row && this.cursorInfo.column === selectionRange.end.column) {
                            // selection direction is bottom => up
                            selection.start = selectionRange.end;
                            selection.end = selectionRange.start;
                        } else selection = selectionRange;
                        return {
                            start: selection.start,
                            end: selection.end,
                            text: this.textarea.value.substring(selectionRange.startIndex, selectionRange.endIndex)
                        };
                    }
                    if (this.aceEditor) {
                        var aceSelection = this.aceEditor.getSelection();
                        var selectedText = this.aceEditor.getSelectedText();
                        var range = aceSelection.getRange();
                        var lead = aceSelection.getSelectionLead();
                        if (lead.row === range.end.row && lead.column === range.end.column) selection = range;
                        else {
                            // selection direction is bottom => up
                            selection.start = range.end;
                            selection.end = range.start;
                        }
                        return {
                            start: {
                                row: selection.start.row + 1,
                                column: selection.start.column + 1
                            },
                            end: {
                                row: selection.end.row + 1,
                                column: selection.end.column + 1
                            },
                            text: selectedText
                        };
                    }
                };
                /**
 * Callback registration for selection change
 * @param {selectionCallback} callback
 *
 * @callback selectionCallback
 */ textmode.onTextSelectionChange = function(callback) {
                    if (typeof callback === "function") this._selectionChangedHandler = (0, util.debounce)(callback, this.DEBOUNCE_INTERVAL);
                };
                /**
 * Set selection on editor's text
 * @param {{row:Number, column:Number}} startPos selection start position
 * @param {{row:Number, column:Number}} endPos selected end position
 */ textmode.setTextSelection = function(startPos, endPos) {
                    if (!startPos || !endPos) return;
                    if (this.textarea) {
                        var startIndex = (0, util.getIndexForPosition)(this.textarea, startPos.row, startPos.column);
                        var endIndex = (0, util.getIndexForPosition)(this.textarea, endPos.row, endPos.column);
                        if (startIndex > -1 && endIndex > -1) {
                            if (this.textarea.setSelectionRange) {
                                this.textarea.focus();
                                this.textarea.setSelectionRange(startIndex, endIndex);
                            } else if (this.textarea.createTextRange) {
                                // IE < 9
                                var range = this.textarea.createTextRange();
                                range.collapse(true);
                                range.moveEnd("character", endIndex);
                                range.moveStart("character", startIndex);
                                range.select();
                            }
                            var rows = (this.textarea.value.match(/\n/g) || []).length + 1;
                            var lineHeight = this.textarea.scrollHeight / rows;
                            var selectionScrollPos = startPos.row * lineHeight;
                            this.textarea.scrollTop = selectionScrollPos > this.textarea.clientHeight ? selectionScrollPos - this.textarea.clientHeight / 2 : 0;
                        }
                    } else if (this.aceEditor) {
                        var _range = {
                            start: {
                                row: startPos.row - 1,
                                column: startPos.column - 1
                            },
                            end: {
                                row: endPos.row - 1,
                                column: endPos.column - 1
                            }
                        };
                        this.aceEditor.selection.setRange(_range);
                        this.aceEditor.scrollToLine(startPos.row - 1, true);
                    }
                };
                function load() {
                    try {
                        this.format();
                    } catch (err) {
                    // in case of an error, just move on, failing formatting is not a big deal
                    }
                }
                // define modes
                var textModeMixins = [
                    {
                        mode: "text",
                        mixin: textmode,
                        data: "text",
                        load: load
                    },
                    {
                        mode: "code",
                        mixin: textmode,
                        data: "text",
                        load: load
                    }
                ];
            /***/ },
            /***/ 38: /***/ function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {
                "use strict";
                // ESM COMPAT FLAG
                __webpack_require__.r(__webpack_exports__);
                // EXPORTS
                __webpack_require__.d(__webpack_exports__, {
                    "treeModeMixins": function() {
                        return /* binding */ treeModeMixins;
                    }
                });
                var defaultFilterFunction = {
                    start: function start(token, match, config) {
                        return match.indexOf(token) === 0;
                    },
                    contain: function contain(token, match, config) {
                        return match.indexOf(token) > -1;
                    }
                };
                function autocomplete(config) {
                    config = config || {};
                    config.filter = config.filter || "start";
                    config.trigger = config.trigger || "keydown";
                    config.confirmKeys = config.confirmKeys || [
                        39,
                        35,
                        9
                    ]; // right, end, tab
                    config.caseSensitive = config.caseSensitive || false; // autocomplete case sensitive
                    var fontSize = "";
                    var fontFamily = "";
                    var wrapper = document.createElement("div");
                    wrapper.style.position = "relative";
                    wrapper.style.outline = "0";
                    wrapper.style.border = "0";
                    wrapper.style.margin = "0";
                    wrapper.style.padding = "0";
                    var dropDown = document.createElement("div");
                    dropDown.className = "autocomplete dropdown";
                    dropDown.style.position = "absolute";
                    dropDown.style.visibility = "hidden";
                    var spacer;
                    var leftSide; // <-- it will contain the leftSide part of the textfield (the bit that was already autocompleted)
                    var createDropDownController = function createDropDownController(elem, rs) {
                        var rows = [];
                        var ix = 0;
                        var oldIndex = -1;
                        // TODO: move this styling in JS to SCSS
                        var onMouseOver = function onMouseOver() {
                            this.style.backgroundColor = "#ddd";
                        };
                        var onMouseOut = function onMouseOut() {
                            this.style.backgroundColor = "";
                        };
                        var onMouseDown = function onMouseDown() {
                            p.hide();
                            p.onmouseselection(this.__hint, p.rs);
                        };
                        var p = {
                            rs: rs,
                            hide: function hide() {
                                elem.style.visibility = "hidden";
                            // rs.hideDropDown();
                            },
                            refresh: function refresh(token, array) {
                                elem.style.visibility = "hidden";
                                ix = 0;
                                elem.textContent = "";
                                var vph = window.innerHeight || document.documentElement.clientHeight;
                                var rect = elem.parentNode.getBoundingClientRect();
                                var distanceToTop = rect.top - 6; // heuristic give 6px
                                var distanceToBottom = vph - rect.bottom - 6; // distance from the browser border.
                                rows = [];
                                var filterFn = typeof config.filter === "function" ? config.filter : defaultFilterFunction[config.filter];
                                var filtered = !filterFn ? [] : array.filter(function(match) {
                                    return filterFn(config.caseSensitive ? token : token.toLowerCase(), config.caseSensitive ? match : match.toLowerCase(), config);
                                });
                                rows = filtered.map(function(row) {
                                    var divRow = document.createElement("div");
                                    divRow.className = "item";
                                    // divRow.style.color = config.color;
                                    divRow.onmouseover = onMouseOver;
                                    divRow.onmouseout = onMouseOut;
                                    divRow.onmousedown = onMouseDown;
                                    divRow.__hint = row;
                                    divRow.textContent = "";
                                    divRow.appendChild(document.createTextNode(row.substring(0, token.length)));
                                    var b = document.createElement("b");
                                    b.appendChild(document.createTextNode(row.substring(token.length)));
                                    divRow.appendChild(b);
                                    elem.appendChild(divRow);
                                    return divRow;
                                });
                                if (rows.length === 0) return; // nothing to show.
                                if (rows.length === 1 && (token.toLowerCase() === rows[0].__hint.toLowerCase() && !config.caseSensitive || token === rows[0].__hint && config.caseSensitive)) return; // do not show the dropDown if it has only one element which matches what we have just displayed.
                                if (rows.length < 2) return;
                                p.highlight(0);
                                if (distanceToTop > distanceToBottom * 3) {
                                    // Heuristic (only when the distance to the to top is 4 times more than distance to the bottom
                                    elem.style.maxHeight = distanceToTop + "px"; // we display the dropDown on the top of the input text
                                    elem.style.top = "";
                                    elem.style.bottom = "100%";
                                } else {
                                    elem.style.top = "100%";
                                    elem.style.bottom = "";
                                    elem.style.maxHeight = distanceToBottom + "px";
                                }
                                elem.style.visibility = "visible";
                            },
                            highlight: function highlight(index) {
                                if (oldIndex !== -1 && rows[oldIndex]) rows[oldIndex].className = "item";
                                rows[index].className = "item hover";
                                oldIndex = index;
                            },
                            move: function move(step) {
                                // moves the selection either up or down (unless it's not possible) step is either +1 or -1.
                                if (elem.style.visibility === "hidden") return ""; // nothing to move if there is no dropDown. (this happens if the user hits escape and then down or up)
                                if (ix + step === -1 || ix + step === rows.length) return rows[ix].__hint; // NO CIRCULAR SCROLLING.
                                ix += step;
                                p.highlight(ix);
                                return rows[ix].__hint; // txtShadow.value = uRows[uIndex].__hint ;
                            },
                            onmouseselection: function onmouseselection() {} // it will be overwritten.
                        };
                        return p;
                    };
                    function setEndOfContenteditable(contentEditableElement) {
                        var range, selection;
                        if (document.createRange) {
                            // Firefox, Chrome, Opera, Safari, IE 9+
                            range = document.createRange(); // Create a range (a range is a like the selection but invisible)
                            range.selectNodeContents(contentEditableElement); // Select the entire contents of the element with the range
                            range.collapse(false); // collapse the range to the end point. false means collapse to end rather than the start
                            selection = window.getSelection(); // get the selection object (allows you to change selection)
                            selection.removeAllRanges(); // remove any selections already made
                            selection.addRange(range); // make the range you have just created the visible selection
                        } else if (document.selection) {
                            // IE 8 and lower
                            range = document.body.createTextRange(); // Create a range (a range is a like the selection but invisible)
                            range.moveToElementText(contentEditableElement); // Select the entire contents of the element with the range
                            range.collapse(false); // collapse the range to the end point. false means collapse to end rather than the start
                            range.select(); // Select the range (make it the visible selection
                        }
                    }
                    function calculateWidthForText(text) {
                        if (spacer === undefined) {
                            // on first call only.
                            spacer = document.createElement("span");
                            spacer.style.visibility = "hidden";
                            spacer.style.position = "fixed";
                            spacer.style.outline = "0";
                            spacer.style.margin = "0";
                            spacer.style.padding = "0";
                            spacer.style.border = "0";
                            spacer.style.left = "0";
                            spacer.style.whiteSpace = "pre";
                            spacer.style.fontSize = fontSize;
                            spacer.style.fontFamily = fontFamily;
                            spacer.style.fontWeight = "normal";
                            document.body.appendChild(spacer);
                        }
                        spacer.textContent = text;
                        return spacer.getBoundingClientRect().right;
                    }
                    var rs = {
                        onArrowDown: function onArrowDown() {},
                        // defaults to no action.
                        onArrowUp: function onArrowUp() {},
                        // defaults to no action.
                        onEnter: function onEnter() {},
                        // defaults to no action.
                        onTab: function onTab() {},
                        // defaults to no action.
                        startFrom: 0,
                        options: [],
                        element: null,
                        elementHint: null,
                        elementStyle: null,
                        wrapper: wrapper,
                        // Only to allow  easy access to the HTML elements to the final user (possibly for minor customizations)
                        show: function show(element, startPos, options) {
                            var _this = this;
                            this.startFrom = startPos;
                            this.wrapper.remove();
                            if (this.elementHint) {
                                this.elementHint.remove();
                                this.elementHint = null;
                            }
                            if (fontSize === "") fontSize = window.getComputedStyle(element).getPropertyValue("font-size");
                            if (fontFamily === "") fontFamily = window.getComputedStyle(element).getPropertyValue("font-family");
                            dropDown.style.marginLeft = "0";
                            dropDown.style.marginTop = element.getBoundingClientRect().height + "px";
                            this.options = options.map(String);
                            if (this.element !== element) {
                                this.element = element;
                                this.elementStyle = {
                                    zIndex: this.element.style.zIndex,
                                    position: this.element.style.position,
                                    backgroundColor: this.element.style.backgroundColor,
                                    borderColor: this.element.style.borderColor
                                };
                            }
                            this.element.style.zIndex = 3;
                            this.element.style.position = "relative";
                            this.element.style.backgroundColor = "transparent";
                            this.element.style.borderColor = "transparent";
                            this.elementHint = element.cloneNode();
                            this.elementHint.className = "autocomplete hint";
                            this.elementHint.style.zIndex = 2;
                            this.elementHint.style.position = "absolute";
                            this.elementHint.onfocus = function() {
                                _this.element.focus();
                            };
                            if (this.element.addEventListener) {
                                this.element.removeEventListener("keydown", keyDownHandler);
                                this.element.addEventListener("keydown", keyDownHandler, false);
                                this.element.removeEventListener("blur", onBlurHandler);
                                this.element.addEventListener("blur", onBlurHandler, false);
                            }
                            wrapper.appendChild(this.elementHint);
                            wrapper.appendChild(dropDown);
                            element.parentElement.appendChild(wrapper);
                            this.repaint(element);
                        },
                        setText: function setText(text) {
                            this.element.innerText = text;
                        },
                        getText: function getText() {
                            return this.element.innerText;
                        },
                        hideDropDown: function hideDropDown() {
                            this.wrapper.remove();
                            if (this.elementHint) {
                                this.elementHint.remove();
                                this.elementHint = null;
                                dropDownController.hide();
                                this.element.style.zIndex = this.elementStyle.zIndex;
                                this.element.style.position = this.elementStyle.position;
                                this.element.style.backgroundColor = this.elementStyle.backgroundColor;
                                this.element.style.borderColor = this.elementStyle.borderColor;
                            }
                        },
                        repaint: function repaint(element) {
                            var text = element.innerText;
                            text = text.replace("\n", "");
                            var optionsLength = this.options.length;
                            // breaking text in leftSide and token.
                            var token = text.substring(this.startFrom);
                            leftSide = text.substring(0, this.startFrom);
                            for(var i = 0; i < optionsLength; i++){
                                var opt = this.options[i];
                                if (!config.caseSensitive && opt.toLowerCase().indexOf(token.toLowerCase()) === 0 || config.caseSensitive && opt.indexOf(token) === 0) {
                                    // <-- how about upperCase vs. lowercase
                                    this.elementHint.innerText = leftSide + token + opt.substring(token.length);
                                    this.elementHint.realInnerText = leftSide + opt;
                                    break;
                                }
                            }
                            // moving the dropDown and refreshing it.
                            dropDown.style.left = calculateWidthForText(leftSide) + "px";
                            dropDownController.refresh(token, this.options);
                            this.elementHint.style.width = calculateWidthForText(this.elementHint.innerText) + 10 + "px";
                            var wasDropDownHidden = dropDown.style.visibility === "hidden";
                            if (!wasDropDownHidden) this.elementHint.style.width = calculateWidthForText(this.elementHint.innerText) + dropDown.clientWidth + "px";
                        }
                    };
                    var dropDownController = createDropDownController(dropDown, rs);
                    var keyDownHandler = (function(e) {
                        // console.log("Keydown:" + e.keyCode);
                        e = e || window.event;
                        var keyCode = e.keyCode;
                        if (this.elementHint == null) return;
                        if (keyCode === 33) return;
                         // page up (do nothing)
                        if (keyCode === 34) return;
                         // page down (do nothing);
                        if (keyCode === 27) {
                            // escape
                            rs.hideDropDown();
                            rs.element.focus();
                            e.preventDefault();
                            e.stopPropagation();
                            return;
                        }
                        var text = this.element.innerText;
                        text = text.replace("\n", "");
                        if (config.confirmKeys.indexOf(keyCode) >= 0) {
                            //  (autocomplete triggered)
                            if (keyCode === 9) {
                                if (this.elementHint.innerText.length === 0) rs.onTab();
                            }
                            if (this.elementHint.innerText.length > 0) // if there is a hint
                            {
                                if (this.element.innerText !== this.elementHint.realInnerText) {
                                    this.element.innerText = this.elementHint.realInnerText;
                                    rs.hideDropDown();
                                    setEndOfContenteditable(this.element);
                                    if (keyCode === 9) {
                                        rs.element.focus();
                                        e.preventDefault();
                                        e.stopPropagation();
                                    }
                                }
                            }
                            return;
                        }
                        if (keyCode === 13) {
                            // enter  (autocomplete triggered)
                            if (this.elementHint.innerText.length === 0) // if there is a hint
                            rs.onEnter();
                            else {
                                var wasDropDownHidden = dropDown.style.visibility === "hidden";
                                dropDownController.hide();
                                if (wasDropDownHidden) {
                                    rs.hideDropDown();
                                    rs.element.focus();
                                    rs.onEnter();
                                    return;
                                }
                                this.element.innerText = this.elementHint.realInnerText;
                                rs.hideDropDown();
                                setEndOfContenteditable(this.element);
                                e.preventDefault();
                                e.stopPropagation();
                            }
                            return;
                        }
                        if (keyCode === 40) {
                            // down
                            var token = text.substring(this.startFrom);
                            var m = dropDownController.move(1);
                            if (m === "") rs.onArrowDown();
                            this.elementHint.innerText = leftSide + token + m.substring(token.length);
                            this.elementHint.realInnerText = leftSide + m;
                            e.preventDefault();
                            e.stopPropagation();
                            return;
                        }
                        if (keyCode === 38) {
                            // up
                            var _token = text.substring(this.startFrom);
                            var _m = dropDownController.move(-1);
                            if (_m === "") rs.onArrowUp();
                            this.elementHint.innerText = leftSide + _token + _m.substring(_token.length);
                            this.elementHint.realInnerText = leftSide + _m;
                            e.preventDefault();
                            e.stopPropagation();
                        }
                    }).bind(rs);
                    var onBlurHandler = function onBlurHandler(e) {
                        rs.hideDropDown();
                    // console.log("Lost focus.");
                    };
                    dropDownController.onmouseselection = function(text, rs) {
                        rs.element.innerText = rs.elementHint.innerText = leftSide + text;
                        rs.hideDropDown();
                        window.setTimeout(function() {
                            rs.element.focus();
                            setEndOfContenteditable(rs.element);
                        }, 1);
                    };
                    return rs;
                }
                // EXTERNAL MODULE: ./src/js/ContextMenu.js
                var ContextMenu = __webpack_require__(897);
                // EXTERNAL MODULE: ./src/js/FocusTracker.js
                var FocusTracker = __webpack_require__(474);
                /**
 * The highlighter can highlight/unhighlight a node, and
 * animate the visibility of a context menu.
 * @constructor Highlighter
 */ function _typeof(obj) {
                    "@babel/helpers - typeof";
                    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
                        return typeof obj;
                    } : function(obj) {
                        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
                    }, _typeof(obj);
                }
                function _classCallCheck(instance, Constructor) {
                    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
                }
                function _defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
                    }
                }
                function _createClass(Constructor, protoProps, staticProps) {
                    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) _defineProperties(Constructor, staticProps);
                    Object.defineProperty(Constructor, "prototype", {
                        writable: false
                    });
                    return Constructor;
                }
                function _toPropertyKey(arg) {
                    var key = _toPrimitive(arg, "string");
                    return _typeof(key) === "symbol" ? key : String(key);
                }
                function _toPrimitive(input, hint) {
                    if (_typeof(input) !== "object" || input === null) return input;
                    var prim = input[Symbol.toPrimitive];
                    if (prim !== undefined) {
                        var res = prim.call(input, hint || "default");
                        if (_typeof(res) !== "object") return res;
                        throw new TypeError("@@toPrimitive must return a primitive value.");
                    }
                    return (hint === "string" ? String : Number)(input);
                }
                var Highlighter = /*#__PURE__*/ function() {
                    function Highlighter() {
                        _classCallCheck(this, Highlighter);
                        this.locked = false;
                    }
                    /**
   * Hightlight given node and its childs
   * @param {Node} node
   */ _createClass(Highlighter, [
                        {
                            key: "highlight",
                            value: function highlight(node) {
                                if (this.locked) return;
                                if (this.node !== node) {
                                    // unhighlight current node
                                    if (this.node) this.node.setHighlight(false);
                                    // highlight new node
                                    this.node = node;
                                    this.node.setHighlight(true);
                                }
                                // cancel any current timeout
                                this._cancelUnhighlight();
                            }
                        },
                        {
                            key: "unhighlight",
                            value: function unhighlight() {
                                if (this.locked) return;
                                var me = this;
                                if (this.node) {
                                    this._cancelUnhighlight();
                                    // do the unhighlighting after a small delay, to prevent re-highlighting
                                    // the same node when moving from the drag-icon to the contextmenu-icon
                                    // or vice versa.
                                    this.unhighlightTimer = setTimeout(function() {
                                        me.node.setHighlight(false);
                                        me.node = undefined;
                                        me.unhighlightTimer = undefined;
                                    }, 0);
                                }
                            }
                        },
                        {
                            key: "_cancelUnhighlight",
                            value: function _cancelUnhighlight() {
                                if (this.unhighlightTimer) {
                                    clearTimeout(this.unhighlightTimer);
                                    this.unhighlightTimer = undefined;
                                }
                            }
                        },
                        {
                            key: "lock",
                            value: function lock() {
                                this.locked = true;
                            }
                        },
                        {
                            key: "unlock",
                            value: function unlock() {
                                this.locked = false;
                            }
                        }
                    ]);
                    return Highlighter;
                }();
                // EXTERNAL MODULE: ./src/js/i18n.js
                var i18n = __webpack_require__(907);
                // EXTERNAL MODULE: ./src/js/jmespathQuery.js
                var jmespathQuery = __webpack_require__(56);
                // EXTERNAL MODULE: ./src/js/ModeSwitcher.js
                var ModeSwitcher = __webpack_require__(617);
                // EXTERNAL MODULE: ./node_modules/javascript-natural-sort/naturalSort.js
                var naturalSort = __webpack_require__(233);
                var naturalSort_default = /*#__PURE__*/ __webpack_require__.n(naturalSort);
                // EXTERNAL MODULE: ./src/js/createAbsoluteAnchor.js
                var createAbsoluteAnchor = __webpack_require__(602);
                // EXTERNAL MODULE: ./src/js/util.js
                var util = __webpack_require__(791);
                /**
 * A factory function to create an AppendNode, which depends on a Node
 * @param {Node} Node
 */ function appendNodeFactory(Node1) {
                    /**
   * @constructor AppendNode
   * @extends Node
   * @param {TreeEditor} editor
   * Create a new AppendNode. This is a special node which is created at the
   * end of the list with childs for an object or array
   */ function AppendNode(editor) {
                        /** @type {TreeEditor} */ this.editor = editor;
                        this.dom = {};
                    }
                    AppendNode.prototype = new Node1();
                    /**
   * Return a table row with an append button.
   * @return {Element} dom   TR element
   */ AppendNode.prototype.getDom = function() {
                        // TODO: implement a new solution for the append node
                        var dom = this.dom;
                        if (dom.tr) return dom.tr;
                        this._updateEditability();
                        // a row for the append button
                        var trAppend = document.createElement("tr");
                        trAppend.className = "jsoneditor-append";
                        trAppend.node = this;
                        dom.tr = trAppend;
                        // TODO: consistent naming
                        if (this.editor.options.mode === "tree") {
                            // a cell for the dragarea column
                            dom.tdDrag = document.createElement("td");
                            // create context menu
                            var tdMenu = document.createElement("td");
                            dom.tdMenu = tdMenu;
                            var menu = document.createElement("button");
                            menu.type = "button";
                            menu.className = "jsoneditor-button jsoneditor-contextmenu-button";
                            menu.title = "Click to open the actions menu (Ctrl+M)";
                            dom.menu = menu;
                            tdMenu.appendChild(dom.menu);
                        }
                        // a cell for the contents (showing text 'empty')
                        var tdAppend = document.createElement("td");
                        var domText = document.createElement("div");
                        domText.appendChild(document.createTextNode("(" + (0, i18n /* translate */ .Iu)("empty") + ")"));
                        domText.className = "jsoneditor-readonly";
                        tdAppend.appendChild(domText);
                        dom.td = tdAppend;
                        dom.text = domText;
                        this.updateDom();
                        return trAppend;
                    };
                    /**
   * Append node doesn't have a path
   * @returns {null}
   */ AppendNode.prototype.getPath = function() {
                        return null;
                    };
                    /**
   * Append node doesn't have an index
   * @returns {null}
   */ AppendNode.prototype.getIndex = function() {
                        return null;
                    };
                    /**
   * Update the HTML dom of the Node
   */ AppendNode.prototype.updateDom = function(options) {
                        var dom = this.dom;
                        var tdAppend = dom.td;
                        if (tdAppend) tdAppend.style.paddingLeft = this.getLevel() * 24 + 26 + "px";
                        var domText = dom.text;
                        if (domText) domText.firstChild.nodeValue = "(" + (0, i18n /* translate */ .Iu)("empty") + " " + this.parent.type + ")";
                        // attach or detach the contents of the append node:
                        // hide when the parent has childs, show when the parent has no childs
                        var trAppend = dom.tr;
                        if (!this.isVisible()) {
                            if (dom.tr.firstChild) {
                                if (dom.tdDrag) trAppend.removeChild(dom.tdDrag);
                                if (dom.tdMenu) trAppend.removeChild(dom.tdMenu);
                                trAppend.removeChild(tdAppend);
                            }
                        } else if (!dom.tr.firstChild) {
                            if (dom.tdDrag) trAppend.appendChild(dom.tdDrag);
                            if (dom.tdMenu) trAppend.appendChild(dom.tdMenu);
                            trAppend.appendChild(tdAppend);
                        }
                    };
                    /**
   * Check whether the AppendNode is currently visible.
   * the AppendNode is visible when its parent has no childs (i.e. is empty).
   * @return {boolean} isVisible
   */ AppendNode.prototype.isVisible = function() {
                        return this.parent.childs.length === 0;
                    };
                    /**
   * Show a contextmenu for this node
   * @param {HTMLElement} anchor   The element to attach the menu to.
   * @param {function} [onClose]   Callback method called when the context menu
   *                               is being closed.
   */ AppendNode.prototype.showContextMenu = function(anchor, onClose) {
                        var node = this;
                        var appendSubmenu = [
                            {
                                text: (0, i18n /* translate */ .Iu)("auto"),
                                className: "jsoneditor-type-auto",
                                title: (0, i18n /* translate */ .Iu)("autoType"),
                                click: function click() {
                                    node._onAppend("", "", "auto");
                                }
                            },
                            {
                                text: (0, i18n /* translate */ .Iu)("array"),
                                className: "jsoneditor-type-array",
                                title: (0, i18n /* translate */ .Iu)("arrayType"),
                                click: function click() {
                                    node._onAppend("", []);
                                }
                            },
                            {
                                text: (0, i18n /* translate */ .Iu)("object"),
                                className: "jsoneditor-type-object",
                                title: (0, i18n /* translate */ .Iu)("objectType"),
                                click: function click() {
                                    node._onAppend("", {});
                                }
                            },
                            {
                                text: (0, i18n /* translate */ .Iu)("string"),
                                className: "jsoneditor-type-string",
                                title: (0, i18n /* translate */ .Iu)("stringType"),
                                click: function click() {
                                    node._onAppend("", "", "string");
                                }
                            }
                        ];
                        node.addTemplates(appendSubmenu, true);
                        var items = [
                            // create append button
                            {
                                text: (0, i18n /* translate */ .Iu)("appendText"),
                                title: (0, i18n /* translate */ .Iu)("appendTitleAuto"),
                                submenuTitle: (0, i18n /* translate */ .Iu)("appendSubmenuTitle"),
                                className: "jsoneditor-insert",
                                click: function click() {
                                    node._onAppend("", "", "auto");
                                },
                                submenu: appendSubmenu
                            }
                        ];
                        if (this.editor.options.onCreateMenu) {
                            var path = node.parent.getPath();
                            items = this.editor.options.onCreateMenu(items, {
                                type: "append",
                                path: path,
                                paths: [
                                    path
                                ]
                            });
                        }
                        var menu = new ContextMenu /* ContextMenu */ .x(items, {
                            close: onClose
                        });
                        menu.show(anchor, this.editor.getPopupAnchor());
                    };
                    /**
   * Handle an event. The event is caught centrally by the editor
   * @param {Event} event
   */ AppendNode.prototype.onEvent = function(event) {
                        var type = event.type;
                        var target = event.target || event.srcElement;
                        var dom = this.dom;
                        // highlight the append nodes parent
                        var menu = dom.menu;
                        if (target === menu) {
                            if (type === "mouseover") this.editor.highlighter.highlight(this.parent);
                            else if (type === "mouseout") this.editor.highlighter.unhighlight();
                        }
                        // context menu events
                        if (type === "click" && target === dom.menu) {
                            var highlighter = this.editor.highlighter;
                            highlighter.highlight(this.parent);
                            highlighter.lock();
                            (0, util.addClassName)(dom.menu, "jsoneditor-selected");
                            this.showContextMenu(dom.menu, function() {
                                (0, util.removeClassName)(dom.menu, "jsoneditor-selected");
                                highlighter.unlock();
                                highlighter.unhighlight();
                            });
                        }
                        if (type === "keydown") this.onKeyDown(event);
                    };
                    return AppendNode;
                }
                /**
 * A factory function to create an ShowMoreNode, which depends on a Node
 * @param {function} Node
 */ function showMoreNodeFactory(Node1) {
                    /**
   * @constructor ShowMoreNode
   * @extends Node
   * @param {TreeEditor} editor
   * @param {Node} parent
   * Create a new ShowMoreNode. This is a special node which is created
   * for arrays or objects having more than 100 items
   */ function ShowMoreNode(editor, parent) {
                        /** @type {TreeEditor} */ this.editor = editor;
                        this.parent = parent;
                        this.dom = {};
                    }
                    ShowMoreNode.prototype = new Node1();
                    /**
   * Return a table row with an append button.
   * @return {Element} dom   TR element
   */ ShowMoreNode.prototype.getDom = function() {
                        if (this.dom.tr) return this.dom.tr;
                        this._updateEditability();
                        // display "show more"
                        if (!this.dom.tr) {
                            var me = this;
                            var parent = this.parent;
                            var showMoreButton = document.createElement("a");
                            showMoreButton.appendChild(document.createTextNode((0, i18n /* translate */ .Iu)("showMore")));
                            showMoreButton.href = "#";
                            showMoreButton.onclick = function(event) {
                                // TODO: use callback instead of accessing a method of the parent
                                parent.visibleChilds = Math.floor(parent.visibleChilds / parent.getMaxVisibleChilds() + 1) * parent.getMaxVisibleChilds();
                                me.updateDom();
                                parent.showChilds();
                                event.preventDefault();
                                return false;
                            };
                            var showAllButton = document.createElement("a");
                            showAllButton.appendChild(document.createTextNode((0, i18n /* translate */ .Iu)("showAll")));
                            showAllButton.href = "#";
                            showAllButton.onclick = function(event) {
                                // TODO: use callback instead of accessing a method of the parent
                                parent.visibleChilds = Infinity;
                                me.updateDom();
                                parent.showChilds();
                                event.preventDefault();
                                return false;
                            };
                            var moreContents = document.createElement("div");
                            var moreText = document.createTextNode(this._getShowMoreText());
                            moreContents.className = "jsoneditor-show-more";
                            moreContents.appendChild(moreText);
                            moreContents.appendChild(showMoreButton);
                            moreContents.appendChild(document.createTextNode(". "));
                            moreContents.appendChild(showAllButton);
                            moreContents.appendChild(document.createTextNode(". "));
                            var tdContents = document.createElement("td");
                            tdContents.appendChild(moreContents);
                            var moreTr = document.createElement("tr");
                            if (this.editor.options.mode === "tree") {
                                moreTr.appendChild(document.createElement("td"));
                                moreTr.appendChild(document.createElement("td"));
                            }
                            moreTr.appendChild(tdContents);
                            moreTr.className = "jsoneditor-show-more";
                            this.dom.tr = moreTr;
                            this.dom.moreContents = moreContents;
                            this.dom.moreText = moreText;
                        }
                        this.updateDom();
                        return this.dom.tr;
                    };
                    /**
   * Update the HTML dom of the Node
   */ ShowMoreNode.prototype.updateDom = function(options) {
                        if (this.isVisible()) {
                            // attach to the right child node (the first non-visible child)
                            this.dom.tr.node = this.parent.childs[this.parent.visibleChilds];
                            if (!this.dom.tr.parentNode) {
                                var nextTr = this.parent._getNextTr();
                                if (nextTr) nextTr.parentNode.insertBefore(this.dom.tr, nextTr);
                            }
                            // update the counts in the text
                            this.dom.moreText.nodeValue = this._getShowMoreText();
                            // update left margin
                            this.dom.moreContents.style.marginLeft = (this.getLevel() + 1) * 24 + "px";
                        } else if (this.dom.tr && this.dom.tr.parentNode) this.dom.tr.parentNode.removeChild(this.dom.tr);
                    };
                    ShowMoreNode.prototype._getShowMoreText = function() {
                        return (0, i18n /* translate */ .Iu)("showMoreStatus", {
                            visibleChilds: this.parent.visibleChilds,
                            totalChilds: this.parent.childs.length
                        }) + " ";
                    };
                    /**
   * Check whether the ShowMoreNode is currently visible.
   * the ShowMoreNode is visible when it's parent has more childs than
   * the current visibleChilds
   * @return {boolean} isVisible
   */ ShowMoreNode.prototype.isVisible = function() {
                        return this.parent.expanded && this.parent.childs.length > this.parent.visibleChilds;
                    };
                    /**
   * Handle an event. The event is caught centrally by the editor
   * @param {Event} event
   */ ShowMoreNode.prototype.onEvent = function(event) {
                        var type = event.type;
                        if (type === "keydown") this.onKeyDown(event);
                    };
                    return ShowMoreNode;
                }
                // EXTERNAL MODULE: ./src/js/showSortModal.js
                var js_showSortModal = __webpack_require__(210);
                // EXTERNAL MODULE: ./src/js/showTransformModal.js + 1 modules
                var js_showTransformModal = __webpack_require__(558);
                // EXTERNAL MODULE: ./src/js/constants.js
                var constants = __webpack_require__(188);
                function _toConsumableArray(arr) {
                    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
                }
                function _nonIterableSpread() {
                    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                }
                function _iterableToArray(iter) {
                    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
                }
                function _arrayWithoutHoles(arr) {
                    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
                }
                function _slicedToArray(arr, i) {
                    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
                }
                function _nonIterableRest() {
                    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                }
                function _iterableToArrayLimit(arr, i) {
                    var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
                    if (null != _i) {
                        var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1;
                        try {
                            if (_x = (_i = _i.call(arr)).next, 0 === i) {
                                if (Object(_i) !== _i) return;
                                _n = !1;
                            } else for(; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0);
                        } catch (err) {
                            _d = !0, _e = err;
                        } finally{
                            try {
                                if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return;
                            } finally{
                                if (_d) throw _e;
                            }
                        }
                        return _arr;
                    }
                }
                function _arrayWithHoles(arr) {
                    if (Array.isArray(arr)) return arr;
                }
                function _createForOfIteratorHelper(o, allowArrayLike) {
                    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
                    if (!it) {
                        if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
                            if (it) o = it;
                            var i = 0;
                            var F = function F() {};
                            return {
                                s: F,
                                n: function n() {
                                    if (i >= o.length) return {
                                        done: true
                                    };
                                    return {
                                        done: false,
                                        value: o[i++]
                                    };
                                },
                                e: function e(_e2) {
                                    throw _e2;
                                },
                                f: F
                            };
                        }
                        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                    }
                    var normalCompletion = true, didErr = false, err;
                    return {
                        s: function s() {
                            it = it.call(o);
                        },
                        n: function n() {
                            var step = it.next();
                            normalCompletion = step.done;
                            return step;
                        },
                        e: function e(_e3) {
                            didErr = true;
                            err = _e3;
                        },
                        f: function f() {
                            try {
                                if (!normalCompletion && it["return"] != null) it["return"]();
                            } finally{
                                if (didErr) throw err;
                            }
                        }
                    };
                }
                function _unsupportedIterableToArray(o, minLen) {
                    if (!o) return;
                    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
                    var n = Object.prototype.toString.call(o).slice(8, -1);
                    if (n === "Object" && o.constructor) n = o.constructor.name;
                    if (n === "Map" || n === "Set") return Array.from(o);
                    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
                }
                function _arrayLikeToArray(arr, len) {
                    if (len == null || len > arr.length) len = arr.length;
                    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
                    return arr2;
                }
                function Node_typeof(obj) {
                    "@babel/helpers - typeof";
                    return Node_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
                        return typeof obj;
                    } : function(obj) {
                        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
                    }, Node_typeof(obj);
                }
                function Node_classCallCheck(instance, Constructor) {
                    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
                }
                function Node_defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, Node_toPropertyKey(descriptor.key), descriptor);
                    }
                }
                function Node_createClass(Constructor, protoProps, staticProps) {
                    if (protoProps) Node_defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) Node_defineProperties(Constructor, staticProps);
                    Object.defineProperty(Constructor, "prototype", {
                        writable: false
                    });
                    return Constructor;
                }
                function Node_toPropertyKey(arg) {
                    var key = Node_toPrimitive(arg, "string");
                    return Node_typeof(key) === "symbol" ? key : String(key);
                }
                function Node_toPrimitive(input, hint) {
                    if (Node_typeof(input) !== "object" || input === null) return input;
                    var prim = input[Symbol.toPrimitive];
                    if (prim !== undefined) {
                        var res = prim.call(input, hint || "default");
                        if (Node_typeof(res) !== "object") return res;
                        throw new TypeError("@@toPrimitive must return a primitive value.");
                    }
                    return (hint === "string" ? String : Number)(input);
                }
                /**
 * @constructor Node
 * Create a new Node
 * @param {./treemode} editor
 * @param {Object} [params] Can contain parameters:
 *                          {string}  field
 *                          {boolean} fieldEditable
 *                          {*}       value
 *                          {String}  type  Can have values 'auto', 'array',
 *                                          'object', or 'string'.
 */ var Node1 = /*#__PURE__*/ function() {
                    function Node1(editor, params) {
                        Node_classCallCheck(this, Node1);
                        /** @type {./treemode} */ this.editor = editor;
                        this.dom = {};
                        this.expanded = false;
                        if (params && params instanceof Object) {
                            this.setField(params.field, params.fieldEditable);
                            if ("value" in params) this.setValue(params.value, params.type);
                            if ("internalValue" in params) this.setInternalValue(params.internalValue);
                        } else {
                            this.setField("");
                            this.setValue(null);
                        }
                        this._debouncedOnChangeValue = (0, util.debounce)(this._onChangeValue.bind(this), Node1.prototype.DEBOUNCE_INTERVAL);
                        this._debouncedOnChangeField = (0, util.debounce)(this._onChangeField.bind(this), Node1.prototype.DEBOUNCE_INTERVAL);
                        // starting value for visible children
                        this.visibleChilds = this.getMaxVisibleChilds();
                    }
                    Node_createClass(Node1, [
                        {
                            key: "getMaxVisibleChilds",
                            value: function getMaxVisibleChilds() {
                                return this.editor && this.editor.options && this.editor.options.maxVisibleChilds ? this.editor.options.maxVisibleChilds : DEFAULT_MAX_VISIBLE_CHILDS;
                            }
                        },
                        {
                            key: "_updateEditability",
                            value: function _updateEditability() {
                                this.editable = {
                                    field: true,
                                    value: true
                                };
                                if (this.editor) {
                                    this.editable.field = this.editor.options.mode === "tree";
                                    this.editable.value = this.editor.options.mode !== "view";
                                    if ((this.editor.options.mode === "tree" || this.editor.options.mode === "form") && typeof this.editor.options.onEditable === "function") {
                                        var getValue = this.getValue.bind(this);
                                        var editable = this.editor.options.onEditable({
                                            field: this.field,
                                            get value () {
                                                return getValue();
                                            },
                                            path: this.getPath()
                                        });
                                        if (typeof editable === "boolean") {
                                            this.editable.field = editable;
                                            this.editable.value = editable;
                                        } else if (Node_typeof(editable) === "object" && editable !== null) {
                                            if (typeof editable.field === "boolean") this.editable.field = editable.field;
                                            if (typeof editable.value === "boolean") this.editable.value = editable.value;
                                        } else {
                                            console.error("Invalid return value for function onEditable.", "Actual value:", editable, ".", "Either a boolean or object { field: boolean, value: boolean } expected.");
                                            this.editable.field = false;
                                            this.editable.value = false;
                                        }
                                    }
                                }
                            }
                        },
                        {
                            key: "getPath",
                            value: function getPath() {
                                var node = this;
                                var path = [];
                                while(node){
                                    var field = node.getName();
                                    if (field !== undefined) path.unshift(field);
                                    node = node.parent;
                                }
                                return path;
                            }
                        },
                        {
                            key: "getInternalPath",
                            value: function getInternalPath() {
                                var node = this;
                                var internalPath = [];
                                while(node){
                                    if (node.parent) internalPath.unshift(node.getIndex());
                                    node = node.parent;
                                }
                                return internalPath;
                            }
                        },
                        {
                            key: "getName",
                            value: function getName() {
                                return !this.parent ? undefined // do not add an (optional) field name of the root node
                                 : this.parent.type !== "array" ? this.field : this.index;
                            }
                        },
                        {
                            key: "findNodeByPath",
                            value: function findNodeByPath(path) {
                                if (!path) return;
                                if (path.length === 0) return this;
                                if (path.length && this.childs && this.childs.length) for(var i = 0; i < this.childs.length; ++i){
                                    if ("" + path[0] === "" + this.childs[i].getName()) return this.childs[i].findNodeByPath(path.slice(1));
                                }
                            }
                        },
                        {
                            key: "findNodeByInternalPath",
                            value: function findNodeByInternalPath(internalPath) {
                                if (!internalPath) return undefined;
                                var node = this;
                                for(var i = 0; i < internalPath.length && node; i++){
                                    var childIndex = internalPath[i];
                                    node = node.childs[childIndex];
                                }
                                return node;
                            }
                        },
                        {
                            key: "serialize",
                            value: function serialize() {
                                return {
                                    value: this.getValue(),
                                    path: this.getPath()
                                };
                            }
                        },
                        {
                            key: "findNode",
                            value: function findNode(jsonPath) {
                                var path = (0, util.parsePath)(jsonPath);
                                var node = this;
                                var _loop = function _loop() {
                                    var prop = path.shift();
                                    if (typeof prop === "number") {
                                        if (node.type !== "array") throw new Error("Cannot get child node at index " + prop + ": node is no array");
                                        node = node.childs[prop];
                                    } else {
                                        // string
                                        if (node.type !== "object") throw new Error("Cannot get child node " + prop + ": node is no object");
                                        node = node.childs.filter(function(child) {
                                            return child.field === prop;
                                        })[0];
                                    }
                                };
                                while(node && path.length > 0)_loop();
                                return node;
                            }
                        },
                        {
                            key: "findParents",
                            value: function findParents() {
                                var parents = [];
                                var parent = this.parent;
                                while(parent){
                                    parents.unshift(parent);
                                    parent = parent.parent;
                                }
                                return parents;
                            }
                        },
                        {
                            key: "setError",
                            value: function setError(error, child) {
                                this.error = error;
                                this.errorChild = child;
                                if (this.dom && this.dom.tr) this.updateError();
                            }
                        },
                        {
                            key: "updateError",
                            value: function updateError() {
                                var _this = this;
                                var error = this.fieldError || this.valueError || this.error;
                                var tdError = this.dom.tdError;
                                if (error && this.dom && this.dom.tr) {
                                    (0, util.addClassName)(this.dom.tr, "jsoneditor-validation-error");
                                    if (!tdError) {
                                        tdError = document.createElement("td");
                                        this.dom.tdError = tdError;
                                        this.dom.tdValue.parentNode.appendChild(tdError);
                                    }
                                    var button = document.createElement("button");
                                    button.type = "button";
                                    button.className = "jsoneditor-button jsoneditor-schema-error";
                                    var destroy = function destroy() {
                                        if (_this.dom.popupAnchor) _this.dom.popupAnchor.destroy(); // this will trigger the onDestroy callback
                                    };
                                    var onDestroy = function onDestroy() {
                                        delete _this.dom.popupAnchor;
                                    };
                                    var createPopup = function createPopup(destroyOnMouseOut) {
                                        var frame = _this.editor.frame;
                                        _this.dom.popupAnchor = (0, createAbsoluteAnchor /* createAbsoluteAnchor */ .w)(button, _this.editor.getPopupAnchor(), onDestroy, destroyOnMouseOut);
                                        var popupWidth = 200; // must correspond to what's configured in the CSS
                                        var buttonRect = button.getBoundingClientRect();
                                        var frameRect = frame.getBoundingClientRect();
                                        var position = frameRect.width - buttonRect.x > popupWidth / 2 + 20 ? "jsoneditor-above" : "jsoneditor-left";
                                        var popover = document.createElement("div");
                                        popover.className = "jsoneditor-popover " + position;
                                        popover.appendChild(document.createTextNode(error.message));
                                        _this.dom.popupAnchor.appendChild(popover);
                                    };
                                    button.onmouseover = function() {
                                        if (!_this.dom.popupAnchor) createPopup(true);
                                    };
                                    button.onfocus = function() {
                                        destroy();
                                        createPopup(false);
                                    };
                                    button.onblur = function() {
                                        destroy();
                                    };
                                    // when clicking the error icon, expand all nodes towards the invalid
                                    // child node, and set focus to the child node
                                    var child = this.errorChild;
                                    if (child) button.onclick = function showInvalidNode() {
                                        child.findParents().forEach(function(parent) {
                                            parent.expand(false);
                                        });
                                        child.scrollTo(function() {
                                            child.focus();
                                        });
                                    };
                                    // apply the error message to the node
                                    while(tdError.firstChild)tdError.removeChild(tdError.firstChild);
                                    tdError.appendChild(button);
                                } else {
                                    if (this.dom.tr) (0, util.removeClassName)(this.dom.tr, "jsoneditor-validation-error");
                                    if (tdError) {
                                        this.dom.tdError.parentNode.removeChild(this.dom.tdError);
                                        delete this.dom.tdError;
                                    }
                                }
                            }
                        },
                        {
                            key: "getIndex",
                            value: function getIndex() {
                                if (this.parent) {
                                    var index = this.parent.childs.indexOf(this);
                                    return index !== -1 ? index : null;
                                } else return -1;
                            }
                        },
                        {
                            key: "setParent",
                            value: function setParent(parent) {
                                this.parent = parent;
                            }
                        },
                        {
                            key: "setField",
                            value: function setField(field, fieldEditable) {
                                this.field = field;
                                this.previousField = field;
                                this.fieldEditable = fieldEditable === true;
                            }
                        },
                        {
                            key: "getField",
                            value: function getField() {
                                if (this.field === undefined) this._getDomField();
                                return this.field;
                            }
                        },
                        {
                            key: "setValue",
                            value: function setValue(value, type) {
                                var childValue, child;
                                var i, j;
                                var updateDom = false;
                                var previousChilds = this.childs;
                                this.type = this._getType(value);
                                // check if type corresponds with the provided type
                                if (type && type !== this.type) {
                                    if (type === "string" && this.type === "auto") this.type = type;
                                    else throw new Error('Type mismatch: cannot cast value of type "' + this.type + ' to the specified type "' + type + '"');
                                }
                                if (this.type === "array") {
                                    // array
                                    if (!this.childs) this.childs = [];
                                    for(i = 0; i < value.length; i++){
                                        childValue = value[i];
                                        if (childValue !== undefined && !(childValue instanceof Function)) {
                                            if (i < this.childs.length) {
                                                // reuse existing child, keep its state
                                                child = this.childs[i];
                                                child.fieldEditable = false;
                                                child.index = i;
                                                child.setValue(childValue);
                                            } else {
                                                // create a new child
                                                child = new Node1(this.editor, {
                                                    value: childValue
                                                });
                                                var visible = i < this.getMaxVisibleChilds();
                                                this.appendChild(child, visible, updateDom);
                                            }
                                        }
                                    }
                                    // cleanup redundant childs
                                    // we loop backward to prevent issues with shifting index numbers
                                    for(j = this.childs.length; j >= value.length; j--)this.removeChild(this.childs[j], updateDom);
                                } else if (this.type === "object") {
                                    // object
                                    if (!this.childs) this.childs = [];
                                    // cleanup redundant childs
                                    // we loop backward to prevent issues with shifting index numbers
                                    for(j = this.childs.length - 1; j >= 0; j--)if (!Node_hasOwnProperty(value, this.childs[j].field)) this.removeChild(this.childs[j], updateDom);
                                    i = 0;
                                    for(var childField in value)if (Node_hasOwnProperty(value, childField)) {
                                        childValue = value[childField];
                                        if (childValue !== undefined && !(childValue instanceof Function)) {
                                            var _child = this.findChildByProperty(childField);
                                            if (_child) {
                                                // reuse existing child, keep its state
                                                _child.setField(childField, true);
                                                _child.setValue(childValue);
                                            } else {
                                                // create a new child, append to the end
                                                var newChild = new Node1(this.editor, {
                                                    field: childField,
                                                    value: childValue
                                                });
                                                var _visible = i < this.getMaxVisibleChilds();
                                                this.appendChild(newChild, _visible, updateDom);
                                            }
                                        }
                                        i++;
                                    }
                                    this.value = "";
                                    // sort object keys during initialization. Must not trigger an onChange action
                                    if (this.editor.options.sortObjectKeys === true) {
                                        var triggerAction = false;
                                        this.sort([], "asc", triggerAction);
                                    }
                                } else {
                                    // value
                                    this.hideChilds();
                                    delete this.append;
                                    delete this.showMore;
                                    delete this.expanded;
                                    delete this.childs;
                                    this.value = value;
                                }
                                // recreate the DOM if switching from an object/array to auto/string or vice versa
                                // needed to recreated the expand button for example
                                if (Array.isArray(previousChilds) !== Array.isArray(this.childs)) this.recreateDom();
                                this.updateDom({
                                    updateIndexes: true
                                });
                                this.previousValue = this.value; // used only to check for changes in DOM vs JS model
                            }
                        },
                        {
                            key: "setInternalValue",
                            value: function setInternalValue(internalValue) {
                                var childValue, child, visible;
                                var i, j;
                                var notUpdateDom = false;
                                var previousChilds = this.childs;
                                this.type = internalValue.type;
                                if (internalValue.type === "array") {
                                    // array
                                    if (!this.childs) this.childs = [];
                                    for(i = 0; i < internalValue.childs.length; i++){
                                        childValue = internalValue.childs[i];
                                        if (childValue !== undefined && !(childValue instanceof Function)) {
                                            if (i < this.childs.length) {
                                                // reuse existing child, keep its state
                                                child = this.childs[i];
                                                child.fieldEditable = false;
                                                child.index = i;
                                                child.setInternalValue(childValue);
                                            } else {
                                                // create a new child
                                                child = new Node1(this.editor, {
                                                    internalValue: childValue
                                                });
                                                visible = i < this.getMaxVisibleChilds();
                                                this.appendChild(child, visible, notUpdateDom);
                                            }
                                        }
                                    }
                                    // cleanup redundant childs
                                    // we loop backward to prevent issues with shifting index numbers
                                    for(j = this.childs.length; j >= internalValue.childs.length; j--)this.removeChild(this.childs[j], notUpdateDom);
                                } else if (internalValue.type === "object") {
                                    // object
                                    if (!this.childs) this.childs = [];
                                    for(i = 0; i < internalValue.childs.length; i++){
                                        childValue = internalValue.childs[i];
                                        if (childValue !== undefined && !(childValue instanceof Function)) {
                                            if (i < this.childs.length) {
                                                // reuse existing child, keep its state
                                                child = this.childs[i];
                                                delete child.index;
                                                child.setField(childValue.field, true);
                                                child.setInternalValue(childValue.value);
                                            } else {
                                                // create a new child
                                                child = new Node1(this.editor, {
                                                    field: childValue.field,
                                                    internalValue: childValue.value
                                                });
                                                visible = i < this.getMaxVisibleChilds();
                                                this.appendChild(child, visible, notUpdateDom);
                                            }
                                        }
                                    }
                                    // cleanup redundant childs
                                    // we loop backward to prevent issues with shifting index numbers
                                    for(j = this.childs.length; j >= internalValue.childs.length; j--)this.removeChild(this.childs[j], notUpdateDom);
                                } else {
                                    // value
                                    this.hideChilds();
                                    delete this.append;
                                    delete this.showMore;
                                    delete this.expanded;
                                    delete this.childs;
                                    this.value = internalValue.value;
                                }
                                // recreate the DOM if switching from an object/array to auto/string or vice versa
                                // needed to recreated the expand button for example
                                if (Array.isArray(previousChilds) !== Array.isArray(this.childs)) this.recreateDom();
                                this.updateDom({
                                    updateIndexes: true
                                });
                                this.previousValue = this.value; // used only to check for changes in DOM vs JS model
                            }
                        },
                        {
                            key: "recreateDom",
                            value: function recreateDom() {
                                if (this.dom && this.dom.tr && this.dom.tr.parentNode) {
                                    var domAnchor = this._detachFromDom();
                                    this.clearDom();
                                    this._attachToDom(domAnchor);
                                } else this.clearDom();
                            }
                        },
                        {
                            key: "getValue",
                            value: function getValue() {
                                if (this.type === "array") {
                                    var arr = [];
                                    this.childs.forEach(function(child) {
                                        arr.push(child.getValue());
                                    });
                                    return arr;
                                } else if (this.type === "object") {
                                    var obj = {};
                                    this.childs.forEach(function(child) {
                                        obj[child.getField()] = child.getValue();
                                    });
                                    return obj;
                                } else {
                                    if (this.value === undefined) this._getDomValue();
                                    return this.value;
                                }
                            }
                        },
                        {
                            key: "getInternalValue",
                            value: function getInternalValue() {
                                if (this.type === "array") return {
                                    type: this.type,
                                    childs: this.childs.map(function(child) {
                                        return child.getInternalValue();
                                    })
                                };
                                else if (this.type === "object") return {
                                    type: this.type,
                                    childs: this.childs.map(function(child) {
                                        return {
                                            field: child.getField(),
                                            value: child.getInternalValue()
                                        };
                                    })
                                };
                                else {
                                    if (this.value === undefined) this._getDomValue();
                                    return {
                                        type: this.type,
                                        value: this.value
                                    };
                                }
                            }
                        },
                        {
                            key: "getLevel",
                            value: function getLevel() {
                                return this.parent ? this.parent.getLevel() + 1 : 0;
                            }
                        },
                        {
                            key: "getNodePath",
                            value: function getNodePath() {
                                var path = this.parent ? this.parent.getNodePath() : [];
                                path.push(this);
                                return path;
                            }
                        },
                        {
                            key: "clone",
                            value: function clone() {
                                var clone = new Node1(this.editor);
                                clone.type = this.type;
                                clone.field = this.field;
                                clone.fieldInnerText = this.fieldInnerText;
                                clone.fieldEditable = this.fieldEditable;
                                clone.previousField = this.previousField;
                                clone.value = this.value;
                                clone.valueInnerText = this.valueInnerText;
                                clone.previousValue = this.previousValue;
                                clone.expanded = this.expanded;
                                clone.visibleChilds = this.visibleChilds;
                                if (this.childs) {
                                    // an object or array
                                    var cloneChilds = [];
                                    this.childs.forEach(function(child) {
                                        var childClone = child.clone();
                                        childClone.setParent(clone);
                                        cloneChilds.push(childClone);
                                    });
                                    clone.childs = cloneChilds;
                                } else // a value
                                clone.childs = undefined;
                                return clone;
                            }
                        },
                        {
                            key: "expand",
                            value: function expand(recurse) {
                                if (!this.childs) return;
                                // set this node expanded
                                this.expanded = true;
                                if (this.dom.expand) this.dom.expand.className = "jsoneditor-button jsoneditor-expanded";
                                this.showChilds();
                                if (recurse !== false) this.childs.forEach(function(child) {
                                    child.expand(recurse);
                                });
                                // update the css classes of table row, and fire onClassName etc
                                this.updateDom({
                                    recurse: false
                                });
                            }
                        },
                        {
                            key: "collapse",
                            value: function collapse(recurse) {
                                if (!this.childs) return;
                                this.hideChilds();
                                // collapse childs in case of recurse
                                if (recurse !== false) this.childs.forEach(function(child) {
                                    child.collapse(recurse);
                                });
                                // make this node collapsed
                                if (this.dom.expand) this.dom.expand.className = "jsoneditor-button jsoneditor-collapsed";
                                this.expanded = false;
                                // update the css classes of table row, and fire onClassName etc
                                this.updateDom({
                                    recurse: false
                                });
                            }
                        },
                        {
                            key: "showChilds",
                            value: function showChilds() {
                                var childs = this.childs;
                                if (!childs) return;
                                if (!this.expanded) return;
                                var tr = this.dom.tr;
                                var nextTr;
                                var table = tr ? tr.parentNode : undefined;
                                if (table) {
                                    // show row with append button
                                    var append = this.getAppendDom();
                                    if (!append.parentNode) {
                                        nextTr = tr.nextSibling;
                                        if (nextTr) table.insertBefore(append, nextTr);
                                        else table.appendChild(append);
                                    }
                                    // show childs
                                    var iMax = Math.min(this.childs.length, this.visibleChilds);
                                    nextTr = this._getNextTr();
                                    for(var i = 0; i < iMax; i++){
                                        var child = this.childs[i];
                                        if (!child.getDom().parentNode) table.insertBefore(child.getDom(), nextTr);
                                        child.showChilds();
                                    }
                                    // show "show more childs" if limited
                                    var showMore = this.getShowMoreDom();
                                    nextTr = this._getNextTr();
                                    if (!showMore.parentNode) table.insertBefore(showMore, nextTr);
                                    this.showMore.updateDom(); // to update the counter
                                }
                            }
                        },
                        {
                            key: "_getNextTr",
                            value: function _getNextTr() {
                                if (this.showMore && this.showMore.getDom().parentNode) return this.showMore.getDom();
                                if (this.append && this.append.getDom().parentNode) return this.append.getDom();
                            }
                        },
                        {
                            key: "hide",
                            value: function hide(options) {
                                var tr = this.dom.tr;
                                var table = tr ? tr.parentNode : undefined;
                                if (table) table.removeChild(tr);
                                if (this.dom.popupAnchor) this.dom.popupAnchor.destroy();
                                this.hideChilds(options);
                            }
                        },
                        {
                            key: "hideChilds",
                            value: function hideChilds(options) {
                                var childs = this.childs;
                                if (!childs) return;
                                if (!this.expanded) return;
                                // hide append row
                                var append = this.getAppendDom();
                                if (append.parentNode) append.parentNode.removeChild(append);
                                // hide childs
                                this.childs.forEach(function(child) {
                                    child.hide();
                                });
                                // hide "show more" row
                                var showMore = this.getShowMoreDom();
                                if (showMore.parentNode) showMore.parentNode.removeChild(showMore);
                                // reset max visible childs
                                if (!options || options.resetVisibleChilds) this.visibleChilds = this.getMaxVisibleChilds();
                            }
                        },
                        {
                            key: "_updateCssClassName",
                            value: function _updateCssClassName() {
                                if (this.dom.field && this.editor && this.editor.options && typeof this.editor.options.onClassName === "function" && this.dom.tree) {
                                    (0, util.removeAllClassNames)(this.dom.tree);
                                    var getValue = this.getValue.bind(this);
                                    var addClasses = this.editor.options.onClassName({
                                        path: this.getPath(),
                                        field: this.field,
                                        get value () {
                                            return getValue();
                                        }
                                    }) || "";
                                    (0, util.addClassName)(this.dom.tree, "jsoneditor-values " + addClasses);
                                }
                            }
                        },
                        {
                            key: "recursivelyUpdateCssClassesOnNodes",
                            value: function recursivelyUpdateCssClassesOnNodes() {
                                this._updateCssClassName();
                                if (Array.isArray(this.childs)) for(var i = 0; i < this.childs.length; i++)this.childs[i].recursivelyUpdateCssClassesOnNodes();
                            }
                        },
                        {
                            key: "expandTo",
                            value: function expandTo() {
                                var currentNode = this.parent;
                                while(currentNode){
                                    if (!currentNode.expanded) currentNode.expand();
                                    currentNode = currentNode.parent;
                                }
                            }
                        },
                        {
                            key: "appendChild",
                            value: function appendChild(node, visible, updateDom) {
                                if (this._hasChilds()) {
                                    // adjust the link to the parent
                                    node.setParent(this);
                                    node.fieldEditable = this.type === "object";
                                    if (this.type === "array") node.index = this.childs.length;
                                    if (this.type === "object" && node.field === undefined) // initialize field value if needed
                                    node.setField("");
                                    this.childs.push(node);
                                    if (this.expanded && visible !== false) {
                                        // insert into the DOM, before the appendRow
                                        var newTr = node.getDom();
                                        var nextTr = this._getNextTr();
                                        var table = nextTr ? nextTr.parentNode : undefined;
                                        if (nextTr && table) table.insertBefore(newTr, nextTr);
                                        node.showChilds();
                                        this.visibleChilds++;
                                    }
                                    if (updateDom !== false) {
                                        this.updateDom({
                                            updateIndexes: true
                                        });
                                        node.updateDom({
                                            recurse: true
                                        });
                                    }
                                }
                            }
                        },
                        {
                            key: "moveBefore",
                            value: function moveBefore(node, beforeNode, updateDom) {
                                if (this._hasChilds()) {
                                    // create a temporary row, to prevent the scroll position from jumping
                                    // when removing the node
                                    var tbody = this.dom.tr ? this.dom.tr.parentNode : undefined;
                                    var trTemp;
                                    if (tbody) {
                                        trTemp = document.createElement("tr");
                                        trTemp.style.height = tbody.clientHeight + "px";
                                        tbody.appendChild(trTemp);
                                    }
                                    if (node.parent) node.parent.removeChild(node);
                                    if (beforeNode instanceof AppendNode || !beforeNode) {
                                        // the this.childs.length + 1 is to reckon with the node that we're about to add
                                        if (this.childs.length + 1 > this.visibleChilds) {
                                            var lastVisibleNode = this.childs[this.visibleChilds - 1];
                                            this.insertBefore(node, lastVisibleNode, updateDom);
                                        } else {
                                            var visible = true;
                                            this.appendChild(node, visible, updateDom);
                                        }
                                    } else this.insertBefore(node, beforeNode, updateDom);
                                    if (tbody && trTemp) tbody.removeChild(trTemp);
                                }
                            }
                        },
                        {
                            key: "insertBefore",
                            value: function insertBefore(node, beforeNode, updateDom) {
                                if (this._hasChilds()) {
                                    this.visibleChilds++;
                                    // initialize field value if needed
                                    if (this.type === "object" && node.field === undefined) node.setField("");
                                    if (beforeNode === this.append) {
                                        // append to the child nodes
                                        // adjust the link to the parent
                                        node.setParent(this);
                                        node.fieldEditable = this.type === "object";
                                        this.childs.push(node);
                                    } else {
                                        // insert before a child node
                                        var index = this.childs.indexOf(beforeNode);
                                        if (index === -1) throw new Error("Node not found");
                                        // adjust the link to the parent
                                        node.setParent(this);
                                        node.fieldEditable = this.type === "object";
                                        this.childs.splice(index, 0, node);
                                    }
                                    if (this.expanded) {
                                        // insert into the DOM
                                        var newTr = node.getDom();
                                        var nextTr = beforeNode.getDom();
                                        var table = nextTr ? nextTr.parentNode : undefined;
                                        if (nextTr && table) table.insertBefore(newTr, nextTr);
                                        node.showChilds();
                                        this.showChilds();
                                    }
                                    if (updateDom !== false) {
                                        this.updateDom({
                                            updateIndexes: true
                                        });
                                        node.updateDom({
                                            recurse: true
                                        });
                                    }
                                }
                            }
                        },
                        {
                            key: "insertAfter",
                            value: function insertAfter(node, afterNode) {
                                if (this._hasChilds()) {
                                    var index = this.childs.indexOf(afterNode);
                                    var beforeNode = this.childs[index + 1];
                                    if (beforeNode) this.insertBefore(node, beforeNode);
                                    else this.appendChild(node);
                                }
                            }
                        },
                        {
                            key: "search",
                            value: function search(text, results) {
                                if (!Array.isArray(results)) results = [];
                                var index;
                                var search = text ? text.toLowerCase() : undefined;
                                // delete old search data
                                delete this.searchField;
                                delete this.searchValue;
                                // search in field
                                if (this.field !== undefined && results.length <= this.MAX_SEARCH_RESULTS) {
                                    var field = String(this.field).toLowerCase();
                                    index = field.indexOf(search);
                                    if (index !== -1) {
                                        this.searchField = true;
                                        results.push({
                                            node: this,
                                            elem: "field"
                                        });
                                    }
                                    // update dom
                                    this._updateDomField();
                                }
                                // search in value
                                if (this._hasChilds()) // array, object
                                // search the nodes childs
                                {
                                    if (this.childs) this.childs.forEach(function(child) {
                                        child.search(text, results);
                                    });
                                } else // string, auto
                                if (this.value !== undefined && results.length <= this.MAX_SEARCH_RESULTS) {
                                    var value = String(this.value).toLowerCase();
                                    index = value.indexOf(search);
                                    if (index !== -1) {
                                        this.searchValue = true;
                                        results.push({
                                            node: this,
                                            elem: "value"
                                        });
                                    }
                                    // update dom
                                    this._updateDomValue();
                                }
                                return results;
                            }
                        },
                        {
                            key: "scrollTo",
                            value: function scrollTo(callback) {
                                this.expandPathToNode();
                                if (this.dom.tr && this.dom.tr.parentNode) this.editor.scrollTo(this.dom.tr.offsetTop, callback);
                            }
                        },
                        {
                            key: "expandPathToNode",
                            value: function expandPathToNode() {
                                var node = this;
                                var recurse = false;
                                while(node && node.parent){
                                    // expand visible childs of the parent if needed
                                    var index = node.parent.type === "array" ? node.index : node.parent.childs.indexOf(node);
                                    while(node.parent.visibleChilds < index + 1)node.parent.visibleChilds += this.getMaxVisibleChilds();
                                    // expand the parent itself
                                    node.parent.expand(recurse);
                                    node = node.parent;
                                }
                            }
                        },
                        {
                            key: "focus",
                            value: function focus(elementName) {
                                Node1.focusElement = elementName;
                                if (this.dom.tr && this.dom.tr.parentNode) {
                                    var dom = this.dom;
                                    switch(elementName){
                                        case "drag":
                                            if (dom.drag) dom.drag.focus();
                                            else dom.menu.focus();
                                            break;
                                        case "menu":
                                            dom.menu.focus();
                                            break;
                                        case "expand":
                                            if (this._hasChilds()) dom.expand.focus();
                                            else if (dom.field && this.fieldEditable) {
                                                dom.field.focus();
                                                (0, util.selectContentEditable)(dom.field);
                                            } else if (dom.value && !this._hasChilds()) {
                                                dom.value.focus();
                                                (0, util.selectContentEditable)(dom.value);
                                            } else dom.menu.focus();
                                            break;
                                        case "field":
                                            if (dom.field && this.fieldEditable) {
                                                dom.field.focus();
                                                (0, util.selectContentEditable)(dom.field);
                                            } else if (dom.value && !this._hasChilds()) {
                                                dom.value.focus();
                                                (0, util.selectContentEditable)(dom.value);
                                            } else if (this._hasChilds()) dom.expand.focus();
                                            else dom.menu.focus();
                                            break;
                                        case "value":
                                        default:
                                            if (dom.select) // enum select box
                                            dom.select.focus();
                                            else if (dom.value && !this._hasChilds()) {
                                                dom.value.focus();
                                                (0, util.selectContentEditable)(dom.value);
                                            } else if (dom.field && this.fieldEditable) {
                                                dom.field.focus();
                                                (0, util.selectContentEditable)(dom.field);
                                            } else if (this._hasChilds()) dom.expand.focus();
                                            else dom.menu.focus();
                                            break;
                                    }
                                }
                            }
                        },
                        {
                            key: "containsNode",
                            value: function containsNode(node) {
                                if (this === node) return true;
                                var childs = this.childs;
                                if (childs) // TODO: use the js5 Array.some() here?
                                for(var i = 0, iMax = childs.length; i < iMax; i++){
                                    if (childs[i].containsNode(node)) return true;
                                }
                                return false;
                            }
                        },
                        {
                            key: "removeChild",
                            value: function removeChild(node, updateDom) {
                                if (this.childs) {
                                    var index = this.childs.indexOf(node);
                                    if (index !== -1) {
                                        if (index < this.visibleChilds && this.expanded) this.visibleChilds--;
                                        node.hide();
                                        // delete old search results
                                        delete node.searchField;
                                        delete node.searchValue;
                                        var removedNode = this.childs.splice(index, 1)[0];
                                        removedNode.parent = null;
                                        if (updateDom !== false) this.updateDom({
                                            updateIndexes: true
                                        });
                                        return removedNode;
                                    }
                                }
                                return undefined;
                            }
                        },
                        {
                            key: "_remove",
                            value: function _remove(node) {
                                this.removeChild(node);
                            }
                        },
                        {
                            key: "changeType",
                            value: function changeType(newType) {
                                var oldType = this.type;
                                if (oldType === newType) // type is not changed
                                return;
                                if ((newType === "string" || newType === "auto") && (oldType === "string" || oldType === "auto")) // this is an easy change
                                this.type = newType;
                                else {
                                    // change from array to object, or from string/auto to object/array
                                    var domAnchor = this._detachFromDom();
                                    // delete the old DOM
                                    this.clearDom();
                                    // adjust the field and the value
                                    this.type = newType;
                                    // adjust childs
                                    if (newType === "object") {
                                        if (!this.childs) this.childs = [];
                                        this.childs.forEach(function(child) {
                                            child.clearDom();
                                            delete child.index;
                                            child.fieldEditable = true;
                                            if (child.field === undefined) child.field = "";
                                        });
                                        if (oldType === "string" || oldType === "auto") this.expanded = true;
                                    } else if (newType === "array") {
                                        if (!this.childs) this.childs = [];
                                        this.childs.forEach(function(child, index) {
                                            child.clearDom();
                                            child.fieldEditable = false;
                                            child.index = index;
                                        });
                                        if (oldType === "string" || oldType === "auto") this.expanded = true;
                                    } else this.expanded = false;
                                    this._attachToDom(domAnchor);
                                }
                                if (newType === "auto" || newType === "string") {
                                    // cast value to the correct type
                                    if (newType === "string") this.value = String(this.value);
                                    else this.value = (0, util.parseString)(String(this.value));
                                    this.focus();
                                }
                                this.updateDom({
                                    updateIndexes: true
                                });
                            }
                        },
                        {
                            key: "deepEqual",
                            value: function deepEqual(json) {
                                var i;
                                if (this.type === "array") {
                                    if (!Array.isArray(json)) return false;
                                    if (this.childs.length !== json.length) return false;
                                    for(i = 0; i < this.childs.length; i++){
                                        if (!this.childs[i].deepEqual(json[i])) return false;
                                    }
                                } else if (this.type === "object") {
                                    if (Node_typeof(json) !== "object" || !json) return false;
                                    // we reckon with the order of the properties too.
                                    var props = Object.keys(json);
                                    if (this.childs.length !== props.length) return false;
                                    for(i = 0; i < props.length; i++){
                                        var child = this.childs[i];
                                        if (child.field !== props[i] || !child.deepEqual(json[child.field])) return false;
                                    }
                                } else {
                                    if (this.value !== json) return false;
                                }
                                return true;
                            }
                        },
                        {
                            key: "_getDomValue",
                            value: function _getDomValue() {
                                this._clearValueError();
                                if (this.dom.value && this.type !== "array" && this.type !== "object") {
                                    this.valueInnerText = (0, util.getInnerText)(this.dom.value);
                                    if (this.valueInnerText === "" && this.dom.value.innerHTML !== "") // When clearing the contents, often a <br/> remains, messing up the
                                    // styling of the empty text box. Therefore we remove the <br/>
                                    this.dom.value.textContent = "";
                                }
                                if (this.valueInnerText !== undefined) try {
                                    // retrieve the value
                                    var value;
                                    if (this.type === "string") value = this._unescapeHTML(this.valueInnerText);
                                    else {
                                        var str = this._unescapeHTML(this.valueInnerText);
                                        value = (0, util.parseString)(str);
                                    }
                                    if (value !== this.value) {
                                        this.value = value;
                                        this._debouncedOnChangeValue();
                                    }
                                } catch (err) {
                                    // keep the previous value
                                    this._setValueError((0, i18n /* translate */ .Iu)("cannotParseValueError"));
                                }
                            }
                        },
                        {
                            key: "_setValueError",
                            value: function _setValueError(message) {
                                this.valueError = {
                                    message: message
                                };
                                this.updateError();
                            }
                        },
                        {
                            key: "_clearValueError",
                            value: function _clearValueError() {
                                if (this.valueError) {
                                    this.valueError = null;
                                    this.updateError();
                                }
                            }
                        },
                        {
                            key: "_setFieldError",
                            value: function _setFieldError(message) {
                                this.fieldError = {
                                    message: message
                                };
                                this.updateError();
                            }
                        },
                        {
                            key: "_clearFieldError",
                            value: function _clearFieldError() {
                                if (this.fieldError) {
                                    this.fieldError = null;
                                    this.updateError();
                                }
                            }
                        },
                        {
                            key: "_onChangeValue",
                            value: function _onChangeValue() {
                                // get current selection, then override the range such that we can select
                                // the added/removed text on undo/redo
                                var oldSelection = this.editor.getDomSelection();
                                if (oldSelection.range) {
                                    var undoDiff = (0, util.textDiff)(String(this.value), String(this.previousValue));
                                    oldSelection.range.startOffset = undoDiff.start;
                                    oldSelection.range.endOffset = undoDiff.end;
                                }
                                var newSelection = this.editor.getDomSelection();
                                if (newSelection.range) {
                                    var redoDiff = (0, util.textDiff)(String(this.previousValue), String(this.value));
                                    newSelection.range.startOffset = redoDiff.start;
                                    newSelection.range.endOffset = redoDiff.end;
                                }
                                this.editor._onAction("editValue", {
                                    path: this.getInternalPath(),
                                    oldValue: this.previousValue,
                                    newValue: this.value,
                                    oldSelection: oldSelection,
                                    newSelection: newSelection
                                });
                                this.previousValue = this.value;
                            }
                        },
                        {
                            key: "_onChangeField",
                            value: function _onChangeField() {
                                // get current selection, then override the range such that we can select
                                // the added/removed text on undo/redo
                                var oldSelection = this.editor.getDomSelection();
                                var previous = this.previousField || "";
                                if (oldSelection.range) {
                                    var undoDiff = (0, util.textDiff)(this.field, previous);
                                    oldSelection.range.startOffset = undoDiff.start;
                                    oldSelection.range.endOffset = undoDiff.end;
                                }
                                var newSelection = this.editor.getDomSelection();
                                if (newSelection.range) {
                                    var redoDiff = (0, util.textDiff)(previous, this.field);
                                    newSelection.range.startOffset = redoDiff.start;
                                    newSelection.range.endOffset = redoDiff.end;
                                }
                                this.editor._onAction("editField", {
                                    parentPath: this.parent.getInternalPath(),
                                    index: this.getIndex(),
                                    oldValue: this.previousField,
                                    newValue: this.field,
                                    oldSelection: oldSelection,
                                    newSelection: newSelection
                                });
                                this.previousField = this.field;
                            }
                        },
                        {
                            key: "_updateDomValue",
                            value: function _updateDomValue() {
                                var domValue = this.dom.value;
                                if (domValue) {
                                    var classNames = [
                                        "jsoneditor-value"
                                    ];
                                    // set text color depending on value type
                                    var value = this.value;
                                    var valueType = this.type === "auto" ? (0, util.getType)(value) : this.type;
                                    var valueIsUrl = valueType === "string" && (0, util.isUrl)(value);
                                    classNames.push("jsoneditor-" + valueType);
                                    if (valueIsUrl) classNames.push("jsoneditor-url");
                                    // visual styling when empty
                                    var isEmpty = String(this.value) === "" && this.type !== "array" && this.type !== "object";
                                    if (isEmpty) classNames.push("jsoneditor-empty");
                                    // highlight when there is a search result
                                    if (this.searchValueActive) classNames.push("jsoneditor-highlight-active");
                                    if (this.searchValue) classNames.push("jsoneditor-highlight");
                                    domValue.className = classNames.join(" ");
                                    // update title
                                    if (valueType === "array" || valueType === "object") {
                                        var count = this.childs ? this.childs.length : 0;
                                        domValue.title = this.type + " containing " + count + " items";
                                    } else if (valueIsUrl && this.editable.value) domValue.title = (0, i18n /* translate */ .Iu)("openUrl");
                                    else domValue.title = "";
                                    // show checkbox when the value is a boolean
                                    if (valueType === "boolean" && this.editable.value) {
                                        if (!this.dom.checkbox) {
                                            this.dom.checkbox = document.createElement("input");
                                            this.dom.checkbox.type = "checkbox";
                                            this.dom.tdCheckbox = document.createElement("td");
                                            this.dom.tdCheckbox.className = "jsoneditor-tree";
                                            this.dom.tdCheckbox.appendChild(this.dom.checkbox);
                                            this.dom.tdValue.parentNode.insertBefore(this.dom.tdCheckbox, this.dom.tdValue);
                                        }
                                        this.dom.checkbox.checked = this.value;
                                    } else // cleanup checkbox when displayed
                                    if (this.dom.tdCheckbox) {
                                        this.dom.tdCheckbox.parentNode.removeChild(this.dom.tdCheckbox);
                                        delete this.dom.tdCheckbox;
                                        delete this.dom.checkbox;
                                    }
                                    // create select box when this node has an enum object
                                    if (this["enum"] && this.editable.value) {
                                        if (!this.dom.select) {
                                            this.dom.select = document.createElement("select");
                                            this.id = this.field + "_" + new Date().getUTCMilliseconds();
                                            this.dom.select.id = this.id;
                                            this.dom.select.name = this.dom.select.id;
                                            // Create the default empty option
                                            var defaultOption = document.createElement("option");
                                            defaultOption.value = "";
                                            defaultOption.textContent = "--";
                                            this.dom.select.appendChild(defaultOption);
                                            // Iterate all enum values and add them as options
                                            this._updateEnumOptions();
                                            this.dom.tdSelect = document.createElement("td");
                                            this.dom.tdSelect.className = "jsoneditor-tree";
                                            this.dom.tdSelect.appendChild(this.dom.select);
                                            this.dom.tdValue.parentNode.insertBefore(this.dom.tdSelect, this.dom.tdValue);
                                        }
                                        // Select the matching value
                                        this.dom.select.value = this["enum"].indexOf(this.value) !== -1 ? this.value : ""; // default
                                        // If the enum is inside a composite type display
                                        // both the simple input and the dropdown field
                                        if (this.schema && !Node_hasOwnProperty(this.schema, "oneOf") && !Node_hasOwnProperty(this.schema, "anyOf") && !Node_hasOwnProperty(this.schema, "allOf")) {
                                            this.valueFieldHTML = this.dom.tdValue.innerHTML;
                                            this.dom.tdValue.style.visibility = "hidden";
                                            this.dom.tdValue.textContent = "";
                                        } else delete this.valueFieldHTML;
                                    } else // cleanup select box when displayed, and attach the editable div instead
                                    if (this.dom.tdSelect) {
                                        this.dom.tdSelect.parentNode.removeChild(this.dom.tdSelect);
                                        delete this.dom.tdSelect;
                                        delete this.dom.select;
                                        this.dom.tdValue.innerHTML = this.valueFieldHTML;
                                        this.dom.tdValue.style.visibility = "";
                                        delete this.valueFieldHTML;
                                        this.dom.tdValue.appendChild(this.dom.value);
                                    }
                                    // show color picker when value is a color
                                    if (this.editor.options.colorPicker && typeof value === "string" && (0, util.isValidColor)(value)) {
                                        if (!this.dom.color) {
                                            this.dom.color = document.createElement("div");
                                            this.dom.color.className = "jsoneditor-color";
                                            this.dom.tdColor = document.createElement("td");
                                            this.dom.tdColor.className = "jsoneditor-tree";
                                            this.dom.tdColor.appendChild(this.dom.color);
                                            this.dom.tdValue.parentNode.insertBefore(this.dom.tdColor, this.dom.tdValue);
                                        }
                                        // update styling of value and color background
                                        (0, util.addClassName)(this.dom.value, "jsoneditor-color-value");
                                        if (!this.editable.value) (0, util.addClassName)(this.dom.color, "jsoneditor-color-readonly");
                                        else (0, util.removeClassName)(this.dom.color, "jsoneditor-color-readonly");
                                        this.dom.color.style.backgroundColor = value;
                                    } else // cleanup color picker when displayed
                                    this._deleteDomColor();
                                    // show date tag when value is a timestamp in milliseconds
                                    if (this._showTimestampTag()) {
                                        if (!this.dom.date) {
                                            this.dom.date = document.createElement("div");
                                            this.dom.date.className = "jsoneditor-date";
                                            this.dom.value.parentNode.appendChild(this.dom.date);
                                        }
                                        var title = null;
                                        if (typeof this.editor.options.timestampFormat === "function") title = this.editor.options.timestampFormat({
                                            field: this.field,
                                            value: this.value,
                                            path: this.getPath()
                                        });
                                        if (!title) this.dom.date.textContent = new Date(value).toISOString();
                                        else {
                                            while(this.dom.date.firstChild)this.dom.date.removeChild(this.dom.date.firstChild);
                                            this.dom.date.appendChild(document.createTextNode(title));
                                        }
                                        this.dom.date.title = new Date(value).toString();
                                    } else // cleanup date tag
                                    if (this.dom.date) {
                                        this.dom.date.parentNode.removeChild(this.dom.date);
                                        delete this.dom.date;
                                    }
                                    // strip formatting from the contents of the editable div
                                    (0, util.stripFormatting)(domValue);
                                    this._updateDomDefault();
                                }
                            }
                        },
                        {
                            key: "_updateEnumOptions",
                            value: function _updateEnumOptions() {
                                if (!this["enum"] || !this.dom.select) return;
                                // clear the existing options
                                this.dom.select.innerHTML = "";
                                // Iterate all enum values and add them as options
                                for(var i = 0; i < this["enum"].length; i++){
                                    var option = document.createElement("option");
                                    option.value = this["enum"][i];
                                    option.textContent = this["enum"][i];
                                    this.dom.select.appendChild(option);
                                }
                            }
                        },
                        {
                            key: "_deleteDomColor",
                            value: function _deleteDomColor() {
                                if (this.dom.color) {
                                    this.dom.tdColor.parentNode.removeChild(this.dom.tdColor);
                                    delete this.dom.tdColor;
                                    delete this.dom.color;
                                    (0, util.removeClassName)(this.dom.value, "jsoneditor-color-value");
                                }
                            }
                        },
                        {
                            key: "_updateDomField",
                            value: function _updateDomField() {
                                var domField = this.dom.field;
                                if (domField) {
                                    var tooltip = (0, util.makeFieldTooltip)(this.schema, this.editor.options.language);
                                    if (tooltip) domField.title = tooltip;
                                    // make background color lightgray when empty
                                    var isEmpty = String(this.field) === "" && this.parent && this.parent.type !== "array";
                                    if (isEmpty) (0, util.addClassName)(domField, "jsoneditor-empty");
                                    else (0, util.removeClassName)(domField, "jsoneditor-empty");
                                    // highlight when there is a search result
                                    if (this.searchFieldActive) (0, util.addClassName)(domField, "jsoneditor-highlight-active");
                                    else (0, util.removeClassName)(domField, "jsoneditor-highlight-active");
                                    if (this.searchField) (0, util.addClassName)(domField, "jsoneditor-highlight");
                                    else (0, util.removeClassName)(domField, "jsoneditor-highlight");
                                    // strip formatting from the contents of the editable div
                                    (0, util.stripFormatting)(domField);
                                }
                            }
                        },
                        {
                            key: "_getDomField",
                            value: function _getDomField(forceUnique) {
                                this._clearFieldError();
                                if (this.dom.field && this.fieldEditable) {
                                    this.fieldInnerText = (0, util.getInnerText)(this.dom.field);
                                    if (this.fieldInnerText === "" && this.dom.field.innerHTML !== "") // When clearing the contents, often a <br/> remains, messing up the
                                    // styling of the empty text box. Therefore we remove the <br/>
                                    this.dom.field.textContent = "";
                                }
                                if (this.fieldInnerText !== undefined) try {
                                    var field = this._unescapeHTML(this.fieldInnerText);
                                    var existingFieldNames = this.parent.getFieldNames(this);
                                    var isDuplicate = existingFieldNames.indexOf(field) !== -1;
                                    if (!isDuplicate) {
                                        if (field !== this.field) {
                                            this.field = field;
                                            this._debouncedOnChangeField();
                                        }
                                    } else if (forceUnique) {
                                        // fix duplicate field: change it into a unique name
                                        field = (0, util.findUniqueName)(field, existingFieldNames);
                                        if (field !== this.field) {
                                            this.field = field;
                                            // TODO: don't debounce but resolve right away, and cancel current debounce
                                            this._debouncedOnChangeField();
                                        }
                                    } else this._setFieldError((0, i18n /* translate */ .Iu)("duplicateFieldError"));
                                } catch (err) {
                                    // keep the previous field value
                                    this._setFieldError((0, i18n /* translate */ .Iu)("cannotParseFieldError"));
                                }
                            }
                        },
                        {
                            key: "_updateDomDefault",
                            value: function _updateDomDefault() {
                                // Short-circuit if schema is missing, has no default, or if Node has children
                                if (!this.schema || this.schema["default"] === undefined || this._hasChilds()) return;
                                // select either enum dropdown (select) or input value
                                var inputElement = this.dom.select ? this.dom.select : this.dom.value;
                                if (!inputElement) return;
                                if (this.value === this.schema["default"]) {
                                    inputElement.title = (0, i18n /* translate */ .Iu)("default");
                                    (0, util.addClassName)(inputElement, "jsoneditor-is-default");
                                    (0, util.removeClassName)(inputElement, "jsoneditor-is-not-default");
                                } else {
                                    inputElement.removeAttribute("title");
                                    (0, util.removeClassName)(inputElement, "jsoneditor-is-default");
                                    (0, util.addClassName)(inputElement, "jsoneditor-is-not-default");
                                }
                            }
                        },
                        {
                            key: "_showTimestampTag",
                            value: function _showTimestampTag() {
                                if (typeof this.value !== "number") return false;
                                var timestampTag = this.editor.options.timestampTag;
                                if (typeof timestampTag === "function") {
                                    var result = timestampTag({
                                        field: this.field,
                                        value: this.value,
                                        path: this.getPath()
                                    });
                                    if (typeof result === "boolean") return result;
                                    else return (0, util.isTimestamp)(this.field, this.value);
                                } else if (timestampTag === true) return (0, util.isTimestamp)(this.field, this.value);
                                else return false;
                            }
                        },
                        {
                            key: "clearDom",
                            value: function clearDom() {
                                // TODO: hide the node first?
                                // this.hide();
                                // TODO: recursively clear dom?
                                this.dom = {};
                            }
                        },
                        {
                            key: "getDom",
                            value: function getDom() {
                                var dom = this.dom;
                                if (dom.tr) return dom.tr;
                                this._updateEditability();
                                // create row
                                dom.tr = document.createElement("tr");
                                dom.tr.node = this;
                                if (this.editor.options.mode === "tree") {
                                    // note: we take here the global setting
                                    var tdDrag = document.createElement("td");
                                    if (this.editable.field) // create draggable area
                                    {
                                        if (this.parent) {
                                            var domDrag = document.createElement("button");
                                            domDrag.type = "button";
                                            dom.drag = domDrag;
                                            domDrag.className = "jsoneditor-button jsoneditor-dragarea";
                                            domDrag.title = (0, i18n /* translate */ .Iu)("drag");
                                            tdDrag.appendChild(domDrag);
                                        }
                                    }
                                    dom.tr.appendChild(tdDrag);
                                    // create context menu
                                    var tdMenu = document.createElement("td");
                                    var menu = document.createElement("button");
                                    menu.type = "button";
                                    dom.menu = menu;
                                    menu.className = "jsoneditor-button jsoneditor-contextmenu-button";
                                    menu.title = (0, i18n /* translate */ .Iu)("actionsMenu");
                                    tdMenu.appendChild(dom.menu);
                                    dom.tr.appendChild(tdMenu);
                                }
                                // create tree and field
                                var tdField = document.createElement("td");
                                dom.tr.appendChild(tdField);
                                dom.tree = this._createDomTree();
                                tdField.appendChild(dom.tree);
                                this.updateDom({
                                    updateIndexes: true
                                });
                                return dom.tr;
                            }
                        },
                        {
                            key: "isVisible",
                            value: function isVisible() {
                                return this.dom && this.dom.tr && this.dom.tr.parentNode || false;
                            }
                        },
                        {
                            key: "isDescendantOf",
                            value: function isDescendantOf(node) {
                                var n = this.parent;
                                while(n){
                                    if (n === node) return true;
                                    n = n.parent;
                                }
                                return false;
                            }
                        },
                        {
                            key: "_createDomField",
                            value: function _createDomField() {
                                return document.createElement("div");
                            }
                        },
                        {
                            key: "setHighlight",
                            value: function setHighlight(highlight) {
                                if (this.dom.tr) {
                                    if (highlight) (0, util.addClassName)(this.dom.tr, "jsoneditor-highlight");
                                    else (0, util.removeClassName)(this.dom.tr, "jsoneditor-highlight");
                                    if (this.append) this.append.setHighlight(highlight);
                                    if (this.childs) this.childs.forEach(function(child) {
                                        child.setHighlight(highlight);
                                    });
                                }
                            }
                        },
                        {
                            key: "setSelected",
                            value: function setSelected(selected, isFirst) {
                                this.selected = selected;
                                if (this.dom.tr) {
                                    if (selected) (0, util.addClassName)(this.dom.tr, "jsoneditor-selected");
                                    else (0, util.removeClassName)(this.dom.tr, "jsoneditor-selected");
                                    if (isFirst) (0, util.addClassName)(this.dom.tr, "jsoneditor-first");
                                    else (0, util.removeClassName)(this.dom.tr, "jsoneditor-first");
                                    if (this.append) this.append.setSelected(selected);
                                    if (this.showMore) this.showMore.setSelected(selected);
                                    if (this.childs) this.childs.forEach(function(child) {
                                        child.setSelected(selected);
                                    });
                                }
                            }
                        },
                        {
                            key: "updateValue",
                            value: function updateValue(value) {
                                this.value = value;
                                this.previousValue = value;
                                this.valueError = undefined;
                                this.updateDom();
                            }
                        },
                        {
                            key: "updateField",
                            value: function updateField(field) {
                                this.field = field;
                                this.previousField = field;
                                this.fieldError = undefined;
                                this.updateDom();
                            }
                        },
                        {
                            key: "updateDom",
                            value: function updateDom(options) {
                                // update level indentation
                                var domTree = this.dom.tree;
                                if (domTree) domTree.style.marginLeft = this.getLevel() * 24 + "px";
                                // apply field to DOM
                                var domField = this.dom.field;
                                if (domField) {
                                    if (this.fieldEditable) {
                                        // parent is an object
                                        domField.contentEditable = this.editable.field;
                                        domField.spellcheck = false;
                                        domField.className = "jsoneditor-field";
                                    } else {
                                        // parent is an array this is the root node
                                        domField.contentEditable = false;
                                        domField.className = "jsoneditor-readonly";
                                    }
                                    var fieldText;
                                    if (this.index !== undefined) fieldText = this.index;
                                    else if (this.field !== undefined) fieldText = this.field;
                                    else {
                                        var schema = this.editor.options.schema ? Node1._findSchema(this.editor.options.schema, this.editor.options.schemaRefs || {}, this.getPath()) : undefined;
                                        if (schema && schema.title) fieldText = schema.title;
                                        else if (this._hasChilds()) fieldText = this.type;
                                        else fieldText = "";
                                    }
                                    var escapedField = this._escapeHTML(fieldText);
                                    if (document.activeElement !== domField && escapedField !== this._unescapeHTML((0, util.getInnerText)(domField))) // only update if it not has the focus or when there is an actual change,
                                    // else you would needlessly loose the caret position when changing tabs
                                    // or whilst typing
                                    domField.innerHTML = escapedField;
                                    this._updateSchema();
                                    this._updateEnumOptions();
                                }
                                // apply value to DOM
                                var domValue = this.dom.value;
                                if (domValue) {
                                    if (this.type === "array" || this.type === "object") this.updateNodeName();
                                    else {
                                        var escapedValue = this._escapeHTML(this.value);
                                        if (document.activeElement !== domValue && escapedValue !== this._unescapeHTML((0, util.getInnerText)(domValue))) // only update if it not has the focus or when there is an actual change,
                                        // else you would needlessly loose the caret position when changing tabs
                                        // or whilst typing
                                        domValue.innerHTML = escapedValue;
                                    }
                                }
                                // apply styling to the table row
                                var tr = this.dom.tr;
                                if (tr) {
                                    if (this.type === "array" || this.type === "object") {
                                        (0, util.addClassName)(tr, "jsoneditor-expandable");
                                        if (this.expanded) {
                                            (0, util.addClassName)(tr, "jsoneditor-expanded");
                                            (0, util.removeClassName)(tr, "jsoneditor-collapsed");
                                        } else {
                                            (0, util.addClassName)(tr, "jsoneditor-collapsed");
                                            (0, util.removeClassName)(tr, "jsoneditor-expanded");
                                        }
                                    } else {
                                        (0, util.removeClassName)(tr, "jsoneditor-expandable");
                                        (0, util.removeClassName)(tr, "jsoneditor-expanded");
                                        (0, util.removeClassName)(tr, "jsoneditor-collapsed");
                                    }
                                }
                                // update field and value
                                this._updateDomField();
                                this._updateDomValue();
                                // update childs indexes
                                if (options && options.updateIndexes === true) // updateIndexes is true or undefined
                                this._updateDomIndexes();
                                // update childs recursively
                                if (options && options.recurse === true) {
                                    if (this.childs) this.childs.forEach(function(child) {
                                        child.updateDom(options);
                                    });
                                }
                                // update rendering of error
                                if (this.error) this.updateError();
                                // update row with append button
                                if (this.append) this.append.updateDom();
                                // update "show more" text at the bottom of large arrays
                                if (this.showMore) this.showMore.updateDom();
                                // fire onClassName
                                this._updateCssClassName();
                            }
                        },
                        {
                            key: "_updateSchema",
                            value: function _updateSchema() {
                                // Locating the schema of the node and checking for any enum type
                                if (this.editor && this.editor.options) {
                                    // find the part of the json schema matching this nodes path
                                    this.schema = this.editor.options.schema ? Node1._findSchema(this.editor.options.schema, this.editor.options.schemaRefs || {}, this.getPath()) : null;
                                    if (this.schema) this["enum"] = Node1._findEnum(this.schema);
                                    else delete this["enum"];
                                }
                            }
                        },
                        {
                            key: "_updateDomIndexes",
                            value: function _updateDomIndexes() {
                                var domValue = this.dom.value;
                                var childs = this.childs;
                                if (domValue && childs) {
                                    if (this.type === "array") childs.forEach(function(child, index) {
                                        child.index = index;
                                        var childField = child.dom.field;
                                        if (childField) childField.textContent = index;
                                    });
                                    else if (this.type === "object") childs.forEach(function(child) {
                                        if (child.index !== undefined) {
                                            delete child.index;
                                            if (child.field === undefined) child.field = "";
                                        }
                                    });
                                }
                            }
                        },
                        {
                            key: "_createDomValue",
                            value: function _createDomValue() {
                                var domValue;
                                if (this.type === "array") {
                                    domValue = document.createElement("div");
                                    domValue.textContent = "[...]";
                                } else if (this.type === "object") {
                                    domValue = document.createElement("div");
                                    domValue.textContent = "{...}";
                                } else if (!this.editable.value && (0, util.isUrl)(this.value)) {
                                    // create a link in case of read-only editor and value containing an url
                                    domValue = document.createElement("a");
                                    domValue.href = this.value;
                                    domValue.innerHTML = this._escapeHTML(this.value);
                                } else {
                                    // create an editable or read-only div
                                    domValue = document.createElement("div");
                                    domValue.contentEditable = this.editable.value;
                                    domValue.spellcheck = false;
                                    domValue.innerHTML = this._escapeHTML(this.value);
                                }
                                return domValue;
                            }
                        },
                        {
                            key: "_createDomExpandButton",
                            value: function _createDomExpandButton() {
                                // create expand button
                                var expand = document.createElement("button");
                                expand.type = "button";
                                if (this._hasChilds()) {
                                    expand.className = this.expanded ? "jsoneditor-button jsoneditor-expanded" : "jsoneditor-button jsoneditor-collapsed";
                                    expand.title = (0, i18n /* translate */ .Iu)("expandTitle");
                                } else {
                                    expand.className = "jsoneditor-button jsoneditor-invisible";
                                    expand.title = "";
                                }
                                return expand;
                            }
                        },
                        {
                            key: "_createDomTree",
                            value: function _createDomTree() {
                                var dom = this.dom;
                                var domTree = document.createElement("table");
                                var tbody = document.createElement("tbody");
                                domTree.style.borderCollapse = "collapse"; // TODO: put in css
                                domTree.className = "jsoneditor-values";
                                domTree.appendChild(tbody);
                                var tr = document.createElement("tr");
                                tbody.appendChild(tr);
                                // create expand button
                                var tdExpand = document.createElement("td");
                                tdExpand.className = "jsoneditor-tree";
                                tr.appendChild(tdExpand);
                                dom.expand = this._createDomExpandButton();
                                tdExpand.appendChild(dom.expand);
                                dom.tdExpand = tdExpand;
                                // create the field
                                var tdField = document.createElement("td");
                                tdField.className = "jsoneditor-tree";
                                tr.appendChild(tdField);
                                dom.field = this._createDomField();
                                tdField.appendChild(dom.field);
                                dom.tdField = tdField;
                                // create a separator
                                var tdSeparator = document.createElement("td");
                                tdSeparator.className = "jsoneditor-tree";
                                tr.appendChild(tdSeparator);
                                if (this.type !== "object" && this.type !== "array") {
                                    tdSeparator.appendChild(document.createTextNode(":"));
                                    tdSeparator.className = "jsoneditor-separator";
                                }
                                dom.tdSeparator = tdSeparator;
                                // create the value
                                var tdValue = document.createElement("td");
                                tdValue.className = "jsoneditor-tree";
                                tr.appendChild(tdValue);
                                dom.value = this._createDomValue();
                                tdValue.appendChild(dom.value);
                                dom.tdValue = tdValue;
                                return domTree;
                            }
                        },
                        {
                            key: "onEvent",
                            value: function onEvent(event) {
                                var type = event.type;
                                var target = event.target || event.srcElement;
                                var dom = this.dom;
                                var node = this;
                                var expandable = this._hasChilds();
                                // check if mouse is on menu or on dragarea.
                                // If so, highlight current row and its childs
                                if (target === dom.drag || target === dom.menu) {
                                    if (type === "mouseover") this.editor.highlighter.highlight(this);
                                    else if (type === "mouseout") this.editor.highlighter.unhighlight();
                                }
                                // context menu events
                                if (type === "click" && target === dom.menu) {
                                    var highlighter = node.editor.highlighter;
                                    highlighter.highlight(node);
                                    highlighter.lock();
                                    (0, util.addClassName)(dom.menu, "jsoneditor-selected");
                                    this.showContextMenu(dom.menu, function() {
                                        (0, util.removeClassName)(dom.menu, "jsoneditor-selected");
                                        highlighter.unlock();
                                        highlighter.unhighlight();
                                    });
                                }
                                // expand events
                                if (type === "click") {
                                    if (target === dom.expand) {
                                        if (expandable) {
                                            var recurse = event.ctrlKey; // with ctrl-key, expand/collapse all
                                            this._onExpand(recurse);
                                        }
                                    }
                                }
                                if (type === "click" && (event.target === node.dom.tdColor || event.target === node.dom.color) && this.editable.value) this._showColorPicker();
                                // swap the value of a boolean when the checkbox displayed left is clicked
                                if (type === "change" && target === dom.checkbox) {
                                    this.dom.value.textContent = String(!this.value);
                                    this._getDomValue();
                                    this._updateDomDefault();
                                }
                                // update the value of the node based on the selected option
                                if (type === "change" && target === dom.select) {
                                    this.dom.value.innerHTML = this._escapeHTML(dom.select.value);
                                    this._getDomValue();
                                    this._updateDomValue();
                                }
                                // value events
                                var domValue = dom.value;
                                if (target === domValue) // noinspection FallthroughInSwitchStatementJS
                                switch(type){
                                    case "blur":
                                    case "change":
                                        this._getDomValue();
                                        this._clearValueError();
                                        this._updateDomValue();
                                        var escapedValue = this._escapeHTML(this.value);
                                        if (escapedValue !== this._unescapeHTML((0, util.getInnerText)(domValue))) // only update when there is an actual change, else you loose the
                                        // caret position when changing tabs or whilst typing
                                        domValue.innerHTML = escapedValue;
                                        break;
                                    case "input":
                                        // this._debouncedGetDomValue(true); // TODO
                                        this._getDomValue();
                                        this._updateDomValue();
                                        break;
                                    case "keydown":
                                    case "mousedown":
                                        // TODO: cleanup
                                        this.editor.selection = this.editor.getDomSelection();
                                        break;
                                    case "click":
                                        if (event.ctrlKey && this.editable.value) // if read-only, we use the regular click behavior of an anchor
                                        {
                                            if ((0, util.isUrl)(this.value)) {
                                                event.preventDefault();
                                                window.open(this.value, "_blank", "noreferrer");
                                            }
                                        }
                                        break;
                                    case "keyup":
                                        // this._debouncedGetDomValue(true); // TODO
                                        this._getDomValue();
                                        this._updateDomValue();
                                        break;
                                    case "cut":
                                    case "paste":
                                        setTimeout(function() {
                                            node._getDomValue();
                                            node._updateDomValue();
                                        }, 1);
                                        break;
                                }
                                // field events
                                var domField = dom.field;
                                if (target === domField) switch(type){
                                    case "blur":
                                        this._getDomField(true);
                                        this._updateDomField();
                                        var escapedField = this._escapeHTML(this.field);
                                        if (escapedField !== this._unescapeHTML((0, util.getInnerText)(domField))) // only update when there is an actual change, else you loose the
                                        // caret position when changing tabs or whilst typing
                                        domField.innerHTML = escapedField;
                                        break;
                                    case "input":
                                        this._getDomField();
                                        this._updateSchema();
                                        this._updateDomField();
                                        this._updateDomValue();
                                        break;
                                    case "keydown":
                                    case "mousedown":
                                        this.editor.selection = this.editor.getDomSelection();
                                        break;
                                    case "keyup":
                                        this._getDomField();
                                        this._updateDomField();
                                        break;
                                    case "cut":
                                    case "paste":
                                        setTimeout(function() {
                                            node._getDomField();
                                            node._updateDomField();
                                        }, 1);
                                        break;
                                }
                                // focus
                                // when clicked in whitespace left or right from the field or value, set focus
                                var domTree = dom.tree;
                                if (domTree && target === domTree.parentNode && type === "click" && !event.hasMoved) {
                                    var left = event.offsetX !== undefined ? event.offsetX < (this.getLevel() + 1) * 24 : event.pageX < (0, util.getAbsoluteLeft)(dom.tdSeparator); // for FF
                                    if (left || expandable) // node is expandable when it is an object or array
                                    {
                                        if (domField) {
                                            (0, util.setEndOfContentEditable)(domField);
                                            domField.focus();
                                        }
                                    } else if (domValue && !this["enum"]) {
                                        (0, util.setEndOfContentEditable)(domValue);
                                        domValue.focus();
                                    }
                                }
                                if ((target === dom.tdExpand && !expandable || target === dom.tdField || target === dom.tdSeparator) && type === "click" && !event.hasMoved) {
                                    if (domField) {
                                        (0, util.setEndOfContentEditable)(domField);
                                        domField.focus();
                                    }
                                }
                                if (type === "keydown") this.onKeyDown(event);
                                // fire after applying for example a change by clicking a checkbox
                                if (typeof this.editor.options.onEvent === "function") this._onEvent(event);
                            }
                        },
                        {
                            key: "_onEvent",
                            value: function _onEvent(event) {
                                var element = event.target;
                                var isField = element === this.dom.field;
                                var isValue = element === this.dom.value || element === this.dom.checkbox || element === this.dom.select;
                                if (isField || isValue) {
                                    var info = {
                                        field: this.getField(),
                                        path: this.getPath()
                                    };
                                    // For leaf values, include value
                                    if (isValue && !this._hasChilds()) info.value = this.getValue();
                                    this.editor.options.onEvent(info, event);
                                }
                            }
                        },
                        {
                            key: "onKeyDown",
                            value: function onKeyDown(event) {
                                var keynum = event.which || event.keyCode;
                                var target = event.target || event.srcElement;
                                var ctrlKey = event.ctrlKey;
                                var shiftKey = event.shiftKey;
                                var altKey = event.altKey;
                                var handled = false;
                                var prevNode, nextNode, nextDom, nextDom2;
                                var editable = this.editor.options.mode === "tree";
                                var oldSelection;
                                var oldNextNode;
                                var oldParent;
                                var oldIndexRedo;
                                var newIndexRedo;
                                var oldParentPathRedo;
                                var newParentPathRedo;
                                var nodes;
                                var multiselection;
                                var selectedNodes = this.editor.multiselection.nodes.length > 0 ? this.editor.multiselection.nodes : [
                                    this
                                ];
                                var firstNode = selectedNodes[0];
                                var lastNode = selectedNodes[selectedNodes.length - 1];
                                // console.log(ctrlKey, keynum, event.charCode); // TODO: cleanup
                                if (keynum === 13) {
                                    // Enter
                                    if (target === this.dom.value) {
                                        if (!this.editable.value || event.ctrlKey) {
                                            if ((0, util.isUrl)(this.value)) {
                                                window.open(this.value, "_blank", "noreferrer");
                                                handled = true;
                                            }
                                        }
                                    } else if (target === this.dom.expand) {
                                        var expandable = this._hasChilds();
                                        if (expandable) {
                                            var recurse = event.ctrlKey; // with ctrl-key, expand/collapse all
                                            this._onExpand(recurse);
                                            target.focus();
                                            handled = true;
                                        }
                                    }
                                } else if (keynum === 68) // D
                                {
                                    if (ctrlKey && editable) {
                                        // Ctrl+D
                                        Node1.onDuplicate(selectedNodes);
                                        handled = true;
                                    }
                                } else if (keynum === 69) // E
                                {
                                    if (ctrlKey) {
                                        // Ctrl+E and Ctrl+Shift+E
                                        this._onExpand(shiftKey); // recurse = shiftKey
                                        target.focus(); // TODO: should restore focus in case of recursing expand (which takes DOM offline)
                                        handled = true;
                                    }
                                } else if (keynum === 77 && editable) // M
                                {
                                    if (ctrlKey) {
                                        // Ctrl+M
                                        this.showContextMenu(target);
                                        handled = true;
                                    }
                                } else if (keynum === 46 && editable) // Del
                                {
                                    if (ctrlKey) {
                                        // Ctrl+Del
                                        Node1.onRemove(selectedNodes);
                                        handled = true;
                                    }
                                } else if (keynum === 45 && editable) {
                                    // Ins
                                    if (ctrlKey && !shiftKey) {
                                        // Ctrl+Ins
                                        this._onInsertBefore();
                                        handled = true;
                                    } else if (ctrlKey && shiftKey) {
                                        // Ctrl+Shift+Ins
                                        this._onInsertAfter();
                                        handled = true;
                                    }
                                } else if (keynum === 35) // End
                                {
                                    if (altKey) {
                                        // Alt+End
                                        // find the last node
                                        var endNode = this._lastNode();
                                        if (endNode) endNode.focus(Node1.focusElement || this._getElementName(target));
                                        handled = true;
                                    }
                                } else if (keynum === 36) // Home
                                {
                                    if (altKey) {
                                        // Alt+Home
                                        // find the first node
                                        var homeNode = this._firstNode();
                                        if (homeNode) homeNode.focus(Node1.focusElement || this._getElementName(target));
                                        handled = true;
                                    }
                                } else if (keynum === 37) {
                                    // Arrow Left
                                    if (altKey && !shiftKey) {
                                        // Alt + Arrow Left
                                        // move to left element
                                        var prevElement = this._previousElement(target);
                                        if (prevElement) this.focus(this._getElementName(prevElement));
                                        handled = true;
                                    } else if (altKey && shiftKey && editable) {
                                        // Alt + Shift + Arrow left
                                        if (lastNode.expanded) {
                                            var appendDom = lastNode.getAppendDom();
                                            nextDom = appendDom ? appendDom.nextSibling : undefined;
                                        } else {
                                            var dom = lastNode.getDom();
                                            nextDom = dom.nextSibling;
                                        }
                                        if (nextDom) {
                                            nextNode = Node1.getNodeFromTarget(nextDom);
                                            nextDom2 = nextDom.nextSibling;
                                            var nextNode2 = Node1.getNodeFromTarget(nextDom2);
                                            if (nextNode && nextNode instanceof AppendNode && !(lastNode.parent.childs.length === 1) && nextNode2 && nextNode2.parent) {
                                                oldSelection = this.editor.getDomSelection();
                                                oldParent = firstNode.parent;
                                                oldNextNode = oldParent.childs[lastNode.getIndex() + 1] || oldParent.append;
                                                oldIndexRedo = firstNode.getIndex();
                                                newIndexRedo = nextNode2.getIndex();
                                                oldParentPathRedo = oldParent.getInternalPath();
                                                newParentPathRedo = nextNode2.parent.getInternalPath();
                                                selectedNodes.forEach(function(node) {
                                                    nextNode2.parent.moveBefore(node, nextNode2);
                                                });
                                                this.focus(Node1.focusElement || this._getElementName(target));
                                                this.editor._onAction("moveNodes", {
                                                    count: selectedNodes.length,
                                                    fieldNames: selectedNodes.map(getField),
                                                    oldParentPath: oldParent.getInternalPath(),
                                                    newParentPath: firstNode.parent.getInternalPath(),
                                                    oldIndex: oldNextNode.getIndex(),
                                                    newIndex: firstNode.getIndex(),
                                                    oldIndexRedo: oldIndexRedo,
                                                    newIndexRedo: newIndexRedo,
                                                    oldParentPathRedo: oldParentPathRedo,
                                                    newParentPathRedo: newParentPathRedo,
                                                    oldSelection: oldSelection,
                                                    newSelection: this.editor.getDomSelection()
                                                });
                                            }
                                        }
                                    }
                                } else if (keynum === 38) {
                                    // Arrow Up
                                    if (altKey && !shiftKey) {
                                        // Alt + Arrow Up
                                        // find the previous node
                                        prevNode = this._previousNode();
                                        if (prevNode) {
                                            this.editor.deselect(true);
                                            prevNode.focus(Node1.focusElement || this._getElementName(target));
                                        }
                                        handled = true;
                                    } else if (!altKey && ctrlKey && shiftKey && editable) {
                                        // Ctrl + Shift + Arrow Up
                                        // select multiple nodes
                                        prevNode = this._previousNode();
                                        if (prevNode) {
                                            multiselection = this.editor.multiselection;
                                            multiselection.start = multiselection.start || this;
                                            multiselection.end = prevNode;
                                            nodes = this.editor._findTopLevelNodes(multiselection.start, multiselection.end);
                                            this.editor.select(nodes);
                                            prevNode.focus("field"); // select field as we know this always exists
                                        }
                                        handled = true;
                                    } else if (altKey && shiftKey && editable) {
                                        // Alt + Shift + Arrow Up
                                        // find the previous node
                                        prevNode = firstNode._previousNode();
                                        if (prevNode && prevNode.parent) {
                                            oldSelection = this.editor.getDomSelection();
                                            oldParent = firstNode.parent;
                                            oldNextNode = oldParent.childs[lastNode.getIndex() + 1] || oldParent.append;
                                            oldIndexRedo = firstNode.getIndex();
                                            newIndexRedo = prevNode.getIndex();
                                            oldParentPathRedo = oldParent.getInternalPath();
                                            newParentPathRedo = prevNode.parent.getInternalPath();
                                            selectedNodes.forEach(function(node) {
                                                prevNode.parent.moveBefore(node, prevNode);
                                            });
                                            this.focus(Node1.focusElement || this._getElementName(target));
                                            this.editor._onAction("moveNodes", {
                                                count: selectedNodes.length,
                                                fieldNames: selectedNodes.map(getField),
                                                oldParentPath: oldParent.getInternalPath(),
                                                newParentPath: firstNode.parent.getInternalPath(),
                                                oldIndex: oldNextNode.getIndex(),
                                                newIndex: firstNode.getIndex(),
                                                oldIndexRedo: oldIndexRedo,
                                                newIndexRedo: newIndexRedo,
                                                oldParentPathRedo: oldParentPathRedo,
                                                newParentPathRedo: newParentPathRedo,
                                                oldSelection: oldSelection,
                                                newSelection: this.editor.getDomSelection()
                                            });
                                        }
                                        handled = true;
                                    }
                                } else if (keynum === 39) {
                                    // Arrow Right
                                    if (altKey && !shiftKey) {
                                        // Alt + Arrow Right
                                        // move to right element
                                        var nextElement = this._nextElement(target);
                                        if (nextElement) this.focus(this._getElementName(nextElement));
                                        handled = true;
                                    } else if (altKey && shiftKey && editable) {
                                        // Alt + Shift + Arrow Right
                                        var _dom = firstNode.getDom();
                                        var prevDom = _dom.previousSibling;
                                        if (prevDom) {
                                            prevNode = Node1.getNodeFromTarget(prevDom);
                                            if (prevNode && prevNode.parent && !prevNode.isVisible()) {
                                                oldSelection = this.editor.getDomSelection();
                                                oldParent = firstNode.parent;
                                                oldNextNode = oldParent.childs[lastNode.getIndex() + 1] || oldParent.append;
                                                oldIndexRedo = firstNode.getIndex();
                                                newIndexRedo = prevNode.getIndex();
                                                oldParentPathRedo = oldParent.getInternalPath();
                                                newParentPathRedo = prevNode.parent.getInternalPath();
                                                selectedNodes.forEach(function(node) {
                                                    prevNode.parent.moveBefore(node, prevNode);
                                                });
                                                this.focus(Node1.focusElement || this._getElementName(target));
                                                this.editor._onAction("moveNodes", {
                                                    count: selectedNodes.length,
                                                    fieldNames: selectedNodes.map(getField),
                                                    oldParentPath: oldParent.getInternalPath(),
                                                    newParentPath: firstNode.parent.getInternalPath(),
                                                    oldIndex: oldNextNode.getIndex(),
                                                    newIndex: firstNode.getIndex(),
                                                    oldIndexRedo: oldIndexRedo,
                                                    newIndexRedo: newIndexRedo,
                                                    oldParentPathRedo: oldParentPathRedo,
                                                    newParentPathRedo: newParentPathRedo,
                                                    oldSelection: oldSelection,
                                                    newSelection: this.editor.getDomSelection()
                                                });
                                            }
                                        }
                                    }
                                } else if (keynum === 40) {
                                    // Arrow Down
                                    if (altKey && !shiftKey) {
                                        // Alt + Arrow Down
                                        // find the next node
                                        nextNode = this._nextNode();
                                        if (nextNode) {
                                            this.editor.deselect(true);
                                            nextNode.focus(Node1.focusElement || this._getElementName(target));
                                        }
                                        handled = true;
                                    } else if (!altKey && ctrlKey && shiftKey && editable) {
                                        // Ctrl + Shift + Arrow Down
                                        // select multiple nodes
                                        nextNode = this._nextNode();
                                        if (nextNode) {
                                            multiselection = this.editor.multiselection;
                                            multiselection.start = multiselection.start || this;
                                            multiselection.end = nextNode;
                                            nodes = this.editor._findTopLevelNodes(multiselection.start, multiselection.end);
                                            this.editor.select(nodes);
                                            nextNode.focus("field"); // select field as we know this always exists
                                        }
                                        handled = true;
                                    } else if (altKey && shiftKey && editable) {
                                        // Alt + Shift + Arrow Down
                                        // find the 2nd next node and move before that one
                                        if (lastNode.expanded) nextNode = lastNode.append ? lastNode.append._nextNode() : undefined;
                                        else nextNode = lastNode._nextNode();
                                        // when the next node is not visible, we've reached the "showMore" buttons
                                        if (nextNode && !nextNode.isVisible()) nextNode = nextNode.parent.showMore;
                                        if (nextNode && nextNode instanceof AppendNode) nextNode = lastNode;
                                        var _nextNode2 = nextNode && (nextNode._nextNode() || nextNode.parent.append);
                                        if (_nextNode2 && _nextNode2.parent) {
                                            oldSelection = this.editor.getDomSelection();
                                            oldParent = firstNode.parent;
                                            oldNextNode = oldParent.childs[lastNode.getIndex() + 1] || oldParent.append;
                                            oldIndexRedo = firstNode.getIndex();
                                            newIndexRedo = _nextNode2.getIndex();
                                            oldParentPathRedo = oldParent.getInternalPath();
                                            newParentPathRedo = _nextNode2.parent.getInternalPath();
                                            selectedNodes.forEach(function(node) {
                                                _nextNode2.parent.moveBefore(node, _nextNode2);
                                            });
                                            this.focus(Node1.focusElement || this._getElementName(target));
                                            this.editor._onAction("moveNodes", {
                                                count: selectedNodes.length,
                                                fieldNames: selectedNodes.map(getField),
                                                oldParentPath: oldParent.getInternalPath(),
                                                newParentPath: firstNode.parent.getInternalPath(),
                                                oldParentPathRedo: oldParentPathRedo,
                                                newParentPathRedo: newParentPathRedo,
                                                oldIndexRedo: oldIndexRedo,
                                                newIndexRedo: newIndexRedo,
                                                oldIndex: oldNextNode.getIndex(),
                                                newIndex: firstNode.getIndex(),
                                                oldSelection: oldSelection,
                                                newSelection: this.editor.getDomSelection()
                                            });
                                        }
                                        handled = true;
                                    }
                                }
                                if (handled) {
                                    event.preventDefault();
                                    event.stopPropagation();
                                }
                            }
                        },
                        {
                            key: "_onExpand",
                            value: function _onExpand(recurse) {
                                var table;
                                var frame;
                                var scrollTop;
                                if (recurse) {
                                    // Take the table offline
                                    table = this.dom.tr.parentNode; // TODO: not nice to access the main table like this
                                    frame = table.parentNode;
                                    scrollTop = frame.scrollTop;
                                    frame.removeChild(table);
                                }
                                if (this.expanded) this.collapse(recurse);
                                else this.expand(recurse);
                                if (recurse) {
                                    // Put the table online again
                                    frame.appendChild(table);
                                    frame.scrollTop = scrollTop;
                                }
                                if (typeof this.editor.options.onExpand === "function") this.editor.options.onExpand({
                                    path: this.getPath(),
                                    isExpand: this.expanded,
                                    recursive: recurse
                                });
                            }
                        },
                        {
                            key: "_showColorPicker",
                            value: function _showColorPicker() {
                                if (typeof this.editor.options.onColorPicker === "function" && this.dom.color) {
                                    var node = this;
                                    // force deleting current color picker (if any)
                                    node._deleteDomColor();
                                    node.updateDom();
                                    var colorAnchor = (0, createAbsoluteAnchor /* createAbsoluteAnchor */ .w)(this.dom.color, this.editor.getPopupAnchor());
                                    this.editor.options.onColorPicker(colorAnchor, this.value, function onChange(value) {
                                        if (typeof value === "string" && value !== node.value) {
                                            // force recreating the color block, to cleanup any attached color picker
                                            node._deleteDomColor();
                                            node.value = value;
                                            node.updateDom();
                                            node._debouncedOnChangeValue();
                                        }
                                    });
                                }
                            }
                        },
                        {
                            key: "getFieldNames",
                            value: function getFieldNames(excludeNode) {
                                if (this.type === "object") return this.childs.filter(function(child) {
                                    return child !== excludeNode;
                                }).map(function(child) {
                                    return child.field;
                                });
                                return [];
                            }
                        },
                        {
                            key: "_onInsertBefore",
                            value: function _onInsertBefore(field, value, type) {
                                var oldSelection = this.editor.getDomSelection();
                                var newNode = new Node1(this.editor, {
                                    field: field !== undefined ? field : "",
                                    value: value !== undefined ? value : "",
                                    type: type
                                });
                                newNode.expand(true);
                                var beforePath = this.getInternalPath();
                                this.parent.insertBefore(newNode, this);
                                this.editor.highlighter.unhighlight();
                                newNode.focus("field");
                                var newSelection = this.editor.getDomSelection();
                                this.editor._onAction("insertBeforeNodes", {
                                    nodes: [
                                        newNode
                                    ],
                                    paths: [
                                        newNode.getInternalPath()
                                    ],
                                    beforePath: beforePath,
                                    parentPath: this.parent.getInternalPath(),
                                    oldSelection: oldSelection,
                                    newSelection: newSelection
                                });
                            }
                        },
                        {
                            key: "_onInsertAfter",
                            value: function _onInsertAfter(field, value, type) {
                                var oldSelection = this.editor.getDomSelection();
                                var newNode = new Node1(this.editor, {
                                    field: field !== undefined ? field : "",
                                    value: value !== undefined ? value : "",
                                    type: type
                                });
                                newNode.expand(true);
                                this.parent.insertAfter(newNode, this);
                                this.editor.highlighter.unhighlight();
                                newNode.focus("field");
                                var newSelection = this.editor.getDomSelection();
                                this.editor._onAction("insertAfterNodes", {
                                    nodes: [
                                        newNode
                                    ],
                                    paths: [
                                        newNode.getInternalPath()
                                    ],
                                    afterPath: this.getInternalPath(),
                                    parentPath: this.parent.getInternalPath(),
                                    oldSelection: oldSelection,
                                    newSelection: newSelection
                                });
                            }
                        },
                        {
                            key: "_onAppend",
                            value: function _onAppend(field, value, type) {
                                var oldSelection = this.editor.getDomSelection();
                                var newNode = new Node1(this.editor, {
                                    field: field !== undefined ? field : "",
                                    value: value !== undefined ? value : "",
                                    type: type
                                });
                                newNode.expand(true);
                                this.parent.appendChild(newNode);
                                this.editor.highlighter.unhighlight();
                                newNode.focus("field");
                                var newSelection = this.editor.getDomSelection();
                                this.editor._onAction("appendNodes", {
                                    nodes: [
                                        newNode
                                    ],
                                    paths: [
                                        newNode.getInternalPath()
                                    ],
                                    parentPath: this.parent.getInternalPath(),
                                    oldSelection: oldSelection,
                                    newSelection: newSelection
                                });
                            }
                        },
                        {
                            key: "_onChangeType",
                            value: function _onChangeType(newType) {
                                var oldType = this.type;
                                if (newType !== oldType) {
                                    var oldSelection = this.editor.getDomSelection();
                                    this.changeType(newType);
                                    var newSelection = this.editor.getDomSelection();
                                    this.editor._onAction("changeType", {
                                        path: this.getInternalPath(),
                                        oldType: oldType,
                                        newType: newType,
                                        oldSelection: oldSelection,
                                        newSelection: newSelection
                                    });
                                }
                            }
                        },
                        {
                            key: "sort",
                            value: function sort(path, direction) {
                                var triggerAction = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
                                if (typeof path === "string") path = (0, util.parsePath)(path);
                                if (!this._hasChilds()) return;
                                this.hideChilds(); // sorting is faster when the childs are not attached to the dom
                                // copy the childs array (the old one will be kept for an undo action
                                var oldChilds = this.childs;
                                this.childs = this.childs.concat();
                                // sort the childs array
                                var order = direction === "desc" ? -1 : 1;
                                if (this.type === "object") this.childs.sort(function(a, b) {
                                    return order * naturalSort_default()(a.field, b.field);
                                });
                                else // this.type === 'array'
                                this.childs.sort(function(a, b) {
                                    var nodeA = a.getNestedChild(path);
                                    var nodeB = b.getNestedChild(path);
                                    if (!nodeA) return order;
                                    if (!nodeB) return -order;
                                    var valueA = nodeA.value;
                                    var valueB = nodeB.value;
                                    if (typeof valueA !== "string" && typeof valueB !== "string") // both values are a number, boolean, or null -> use simple, fast sorting
                                    return valueA > valueB ? order : valueA < valueB ? -order : 0;
                                    return order * naturalSort_default()(valueA, valueB);
                                });
                                // update the index numbering
                                this._updateDomIndexes();
                                this.showChilds();
                                if (triggerAction === true) this.editor._onAction("sort", {
                                    path: this.getInternalPath(),
                                    oldChilds: oldChilds,
                                    newChilds: this.childs
                                });
                            }
                        },
                        {
                            key: "update",
                            value: function update(newValue) {
                                var oldValue = this.getInternalValue();
                                this.setValue(newValue);
                                this.editor._onAction("transform", {
                                    path: this.getInternalPath(),
                                    oldValue: oldValue,
                                    newValue: this.getInternalValue()
                                });
                            }
                        },
                        {
                            key: "_detachFromDom",
                            value: function _detachFromDom() {
                                var table = this.dom.tr ? this.dom.tr.parentNode : undefined;
                                var lastTr;
                                if (this.expanded) lastTr = this.getAppendDom();
                                else lastTr = this.getDom();
                                var nextTr = lastTr && lastTr.parentNode ? lastTr.nextSibling : undefined;
                                this.hide({
                                    resetVisibleChilds: false
                                });
                                return {
                                    table: table,
                                    nextTr: nextTr
                                };
                            }
                        },
                        {
                            key: "_attachToDom",
                            value: function _attachToDom(domAnchor) {
                                if (domAnchor.table) {
                                    if (domAnchor.nextTr) domAnchor.table.insertBefore(this.getDom(), domAnchor.nextTr);
                                    else domAnchor.table.appendChild(this.getDom());
                                }
                                if (this.expanded) this.showChilds();
                            }
                        },
                        {
                            key: "transform",
                            value: function transform(query) {
                                if (!this._hasChilds()) return;
                                this.hideChilds(); // sorting is faster when the childs are not attached to the dom
                                try {
                                    var oldInternalValue = this.getInternalValue();
                                    // apply the JMESPath query
                                    var oldValue = this.getValue();
                                    var newValue = this.editor.options.executeQuery(oldValue, query);
                                    this.setValue(newValue);
                                    var newInternalValue = this.getInternalValue();
                                    this.editor._onAction("transform", {
                                        path: this.getInternalPath(),
                                        oldValue: oldInternalValue,
                                        newValue: newInternalValue
                                    });
                                    this.showChilds();
                                } catch (err) {
                                    this.showChilds();
                                    this.editor._onError(err);
                                }
                            }
                        },
                        {
                            key: "extract",
                            value: function extract() {
                                this.editor.node.hideChilds();
                                this.hideChilds();
                                try {
                                    var oldInternalValue = this.editor.node.getInternalValue();
                                    this.editor._setRoot(this);
                                    var newInternalValue = this.editor.node.getInternalValue();
                                    this.editor._onAction("transform", {
                                        path: this.editor.node.getInternalPath(),
                                        oldValue: oldInternalValue,
                                        newValue: newInternalValue
                                    });
                                } catch (err) {
                                    this.editor._onError(err);
                                } finally{
                                    this.updateDom({
                                        recurse: true
                                    });
                                    this.showChilds();
                                }
                            }
                        },
                        {
                            key: "getNestedChild",
                            value: function getNestedChild(path) {
                                var i = 0;
                                var child = this;
                                while(child && i < path.length){
                                    child = child.findChildByProperty(path[i]);
                                    i++;
                                }
                                return child;
                            }
                        },
                        {
                            key: "findChildByProperty",
                            value: function findChildByProperty(prop) {
                                if (this.type !== "object") return undefined;
                                return this.childs.find(function(child) {
                                    return child.field === prop;
                                });
                            }
                        },
                        {
                            key: "getAppendDom",
                            value: function getAppendDom() {
                                if (!this.append) {
                                    this.append = new AppendNode(this.editor);
                                    this.append.setParent(this);
                                }
                                return this.append.getDom();
                            }
                        },
                        {
                            key: "getShowMoreDom",
                            value: function getShowMoreDom() {
                                if (!this.showMore) this.showMore = new ShowMoreNode(this.editor, this);
                                return this.showMore.getDom();
                            }
                        },
                        {
                            key: "nextSibling",
                            value: function nextSibling() {
                                var index = this.parent.childs.indexOf(this);
                                return this.parent.childs[index + 1] || this.parent.append;
                            }
                        },
                        {
                            key: "_previousNode",
                            value: function _previousNode() {
                                var prevNode = null;
                                var dom = this.getDom();
                                if (dom && dom.parentNode) {
                                    // find the previous field
                                    var prevDom = dom;
                                    do {
                                        prevDom = prevDom.previousSibling;
                                        prevNode = Node1.getNodeFromTarget(prevDom);
                                    }while (prevDom && prevNode && prevNode instanceof AppendNode && !prevNode.isVisible());
                                }
                                return prevNode;
                            }
                        },
                        {
                            key: "_nextNode",
                            value: function _nextNode() {
                                var nextNode = null;
                                var dom = this.getDom();
                                if (dom && dom.parentNode) {
                                    // find the previous field
                                    var nextDom = dom;
                                    do {
                                        nextDom = nextDom.nextSibling;
                                        nextNode = Node1.getNodeFromTarget(nextDom);
                                    }while (nextDom && nextNode && nextNode instanceof AppendNode && !nextNode.isVisible());
                                }
                                return nextNode;
                            }
                        },
                        {
                            key: "_firstNode",
                            value: function _firstNode() {
                                var firstNode = null;
                                var dom = this.getDom();
                                if (dom && dom.parentNode) {
                                    var firstDom = dom.parentNode.firstChild;
                                    firstNode = Node1.getNodeFromTarget(firstDom);
                                }
                                return firstNode;
                            }
                        },
                        {
                            key: "_lastNode",
                            value: function _lastNode() {
                                var lastNode = null;
                                var dom = this.getDom();
                                if (dom && dom.parentNode) {
                                    var lastDom = dom.parentNode.lastChild;
                                    lastNode = Node1.getNodeFromTarget(lastDom);
                                    while(lastDom && lastNode && !lastNode.isVisible()){
                                        lastDom = lastDom.previousSibling;
                                        lastNode = Node1.getNodeFromTarget(lastDom);
                                    }
                                }
                                return lastNode;
                            }
                        },
                        {
                            key: "_previousElement",
                            value: function _previousElement(elem) {
                                var dom = this.dom;
                                // noinspection FallthroughInSwitchStatementJS
                                switch(elem){
                                    case dom.value:
                                        if (this.fieldEditable) return dom.field;
                                    // intentional fall through
                                    case dom.field:
                                        if (this._hasChilds()) return dom.expand;
                                    // intentional fall through
                                    case dom.expand:
                                        return dom.menu;
                                    case dom.menu:
                                        if (dom.drag) return dom.drag;
                                    // intentional fall through
                                    default:
                                        return null;
                                }
                            }
                        },
                        {
                            key: "_nextElement",
                            value: function _nextElement(elem) {
                                var dom = this.dom;
                                // noinspection FallthroughInSwitchStatementJS
                                switch(elem){
                                    case dom.drag:
                                        return dom.menu;
                                    case dom.menu:
                                        if (this._hasChilds()) return dom.expand;
                                    // intentional fall through
                                    case dom.expand:
                                        if (this.fieldEditable) return dom.field;
                                    // intentional fall through
                                    case dom.field:
                                        if (!this._hasChilds()) return dom.value;
                                    // intentional fall through
                                    default:
                                        return null;
                                }
                            }
                        },
                        {
                            key: "_getElementName",
                            value: function _getElementName(element) {
                                var _this2 = this;
                                return Object.keys(this.dom).find(function(name) {
                                    return _this2.dom[name] === element;
                                });
                            }
                        },
                        {
                            key: "_hasChilds",
                            value: function _hasChilds() {
                                return this.type === "array" || this.type === "object";
                            }
                        },
                        {
                            key: "addTemplates",
                            value: function addTemplates(menu, append) {
                                var node = this;
                                var templates = node.editor.options.templates;
                                if (templates == null) return;
                                if (templates.length) // create a separator
                                menu.push({
                                    type: "separator"
                                });
                                var appendData = function appendData(name, data) {
                                    node._onAppend(name, data);
                                };
                                var insertData = function insertData(name, data) {
                                    node._onInsertBefore(name, data);
                                };
                                templates.forEach(function(template) {
                                    menu.push({
                                        text: template.text,
                                        className: template.className || "jsoneditor-type-object",
                                        title: template.title,
                                        click: append ? appendData.bind(this, template.field, template.value) : insertData.bind(this, template.field, template.value)
                                    });
                                });
                            }
                        },
                        {
                            key: "showContextMenu",
                            value: function showContextMenu(anchor, onClose) {
                                var node = this;
                                var items = [];
                                if (this.editable.value) items.push({
                                    text: (0, i18n /* translate */ .Iu)("type"),
                                    title: (0, i18n /* translate */ .Iu)("typeTitle"),
                                    className: "jsoneditor-type-" + this.type,
                                    submenu: [
                                        {
                                            text: (0, i18n /* translate */ .Iu)("auto"),
                                            className: "jsoneditor-type-auto" + (this.type === "auto" ? " jsoneditor-selected" : ""),
                                            title: (0, i18n /* translate */ .Iu)("autoType"),
                                            click: function click() {
                                                node._onChangeType("auto");
                                            }
                                        },
                                        {
                                            text: (0, i18n /* translate */ .Iu)("array"),
                                            className: "jsoneditor-type-array" + (this.type === "array" ? " jsoneditor-selected" : ""),
                                            title: (0, i18n /* translate */ .Iu)("arrayType"),
                                            click: function click() {
                                                node._onChangeType("array");
                                            }
                                        },
                                        {
                                            text: (0, i18n /* translate */ .Iu)("object"),
                                            className: "jsoneditor-type-object" + (this.type === "object" ? " jsoneditor-selected" : ""),
                                            title: (0, i18n /* translate */ .Iu)("objectType"),
                                            click: function click() {
                                                node._onChangeType("object");
                                            }
                                        },
                                        {
                                            text: (0, i18n /* translate */ .Iu)("string"),
                                            className: "jsoneditor-type-string" + (this.type === "string" ? " jsoneditor-selected" : ""),
                                            title: (0, i18n /* translate */ .Iu)("stringType"),
                                            click: function click() {
                                                node._onChangeType("string");
                                            }
                                        }
                                    ]
                                });
                                if (this._hasChilds()) {
                                    if (this.editor.options.enableSort) items.push({
                                        text: (0, i18n /* translate */ .Iu)("sort"),
                                        title: (0, i18n /* translate */ .Iu)("sortTitle", {
                                            type: this.type
                                        }),
                                        className: "jsoneditor-sort-asc",
                                        click: function click() {
                                            node.showSortModal();
                                        }
                                    });
                                    if (this.editor.options.enableTransform) items.push({
                                        text: (0, i18n /* translate */ .Iu)("transform"),
                                        title: (0, i18n /* translate */ .Iu)("transformTitle", {
                                            type: this.type
                                        }),
                                        className: "jsoneditor-transform",
                                        click: function click() {
                                            node.showTransformModal();
                                        }
                                    });
                                    if (this.parent) items.push({
                                        text: (0, i18n /* translate */ .Iu)("extract"),
                                        title: (0, i18n /* translate */ .Iu)("extractTitle", {
                                            type: this.type
                                        }),
                                        className: "jsoneditor-extract",
                                        click: function click() {
                                            node.extract();
                                        }
                                    });
                                }
                                if (this.parent && this.parent._hasChilds()) {
                                    if (items.length) // create a separator
                                    items.push({
                                        type: "separator"
                                    });
                                    // create append button (for last child node only)
                                    var childs = node.parent.childs;
                                    if (node === childs[childs.length - 1]) {
                                        var appendSubmenu = [
                                            {
                                                text: (0, i18n /* translate */ .Iu)("auto"),
                                                className: "jsoneditor-type-auto",
                                                title: (0, i18n /* translate */ .Iu)("autoType"),
                                                click: function click() {
                                                    node._onAppend("", "", "auto");
                                                }
                                            },
                                            {
                                                text: (0, i18n /* translate */ .Iu)("array"),
                                                className: "jsoneditor-type-array",
                                                title: (0, i18n /* translate */ .Iu)("arrayType"),
                                                click: function click() {
                                                    node._onAppend("", []);
                                                }
                                            },
                                            {
                                                text: (0, i18n /* translate */ .Iu)("object"),
                                                className: "jsoneditor-type-object",
                                                title: (0, i18n /* translate */ .Iu)("objectType"),
                                                click: function click() {
                                                    node._onAppend("", {});
                                                }
                                            },
                                            {
                                                text: (0, i18n /* translate */ .Iu)("string"),
                                                className: "jsoneditor-type-string",
                                                title: (0, i18n /* translate */ .Iu)("stringType"),
                                                click: function click() {
                                                    node._onAppend("", "", "string");
                                                }
                                            }
                                        ];
                                        node.addTemplates(appendSubmenu, true);
                                        items.push({
                                            text: (0, i18n /* translate */ .Iu)("appendText"),
                                            title: (0, i18n /* translate */ .Iu)("appendTitle"),
                                            submenuTitle: (0, i18n /* translate */ .Iu)("appendSubmenuTitle"),
                                            className: "jsoneditor-append",
                                            click: function click() {
                                                node._onAppend("", "", "auto");
                                            },
                                            submenu: appendSubmenu
                                        });
                                    }
                                    // create insert button
                                    var insertSubmenu = [
                                        {
                                            text: (0, i18n /* translate */ .Iu)("auto"),
                                            className: "jsoneditor-type-auto",
                                            title: (0, i18n /* translate */ .Iu)("autoType"),
                                            click: function click() {
                                                node._onInsertBefore("", "", "auto");
                                            }
                                        },
                                        {
                                            text: (0, i18n /* translate */ .Iu)("array"),
                                            className: "jsoneditor-type-array",
                                            title: (0, i18n /* translate */ .Iu)("arrayType"),
                                            click: function click() {
                                                node._onInsertBefore("", []);
                                            }
                                        },
                                        {
                                            text: (0, i18n /* translate */ .Iu)("object"),
                                            className: "jsoneditor-type-object",
                                            title: (0, i18n /* translate */ .Iu)("objectType"),
                                            click: function click() {
                                                node._onInsertBefore("", {});
                                            }
                                        },
                                        {
                                            text: (0, i18n /* translate */ .Iu)("string"),
                                            className: "jsoneditor-type-string",
                                            title: (0, i18n /* translate */ .Iu)("stringType"),
                                            click: function click() {
                                                node._onInsertBefore("", "", "string");
                                            }
                                        }
                                    ];
                                    node.addTemplates(insertSubmenu, false);
                                    items.push({
                                        text: (0, i18n /* translate */ .Iu)("insert"),
                                        title: (0, i18n /* translate */ .Iu)("insertTitle"),
                                        submenuTitle: (0, i18n /* translate */ .Iu)("insertSub"),
                                        className: "jsoneditor-insert",
                                        click: function click() {
                                            node._onInsertBefore("", "", "auto");
                                        },
                                        submenu: insertSubmenu
                                    });
                                    if (this.editable.field) {
                                        // create duplicate button
                                        items.push({
                                            text: (0, i18n /* translate */ .Iu)("duplicateText"),
                                            title: (0, i18n /* translate */ .Iu)("duplicateField"),
                                            className: "jsoneditor-duplicate",
                                            click: function click() {
                                                Node1.onDuplicate(node);
                                            }
                                        });
                                        // create remove button
                                        items.push({
                                            text: (0, i18n /* translate */ .Iu)("removeText"),
                                            title: (0, i18n /* translate */ .Iu)("removeField"),
                                            className: "jsoneditor-remove",
                                            click: function click() {
                                                Node1.onRemove(node);
                                            }
                                        });
                                    }
                                }
                                if (this.editor.options.onCreateMenu) {
                                    var path = node.getPath();
                                    items = this.editor.options.onCreateMenu(items, {
                                        type: "single",
                                        path: path,
                                        paths: [
                                            path
                                        ]
                                    });
                                }
                                var menu = new ContextMenu /* ContextMenu */ .x(items, {
                                    close: onClose
                                });
                                menu.show(anchor, this.editor.getPopupAnchor());
                            }
                        },
                        {
                            key: "showSortModal",
                            value: function showSortModal() {
                                var node = this;
                                var container = this.editor.options.modalAnchor || constants /* DEFAULT_MODAL_ANCHOR */ .qD;
                                var json = this.getValue();
                                function onSort(sortedBy) {
                                    var path = sortedBy.path;
                                    var pathArray = (0, util.parsePath)(path);
                                    node.sortedBy = sortedBy;
                                    node.sort(pathArray, sortedBy.direction);
                                }
                                (0, js_showSortModal.showSortModal)(container, json, onSort, node.sortedBy);
                            }
                        },
                        {
                            key: "showTransformModal",
                            value: function showTransformModal() {
                                var _this3 = this;
                                var _this$editor$options = this.editor.options, modalAnchor = _this$editor$options.modalAnchor, createQuery = _this$editor$options.createQuery, executeQuery = _this$editor$options.executeQuery, queryDescription = _this$editor$options.queryDescription;
                                var json = this.getValue();
                                (0, js_showTransformModal.showTransformModal)({
                                    container: modalAnchor || constants /* DEFAULT_MODAL_ANCHOR */ .qD,
                                    json: json,
                                    queryDescription: queryDescription,
                                    // can be undefined
                                    createQuery: createQuery,
                                    executeQuery: executeQuery,
                                    onTransform: function onTransform(query) {
                                        _this3.transform(query);
                                    }
                                });
                            }
                        },
                        {
                            key: "_getType",
                            value: function _getType(value) {
                                if (value instanceof Array) return "array";
                                if (value instanceof Object) return "object";
                                if (typeof value === "string" && typeof (0, util.parseString)(value) !== "string") return "string";
                                return "auto";
                            }
                        },
                        {
                            key: "_escapeHTML",
                            value: function _escapeHTML(text) {
                                if (typeof text !== "string") return String(text);
                                else {
                                    var htmlEscaped = String(text).replace(/&/g, "&amp;") // must be replaced first!
                                    .replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/ {2}/g, " &nbsp;") // replace double space with an nbsp and space
                                    .replace(/^ /, "&nbsp;") // space at start
                                    .replace(/ $/, "&nbsp;"); // space at end
                                    var json = JSON.stringify(htmlEscaped);
                                    var html = json.substring(1, json.length - 1);
                                    if (this.editor.options.escapeUnicode === true) html = (0, util.escapeUnicodeChars)(html);
                                    return html;
                                }
                            }
                        },
                        {
                            key: "_unescapeHTML",
                            value: function _unescapeHTML(escapedText) {
                                var json = '"' + this._escapeJSON(escapedText) + '"';
                                var htmlEscaped = (0, util.parse)(json);
                                return htmlEscaped.replace(/&lt;/g, "<").replace(/&gt;/g, ">").replace(/&nbsp;|\u00A0/g, " ").replace(/&amp;/g, "&"); // must be replaced last
                            }
                        },
                        {
                            key: "_escapeJSON",
                            value: function _escapeJSON(text) {
                                // TODO: replace with some smart regex (only when a new solution is faster!)
                                var escaped = "";
                                var i = 0;
                                while(i < text.length){
                                    var c = text.charAt(i);
                                    if (c === "\n") escaped += "\\n";
                                    else if (c === "\\") {
                                        escaped += c;
                                        i++;
                                        c = text.charAt(i);
                                        if (c === "" || '"\\/bfnrtu'.indexOf(c) === -1) escaped += "\\"; // no valid escape character
                                        escaped += c;
                                    } else if (c === '"') escaped += '\\"';
                                    else escaped += c;
                                    i++;
                                }
                                return escaped;
                            }
                        },
                        {
                            key: "updateNodeName",
                            value: function updateNodeName() {
                                var count = this.childs ? this.childs.length : 0;
                                var nodeName;
                                if (this.type === "object" || this.type === "array") {
                                    if (this.editor.options.onNodeName) try {
                                        var getValue = this.getValue.bind(this);
                                        nodeName = this.editor.options.onNodeName({
                                            path: this.getPath(),
                                            size: count,
                                            type: this.type,
                                            get value () {
                                                return getValue();
                                            }
                                        });
                                    } catch (err) {
                                        console.error("Error in onNodeName callback: ", err);
                                    }
                                    this.dom.value.textContent = this.type === "object" ? "{" + (nodeName || count) + "}" : "[" + (nodeName || count) + "]";
                                }
                            }
                        },
                        {
                            key: "recursivelyUpdateNodeName",
                            value: function recursivelyUpdateNodeName() {
                                if (this.expanded) {
                                    this.updateNodeName();
                                    if (this.childs !== "undefined") {
                                        var i;
                                        for(i in this.childs)this.childs[i].recursivelyUpdateNodeName();
                                    }
                                }
                            }
                        }
                    ]);
                    return Node1;
                }();
                // debounce interval for keyboard input in milliseconds
                Node1.prototype.DEBOUNCE_INTERVAL = 150;
                // search will stop iterating as soon as the max is reached
                Node1.prototype.MAX_SEARCH_RESULTS = 999;
                // default number of child nodes to display
                var DEFAULT_MAX_VISIBLE_CHILDS = 100;
                // stores the element name currently having the focus
                Node1.focusElement = undefined;
                /**
 * Select all text in an editable div after a delay of 0 ms
 * @param {Element} editableDiv
 */ Node1.select = function(editableDiv) {
                    setTimeout(function() {
                        (0, util.selectContentEditable)(editableDiv);
                    }, 0);
                };
                /**
 * DragStart event, fired on mousedown on the dragarea at the left side of a Node
 * @param {Node[] | Node} nodes
 * @param {Event} event
 */ Node1.onDragStart = function(nodes, event) {
                    if (!Array.isArray(nodes)) return Node1.onDragStart([
                        nodes
                    ], event);
                    if (nodes.length === 0) return;
                    var firstNode = nodes[0];
                    var lastNode = nodes[nodes.length - 1];
                    var parent = firstNode.parent;
                    var draggedNode = Node1.getNodeFromTarget(event.target);
                    var editor = firstNode.editor;
                    // in case of multiple selected nodes, offsetY prevents the selection from
                    // jumping when you start dragging one of the lower down nodes in the selection
                    var offsetY = (0, util.getAbsoluteTop)(draggedNode.dom.tr) - (0, util.getAbsoluteTop)(firstNode.dom.tr);
                    if (!editor.mousemove) editor.mousemove = (0, util.addEventListener)(event.view, "mousemove", function(event) {
                        Node1.onDrag(nodes, event);
                    });
                    if (!editor.mouseup) editor.mouseup = (0, util.addEventListener)(event.view, "mouseup", function(event) {
                        Node1.onDragEnd(nodes, event);
                    });
                    editor.highlighter.lock();
                    editor.drag = {
                        oldCursor: document.body.style.cursor,
                        oldSelection: editor.getDomSelection(),
                        oldPaths: nodes.map(getInternalPath),
                        oldParent: parent,
                        oldNextNode: parent.childs[lastNode.getIndex() + 1] || parent.append,
                        oldParentPathRedo: parent.getInternalPath(),
                        oldIndexRedo: firstNode.getIndex(),
                        mouseX: event.pageX,
                        offsetY: offsetY,
                        level: firstNode.getLevel()
                    };
                    document.body.style.cursor = "move";
                    event.preventDefault();
                };
                /**
 * Drag event, fired when moving the mouse while dragging a Node
 * @param {Node[] | Node} nodes
 * @param {Event} event
 */ Node1.onDrag = function(nodes, event) {
                    if (!Array.isArray(nodes)) return Node1.onDrag([
                        nodes
                    ], event);
                    if (nodes.length === 0) return;
                    // TODO: this method has grown too large. Split it in a number of methods
                    var editor = nodes[0].editor;
                    var mouseY = event.pageY - editor.drag.offsetY;
                    var mouseX = event.pageX;
                    var trPrev, trNext, trFirst, trLast, trRoot;
                    var nodePrev, nodeNext;
                    var topPrev, topFirst, bottomNext, heightNext;
                    var moved = false;
                    // TODO: add an ESC option, which resets to the original position
                    // move up/down
                    var firstNode = nodes[0];
                    var trThis = firstNode.dom.tr;
                    var topThis = (0, util.getAbsoluteTop)(trThis);
                    var heightThis = trThis.offsetHeight;
                    if (mouseY < topThis) {
                        // move up
                        trPrev = trThis;
                        do {
                            trPrev = trPrev.previousSibling;
                            nodePrev = Node1.getNodeFromTarget(trPrev);
                            topPrev = trPrev ? (0, util.getAbsoluteTop)(trPrev) : 0;
                        }while (trPrev && mouseY < topPrev);
                        if (nodePrev && !nodePrev.parent) nodePrev = undefined;
                        if (!nodePrev) {
                            // move to the first node
                            trRoot = trThis.parentNode.firstChild;
                            trPrev = trRoot ? trRoot.nextSibling : undefined;
                            nodePrev = Node1.getNodeFromTarget(trPrev);
                            if (nodePrev === firstNode) nodePrev = undefined;
                        }
                        if (nodePrev && nodePrev.isVisible()) {
                            // check if mouseY is really inside the found node
                            trPrev = nodePrev.dom.tr;
                            topPrev = trPrev ? (0, util.getAbsoluteTop)(trPrev) : 0;
                            if (mouseY > topPrev + heightThis) nodePrev = undefined;
                        }
                        if (nodePrev && (editor.options.limitDragging === false || nodePrev.parent === nodes[0].parent)) {
                            nodes.forEach(function(node) {
                                nodePrev.parent.moveBefore(node, nodePrev);
                            });
                            moved = true;
                        }
                    } else {
                        // move down
                        var lastNode = nodes[nodes.length - 1];
                        trLast = lastNode.expanded && lastNode.append ? lastNode.append.getDom() : lastNode.dom.tr;
                        trFirst = trLast ? trLast.nextSibling : undefined;
                        if (trFirst) {
                            topFirst = (0, util.getAbsoluteTop)(trFirst);
                            trNext = trFirst;
                            do {
                                nodeNext = Node1.getNodeFromTarget(trNext);
                                if (trNext) {
                                    bottomNext = trNext.nextSibling ? (0, util.getAbsoluteTop)(trNext.nextSibling) : 0;
                                    heightNext = trNext ? bottomNext - topFirst : 0;
                                    if (nodeNext && nodeNext.parent.childs.length === nodes.length && nodeNext.parent.childs[nodes.length - 1] === lastNode) // We are about to remove the last child of this parent,
                                    // which will make the parents appendNode visible.
                                    topThis += 27;
                                    trNext = trNext.nextSibling;
                                }
                            }while (trNext && mouseY > topThis + heightNext);
                            if (nodeNext && nodeNext.parent) {
                                // calculate the desired level
                                var diffX = mouseX - editor.drag.mouseX;
                                var diffLevel = Math.round(diffX / 24 / 2);
                                var level = editor.drag.level + diffLevel; // desired level
                                var levelNext = nodeNext.getLevel(); // level to be
                                // find the best fitting level (move upwards over the append nodes)
                                trPrev = nodeNext.dom.tr && nodeNext.dom.tr.previousSibling;
                                while(levelNext < level && trPrev){
                                    nodePrev = Node1.getNodeFromTarget(trPrev);
                                    var isDraggedNode = nodes.some(function(node) {
                                        return node === nodePrev || nodePrev.isDescendantOf(node);
                                    });
                                    if (isDraggedNode) ;
                                    else if (nodePrev instanceof AppendNode) {
                                        var childs = nodePrev.parent.childs;
                                        if (childs.length !== nodes.length || childs[nodes.length - 1] !== lastNode) {
                                            // non-visible append node of a list of childs
                                            // consisting of not only this node (else the
                                            // append node will change into a visible "empty"
                                            // text when removing this node).
                                            nodeNext = Node1.getNodeFromTarget(trPrev);
                                            levelNext = nodeNext.getLevel();
                                        } else break;
                                    } else break;
                                    trPrev = trPrev.previousSibling;
                                }
                                if (nodeNext instanceof AppendNode && !nodeNext.isVisible() && nodeNext.parent.showMore.isVisible()) nodeNext = nodeNext._nextNode();
                                // move the node when its position is changed
                                if (nodeNext && (editor.options.limitDragging === false || nodeNext.parent === nodes[0].parent) && nodeNext.dom.tr && nodeNext.dom.tr !== trLast.nextSibling) {
                                    nodes.forEach(function(node) {
                                        nodeNext.parent.moveBefore(node, nodeNext);
                                    });
                                    moved = true;
                                }
                            }
                        }
                    }
                    if (moved) {
                        // update the dragging parameters when moved
                        editor.drag.mouseX = mouseX;
                        editor.drag.level = firstNode.getLevel();
                    }
                    // auto scroll when hovering around the top of the editor
                    editor.startAutoScroll(mouseY);
                    event.preventDefault();
                };
                /**
 * Drag event, fired on mouseup after having dragged a node
 * @param {Node[] | Node} nodes
 * @param {Event} event
 */ Node1.onDragEnd = function(nodes, event) {
                    if (!Array.isArray(nodes)) return Node1.onDrag([
                        nodes
                    ], event);
                    if (nodes.length === 0) return;
                    var firstNode = nodes[0];
                    var editor = firstNode.editor;
                    // set focus to the context menu button of the first node
                    if (firstNode && firstNode.dom.menu) firstNode.dom.menu.focus();
                    var oldParentPath = editor.drag.oldParent.getInternalPath();
                    var newParentPath = firstNode.parent.getInternalPath();
                    var sameParent = editor.drag.oldParent === firstNode.parent;
                    var oldIndex = editor.drag.oldNextNode.getIndex();
                    var newIndex = firstNode.getIndex();
                    var oldParentPathRedo = editor.drag.oldParentPathRedo;
                    var oldIndexRedo = editor.drag.oldIndexRedo;
                    var newIndexRedo = sameParent && oldIndexRedo < newIndex ? newIndex + nodes.length : newIndex;
                    if (!sameParent || oldIndexRedo !== newIndex) // only register this action if the node is actually moved to another place
                    editor._onAction("moveNodes", {
                        count: nodes.length,
                        fieldNames: nodes.map(getField),
                        oldParentPath: oldParentPath,
                        newParentPath: newParentPath,
                        oldIndex: oldIndex,
                        newIndex: newIndex,
                        oldIndexRedo: oldIndexRedo,
                        newIndexRedo: newIndexRedo,
                        oldParentPathRedo: oldParentPathRedo,
                        newParentPathRedo: null,
                        // This is a hack, value will be filled in during undo
                        oldSelection: editor.drag.oldSelection,
                        newSelection: editor.getDomSelection()
                    });
                    document.body.style.cursor = editor.drag.oldCursor;
                    editor.highlighter.unlock();
                    nodes.forEach(function(node) {
                        node.updateDom();
                        if (event.target !== node.dom.drag && event.target !== node.dom.menu) editor.highlighter.unhighlight();
                    });
                    delete editor.drag;
                    if (editor.mousemove) {
                        (0, util.removeEventListener)(event.view, "mousemove", editor.mousemove);
                        delete editor.mousemove;
                    }
                    if (editor.mouseup) {
                        (0, util.removeEventListener)(event.view, "mouseup", editor.mouseup);
                        delete editor.mouseup;
                    }
                    // Stop any running auto scroll
                    editor.stopAutoScroll();
                    event.preventDefault();
                };
                /**
 * find an enum definition in a JSON schema, as property `enum` or inside
 * one of the schemas composites (`oneOf`, `anyOf`, `allOf`)
 * @param  {Object} schema
 * @return {Array | null} Returns the enum when found, null otherwise.
 * @private
 */ Node1._findEnum = function(schema) {
                    if (schema["enum"]) return schema["enum"];
                    var composite = schema.oneOf || schema.anyOf || schema.allOf;
                    if (composite) {
                        var match = composite.filter(function(entry) {
                            return entry["enum"];
                        });
                        if (match.length > 0) return match[0]["enum"];
                    }
                    return null;
                };
                /**
 * Return the part of a JSON schema matching given path.
 * @param {Object} topLevelSchema
 * @param {Object} schemaRefs
 * @param {Array.<string | number>} path
 * @param {Object} currentSchema
 * @return {Object | null}
 * @private
 */ Node1._findSchema = function(topLevelSchema, schemaRefs, path) {
                    var currentSchema = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : topLevelSchema;
                    var nextPath = path.slice(1, path.length);
                    var nextKey = path[0];
                    var possibleSchemas = [
                        currentSchema
                    ];
                    for(var _i = 0, _arr = [
                        currentSchema.oneOf,
                        currentSchema.anyOf,
                        currentSchema.allOf
                    ]; _i < _arr.length; _i++){
                        var subSchemas = _arr[_i];
                        if (Array.isArray(subSchemas)) possibleSchemas = possibleSchemas.concat(subSchemas);
                    }
                    var _iterator = _createForOfIteratorHelper(possibleSchemas), _step;
                    try {
                        for(_iterator.s(); !(_step = _iterator.n()).done;){
                            var schema = _step.value;
                            currentSchema = schema;
                            if ("$ref" in currentSchema && typeof currentSchema.$ref === "string") {
                                var _ref$match;
                                var ref = currentSchema.$ref;
                                if (ref in schemaRefs) currentSchema = schemaRefs[ref];
                                else if (ref.startsWith("#/")) {
                                    var refPath = ref.substring(2).split("/");
                                    currentSchema = topLevelSchema;
                                    var _iterator2 = _createForOfIteratorHelper(refPath), _step2;
                                    try {
                                        for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                                            var segment = _step2.value;
                                            if (segment in currentSchema) currentSchema = currentSchema[segment];
                                            else throw Error("Unable to resolve reference ".concat(ref));
                                        }
                                    } catch (err) {
                                        _iterator2.e(err);
                                    } finally{
                                        _iterator2.f();
                                    }
                                } else if (((_ref$match = ref.match(/#\//g)) === null || _ref$match === void 0 ? void 0 : _ref$match.length) === 1) {
                                    var _ref$split = ref.split("#/"), _ref$split2 = _slicedToArray(_ref$split, 2), schemaUrl = _ref$split2[0], relativePath = _ref$split2[1];
                                    if (schemaUrl in schemaRefs) {
                                        var referencedSchema = schemaRefs[schemaUrl];
                                        var reference = {
                                            $ref: "#/".concat(relativePath)
                                        };
                                        var auxNextPath = [];
                                        auxNextPath.push(nextKey);
                                        if (nextPath.length > 0) auxNextPath.push.apply(auxNextPath, _toConsumableArray(nextPath));
                                        return Node1._findSchema(referencedSchema, schemaRefs, auxNextPath, reference);
                                    } else throw Error("Unable to resolve reference ".concat(ref));
                                } else throw Error("Unable to resolve reference ".concat(ref));
                            }
                            // We have no more path segments to resolve, return the currently found schema
                            // We do this here, after resolving references, in case of the leaf schema beeing a reference
                            if (nextKey === undefined) return currentSchema;
                            if (typeof nextKey === "string") {
                                if (Node_typeof(currentSchema.properties) === "object" && currentSchema.properties !== null && nextKey in currentSchema.properties) {
                                    currentSchema = currentSchema.properties[nextKey];
                                    return Node1._findSchema(topLevelSchema, schemaRefs, nextPath, currentSchema);
                                }
                                if (Node_typeof(currentSchema.patternProperties) === "object" && currentSchema.patternProperties !== null) {
                                    for(var prop in currentSchema.patternProperties)if (nextKey.match(prop)) {
                                        currentSchema = currentSchema.patternProperties[prop];
                                        return Node1._findSchema(topLevelSchema, schemaRefs, nextPath, currentSchema);
                                    }
                                }
                                if (Node_typeof(currentSchema.additionalProperties) === "object") {
                                    currentSchema = currentSchema.additionalProperties;
                                    return Node1._findSchema(topLevelSchema, schemaRefs, nextPath, currentSchema);
                                }
                                continue;
                            }
                            if (typeof nextKey === "number" && Node_typeof(currentSchema.items) === "object" && currentSchema.items !== null) {
                                currentSchema = currentSchema.items;
                                return Node1._findSchema(topLevelSchema, schemaRefs, nextPath, currentSchema);
                            }
                        }
                    } catch (err) {
                        _iterator.e(err);
                    } finally{
                        _iterator.f();
                    }
                    return null;
                };
                /**
 * Remove nodes
 * @param {Node[] | Node} nodes
 */ Node1.onRemove = function(nodes) {
                    if (!Array.isArray(nodes)) return Node1.onRemove([
                        nodes
                    ]);
                    if (nodes && nodes.length > 0) {
                        var firstNode = nodes[0];
                        var parent = firstNode.parent;
                        var editor = firstNode.editor;
                        var firstIndex = firstNode.getIndex();
                        editor.highlighter.unhighlight();
                        // adjust the focus
                        var oldSelection = editor.getDomSelection();
                        Node1.blurNodes(nodes);
                        var newSelection = editor.getDomSelection();
                        // store the paths before removing them (needed for history)
                        var paths = nodes.map(getInternalPath);
                        // remove the nodes
                        nodes.forEach(function(node) {
                            node.parent._remove(node);
                        });
                        // store history action
                        editor._onAction("removeNodes", {
                            nodes: nodes,
                            paths: paths,
                            parentPath: parent.getInternalPath(),
                            index: firstIndex,
                            oldSelection: oldSelection,
                            newSelection: newSelection
                        });
                    }
                };
                /**
 * Duplicate nodes
 * duplicated nodes will be added right after the original nodes
 * @param {Node[] | Node} nodes
 */ Node1.onDuplicate = function(nodes) {
                    if (!Array.isArray(nodes)) return Node1.onDuplicate([
                        nodes
                    ]);
                    if (nodes && nodes.length > 0) {
                        var lastNode = nodes[nodes.length - 1];
                        var parent = lastNode.parent;
                        var editor = lastNode.editor;
                        editor.deselect(editor.multiselection.nodes);
                        // duplicate the nodes
                        var oldSelection = editor.getDomSelection();
                        var afterNode = lastNode;
                        var clones = nodes.map(function(node) {
                            var clone = node.clone();
                            if (node.parent.type === "object") {
                                var existingFieldNames = node.parent.getFieldNames();
                                clone.field = (0, util.findUniqueName)(node.field, existingFieldNames);
                            }
                            parent.insertAfter(clone, afterNode);
                            afterNode = clone;
                            return clone;
                        });
                        // set selection to the duplicated nodes
                        if (nodes.length === 1) {
                            if (clones[0].parent.type === "object") {
                                // when duplicating a single object property,
                                // set focus to the field and keep the original field name
                                clones[0].dom.field.innerHTML = nodes[0]._escapeHTML(nodes[0].field);
                                clones[0].focus("field");
                            } else clones[0].focus();
                        } else editor.select(clones);
                        var newSelection = editor.getDomSelection();
                        editor._onAction("duplicateNodes", {
                            paths: nodes.map(getInternalPath),
                            clonePaths: clones.map(getInternalPath),
                            afterPath: lastNode.getInternalPath(),
                            parentPath: parent.getInternalPath(),
                            oldSelection: oldSelection,
                            newSelection: newSelection
                        });
                    }
                };
                /**
 * Find the node from an event target
 * @param {HTMLElement} target
 * @return {Node | undefined} node  or undefined when not found
 * @static
 */ Node1.getNodeFromTarget = function(target) {
                    while(target){
                        if (target.node) return target.node;
                        target = target.parentNode;
                    }
                    return undefined;
                };
                /**
 * Test whether target is a child of the color DOM of a node
 * @param {HTMLElement} target
 * @returns {boolean}
 */ Node1.targetIsColorPicker = function(target) {
                    var node = Node1.getNodeFromTarget(target);
                    if (node) {
                        var parent = target && target.parentNode;
                        while(parent){
                            if (parent === node.dom.color) return true;
                            parent = parent.parentNode;
                        }
                    }
                    return false;
                };
                /**
 * Remove the focus of given nodes, and move the focus to the (a) node before,
 * (b) the node after, or (c) the parent node.
 * @param {Array.<Node> | Node} nodes
 */ Node1.blurNodes = function(nodes) {
                    if (!Array.isArray(nodes)) {
                        Node1.blurNodes([
                            nodes
                        ]);
                        return;
                    }
                    var firstNode = nodes[0];
                    var parent = firstNode.parent;
                    var firstIndex = firstNode.getIndex();
                    if (parent.childs[firstIndex + nodes.length]) parent.childs[firstIndex + nodes.length].focus();
                    else if (parent.childs[firstIndex - 1]) parent.childs[firstIndex - 1].focus();
                    else parent.focus();
                };
                // helper function to get the internal path of a node
                function getInternalPath(node) {
                    return node.getInternalPath();
                }
                // helper function to get the field of a node
                function getField(node) {
                    return node.getField();
                }
                function Node_hasOwnProperty(object, key) {
                    return Object.prototype.hasOwnProperty.call(object, key);
                }
                // TODO: find a nicer solution to resolve this circular dependency between Node and AppendNode
                //       idea: introduce properties .isAppendNode and .isNode and use that instead of instanceof AppendNode checks
                var AppendNode = appendNodeFactory(Node1);
                var ShowMoreNode = showMoreNodeFactory(Node1);
                function NodeHistory_typeof(obj) {
                    "@babel/helpers - typeof";
                    return NodeHistory_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
                        return typeof obj;
                    } : function(obj) {
                        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
                    }, NodeHistory_typeof(obj);
                }
                function NodeHistory_classCallCheck(instance, Constructor) {
                    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
                }
                function NodeHistory_defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, NodeHistory_toPropertyKey(descriptor.key), descriptor);
                    }
                }
                function NodeHistory_createClass(Constructor, protoProps, staticProps) {
                    if (protoProps) NodeHistory_defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) NodeHistory_defineProperties(Constructor, staticProps);
                    Object.defineProperty(Constructor, "prototype", {
                        writable: false
                    });
                    return Constructor;
                }
                function NodeHistory_toPropertyKey(arg) {
                    var key = NodeHistory_toPrimitive(arg, "string");
                    return NodeHistory_typeof(key) === "symbol" ? key : String(key);
                }
                function NodeHistory_toPrimitive(input, hint) {
                    if (NodeHistory_typeof(input) !== "object" || input === null) return input;
                    var prim = input[Symbol.toPrimitive];
                    if (prim !== undefined) {
                        var res = prim.call(input, hint || "default");
                        if (NodeHistory_typeof(res) !== "object") return res;
                        throw new TypeError("@@toPrimitive must return a primitive value.");
                    }
                    return (hint === "string" ? String : Number)(input);
                }
                /**
 * @constructor History
 * Store action history, enables undo and redo
 * @param {JSONEditor} editor
 */ var NodeHistory = /*#__PURE__*/ function() {
                    function NodeHistory(editor) {
                        NodeHistory_classCallCheck(this, NodeHistory);
                        this.editor = editor;
                        this.history = [];
                        this.index = -1;
                        this.clear();
                        // helper function to find a Node from a path
                        function findNode(path) {
                            return editor.node.findNodeByInternalPath(path);
                        }
                        // map with all supported actions
                        this.actions = {
                            editField: {
                                undo: function undo(params) {
                                    var parentNode = findNode(params.parentPath);
                                    var node = parentNode.childs[params.index];
                                    node.updateField(params.oldValue);
                                },
                                redo: function redo(params) {
                                    var parentNode = findNode(params.parentPath);
                                    var node = parentNode.childs[params.index];
                                    node.updateField(params.newValue);
                                }
                            },
                            editValue: {
                                undo: function undo(params) {
                                    findNode(params.path).updateValue(params.oldValue);
                                },
                                redo: function redo(params) {
                                    findNode(params.path).updateValue(params.newValue);
                                }
                            },
                            changeType: {
                                undo: function undo(params) {
                                    findNode(params.path).changeType(params.oldType);
                                },
                                redo: function redo(params) {
                                    findNode(params.path).changeType(params.newType);
                                }
                            },
                            appendNodes: {
                                undo: function undo(params) {
                                    var parentNode = findNode(params.parentPath);
                                    params.paths.map(findNode).forEach(function(node) {
                                        parentNode.removeChild(node);
                                    });
                                },
                                redo: function redo(params) {
                                    var parentNode = findNode(params.parentPath);
                                    params.nodes.forEach(function(node) {
                                        parentNode.appendChild(node);
                                    });
                                }
                            },
                            insertBeforeNodes: {
                                undo: function undo(params) {
                                    var parentNode = findNode(params.parentPath);
                                    params.paths.map(findNode).forEach(function(node) {
                                        parentNode.removeChild(node);
                                    });
                                },
                                redo: function redo(params) {
                                    var parentNode = findNode(params.parentPath);
                                    var beforeNode = findNode(params.beforePath);
                                    params.nodes.forEach(function(node) {
                                        parentNode.insertBefore(node, beforeNode);
                                    });
                                }
                            },
                            insertAfterNodes: {
                                undo: function undo(params) {
                                    var parentNode = findNode(params.parentPath);
                                    params.paths.map(findNode).forEach(function(node) {
                                        parentNode.removeChild(node);
                                    });
                                },
                                redo: function redo(params) {
                                    var parentNode = findNode(params.parentPath);
                                    var afterNode = findNode(params.afterPath);
                                    params.nodes.forEach(function(node) {
                                        parentNode.insertAfter(node, afterNode);
                                        afterNode = node;
                                    });
                                }
                            },
                            removeNodes: {
                                undo: function undo(params) {
                                    var parentNode = findNode(params.parentPath);
                                    var beforeNode = parentNode.childs[params.index] || parentNode.append;
                                    params.nodes.forEach(function(node) {
                                        parentNode.insertBefore(node, beforeNode);
                                    });
                                },
                                redo: function redo(params) {
                                    var parentNode = findNode(params.parentPath);
                                    params.paths.map(findNode).forEach(function(node) {
                                        parentNode.removeChild(node);
                                    });
                                }
                            },
                            duplicateNodes: {
                                undo: function undo(params) {
                                    var parentNode = findNode(params.parentPath);
                                    params.clonePaths.map(findNode).forEach(function(node) {
                                        parentNode.removeChild(node);
                                    });
                                },
                                redo: function redo(params) {
                                    var parentNode = findNode(params.parentPath);
                                    var afterNode = findNode(params.afterPath);
                                    var nodes = params.paths.map(findNode);
                                    nodes.forEach(function(node) {
                                        var clone = node.clone();
                                        if (parentNode.type === "object") {
                                            var existingFieldNames = parentNode.getFieldNames();
                                            clone.field = (0, util.findUniqueName)(node.field, existingFieldNames);
                                        }
                                        parentNode.insertAfter(clone, afterNode);
                                        afterNode = clone;
                                    });
                                }
                            },
                            moveNodes: {
                                undo: function undo(params) {
                                    var oldParentNode = findNode(params.oldParentPath);
                                    var newParentNode = findNode(params.newParentPath);
                                    var oldBeforeNode = oldParentNode.childs[params.oldIndex] || oldParentNode.append;
                                    // first copy the nodes, then move them
                                    var nodes = newParentNode.childs.slice(params.newIndex, params.newIndex + params.count);
                                    nodes.forEach(function(node, index) {
                                        node.field = params.fieldNames[index];
                                        oldParentNode.moveBefore(node, oldBeforeNode);
                                    });
                                    // This is a hack to work around an issue that we don't know tha original
                                    // path of the new parent after dragging, as the node is already moved at that time.
                                    if (params.newParentPathRedo === null) params.newParentPathRedo = newParentNode.getInternalPath();
                                },
                                redo: function redo(params) {
                                    var oldParentNode = findNode(params.oldParentPathRedo);
                                    var newParentNode = findNode(params.newParentPathRedo);
                                    var newBeforeNode = newParentNode.childs[params.newIndexRedo] || newParentNode.append;
                                    // first copy the nodes, then move them
                                    var nodes = oldParentNode.childs.slice(params.oldIndexRedo, params.oldIndexRedo + params.count);
                                    nodes.forEach(function(node, index) {
                                        node.field = params.fieldNames[index];
                                        newParentNode.moveBefore(node, newBeforeNode);
                                    });
                                }
                            },
                            sort: {
                                undo: function undo(params) {
                                    var node = findNode(params.path);
                                    node.hideChilds();
                                    node.childs = params.oldChilds;
                                    node.updateDom({
                                        updateIndexes: true
                                    });
                                    node.showChilds();
                                },
                                redo: function redo(params) {
                                    var node = findNode(params.path);
                                    node.hideChilds();
                                    node.childs = params.newChilds;
                                    node.updateDom({
                                        updateIndexes: true
                                    });
                                    node.showChilds();
                                }
                            },
                            transform: {
                                undo: function undo(params) {
                                    findNode(params.path).setInternalValue(params.oldValue);
                                // TODO: would be nice to restore the state of the node and childs
                                },
                                redo: function redo(params) {
                                    findNode(params.path).setInternalValue(params.newValue);
                                // TODO: would be nice to restore the state of the node and childs
                                }
                            }
                        };
                    }
                    /**
   * The method onChange is executed when the History is changed, and can
   * be overloaded.
   */ NodeHistory_createClass(NodeHistory, [
                        {
                            key: "onChange",
                            value: function onChange() {}
                        },
                        {
                            key: "add",
                            value: function add(action, params) {
                                this.index++;
                                this.history[this.index] = {
                                    action: action,
                                    params: params,
                                    timestamp: new Date()
                                };
                                // remove redo actions which are invalid now
                                if (this.index < this.history.length - 1) this.history.splice(this.index + 1, this.history.length - this.index - 1);
                                // fire onchange event
                                this.onChange();
                            }
                        },
                        {
                            key: "clear",
                            value: function clear() {
                                this.history = [];
                                this.index = -1;
                                // fire onchange event
                                this.onChange();
                            }
                        },
                        {
                            key: "canUndo",
                            value: function canUndo() {
                                return this.index >= 0;
                            }
                        },
                        {
                            key: "canRedo",
                            value: function canRedo() {
                                return this.index < this.history.length - 1;
                            }
                        },
                        {
                            key: "undo",
                            value: function undo() {
                                if (this.canUndo()) {
                                    var obj = this.history[this.index];
                                    if (obj) {
                                        var action = this.actions[obj.action];
                                        if (action && action.undo) {
                                            action.undo(obj.params);
                                            if (obj.params.oldSelection) try {
                                                this.editor.setDomSelection(obj.params.oldSelection);
                                            } catch (err) {
                                                console.error(err);
                                            }
                                        } else console.error(new Error('unknown action "' + obj.action + '"'));
                                    }
                                    this.index--;
                                    // fire onchange event
                                    this.onChange();
                                }
                            }
                        },
                        {
                            key: "redo",
                            value: function redo() {
                                if (this.canRedo()) {
                                    this.index++;
                                    var obj = this.history[this.index];
                                    if (obj) {
                                        var action = this.actions[obj.action];
                                        if (action && action.redo) {
                                            action.redo(obj.params);
                                            if (obj.params.newSelection) try {
                                                this.editor.setDomSelection(obj.params.newSelection);
                                            } catch (err) {
                                                console.error(err);
                                            }
                                        } else console.error(new Error('unknown action "' + obj.action + '"'));
                                    }
                                    // fire onchange event
                                    this.onChange();
                                }
                            }
                        },
                        {
                            key: "destroy",
                            value: function destroy() {
                                this.editor = null;
                                this.history = [];
                                this.index = -1;
                            }
                        }
                    ]);
                    return NodeHistory;
                }();
                function SearchBox_typeof(obj) {
                    "@babel/helpers - typeof";
                    return SearchBox_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
                        return typeof obj;
                    } : function(obj) {
                        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
                    }, SearchBox_typeof(obj);
                }
                function SearchBox_classCallCheck(instance, Constructor) {
                    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
                }
                function SearchBox_defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, SearchBox_toPropertyKey(descriptor.key), descriptor);
                    }
                }
                function SearchBox_createClass(Constructor, protoProps, staticProps) {
                    if (protoProps) SearchBox_defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) SearchBox_defineProperties(Constructor, staticProps);
                    Object.defineProperty(Constructor, "prototype", {
                        writable: false
                    });
                    return Constructor;
                }
                function SearchBox_toPropertyKey(arg) {
                    var key = SearchBox_toPrimitive(arg, "string");
                    return SearchBox_typeof(key) === "symbol" ? key : String(key);
                }
                function SearchBox_toPrimitive(input, hint) {
                    if (SearchBox_typeof(input) !== "object" || input === null) return input;
                    var prim = input[Symbol.toPrimitive];
                    if (prim !== undefined) {
                        var res = prim.call(input, hint || "default");
                        if (SearchBox_typeof(res) !== "object") return res;
                        throw new TypeError("@@toPrimitive must return a primitive value.");
                    }
                    return (hint === "string" ? String : Number)(input);
                }
                /**
 * @constructor SearchBox
 * Create a search box in given HTML container
 * @param {JSONEditor} editor    The JSON Editor to attach to
 * @param {Element} container               HTML container element of where to
 *                                          create the search box
 */ var SearchBox = /*#__PURE__*/ function() {
                    function SearchBox(editor, container) {
                        SearchBox_classCallCheck(this, SearchBox);
                        var searchBox = this;
                        this.editor = editor;
                        this.timeout = undefined;
                        this.delay = 200; // ms
                        this.lastText = undefined;
                        this.results = null;
                        this.dom = {};
                        this.dom.container = container;
                        var wrapper = document.createElement("div");
                        this.dom.wrapper = wrapper;
                        wrapper.className = "jsoneditor-search";
                        container.appendChild(wrapper);
                        var results = document.createElement("div");
                        this.dom.results = results;
                        results.className = "jsoneditor-results";
                        wrapper.appendChild(results);
                        var divInput = document.createElement("div");
                        this.dom.input = divInput;
                        divInput.className = "jsoneditor-frame";
                        divInput.title = (0, i18n /* translate */ .Iu)("searchTitle");
                        wrapper.appendChild(divInput);
                        var refreshSearch = document.createElement("button");
                        refreshSearch.type = "button";
                        refreshSearch.className = "jsoneditor-refresh";
                        divInput.appendChild(refreshSearch);
                        var search = document.createElement("input");
                        search.type = "text";
                        this.dom.search = search;
                        search.oninput = function(event) {
                            searchBox._onDelayedSearch(event);
                        };
                        search.onchange = function(event) {
                            // For IE 9
                            searchBox._onSearch();
                        };
                        search.onkeydown = function(event) {
                            searchBox._onKeyDown(event);
                        };
                        search.onkeyup = function(event) {
                            searchBox._onKeyUp(event);
                        };
                        refreshSearch.onclick = function(event) {
                            search.select();
                        };
                        // TODO: ESC in FF restores the last input, is a FF bug, https://bugzilla.mozilla.org/show_bug.cgi?id=598819
                        divInput.appendChild(search);
                        var searchNext = document.createElement("button");
                        searchNext.type = "button";
                        searchNext.title = (0, i18n /* translate */ .Iu)("searchNextResultTitle");
                        searchNext.className = "jsoneditor-next";
                        searchNext.onclick = function() {
                            searchBox.next();
                        };
                        divInput.appendChild(searchNext);
                        var searchPrevious = document.createElement("button");
                        searchPrevious.type = "button";
                        searchPrevious.title = (0, i18n /* translate */ .Iu)("searchPreviousResultTitle");
                        searchPrevious.className = "jsoneditor-previous";
                        searchPrevious.onclick = function() {
                            searchBox.previous();
                        };
                        divInput.appendChild(searchPrevious);
                    }
                    /**
   * Go to the next search result
   * @param {boolean} [focus]   If true, focus will be set to the next result
   *                            focus is false by default.
   */ SearchBox_createClass(SearchBox, [
                        {
                            key: "next",
                            value: function next(focus) {
                                if (this.results) {
                                    var index = this.resultIndex !== null ? this.resultIndex + 1 : 0;
                                    if (index > this.results.length - 1) index = 0;
                                    this._setActiveResult(index, focus);
                                }
                            }
                        },
                        {
                            key: "previous",
                            value: function previous(focus) {
                                if (this.results) {
                                    var max = this.results.length - 1;
                                    var index = this.resultIndex !== null ? this.resultIndex - 1 : max;
                                    if (index < 0) index = max;
                                    this._setActiveResult(index, focus);
                                }
                            }
                        },
                        {
                            key: "_setActiveResult",
                            value: function _setActiveResult(index, focus) {
                                // de-activate current active result
                                if (this.activeResult) {
                                    var prevNode = this.activeResult.node;
                                    var prevElem = this.activeResult.elem;
                                    if (prevElem === "field") delete prevNode.searchFieldActive;
                                    else delete prevNode.searchValueActive;
                                    prevNode.updateDom();
                                }
                                if (!this.results || !this.results[index]) {
                                    // out of range, set to undefined
                                    this.resultIndex = undefined;
                                    this.activeResult = undefined;
                                    return;
                                }
                                this.resultIndex = index;
                                // set new node active
                                var node = this.results[this.resultIndex].node;
                                var elem = this.results[this.resultIndex].elem;
                                if (elem === "field") node.searchFieldActive = true;
                                else node.searchValueActive = true;
                                this.activeResult = this.results[this.resultIndex];
                                node.updateDom();
                                // TODO: not so nice that the focus is only set after the animation is finished
                                node.scrollTo(function() {
                                    if (focus) node.focus(elem);
                                });
                            }
                        },
                        {
                            key: "_clearDelay",
                            value: function _clearDelay() {
                                if (this.timeout !== undefined) {
                                    clearTimeout(this.timeout);
                                    delete this.timeout;
                                }
                            }
                        },
                        {
                            key: "_onDelayedSearch",
                            value: function _onDelayedSearch(event) {
                                // execute the search after a short delay (reduces the number of
                                // search actions while typing in the search text box)
                                this._clearDelay();
                                var searchBox = this;
                                this.timeout = setTimeout(function(event) {
                                    searchBox._onSearch();
                                }, this.delay);
                            }
                        },
                        {
                            key: "_onSearch",
                            value: function _onSearch(forceSearch) {
                                this._clearDelay();
                                var value = this.dom.search.value;
                                var text = value.length > 0 ? value : undefined;
                                if (text !== this.lastText || forceSearch) {
                                    // only search again when changed
                                    this.lastText = text;
                                    this.results = this.editor.search(text);
                                    var MAX_SEARCH_RESULTS = this.results[0] ? this.results[0].node.MAX_SEARCH_RESULTS : Infinity;
                                    // try to maintain the current active result if this is still part of the new search results
                                    var activeResultIndex = 0;
                                    if (this.activeResult) {
                                        for(var i = 0; i < this.results.length; i++)if (this.results[i].node === this.activeResult.node) {
                                            activeResultIndex = i;
                                            break;
                                        }
                                    }
                                    this._setActiveResult(activeResultIndex, false);
                                    // display search results
                                    if (text !== undefined) {
                                        var resultCount = this.results.length;
                                        if (resultCount === 0) this.dom.results.textContent = "no\xa0results";
                                        else if (resultCount === 1) this.dom.results.textContent = "1\xa0result";
                                        else if (resultCount > MAX_SEARCH_RESULTS) this.dom.results.textContent = MAX_SEARCH_RESULTS + "+\xa0results";
                                        else this.dom.results.textContent = resultCount + "\xa0results";
                                    } else this.dom.results.textContent = "";
                                }
                            }
                        },
                        {
                            key: "_onKeyDown",
                            value: function _onKeyDown(event) {
                                var keynum = event.which;
                                if (keynum === 27) {
                                    // ESC
                                    this.dom.search.value = ""; // clear search
                                    this._onSearch();
                                    event.preventDefault();
                                    event.stopPropagation();
                                } else if (keynum === 13) {
                                    // Enter
                                    if (event.ctrlKey) // force to search again
                                    this._onSearch(true);
                                    else if (event.shiftKey) // move to the previous search result
                                    this.previous();
                                    else // move to the next search result
                                    this.next();
                                    event.preventDefault();
                                    event.stopPropagation();
                                }
                            }
                        },
                        {
                            key: "_onKeyUp",
                            value: function _onKeyUp(event) {
                                var keynum = event.keyCode;
                                if (keynum !== 27 && keynum !== 13) // !show and !Enter
                                this._onDelayedSearch(event); // For IE 9
                            }
                        },
                        {
                            key: "clear",
                            value: function clear() {
                                this.dom.search.value = "";
                                this._onSearch();
                            }
                        },
                        {
                            key: "forceSearch",
                            value: function forceSearch() {
                                this._onSearch(true);
                            }
                        },
                        {
                            key: "isEmpty",
                            value: function isEmpty() {
                                return this.dom.search.value === "";
                            }
                        },
                        {
                            key: "destroy",
                            value: function destroy() {
                                this.editor = null;
                                this.dom.container.removeChild(this.dom.wrapper);
                                this.dom = null;
                                this.results = null;
                                this.activeResult = null;
                                this._clearDelay();
                            }
                        }
                    ]);
                    return SearchBox;
                }();
                function TreePath_typeof(obj) {
                    "@babel/helpers - typeof";
                    return TreePath_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
                        return typeof obj;
                    } : function(obj) {
                        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
                    }, TreePath_typeof(obj);
                }
                function TreePath_classCallCheck(instance, Constructor) {
                    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
                }
                function TreePath_defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, TreePath_toPropertyKey(descriptor.key), descriptor);
                    }
                }
                function TreePath_createClass(Constructor, protoProps, staticProps) {
                    if (protoProps) TreePath_defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) TreePath_defineProperties(Constructor, staticProps);
                    Object.defineProperty(Constructor, "prototype", {
                        writable: false
                    });
                    return Constructor;
                }
                function TreePath_toPropertyKey(arg) {
                    var key = TreePath_toPrimitive(arg, "string");
                    return TreePath_typeof(key) === "symbol" ? key : String(key);
                }
                function TreePath_toPrimitive(input, hint) {
                    if (TreePath_typeof(input) !== "object" || input === null) return input;
                    var prim = input[Symbol.toPrimitive];
                    if (prim !== undefined) {
                        var res = prim.call(input, hint || "default");
                        if (TreePath_typeof(res) !== "object") return res;
                        throw new TypeError("@@toPrimitive must return a primitive value.");
                    }
                    return (hint === "string" ? String : Number)(input);
                }
                /**
 * Creates a component that visualize path selection in tree based editors
 * @param {HTMLElement} container
 * @param {HTMLElement} root
 * @constructor
 */ var TreePath = /*#__PURE__*/ function() {
                    function TreePath(container, root) {
                        TreePath_classCallCheck(this, TreePath);
                        if (container) {
                            this.root = root;
                            this.path = document.createElement("div");
                            this.path.className = "jsoneditor-treepath";
                            this.path.setAttribute("tabindex", 0);
                            this.contentMenuClicked = false;
                            container.appendChild(this.path);
                            this.reset();
                        }
                    }
                    /**
   * Reset component to initial status
   */ TreePath_createClass(TreePath, [
                        {
                            key: "reset",
                            value: function reset() {
                                this.path.textContent = (0, i18n /* translate */ .Iu)("selectNode");
                            }
                        },
                        {
                            key: "setPath",
                            value: function setPath(pathObjs) {
                                var me = this;
                                this.path.textContent = "";
                                if (pathObjs && pathObjs.length) pathObjs.forEach(function(pathObj, idx) {
                                    var pathEl = document.createElement("span");
                                    var sepEl;
                                    pathEl.className = "jsoneditor-treepath-element";
                                    pathEl.innerText = pathObj.name;
                                    pathEl.onclick = _onSegmentClick.bind(me, pathObj);
                                    me.path.appendChild(pathEl);
                                    if (pathObj.children.length) {
                                        sepEl = document.createElement("span");
                                        sepEl.className = "jsoneditor-treepath-seperator";
                                        sepEl.textContent = "►";
                                        sepEl.onclick = function() {
                                            me.contentMenuClicked = true;
                                            var items = [];
                                            pathObj.children.forEach(function(child) {
                                                items.push({
                                                    text: child.name,
                                                    className: "jsoneditor-type-modes" + (pathObjs[idx + 1] + 1 && pathObjs[idx + 1].name === child.name ? " jsoneditor-selected" : ""),
                                                    click: _onContextMenuItemClick.bind(me, pathObj, child.name)
                                                });
                                            });
                                            var menu = new ContextMenu /* ContextMenu */ .x(items, {
                                                limitHeight: true
                                            });
                                            menu.show(sepEl, me.root, true);
                                        };
                                        me.path.appendChild(sepEl);
                                    }
                                    if (idx === pathObjs.length - 1) {
                                        var leftRectPos = (sepEl || pathEl).getBoundingClientRect().right;
                                        if (me.path.offsetWidth < leftRectPos) me.path.scrollLeft = leftRectPos;
                                        if (me.path.scrollLeft) {
                                            var showAllBtn = document.createElement("span");
                                            showAllBtn.className = "jsoneditor-treepath-show-all-btn";
                                            showAllBtn.title = "show all path";
                                            showAllBtn.textContent = "...";
                                            showAllBtn.onclick = _onShowAllClick.bind(me, pathObjs);
                                            me.path.insertBefore(showAllBtn, me.path.firstChild);
                                        }
                                    }
                                });
                                function _onShowAllClick(pathObjs) {
                                    me.contentMenuClicked = false;
                                    (0, util.addClassName)(me.path, "show-all");
                                    me.path.style.width = me.path.parentNode.getBoundingClientRect().width - 10 + "px";
                                    me.path.onblur = function() {
                                        if (me.contentMenuClicked) {
                                            me.contentMenuClicked = false;
                                            me.path.focus();
                                            return;
                                        }
                                        (0, util.removeClassName)(me.path, "show-all");
                                        me.path.onblur = undefined;
                                        me.path.style.width = "";
                                        me.setPath(pathObjs);
                                    };
                                }
                                function _onSegmentClick(pathObj) {
                                    if (this.selectionCallback) this.selectionCallback(pathObj);
                                }
                                function _onContextMenuItemClick(pathObj, selection) {
                                    if (this.contextMenuCallback) this.contextMenuCallback(pathObj, selection);
                                }
                            }
                        },
                        {
                            key: "onSectionSelected",
                            value: function onSectionSelected(callback) {
                                if (typeof callback === "function") this.selectionCallback = callback;
                            }
                        },
                        {
                            key: "onContextMenuItemSelected",
                            value: function onContextMenuItemSelected(callback) {
                                if (typeof callback === "function") this.contextMenuCallback = callback;
                            }
                        }
                    ]);
                    return TreePath;
                }();
                // EXTERNAL MODULE: ./src/js/vanilla-picker/index.js
                var vanilla_picker = __webpack_require__(37);
                var vanilla_picker_default = /*#__PURE__*/ __webpack_require__.n(vanilla_picker);
                // create a mixin with the functions for tree mode
                var treemode = {};
                /**
 * Create a tree editor
 * @param {Element} container    Container element
 * @param {Object} [options]   Object with options. See docs for details.
 * @private
 */ treemode.create = function(container, options) {
                    if (!container) throw new Error("No container element provided.");
                    this.container = container;
                    this.dom = {};
                    this.highlighter = new Highlighter();
                    this.selection = undefined; // will hold the last input selection
                    this.multiselection = {
                        nodes: []
                    };
                    this.validateSchema = null; // will be set in .setSchema(schema)
                    this.validationSequence = 0;
                    this.errorNodes = [];
                    this.lastSchemaErrors = undefined;
                    this.node = null;
                    this.focusTarget = null;
                    this._setOptions(options);
                    if (options.autocomplete) this.autocomplete = autocomplete(options.autocomplete);
                    if (this.options.history && this.options.mode !== "view") this.history = new NodeHistory(this);
                    this._createFrame();
                    this._createTable();
                };
                /**
 * Destroy the editor. Clean up DOM, event listeners, and web workers.
 */ treemode.destroy = function() {
                    if (this.frame && this.container && this.frame.parentNode === this.container) {
                        this.container.removeChild(this.frame);
                        this.frame = null;
                    }
                    this.container = null;
                    this.dom = null;
                    this.clear();
                    this.node = null;
                    this.focusTarget = null;
                    this.selection = null;
                    this.multiselection = null;
                    this.errorNodes = null;
                    this.validateSchema = null;
                    this._debouncedValidate = null;
                    if (this.history) {
                        this.history.destroy();
                        this.history = null;
                    }
                    if (this.searchBox) {
                        this.searchBox.destroy();
                        this.searchBox = null;
                    }
                    if (this.modeSwitcher) {
                        this.modeSwitcher.destroy();
                        this.modeSwitcher = null;
                    }
                    // Removing the FocusTracker set to track the editor's focus event
                    this.frameFocusTracker.destroy();
                };
                /**
 * Initialize and set default options
 * @param {Object}  [options]    See description in constructor
 * @private
 */ treemode._setOptions = function(options) {
                    var _this = this;
                    this.options = {
                        search: true,
                        history: true,
                        mode: "tree",
                        name: undefined,
                        // field name of root node
                        schema: null,
                        schemaRefs: null,
                        autocomplete: null,
                        navigationBar: true,
                        mainMenuBar: true,
                        limitDragging: false,
                        onSelectionChange: null,
                        colorPicker: true,
                        onColorPicker: function onColorPicker(parent, color, onChange) {
                            if (vanilla_picker_default()) {
                                // we'll render the color picker on top
                                // when there is not enough space below, and there is enough space above
                                var pickerHeight = 300; // estimated height of the color picker
                                var top = parent.getBoundingClientRect().top;
                                var windowHeight = (0, util.getWindow)(parent).innerHeight;
                                var showOnTop = windowHeight - top < pickerHeight && top > pickerHeight;
                                new (vanilla_picker_default())({
                                    parent: parent,
                                    color: color,
                                    popup: showOnTop ? "top" : "bottom",
                                    onDone: function onDone(color) {
                                        var alpha = color.rgba[3];
                                        var hex = alpha === 1 ? color.hex.substr(0, 7) // return #RRGGBB
                                         : color.hex; // return #RRGGBBAA
                                        onChange(hex);
                                    }
                                }).show();
                            } else console.warn("Cannot open color picker: the `vanilla-picker` library is not included in the bundle. Either use the full bundle or implement your own color picker using `onColorPicker`.");
                        },
                        timestampTag: true,
                        timestampFormat: null,
                        createQuery: jmespathQuery /* createQuery */ .r,
                        executeQuery: jmespathQuery /* executeQuery */ .J,
                        onEvent: null,
                        enableSort: true,
                        enableTransform: true
                    };
                    // copy all options
                    if (options) {
                        Object.keys(options).forEach(function(prop) {
                            _this.options[prop] = options[prop];
                        });
                        // default limitDragging to true when a JSON schema is defined
                        if (options.limitDragging == null && options.schema != null) this.options.limitDragging = true;
                    }
                    // compile a JSON schema validator if a JSON schema is provided
                    this.setSchema(this.options.schema, this.options.schemaRefs);
                    // create a debounced validate function
                    this._debouncedValidate = (0, util.debounce)(this._validateAndCatch.bind(this), this.DEBOUNCE_INTERVAL);
                    if (options.onSelectionChange) this.onSelectionChange(options.onSelectionChange);
                    (0, i18n /* setLanguages */ .cC)(this.options.languages);
                    (0, i18n /* setLanguage */ .m0)(this.options.language);
                };
                /**
 * Set new JSON object in editor.
 * Resets the state of the editor (expanded nodes, search, selection).
 *
 * @param {*} json
 */ treemode.set = function(json) {
                    // verify if json is valid JSON, ignore when a function
                    if (json instanceof Function || json === undefined) this.clear();
                    else {
                        this.content.removeChild(this.table); // Take the table offline
                        // replace the root node
                        var params = {
                            field: this.options.name,
                            value: json
                        };
                        var node = new Node1(this, params);
                        this._setRoot(node);
                        // validate JSON schema (if configured)
                        this._validateAndCatch();
                        // expand
                        var recurse = false;
                        this.node.expand(recurse);
                        this.content.appendChild(this.table); // Put the table online again
                    }
                    // TODO: maintain history, store last state and previous document
                    if (this.history) this.history.clear();
                    // clear search
                    if (this.searchBox) this.searchBox.clear();
                };
                /**
 * Update JSON object in editor.
 * Maintains the state of the editor (expanded nodes, search, selection).
 *
 * @param {*} json
 */ treemode.update = function(json) {
                    // don't update if there are no changes
                    if (this.node.deepEqual(json)) return;
                    var selection = this.getSelection();
                    // apply the changed json
                    this.onChangeDisabled = true; // don't fire an onChange event
                    this.node.update(json);
                    this.onChangeDisabled = false;
                    // validate JSON schema
                    this._validateAndCatch();
                    // update search result if any
                    if (this.searchBox && !this.searchBox.isEmpty()) this.searchBox.forceSearch();
                    // update selection if any
                    if (selection && selection.start && selection.end) {
                        // only keep/update the selection if both start and end node still exists,
                        // else we clear the selection
                        var startNode = this.node.findNodeByPath(selection.start.path);
                        var endNode = this.node.findNodeByPath(selection.end.path);
                        if (startNode && endNode) this.setSelection(selection.start, selection.end);
                        else this.setSelection({}, {}); // clear selection
                    } else this.setSelection({}, {}); // clear selection
                };
                /**
 * Get JSON object from editor
 * @return {Object | undefined} json
 */ treemode.get = function() {
                    // TODO: resolve pending debounced input changes if any, but do not resolve invalid inputs
                    if (this.node) return this.node.getValue();
                    else return undefined;
                };
                /**
 * Get the text contents of the editor
 * @return {String} jsonText
 */ treemode.getText = function() {
                    return JSON.stringify(this.get());
                };
                /**
 * Set the text contents of the editor.
 * Resets the state of the editor (expanded nodes, search, selection).
 * @param {String} jsonText
 */ treemode.setText = function(jsonText) {
                    try {
                        this.set((0, util.parse)(jsonText)); // this can throw an error
                    } catch (err) {
                        // try to repair json, replace JavaScript notation with JSON notation
                        var repairedJsonText = (0, util.tryJsonRepair)(jsonText);
                        // try to parse again
                        this.set((0, util.parse)(repairedJsonText)); // this can throw an error
                    }
                };
                /**
 * Update the text contents of the editor.
 * Maintains the state of the editor (expanded nodes, search, selection).
 * @param {String} jsonText
 */ treemode.updateText = function(jsonText) {
                    try {
                        this.update((0, util.parse)(jsonText)); // this can throw an error
                    } catch (err) {
                        // try to repair json, replace JavaScript notation with JSON notation
                        var repairJsonText = (0, util.tryJsonRepair)(jsonText);
                        // try to parse again
                        this.update((0, util.parse)(repairJsonText)); // this can throw an error
                    }
                };
                /**
 * Set a field name for the root node.
 * @param {String | undefined} name
 */ treemode.setName = function(name) {
                    this.options.name = name;
                    if (this.node) this.node.updateField(this.options.name);
                };
                /**
 * Get the field name for the root node.
 * @return {String | undefined} name
 */ treemode.getName = function() {
                    return this.options.name;
                };
                /**
 * Set focus to the editor. Focus will be set to:
 * - the first editable field or value, or else
 * - to the expand button of the root node, or else
 * - to the context menu button of the root node, or else
 * - to the first button in the top menu
 */ treemode.focus = function() {
                    var input = this.scrollableContent.querySelector("[contenteditable=true]");
                    if (input) input.focus();
                    else if (this.node.dom.expand) this.node.dom.expand.focus();
                    else if (this.node.dom.menu) this.node.dom.menu.focus();
                    else {
                        // focus to the first button in the menu
                        input = this.frame.querySelector("button");
                        if (input) input.focus();
                    }
                };
                /**
 * Remove the root node from the editor
 */ treemode.clear = function() {
                    if (this.node) {
                        this.node.hide();
                        delete this.node;
                    }
                    if (this.treePath) this.treePath.reset();
                };
                /**
 * Set the root node for the json editor
 * @param {Node} node
 * @private
 */ treemode._setRoot = function(node) {
                    this.clear();
                    this.node = node;
                    node.setParent(null);
                    node.setField(this.getName(), false);
                    delete node.index;
                    // append to the dom
                    this.tbody.appendChild(node.getDom());
                };
                /**
 * Search text in all nodes
 * The nodes will be expanded when the text is found one of its childs,
 * else it will be collapsed. Searches are case insensitive.
 * @param {String} text
 * @return {Object[]} results  Array with nodes containing the search results
 *                             The result objects contains fields:
 *                             - {Node} node,
 *                             - {String} elem  the dom element name where
 *                                              the result is found ('field' or
 *                                              'value')
 */ treemode.search = function(text) {
                    var results;
                    if (this.node) {
                        this.content.removeChild(this.table); // Take the table offline
                        results = this.node.search(text);
                        this.content.appendChild(this.table); // Put the table online again
                    } else results = [];
                    return results;
                };
                /**
 * Expand all nodes
 */ treemode.expandAll = function() {
                    if (this.node) {
                        this.content.removeChild(this.table); // Take the table offline
                        this.node.expand();
                        this.content.appendChild(this.table); // Put the table online again
                    }
                };
                /**
 * Collapse all nodes
 */ treemode.collapseAll = function() {
                    if (this.node) {
                        this.content.removeChild(this.table); // Take the table offline
                        this.node.collapse();
                        this.content.appendChild(this.table); // Put the table online again
                    }
                };
                /**
 * Expand/collapse a given JSON node.
 * @param {Object} [options] Available parameters:
 *                         {Array<String>} [path] Path for the node to expand/collapse.
 *                         {Boolean} [isExpand]  Whether to expand the node (else collapse).
 *                         {Boolean} [recursive]  Whether to expand/collapse child nodes recursively.
 */ treemode.expand = function(options) {
                    if (!options) return;
                    var node = this.node ? this.node.findNodeByPath(options.path) : null;
                    if (!node) return;
                    if (options.isExpand) node.expand(options.recursive);
                    else node.collapse(options.recursive);
                };
                /**
 * The method onChange is called whenever a field or value is changed, created,
 * deleted, duplicated, etc.
 * @param {String} action  Change action. Available values: "editField",
 *                         "editValue", "changeType", "appendNode",
 *                         "removeNode", "duplicateNode", "moveNode", "expand",
 *                         "collapse".
 * @param {Object} params  Object containing parameters describing the change.
 *                         The parameters in params depend on the action (for
 *                         example for "editValue" the Node, old value, and new
 *                         value are provided). params contains all information
 *                         needed to undo or redo the action.
 * @private
 */ treemode._onAction = function(action, params) {
                    // add an action to the history
                    if (this.history) this.history.add(action, params);
                    this._onChange();
                };
                /**
 * Handle a change:
 * - Validate JSON schema
 * - Send a callback to the onChange listener if provided
 * @private
 */ treemode._onChange = function() {
                    if (this.onChangeDisabled) return;
                    // selection can be changed after undo/redo
                    this.selection = this.getDomSelection();
                    // validate JSON schema (if configured)
                    this._debouncedValidate();
                    if (this.treePath) {
                        var selectedNode = this.node && this.selection ? this.node.findNodeByInternalPath(this.selection.path) : this.multiselection ? this.multiselection.nodes[0] : undefined;
                        if (selectedNode) this._updateTreePath(selectedNode.getNodePath());
                        else this.treePath.reset();
                    }
                    // trigger the onChange callback
                    if (this.options.onChange) try {
                        this.options.onChange();
                    } catch (err) {
                        console.error("Error in onChange callback: ", err);
                    }
                    // trigger the onChangeJSON callback
                    if (this.options.onChangeJSON) try {
                        this.options.onChangeJSON(this.get());
                    } catch (err) {
                        console.error("Error in onChangeJSON callback: ", err);
                    }
                    // trigger the onChangeText callback
                    if (this.options.onChangeText) try {
                        this.options.onChangeText(this.getText());
                    } catch (err) {
                        console.error("Error in onChangeText callback: ", err);
                    }
                    // trigger the onClassName callback
                    if (this.options.onClassName) this.node.recursivelyUpdateCssClassesOnNodes();
                    // trigger the onNodeName callback
                    if (this.options.onNodeName && this.node.childs) try {
                        this.node.recursivelyUpdateNodeName();
                    } catch (err) {
                        console.error("Error in onNodeName callback: ", err);
                    }
                };
                /**
 * Validate current JSON object against the configured JSON schema
 * Throws an exception when no JSON schema is configured
 */ treemode.validate = function() {
                    var _this2 = this;
                    var root = this.node;
                    if (!root) // TODO: this should be redundant but is needed on mode switch
                    return;
                    var json = root.getValue();
                    // execute JSON schema validation
                    var schemaErrors = [];
                    if (this.validateSchema) {
                        var valid = this.validateSchema(json);
                        if (!valid) // apply all new errors
                        schemaErrors = this.validateSchema.errors.map(function(error) {
                            return (0, util.improveSchemaError)(error);
                        }).map(function findNode(error) {
                            return {
                                node: root.findNode(error.dataPath),
                                error: error,
                                type: "validation"
                            };
                        }).filter(function hasNode(entry) {
                            return entry.node != null;
                        });
                    }
                    // execute custom validation and after than merge and render all errors
                    try {
                        this.validationSequence++;
                        var me = this;
                        var seq = this.validationSequence;
                        return this._validateCustom(json).then(function(customValidationErrors) {
                            // only apply when there was no other validation started whilst resolving async results
                            if (seq === me.validationSequence) {
                                var errorNodes = [].concat(schemaErrors, customValidationErrors || []);
                                me._renderValidationErrors(errorNodes);
                                if (typeof _this2.options.onValidationError === "function" && (0, util.isValidationErrorChanged)(errorNodes, _this2.lastSchemaErrors)) _this2.options.onValidationError.call(_this2, errorNodes);
                                _this2.lastSchemaErrors = errorNodes;
                            }
                            return _this2.lastSchemaErrors;
                        });
                    } catch (err) {
                        return Promise.reject(err);
                    }
                };
                treemode._validateAndCatch = function() {
                    this.validate()["catch"](function(err) {
                        console.error("Error running validation:", err);
                    });
                };
                treemode._renderValidationErrors = function(errorNodes) {
                    // clear all current errors
                    if (this.errorNodes) this.errorNodes.forEach(function(node) {
                        node.setError(null);
                    });
                    // render the new errors
                    var parentPairs = errorNodes.reduce(function(all, entry) {
                        return entry.node.findParents().filter(function(parent) {
                            return !all.some(function(pair) {
                                return pair[0] === parent;
                            });
                        }).map(function(parent) {
                            return [
                                parent,
                                entry.node
                            ];
                        }).concat(all);
                    }, []);
                    this.errorNodes = parentPairs.map(function(pair) {
                        return {
                            node: pair[0],
                            child: pair[1],
                            error: {
                                message: pair[0].type === "object" ? (0, i18n /* translate */ .Iu)("containsInvalidProperties") // object
                                 : (0, i18n /* translate */ .Iu)("containsInvalidItems") // array
                            }
                        };
                    }).concat(errorNodes).map(function setError(entry) {
                        entry.node.setError(entry.error, entry.child);
                        return entry.node;
                    });
                };
                /**
 * Execute custom validation if configured.
 *
 * Returns a promise resolving with the custom errors (or nothing).
 */ treemode._validateCustom = function(json) {
                    try {
                        if (this.options.onValidate) {
                            var root = this.node;
                            var customValidateResults = this.options.onValidate(json);
                            var resultPromise = (0, util.isPromise)(customValidateResults) ? customValidateResults : Promise.resolve(customValidateResults);
                            return resultPromise.then(function(customValidationPathErrors) {
                                if (Array.isArray(customValidationPathErrors)) return customValidationPathErrors.filter(function(error) {
                                    var valid = (0, util.isValidValidationError)(error);
                                    if (!valid) console.warn('Ignoring a custom validation error with invalid structure. Expected structure: {path: [...], message: "..."}. Actual error:', error);
                                    return valid;
                                }).map(function(error) {
                                    var node;
                                    try {
                                        node = error && error.path ? root.findNodeByPath(error.path) : null;
                                    } catch (err) {
                                    // stay silent here, we throw a generic warning if no node is found
                                    }
                                    if (!node) console.warn("Ignoring validation error: node not found. Path:", error.path, "Error:", error);
                                    return {
                                        node: node,
                                        error: error,
                                        type: "customValidation"
                                    };
                                }).filter(function(entry) {
                                    return entry && entry.node && entry.error && entry.error.message;
                                });
                                else return null;
                            });
                        }
                    } catch (err) {
                        return Promise.reject(err);
                    }
                    return Promise.resolve(null);
                };
                /**
 * Refresh the rendered contents
 */ treemode.refresh = function() {
                    if (this.node) this.node.updateDom({
                        recurse: true
                    });
                };
                /**
 * Start autoscrolling when given mouse position is above the top of the
 * editor contents, or below the bottom.
 * @param {Number} mouseY  Absolute mouse position in pixels
 */ treemode.startAutoScroll = function(mouseY) {
                    var me = this;
                    var content = this.scrollableContent;
                    var top = (0, util.getAbsoluteTop)(content);
                    var height = content.clientHeight;
                    var bottom = top + height;
                    var margin = 24;
                    var interval = 50; // ms
                    if (mouseY < top + margin && content.scrollTop > 0) this.autoScrollStep = (top + margin - mouseY) / 3;
                    else if (mouseY > bottom - margin && height + content.scrollTop < content.scrollHeight) this.autoScrollStep = (bottom - margin - mouseY) / 3;
                    else this.autoScrollStep = undefined;
                    if (this.autoScrollStep) {
                        if (!this.autoScrollTimer) this.autoScrollTimer = setInterval(function() {
                            if (me.autoScrollStep) content.scrollTop -= me.autoScrollStep;
                            else me.stopAutoScroll();
                        }, interval);
                    } else this.stopAutoScroll();
                };
                /**
 * Stop auto scrolling. Only applicable when scrolling
 */ treemode.stopAutoScroll = function() {
                    if (this.autoScrollTimer) {
                        clearTimeout(this.autoScrollTimer);
                        delete this.autoScrollTimer;
                    }
                    if (this.autoScrollStep) delete this.autoScrollStep;
                };
                /**
 * Set the focus to an element in the editor, set text selection, and
 * set scroll position.
 * @param {Object} selection  An object containing fields:
 *                            {Element | undefined} dom     The dom element
 *                                                          which has focus
 *                            {Range | TextRange} range     A text selection
 *                            {Node[]} nodes                Nodes in case of multi selection
 *                            {Number} scrollTop            Scroll position
 */ treemode.setDomSelection = function(selection) {
                    if (!selection) return;
                    if ("scrollTop" in selection && this.scrollableContent) // TODO: animated scroll
                    this.scrollableContent.scrollTop = selection.scrollTop;
                    if (selection.paths) {
                        // multi-select
                        var me = this;
                        var nodes = selection.paths.map(function(path) {
                            return me.node.findNodeByInternalPath(path);
                        });
                        this.select(nodes);
                    } else {
                        // find the actual DOM element where to apply the focus
                        var node = selection.path ? this.node.findNodeByInternalPath(selection.path) : null;
                        var container = node && selection.domName ? node.dom[selection.domName] : null;
                        if (selection.range && container) {
                            var range = Object.assign({}, selection.range, {
                                container: container
                            });
                            (0, util.setSelectionOffset)(range);
                        } else if (node) // just a fallback
                        node.focus();
                    }
                };
                /**
 * Get the current focus
 * @return {Object} selection An object containing fields:
 *                            {Element | undefined} dom     The dom element
 *                                                          which has focus
 *                            {Range | TextRange} range     A text selection
 *                            {Node[]} nodes                Nodes in case of multi selection
 *                            {Number} scrollTop            Scroll position
 */ treemode.getDomSelection = function() {
                    // find the node and field name of the current target,
                    // so we can store the current selection in a serializable
                    // way (internal node path and domName)
                    var node = Node1.getNodeFromTarget(this.focusTarget);
                    var focusTarget = this.focusTarget;
                    var domName = node ? Object.keys(node.dom).find(function(domName) {
                        return node.dom[domName] === focusTarget;
                    }) : null;
                    var range = (0, util.getSelectionOffset)();
                    if (range && range.container.nodeName !== "DIV") // filter on (editable) divs)
                    range = null;
                    if (range && range.container !== focusTarget) range = null;
                    if (range) // we cannot rely on the current instance of the container,
                    // we need to store the internal node path and field and
                    // find the actual DOM field when applying the selection
                    delete range.container;
                    return {
                        path: node ? node.getInternalPath() : null,
                        domName: domName,
                        range: range,
                        paths: this.multiselection.length > 0 ? this.multiselection.nodes.map(function(node) {
                            return node.getInternalPath();
                        }) : null,
                        scrollTop: this.scrollableContent ? this.scrollableContent.scrollTop : 0
                    };
                };
                /**
 * Adjust the scroll position such that given top position is shown at 1/4
 * of the window height.
 * @param {Number} top
 * @param {function(boolean)} [animateCallback] Callback, executed when animation is
 *                                              finished. The callback returns true
 *                                              when animation is finished, or false
 *                                              when not.
 */ treemode.scrollTo = function(top, animateCallback) {
                    var content = this.scrollableContent;
                    if (content) {
                        var editor = this;
                        // cancel any running animation
                        if (editor.animateTimeout) {
                            clearTimeout(editor.animateTimeout);
                            delete editor.animateTimeout;
                        }
                        if (editor.animateCallback) {
                            editor.animateCallback(false);
                            delete editor.animateCallback;
                        }
                        // calculate final scroll position
                        var height = content.clientHeight;
                        var bottom = content.scrollHeight - height;
                        var finalScrollTop = Math.min(Math.max(top - height / 4, 0), bottom);
                        // animate towards the new scroll position
                        var animate = function animate() {
                            var scrollTop = content.scrollTop;
                            var diff = finalScrollTop - scrollTop;
                            if (Math.abs(diff) > 3) {
                                content.scrollTop += diff / 3;
                                editor.animateCallback = animateCallback;
                                editor.animateTimeout = setTimeout(animate, 50);
                            } else {
                                // finished
                                if (animateCallback) animateCallback(true);
                                content.scrollTop = finalScrollTop;
                                delete editor.animateTimeout;
                                delete editor.animateCallback;
                            }
                        };
                        animate();
                    } else if (animateCallback) animateCallback(false);
                };
                /**
 * Create main frame
 * @private
 */ treemode._createFrame = function() {
                    var _this3 = this;
                    // create the frame
                    this.frame = document.createElement("div");
                    this.frame.className = "jsoneditor jsoneditor-mode-" + this.options.mode;
                    // this.frame.setAttribute("tabindex","0");
                    this.container.appendChild(this.frame);
                    this.contentOuter = document.createElement("div");
                    this.contentOuter.className = "jsoneditor-outer";
                    // create one global event listener to handle all events from all nodes
                    var editor = this;
                    function onEvent(event) {
                        // when switching to mode "code" or "text" via the menu, some events
                        // are still fired whilst the _onEvent methods is already removed.
                        if (editor._onEvent) editor._onEvent(event);
                    }
                    // setting the FocusTracker on 'this.frame' to track the editor's focus event
                    var focusTrackerConfig = {
                        target: this.frame,
                        onFocus: this.options.onFocus || null,
                        onBlur: this.options.onBlur || null
                    };
                    this.frameFocusTracker = new FocusTracker /* FocusTracker */ .R(focusTrackerConfig);
                    this.frame.onclick = function(event) {
                        var target = event.target; // || event.srcElement;
                        onEvent(event);
                        // prevent default submit action of buttons when editor is located
                        // inside a form
                        if (target.nodeName === "BUTTON") event.preventDefault();
                    };
                    this.frame.oninput = onEvent;
                    this.frame.onchange = onEvent;
                    this.frame.onkeydown = onEvent;
                    this.frame.onkeyup = onEvent;
                    this.frame.oncut = onEvent;
                    this.frame.onpaste = onEvent;
                    this.frame.onmousedown = onEvent;
                    this.frame.onmouseup = onEvent;
                    this.frame.onmouseover = onEvent;
                    this.frame.onmouseout = onEvent;
                    // Note: focus and blur events do not propagate, therefore they defined
                    // using an eventListener with useCapture=true
                    // see http://www.quirksmode.org/blog/archives/2008/04/delegating_the.html
                    (0, util.addEventListener)(this.frame, "focus", onEvent, true);
                    (0, util.addEventListener)(this.frame, "blur", onEvent, true);
                    this.frame.onfocusin = onEvent; // for IE
                    this.frame.onfocusout = onEvent; // for IE
                    if (this.options.mainMenuBar) {
                        (0, util.addClassName)(this.contentOuter, "has-main-menu-bar");
                        // create menu
                        this.menu = document.createElement("div");
                        this.menu.className = "jsoneditor-menu";
                        this.frame.appendChild(this.menu);
                        // create expand all button
                        var expandAll = document.createElement("button");
                        expandAll.type = "button";
                        expandAll.className = "jsoneditor-expand-all";
                        expandAll.title = (0, i18n /* translate */ .Iu)("expandAll");
                        expandAll.onclick = function() {
                            editor.expandAll();
                            if (typeof _this3.options.onExpand === "function") _this3.options.onExpand({
                                path: [],
                                isExpand: true,
                                recursive: true
                            });
                        };
                        this.menu.appendChild(expandAll);
                        // create collapse all button
                        var collapseAll = document.createElement("button");
                        collapseAll.type = "button";
                        collapseAll.title = (0, i18n /* translate */ .Iu)("collapseAll");
                        collapseAll.className = "jsoneditor-collapse-all";
                        collapseAll.onclick = function() {
                            editor.collapseAll();
                            if (typeof _this3.options.onExpand === "function") _this3.options.onExpand({
                                path: [],
                                isExpand: false,
                                recursive: true
                            });
                        };
                        this.menu.appendChild(collapseAll);
                        // create sort button
                        if (this.options.enableSort) {
                            var sort = document.createElement("button");
                            sort.type = "button";
                            sort.className = "jsoneditor-sort";
                            sort.title = (0, i18n /* translate */ .Iu)("sortTitleShort");
                            sort.onclick = function() {
                                editor.node.showSortModal();
                            };
                            this.menu.appendChild(sort);
                        }
                        // create transform button
                        if (this.options.enableTransform) {
                            var transform = document.createElement("button");
                            transform.type = "button";
                            transform.title = (0, i18n /* translate */ .Iu)("transformTitleShort");
                            transform.className = "jsoneditor-transform";
                            transform.onclick = function() {
                                editor.node.showTransformModal();
                            };
                            this.menu.appendChild(transform);
                        }
                        // create undo/redo buttons
                        if (this.history) {
                            // create undo button
                            var undo = document.createElement("button");
                            undo.type = "button";
                            undo.className = "jsoneditor-undo jsoneditor-separator";
                            undo.title = (0, i18n /* translate */ .Iu)("undo");
                            undo.onclick = function() {
                                editor._onUndo();
                            };
                            this.menu.appendChild(undo);
                            this.dom.undo = undo;
                            // create redo button
                            var redo = document.createElement("button");
                            redo.type = "button";
                            redo.className = "jsoneditor-redo";
                            redo.title = (0, i18n /* translate */ .Iu)("redo");
                            redo.onclick = function() {
                                editor._onRedo();
                            };
                            this.menu.appendChild(redo);
                            this.dom.redo = redo;
                            // register handler for onchange of history
                            this.history.onChange = function() {
                                undo.disabled = !editor.history.canUndo();
                                redo.disabled = !editor.history.canRedo();
                            };
                            this.history.onChange();
                        }
                        // create mode box
                        if (this.options && this.options.modes && this.options.modes.length) {
                            var me = this;
                            this.modeSwitcher = new ModeSwitcher /* ModeSwitcher */ .x(this.menu, this.options.modes, this.options.mode, function onSwitch(mode) {
                                // switch mode and restore focus
                                try {
                                    me.setMode(mode);
                                    me.modeSwitcher.focus();
                                } catch (err) {
                                    me._onError(err);
                                }
                            });
                        }
                        // create search box
                        if (this.options.search) this.searchBox = new SearchBox(this, this.menu);
                    }
                    if (this.options.navigationBar) {
                        // create second menu row for treepath
                        this.navBar = document.createElement("div");
                        this.navBar.className = "jsoneditor-navigation-bar nav-bar-empty";
                        this.frame.appendChild(this.navBar);
                        this.treePath = new TreePath(this.navBar, this.getPopupAnchor());
                        this.treePath.onSectionSelected(this._onTreePathSectionSelected.bind(this));
                        this.treePath.onContextMenuItemSelected(this._onTreePathMenuItemSelected.bind(this));
                    }
                };
                /**
 * Perform an undo action
 * @private
 */ treemode._onUndo = function() {
                    if (this.history) {
                        // undo last action
                        this.history.undo();
                        // fire change event
                        this._onChange();
                    }
                };
                /**
 * Perform a redo action
 * @private
 */ treemode._onRedo = function() {
                    if (this.history) {
                        // redo last action
                        this.history.redo();
                        // fire change event
                        this._onChange();
                    }
                };
                /**
 * Event handler
 * @param event
 * @private
 */ treemode._onEvent = function(event) {
                    // don't process events when coming from the color picker
                    if (Node1.targetIsColorPicker(event.target)) return;
                    var node = Node1.getNodeFromTarget(event.target);
                    if (event.type === "keydown") this._onKeyDown(event);
                    if (node && event.type === "focus") {
                        this.focusTarget = event.target;
                        if (this.options.autocomplete && this.options.autocomplete.trigger === "focus") this._showAutoComplete(event.target);
                    }
                    if (event.type === "mousedown") this._startDragDistance(event);
                    if (event.type === "mousemove" || event.type === "mouseup" || event.type === "click") this._updateDragDistance(event);
                    if (node && this.options && this.options.navigationBar && node && (event.type === "keydown" || event.type === "mousedown")) {
                        // apply on next tick, right after the new key press is applied
                        var me = this;
                        setTimeout(function() {
                            me._updateTreePath(node.getNodePath());
                        });
                    }
                    if (node && node.selected) {
                        if (event.type === "click") {
                            if (event.target === node.dom.menu) {
                                this.showContextMenu(event.target);
                                // stop propagation (else we will open the context menu of a single node)
                                return;
                            }
                            // deselect a multi selection
                            if (!event.hasMoved) this.deselect();
                        }
                        if (event.type === "mousedown") // drag multiple nodes
                        Node1.onDragStart(this.multiselection.nodes, event);
                    } else // filter mouse events in the contents part of the editor (not the main menu)
                    if (event.type === "mousedown" && (0, util.hasParentNode)(event.target, this.content)) {
                        this.deselect();
                        if (node && event.target === node.dom.drag) // drag a singe node
                        Node1.onDragStart(node, event);
                        else if (!node || event.target !== node.dom.field && event.target !== node.dom.value && event.target !== node.dom.select) // select multiple nodes
                        this._onMultiSelectStart(event);
                    }
                    if (node) node.onEvent(event);
                };
                /**
 * Update TreePath components
 * @param {Array<Node>} pathNodes list of nodes in path from root to selection
 * @private
 */ treemode._updateTreePath = function(pathNodes) {
                    if (pathNodes && pathNodes.length) {
                        (0, util.removeClassName)(this.navBar, "nav-bar-empty");
                        var pathObjs = [];
                        pathNodes.forEach(function(node) {
                            var pathObj = {
                                name: getName(node),
                                node: node,
                                children: []
                            };
                            if (node.childs && node.childs.length) node.childs.forEach(function(childNode) {
                                pathObj.children.push({
                                    name: getName(childNode),
                                    node: childNode
                                });
                            });
                            pathObjs.push(pathObj);
                        });
                        this.treePath.setPath(pathObjs);
                    } else (0, util.addClassName)(this.navBar, "nav-bar-empty");
                    function getName(node) {
                        return node.parent ? node.parent.type === "array" ? node.index : node.field : node.field || node.type;
                    }
                };
                /**
 * Callback for tree path section selection - focus the selected node in the tree
 * @param {Object} pathObj path object that was represents the selected section node
 * @private
 */ treemode._onTreePathSectionSelected = function(pathObj) {
                    if (pathObj && pathObj.node) {
                        pathObj.node.expandTo();
                        pathObj.node.focus();
                    }
                };
                /**
 * Callback for tree path menu item selection - rebuild the path accrding to the new selection and focus the selected node in the tree
 * @param {Object} pathObj path object that was represents the parent section node
 * @param {String} selection selected section child
 * @private
 */ treemode._onTreePathMenuItemSelected = function(pathObj, selection) {
                    if (pathObj && pathObj.children.length) {
                        var selectionObj = pathObj.children.find(function(obj) {
                            return obj.name === selection;
                        });
                        if (selectionObj && selectionObj.node) {
                            this._updateTreePath(selectionObj.node.getNodePath());
                            selectionObj.node.expandTo();
                            selectionObj.node.focus();
                        }
                    }
                };
                treemode._startDragDistance = function(event) {
                    this.dragDistanceEvent = {
                        initialTarget: event.target,
                        initialPageX: event.pageX,
                        initialPageY: event.pageY,
                        dragDistance: 0,
                        hasMoved: false
                    };
                };
                treemode._updateDragDistance = function(event) {
                    if (!this.dragDistanceEvent) this._startDragDistance(event);
                    var diffX = event.pageX - this.dragDistanceEvent.initialPageX;
                    var diffY = event.pageY - this.dragDistanceEvent.initialPageY;
                    this.dragDistanceEvent.dragDistance = Math.sqrt(diffX * diffX + diffY * diffY);
                    this.dragDistanceEvent.hasMoved = this.dragDistanceEvent.hasMoved || this.dragDistanceEvent.dragDistance > 10;
                    event.dragDistance = this.dragDistanceEvent.dragDistance;
                    event.hasMoved = this.dragDistanceEvent.hasMoved;
                    return event.dragDistance;
                };
                /**
 * Start multi selection of nodes by dragging the mouse
 * @param {MouseEvent} event
 * @private
 */ treemode._onMultiSelectStart = function(event) {
                    var node = Node1.getNodeFromTarget(event.target);
                    if (this.options.mode !== "tree" || this.options.onEditable !== undefined) // dragging not allowed in modes 'view' and 'form'
                    // TODO: allow multiselection of items when option onEditable is specified
                    return;
                    this.multiselection = {
                        start: node || null,
                        end: null,
                        nodes: []
                    };
                    this._startDragDistance(event);
                    var editor = this;
                    if (!this.mousemove) this.mousemove = (0, util.addEventListener)(event.view, "mousemove", function(event) {
                        editor._onMultiSelect(event);
                    });
                    if (!this.mouseup) this.mouseup = (0, util.addEventListener)(event.view, "mouseup", function(event) {
                        editor._onMultiSelectEnd(event);
                    });
                    event.preventDefault();
                };
                /**
 * Multiselect nodes by dragging
 * @param {MouseEvent} event
 * @private
 */ treemode._onMultiSelect = function(event) {
                    event.preventDefault();
                    this._updateDragDistance(event);
                    if (!event.hasMoved) return;
                    var node = Node1.getNodeFromTarget(event.target);
                    if (node) {
                        if (this.multiselection.start == null) this.multiselection.start = node;
                        this.multiselection.end = node;
                    }
                    // deselect previous selection
                    this.deselect();
                    // find the selected nodes in the range from first to last
                    var start = this.multiselection.start;
                    var end = this.multiselection.end || this.multiselection.start;
                    if (start && end) {
                        // find the top level childs, all having the same parent
                        this.multiselection.nodes = this._findTopLevelNodes(start, end);
                        if (this.multiselection.nodes && this.multiselection.nodes.length) {
                            var firstNode = this.multiselection.nodes[0];
                            if (this.multiselection.start === firstNode || this.multiselection.start.isDescendantOf(firstNode)) this.multiselection.direction = "down";
                            else this.multiselection.direction = "up";
                        }
                        this.select(this.multiselection.nodes);
                    }
                };
                /**
 * End of multiselect nodes by dragging
 * @param {MouseEvent} event
 * @private
 */ treemode._onMultiSelectEnd = function(event) {
                    // set focus to the context menu button of the first node
                    var firstNode = this.multiselection.nodes[0];
                    if (firstNode && firstNode.dom.menu) firstNode.dom.menu.focus();
                    this.multiselection.start = null;
                    this.multiselection.end = null;
                    // cleanup global event listeners
                    if (this.mousemove) {
                        (0, util.removeEventListener)(event.view, "mousemove", this.mousemove);
                        delete this.mousemove;
                    }
                    if (this.mouseup) {
                        (0, util.removeEventListener)(event.view, "mouseup", this.mouseup);
                        delete this.mouseup;
                    }
                };
                /**
 * deselect currently selected nodes
 * @param {boolean} [clearStartAndEnd=false]  If true, the `start` and `end`
 *                                            state is cleared too.
 */ treemode.deselect = function(clearStartAndEnd) {
                    var selectionChanged = !!this.multiselection.nodes.length;
                    this.multiselection.nodes.forEach(function(node) {
                        node.setSelected(false);
                    });
                    this.multiselection.nodes = [];
                    if (clearStartAndEnd) {
                        this.multiselection.start = null;
                        this.multiselection.end = null;
                    }
                    if (selectionChanged) {
                        if (this._selectionChangedHandler) this._selectionChangedHandler();
                    }
                };
                /**
 * select nodes
 * @param {Node[] | Node} nodes
 */ treemode.select = function(nodes) {
                    if (!Array.isArray(nodes)) return this.select([
                        nodes
                    ]);
                    if (nodes) {
                        this.deselect();
                        this.multiselection.nodes = nodes.slice(0);
                        var first = nodes[0];
                        nodes.forEach(function(node) {
                            node.expandPathToNode();
                            node.setSelected(true, node === first);
                        });
                        if (this._selectionChangedHandler) {
                            var selection = this.getSelection();
                            this._selectionChangedHandler(selection.start, selection.end);
                        }
                    }
                };
                /**
 * From two arbitrary selected nodes, find their shared parent node.
 * From that parent node, select the two child nodes in the brances going to
 * nodes `start` and `end`, and select all childs in between.
 * @param {Node} start
 * @param {Node} end
 * @return {Array.<Node>} Returns an ordered list with child nodes
 * @private
 */ treemode._findTopLevelNodes = function(start, end) {
                    var startPath = start.getNodePath();
                    var endPath = end.getNodePath();
                    var i = 0;
                    while(i < startPath.length && startPath[i] === endPath[i])i++;
                    var root = startPath[i - 1];
                    var startChild = startPath[i];
                    var endChild = endPath[i];
                    if (!startChild || !endChild) {
                        if (root.parent) {
                            // startChild is a parent of endChild or vice versa
                            startChild = root;
                            endChild = root;
                            root = root.parent;
                        } else {
                            // we have selected the root node (which doesn't have a parent)
                            startChild = root.childs[0];
                            endChild = root.childs[root.childs.length - 1];
                        }
                    }
                    if (root && startChild && endChild) {
                        var startIndex = root.childs.indexOf(startChild);
                        var endIndex = root.childs.indexOf(endChild);
                        var firstIndex = Math.min(startIndex, endIndex);
                        var lastIndex = Math.max(startIndex, endIndex);
                        return root.childs.slice(firstIndex, lastIndex + 1);
                    } else return [];
                };
                /**
 * Show autocomplete menu
 * @param {HTMLElement} element
 * @private
 */ treemode._showAutoComplete = function(element) {
                    var node = Node1.getNodeFromTarget(element);
                    var jsonElementType = "";
                    if (element.className.indexOf("jsoneditor-value") >= 0) jsonElementType = "value";
                    if (element.className.indexOf("jsoneditor-field") >= 0) jsonElementType = "field";
                    if (jsonElementType === "") // Unknown element field. Could be a button or something else
                    return;
                    var self1 = this;
                    setTimeout(function() {
                        if (node && (self1.options.autocomplete.trigger === "focus" || element.innerText.length > 0)) {
                            var result = self1.options.autocomplete.getOptions(element.innerText, node.getPath(), jsonElementType, node.editor);
                            if (result === null) self1.autocomplete.hideDropDown();
                            else if (typeof result.then === "function") // probably a promise
                            result.then(function(obj) {
                                if (obj === null) self1.autocomplete.hideDropDown();
                                else if (obj.options) self1.autocomplete.show(element, obj.startFrom, obj.options);
                                else self1.autocomplete.show(element, 0, obj);
                            })["catch"](function(err) {
                                console.error(err);
                            });
                            else // definitely not a promise
                            if (result.options) self1.autocomplete.show(element, result.startFrom, result.options);
                            else self1.autocomplete.show(element, 0, result);
                        } else self1.autocomplete.hideDropDown();
                    }, 50);
                };
                /**
 * Event handler for keydown. Handles shortcut keys
 * @param {Event} event
 * @private
 */ treemode._onKeyDown = function(event) {
                    var keynum = event.which || event.keyCode;
                    var altKey = event.altKey;
                    var ctrlKey = event.ctrlKey;
                    var metaKey = event.metaKey;
                    var shiftKey = event.shiftKey;
                    var handled = false;
                    var currentTarget = this.focusTarget;
                    if (keynum === 9) {
                        // Tab or Shift+Tab
                        var me = this;
                        setTimeout(function() {
                            /*
          - Checking for change in focusTarget
          - Without the check,
            pressing tab after reaching the final DOM element in the editor will
            set the focus back to it than passing focus outside the editor
      */ if (me.focusTarget !== currentTarget) // select all text when moving focus to an editable div
                            (0, util.selectContentEditable)(me.focusTarget);
                        }, 0);
                    }
                    if (this.searchBox) {
                        if (ctrlKey && keynum === 70) {
                            // Ctrl+F
                            this.searchBox.dom.search.focus();
                            this.searchBox.dom.search.select();
                            handled = true;
                        } else if (keynum === 114 || ctrlKey && keynum === 71) {
                            // F3 or Ctrl+G
                            var focus = true;
                            if (!shiftKey) // select next search result (F3 or Ctrl+G)
                            this.searchBox.next(focus);
                            else // select previous search result (Shift+F3 or Ctrl+Shift+G)
                            this.searchBox.previous(focus);
                            handled = true;
                        }
                    }
                    if (this.history) {
                        if (ctrlKey && !shiftKey && keynum === 90) {
                            // Ctrl+Z
                            // undo
                            this._onUndo();
                            handled = true;
                        } else if (ctrlKey && shiftKey && keynum === 90) {
                            // Ctrl+Shift+Z
                            // redo
                            this._onRedo();
                            handled = true;
                        }
                    }
                    if (this.options.autocomplete && !handled) {
                        if (!ctrlKey && !altKey && !metaKey && (event.key.length === 1 || keynum === 8 || keynum === 46)) {
                            handled = false;
                            // Activate autocomplete
                            this._showAutoComplete(event.target);
                        }
                    }
                    if (handled) {
                        event.preventDefault();
                        event.stopPropagation();
                    }
                };
                /**
 * Create main table
 * @private
 */ treemode._createTable = function() {
                    if (this.options.navigationBar) (0, util.addClassName)(this.contentOuter, "has-nav-bar");
                    this.scrollableContent = document.createElement("div");
                    this.scrollableContent.className = "jsoneditor-tree";
                    this.contentOuter.appendChild(this.scrollableContent);
                    // the jsoneditor-tree-inner div with bottom padding is here to
                    // keep space for the action menu dropdown. It's created as a
                    // separate div instead of using scrollableContent to work around
                    // and issue in the Chrome browser showing scrollable contents outside of the div
                    // see https://github.com/josdejong/jsoneditor/issues/557
                    this.content = document.createElement("div");
                    this.content.className = "jsoneditor-tree-inner";
                    this.scrollableContent.appendChild(this.content);
                    this.table = document.createElement("table");
                    this.table.className = "jsoneditor-tree";
                    this.content.appendChild(this.table);
                    // create colgroup where the first two columns don't have a fixed
                    // width, and the edit columns do have a fixed width
                    var col;
                    this.colgroupContent = document.createElement("colgroup");
                    if (this.options.mode === "tree") {
                        col = document.createElement("col");
                        col.width = "24px";
                        this.colgroupContent.appendChild(col);
                    }
                    col = document.createElement("col");
                    col.width = "24px";
                    this.colgroupContent.appendChild(col);
                    col = document.createElement("col");
                    this.colgroupContent.appendChild(col);
                    this.table.appendChild(this.colgroupContent);
                    this.tbody = document.createElement("tbody");
                    this.table.appendChild(this.tbody);
                    this.frame.appendChild(this.contentOuter);
                };
                /**
 * Show a contextmenu for this node.
 * Used for multiselection
 * @param {HTMLElement} anchor   Anchor element to attach the context menu to.
 * @param {function} [onClose]   Callback method called when the context menu
 *                               is being closed.
 */ treemode.showContextMenu = function(anchor, onClose) {
                    var items = [];
                    var selectedNodes = this.multiselection.nodes.slice();
                    // create duplicate button
                    items.push({
                        text: (0, i18n /* translate */ .Iu)("duplicateText"),
                        title: (0, i18n /* translate */ .Iu)("duplicateTitle"),
                        className: "jsoneditor-duplicate",
                        click: function click() {
                            Node1.onDuplicate(selectedNodes);
                        }
                    });
                    // create remove button
                    items.push({
                        text: (0, i18n /* translate */ .Iu)("remove"),
                        title: (0, i18n /* translate */ .Iu)("removeTitle"),
                        className: "jsoneditor-remove",
                        click: function click() {
                            Node1.onRemove(selectedNodes);
                        }
                    });
                    if (this.options.onCreateMenu) {
                        var paths = selectedNodes.map(function(node) {
                            return node.getPath();
                        });
                        items = this.options.onCreateMenu(items, {
                            type: "multiple",
                            path: paths[0],
                            paths: paths
                        });
                    }
                    var menu = new ContextMenu /* ContextMenu */ .x(items, {
                        close: onClose
                    });
                    menu.show(anchor, this.getPopupAnchor());
                };
                treemode.getPopupAnchor = function() {
                    return this.options.popupAnchor || this.frame;
                };
                /**
 * Get current selected nodes
 * @return {{start:SerializableNode, end: SerializableNode}}
 */ treemode.getSelection = function() {
                    var selection = {
                        start: null,
                        end: null
                    };
                    if (this.multiselection.nodes && this.multiselection.nodes.length) {
                        if (this.multiselection.nodes.length) {
                            var selection1 = this.multiselection.nodes[0];
                            var selection2 = this.multiselection.nodes[this.multiselection.nodes.length - 1];
                            if (this.multiselection.direction === "down") {
                                selection.start = selection1.serialize();
                                selection.end = selection2.serialize();
                            } else {
                                selection.start = selection2.serialize();
                                selection.end = selection1.serialize();
                            }
                        }
                    }
                    return selection;
                };
                /**
 * Callback registration for selection change
 * @param {selectionCallback} callback
 *
 * @callback selectionCallback
 */ treemode.onSelectionChange = function(callback) {
                    if (typeof callback === "function") this._selectionChangedHandler = (0, util.debounce)(callback, this.DEBOUNCE_INTERVAL);
                };
                /**
 * Select range of nodes.
 * For selecting single node send only the start parameter
 * For clear the selection do not send any parameter
 * If the nodes are not from the same level the first common parent will be selected
 * @param {{path: Array.<String>}} start object contains the path for selection start
 * @param {{path: Array.<String>}} end object contains the path for selection end
 */ treemode.setSelection = function(start, end) {
                    // check for old usage
                    if (start && start.dom && start.range) {
                        console.warn("setSelection/getSelection usage for text selection is deprecated and should not be used, see documentation for supported selection options");
                        this.setDomSelection(start);
                    }
                    var nodes = this._getNodeInstancesByRange(start, end);
                    nodes.forEach(function(node) {
                        node.expandTo();
                    });
                    this.select(nodes);
                };
                /**
 * Returns a set of Nodes according to a range of selection
 * @param {{path: Array.<String>}} start object contains the path for range start
 * @param {{path: Array.<String>}=} end object contains the path for range end
 * @return {Array.<Node>} Node instances on the given range
 * @private
 */ treemode._getNodeInstancesByRange = function(start, end) {
                    var startNode, endNode;
                    if (start && start.path) {
                        startNode = this.node.findNodeByPath(start.path);
                        if (end && end.path) endNode = this.node.findNodeByPath(end.path);
                    }
                    var nodes = [];
                    if (startNode instanceof Node1) {
                        if (endNode instanceof Node1 && endNode !== startNode) {
                            if (startNode.parent === endNode.parent) {
                                if (startNode.getIndex() < endNode.getIndex()) {
                                    start = startNode;
                                    end = endNode;
                                } else {
                                    start = endNode;
                                    end = startNode;
                                }
                                var current = start;
                                nodes.push(current);
                                do {
                                    current = current.nextSibling();
                                    nodes.push(current);
                                }while (current && current !== end);
                            } else nodes = this._findTopLevelNodes(startNode, endNode);
                        } else nodes.push(startNode);
                    }
                    return nodes;
                };
                treemode.getNodesByRange = function(start, end) {
                    var nodes = this._getNodeInstancesByRange(start, end);
                    var serializableNodes = [];
                    nodes.forEach(function(node) {
                        serializableNodes.push(node.serialize());
                    });
                    return serializableNodes;
                };
                // define modes
                var treeModeMixins = [
                    {
                        mode: "tree",
                        mixin: treemode,
                        data: "json"
                    },
                    {
                        mode: "view",
                        mixin: treemode,
                        data: "json"
                    },
                    {
                        mode: "form",
                        mixin: treemode,
                        data: "json"
                    }
                ];
            /***/ },
            /***/ 744: /***/ function(__unused_webpack_module, exports, __webpack_require__) {
                exports.tryRequireAjv = function() {
                    try {
                        return __webpack_require__(Object(function webpackMissingModule() {
                            var e = new Error("Cannot find module 'ajv'");
                            e.code = "MODULE_NOT_FOUND";
                            throw e;
                        }()));
                    } catch (err) {
                    // no problem... when we need Ajv we will throw a neat exception
                    }
                };
            /***/ },
            /***/ 49: /***/ function(__unused_webpack_module, exports, __webpack_require__) {
                exports.O = function() {
                    try {
                        __webpack_require__(864);
                    } catch (err) {
                        console.error(err);
                    }
                };
            /***/ },
            /***/ 791: /***/ function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {
                "use strict";
                __webpack_require__.r(__webpack_exports__);
                /* harmony export */ __webpack_require__.d(__webpack_exports__, {
                    /* harmony export */ "addClassName": function() {
                        return /* binding */ addClassName;
                    },
                    /* harmony export */ "addEventListener": function() {
                        return /* binding */ addEventListener;
                    },
                    /* harmony export */ "asyncExec": function() {
                        return /* binding */ asyncExec;
                    },
                    /* harmony export */ "clear": function() {
                        return /* binding */ clear;
                    },
                    /* harmony export */ "compileJSONPointer": function() {
                        return /* binding */ compileJSONPointer;
                    },
                    /* harmony export */ "contains": function() {
                        return /* binding */ contains;
                    },
                    /* harmony export */ "debounce": function() {
                        return /* binding */ debounce;
                    },
                    /* harmony export */ "escapeUnicodeChars": function() {
                        return /* binding */ escapeUnicodeChars;
                    },
                    /* harmony export */ "extend": function() {
                        return /* binding */ extend;
                    },
                    /* harmony export */ "findUniqueName": function() {
                        return /* binding */ findUniqueName;
                    },
                    /* harmony export */ "formatSize": function() {
                        return /* binding */ formatSize;
                    },
                    /* harmony export */ "get": function() {
                        return /* binding */ get;
                    },
                    /* harmony export */ "getAbsoluteLeft": function() {
                        return /* binding */ getAbsoluteLeft;
                    },
                    /* harmony export */ "getAbsoluteTop": function() {
                        return /* binding */ getAbsoluteTop;
                    },
                    /* harmony export */ "getChildPaths": function() {
                        return /* binding */ getChildPaths;
                    },
                    /* harmony export */ "getColorCSS": function() {
                        return /* binding */ getColorCSS;
                    },
                    /* harmony export */ "getIndexForPosition": function() {
                        return /* binding */ getIndexForPosition;
                    },
                    /* harmony export */ "getInnerText": function() {
                        return /* binding */ getInnerText;
                    },
                    /* harmony export */ "getInputSelection": function() {
                        return /* binding */ getInputSelection;
                    },
                    /* harmony export */ "getInternetExplorerVersion": function() {
                        return /* binding */ getInternetExplorerVersion;
                    },
                    /* harmony export */ "getPositionForPath": function() {
                        return /* binding */ getPositionForPath;
                    },
                    /* harmony export */ "getSelection": function() {
                        return /* binding */ getSelection;
                    },
                    /* harmony export */ "getSelectionOffset": function() {
                        return /* binding */ getSelectionOffset;
                    },
                    /* harmony export */ "getType": function() {
                        return /* binding */ getType;
                    },
                    /* harmony export */ "getWindow": function() {
                        return /* binding */ getWindow;
                    },
                    /* harmony export */ "hasParentNode": function() {
                        return /* binding */ hasParentNode;
                    },
                    /* harmony export */ "improveSchemaError": function() {
                        return /* binding */ improveSchemaError;
                    },
                    /* harmony export */ "insideRect": function() {
                        return /* binding */ insideRect;
                    },
                    /* harmony export */ "isArray": function() {
                        return /* binding */ isArray;
                    },
                    /* harmony export */ "isChildOf": function() {
                        return /* binding */ isChildOf;
                    },
                    /* harmony export */ "isFirefox": function() {
                        return /* binding */ isFirefox;
                    },
                    /* harmony export */ "isObject": function() {
                        return /* binding */ isObject;
                    },
                    /* harmony export */ "isPromise": function() {
                        return /* binding */ isPromise;
                    },
                    /* harmony export */ "isTimestamp": function() {
                        return /* binding */ isTimestamp;
                    },
                    /* harmony export */ "isUrl": function() {
                        return /* binding */ isUrl;
                    },
                    /* harmony export */ "isValidColor": function() {
                        return /* binding */ isValidColor;
                    },
                    /* harmony export */ "isValidValidationError": function() {
                        return /* binding */ isValidValidationError;
                    },
                    /* harmony export */ "isValidationErrorChanged": function() {
                        return /* binding */ isValidationErrorChanged;
                    },
                    /* harmony export */ "limitCharacters": function() {
                        return /* binding */ limitCharacters;
                    },
                    /* harmony export */ "makeFieldTooltip": function() {
                        return /* binding */ makeFieldTooltip;
                    },
                    /* harmony export */ "parse": function() {
                        return /* binding */ parse;
                    },
                    /* harmony export */ "parsePath": function() {
                        return /* binding */ parsePath;
                    },
                    /* harmony export */ "parseString": function() {
                        return /* binding */ parseString;
                    },
                    /* harmony export */ "removeAllClassNames": function() {
                        return /* binding */ removeAllClassNames;
                    },
                    /* harmony export */ "removeClassName": function() {
                        return /* binding */ removeClassName;
                    },
                    /* harmony export */ "removeEventListener": function() {
                        return /* binding */ removeEventListener;
                    },
                    /* harmony export */ "removeReturnsAndSurroundingWhitespace": function() {
                        return /* binding */ removeReturnsAndSurroundingWhitespace;
                    },
                    /* harmony export */ "selectContentEditable": function() {
                        return /* binding */ selectContentEditable;
                    },
                    /* harmony export */ "setEndOfContentEditable": function() {
                        return /* binding */ setEndOfContentEditable;
                    },
                    /* harmony export */ "setSelection": function() {
                        return /* binding */ setSelection;
                    },
                    /* harmony export */ "setSelectionOffset": function() {
                        return /* binding */ setSelectionOffset;
                    },
                    /* harmony export */ "sort": function() {
                        return /* binding */ sort;
                    },
                    /* harmony export */ "sortObjectKeys": function() {
                        return /* binding */ sortObjectKeys;
                    },
                    /* harmony export */ "stringifyPath": function() {
                        return /* binding */ stringifyPath;
                    },
                    /* harmony export */ "stripFormatting": function() {
                        return /* binding */ stripFormatting;
                    },
                    /* harmony export */ "textDiff": function() {
                        return /* binding */ textDiff;
                    },
                    /* harmony export */ "tryJsonRepair": function() {
                        return /* binding */ tryJsonRepair;
                    },
                    /* harmony export */ "uniqueMergeArrays": function() {
                        return /* binding */ uniqueMergeArrays;
                    },
                    /* harmony export */ "validate": function() {
                        return /* binding */ validate;
                    }
                });
                /* harmony import */ var _polyfills__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(987);
                /* harmony import */ var _polyfills__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/ __webpack_require__.n(_polyfills__WEBPACK_IMPORTED_MODULE_0__);
                /* harmony import */ var javascript_natural_sort__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(233);
                /* harmony import */ var javascript_natural_sort__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/ __webpack_require__.n(javascript_natural_sort__WEBPACK_IMPORTED_MODULE_1__);
                /* harmony import */ var jsonrepair__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(262);
                /* harmony import */ var _assets_jsonlint_jsonlint__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(589);
                /* harmony import */ var json_source_map__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26);
                /* harmony import */ var _i18n__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(907);
                function _toConsumableArray(arr) {
                    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
                }
                function _nonIterableSpread() {
                    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                }
                function _unsupportedIterableToArray(o, minLen) {
                    if (!o) return;
                    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
                    var n = Object.prototype.toString.call(o).slice(8, -1);
                    if (n === "Object" && o.constructor) n = o.constructor.name;
                    if (n === "Map" || n === "Set") return Array.from(o);
                    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
                }
                function _iterableToArray(iter) {
                    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
                }
                function _arrayWithoutHoles(arr) {
                    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
                }
                function _arrayLikeToArray(arr, len) {
                    if (len == null || len > arr.length) len = arr.length;
                    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
                    return arr2;
                }
                function _typeof(obj) {
                    "@babel/helpers - typeof";
                    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
                        return typeof obj;
                    } : function(obj) {
                        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
                    }, _typeof(obj);
                }
                var MAX_ITEMS_FIELDS_COLLECTION = 10000;
                var YEAR_2000 = 946684800000;
                /**
 * Parse JSON using the parser built-in in the browser.
 * On exception, the jsonString is validated and a detailed error is thrown.
 * @param {String} jsonString
 * @return {JSON} json
 */ function parse(jsonString) {
                    try {
                        return JSON.parse(jsonString);
                    } catch (err) {
                        // try to throw a more detailed error message using validate
                        validate(jsonString);
                        // rethrow the original error
                        throw err;
                    }
                }
                /**
 * Try to fix the JSON string. If not successful, return the original string
 * @param {string} jsonString
 */ function tryJsonRepair(jsonString) {
                    try {
                        return (0, jsonrepair__WEBPACK_IMPORTED_MODULE_5__ /* .jsonrepair */ .K)(jsonString);
                    } catch (err) {
                        // repair was not successful, return original text
                        return jsonString;
                    }
                }
                /**
 * Escape unicode characters.
 * For example input '\u2661' (length 1) will output '\\u2661' (length 5).
 * @param {string} text
 * @return {string}
 */ function escapeUnicodeChars(// see https://www.wikiwand.com/en/UTF-16
                text) {
                    return(// note: we leave surrogate pairs as two individual chars,
                    // as JSON doesn't interpret them as a single unicode char.
                    text.replace(/[\u007F-\uFFFF]/g, function(c) {
                        return "\\u" + ("0000" + c.charCodeAt(0).toString(16)).slice(-4);
                    }));
                }
                /**
 * Validate a string containing a JSON object
 * This method uses JSONLint to validate the String. If JSONLint is not
 * available, the built-in JSON parser of the browser is used.
 * @param {String} jsonString   String with an (invalid) JSON object
 * @throws Error
 */ function validate(jsonString) {
                    if (typeof _assets_jsonlint_jsonlint__WEBPACK_IMPORTED_MODULE_2__ !== "undefined") _assets_jsonlint_jsonlint__WEBPACK_IMPORTED_MODULE_2__.parse(jsonString);
                    else JSON.parse(jsonString);
                }
                /**
 * Extend object a with the properties of object b
 * @param {Object} a
 * @param {Object} b
 * @return {Object} a
 */ function extend(a, b) {
                    for(var prop in b)if (hasOwnProperty1(b, prop)) a[prop] = b[prop];
                    return a;
                }
                /**
 * Remove all properties from object a
 * @param {Object} a
 * @return {Object} a
 */ function clear(a) {
                    for(var prop in a)if (hasOwnProperty1(a, prop)) delete a[prop];
                    return a;
                }
                /**
 * Get the type of an object
 * @param {*} object
 * @return {String} type
 */ function getType(object) {
                    if (object === null) return "null";
                    if (object === undefined) return "undefined";
                    if (object instanceof Number || typeof object === "number") return "number";
                    if (object instanceof String || typeof object === "string") return "string";
                    if (object instanceof Boolean || typeof object === "boolean") return "boolean";
                    if (object instanceof RegExp) return "regexp";
                    if (isArray(object)) return "array";
                    return "object";
                }
                /**
 * Test whether a text contains a url (matches when a string starts
 * with 'http://*' or 'https://*' and has no whitespace characters)
 * @param {String} text
 */ var isUrlRegex = /^https?:\/\/\S+$/;
                function isUrl(text) {
                    return (typeof text === "string" || text instanceof String) && isUrlRegex.test(text);
                }
                /**
 * Tes whether given object is an Array
 * @param {*} obj
 * @returns {boolean} returns true when obj is an array
 */ function isArray(obj) {
                    return Object.prototype.toString.call(obj) === "[object Array]";
                }
                /**
 * Gets a DOM element's Window.  This is normally just the global `window`
 * variable, but if we opened a child window, it may be different.
 * @param {HTMLElement} element
 * @return {Window}
 */ function getWindow(element) {
                    return element.ownerDocument.defaultView;
                }
                /**
 * Retrieve the absolute left value of a DOM element
 * @param {Element} elem    A dom element, for example a div
 * @return {Number} left    The absolute left position of this element
 *                          in the browser page.
 */ function getAbsoluteLeft(elem) {
                    var rect = elem.getBoundingClientRect();
                    return rect.left + window.pageXOffset || document.scrollLeft || 0;
                }
                /**
 * Retrieve the absolute top value of a DOM element
 * @param {Element} elem    A dom element, for example a div
 * @return {Number} top     The absolute top position of this element
 *                          in the browser page.
 */ function getAbsoluteTop(elem) {
                    var rect = elem.getBoundingClientRect();
                    return rect.top + window.pageYOffset || document.scrollTop || 0;
                }
                /**
 * add a className to the given elements style
 * @param {Element} elem
 * @param {String} className
 */ function addClassName(elem, className) {
                    var classes = elem.className.split(" ");
                    if (classes.indexOf(className) === -1) {
                        classes.push(className); // add the class to the array
                        elem.className = classes.join(" ");
                    }
                }
                /**
 * remove all classes from the given elements style
 * @param {Element} elem
 */ function removeAllClassNames(elem) {
                    elem.className = "";
                }
                /**
 * add a className to the given elements style
 * @param {Element} elem
 * @param {String} className
 */ function removeClassName(elem, className) {
                    var classes = elem.className.split(" ");
                    var index = classes.indexOf(className);
                    if (index !== -1) {
                        classes.splice(index, 1); // remove the class from the array
                        elem.className = classes.join(" ");
                    }
                }
                /**
 * Strip the formatting from the contents of a div
 * the formatting from the div itself is not stripped, only from its childs.
 * @param {Element} divElement
 */ function stripFormatting(divElement) {
                    var childs = divElement.childNodes;
                    for(var i = 0, iMax = childs.length; i < iMax; i++){
                        var child = childs[i];
                        // remove the style
                        if (child.style) // TODO: test if child.attributes does contain style
                        child.removeAttribute("style");
                        // remove all attributes
                        var attributes = child.attributes;
                        if (attributes) for(var j = attributes.length - 1; j >= 0; j--){
                            var attribute = attributes[j];
                            if (attribute.specified === true) child.removeAttribute(attribute.name);
                        }
                        // recursively strip childs
                        stripFormatting(child);
                    }
                }
                /**
 * Set focus to the end of an editable div
 * code from Nico Burns
 * http://stackoverflow.com/users/140293/nico-burns
 * http://stackoverflow.com/questions/1125292/how-to-move-cursor-to-end-of-contenteditable-entity
 * @param {Element} contentEditableElement   A content editable div
 */ function setEndOfContentEditable(contentEditableElement) {
                    var range, selection;
                    if (document.createRange) {
                        range = document.createRange(); // Create a range (a range is a like the selection but invisible)
                        range.selectNodeContents(contentEditableElement); // Select the entire contents of the element with the range
                        range.collapse(false); // collapse the range to the end point. false means collapse to end rather than the start
                        selection = window.getSelection(); // get the selection object (allows you to change selection)
                        selection.removeAllRanges(); // remove any selections already made
                        selection.addRange(range); // make the range you have just created the visible selection
                    }
                }
                /**
 * Select all text of a content editable div.
 * http://stackoverflow.com/a/3806004/1262753
 * @param {Element} contentEditableElement   A content editable div
 */ function selectContentEditable(contentEditableElement) {
                    if (!contentEditableElement || contentEditableElement.nodeName !== "DIV") return;
                    var sel, range;
                    if (window.getSelection && document.createRange) {
                        range = document.createRange();
                        range.selectNodeContents(contentEditableElement);
                        sel = window.getSelection();
                        sel.removeAllRanges();
                        sel.addRange(range);
                    }
                }
                /**
 * Get text selection
 * http://stackoverflow.com/questions/4687808/contenteditable-selected-text-save-and-restore
 * @return {Range | TextRange | null} range
 */ function getSelection() {
                    if (window.getSelection) {
                        var sel = window.getSelection();
                        if (sel.getRangeAt && sel.rangeCount) return sel.getRangeAt(0);
                    }
                    return null;
                }
                /**
 * Set text selection
 * http://stackoverflow.com/questions/4687808/contenteditable-selected-text-save-and-restore
 * @param {Range | TextRange | null} range
 */ function setSelection(range) {
                    if (range) {
                        if (window.getSelection) {
                            var sel = window.getSelection();
                            sel.removeAllRanges();
                            sel.addRange(range);
                        }
                    }
                }
                /**
 * Get selected text range
 * @return {Object} params  object containing parameters:
 *                              {Number}  startOffset
 *                              {Number}  endOffset
 *                              {Element} container  HTML element holding the
 *                                                   selected text element
 *                          Returns null if no text selection is found
 */ function getSelectionOffset() {
                    var range = getSelection();
                    if (range && "startOffset" in range && "endOffset" in range && range.startContainer && range.startContainer === range.endContainer) return {
                        startOffset: range.startOffset,
                        endOffset: range.endOffset,
                        container: range.startContainer.parentNode
                    };
                    return null;
                }
                /**
 * Set selected text range in given element
 * @param {Object} params   An object containing:
 *                              {Element} container
 *                              {Number} startOffset
 *                              {Number} endOffset
 */ function setSelectionOffset(params) {
                    if (document.createRange && window.getSelection) {
                        var selection = window.getSelection();
                        if (selection) {
                            var range = document.createRange();
                            if (!params.container.firstChild) params.container.appendChild(document.createTextNode(""));
                            // TODO: do not suppose that the first child of the container is a textnode,
                            //       but recursively find the textnodes
                            range.setStart(params.container.firstChild, params.startOffset);
                            range.setEnd(params.container.firstChild, params.endOffset);
                            setSelection(range);
                        }
                    }
                }
                /**
 * Get the inner text of an HTML element (for example a div element)
 * @param {Element} element
 * @param {Object} [buffer]
 * @return {String} innerText
 */ function getInnerText(element, buffer) {
                    var first = buffer === undefined;
                    if (first) buffer = {
                        _text: "",
                        flush: function flush() {
                            var text = this._text;
                            this._text = "";
                            return text;
                        },
                        set: function set(text) {
                            this._text = text;
                        }
                    };
                    // text node
                    if (element.nodeValue) {
                        // remove return characters and the whitespaces surrounding those return characters
                        var trimmedValue = removeReturnsAndSurroundingWhitespace(element.nodeValue);
                        if (trimmedValue !== "") return buffer.flush() + trimmedValue;
                        else // ignore empty text
                        return "";
                    }
                    // divs or other HTML elements
                    if (element.hasChildNodes()) {
                        var childNodes = element.childNodes;
                        var innerText = "";
                        for(var i = 0, iMax = childNodes.length; i < iMax; i++){
                            var child = childNodes[i];
                            if (child.nodeName === "DIV" || child.nodeName === "P") {
                                var prevChild = childNodes[i - 1];
                                var prevName = prevChild ? prevChild.nodeName : undefined;
                                if (prevName && prevName !== "DIV" && prevName !== "P" && prevName !== "BR") {
                                    if (innerText !== "") innerText += "\n";
                                    buffer.flush();
                                }
                                innerText += getInnerText(child, buffer);
                                buffer.set("\n");
                            } else if (child.nodeName === "BR") {
                                innerText += buffer.flush();
                                buffer.set("\n");
                            } else innerText += getInnerText(child, buffer);
                        }
                        return innerText;
                    }
                    // br or unknown
                    return "";
                }
                // regular expression matching one or multiple return characters with all their
                // enclosing white spaces
                function removeReturnsAndSurroundingWhitespace(text) {
                    return text.replace(/(\b|^)\s*(\b|$)/g, function(match) {
                        return /\n/.exec(match) ? "" : match;
                    });
                }
                /**
 * Test whether an element has the provided parent node somewhere up the node tree.
 * @param {Element} elem
 * @param {Element} parent
 * @return {boolean}
 */ function hasParentNode(elem, parent) {
                    var e = elem ? elem.parentNode : undefined;
                    while(e){
                        if (e === parent) return true;
                        e = e.parentNode;
                    }
                    return false;
                }
                /**
 * Returns the version of Internet Explorer or a -1
 * (indicating the use of another browser).
 * Source: http://msdn.microsoft.com/en-us/library/ms537509(v=vs.85).aspx
 * @return {Number} Internet Explorer version, or -1 in case of an other browser
 */ function getInternetExplorerVersion() {
                    if (_ieVersion === -1) {
                        var rv = -1; // Return value assumes failure.
                        if (typeof navigator !== "undefined" && navigator.appName === "Microsoft Internet Explorer") {
                            var ua = navigator.userAgent;
                            var re = /MSIE ([0-9]+[.0-9]+)/;
                            if (re.exec(ua) != null) rv = parseFloat(RegExp.$1);
                        }
                        _ieVersion = rv;
                    }
                    return _ieVersion;
                }
                /**
 * cached internet explorer version
 * @type {Number}
 * @private
 */ var _ieVersion = -1;
                /**
 * Test whether the current browser is Firefox
 * @returns {boolean} isFirefox
 */ function isFirefox() {
                    return typeof navigator !== "undefined" && navigator.userAgent.indexOf("Firefox") !== -1;
                }
                /**
 * Add an event listener. Works for all browsers
 * @param {Element}     element    An html element
 * @param {string}      action     The action, for example "click",
 *                                 without the prefix "on"
 * @param {function}    listener   The callback function to be executed
 * @param {boolean}     [useCapture] false by default
 * @return {function}   the created event listener
 */ function addEventListener(element, action, listener, useCapture) {
                    if (element.addEventListener) {
                        if (useCapture === undefined) useCapture = false;
                        if (action === "mousewheel" && isFirefox()) action = "DOMMouseScroll"; // For Firefox
                        element.addEventListener(action, listener, useCapture);
                        return listener;
                    } else if (element.attachEvent) {
                        // Old IE browsers
                        var f = function f() {
                            return listener.call(element, window.event);
                        };
                        element.attachEvent("on" + action, f);
                        return f;
                    }
                }
                /**
 * Remove an event listener from an element
 * @param {Element}  element   An html dom element
 * @param {string}   action    The name of the event, for example "mousedown"
 * @param {function} listener  The listener function
 * @param {boolean}  [useCapture]   false by default
 */ function removeEventListener(element, action, listener, useCapture) {
                    if (element.removeEventListener) {
                        if (useCapture === undefined) useCapture = false;
                        if (action === "mousewheel" && isFirefox()) action = "DOMMouseScroll"; // For Firefox
                        element.removeEventListener(action, listener, useCapture);
                    } else if (element.detachEvent) // Old IE browsers
                    element.detachEvent("on" + action, listener);
                }
                /**
 * Test if an element is a child of a parent element.
 * @param {Element} elem
 * @param {Element} parent
 * @return {boolean} returns true if elem is a child of the parent
 */ function isChildOf(elem, parent) {
                    var e = elem.parentNode;
                    while(e){
                        if (e === parent) return true;
                        e = e.parentNode;
                    }
                    return false;
                }
                /**
 * Parse a JSON path like '.items[3].name' into an array
 * @param {string} jsonPath
 * @return {Array}
 */ function parsePath(jsonPath) {
                    var path = [];
                    var i = 0;
                    function parseProperty() {
                        var prop = "";
                        while(jsonPath[i] !== undefined && /[\w$]/.test(jsonPath[i])){
                            prop += jsonPath[i];
                            i++;
                        }
                        if (prop === "") throw new Error("Invalid JSON path: property name expected at index " + i);
                        return prop;
                    }
                    function parseIndex(end) {
                        var name = "";
                        while(jsonPath[i] !== undefined && jsonPath[i] !== end){
                            name += jsonPath[i];
                            i++;
                        }
                        if (jsonPath[i] !== end) throw new Error("Invalid JSON path: unexpected end, character " + end + " expected");
                        return name;
                    }
                    while(jsonPath[i] !== undefined){
                        if (jsonPath[i] === ".") {
                            i++;
                            path.push(parseProperty());
                        } else if (jsonPath[i] === "[") {
                            i++;
                            if (jsonPath[i] === "'" || jsonPath[i] === '"') {
                                var end = jsonPath[i];
                                i++;
                                path.push(parseIndex(end));
                                if (jsonPath[i] !== end) throw new Error("Invalid JSON path: closing quote ' expected at index " + i);
                                i++;
                            } else {
                                var index = parseIndex("]").trim();
                                if (index.length === 0) throw new Error("Invalid JSON path: array value expected at index " + i);
                                // Coerce numeric indices to numbers, but ignore star
                                index = index === "*" ? index : JSON.parse(index);
                                path.push(index);
                            }
                            if (jsonPath[i] !== "]") throw new Error("Invalid JSON path: closing bracket ] expected at index " + i);
                            i++;
                        } else throw new Error('Invalid JSON path: unexpected character "' + jsonPath[i] + '" at index ' + i);
                    }
                    return path;
                }
                /**
 * Stringify an array with a path in a JSON path like '.items[3].name'
 * @param {Array.<string | number>} path
 * @returns {string}
 */ function stringifyPath(path) {
                    return path.map(function(p) {
                        if (typeof p === "number") return "[" + p + "]";
                        else if (typeof p === "string" && p.match(/^[A-Za-z0-9_$]+$/)) return "." + p;
                        else return '["' + p + '"]';
                    }).join("");
                }
                /**
 * Improve the error message of a JSON schema error
 * @param {Object} error
 * @return {Object} The error
 */ function improveSchemaError(error) {
                    if (error.keyword === "enum" && Array.isArray(error.schema)) {
                        var enums = error.schema;
                        if (enums) {
                            enums = enums.map(function(value) {
                                return JSON.stringify(value);
                            });
                            if (enums.length > 5) {
                                var more = [
                                    "(" + (enums.length - 5) + " more...)"
                                ];
                                enums = enums.slice(0, 5);
                                enums.push(more);
                            }
                            error.message = "should be equal to one of: " + enums.join(", ");
                        }
                    }
                    if (error.keyword === "additionalProperties") error.message = "should NOT have additional property: " + error.params.additionalProperty;
                    return error;
                }
                /**
 * Test whether something is a Promise
 * @param {*} object
 * @returns {boolean} Returns true when object is a promise, false otherwise
 */ function isPromise(object) {
                    return object && typeof object.then === "function" && typeof object["catch"] === "function";
                }
                /**
 * Test whether a custom validation error has the correct structure
 * @param {*} validationError The error to be checked.
 * @returns {boolean} Returns true if the structure is ok, false otherwise
 */ function isValidValidationError(validationError) {
                    return _typeof(validationError) === "object" && Array.isArray(validationError.path) && typeof validationError.message === "string";
                }
                /**
 * Test whether the child rect fits completely inside the parent rect.
 * @param {ClientRect} parent
 * @param {ClientRect} child
 * @param {number} margin
 */ function insideRect(parent, child, margin) {
                    var _margin = margin !== undefined ? margin : 0;
                    return child.left - _margin >= parent.left && child.right + _margin <= parent.right && child.top - _margin >= parent.top && child.bottom + _margin <= parent.bottom;
                }
                /**
 * Returns a function, that, as long as it continues to be invoked, will not
 * be triggered. The function will be called after it stops being called for
 * N milliseconds.
 *
 * Source: https://davidwalsh.name/javascript-debounce-function
 *
 * @param {function} func
 * @param {number} wait                 Number in milliseconds
 * @param {boolean} [immediate=false]   If `immediate` is passed, trigger the
 *                                      function on the leading edge, instead
 *                                      of the trailing.
 * @return {function} Return the debounced function
 */ function debounce(func, wait, immediate) {
                    var timeout;
                    return function() {
                        var context = this;
                        var args = arguments;
                        var later = function later() {
                            timeout = null;
                            if (!immediate) func.apply(context, args);
                        };
                        var callNow = immediate && !timeout;
                        clearTimeout(timeout);
                        timeout = setTimeout(later, wait);
                        if (callNow) func.apply(context, args);
                    };
                }
                /**
 * Determines the difference between two texts.
 * Can only detect one removed or inserted block of characters.
 * @param {string} oldText
 * @param {string} newText
 * @return {{start: number, end: number}} Returns the start and end
 *                                        of the changed part in newText.
 */ function textDiff(oldText, newText) {
                    var len = newText.length;
                    var start = 0;
                    var oldEnd = oldText.length;
                    var newEnd = newText.length;
                    while(newText.charAt(start) === oldText.charAt(start) && start < len)start++;
                    while(newText.charAt(newEnd - 1) === oldText.charAt(oldEnd - 1) && newEnd > start && oldEnd > 0){
                        newEnd--;
                        oldEnd--;
                    }
                    return {
                        start: start,
                        end: newEnd
                    };
                }
                /**
 * Return an object with the selection range or cursor position (if both have the same value)
 * Support also old browsers (IE8-)
 * Source: http://ourcodeworld.com/articles/read/282/how-to-get-the-current-cursor-position-and-selection-within-a-text-input-or-textarea-in-javascript
 * @param {DOMElement} el A dom element of a textarea or input text.
 * @return {Object} reference Object with 2 properties (start and end) with the identifier of the location of the cursor and selected text.
 **/ function getInputSelection(el) {
                    var startIndex = 0;
                    var endIndex = 0;
                    var normalizedValue;
                    var range;
                    var textInputRange;
                    var len;
                    var endRange;
                    if (typeof el.selectionStart === "number" && typeof el.selectionEnd === "number") {
                        startIndex = el.selectionStart;
                        endIndex = el.selectionEnd;
                    } else {
                        range = document.selection.createRange();
                        if (range && range.parentElement() === el) {
                            len = el.value.length;
                            normalizedValue = el.value.replace(/\r\n/g, "\n");
                            // Create a working TextRange that lives only in the input
                            textInputRange = el.createTextRange();
                            textInputRange.moveToBookmark(range.getBookmark());
                            // Check if the startIndex and endIndex of the selection are at the very end
                            // of the input, since moveStart/moveEnd doesn't return what we want
                            // in those cases
                            endRange = el.createTextRange();
                            endRange.collapse(false);
                            if (textInputRange.compareEndPoints("StartToEnd", endRange) > -1) startIndex = endIndex = len;
                            else {
                                startIndex = -textInputRange.moveStart("character", -len);
                                startIndex += normalizedValue.slice(0, startIndex).split("\n").length - 1;
                                if (textInputRange.compareEndPoints("EndToEnd", endRange) > -1) endIndex = len;
                                else {
                                    endIndex = -textInputRange.moveEnd("character", -len);
                                    endIndex += normalizedValue.slice(0, endIndex).split("\n").length - 1;
                                }
                            }
                        }
                    }
                    return {
                        startIndex: startIndex,
                        endIndex: endIndex,
                        start: _positionForIndex(startIndex),
                        end: _positionForIndex(endIndex)
                    };
                    /**
   * Returns textarea row and column position for certain index
   * @param {Number} index text index
   * @returns {{row: Number, column: Number}}
   */ function _positionForIndex(index) {
                        var textTillIndex = el.value.substring(0, index);
                        var row = (textTillIndex.match(/\n/g) || []).length + 1;
                        var col = textTillIndex.length - textTillIndex.lastIndexOf("\n");
                        return {
                            row: row,
                            column: col
                        };
                    }
                }
                /**
 * Returns the index for certain position in text element
 * @param {DOMElement} el A dom element of a textarea or input text.
 * @param {Number} row row value, > 0, if exceeds rows number - last row will be returned
 * @param {Number} column column value, > 0, if exceeds column length - end of column will be returned
 * @returns {Number} index of position in text, -1 if not found
 */ function getIndexForPosition(el, row, column) {
                    var text = el.value || "";
                    if (row > 0 && column > 0) {
                        var rows = text.split("\n", row);
                        row = Math.min(rows.length, row);
                        column = Math.min(rows[row - 1].length, column - 1);
                        var columnCount = row === 1 ? column : column + 1; // count new line on multiple rows
                        return rows.slice(0, row - 1).join("\n").length + columnCount;
                    }
                    return -1;
                }
                /**
 * Returns location of json paths in certain json string
 * @param {String} text json string
 * @param {Array<String>} paths array of json paths
 * @returns {Array<{path: String, line: Number, row: Number}>}
 */ function getPositionForPath(text, paths) {
                    var result = [];
                    var jsmap;
                    if (!paths || !paths.length) return result;
                    try {
                        jsmap = json_source_map__WEBPACK_IMPORTED_MODULE_3__.parse(text);
                    } catch (err) {
                        return result;
                    }
                    paths.forEach(function(path) {
                        var pathArr = parsePath(path);
                        var pointerName = compileJSONPointer(pathArr);
                        var pointer = jsmap.pointers[pointerName];
                        if (pointer) result.push({
                            path: path,
                            line: pointer.key ? pointer.key.line : pointer.value ? pointer.value.line : 0,
                            column: pointer.key ? pointer.key.column : pointer.value ? pointer.value.column : 0
                        });
                    });
                    return result;
                }
                /**
 * Compile a JSON Pointer
 * WARNING: this is an incomplete implementation
 * @param {Array.<string | number>} path
 * @return {string}
 */ function compileJSONPointer(path) {
                    return path.map(function(p) {
                        return "/" + String(p).replace(/~/g, "~0").replace(/\//g, "~1");
                    }).join("");
                }
                /**
 * Get the applied color given a color name or code
 * Source: https://stackoverflow.com/questions/6386090/validating-css-color-names/33184805
 * @param {string} color
 * @returns {string | null} returns the color if the input is a valid
 *                   color, and returns null otherwise. Example output:
 *                   'rgba(255,0,0,0.7)' or 'rgb(255,0,0)'
 */ function getColorCSS(color) {
                    var ele = document.createElement("div");
                    ele.style.color = color;
                    return ele.style.color.split(/\s+/).join("").toLowerCase() || null;
                }
                /**
 * Test if a string contains a valid color name or code.
 * @param {string} color
 * @returns {boolean} returns true if a valid color, false otherwise
 */ function isValidColor(color) {
                    return !!getColorCSS(color);
                }
                /**
 * Make a tooltip for a field based on the field's schema.
 * @param {object} schema JSON schema
 * @param {string} [locale] Locale code (for example, zh-CN)
 * @returns {string} Field tooltip, may be empty string if all relevant schema properties are missing
 */ function makeFieldTooltip(schema, locale) {
                    if (!schema) return "";
                    var tooltip = "";
                    if (schema.title) tooltip += schema.title;
                    if (schema.description) {
                        if (tooltip.length > 0) tooltip += "\n";
                        tooltip += schema.description;
                    }
                    if (schema["default"]) {
                        if (tooltip.length > 0) tooltip += "\n\n";
                        tooltip += (0, _i18n__WEBPACK_IMPORTED_MODULE_4__ /* .translate */ .Iu)("default", undefined, locale) + "\n";
                        tooltip += JSON.stringify(schema["default"], null, 2);
                    }
                    if (Array.isArray(schema.examples) && schema.examples.length > 0) {
                        if (tooltip.length > 0) tooltip += "\n\n";
                        tooltip += (0, _i18n__WEBPACK_IMPORTED_MODULE_4__ /* .translate */ .Iu)("examples", undefined, locale) + "\n";
                        schema.examples.forEach(function(example, index) {
                            tooltip += JSON.stringify(example, null, 2);
                            if (index !== schema.examples.length - 1) tooltip += "\n";
                        });
                    }
                    return tooltip;
                }
                /**
 * Get a nested property from an object.
 * Returns undefined when the property does not exist.
 * @param {Object} object
 * @param {string[]} path
 * @return {*}
 */ function get(object, path) {
                    var value = object;
                    for(var i = 0; i < path.length && value !== undefined && value !== null; i++)value = value[path[i]];
                    return value;
                }
                /**
 * Find a unique name. Suffix the name with ' (copy)', '(copy 2)', etc
 * until a unique name is found
 * @param {string} name
 * @param {Array} existingPropNames    Array with existing prop names
 */ function findUniqueName(name, existingPropNames) {
                    var strippedName = name.replace(/ \(copy( \d+)?\)$/, "");
                    var validName = strippedName;
                    var i = 1;
                    while(existingPropNames.indexOf(validName) !== -1){
                        var copy = "copy" + (i > 1 ? " " + i : "");
                        validName = strippedName + " (" + copy + ")";
                        i++;
                    }
                    return validName;
                }
                /**
 * Get the child paths of an array
 * @param {JSON} json
 * @param {boolean} [includeObjects=false] If true, object and array paths are returned as well
 * @return {string[]}
 */ function getChildPaths(json, includeObjects) {
                    var pathsMap = {};
                    function getObjectChildPaths(json, pathsMap, rootPath, includeObjects) {
                        var isValue = !Array.isArray(json) && !isObject(json);
                        if (isValue || includeObjects) pathsMap[rootPath || ""] = true;
                        if (isObject(json)) Object.keys(json).forEach(function(field) {
                            getObjectChildPaths(json[field], pathsMap, rootPath + "." + field, includeObjects);
                        });
                    }
                    if (Array.isArray(json)) {
                        var max = Math.min(json.length, MAX_ITEMS_FIELDS_COLLECTION);
                        for(var i = 0; i < max; i++){
                            var item = json[i];
                            getObjectChildPaths(item, pathsMap, "", includeObjects);
                        }
                    } else pathsMap[""] = true;
                    return Object.keys(pathsMap).sort();
                }
                /**
 * Sort object keys using natural sort
 * @param {Array} array
 * @param {String} [path] JSON pointer
 * @param {'asc' | 'desc'} [direction]
 */ function sort(array, path, direction) {
                    var parsedPath = path && path !== "." ? parsePath(path) : [];
                    var sign = direction === "desc" ? -1 : 1;
                    var sortedArray = array.slice();
                    sortedArray.sort(function(a, b) {
                        var aValue = get(a, parsedPath);
                        var bValue = get(b, parsedPath);
                        return sign * (aValue > bValue ? 1 : aValue < bValue ? -1 : 0);
                    });
                    return sortedArray;
                }
                /**
 * Sort object keys using natural sort
 * @param {Object} object
 * @param {'asc' | 'desc'} [direction]
 */ function sortObjectKeys(object, direction) {
                    var sign = direction === "desc" ? -1 : 1;
                    var sortedFields = Object.keys(object).sort(function(a, b) {
                        return sign * javascript_natural_sort__WEBPACK_IMPORTED_MODULE_1___default()(a, b);
                    });
                    var sortedObject = {};
                    sortedFields.forEach(function(field) {
                        sortedObject[field] = object[field];
                    });
                    return sortedObject;
                }
                /**
 * Cast contents of a string to the correct type.
 * This can be a string, a number, a boolean, etc
 * @param {String} str
 * @return {*} castedStr
 * @private
 */ function parseString(str) {
                    if (str === "") return "";
                    var lower = str.toLowerCase();
                    if (lower === "null") return null;
                    if (lower === "true") return true;
                    if (lower === "false") return false;
                    var num = Number(str); // will nicely fail with '123ab'
                    var numFloat = parseFloat(str); // will nicely fail with '  '
                    if (!isNaN(num) && !isNaN(numFloat)) return num;
                    return str;
                }
                /**
 * Test whether some field contains a timestamp in milliseconds after the year 2000.
 * @param {string} field
 * @param {number} value
 * @return {boolean}
 */ function isTimestamp(field, value) {
                    return typeof value === "number" && value > YEAR_2000 && isFinite(value) && Math.floor(value) === value && !isNaN(new Date(value).valueOf());
                }
                /**
 * Return a human readable document size
 * For example formatSize(7570718) outputs '7.6 MB'
 * @param {number} size
 * @return {string} Returns a human readable size
 */ function formatSize(size) {
                    if (size < 900) return size.toFixed() + " B";
                    var KB = size / 1000;
                    if (KB < 900) return KB.toFixed(1) + " KB";
                    var MB = KB / 1000;
                    if (MB < 900) return MB.toFixed(1) + " MB";
                    var GB = MB / 1000;
                    if (GB < 900) return GB.toFixed(1) + " GB";
                    var TB = GB / 1000;
                    return TB.toFixed(1) + " TB";
                }
                /**
 * Limit text to a maximum number of characters
 * @param {string} text
 * @param {number} maxCharacterCount
 * @return {string} Returns the limited text,
 *                  ending with '...' if the max was exceeded
 */ function limitCharacters(text, maxCharacterCount) {
                    if (text.length <= maxCharacterCount) return text;
                    return text.slice(0, maxCharacterCount) + "...";
                }
                /**
 * Test whether a value is an Object
 * @param {*} value
 * @return {boolean}
 */ function isObject(value) {
                    return _typeof(value) === "object" && value !== null && !Array.isArray(value);
                }
                /**
 * Helper function to test whether an array contains an item
 * @param {Array} array
 * @param {*} item
 * @return {boolean} Returns true if `item` is in `array`, returns false otherwise.
 */ function contains(array, item) {
                    return array.indexOf(item) !== -1;
                }
                /**
 * Checks if validation has changed from the previous execution
 * @param {Array} currErr current validation errors
 * @param {Array} prevErr previous validation errors
 */ function isValidationErrorChanged(currErr, prevErr) {
                    if (!prevErr && !currErr) return false;
                    if (prevErr && !currErr || !prevErr && currErr) return true;
                    if (prevErr.length !== currErr.length) return true;
                    var _loop = function _loop(i) {
                        var pErr;
                        if (currErr[i].type === "error") pErr = prevErr.find(function(p) {
                            return p.line === currErr[i].line;
                        });
                        else pErr = prevErr.find(function(p) {
                            return p.dataPath === currErr[i].dataPath && p.schemaPath === currErr[i].schemaPath;
                        });
                        if (!pErr) return {
                            v: true
                        };
                    };
                    for(var i = 0; i < currErr.length; ++i){
                        var _ret = _loop(i);
                        if (_typeof(_ret) === "object") return _ret.v;
                    }
                    return false;
                }
                /**
 * Uniquely merge array of elements
 * @param {Array<string|number>} inputArray1
 * @param {Array<string|number?} inputArray2
 * @returns {Array<string|number>} an array with unique merged elements
 */ function uniqueMergeArrays(inputArray1, inputArray2) {
                    var arr1 = inputArray1 !== null && inputArray1 !== void 0 && inputArray1.length ? inputArray1 : [];
                    var arr2 = inputArray2 !== null && inputArray2 !== void 0 && inputArray2.length ? inputArray2 : [];
                    return _toConsumableArray(new Set(arr1.concat(arr2)));
                }
                function asyncExec(callback) {
                    setTimeout(callback);
                }
                function hasOwnProperty1(object, key) {
                    return Object.prototype.hasOwnProperty.call(object, key);
                }
            /***/ },
            /***/ 37: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                var VanillaPicker;
                if (window.Picker) // use the already loaded instance of VanillaPicker
                VanillaPicker = window.Picker;
                else try {
                    // load color picker
                    VanillaPicker = __webpack_require__(Object(function webpackMissingModule() {
                        var e = new Error("Cannot find module 'vanilla-picker'");
                        e.code = "MODULE_NOT_FOUND";
                        throw e;
                    }()));
                } catch (err) {
                // probably running the minimalist bundle
                }
                module1.exports = VanillaPicker;
            /***/ },
            /***/ 233: /***/ function(module1) {
                /*
 * Natural Sort algorithm for Javascript - Version 0.7 - Released under MIT license
 * Author: Jim Palmer (based on chunking idea from Dave Koelle)
 */ /*jshint unused:false */ module1.exports = function naturalSort(a, b) {
                    "use strict";
                    var re = /(^([+\-]?(?:0|[1-9]\d*)(?:\.\d*)?(?:[eE][+\-]?\d+)?)?$|^0x[0-9a-f]+$|\d+)/gi, sre = /(^[ ]*|[ ]*$)/g, dre = /(^([\w ]+,?[\w ]+)?[\w ]+,?[\w ]+\d+:\d+(:\d+)?[\w ]?|^\d{1,4}[\/\-]\d{1,4}[\/\-]\d{1,4}|^\w+, \w+ \d+, \d{4})/, hre = /^0x[0-9a-f]+$/i, ore = /^0/, i = function(s) {
                        return naturalSort.insensitive && ("" + s).toLowerCase() || "" + s;
                    }, // convert all to strings strip whitespace
                    x = i(a).replace(sre, "") || "", y = i(b).replace(sre, "") || "", // chunk/tokenize
                    xN = x.replace(re, "\x00$1\x00").replace(/\0$/, "").replace(/^\0/, "").split("\x00"), yN = y.replace(re, "\x00$1\x00").replace(/\0$/, "").replace(/^\0/, "").split("\x00"), // numeric, hex or date detection
                    xD = parseInt(x.match(hre), 16) || xN.length !== 1 && x.match(dre) && Date.parse(x), yD = parseInt(y.match(hre), 16) || xD && y.match(dre) && Date.parse(y) || null, oFxNcL, oFyNcL;
                    // first try and sort Hex codes or Dates
                    if (yD) {
                        if (xD < yD) return -1;
                        else if (xD > yD) return 1;
                    }
                    // natural sorting through split numeric strings and default strings
                    for(var cLoc = 0, numS = Math.max(xN.length, yN.length); cLoc < numS; cLoc++){
                        // find floats not starting with '0', string or 0 if not defined (Clint Priest)
                        oFxNcL = !(xN[cLoc] || "").match(ore) && parseFloat(xN[cLoc]) || xN[cLoc] || 0;
                        oFyNcL = !(yN[cLoc] || "").match(ore) && parseFloat(yN[cLoc]) || yN[cLoc] || 0;
                        // handle numeric vs string comparison - number < string - (Kyle Adams)
                        if (isNaN(oFxNcL) !== isNaN(oFyNcL)) return isNaN(oFxNcL) ? 1 : -1;
                        else if (typeof oFxNcL !== typeof oFyNcL) {
                            oFxNcL += "";
                            oFyNcL += "";
                        }
                        if (oFxNcL < oFyNcL) return -1;
                        if (oFxNcL > oFyNcL) return 1;
                    }
                    return 0;
                };
            /***/ },
            /***/ 156: /***/ function(__unused_webpack_module, exports) {
                (function(exports) {
                    "use strict";
                    function isArray(obj) {
                        if (obj !== null) return Object.prototype.toString.call(obj) === "[object Array]";
                        else return false;
                    }
                    function isObject(obj) {
                        if (obj !== null) return Object.prototype.toString.call(obj) === "[object Object]";
                        else return false;
                    }
                    function strictDeepEqual(first, second) {
                        // Check the scalar case first.
                        if (first === second) return true;
                        // Check if they are the same type.
                        var firstType = Object.prototype.toString.call(first);
                        if (firstType !== Object.prototype.toString.call(second)) return false;
                        // We know that first and second have the same type so we can just check the
                        // first type from now on.
                        if (isArray(first) === true) {
                            // Short circuit if they're not the same length;
                            if (first.length !== second.length) return false;
                            for(var i = 0; i < first.length; i++){
                                if (strictDeepEqual(first[i], second[i]) === false) return false;
                            }
                            return true;
                        }
                        if (isObject(first) === true) {
                            // An object is equal if it has the same key/value pairs.
                            var keysSeen = {};
                            for(var key in first)if (hasOwnProperty.call(first, key)) {
                                if (strictDeepEqual(first[key], second[key]) === false) return false;
                                keysSeen[key] = true;
                            }
                            // Now check that there aren't any keys in second that weren't
                            // in first.
                            for(var key2 in second)if (hasOwnProperty.call(second, key2)) {
                                if (keysSeen[key2] !== true) return false;
                            }
                            return true;
                        }
                        return false;
                    }
                    function isFalse(obj) {
                        // From the spec:
                        // A false value corresponds to the following values:
                        // Empty list
                        // Empty object
                        // Empty string
                        // False boolean
                        // null value
                        // First check the scalar values.
                        if (obj === "" || obj === false || obj === null) return true;
                        else if (isArray(obj) && obj.length === 0) // Check for an empty array.
                        return true;
                        else if (isObject(obj)) {
                            // Check for an empty object.
                            for(var key in obj){
                                // If there are any keys, then
                                // the object is not empty so the object
                                // is not false.
                                if (obj.hasOwnProperty(key)) return false;
                            }
                            return true;
                        } else return false;
                    }
                    function objValues(obj) {
                        var keys = Object.keys(obj);
                        var values = [];
                        for(var i = 0; i < keys.length; i++)values.push(obj[keys[i]]);
                        return values;
                    }
                    function merge(a, b) {
                        var merged = {};
                        for(var key in a)merged[key] = a[key];
                        for(var key2 in b)merged[key2] = b[key2];
                        return merged;
                    }
                    var trimLeft;
                    if (typeof String.prototype.trimLeft === "function") trimLeft = function(str) {
                        return str.trimLeft();
                    };
                    else trimLeft = function(str) {
                        return str.match(/^\s*(.*)/)[1];
                    };
                    // Type constants used to define functions.
                    var TYPE_NUMBER = 0;
                    var TYPE_ANY = 1;
                    var TYPE_STRING = 2;
                    var TYPE_ARRAY = 3;
                    var TYPE_OBJECT = 4;
                    var TYPE_BOOLEAN = 5;
                    var TYPE_EXPREF = 6;
                    var TYPE_NULL = 7;
                    var TYPE_ARRAY_NUMBER = 8;
                    var TYPE_ARRAY_STRING = 9;
                    var TYPE_NAME_TABLE = {
                        0: "number",
                        1: "any",
                        2: "string",
                        3: "array",
                        4: "object",
                        5: "boolean",
                        6: "expression",
                        7: "null",
                        8: "Array<number>",
                        9: "Array<string>"
                    };
                    var TOK_EOF = "EOF";
                    var TOK_UNQUOTEDIDENTIFIER = "UnquotedIdentifier";
                    var TOK_QUOTEDIDENTIFIER = "QuotedIdentifier";
                    var TOK_RBRACKET = "Rbracket";
                    var TOK_RPAREN = "Rparen";
                    var TOK_COMMA = "Comma";
                    var TOK_COLON = "Colon";
                    var TOK_RBRACE = "Rbrace";
                    var TOK_NUMBER = "Number";
                    var TOK_CURRENT = "Current";
                    var TOK_EXPREF = "Expref";
                    var TOK_PIPE = "Pipe";
                    var TOK_OR = "Or";
                    var TOK_AND = "And";
                    var TOK_EQ = "EQ";
                    var TOK_GT = "GT";
                    var TOK_LT = "LT";
                    var TOK_GTE = "GTE";
                    var TOK_LTE = "LTE";
                    var TOK_NE = "NE";
                    var TOK_FLATTEN = "Flatten";
                    var TOK_STAR = "Star";
                    var TOK_FILTER = "Filter";
                    var TOK_DOT = "Dot";
                    var TOK_NOT = "Not";
                    var TOK_LBRACE = "Lbrace";
                    var TOK_LBRACKET = "Lbracket";
                    var TOK_LPAREN = "Lparen";
                    var TOK_LITERAL = "Literal";
                    // The "&", "[", "<", ">" tokens
                    // are not in basicToken because
                    // there are two token variants
                    // ("&&", "[?", "<=", ">=").  This is specially handled
                    // below.
                    var basicTokens = {
                        ".": TOK_DOT,
                        "*": TOK_STAR,
                        ",": TOK_COMMA,
                        ":": TOK_COLON,
                        "{": TOK_LBRACE,
                        "}": TOK_RBRACE,
                        "]": TOK_RBRACKET,
                        "(": TOK_LPAREN,
                        ")": TOK_RPAREN,
                        "@": TOK_CURRENT
                    };
                    var operatorStartToken = {
                        "<": true,
                        ">": true,
                        "=": true,
                        "!": true
                    };
                    var skipChars = {
                        " ": true,
                        "	": true,
                        "\n": true
                    };
                    function isAlpha(ch) {
                        return ch >= "a" && ch <= "z" || ch >= "A" && ch <= "Z" || ch === "_";
                    }
                    function isNum(ch) {
                        return ch >= "0" && ch <= "9" || ch === "-";
                    }
                    function isAlphaNum(ch) {
                        return ch >= "a" && ch <= "z" || ch >= "A" && ch <= "Z" || ch >= "0" && ch <= "9" || ch === "_";
                    }
                    function Lexer() {}
                    Lexer.prototype = {
                        tokenize: function(stream) {
                            var tokens = [];
                            this._current = 0;
                            var start;
                            var identifier;
                            var token;
                            while(this._current < stream.length){
                                if (isAlpha(stream[this._current])) {
                                    start = this._current;
                                    identifier = this._consumeUnquotedIdentifier(stream);
                                    tokens.push({
                                        type: TOK_UNQUOTEDIDENTIFIER,
                                        value: identifier,
                                        start: start
                                    });
                                } else if (basicTokens[stream[this._current]] !== undefined) {
                                    tokens.push({
                                        type: basicTokens[stream[this._current]],
                                        value: stream[this._current],
                                        start: this._current
                                    });
                                    this._current++;
                                } else if (isNum(stream[this._current])) {
                                    token = this._consumeNumber(stream);
                                    tokens.push(token);
                                } else if (stream[this._current] === "[") {
                                    // No need to increment this._current.  This happens
                                    // in _consumeLBracket
                                    token = this._consumeLBracket(stream);
                                    tokens.push(token);
                                } else if (stream[this._current] === '"') {
                                    start = this._current;
                                    identifier = this._consumeQuotedIdentifier(stream);
                                    tokens.push({
                                        type: TOK_QUOTEDIDENTIFIER,
                                        value: identifier,
                                        start: start
                                    });
                                } else if (stream[this._current] === "'") {
                                    start = this._current;
                                    identifier = this._consumeRawStringLiteral(stream);
                                    tokens.push({
                                        type: TOK_LITERAL,
                                        value: identifier,
                                        start: start
                                    });
                                } else if (stream[this._current] === "`") {
                                    start = this._current;
                                    var literal = this._consumeLiteral(stream);
                                    tokens.push({
                                        type: TOK_LITERAL,
                                        value: literal,
                                        start: start
                                    });
                                } else if (operatorStartToken[stream[this._current]] !== undefined) tokens.push(this._consumeOperator(stream));
                                else if (skipChars[stream[this._current]] !== undefined) // Ignore whitespace.
                                this._current++;
                                else if (stream[this._current] === "&") {
                                    start = this._current;
                                    this._current++;
                                    if (stream[this._current] === "&") {
                                        this._current++;
                                        tokens.push({
                                            type: TOK_AND,
                                            value: "&&",
                                            start: start
                                        });
                                    } else tokens.push({
                                        type: TOK_EXPREF,
                                        value: "&",
                                        start: start
                                    });
                                } else if (stream[this._current] === "|") {
                                    start = this._current;
                                    this._current++;
                                    if (stream[this._current] === "|") {
                                        this._current++;
                                        tokens.push({
                                            type: TOK_OR,
                                            value: "||",
                                            start: start
                                        });
                                    } else tokens.push({
                                        type: TOK_PIPE,
                                        value: "|",
                                        start: start
                                    });
                                } else {
                                    var error = new Error("Unknown character:" + stream[this._current]);
                                    error.name = "LexerError";
                                    throw error;
                                }
                            }
                            return tokens;
                        },
                        _consumeUnquotedIdentifier: function(stream) {
                            var start = this._current;
                            this._current++;
                            while(this._current < stream.length && isAlphaNum(stream[this._current]))this._current++;
                            return stream.slice(start, this._current);
                        },
                        _consumeQuotedIdentifier: function(stream) {
                            var start = this._current;
                            this._current++;
                            var maxLength = stream.length;
                            while(stream[this._current] !== '"' && this._current < maxLength){
                                // You can escape a double quote and you can escape an escape.
                                var current = this._current;
                                if (stream[current] === "\\" && (stream[current + 1] === "\\" || stream[current + 1] === '"')) current += 2;
                                else current++;
                                this._current = current;
                            }
                            this._current++;
                            return JSON.parse(stream.slice(start, this._current));
                        },
                        _consumeRawStringLiteral: function(stream) {
                            var start = this._current;
                            this._current++;
                            var maxLength = stream.length;
                            while(stream[this._current] !== "'" && this._current < maxLength){
                                // You can escape a single quote and you can escape an escape.
                                var current = this._current;
                                if (stream[current] === "\\" && (stream[current + 1] === "\\" || stream[current + 1] === "'")) current += 2;
                                else current++;
                                this._current = current;
                            }
                            this._current++;
                            var literal = stream.slice(start + 1, this._current - 1);
                            return literal.replace("\\'", "'");
                        },
                        _consumeNumber: function(stream) {
                            var start = this._current;
                            this._current++;
                            var maxLength = stream.length;
                            while(isNum(stream[this._current]) && this._current < maxLength)this._current++;
                            var value = parseInt(stream.slice(start, this._current));
                            return {
                                type: TOK_NUMBER,
                                value: value,
                                start: start
                            };
                        },
                        _consumeLBracket: function(stream) {
                            var start = this._current;
                            this._current++;
                            if (stream[this._current] === "?") {
                                this._current++;
                                return {
                                    type: TOK_FILTER,
                                    value: "[?",
                                    start: start
                                };
                            } else if (stream[this._current] === "]") {
                                this._current++;
                                return {
                                    type: TOK_FLATTEN,
                                    value: "[]",
                                    start: start
                                };
                            } else return {
                                type: TOK_LBRACKET,
                                value: "[",
                                start: start
                            };
                        },
                        _consumeOperator: function(stream) {
                            var start = this._current;
                            var startingChar = stream[start];
                            this._current++;
                            if (startingChar === "!") {
                                if (stream[this._current] === "=") {
                                    this._current++;
                                    return {
                                        type: TOK_NE,
                                        value: "!=",
                                        start: start
                                    };
                                } else return {
                                    type: TOK_NOT,
                                    value: "!",
                                    start: start
                                };
                            } else if (startingChar === "<") {
                                if (stream[this._current] === "=") {
                                    this._current++;
                                    return {
                                        type: TOK_LTE,
                                        value: "<=",
                                        start: start
                                    };
                                } else return {
                                    type: TOK_LT,
                                    value: "<",
                                    start: start
                                };
                            } else if (startingChar === ">") {
                                if (stream[this._current] === "=") {
                                    this._current++;
                                    return {
                                        type: TOK_GTE,
                                        value: ">=",
                                        start: start
                                    };
                                } else return {
                                    type: TOK_GT,
                                    value: ">",
                                    start: start
                                };
                            } else if (startingChar === "=") {
                                if (stream[this._current] === "=") {
                                    this._current++;
                                    return {
                                        type: TOK_EQ,
                                        value: "==",
                                        start: start
                                    };
                                }
                            }
                        },
                        _consumeLiteral: function(stream) {
                            this._current++;
                            var start = this._current;
                            var maxLength = stream.length;
                            var literal;
                            while(stream[this._current] !== "`" && this._current < maxLength){
                                // You can escape a literal char or you can escape the escape.
                                var current = this._current;
                                if (stream[current] === "\\" && (stream[current + 1] === "\\" || stream[current + 1] === "`")) current += 2;
                                else current++;
                                this._current = current;
                            }
                            var literalString = trimLeft(stream.slice(start, this._current));
                            literalString = literalString.replace("\\`", "`");
                            if (this._looksLikeJSON(literalString)) literal = JSON.parse(literalString);
                            else // Try to JSON parse it as "<literal>"
                            literal = JSON.parse('"' + literalString + '"');
                            // +1 gets us to the ending "`", +1 to move on to the next char.
                            this._current++;
                            return literal;
                        },
                        _looksLikeJSON: function(literalString) {
                            var startingChars = '[{"';
                            var jsonLiterals = [
                                "true",
                                "false",
                                "null"
                            ];
                            var numberLooking = "-0123456789";
                            if (literalString === "") return false;
                            else if (startingChars.indexOf(literalString[0]) >= 0) return true;
                            else if (jsonLiterals.indexOf(literalString) >= 0) return true;
                            else if (numberLooking.indexOf(literalString[0]) >= 0) try {
                                JSON.parse(literalString);
                                return true;
                            } catch (ex) {
                                return false;
                            }
                            else return false;
                        }
                    };
                    var bindingPower = {};
                    bindingPower[TOK_EOF] = 0;
                    bindingPower[TOK_UNQUOTEDIDENTIFIER] = 0;
                    bindingPower[TOK_QUOTEDIDENTIFIER] = 0;
                    bindingPower[TOK_RBRACKET] = 0;
                    bindingPower[TOK_RPAREN] = 0;
                    bindingPower[TOK_COMMA] = 0;
                    bindingPower[TOK_RBRACE] = 0;
                    bindingPower[TOK_NUMBER] = 0;
                    bindingPower[TOK_CURRENT] = 0;
                    bindingPower[TOK_EXPREF] = 0;
                    bindingPower[TOK_PIPE] = 1;
                    bindingPower[TOK_OR] = 2;
                    bindingPower[TOK_AND] = 3;
                    bindingPower[TOK_EQ] = 5;
                    bindingPower[TOK_GT] = 5;
                    bindingPower[TOK_LT] = 5;
                    bindingPower[TOK_GTE] = 5;
                    bindingPower[TOK_LTE] = 5;
                    bindingPower[TOK_NE] = 5;
                    bindingPower[TOK_FLATTEN] = 9;
                    bindingPower[TOK_STAR] = 20;
                    bindingPower[TOK_FILTER] = 21;
                    bindingPower[TOK_DOT] = 40;
                    bindingPower[TOK_NOT] = 45;
                    bindingPower[TOK_LBRACE] = 50;
                    bindingPower[TOK_LBRACKET] = 55;
                    bindingPower[TOK_LPAREN] = 60;
                    function Parser() {}
                    Parser.prototype = {
                        parse: function(expression) {
                            this._loadTokens(expression);
                            this.index = 0;
                            var ast = this.expression(0);
                            if (this._lookahead(0) !== TOK_EOF) {
                                var t = this._lookaheadToken(0);
                                var error = new Error("Unexpected token type: " + t.type + ", value: " + t.value);
                                error.name = "ParserError";
                                throw error;
                            }
                            return ast;
                        },
                        _loadTokens: function(expression) {
                            var lexer = new Lexer();
                            var tokens = lexer.tokenize(expression);
                            tokens.push({
                                type: TOK_EOF,
                                value: "",
                                start: expression.length
                            });
                            this.tokens = tokens;
                        },
                        expression: function(rbp) {
                            var leftToken = this._lookaheadToken(0);
                            this._advance();
                            var left = this.nud(leftToken);
                            var currentToken = this._lookahead(0);
                            while(rbp < bindingPower[currentToken]){
                                this._advance();
                                left = this.led(currentToken, left);
                                currentToken = this._lookahead(0);
                            }
                            return left;
                        },
                        _lookahead: function(number) {
                            return this.tokens[this.index + number].type;
                        },
                        _lookaheadToken: function(number) {
                            return this.tokens[this.index + number];
                        },
                        _advance: function() {
                            this.index++;
                        },
                        nud: function(token) {
                            var left;
                            var right;
                            var expression;
                            switch(token.type){
                                case TOK_LITERAL:
                                    return {
                                        type: "Literal",
                                        value: token.value
                                    };
                                case TOK_UNQUOTEDIDENTIFIER:
                                    return {
                                        type: "Field",
                                        name: token.value
                                    };
                                case TOK_QUOTEDIDENTIFIER:
                                    var node = {
                                        type: "Field",
                                        name: token.value
                                    };
                                    if (this._lookahead(0) === TOK_LPAREN) throw new Error("Quoted identifier not allowed for function names.");
                                    return node;
                                case TOK_NOT:
                                    right = this.expression(bindingPower.Not);
                                    return {
                                        type: "NotExpression",
                                        children: [
                                            right
                                        ]
                                    };
                                case TOK_STAR:
                                    left = {
                                        type: "Identity"
                                    };
                                    right = null;
                                    if (this._lookahead(0) === TOK_RBRACKET) // This can happen in a multiselect,
                                    // [a, b, *]
                                    right = {
                                        type: "Identity"
                                    };
                                    else right = this._parseProjectionRHS(bindingPower.Star);
                                    return {
                                        type: "ValueProjection",
                                        children: [
                                            left,
                                            right
                                        ]
                                    };
                                case TOK_FILTER:
                                    return this.led(token.type, {
                                        type: "Identity"
                                    });
                                case TOK_LBRACE:
                                    return this._parseMultiselectHash();
                                case TOK_FLATTEN:
                                    left = {
                                        type: TOK_FLATTEN,
                                        children: [
                                            {
                                                type: "Identity"
                                            }
                                        ]
                                    };
                                    right = this._parseProjectionRHS(bindingPower.Flatten);
                                    return {
                                        type: "Projection",
                                        children: [
                                            left,
                                            right
                                        ]
                                    };
                                case TOK_LBRACKET:
                                    if (this._lookahead(0) === TOK_NUMBER || this._lookahead(0) === TOK_COLON) {
                                        right = this._parseIndexExpression();
                                        return this._projectIfSlice({
                                            type: "Identity"
                                        }, right);
                                    } else if (this._lookahead(0) === TOK_STAR && this._lookahead(1) === TOK_RBRACKET) {
                                        this._advance();
                                        this._advance();
                                        right = this._parseProjectionRHS(bindingPower.Star);
                                        return {
                                            type: "Projection",
                                            children: [
                                                {
                                                    type: "Identity"
                                                },
                                                right
                                            ]
                                        };
                                    }
                                    return this._parseMultiselectList();
                                case TOK_CURRENT:
                                    return {
                                        type: TOK_CURRENT
                                    };
                                case TOK_EXPREF:
                                    expression = this.expression(bindingPower.Expref);
                                    return {
                                        type: "ExpressionReference",
                                        children: [
                                            expression
                                        ]
                                    };
                                case TOK_LPAREN:
                                    var args = [];
                                    while(this._lookahead(0) !== TOK_RPAREN){
                                        if (this._lookahead(0) === TOK_CURRENT) {
                                            expression = {
                                                type: TOK_CURRENT
                                            };
                                            this._advance();
                                        } else expression = this.expression(0);
                                        args.push(expression);
                                    }
                                    this._match(TOK_RPAREN);
                                    return args[0];
                                default:
                                    this._errorToken(token);
                            }
                        },
                        led: function(tokenName, left) {
                            var right;
                            switch(tokenName){
                                case TOK_DOT:
                                    var rbp = bindingPower.Dot;
                                    if (this._lookahead(0) !== TOK_STAR) {
                                        right = this._parseDotRHS(rbp);
                                        return {
                                            type: "Subexpression",
                                            children: [
                                                left,
                                                right
                                            ]
                                        };
                                    }
                                    // Creating a projection.
                                    this._advance();
                                    right = this._parseProjectionRHS(rbp);
                                    return {
                                        type: "ValueProjection",
                                        children: [
                                            left,
                                            right
                                        ]
                                    };
                                case TOK_PIPE:
                                    right = this.expression(bindingPower.Pipe);
                                    return {
                                        type: TOK_PIPE,
                                        children: [
                                            left,
                                            right
                                        ]
                                    };
                                case TOK_OR:
                                    right = this.expression(bindingPower.Or);
                                    return {
                                        type: "OrExpression",
                                        children: [
                                            left,
                                            right
                                        ]
                                    };
                                case TOK_AND:
                                    right = this.expression(bindingPower.And);
                                    return {
                                        type: "AndExpression",
                                        children: [
                                            left,
                                            right
                                        ]
                                    };
                                case TOK_LPAREN:
                                    var name = left.name;
                                    var args = [];
                                    var expression, node;
                                    while(this._lookahead(0) !== TOK_RPAREN){
                                        if (this._lookahead(0) === TOK_CURRENT) {
                                            expression = {
                                                type: TOK_CURRENT
                                            };
                                            this._advance();
                                        } else expression = this.expression(0);
                                        if (this._lookahead(0) === TOK_COMMA) this._match(TOK_COMMA);
                                        args.push(expression);
                                    }
                                    this._match(TOK_RPAREN);
                                    node = {
                                        type: "Function",
                                        name: name,
                                        children: args
                                    };
                                    return node;
                                case TOK_FILTER:
                                    var condition = this.expression(0);
                                    this._match(TOK_RBRACKET);
                                    if (this._lookahead(0) === TOK_FLATTEN) right = {
                                        type: "Identity"
                                    };
                                    else right = this._parseProjectionRHS(bindingPower.Filter);
                                    return {
                                        type: "FilterProjection",
                                        children: [
                                            left,
                                            right,
                                            condition
                                        ]
                                    };
                                case TOK_FLATTEN:
                                    var leftNode = {
                                        type: TOK_FLATTEN,
                                        children: [
                                            left
                                        ]
                                    };
                                    var rightNode = this._parseProjectionRHS(bindingPower.Flatten);
                                    return {
                                        type: "Projection",
                                        children: [
                                            leftNode,
                                            rightNode
                                        ]
                                    };
                                case TOK_EQ:
                                case TOK_NE:
                                case TOK_GT:
                                case TOK_GTE:
                                case TOK_LT:
                                case TOK_LTE:
                                    return this._parseComparator(left, tokenName);
                                case TOK_LBRACKET:
                                    var token = this._lookaheadToken(0);
                                    if (token.type === TOK_NUMBER || token.type === TOK_COLON) {
                                        right = this._parseIndexExpression();
                                        return this._projectIfSlice(left, right);
                                    }
                                    this._match(TOK_STAR);
                                    this._match(TOK_RBRACKET);
                                    right = this._parseProjectionRHS(bindingPower.Star);
                                    return {
                                        type: "Projection",
                                        children: [
                                            left,
                                            right
                                        ]
                                    };
                                default:
                                    this._errorToken(this._lookaheadToken(0));
                            }
                        },
                        _match: function(tokenType) {
                            if (this._lookahead(0) === tokenType) this._advance();
                            else {
                                var t = this._lookaheadToken(0);
                                var error = new Error("Expected " + tokenType + ", got: " + t.type);
                                error.name = "ParserError";
                                throw error;
                            }
                        },
                        _errorToken: function(token) {
                            var error = new Error("Invalid token (" + token.type + '): "' + token.value + '"');
                            error.name = "ParserError";
                            throw error;
                        },
                        _parseIndexExpression: function() {
                            if (this._lookahead(0) === TOK_COLON || this._lookahead(1) === TOK_COLON) return this._parseSliceExpression();
                            else {
                                var node = {
                                    type: "Index",
                                    value: this._lookaheadToken(0).value
                                };
                                this._advance();
                                this._match(TOK_RBRACKET);
                                return node;
                            }
                        },
                        _projectIfSlice: function(left, right) {
                            var indexExpr = {
                                type: "IndexExpression",
                                children: [
                                    left,
                                    right
                                ]
                            };
                            if (right.type === "Slice") return {
                                type: "Projection",
                                children: [
                                    indexExpr,
                                    this._parseProjectionRHS(bindingPower.Star)
                                ]
                            };
                            else return indexExpr;
                        },
                        _parseSliceExpression: function() {
                            // [start:end:step] where each part is optional, as well as the last
                            // colon.
                            var parts = [
                                null,
                                null,
                                null
                            ];
                            var index = 0;
                            var currentToken = this._lookahead(0);
                            while(currentToken !== TOK_RBRACKET && index < 3){
                                if (currentToken === TOK_COLON) {
                                    index++;
                                    this._advance();
                                } else if (currentToken === TOK_NUMBER) {
                                    parts[index] = this._lookaheadToken(0).value;
                                    this._advance();
                                } else {
                                    var t = this._lookahead(0);
                                    var error = new Error("Syntax error, unexpected token: " + t.value + "(" + t.type + ")");
                                    error.name = "Parsererror";
                                    throw error;
                                }
                                currentToken = this._lookahead(0);
                            }
                            this._match(TOK_RBRACKET);
                            return {
                                type: "Slice",
                                children: parts
                            };
                        },
                        _parseComparator: function(left, comparator) {
                            var right = this.expression(bindingPower[comparator]);
                            return {
                                type: "Comparator",
                                name: comparator,
                                children: [
                                    left,
                                    right
                                ]
                            };
                        },
                        _parseDotRHS: function(rbp) {
                            var lookahead = this._lookahead(0);
                            var exprTokens = [
                                TOK_UNQUOTEDIDENTIFIER,
                                TOK_QUOTEDIDENTIFIER,
                                TOK_STAR
                            ];
                            if (exprTokens.indexOf(lookahead) >= 0) return this.expression(rbp);
                            else if (lookahead === TOK_LBRACKET) {
                                this._match(TOK_LBRACKET);
                                return this._parseMultiselectList();
                            } else if (lookahead === TOK_LBRACE) {
                                this._match(TOK_LBRACE);
                                return this._parseMultiselectHash();
                            }
                        },
                        _parseProjectionRHS: function(rbp) {
                            var right;
                            if (bindingPower[this._lookahead(0)] < 10) right = {
                                type: "Identity"
                            };
                            else if (this._lookahead(0) === TOK_LBRACKET) right = this.expression(rbp);
                            else if (this._lookahead(0) === TOK_FILTER) right = this.expression(rbp);
                            else if (this._lookahead(0) === TOK_DOT) {
                                this._match(TOK_DOT);
                                right = this._parseDotRHS(rbp);
                            } else {
                                var t = this._lookaheadToken(0);
                                var error = new Error("Sytanx error, unexpected token: " + t.value + "(" + t.type + ")");
                                error.name = "ParserError";
                                throw error;
                            }
                            return right;
                        },
                        _parseMultiselectList: function() {
                            var expressions = [];
                            while(this._lookahead(0) !== TOK_RBRACKET){
                                var expression = this.expression(0);
                                expressions.push(expression);
                                if (this._lookahead(0) === TOK_COMMA) {
                                    this._match(TOK_COMMA);
                                    if (this._lookahead(0) === TOK_RBRACKET) throw new Error("Unexpected token Rbracket");
                                }
                            }
                            this._match(TOK_RBRACKET);
                            return {
                                type: "MultiSelectList",
                                children: expressions
                            };
                        },
                        _parseMultiselectHash: function() {
                            var pairs = [];
                            var identifierTypes = [
                                TOK_UNQUOTEDIDENTIFIER,
                                TOK_QUOTEDIDENTIFIER
                            ];
                            var keyToken, keyName, value, node;
                            for(;;){
                                keyToken = this._lookaheadToken(0);
                                if (identifierTypes.indexOf(keyToken.type) < 0) throw new Error("Expecting an identifier token, got: " + keyToken.type);
                                keyName = keyToken.value;
                                this._advance();
                                this._match(TOK_COLON);
                                value = this.expression(0);
                                node = {
                                    type: "KeyValuePair",
                                    name: keyName,
                                    value: value
                                };
                                pairs.push(node);
                                if (this._lookahead(0) === TOK_COMMA) this._match(TOK_COMMA);
                                else if (this._lookahead(0) === TOK_RBRACE) {
                                    this._match(TOK_RBRACE);
                                    break;
                                }
                            }
                            return {
                                type: "MultiSelectHash",
                                children: pairs
                            };
                        }
                    };
                    function TreeInterpreter(runtime) {
                        this.runtime = runtime;
                    }
                    TreeInterpreter.prototype = {
                        search: function(node, value) {
                            return this.visit(node, value);
                        },
                        visit: function(node, value) {
                            var matched, current, result, first, second, field, left, right, collected, i;
                            switch(node.type){
                                case "Field":
                                    if (value !== null && isObject(value)) {
                                        field = value[node.name];
                                        if (field === undefined) return null;
                                        else return field;
                                    }
                                    return null;
                                case "Subexpression":
                                    result = this.visit(node.children[0], value);
                                    for(i = 1; i < node.children.length; i++){
                                        result = this.visit(node.children[1], result);
                                        if (result === null) return null;
                                    }
                                    return result;
                                case "IndexExpression":
                                    left = this.visit(node.children[0], value);
                                    right = this.visit(node.children[1], left);
                                    return right;
                                case "Index":
                                    if (!isArray(value)) return null;
                                    var index = node.value;
                                    if (index < 0) index = value.length + index;
                                    result = value[index];
                                    if (result === undefined) result = null;
                                    return result;
                                case "Slice":
                                    if (!isArray(value)) return null;
                                    var sliceParams = node.children.slice(0);
                                    var computed = this.computeSliceParams(value.length, sliceParams);
                                    var start = computed[0];
                                    var stop = computed[1];
                                    var step = computed[2];
                                    result = [];
                                    if (step > 0) for(i = start; i < stop; i += step)result.push(value[i]);
                                    else for(i = start; i > stop; i += step)result.push(value[i]);
                                    return result;
                                case "Projection":
                                    // Evaluate left child.
                                    var base = this.visit(node.children[0], value);
                                    if (!isArray(base)) return null;
                                    collected = [];
                                    for(i = 0; i < base.length; i++){
                                        current = this.visit(node.children[1], base[i]);
                                        if (current !== null) collected.push(current);
                                    }
                                    return collected;
                                case "ValueProjection":
                                    // Evaluate left child.
                                    base = this.visit(node.children[0], value);
                                    if (!isObject(base)) return null;
                                    collected = [];
                                    var values = objValues(base);
                                    for(i = 0; i < values.length; i++){
                                        current = this.visit(node.children[1], values[i]);
                                        if (current !== null) collected.push(current);
                                    }
                                    return collected;
                                case "FilterProjection":
                                    base = this.visit(node.children[0], value);
                                    if (!isArray(base)) return null;
                                    var filtered = [];
                                    var finalResults = [];
                                    for(i = 0; i < base.length; i++){
                                        matched = this.visit(node.children[2], base[i]);
                                        if (!isFalse(matched)) filtered.push(base[i]);
                                    }
                                    for(var j = 0; j < filtered.length; j++){
                                        current = this.visit(node.children[1], filtered[j]);
                                        if (current !== null) finalResults.push(current);
                                    }
                                    return finalResults;
                                case "Comparator":
                                    first = this.visit(node.children[0], value);
                                    second = this.visit(node.children[1], value);
                                    switch(node.name){
                                        case TOK_EQ:
                                            result = strictDeepEqual(first, second);
                                            break;
                                        case TOK_NE:
                                            result = !strictDeepEqual(first, second);
                                            break;
                                        case TOK_GT:
                                            result = first > second;
                                            break;
                                        case TOK_GTE:
                                            result = first >= second;
                                            break;
                                        case TOK_LT:
                                            result = first < second;
                                            break;
                                        case TOK_LTE:
                                            result = first <= second;
                                            break;
                                        default:
                                            throw new Error("Unknown comparator: " + node.name);
                                    }
                                    return result;
                                case TOK_FLATTEN:
                                    var original = this.visit(node.children[0], value);
                                    if (!isArray(original)) return null;
                                    var merged = [];
                                    for(i = 0; i < original.length; i++){
                                        current = original[i];
                                        if (isArray(current)) merged.push.apply(merged, current);
                                        else merged.push(current);
                                    }
                                    return merged;
                                case "Identity":
                                    return value;
                                case "MultiSelectList":
                                    if (value === null) return null;
                                    collected = [];
                                    for(i = 0; i < node.children.length; i++)collected.push(this.visit(node.children[i], value));
                                    return collected;
                                case "MultiSelectHash":
                                    if (value === null) return null;
                                    collected = {};
                                    var child;
                                    for(i = 0; i < node.children.length; i++){
                                        child = node.children[i];
                                        collected[child.name] = this.visit(child.value, value);
                                    }
                                    return collected;
                                case "OrExpression":
                                    matched = this.visit(node.children[0], value);
                                    if (isFalse(matched)) matched = this.visit(node.children[1], value);
                                    return matched;
                                case "AndExpression":
                                    first = this.visit(node.children[0], value);
                                    if (isFalse(first) === true) return first;
                                    return this.visit(node.children[1], value);
                                case "NotExpression":
                                    first = this.visit(node.children[0], value);
                                    return isFalse(first);
                                case "Literal":
                                    return node.value;
                                case TOK_PIPE:
                                    left = this.visit(node.children[0], value);
                                    return this.visit(node.children[1], left);
                                case TOK_CURRENT:
                                    return value;
                                case "Function":
                                    var resolvedArgs = [];
                                    for(i = 0; i < node.children.length; i++)resolvedArgs.push(this.visit(node.children[i], value));
                                    return this.runtime.callFunction(node.name, resolvedArgs);
                                case "ExpressionReference":
                                    var refNode = node.children[0];
                                    // Tag the node with a specific attribute so the type
                                    // checker verify the type.
                                    refNode.jmespathType = TOK_EXPREF;
                                    return refNode;
                                default:
                                    throw new Error("Unknown node type: " + node.type);
                            }
                        },
                        computeSliceParams: function(arrayLength, sliceParams) {
                            var start = sliceParams[0];
                            var stop = sliceParams[1];
                            var step = sliceParams[2];
                            var computed = [
                                null,
                                null,
                                null
                            ];
                            if (step === null) step = 1;
                            else if (step === 0) {
                                var error = new Error("Invalid slice, step cannot be 0");
                                error.name = "RuntimeError";
                                throw error;
                            }
                            var stepValueNegative = step < 0 ? true : false;
                            if (start === null) start = stepValueNegative ? arrayLength - 1 : 0;
                            else start = this.capSliceRange(arrayLength, start, step);
                            if (stop === null) stop = stepValueNegative ? -1 : arrayLength;
                            else stop = this.capSliceRange(arrayLength, stop, step);
                            computed[0] = start;
                            computed[1] = stop;
                            computed[2] = step;
                            return computed;
                        },
                        capSliceRange: function(arrayLength, actualValue, step) {
                            if (actualValue < 0) {
                                actualValue += arrayLength;
                                if (actualValue < 0) actualValue = step < 0 ? -1 : 0;
                            } else if (actualValue >= arrayLength) actualValue = step < 0 ? arrayLength - 1 : arrayLength;
                            return actualValue;
                        }
                    };
                    function Runtime(interpreter) {
                        this._interpreter = interpreter;
                        this.functionTable = {
                            // name: [function, <signature>]
                            // The <signature> can be:
                            //
                            // {
                            //   args: [[type1, type2], [type1, type2]],
                            //   variadic: true|false
                            // }
                            //
                            // Each arg in the arg list is a list of valid types
                            // (if the function is overloaded and supports multiple
                            // types.  If the type is "any" then no type checking
                            // occurs on the argument.  Variadic is optional
                            // and if not provided is assumed to be false.
                            abs: {
                                _func: this._functionAbs,
                                _signature: [
                                    {
                                        types: [
                                            TYPE_NUMBER
                                        ]
                                    }
                                ]
                            },
                            avg: {
                                _func: this._functionAvg,
                                _signature: [
                                    {
                                        types: [
                                            TYPE_ARRAY_NUMBER
                                        ]
                                    }
                                ]
                            },
                            ceil: {
                                _func: this._functionCeil,
                                _signature: [
                                    {
                                        types: [
                                            TYPE_NUMBER
                                        ]
                                    }
                                ]
                            },
                            contains: {
                                _func: this._functionContains,
                                _signature: [
                                    {
                                        types: [
                                            TYPE_STRING,
                                            TYPE_ARRAY
                                        ]
                                    },
                                    {
                                        types: [
                                            TYPE_ANY
                                        ]
                                    }
                                ]
                            },
                            "ends_with": {
                                _func: this._functionEndsWith,
                                _signature: [
                                    {
                                        types: [
                                            TYPE_STRING
                                        ]
                                    },
                                    {
                                        types: [
                                            TYPE_STRING
                                        ]
                                    }
                                ]
                            },
                            floor: {
                                _func: this._functionFloor,
                                _signature: [
                                    {
                                        types: [
                                            TYPE_NUMBER
                                        ]
                                    }
                                ]
                            },
                            length: {
                                _func: this._functionLength,
                                _signature: [
                                    {
                                        types: [
                                            TYPE_STRING,
                                            TYPE_ARRAY,
                                            TYPE_OBJECT
                                        ]
                                    }
                                ]
                            },
                            map: {
                                _func: this._functionMap,
                                _signature: [
                                    {
                                        types: [
                                            TYPE_EXPREF
                                        ]
                                    },
                                    {
                                        types: [
                                            TYPE_ARRAY
                                        ]
                                    }
                                ]
                            },
                            max: {
                                _func: this._functionMax,
                                _signature: [
                                    {
                                        types: [
                                            TYPE_ARRAY_NUMBER,
                                            TYPE_ARRAY_STRING
                                        ]
                                    }
                                ]
                            },
                            "merge": {
                                _func: this._functionMerge,
                                _signature: [
                                    {
                                        types: [
                                            TYPE_OBJECT
                                        ],
                                        variadic: true
                                    }
                                ]
                            },
                            "max_by": {
                                _func: this._functionMaxBy,
                                _signature: [
                                    {
                                        types: [
                                            TYPE_ARRAY
                                        ]
                                    },
                                    {
                                        types: [
                                            TYPE_EXPREF
                                        ]
                                    }
                                ]
                            },
                            sum: {
                                _func: this._functionSum,
                                _signature: [
                                    {
                                        types: [
                                            TYPE_ARRAY_NUMBER
                                        ]
                                    }
                                ]
                            },
                            "starts_with": {
                                _func: this._functionStartsWith,
                                _signature: [
                                    {
                                        types: [
                                            TYPE_STRING
                                        ]
                                    },
                                    {
                                        types: [
                                            TYPE_STRING
                                        ]
                                    }
                                ]
                            },
                            min: {
                                _func: this._functionMin,
                                _signature: [
                                    {
                                        types: [
                                            TYPE_ARRAY_NUMBER,
                                            TYPE_ARRAY_STRING
                                        ]
                                    }
                                ]
                            },
                            "min_by": {
                                _func: this._functionMinBy,
                                _signature: [
                                    {
                                        types: [
                                            TYPE_ARRAY
                                        ]
                                    },
                                    {
                                        types: [
                                            TYPE_EXPREF
                                        ]
                                    }
                                ]
                            },
                            type: {
                                _func: this._functionType,
                                _signature: [
                                    {
                                        types: [
                                            TYPE_ANY
                                        ]
                                    }
                                ]
                            },
                            keys: {
                                _func: this._functionKeys,
                                _signature: [
                                    {
                                        types: [
                                            TYPE_OBJECT
                                        ]
                                    }
                                ]
                            },
                            values: {
                                _func: this._functionValues,
                                _signature: [
                                    {
                                        types: [
                                            TYPE_OBJECT
                                        ]
                                    }
                                ]
                            },
                            sort: {
                                _func: this._functionSort,
                                _signature: [
                                    {
                                        types: [
                                            TYPE_ARRAY_STRING,
                                            TYPE_ARRAY_NUMBER
                                        ]
                                    }
                                ]
                            },
                            "sort_by": {
                                _func: this._functionSortBy,
                                _signature: [
                                    {
                                        types: [
                                            TYPE_ARRAY
                                        ]
                                    },
                                    {
                                        types: [
                                            TYPE_EXPREF
                                        ]
                                    }
                                ]
                            },
                            join: {
                                _func: this._functionJoin,
                                _signature: [
                                    {
                                        types: [
                                            TYPE_STRING
                                        ]
                                    },
                                    {
                                        types: [
                                            TYPE_ARRAY_STRING
                                        ]
                                    }
                                ]
                            },
                            reverse: {
                                _func: this._functionReverse,
                                _signature: [
                                    {
                                        types: [
                                            TYPE_STRING,
                                            TYPE_ARRAY
                                        ]
                                    }
                                ]
                            },
                            "to_array": {
                                _func: this._functionToArray,
                                _signature: [
                                    {
                                        types: [
                                            TYPE_ANY
                                        ]
                                    }
                                ]
                            },
                            "to_string": {
                                _func: this._functionToString,
                                _signature: [
                                    {
                                        types: [
                                            TYPE_ANY
                                        ]
                                    }
                                ]
                            },
                            "to_number": {
                                _func: this._functionToNumber,
                                _signature: [
                                    {
                                        types: [
                                            TYPE_ANY
                                        ]
                                    }
                                ]
                            },
                            "not_null": {
                                _func: this._functionNotNull,
                                _signature: [
                                    {
                                        types: [
                                            TYPE_ANY
                                        ],
                                        variadic: true
                                    }
                                ]
                            }
                        };
                    }
                    Runtime.prototype = {
                        callFunction: function(name, resolvedArgs) {
                            var functionEntry = this.functionTable[name];
                            if (functionEntry === undefined) throw new Error("Unknown function: " + name + "()");
                            this._validateArgs(name, resolvedArgs, functionEntry._signature);
                            return functionEntry._func.call(this, resolvedArgs);
                        },
                        _validateArgs: function(name, args, signature) {
                            // Validating the args requires validating
                            // the correct arity and the correct type of each arg.
                            // If the last argument is declared as variadic, then we need
                            // a minimum number of args to be required.  Otherwise it has to
                            // be an exact amount.
                            var pluralized;
                            if (signature[signature.length - 1].variadic) {
                                if (args.length < signature.length) {
                                    pluralized = signature.length === 1 ? " argument" : " arguments";
                                    throw new Error("ArgumentError: " + name + "() " + "takes at least" + signature.length + pluralized + " but received " + args.length);
                                }
                            } else if (args.length !== signature.length) {
                                pluralized = signature.length === 1 ? " argument" : " arguments";
                                throw new Error("ArgumentError: " + name + "() " + "takes " + signature.length + pluralized + " but received " + args.length);
                            }
                            var currentSpec;
                            var actualType;
                            var typeMatched;
                            for(var i = 0; i < signature.length; i++){
                                typeMatched = false;
                                currentSpec = signature[i].types;
                                actualType = this._getTypeName(args[i]);
                                for(var j = 0; j < currentSpec.length; j++)if (this._typeMatches(actualType, currentSpec[j], args[i])) {
                                    typeMatched = true;
                                    break;
                                }
                                if (!typeMatched) {
                                    var expected = currentSpec.map(function(typeIdentifier) {
                                        return TYPE_NAME_TABLE[typeIdentifier];
                                    }).join(",");
                                    throw new Error("TypeError: " + name + "() " + "expected argument " + (i + 1) + " to be type " + expected + " but received type " + TYPE_NAME_TABLE[actualType] + " instead.");
                                }
                            }
                        },
                        _typeMatches: function(actual, expected, argValue) {
                            if (expected === TYPE_ANY) return true;
                            if (expected === TYPE_ARRAY_STRING || expected === TYPE_ARRAY_NUMBER || expected === TYPE_ARRAY) {
                                // The expected type can either just be array,
                                // or it can require a specific subtype (array of numbers).
                                //
                                // The simplest case is if "array" with no subtype is specified.
                                if (expected === TYPE_ARRAY) return actual === TYPE_ARRAY;
                                else if (actual === TYPE_ARRAY) {
                                    // Otherwise we need to check subtypes.
                                    // I think this has potential to be improved.
                                    var subtype;
                                    if (expected === TYPE_ARRAY_NUMBER) subtype = TYPE_NUMBER;
                                    else if (expected === TYPE_ARRAY_STRING) subtype = TYPE_STRING;
                                    for(var i = 0; i < argValue.length; i++){
                                        if (!this._typeMatches(this._getTypeName(argValue[i]), subtype, argValue[i])) return false;
                                    }
                                    return true;
                                }
                            } else return actual === expected;
                        },
                        _getTypeName: function(obj) {
                            switch(Object.prototype.toString.call(obj)){
                                case "[object String]":
                                    return TYPE_STRING;
                                case "[object Number]":
                                    return TYPE_NUMBER;
                                case "[object Array]":
                                    return TYPE_ARRAY;
                                case "[object Boolean]":
                                    return TYPE_BOOLEAN;
                                case "[object Null]":
                                    return TYPE_NULL;
                                case "[object Object]":
                                    // Check if it's an expref.  If it has, it's been
                                    // tagged with a jmespathType attr of 'Expref';
                                    if (obj.jmespathType === TOK_EXPREF) return TYPE_EXPREF;
                                    else return TYPE_OBJECT;
                            }
                        },
                        _functionStartsWith: function(resolvedArgs) {
                            return resolvedArgs[0].lastIndexOf(resolvedArgs[1]) === 0;
                        },
                        _functionEndsWith: function(resolvedArgs) {
                            var searchStr = resolvedArgs[0];
                            var suffix = resolvedArgs[1];
                            return searchStr.indexOf(suffix, searchStr.length - suffix.length) !== -1;
                        },
                        _functionReverse: function(resolvedArgs) {
                            var typeName = this._getTypeName(resolvedArgs[0]);
                            if (typeName === TYPE_STRING) {
                                var originalStr = resolvedArgs[0];
                                var reversedStr = "";
                                for(var i = originalStr.length - 1; i >= 0; i--)reversedStr += originalStr[i];
                                return reversedStr;
                            } else {
                                var reversedArray = resolvedArgs[0].slice(0);
                                reversedArray.reverse();
                                return reversedArray;
                            }
                        },
                        _functionAbs: function(resolvedArgs) {
                            return Math.abs(resolvedArgs[0]);
                        },
                        _functionCeil: function(resolvedArgs) {
                            return Math.ceil(resolvedArgs[0]);
                        },
                        _functionAvg: function(resolvedArgs) {
                            var sum = 0;
                            var inputArray = resolvedArgs[0];
                            for(var i = 0; i < inputArray.length; i++)sum += inputArray[i];
                            return sum / inputArray.length;
                        },
                        _functionContains: function(resolvedArgs) {
                            return resolvedArgs[0].indexOf(resolvedArgs[1]) >= 0;
                        },
                        _functionFloor: function(resolvedArgs) {
                            return Math.floor(resolvedArgs[0]);
                        },
                        _functionLength: function(resolvedArgs) {
                            if (!isObject(resolvedArgs[0])) return resolvedArgs[0].length;
                            else // As far as I can tell, there's no way to get the length
                            // of an object without O(n) iteration through the object.
                            return Object.keys(resolvedArgs[0]).length;
                        },
                        _functionMap: function(resolvedArgs) {
                            var mapped = [];
                            var interpreter = this._interpreter;
                            var exprefNode = resolvedArgs[0];
                            var elements = resolvedArgs[1];
                            for(var i = 0; i < elements.length; i++)mapped.push(interpreter.visit(exprefNode, elements[i]));
                            return mapped;
                        },
                        _functionMerge: function(resolvedArgs) {
                            var merged = {};
                            for(var i = 0; i < resolvedArgs.length; i++){
                                var current = resolvedArgs[i];
                                for(var key in current)merged[key] = current[key];
                            }
                            return merged;
                        },
                        _functionMax: function(resolvedArgs) {
                            if (resolvedArgs[0].length > 0) {
                                var typeName = this._getTypeName(resolvedArgs[0][0]);
                                if (typeName === TYPE_NUMBER) return Math.max.apply(Math, resolvedArgs[0]);
                                else {
                                    var elements = resolvedArgs[0];
                                    var maxElement = elements[0];
                                    for(var i = 1; i < elements.length; i++)if (maxElement.localeCompare(elements[i]) < 0) maxElement = elements[i];
                                    return maxElement;
                                }
                            } else return null;
                        },
                        _functionMin: function(resolvedArgs) {
                            if (resolvedArgs[0].length > 0) {
                                var typeName = this._getTypeName(resolvedArgs[0][0]);
                                if (typeName === TYPE_NUMBER) return Math.min.apply(Math, resolvedArgs[0]);
                                else {
                                    var elements = resolvedArgs[0];
                                    var minElement = elements[0];
                                    for(var i = 1; i < elements.length; i++)if (elements[i].localeCompare(minElement) < 0) minElement = elements[i];
                                    return minElement;
                                }
                            } else return null;
                        },
                        _functionSum: function(resolvedArgs) {
                            var sum = 0;
                            var listToSum = resolvedArgs[0];
                            for(var i = 0; i < listToSum.length; i++)sum += listToSum[i];
                            return sum;
                        },
                        _functionType: function(resolvedArgs) {
                            switch(this._getTypeName(resolvedArgs[0])){
                                case TYPE_NUMBER:
                                    return "number";
                                case TYPE_STRING:
                                    return "string";
                                case TYPE_ARRAY:
                                    return "array";
                                case TYPE_OBJECT:
                                    return "object";
                                case TYPE_BOOLEAN:
                                    return "boolean";
                                case TYPE_EXPREF:
                                    return "expref";
                                case TYPE_NULL:
                                    return "null";
                            }
                        },
                        _functionKeys: function(resolvedArgs) {
                            return Object.keys(resolvedArgs[0]);
                        },
                        _functionValues: function(resolvedArgs) {
                            var obj = resolvedArgs[0];
                            var keys = Object.keys(obj);
                            var values = [];
                            for(var i = 0; i < keys.length; i++)values.push(obj[keys[i]]);
                            return values;
                        },
                        _functionJoin: function(resolvedArgs) {
                            var joinChar = resolvedArgs[0];
                            var listJoin = resolvedArgs[1];
                            return listJoin.join(joinChar);
                        },
                        _functionToArray: function(resolvedArgs) {
                            if (this._getTypeName(resolvedArgs[0]) === TYPE_ARRAY) return resolvedArgs[0];
                            else return [
                                resolvedArgs[0]
                            ];
                        },
                        _functionToString: function(resolvedArgs) {
                            if (this._getTypeName(resolvedArgs[0]) === TYPE_STRING) return resolvedArgs[0];
                            else return JSON.stringify(resolvedArgs[0]);
                        },
                        _functionToNumber: function(resolvedArgs) {
                            var typeName = this._getTypeName(resolvedArgs[0]);
                            var convertedValue;
                            if (typeName === TYPE_NUMBER) return resolvedArgs[0];
                            else if (typeName === TYPE_STRING) {
                                convertedValue = +resolvedArgs[0];
                                if (!isNaN(convertedValue)) return convertedValue;
                            }
                            return null;
                        },
                        _functionNotNull: function(resolvedArgs) {
                            for(var i = 0; i < resolvedArgs.length; i++){
                                if (this._getTypeName(resolvedArgs[i]) !== TYPE_NULL) return resolvedArgs[i];
                            }
                            return null;
                        },
                        _functionSort: function(resolvedArgs) {
                            var sortedArray = resolvedArgs[0].slice(0);
                            sortedArray.sort();
                            return sortedArray;
                        },
                        _functionSortBy: function(resolvedArgs) {
                            var sortedArray = resolvedArgs[0].slice(0);
                            if (sortedArray.length === 0) return sortedArray;
                            var interpreter = this._interpreter;
                            var exprefNode = resolvedArgs[1];
                            var requiredType = this._getTypeName(interpreter.visit(exprefNode, sortedArray[0]));
                            if ([
                                TYPE_NUMBER,
                                TYPE_STRING
                            ].indexOf(requiredType) < 0) throw new Error("TypeError");
                            var that = this;
                            // In order to get a stable sort out of an unstable
                            // sort algorithm, we decorate/sort/undecorate (DSU)
                            // by creating a new list of [index, element] pairs.
                            // In the cmp function, if the evaluated elements are
                            // equal, then the index will be used as the tiebreaker.
                            // After the decorated list has been sorted, it will be
                            // undecorated to extract the original elements.
                            var decorated = [];
                            for(var i = 0; i < sortedArray.length; i++)decorated.push([
                                i,
                                sortedArray[i]
                            ]);
                            decorated.sort(function(a, b) {
                                var exprA = interpreter.visit(exprefNode, a[1]);
                                var exprB = interpreter.visit(exprefNode, b[1]);
                                if (that._getTypeName(exprA) !== requiredType) throw new Error("TypeError: expected " + requiredType + ", received " + that._getTypeName(exprA));
                                else if (that._getTypeName(exprB) !== requiredType) throw new Error("TypeError: expected " + requiredType + ", received " + that._getTypeName(exprB));
                                if (exprA > exprB) return 1;
                                else if (exprA < exprB) return -1;
                                else // If they're equal compare the items by their
                                // order to maintain relative order of equal keys
                                // (i.e. to get a stable sort).
                                return a[0] - b[0];
                            });
                            // Undecorate: extract out the original list elements.
                            for(var j = 0; j < decorated.length; j++)sortedArray[j] = decorated[j][1];
                            return sortedArray;
                        },
                        _functionMaxBy: function(resolvedArgs) {
                            var exprefNode = resolvedArgs[1];
                            var resolvedArray = resolvedArgs[0];
                            var keyFunction = this.createKeyFunction(exprefNode, [
                                TYPE_NUMBER,
                                TYPE_STRING
                            ]);
                            var maxNumber = -Infinity;
                            var maxRecord;
                            var current;
                            for(var i = 0; i < resolvedArray.length; i++){
                                current = keyFunction(resolvedArray[i]);
                                if (current > maxNumber) {
                                    maxNumber = current;
                                    maxRecord = resolvedArray[i];
                                }
                            }
                            return maxRecord;
                        },
                        _functionMinBy: function(resolvedArgs) {
                            var exprefNode = resolvedArgs[1];
                            var resolvedArray = resolvedArgs[0];
                            var keyFunction = this.createKeyFunction(exprefNode, [
                                TYPE_NUMBER,
                                TYPE_STRING
                            ]);
                            var minNumber = Infinity;
                            var minRecord;
                            var current;
                            for(var i = 0; i < resolvedArray.length; i++){
                                current = keyFunction(resolvedArray[i]);
                                if (current < minNumber) {
                                    minNumber = current;
                                    minRecord = resolvedArray[i];
                                }
                            }
                            return minRecord;
                        },
                        createKeyFunction: function(exprefNode, allowedTypes) {
                            var that = this;
                            var interpreter = this._interpreter;
                            var keyFunc = function(x) {
                                var current = interpreter.visit(exprefNode, x);
                                if (allowedTypes.indexOf(that._getTypeName(current)) < 0) {
                                    var msg = "TypeError: expected one of " + allowedTypes + ", received " + that._getTypeName(current);
                                    throw new Error(msg);
                                }
                                return current;
                            };
                            return keyFunc;
                        }
                    };
                    function compile(stream) {
                        var parser = new Parser();
                        var ast = parser.parse(stream);
                        return ast;
                    }
                    function tokenize(stream) {
                        var lexer = new Lexer();
                        return lexer.tokenize(stream);
                    }
                    function search(data, expression) {
                        var parser = new Parser();
                        // This needs to be improved.  Both the interpreter and runtime depend on
                        // each other.  The runtime needs the interpreter to support exprefs.
                        // There's likely a clean way to avoid the cyclic dependency.
                        var runtime = new Runtime();
                        var interpreter = new TreeInterpreter(runtime);
                        runtime._interpreter = interpreter;
                        var node = parser.parse(expression);
                        return interpreter.search(node, data);
                    }
                    exports.tokenize = tokenize;
                    exports.compile = compile;
                    exports.search = search;
                    exports.strictDeepEqual = strictDeepEqual;
                })(exports);
            /***/ },
            /***/ 26: /***/ function(__unused_webpack_module, exports) {
                "use strict";
                var escapedChars = {
                    "b": "\b",
                    "f": "\f",
                    "n": "\n",
                    "r": "\r",
                    "t": "	",
                    '"': '"',
                    "/": "/",
                    "\\": "\\"
                };
                var A_CODE = "a".charCodeAt();
                exports.parse = function(source, _, options) {
                    var pointers = {};
                    var line = 0;
                    var column = 0;
                    var pos = 0;
                    var bigint = options && options.bigint && typeof BigInt != "undefined";
                    return {
                        data: _parse("", true),
                        pointers: pointers
                    };
                    function _parse(ptr, topLevel) {
                        whitespace();
                        var data;
                        map(ptr, "value");
                        var char = getChar();
                        switch(char){
                            case "t":
                                read("rue");
                                data = true;
                                break;
                            case "f":
                                read("alse");
                                data = false;
                                break;
                            case "n":
                                read("ull");
                                data = null;
                                break;
                            case '"':
                                data = parseString();
                                break;
                            case "[":
                                data = parseArray(ptr);
                                break;
                            case "{":
                                data = parseObject(ptr);
                                break;
                            default:
                                backChar();
                                if ("-0123456789".indexOf(char) >= 0) data = parseNumber();
                                else unexpectedToken();
                        }
                        map(ptr, "valueEnd");
                        whitespace();
                        if (topLevel && pos < source.length) unexpectedToken();
                        return data;
                    }
                    function whitespace() {
                        loop: while(pos < source.length){
                            switch(source[pos]){
                                case " ":
                                    column++;
                                    break;
                                case "	":
                                    column += 4;
                                    break;
                                case "\r":
                                    column = 0;
                                    break;
                                case "\n":
                                    column = 0;
                                    line++;
                                    break;
                                default:
                                    break loop;
                            }
                            pos++;
                        }
                    }
                    function parseString() {
                        var str = "";
                        var char;
                        while(true){
                            char = getChar();
                            if (char == '"') break;
                            else if (char == "\\") {
                                char = getChar();
                                if (char in escapedChars) str += escapedChars[char];
                                else if (char == "u") str += getCharCode();
                                else wasUnexpectedToken();
                            } else str += char;
                        }
                        return str;
                    }
                    function parseNumber() {
                        var numStr = "";
                        var integer = true;
                        if (source[pos] == "-") numStr += getChar();
                        numStr += source[pos] == "0" ? getChar() : getDigits();
                        if (source[pos] == ".") {
                            numStr += getChar() + getDigits();
                            integer = false;
                        }
                        if (source[pos] == "e" || source[pos] == "E") {
                            numStr += getChar();
                            if (source[pos] == "+" || source[pos] == "-") numStr += getChar();
                            numStr += getDigits();
                            integer = false;
                        }
                        var result = +numStr;
                        return bigint && integer && (result > Number.MAX_SAFE_INTEGER || result < Number.MIN_SAFE_INTEGER) ? BigInt(numStr) : result;
                    }
                    function parseArray(ptr) {
                        whitespace();
                        var arr = [];
                        var i = 0;
                        if (getChar() == "]") return arr;
                        backChar();
                        while(true){
                            var itemPtr = ptr + "/" + i;
                            arr.push(_parse(itemPtr));
                            whitespace();
                            var char = getChar();
                            if (char == "]") break;
                            if (char != ",") wasUnexpectedToken();
                            whitespace();
                            i++;
                        }
                        return arr;
                    }
                    function parseObject(ptr) {
                        whitespace();
                        var obj = {};
                        if (getChar() == "}") return obj;
                        backChar();
                        while(true){
                            var loc = getLoc();
                            if (getChar() != '"') wasUnexpectedToken();
                            var key = parseString();
                            var propPtr = ptr + "/" + escapeJsonPointer(key);
                            mapLoc(propPtr, "key", loc);
                            map(propPtr, "keyEnd");
                            whitespace();
                            if (getChar() != ":") wasUnexpectedToken();
                            whitespace();
                            obj[key] = _parse(propPtr);
                            whitespace();
                            var char = getChar();
                            if (char == "}") break;
                            if (char != ",") wasUnexpectedToken();
                            whitespace();
                        }
                        return obj;
                    }
                    function read(str) {
                        for(var i = 0; i < str.length; i++)if (getChar() !== str[i]) wasUnexpectedToken();
                    }
                    function getChar() {
                        checkUnexpectedEnd();
                        var char = source[pos];
                        pos++;
                        column++; // new line?
                        return char;
                    }
                    function backChar() {
                        pos--;
                        column--;
                    }
                    function getCharCode() {
                        var count = 4;
                        var code = 0;
                        while(count--){
                            code <<= 4;
                            var char = getChar().toLowerCase();
                            if (char >= "a" && char <= "f") code += char.charCodeAt() - A_CODE + 10;
                            else if (char >= "0" && char <= "9") code += +char;
                            else wasUnexpectedToken();
                        }
                        return String.fromCharCode(code);
                    }
                    function getDigits() {
                        var digits = "";
                        while(source[pos] >= "0" && source[pos] <= "9")digits += getChar();
                        if (digits.length) return digits;
                        checkUnexpectedEnd();
                        unexpectedToken();
                    }
                    function map(ptr, prop) {
                        mapLoc(ptr, prop, getLoc());
                    }
                    function mapLoc(ptr, prop, loc) {
                        pointers[ptr] = pointers[ptr] || {};
                        pointers[ptr][prop] = loc;
                    }
                    function getLoc() {
                        return {
                            line: line,
                            column: column,
                            pos: pos
                        };
                    }
                    function unexpectedToken() {
                        throw new SyntaxError("Unexpected token " + source[pos] + " in JSON at position " + pos);
                    }
                    function wasUnexpectedToken() {
                        backChar();
                        unexpectedToken();
                    }
                    function checkUnexpectedEnd() {
                        if (pos >= source.length) throw new SyntaxError("Unexpected end of JSON input");
                    }
                };
                exports.stringify = function(data, _, options) {
                    if (!validType(data)) return;
                    var wsLine = 0;
                    var wsPos, wsColumn;
                    var whitespace = typeof options == "object" ? options.space : options;
                    switch(typeof whitespace){
                        case "number":
                            var len = whitespace > 10 ? 10 : whitespace < 0 ? 0 : Math.floor(whitespace);
                            whitespace = len && repeat(len, " ");
                            wsPos = len;
                            wsColumn = len;
                            break;
                        case "string":
                            whitespace = whitespace.slice(0, 10);
                            wsPos = 0;
                            wsColumn = 0;
                            for(var j = 0; j < whitespace.length; j++){
                                var char = whitespace[j];
                                switch(char){
                                    case " ":
                                        wsColumn++;
                                        break;
                                    case "	":
                                        wsColumn += 4;
                                        break;
                                    case "\r":
                                        wsColumn = 0;
                                        break;
                                    case "\n":
                                        wsColumn = 0;
                                        wsLine++;
                                        break;
                                    default:
                                        throw new Error("whitespace characters not allowed in JSON");
                                }
                                wsPos++;
                            }
                            break;
                        default:
                            whitespace = undefined;
                    }
                    var json = "";
                    var pointers = {};
                    var line = 0;
                    var column = 0;
                    var pos = 0;
                    var es6 = options && options.es6 && typeof Map == "function";
                    _stringify(data, 0, "");
                    return {
                        json: json,
                        pointers: pointers
                    };
                    function _stringify(_data, lvl, ptr) {
                        map(ptr, "value");
                        switch(typeof _data){
                            case "number":
                            case "bigint":
                            case "boolean":
                                out("" + _data);
                                break;
                            case "string":
                                out(quoted(_data));
                                break;
                            case "object":
                                if (_data === null) out("null");
                                else if (typeof _data.toJSON == "function") out(quoted(_data.toJSON()));
                                else if (Array.isArray(_data)) stringifyArray();
                                else if (es6) {
                                    if (_data.constructor.BYTES_PER_ELEMENT) stringifyArray();
                                    else if (_data instanceof Map) stringifyMapSet();
                                    else if (_data instanceof Set) stringifyMapSet(true);
                                    else stringifyObject();
                                } else stringifyObject();
                        }
                        map(ptr, "valueEnd");
                        function stringifyArray() {
                            if (_data.length) {
                                out("[");
                                var itemLvl = lvl + 1;
                                for(var i = 0; i < _data.length; i++){
                                    if (i) out(",");
                                    indent(itemLvl);
                                    var item = validType(_data[i]) ? _data[i] : null;
                                    var itemPtr = ptr + "/" + i;
                                    _stringify(item, itemLvl, itemPtr);
                                }
                                indent(lvl);
                                out("]");
                            } else out("[]");
                        }
                        function stringifyObject() {
                            var keys = Object.keys(_data);
                            if (keys.length) {
                                out("{");
                                var propLvl = lvl + 1;
                                for(var i = 0; i < keys.length; i++){
                                    var key = keys[i];
                                    var value = _data[key];
                                    if (validType(value)) {
                                        if (i) out(",");
                                        var propPtr = ptr + "/" + escapeJsonPointer(key);
                                        indent(propLvl);
                                        map(propPtr, "key");
                                        out(quoted(key));
                                        map(propPtr, "keyEnd");
                                        out(":");
                                        if (whitespace) out(" ");
                                        _stringify(value, propLvl, propPtr);
                                    }
                                }
                                indent(lvl);
                                out("}");
                            } else out("{}");
                        }
                        function stringifyMapSet(isSet) {
                            if (_data.size) {
                                out("{");
                                var propLvl = lvl + 1;
                                var first = true;
                                var entries = _data.entries();
                                var entry = entries.next();
                                while(!entry.done){
                                    var item = entry.value;
                                    var key = item[0];
                                    var value = isSet ? true : item[1];
                                    if (validType(value)) {
                                        if (!first) out(",");
                                        first = false;
                                        var propPtr = ptr + "/" + escapeJsonPointer(key);
                                        indent(propLvl);
                                        map(propPtr, "key");
                                        out(quoted(key));
                                        map(propPtr, "keyEnd");
                                        out(":");
                                        if (whitespace) out(" ");
                                        _stringify(value, propLvl, propPtr);
                                    }
                                    entry = entries.next();
                                }
                                indent(lvl);
                                out("}");
                            } else out("{}");
                        }
                    }
                    function out(str) {
                        column += str.length;
                        pos += str.length;
                        json += str;
                    }
                    function indent(lvl) {
                        if (whitespace) {
                            json += "\n" + repeat(lvl, whitespace);
                            line++;
                            column = 0;
                            while(lvl--){
                                if (wsLine) {
                                    line += wsLine;
                                    column = wsColumn;
                                } else column += wsColumn;
                                pos += wsPos;
                            }
                            pos += 1; // \n character
                        }
                    }
                    function map(ptr, prop) {
                        pointers[ptr] = pointers[ptr] || {};
                        pointers[ptr][prop] = {
                            line: line,
                            column: column,
                            pos: pos
                        };
                    }
                    function repeat(n, str) {
                        return Array(n + 1).join(str);
                    }
                };
                var VALID_TYPES = [
                    "number",
                    "bigint",
                    "boolean",
                    "string",
                    "object"
                ];
                function validType(data) {
                    return VALID_TYPES.indexOf(typeof data) >= 0;
                }
                var ESC_QUOTE = /"|\\/g;
                var ESC_B = /[\b]/g;
                var ESC_F = /\f/g;
                var ESC_N = /\n/g;
                var ESC_R = /\r/g;
                var ESC_T = /\t/g;
                function quoted(str) {
                    str = str.replace(ESC_QUOTE, "\\$&").replace(ESC_F, "\\f").replace(ESC_B, "\\b").replace(ESC_N, "\\n").replace(ESC_R, "\\r").replace(ESC_T, "\\t");
                    return '"' + str + '"';
                }
                var ESC_0 = /~/g;
                var ESC_1 = /\//g;
                function escapeJsonPointer(str) {
                    return str.replace(ESC_0, "~0").replace(ESC_1, "~1");
                }
            /***/ },
            /***/ 483: /***/ function(module1, exports) {
                var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__; /**
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */ 
                (function(root, factory) {
                    "use strict";
                    __WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = factory, __WEBPACK_AMD_DEFINE_RESULT__ = typeof __WEBPACK_AMD_DEFINE_FACTORY__ === "function" ? __WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__) : __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module1.exports = __WEBPACK_AMD_DEFINE_RESULT__);
                })(this, function() {
                    /**
     * A self-contained modal library
     */ "use strict";
                    /** Returns whether a value is a dom node */ function isNode(value) {
                        if (typeof Node === "object") return value instanceof Node;
                        else return value && typeof value === "object" && typeof value.nodeType === "number";
                    }
                    /** Returns whether a value is a string */ function isString(value) {
                        return typeof value === "string";
                    }
                    /**
     * Generates observable objects that can be watched and triggered
     */ function observable() {
                        var callbacks = [];
                        return {
                            watch: callbacks.push.bind(callbacks),
                            trigger: function(context, detail) {
                                var unprevented = true;
                                var event = {
                                    detail: detail,
                                    preventDefault: function preventDefault() {
                                        unprevented = false;
                                    }
                                };
                                for(var i = 0; i < callbacks.length; i++)callbacks[i](context, event);
                                return unprevented;
                            }
                        };
                    }
                    /** Whether an element is hidden */ function isHidden(elem) {
                        // @see http://stackoverflow.com/questions/19669786
                        return window.getComputedStyle(elem).display === "none";
                    }
                    /**
     * A small interface for creating and managing a dom element
     */ function Elem(elem) {
                        this.elem = elem;
                    }
                    /** Creates a new div */ Elem.make = function(parent, tag) {
                        if (typeof parent === "string") parent = document.querySelector(parent);
                        var elem = document.createElement(tag || "div");
                        (parent || document.body).appendChild(elem);
                        return new Elem(elem);
                    };
                    Elem.prototype = {
                        /** Creates a child of this node */ child: function(tag) {
                            return Elem.make(this.elem, tag);
                        },
                        /** Applies a set of styles to an element */ stylize: function(styles) {
                            styles = styles || {};
                            if (typeof styles.opacity !== "undefined") styles.filter = "alpha(opacity=" + styles.opacity * 100 + ")";
                            for(var prop in styles)if (styles.hasOwnProperty(prop)) this.elem.style[prop] = styles[prop];
                            return this;
                        },
                        /** Adds a class name */ clazz: function(clazz) {
                            this.elem.className += " " + clazz;
                            return this;
                        },
                        /** Sets the HTML */ html: function(content) {
                            if (isNode(content)) this.elem.appendChild(content);
                            else this.elem.innerHTML = content;
                            return this;
                        },
                        /** Adds a click handler to this element */ onClick: function(callback) {
                            this.elem.addEventListener("click", callback);
                            return this;
                        },
                        /** Removes this element from the DOM */ destroy: function() {
                            this.elem.parentNode.removeChild(this.elem);
                        },
                        /** Hides this element */ hide: function() {
                            this.elem.style.display = "none";
                        },
                        /** Shows this element */ show: function() {
                            this.elem.style.display = "block";
                        },
                        /** Sets an attribute on this element */ attr: function(name, value) {
                            if (value !== undefined) this.elem.setAttribute(name, value);
                            return this;
                        },
                        /** Executes a callback on all the ancestors of an element */ anyAncestor: function(predicate) {
                            var elem = this.elem;
                            while(elem){
                                if (predicate(new Elem(elem))) return true;
                                else elem = elem.parentNode;
                            }
                            return false;
                        },
                        /** Whether this element is visible */ isVisible: function() {
                            return !isHidden(this.elem);
                        }
                    };
                    /** Generates the grey-out effect */ function buildOverlay(getOption, close) {
                        return Elem.make(getOption("parent")).clazz("pico-overlay").clazz(getOption("overlayClass", "")).stylize({
                            display: "none",
                            position: "fixed",
                            top: "0px",
                            left: "0px",
                            height: "100%",
                            width: "100%",
                            zIndex: 10000
                        }).stylize(getOption("overlayStyles", {
                            opacity: 0.5,
                            background: "#000"
                        })).onClick(function() {
                            if (getOption("overlayClose", true)) close();
                        });
                    }
                    // An auto incrementing ID assigned to each modal
                    var autoinc = 1;
                    /** Builds the content of a modal */ function buildModal(getOption, close) {
                        var width = getOption("width", "auto");
                        if (typeof width === "number") width = "" + width + "px";
                        var id = getOption("modalId", "pico-" + autoinc++);
                        var elem = Elem.make(getOption("parent")).clazz("pico-content").clazz(getOption("modalClass", "")).stylize({
                            display: "none",
                            position: "fixed",
                            zIndex: 10001,
                            left: "50%",
                            top: "38.1966%",
                            maxHeight: "90%",
                            boxSizing: "border-box",
                            width: width,
                            "-ms-transform": "translate(-50%,-38.1966%)",
                            "-moz-transform": "translate(-50%,-38.1966%)",
                            "-webkit-transform": "translate(-50%,-38.1966%)",
                            "-o-transform": "translate(-50%,-38.1966%)",
                            transform: "translate(-50%,-38.1966%)"
                        }).stylize(getOption("modalStyles", {
                            overflow: "auto",
                            backgroundColor: "white",
                            padding: "20px",
                            borderRadius: "5px"
                        })).html(getOption("content")).attr("id", id).attr("role", "dialog").attr("aria-labelledby", getOption("ariaLabelledBy")).attr("aria-describedby", getOption("ariaDescribedBy", id)).onClick(function(event) {
                            var isCloseClick = new Elem(event.target).anyAncestor(function(elem) {
                                return /\bpico-close\b/.test(elem.elem.className);
                            });
                            if (isCloseClick) close();
                        });
                        return elem;
                    }
                    /** Builds the close button */ function buildClose(elem, getOption) {
                        if (getOption("closeButton", true)) return elem.child("button").html(getOption("closeHtml", "&#xD7;")).clazz("pico-close").clazz(getOption("closeClass", "")).stylize(getOption("closeStyles", {
                            borderRadius: "2px",
                            border: 0,
                            padding: 0,
                            cursor: "pointer",
                            height: "15px",
                            width: "15px",
                            position: "absolute",
                            top: "5px",
                            right: "5px",
                            fontSize: "16px",
                            textAlign: "center",
                            lineHeight: "15px",
                            background: "#CCC"
                        })).attr("aria-label", getOption("close-label", "Close"));
                    }
                    /** Builds a method that calls a method and returns an element */ function buildElemAccessor(builder) {
                        return function() {
                            return builder().elem;
                        };
                    }
                    // An observable that is triggered whenever the escape key is pressed
                    var escapeKey = observable();
                    // An observable that is triggered when the user hits the tab key
                    var tabKey = observable();
                    /** A global event handler to detect the escape key being pressed */ document.documentElement.addEventListener("keydown", function onKeyPress(event) {
                        var keycode = event.which || event.keyCode;
                        // If this is the escape key
                        if (keycode === 27) escapeKey.trigger();
                        else if (keycode === 9) tabKey.trigger(event);
                    });
                    /** Attaches focus management events */ function manageFocus(iface, isEnabled) {
                        /** Whether an element matches a selector */ function matches(elem, selector) {
                            var fn = elem.msMatchesSelector || elem.webkitMatchesSelector || elem.matches;
                            return fn.call(elem, selector);
                        }
                        /**
         * Returns whether an element is focusable
         * @see http://stackoverflow.com/questions/18261595
         */ function canFocus(elem) {
                            if (isHidden(elem) || matches(elem, ":disabled") || elem.hasAttribute("contenteditable")) return false;
                            else return elem.hasAttribute("tabindex") || matches(elem, "input,select,textarea,button,a[href],area[href],iframe");
                        }
                        /** Returns the first descendant that can be focused */ function firstFocusable(elem) {
                            var items = elem.getElementsByTagName("*");
                            for(var i = 0; i < items.length; i++){
                                if (canFocus(items[i])) return items[i];
                            }
                        }
                        /** Returns the last descendant that can be focused */ function lastFocusable(elem) {
                            var items = elem.getElementsByTagName("*");
                            for(var i = items.length; i--;){
                                if (canFocus(items[i])) return items[i];
                            }
                        }
                        // The element focused before the modal opens
                        var focused;
                        // Records the currently focused element so state can be returned
                        // after the modal closes
                        iface.beforeShow(function getActiveFocus() {
                            focused = document.activeElement;
                        });
                        // Shift focus into the modal
                        iface.afterShow(function focusModal() {
                            if (isEnabled()) {
                                var focusable = firstFocusable(iface.modalElem());
                                if (focusable) focusable.focus();
                            }
                        });
                        // Restore the previously focused element when the modal closes
                        iface.afterClose(function returnFocus() {
                            if (isEnabled() && focused) focused.focus();
                            focused = null;
                        });
                        // Capture tab key presses and loop them within the modal
                        tabKey.watch(function tabKeyPress(event) {
                            if (isEnabled() && iface.isVisible()) {
                                var first = firstFocusable(iface.modalElem());
                                var last = lastFocusable(iface.modalElem());
                                var from = event.shiftKey ? first : last;
                                if (from === document.activeElement) {
                                    (event.shiftKey ? last : first).focus();
                                    event.preventDefault();
                                }
                            }
                        });
                    }
                    /** Manages setting the 'overflow: hidden' on the body tag */ function manageBodyOverflow(iface, isEnabled) {
                        var origOverflow;
                        var body = new Elem(document.body);
                        iface.beforeShow(function() {
                            // Capture the current values so they can be restored
                            origOverflow = body.elem.style.overflow;
                            if (isEnabled()) body.stylize({
                                overflow: "hidden"
                            });
                        });
                        iface.afterClose(function() {
                            body.stylize({
                                overflow: origOverflow
                            });
                        });
                    }
                    /**
     * Displays a modal
     */ return function picoModal(options) {
                        if (isString(options) || isNode(options)) options = {
                            content: options
                        };
                        var afterCreateEvent = observable();
                        var beforeShowEvent = observable();
                        var afterShowEvent = observable();
                        var beforeCloseEvent = observable();
                        var afterCloseEvent = observable();
                        /**
         * Returns a named option if it has been explicitly defined. Otherwise,
         * it returns the given default value
         */ function getOption(opt, defaultValue) {
                            var value = options[opt];
                            if (typeof value === "function") value = value(defaultValue);
                            return value === undefined ? defaultValue : value;
                        }
                        // The various DOM elements that constitute the modal
                        var modalElem = build.bind(window, "modal");
                        var shadowElem = build.bind(window, "overlay");
                        var closeElem = build.bind(window, "close");
                        // This will eventually contain the modal API returned to the user
                        var iface;
                        /** Hides this modal */ function forceClose(detail) {
                            shadowElem().hide();
                            modalElem().hide();
                            afterCloseEvent.trigger(iface, detail);
                        }
                        /** Gracefully hides this modal */ function close(detail) {
                            if (beforeCloseEvent.trigger(iface, detail)) forceClose(detail);
                        }
                        /** Wraps a method so it returns the modal interface */ function returnIface(callback) {
                            return function() {
                                callback.apply(this, arguments);
                                return iface;
                            };
                        }
                        // The constructed dom nodes
                        var built;
                        /** Builds a method that calls a method and returns an element */ function build(name, detail) {
                            if (!built) {
                                var modal = buildModal(getOption, close);
                                built = {
                                    modal: modal,
                                    overlay: buildOverlay(getOption, close),
                                    close: buildClose(modal, getOption)
                                };
                                afterCreateEvent.trigger(iface, detail);
                            }
                            return built[name];
                        }
                        iface = {
                            /** Returns the wrapping modal element */ modalElem: buildElemAccessor(modalElem),
                            /** Returns the close button element */ closeElem: buildElemAccessor(closeElem),
                            /** Returns the overlay element */ overlayElem: buildElemAccessor(shadowElem),
                            /** Builds the dom without showing the modal */ buildDom: returnIface(build.bind(null, null)),
                            /** Returns whether this modal is currently being shown */ isVisible: function() {
                                return !!(built && modalElem && modalElem().isVisible());
                            },
                            /** Shows this modal */ show: function(detail) {
                                if (beforeShowEvent.trigger(iface, detail)) {
                                    shadowElem().show();
                                    closeElem();
                                    modalElem().show();
                                    afterShowEvent.trigger(iface, detail);
                                }
                                return this;
                            },
                            /** Hides this modal */ close: returnIface(close),
                            /**
             * Force closes this modal. This will not call beforeClose
             * events and will just immediately hide the modal
             */ forceClose: returnIface(forceClose),
                            /** Destroys this modal */ destroy: function() {
                                modalElem().destroy();
                                shadowElem().destroy();
                                shadowElem = modalElem = closeElem = undefined;
                            },
                            /**
             * Updates the options for this modal. This will only let you
             * change options that are re-evaluted regularly, such as
             * `overlayClose`.
             */ options: function(opts) {
                                Object.keys(opts).map(function(key) {
                                    options[key] = opts[key];
                                });
                            },
                            /** Executes after the DOM nodes are created */ afterCreate: returnIface(afterCreateEvent.watch),
                            /** Executes a callback before this modal is closed */ beforeShow: returnIface(beforeShowEvent.watch),
                            /** Executes a callback after this modal is shown */ afterShow: returnIface(afterShowEvent.watch),
                            /** Executes a callback before this modal is closed */ beforeClose: returnIface(beforeCloseEvent.watch),
                            /** Executes a callback after this modal is closed */ afterClose: returnIface(afterCloseEvent.watch)
                        };
                        manageFocus(iface, getOption.bind(null, "focus", true));
                        manageBodyOverflow(iface, getOption.bind(null, "bodyOverflow", true));
                        // If a user presses the 'escape' key, close the modal.
                        escapeKey.watch(function escapeKeyPress() {
                            if (getOption("escCloses", true) && iface.isVisible()) iface.close();
                        });
                        return iface;
                    };
                });
            /***/ },
            /***/ 262: /***/ function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {
                "use strict";
                // EXPORTS
                __webpack_require__.d(__webpack_exports__, {
                    "K": function() {
                        return /* binding */ jsonrepair;
                    }
                });
                function _typeof(obj) {
                    "@babel/helpers - typeof";
                    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
                        return typeof obj;
                    } : function(obj) {
                        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
                    }, _typeof(obj);
                }
                function _defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
                    }
                }
                function _createClass(Constructor, protoProps, staticProps) {
                    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) _defineProperties(Constructor, staticProps);
                    Object.defineProperty(Constructor, "prototype", {
                        writable: false
                    });
                    return Constructor;
                }
                function _toPropertyKey(arg) {
                    var key = _toPrimitive(arg, "string");
                    return _typeof(key) === "symbol" ? key : String(key);
                }
                function _toPrimitive(input, hint) {
                    if (_typeof(input) !== "object" || input === null) return input;
                    var prim = input[Symbol.toPrimitive];
                    if (prim !== undefined) {
                        var res = prim.call(input, hint || "default");
                        if (_typeof(res) !== "object") return res;
                        throw new TypeError("@@toPrimitive must return a primitive value.");
                    }
                    return (hint === "string" ? String : Number)(input);
                }
                function _classCallCheck(instance, Constructor) {
                    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
                }
                function _inherits(subClass, superClass) {
                    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
                    subClass.prototype = Object.create(superClass && superClass.prototype, {
                        constructor: {
                            value: subClass,
                            writable: true,
                            configurable: true
                        }
                    });
                    Object.defineProperty(subClass, "prototype", {
                        writable: false
                    });
                    if (superClass) _setPrototypeOf(subClass, superClass);
                }
                function _createSuper(Derived) {
                    var hasNativeReflectConstruct = _isNativeReflectConstruct();
                    return function _createSuperInternal() {
                        var Super = _getPrototypeOf(Derived), result;
                        if (hasNativeReflectConstruct) {
                            var NewTarget = _getPrototypeOf(this).constructor;
                            result = Reflect.construct(Super, arguments, NewTarget);
                        } else result = Super.apply(this, arguments);
                        return _possibleConstructorReturn(this, result);
                    };
                }
                function _possibleConstructorReturn(self1, call) {
                    if (call && (_typeof(call) === "object" || typeof call === "function")) return call;
                    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
                    return _assertThisInitialized(self1);
                }
                function _assertThisInitialized(self1) {
                    if (self1 === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                    return self1;
                }
                function _wrapNativeSuper(Class) {
                    var _cache = typeof Map === "function" ? new Map() : undefined;
                    _wrapNativeSuper = function _wrapNativeSuper(Class) {
                        if (Class === null || !_isNativeFunction(Class)) return Class;
                        if (typeof Class !== "function") throw new TypeError("Super expression must either be null or a function");
                        if (typeof _cache !== "undefined") {
                            if (_cache.has(Class)) return _cache.get(Class);
                            _cache.set(Class, Wrapper);
                        }
                        function Wrapper() {
                            return _construct(Class, arguments, _getPrototypeOf(this).constructor);
                        }
                        Wrapper.prototype = Object.create(Class.prototype, {
                            constructor: {
                                value: Wrapper,
                                enumerable: false,
                                writable: true,
                                configurable: true
                            }
                        });
                        return _setPrototypeOf(Wrapper, Class);
                    };
                    return _wrapNativeSuper(Class);
                }
                function _construct(Parent, args, Class) {
                    if (_isNativeReflectConstruct()) _construct = Reflect.construct.bind();
                    else _construct = function _construct(Parent, args, Class) {
                        var a = [
                            null
                        ];
                        a.push.apply(a, args);
                        var Constructor = Function.bind.apply(Parent, a);
                        var instance = new Constructor();
                        if (Class) _setPrototypeOf(instance, Class.prototype);
                        return instance;
                    };
                    return _construct.apply(null, arguments);
                }
                function _isNativeReflectConstruct() {
                    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
                    if (Reflect.construct.sham) return false;
                    if (typeof Proxy === "function") return true;
                    try {
                        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
                        return true;
                    } catch (e) {
                        return false;
                    }
                }
                function _isNativeFunction(fn) {
                    return Function.toString.call(fn).indexOf("[native code]") !== -1;
                }
                function _setPrototypeOf(o, p) {
                    _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
                        o.__proto__ = p;
                        return o;
                    };
                    return _setPrototypeOf(o, p);
                }
                function _getPrototypeOf(o) {
                    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
                        return o.__proto__ || Object.getPrototypeOf(o);
                    };
                    return _getPrototypeOf(o);
                }
                var JSONRepairError = /*#__PURE__*/ function(_Error) {
                    _inherits(JSONRepairError, _Error);
                    var _super = _createSuper(JSONRepairError);
                    function JSONRepairError(message, position) {
                        var _this;
                        _classCallCheck(this, JSONRepairError);
                        _this = _super.call(this, message + " at position " + position);
                        _this.position = position;
                        return _this;
                    }
                    return _createClass(JSONRepairError);
                }(/*#__PURE__*/ _wrapNativeSuper(Error));
                // TODO: sort the codes
                var codeBackslash = 0x5c; // "\"
                var codeSlash = 0x2f; // "/"
                var codeAsterisk = 0x2a; // "*"
                var codeOpeningBrace = 0x7b; // "{"
                var codeClosingBrace = 0x7d; // "}"
                var codeOpeningBracket = 0x5b; // "["
                var codeClosingBracket = 0x5d; // "]"
                var codeOpenParenthesis = 0x28; // "("
                var codeCloseParenthesis = 0x29; // ")"
                var codeSpace = 0x20; // " "
                var codeNewline = 0xa; // "\n"
                var codeTab = 0x9; // "\t"
                var codeReturn = 0xd; // "\r"
                var codeBackspace = 0x08; // "\b"
                var codeFormFeed = 0x0c; // "\f"
                var codeDoubleQuote = 0x0022; // "
                var codePlus = 0x2b; // "+"
                var codeMinus = 0x2d; // "-"
                var codeQuote = 0x27; // "'"
                var codeZero = 0x30;
                var codeOne = 0x31;
                var codeNine = 0x39;
                var codeComma = 0x2c; // ","
                var codeDot = 0x2e; // "." (dot, period)
                var codeColon = 0x3a; // ":"
                var codeSemicolon = 0x3b; // ";"
                var codeUppercaseA = 0x41; // "A"
                var codeLowercaseA = 0x61; // "a"
                var codeUppercaseE = 0x45; // "E"
                var codeLowercaseE = 0x65; // "e"
                var codeUppercaseF = 0x46; // "F"
                var codeLowercaseF = 0x66; // "f"
                var codeNonBreakingSpace = 0xa0;
                var codeEnQuad = 0x2000;
                var codeHairSpace = 0x200a;
                var codeNarrowNoBreakSpace = 0x202f;
                var codeMediumMathematicalSpace = 0x205f;
                var codeIdeographicSpace = 0x3000;
                var codeDoubleQuoteLeft = 0x201c; // “
                var codeDoubleQuoteRight = 0x201d; // ”
                var codeQuoteLeft = 0x2018; // ‘
                var codeQuoteRight = 0x2019; // ’
                var codeGraveAccent = 0x0060; // `
                var codeAcuteAccent = 0x00b4; // ´
                function isHex(code) {
                    return code >= codeZero && code <= codeNine || code >= codeUppercaseA && code <= codeUppercaseF || code >= codeLowercaseA && code <= codeLowercaseF;
                }
                function isDigit(code) {
                    return code >= codeZero && code <= codeNine;
                }
                function isNonZeroDigit(code) {
                    return code >= codeOne && code <= codeNine;
                }
                function isValidStringCharacter(code) {
                    return code >= 0x20 && code <= 0x10ffff;
                }
                function isDelimiter(char) {
                    return regexDelimiter.test(char) || char && isQuote(char.charCodeAt(0));
                }
                var regexDelimiter = /^[,:[\]{}()\n]$/;
                function isStartOfValue(char) {
                    return regexStartOfValue.test(char) || char && isQuote(char.charCodeAt(0));
                }
                // alpha, number, minus, or opening bracket or brace
                var regexStartOfValue = /^[[{\w-]$/;
                function isControlCharacter(code) {
                    return code === codeNewline || code === codeReturn || code === codeTab || code === codeBackspace || code === codeFormFeed;
                }
                /**
 * Check if the given character is a whitespace character like space, tab, or
 * newline
 */ function isWhitespace(code) {
                    return code === codeSpace || code === codeNewline || code === codeTab || code === codeReturn;
                }
                /**
 * Check if the given character is a special whitespace character, some
 * unicode variant
 */ function isSpecialWhitespace(code) {
                    return code === codeNonBreakingSpace || code >= codeEnQuad && code <= codeHairSpace || code === codeNarrowNoBreakSpace || code === codeMediumMathematicalSpace || code === codeIdeographicSpace;
                }
                /**
 * Test whether the given character is a quote or double quote character.
 * Also tests for special variants of quotes.
 */ function isQuote(code) {
                    // the first check double quotes, since that occurs most often
                    return isDoubleQuoteLike(code) || isSingleQuoteLike(code);
                }
                /**
 * Test whether the given character is a double quote character.
 * Also tests for special variants of double quotes.
 */ function isDoubleQuoteLike(code) {
                    // the first check double quotes, since that occurs most often
                    return code === codeDoubleQuote || code === codeDoubleQuoteLeft || code === codeDoubleQuoteRight;
                }
                /**
 * Test whether the given character is a double quote character.
 * Does NOT test for special variants of double quotes.
 */ function isDoubleQuote(code) {
                    return code === codeDoubleQuote;
                }
                /**
 * Test whether the given character is a single quote character.
 * Also tests for special variants of single quotes.
 */ function isSingleQuoteLike(code) {
                    return code === codeQuote || code === codeQuoteLeft || code === codeQuoteRight || code === codeGraveAccent || code === codeAcuteAccent;
                }
                /**
 * Strip last occurrence of textToStrip from text
 */ function stripLastOccurrence(text, textToStrip) {
                    var stripRemainingText = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
                    var index = text.lastIndexOf(textToStrip);
                    return index !== -1 ? text.substring(0, index) + (stripRemainingText ? "" : text.substring(index + 1)) : text;
                }
                function insertBeforeLastWhitespace(text, textToInsert) {
                    var index = text.length;
                    if (!isWhitespace(text.charCodeAt(index - 1))) // no trailing whitespaces
                    return text + textToInsert;
                    while(isWhitespace(text.charCodeAt(index - 1)))index--;
                    return text.substring(0, index) + textToInsert + text.substring(index);
                }
                function removeAtIndex(text, start, count) {
                    return text.substring(0, start) + text.substring(start + count);
                }
                /**
 * Test whether a string ends with a newline or comma character and optional whitespace
 */ function endsWithCommaOrNewline(text) {
                    return /[,\n][ \t\r]*$/.test(text);
                }
                var controlCharacters = {
                    "\b": "\\b",
                    "\f": "\\f",
                    "\n": "\\n",
                    "\r": "\\r",
                    "	": "\\t"
                };
                // map with all escape characters
                var escapeCharacters = {
                    '"': '"',
                    "\\": "\\",
                    "/": "/",
                    b: "\b",
                    f: "\f",
                    n: "\n",
                    r: "\r",
                    t: "	"
                };
                /**
 * Repair a string containing an invalid JSON document.
 * For example changes JavaScript notation into JSON notation.
 *
 * Example:
 *
 *     try {
 *       const json = "{name: 'John'}"
 *       const repaired = jsonrepair(json)
 *       console.log(repaired)
 *       // '{"name": "John"}'
 *     } catch (err) {
 *       console.error(err)
 *     }
 *
 */ function jsonrepair(text) {
                    var i = 0; // current index in text
                    var output = ""; // generated output
                    var processed = parseValue();
                    if (!processed) throwUnexpectedEnd();
                    var processedComma = parseCharacter(codeComma);
                    if (processedComma) parseWhitespaceAndSkipComments();
                    if (isStartOfValue(text[i]) && endsWithCommaOrNewline(output)) {
                        // start of a new value after end of the root level object: looks like
                        // newline delimited JSON -> turn into a root level array
                        if (!processedComma) // repair missing comma
                        output = insertBeforeLastWhitespace(output, ",");
                        parseNewlineDelimitedJSON();
                    } else if (processedComma) // repair: remove trailing comma
                    output = stripLastOccurrence(output, ",");
                    if (i >= text.length) // reached the end of the document properly
                    return output;
                    throwUnexpectedCharacter();
                    function parseValue() {
                        parseWhitespaceAndSkipComments();
                        var processed = parseObject() || parseArray() || parseString() || parseNumber() || parseKeywords() || parseUnquotedString();
                        parseWhitespaceAndSkipComments();
                        return processed;
                    }
                    function parseWhitespaceAndSkipComments() {
                        var start = i;
                        var changed = parseWhitespace();
                        do {
                            changed = parseComment();
                            if (changed) changed = parseWhitespace();
                        }while (changed);
                        return i > start;
                    }
                    function parseWhitespace() {
                        var whitespace = "";
                        var normal;
                        while((normal = isWhitespace(text.charCodeAt(i))) || isSpecialWhitespace(text.charCodeAt(i))){
                            if (normal) whitespace += text[i];
                            else // repair special whitespace
                            whitespace += " ";
                            i++;
                        }
                        if (whitespace.length > 0) {
                            output += whitespace;
                            return true;
                        }
                        return false;
                    }
                    function parseComment() {
                        // find a block comment '/* ... */'
                        if (text.charCodeAt(i) === codeSlash && text.charCodeAt(i + 1) === codeAsterisk) {
                            // repair block comment by skipping it
                            while(i < text.length && !atEndOfBlockComment(text, i))i++;
                            i += 2;
                            return true;
                        }
                        // find a line comment '// ...'
                        if (text.charCodeAt(i) === codeSlash && text.charCodeAt(i + 1) === codeSlash) {
                            // repair line comment by skipping it
                            while(i < text.length && text.charCodeAt(i) !== codeNewline)i++;
                            return true;
                        }
                        return false;
                    }
                    function parseCharacter(code) {
                        if (text.charCodeAt(i) === code) {
                            output += text[i];
                            i++;
                            return true;
                        }
                        return false;
                    }
                    function skipCharacter(code) {
                        if (text.charCodeAt(i) === code) {
                            i++;
                            return true;
                        }
                        return false;
                    }
                    function skipEscapeCharacter() {
                        return skipCharacter(codeBackslash);
                    }
                    /**
   * Parse an object like '{"key": "value"}'
   */ function parseObject() {
                        if (text.charCodeAt(i) === codeOpeningBrace) {
                            output += "{";
                            i++;
                            parseWhitespaceAndSkipComments();
                            var initial = true;
                            while(i < text.length && text.charCodeAt(i) !== codeClosingBrace){
                                var _processedComma = void 0;
                                if (!initial) {
                                    _processedComma = parseCharacter(codeComma);
                                    if (!_processedComma) // repair missing comma
                                    output = insertBeforeLastWhitespace(output, ",");
                                    parseWhitespaceAndSkipComments();
                                } else {
                                    _processedComma = true;
                                    initial = false;
                                }
                                var processedKey = parseString() || parseUnquotedString();
                                if (!processedKey) {
                                    if (text.charCodeAt(i) === codeClosingBrace || text.charCodeAt(i) === codeOpeningBrace || text.charCodeAt(i) === codeClosingBracket || text.charCodeAt(i) === codeOpeningBracket || text[i] === undefined) // repair trailing comma
                                    output = stripLastOccurrence(output, ",");
                                    else throwObjectKeyExpected();
                                    break;
                                }
                                parseWhitespaceAndSkipComments();
                                var processedColon = parseCharacter(codeColon);
                                if (!processedColon) {
                                    if (isStartOfValue(text[i])) // repair missing colon
                                    output = insertBeforeLastWhitespace(output, ":");
                                    else throwColonExpected();
                                }
                                var processedValue = parseValue();
                                if (!processedValue) {
                                    if (processedColon) throwObjectValueExpected();
                                    else throwColonExpected();
                                }
                            }
                            if (text.charCodeAt(i) === codeClosingBrace) {
                                output += "}";
                                i++;
                            } else // repair missing end bracket
                            output = insertBeforeLastWhitespace(output, "}");
                            return true;
                        }
                        return false;
                    }
                    /**
   * Parse an array like '["item1", "item2", ...]'
   */ function parseArray() {
                        if (text.charCodeAt(i) === codeOpeningBracket) {
                            output += "[";
                            i++;
                            parseWhitespaceAndSkipComments();
                            var initial = true;
                            while(i < text.length && text.charCodeAt(i) !== codeClosingBracket){
                                if (!initial) {
                                    var _processedComma2 = parseCharacter(codeComma);
                                    if (!_processedComma2) // repair missing comma
                                    output = insertBeforeLastWhitespace(output, ",");
                                } else initial = false;
                                var processedValue = parseValue();
                                if (!processedValue) {
                                    // repair trailing comma
                                    output = stripLastOccurrence(output, ",");
                                    break;
                                }
                            }
                            if (text.charCodeAt(i) === codeClosingBracket) {
                                output += "]";
                                i++;
                            } else // repair missing closing array bracket
                            output = insertBeforeLastWhitespace(output, "]");
                            return true;
                        }
                        return false;
                    }
                    /**
   * Parse and repair Newline Delimited JSON (NDJSON):
   * multiple JSON objects separated by a newline character
   */ function parseNewlineDelimitedJSON() {
                        // repair NDJSON
                        var initial = true;
                        var processedValue = true;
                        while(processedValue){
                            if (!initial) {
                                // parse optional comma, insert when missing
                                var _processedComma3 = parseCharacter(codeComma);
                                if (!_processedComma3) // repair: add missing comma
                                output = insertBeforeLastWhitespace(output, ",");
                            } else initial = false;
                            processedValue = parseValue();
                        }
                        if (!processedValue) // repair: remove trailing comma
                        output = stripLastOccurrence(output, ",");
                        // repair: wrap the output inside array brackets
                        output = "[\n".concat(output, "\n]");
                    }
                    /**
   * Parse a string enclosed by double quotes "...". Can contain escaped quotes
   * Repair strings enclosed in single quotes or special quotes
   * Repair an escaped string
   */ function parseString() {
                        var skipEscapeChars = text.charCodeAt(i) === codeBackslash;
                        if (skipEscapeChars) {
                            // repair: remove the first escape character
                            i++;
                            skipEscapeChars = true;
                        }
                        if (isQuote(text.charCodeAt(i))) {
                            var isEndQuote = isSingleQuoteLike(text.charCodeAt(i)) ? isSingleQuoteLike : isDoubleQuote(text.charCodeAt(i)) ? isDoubleQuote // eslint-disable-line indent
                             : isDoubleQuoteLike; // eslint-disable-line indent
                            output += '"';
                            i++;
                            while(i < text.length && !isEndQuote(text.charCodeAt(i))){
                                if (text.charCodeAt(i) === codeBackslash) {
                                    var char = text[i + 1];
                                    var escapeChar = escapeCharacters[char];
                                    if (escapeChar !== undefined) {
                                        output += text.slice(i, i + 2);
                                        i += 2;
                                    } else if (char === "u") {
                                        if (isHex(text.charCodeAt(i + 2)) && isHex(text.charCodeAt(i + 3)) && isHex(text.charCodeAt(i + 4)) && isHex(text.charCodeAt(i + 5))) {
                                            output += text.slice(i, i + 6);
                                            i += 6;
                                        } else throwInvalidUnicodeCharacter(i);
                                    } else {
                                        // repair invalid escape character: remove it
                                        output += char;
                                        i += 2;
                                    }
                                } else {
                                    var _char = text[i];
                                    var code = text.charCodeAt(i);
                                    if (code === codeDoubleQuote && text.charCodeAt(i - 1) !== codeBackslash) {
                                        // repair unescaped double quote
                                        output += "\\" + _char;
                                        i++;
                                    } else if (isControlCharacter(code)) {
                                        // unescaped control character
                                        output += controlCharacters[_char];
                                        i++;
                                    } else {
                                        if (!isValidStringCharacter(code)) throwInvalidCharacter(_char);
                                        output += _char;
                                        i++;
                                    }
                                }
                                if (skipEscapeChars) {
                                    var _processed = skipEscapeCharacter();
                                    _processed;
                                }
                            }
                            if (isQuote(text.charCodeAt(i))) {
                                text.charCodeAt(i);
                                output += '"';
                                i++;
                            } else // repair missing end quote
                            output += '"';
                            parseConcatenatedString();
                            return true;
                        }
                        return false;
                    }
                    /**
   * Repair concatenated strings like "hello" + "world", change this into "helloworld"
   */ function parseConcatenatedString() {
                        var processed = false;
                        parseWhitespaceAndSkipComments();
                        while(text.charCodeAt(i) === codePlus){
                            processed = true;
                            i++;
                            parseWhitespaceAndSkipComments();
                            // repair: remove the end quote of the first string
                            output = stripLastOccurrence(output, '"', true);
                            var start = output.length;
                            parseString();
                            // repair: remove the start quote of the second string
                            output = removeAtIndex(output, start, 1);
                        }
                        return processed;
                    }
                    /**
   * Parse a number like 2.4 or 2.4e6
   */ function parseNumber() {
                        var start = i;
                        if (text.charCodeAt(i) === codeMinus) {
                            i++;
                            if (expectDigitOrRepair(start)) return true;
                        }
                        if (text.charCodeAt(i) === codeZero) i++;
                        else if (isNonZeroDigit(text.charCodeAt(i))) {
                            i++;
                            while(isDigit(text.charCodeAt(i)))i++;
                        }
                        if (text.charCodeAt(i) === codeDot) {
                            i++;
                            if (expectDigitOrRepair(start)) return true;
                            while(isDigit(text.charCodeAt(i)))i++;
                        }
                        if (text.charCodeAt(i) === codeLowercaseE || text.charCodeAt(i) === codeUppercaseE) {
                            i++;
                            if (text.charCodeAt(i) === codeMinus || text.charCodeAt(i) === codePlus) i++;
                            if (expectDigitOrRepair(start)) return true;
                            while(isDigit(text.charCodeAt(i)))i++;
                        }
                        if (i > start) {
                            output += text.slice(start, i);
                            return true;
                        }
                        return false;
                    }
                    /**
   * Parse keywords true, false, null
   * Repair Python keywords True, False, None
   */ function parseKeywords() {
                        return parseKeyword("true", "true") || parseKeyword("false", "false") || parseKeyword("null", "null") || // repair Python keywords True, False, None
                        parseKeyword("True", "true") || parseKeyword("False", "false") || parseKeyword("None", "null");
                    }
                    function parseKeyword(name, value) {
                        if (text.slice(i, i + name.length) === name) {
                            output += value;
                            i += name.length;
                            return true;
                        }
                        return false;
                    }
                    /**
   * Repair and unquoted string by adding quotes around it
   * Repair a MongoDB function call like NumberLong("2")
   * Repair a JSONP function call like callback({...});
   */ function parseUnquotedString() {
                        // note that the symbol can end with whitespaces: we stop at the next delimiter
                        var start = i;
                        while(i < text.length && !isDelimiter(text[i]))i++;
                        if (i > start) {
                            if (text.charCodeAt(i) === codeOpenParenthesis) {
                                // repair a MongoDB function call like NumberLong("2")
                                // repair a JSONP function call like callback({...});
                                i++;
                                parseValue();
                                if (text.charCodeAt(i) === codeCloseParenthesis) {
                                    // repair: skip close bracket of function call
                                    i++;
                                    if (text.charCodeAt(i) === codeSemicolon) // repair: skip semicolon after JSONP call
                                    i++;
                                }
                                return true;
                            } else {
                                // repair unquoted string
                                // first, go back to prevent getting trailing whitespaces in the string
                                while(isWhitespace(text.charCodeAt(i - 1)) && i > 0)i--;
                                var symbol = text.slice(start, i);
                                output += JSON.stringify(symbol);
                                return true;
                            }
                        }
                    }
                    function expectDigit(start) {
                        if (!isDigit(text.charCodeAt(i))) {
                            var numSoFar = text.slice(start, i);
                            throw new JSONRepairError("Invalid number '".concat(numSoFar, "', expecting a digit ").concat(got()), 2);
                        }
                    }
                    function expectDigitOrRepair(start) {
                        if (i >= text.length) {
                            // repair numbers cut off at the end
                            // this will only be called when we end after a '.', '-', or 'e' and does not
                            // change the number more than it needs to make it valid JSON
                            output += text.slice(start, i) + "0";
                            return true;
                        } else {
                            expectDigit(start);
                            return false;
                        }
                    }
                    function throwInvalidCharacter(char) {
                        throw new JSONRepairError("Invalid character " + JSON.stringify(char), i);
                    }
                    function throwUnexpectedCharacter() {
                        throw new JSONRepairError("Unexpected character " + JSON.stringify(text[i]), i);
                    }
                    function throwUnexpectedEnd() {
                        throw new JSONRepairError("Unexpected end of json string", text.length);
                    }
                    function throwObjectKeyExpected() {
                        throw new JSONRepairError("Object key expected", i);
                    }
                    function throwObjectValueExpected() {
                        throw new JSONRepairError("Object value expected", i);
                    }
                    function throwColonExpected() {
                        throw new JSONRepairError("Colon expected", i);
                    }
                    function throwInvalidUnicodeCharacter(start) {
                        var end = start + 2;
                        while(/\w/.test(text[end]))end++;
                        var chars = text.slice(start, end);
                        throw new JSONRepairError('Invalid unicode character "'.concat(chars, '"'), i);
                    }
                    function got() {
                        return text[i] ? "but got '".concat(text[i], "'") : "but reached end of input";
                    }
                }
                function atEndOfBlockComment(text, i) {
                    return text[i] === "*" && text[i + 1] === "/";
                }
            /***/ }
        };
        /************************************************************************/ /******/ // The module cache
        /******/ var __webpack_module_cache__ = {};
        /******/ /******/ // The require function
        /******/ function __webpack_require__(moduleId) {
            /******/ // Check if module is in cache
            /******/ var cachedModule = __webpack_module_cache__[moduleId];
            /******/ if (cachedModule !== undefined) /******/ return cachedModule.exports;
            /******/ // Create a new module (and put it into the cache)
            /******/ var module1 = __webpack_module_cache__[moduleId] = {
                /******/ // no module.id needed
                /******/ // no module.loaded needed
                /******/ exports: {}
            };
            /******/ /******/ // Execute the module function
            /******/ __webpack_modules__[moduleId].call(module1.exports, module1, module1.exports, __webpack_require__);
            /******/ /******/ // Return the exports of the module
            /******/ return module1.exports;
        /******/ }
        /******/ /************************************************************************/ /******/ /* webpack/runtime/compat get default export */ /******/ !function() {
            /******/ // getDefaultExport function for compatibility with non-harmony modules
            /******/ __webpack_require__.n = function(module1) {
                /******/ var getter = module1 && module1.__esModule ? /******/ function() {
                    return module1["default"];
                } : /******/ function() {
                    return module1;
                };
                /******/ __webpack_require__.d(getter, {
                    a: getter
                });
                /******/ return getter;
            /******/ };
        /******/ }();
        /******/ /******/ /* webpack/runtime/define property getters */ /******/ !function() {
            /******/ // define getter functions for harmony exports
            /******/ __webpack_require__.d = function(exports, definition) {
                /******/ for(var key in definition)/******/ if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) /******/ Object.defineProperty(exports, key, {
                    enumerable: true,
                    get: definition[key]
                });
            /******/ };
        /******/ }();
        /******/ /******/ /* webpack/runtime/hasOwnProperty shorthand */ /******/ !function() {
            /******/ __webpack_require__.o = function(obj, prop) {
                return Object.prototype.hasOwnProperty.call(obj, prop);
            };
        /******/ }();
        /******/ /******/ /* webpack/runtime/make namespace object */ /******/ !function() {
            /******/ // define __esModule on exports
            /******/ __webpack_require__.r = function(exports) {
                /******/ if (typeof Symbol !== "undefined" && Symbol.toStringTag) /******/ Object.defineProperty(exports, Symbol.toStringTag, {
                    value: "Module"
                });
                /******/ Object.defineProperty(exports, "__esModule", {
                    value: true
                });
            /******/ };
        /******/ }();
        /******/ /************************************************************************/ /******/ /******/ // startup
        /******/ // Load entry module and return exports
        /******/ // This entry module is referenced by other modules so it can't be inlined
        /******/ var __webpack_exports__ = __webpack_require__(161);
        /******/ /******/ return __webpack_exports__;
    /******/ }();
});

},{}],"XQLmh":[function() {},{}],"lvjRC":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _base = require("@emotion/styled/base");
var _baseDefault = parcelHelpers.interopDefault(_base);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _testCaseContainer = require("../../hooks/TestCaseContainer");
var _testCaseContainerDefault = parcelHelpers.interopDefault(_testCaseContainer);
var _colors = require("../../constants/colors");
var _useWindowSize = require("../../hooks/UseWindowSize");
var _useWindowSizeDefault = parcelHelpers.interopDefault(_useWindowSize);
var _reactCustomScrollbars = require("react-custom-scrollbars");
var _reactCustomScrollbarsDefault = parcelHelpers.interopDefault(_reactCustomScrollbars);
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const TestCaseHistoryViewer = ({ currentTestCase })=>{
    const [turns, setTurns] = (0, _react1.useState)([]);
    const testCaseContainer = (0, _testCaseContainerDefault.default).useContainer();
    const windowSize = (0, _useWindowSizeDefault.default)();
    const MODAL_SCROLLBAR_SUBTRACTION = 185;
    const subScrollbarRef = (0, _react1.useRef)(null);
    (0, _react1.useEffect)(()=>{
        if (subScrollbarRef?.current) subScrollbarRef?.current.scrollToBottom();
    }, [
        turns
    ]);
    (0, _react1.useEffect)(()=>{
        let tc = currentTestCase;
        var turnHistoryState = tc.sessionState.sessionAttributes["ConversationTurnHistoryState"];
        if (!turnHistoryState) turnHistoryState = tc.sessionState.sessionAttributes["conversationTurnHistoryState"];
        if (turnHistoryState?.TurnHistory?.length) {
            const newTurns = [];
            for (const turn of turnHistoryState.TurnHistory)newTurns.push({
                user: turn.UserInput,
                assistant: turn.AssistantResponse
            });
            setTurns(newTurns);
            if (subScrollbarRef?.current) subScrollbarRef?.current.scrollToBottom();
        }
    }, [
        currentTestCase
    ]);
    return (0, _react.jsx)(HistoryViewer, null, (0, _react.jsx)((0, _reactCustomScrollbarsDefault.default), {
        autoHide: true,
        autoHeight: true,
        autoHeightMin: 250,
        autoHeightMax: 250,
        ref: subScrollbarRef
    }, (0, _react.jsx)(HistoryViewerInScroll, null, turns.map((turn, i)=>(0, _react.jsx)("div", {
            key: i
        }, (0, _react.jsx)(LabelWrapper, null, (0, _react.jsx)(SmallLabel, null, "User")), (0, _react.jsx)(LabelWrapper, null, (0, _react.jsx)(InfoLabel, null, `${turn.user}`)), (0, _react.jsx)(LabelWrapper, null, (0, _react.jsx)(SmallLabel, null, "Assistant")), (0, _react.jsx)(LabelWrapper, null, (0, _react.jsx)(InfoLabel, null, `${turn.assistant}`)))), testCaseContainer?.fullResponses[currentTestCase?.name]?.outputSpeech?.length ? (0, _react.jsx)(FinalTurnWrapper, null, (0, _react.jsx)(LabelWrapper, null, (0, _react.jsx)(BoldSmallLabel, null, "User")), (0, _react.jsx)(LabelWrapper, null, (0, _react.jsx)(BoldInfoLabel, null, `${currentTestCase.text}`)), (0, _react.jsx)(LabelWrapper, null, (0, _react.jsx)(BoldSmallLabel, null, "Assistant")), (0, _react.jsx)(LabelWrapper, null, (0, _react.jsx)(BoldInfoLabel, null, `${testCaseContainer?.fullResponses[currentTestCase?.name]?.outputSpeech}`))) : currentTestCase?.text?.length ? (0, _react.jsx)(FinalTurnWrapper, null, (0, _react.jsx)(LabelWrapper, null, (0, _react.jsx)(BoldSmallLabel, null, "User")), (0, _react.jsx)(LabelWrapper, null, (0, _react.jsx)(BoldInfoLabel, null, `${currentTestCase.text}`))) : (0, _react.jsx)((0, _reactDefault.default).Fragment, null))));
};
exports.default = TestCaseHistoryViewer;
const LabelWrapper = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1w8afop7"
})({
    name: "ho1qnd",
    styles: "display:flex;flex-direction:row"
});
const SmallLabel = /*#__PURE__*/ (0, _baseDefault.default)("p", {
    target: "e1w8afop6"
})("font-weight:400;font-size:14px;color:", (0, _colors.color_shades_darkest), ";margin:0 0 4px 0px;");
const BoldSmallLabel = /*#__PURE__*/ (0, _baseDefault.default)(SmallLabel, {
    target: "e1w8afop5"
})("font-weight:bold;color:", (0, _colors.color_defaults_black), ";");
const InfoLabel = /*#__PURE__*/ (0, _baseDefault.default)("p", {
    target: "e1w8afop4"
})("font-weight:300;font-size:14px;font-style:italic;color:", (0, _colors.color_shades_darker), ";margin:0 0 4px 0px;");
const BoldInfoLabel = /*#__PURE__*/ (0, _baseDefault.default)(InfoLabel, {
    target: "e1w8afop3"
})("font-weight:bold;color:", (0, _colors.color_defaults_black), ";");
const FinalTurnWrapper = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1w8afop2"
})("");
const HistoryViewer = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1w8afop1"
})("border-radius:8px;display:block;background-color:", (0, _colors.color_shades_lighter), ";height:250px;margin:0px 16px;");
const HistoryViewerInScroll = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1w8afop0"
})({
    name: "q9jxqs",
    styles: "padding:16px 0px;margin:0 16px"
});

},{"@emotion/styled/base":"lSuFu","@emotion/react":"djZKr","react":"6uln9","../../hooks/TestCaseContainer":"cLg3U","../../constants/colors":"1p3OR","../../hooks/UseWindowSize":"43j9z","react-custom-scrollbars":"f2YFt","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4D83Y":[function(require,module,exports) {
module.exports = require("21e6bf64511509c1").getBundleURL("kVLro") + require("630f1a6195e08064").resolve("bLVdP");

},{"21e6bf64511509c1":"c7Tr5","630f1a6195e08064":"fyJL2"}],"9akQy":[function(require,module,exports) {
module.exports = require("2fe330c6116d522f").getBundleURL("kVLro") + require("9f2f3f6c4409fc91").resolve("ddGkZ");

},{"2fe330c6116d522f":"c7Tr5","9f2f3f6c4409fc91":"fyJL2"}],"8RZxX":[function(require,module,exports) {
module.exports = require("90823cab70b6c85e").getBundleURL("kVLro") + require("552894f45f077441").resolve("aXCHc");

},{"90823cab70b6c85e":"c7Tr5","552894f45f077441":"fyJL2"}],"2osOD":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _defineProperty = require("@babel/runtime/helpers/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _unstated = require("unstated");
// container for the state of the page title.
// use this for managing the title of the dashboard 
// and updating based on the page that is current
class TitleStateContainer extends (0, _unstated.Container) {
    constructor(...args){
        super(...args);
        (0, _definePropertyDefault.default)(this, "state", {
            title: "",
            breadcrumb: [],
            application: null
        });
    }
    setTitle(text) {
        if (this.state.title == text) return;
        this.setState({
            ...this.state,
            title: text
        });
    }
    setTitleView(title, breadcrumb, application) {
        this.setState({
            ...this.state,
            title,
            breadcrumb,
            application
        });
    }
}
exports.default = TitleStateContainer;

},{"@babel/runtime/helpers/defineProperty":"9sJxO","unstated":"grh7p","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"dUUA3":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _backButton = require("../../components/general/BackButton");
var _backButtonDefault = parcelHelpers.interopDefault(_backButton);
var _reactTabs = require("react-tabs");
var _pageContainer = require("../../components/structure/PageContainer");
var _pageContainerDefault = parcelHelpers.interopDefault(_pageContainer);
var _headerTitleView = require("../../components/structure/HeaderTitleView");
var _headerTitleViewDefault = parcelHelpers.interopDefault(_headerTitleView);
var _detailLabel = require("../../components/general/DetailLabel");
var _detailLabelDefault = parcelHelpers.interopDefault(_detailLabel);
var _loader = require("../../components/general/Loader");
var _loaderDefault = parcelHelpers.interopDefault(_loader);
var _fullPageTabbedPanel = require("../../components/structure/Panels/FullPageTabbedPanel");
var _fullPageTabbedPanelDefault = parcelHelpers.interopDefault(_fullPageTabbedPanel);
var _scrollablePanelBody = require("../../components/structure/ScrollablePanelBody");
var _scrollablePanelBodyDefault = parcelHelpers.interopDefault(_scrollablePanelBody);
var _applicationContentMenuSelector = require("../applicationContentMenuSelector");
var _applicationContentMenuSelectorDefault = parcelHelpers.interopDefault(_applicationContentMenuSelector);
var _pageError = require("../../components/general/PageError");
var _pageErrorDefault = parcelHelpers.interopDefault(_pageError);
var _css = require("@emotion/css");
var _extensions = require("../../models/extensions");
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const contentEditIcon = require("788221cf2a809cc1");
const analyticsIcon = require("6047b7ecbaff9e94");
const GenericCreateContentItemPage = (props)=>{
    const [accessType, setAccessType] = (0, _react1.useState)(null);
    const [isPublishing, setIsPublishing] = (0, _react1.useState)(false);
    (0, _react1.useEffect)(()=>{
        const asyncLoad = async ()=>{
            const featureResult = await props.featureContainer.getApplicationFeature(props.match.params.applicationFeatureId);
            props.applicationContainer.state.currentApp ?? await props.applicationContainer.loadCurrentAppById(featureResult.data.applicationId);
            props.stateContainer.setInitialCreateState();
        };
        asyncLoad();
    }, []);
    const getBreadCrumbItems = ()=>{
        var ancestors = props.featureContainer.getAllAncestors(props.match.params.applicationFeatureId);
        var crumbs = ancestors?.reverse()?.map((af)=>({
                id: af?.id,
                title: af.parentId ? af?.name ?? af.feature?.name ?? af?.feature?.featureType?.name ?? "Untitled" : "Home",
                link: `/v/apps/${props.applicationContainer.state.currentApp?.id}/content/${af?.id}`
            }));
        return crumbs;
    };
    const handleSubmit = async (model, onSuccess)=>{
        const result = await props.stateContainer.createFromModel({
            ...model,
            applicationFeatureId: props.match.params.applicationFeatureId,
            applicationId: props.applicationContainer.state.currentApp?.id
        });
        if (result.resultType == "Ok") {
            if (onSuccess) onSuccess(result);
            // Full update was successful
            if (props.stateContainer.state.hasWebhookUpdate) await props.stateContainer.bulkUpdateContentItemWebhookInstances(result.data.id, props.stateContainer.state.webhookUpdates);
            // Update edited content state, redirect to edit content page             
            props.featureContainer?.addOrUpdateContentItem(result.data, result.data.responses[0], props.stateContainer.featureTypeId);
            let editUrl = (0, _extensions.getEditUrl)(result.data.id, props.match.params.applicationFeatureId, props.stateContainer.featureTypeId);
            if (isPublishing) // Redirect and open publish form
            editUrl = `${editUrl}?publishing=true`;
            props.history.push(editUrl);
        }
        return result;
    };
    const handleClose = ()=>{
        props.history.push(`/v/apps/${props.applicationContainer.state.currentApp.id}/content/${props.match.params.applicationFeatureId}`);
    };
    const isLoading = props.stateContainer.state.isLoading;
    if (!props.applicationContainer.state.currentApp) return (0, _react.jsx)((0, _loaderDefault.default), null);
    return (0, _react.jsx)((0, _reactDefault.default).Fragment, null, (0, _react.jsx)((0, _fullPageTabbedPanelDefault.default), {
        tabs: [
            {
                title: "Content Edit",
                icon: contentEditIcon,
                selectedIcon: contentEditIcon
            },
            {
                title: "Analytics",
                icon: analyticsIcon,
                selectedIcon: analyticsIcon
            }
        ],
        leftRender: ()=>(0, _react.jsx)((0, _reactDefault.default).Fragment, null, (0, _react.jsx)((0, _backButtonDefault.default), {
                onClick: handleClose.bind(undefined)
            }), (0, _react.jsx)((0, _applicationContentMenuSelectorDefault.default), {
                application: props.applicationContainer.state.currentApp,
                featureTypeId: props.featureTypeId,
                history: props.history
            })),
        titleRender: ()=>(0, _react.jsx)((0, _headerTitleViewDefault.default), {
                text: props.defaultTitle,
                breadcrumb: getBreadCrumbItems(),
                app: props.applicationContainer.state.currentApp
            }),
        rightRender: ()=>null
    }, (0, _react.jsx)((0, _reactTabs.TabPanel), null, !isLoading ? props.formRender(props.applicationContainer.state.currentApp, props.applicationContainer.state.assistantApplication, ()=>setIsPublishing(true), handleSubmit, setAccessType) : (0, _react.jsx)((0, _loaderDefault.default), null)), (0, _react.jsx)((0, _reactTabs.TabPanel), null, (0, _react.jsx)((0, _scrollablePanelBodyDefault.default), {
        className: paddedStyle
    }, (0, _react.jsx)((0, _pageContainerDefault.default), null, !isLoading ? (0, _react.jsx)((0, _detailLabelDefault.default), {
        text: "Here’s where you'll be able to see analytics for  item once it is published and used."
    }) : (0, _react.jsx)((0, _loaderDefault.default), null))))), (0, _react.jsx)((0, _pageErrorDefault.default), {
        errors: props.stateContainer?.state?.errors,
        onClear: ()=>props.stateContainer.clearErrors()
    }));
};
const paddedStyle = /*#__PURE__*/ (0, _css.css)({
    name: "knjsbg",
    styles: "padding:32px"
});
exports.default = GenericCreateContentItemPage;

},{"@emotion/react":"djZKr","react":"6uln9","../../components/general/BackButton":"jZrQd","react-tabs":"92Sgf","../../components/structure/PageContainer":"hc1r8","../../components/structure/HeaderTitleView":"4unvp","../../components/general/DetailLabel":"j3EnX","../../components/general/Loader":"bnV5T","../../components/structure/Panels/FullPageTabbedPanel":"72bEo","../../components/structure/ScrollablePanelBody":"6LRg3","../applicationContentMenuSelector":"3nrW0","../../components/general/PageError":"ezFTm","@emotion/css":"awUBr","../../models/extensions":"7h01B","788221cf2a809cc1":"sFXKk","6047b7ecbaff9e94":"7VuKq","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jZrQd":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _button = require("./Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _breakpoints = require("../../constants/breakpoints");
const closeIcon = require("b985bb165e42f81a");
const BackButton = (props)=>(0, _react.jsx)((0, _buttonDefault.default), {
        themes: [
            "inverse"
        ],
        onClick: props.onClick,
        text: "Back",
        icon: closeIcon,
        additionalClasses: backStyle
    });
const backStyle = /*#__PURE__*/ (0, _css.css)("width:160px;", (0, _breakpoints.breakpoint_small), "{font-size:14px;width:100px;img{width:18px;}}", "");
exports.default = BackButton;

},{"@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","./Button":"6ymxN","../../constants/breakpoints":"2F01A","b985bb165e42f81a":"4zwnK","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4zwnK":[function(require,module,exports) {
module.exports = require("5bfd00cd7ee7951c").getBundleURL("kVLro") + require("dbfa2ed0e7dd1f7d").resolve("gSdFh");

},{"5bfd00cd7ee7951c":"c7Tr5","dbfa2ed0e7dd1f7d":"fyJL2"}],"4unvp":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _base = require("@emotion/styled/base");
var _baseDefault = parcelHelpers.interopDefault(_base);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _colors = require("../../constants/colors");
var _reactRouterDom = require("react-router-dom");
var _breakpoints = require("../../constants/breakpoints");
var _sparkContainer = require("../../hooks/SparkContainer");
var _sparkContainerDefault = parcelHelpers.interopDefault(_sparkContainer);
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const separatorIcon = require("7299d8e99c238d60");
const HeaderTitleView = (props)=>{
    const sparkContainer = (0, _sparkContainerDefault.default).useContainer();
    return (0, _react.jsx)("div", {
        key: props.app?.id,
        className: `${titleStyle} ${!props.forceTitle ? displayNoneStyle : ""}`
    }, (0, _react.jsx)("div", null, (0, _react.jsx)("div", {
        className: breadcrumbContainer
    }, props.breadcrumb !== undefined && props.breadcrumb !== null && props.breadcrumb.length > 0 ? props.breadcrumb.map((b, i)=>(0, _react.jsx)("div", {
            key: i
        }, (0, _react.jsx)((0, _reactRouterDom.Link), {
            to: b.link
        }, (0, _react.jsx)("span", null, b.title)), i < props.breadcrumb.length - 1 ? (0, _react.jsx)("img", {
            src: separatorIcon
        }) : null)) : null), (0, _react.jsx)(MainTitle, null, props.titleImage && (0, _react.jsx)("div", {
        className: "title-image-border ac-header-title-image"
    }, (0, _react.jsx)("img", {
        src: props.titleImage
    })), (0, _react.jsx)(MainTitleText, {
        forceShow: props.forceTitle,
        className: sparkContainer.inSpark ? "spark-title" : "ac-title-image"
    }, props.text))));
};
const MainTitle = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e14650zk1"
})({
    name: "eaevu1",
    styles: "display:flex;flex-direction:row;.title-image-border{width:24px;height:24px;margin:6px 8px 0px 0px;border:1px solid white;border-radius:8px;box-sizing:border-box;text-align:center;img{height:17px;margin-top:2px;}}"
});
const MainTitleText = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e14650zk0"
})("font-size:30px;&.spark-title{", (props)=>props.forceShow ? `display: block !important; font-size: 30px !important;` : "", ";", (0, _breakpoints.breakpoint_small), "{display:none;font-size:0px;}}");
const titleStyle = /*#__PURE__*/ (0, _css.css)('flex:1;display:flex;flex-direction:row;align-items:center;padding:13px 0;margin:0 32px;height:58px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;h1{font-family:Muli,"sans-serif";font-size:30px;font-weight:normal;font-style:normal;font-stretch:normal;line-height:normal;letter-spacing:normal;text-align:left;color:', (0, _colors.color_text_inverse), ";word-wrap:normal;text-overflow:ellipsis;}.title-avatar{margin-right:12px;}span{font-family:Muli;font-size:14px;font-weight:normal;font-style:normal;font-stretch:normal;line-height:normal;letter-spacing:normal;}", "");
const displayNoneStyle = /*#__PURE__*/ (0, _css.css)((0, _breakpoints.breakpoint_small), "{display:none;}", "");
const breadcrumbContainer = /*#__PURE__*/ (0, _css.css)("display:flex;align-items:center;a{color:", (0, _colors.color_shades_light), ";margin:0 4px;&:hover{span{color:white;}}}img{margin:0 10px;}", "");
exports.default = HeaderTitleView;

},{"@emotion/styled/base":"lSuFu","@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","../../constants/colors":"1p3OR","react-router-dom":"5fzqq","../../constants/breakpoints":"2F01A","../../hooks/SparkContainer":"jzXzx","7299d8e99c238d60":"4ljSl","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jzXzx":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _unstatedNext = require("unstated-next");
function useSparkContainer() {
    const [inSpark, setInSpark] = (0, _react.useState)(false);
    return {
        setInSpark,
        inSpark
    };
}
const SparkContainer = (0, _unstatedNext.createContainer)(useSparkContainer);
exports.default = SparkContainer;

},{"react":"6uln9","unstated-next":"61zE5","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4ljSl":[function(require,module,exports) {
module.exports = require("21477c80d01ea157").getBundleURL("kVLro") + require("283bbbe42497a953").resolve("9rAJh");

},{"21477c80d01ea157":"c7Tr5","283bbbe42497a953":"fyJL2"}],"72bEo":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _reactTabs = require("react-tabs");
var _bodyContainerPanel = require("./BodyContainerPanel");
var _bodyContainerPanelDefault = parcelHelpers.interopDefault(_bodyContainerPanel);
var _headerSeparator = require("./HeaderSeparator");
var _headerSeparatorDefault = parcelHelpers.interopDefault(_headerSeparator);
var _primaryIconTab = require("./PrimaryIconTab");
var _primaryIconTabDefault = parcelHelpers.interopDefault(_primaryIconTab);
var _headerBar = require("../HeaderBar");
var _headerBarDefault = parcelHelpers.interopDefault(_headerBar);
var _fullPagePanel = require("./FullPagePanel");
var _fullPagePanelDefault = parcelHelpers.interopDefault(_fullPagePanel);
var _breakpoints = require("../../../constants/breakpoints");
const FullPageTabbedPanel = (props)=>{
    const renderTab = (tab, index)=>{
        return (0, _primaryIconTabDefault.default)({
            tab,
            index,
            className: ""
        });
    };
    return (0, _react.jsx)((0, _fullPagePanelDefault.default), {
        className: `${panelStyle}`
    }, (0, _react.jsx)((0, _reactTabs.Tabs), {
        className: "tabs",
        forceRenderTabPanel: props.forceRenderTabPanel,
        defaultIndex: props.selectedIndex,
        onSelect: props.onTabSelected
    }, (0, _react.jsx)((0, _headerBarDefault.default), null, props.leftRender(), props.titleRender(), (0, _react.jsx)((0, _headerSeparatorDefault.default), null), (0, _react.jsx)((0, _reactTabs.TabList), {
        className: "panel-tab-list full-page-tab-list"
    }, props.tabs.map(renderTab)), props.rightRender()), (0, _react.jsx)((0, _bodyContainerPanelDefault.default), null, props.children)));
};
const panelStyle = /*#__PURE__*/ (0, _css.css)(".tabs{overflow:hidden;width:100vw;height:100vh;position:absolute;top:0px;}ul{flex:1;}.panel-tab-list{color:white;list-style-type:none;display:flex;align-items:center;margin-left:16px;flex:1.5;}.full-page-tab-list{", (0, _breakpoints.breakpoint_small), "{overflow-x:auto;scrollbar-width:none;&::-webkit-scrollbar{display:none;}}}", "");
exports.default = FullPageTabbedPanel;

},{"@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","react-tabs":"92Sgf","./BodyContainerPanel":"2opyb","./HeaderSeparator":"c2pZO","./PrimaryIconTab":"jQDe6","../HeaderBar":"5ka3F","./FullPagePanel":"aZqiJ","../../../constants/breakpoints":"2F01A","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2opyb":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _base = require("@emotion/styled/base");
var _baseDefault = parcelHelpers.interopDefault(_base);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _colors = require("../../../constants/colors");
var _breakpoints = require("../../../constants/breakpoints");
const BodyContainerPanel = (props)=>(0, _react.jsx)(BodyContainerPanelWrapper, null, props.children);
const BodyContainerPanelWrapper = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1e0ywzt0"
})("height:calc(100% - 80px);position:fixed;top:80px;width:100vw;background:", (0, _colors.color_variants_main_bg), ";", (0, _breakpoints.breakpoint_small), "{height:calc(100% - 100px);}");
exports.default = BodyContainerPanel;

},{"@emotion/styled/base":"lSuFu","@emotion/react":"djZKr","react":"6uln9","../../../constants/colors":"1p3OR","../../../constants/breakpoints":"2F01A","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"c2pZO":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _colors = require("../../../constants/colors");
var _breakpoints = require("../../../constants/breakpoints");
const HeaderSeparator = (props)=>(0, _react.jsx)("div", {
        className: (0, _css.cx)(separatorStyle, props.className)
    });
const separatorStyle = /*#__PURE__*/ (0, _css.css)("height:48px;width:1px;background:", (0, _colors.color_shades_darker), ";margin-right:0;", (0, _breakpoints.breakpoint_small), "{display:none;}", "");
exports.default = HeaderSeparator;

},{"@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","../../../constants/colors":"1p3OR","../../../constants/breakpoints":"2F01A","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jQDe6":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _reactTabs = require("react-tabs");
var _colors = require("../../../constants/colors");
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
function PrimaryIconTab(props) {
    return (0, _react.jsx)((0, _reactTabs.Tab), {
        key: props.index,
        selectedClassName: activeTabStyle,
        className: `${tabStyle} ${props.className ? props.className : ""} ${props.tab.className ?? ""}`
    }, (0, _react.jsx)("div", {
        className: "tab-wrapper"
    }, (0, _react.jsx)("div", {
        className: "tab-content"
    }, (0, _react.jsx)("img", {
        className: "tab-icon",
        src: props.tab.icon
    }), (0, _react.jsx)("p", null, props.tab.title))));
}
const tabStyle = /*#__PURE__*/ (0, _css.css)({
    name: "1cw149o",
    styles: "color:black;cursor:pointer;flex-grow:1;align-items:center;margin:0 4px;min-width:80px;border-radius:8px;flex:0;.tab-wrapper{display:flex;align-items:center;}.tab-content{min-width:48px;flex-grow:1;display:flex;flex-direction:column;align-items:center;justify-content:center;height:56px;p{font-family:Muli;font-style:normal;font-weight:normal;font-size:10px;line-height:16px;color:white;}img{width:24px;height:auto;}}.tab-indicator{display:none;flex-grow:0;flex-shrink:0;}"
});
const activeTabStyle = /*#__PURE__*/ (0, _css.css)("background-color:", (0, _colors.color_text_link), ";>.tab-indicator{display:block;}", "");
exports.default = PrimaryIconTab;

},{"@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","react-tabs":"92Sgf","../../../constants/colors":"1p3OR","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"5ka3F":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _colors = require("../../constants/colors");
const HeaderBar = (props)=>(0, _react.jsx)("header", {
        className: headerStyle
    }, props.children);
const headerStyle = /*#__PURE__*/ (0, _css.css)("display:flex;align-items:center;height:80px;background:", (0, _colors.color_shades_darkest), ";color:white;top:0;width:100vw;", "");
exports.default = HeaderBar;

},{"@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","../../constants/colors":"1p3OR","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"aZqiJ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _colors = require("../../../constants/colors");
const FullPagePanel = (props)=>{
    return (0, _react.jsx)("div", {
        className: `${panelStyle} ${props.className ?? ""}`
    }, props.children);
};
const panelStyle = /*#__PURE__*/ (0, _css.css)("background:", (0, _colors.color_variants_main_bg), ";position:absolute;font-family:Muli;font-weight:normal;font-style:normal;font-stretch:normal;line-height:normal;letter-spacing:normal;color:", (0, _colors.dark_grey_blue), ";overflow:visible;height:100vh;width:100vw;z-index:1;", "");
exports.default = FullPagePanel;

},{"@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","../../../constants/colors":"1p3OR","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3nrW0":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _applicationContainer = require("../../state/containers/ApplicationContainer");
var _applicationContainerDefault = parcelHelpers.interopDefault(_applicationContainer);
var _currentContentSelector = require("./components/CurrentContentSelector");
var _currentContentSelectorDefault = parcelHelpers.interopDefault(_currentContentSelector);
var _applicationContentTree = require("../applicationContentMenuPanel/components/ApplicationContentTree");
var _applicationContentTreeDefault = parcelHelpers.interopDefault(_applicationContentTree);
var _featureContainer = require("../../state/containers/FeatureContainer");
var _featureContainerDefault = parcelHelpers.interopDefault(_featureContainer);
var _unstated = require("unstated");
var _contentTreeStateContainer = require("../../state/containers/ContentTreeStateContainer");
var _contentTreeStateContainerDefault = parcelHelpers.interopDefault(_contentTreeStateContainer);
var _colors = require("../../constants/colors");
var _slideInSlideOutComponent = require("../../components/structure/SlideInSlideOutComponent");
var _slideInSlideOutComponentDefault = parcelHelpers.interopDefault(_slideInSlideOutComponent);
var _applicationBackupVersionsContainer = require("../../state/containers/ApplicationBackupVersionsContainer");
var _applicationBackupVersionsContainerDefault = parcelHelpers.interopDefault(_applicationBackupVersionsContainer);
class ApplicationContentMenuSelector extends (0, _reactDefault.default).Component {
    constructor(props){
        super(props);
        this.state = {
            isExpanded: false
        };
    }
    toggle() {
        this.setState({
            ...this.state,
            isExpanded: !this.state.isExpanded
        });
    }
    render() {
        return (0, _react.jsx)((0, _unstated.Subscribe), {
            to: [
                (0, _applicationContainerDefault.default),
                (0, _contentTreeStateContainerDefault.default),
                (0, _featureContainerDefault.default),
                (0, _applicationBackupVersionsContainerDefault.default)
            ]
        }, (appContainer, treeContainer, featureContainer, backupsContainer)=>(0, _react.jsx)("div", {
                className: `${containerStyle} ${this.state.isExpanded ? "expanded" : ""}`
            }, (0, _react.jsx)((0, _currentContentSelectorDefault.default), {
                onToggle: this.toggle.bind(this),
                featureTypeId: this.props.featureTypeId,
                isMinified: true,
                isOpen: this.state.isExpanded
            }), (0, _react.jsx)((0, _slideInSlideOutComponentDefault.default), {
                showChildren: this.state.isExpanded,
                styleName: "contentTreeDropdownSlide",
                direction: "down",
                slideType: "size"
            }, (0, _react.jsx)("div", {
                className: "fixed-tree-container"
            }, (0, _react.jsx)((0, _applicationContentTreeDefault.default), {
                backupsContainer: backupsContainer,
                appContainer: appContainer,
                featureContainer: featureContainer,
                treeContainer: treeContainer,
                application: this.props.application,
                history: this.props.history
            })))));
    }
}
const containerStyle = /*#__PURE__*/ (0, _css.css)("height:80px;padding-top:16px;&.expanded{background:", (0, _colors.text_blue), ";}.fixed-tree-container{margin-top:80px;top:0;left:0;bottom:0;display:flex;flex-direction:column;position:fixed;max-height:calc(100% - 80px);width:288px;z-index:3;background:white;border-right:1px solid ", (0, _colors.color_shades_dark), ";}", "");
exports.default = ApplicationContentMenuSelector;

},{"@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","../../state/containers/ApplicationContainer":"cuqi2","./components/CurrentContentSelector":"7Eytr","../applicationContentMenuPanel/components/ApplicationContentTree":"bn3fl","../../state/containers/FeatureContainer":"4ApGg","unstated":"grh7p","../../state/containers/ContentTreeStateContainer":"e0LlA","../../constants/colors":"1p3OR","../../components/structure/SlideInSlideOutComponent":"bwTqS","../../state/containers/ApplicationBackupVersionsContainer":"6rA1P","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7Eytr":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _toggleIndicator = require("../../../components/general/ToggleIndicator");
var _toggleIndicatorDefault = parcelHelpers.interopDefault(_toggleIndicator);
var _colors = require("../../../constants/colors");
var _extensions = require("../../../models/extensions");
const appsIcon = require("f42d51c2bc11b6a");
const CurrentContentSelector = (props)=>(0, _react.jsx)("div", {
        className: `${containerStyle} ${props.isOpen ? "open" : ""} ${props.isMinified ? "minified" : ""}`,
        onClick: props.onToggle
    }, (0, _react.jsx)("div", {
        className: "feature-type-icon"
    }, (0, _react.jsx)("img", {
        src: (0, _extensions.getFeatureTypeIcon)(props.featureTypeId)
    })), !props.isMinified && (0, _react.jsx)("div", {
        className: "app-selector-title"
    }, (0, _react.jsx)("p", {
        className: "selection-detail"
    }, "Select Content"), (0, _react.jsx)("p", {
        className: "selection-title"
    }, (0, _extensions.getDefaultFeatureTypeName)(props.featureTypeId))), (0, _react.jsx)((0, _toggleIndicatorDefault.default), {
        direction: props.isOpen ? "up" : "down",
        className: "toggle-indicator"
    }));
const containerStyle = /*#__PURE__*/ (0, _css.css)("cursor:pointer;display:flex;align-items:center;max-width:100%;height:48px;padding:0 16px;border-left:1px solid ", (0, _colors.color_shades_darker), ";border-right:1px solid ", (0, _colors.color_shades_darker), ";.feature-type-icon{background:white;border:1px solid ", (0, _colors.color_shades_dark), ";box-sizing:border-box;border-radius:8px;padding:8px;width:48px;height:48px;img{width:32px;height:32px;}}&.minified{.toggle-indicator{border-color:white;margin-left:8px;}}&.open{background:", (0, _colors.text_blue), ";border-left:1px solid transparent;border-right:1px solid transparent;}.app-selector-title{margin:0 12px;p{color:white;}.selection-detail{font-family:Muli;font-style:italic;font-weight:normal;font-size:10px;line-height:16px;}.selection-title{font-family:Muli;font-style:normal;font-weight:normal;font-size:14px;line-height:20px;}}.toggle-indicator{border-color:white;margin-left:auto;margin-right:0;}", "");
exports.default = CurrentContentSelector;

},{"@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","../../../components/general/ToggleIndicator":"4eej1","../../../constants/colors":"1p3OR","../../../models/extensions":"7h01B","f42d51c2bc11b6a":"hNrC2","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hNrC2":[function(require,module,exports) {
module.exports = require("87e6eb937c89cb53").getBundleURL("kVLro") + require("e0139937d0fda8aa").resolve("9lO87");

},{"87e6eb937c89cb53":"c7Tr5","e0139937d0fda8aa":"fyJL2"}],"bn3fl":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _nestedTree = require("../../../components/structure/NestedTree/NestedTree");
var _nestedTreeDefault = parcelHelpers.interopDefault(_nestedTree);
var _featureTypeIds = require("../../../constants/featureTypeIds");
var _extensions = require("../../../models/extensions");
var _colors = require("../../../constants/colors");
var _lodash = require("lodash");
var _lodashDefault = parcelHelpers.interopDefault(_lodash);
var _customScrollbars = require("../../../components/structure/CustomScrollbars");
var _customScrollbarsDefault = parcelHelpers.interopDefault(_customScrollbars);
var _applicationHistoryToolbar = require("./ApplicationHistoryToolbar");
var _applicationHistoryToolbarDefault = parcelHelpers.interopDefault(_applicationHistoryToolbar);
var _saveApplicationBackupModal = require("../../applicationHistoryPanel/components/SaveApplicationBackupModal");
var _saveApplicationBackupModalDefault = parcelHelpers.interopDefault(_saveApplicationBackupModal);
var _applicationHistoryPanel = require("../../applicationHistoryPanel");
var _applicationHistoryPanelDefault = parcelHelpers.interopDefault(_applicationHistoryPanel);
const folderIcon = require("6f191233ad8a21eb");
const folderOpenIcon = require("654fb0838b68528d");
const customRequestIcon = require("e647a212d75c4400");
const exitIcon = require("a8c97e8471383f22");
const fallbackIcon = require("31c86851c5102dd6");
const helpIcon = require("514b0bbc1d0e6c3d");
const latestMessageIcon = require("acfc41a9bed7f2b7");
const numberRangeIcon = require("ad70046dc16ab1f3");
const questionAnswerIcon = require("d760c9b513bf3bf9");
const welcomeIcon = require("8a87d8a7be96f872");
const simpleChoiceIcon = require("2be984b46d946d1f");
const ApplicationContentTree = (props)=>{
    const [isHistoryExpanded, setIsHistoryExpanded] = (0, _react1.useState)(false);
    const [isCreatingBackup, setIsCreatingBackup] = (0, _react1.useState)(false);
    const getContentIcon = (featureTypeId)=>{
        switch(featureTypeId){
            case 0, _featureTypeIds.WelcomeMessagesFeatureTypeId:
                return welcomeIcon;
            case 0, _featureTypeIds.HelpMessagesFeatureTypeId:
                return helpIcon;
            case 0, _featureTypeIds.FallbackFeatureTypeId:
                return fallbackIcon;
            case 0, _featureTypeIds.ExitMessagesFeatureTypeId:
                return exitIcon;
            case 0, _featureTypeIds.QuestionAnswerFeatureTypeId:
                return questionAnswerIcon;
            case 0, _featureTypeIds.LatestMessagesFeatureTypeId:
                return latestMessageIcon;
            case 0, _featureTypeIds.NumberRangeFeatureTypeId:
                return numberRangeIcon;
            case 0, _featureTypeIds.SimpleChoiceFeatureTypeId:
                return simpleChoiceIcon;
            case 0, _featureTypeIds.CustomRequestsFeatureTypeId:
                return customRequestIcon;
        }
        return "";
    };
    const handleTreeItemClick = (item)=>{
        if (item.type == "feature") {
            const expandedIds = props.treeContainer.state.expandedIds;
            if (expandedIds.some((id)=>id == item.id)) expandedIds.splice(expandedIds.indexOf(item.id), 1);
            else {
                expandedIds.push(item.id);
                props.featureContainer.getContentItemsForAppFeature(item.id);
            }
            props.treeContainer.setExpandedIds(expandedIds);
        }
    };
    const mapFeatureToTreeItem = (applicationFeature)=>{
        return {
            id: applicationFeature?.id,
            type: "feature",
            isHighlighted: props.treeContainer.state.selectedId == applicationFeature?.id,
            isExpanded: applicationFeature.parentId == null || props.treeContainer.state.expandedIds?.some((id)=>applicationFeature?.id == id),
            isLoadingChildren: props.featureContainer.state.loadingAppFeatureIds.some((s)=>s === applicationFeature?.id),
            icon: folderIcon,
            expandedIcon: folderOpenIcon,
            title: applicationFeature?.name ?? applicationFeature?.feature?.name ?? "Untitled",
            canExpand: true,
            linkTo: `/v/apps/${props.application.id}/content/${applicationFeature?.id}`,
            children: [
                ...props.featureContainer.getFeaturesForParent(applicationFeature?.id)?.map((af)=>mapFeatureToTreeItem(af)),
                ...(0, _lodashDefault.default).orderBy(props.featureContainer.getContentByFeatureId(applicationFeature?.id), (item)=>{
                    item.priority, item.createdDate;
                }, "asc")?.map((c)=>mapContentToTreeItem(c))
            ]
        };
    };
    const mapContentToTreeItem = (contentItem)=>{
        return {
            id: contentItem.id,
            type: "content",
            title: contentItem.title ?? "Unknown",
            icon: getContentIcon(contentItem.featureTypeId),
            isExpanded: false,
            isLoadingChildren: false,
            canExpand: false,
            children: [],
            linkTo: (0, _extensions.getEditUrl)(contentItem.id, contentItem.applicationFeatureId, contentItem.featureTypeId)
        };
    };
    // default select the top feature
    const rootFeature = props.featureContainer.getRootFeature(props.application?.id);
    if (!rootFeature) return null;
    return (0, _react.jsx)("div", {
        className: containerStyle
    }, (0, _react.jsx)((0, _applicationHistoryToolbarDefault.default), {
        onSaveBackup: ()=>setIsCreatingBackup(true),
        onToggle: ()=>setIsHistoryExpanded(!isHistoryExpanded),
        isExpanded: isHistoryExpanded,
        isLoading: props.backupsContainer.state.isCreating
    }), isHistoryExpanded ? (0, _react.jsx)((0, _customScrollbarsDefault.default), {
        autoHide: true,
        className: "tree-scroll"
    }, (0, _react.jsx)("div", {
        className: "tree-container"
    }, (0, _react.jsx)((0, _applicationHistoryPanelDefault.default), {
        applicationId: props.application.id,
        onClose: ()=>setIsHistoryExpanded(false)
    }))) : (0, _react.jsx)((0, _customScrollbarsDefault.default), {
        autoHide: true,
        className: "tree-scroll"
    }, (0, _react.jsx)("div", {
        className: "tree-container"
    }, rootFeature != null && (0, _react.jsx)((0, _nestedTreeDefault.default), {
        isRootHidden: true,
        key: rootFeature?.id ?? "r",
        root: mapFeatureToTreeItem(rootFeature),
        onItemClick: handleTreeItemClick
    }))), isCreatingBackup && (0, _react.jsx)((0, _saveApplicationBackupModalDefault.default), {
        applicationId: props.application.id,
        onClose: ()=>setIsCreatingBackup(false),
        backupsContainer: props.backupsContainer
    }));
};
const containerStyle = /*#__PURE__*/ (0, _css.css)("display:flex;flex-direction:column;height:100%;.selector-section-header{align-items:center;padding:0px 16px 0 24px;background:white;height:56px;min-height:56px;max-height:56px;border-bottom:1px solid ", (0, _colors.color_shades_dark), ";p{font-size:18px;line-height:24px;padding-top:16px;color:", (0, _colors.color_text_default), ";}}.tree-container{padding-bottom:16px;max-height:100%;flex:1;}", "");
exports.default = ApplicationContentTree;

},{"@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","../../../components/structure/NestedTree/NestedTree":"fhYq0","../../../constants/featureTypeIds":"hPLMP","../../../models/extensions":"7h01B","../../../constants/colors":"1p3OR","lodash":"3hMBK","../../../components/structure/CustomScrollbars":"50vFq","./ApplicationHistoryToolbar":"5SuoU","../../applicationHistoryPanel/components/SaveApplicationBackupModal":"cIdzx","../../applicationHistoryPanel":"aqO4p","6f191233ad8a21eb":"csmC0","654fb0838b68528d":"3i6IH","e647a212d75c4400":"f21t8","a8c97e8471383f22":"350sm","31c86851c5102dd6":"yQsT7","514b0bbc1d0e6c3d":"in9Q6","acfc41a9bed7f2b7":"hxg0t","ad70046dc16ab1f3":"8oys6","d760c9b513bf3bf9":"j1A8X","8a87d8a7be96f872":"hnmJq","2be984b46d946d1f":"6JZvO","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"cIdzx":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _base = require("@emotion/styled/base");
var _baseDefault = parcelHelpers.interopDefault(_base);
var _react = require("@emotion/react");
var _css = require("@emotion/css");
var _formik = require("formik");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _yup = require("yup");
var _textField = require("../../../components/forms/TextField");
var _textFieldDefault = parcelHelpers.interopDefault(_textField);
var _button = require("../../../components/general/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _modalHeader = require("../../../components/general/ModalHeader");
var _modalHeaderDefault = parcelHelpers.interopDefault(_modalHeader);
var _pageError = require("../../../components/general/PageError");
var _pageErrorDefault = parcelHelpers.interopDefault(_pageError);
var _footerBar = require("../../../components/structure/FooterBar");
var _footerBarDefault = parcelHelpers.interopDefault(_footerBar);
var _smallModalLayout = require("../../../components/structure/SmallModalLayout");
var _smallModalLayoutDefault = parcelHelpers.interopDefault(_smallModalLayout);
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const InnerForm = (props)=>(0, _react.jsx)((0, _smallModalLayoutDefault.default), {
        isVisible: true,
        onClose: props.onClose,
        className: customModalInner
    }, (0, _react.jsx)(ModalForm, {
        onSubmit: props.handleSubmit
    }, (0, _react.jsx)((0, _modalHeaderDefault.default), {
        title: "Save Backup",
        onClose: props.onClose
    }), (0, _react.jsx)("div", {
        className: "modal-body"
    }, (0, _react.jsx)("p", null, "Save a copy of your App in its current state. You can then use this version as a reference for later revisions or to publish to your live instance."), (0, _react.jsx)((0, _textFieldDefault.default), {
        name: "name",
        placeholder: "Saved",
        label: "Backup Name",
        onBlur: props.handleBlur,
        onChange: props.handleChange
    })), (0, _react.jsx)((0, _footerBarDefault.default), null, (0, _react.jsx)((0, _buttonDefault.default), {
        type: "submit",
        themes: [
            "primary",
            "start"
        ],
        text: "Save",
        disabled: props.isSubmitting,
        loading: props.isSubmitting
    }), (0, _react.jsx)((0, _buttonDefault.default), {
        type: "button",
        themes: [
            "secondary",
            "end"
        ],
        text: "Cancel",
        onClick: ()=>props.onClose(),
        disabled: props.isSubmitting,
        loading: props.isSubmitting
    }))), (0, _react.jsx)((0, _pageErrorDefault.default), {
        errors: props.backupsContainer.state.errors ?? [],
        onClear: ()=>props.backupsContainer.clearErrors()
    }));
const SaveApplicationBackupModal = (0, _formik.withFormik)({
    mapPropsToValues: (props)=>({
            name: ""
        }),
    validationSchema: _yup.object().shape({
        name: _yup.string().required("You must enter a name for the backup")
    }),
    handleSubmit: async (values, { props, setSubmitting })=>{
        setSubmitting(true);
        var backupResult = await props.backupsContainer.queueCreateFullBackup(props.applicationId, {
            name: values.name,
            description: ""
        });
        if (backupResult?.resultType == "Ok") {
            // We do not need to do await here since its going to wait for the backup in the container in the background
            props.backupsContainer.waitForBackup(backupResult.data.id);
            setSubmitting(false);
            props.onClose();
            return;
        }
        setSubmitting(false);
    }
})(InnerForm);
const customModalInner = /*#__PURE__*/ (0, _css.css)({
    name: "1mw49wb",
    styles: "height:416px;min-height:416px"
});
const ModalForm = /*#__PURE__*/ (0, _baseDefault.default)("form", {
    target: "ev4q1pn0"
})({
    name: "11585cm",
    styles: "min-height:416px;height:416px;padding-bottom:64px;.modal-body{padding:0 32px;margin-bottom:180px;height:100%;flex:1;>h4{font-style:normal;font-weight:normal;font-size:18px;line-height:24px;}>p{font-style:normal;font-weight:normal;font-size:14px;line-height:20px;margin:24px 0;}}"
});
exports.default = SaveApplicationBackupModal;

},{"@emotion/styled/base":"lSuFu","@emotion/react":"djZKr","@emotion/css":"awUBr","formik":"3YnOK","react":"6uln9","yup":"j2SJU","../../../components/forms/TextField":"7a7bh","../../../components/general/Button":"6ymxN","../../../components/general/ModalHeader":"aUACx","../../../components/general/PageError":"ezFTm","../../../components/structure/FooterBar":"bibRL","../../../components/structure/SmallModalLayout":"khwvt","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"csmC0":[function(require,module,exports) {
module.exports = require("c5f15c66c1c974e9").getBundleURL("kVLro") + require("288a9a7527907cfc").resolve("8vOw8");

},{"c5f15c66c1c974e9":"c7Tr5","288a9a7527907cfc":"fyJL2"}],"3i6IH":[function(require,module,exports) {
module.exports = require("c3a3c4e57faae251").getBundleURL("kVLro") + require("15cc5bb1b965adc5").resolve("j7iNB");

},{"c3a3c4e57faae251":"c7Tr5","15cc5bb1b965adc5":"fyJL2"}],"f21t8":[function(require,module,exports) {
module.exports = require("e8cb358d2d0947d4").getBundleURL("kVLro") + require("c9be358803c0f8fc").resolve("lmwoA");

},{"e8cb358d2d0947d4":"c7Tr5","c9be358803c0f8fc":"fyJL2"}],"350sm":[function(require,module,exports) {
module.exports = require("5d9b1e26b92f12ef").getBundleURL("kVLro") + require("401002fc3692738f").resolve("30Uu4");

},{"5d9b1e26b92f12ef":"c7Tr5","401002fc3692738f":"fyJL2"}],"yQsT7":[function(require,module,exports) {
module.exports = require("b5294f281b185666").getBundleURL("kVLro") + require("828b53a8a6f6fc49").resolve("lJqce");

},{"b5294f281b185666":"c7Tr5","828b53a8a6f6fc49":"fyJL2"}],"in9Q6":[function(require,module,exports) {
module.exports = require("e82cc6d27f144d13").getBundleURL("kVLro") + require("e546624dd38feda1").resolve("6SwKL");

},{"e82cc6d27f144d13":"c7Tr5","e546624dd38feda1":"fyJL2"}],"hxg0t":[function(require,module,exports) {
module.exports = require("4d91a3c6e394f92b").getBundleURL("kVLro") + require("64f9b7a1c585855f").resolve("hDrvo");

},{"4d91a3c6e394f92b":"c7Tr5","64f9b7a1c585855f":"fyJL2"}],"8oys6":[function(require,module,exports) {
module.exports = require("3fe708a7bf05205d").getBundleURL("kVLro") + require("5da1e4b580008382").resolve("9g9ZE");

},{"3fe708a7bf05205d":"c7Tr5","5da1e4b580008382":"fyJL2"}],"j1A8X":[function(require,module,exports) {
module.exports = require("19cc3823be9319e5").getBundleURL("kVLro") + require("4c277073f282b4b8").resolve("hSg0U");

},{"19cc3823be9319e5":"c7Tr5","4c277073f282b4b8":"fyJL2"}],"hnmJq":[function(require,module,exports) {
module.exports = require("1771f2102ad3db3b").getBundleURL("kVLro") + require("2ae5de603d7dc277").resolve("ep4N7");

},{"1771f2102ad3db3b":"c7Tr5","2ae5de603d7dc277":"fyJL2"}],"6JZvO":[function(require,module,exports) {
module.exports = require("612cd95f427414c9").getBundleURL("kVLro") + require("7f4d078321100ab2").resolve("iwGiX");

},{"612cd95f427414c9":"c7Tr5","7f4d078321100ab2":"fyJL2"}],"e0LlA":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _defineProperty = require("@babel/runtime/helpers/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _unstated = require("unstated");
class ContentTreeStateContainer extends (0, _unstated.Container) {
    constructor(...args){
        super(...args);
        (0, _definePropertyDefault.default)(this, "state", {
            expandedIds: [],
            selectedId: null
        });
    }
    setExpandedIds(ids) {
        this.setState({
            ...this.state,
            expandedIds: ids
        });
    }
    setSelectedId(id) {
        this.setState({
            ...this.state,
            selectedId: id
        });
    }
    addExpandedId(id) {
        if (this.state.expandedIds.some((i)=>i == id)) return;
        const expandedIds = this.state.expandedIds;
        expandedIds.push(id);
        this.setState({
            ...this.state,
            expandedIds
        });
    }
}
exports.default = ContentTreeStateContainer;

},{"@babel/runtime/helpers/defineProperty":"9sJxO","unstated":"grh7p","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"sFXKk":[function(require,module,exports) {
module.exports = require("f1ee7b85bfa3ecda").getBundleURL("kVLro") + require("580ea0e7ce32d7e5").resolve("70F6Q");

},{"f1ee7b85bfa3ecda":"c7Tr5","580ea0e7ce32d7e5":"fyJL2"}],"7VuKq":[function(require,module,exports) {
module.exports = require("545d1f5c0c2f90ec").getBundleURL("kVLro") + require("123558a3a31fc23e").resolve("bqPCf");

},{"545d1f5c0c2f90ec":"c7Tr5","123558a3a31fc23e":"fyJL2"}],"d04fQ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _unstated = require("unstated");
var _exitMessageContainer = require("../../state/containers/ExitMessageContainer");
var _exitMessageContainerDefault = parcelHelpers.interopDefault(_exitMessageContainer);
var _editExitMessageForm = require("./components/EditExitMessageForm");
var _editExitMessageFormDefault = parcelHelpers.interopDefault(_editExitMessageForm);
var _applicationContainer = require("../../state/containers/ApplicationContainer");
var _applicationContainerDefault = parcelHelpers.interopDefault(_applicationContainer);
var _titleStateContainer = require("../../state/containers/TitleStateContainer");
var _titleStateContainerDefault = parcelHelpers.interopDefault(_titleStateContainer);
var _mediaResponseContainer = require("../../state/containers/MediaResponseContainer");
var _mediaResponseContainerDefault = parcelHelpers.interopDefault(_mediaResponseContainer);
var _genericEditContentItemPage = require("../formScenes/GenericEditContentItemPage");
var _genericEditContentItemPageDefault = parcelHelpers.interopDefault(_genericEditContentItemPage);
var _featureContainer = require("../../state/containers/FeatureContainer");
var _featureContainerDefault = parcelHelpers.interopDefault(_featureContainer);
var _featureTypeIds = require("../../constants/featureTypeIds");
var _queryString = require("query-string");
var _queryStringDefault = parcelHelpers.interopDefault(_queryString);
var _repromptContainer = require("../../state/containers/RepromptContainer");
var _repromptContainerDefault = parcelHelpers.interopDefault(_repromptContainer);
var _followUpContainer = require("../../state/containers/FollowUpContainer");
var _followUpContainerDefault = parcelHelpers.interopDefault(_followUpContainer);
var _applicationBackupVersionsContainer = require("../../state/containers/ApplicationBackupVersionsContainer");
var _applicationBackupVersionsContainerDefault = parcelHelpers.interopDefault(_applicationBackupVersionsContainer);
var _applicationEnvironmentsContainer = require("../../state/containers/ApplicationEnvironmentsContainer");
var _applicationEnvironmentsContainerDefault = parcelHelpers.interopDefault(_applicationEnvironmentsContainer);
class EditExitMessage extends (0, _reactDefault.default).Component {
    render() {
        return (0, _react.jsx)((0, _unstated.Subscribe), {
            key: this.props.match.params.exitMessageId + this.props.match.params.applicationFeatureId,
            to: [
                (0, _exitMessageContainerDefault.default),
                (0, _applicationContainerDefault.default),
                (0, _repromptContainerDefault.default),
                (0, _followUpContainerDefault.default),
                (0, _titleStateContainerDefault.default),
                (0, _mediaResponseContainerDefault.default),
                (0, _featureContainerDefault.default),
                (0, _applicationEnvironmentsContainerDefault.default),
                (0, _applicationBackupVersionsContainerDefault.default)
            ]
        }, (exitContainer, appContainer, repromptContainer, followUpContainer, titleContainer, responseContainer, featureContainer, environmentsContainer, backupsContainer)=>{
            return (0, _react.jsx)((0, _genericEditContentItemPageDefault.default), {
                stateContainer: exitContainer,
                environmentsContainer: environmentsContainer,
                backupsContainer: backupsContainer,
                titleContainer: titleContainer,
                applicationContainer: appContainer,
                defaultTitle: "Edit Exit Message",
                contentItemId: this.props.match.params.exitMessageId,
                history: this.props.history,
                location: this.props.location,
                match: this.props.match,
                staticContext: this.props.staticContext,
                featureContainer: featureContainer,
                featureTypeId: (0, _featureTypeIds.ExitMessagesFeatureTypeId),
                formRender: (contentItem, application, isTemplateOwned, assistantApplication, onShowPublishModal, onSubmit, toggleSync, onAccessTypeChange)=>(0, _react.jsx)((0, _editExitMessageFormDefault.default), {
                        appContainer: appContainer,
                        followUpContainer: followUpContainer,
                        repromptContainer: repromptContainer,
                        location: this.props.location,
                        application: application,
                        applicationFeatureId: this.props.match.params.applicationFeatureId,
                        exitMessage: contentItem,
                        stateContainer: exitContainer,
                        responseStateContainer: responseContainer,
                        featureContainer: featureContainer,
                        assistantApplication: assistantApplication,
                        onShowPublishModal: onShowPublishModal,
                        onAccessTypeChange: onAccessTypeChange,
                        onSubmit: onSubmit,
                        onToggleSync: toggleSync,
                        previousContentId: (0, _queryStringDefault.default)?.parse(this.props.location.search)?.previousContentId,
                        history: this.props.history,
                        isSaving: exitContainer.state.isSaving,
                        isTemplateOwned: isTemplateOwned
                    })
            });
        });
    }
}
exports.default = EditExitMessage;

},{"@emotion/react":"djZKr","react":"6uln9","unstated":"grh7p","../../state/containers/ExitMessageContainer":"lSKl8","./components/EditExitMessageForm":"lWTzx","../../state/containers/ApplicationContainer":"cuqi2","../../state/containers/TitleStateContainer":"2osOD","../../state/containers/MediaResponseContainer":"1ccrV","../formScenes/GenericEditContentItemPage":"6RzEJ","../../state/containers/FeatureContainer":"4ApGg","../../constants/featureTypeIds":"hPLMP","query-string":"klvAV","../../state/containers/RepromptContainer":"5vKMV","../../state/containers/FollowUpContainer":"rm9OA","../../state/containers/ApplicationBackupVersionsContainer":"6rA1P","../../state/containers/ApplicationEnvironmentsContainer":"jCULY","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"lWTzx":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _formik = require("formik");
var _yup = require("yup");
var _exitMessageForm = require("../../formScenes/ExitMessageForm");
var _exitMessageFormDefault = parcelHelpers.interopDefault(_exitMessageForm);
const EditExitMessageForm = (0, _formik.withFormik)({
    mapPropsToValues: (props)=>{
        return {
            title: props.exitMessage.title,
            responses: props.exitMessage.responses.length > 0 ? props.exitMessage.responses : [
                {
                    content: ""
                }
            ],
            languages: props.exitMessage.languages,
            webhookChainingType: props.exitMessage.webhookChainingType,
            isLive: props.exitMessage.isLive,
            requiresParent: props.exitMessage.requiresParent,
            sensitiveConversationChange: props.exitMessage.sensitiveConversationChange ?? "None",
            disabledForFeatureFlagIds: props.exitMessage?.disabledForFeatureFlagIds
        };
    },
    validationSchema: _yup.object().shape({
        title: _yup.string().required("You must enter a title"),
        responses: _yup.array().of(_yup.object().shape({
            content: _yup.string().required("You must enter an response variation")
        })).required("You must enter at least 1 response variation").min(1, "You must enter at least 1 response variation")
    }),
    validateOnMount: true,
    handleSubmit: (values, { props, setStatus })=>{
        setStatus({
            submitting: true
        });
        return props.onSubmit(props.stateContainer.mapFormDataToModel(props.exitMessage, values));
    }
})((0, _exitMessageFormDefault.default));
exports.default = EditExitMessageForm;

},{"formik":"3YnOK","yup":"j2SJU","../../formScenes/ExitMessageForm":"g6YNd","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6RzEJ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _backButton = require("../../components/general/BackButton");
var _backButtonDefault = parcelHelpers.interopDefault(_backButton);
var _reactTabs = require("react-tabs");
var _headerTitleView = require("../../components/structure/HeaderTitleView");
var _headerTitleViewDefault = parcelHelpers.interopDefault(_headerTitleView);
var _contentAnalytics = require("../contentAnalytics");
var _contentAnalyticsDefault = parcelHelpers.interopDefault(_contentAnalytics);
var _headerStatusContainer = require("../../components/general/HeaderStatusContainer");
var _headerStatusContainerDefault = parcelHelpers.interopDefault(_headerStatusContainer);
var _loader = require("../../components/general/Loader");
var _loaderDefault = parcelHelpers.interopDefault(_loader);
var _fullPageTabbedPanel = require("../../components/structure/Panels/FullPageTabbedPanel");
var _fullPageTabbedPanelDefault = parcelHelpers.interopDefault(_fullPageTabbedPanel);
var _applicationContentMenuSelector = require("../applicationContentMenuSelector");
var _applicationContentMenuSelectorDefault = parcelHelpers.interopDefault(_applicationContentMenuSelector);
var _pageError = require("../../components/general/PageError");
var _pageErrorDefault = parcelHelpers.interopDefault(_pageError);
var _extensions = require("../../models/extensions");
var _unstated = require("unstated");
var _applicationAnalyticsFacetContainer = require("../../state/containers/ApplicationAnalyticsFacetContainer");
var _applicationAnalyticsFacetContainerDefault = parcelHelpers.interopDefault(_applicationAnalyticsFacetContainer);
var _partialPublishForm = require("./PartialPublishForm");
var _partialPublishFormDefault = parcelHelpers.interopDefault(_partialPublishForm);
var _contentItemListStatus = require("../../components/general/ContentItemListStatus");
var _contentItemListStatusDefault = parcelHelpers.interopDefault(_contentItemListStatus);
var _contentItems = require("../../models/extensions/contentItems");
const contentEditIcon = require("1e2c9fadb99d1684");
const analyticsIcon = require("d04f5b79eaa71829");
const noAccessImage = require("f0b56be8f2d52d94");
const targetedAccessImage = require("3e9108050778fbd0");
const analyticsTabName = "analytics";
const integrationsTabName = "integrations";
const GenericEditContentItemPage = (props)=>{
    const [contentItem, setContentItem] = (0, _react1.useState)(null);
    const [environment, setEnvironment] = (0, _react1.useState)(null);
    const [lastPublish, setLastPublish] = (0, _react1.useState)(null);
    const [showPublishModal, setShowPublishModal] = (0, _react1.useState)(false);
    const [isUnPublishing, setIsUnPublishing] = (0, _react1.useState)(false);
    const [accessType, setAccessType] = (0, _react1.useState)(null);
    (0, _react1.useEffect)(()=>{
        const asyncLoad = async ()=>{
            props.stateContainer.getContentWebhooks(props.contentItemId);
            const contentResult = await props.stateContainer.findFullById(props.contentItemId);
            props.applicationContainer.state.currentApp ?? await props.applicationContainer.loadCurrentAppById(contentResult.data.applicationId);
            await props.environmentsContainer.loadEnvironments(props.applicationContainer.state.currentApp.id);
            const primaryEnvironment = props.environmentsContainer.findPrimaryEnvironment(props.applicationContainer.state.currentApp.id);
            const publishHistoryResult = await props.stateContainer.loadPublishHistory(props.contentItemId, primaryEnvironment.id, 0, 1);
            setContentItem(contentResult.data);
            setEnvironment(primaryEnvironment);
            setLastPublish(publishHistoryResult.data[0]);
            setAccessType((0, _contentItems.getContentItemAccessType)(contentResult.data));
            props?.location?.search?.includes("publishing=true") && handleShowPublishModal();
        };
        asyncLoad();
    }, [
        props.contentItemId
    ]);
    const handleSubmit = async (model, onSuccess)=>{
        const result = await props.stateContainer.updateFromModel(model);
        if (result.resultType == "Ok") {
            if (onSuccess) onSuccess(result);
            // Full update was successful
            if (props.stateContainer.state.hasWebhookUpdate) await props.stateContainer.bulkUpdateContentItemWebhookInstances(result.data.id, props.stateContainer.state.webhookUpdates);
            // Update edited content state, do not redirect
            props.featureContainer?.addOrUpdateContentItem(result.data, result.data.responses[0], props.stateContainer.featureTypeId);
            setContentItem(result.data);
        }
        return result;
    };
    const handleShowPublishModal = async ()=>{
        setShowPublishModal(true);
    };
    const getBreadCrumbItems = ()=>{
        var ancestors = props.featureContainer.getAllAncestors(props.match.params.applicationFeatureId);
        var crumbs = ancestors?.reverse()?.map((af)=>({
                id: af?.id,
                title: af.parentId ? af?.name ?? af.feature?.name ?? af?.feature?.featureType?.name ?? "Untitled" : "Home",
                link: `/v/apps/${props.applicationContainer.state.currentApp?.id}/content/${af?.id}`
            }));
        return crumbs;
    };
    const handleClose = ()=>{
        props.history.push(`/v/apps/${props.applicationContainer.state.currentApp.id}/content/${props.match.params.applicationFeatureId}`);
    };
    const handleToggleSync = (id, shouldNotSync)=>{
        const promise = props.stateContainer.toggleSync(id, shouldNotSync);
        promise.then((result)=>{
            if (result.resultType == "Ok") props.stateContainer.findFullById(props.contentItemId).then((result)=>{
                setContentItem(result?.data);
            });
        });
        return promise;
    };
    const handleTabSelection = (index, last)=>{
        if (index == last) return;
        const urlStart = (0, _extensions.getEditUrl)(props.contentItemId, props.match.params.applicationFeatureId, props.featureTypeId);
        if (index == 1) props.history.push(urlStart + analyticsTabName);
        else if (index == 2) props.history.push(urlStart + integrationsTabName);
        else props.history.push(urlStart);
    };
    const getSelectedIndex = ()=>{
        if (location.href.indexOf(analyticsTabName) > -1) return 1;
        if (location.href.indexOf(integrationsTabName) > -1) return 2;
        return 0;
    };
    const handlePartialPublishClose = async ()=>{
        setIsUnPublishing(false);
        setShowPublishModal(false);
        const publishHistoryResult = await props.stateContainer.loadPublishHistory(props.contentItemId, environment.id, 0, 1);
        setLastPublish(publishHistoryResult.data[0]);
    };
    if (contentItem == null || props.applicationContainer.state.currentApp == null) return (0, _react.jsx)((0, _loaderDefault.default), null);
    const isLoading = props.stateContainer.state.isLoading || props.applicationContainer.state.isLoadingCurrentApp;
    const isTemplateOwned = contentItem?.createdFromId && !contentItem?.shouldNotSync;
    const renderStatus = (contentItem)=>{
        return (0, _react.jsx)((0, _contentItemListStatusDefault.default), {
            dropDownDisabled: props.applicationContainer.state.assistantApplication == null,
            isListView: false,
            loaded: true,
            contentItem: contentItem,
            lastPublish: lastPublish,
            handlePublish: ()=>{
                // TODO: need to submit the form here? This may be a UX challenge as well
                // when you are on analytics page, you can still say "save and publish"
                // because status is higher than the tab, but there is no form to reference for the "save"
                // unless you are on the edit page. We need to consult with Jason here as well
                setShowPublishModal(true);
            },
            handleUnpublish: ()=>{
                setIsUnPublishing(true);
                setShowPublishModal(true);
            }
        });
    };
    return (0, _react.jsx)((0, _reactDefault.default).Fragment, null, (0, _react.jsx)((0, _fullPageTabbedPanelDefault.default), {
        tabs: [
            {
                title: "Content Edit",
                icon: contentEditIcon,
                selectedIcon: contentEditIcon,
                className: "ac-content-edit-tab"
            },
            {
                title: "Analytics",
                icon: analyticsIcon,
                selectedIcon: analyticsIcon,
                className: "ac-content-analytics-tab"
            }
        ],
        onTabSelected: handleTabSelection.bind(undefined),
        selectedIndex: getSelectedIndex(),
        leftRender: ()=>(0, _react.jsx)((0, _reactDefault.default).Fragment, null, (0, _react.jsx)((0, _backButtonDefault.default), {
                onClick: handleClose.bind(undefined)
            }), (0, _react.jsx)((0, _applicationContentMenuSelectorDefault.default), {
                application: props.applicationContainer.state.currentApp,
                featureTypeId: props.featureTypeId,
                history: props.history
            })),
        titleRender: ()=>(0, _react.jsx)((0, _headerTitleViewDefault.default), {
                titleImage: contentItem.isLive && contentItem.requiresParent ? targetedAccessImage : !contentItem?.isLive ? noAccessImage : null,
                text: contentItem?.title ?? props.defaultTitle,
                breadcrumb: getBreadCrumbItems(),
                app: props.titleContainer.state.application
            }),
        rightRender: ()=>!isLoading ? (0, _react.jsx)((0, _headerStatusContainerDefault.default), null, renderStatus(contentItem)) : null
    }, (0, _react.jsx)((0, _reactTabs.TabPanel), null, !isLoading ? props.formRender(contentItem, props.applicationContainer.state.currentApp, isTemplateOwned, props.applicationContainer.state.assistantApplication, handleShowPublishModal, handleSubmit, handleToggleSync, setAccessType) : (0, _react.jsx)((0, _loaderDefault.default), null)), (0, _react.jsx)((0, _reactTabs.TabPanel), null, !isLoading ? (0, _react.jsx)((0, _unstated.Subscribe), {
        to: [
            (0, _applicationAnalyticsFacetContainerDefault.default)
        ]
    }, (facetContainer)=>(0, _react.jsx)((0, _contentAnalyticsDefault.default), {
            contentItem: contentItem,
            facetContainer: facetContainer,
            history: props.history,
            applicationId: contentItem.applicationId,
            contentId: contentItem.id,
            featureTypeId: props.featureTypeId,
            applicationFeatureId: props.match.params.applicationFeatureId
        })) : (0, _react.jsx)((0, _loaderDefault.default), null))), (0, _react.jsx)((0, _pageErrorDefault.default), {
        errors: [
            ...props.stateContainer?.state?.errors ?? [],
            ...props.environmentsContainer?.state?.errors ?? [],
            ...props.applicationContainer?.state?.errors ?? [],
            ...props.backupsContainer?.state?.errors ?? [],
            ...props.featureContainer?.state?.errors ?? []
        ],
        onClear: ()=>{
            props.stateContainer.clearErrors();
            props.environmentsContainer.clearErrors();
            props.applicationContainer.clearErrors();
            props.backupsContainer.clearErrors();
            props.featureContainer.clearErrors();
        }
    }), showPublishModal && (0, _react.jsx)((0, _partialPublishFormDefault.default), {
        contentItems: [
            {
                contentId: props.contentItemId,
                featureTypeId: props.featureTypeId
            }
        ],
        defaultContentItemName: contentItem.title,
        applicationId: contentItem.applicationId,
        isUnpublishing: isUnPublishing,
        applicationFeatureId: props.match.params.applicationFeatureId,
        history: props.history,
        showClosedAccessWarning: accessType === "closed",
        onClose: handlePartialPublishClose.bind(undefined)
    }));
};
exports.default = GenericEditContentItemPage;

},{"@emotion/react":"djZKr","react":"6uln9","../../components/general/BackButton":"jZrQd","react-tabs":"92Sgf","../../components/structure/HeaderTitleView":"4unvp","../contentAnalytics":"kkZn0","../../components/general/HeaderStatusContainer":"6668N","../../components/general/Loader":"bnV5T","../../components/structure/Panels/FullPageTabbedPanel":"72bEo","../applicationContentMenuSelector":"3nrW0","../../components/general/PageError":"ezFTm","../../models/extensions":"7h01B","unstated":"grh7p","../../state/containers/ApplicationAnalyticsFacetContainer":"btY5V","./PartialPublishForm":"bSD86","../../components/general/ContentItemListStatus":"cSnWf","../../models/extensions/contentItems":"5ICLt","1e2c9fadb99d1684":"sFXKk","d04f5b79eaa71829":"7VuKq","f0b56be8f2d52d94":"iwYJ0","3e9108050778fbd0":"aoV7Y","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"kkZn0":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _unstated = require("unstated");
var _moment = require("moment");
var _momentDefault = parcelHelpers.interopDefault(_moment);
var _extensions = require("../../models/extensions");
var _contentInteractionAnalyticsContainer = require("../../state/containers/ContentInteractionAnalyticsContainer");
var _contentInteractionAnalyticsContainerDefault = parcelHelpers.interopDefault(_contentInteractionAnalyticsContainer);
var _contentUserAnalyticsContainer = require("../../state/containers/ContentUserAnalyticsContainer");
var _contentUserAnalyticsContainerDefault = parcelHelpers.interopDefault(_contentUserAnalyticsContainer);
var _contentStatisticsContainer = require("../../state/containers/ContentStatisticsContainer");
var _contentStatisticsContainerDefault = parcelHelpers.interopDefault(_contentStatisticsContainer);
var _tabContainerPanel = require("../../components/structure/Panels/TabContainerPanel");
var _tabContainerPanelDefault = parcelHelpers.interopDefault(_tabContainerPanel);
var _timeIntervalSelectorHeader = require("../../components/analytics/TimeIntervalSelectorHeader");
var _timeIntervalSelectorHeaderDefault = parcelHelpers.interopDefault(_timeIntervalSelectorHeader);
var _reactTabs = require("react-tabs");
var _scrollablePanelBody = require("../../components/structure/ScrollablePanelBody");
var _scrollablePanelBodyDefault = parcelHelpers.interopDefault(_scrollablePanelBody);
var _dateRangeIntervalPicker = require("../../components/analytics/DateRangeIntervalPicker");
var _dateRangeIntervalPickerDefault = parcelHelpers.interopDefault(_dateRangeIntervalPicker);
var _contentMeasurementPage = require("./components/ContentMeasurementPage");
var _contentMeasurementPageDefault = parcelHelpers.interopDefault(_contentMeasurementPage);
var _css = require("@emotion/css");
var _colors = require("../../constants/colors");
var _analyticsDateFormat = require("../../models/analytics/AnalyticsDateFormat");
var _filterToggleButton = require("../../components/analytics/filters/FilterToggleButton");
var _filterToggleButtonDefault = parcelHelpers.interopDefault(_filterToggleButton);
var _analyticsFilters = require("../../components/analytics/filters/AnalyticsFilters");
var _analyticsFiltersDefault = parcelHelpers.interopDefault(_analyticsFilters);
var _contentTrackingPage = require("./components/ContentTrackingPage");
var _contentTrackingPageDefault = parcelHelpers.interopDefault(_contentTrackingPage);
var _queryString = require("query-string");
var _queryStringDefault = parcelHelpers.interopDefault(_queryString);
var _contentTrackingContainer = require("../../state/containers/ContentTrackingContainer");
var _contentTrackingContainerDefault = parcelHelpers.interopDefault(_contentTrackingContainer);
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const measureIcon = require("104f222ff8cc0c6a");
const measureIconBlue = require("de48f9da79effcd9");
const trackIcon = require("ed4ae69cdd6c3eb5");
const trackIconBlue = require("d87c14501ea4b83f");
class ContentAnalytics extends (0, _reactDefault.default).Component {
    constructor(props){
        super(props);
        const query = (0, _queryStringDefault.default).parse(window.location.search);
        this.state = {
            interval: query?.interval ?? "past month",
            startDate: query?.startDate ?? (0, _momentDefault.default)().startOf("day").subtract(28, "days").format((0, _analyticsDateFormat.DATE_FORMAT)),
            endDate: query?.endDate ?? (0, _momentDefault.default)().endOf("day").add(2, "days").format((0, _analyticsDateFormat.DATE_FORMAT)),
            isDatePickerExpanded: false,
            isFilterExpanded: false,
            filter: {}
        };
    }
    handleTabSelection(index, last) {
        if (index == last) return;
        const urlStart = (0, _extensions.getEditUrl)(this.props.contentId, this.props.applicationFeatureId, this.props.featureTypeId) + "analytics/";
        if (index == 0) this.props.history.push(urlStart);
        if (index == 1) this.props.history.push(urlStart + "track");
    }
    getSelectedIndex() {
        if (location.href.indexOf("track") > -1) return 1;
        return 0;
    }
    handleDateRangeChange(startDate, endDate) {
        this.setState({
            ...this.state,
            startDate,
            endDate,
            isDatePickerExpanded: false
        });
    }
    toggleDatePicker() {
        this.setState({
            ...this.state,
            isDatePickerExpanded: !this.state.isDatePickerExpanded
        });
    }
    toggleFilter() {
        this.setState({
            ...this.state,
            isFilterExpanded: !this.state.isFilterExpanded
        });
    }
    handleFilterChange(filter) {
        this.setState({
            ...this.state,
            filter
        });
    }
    getFilterCount() {
        let count = 0;
        if (this.state.filter?.assistants?.length > 0) count++;
        if (this.state.filter?.interfaces?.length > 0) count++;
        if (this.state.filter?.deviceTargetIds?.length > 0) count++;
        if (this.state.filter?.languageIds?.length > 0) count++;
        return count;
    }
    render() {
        const filter = this.props.facetContainer.convertFilter(this.state.startDate, this.state.endDate, this.state.filter, this.props.facetContainer.state.deviceTargets ?? []);
        return (0, _react.jsx)((0, _unstated.Subscribe), {
            to: [
                (0, _contentUserAnalyticsContainerDefault.default),
                (0, _contentInteractionAnalyticsContainerDefault.default),
                (0, _contentStatisticsContainerDefault.default),
                (0, _contentTrackingContainerDefault.default)
            ]
        }, (userAnalyticsContainer, interactionAnalyticsContainer, statisticsContainer, trackingContainer)=>{
            return (0, _react.jsx)((0, _tabContainerPanelDefault.default), {
                className: containerStyle,
                tabs: [
                    {
                        title: "Measure",
                        icon: measureIcon,
                        selectedIcon: measureIconBlue
                    },
                    {
                        title: "Track",
                        icon: trackIcon,
                        selectedIcon: trackIconBlue
                    }
                ],
                selectedIndex: this.getSelectedIndex(),
                onTabSelected: this.handleTabSelection.bind(this),
                additionalHeaderContent: ()=>(0, _react.jsx)("div", {
                        className: headerContainer
                    }, (0, _react.jsx)((0, _timeIntervalSelectorHeaderDefault.default), {
                        startDate: this.state.startDate,
                        endDate: this.state.endDate,
                        isExpanded: this.state.isDatePickerExpanded,
                        onClick: this.toggleDatePicker.bind(this)
                    }), (0, _react.jsx)((0, _filterToggleButtonDefault.default), {
                        filterCount: this.getFilterCount(),
                        isExpanded: this.state.isFilterExpanded,
                        onClick: this.toggleFilter.bind(this)
                    }))
            }, (0, _react.jsx)((0, _reactTabs.TabPanel), null, (0, _react.jsx)((0, _scrollablePanelBodyDefault.default), null, this.state.isFilterExpanded && (0, _react.jsx)((0, _analyticsFiltersDefault.default), {
                currentFilter: this.state.filter,
                onChange: this.handleFilterChange.bind(this),
                filterCount: this.getFilterCount(),
                languages: this.props.contentItem?.languages ?? [],
                deviceTargets: this.props.facetContainer.state.deviceTargets ?? [],
                assistants: this.props.facetContainer.state.assistants ?? [],
                interfaces: this.props.facetContainer.state.interfaces ?? []
            }), this.state.isDatePickerExpanded && (0, _react.jsx)((0, _dateRangeIntervalPickerDefault.default), {
                startDate: this.state.startDate,
                endDate: this.state.endDate,
                interval: this.state.interval,
                onChange: this.handleDateRangeChange.bind(this),
                onClose: this.toggleDatePicker.bind(this)
            }), (0, _react.jsx)((0, _contentMeasurementPageDefault.default), {
                interval: this.state.interval,
                userAnalyticsContainer: userAnalyticsContainer,
                interactionAnalyticsContainer: interactionAnalyticsContainer,
                statisticsContainer: statisticsContainer,
                applicationId: this.props.applicationId,
                contentId: this.props.contentId,
                featureTypeId: this.props.featureTypeId,
                applicationFeatureId: this.props.applicationFeatureId,
                filter: filter,
                history: this.props.history
            }))), (0, _react.jsx)((0, _reactTabs.TabPanel), null, this.state.isFilterExpanded && (0, _react.jsx)((0, _analyticsFiltersDefault.default), {
                currentFilter: this.state.filter,
                onChange: this.handleFilterChange.bind(this),
                filterCount: this.getFilterCount(),
                languages: this.props.contentItem?.languages ?? [],
                deviceTargets: this.props.facetContainer.state.deviceTargets ?? [],
                assistants: this.props.facetContainer.state.assistants ?? [],
                interfaces: this.props.facetContainer.state.interfaces ?? []
            }), this.state.isDatePickerExpanded && (0, _react.jsx)((0, _dateRangeIntervalPickerDefault.default), {
                startDate: this.state.startDate,
                endDate: this.state.endDate,
                interval: this.state.interval,
                onChange: this.handleDateRangeChange.bind(this),
                onClose: this.toggleDatePicker.bind(this)
            }), (0, _react.jsx)((0, _contentTrackingPageDefault.default), {
                trackingContainer: trackingContainer,
                applicationId: this.props.applicationId,
                contentId: this.props.contentId,
                contentItem: this.props.contentItem,
                featureTypeId: this.props.featureTypeId,
                filter: filter,
                history: this.props.history
            })));
        });
    }
}
const containerStyle = /*#__PURE__*/ (0, _css.css)({
    name: "101k0wb",
    styles: ".panel-tab-list{flex:0;}"
});
const headerContainer = /*#__PURE__*/ (0, _css.css)("display:flex;flex:1;height:100%;margin-left:94px;margin-right:32px;align-items:center;border-left:1px solid ", (0, _colors.color_shades_dark), ";", "");
exports.default = ContentAnalytics;

},{"@emotion/react":"djZKr","react":"6uln9","unstated":"grh7p","moment":"2meyw","../../models/extensions":"7h01B","../../state/containers/ContentInteractionAnalyticsContainer":"1o592","../../state/containers/ContentUserAnalyticsContainer":"2uotB","../../state/containers/ContentStatisticsContainer":"5lMwe","../../components/structure/Panels/TabContainerPanel":"iDHIJ","../../components/analytics/TimeIntervalSelectorHeader":"9ttp0","react-tabs":"92Sgf","../../components/structure/ScrollablePanelBody":"6LRg3","../../components/analytics/DateRangeIntervalPicker":"2sClv","./components/ContentMeasurementPage":"hMx5G","@emotion/css":"awUBr","../../constants/colors":"1p3OR","../../models/analytics/AnalyticsDateFormat":"ia5MW","../../components/analytics/filters/FilterToggleButton":"7cwN5","../../components/analytics/filters/AnalyticsFilters":"cKU0F","./components/ContentTrackingPage":"1KotO","query-string":"klvAV","../../state/containers/ContentTrackingContainer":"WpI1B","104f222ff8cc0c6a":"7u8KD","de48f9da79effcd9":"gwpgo","ed4ae69cdd6c3eb5":"dStWl","d87c14501ea4b83f":"dt39z","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1o592":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _defineProperty = require("@babel/runtime/helpers/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _api = require("../../api");
var _genericMeasurementsContainer = require("./GenericMeasurementsContainer");
var _genericMeasurementsContainerDefault = parcelHelpers.interopDefault(_genericMeasurementsContainer);
class ContentInteractionAnalyticsContainer extends (0, _genericMeasurementsContainerDefault.default) {
    constructor(){
        super();
        (0, _definePropertyDefault.default)(this, "breakdownOptions", [
            "By Platform",
            "By Interface",
            "By Device Type",
            "By Language"
        ]);
        (0, _definePropertyDefault.default)(this, "displayOptions", [
            "Interactions",
            "Sessions",
            "Interactions & Sessions"
        ]);
        (0, _definePropertyDefault.default)(this, "getContextId", (scope)=>scope.contentId);
        (0, _definePropertyDefault.default)(this, "getPrimaryHistogramPromise", (scope, interval, filter)=>_api.getUsageHistogramForContent(scope.applicationId, scope.contentId, interval, filter));
        (0, _definePropertyDefault.default)(this, "getSecondaryHistogramPromise", (scope, interval, filter)=>_api.getSessionHistogramForContent(scope.applicationId, scope.contentId, interval, filter));
        (0, _definePropertyDefault.default)(this, "getAverages", async (scope, filter)=>{
            const output = [];
            const previousDates = this.getPreviousDates(filter.startDate, filter.endDate);
            var primaryHistogram = this.state.primaryHistogramData?.find((h)=>this.buildHistogramKey(h) == this.buildCacheKey(scope.contentId, filter));
            var secondaryHistogram = this.state.secondaryHistogramData?.find((h)=>this.buildHistogramKey(h) == this.buildCacheKey(scope.contentId, filter));
            var previousPrimaryHistogram = this.state.primaryHistogramData?.find((h)=>this.buildHistogramKey(h) == this.buildCacheKey(scope.contentId, {
                    ...filter,
                    startDate: previousDates.startDate,
                    endDate: previousDates.endDate
                }));
            var previousSecondaryHistogram = this.state.secondaryHistogramData?.find((h)=>this.buildHistogramKey(h) == this.buildCacheKey(scope.contentId, {
                    ...filter,
                    startDate: previousDates.startDate,
                    endDate: previousDates.endDate
                }));
            var numberOfDays = this.getDaysBetween(filter.startDate, filter.endDate);
            var numberOfOcurredDays = this.getDaysBetween(filter.startDate, filter.endDate, true);
            if (primaryHistogram != null && previousPrimaryHistogram != null) {
                const total = primaryHistogram?.data?.map((h)=>h.count)?.reduce((a, b)=>a + b);
                const prevTotal = previousPrimaryHistogram?.data?.map((h)=>h.count)?.reduce((a, b)=>a + b);
                const value = (total ?? 0) / (numberOfOcurredDays ?? 1);
                const prevValue = (prevTotal ?? 0) / (numberOfDays ?? 1);
                const deltaValue = (value ?? 0) - (prevValue ?? 0);
                output.push({
                    title: "interactions per day",
                    value: value !== Math.round(value) ? value.toFixed(2) : value,
                    deltaPercentage: deltaValue / (value > 0 ? value : 1) * 100,
                    deltaValue: deltaValue !== Math.round(deltaValue) ? deltaValue.toFixed(2) : deltaValue
                });
            }
            if (secondaryHistogram != null && previousSecondaryHistogram != null) {
                const total = secondaryHistogram.data?.map((h)=>h.count)?.reduce((a, b)=>a + b);
                const prevTotal = previousSecondaryHistogram?.data?.map((h)=>h.count)?.reduce((a, b)=>a + b);
                const value = (total ?? 0) / (numberOfOcurredDays ?? 1);
                const prevValue = (prevTotal ?? 0) / (numberOfDays ?? 1);
                const deltaValue = (value ?? 0) - (prevValue ?? 0);
                output.push({
                    title: "sessions per day",
                    value: value !== Math.round(value) ? value.toFixed(2) : value,
                    deltaPercentage: deltaValue / (value > 0 ? value : 1) * 100,
                    deltaValue: deltaValue !== Math.round(deltaValue) ? deltaValue.toFixed(2) : deltaValue
                });
            }
            if (secondaryHistogram != null && primaryHistogram != null && previousPrimaryHistogram != null && previousSecondaryHistogram != null) {
                var interactions = primaryHistogram.data?.map((h)=>h.count)?.reduce((a, b)=>a + b);
                var sessions = secondaryHistogram.data?.map((h)=>h.count)?.reduce((a, b)=>a + b);
                var prevInteractions = previousPrimaryHistogram?.data?.map((h)=>h.count)?.reduce((a, b)=>a + b);
                var prevSessions = previousSecondaryHistogram?.data?.map((h)=>h.count)?.reduce((a, b)=>a + b);
                const value = (interactions ?? 0) / (sessions > 0 ? sessions : 1);
                const prevValue = (prevInteractions ?? 0) / (prevSessions > 0 ? prevSessions : 1);
                const deltaValue = (value ?? 0) - (prevValue ?? 0);
                output.push({
                    title: "interactions per session",
                    value: value !== Math.round(value) ? value.toFixed(2) : value,
                    deltaPercentage: deltaValue / (value > 0 ? value : 1) * 100,
                    deltaValue: deltaValue !== Math.round(deltaValue) ? deltaValue.toFixed(2) : deltaValue
                });
            }
            const averages = [];
            averages.push({
                id: scope.contentId,
                filter,
                items: output
            });
            this.setState({
                ...this.state,
                averages
            });
            return {
                resultType: "Ok",
                errors: [],
                data: output
            };
        });
        (0, _definePropertyDefault.default)(this, "getPrimaryBreakdownPromise", async (scope, filter, breakdownType)=>{
            const breakdownData = {
                resultType: "Ok",
                data: [],
                errors: []
            };
            var aggregateData;
            switch(breakdownType){
                case "By Platform":
                    aggregateData = await _api.getContentInteractionAggregateByAssistant(scope.applicationId, scope.contentId, filter);
                    if (aggregateData.resultType != "Ok") return aggregateData;
                    breakdownData.data = aggregateData.data.map((a, i, agg)=>({
                            label: a.key,
                            iconRender: ()=>this.getPlatformImage(a.key),
                            count: a.count,
                            percentage: this.getPercentage(a.count, agg)
                        }));
                    break;
                case "By Interface":
                    aggregateData = await _api.getContentInteractionAggregateByInterfaceType(scope.applicationId, scope.contentId, filter);
                    if (aggregateData.resultType != "Ok") return aggregateData;
                    breakdownData.data = aggregateData.data.map((a, i, agg)=>({
                            label: a.key,
                            iconRender: ()=>this.getDeviceCapabilityImage(a.key),
                            count: a.count,
                            percentage: this.getPercentage(a.count, agg)
                        }));
                    break;
                case "By Device Type":
                    aggregateData = await _api.getContentInteractionAggregateByDeviceTarget(scope.applicationId, scope.contentId, filter);
                    if (aggregateData.resultType != "Ok") return aggregateData;
                    breakdownData.data = aggregateData.data.map((a, i, agg)=>({
                            label: this.findDeviceType(a.key)?.displayName ?? "Unknown",
                            iconRender: ()=>this.getDeviceTypeImage(a.key),
                            count: a.count,
                            percentage: this.getPercentage(a.count, agg)
                        }));
                    break;
                case "By Language":
                    aggregateData = await _api.getContentInteractionAggregateByLanguage(scope.applicationId, scope.contentId, filter);
                    if (aggregateData.resultType != "Ok") return aggregateData;
                    breakdownData.data = aggregateData.data.map((a, i, agg)=>({
                            label: this.getLanguageTitle(a.key),
                            iconRender: ()=>this.getLanguageImage(a.key),
                            count: a.count,
                            percentage: this.getPercentage(a.count, agg)
                        }));
                    break;
            }
            return breakdownData;
        });
        (0, _definePropertyDefault.default)(this, "getSecondaryBreakdownPromise", async (scope, filter, breakdownType)=>{
            const breakdownData = {
                resultType: "Ok",
                data: [],
                errors: []
            };
            var aggregateData;
            switch(breakdownType){
                case "By Platform":
                    aggregateData = await _api.getContentSessionAggregateByAssistant(scope.applicationId, scope.contentId, filter);
                    if (aggregateData.resultType != "Ok") return aggregateData;
                    breakdownData.data = aggregateData.data.map((a, i, agg)=>({
                            label: a.key,
                            iconRender: ()=>this.getPlatformImage(a.key),
                            count: a.count,
                            percentage: this.getPercentage(a.count, agg)
                        }));
                    break;
                case "By Interface":
                    aggregateData = await _api.getContentSessionAggregateByInterfaceType(scope.applicationId, scope.contentId, filter);
                    if (aggregateData.resultType != "Ok") return aggregateData;
                    breakdownData.data = aggregateData.data.map((a, i, agg)=>({
                            label: a.key,
                            iconRender: ()=>this.getDeviceCapabilityImage(a.key),
                            count: a.count,
                            percentage: this.getPercentage(a.count, agg)
                        }));
                    break;
                case "By Device Type":
                    aggregateData = await _api.getContentSessionAggregateByDeviceTarget(scope.applicationId, scope.contentId, filter);
                    if (aggregateData.resultType != "Ok") return aggregateData;
                    breakdownData.data = aggregateData.data.map((a, i, agg)=>({
                            label: this.findDeviceType(a.key)?.displayName ?? "Unknown",
                            iconRender: ()=>this.getDeviceTypeImage(a.key),
                            count: a.count,
                            percentage: this.getPercentage(a.count, agg)
                        }));
                    break;
                case "By Language":
                    aggregateData = await _api.getContentSessionAggregateByLanguage(scope.applicationId, scope.contentId, filter);
                    if (aggregateData.resultType != "Ok") return aggregateData;
                    breakdownData.data = aggregateData.data.map((a, i, agg)=>({
                            label: a.key,
                            iconRender: ()=>this.getLanguageImage(a.key),
                            count: a.count,
                            percentage: this.getPercentage(a.count, agg)
                        }));
                    break;
            }
            return breakdownData;
        });
        this.state = {
            isLoadingHistogram: false,
            isLoadingBreakdown: false,
            currentBreakdown: this.breakdownOptions[0],
            currentDisplayOption: this.displayOptions[0],
            currentDeltaPeriod: "Previous Period",
            currentDeltaType: "Value"
        };
    }
}
exports.default = ContentInteractionAnalyticsContainer;

},{"@babel/runtime/helpers/defineProperty":"9sJxO","../../api":"loxM6","./GenericMeasurementsContainer":"gjwAK","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"gjwAK":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _api = require("../../api");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _extensions = require("../../models/extensions");
var _languages = require("../../models/extensions/languages");
var _avatarContainer = require("../../components/general/AvatarContainer");
var _avatarContainerDefault = parcelHelpers.interopDefault(_avatarContainer);
var _genericAnalyticsContainer = require("./GenericAnalyticsContainer");
var _genericAnalyticsContainerDefault = parcelHelpers.interopDefault(_genericAnalyticsContainer);
var _platforms = require("../../models/extensions/platforms");
const speakerIcon = require("1b47c821d51c8fd");
const screenIcon = require("a6dbaf5fd315854e");
const chatIcon = require("f544518c66eff833");
class GenericMeasurementsContainer extends (0, _genericAnalyticsContainerDefault.default) {
    async loadPrimaryHistogram(scope, interval, filter) {
        try {
            await this.setLoadingHistogram(true);
            const previousPeriod = this.getPreviousDates(filter.startDate, filter.endDate);
            const existingHistogram = this.state.primaryHistogramData?.find((r)=>this.buildHistogramKey(r) == this.buildCacheKey(this.getContextId(scope), filter));
            const existingPrevious = this.state.primaryHistogramData?.find((r)=>this.buildHistogramKey(r) == this.buildCacheKey(this.getContextId(scope), {
                    ...filter,
                    startDate: previousPeriod.startDate,
                    endDate: previousPeriod.endDate
                }));
            if (!existingPrevious) await this.reloadPrimaryHistogram(scope, interval, {
                ...filter,
                startDate: previousPeriod.startDate,
                endDate: previousPeriod.endDate
            });
            if (existingHistogram) {
                await this.setLoadingHistogram(false);
                return new Promise((resolve)=>resolve({
                        resultType: "Ok",
                        errors: null,
                        data: existingHistogram.data
                    }));
            }
            // load primary and previous period at the same time
            var primaryPromise = this.reloadPrimaryHistogram(scope, interval, filter);
            await this.setLoadingHistogram(false);
            return primaryPromise;
        } catch  {
            await this.setLoadingHistogram(false);
        }
    }
    async reloadPrimaryHistogram(scope, interval, filter) {
        try {
            const result = await this.getPrimaryHistogramPromise(scope, interval, filter);
            if (result.resultType == "Ok") {
                const newUsage = {
                    id: this.getContextId(scope),
                    filter: {
                        ...filter
                    },
                    interval: interval,
                    data: result.data
                };
                newUsage.key = this.buildHistogramKey(newUsage);
                var usage = this.state.primaryHistogramData ?? [];
                usage.push(newUsage);
                await this.setState({
                    ...this.state,
                    isLoadingHistogram: false,
                    errors: [],
                    primaryHistogramData: usage
                });
            }
            return result;
        } catch  {}
    }
    async loadSecondaryHistogram(scope, interval, filter) {
        try {
            await this.setSecondaryLoadingHistogram(true);
            const previousPeriod = this.getPreviousDates(filter.startDate, filter.endDate);
            const existingHistogram = this.state.secondaryHistogramData?.find((r)=>this.buildHistogramKey(r) == this.buildCacheKey(this.getContextId(scope), filter));
            const existingPrevious = this.state.secondaryHistogramData?.find((r)=>this.buildHistogramKey(r) == this.buildCacheKey(this.getContextId(scope), {
                    ...filter,
                    startDate: previousPeriod.startDate,
                    endDate: previousPeriod.endDate
                }));
            if (!existingPrevious) await this.reloadSecondaryHistogram(scope, interval, {
                ...filter,
                startDate: previousPeriod.startDate,
                endDate: previousPeriod.endDate
            });
            if (existingHistogram) {
                await this.setSecondaryLoadingHistogram(false);
                return new Promise((resolve)=>resolve({
                        resultType: "Ok",
                        errors: null,
                        data: existingHistogram.data
                    }));
            }
            // load primary and previous period at the same time
            var secondaryPromise = await this.reloadSecondaryHistogram(scope, interval, filter);
            await this.setSecondaryLoadingHistogram(false);
            return secondaryPromise;
        } catch  {
            await this.setSecondaryLoadingHistogram(false);
        }
    }
    async reloadSecondaryHistogram(scope, interval, filter) {
        try {
            const result = await this.getSecondaryHistogramPromise(scope, interval, filter);
            if (result.resultType == "Ok") {
                const newUsage = {
                    id: this.getContextId(scope),
                    filter,
                    interval: interval,
                    data: result.data
                };
                newUsage.key = this.buildHistogramKey(newUsage);
                var usage = this.state.secondaryHistogramData ?? [];
                usage.push(newUsage);
                await this.setState({
                    ...this.state,
                    errors: [],
                    secondaryHistogramData: usage
                });
            }
            return result;
        } catch  {}
    }
    async loadPrimaryBreakdown(scope, filter, breakdownType) {
        try {
            await this.setLoadingBreakdown(true);
            const existingBreakdown = this.state.primaryBreakdownData?.find((r)=>this.buildBreakdownKey(r) == this.buildCacheKey(this.getContextId(scope), filter, breakdownType));
            if (existingBreakdown) {
                await this.setLoadingBreakdown(false);
                return new Promise((resolve)=>resolve({
                        resultType: "Ok",
                        errors: null,
                        data: existingBreakdown.items
                    }));
            }
            const result = await this.getPrimaryBreakdownPromise(scope, filter, breakdownType);
            if (result.resultType == "Ok") {
                var usage = this.state.primaryBreakdownData ?? [];
                const newUsage = {
                    id: this.getContextId(scope),
                    filter,
                    type: breakdownType,
                    items: result.data
                };
                newUsage.key = this.buildBreakdownKey(newUsage);
                usage.push(newUsage);
                await this.setState({
                    ...this.state,
                    isLoadingBreakdown: false,
                    errors: [],
                    primaryBreakdownData: usage
                });
            }
            await this.setLoadingBreakdown(false);
            return result;
        } catch  {
            await this.setLoadingBreakdown(false);
        }
    }
    async loadSecondaryBreakdown(scope, filter, breakdownType) {
        await this.setLoadingBreakdown(true);
        const existingBreakdown = this.state.secondaryBreakdownData?.find((r)=>this.buildBreakdownKey(r) == this.buildCacheKey(this.getContextId(scope), filter, breakdownType));
        if (existingBreakdown) {
            await this.setLoadingBreakdown(false);
            return new Promise((resolve)=>resolve({
                    resultType: "Ok",
                    errors: null,
                    data: existingBreakdown.items
                }));
        }
        const promise = this.getSecondaryBreakdownPromise(scope, filter, breakdownType);
        promise.then(async (result)=>{
            if (result.resultType == "Ok") {
                var usage = this.state.secondaryBreakdownData ?? [];
                const newUsage = {
                    id: this.getContextId(scope),
                    filter,
                    type: breakdownType,
                    items: result.data
                };
                newUsage.key = this.buildBreakdownKey(newUsage);
                usage.push(newUsage);
                await this.setState({
                    ...this.state,
                    isLoadingBreakdown: false,
                    errors: [],
                    secondaryBreakdownData: usage
                });
            } else await this.setLoadingBreakdown(false);
        }).catch(async (error)=>{
            await this.setLoadingBreakdown(false);
        });
        return promise;
    }
    createBreakdownItems(aggregateData, title, labelRender, iconRender) {
        const total = aggregateData.reduce((a, b)=>{
            return a + b.count;
        }, 0);
        return aggregateData.map((a)=>({
                count: a.count,
                percentage: a.count / total * 100,
                iconRender: iconRender,
                label: labelRender()
            }));
    }
    loadFeatureTypes() {
        if (this.state.featureTypes?.length > 0) return new Promise((resolve)=>{
            resolve({
                data: this.state.featureTypes,
                resultType: "Ok",
                errors: null
            });
        });
        const promise = _api.getFeatureTypes();
        promise.then((result)=>{
            if (result.resultType == "Ok") this.setState({
                ...this.state,
                featureTypes: result.data
            });
        });
        return promise;
    }
    async loadDeviceTypes() {
        if (this.state.deviceTypes?.length > 0) return {
            data: this.state.deviceTypes,
            resultType: "Ok",
            errors: null
        };
        const promise = _api.getAllDeviceTargets();
        promise.then((result)=>{
            if (result.resultType == "Ok") this.setState({
                ...this.state,
                deviceTypes: result.data
            });
        });
        return await promise;
    }
    findFeatureType(featureTypeId) {
        var type = this.state.featureTypes.find((f)=>f.id == featureTypeId);
        if (type === undefined || type === null) return {
            id: "unknown",
            name: "Unknown",
            description: "Unknown"
        };
        return type;
    }
    findDeviceType(deviceTypeId) {
        return this.state.deviceTypes?.find((f)=>f.id == deviceTypeId);
    }
    async handleBreakdownChange(option) {
        await this.setState({
            ...this.state,
            currentBreakdown: option
        });
    }
    getHistogramDateLabel(interval, date) {
        if (interval == "hour") return date.format("hh:mm a"); //the other intervals need to be converted to utc because their hour:minutes is 0
        if (interval == "dayAndHour") //more then a day but less than 2 days, need to supply Day and Hour
        return date.utc().format("DD hh:mm a");
        if (interval == "year") return date.utc().year().toString();
        if (interval == "month") return date.utc().format("MMM, YYYY");
        return date.utc().format("M/DD");
    }
    getDeviceTypeImage(deviceTargetId) {
        var deviceType = this.findDeviceType(deviceTargetId);
        if (!deviceType?.iconUrl) return (0, _react.jsx)((0, _avatarContainerDefault.default), {
            size: 32
        });
        return (0, _react.jsx)("img", {
            src: deviceType.iconUrl
        });
    }
    getDeviceCapabilityImage(category) {
        switch(category){
            case "Audio":
                return (0, _react.jsx)("img", {
                    src: speakerIcon
                });
            case "Screen":
                return (0, _react.jsx)("img", {
                    src: screenIcon
                });
            case "Chat":
                return (0, _react.jsx)("img", {
                    src: chatIcon
                });
        }
    }
    getPlatformImage(platform) {
        return (0, _react.jsx)((0, _avatarContainerDefault.default), {
            size: 32,
            noPadding: true
        }, (0, _react.jsx)("img", {
            src: (0, _platforms.getPlatformIcon)(platform)
        }));
    }
    getFeatureTypeImage(featureTypeId) {
        return (0, _react.jsx)("img", {
            src: (0, _extensions.getSmallFeatureTypeIcon)(featureTypeId)
        });
    }
    getLanguageImage(locale) {
        return (0, _react.jsx)((0, _avatarContainerDefault.default), {
            size: 32,
            noPadding: true
        }, (0, _react.jsx)("img", {
            src: (0, _languages.getFlagIcon)(locale.length == 5 ? locale.substr(3, 2) : locale)
        }));
    }
    getLanguageTitle(locale) {
        if (locale.length == 2) return (0, _languages.getLanguageName)(locale);
        else if (locale.length == 5) return `${(0, _languages.getLanguageName)(locale.substr(0, 2))} - ${(0, _languages.getRegionName)(locale.substr(3, 2))}`;
        return locale;
    }
    async setLoadingHistogram(isLoading) {
        if (this.state.isLoadingHistogram != isLoading) await this.setState({
            ...this.state,
            isLoadingHistogram: isLoading
        });
    }
    async setSecondaryLoadingHistogram(isLoading) {
        if (this.state.isLoadingSecondaryHistogram != isLoading) await this.setState({
            ...this.state,
            isLoadingSecondaryHistogram: isLoading
        });
    }
    async setLoadingBreakdown(isLoading) {
        if (this.state.isLoadingBreakdown != isLoading) await this.setState({
            ...this.state,
            isLoadingBreakdown: isLoading
        });
    }
}
exports.default = GenericMeasurementsContainer;

},{"@emotion/react":"djZKr","../../api":"loxM6","react":"6uln9","../../models/extensions":"7h01B","../../models/extensions/languages":"8E5Oo","../../components/general/AvatarContainer":"fvd8A","./GenericAnalyticsContainer":"3eKoF","../../models/extensions/platforms":"fObhx","1b47c821d51c8fd":"9pEQA","a6dbaf5fd315854e":"9l70Q","f544518c66eff833":"3u7X8","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"fvd8A":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _colors = require("../../constants/colors");
const AvatarContainer = (props)=>(0, _react.jsx)("div", {
        className: `${containerStyle} ${props.className !== undefined ? props.className : ""} ${props.noPadding ? "no-pad" : ""}`,
        style: {
            width: props.size,
            height: props.size,
            minWidth: props.size,
            minHeight: props.size
        }
    }, props.children);
const containerStyle = /*#__PURE__*/ (0, _css.css)("border-radius:50%;box-shadow:0 2px 4px 0 ", (0, _colors.dark_grey_blue_10), ";border:solid 1px ", (0, _colors.silver_three), ";background:white;display:flex;align-items:center;justify-content:center;box-sizing:border-box;&.no-pad{padding:0;>img{width:100%;height:100%;}}", "");
exports.default = AvatarContainer;

},{"@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","../../constants/colors":"1p3OR","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3eKoF":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _unstated = require("unstated");
var _moment = require("moment");
var _momentDefault = parcelHelpers.interopDefault(_moment);
var _analyticsDateFormat = require("../../models/analytics/AnalyticsDateFormat");
class GenericAnalyticsContainer extends (0, _unstated.Container) {
    handleDisplayOptionChange(option) {
        this.setState({
            ...this.state,
            currentDisplayOption: option
        });
    }
    handleSparkDisplayOptionChange(option) {
        this.setState({
            ...this.state,
            sparkDisplayOption: option
        });
    }
    handleDeltaPeriodChange(option) {
        return this.setState({
            ...this.state,
            currentDeltaPeriod: option
        });
    }
    handleDeltaTypeChange(option) {
        this.setState({
            ...this.state,
            currentDeltaType: option
        });
    }
    getPreviousDates(startDate, endDate) {
        if (this.state.currentDeltaPeriod == "Previous Period") {
            const start = (0, _momentDefault.default)(startDate, (0, _analyticsDateFormat.DATE_FORMAT));
            const end = (0, _momentDefault.default)(endDate, (0, _analyticsDateFormat.DATE_FORMAT));
            const duration = end.diff(start, "days");
            const tempStart = (0, _momentDefault.default)(startDate, (0, _analyticsDateFormat.DATE_FORMAT));
            const isFullMonth = start.isSame(start.clone().startOf("month"), "day") && end.isSame(end.clone().endOf("month"), "day");
            let prevStart;
            if (isFullMonth) {
                const monthDuration = end.diff(start, "month");
                prevStart = tempStart.subtract(monthDuration + 1, "month").startOf("day");
            } else prevStart = tempStart.subtract(duration + 1, "days").startOf("day");
            const prevEnd = start.subtract(1, "seconds");
            return {
                startDate: prevStart.format((0, _analyticsDateFormat.DATE_FORMAT)),
                endDate: prevEnd.format((0, _analyticsDateFormat.DATE_FORMAT))
            };
        }
        if (this.state.currentDeltaPeriod == "Same Time Last Year") return {
            startDate: (0, _momentDefault.default)(startDate, (0, _analyticsDateFormat.DATE_FORMAT)).subtract(1, "year").format((0, _analyticsDateFormat.DATE_FORMAT)),
            endDate: (0, _momentDefault.default)(endDate, (0, _analyticsDateFormat.DATE_FORMAT)).subtract(1, "year").format((0, _analyticsDateFormat.DATE_FORMAT))
        };
        return null;
    }
    getDaysBetween(startDate, endDate, enforcePast) {
        const start = (0, _momentDefault.default)(startDate, (0, _analyticsDateFormat.DATE_FORMAT));
        const end = (0, _momentDefault.default)(endDate, (0, _analyticsDateFormat.DATE_FORMAT));
        const today = (0, _momentDefault.default)();
        const isEndFuture = end.isAfter(today);
        const daysDiff = (isEndFuture && enforcePast ? today : end).diff(start, "days") + 1; // add one to be inclusive of start date
        if (daysDiff < 1) // we can get 0 if we are in the same day, but we want to assert the calculation to 1
        return 1;
        return daysDiff;
    }
    buildCacheKey(id, filter, additionalKey) {
        return id + JSON.stringify(filter) + (additionalKey ?? "");
    }
    buildBreakdownKey(breakdown) {
        if (breakdown.key) return breakdown.key;
        return this.buildCacheKey(breakdown.id, breakdown.filter, breakdown.type);
    }
    buildHistogramKey(histogram) {
        if (histogram.key) return histogram.key;
        return this.buildCacheKey(histogram.id, histogram.filter);
    }
    buildAverageKey(average) {
        if (average.key) return average.key;
        return this.buildCacheKey(average.id, average.filter);
    }
    getPercentage(count, agg) {
        return count / agg.reduce((a, b)=>a + b.count, 0) * 100;
    }
    setLoading(isLoading) {
        this.setState({
            ...this.state,
            isLoading
        });
    }
}
exports.default = GenericAnalyticsContainer;

},{"unstated":"grh7p","moment":"2meyw","../../models/analytics/AnalyticsDateFormat":"ia5MW","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"fObhx":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getPlatformIcon", ()=>getPlatformIcon);
const alexaIcon = require("11192a5c2e58be25");
const azureIcon = require("e5d272e6003f1cf6");
const customBotIcon = require("d987fa4ca9bb8e22");
const cortanaIcon = require("d65249bed938182c");
const dialogflowIcon = require("bb6852bfe81a0e23");
const googleIcon = require("ead915dfc5a11c16");
const getPlatformIcon = (platform)=>{
    switch(platform?.toLocaleLowerCase()){
        case "alexa":
            return alexaIcon;
        case "google":
        case "googleassistant":
            return googleIcon;
        case "cortana":
            return cortanaIcon;
        case "dialogflow":
            return dialogflowIcon;
        case "webchat":
            return azureIcon;
    }
    return customBotIcon;
};

},{"11192a5c2e58be25":"7iQdL","e5d272e6003f1cf6":"g0Elm","d987fa4ca9bb8e22":"a0DXf","d65249bed938182c":"3gV4X","bb6852bfe81a0e23":"gPHJM","ead915dfc5a11c16":"d4OQN","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7iQdL":[function(require,module,exports) {
module.exports = require("2122b44f3324d94e").getBundleURL("kVLro") + require("56e220c59389c8bd").resolve("bf4Dz");

},{"2122b44f3324d94e":"c7Tr5","56e220c59389c8bd":"fyJL2"}],"g0Elm":[function(require,module,exports) {
module.exports = require("c0b78a31310342a6").getBundleURL("kVLro") + require("221b69e9a24e205e").resolve("aJglR");

},{"c0b78a31310342a6":"c7Tr5","221b69e9a24e205e":"fyJL2"}],"a0DXf":[function(require,module,exports) {
module.exports = require("95793865dcd88bdf").getBundleURL("kVLro") + require("e9bf4683d6908308").resolve("bmwnB");

},{"95793865dcd88bdf":"c7Tr5","e9bf4683d6908308":"fyJL2"}],"3gV4X":[function(require,module,exports) {
module.exports = require("e08b20554214feb1").getBundleURL("kVLro") + require("2a0434760f7467d1").resolve("5ZjMj");

},{"e08b20554214feb1":"c7Tr5","2a0434760f7467d1":"fyJL2"}],"gPHJM":[function(require,module,exports) {
module.exports = require("bb57dbeb61ebd07a").getBundleURL("kVLro") + require("77cef53902324ba6").resolve("dIvPi");

},{"bb57dbeb61ebd07a":"c7Tr5","77cef53902324ba6":"fyJL2"}],"d4OQN":[function(require,module,exports) {
module.exports = require("35948437671c44bb").getBundleURL("kVLro") + require("25c1aca64e15c685").resolve("1W40C");

},{"35948437671c44bb":"c7Tr5","25c1aca64e15c685":"fyJL2"}],"2uotB":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _defineProperty = require("@babel/runtime/helpers/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _api = require("../../api");
var _genericMeasurementsContainer = require("./GenericMeasurementsContainer");
var _genericMeasurementsContainerDefault = parcelHelpers.interopDefault(_genericMeasurementsContainer);
class ContentUserAnalyticsContainer extends (0, _genericMeasurementsContainerDefault.default) {
    constructor(){
        super();
        (0, _definePropertyDefault.default)(this, "breakdownOptions", [
            "By Platform",
            "By Interface",
            "By Device Type",
            "By Language"
        ]);
        (0, _definePropertyDefault.default)(this, "displayOptions", [
            "Total Users",
            "New Users",
            "Total Users & New Users"
        ]);
        (0, _definePropertyDefault.default)(this, "getContextId", (scope)=>scope.contentId);
        (0, _definePropertyDefault.default)(this, "getPrimaryHistogramPromise", (scope, interval, filter)=>_api.getUserHistogramForContent(scope.applicationId, scope.contentId, interval, filter));
        (0, _definePropertyDefault.default)(this, "getSecondaryHistogramPromise", (scope, interval, filter)=>_api.getNewUserHistogramForContent(scope.applicationId, scope.contentId, interval, filter));
        (0, _definePropertyDefault.default)(this, "getAverages", async (scope, filter)=>{
            const output = [];
            const previousDates = this.getPreviousDates(filter.startDate, filter.endDate);
            var usersHistogram = this.state.primaryHistogramData?.find((h)=>this.buildHistogramKey(h) == this.buildCacheKey(scope.contentId, filter));
            var secondaryHistogram = this.state.secondaryHistogramData?.find((h)=>this.buildHistogramKey(h) == this.buildCacheKey(scope.contentId, filter));
            var previousUsersHistogram = this.state.primaryHistogramData?.find((h)=>this.buildHistogramKey(h) == this.buildCacheKey(scope.contentId, {
                    ...filter,
                    startDate: previousDates.startDate,
                    endDate: previousDates.endDate
                }));
            var previousSecondaryHistogram = this.state.secondaryHistogramData?.find((h)=>this.buildHistogramKey(h) == this.buildCacheKey(scope.contentId, {
                    ...filter,
                    startDate: previousDates.startDate,
                    endDate: previousDates.endDate
                }));
            var numberOfDays = this.getDaysBetween(filter.startDate, filter.endDate);
            var numberOfOcurredDays = this.getDaysBetween(filter.startDate, filter.endDate, true);
            if (usersHistogram != null && previousUsersHistogram != null) {
                const total = usersHistogram.data?.map((h)=>h.count)?.reduce((a, b)=>a + b);
                const prevTotal = previousUsersHistogram?.data?.map((h)=>h.count)?.reduce((a, b)=>a + b);
                const value = (total ?? 0) / (numberOfOcurredDays ?? 1);
                const prevValue = (prevTotal ?? 0) / (numberOfDays ?? 1);
                const deltaValue = (value ?? 0) - (prevValue ?? 0);
                output.push({
                    title: "users per day",
                    value: value !== Math.round(value) ? value.toFixed(2) : value,
                    deltaPercentage: deltaValue / (value > 0 ? value : 1) * 100,
                    deltaValue: deltaValue !== Math.round(deltaValue) ? deltaValue.toFixed(2) : deltaValue
                });
            }
            if (secondaryHistogram != null && previousSecondaryHistogram != null) {
                const total = secondaryHistogram.data?.map((h)=>h.count)?.reduce((a, b)=>a + b);
                const prevTotal = previousSecondaryHistogram?.data?.map((h)=>h.count)?.reduce((a, b)=>a + b);
                const value = (total ?? 0) / (numberOfOcurredDays ?? 1);
                const prevValue = (prevTotal ?? 0) / (numberOfDays ?? 1);
                const deltaValue = (value ?? 0) - (prevValue ?? 0);
                output.push({
                    title: "new users per day",
                    value: value !== Math.round(value) ? value.toFixed(2) : value,
                    deltaPercentage: deltaValue / (value > 0 ? value : 1) * 100,
                    deltaValue: deltaValue !== Math.round(deltaValue) ? deltaValue.toFixed(2) : deltaValue
                });
            }
            const averages = this.state.averages ?? [];
            averages.push({
                id: scope.contentId,
                filter,
                items: output
            });
            this.setState({
                ...this.state,
                averages
            });
            return {
                resultType: "Ok",
                errors: [],
                data: output
            };
        });
        (0, _definePropertyDefault.default)(this, "getPrimaryBreakdownPromise", async (scope, filter, breakdownType)=>{
            const breakdownData = {
                resultType: "Ok",
                data: [],
                errors: []
            };
            var aggregateData;
            switch(breakdownType){
                case "By Platform":
                    aggregateData = await _api.getContentUserAggregateByAssistant(scope.applicationId, scope.contentId, filter);
                    if (aggregateData.resultType != "Ok") return aggregateData;
                    breakdownData.data = aggregateData.data.map((a, i, agg)=>({
                            label: a.key,
                            iconRender: ()=>this.getPlatformImage(a.key),
                            count: a.count,
                            percentage: this.getPercentage(a.count, agg)
                        }));
                    break;
                case "By Interface":
                    aggregateData = await _api.getContentUserAggregateByInterfaceType(scope.applicationId, scope.contentId, filter);
                    if (aggregateData.resultType != "Ok") return aggregateData;
                    breakdownData.data = aggregateData.data.map((a, i, agg)=>({
                            label: a.key,
                            iconRender: ()=>this.getDeviceCapabilityImage(a.key),
                            count: a.count,
                            percentage: this.getPercentage(a.count, agg)
                        }));
                    break;
                case "By Device Type":
                    aggregateData = await _api.getContentUserAggregateByDeviceTarget(scope.applicationId, scope.contentId, filter);
                    if (aggregateData.resultType != "Ok") return aggregateData;
                    breakdownData.data = aggregateData.data.map((a, i, agg)=>({
                            label: this.findDeviceType(a.key)?.displayName ?? "Unknown",
                            iconRender: ()=>this.getDeviceTypeImage(a.key),
                            count: a.count,
                            percentage: this.getPercentage(a.count, agg)
                        }));
                    break;
                case "By Language":
                    aggregateData = await _api.getContentUserAggregateByLanguage(scope.applicationId, scope.contentId, filter);
                    if (aggregateData.resultType != "Ok") return aggregateData;
                    breakdownData.data = aggregateData.data.map((a, i, agg)=>({
                            label: this.getLanguageTitle(a.key),
                            iconRender: ()=>this.getLanguageImage(a.key),
                            count: a.count,
                            percentage: this.getPercentage(a.count, agg)
                        }));
                    break;
            }
            return breakdownData;
        });
        (0, _definePropertyDefault.default)(this, "getSecondaryBreakdownPromise", async (scope, filter, breakdownType)=>{
            const breakdownData = {
                resultType: "Ok",
                data: [],
                errors: []
            };
            var aggregateData;
            switch(breakdownType){
                case "By Platform":
                    aggregateData = await _api.getContentNewUserAggregateByAssistant(scope.applicationId, scope.contentId, filter);
                    if (aggregateData.resultType != "Ok") return aggregateData;
                    breakdownData.data = aggregateData.data.map((a, i, agg)=>({
                            label: a.key,
                            iconRender: ()=>this.getPlatformImage(a.key),
                            count: a.count,
                            percentage: this.getPercentage(a.count, agg)
                        }));
                    break;
                case "By Interface":
                    aggregateData = await _api.getContentNewUserAggregateByInterfaceType(scope.applicationId, scope.contentId, filter);
                    if (aggregateData.resultType != "Ok") return aggregateData;
                    breakdownData.data = aggregateData.data.map((a, i, agg)=>({
                            label: a.key,
                            iconRender: ()=>this.getDeviceCapabilityImage(a.key),
                            count: a.count,
                            percentage: this.getPercentage(a.count, agg)
                        }));
                    break;
                case "By Device Type":
                    aggregateData = await _api.getContentNewUserAggregateByDeviceTarget(scope.applicationId, scope.contentId, filter);
                    if (aggregateData.resultType != "Ok") return aggregateData;
                    breakdownData.data = aggregateData.data.map((a, i, agg)=>({
                            label: this.findDeviceType(a.key)?.displayName ?? "Unknown",
                            iconRender: ()=>this.getDeviceTypeImage(a.key),
                            count: a.count,
                            percentage: this.getPercentage(a.count, agg)
                        }));
                    break;
                case "By Language":
                    aggregateData = await _api.getContentNewUserAggregateByLanguage(scope.applicationId, scope.contentId, filter);
                    if (aggregateData.resultType != "Ok") return aggregateData;
                    breakdownData.data = aggregateData.data.map((a, i, agg)=>({
                            label: a.key,
                            iconRender: ()=>this.getLanguageImage(a.key),
                            count: a.count,
                            percentage: this.getPercentage(a.count, agg)
                        }));
                    break;
            }
            return breakdownData;
        });
        this.state = {
            isLoadingHistogram: false,
            isLoadingBreakdown: false,
            currentBreakdown: this.breakdownOptions[0],
            currentDisplayOption: this.displayOptions[0],
            currentDeltaPeriod: "Previous Period",
            currentDeltaType: "Value"
        };
    }
}
exports.default = ContentUserAnalyticsContainer;

},{"@babel/runtime/helpers/defineProperty":"9sJxO","../../api":"loxM6","./GenericMeasurementsContainer":"gjwAK","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"5lMwe":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _defineProperty = require("@babel/runtime/helpers/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _api = require("../../api");
var _genericAnalyticsContainer = require("./GenericAnalyticsContainer");
var _genericAnalyticsContainerDefault = parcelHelpers.interopDefault(_genericAnalyticsContainer);
class ContentStatisticsContainer extends (0, _genericAnalyticsContainerDefault.default) {
    constructor(){
        super();
        (0, _definePropertyDefault.default)(this, "displayOptions", []);
        this.state = {
            contentStats: [],
            isLoading: false,
            isLoadingTotals: false,
            currentDisplayOption: "",
            currentDeltaPeriod: "Previous Period",
            currentDeltaType: "Value",
            errors: []
        };
    }
    async loadStats(applicationId, contentId, filter) {
        await this.setLoading(true);
        const previousPeriod = this.getPreviousDates(filter.startDate, filter.endDate);
        const existingStats = this.state.contentStats?.find((r)=>this.buildCacheKey(r.id, r.filter) == this.buildCacheKey(applicationId, filter));
        const existingPrevious = this.state.contentStats?.find((r)=>this.buildCacheKey(r.id, r.filter) == this.buildCacheKey(applicationId, {
                ...filter,
                startDate: previousPeriod.startDate,
                endDate: previousPeriod.endDate
            }));
        if (!existingPrevious) await this.reloadStats(applicationId, contentId, {
            ...filter,
            startDate: previousPeriod.startDate,
            endDate: previousPeriod.endDate
        });
        if (existingStats) {
            this.setLoading(false);
            return new Promise((resolve)=>resolve({
                    resultType: "Ok",
                    errors: null,
                    data: existingStats.data
                }));
        }
        // load primary and previous period at the same time
        var primaryPromise = this.reloadStats(applicationId, contentId, filter);
        return primaryPromise;
    }
    async reloadStats(applicationId, contentId, filter) {
        this.setLoadingTotals(true);
        const existingStats = this.state.contentStats.find((r)=>this.buildCacheKey(r.id, r.filter) == this.buildCacheKey(applicationId, filter));
        if (existingStats !== undefined && existingStats !== null) {
            this.setLoadingTotals(false);
            return new Promise((resolve)=>resolve({
                    resultType: "Ok",
                    errors: null,
                    data: existingStats.data
                }));
        }
        const promise = _api.getContentItemStats(applicationId, contentId, filter);
        promise.then((result)=>{
            if (result.resultType == "Ok") {
                var usage = this.state.contentStats;
                usage.push({
                    id: contentId,
                    filter,
                    data: result.data
                });
                this.setState({
                    ...this.state,
                    isLoadingTotals: false,
                    errors: [],
                    contentStats: usage
                });
            } else this.setLoadingTotals(false);
        }).catch(()=>{
            this.setLoadingTotals(false);
        });
        return promise;
    }
    setLoadingTotals(isLoading) {
        this.setState({
            ...this.state,
            isLoadingTotals: isLoading
        });
    }
}
exports.default = ContentStatisticsContainer;

},{"@babel/runtime/helpers/defineProperty":"9sJxO","../../api":"loxM6","./GenericAnalyticsContainer":"3eKoF","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9ttp0":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _moment = require("moment");
var _momentDefault = parcelHelpers.interopDefault(_moment);
var _colors = require("../../constants/colors");
var _stylesCss = require("react-date-range/dist/styles.css"); // main style file
var _defaultCss = require("react-date-range/dist/theme/default.css"); // theme css file
var _analyticsDateFormat = require("../../models/analytics/AnalyticsDateFormat");
const indicatorIcon = require("c06c85b7e875ce6c");
const TimeIntervalSelectorHeader = (props)=>(0, _react.jsx)("div", {
        className: `${containerStyle} ac-analytics-timeframe-picker ${props.className}`,
        onClick: props.onClick
    }, (0, _react.jsx)("p", {
        className: "time-label"
    }, "Timeframe"), (0, _react.jsx)("p", {
        className: "time-selection"
    }, (0, _react.jsx)("span", null, (0, _momentDefault.default)(props.startDate, (0, _analyticsDateFormat.DATE_FORMAT)).format("MMM DD, YYYY")), (0, _react.jsx)("span", null, "-"), (0, _react.jsx)("span", null, (0, _momentDefault.default)(props.endDate, (0, _analyticsDateFormat.DATE_FORMAT)).format("MMM DD, YYYY"))), (0, _react.jsx)("img", {
        src: indicatorIcon,
        className: props.isExpanded ? "up" : "down"
    }));
const containerStyle = /*#__PURE__*/ (0, _css.css)("display:flex;align-items:center;cursor:pointer;height:100%;.time-label{font-size:14px;line-height:16px;letter-spacing:0.1em;text-transform:uppercase;color:", (0, _colors.color_text_light), ";padding:0 16px 0 32px;}.time-selection{padding-left:16px;font-size:24px;line-height:32px;border-left:1px solid ", (0, _colors.color_shades_dark), ";>span{margin-right:12px;}}>img{&.down{transform:rotate(180deg);}}", "");
exports.default = TimeIntervalSelectorHeader;

},{"@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","moment":"2meyw","../../constants/colors":"1p3OR","react-date-range/dist/styles.css":"1JfNp","react-date-range/dist/theme/default.css":"8BHQG","../../models/analytics/AnalyticsDateFormat":"ia5MW","c06c85b7e875ce6c":"cW7Iq","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1JfNp":[function() {},{}],"8BHQG":[function() {},{}],"cW7Iq":[function(require,module,exports) {
module.exports = require("8e7499beddc9125d").getBundleURL("kVLro") + require("9aa3b35c9691302d").resolve("FgiQ8");

},{"8e7499beddc9125d":"c7Tr5","9aa3b35c9691302d":"fyJL2"}],"2sClv":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _moment = require("moment");
var _momentDefault = parcelHelpers.interopDefault(_moment);
var _colors = require("../../constants/colors");
var _reactDateRange = require("react-date-range");
var _stylesCss = require("react-date-range/dist/styles.css"); // main style file
var _defaultCss = require("react-date-range/dist/theme/default.css"); // theme css file
var _button = require("../general/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _dateInputField = require("./DateInputField");
var _dateInputFieldDefault = parcelHelpers.interopDefault(_dateInputField);
var _timeIntervalPicker = require("./TimeIntervalPicker");
var _timeIntervalPickerDefault = parcelHelpers.interopDefault(_timeIntervalPicker);
var _toggleIndicator = require("../general/ToggleIndicator");
var _toggleIndicatorDefault = parcelHelpers.interopDefault(_toggleIndicator);
var _breakpoints = require("../../constants/breakpoints");
var _clickOutside = require("../../hooks/general/ClickOutside");
var _clickOutsideDefault = parcelHelpers.interopDefault(_clickOutside);
const DATE_FORMAT = "YYYY-MM-DD hh:mm a";
const DateRangeIntervalPicker = /*#__PURE__*/ (0, _reactDefault.default).memo((props)=>{
    const [intervalType, setIntervalType] = (0, _react1.useState)();
    const [selectedDate, setSelectedDate] = (0, _react1.useState)({
        startDate: (0, _momentDefault.default)().format(DATE_FORMAT),
        endDate: (0, _momentDefault.default)().format(DATE_FORMAT)
    });
    const [temporalDate, setTemporalDate] = (0, _react1.useState)({
        startDate: (0, _momentDefault.default)().format(DATE_FORMAT),
        endDate: (0, _momentDefault.default)().format(DATE_FORMAT)
    });
    const DatePickerRef = (0, _clickOutsideDefault.default)(()=>{
        if (props.onClose) props.onClose();
    });
    (0, _react1.useEffect)(()=>{
        const isCustomDateEntered = intervalType === "custom" || selectedDate.startDate !== temporalDate.startDate || selectedDate.endDate !== temporalDate.endDate;
        if (props && !isCustomDateEntered) {
            setIntervalType(props.interval);
            setSelectedDate({
                startDate: props.startDate,
                endDate: props.endDate
            });
            setTemporalDate({
                startDate: props.startDate,
                endDate: props.endDate
            });
        }
    }, [
        props.interval,
        props.startDate,
        props.endDate
    ]);
    function handleIntervalChange(interval) {
        var startDate = (0, _momentDefault.default)();
        var endDate = (0, _momentDefault.default)();
        // handle the non-moment intervals
        if (interval == "custom") {
            // do nothing...
            startDate = (0, _momentDefault.default)(selectedDate.startDate, DATE_FORMAT);
            endDate = (0, _momentDefault.default)(selectedDate.endDate, DATE_FORMAT);
        } else if (interval == "past 7 days") {
            startDate = (0, _momentDefault.default)().subtract(6, "days"); // note the 6 and 29 is because it is inclusive of the current date by default
            endDate = (0, _momentDefault.default)();
        } else if (interval == "past month") {
            startDate = (0, _momentDefault.default)().subtract(1, "month").startOf("month");
            endDate = (0, _momentDefault.default)().subtract(1, "month").endOf("month");
        } else {
            startDate = startDate.startOf(interval);
            endDate = endDate.endOf(interval);
        }
        setIntervalType(interval);
        setSelectedDate({
            startDate: startDate.format(DATE_FORMAT),
            endDate: endDate.format(DATE_FORMAT)
        });
        setTemporalDate({
            startDate: startDate.format(DATE_FORMAT),
            endDate: endDate.format(DATE_FORMAT)
        });
    }
    function handleDateRangeChange(ranges) {
        var startDate = (0, _momentDefault.default)(ranges.selection?.startDate);
        var endDate = (0, _momentDefault.default)(ranges.selection?.endDate);
        startDate = startDate.startOf("day");
        endDate = endDate.endOf("day");
        setIntervalType("custom");
        setSelectedDate({
            startDate: startDate.format(DATE_FORMAT),
            endDate: endDate.format(DATE_FORMAT)
        });
        setTemporalDate({
            startDate: startDate.format(DATE_FORMAT),
            endDate: endDate.format(DATE_FORMAT)
        });
    }
    function handleConfirmDateChange() {
        props.onChange((0, _momentDefault.default)(selectedDate.startDate, DATE_FORMAT).format(DATE_FORMAT), (0, _momentDefault.default)(selectedDate.endDate, DATE_FORMAT).format(DATE_FORMAT), intervalType);
    }
    function handleTempStartChange(e) {
        const inputDate = (0, _momentDefault.default)(e.target.value, "YYYY-MM-DD");
        if (inputDate.isValid()) setTemporalDate({
            ...temporalDate,
            startDate: inputDate.format(DATE_FORMAT)
        });
    }
    function handleTempEndChange(e) {
        const inputDate = (0, _momentDefault.default)(e.target.value, "YYYY-MM-DD");
        if (inputDate.isValid()) setTemporalDate({
            ...temporalDate,
            endDate: inputDate.format(DATE_FORMAT)
        });
    }
    function weekOfMonth(input = (0, _momentDefault.default)()) {
        const firstDayOfMonth = input.clone().startOf("month");
        const firstDayOfWeek = firstDayOfMonth.clone().startOf("week");
        const offset = firstDayOfMonth.diff(firstDayOfWeek, "days");
        return Math.ceil((input.date() + offset) / 7);
    }
    function getCurrentPeriodLabel() {
        // gets a dynamic label based on the interval and start/end dates
        const startDate = (0, _momentDefault.default)(selectedDate.startDate, DATE_FORMAT);
        if (intervalType == "year") return `${startDate.year()} Selected`;
        if (intervalType == "month") return `${startDate.format("MMMM")} ${startDate.year()} Selected`;
        if (intervalType == "week") return `Week ${weekOfMonth(startDate)} of ${startDate.format("MMMM")} ${startDate.year()} Selected`;
        var daysBetween = (0, _momentDefault.default)(selectedDate.endDate, DATE_FORMAT).diff((0, _momentDefault.default)(selectedDate.startDate, DATE_FORMAT), "days") + 1; // +1 is to be inclusive of the selected date
        return `${daysBetween} Day${daysBetween > 1 ? "s" : ""} Selected`;
    }
    function handleDateBlur(e) {
        var startDate = (0, _momentDefault.default)(temporalDate.startDate, DATE_FORMAT);
        var endDate = (0, _momentDefault.default)(temporalDate.endDate, DATE_FORMAT);
        var diff = endDate.diff(startDate, "hours");
        if (diff == 0) {
            startDate = startDate.startOf("day");
            endDate = endDate.endOf("day");
        }
        if (diff < 0) {
            // if they set the start to earlier, flip them
            setSelectedDate({
                startDate: endDate.format(DATE_FORMAT),
                endDate: startDate.format(DATE_FORMAT)
            });
            setTemporalDate({
                startDate: endDate.format(DATE_FORMAT),
                endDate: startDate.format(DATE_FORMAT)
            });
        } else {
            setSelectedDate({
                startDate: startDate.format(DATE_FORMAT),
                endDate: endDate.format(DATE_FORMAT)
            });
            setTemporalDate({
                startDate: startDate.format(DATE_FORMAT),
                endDate: endDate.format(DATE_FORMAT)
            });
        }
    }
    function handlePreviousPeriod() {
        var startDate = (0, _momentDefault.default)(selectedDate.startDate, DATE_FORMAT);
        var endDate = (0, _momentDefault.default)(selectedDate.endDate, DATE_FORMAT);
        if (intervalType == "year" || intervalType == "month" || intervalType == "week" || intervalType == "day") {
            startDate = startDate.subtract(1, intervalType);
            endDate = endDate.subtract(1, intervalType);
            if (intervalType == "month") endDate = endDate.endOf("month"); // without this, shuffling between months with 30 and 31 days will exlcude the 31st
        } else {
            var hoursBetween = endDate.diff(startDate, "hours");
            startDate = startDate.subtract(hoursBetween > 0 ? hoursBetween : 24, "hours");
            endDate = endDate.subtract(hoursBetween > 0 ? hoursBetween : 24, "hours");
        }
        setSelectedDate({
            startDate: startDate.format(DATE_FORMAT),
            endDate: endDate.format(DATE_FORMAT)
        });
        setTemporalDate({
            startDate: startDate.format(DATE_FORMAT),
            endDate: endDate.format(DATE_FORMAT)
        });
    }
    function handleNextPeriod() {
        var startDate = (0, _momentDefault.default)(selectedDate.startDate, DATE_FORMAT);
        var endDate = (0, _momentDefault.default)(selectedDate.endDate, DATE_FORMAT);
        if (intervalType == "year" || intervalType == "month" || intervalType == "week") {
            startDate = startDate.add(1, intervalType);
            endDate = endDate.add(1, intervalType);
            if (intervalType == "month") endDate = endDate.endOf("month"); // without this, shuffling between months with 30 and 31 days will exlcude the 31st
        } else {
            var daysBetween = endDate.diff(startDate, "days");
            startDate = startDate.add(daysBetween > 0 ? daysBetween : 1, "days");
            endDate = endDate.add(daysBetween > 0 ? daysBetween : 1, "days");
        }
        setSelectedDate({
            startDate: startDate.format(DATE_FORMAT),
            endDate: endDate.format(DATE_FORMAT)
        });
        setTemporalDate({
            startDate: startDate.format(DATE_FORMAT),
            endDate: endDate.format(DATE_FORMAT)
        });
    }
    const openAtTop = props.openAtTop;
    const propsClassName = props.className ?? "";
    const showTimeIntervalPicker = props.showTimeIntervalPicker ?? true;
    const alignLeft = props.alignLeft ?? false;
    const selectionRange = {
        startDate: (0, _momentDefault.default)(selectedDate.startDate, DATE_FORMAT).toDate(),
        endDate: (0, _momentDefault.default)(selectedDate.endDate, DATE_FORMAT).toDate(),
        key: "selection",
        showDateDisplay: false,
        color: (0, _colors.color_variants_ocean_light_2)
    };
    return (0, _react.jsx)("div", {
        className: `${containerStyle(openAtTop, alignLeft)} ${propsClassName}`,
        ref: DatePickerRef
    }, (0, _react.jsx)("div", {
        className: "triangle"
    }), (0, _react.jsx)("div", {
        className: "selection-container"
    }, (0, _react.jsx)("div", {
        className: "date-picker-header"
    }, (0, _react.jsx)("div", {
        className: "field-wrapper ac-analytics-custom-date-input"
    }, (0, _react.jsx)((0, _dateInputFieldDefault.default), {
        value: (0, _momentDefault.default)(temporalDate.startDate, DATE_FORMAT).format("YYYY-MM-DD"),
        onChange: handleTempStartChange,
        onBlur: handleDateBlur
    }), (0, _react.jsx)("div", {
        className: "field-separator"
    }), (0, _react.jsx)((0, _dateInputFieldDefault.default), {
        value: (0, _momentDefault.default)(temporalDate.endDate, DATE_FORMAT).format("YYYY-MM-DD"),
        onChange: handleTempEndChange,
        onBlur: handleDateBlur
    })), (0, _react.jsx)("button", {
        className: "period-toggle-button left",
        onClick: handlePreviousPeriod
    }, (0, _react.jsx)((0, _toggleIndicatorDefault.default), {
        direction: "left"
    })), (0, _react.jsx)("button", {
        className: "period-toggle-button right",
        onClick: handleNextPeriod
    }, (0, _react.jsx)((0, _toggleIndicatorDefault.default), {
        direction: "right"
    })), (0, _react.jsx)("p", {
        className: "period-label ac-analytics-selected-period"
    }, getCurrentPeriodLabel()), (0, _react.jsx)((0, _buttonDefault.default), {
        themes: [
            "primary-small"
        ],
        className: "confirm-button ac-analytics-set-date-button",
        type: "button",
        text: "Update Timeframe",
        onClick: handleConfirmDateChange
    })), (0, _react.jsx)("div", {
        className: "date-interval-container"
    }, showTimeIntervalPicker && (0, _react.jsx)((0, _timeIntervalPickerDefault.default), {
        interval: intervalType,
        onChange: handleIntervalChange
    }), (0, _react.jsx)((0, _reactDateRange.DateRangePicker), {
        ranges: [
            selectionRange
        ],
        onChange: handleDateRangeChange,
        months: 2,
        direction: "horizontal",
        className: "date-picker ac-analytics-calendar-picker"
    }))));
});
exports.default = DateRangeIntervalPicker;
const containerStyle = (openAtTop = false, alignLeft = false)=>/*#__PURE__*/ (0, _css.css)("display:flex;position:absolute;", openAtTop ? "bottom: 100%;" : "margin: 12px 288px;", " ", alignLeft ? "right: 0;" : "", " background:", (0, _colors.color_shades_lighter), ";border:1px solid ", (0, _colors.color_shades_dark), ";border-radius:8px;box-shadow:0px 1px 2px rgba(50, 70, 97, 0.1);z-index:8;.triangle{transform:rotate(45deg);position:absolute;width:12px;height:12px;", openAtTop ? "bottom: -6px;" : "margin-top: -6px; margin-bottom: -6px;", " border-top:solid 1px ", (0, _colors.color_shades_dark), ";border-left:solid 1px ", (0, _colors.color_shades_dark), ";background:", (0, _colors.color_shades_lighter), ";", alignLeft ? "right: 60px;" : "margin-left: 72px;", " border-radius:2px;z-index:5;", (0, _breakpoints.breakpoint_small), "{", openAtTop ? "bottom: -14px;" : "margin-top: -14px;", " margin-left:292px;}}.pick-container{margin:24px 0;border-right:1px solid ", (0, _colors.color_shades_dark), ";}.selection-container{padding:24px 32px;.date-picker-header{display:flex;align-items:center;padding-bottom:24px;border-bottom:1px solid ", (0, _colors.color_shades_dark), ";.confirm-button{margin-top:0;margin-bottom:0;}.field-wrapper{display:flex;align-items:center;padding-right:16px;border-right:1px solid ", (0, _colors.color_shades_dark), ";.field-separator{background:", (0, _colors.color_shades_dark), ";height:1px;width:8px;margin:12px;}}.period-toggle-button{width:32px;height:32px;display:flex;align-items:center;justify-content:center;background:#FFFFFF;border:1px solid ", (0, _colors.color_shades_dark), ";box-sizing:border-box;border-radius:8px;cursor:pointer;&.left{margin-left:16px;}&.right{margin-left:8px;}}.period-label{margin:0 16px;font-size:16px;line-height:24px;}}.date-interval-container{display:flex;}.date-picker{font-size:14px;flex:1;div{background:transparent;}.rdrDay{&.rdrDayPassive{>span>span{color:", (0, _colors.color_text_light), ";}}&:not(.rdrDayPassive){.rdrStartEdge+span,.rdrEndEdge+span{display:none;}.rdrStartEdge~.rdrDayNumber,.rdrEndEdge~.rdrDayNumber{display:flex;>span{color:white;background:", (0, _colors.color_colors_ocean), ";border-radius:16px;width:36px;height:24px;display:flex;align-items:center;justify-content:center;}}}}.rdrDayNumber{>span{color:", (0, _colors.color_text_default), ";}}.rdrCalendarWrapper,.rdrDefinedRangesWrapper{font-size:14px;font-family:Muli;}.rdrDateDisplayWrapper,.rdrInputRanges,.rdrDefinedRangesWrapper{display:none;}}", (0, _breakpoints.breakpoint_small), "{padding:0;margin:0;.date-picker-header{display:flex;align-items:flex-start;padding-bottom:0;border-bottom:none;display:flex;flex-direction:column;.period-toggle-button.left{display:none;}.period-toggle-button.right{display:none;}.confirm-button{margin:8px 0 0 0;align-self:flex-end;}.field-wrapper{padding-right:0;border-right:none;}}.date-interval-container{display:none;}.period-label{display:none;}}}", (0, _breakpoints.breakpoint_small), "{display:flex;flex-direction:column;margin:12px 0 0 8px;padding:8px;}", "");

},{"@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","moment":"2meyw","../../constants/colors":"1p3OR","react-date-range":"9NBpI","react-date-range/dist/styles.css":"1JfNp","react-date-range/dist/theme/default.css":"8BHQG","../general/Button":"6ymxN","./DateInputField":"8Rhf6","./TimeIntervalPicker":"9KECk","../general/ToggleIndicator":"4eej1","../../constants/breakpoints":"2F01A","../../hooks/general/ClickOutside":"iffWk","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9NBpI":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "DateRange", {
    enumerable: true,
    get: function get() {
        return _DateRange.default;
    }
});
Object.defineProperty(exports, "Calendar", {
    enumerable: true,
    get: function get() {
        return _Calendar.default;
    }
});
Object.defineProperty(exports, "DateRangePicker", {
    enumerable: true,
    get: function get() {
        return _DateRangePicker.default;
    }
});
Object.defineProperty(exports, "DefinedRange", {
    enumerable: true,
    get: function get() {
        return _DefinedRange.default;
    }
});
Object.defineProperty(exports, "defaultInputRanges", {
    enumerable: true,
    get: function get() {
        return _defaultRanges.defaultInputRanges;
    }
});
Object.defineProperty(exports, "defaultStaticRanges", {
    enumerable: true,
    get: function get() {
        return _defaultRanges.defaultStaticRanges;
    }
});
Object.defineProperty(exports, "createStaticRanges", {
    enumerable: true,
    get: function get() {
        return _defaultRanges.createStaticRanges;
    }
});
var _DateRange = _interopRequireDefault(require("f9aee6d8d6c6ea28"));
var _Calendar = _interopRequireDefault(require("46d5592bfc12b9c"));
var _DateRangePicker = _interopRequireDefault(require("14bf096f7beacad2"));
var _DefinedRange = _interopRequireDefault(require("f5c6f3a9fe96fc28"));
var _defaultRanges = require("744331dba0772790");
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}

},{"f9aee6d8d6c6ea28":"7w1K9","46d5592bfc12b9c":"7PLf2","14bf096f7beacad2":"kDprO","f5c6f3a9fe96fc28":"cccP3","744331dba0772790":"hNj6e"}],"7w1K9":[function(require,module,exports) {
"use strict";
function _typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") _typeof = function _typeof(obj) {
        return typeof obj;
    };
    else _typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return _typeof(obj);
}
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("c2fc6805b430042"));
var _propTypes = _interopRequireDefault(require("c3190519eef7293"));
var _Calendar = _interopRequireDefault(require("33192c46b935830a"));
var _DayCell = require("eedc4ea599286ed8");
var _utils = require("5eb3c8600be4290d");
var _max = _interopRequireDefault(require("528f4ed60f9383a2"));
var _isWithinInterval = _interopRequireDefault(require("748fe4543f15bbeb"));
var _min = _interopRequireDefault(require("c51915e91d392e37"));
var _addDays = _interopRequireDefault(require("54168a012184cfa6"));
var _differenceInCalendarDays = _interopRequireDefault(require("92303a8554ca93f"));
var _isBefore = _interopRequireDefault(require("65c395616bd7e9c3"));
var _classnames = _interopRequireDefault(require("607a4818d4859e90"));
var _styles = _interopRequireDefault(require("3e64abb7d14b146d"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) ownKeys(Object(source), true).forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return _possibleConstructorReturn(this, result);
    };
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) return call;
    return _assertThisInitialized(self);
}
function _assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var DateRange = /*#__PURE__*/ function(_Component) {
    _inherits(DateRange, _Component);
    var _super = _createSuper(DateRange);
    function DateRange(props, context) {
        var _this;
        _classCallCheck(this, DateRange);
        _this = _super.call(this, props, context);
        _defineProperty(_assertThisInitialized(_this), "calcNewSelection", function(value) {
            var isSingleValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
            var focusedRange = _this.props.focusedRange || _this.state.focusedRange;
            var _this$props = _this.props, ranges = _this$props.ranges, onChange = _this$props.onChange, maxDate = _this$props.maxDate, moveRangeOnFirstSelection = _this$props.moveRangeOnFirstSelection, retainEndDateOnFirstSelection = _this$props.retainEndDateOnFirstSelection, disabledDates = _this$props.disabledDates;
            var focusedRangeIndex = focusedRange[0];
            var selectedRange = ranges[focusedRangeIndex];
            if (!selectedRange || !onChange) return {};
            var startDate = selectedRange.startDate, endDate = selectedRange.endDate;
            var now = new Date();
            var nextFocusRange;
            if (!isSingleValue) {
                startDate = value.startDate;
                endDate = value.endDate;
            } else if (focusedRange[1] === 0) {
                // startDate selection
                var dayOffset = (0, _differenceInCalendarDays.default)(endDate || now, startDate);
                var calculateEndDate = function calculateEndDate() {
                    if (moveRangeOnFirstSelection) return (0, _addDays.default)(value, dayOffset);
                    if (retainEndDateOnFirstSelection) {
                        if (!endDate || (0, _isBefore.default)(value, endDate)) return endDate;
                        return value;
                    }
                    return value || now;
                };
                startDate = value;
                endDate = calculateEndDate();
                if (maxDate) endDate = (0, _min.default)([
                    endDate,
                    maxDate
                ]);
                nextFocusRange = [
                    focusedRange[0],
                    1
                ];
            } else endDate = value;
             // reverse dates if startDate before endDate
            var isStartDateSelected = focusedRange[1] === 0;
            if ((0, _isBefore.default)(endDate, startDate)) {
                isStartDateSelected = !isStartDateSelected;
                var _ref = [
                    endDate,
                    startDate
                ];
                startDate = _ref[0];
                endDate = _ref[1];
            }
            var inValidDatesWithinRange = disabledDates.filter(function(disabledDate) {
                return (0, _isWithinInterval.default)(disabledDate, {
                    start: startDate,
                    end: endDate
                });
            });
            if (inValidDatesWithinRange.length > 0) {
                if (isStartDateSelected) startDate = (0, _addDays.default)((0, _max.default)(inValidDatesWithinRange), 1);
                else endDate = (0, _addDays.default)((0, _min.default)(inValidDatesWithinRange), -1);
            }
            if (!nextFocusRange) {
                var nextFocusRangeIndex = (0, _utils.findNextRangeIndex)(_this.props.ranges, focusedRange[0]);
                nextFocusRange = [
                    nextFocusRangeIndex,
                    0
                ];
            }
            return {
                wasValid: !(inValidDatesWithinRange.length > 0),
                range: {
                    startDate: startDate,
                    endDate: endDate
                },
                nextFocusRange: nextFocusRange
            };
        });
        _defineProperty(_assertThisInitialized(_this), "setSelection", function(value, isSingleValue) {
            var _this$props2 = _this.props, onChange = _this$props2.onChange, ranges = _this$props2.ranges, onRangeFocusChange = _this$props2.onRangeFocusChange;
            var focusedRange = _this.props.focusedRange || _this.state.focusedRange;
            var focusedRangeIndex = focusedRange[0];
            var selectedRange = ranges[focusedRangeIndex];
            if (!selectedRange) return;
            var newSelection = _this.calcNewSelection(value, isSingleValue);
            onChange(_defineProperty({}, selectedRange.key || "range".concat(focusedRangeIndex + 1), _objectSpread(_objectSpread({}, selectedRange), newSelection.range)));
            _this.setState({
                focusedRange: newSelection.nextFocusRange,
                preview: null
            });
            onRangeFocusChange && onRangeFocusChange(newSelection.nextFocusRange);
        });
        _defineProperty(_assertThisInitialized(_this), "handleRangeFocusChange", function(focusedRange) {
            _this.setState({
                focusedRange: focusedRange
            });
            _this.props.onRangeFocusChange && _this.props.onRangeFocusChange(focusedRange);
        });
        _defineProperty(_assertThisInitialized(_this), "updatePreview", function(val) {
            var _ranges$focusedRange$;
            if (!val) {
                _this.setState({
                    preview: null
                });
                return;
            }
            var _this$props3 = _this.props, rangeColors = _this$props3.rangeColors, ranges = _this$props3.ranges;
            var focusedRange = _this.props.focusedRange || _this.state.focusedRange;
            var color = ((_ranges$focusedRange$ = ranges[focusedRange[0]]) === null || _ranges$focusedRange$ === void 0 ? void 0 : _ranges$focusedRange$.color) || rangeColors[focusedRange[0]] || color;
            _this.setState({
                preview: _objectSpread(_objectSpread({}, val.range), {}, {
                    color: color
                })
            });
        });
        _this.state = {
            focusedRange: props.initialFocusedRange || [
                (0, _utils.findNextRangeIndex)(props.ranges),
                0
            ],
            preview: null
        };
        _this.styles = (0, _utils.generateStyles)([
            _styles.default,
            props.classNames
        ]);
        return _this;
    }
    _createClass(DateRange, [
        {
            key: "render",
            value: function render() {
                var _this2 = this;
                return /*#__PURE__*/ _react.default.createElement(_Calendar.default, _extends({
                    focusedRange: this.state.focusedRange,
                    onRangeFocusChange: this.handleRangeFocusChange,
                    preview: this.state.preview,
                    onPreviewChange: function onPreviewChange(value) {
                        _this2.updatePreview(value ? _this2.calcNewSelection(value) : null);
                    }
                }, this.props, {
                    displayMode: "dateRange",
                    className: (0, _classnames.default)(this.styles.dateRangeWrapper, this.props.className),
                    onChange: this.setSelection,
                    updateRange: function updateRange(val) {
                        return _this2.setSelection(val, false);
                    },
                    ref: function ref(target) {
                        _this2.calendar = target;
                    }
                }));
            }
        }
    ]);
    return DateRange;
}(_react.Component);
DateRange.defaultProps = {
    classNames: {},
    ranges: [],
    moveRangeOnFirstSelection: false,
    retainEndDateOnFirstSelection: false,
    rangeColors: [
        "#3d91ff",
        "#3ecf8e",
        "#fed14c"
    ],
    disabledDates: []
};
DateRange.propTypes = _objectSpread(_objectSpread({}, _Calendar.default.propTypes), {}, {
    onChange: _propTypes.default.func,
    onRangeFocusChange: _propTypes.default.func,
    className: _propTypes.default.string,
    ranges: _propTypes.default.arrayOf(_DayCell.rangeShape),
    moveRangeOnFirstSelection: _propTypes.default.bool,
    retainEndDateOnFirstSelection: _propTypes.default.bool
});
var _default = DateRange;
exports.default = _default;

},{"c2fc6805b430042":"6uln9","c3190519eef7293":"6FKs7","33192c46b935830a":"7PLf2","eedc4ea599286ed8":"8U3Bs","5eb3c8600be4290d":"6TTND","528f4ed60f9383a2":"dmOVr","748fe4543f15bbeb":"fYupW","c51915e91d392e37":"2P2GJ","54168a012184cfa6":"gh2CN","92303a8554ca93f":"kfTvM","65c395616bd7e9c3":"d6hvx","607a4818d4859e90":"hVGzI","3e64abb7d14b146d":"cP3WV"}],"7PLf2":[function(require,module,exports) {
"use strict";
function _typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") _typeof = function _typeof(obj) {
        return typeof obj;
    };
    else _typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return _typeof(obj);
}
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("f1c2bac901ddd6fe"));
var _propTypes = _interopRequireDefault(require("33c616ffe6f08019"));
var _DayCell = require("703d708f01b6b038");
var _Month = _interopRequireDefault(require("7c129f05972fce66"));
var _DateInput = _interopRequireDefault(require("bd884b8232b20dde"));
var _utils = require("6b149be3610d910e");
var _classnames3 = _interopRequireDefault(require("f9237481e5027fa6"));
var _reactList = _interopRequireDefault(require("cc30d1ffdc3f1f89"));
var _shallowEqual = require("6053c0502619dd38");
var _max = _interopRequireDefault(require("ce0f9d81c8f47ce1"));
var _min = _interopRequireDefault(require("656d92c570254200"));
var _differenceInDays = _interopRequireDefault(require("8bb6f3e601350005"));
var _isSameMonth = _interopRequireDefault(require("42a18e462bf5158"));
var _addDays = _interopRequireDefault(require("588941a695e937bd"));
var _endOfMonth = _interopRequireDefault(require("4e5c7df9a0fb4c9c"));
var _startOfMonth = _interopRequireDefault(require("4ab0ddd36cbce75e"));
var _differenceInCalendarMonths = _interopRequireDefault(require("39a5dc02e8a74aba"));
var _setMonth2 = _interopRequireDefault(require("802cc6d9d409af71"));
var _setYear2 = _interopRequireDefault(require("cf7d3b97bb7ad6f5"));
var _addYears = _interopRequireDefault(require("78c5ac9876555455"));
var _isSameDay = _interopRequireDefault(require("fd4c9f62f6b62084"));
var _endOfWeek = _interopRequireDefault(require("d030c991a382edaf"));
var _startOfWeek = _interopRequireDefault(require("11d4da545873ddf4"));
var _eachDayOfInterval = _interopRequireDefault(require("e8e1378c58f99ee5"));
var _format = _interopRequireDefault(require("31639c10cafd7261"));
var _subMonths = _interopRequireDefault(require("24127d40cb4da451"));
var _addMonths = _interopRequireDefault(require("f9d849984db8fd99"));
var _enUS = _interopRequireDefault(require("a41ac387b2779207"));
var _styles = _interopRequireDefault(require("2ec0ae236f296345"));
var _accessibility = require("969c73440a54ba38");
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) ownKeys(Object(source), true).forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return _possibleConstructorReturn(this, result);
    };
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) return call;
    return _assertThisInitialized(self);
}
function _assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var Calendar = /*#__PURE__*/ function(_PureComponent) {
    _inherits(Calendar, _PureComponent);
    var _super = _createSuper(Calendar);
    function Calendar(_props, context) {
        var _this;
        _classCallCheck(this, Calendar);
        _this = _super.call(this, _props, context);
        _defineProperty(_assertThisInitialized(_this), "focusToDate", function(date) {
            var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _this.props;
            var preventUnnecessary = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
            if (!props.scroll.enabled) {
                if (preventUnnecessary && props.preventSnapRefocus) {
                    var focusedDateDiff = (0, _differenceInCalendarMonths.default)(date, _this.state.focusedDate);
                    var isAllowedForward = props.calendarFocus === "forwards" && focusedDateDiff >= 0;
                    var isAllowedBackward = props.calendarFocus === "backwards" && focusedDateDiff <= 0;
                    if ((isAllowedForward || isAllowedBackward) && Math.abs(focusedDateDiff) < props.months) return;
                }
                _this.setState({
                    focusedDate: date
                });
                return;
            }
            var targetMonthIndex = (0, _differenceInCalendarMonths.default)(date, props.minDate, _this.dateOptions);
            var visibleMonths = _this.list.getVisibleRange();
            if (preventUnnecessary && visibleMonths.includes(targetMonthIndex)) return;
            _this.isFirstRender = true;
            _this.list.scrollTo(targetMonthIndex);
            _this.setState({
                focusedDate: date
            });
        });
        _defineProperty(_assertThisInitialized(_this), "updateShownDate", function() {
            var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this.props;
            var newProps = props.scroll.enabled ? _objectSpread(_objectSpread({}, props), {}, {
                months: _this.list.getVisibleRange().length
            }) : props;
            var newFocus = (0, _utils.calcFocusDate)(_this.state.focusedDate, newProps);
            _this.focusToDate(newFocus, newProps);
        });
        _defineProperty(_assertThisInitialized(_this), "updatePreview", function(val) {
            if (!val) {
                _this.setState({
                    preview: null
                });
                return;
            }
            var preview = {
                startDate: val,
                endDate: val,
                color: _this.props.color
            };
            _this.setState({
                preview: preview
            });
        });
        _defineProperty(_assertThisInitialized(_this), "changeShownDate", function(value) {
            var mode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "set";
            var focusedDate = _this.state.focusedDate;
            var _this$props = _this.props, onShownDateChange = _this$props.onShownDateChange, minDate = _this$props.minDate, maxDate = _this$props.maxDate;
            var modeMapper = {
                monthOffset: function monthOffset() {
                    return (0, _addMonths.default)(focusedDate, value);
                },
                setMonth: function(_setMonth) {
                    function setMonth() {
                        return _setMonth.apply(this, arguments);
                    }
                    setMonth.toString = function() {
                        return _setMonth.toString();
                    };
                    return setMonth;
                }(function() {
                    return (0, _setMonth2.default)(focusedDate, value);
                }),
                setYear: function(_setYear) {
                    function setYear() {
                        return _setYear.apply(this, arguments);
                    }
                    setYear.toString = function() {
                        return _setYear.toString();
                    };
                    return setYear;
                }(function() {
                    return (0, _setYear2.default)(focusedDate, value);
                }),
                set: function set() {
                    return value;
                }
            };
            var newDate = (0, _min.default)([
                (0, _max.default)([
                    modeMapper[mode](),
                    minDate
                ]),
                maxDate
            ]);
            _this.focusToDate(newDate, _this.props, false);
            onShownDateChange && onShownDateChange(newDate);
        });
        _defineProperty(_assertThisInitialized(_this), "handleRangeFocusChange", function(rangesIndex, rangeItemIndex) {
            _this.props.onRangeFocusChange && _this.props.onRangeFocusChange([
                rangesIndex,
                rangeItemIndex
            ]);
        });
        _defineProperty(_assertThisInitialized(_this), "handleScroll", function() {
            var _this$props2 = _this.props, onShownDateChange = _this$props2.onShownDateChange, minDate = _this$props2.minDate;
            var focusedDate = _this.state.focusedDate;
            var _assertThisInitialize = _assertThisInitialized(_this), isFirstRender = _assertThisInitialize.isFirstRender;
            var visibleMonths = _this.list.getVisibleRange(); // prevent scroll jump with wrong visible value
            if (visibleMonths[0] === undefined) return;
            var visibleMonth = (0, _addMonths.default)(minDate, visibleMonths[0] || 0);
            var isFocusedToDifferent = !(0, _isSameMonth.default)(visibleMonth, focusedDate);
            if (isFocusedToDifferent && !isFirstRender) {
                _this.setState({
                    focusedDate: visibleMonth
                });
                onShownDateChange && onShownDateChange(visibleMonth);
            }
            _this.isFirstRender = false;
        });
        _defineProperty(_assertThisInitialized(_this), "renderMonthAndYear", function(focusedDate, changeShownDate, props) {
            var showMonthArrow = props.showMonthArrow, minDate = props.minDate, maxDate = props.maxDate, showMonthAndYearPickers = props.showMonthAndYearPickers, ariaLabels = props.ariaLabels;
            var upperYearLimit = (maxDate || Calendar.defaultProps.maxDate).getFullYear();
            var lowerYearLimit = (minDate || Calendar.defaultProps.minDate).getFullYear();
            var styles = _this.styles;
            return /*#__PURE__*/ _react.default.createElement("div", {
                onMouseUp: function onMouseUp(e) {
                    return e.stopPropagation();
                },
                className: styles.monthAndYearWrapper
            }, showMonthArrow ? /*#__PURE__*/ _react.default.createElement("button", {
                type: "button",
                className: (0, _classnames3.default)(styles.nextPrevButton, styles.prevButton),
                onClick: function onClick() {
                    return changeShownDate(-1, "monthOffset");
                },
                "aria-label": ariaLabels.prevButton
            }, /*#__PURE__*/ _react.default.createElement("i", null)) : null, showMonthAndYearPickers ? /*#__PURE__*/ _react.default.createElement("span", {
                className: styles.monthAndYearPickers
            }, /*#__PURE__*/ _react.default.createElement("span", {
                className: styles.monthPicker
            }, /*#__PURE__*/ _react.default.createElement("select", {
                value: focusedDate.getMonth(),
                onChange: function onChange(e) {
                    return changeShownDate(e.target.value, "setMonth");
                },
                "aria-label": ariaLabels.monthPicker
            }, _this.state.monthNames.map(function(monthName, i) {
                return /*#__PURE__*/ _react.default.createElement("option", {
                    key: i,
                    value: i
                }, monthName);
            }))), /*#__PURE__*/ _react.default.createElement("span", {
                className: styles.monthAndYearDivider
            }), /*#__PURE__*/ _react.default.createElement("span", {
                className: styles.yearPicker
            }, /*#__PURE__*/ _react.default.createElement("select", {
                value: focusedDate.getFullYear(),
                onChange: function onChange(e) {
                    return changeShownDate(e.target.value, "setYear");
                },
                "aria-label": ariaLabels.yearPicker
            }, new Array(upperYearLimit - lowerYearLimit + 1).fill(upperYearLimit).map(function(val, i) {
                var year = val - i;
                return /*#__PURE__*/ _react.default.createElement("option", {
                    key: year,
                    value: year
                }, year);
            })))) : /*#__PURE__*/ _react.default.createElement("span", {
                className: styles.monthAndYearPickers
            }, _this.state.monthNames[focusedDate.getMonth()], " ", focusedDate.getFullYear()), showMonthArrow ? /*#__PURE__*/ _react.default.createElement("button", {
                type: "button",
                className: (0, _classnames3.default)(styles.nextPrevButton, styles.nextButton),
                onClick: function onClick() {
                    return changeShownDate(1, "monthOffset");
                },
                "aria-label": ariaLabels.nextButton
            }, /*#__PURE__*/ _react.default.createElement("i", null)) : null);
        });
        _defineProperty(_assertThisInitialized(_this), "renderDateDisplay", function() {
            var _this$props3 = _this.props, focusedRange = _this$props3.focusedRange, color = _this$props3.color, ranges = _this$props3.ranges, rangeColors = _this$props3.rangeColors, dateDisplayFormat = _this$props3.dateDisplayFormat, editableDateInputs = _this$props3.editableDateInputs, startDatePlaceholder = _this$props3.startDatePlaceholder, endDatePlaceholder = _this$props3.endDatePlaceholder, ariaLabels = _this$props3.ariaLabels;
            var defaultColor = rangeColors[focusedRange[0]] || color;
            var styles = _this.styles;
            return /*#__PURE__*/ _react.default.createElement("div", {
                className: styles.dateDisplayWrapper
            }, ranges.map(function(range, i) {
                if (range.showDateDisplay === false || range.disabled && !range.showDateDisplay) return null;
                return /*#__PURE__*/ _react.default.createElement("div", {
                    className: styles.dateDisplay,
                    key: i,
                    style: {
                        color: range.color || defaultColor
                    }
                }, /*#__PURE__*/ _react.default.createElement(_DateInput.default, {
                    className: (0, _classnames3.default)(styles.dateDisplayItem, _defineProperty({}, styles.dateDisplayItemActive, focusedRange[0] === i && focusedRange[1] === 0)),
                    readOnly: !editableDateInputs,
                    disabled: range.disabled,
                    value: range.startDate,
                    placeholder: startDatePlaceholder,
                    dateOptions: _this.dateOptions,
                    dateDisplayFormat: dateDisplayFormat,
                    ariaLabel: ariaLabels.dateInput && ariaLabels.dateInput[range.key] && ariaLabels.dateInput[range.key].startDate,
                    onChange: _this.onDragSelectionEnd,
                    onFocus: function onFocus() {
                        return _this.handleRangeFocusChange(i, 0);
                    }
                }), /*#__PURE__*/ _react.default.createElement(_DateInput.default, {
                    className: (0, _classnames3.default)(styles.dateDisplayItem, _defineProperty({}, styles.dateDisplayItemActive, focusedRange[0] === i && focusedRange[1] === 1)),
                    readOnly: !editableDateInputs,
                    disabled: range.disabled,
                    value: range.endDate,
                    placeholder: endDatePlaceholder,
                    dateOptions: _this.dateOptions,
                    dateDisplayFormat: dateDisplayFormat,
                    ariaLabel: ariaLabels.dateInput && ariaLabels.dateInput[range.key] && ariaLabels.dateInput[range.key].endDate,
                    onChange: _this.onDragSelectionEnd,
                    onFocus: function onFocus() {
                        return _this.handleRangeFocusChange(i, 1);
                    }
                }));
            }));
        });
        _defineProperty(_assertThisInitialized(_this), "onDragSelectionStart", function(date) {
            var _this$props4 = _this.props, onChange = _this$props4.onChange, dragSelectionEnabled = _this$props4.dragSelectionEnabled;
            if (dragSelectionEnabled) _this.setState({
                drag: {
                    status: true,
                    range: {
                        startDate: date,
                        endDate: date
                    },
                    disablePreview: true
                }
            });
            else onChange && onChange(date);
        });
        _defineProperty(_assertThisInitialized(_this), "onDragSelectionEnd", function(date) {
            var _this$props5 = _this.props, updateRange = _this$props5.updateRange, displayMode = _this$props5.displayMode, onChange = _this$props5.onChange, dragSelectionEnabled = _this$props5.dragSelectionEnabled;
            if (!dragSelectionEnabled) return;
            if (displayMode === "date" || !_this.state.drag.status) {
                onChange && onChange(date);
                return;
            }
            var newRange = {
                startDate: _this.state.drag.range.startDate,
                endDate: date
            };
            if (displayMode !== "dateRange" || (0, _isSameDay.default)(newRange.startDate, date)) _this.setState({
                drag: {
                    status: false,
                    range: {}
                }
            }, function() {
                return onChange && onChange(date);
            });
            else _this.setState({
                drag: {
                    status: false,
                    range: {}
                }
            }, function() {
                updateRange && updateRange(newRange);
            });
        });
        _defineProperty(_assertThisInitialized(_this), "onDragSelectionMove", function(date) {
            var drag = _this.state.drag;
            if (!drag.status || !_this.props.dragSelectionEnabled) return;
            _this.setState({
                drag: {
                    status: drag.status,
                    range: {
                        startDate: drag.range.startDate,
                        endDate: date
                    },
                    disablePreview: true
                }
            });
        });
        _defineProperty(_assertThisInitialized(_this), "estimateMonthSize", function(index, cache) {
            var _this$props6 = _this.props, direction = _this$props6.direction, minDate = _this$props6.minDate;
            var scrollArea = _this.state.scrollArea;
            if (cache) {
                _this.listSizeCache = cache;
                if (cache[index]) return cache[index];
            }
            if (direction === "horizontal") return scrollArea.monthWidth;
            var monthStep = (0, _addMonths.default)(minDate, index);
            var _getMonthDisplayRange = (0, _utils.getMonthDisplayRange)(monthStep, _this.dateOptions), start = _getMonthDisplayRange.start, end = _getMonthDisplayRange.end;
            var isLongMonth = (0, _differenceInDays.default)(end, start, _this.dateOptions) + 1 > 35;
            return isLongMonth ? scrollArea.longMonthHeight : scrollArea.monthHeight;
        });
        _this.dateOptions = {
            locale: _props.locale
        };
        if (_props.weekStartsOn !== undefined) _this.dateOptions.weekStartsOn = _props.weekStartsOn;
        _this.styles = (0, _utils.generateStyles)([
            _styles.default,
            _props.classNames
        ]);
        _this.listSizeCache = {};
        _this.isFirstRender = true;
        _this.state = {
            monthNames: _this.getMonthNames(),
            focusedDate: (0, _utils.calcFocusDate)(null, _props),
            drag: {
                status: false,
                range: {
                    startDate: null,
                    endDate: null
                },
                disablePreview: false
            },
            scrollArea: _this.calcScrollArea(_props)
        };
        return _this;
    }
    _createClass(Calendar, [
        {
            key: "getMonthNames",
            value: function getMonthNames() {
                var _this2 = this;
                return _toConsumableArray(Array(12).keys()).map(function(i) {
                    return _this2.props.locale.localize.month(i);
                });
            }
        },
        {
            key: "calcScrollArea",
            value: function calcScrollArea(props) {
                var direction = props.direction, months = props.months, scroll = props.scroll;
                if (!scroll.enabled) return {
                    enabled: false
                };
                var longMonthHeight = scroll.longMonthHeight || scroll.monthHeight;
                if (direction === "vertical") return {
                    enabled: true,
                    monthHeight: scroll.monthHeight || 220,
                    longMonthHeight: longMonthHeight || 260,
                    calendarWidth: "auto",
                    calendarHeight: (scroll.calendarHeight || longMonthHeight || 240) * months
                };
                return {
                    enabled: true,
                    monthWidth: scroll.monthWidth || 332,
                    calendarWidth: (scroll.calendarWidth || scroll.monthWidth || 332) * months,
                    monthHeight: longMonthHeight || 300,
                    calendarHeight: longMonthHeight || 300
                };
            }
        },
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                var _this3 = this;
                if (this.props.scroll.enabled) // prevent react-list's initial render focus problem
                setTimeout(function() {
                    return _this3.focusToDate(_this3.state.focusedDate);
                });
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps) {
                var propMapper = {
                    dateRange: "ranges",
                    date: "date"
                };
                var targetProp = propMapper[this.props.displayMode];
                if (this.props[targetProp] !== prevProps[targetProp]) this.updateShownDate(this.props);
                if (prevProps.locale !== this.props.locale || prevProps.weekStartsOn !== this.props.weekStartsOn) {
                    this.dateOptions = {
                        locale: this.props.locale
                    };
                    if (this.props.weekStartsOn !== undefined) this.dateOptions.weekStartsOn = this.props.weekStartsOn;
                    this.setState({
                        monthNames: this.getMonthNames()
                    });
                }
                if (!(0, _shallowEqual.shallowEqualObjects)(prevProps.scroll, this.props.scroll)) this.setState({
                    scrollArea: this.calcScrollArea(this.props)
                });
            }
        },
        {
            key: "renderWeekdays",
            value: function renderWeekdays() {
                var _this4 = this;
                var now = new Date();
                return /*#__PURE__*/ _react.default.createElement("div", {
                    className: this.styles.weekDays
                }, (0, _eachDayOfInterval.default)({
                    start: (0, _startOfWeek.default)(now, this.dateOptions),
                    end: (0, _endOfWeek.default)(now, this.dateOptions)
                }).map(function(day, i) {
                    return /*#__PURE__*/ _react.default.createElement("span", {
                        className: _this4.styles.weekDay,
                        key: i
                    }, (0, _format.default)(day, _this4.props.weekdayDisplayFormat, _this4.dateOptions));
                }));
            }
        },
        {
            key: "render",
            value: function render() {
                var _this5 = this;
                var _this$props7 = this.props, showDateDisplay = _this$props7.showDateDisplay, onPreviewChange = _this$props7.onPreviewChange, scroll = _this$props7.scroll, direction = _this$props7.direction, disabledDates = _this$props7.disabledDates, disabledDay = _this$props7.disabledDay, maxDate = _this$props7.maxDate, minDate = _this$props7.minDate, rangeColors = _this$props7.rangeColors, color = _this$props7.color, navigatorRenderer = _this$props7.navigatorRenderer, className = _this$props7.className, preview = _this$props7.preview;
                var _this$state = this.state, scrollArea = _this$state.scrollArea, focusedDate = _this$state.focusedDate;
                var isVertical = direction === "vertical";
                var monthAndYearRenderer = navigatorRenderer || this.renderMonthAndYear;
                var ranges = this.props.ranges.map(function(range, i) {
                    return _objectSpread(_objectSpread({}, range), {}, {
                        color: range.color || rangeColors[i] || color
                    });
                });
                return /*#__PURE__*/ _react.default.createElement("div", {
                    className: (0, _classnames3.default)(this.styles.calendarWrapper, className),
                    onMouseUp: function onMouseUp() {
                        return _this5.setState({
                            drag: {
                                status: false,
                                range: {}
                            }
                        });
                    },
                    onMouseLeave: function onMouseLeave() {
                        _this5.setState({
                            drag: {
                                status: false,
                                range: {}
                            }
                        });
                    }
                }, showDateDisplay && this.renderDateDisplay(), monthAndYearRenderer(focusedDate, this.changeShownDate, this.props), scroll.enabled ? /*#__PURE__*/ _react.default.createElement("div", null, isVertical && this.renderWeekdays(this.dateOptions), /*#__PURE__*/ _react.default.createElement("div", {
                    className: (0, _classnames3.default)(this.styles.infiniteMonths, isVertical ? this.styles.monthsVertical : this.styles.monthsHorizontal),
                    onMouseLeave: function onMouseLeave() {
                        return onPreviewChange && onPreviewChange();
                    },
                    style: {
                        width: scrollArea.calendarWidth + 11,
                        height: scrollArea.calendarHeight + 11
                    },
                    onScroll: this.handleScroll
                }, /*#__PURE__*/ _react.default.createElement(_reactList.default, {
                    length: (0, _differenceInCalendarMonths.default)((0, _endOfMonth.default)(maxDate), (0, _addDays.default)((0, _startOfMonth.default)(minDate), -1), this.dateOptions),
                    treshold: 500,
                    type: "variable",
                    ref: function ref(target) {
                        return _this5.list = target;
                    },
                    itemSizeEstimator: this.estimateMonthSize,
                    axis: isVertical ? "y" : "x",
                    itemRenderer: function itemRenderer(index, key) {
                        var monthStep = (0, _addMonths.default)(minDate, index);
                        return /*#__PURE__*/ _react.default.createElement(_Month.default, _extends({}, _this5.props, {
                            onPreviewChange: onPreviewChange || _this5.updatePreview,
                            preview: preview || _this5.state.preview,
                            ranges: ranges,
                            key: key,
                            drag: _this5.state.drag,
                            dateOptions: _this5.dateOptions,
                            disabledDates: disabledDates,
                            disabledDay: disabledDay,
                            month: monthStep,
                            onDragSelectionStart: _this5.onDragSelectionStart,
                            onDragSelectionEnd: _this5.onDragSelectionEnd,
                            onDragSelectionMove: _this5.onDragSelectionMove,
                            onMouseLeave: function onMouseLeave() {
                                return onPreviewChange && onPreviewChange();
                            },
                            styles: _this5.styles,
                            style: isVertical ? {
                                height: _this5.estimateMonthSize(index)
                            } : {
                                height: scrollArea.monthHeight,
                                width: _this5.estimateMonthSize(index)
                            },
                            showMonthName: true,
                            showWeekDays: !isVertical
                        }));
                    }
                }))) : /*#__PURE__*/ _react.default.createElement("div", {
                    className: (0, _classnames3.default)(this.styles.months, isVertical ? this.styles.monthsVertical : this.styles.monthsHorizontal)
                }, new Array(this.props.months).fill(null).map(function(_, i) {
                    var monthStep = (0, _addMonths.default)(_this5.state.focusedDate, i);
                    if (_this5.props.calendarFocus === "backwards") monthStep = (0, _subMonths.default)(_this5.state.focusedDate, _this5.props.months - 1 - i);
                    return /*#__PURE__*/ _react.default.createElement(_Month.default, _extends({}, _this5.props, {
                        onPreviewChange: onPreviewChange || _this5.updatePreview,
                        preview: preview || _this5.state.preview,
                        ranges: ranges,
                        key: i,
                        drag: _this5.state.drag,
                        dateOptions: _this5.dateOptions,
                        disabledDates: disabledDates,
                        disabledDay: disabledDay,
                        month: monthStep,
                        onDragSelectionStart: _this5.onDragSelectionStart,
                        onDragSelectionEnd: _this5.onDragSelectionEnd,
                        onDragSelectionMove: _this5.onDragSelectionMove,
                        onMouseLeave: function onMouseLeave() {
                            return onPreviewChange && onPreviewChange();
                        },
                        styles: _this5.styles,
                        showWeekDays: !isVertical || i === 0,
                        showMonthName: !isVertical || i > 0
                    }));
                })));
            }
        }
    ]);
    return Calendar;
}(_react.PureComponent);
Calendar.defaultProps = {
    showMonthArrow: true,
    showMonthAndYearPickers: true,
    disabledDates: [],
    disabledDay: function disabledDay() {},
    classNames: {},
    locale: _enUS.default,
    ranges: [],
    focusedRange: [
        0,
        0
    ],
    dateDisplayFormat: "MMM d, yyyy",
    monthDisplayFormat: "MMM yyyy",
    weekdayDisplayFormat: "E",
    dayDisplayFormat: "d",
    showDateDisplay: true,
    showPreview: true,
    displayMode: "date",
    months: 1,
    color: "#3d91ff",
    scroll: {
        enabled: false
    },
    direction: "vertical",
    maxDate: (0, _addYears.default)(new Date(), 20),
    minDate: (0, _addYears.default)(new Date(), -100),
    rangeColors: [
        "#3d91ff",
        "#3ecf8e",
        "#fed14c"
    ],
    startDatePlaceholder: "Early",
    endDatePlaceholder: "Continuous",
    editableDateInputs: false,
    dragSelectionEnabled: true,
    fixedHeight: false,
    calendarFocus: "forwards",
    preventSnapRefocus: false,
    ariaLabels: {}
};
Calendar.propTypes = {
    showMonthArrow: _propTypes.default.bool,
    showMonthAndYearPickers: _propTypes.default.bool,
    disabledDates: _propTypes.default.array,
    disabledDay: _propTypes.default.func,
    minDate: _propTypes.default.object,
    maxDate: _propTypes.default.object,
    date: _propTypes.default.object,
    onChange: _propTypes.default.func,
    onPreviewChange: _propTypes.default.func,
    onRangeFocusChange: _propTypes.default.func,
    classNames: _propTypes.default.object,
    locale: _propTypes.default.object,
    shownDate: _propTypes.default.object,
    onShownDateChange: _propTypes.default.func,
    ranges: _propTypes.default.arrayOf(_DayCell.rangeShape),
    preview: _propTypes.default.shape({
        startDate: _propTypes.default.object,
        endDate: _propTypes.default.object,
        color: _propTypes.default.string
    }),
    dateDisplayFormat: _propTypes.default.string,
    monthDisplayFormat: _propTypes.default.string,
    weekdayDisplayFormat: _propTypes.default.string,
    weekStartsOn: _propTypes.default.number,
    dayDisplayFormat: _propTypes.default.string,
    focusedRange: _propTypes.default.arrayOf(_propTypes.default.number),
    initialFocusedRange: _propTypes.default.arrayOf(_propTypes.default.number),
    months: _propTypes.default.number,
    className: _propTypes.default.string,
    showDateDisplay: _propTypes.default.bool,
    showPreview: _propTypes.default.bool,
    displayMode: _propTypes.default.oneOf([
        "dateRange",
        "date"
    ]),
    color: _propTypes.default.string,
    updateRange: _propTypes.default.func,
    scroll: _propTypes.default.shape({
        enabled: _propTypes.default.bool,
        monthHeight: _propTypes.default.number,
        longMonthHeight: _propTypes.default.number,
        monthWidth: _propTypes.default.number,
        calendarWidth: _propTypes.default.number,
        calendarHeight: _propTypes.default.number
    }),
    direction: _propTypes.default.oneOf([
        "vertical",
        "horizontal"
    ]),
    startDatePlaceholder: _propTypes.default.string,
    endDatePlaceholder: _propTypes.default.string,
    navigatorRenderer: _propTypes.default.func,
    rangeColors: _propTypes.default.arrayOf(_propTypes.default.string),
    editableDateInputs: _propTypes.default.bool,
    dragSelectionEnabled: _propTypes.default.bool,
    fixedHeight: _propTypes.default.bool,
    calendarFocus: _propTypes.default.string,
    preventSnapRefocus: _propTypes.default.bool,
    ariaLabels: _accessibility.ariaLabelsShape
};
var _default = Calendar;
exports.default = _default;

},{"f1c2bac901ddd6fe":"6uln9","33c616ffe6f08019":"6FKs7","703d708f01b6b038":"8U3Bs","7c129f05972fce66":"6lKBe","bd884b8232b20dde":"cMacC","6b149be3610d910e":"6TTND","f9237481e5027fa6":"hVGzI","cc30d1ffdc3f1f89":"2L0r2","6053c0502619dd38":"71Zzs","ce0f9d81c8f47ce1":"dmOVr","656d92c570254200":"2P2GJ","8bb6f3e601350005":"9DPCg","42a18e462bf5158":"qPsB2","588941a695e937bd":"gh2CN","4e5c7df9a0fb4c9c":"fMDiz","4ab0ddd36cbce75e":"j9jcE","39a5dc02e8a74aba":"hXq92","802cc6d9d409af71":"8smkx","cf7d3b97bb7ad6f5":"jxmoh","78c5ac9876555455":"2VLwd","fd4c9f62f6b62084":"zixuD","d030c991a382edaf":"1dSZs","11d4da545873ddf4":"5iVAO","e8e1378c58f99ee5":"iGmwl","31639c10cafd7261":"3AQSq","24127d40cb4da451":"afiGD","f9d849984db8fd99":"2h5VH","a41ac387b2779207":"dxPPF","2ec0ae236f296345":"cP3WV","969c73440a54ba38":"cTcxr"}],"8U3Bs":[function(require,module,exports) {
"use strict";
function _typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") _typeof = function _typeof(obj) {
        return typeof obj;
    };
    else _typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return _typeof(obj);
}
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = exports.rangeShape = void 0;
var _react = _interopRequireWildcard(require("21befc2105e4624b"));
var _propTypes = _interopRequireDefault(require("875ca86b6a547a16"));
var _classnames4 = _interopRequireDefault(require("23286e331f68c16a"));
var _endOfDay = _interopRequireDefault(require("ad8d62c47f265e95"));
var _isBefore = _interopRequireDefault(require("1e244c1aeb7782f8"));
var _isAfter = _interopRequireDefault(require("dc17a5dadf8815b1"));
var _isSameDay = _interopRequireDefault(require("523c198b455be3bd"));
var _format = _interopRequireDefault(require("376560d82a27d539"));
var _startOfDay = _interopRequireDefault(require("a16dbe9e1a924836"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) ownKeys(Object(source), true).forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return _possibleConstructorReturn(this, result);
    };
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) return call;
    return _assertThisInitialized(self);
}
function _assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var DayCell = /*#__PURE__*/ function(_Component) {
    _inherits(DayCell, _Component);
    var _super = _createSuper(DayCell);
    function DayCell(props, context) {
        var _this;
        _classCallCheck(this, DayCell);
        _this = _super.call(this, props, context);
        _defineProperty(_assertThisInitialized(_this), "handleKeyEvent", function(event) {
            var _this$props = _this.props, day = _this$props.day, onMouseDown = _this$props.onMouseDown, onMouseUp = _this$props.onMouseUp;
            if ([
                13,
                32
            ].includes(event.keyCode)) {
                if (event.type === "keydown") onMouseDown(day);
                else onMouseUp(day);
            }
        });
        _defineProperty(_assertThisInitialized(_this), "handleMouseEvent", function(event) {
            var _this$props2 = _this.props, day = _this$props2.day, disabled = _this$props2.disabled, onPreviewChange = _this$props2.onPreviewChange, onMouseEnter = _this$props2.onMouseEnter, onMouseDown = _this$props2.onMouseDown, onMouseUp = _this$props2.onMouseUp;
            var stateChanges = {};
            if (disabled) {
                onPreviewChange();
                return;
            }
            switch(event.type){
                case "mouseenter":
                    onMouseEnter(day);
                    onPreviewChange(day);
                    stateChanges.hover = true;
                    break;
                case "blur":
                case "mouseleave":
                    stateChanges.hover = false;
                    break;
                case "mousedown":
                    stateChanges.active = true;
                    onMouseDown(day);
                    break;
                case "mouseup":
                    event.stopPropagation();
                    stateChanges.active = false;
                    onMouseUp(day);
                    break;
                case "focus":
                    onPreviewChange(day);
                    break;
            }
            if (Object.keys(stateChanges).length) _this.setState(stateChanges);
        });
        _defineProperty(_assertThisInitialized(_this), "getClassNames", function() {
            var _classnames;
            var _this$props3 = _this.props, isPassive = _this$props3.isPassive, isToday = _this$props3.isToday, isWeekend = _this$props3.isWeekend, isStartOfWeek = _this$props3.isStartOfWeek, isEndOfWeek = _this$props3.isEndOfWeek, isStartOfMonth = _this$props3.isStartOfMonth, isEndOfMonth = _this$props3.isEndOfMonth, disabled = _this$props3.disabled, styles = _this$props3.styles;
            return (0, _classnames4.default)(styles.day, (_classnames = {}, _defineProperty(_classnames, styles.dayPassive, isPassive), _defineProperty(_classnames, styles.dayDisabled, disabled), _defineProperty(_classnames, styles.dayToday, isToday), _defineProperty(_classnames, styles.dayWeekend, isWeekend), _defineProperty(_classnames, styles.dayStartOfWeek, isStartOfWeek), _defineProperty(_classnames, styles.dayEndOfWeek, isEndOfWeek), _defineProperty(_classnames, styles.dayStartOfMonth, isStartOfMonth), _defineProperty(_classnames, styles.dayEndOfMonth, isEndOfMonth), _defineProperty(_classnames, styles.dayHovered, _this.state.hover), _defineProperty(_classnames, styles.dayActive, _this.state.active), _classnames));
        });
        _defineProperty(_assertThisInitialized(_this), "renderPreviewPlaceholder", function() {
            var _classnames2;
            var _this$props4 = _this.props, preview = _this$props4.preview, day = _this$props4.day, styles = _this$props4.styles;
            if (!preview) return null;
            var startDate = preview.startDate ? (0, _endOfDay.default)(preview.startDate) : null;
            var endDate = preview.endDate ? (0, _startOfDay.default)(preview.endDate) : null;
            var isInRange = (!startDate || (0, _isAfter.default)(day, startDate)) && (!endDate || (0, _isBefore.default)(day, endDate));
            var isStartEdge = !isInRange && (0, _isSameDay.default)(day, startDate);
            var isEndEdge = !isInRange && (0, _isSameDay.default)(day, endDate);
            return /*#__PURE__*/ _react.default.createElement("span", {
                className: (0, _classnames4.default)((_classnames2 = {}, _defineProperty(_classnames2, styles.dayStartPreview, isStartEdge), _defineProperty(_classnames2, styles.dayInPreview, isInRange), _defineProperty(_classnames2, styles.dayEndPreview, isEndEdge), _classnames2)),
                style: {
                    color: preview.color
                }
            });
        });
        _defineProperty(_assertThisInitialized(_this), "renderSelectionPlaceholders", function() {
            var _this$props5 = _this.props, styles = _this$props5.styles, ranges = _this$props5.ranges, day = _this$props5.day;
            if (_this.props.displayMode === "date") {
                var isSelected = (0, _isSameDay.default)(_this.props.day, _this.props.date);
                return isSelected ? /*#__PURE__*/ _react.default.createElement("span", {
                    className: styles.selected,
                    style: {
                        color: _this.props.color
                    }
                }) : null;
            }
            var inRanges = ranges.reduce(function(result, range) {
                var startDate = range.startDate;
                var endDate = range.endDate;
                if (startDate && endDate && (0, _isBefore.default)(endDate, startDate)) {
                    var _ref = [
                        endDate,
                        startDate
                    ];
                    startDate = _ref[0];
                    endDate = _ref[1];
                }
                startDate = startDate ? (0, _endOfDay.default)(startDate) : null;
                endDate = endDate ? (0, _startOfDay.default)(endDate) : null;
                var isInRange = (!startDate || (0, _isAfter.default)(day, startDate)) && (!endDate || (0, _isBefore.default)(day, endDate));
                var isStartEdge = !isInRange && (0, _isSameDay.default)(day, startDate);
                var isEndEdge = !isInRange && (0, _isSameDay.default)(day, endDate);
                if (isInRange || isStartEdge || isEndEdge) return [].concat(_toConsumableArray(result), [
                    _objectSpread({
                        isStartEdge: isStartEdge,
                        isEndEdge: isEndEdge,
                        isInRange: isInRange
                    }, range)
                ]);
                return result;
            }, []);
            return inRanges.map(function(range, i) {
                var _classnames3;
                return /*#__PURE__*/ _react.default.createElement("span", {
                    key: i,
                    className: (0, _classnames4.default)((_classnames3 = {}, _defineProperty(_classnames3, styles.startEdge, range.isStartEdge), _defineProperty(_classnames3, styles.endEdge, range.isEndEdge), _defineProperty(_classnames3, styles.inRange, range.isInRange), _classnames3)),
                    style: {
                        color: range.color || _this.props.color
                    }
                });
            });
        });
        _this.state = {
            hover: false,
            active: false
        };
        return _this;
    }
    _createClass(DayCell, [
        {
            key: "render",
            value: function render() {
                var dayContentRenderer = this.props.dayContentRenderer;
                return /*#__PURE__*/ _react.default.createElement("button", _extends({
                    type: "button",
                    onMouseEnter: this.handleMouseEvent,
                    onMouseLeave: this.handleMouseEvent,
                    onFocus: this.handleMouseEvent,
                    onMouseDown: this.handleMouseEvent,
                    onMouseUp: this.handleMouseEvent,
                    onBlur: this.handleMouseEvent,
                    onPauseCapture: this.handleMouseEvent,
                    onKeyDown: this.handleKeyEvent,
                    onKeyUp: this.handleKeyEvent,
                    className: this.getClassNames(this.props.styles)
                }, this.props.disabled || this.props.isPassive ? {
                    tabIndex: -1
                } : {}, {
                    style: {
                        color: this.props.color
                    }
                }), this.renderSelectionPlaceholders(), this.renderPreviewPlaceholder(), /*#__PURE__*/ _react.default.createElement("span", {
                    className: this.props.styles.dayNumber
                }, (dayContentRenderer === null || dayContentRenderer === void 0 ? void 0 : dayContentRenderer(this.props.day)) || /*#__PURE__*/ _react.default.createElement("span", null, (0, _format.default)(this.props.day, this.props.dayDisplayFormat))));
            }
        }
    ]);
    return DayCell;
}(_react.Component);
DayCell.defaultProps = {};
var rangeShape = _propTypes.default.shape({
    startDate: _propTypes.default.object,
    endDate: _propTypes.default.object,
    color: _propTypes.default.string,
    key: _propTypes.default.string,
    autoFocus: _propTypes.default.bool,
    disabled: _propTypes.default.bool,
    showDateDisplay: _propTypes.default.bool
});
exports.rangeShape = rangeShape;
DayCell.propTypes = {
    day: _propTypes.default.object.isRequired,
    dayDisplayFormat: _propTypes.default.string,
    date: _propTypes.default.object,
    ranges: _propTypes.default.arrayOf(rangeShape),
    preview: _propTypes.default.shape({
        startDate: _propTypes.default.object,
        endDate: _propTypes.default.object,
        color: _propTypes.default.string
    }),
    onPreviewChange: _propTypes.default.func,
    previewColor: _propTypes.default.string,
    disabled: _propTypes.default.bool,
    isPassive: _propTypes.default.bool,
    isToday: _propTypes.default.bool,
    isWeekend: _propTypes.default.bool,
    isStartOfWeek: _propTypes.default.bool,
    isEndOfWeek: _propTypes.default.bool,
    isStartOfMonth: _propTypes.default.bool,
    isEndOfMonth: _propTypes.default.bool,
    color: _propTypes.default.string,
    displayMode: _propTypes.default.oneOf([
        "dateRange",
        "date"
    ]),
    styles: _propTypes.default.object,
    onMouseDown: _propTypes.default.func,
    onMouseUp: _propTypes.default.func,
    onMouseEnter: _propTypes.default.func,
    dayContentRenderer: _propTypes.default.func
};
var _default = DayCell;
exports.default = _default;

},{"21befc2105e4624b":"6uln9","875ca86b6a547a16":"6FKs7","23286e331f68c16a":"hVGzI","ad8d62c47f265e95":"4Dc68","1e244c1aeb7782f8":"d6hvx","dc17a5dadf8815b1":"kUiIh","523c198b455be3bd":"zixuD","376560d82a27d539":"3AQSq","a16dbe9e1a924836":"3ImQM"}],"4Dc68":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>endOfDay);
var _indexJs = require("../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
function endOfDay(dirtyDate) {
    (0, _indexJsDefault1.default)(1, arguments);
    var date = (0, _indexJsDefault.default)(dirtyDate);
    date.setHours(23, 59, 59, 999);
    return date;
}

},{"../toDate/index.js":"fYDr6","../_lib/requiredArgs/index.js":"180ox","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"fYDr6":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>toDate);
var _typeof = require("@babel/runtime/helpers/esm/typeof");
var _typeofDefault = parcelHelpers.interopDefault(_typeof);
var _indexJs = require("../_lib/requiredArgs/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
function toDate(argument) {
    (0, _indexJsDefault.default)(1, arguments);
    var argStr = Object.prototype.toString.call(argument);
    // Clone the date
    if (argument instanceof Date || (0, _typeofDefault.default)(argument) === "object" && argStr === "[object Date]") // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new Date(argument.getTime());
    else if (typeof argument === "number" || argStr === "[object Number]") return new Date(argument);
    else {
        if ((typeof argument === "string" || argStr === "[object String]") && typeof console !== "undefined") {
            // eslint-disable-next-line no-console
            console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#string-arguments");
            // eslint-disable-next-line no-console
            console.warn(new Error().stack);
        }
        return new Date(NaN);
    }
}

},{"@babel/runtime/helpers/esm/typeof":"4ZfJH","../_lib/requiredArgs/index.js":"180ox","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"180ox":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>requiredArgs);
function requiredArgs(required, args) {
    if (args.length < required) throw new TypeError(required + " argument" + (required > 1 ? "s" : "") + " required, but only " + args.length + " present");
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"d6hvx":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>isBefore);
var _indexJs = require("../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
function isBefore(dirtyDate, dirtyDateToCompare) {
    (0, _indexJsDefault1.default)(2, arguments);
    var date = (0, _indexJsDefault.default)(dirtyDate);
    var dateToCompare = (0, _indexJsDefault.default)(dirtyDateToCompare);
    return date.getTime() < dateToCompare.getTime();
}

},{"../toDate/index.js":"fYDr6","../_lib/requiredArgs/index.js":"180ox","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"kUiIh":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>isAfter);
var _indexJs = require("../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
function isAfter(dirtyDate, dirtyDateToCompare) {
    (0, _indexJsDefault1.default)(2, arguments);
    var date = (0, _indexJsDefault.default)(dirtyDate);
    var dateToCompare = (0, _indexJsDefault.default)(dirtyDateToCompare);
    return date.getTime() > dateToCompare.getTime();
}

},{"../toDate/index.js":"fYDr6","../_lib/requiredArgs/index.js":"180ox","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"zixuD":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>isSameDay);
var _indexJs = require("../startOfDay/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
function isSameDay(dirtyDateLeft, dirtyDateRight) {
    (0, _indexJsDefault1.default)(2, arguments);
    var dateLeftStartOfDay = (0, _indexJsDefault.default)(dirtyDateLeft);
    var dateRightStartOfDay = (0, _indexJsDefault.default)(dirtyDateRight);
    return dateLeftStartOfDay.getTime() === dateRightStartOfDay.getTime();
}

},{"../startOfDay/index.js":"3ImQM","../_lib/requiredArgs/index.js":"180ox","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3ImQM":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>startOfDay);
var _indexJs = require("../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
function startOfDay(dirtyDate) {
    (0, _indexJsDefault1.default)(1, arguments);
    var date = (0, _indexJsDefault.default)(dirtyDate);
    date.setHours(0, 0, 0, 0);
    return date;
}

},{"../toDate/index.js":"fYDr6","../_lib/requiredArgs/index.js":"180ox","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3AQSq":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>format);
var _indexJs = require("../isValid/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../subMilliseconds/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../toDate/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("../_lib/format/formatters/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("../_lib/format/longFormatters/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
var _indexJs5 = require("../_lib/getTimezoneOffsetInMilliseconds/index.js");
var _indexJsDefault5 = parcelHelpers.interopDefault(_indexJs5);
var _indexJs6 = require("../_lib/protectedTokens/index.js");
var _indexJs7 = require("../_lib/toInteger/index.js");
var _indexJsDefault6 = parcelHelpers.interopDefault(_indexJs7);
var _indexJs8 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault7 = parcelHelpers.interopDefault(_indexJs8);
var _indexJs9 = require("../_lib/defaultOptions/index.js");
var _indexJs10 = require("../_lib/defaultLocale/index.js"); // This RegExp consists of three parts separated by `|`:
var _indexJsDefault8 = parcelHelpers.interopDefault(_indexJs10);
// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps
var formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;
// This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`
var longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
var escapedStringRegExp = /^'([^]*?)'?$/;
var doubleQuoteRegExp = /''/g;
var unescapedLatinCharacterRegExp = /[a-zA-Z]/;
function format(dirtyDate, dirtyFormatStr, options) {
    var _ref, _options$locale, _ref2, _ref3, _ref4, _options$firstWeekCon, _options$locale2, _options$locale2$opti, _defaultOptions$local, _defaultOptions$local2, _ref5, _ref6, _ref7, _options$weekStartsOn, _options$locale3, _options$locale3$opti, _defaultOptions$local3, _defaultOptions$local4;
    (0, _indexJsDefault7.default)(2, arguments);
    var formatStr = String(dirtyFormatStr);
    var defaultOptions = (0, _indexJs9.getDefaultOptions)();
    var locale = (_ref = (_options$locale = options === null || options === void 0 ? void 0 : options.locale) !== null && _options$locale !== void 0 ? _options$locale : defaultOptions.locale) !== null && _ref !== void 0 ? _ref : (0, _indexJsDefault8.default);
    var firstWeekContainsDate = (0, _indexJsDefault6.default)((_ref2 = (_ref3 = (_ref4 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale2 = options.locale) === null || _options$locale2 === void 0 ? void 0 : (_options$locale2$opti = _options$locale2.options) === null || _options$locale2$opti === void 0 ? void 0 : _options$locale2$opti.firstWeekContainsDate) !== null && _ref4 !== void 0 ? _ref4 : defaultOptions.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : 1);
    // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
    if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
    var weekStartsOn = (0, _indexJsDefault6.default)((_ref5 = (_ref6 = (_ref7 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale3 = options.locale) === null || _options$locale3 === void 0 ? void 0 : (_options$locale3$opti = _options$locale3.options) === null || _options$locale3$opti === void 0 ? void 0 : _options$locale3$opti.weekStartsOn) !== null && _ref7 !== void 0 ? _ref7 : defaultOptions.weekStartsOn) !== null && _ref6 !== void 0 ? _ref6 : (_defaultOptions$local3 = defaultOptions.locale) === null || _defaultOptions$local3 === void 0 ? void 0 : (_defaultOptions$local4 = _defaultOptions$local3.options) === null || _defaultOptions$local4 === void 0 ? void 0 : _defaultOptions$local4.weekStartsOn) !== null && _ref5 !== void 0 ? _ref5 : 0);
    // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
    if (!locale.localize) throw new RangeError("locale must contain localize property");
    if (!locale.formatLong) throw new RangeError("locale must contain formatLong property");
    var originalDate = (0, _indexJsDefault2.default)(dirtyDate);
    if (!(0, _indexJsDefault.default)(originalDate)) throw new RangeError("Invalid time value");
    // Convert the date in system timezone to the same date in UTC+00:00 timezone.
    // This ensures that when UTC functions will be implemented, locales will be compatible with them.
    // See an issue about UTC functions: https://github.com/date-fns/date-fns/issues/376
    var timezoneOffset = (0, _indexJsDefault5.default)(originalDate);
    var utcDate = (0, _indexJsDefault1.default)(originalDate, timezoneOffset);
    var formatterOptions = {
        firstWeekContainsDate: firstWeekContainsDate,
        weekStartsOn: weekStartsOn,
        locale: locale,
        _originalDate: originalDate
    };
    var result = formatStr.match(longFormattingTokensRegExp).map(function(substring) {
        var firstCharacter = substring[0];
        if (firstCharacter === "p" || firstCharacter === "P") {
            var longFormatter = (0, _indexJsDefault4.default)[firstCharacter];
            return longFormatter(substring, locale.formatLong);
        }
        return substring;
    }).join("").match(formattingTokensRegExp).map(function(substring) {
        // Replace two single quote characters with one single quote character
        if (substring === "''") return "'";
        var firstCharacter = substring[0];
        if (firstCharacter === "'") return cleanEscapedString(substring);
        var formatter = (0, _indexJsDefault3.default)[firstCharacter];
        if (formatter) {
            if (!(options !== null && options !== void 0 && options.useAdditionalWeekYearTokens) && (0, _indexJs6.isProtectedWeekYearToken)(substring)) (0, _indexJs6.throwProtectedError)(substring, dirtyFormatStr, String(dirtyDate));
            if (!(options !== null && options !== void 0 && options.useAdditionalDayOfYearTokens) && (0, _indexJs6.isProtectedDayOfYearToken)(substring)) (0, _indexJs6.throwProtectedError)(substring, dirtyFormatStr, String(dirtyDate));
            return formatter(utcDate, substring, locale.localize, formatterOptions);
        }
        if (firstCharacter.match(unescapedLatinCharacterRegExp)) throw new RangeError("Format string contains an unescaped latin alphabet character `" + firstCharacter + "`");
        return substring;
    }).join("");
    return result;
}
function cleanEscapedString(input) {
    var matched = input.match(escapedStringRegExp);
    if (!matched) return input;
    return matched[1].replace(doubleQuoteRegExp, "'");
}

},{"../isValid/index.js":"iWjlu","../subMilliseconds/index.js":"16tPB","../toDate/index.js":"fYDr6","../_lib/format/formatters/index.js":"gFjwI","../_lib/format/longFormatters/index.js":"hOFhU","../_lib/getTimezoneOffsetInMilliseconds/index.js":"fAihR","../_lib/protectedTokens/index.js":"cQJLO","../_lib/toInteger/index.js":"fgaQ2","../_lib/requiredArgs/index.js":"180ox","../_lib/defaultOptions/index.js":"j28dB","../_lib/defaultLocale/index.js":"fj9oT","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"iWjlu":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>isValid);
var _indexJs = require("../isDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../toDate/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
function isValid(dirtyDate) {
    (0, _indexJsDefault2.default)(1, arguments);
    if (!(0, _indexJsDefault.default)(dirtyDate) && typeof dirtyDate !== "number") return false;
    var date = (0, _indexJsDefault1.default)(dirtyDate);
    return !isNaN(Number(date));
}

},{"../isDate/index.js":"5PSLF","../toDate/index.js":"fYDr6","../_lib/requiredArgs/index.js":"180ox","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"5PSLF":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>isDate);
var _typeof = require("@babel/runtime/helpers/esm/typeof");
var _typeofDefault = parcelHelpers.interopDefault(_typeof);
var _indexJs = require("../_lib/requiredArgs/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
function isDate(value) {
    (0, _indexJsDefault.default)(1, arguments);
    return value instanceof Date || (0, _typeofDefault.default)(value) === "object" && Object.prototype.toString.call(value) === "[object Date]";
}

},{"@babel/runtime/helpers/esm/typeof":"4ZfJH","../_lib/requiredArgs/index.js":"180ox","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"16tPB":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>subMilliseconds);
var _indexJs = require("../addMilliseconds/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../_lib/toInteger/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
function subMilliseconds(dirtyDate, dirtyAmount) {
    (0, _indexJsDefault1.default)(2, arguments);
    var amount = (0, _indexJsDefault2.default)(dirtyAmount);
    return (0, _indexJsDefault.default)(dirtyDate, -amount);
}

},{"../addMilliseconds/index.js":"3BEY5","../_lib/requiredArgs/index.js":"180ox","../_lib/toInteger/index.js":"fgaQ2","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3BEY5":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>addMilliseconds);
var _indexJs = require("../_lib/toInteger/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../toDate/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
function addMilliseconds(dirtyDate, dirtyAmount) {
    (0, _indexJsDefault2.default)(2, arguments);
    var timestamp = (0, _indexJsDefault1.default)(dirtyDate).getTime();
    var amount = (0, _indexJsDefault.default)(dirtyAmount);
    return new Date(timestamp + amount);
}

},{"../_lib/toInteger/index.js":"fgaQ2","../toDate/index.js":"fYDr6","../_lib/requiredArgs/index.js":"180ox","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"fgaQ2":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>toInteger);
function toInteger(dirtyNumber) {
    if (dirtyNumber === null || dirtyNumber === true || dirtyNumber === false) return NaN;
    var number = Number(dirtyNumber);
    if (isNaN(number)) return number;
    return number < 0 ? Math.ceil(number) : Math.floor(number);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"gFjwI":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/getUTCDayOfYear/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../../../_lib/getUTCISOWeek/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../../../_lib/getUTCISOWeekYear/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("../../../_lib/getUTCWeek/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("../../../_lib/getUTCWeekYear/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
var _indexJs5 = require("../../addLeadingZeros/index.js");
var _indexJsDefault5 = parcelHelpers.interopDefault(_indexJs5);
var _indexJs6 = require("../lightFormatters/index.js");
var _indexJsDefault6 = parcelHelpers.interopDefault(_indexJs6);
var dayPeriodEnum = {
    am: "am",
    pm: "pm",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
};
/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* | Milliseconds in day            |
 * |  b  | AM, PM, noon, midnight         |  B  | Flexible day period            |
 * |  c  | Stand-alone local day of week  |  C* | Localized hour w/ day period   |
 * |  d  | Day of month                   |  D  | Day of year                    |
 * |  e  | Local day of week              |  E  | Day of week                    |
 * |  f  |                                |  F* | Day of week in month           |
 * |  g* | Modified Julian day            |  G  | Era                            |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  i! | ISO day of week                |  I! | ISO week of year               |
 * |  j* | Localized hour w/ day period   |  J* | Localized hour w/o day period  |
 * |  k  | Hour [1-24]                    |  K  | Hour [0-11]                    |
 * |  l* | (deprecated)                   |  L  | Stand-alone month              |
 * |  m  | Minute                         |  M  | Month                          |
 * |  n  |                                |  N  |                                |
 * |  o! | Ordinal number modifier        |  O  | Timezone (GMT)                 |
 * |  p! | Long localized time            |  P! | Long localized date            |
 * |  q  | Stand-alone quarter            |  Q  | Quarter                        |
 * |  r* | Related Gregorian year         |  R! | ISO week-numbering year        |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  t! | Seconds timestamp              |  T! | Milliseconds timestamp         |
 * |  u  | Extended year                  |  U* | Cyclic year                    |
 * |  v* | Timezone (generic non-locat.)  |  V* | Timezone (location)            |
 * |  w  | Local week of year             |  W* | Week of month                  |
 * |  x  | Timezone (ISO-8601 w/o Z)      |  X  | Timezone (ISO-8601)            |
 * |  y  | Year (abs)                     |  Y  | Local week-numbering year      |
 * |  z  | Timezone (specific non-locat.) |  Z* | Timezone (aliases)             |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 *
 * Letters marked by ! are non-standard, but implemented by date-fns:
 * - `o` modifies the previous token to turn it into an ordinal (see `format` docs)
 * - `i` is ISO day of week. For `i` and `ii` is returns numeric ISO week days,
 *   i.e. 7 for Sunday, 1 for Monday, etc.
 * - `I` is ISO week of year, as opposed to `w` which is local week of year.
 * - `R` is ISO week-numbering year, as opposed to `Y` which is local week-numbering year.
 *   `R` is supposed to be used in conjunction with `I` and `i`
 *   for universal ISO week-numbering date, whereas
 *   `Y` is supposed to be used in conjunction with `w` and `e`
 *   for week-numbering date specific to the locale.
 * - `P` is long localized date format
 * - `p` is long localized time format
 */ var formatters = {
    // Era
    G: function G(date, token, localize) {
        var era = date.getUTCFullYear() > 0 ? 1 : 0;
        switch(token){
            // AD, BC
            case "G":
            case "GG":
            case "GGG":
                return localize.era(era, {
                    width: "abbreviated"
                });
            // A, B
            case "GGGGG":
                return localize.era(era, {
                    width: "narrow"
                });
            // Anno Domini, Before Christ
            case "GGGG":
            default:
                return localize.era(era, {
                    width: "wide"
                });
        }
    },
    // Year
    y: function y(date, token, localize) {
        // Ordinal number
        if (token === "yo") {
            var signedYear = date.getUTCFullYear();
            // Returns 1 for 1 BC (which is year 0 in JavaScript)
            var year = signedYear > 0 ? signedYear : 1 - signedYear;
            return localize.ordinalNumber(year, {
                unit: "year"
            });
        }
        return (0, _indexJsDefault6.default).y(date, token);
    },
    // Local week-numbering year
    Y: function Y(date, token, localize, options) {
        var signedWeekYear = (0, _indexJsDefault4.default)(date, options);
        // Returns 1 for 1 BC (which is year 0 in JavaScript)
        var weekYear = signedWeekYear > 0 ? signedWeekYear : 1 - signedWeekYear;
        // Two digit year
        if (token === "YY") {
            var twoDigitYear = weekYear % 100;
            return (0, _indexJsDefault5.default)(twoDigitYear, 2);
        }
        // Ordinal number
        if (token === "Yo") return localize.ordinalNumber(weekYear, {
            unit: "year"
        });
        // Padding
        return (0, _indexJsDefault5.default)(weekYear, token.length);
    },
    // ISO week-numbering year
    R: function R(date, token) {
        var isoWeekYear = (0, _indexJsDefault2.default)(date);
        // Padding
        return (0, _indexJsDefault5.default)(isoWeekYear, token.length);
    },
    // Extended year. This is a single number designating the year of this calendar system.
    // The main difference between `y` and `u` localizers are B.C. years:
    // | Year | `y` | `u` |
    // |------|-----|-----|
    // | AC 1 |   1 |   1 |
    // | BC 1 |   1 |   0 |
    // | BC 2 |   2 |  -1 |
    // Also `yy` always returns the last two digits of a year,
    // while `uu` pads single digit years to 2 characters and returns other years unchanged.
    u: function u(date, token) {
        var year = date.getUTCFullYear();
        return (0, _indexJsDefault5.default)(year, token.length);
    },
    // Quarter
    Q: function Q(date, token, localize) {
        var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
        switch(token){
            // 1, 2, 3, 4
            case "Q":
                return String(quarter);
            // 01, 02, 03, 04
            case "QQ":
                return (0, _indexJsDefault5.default)(quarter, 2);
            // 1st, 2nd, 3rd, 4th
            case "Qo":
                return localize.ordinalNumber(quarter, {
                    unit: "quarter"
                });
            // Q1, Q2, Q3, Q4
            case "QQQ":
                return localize.quarter(quarter, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case "QQQQQ":
                return localize.quarter(quarter, {
                    width: "narrow",
                    context: "formatting"
                });
            // 1st quarter, 2nd quarter, ...
            case "QQQQ":
            default:
                return localize.quarter(quarter, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Stand-alone quarter
    q: function q(date, token, localize) {
        var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
        switch(token){
            // 1, 2, 3, 4
            case "q":
                return String(quarter);
            // 01, 02, 03, 04
            case "qq":
                return (0, _indexJsDefault5.default)(quarter, 2);
            // 1st, 2nd, 3rd, 4th
            case "qo":
                return localize.ordinalNumber(quarter, {
                    unit: "quarter"
                });
            // Q1, Q2, Q3, Q4
            case "qqq":
                return localize.quarter(quarter, {
                    width: "abbreviated",
                    context: "standalone"
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case "qqqqq":
                return localize.quarter(quarter, {
                    width: "narrow",
                    context: "standalone"
                });
            // 1st quarter, 2nd quarter, ...
            case "qqqq":
            default:
                return localize.quarter(quarter, {
                    width: "wide",
                    context: "standalone"
                });
        }
    },
    // Month
    M: function M(date, token, localize) {
        var month = date.getUTCMonth();
        switch(token){
            case "M":
            case "MM":
                return (0, _indexJsDefault6.default).M(date, token);
            // 1st, 2nd, ..., 12th
            case "Mo":
                return localize.ordinalNumber(month + 1, {
                    unit: "month"
                });
            // Jan, Feb, ..., Dec
            case "MMM":
                return localize.month(month, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // J, F, ..., D
            case "MMMMM":
                return localize.month(month, {
                    width: "narrow",
                    context: "formatting"
                });
            // January, February, ..., December
            case "MMMM":
            default:
                return localize.month(month, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Stand-alone month
    L: function L(date, token, localize) {
        var month = date.getUTCMonth();
        switch(token){
            // 1, 2, ..., 12
            case "L":
                return String(month + 1);
            // 01, 02, ..., 12
            case "LL":
                return (0, _indexJsDefault5.default)(month + 1, 2);
            // 1st, 2nd, ..., 12th
            case "Lo":
                return localize.ordinalNumber(month + 1, {
                    unit: "month"
                });
            // Jan, Feb, ..., Dec
            case "LLL":
                return localize.month(month, {
                    width: "abbreviated",
                    context: "standalone"
                });
            // J, F, ..., D
            case "LLLLL":
                return localize.month(month, {
                    width: "narrow",
                    context: "standalone"
                });
            // January, February, ..., December
            case "LLLL":
            default:
                return localize.month(month, {
                    width: "wide",
                    context: "standalone"
                });
        }
    },
    // Local week of year
    w: function w(date, token, localize, options) {
        var week = (0, _indexJsDefault3.default)(date, options);
        if (token === "wo") return localize.ordinalNumber(week, {
            unit: "week"
        });
        return (0, _indexJsDefault5.default)(week, token.length);
    },
    // ISO week of year
    I: function I(date, token, localize) {
        var isoWeek = (0, _indexJsDefault1.default)(date);
        if (token === "Io") return localize.ordinalNumber(isoWeek, {
            unit: "week"
        });
        return (0, _indexJsDefault5.default)(isoWeek, token.length);
    },
    // Day of the month
    d: function d(date, token, localize) {
        if (token === "do") return localize.ordinalNumber(date.getUTCDate(), {
            unit: "date"
        });
        return (0, _indexJsDefault6.default).d(date, token);
    },
    // Day of year
    D: function D(date, token, localize) {
        var dayOfYear = (0, _indexJsDefault.default)(date);
        if (token === "Do") return localize.ordinalNumber(dayOfYear, {
            unit: "dayOfYear"
        });
        return (0, _indexJsDefault5.default)(dayOfYear, token.length);
    },
    // Day of week
    E: function E(date, token, localize) {
        var dayOfWeek = date.getUTCDay();
        switch(token){
            // Tue
            case "E":
            case "EE":
            case "EEE":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // T
            case "EEEEE":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tu
            case "EEEEEE":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "formatting"
                });
            // Tuesday
            case "EEEE":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Local day of week
    e: function e(date, token, localize, options) {
        var dayOfWeek = date.getUTCDay();
        var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
        switch(token){
            // Numerical value (Nth day of week with current locale or weekStartsOn)
            case "e":
                return String(localDayOfWeek);
            // Padded numerical value
            case "ee":
                return (0, _indexJsDefault5.default)(localDayOfWeek, 2);
            // 1st, 2nd, ..., 7th
            case "eo":
                return localize.ordinalNumber(localDayOfWeek, {
                    unit: "day"
                });
            case "eee":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // T
            case "eeeee":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tu
            case "eeeeee":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "formatting"
                });
            // Tuesday
            case "eeee":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Stand-alone local day of week
    c: function c(date, token, localize, options) {
        var dayOfWeek = date.getUTCDay();
        var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
        switch(token){
            // Numerical value (same as in `e`)
            case "c":
                return String(localDayOfWeek);
            // Padded numerical value
            case "cc":
                return (0, _indexJsDefault5.default)(localDayOfWeek, token.length);
            // 1st, 2nd, ..., 7th
            case "co":
                return localize.ordinalNumber(localDayOfWeek, {
                    unit: "day"
                });
            case "ccc":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "standalone"
                });
            // T
            case "ccccc":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "standalone"
                });
            // Tu
            case "cccccc":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "standalone"
                });
            // Tuesday
            case "cccc":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "standalone"
                });
        }
    },
    // ISO day of week
    i: function i(date, token, localize) {
        var dayOfWeek = date.getUTCDay();
        var isoDayOfWeek = dayOfWeek === 0 ? 7 : dayOfWeek;
        switch(token){
            // 2
            case "i":
                return String(isoDayOfWeek);
            // 02
            case "ii":
                return (0, _indexJsDefault5.default)(isoDayOfWeek, token.length);
            // 2nd
            case "io":
                return localize.ordinalNumber(isoDayOfWeek, {
                    unit: "day"
                });
            // Tue
            case "iii":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // T
            case "iiiii":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tu
            case "iiiiii":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "formatting"
                });
            // Tuesday
            case "iiii":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // AM or PM
    a: function a(date, token, localize) {
        var hours = date.getUTCHours();
        var dayPeriodEnumValue = hours / 12 >= 1 ? "pm" : "am";
        switch(token){
            case "a":
            case "aa":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                });
            case "aaa":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                }).toLowerCase();
            case "aaaaa":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "narrow",
                    context: "formatting"
                });
            case "aaaa":
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // AM, PM, midnight, noon
    b: function b(date, token, localize) {
        var hours = date.getUTCHours();
        var dayPeriodEnumValue;
        if (hours === 12) dayPeriodEnumValue = dayPeriodEnum.noon;
        else if (hours === 0) dayPeriodEnumValue = dayPeriodEnum.midnight;
        else dayPeriodEnumValue = hours / 12 >= 1 ? "pm" : "am";
        switch(token){
            case "b":
            case "bb":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                });
            case "bbb":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                }).toLowerCase();
            case "bbbbb":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "narrow",
                    context: "formatting"
                });
            case "bbbb":
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // in the morning, in the afternoon, in the evening, at night
    B: function B(date, token, localize) {
        var hours = date.getUTCHours();
        var dayPeriodEnumValue;
        if (hours >= 17) dayPeriodEnumValue = dayPeriodEnum.evening;
        else if (hours >= 12) dayPeriodEnumValue = dayPeriodEnum.afternoon;
        else if (hours >= 4) dayPeriodEnumValue = dayPeriodEnum.morning;
        else dayPeriodEnumValue = dayPeriodEnum.night;
        switch(token){
            case "B":
            case "BB":
            case "BBB":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                });
            case "BBBBB":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "narrow",
                    context: "formatting"
                });
            case "BBBB":
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Hour [1-12]
    h: function h(date, token, localize) {
        if (token === "ho") {
            var hours = date.getUTCHours() % 12;
            if (hours === 0) hours = 12;
            return localize.ordinalNumber(hours, {
                unit: "hour"
            });
        }
        return (0, _indexJsDefault6.default).h(date, token);
    },
    // Hour [0-23]
    H: function H(date, token, localize) {
        if (token === "Ho") return localize.ordinalNumber(date.getUTCHours(), {
            unit: "hour"
        });
        return (0, _indexJsDefault6.default).H(date, token);
    },
    // Hour [0-11]
    K: function K(date, token, localize) {
        var hours = date.getUTCHours() % 12;
        if (token === "Ko") return localize.ordinalNumber(hours, {
            unit: "hour"
        });
        return (0, _indexJsDefault5.default)(hours, token.length);
    },
    // Hour [1-24]
    k: function k(date, token, localize) {
        var hours = date.getUTCHours();
        if (hours === 0) hours = 24;
        if (token === "ko") return localize.ordinalNumber(hours, {
            unit: "hour"
        });
        return (0, _indexJsDefault5.default)(hours, token.length);
    },
    // Minute
    m: function m(date, token, localize) {
        if (token === "mo") return localize.ordinalNumber(date.getUTCMinutes(), {
            unit: "minute"
        });
        return (0, _indexJsDefault6.default).m(date, token);
    },
    // Second
    s: function s(date, token, localize) {
        if (token === "so") return localize.ordinalNumber(date.getUTCSeconds(), {
            unit: "second"
        });
        return (0, _indexJsDefault6.default).s(date, token);
    },
    // Fraction of second
    S: function S(date, token) {
        return (0, _indexJsDefault6.default).S(date, token);
    },
    // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
    X: function X(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        if (timezoneOffset === 0) return "Z";
        switch(token){
            // Hours and optional minutes
            case "X":
                return formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XX`
            case "XXXX":
            case "XX":
                // Hours and minutes without `:` delimiter
                return formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XXX`
            case "XXXXX":
            case "XXX":
            default:
                return formatTimezone(timezoneOffset, ":");
        }
    },
    // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
    x: function x(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        switch(token){
            // Hours and optional minutes
            case "x":
                return formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xx`
            case "xxxx":
            case "xx":
                // Hours and minutes without `:` delimiter
                return formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xxx`
            case "xxxxx":
            case "xxx":
            default:
                return formatTimezone(timezoneOffset, ":");
        }
    },
    // Timezone (GMT)
    O: function O(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        switch(token){
            // Short
            case "O":
            case "OO":
            case "OOO":
                return "GMT" + formatTimezoneShort(timezoneOffset, ":");
            // Long
            case "OOOO":
            default:
                return "GMT" + formatTimezone(timezoneOffset, ":");
        }
    },
    // Timezone (specific non-location)
    z: function z(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        switch(token){
            // Short
            case "z":
            case "zz":
            case "zzz":
                return "GMT" + formatTimezoneShort(timezoneOffset, ":");
            // Long
            case "zzzz":
            default:
                return "GMT" + formatTimezone(timezoneOffset, ":");
        }
    },
    // Seconds timestamp
    t: function t(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timestamp = Math.floor(originalDate.getTime() / 1000);
        return (0, _indexJsDefault5.default)(timestamp, token.length);
    },
    // Milliseconds timestamp
    T: function T(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timestamp = originalDate.getTime();
        return (0, _indexJsDefault5.default)(timestamp, token.length);
    }
};
function formatTimezoneShort(offset, dirtyDelimiter) {
    var sign = offset > 0 ? "-" : "+";
    var absOffset = Math.abs(offset);
    var hours = Math.floor(absOffset / 60);
    var minutes = absOffset % 60;
    if (minutes === 0) return sign + String(hours);
    var delimiter = dirtyDelimiter || "";
    return sign + String(hours) + delimiter + (0, _indexJsDefault5.default)(minutes, 2);
}
function formatTimezoneWithOptionalMinutes(offset, dirtyDelimiter) {
    if (offset % 60 === 0) {
        var sign = offset > 0 ? "-" : "+";
        return sign + (0, _indexJsDefault5.default)(Math.abs(offset) / 60, 2);
    }
    return formatTimezone(offset, dirtyDelimiter);
}
function formatTimezone(offset, dirtyDelimiter) {
    var delimiter = dirtyDelimiter || "";
    var sign = offset > 0 ? "-" : "+";
    var absOffset = Math.abs(offset);
    var hours = (0, _indexJsDefault5.default)(Math.floor(absOffset / 60), 2);
    var minutes = (0, _indexJsDefault5.default)(absOffset % 60, 2);
    return sign + hours + delimiter + minutes;
}
exports.default = formatters;

},{"../../../_lib/getUTCDayOfYear/index.js":"5ZRIG","../../../_lib/getUTCISOWeek/index.js":"jinth","../../../_lib/getUTCISOWeekYear/index.js":"8sYG9","../../../_lib/getUTCWeek/index.js":"7bKJm","../../../_lib/getUTCWeekYear/index.js":"1Wt2k","../../addLeadingZeros/index.js":"heNqB","../lightFormatters/index.js":"bviEo","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"5ZRIG":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getUTCDayOfYear);
var _indexJs = require("../../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var MILLISECONDS_IN_DAY = 86400000;
function getUTCDayOfYear(dirtyDate) {
    (0, _indexJsDefault1.default)(1, arguments);
    var date = (0, _indexJsDefault.default)(dirtyDate);
    var timestamp = date.getTime();
    date.setUTCMonth(0, 1);
    date.setUTCHours(0, 0, 0, 0);
    var startOfYearTimestamp = date.getTime();
    var difference = timestamp - startOfYearTimestamp;
    return Math.floor(difference / MILLISECONDS_IN_DAY) + 1;
}

},{"../../toDate/index.js":"fYDr6","../requiredArgs/index.js":"180ox","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jinth":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getUTCISOWeek);
var _indexJs = require("../../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../startOfUTCISOWeek/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../startOfUTCISOWeekYear/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("../requiredArgs/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var MILLISECONDS_IN_WEEK = 604800000;
function getUTCISOWeek(dirtyDate) {
    (0, _indexJsDefault3.default)(1, arguments);
    var date = (0, _indexJsDefault.default)(dirtyDate);
    var diff = (0, _indexJsDefault1.default)(date).getTime() - (0, _indexJsDefault2.default)(date).getTime();
    // Round the number of days to the nearest integer
    // because the number of milliseconds in a week is not constant
    // (e.g. it's different in the week of the daylight saving time clock shift)
    return Math.round(diff / MILLISECONDS_IN_WEEK) + 1;
}

},{"../../toDate/index.js":"fYDr6","../startOfUTCISOWeek/index.js":"9vtwc","../startOfUTCISOWeekYear/index.js":"kOYBE","../requiredArgs/index.js":"180ox","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9vtwc":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>startOfUTCISOWeek);
var _indexJs = require("../../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
function startOfUTCISOWeek(dirtyDate) {
    (0, _indexJsDefault1.default)(1, arguments);
    var weekStartsOn = 1;
    var date = (0, _indexJsDefault.default)(dirtyDate);
    var day = date.getUTCDay();
    var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
    date.setUTCDate(date.getUTCDate() - diff);
    date.setUTCHours(0, 0, 0, 0);
    return date;
}

},{"../../toDate/index.js":"fYDr6","../requiredArgs/index.js":"180ox","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"kOYBE":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>startOfUTCISOWeekYear);
var _indexJs = require("../getUTCISOWeekYear/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../startOfUTCISOWeek/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../requiredArgs/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
function startOfUTCISOWeekYear(dirtyDate) {
    (0, _indexJsDefault2.default)(1, arguments);
    var year = (0, _indexJsDefault.default)(dirtyDate);
    var fourthOfJanuary = new Date(0);
    fourthOfJanuary.setUTCFullYear(year, 0, 4);
    fourthOfJanuary.setUTCHours(0, 0, 0, 0);
    var date = (0, _indexJsDefault1.default)(fourthOfJanuary);
    return date;
}

},{"../getUTCISOWeekYear/index.js":"8sYG9","../startOfUTCISOWeek/index.js":"9vtwc","../requiredArgs/index.js":"180ox","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8sYG9":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getUTCISOWeekYear);
var _indexJs = require("../../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../startOfUTCISOWeek/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
function getUTCISOWeekYear(dirtyDate) {
    (0, _indexJsDefault1.default)(1, arguments);
    var date = (0, _indexJsDefault.default)(dirtyDate);
    var year = date.getUTCFullYear();
    var fourthOfJanuaryOfNextYear = new Date(0);
    fourthOfJanuaryOfNextYear.setUTCFullYear(year + 1, 0, 4);
    fourthOfJanuaryOfNextYear.setUTCHours(0, 0, 0, 0);
    var startOfNextYear = (0, _indexJsDefault2.default)(fourthOfJanuaryOfNextYear);
    var fourthOfJanuaryOfThisYear = new Date(0);
    fourthOfJanuaryOfThisYear.setUTCFullYear(year, 0, 4);
    fourthOfJanuaryOfThisYear.setUTCHours(0, 0, 0, 0);
    var startOfThisYear = (0, _indexJsDefault2.default)(fourthOfJanuaryOfThisYear);
    if (date.getTime() >= startOfNextYear.getTime()) return year + 1;
    else if (date.getTime() >= startOfThisYear.getTime()) return year;
    else return year - 1;
}

},{"../../toDate/index.js":"fYDr6","../requiredArgs/index.js":"180ox","../startOfUTCISOWeek/index.js":"9vtwc","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7bKJm":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getUTCWeek);
var _indexJs = require("../../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../startOfUTCWeek/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../startOfUTCWeekYear/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("../requiredArgs/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var MILLISECONDS_IN_WEEK = 604800000;
function getUTCWeek(dirtyDate, options) {
    (0, _indexJsDefault3.default)(1, arguments);
    var date = (0, _indexJsDefault.default)(dirtyDate);
    var diff = (0, _indexJsDefault1.default)(date, options).getTime() - (0, _indexJsDefault2.default)(date, options).getTime();
    // Round the number of days to the nearest integer
    // because the number of milliseconds in a week is not constant
    // (e.g. it's different in the week of the daylight saving time clock shift)
    return Math.round(diff / MILLISECONDS_IN_WEEK) + 1;
}

},{"../../toDate/index.js":"fYDr6","../startOfUTCWeek/index.js":"24zN6","../startOfUTCWeekYear/index.js":"bFYE0","../requiredArgs/index.js":"180ox","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"24zN6":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>startOfUTCWeek);
var _indexJs = require("../../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../toInteger/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("../defaultOptions/index.js");
function startOfUTCWeek(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, _indexJsDefault1.default)(1, arguments);
    var defaultOptions = (0, _indexJs3.getDefaultOptions)();
    var weekStartsOn = (0, _indexJsDefault2.default)((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0);
    // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
    var date = (0, _indexJsDefault.default)(dirtyDate);
    var day = date.getUTCDay();
    var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
    date.setUTCDate(date.getUTCDate() - diff);
    date.setUTCHours(0, 0, 0, 0);
    return date;
}

},{"../../toDate/index.js":"fYDr6","../requiredArgs/index.js":"180ox","../toInteger/index.js":"fgaQ2","../defaultOptions/index.js":"j28dB","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"j28dB":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getDefaultOptions", ()=>getDefaultOptions);
parcelHelpers.export(exports, "setDefaultOptions", ()=>setDefaultOptions);
var defaultOptions = {};
function getDefaultOptions() {
    return defaultOptions;
}
function setDefaultOptions(newOptions) {
    defaultOptions = newOptions;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"bFYE0":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>startOfUTCWeekYear);
var _indexJs = require("../getUTCWeekYear/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../startOfUTCWeek/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("../toInteger/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("../defaultOptions/index.js");
function startOfUTCWeekYear(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, _indexJsDefault1.default)(1, arguments);
    var defaultOptions = (0, _indexJs4.getDefaultOptions)();
    var firstWeekContainsDate = (0, _indexJsDefault3.default)((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1);
    var year = (0, _indexJsDefault.default)(dirtyDate, options);
    var firstWeek = new Date(0);
    firstWeek.setUTCFullYear(year, 0, firstWeekContainsDate);
    firstWeek.setUTCHours(0, 0, 0, 0);
    var date = (0, _indexJsDefault2.default)(firstWeek, options);
    return date;
}

},{"../getUTCWeekYear/index.js":"1Wt2k","../requiredArgs/index.js":"180ox","../startOfUTCWeek/index.js":"24zN6","../toInteger/index.js":"fgaQ2","../defaultOptions/index.js":"j28dB","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1Wt2k":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getUTCWeekYear);
var _indexJs = require("../../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../startOfUTCWeek/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("../toInteger/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("../defaultOptions/index.js");
function getUTCWeekYear(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, _indexJsDefault1.default)(1, arguments);
    var date = (0, _indexJsDefault.default)(dirtyDate);
    var year = date.getUTCFullYear();
    var defaultOptions = (0, _indexJs4.getDefaultOptions)();
    var firstWeekContainsDate = (0, _indexJsDefault3.default)((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1);
    // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
    if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
    var firstWeekOfNextYear = new Date(0);
    firstWeekOfNextYear.setUTCFullYear(year + 1, 0, firstWeekContainsDate);
    firstWeekOfNextYear.setUTCHours(0, 0, 0, 0);
    var startOfNextYear = (0, _indexJsDefault2.default)(firstWeekOfNextYear, options);
    var firstWeekOfThisYear = new Date(0);
    firstWeekOfThisYear.setUTCFullYear(year, 0, firstWeekContainsDate);
    firstWeekOfThisYear.setUTCHours(0, 0, 0, 0);
    var startOfThisYear = (0, _indexJsDefault2.default)(firstWeekOfThisYear, options);
    if (date.getTime() >= startOfNextYear.getTime()) return year + 1;
    else if (date.getTime() >= startOfThisYear.getTime()) return year;
    else return year - 1;
}

},{"../../toDate/index.js":"fYDr6","../requiredArgs/index.js":"180ox","../startOfUTCWeek/index.js":"24zN6","../toInteger/index.js":"fgaQ2","../defaultOptions/index.js":"j28dB","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"heNqB":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>addLeadingZeros);
function addLeadingZeros(number, targetLength) {
    var sign = number < 0 ? "-" : "";
    var output = Math.abs(number).toString();
    while(output.length < targetLength)output = "0" + output;
    return sign + output;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"bviEo":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../addLeadingZeros/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* |                                |
 * |  d  | Day of month                   |  D  |                                |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  m  | Minute                         |  M  | Month                          |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  y  | Year (abs)                     |  Y  |                                |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 */ var formatters = {
    // Year
    y: function y(date, token) {
        // From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_tokens
        // | Year     |     y | yy |   yyy |  yyyy | yyyyy |
        // |----------|-------|----|-------|-------|-------|
        // | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
        // | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
        // | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
        // | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
        // | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |
        var signedYear = date.getUTCFullYear();
        // Returns 1 for 1 BC (which is year 0 in JavaScript)
        var year = signedYear > 0 ? signedYear : 1 - signedYear;
        return (0, _indexJsDefault.default)(token === "yy" ? year % 100 : year, token.length);
    },
    // Month
    M: function M(date, token) {
        var month = date.getUTCMonth();
        return token === "M" ? String(month + 1) : (0, _indexJsDefault.default)(month + 1, 2);
    },
    // Day of the month
    d: function d(date, token) {
        return (0, _indexJsDefault.default)(date.getUTCDate(), token.length);
    },
    // AM or PM
    a: function a(date, token) {
        var dayPeriodEnumValue = date.getUTCHours() / 12 >= 1 ? "pm" : "am";
        switch(token){
            case "a":
            case "aa":
                return dayPeriodEnumValue.toUpperCase();
            case "aaa":
                return dayPeriodEnumValue;
            case "aaaaa":
                return dayPeriodEnumValue[0];
            case "aaaa":
            default:
                return dayPeriodEnumValue === "am" ? "a.m." : "p.m.";
        }
    },
    // Hour [1-12]
    h: function h(date, token) {
        return (0, _indexJsDefault.default)(date.getUTCHours() % 12 || 12, token.length);
    },
    // Hour [0-23]
    H: function H(date, token) {
        return (0, _indexJsDefault.default)(date.getUTCHours(), token.length);
    },
    // Minute
    m: function m(date, token) {
        return (0, _indexJsDefault.default)(date.getUTCMinutes(), token.length);
    },
    // Second
    s: function s(date, token) {
        return (0, _indexJsDefault.default)(date.getUTCSeconds(), token.length);
    },
    // Fraction of second
    S: function S(date, token) {
        var numberOfDigits = token.length;
        var milliseconds = date.getUTCMilliseconds();
        var fractionalSeconds = Math.floor(milliseconds * Math.pow(10, numberOfDigits - 3));
        return (0, _indexJsDefault.default)(fractionalSeconds, token.length);
    }
};
exports.default = formatters;

},{"../../addLeadingZeros/index.js":"heNqB","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hOFhU":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var dateLongFormatter = function dateLongFormatter(pattern, formatLong) {
    switch(pattern){
        case "P":
            return formatLong.date({
                width: "short"
            });
        case "PP":
            return formatLong.date({
                width: "medium"
            });
        case "PPP":
            return formatLong.date({
                width: "long"
            });
        case "PPPP":
        default:
            return formatLong.date({
                width: "full"
            });
    }
};
var timeLongFormatter = function timeLongFormatter(pattern, formatLong) {
    switch(pattern){
        case "p":
            return formatLong.time({
                width: "short"
            });
        case "pp":
            return formatLong.time({
                width: "medium"
            });
        case "ppp":
            return formatLong.time({
                width: "long"
            });
        case "pppp":
        default:
            return formatLong.time({
                width: "full"
            });
    }
};
var dateTimeLongFormatter = function dateTimeLongFormatter(pattern, formatLong) {
    var matchResult = pattern.match(/(P+)(p+)?/) || [];
    var datePattern = matchResult[1];
    var timePattern = matchResult[2];
    if (!timePattern) return dateLongFormatter(pattern, formatLong);
    var dateTimeFormat;
    switch(datePattern){
        case "P":
            dateTimeFormat = formatLong.dateTime({
                width: "short"
            });
            break;
        case "PP":
            dateTimeFormat = formatLong.dateTime({
                width: "medium"
            });
            break;
        case "PPP":
            dateTimeFormat = formatLong.dateTime({
                width: "long"
            });
            break;
        case "PPPP":
        default:
            dateTimeFormat = formatLong.dateTime({
                width: "full"
            });
            break;
    }
    return dateTimeFormat.replace("{{date}}", dateLongFormatter(datePattern, formatLong)).replace("{{time}}", timeLongFormatter(timePattern, formatLong));
};
var longFormatters = {
    p: timeLongFormatter,
    P: dateTimeLongFormatter
};
exports.default = longFormatters;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"fAihR":[function(require,module,exports) {
/**
 * Google Chrome as of 67.0.3396.87 introduced timezones with offset that includes seconds.
 * They usually appear for dates that denote time before the timezones were introduced
 * (e.g. for 'Europe/Prague' timezone the offset is GMT+00:57:44 before 1 October 1891
 * and GMT+01:00:00 after that date)
 *
 * Date#getTimezoneOffset returns the offset in minutes and would return 57 for the example above,
 * which would lead to incorrect calculations.
 *
 * This function returns the timezone offset in milliseconds that takes seconds in account.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getTimezoneOffsetInMilliseconds);
function getTimezoneOffsetInMilliseconds(date) {
    var utcDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds()));
    utcDate.setUTCFullYear(date.getFullYear());
    return date.getTime() - utcDate.getTime();
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"cQJLO":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isProtectedDayOfYearToken", ()=>isProtectedDayOfYearToken);
parcelHelpers.export(exports, "isProtectedWeekYearToken", ()=>isProtectedWeekYearToken);
parcelHelpers.export(exports, "throwProtectedError", ()=>throwProtectedError);
var protectedDayOfYearTokens = [
    "D",
    "DD"
];
var protectedWeekYearTokens = [
    "YY",
    "YYYY"
];
function isProtectedDayOfYearToken(token) {
    return protectedDayOfYearTokens.indexOf(token) !== -1;
}
function isProtectedWeekYearToken(token) {
    return protectedWeekYearTokens.indexOf(token) !== -1;
}
function throwProtectedError(token, format, input) {
    if (token === "YYYY") throw new RangeError("Use `yyyy` instead of `YYYY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
    else if (token === "YY") throw new RangeError("Use `yy` instead of `YY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
    else if (token === "D") throw new RangeError("Use `d` instead of `D` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
    else if (token === "DD") throw new RangeError("Use `dd` instead of `DD` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"fj9oT":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../locale/en-US/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
exports.default = (0, _indexJsDefault.default);

},{"../../locale/en-US/index.js":"dxPPF","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"dxPPF":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("./_lib/formatDistance/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("./_lib/formatLong/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("./_lib/formatRelative/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("./_lib/localize/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("./_lib/match/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
/**
 * @type {Locale}
 * @category Locales
 * @summary English locale (United States).
 * @language English
 * @iso-639-2 eng
 * @author Sasha Koss [@kossnocorp]{@link https://github.com/kossnocorp}
 * @author Lesha Koss [@leshakoss]{@link https://github.com/leshakoss}
 */ var locale = {
    code: "en-US",
    formatDistance: (0, _indexJsDefault.default),
    formatLong: (0, _indexJsDefault1.default),
    formatRelative: (0, _indexJsDefault2.default),
    localize: (0, _indexJsDefault3.default),
    match: (0, _indexJsDefault4.default),
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};
exports.default = locale;

},{"./_lib/formatDistance/index.js":"9IMHo","./_lib/formatLong/index.js":"2vgpz","./_lib/formatRelative/index.js":"aj0u7","./_lib/localize/index.js":"bIlNU","./_lib/match/index.js":"1C8qi","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9IMHo":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatDistanceLocale = {
    lessThanXSeconds: {
        one: "less than a second",
        other: "less than {{count}} seconds"
    },
    xSeconds: {
        one: "1 second",
        other: "{{count}} seconds"
    },
    halfAMinute: "half a minute",
    lessThanXMinutes: {
        one: "less than a minute",
        other: "less than {{count}} minutes"
    },
    xMinutes: {
        one: "1 minute",
        other: "{{count}} minutes"
    },
    aboutXHours: {
        one: "about 1 hour",
        other: "about {{count}} hours"
    },
    xHours: {
        one: "1 hour",
        other: "{{count}} hours"
    },
    xDays: {
        one: "1 day",
        other: "{{count}} days"
    },
    aboutXWeeks: {
        one: "about 1 week",
        other: "about {{count}} weeks"
    },
    xWeeks: {
        one: "1 week",
        other: "{{count}} weeks"
    },
    aboutXMonths: {
        one: "about 1 month",
        other: "about {{count}} months"
    },
    xMonths: {
        one: "1 month",
        other: "{{count}} months"
    },
    aboutXYears: {
        one: "about 1 year",
        other: "about {{count}} years"
    },
    xYears: {
        one: "1 year",
        other: "{{count}} years"
    },
    overXYears: {
        one: "over 1 year",
        other: "over {{count}} years"
    },
    almostXYears: {
        one: "almost 1 year",
        other: "almost {{count}} years"
    }
};
var formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", count.toString());
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return "in " + result;
        else return result + " ago";
    }
    return result;
};
exports.default = formatDistance;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2vgpz":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildFormatLongFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var dateFormats = {
    full: "EEEE, MMMM do, y",
    long: "MMMM do, y",
    medium: "MMM d, y",
    short: "MM/dd/yyyy"
};
var timeFormats = {
    full: "h:mm:ss a zzzz",
    long: "h:mm:ss a z",
    medium: "h:mm:ss a",
    short: "h:mm a"
};
var dateTimeFormats = {
    full: "{{date}} 'at' {{time}}",
    long: "{{date}} 'at' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
var formatLong = {
    date: (0, _indexJsDefault.default)({
        formats: dateFormats,
        defaultWidth: "full"
    }),
    time: (0, _indexJsDefault.default)({
        formats: timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, _indexJsDefault.default)({
        formats: dateTimeFormats,
        defaultWidth: "full"
    })
};
exports.default = formatLong;

},{"../../../_lib/buildFormatLongFn/index.js":"e7vuN","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"e7vuN":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>buildFormatLongFn);
function buildFormatLongFn(args) {
    return function() {
        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        // TODO: Remove String()
        var width = options.width ? String(options.width) : args.defaultWidth;
        var format = args.formats[width] || args.formats[args.defaultWidth];
        return format;
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"aj0u7":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatRelativeLocale = {
    lastWeek: "'last' eeee 'at' p",
    yesterday: "'yesterday at' p",
    today: "'today at' p",
    tomorrow: "'tomorrow at' p",
    nextWeek: "eeee 'at' p",
    other: "P"
};
var formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return formatRelativeLocale[token];
};
exports.default = formatRelative;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"bIlNU":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildLocalizeFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var eraValues = {
    narrow: [
        "B",
        "A"
    ],
    abbreviated: [
        "BC",
        "AD"
    ],
    wide: [
        "Before Christ",
        "Anno Domini"
    ]
};
var quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "Q1",
        "Q2",
        "Q3",
        "Q4"
    ],
    wide: [
        "1st quarter",
        "2nd quarter",
        "3rd quarter",
        "4th quarter"
    ]
};
// Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
var monthValues = {
    narrow: [
        "J",
        "F",
        "M",
        "A",
        "M",
        "J",
        "J",
        "A",
        "S",
        "O",
        "N",
        "D"
    ],
    abbreviated: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec"
    ],
    wide: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
    ]
};
var dayValues = {
    narrow: [
        "S",
        "M",
        "T",
        "W",
        "T",
        "F",
        "S"
    ],
    short: [
        "Su",
        "Mo",
        "Tu",
        "We",
        "Th",
        "Fr",
        "Sa"
    ],
    abbreviated: [
        "Sun",
        "Mon",
        "Tue",
        "Wed",
        "Thu",
        "Fri",
        "Sat"
    ],
    wide: [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday"
    ]
};
var dayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "mi",
        noon: "n",
        morning: "morning",
        afternoon: "afternoon",
        evening: "evening",
        night: "night"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "midnight",
        noon: "noon",
        morning: "morning",
        afternoon: "afternoon",
        evening: "evening",
        night: "night"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "midnight",
        noon: "noon",
        morning: "morning",
        afternoon: "afternoon",
        evening: "evening",
        night: "night"
    }
};
var formattingDayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "mi",
        noon: "n",
        morning: "in the morning",
        afternoon: "in the afternoon",
        evening: "in the evening",
        night: "at night"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "midnight",
        noon: "noon",
        morning: "in the morning",
        afternoon: "in the afternoon",
        evening: "in the evening",
        night: "at night"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "midnight",
        noon: "noon",
        morning: "in the morning",
        afternoon: "in the afternoon",
        evening: "in the evening",
        night: "at night"
    }
};
var ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    // If ordinal numbers depend on context, for example,
    // if they are different for different grammatical genders,
    // use `options.unit`.
    //
    // `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
    // 'day', 'hour', 'minute', 'second'.
    var rem100 = number % 100;
    if (rem100 > 20 || rem100 < 10) switch(rem100 % 10){
        case 1:
            return number + "st";
        case 2:
            return number + "nd";
        case 3:
            return number + "rd";
    }
    return number + "th";
};
var localize = {
    ordinalNumber: ordinalNumber,
    era: (0, _indexJsDefault.default)({
        values: eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, _indexJsDefault.default)({
        values: quarterValues,
        defaultWidth: "wide",
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        values: monthValues,
        defaultWidth: "wide"
    }),
    day: (0, _indexJsDefault.default)({
        values: dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        values: dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};
exports.default = localize;

},{"../../../_lib/buildLocalizeFn/index.js":"5xuBA","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"5xuBA":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>buildLocalizeFn);
function buildLocalizeFn(args) {
    return function(dirtyIndex, options) {
        var context = options !== null && options !== void 0 && options.context ? String(options.context) : "standalone";
        var valuesArray;
        if (context === "formatting" && args.formattingValues) {
            var defaultWidth = args.defaultFormattingWidth || args.defaultWidth;
            var width = options !== null && options !== void 0 && options.width ? String(options.width) : defaultWidth;
            valuesArray = args.formattingValues[width] || args.formattingValues[defaultWidth];
        } else {
            var _defaultWidth = args.defaultWidth;
            var _width = options !== null && options !== void 0 && options.width ? String(options.width) : args.defaultWidth;
            valuesArray = args.values[_width] || args.values[_defaultWidth];
        }
        var index = args.argumentCallback ? args.argumentCallback(dirtyIndex) : dirtyIndex;
        // @ts-ignore: For some reason TypeScript just don't want to match it, no matter how hard we try. I challenge you to try to remove it!
        return valuesArray[index];
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1C8qi":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildMatchFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../../../_lib/buildMatchPatternFn/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
    narrow: /^(b|a)/i,
    abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
    wide: /^(before christ|before common era|anno domini|common era)/i
};
var parseEraPatterns = {
    any: [
        /^b/i,
        /^(a|c)/i
    ]
};
var matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234](th|st|nd|rd)? quarter/i
};
var parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
    wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
};
var parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^may/i,
        /^jun/i,
        /^jul/i,
        /^au/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var matchDayPatterns = {
    narrow: /^[smtwf]/i,
    short: /^(su|mo|tu|we|th|fr|sa)/i,
    abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
    wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
};
var parseDayPatterns = {
    narrow: [
        /^s/i,
        /^m/i,
        /^t/i,
        /^w/i,
        /^t/i,
        /^f/i,
        /^s/i
    ],
    any: [
        /^su/i,
        /^m/i,
        /^tu/i,
        /^w/i,
        /^th/i,
        /^f/i,
        /^sa/i
    ]
};
var matchDayPeriodPatterns = {
    narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
    any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
};
var parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^mi/i,
        noon: /^no/i,
        morning: /morning/i,
        afternoon: /afternoon/i,
        evening: /evening/i,
        night: /night/i
    }
};
var match = {
    ordinalNumber: (0, _indexJsDefault1.default)({
        matchPattern: matchOrdinalNumberPattern,
        parsePattern: parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, _indexJsDefault.default)({
        matchPatterns: matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, _indexJsDefault.default)({
        matchPatterns: matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        matchPatterns: matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};
exports.default = match;

},{"../../../_lib/buildMatchFn/index.js":"gzaTz","../../../_lib/buildMatchPatternFn/index.js":"5bSIO","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"gzaTz":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>buildMatchFn);
function buildMatchFn(args) {
    return function(string) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var width = options.width;
        var matchPattern = width && args.matchPatterns[width] || args.matchPatterns[args.defaultMatchWidth];
        var matchResult = string.match(matchPattern);
        if (!matchResult) return null;
        var matchedString = matchResult[0];
        var parsePatterns = width && args.parsePatterns[width] || args.parsePatterns[args.defaultParseWidth];
        var key = Array.isArray(parsePatterns) ? findIndex(parsePatterns, function(pattern) {
            return pattern.test(matchedString);
        }) : findKey(parsePatterns, function(pattern) {
            return pattern.test(matchedString);
        });
        var value;
        value = args.valueCallback ? args.valueCallback(key) : key;
        value = options.valueCallback ? options.valueCallback(value) : value;
        var rest = string.slice(matchedString.length);
        return {
            value: value,
            rest: rest
        };
    };
}
function findKey(object, predicate) {
    for(var key in object){
        if (object.hasOwnProperty(key) && predicate(object[key])) return key;
    }
    return undefined;
}
function findIndex(array, predicate) {
    for(var key = 0; key < array.length; key++){
        if (predicate(array[key])) return key;
    }
    return undefined;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"5bSIO":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>buildMatchPatternFn);
function buildMatchPatternFn(args) {
    return function(string) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var matchResult = string.match(args.matchPattern);
        if (!matchResult) return null;
        var matchedString = matchResult[0];
        var parseResult = string.match(args.parsePattern);
        if (!parseResult) return null;
        var value = args.valueCallback ? args.valueCallback(parseResult[0]) : parseResult[0];
        value = options.valueCallback ? options.valueCallback(value) : value;
        var rest = string.slice(matchedString.length);
        return {
            value: value,
            rest: rest
        };
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6lKBe":[function(require,module,exports) {
"use strict";
function _typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") _typeof = function _typeof(obj) {
        return typeof obj;
    };
    else _typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return _typeof(obj);
}
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("2a8abeca5759e09f"));
var _propTypes = _interopRequireDefault(require("b3a77477a681f1fe"));
var _DayCell = _interopRequireWildcard(require("b5d64ffbd0c5e971"));
var _eachDayOfInterval = _interopRequireDefault(require("ffe647168d9b9efb"));
var _isWithinInterval = _interopRequireDefault(require("8248f7c39f23c2e9"));
var _isWeekend = _interopRequireDefault(require("21e3ca8cfeb9fa74"));
var _isAfter = _interopRequireDefault(require("b1905e3fe1e30bc5"));
var _isSameDay = _interopRequireDefault(require("5cd6047a8cb98fc4"));
var _isBefore = _interopRequireDefault(require("101f8c69638a4316"));
var _endOfWeek = _interopRequireDefault(require("98e37c4d130136a2"));
var _startOfWeek = _interopRequireDefault(require("97683bf6bf304d49"));
var _endOfDay = _interopRequireDefault(require("59fcdb0790a30ca3"));
var _startOfDay = _interopRequireDefault(require("33a27506c23db61f"));
var _format = _interopRequireDefault(require("f6af88c6e535257"));
var _utils = require("b8e5d8f833363158");
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) ownKeys(Object(source), true).forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return _possibleConstructorReturn(this, result);
    };
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) return call;
    return _assertThisInitialized(self);
}
function _assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function renderWeekdays(styles, dateOptions, weekdayDisplayFormat) {
    var now = new Date();
    return /*#__PURE__*/ _react.default.createElement("div", {
        className: styles.weekDays
    }, (0, _eachDayOfInterval.default)({
        start: (0, _startOfWeek.default)(now, dateOptions),
        end: (0, _endOfWeek.default)(now, dateOptions)
    }).map(function(day, i) {
        return /*#__PURE__*/ _react.default.createElement("span", {
            className: styles.weekDay,
            key: i
        }, (0, _format.default)(day, weekdayDisplayFormat, dateOptions));
    }));
}
var Month = /*#__PURE__*/ function(_PureComponent) {
    _inherits(Month, _PureComponent);
    var _super = _createSuper(Month);
    function Month() {
        _classCallCheck(this, Month);
        return _super.apply(this, arguments);
    }
    _createClass(Month, [
        {
            key: "render",
            value: function render() {
                var _this = this;
                var now = new Date();
                var _this$props = this.props, displayMode = _this$props.displayMode, focusedRange = _this$props.focusedRange, drag = _this$props.drag, styles = _this$props.styles, disabledDates = _this$props.disabledDates, disabledDay = _this$props.disabledDay;
                var minDate = this.props.minDate && (0, _startOfDay.default)(this.props.minDate);
                var maxDate = this.props.maxDate && (0, _endOfDay.default)(this.props.maxDate);
                var monthDisplay = (0, _utils.getMonthDisplayRange)(this.props.month, this.props.dateOptions, this.props.fixedHeight);
                var ranges = this.props.ranges;
                if (displayMode === "dateRange" && drag.status) {
                    var _drag$range = drag.range, startDate = _drag$range.startDate, endDate = _drag$range.endDate;
                    ranges = ranges.map(function(range, i) {
                        if (i !== focusedRange[0]) return range;
                        return _objectSpread(_objectSpread({}, range), {}, {
                            startDate: startDate,
                            endDate: endDate
                        });
                    });
                }
                var showPreview = this.props.showPreview && !drag.disablePreview;
                return /*#__PURE__*/ _react.default.createElement("div", {
                    className: styles.month,
                    style: this.props.style
                }, this.props.showMonthName ? /*#__PURE__*/ _react.default.createElement("div", {
                    className: styles.monthName
                }, (0, _format.default)(this.props.month, this.props.monthDisplayFormat, this.props.dateOptions)) : null, this.props.showWeekDays && renderWeekdays(styles, this.props.dateOptions, this.props.weekdayDisplayFormat), /*#__PURE__*/ _react.default.createElement("div", {
                    className: styles.days,
                    onMouseLeave: this.props.onMouseLeave
                }, (0, _eachDayOfInterval.default)({
                    start: monthDisplay.start,
                    end: monthDisplay.end
                }).map(function(day, index) {
                    var isStartOfMonth = (0, _isSameDay.default)(day, monthDisplay.startDateOfMonth);
                    var isEndOfMonth = (0, _isSameDay.default)(day, monthDisplay.endDateOfMonth);
                    var isOutsideMinMax = minDate && (0, _isBefore.default)(day, minDate) || maxDate && (0, _isAfter.default)(day, maxDate);
                    var isDisabledSpecifically = disabledDates.some(function(disabledDate) {
                        return (0, _isSameDay.default)(disabledDate, day);
                    });
                    var isDisabledDay = disabledDay(day);
                    return /*#__PURE__*/ _react.default.createElement(_DayCell.default, _extends({}, _this.props, {
                        ranges: ranges,
                        day: day,
                        preview: showPreview ? _this.props.preview : null,
                        isWeekend: (0, _isWeekend.default)(day, _this.props.dateOptions),
                        isToday: (0, _isSameDay.default)(day, now),
                        isStartOfWeek: (0, _isSameDay.default)(day, (0, _startOfWeek.default)(day, _this.props.dateOptions)),
                        isEndOfWeek: (0, _isSameDay.default)(day, (0, _endOfWeek.default)(day, _this.props.dateOptions)),
                        isStartOfMonth: isStartOfMonth,
                        isEndOfMonth: isEndOfMonth,
                        key: index,
                        disabled: isOutsideMinMax || isDisabledSpecifically || isDisabledDay,
                        isPassive: !(0, _isWithinInterval.default)(day, {
                            start: monthDisplay.startDateOfMonth,
                            end: monthDisplay.endDateOfMonth
                        }),
                        styles: styles,
                        onMouseDown: _this.props.onDragSelectionStart,
                        onMouseUp: _this.props.onDragSelectionEnd,
                        onMouseEnter: _this.props.onDragSelectionMove,
                        dragRange: drag.range,
                        drag: drag.status
                    }));
                })));
            }
        }
    ]);
    return Month;
}(_react.PureComponent);
Month.defaultProps = {};
Month.propTypes = {
    style: _propTypes.default.object,
    styles: _propTypes.default.object,
    month: _propTypes.default.object,
    drag: _propTypes.default.object,
    dateOptions: _propTypes.default.object,
    disabledDates: _propTypes.default.array,
    disabledDay: _propTypes.default.func,
    preview: _propTypes.default.shape({
        startDate: _propTypes.default.object,
        endDate: _propTypes.default.object
    }),
    showPreview: _propTypes.default.bool,
    displayMode: _propTypes.default.oneOf([
        "dateRange",
        "date"
    ]),
    minDate: _propTypes.default.object,
    maxDate: _propTypes.default.object,
    ranges: _propTypes.default.arrayOf(_DayCell.rangeShape),
    focusedRange: _propTypes.default.arrayOf(_propTypes.default.number),
    onDragSelectionStart: _propTypes.default.func,
    onDragSelectionEnd: _propTypes.default.func,
    onDragSelectionMove: _propTypes.default.func,
    onMouseLeave: _propTypes.default.func,
    monthDisplayFormat: _propTypes.default.string,
    weekdayDisplayFormat: _propTypes.default.string,
    dayDisplayFormat: _propTypes.default.string,
    showWeekDays: _propTypes.default.bool,
    showMonthName: _propTypes.default.bool,
    fixedHeight: _propTypes.default.bool
};
var _default = Month;
exports.default = _default;

},{"2a8abeca5759e09f":"6uln9","b3a77477a681f1fe":"6FKs7","b5d64ffbd0c5e971":"8U3Bs","ffe647168d9b9efb":"iGmwl","8248f7c39f23c2e9":"fYupW","21e3ca8cfeb9fa74":"gQMWr","b1905e3fe1e30bc5":"kUiIh","5cd6047a8cb98fc4":"zixuD","101f8c69638a4316":"d6hvx","98e37c4d130136a2":"1dSZs","97683bf6bf304d49":"5iVAO","59fcdb0790a30ca3":"4Dc68","33a27506c23db61f":"3ImQM","f6af88c6e535257":"3AQSq","b8e5d8f833363158":"6TTND"}],"iGmwl":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>eachDayOfInterval);
var _indexJs = require("../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
function eachDayOfInterval(dirtyInterval, options) {
    var _options$step;
    (0, _indexJsDefault1.default)(1, arguments);
    var interval = dirtyInterval || {};
    var startDate = (0, _indexJsDefault.default)(interval.start);
    var endDate = (0, _indexJsDefault.default)(interval.end);
    var endTime = endDate.getTime();
    // Throw an exception if start date is after end date or if any date is `Invalid Date`
    if (!(startDate.getTime() <= endTime)) throw new RangeError("Invalid interval");
    var dates = [];
    var currentDate = startDate;
    currentDate.setHours(0, 0, 0, 0);
    var step = Number((_options$step = options === null || options === void 0 ? void 0 : options.step) !== null && _options$step !== void 0 ? _options$step : 1);
    if (step < 1 || isNaN(step)) throw new RangeError("`options.step` must be a number greater than 1");
    while(currentDate.getTime() <= endTime){
        dates.push((0, _indexJsDefault.default)(currentDate));
        currentDate.setDate(currentDate.getDate() + step);
        currentDate.setHours(0, 0, 0, 0);
    }
    return dates;
}

},{"../toDate/index.js":"fYDr6","../_lib/requiredArgs/index.js":"180ox","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"fYupW":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>isWithinInterval);
var _indexJs = require("../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
function isWithinInterval(dirtyDate, interval) {
    (0, _indexJsDefault1.default)(2, arguments);
    var time = (0, _indexJsDefault.default)(dirtyDate).getTime();
    var startTime = (0, _indexJsDefault.default)(interval.start).getTime();
    var endTime = (0, _indexJsDefault.default)(interval.end).getTime();
    // Throw an exception if start date is after end date or if any date is `Invalid Date`
    if (!(startTime <= endTime)) throw new RangeError("Invalid interval");
    return time >= startTime && time <= endTime;
}

},{"../toDate/index.js":"fYDr6","../_lib/requiredArgs/index.js":"180ox","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"gQMWr":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>isWeekend);
var _indexJs = require("../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
function isWeekend(dirtyDate) {
    (0, _indexJsDefault1.default)(1, arguments);
    var date = (0, _indexJsDefault.default)(dirtyDate);
    var day = date.getDay();
    return day === 0 || day === 6;
}

},{"../toDate/index.js":"fYDr6","../_lib/requiredArgs/index.js":"180ox","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1dSZs":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>endOfWeek);
var _indexJs = require("../_lib/defaultOptions/index.js");
var _indexJs1 = require("../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../_lib/toInteger/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs3);
function endOfWeek(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, _indexJsDefault2.default)(1, arguments);
    var defaultOptions = (0, _indexJs.getDefaultOptions)();
    var weekStartsOn = (0, _indexJsDefault1.default)((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0);
    // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
    var date = (0, _indexJsDefault.default)(dirtyDate);
    var day = date.getDay();
    var diff = (day < weekStartsOn ? -7 : 0) + 6 - (day - weekStartsOn);
    date.setDate(date.getDate() + diff);
    date.setHours(23, 59, 59, 999);
    return date;
}

},{"../_lib/defaultOptions/index.js":"j28dB","../toDate/index.js":"fYDr6","../_lib/toInteger/index.js":"fgaQ2","../_lib/requiredArgs/index.js":"180ox","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"5iVAO":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>startOfWeek);
var _indexJs = require("../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/toInteger/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("../_lib/defaultOptions/index.js");
function startOfWeek(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, _indexJsDefault2.default)(1, arguments);
    var defaultOptions = (0, _indexJs3.getDefaultOptions)();
    var weekStartsOn = (0, _indexJsDefault1.default)((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0);
    // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
    var date = (0, _indexJsDefault.default)(dirtyDate);
    var day = date.getDay();
    var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
    date.setDate(date.getDate() - diff);
    date.setHours(0, 0, 0, 0);
    return date;
}

},{"../toDate/index.js":"fYDr6","../_lib/toInteger/index.js":"fgaQ2","../_lib/requiredArgs/index.js":"180ox","../_lib/defaultOptions/index.js":"j28dB","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6TTND":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.calcFocusDate = calcFocusDate;
exports.findNextRangeIndex = findNextRangeIndex;
exports.getMonthDisplayRange = getMonthDisplayRange;
exports.generateStyles = generateStyles;
var _classnames = _interopRequireDefault(require("d7e6f256cf11458"));
var _addDays = _interopRequireDefault(require("c001cd2ab2d7e599"));
var _differenceInCalendarMonths = _interopRequireDefault(require("323ed8a532227865"));
var _differenceInCalendarDays = _interopRequireDefault(require("c42860e6fc05eed0"));
var _endOfWeek = _interopRequireDefault(require("1d0d680e88c2ca97"));
var _startOfWeek = _interopRequireDefault(require("6e8048113c91ac5b"));
var _endOfMonth = _interopRequireDefault(require("743540ee23a54cea"));
var _startOfMonth = _interopRequireDefault(require("97c9b08518b90c3f"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function calcFocusDate(currentFocusedDate, props) {
    var shownDate = props.shownDate, date = props.date, months = props.months, ranges = props.ranges, focusedRange = props.focusedRange, displayMode = props.displayMode; // find primary date according the props
    var targetInterval;
    if (displayMode === "dateRange") {
        var range = ranges[focusedRange[0]] || {};
        targetInterval = {
            start: range.startDate,
            end: range.endDate
        };
    } else targetInterval = {
        start: date,
        end: date
    };
    targetInterval.start = (0, _startOfMonth.default)(targetInterval.start || new Date());
    targetInterval.end = (0, _endOfMonth.default)(targetInterval.end || targetInterval.start);
    var targetDate = targetInterval.start || targetInterval.end || shownDate || new Date(); // initial focus
    if (!currentFocusedDate) return shownDate || targetDate; // // just return targetDate for native scrolled calendars
    // if (props.scroll.enabled) return targetDate;
    if ((0, _differenceInCalendarMonths.default)(targetInterval.start, targetInterval.end) > months) // don't change focused if new selection in view area
    return currentFocusedDate;
    return targetDate;
}
function findNextRangeIndex(ranges) {
    var currentRangeIndex = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : -1;
    var nextIndex = ranges.findIndex(function(range, i) {
        return i > currentRangeIndex && range.autoFocus !== false && !range.disabled;
    });
    if (nextIndex !== -1) return nextIndex;
    return ranges.findIndex(function(range) {
        return range.autoFocus !== false && !range.disabled;
    });
}
function getMonthDisplayRange(date, dateOptions, fixedHeight) {
    var startDateOfMonth = (0, _startOfMonth.default)(date, dateOptions);
    var endDateOfMonth = (0, _endOfMonth.default)(date, dateOptions);
    var startDateOfCalendar = (0, _startOfWeek.default)(startDateOfMonth, dateOptions);
    var endDateOfCalendar = (0, _endOfWeek.default)(endDateOfMonth, dateOptions);
    if (fixedHeight && (0, _differenceInCalendarDays.default)(endDateOfCalendar, startDateOfCalendar) <= 34) endDateOfCalendar = (0, _addDays.default)(endDateOfCalendar, 7);
    return {
        start: startDateOfCalendar,
        end: endDateOfCalendar,
        startDateOfMonth: startDateOfMonth,
        endDateOfMonth: endDateOfMonth
    };
}
function generateStyles(sources) {
    if (!sources.length) return {};
    var generatedStyles = sources.filter(function(source) {
        return Boolean(source);
    }).reduce(function(styles, styleSource) {
        Object.keys(styleSource).forEach(function(key) {
            styles[key] = (0, _classnames.default)(styles[key], styleSource[key]);
        });
        return styles;
    }, {});
    return generatedStyles;
}

},{"d7e6f256cf11458":"hVGzI","c001cd2ab2d7e599":"gh2CN","323ed8a532227865":"hXq92","c42860e6fc05eed0":"kfTvM","1d0d680e88c2ca97":"1dSZs","6e8048113c91ac5b":"5iVAO","743540ee23a54cea":"fMDiz","97c9b08518b90c3f":"j9jcE"}],"gh2CN":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>addDays);
var _indexJs = require("../_lib/toInteger/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../toDate/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
function addDays(dirtyDate, dirtyAmount) {
    (0, _indexJsDefault2.default)(2, arguments);
    var date = (0, _indexJsDefault1.default)(dirtyDate);
    var amount = (0, _indexJsDefault.default)(dirtyAmount);
    if (isNaN(amount)) return new Date(NaN);
    if (!amount) // If 0 days, no-op to avoid changing times in the hour before end of DST
    return date;
    date.setDate(date.getDate() + amount);
    return date;
}

},{"../_lib/toInteger/index.js":"fgaQ2","../toDate/index.js":"fYDr6","../_lib/requiredArgs/index.js":"180ox","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hXq92":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>differenceInCalendarMonths);
var _indexJs = require("../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
function differenceInCalendarMonths(dirtyDateLeft, dirtyDateRight) {
    (0, _indexJsDefault1.default)(2, arguments);
    var dateLeft = (0, _indexJsDefault.default)(dirtyDateLeft);
    var dateRight = (0, _indexJsDefault.default)(dirtyDateRight);
    var yearDiff = dateLeft.getFullYear() - dateRight.getFullYear();
    var monthDiff = dateLeft.getMonth() - dateRight.getMonth();
    return yearDiff * 12 + monthDiff;
}

},{"../toDate/index.js":"fYDr6","../_lib/requiredArgs/index.js":"180ox","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"kfTvM":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>differenceInCalendarDays);
var _indexJs = require("../_lib/getTimezoneOffsetInMilliseconds/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../startOfDay/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var MILLISECONDS_IN_DAY = 86400000;
function differenceInCalendarDays(dirtyDateLeft, dirtyDateRight) {
    (0, _indexJsDefault2.default)(2, arguments);
    var startOfDayLeft = (0, _indexJsDefault1.default)(dirtyDateLeft);
    var startOfDayRight = (0, _indexJsDefault1.default)(dirtyDateRight);
    var timestampLeft = startOfDayLeft.getTime() - (0, _indexJsDefault.default)(startOfDayLeft);
    var timestampRight = startOfDayRight.getTime() - (0, _indexJsDefault.default)(startOfDayRight);
    // Round the number of days to the nearest integer
    // because the number of milliseconds in a day is not constant
    // (e.g. it's different in the day of the daylight saving time clock shift)
    return Math.round((timestampLeft - timestampRight) / MILLISECONDS_IN_DAY);
}

},{"../_lib/getTimezoneOffsetInMilliseconds/index.js":"fAihR","../startOfDay/index.js":"3ImQM","../_lib/requiredArgs/index.js":"180ox","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"fMDiz":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>endOfMonth);
var _indexJs = require("../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
function endOfMonth(dirtyDate) {
    (0, _indexJsDefault1.default)(1, arguments);
    var date = (0, _indexJsDefault.default)(dirtyDate);
    var month = date.getMonth();
    date.setFullYear(date.getFullYear(), month + 1, 0);
    date.setHours(23, 59, 59, 999);
    return date;
}

},{"../toDate/index.js":"fYDr6","../_lib/requiredArgs/index.js":"180ox","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"j9jcE":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>startOfMonth);
var _indexJs = require("../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
function startOfMonth(dirtyDate) {
    (0, _indexJsDefault1.default)(1, arguments);
    var date = (0, _indexJsDefault.default)(dirtyDate);
    date.setDate(1);
    date.setHours(0, 0, 0, 0);
    return date;
}

},{"../toDate/index.js":"fYDr6","../_lib/requiredArgs/index.js":"180ox","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"cMacC":[function(require,module,exports) {
"use strict";
function _typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") _typeof = function _typeof(obj) {
        return typeof obj;
    };
    else _typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return _typeof(obj);
}
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("b5ef8c2024052fe8"));
var _propTypes = _interopRequireDefault(require("8beb8f81195e1f45"));
var _classnames = _interopRequireDefault(require("c7190ce596935468"));
var _isEqual = _interopRequireDefault(require("dc316798f4b32a8a"));
var _isValid = _interopRequireDefault(require("becaa34ccd225867"));
var _parse = _interopRequireDefault(require("98e3eeed2c043824"));
var _format = _interopRequireDefault(require("69398b5ef81f0e9a"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return _possibleConstructorReturn(this, result);
    };
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) return call;
    return _assertThisInitialized(self);
}
function _assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var DateInput = /*#__PURE__*/ function(_PureComponent) {
    _inherits(DateInput, _PureComponent);
    var _super = _createSuper(DateInput);
    function DateInput(props, context) {
        var _this;
        _classCallCheck(this, DateInput);
        _this = _super.call(this, props, context);
        _defineProperty(_assertThisInitialized(_this), "onKeyDown", function(e) {
            var value = _this.state.value;
            if (e.key === "Enter") _this.update(value);
        });
        _defineProperty(_assertThisInitialized(_this), "onChange", function(e) {
            _this.setState({
                value: e.target.value,
                changed: true,
                invalid: false
            });
        });
        _defineProperty(_assertThisInitialized(_this), "onBlur", function() {
            var value = _this.state.value;
            _this.update(value);
        });
        _this.state = {
            invalid: false,
            changed: false,
            value: _this.formatDate(props)
        };
        return _this;
    }
    _createClass(DateInput, [
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps) {
                var value = prevProps.value;
                if (!(0, _isEqual.default)(value, this.props.value)) this.setState({
                    value: this.formatDate(this.props)
                });
            }
        },
        {
            key: "formatDate",
            value: function formatDate(_ref) {
                var value = _ref.value, dateDisplayFormat = _ref.dateDisplayFormat, dateOptions = _ref.dateOptions;
                if (value && (0, _isValid.default)(value)) return (0, _format.default)(value, dateDisplayFormat, dateOptions);
                return "";
            }
        },
        {
            key: "update",
            value: function update(value) {
                var _this$state = this.state, invalid = _this$state.invalid, changed = _this$state.changed;
                if (invalid || !changed || !value) return;
                var _this$props = this.props, onChange = _this$props.onChange, dateDisplayFormat = _this$props.dateDisplayFormat, dateOptions = _this$props.dateOptions;
                var parsed = (0, _parse.default)(value, dateDisplayFormat, new Date(), dateOptions);
                if ((0, _isValid.default)(parsed)) this.setState({
                    changed: false
                }, function() {
                    return onChange(parsed);
                });
                else this.setState({
                    invalid: true
                });
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$props2 = this.props, className = _this$props2.className, readOnly = _this$props2.readOnly, placeholder = _this$props2.placeholder, ariaLabel = _this$props2.ariaLabel, disabled = _this$props2.disabled, onFocus = _this$props2.onFocus;
                var _this$state2 = this.state, value = _this$state2.value, invalid = _this$state2.invalid;
                return /*#__PURE__*/ _react.default.createElement("span", {
                    className: (0, _classnames.default)("rdrDateInput", className)
                }, /*#__PURE__*/ _react.default.createElement("input", {
                    readOnly: readOnly,
                    disabled: disabled,
                    value: value,
                    placeholder: placeholder,
                    "aria-label": ariaLabel,
                    onKeyDown: this.onKeyDown,
                    onChange: this.onChange,
                    onBlur: this.onBlur,
                    onFocus: onFocus
                }), invalid && /*#__PURE__*/ _react.default.createElement("span", {
                    className: "rdrWarning"
                }, "⚠"));
            }
        }
    ]);
    return DateInput;
}(_react.PureComponent);
DateInput.propTypes = {
    value: _propTypes.default.object,
    placeholder: _propTypes.default.string,
    disabled: _propTypes.default.bool,
    readOnly: _propTypes.default.bool,
    dateOptions: _propTypes.default.object,
    dateDisplayFormat: _propTypes.default.string,
    ariaLabel: _propTypes.default.string,
    className: _propTypes.default.string,
    onFocus: _propTypes.default.func.isRequired,
    onChange: _propTypes.default.func.isRequired
};
DateInput.defaultProps = {
    readOnly: true,
    disabled: false,
    dateDisplayFormat: "MMM D, YYYY"
};
var _default = DateInput;
exports.default = _default;

},{"b5ef8c2024052fe8":"6uln9","8beb8f81195e1f45":"6FKs7","c7190ce596935468":"hVGzI","dc316798f4b32a8a":"9oq5z","becaa34ccd225867":"iWjlu","98e3eeed2c043824":"ie2Pd","69398b5ef81f0e9a":"3AQSq"}],"9oq5z":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>isEqual);
var _indexJs = require("../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
function isEqual(dirtyLeftDate, dirtyRightDate) {
    (0, _indexJsDefault1.default)(2, arguments);
    var dateLeft = (0, _indexJsDefault.default)(dirtyLeftDate);
    var dateRight = (0, _indexJsDefault.default)(dirtyRightDate);
    return dateLeft.getTime() === dateRight.getTime();
}

},{"../toDate/index.js":"fYDr6","../_lib/requiredArgs/index.js":"180ox","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"ie2Pd":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>parse);
var _typeof = require("@babel/runtime/helpers/esm/typeof");
var _typeofDefault = parcelHelpers.interopDefault(_typeof);
var _createForOfIteratorHelper = require("@babel/runtime/helpers/esm/createForOfIteratorHelper");
var _createForOfIteratorHelperDefault = parcelHelpers.interopDefault(_createForOfIteratorHelper);
var _indexJs = require("../_lib/defaultLocale/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../subMilliseconds/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../toDate/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("../_lib/assign/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("../_lib/format/longFormatters/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
var _indexJs5 = require("../_lib/getTimezoneOffsetInMilliseconds/index.js");
var _indexJsDefault5 = parcelHelpers.interopDefault(_indexJs5);
var _indexJs6 = require("../_lib/protectedTokens/index.js");
var _indexJs7 = require("../_lib/toInteger/index.js");
var _indexJsDefault6 = parcelHelpers.interopDefault(_indexJs7);
var _indexJs8 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault7 = parcelHelpers.interopDefault(_indexJs8);
var _setterJs = require("./_lib/Setter.js");
var _indexJs9 = require("./_lib/parsers/index.js");
var _indexJs10 = require("../_lib/defaultOptions/index.js"); // This RegExp consists of three parts separated by `|`:
// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps
var formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;
// This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`
var longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
var escapedStringRegExp = /^'([^]*?)'?$/;
var doubleQuoteRegExp = /''/g;
var notWhitespaceRegExp = /\S/;
var unescapedLatinCharacterRegExp = /[a-zA-Z]/;
function parse(dirtyDateString, dirtyFormatString, dirtyReferenceDate, options) {
    var _ref, _options$locale, _ref2, _ref3, _ref4, _options$firstWeekCon, _options$locale2, _options$locale2$opti, _defaultOptions$local, _defaultOptions$local2, _ref5, _ref6, _ref7, _options$weekStartsOn, _options$locale3, _options$locale3$opti, _defaultOptions$local3, _defaultOptions$local4;
    (0, _indexJsDefault7.default)(3, arguments);
    var dateString = String(dirtyDateString);
    var formatString = String(dirtyFormatString);
    var defaultOptions = (0, _indexJs10.getDefaultOptions)();
    var locale = (_ref = (_options$locale = options === null || options === void 0 ? void 0 : options.locale) !== null && _options$locale !== void 0 ? _options$locale : defaultOptions.locale) !== null && _ref !== void 0 ? _ref : (0, _indexJsDefault.default);
    if (!locale.match) throw new RangeError("locale must contain match property");
    var firstWeekContainsDate = (0, _indexJsDefault6.default)((_ref2 = (_ref3 = (_ref4 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale2 = options.locale) === null || _options$locale2 === void 0 ? void 0 : (_options$locale2$opti = _options$locale2.options) === null || _options$locale2$opti === void 0 ? void 0 : _options$locale2$opti.firstWeekContainsDate) !== null && _ref4 !== void 0 ? _ref4 : defaultOptions.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : 1);
    // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
    if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
    var weekStartsOn = (0, _indexJsDefault6.default)((_ref5 = (_ref6 = (_ref7 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale3 = options.locale) === null || _options$locale3 === void 0 ? void 0 : (_options$locale3$opti = _options$locale3.options) === null || _options$locale3$opti === void 0 ? void 0 : _options$locale3$opti.weekStartsOn) !== null && _ref7 !== void 0 ? _ref7 : defaultOptions.weekStartsOn) !== null && _ref6 !== void 0 ? _ref6 : (_defaultOptions$local3 = defaultOptions.locale) === null || _defaultOptions$local3 === void 0 ? void 0 : (_defaultOptions$local4 = _defaultOptions$local3.options) === null || _defaultOptions$local4 === void 0 ? void 0 : _defaultOptions$local4.weekStartsOn) !== null && _ref5 !== void 0 ? _ref5 : 0);
    // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
    if (formatString === "") {
        if (dateString === "") return (0, _indexJsDefault2.default)(dirtyReferenceDate);
        else return new Date(NaN);
    }
    var subFnOptions = {
        firstWeekContainsDate: firstWeekContainsDate,
        weekStartsOn: weekStartsOn,
        locale: locale
    };
    // If timezone isn't specified, it will be set to the system timezone
    var setters = [
        new (0, _setterJs.DateToSystemTimezoneSetter)()
    ];
    var tokens = formatString.match(longFormattingTokensRegExp).map(function(substring) {
        var firstCharacter = substring[0];
        if (firstCharacter in (0, _indexJsDefault4.default)) {
            var longFormatter = (0, _indexJsDefault4.default)[firstCharacter];
            return longFormatter(substring, locale.formatLong);
        }
        return substring;
    }).join("").match(formattingTokensRegExp);
    var usedTokens = [];
    var _iterator = (0, _createForOfIteratorHelperDefault.default)(tokens), _step;
    try {
        var _loop = function _loop() {
            var token = _step.value;
            if (!(options !== null && options !== void 0 && options.useAdditionalWeekYearTokens) && (0, _indexJs6.isProtectedWeekYearToken)(token)) (0, _indexJs6.throwProtectedError)(token, formatString, dirtyDateString);
            if (!(options !== null && options !== void 0 && options.useAdditionalDayOfYearTokens) && (0, _indexJs6.isProtectedDayOfYearToken)(token)) (0, _indexJs6.throwProtectedError)(token, formatString, dirtyDateString);
            var firstCharacter = token[0];
            var parser = (0, _indexJs9.parsers)[firstCharacter];
            if (parser) {
                var incompatibleTokens = parser.incompatibleTokens;
                if (Array.isArray(incompatibleTokens)) {
                    var incompatibleToken = usedTokens.find(function(usedToken) {
                        return incompatibleTokens.includes(usedToken.token) || usedToken.token === firstCharacter;
                    });
                    if (incompatibleToken) throw new RangeError("The format string mustn't contain `".concat(incompatibleToken.fullToken, "` and `").concat(token, "` at the same time"));
                } else if (parser.incompatibleTokens === "*" && usedTokens.length > 0) throw new RangeError("The format string mustn't contain `".concat(token, "` and any other token at the same time"));
                usedTokens.push({
                    token: firstCharacter,
                    fullToken: token
                });
                var parseResult = parser.run(dateString, token, locale.match, subFnOptions);
                if (!parseResult) return {
                    v: new Date(NaN)
                };
                setters.push(parseResult.setter);
                dateString = parseResult.rest;
            } else {
                if (firstCharacter.match(unescapedLatinCharacterRegExp)) throw new RangeError("Format string contains an unescaped latin alphabet character `" + firstCharacter + "`");
                // Replace two single quote characters with one single quote character
                if (token === "''") token = "'";
                else if (firstCharacter === "'") token = cleanEscapedString(token);
                // Cut token from string, or, if string doesn't match the token, return Invalid Date
                if (dateString.indexOf(token) === 0) dateString = dateString.slice(token.length);
                else return {
                    v: new Date(NaN)
                };
            }
        };
        for(_iterator.s(); !(_step = _iterator.n()).done;){
            var _ret = _loop();
            if ((0, _typeofDefault.default)(_ret) === "object") return _ret.v;
        }
    // Check if the remaining input contains something other than whitespace
    } catch (err) {
        _iterator.e(err);
    } finally{
        _iterator.f();
    }
    if (dateString.length > 0 && notWhitespaceRegExp.test(dateString)) return new Date(NaN);
    var uniquePrioritySetters = setters.map(function(setter) {
        return setter.priority;
    }).sort(function(a, b) {
        return b - a;
    }).filter(function(priority, index, array) {
        return array.indexOf(priority) === index;
    }).map(function(priority) {
        return setters.filter(function(setter) {
            return setter.priority === priority;
        }).sort(function(a, b) {
            return b.subPriority - a.subPriority;
        });
    }).map(function(setterArray) {
        return setterArray[0];
    });
    var date = (0, _indexJsDefault2.default)(dirtyReferenceDate);
    if (isNaN(date.getTime())) return new Date(NaN);
    // Convert the date in system timezone to the same date in UTC+00:00 timezone.
    var utcDate = (0, _indexJsDefault1.default)(date, (0, _indexJsDefault5.default)(date));
    var flags = {};
    var _iterator2 = (0, _createForOfIteratorHelperDefault.default)(uniquePrioritySetters), _step2;
    try {
        for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
            var setter = _step2.value;
            if (!setter.validate(utcDate, subFnOptions)) return new Date(NaN);
            var result = setter.set(utcDate, flags, subFnOptions);
            // Result is tuple (date, flags)
            if (Array.isArray(result)) {
                utcDate = result[0];
                (0, _indexJsDefault3.default)(flags, result[1]);
            // Result is date
            } else utcDate = result;
        }
    } catch (err) {
        _iterator2.e(err);
    } finally{
        _iterator2.f();
    }
    return utcDate;
}
function cleanEscapedString(input) {
    return input.match(escapedStringRegExp)[1].replace(doubleQuoteRegExp, "'");
}

},{"@babel/runtime/helpers/esm/typeof":"4ZfJH","@babel/runtime/helpers/esm/createForOfIteratorHelper":"lBltn","../_lib/defaultLocale/index.js":"fj9oT","../subMilliseconds/index.js":"16tPB","../toDate/index.js":"fYDr6","../_lib/assign/index.js":"gzdO7","../_lib/format/longFormatters/index.js":"hOFhU","../_lib/getTimezoneOffsetInMilliseconds/index.js":"fAihR","../_lib/protectedTokens/index.js":"cQJLO","../_lib/toInteger/index.js":"fgaQ2","../_lib/requiredArgs/index.js":"180ox","./_lib/Setter.js":"e4ESz","./_lib/parsers/index.js":"anRHj","../_lib/defaultOptions/index.js":"j28dB","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"lBltn":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_createForOfIteratorHelper);
var _unsupportedIterableToArrayJs = require("./unsupportedIterableToArray.js");
var _unsupportedIterableToArrayJsDefault = parcelHelpers.interopDefault(_unsupportedIterableToArrayJs);
function _createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = (0, _unsupportedIterableToArrayJsDefault.default)(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t["return"] || t["return"]();
            } finally{
                if (u) throw o;
            }
        }
    };
}

},{"./unsupportedIterableToArray.js":"ewY80","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"ewY80":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_unsupportedIterableToArray);
var _arrayLikeToArrayJs = require("./arrayLikeToArray.js");
var _arrayLikeToArrayJsDefault = parcelHelpers.interopDefault(_arrayLikeToArrayJs);
function _unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return (0, _arrayLikeToArrayJsDefault.default)(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? (0, _arrayLikeToArrayJsDefault.default)(r, a) : void 0;
    }
}

},{"./arrayLikeToArray.js":"9DDgo","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9DDgo":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_arrayLikeToArray);
function _arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"gzdO7":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>assign);
function assign(target, object) {
    if (target == null) throw new TypeError("assign requires that input parameter not be null or undefined");
    for(var property in object)if (Object.prototype.hasOwnProperty.call(object, property)) target[property] = object[property];
    return target;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"e4ESz":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Setter", ()=>Setter);
parcelHelpers.export(exports, "ValueSetter", ()=>ValueSetter);
parcelHelpers.export(exports, "DateToSystemTimezoneSetter", ()=>DateToSystemTimezoneSetter);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inherits = require("@babel/runtime/helpers/esm/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _createSuper = require("@babel/runtime/helpers/esm/createSuper");
var _createSuperDefault = parcelHelpers.interopDefault(_createSuper);
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var TIMEZONE_UNIT_PRIORITY = 10;
var Setter = /*#__PURE__*/ function() {
    function Setter() {
        (0, _classCallCheckDefault.default)(this, Setter);
        (0, _definePropertyDefault.default)(this, "priority", void 0);
        (0, _definePropertyDefault.default)(this, "subPriority", 0);
    }
    (0, _createClassDefault.default)(Setter, [
        {
            key: "validate",
            value: function validate(_utcDate, _options) {
                return true;
            }
        }
    ]);
    return Setter;
}();
var ValueSetter = /*#__PURE__*/ function(_Setter) {
    (0, _inheritsDefault.default)(ValueSetter, _Setter);
    var _super = (0, _createSuperDefault.default)(ValueSetter);
    function ValueSetter(value, validateValue, setValue, priority, subPriority) {
        var _this;
        (0, _classCallCheckDefault.default)(this, ValueSetter);
        _this = _super.call(this);
        _this.value = value;
        _this.validateValue = validateValue;
        _this.setValue = setValue;
        _this.priority = priority;
        if (subPriority) _this.subPriority = subPriority;
        return _this;
    }
    (0, _createClassDefault.default)(ValueSetter, [
        {
            key: "validate",
            value: function validate(utcDate, options) {
                return this.validateValue(utcDate, this.value, options);
            }
        },
        {
            key: "set",
            value: function set(utcDate, flags, options) {
                return this.setValue(utcDate, flags, this.value, options);
            }
        }
    ]);
    return ValueSetter;
}(Setter);
var DateToSystemTimezoneSetter = /*#__PURE__*/ function(_Setter2) {
    (0, _inheritsDefault.default)(DateToSystemTimezoneSetter, _Setter2);
    var _super2 = (0, _createSuperDefault.default)(DateToSystemTimezoneSetter);
    function DateToSystemTimezoneSetter() {
        var _this2;
        (0, _classCallCheckDefault.default)(this, DateToSystemTimezoneSetter);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this2 = _super2.call.apply(_super2, [
            this
        ].concat(args));
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this2), "priority", TIMEZONE_UNIT_PRIORITY);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this2), "subPriority", -1);
        return _this2;
    }
    (0, _createClassDefault.default)(DateToSystemTimezoneSetter, [
        {
            key: "set",
            value: function set(date, flags) {
                if (flags.timestampIsSet) return date;
                var convertedDate = new Date(0);
                convertedDate.setFullYear(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate());
                convertedDate.setHours(date.getUTCHours(), date.getUTCMinutes(), date.getUTCSeconds(), date.getUTCMilliseconds());
                return convertedDate;
            }
        }
    ]);
    return DateToSystemTimezoneSetter;
}(Setter);

},{"@babel/runtime/helpers/esm/assertThisInitialized":"hqdCW","@babel/runtime/helpers/esm/inherits":"erMSu","@babel/runtime/helpers/esm/createSuper":"wUOND","@babel/runtime/helpers/esm/classCallCheck":"17u6i","@babel/runtime/helpers/esm/createClass":"2lub7","@babel/runtime/helpers/esm/defineProperty":"5XpnH","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"erMSu":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_inherits);
var _setPrototypeOfJs = require("./setPrototypeOf.js");
var _setPrototypeOfJsDefault = parcelHelpers.interopDefault(_setPrototypeOfJs);
function _inherits(t, e) {
    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
    t.prototype = Object.create(e && e.prototype, {
        constructor: {
            value: t,
            writable: !0,
            configurable: !0
        }
    }), Object.defineProperty(t, "prototype", {
        writable: !1
    }), e && (0, _setPrototypeOfJsDefault.default)(t, e);
}

},{"./setPrototypeOf.js":"hT6Yn","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"wUOND":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_createSuper);
var _getPrototypeOfJs = require("./getPrototypeOf.js");
var _getPrototypeOfJsDefault = parcelHelpers.interopDefault(_getPrototypeOfJs);
var _isNativeReflectConstructJs = require("./isNativeReflectConstruct.js");
var _isNativeReflectConstructJsDefault = parcelHelpers.interopDefault(_isNativeReflectConstructJs);
var _possibleConstructorReturnJs = require("./possibleConstructorReturn.js");
var _possibleConstructorReturnJsDefault = parcelHelpers.interopDefault(_possibleConstructorReturnJs);
function _createSuper(t) {
    var r = (0, _isNativeReflectConstructJsDefault.default)();
    return function() {
        var e, o = (0, _getPrototypeOfJsDefault.default)(t);
        if (r) {
            var s = (0, _getPrototypeOfJsDefault.default)(this).constructor;
            e = Reflect.construct(o, arguments, s);
        } else e = o.apply(this, arguments);
        return (0, _possibleConstructorReturnJsDefault.default)(this, e);
    };
}

},{"./getPrototypeOf.js":"fqOF1","./isNativeReflectConstruct.js":"cBMHu","./possibleConstructorReturn.js":"g7Pbi","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"fqOF1":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_getPrototypeOf);
function _getPrototypeOf(t) {
    return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
        return t.__proto__ || Object.getPrototypeOf(t);
    }, _getPrototypeOf(t);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"cBMHu":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_isNativeReflectConstruct);
function _isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return (_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"g7Pbi":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_possibleConstructorReturn);
var _typeofJs = require("./typeof.js");
var _typeofJsDefault = parcelHelpers.interopDefault(_typeofJs);
var _assertThisInitializedJs = require("./assertThisInitialized.js");
var _assertThisInitializedJsDefault = parcelHelpers.interopDefault(_assertThisInitializedJs);
function _possibleConstructorReturn(t, e) {
    if (e && ("object" == (0, _typeofJsDefault.default)(e) || "function" == typeof e)) return e;
    if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
    return (0, _assertThisInitializedJsDefault.default)(t);
}

},{"./typeof.js":"4ZfJH","./assertThisInitialized.js":"hqdCW","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"17u6i":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_classCallCheck);
function _classCallCheck(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2lub7":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_createClass);
var _toPropertyKeyJs = require("./toPropertyKey.js");
var _toPropertyKeyJsDefault = parcelHelpers.interopDefault(_toPropertyKeyJs);
function _defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, (0, _toPropertyKeyJsDefault.default)(o.key), o);
    }
}
function _createClass(e, r, t) {
    return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}

},{"./toPropertyKey.js":"2D7VT","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"anRHj":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "parsers", ()=>parsers);
var _eraParserJs = require("./EraParser.js");
var _yearParserJs = require("./YearParser.js");
var _localWeekYearParserJs = require("./LocalWeekYearParser.js");
var _isoweekYearParserJs = require("./ISOWeekYearParser.js");
var _extendedYearParserJs = require("./ExtendedYearParser.js");
var _quarterParserJs = require("./QuarterParser.js");
var _standAloneQuarterParserJs = require("./StandAloneQuarterParser.js");
var _monthParserJs = require("./MonthParser.js");
var _standAloneMonthParserJs = require("./StandAloneMonthParser.js");
var _localWeekParserJs = require("./LocalWeekParser.js");
var _isoweekParserJs = require("./ISOWeekParser.js");
var _dateParserJs = require("./DateParser.js");
var _dayOfYearParserJs = require("./DayOfYearParser.js");
var _dayParserJs = require("./DayParser.js");
var _localDayParserJs = require("./LocalDayParser.js");
var _standAloneLocalDayParserJs = require("./StandAloneLocalDayParser.js");
var _isodayParserJs = require("./ISODayParser.js");
var _ampmparserJs = require("./AMPMParser.js");
var _ampmmidnightParserJs = require("./AMPMMidnightParser.js");
var _dayPeriodParserJs = require("./DayPeriodParser.js");
var _hour1To12ParserJs = require("./Hour1to12Parser.js");
var _hour0To23ParserJs = require("./Hour0to23Parser.js");
var _hour0To11ParserJs = require("./Hour0To11Parser.js");
var _hour1To24ParserJs = require("./Hour1To24Parser.js");
var _minuteParserJs = require("./MinuteParser.js");
var _secondParserJs = require("./SecondParser.js");
var _fractionOfSecondParserJs = require("./FractionOfSecondParser.js");
var _isotimezoneWithZParserJs = require("./ISOTimezoneWithZParser.js");
var _isotimezoneParserJs = require("./ISOTimezoneParser.js");
var _timestampSecondsParserJs = require("./TimestampSecondsParser.js");
var _timestampMillisecondsParserJs = require("./TimestampMillisecondsParser.js");
var parsers = {
    G: new (0, _eraParserJs.EraParser)(),
    y: new (0, _yearParserJs.YearParser)(),
    Y: new (0, _localWeekYearParserJs.LocalWeekYearParser)(),
    R: new (0, _isoweekYearParserJs.ISOWeekYearParser)(),
    u: new (0, _extendedYearParserJs.ExtendedYearParser)(),
    Q: new (0, _quarterParserJs.QuarterParser)(),
    q: new (0, _standAloneQuarterParserJs.StandAloneQuarterParser)(),
    M: new (0, _monthParserJs.MonthParser)(),
    L: new (0, _standAloneMonthParserJs.StandAloneMonthParser)(),
    w: new (0, _localWeekParserJs.LocalWeekParser)(),
    I: new (0, _isoweekParserJs.ISOWeekParser)(),
    d: new (0, _dateParserJs.DateParser)(),
    D: new (0, _dayOfYearParserJs.DayOfYearParser)(),
    E: new (0, _dayParserJs.DayParser)(),
    e: new (0, _localDayParserJs.LocalDayParser)(),
    c: new (0, _standAloneLocalDayParserJs.StandAloneLocalDayParser)(),
    i: new (0, _isodayParserJs.ISODayParser)(),
    a: new (0, _ampmparserJs.AMPMParser)(),
    b: new (0, _ampmmidnightParserJs.AMPMMidnightParser)(),
    B: new (0, _dayPeriodParserJs.DayPeriodParser)(),
    h: new (0, _hour1To12ParserJs.Hour1to12Parser)(),
    H: new (0, _hour0To23ParserJs.Hour0to23Parser)(),
    K: new (0, _hour0To11ParserJs.Hour0To11Parser)(),
    k: new (0, _hour1To24ParserJs.Hour1To24Parser)(),
    m: new (0, _minuteParserJs.MinuteParser)(),
    s: new (0, _secondParserJs.SecondParser)(),
    S: new (0, _fractionOfSecondParserJs.FractionOfSecondParser)(),
    X: new (0, _isotimezoneWithZParserJs.ISOTimezoneWithZParser)(),
    x: new (0, _isotimezoneParserJs.ISOTimezoneParser)(),
    t: new (0, _timestampSecondsParserJs.TimestampSecondsParser)(),
    T: new (0, _timestampMillisecondsParserJs.TimestampMillisecondsParser)()
};

},{"./EraParser.js":"dbkmZ","./YearParser.js":"3nlYO","./LocalWeekYearParser.js":"aGN9R","./ISOWeekYearParser.js":"3l3Kg","./ExtendedYearParser.js":"iylkW","./QuarterParser.js":"g0Klx","./StandAloneQuarterParser.js":"1EreM","./MonthParser.js":"iO5OM","./StandAloneMonthParser.js":"5unkD","./LocalWeekParser.js":"2Hawd","./ISOWeekParser.js":"dBGvL","./DateParser.js":"2Mu06","./DayOfYearParser.js":"2pI2J","./DayParser.js":"4DRIi","./LocalDayParser.js":"kZBTO","./StandAloneLocalDayParser.js":"CoUHj","./ISODayParser.js":"2QSWv","./AMPMParser.js":"deerG","./AMPMMidnightParser.js":"3a8AR","./DayPeriodParser.js":"lQ3tQ","./Hour1to12Parser.js":"6B3Bf","./Hour0to23Parser.js":"e44gO","./Hour0To11Parser.js":"2OGRl","./Hour1To24Parser.js":"iOlos","./MinuteParser.js":"2x6o5","./SecondParser.js":"e9Os0","./FractionOfSecondParser.js":"10COg","./ISOTimezoneWithZParser.js":"evbLy","./ISOTimezoneParser.js":"1MoHP","./TimestampSecondsParser.js":"7IzaS","./TimestampMillisecondsParser.js":"7rpVu","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"dbkmZ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "EraParser", ()=>EraParser);
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inherits = require("@babel/runtime/helpers/esm/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _createSuper = require("@babel/runtime/helpers/esm/createSuper");
var _createSuperDefault = parcelHelpers.interopDefault(_createSuper);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _parserJs = require("../Parser.js");
var EraParser = /*#__PURE__*/ function(_Parser) {
    (0, _inheritsDefault.default)(EraParser, _Parser);
    var _super = (0, _createSuperDefault.default)(EraParser);
    function EraParser() {
        var _this;
        (0, _classCallCheckDefault.default)(this, EraParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "priority", 140);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "incompatibleTokens", [
            "R",
            "u",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, _createClassDefault.default)(EraParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    // AD, BC
                    case "G":
                    case "GG":
                    case "GGG":
                        return match.era(dateString, {
                            width: "abbreviated"
                        }) || match.era(dateString, {
                            width: "narrow"
                        });
                    // A, B
                    case "GGGGG":
                        return match.era(dateString, {
                            width: "narrow"
                        });
                    // Anno Domini, Before Christ
                    case "GGGG":
                    default:
                        return match.era(dateString, {
                            width: "wide"
                        }) || match.era(dateString, {
                            width: "abbreviated"
                        }) || match.era(dateString, {
                            width: "narrow"
                        });
                }
            }
        },
        {
            key: "set",
            value: function set(date, flags, value) {
                flags.era = value;
                date.setUTCFullYear(value, 0, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return EraParser;
}((0, _parserJs.Parser));

},{"@babel/runtime/helpers/esm/classCallCheck":"17u6i","@babel/runtime/helpers/esm/createClass":"2lub7","@babel/runtime/helpers/esm/assertThisInitialized":"hqdCW","@babel/runtime/helpers/esm/inherits":"erMSu","@babel/runtime/helpers/esm/createSuper":"wUOND","@babel/runtime/helpers/esm/defineProperty":"5XpnH","../Parser.js":"7RnfN","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7RnfN":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Parser", ()=>Parser);
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _setterJs = require("./Setter.js");
var Parser = /*#__PURE__*/ function() {
    function Parser() {
        (0, _classCallCheckDefault.default)(this, Parser);
        (0, _definePropertyDefault.default)(this, "incompatibleTokens", void 0);
        (0, _definePropertyDefault.default)(this, "priority", void 0);
        (0, _definePropertyDefault.default)(this, "subPriority", void 0);
    }
    (0, _createClassDefault.default)(Parser, [
        {
            key: "run",
            value: function run(dateString, token, match, options) {
                var result = this.parse(dateString, token, match, options);
                if (!result) return null;
                return {
                    setter: new (0, _setterJs.ValueSetter)(result.value, this.validate, this.set, this.priority, this.subPriority),
                    rest: result.rest
                };
            }
        },
        {
            key: "validate",
            value: function validate(_utcDate, _value, _options) {
                return true;
            }
        }
    ]);
    return Parser;
}();

},{"@babel/runtime/helpers/esm/classCallCheck":"17u6i","@babel/runtime/helpers/esm/createClass":"2lub7","@babel/runtime/helpers/esm/defineProperty":"5XpnH","./Setter.js":"e4ESz","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3nlYO":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "YearParser", ()=>YearParser);
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inherits = require("@babel/runtime/helpers/esm/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _createSuper = require("@babel/runtime/helpers/esm/createSuper");
var _createSuperDefault = parcelHelpers.interopDefault(_createSuper);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _parserJs = require("../Parser.js");
var _utilsJs = require("../utils.js");
var YearParser = /*#__PURE__*/ function(_Parser) {
    (0, _inheritsDefault.default)(YearParser, _Parser);
    var _super = (0, _createSuperDefault.default)(YearParser);
    function YearParser() {
        var _this;
        (0, _classCallCheckDefault.default)(this, YearParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "priority", 130);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "incompatibleTokens", [
            "Y",
            "R",
            "u",
            "w",
            "I",
            "i",
            "e",
            "c",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, _createClassDefault.default)(YearParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                var valueCallback = function valueCallback(year) {
                    return {
                        year: year,
                        isTwoDigitYear: token === "yy"
                    };
                };
                switch(token){
                    case "y":
                        return (0, _utilsJs.mapValue)((0, _utilsJs.parseNDigits)(4, dateString), valueCallback);
                    case "yo":
                        return (0, _utilsJs.mapValue)(match.ordinalNumber(dateString, {
                            unit: "year"
                        }), valueCallback);
                    default:
                        return (0, _utilsJs.mapValue)((0, _utilsJs.parseNDigits)(token.length, dateString), valueCallback);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value.isTwoDigitYear || value.year > 0;
            }
        },
        {
            key: "set",
            value: function set(date, flags, value) {
                var currentYear = date.getUTCFullYear();
                if (value.isTwoDigitYear) {
                    var normalizedTwoDigitYear = (0, _utilsJs.normalizeTwoDigitYear)(value.year, currentYear);
                    date.setUTCFullYear(normalizedTwoDigitYear, 0, 1);
                    date.setUTCHours(0, 0, 0, 0);
                    return date;
                }
                var year = !("era" in flags) || flags.era === 1 ? value.year : 1 - value.year;
                date.setUTCFullYear(year, 0, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return YearParser;
}((0, _parserJs.Parser));

},{"@babel/runtime/helpers/esm/classCallCheck":"17u6i","@babel/runtime/helpers/esm/createClass":"2lub7","@babel/runtime/helpers/esm/assertThisInitialized":"hqdCW","@babel/runtime/helpers/esm/inherits":"erMSu","@babel/runtime/helpers/esm/createSuper":"wUOND","@babel/runtime/helpers/esm/defineProperty":"5XpnH","../Parser.js":"7RnfN","../utils.js":"jpqG3","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jpqG3":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "mapValue", ()=>mapValue);
parcelHelpers.export(exports, "parseNumericPattern", ()=>parseNumericPattern);
parcelHelpers.export(exports, "parseTimezonePattern", ()=>parseTimezonePattern);
parcelHelpers.export(exports, "parseAnyDigitsSigned", ()=>parseAnyDigitsSigned);
parcelHelpers.export(exports, "parseNDigits", ()=>parseNDigits);
parcelHelpers.export(exports, "parseNDigitsSigned", ()=>parseNDigitsSigned);
parcelHelpers.export(exports, "dayPeriodEnumToHours", ()=>dayPeriodEnumToHours);
parcelHelpers.export(exports, "normalizeTwoDigitYear", ()=>normalizeTwoDigitYear);
parcelHelpers.export(exports, "isLeapYearIndex", ()=>isLeapYearIndex);
var _indexJs = require("../../constants/index.js");
var _constantsJs = require("./constants.js");
function mapValue(parseFnResult, mapFn) {
    if (!parseFnResult) return parseFnResult;
    return {
        value: mapFn(parseFnResult.value),
        rest: parseFnResult.rest
    };
}
function parseNumericPattern(pattern, dateString) {
    var matchResult = dateString.match(pattern);
    if (!matchResult) return null;
    return {
        value: parseInt(matchResult[0], 10),
        rest: dateString.slice(matchResult[0].length)
    };
}
function parseTimezonePattern(pattern, dateString) {
    var matchResult = dateString.match(pattern);
    if (!matchResult) return null;
    // Input is 'Z'
    if (matchResult[0] === "Z") return {
        value: 0,
        rest: dateString.slice(1)
    };
    var sign = matchResult[1] === "+" ? 1 : -1;
    var hours = matchResult[2] ? parseInt(matchResult[2], 10) : 0;
    var minutes = matchResult[3] ? parseInt(matchResult[3], 10) : 0;
    var seconds = matchResult[5] ? parseInt(matchResult[5], 10) : 0;
    return {
        value: sign * (hours * (0, _indexJs.millisecondsInHour) + minutes * (0, _indexJs.millisecondsInMinute) + seconds * (0, _indexJs.millisecondsInSecond)),
        rest: dateString.slice(matchResult[0].length)
    };
}
function parseAnyDigitsSigned(dateString) {
    return parseNumericPattern((0, _constantsJs.numericPatterns).anyDigitsSigned, dateString);
}
function parseNDigits(n, dateString) {
    switch(n){
        case 1:
            return parseNumericPattern((0, _constantsJs.numericPatterns).singleDigit, dateString);
        case 2:
            return parseNumericPattern((0, _constantsJs.numericPatterns).twoDigits, dateString);
        case 3:
            return parseNumericPattern((0, _constantsJs.numericPatterns).threeDigits, dateString);
        case 4:
            return parseNumericPattern((0, _constantsJs.numericPatterns).fourDigits, dateString);
        default:
            return parseNumericPattern(new RegExp("^\\d{1," + n + "}"), dateString);
    }
}
function parseNDigitsSigned(n, dateString) {
    switch(n){
        case 1:
            return parseNumericPattern((0, _constantsJs.numericPatterns).singleDigitSigned, dateString);
        case 2:
            return parseNumericPattern((0, _constantsJs.numericPatterns).twoDigitsSigned, dateString);
        case 3:
            return parseNumericPattern((0, _constantsJs.numericPatterns).threeDigitsSigned, dateString);
        case 4:
            return parseNumericPattern((0, _constantsJs.numericPatterns).fourDigitsSigned, dateString);
        default:
            return parseNumericPattern(new RegExp("^-?\\d{1," + n + "}"), dateString);
    }
}
function dayPeriodEnumToHours(dayPeriod) {
    switch(dayPeriod){
        case "morning":
            return 4;
        case "evening":
            return 17;
        case "pm":
        case "noon":
        case "afternoon":
            return 12;
        case "am":
        case "midnight":
        case "night":
        default:
            return 0;
    }
}
function normalizeTwoDigitYear(twoDigitYear, currentYear) {
    var isCommonEra = currentYear > 0;
    // Absolute number of the current year:
    // 1 -> 1 AC
    // 0 -> 1 BC
    // -1 -> 2 BC
    var absCurrentYear = isCommonEra ? currentYear : 1 - currentYear;
    var result;
    if (absCurrentYear <= 50) result = twoDigitYear || 100;
    else {
        var rangeEnd = absCurrentYear + 50;
        var rangeEndCentury = Math.floor(rangeEnd / 100) * 100;
        var isPreviousCentury = twoDigitYear >= rangeEnd % 100;
        result = twoDigitYear + rangeEndCentury - (isPreviousCentury ? 100 : 0);
    }
    return isCommonEra ? result : 1 - result;
}
function isLeapYearIndex(year) {
    return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}

},{"../../constants/index.js":"2mYwa","./constants.js":"J1mKQ","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2mYwa":[function(require,module,exports) {
/**
 * Days in 1 week.
 *
 * @name daysInWeek
 * @constant
 * @type {number}
 * @default
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "daysInWeek", ()=>daysInWeek);
parcelHelpers.export(exports, "daysInYear", ()=>daysInYear);
parcelHelpers.export(exports, "maxTime", ()=>maxTime);
parcelHelpers.export(exports, "millisecondsInMinute", ()=>millisecondsInMinute);
parcelHelpers.export(exports, "millisecondsInHour", ()=>millisecondsInHour);
parcelHelpers.export(exports, "millisecondsInSecond", ()=>millisecondsInSecond);
parcelHelpers.export(exports, "minTime", ()=>minTime);
parcelHelpers.export(exports, "minutesInHour", ()=>minutesInHour);
parcelHelpers.export(exports, "monthsInQuarter", ()=>monthsInQuarter);
parcelHelpers.export(exports, "monthsInYear", ()=>monthsInYear);
parcelHelpers.export(exports, "quartersInYear", ()=>quartersInYear);
parcelHelpers.export(exports, "secondsInHour", ()=>secondsInHour);
parcelHelpers.export(exports, "secondsInMinute", ()=>secondsInMinute);
parcelHelpers.export(exports, "secondsInDay", ()=>secondsInDay);
parcelHelpers.export(exports, "secondsInWeek", ()=>secondsInWeek);
parcelHelpers.export(exports, "secondsInYear", ()=>secondsInYear);
parcelHelpers.export(exports, "secondsInMonth", ()=>secondsInMonth);
parcelHelpers.export(exports, "secondsInQuarter", ()=>secondsInQuarter);
var daysInWeek = 7;
var daysInYear = 365.2425;
var maxTime = Math.pow(10, 8) * 86400000;
var millisecondsInMinute = 60000;
var millisecondsInHour = 3600000;
var millisecondsInSecond = 1000;
var minTime = -maxTime;
var minutesInHour = 60;
var monthsInQuarter = 3;
var monthsInYear = 12;
var quartersInYear = 4;
var secondsInHour = 3600;
var secondsInMinute = 60;
var secondsInDay = secondsInHour * 24;
var secondsInWeek = secondsInDay * 7;
var secondsInYear = secondsInDay * daysInYear;
var secondsInMonth = secondsInYear / 12;
var secondsInQuarter = secondsInMonth * 3;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"J1mKQ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "numericPatterns", ()=>numericPatterns);
parcelHelpers.export(exports, "timezonePatterns", ()=>timezonePatterns);
var numericPatterns = {
    month: /^(1[0-2]|0?\d)/,
    // 0 to 12
    date: /^(3[0-1]|[0-2]?\d)/,
    // 0 to 31
    dayOfYear: /^(36[0-6]|3[0-5]\d|[0-2]?\d?\d)/,
    // 0 to 366
    week: /^(5[0-3]|[0-4]?\d)/,
    // 0 to 53
    hour23h: /^(2[0-3]|[0-1]?\d)/,
    // 0 to 23
    hour24h: /^(2[0-4]|[0-1]?\d)/,
    // 0 to 24
    hour11h: /^(1[0-1]|0?\d)/,
    // 0 to 11
    hour12h: /^(1[0-2]|0?\d)/,
    // 0 to 12
    minute: /^[0-5]?\d/,
    // 0 to 59
    second: /^[0-5]?\d/,
    // 0 to 59
    singleDigit: /^\d/,
    // 0 to 9
    twoDigits: /^\d{1,2}/,
    // 0 to 99
    threeDigits: /^\d{1,3}/,
    // 0 to 999
    fourDigits: /^\d{1,4}/,
    // 0 to 9999
    anyDigitsSigned: /^-?\d+/,
    singleDigitSigned: /^-?\d/,
    // 0 to 9, -0 to -9
    twoDigitsSigned: /^-?\d{1,2}/,
    // 0 to 99, -0 to -99
    threeDigitsSigned: /^-?\d{1,3}/,
    // 0 to 999, -0 to -999
    fourDigitsSigned: /^-?\d{1,4}/ // 0 to 9999, -0 to -9999
};
var timezonePatterns = {
    basicOptionalMinutes: /^([+-])(\d{2})(\d{2})?|Z/,
    basic: /^([+-])(\d{2})(\d{2})|Z/,
    basicOptionalSeconds: /^([+-])(\d{2})(\d{2})((\d{2}))?|Z/,
    extended: /^([+-])(\d{2}):(\d{2})|Z/,
    extendedOptionalSeconds: /^([+-])(\d{2}):(\d{2})(:(\d{2}))?|Z/
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"aGN9R":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LocalWeekYearParser", ()=>LocalWeekYearParser);
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inherits = require("@babel/runtime/helpers/esm/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _createSuper = require("@babel/runtime/helpers/esm/createSuper");
var _createSuperDefault = parcelHelpers.interopDefault(_createSuper);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _parserJs = require("../Parser.js");
var _utilsJs = require("../utils.js");
var _indexJs = require("../../../_lib/getUTCWeekYear/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../../../_lib/startOfUTCWeek/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var LocalWeekYearParser = /*#__PURE__*/ function(_Parser) {
    (0, _inheritsDefault.default)(LocalWeekYearParser, _Parser);
    var _super = (0, _createSuperDefault.default)(LocalWeekYearParser);
    function LocalWeekYearParser() {
        var _this;
        (0, _classCallCheckDefault.default)(this, LocalWeekYearParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "priority", 130);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "incompatibleTokens", [
            "y",
            "R",
            "u",
            "Q",
            "q",
            "M",
            "L",
            "I",
            "d",
            "D",
            "i",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, _createClassDefault.default)(LocalWeekYearParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                var valueCallback = function valueCallback(year) {
                    return {
                        year: year,
                        isTwoDigitYear: token === "YY"
                    };
                };
                switch(token){
                    case "Y":
                        return (0, _utilsJs.mapValue)((0, _utilsJs.parseNDigits)(4, dateString), valueCallback);
                    case "Yo":
                        return (0, _utilsJs.mapValue)(match.ordinalNumber(dateString, {
                            unit: "year"
                        }), valueCallback);
                    default:
                        return (0, _utilsJs.mapValue)((0, _utilsJs.parseNDigits)(token.length, dateString), valueCallback);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value.isTwoDigitYear || value.year > 0;
            }
        },
        {
            key: "set",
            value: function set(date, flags, value, options) {
                var currentYear = (0, _indexJsDefault.default)(date, options);
                if (value.isTwoDigitYear) {
                    var normalizedTwoDigitYear = (0, _utilsJs.normalizeTwoDigitYear)(value.year, currentYear);
                    date.setUTCFullYear(normalizedTwoDigitYear, 0, options.firstWeekContainsDate);
                    date.setUTCHours(0, 0, 0, 0);
                    return (0, _indexJsDefault1.default)(date, options);
                }
                var year = !("era" in flags) || flags.era === 1 ? value.year : 1 - value.year;
                date.setUTCFullYear(year, 0, options.firstWeekContainsDate);
                date.setUTCHours(0, 0, 0, 0);
                return (0, _indexJsDefault1.default)(date, options);
            }
        }
    ]);
    return LocalWeekYearParser;
}((0, _parserJs.Parser));

},{"@babel/runtime/helpers/esm/classCallCheck":"17u6i","@babel/runtime/helpers/esm/createClass":"2lub7","@babel/runtime/helpers/esm/assertThisInitialized":"hqdCW","@babel/runtime/helpers/esm/inherits":"erMSu","@babel/runtime/helpers/esm/createSuper":"wUOND","@babel/runtime/helpers/esm/defineProperty":"5XpnH","../Parser.js":"7RnfN","../utils.js":"jpqG3","../../../_lib/getUTCWeekYear/index.js":"1Wt2k","../../../_lib/startOfUTCWeek/index.js":"24zN6","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3l3Kg":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ISOWeekYearParser", ()=>ISOWeekYearParser);
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inherits = require("@babel/runtime/helpers/esm/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _createSuper = require("@babel/runtime/helpers/esm/createSuper");
var _createSuperDefault = parcelHelpers.interopDefault(_createSuper);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _parserJs = require("../Parser.js");
var _utilsJs = require("../utils.js");
var _indexJs = require("../../../_lib/startOfUTCISOWeek/index.js"); // ISO week-numbering year
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var ISOWeekYearParser = /*#__PURE__*/ function(_Parser) {
    (0, _inheritsDefault.default)(ISOWeekYearParser, _Parser);
    var _super = (0, _createSuperDefault.default)(ISOWeekYearParser);
    function ISOWeekYearParser() {
        var _this;
        (0, _classCallCheckDefault.default)(this, ISOWeekYearParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "priority", 130);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "incompatibleTokens", [
            "G",
            "y",
            "Y",
            "u",
            "Q",
            "q",
            "M",
            "L",
            "w",
            "d",
            "D",
            "e",
            "c",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, _createClassDefault.default)(ISOWeekYearParser, [
        {
            key: "parse",
            value: function parse(dateString, token) {
                if (token === "R") return (0, _utilsJs.parseNDigitsSigned)(4, dateString);
                return (0, _utilsJs.parseNDigitsSigned)(token.length, dateString);
            }
        },
        {
            key: "set",
            value: function set(_date, _flags, value) {
                var firstWeekOfYear = new Date(0);
                firstWeekOfYear.setUTCFullYear(value, 0, 4);
                firstWeekOfYear.setUTCHours(0, 0, 0, 0);
                return (0, _indexJsDefault.default)(firstWeekOfYear);
            }
        }
    ]);
    return ISOWeekYearParser;
}((0, _parserJs.Parser));

},{"@babel/runtime/helpers/esm/classCallCheck":"17u6i","@babel/runtime/helpers/esm/createClass":"2lub7","@babel/runtime/helpers/esm/assertThisInitialized":"hqdCW","@babel/runtime/helpers/esm/inherits":"erMSu","@babel/runtime/helpers/esm/createSuper":"wUOND","@babel/runtime/helpers/esm/defineProperty":"5XpnH","../Parser.js":"7RnfN","../utils.js":"jpqG3","../../../_lib/startOfUTCISOWeek/index.js":"9vtwc","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"iylkW":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ExtendedYearParser", ()=>ExtendedYearParser);
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inherits = require("@babel/runtime/helpers/esm/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _createSuper = require("@babel/runtime/helpers/esm/createSuper");
var _createSuperDefault = parcelHelpers.interopDefault(_createSuper);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _parserJs = require("../Parser.js");
var _utilsJs = require("../utils.js");
var ExtendedYearParser = /*#__PURE__*/ function(_Parser) {
    (0, _inheritsDefault.default)(ExtendedYearParser, _Parser);
    var _super = (0, _createSuperDefault.default)(ExtendedYearParser);
    function ExtendedYearParser() {
        var _this;
        (0, _classCallCheckDefault.default)(this, ExtendedYearParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "priority", 130);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "incompatibleTokens", [
            "G",
            "y",
            "Y",
            "R",
            "w",
            "I",
            "i",
            "e",
            "c",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, _createClassDefault.default)(ExtendedYearParser, [
        {
            key: "parse",
            value: function parse(dateString, token) {
                if (token === "u") return (0, _utilsJs.parseNDigitsSigned)(4, dateString);
                return (0, _utilsJs.parseNDigitsSigned)(token.length, dateString);
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCFullYear(value, 0, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return ExtendedYearParser;
}((0, _parserJs.Parser));

},{"@babel/runtime/helpers/esm/classCallCheck":"17u6i","@babel/runtime/helpers/esm/createClass":"2lub7","@babel/runtime/helpers/esm/assertThisInitialized":"hqdCW","@babel/runtime/helpers/esm/inherits":"erMSu","@babel/runtime/helpers/esm/createSuper":"wUOND","@babel/runtime/helpers/esm/defineProperty":"5XpnH","../Parser.js":"7RnfN","../utils.js":"jpqG3","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"g0Klx":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "QuarterParser", ()=>QuarterParser);
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inherits = require("@babel/runtime/helpers/esm/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _createSuper = require("@babel/runtime/helpers/esm/createSuper");
var _createSuperDefault = parcelHelpers.interopDefault(_createSuper);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _parserJs = require("../Parser.js");
var _utilsJs = require("../utils.js");
var QuarterParser = /*#__PURE__*/ function(_Parser) {
    (0, _inheritsDefault.default)(QuarterParser, _Parser);
    var _super = (0, _createSuperDefault.default)(QuarterParser);
    function QuarterParser() {
        var _this;
        (0, _classCallCheckDefault.default)(this, QuarterParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "priority", 120);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "incompatibleTokens", [
            "Y",
            "R",
            "q",
            "M",
            "L",
            "w",
            "I",
            "d",
            "D",
            "i",
            "e",
            "c",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, _createClassDefault.default)(QuarterParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    // 1, 2, 3, 4
                    case "Q":
                    case "QQ":
                        // 01, 02, 03, 04
                        return (0, _utilsJs.parseNDigits)(token.length, dateString);
                    // 1st, 2nd, 3rd, 4th
                    case "Qo":
                        return match.ordinalNumber(dateString, {
                            unit: "quarter"
                        });
                    // Q1, Q2, Q3, Q4
                    case "QQQ":
                        return match.quarter(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.quarter(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    // 1, 2, 3, 4 (narrow quarter; could be not numerical)
                    case "QQQQQ":
                        return match.quarter(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    // 1st quarter, 2nd quarter, ...
                    case "QQQQ":
                    default:
                        return match.quarter(dateString, {
                            width: "wide",
                            context: "formatting"
                        }) || match.quarter(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.quarter(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 4;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMonth((value - 1) * 3, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return QuarterParser;
}((0, _parserJs.Parser));

},{"@babel/runtime/helpers/esm/classCallCheck":"17u6i","@babel/runtime/helpers/esm/createClass":"2lub7","@babel/runtime/helpers/esm/assertThisInitialized":"hqdCW","@babel/runtime/helpers/esm/inherits":"erMSu","@babel/runtime/helpers/esm/createSuper":"wUOND","@babel/runtime/helpers/esm/defineProperty":"5XpnH","../Parser.js":"7RnfN","../utils.js":"jpqG3","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1EreM":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StandAloneQuarterParser", ()=>StandAloneQuarterParser);
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inherits = require("@babel/runtime/helpers/esm/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _createSuper = require("@babel/runtime/helpers/esm/createSuper");
var _createSuperDefault = parcelHelpers.interopDefault(_createSuper);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _parserJs = require("../Parser.js");
var _utilsJs = require("../utils.js");
var StandAloneQuarterParser = /*#__PURE__*/ function(_Parser) {
    (0, _inheritsDefault.default)(StandAloneQuarterParser, _Parser);
    var _super = (0, _createSuperDefault.default)(StandAloneQuarterParser);
    function StandAloneQuarterParser() {
        var _this;
        (0, _classCallCheckDefault.default)(this, StandAloneQuarterParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "priority", 120);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "incompatibleTokens", [
            "Y",
            "R",
            "Q",
            "M",
            "L",
            "w",
            "I",
            "d",
            "D",
            "i",
            "e",
            "c",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, _createClassDefault.default)(StandAloneQuarterParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    // 1, 2, 3, 4
                    case "q":
                    case "qq":
                        // 01, 02, 03, 04
                        return (0, _utilsJs.parseNDigits)(token.length, dateString);
                    // 1st, 2nd, 3rd, 4th
                    case "qo":
                        return match.ordinalNumber(dateString, {
                            unit: "quarter"
                        });
                    // Q1, Q2, Q3, Q4
                    case "qqq":
                        return match.quarter(dateString, {
                            width: "abbreviated",
                            context: "standalone"
                        }) || match.quarter(dateString, {
                            width: "narrow",
                            context: "standalone"
                        });
                    // 1, 2, 3, 4 (narrow quarter; could be not numerical)
                    case "qqqqq":
                        return match.quarter(dateString, {
                            width: "narrow",
                            context: "standalone"
                        });
                    // 1st quarter, 2nd quarter, ...
                    case "qqqq":
                    default:
                        return match.quarter(dateString, {
                            width: "wide",
                            context: "standalone"
                        }) || match.quarter(dateString, {
                            width: "abbreviated",
                            context: "standalone"
                        }) || match.quarter(dateString, {
                            width: "narrow",
                            context: "standalone"
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 4;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMonth((value - 1) * 3, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return StandAloneQuarterParser;
}((0, _parserJs.Parser));

},{"@babel/runtime/helpers/esm/classCallCheck":"17u6i","@babel/runtime/helpers/esm/createClass":"2lub7","@babel/runtime/helpers/esm/assertThisInitialized":"hqdCW","@babel/runtime/helpers/esm/inherits":"erMSu","@babel/runtime/helpers/esm/createSuper":"wUOND","@babel/runtime/helpers/esm/defineProperty":"5XpnH","../Parser.js":"7RnfN","../utils.js":"jpqG3","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"iO5OM":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MonthParser", ()=>MonthParser);
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inherits = require("@babel/runtime/helpers/esm/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _createSuper = require("@babel/runtime/helpers/esm/createSuper");
var _createSuperDefault = parcelHelpers.interopDefault(_createSuper);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _utilsJs = require("../utils.js");
var _parserJs = require("../Parser.js");
var _constantsJs = require("../constants.js");
var MonthParser = /*#__PURE__*/ function(_Parser) {
    (0, _inheritsDefault.default)(MonthParser, _Parser);
    var _super = (0, _createSuperDefault.default)(MonthParser);
    function MonthParser() {
        var _this;
        (0, _classCallCheckDefault.default)(this, MonthParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "incompatibleTokens", [
            "Y",
            "R",
            "q",
            "Q",
            "L",
            "w",
            "I",
            "D",
            "i",
            "e",
            "c",
            "t",
            "T"
        ]);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "priority", 110);
        return _this;
    }
    (0, _createClassDefault.default)(MonthParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                var valueCallback = function valueCallback(value) {
                    return value - 1;
                };
                switch(token){
                    // 1, 2, ..., 12
                    case "M":
                        return (0, _utilsJs.mapValue)((0, _utilsJs.parseNumericPattern)((0, _constantsJs.numericPatterns).month, dateString), valueCallback);
                    // 01, 02, ..., 12
                    case "MM":
                        return (0, _utilsJs.mapValue)((0, _utilsJs.parseNDigits)(2, dateString), valueCallback);
                    // 1st, 2nd, ..., 12th
                    case "Mo":
                        return (0, _utilsJs.mapValue)(match.ordinalNumber(dateString, {
                            unit: "month"
                        }), valueCallback);
                    // Jan, Feb, ..., Dec
                    case "MMM":
                        return match.month(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.month(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    // J, F, ..., D
                    case "MMMMM":
                        return match.month(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    // January, February, ..., December
                    case "MMMM":
                    default:
                        return match.month(dateString, {
                            width: "wide",
                            context: "formatting"
                        }) || match.month(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.month(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 11;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMonth(value, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return MonthParser;
}((0, _parserJs.Parser));

},{"@babel/runtime/helpers/esm/classCallCheck":"17u6i","@babel/runtime/helpers/esm/createClass":"2lub7","@babel/runtime/helpers/esm/assertThisInitialized":"hqdCW","@babel/runtime/helpers/esm/inherits":"erMSu","@babel/runtime/helpers/esm/createSuper":"wUOND","@babel/runtime/helpers/esm/defineProperty":"5XpnH","../utils.js":"jpqG3","../Parser.js":"7RnfN","../constants.js":"J1mKQ","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"5unkD":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StandAloneMonthParser", ()=>StandAloneMonthParser);
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inherits = require("@babel/runtime/helpers/esm/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _createSuper = require("@babel/runtime/helpers/esm/createSuper");
var _createSuperDefault = parcelHelpers.interopDefault(_createSuper);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _parserJs = require("../Parser.js");
var _constantsJs = require("../constants.js");
var _utilsJs = require("../utils.js");
var StandAloneMonthParser = /*#__PURE__*/ function(_Parser) {
    (0, _inheritsDefault.default)(StandAloneMonthParser, _Parser);
    var _super = (0, _createSuperDefault.default)(StandAloneMonthParser);
    function StandAloneMonthParser() {
        var _this;
        (0, _classCallCheckDefault.default)(this, StandAloneMonthParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "priority", 110);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "incompatibleTokens", [
            "Y",
            "R",
            "q",
            "Q",
            "M",
            "w",
            "I",
            "D",
            "i",
            "e",
            "c",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, _createClassDefault.default)(StandAloneMonthParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                var valueCallback = function valueCallback(value) {
                    return value - 1;
                };
                switch(token){
                    // 1, 2, ..., 12
                    case "L":
                        return (0, _utilsJs.mapValue)((0, _utilsJs.parseNumericPattern)((0, _constantsJs.numericPatterns).month, dateString), valueCallback);
                    // 01, 02, ..., 12
                    case "LL":
                        return (0, _utilsJs.mapValue)((0, _utilsJs.parseNDigits)(2, dateString), valueCallback);
                    // 1st, 2nd, ..., 12th
                    case "Lo":
                        return (0, _utilsJs.mapValue)(match.ordinalNumber(dateString, {
                            unit: "month"
                        }), valueCallback);
                    // Jan, Feb, ..., Dec
                    case "LLL":
                        return match.month(dateString, {
                            width: "abbreviated",
                            context: "standalone"
                        }) || match.month(dateString, {
                            width: "narrow",
                            context: "standalone"
                        });
                    // J, F, ..., D
                    case "LLLLL":
                        return match.month(dateString, {
                            width: "narrow",
                            context: "standalone"
                        });
                    // January, February, ..., December
                    case "LLLL":
                    default:
                        return match.month(dateString, {
                            width: "wide",
                            context: "standalone"
                        }) || match.month(dateString, {
                            width: "abbreviated",
                            context: "standalone"
                        }) || match.month(dateString, {
                            width: "narrow",
                            context: "standalone"
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 11;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMonth(value, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return StandAloneMonthParser;
}((0, _parserJs.Parser));

},{"@babel/runtime/helpers/esm/classCallCheck":"17u6i","@babel/runtime/helpers/esm/createClass":"2lub7","@babel/runtime/helpers/esm/assertThisInitialized":"hqdCW","@babel/runtime/helpers/esm/inherits":"erMSu","@babel/runtime/helpers/esm/createSuper":"wUOND","@babel/runtime/helpers/esm/defineProperty":"5XpnH","../Parser.js":"7RnfN","../constants.js":"J1mKQ","../utils.js":"jpqG3","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2Hawd":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LocalWeekParser", ()=>LocalWeekParser);
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inherits = require("@babel/runtime/helpers/esm/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _createSuper = require("@babel/runtime/helpers/esm/createSuper");
var _createSuperDefault = parcelHelpers.interopDefault(_createSuper);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _parserJs = require("../Parser.js");
var _constantsJs = require("../constants.js");
var _utilsJs = require("../utils.js");
var _indexJs = require("../../../_lib/setUTCWeek/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../../../_lib/startOfUTCWeek/index.js"); // Local week of year
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var LocalWeekParser = /*#__PURE__*/ function(_Parser) {
    (0, _inheritsDefault.default)(LocalWeekParser, _Parser);
    var _super = (0, _createSuperDefault.default)(LocalWeekParser);
    function LocalWeekParser() {
        var _this;
        (0, _classCallCheckDefault.default)(this, LocalWeekParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "priority", 100);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "incompatibleTokens", [
            "y",
            "R",
            "u",
            "q",
            "Q",
            "M",
            "L",
            "I",
            "d",
            "D",
            "i",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, _createClassDefault.default)(LocalWeekParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case "w":
                        return (0, _utilsJs.parseNumericPattern)((0, _constantsJs.numericPatterns).week, dateString);
                    case "wo":
                        return match.ordinalNumber(dateString, {
                            unit: "week"
                        });
                    default:
                        return (0, _utilsJs.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 53;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value, options) {
                return (0, _indexJsDefault1.default)((0, _indexJsDefault.default)(date, value, options), options);
            }
        }
    ]);
    return LocalWeekParser;
}((0, _parserJs.Parser));

},{"@babel/runtime/helpers/esm/classCallCheck":"17u6i","@babel/runtime/helpers/esm/createClass":"2lub7","@babel/runtime/helpers/esm/assertThisInitialized":"hqdCW","@babel/runtime/helpers/esm/inherits":"erMSu","@babel/runtime/helpers/esm/createSuper":"wUOND","@babel/runtime/helpers/esm/defineProperty":"5XpnH","../Parser.js":"7RnfN","../constants.js":"J1mKQ","../utils.js":"jpqG3","../../../_lib/setUTCWeek/index.js":"jSW87","../../../_lib/startOfUTCWeek/index.js":"24zN6","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jSW87":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>setUTCWeek);
var _indexJs = require("../toInteger/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../../toDate/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../getUTCWeek/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("../requiredArgs/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
function setUTCWeek(dirtyDate, dirtyWeek, options) {
    (0, _indexJsDefault3.default)(2, arguments);
    var date = (0, _indexJsDefault1.default)(dirtyDate);
    var week = (0, _indexJsDefault.default)(dirtyWeek);
    var diff = (0, _indexJsDefault2.default)(date, options) - week;
    date.setUTCDate(date.getUTCDate() - diff * 7);
    return date;
}

},{"../toInteger/index.js":"fgaQ2","../../toDate/index.js":"fYDr6","../getUTCWeek/index.js":"7bKJm","../requiredArgs/index.js":"180ox","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"dBGvL":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ISOWeekParser", ()=>ISOWeekParser);
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inherits = require("@babel/runtime/helpers/esm/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _createSuper = require("@babel/runtime/helpers/esm/createSuper");
var _createSuperDefault = parcelHelpers.interopDefault(_createSuper);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _parserJs = require("../Parser.js");
var _constantsJs = require("../constants.js");
var _utilsJs = require("../utils.js");
var _indexJs = require("../../../_lib/setUTCISOWeek/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../../../_lib/startOfUTCISOWeek/index.js"); // ISO week of year
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var ISOWeekParser = /*#__PURE__*/ function(_Parser) {
    (0, _inheritsDefault.default)(ISOWeekParser, _Parser);
    var _super = (0, _createSuperDefault.default)(ISOWeekParser);
    function ISOWeekParser() {
        var _this;
        (0, _classCallCheckDefault.default)(this, ISOWeekParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "priority", 100);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "incompatibleTokens", [
            "y",
            "Y",
            "u",
            "q",
            "Q",
            "M",
            "L",
            "w",
            "d",
            "D",
            "e",
            "c",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, _createClassDefault.default)(ISOWeekParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case "I":
                        return (0, _utilsJs.parseNumericPattern)((0, _constantsJs.numericPatterns).week, dateString);
                    case "Io":
                        return match.ordinalNumber(dateString, {
                            unit: "week"
                        });
                    default:
                        return (0, _utilsJs.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 53;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                return (0, _indexJsDefault1.default)((0, _indexJsDefault.default)(date, value));
            }
        }
    ]);
    return ISOWeekParser;
}((0, _parserJs.Parser));

},{"@babel/runtime/helpers/esm/classCallCheck":"17u6i","@babel/runtime/helpers/esm/createClass":"2lub7","@babel/runtime/helpers/esm/assertThisInitialized":"hqdCW","@babel/runtime/helpers/esm/inherits":"erMSu","@babel/runtime/helpers/esm/createSuper":"wUOND","@babel/runtime/helpers/esm/defineProperty":"5XpnH","../Parser.js":"7RnfN","../constants.js":"J1mKQ","../utils.js":"jpqG3","../../../_lib/setUTCISOWeek/index.js":"ihVoE","../../../_lib/startOfUTCISOWeek/index.js":"9vtwc","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"ihVoE":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>setUTCISOWeek);
var _indexJs = require("../toInteger/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../../toDate/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../getUTCISOWeek/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("../requiredArgs/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
function setUTCISOWeek(dirtyDate, dirtyISOWeek) {
    (0, _indexJsDefault3.default)(2, arguments);
    var date = (0, _indexJsDefault1.default)(dirtyDate);
    var isoWeek = (0, _indexJsDefault.default)(dirtyISOWeek);
    var diff = (0, _indexJsDefault2.default)(date) - isoWeek;
    date.setUTCDate(date.getUTCDate() - diff * 7);
    return date;
}

},{"../toInteger/index.js":"fgaQ2","../../toDate/index.js":"fYDr6","../getUTCISOWeek/index.js":"jinth","../requiredArgs/index.js":"180ox","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2Mu06":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DateParser", ()=>DateParser);
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inherits = require("@babel/runtime/helpers/esm/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _createSuper = require("@babel/runtime/helpers/esm/createSuper");
var _createSuperDefault = parcelHelpers.interopDefault(_createSuper);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _utilsJs = require("../utils.js");
var _parserJs = require("../Parser.js");
var _constantsJs = require("../constants.js");
var DAYS_IN_MONTH = [
    31,
    28,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
var DAYS_IN_MONTH_LEAP_YEAR = [
    31,
    29,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
var DateParser = /*#__PURE__*/ function(_Parser) {
    (0, _inheritsDefault.default)(DateParser, _Parser);
    var _super = (0, _createSuperDefault.default)(DateParser);
    function DateParser() {
        var _this;
        (0, _classCallCheckDefault.default)(this, DateParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "priority", 90);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "subPriority", 1);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "incompatibleTokens", [
            "Y",
            "R",
            "q",
            "Q",
            "w",
            "I",
            "D",
            "i",
            "e",
            "c",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, _createClassDefault.default)(DateParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case "d":
                        return (0, _utilsJs.parseNumericPattern)((0, _constantsJs.numericPatterns).date, dateString);
                    case "do":
                        return match.ordinalNumber(dateString, {
                            unit: "date"
                        });
                    default:
                        return (0, _utilsJs.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(date, value) {
                var year = date.getUTCFullYear();
                var isLeapYear = (0, _utilsJs.isLeapYearIndex)(year);
                var month = date.getUTCMonth();
                if (isLeapYear) return value >= 1 && value <= DAYS_IN_MONTH_LEAP_YEAR[month];
                else return value >= 1 && value <= DAYS_IN_MONTH[month];
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCDate(value);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return DateParser;
}((0, _parserJs.Parser));

},{"@babel/runtime/helpers/esm/classCallCheck":"17u6i","@babel/runtime/helpers/esm/createClass":"2lub7","@babel/runtime/helpers/esm/assertThisInitialized":"hqdCW","@babel/runtime/helpers/esm/inherits":"erMSu","@babel/runtime/helpers/esm/createSuper":"wUOND","@babel/runtime/helpers/esm/defineProperty":"5XpnH","../utils.js":"jpqG3","../Parser.js":"7RnfN","../constants.js":"J1mKQ","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2pI2J":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DayOfYearParser", ()=>DayOfYearParser);
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inherits = require("@babel/runtime/helpers/esm/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _createSuper = require("@babel/runtime/helpers/esm/createSuper");
var _createSuperDefault = parcelHelpers.interopDefault(_createSuper);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _parserJs = require("../Parser.js");
var _constantsJs = require("../constants.js");
var _utilsJs = require("../utils.js");
var DayOfYearParser = /*#__PURE__*/ function(_Parser) {
    (0, _inheritsDefault.default)(DayOfYearParser, _Parser);
    var _super = (0, _createSuperDefault.default)(DayOfYearParser);
    function DayOfYearParser() {
        var _this;
        (0, _classCallCheckDefault.default)(this, DayOfYearParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "priority", 90);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "subpriority", 1);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "incompatibleTokens", [
            "Y",
            "R",
            "q",
            "Q",
            "M",
            "L",
            "w",
            "I",
            "d",
            "E",
            "i",
            "e",
            "c",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, _createClassDefault.default)(DayOfYearParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case "D":
                    case "DD":
                        return (0, _utilsJs.parseNumericPattern)((0, _constantsJs.numericPatterns).dayOfYear, dateString);
                    case "Do":
                        return match.ordinalNumber(dateString, {
                            unit: "date"
                        });
                    default:
                        return (0, _utilsJs.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(date, value) {
                var year = date.getUTCFullYear();
                var isLeapYear = (0, _utilsJs.isLeapYearIndex)(year);
                if (isLeapYear) return value >= 1 && value <= 366;
                else return value >= 1 && value <= 365;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMonth(0, value);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return DayOfYearParser;
}((0, _parserJs.Parser));

},{"@babel/runtime/helpers/esm/classCallCheck":"17u6i","@babel/runtime/helpers/esm/createClass":"2lub7","@babel/runtime/helpers/esm/assertThisInitialized":"hqdCW","@babel/runtime/helpers/esm/inherits":"erMSu","@babel/runtime/helpers/esm/createSuper":"wUOND","@babel/runtime/helpers/esm/defineProperty":"5XpnH","../Parser.js":"7RnfN","../constants.js":"J1mKQ","../utils.js":"jpqG3","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4DRIi":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DayParser", ()=>DayParser);
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inherits = require("@babel/runtime/helpers/esm/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _createSuper = require("@babel/runtime/helpers/esm/createSuper");
var _createSuperDefault = parcelHelpers.interopDefault(_createSuper);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _parserJs = require("../Parser.js");
var _indexJs = require("../../../_lib/setUTCDay/index.js"); // Day of week
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var DayParser = /*#__PURE__*/ function(_Parser) {
    (0, _inheritsDefault.default)(DayParser, _Parser);
    var _super = (0, _createSuperDefault.default)(DayParser);
    function DayParser() {
        var _this;
        (0, _classCallCheckDefault.default)(this, DayParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "priority", 90);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "incompatibleTokens", [
            "D",
            "i",
            "e",
            "c",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, _createClassDefault.default)(DayParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    // Tue
                    case "E":
                    case "EE":
                    case "EEE":
                        return match.day(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "short",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    // T
                    case "EEEEE":
                        return match.day(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    // Tu
                    case "EEEEEE":
                        return match.day(dateString, {
                            width: "short",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    // Tuesday
                    case "EEEE":
                    default:
                        return match.day(dateString, {
                            width: "wide",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "short",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 6;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value, options) {
                date = (0, _indexJsDefault.default)(date, value, options);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return DayParser;
}((0, _parserJs.Parser));

},{"@babel/runtime/helpers/esm/classCallCheck":"17u6i","@babel/runtime/helpers/esm/createClass":"2lub7","@babel/runtime/helpers/esm/assertThisInitialized":"hqdCW","@babel/runtime/helpers/esm/inherits":"erMSu","@babel/runtime/helpers/esm/createSuper":"wUOND","@babel/runtime/helpers/esm/defineProperty":"5XpnH","../Parser.js":"7RnfN","../../../_lib/setUTCDay/index.js":"13Fsy","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"13Fsy":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>setUTCDay);
var _indexJs = require("../../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../toInteger/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("../defaultOptions/index.js");
function setUTCDay(dirtyDate, dirtyDay, options) {
    var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, _indexJsDefault1.default)(2, arguments);
    var defaultOptions = (0, _indexJs3.getDefaultOptions)();
    var weekStartsOn = (0, _indexJsDefault2.default)((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0);
    // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
    var date = (0, _indexJsDefault.default)(dirtyDate);
    var day = (0, _indexJsDefault2.default)(dirtyDay);
    var currentDay = date.getUTCDay();
    var remainder = day % 7;
    var dayIndex = (remainder + 7) % 7;
    var diff = (dayIndex < weekStartsOn ? 7 : 0) + day - currentDay;
    date.setUTCDate(date.getUTCDate() + diff);
    return date;
}

},{"../../toDate/index.js":"fYDr6","../requiredArgs/index.js":"180ox","../toInteger/index.js":"fgaQ2","../defaultOptions/index.js":"j28dB","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"kZBTO":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LocalDayParser", ()=>LocalDayParser);
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inherits = require("@babel/runtime/helpers/esm/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _createSuper = require("@babel/runtime/helpers/esm/createSuper");
var _createSuperDefault = parcelHelpers.interopDefault(_createSuper);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _parserJs = require("../Parser.js");
var _utilsJs = require("../utils.js");
var _indexJs = require("../../../_lib/setUTCDay/index.js"); // Local day of week
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var LocalDayParser = /*#__PURE__*/ function(_Parser) {
    (0, _inheritsDefault.default)(LocalDayParser, _Parser);
    var _super = (0, _createSuperDefault.default)(LocalDayParser);
    function LocalDayParser() {
        var _this;
        (0, _classCallCheckDefault.default)(this, LocalDayParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "priority", 90);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "incompatibleTokens", [
            "y",
            "R",
            "u",
            "q",
            "Q",
            "M",
            "L",
            "I",
            "d",
            "D",
            "E",
            "i",
            "c",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, _createClassDefault.default)(LocalDayParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match, options) {
                var valueCallback = function valueCallback(value) {
                    var wholeWeekDays = Math.floor((value - 1) / 7) * 7;
                    return (value + options.weekStartsOn + 6) % 7 + wholeWeekDays;
                };
                switch(token){
                    // 3
                    case "e":
                    case "ee":
                        // 03
                        return (0, _utilsJs.mapValue)((0, _utilsJs.parseNDigits)(token.length, dateString), valueCallback);
                    // 3rd
                    case "eo":
                        return (0, _utilsJs.mapValue)(match.ordinalNumber(dateString, {
                            unit: "day"
                        }), valueCallback);
                    // Tue
                    case "eee":
                        return match.day(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "short",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    // T
                    case "eeeee":
                        return match.day(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    // Tu
                    case "eeeeee":
                        return match.day(dateString, {
                            width: "short",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    // Tuesday
                    case "eeee":
                    default:
                        return match.day(dateString, {
                            width: "wide",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "short",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 6;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value, options) {
                date = (0, _indexJsDefault.default)(date, value, options);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return LocalDayParser;
}((0, _parserJs.Parser));

},{"@babel/runtime/helpers/esm/classCallCheck":"17u6i","@babel/runtime/helpers/esm/createClass":"2lub7","@babel/runtime/helpers/esm/assertThisInitialized":"hqdCW","@babel/runtime/helpers/esm/inherits":"erMSu","@babel/runtime/helpers/esm/createSuper":"wUOND","@babel/runtime/helpers/esm/defineProperty":"5XpnH","../Parser.js":"7RnfN","../utils.js":"jpqG3","../../../_lib/setUTCDay/index.js":"13Fsy","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"CoUHj":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StandAloneLocalDayParser", ()=>StandAloneLocalDayParser);
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inherits = require("@babel/runtime/helpers/esm/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _createSuper = require("@babel/runtime/helpers/esm/createSuper");
var _createSuperDefault = parcelHelpers.interopDefault(_createSuper);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _parserJs = require("../Parser.js");
var _utilsJs = require("../utils.js");
var _indexJs = require("../../../_lib/setUTCDay/index.js"); // Stand-alone local day of week
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var StandAloneLocalDayParser = /*#__PURE__*/ function(_Parser) {
    (0, _inheritsDefault.default)(StandAloneLocalDayParser, _Parser);
    var _super = (0, _createSuperDefault.default)(StandAloneLocalDayParser);
    function StandAloneLocalDayParser() {
        var _this;
        (0, _classCallCheckDefault.default)(this, StandAloneLocalDayParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "priority", 90);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "incompatibleTokens", [
            "y",
            "R",
            "u",
            "q",
            "Q",
            "M",
            "L",
            "I",
            "d",
            "D",
            "E",
            "i",
            "e",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, _createClassDefault.default)(StandAloneLocalDayParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match, options) {
                var valueCallback = function valueCallback(value) {
                    var wholeWeekDays = Math.floor((value - 1) / 7) * 7;
                    return (value + options.weekStartsOn + 6) % 7 + wholeWeekDays;
                };
                switch(token){
                    // 3
                    case "c":
                    case "cc":
                        // 03
                        return (0, _utilsJs.mapValue)((0, _utilsJs.parseNDigits)(token.length, dateString), valueCallback);
                    // 3rd
                    case "co":
                        return (0, _utilsJs.mapValue)(match.ordinalNumber(dateString, {
                            unit: "day"
                        }), valueCallback);
                    // Tue
                    case "ccc":
                        return match.day(dateString, {
                            width: "abbreviated",
                            context: "standalone"
                        }) || match.day(dateString, {
                            width: "short",
                            context: "standalone"
                        }) || match.day(dateString, {
                            width: "narrow",
                            context: "standalone"
                        });
                    // T
                    case "ccccc":
                        return match.day(dateString, {
                            width: "narrow",
                            context: "standalone"
                        });
                    // Tu
                    case "cccccc":
                        return match.day(dateString, {
                            width: "short",
                            context: "standalone"
                        }) || match.day(dateString, {
                            width: "narrow",
                            context: "standalone"
                        });
                    // Tuesday
                    case "cccc":
                    default:
                        return match.day(dateString, {
                            width: "wide",
                            context: "standalone"
                        }) || match.day(dateString, {
                            width: "abbreviated",
                            context: "standalone"
                        }) || match.day(dateString, {
                            width: "short",
                            context: "standalone"
                        }) || match.day(dateString, {
                            width: "narrow",
                            context: "standalone"
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 6;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value, options) {
                date = (0, _indexJsDefault.default)(date, value, options);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return StandAloneLocalDayParser;
}((0, _parserJs.Parser));

},{"@babel/runtime/helpers/esm/classCallCheck":"17u6i","@babel/runtime/helpers/esm/createClass":"2lub7","@babel/runtime/helpers/esm/assertThisInitialized":"hqdCW","@babel/runtime/helpers/esm/inherits":"erMSu","@babel/runtime/helpers/esm/createSuper":"wUOND","@babel/runtime/helpers/esm/defineProperty":"5XpnH","../Parser.js":"7RnfN","../utils.js":"jpqG3","../../../_lib/setUTCDay/index.js":"13Fsy","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2QSWv":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ISODayParser", ()=>ISODayParser);
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inherits = require("@babel/runtime/helpers/esm/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _createSuper = require("@babel/runtime/helpers/esm/createSuper");
var _createSuperDefault = parcelHelpers.interopDefault(_createSuper);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _parserJs = require("../Parser.js");
var _utilsJs = require("../utils.js");
var _indexJs = require("../../../_lib/setUTCISODay/index.js"); // ISO day of week
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var ISODayParser = /*#__PURE__*/ function(_Parser) {
    (0, _inheritsDefault.default)(ISODayParser, _Parser);
    var _super = (0, _createSuperDefault.default)(ISODayParser);
    function ISODayParser() {
        var _this;
        (0, _classCallCheckDefault.default)(this, ISODayParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "priority", 90);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "incompatibleTokens", [
            "y",
            "Y",
            "u",
            "q",
            "Q",
            "M",
            "L",
            "w",
            "d",
            "D",
            "E",
            "e",
            "c",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, _createClassDefault.default)(ISODayParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                var valueCallback = function valueCallback(value) {
                    if (value === 0) return 7;
                    return value;
                };
                switch(token){
                    // 2
                    case "i":
                    case "ii":
                        // 02
                        return (0, _utilsJs.parseNDigits)(token.length, dateString);
                    // 2nd
                    case "io":
                        return match.ordinalNumber(dateString, {
                            unit: "day"
                        });
                    // Tue
                    case "iii":
                        return (0, _utilsJs.mapValue)(match.day(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "short",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "narrow",
                            context: "formatting"
                        }), valueCallback);
                    // T
                    case "iiiii":
                        return (0, _utilsJs.mapValue)(match.day(dateString, {
                            width: "narrow",
                            context: "formatting"
                        }), valueCallback);
                    // Tu
                    case "iiiiii":
                        return (0, _utilsJs.mapValue)(match.day(dateString, {
                            width: "short",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "narrow",
                            context: "formatting"
                        }), valueCallback);
                    // Tuesday
                    case "iiii":
                    default:
                        return (0, _utilsJs.mapValue)(match.day(dateString, {
                            width: "wide",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "short",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "narrow",
                            context: "formatting"
                        }), valueCallback);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 7;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date = (0, _indexJsDefault.default)(date, value);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return ISODayParser;
}((0, _parserJs.Parser));

},{"@babel/runtime/helpers/esm/classCallCheck":"17u6i","@babel/runtime/helpers/esm/createClass":"2lub7","@babel/runtime/helpers/esm/assertThisInitialized":"hqdCW","@babel/runtime/helpers/esm/inherits":"erMSu","@babel/runtime/helpers/esm/createSuper":"wUOND","@babel/runtime/helpers/esm/defineProperty":"5XpnH","../Parser.js":"7RnfN","../utils.js":"jpqG3","../../../_lib/setUTCISODay/index.js":"35p2s","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"35p2s":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>setUTCISODay);
var _indexJs = require("../../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../toInteger/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
function setUTCISODay(dirtyDate, dirtyDay) {
    (0, _indexJsDefault1.default)(2, arguments);
    var day = (0, _indexJsDefault2.default)(dirtyDay);
    if (day % 7 === 0) day = day - 7;
    var weekStartsOn = 1;
    var date = (0, _indexJsDefault.default)(dirtyDate);
    var currentDay = date.getUTCDay();
    var remainder = day % 7;
    var dayIndex = (remainder + 7) % 7;
    var diff = (dayIndex < weekStartsOn ? 7 : 0) + day - currentDay;
    date.setUTCDate(date.getUTCDate() + diff);
    return date;
}

},{"../../toDate/index.js":"fYDr6","../requiredArgs/index.js":"180ox","../toInteger/index.js":"fgaQ2","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"deerG":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AMPMParser", ()=>AMPMParser);
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inherits = require("@babel/runtime/helpers/esm/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _createSuper = require("@babel/runtime/helpers/esm/createSuper");
var _createSuperDefault = parcelHelpers.interopDefault(_createSuper);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _parserJs = require("../Parser.js");
var _utilsJs = require("../utils.js");
var AMPMParser = /*#__PURE__*/ function(_Parser) {
    (0, _inheritsDefault.default)(AMPMParser, _Parser);
    var _super = (0, _createSuperDefault.default)(AMPMParser);
    function AMPMParser() {
        var _this;
        (0, _classCallCheckDefault.default)(this, AMPMParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "priority", 80);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "incompatibleTokens", [
            "b",
            "B",
            "H",
            "k",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, _createClassDefault.default)(AMPMParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case "a":
                    case "aa":
                    case "aaa":
                        return match.dayPeriod(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.dayPeriod(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    case "aaaaa":
                        return match.dayPeriod(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    case "aaaa":
                    default:
                        return match.dayPeriod(dateString, {
                            width: "wide",
                            context: "formatting"
                        }) || match.dayPeriod(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.dayPeriod(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                }
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCHours((0, _utilsJs.dayPeriodEnumToHours)(value), 0, 0, 0);
                return date;
            }
        }
    ]);
    return AMPMParser;
}((0, _parserJs.Parser));

},{"@babel/runtime/helpers/esm/classCallCheck":"17u6i","@babel/runtime/helpers/esm/createClass":"2lub7","@babel/runtime/helpers/esm/assertThisInitialized":"hqdCW","@babel/runtime/helpers/esm/inherits":"erMSu","@babel/runtime/helpers/esm/createSuper":"wUOND","@babel/runtime/helpers/esm/defineProperty":"5XpnH","../Parser.js":"7RnfN","../utils.js":"jpqG3","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3a8AR":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AMPMMidnightParser", ()=>AMPMMidnightParser);
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inherits = require("@babel/runtime/helpers/esm/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _createSuper = require("@babel/runtime/helpers/esm/createSuper");
var _createSuperDefault = parcelHelpers.interopDefault(_createSuper);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _parserJs = require("../Parser.js");
var _utilsJs = require("../utils.js");
var AMPMMidnightParser = /*#__PURE__*/ function(_Parser) {
    (0, _inheritsDefault.default)(AMPMMidnightParser, _Parser);
    var _super = (0, _createSuperDefault.default)(AMPMMidnightParser);
    function AMPMMidnightParser() {
        var _this;
        (0, _classCallCheckDefault.default)(this, AMPMMidnightParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "priority", 80);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "incompatibleTokens", [
            "a",
            "B",
            "H",
            "k",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, _createClassDefault.default)(AMPMMidnightParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case "b":
                    case "bb":
                    case "bbb":
                        return match.dayPeriod(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.dayPeriod(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    case "bbbbb":
                        return match.dayPeriod(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    case "bbbb":
                    default:
                        return match.dayPeriod(dateString, {
                            width: "wide",
                            context: "formatting"
                        }) || match.dayPeriod(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.dayPeriod(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                }
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCHours((0, _utilsJs.dayPeriodEnumToHours)(value), 0, 0, 0);
                return date;
            }
        }
    ]);
    return AMPMMidnightParser;
}((0, _parserJs.Parser));

},{"@babel/runtime/helpers/esm/classCallCheck":"17u6i","@babel/runtime/helpers/esm/createClass":"2lub7","@babel/runtime/helpers/esm/assertThisInitialized":"hqdCW","@babel/runtime/helpers/esm/inherits":"erMSu","@babel/runtime/helpers/esm/createSuper":"wUOND","@babel/runtime/helpers/esm/defineProperty":"5XpnH","../Parser.js":"7RnfN","../utils.js":"jpqG3","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"lQ3tQ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DayPeriodParser", ()=>DayPeriodParser);
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inherits = require("@babel/runtime/helpers/esm/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _createSuper = require("@babel/runtime/helpers/esm/createSuper");
var _createSuperDefault = parcelHelpers.interopDefault(_createSuper);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _parserJs = require("../Parser.js");
var _utilsJs = require("../utils.js"); // in the morning, in the afternoon, in the evening, at night
var DayPeriodParser = /*#__PURE__*/ function(_Parser) {
    (0, _inheritsDefault.default)(DayPeriodParser, _Parser);
    var _super = (0, _createSuperDefault.default)(DayPeriodParser);
    function DayPeriodParser() {
        var _this;
        (0, _classCallCheckDefault.default)(this, DayPeriodParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "priority", 80);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "incompatibleTokens", [
            "a",
            "b",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, _createClassDefault.default)(DayPeriodParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case "B":
                    case "BB":
                    case "BBB":
                        return match.dayPeriod(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.dayPeriod(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    case "BBBBB":
                        return match.dayPeriod(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    case "BBBB":
                    default:
                        return match.dayPeriod(dateString, {
                            width: "wide",
                            context: "formatting"
                        }) || match.dayPeriod(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.dayPeriod(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                }
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCHours((0, _utilsJs.dayPeriodEnumToHours)(value), 0, 0, 0);
                return date;
            }
        }
    ]);
    return DayPeriodParser;
}((0, _parserJs.Parser));

},{"@babel/runtime/helpers/esm/classCallCheck":"17u6i","@babel/runtime/helpers/esm/createClass":"2lub7","@babel/runtime/helpers/esm/assertThisInitialized":"hqdCW","@babel/runtime/helpers/esm/inherits":"erMSu","@babel/runtime/helpers/esm/createSuper":"wUOND","@babel/runtime/helpers/esm/defineProperty":"5XpnH","../Parser.js":"7RnfN","../utils.js":"jpqG3","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6B3Bf":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Hour1to12Parser", ()=>Hour1to12Parser);
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inherits = require("@babel/runtime/helpers/esm/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _createSuper = require("@babel/runtime/helpers/esm/createSuper");
var _createSuperDefault = parcelHelpers.interopDefault(_createSuper);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _parserJs = require("../Parser.js");
var _constantsJs = require("../constants.js");
var _utilsJs = require("../utils.js");
var Hour1to12Parser = /*#__PURE__*/ function(_Parser) {
    (0, _inheritsDefault.default)(Hour1to12Parser, _Parser);
    var _super = (0, _createSuperDefault.default)(Hour1to12Parser);
    function Hour1to12Parser() {
        var _this;
        (0, _classCallCheckDefault.default)(this, Hour1to12Parser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "priority", 70);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "incompatibleTokens", [
            "H",
            "K",
            "k",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, _createClassDefault.default)(Hour1to12Parser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case "h":
                        return (0, _utilsJs.parseNumericPattern)((0, _constantsJs.numericPatterns).hour12h, dateString);
                    case "ho":
                        return match.ordinalNumber(dateString, {
                            unit: "hour"
                        });
                    default:
                        return (0, _utilsJs.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 12;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                var isPM = date.getUTCHours() >= 12;
                if (isPM && value < 12) date.setUTCHours(value + 12, 0, 0, 0);
                else if (!isPM && value === 12) date.setUTCHours(0, 0, 0, 0);
                else date.setUTCHours(value, 0, 0, 0);
                return date;
            }
        }
    ]);
    return Hour1to12Parser;
}((0, _parserJs.Parser));

},{"@babel/runtime/helpers/esm/classCallCheck":"17u6i","@babel/runtime/helpers/esm/createClass":"2lub7","@babel/runtime/helpers/esm/assertThisInitialized":"hqdCW","@babel/runtime/helpers/esm/inherits":"erMSu","@babel/runtime/helpers/esm/createSuper":"wUOND","@babel/runtime/helpers/esm/defineProperty":"5XpnH","../Parser.js":"7RnfN","../constants.js":"J1mKQ","../utils.js":"jpqG3","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"e44gO":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Hour0to23Parser", ()=>Hour0to23Parser);
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inherits = require("@babel/runtime/helpers/esm/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _createSuper = require("@babel/runtime/helpers/esm/createSuper");
var _createSuperDefault = parcelHelpers.interopDefault(_createSuper);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _parserJs = require("../Parser.js");
var _constantsJs = require("../constants.js");
var _utilsJs = require("../utils.js");
var Hour0to23Parser = /*#__PURE__*/ function(_Parser) {
    (0, _inheritsDefault.default)(Hour0to23Parser, _Parser);
    var _super = (0, _createSuperDefault.default)(Hour0to23Parser);
    function Hour0to23Parser() {
        var _this;
        (0, _classCallCheckDefault.default)(this, Hour0to23Parser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "priority", 70);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "incompatibleTokens", [
            "a",
            "b",
            "h",
            "K",
            "k",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, _createClassDefault.default)(Hour0to23Parser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case "H":
                        return (0, _utilsJs.parseNumericPattern)((0, _constantsJs.numericPatterns).hour23h, dateString);
                    case "Ho":
                        return match.ordinalNumber(dateString, {
                            unit: "hour"
                        });
                    default:
                        return (0, _utilsJs.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 23;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCHours(value, 0, 0, 0);
                return date;
            }
        }
    ]);
    return Hour0to23Parser;
}((0, _parserJs.Parser));

},{"@babel/runtime/helpers/esm/classCallCheck":"17u6i","@babel/runtime/helpers/esm/createClass":"2lub7","@babel/runtime/helpers/esm/assertThisInitialized":"hqdCW","@babel/runtime/helpers/esm/inherits":"erMSu","@babel/runtime/helpers/esm/createSuper":"wUOND","@babel/runtime/helpers/esm/defineProperty":"5XpnH","../Parser.js":"7RnfN","../constants.js":"J1mKQ","../utils.js":"jpqG3","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2OGRl":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Hour0To11Parser", ()=>Hour0To11Parser);
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inherits = require("@babel/runtime/helpers/esm/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _createSuper = require("@babel/runtime/helpers/esm/createSuper");
var _createSuperDefault = parcelHelpers.interopDefault(_createSuper);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _parserJs = require("../Parser.js");
var _constantsJs = require("../constants.js");
var _utilsJs = require("../utils.js");
var Hour0To11Parser = /*#__PURE__*/ function(_Parser) {
    (0, _inheritsDefault.default)(Hour0To11Parser, _Parser);
    var _super = (0, _createSuperDefault.default)(Hour0To11Parser);
    function Hour0To11Parser() {
        var _this;
        (0, _classCallCheckDefault.default)(this, Hour0To11Parser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "priority", 70);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "incompatibleTokens", [
            "h",
            "H",
            "k",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, _createClassDefault.default)(Hour0To11Parser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case "K":
                        return (0, _utilsJs.parseNumericPattern)((0, _constantsJs.numericPatterns).hour11h, dateString);
                    case "Ko":
                        return match.ordinalNumber(dateString, {
                            unit: "hour"
                        });
                    default:
                        return (0, _utilsJs.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 11;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                var isPM = date.getUTCHours() >= 12;
                if (isPM && value < 12) date.setUTCHours(value + 12, 0, 0, 0);
                else date.setUTCHours(value, 0, 0, 0);
                return date;
            }
        }
    ]);
    return Hour0To11Parser;
}((0, _parserJs.Parser));

},{"@babel/runtime/helpers/esm/classCallCheck":"17u6i","@babel/runtime/helpers/esm/createClass":"2lub7","@babel/runtime/helpers/esm/assertThisInitialized":"hqdCW","@babel/runtime/helpers/esm/inherits":"erMSu","@babel/runtime/helpers/esm/createSuper":"wUOND","@babel/runtime/helpers/esm/defineProperty":"5XpnH","../Parser.js":"7RnfN","../constants.js":"J1mKQ","../utils.js":"jpqG3","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"iOlos":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Hour1To24Parser", ()=>Hour1To24Parser);
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inherits = require("@babel/runtime/helpers/esm/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _createSuper = require("@babel/runtime/helpers/esm/createSuper");
var _createSuperDefault = parcelHelpers.interopDefault(_createSuper);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _parserJs = require("../Parser.js");
var _constantsJs = require("../constants.js");
var _utilsJs = require("../utils.js");
var Hour1To24Parser = /*#__PURE__*/ function(_Parser) {
    (0, _inheritsDefault.default)(Hour1To24Parser, _Parser);
    var _super = (0, _createSuperDefault.default)(Hour1To24Parser);
    function Hour1To24Parser() {
        var _this;
        (0, _classCallCheckDefault.default)(this, Hour1To24Parser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "priority", 70);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "incompatibleTokens", [
            "a",
            "b",
            "h",
            "H",
            "K",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, _createClassDefault.default)(Hour1To24Parser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case "k":
                        return (0, _utilsJs.parseNumericPattern)((0, _constantsJs.numericPatterns).hour24h, dateString);
                    case "ko":
                        return match.ordinalNumber(dateString, {
                            unit: "hour"
                        });
                    default:
                        return (0, _utilsJs.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 24;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                var hours = value <= 24 ? value % 24 : value;
                date.setUTCHours(hours, 0, 0, 0);
                return date;
            }
        }
    ]);
    return Hour1To24Parser;
}((0, _parserJs.Parser));

},{"@babel/runtime/helpers/esm/classCallCheck":"17u6i","@babel/runtime/helpers/esm/createClass":"2lub7","@babel/runtime/helpers/esm/assertThisInitialized":"hqdCW","@babel/runtime/helpers/esm/inherits":"erMSu","@babel/runtime/helpers/esm/createSuper":"wUOND","@babel/runtime/helpers/esm/defineProperty":"5XpnH","../Parser.js":"7RnfN","../constants.js":"J1mKQ","../utils.js":"jpqG3","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2x6o5":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MinuteParser", ()=>MinuteParser);
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inherits = require("@babel/runtime/helpers/esm/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _createSuper = require("@babel/runtime/helpers/esm/createSuper");
var _createSuperDefault = parcelHelpers.interopDefault(_createSuper);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _parserJs = require("../Parser.js");
var _constantsJs = require("../constants.js");
var _utilsJs = require("../utils.js");
var MinuteParser = /*#__PURE__*/ function(_Parser) {
    (0, _inheritsDefault.default)(MinuteParser, _Parser);
    var _super = (0, _createSuperDefault.default)(MinuteParser);
    function MinuteParser() {
        var _this;
        (0, _classCallCheckDefault.default)(this, MinuteParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "priority", 60);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "incompatibleTokens", [
            "t",
            "T"
        ]);
        return _this;
    }
    (0, _createClassDefault.default)(MinuteParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case "m":
                        return (0, _utilsJs.parseNumericPattern)((0, _constantsJs.numericPatterns).minute, dateString);
                    case "mo":
                        return match.ordinalNumber(dateString, {
                            unit: "minute"
                        });
                    default:
                        return (0, _utilsJs.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 59;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMinutes(value, 0, 0);
                return date;
            }
        }
    ]);
    return MinuteParser;
}((0, _parserJs.Parser));

},{"@babel/runtime/helpers/esm/classCallCheck":"17u6i","@babel/runtime/helpers/esm/createClass":"2lub7","@babel/runtime/helpers/esm/assertThisInitialized":"hqdCW","@babel/runtime/helpers/esm/inherits":"erMSu","@babel/runtime/helpers/esm/createSuper":"wUOND","@babel/runtime/helpers/esm/defineProperty":"5XpnH","../Parser.js":"7RnfN","../constants.js":"J1mKQ","../utils.js":"jpqG3","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"e9Os0":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SecondParser", ()=>SecondParser);
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inherits = require("@babel/runtime/helpers/esm/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _createSuper = require("@babel/runtime/helpers/esm/createSuper");
var _createSuperDefault = parcelHelpers.interopDefault(_createSuper);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _parserJs = require("../Parser.js");
var _constantsJs = require("../constants.js");
var _utilsJs = require("../utils.js");
var SecondParser = /*#__PURE__*/ function(_Parser) {
    (0, _inheritsDefault.default)(SecondParser, _Parser);
    var _super = (0, _createSuperDefault.default)(SecondParser);
    function SecondParser() {
        var _this;
        (0, _classCallCheckDefault.default)(this, SecondParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "priority", 50);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "incompatibleTokens", [
            "t",
            "T"
        ]);
        return _this;
    }
    (0, _createClassDefault.default)(SecondParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case "s":
                        return (0, _utilsJs.parseNumericPattern)((0, _constantsJs.numericPatterns).second, dateString);
                    case "so":
                        return match.ordinalNumber(dateString, {
                            unit: "second"
                        });
                    default:
                        return (0, _utilsJs.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 59;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCSeconds(value, 0);
                return date;
            }
        }
    ]);
    return SecondParser;
}((0, _parserJs.Parser));

},{"@babel/runtime/helpers/esm/classCallCheck":"17u6i","@babel/runtime/helpers/esm/createClass":"2lub7","@babel/runtime/helpers/esm/assertThisInitialized":"hqdCW","@babel/runtime/helpers/esm/inherits":"erMSu","@babel/runtime/helpers/esm/createSuper":"wUOND","@babel/runtime/helpers/esm/defineProperty":"5XpnH","../Parser.js":"7RnfN","../constants.js":"J1mKQ","../utils.js":"jpqG3","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"10COg":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "FractionOfSecondParser", ()=>FractionOfSecondParser);
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inherits = require("@babel/runtime/helpers/esm/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _createSuper = require("@babel/runtime/helpers/esm/createSuper");
var _createSuperDefault = parcelHelpers.interopDefault(_createSuper);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _parserJs = require("../Parser.js");
var _utilsJs = require("../utils.js");
var FractionOfSecondParser = /*#__PURE__*/ function(_Parser) {
    (0, _inheritsDefault.default)(FractionOfSecondParser, _Parser);
    var _super = (0, _createSuperDefault.default)(FractionOfSecondParser);
    function FractionOfSecondParser() {
        var _this;
        (0, _classCallCheckDefault.default)(this, FractionOfSecondParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "priority", 30);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "incompatibleTokens", [
            "t",
            "T"
        ]);
        return _this;
    }
    (0, _createClassDefault.default)(FractionOfSecondParser, [
        {
            key: "parse",
            value: function parse(dateString, token) {
                var valueCallback = function valueCallback(value) {
                    return Math.floor(value * Math.pow(10, -token.length + 3));
                };
                return (0, _utilsJs.mapValue)((0, _utilsJs.parseNDigits)(token.length, dateString), valueCallback);
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMilliseconds(value);
                return date;
            }
        }
    ]);
    return FractionOfSecondParser;
}((0, _parserJs.Parser));

},{"@babel/runtime/helpers/esm/classCallCheck":"17u6i","@babel/runtime/helpers/esm/createClass":"2lub7","@babel/runtime/helpers/esm/assertThisInitialized":"hqdCW","@babel/runtime/helpers/esm/inherits":"erMSu","@babel/runtime/helpers/esm/createSuper":"wUOND","@babel/runtime/helpers/esm/defineProperty":"5XpnH","../Parser.js":"7RnfN","../utils.js":"jpqG3","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"evbLy":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ISOTimezoneWithZParser", ()=>ISOTimezoneWithZParser);
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inherits = require("@babel/runtime/helpers/esm/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _createSuper = require("@babel/runtime/helpers/esm/createSuper");
var _createSuperDefault = parcelHelpers.interopDefault(_createSuper);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _parserJs = require("../Parser.js");
var _constantsJs = require("../constants.js");
var _utilsJs = require("../utils.js"); // Timezone (ISO-8601. +00:00 is `'Z'`)
var ISOTimezoneWithZParser = /*#__PURE__*/ function(_Parser) {
    (0, _inheritsDefault.default)(ISOTimezoneWithZParser, _Parser);
    var _super = (0, _createSuperDefault.default)(ISOTimezoneWithZParser);
    function ISOTimezoneWithZParser() {
        var _this;
        (0, _classCallCheckDefault.default)(this, ISOTimezoneWithZParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "priority", 10);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "incompatibleTokens", [
            "t",
            "T",
            "x"
        ]);
        return _this;
    }
    (0, _createClassDefault.default)(ISOTimezoneWithZParser, [
        {
            key: "parse",
            value: function parse(dateString, token) {
                switch(token){
                    case "X":
                        return (0, _utilsJs.parseTimezonePattern)((0, _constantsJs.timezonePatterns).basicOptionalMinutes, dateString);
                    case "XX":
                        return (0, _utilsJs.parseTimezonePattern)((0, _constantsJs.timezonePatterns).basic, dateString);
                    case "XXXX":
                        return (0, _utilsJs.parseTimezonePattern)((0, _constantsJs.timezonePatterns).basicOptionalSeconds, dateString);
                    case "XXXXX":
                        return (0, _utilsJs.parseTimezonePattern)((0, _constantsJs.timezonePatterns).extendedOptionalSeconds, dateString);
                    case "XXX":
                    default:
                        return (0, _utilsJs.parseTimezonePattern)((0, _constantsJs.timezonePatterns).extended, dateString);
                }
            }
        },
        {
            key: "set",
            value: function set(date, flags, value) {
                if (flags.timestampIsSet) return date;
                return new Date(date.getTime() - value);
            }
        }
    ]);
    return ISOTimezoneWithZParser;
}((0, _parserJs.Parser));

},{"@babel/runtime/helpers/esm/classCallCheck":"17u6i","@babel/runtime/helpers/esm/createClass":"2lub7","@babel/runtime/helpers/esm/assertThisInitialized":"hqdCW","@babel/runtime/helpers/esm/inherits":"erMSu","@babel/runtime/helpers/esm/createSuper":"wUOND","@babel/runtime/helpers/esm/defineProperty":"5XpnH","../Parser.js":"7RnfN","../constants.js":"J1mKQ","../utils.js":"jpqG3","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1MoHP":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ISOTimezoneParser", ()=>ISOTimezoneParser);
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inherits = require("@babel/runtime/helpers/esm/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _createSuper = require("@babel/runtime/helpers/esm/createSuper");
var _createSuperDefault = parcelHelpers.interopDefault(_createSuper);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _parserJs = require("../Parser.js");
var _constantsJs = require("../constants.js");
var _utilsJs = require("../utils.js"); // Timezone (ISO-8601)
var ISOTimezoneParser = /*#__PURE__*/ function(_Parser) {
    (0, _inheritsDefault.default)(ISOTimezoneParser, _Parser);
    var _super = (0, _createSuperDefault.default)(ISOTimezoneParser);
    function ISOTimezoneParser() {
        var _this;
        (0, _classCallCheckDefault.default)(this, ISOTimezoneParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "priority", 10);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "incompatibleTokens", [
            "t",
            "T",
            "X"
        ]);
        return _this;
    }
    (0, _createClassDefault.default)(ISOTimezoneParser, [
        {
            key: "parse",
            value: function parse(dateString, token) {
                switch(token){
                    case "x":
                        return (0, _utilsJs.parseTimezonePattern)((0, _constantsJs.timezonePatterns).basicOptionalMinutes, dateString);
                    case "xx":
                        return (0, _utilsJs.parseTimezonePattern)((0, _constantsJs.timezonePatterns).basic, dateString);
                    case "xxxx":
                        return (0, _utilsJs.parseTimezonePattern)((0, _constantsJs.timezonePatterns).basicOptionalSeconds, dateString);
                    case "xxxxx":
                        return (0, _utilsJs.parseTimezonePattern)((0, _constantsJs.timezonePatterns).extendedOptionalSeconds, dateString);
                    case "xxx":
                    default:
                        return (0, _utilsJs.parseTimezonePattern)((0, _constantsJs.timezonePatterns).extended, dateString);
                }
            }
        },
        {
            key: "set",
            value: function set(date, flags, value) {
                if (flags.timestampIsSet) return date;
                return new Date(date.getTime() - value);
            }
        }
    ]);
    return ISOTimezoneParser;
}((0, _parserJs.Parser));

},{"@babel/runtime/helpers/esm/classCallCheck":"17u6i","@babel/runtime/helpers/esm/createClass":"2lub7","@babel/runtime/helpers/esm/assertThisInitialized":"hqdCW","@babel/runtime/helpers/esm/inherits":"erMSu","@babel/runtime/helpers/esm/createSuper":"wUOND","@babel/runtime/helpers/esm/defineProperty":"5XpnH","../Parser.js":"7RnfN","../constants.js":"J1mKQ","../utils.js":"jpqG3","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7IzaS":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TimestampSecondsParser", ()=>TimestampSecondsParser);
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inherits = require("@babel/runtime/helpers/esm/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _createSuper = require("@babel/runtime/helpers/esm/createSuper");
var _createSuperDefault = parcelHelpers.interopDefault(_createSuper);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _parserJs = require("../Parser.js");
var _utilsJs = require("../utils.js");
var TimestampSecondsParser = /*#__PURE__*/ function(_Parser) {
    (0, _inheritsDefault.default)(TimestampSecondsParser, _Parser);
    var _super = (0, _createSuperDefault.default)(TimestampSecondsParser);
    function TimestampSecondsParser() {
        var _this;
        (0, _classCallCheckDefault.default)(this, TimestampSecondsParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "priority", 40);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "incompatibleTokens", "*");
        return _this;
    }
    (0, _createClassDefault.default)(TimestampSecondsParser, [
        {
            key: "parse",
            value: function parse(dateString) {
                return (0, _utilsJs.parseAnyDigitsSigned)(dateString);
            }
        },
        {
            key: "set",
            value: function set(_date, _flags, value) {
                return [
                    new Date(value * 1000),
                    {
                        timestampIsSet: true
                    }
                ];
            }
        }
    ]);
    return TimestampSecondsParser;
}((0, _parserJs.Parser));

},{"@babel/runtime/helpers/esm/classCallCheck":"17u6i","@babel/runtime/helpers/esm/createClass":"2lub7","@babel/runtime/helpers/esm/assertThisInitialized":"hqdCW","@babel/runtime/helpers/esm/inherits":"erMSu","@babel/runtime/helpers/esm/createSuper":"wUOND","@babel/runtime/helpers/esm/defineProperty":"5XpnH","../Parser.js":"7RnfN","../utils.js":"jpqG3","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7rpVu":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TimestampMillisecondsParser", ()=>TimestampMillisecondsParser);
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inherits = require("@babel/runtime/helpers/esm/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _createSuper = require("@babel/runtime/helpers/esm/createSuper");
var _createSuperDefault = parcelHelpers.interopDefault(_createSuper);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _parserJs = require("../Parser.js");
var _utilsJs = require("../utils.js");
var TimestampMillisecondsParser = /*#__PURE__*/ function(_Parser) {
    (0, _inheritsDefault.default)(TimestampMillisecondsParser, _Parser);
    var _super = (0, _createSuperDefault.default)(TimestampMillisecondsParser);
    function TimestampMillisecondsParser() {
        var _this;
        (0, _classCallCheckDefault.default)(this, TimestampMillisecondsParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "priority", 20);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "incompatibleTokens", "*");
        return _this;
    }
    (0, _createClassDefault.default)(TimestampMillisecondsParser, [
        {
            key: "parse",
            value: function parse(dateString) {
                return (0, _utilsJs.parseAnyDigitsSigned)(dateString);
            }
        },
        {
            key: "set",
            value: function set(_date, _flags, value) {
                return [
                    new Date(value),
                    {
                        timestampIsSet: true
                    }
                ];
            }
        }
    ]);
    return TimestampMillisecondsParser;
}((0, _parserJs.Parser));

},{"@babel/runtime/helpers/esm/classCallCheck":"17u6i","@babel/runtime/helpers/esm/createClass":"2lub7","@babel/runtime/helpers/esm/assertThisInitialized":"hqdCW","@babel/runtime/helpers/esm/inherits":"erMSu","@babel/runtime/helpers/esm/createSuper":"wUOND","@babel/runtime/helpers/esm/defineProperty":"5XpnH","../Parser.js":"7RnfN","../utils.js":"jpqG3","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2L0r2":[function(require,module,exports) {
(function(global, factory) {
    if (typeof define === "function" && define.amd) define("react-list", [
        "prop-types",
        "react"
    ], factory);
    else {
        var mod;
        factory(require("101976bb597b11"), require("596594290f6b61b9"));
    }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function(_propTypes, _react) {
    "use strict";
    _propTypes = _interopRequireDefault(_propTypes);
    _react = _interopRequireWildcard(_react);
    var _class, _temp;
    function _getRequireWildcardCache() {
        if (typeof WeakMap !== "function") return null;
        var cache = new WeakMap();
        _getRequireWildcardCache = function _getRequireWildcardCache() {
            return cache;
        };
        return cache;
    }
    function _interopRequireWildcard(obj) {
        if (obj && obj.__esModule) return obj;
        if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") return {
            "default": obj
        };
        var cache = _getRequireWildcardCache();
        if (cache && cache.has(obj)) return cache.get(obj);
        var newObj = {};
        var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
        for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) {
            var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
            if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
            else newObj[key] = obj[key];
        }
        newObj["default"] = obj;
        if (cache) cache.set(obj, newObj);
        return newObj;
    }
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            "default": obj
        };
    }
    function _typeof(obj) {
        "@babel/helpers - typeof";
        if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") _typeof = function _typeof(obj) {
            return typeof obj;
        };
        else _typeof = function _typeof(obj) {
            return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
        };
        return _typeof(obj);
    }
    function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
    }
    function _defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    function _createClass(Constructor, protoProps, staticProps) {
        if (protoProps) _defineProperties(Constructor.prototype, protoProps);
        if (staticProps) _defineProperties(Constructor, staticProps);
        return Constructor;
    }
    function _inherits(subClass, superClass) {
        if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
        subClass.prototype = Object.create(superClass && superClass.prototype, {
            constructor: {
                value: subClass,
                writable: true,
                configurable: true
            }
        });
        if (superClass) _setPrototypeOf(subClass, superClass);
    }
    function _setPrototypeOf(o, p) {
        _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
            o.__proto__ = p;
            return o;
        };
        return _setPrototypeOf(o, p);
    }
    function _createSuper(Derived) {
        var hasNativeReflectConstruct = _isNativeReflectConstruct();
        return function _createSuperInternal() {
            var Super = _getPrototypeOf(Derived), result;
            if (hasNativeReflectConstruct) {
                var NewTarget = _getPrototypeOf(this).constructor;
                result = Reflect.construct(Super, arguments, NewTarget);
            } else result = Super.apply(this, arguments);
            return _possibleConstructorReturn(this, result);
        };
    }
    function _possibleConstructorReturn(self1, call) {
        if (call && (_typeof(call) === "object" || typeof call === "function")) return call;
        return _assertThisInitialized(self1);
    }
    function _assertThisInitialized(self1) {
        if (self1 === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return self1;
    }
    function _isNativeReflectConstruct() {
        if (typeof Reflect === "undefined" || !Reflect.construct) return false;
        if (Reflect.construct.sham) return false;
        if (typeof Proxy === "function") return true;
        try {
            Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
            return true;
        } catch (e) {
            return false;
        }
    }
    function _getPrototypeOf(o) {
        _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
            return o.__proto__ || Object.getPrototypeOf(o);
        };
        return _getPrototypeOf(o);
    }
    function ownKeys(object, enumerableOnly) {
        var keys = Object.keys(object);
        if (Object.getOwnPropertySymbols) {
            var symbols = Object.getOwnPropertySymbols(object);
            if (enumerableOnly) symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
            keys.push.apply(keys, symbols);
        }
        return keys;
    }
    function _objectSpread(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i] != null ? arguments[i] : {};
            if (i % 2) ownKeys(Object(source), true).forEach(function(key) {
                _defineProperty(target, key, source[key]);
            });
            else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
            else ownKeys(Object(source)).forEach(function(key) {
                Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
            });
        }
        return target;
    }
    function _defineProperty(obj, key, value) {
        if (key in obj) Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
        else obj[key] = value;
        return obj;
    }
    var CLIENT_SIZE_KEYS = {
        x: "clientWidth",
        y: "clientHeight"
    };
    var CLIENT_START_KEYS = {
        x: "clientTop",
        y: "clientLeft"
    };
    var INNER_SIZE_KEYS = {
        x: "innerWidth",
        y: "innerHeight"
    };
    var OFFSET_SIZE_KEYS = {
        x: "offsetWidth",
        y: "offsetHeight"
    };
    var OFFSET_START_KEYS = {
        x: "offsetLeft",
        y: "offsetTop"
    };
    var OVERFLOW_KEYS = {
        x: "overflowX",
        y: "overflowY"
    };
    var SCROLL_SIZE_KEYS = {
        x: "scrollWidth",
        y: "scrollHeight"
    };
    var SCROLL_START_KEYS = {
        x: "scrollLeft",
        y: "scrollTop"
    };
    var SIZE_KEYS = {
        x: "width",
        y: "height"
    };
    var NOOP = function NOOP() {}; // If a browser doesn't support the `options` argument to
    // add/removeEventListener, we need to check, otherwise we will
    // accidentally set `capture` with a truthy value.
    var PASSIVE = function() {
        if (typeof window === "undefined") return false;
        var hasSupport = false;
        try {
            document.createElement("div").addEventListener("test", NOOP, {
                get passive () {
                    hasSupport = true;
                    return false;
                }
            });
        } catch (e) {}
        return hasSupport;
    }() ? {
        passive: true
    } : false;
    var UNSTABLE_MESSAGE = "ReactList failed to reach a stable state.";
    var MAX_SYNC_UPDATES = 40;
    var isEqualSubset = function isEqualSubset(a, b) {
        for(var key in b){
            if (a[key] !== b[key]) return false;
        }
        return true;
    };
    var defaultScrollParentGetter = function defaultScrollParentGetter(component) {
        var axis = component.props.axis;
        var el = component.getEl();
        var overflowKey = OVERFLOW_KEYS[axis];
        while(el = el.parentElement)switch(window.getComputedStyle(el)[overflowKey]){
            case "auto":
            case "scroll":
            case "overlay":
                return el;
        }
        return window;
    };
    var defaultScrollParentViewportSizeGetter = function defaultScrollParentViewportSizeGetter(component) {
        var axis = component.props.axis;
        var scrollParent = component.scrollParent;
        return scrollParent === window ? window[INNER_SIZE_KEYS[axis]] : scrollParent[CLIENT_SIZE_KEYS[axis]];
    };
    var constrain = function constrain(props, state) {
        var length = props.length, minSize = props.minSize, type = props.type;
        var from = state.from, size = state.size, itemsPerRow = state.itemsPerRow;
        size = Math.max(size, minSize);
        var mod = size % itemsPerRow;
        if (mod) size += itemsPerRow - mod;
        if (size > length) size = length;
        from = type === "simple" || !from ? 0 : Math.max(Math.min(from, length - size), 0);
        if (mod = from % itemsPerRow) {
            from -= mod;
            size += mod;
        }
        if (from === state.from && size == state.size) return state;
        return _objectSpread(_objectSpread({}, state), {}, {
            from: from,
            size: size
        });
    };
    module.exports = (_temp = _class = /*#__PURE__*/ function(_Component) {
        _inherits(ReactList, _Component);
        var _super = _createSuper(ReactList);
        _createClass(ReactList, null, [
            {
                key: "getDerivedStateFromProps",
                value: function getDerivedStateFromProps(props, state) {
                    var newState = constrain(props, state);
                    return newState === state ? null : newState;
                }
            }
        ]);
        function ReactList(props) {
            var _this;
            _classCallCheck(this, ReactList);
            _this = _super.call(this, props);
            _this.state = constrain(props, {
                itemsPerRow: 1,
                from: props.initialIndex,
                size: 0
            });
            _this.cache = {};
            _this.cachedScrollPosition = null;
            _this.prevPrevState = {};
            _this.unstable = false;
            _this.updateCounter = 0;
            return _this;
        }
        _createClass(ReactList, [
            {
                key: "componentDidMount",
                value: function componentDidMount() {
                    this.updateFrameAndClearCache = this.updateFrameAndClearCache.bind(this);
                    window.addEventListener("resize", this.updateFrameAndClearCache);
                    this.updateFrame(this.scrollTo.bind(this, this.props.initialIndex));
                }
            },
            {
                key: "componentDidUpdate",
                value: function componentDidUpdate(prevProps) {
                    var _this2 = this;
                    // Viewport scroll is no longer useful if axis changes
                    if (this.props.axis !== prevProps.axis) this.clearSizeCache(); // If the list has reached an unstable state, prevent an infinite loop.
                    if (this.unstable) return;
                    if (++this.updateCounter > MAX_SYNC_UPDATES) {
                        this.unstable = true;
                        return console.error(UNSTABLE_MESSAGE);
                    }
                    if (!this.updateCounterTimeoutId) this.updateCounterTimeoutId = setTimeout(function() {
                        _this2.updateCounter = 0;
                        delete _this2.updateCounterTimeoutId;
                    }, 0);
                    this.updateFrame();
                }
            },
            {
                key: "maybeSetState",
                value: function maybeSetState(b, cb) {
                    if (isEqualSubset(this.state, b)) return cb();
                    this.setState(b, cb);
                }
            },
            {
                key: "componentWillUnmount",
                value: function componentWillUnmount() {
                    window.removeEventListener("resize", this.updateFrameAndClearCache);
                    this.scrollParent.removeEventListener("scroll", this.updateFrameAndClearCache, PASSIVE);
                    this.scrollParent.removeEventListener("mousewheel", NOOP, PASSIVE);
                }
            },
            {
                key: "getOffset",
                value: function getOffset(el) {
                    var axis = this.props.axis;
                    var offset = el[CLIENT_START_KEYS[axis]] || 0;
                    var offsetKey = OFFSET_START_KEYS[axis];
                    do offset += el[offsetKey] || 0;
                    while (el = el.offsetParent);
                    return offset;
                }
            },
            {
                key: "getEl",
                value: function getEl() {
                    return this.el || this.items;
                }
            },
            {
                key: "getScrollPosition",
                value: function getScrollPosition() {
                    // Cache scroll position as this causes a forced synchronous layout.
                    if (typeof this.cachedScrollPosition === "number") return this.cachedScrollPosition;
                    var scrollParent = this.scrollParent;
                    var axis = this.props.axis;
                    var scrollKey = SCROLL_START_KEYS[axis];
                    var actual = scrollParent === window ? // always return document.documentElement[scrollKey] as 0, so take
                    // whichever has a value.
                    document.body[scrollKey] || document.documentElement[scrollKey] : scrollParent[scrollKey];
                    var max = this.getScrollSize() - this.props.scrollParentViewportSizeGetter(this);
                    var scroll = Math.max(0, Math.min(actual, max));
                    var el = this.getEl();
                    this.cachedScrollPosition = this.getOffset(scrollParent) + scroll - this.getOffset(el);
                    return this.cachedScrollPosition;
                }
            },
            {
                key: "setScroll",
                value: function setScroll(offset) {
                    var scrollParent = this.scrollParent;
                    var axis = this.props.axis;
                    offset += this.getOffset(this.getEl());
                    if (scrollParent === window) return window.scrollTo(0, offset);
                    offset -= this.getOffset(this.scrollParent);
                    scrollParent[SCROLL_START_KEYS[axis]] = offset;
                }
            },
            {
                key: "getScrollSize",
                value: function getScrollSize() {
                    var scrollParent = this.scrollParent;
                    var _document = document, body = _document.body, documentElement = _document.documentElement;
                    var key = SCROLL_SIZE_KEYS[this.props.axis];
                    return scrollParent === window ? Math.max(body[key], documentElement[key]) : scrollParent[key];
                }
            },
            {
                key: "hasDeterminateSize",
                value: function hasDeterminateSize() {
                    var _this$props = this.props, itemSizeGetter = _this$props.itemSizeGetter, type = _this$props.type;
                    return type === "uniform" || itemSizeGetter;
                }
            },
            {
                key: "getStartAndEnd",
                value: function getStartAndEnd() {
                    var threshold = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props.threshold;
                    var scroll = this.getScrollPosition();
                    var start = Math.max(0, scroll - threshold);
                    var end = scroll + this.props.scrollParentViewportSizeGetter(this) + threshold;
                    if (this.hasDeterminateSize()) end = Math.min(end, this.getSpaceBefore(this.props.length));
                    return {
                        start: start,
                        end: end
                    };
                }
            },
            {
                key: "getItemSizeAndItemsPerRow",
                value: function getItemSizeAndItemsPerRow() {
                    var _this$props2 = this.props, axis = _this$props2.axis, useStaticSize = _this$props2.useStaticSize;
                    var _this$state = this.state, itemSize = _this$state.itemSize, itemsPerRow = _this$state.itemsPerRow;
                    if (useStaticSize && itemSize && itemsPerRow) return {
                        itemSize: itemSize,
                        itemsPerRow: itemsPerRow
                    };
                    var itemEls = this.items.children;
                    if (!itemEls.length) return {};
                    var firstEl = itemEls[0]; // Firefox has a problem where it will return a *slightly* (less than
                    // thousandths of a pixel) different size for the same element between
                    // renders. This can cause an infinite render loop, so only change the
                    // itemSize when it is significantly different.
                    var firstElSize = firstEl[OFFSET_SIZE_KEYS[axis]];
                    var delta = Math.abs(firstElSize - itemSize);
                    if (isNaN(delta) || delta >= 1) itemSize = firstElSize;
                    if (!itemSize) return {};
                    var startKey = OFFSET_START_KEYS[axis];
                    var firstStart = firstEl[startKey];
                    itemsPerRow = 1;
                    for(var item = itemEls[itemsPerRow]; item && item[startKey] === firstStart; item = itemEls[itemsPerRow])++itemsPerRow;
                    return {
                        itemSize: itemSize,
                        itemsPerRow: itemsPerRow
                    };
                }
            },
            {
                key: "clearSizeCache",
                value: function clearSizeCache() {
                    this.cachedScrollPosition = null;
                } // Called by 'scroll' and 'resize' events, clears scroll position cache.
            },
            {
                key: "updateFrameAndClearCache",
                value: function updateFrameAndClearCache(cb) {
                    this.clearSizeCache();
                    return this.updateFrame(cb);
                }
            },
            {
                key: "updateFrame",
                value: function updateFrame(cb) {
                    this.updateScrollParent();
                    if (typeof cb != "function") cb = NOOP;
                    switch(this.props.type){
                        case "simple":
                            return this.updateSimpleFrame(cb);
                        case "variable":
                            return this.updateVariableFrame(cb);
                        case "uniform":
                            return this.updateUniformFrame(cb);
                    }
                }
            },
            {
                key: "updateScrollParent",
                value: function updateScrollParent() {
                    var prev = this.scrollParent;
                    this.scrollParent = this.props.scrollParentGetter(this);
                    if (prev === this.scrollParent) return;
                    if (prev) {
                        prev.removeEventListener("scroll", this.updateFrameAndClearCache);
                        prev.removeEventListener("mousewheel", NOOP);
                    } // If we have a new parent, cached parent dimensions are no longer useful.
                    this.clearSizeCache();
                    this.scrollParent.addEventListener("scroll", this.updateFrameAndClearCache, PASSIVE); // You have to attach mousewheel listener to the scrollable element.
                    // Just an empty listener. After that onscroll events will be fired synchronously.
                    this.scrollParent.addEventListener("mousewheel", NOOP, PASSIVE);
                }
            },
            {
                key: "updateSimpleFrame",
                value: function updateSimpleFrame(cb) {
                    var _this$getStartAndEnd = this.getStartAndEnd(), end = _this$getStartAndEnd.end;
                    var itemEls = this.items.children;
                    var elEnd = 0;
                    if (itemEls.length) {
                        var axis = this.props.axis;
                        var firstItemEl = itemEls[0];
                        var lastItemEl = itemEls[itemEls.length - 1];
                        elEnd = this.getOffset(lastItemEl) + lastItemEl[OFFSET_SIZE_KEYS[axis]] - this.getOffset(firstItemEl);
                    }
                    if (elEnd > end) return cb();
                    var _this$props3 = this.props, pageSize = _this$props3.pageSize, length = _this$props3.length;
                    var size = Math.min(this.state.size + pageSize, length);
                    this.maybeSetState({
                        size: size
                    }, cb);
                }
            },
            {
                key: "updateVariableFrame",
                value: function updateVariableFrame(cb) {
                    if (!this.props.itemSizeGetter) this.cacheSizes();
                    var _this$getStartAndEnd2 = this.getStartAndEnd(), start = _this$getStartAndEnd2.start, end = _this$getStartAndEnd2.end;
                    var _this$props4 = this.props, length = _this$props4.length, pageSize = _this$props4.pageSize;
                    var space = 0;
                    var from = 0;
                    var size = 0;
                    var maxFrom = length - 1;
                    while(from < maxFrom){
                        var itemSize = this.getSizeOfItem(from);
                        if (itemSize == null || space + itemSize > start) break;
                        space += itemSize;
                        ++from;
                    }
                    var maxSize = length - from;
                    while(size < maxSize && space < end){
                        var _itemSize = this.getSizeOfItem(from + size);
                        if (_itemSize == null) {
                            size = Math.min(size + pageSize, maxSize);
                            break;
                        }
                        space += _itemSize;
                        ++size;
                    }
                    this.maybeSetState(constrain(this.props, {
                        from: from,
                        itemsPerRow: 1,
                        size: size
                    }), cb);
                }
            },
            {
                key: "updateUniformFrame",
                value: function updateUniformFrame(cb) {
                    var _this$getItemSizeAndI = this.getItemSizeAndItemsPerRow(), itemSize = _this$getItemSizeAndI.itemSize, itemsPerRow = _this$getItemSizeAndI.itemsPerRow;
                    if (!itemSize || !itemsPerRow) return cb();
                    var _this$getStartAndEnd3 = this.getStartAndEnd(), start = _this$getStartAndEnd3.start, end = _this$getStartAndEnd3.end;
                    var _constrain = constrain(this.props, {
                        from: Math.floor(start / itemSize) * itemsPerRow,
                        size: (Math.ceil((end - start) / itemSize) + 1) * itemsPerRow,
                        itemsPerRow: itemsPerRow
                    }), from = _constrain.from, size = _constrain.size;
                    return this.maybeSetState({
                        itemsPerRow: itemsPerRow,
                        from: from,
                        itemSize: itemSize,
                        size: size
                    }, cb);
                }
            },
            {
                key: "getSpaceBefore",
                value: function getSpaceBefore(index) {
                    var cache = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                    if (cache[index] != null) return cache[index]; // Try the static itemSize.
                    var _this$state2 = this.state, itemSize = _this$state2.itemSize, itemsPerRow = _this$state2.itemsPerRow;
                    if (itemSize) return cache[index] = Math.floor(index / itemsPerRow) * itemSize;
                     // Find the closest space to index there is a cached value for.
                    var from = index;
                    while(from > 0 && cache[--from] == null); // Finally, accumulate sizes of items from - index.
                    var space = cache[from] || 0;
                    for(var i = from; i < index; ++i){
                        cache[i] = space;
                        var _itemSize2 = this.getSizeOfItem(i);
                        if (_itemSize2 == null) break;
                        space += _itemSize2;
                    }
                    return cache[index] = space;
                }
            },
            {
                key: "cacheSizes",
                value: function cacheSizes() {
                    var cache = this.cache;
                    var from = this.state.from;
                    var itemEls = this.items.children;
                    var sizeKey = OFFSET_SIZE_KEYS[this.props.axis];
                    for(var i = 0, l = itemEls.length; i < l; ++i)cache[from + i] = itemEls[i][sizeKey];
                }
            },
            {
                key: "getSizeOfItem",
                value: function getSizeOfItem(index) {
                    var cache = this.cache, items = this.items;
                    var _this$props5 = this.props, axis = _this$props5.axis, itemSizeGetter = _this$props5.itemSizeGetter, itemSizeEstimator = _this$props5.itemSizeEstimator, type = _this$props5.type;
                    var _this$state3 = this.state, from = _this$state3.from, itemSize = _this$state3.itemSize, size = _this$state3.size; // Try the static itemSize.
                    if (itemSize) return itemSize; // Try the itemSizeGetter.
                    if (itemSizeGetter) return itemSizeGetter(index); // Try the cache.
                    if (index in cache) return cache[index]; // Try the DOM.
                    if (type === "simple" && index >= from && index < from + size && items) {
                        var itemEl = items.children[index - from];
                        if (itemEl) return itemEl[OFFSET_SIZE_KEYS[axis]];
                    } // Try the itemSizeEstimator.
                    if (itemSizeEstimator) return itemSizeEstimator(index, cache);
                }
            },
            {
                key: "scrollTo",
                value: function scrollTo(index) {
                    if (index != null) this.setScroll(this.getSpaceBefore(index));
                }
            },
            {
                key: "scrollAround",
                value: function scrollAround(index) {
                    var current = this.getScrollPosition();
                    var bottom = this.getSpaceBefore(index);
                    var top = bottom - this.props.scrollParentViewportSizeGetter(this) + this.getSizeOfItem(index);
                    var min = Math.min(top, bottom);
                    var max = Math.max(top, bottom);
                    if (current <= min) return this.setScroll(min);
                    if (current > max) return this.setScroll(max);
                }
            },
            {
                key: "getVisibleRange",
                value: function getVisibleRange() {
                    var _this$state4 = this.state, from = _this$state4.from, size = _this$state4.size;
                    var _this$getStartAndEnd4 = this.getStartAndEnd(0), start = _this$getStartAndEnd4.start, end = _this$getStartAndEnd4.end;
                    var cache = {};
                    var first, last;
                    for(var i = from; i < from + size; ++i){
                        var itemStart = this.getSpaceBefore(i, cache);
                        var itemEnd = itemStart + this.getSizeOfItem(i);
                        if (first == null && itemEnd > start) first = i;
                        if (first != null && itemStart < end) last = i;
                    }
                    return [
                        first,
                        last
                    ];
                }
            },
            {
                key: "renderItems",
                value: function renderItems() {
                    var _this3 = this;
                    var _this$props6 = this.props, itemRenderer = _this$props6.itemRenderer, itemsRenderer = _this$props6.itemsRenderer;
                    var _this$state5 = this.state, from = _this$state5.from, size = _this$state5.size;
                    var items = [];
                    for(var i = 0; i < size; ++i)items.push(itemRenderer(from + i, i));
                    return itemsRenderer(items, function(c) {
                        return _this3.items = c;
                    });
                }
            },
            {
                key: "render",
                value: function render() {
                    var _this4 = this;
                    var _this$props7 = this.props, axis = _this$props7.axis, length = _this$props7.length, type = _this$props7.type, useTranslate3d = _this$props7.useTranslate3d;
                    var _this$state6 = this.state, from = _this$state6.from, itemsPerRow = _this$state6.itemsPerRow;
                    var items = this.renderItems();
                    if (type === "simple") return items;
                    var style = {
                        position: "relative"
                    };
                    var cache = {};
                    var bottom = Math.ceil(length / itemsPerRow) * itemsPerRow;
                    var size = this.getSpaceBefore(bottom, cache);
                    if (size) {
                        style[SIZE_KEYS[axis]] = size;
                        if (axis === "x") style.overflowX = "hidden";
                    }
                    var offset = this.getSpaceBefore(from, cache);
                    var x = axis === "x" ? offset : 0;
                    var y = axis === "y" ? offset : 0;
                    var transform = useTranslate3d ? "translate3d(".concat(x, "px, ").concat(y, "px, 0)") : "translate(".concat(x, "px, ").concat(y, "px)");
                    var listStyle = {
                        msTransform: transform,
                        WebkitTransform: transform,
                        transform: transform
                    };
                    return /*#__PURE__*/ _react["default"].createElement("div", {
                        style: style,
                        ref: function ref(c) {
                            return _this4.el = c;
                        }
                    }, /*#__PURE__*/ _react["default"].createElement("div", {
                        style: listStyle
                    }, items));
                }
            }
        ]);
        return ReactList;
    }(_react.Component), _defineProperty(_class, "displayName", "ReactList"), _defineProperty(_class, "propTypes", {
        axis: _propTypes["default"].oneOf([
            "x",
            "y"
        ]),
        initialIndex: _propTypes["default"].number,
        itemRenderer: _propTypes["default"].func,
        itemSizeEstimator: _propTypes["default"].func,
        itemSizeGetter: _propTypes["default"].func,
        itemsRenderer: _propTypes["default"].func,
        length: _propTypes["default"].number,
        minSize: _propTypes["default"].number,
        pageSize: _propTypes["default"].number,
        scrollParentGetter: _propTypes["default"].func,
        scrollParentViewportSizeGetter: _propTypes["default"].func,
        threshold: _propTypes["default"].number,
        type: _propTypes["default"].oneOf([
            "simple",
            "variable",
            "uniform"
        ]),
        useStaticSize: _propTypes["default"].bool,
        useTranslate3d: _propTypes["default"].bool
    }), _defineProperty(_class, "defaultProps", {
        axis: "y",
        itemRenderer: function itemRenderer(index, key) {
            return /*#__PURE__*/ _react["default"].createElement("div", {
                key: key
            }, index);
        },
        itemsRenderer: function itemsRenderer(items, ref) {
            return /*#__PURE__*/ _react["default"].createElement("div", {
                ref: ref
            }, items);
        },
        length: 0,
        minSize: 1,
        pageSize: 10,
        scrollParentGetter: defaultScrollParentGetter,
        scrollParentViewportSizeGetter: defaultScrollParentViewportSizeGetter,
        threshold: 100,
        type: "simple",
        useStaticSize: false,
        useTranslate3d: false
    }), _temp);
});

},{"101976bb597b11":"6FKs7","596594290f6b61b9":"6uln9"}],"71Zzs":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "shallowEqualArrays", ()=>shallowEqualArrays);
parcelHelpers.export(exports, "shallowEqualObjects", ()=>shallowEqualObjects);
function shallowEqualObjects(objA, objB) {
    if (objA === objB) return true;
    if (!objA || !objB) return false;
    var aKeys = Object.keys(objA);
    var bKeys = Object.keys(objB);
    var len = aKeys.length;
    if (bKeys.length !== len) return false;
    for(var i = 0; i < len; i++){
        var key = aKeys[i];
        if (objA[key] !== objB[key] || !Object.prototype.hasOwnProperty.call(objB, key)) return false;
    }
    return true;
}
function shallowEqualArrays(arrA, arrB) {
    if (arrA === arrB) return true;
    if (!arrA || !arrB) return false;
    var len = arrA.length;
    if (arrB.length !== len) return false;
    for(var i = 0; i < len; i++){
        if (arrA[i] !== arrB[i]) return false;
    }
    return true;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"dmOVr":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>max);
var _typeof = require("@babel/runtime/helpers/esm/typeof");
var _typeofDefault = parcelHelpers.interopDefault(_typeof);
var _indexJs = require("../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
function max(dirtyDatesArray) {
    (0, _indexJsDefault1.default)(1, arguments);
    var datesArray;
    // `dirtyDatesArray` is Array, Set or Map, or object with custom `forEach` method
    if (dirtyDatesArray && typeof dirtyDatesArray.forEach === "function") datesArray = dirtyDatesArray;
    else if ((0, _typeofDefault.default)(dirtyDatesArray) === "object" && dirtyDatesArray !== null) datesArray = Array.prototype.slice.call(dirtyDatesArray);
    else // `dirtyDatesArray` is non-iterable, return Invalid Date
    return new Date(NaN);
    var result;
    datesArray.forEach(function(dirtyDate) {
        var currentDate = (0, _indexJsDefault.default)(dirtyDate);
        if (result === undefined || result < currentDate || isNaN(Number(currentDate))) result = currentDate;
    });
    return result || new Date(NaN);
}

},{"@babel/runtime/helpers/esm/typeof":"4ZfJH","../toDate/index.js":"fYDr6","../_lib/requiredArgs/index.js":"180ox","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2P2GJ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>min);
var _typeof = require("@babel/runtime/helpers/esm/typeof");
var _typeofDefault = parcelHelpers.interopDefault(_typeof);
var _indexJs = require("../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
function min(dirtyDatesArray) {
    (0, _indexJsDefault1.default)(1, arguments);
    var datesArray;
    // `dirtyDatesArray` is Array, Set or Map, or object with custom `forEach` method
    if (dirtyDatesArray && typeof dirtyDatesArray.forEach === "function") datesArray = dirtyDatesArray;
    else if ((0, _typeofDefault.default)(dirtyDatesArray) === "object" && dirtyDatesArray !== null) datesArray = Array.prototype.slice.call(dirtyDatesArray);
    else // `dirtyDatesArray` is non-iterable, return Invalid Date
    return new Date(NaN);
    var result;
    datesArray.forEach(function(dirtyDate) {
        var currentDate = (0, _indexJsDefault.default)(dirtyDate);
        if (result === undefined || result > currentDate || isNaN(currentDate.getDate())) result = currentDate;
    });
    return result || new Date(NaN);
}

},{"@babel/runtime/helpers/esm/typeof":"4ZfJH","../toDate/index.js":"fYDr6","../_lib/requiredArgs/index.js":"180ox","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9DPCg":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>differenceInDays);
var _indexJs = require("../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../differenceInCalendarDays/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../_lib/requiredArgs/index.js"); // Like `compareAsc` but uses local time not UTC, which is needed
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
// for accurate equality comparisons of UTC timestamps that end up
// having the same representation in local time, e.g. one hour before
// DST ends vs. the instant that DST ends.
function compareLocalAsc(dateLeft, dateRight) {
    var diff = dateLeft.getFullYear() - dateRight.getFullYear() || dateLeft.getMonth() - dateRight.getMonth() || dateLeft.getDate() - dateRight.getDate() || dateLeft.getHours() - dateRight.getHours() || dateLeft.getMinutes() - dateRight.getMinutes() || dateLeft.getSeconds() - dateRight.getSeconds() || dateLeft.getMilliseconds() - dateRight.getMilliseconds();
    if (diff < 0) return -1;
    else if (diff > 0) return 1;
    else return diff;
}
function differenceInDays(dirtyDateLeft, dirtyDateRight) {
    (0, _indexJsDefault2.default)(2, arguments);
    var dateLeft = (0, _indexJsDefault.default)(dirtyDateLeft);
    var dateRight = (0, _indexJsDefault.default)(dirtyDateRight);
    var sign = compareLocalAsc(dateLeft, dateRight);
    var difference = Math.abs((0, _indexJsDefault1.default)(dateLeft, dateRight));
    dateLeft.setDate(dateLeft.getDate() - sign * difference);
    // Math.abs(diff in full days - diff in calendar days) === 1 if last calendar day is not full
    // If so, result must be decreased by 1 in absolute value
    var isLastDayNotFull = Number(compareLocalAsc(dateLeft, dateRight) === -sign);
    var result = sign * (difference - isLastDayNotFull);
    // Prevent negative zero
    return result === 0 ? 0 : result;
}

},{"../toDate/index.js":"fYDr6","../differenceInCalendarDays/index.js":"kfTvM","../_lib/requiredArgs/index.js":"180ox","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"qPsB2":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>isSameMonth);
var _indexJs = require("../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
function isSameMonth(dirtyDateLeft, dirtyDateRight) {
    (0, _indexJsDefault1.default)(2, arguments);
    var dateLeft = (0, _indexJsDefault.default)(dirtyDateLeft);
    var dateRight = (0, _indexJsDefault.default)(dirtyDateRight);
    return dateLeft.getFullYear() === dateRight.getFullYear() && dateLeft.getMonth() === dateRight.getMonth();
}

},{"../toDate/index.js":"fYDr6","../_lib/requiredArgs/index.js":"180ox","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8smkx":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>setMonth);
var _indexJs = require("../_lib/toInteger/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../toDate/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../getDaysInMonth/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
function setMonth(dirtyDate, dirtyMonth) {
    (0, _indexJsDefault3.default)(2, arguments);
    var date = (0, _indexJsDefault1.default)(dirtyDate);
    var month = (0, _indexJsDefault.default)(dirtyMonth);
    var year = date.getFullYear();
    var day = date.getDate();
    var dateWithDesiredMonth = new Date(0);
    dateWithDesiredMonth.setFullYear(year, month, 15);
    dateWithDesiredMonth.setHours(0, 0, 0, 0);
    var daysInMonth = (0, _indexJsDefault2.default)(dateWithDesiredMonth);
    // Set the last day of the new month
    // if the original date was the last day of the longer month
    date.setMonth(month, Math.min(day, daysInMonth));
    return date;
}

},{"../_lib/toInteger/index.js":"fgaQ2","../toDate/index.js":"fYDr6","../getDaysInMonth/index.js":"iwrdU","../_lib/requiredArgs/index.js":"180ox","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"iwrdU":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getDaysInMonth);
var _indexJs = require("../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
function getDaysInMonth(dirtyDate) {
    (0, _indexJsDefault1.default)(1, arguments);
    var date = (0, _indexJsDefault.default)(dirtyDate);
    var year = date.getFullYear();
    var monthIndex = date.getMonth();
    var lastDayOfMonth = new Date(0);
    lastDayOfMonth.setFullYear(year, monthIndex + 1, 0);
    lastDayOfMonth.setHours(0, 0, 0, 0);
    return lastDayOfMonth.getDate();
}

},{"../toDate/index.js":"fYDr6","../_lib/requiredArgs/index.js":"180ox","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jxmoh":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>setYear);
var _indexJs = require("../_lib/toInteger/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../toDate/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
function setYear(dirtyDate, dirtyYear) {
    (0, _indexJsDefault2.default)(2, arguments);
    var date = (0, _indexJsDefault1.default)(dirtyDate);
    var year = (0, _indexJsDefault.default)(dirtyYear);
    // Check if date is Invalid Date because Date.prototype.setFullYear ignores the value of Invalid Date
    if (isNaN(date.getTime())) return new Date(NaN);
    date.setFullYear(year);
    return date;
}

},{"../_lib/toInteger/index.js":"fgaQ2","../toDate/index.js":"fYDr6","../_lib/requiredArgs/index.js":"180ox","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2VLwd":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>addYears);
var _indexJs = require("../_lib/toInteger/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../addMonths/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
function addYears(dirtyDate, dirtyAmount) {
    (0, _indexJsDefault2.default)(2, arguments);
    var amount = (0, _indexJsDefault.default)(dirtyAmount);
    return (0, _indexJsDefault1.default)(dirtyDate, amount * 12);
}

},{"../_lib/toInteger/index.js":"fgaQ2","../addMonths/index.js":"2h5VH","../_lib/requiredArgs/index.js":"180ox","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2h5VH":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>addMonths);
var _indexJs = require("../_lib/toInteger/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../toDate/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
function addMonths(dirtyDate, dirtyAmount) {
    (0, _indexJsDefault2.default)(2, arguments);
    var date = (0, _indexJsDefault1.default)(dirtyDate);
    var amount = (0, _indexJsDefault.default)(dirtyAmount);
    if (isNaN(amount)) return new Date(NaN);
    if (!amount) // If 0 months, no-op to avoid changing times in the hour before end of DST
    return date;
    var dayOfMonth = date.getDate();
    // The JS Date object supports date math by accepting out-of-bounds values for
    // month, day, etc. For example, new Date(2020, 0, 0) returns 31 Dec 2019 and
    // new Date(2020, 13, 1) returns 1 Feb 2021.  This is *almost* the behavior we
    // want except that dates will wrap around the end of a month, meaning that
    // new Date(2020, 13, 31) will return 3 Mar 2021 not 28 Feb 2021 as desired. So
    // we'll default to the end of the desired month by adding 1 to the desired
    // month and using a date of 0 to back up one day to the end of the desired
    // month.
    var endOfDesiredMonth = new Date(date.getTime());
    endOfDesiredMonth.setMonth(date.getMonth() + amount + 1, 0);
    var daysInMonth = endOfDesiredMonth.getDate();
    if (dayOfMonth >= daysInMonth) // If we're already at the end of the month, then this is the correct date
    // and we're done.
    return endOfDesiredMonth;
    else {
        // Otherwise, we now know that setting the original day-of-month value won't
        // cause an overflow, so set the desired day-of-month. Note that we can't
        // just set the date of `endOfDesiredMonth` because that object may have had
        // its time changed in the unusual case where where a DST transition was on
        // the last day of the month and its local time was in the hour skipped or
        // repeated next to a DST transition.  So we use `date` instead which is
        // guaranteed to still have the original time.
        date.setFullYear(endOfDesiredMonth.getFullYear(), endOfDesiredMonth.getMonth(), dayOfMonth);
        return date;
    }
}

},{"../_lib/toInteger/index.js":"fgaQ2","../toDate/index.js":"fYDr6","../_lib/requiredArgs/index.js":"180ox","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"afiGD":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>subMonths);
var _indexJs = require("../_lib/toInteger/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../addMonths/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
function subMonths(dirtyDate, dirtyAmount) {
    (0, _indexJsDefault2.default)(2, arguments);
    var amount = (0, _indexJsDefault.default)(dirtyAmount);
    return (0, _indexJsDefault1.default)(dirtyDate, -amount);
}

},{"../_lib/toInteger/index.js":"fgaQ2","../addMonths/index.js":"2h5VH","../_lib/requiredArgs/index.js":"180ox","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"cP3WV":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _default = {
    dateRangeWrapper: "rdrDateRangeWrapper",
    calendarWrapper: "rdrCalendarWrapper",
    dateDisplay: "rdrDateDisplay",
    dateDisplayItem: "rdrDateDisplayItem",
    dateDisplayItemActive: "rdrDateDisplayItemActive",
    monthAndYearWrapper: "rdrMonthAndYearWrapper",
    monthAndYearPickers: "rdrMonthAndYearPickers",
    nextPrevButton: "rdrNextPrevButton",
    month: "rdrMonth",
    weekDays: "rdrWeekDays",
    weekDay: "rdrWeekDay",
    days: "rdrDays",
    day: "rdrDay",
    dayNumber: "rdrDayNumber",
    dayPassive: "rdrDayPassive",
    dayToday: "rdrDayToday",
    dayStartOfWeek: "rdrDayStartOfWeek",
    dayEndOfWeek: "rdrDayEndOfWeek",
    daySelected: "rdrDaySelected",
    dayDisabled: "rdrDayDisabled",
    dayStartOfMonth: "rdrDayStartOfMonth",
    dayEndOfMonth: "rdrDayEndOfMonth",
    dayWeekend: "rdrDayWeekend",
    dayStartPreview: "rdrDayStartPreview",
    dayInPreview: "rdrDayInPreview",
    dayEndPreview: "rdrDayEndPreview",
    dayHovered: "rdrDayHovered",
    dayActive: "rdrDayActive",
    inRange: "rdrInRange",
    endEdge: "rdrEndEdge",
    startEdge: "rdrStartEdge",
    prevButton: "rdrPprevButton",
    nextButton: "rdrNextButton",
    selected: "rdrSelected",
    months: "rdrMonths",
    monthPicker: "rdrMonthPicker",
    yearPicker: "rdrYearPicker",
    dateDisplayWrapper: "rdrDateDisplayWrapper",
    definedRangesWrapper: "rdrDefinedRangesWrapper",
    staticRanges: "rdrStaticRanges",
    staticRange: "rdrStaticRange",
    inputRanges: "rdrInputRanges",
    inputRange: "rdrInputRange",
    inputRangeInput: "rdrInputRangeInput",
    dateRangePickerWrapper: "rdrDateRangePickerWrapper",
    staticRangeLabel: "rdrStaticRangeLabel",
    staticRangeSelected: "rdrStaticRangeSelected",
    monthName: "rdrMonthName",
    infiniteMonths: "rdrInfiniteMonths",
    monthsVertical: "rdrMonthsVertical",
    monthsHorizontal: "rdrMonthsHorizontal"
};
exports.default = _default;

},{}],"cTcxr":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ariaLabelsShape = void 0;
var _propTypes = _interopRequireDefault(require("d1266b1de74987c1"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var ariaLabelsShape = _propTypes.default.shape({
    dateInput: _propTypes.default.objectOf(_propTypes.default.shape({
        startDate: _propTypes.default.string,
        endDate: _propTypes.default.string
    })),
    monthPicker: _propTypes.default.string,
    yearPicker: _propTypes.default.string,
    prevButton: _propTypes.default.string,
    nextButton: _propTypes.default.string
});
exports.ariaLabelsShape = ariaLabelsShape;

},{"d1266b1de74987c1":"6FKs7"}],"kDprO":[function(require,module,exports) {
"use strict";
function _typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") _typeof = function _typeof(obj) {
        return typeof obj;
    };
    else _typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return _typeof(obj);
}
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("7ca85eb64ae29d94"));
var _propTypes = _interopRequireDefault(require("4d1d46617d9012c8"));
var _DateRange = _interopRequireDefault(require("fd522ef36fee1d9b"));
var _DefinedRange = _interopRequireDefault(require("b1c24a73fe3029a"));
var _utils = require("6463bb42ff53626c");
var _classnames = _interopRequireDefault(require("37adfe5418d83561"));
var _styles = _interopRequireDefault(require("2aa127541dfbf864"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) ownKeys(Object(source), true).forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return _possibleConstructorReturn(this, result);
    };
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) return call;
    return _assertThisInitialized(self);
}
function _assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
var DateRangePicker = /*#__PURE__*/ function(_Component) {
    _inherits(DateRangePicker, _Component);
    var _super = _createSuper(DateRangePicker);
    function DateRangePicker(props) {
        var _this;
        _classCallCheck(this, DateRangePicker);
        _this = _super.call(this, props);
        _this.state = {
            focusedRange: [
                (0, _utils.findNextRangeIndex)(props.ranges),
                0
            ]
        };
        _this.styles = (0, _utils.generateStyles)([
            _styles.default,
            props.classNames
        ]);
        return _this;
    }
    _createClass(DateRangePicker, [
        {
            key: "render",
            value: function render() {
                var _this2 = this;
                var focusedRange = this.state.focusedRange;
                return /*#__PURE__*/ _react.default.createElement("div", {
                    className: (0, _classnames.default)(this.styles.dateRangePickerWrapper, this.props.className)
                }, /*#__PURE__*/ _react.default.createElement(_DefinedRange.default, _extends({
                    focusedRange: focusedRange,
                    onPreviewChange: function onPreviewChange(value) {
                        return _this2.dateRange.updatePreview(value ? _this2.dateRange.calcNewSelection(value, typeof value === "string") : null);
                    }
                }, this.props, {
                    range: this.props.ranges[focusedRange[0]],
                    className: undefined
                })), /*#__PURE__*/ _react.default.createElement(_DateRange.default, _extends({
                    onRangeFocusChange: function onRangeFocusChange(focusedRange) {
                        return _this2.setState({
                            focusedRange: focusedRange
                        });
                    },
                    focusedRange: focusedRange
                }, this.props, {
                    ref: function ref(t) {
                        return _this2.dateRange = t;
                    },
                    className: undefined
                })));
            }
        }
    ]);
    return DateRangePicker;
}(_react.Component);
DateRangePicker.defaultProps = {};
DateRangePicker.propTypes = _objectSpread(_objectSpread(_objectSpread({}, _DateRange.default.propTypes), _DefinedRange.default.propTypes), {}, {
    className: _propTypes.default.string
});
var _default = DateRangePicker;
exports.default = _default;

},{"7ca85eb64ae29d94":"6uln9","4d1d46617d9012c8":"6FKs7","fd522ef36fee1d9b":"7w1K9","b1c24a73fe3029a":"cccP3","6463bb42ff53626c":"6TTND","37adfe5418d83561":"hVGzI","2aa127541dfbf864":"cP3WV"}],"cccP3":[function(require,module,exports) {
"use strict";
function _typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") _typeof = function _typeof(obj) {
        return typeof obj;
    };
    else _typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return _typeof(obj);
}
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("5e041fb4d60a906"));
var _propTypes = _interopRequireDefault(require("988156a21b3f6e45"));
var _styles = _interopRequireDefault(require("9311be5501b3881e"));
var _defaultRanges = require("18a8d4b592fd1b7b");
var _DayCell = require("463e15f449f94b70");
var _InputRangeField = _interopRequireDefault(require("2ccb33bde7d3242f"));
var _classnames = _interopRequireDefault(require("3cab8f03489adf4f"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) ownKeys(Object(source), true).forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return _possibleConstructorReturn(this, result);
    };
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) return call;
    return _assertThisInitialized(self);
}
function _assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var DefinedRange = /*#__PURE__*/ function(_Component) {
    _inherits(DefinedRange, _Component);
    var _super = _createSuper(DefinedRange);
    function DefinedRange(props) {
        var _this;
        _classCallCheck(this, DefinedRange);
        _this = _super.call(this, props);
        _defineProperty(_assertThisInitialized(_this), "handleRangeChange", function(range) {
            var _this$props = _this.props, onChange = _this$props.onChange, ranges = _this$props.ranges, focusedRange = _this$props.focusedRange;
            var selectedRange = ranges[focusedRange[0]];
            if (!onChange || !selectedRange) return;
            onChange(_defineProperty({}, selectedRange.key || "range".concat(focusedRange[0] + 1), _objectSpread(_objectSpread({}, selectedRange), range)));
        });
        _this.state = {
            rangeOffset: 0,
            focusedInput: -1
        };
        return _this;
    }
    _createClass(DefinedRange, [
        {
            key: "getRangeOptionValue",
            value: function getRangeOptionValue(option) {
                var _this$props2 = this.props, _this$props2$ranges = _this$props2.ranges, ranges = _this$props2$ranges === void 0 ? [] : _this$props2$ranges, _this$props2$focusedR = _this$props2.focusedRange, focusedRange = _this$props2$focusedR === void 0 ? [] : _this$props2$focusedR;
                if (typeof option.getCurrentValue !== "function") return "";
                var selectedRange = ranges[focusedRange[0]] || {};
                return option.getCurrentValue(selectedRange) || "";
            }
        },
        {
            key: "getSelectedRange",
            value: function getSelectedRange(ranges, staticRange) {
                var focusedRangeIndex = ranges.findIndex(function(range) {
                    if (!range.startDate || !range.endDate || range.disabled) return false;
                    return staticRange.isSelected(range);
                });
                var selectedRange = ranges[focusedRangeIndex];
                return {
                    selectedRange: selectedRange,
                    focusedRangeIndex: focusedRangeIndex
                };
            }
        },
        {
            key: "render",
            value: function render() {
                var _this2 = this;
                var _this$props3 = this.props, headerContent = _this$props3.headerContent, footerContent = _this$props3.footerContent, onPreviewChange = _this$props3.onPreviewChange, inputRanges = _this$props3.inputRanges, staticRanges = _this$props3.staticRanges, ranges = _this$props3.ranges, renderStaticRangeLabel = _this$props3.renderStaticRangeLabel, rangeColors = _this$props3.rangeColors, className = _this$props3.className;
                return /*#__PURE__*/ _react.default.createElement("div", {
                    className: (0, _classnames.default)(_styles.default.definedRangesWrapper, className)
                }, headerContent, /*#__PURE__*/ _react.default.createElement("div", {
                    className: _styles.default.staticRanges
                }, staticRanges.map(function(staticRange, i) {
                    var _this2$getSelectedRan = _this2.getSelectedRange(ranges, staticRange), selectedRange = _this2$getSelectedRan.selectedRange, focusedRangeIndex = _this2$getSelectedRan.focusedRangeIndex;
                    var labelContent;
                    if (staticRange.hasCustomRendering) labelContent = renderStaticRangeLabel(staticRange);
                    else labelContent = staticRange.label;
                    return /*#__PURE__*/ _react.default.createElement("button", {
                        type: "button",
                        className: (0, _classnames.default)(_styles.default.staticRange, _defineProperty({}, _styles.default.staticRangeSelected, Boolean(selectedRange))),
                        style: {
                            color: selectedRange ? selectedRange.color || rangeColors[focusedRangeIndex] : null
                        },
                        key: i,
                        onClick: function onClick() {
                            return _this2.handleRangeChange(staticRange.range(_this2.props));
                        },
                        onFocus: function onFocus() {
                            return onPreviewChange && onPreviewChange(staticRange.range(_this2.props));
                        },
                        onMouseOver: function onMouseOver() {
                            return onPreviewChange && onPreviewChange(staticRange.range(_this2.props));
                        },
                        onMouseLeave: function onMouseLeave() {
                            onPreviewChange && onPreviewChange();
                        }
                    }, /*#__PURE__*/ _react.default.createElement("span", {
                        tabIndex: -1,
                        className: _styles.default.staticRangeLabel
                    }, labelContent));
                })), /*#__PURE__*/ _react.default.createElement("div", {
                    className: _styles.default.inputRanges
                }, inputRanges.map(function(rangeOption, i) {
                    return /*#__PURE__*/ _react.default.createElement(_InputRangeField.default, {
                        key: i,
                        styles: _styles.default,
                        label: rangeOption.label,
                        onFocus: function onFocus() {
                            return _this2.setState({
                                focusedInput: i,
                                rangeOffset: 0
                            });
                        },
                        onBlur: function onBlur() {
                            return _this2.setState({
                                rangeOffset: 0
                            });
                        },
                        onChange: function onChange(value) {
                            return _this2.handleRangeChange(rangeOption.range(value, _this2.props));
                        },
                        value: _this2.getRangeOptionValue(rangeOption)
                    });
                })), footerContent);
            }
        }
    ]);
    return DefinedRange;
}(_react.Component);
DefinedRange.propTypes = {
    inputRanges: _propTypes.default.array,
    staticRanges: _propTypes.default.array,
    ranges: _propTypes.default.arrayOf(_DayCell.rangeShape),
    focusedRange: _propTypes.default.arrayOf(_propTypes.default.number),
    onPreviewChange: _propTypes.default.func,
    onChange: _propTypes.default.func,
    footerContent: _propTypes.default.any,
    headerContent: _propTypes.default.any,
    rangeColors: _propTypes.default.arrayOf(_propTypes.default.string),
    className: _propTypes.default.string,
    renderStaticRangeLabel: _propTypes.default.func
};
DefinedRange.defaultProps = {
    inputRanges: _defaultRanges.defaultInputRanges,
    staticRanges: _defaultRanges.defaultStaticRanges,
    ranges: [],
    rangeColors: [
        "#3d91ff",
        "#3ecf8e",
        "#fed14c"
    ],
    focusedRange: [
        0,
        0
    ]
};
var _default = DefinedRange;
exports.default = _default;

},{"5e041fb4d60a906":"6uln9","988156a21b3f6e45":"6FKs7","9311be5501b3881e":"cP3WV","18a8d4b592fd1b7b":"hNj6e","463e15f449f94b70":"8U3Bs","2ccb33bde7d3242f":"k9k5Y","3cab8f03489adf4f":"hVGzI"}],"hNj6e":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.createStaticRanges = createStaticRanges;
exports.defaultInputRanges = exports.defaultStaticRanges = void 0;
var _differenceInCalendarDays = _interopRequireDefault(require("a31c801a62affe28"));
var _isSameDay = _interopRequireDefault(require("7a0177678dd83ea0"));
var _endOfWeek = _interopRequireDefault(require("8828c2b98c8993cd"));
var _startOfWeek = _interopRequireDefault(require("e9fd7e119415bae7"));
var _addMonths = _interopRequireDefault(require("844e9ec853896ec9"));
var _endOfMonth = _interopRequireDefault(require("c1930a01b1cc0b53"));
var _startOfMonth = _interopRequireDefault(require("ff678ac9e8e85c7e"));
var _startOfDay = _interopRequireDefault(require("c903cba260f70341"));
var _endOfDay = _interopRequireDefault(require("81a2cd342f565870"));
var _addDays = _interopRequireDefault(require("1de218ec76ad45f3"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) ownKeys(Object(source), true).forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var defineds = {
    startOfWeek: (0, _startOfWeek.default)(new Date()),
    endOfWeek: (0, _endOfWeek.default)(new Date()),
    startOfLastWeek: (0, _startOfWeek.default)((0, _addDays.default)(new Date(), -7)),
    endOfLastWeek: (0, _endOfWeek.default)((0, _addDays.default)(new Date(), -7)),
    startOfToday: (0, _startOfDay.default)(new Date()),
    endOfToday: (0, _endOfDay.default)(new Date()),
    startOfYesterday: (0, _startOfDay.default)((0, _addDays.default)(new Date(), -1)),
    endOfYesterday: (0, _endOfDay.default)((0, _addDays.default)(new Date(), -1)),
    startOfMonth: (0, _startOfMonth.default)(new Date()),
    endOfMonth: (0, _endOfMonth.default)(new Date()),
    startOfLastMonth: (0, _startOfMonth.default)((0, _addMonths.default)(new Date(), -1)),
    endOfLastMonth: (0, _endOfMonth.default)((0, _addMonths.default)(new Date(), -1))
};
var staticRangeHandler = {
    range: {},
    isSelected: function isSelected(range) {
        var definedRange = this.range();
        return (0, _isSameDay.default)(range.startDate, definedRange.startDate) && (0, _isSameDay.default)(range.endDate, definedRange.endDate);
    }
};
function createStaticRanges(ranges) {
    return ranges.map(function(range) {
        return _objectSpread(_objectSpread({}, staticRangeHandler), range);
    });
}
var defaultStaticRanges = createStaticRanges([
    {
        label: "Today",
        range: function range() {
            return {
                startDate: defineds.startOfToday,
                endDate: defineds.endOfToday
            };
        }
    },
    {
        label: "Yesterday",
        range: function range() {
            return {
                startDate: defineds.startOfYesterday,
                endDate: defineds.endOfYesterday
            };
        }
    },
    {
        label: "This Week",
        range: function range() {
            return {
                startDate: defineds.startOfWeek,
                endDate: defineds.endOfWeek
            };
        }
    },
    {
        label: "Last Week",
        range: function range() {
            return {
                startDate: defineds.startOfLastWeek,
                endDate: defineds.endOfLastWeek
            };
        }
    },
    {
        label: "This Month",
        range: function range() {
            return {
                startDate: defineds.startOfMonth,
                endDate: defineds.endOfMonth
            };
        }
    },
    {
        label: "Last Month",
        range: function range() {
            return {
                startDate: defineds.startOfLastMonth,
                endDate: defineds.endOfLastMonth
            };
        }
    }
]);
exports.defaultStaticRanges = defaultStaticRanges;
var defaultInputRanges = [
    {
        label: "days up to today",
        range: function range(value) {
            return {
                startDate: (0, _addDays.default)(defineds.startOfToday, (Math.max(Number(value), 1) - 1) * -1),
                endDate: defineds.endOfToday
            };
        },
        getCurrentValue: function getCurrentValue(range) {
            if (!(0, _isSameDay.default)(range.endDate, defineds.endOfToday)) return "-";
            if (!range.startDate) return "∞";
            return (0, _differenceInCalendarDays.default)(defineds.endOfToday, range.startDate) + 1;
        }
    },
    {
        label: "days starting today",
        range: function range(value) {
            var today = new Date();
            return {
                startDate: today,
                endDate: (0, _addDays.default)(today, Math.max(Number(value), 1) - 1)
            };
        },
        getCurrentValue: function getCurrentValue(range) {
            if (!(0, _isSameDay.default)(range.startDate, defineds.startOfToday)) return "-";
            if (!range.endDate) return "∞";
            return (0, _differenceInCalendarDays.default)(range.endDate, defineds.startOfToday) + 1;
        }
    }
];
exports.defaultInputRanges = defaultInputRanges;

},{"a31c801a62affe28":"kfTvM","7a0177678dd83ea0":"zixuD","8828c2b98c8993cd":"1dSZs","e9fd7e119415bae7":"5iVAO","844e9ec853896ec9":"2h5VH","c1930a01b1cc0b53":"fMDiz","ff678ac9e8e85c7e":"j9jcE","c903cba260f70341":"3ImQM","81a2cd342f565870":"4Dc68","1de218ec76ad45f3":"gh2CN"}],"k9k5Y":[function(require,module,exports) {
"use strict";
function _typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") _typeof = function _typeof(obj) {
        return typeof obj;
    };
    else _typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return _typeof(obj);
}
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("cb067d846c1f2129"));
var _propTypes = _interopRequireDefault(require("e61f6328ba6954ce"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return _possibleConstructorReturn(this, result);
    };
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) return call;
    return _assertThisInitialized(self);
}
function _assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var MIN = 0;
var MAX = 99999;
var InputRangeField = /*#__PURE__*/ function(_Component) {
    _inherits(InputRangeField, _Component);
    var _super = _createSuper(InputRangeField);
    function InputRangeField(props, context) {
        var _this;
        _classCallCheck(this, InputRangeField);
        _this = _super.call(this, props, context);
        _defineProperty(_assertThisInitialized(_this), "onChange", function(e) {
            var onChange = _this.props.onChange;
            var value = parseInt(e.target.value, 10);
            value = isNaN(value) ? 0 : Math.max(Math.min(MAX, value), MIN);
            onChange(value);
        });
        return _this;
    }
    _createClass(InputRangeField, [
        {
            key: "shouldComponentUpdate",
            value: function shouldComponentUpdate(nextProps) {
                var _this$props = this.props, value = _this$props.value, label = _this$props.label, placeholder = _this$props.placeholder;
                return value !== nextProps.value || label !== nextProps.label || placeholder !== nextProps.placeholder;
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$props2 = this.props, label = _this$props2.label, placeholder = _this$props2.placeholder, value = _this$props2.value, styles = _this$props2.styles, onBlur = _this$props2.onBlur, onFocus = _this$props2.onFocus;
                return /*#__PURE__*/ _react.default.createElement("div", {
                    className: styles.inputRange
                }, /*#__PURE__*/ _react.default.createElement("input", {
                    className: styles.inputRangeInput,
                    placeholder: placeholder,
                    value: value,
                    min: MIN,
                    max: MAX,
                    onChange: this.onChange,
                    onFocus: onFocus,
                    onBlur: onBlur
                }), /*#__PURE__*/ _react.default.createElement("span", {
                    className: styles.inputRangeLabel
                }, label));
            }
        }
    ]);
    return InputRangeField;
}(_react.Component);
InputRangeField.propTypes = {
    value: _propTypes.default.oneOfType([
        _propTypes.default.string,
        _propTypes.default.number
    ]),
    label: _propTypes.default.oneOfType([
        _propTypes.default.element,
        _propTypes.default.node
    ]).isRequired,
    placeholder: _propTypes.default.string,
    styles: _propTypes.default.shape({
        inputRange: _propTypes.default.string,
        inputRangeInput: _propTypes.default.string,
        inputRangeLabel: _propTypes.default.string
    }).isRequired,
    onBlur: _propTypes.default.func.isRequired,
    onFocus: _propTypes.default.func.isRequired,
    onChange: _propTypes.default.func.isRequired
};
InputRangeField.defaultProps = {
    value: "",
    placeholder: "-"
};
var _default = InputRangeField;
exports.default = _default;

},{"cb067d846c1f2129":"6uln9","e61f6328ba6954ce":"6FKs7"}],"1JfNp":[function() {},{}],"8BHQG":[function() {},{}],"8Rhf6":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _extends = require("@babel/runtime/helpers/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _colors = require("../../constants/colors");
const calendarIcon = require("5556f579ec7bc870");
const DateInputField = (props)=>(0, _react.jsx)("div", {
        className: containerStyle
    }, (0, _react.jsx)("img", {
        src: calendarIcon
    }), (0, _react.jsx)("input", (0, _extendsDefault.default)({
        name: props.name,
        type: "date"
    }, props)));
const containerStyle = /*#__PURE__*/ (0, _css.css)("background:#FFFFFF;border:1px solid ", (0, _colors.color_shades_dark), ";box-sizing:border-box;box-shadow:inset 0px 1px 2px rgba(50, 70, 97, 0.1);border-radius:8px;height:32px;width:154px;display:flex;align-items:center;padding:0 8px;>img{width:20px;height:20px;}input{border:none;background:transparent;box-shadow:none;margin-left:12px;font-family:Muli;font-style:normal;font-weight:normal;font-size:14px;line-height:20px;&::-webkit-calendar-picker-indicator,&::-webkit-inner-spin-button{display:none;}}", "");
exports.default = DateInputField;

},{"@babel/runtime/helpers/extends":"4iKIP","@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","../../constants/colors":"1p3OR","5556f579ec7bc870":"jTABg","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jTABg":[function(require,module,exports) {
module.exports = require("2104c8e65bc91e2e").getBundleURL("kVLro") + require("d9d48dbd6e76a85c").resolve("kZfp4");

},{"2104c8e65bc91e2e":"c7Tr5","d9d48dbd6e76a85c":"fyJL2"}],"9KECk":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _analyticsInterval = require("../../models/analytics/AnalyticsInterval");
var _colors = require("../../constants/colors");
const TimeIntervalPicker = (props)=>{
    return (0, _react.jsx)("div", {
        className: `${containerStyle} ac-analytics-common-intervals`
    }, (0, _analyticsInterval.analyticsIntervalTypes).map((a, i)=>(0, _react.jsx)("button", {
            className: `interval-item ${a == props.interval ? "active" : "inactive"}`,
            type: "button",
            onClick: ()=>props.onChange(a),
            key: i
        }, (0, _react.jsx)("p", null, a), (0, _react.jsx)("span", {
            className: "active-indicator"
        }))));
};
const containerStyle = /*#__PURE__*/ (0, _css.css)("display:flex;flex-direction:column;max-width:340px;width:340px;margin:24px 0;flex:1;button{background:transparent;height:40px;border-radius:4px;display:flex;align-items:center;padding:0 16px;font-family:Muli;font-style:normal;font-weight:normal;font-size:18px;line-height:24px;border:none;text-transform:capitalize;cursor:pointer;.active-indicator{display:none;}&.active{background:", (0, _colors.color_variants_ocean_light_1), ";.active-indicator{display:block;width:8px;height:8px;border-radius:50%;margin-right:0;margin-left:auto;background:", (0, _colors.color_text_link), ";}}}", "");
exports.default = TimeIntervalPicker;

},{"@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","../../models/analytics/AnalyticsInterval":"6TH5S","../../constants/colors":"1p3OR","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6TH5S":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "analyticsIntervalTypes", ()=>analyticsIntervalTypes);
const analyticsIntervalTypes = [
    "custom",
    "day",
    "past 7 days",
    "week",
    "past month",
    "month",
    "year"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"iffWk":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
const useClickOutside = (onClickOutside)=>{
    const ref = (0, _react.useRef)(null);
    (0, _react.useEffect)(()=>{
        const handleClickOutside = (event)=>{
            if (ref.current && !ref.current.contains(event.target)) onClickOutside();
        };
        document.addEventListener("mousedown", handleClickOutside);
        return ()=>{
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [
        onClickOutside
    ]);
    return ref;
};
exports.default = useClickOutside;

},{"react":"6uln9","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hMx5G":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _moment = require("moment");
var _momentDefault = parcelHelpers.interopDefault(_moment);
var _reactTabs = require("react-tabs");
var _scrollablePanelBody = require("../../../components/structure/ScrollablePanelBody");
var _scrollablePanelBodyDefault = parcelHelpers.interopDefault(_scrollablePanelBody);
var _tabbedLayout = require("../../../components/structure/TabbedLayout");
var _tabbedLayoutDefault = parcelHelpers.interopDefault(_tabbedLayout);
var _extensions = require("../../../models/extensions");
var _contentUserCharts = require("./ContentUserCharts");
var _contentUserChartsDefault = parcelHelpers.interopDefault(_contentUserCharts);
var _contentInteractionsCharts = require("./ContentInteractionsCharts");
var _contentInteractionsChartsDefault = parcelHelpers.interopDefault(_contentInteractionsCharts);
var _contentStatistics = require("./ContentStatistics");
var _contentStatisticsDefault = parcelHelpers.interopDefault(_contentStatistics);
var _analyticsDateFormat = require("../../../models/analytics/AnalyticsDateFormat");
class ContentMeasurementPage extends (0, _reactDefault.default).Component {
    handleTabSelection(index, last) {
        if (index == last) return;
        const urlStart = (0, _extensions.getEditUrl)(this.props.contentId, this.props.applicationFeatureId, this.props.featureTypeId) + "analytics/";
        if (index == 0) this.props.history.push(urlStart + "users");
        if (index == 1) this.props.history.push(urlStart + "activity");
        if (index == 2) this.props.history.push(urlStart + "report");
    }
    getSelectedIndex() {
        if (location.href.indexOf("activity") > -1) return 1;
        if (location.href.indexOf("report") > -1) return 2;
        return 0;
    }
    getInnerInterval(startDate, endDate) {
        // rule of 3s.
        // if we are under 3 days, use hours
        // if we are under 3 months, use days
        // if we are under 3 years, use months
        // use years
        // get hours between dates
        const hoursBetween = (0, _momentDefault.default)(endDate, (0, _analyticsDateFormat.DATE_FORMAT)).diff((0, _momentDefault.default)(startDate, (0, _analyticsDateFormat.DATE_FORMAT)), "hours");
        if (hoursBetween <= 72) return "hour";
        if (hoursBetween <= 2160) return "day";
        if (hoursBetween <= 26280) return "month";
        return "year";
    }
    handleMeasurementTypeChange(type) {
        this.setState({
            ...this.state,
            measurementType: type
        });
    }
    render() {
        const innerInterval = this.getInnerInterval(this.props.filter.startDate, this.props.filter.endDate);
        return (0, _react.jsx)((0, _scrollablePanelBodyDefault.default), null, (0, _react.jsx)((0, _tabbedLayoutDefault.default), {
            tabs: [
                "Users",
                "Activity",
                "Report"
            ],
            top: true,
            selectedIndex: this.getSelectedIndex(),
            onTabSelected: this.handleTabSelection.bind(this)
        }, (0, _react.jsx)((0, _reactTabs.TabPanel), null, (0, _react.jsx)((0, _contentUserChartsDefault.default), {
            contentId: this.props.contentId,
            filter: this.props.filter,
            interval: this.props.interval,
            innerInterval: innerInterval,
            stateContainer: this.props.userAnalyticsContainer,
            applicationId: this.props.applicationId
        })), (0, _react.jsx)((0, _reactTabs.TabPanel), null, (0, _react.jsx)((0, _contentInteractionsChartsDefault.default), {
            contentId: this.props.contentId,
            filter: this.props.filter,
            interval: this.props.interval,
            innerInterval: innerInterval,
            stateContainer: this.props.interactionAnalyticsContainer,
            applicationId: this.props.applicationId
        })), (0, _react.jsx)((0, _reactTabs.TabPanel), null, (0, _react.jsx)((0, _contentStatisticsDefault.default), {
            contentId: this.props.contentId,
            filter: this.props.filter,
            interval: this.props.interval,
            innerInterval: innerInterval,
            stateContainer: this.props.statisticsContainer,
            applicationId: this.props.applicationId
        }))));
    }
}
exports.default = ContentMeasurementPage;

},{"@emotion/react":"djZKr","react":"6uln9","moment":"2meyw","react-tabs":"92Sgf","../../../components/structure/ScrollablePanelBody":"6LRg3","../../../components/structure/TabbedLayout":"Hb6hy","../../../models/extensions":"7h01B","./ContentUserCharts":"4KTYb","./ContentInteractionsCharts":"gcRsF","./ContentStatistics":"d2UIf","../../../models/analytics/AnalyticsDateFormat":"ia5MW","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"Hb6hy":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _reactTabs = require("react-tabs");
var _tabIndicator = require("./TabIndicator");
var _tabIndicatorDefault = parcelHelpers.interopDefault(_tabIndicator);
var _css = require("@emotion/css");
var _colors = require("../../constants/colors");
var _breakpoints = require("../../constants/breakpoints");
var _sparkContainer = require("../../hooks/SparkContainer");
var _sparkContainerDefault = parcelHelpers.interopDefault(_sparkContainer);
var _useIsMobile = require("../../hooks/UseIsMobile");
var _useIsMobileDefault = parcelHelpers.interopDefault(_useIsMobile);
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const TabbedLayout = (props)=>{
    const sparkContainer = (0, _sparkContainerDefault.default).useContainer();
    const inSpark = sparkContainer.inSpark;
    const inMobile = (0, _useIsMobileDefault.default)();
    const tabListRef = (0, _react1.useRef)(null);
    const tabListStyle = /*#__PURE__*/ (0, _css.css)(tabStripStyle, ";", inSpark && inMobile && sparkMobileTabStripStyle, ";", inMobile && mobileTabStripStyle, ";", "");
    const indicatorGradient = `linear-gradient(267deg, ${(0, _colors.dark_sky_blue)}, ${(0, _colors.ocean_blue)});`;
    // Scroll selected tab into view on mobile (when first loaded, it goes to activity)
    (0, _react1.useEffect)(()=>{
        if (inMobile && tabListRef.current && props.selectedIndex !== undefined) {
            const tabListElement = tabListRef.current.querySelector("ul");
            if (tabListElement) {
                const selectedTab = tabListElement.children[props.selectedIndex];
                if (selectedTab) selectedTab.scrollIntoView({
                    behavior: "smooth",
                    block: "nearest",
                    inline: "center"
                });
            }
        }
    }, [
        props.selectedIndex,
        inMobile
    ]);
    (0, _react1.useEffect)(()=>{
        if (inMobile && tabListRef.current) {
            const tabListElement = tabListRef.current.querySelector("ul");
            if (tabListElement) tabListElement.scrollLeft = 0;
        }
    }, [
        inMobile
    ]);
    function renderTab(name) {
        return (0, _react.jsx)((0, _reactTabs.Tab), {
            selectedClassName: activeTabStyle,
            className: `${tabStyle} ac-tab-${name}`,
            key: name
        }, (0, _react.jsx)("span", null, name), (0, _react.jsx)((0, _tabIndicatorDefault.default), {
            color: indicatorGradient,
            className: tabIndicatorStyle
        }));
    }
    return (0, _react.jsx)((0, _reactTabs.Tabs), {
        forceRenderTabPanel: props.forceRenderTabPanel,
        className: props.top ? topTabLayoutStyle : tablayoutStyle,
        defaultIndex: props.selectedIndex,
        onSelect: props.onTabSelected
    }, (0, _react.jsx)("div", {
        ref: tabListRef
    }, (0, _react.jsx)((0, _reactTabs.TabList), {
        className: `${tabListStyle}`
    }, props.tabs.map(renderTab))), props.children);
};
const sparkMobileTabStripStyle = /*#__PURE__*/ (0, _css.css)({
    name: "17tdlt3",
    styles: "height:44px;align-items:center"
});
const mobileTabStripStyle = /*#__PURE__*/ (0, _css.css)({
    name: "tz07t2",
    styles: "height:50px;overflow-x:auto;overflow-y:hidden;flex-wrap:nowrap;-webkit-overflow-scrolling:touch;scrollbar-width:none;justify-content:flex-start;&::-webkit-scrollbar{display:none;}padding-bottom:3px;padding-left:0;margin-left:0"
});
const tabStripStyle = /*#__PURE__*/ (0, _css.css)("display:flex;justify-content:center;flex-direction:row;height:80px;list-style:none;border-bottom:solid 1px ", (0, _colors.silver_two), ";", "");
const tabStyle = /*#__PURE__*/ (0, _css.css)("display:flex;flex-direction:column;width:22%;color:black;text-align:center;cursor:pointer;span{flex-grow:1;line-height:80px;font-family:Muli;font-size:18px;font-weight:normal;font-style:normal;letter-spacing:0.5px;color:", (0, _colors.dark_grey_blue), ";}div{display:none;flex-grow:0;flex-shrink:0;}", (0, _breakpoints.breakpoint_small), "{min-width:120px;width:auto;flex-shrink:0;padding:0 16px;span{font-size:14px;text-align:center;line-height:50px;white-space:nowrap;}}", "");
const activeTabStyle = /*#__PURE__*/ (0, _css.css)("color:", (0, _colors.ocean_blue), ";div{display:block;}", "");
const tablayoutStyle = /*#__PURE__*/ (0, _css.css)("margin-top:80px;background:", (0, _colors.blue_white), ";", "");
const topTabLayoutStyle = /*#__PURE__*/ (0, _css.css)("margin-top:0;background:", (0, _colors.blue_white), ";", "");
const tabIndicatorStyle = /*#__PURE__*/ (0, _css.css)({
    name: "gm89as",
    styles: "margin:-2px auto 0 auto"
});
exports.default = TabbedLayout;

},{"@emotion/react":"djZKr","react":"6uln9","react-tabs":"92Sgf","./TabIndicator":"3Sj8d","@emotion/css":"awUBr","../../constants/colors":"1p3OR","../../constants/breakpoints":"2F01A","../../hooks/SparkContainer":"jzXzx","../../hooks/UseIsMobile":"9Gz1L","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4KTYb":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _contentAnalyticsCharts = require("./ContentAnalyticsCharts");
var _contentAnalyticsChartsDefault = parcelHelpers.interopDefault(_contentAnalyticsCharts);
class ContentUserCharts extends (0, _reactDefault.default).Component {
    componentDidMount() {
        this.loadChartData();
    }
    componentDidUpdate(previousProps) {
        if (previousProps.interval !== this.props.interval || JSON.stringify(previousProps.filter) != JSON.stringify(this.props.filter)) this.loadChartData();
    }
    async loadChartData() {
        this.setState({
            ...this.state,
            isLoadingHistograms: true
        });
        this.props.stateContainer.loadPrimaryBreakdown({
            applicationId: this.props.applicationId,
            contentId: this.props.contentId
        }, this.props.filter, this.props.stateContainer.state.currentBreakdown);
        this.props.stateContainer.loadSecondaryBreakdown({
            applicationId: this.props.applicationId,
            contentId: this.props.contentId
        }, this.props.filter, this.props.stateContainer.state.currentBreakdown);
        await this.props.stateContainer.loadPrimaryHistogram({
            applicationId: this.props.applicationId,
            contentId: this.props.contentId
        }, this.props.innerInterval, this.props.filter);
        await this.props.stateContainer.loadSecondaryHistogram({
            applicationId: this.props.applicationId,
            contentId: this.props.contentId
        }, this.props.innerInterval, this.props.filter);
        await this.props.stateContainer.getAverages({
            applicationId: this.props.applicationId,
            contentId: this.props.contentId
        }, this.props.filter);
    }
    render() {
        return (0, _react.jsx)((0, _contentAnalyticsChartsDefault.default), {
            applicationId: this.props.applicationId,
            contentId: this.props.contentId,
            filter: this.props.filter,
            innerInterval: this.props.innerInterval,
            interval: this.props.interval,
            dataType: "Users",
            stateContainer: this.props.stateContainer,
            showPrimary: this.props.stateContainer.state.currentDisplayOption?.toLocaleLowerCase()?.indexOf("total") > -1,
            showSecondary: this.props.stateContainer.state.currentDisplayOption?.toLowerCase()?.indexOf("new") > -1,
            secondaryDataName: "New Users",
            primaryDataName: "Total Users"
        });
    }
}
exports.default = ContentUserCharts;

},{"@emotion/react":"djZKr","react":"6uln9","./ContentAnalyticsCharts":"jqtRW","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jqtRW":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _defineProperty = require("@babel/runtime/helpers/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _moment = require("moment");
var _momentDefault = parcelHelpers.interopDefault(_moment);
var _colors = require("../../../constants/colors");
var _histogramChartCard = require("../../../components/charts/HistogramChartCard");
var _histogramChartCardDefault = parcelHelpers.interopDefault(_histogramChartCard);
var _analyticsSelectField = require("../../../components/analytics/AnalyticsSelectField");
var _analyticsSelectFieldDefault = parcelHelpers.interopDefault(_analyticsSelectField);
var _breakdownChartCard = require("../../../components/charts/BreakdownChartCard");
var _breakdownChartCardDefault = parcelHelpers.interopDefault(_breakdownChartCard);
var _averagesCard = require("../../../components/charts/AveragesCard");
var _averagesCardDefault = parcelHelpers.interopDefault(_averagesCard);
var _analyticsDateFormat = require("../../../models/analytics/AnalyticsDateFormat");
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
class ContentAnalyticsCharts extends (0, _reactDefault.default).Component {
    constructor(...args){
        super(...args);
        (0, _definePropertyDefault.default)(this, "today", (0, _momentDefault.default).utc());
    }
    componentDidMount() {
        this.props.stateContainer.loadFeatureTypes();
        this.props.stateContainer.loadDeviceTypes();
    }
    async handleBreakdownChange(option) {
        await this.props.stateContainer.handleBreakdownChange(option);
        await this.props.stateContainer.loadPrimaryBreakdown({
            applicationId: this.props.applicationId,
            contentId: this.props.contentId
        }, this.props.filter, option);
        await this.props.stateContainer.loadSecondaryBreakdown({
            applicationId: this.props.applicationId,
            contentId: this.props.contentId
        }, this.props.filter, option);
    }
    async handleDeltaPeriodChange(option) {
        await this.props.stateContainer.handleDeltaPeriodChange(option);
        await this.props.stateContainer.loadPrimaryHistogram({
            applicationId: this.props.applicationId,
            contentId: this.props.contentId
        }, this.props.innerInterval, this.props.filter);
        await this.props.stateContainer.loadSecondaryHistogram({
            applicationId: this.props.applicationId,
            contentId: this.props.contentId
        }, this.props.innerInterval, this.props.filter);
        await this.props.stateContainer.getAverages({
            applicationId: this.props.applicationId,
            contentId: this.props.contentId
        }, this.props.filter);
    }
    getInnerDateString(momentDate) {
        switch(this.props.innerInterval){
            case "year":
                return momentDate.format("YYYY");
            case "month":
                return momentDate.format("MMMM YYYY");
            case "day":
                return momentDate.format("MMMM DD, YYYY");
            case "hour":
                return momentDate.format("hh:mm a");
        }
    }
    render() {
        const prevDates = this.props.stateContainer.getPreviousDates(this.props.filter.startDate, this.props.filter.endDate);
        const histogramData = this.props.stateContainer.state.primaryHistogramData?.find((h)=>this.props.stateContainer.buildHistogramKey(h) == this.props.stateContainer.buildCacheKey(this.props.contentId, this.props.filter))?.data?.map((d)=>{
            const momentDate = (0, _momentDefault.default).utc(d.date);
            return {
                color: (0, _colors.ocean_blue),
                x: this.props.stateContainer.getHistogramDateLabel(this.props.innerInterval, momentDate),
                y: this.today.diff(momentDate) > 0 ? d.count : null,
                // null will add gaps - so we can null the values for future dates
                fullDate: this.getInnerDateString(momentDate)
            };
        });
        const secondaryHistogramData = this.props.stateContainer.state.secondaryHistogramData?.find((h)=>this.props.stateContainer.buildHistogramKey(h) == this.props.stateContainer.buildCacheKey(this.props.contentId, this.props.filter))?.data?.map((d)=>{
            const momentDate = (0, _momentDefault.default).utc(d.date);
            return {
                color: (0, _colors.ocean_blue),
                x: this.props.stateContainer.getHistogramDateLabel(this.props.innerInterval, momentDate),
                y: this.today.diff(momentDate) > 0 ? d.count : null,
                // null will add gaps - so we can null the values for future dates
                fullDate: this.getInnerDateString(momentDate)
            };
        });
        const breakdownData = this.props.stateContainer.state.primaryBreakdownData?.find((h)=>this.props.stateContainer.buildBreakdownKey(h) == this.props.stateContainer.buildCacheKey(this.props.contentId, this.props.filter, this.props.stateContainer.state.currentBreakdown))?.items ?? [];
        const secondaryBreakdownData = this.props.stateContainer.state.secondaryBreakdownData?.find((h)=>this.props.stateContainer.buildBreakdownKey(h) == this.props.stateContainer.buildCacheKey(this.props.contentId, this.props.filter, this.props.stateContainer.state.currentBreakdown))?.items ?? [];
        const averagesData = this.props.stateContainer.state.averages?.find((h)=>this.props.stateContainer.buildAverageKey(h) == this.props.stateContainer.buildCacheKey(this.props.contentId, this.props.filter))?.items ?? [];
        return (0, _react.jsx)("div", {
            className: wrapperStyle
        }, (0, _react.jsx)("div", {
            className: "options-row-container"
        }, (0, _react.jsx)((0, _analyticsSelectFieldDefault.default), {
            label: "Display:",
            options: this.props.stateContainer.displayOptions.map((s)=>({
                    label: s,
                    value: s
                })),
            value: this.props.stateContainer.state.currentDisplayOption,
            onChange: (e)=>this.props.stateContainer.handleDisplayOptionChange(e.value)
        }), (0, _react.jsx)("div", {
            className: "end-container"
        }, (0, _react.jsx)((0, _analyticsSelectFieldDefault.default), {
            label: "Compare to:",
            options: [
                "Previous Period",
                "Same Time Last Year"
            ].map((s)=>({
                    label: s,
                    value: s
                })),
            value: this.props.stateContainer.state.currentDeltaPeriod,
            onChange: (e)=>this.handleDeltaPeriodChange(e.value)
        }), (0, _react.jsx)((0, _analyticsSelectFieldDefault.default), {
            label: "Change in:",
            options: [
                "Value",
                "Percentage",
                "Value & Percentage"
            ].map((s)=>({
                    label: s,
                    value: s
                })),
            value: this.props.stateContainer.state.currentDeltaType,
            onChange: (e)=>this.props.stateContainer.handleDeltaTypeChange(e.value)
        }))), (0, _react.jsx)("div", {
            className: "card-container"
        }, (0, _react.jsx)("div", {
            className: histogramContainer
        }, (0, _react.jsx)((0, _histogramChartCardDefault.default), {
            isLoading: this.props.stateContainer.state.isLoadingHistogram || !histogramData,
            data: histogramData,
            showSecondary: this.props.showSecondary,
            showPrimary: this.props.showPrimary,
            secondaryData: secondaryHistogramData,
            secondaryDataName: this.props.secondaryDataName,
            primaryDataName: this.props.primaryDataName,
            title: this.props.dataType
        })), (0, _react.jsx)("div", {
            className: breakdownContainer
        }, (0, _react.jsx)((0, _breakdownChartCardDefault.default), {
            options: this.props.stateContainer.breakdownOptions,
            selectedOption: this.props.stateContainer.state.currentBreakdown,
            onOptionChange: this.handleBreakdownChange.bind(this),
            secondaryDataLabel: this.props.secondaryDataName,
            primaryDataLabel: this.props.primaryDataName,
            items: breakdownData,
            secondaryItems: secondaryBreakdownData,
            showSecondary: this.props.showSecondary,
            showPrimary: this.props.showPrimary,
            isLoading: this.props.stateContainer.state.isLoadingBreakdown
        }))), (0, _react.jsx)("div", {
            className: averagesContainer
        }, (0, _react.jsx)((0, _averagesCardDefault.default), {
            items: averagesData ?? [],
            comparedDateRangeLabel: `vs ${(0, _momentDefault.default)(prevDates.startDate, (0, _analyticsDateFormat.DATE_FORMAT)).format("MMM DD, YYYY")} - ${(0, _momentDefault.default)(prevDates.endDate, (0, _analyticsDateFormat.DATE_FORMAT)).format("MMM DD, YYYY")}`,
            showPercentage: this.props.stateContainer.state.currentDeltaType.toLocaleLowerCase().indexOf("percentage") > -1,
            showValue: this.props.stateContainer.state.currentDeltaType.toLocaleLowerCase().indexOf("value") > -1
        })));
    }
}
const wrapperStyle = /*#__PURE__*/ (0, _css.css)({
    name: "1f8klr2",
    styles: ".card-container{display:flex;}.options-row-container{display:flex;align-items:center;margin:32px;}.end-container{display:flex;align-items:center;margin-right:0;margin-left:auto;>div{margin-left:24px;}}"
});
const histogramContainer = /*#__PURE__*/ (0, _css.css)({
    name: "j411l2",
    styles: "flex:1;min-width:300px;margin:0 32px"
});
const breakdownContainer = /*#__PURE__*/ (0, _css.css)({
    name: "1qijuei",
    styles: "min-width:300px;margin-right:32px"
});
const averagesContainer = /*#__PURE__*/ (0, _css.css)({
    name: "18d63h3",
    styles: "margin:32px"
});
exports.default = ContentAnalyticsCharts;

},{"@babel/runtime/helpers/defineProperty":"9sJxO","@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","moment":"2meyw","../../../constants/colors":"1p3OR","../../../components/charts/HistogramChartCard":"cGWvK","../../../components/analytics/AnalyticsSelectField":"fCPWH","../../../components/charts/BreakdownChartCard":"dvaPH","../../../components/charts/AveragesCard":"1L0S8","../../../models/analytics/AnalyticsDateFormat":"ia5MW","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"cGWvK":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "HistogramChartCard", ()=>HistogramChartCard);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _reactDom = require("react-dom");
var _reactDomDefault = parcelHelpers.interopDefault(_reactDom);
var _css = require("@emotion/css");
var _colors = require("../../constants/colors");
var _line = require("@nivo/line");
var _secondaryLoader = require("../general/SecondaryLoader");
var _secondaryLoaderDefault = parcelHelpers.interopDefault(_secondaryLoader);
var _chartTheme = require("../../constants/chartTheme");
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const primaryIndicator = require("1899fe3e85579e22");
const secondaryIndicator = require("252aca2f4ead97");
// Multi-line histogram chart component
const HistogramChartMultiLine = (props)=>{
    // Track if we're on mobile for margin adjustments
    const [isMobile, setIsMobile] = (0, _reactDefault.default).useState(false);
    // Laptop breakpoint detection — same pattern as ChartTooltip.tsx and TransfersChart.tsx
    const screenWidth = typeof window !== "undefined" ? window.innerWidth : 1920;
    const isChromebook = screenWidth >= 1024 && screenWidth < 1280;
    const isSmallLaptop = screenWidth >= 1280 && screenWidth < 1440;
    const ttBody = isChromebook ? "10px" : isSmallLaptop ? "11px" : "12px";
    const ttValue = isChromebook ? "13px" : isSmallLaptop ? "14px" : "16px";
    (0, _reactDefault.default).useEffect(()=>{
        const checkMobile = ()=>setIsMobile(window.innerWidth <= 640);
        checkMobile();
        window.addEventListener("resize", checkMobile);
        return ()=>window.removeEventListener("resize", checkMobile);
    }, []);
    const chartContainerStyle = /*#__PURE__*/ (0, _css.css)({
        name: "189dn3i",
        styles: "height:100%;width:100%;overflow:hidden;padding:0;font-family:Muli;flex:1;min-height:0;tspan{font-family:Muli;font-size:10px;font-weight:normal;@media (max-width: 640px){font-size:8px;}}"
    });
    const tooltipStyle = /*#__PURE__*/ (0, _css.css)("position:fixed;background:", (0, _chartTheme.tooltipStyles).container.background, ";backdrop-filter:", (0, _chartTheme.tooltipStyles).container.backdropFilter, ";padding:", (0, _chartTheme.tooltipStyles).container.padding, ";border-radius:", (0, _chartTheme.tooltipStyles).container.borderRadius, ";box-shadow:", (0, _chartTheme.tooltipStyles).container.boxShadow, ";border:", (0, _chartTheme.tooltipStyles).container.border, ";min-width:", (0, _chartTheme.tooltipStyles).container.minWidth, ";z-index:99999;pointer-events:none;.date-label{font-weight:", (0, _chartTheme.tooltipStyles).title.fontWeight, ";font-size:", (0, _chartTheme.tooltipStyles).title.fontSize, ";line-height:20px;color:", (0, _chartTheme.tooltipStyles).title.color, ";margin-bottom:", (0, _chartTheme.tooltipStyles).title.marginBottom, "px;@media (min-width: 1280px) and (max-width: 1439.98px){font-size:12px;}@media (min-width: 1024px) and (max-width: 1279.98px){font-size:11px;}}.value-label{font-size:13px;color:", (0, _colors.color_shades_darker), ";@media (min-width: 1280px) and (max-width: 1439.98px){font-size:11px;}@media (min-width: 1024px) and (max-width: 1279.98px){font-size:10px;}}", "");
    // Portal-based tooltip component that follows cursor
    const PortalTooltip = ({ slice })=>{
        const [position, setPosition] = (0, _reactDefault.default).useState({
            x: 0,
            y: 0
        });
        (0, _reactDefault.default).useEffect(()=>{
            // Skip mouse tracking for mobile compact mode
            if (isMobile) return;
            const handleMouseMove = (e)=>{
                setPosition({
                    x: e.clientX,
                    y: e.clientY
                });
            };
            document.addEventListener("mousemove", handleMouseMove);
            return ()=>document.removeEventListener("mousemove", handleMouseMove);
        }, [
            isMobile
        ]);
        // Format the date for display (day of week and date only, no time)
        const formatDate = (dateString)=>{
            if (!dateString) return "";
            const date = new Date(dateString);
            if (isNaN(date.getTime())) return dateString;
            return date.toLocaleDateString("en-US", {
                weekday: "long",
                month: "short",
                day: "numeric",
                year: "numeric"
            });
        };
        // Format date for compact mobile display (shorter)
        const formatDateCompact = (dateString)=>{
            if (!dateString) return "";
            const date = new Date(dateString);
            if (isNaN(date.getTime())) return dateString;
            return date.toLocaleDateString("en-US", {
                weekday: "short",
                month: "short",
                day: "numeric"
            });
        };
        // Collect values and colors from actual data points in the slice
        const seriesMap = {};
        // Helper to clean series name (remove trailing .0, .1, etc. that nivo may append)
        const cleanSeriesName = (name)=>{
            return name?.replace(/\.\d+$/, "") || "Unknown";
        };
        slice.points.forEach((p)=>{
            // nivo ResponsiveLine with enableSlices="x" provides serieId on slice points
            // Also check serie.id as a fallback for different nivo versions
            const rawSeriesName = p.serieId ?? p.serie?.id ?? p.id ?? "Unknown";
            const seriesName = cleanSeriesName(String(rawSeriesName));
            const yValue = p.data?.y ?? p.y ?? 0;
            const seriesColor = p.serieColor ?? p.serie?.color ?? p.color ?? (0, _colors.color_shades_darker);
            if (!seriesMap[seriesName]) seriesMap[seriesName] = {
                value: yValue,
                color: seriesColor
            };
            else seriesMap[seriesName].value += yValue;
        });
        // Determine if this is the "All Conversations" view with nested series (contained ⊆ containable ⊆ all)
        const allCallsValue = seriesMap["All Conversations"]?.value;
        const containableCallsValue = seriesMap["Containable Conversations"]?.value;
        const containedCallsValue = seriesMap["Contained Conversations"]?.value;
        const isAllCallsView = allCallsValue !== undefined && containableCallsValue !== undefined && containedCallsValue !== undefined;
        // Check for partial "All Conversations" view (when only 2 of 3 series present, like Containable Conversations view)
        const isContainableCallsView = !isAllCallsView && containableCallsValue !== undefined && containedCallsValue !== undefined;
        // For Spanish calls view
        const allSpanishCallsValue = seriesMap["All Spanish Calls"]?.value;
        const spanishContainableValue = seriesMap["Spanish Containable Conversations"]?.value;
        const spanishContainedValue = seriesMap["Spanish Contained Conversations"]?.value;
        const isSpanishCallsView = allSpanishCallsValue !== undefined && spanishContainableValue !== undefined && spanishContainedValue !== undefined;
        // Calculate percentages for nested series
        const getPercentage = (value, parent)=>{
            if (parent === 0) return "0%";
            return `${Math.round(value / parent * 100)}%`;
        };
        // Build display data with percentages for nested views
        const getDisplayData = ()=>{
            if (isAllCallsView) // All Conversations view: show raw values + % of parent
            // Contained is % of Containable, Containable is % of All Conversations
            return [
                {
                    name: "All Conversations",
                    value: allCallsValue,
                    color: seriesMap["All Conversations"].color
                },
                {
                    name: "Containable Conversations",
                    value: containableCallsValue,
                    color: seriesMap["Containable Conversations"].color,
                    percentage: getPercentage(containableCallsValue, allCallsValue)
                },
                {
                    name: "Contained Conversations",
                    value: containedCallsValue,
                    color: seriesMap["Contained Conversations"].color,
                    percentage: getPercentage(containedCallsValue, containableCallsValue)
                }
            ];
            else if (isContainableCallsView) // Containable Conversations view (only Containable + Contained, no All Conversations)
            // Contained is % of Containable
            return [
                {
                    name: "Containable Conversations",
                    value: containableCallsValue,
                    color: seriesMap["Containable Conversations"].color
                },
                {
                    name: "Contained Conversations",
                    value: containedCallsValue,
                    color: seriesMap["Contained Conversations"].color,
                    percentage: getPercentage(containedCallsValue, containableCallsValue)
                }
            ];
            else if (isSpanishCallsView) // Spanish Calls view: similar nested structure
            return [
                {
                    name: "All Spanish Calls",
                    value: allSpanishCallsValue,
                    color: seriesMap["All Spanish Calls"].color
                },
                {
                    name: "Spanish Containable Conversations",
                    value: spanishContainableValue,
                    color: seriesMap["Spanish Containable Conversations"].color,
                    percentage: getPercentage(spanishContainableValue, allSpanishCallsValue)
                },
                {
                    name: "Spanish Contained Conversations",
                    value: spanishContainedValue,
                    color: seriesMap["Spanish Contained Conversations"].color,
                    percentage: getPercentage(spanishContainedValue, spanishContainableValue)
                }
            ];
            else // Other views (Average Calls, Concurrent Calls, etc.): just show raw values
            // Filter out 'undefined' or 'Unknown' series names
            return Object.entries(seriesMap).filter(([name])=>name !== "undefined" && name !== "Unknown").map(([name, data])=>({
                    name,
                    value: data.value,
                    color: data.color
                }));
        };
        const displayData = getDisplayData();
        const rawDate = slice.points[0]?.data?.fullDate || slice.points[0]?.data?.x;
        // Determine if this is the first data point (near left edge)
        // slice.x is the pixel position of the slice within the chart
        const isFirstPoint = slice.x !== undefined && slice.x < 60;
        // Compact mode for mobile - render inline simplified tooltip
        if (isMobile) {
            const formattedDateMobile = formatDateCompact(rawDate);
            // Show only the first/primary series for compact view
            const primaryData = displayData[0];
            return (0, _react.jsx)("div", {
                style: {
                    background: (0, _chartTheme.tooltipStyles).container.background,
                    backdropFilter: (0, _chartTheme.tooltipStyles).container.backdropFilter,
                    padding: "10px 14px",
                    borderRadius: (0, _chartTheme.tooltipStyles).container.borderRadius,
                    boxShadow: (0, _chartTheme.tooltipStyles).container.boxShadow,
                    border: (0, _chartTheme.tooltipStyles).container.border,
                    maxWidth: "180px",
                    textAlign: "center",
                    // Shift tooltip to the right if it's the first point to avoid going off-screen
                    transform: isFirstPoint ? "translateX(100%)" : undefined
                }
            }, (0, _react.jsx)("div", {
                style: {
                    fontSize: "11px",
                    color: (0, _colors.color_shades_darker),
                    marginBottom: 6
                }
            }, formattedDateMobile), primaryData && (0, _react.jsx)("div", {
                style: {
                    marginBottom: displayData.length > 1 ? 4 : 0
                }
            }, (0, _react.jsx)("span", {
                style: {
                    fontWeight: 600,
                    fontSize: "14px",
                    color: (0, _colors.color_shades_darkest)
                }
            }, primaryData.value.toLocaleString()), (0, _react.jsx)("span", {
                style: {
                    fontSize: "11px",
                    color: (0, _colors.color_shades_darker),
                    marginLeft: 4
                }
            }, primaryData.name.replace(" Calls", "").toLowerCase())), displayData.length > 1 && displayData[displayData.length - 1].percentage && (0, _react.jsx)("div", {
                style: {
                    fontSize: "10px",
                    color: (0, _colors.color_shades_darker),
                    lineHeight: 1.3
                }
            }, displayData[displayData.length - 1].percentage, " contained"));
        }
        const formattedDate = formatDate(rawDate);
        // Position tooltip - normally to the left, but to the right if near the left edge
        const tooltipWidth = 280;
        const padding = 15;
        // Check if tooltip would go off the left edge, if so position to the right
        const wouldGoOffLeft = position.x - tooltipWidth - padding < 10;
        const leftPosition = wouldGoOffLeft ? position.x + padding : position.x - tooltipWidth - padding;
        const tooltipContent = (0, _react.jsx)("div", {
            className: tooltipStyle,
            style: {
                left: leftPosition,
                top: position.y - 10
            }
        }, (0, _react.jsx)("p", {
            className: "date-label"
        }, formattedDate), displayData.map((series, index)=>(0, _react.jsx)("div", {
                key: series.name,
                style: {
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    gap: "16px",
                    marginTop: index === 0 ? 0 : 6,
                    paddingTop: index === 0 ? 0 : 6,
                    borderTop: index === 0 ? "none" : `1px solid ${0, _colors.color_shades_light}`
                }
            }, (0, _react.jsx)("span", {
                style: {
                    display: "flex",
                    alignItems: "center",
                    gap: "8px",
                    fontSize: ttBody,
                    color: (0, _colors.color_shades_darker)
                }
            }, (0, _react.jsx)("span", {
                style: {
                    ...(0, _chartTheme.tooltipStyles).colorIndicator,
                    backgroundColor: series.color,
                    border: `2px solid ${series.color}`,
                    opacity: 0.9
                }
            }), series.name), (0, _react.jsx)("span", {
                style: {
                    display: "flex",
                    alignItems: "center",
                    gap: "4px"
                }
            }, (0, _react.jsx)("span", {
                style: {
                    fontWeight: 600,
                    fontSize: ttValue,
                    color: (0, _colors.color_shades_darkest)
                }
            }, series.value.toLocaleString()), series.percentage && (0, _react.jsx)("span", {
                style: {
                    fontWeight: 500,
                    fontSize: ttBody,
                    color: (0, _colors.color_shades_darker)
                }
            }, "(", series.percentage, ")")))));
        return /*#__PURE__*/ (0, _reactDomDefault.default).createPortal(tooltipContent, document.body);
    };
    const SliceTooltip = ({ slice })=>{
        return (0, _react.jsx)(PortalTooltip, {
            slice: slice
        });
    };
    // Calculate tick values to display based on data length and device size
    const getTickValues = ()=>{
        if (!props.data || props.data.length === 0) return undefined;
        const dataLength = props.data[0]?.data?.length || 0;
        if (isMobile) {
            // On mobile, show fewer ticks based on data density
            if (dataLength <= 7) // 7 days or less: show all
            return undefined;
            else if (dataLength <= 14) // 8-14 points: show every other
            return props.data[0]?.data?.filter((_, i)=>i % 2 === 0).map((d)=>d.x) || undefined;
            else if (dataLength <= 24) // 15-24 points (hours): show every 4th (6 labels)
            return props.data[0]?.data?.filter((_, i)=>i % 4 === 0).map((d)=>d.x) || undefined;
            else // More than 24 points: show every 5th
            return props.data[0]?.data?.filter((_, i)=>i % 5 === 0).map((d)=>d.x) || undefined;
        }
        // Desktop: show more labels but still limit if very dense
        if (dataLength > 31) return props.data[0]?.data?.filter((_, i)=>i % 3 === 0).map((d)=>d.x) || undefined;
        return undefined; // nivo will auto-determine
    };
    return (0, _react.jsx)("div", {
        className: chartContainerStyle
    }, (0, _react.jsx)((0, _line.ResponsiveLine), {
        data: props.data,
        enableArea: true,
        areaOpacity: 0.08,
        animate: true,
        curve: "monotoneX",
        enableGridX: false,
        colors: (series)=>series.color,
        lineWidth: isMobile ? 2 : 2.5,
        pointSize: isMobile ? 3 : 5,
        pointBorderColor: (0, _colors.color_defaults_white),
        pointBorderWidth: isMobile ? 1 : 1.5,
        pointColor: (point)=>point.series.color,
        useMesh: true,
        enableSlices: "x",
        sliceTooltip: SliceTooltip,
        margin: {
            top: isMobile ? 8 : 10,
            right: isMobile ? 35 : 55,
            bottom: isMobile ? 50 : 55,
            left: isMobile ? 30 : 55
        },
        axisTop: null,
        axisLeft: null,
        axisBottom: {
            tickSize: 0,
            tickPadding: isMobile ? 3 : 5,
            tickRotation: isMobile ? -55 : -45,
            tickValues: getTickValues()
        },
        axisRight: {
            tickSize: 0,
            tickPadding: isMobile ? 4 : 8,
            tickRotation: 0,
            tickValues: isMobile ? 5 : undefined
        },
        theme: {
            background: "#ffffff",
            tooltip: {
                container: {
                    fontSize: "13px"
                }
            },
            labels: {
                text: {
                    color: "#555"
                }
            }
        },
        legends: []
    }));
};
const HistogramChartCard = (props)=>{
    const allViewOptions = [
        "All Conversations",
        "Containable Conversations",
        "Order Calls",
        "Average Calls by Day of Week",
        "Average Calls by Hour",
        "Concurrent Calls",
        "Spanish Calls"
    ];
    const viewOptions = allViewOptions.filter((option)=>{
        if (props.hideSpanishCallsOption && option === "Spanish Calls") return false;
        if (props.hideConcurrentCallsOption && option === "Concurrent Calls") return false;
        if (props.hideContainableCallsOption && option === "Containable Conversations") return false;
        if (props.hideOrderCallsOption && option === "Order Calls") return false;
        return true;
    });
    const containerStyle = /*#__PURE__*/ (0, _css.css)("height:100%;width:auto;font-family:Muli;border:1px solid #CBCCD2;box-sizing:border-box;border-radius:8px;flex:1;background:white;overflow:visible;display:flex;flex-direction:column;.loader-container{display:flex;flex:1;align-items:center;justify-content:center;height:100%;width:100%;.spinner>div{background:", (0, _colors.color_colors_ocean), ";}}.title-section{display:flex;align-items:center;flex-shrink:0;flex-wrap:wrap;gap:8px;margin:", props.titleMargin ? `${props.titleMargin.top}px ${props.titleMargin.right}px ${props.titleMargin.bottom}px ${props.titleMargin.left}px` : props.subtitle ? "0px 0px 24px 0px" : "0px", ";padding:", props.titlePadding ? `${props.titlePadding.top}px ${props.titlePadding.right}px ${props.titlePadding.bottom}px ${props.titlePadding.left}px` : props.subtitle ? "16px" : "16px 16px 0px 16px", ";@media (max-width: 640px){flex-direction:column;align-items:flex-start;padding:12px 12px 8px 12px;gap:8px;}.title-with-dropdown{display:flex;align-items:center;gap:12px;position:relative;z-index:10;@media (max-width: 640px){gap:8px;width:100%;flex-wrap:wrap;}}.export-button{padding:5px 12px;background:#2C3D52;color:white;border:none;border-radius:16px;font-size:10px;font-weight:600;cursor:pointer;transition:all 0.2s ease;white-space:nowrap;position:relative;z-index:10;@media (min-width: 1440px) and (max-width: 1679.98px){padding:5px 10px;font-size:10px;}@media (min-width: 1280px) and (max-width: 1439.98px){padding:4px 9px;font-size:9px;}@media (min-width: 1024px) and (max-width: 1279.98px){padding:3px 7px;font-size:8px;}@media (max-width: 640px){padding:5px 10px;font-size:10px;}&:hover:not(:disabled){background:#3a5068;box-shadow:0 2px 8px rgba(0, 0, 0, 0.15);}&:active:not(:disabled){transform:scale(0.98);}&:disabled{opacity:0.5;cursor:not-allowed;}}.title-label{font-size:18px;line-height:24px;letter-spacing:0.1em;text-transform:uppercase;color:", (0, _colors.color_text_light), ";margin:0;text-align:center;@media (max-width: 640px){font-size:14px;line-height:20px;}}.view-dropdown{position:relative;z-index:10;select{font-size:15px;font-weight:600;color:#2D2D39;padding:4px 24px 4px 8px;border:1px solid ", (0, _colors.color_shades_light), ";border-radius:4px;background:white;cursor:pointer;appearance:none;font-family:Muli;@media (min-width: 1280px) and (max-width: 1439.98px){font-size:10px;padding:3px 20px 3px 6px;}@media (min-width: 1024px) and (max-width: 1279.98px){font-size:9px;padding:3px 18px 3px 5px;}@media (max-width: 640px){font-size:13px;padding:4px 20px 4px 6px;}&:hover:not(:disabled){border-color:", (0, _colors.color_colors_ocean), ";}&:focus{outline:none;border-color:", (0, _colors.color_colors_ocean), ";}&:disabled{opacity:0.6;cursor:not-allowed;background:#f5f5f5;color:#888;}}&::after{content:'▼';position:absolute;right:8px;top:50%;transform:translateY(-50%);pointer-events:none;font-size:10px;color:#2D2D39;@media (max-width: 640px){right:6px;font-size:8px;}}}.legend-container{display:flex;align-items:center;flex-wrap:wrap;margin-right:0;margin-left:auto;gap:4px 0;@media (max-width: 640px){margin-left:0;width:100%;justify-content:flex-start;gap:4px 8px;}>img{margin-right:8px;@media (max-width: 640px){margin-right:4px;width:10px;height:10px;}}>div{@media (max-width: 640px){width:10px!important;height:10px!important;margin-right:3px!important;}}>p{font-style:normal;font-weight:normal;font-size:14px;line-height:20px;text-align:right;margin-right:16px;@media (min-width: 1280px) and (max-width: 1439.98px){font-size:10px!important;line-height:15px;margin-right:10px!important;}@media (min-width: 1024px) and (max-width: 1279.98px){font-size:9px!important;line-height:14px;margin-right:8px!important;}@media (max-width: 640px){font-size:10px!important;line-height:14px;margin-right:6px!important;text-align:left;}}}}.subtitle-section{display:flex;align-items:center;margin-top:-7px;padding:0px 36px;margin-left:-7px;@media (max-width: 640px){padding:0px 12px;margin-left:0;margin-top:-4px;}h4{font-style:normal;font-weight:normal;font-color:", (0, _colors.color_text_light), ";font-size:12px;line-height:18px;flex:1;@media (max-width: 640px){font-size:10px;line-height:14px;}}}", "");
    // Prepare data for the chart
    const chartData = props.multiLineData || (props.showPrimary || props.showSecondary ? [
        ...props.showPrimary ? [
            {
                id: props.primaryDataName,
                data: props.data,
                color: (0, _colors.ocean_blue)
            }
        ] : [],
        ...props.showSecondary ? [
            {
                id: props.secondaryDataName,
                data: props.secondaryData,
                color: (0, _colors.ocean_blue)
            }
        ] : []
    ] : []);
    return (0, _react.jsx)("div", {
        className: containerStyle
    }, (0, _react.jsx)("div", {
        className: "title-section ac-analytics-histogram-card"
    }, props.showViewDropdown ? (0, _react.jsx)("div", {
        className: "title-with-dropdown"
    }, (0, _react.jsx)("div", {
        className: "view-dropdown"
    }, (0, _react.jsx)("select", {
        value: props.selectedView || "Containable Conversations",
        onChange: (e)=>props.onViewChange?.(e.target.value),
        disabled: props.disableViewDropdown
    }, viewOptions.map((option)=>(0, _react.jsx)("option", {
            key: option,
            value: option
        }, props.viewOptionLabels?.[option] || option)))), props.onExportClick && (props.selectedView === "All Conversations" || props.selectedView === "Containable Conversations") && (0, _react.jsx)("button", {
        className: "export-button",
        onClick: props.onExportClick,
        "data-view-export-button": true,
        disabled: props.isLoading
    }, props.exportButtonText || "View Details")) : (0, _react.jsx)("h5", {
        className: props.titleStyle || "title-label",
        style: props.titleStyles
    }, props.title), (0, _react.jsx)("div", {
        className: "legend-container"
    }, props?.filterButton === undefined ? (0, _react.jsx)((0, _reactDefault.default).Fragment, null, props.multiLineData ? // Show legend for multi-line data
    props.multiLineData.map((line, idx)=>(0, _react.jsx)((0, _reactDefault.default).Fragment, {
            key: line.id
        }, (0, _react.jsx)("div", {
            style: {
                width: 12,
                height: 12,
                backgroundColor: line.color,
                borderRadius: 2,
                marginRight: 4
            }
        }), (0, _react.jsx)("p", {
            style: {
                marginRight: idx < props.multiLineData.length - 1 ? 16 : 0,
                display: "inline-flex",
                alignItems: "center",
                gap: "2px"
            }
        }, line.id, props.legendCounts?.[line.id] !== undefined && (0, _react.jsx)("span", {
            style: {
                marginLeft: 2
            }
        }, "(", props.legendCounts[line.id].toLocaleString(), ")"), props.legendTooltips?.[line.id] && props.renderLegendTooltip && props.renderLegendTooltip(line.id, props.legendTooltips[line.id])))) : (0, _react.jsx)((0, _reactDefault.default).Fragment, null, props.showSecondary && (0, _react.jsx)((0, _reactDefault.default).Fragment, null, (0, _react.jsx)("img", {
        src: secondaryIndicator
    }), (0, _react.jsx)("p", null, props.secondaryDataName)), props.showPrimary && (0, _react.jsx)((0, _reactDefault.default).Fragment, null, (0, _react.jsx)("img", {
        src: primaryIndicator
    }), (0, _react.jsx)("p", null, props.primaryDataName)))) : props.filterButton)), props.subtitle && (0, _react.jsx)("div", {
        className: "subtitle-section ac-analytics-histogram-card"
    }, (0, _react.jsx)("h4", null, props.subtitle)), props.isLoading ? (0, _react.jsx)("div", {
        className: "loader-container"
    }, (0, _react.jsx)((0, _secondaryLoaderDefault.default), null)) : (0, _react.jsx)(HistogramChartMultiLine, {
        data: chartData,
        padding: props.graphPadding,
        paddingBottom: props.graphBottomPadding,
        hasSubtitle: !!props.subtitle,
        scale: props.scale
    }));
};
exports.default = HistogramChartCard;

},{"@emotion/react":"djZKr","react":"6uln9","react-dom":"b8T3j","@emotion/css":"awUBr","../../constants/colors":"1p3OR","@nivo/line":"aa8Vk","../general/SecondaryLoader":"7zJiF","../../constants/chartTheme":"1MLTJ","1899fe3e85579e22":"73v87","252aca2f4ead97":"43uUb","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"aa8Vk":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LINE_UNIQUE_ID_PREFIX", ()=>le);
parcelHelpers.export(exports, "Line", ()=>ye);
parcelHelpers.export(exports, "LineCanvas", ()=>Be);
parcelHelpers.export(exports, "ResponsiveLine", ()=>Me);
parcelHelpers.export(exports, "ResponsiveLineCanvas", ()=>Te);
parcelHelpers.export(exports, "canvasDefaultProps", ()=>ne);
parcelHelpers.export(exports, "commonDefaultProps", ()=>oe);
parcelHelpers.export(exports, "isPoint", ()=>ke);
parcelHelpers.export(exports, "isSliceData", ()=>We);
parcelHelpers.export(exports, "svgDefaultProps", ()=>ie);
parcelHelpers.export(exports, "useAreaGenerator", ()=>re);
parcelHelpers.export(exports, "useLine", ()=>se);
parcelHelpers.export(exports, "useLineGenerator", ()=>te);
parcelHelpers.export(exports, "useSlices", ()=>ae);
var _react = require("react");
var _core = require("@nivo/core");
var _axes = require("@nivo/axes");
var _legends = require("@nivo/legends");
var _tooltip = require("@nivo/tooltip");
var _d3Shape = require("d3-shape");
var _uniqueIdJs = require("lodash/uniqueId.js");
var _uniqueIdJsDefault = parcelHelpers.interopDefault(_uniqueIdJs);
var _theming = require("@nivo/theming");
var _colors = require("@nivo/colors");
var _scales = require("@nivo/scales");
var _jsxRuntime = require("react/jsx-runtime");
var _web = require("@react-spring/web");
var _voronoi = require("@nivo/voronoi");
function $() {
    return $ = Object.assign ? Object.assign.bind() : function(e) {
        for(var o = 1; o < arguments.length; o++){
            var i = arguments[o];
            for(var n in i)({}).hasOwnProperty.call(i, n) && (e[n] = i[n]);
        }
        return e;
    }, $.apply(null, arguments);
}
function _(e, o) {
    if (null == e) return {};
    var i = {};
    for(var n in e)if (({}).hasOwnProperty.call(e, n)) {
        if (-1 !== o.indexOf(n)) continue;
        i[n] = e[n];
    }
    return i;
}
var ee, oe = {
    xScale: {
        type: "point"
    },
    yScale: {
        type: "linear",
        min: 0,
        max: "auto"
    },
    curve: "linear",
    colors: {
        scheme: "nivo"
    },
    lineWidth: 2,
    layers: [
        "grid",
        "markers",
        "axes",
        "areas",
        "crosshair",
        "lines",
        "points",
        "slices",
        "mesh",
        "legends"
    ],
    enablePoints: !0,
    pointSize: 6,
    pointColor: {
        from: "series.color"
    },
    pointBorderWidth: 0,
    pointBorderColor: {
        theme: "background"
    },
    enableArea: !1,
    areaBaselineValue: 0,
    areaOpacity: .2,
    enableGridX: !0,
    enableGridY: !0,
    legends: [],
    isInteractive: !0,
    tooltip: (0, _react.memo)(function(e) {
        var o = e.point;
        return (0, _jsxRuntime.jsx)((0, _tooltip.BasicTooltip), {
            id: (0, _jsxRuntime.jsxs)("span", {
                children: [
                    "x: ",
                    (0, _jsxRuntime.jsx)("strong", {
                        children: o.data.xFormatted
                    }),
                    ", y:",
                    " ",
                    (0, _jsxRuntime.jsx)("strong", {
                        children: o.data.yFormatted
                    })
                ]
            }),
            enableChip: !0,
            color: o.seriesColor
        });
    }),
    sliceTooltip: (0, _react.memo)(function(e) {
        var o = e.slice, i = e.axis, n = (0, _theming.useTheme)(), t = "x" === i ? "y" : "x";
        return (0, _jsxRuntime.jsx)((0, _tooltip.TableTooltip), {
            rows: o.points.map(function(e) {
                return [
                    (0, _jsxRuntime.jsx)((0, _tooltip.Chip), {
                        color: e.seriesColor,
                        style: n.tooltip.chip
                    }, "chip"),
                    e.seriesId,
                    (0, _jsxRuntime.jsx)("span", {
                        style: n.tooltip.tableCellValue,
                        children: e.data[t + "Formatted"]
                    }, "value")
                ];
            })
        });
    }),
    debugMesh: !1,
    renderWrapper: !0
}, ie = $({}, oe, {
    defs: [],
    fill: [],
    enablePointLabel: !1,
    pointLabel: "data.yFormatted",
    areaBlendMode: "normal",
    axisTop: null,
    axisRight: null,
    axisBottom: (0, _axes.defaultAxisProps),
    axisLeft: (0, _axes.defaultAxisProps),
    useMesh: !1,
    enableSlices: !1,
    debugSlices: !1,
    enableCrosshair: !0,
    crosshairType: "bottom-left",
    enableTouchCrosshair: !1,
    initialHiddenIds: [],
    animate: !0,
    motionConfig: "gentle",
    role: "img",
    isFocusable: !1
}), ne = $({}, oe, {
    pixelRatio: "undefined" != typeof window && null != (ee = window.devicePixelRatio) ? ee : 1,
    axisTop: null,
    axisRight: null,
    axisBottom: (0, _axes.defaultAxisProps),
    axisLeft: (0, _axes.defaultAxisProps)
});
function te(e) {
    return (0, _react.useMemo)(function() {
        return (0, _d3Shape.line)().defined(function(e) {
            return null !== e.x && null !== e.y;
        }).x(function(e) {
            return e.x;
        }).y(function(e) {
            return e.y;
        }).curve((0, _core.curveFromProp)(e));
    }, [
        e
    ]);
}
function re(e) {
    var i = e.curve, n = e.yScale, t = e.areaBaselineValue;
    return (0, _react.useMemo)(function() {
        return (0, _d3Shape.area)().defined(function(e) {
            return null !== e.x && null !== e.y;
        }).x(function(e) {
            return e.x;
        }).y1(function(e) {
            return e.y;
        }).curve((0, _core.curveFromProp)(i)).y0(n(t));
    }, [
        i,
        n,
        t
    ]);
}
var ae = function(e) {
    var i = e.componentId, n = e.enableSlices, t = e.points, r = e.width, a = e.height;
    return (0, _react.useMemo)(function() {
        if ("x" === n) {
            var e = new Map;
            return t.forEach(function(o) {
                null !== o.data.x && null !== o.data.y && (e.has(o.x) ? e.get(o.x).push(o) : e.set(o.x, [
                    o
                ]));
            }), Array.from(e.entries()).sort(function(e, o) {
                return e[0] - o[0];
            }).map(function(e, o, n) {
                var t, l, s = e[0], u = e[1], d = n[o - 1], c = n[o + 1];
                return t = d ? s - (s - d[0]) / 2 : s, l = c ? s - t + (c[0] - s) / 2 : r - t, {
                    id: "slice:" + i + ":" + s,
                    x0: t,
                    x: s,
                    y0: 0,
                    y: 0,
                    width: l,
                    height: a,
                    points: u.reverse()
                };
            });
        }
        if ("y" === n) {
            var o = new Map;
            return t.forEach(function(e) {
                null !== e.data.x && null !== e.data.y && (o.has(e.y) ? o.get(e.y).push(e) : o.set(e.y, [
                    e
                ]));
            }), Array.from(o.entries()).sort(function(e, o) {
                return e[0] - o[0];
            }).map(function(e, o, i) {
                var n, t, l = e[0], s = e[1], u = i[o - 1], d = i[o + 1];
                return n = u ? l - (l - u[0]) / 2 : l, t = d ? l - n + (d[0] - l) / 2 : a - n, {
                    id: l,
                    x0: 0,
                    x: 0,
                    y0: n,
                    y: l,
                    width: r,
                    height: t,
                    points: s.reverse()
                };
            });
        }
        return [];
    }, [
        i,
        n,
        a,
        t,
        r
    ]);
}, le = "line", se = function(e) {
    var t = e.data, r = e.xScale, a = void 0 === r ? oe.xScale : r, l = e.xFormat, s = e.yScale, u = void 0 === s ? oe.yScale : s, c = e.yFormat, h = e.width, f = e.height, p = e.colors, v = void 0 === p ? oe.colors : p, b = e.curve, g = void 0 === b ? oe.curve : b, m = e.areaBaselineValue, y = void 0 === m ? oe.areaBaselineValue : m, x = e.pointColor, M = void 0 === x ? oe.pointColor : x, C = e.pointBorderColor, S = void 0 === C ? oe.pointBorderColor : C, B = e.enableSlices, w = void 0 === B ? ie.enableSlices : B, T = e.initialHiddenIds, k = void 0 === T ? ie.initialHiddenIds : T, W = (0, _react.useState)((0, _uniqueIdJsDefault.default)(le))[0], L = (0, _core.useValueFormatter)(l), D = (0, _core.useValueFormatter)(c), I = (0, _colors.useOrdinalColorScale)(v, "id"), F = (0, _theming.useTheme)(), E = (0, _colors.useInheritedColor)(M, F), G = (0, _colors.useInheritedColor)(S, F), H = (0, _react.useState)(null != k ? k : []), P = H[0], R = H[1], U = (0, _react.useMemo)(function() {
        return (0, _scales.computeXYScalesForSeries)(t.filter(function(e) {
            return -1 === P.indexOf(e.id);
        }), a, u, h, f);
    }, [
        t,
        P,
        a,
        u,
        h,
        f
    ]), X = U.xScale, j = U.yScale, q = U.series, J = (0, _react.useMemo)(function() {
        var e = t.map(function(e) {
            return {
                id: e.id,
                label: "" + e.id,
                color: I(e)
            };
        }), o = e.map(function(e) {
            return $({}, q.find(function(o) {
                return o.id === e.id;
            }), {
                color: e.color
            });
        }).filter(function(e) {
            return Boolean(e.id);
        });
        return {
            legendData: e.map(function(e) {
                return $({}, e, {
                    hidden: !o.find(function(o) {
                        return o.id === e.id;
                    })
                });
            }).reverse(),
            series: o
        };
    }, [
        t,
        q,
        I
    ]), K = J.legendData, N = J.series, Q = (0, _react.useCallback)(function(e) {
        R(function(o) {
            return o.indexOf(e) > -1 ? o.filter(function(o) {
                return o !== e;
            }) : [].concat(o, [
                e
            ]);
        });
    }, []), Z = function(e) {
        var i = e.series, n = e.getPointColor, t = e.getPointBorderColor, r = e.formatX, a = e.formatY;
        return (0, _react.useMemo)(function() {
            return i.reduce(function(e, o, i) {
                return [].concat(e, o.data.filter(function(e) {
                    return null !== e.position.x && null !== e.position.y;
                }).map(function(l, s) {
                    var u = {
                        id: o.id + "." + s,
                        indexInSeries: s,
                        absIndex: e.length + s,
                        seriesIndex: i,
                        seriesId: o.id,
                        seriesColor: o.color,
                        x: l.position.x,
                        y: l.position.y,
                        data: $({}, l.data, {
                            xFormatted: r(l.data.x),
                            yFormatted: a(l.data.y)
                        })
                    };
                    return u.color = n({
                        series: o,
                        point: u
                    }), u.borderColor = t(u), u;
                }));
            }, []);
        }, [
            i,
            n,
            t,
            r,
            a
        ]);
    }({
        series: N,
        getPointColor: E,
        getPointBorderColor: G,
        formatX: L,
        formatY: D
    }), _ = ae({
        componentId: W,
        enableSlices: w,
        points: Z,
        width: h,
        height: f
    });
    return {
        legendData: K,
        toggleSeries: Q,
        lineGenerator: te(g),
        areaGenerator: re({
            curve: g,
            yScale: j,
            areaBaselineValue: y
        }),
        getColor: I,
        series: N,
        xScale: X,
        yScale: j,
        slices: _,
        points: Z
    };
}, ue = function(e) {
    var o = e.areaBlendMode, i = e.areaOpacity, n = e.color, t = e.fill, r = e.path, a = (0, _core.useMotionConfig)(), l = a.animate, s = a.config, u = (0, _core.useAnimatedPath)(r), d = (0, _web.useSpring)({
        color: n,
        config: s,
        immediate: !l
    });
    return (0, _jsxRuntime.jsx)((0, _web.animated).path, {
        d: u,
        fill: t || d.color,
        fillOpacity: i,
        strokeWidth: 0,
        style: {
            mixBlendMode: o
        }
    });
}, de = (0, _react.memo)(function(e) {
    var o = e.areaGenerator, i = e.areaOpacity, n = e.areaBlendMode, t = e.series.slice(0).reverse();
    return (0, _jsxRuntime.jsx)("g", {
        children: t.map(function(e) {
            return (0, _jsxRuntime.jsx)(ue, $({
                path: o(e.data.map(function(e) {
                    return e.position;
                }))
            }, $({
                areaOpacity: i,
                areaBlendMode: n
            }, e)), "" + e.id);
        })
    });
}), ce = (0, _react.memo)(function(e) {
    var i = e.lineGenerator, n = e.points, t = e.color, r = e.thickness, a = (0, _react.useMemo)(function() {
        return i(n);
    }, [
        i,
        n
    ]), l = (0, _core.useAnimatedPath)(a);
    return (0, _jsxRuntime.jsx)((0, _web.animated).path, {
        d: l,
        fill: "none",
        strokeWidth: r,
        stroke: t
    });
}), he = (0, _react.memo)(function(e) {
    var o = e.series, i = e.lineGenerator, n = e.lineWidth;
    return (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
        children: o.slice(0).reverse().map(function(e) {
            var o = e.id, t = e.data, r = e.color;
            return (0, _jsxRuntime.jsx)(ce, {
                points: t.map(function(e) {
                    return e.position;
                }),
                lineGenerator: i,
                color: r,
                thickness: n
            }, o);
        })
    });
}), fe = (0, _react.memo)(function(e) {
    var o = e.slice, i = e.slices, r = e.axis, a = e.debug, l = e.tooltip, s = e.isCurrent, u = e.setCurrent, d = e.onMouseEnter, c = e.onMouseMove, h = e.onMouseLeave, f = e.onMouseDown, p = e.onMouseUp, v = e.onClick, b = e.onDoubleClick, g = e.onTouchStart, m = e.onTouchMove, y = e.onTouchEnd, x = (0, _tooltip.useTooltip)(), M = x.showTooltipFromEvent, C = x.hideTooltip, S = (0, _react.useCallback)(function(e) {
        M((0, _react.createElement)(l, {
            slice: o,
            axis: r
        }), e, "right"), u(o), null == d || d(o, e);
    }, [
        M,
        l,
        o,
        r,
        u,
        d
    ]), B = (0, _react.useCallback)(function(e) {
        M((0, _react.createElement)(l, {
            slice: o,
            axis: r
        }), e, "right"), null == c || c(o, e);
    }, [
        M,
        l,
        o,
        r,
        c
    ]), w = (0, _react.useCallback)(function(e) {
        C(), u(null), null == h || h(o, e);
    }, [
        C,
        u,
        h,
        o
    ]), T = (0, _react.useCallback)(function(e) {
        null == f || f(o, e);
    }, [
        o,
        f
    ]), k = (0, _react.useCallback)(function(e) {
        null == p || p(o, e);
    }, [
        o,
        p
    ]), W = (0, _react.useCallback)(function(e) {
        null == v || v(o, e);
    }, [
        o,
        v
    ]), L = (0, _react.useCallback)(function(e) {
        null == b || b(o, e);
    }, [
        o,
        b
    ]), D = (0, _react.useCallback)(function(e) {
        M((0, _react.createElement)(l, {
            slice: o,
            axis: r
        }), e, "right"), u(o), null == g || g(o, e);
    }, [
        r,
        g,
        u,
        M,
        o,
        l
    ]), I = (0, _react.useCallback)(function(e) {
        var n = e.touches[0], a = document.elementFromPoint(n.clientX, n.clientY), s = null == a ? void 0 : a.getAttribute("data-ref");
        if (s) {
            var d = i.find(function(e) {
                return e.id === s;
            });
            d && (M((0, _react.createElement)(l, {
                slice: d,
                axis: r
            }), e, "right"), u(d));
        }
        null == m || m(o, e);
    }, [
        r,
        m,
        u,
        M,
        o,
        i,
        l
    ]), F = (0, _react.useCallback)(function(e) {
        C(), u(null), null == y || y(o, e);
    }, [
        C,
        u,
        y,
        o
    ]);
    return (0, _jsxRuntime.jsx)("rect", {
        x: o.x0,
        y: o.y0,
        width: o.width,
        height: o.height,
        stroke: "red",
        strokeWidth: a ? 1 : 0,
        strokeOpacity: .75,
        fill: "red",
        fillOpacity: s && a ? .35 : 0,
        onMouseEnter: S,
        onMouseMove: B,
        onMouseLeave: w,
        onMouseDown: T,
        onMouseUp: k,
        onClick: W,
        onDoubleClick: L,
        onTouchStart: D,
        onTouchMove: I,
        onTouchEnd: F,
        "data-ref": o.id
    });
}), pe = (0, _react.memo)(function(e) {
    var o = e.slices, i = e.axis, n = e.debug, t = e.tooltip, r = e.current, a = e.setCurrent, l = e.onMouseEnter, s = e.onMouseMove, u = e.onMouseLeave, d = e.onMouseDown, c = e.onMouseUp, h = e.onClick, f = e.onDoubleClick, p = e.onTouchStart, v = e.onTouchMove, b = e.onTouchEnd;
    return (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
        children: o.map(function(e) {
            return (0, _jsxRuntime.jsx)(fe, {
                slice: e,
                slices: o,
                axis: i,
                debug: n,
                tooltip: t,
                setCurrent: a,
                isCurrent: null !== r && r.id === e.id,
                onMouseEnter: l,
                onMouseMove: s,
                onMouseLeave: u,
                onMouseDown: d,
                onMouseUp: c,
                onClick: h,
                onDoubleClick: f,
                onTouchStart: p,
                onTouchMove: v,
                onTouchEnd: b
            }, e.id);
        })
    });
}), ve = (0, _react.memo)(function(e) {
    var o = e.points, i = e.symbol, n = e.size, r = e.borderWidth, a = e.enableLabel, l = e.label, s = e.labelYOffset, u = e.isFocusable, d = e.setCurrentPoint, c = e.tooltip, h = e.margin, v = e.ariaLabel, b = e.ariaLabelledBy, g = e.ariaDescribedBy, m = e.ariaHidden, y = e.ariaDisabled, x = (0, _core.getLabelGenerator)(l), M = (0, _tooltip.useTooltip)(), C = M.showTooltipAt, S = M.hideTooltip, B = o.slice(0).sort(function(e, o) {
        return e.indexInSeries - o.indexInSeries;
    }).sort(function(e, o) {
        return o.seriesIndex - e.seriesIndex;
    }).map(function(e) {
        return {
            id: e.id,
            x: e.x,
            y: e.y,
            datum: e.data,
            fill: e.color,
            stroke: e.borderColor,
            label: a ? x(e) : null,
            ariaLabel: v ? v(e) : void 0,
            ariaLabelledBy: b ? b(e) : void 0,
            ariaDescribedBy: g ? g(e) : void 0,
            ariaHidden: m ? m(e) : void 0,
            ariaDisabled: y ? y(e) : void 0,
            onFocus: u ? function() {
                d(e), C((0, _react.createElement)(c, {
                    point: e
                }), [
                    h.left + e.x,
                    h.top + e.y
                ], "top");
            } : void 0,
            onBlur: u ? function() {
                d(null), S();
            } : void 0
        };
    });
    return (0, _jsxRuntime.jsx)("g", {
        children: B.map(function(e) {
            return (0, _jsxRuntime.jsx)((0, _core.DotsItem), {
                x: e.x,
                y: e.y,
                datum: e.datum,
                symbol: i,
                size: n,
                color: e.fill,
                borderWidth: r,
                borderColor: e.stroke,
                label: e.label,
                labelYOffset: s,
                ariaLabel: e.ariaLabel,
                ariaLabelledBy: e.ariaLabelledBy,
                ariaDescribedBy: e.ariaDescribedBy,
                ariaHidden: e.ariaHidden,
                ariaDisabled: e.ariaDisabled,
                isFocusable: u,
                onFocus: e.onFocus,
                onBlur: e.onBlur,
                testId: "line.point." + e.id
            }, e.id);
        })
    });
}), be = (0, _react.memo)(function(e) {
    var o = e.points, i = e.width, r = e.height, a = e.margin, l = e.setCurrent, s = e.onMouseEnter, u = e.onMouseMove, d = e.onMouseLeave, c = e.onMouseDown, h = e.onMouseUp, f = e.onClick, p = e.onDoubleClick, v = e.onTouchStart, b = e.onTouchMove, g = e.onTouchEnd, m = e.tooltip, y = e.debug, x = e.enableTouchCrosshair, M = (0, _tooltip.useTooltip)(), C = M.showTooltipAt, S = M.hideTooltip, B = (0, _react.useCallback)(function(e, o) {
        C((0, _react.createElement)(m, {
            point: e
        }), [
            e.x + a.left,
            e.y + a.top
        ], "top"), null == s || s(e, o);
    }, [
        C,
        m,
        s,
        a
    ]), w = (0, _react.useCallback)(function(e, o) {
        C((0, _react.createElement)(m, {
            point: e
        }), [
            e.x + a.left,
            e.y + a.top
        ], "top"), null == u || u(e, o);
    }, [
        C,
        m,
        a.left,
        a.top,
        u
    ]), T = (0, _react.useCallback)(function(e, o) {
        S(), null == d || d(e, o);
    }, [
        S,
        d
    ]), k = (0, _react.useCallback)(function(e, o) {
        null == c || c(e, o);
    }, [
        c
    ]), W = (0, _react.useCallback)(function(e, o) {
        null == h || h(e, o);
    }, [
        h
    ]), L = (0, _react.useCallback)(function(e, o) {
        null == f || f(e, o);
    }, [
        f
    ]), D = (0, _react.useCallback)(function(e, o) {
        null == p || p(e, o);
    }, [
        p
    ]), I = (0, _react.useCallback)(function(e, o) {
        C((0, _react.createElement)(m, {
            point: e
        }), [
            e.x + a.left,
            e.y + a.top
        ], "top"), null == v || v(e, o);
    }, [
        a.left,
        a.top,
        v,
        C,
        m
    ]), F = (0, _react.useCallback)(function(e, o) {
        C((0, _react.createElement)(m, {
            point: e
        }), [
            e.x + a.left,
            e.y + a.top
        ], "top"), null == b || b(e, o);
    }, [
        a.left,
        a.top,
        b,
        C,
        m
    ]), E = (0, _react.useCallback)(function(e, o) {
        S(), null == g || g(e, o);
    }, [
        g,
        S
    ]);
    return (0, _jsxRuntime.jsx)((0, _voronoi.Mesh), {
        nodes: o,
        width: i,
        height: r,
        setCurrent: l,
        onMouseEnter: B,
        onMouseMove: w,
        onMouseLeave: T,
        onMouseDown: k,
        onMouseUp: W,
        onClick: L,
        onDoubleClick: D,
        onTouchStart: I,
        onTouchMove: F,
        onTouchEnd: E,
        enableTouchCrosshair: x,
        debug: y
    });
}), ge = [
    "isInteractive",
    "animate",
    "motionConfig",
    "theme",
    "renderWrapper"
];
function me(e) {
    var o = e.data, n = e.xScale, t = void 0 === n ? ie.xScale : n, r = e.xFormat, l = e.yScale, s = void 0 === l ? ie.yScale : l, u = e.yFormat, d = e.curve, c = void 0 === d ? ie.curve : d, h = e.margin, f = e.width, p = e.height, v = e.colors, x = void 0 === v ? ie.colors : v, M = e.lineWidth, C = void 0 === M ? ie.lineWidth : M, S = e.layers, B = void 0 === S ? ie.layers : S, k = e.enableArea, W = void 0 === k ? ie.enableArea : k, D = e.areaBaselineValue, I = void 0 === D ? ie.areaBaselineValue : D, F = e.areaOpacity, E = void 0 === F ? ie.areaOpacity : F, G = e.areaBlendMode, P = void 0 === G ? ie.areaBlendMode : G, R = e.enablePoints, O = void 0 === R ? ie.enablePoints : R, z = e.pointSymbol, A = e.pointSize, V = void 0 === A ? ie.pointSize : A, Y = e.pointColor, X = void 0 === Y ? ie.pointColor : Y, j = e.pointBorderWidth, q = void 0 === j ? ie.pointBorderWidth : j, J = e.pointBorderColor, K = void 0 === J ? ie.pointBorderColor : J, N = e.enablePointLabel, Q = void 0 === N ? ie.enablePointLabel : N, Z = e.pointLabel, _ = void 0 === Z ? ie.pointLabel : Z, ee = e.pointLabelYOffset, oe = e.enableGridX, ne = void 0 === oe ? ie.enableGridX : oe, te = e.gridXValues, re = e.enableGridY, ae = void 0 === re ? ie.enableGridY : re, le = e.gridYValues, ue = e.axisTop, ce = e.axisRight, fe = e.axisBottom, ge = void 0 === fe ? ie.axisBottom : fe, me = e.axisLeft, ye = void 0 === me ? ie.axisLeft : me, xe = e.defs, Me = void 0 === xe ? ie.defs : xe, Ce = e.fill, Se = void 0 === Ce ? ie.fill : Ce, Be = e.markers, we = e.legends, Te = void 0 === we ? ie.legends : we, ke = e.isInteractive, We = void 0 === ke ? ie.isInteractive : ke, Le = e.useMesh, De = void 0 === Le ? ie.useMesh : Le, Ie = e.debugMesh, Fe = void 0 === Ie ? ie.debugMesh : Ie, Ee = e.onMouseEnter, Ge = e.onMouseMove, He = e.onMouseLeave, Pe = e.onMouseDown, Re = e.onMouseUp, Oe = e.onClick, ze = e.onDoubleClick, Ae = e.onTouchStart, Ve = e.onTouchMove, Ye = e.onTouchEnd, Ue = e.tooltip, Xe = void 0 === Ue ? ie.tooltip : Ue, je = e.enableSlices, qe = void 0 === je ? ie.enableSlices : je, Je = e.debugSlices, Ke = void 0 === Je ? ie.debugSlices : Je, Ne = e.sliceTooltip, Qe = void 0 === Ne ? ie.sliceTooltip : Ne, Ze = e.enableCrosshair, $e = void 0 === Ze ? ie.enableCrosshair : Ze, _e = e.crosshairType, eo = void 0 === _e ? ie.crosshairType : _e, oo = e.enableTouchCrosshair, io = void 0 === oo ? ie.enableTouchCrosshair : oo, no = e.role, to = void 0 === no ? ie.role : no, ro = e.ariaLabel, ao = e.ariaLabelledBy, lo = e.ariaDescribedBy, so = e.isFocusable, uo = void 0 === so ? ie.isFocusable : so, co = e.pointAriaLabel, ho = e.pointAriaLabelledBy, fo = e.pointAriaDescribedBy, po = e.pointAriaHidden, vo = e.pointAriaDisabled, bo = e.initialHiddenIds, go = void 0 === bo ? ie.initialHiddenIds : bo, mo = e.forwardedRef, yo = (0, _core.useDimensions)(f, p, h), xo = yo.margin, Mo = yo.innerWidth, Co = yo.innerHeight, So = yo.outerWidth, Bo = yo.outerHeight, wo = se({
        data: o,
        xScale: t,
        xFormat: r,
        yScale: s,
        yFormat: u,
        width: Mo,
        height: Co,
        colors: x,
        curve: c,
        areaBaselineValue: I,
        pointColor: X,
        pointBorderColor: K,
        enableSlices: qe,
        initialHiddenIds: go
    }), To = wo.legendData, ko = wo.toggleSeries, Wo = wo.lineGenerator, Lo = wo.areaGenerator, Do = wo.series, Io = wo.xScale, Fo = wo.yScale, Eo = wo.slices, Go = wo.points, Ho = (0, _react.useState)(null), Po = Ho[0], Ro = Ho[1], Oo = (0, _react.useState)(null), zo = Oo[0], Ao = Oo[1], Vo = {
        grid: null,
        markers: null,
        axes: null,
        areas: null,
        crosshair: null,
        lines: null,
        points: null,
        slices: null,
        mesh: null,
        legends: null
    };
    B.includes("grid") && (ne || ae) && (Vo.grid = (0, _jsxRuntime.jsx)((0, _axes.Grid), {
        width: Mo,
        height: Co,
        xScale: ne ? Io : null,
        yScale: ae ? Fo : null,
        xValues: te,
        yValues: le
    }, "grid")), B.includes("markers") && Array.isArray(Be) && Be.length > 0 && (Vo.markers = (0, _jsxRuntime.jsx)((0, _core.CartesianMarkers), {
        markers: Be,
        width: Mo,
        height: Co,
        xScale: Io,
        yScale: Fo
    }, "markers")), B.includes("axes") && (Vo.axes = (0, _jsxRuntime.jsx)((0, _axes.Axes), {
        xScale: Io,
        yScale: Fo,
        width: Mo,
        height: Co,
        top: ue,
        right: ce,
        bottom: ge,
        left: ye
    }, "axes")), B.includes("lines") && (Vo.lines = (0, _jsxRuntime.jsx)(he, {
        series: Do,
        lineGenerator: Wo,
        lineWidth: C
    }, "lines")), B.includes("legends") && Te.length > 0 && (Vo.legends = (0, _jsxRuntime.jsx)((0, _react.Fragment), {
        children: Te.map(function(e, o) {
            return (0, _jsxRuntime.jsx)((0, _legends.BoxLegendSvg), $({}, e, {
                containerWidth: Mo,
                containerHeight: Co,
                data: e.data || To,
                toggleSerie: e.toggleSerie ? ko : void 0
            }), o);
        })
    }, "legends"));
    var Yo = (0, _core.bindDefs)(Me, Do, Se);
    W && (Vo.areas = (0, _jsxRuntime.jsx)(de, {
        areaGenerator: Lo,
        areaOpacity: E,
        areaBlendMode: P,
        series: Do
    }, "areas")), We && !1 !== qe && (Vo.slices = (0, _jsxRuntime.jsx)(pe, {
        slices: Eo,
        axis: qe,
        debug: Ke,
        tooltip: Qe,
        current: zo,
        setCurrent: Ao,
        onMouseEnter: Ee,
        onMouseMove: Ge,
        onMouseLeave: He,
        onMouseDown: Pe,
        onMouseUp: Re,
        onClick: Oe,
        onDoubleClick: ze,
        onTouchStart: Ae,
        onTouchMove: Ve,
        onTouchEnd: Ye
    }, "slices")), O && (Vo.points = (0, _jsxRuntime.jsx)(ve, {
        points: Go,
        symbol: z,
        size: V,
        borderWidth: q,
        enableLabel: Q,
        label: _,
        labelYOffset: ee,
        isFocusable: uo,
        setCurrentPoint: Ro,
        tooltip: Xe,
        margin: xo,
        ariaLabel: co,
        ariaLabelledBy: ho,
        ariaDescribedBy: fo,
        ariaHidden: po,
        ariaDisabled: vo
    }, "points")), We && $e && (null !== Po && (Vo.crosshair = (0, _jsxRuntime.jsx)((0, _tooltip.Crosshair), {
        width: Mo,
        height: Co,
        x: Po.x,
        y: Po.y,
        type: eo
    }, "crosshair")), null !== zo && qe && (Vo.crosshair = (0, _jsxRuntime.jsx)((0, _tooltip.Crosshair), {
        width: Mo,
        height: Co,
        x: zo.x,
        y: zo.y,
        type: qe
    }, "crosshair"))), We && De && !1 === qe && (Vo.mesh = (0, _jsxRuntime.jsx)(be, {
        points: Go,
        width: Mo,
        height: Co,
        margin: xo,
        setCurrent: Ro,
        onMouseEnter: Ee,
        onMouseMove: Ge,
        onMouseLeave: He,
        onMouseDown: Pe,
        onMouseUp: Re,
        onClick: Oe,
        onDoubleClick: ze,
        onTouchStart: Ae,
        onTouchMove: Ve,
        onTouchEnd: Ye,
        tooltip: Xe,
        enableTouchCrosshair: io,
        debug: Fe
    }, "mesh"));
    var Uo = $({}, e, {
        innerWidth: Mo,
        innerHeight: Co,
        series: Do,
        slices: Eo,
        points: Go,
        xScale: Io,
        yScale: Fo,
        lineGenerator: Wo,
        areaGenerator: Lo,
        currentPoint: Po,
        setCurrentPoint: Ro,
        currentSlice: zo,
        setCurrentSlice: Ao
    });
    return (0, _jsxRuntime.jsx)((0, _core.SvgWrapper), {
        defs: Yo,
        width: So,
        height: Bo,
        margin: xo,
        role: to,
        ariaLabel: ro,
        ariaLabelledBy: ao,
        ariaDescribedBy: lo,
        isFocusable: uo,
        ref: mo,
        children: B.map(function(e, o) {
            return "function" == typeof e ? (0, _jsxRuntime.jsx)((0, _react.Fragment), {
                children: e(Uo)
            }, o) : Vo[e];
        })
    });
}
var ye = (0, _react.forwardRef)(function(e, o) {
    var i = e.isInteractive, n = void 0 === i ? ie.isInteractive : i, t = e.animate, r = void 0 === t ? ie.animate : t, a = e.motionConfig, l = void 0 === a ? ie.motionConfig : a, s = e.theme, u = e.renderWrapper, d = _(e, ge);
    return (0, _jsxRuntime.jsx)((0, _core.Container), {
        animate: r,
        isInteractive: n,
        motionConfig: l,
        renderWrapper: u,
        theme: s,
        children: (0, _jsxRuntime.jsx)(me, $({
            isInteractive: n
        }, d, {
            forwardedRef: o
        }))
    });
}), xe = [
    "defaultWidth",
    "defaultHeight",
    "onResize",
    "debounceResize"
], Me = (0, _react.forwardRef)(function(e, o) {
    var i = e.defaultWidth, n = e.defaultHeight, t = e.onResize, r = e.debounceResize, a = _(e, xe);
    return (0, _jsxRuntime.jsx)((0, _core.ResponsiveWrapper), {
        defaultWidth: i,
        defaultHeight: n,
        onResize: t,
        debounceResize: r,
        children: function(e) {
            var i = e.width, n = e.height;
            return (0, _jsxRuntime.jsx)(ye, $({
                width: i,
                height: n
            }, a, {
                ref: o
            }));
        }
    });
}), Ce = [
    "isInteractive",
    "renderWrapper",
    "theme"
], Se = function(e) {
    var r = e.width, a = e.height, u = e.margin, d = e.pixelRatio, c = void 0 === d ? ne.pixelRatio : d, h = e.data, f = e.xScale, p = void 0 === f ? ne.xScale : f, v = e.xFormat, g = e.yScale, m = void 0 === g ? ne.yScale : g, y = e.yFormat, x = e.curve, B = void 0 === x ? ne.curve : x, w = e.layers, T = void 0 === w ? ne.layers : w, L = e.colors, I = void 0 === L ? ne.colors : L, F = e.lineWidth, E = void 0 === F ? ne.lineWidth : F, H = e.enableArea, P = void 0 === H ? ne.enableArea : H, R = e.areaBaselineValue, O = void 0 === R ? ne.areaBaselineValue : R, A = e.areaOpacity, V = void 0 === A ? ne.areaOpacity : A, Y = e.enablePoints, X = void 0 === Y ? ne.enablePoints : Y, j = e.pointSize, q = void 0 === j ? ne.pointSize : j, J = e.pointColor, K = void 0 === J ? ne.pointColor : J, _ = e.pointBorderWidth, ee = void 0 === _ ? ne.pointBorderWidth : _, oe = e.pointBorderColor, ie = void 0 === oe ? ne.pointBorderColor : oe, te = e.enableGridX, re = void 0 === te ? ne.enableGridX : te, ae = e.gridXValues, le = e.enableGridY, ue = void 0 === le ? ne.enableGridY : le, de = e.gridYValues, ce = e.axisTop, he = e.axisRight, fe = e.axisBottom, pe = void 0 === fe ? ne.axisBottom : fe, ve = e.axisLeft, be = void 0 === ve ? ne.axisLeft : ve, ge = e.legends, me = void 0 === ge ? ne.legends : ge, ye = e.isInteractive, xe = void 0 === ye ? ne.isInteractive : ye, Me = e.debugMesh, Ce = void 0 === Me ? ne.debugMesh : Me, Se = e.onMouseLeave, Be = e.onMouseDown, we = e.onMouseUp, Te = e.onClick, ke = e.onDoubleClick, We = e.tooltip, Le = void 0 === We ? ne.tooltip : We, De = e.role, Ie = e.forwardedRef, Fe = (0, _react.useRef)(null), Ee = (0, _core.useDimensions)(r, a, u), Ge = Ee.margin, He = Ee.innerWidth, Pe = Ee.innerHeight, Re = Ee.outerWidth, Oe = Ee.outerHeight, ze = (0, _theming.useTheme)(), Ae = (0, _react.useState)(null), Ve = Ae[0], Ye = Ae[1], Ue = se({
        data: h,
        xScale: p,
        xFormat: v,
        yScale: m,
        yFormat: y,
        width: He,
        height: Pe,
        colors: I,
        curve: B,
        areaBaselineValue: O,
        pointColor: K,
        pointBorderColor: ie
    }), Xe = Ue.lineGenerator, je = Ue.areaGenerator, qe = Ue.series, Je = Ue.xScale, Ke = Ue.yScale, Ne = Ue.points, Qe = (0, _react.useMemo)(function() {
        return {
            innerWidth: He,
            innerHeight: Pe,
            series: qe,
            points: Ne,
            xScale: Je,
            yScale: Ke,
            lineWidth: E,
            lineGenerator: Xe,
            areaGenerator: je,
            currentPoint: Ve,
            setCurrentPoint: Ye
        };
    }, [
        He,
        Pe,
        qe,
        Ne,
        Je,
        Ke,
        E,
        Xe,
        je,
        Ve,
        Ye
    ]), Ze = (0, _voronoi.useVoronoiMesh)({
        points: Ne,
        width: He,
        height: Pe,
        debug: Ce
    }), $e = Ze.delaunay, _e = Ze.voronoi;
    (0, _react.useEffect)(function() {
        if (null !== Fe.current) {
            Fe.current.width = Re * c, Fe.current.height = Oe * c;
            var e = Fe.current.getContext("2d");
            e.scale(c, c), e.fillStyle = ze.background, e.fillRect(0, 0, Re, Oe), e.translate(Ge.left, Ge.top), T.forEach(function(o) {
                var i;
                "function" == typeof o && o(e, Qe);
                var n = null != (i = ze.grid.line.strokeWidth) ? i : 0;
                if ("grid" === o && "string" != typeof n && n > 0 && (e.lineWidth = n, e.strokeStyle = ze.grid.line.stroke, re && (0, _axes.renderGridLinesToCanvas)(e, {
                    width: He,
                    height: Pe,
                    scale: Je,
                    axis: "x",
                    values: ae
                }), ue && (0, _axes.renderGridLinesToCanvas)(e, {
                    width: He,
                    height: Pe,
                    scale: Ke,
                    axis: "y",
                    values: de
                })), "axes" === o && (0, _axes.renderAxesToCanvas)(e, {
                    xScale: Je,
                    yScale: Ke,
                    width: He,
                    height: Pe,
                    top: ce,
                    right: he,
                    bottom: pe,
                    left: be,
                    theme: ze
                }), "areas" === o && !0 === P) {
                    e.save(), e.globalAlpha = V, je.context(e);
                    for(var t = qe.length - 1; t >= 0; t--)e.fillStyle = qe[t].color, e.beginPath(), je(qe[t].data.map(function(e) {
                        return e.position;
                    })), e.fill();
                    e.restore();
                }
                if ("lines" === o && (Xe.context(e), qe.forEach(function(o) {
                    e.strokeStyle = o.color, e.lineWidth = E, e.beginPath(), Xe(o.data.map(function(e) {
                        return e.position;
                    })), e.stroke();
                })), "points" === o && !0 === X && q > 0 && Ne.forEach(function(o) {
                    e.fillStyle = o.color, e.beginPath(), e.arc(o.x, o.y, q / 2, 0, 2 * Math.PI), e.fill(), ee > 0 && (e.strokeStyle = o.borderColor, e.lineWidth = ee, e.stroke());
                }), "mesh" === o && !0 === Ce && void 0 !== _e && ((0, _voronoi.renderVoronoiToCanvas)(e, _e), Ve && (0, _voronoi.renderVoronoiCellToCanvas)(e, _e, Ve.absIndex)), "legends" === o) {
                    var r = qe.map(function(e) {
                        return {
                            id: e.id,
                            label: e.id,
                            color: e.color
                        };
                    }).reverse();
                    me.forEach(function(o) {
                        (0, _legends.renderLegendToCanvas)(e, $({}, o, {
                            data: o.data || r,
                            containerWidth: He,
                            containerHeight: Pe,
                            theme: ze
                        }));
                    });
                }
            });
        }
    }, [
        Fe,
        He,
        Re,
        Pe,
        Oe,
        Ge.left,
        Ge.top,
        c,
        T,
        ze,
        Xe,
        qe,
        Je,
        Ke,
        re,
        ae,
        ue,
        de,
        ce,
        he,
        pe,
        be,
        me,
        Ne,
        X,
        q,
        ee,
        Ve,
        Qe,
        Ce,
        P,
        je,
        V,
        E,
        _e
    ]);
    var eo = (0, _react.useCallback)(function(e) {
        if (!Fe.current) return null;
        var o = (0, _core.getRelativeCursor)(Fe.current, e), i = o[0], n = o[1];
        if (!(0, _core.isCursorInRect)(Ge.left, Ge.top, He, Pe, i, n)) return null;
        var t = $e.find(i - Ge.left, n - Ge.top);
        return Ne[t];
    }, [
        Fe,
        Ge,
        He,
        Pe,
        $e,
        Ne
    ]), oo = (0, _tooltip.useTooltip)(), io = oo.showTooltipFromEvent, no = oo.hideTooltip, to = (0, _react.useCallback)(function(e) {
        var o = eo(e);
        Ye(o), o ? io((0, _react.createElement)(Le, {
            point: o
        }), e) : no();
    }, [
        eo,
        Ye,
        io,
        no,
        Le
    ]), ro = (0, _react.useCallback)(function(e) {
        no(), Ye(null), Ve && (null == Se || Se(Ve, e));
    }, [
        no,
        Ye,
        Se,
        Ve
    ]), ao = (0, _react.useCallback)(function(e) {
        if (Be) {
            var o = eo(e);
            o && Be(o, e);
        }
    }, [
        eo,
        Be
    ]), lo = (0, _react.useCallback)(function(e) {
        if (we) {
            var o = eo(e);
            o && we(o, e);
        }
    }, [
        eo,
        we
    ]), so = (0, _react.useCallback)(function(e) {
        if (Te) {
            var o = eo(e);
            o && Te(o, e);
        }
    }, [
        eo,
        Te
    ]), uo = (0, _react.useCallback)(function(e) {
        if (ke) {
            var o = eo(e);
            o && ke(o, e);
        }
    }, [
        eo,
        ke
    ]);
    return (0, _jsxRuntime.jsx)("canvas", {
        ref: (0, _core.mergeRefs)(Fe, Ie),
        width: Re * c,
        height: Oe * c,
        style: {
            width: Re,
            height: Oe,
            cursor: xe ? "auto" : "normal"
        },
        onMouseEnter: xe ? to : void 0,
        onMouseMove: xe ? to : void 0,
        onMouseLeave: xe ? ro : void 0,
        onMouseDown: xe ? ao : void 0,
        onMouseUp: xe ? lo : void 0,
        onClick: xe ? so : void 0,
        onDoubleClick: xe ? uo : void 0,
        role: De
    });
}, Be = (0, _react.forwardRef)(function(e, o) {
    var i = e.isInteractive, n = e.renderWrapper, t = e.theme, r = _(e, Ce);
    return (0, _jsxRuntime.jsx)((0, _core.Container), {
        isInteractive: i,
        renderWrapper: n,
        theme: t,
        animate: !1,
        children: (0, _jsxRuntime.jsx)(Se, $({}, r, {
            forwardedRef: o
        }))
    });
}), we = [
    "defaultWidth",
    "defaultHeight",
    "onResize",
    "debounceResize"
], Te = (0, _react.forwardRef)(function(e, o) {
    var i = e.defaultWidth;
    e.defaultHeight;
    var n = e.onResize, t = e.debounceResize, r = _(e, we);
    return (0, _jsxRuntime.jsx)((0, _core.ResponsiveWrapper), {
        defaultWidth: i,
        defaultHeight: i,
        onResize: n,
        debounceResize: t,
        children: function(e) {
            var i = e.width, n = e.height;
            return (0, _jsxRuntime.jsx)(Be, $({
                width: i,
                height: n
            }, r, {
                ref: o
            }));
        }
    });
});
function ke(e) {
    return void 0 !== e.seriesId;
}
function We(e) {
    return void 0 !== e.points;
}

},{"react":"6uln9","@nivo/core":"3e9EB","@nivo/axes":"5TAzq","@nivo/legends":"kxw7P","@nivo/tooltip":"1CuTy","d3-shape":"ba4g6","lodash/uniqueId.js":"2tTWY","@nivo/theming":"kiBiP","@nivo/colors":"kpdUa","@nivo/scales":"8SXu8","react/jsx-runtime":"gaGEj","@react-spring/web":"39JSM","@nivo/voronoi":"57p2d","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3e9EB":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BOX_ANCHORS", ()=>jn);
parcelHelpers.export(exports, "CartesianMarkers", ()=>Pt);
parcelHelpers.export(exports, "CartesianMarkersItem", ()=>Bt);
parcelHelpers.export(exports, "ChartContext", ()=>At);
parcelHelpers.export(exports, "Container", ()=>Fr);
parcelHelpers.export(exports, "Defs", ()=>Mt);
parcelHelpers.export(exports, "DotsItem", ()=>Ct);
parcelHelpers.export(exports, "LegacyContainer", ()=>Xr);
parcelHelpers.export(exports, "LinearGradient", ()=>tt);
parcelHelpers.export(exports, "MotionConfigProvider", ()=>qr);
parcelHelpers.export(exports, "PatternDots", ()=>at);
parcelHelpers.export(exports, "PatternDotsDefaultProps", ()=>it);
parcelHelpers.export(exports, "PatternLines", ()=>vt);
parcelHelpers.export(exports, "PatternLinesDefaultProps", ()=>mt);
parcelHelpers.export(exports, "PatternSquares", ()=>wt);
parcelHelpers.export(exports, "PatternSquaresDefaultProps", ()=>_t);
parcelHelpers.export(exports, "ResponsiveWrapper", ()=>$r);
parcelHelpers.export(exports, "SvgWrapper", ()=>Rt);
parcelHelpers.export(exports, "TWO_PI", ()=>dt);
parcelHelpers.export(exports, "alignBox", ()=>vn);
parcelHelpers.export(exports, "areaCurvePropKeys", ()=>qt);
parcelHelpers.export(exports, "bindDefs", ()=>Mn);
parcelHelpers.export(exports, "blendModes", ()=>Nt);
parcelHelpers.export(exports, "boxAlignments", ()=>mn);
parcelHelpers.export(exports, "clampArc", ()=>pt);
parcelHelpers.export(exports, "closedCurvePropKeys", ()=>Yt);
parcelHelpers.export(exports, "colorInterpolatorIds", ()=>tn);
parcelHelpers.export(exports, "colorInterpolators", ()=>rn);
parcelHelpers.export(exports, "colorSchemeIds", ()=>en);
parcelHelpers.export(exports, "curveFromProp", ()=>Et);
parcelHelpers.export(exports, "curvePropKeys", ()=>St);
parcelHelpers.export(exports, "curvePropMapping", ()=>Lt);
parcelHelpers.export(exports, "defaultAnimate", ()=>an);
parcelHelpers.export(exports, "defaultCategoricalColors", ()=>ln);
parcelHelpers.export(exports, "defaultColorRange", ()=>dn);
parcelHelpers.export(exports, "defaultMargin", ()=>un);
parcelHelpers.export(exports, "degreesToRadians", ()=>ut);
parcelHelpers.export(exports, "getAngle", ()=>_n);
parcelHelpers.export(exports, "getColorScale", ()=>on);
parcelHelpers.export(exports, "getDistance", ()=>yn);
parcelHelpers.export(exports, "getLabelGenerator", ()=>pn);
parcelHelpers.export(exports, "getPolarLabelProps", ()=>bt);
parcelHelpers.export(exports, "getPropertyAccessor", ()=>gn);
parcelHelpers.export(exports, "getRelativeCursor", ()=>kn);
parcelHelpers.export(exports, "getValueFormatter", ()=>fn);
parcelHelpers.export(exports, "gradientTypes", ()=>ot);
parcelHelpers.export(exports, "guessQuantizeColorScale", ()=>Vt);
parcelHelpers.export(exports, "isCursorInRect", ()=>wn);
parcelHelpers.export(exports, "isMatchingDef", ()=>zn);
parcelHelpers.export(exports, "lineCurvePropKeys", ()=>Dt);
parcelHelpers.export(exports, "linearGradientDef", ()=>nt);
parcelHelpers.export(exports, "mergeRefs", ()=>Rn);
parcelHelpers.export(exports, "midAngle", ()=>st);
parcelHelpers.export(exports, "motionConfigContext", ()=>Sr);
parcelHelpers.export(exports, "motionDefaultProps", ()=>Yr);
parcelHelpers.export(exports, "nivoCategoricalColors", ()=>nn);
parcelHelpers.export(exports, "noop", ()=>Tr);
parcelHelpers.export(exports, "normalizeAngleDegrees", ()=>ht);
parcelHelpers.export(exports, "patternDotsDef", ()=>lt);
parcelHelpers.export(exports, "patternLinesDef", ()=>yt);
parcelHelpers.export(exports, "patternSquaresDef", ()=>kt);
parcelHelpers.export(exports, "patternTypes", ()=>xt);
parcelHelpers.export(exports, "positionFromAngle", ()=>ft);
parcelHelpers.export(exports, "quantizeColorScales", ()=>Jt);
parcelHelpers.export(exports, "quantizeColorScalesKeys", ()=>Qt);
parcelHelpers.export(exports, "radiansToDegrees", ()=>ct);
parcelHelpers.export(exports, "stackOffsetFromProp", ()=>Kt);
parcelHelpers.export(exports, "stackOffsetPropKeys", ()=>Xt);
parcelHelpers.export(exports, "stackOffsetPropMapping", ()=>Ht);
parcelHelpers.export(exports, "stackOrderFromProp", ()=>Tt);
parcelHelpers.export(exports, "stackOrderPropKeys", ()=>Ft);
parcelHelpers.export(exports, "stackOrderPropMapping", ()=>Ut);
parcelHelpers.export(exports, "textPropsByEngine", ()=>gt);
parcelHelpers.export(exports, "useAnimatedPath", ()=>It);
parcelHelpers.export(exports, "useCurveInterpolation", ()=>$t);
parcelHelpers.export(exports, "useDimensions", ()=>cn);
parcelHelpers.export(exports, "useMeasure", ()=>sn);
parcelHelpers.export(exports, "useMotionConfig", ()=>Dr);
parcelHelpers.export(exports, "usePropertyAccessor", ()=>bn);
parcelHelpers.export(exports, "useValueFormatter", ()=>hn);
parcelHelpers.export(exports, "withContainer", ()=>Gt);
var _react = require("react");
var _tooltip = require("@nivo/tooltip");
var _theming = require("@nivo/theming");
var _isStringJs = require("lodash/isString.js");
var _isStringJsDefault = parcelHelpers.interopDefault(_isStringJs);
var _web = require("@react-spring/web");
var _jsxRuntime = require("react/jsx-runtime");
var _reactVirtualizedAutoSizer = require("react-virtualized-auto-sizer");
var _reactVirtualizedAutoSizerDefault = parcelHelpers.interopDefault(_reactVirtualizedAutoSizer);
var _useDebounce = require("use-debounce");
var _d3Interpolate = require("d3-interpolate");
var _withoutJs = require("lodash/without.js");
var _withoutJsDefault = parcelHelpers.interopDefault(_withoutJs);
var _d3Shape = require("d3-shape");
var _d3Scale = require("d3-scale");
var _d3ScaleChromatic = require("d3-scale-chromatic");
var _lastJs = require("lodash/last.js");
var _lastJsDefault = parcelHelpers.interopDefault(_lastJs);
var _isArrayJs = require("lodash/isArray.js");
var _isArrayJsDefault = parcelHelpers.interopDefault(_isArrayJs);
var _isFunctionJs = require("lodash/isFunction.js");
var _isFunctionJsDefault = parcelHelpers.interopDefault(_isFunctionJs);
var _d3Format = require("d3-format");
var _d3TimeFormat = require("d3-time-format");
var _getJs = require("lodash/get.js");
var _getJsDefault = parcelHelpers.interopDefault(_getJs);
var _isPlainObjectJs = require("lodash/isPlainObject.js");
var _isPlainObjectJsDefault = parcelHelpers.interopDefault(_isPlainObjectJs);
var _pickJs = require("lodash/pick.js");
var _pickJsDefault = parcelHelpers.interopDefault(_pickJs);
var _isEqualJs = require("lodash/isEqual.js");
var _isEqualJsDefault = parcelHelpers.interopDefault(_isEqualJs);
var _setJs = require("lodash/set.js");
var _setJsDefault = parcelHelpers.interopDefault(_setJs);
var Sr = (0, _react.createContext)(), Yr = {
    animate: !0,
    config: "default"
}, qr = function(e) {
    var t = e.children, n = e.animate, o = void 0 === n || n, i = e.config, a = void 0 === i ? "default" : i, l = (0, _react.useMemo)(function() {
        var e = (0, _isStringJsDefault.default)(a) ? (0, _web.config)[a] : a;
        return {
            animate: o,
            config: e
        };
    }, [
        o,
        a
    ]);
    return (0, _jsxRuntime.jsx)(Sr.Provider, {
        value: l,
        children: t
    });
}, Dr = function() {
    return (0, _react.useContext)(Sr);
}, Er = function(e) {
    var r = e.children, t = e.condition, o = e.wrapper;
    return t ? (0, _react.cloneElement)(o, {}, r) : r;
}, Ur = {
    position: "relative"
}, Fr = function(e) {
    var r = e.children, t = e.theme, n = e.renderWrapper, i = void 0 === n || n, a = e.isInteractive, l = void 0 === a || a, d = e.animate, u = e.motionConfig, c = (0, _react.useRef)(null);
    return (0, _jsxRuntime.jsx)((0, _theming.ThemeProvider), {
        theme: t,
        children: (0, _jsxRuntime.jsx)(qr, {
            animate: d,
            config: u,
            children: (0, _jsxRuntime.jsx)((0, _tooltip.TooltipProvider), {
                container: c,
                children: (0, _jsxRuntime.jsxs)(Er, {
                    condition: i,
                    wrapper: (0, _jsxRuntime.jsx)("div", {
                        style: Ur,
                        ref: c
                    }),
                    children: [
                        r,
                        l && (0, _jsxRuntime.jsx)((0, _tooltip.Tooltip), {})
                    ]
                })
            })
        })
    });
}, Tr = function() {}, Hr = {
    position: "relative"
}, Xr = function(e) {
    var t = e.children, n = e.theme, a = e.isInteractive, l = void 0 === a || a, d = e.renderWrapper, u = void 0 === d || d, c = e.animate, s = e.motionConfig, f = (0, _react.useRef)(null), v = (0, _tooltip.useTooltipHandlers)(f), y = v.actions, _ = v.state, w = (0, _react.useCallback)(function(e, r) {
        return y.showTooltipFromEvent(e, r);
    }, [
        y
    ]), k = (0, _react.useMemo)(function() {
        return {
            showTooltip: l ? w : Tr,
            hideTooltip: l ? y.hideTooltip : Tr
        };
    }, [
        y,
        l,
        w
    ]);
    return (0, _jsxRuntime.jsx)((0, _theming.ThemeProvider), {
        theme: n,
        children: (0, _jsxRuntime.jsx)(qr, {
            animate: c,
            config: s,
            children: (0, _jsxRuntime.jsx)((0, _tooltip.TooltipActionsContext).Provider, {
                value: y,
                children: (0, _jsxRuntime.jsx)((0, _tooltip.TooltipStateContext).Provider, {
                    value: _,
                    children: (0, _jsxRuntime.jsxs)(Er, {
                        condition: u,
                        wrapper: (0, _jsxRuntime.jsx)("div", {
                            style: Hr,
                            ref: f
                        }),
                        children: [
                            t(k),
                            l && (0, _jsxRuntime.jsx)((0, _tooltip.Tooltip), {})
                        ]
                    })
                })
            })
        })
    });
}, Kr = function(e, r) {
    return e.width === r.width && e.height === r.height;
}, Nr = function(e) {
    var r = e.children, t = e.width, n = e.height, o = e.onResize, i = e.debounceResize, l = (0, _useDebounce.useDebounce)({
        width: t,
        height: n
    }, i, {
        equalityFn: Kr
    })[0];
    return (0, _react.useEffect)(function() {
        null == o || o(l);
    }, [
        l,
        o
    ]), (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
        children: r(l)
    });
}, $r = function(e) {
    var r = e.children, t = e.defaultWidth, n = e.defaultHeight, o = e.onResize, i = e.debounceResize, a = void 0 === i ? 0 : i;
    return (0, _jsxRuntime.jsx)((0, _reactVirtualizedAutoSizerDefault.default), {
        defaultWidth: t,
        defaultHeight: n,
        children: function(e) {
            var t = e.width, n = e.height;
            return (0, _jsxRuntime.jsx)(Nr, {
                width: t,
                height: n,
                onResize: o,
                debounceResize: a,
                children: r
            });
        }
    });
};
function Jr(e, r) {
    (null == r || r > e.length) && (r = e.length);
    for(var t = 0, n = Array(r); t < r; t++)n[t] = e[t];
    return n;
}
function Qr(e, r) {
    var t = "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
    if (t) return (t = t.call(e)).next.bind(t);
    if (Array.isArray(e) || (t = function(e, r) {
        if (e) {
            if ("string" == typeof e) return Jr(e, r);
            var t = ({}).toString.call(e).slice(8, -1);
            return "Object" === t && e.constructor && (t = e.constructor.name), "Map" === t || "Set" === t ? Array.from(e) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? Jr(e, r) : void 0;
        }
    }(e)) || r && e && "number" == typeof e.length) {
        t && (e = t);
        var n = 0;
        return function() {
            return n >= e.length ? {
                done: !0
            } : {
                done: !1,
                value: e[n++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function Vr() {
    return Vr = Object.assign ? Object.assign.bind() : function(e) {
        for(var r = 1; r < arguments.length; r++){
            var t = arguments[r];
            for(var n in t)({}).hasOwnProperty.call(t, n) && (e[n] = t[n]);
        }
        return e;
    }, Vr.apply(null, arguments);
}
function Zr(e, r) {
    if (null == e) return {};
    var t = {};
    for(var n in e)if (({}).hasOwnProperty.call(e, n)) {
        if (-1 !== r.indexOf(n)) continue;
        t[n] = e[n];
    }
    return t;
}
function et(e, r) {
    return et = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(e, r) {
        return e.__proto__ = r, e;
    }, et(e, r);
}
var rt = [
    "id",
    "colors"
], tt = function(e) {
    var r = e.id, t = e.colors, n = Zr(e, rt);
    return (0, _jsxRuntime.jsx)("linearGradient", Vr({
        id: r,
        x1: 0,
        x2: 0,
        y1: 0,
        y2: 1
    }, n, {
        children: t.map(function(e) {
            var r = e.offset, t = e.color, n = e.opacity;
            return (0, _jsxRuntime.jsx)("stop", {
                offset: r + "%",
                stopColor: t,
                stopOpacity: void 0 !== n ? n : 1
            }, r);
        })
    }));
}, nt = function(e, r, t) {
    return void 0 === t && (t = {}), Vr({
        id: e,
        type: "linearGradient",
        colors: r
    }, t);
}, ot = {
    linearGradient: tt
}, it = {
    color: "#000000",
    background: "#ffffff",
    size: 4,
    padding: 4,
    stagger: !1
}, at = (0, _react.memo)(function(e) {
    var r = e.id, t = e.background, n = void 0 === t ? it.background : t, o = e.color, i = void 0 === o ? it.color : o, a = e.size, l = void 0 === a ? it.size : a, d = e.padding, u = void 0 === d ? it.padding : d, c = e.stagger, s = void 0 === c ? it.stagger : c, f = l + u, h = l / 2, p = u / 2;
    return !0 === s && (f = 2 * l + 2 * u), (0, _jsxRuntime.jsxs)("pattern", {
        id: r,
        width: f,
        height: f,
        patternUnits: "userSpaceOnUse",
        children: [
            (0, _jsxRuntime.jsx)("rect", {
                width: f,
                height: f,
                fill: n
            }),
            (0, _jsxRuntime.jsx)("circle", {
                cx: p + h,
                cy: p + h,
                r: h,
                fill: i
            }),
            s && (0, _jsxRuntime.jsx)("circle", {
                cx: 1.5 * u + l + h,
                cy: 1.5 * u + l + h,
                r: h,
                fill: i
            })
        ]
    });
}), lt = function(e, r) {
    return void 0 === r && (r = {}), Vr({
        id: e,
        type: "patternDots"
    }, r);
}, dt = 2 * Math.PI, ut = function(e) {
    return e * Math.PI / 180;
}, ct = function(e) {
    return 180 * e / Math.PI;
}, st = function(e) {
    return e.startAngle + (e.endAngle - e.startAngle) / 2;
}, ft = function(e, r) {
    return {
        x: Math.cos(e) * r,
        y: Math.sin(e) * r
    };
}, ht = function(e) {
    var r = e % 360;
    return r < 0 && (r += 360), r;
}, pt = function(e, r, t) {
    void 0 === t && (t = 360);
    var n = r;
    return Math.abs(r - e) > t && (n = e + (r > e ? t : -t)), [
        e,
        n
    ];
}, gt = {
    svg: {
        align: {
            left: "start",
            center: "middle",
            right: "end",
            start: "start",
            middle: "middle",
            end: "end"
        },
        baseline: {
            top: "text-before-edge",
            center: "central",
            bottom: "alphabetic"
        }
    },
    canvas: {
        align: {
            left: "left",
            center: "center",
            right: "right",
            start: "left",
            middle: "center",
            end: "right"
        },
        baseline: {
            top: "top",
            center: "middle",
            bottom: "bottom"
        }
    }
}, bt = function(e, r, t, n) {
    void 0 === n && (n = "svg");
    var o = gt[n], i = ft(r - Math.PI / 2, e), a = i.x, l = i.y, d = ct(r), u = o.align.center, c = o.baseline.bottom;
    return t > 0 ? (u = o.align.right, c = o.baseline.center) : t < 0 && (u = o.align.left, c = o.baseline.center), 0 !== t && d > 180 && (d -= 180, u = u === o.align.right ? o.align.left : o.align.right), {
        x: a,
        y: l,
        rotate: d += t,
        align: u,
        baseline: c
    };
}, mt = {
    spacing: 5,
    rotation: 0,
    background: "#000000",
    color: "#ffffff",
    lineWidth: 2
}, vt = (0, _react.memo)(function(e) {
    var r = e.id, t = e.spacing, n = void 0 === t ? mt.spacing : t, o = e.rotation, i = void 0 === o ? mt.rotation : o, a = e.background, l = void 0 === a ? mt.background : a, d = e.color, u = void 0 === d ? mt.color : d, c = e.lineWidth, s = void 0 === c ? mt.lineWidth : c, f = Math.round(i) % 360, h = Math.abs(n);
    f > 180 ? f -= 360 : f > 90 ? f -= 180 : f < -180 ? f += 360 : f < -90 && (f += 180);
    var p, g = h, b = h;
    return 0 === f ? p = "\n                M 0 0 L " + g + " 0\n                M 0 " + b + " L " + g + " " + b + "\n            " : 90 === f ? p = "\n                M 0 0 L 0 " + b + "\n                M " + g + " 0 L " + g + " " + b + "\n            " : (g = Math.abs(h / Math.sin(ut(f))), b = h / Math.sin(ut(90 - f)), p = f > 0 ? "\n                    M 0 " + -b + " L " + 2 * g + " " + b + "\n                    M " + -g + " " + -b + " L " + g + " " + b + "\n                    M " + -g + " 0 L " + g + " " + 2 * b + "\n                " : "\n                    M " + -g + " " + b + " L " + g + " " + -b + "\n                    M " + -g + " " + 2 * b + " L " + 2 * g + " " + -b + "\n                    M 0 " + 2 * b + " L " + 2 * g + " 0\n                "), (0, _jsxRuntime.jsxs)("pattern", {
        id: r,
        width: g,
        height: b,
        patternUnits: "userSpaceOnUse",
        children: [
            (0, _jsxRuntime.jsx)("rect", {
                width: g,
                height: b,
                fill: l,
                stroke: "rgba(255, 0, 0, 0.1)",
                strokeWidth: 0
            }),
            (0, _jsxRuntime.jsx)("path", {
                d: p,
                strokeWidth: s,
                stroke: u,
                strokeLinecap: "square"
            })
        ]
    });
}), yt = function(e, r) {
    return void 0 === r && (r = {}), Vr({
        id: e,
        type: "patternLines"
    }, r);
}, _t = {
    color: "#000000",
    background: "#ffffff",
    size: 4,
    padding: 4,
    stagger: !1
}, wt = (0, _react.memo)(function(e) {
    var r = e.id, t = e.color, n = void 0 === t ? _t.color : t, o = e.background, i = void 0 === o ? _t.background : o, a = e.size, l = void 0 === a ? _t.size : a, d = e.padding, u = void 0 === d ? _t.padding : d, c = e.stagger, s = void 0 === c ? _t.stagger : c, f = l + u, h = u / 2;
    return !0 === s && (f = 2 * l + 2 * u), (0, _jsxRuntime.jsxs)("pattern", {
        id: r,
        width: f,
        height: f,
        patternUnits: "userSpaceOnUse",
        children: [
            (0, _jsxRuntime.jsx)("rect", {
                width: f,
                height: f,
                fill: i
            }),
            (0, _jsxRuntime.jsx)("rect", {
                x: h,
                y: h,
                width: l,
                height: l,
                fill: n
            }),
            s && (0, _jsxRuntime.jsx)("rect", {
                x: 1.5 * u + l,
                y: 1.5 * u + l,
                width: l,
                height: l,
                fill: n
            })
        ]
    });
}), kt = function(e, r) {
    return void 0 === r && (r = {}), Vr({
        id: e,
        type: "patternSquares"
    }, r);
}, xt = {
    patternDots: at,
    patternLines: vt,
    patternSquares: wt
}, Ot = [
    "type"
], zt = Vr({}, ot, xt), Mt = (0, _react.memo)(function(e) {
    var r = e.defs;
    return !r || r.length < 1 ? null : (0, _jsxRuntime.jsx)("defs", {
        "aria-hidden": !0,
        children: r.map(function(e) {
            var r = e.type, t = Zr(e, Ot);
            return zt[r] ? (0, _react.createElement)(zt[r], Vr({
                key: t.id
            }, t)) : null;
        })
    });
}), Rt = (0, _react.forwardRef)(function(e, r) {
    var t = e.width, n = e.height, o = e.margin, i = e.defs, a = e.children, l = e.role, d = e.ariaLabel, u = e.ariaLabelledBy, c = e.ariaDescribedBy, s = e.isFocusable, f = (0, _theming.useTheme)();
    return (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: t,
        height: n,
        role: l,
        "aria-label": d,
        "aria-labelledby": u,
        "aria-describedby": c,
        focusable: s,
        tabIndex: s ? 0 : void 0,
        ref: r,
        children: [
            (0, _jsxRuntime.jsx)(Mt, {
                defs: i
            }),
            (0, _jsxRuntime.jsx)("rect", {
                width: t,
                height: n,
                fill: f.background
            }),
            (0, _jsxRuntime.jsx)("g", {
                transform: "translate(" + o.left + "," + o.top + ")",
                children: a
            })
        ]
    });
}), jt = (0, _react.memo)(function(e) {
    var r = e.size, t = e.color, n = e.borderWidth, o = e.borderColor;
    return (0, _jsxRuntime.jsx)("circle", {
        r: r / 2,
        fill: t,
        stroke: o,
        strokeWidth: n,
        style: {
            pointerEvents: "none"
        }
    });
}), Ct = (0, _react.memo)(function(e) {
    var r = e.x, t = e.y, n = e.symbol, o = void 0 === n ? jt : n, a = e.size, l = e.datum, u = e.color, c = e.borderWidth, s = e.borderColor, f = e.label, h = e.labelTextAnchor, p = void 0 === h ? "middle" : h, g = e.labelYOffset, b = void 0 === g ? -12 : g, m = e.ariaLabel, _ = e.ariaLabelledBy, w = e.ariaDescribedBy, O = e.ariaHidden, R = e.ariaDisabled, j = e.isFocusable, C = void 0 !== j && j, B = e.tabIndex, P = void 0 === B ? 0 : B, W = e.onFocus, G = e.onBlur, I = e.testId, A = (0, _theming.useTheme)(), L = Dr(), S = L.animate, Y = L.config, q = (0, _web.useSpring)({
        transform: "translate(" + r + ", " + t + ")",
        config: Y,
        immediate: !S
    }), D = (0, _react.useCallback)(function(e) {
        null == W || W(l, e);
    }, [
        W,
        l
    ]), E = (0, _react.useCallback)(function(e) {
        null == G || G(l, e);
    }, [
        G,
        l
    ]);
    return (0, _jsxRuntime.jsxs)((0, _web.animated).g, {
        transform: q.transform,
        style: {
            pointerEvents: "none"
        },
        focusable: C,
        tabIndex: C ? P : void 0,
        "aria-label": m,
        "aria-labelledby": _,
        "aria-describedby": w,
        "aria-disabled": R,
        "aria-hidden": O,
        onFocus: C && W ? D : void 0,
        onBlur: C && G ? E : void 0,
        "data-testid": I,
        children: [
            (0, _react.createElement)(o, {
                size: a,
                color: u,
                datum: l,
                borderWidth: c,
                borderColor: s
            }),
            f && (0, _jsxRuntime.jsx)("text", {
                textAnchor: p,
                y: b,
                style: (0, _theming.sanitizeSvgTextStyle)(A.dots.text),
                children: f
            })
        ]
    });
}), Bt = (0, _react.memo)(function(e) {
    var r = e.width, t = e.height, n = e.axis, o = e.scale, i = e.value, a = e.lineStyle, l = e.textStyle, d = e.legend, u = e.legendNode, c = e.legendPosition, s = void 0 === c ? "top-right" : c, f = e.legendOffsetX, h = void 0 === f ? 14 : f, p = e.legendOffsetY, g = void 0 === p ? 14 : p, b = e.legendOrientation, m = void 0 === b ? "horizontal" : b, y = (0, _theming.useTheme)(), _ = 0, w = 0, k = 0, x = 0;
    if ("y" === n ? (k = o(i), w = r) : (_ = o(i), x = t), d && !u) {
        var O = function(e) {
            var r = e.axis, t = e.width, n = e.height, o = e.position, i = e.offsetX, a = e.offsetY, l = e.orientation, d = 0, u = 0, c = "vertical" === l ? -90 : 0, s = "start";
            if ("x" === r) switch(o){
                case "top-left":
                    d = -i, u = a, s = "end";
                    break;
                case "top":
                    u = -a, s = "horizontal" === l ? "middle" : "start";
                    break;
                case "top-right":
                    d = i, u = a, s = "horizontal" === l ? "start" : "end";
                    break;
                case "right":
                    d = i, u = n / 2, s = "horizontal" === l ? "start" : "middle";
                    break;
                case "bottom-right":
                    d = i, u = n - a, s = "start";
                    break;
                case "bottom":
                    u = n + a, s = "horizontal" === l ? "middle" : "end";
                    break;
                case "bottom-left":
                    u = n - a, d = -i, s = "horizontal" === l ? "end" : "start";
                    break;
                case "left":
                    d = -i, u = n / 2, s = "horizontal" === l ? "end" : "middle";
            }
            else switch(o){
                case "top-left":
                    d = i, u = -a, s = "start";
                    break;
                case "top":
                    d = t / 2, u = -a, s = "horizontal" === l ? "middle" : "start";
                    break;
                case "top-right":
                    d = t - i, u = -a, s = "horizontal" === l ? "end" : "start";
                    break;
                case "right":
                    d = t + i, s = "horizontal" === l ? "start" : "middle";
                    break;
                case "bottom-right":
                    d = t - i, u = a, s = "end";
                    break;
                case "bottom":
                    d = t / 2, u = a, s = "horizontal" === l ? "middle" : "end";
                    break;
                case "bottom-left":
                    d = i, u = a, s = "horizontal" === l ? "start" : "end";
                    break;
                case "left":
                    d = -i, s = "horizontal" === l ? "end" : "middle";
            }
            return {
                x: d,
                y: u,
                rotation: c,
                textAnchor: s
            };
        }({
            axis: n,
            width: r,
            height: t,
            position: s,
            offsetX: h,
            offsetY: g,
            orientation: m
        });
        u = (0, _jsxRuntime.jsx)("text", {
            transform: "translate(" + O.x + ", " + O.y + ") rotate(" + O.rotation + ")",
            textAnchor: O.textAnchor,
            dominantBaseline: "central",
            style: l,
            children: d
        });
    }
    return (0, _jsxRuntime.jsxs)("g", {
        transform: "translate(" + _ + ", " + k + ")",
        children: [
            (0, _jsxRuntime.jsx)("line", {
                x1: 0,
                x2: w,
                y1: 0,
                y2: x,
                stroke: y.markers.lineColor,
                strokeWidth: y.markers.lineStrokeWidth,
                style: a
            }),
            u
        ]
    });
}), Pt = (0, _react.memo)(function(e) {
    var r = e.markers, t = e.width, n = e.height, o = e.xScale, i = e.yScale;
    return r && 0 !== r.length ? r.map(function(e, r) {
        return (0, _jsxRuntime.jsx)(Bt, Vr({}, e, {
            width: t,
            height: n,
            scale: "y" === e.axis ? i : o
        }), r);
    }) : null;
}), Wt = [
    "theme",
    "renderWrapper",
    "animate",
    "motionConfig"
], Gt = function(e) {
    return function(r) {
        function t() {
            return r.apply(this, arguments) || this;
        }
        var n, o;
        return o = r, (n = t).prototype = Object.create(o.prototype), n.prototype.constructor = n, et(n, o), t.prototype.render = function() {
            var r = this.props, t = r.theme, n = r.renderWrapper, o = r.animate, i = r.motionConfig, a = Zr(r, Wt);
            return (0, _jsxRuntime.jsx)(Fr, {
                theme: t,
                renderWrapper: n,
                isInteractive: a.isInteractive,
                animate: o,
                motionConfig: i,
                children: (0, _jsxRuntime.jsx)(e, Vr({}, a))
            });
        }, t;
    }((0, _react.Component));
}, It = function(e) {
    var t = Dr(), n = t.animate, i = t.config, l = function(e) {
        var r = (0, _react.useRef)();
        return (0, _react.useEffect)(function() {
            r.current = e;
        }, [
            e
        ]), r.current;
    }(e), d = (0, _react.useMemo)(function() {
        return (0, _d3Interpolate.interpolateString)(l, e);
    }, [
        l,
        e
    ]), u = (0, _web.useSpring)({
        from: {
            value: 0
        },
        to: {
            value: 1
        },
        reset: !0,
        config: i,
        immediate: !n
    }).value;
    return (0, _web.to)(u, d);
}, At = (0, _react.createContext)(void 0), Lt = {
    basis: (0, _d3Shape.curveBasis),
    basisClosed: (0, _d3Shape.curveBasisClosed),
    basisOpen: (0, _d3Shape.curveBasisOpen),
    bundle: (0, _d3Shape.curveBundle),
    cardinal: (0, _d3Shape.curveCardinal),
    cardinalClosed: (0, _d3Shape.curveCardinalClosed),
    cardinalOpen: (0, _d3Shape.curveCardinalOpen),
    catmullRom: (0, _d3Shape.curveCatmullRom),
    catmullRomClosed: (0, _d3Shape.curveCatmullRomClosed),
    catmullRomOpen: (0, _d3Shape.curveCatmullRomOpen),
    linear: (0, _d3Shape.curveLinear),
    linearClosed: (0, _d3Shape.curveLinearClosed),
    monotoneX: (0, _d3Shape.curveMonotoneX),
    monotoneY: (0, _d3Shape.curveMonotoneY),
    natural: (0, _d3Shape.curveNatural),
    step: (0, _d3Shape.curveStep),
    stepAfter: (0, _d3Shape.curveStepAfter),
    stepBefore: (0, _d3Shape.curveStepBefore)
}, St = Object.keys(Lt), Yt = St.filter(function(e) {
    return e.endsWith("Closed");
}), qt = (0, _withoutJsDefault.default)(St, "bundle", "basisClosed", "basisOpen", "cardinalClosed", "cardinalOpen", "catmullRomClosed", "catmullRomOpen", "linearClosed"), Dt = (0, _withoutJsDefault.default)(St, "bundle", "basisClosed", "basisOpen", "cardinalClosed", "cardinalOpen", "catmullRomClosed", "catmullRomOpen", "linearClosed"), Et = function(e) {
    if (!Lt[e]) throw new TypeError("'" + e + "', is not a valid curve interpolator identifier.");
    return Lt[e];
}, Ut = {
    ascending: (0, _d3Shape.stackOrderAscending),
    descending: (0, _d3Shape.stackOrderDescending),
    insideOut: (0, _d3Shape.stackOrderInsideOut),
    none: (0, _d3Shape.stackOrderNone),
    reverse: (0, _d3Shape.stackOrderReverse)
}, Ft = Object.keys(Ut), Tt = function(e) {
    return Ut[e];
}, Ht = {
    expand: (0, _d3Shape.stackOffsetExpand),
    diverging: (0, _d3Shape.stackOffsetDiverging),
    none: (0, _d3Shape.stackOffsetNone),
    silhouette: (0, _d3Shape.stackOffsetSilhouette),
    wiggle: (0, _d3Shape.stackOffsetWiggle)
}, Xt = Object.keys(Ht), Kt = function(e) {
    return Ht[e];
}, Nt = [
    "normal",
    "multiply",
    "screen",
    "overlay",
    "darken",
    "lighten",
    "color-dodge",
    "color-burn",
    "hard-light",
    "soft-light",
    "difference",
    "exclusion",
    "hue",
    "saturation",
    "color",
    "luminosity"
], $t = function(e) {
    return (0, _react.useMemo)(function() {
        return Et(e);
    }, [
        e
    ]);
}, Jt = {
    nivo: [
        "#d76445",
        "#f47560",
        "#e8c1a0",
        "#97e3d5",
        "#61cdbb",
        "#00b0a7"
    ],
    BrBG: (0, _lastJsDefault.default)((0, _d3ScaleChromatic.schemeBrBG)),
    PRGn: (0, _lastJsDefault.default)((0, _d3ScaleChromatic.schemePRGn)),
    PiYG: (0, _lastJsDefault.default)((0, _d3ScaleChromatic.schemePiYG)),
    PuOr: (0, _lastJsDefault.default)((0, _d3ScaleChromatic.schemePuOr)),
    RdBu: (0, _lastJsDefault.default)((0, _d3ScaleChromatic.schemeRdBu)),
    RdGy: (0, _lastJsDefault.default)((0, _d3ScaleChromatic.schemeRdGy)),
    RdYlBu: (0, _lastJsDefault.default)((0, _d3ScaleChromatic.schemeRdYlBu)),
    RdYlGn: (0, _lastJsDefault.default)((0, _d3ScaleChromatic.schemeRdYlGn)),
    spectral: (0, _lastJsDefault.default)((0, _d3ScaleChromatic.schemeSpectral)),
    blues: (0, _lastJsDefault.default)((0, _d3ScaleChromatic.schemeBlues)),
    greens: (0, _lastJsDefault.default)((0, _d3ScaleChromatic.schemeGreens)),
    greys: (0, _lastJsDefault.default)((0, _d3ScaleChromatic.schemeGreys)),
    oranges: (0, _lastJsDefault.default)((0, _d3ScaleChromatic.schemeOranges)),
    purples: (0, _lastJsDefault.default)((0, _d3ScaleChromatic.schemePurples)),
    reds: (0, _lastJsDefault.default)((0, _d3ScaleChromatic.schemeReds)),
    BuGn: (0, _lastJsDefault.default)((0, _d3ScaleChromatic.schemeBuGn)),
    BuPu: (0, _lastJsDefault.default)((0, _d3ScaleChromatic.schemeBuPu)),
    GnBu: (0, _lastJsDefault.default)((0, _d3ScaleChromatic.schemeGnBu)),
    OrRd: (0, _lastJsDefault.default)((0, _d3ScaleChromatic.schemeOrRd)),
    PuBuGn: (0, _lastJsDefault.default)((0, _d3ScaleChromatic.schemePuBuGn)),
    PuBu: (0, _lastJsDefault.default)((0, _d3ScaleChromatic.schemePuBu)),
    PuRd: (0, _lastJsDefault.default)((0, _d3ScaleChromatic.schemePuRd)),
    RdPu: (0, _lastJsDefault.default)((0, _d3ScaleChromatic.schemeRdPu)),
    YlGnBu: (0, _lastJsDefault.default)((0, _d3ScaleChromatic.schemeYlGnBu)),
    YlGn: (0, _lastJsDefault.default)((0, _d3ScaleChromatic.schemeYlGn)),
    YlOrBr: (0, _lastJsDefault.default)((0, _d3ScaleChromatic.schemeYlOrBr)),
    YlOrRd: (0, _lastJsDefault.default)((0, _d3ScaleChromatic.schemeYlOrRd))
}, Qt = Object.keys(Jt), Vt = function(e) {
    if ((0, _isFunctionJsDefault.default)(e)) {
        if (!(0, _isFunctionJsDefault.default)(e.domain)) throw new Error("Provided colors should be a valid quantize scale providing a 'domain()' function");
        return e;
    }
    if (Jt[e]) return (0, _d3Scale.scaleQuantize)().range(Jt[e]);
    if ((0, _isArrayJsDefault.default)(e)) return (0, _d3Scale.scaleQuantize)().range(e);
    throw new Error("Unable to guess quantize color scale from '" + e + "',\nmust be a function or one of:\n'" + Qt.join("', '") + "'");
}, Zt = {
    nivo: [
        "#e8c1a0",
        "#f47560",
        "#f1e15b",
        "#e8a838",
        "#61cdbb",
        "#97e3d5"
    ],
    category10: (0, _d3ScaleChromatic.schemeCategory10),
    accent: (0, _d3ScaleChromatic.schemeAccent),
    dark2: (0, _d3ScaleChromatic.schemeDark2),
    paired: (0, _d3ScaleChromatic.schemePaired),
    pastel1: (0, _d3ScaleChromatic.schemePastel1),
    pastel2: (0, _d3ScaleChromatic.schemePastel2),
    set1: (0, _d3ScaleChromatic.schemeSet1),
    set2: (0, _d3ScaleChromatic.schemeSet2),
    set3: (0, _d3ScaleChromatic.schemeSet3),
    brown_blueGreen: (0, _lastJsDefault.default)((0, _d3ScaleChromatic.schemeBrBG)),
    purpleRed_green: (0, _lastJsDefault.default)((0, _d3ScaleChromatic.schemePRGn)),
    pink_yellowGreen: (0, _lastJsDefault.default)((0, _d3ScaleChromatic.schemePiYG)),
    purple_orange: (0, _lastJsDefault.default)((0, _d3ScaleChromatic.schemePuOr)),
    red_blue: (0, _lastJsDefault.default)((0, _d3ScaleChromatic.schemeRdBu)),
    red_grey: (0, _lastJsDefault.default)((0, _d3ScaleChromatic.schemeRdGy)),
    red_yellow_blue: (0, _lastJsDefault.default)((0, _d3ScaleChromatic.schemeRdYlBu)),
    red_yellow_green: (0, _lastJsDefault.default)((0, _d3ScaleChromatic.schemeRdYlGn)),
    spectral: (0, _lastJsDefault.default)((0, _d3ScaleChromatic.schemeSpectral)),
    blues: (0, _lastJsDefault.default)((0, _d3ScaleChromatic.schemeBlues)),
    greens: (0, _lastJsDefault.default)((0, _d3ScaleChromatic.schemeGreens)),
    greys: (0, _lastJsDefault.default)((0, _d3ScaleChromatic.schemeGreys)),
    oranges: (0, _lastJsDefault.default)((0, _d3ScaleChromatic.schemeOranges)),
    purples: (0, _lastJsDefault.default)((0, _d3ScaleChromatic.schemePurples)),
    reds: (0, _lastJsDefault.default)((0, _d3ScaleChromatic.schemeReds)),
    blue_green: (0, _lastJsDefault.default)((0, _d3ScaleChromatic.schemeBuGn)),
    blue_purple: (0, _lastJsDefault.default)((0, _d3ScaleChromatic.schemeBuPu)),
    green_blue: (0, _lastJsDefault.default)((0, _d3ScaleChromatic.schemeGnBu)),
    orange_red: (0, _lastJsDefault.default)((0, _d3ScaleChromatic.schemeOrRd)),
    purple_blue_green: (0, _lastJsDefault.default)((0, _d3ScaleChromatic.schemePuBuGn)),
    purple_blue: (0, _lastJsDefault.default)((0, _d3ScaleChromatic.schemePuBu)),
    purple_red: (0, _lastJsDefault.default)((0, _d3ScaleChromatic.schemePuRd)),
    red_purple: (0, _lastJsDefault.default)((0, _d3ScaleChromatic.schemeRdPu)),
    yellow_green_blue: (0, _lastJsDefault.default)((0, _d3ScaleChromatic.schemeYlGnBu)),
    yellow_green: (0, _lastJsDefault.default)((0, _d3ScaleChromatic.schemeYlGn)),
    yellow_orange_brown: (0, _lastJsDefault.default)((0, _d3ScaleChromatic.schemeYlOrBr)),
    yellow_orange_red: (0, _lastJsDefault.default)((0, _d3ScaleChromatic.schemeYlOrRd))
}, en = [
    "nivo",
    "category10",
    "accent",
    "dark2",
    "paired",
    "pastel1",
    "pastel2",
    "set1",
    "set2",
    "set3",
    "brown_blueGreen",
    "purpleRed_green",
    "pink_yellowGreen",
    "purple_orange",
    "red_blue",
    "red_grey",
    "red_yellow_blue",
    "red_yellow_green",
    "spectral",
    "blues",
    "greens",
    "greys",
    "oranges",
    "purples",
    "reds",
    "blue_green",
    "blue_purple",
    "green_blue",
    "orange_red",
    "purple_blue_green",
    "purple_blue",
    "purple_red",
    "red_purple",
    "yellow_green_blue",
    "yellow_green",
    "yellow_orange_brown",
    "yellow_orange_red"
], rn = {
    brown_blueGreen: (0, _d3ScaleChromatic.interpolateBrBG),
    purpleRed_green: (0, _d3ScaleChromatic.interpolatePRGn),
    pink_yellowGreen: (0, _d3ScaleChromatic.interpolatePiYG),
    purple_orange: (0, _d3ScaleChromatic.interpolatePuOr),
    red_blue: (0, _d3ScaleChromatic.interpolateRdBu),
    red_grey: (0, _d3ScaleChromatic.interpolateRdGy),
    red_yellow_blue: (0, _d3ScaleChromatic.interpolateRdYlBu),
    red_yellow_green: (0, _d3ScaleChromatic.interpolateRdYlGn),
    spectral: (0, _d3ScaleChromatic.interpolateSpectral),
    blues: (0, _d3ScaleChromatic.interpolateBlues),
    greens: (0, _d3ScaleChromatic.interpolateGreens),
    greys: (0, _d3ScaleChromatic.interpolateGreys),
    oranges: (0, _d3ScaleChromatic.interpolateOranges),
    purples: (0, _d3ScaleChromatic.interpolatePurples),
    reds: (0, _d3ScaleChromatic.interpolateReds),
    viridis: (0, _d3ScaleChromatic.interpolateViridis),
    inferno: (0, _d3ScaleChromatic.interpolateInferno),
    magma: (0, _d3ScaleChromatic.interpolateMagma),
    plasma: (0, _d3ScaleChromatic.interpolatePlasma),
    warm: (0, _d3ScaleChromatic.interpolateWarm),
    cool: (0, _d3ScaleChromatic.interpolateCool),
    cubehelixDefault: (0, _d3ScaleChromatic.interpolateCubehelixDefault),
    blue_green: (0, _d3ScaleChromatic.interpolateBuGn),
    blue_purple: (0, _d3ScaleChromatic.interpolateBuPu),
    green_blue: (0, _d3ScaleChromatic.interpolateGnBu),
    orange_red: (0, _d3ScaleChromatic.interpolateOrRd),
    purple_blue_green: (0, _d3ScaleChromatic.interpolatePuBuGn),
    purple_blue: (0, _d3ScaleChromatic.interpolatePuBu),
    purple_red: (0, _d3ScaleChromatic.interpolatePuRd),
    red_purple: (0, _d3ScaleChromatic.interpolateRdPu),
    yellow_green_blue: (0, _d3ScaleChromatic.interpolateYlGnBu),
    yellow_green: (0, _d3ScaleChromatic.interpolateYlGn),
    yellow_orange_brown: (0, _d3ScaleChromatic.interpolateYlOrBr),
    yellow_orange_red: (0, _d3ScaleChromatic.interpolateYlOrRd),
    rainbow: (0, _d3ScaleChromatic.interpolateRainbow),
    sinebow: (0, _d3ScaleChromatic.interpolateSinebow)
}, tn = [
    "brown_blueGreen",
    "purpleRed_green",
    "pink_yellowGreen",
    "purple_orange",
    "red_blue",
    "red_grey",
    "red_yellow_blue",
    "red_yellow_green",
    "spectral",
    "blues",
    "greens",
    "greys",
    "oranges",
    "purples",
    "reds",
    "viridis",
    "inferno",
    "magma",
    "plasma",
    "warm",
    "cool",
    "cubehelixDefault",
    "blue_green",
    "blue_purple",
    "green_blue",
    "orange_red",
    "purple_blue_green",
    "purple_blue",
    "purple_red",
    "red_purple",
    "yellow_green_blue",
    "yellow_green",
    "yellow_orange_brown",
    "yellow_orange_red",
    "rainbow",
    "sinebow"
], nn = function() {
    return (0, _d3Scale.scaleOrdinal)([
        "#e8c1a0",
        "#f47560",
        "#f1e15b",
        "#e8a838",
        "#61cdbb",
        "#97e3d5"
    ]);
}, on = function(e, r) {
    if ((0, _isStringJsDefault.default)(e)) {
        var t = Zt[e];
        if (void 0 !== t) {
            var n = (0, _d3Scale.scaleOrdinal)(t);
            return n.type = "ordinal", n;
        }
        if (void 0 !== r && 0 === e.indexOf("seq:")) {
            var o = rn[e.slice(4)];
            if (void 0 !== o) {
                var i = (0, _d3Scale.scaleSequential)(o).domain(r.domain());
                return i.type = "sequential", i;
            }
        }
    }
    if ((0, _isArrayJsDefault.default)(e)) {
        var a = (0, _d3Scale.scaleOrdinal)(e);
        return a.type = "ordinal", a;
    }
    return function() {
        return e;
    };
}, an = !0, ln = nn, dn = (0, _d3Scale.scaleOrdinal)((0, _d3ScaleChromatic.schemeSet3)), un = {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
}, cn = function(e, t, n) {
    return void 0 === n && (n = {}), (0, _react.useMemo)(function() {
        var r = Vr({}, un, n);
        return {
            margin: r,
            innerWidth: e - r.left - r.right,
            innerHeight: t - r.top - r.bottom,
            outerWidth: e,
            outerHeight: t
        };
    }, [
        e,
        t,
        n
    ]);
}, sn = function() {
    var e = (0, _react.useRef)(null), r = (0, _react.useState)({
        left: 0,
        top: 0,
        width: 0,
        height: 0
    }), t = r[0], n = r[1], i = (0, _react.useState)(function() {
        return "undefined" == typeof ResizeObserver ? null : new ResizeObserver(function(e) {
            var r = e[0];
            return n(r.contentRect);
        });
    })[0];
    return (0, _react.useEffect)(function() {
        return e.current && null !== i && i.observe(e.current), function() {
            null !== i && i.disconnect();
        };
    }, [
        i
    ]), [
        e,
        t
    ];
}, fn = function(e) {
    return "function" == typeof e ? e : "string" == typeof e ? 0 === e.indexOf("time:") ? (0, _d3TimeFormat.timeFormat)(e.slice("5")) : (0, _d3Format.format)(e) : function(e) {
        return "" + e;
    };
}, hn = function(e) {
    return (0, _react.useMemo)(function() {
        return fn(e);
    }, [
        e
    ]);
}, pn = function(e, r) {
    var t, n = (0, _isFunctionJsDefault.default)(e) ? e : function(r) {
        return (0, _getJsDefault.default)(r, e);
    };
    return r && (t = (0, _isFunctionJsDefault.default)(r) ? r : (0, _d3Format.format)(r)), t ? function(e) {
        return t(n(e));
    } : n;
}, gn = function(e) {
    return (0, _isFunctionJsDefault.default)(e) ? e : function(r) {
        return (0, _getJsDefault.default)(r, e);
    };
}, bn = function(e) {
    return (0, _react.useMemo)(function() {
        return gn(e);
    }, [
        e
    ]);
}, mn = [
    "center",
    "top-left",
    "top",
    "top-right",
    "right",
    "bottom-right",
    "bottom",
    "bottom-left",
    "left"
], vn = function(e, r, t) {
    var n = r.width - e.width, o = r.height - e.height, i = 0, a = 0;
    return "center" === t && (i = n / 2, a = o / 2), "top" === t && (i = n / 2), "top-right" === t && (i = n), "right" === t && (i = n, a = o / 2), "bottom-right" === t && (i = n, a = o), "bottom" === t && (i = n / 2, a = o), "bottom-left" === t && (a = o), "left" === t && (a = o / 2), [
        i,
        a
    ];
}, yn = function(e, r, t, n) {
    return Math.sqrt(Math.pow(t - e, 2) + Math.pow(n - r, 2));
}, _n = function(e, r, t, n) {
    var o = Math.atan2(n - r, t - e) - Math.PI / 2;
    return o > 0 ? o : 2 * Math.PI + o;
}, wn = function(e, r, t, n, o, i) {
    return e <= o && o <= e + t && r <= i && i <= r + n;
}, kn = function(e, r) {
    var t, n = "touches" in r ? r.touches[0] : r, o = n.clientX, i = n.clientY, a = e.getBoundingClientRect(), l = (t = void 0 !== e.getBBox ? e.getBBox() : {
        width: e.offsetWidth || 0,
        height: e.offsetHeight || 0
    }).width === a.width ? 1 : t.width / a.width;
    return [
        (o - a.left) * l,
        (i - a.top) * l
    ];
}, xn = Object.keys(ot), On = Object.keys(xt), zn = function(e, r, t) {
    if ("*" === e) return !0;
    if ((0, _isFunctionJsDefault.default)(e)) return e(r);
    if ((0, _isPlainObjectJsDefault.default)(e)) {
        var n = t ? (0, _getJsDefault.default)(r, t) : r;
        return (0, _isEqualJsDefault.default)((0, _pickJsDefault.default)(n, Object.keys(e)), e);
    }
    return !1;
}, Mn = function(e, r, t, n) {
    var o = void 0 === n ? {} : n, i = o.dataKey, a = o.colorKey, l = void 0 === a ? "color" : a, d = o.targetKey, u = void 0 === d ? "fill" : d, c = [], s = {};
    return e.length && r.length && (c = [].concat(e), r.forEach(function(r) {
        for(var n, o = function() {
            var t = n.value, o = t.id, a = t.match;
            if (zn(a, r, i)) {
                var d = e.find(function(e) {
                    return e.id === o;
                });
                if (d) {
                    if (On.includes(d.type)) {
                        if ("inherit" === d.background || "inherit" === d.color) {
                            var f = (0, _getJsDefault.default)(r, l), h = d.background, p = d.color, g = o;
                            "inherit" === d.background && (g = g + ".bg." + f, h = f), "inherit" === d.color && (g = g + ".fg." + f, p = f), (0, _setJsDefault.default)(r, u, "url(#" + g + ")"), s[g] || (c.push(Vr({}, d, {
                                id: g,
                                background: h,
                                color: p
                            })), s[g] = 1);
                        } else (0, _setJsDefault.default)(r, u, "url(#" + o + ")");
                    } else if (xn.includes(d.type)) {
                        if (d.colors.map(function(e) {
                            return e.color;
                        }).includes("inherit")) {
                            var b = (0, _getJsDefault.default)(r, l), m = o, v = Vr({}, d, {
                                colors: d.colors.map(function(e, r) {
                                    return "inherit" !== e.color ? e : (m = m + "." + r + "." + b, Vr({}, e, {
                                        color: "inherit" === e.color ? b : e.color
                                    }));
                                })
                            });
                            v.id = m, (0, _setJsDefault.default)(r, u, "url(#" + m + ")"), s[m] || (c.push(v), s[m] = 1);
                        } else (0, _setJsDefault.default)(r, u, "url(#" + o + ")");
                    }
                }
                return 1;
            }
        }, a = Qr(t); !(n = a()).done && !o(););
    })), c;
};
function Rn() {
    for(var e = arguments.length, r = new Array(e), t = 0; t < e; t++)r[t] = arguments[t];
    return function(e) {
        for(var t = 0, n = r; t < n.length; t++){
            var o = n[t];
            "function" == typeof o ? o(e) : null != o && (o.current = e);
        }
    };
}
var jn = [
    "center",
    "top-left",
    "top",
    "top-right",
    "right",
    "bottom-right",
    "bottom",
    "bottom-left",
    "left"
];

},{"react":"6uln9","@nivo/tooltip":"1CuTy","@nivo/theming":"kiBiP","lodash/isString.js":"hjD1s","@react-spring/web":"39JSM","react/jsx-runtime":"gaGEj","react-virtualized-auto-sizer":"9eimb","use-debounce":"ionNE","d3-interpolate":"6bUMz","lodash/without.js":"ctz6Y","d3-shape":"ba4g6","d3-scale":"7BK9l","d3-scale-chromatic":"3BbmN","lodash/last.js":"5Gv7h","lodash/isArray.js":"2VsjV","lodash/isFunction.js":"i4ymb","d3-format":"bpsrv","d3-time-format":"1JsiF","lodash/get.js":"8z6tS","lodash/isPlainObject.js":"aYsgZ","lodash/pick.js":"b7eTA","lodash/isEqual.js":"64pmh","lodash/set.js":"dUuaa","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1CuTy":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BasicTooltip", ()=>T);
parcelHelpers.export(exports, "Chip", ()=>w);
parcelHelpers.export(exports, "Crosshair", ()=>V);
parcelHelpers.export(exports, "TableTooltip", ()=>E);
parcelHelpers.export(exports, "Tooltip", ()=>M);
parcelHelpers.export(exports, "TooltipActionsContext", ()=>O);
parcelHelpers.export(exports, "TooltipProvider", ()=>W);
parcelHelpers.export(exports, "TooltipStateContext", ()=>j);
parcelHelpers.export(exports, "TooltipWrapper", ()=>g);
parcelHelpers.export(exports, "hiddenTooltipState", ()=>N);
parcelHelpers.export(exports, "isVisibleTooltipState", ()=>F);
parcelHelpers.export(exports, "useTooltip", ()=>z);
parcelHelpers.export(exports, "useTooltipHandlers", ()=>k);
parcelHelpers.export(exports, "useTooltipState", ()=>A);
var _react = require("react");
var _web = require("@react-spring/web");
var _core = require("@nivo/core");
var _theming = require("@nivo/theming");
var _jsxRuntime = require("react/jsx-runtime");
function v() {
    return v = Object.assign ? Object.assign.bind() : function(t) {
        for(var i = 1; i < arguments.length; i++){
            var n = arguments[i];
            for(var o in n)({}).hasOwnProperty.call(n, o) && (t[o] = n[o]);
        }
        return t;
    }, v.apply(null, arguments);
}
var x = [
    "basic",
    "chip",
    "container",
    "table",
    "tableCell",
    "tableCellValue"
], m = {
    pointerEvents: "none",
    position: "absolute",
    zIndex: 10,
    top: 0,
    left: 0
}, b = function(t, i) {
    return "translate(" + t + "px, " + i + "px)";
}, g = (0, _react.memo)(function(t) {
    var n, o = t.position, r = t.anchor, e = t.children, l = (0, _theming.useTheme)(), u = (0, _core.useMotionConfig)(), y = u.animate, f = u.config, g = (0, _core.useMeasure)(), w = g[0], T = g[1], C = (0, _react.useRef)(!1), E = void 0, P = !1, V = T.width > 0 && T.height > 0, O = Math.round(o[0]), N = Math.round(o[1]);
    V && ("top" === r ? (O -= T.width / 2, N -= T.height + 14) : "right" === r ? (O += 14, N -= T.height / 2) : "bottom" === r ? (O -= T.width / 2, N += 14) : "left" === r ? (O -= T.width + 14, N -= T.height / 2) : "center" === r && (O -= T.width / 2, N -= T.height / 2), E = {
        transform: b(O, N)
    }, C.current || (P = !0), C.current = [
        O,
        N
    ]);
    var j = (0, _web.useSpring)({
        to: E,
        config: f,
        immediate: !y || P
    }), k = l.tooltip;
    k.basic, k.chip, k.container, k.table, k.tableCell, k.tableCellValue;
    var z = function(t, i) {
        if (null == t) return {};
        var n = {};
        for(var o in t)if (({}).hasOwnProperty.call(t, o)) {
            if (-1 !== i.indexOf(o)) continue;
            n[o] = t[o];
        }
        return n;
    }(k, x), A = v({}, m, z, {
        transform: null != (n = j.transform) ? n : b(O, N),
        opacity: j.transform ? 1 : 0
    });
    return (0, _jsxRuntime.jsx)((0, _web.animated).div, {
        ref: w,
        style: A,
        children: e
    });
});
g.displayName = "TooltipWrapper";
var w = (0, _react.memo)(function(t) {
    var i = t.size, n = void 0 === i ? 12 : i, o = t.color, r = t.style;
    return (0, _jsxRuntime.jsx)("span", {
        style: v({
            display: "block",
            width: n,
            height: n,
            background: o
        }, void 0 === r ? {} : r)
    });
}), T = (0, _react.memo)(function(t) {
    var i, n = t.id, o = t.value, r = t.format, e = t.enableChip, l = void 0 !== e && e, a = t.color, c = t.renderContent, s = (0, _theming.useTheme)(), h = (0, _core.useValueFormatter)(r);
    if ("function" == typeof c) i = c();
    else {
        var f = o;
        void 0 !== h && void 0 !== f && (f = h(f)), i = (0, _jsxRuntime.jsxs)("div", {
            style: s.tooltip.basic,
            children: [
                l && (0, _jsxRuntime.jsx)(w, {
                    color: a,
                    style: s.tooltip.chip
                }),
                void 0 !== f ? (0, _jsxRuntime.jsxs)("span", {
                    children: [
                        n,
                        ": ",
                        (0, _jsxRuntime.jsx)("strong", {
                            children: "" + f
                        })
                    ]
                }) : n
            ]
        });
    }
    return (0, _jsxRuntime.jsx)("div", {
        style: s.tooltip.container,
        role: "tooltip",
        children: i
    });
}), C = {
    width: "100%",
    borderCollapse: "collapse"
}, E = (0, _react.memo)(function(t) {
    var i, n = t.title, o = t.rows, r = void 0 === o ? [] : o, e = t.renderContent, l = (0, _theming.useTheme)();
    return r.length ? (i = "function" == typeof e ? e() : (0, _jsxRuntime.jsxs)("div", {
        children: [
            n && n,
            (0, _jsxRuntime.jsx)("table", {
                style: v({}, C, l.tooltip.table),
                children: (0, _jsxRuntime.jsx)("tbody", {
                    children: r.map(function(t, i) {
                        return (0, _jsxRuntime.jsx)("tr", {
                            children: t.map(function(t, i) {
                                return (0, _jsxRuntime.jsx)("td", {
                                    style: l.tooltip.tableCell,
                                    children: t
                                }, i);
                            })
                        }, i);
                    })
                })
            })
        ]
    }), (0, _jsxRuntime.jsx)("div", {
        style: l.tooltip.container,
        children: i
    })) : null;
});
E.displayName = "TableTooltip";
var P = (0, _react.memo)(function(t) {
    var i = t.x0, o = t.x1, r = t.y0, e = t.y1, l = (0, _theming.useTheme)(), h = (0, _core.useMotionConfig)(), u = h.animate, y = h.config, f = (0, _react.useMemo)(function() {
        return v({}, l.crosshair.line, {
            pointerEvents: "none"
        });
    }, [
        l.crosshair.line
    ]), x = (0, _web.useSpring)({
        x1: i,
        x2: o,
        y1: r,
        y2: e,
        config: y,
        immediate: !u
    });
    return (0, _jsxRuntime.jsx)((0, _web.animated).line, v({}, x, {
        fill: "none",
        style: f
    }));
});
P.displayName = "CrosshairLine";
var V = (0, _react.memo)(function(t) {
    var i, n, o = t.width, r = t.height, e = t.type, l = t.x, a = t.y;
    return "cross" === e ? (i = {
        x0: l,
        x1: l,
        y0: 0,
        y1: r
    }, n = {
        x0: 0,
        x1: o,
        y0: a,
        y1: a
    }) : "top-left" === e ? (i = {
        x0: l,
        x1: l,
        y0: 0,
        y1: a
    }, n = {
        x0: 0,
        x1: l,
        y0: a,
        y1: a
    }) : "top" === e ? i = {
        x0: l,
        x1: l,
        y0: 0,
        y1: a
    } : "top-right" === e ? (i = {
        x0: l,
        x1: l,
        y0: 0,
        y1: a
    }, n = {
        x0: l,
        x1: o,
        y0: a,
        y1: a
    }) : "right" === e ? n = {
        x0: l,
        x1: o,
        y0: a,
        y1: a
    } : "bottom-right" === e ? (i = {
        x0: l,
        x1: l,
        y0: a,
        y1: r
    }, n = {
        x0: l,
        x1: o,
        y0: a,
        y1: a
    }) : "bottom" === e ? i = {
        x0: l,
        x1: l,
        y0: a,
        y1: r
    } : "bottom-left" === e ? (i = {
        x0: l,
        x1: l,
        y0: a,
        y1: r
    }, n = {
        x0: 0,
        x1: l,
        y0: a,
        y1: a
    }) : "left" === e ? n = {
        x0: 0,
        x1: l,
        y0: a,
        y1: a
    } : "x" === e ? i = {
        x0: l,
        x1: l,
        y0: 0,
        y1: r
    } : "y" === e && (n = {
        x0: 0,
        x1: o,
        y0: a,
        y1: a
    }), (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            i && (0, _jsxRuntime.jsx)(P, {
                x0: i.x0,
                x1: i.x1,
                y0: i.y0,
                y1: i.y1
            }),
            n && (0, _jsxRuntime.jsx)(P, {
                x0: n.x0,
                x1: n.x1,
                y0: n.y0,
                y1: n.y1
            })
        ]
    });
});
V.displayName = "Crosshair";
var O = (0, _react.createContext)({
    showTooltipAt: function() {},
    showTooltipFromEvent: function() {},
    hideTooltip: function() {}
}), N = {
    isVisible: !1,
    position: [
        null,
        null
    ],
    content: null,
    anchor: null
}, j = (0, _react.createContext)(N), k = function(t) {
    var i = (0, _react.useState)(N), o = i[0], l = i[1], a = (0, _react.useCallback)(function(t, i, n) {
        var o = i[0], r = i[1];
        void 0 === n && (n = "top"), l({
            isVisible: !0,
            position: [
                o,
                r
            ],
            anchor: n,
            content: t
        });
    }, [
        l
    ]), c = (0, _react.useCallback)(function(i, n, o) {
        void 0 === o && (o = "top");
        var r = t.current.getBoundingClientRect(), e = t.current.offsetWidth, a = e === r.width ? 1 : e / r.width, c = "touches" in n ? n.touches[0] : n, s = c.clientX, h = c.clientY, u = (s - r.left) * a, d = (h - r.top) * a;
        "left" !== o && "right" !== o || (o = u < r.width / 2 ? "right" : "left"), l({
            isVisible: !0,
            position: [
                u,
                d
            ],
            anchor: o,
            content: i
        });
    }, [
        t,
        l
    ]), s = (0, _react.useCallback)(function() {
        l(N);
    }, [
        l
    ]);
    return {
        actions: (0, _react.useMemo)(function() {
            return {
                showTooltipAt: a,
                showTooltipFromEvent: c,
                hideTooltip: s
            };
        }, [
            a,
            c,
            s
        ]),
        state: o
    };
}, z = function() {
    var t = (0, _react.useContext)(O);
    if (void 0 === t) throw new Error("useTooltip must be used within a TooltipProvider");
    return t;
}, A = function() {
    var t = (0, _react.useContext)(j);
    if (void 0 === t) throw new Error("useTooltipState must be used within a TooltipProvider");
    return t;
}, F = function(t) {
    return t.isVisible;
}, M = function() {
    var t = A();
    return F(t) ? (0, _jsxRuntime.jsx)(g, {
        position: t.position,
        anchor: t.anchor,
        children: t.content
    }) : null;
}, W = function(t) {
    var i = t.container, n = t.children, o = k(i), r = o.actions, e = o.state;
    return (0, _jsxRuntime.jsx)(O.Provider, {
        value: r,
        children: (0, _jsxRuntime.jsx)(j.Provider, {
            value: e,
            children: n
        })
    });
};

},{"react":"6uln9","@react-spring/web":"39JSM","@nivo/core":"3e9EB","@nivo/theming":"kiBiP","react/jsx-runtime":"gaGEj","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"39JSM":[function(require,module,exports) {
// src/index.ts
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "a", ()=>animated);
parcelHelpers.export(exports, "animated", ()=>animated);
var _core = require("@react-spring/core");
var _reactDom = require("react-dom");
var _shared = require("@react-spring/shared");
var _animated = require("@react-spring/animated");
// src/index.ts
parcelHelpers.exportAll(_core, exports);
// src/applyAnimatedValues.ts
var isCustomPropRE = /^--/;
function dangerousStyleValue(name, value) {
    if (value == null || typeof value === "boolean" || value === "") return "";
    if (typeof value === "number" && value !== 0 && !isCustomPropRE.test(name) && !(isUnitlessNumber.hasOwnProperty(name) && isUnitlessNumber[name])) return value + "px";
    return ("" + value).trim();
}
var attributeCache = {};
function applyAnimatedValues(instance, props) {
    if (!instance.nodeType || !instance.setAttribute) return false;
    const isFilterElement = instance.nodeName === "filter" || instance.parentNode && instance.parentNode.nodeName === "filter";
    const { style, children, scrollTop, scrollLeft, viewBox, ...attributes } = props;
    const values = Object.values(attributes);
    const names = Object.keys(attributes).map((name)=>isFilterElement || instance.hasAttribute(name) ? name : attributeCache[name] || (attributeCache[name] = name.replace(/([A-Z])/g, // Attributes are written in dash case
        (n)=>"-" + n.toLowerCase())));
    if (children !== void 0) instance.textContent = children;
    for(const name in style)if (style.hasOwnProperty(name)) {
        const value = dangerousStyleValue(name, style[name]);
        if (isCustomPropRE.test(name)) instance.style.setProperty(name, value);
        else instance.style[name] = value;
    }
    names.forEach((name, i)=>{
        instance.setAttribute(name, values[i]);
    });
    if (scrollTop !== void 0) instance.scrollTop = scrollTop;
    if (scrollLeft !== void 0) instance.scrollLeft = scrollLeft;
    if (viewBox !== void 0) instance.setAttribute("viewBox", viewBox);
}
var isUnitlessNumber = {
    animationIterationCount: true,
    borderImageOutset: true,
    borderImageSlice: true,
    borderImageWidth: true,
    boxFlex: true,
    boxFlexGroup: true,
    boxOrdinalGroup: true,
    columnCount: true,
    columns: true,
    flex: true,
    flexGrow: true,
    flexPositive: true,
    flexShrink: true,
    flexNegative: true,
    flexOrder: true,
    gridRow: true,
    gridRowEnd: true,
    gridRowSpan: true,
    gridRowStart: true,
    gridColumn: true,
    gridColumnEnd: true,
    gridColumnSpan: true,
    gridColumnStart: true,
    fontWeight: true,
    lineClamp: true,
    lineHeight: true,
    opacity: true,
    order: true,
    orphans: true,
    tabSize: true,
    widows: true,
    zIndex: true,
    zoom: true,
    // SVG-related properties
    fillOpacity: true,
    floodOpacity: true,
    stopOpacity: true,
    strokeDasharray: true,
    strokeDashoffset: true,
    strokeMiterlimit: true,
    strokeOpacity: true,
    strokeWidth: true
};
var prefixKey = (prefix, key)=>prefix + key.charAt(0).toUpperCase() + key.substring(1);
var prefixes = [
    "Webkit",
    "Ms",
    "Moz",
    "O"
];
isUnitlessNumber = Object.keys(isUnitlessNumber).reduce((acc, prop)=>{
    prefixes.forEach((prefix)=>acc[prefixKey(prefix, prop)] = acc[prop]);
    return acc;
}, isUnitlessNumber);
var domTransforms = /^(matrix|translate|scale|rotate|skew)/;
var pxTransforms = /^(translate)/;
var degTransforms = /^(rotate|skew)/;
var addUnit = (value, unit)=>(0, _shared.is).num(value) && value !== 0 ? value + unit : value;
var isValueIdentity = (value, id)=>(0, _shared.is).arr(value) ? value.every((v)=>isValueIdentity(v, id)) : (0, _shared.is).num(value) ? value === id : parseFloat(value) === id;
var AnimatedStyle = class extends (0, _animated.AnimatedObject) {
    constructor({ x, y, z, ...style }){
        const inputs = [];
        const transforms = [];
        if (x || y || z) {
            inputs.push([
                x || 0,
                y || 0,
                z || 0
            ]);
            transforms.push((xyz)=>[
                    `translate3d(${xyz.map((v)=>addUnit(v, "px")).join(",")})`,
                    // prettier-ignore
                    isValueIdentity(xyz, 0)
                ]);
        }
        (0, _shared.eachProp)(style, (value, key)=>{
            if (key === "transform") {
                inputs.push([
                    value || ""
                ]);
                transforms.push((transform)=>[
                        transform,
                        transform === ""
                    ]);
            } else if (domTransforms.test(key)) {
                delete style[key];
                if ((0, _shared.is).und(value)) return;
                const unit = pxTransforms.test(key) ? "px" : degTransforms.test(key) ? "deg" : "";
                inputs.push((0, _shared.toArray)(value));
                transforms.push(key === "rotate3d" ? ([x2, y2, z2, deg])=>[
                        `rotate3d(${x2},${y2},${z2},${addUnit(deg, unit)})`,
                        isValueIdentity(deg, 0)
                    ] : (input)=>[
                        `${key}(${input.map((v)=>addUnit(v, unit)).join(",")})`,
                        isValueIdentity(input, key.startsWith("scale") ? 1 : 0)
                    ]);
            }
        });
        if (inputs.length) style.transform = new FluidTransform(inputs, transforms);
        super(style);
    }
};
var FluidTransform = class extends (0, _shared.FluidValue) {
    constructor(inputs, transforms){
        super();
        this.inputs = inputs;
        this.transforms = transforms;
        this._value = null;
    }
    get() {
        return this._value || (this._value = this._get());
    }
    _get() {
        let transform = "";
        let identity = true;
        (0, _shared.each)(this.inputs, (input, i)=>{
            const arg1 = (0, _shared.getFluidValue)(input[0]);
            const [t, id] = this.transforms[i]((0, _shared.is).arr(arg1) ? arg1 : input.map((0, _shared.getFluidValue)));
            transform += " " + t;
            identity = identity && id;
        });
        return identity ? "none" : transform;
    }
    // Start observing our inputs once we have an observer.
    observerAdded(count) {
        if (count == 1) (0, _shared.each)(this.inputs, (input)=>(0, _shared.each)(input, (value)=>(0, _shared.hasFluidValue)(value) && (0, _shared.addFluidObserver)(value, this)));
    }
    // Stop observing our inputs once we have no observers.
    observerRemoved(count) {
        if (count == 0) (0, _shared.each)(this.inputs, (input)=>(0, _shared.each)(input, (value)=>(0, _shared.hasFluidValue)(value) && (0, _shared.removeFluidObserver)(value, this)));
    }
    eventObserved(event) {
        if (event.type == "change") this._value = null;
        (0, _shared.callFluidObservers)(this, event);
    }
};
// src/primitives.ts
var primitives = [
    "a",
    "abbr",
    "address",
    "area",
    "article",
    "aside",
    "audio",
    "b",
    "base",
    "bdi",
    "bdo",
    "big",
    "blockquote",
    "body",
    "br",
    "button",
    "canvas",
    "caption",
    "cite",
    "code",
    "col",
    "colgroup",
    "data",
    "datalist",
    "dd",
    "del",
    "details",
    "dfn",
    "dialog",
    "div",
    "dl",
    "dt",
    "em",
    "embed",
    "fieldset",
    "figcaption",
    "figure",
    "footer",
    "form",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "head",
    "header",
    "hgroup",
    "hr",
    "html",
    "i",
    "iframe",
    "img",
    "input",
    "ins",
    "kbd",
    "keygen",
    "label",
    "legend",
    "li",
    "link",
    "main",
    "map",
    "mark",
    "menu",
    "menuitem",
    "meta",
    "meter",
    "nav",
    "noscript",
    "object",
    "ol",
    "optgroup",
    "option",
    "output",
    "p",
    "param",
    "picture",
    "pre",
    "progress",
    "q",
    "rp",
    "rt",
    "ruby",
    "s",
    "samp",
    "script",
    "section",
    "select",
    "small",
    "source",
    "span",
    "strong",
    "style",
    "sub",
    "summary",
    "sup",
    "table",
    "tbody",
    "td",
    "textarea",
    "tfoot",
    "th",
    "thead",
    "time",
    "title",
    "tr",
    "track",
    "u",
    "ul",
    "var",
    "video",
    "wbr",
    // SVG
    "circle",
    "clipPath",
    "defs",
    "ellipse",
    "foreignObject",
    "g",
    "image",
    "line",
    "linearGradient",
    "mask",
    "path",
    "pattern",
    "polygon",
    "polyline",
    "radialGradient",
    "rect",
    "stop",
    "svg",
    "text",
    "tspan"
];
(0, _core.Globals).assign({
    batchedUpdates: (0, _reactDom.unstable_batchedUpdates),
    createStringInterpolator: (0, _shared.createStringInterpolator),
    colors: (0, _shared.colors)
});
var host = (0, _animated.createHost)(primitives, {
    applyAnimatedValues,
    createAnimatedStyle: (style)=>new AnimatedStyle(style),
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    getComponentProps: ({ scrollTop, scrollLeft, ...props })=>props
});
var animated = host.animated;

},{"@react-spring/core":"aSh3B","react-dom":"b8T3j","@react-spring/shared":"byxMz","@react-spring/animated":"b9czT","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"aSh3B":[function(require,module,exports) {
// src/hooks/useChain.ts
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BailSignal", ()=>BailSignal);
parcelHelpers.export(exports, "Controller", ()=>Controller);
parcelHelpers.export(exports, "FrameValue", ()=>FrameValue);
parcelHelpers.export(exports, "Globals", ()=>(0, _shared.Globals));
parcelHelpers.export(exports, "Interpolation", ()=>Interpolation);
parcelHelpers.export(exports, "Spring", ()=>Spring);
parcelHelpers.export(exports, "SpringContext", ()=>SpringContext);
parcelHelpers.export(exports, "SpringRef", ()=>SpringRef);
parcelHelpers.export(exports, "SpringValue", ()=>SpringValue);
parcelHelpers.export(exports, "Trail", ()=>Trail);
parcelHelpers.export(exports, "Transition", ()=>Transition);
parcelHelpers.export(exports, "config", ()=>config);
parcelHelpers.export(exports, "createInterpolator", ()=>(0, _shared.createInterpolator));
parcelHelpers.export(exports, "easings", ()=>(0, _shared.easings));
parcelHelpers.export(exports, "inferTo", ()=>inferTo);
parcelHelpers.export(exports, "interpolate", ()=>interpolate);
parcelHelpers.export(exports, "to", ()=>to);
parcelHelpers.export(exports, "update", ()=>update);
parcelHelpers.export(exports, "useChain", ()=>useChain);
parcelHelpers.export(exports, "useInView", ()=>useInView);
parcelHelpers.export(exports, "useIsomorphicLayoutEffect", ()=>(0, _shared.useIsomorphicLayoutEffect));
parcelHelpers.export(exports, "useReducedMotion", ()=>(0, _shared.useReducedMotion));
parcelHelpers.export(exports, "useResize", ()=>useResize);
parcelHelpers.export(exports, "useScroll", ()=>useScroll);
parcelHelpers.export(exports, "useSpring", ()=>useSpring);
parcelHelpers.export(exports, "useSpringRef", ()=>useSpringRef);
parcelHelpers.export(exports, "useSpringValue", ()=>useSpringValue);
parcelHelpers.export(exports, "useSprings", ()=>useSprings);
parcelHelpers.export(exports, "useTrail", ()=>useTrail);
parcelHelpers.export(exports, "useTransition", ()=>useTransition);
var _shared = require("@react-spring/shared");
// src/hooks/useSprings.ts
var _react = require("react");
var _animated = require("@react-spring/animated");
var _types = require("@react-spring/types");
parcelHelpers.exportAll(_types, exports);
function callProp(value, ...args) {
    return (0, _shared.is).fun(value) ? value(...args) : value;
}
var matchProp = (value, key)=>value === true || !!(key && value && ((0, _shared.is).fun(value) ? value(key) : (0, _shared.toArray)(value).includes(key)));
var resolveProp = (prop, key)=>(0, _shared.is).obj(prop) ? key && prop[key] : prop;
var getDefaultProp = (props, key)=>props.default === true ? props[key] : props.default ? props.default[key] : void 0;
var noopTransform = (value)=>value;
var getDefaultProps = (props, transform = noopTransform)=>{
    let keys = DEFAULT_PROPS;
    if (props.default && props.default !== true) {
        props = props.default;
        keys = Object.keys(props);
    }
    const defaults2 = {};
    for (const key of keys){
        const value = transform(props[key], key);
        if (!(0, _shared.is).und(value)) defaults2[key] = value;
    }
    return defaults2;
};
var DEFAULT_PROPS = [
    "config",
    "onProps",
    "onStart",
    "onChange",
    "onPause",
    "onResume",
    "onRest"
];
var RESERVED_PROPS = {
    config: 1,
    from: 1,
    to: 1,
    ref: 1,
    loop: 1,
    reset: 1,
    pause: 1,
    cancel: 1,
    reverse: 1,
    immediate: 1,
    default: 1,
    delay: 1,
    onProps: 1,
    onStart: 1,
    onChange: 1,
    onPause: 1,
    onResume: 1,
    onRest: 1,
    onResolve: 1,
    // Transition props
    items: 1,
    trail: 1,
    sort: 1,
    expires: 1,
    initial: 1,
    enter: 1,
    update: 1,
    leave: 1,
    children: 1,
    onDestroyed: 1,
    // Internal props
    keys: 1,
    callId: 1,
    parentId: 1
};
function getForwardProps(props) {
    const forward = {};
    let count = 0;
    (0, _shared.eachProp)(props, (value, prop)=>{
        if (!RESERVED_PROPS[prop]) {
            forward[prop] = value;
            count++;
        }
    });
    if (count) return forward;
}
function inferTo(props) {
    const to2 = getForwardProps(props);
    if (to2) {
        const out = {
            to: to2
        };
        (0, _shared.eachProp)(props, (val, key)=>key in to2 || (out[key] = val));
        return out;
    }
    return {
        ...props
    };
}
function computeGoal(value) {
    value = (0, _shared.getFluidValue)(value);
    return (0, _shared.is).arr(value) ? value.map(computeGoal) : (0, _shared.isAnimatedString)(value) ? (0, _shared.Globals).createStringInterpolator({
        range: [
            0,
            1
        ],
        output: [
            value,
            value
        ]
    })(1) : value;
}
function hasProps(props) {
    for(const _ in props)return true;
    return false;
}
function isAsyncTo(to2) {
    return (0, _shared.is).fun(to2) || (0, _shared.is).arr(to2) && (0, _shared.is).obj(to2[0]);
}
function detachRefs(ctrl, ref) {
    ctrl.ref?.delete(ctrl);
    ref?.delete(ctrl);
}
function replaceRef(ctrl, ref) {
    if (ref && ctrl.ref !== ref) {
        ctrl.ref?.delete(ctrl);
        ref.add(ctrl);
        ctrl.ref = ref;
    }
}
// src/hooks/useChain.ts
function useChain(refs, timeSteps, timeFrame = 1e3) {
    (0, _shared.useIsomorphicLayoutEffect)(()=>{
        if (timeSteps) {
            let prevDelay = 0;
            (0, _shared.each)(refs, (ref, i)=>{
                const controllers = ref.current;
                if (controllers.length) {
                    let delay = timeFrame * timeSteps[i];
                    if (isNaN(delay)) delay = prevDelay;
                    else prevDelay = delay;
                    (0, _shared.each)(controllers, (ctrl)=>{
                        (0, _shared.each)(ctrl.queue, (props)=>{
                            const memoizedDelayProp = props.delay;
                            props.delay = (key)=>delay + callProp(memoizedDelayProp || 0, key);
                        });
                    });
                    ref.start();
                }
            });
        } else {
            let p = Promise.resolve();
            (0, _shared.each)(refs, (ref)=>{
                const controllers = ref.current;
                if (controllers.length) {
                    const queues = controllers.map((ctrl)=>{
                        const q = ctrl.queue;
                        ctrl.queue = [];
                        return q;
                    });
                    p = p.then(()=>{
                        (0, _shared.each)(controllers, (ctrl, i)=>(0, _shared.each)(queues[i] || [], (update2)=>ctrl.queue.push(update2)));
                        return Promise.all(ref.start());
                    });
                }
            });
        }
    });
}
// src/constants.ts
var config = {
    default: {
        tension: 170,
        friction: 26
    },
    gentle: {
        tension: 120,
        friction: 14
    },
    wobbly: {
        tension: 180,
        friction: 12
    },
    stiff: {
        tension: 210,
        friction: 20
    },
    slow: {
        tension: 280,
        friction: 60
    },
    molasses: {
        tension: 280,
        friction: 120
    }
};
// src/AnimationConfig.ts
var defaults = {
    ...config.default,
    mass: 1,
    damping: 1,
    easing: (0, _shared.easings).linear,
    clamp: false
};
var AnimationConfig = class {
    constructor(){
        /**
     * The initial velocity of one or more values.
     *
     * @default 0
     */ this.velocity = 0;
        Object.assign(this, defaults);
    }
};
function mergeConfig(config2, newConfig, defaultConfig) {
    if (defaultConfig) {
        defaultConfig = {
            ...defaultConfig
        };
        sanitizeConfig(defaultConfig, newConfig);
        newConfig = {
            ...defaultConfig,
            ...newConfig
        };
    }
    sanitizeConfig(config2, newConfig);
    Object.assign(config2, newConfig);
    for(const key in defaults)if (config2[key] == null) config2[key] = defaults[key];
    let { frequency, damping } = config2;
    const { mass } = config2;
    if (!(0, _shared.is).und(frequency)) {
        if (frequency < 0.01) frequency = 0.01;
        if (damping < 0) damping = 0;
        config2.tension = Math.pow(2 * Math.PI / frequency, 2) * mass;
        config2.friction = 4 * Math.PI * damping * mass / frequency;
    }
    return config2;
}
function sanitizeConfig(config2, props) {
    if (!(0, _shared.is).und(props.decay)) config2.duration = void 0;
    else {
        const isTensionConfig = !(0, _shared.is).und(props.tension) || !(0, _shared.is).und(props.friction);
        if (isTensionConfig || !(0, _shared.is).und(props.frequency) || !(0, _shared.is).und(props.damping) || !(0, _shared.is).und(props.mass)) {
            config2.duration = void 0;
            config2.decay = void 0;
        }
        if (isTensionConfig) config2.frequency = void 0;
    }
}
// src/Animation.ts
var emptyArray = [];
var Animation = class {
    constructor(){
        this.changed = false;
        this.values = emptyArray;
        this.toValues = null;
        this.fromValues = emptyArray;
        this.config = new AnimationConfig();
        this.immediate = false;
    }
};
function scheduleProps(callId, { key, props, defaultProps, state, actions }) {
    return new Promise((resolve, reject)=>{
        let delay;
        let timeout;
        let cancel = matchProp(props.cancel ?? defaultProps?.cancel, key);
        if (cancel) onStart();
        else {
            if (!(0, _shared.is).und(props.pause)) state.paused = matchProp(props.pause, key);
            let pause = defaultProps?.pause;
            if (pause !== true) pause = state.paused || matchProp(pause, key);
            delay = callProp(props.delay || 0, key);
            if (pause) {
                state.resumeQueue.add(onResume);
                actions.pause();
            } else {
                actions.resume();
                onResume();
            }
        }
        function onPause() {
            state.resumeQueue.add(onResume);
            state.timeouts.delete(timeout);
            timeout.cancel();
            delay = timeout.time - (0, _shared.raf).now();
        }
        function onResume() {
            if (delay > 0 && !(0, _shared.Globals).skipAnimation) {
                state.delayed = true;
                timeout = (0, _shared.raf).setTimeout(onStart, delay);
                state.pauseQueue.add(onPause);
                state.timeouts.add(timeout);
            } else onStart();
        }
        function onStart() {
            if (state.delayed) state.delayed = false;
            state.pauseQueue.delete(onPause);
            state.timeouts.delete(timeout);
            if (callId <= (state.cancelId || 0)) cancel = true;
            try {
                actions.start({
                    ...props,
                    callId,
                    cancel
                }, resolve);
            } catch (err) {
                reject(err);
            }
        }
    });
}
// src/AnimationResult.ts
var getCombinedResult = (target, results)=>results.length == 1 ? results[0] : results.some((result)=>result.cancelled) ? getCancelledResult(target.get()) : results.every((result)=>result.noop) ? getNoopResult(target.get()) : getFinishedResult(target.get(), results.every((result)=>result.finished));
var getNoopResult = (value)=>({
        value,
        noop: true,
        finished: true,
        cancelled: false
    });
var getFinishedResult = (value, finished, cancelled = false)=>({
        value,
        finished,
        cancelled
    });
var getCancelledResult = (value)=>({
        value,
        cancelled: true,
        finished: false
    });
// src/runAsync.ts
function runAsync(to2, props, state, target) {
    const { callId, parentId, onRest } = props;
    const { asyncTo: prevTo, promise: prevPromise } = state;
    if (!parentId && to2 === prevTo && !props.reset) return prevPromise;
    return state.promise = (async ()=>{
        state.asyncId = callId;
        state.asyncTo = to2;
        const defaultProps = getDefaultProps(props, (value, key)=>// The `onRest` prop is only called when the `runAsync` promise is resolved.
            key === "onRest" ? void 0 : value);
        let preventBail;
        let bail;
        const bailPromise = new Promise((resolve, reject)=>(preventBail = resolve, bail = reject));
        const bailIfEnded = (bailSignal)=>{
            const bailResult = // The `cancel` prop or `stop` method was used.
            callId <= (state.cancelId || 0) && getCancelledResult(target) || // The async `to` prop was replaced.
            callId !== state.asyncId && getFinishedResult(target, false);
            if (bailResult) {
                bailSignal.result = bailResult;
                bail(bailSignal);
                throw bailSignal;
            }
        };
        const animate = (arg1, arg2)=>{
            const bailSignal = new BailSignal();
            const skipAnimationSignal = new SkipAnimationSignal();
            return (async ()=>{
                if ((0, _shared.Globals).skipAnimation) {
                    stopAsync(state);
                    skipAnimationSignal.result = getFinishedResult(target, false);
                    bail(skipAnimationSignal);
                    throw skipAnimationSignal;
                }
                bailIfEnded(bailSignal);
                const props2 = (0, _shared.is).obj(arg1) ? {
                    ...arg1
                } : {
                    ...arg2,
                    to: arg1
                };
                props2.parentId = callId;
                (0, _shared.eachProp)(defaultProps, (value, key)=>{
                    if ((0, _shared.is).und(props2[key])) props2[key] = value;
                });
                const result2 = await target.start(props2);
                bailIfEnded(bailSignal);
                if (state.paused) await new Promise((resume)=>{
                    state.resumeQueue.add(resume);
                });
                return result2;
            })();
        };
        let result;
        if ((0, _shared.Globals).skipAnimation) {
            stopAsync(state);
            return getFinishedResult(target, false);
        }
        try {
            let animating;
            if ((0, _shared.is).arr(to2)) animating = (async (queue)=>{
                for (const props2 of queue)await animate(props2);
            })(to2);
            else animating = Promise.resolve(to2(animate, target.stop.bind(target)));
            await Promise.all([
                animating.then(preventBail),
                bailPromise
            ]);
            result = getFinishedResult(target.get(), true, false);
        } catch (err) {
            if (err instanceof BailSignal) result = err.result;
            else if (err instanceof SkipAnimationSignal) result = err.result;
            else throw err;
        } finally{
            if (callId == state.asyncId) {
                state.asyncId = parentId;
                state.asyncTo = parentId ? prevTo : void 0;
                state.promise = parentId ? prevPromise : void 0;
            }
        }
        if ((0, _shared.is).fun(onRest)) (0, _shared.raf).batchedUpdates(()=>{
            onRest(result, target, target.item);
        });
        return result;
    })();
}
function stopAsync(state, cancelId) {
    (0, _shared.flush)(state.timeouts, (t)=>t.cancel());
    state.pauseQueue.clear();
    state.resumeQueue.clear();
    state.asyncId = state.asyncTo = state.promise = void 0;
    if (cancelId) state.cancelId = cancelId;
}
var BailSignal = class extends Error {
    constructor(){
        super("An async animation has been interrupted. You see this error because you forgot to use `await` or `.catch(...)` on its returned promise.");
    }
};
var SkipAnimationSignal = class extends Error {
    constructor(){
        super("SkipAnimationSignal");
    }
};
var isFrameValue = (value)=>value instanceof FrameValue;
var nextId = 1;
var FrameValue = class extends (0, _shared.FluidValue) {
    constructor(){
        super(...arguments);
        this.id = nextId++;
        this._priority = 0;
    }
    get priority() {
        return this._priority;
    }
    set priority(priority) {
        if (this._priority != priority) {
            this._priority = priority;
            this._onPriorityChange(priority);
        }
    }
    /** Get the current value */ get() {
        const node = (0, _animated.getAnimated)(this);
        return node && node.getValue();
    }
    /** Create a spring that maps our value to another value */ to(...args) {
        return (0, _shared.Globals).to(this, args);
    }
    /** @deprecated Use the `to` method instead. */ interpolate(...args) {
        (0, _shared.deprecateInterpolate)();
        return (0, _shared.Globals).to(this, args);
    }
    toJSON() {
        return this.get();
    }
    observerAdded(count) {
        if (count == 1) this._attach();
    }
    observerRemoved(count) {
        if (count == 0) this._detach();
    }
    /** Called when the first child is added. */ _attach() {}
    /** Called when the last child is removed. */ _detach() {}
    /** Tell our children about our new value */ _onChange(value, idle = false) {
        (0, _shared.callFluidObservers)(this, {
            type: "change",
            parent: this,
            value,
            idle
        });
    }
    /** Tell our children about our new priority */ _onPriorityChange(priority) {
        if (!this.idle) (0, _shared.frameLoop).sort(this);
        (0, _shared.callFluidObservers)(this, {
            type: "priority",
            parent: this,
            priority
        });
    }
};
// src/SpringPhase.ts
var $P = Symbol.for("SpringPhase");
var HAS_ANIMATED = 1;
var IS_ANIMATING = 2;
var IS_PAUSED = 4;
var hasAnimated = (target)=>(target[$P] & HAS_ANIMATED) > 0;
var isAnimating = (target)=>(target[$P] & IS_ANIMATING) > 0;
var isPaused = (target)=>(target[$P] & IS_PAUSED) > 0;
var setActiveBit = (target, active)=>active ? target[$P] |= IS_ANIMATING | HAS_ANIMATED : target[$P] &= ~IS_ANIMATING;
var setPausedBit = (target, paused)=>paused ? target[$P] |= IS_PAUSED : target[$P] &= ~IS_PAUSED;
// src/SpringValue.ts
var SpringValue = class extends FrameValue {
    constructor(arg1, arg2){
        super();
        /** The animation state */ this.animation = new Animation();
        /** Some props have customizable default values */ this.defaultProps = {};
        /** The state for `runAsync` calls */ this._state = {
            paused: false,
            delayed: false,
            pauseQueue: /* @__PURE__ */ new Set(),
            resumeQueue: /* @__PURE__ */ new Set(),
            timeouts: /* @__PURE__ */ new Set()
        };
        /** The promise resolvers of pending `start` calls */ this._pendingCalls = /* @__PURE__ */ new Set();
        /** The counter for tracking `scheduleProps` calls */ this._lastCallId = 0;
        /** The last `scheduleProps` call that changed the `to` prop */ this._lastToId = 0;
        this._memoizedDuration = 0;
        if (!(0, _shared.is).und(arg1) || !(0, _shared.is).und(arg2)) {
            const props = (0, _shared.is).obj(arg1) ? {
                ...arg1
            } : {
                ...arg2,
                from: arg1
            };
            if ((0, _shared.is).und(props.default)) props.default = true;
            this.start(props);
        }
    }
    /** Equals true when not advancing on each frame. */ get idle() {
        return !(isAnimating(this) || this._state.asyncTo) || isPaused(this);
    }
    get goal() {
        return (0, _shared.getFluidValue)(this.animation.to);
    }
    get velocity() {
        const node = (0, _animated.getAnimated)(this);
        return node instanceof (0, _animated.AnimatedValue) ? node.lastVelocity || 0 : node.getPayload().map((node2)=>node2.lastVelocity || 0);
    }
    /**
   * When true, this value has been animated at least once.
   */ get hasAnimated() {
        return hasAnimated(this);
    }
    /**
   * When true, this value has an unfinished animation,
   * which is either active or paused.
   */ get isAnimating() {
        return isAnimating(this);
    }
    /**
   * When true, all current and future animations are paused.
   */ get isPaused() {
        return isPaused(this);
    }
    /**
   *
   *
   */ get isDelayed() {
        return this._state.delayed;
    }
    /** Advance the current animation by a number of milliseconds */ advance(dt) {
        let idle = true;
        let changed = false;
        const anim = this.animation;
        let { toValues } = anim;
        const { config: config2 } = anim;
        const payload = (0, _animated.getPayload)(anim.to);
        if (!payload && (0, _shared.hasFluidValue)(anim.to)) toValues = (0, _shared.toArray)((0, _shared.getFluidValue)(anim.to));
        anim.values.forEach((node2, i)=>{
            if (node2.done) return;
            const to2 = // Animated strings always go from 0 to 1.
            node2.constructor == (0, _animated.AnimatedString) ? 1 : payload ? payload[i].lastPosition : toValues[i];
            let finished = anim.immediate;
            let position = to2;
            if (!finished) {
                position = node2.lastPosition;
                if (config2.tension <= 0) {
                    node2.done = true;
                    return;
                }
                let elapsed = node2.elapsedTime += dt;
                const from = anim.fromValues[i];
                const v0 = node2.v0 != null ? node2.v0 : node2.v0 = (0, _shared.is).arr(config2.velocity) ? config2.velocity[i] : config2.velocity;
                let velocity;
                const precision = config2.precision || (from == to2 ? 5e-3 : Math.min(1, Math.abs(to2 - from) * 1e-3));
                if (!(0, _shared.is).und(config2.duration)) {
                    let p = 1;
                    if (config2.duration > 0) {
                        if (this._memoizedDuration !== config2.duration) {
                            this._memoizedDuration = config2.duration;
                            if (node2.durationProgress > 0) {
                                node2.elapsedTime = config2.duration * node2.durationProgress;
                                elapsed = node2.elapsedTime += dt;
                            }
                        }
                        p = (config2.progress || 0) + elapsed / this._memoizedDuration;
                        p = p > 1 ? 1 : p < 0 ? 0 : p;
                        node2.durationProgress = p;
                    }
                    position = from + config2.easing(p) * (to2 - from);
                    velocity = (position - node2.lastPosition) / dt;
                    finished = p == 1;
                } else if (config2.decay) {
                    const decay = config2.decay === true ? 0.998 : config2.decay;
                    const e = Math.exp(-(1 - decay) * elapsed);
                    position = from + v0 / (1 - decay) * (1 - e);
                    finished = Math.abs(node2.lastPosition - position) <= precision;
                    velocity = v0 * e;
                } else {
                    velocity = node2.lastVelocity == null ? v0 : node2.lastVelocity;
                    const restVelocity = config2.restVelocity || precision / 10;
                    const bounceFactor = config2.clamp ? 0 : config2.bounce;
                    const canBounce = !(0, _shared.is).und(bounceFactor);
                    const isGrowing = from == to2 ? node2.v0 > 0 : from < to2;
                    let isMoving;
                    let isBouncing = false;
                    const step = 1;
                    const numSteps = Math.ceil(dt / step);
                    for(let n = 0; n < numSteps; ++n){
                        isMoving = Math.abs(velocity) > restVelocity;
                        if (!isMoving) {
                            finished = Math.abs(to2 - position) <= precision;
                            if (finished) break;
                        }
                        if (canBounce) {
                            isBouncing = position == to2 || position > to2 == isGrowing;
                            if (isBouncing) {
                                velocity = -velocity * bounceFactor;
                                position = to2;
                            }
                        }
                        const springForce = -config2.tension * 1e-6 * (position - to2);
                        const dampingForce = -config2.friction * 1e-3 * velocity;
                        const acceleration = (springForce + dampingForce) / config2.mass;
                        velocity = velocity + acceleration * step;
                        position = position + velocity * step;
                    }
                }
                node2.lastVelocity = velocity;
                if (Number.isNaN(position)) {
                    console.warn(`Got NaN while animating:`, this);
                    finished = true;
                }
            }
            if (payload && !payload[i].done) finished = false;
            if (finished) node2.done = true;
            else idle = false;
            if (node2.setValue(position, config2.round)) changed = true;
        });
        const node = (0, _animated.getAnimated)(this);
        const currVal = node.getValue();
        if (idle) {
            const finalVal = (0, _shared.getFluidValue)(anim.to);
            if ((currVal !== finalVal || changed) && !config2.decay) {
                node.setValue(finalVal);
                this._onChange(finalVal);
            } else if (changed && config2.decay) this._onChange(currVal);
            this._stop();
        } else if (changed) this._onChange(currVal);
    }
    /** Set the current value, while stopping the current animation */ set(value) {
        (0, _shared.raf).batchedUpdates(()=>{
            this._stop();
            this._focus(value);
            this._set(value);
        });
        return this;
    }
    /**
   * Freeze the active animation in time, as well as any updates merged
   * before `resume` is called.
   */ pause() {
        this._update({
            pause: true
        });
    }
    /** Resume the animation if paused. */ resume() {
        this._update({
            pause: false
        });
    }
    /** Skip to the end of the current animation. */ finish() {
        if (isAnimating(this)) {
            const { to: to2, config: config2 } = this.animation;
            (0, _shared.raf).batchedUpdates(()=>{
                this._onStart();
                if (!config2.decay) this._set(to2, false);
                this._stop();
            });
        }
        return this;
    }
    /** Push props into the pending queue. */ update(props) {
        const queue = this.queue || (this.queue = []);
        queue.push(props);
        return this;
    }
    start(to2, arg2) {
        let queue;
        if (!(0, _shared.is).und(to2)) queue = [
            (0, _shared.is).obj(to2) ? to2 : {
                ...arg2,
                to: to2
            }
        ];
        else {
            queue = this.queue || [];
            this.queue = [];
        }
        return Promise.all(queue.map((props)=>{
            const up = this._update(props);
            return up;
        })).then((results)=>getCombinedResult(this, results));
    }
    /**
   * Stop the current animation, and cancel any delayed updates.
   *
   * Pass `true` to call `onRest` with `cancelled: true`.
   */ stop(cancel) {
        const { to: to2 } = this.animation;
        this._focus(this.get());
        stopAsync(this._state, cancel && this._lastCallId);
        (0, _shared.raf).batchedUpdates(()=>this._stop(to2, cancel));
        return this;
    }
    /** Restart the animation. */ reset() {
        this._update({
            reset: true
        });
    }
    /** @internal */ eventObserved(event) {
        if (event.type == "change") this._start();
        else if (event.type == "priority") this.priority = event.priority + 1;
    }
    /**
   * Parse the `to` and `from` range from the given `props` object.
   *
   * This also ensures the initial value is available to animated components
   * during the render phase.
   */ _prepareNode(props) {
        const key = this.key || "";
        let { to: to2, from } = props;
        to2 = (0, _shared.is).obj(to2) ? to2[key] : to2;
        if (to2 == null || isAsyncTo(to2)) to2 = void 0;
        from = (0, _shared.is).obj(from) ? from[key] : from;
        if (from == null) from = void 0;
        const range = {
            to: to2,
            from
        };
        if (!hasAnimated(this)) {
            if (props.reverse) [to2, from] = [
                from,
                to2
            ];
            from = (0, _shared.getFluidValue)(from);
            if (!(0, _shared.is).und(from)) this._set(from);
            else if (!(0, _animated.getAnimated)(this)) this._set(to2);
        }
        return range;
    }
    /** Every update is processed by this method before merging. */ _update({ ...props }, isLoop) {
        const { key, defaultProps } = this;
        if (props.default) Object.assign(defaultProps, getDefaultProps(props, (value, prop)=>/^on/.test(prop) ? resolveProp(value, key) : value));
        mergeActiveFn(this, props, "onProps");
        sendEvent(this, "onProps", props, this);
        const range = this._prepareNode(props);
        if (Object.isFrozen(this)) throw Error("Cannot animate a `SpringValue` object that is frozen. Did you forget to pass your component to `animated(...)` before animating its props?");
        const state = this._state;
        return scheduleProps(++this._lastCallId, {
            key,
            props,
            defaultProps,
            state,
            actions: {
                pause: ()=>{
                    if (!isPaused(this)) {
                        setPausedBit(this, true);
                        (0, _shared.flushCalls)(state.pauseQueue);
                        sendEvent(this, "onPause", getFinishedResult(this, checkFinished(this, this.animation.to)), this);
                    }
                },
                resume: ()=>{
                    if (isPaused(this)) {
                        setPausedBit(this, false);
                        if (isAnimating(this)) this._resume();
                        (0, _shared.flushCalls)(state.resumeQueue);
                        sendEvent(this, "onResume", getFinishedResult(this, checkFinished(this, this.animation.to)), this);
                    }
                },
                start: this._merge.bind(this, range)
            }
        }).then((result)=>{
            if (props.loop && result.finished && !(isLoop && result.noop)) {
                const nextProps = createLoopUpdate(props);
                if (nextProps) return this._update(nextProps, true);
            }
            return result;
        });
    }
    /** Merge props into the current animation */ _merge(range, props, resolve) {
        if (props.cancel) {
            this.stop(true);
            return resolve(getCancelledResult(this));
        }
        const hasToProp = !(0, _shared.is).und(range.to);
        const hasFromProp = !(0, _shared.is).und(range.from);
        if (hasToProp || hasFromProp) {
            if (props.callId > this._lastToId) this._lastToId = props.callId;
            else return resolve(getCancelledResult(this));
        }
        const { key, defaultProps, animation: anim } = this;
        const { to: prevTo, from: prevFrom } = anim;
        let { to: to2 = prevTo, from = prevFrom } = range;
        if (hasFromProp && !hasToProp && (!props.default || (0, _shared.is).und(to2))) to2 = from;
        if (props.reverse) [to2, from] = [
            from,
            to2
        ];
        const hasFromChanged = !(0, _shared.isEqual)(from, prevFrom);
        if (hasFromChanged) anim.from = from;
        from = (0, _shared.getFluidValue)(from);
        const hasToChanged = !(0, _shared.isEqual)(to2, prevTo);
        if (hasToChanged) this._focus(to2);
        const hasAsyncTo = isAsyncTo(props.to);
        const { config: config2 } = anim;
        const { decay, velocity } = config2;
        if (hasToProp || hasFromProp) config2.velocity = 0;
        if (props.config && !hasAsyncTo) mergeConfig(config2, callProp(props.config, key), // Avoid calling the same "config" prop twice.
        props.config !== defaultProps.config ? callProp(defaultProps.config, key) : void 0);
        let node = (0, _animated.getAnimated)(this);
        if (!node || (0, _shared.is).und(to2)) return resolve(getFinishedResult(this, true));
        const reset = // When `reset` is undefined, the `from` prop implies `reset: true`,
        // except for declarative updates. When `reset` is defined, there
        // must exist a value to animate from.
        (0, _shared.is).und(props.reset) ? hasFromProp && !props.default : !(0, _shared.is).und(from) && matchProp(props.reset, key);
        const value = reset ? from : this.get();
        const goal = computeGoal(to2);
        const isAnimatable = (0, _shared.is).num(goal) || (0, _shared.is).arr(goal) || (0, _shared.isAnimatedString)(goal);
        const immediate = !hasAsyncTo && (!isAnimatable || matchProp(defaultProps.immediate || props.immediate, key));
        if (hasToChanged) {
            const nodeType = (0, _animated.getAnimatedType)(to2);
            if (nodeType !== node.constructor) {
                if (immediate) node = this._set(goal);
                else throw Error(`Cannot animate between ${node.constructor.name} and ${nodeType.name}, as the "to" prop suggests`);
            }
        }
        const goalType = node.constructor;
        let started = (0, _shared.hasFluidValue)(to2);
        let finished = false;
        if (!started) {
            const hasValueChanged = reset || !hasAnimated(this) && hasFromChanged;
            if (hasToChanged || hasValueChanged) {
                finished = (0, _shared.isEqual)(computeGoal(value), goal);
                started = !finished;
            }
            if (!(0, _shared.isEqual)(anim.immediate, immediate) && !immediate || !(0, _shared.isEqual)(config2.decay, decay) || !(0, _shared.isEqual)(config2.velocity, velocity)) started = true;
        }
        if (finished && isAnimating(this)) {
            if (anim.changed && !reset) started = true;
            else if (!started) this._stop(prevTo);
        }
        if (!hasAsyncTo) {
            if (started || (0, _shared.hasFluidValue)(prevTo)) {
                anim.values = node.getPayload();
                anim.toValues = (0, _shared.hasFluidValue)(to2) ? null : goalType == (0, _animated.AnimatedString) ? [
                    1
                ] : (0, _shared.toArray)(goal);
            }
            if (anim.immediate != immediate) {
                anim.immediate = immediate;
                if (!immediate && !reset) this._set(prevTo);
            }
            if (started) {
                const { onRest } = anim;
                (0, _shared.each)(ACTIVE_EVENTS, (type)=>mergeActiveFn(this, props, type));
                const result = getFinishedResult(this, checkFinished(this, prevTo));
                (0, _shared.flushCalls)(this._pendingCalls, result);
                this._pendingCalls.add(resolve);
                if (anim.changed) (0, _shared.raf).batchedUpdates(()=>{
                    anim.changed = !reset;
                    onRest?.(result, this);
                    if (reset) callProp(defaultProps.onRest, result);
                    else anim.onStart?.(result, this);
                });
            }
        }
        if (reset) this._set(value);
        if (hasAsyncTo) resolve(runAsync(props.to, props, this._state, this));
        else if (started) this._start();
        else if (isAnimating(this) && !hasToChanged) this._pendingCalls.add(resolve);
        else resolve(getNoopResult(value));
    }
    /** Update the `animation.to` value, which might be a `FluidValue` */ _focus(value) {
        const anim = this.animation;
        if (value !== anim.to) {
            if ((0, _shared.getFluidObservers)(this)) this._detach();
            anim.to = value;
            if ((0, _shared.getFluidObservers)(this)) this._attach();
        }
    }
    _attach() {
        let priority = 0;
        const { to: to2 } = this.animation;
        if ((0, _shared.hasFluidValue)(to2)) {
            (0, _shared.addFluidObserver)(to2, this);
            if (isFrameValue(to2)) priority = to2.priority + 1;
        }
        this.priority = priority;
    }
    _detach() {
        const { to: to2 } = this.animation;
        if ((0, _shared.hasFluidValue)(to2)) (0, _shared.removeFluidObserver)(to2, this);
    }
    /**
   * Update the current value from outside the frameloop,
   * and return the `Animated` node.
   */ _set(arg, idle = true) {
        const value = (0, _shared.getFluidValue)(arg);
        if (!(0, _shared.is).und(value)) {
            const oldNode = (0, _animated.getAnimated)(this);
            if (!oldNode || !(0, _shared.isEqual)(value, oldNode.getValue())) {
                const nodeType = (0, _animated.getAnimatedType)(value);
                if (!oldNode || oldNode.constructor != nodeType) (0, _animated.setAnimated)(this, nodeType.create(value));
                else oldNode.setValue(value);
                if (oldNode) (0, _shared.raf).batchedUpdates(()=>{
                    this._onChange(value, idle);
                });
            }
        }
        return (0, _animated.getAnimated)(this);
    }
    _onStart() {
        const anim = this.animation;
        if (!anim.changed) {
            anim.changed = true;
            sendEvent(this, "onStart", getFinishedResult(this, checkFinished(this, anim.to)), this);
        }
    }
    _onChange(value, idle) {
        if (!idle) {
            this._onStart();
            callProp(this.animation.onChange, value, this);
        }
        callProp(this.defaultProps.onChange, value, this);
        super._onChange(value, idle);
    }
    // This method resets the animation state (even if already animating) to
    // ensure the latest from/to range is used, and it also ensures this spring
    // is added to the frameloop.
    _start() {
        const anim = this.animation;
        (0, _animated.getAnimated)(this).reset((0, _shared.getFluidValue)(anim.to));
        if (!anim.immediate) anim.fromValues = anim.values.map((node)=>node.lastPosition);
        if (!isAnimating(this)) {
            setActiveBit(this, true);
            if (!isPaused(this)) this._resume();
        }
    }
    _resume() {
        if ((0, _shared.Globals).skipAnimation) this.finish();
        else (0, _shared.frameLoop).start(this);
    }
    /**
   * Exit the frameloop and notify `onRest` listeners.
   *
   * Always wrap `_stop` calls with `batchedUpdates`.
   */ _stop(goal, cancel) {
        if (isAnimating(this)) {
            setActiveBit(this, false);
            const anim = this.animation;
            (0, _shared.each)(anim.values, (node)=>{
                node.done = true;
            });
            if (anim.toValues) anim.onChange = anim.onPause = anim.onResume = void 0;
            (0, _shared.callFluidObservers)(this, {
                type: "idle",
                parent: this
            });
            const result = cancel ? getCancelledResult(this.get()) : getFinishedResult(this.get(), checkFinished(this, goal ?? anim.to));
            (0, _shared.flushCalls)(this._pendingCalls, result);
            if (anim.changed) {
                anim.changed = false;
                sendEvent(this, "onRest", result, this);
            }
        }
    }
};
function checkFinished(target, to2) {
    const goal = computeGoal(to2);
    const value = computeGoal(target.get());
    return (0, _shared.isEqual)(value, goal);
}
function createLoopUpdate(props, loop = props.loop, to2 = props.to) {
    const loopRet = callProp(loop);
    if (loopRet) {
        const overrides = loopRet !== true && inferTo(loopRet);
        const reverse = (overrides || props).reverse;
        const reset = !overrides || overrides.reset;
        return createUpdate({
            ...props,
            loop,
            // Avoid updating default props when looping.
            default: false,
            // Never loop the `pause` prop.
            pause: void 0,
            // For the "reverse" prop to loop as expected, the "to" prop
            // must be undefined. The "reverse" prop is ignored when the
            // "to" prop is an array or function.
            to: !reverse || isAsyncTo(to2) ? to2 : void 0,
            // Ignore the "from" prop except on reset.
            from: reset ? props.from : void 0,
            reset,
            // The "loop" prop can return a "useSpring" props object to
            // override any of the original props.
            ...overrides
        });
    }
}
function createUpdate(props) {
    const { to: to2, from } = props = inferTo(props);
    const keys = /* @__PURE__ */ new Set();
    if ((0, _shared.is).obj(to2)) findDefined(to2, keys);
    if ((0, _shared.is).obj(from)) findDefined(from, keys);
    props.keys = keys.size ? Array.from(keys) : null;
    return props;
}
function declareUpdate(props) {
    const update2 = createUpdate(props);
    if ((0, _shared.is).und(update2.default)) update2.default = getDefaultProps(update2);
    return update2;
}
function findDefined(values, keys) {
    (0, _shared.eachProp)(values, (value, key)=>value != null && keys.add(key));
}
var ACTIVE_EVENTS = [
    "onStart",
    "onRest",
    "onChange",
    "onPause",
    "onResume"
];
function mergeActiveFn(target, props, type) {
    target.animation[type] = props[type] !== getDefaultProp(props, type) ? resolveProp(props[type], target.key) : void 0;
}
function sendEvent(target, type, ...args) {
    target.animation[type]?.(...args);
    target.defaultProps[type]?.(...args);
}
var BATCHED_EVENTS = [
    "onStart",
    "onChange",
    "onRest"
];
var nextId2 = 1;
var Controller = class {
    constructor(props, flush3){
        this.id = nextId2++;
        /** The animated values */ this.springs = {};
        /** The queue of props passed to the `update` method. */ this.queue = [];
        /** The counter for tracking `scheduleProps` calls */ this._lastAsyncId = 0;
        /** The values currently being animated */ this._active = /* @__PURE__ */ new Set();
        /** The values that changed recently */ this._changed = /* @__PURE__ */ new Set();
        /** Equals false when `onStart` listeners can be called */ this._started = false;
        /** State used by the `runAsync` function */ this._state = {
            paused: false,
            pauseQueue: /* @__PURE__ */ new Set(),
            resumeQueue: /* @__PURE__ */ new Set(),
            timeouts: /* @__PURE__ */ new Set()
        };
        /** The event queues that are flushed once per frame maximum */ this._events = {
            onStart: /* @__PURE__ */ new Map(),
            onChange: /* @__PURE__ */ new Map(),
            onRest: /* @__PURE__ */ new Map()
        };
        this._onFrame = this._onFrame.bind(this);
        if (flush3) this._flush = flush3;
        if (props) this.start({
            default: true,
            ...props
        });
    }
    /**
   * Equals `true` when no spring values are in the frameloop, and
   * no async animation is currently active.
   */ get idle() {
        return !this._state.asyncTo && Object.values(this.springs).every((spring)=>{
            return spring.idle && !spring.isDelayed && !spring.isPaused;
        });
    }
    get item() {
        return this._item;
    }
    set item(item) {
        this._item = item;
    }
    /** Get the current values of our springs */ get() {
        const values = {};
        this.each((spring, key)=>values[key] = spring.get());
        return values;
    }
    /** Set the current values without animating. */ set(values) {
        for(const key in values){
            const value = values[key];
            if (!(0, _shared.is).und(value)) this.springs[key].set(value);
        }
    }
    /** Push an update onto the queue of each value. */ update(props) {
        if (props) this.queue.push(createUpdate(props));
        return this;
    }
    /**
   * Start the queued animations for every spring, and resolve the returned
   * promise once all queued animations have finished or been cancelled.
   *
   * When you pass a queue (instead of nothing), that queue is used instead of
   * the queued animations added with the `update` method, which are left alone.
   */ start(props) {
        let { queue } = this;
        if (props) queue = (0, _shared.toArray)(props).map(createUpdate);
        else this.queue = [];
        if (this._flush) return this._flush(this, queue);
        prepareKeys(this, queue);
        return flushUpdateQueue(this, queue);
    }
    /** @internal */ stop(arg, keys) {
        if (arg !== !!arg) keys = arg;
        if (keys) {
            const springs = this.springs;
            (0, _shared.each)((0, _shared.toArray)(keys), (key)=>springs[key].stop(!!arg));
        } else {
            stopAsync(this._state, this._lastAsyncId);
            this.each((spring)=>spring.stop(!!arg));
        }
        return this;
    }
    /** Freeze the active animation in time */ pause(keys) {
        if ((0, _shared.is).und(keys)) this.start({
            pause: true
        });
        else {
            const springs = this.springs;
            (0, _shared.each)((0, _shared.toArray)(keys), (key)=>springs[key].pause());
        }
        return this;
    }
    /** Resume the animation if paused. */ resume(keys) {
        if ((0, _shared.is).und(keys)) this.start({
            pause: false
        });
        else {
            const springs = this.springs;
            (0, _shared.each)((0, _shared.toArray)(keys), (key)=>springs[key].resume());
        }
        return this;
    }
    /** Call a function once per spring value */ each(iterator) {
        (0, _shared.eachProp)(this.springs, iterator);
    }
    /** @internal Called at the end of every animation frame */ _onFrame() {
        const { onStart, onChange, onRest } = this._events;
        const active = this._active.size > 0;
        const changed = this._changed.size > 0;
        if (active && !this._started || changed && !this._started) {
            this._started = true;
            (0, _shared.flush)(onStart, ([onStart2, result])=>{
                result.value = this.get();
                onStart2(result, this, this._item);
            });
        }
        const idle = !active && this._started;
        const values = changed || idle && onRest.size ? this.get() : null;
        if (changed && onChange.size) (0, _shared.flush)(onChange, ([onChange2, result])=>{
            result.value = values;
            onChange2(result, this, this._item);
        });
        if (idle) {
            this._started = false;
            (0, _shared.flush)(onRest, ([onRest2, result])=>{
                result.value = values;
                onRest2(result, this, this._item);
            });
        }
    }
    /** @internal */ eventObserved(event) {
        if (event.type == "change") {
            this._changed.add(event.parent);
            if (!event.idle) this._active.add(event.parent);
        } else if (event.type == "idle") this._active.delete(event.parent);
        else return;
        (0, _shared.raf).onFrame(this._onFrame);
    }
};
function flushUpdateQueue(ctrl, queue) {
    return Promise.all(queue.map((props)=>flushUpdate(ctrl, props))).then((results)=>getCombinedResult(ctrl, results));
}
async function flushUpdate(ctrl, props, isLoop) {
    const { keys, to: to2, from, loop, onRest, onResolve } = props;
    const defaults2 = (0, _shared.is).obj(props.default) && props.default;
    if (loop) props.loop = false;
    if (to2 === false) props.to = null;
    if (from === false) props.from = null;
    const asyncTo = (0, _shared.is).arr(to2) || (0, _shared.is).fun(to2) ? to2 : void 0;
    if (asyncTo) {
        props.to = void 0;
        props.onRest = void 0;
        if (defaults2) defaults2.onRest = void 0;
    } else (0, _shared.each)(BATCHED_EVENTS, (key)=>{
        const handler = props[key];
        if ((0, _shared.is).fun(handler)) {
            const queue = ctrl["_events"][key];
            props[key] = ({ finished, cancelled })=>{
                const result2 = queue.get(handler);
                if (result2) {
                    if (!finished) result2.finished = false;
                    if (cancelled) result2.cancelled = true;
                } else queue.set(handler, {
                    value: null,
                    finished: finished || false,
                    cancelled: cancelled || false
                });
            };
            if (defaults2) defaults2[key] = props[key];
        }
    });
    const state = ctrl["_state"];
    if (props.pause === !state.paused) {
        state.paused = props.pause;
        (0, _shared.flushCalls)(props.pause ? state.pauseQueue : state.resumeQueue);
    } else if (state.paused) props.pause = true;
    const promises = (keys || Object.keys(ctrl.springs)).map((key)=>ctrl.springs[key].start(props));
    const cancel = props.cancel === true || getDefaultProp(props, "cancel") === true;
    if (asyncTo || cancel && state.asyncId) promises.push(scheduleProps(++ctrl["_lastAsyncId"], {
        props,
        state,
        actions: {
            pause: (0, _shared.noop),
            resume: (0, _shared.noop),
            start (props2, resolve) {
                if (cancel) {
                    stopAsync(state, ctrl["_lastAsyncId"]);
                    resolve(getCancelledResult(ctrl));
                } else {
                    props2.onRest = onRest;
                    resolve(runAsync(asyncTo, props2, state, ctrl));
                }
            }
        }
    }));
    if (state.paused) await new Promise((resume)=>{
        state.resumeQueue.add(resume);
    });
    const result = getCombinedResult(ctrl, await Promise.all(promises));
    if (loop && result.finished && !(isLoop && result.noop)) {
        const nextProps = createLoopUpdate(props, loop, to2);
        if (nextProps) {
            prepareKeys(ctrl, [
                nextProps
            ]);
            return flushUpdate(ctrl, nextProps, true);
        }
    }
    if (onResolve) (0, _shared.raf).batchedUpdates(()=>onResolve(result, ctrl, ctrl.item));
    return result;
}
function getSprings(ctrl, props) {
    const springs = {
        ...ctrl.springs
    };
    if (props) (0, _shared.each)((0, _shared.toArray)(props), (props2)=>{
        if ((0, _shared.is).und(props2.keys)) props2 = createUpdate(props2);
        if (!(0, _shared.is).obj(props2.to)) props2 = {
            ...props2,
            to: void 0
        };
        prepareSprings(springs, props2, (key)=>{
            return createSpring(key);
        });
    });
    setSprings(ctrl, springs);
    return springs;
}
function setSprings(ctrl, springs) {
    (0, _shared.eachProp)(springs, (spring, key)=>{
        if (!ctrl.springs[key]) {
            ctrl.springs[key] = spring;
            (0, _shared.addFluidObserver)(spring, ctrl);
        }
    });
}
function createSpring(key, observer) {
    const spring = new SpringValue();
    spring.key = key;
    if (observer) (0, _shared.addFluidObserver)(spring, observer);
    return spring;
}
function prepareSprings(springs, props, create) {
    if (props.keys) (0, _shared.each)(props.keys, (key)=>{
        const spring = springs[key] || (springs[key] = create(key));
        spring["_prepareNode"](props);
    });
}
function prepareKeys(ctrl, queue) {
    (0, _shared.each)(queue, (props)=>{
        prepareSprings(ctrl.springs, props, (key)=>{
            return createSpring(key, ctrl);
        });
    });
}
var SpringContext = ({ children, ...props })=>{
    const inherited = (0, _react.useContext)(ctx);
    const pause = props.pause || !!inherited.pause, immediate = props.immediate || !!inherited.immediate;
    props = (0, _shared.useMemoOne)(()=>({
            pause,
            immediate
        }), [
        pause,
        immediate
    ]);
    const { Provider } = ctx;
    return /* @__PURE__ */ _react.createElement(Provider, {
        value: props
    }, children);
};
var ctx = makeContext(SpringContext, {});
SpringContext.Provider = ctx.Provider;
SpringContext.Consumer = ctx.Consumer;
function makeContext(target, init) {
    Object.assign(target, _react.createContext(init));
    target.Provider._context = target;
    target.Consumer._context = target;
    return target;
}
var SpringRef = ()=>{
    const current = [];
    const SpringRef2 = function(props) {
        (0, _shared.deprecateDirectCall)();
        const results = [];
        (0, _shared.each)(current, (ctrl, i)=>{
            if ((0, _shared.is).und(props)) results.push(ctrl.start());
            else {
                const update2 = _getProps(props, ctrl, i);
                if (update2) results.push(ctrl.start(update2));
            }
        });
        return results;
    };
    SpringRef2.current = current;
    SpringRef2.add = function(ctrl) {
        if (!current.includes(ctrl)) current.push(ctrl);
    };
    SpringRef2.delete = function(ctrl) {
        const i = current.indexOf(ctrl);
        if (~i) current.splice(i, 1);
    };
    SpringRef2.pause = function() {
        (0, _shared.each)(current, (ctrl)=>ctrl.pause(...arguments));
        return this;
    };
    SpringRef2.resume = function() {
        (0, _shared.each)(current, (ctrl)=>ctrl.resume(...arguments));
        return this;
    };
    SpringRef2.set = function(values) {
        (0, _shared.each)(current, (ctrl, i)=>{
            const update2 = (0, _shared.is).fun(values) ? values(i, ctrl) : values;
            if (update2) ctrl.set(update2);
        });
    };
    SpringRef2.start = function(props) {
        const results = [];
        (0, _shared.each)(current, (ctrl, i)=>{
            if ((0, _shared.is).und(props)) results.push(ctrl.start());
            else {
                const update2 = this._getProps(props, ctrl, i);
                if (update2) results.push(ctrl.start(update2));
            }
        });
        return results;
    };
    SpringRef2.stop = function() {
        (0, _shared.each)(current, (ctrl)=>ctrl.stop(...arguments));
        return this;
    };
    SpringRef2.update = function(props) {
        (0, _shared.each)(current, (ctrl, i)=>ctrl.update(this._getProps(props, ctrl, i)));
        return this;
    };
    const _getProps = function(arg, ctrl, index) {
        return (0, _shared.is).fun(arg) ? arg(index, ctrl) : arg;
    };
    SpringRef2._getProps = _getProps;
    return SpringRef2;
};
// src/hooks/useSprings.ts
function useSprings(length, props, deps) {
    const propsFn = (0, _shared.is).fun(props) && props;
    if (propsFn && !deps) deps = [];
    const ref = (0, _react.useMemo)(()=>propsFn || arguments.length == 3 ? SpringRef() : void 0, []);
    const layoutId = (0, _react.useRef)(0);
    const forceUpdate = (0, _shared.useForceUpdate)();
    const state = (0, _react.useMemo)(()=>({
            ctrls: [],
            queue: [],
            flush (ctrl, updates2) {
                const springs2 = getSprings(ctrl, updates2);
                const canFlushSync = layoutId.current > 0 && !state.queue.length && !Object.keys(springs2).some((key)=>!ctrl.springs[key]);
                return canFlushSync ? flushUpdateQueue(ctrl, updates2) : new Promise((resolve)=>{
                    setSprings(ctrl, springs2);
                    state.queue.push(()=>{
                        resolve(flushUpdateQueue(ctrl, updates2));
                    });
                    forceUpdate();
                });
            }
        }), []);
    const ctrls = (0, _react.useRef)([
        ...state.ctrls
    ]);
    const updates = [];
    const prevLength = (0, _shared.usePrev)(length) || 0;
    (0, _react.useMemo)(()=>{
        (0, _shared.each)(ctrls.current.slice(length, prevLength), (ctrl)=>{
            detachRefs(ctrl, ref);
            ctrl.stop(true);
        });
        ctrls.current.length = length;
        declareUpdates(prevLength, length);
    }, [
        length
    ]);
    (0, _react.useMemo)(()=>{
        declareUpdates(0, Math.min(prevLength, length));
    }, deps);
    function declareUpdates(startIndex, endIndex) {
        for(let i = startIndex; i < endIndex; i++){
            const ctrl = ctrls.current[i] || (ctrls.current[i] = new Controller(null, state.flush));
            const update2 = propsFn ? propsFn(i, ctrl) : props[i];
            if (update2) updates[i] = declareUpdate(update2);
        }
    }
    const springs = ctrls.current.map((ctrl, i)=>getSprings(ctrl, updates[i]));
    const context = (0, _react.useContext)(SpringContext);
    const prevContext = (0, _shared.usePrev)(context);
    const hasContext = context !== prevContext && hasProps(context);
    (0, _shared.useIsomorphicLayoutEffect)(()=>{
        layoutId.current++;
        state.ctrls = ctrls.current;
        const { queue } = state;
        if (queue.length) {
            state.queue = [];
            (0, _shared.each)(queue, (cb)=>cb());
        }
        (0, _shared.each)(ctrls.current, (ctrl, i)=>{
            ref?.add(ctrl);
            if (hasContext) ctrl.start({
                default: context
            });
            const update2 = updates[i];
            if (update2) {
                replaceRef(ctrl, update2.ref);
                if (ctrl.ref) ctrl.queue.push(update2);
                else ctrl.start(update2);
            }
        });
    });
    (0, _shared.useOnce)(()=>()=>{
            (0, _shared.each)(state.ctrls, (ctrl)=>ctrl.stop(true));
        });
    const values = springs.map((x)=>({
            ...x
        }));
    return ref ? [
        values,
        ref
    ] : values;
}
// src/hooks/useSpring.ts
function useSpring(props, deps) {
    const isFn = (0, _shared.is).fun(props);
    const [[values], ref] = useSprings(1, isFn ? props : [
        props
    ], isFn ? deps || [] : deps);
    return isFn || arguments.length == 2 ? [
        values,
        ref
    ] : values;
}
var initSpringRef = ()=>SpringRef();
var useSpringRef = ()=>(0, _react.useState)(initSpringRef)[0];
var useSpringValue = (initial, props)=>{
    const springValue = (0, _shared.useConstant)(()=>new SpringValue(initial, props));
    (0, _shared.useOnce)(()=>()=>{
            springValue.stop();
        });
    return springValue;
};
function useTrail(length, propsArg, deps) {
    const propsFn = (0, _shared.is).fun(propsArg) && propsArg;
    if (propsFn && !deps) deps = [];
    let reverse = true;
    let passedRef = void 0;
    const result = useSprings(length, (i, ctrl)=>{
        const props = propsFn ? propsFn(i, ctrl) : propsArg;
        passedRef = props.ref;
        reverse = reverse && props.reverse;
        return props;
    }, // Ensure the props function is called when no deps exist.
    // This works around the 3 argument rule.
    deps || [
        {}
    ]);
    (0, _shared.useIsomorphicLayoutEffect)(()=>{
        (0, _shared.each)(result[1].current, (ctrl, i)=>{
            const parent = result[1].current[i + (reverse ? 1 : -1)];
            replaceRef(ctrl, passedRef);
            if (ctrl.ref) {
                if (parent) ctrl.update({
                    to: parent.springs
                });
                return;
            }
            if (parent) ctrl.start({
                to: parent.springs
            });
            else ctrl.start();
        });
    }, deps);
    if (propsFn || arguments.length == 3) {
        const ref = passedRef ?? result[1];
        ref["_getProps"] = (propsArg2, ctrl, i)=>{
            const props = (0, _shared.is).fun(propsArg2) ? propsArg2(i, ctrl) : propsArg2;
            if (props) {
                const parent = ref.current[i + (props.reverse ? 1 : -1)];
                if (parent) props.to = parent.springs;
                return props;
            }
        };
        return result;
    }
    return result[0];
}
function useTransition(data, props, deps) {
    const propsFn = (0, _shared.is).fun(props) && props;
    const { reset, sort, trail = 0, expires = true, exitBeforeEnter = false, onDestroyed, ref: propsRef, config: propsConfig } = propsFn ? propsFn() : props;
    const ref = (0, _react.useMemo)(()=>propsFn || arguments.length == 3 ? SpringRef() : void 0, []);
    const items = (0, _shared.toArray)(data);
    const transitions = [];
    const usedTransitions = (0, _react.useRef)(null);
    const prevTransitions = reset ? null : usedTransitions.current;
    (0, _shared.useIsomorphicLayoutEffect)(()=>{
        usedTransitions.current = transitions;
    });
    (0, _shared.useOnce)(()=>{
        (0, _shared.each)(transitions, (t)=>{
            ref?.add(t.ctrl);
            t.ctrl.ref = ref;
        });
        return ()=>{
            (0, _shared.each)(usedTransitions.current, (t)=>{
                if (t.expired) clearTimeout(t.expirationId);
                detachRefs(t.ctrl, ref);
                t.ctrl.stop(true);
            });
        };
    });
    const keys = getKeys(items, propsFn ? propsFn() : props, prevTransitions);
    const expired = reset && usedTransitions.current || [];
    (0, _shared.useIsomorphicLayoutEffect)(()=>(0, _shared.each)(expired, ({ ctrl, item, key })=>{
            detachRefs(ctrl, ref);
            callProp(onDestroyed, item, key);
        }));
    const reused = [];
    if (prevTransitions) (0, _shared.each)(prevTransitions, (t, i)=>{
        if (t.expired) {
            clearTimeout(t.expirationId);
            expired.push(t);
        } else {
            i = reused[i] = keys.indexOf(t.key);
            if (~i) transitions[i] = t;
        }
    });
    (0, _shared.each)(items, (item, i)=>{
        if (!transitions[i]) {
            transitions[i] = {
                key: keys[i],
                item,
                phase: "mount" /* MOUNT */ ,
                ctrl: new Controller()
            };
            transitions[i].ctrl.item = item;
        }
    });
    if (reused.length) {
        let i = -1;
        const { leave } = propsFn ? propsFn() : props;
        (0, _shared.each)(reused, (keyIndex, prevIndex)=>{
            const t = prevTransitions[prevIndex];
            if (~keyIndex) {
                i = transitions.indexOf(t);
                transitions[i] = {
                    ...t,
                    item: items[keyIndex]
                };
            } else if (leave) transitions.splice(++i, 0, t);
        });
    }
    if ((0, _shared.is).fun(sort)) transitions.sort((a, b)=>sort(a.item, b.item));
    let delay = -trail;
    const forceUpdate = (0, _shared.useForceUpdate)();
    const defaultProps = getDefaultProps(props);
    const changes = /* @__PURE__ */ new Map();
    const exitingTransitions = (0, _react.useRef)(/* @__PURE__ */ new Map());
    const forceChange = (0, _react.useRef)(false);
    (0, _shared.each)(transitions, (t, i)=>{
        const key = t.key;
        const prevPhase = t.phase;
        const p = propsFn ? propsFn() : props;
        let to2;
        let phase;
        const propsDelay = callProp(p.delay || 0, key);
        if (prevPhase == "mount" /* MOUNT */ ) {
            to2 = p.enter;
            phase = "enter" /* ENTER */ ;
        } else {
            const isLeave = keys.indexOf(key) < 0;
            if (prevPhase != "leave" /* LEAVE */ ) {
                if (isLeave) {
                    to2 = p.leave;
                    phase = "leave" /* LEAVE */ ;
                } else if (to2 = p.update) phase = "update" /* UPDATE */ ;
                else return;
            } else if (!isLeave) {
                to2 = p.enter;
                phase = "enter" /* ENTER */ ;
            } else return;
        }
        to2 = callProp(to2, t.item, i);
        to2 = (0, _shared.is).obj(to2) ? inferTo(to2) : {
            to: to2
        };
        if (!to2.config) {
            const config2 = propsConfig || defaultProps.config;
            to2.config = callProp(config2, t.item, i, phase);
        }
        delay += trail;
        const payload = {
            ...defaultProps,
            // we need to add our props.delay value you here.
            delay: propsDelay + delay,
            ref: propsRef,
            immediate: p.immediate,
            // This prevents implied resets.
            reset: false,
            // Merge any phase-specific props.
            ...to2
        };
        if (phase == "enter" /* ENTER */  && (0, _shared.is).und(payload.from)) {
            const p2 = propsFn ? propsFn() : props;
            const from = (0, _shared.is).und(p2.initial) || prevTransitions ? p2.from : p2.initial;
            payload.from = callProp(from, t.item, i);
        }
        const { onResolve } = payload;
        payload.onResolve = (result)=>{
            callProp(onResolve, result);
            const transitions2 = usedTransitions.current;
            const t2 = transitions2.find((t3)=>t3.key === key);
            if (!t2) return;
            if (result.cancelled && t2.phase != "update" /* UPDATE */ ) return;
            if (t2.ctrl.idle) {
                const idle = transitions2.every((t3)=>t3.ctrl.idle);
                if (t2.phase == "leave" /* LEAVE */ ) {
                    const expiry = callProp(expires, t2.item);
                    if (expiry !== false) {
                        const expiryMs = expiry === true ? 0 : expiry;
                        t2.expired = true;
                        if (!idle && expiryMs > 0) {
                            if (expiryMs <= 2147483647) t2.expirationId = setTimeout(forceUpdate, expiryMs);
                            return;
                        }
                    }
                }
                if (idle && transitions2.some((t3)=>t3.expired)) {
                    exitingTransitions.current.delete(t2);
                    if (exitBeforeEnter) forceChange.current = true;
                    forceUpdate();
                }
            }
        };
        const springs = getSprings(t.ctrl, payload);
        if (phase === "leave" /* LEAVE */  && exitBeforeEnter) exitingTransitions.current.set(t, {
            phase,
            springs,
            payload
        });
        else changes.set(t, {
            phase,
            springs,
            payload
        });
    });
    const context = (0, _react.useContext)(SpringContext);
    const prevContext = (0, _shared.usePrev)(context);
    const hasContext = context !== prevContext && hasProps(context);
    (0, _shared.useIsomorphicLayoutEffect)(()=>{
        if (hasContext) (0, _shared.each)(transitions, (t)=>{
            t.ctrl.start({
                default: context
            });
        });
    }, [
        context
    ]);
    (0, _shared.each)(changes, (_, t)=>{
        if (exitingTransitions.current.size) {
            const ind = transitions.findIndex((state)=>state.key === t.key);
            transitions.splice(ind, 1);
        }
    });
    (0, _shared.useIsomorphicLayoutEffect)(()=>{
        (0, _shared.each)(exitingTransitions.current.size ? exitingTransitions.current : changes, ({ phase, payload }, t)=>{
            const { ctrl } = t;
            t.phase = phase;
            ref?.add(ctrl);
            if (hasContext && phase == "enter" /* ENTER */ ) ctrl.start({
                default: context
            });
            if (payload) {
                replaceRef(ctrl, payload.ref);
                if ((ctrl.ref || ref) && !forceChange.current) ctrl.update(payload);
                else {
                    ctrl.start(payload);
                    if (forceChange.current) forceChange.current = false;
                }
            }
        });
    }, reset ? void 0 : deps);
    const renderTransitions = (render)=>/* @__PURE__ */ _react.createElement(_react.Fragment, null, transitions.map((t, i)=>{
            const { springs } = changes.get(t) || t.ctrl;
            const elem = render({
                ...springs
            }, t.item, t, i);
            return elem && elem.type ? /* @__PURE__ */ _react.createElement(elem.type, {
                ...elem.props,
                key: (0, _shared.is).str(t.key) || (0, _shared.is).num(t.key) ? t.key : t.ctrl.id,
                ref: elem.ref
            }) : elem;
        }));
    return ref ? [
        renderTransitions,
        ref
    ] : renderTransitions;
}
var nextKey = 1;
function getKeys(items, { key, keys = key }, prevTransitions) {
    if (keys === null) {
        const reused = /* @__PURE__ */ new Set();
        return items.map((item)=>{
            const t = prevTransitions && prevTransitions.find((t2)=>t2.item === item && t2.phase !== "leave" /* LEAVE */  && !reused.has(t2));
            if (t) {
                reused.add(t);
                return t.key;
            }
            return nextKey++;
        });
    }
    return (0, _shared.is).und(keys) ? items : (0, _shared.is).fun(keys) ? items.map(keys) : (0, _shared.toArray)(keys);
}
var useScroll = ({ container, ...springOptions } = {})=>{
    const [scrollValues, api] = useSpring(()=>({
            scrollX: 0,
            scrollY: 0,
            scrollXProgress: 0,
            scrollYProgress: 0,
            ...springOptions
        }), []);
    (0, _shared.useIsomorphicLayoutEffect)(()=>{
        const cleanupScroll = (0, _shared.onScroll)(({ x, y })=>{
            api.start({
                scrollX: x.current,
                scrollXProgress: x.progress,
                scrollY: y.current,
                scrollYProgress: y.progress
            });
        }, {
            container: container?.current || void 0
        });
        return ()=>{
            (0, _shared.each)(Object.values(scrollValues), (value)=>value.stop());
            cleanupScroll();
        };
    }, []);
    return scrollValues;
};
var useResize = ({ container, ...springOptions })=>{
    const [sizeValues, api] = useSpring(()=>({
            width: 0,
            height: 0,
            ...springOptions
        }), []);
    (0, _shared.useIsomorphicLayoutEffect)(()=>{
        const cleanupScroll = (0, _shared.onResize)(({ width, height })=>{
            api.start({
                width,
                height,
                immediate: sizeValues.width.get() === 0 || sizeValues.height.get() === 0
            });
        }, {
            container: container?.current || void 0
        });
        return ()=>{
            (0, _shared.each)(Object.values(sizeValues), (value)=>value.stop());
            cleanupScroll();
        };
    }, []);
    return sizeValues;
};
var defaultThresholdOptions = {
    any: 0,
    all: 1
};
function useInView(props, args) {
    const [isInView, setIsInView] = (0, _react.useState)(false);
    const ref = (0, _react.useRef)();
    const propsFn = (0, _shared.is).fun(props) && props;
    const springsProps = propsFn ? propsFn() : {};
    const { to: to2 = {}, from = {}, ...restSpringProps } = springsProps;
    const intersectionArguments = propsFn ? args : props;
    const [springs, api] = useSpring(()=>({
            from,
            ...restSpringProps
        }), []);
    (0, _shared.useIsomorphicLayoutEffect)(()=>{
        const element = ref.current;
        const { root, once, amount = "any", ...restArgs } = intersectionArguments ?? {};
        if (!element || once && isInView || typeof IntersectionObserver === "undefined") return;
        const activeIntersections = /* @__PURE__ */ new WeakMap();
        const onEnter = ()=>{
            if (to2) api.start(to2);
            setIsInView(true);
            const cleanup = ()=>{
                if (from) api.start(from);
                setIsInView(false);
            };
            return once ? void 0 : cleanup;
        };
        const handleIntersection = (entries)=>{
            entries.forEach((entry)=>{
                const onLeave = activeIntersections.get(entry.target);
                if (entry.isIntersecting === Boolean(onLeave)) return;
                if (entry.isIntersecting) {
                    const newOnLeave = onEnter();
                    if ((0, _shared.is).fun(newOnLeave)) activeIntersections.set(entry.target, newOnLeave);
                    else observer.unobserve(entry.target);
                } else if (onLeave) {
                    onLeave();
                    activeIntersections.delete(entry.target);
                }
            });
        };
        const observer = new IntersectionObserver(handleIntersection, {
            root: root && root.current || void 0,
            threshold: typeof amount === "number" || Array.isArray(amount) ? amount : defaultThresholdOptions[amount],
            ...restArgs
        });
        observer.observe(element);
        return ()=>observer.unobserve(element);
    }, [
        intersectionArguments
    ]);
    if (propsFn) return [
        ref,
        springs
    ];
    return [
        ref,
        isInView
    ];
}
// src/components/Spring.tsx
function Spring({ children, ...props }) {
    return children(useSpring(props));
}
function Trail({ items, children, ...props }) {
    const trails = useTrail(items.length, props);
    return items.map((item, index)=>{
        const result = children(item, index);
        return (0, _shared.is).fun(result) ? result(trails[index]) : result;
    });
}
// src/components/Transition.tsx
function Transition({ items, children, ...props }) {
    return useTransition(items, props)(children);
}
var Interpolation = class extends FrameValue {
    constructor(source, args){
        super();
        this.source = source;
        /** Equals false when in the frameloop */ this.idle = true;
        /** The inputs which are currently animating */ this._active = /* @__PURE__ */ new Set();
        this.calc = (0, _shared.createInterpolator)(...args);
        const value = this._get();
        const nodeType = (0, _animated.getAnimatedType)(value);
        (0, _animated.setAnimated)(this, nodeType.create(value));
    }
    advance(_dt) {
        const value = this._get();
        const oldValue = this.get();
        if (!(0, _shared.isEqual)(value, oldValue)) {
            (0, _animated.getAnimated)(this).setValue(value);
            this._onChange(value, this.idle);
        }
        if (!this.idle && checkIdle(this._active)) becomeIdle(this);
    }
    _get() {
        const inputs = (0, _shared.is).arr(this.source) ? this.source.map((0, _shared.getFluidValue)) : (0, _shared.toArray)((0, _shared.getFluidValue)(this.source));
        return this.calc(...inputs);
    }
    _start() {
        if (this.idle && !checkIdle(this._active)) {
            this.idle = false;
            (0, _shared.each)((0, _animated.getPayload)(this), (node)=>{
                node.done = false;
            });
            if ((0, _shared.Globals).skipAnimation) {
                (0, _shared.raf).batchedUpdates(()=>this.advance());
                becomeIdle(this);
            } else (0, _shared.frameLoop).start(this);
        }
    }
    // Observe our sources only when we're observed.
    _attach() {
        let priority = 1;
        (0, _shared.each)((0, _shared.toArray)(this.source), (source)=>{
            if ((0, _shared.hasFluidValue)(source)) (0, _shared.addFluidObserver)(source, this);
            if (isFrameValue(source)) {
                if (!source.idle) this._active.add(source);
                priority = Math.max(priority, source.priority + 1);
            }
        });
        this.priority = priority;
        this._start();
    }
    // Stop observing our sources once we have no observers.
    _detach() {
        (0, _shared.each)((0, _shared.toArray)(this.source), (source)=>{
            if ((0, _shared.hasFluidValue)(source)) (0, _shared.removeFluidObserver)(source, this);
        });
        this._active.clear();
        becomeIdle(this);
    }
    /** @internal */ eventObserved(event) {
        if (event.type == "change") {
            if (event.idle) this.advance();
            else {
                this._active.add(event.parent);
                this._start();
            }
        } else if (event.type == "idle") this._active.delete(event.parent);
        else if (event.type == "priority") this.priority = (0, _shared.toArray)(this.source).reduce((highest, parent)=>Math.max(highest, (isFrameValue(parent) ? parent.priority : 0) + 1), 0);
    }
};
function isIdle(source) {
    return source.idle !== false;
}
function checkIdle(active) {
    return !active.size || Array.from(active).every(isIdle);
}
function becomeIdle(self) {
    if (!self.idle) {
        self.idle = true;
        (0, _shared.each)((0, _animated.getPayload)(self), (node)=>{
            node.done = true;
        });
        (0, _shared.callFluidObservers)(self, {
            type: "idle",
            parent: self
        });
    }
}
// src/interpolate.ts
var to = (source, ...args)=>new Interpolation(source, args);
var interpolate = (source, ...args)=>((0, _shared.deprecateInterpolate)(), new Interpolation(source, args));
(0, _shared.Globals).assign({
    createStringInterpolator: (0, _shared.createStringInterpolator),
    to: (source, args)=>new Interpolation(source, args)
});
var update = (0, _shared.frameLoop).advance;

},{"@react-spring/shared":"byxMz","react":"6uln9","@react-spring/animated":"b9czT","@react-spring/types":"1Kqqt","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"byxMz":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "FluidValue", ()=>FluidValue);
parcelHelpers.export(exports, "Globals", ()=>globals_exports);
parcelHelpers.export(exports, "addFluidObserver", ()=>addFluidObserver);
parcelHelpers.export(exports, "callFluidObserver", ()=>callFluidObserver);
parcelHelpers.export(exports, "callFluidObservers", ()=>callFluidObservers);
parcelHelpers.export(exports, "clamp", ()=>clamp);
parcelHelpers.export(exports, "colorToRgba", ()=>colorToRgba);
parcelHelpers.export(exports, "colors", ()=>colors2);
parcelHelpers.export(exports, "createInterpolator", ()=>createInterpolator);
parcelHelpers.export(exports, "createStringInterpolator", ()=>createStringInterpolator2);
parcelHelpers.export(exports, "defineHidden", ()=>defineHidden);
parcelHelpers.export(exports, "deprecateDirectCall", ()=>deprecateDirectCall);
parcelHelpers.export(exports, "deprecateInterpolate", ()=>deprecateInterpolate);
parcelHelpers.export(exports, "each", ()=>each);
parcelHelpers.export(exports, "eachProp", ()=>eachProp);
parcelHelpers.export(exports, "easings", ()=>easings);
parcelHelpers.export(exports, "flush", ()=>flush);
parcelHelpers.export(exports, "flushCalls", ()=>flushCalls);
parcelHelpers.export(exports, "frameLoop", ()=>frameLoop);
parcelHelpers.export(exports, "getFluidObservers", ()=>getFluidObservers);
parcelHelpers.export(exports, "getFluidValue", ()=>getFluidValue);
parcelHelpers.export(exports, "hasFluidValue", ()=>hasFluidValue);
parcelHelpers.export(exports, "hex3", ()=>hex3);
parcelHelpers.export(exports, "hex4", ()=>hex4);
parcelHelpers.export(exports, "hex6", ()=>hex6);
parcelHelpers.export(exports, "hex8", ()=>hex8);
parcelHelpers.export(exports, "hsl", ()=>hsl);
parcelHelpers.export(exports, "hsla", ()=>hsla);
parcelHelpers.export(exports, "is", ()=>is);
parcelHelpers.export(exports, "isAnimatedString", ()=>isAnimatedString);
parcelHelpers.export(exports, "isEqual", ()=>isEqual);
parcelHelpers.export(exports, "isSSR", ()=>isSSR);
parcelHelpers.export(exports, "noop", ()=>noop);
parcelHelpers.export(exports, "onResize", ()=>onResize);
parcelHelpers.export(exports, "onScroll", ()=>onScroll);
parcelHelpers.export(exports, "once", ()=>once);
parcelHelpers.export(exports, "prefix", ()=>prefix);
parcelHelpers.export(exports, "raf", ()=>raf);
parcelHelpers.export(exports, "removeFluidObserver", ()=>removeFluidObserver);
parcelHelpers.export(exports, "rgb", ()=>rgb);
parcelHelpers.export(exports, "rgba", ()=>rgba);
parcelHelpers.export(exports, "setFluidGetter", ()=>setFluidGetter);
parcelHelpers.export(exports, "toArray", ()=>toArray);
parcelHelpers.export(exports, "useConstant", ()=>useConstant);
parcelHelpers.export(exports, "useForceUpdate", ()=>useForceUpdate);
parcelHelpers.export(exports, "useIsomorphicLayoutEffect", ()=>useIsomorphicLayoutEffect);
parcelHelpers.export(exports, "useMemoOne", ()=>useMemoOne);
parcelHelpers.export(exports, "useOnce", ()=>useOnce);
parcelHelpers.export(exports, "usePrev", ()=>usePrev);
parcelHelpers.export(exports, "useReducedMotion", ()=>useReducedMotion);
// src/hooks/useConstant.ts
var _react = require("react");
var __defProp = Object.defineProperty;
var __export = (target, all)=>{
    for(var name in all)__defProp(target, name, {
        get: all[name],
        enumerable: true
    });
};
// src/globals.ts
var globals_exports = {};
__export(globals_exports, {
    assign: ()=>assign,
    colors: ()=>colors,
    createStringInterpolator: ()=>createStringInterpolator,
    skipAnimation: ()=>skipAnimation,
    to: ()=>to,
    willAdvance: ()=>willAdvance
});
// ../rafz/dist/react-spring_rafz.modern.mjs
var updateQueue = makeQueue();
var raf = (fn)=>schedule(fn, updateQueue);
var writeQueue = makeQueue();
raf.write = (fn)=>schedule(fn, writeQueue);
var onStartQueue = makeQueue();
raf.onStart = (fn)=>schedule(fn, onStartQueue);
var onFrameQueue = makeQueue();
raf.onFrame = (fn)=>schedule(fn, onFrameQueue);
var onFinishQueue = makeQueue();
raf.onFinish = (fn)=>schedule(fn, onFinishQueue);
var timeouts = [];
raf.setTimeout = (handler, ms)=>{
    const time = raf.now() + ms;
    const cancel = ()=>{
        const i = timeouts.findIndex((t)=>t.cancel == cancel);
        if (~i) timeouts.splice(i, 1);
        pendingCount -= ~i ? 1 : 0;
    };
    const timeout = {
        time,
        handler,
        cancel
    };
    timeouts.splice(findTimeout(time), 0, timeout);
    pendingCount += 1;
    start();
    return timeout;
};
var findTimeout = (time)=>~(~timeouts.findIndex((t)=>t.time > time) || ~timeouts.length);
raf.cancel = (fn)=>{
    onStartQueue.delete(fn);
    onFrameQueue.delete(fn);
    onFinishQueue.delete(fn);
    updateQueue.delete(fn);
    writeQueue.delete(fn);
};
raf.sync = (fn)=>{
    sync = true;
    raf.batchedUpdates(fn);
    sync = false;
};
raf.throttle = (fn)=>{
    let lastArgs;
    function queuedFn() {
        try {
            fn(...lastArgs);
        } finally{
            lastArgs = null;
        }
    }
    function throttled(...args) {
        lastArgs = args;
        raf.onStart(queuedFn);
    }
    throttled.handler = fn;
    throttled.cancel = ()=>{
        onStartQueue.delete(queuedFn);
        lastArgs = null;
    };
    return throttled;
};
var nativeRaf = typeof window != "undefined" ? window.requestAnimationFrame : // eslint-disable-next-line @typescript-eslint/no-empty-function
()=>{};
raf.use = (impl)=>nativeRaf = impl;
raf.now = typeof performance != "undefined" ? ()=>performance.now() : Date.now;
raf.batchedUpdates = (fn)=>fn();
raf.catch = console.error;
raf.frameLoop = "always";
raf.advance = ()=>{
    if (raf.frameLoop !== "demand") console.warn("Cannot call the manual advancement of rafz whilst frameLoop is not set as demand");
    else update();
};
var ts = -1;
var pendingCount = 0;
var sync = false;
function schedule(fn, queue) {
    if (sync) {
        queue.delete(fn);
        fn(0);
    } else {
        queue.add(fn);
        start();
    }
}
function start() {
    if (ts < 0) {
        ts = 0;
        if (raf.frameLoop !== "demand") nativeRaf(loop);
    }
}
function stop() {
    ts = -1;
}
function loop() {
    if (~ts) {
        nativeRaf(loop);
        raf.batchedUpdates(update);
    }
}
function update() {
    const prevTs = ts;
    ts = raf.now();
    const count = findTimeout(ts);
    if (count) {
        eachSafely(timeouts.splice(0, count), (t)=>t.handler());
        pendingCount -= count;
    }
    if (!pendingCount) {
        stop();
        return;
    }
    onStartQueue.flush();
    updateQueue.flush(prevTs ? Math.min(64, ts - prevTs) : 16.667);
    onFrameQueue.flush();
    writeQueue.flush();
    onFinishQueue.flush();
}
function makeQueue() {
    let next = /* @__PURE__ */ new Set();
    let current = next;
    return {
        add (fn) {
            pendingCount += current == next && !next.has(fn) ? 1 : 0;
            next.add(fn);
        },
        delete (fn) {
            pendingCount -= current == next && next.has(fn) ? 1 : 0;
            return next.delete(fn);
        },
        flush (arg) {
            if (current.size) {
                next = /* @__PURE__ */ new Set();
                pendingCount -= current.size;
                eachSafely(current, (fn)=>fn(arg) && next.add(fn));
                pendingCount += next.size;
                current = next;
            }
        }
    };
}
function eachSafely(values, each2) {
    values.forEach((value)=>{
        try {
            each2(value);
        } catch (e) {
            raf.catch(e);
        }
    });
}
// src/helpers.ts
function noop() {}
var defineHidden = (obj, key, value)=>Object.defineProperty(obj, key, {
        value,
        writable: true,
        configurable: true
    });
var is = {
    arr: Array.isArray,
    obj: (a)=>!!a && a.constructor.name === "Object",
    fun: (a)=>typeof a === "function",
    str: (a)=>typeof a === "string",
    num: (a)=>typeof a === "number",
    und: (a)=>a === void 0
};
function isEqual(a, b) {
    if (is.arr(a)) {
        if (!is.arr(b) || a.length !== b.length) return false;
        for(let i = 0; i < a.length; i++){
            if (a[i] !== b[i]) return false;
        }
        return true;
    }
    return a === b;
}
var each = (obj, fn)=>obj.forEach(fn);
function eachProp(obj, fn, ctx) {
    if (is.arr(obj)) {
        for(let i = 0; i < obj.length; i++)fn.call(ctx, obj[i], `${i}`);
        return;
    }
    for(const key in obj)if (obj.hasOwnProperty(key)) fn.call(ctx, obj[key], key);
}
var toArray = (a)=>is.und(a) ? [] : is.arr(a) ? a : [
        a
    ];
function flush(queue, iterator) {
    if (queue.size) {
        const items = Array.from(queue);
        queue.clear();
        each(items, iterator);
    }
}
var flushCalls = (queue, ...args)=>flush(queue, (fn)=>fn(...args));
var isSSR = ()=>typeof window === "undefined" || !window.navigator || /ServerSideRendering|^Deno\//.test(window.navigator.userAgent);
// src/globals.ts
var createStringInterpolator;
var to;
var colors = null;
var skipAnimation = false;
var willAdvance = noop;
var assign = (globals)=>{
    if (globals.to) to = globals.to;
    if (globals.now) raf.now = globals.now;
    if (globals.colors !== void 0) colors = globals.colors;
    if (globals.skipAnimation != null) skipAnimation = globals.skipAnimation;
    if (globals.createStringInterpolator) createStringInterpolator = globals.createStringInterpolator;
    if (globals.requestAnimationFrame) raf.use(globals.requestAnimationFrame);
    if (globals.batchedUpdates) raf.batchedUpdates = globals.batchedUpdates;
    if (globals.willAdvance) willAdvance = globals.willAdvance;
    if (globals.frameLoop) raf.frameLoop = globals.frameLoop;
};
// src/FrameLoop.ts
var startQueue = /* @__PURE__ */ new Set();
var currentFrame = [];
var prevFrame = [];
var priority = 0;
var frameLoop = {
    get idle () {
        return !startQueue.size && !currentFrame.length;
    },
    /** Advance the given animation on every frame until idle. */ start (animation) {
        if (priority > animation.priority) {
            startQueue.add(animation);
            raf.onStart(flushStartQueue);
        } else {
            startSafely(animation);
            raf(advance);
        }
    },
    /** Advance all animations by the given time. */ advance,
    /** Call this when an animation's priority changes. */ sort (animation) {
        if (priority) raf.onFrame(()=>frameLoop.sort(animation));
        else {
            const prevIndex = currentFrame.indexOf(animation);
            if (~prevIndex) {
                currentFrame.splice(prevIndex, 1);
                startUnsafely(animation);
            }
        }
    },
    /**
   * Clear all animations. For testing purposes.
   *
   * ☠️ Never call this from within the frameloop.
   */ clear () {
        currentFrame = [];
        startQueue.clear();
    }
};
function flushStartQueue() {
    startQueue.forEach(startSafely);
    startQueue.clear();
    raf(advance);
}
function startSafely(animation) {
    if (!currentFrame.includes(animation)) startUnsafely(animation);
}
function startUnsafely(animation) {
    currentFrame.splice(findIndex(currentFrame, (other)=>other.priority > animation.priority), 0, animation);
}
function advance(dt) {
    const nextFrame = prevFrame;
    for(let i = 0; i < currentFrame.length; i++){
        const animation = currentFrame[i];
        priority = animation.priority;
        if (!animation.idle) {
            willAdvance(animation);
            animation.advance(dt);
            if (!animation.idle) nextFrame.push(animation);
        }
    }
    priority = 0;
    prevFrame = currentFrame;
    prevFrame.length = 0;
    currentFrame = nextFrame;
    return currentFrame.length > 0;
}
function findIndex(arr, test) {
    const index = arr.findIndex(test);
    return index < 0 ? arr.length : index;
}
// src/clamp.ts
var clamp = (min, max, v)=>Math.min(Math.max(v, min), max);
// src/colors.ts
var colors2 = {
    transparent: 0,
    aliceblue: 4042850303,
    antiquewhite: 4209760255,
    aqua: 16777215,
    aquamarine: 2147472639,
    azure: 4043309055,
    beige: 4126530815,
    bisque: 4293182719,
    black: 255,
    blanchedalmond: 4293643775,
    blue: 65535,
    blueviolet: 2318131967,
    brown: 2771004159,
    burlywood: 3736635391,
    burntsienna: 3934150143,
    cadetblue: 1604231423,
    chartreuse: 2147418367,
    chocolate: 3530104575,
    coral: 4286533887,
    cornflowerblue: 1687547391,
    cornsilk: 4294499583,
    crimson: 3692313855,
    cyan: 16777215,
    darkblue: 35839,
    darkcyan: 9145343,
    darkgoldenrod: 3095792639,
    darkgray: 2846468607,
    darkgreen: 6553855,
    darkgrey: 2846468607,
    darkkhaki: 3182914559,
    darkmagenta: 2332068863,
    darkolivegreen: 1433087999,
    darkorange: 4287365375,
    darkorchid: 2570243327,
    darkred: 2332033279,
    darksalmon: 3918953215,
    darkseagreen: 2411499519,
    darkslateblue: 1211993087,
    darkslategray: 793726975,
    darkslategrey: 793726975,
    darkturquoise: 13554175,
    darkviolet: 2483082239,
    deeppink: 4279538687,
    deepskyblue: 12582911,
    dimgray: 1768516095,
    dimgrey: 1768516095,
    dodgerblue: 512819199,
    firebrick: 2988581631,
    floralwhite: 4294635775,
    forestgreen: 579543807,
    fuchsia: 4278255615,
    gainsboro: 3705462015,
    ghostwhite: 4177068031,
    gold: 4292280575,
    goldenrod: 3668254975,
    gray: 2155905279,
    green: 8388863,
    greenyellow: 2919182335,
    grey: 2155905279,
    honeydew: 4043305215,
    hotpink: 4285117695,
    indianred: 3445382399,
    indigo: 1258324735,
    ivory: 4294963455,
    khaki: 4041641215,
    lavender: 3873897215,
    lavenderblush: 4293981695,
    lawngreen: 2096890111,
    lemonchiffon: 4294626815,
    lightblue: 2916673279,
    lightcoral: 4034953471,
    lightcyan: 3774873599,
    lightgoldenrodyellow: 4210742015,
    lightgray: 3553874943,
    lightgreen: 2431553791,
    lightgrey: 3553874943,
    lightpink: 4290167295,
    lightsalmon: 4288707327,
    lightseagreen: 548580095,
    lightskyblue: 2278488831,
    lightslategray: 2005441023,
    lightslategrey: 2005441023,
    lightsteelblue: 2965692159,
    lightyellow: 4294959359,
    lime: 16711935,
    limegreen: 852308735,
    linen: 4210091775,
    magenta: 4278255615,
    maroon: 2147483903,
    mediumaquamarine: 1724754687,
    mediumblue: 52735,
    mediumorchid: 3126187007,
    mediumpurple: 2473647103,
    mediumseagreen: 1018393087,
    mediumslateblue: 2070474495,
    mediumspringgreen: 16423679,
    mediumturquoise: 1221709055,
    mediumvioletred: 3340076543,
    midnightblue: 421097727,
    mintcream: 4127193855,
    mistyrose: 4293190143,
    moccasin: 4293178879,
    navajowhite: 4292783615,
    navy: 33023,
    oldlace: 4260751103,
    olive: 2155872511,
    olivedrab: 1804477439,
    orange: 4289003775,
    orangered: 4282712319,
    orchid: 3664828159,
    palegoldenrod: 4008225535,
    palegreen: 2566625535,
    paleturquoise: 2951671551,
    palevioletred: 3681588223,
    papayawhip: 4293907967,
    peachpuff: 4292524543,
    peru: 3448061951,
    pink: 4290825215,
    plum: 3718307327,
    powderblue: 2967529215,
    purple: 2147516671,
    rebeccapurple: 1714657791,
    red: 4278190335,
    rosybrown: 3163525119,
    royalblue: 1097458175,
    saddlebrown: 2336560127,
    salmon: 4202722047,
    sandybrown: 4104413439,
    seagreen: 780883967,
    seashell: 4294307583,
    sienna: 2689740287,
    silver: 3233857791,
    skyblue: 2278484991,
    slateblue: 1784335871,
    slategray: 1887473919,
    slategrey: 1887473919,
    snow: 4294638335,
    springgreen: 16744447,
    steelblue: 1182971135,
    tan: 3535047935,
    teal: 8421631,
    thistle: 3636451583,
    tomato: 4284696575,
    turquoise: 1088475391,
    violet: 4001558271,
    wheat: 4125012991,
    white: 4294967295,
    whitesmoke: 4126537215,
    yellow: 4294902015,
    yellowgreen: 2597139199
};
// src/colorMatchers.ts
var NUMBER = "[-+]?\\d*\\.?\\d+";
var PERCENTAGE = NUMBER + "%";
function call(...parts) {
    return "\\(\\s*(" + parts.join(")\\s*,\\s*(") + ")\\s*\\)";
}
var rgb = new RegExp("rgb" + call(NUMBER, NUMBER, NUMBER));
var rgba = new RegExp("rgba" + call(NUMBER, NUMBER, NUMBER, NUMBER));
var hsl = new RegExp("hsl" + call(NUMBER, PERCENTAGE, PERCENTAGE));
var hsla = new RegExp("hsla" + call(NUMBER, PERCENTAGE, PERCENTAGE, NUMBER));
var hex3 = /^#([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/;
var hex4 = /^#([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/;
var hex6 = /^#([0-9a-fA-F]{6})$/;
var hex8 = /^#([0-9a-fA-F]{8})$/;
// src/normalizeColor.ts
function normalizeColor(color) {
    let match;
    if (typeof color === "number") return color >>> 0 === color && color >= 0 && color <= 4294967295 ? color : null;
    if (match = hex6.exec(color)) return parseInt(match[1] + "ff", 16) >>> 0;
    if (colors && colors[color] !== void 0) return colors[color];
    if (match = rgb.exec(color)) return (parse255(match[1]) << 24 | // r
    parse255(match[2]) << 16 | // g
    parse255(match[3]) << 8 | // b
    255) >>> // a
    0;
    if (match = rgba.exec(color)) return (parse255(match[1]) << 24 | // r
    parse255(match[2]) << 16 | // g
    parse255(match[3]) << 8 | // b
    parse1(match[4])) >>> // a
    0;
    if (match = hex3.exec(color)) return parseInt(match[1] + match[1] + // r
    match[2] + match[2] + // g
    match[3] + match[3] + // b
    "ff", // a
    16) >>> 0;
    if (match = hex8.exec(color)) return parseInt(match[1], 16) >>> 0;
    if (match = hex4.exec(color)) return parseInt(match[1] + match[1] + // r
    match[2] + match[2] + // g
    match[3] + match[3] + // b
    match[4] + match[4], // a
    16) >>> 0;
    if (match = hsl.exec(color)) return (hslToRgb(parse360(match[1]), // h
    parsePercentage(match[2]), // s
    parsePercentage(match[3])) | 255) >>> // a
    0;
    if (match = hsla.exec(color)) return (hslToRgb(parse360(match[1]), // h
    parsePercentage(match[2]), // s
    parsePercentage(match[3])) | parse1(match[4])) >>> // a
    0;
    return null;
}
function hue2rgb(p, q, t) {
    if (t < 0) t += 1;
    if (t > 1) t -= 1;
    if (t < 1 / 6) return p + (q - p) * 6 * t;
    if (t < 0.5) return q;
    if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
    return p;
}
function hslToRgb(h, s, l) {
    const q = l < 0.5 ? l * (1 + s) : l + s - l * s;
    const p = 2 * l - q;
    const r = hue2rgb(p, q, h + 1 / 3);
    const g = hue2rgb(p, q, h);
    const b = hue2rgb(p, q, h - 1 / 3);
    return Math.round(r * 255) << 24 | Math.round(g * 255) << 16 | Math.round(b * 255) << 8;
}
function parse255(str) {
    const int = parseInt(str, 10);
    if (int < 0) return 0;
    if (int > 255) return 255;
    return int;
}
function parse360(str) {
    const int = parseFloat(str);
    return (int % 360 + 360) % 360 / 360;
}
function parse1(str) {
    const num = parseFloat(str);
    if (num < 0) return 0;
    if (num > 1) return 255;
    return Math.round(num * 255);
}
function parsePercentage(str) {
    const int = parseFloat(str);
    if (int < 0) return 0;
    if (int > 100) return 1;
    return int / 100;
}
// src/colorToRgba.ts
function colorToRgba(input) {
    let int32Color = normalizeColor(input);
    if (int32Color === null) return input;
    int32Color = int32Color || 0;
    const r = (int32Color & 4278190080) >>> 24;
    const g = (int32Color & 16711680) >>> 16;
    const b = (int32Color & 65280) >>> 8;
    const a = (int32Color & 255) / 255;
    return `rgba(${r}, ${g}, ${b}, ${a})`;
}
// src/createInterpolator.ts
var createInterpolator = (range, output, extrapolate)=>{
    if (is.fun(range)) return range;
    if (is.arr(range)) return createInterpolator({
        range,
        output,
        extrapolate
    });
    if (is.str(range.output[0])) return createStringInterpolator(range);
    const config = range;
    const outputRange = config.output;
    const inputRange = config.range || [
        0,
        1
    ];
    const extrapolateLeft = config.extrapolateLeft || config.extrapolate || "extend";
    const extrapolateRight = config.extrapolateRight || config.extrapolate || "extend";
    const easing = config.easing || ((t)=>t);
    return (input)=>{
        const range2 = findRange(input, inputRange);
        return interpolate(input, inputRange[range2], inputRange[range2 + 1], outputRange[range2], outputRange[range2 + 1], easing, extrapolateLeft, extrapolateRight, config.map);
    };
};
function interpolate(input, inputMin, inputMax, outputMin, outputMax, easing, extrapolateLeft, extrapolateRight, map) {
    let result = map ? map(input) : input;
    if (result < inputMin) {
        if (extrapolateLeft === "identity") return result;
        else if (extrapolateLeft === "clamp") result = inputMin;
    }
    if (result > inputMax) {
        if (extrapolateRight === "identity") return result;
        else if (extrapolateRight === "clamp") result = inputMax;
    }
    if (outputMin === outputMax) return outputMin;
    if (inputMin === inputMax) return input <= inputMin ? outputMin : outputMax;
    if (inputMin === -Infinity) result = -result;
    else if (inputMax === Infinity) result = result - inputMin;
    else result = (result - inputMin) / (inputMax - inputMin);
    result = easing(result);
    if (outputMin === -Infinity) result = -result;
    else if (outputMax === Infinity) result = result + outputMin;
    else result = result * (outputMax - outputMin) + outputMin;
    return result;
}
function findRange(input, inputRange) {
    for(var i = 1; i < inputRange.length - 1; ++i)if (inputRange[i] >= input) break;
    return i - 1;
}
// src/easings.ts
var steps = (steps2, direction = "end")=>(progress2)=>{
        progress2 = direction === "end" ? Math.min(progress2, 0.999) : Math.max(progress2, 1e-3);
        const expanded = progress2 * steps2;
        const rounded = direction === "end" ? Math.floor(expanded) : Math.ceil(expanded);
        return clamp(0, 1, rounded / steps2);
    };
var c1 = 1.70158;
var c2 = c1 * 1.525;
var c3 = c1 + 1;
var c4 = 2 * Math.PI / 3;
var c5 = 2 * Math.PI / 4.5;
var bounceOut = (x)=>{
    const n1 = 7.5625;
    const d1 = 2.75;
    if (x < 1 / d1) return n1 * x * x;
    else if (x < 2 / d1) return n1 * (x -= 1.5 / d1) * x + 0.75;
    else if (x < 2.5 / d1) return n1 * (x -= 2.25 / d1) * x + 0.9375;
    else return n1 * (x -= 2.625 / d1) * x + 0.984375;
};
var easings = {
    linear: (x)=>x,
    easeInQuad: (x)=>x * x,
    easeOutQuad: (x)=>1 - (1 - x) * (1 - x),
    easeInOutQuad: (x)=>x < 0.5 ? 2 * x * x : 1 - Math.pow(-2 * x + 2, 2) / 2,
    easeInCubic: (x)=>x * x * x,
    easeOutCubic: (x)=>1 - Math.pow(1 - x, 3),
    easeInOutCubic: (x)=>x < 0.5 ? 4 * x * x * x : 1 - Math.pow(-2 * x + 2, 3) / 2,
    easeInQuart: (x)=>x * x * x * x,
    easeOutQuart: (x)=>1 - Math.pow(1 - x, 4),
    easeInOutQuart: (x)=>x < 0.5 ? 8 * x * x * x * x : 1 - Math.pow(-2 * x + 2, 4) / 2,
    easeInQuint: (x)=>x * x * x * x * x,
    easeOutQuint: (x)=>1 - Math.pow(1 - x, 5),
    easeInOutQuint: (x)=>x < 0.5 ? 16 * x * x * x * x * x : 1 - Math.pow(-2 * x + 2, 5) / 2,
    easeInSine: (x)=>1 - Math.cos(x * Math.PI / 2),
    easeOutSine: (x)=>Math.sin(x * Math.PI / 2),
    easeInOutSine: (x)=>-(Math.cos(Math.PI * x) - 1) / 2,
    easeInExpo: (x)=>x === 0 ? 0 : Math.pow(2, 10 * x - 10),
    easeOutExpo: (x)=>x === 1 ? 1 : 1 - Math.pow(2, -10 * x),
    easeInOutExpo: (x)=>x === 0 ? 0 : x === 1 ? 1 : x < 0.5 ? Math.pow(2, 20 * x - 10) / 2 : (2 - Math.pow(2, -20 * x + 10)) / 2,
    easeInCirc: (x)=>1 - Math.sqrt(1 - Math.pow(x, 2)),
    easeOutCirc: (x)=>Math.sqrt(1 - Math.pow(x - 1, 2)),
    easeInOutCirc: (x)=>x < 0.5 ? (1 - Math.sqrt(1 - Math.pow(2 * x, 2))) / 2 : (Math.sqrt(1 - Math.pow(-2 * x + 2, 2)) + 1) / 2,
    easeInBack: (x)=>c3 * x * x * x - c1 * x * x,
    easeOutBack: (x)=>1 + c3 * Math.pow(x - 1, 3) + c1 * Math.pow(x - 1, 2),
    easeInOutBack: (x)=>x < 0.5 ? Math.pow(2 * x, 2) * ((c2 + 1) * 2 * x - c2) / 2 : (Math.pow(2 * x - 2, 2) * ((c2 + 1) * (x * 2 - 2) + c2) + 2) / 2,
    easeInElastic: (x)=>x === 0 ? 0 : x === 1 ? 1 : -Math.pow(2, 10 * x - 10) * Math.sin((x * 10 - 10.75) * c4),
    easeOutElastic: (x)=>x === 0 ? 0 : x === 1 ? 1 : Math.pow(2, -10 * x) * Math.sin((x * 10 - 0.75) * c4) + 1,
    easeInOutElastic: (x)=>x === 0 ? 0 : x === 1 ? 1 : x < 0.5 ? -(Math.pow(2, 20 * x - 10) * Math.sin((20 * x - 11.125) * c5)) / 2 : Math.pow(2, -20 * x + 10) * Math.sin((20 * x - 11.125) * c5) / 2 + 1,
    easeInBounce: (x)=>1 - bounceOut(1 - x),
    easeOutBounce: bounceOut,
    easeInOutBounce: (x)=>x < 0.5 ? (1 - bounceOut(1 - 2 * x)) / 2 : (1 + bounceOut(2 * x - 1)) / 2,
    steps
};
// src/fluids.ts
var $get = Symbol.for("FluidValue.get");
var $observers = Symbol.for("FluidValue.observers");
var hasFluidValue = (arg)=>Boolean(arg && arg[$get]);
var getFluidValue = (arg)=>arg && arg[$get] ? arg[$get]() : arg;
var getFluidObservers = (target)=>target[$observers] || null;
function callFluidObserver(observer2, event) {
    if (observer2.eventObserved) observer2.eventObserved(event);
    else observer2(event);
}
function callFluidObservers(target, event) {
    const observers = target[$observers];
    if (observers) observers.forEach((observer2)=>{
        callFluidObserver(observer2, event);
    });
}
var FluidValue = class {
    constructor(get){
        if (!get && !(get = this.get)) throw Error("Unknown getter");
        setFluidGetter(this, get);
    }
};
$get, $observers;
var setFluidGetter = (target, get)=>setHidden(target, $get, get);
function addFluidObserver(target, observer2) {
    if (target[$get]) {
        let observers = target[$observers];
        if (!observers) setHidden(target, $observers, observers = /* @__PURE__ */ new Set());
        if (!observers.has(observer2)) {
            observers.add(observer2);
            if (target.observerAdded) target.observerAdded(observers.size, observer2);
        }
    }
    return observer2;
}
function removeFluidObserver(target, observer2) {
    const observers = target[$observers];
    if (observers && observers.has(observer2)) {
        const count = observers.size - 1;
        if (count) observers.delete(observer2);
        else target[$observers] = null;
        if (target.observerRemoved) target.observerRemoved(count, observer2);
    }
}
var setHidden = (target, key, value)=>Object.defineProperty(target, key, {
        value,
        writable: true,
        configurable: true
    });
// src/regexs.ts
var numberRegex = /[+\-]?(?:0|[1-9]\d*)(?:\.\d*)?(?:[eE][+\-]?\d+)?/g;
var colorRegex = /(#(?:[0-9a-f]{2}){2,4}|(#[0-9a-f]{3})|(rgb|hsl)a?\((-?\d+%?[,\s]+){2,3}\s*[\d\.]+%?\))/gi;
var unitRegex = new RegExp(`(${numberRegex.source})(%|[a-z]+)`, "i");
var rgbaRegex = /rgba\(([0-9\.-]+), ([0-9\.-]+), ([0-9\.-]+), ([0-9\.-]+)\)/gi;
var cssVariableRegex = /var\((--[a-zA-Z0-9-_]+),? ?([a-zA-Z0-9 ()%#.,-]+)?\)/;
// src/variableToRgba.ts
var variableToRgba = (input)=>{
    const [token, fallback] = parseCSSVariable(input);
    if (!token || isSSR()) return input;
    const value = window.getComputedStyle(document.documentElement).getPropertyValue(token);
    if (value) return value.trim();
    else if (fallback && fallback.startsWith("--")) {
        const value2 = window.getComputedStyle(document.documentElement).getPropertyValue(fallback);
        if (value2) return value2;
        else return input;
    } else if (fallback && cssVariableRegex.test(fallback)) return variableToRgba(fallback);
    else if (fallback) return fallback;
    return input;
};
var parseCSSVariable = (current)=>{
    const match = cssVariableRegex.exec(current);
    if (!match) return [
        , 
    ];
    const [, token, fallback] = match;
    return [
        token,
        fallback
    ];
};
// src/stringInterpolation.ts
var namedColorRegex;
var rgbaRound = (_, p1, p2, p3, p4)=>`rgba(${Math.round(p1)}, ${Math.round(p2)}, ${Math.round(p3)}, ${p4})`;
var createStringInterpolator2 = (config)=>{
    if (!namedColorRegex) namedColorRegex = colors ? // match color names, ignore partial matches
    new RegExp(`(${Object.keys(colors).join("|")})(?!\\w)`, "g") : // never match
    /^\b$/;
    const output = config.output.map((value)=>{
        return getFluidValue(value).replace(cssVariableRegex, variableToRgba).replace(colorRegex, colorToRgba).replace(namedColorRegex, colorToRgba);
    });
    const keyframes = output.map((value)=>value.match(numberRegex).map(Number));
    const outputRanges = keyframes[0].map((_, i)=>keyframes.map((values)=>{
            if (!(i in values)) throw Error('The arity of each "output" value must be equal');
            return values[i];
        }));
    const interpolators = outputRanges.map((output2)=>createInterpolator({
            ...config,
            output: output2
        }));
    return (input)=>{
        const missingUnit = !unitRegex.test(output[0]) && output.find((value)=>unitRegex.test(value))?.replace(numberRegex, "");
        let i = 0;
        return output[0].replace(numberRegex, ()=>`${interpolators[i++](input)}${missingUnit || ""}`).replace(rgbaRegex, rgbaRound);
    };
};
// src/deprecations.ts
var prefix = "react-spring: ";
var once = (fn)=>{
    const func = fn;
    let called = false;
    if (typeof func != "function") throw new TypeError(`${prefix}once requires a function parameter`);
    return (...args)=>{
        if (!called) {
            func(...args);
            called = true;
        }
    };
};
var warnInterpolate = once(console.warn);
function deprecateInterpolate() {
    warnInterpolate(`${prefix}The "interpolate" function is deprecated in v9 (use "to" instead)`);
}
var warnDirectCall = once(console.warn);
function deprecateDirectCall() {
    warnDirectCall(`${prefix}Directly calling start instead of using the api object is deprecated in v9 (use ".start" instead), this will be removed in later 0.X.0 versions`);
}
// src/isAnimatedString.ts
function isAnimatedString(value) {
    return is.str(value) && (value[0] == "#" || /\d/.test(value) || // Do not identify a CSS variable as an AnimatedString if its SSR
    !isSSR() && cssVariableRegex.test(value) || value in (colors || {}));
}
// src/dom-events/resize/resizeElement.ts
var observer;
var resizeHandlers = /* @__PURE__ */ new WeakMap();
var handleObservation = (entries)=>entries.forEach(({ target, contentRect })=>{
        return resizeHandlers.get(target)?.forEach((handler)=>handler(contentRect));
    });
function resizeElement(handler, target) {
    if (!observer) {
        if (typeof ResizeObserver !== "undefined") observer = new ResizeObserver(handleObservation);
    }
    let elementHandlers = resizeHandlers.get(target);
    if (!elementHandlers) {
        elementHandlers = /* @__PURE__ */ new Set();
        resizeHandlers.set(target, elementHandlers);
    }
    elementHandlers.add(handler);
    if (observer) observer.observe(target);
    return ()=>{
        const elementHandlers2 = resizeHandlers.get(target);
        if (!elementHandlers2) return;
        elementHandlers2.delete(handler);
        if (!elementHandlers2.size && observer) observer.unobserve(target);
    };
}
// src/dom-events/resize/resizeWindow.ts
var listeners = /* @__PURE__ */ new Set();
var cleanupWindowResizeHandler;
var createResizeHandler = ()=>{
    const handleResize = ()=>{
        listeners.forEach((callback)=>callback({
                width: window.innerWidth,
                height: window.innerHeight
            }));
    };
    window.addEventListener("resize", handleResize);
    return ()=>{
        window.removeEventListener("resize", handleResize);
    };
};
var resizeWindow = (callback)=>{
    listeners.add(callback);
    if (!cleanupWindowResizeHandler) cleanupWindowResizeHandler = createResizeHandler();
    return ()=>{
        listeners.delete(callback);
        if (!listeners.size && cleanupWindowResizeHandler) {
            cleanupWindowResizeHandler();
            cleanupWindowResizeHandler = void 0;
        }
    };
};
// src/dom-events/resize/index.ts
var onResize = (callback, { container = document.documentElement } = {})=>{
    if (container === document.documentElement) return resizeWindow(callback);
    else return resizeElement(callback, container);
};
// src/progress.ts
var progress = (min, max, value)=>max - min === 0 ? 1 : (value - min) / (max - min);
// src/dom-events/scroll/ScrollHandler.ts
var SCROLL_KEYS = {
    x: {
        length: "Width",
        position: "Left"
    },
    y: {
        length: "Height",
        position: "Top"
    }
};
var ScrollHandler = class {
    constructor(callback, container){
        this.createAxis = ()=>({
                current: 0,
                progress: 0,
                scrollLength: 0
            });
        this.updateAxis = (axisName)=>{
            const axis = this.info[axisName];
            const { length, position } = SCROLL_KEYS[axisName];
            axis.current = this.container[`scroll${position}`];
            axis.scrollLength = this.container["scroll" + length] - this.container["client" + length];
            axis.progress = progress(0, axis.scrollLength, axis.current);
        };
        this.update = ()=>{
            this.updateAxis("x");
            this.updateAxis("y");
        };
        this.sendEvent = ()=>{
            this.callback(this.info);
        };
        this.advance = ()=>{
            this.update();
            this.sendEvent();
        };
        this.callback = callback;
        this.container = container;
        this.info = {
            time: 0,
            x: this.createAxis(),
            y: this.createAxis()
        };
    }
};
// src/dom-events/scroll/index.ts
var scrollListeners = /* @__PURE__ */ new WeakMap();
var resizeListeners = /* @__PURE__ */ new WeakMap();
var onScrollHandlers = /* @__PURE__ */ new WeakMap();
var getTarget = (container)=>container === document.documentElement ? window : container;
var onScroll = (callback, { container = document.documentElement } = {})=>{
    let containerHandlers = onScrollHandlers.get(container);
    if (!containerHandlers) {
        containerHandlers = /* @__PURE__ */ new Set();
        onScrollHandlers.set(container, containerHandlers);
    }
    const containerHandler = new ScrollHandler(callback, container);
    containerHandlers.add(containerHandler);
    if (!scrollListeners.has(container)) {
        const listener = ()=>{
            containerHandlers?.forEach((handler)=>handler.advance());
            return true;
        };
        scrollListeners.set(container, listener);
        const target = getTarget(container);
        window.addEventListener("resize", listener, {
            passive: true
        });
        if (container !== document.documentElement) resizeListeners.set(container, onResize(listener, {
            container
        }));
        target.addEventListener("scroll", listener, {
            passive: true
        });
    }
    const animateScroll = scrollListeners.get(container);
    raf(animateScroll);
    return ()=>{
        raf.cancel(animateScroll);
        const containerHandlers2 = onScrollHandlers.get(container);
        if (!containerHandlers2) return;
        containerHandlers2.delete(containerHandler);
        if (containerHandlers2.size) return;
        const listener = scrollListeners.get(container);
        scrollListeners.delete(container);
        if (listener) {
            getTarget(container).removeEventListener("scroll", listener);
            window.removeEventListener("resize", listener);
            resizeListeners.get(container)?.();
        }
    };
};
function useConstant(init) {
    const ref = (0, _react.useRef)(null);
    if (ref.current === null) ref.current = init();
    return ref.current;
}
var useIsomorphicLayoutEffect = isSSR() ? (0, _react.useEffect) : (0, _react.useLayoutEffect);
// src/hooks/useIsMounted.ts
var useIsMounted = ()=>{
    const isMounted = (0, _react.useRef)(false);
    useIsomorphicLayoutEffect(()=>{
        isMounted.current = true;
        return ()=>{
            isMounted.current = false;
        };
    }, []);
    return isMounted;
};
// src/hooks/useForceUpdate.ts
function useForceUpdate() {
    const update2 = (0, _react.useState)()[1];
    const isMounted = useIsMounted();
    return ()=>{
        if (isMounted.current) update2(Math.random());
    };
}
function useMemoOne(getResult, inputs) {
    const [initial] = (0, _react.useState)(()=>({
            inputs,
            result: getResult()
        }));
    const committed = (0, _react.useRef)();
    const prevCache = committed.current;
    let cache = prevCache;
    if (cache) {
        const useCache = Boolean(inputs && cache.inputs && areInputsEqual(inputs, cache.inputs));
        if (!useCache) cache = {
            inputs,
            result: getResult()
        };
    } else cache = initial;
    (0, _react.useEffect)(()=>{
        committed.current = cache;
        if (prevCache == initial) initial.inputs = initial.result = void 0;
    }, [
        cache
    ]);
    return cache.result;
}
function areInputsEqual(next, prev) {
    if (next.length !== prev.length) return false;
    for(let i = 0; i < next.length; i++){
        if (next[i] !== prev[i]) return false;
    }
    return true;
}
var useOnce = (effect)=>(0, _react.useEffect)(effect, emptyDeps);
var emptyDeps = [];
function usePrev(value) {
    const prevRef = (0, _react.useRef)();
    (0, _react.useEffect)(()=>{
        prevRef.current = value;
    });
    return prevRef.current;
}
var useReducedMotion = ()=>{
    const [reducedMotion, setReducedMotion] = (0, _react.useState)(null);
    useIsomorphicLayoutEffect(()=>{
        const mql = window.matchMedia("(prefers-reduced-motion)");
        const handleMediaChange = (e)=>{
            setReducedMotion(e.matches);
            assign({
                skipAnimation: e.matches
            });
        };
        handleMediaChange(mql);
        mql.addEventListener("change", handleMediaChange);
        return ()=>{
            mql.removeEventListener("change", handleMediaChange);
        };
    }, []);
    return reducedMotion;
};

},{"react":"6uln9","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"b9czT":[function(require,module,exports) {
// src/Animated.ts
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Animated", ()=>Animated);
parcelHelpers.export(exports, "AnimatedArray", ()=>AnimatedArray);
parcelHelpers.export(exports, "AnimatedObject", ()=>AnimatedObject);
parcelHelpers.export(exports, "AnimatedString", ()=>AnimatedString);
parcelHelpers.export(exports, "AnimatedValue", ()=>AnimatedValue);
parcelHelpers.export(exports, "createHost", ()=>createHost);
parcelHelpers.export(exports, "getAnimated", ()=>getAnimated);
parcelHelpers.export(exports, "getAnimatedType", ()=>getAnimatedType);
parcelHelpers.export(exports, "getPayload", ()=>getPayload);
parcelHelpers.export(exports, "isAnimated", ()=>isAnimated);
parcelHelpers.export(exports, "setAnimated", ()=>setAnimated);
var _shared = require("@react-spring/shared");
// src/withAnimated.tsx
var _react = require("react");
var $node = Symbol.for("Animated:node");
var isAnimated = (value)=>!!value && value[$node] === value;
var getAnimated = (owner)=>owner && owner[$node];
var setAnimated = (owner, node)=>(0, _shared.defineHidden)(owner, $node, node);
var getPayload = (owner)=>owner && owner[$node] && owner[$node].getPayload();
var Animated = class {
    constructor(){
        setAnimated(this, this);
    }
    /** Get every `AnimatedValue` used by this node. */ getPayload() {
        return this.payload || [];
    }
};
var AnimatedValue = class extends Animated {
    constructor(_value){
        super();
        this._value = _value;
        this.done = true;
        this.durationProgress = 0;
        if ((0, _shared.is).num(this._value)) this.lastPosition = this._value;
    }
    /** @internal */ static create(value) {
        return new AnimatedValue(value);
    }
    getPayload() {
        return [
            this
        ];
    }
    getValue() {
        return this._value;
    }
    setValue(value, step) {
        if ((0, _shared.is).num(value)) {
            this.lastPosition = value;
            if (step) {
                value = Math.round(value / step) * step;
                if (this.done) this.lastPosition = value;
            }
        }
        if (this._value === value) return false;
        this._value = value;
        return true;
    }
    reset() {
        const { done } = this;
        this.done = false;
        if ((0, _shared.is).num(this._value)) {
            this.elapsedTime = 0;
            this.durationProgress = 0;
            this.lastPosition = this._value;
            if (done) this.lastVelocity = null;
            this.v0 = null;
        }
    }
};
var AnimatedString = class extends AnimatedValue {
    constructor(value){
        super(0);
        this._string = null;
        this._toString = (0, _shared.createInterpolator)({
            output: [
                value,
                value
            ]
        });
    }
    /** @internal */ static create(value) {
        return new AnimatedString(value);
    }
    getValue() {
        const value = this._string;
        return value == null ? this._string = this._toString(this._value) : value;
    }
    setValue(value) {
        if ((0, _shared.is).str(value)) {
            if (value == this._string) return false;
            this._string = value;
            this._value = 1;
        } else if (super.setValue(value)) this._string = null;
        else return false;
        return true;
    }
    reset(goal) {
        if (goal) this._toString = (0, _shared.createInterpolator)({
            output: [
                this.getValue(),
                goal
            ]
        });
        this._value = 0;
        super.reset();
    }
};
// src/context.ts
var TreeContext = {
    dependencies: null
};
// src/AnimatedObject.ts
var AnimatedObject = class extends Animated {
    constructor(source){
        super();
        this.source = source;
        this.setValue(source);
    }
    getValue(animated) {
        const values = {};
        (0, _shared.eachProp)(this.source, (source, key)=>{
            if (isAnimated(source)) values[key] = source.getValue(animated);
            else if ((0, _shared.hasFluidValue)(source)) values[key] = (0, _shared.getFluidValue)(source);
            else if (!animated) values[key] = source;
        });
        return values;
    }
    /** Replace the raw object data */ setValue(source) {
        this.source = source;
        this.payload = this._makePayload(source);
    }
    reset() {
        if (this.payload) (0, _shared.each)(this.payload, (node)=>node.reset());
    }
    /** Create a payload set. */ _makePayload(source) {
        if (source) {
            const payload = /* @__PURE__ */ new Set();
            (0, _shared.eachProp)(source, this._addToPayload, payload);
            return Array.from(payload);
        }
    }
    /** Add to a payload set. */ _addToPayload(source) {
        if (TreeContext.dependencies && (0, _shared.hasFluidValue)(source)) TreeContext.dependencies.add(source);
        const payload = getPayload(source);
        if (payload) (0, _shared.each)(payload, (node)=>this.add(node));
    }
};
// src/AnimatedArray.ts
var AnimatedArray = class extends AnimatedObject {
    constructor(source){
        super(source);
    }
    /** @internal */ static create(source) {
        return new AnimatedArray(source);
    }
    getValue() {
        return this.source.map((node)=>node.getValue());
    }
    setValue(source) {
        const payload = this.getPayload();
        if (source.length == payload.length) return payload.map((node, i)=>node.setValue(source[i])).some(Boolean);
        super.setValue(source.map(makeAnimated));
        return true;
    }
};
function makeAnimated(value) {
    const nodeType = (0, _shared.isAnimatedString)(value) ? AnimatedString : AnimatedValue;
    return nodeType.create(value);
}
function getAnimatedType(value) {
    const parentNode = getAnimated(value);
    return parentNode ? parentNode.constructor : (0, _shared.is).arr(value) ? AnimatedArray : (0, _shared.isAnimatedString)(value) ? AnimatedString : AnimatedValue;
}
var withAnimated = (Component, host)=>{
    const hasInstance = // Function components must use "forwardRef" to avoid being
    // re-rendered on every animation frame.
    !(0, _shared.is).fun(Component) || Component.prototype && Component.prototype.isReactComponent;
    return (0, _react.forwardRef)((givenProps, givenRef)=>{
        const instanceRef = (0, _react.useRef)(null);
        const ref = hasInstance && // eslint-disable-next-line react-hooks/rules-of-hooks
        (0, _react.useCallback)((value)=>{
            instanceRef.current = updateRef(givenRef, value);
        }, [
            givenRef
        ]);
        const [props, deps] = getAnimatedState(givenProps, host);
        const forceUpdate = (0, _shared.useForceUpdate)();
        const callback = ()=>{
            const instance = instanceRef.current;
            if (hasInstance && !instance) return;
            const didUpdate = instance ? host.applyAnimatedValues(instance, props.getValue(true)) : false;
            if (didUpdate === false) forceUpdate();
        };
        const observer = new PropsObserver(callback, deps);
        const observerRef = (0, _react.useRef)();
        (0, _shared.useIsomorphicLayoutEffect)(()=>{
            observerRef.current = observer;
            (0, _shared.each)(deps, (dep)=>(0, _shared.addFluidObserver)(dep, observer));
            return ()=>{
                if (observerRef.current) {
                    (0, _shared.each)(observerRef.current.deps, (dep)=>(0, _shared.removeFluidObserver)(dep, observerRef.current));
                    (0, _shared.raf).cancel(observerRef.current.update);
                }
            };
        });
        (0, _react.useEffect)(callback, []);
        (0, _shared.useOnce)(()=>()=>{
                const observer2 = observerRef.current;
                (0, _shared.each)(observer2.deps, (dep)=>(0, _shared.removeFluidObserver)(dep, observer2));
            });
        const usedProps = host.getComponentProps(props.getValue());
        return /* @__PURE__ */ _react.createElement(Component, {
            ...usedProps,
            ref
        });
    });
};
var PropsObserver = class {
    constructor(update, deps){
        this.update = update;
        this.deps = deps;
    }
    eventObserved(event) {
        if (event.type == "change") (0, _shared.raf).write(this.update);
    }
};
function getAnimatedState(props, host) {
    const dependencies = /* @__PURE__ */ new Set();
    TreeContext.dependencies = dependencies;
    if (props.style) props = {
        ...props,
        style: host.createAnimatedStyle(props.style)
    };
    props = new AnimatedObject(props);
    TreeContext.dependencies = null;
    return [
        props,
        dependencies
    ];
}
function updateRef(ref, value) {
    if (ref) {
        if ((0, _shared.is).fun(ref)) ref(value);
        else ref.current = value;
    }
    return value;
}
// src/createHost.ts
var cacheKey = Symbol.for("AnimatedComponent");
var createHost = (components, { applyAnimatedValues = ()=>false, createAnimatedStyle = (style)=>new AnimatedObject(style), getComponentProps = (props)=>props } = {})=>{
    const hostConfig = {
        applyAnimatedValues,
        createAnimatedStyle,
        getComponentProps
    };
    const animated = (Component)=>{
        const displayName = getDisplayName(Component) || "Anonymous";
        if ((0, _shared.is).str(Component)) Component = animated[Component] || (animated[Component] = withAnimated(Component, hostConfig));
        else Component = Component[cacheKey] || (Component[cacheKey] = withAnimated(Component, hostConfig));
        Component.displayName = `Animated(${displayName})`;
        return Component;
    };
    (0, _shared.eachProp)(components, (Component, key)=>{
        if ((0, _shared.is).arr(components)) key = getDisplayName(Component);
        animated[key] = animated(Component);
    });
    return {
        animated
    };
};
var getDisplayName = (arg)=>(0, _shared.is).str(arg) ? arg : arg && (0, _shared.is).str(arg.displayName) ? arg.displayName : (0, _shared.is).fun(arg) && arg.name || null;

},{"@react-spring/shared":"byxMz","react":"6uln9","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1Kqqt":[function(require,module,exports) {
// src/utils.ts
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Any", ()=>Any);
var Any = class {
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"kiBiP":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ThemeContext", ()=>S);
parcelHelpers.export(exports, "ThemeProvider", ()=>z);
parcelHelpers.export(exports, "borderRadiusToCss", ()=>k);
parcelHelpers.export(exports, "canvasStyleAttributesMapping", ()=>x);
parcelHelpers.export(exports, "constrainBorderRadius", ()=>f);
parcelHelpers.export(exports, "convertStyleAttribute", ()=>g);
parcelHelpers.export(exports, "cssStyleAttributesMapping", ()=>h);
parcelHelpers.export(exports, "defaultTheme", ()=>C);
parcelHelpers.export(exports, "extendAxisTheme", ()=>R);
parcelHelpers.export(exports, "extendDefaultTheme", ()=>O);
parcelHelpers.export(exports, "inheritRootThemeText", ()=>W);
parcelHelpers.export(exports, "normalizeBorderRadius", ()=>a);
parcelHelpers.export(exports, "sanitizeHtmlTextStyle", ()=>v);
parcelHelpers.export(exports, "sanitizeSvgTextStyle", ()=>b);
parcelHelpers.export(exports, "styleAttributesMapping", ()=>m);
parcelHelpers.export(exports, "svgStyleAttributesMapping", ()=>p);
parcelHelpers.export(exports, "useExtendedAxisTheme", ()=>w);
parcelHelpers.export(exports, "usePartialTheme", ()=>L);
parcelHelpers.export(exports, "useTheme", ()=>M);
var _react = require("react");
var _mergeJs = require("lodash/merge.js");
var _mergeJsDefault = parcelHelpers.interopDefault(_mergeJs);
var _getJs = require("lodash/get.js");
var _getJsDefault = parcelHelpers.interopDefault(_getJs);
var _setJs = require("lodash/set.js");
var _setJsDefault = parcelHelpers.interopDefault(_setJs);
var _jsxRuntime = require("react/jsx-runtime");
var a = function(t) {
    var e, o, i, n;
    if (null == t || "object" != typeof t) return {
        topLeft: t,
        topRight: t,
        bottomRight: t,
        bottomLeft: t
    };
    var r = t, l = r.top, a = r.bottom, f = r.left, u = r.right;
    return {
        topLeft: null != (e = r.topLeft) ? e : void 0 !== l ? l : null != f ? f : 0,
        topRight: null != (o = r.topRight) ? o : void 0 !== l ? l : null != u ? u : 0,
        bottomRight: null != (i = r.bottomRight) ? i : void 0 !== a ? a : null != u ? u : 0,
        bottomLeft: null != (n = r.bottomLeft) ? n : void 0 !== a ? a : null != f ? f : 0
    };
}, f = function(t, e, o) {
    var i = a(t), n = i.topLeft, r = i.topRight, l = i.bottomRight, f = i.bottomLeft, u = Math.max(0, n), d = Math.max(0, r), s = Math.max(0, l), c = Math.max(0, f), p = u + d;
    if (p > e) {
        var h = e / p;
        u *= h, d *= h;
    }
    var x = c + s;
    if (x > e) {
        var m = e / x;
        c *= m, s *= m;
    }
    var g = u + c;
    if (g > o) {
        var b = o / g;
        u *= b, c *= b;
    }
    var v = d + s;
    if (v > o) {
        var k = o / v;
        d *= k, s *= k;
    }
    return {
        topLeft: u,
        topRight: d,
        bottomRight: s,
        bottomLeft: c
    };
};
function u() {
    return u = Object.assign ? Object.assign.bind() : function(t) {
        for(var e = 1; e < arguments.length; e++){
            var o = arguments[e];
            for(var i in o)({}).hasOwnProperty.call(o, i) && (t[i] = o[i]);
        }
        return t;
    }, u.apply(null, arguments);
}
function d(t, e) {
    if (null == t) return {};
    var o = {};
    for(var i in t)if (({}).hasOwnProperty.call(t, i)) {
        if (-1 !== e.indexOf(i)) continue;
        o[i] = t[i];
    }
    return o;
}
var s = [
    "outlineWidth",
    "outlineColor",
    "outlineOpacity"
], c = [
    "fill",
    "outlineWidth",
    "outlineColor",
    "outlineOpacity"
], p = {
    textAlign: {
        start: "start",
        center: "middle",
        end: "end"
    },
    textBaseline: {
        top: "text-before-edge",
        center: "middle",
        bottom: "text-after-edge"
    }
}, h = {
    textAlign: {
        start: "left",
        center: "center",
        end: "right"
    },
    textBaseline: {
        top: "top",
        center: "middle",
        bottom: "bottom"
    }
}, x = {
    textAlign: {
        start: "left",
        center: "center",
        end: "right"
    },
    textBaseline: {
        top: "top",
        center: "middle",
        bottom: "bottom"
    }
}, m = {
    svg: p,
    css: h,
    canvas: x
}, g = function(t, e, o) {
    return m[t][e][o];
}, b = function(t) {
    return t.outlineWidth, t.outlineColor, t.outlineOpacity, d(t, s);
}, v = function(t) {
    var e = t.fill;
    return t.outlineWidth, t.outlineColor, t.outlineOpacity, u({}, d(t, c), {
        color: e
    });
}, k = function(t) {
    return t.topLeft + "px " + t.topRight + "px " + t.bottomRight + "px " + t.bottomLeft + "px";
}, y = [
    "axis.ticks.text",
    "axis.legend.text",
    "legends.title.text",
    "legends.text",
    "legends.ticks.text",
    "legends.title.text",
    "labels.text",
    "dots.text",
    "markers.text",
    "annotations.text"
], W = function(t, e) {
    return u({}, e, t);
}, O = function(t, e) {
    var o = (0, _mergeJsDefault.default)({}, t, e);
    return y.forEach(function(t) {
        (0, _setJsDefault.default)(o, t, W((0, _getJsDefault.default)(o, t), o.text));
    }), o;
}, R = function(t, e) {
    return e ? (0, _mergeJsDefault.default)({}, t, e) : t;
}, C = {
    background: "transparent",
    text: {
        fontFamily: "sans-serif",
        fontSize: 11,
        fill: "#333333",
        outlineWidth: 0,
        outlineColor: "#ffffff",
        outlineOpacity: 1
    },
    axis: {
        domain: {
            line: {
                stroke: "transparent",
                strokeWidth: 1
            }
        },
        ticks: {
            line: {
                stroke: "#777777",
                strokeWidth: 1
            },
            text: {}
        },
        legend: {
            text: {
                fontSize: 12
            }
        }
    },
    grid: {
        line: {
            stroke: "#dddddd",
            strokeWidth: 1
        }
    },
    legends: {
        hidden: {
            symbol: {
                fill: "#333333",
                opacity: .6
            },
            text: {
                fill: "#333333",
                opacity: .6
            }
        },
        text: {},
        ticks: {
            line: {
                stroke: "#777777",
                strokeWidth: 1
            },
            text: {
                fontSize: 10
            }
        },
        title: {
            text: {}
        }
    },
    labels: {
        text: {}
    },
    markers: {
        lineColor: "#000000",
        lineStrokeWidth: 1,
        text: {}
    },
    dots: {
        text: {}
    },
    tooltip: {
        container: {
            background: "white",
            color: "inherit",
            fontSize: "inherit",
            borderRadius: "2px",
            boxShadow: "0 1px 2px rgba(0, 0, 0, 0.25)",
            padding: "5px 9px"
        },
        basic: {
            whiteSpace: "pre",
            display: "flex",
            alignItems: "center"
        },
        chip: {
            marginRight: 7
        },
        table: {},
        tableCell: {
            padding: "3px 5px"
        },
        tableCellValue: {
            fontWeight: "bold"
        }
    },
    crosshair: {
        line: {
            stroke: "#000000",
            strokeWidth: 1,
            strokeOpacity: .75,
            strokeDasharray: "6 6"
        }
    },
    annotations: {
        text: {
            fontSize: 13,
            outlineWidth: 2,
            outlineColor: "#ffffff",
            outlineOpacity: 1
        },
        link: {
            stroke: "#000000",
            strokeWidth: 1,
            outlineWidth: 2,
            outlineColor: "#ffffff",
            outlineOpacity: 1
        },
        outline: {
            fill: "none",
            stroke: "#000000",
            strokeWidth: 2,
            outlineWidth: 2,
            outlineColor: "#ffffff",
            outlineOpacity: 1
        },
        symbol: {
            fill: "#000000",
            outlineWidth: 2,
            outlineColor: "#ffffff",
            outlineOpacity: 1
        }
    }
}, L = function(e) {
    return (0, _react.useMemo)(function() {
        return O(C, e);
    }, [
        e
    ]);
}, w = function(e, o) {
    return (0, _react.useMemo)(function() {
        return R(e, o);
    }, [
        e,
        o
    ]);
}, S = (0, _react.createContext)(null), j = {}, z = function(t) {
    var e = t.theme, o = void 0 === e ? j : e, i = t.children, n = L(o);
    return (0, _jsxRuntime.jsx)(S.Provider, {
        value: n,
        children: i
    });
}, M = function() {
    var t = (0, _react.useContext)(S);
    if (null === t) throw new Error("Unable to find the theme, did you forget to wrap your component with ThemeProvider?");
    return t;
};

},{"react":"6uln9","lodash/merge.js":"68Goo","lodash/get.js":"8z6tS","lodash/set.js":"dUuaa","react/jsx-runtime":"gaGEj","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"68Goo":[function(require,module,exports) {
var baseMerge = require("7b601c4be119b25d"), createAssigner = require("e87a09d93c0fc32d");
/**
 * This method is like `_.assign` except that it recursively merges own and
 * inherited enumerable string keyed properties of source objects into the
 * destination object. Source properties that resolve to `undefined` are
 * skipped if a destination value exists. Array and plain object properties
 * are merged recursively. Other objects and value types are overridden by
 * assignment. Source objects are applied from left to right. Subsequent
 * sources overwrite property assignments of previous sources.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 0.5.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = {
 *   'a': [{ 'b': 2 }, { 'd': 4 }]
 * };
 *
 * var other = {
 *   'a': [{ 'c': 3 }, { 'e': 5 }]
 * };
 *
 * _.merge(object, other);
 * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
 */ var merge = createAssigner(function(object, source, srcIndex) {
    baseMerge(object, source, srcIndex);
});
module.exports = merge;

},{"7b601c4be119b25d":"fmzk3","e87a09d93c0fc32d":"6yvTP"}],"fmzk3":[function(require,module,exports) {
var Stack = require("49ff021be75c93ea"), assignMergeValue = require("76e9fd6386317324"), baseFor = require("e7dca58bcfe9c669"), baseMergeDeep = require("4ea46d88599071ec"), isObject = require("c52c932be04280cc"), keysIn = require("27adf66142f57b4b"), safeGet = require("564385b2292facea");
/**
 * The base implementation of `_.merge` without support for multiple sources.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} [customizer] The function to customize merged values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */ function baseMerge(object, source, srcIndex, customizer, stack) {
    if (object === source) return;
    baseFor(source, function(srcValue, key) {
        stack || (stack = new Stack);
        if (isObject(srcValue)) baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
        else {
            var newValue = customizer ? customizer(safeGet(object, key), srcValue, key + "", object, source, stack) : undefined;
            if (newValue === undefined) newValue = srcValue;
            assignMergeValue(object, key, newValue);
        }
    }, keysIn);
}
module.exports = baseMerge;

},{"49ff021be75c93ea":"l4EdS","76e9fd6386317324":"aiqBb","e7dca58bcfe9c669":"5bb9g","4ea46d88599071ec":"9D0e6","c52c932be04280cc":"3TlAp","27adf66142f57b4b":"1kPzt","564385b2292facea":"82z3k"}],"aiqBb":[function(require,module,exports) {
var baseAssignValue = require("30a6c72f04f5134"), eq = require("7d9c95e1ffdd4f16");
/**
 * This function is like `assignValue` except that it doesn't assign
 * `undefined` values.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function assignMergeValue(object, key, value) {
    if (value !== undefined && !eq(object[key], value) || value === undefined && !(key in object)) baseAssignValue(object, key, value);
}
module.exports = assignMergeValue;

},{"30a6c72f04f5134":"4b75V","7d9c95e1ffdd4f16":"5Gmi2"}],"9D0e6":[function(require,module,exports) {
var assignMergeValue = require("4af3e5b0ee4c14f6"), cloneBuffer = require("ec8e1b90277c5e12"), cloneTypedArray = require("4b1a2b5090faf247"), copyArray = require("d7675bdf0a02bffc"), initCloneObject = require("1067a6f3f6bd5986"), isArguments = require("2238139506f6727b"), isArray = require("290c774b41e416bb"), isArrayLikeObject = require("f481819c40e5b527"), isBuffer = require("6532fda6a198015f"), isFunction = require("7f306c94b573f977"), isObject = require("32c89e763261c579"), isPlainObject = require("ff359d315efefc4f"), isTypedArray = require("61ce92c01fd411fe"), safeGet = require("abfa8f7e72201edb"), toPlainObject = require("c54d414b219fa287");
/**
 * A specialized version of `baseMerge` for arrays and objects which performs
 * deep merges and tracks traversed objects enabling objects with circular
 * references to be merged.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {string} key The key of the value to merge.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} mergeFunc The function to merge values.
 * @param {Function} [customizer] The function to customize assigned values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */ function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
    var objValue = safeGet(object, key), srcValue = safeGet(source, key), stacked = stack.get(srcValue);
    if (stacked) {
        assignMergeValue(object, key, stacked);
        return;
    }
    var newValue = customizer ? customizer(objValue, srcValue, key + "", object, source, stack) : undefined;
    var isCommon = newValue === undefined;
    if (isCommon) {
        var isArr = isArray(srcValue), isBuff = !isArr && isBuffer(srcValue), isTyped = !isArr && !isBuff && isTypedArray(srcValue);
        newValue = srcValue;
        if (isArr || isBuff || isTyped) {
            if (isArray(objValue)) newValue = objValue;
            else if (isArrayLikeObject(objValue)) newValue = copyArray(objValue);
            else if (isBuff) {
                isCommon = false;
                newValue = cloneBuffer(srcValue, true);
            } else if (isTyped) {
                isCommon = false;
                newValue = cloneTypedArray(srcValue, true);
            } else newValue = [];
        } else if (isPlainObject(srcValue) || isArguments(srcValue)) {
            newValue = objValue;
            if (isArguments(objValue)) newValue = toPlainObject(objValue);
            else if (!isObject(objValue) || isFunction(objValue)) newValue = initCloneObject(srcValue);
        } else isCommon = false;
    }
    if (isCommon) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, newValue);
        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
        stack["delete"](srcValue);
    }
    assignMergeValue(object, key, newValue);
}
module.exports = baseMergeDeep;

},{"4af3e5b0ee4c14f6":"aiqBb","ec8e1b90277c5e12":"36agR","4b1a2b5090faf247":"iCbSW","d7675bdf0a02bffc":"7vKch","1067a6f3f6bd5986":"eUm3n","2238139506f6727b":"asnYU","290c774b41e416bb":"2VsjV","f481819c40e5b527":"hn1J7","6532fda6a198015f":"kfeDT","7f306c94b573f977":"i4ymb","32c89e763261c579":"3TlAp","ff359d315efefc4f":"aYsgZ","61ce92c01fd411fe":"hUF8Z","abfa8f7e72201edb":"82z3k","c54d414b219fa287":"d7D9A"}],"36agR":[function(require,module,exports) {
var root = require("5d68e87b918bbcc5");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? root.Buffer : undefined, allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;
/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */ function cloneBuffer(buffer, isDeep) {
    if (isDeep) return buffer.slice();
    var length = buffer.length, result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
    buffer.copy(result);
    return result;
}
module.exports = cloneBuffer;

},{"5d68e87b918bbcc5":"iGWPT"}],"iCbSW":[function(require,module,exports) {
var cloneArrayBuffer = require("b3183de060e04548");
/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */ function cloneTypedArray(typedArray, isDeep) {
    var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
    return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}
module.exports = cloneTypedArray;

},{"b3183de060e04548":"1MB0T"}],"1MB0T":[function(require,module,exports) {
var Uint8Array = require("c50984a96481fd62");
/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */ function cloneArrayBuffer(arrayBuffer) {
    var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
    new Uint8Array(result).set(new Uint8Array(arrayBuffer));
    return result;
}
module.exports = cloneArrayBuffer;

},{"c50984a96481fd62":"5fXsE"}],"7vKch":[function(require,module,exports) {
/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */ function copyArray(source, array) {
    var index = -1, length = source.length;
    array || (array = Array(length));
    while(++index < length)array[index] = source[index];
    return array;
}
module.exports = copyArray;

},{}],"eUm3n":[function(require,module,exports) {
var baseCreate = require("4a25a11eb90445e8"), getPrototype = require("8c92276927b7c3e0"), isPrototype = require("e939f15d7a0f64a5");
/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */ function initCloneObject(object) {
    return typeof object.constructor == "function" && !isPrototype(object) ? baseCreate(getPrototype(object)) : {};
}
module.exports = initCloneObject;

},{"4a25a11eb90445e8":"9zHQ7","8c92276927b7c3e0":"lvQrI","e939f15d7a0f64a5":"hcjX5"}],"9zHQ7":[function(require,module,exports) {
var isObject = require("2c87f13f7934e7bd");
/** Built-in value references. */ var objectCreate = Object.create;
/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */ var baseCreate = function() {
    function object() {}
    return function(proto) {
        if (!isObject(proto)) return {};
        if (objectCreate) return objectCreate(proto);
        object.prototype = proto;
        var result = new object;
        object.prototype = undefined;
        return result;
    };
}();
module.exports = baseCreate;

},{"2c87f13f7934e7bd":"3TlAp"}],"lvQrI":[function(require,module,exports) {
var overArg = require("11c2fcc01fbb2119");
/** Built-in value references. */ var getPrototype = overArg(Object.getPrototypeOf, Object);
module.exports = getPrototype;

},{"11c2fcc01fbb2119":"5rEQb"}],"hn1J7":[function(require,module,exports) {
var isArrayLike = require("9ce7efb3ed8cb283"), isObjectLike = require("639a4883b097af28");
/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */ function isArrayLikeObject(value) {
    return isObjectLike(value) && isArrayLike(value);
}
module.exports = isArrayLikeObject;

},{"9ce7efb3ed8cb283":"5uWOF","639a4883b097af28":"5TH1N"}],"aYsgZ":[function(require,module,exports) {
var baseGetTag = require("c03dd41ed9922dd2"), getPrototype = require("2ca5b85a120835de"), isObjectLike = require("963b65e043435612");
/** `Object#toString` result references. */ var objectTag = "[object Object]";
/** Used for built-in method references. */ var funcProto = Function.prototype, objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/** Used to infer the `Object` constructor. */ var objectCtorString = funcToString.call(Object);
/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */ function isPlainObject(value) {
    if (!isObjectLike(value) || baseGetTag(value) != objectTag) return false;
    var proto = getPrototype(value);
    if (proto === null) return true;
    var Ctor = hasOwnProperty.call(proto, "constructor") && proto.constructor;
    return typeof Ctor == "function" && Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString;
}
module.exports = isPlainObject;

},{"c03dd41ed9922dd2":"fQG2h","2ca5b85a120835de":"lvQrI","963b65e043435612":"5TH1N"}],"82z3k":[function(require,module,exports) {
/**
 * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function safeGet(object, key) {
    if (key === "constructor" && typeof object[key] === "function") return;
    if (key == "__proto__") return;
    return object[key];
}
module.exports = safeGet;

},{}],"d7D9A":[function(require,module,exports) {
var copyObject = require("6377e94c7c46b197"), keysIn = require("437a3e3814017158");
/**
 * Converts `value` to a plain object flattening inherited enumerable string
 * keyed properties of `value` to own properties of the plain object.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {Object} Returns the converted plain object.
 * @example
 *
 * function Foo() {
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.assign({ 'a': 1 }, new Foo);
 * // => { 'a': 1, 'b': 2 }
 *
 * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
 * // => { 'a': 1, 'b': 2, 'c': 3 }
 */ function toPlainObject(value) {
    return copyObject(value, keysIn(value));
}
module.exports = toPlainObject;

},{"6377e94c7c46b197":"d4hzg","437a3e3814017158":"1kPzt"}],"d4hzg":[function(require,module,exports) {
var assignValue = require("51e2769785cbfa78"), baseAssignValue = require("9cddf6ac1a092765");
/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */ function copyObject(source, props, object, customizer) {
    var isNew = !object;
    object || (object = {});
    var index = -1, length = props.length;
    while(++index < length){
        var key = props[index];
        var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;
        if (newValue === undefined) newValue = source[key];
        if (isNew) baseAssignValue(object, key, newValue);
        else assignValue(object, key, newValue);
    }
    return object;
}
module.exports = copyObject;

},{"51e2769785cbfa78":"9tFgZ","9cddf6ac1a092765":"4b75V"}],"9tFgZ":[function(require,module,exports) {
var baseAssignValue = require("be513dd57a36b3f4"), eq = require("b62ef95b3cf1cde1");
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function assignValue(object, key, value) {
    var objValue = object[key];
    if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) || value === undefined && !(key in object)) baseAssignValue(object, key, value);
}
module.exports = assignValue;

},{"be513dd57a36b3f4":"4b75V","b62ef95b3cf1cde1":"5Gmi2"}],"1kPzt":[function(require,module,exports) {
var arrayLikeKeys = require("635aebb56f3a408f"), baseKeysIn = require("194eb1a802636842"), isArrayLike = require("ac15afdc3ddd76cd");
/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */ function keysIn(object) {
    return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
}
module.exports = keysIn;

},{"635aebb56f3a408f":"2dYEW","194eb1a802636842":"4Tg9i","ac15afdc3ddd76cd":"5uWOF"}],"4Tg9i":[function(require,module,exports) {
var isObject = require("bd1636f5883f1002"), isPrototype = require("f7d53cd92b2b977b"), nativeKeysIn = require("c039208a16eb68bd");
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function baseKeysIn(object) {
    if (!isObject(object)) return nativeKeysIn(object);
    var isProto = isPrototype(object), result = [];
    for(var key in object)if (!(key == "constructor" && (isProto || !hasOwnProperty.call(object, key)))) result.push(key);
    return result;
}
module.exports = baseKeysIn;

},{"bd1636f5883f1002":"3TlAp","f7d53cd92b2b977b":"hcjX5","c039208a16eb68bd":"krurR"}],"krurR":[function(require,module,exports) {
/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function nativeKeysIn(object) {
    var result = [];
    if (object != null) for(var key in Object(object))result.push(key);
    return result;
}
module.exports = nativeKeysIn;

},{}],"6yvTP":[function(require,module,exports) {
var baseRest = require("b91f3c8e236f389b"), isIterateeCall = require("4f5832110eba92d3");
/**
 * Creates a function like `_.assign`.
 *
 * @private
 * @param {Function} assigner The function to assign values.
 * @returns {Function} Returns the new assigner function.
 */ function createAssigner(assigner) {
    return baseRest(function(object, sources) {
        var index = -1, length = sources.length, customizer = length > 1 ? sources[length - 1] : undefined, guard = length > 2 ? sources[2] : undefined;
        customizer = assigner.length > 3 && typeof customizer == "function" ? (length--, customizer) : undefined;
        if (guard && isIterateeCall(sources[0], sources[1], guard)) {
            customizer = length < 3 ? undefined : customizer;
            length = 1;
        }
        object = Object(object);
        while(++index < length){
            var source = sources[index];
            if (source) assigner(object, source, index, customizer);
        }
        return object;
    });
}
module.exports = createAssigner;

},{"b91f3c8e236f389b":"9p3xS","4f5832110eba92d3":"hr6A6"}],"9p3xS":[function(require,module,exports) {
var identity = require("3b2979bd51a0f85f"), overRest = require("ff7d23ff2a2ea6f8"), setToString = require("a11d545e809d14f7");
/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */ function baseRest(func, start) {
    return setToString(overRest(func, start, identity), func + "");
}
module.exports = baseRest;

},{"3b2979bd51a0f85f":"71tSl","ff7d23ff2a2ea6f8":"atctO","a11d545e809d14f7":"dubzo"}],"atctO":[function(require,module,exports) {
var apply = require("6f683b05f63ed25a");
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeMax = Math.max;
/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */ function overRest(func, start, transform) {
    start = nativeMax(start === undefined ? func.length - 1 : start, 0);
    return function() {
        var args = arguments, index = -1, length = nativeMax(args.length - start, 0), array = Array(length);
        while(++index < length)array[index] = args[start + index];
        index = -1;
        var otherArgs = Array(start + 1);
        while(++index < start)otherArgs[index] = args[index];
        otherArgs[start] = transform(array);
        return apply(func, this, otherArgs);
    };
}
module.exports = overRest;

},{"6f683b05f63ed25a":"ibr7y"}],"ibr7y":[function(require,module,exports) {
/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */ function apply(func, thisArg, args) {
    switch(args.length){
        case 0:
            return func.call(thisArg);
        case 1:
            return func.call(thisArg, args[0]);
        case 2:
            return func.call(thisArg, args[0], args[1]);
        case 3:
            return func.call(thisArg, args[0], args[1], args[2]);
    }
    return func.apply(thisArg, args);
}
module.exports = apply;

},{}],"dubzo":[function(require,module,exports) {
var baseSetToString = require("eebd487fbab521b6"), shortOut = require("9114f59293388d49");
/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */ var setToString = shortOut(baseSetToString);
module.exports = setToString;

},{"eebd487fbab521b6":"aUcbM","9114f59293388d49":"j9OR0"}],"aUcbM":[function(require,module,exports) {
var constant = require("706929c7b4749485"), defineProperty = require("eff1240bc0447727"), identity = require("b00d1e57326793e1");
/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */ var baseSetToString = !defineProperty ? identity : function(func, string) {
    return defineProperty(func, "toString", {
        "configurable": true,
        "enumerable": false,
        "value": constant(string),
        "writable": true
    });
};
module.exports = baseSetToString;

},{"706929c7b4749485":"hrIfL","eff1240bc0447727":"51SSX","b00d1e57326793e1":"71tSl"}],"hrIfL":[function(require,module,exports) {
/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */ function constant(value) {
    return function() {
        return value;
    };
}
module.exports = constant;

},{}],"j9OR0":[function(require,module,exports) {
/** Used to detect hot functions by number of calls within a span of milliseconds. */ var HOT_COUNT = 800, HOT_SPAN = 16;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeNow = Date.now;
/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */ function shortOut(func) {
    var count = 0, lastCalled = 0;
    return function() {
        var stamp = nativeNow(), remaining = HOT_SPAN - (stamp - lastCalled);
        lastCalled = stamp;
        if (remaining > 0) {
            if (++count >= HOT_COUNT) return arguments[0];
        } else count = 0;
        return func.apply(undefined, arguments);
    };
}
module.exports = shortOut;

},{}],"hr6A6":[function(require,module,exports) {
var eq = require("a8ec2a011d2eca69"), isArrayLike = require("616bc732534dffe0"), isIndex = require("e781332a36d1bd7"), isObject = require("c8548bf6929b8a5d");
/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */ function isIterateeCall(value, index, object) {
    if (!isObject(object)) return false;
    var type = typeof index;
    if (type == "number" ? isArrayLike(object) && isIndex(index, object.length) : type == "string" && index in object) return eq(object[index], value);
    return false;
}
module.exports = isIterateeCall;

},{"a8ec2a011d2eca69":"5Gmi2","616bc732534dffe0":"5uWOF","e781332a36d1bd7":"9uPJ6","c8548bf6929b8a5d":"3TlAp"}],"dUuaa":[function(require,module,exports) {
var baseSet = require("a003324b62105673");
/**
 * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
 * it's created. Arrays are created for missing index properties while objects
 * are created for all other missing properties. Use `_.setWith` to customize
 * `path` creation.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.set(object, 'a[0].b.c', 4);
 * console.log(object.a[0].b.c);
 * // => 4
 *
 * _.set(object, ['x', '0', 'y', 'z'], 5);
 * console.log(object.x[0].y.z);
 * // => 5
 */ function set(object, path, value) {
    return object == null ? object : baseSet(object, path, value);
}
module.exports = set;

},{"a003324b62105673":"k40cK"}],"k40cK":[function(require,module,exports) {
var assignValue = require("a01f3b7ce097c710"), castPath = require("56e0b8a492d56399"), isIndex = require("d1eb8acc5a65dc38"), isObject = require("dfb182b16ef275c0"), toKey = require("6a51dc787ca5b6e3");
/**
 * The base implementation of `_.set`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @param {Function} [customizer] The function to customize path creation.
 * @returns {Object} Returns `object`.
 */ function baseSet(object, path, value, customizer) {
    if (!isObject(object)) return object;
    path = castPath(path, object);
    var index = -1, length = path.length, lastIndex = length - 1, nested = object;
    while(nested != null && ++index < length){
        var key = toKey(path[index]), newValue = value;
        if (key === "__proto__" || key === "constructor" || key === "prototype") return object;
        if (index != lastIndex) {
            var objValue = nested[key];
            newValue = customizer ? customizer(objValue, key, nested) : undefined;
            if (newValue === undefined) newValue = isObject(objValue) ? objValue : isIndex(path[index + 1]) ? [] : {};
        }
        assignValue(nested, key, newValue);
        nested = nested[key];
    }
    return object;
}
module.exports = baseSet;

},{"a01f3b7ce097c710":"9tFgZ","56e0b8a492d56399":"Q3Xos","d1eb8acc5a65dc38":"9uPJ6","dfb182b16ef275c0":"3TlAp","6a51dc787ca5b6e3":"e9p91"}],"gaGEj":[function(require,module,exports) {
"use strict";
module.exports = require("e5e9711c2edf1a4e");

},{"e5e9711c2edf1a4e":"kbpKW"}],"kbpKW":[function(require,module,exports) {
/** @license React v17.0.2
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
require("ea59cf80247f96ff");
var f = require("3fd2a064dc1f3641"), g = 60103;
exports.Fragment = 60107;
if ("function" === typeof Symbol && Symbol.for) {
    var h = Symbol.for;
    g = h("react.element");
    exports.Fragment = h("react.fragment");
}
var m = f.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, n = Object.prototype.hasOwnProperty, p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function q(c, a, k) {
    var b, d = {}, e = null, l = null;
    void 0 !== k && (e = "" + k);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (l = a.ref);
    for(b in a)n.call(a, b) && !p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: g,
        type: c,
        key: e,
        ref: l,
        props: d,
        _owner: m.current
    };
}
exports.jsx = q;
exports.jsxs = q;

},{"ea59cf80247f96ff":"hdgcG","3fd2a064dc1f3641":"6uln9"}],"hjD1s":[function(require,module,exports) {
var baseGetTag = require("b4b8a393acf14901"), isArray = require("46fdd4d2c5d7b4ab"), isObjectLike = require("36ebbb6a9d8b3fe4");
/** `Object#toString` result references. */ var stringTag = "[object String]";
/**
 * Checks if `value` is classified as a `String` primitive or object.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a string, else `false`.
 * @example
 *
 * _.isString('abc');
 * // => true
 *
 * _.isString(1);
 * // => false
 */ function isString(value) {
    return typeof value == "string" || !isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag;
}
module.exports = isString;

},{"b4b8a393acf14901":"fQG2h","46fdd4d2c5d7b4ab":"2VsjV","36ebbb6a9d8b3fe4":"5TH1N"}],"9eimb":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>AutoSizer);
parcelHelpers.export(exports, "isHeightAndWidthProps", ()=>isHeightAndWidthProps);
parcelHelpers.export(exports, "isHeightOnlyProps", ()=>isHeightOnlyProps);
parcelHelpers.export(exports, "isWidthOnlyProps", ()=>isWidthOnlyProps);
var _react = require("react");
var global = arguments[3];
/**
 * Detect Element Resize.
 * https://github.com/sdecima/javascript-detect-element-resize
 * Sebastian Decima
 *
 * Forked from version 0.5.3; includes the following modifications:
 * 1) Guard against unsafe 'window' and 'document' references (to support SSR).
 * 2) Defer initialization code via a top-level function wrapper (to support SSR).
 * 3) Avoid unnecessary reflows by not measuring size for scroll events bubbling from children.
 * 4) Add nonce for style element.
 * 5) Use 'export' statement over 'module.exports' assignment
 **/ // Check `document` and `window` in case of server-side rendering
let windowObject;
if (typeof window !== "undefined") windowObject = window;
else if (typeof self !== "undefined") // eslint-disable-next-line no-restricted-globals
windowObject = self;
else windowObject = global;
let cancelFrame = null;
let requestFrame = null;
const TIMEOUT_DURATION = 20;
const clearTimeoutFn = windowObject.clearTimeout;
const setTimeoutFn = windowObject.setTimeout;
const cancelAnimationFrameFn = windowObject.cancelAnimationFrame || windowObject.mozCancelAnimationFrame || windowObject.webkitCancelAnimationFrame;
const requestAnimationFrameFn = windowObject.requestAnimationFrame || windowObject.mozRequestAnimationFrame || windowObject.webkitRequestAnimationFrame;
if (cancelAnimationFrameFn == null || requestAnimationFrameFn == null) {
    // For environments that don't support animation frame,
    // fallback to a setTimeout based approach.
    cancelFrame = clearTimeoutFn;
    requestFrame = function requestAnimationFrameViaSetTimeout(callback) {
        return setTimeoutFn(callback, TIMEOUT_DURATION);
    };
} else {
    // Counter intuitively, environments that support animation frames can be trickier.
    // Chrome's "Throttle non-visible cross-origin iframes" flag can prevent rAFs from being called.
    // In this case, we should fallback to a setTimeout() implementation.
    cancelFrame = function cancelFrame([animationFrameID, timeoutID]) {
        cancelAnimationFrameFn(animationFrameID);
        clearTimeoutFn(timeoutID);
    };
    requestFrame = function requestAnimationFrameWithSetTimeoutFallback(callback) {
        const animationFrameID = requestAnimationFrameFn(function animationFrameCallback() {
            clearTimeoutFn(timeoutID);
            callback();
        });
        const timeoutID = setTimeoutFn(function timeoutCallback() {
            cancelAnimationFrameFn(animationFrameID);
            callback();
        }, TIMEOUT_DURATION);
        return [
            animationFrameID,
            timeoutID
        ];
    };
}
function createDetectElementResize(nonce) {
    let animationKeyframes;
    let animationName;
    let animationStartEvent;
    let animationStyle;
    let checkTriggers;
    let resetTriggers;
    let scrollListener;
    const attachEvent = typeof document !== "undefined" && document.attachEvent;
    if (!attachEvent) {
        resetTriggers = function(element) {
            const triggers = element.__resizeTriggers__, expand = triggers.firstElementChild, contract = triggers.lastElementChild, expandChild = expand.firstElementChild;
            contract.scrollLeft = contract.scrollWidth;
            contract.scrollTop = contract.scrollHeight;
            expandChild.style.width = expand.offsetWidth + 1 + "px";
            expandChild.style.height = expand.offsetHeight + 1 + "px";
            expand.scrollLeft = expand.scrollWidth;
            expand.scrollTop = expand.scrollHeight;
        };
        checkTriggers = function(element) {
            return element.offsetWidth !== element.__resizeLast__.width || element.offsetHeight !== element.__resizeLast__.height;
        };
        scrollListener = function(e) {
            // Don't measure (which forces) reflow for scrolls that happen inside of children!
            if (e.target.className && typeof e.target.className.indexOf === "function" && e.target.className.indexOf("contract-trigger") < 0 && e.target.className.indexOf("expand-trigger") < 0) return;
            const element = this;
            resetTriggers(this);
            if (this.__resizeRAF__) cancelFrame(this.__resizeRAF__);
            this.__resizeRAF__ = requestFrame(function animationFrame() {
                if (checkTriggers(element)) {
                    element.__resizeLast__.width = element.offsetWidth;
                    element.__resizeLast__.height = element.offsetHeight;
                    element.__resizeListeners__.forEach(function forEachResizeListener(fn) {
                        fn.call(element, e);
                    });
                }
            });
        };
        /* Detect CSS Animations support to detect element display/re-attach */ let animation = false;
        let keyframeprefix = "";
        animationStartEvent = "animationstart";
        const domPrefixes = "Webkit Moz O ms".split(" ");
        let startEvents = "webkitAnimationStart animationstart oAnimationStart MSAnimationStart".split(" ");
        let pfx = "";
        {
            const elm = document.createElement("fakeelement");
            if (elm.style.animationName !== undefined) animation = true;
            if (animation === false) {
                for(let i = 0; i < domPrefixes.length; i++)if (elm.style[domPrefixes[i] + "AnimationName"] !== undefined) {
                    pfx = domPrefixes[i];
                    keyframeprefix = "-" + pfx.toLowerCase() + "-";
                    animationStartEvent = startEvents[i];
                    animation = true;
                    break;
                }
            }
        }
        animationName = "resizeanim";
        animationKeyframes = "@" + keyframeprefix + "keyframes " + animationName + " { from { opacity: 0; } to { opacity: 0; } } ";
        animationStyle = keyframeprefix + "animation: 1ms " + animationName + "; ";
    }
    const createStyles = function(doc) {
        if (!doc.getElementById("detectElementResize")) {
            //opacity:0 works around a chrome bug https://code.google.com/p/chromium/issues/detail?id=286360
            const css = (animationKeyframes ? animationKeyframes : "") + ".resize-triggers { " + (animationStyle ? animationStyle : "") + "visibility: hidden; opacity: 0; } " + '.resize-triggers, .resize-triggers > div, .contract-trigger:before { content: " "; display: block; position: absolute; top: 0; left: 0; height: 100%; width: 100%; overflow: hidden; z-index: -1; } .resize-triggers > div { background: #eee; overflow: auto; } .contract-trigger:before { width: 200%; height: 200%; }', head = doc.head || doc.getElementsByTagName("head")[0], style = doc.createElement("style");
            style.id = "detectElementResize";
            style.type = "text/css";
            if (nonce != null) style.setAttribute("nonce", nonce);
            if (style.styleSheet) style.styleSheet.cssText = css;
            else style.appendChild(doc.createTextNode(css));
            head.appendChild(style);
        }
    };
    const addResizeListener = function(element, fn) {
        if (attachEvent) element.attachEvent("onresize", fn);
        else {
            if (!element.__resizeTriggers__) {
                const doc = element.ownerDocument;
                const elementStyle = windowObject.getComputedStyle(element);
                if (elementStyle && elementStyle.position === "static") element.style.position = "relative";
                createStyles(doc);
                element.__resizeLast__ = {};
                element.__resizeListeners__ = [];
                (element.__resizeTriggers__ = doc.createElement("div")).className = "resize-triggers";
                const expandTrigger = doc.createElement("div");
                expandTrigger.className = "expand-trigger";
                expandTrigger.appendChild(doc.createElement("div"));
                const contractTrigger = doc.createElement("div");
                contractTrigger.className = "contract-trigger";
                element.__resizeTriggers__.appendChild(expandTrigger);
                element.__resizeTriggers__.appendChild(contractTrigger);
                element.appendChild(element.__resizeTriggers__);
                resetTriggers(element);
                element.addEventListener("scroll", scrollListener, true);
                /* Listen for a css animation to detect element display/re-attach */ if (animationStartEvent) {
                    element.__resizeTriggers__.__animationListener__ = function animationListener(e) {
                        if (e.animationName === animationName) resetTriggers(element);
                    };
                    element.__resizeTriggers__.addEventListener(animationStartEvent, element.__resizeTriggers__.__animationListener__);
                }
            }
            element.__resizeListeners__.push(fn);
        }
    };
    const removeResizeListener = function(element, fn) {
        if (attachEvent) element.detachEvent("onresize", fn);
        else {
            element.__resizeListeners__.splice(element.__resizeListeners__.indexOf(fn), 1);
            if (!element.__resizeListeners__.length) {
                element.removeEventListener("scroll", scrollListener, true);
                if (element.__resizeTriggers__.__animationListener__) {
                    element.__resizeTriggers__.removeEventListener(animationStartEvent, element.__resizeTriggers__.__animationListener__);
                    element.__resizeTriggers__.__animationListener__ = null;
                }
                try {
                    element.__resizeTriggers__ = !element.removeChild(element.__resizeTriggers__);
                } catch (e) {
                // Preact compat; see developit/preact-compat/issues/228
                }
            }
        }
    };
    return {
        addResizeListener,
        removeResizeListener
    };
}
class AutoSizer extends (0, _react.Component) {
    constructor(...args){
        super(...args);
        this.state = {
            height: this.props.defaultHeight || 0,
            width: this.props.defaultWidth || 0
        };
        this._autoSizer = null;
        this._detectElementResize = null;
        this._didLogDeprecationWarning = false;
        this._parentNode = null;
        this._resizeObserver = null;
        this._timeoutId = null;
        this._onResize = ()=>{
            this._timeoutId = null;
            const { disableHeight, disableWidth, onResize } = this.props;
            if (this._parentNode) {
                // Guard against AutoSizer component being removed from the DOM immediately after being added.
                // This can result in invalid style values which can result in NaN values if we don't handle them.
                // See issue #150 for more context.
                const style = window.getComputedStyle(this._parentNode) || {};
                const paddingLeft = parseFloat(style.paddingLeft || "0");
                const paddingRight = parseFloat(style.paddingRight || "0");
                const paddingTop = parseFloat(style.paddingTop || "0");
                const paddingBottom = parseFloat(style.paddingBottom || "0");
                const rect = this._parentNode.getBoundingClientRect();
                const height = rect.height - paddingTop - paddingBottom;
                const width = rect.width - paddingLeft - paddingRight;
                if (!disableHeight && this.state.height !== height || !disableWidth && this.state.width !== width) {
                    this.setState({
                        height,
                        width
                    });
                    const maybeLogDeprecationWarning = ()=>{
                        if (!this._didLogDeprecationWarning) {
                            this._didLogDeprecationWarning = true;
                            console.warn("scaledWidth and scaledHeight parameters have been deprecated; use width and height instead");
                        }
                    };
                    if (typeof onResize === "function") onResize({
                        height,
                        width,
                        // TODO Remove these params in the next major release
                        get scaledHeight () {
                            maybeLogDeprecationWarning();
                            return height;
                        },
                        get scaledWidth () {
                            maybeLogDeprecationWarning();
                            return width;
                        }
                    });
                }
            }
        };
        this._setRef = (autoSizer)=>{
            this._autoSizer = autoSizer;
        };
    }
    componentDidMount() {
        const { nonce } = this.props;
        const parentNode = this._autoSizer ? this._autoSizer.parentNode : null;
        if (parentNode != null && parentNode.ownerDocument && parentNode.ownerDocument.defaultView && parentNode instanceof parentNode.ownerDocument.defaultView.HTMLElement) {
            // Delay access of parentNode until mount.
            // This handles edge-cases where the component has already been unmounted before its ref has been set,
            // As well as libraries like react-lite which have a slightly different lifecycle.
            this._parentNode = parentNode;
            // Use ResizeObserver from the same context where parentNode (which we will observe) was defined
            // Using just global can result into onResize events not being emitted in cases with multiple realms
            const ResizeObserverInstance = parentNode.ownerDocument.defaultView.ResizeObserver;
            if (ResizeObserverInstance != null) {
                this._resizeObserver = new ResizeObserverInstance(()=>{
                    // Guard against "ResizeObserver loop limit exceeded" error;
                    // could be triggered if the state update causes the ResizeObserver handler to run long.
                    // See https://github.com/bvaughn/react-virtualized-auto-sizer/issues/55
                    this._timeoutId = setTimeout(this._onResize, 0);
                });
                this._resizeObserver.observe(parentNode);
            } else {
                // Defer requiring resize handler in order to support server-side rendering.
                // See issue #41
                this._detectElementResize = createDetectElementResize(nonce);
                this._detectElementResize.addResizeListener(parentNode, this._onResize);
            }
            this._onResize();
        }
    }
    componentWillUnmount() {
        if (this._parentNode) {
            if (this._detectElementResize) this._detectElementResize.removeResizeListener(this._parentNode, this._onResize);
            if (this._timeoutId !== null) clearTimeout(this._timeoutId);
            if (this._resizeObserver) this._resizeObserver.disconnect();
        }
    }
    render() {
        const { children, defaultHeight, defaultWidth, disableHeight = false, disableWidth = false, doNotBailOutOnEmptyChildren = false, nonce, onResize, style = {}, tagName = "div", ...rest } = this.props;
        const { height, width } = this.state;
        // Outer div should not force width/height since that may prevent containers from shrinking.
        // Inner component should overflow and use calculated width/height.
        // See issue #68 for more information.
        const outerStyle = {
            overflow: "visible"
        };
        const childParams = {};
        // Avoid rendering children before the initial measurements have been collected.
        // At best this would just be wasting cycles.
        let bailoutOnChildren = false;
        if (!disableHeight) {
            if (height === 0) bailoutOnChildren = true;
            outerStyle.height = 0;
            childParams.height = height;
            // TODO Remove this in the next major release
            childParams.scaledHeight = height;
        }
        if (!disableWidth) {
            if (width === 0) bailoutOnChildren = true;
            outerStyle.width = 0;
            childParams.width = width;
            // TODO Remove this in the next major release
            childParams.scaledWidth = width;
        }
        if (doNotBailOutOnEmptyChildren) bailoutOnChildren = false;
        return (0, _react.createElement)(tagName, {
            ref: this._setRef,
            style: {
                ...outerStyle,
                ...style
            },
            ...rest
        }, !bailoutOnChildren && children(childParams));
    }
}
function isHeightAndWidthProps(props) {
    return props && props.disableHeight !== true && props.disableWidth !== true;
}
function isHeightOnlyProps(props) {
    return props && props.disableHeight !== true && props.disableWidth === true;
}
function isWidthOnlyProps(props) {
    return props && props.disableHeight === true && props.disableWidth !== true;
}

},{"react":"6uln9","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"ionNE":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useDebounce", ()=>a);
parcelHelpers.export(exports, "useDebouncedCallback", ()=>c);
parcelHelpers.export(exports, "useThrottledCallback", ()=>o);
var _react = require("react");
function c(e, u, c, i) {
    var a = this, o = (0, _react.useRef)(null), f = (0, _react.useRef)(0), l = (0, _react.useRef)(0), v = (0, _react.useRef)(null), m = (0, _react.useRef)([]), d = (0, _react.useRef)(), g = (0, _react.useRef)(), p = (0, _react.useRef)(e), w = (0, _react.useRef)(!0);
    p.current = e;
    var s = "undefined" != typeof window, x = !u && 0 !== u && s;
    if ("function" != typeof e) throw new TypeError("Expected a function");
    u = +u || 0;
    var h = !!(c = c || {}).leading, y = !("trailing" in c) || !!c.trailing, F = "maxWait" in c, A = "debounceOnServer" in c && !!c.debounceOnServer, D = F ? Math.max(+c.maxWait || 0, u) : null;
    (0, _react.useEffect)(function() {
        return w.current = !0, function() {
            w.current = !1;
        };
    }, []);
    var T = (0, _react.useMemo)(function() {
        var r = function(r) {
            var n = m.current, t = d.current;
            return m.current = d.current = null, f.current = r, l.current = l.current || r, g.current = p.current.apply(t, n);
        }, n = function(r, n) {
            x && cancelAnimationFrame(v.current), v.current = x ? requestAnimationFrame(r) : setTimeout(r, n);
        }, t = function(r) {
            if (!w.current) return !1;
            var n = r - o.current;
            return !o.current || n >= u || n < 0 || F && r - f.current >= D;
        }, e = function(n) {
            return v.current = null, y && m.current ? r(n) : (m.current = d.current = null, g.current);
        }, c = function r() {
            var c = Date.now();
            if (h && l.current === f.current && T(), t(c)) return e(c);
            if (w.current) {
                var i = u - (c - o.current), a = F ? Math.min(i, D - (c - f.current)) : i;
                n(r, a);
            }
        }, T = function() {
            i && i({});
        }, W = function() {
            if (s || A) {
                var e = Date.now(), i = t(e);
                if (m.current = [].slice.call(arguments), d.current = a, o.current = e, i) {
                    if (!v.current && w.current) return f.current = o.current, n(c, u), h ? r(o.current) : g.current;
                    if (F) return n(c, u), r(o.current);
                }
                return v.current || n(c, u), g.current;
            }
        };
        return W.cancel = function() {
            var r = v.current;
            r && (x ? cancelAnimationFrame(v.current) : clearTimeout(v.current)), f.current = 0, m.current = o.current = d.current = v.current = null, r && i && i({});
        }, W.isPending = function() {
            return !!v.current;
        }, W.flush = function() {
            return v.current ? e(Date.now()) : g.current;
        }, W;
    }, [
        h,
        F,
        u,
        D,
        y,
        x,
        s,
        A,
        i
    ]);
    return T;
}
function i(r, n) {
    return r === n;
}
function a(n, t, a) {
    var o = a && a.equalityFn || i, f = (0, _react.useRef)(n), l = (0, _react.useState)({})[1], v = c((0, _react.useCallback)(function(r) {
        f.current = r, l({});
    }, [
        l
    ]), t, a, l), m = (0, _react.useRef)(n);
    return o(m.current, n) || (v(n), m.current = n), [
        f.current,
        v
    ];
}
function o(r, n, t) {
    var e = void 0 === t ? {} : t, u = e.leading, i = e.trailing;
    return c(r, n, {
        maxWait: n,
        leading: void 0 === u || u,
        trailing: void 0 === i || i
    });
}

},{"react":"6uln9","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6bUMz":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "interpolate", ()=>(0, _valueJsDefault.default));
parcelHelpers.export(exports, "interpolateArray", ()=>(0, _arrayJsDefault.default));
parcelHelpers.export(exports, "interpolateBasis", ()=>(0, _basisJsDefault.default));
parcelHelpers.export(exports, "interpolateBasisClosed", ()=>(0, _basisClosedJsDefault.default));
parcelHelpers.export(exports, "interpolateDate", ()=>(0, _dateJsDefault.default));
parcelHelpers.export(exports, "interpolateDiscrete", ()=>(0, _discreteJsDefault.default));
parcelHelpers.export(exports, "interpolateHue", ()=>(0, _hueJsDefault.default));
parcelHelpers.export(exports, "interpolateNumber", ()=>(0, _numberJsDefault.default));
parcelHelpers.export(exports, "interpolateNumberArray", ()=>(0, _numberArrayJsDefault.default));
parcelHelpers.export(exports, "interpolateObject", ()=>(0, _objectJsDefault.default));
parcelHelpers.export(exports, "interpolateRound", ()=>(0, _roundJsDefault.default));
parcelHelpers.export(exports, "interpolateString", ()=>(0, _stringJsDefault.default));
parcelHelpers.export(exports, "interpolateTransformCss", ()=>(0, _indexJs.interpolateTransformCss));
parcelHelpers.export(exports, "interpolateTransformSvg", ()=>(0, _indexJs.interpolateTransformSvg));
parcelHelpers.export(exports, "interpolateZoom", ()=>(0, _zoomJsDefault.default));
parcelHelpers.export(exports, "interpolateRgb", ()=>(0, _rgbJsDefault.default));
parcelHelpers.export(exports, "interpolateRgbBasis", ()=>(0, _rgbJs.rgbBasis));
parcelHelpers.export(exports, "interpolateRgbBasisClosed", ()=>(0, _rgbJs.rgbBasisClosed));
parcelHelpers.export(exports, "interpolateHsl", ()=>(0, _hslJsDefault.default));
parcelHelpers.export(exports, "interpolateHslLong", ()=>(0, _hslJs.hslLong));
parcelHelpers.export(exports, "interpolateLab", ()=>(0, _labJsDefault.default));
parcelHelpers.export(exports, "interpolateHcl", ()=>(0, _hclJsDefault.default));
parcelHelpers.export(exports, "interpolateHclLong", ()=>(0, _hclJs.hclLong));
parcelHelpers.export(exports, "interpolateCubehelix", ()=>(0, _cubehelixJsDefault.default));
parcelHelpers.export(exports, "interpolateCubehelixLong", ()=>(0, _cubehelixJs.cubehelixLong));
parcelHelpers.export(exports, "piecewise", ()=>(0, _piecewiseJsDefault.default));
parcelHelpers.export(exports, "quantize", ()=>(0, _quantizeJsDefault.default));
var _valueJs = require("./value.js");
var _valueJsDefault = parcelHelpers.interopDefault(_valueJs);
var _arrayJs = require("./array.js");
var _arrayJsDefault = parcelHelpers.interopDefault(_arrayJs);
var _basisJs = require("./basis.js");
var _basisJsDefault = parcelHelpers.interopDefault(_basisJs);
var _basisClosedJs = require("./basisClosed.js");
var _basisClosedJsDefault = parcelHelpers.interopDefault(_basisClosedJs);
var _dateJs = require("./date.js");
var _dateJsDefault = parcelHelpers.interopDefault(_dateJs);
var _discreteJs = require("./discrete.js");
var _discreteJsDefault = parcelHelpers.interopDefault(_discreteJs);
var _hueJs = require("./hue.js");
var _hueJsDefault = parcelHelpers.interopDefault(_hueJs);
var _numberJs = require("./number.js");
var _numberJsDefault = parcelHelpers.interopDefault(_numberJs);
var _numberArrayJs = require("./numberArray.js");
var _numberArrayJsDefault = parcelHelpers.interopDefault(_numberArrayJs);
var _objectJs = require("./object.js");
var _objectJsDefault = parcelHelpers.interopDefault(_objectJs);
var _roundJs = require("./round.js");
var _roundJsDefault = parcelHelpers.interopDefault(_roundJs);
var _stringJs = require("./string.js");
var _stringJsDefault = parcelHelpers.interopDefault(_stringJs);
var _indexJs = require("./transform/index.js");
var _zoomJs = require("./zoom.js");
var _zoomJsDefault = parcelHelpers.interopDefault(_zoomJs);
var _rgbJs = require("./rgb.js");
var _rgbJsDefault = parcelHelpers.interopDefault(_rgbJs);
var _hslJs = require("./hsl.js");
var _hslJsDefault = parcelHelpers.interopDefault(_hslJs);
var _labJs = require("./lab.js");
var _labJsDefault = parcelHelpers.interopDefault(_labJs);
var _hclJs = require("./hcl.js");
var _hclJsDefault = parcelHelpers.interopDefault(_hclJs);
var _cubehelixJs = require("./cubehelix.js");
var _cubehelixJsDefault = parcelHelpers.interopDefault(_cubehelixJs);
var _piecewiseJs = require("./piecewise.js");
var _piecewiseJsDefault = parcelHelpers.interopDefault(_piecewiseJs);
var _quantizeJs = require("./quantize.js");
var _quantizeJsDefault = parcelHelpers.interopDefault(_quantizeJs);

},{"./value.js":"cwEse","./array.js":false,"./basis.js":false,"./basisClosed.js":false,"./date.js":false,"./discrete.js":false,"./hue.js":false,"./number.js":"9apRc","./numberArray.js":false,"./object.js":false,"./round.js":"3ityw","./string.js":"9GlJ4","./transform/index.js":false,"./zoom.js":false,"./rgb.js":"hI9ZC","./hsl.js":false,"./lab.js":false,"./hcl.js":false,"./cubehelix.js":"7lP4n","./piecewise.js":"aazor","./quantize.js":false,"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"cwEse":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(a, b) {
        var t = typeof b, c;
        return b == null || t === "boolean" ? (0, _constantJsDefault.default)(b) : (t === "number" ? (0, _numberJsDefault.default) : t === "string" ? (c = (0, _d3Color.color)(b)) ? (b = c, _rgbJsDefault.default) : (0, _stringJsDefault.default) : b instanceof (0, _d3Color.color) ? (0, _rgbJsDefault.default) : b instanceof Date ? (0, _dateJsDefault.default) : (0, _numberArrayJs.isNumberArray)(b) ? (0, _numberArrayJsDefault.default) : Array.isArray(b) ? (0, _arrayJs.genericArray) : typeof b.valueOf !== "function" && typeof b.toString !== "function" || isNaN(b) ? (0, _objectJsDefault.default) : (0, _numberJsDefault.default))(a, b);
    });
var _d3Color = require("d3-color");
var _rgbJs = require("./rgb.js");
var _rgbJsDefault = parcelHelpers.interopDefault(_rgbJs);
var _arrayJs = require("./array.js");
var _dateJs = require("./date.js");
var _dateJsDefault = parcelHelpers.interopDefault(_dateJs);
var _numberJs = require("./number.js");
var _numberJsDefault = parcelHelpers.interopDefault(_numberJs);
var _objectJs = require("./object.js");
var _objectJsDefault = parcelHelpers.interopDefault(_objectJs);
var _stringJs = require("./string.js");
var _stringJsDefault = parcelHelpers.interopDefault(_stringJs);
var _constantJs = require("./constant.js");
var _constantJsDefault = parcelHelpers.interopDefault(_constantJs);
var _numberArrayJs = require("./numberArray.js");
var _numberArrayJsDefault = parcelHelpers.interopDefault(_numberArrayJs);

},{"d3-color":"euMEi","./rgb.js":"hI9ZC","./array.js":"lLjCm","./date.js":"flWxY","./number.js":"9apRc","./object.js":"4cdV8","./string.js":"9GlJ4","./constant.js":"1LLXa","./numberArray.js":"dwDrC","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"euMEi":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "color", ()=>(0, _colorJsDefault.default));
parcelHelpers.export(exports, "rgb", ()=>(0, _colorJs.rgb));
parcelHelpers.export(exports, "hsl", ()=>(0, _colorJs.hsl));
parcelHelpers.export(exports, "lab", ()=>(0, _labJsDefault.default));
parcelHelpers.export(exports, "hcl", ()=>(0, _labJs.hcl));
parcelHelpers.export(exports, "lch", ()=>(0, _labJs.lch));
parcelHelpers.export(exports, "gray", ()=>(0, _labJs.gray));
parcelHelpers.export(exports, "cubehelix", ()=>(0, _cubehelixJsDefault.default));
var _colorJs = require("./color.js");
var _colorJsDefault = parcelHelpers.interopDefault(_colorJs);
var _labJs = require("./lab.js");
var _labJsDefault = parcelHelpers.interopDefault(_labJs);
var _cubehelixJs = require("./cubehelix.js");
var _cubehelixJsDefault = parcelHelpers.interopDefault(_cubehelixJs);

},{"./color.js":"bKuhM","./lab.js":false,"./cubehelix.js":"aeJEJ","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"bKuhM":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Color", ()=>Color);
parcelHelpers.export(exports, "darker", ()=>darker);
parcelHelpers.export(exports, "brighter", ()=>brighter);
parcelHelpers.export(exports, "default", ()=>color);
parcelHelpers.export(exports, "rgbConvert", ()=>rgbConvert);
parcelHelpers.export(exports, "rgb", ()=>rgb);
parcelHelpers.export(exports, "Rgb", ()=>Rgb);
parcelHelpers.export(exports, "hslConvert", ()=>hslConvert);
parcelHelpers.export(exports, "hsl", ()=>hsl);
var _defineJs = require("./define.js");
var _defineJsDefault = parcelHelpers.interopDefault(_defineJs);
function Color() {}
var darker = 0.7;
var brighter = 1 / darker;
var reI = "\\s*([+-]?\\d+)\\s*", reN = "\\s*([+-]?(?:\\d*\\.)?\\d+(?:[eE][+-]?\\d+)?)\\s*", reP = "\\s*([+-]?(?:\\d*\\.)?\\d+(?:[eE][+-]?\\d+)?)%\\s*", reHex = /^#([0-9a-f]{3,8})$/, reRgbInteger = new RegExp(`^rgb\\(${reI},${reI},${reI}\\)$`), reRgbPercent = new RegExp(`^rgb\\(${reP},${reP},${reP}\\)$`), reRgbaInteger = new RegExp(`^rgba\\(${reI},${reI},${reI},${reN}\\)$`), reRgbaPercent = new RegExp(`^rgba\\(${reP},${reP},${reP},${reN}\\)$`), reHslPercent = new RegExp(`^hsl\\(${reN},${reP},${reP}\\)$`), reHslaPercent = new RegExp(`^hsla\\(${reN},${reP},${reP},${reN}\\)$`);
var named = {
    aliceblue: 0xf0f8ff,
    antiquewhite: 0xfaebd7,
    aqua: 0x00ffff,
    aquamarine: 0x7fffd4,
    azure: 0xf0ffff,
    beige: 0xf5f5dc,
    bisque: 0xffe4c4,
    black: 0x000000,
    blanchedalmond: 0xffebcd,
    blue: 0x0000ff,
    blueviolet: 0x8a2be2,
    brown: 0xa52a2a,
    burlywood: 0xdeb887,
    cadetblue: 0x5f9ea0,
    chartreuse: 0x7fff00,
    chocolate: 0xd2691e,
    coral: 0xff7f50,
    cornflowerblue: 0x6495ed,
    cornsilk: 0xfff8dc,
    crimson: 0xdc143c,
    cyan: 0x00ffff,
    darkblue: 0x00008b,
    darkcyan: 0x008b8b,
    darkgoldenrod: 0xb8860b,
    darkgray: 0xa9a9a9,
    darkgreen: 0x006400,
    darkgrey: 0xa9a9a9,
    darkkhaki: 0xbdb76b,
    darkmagenta: 0x8b008b,
    darkolivegreen: 0x556b2f,
    darkorange: 0xff8c00,
    darkorchid: 0x9932cc,
    darkred: 0x8b0000,
    darksalmon: 0xe9967a,
    darkseagreen: 0x8fbc8f,
    darkslateblue: 0x483d8b,
    darkslategray: 0x2f4f4f,
    darkslategrey: 0x2f4f4f,
    darkturquoise: 0x00ced1,
    darkviolet: 0x9400d3,
    deeppink: 0xff1493,
    deepskyblue: 0x00bfff,
    dimgray: 0x696969,
    dimgrey: 0x696969,
    dodgerblue: 0x1e90ff,
    firebrick: 0xb22222,
    floralwhite: 0xfffaf0,
    forestgreen: 0x228b22,
    fuchsia: 0xff00ff,
    gainsboro: 0xdcdcdc,
    ghostwhite: 0xf8f8ff,
    gold: 0xffd700,
    goldenrod: 0xdaa520,
    gray: 0x808080,
    green: 0x008000,
    greenyellow: 0xadff2f,
    grey: 0x808080,
    honeydew: 0xf0fff0,
    hotpink: 0xff69b4,
    indianred: 0xcd5c5c,
    indigo: 0x4b0082,
    ivory: 0xfffff0,
    khaki: 0xf0e68c,
    lavender: 0xe6e6fa,
    lavenderblush: 0xfff0f5,
    lawngreen: 0x7cfc00,
    lemonchiffon: 0xfffacd,
    lightblue: 0xadd8e6,
    lightcoral: 0xf08080,
    lightcyan: 0xe0ffff,
    lightgoldenrodyellow: 0xfafad2,
    lightgray: 0xd3d3d3,
    lightgreen: 0x90ee90,
    lightgrey: 0xd3d3d3,
    lightpink: 0xffb6c1,
    lightsalmon: 0xffa07a,
    lightseagreen: 0x20b2aa,
    lightskyblue: 0x87cefa,
    lightslategray: 0x778899,
    lightslategrey: 0x778899,
    lightsteelblue: 0xb0c4de,
    lightyellow: 0xffffe0,
    lime: 0x00ff00,
    limegreen: 0x32cd32,
    linen: 0xfaf0e6,
    magenta: 0xff00ff,
    maroon: 0x800000,
    mediumaquamarine: 0x66cdaa,
    mediumblue: 0x0000cd,
    mediumorchid: 0xba55d3,
    mediumpurple: 0x9370db,
    mediumseagreen: 0x3cb371,
    mediumslateblue: 0x7b68ee,
    mediumspringgreen: 0x00fa9a,
    mediumturquoise: 0x48d1cc,
    mediumvioletred: 0xc71585,
    midnightblue: 0x191970,
    mintcream: 0xf5fffa,
    mistyrose: 0xffe4e1,
    moccasin: 0xffe4b5,
    navajowhite: 0xffdead,
    navy: 0x000080,
    oldlace: 0xfdf5e6,
    olive: 0x808000,
    olivedrab: 0x6b8e23,
    orange: 0xffa500,
    orangered: 0xff4500,
    orchid: 0xda70d6,
    palegoldenrod: 0xeee8aa,
    palegreen: 0x98fb98,
    paleturquoise: 0xafeeee,
    palevioletred: 0xdb7093,
    papayawhip: 0xffefd5,
    peachpuff: 0xffdab9,
    peru: 0xcd853f,
    pink: 0xffc0cb,
    plum: 0xdda0dd,
    powderblue: 0xb0e0e6,
    purple: 0x800080,
    rebeccapurple: 0x663399,
    red: 0xff0000,
    rosybrown: 0xbc8f8f,
    royalblue: 0x4169e1,
    saddlebrown: 0x8b4513,
    salmon: 0xfa8072,
    sandybrown: 0xf4a460,
    seagreen: 0x2e8b57,
    seashell: 0xfff5ee,
    sienna: 0xa0522d,
    silver: 0xc0c0c0,
    skyblue: 0x87ceeb,
    slateblue: 0x6a5acd,
    slategray: 0x708090,
    slategrey: 0x708090,
    snow: 0xfffafa,
    springgreen: 0x00ff7f,
    steelblue: 0x4682b4,
    tan: 0xd2b48c,
    teal: 0x008080,
    thistle: 0xd8bfd8,
    tomato: 0xff6347,
    turquoise: 0x40e0d0,
    violet: 0xee82ee,
    wheat: 0xf5deb3,
    white: 0xffffff,
    whitesmoke: 0xf5f5f5,
    yellow: 0xffff00,
    yellowgreen: 0x9acd32
};
(0, _defineJsDefault.default)(Color, color, {
    copy (channels) {
        return Object.assign(new this.constructor, this, channels);
    },
    displayable () {
        return this.rgb().displayable();
    },
    hex: color_formatHex,
    formatHex: color_formatHex,
    formatHex8: color_formatHex8,
    formatHsl: color_formatHsl,
    formatRgb: color_formatRgb,
    toString: color_formatRgb
});
function color_formatHex() {
    return this.rgb().formatHex();
}
function color_formatHex8() {
    return this.rgb().formatHex8();
}
function color_formatHsl() {
    return hslConvert(this).formatHsl();
}
function color_formatRgb() {
    return this.rgb().formatRgb();
}
function color(format) {
    var m, l;
    format = (format + "").trim().toLowerCase();
    return (m = reHex.exec(format)) ? (l = m[1].length, m = parseInt(m[1], 16), l === 6 ? rgbn(m) // #ff0000
     : l === 3 ? new Rgb(m >> 8 & 0xf | m >> 4 & 0xf0, m >> 4 & 0xf | m & 0xf0, (m & 0xf) << 4 | m & 0xf, 1) // #f00
     : l === 8 ? rgba(m >> 24 & 0xff, m >> 16 & 0xff, m >> 8 & 0xff, (m & 0xff) / 0xff) // #ff000000
     : l === 4 ? rgba(m >> 12 & 0xf | m >> 8 & 0xf0, m >> 8 & 0xf | m >> 4 & 0xf0, m >> 4 & 0xf | m & 0xf0, ((m & 0xf) << 4 | m & 0xf) / 0xff) // #f000
     : null // invalid hex
    ) : (m = reRgbInteger.exec(format)) ? new Rgb(m[1], m[2], m[3], 1) // rgb(255, 0, 0)
     : (m = reRgbPercent.exec(format)) ? new Rgb(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, 1) // rgb(100%, 0%, 0%)
     : (m = reRgbaInteger.exec(format)) ? rgba(m[1], m[2], m[3], m[4]) // rgba(255, 0, 0, 1)
     : (m = reRgbaPercent.exec(format)) ? rgba(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, m[4]) // rgb(100%, 0%, 0%, 1)
     : (m = reHslPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, 1) // hsl(120, 50%, 50%)
     : (m = reHslaPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, m[4]) // hsla(120, 50%, 50%, 1)
     : named.hasOwnProperty(format) ? rgbn(named[format]) // eslint-disable-line no-prototype-builtins
     : format === "transparent" ? new Rgb(NaN, NaN, NaN, 0) : null;
}
function rgbn(n) {
    return new Rgb(n >> 16 & 0xff, n >> 8 & 0xff, n & 0xff, 1);
}
function rgba(r, g, b, a) {
    if (a <= 0) r = g = b = NaN;
    return new Rgb(r, g, b, a);
}
function rgbConvert(o) {
    if (!(o instanceof Color)) o = color(o);
    if (!o) return new Rgb;
    o = o.rgb();
    return new Rgb(o.r, o.g, o.b, o.opacity);
}
function rgb(r, g, b, opacity) {
    return arguments.length === 1 ? rgbConvert(r) : new Rgb(r, g, b, opacity == null ? 1 : opacity);
}
function Rgb(r, g, b, opacity) {
    this.r = +r;
    this.g = +g;
    this.b = +b;
    this.opacity = +opacity;
}
(0, _defineJsDefault.default)(Rgb, rgb, (0, _defineJs.extend)(Color, {
    brighter (k) {
        k = k == null ? brighter : Math.pow(brighter, k);
        return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
    },
    darker (k) {
        k = k == null ? darker : Math.pow(darker, k);
        return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
    },
    rgb () {
        return this;
    },
    clamp () {
        return new Rgb(clampi(this.r), clampi(this.g), clampi(this.b), clampa(this.opacity));
    },
    displayable () {
        return -0.5 <= this.r && this.r < 255.5 && -0.5 <= this.g && this.g < 255.5 && -0.5 <= this.b && this.b < 255.5 && 0 <= this.opacity && this.opacity <= 1;
    },
    hex: rgb_formatHex,
    formatHex: rgb_formatHex,
    formatHex8: rgb_formatHex8,
    formatRgb: rgb_formatRgb,
    toString: rgb_formatRgb
}));
function rgb_formatHex() {
    return `#${hex(this.r)}${hex(this.g)}${hex(this.b)}`;
}
function rgb_formatHex8() {
    return `#${hex(this.r)}${hex(this.g)}${hex(this.b)}${hex((isNaN(this.opacity) ? 1 : this.opacity) * 255)}`;
}
function rgb_formatRgb() {
    const a = clampa(this.opacity);
    return `${a === 1 ? "rgb(" : "rgba("}${clampi(this.r)}, ${clampi(this.g)}, ${clampi(this.b)}${a === 1 ? ")" : `, ${a})`}`;
}
function clampa(opacity) {
    return isNaN(opacity) ? 1 : Math.max(0, Math.min(1, opacity));
}
function clampi(value) {
    return Math.max(0, Math.min(255, Math.round(value) || 0));
}
function hex(value) {
    value = clampi(value);
    return (value < 16 ? "0" : "") + value.toString(16);
}
function hsla(h, s, l, a) {
    if (a <= 0) h = s = l = NaN;
    else if (l <= 0 || l >= 1) h = s = NaN;
    else if (s <= 0) h = NaN;
    return new Hsl(h, s, l, a);
}
function hslConvert(o) {
    if (o instanceof Hsl) return new Hsl(o.h, o.s, o.l, o.opacity);
    if (!(o instanceof Color)) o = color(o);
    if (!o) return new Hsl;
    if (o instanceof Hsl) return o;
    o = o.rgb();
    var r = o.r / 255, g = o.g / 255, b = o.b / 255, min = Math.min(r, g, b), max = Math.max(r, g, b), h = NaN, s = max - min, l = (max + min) / 2;
    if (s) {
        if (r === max) h = (g - b) / s + (g < b) * 6;
        else if (g === max) h = (b - r) / s + 2;
        else h = (r - g) / s + 4;
        s /= l < 0.5 ? max + min : 2 - max - min;
        h *= 60;
    } else s = l > 0 && l < 1 ? 0 : h;
    return new Hsl(h, s, l, o.opacity);
}
function hsl(h, s, l, opacity) {
    return arguments.length === 1 ? hslConvert(h) : new Hsl(h, s, l, opacity == null ? 1 : opacity);
}
function Hsl(h, s, l, opacity) {
    this.h = +h;
    this.s = +s;
    this.l = +l;
    this.opacity = +opacity;
}
(0, _defineJsDefault.default)(Hsl, hsl, (0, _defineJs.extend)(Color, {
    brighter (k) {
        k = k == null ? brighter : Math.pow(brighter, k);
        return new Hsl(this.h, this.s, this.l * k, this.opacity);
    },
    darker (k) {
        k = k == null ? darker : Math.pow(darker, k);
        return new Hsl(this.h, this.s, this.l * k, this.opacity);
    },
    rgb () {
        var h = this.h % 360 + (this.h < 0) * 360, s = isNaN(h) || isNaN(this.s) ? 0 : this.s, l = this.l, m2 = l + (l < 0.5 ? l : 1 - l) * s, m1 = 2 * l - m2;
        return new Rgb(hsl2rgb(h >= 240 ? h - 240 : h + 120, m1, m2), hsl2rgb(h, m1, m2), hsl2rgb(h < 120 ? h + 240 : h - 120, m1, m2), this.opacity);
    },
    clamp () {
        return new Hsl(clamph(this.h), clampt(this.s), clampt(this.l), clampa(this.opacity));
    },
    displayable () {
        return (0 <= this.s && this.s <= 1 || isNaN(this.s)) && 0 <= this.l && this.l <= 1 && 0 <= this.opacity && this.opacity <= 1;
    },
    formatHsl () {
        const a = clampa(this.opacity);
        return `${a === 1 ? "hsl(" : "hsla("}${clamph(this.h)}, ${clampt(this.s) * 100}%, ${clampt(this.l) * 100}%${a === 1 ? ")" : `, ${a})`}`;
    }
}));
function clamph(value) {
    value = (value || 0) % 360;
    return value < 0 ? value + 360 : value;
}
function clampt(value) {
    return Math.max(0, Math.min(1, value || 0));
}
/* From FvD 13.37, CSS Color Module Level 3 */ function hsl2rgb(h, m1, m2) {
    return (h < 60 ? m1 + (m2 - m1) * h / 60 : h < 180 ? m2 : h < 240 ? m1 + (m2 - m1) * (240 - h) / 60 : m1) * 255;
}

},{"./define.js":"dMzf8","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"dMzf8":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(constructor, factory, prototype) {
        constructor.prototype = factory.prototype = prototype;
        prototype.constructor = constructor;
    });
parcelHelpers.export(exports, "extend", ()=>extend);
function extend(parent, definition) {
    var prototype = Object.create(parent.prototype);
    for(var key in definition)prototype[key] = definition[key];
    return prototype;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"aeJEJ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>cubehelix);
parcelHelpers.export(exports, "Cubehelix", ()=>Cubehelix);
var _defineJs = require("./define.js");
var _defineJsDefault = parcelHelpers.interopDefault(_defineJs);
var _colorJs = require("./color.js");
var _mathJs = require("./math.js");
var A = -0.14861, B = 1.78277, C = -0.29227, D = -0.90649, E = 1.97294, ED = E * D, EB = E * B, BC_DA = B * C - D * A;
function cubehelixConvert(o) {
    if (o instanceof Cubehelix) return new Cubehelix(o.h, o.s, o.l, o.opacity);
    if (!(o instanceof (0, _colorJs.Rgb))) o = (0, _colorJs.rgbConvert)(o);
    var r = o.r / 255, g = o.g / 255, b = o.b / 255, l = (BC_DA * b + ED * r - EB * g) / (BC_DA + ED - EB), bl = b - l, k = (E * (g - l) - C * bl) / D, s = Math.sqrt(k * k + bl * bl) / (E * l * (1 - l)), h = s ? Math.atan2(k, bl) * (0, _mathJs.degrees) - 120 : NaN;
    return new Cubehelix(h < 0 ? h + 360 : h, s, l, o.opacity);
}
function cubehelix(h, s, l, opacity) {
    return arguments.length === 1 ? cubehelixConvert(h) : new Cubehelix(h, s, l, opacity == null ? 1 : opacity);
}
function Cubehelix(h, s, l, opacity) {
    this.h = +h;
    this.s = +s;
    this.l = +l;
    this.opacity = +opacity;
}
(0, _defineJsDefault.default)(Cubehelix, cubehelix, (0, _defineJs.extend)((0, _colorJs.Color), {
    brighter (k) {
        k = k == null ? (0, _colorJs.brighter) : Math.pow((0, _colorJs.brighter), k);
        return new Cubehelix(this.h, this.s, this.l * k, this.opacity);
    },
    darker (k) {
        k = k == null ? (0, _colorJs.darker) : Math.pow((0, _colorJs.darker), k);
        return new Cubehelix(this.h, this.s, this.l * k, this.opacity);
    },
    rgb () {
        var h = isNaN(this.h) ? 0 : (this.h + 120) * (0, _mathJs.radians), l = +this.l, a = isNaN(this.s) ? 0 : this.s * l * (1 - l), cosh = Math.cos(h), sinh = Math.sin(h);
        return new (0, _colorJs.Rgb)(255 * (l + a * (A * cosh + B * sinh)), 255 * (l + a * (C * cosh + D * sinh)), 255 * (l + a * (E * cosh)), this.opacity);
    }
}));

},{"./define.js":"dMzf8","./color.js":"bKuhM","./math.js":"bPhIW","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"bPhIW":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "radians", ()=>radians);
parcelHelpers.export(exports, "degrees", ()=>degrees);
const radians = Math.PI / 180;
const degrees = 180 / Math.PI;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hI9ZC":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "rgbBasis", ()=>rgbBasis);
parcelHelpers.export(exports, "rgbBasisClosed", ()=>rgbBasisClosed);
var _d3Color = require("d3-color");
var _basisJs = require("./basis.js");
var _basisJsDefault = parcelHelpers.interopDefault(_basisJs);
var _basisClosedJs = require("./basisClosed.js");
var _basisClosedJsDefault = parcelHelpers.interopDefault(_basisClosedJs);
var _colorJs = require("./color.js");
var _colorJsDefault = parcelHelpers.interopDefault(_colorJs);
exports.default = function rgbGamma(y) {
    var color = (0, _colorJs.gamma)(y);
    function rgb(start, end) {
        var r = color((start = (0, _d3Color.rgb)(start)).r, (end = (0, _d3Color.rgb)(end)).r), g = color(start.g, end.g), b = color(start.b, end.b), opacity = (0, _colorJsDefault.default)(start.opacity, end.opacity);
        return function(t) {
            start.r = r(t);
            start.g = g(t);
            start.b = b(t);
            start.opacity = opacity(t);
            return start + "";
        };
    }
    rgb.gamma = rgbGamma;
    return rgb;
}(1);
function rgbSpline(spline) {
    return function(colors) {
        var n = colors.length, r = new Array(n), g = new Array(n), b = new Array(n), i, color;
        for(i = 0; i < n; ++i){
            color = (0, _d3Color.rgb)(colors[i]);
            r[i] = color.r || 0;
            g[i] = color.g || 0;
            b[i] = color.b || 0;
        }
        r = spline(r);
        g = spline(g);
        b = spline(b);
        color.opacity = 1;
        return function(t) {
            color.r = r(t);
            color.g = g(t);
            color.b = b(t);
            return color + "";
        };
    };
}
var rgbBasis = rgbSpline((0, _basisJsDefault.default));
var rgbBasisClosed = rgbSpline((0, _basisClosedJsDefault.default));

},{"d3-color":"euMEi","./basis.js":"9reI8","./basisClosed.js":"aKD3P","./color.js":"giYtf","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9reI8":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "basis", ()=>basis);
parcelHelpers.export(exports, "default", ()=>function(values) {
        var n = values.length - 1;
        return function(t) {
            var i = t <= 0 ? t = 0 : t >= 1 ? (t = 1, n - 1) : Math.floor(t * n), v1 = values[i], v2 = values[i + 1], v0 = i > 0 ? values[i - 1] : 2 * v1 - v2, v3 = i < n - 1 ? values[i + 2] : 2 * v2 - v1;
            return basis((t - i / n) * n, v0, v1, v2, v3);
        };
    });
function basis(t1, v0, v1, v2, v3) {
    var t2 = t1 * t1, t3 = t2 * t1;
    return ((1 - 3 * t1 + 3 * t2 - t3) * v0 + (4 - 6 * t2 + 3 * t3) * v1 + (1 + 3 * t1 + 3 * t2 - 3 * t3) * v2 + t3 * v3) / 6;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"aKD3P":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(values) {
        var n = values.length;
        return function(t) {
            var i = Math.floor(((t %= 1) < 0 ? ++t : t) * n), v0 = values[(i + n - 1) % n], v1 = values[i % n], v2 = values[(i + 1) % n], v3 = values[(i + 2) % n];
            return (0, _basisJs.basis)((t - i / n) * n, v0, v1, v2, v3);
        };
    });
var _basisJs = require("./basis.js");

},{"./basis.js":"9reI8","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"giYtf":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "hue", ()=>hue);
parcelHelpers.export(exports, "gamma", ()=>gamma);
parcelHelpers.export(exports, "default", ()=>nogamma);
var _constantJs = require("./constant.js");
var _constantJsDefault = parcelHelpers.interopDefault(_constantJs);
function linear(a, d) {
    return function(t) {
        return a + t * d;
    };
}
function exponential(a, b, y) {
    return a = Math.pow(a, y), b = Math.pow(b, y) - a, y = 1 / y, function(t) {
        return Math.pow(a + t * b, y);
    };
}
function hue(a, b) {
    var d = b - a;
    return d ? linear(a, d > 180 || d < -180 ? d - 360 * Math.round(d / 360) : d) : (0, _constantJsDefault.default)(isNaN(a) ? b : a);
}
function gamma(y) {
    return (y = +y) === 1 ? nogamma : function(a, b) {
        return b - a ? exponential(a, b, y) : (0, _constantJsDefault.default)(isNaN(a) ? b : a);
    };
}
function nogamma(a, b) {
    var d = b - a;
    return d ? linear(a, d) : (0, _constantJsDefault.default)(isNaN(a) ? b : a);
}

},{"./constant.js":"1LLXa","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1LLXa":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = (x)=>()=>x;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"lLjCm":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(a, b) {
        return ((0, _numberArrayJs.isNumberArray)(b) ? (0, _numberArrayJsDefault.default) : genericArray)(a, b);
    });
parcelHelpers.export(exports, "genericArray", ()=>genericArray);
var _valueJs = require("./value.js");
var _valueJsDefault = parcelHelpers.interopDefault(_valueJs);
var _numberArrayJs = require("./numberArray.js");
var _numberArrayJsDefault = parcelHelpers.interopDefault(_numberArrayJs);
function genericArray(a, b) {
    var nb = b ? b.length : 0, na = a ? Math.min(nb, a.length) : 0, x = new Array(na), c = new Array(nb), i;
    for(i = 0; i < na; ++i)x[i] = (0, _valueJsDefault.default)(a[i], b[i]);
    for(; i < nb; ++i)c[i] = b[i];
    return function(t) {
        for(i = 0; i < na; ++i)c[i] = x[i](t);
        return c;
    };
}

},{"./value.js":"cwEse","./numberArray.js":"dwDrC","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"dwDrC":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(a, b) {
        if (!b) b = [];
        var n = a ? Math.min(b.length, a.length) : 0, c = b.slice(), i;
        return function(t) {
            for(i = 0; i < n; ++i)c[i] = a[i] * (1 - t) + b[i] * t;
            return c;
        };
    });
parcelHelpers.export(exports, "isNumberArray", ()=>isNumberArray);
function isNumberArray(x) {
    return ArrayBuffer.isView(x) && !(x instanceof DataView);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"flWxY":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(a, b) {
        var d = new Date;
        return a = +a, b = +b, function(t) {
            return d.setTime(a * (1 - t) + b * t), d;
        };
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9apRc":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(a, b) {
        return a = +a, b = +b, function(t) {
            return a * (1 - t) + b * t;
        };
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4cdV8":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(a, b) {
        var i = {}, c = {}, k;
        if (a === null || typeof a !== "object") a = {};
        if (b === null || typeof b !== "object") b = {};
        for(k in b)if (k in a) i[k] = (0, _valueJsDefault.default)(a[k], b[k]);
        else c[k] = b[k];
        return function(t) {
            for(k in i)c[k] = i[k](t);
            return c;
        };
    });
var _valueJs = require("./value.js");
var _valueJsDefault = parcelHelpers.interopDefault(_valueJs);

},{"./value.js":"cwEse","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9GlJ4":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(a, b) {
        var bi = reA.lastIndex = reB.lastIndex = 0, am, bm, bs, i = -1, s = [], q = []; // number interpolators
        // Coerce inputs to strings.
        a = a + "", b = b + "";
        // Interpolate pairs of numbers in a & b.
        while((am = reA.exec(a)) && (bm = reB.exec(b))){
            if ((bs = bm.index) > bi) {
                bs = b.slice(bi, bs);
                if (s[i]) s[i] += bs; // coalesce with previous string
                else s[++i] = bs;
            }
            if ((am = am[0]) === (bm = bm[0])) {
                if (s[i]) s[i] += bm; // coalesce with previous string
                else s[++i] = bm;
            } else {
                s[++i] = null;
                q.push({
                    i: i,
                    x: (0, _numberJsDefault.default)(am, bm)
                });
            }
            bi = reB.lastIndex;
        }
        // Add remains of b.
        if (bi < b.length) {
            bs = b.slice(bi);
            if (s[i]) s[i] += bs; // coalesce with previous string
            else s[++i] = bs;
        }
        // Special optimization for only a single match.
        // Otherwise, interpolate each of the numbers and rejoin the string.
        return s.length < 2 ? q[0] ? one(q[0].x) : zero(b) : (b = q.length, function(t) {
            for(var i = 0, o; i < b; ++i)s[(o = q[i]).i] = o.x(t);
            return s.join("");
        });
    });
var _numberJs = require("./number.js");
var _numberJsDefault = parcelHelpers.interopDefault(_numberJs);
var reA = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g, reB = new RegExp(reA.source, "g");
function zero(b) {
    return function() {
        return b;
    };
}
function one(b) {
    return function(t) {
        return b(t) + "";
    };
}

},{"./number.js":"9apRc","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3ityw":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(a, b) {
        return a = +a, b = +b, function(t) {
            return Math.round(a * (1 - t) + b * t);
        };
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7lP4n":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "cubehelixLong", ()=>cubehelixLong);
var _d3Color = require("d3-color");
var _colorJs = require("./color.js");
var _colorJsDefault = parcelHelpers.interopDefault(_colorJs);
function cubehelix(hue) {
    return function cubehelixGamma(y) {
        y = +y;
        function cubehelix(start, end) {
            var h = hue((start = (0, _d3Color.cubehelix)(start)).h, (end = (0, _d3Color.cubehelix)(end)).h), s = (0, _colorJsDefault.default)(start.s, end.s), l = (0, _colorJsDefault.default)(start.l, end.l), opacity = (0, _colorJsDefault.default)(start.opacity, end.opacity);
            return function(t) {
                start.h = h(t);
                start.s = s(t);
                start.l = l(Math.pow(t, y));
                start.opacity = opacity(t);
                return start + "";
            };
        }
        cubehelix.gamma = cubehelixGamma;
        return cubehelix;
    }(1);
}
exports.default = cubehelix((0, _colorJs.hue));
var cubehelixLong = cubehelix((0, _colorJsDefault.default));

},{"d3-color":"euMEi","./color.js":"giYtf","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"aazor":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>piecewise);
var _valueJs = require("./value.js");
var _valueJsDefault = parcelHelpers.interopDefault(_valueJs);
function piecewise(interpolate, values) {
    if (values === undefined) values = interpolate, interpolate = (0, _valueJsDefault.default);
    var i = 0, n = values.length - 1, v = values[0], I = new Array(n < 0 ? 0 : n);
    while(i < n)I[i] = interpolate(v, v = values[++i]);
    return function(t) {
        var i = Math.max(0, Math.min(n - 1, Math.floor(t *= n)));
        return I[i](t - i);
    };
}

},{"./value.js":"cwEse","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"ctz6Y":[function(require,module,exports) {
var baseDifference = require("4db0cb250ff88e72"), baseRest = require("b2f01aa6851573dc"), isArrayLikeObject = require("15809c5e06486880");
/**
 * Creates an array excluding all given values using
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * **Note:** Unlike `_.pull`, this method returns a new array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {...*} [values] The values to exclude.
 * @returns {Array} Returns the new array of filtered values.
 * @see _.difference, _.xor
 * @example
 *
 * _.without([2, 1, 2, 3], 1, 2);
 * // => [3]
 */ var without = baseRest(function(array, values) {
    return isArrayLikeObject(array) ? baseDifference(array, values) : [];
});
module.exports = without;

},{"4db0cb250ff88e72":"bT2tm","b2f01aa6851573dc":"9p3xS","15809c5e06486880":"hn1J7"}],"bT2tm":[function(require,module,exports) {
var SetCache = require("24f4b9cbc81696e0"), arrayIncludes = require("81e4fe535468d831"), arrayIncludesWith = require("90bb2140eaac029e"), arrayMap = require("7436ea7dfb9a8bab"), baseUnary = require("c466a3eeaa8c48da"), cacheHas = require("aea8a6a021670ce5");
/** Used as the size to enable large array optimizations. */ var LARGE_ARRAY_SIZE = 200;
/**
 * The base implementation of methods like `_.difference` without support
 * for excluding multiple arrays or iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Array} values The values to exclude.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new array of filtered values.
 */ function baseDifference(array, values, iteratee, comparator) {
    var index = -1, includes = arrayIncludes, isCommon = true, length = array.length, result = [], valuesLength = values.length;
    if (!length) return result;
    if (iteratee) values = arrayMap(values, baseUnary(iteratee));
    if (comparator) {
        includes = arrayIncludesWith;
        isCommon = false;
    } else if (values.length >= LARGE_ARRAY_SIZE) {
        includes = cacheHas;
        isCommon = false;
        values = new SetCache(values);
    }
    outer: while(++index < length){
        var value = array[index], computed = iteratee == null ? value : iteratee(value);
        value = comparator || value !== 0 ? value : 0;
        if (isCommon && computed === computed) {
            var valuesIndex = valuesLength;
            while(valuesIndex--){
                if (values[valuesIndex] === computed) continue outer;
            }
            result.push(value);
        } else if (!includes(values, computed, comparator)) result.push(value);
    }
    return result;
}
module.exports = baseDifference;

},{"24f4b9cbc81696e0":"8LOJe","81e4fe535468d831":"894B4","90bb2140eaac029e":"7U6V2","7436ea7dfb9a8bab":"fahvZ","c466a3eeaa8c48da":"993qv","aea8a6a021670ce5":"tTji9"}],"894B4":[function(require,module,exports) {
var baseIndexOf = require("277b2d1a618f2b2f");
/**
 * A specialized version of `_.includes` for arrays without support for
 * specifying an index to search from.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */ function arrayIncludes(array, value) {
    var length = array == null ? 0 : array.length;
    return !!length && baseIndexOf(array, value, 0) > -1;
}
module.exports = arrayIncludes;

},{"277b2d1a618f2b2f":"b5Lpi"}],"b5Lpi":[function(require,module,exports) {
var baseFindIndex = require("badcebec79c8cd4"), baseIsNaN = require("c991ed2b82d165b"), strictIndexOf = require("c0bb8190b05a00a5");
/**
 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function baseIndexOf(array, value, fromIndex) {
    return value === value ? strictIndexOf(array, value, fromIndex) : baseFindIndex(array, baseIsNaN, fromIndex);
}
module.exports = baseIndexOf;

},{"badcebec79c8cd4":"bwy2b","c991ed2b82d165b":"76EiO","c0bb8190b05a00a5":"3vTtq"}],"bwy2b":[function(require,module,exports) {
/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function baseFindIndex(array, predicate, fromIndex, fromRight) {
    var length = array.length, index = fromIndex + (fromRight ? 1 : -1);
    while(fromRight ? index-- : ++index < length){
        if (predicate(array[index], index, array)) return index;
    }
    return -1;
}
module.exports = baseFindIndex;

},{}],"76EiO":[function(require,module,exports) {
/**
 * The base implementation of `_.isNaN` without support for number objects.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 */ function baseIsNaN(value) {
    return value !== value;
}
module.exports = baseIsNaN;

},{}],"3vTtq":[function(require,module,exports) {
/**
 * A specialized version of `_.indexOf` which performs strict equality
 * comparisons of values, i.e. `===`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function strictIndexOf(array, value, fromIndex) {
    var index = fromIndex - 1, length = array.length;
    while(++index < length){
        if (array[index] === value) return index;
    }
    return -1;
}
module.exports = strictIndexOf;

},{}],"7U6V2":[function(require,module,exports) {
/**
 * This function is like `arrayIncludes` except that it accepts a comparator.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @param {Function} comparator The comparator invoked per element.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */ function arrayIncludesWith(array, value, comparator) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (comparator(value, array[index])) return true;
    }
    return false;
}
module.exports = arrayIncludesWith;

},{}],"ba4g6":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "arc", ()=>(0, _arcJsDefault.default));
parcelHelpers.export(exports, "area", ()=>(0, _areaJsDefault.default));
parcelHelpers.export(exports, "line", ()=>(0, _lineJsDefault.default));
parcelHelpers.export(exports, "pie", ()=>(0, _pieJsDefault.default));
parcelHelpers.export(exports, "areaRadial", ()=>(0, _areaRadialJsDefault.default)) // Note: radialArea is deprecated!
;
parcelHelpers.export(exports, "radialArea", ()=>(0, _areaRadialJsDefault.default));
parcelHelpers.export(exports, "lineRadial", ()=>(0, _lineRadialJsDefault.default)) // Note: radialLine is deprecated!
;
parcelHelpers.export(exports, "radialLine", ()=>(0, _lineRadialJsDefault.default));
parcelHelpers.export(exports, "pointRadial", ()=>(0, _pointRadialJsDefault.default));
parcelHelpers.export(exports, "link", ()=>(0, _linkJs.link));
parcelHelpers.export(exports, "linkHorizontal", ()=>(0, _linkJs.linkHorizontal));
parcelHelpers.export(exports, "linkVertical", ()=>(0, _linkJs.linkVertical));
parcelHelpers.export(exports, "linkRadial", ()=>(0, _linkJs.linkRadial));
parcelHelpers.export(exports, "symbol", ()=>(0, _symbolJsDefault.default));
parcelHelpers.export(exports, "symbolsStroke", ()=>(0, _symbolJs.symbolsStroke));
parcelHelpers.export(exports, "symbolsFill", ()=>(0, _symbolJs.symbolsFill));
parcelHelpers.export(exports, "symbols", ()=>(0, _symbolJs.symbolsFill));
parcelHelpers.export(exports, "symbolAsterisk", ()=>(0, _asteriskJsDefault.default));
parcelHelpers.export(exports, "symbolCircle", ()=>(0, _circleJsDefault.default));
parcelHelpers.export(exports, "symbolCross", ()=>(0, _crossJsDefault.default));
parcelHelpers.export(exports, "symbolDiamond", ()=>(0, _diamondJsDefault.default));
parcelHelpers.export(exports, "symbolDiamond2", ()=>(0, _diamond2JsDefault.default));
parcelHelpers.export(exports, "symbolPlus", ()=>(0, _plusJsDefault.default));
parcelHelpers.export(exports, "symbolSquare", ()=>(0, _squareJsDefault.default));
parcelHelpers.export(exports, "symbolSquare2", ()=>(0, _square2JsDefault.default));
parcelHelpers.export(exports, "symbolStar", ()=>(0, _starJsDefault.default));
parcelHelpers.export(exports, "symbolTriangle", ()=>(0, _triangleJsDefault.default));
parcelHelpers.export(exports, "symbolTriangle2", ()=>(0, _triangle2JsDefault.default));
parcelHelpers.export(exports, "symbolWye", ()=>(0, _wyeJsDefault.default));
parcelHelpers.export(exports, "symbolTimes", ()=>(0, _timesJsDefault.default));
parcelHelpers.export(exports, "symbolX", ()=>(0, _timesJsDefault.default));
parcelHelpers.export(exports, "curveBasisClosed", ()=>(0, _basisClosedJsDefault.default));
parcelHelpers.export(exports, "curveBasisOpen", ()=>(0, _basisOpenJsDefault.default));
parcelHelpers.export(exports, "curveBasis", ()=>(0, _basisJsDefault.default));
parcelHelpers.export(exports, "curveBumpX", ()=>(0, _bumpJs.bumpX));
parcelHelpers.export(exports, "curveBumpY", ()=>(0, _bumpJs.bumpY));
parcelHelpers.export(exports, "curveBundle", ()=>(0, _bundleJsDefault.default));
parcelHelpers.export(exports, "curveCardinalClosed", ()=>(0, _cardinalClosedJsDefault.default));
parcelHelpers.export(exports, "curveCardinalOpen", ()=>(0, _cardinalOpenJsDefault.default));
parcelHelpers.export(exports, "curveCardinal", ()=>(0, _cardinalJsDefault.default));
parcelHelpers.export(exports, "curveCatmullRomClosed", ()=>(0, _catmullRomClosedJsDefault.default));
parcelHelpers.export(exports, "curveCatmullRomOpen", ()=>(0, _catmullRomOpenJsDefault.default));
parcelHelpers.export(exports, "curveCatmullRom", ()=>(0, _catmullRomJsDefault.default));
parcelHelpers.export(exports, "curveLinearClosed", ()=>(0, _linearClosedJsDefault.default));
parcelHelpers.export(exports, "curveLinear", ()=>(0, _linearJsDefault.default));
parcelHelpers.export(exports, "curveMonotoneX", ()=>(0, _monotoneJs.monotoneX));
parcelHelpers.export(exports, "curveMonotoneY", ()=>(0, _monotoneJs.monotoneY));
parcelHelpers.export(exports, "curveNatural", ()=>(0, _naturalJsDefault.default));
parcelHelpers.export(exports, "curveStep", ()=>(0, _stepJsDefault.default));
parcelHelpers.export(exports, "curveStepAfter", ()=>(0, _stepJs.stepAfter));
parcelHelpers.export(exports, "curveStepBefore", ()=>(0, _stepJs.stepBefore));
parcelHelpers.export(exports, "stack", ()=>(0, _stackJsDefault.default));
parcelHelpers.export(exports, "stackOffsetExpand", ()=>(0, _expandJsDefault.default));
parcelHelpers.export(exports, "stackOffsetDiverging", ()=>(0, _divergingJsDefault.default));
parcelHelpers.export(exports, "stackOffsetNone", ()=>(0, _noneJsDefault.default));
parcelHelpers.export(exports, "stackOffsetSilhouette", ()=>(0, _silhouetteJsDefault.default));
parcelHelpers.export(exports, "stackOffsetWiggle", ()=>(0, _wiggleJsDefault.default));
parcelHelpers.export(exports, "stackOrderAppearance", ()=>(0, _appearanceJsDefault.default));
parcelHelpers.export(exports, "stackOrderAscending", ()=>(0, _ascendingJsDefault.default));
parcelHelpers.export(exports, "stackOrderDescending", ()=>(0, _descendingJsDefault.default));
parcelHelpers.export(exports, "stackOrderInsideOut", ()=>(0, _insideOutJsDefault.default));
parcelHelpers.export(exports, "stackOrderNone", ()=>(0, _noneJsDefault1.default));
parcelHelpers.export(exports, "stackOrderReverse", ()=>(0, _reverseJsDefault.default));
var _arcJs = require("./arc.js");
var _arcJsDefault = parcelHelpers.interopDefault(_arcJs);
var _areaJs = require("./area.js");
var _areaJsDefault = parcelHelpers.interopDefault(_areaJs);
var _lineJs = require("./line.js");
var _lineJsDefault = parcelHelpers.interopDefault(_lineJs);
var _pieJs = require("./pie.js");
var _pieJsDefault = parcelHelpers.interopDefault(_pieJs);
var _areaRadialJs = require("./areaRadial.js");
var _areaRadialJsDefault = parcelHelpers.interopDefault(_areaRadialJs);
var _lineRadialJs = require("./lineRadial.js");
var _lineRadialJsDefault = parcelHelpers.interopDefault(_lineRadialJs);
var _pointRadialJs = require("./pointRadial.js");
var _pointRadialJsDefault = parcelHelpers.interopDefault(_pointRadialJs);
var _linkJs = require("./link.js");
var _symbolJs = require("./symbol.js");
var _symbolJsDefault = parcelHelpers.interopDefault(_symbolJs);
var _asteriskJs = require("./symbol/asterisk.js");
var _asteriskJsDefault = parcelHelpers.interopDefault(_asteriskJs);
var _circleJs = require("./symbol/circle.js");
var _circleJsDefault = parcelHelpers.interopDefault(_circleJs);
var _crossJs = require("./symbol/cross.js");
var _crossJsDefault = parcelHelpers.interopDefault(_crossJs);
var _diamondJs = require("./symbol/diamond.js");
var _diamondJsDefault = parcelHelpers.interopDefault(_diamondJs);
var _diamond2Js = require("./symbol/diamond2.js");
var _diamond2JsDefault = parcelHelpers.interopDefault(_diamond2Js);
var _plusJs = require("./symbol/plus.js");
var _plusJsDefault = parcelHelpers.interopDefault(_plusJs);
var _squareJs = require("./symbol/square.js");
var _squareJsDefault = parcelHelpers.interopDefault(_squareJs);
var _square2Js = require("./symbol/square2.js");
var _square2JsDefault = parcelHelpers.interopDefault(_square2Js);
var _starJs = require("./symbol/star.js");
var _starJsDefault = parcelHelpers.interopDefault(_starJs);
var _triangleJs = require("./symbol/triangle.js");
var _triangleJsDefault = parcelHelpers.interopDefault(_triangleJs);
var _triangle2Js = require("./symbol/triangle2.js");
var _triangle2JsDefault = parcelHelpers.interopDefault(_triangle2Js);
var _wyeJs = require("./symbol/wye.js");
var _wyeJsDefault = parcelHelpers.interopDefault(_wyeJs);
var _timesJs = require("./symbol/times.js");
var _timesJsDefault = parcelHelpers.interopDefault(_timesJs);
var _basisClosedJs = require("./curve/basisClosed.js");
var _basisClosedJsDefault = parcelHelpers.interopDefault(_basisClosedJs);
var _basisOpenJs = require("./curve/basisOpen.js");
var _basisOpenJsDefault = parcelHelpers.interopDefault(_basisOpenJs);
var _basisJs = require("./curve/basis.js");
var _basisJsDefault = parcelHelpers.interopDefault(_basisJs);
var _bumpJs = require("./curve/bump.js");
var _bundleJs = require("./curve/bundle.js");
var _bundleJsDefault = parcelHelpers.interopDefault(_bundleJs);
var _cardinalClosedJs = require("./curve/cardinalClosed.js");
var _cardinalClosedJsDefault = parcelHelpers.interopDefault(_cardinalClosedJs);
var _cardinalOpenJs = require("./curve/cardinalOpen.js");
var _cardinalOpenJsDefault = parcelHelpers.interopDefault(_cardinalOpenJs);
var _cardinalJs = require("./curve/cardinal.js");
var _cardinalJsDefault = parcelHelpers.interopDefault(_cardinalJs);
var _catmullRomClosedJs = require("./curve/catmullRomClosed.js");
var _catmullRomClosedJsDefault = parcelHelpers.interopDefault(_catmullRomClosedJs);
var _catmullRomOpenJs = require("./curve/catmullRomOpen.js");
var _catmullRomOpenJsDefault = parcelHelpers.interopDefault(_catmullRomOpenJs);
var _catmullRomJs = require("./curve/catmullRom.js");
var _catmullRomJsDefault = parcelHelpers.interopDefault(_catmullRomJs);
var _linearClosedJs = require("./curve/linearClosed.js");
var _linearClosedJsDefault = parcelHelpers.interopDefault(_linearClosedJs);
var _linearJs = require("./curve/linear.js");
var _linearJsDefault = parcelHelpers.interopDefault(_linearJs);
var _monotoneJs = require("./curve/monotone.js");
var _naturalJs = require("./curve/natural.js");
var _naturalJsDefault = parcelHelpers.interopDefault(_naturalJs);
var _stepJs = require("./curve/step.js");
var _stepJsDefault = parcelHelpers.interopDefault(_stepJs);
var _stackJs = require("./stack.js");
var _stackJsDefault = parcelHelpers.interopDefault(_stackJs);
var _expandJs = require("./offset/expand.js");
var _expandJsDefault = parcelHelpers.interopDefault(_expandJs);
var _divergingJs = require("./offset/diverging.js");
var _divergingJsDefault = parcelHelpers.interopDefault(_divergingJs);
var _noneJs = require("./offset/none.js");
var _noneJsDefault = parcelHelpers.interopDefault(_noneJs);
var _silhouetteJs = require("./offset/silhouette.js");
var _silhouetteJsDefault = parcelHelpers.interopDefault(_silhouetteJs);
var _wiggleJs = require("./offset/wiggle.js");
var _wiggleJsDefault = parcelHelpers.interopDefault(_wiggleJs);
var _appearanceJs = require("./order/appearance.js");
var _appearanceJsDefault = parcelHelpers.interopDefault(_appearanceJs);
var _ascendingJs = require("./order/ascending.js");
var _ascendingJsDefault = parcelHelpers.interopDefault(_ascendingJs);
var _descendingJs = require("./order/descending.js");
var _descendingJsDefault = parcelHelpers.interopDefault(_descendingJs);
var _insideOutJs = require("./order/insideOut.js");
var _insideOutJsDefault = parcelHelpers.interopDefault(_insideOutJs);
var _noneJs1 = require("./order/none.js");
var _noneJsDefault1 = parcelHelpers.interopDefault(_noneJs1);
var _reverseJs = require("./order/reverse.js");
var _reverseJsDefault = parcelHelpers.interopDefault(_reverseJs);

},{"./arc.js":"9FtUx","./area.js":"chNqs","./line.js":"cajtE","./pie.js":"bGWh0","./areaRadial.js":false,"./lineRadial.js":false,"./pointRadial.js":false,"./link.js":false,"./symbol.js":false,"./symbol/asterisk.js":false,"./symbol/circle.js":false,"./symbol/cross.js":false,"./symbol/diamond.js":false,"./symbol/diamond2.js":false,"./symbol/plus.js":false,"./symbol/square.js":false,"./symbol/square2.js":false,"./symbol/star.js":false,"./symbol/triangle.js":false,"./symbol/triangle2.js":false,"./symbol/wye.js":false,"./symbol/times.js":false,"./curve/basisClosed.js":"ijoiU","./curve/basisOpen.js":"g9pcb","./curve/basis.js":"4H0iE","./curve/bump.js":false,"./curve/bundle.js":"Q1NIm","./curve/cardinalClosed.js":"hEwXQ","./curve/cardinalOpen.js":"5UKJ2","./curve/cardinal.js":"dxG8N","./curve/catmullRomClosed.js":"91kOz","./curve/catmullRomOpen.js":"fymLo","./curve/catmullRom.js":"bdz6e","./curve/linearClosed.js":"dcgCm","./curve/linear.js":"2wPoR","./curve/monotone.js":"lmU2h","./curve/natural.js":"2QGlH","./curve/step.js":"ipHcF","./stack.js":"724K5","./offset/expand.js":"1GMo5","./offset/diverging.js":"gyAC2","./offset/none.js":"BSEuE","./offset/silhouette.js":"iSONX","./offset/wiggle.js":"95A1s","./order/appearance.js":false,"./order/ascending.js":"amYoy","./order/descending.js":"5TXuD","./order/insideOut.js":"21iWT","./order/none.js":"heTyv","./order/reverse.js":"1cGWN","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9FtUx":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        var innerRadius = arcInnerRadius, outerRadius = arcOuterRadius, cornerRadius = (0, _constantJsDefault.default)(0), padRadius = null, startAngle = arcStartAngle, endAngle = arcEndAngle, padAngle = arcPadAngle, context = null, path = (0, _pathJs.withPath)(arc);
        function arc() {
            var buffer, r, r0 = +innerRadius.apply(this, arguments), r1 = +outerRadius.apply(this, arguments), a0 = startAngle.apply(this, arguments) - (0, _mathJs.halfPi), a1 = endAngle.apply(this, arguments) - (0, _mathJs.halfPi), da = (0, _mathJs.abs)(a1 - a0), cw = a1 > a0;
            if (!context) context = buffer = path();
            // Ensure that the outer radius is always larger than the inner radius.
            if (r1 < r0) r = r1, r1 = r0, r0 = r;
            // Is it a point?
            if (!(r1 > (0, _mathJs.epsilon))) context.moveTo(0, 0);
            else if (da > (0, _mathJs.tau) - (0, _mathJs.epsilon)) {
                context.moveTo(r1 * (0, _mathJs.cos)(a0), r1 * (0, _mathJs.sin)(a0));
                context.arc(0, 0, r1, a0, a1, !cw);
                if (r0 > (0, _mathJs.epsilon)) {
                    context.moveTo(r0 * (0, _mathJs.cos)(a1), r0 * (0, _mathJs.sin)(a1));
                    context.arc(0, 0, r0, a1, a0, cw);
                }
            } else {
                var a01 = a0, a11 = a1, a00 = a0, a10 = a1, da0 = da, da1 = da, ap = padAngle.apply(this, arguments) / 2, rp = ap > (0, _mathJs.epsilon) && (padRadius ? +padRadius.apply(this, arguments) : (0, _mathJs.sqrt)(r0 * r0 + r1 * r1)), rc = (0, _mathJs.min)((0, _mathJs.abs)(r1 - r0) / 2, +cornerRadius.apply(this, arguments)), rc0 = rc, rc1 = rc, t0, t1;
                // Apply padding? Note that since r1 ≥ r0, da1 ≥ da0.
                if (rp > (0, _mathJs.epsilon)) {
                    var p0 = (0, _mathJs.asin)(rp / r0 * (0, _mathJs.sin)(ap)), p1 = (0, _mathJs.asin)(rp / r1 * (0, _mathJs.sin)(ap));
                    if ((da0 -= p0 * 2) > (0, _mathJs.epsilon)) p0 *= cw ? 1 : -1, a00 += p0, a10 -= p0;
                    else da0 = 0, a00 = a10 = (a0 + a1) / 2;
                    if ((da1 -= p1 * 2) > (0, _mathJs.epsilon)) p1 *= cw ? 1 : -1, a01 += p1, a11 -= p1;
                    else da1 = 0, a01 = a11 = (a0 + a1) / 2;
                }
                var x01 = r1 * (0, _mathJs.cos)(a01), y01 = r1 * (0, _mathJs.sin)(a01), x10 = r0 * (0, _mathJs.cos)(a10), y10 = r0 * (0, _mathJs.sin)(a10);
                // Apply rounded corners?
                if (rc > (0, _mathJs.epsilon)) {
                    var x11 = r1 * (0, _mathJs.cos)(a11), y11 = r1 * (0, _mathJs.sin)(a11), x00 = r0 * (0, _mathJs.cos)(a00), y00 = r0 * (0, _mathJs.sin)(a00), oc;
                    // Restrict the corner radius according to the sector angle. If this
                    // intersection fails, it’s probably because the arc is too small, so
                    // disable the corner radius entirely.
                    if (da < (0, _mathJs.pi)) {
                        if (oc = intersect(x01, y01, x00, y00, x11, y11, x10, y10)) {
                            var ax = x01 - oc[0], ay = y01 - oc[1], bx = x11 - oc[0], by = y11 - oc[1], kc = 1 / (0, _mathJs.sin)((0, _mathJs.acos)((ax * bx + ay * by) / ((0, _mathJs.sqrt)(ax * ax + ay * ay) * (0, _mathJs.sqrt)(bx * bx + by * by))) / 2), lc = (0, _mathJs.sqrt)(oc[0] * oc[0] + oc[1] * oc[1]);
                            rc0 = (0, _mathJs.min)(rc, (r0 - lc) / (kc - 1));
                            rc1 = (0, _mathJs.min)(rc, (r1 - lc) / (kc + 1));
                        } else rc0 = rc1 = 0;
                    }
                }
                // Is the sector collapsed to a line?
                if (!(da1 > (0, _mathJs.epsilon))) context.moveTo(x01, y01);
                else if (rc1 > (0, _mathJs.epsilon)) {
                    t0 = cornerTangents(x00, y00, x01, y01, r1, rc1, cw);
                    t1 = cornerTangents(x11, y11, x10, y10, r1, rc1, cw);
                    context.moveTo(t0.cx + t0.x01, t0.cy + t0.y01);
                    // Have the corners merged?
                    if (rc1 < rc) context.arc(t0.cx, t0.cy, rc1, (0, _mathJs.atan2)(t0.y01, t0.x01), (0, _mathJs.atan2)(t1.y01, t1.x01), !cw);
                    else {
                        context.arc(t0.cx, t0.cy, rc1, (0, _mathJs.atan2)(t0.y01, t0.x01), (0, _mathJs.atan2)(t0.y11, t0.x11), !cw);
                        context.arc(0, 0, r1, (0, _mathJs.atan2)(t0.cy + t0.y11, t0.cx + t0.x11), (0, _mathJs.atan2)(t1.cy + t1.y11, t1.cx + t1.x11), !cw);
                        context.arc(t1.cx, t1.cy, rc1, (0, _mathJs.atan2)(t1.y11, t1.x11), (0, _mathJs.atan2)(t1.y01, t1.x01), !cw);
                    }
                } else context.moveTo(x01, y01), context.arc(0, 0, r1, a01, a11, !cw);
                // Is there no inner ring, and it’s a circular sector?
                // Or perhaps it’s an annular sector collapsed due to padding?
                if (!(r0 > (0, _mathJs.epsilon)) || !(da0 > (0, _mathJs.epsilon))) context.lineTo(x10, y10);
                else if (rc0 > (0, _mathJs.epsilon)) {
                    t0 = cornerTangents(x10, y10, x11, y11, r0, -rc0, cw);
                    t1 = cornerTangents(x01, y01, x00, y00, r0, -rc0, cw);
                    context.lineTo(t0.cx + t0.x01, t0.cy + t0.y01);
                    // Have the corners merged?
                    if (rc0 < rc) context.arc(t0.cx, t0.cy, rc0, (0, _mathJs.atan2)(t0.y01, t0.x01), (0, _mathJs.atan2)(t1.y01, t1.x01), !cw);
                    else {
                        context.arc(t0.cx, t0.cy, rc0, (0, _mathJs.atan2)(t0.y01, t0.x01), (0, _mathJs.atan2)(t0.y11, t0.x11), !cw);
                        context.arc(0, 0, r0, (0, _mathJs.atan2)(t0.cy + t0.y11, t0.cx + t0.x11), (0, _mathJs.atan2)(t1.cy + t1.y11, t1.cx + t1.x11), cw);
                        context.arc(t1.cx, t1.cy, rc0, (0, _mathJs.atan2)(t1.y11, t1.x11), (0, _mathJs.atan2)(t1.y01, t1.x01), !cw);
                    }
                } else context.arc(0, 0, r0, a10, a00, cw);
            }
            context.closePath();
            if (buffer) return context = null, buffer + "" || null;
        }
        arc.centroid = function() {
            var r = (+innerRadius.apply(this, arguments) + +outerRadius.apply(this, arguments)) / 2, a = (+startAngle.apply(this, arguments) + +endAngle.apply(this, arguments)) / 2 - (0, _mathJs.pi) / 2;
            return [
                (0, _mathJs.cos)(a) * r,
                (0, _mathJs.sin)(a) * r
            ];
        };
        arc.innerRadius = function(_) {
            return arguments.length ? (innerRadius = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(+_), arc) : innerRadius;
        };
        arc.outerRadius = function(_) {
            return arguments.length ? (outerRadius = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(+_), arc) : outerRadius;
        };
        arc.cornerRadius = function(_) {
            return arguments.length ? (cornerRadius = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(+_), arc) : cornerRadius;
        };
        arc.padRadius = function(_) {
            return arguments.length ? (padRadius = _ == null ? null : typeof _ === "function" ? _ : (0, _constantJsDefault.default)(+_), arc) : padRadius;
        };
        arc.startAngle = function(_) {
            return arguments.length ? (startAngle = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(+_), arc) : startAngle;
        };
        arc.endAngle = function(_) {
            return arguments.length ? (endAngle = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(+_), arc) : endAngle;
        };
        arc.padAngle = function(_) {
            return arguments.length ? (padAngle = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(+_), arc) : padAngle;
        };
        arc.context = function(_) {
            return arguments.length ? (context = _ == null ? null : _, arc) : context;
        };
        return arc;
    });
var _constantJs = require("./constant.js");
var _constantJsDefault = parcelHelpers.interopDefault(_constantJs);
var _mathJs = require("./math.js");
var _pathJs = require("./path.js");
function arcInnerRadius(d) {
    return d.innerRadius;
}
function arcOuterRadius(d) {
    return d.outerRadius;
}
function arcStartAngle(d) {
    return d.startAngle;
}
function arcEndAngle(d) {
    return d.endAngle;
}
function arcPadAngle(d) {
    return d && d.padAngle; // Note: optional!
}
function intersect(x0, y0, x1, y1, x2, y2, x3, y3) {
    var x10 = x1 - x0, y10 = y1 - y0, x32 = x3 - x2, y32 = y3 - y2, t = y32 * x10 - x32 * y10;
    if (t * t < (0, _mathJs.epsilon)) return;
    t = (x32 * (y0 - y2) - y32 * (x0 - x2)) / t;
    return [
        x0 + t * x10,
        y0 + t * y10
    ];
}
// Compute perpendicular offset line of length rc.
// http://mathworld.wolfram.com/Circle-LineIntersection.html
function cornerTangents(x0, y0, x1, y1, r1, rc, cw) {
    var x01 = x0 - x1, y01 = y0 - y1, lo = (cw ? rc : -rc) / (0, _mathJs.sqrt)(x01 * x01 + y01 * y01), ox = lo * y01, oy = -lo * x01, x11 = x0 + ox, y11 = y0 + oy, x10 = x1 + ox, y10 = y1 + oy, x00 = (x11 + x10) / 2, y00 = (y11 + y10) / 2, dx = x10 - x11, dy = y10 - y11, d2 = dx * dx + dy * dy, r = r1 - rc, D = x11 * y10 - x10 * y11, d = (dy < 0 ? -1 : 1) * (0, _mathJs.sqrt)((0, _mathJs.max)(0, r * r * d2 - D * D)), cx0 = (D * dy - dx * d) / d2, cy0 = (-D * dx - dy * d) / d2, cx1 = (D * dy + dx * d) / d2, cy1 = (-D * dx + dy * d) / d2, dx0 = cx0 - x00, dy0 = cy0 - y00, dx1 = cx1 - x00, dy1 = cy1 - y00;
    // Pick the closer of the two intersection points.
    // TODO Is there a faster way to determine which intersection to use?
    if (dx0 * dx0 + dy0 * dy0 > dx1 * dx1 + dy1 * dy1) cx0 = cx1, cy0 = cy1;
    return {
        cx: cx0,
        cy: cy0,
        x01: -ox,
        y01: -oy,
        x11: cx0 * (r1 / r - 1),
        y11: cy0 * (r1 / r - 1)
    };
}

},{"./constant.js":"dowtg","./math.js":"cVb0q","./path.js":"xrefU","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"dowtg":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(x) {
        return function constant() {
            return x;
        };
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"cVb0q":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "abs", ()=>abs);
parcelHelpers.export(exports, "atan2", ()=>atan2);
parcelHelpers.export(exports, "cos", ()=>cos);
parcelHelpers.export(exports, "max", ()=>max);
parcelHelpers.export(exports, "min", ()=>min);
parcelHelpers.export(exports, "sin", ()=>sin);
parcelHelpers.export(exports, "sqrt", ()=>sqrt);
parcelHelpers.export(exports, "epsilon", ()=>epsilon);
parcelHelpers.export(exports, "pi", ()=>pi);
parcelHelpers.export(exports, "halfPi", ()=>halfPi);
parcelHelpers.export(exports, "tau", ()=>tau);
parcelHelpers.export(exports, "acos", ()=>acos);
parcelHelpers.export(exports, "asin", ()=>asin);
const abs = Math.abs;
const atan2 = Math.atan2;
const cos = Math.cos;
const max = Math.max;
const min = Math.min;
const sin = Math.sin;
const sqrt = Math.sqrt;
const epsilon = 1e-12;
const pi = Math.PI;
const halfPi = pi / 2;
const tau = 2 * pi;
function acos(x) {
    return x > 1 ? 0 : x < -1 ? pi : Math.acos(x);
}
function asin(x) {
    return x >= 1 ? halfPi : x <= -1 ? -halfPi : Math.asin(x);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"xrefU":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "withPath", ()=>withPath);
var _d3Path = require("d3-path");
function withPath(shape) {
    let digits = 3;
    shape.digits = function(_) {
        if (!arguments.length) return digits;
        if (_ == null) digits = null;
        else {
            const d = Math.floor(_);
            if (!(d >= 0)) throw new RangeError(`invalid digits: ${_}`);
            digits = d;
        }
        return shape;
    };
    return ()=>new (0, _d3Path.Path)(digits);
}

},{"d3-path":"gnRAQ","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"gnRAQ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Path", ()=>(0, _pathJs.Path));
parcelHelpers.export(exports, "path", ()=>(0, _pathJs.path));
parcelHelpers.export(exports, "pathRound", ()=>(0, _pathJs.pathRound));
var _pathJs = require("./path.js");

},{"./path.js":"3fsH9","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3fsH9":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Path", ()=>Path);
parcelHelpers.export(exports, "path", ()=>path);
parcelHelpers.export(exports, "pathRound", ()=>pathRound);
const pi = Math.PI, tau = 2 * pi, epsilon = 1e-6, tauEpsilon = tau - epsilon;
function append(strings) {
    this._ += strings[0];
    for(let i = 1, n = strings.length; i < n; ++i)this._ += arguments[i] + strings[i];
}
function appendRound(digits) {
    let d = Math.floor(digits);
    if (!(d >= 0)) throw new Error(`invalid digits: ${digits}`);
    if (d > 15) return append;
    const k = 10 ** d;
    return function(strings) {
        this._ += strings[0];
        for(let i = 1, n = strings.length; i < n; ++i)this._ += Math.round(arguments[i] * k) / k + strings[i];
    };
}
class Path {
    constructor(digits){
        this._x0 = this._y0 = this._x1 = this._y1 = null; // end of current subpath
        this._ = "";
        this._append = digits == null ? append : appendRound(digits);
    }
    moveTo(x, y) {
        this._append`M${this._x0 = this._x1 = +x},${this._y0 = this._y1 = +y}`;
    }
    closePath() {
        if (this._x1 !== null) {
            this._x1 = this._x0, this._y1 = this._y0;
            this._append`Z`;
        }
    }
    lineTo(x, y) {
        this._append`L${this._x1 = +x},${this._y1 = +y}`;
    }
    quadraticCurveTo(x1, y1, x, y) {
        this._append`Q${+x1},${+y1},${this._x1 = +x},${this._y1 = +y}`;
    }
    bezierCurveTo(x1, y1, x2, y2, x, y) {
        this._append`C${+x1},${+y1},${+x2},${+y2},${this._x1 = +x},${this._y1 = +y}`;
    }
    arcTo(x1, y1, x2, y2, r) {
        x1 = +x1, y1 = +y1, x2 = +x2, y2 = +y2, r = +r;
        // Is the radius negative? Error.
        if (r < 0) throw new Error(`negative radius: ${r}`);
        let x0 = this._x1, y0 = this._y1, x21 = x2 - x1, y21 = y2 - y1, x01 = x0 - x1, y01 = y0 - y1, l01_2 = x01 * x01 + y01 * y01;
        // Is this path empty? Move to (x1,y1).
        if (this._x1 === null) this._append`M${this._x1 = x1},${this._y1 = y1}`;
        else if (!(l01_2 > epsilon)) ;
        else if (!(Math.abs(y01 * x21 - y21 * x01) > epsilon) || !r) this._append`L${this._x1 = x1},${this._y1 = y1}`;
        else {
            let x20 = x2 - x0, y20 = y2 - y0, l21_2 = x21 * x21 + y21 * y21, l20_2 = x20 * x20 + y20 * y20, l21 = Math.sqrt(l21_2), l01 = Math.sqrt(l01_2), l = r * Math.tan((pi - Math.acos((l21_2 + l01_2 - l20_2) / (2 * l21 * l01))) / 2), t01 = l / l01, t21 = l / l21;
            // If the start tangent is not coincident with (x0,y0), line to.
            if (Math.abs(t01 - 1) > epsilon) this._append`L${x1 + t01 * x01},${y1 + t01 * y01}`;
            this._append`A${r},${r},0,0,${+(y01 * x20 > x01 * y20)},${this._x1 = x1 + t21 * x21},${this._y1 = y1 + t21 * y21}`;
        }
    }
    arc(x, y, r, a0, a1, ccw) {
        x = +x, y = +y, r = +r, ccw = !!ccw;
        // Is the radius negative? Error.
        if (r < 0) throw new Error(`negative radius: ${r}`);
        let dx = r * Math.cos(a0), dy = r * Math.sin(a0), x0 = x + dx, y0 = y + dy, cw = 1 ^ ccw, da = ccw ? a0 - a1 : a1 - a0;
        // Is this path empty? Move to (x0,y0).
        if (this._x1 === null) this._append`M${x0},${y0}`;
        else if (Math.abs(this._x1 - x0) > epsilon || Math.abs(this._y1 - y0) > epsilon) this._append`L${x0},${y0}`;
        // Is this arc empty? We’re done.
        if (!r) return;
        // Does the angle go the wrong way? Flip the direction.
        if (da < 0) da = da % tau + tau;
        // Is this a complete circle? Draw two arcs to complete the circle.
        if (da > tauEpsilon) this._append`A${r},${r},0,1,${cw},${x - dx},${y - dy}A${r},${r},0,1,${cw},${this._x1 = x0},${this._y1 = y0}`;
        else if (da > epsilon) this._append`A${r},${r},0,${+(da >= pi)},${cw},${this._x1 = x + r * Math.cos(a1)},${this._y1 = y + r * Math.sin(a1)}`;
    }
    rect(x, y, w, h) {
        this._append`M${this._x0 = this._x1 = +x},${this._y0 = this._y1 = +y}h${w = +w}v${+h}h${-w}Z`;
    }
    toString() {
        return this._;
    }
}
function path() {
    return new Path;
}
// Allow instanceof d3.path
path.prototype = Path.prototype;
function pathRound(digits = 3) {
    return new Path(+digits);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"chNqs":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(x0, y0, y1) {
        var x1 = null, defined = (0, _constantJsDefault.default)(true), context = null, curve = (0, _linearJsDefault.default), output = null, path = (0, _pathJs.withPath)(area);
        x0 = typeof x0 === "function" ? x0 : x0 === undefined ? (0, _pointJs.x) : (0, _constantJsDefault.default)(+x0);
        y0 = typeof y0 === "function" ? y0 : y0 === undefined ? (0, _constantJsDefault.default)(0) : (0, _constantJsDefault.default)(+y0);
        y1 = typeof y1 === "function" ? y1 : y1 === undefined ? (0, _pointJs.y) : (0, _constantJsDefault.default)(+y1);
        function area(data) {
            var i, j, k, n = (data = (0, _arrayJsDefault.default)(data)).length, d, defined0 = false, buffer, x0z = new Array(n), y0z = new Array(n);
            if (context == null) output = curve(buffer = path());
            for(i = 0; i <= n; ++i){
                if (!(i < n && defined(d = data[i], i, data)) === defined0) {
                    if (defined0 = !defined0) {
                        j = i;
                        output.areaStart();
                        output.lineStart();
                    } else {
                        output.lineEnd();
                        output.lineStart();
                        for(k = i - 1; k >= j; --k)output.point(x0z[k], y0z[k]);
                        output.lineEnd();
                        output.areaEnd();
                    }
                }
                if (defined0) {
                    x0z[i] = +x0(d, i, data), y0z[i] = +y0(d, i, data);
                    output.point(x1 ? +x1(d, i, data) : x0z[i], y1 ? +y1(d, i, data) : y0z[i]);
                }
            }
            if (buffer) return output = null, buffer + "" || null;
        }
        function arealine() {
            return (0, _lineJsDefault.default)().defined(defined).curve(curve).context(context);
        }
        area.x = function(_) {
            return arguments.length ? (x0 = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(+_), x1 = null, area) : x0;
        };
        area.x0 = function(_) {
            return arguments.length ? (x0 = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(+_), area) : x0;
        };
        area.x1 = function(_) {
            return arguments.length ? (x1 = _ == null ? null : typeof _ === "function" ? _ : (0, _constantJsDefault.default)(+_), area) : x1;
        };
        area.y = function(_) {
            return arguments.length ? (y0 = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(+_), y1 = null, area) : y0;
        };
        area.y0 = function(_) {
            return arguments.length ? (y0 = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(+_), area) : y0;
        };
        area.y1 = function(_) {
            return arguments.length ? (y1 = _ == null ? null : typeof _ === "function" ? _ : (0, _constantJsDefault.default)(+_), area) : y1;
        };
        area.lineX0 = area.lineY0 = function() {
            return arealine().x(x0).y(y0);
        };
        area.lineY1 = function() {
            return arealine().x(x0).y(y1);
        };
        area.lineX1 = function() {
            return arealine().x(x1).y(y0);
        };
        area.defined = function(_) {
            return arguments.length ? (defined = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(!!_), area) : defined;
        };
        area.curve = function(_) {
            return arguments.length ? (curve = _, context != null && (output = curve(context)), area) : curve;
        };
        area.context = function(_) {
            return arguments.length ? (_ == null ? context = output = null : output = curve(context = _), area) : context;
        };
        return area;
    });
var _arrayJs = require("./array.js");
var _arrayJsDefault = parcelHelpers.interopDefault(_arrayJs);
var _constantJs = require("./constant.js");
var _constantJsDefault = parcelHelpers.interopDefault(_constantJs);
var _linearJs = require("./curve/linear.js");
var _linearJsDefault = parcelHelpers.interopDefault(_linearJs);
var _lineJs = require("./line.js");
var _lineJsDefault = parcelHelpers.interopDefault(_lineJs);
var _pathJs = require("./path.js");
var _pointJs = require("./point.js");

},{"./array.js":"7c3gb","./constant.js":"dowtg","./curve/linear.js":"2wPoR","./line.js":"cajtE","./path.js":"xrefU","./point.js":"8C5ZW","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7c3gb":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "slice", ()=>slice);
parcelHelpers.export(exports, "default", ()=>function(x) {
        return typeof x === "object" && "length" in x ? x // Array, TypedArray, NodeList, array-like
         : Array.from(x); // Map, Set, iterable, string, or anything else
    });
var slice = Array.prototype.slice;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2wPoR":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(context) {
        return new Linear(context);
    });
function Linear(context) {
    this._context = context;
}
Linear.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._point = 0;
    },
    lineEnd: function() {
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2; // falls through
            default:
                this._context.lineTo(x, y);
                break;
        }
    }
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"cajtE":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(x, y) {
        var defined = (0, _constantJsDefault.default)(true), context = null, curve = (0, _linearJsDefault.default), output = null, path = (0, _pathJs.withPath)(line);
        x = typeof x === "function" ? x : x === undefined ? (0, _pointJs.x) : (0, _constantJsDefault.default)(x);
        y = typeof y === "function" ? y : y === undefined ? (0, _pointJs.y) : (0, _constantJsDefault.default)(y);
        function line(data) {
            var i, n = (data = (0, _arrayJsDefault.default)(data)).length, d, defined0 = false, buffer;
            if (context == null) output = curve(buffer = path());
            for(i = 0; i <= n; ++i){
                if (!(i < n && defined(d = data[i], i, data)) === defined0) {
                    if (defined0 = !defined0) output.lineStart();
                    else output.lineEnd();
                }
                if (defined0) output.point(+x(d, i, data), +y(d, i, data));
            }
            if (buffer) return output = null, buffer + "" || null;
        }
        line.x = function(_) {
            return arguments.length ? (x = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(+_), line) : x;
        };
        line.y = function(_) {
            return arguments.length ? (y = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(+_), line) : y;
        };
        line.defined = function(_) {
            return arguments.length ? (defined = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(!!_), line) : defined;
        };
        line.curve = function(_) {
            return arguments.length ? (curve = _, context != null && (output = curve(context)), line) : curve;
        };
        line.context = function(_) {
            return arguments.length ? (_ == null ? context = output = null : output = curve(context = _), line) : context;
        };
        return line;
    });
var _arrayJs = require("./array.js");
var _arrayJsDefault = parcelHelpers.interopDefault(_arrayJs);
var _constantJs = require("./constant.js");
var _constantJsDefault = parcelHelpers.interopDefault(_constantJs);
var _linearJs = require("./curve/linear.js");
var _linearJsDefault = parcelHelpers.interopDefault(_linearJs);
var _pathJs = require("./path.js");
var _pointJs = require("./point.js");

},{"./array.js":"7c3gb","./constant.js":"dowtg","./curve/linear.js":"2wPoR","./path.js":"xrefU","./point.js":"8C5ZW","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8C5ZW":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "x", ()=>x);
parcelHelpers.export(exports, "y", ()=>y);
function x(p) {
    return p[0];
}
function y(p) {
    return p[1];
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"bGWh0":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        var value = (0, _identityJsDefault.default), sortValues = (0, _descendingJsDefault.default), sort = null, startAngle = (0, _constantJsDefault.default)(0), endAngle = (0, _constantJsDefault.default)((0, _mathJs.tau)), padAngle = (0, _constantJsDefault.default)(0);
        function pie(data) {
            var i, n = (data = (0, _arrayJsDefault.default)(data)).length, j, k, sum = 0, index = new Array(n), arcs = new Array(n), a0 = +startAngle.apply(this, arguments), da = Math.min((0, _mathJs.tau), Math.max(-(0, _mathJs.tau), endAngle.apply(this, arguments) - a0)), a1, p = Math.min(Math.abs(da) / n, padAngle.apply(this, arguments)), pa = p * (da < 0 ? -1 : 1), v;
            for(i = 0; i < n; ++i)if ((v = arcs[index[i] = i] = +value(data[i], i, data)) > 0) sum += v;
            // Optionally sort the arcs by previously-computed values or by data.
            if (sortValues != null) index.sort(function(i, j) {
                return sortValues(arcs[i], arcs[j]);
            });
            else if (sort != null) index.sort(function(i, j) {
                return sort(data[i], data[j]);
            });
            // Compute the arcs! They are stored in the original data's order.
            for(i = 0, k = sum ? (da - n * pa) / sum : 0; i < n; ++i, a0 = a1)j = index[i], v = arcs[j], a1 = a0 + (v > 0 ? v * k : 0) + pa, arcs[j] = {
                data: data[j],
                index: i,
                value: v,
                startAngle: a0,
                endAngle: a1,
                padAngle: p
            };
            return arcs;
        }
        pie.value = function(_) {
            return arguments.length ? (value = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(+_), pie) : value;
        };
        pie.sortValues = function(_) {
            return arguments.length ? (sortValues = _, sort = null, pie) : sortValues;
        };
        pie.sort = function(_) {
            return arguments.length ? (sort = _, sortValues = null, pie) : sort;
        };
        pie.startAngle = function(_) {
            return arguments.length ? (startAngle = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(+_), pie) : startAngle;
        };
        pie.endAngle = function(_) {
            return arguments.length ? (endAngle = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(+_), pie) : endAngle;
        };
        pie.padAngle = function(_) {
            return arguments.length ? (padAngle = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(+_), pie) : padAngle;
        };
        return pie;
    });
var _arrayJs = require("./array.js");
var _arrayJsDefault = parcelHelpers.interopDefault(_arrayJs);
var _constantJs = require("./constant.js");
var _constantJsDefault = parcelHelpers.interopDefault(_constantJs);
var _descendingJs = require("./descending.js");
var _descendingJsDefault = parcelHelpers.interopDefault(_descendingJs);
var _identityJs = require("./identity.js");
var _identityJsDefault = parcelHelpers.interopDefault(_identityJs);
var _mathJs = require("./math.js");

},{"./array.js":"7c3gb","./constant.js":"dowtg","./descending.js":"gYyQA","./identity.js":"4iLVz","./math.js":"cVb0q","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"gYyQA":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(a, b) {
        return b < a ? -1 : b > a ? 1 : b >= a ? 0 : NaN;
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4iLVz":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(d) {
        return d;
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"ijoiU":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(context) {
        return new BasisClosed(context);
    });
var _noopJs = require("../noop.js");
var _noopJsDefault = parcelHelpers.interopDefault(_noopJs);
var _basisJs = require("./basis.js");
function BasisClosed(context) {
    this._context = context;
}
BasisClosed.prototype = {
    areaStart: (0, _noopJsDefault.default),
    areaEnd: (0, _noopJsDefault.default),
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 1:
                this._context.moveTo(this._x2, this._y2);
                this._context.closePath();
                break;
            case 2:
                this._context.moveTo((this._x2 + 2 * this._x3) / 3, (this._y2 + 2 * this._y3) / 3);
                this._context.lineTo((this._x3 + 2 * this._x2) / 3, (this._y3 + 2 * this._y2) / 3);
                this._context.closePath();
                break;
            case 3:
                this.point(this._x2, this._y2);
                this.point(this._x3, this._y3);
                this.point(this._x4, this._y4);
                break;
        }
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._x2 = x, this._y2 = y;
                break;
            case 1:
                this._point = 2;
                this._x3 = x, this._y3 = y;
                break;
            case 2:
                this._point = 3;
                this._x4 = x, this._y4 = y;
                this._context.moveTo((this._x0 + 4 * this._x1 + x) / 6, (this._y0 + 4 * this._y1 + y) / 6);
                break;
            default:
                (0, _basisJs.point)(this, x, y);
                break;
        }
        this._x0 = this._x1, this._x1 = x;
        this._y0 = this._y1, this._y1 = y;
    }
};

},{"../noop.js":"jKJtW","./basis.js":"4H0iE","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jKJtW":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {});

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4H0iE":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "point", ()=>point);
parcelHelpers.export(exports, "Basis", ()=>Basis);
parcelHelpers.export(exports, "default", ()=>function(context) {
        return new Basis(context);
    });
function point(that, x, y) {
    that._context.bezierCurveTo((2 * that._x0 + that._x1) / 3, (2 * that._y0 + that._y1) / 3, (that._x0 + 2 * that._x1) / 3, (that._y0 + 2 * that._y1) / 3, (that._x0 + 4 * that._x1 + x) / 6, (that._y0 + 4 * that._y1 + y) / 6);
}
function Basis(context) {
    this._context = context;
}
Basis.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._y0 = this._y1 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 3:
                point(this, this._x1, this._y1); // falls through
            case 2:
                this._context.lineTo(this._x1, this._y1);
                break;
        }
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2;
                break;
            case 2:
                this._point = 3;
                this._context.lineTo((5 * this._x0 + this._x1) / 6, (5 * this._y0 + this._y1) / 6); // falls through
            default:
                point(this, x, y);
                break;
        }
        this._x0 = this._x1, this._x1 = x;
        this._y0 = this._y1, this._y1 = y;
    }
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"g9pcb":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(context) {
        return new BasisOpen(context);
    });
var _basisJs = require("./basis.js");
function BasisOpen(context) {
    this._context = context;
}
BasisOpen.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._y0 = this._y1 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        if (this._line || this._line !== 0 && this._point === 3) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                break;
            case 1:
                this._point = 2;
                break;
            case 2:
                this._point = 3;
                var x0 = (this._x0 + 4 * this._x1 + x) / 6, y0 = (this._y0 + 4 * this._y1 + y) / 6;
                this._line ? this._context.lineTo(x0, y0) : this._context.moveTo(x0, y0);
                break;
            case 3:
                this._point = 4; // falls through
            default:
                (0, _basisJs.point)(this, x, y);
                break;
        }
        this._x0 = this._x1, this._x1 = x;
        this._y0 = this._y1, this._y1 = y;
    }
};

},{"./basis.js":"4H0iE","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"Q1NIm":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _basisJs = require("./basis.js");
function Bundle(context, beta) {
    this._basis = new (0, _basisJs.Basis)(context);
    this._beta = beta;
}
Bundle.prototype = {
    lineStart: function() {
        this._x = [];
        this._y = [];
        this._basis.lineStart();
    },
    lineEnd: function() {
        var x = this._x, y = this._y, j = x.length - 1;
        if (j > 0) {
            var x0 = x[0], y0 = y[0], dx = x[j] - x0, dy = y[j] - y0, i = -1, t;
            while(++i <= j){
                t = i / j;
                this._basis.point(this._beta * x[i] + (1 - this._beta) * (x0 + t * dx), this._beta * y[i] + (1 - this._beta) * (y0 + t * dy));
            }
        }
        this._x = this._y = null;
        this._basis.lineEnd();
    },
    point: function(x, y) {
        this._x.push(+x);
        this._y.push(+y);
    }
};
exports.default = function custom(beta) {
    function bundle(context) {
        return beta === 1 ? new (0, _basisJs.Basis)(context) : new Bundle(context, beta);
    }
    bundle.beta = function(beta) {
        return custom(+beta);
    };
    return bundle;
}(0.85);

},{"./basis.js":"4H0iE","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hEwXQ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CardinalClosed", ()=>CardinalClosed);
var _noopJs = require("../noop.js");
var _noopJsDefault = parcelHelpers.interopDefault(_noopJs);
var _cardinalJs = require("./cardinal.js");
function CardinalClosed(context, tension) {
    this._context = context;
    this._k = (1 - tension) / 6;
}
CardinalClosed.prototype = {
    areaStart: (0, _noopJsDefault.default),
    areaEnd: (0, _noopJsDefault.default),
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._x5 = this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = this._y5 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 1:
                this._context.moveTo(this._x3, this._y3);
                this._context.closePath();
                break;
            case 2:
                this._context.lineTo(this._x3, this._y3);
                this._context.closePath();
                break;
            case 3:
                this.point(this._x3, this._y3);
                this.point(this._x4, this._y4);
                this.point(this._x5, this._y5);
                break;
        }
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._x3 = x, this._y3 = y;
                break;
            case 1:
                this._point = 2;
                this._context.moveTo(this._x4 = x, this._y4 = y);
                break;
            case 2:
                this._point = 3;
                this._x5 = x, this._y5 = y;
                break;
            default:
                (0, _cardinalJs.point)(this, x, y);
                break;
        }
        this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
        this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
    }
};
exports.default = function custom(tension) {
    function cardinal(context) {
        return new CardinalClosed(context, tension);
    }
    cardinal.tension = function(tension) {
        return custom(+tension);
    };
    return cardinal;
}(0);

},{"../noop.js":"jKJtW","./cardinal.js":"dxG8N","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"dxG8N":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "point", ()=>point);
parcelHelpers.export(exports, "Cardinal", ()=>Cardinal);
function point(that, x, y) {
    that._context.bezierCurveTo(that._x1 + that._k * (that._x2 - that._x0), that._y1 + that._k * (that._y2 - that._y0), that._x2 + that._k * (that._x1 - x), that._y2 + that._k * (that._y1 - y), that._x2, that._y2);
}
function Cardinal(context, tension) {
    this._context = context;
    this._k = (1 - tension) / 6;
}
Cardinal.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 2:
                this._context.lineTo(this._x2, this._y2);
                break;
            case 3:
                point(this, this._x1, this._y1);
                break;
        }
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2;
                this._x1 = x, this._y1 = y;
                break;
            case 2:
                this._point = 3; // falls through
            default:
                point(this, x, y);
                break;
        }
        this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
        this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
    }
};
exports.default = function custom(tension) {
    function cardinal(context) {
        return new Cardinal(context, tension);
    }
    cardinal.tension = function(tension) {
        return custom(+tension);
    };
    return cardinal;
}(0);

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"5UKJ2":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CardinalOpen", ()=>CardinalOpen);
var _cardinalJs = require("./cardinal.js");
function CardinalOpen(context, tension) {
    this._context = context;
    this._k = (1 - tension) / 6;
}
CardinalOpen.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        if (this._line || this._line !== 0 && this._point === 3) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                break;
            case 1:
                this._point = 2;
                break;
            case 2:
                this._point = 3;
                this._line ? this._context.lineTo(this._x2, this._y2) : this._context.moveTo(this._x2, this._y2);
                break;
            case 3:
                this._point = 4; // falls through
            default:
                (0, _cardinalJs.point)(this, x, y);
                break;
        }
        this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
        this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
    }
};
exports.default = function custom(tension) {
    function cardinal(context) {
        return new CardinalOpen(context, tension);
    }
    cardinal.tension = function(tension) {
        return custom(+tension);
    };
    return cardinal;
}(0);

},{"./cardinal.js":"dxG8N","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"91kOz":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _cardinalClosedJs = require("./cardinalClosed.js");
var _noopJs = require("../noop.js");
var _noopJsDefault = parcelHelpers.interopDefault(_noopJs);
var _catmullRomJs = require("./catmullRom.js");
function CatmullRomClosed(context, alpha) {
    this._context = context;
    this._alpha = alpha;
}
CatmullRomClosed.prototype = {
    areaStart: (0, _noopJsDefault.default),
    areaEnd: (0, _noopJsDefault.default),
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._x5 = this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = this._y5 = NaN;
        this._l01_a = this._l12_a = this._l23_a = this._l01_2a = this._l12_2a = this._l23_2a = this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 1:
                this._context.moveTo(this._x3, this._y3);
                this._context.closePath();
                break;
            case 2:
                this._context.lineTo(this._x3, this._y3);
                this._context.closePath();
                break;
            case 3:
                this.point(this._x3, this._y3);
                this.point(this._x4, this._y4);
                this.point(this._x5, this._y5);
                break;
        }
    },
    point: function(x, y) {
        x = +x, y = +y;
        if (this._point) {
            var x23 = this._x2 - x, y23 = this._y2 - y;
            this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
        }
        switch(this._point){
            case 0:
                this._point = 1;
                this._x3 = x, this._y3 = y;
                break;
            case 1:
                this._point = 2;
                this._context.moveTo(this._x4 = x, this._y4 = y);
                break;
            case 2:
                this._point = 3;
                this._x5 = x, this._y5 = y;
                break;
            default:
                (0, _catmullRomJs.point)(this, x, y);
                break;
        }
        this._l01_a = this._l12_a, this._l12_a = this._l23_a;
        this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
        this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
        this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
    }
};
exports.default = function custom(alpha) {
    function catmullRom(context) {
        return alpha ? new CatmullRomClosed(context, alpha) : new (0, _cardinalClosedJs.CardinalClosed)(context, 0);
    }
    catmullRom.alpha = function(alpha) {
        return custom(+alpha);
    };
    return catmullRom;
}(0.5);

},{"./cardinalClosed.js":"hEwXQ","../noop.js":"jKJtW","./catmullRom.js":"bdz6e","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"bdz6e":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "point", ()=>point);
var _mathJs = require("../math.js");
var _cardinalJs = require("./cardinal.js");
function point(that, x, y) {
    var x1 = that._x1, y1 = that._y1, x2 = that._x2, y2 = that._y2;
    if (that._l01_a > (0, _mathJs.epsilon)) {
        var a = 2 * that._l01_2a + 3 * that._l01_a * that._l12_a + that._l12_2a, n = 3 * that._l01_a * (that._l01_a + that._l12_a);
        x1 = (x1 * a - that._x0 * that._l12_2a + that._x2 * that._l01_2a) / n;
        y1 = (y1 * a - that._y0 * that._l12_2a + that._y2 * that._l01_2a) / n;
    }
    if (that._l23_a > (0, _mathJs.epsilon)) {
        var b = 2 * that._l23_2a + 3 * that._l23_a * that._l12_a + that._l12_2a, m = 3 * that._l23_a * (that._l23_a + that._l12_a);
        x2 = (x2 * b + that._x1 * that._l23_2a - x * that._l12_2a) / m;
        y2 = (y2 * b + that._y1 * that._l23_2a - y * that._l12_2a) / m;
    }
    that._context.bezierCurveTo(x1, y1, x2, y2, that._x2, that._y2);
}
function CatmullRom(context, alpha) {
    this._context = context;
    this._alpha = alpha;
}
CatmullRom.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN;
        this._l01_a = this._l12_a = this._l23_a = this._l01_2a = this._l12_2a = this._l23_2a = this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 2:
                this._context.lineTo(this._x2, this._y2);
                break;
            case 3:
                this.point(this._x2, this._y2);
                break;
        }
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        if (this._point) {
            var x23 = this._x2 - x, y23 = this._y2 - y;
            this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
        }
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2;
                break;
            case 2:
                this._point = 3; // falls through
            default:
                point(this, x, y);
                break;
        }
        this._l01_a = this._l12_a, this._l12_a = this._l23_a;
        this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
        this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
        this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
    }
};
exports.default = function custom(alpha) {
    function catmullRom(context) {
        return alpha ? new CatmullRom(context, alpha) : new (0, _cardinalJs.Cardinal)(context, 0);
    }
    catmullRom.alpha = function(alpha) {
        return custom(+alpha);
    };
    return catmullRom;
}(0.5);

},{"../math.js":"cVb0q","./cardinal.js":"dxG8N","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"fymLo":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _cardinalOpenJs = require("./cardinalOpen.js");
var _catmullRomJs = require("./catmullRom.js");
function CatmullRomOpen(context, alpha) {
    this._context = context;
    this._alpha = alpha;
}
CatmullRomOpen.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN;
        this._l01_a = this._l12_a = this._l23_a = this._l01_2a = this._l12_2a = this._l23_2a = this._point = 0;
    },
    lineEnd: function() {
        if (this._line || this._line !== 0 && this._point === 3) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        if (this._point) {
            var x23 = this._x2 - x, y23 = this._y2 - y;
            this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
        }
        switch(this._point){
            case 0:
                this._point = 1;
                break;
            case 1:
                this._point = 2;
                break;
            case 2:
                this._point = 3;
                this._line ? this._context.lineTo(this._x2, this._y2) : this._context.moveTo(this._x2, this._y2);
                break;
            case 3:
                this._point = 4; // falls through
            default:
                (0, _catmullRomJs.point)(this, x, y);
                break;
        }
        this._l01_a = this._l12_a, this._l12_a = this._l23_a;
        this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
        this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
        this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
    }
};
exports.default = function custom(alpha) {
    function catmullRom(context) {
        return alpha ? new CatmullRomOpen(context, alpha) : new (0, _cardinalOpenJs.CardinalOpen)(context, 0);
    }
    catmullRom.alpha = function(alpha) {
        return custom(+alpha);
    };
    return catmullRom;
}(0.5);

},{"./cardinalOpen.js":"5UKJ2","./catmullRom.js":"bdz6e","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"dcgCm":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(context) {
        return new LinearClosed(context);
    });
var _noopJs = require("../noop.js");
var _noopJsDefault = parcelHelpers.interopDefault(_noopJs);
function LinearClosed(context) {
    this._context = context;
}
LinearClosed.prototype = {
    areaStart: (0, _noopJsDefault.default),
    areaEnd: (0, _noopJsDefault.default),
    lineStart: function() {
        this._point = 0;
    },
    lineEnd: function() {
        if (this._point) this._context.closePath();
    },
    point: function(x, y) {
        x = +x, y = +y;
        if (this._point) this._context.lineTo(x, y);
        else this._point = 1, this._context.moveTo(x, y);
    }
};

},{"../noop.js":"jKJtW","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"lmU2h":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "monotoneX", ()=>monotoneX);
parcelHelpers.export(exports, "monotoneY", ()=>monotoneY);
function sign(x) {
    return x < 0 ? -1 : 1;
}
// Calculate the slopes of the tangents (Hermite-type interpolation) based on
// the following paper: Steffen, M. 1990. A Simple Method for Monotonic
// Interpolation in One Dimension. Astronomy and Astrophysics, Vol. 239, NO.
// NOV(II), P. 443, 1990.
function slope3(that, x2, y2) {
    var h0 = that._x1 - that._x0, h1 = x2 - that._x1, s0 = (that._y1 - that._y0) / (h0 || h1 < 0 && -0), s1 = (y2 - that._y1) / (h1 || h0 < 0 && -0), p = (s0 * h1 + s1 * h0) / (h0 + h1);
    return (sign(s0) + sign(s1)) * Math.min(Math.abs(s0), Math.abs(s1), 0.5 * Math.abs(p)) || 0;
}
// Calculate a one-sided slope.
function slope2(that, t) {
    var h = that._x1 - that._x0;
    return h ? (3 * (that._y1 - that._y0) / h - t) / 2 : t;
}
// According to https://en.wikipedia.org/wiki/Cubic_Hermite_spline#Representations
// "you can express cubic Hermite interpolation in terms of cubic Bézier curves
// with respect to the four values p0, p0 + m0 / 3, p1 - m1 / 3, p1".
function point(that, t0, t1) {
    var x0 = that._x0, y0 = that._y0, x1 = that._x1, y1 = that._y1, dx = (x1 - x0) / 3;
    that._context.bezierCurveTo(x0 + dx, y0 + dx * t0, x1 - dx, y1 - dx * t1, x1, y1);
}
function MonotoneX(context) {
    this._context = context;
}
MonotoneX.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._y0 = this._y1 = this._t0 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 2:
                this._context.lineTo(this._x1, this._y1);
                break;
            case 3:
                point(this, this._t0, slope2(this, this._t0));
                break;
        }
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        var t1 = NaN;
        x = +x, y = +y;
        if (x === this._x1 && y === this._y1) return; // Ignore coincident points.
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2;
                break;
            case 2:
                this._point = 3;
                point(this, slope2(this, t1 = slope3(this, x, y)), t1);
                break;
            default:
                point(this, this._t0, t1 = slope3(this, x, y));
                break;
        }
        this._x0 = this._x1, this._x1 = x;
        this._y0 = this._y1, this._y1 = y;
        this._t0 = t1;
    }
};
function MonotoneY(context) {
    this._context = new ReflectContext(context);
}
(MonotoneY.prototype = Object.create(MonotoneX.prototype)).point = function(x, y) {
    MonotoneX.prototype.point.call(this, y, x);
};
function ReflectContext(context) {
    this._context = context;
}
ReflectContext.prototype = {
    moveTo: function(x, y) {
        this._context.moveTo(y, x);
    },
    closePath: function() {
        this._context.closePath();
    },
    lineTo: function(x, y) {
        this._context.lineTo(y, x);
    },
    bezierCurveTo: function(x1, y1, x2, y2, x, y) {
        this._context.bezierCurveTo(y1, x1, y2, x2, y, x);
    }
};
function monotoneX(context) {
    return new MonotoneX(context);
}
function monotoneY(context) {
    return new MonotoneY(context);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2QGlH":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(context) {
        return new Natural(context);
    });
function Natural(context) {
    this._context = context;
}
Natural.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x = [];
        this._y = [];
    },
    lineEnd: function() {
        var x = this._x, y = this._y, n = x.length;
        if (n) {
            this._line ? this._context.lineTo(x[0], y[0]) : this._context.moveTo(x[0], y[0]);
            if (n === 2) this._context.lineTo(x[1], y[1]);
            else {
                var px = controlPoints(x), py = controlPoints(y);
                for(var i0 = 0, i1 = 1; i1 < n; ++i0, ++i1)this._context.bezierCurveTo(px[0][i0], py[0][i0], px[1][i0], py[1][i0], x[i1], y[i1]);
            }
        }
        if (this._line || this._line !== 0 && n === 1) this._context.closePath();
        this._line = 1 - this._line;
        this._x = this._y = null;
    },
    point: function(x, y) {
        this._x.push(+x);
        this._y.push(+y);
    }
};
// See https://www.particleincell.com/2012/bezier-splines/ for derivation.
function controlPoints(x) {
    var i, n = x.length - 1, m, a = new Array(n), b = new Array(n), r = new Array(n);
    a[0] = 0, b[0] = 2, r[0] = x[0] + 2 * x[1];
    for(i = 1; i < n - 1; ++i)a[i] = 1, b[i] = 4, r[i] = 4 * x[i] + 2 * x[i + 1];
    a[n - 1] = 2, b[n - 1] = 7, r[n - 1] = 8 * x[n - 1] + x[n];
    for(i = 1; i < n; ++i)m = a[i] / b[i - 1], b[i] -= m, r[i] -= m * r[i - 1];
    a[n - 1] = r[n - 1] / b[n - 1];
    for(i = n - 2; i >= 0; --i)a[i] = (r[i] - a[i + 1]) / b[i];
    b[n - 1] = (x[n] + a[n - 1]) / 2;
    for(i = 0; i < n - 1; ++i)b[i] = 2 * x[i + 1] - a[i + 1];
    return [
        a,
        b
    ];
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"ipHcF":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(context) {
        return new Step(context, 0.5);
    });
parcelHelpers.export(exports, "stepBefore", ()=>stepBefore);
parcelHelpers.export(exports, "stepAfter", ()=>stepAfter);
function Step(context, t) {
    this._context = context;
    this._t = t;
}
Step.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x = this._y = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        if (0 < this._t && this._t < 1 && this._point === 2) this._context.lineTo(this._x, this._y);
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        if (this._line >= 0) this._t = 1 - this._t, this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2; // falls through
            default:
                if (this._t <= 0) {
                    this._context.lineTo(this._x, y);
                    this._context.lineTo(x, y);
                } else {
                    var x1 = this._x * (1 - this._t) + x * this._t;
                    this._context.lineTo(x1, this._y);
                    this._context.lineTo(x1, y);
                }
                break;
        }
        this._x = x, this._y = y;
    }
};
function stepBefore(context) {
    return new Step(context, 0);
}
function stepAfter(context) {
    return new Step(context, 1);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"724K5":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        var keys = (0, _constantJsDefault.default)([]), order = (0, _noneJsDefault1.default), offset = (0, _noneJsDefault.default), value = stackValue;
        function stack(data) {
            var sz = Array.from(keys.apply(this, arguments), stackSeries), i, n = sz.length, j = -1, oz;
            for (const d of data)for(i = 0, ++j; i < n; ++i)(sz[i][j] = [
                0,
                +value(d, sz[i].key, j, data)
            ]).data = d;
            for(i = 0, oz = (0, _arrayJsDefault.default)(order(sz)); i < n; ++i)sz[oz[i]].index = i;
            offset(sz, oz);
            return sz;
        }
        stack.keys = function(_) {
            return arguments.length ? (keys = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(Array.from(_)), stack) : keys;
        };
        stack.value = function(_) {
            return arguments.length ? (value = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(+_), stack) : value;
        };
        stack.order = function(_) {
            return arguments.length ? (order = _ == null ? (0, _noneJsDefault1.default) : typeof _ === "function" ? _ : (0, _constantJsDefault.default)(Array.from(_)), stack) : order;
        };
        stack.offset = function(_) {
            return arguments.length ? (offset = _ == null ? (0, _noneJsDefault.default) : _, stack) : offset;
        };
        return stack;
    });
var _arrayJs = require("./array.js");
var _arrayJsDefault = parcelHelpers.interopDefault(_arrayJs);
var _constantJs = require("./constant.js");
var _constantJsDefault = parcelHelpers.interopDefault(_constantJs);
var _noneJs = require("./offset/none.js");
var _noneJsDefault = parcelHelpers.interopDefault(_noneJs);
var _noneJs1 = require("./order/none.js");
var _noneJsDefault1 = parcelHelpers.interopDefault(_noneJs1);
function stackValue(d, key) {
    return d[key];
}
function stackSeries(key) {
    const series = [];
    series.key = key;
    return series;
}

},{"./array.js":"7c3gb","./constant.js":"dowtg","./offset/none.js":"BSEuE","./order/none.js":"heTyv","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"BSEuE":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(series, order) {
        if (!((n = series.length) > 1)) return;
        for(var i = 1, j, s0, s1 = series[order[0]], n, m = s1.length; i < n; ++i){
            s0 = s1, s1 = series[order[i]];
            for(j = 0; j < m; ++j)s1[j][1] += s1[j][0] = isNaN(s0[j][1]) ? s0[j][0] : s0[j][1];
        }
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"heTyv":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(series) {
        var n = series.length, o = new Array(n);
        while(--n >= 0)o[n] = n;
        return o;
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1GMo5":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(series, order) {
        if (!((n = series.length) > 0)) return;
        for(var i, n, j = 0, m = series[0].length, y; j < m; ++j){
            for(y = i = 0; i < n; ++i)y += series[i][j][1] || 0;
            if (y) for(i = 0; i < n; ++i)series[i][j][1] /= y;
        }
        (0, _noneJsDefault.default)(series, order);
    });
var _noneJs = require("./none.js");
var _noneJsDefault = parcelHelpers.interopDefault(_noneJs);

},{"./none.js":"BSEuE","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"gyAC2":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(series, order) {
        if (!((n = series.length) > 0)) return;
        for(var i, j = 0, d, dy, yp, yn, n, m = series[order[0]].length; j < m; ++j)for(yp = yn = 0, i = 0; i < n; ++i){
            if ((dy = (d = series[order[i]][j])[1] - d[0]) > 0) d[0] = yp, d[1] = yp += dy;
            else if (dy < 0) d[1] = yn, d[0] = yn += dy;
            else d[0] = 0, d[1] = dy;
        }
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"iSONX":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(series, order) {
        if (!((n = series.length) > 0)) return;
        for(var j = 0, s0 = series[order[0]], n, m = s0.length; j < m; ++j){
            for(var i = 0, y = 0; i < n; ++i)y += series[i][j][1] || 0;
            s0[j][1] += s0[j][0] = -y / 2;
        }
        (0, _noneJsDefault.default)(series, order);
    });
var _noneJs = require("./none.js");
var _noneJsDefault = parcelHelpers.interopDefault(_noneJs);

},{"./none.js":"BSEuE","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"95A1s":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(series, order) {
        if (!((n = series.length) > 0) || !((m = (s0 = series[order[0]]).length) > 0)) return;
        for(var y = 0, j = 1, s0, m, n; j < m; ++j){
            for(var i = 0, s1 = 0, s2 = 0; i < n; ++i){
                var si = series[order[i]], sij0 = si[j][1] || 0, sij1 = si[j - 1][1] || 0, s3 = (sij0 - sij1) / 2;
                for(var k = 0; k < i; ++k){
                    var sk = series[order[k]], skj0 = sk[j][1] || 0, skj1 = sk[j - 1][1] || 0;
                    s3 += skj0 - skj1;
                }
                s1 += sij0, s2 += s3 * sij0;
            }
            s0[j - 1][1] += s0[j - 1][0] = y;
            if (s1) y -= s2 / s1;
        }
        s0[j - 1][1] += s0[j - 1][0] = y;
        (0, _noneJsDefault.default)(series, order);
    });
var _noneJs = require("./none.js");
var _noneJsDefault = parcelHelpers.interopDefault(_noneJs);

},{"./none.js":"BSEuE","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"ahopc":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(series) {
        var peaks = series.map(peak);
        return (0, _noneJsDefault.default)(series).sort(function(a, b) {
            return peaks[a] - peaks[b];
        });
    });
var _noneJs = require("./none.js");
var _noneJsDefault = parcelHelpers.interopDefault(_noneJs);
function peak(series) {
    var i = -1, j = 0, n = series.length, vi, vj = -Infinity;
    while(++i < n)if ((vi = +series[i][1]) > vj) vj = vi, j = i;
    return j;
}

},{"./none.js":"heTyv","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"amYoy":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(series) {
        var sums = series.map(sum);
        return (0, _noneJsDefault.default)(series).sort(function(a, b) {
            return sums[a] - sums[b];
        });
    });
parcelHelpers.export(exports, "sum", ()=>sum);
var _noneJs = require("./none.js");
var _noneJsDefault = parcelHelpers.interopDefault(_noneJs);
function sum(series) {
    var s = 0, i = -1, n = series.length, v;
    while(++i < n)if (v = +series[i][1]) s += v;
    return s;
}

},{"./none.js":"heTyv","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"5TXuD":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(series) {
        return (0, _ascendingJsDefault.default)(series).reverse();
    });
var _ascendingJs = require("./ascending.js");
var _ascendingJsDefault = parcelHelpers.interopDefault(_ascendingJs);

},{"./ascending.js":"amYoy","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"21iWT":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(series) {
        var n = series.length, i, j, sums = series.map((0, _ascendingJs.sum)), order = (0, _appearanceJsDefault.default)(series), top = 0, bottom = 0, tops = [], bottoms = [];
        for(i = 0; i < n; ++i){
            j = order[i];
            if (top < bottom) {
                top += sums[j];
                tops.push(j);
            } else {
                bottom += sums[j];
                bottoms.push(j);
            }
        }
        return bottoms.reverse().concat(tops);
    });
var _appearanceJs = require("./appearance.js");
var _appearanceJsDefault = parcelHelpers.interopDefault(_appearanceJs);
var _ascendingJs = require("./ascending.js");

},{"./appearance.js":"ahopc","./ascending.js":"amYoy","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1cGWN":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(series) {
        return (0, _noneJsDefault.default)(series).reverse();
    });
var _noneJs = require("./none.js");
var _noneJsDefault = parcelHelpers.interopDefault(_noneJs);

},{"./none.js":"heTyv","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7BK9l":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "scaleBand", ()=>(0, _bandJsDefault.default));
parcelHelpers.export(exports, "scalePoint", ()=>(0, _bandJs.point));
parcelHelpers.export(exports, "scaleIdentity", ()=>(0, _identityJsDefault.default));
parcelHelpers.export(exports, "scaleLinear", ()=>(0, _linearJsDefault.default));
parcelHelpers.export(exports, "scaleLog", ()=>(0, _logJsDefault.default));
parcelHelpers.export(exports, "scaleSymlog", ()=>(0, _symlogJsDefault.default));
parcelHelpers.export(exports, "scaleOrdinal", ()=>(0, _ordinalJsDefault.default));
parcelHelpers.export(exports, "scaleImplicit", ()=>(0, _ordinalJs.implicit));
parcelHelpers.export(exports, "scalePow", ()=>(0, _powJsDefault.default));
parcelHelpers.export(exports, "scaleSqrt", ()=>(0, _powJs.sqrt));
parcelHelpers.export(exports, "scaleRadial", ()=>(0, _radialJsDefault.default));
parcelHelpers.export(exports, "scaleQuantile", ()=>(0, _quantileJsDefault.default));
parcelHelpers.export(exports, "scaleQuantize", ()=>(0, _quantizeJsDefault.default));
parcelHelpers.export(exports, "scaleThreshold", ()=>(0, _thresholdJsDefault.default));
parcelHelpers.export(exports, "scaleTime", ()=>(0, _timeJsDefault.default));
parcelHelpers.export(exports, "scaleUtc", ()=>(0, _utcTimeJsDefault.default));
parcelHelpers.export(exports, "scaleSequential", ()=>(0, _sequentialJsDefault.default));
parcelHelpers.export(exports, "scaleSequentialLog", ()=>(0, _sequentialJs.sequentialLog));
parcelHelpers.export(exports, "scaleSequentialPow", ()=>(0, _sequentialJs.sequentialPow));
parcelHelpers.export(exports, "scaleSequentialSqrt", ()=>(0, _sequentialJs.sequentialSqrt));
parcelHelpers.export(exports, "scaleSequentialSymlog", ()=>(0, _sequentialJs.sequentialSymlog));
parcelHelpers.export(exports, "scaleSequentialQuantile", ()=>(0, _sequentialQuantileJsDefault.default));
parcelHelpers.export(exports, "scaleDiverging", ()=>(0, _divergingJsDefault.default));
parcelHelpers.export(exports, "scaleDivergingLog", ()=>(0, _divergingJs.divergingLog));
parcelHelpers.export(exports, "scaleDivergingPow", ()=>(0, _divergingJs.divergingPow));
parcelHelpers.export(exports, "scaleDivergingSqrt", ()=>(0, _divergingJs.divergingSqrt));
parcelHelpers.export(exports, "scaleDivergingSymlog", ()=>(0, _divergingJs.divergingSymlog));
parcelHelpers.export(exports, "tickFormat", ()=>(0, _tickFormatJsDefault.default));
var _bandJs = require("./band.js");
var _bandJsDefault = parcelHelpers.interopDefault(_bandJs);
var _identityJs = require("./identity.js");
var _identityJsDefault = parcelHelpers.interopDefault(_identityJs);
var _linearJs = require("./linear.js");
var _linearJsDefault = parcelHelpers.interopDefault(_linearJs);
var _logJs = require("./log.js");
var _logJsDefault = parcelHelpers.interopDefault(_logJs);
var _symlogJs = require("./symlog.js");
var _symlogJsDefault = parcelHelpers.interopDefault(_symlogJs);
var _ordinalJs = require("./ordinal.js");
var _ordinalJsDefault = parcelHelpers.interopDefault(_ordinalJs);
var _powJs = require("./pow.js");
var _powJsDefault = parcelHelpers.interopDefault(_powJs);
var _radialJs = require("./radial.js");
var _radialJsDefault = parcelHelpers.interopDefault(_radialJs);
var _quantileJs = require("./quantile.js");
var _quantileJsDefault = parcelHelpers.interopDefault(_quantileJs);
var _quantizeJs = require("./quantize.js");
var _quantizeJsDefault = parcelHelpers.interopDefault(_quantizeJs);
var _thresholdJs = require("./threshold.js");
var _thresholdJsDefault = parcelHelpers.interopDefault(_thresholdJs);
var _timeJs = require("./time.js");
var _timeJsDefault = parcelHelpers.interopDefault(_timeJs);
var _utcTimeJs = require("./utcTime.js");
var _utcTimeJsDefault = parcelHelpers.interopDefault(_utcTimeJs);
var _sequentialJs = require("./sequential.js");
var _sequentialJsDefault = parcelHelpers.interopDefault(_sequentialJs);
var _sequentialQuantileJs = require("./sequentialQuantile.js");
var _sequentialQuantileJsDefault = parcelHelpers.interopDefault(_sequentialQuantileJs);
var _divergingJs = require("./diverging.js");
var _divergingJsDefault = parcelHelpers.interopDefault(_divergingJs);
var _tickFormatJs = require("./tickFormat.js");
var _tickFormatJsDefault = parcelHelpers.interopDefault(_tickFormatJs);

},{"./band.js":"5Q6GK","./identity.js":false,"./linear.js":"5y58A","./log.js":"ie2vG","./symlog.js":"3luv5","./ordinal.js":"9md62","./pow.js":false,"./radial.js":false,"./quantile.js":false,"./quantize.js":"9QtkS","./threshold.js":false,"./time.js":"fNFf4","./utcTime.js":"98eKC","./sequential.js":"g41Hh","./sequentialQuantile.js":false,"./diverging.js":"lGrfG","./tickFormat.js":false,"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"5Q6GK":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>band);
parcelHelpers.export(exports, "point", ()=>point);
var _d3Array = require("d3-array");
var _initJs = require("./init.js");
var _ordinalJs = require("./ordinal.js");
var _ordinalJsDefault = parcelHelpers.interopDefault(_ordinalJs);
function band() {
    var scale = (0, _ordinalJsDefault.default)().unknown(undefined), domain = scale.domain, ordinalRange = scale.range, r0 = 0, r1 = 1, step, bandwidth, round = false, paddingInner = 0, paddingOuter = 0, align = 0.5;
    delete scale.unknown;
    function rescale() {
        var n = domain().length, reverse = r1 < r0, start = reverse ? r1 : r0, stop = reverse ? r0 : r1;
        step = (stop - start) / Math.max(1, n - paddingInner + paddingOuter * 2);
        if (round) step = Math.floor(step);
        start += (stop - start - step * (n - paddingInner)) * align;
        bandwidth = step * (1 - paddingInner);
        if (round) start = Math.round(start), bandwidth = Math.round(bandwidth);
        var values = (0, _d3Array.range)(n).map(function(i) {
            return start + step * i;
        });
        return ordinalRange(reverse ? values.reverse() : values);
    }
    scale.domain = function(_) {
        return arguments.length ? (domain(_), rescale()) : domain();
    };
    scale.range = function(_) {
        return arguments.length ? ([r0, r1] = _, r0 = +r0, r1 = +r1, rescale()) : [
            r0,
            r1
        ];
    };
    scale.rangeRound = function(_) {
        return [r0, r1] = _, r0 = +r0, r1 = +r1, round = true, rescale();
    };
    scale.bandwidth = function() {
        return bandwidth;
    };
    scale.step = function() {
        return step;
    };
    scale.round = function(_) {
        return arguments.length ? (round = !!_, rescale()) : round;
    };
    scale.padding = function(_) {
        return arguments.length ? (paddingInner = Math.min(1, paddingOuter = +_), rescale()) : paddingInner;
    };
    scale.paddingInner = function(_) {
        return arguments.length ? (paddingInner = Math.min(1, _), rescale()) : paddingInner;
    };
    scale.paddingOuter = function(_) {
        return arguments.length ? (paddingOuter = +_, rescale()) : paddingOuter;
    };
    scale.align = function(_) {
        return arguments.length ? (align = Math.max(0, Math.min(1, _)), rescale()) : align;
    };
    scale.copy = function() {
        return band(domain(), [
            r0,
            r1
        ]).round(round).paddingInner(paddingInner).paddingOuter(paddingOuter).align(align);
    };
    return (0, _initJs.initRange).apply(rescale(), arguments);
}
function pointish(scale) {
    var copy = scale.copy;
    scale.padding = scale.paddingOuter;
    delete scale.paddingInner;
    delete scale.paddingOuter;
    scale.copy = function() {
        return pointish(copy());
    };
    return scale;
}
function point() {
    return pointish(band.apply(null, arguments).paddingInner(1));
}

},{"d3-array":"bmqp6","./init.js":"MGGB7","./ordinal.js":"9md62","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"bmqp6":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "bisect", ()=>(0, _bisectJsDefault.default));
parcelHelpers.export(exports, "bisectRight", ()=>(0, _bisectJs.bisectRight));
parcelHelpers.export(exports, "bisectLeft", ()=>(0, _bisectJs.bisectLeft));
parcelHelpers.export(exports, "bisectCenter", ()=>(0, _bisectJs.bisectCenter));
parcelHelpers.export(exports, "ascending", ()=>(0, _ascendingJsDefault.default));
parcelHelpers.export(exports, "bisector", ()=>(0, _bisectorJsDefault.default));
parcelHelpers.export(exports, "blur", ()=>(0, _blurJs.blur));
parcelHelpers.export(exports, "blur2", ()=>(0, _blurJs.blur2));
parcelHelpers.export(exports, "blurImage", ()=>(0, _blurJs.blurImage));
parcelHelpers.export(exports, "count", ()=>(0, _countJsDefault.default));
parcelHelpers.export(exports, "cross", ()=>(0, _crossJsDefault.default));
parcelHelpers.export(exports, "cumsum", ()=>(0, _cumsumJsDefault.default));
parcelHelpers.export(exports, "descending", ()=>(0, _descendingJsDefault.default));
parcelHelpers.export(exports, "deviation", ()=>(0, _deviationJsDefault.default));
parcelHelpers.export(exports, "extent", ()=>(0, _extentJsDefault.default));
parcelHelpers.export(exports, "Adder", ()=>(0, _fsumJs.Adder));
parcelHelpers.export(exports, "fsum", ()=>(0, _fsumJs.fsum));
parcelHelpers.export(exports, "fcumsum", ()=>(0, _fsumJs.fcumsum));
parcelHelpers.export(exports, "group", ()=>(0, _groupJsDefault.default));
parcelHelpers.export(exports, "flatGroup", ()=>(0, _groupJs.flatGroup));
parcelHelpers.export(exports, "flatRollup", ()=>(0, _groupJs.flatRollup));
parcelHelpers.export(exports, "groups", ()=>(0, _groupJs.groups));
parcelHelpers.export(exports, "index", ()=>(0, _groupJs.index));
parcelHelpers.export(exports, "indexes", ()=>(0, _groupJs.indexes));
parcelHelpers.export(exports, "rollup", ()=>(0, _groupJs.rollup));
parcelHelpers.export(exports, "rollups", ()=>(0, _groupJs.rollups));
parcelHelpers.export(exports, "groupSort", ()=>(0, _groupSortJsDefault.default));
parcelHelpers.export(exports, "bin", ()=>(0, _binJsDefault.default)) // Deprecated; use bin.
;
parcelHelpers.export(exports, "histogram", ()=>(0, _binJsDefault.default));
parcelHelpers.export(exports, "thresholdFreedmanDiaconis", ()=>(0, _freedmanDiaconisJsDefault.default));
parcelHelpers.export(exports, "thresholdScott", ()=>(0, _scottJsDefault.default));
parcelHelpers.export(exports, "thresholdSturges", ()=>(0, _sturgesJsDefault.default));
parcelHelpers.export(exports, "max", ()=>(0, _maxJsDefault.default));
parcelHelpers.export(exports, "maxIndex", ()=>(0, _maxIndexJsDefault.default));
parcelHelpers.export(exports, "mean", ()=>(0, _meanJsDefault.default));
parcelHelpers.export(exports, "median", ()=>(0, _medianJsDefault.default));
parcelHelpers.export(exports, "medianIndex", ()=>(0, _medianJs.medianIndex));
parcelHelpers.export(exports, "merge", ()=>(0, _mergeJsDefault.default));
parcelHelpers.export(exports, "min", ()=>(0, _minJsDefault.default));
parcelHelpers.export(exports, "minIndex", ()=>(0, _minIndexJsDefault.default));
parcelHelpers.export(exports, "mode", ()=>(0, _modeJsDefault.default));
parcelHelpers.export(exports, "nice", ()=>(0, _niceJsDefault.default));
parcelHelpers.export(exports, "pairs", ()=>(0, _pairsJsDefault.default));
parcelHelpers.export(exports, "permute", ()=>(0, _permuteJsDefault.default));
parcelHelpers.export(exports, "quantile", ()=>(0, _quantileJsDefault.default));
parcelHelpers.export(exports, "quantileIndex", ()=>(0, _quantileJs.quantileIndex));
parcelHelpers.export(exports, "quantileSorted", ()=>(0, _quantileJs.quantileSorted));
parcelHelpers.export(exports, "quickselect", ()=>(0, _quickselectJsDefault.default));
parcelHelpers.export(exports, "range", ()=>(0, _rangeJsDefault.default));
parcelHelpers.export(exports, "rank", ()=>(0, _rankJsDefault.default));
parcelHelpers.export(exports, "least", ()=>(0, _leastJsDefault.default));
parcelHelpers.export(exports, "leastIndex", ()=>(0, _leastIndexJsDefault.default));
parcelHelpers.export(exports, "greatest", ()=>(0, _greatestJsDefault.default));
parcelHelpers.export(exports, "greatestIndex", ()=>(0, _greatestIndexJsDefault.default));
parcelHelpers.export(exports, "scan", ()=>(0, _scanJsDefault.default)) // Deprecated; use leastIndex.
;
parcelHelpers.export(exports, "shuffle", ()=>(0, _shuffleJsDefault.default));
parcelHelpers.export(exports, "shuffler", ()=>(0, _shuffleJs.shuffler));
parcelHelpers.export(exports, "sum", ()=>(0, _sumJsDefault.default));
parcelHelpers.export(exports, "ticks", ()=>(0, _ticksJsDefault.default));
parcelHelpers.export(exports, "tickIncrement", ()=>(0, _ticksJs.tickIncrement));
parcelHelpers.export(exports, "tickStep", ()=>(0, _ticksJs.tickStep));
parcelHelpers.export(exports, "transpose", ()=>(0, _transposeJsDefault.default));
parcelHelpers.export(exports, "variance", ()=>(0, _varianceJsDefault.default));
parcelHelpers.export(exports, "zip", ()=>(0, _zipJsDefault.default));
parcelHelpers.export(exports, "every", ()=>(0, _everyJsDefault.default));
parcelHelpers.export(exports, "some", ()=>(0, _someJsDefault.default));
parcelHelpers.export(exports, "filter", ()=>(0, _filterJsDefault.default));
parcelHelpers.export(exports, "map", ()=>(0, _mapJsDefault.default));
parcelHelpers.export(exports, "reduce", ()=>(0, _reduceJsDefault.default));
parcelHelpers.export(exports, "reverse", ()=>(0, _reverseJsDefault.default));
parcelHelpers.export(exports, "sort", ()=>(0, _sortJsDefault.default));
parcelHelpers.export(exports, "difference", ()=>(0, _differenceJsDefault.default));
parcelHelpers.export(exports, "disjoint", ()=>(0, _disjointJsDefault.default));
parcelHelpers.export(exports, "intersection", ()=>(0, _intersectionJsDefault.default));
parcelHelpers.export(exports, "subset", ()=>(0, _subsetJsDefault.default));
parcelHelpers.export(exports, "superset", ()=>(0, _supersetJsDefault.default));
parcelHelpers.export(exports, "union", ()=>(0, _unionJsDefault.default));
parcelHelpers.export(exports, "InternMap", ()=>(0, _internmap.InternMap));
parcelHelpers.export(exports, "InternSet", ()=>(0, _internmap.InternSet));
var _bisectJs = require("./bisect.js");
var _bisectJsDefault = parcelHelpers.interopDefault(_bisectJs);
var _ascendingJs = require("./ascending.js");
var _ascendingJsDefault = parcelHelpers.interopDefault(_ascendingJs);
var _bisectorJs = require("./bisector.js");
var _bisectorJsDefault = parcelHelpers.interopDefault(_bisectorJs);
var _blurJs = require("./blur.js");
var _countJs = require("./count.js");
var _countJsDefault = parcelHelpers.interopDefault(_countJs);
var _crossJs = require("./cross.js");
var _crossJsDefault = parcelHelpers.interopDefault(_crossJs);
var _cumsumJs = require("./cumsum.js");
var _cumsumJsDefault = parcelHelpers.interopDefault(_cumsumJs);
var _descendingJs = require("./descending.js");
var _descendingJsDefault = parcelHelpers.interopDefault(_descendingJs);
var _deviationJs = require("./deviation.js");
var _deviationJsDefault = parcelHelpers.interopDefault(_deviationJs);
var _extentJs = require("./extent.js");
var _extentJsDefault = parcelHelpers.interopDefault(_extentJs);
var _fsumJs = require("./fsum.js");
var _groupJs = require("./group.js");
var _groupJsDefault = parcelHelpers.interopDefault(_groupJs);
var _groupSortJs = require("./groupSort.js");
var _groupSortJsDefault = parcelHelpers.interopDefault(_groupSortJs);
var _binJs = require("./bin.js");
var _binJsDefault = parcelHelpers.interopDefault(_binJs);
var _freedmanDiaconisJs = require("./threshold/freedmanDiaconis.js");
var _freedmanDiaconisJsDefault = parcelHelpers.interopDefault(_freedmanDiaconisJs);
var _scottJs = require("./threshold/scott.js");
var _scottJsDefault = parcelHelpers.interopDefault(_scottJs);
var _sturgesJs = require("./threshold/sturges.js");
var _sturgesJsDefault = parcelHelpers.interopDefault(_sturgesJs);
var _maxJs = require("./max.js");
var _maxJsDefault = parcelHelpers.interopDefault(_maxJs);
var _maxIndexJs = require("./maxIndex.js");
var _maxIndexJsDefault = parcelHelpers.interopDefault(_maxIndexJs);
var _meanJs = require("./mean.js");
var _meanJsDefault = parcelHelpers.interopDefault(_meanJs);
var _medianJs = require("./median.js");
var _medianJsDefault = parcelHelpers.interopDefault(_medianJs);
var _mergeJs = require("./merge.js");
var _mergeJsDefault = parcelHelpers.interopDefault(_mergeJs);
var _minJs = require("./min.js");
var _minJsDefault = parcelHelpers.interopDefault(_minJs);
var _minIndexJs = require("./minIndex.js");
var _minIndexJsDefault = parcelHelpers.interopDefault(_minIndexJs);
var _modeJs = require("./mode.js");
var _modeJsDefault = parcelHelpers.interopDefault(_modeJs);
var _niceJs = require("./nice.js");
var _niceJsDefault = parcelHelpers.interopDefault(_niceJs);
var _pairsJs = require("./pairs.js");
var _pairsJsDefault = parcelHelpers.interopDefault(_pairsJs);
var _permuteJs = require("./permute.js");
var _permuteJsDefault = parcelHelpers.interopDefault(_permuteJs);
var _quantileJs = require("./quantile.js");
var _quantileJsDefault = parcelHelpers.interopDefault(_quantileJs);
var _quickselectJs = require("./quickselect.js");
var _quickselectJsDefault = parcelHelpers.interopDefault(_quickselectJs);
var _rangeJs = require("./range.js");
var _rangeJsDefault = parcelHelpers.interopDefault(_rangeJs);
var _rankJs = require("./rank.js");
var _rankJsDefault = parcelHelpers.interopDefault(_rankJs);
var _leastJs = require("./least.js");
var _leastJsDefault = parcelHelpers.interopDefault(_leastJs);
var _leastIndexJs = require("./leastIndex.js");
var _leastIndexJsDefault = parcelHelpers.interopDefault(_leastIndexJs);
var _greatestJs = require("./greatest.js");
var _greatestJsDefault = parcelHelpers.interopDefault(_greatestJs);
var _greatestIndexJs = require("./greatestIndex.js");
var _greatestIndexJsDefault = parcelHelpers.interopDefault(_greatestIndexJs);
var _scanJs = require("./scan.js");
var _scanJsDefault = parcelHelpers.interopDefault(_scanJs);
var _shuffleJs = require("./shuffle.js");
var _shuffleJsDefault = parcelHelpers.interopDefault(_shuffleJs);
var _sumJs = require("./sum.js");
var _sumJsDefault = parcelHelpers.interopDefault(_sumJs);
var _ticksJs = require("./ticks.js");
var _ticksJsDefault = parcelHelpers.interopDefault(_ticksJs);
var _transposeJs = require("./transpose.js");
var _transposeJsDefault = parcelHelpers.interopDefault(_transposeJs);
var _varianceJs = require("./variance.js");
var _varianceJsDefault = parcelHelpers.interopDefault(_varianceJs);
var _zipJs = require("./zip.js");
var _zipJsDefault = parcelHelpers.interopDefault(_zipJs);
var _everyJs = require("./every.js");
var _everyJsDefault = parcelHelpers.interopDefault(_everyJs);
var _someJs = require("./some.js");
var _someJsDefault = parcelHelpers.interopDefault(_someJs);
var _filterJs = require("./filter.js");
var _filterJsDefault = parcelHelpers.interopDefault(_filterJs);
var _mapJs = require("./map.js");
var _mapJsDefault = parcelHelpers.interopDefault(_mapJs);
var _reduceJs = require("./reduce.js");
var _reduceJsDefault = parcelHelpers.interopDefault(_reduceJs);
var _reverseJs = require("./reverse.js");
var _reverseJsDefault = parcelHelpers.interopDefault(_reverseJs);
var _sortJs = require("./sort.js");
var _sortJsDefault = parcelHelpers.interopDefault(_sortJs);
var _differenceJs = require("./difference.js");
var _differenceJsDefault = parcelHelpers.interopDefault(_differenceJs);
var _disjointJs = require("./disjoint.js");
var _disjointJsDefault = parcelHelpers.interopDefault(_disjointJs);
var _intersectionJs = require("./intersection.js");
var _intersectionJsDefault = parcelHelpers.interopDefault(_intersectionJs);
var _subsetJs = require("./subset.js");
var _subsetJsDefault = parcelHelpers.interopDefault(_subsetJs);
var _supersetJs = require("./superset.js");
var _supersetJsDefault = parcelHelpers.interopDefault(_supersetJs);
var _unionJs = require("./union.js");
var _unionJsDefault = parcelHelpers.interopDefault(_unionJs);
var _internmap = require("internmap");

},{"./bisect.js":"6E3K1","./ascending.js":"fxpE9","./bisector.js":"gZxpz","./blur.js":"6MSys","./count.js":"bEr1m","./cross.js":"d7fnh","./cumsum.js":"2Kj7J","./descending.js":"eZNjL","./deviation.js":"63ogy","./extent.js":"kkkz7","./fsum.js":"5h9sS","./group.js":"dK75Z","./groupSort.js":"bd0HG","./bin.js":"fSCEd","./threshold/freedmanDiaconis.js":"ivGXE","./threshold/scott.js":"7aFxa","./threshold/sturges.js":"5VRgb","./max.js":"8VFj7","./maxIndex.js":"9TsNn","./mean.js":"lGLmc","./median.js":"4CtA1","./merge.js":"fZD2z","./min.js":"aV6tL","./minIndex.js":"4MZIY","./mode.js":"49bDg","./nice.js":"6opYb","./pairs.js":"3GyTU","./permute.js":"eLUwT","./quantile.js":"gtsMZ","./quickselect.js":"bjyfD","./range.js":"egnZn","./rank.js":"2fUwM","./least.js":"g2WOH","./leastIndex.js":"cdgca","./greatest.js":"ba9H2","./greatestIndex.js":"6pWs0","./scan.js":"3j2zL","./shuffle.js":"gHM4C","./sum.js":"7UDGD","./ticks.js":"hdIWy","./transpose.js":"f6Iqo","./variance.js":"4UZOK","./zip.js":"GnVPt","./every.js":"iMs3v","./some.js":"2SKDc","./filter.js":"lew24","./map.js":"6QMxP","./reduce.js":"fO6yJ","./reverse.js":"6VYWf","./sort.js":"hn4qB","./difference.js":"CzXyM","./disjoint.js":"jsBdg","./intersection.js":"XLnB1","./subset.js":"5pv38","./superset.js":"dQOGc","./union.js":"bPXjL","internmap":"lN5oE","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6E3K1":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "bisectRight", ()=>bisectRight);
parcelHelpers.export(exports, "bisectLeft", ()=>bisectLeft);
parcelHelpers.export(exports, "bisectCenter", ()=>bisectCenter);
var _ascendingJs = require("./ascending.js");
var _ascendingJsDefault = parcelHelpers.interopDefault(_ascendingJs);
var _bisectorJs = require("./bisector.js");
var _bisectorJsDefault = parcelHelpers.interopDefault(_bisectorJs);
var _numberJs = require("./number.js");
var _numberJsDefault = parcelHelpers.interopDefault(_numberJs);
const ascendingBisect = (0, _bisectorJsDefault.default)((0, _ascendingJsDefault.default));
const bisectRight = ascendingBisect.right;
const bisectLeft = ascendingBisect.left;
const bisectCenter = (0, _bisectorJsDefault.default)((0, _numberJsDefault.default)).center;
exports.default = bisectRight;

},{"./ascending.js":"fxpE9","./bisector.js":"gZxpz","./number.js":"cFSaj","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"fxpE9":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>ascending);
function ascending(a, b) {
    return a == null || b == null ? NaN : a < b ? -1 : a > b ? 1 : a >= b ? 0 : NaN;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"gZxpz":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>bisector);
var _ascendingJs = require("./ascending.js");
var _ascendingJsDefault = parcelHelpers.interopDefault(_ascendingJs);
var _descendingJs = require("./descending.js");
var _descendingJsDefault = parcelHelpers.interopDefault(_descendingJs);
function bisector(f) {
    let compare1, compare2, delta;
    // If an accessor is specified, promote it to a comparator. In this case we
    // can test whether the search value is (self-) comparable. We can’t do this
    // for a comparator (except for specific, known comparators) because we can’t
    // tell if the comparator is symmetric, and an asymmetric comparator can’t be
    // used to test whether a single value is comparable.
    if (f.length !== 2) {
        compare1 = (0, _ascendingJsDefault.default);
        compare2 = (d, x)=>(0, _ascendingJsDefault.default)(f(d), x);
        delta = (d, x)=>f(d) - x;
    } else {
        compare1 = f === (0, _ascendingJsDefault.default) || f === (0, _descendingJsDefault.default) ? f : zero;
        compare2 = f;
        delta = f;
    }
    function left(a, x, lo = 0, hi = a.length) {
        if (lo < hi) {
            if (compare1(x, x) !== 0) return hi;
            do {
                const mid = lo + hi >>> 1;
                if (compare2(a[mid], x) < 0) lo = mid + 1;
                else hi = mid;
            }while (lo < hi);
        }
        return lo;
    }
    function right(a, x, lo = 0, hi = a.length) {
        if (lo < hi) {
            if (compare1(x, x) !== 0) return hi;
            do {
                const mid = lo + hi >>> 1;
                if (compare2(a[mid], x) <= 0) lo = mid + 1;
                else hi = mid;
            }while (lo < hi);
        }
        return lo;
    }
    function center(a, x, lo = 0, hi = a.length) {
        const i = left(a, x, lo, hi - 1);
        return i > lo && delta(a[i - 1], x) > -delta(a[i], x) ? i - 1 : i;
    }
    return {
        left,
        center,
        right
    };
}
function zero() {
    return 0;
}

},{"./ascending.js":"fxpE9","./descending.js":"eZNjL","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"eZNjL":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>descending);
function descending(a, b) {
    return a == null || b == null ? NaN : b < a ? -1 : b > a ? 1 : b >= a ? 0 : NaN;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"cFSaj":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>number);
parcelHelpers.export(exports, "numbers", ()=>numbers);
function number(x) {
    return x === null ? NaN : +x;
}
function* numbers(values, valueof) {
    if (valueof === undefined) {
        for (let value of values)if (value != null && (value = +value) >= value) yield value;
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (value = +value) >= value) yield value;
    }
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6MSys":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "blur", ()=>blur);
parcelHelpers.export(exports, "blur2", ()=>blur2);
parcelHelpers.export(exports, "blurImage", ()=>blurImage);
function blur(values, r) {
    if (!((r = +r) >= 0)) throw new RangeError("invalid r");
    let length = values.length;
    if (!((length = Math.floor(length)) >= 0)) throw new RangeError("invalid length");
    if (!length || !r) return values;
    const blur = blurf(r);
    const temp = values.slice();
    blur(values, temp, 0, length, 1);
    blur(temp, values, 0, length, 1);
    blur(values, temp, 0, length, 1);
    return values;
}
const blur2 = Blur2(blurf);
const blurImage = Blur2(blurfImage);
function Blur2(blur) {
    return function(data, rx, ry = rx) {
        if (!((rx = +rx) >= 0)) throw new RangeError("invalid rx");
        if (!((ry = +ry) >= 0)) throw new RangeError("invalid ry");
        let { data: values, width, height } = data;
        if (!((width = Math.floor(width)) >= 0)) throw new RangeError("invalid width");
        if (!((height = Math.floor(height !== undefined ? height : values.length / width)) >= 0)) throw new RangeError("invalid height");
        if (!width || !height || !rx && !ry) return data;
        const blurx = rx && blur(rx);
        const blury = ry && blur(ry);
        const temp = values.slice();
        if (blurx && blury) {
            blurh(blurx, temp, values, width, height);
            blurh(blurx, values, temp, width, height);
            blurh(blurx, temp, values, width, height);
            blurv(blury, values, temp, width, height);
            blurv(blury, temp, values, width, height);
            blurv(blury, values, temp, width, height);
        } else if (blurx) {
            blurh(blurx, values, temp, width, height);
            blurh(blurx, temp, values, width, height);
            blurh(blurx, values, temp, width, height);
        } else if (blury) {
            blurv(blury, values, temp, width, height);
            blurv(blury, temp, values, width, height);
            blurv(blury, values, temp, width, height);
        }
        return data;
    };
}
function blurh(blur, T, S, w, h) {
    for(let y = 0, n = w * h; y < n;)blur(T, S, y, y += w, 1);
}
function blurv(blur, T, S, w, h) {
    for(let x = 0, n = w * h; x < w; ++x)blur(T, S, x, x + n, w);
}
function blurfImage(radius) {
    const blur = blurf(radius);
    return (T, S, start, stop, step)=>{
        start <<= 2, stop <<= 2, step <<= 2;
        blur(T, S, start + 0, stop + 0, step);
        blur(T, S, start + 1, stop + 1, step);
        blur(T, S, start + 2, stop + 2, step);
        blur(T, S, start + 3, stop + 3, step);
    };
}
// Given a target array T, a source array S, sets each value T[i] to the average
// of {S[i - r], …, S[i], …, S[i + r]}, where r = ⌊radius⌋, start <= i < stop,
// for each i, i + step, i + 2 * step, etc., and where S[j] is clamped between
// S[start] (inclusive) and S[stop] (exclusive). If the given radius is not an
// integer, S[i - r - 1] and S[i + r + 1] are added to the sum, each weighted
// according to r - ⌊radius⌋.
function blurf(radius) {
    const radius0 = Math.floor(radius);
    if (radius0 === radius) return bluri(radius);
    const t = radius - radius0;
    const w = 2 * radius + 1;
    return (T, S, start, stop, step)=>{
        if (!((stop -= step) >= start)) return; // inclusive stop
        let sum = radius0 * S[start];
        const s0 = step * radius0;
        const s1 = s0 + step;
        for(let i = start, j = start + s0; i < j; i += step)sum += S[Math.min(stop, i)];
        for(let i = start, j = stop; i <= j; i += step){
            sum += S[Math.min(stop, i + s0)];
            T[i] = (sum + t * (S[Math.max(start, i - s1)] + S[Math.min(stop, i + s1)])) / w;
            sum -= S[Math.max(start, i - s0)];
        }
    };
}
// Like blurf, but optimized for integer radius.
function bluri(radius) {
    const w = 2 * radius + 1;
    return (T, S, start, stop, step)=>{
        if (!((stop -= step) >= start)) return; // inclusive stop
        let sum = radius * S[start];
        const s = step * radius;
        for(let i = start, j = start + s; i < j; i += step)sum += S[Math.min(stop, i)];
        for(let i = start, j = stop; i <= j; i += step){
            sum += S[Math.min(stop, i + s)];
            T[i] = sum / w;
            sum -= S[Math.max(start, i - s)];
        }
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"bEr1m":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>count);
function count(values, valueof) {
    let count = 0;
    if (valueof === undefined) {
        for (let value of values)if (value != null && (value = +value) >= value) ++count;
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (value = +value) >= value) ++count;
    }
    return count;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"d7fnh":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>cross);
function length(array) {
    return array.length | 0;
}
function empty(length) {
    return !(length > 0);
}
function arrayify(values) {
    return typeof values !== "object" || "length" in values ? values : Array.from(values);
}
function reducer(reduce) {
    return (values)=>reduce(...values);
}
function cross(...values) {
    const reduce = typeof values[values.length - 1] === "function" && reducer(values.pop());
    values = values.map(arrayify);
    const lengths = values.map(length);
    const j = values.length - 1;
    const index = new Array(j + 1).fill(0);
    const product = [];
    if (j < 0 || lengths.some(empty)) return product;
    while(true){
        product.push(index.map((j, i)=>values[i][j]));
        let i = j;
        while(++index[i] === lengths[i]){
            if (i === 0) return reduce ? product.map(reduce) : product;
            index[i--] = 0;
        }
    }
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2Kj7J":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>cumsum);
function cumsum(values, valueof) {
    var sum = 0, index = 0;
    return Float64Array.from(values, valueof === undefined ? (v)=>sum += +v || 0 : (v)=>sum += +valueof(v, index++, values) || 0);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"63ogy":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>deviation);
var _varianceJs = require("./variance.js");
var _varianceJsDefault = parcelHelpers.interopDefault(_varianceJs);
function deviation(values, valueof) {
    const v = (0, _varianceJsDefault.default)(values, valueof);
    return v ? Math.sqrt(v) : v;
}

},{"./variance.js":"4UZOK","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4UZOK":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>variance);
function variance(values, valueof) {
    let count = 0;
    let delta;
    let mean = 0;
    let sum = 0;
    if (valueof === undefined) {
        for (let value of values)if (value != null && (value = +value) >= value) {
            delta = value - mean;
            mean += delta / ++count;
            sum += delta * (value - mean);
        }
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (value = +value) >= value) {
            delta = value - mean;
            mean += delta / ++count;
            sum += delta * (value - mean);
        }
    }
    if (count > 1) return sum / (count - 1);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"kkkz7":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>extent);
function extent(values, valueof) {
    let min;
    let max;
    if (valueof === undefined) {
        for (const value of values)if (value != null) {
            if (min === undefined) {
                if (value >= value) min = max = value;
            } else {
                if (min > value) min = value;
                if (max < value) max = value;
            }
        }
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null) {
            if (min === undefined) {
                if (value >= value) min = max = value;
            } else {
                if (min > value) min = value;
                if (max < value) max = value;
            }
        }
    }
    return [
        min,
        max
    ];
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"5h9sS":[function(require,module,exports) {
// https://github.com/python/cpython/blob/a74eea238f5baba15797e2e8b570d153bc8690a7/Modules/mathmodule.c#L1423
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Adder", ()=>Adder);
parcelHelpers.export(exports, "fsum", ()=>fsum);
parcelHelpers.export(exports, "fcumsum", ()=>fcumsum);
class Adder {
    constructor(){
        this._partials = new Float64Array(32);
        this._n = 0;
    }
    add(x) {
        const p = this._partials;
        let i = 0;
        for(let j = 0; j < this._n && j < 32; j++){
            const y = p[j], hi = x + y, lo = Math.abs(x) < Math.abs(y) ? x - (hi - y) : y - (hi - x);
            if (lo) p[i++] = lo;
            x = hi;
        }
        p[i] = x;
        this._n = i + 1;
        return this;
    }
    valueOf() {
        const p = this._partials;
        let n = this._n, x, y, lo, hi = 0;
        if (n > 0) {
            hi = p[--n];
            while(n > 0){
                x = hi;
                y = p[--n];
                hi = x + y;
                lo = y - (hi - x);
                if (lo) break;
            }
            if (n > 0 && (lo < 0 && p[n - 1] < 0 || lo > 0 && p[n - 1] > 0)) {
                y = lo * 2;
                x = hi + y;
                if (y == x - hi) hi = x;
            }
        }
        return hi;
    }
}
function fsum(values, valueof) {
    const adder = new Adder();
    if (valueof === undefined) {
        for (let value of values)if (value = +value) adder.add(value);
    } else {
        let index = -1;
        for (let value of values)if (value = +valueof(value, ++index, values)) adder.add(value);
    }
    return +adder;
}
function fcumsum(values, valueof) {
    const adder = new Adder();
    let index = -1;
    return Float64Array.from(values, valueof === undefined ? (v)=>adder.add(+v || 0) : (v)=>adder.add(+valueof(v, ++index, values) || 0));
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"dK75Z":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>group);
parcelHelpers.export(exports, "groups", ()=>groups);
parcelHelpers.export(exports, "flatGroup", ()=>flatGroup);
parcelHelpers.export(exports, "flatRollup", ()=>flatRollup);
parcelHelpers.export(exports, "rollup", ()=>rollup);
parcelHelpers.export(exports, "rollups", ()=>rollups);
parcelHelpers.export(exports, "index", ()=>index);
parcelHelpers.export(exports, "indexes", ()=>indexes);
var _internmap = require("internmap");
var _identityJs = require("./identity.js");
var _identityJsDefault = parcelHelpers.interopDefault(_identityJs);
function group(values, ...keys) {
    return nest(values, (0, _identityJsDefault.default), (0, _identityJsDefault.default), keys);
}
function groups(values, ...keys) {
    return nest(values, Array.from, (0, _identityJsDefault.default), keys);
}
function flatten(groups, keys) {
    for(let i = 1, n = keys.length; i < n; ++i)groups = groups.flatMap((g)=>g.pop().map(([key, value])=>[
                ...g,
                key,
                value
            ]));
    return groups;
}
function flatGroup(values, ...keys) {
    return flatten(groups(values, ...keys), keys);
}
function flatRollup(values, reduce, ...keys) {
    return flatten(rollups(values, reduce, ...keys), keys);
}
function rollup(values, reduce, ...keys) {
    return nest(values, (0, _identityJsDefault.default), reduce, keys);
}
function rollups(values, reduce, ...keys) {
    return nest(values, Array.from, reduce, keys);
}
function index(values, ...keys) {
    return nest(values, (0, _identityJsDefault.default), unique, keys);
}
function indexes(values, ...keys) {
    return nest(values, Array.from, unique, keys);
}
function unique(values) {
    if (values.length !== 1) throw new Error("duplicate key");
    return values[0];
}
function nest(values, map, reduce, keys) {
    return function regroup(values, i) {
        if (i >= keys.length) return reduce(values);
        const groups = new (0, _internmap.InternMap)();
        const keyof = keys[i++];
        let index = -1;
        for (const value of values){
            const key = keyof(value, ++index, values);
            const group = groups.get(key);
            if (group) group.push(value);
            else groups.set(key, [
                value
            ]);
        }
        for (const [key, values] of groups)groups.set(key, regroup(values, i));
        return map(groups);
    }(values, 0);
}

},{"internmap":"lN5oE","./identity.js":"fWWSu","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"lN5oE":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "InternMap", ()=>InternMap);
parcelHelpers.export(exports, "InternSet", ()=>InternSet);
class InternMap extends Map {
    constructor(entries, key = keyof){
        super();
        Object.defineProperties(this, {
            _intern: {
                value: new Map()
            },
            _key: {
                value: key
            }
        });
        if (entries != null) for (const [key, value] of entries)this.set(key, value);
    }
    get(key) {
        return super.get(intern_get(this, key));
    }
    has(key) {
        return super.has(intern_get(this, key));
    }
    set(key, value) {
        return super.set(intern_set(this, key), value);
    }
    delete(key) {
        return super.delete(intern_delete(this, key));
    }
}
class InternSet extends Set {
    constructor(values, key = keyof){
        super();
        Object.defineProperties(this, {
            _intern: {
                value: new Map()
            },
            _key: {
                value: key
            }
        });
        if (values != null) for (const value of values)this.add(value);
    }
    has(value) {
        return super.has(intern_get(this, value));
    }
    add(value) {
        return super.add(intern_set(this, value));
    }
    delete(value) {
        return super.delete(intern_delete(this, value));
    }
}
function intern_get({ _intern, _key }, value) {
    const key = _key(value);
    return _intern.has(key) ? _intern.get(key) : value;
}
function intern_set({ _intern, _key }, value) {
    const key = _key(value);
    if (_intern.has(key)) return _intern.get(key);
    _intern.set(key, value);
    return value;
}
function intern_delete({ _intern, _key }, value) {
    const key = _key(value);
    if (_intern.has(key)) {
        value = _intern.get(key);
        _intern.delete(key);
    }
    return value;
}
function keyof(value) {
    return value !== null && typeof value === "object" ? value.valueOf() : value;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"fWWSu":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>identity);
function identity(x) {
    return x;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"bd0HG":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>groupSort);
var _ascendingJs = require("./ascending.js");
var _ascendingJsDefault = parcelHelpers.interopDefault(_ascendingJs);
var _groupJs = require("./group.js");
var _groupJsDefault = parcelHelpers.interopDefault(_groupJs);
var _sortJs = require("./sort.js");
var _sortJsDefault = parcelHelpers.interopDefault(_sortJs);
function groupSort(values, reduce, key) {
    return (reduce.length !== 2 ? (0, _sortJsDefault.default)((0, _groupJs.rollup)(values, reduce, key), ([ak, av], [bk, bv])=>(0, _ascendingJsDefault.default)(av, bv) || (0, _ascendingJsDefault.default)(ak, bk)) : (0, _sortJsDefault.default)((0, _groupJsDefault.default)(values, key), ([ak, av], [bk, bv])=>reduce(av, bv) || (0, _ascendingJsDefault.default)(ak, bk))).map(([key])=>key);
}

},{"./ascending.js":"fxpE9","./group.js":"dK75Z","./sort.js":"hn4qB","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hn4qB":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>sort);
parcelHelpers.export(exports, "compareDefined", ()=>compareDefined);
parcelHelpers.export(exports, "ascendingDefined", ()=>ascendingDefined);
var _ascendingJs = require("./ascending.js");
var _ascendingJsDefault = parcelHelpers.interopDefault(_ascendingJs);
var _permuteJs = require("./permute.js");
var _permuteJsDefault = parcelHelpers.interopDefault(_permuteJs);
function sort(values, ...F) {
    if (typeof values[Symbol.iterator] !== "function") throw new TypeError("values is not iterable");
    values = Array.from(values);
    let [f] = F;
    if (f && f.length !== 2 || F.length > 1) {
        const index = Uint32Array.from(values, (d, i)=>i);
        if (F.length > 1) {
            F = F.map((f)=>values.map(f));
            index.sort((i, j)=>{
                for (const f of F){
                    const c = ascendingDefined(f[i], f[j]);
                    if (c) return c;
                }
            });
        } else {
            f = values.map(f);
            index.sort((i, j)=>ascendingDefined(f[i], f[j]));
        }
        return (0, _permuteJsDefault.default)(values, index);
    }
    return values.sort(compareDefined(f));
}
function compareDefined(compare = (0, _ascendingJsDefault.default)) {
    if (compare === (0, _ascendingJsDefault.default)) return ascendingDefined;
    if (typeof compare !== "function") throw new TypeError("compare is not a function");
    return (a, b)=>{
        const x = compare(a, b);
        if (x || x === 0) return x;
        return (compare(b, b) === 0) - (compare(a, a) === 0);
    };
}
function ascendingDefined(a, b) {
    return (a == null || !(a >= a)) - (b == null || !(b >= b)) || (a < b ? -1 : a > b ? 1 : 0);
}

},{"./ascending.js":"fxpE9","./permute.js":"eLUwT","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"eLUwT":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>permute);
function permute(source, keys) {
    return Array.from(keys, (key)=>source[key]);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"fSCEd":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>bin);
var _arrayJs = require("./array.js");
var _bisectJs = require("./bisect.js");
var _bisectJsDefault = parcelHelpers.interopDefault(_bisectJs);
var _constantJs = require("./constant.js");
var _constantJsDefault = parcelHelpers.interopDefault(_constantJs);
var _extentJs = require("./extent.js");
var _extentJsDefault = parcelHelpers.interopDefault(_extentJs);
var _identityJs = require("./identity.js");
var _identityJsDefault = parcelHelpers.interopDefault(_identityJs);
var _niceJs = require("./nice.js");
var _niceJsDefault = parcelHelpers.interopDefault(_niceJs);
var _ticksJs = require("./ticks.js");
var _ticksJsDefault = parcelHelpers.interopDefault(_ticksJs);
var _sturgesJs = require("./threshold/sturges.js");
var _sturgesJsDefault = parcelHelpers.interopDefault(_sturgesJs);
function bin() {
    var value = (0, _identityJsDefault.default), domain = (0, _extentJsDefault.default), threshold = (0, _sturgesJsDefault.default);
    function histogram(data) {
        if (!Array.isArray(data)) data = Array.from(data);
        var i, n = data.length, x, step, values = new Array(n);
        for(i = 0; i < n; ++i)values[i] = value(data[i], i, data);
        var xz = domain(values), x0 = xz[0], x1 = xz[1], tz = threshold(values, x0, x1);
        // Convert number of thresholds into uniform thresholds, and nice the
        // default domain accordingly.
        if (!Array.isArray(tz)) {
            const max = x1, tn = +tz;
            if (domain === (0, _extentJsDefault.default)) [x0, x1] = (0, _niceJsDefault.default)(x0, x1, tn);
            tz = (0, _ticksJsDefault.default)(x0, x1, tn);
            // If the domain is aligned with the first tick (which it will by
            // default), then we can use quantization rather than bisection to bin
            // values, which is substantially faster.
            if (tz[0] <= x0) step = (0, _ticksJs.tickIncrement)(x0, x1, tn);
            // If the last threshold is coincident with the domain’s upper bound, the
            // last bin will be zero-width. If the default domain is used, and this
            // last threshold is coincident with the maximum input value, we can
            // extend the niced upper bound by one tick to ensure uniform bin widths;
            // otherwise, we simply remove the last threshold. Note that we don’t
            // coerce values or the domain to numbers, and thus must be careful to
            // compare order (>=) rather than strict equality (===)!
            if (tz[tz.length - 1] >= x1) {
                if (max >= x1 && domain === (0, _extentJsDefault.default)) {
                    const step = (0, _ticksJs.tickIncrement)(x0, x1, tn);
                    if (isFinite(step)) {
                        if (step > 0) x1 = (Math.floor(x1 / step) + 1) * step;
                        else if (step < 0) x1 = (Math.ceil(x1 * -step) + 1) / -step;
                    }
                } else tz.pop();
            }
        }
        // Remove any thresholds outside the domain.
        // Be careful not to mutate an array owned by the user!
        var m = tz.length, a = 0, b = m;
        while(tz[a] <= x0)++a;
        while(tz[b - 1] > x1)--b;
        if (a || b < m) tz = tz.slice(a, b), m = b - a;
        var bins = new Array(m + 1), bin;
        // Initialize bins.
        for(i = 0; i <= m; ++i){
            bin = bins[i] = [];
            bin.x0 = i > 0 ? tz[i - 1] : x0;
            bin.x1 = i < m ? tz[i] : x1;
        }
        // Assign data to bins by value, ignoring any outside the domain.
        if (isFinite(step)) {
            if (step > 0) {
                for(i = 0; i < n; ++i)if ((x = values[i]) != null && x0 <= x && x <= x1) bins[Math.min(m, Math.floor((x - x0) / step))].push(data[i]);
            } else if (step < 0) {
                for(i = 0; i < n; ++i)if ((x = values[i]) != null && x0 <= x && x <= x1) {
                    const j = Math.floor((x0 - x) * step);
                    bins[Math.min(m, j + (tz[j] <= x))].push(data[i]); // handle off-by-one due to rounding
                }
            }
        } else {
            for(i = 0; i < n; ++i)if ((x = values[i]) != null && x0 <= x && x <= x1) bins[(0, _bisectJsDefault.default)(tz, x, 0, m)].push(data[i]);
        }
        return bins;
    }
    histogram.value = function(_) {
        return arguments.length ? (value = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(_), histogram) : value;
    };
    histogram.domain = function(_) {
        return arguments.length ? (domain = typeof _ === "function" ? _ : (0, _constantJsDefault.default)([
            _[0],
            _[1]
        ]), histogram) : domain;
    };
    histogram.thresholds = function(_) {
        return arguments.length ? (threshold = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(Array.isArray(_) ? (0, _arrayJs.slice).call(_) : _), histogram) : threshold;
    };
    return histogram;
}

},{"./array.js":"aYFJZ","./bisect.js":"6E3K1","./constant.js":"a2vmN","./extent.js":"kkkz7","./identity.js":"fWWSu","./nice.js":"6opYb","./ticks.js":"hdIWy","./threshold/sturges.js":"5VRgb","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"aYFJZ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "slice", ()=>slice);
parcelHelpers.export(exports, "map", ()=>map);
var array = Array.prototype;
var slice = array.slice;
var map = array.map;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"a2vmN":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>constant);
function constant(x) {
    return ()=>x;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6opYb":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>nice);
var _ticksJs = require("./ticks.js");
function nice(start, stop, count) {
    let prestep;
    while(true){
        const step = (0, _ticksJs.tickIncrement)(start, stop, count);
        if (step === prestep || step === 0 || !isFinite(step)) return [
            start,
            stop
        ];
        else if (step > 0) {
            start = Math.floor(start / step) * step;
            stop = Math.ceil(stop / step) * step;
        } else if (step < 0) {
            start = Math.ceil(start * step) / step;
            stop = Math.floor(stop * step) / step;
        }
        prestep = step;
    }
}

},{"./ticks.js":"hdIWy","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hdIWy":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>ticks);
parcelHelpers.export(exports, "tickIncrement", ()=>tickIncrement);
parcelHelpers.export(exports, "tickStep", ()=>tickStep);
const e10 = Math.sqrt(50), e5 = Math.sqrt(10), e2 = Math.sqrt(2);
function tickSpec(start, stop, count) {
    const step = (stop - start) / Math.max(0, count), power = Math.floor(Math.log10(step)), error = step / Math.pow(10, power), factor = error >= e10 ? 10 : error >= e5 ? 5 : error >= e2 ? 2 : 1;
    let i1, i2, inc;
    if (power < 0) {
        inc = Math.pow(10, -power) / factor;
        i1 = Math.round(start * inc);
        i2 = Math.round(stop * inc);
        if (i1 / inc < start) ++i1;
        if (i2 / inc > stop) --i2;
        inc = -inc;
    } else {
        inc = Math.pow(10, power) * factor;
        i1 = Math.round(start / inc);
        i2 = Math.round(stop / inc);
        if (i1 * inc < start) ++i1;
        if (i2 * inc > stop) --i2;
    }
    if (i2 < i1 && 0.5 <= count && count < 2) return tickSpec(start, stop, count * 2);
    return [
        i1,
        i2,
        inc
    ];
}
function ticks(start, stop, count) {
    stop = +stop, start = +start, count = +count;
    if (!(count > 0)) return [];
    if (start === stop) return [
        start
    ];
    const reverse = stop < start, [i1, i2, inc] = reverse ? tickSpec(stop, start, count) : tickSpec(start, stop, count);
    if (!(i2 >= i1)) return [];
    const n = i2 - i1 + 1, ticks = new Array(n);
    if (reverse) {
        if (inc < 0) for(let i = 0; i < n; ++i)ticks[i] = (i2 - i) / -inc;
        else for(let i = 0; i < n; ++i)ticks[i] = (i2 - i) * inc;
    } else {
        if (inc < 0) for(let i = 0; i < n; ++i)ticks[i] = (i1 + i) / -inc;
        else for(let i = 0; i < n; ++i)ticks[i] = (i1 + i) * inc;
    }
    return ticks;
}
function tickIncrement(start, stop, count) {
    stop = +stop, start = +start, count = +count;
    return tickSpec(start, stop, count)[2];
}
function tickStep(start, stop, count) {
    stop = +stop, start = +start, count = +count;
    const reverse = stop < start, inc = reverse ? tickIncrement(stop, start, count) : tickIncrement(start, stop, count);
    return (reverse ? -1 : 1) * (inc < 0 ? 1 / -inc : inc);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"5VRgb":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>thresholdSturges);
var _countJs = require("../count.js");
var _countJsDefault = parcelHelpers.interopDefault(_countJs);
function thresholdSturges(values) {
    return Math.max(1, Math.ceil(Math.log((0, _countJsDefault.default)(values)) / Math.LN2) + 1);
}

},{"../count.js":"bEr1m","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"ivGXE":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>thresholdFreedmanDiaconis);
var _countJs = require("../count.js");
var _countJsDefault = parcelHelpers.interopDefault(_countJs);
var _quantileJs = require("../quantile.js");
var _quantileJsDefault = parcelHelpers.interopDefault(_quantileJs);
function thresholdFreedmanDiaconis(values, min, max) {
    const c = (0, _countJsDefault.default)(values), d = (0, _quantileJsDefault.default)(values, 0.75) - (0, _quantileJsDefault.default)(values, 0.25);
    return c && d ? Math.ceil((max - min) / (2 * d * Math.pow(c, -1 / 3))) : 1;
}

},{"../count.js":"bEr1m","../quantile.js":"gtsMZ","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"gtsMZ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>quantile);
parcelHelpers.export(exports, "quantileSorted", ()=>quantileSorted);
parcelHelpers.export(exports, "quantileIndex", ()=>quantileIndex);
var _maxJs = require("./max.js");
var _maxJsDefault = parcelHelpers.interopDefault(_maxJs);
var _maxIndexJs = require("./maxIndex.js");
var _maxIndexJsDefault = parcelHelpers.interopDefault(_maxIndexJs);
var _minJs = require("./min.js");
var _minJsDefault = parcelHelpers.interopDefault(_minJs);
var _minIndexJs = require("./minIndex.js");
var _minIndexJsDefault = parcelHelpers.interopDefault(_minIndexJs);
var _quickselectJs = require("./quickselect.js");
var _quickselectJsDefault = parcelHelpers.interopDefault(_quickselectJs);
var _numberJs = require("./number.js");
var _numberJsDefault = parcelHelpers.interopDefault(_numberJs);
var _sortJs = require("./sort.js");
var _greatestJs = require("./greatest.js");
var _greatestJsDefault = parcelHelpers.interopDefault(_greatestJs);
function quantile(values, p, valueof) {
    values = Float64Array.from((0, _numberJs.numbers)(values, valueof));
    if (!(n = values.length) || isNaN(p = +p)) return;
    if (p <= 0 || n < 2) return (0, _minJsDefault.default)(values);
    if (p >= 1) return (0, _maxJsDefault.default)(values);
    var n, i = (n - 1) * p, i0 = Math.floor(i), value0 = (0, _maxJsDefault.default)((0, _quickselectJsDefault.default)(values, i0).subarray(0, i0 + 1)), value1 = (0, _minJsDefault.default)(values.subarray(i0 + 1));
    return value0 + (value1 - value0) * (i - i0);
}
function quantileSorted(values, p, valueof = (0, _numberJsDefault.default)) {
    if (!(n = values.length) || isNaN(p = +p)) return;
    if (p <= 0 || n < 2) return +valueof(values[0], 0, values);
    if (p >= 1) return +valueof(values[n - 1], n - 1, values);
    var n, i = (n - 1) * p, i0 = Math.floor(i), value0 = +valueof(values[i0], i0, values), value1 = +valueof(values[i0 + 1], i0 + 1, values);
    return value0 + (value1 - value0) * (i - i0);
}
function quantileIndex(values, p, valueof = (0, _numberJsDefault.default)) {
    if (isNaN(p = +p)) return;
    numbers = Float64Array.from(values, (_, i)=>(0, _numberJsDefault.default)(valueof(values[i], i, values)));
    if (p <= 0) return (0, _minIndexJsDefault.default)(numbers);
    if (p >= 1) return (0, _maxIndexJsDefault.default)(numbers);
    var numbers, index = Uint32Array.from(values, (_, i)=>i), j = numbers.length - 1, i = Math.floor(j * p);
    (0, _quickselectJsDefault.default)(index, i, 0, j, (i, j)=>(0, _sortJs.ascendingDefined)(numbers[i], numbers[j]));
    i = (0, _greatestJsDefault.default)(index.subarray(0, i + 1), (i)=>numbers[i]);
    return i >= 0 ? i : -1;
}

},{"./max.js":"8VFj7","./maxIndex.js":"9TsNn","./min.js":"aV6tL","./minIndex.js":"4MZIY","./quickselect.js":"bjyfD","./number.js":"cFSaj","./sort.js":"hn4qB","./greatest.js":"ba9H2","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8VFj7":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>max);
function max(values, valueof) {
    let max;
    if (valueof === undefined) {
        for (const value of values)if (value != null && (max < value || max === undefined && value >= value)) max = value;
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (max < value || max === undefined && value >= value)) max = value;
    }
    return max;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9TsNn":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>maxIndex);
function maxIndex(values, valueof) {
    let max;
    let maxIndex = -1;
    let index = -1;
    if (valueof === undefined) for (const value of values){
        ++index;
        if (value != null && (max < value || max === undefined && value >= value)) max = value, maxIndex = index;
    }
    else {
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (max < value || max === undefined && value >= value)) max = value, maxIndex = index;
    }
    return maxIndex;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"aV6tL":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>min);
function min(values, valueof) {
    let min;
    if (valueof === undefined) {
        for (const value of values)if (value != null && (min > value || min === undefined && value >= value)) min = value;
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (min > value || min === undefined && value >= value)) min = value;
    }
    return min;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4MZIY":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>minIndex);
function minIndex(values, valueof) {
    let min;
    let minIndex = -1;
    let index = -1;
    if (valueof === undefined) for (const value of values){
        ++index;
        if (value != null && (min > value || min === undefined && value >= value)) min = value, minIndex = index;
    }
    else {
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (min > value || min === undefined && value >= value)) min = value, minIndex = index;
    }
    return minIndex;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"bjyfD":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>quickselect);
var _sortJs = require("./sort.js");
function quickselect(array, k, left = 0, right = Infinity, compare) {
    k = Math.floor(k);
    left = Math.floor(Math.max(0, left));
    right = Math.floor(Math.min(array.length - 1, right));
    if (!(left <= k && k <= right)) return array;
    compare = compare === undefined ? (0, _sortJs.ascendingDefined) : (0, _sortJs.compareDefined)(compare);
    while(right > left){
        if (right - left > 600) {
            const n = right - left + 1;
            const m = k - left + 1;
            const z = Math.log(n);
            const s = 0.5 * Math.exp(2 * z / 3);
            const sd = 0.5 * Math.sqrt(z * s * (n - s) / n) * (m - n / 2 < 0 ? -1 : 1);
            const newLeft = Math.max(left, Math.floor(k - m * s / n + sd));
            const newRight = Math.min(right, Math.floor(k + (n - m) * s / n + sd));
            quickselect(array, k, newLeft, newRight, compare);
        }
        const t = array[k];
        let i = left;
        let j = right;
        swap(array, left, k);
        if (compare(array[right], t) > 0) swap(array, left, right);
        while(i < j){
            swap(array, i, j), ++i, --j;
            while(compare(array[i], t) < 0)++i;
            while(compare(array[j], t) > 0)--j;
        }
        if (compare(array[left], t) === 0) swap(array, left, j);
        else ++j, swap(array, j, right);
        if (j <= k) left = j + 1;
        if (k <= j) right = j - 1;
    }
    return array;
}
function swap(array, i, j) {
    const t = array[i];
    array[i] = array[j];
    array[j] = t;
}

},{"./sort.js":"hn4qB","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"ba9H2":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>greatest);
var _ascendingJs = require("./ascending.js");
var _ascendingJsDefault = parcelHelpers.interopDefault(_ascendingJs);
function greatest(values, compare = (0, _ascendingJsDefault.default)) {
    let max;
    let defined = false;
    if (compare.length === 1) {
        let maxValue;
        for (const element of values){
            const value = compare(element);
            if (defined ? (0, _ascendingJsDefault.default)(value, maxValue) > 0 : (0, _ascendingJsDefault.default)(value, value) === 0) {
                max = element;
                maxValue = value;
                defined = true;
            }
        }
    } else {
        for (const value of values)if (defined ? compare(value, max) > 0 : compare(value, value) === 0) {
            max = value;
            defined = true;
        }
    }
    return max;
}

},{"./ascending.js":"fxpE9","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7aFxa":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>thresholdScott);
var _countJs = require("../count.js");
var _countJsDefault = parcelHelpers.interopDefault(_countJs);
var _deviationJs = require("../deviation.js");
var _deviationJsDefault = parcelHelpers.interopDefault(_deviationJs);
function thresholdScott(values, min, max) {
    const c = (0, _countJsDefault.default)(values), d = (0, _deviationJsDefault.default)(values);
    return c && d ? Math.ceil((max - min) * Math.cbrt(c) / (3.49 * d)) : 1;
}

},{"../count.js":"bEr1m","../deviation.js":"63ogy","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"lGLmc":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>mean);
function mean(values, valueof) {
    let count = 0;
    let sum = 0;
    if (valueof === undefined) {
        for (let value of values)if (value != null && (value = +value) >= value) ++count, sum += value;
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (value = +value) >= value) ++count, sum += value;
    }
    if (count) return sum / count;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4CtA1":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>median);
parcelHelpers.export(exports, "medianIndex", ()=>medianIndex);
var _quantileJs = require("./quantile.js");
var _quantileJsDefault = parcelHelpers.interopDefault(_quantileJs);
function median(values, valueof) {
    return (0, _quantileJsDefault.default)(values, 0.5, valueof);
}
function medianIndex(values, valueof) {
    return (0, _quantileJs.quantileIndex)(values, 0.5, valueof);
}

},{"./quantile.js":"gtsMZ","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"fZD2z":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>merge);
function* flatten(arrays) {
    for (const array of arrays)yield* array;
}
function merge(arrays) {
    return Array.from(flatten(arrays));
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"49bDg":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>mode);
var _internmap = require("internmap");
function mode(values, valueof) {
    const counts = new (0, _internmap.InternMap)();
    if (valueof === undefined) {
        for (let value of values)if (value != null && value >= value) counts.set(value, (counts.get(value) || 0) + 1);
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && value >= value) counts.set(value, (counts.get(value) || 0) + 1);
    }
    let modeValue;
    let modeCount = 0;
    for (const [value, count] of counts)if (count > modeCount) {
        modeCount = count;
        modeValue = value;
    }
    return modeValue;
}

},{"internmap":"lN5oE","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3GyTU":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>pairs);
parcelHelpers.export(exports, "pair", ()=>pair);
function pairs(values, pairof = pair) {
    const pairs = [];
    let previous;
    let first = false;
    for (const value of values){
        if (first) pairs.push(pairof(previous, value));
        previous = value;
        first = true;
    }
    return pairs;
}
function pair(a, b) {
    return [
        a,
        b
    ];
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"egnZn":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>range);
function range(start, stop, step) {
    start = +start, stop = +stop, step = (n = arguments.length) < 2 ? (stop = start, start = 0, 1) : n < 3 ? 1 : +step;
    var i = -1, n = Math.max(0, Math.ceil((stop - start) / step)) | 0, range = new Array(n);
    while(++i < n)range[i] = start + i * step;
    return range;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2fUwM":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>rank);
var _ascendingJs = require("./ascending.js");
var _ascendingJsDefault = parcelHelpers.interopDefault(_ascendingJs);
var _sortJs = require("./sort.js");
function rank(values, valueof = (0, _ascendingJsDefault.default)) {
    if (typeof values[Symbol.iterator] !== "function") throw new TypeError("values is not iterable");
    let V = Array.from(values);
    const R = new Float64Array(V.length);
    if (valueof.length !== 2) V = V.map(valueof), valueof = (0, _ascendingJsDefault.default);
    const compareIndex = (i, j)=>valueof(V[i], V[j]);
    let k, r;
    values = Uint32Array.from(V, (_, i)=>i);
    // Risky chaining due to Safari 14 https://github.com/d3/d3-array/issues/123
    values.sort(valueof === (0, _ascendingJsDefault.default) ? (i, j)=>(0, _sortJs.ascendingDefined)(V[i], V[j]) : (0, _sortJs.compareDefined)(compareIndex));
    values.forEach((j, i)=>{
        const c = compareIndex(j, k === undefined ? j : k);
        if (c >= 0) {
            if (k === undefined || c > 0) k = j, r = i;
            R[j] = r;
        } else R[j] = NaN;
    });
    return R;
}

},{"./ascending.js":"fxpE9","./sort.js":"hn4qB","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"g2WOH":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>least);
var _ascendingJs = require("./ascending.js");
var _ascendingJsDefault = parcelHelpers.interopDefault(_ascendingJs);
function least(values, compare = (0, _ascendingJsDefault.default)) {
    let min;
    let defined = false;
    if (compare.length === 1) {
        let minValue;
        for (const element of values){
            const value = compare(element);
            if (defined ? (0, _ascendingJsDefault.default)(value, minValue) < 0 : (0, _ascendingJsDefault.default)(value, value) === 0) {
                min = element;
                minValue = value;
                defined = true;
            }
        }
    } else {
        for (const value of values)if (defined ? compare(value, min) < 0 : compare(value, value) === 0) {
            min = value;
            defined = true;
        }
    }
    return min;
}

},{"./ascending.js":"fxpE9","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"cdgca":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>leastIndex);
var _ascendingJs = require("./ascending.js");
var _ascendingJsDefault = parcelHelpers.interopDefault(_ascendingJs);
var _minIndexJs = require("./minIndex.js");
var _minIndexJsDefault = parcelHelpers.interopDefault(_minIndexJs);
function leastIndex(values, compare = (0, _ascendingJsDefault.default)) {
    if (compare.length === 1) return (0, _minIndexJsDefault.default)(values, compare);
    let minValue;
    let min = -1;
    let index = -1;
    for (const value of values){
        ++index;
        if (min < 0 ? compare(value, value) === 0 : compare(value, minValue) < 0) {
            minValue = value;
            min = index;
        }
    }
    return min;
}

},{"./ascending.js":"fxpE9","./minIndex.js":"4MZIY","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6pWs0":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>greatestIndex);
var _ascendingJs = require("./ascending.js");
var _ascendingJsDefault = parcelHelpers.interopDefault(_ascendingJs);
var _maxIndexJs = require("./maxIndex.js");
var _maxIndexJsDefault = parcelHelpers.interopDefault(_maxIndexJs);
function greatestIndex(values, compare = (0, _ascendingJsDefault.default)) {
    if (compare.length === 1) return (0, _maxIndexJsDefault.default)(values, compare);
    let maxValue;
    let max = -1;
    let index = -1;
    for (const value of values){
        ++index;
        if (max < 0 ? compare(value, value) === 0 : compare(value, maxValue) > 0) {
            maxValue = value;
            max = index;
        }
    }
    return max;
}

},{"./ascending.js":"fxpE9","./maxIndex.js":"9TsNn","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3j2zL":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>scan);
var _leastIndexJs = require("./leastIndex.js");
var _leastIndexJsDefault = parcelHelpers.interopDefault(_leastIndexJs);
function scan(values, compare) {
    const index = (0, _leastIndexJsDefault.default)(values, compare);
    return index < 0 ? undefined : index;
}

},{"./leastIndex.js":"cdgca","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"gHM4C":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "shuffler", ()=>shuffler);
exports.default = shuffler(Math.random);
function shuffler(random) {
    return function shuffle(array, i0 = 0, i1 = array.length) {
        let m = i1 - (i0 = +i0);
        while(m){
            const i = random() * m-- | 0, t = array[m + i0];
            array[m + i0] = array[i + i0];
            array[i + i0] = t;
        }
        return array;
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7UDGD":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>sum);
function sum(values, valueof) {
    let sum = 0;
    if (valueof === undefined) {
        for (let value of values)if (value = +value) sum += value;
    } else {
        let index = -1;
        for (let value of values)if (value = +valueof(value, ++index, values)) sum += value;
    }
    return sum;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"f6Iqo":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>transpose);
var _minJs = require("./min.js");
var _minJsDefault = parcelHelpers.interopDefault(_minJs);
function transpose(matrix) {
    if (!(n = matrix.length)) return [];
    for(var i = -1, m = (0, _minJsDefault.default)(matrix, length), transpose = new Array(m); ++i < m;)for(var j = -1, n, row = transpose[i] = new Array(n); ++j < n;)row[j] = matrix[j][i];
    return transpose;
}
function length(d) {
    return d.length;
}

},{"./min.js":"aV6tL","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"GnVPt":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>zip);
var _transposeJs = require("./transpose.js");
var _transposeJsDefault = parcelHelpers.interopDefault(_transposeJs);
function zip() {
    return (0, _transposeJsDefault.default)(arguments);
}

},{"./transpose.js":"f6Iqo","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"iMs3v":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>every);
function every(values, test) {
    if (typeof test !== "function") throw new TypeError("test is not a function");
    let index = -1;
    for (const value of values){
        if (!test(value, ++index, values)) return false;
    }
    return true;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2SKDc":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>some);
function some(values, test) {
    if (typeof test !== "function") throw new TypeError("test is not a function");
    let index = -1;
    for (const value of values){
        if (test(value, ++index, values)) return true;
    }
    return false;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"lew24":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>filter);
function filter(values, test) {
    if (typeof test !== "function") throw new TypeError("test is not a function");
    const array = [];
    let index = -1;
    for (const value of values)if (test(value, ++index, values)) array.push(value);
    return array;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6QMxP":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>map);
function map(values, mapper) {
    if (typeof values[Symbol.iterator] !== "function") throw new TypeError("values is not iterable");
    if (typeof mapper !== "function") throw new TypeError("mapper is not a function");
    return Array.from(values, (value, index)=>mapper(value, index, values));
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"fO6yJ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>reduce);
function reduce(values, reducer, value) {
    if (typeof reducer !== "function") throw new TypeError("reducer is not a function");
    const iterator = values[Symbol.iterator]();
    let done, next, index = -1;
    if (arguments.length < 3) {
        ({ done, value } = iterator.next());
        if (done) return;
        ++index;
    }
    while({ done, value: next } = iterator.next(), !done)value = reducer(value, next, ++index, values);
    return value;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6VYWf":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>reverse);
function reverse(values) {
    if (typeof values[Symbol.iterator] !== "function") throw new TypeError("values is not iterable");
    return Array.from(values).reverse();
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"CzXyM":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>difference);
var _internmap = require("internmap");
function difference(values, ...others) {
    values = new (0, _internmap.InternSet)(values);
    for (const other of others)for (const value of other)values.delete(value);
    return values;
}

},{"internmap":"lN5oE","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jsBdg":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>disjoint);
var _internmap = require("internmap");
function disjoint(values, other) {
    const iterator = other[Symbol.iterator](), set = new (0, _internmap.InternSet)();
    for (const v of values){
        if (set.has(v)) return false;
        let value, done;
        while({ value, done } = iterator.next()){
            if (done) break;
            if (Object.is(v, value)) return false;
            set.add(value);
        }
    }
    return true;
}

},{"internmap":"lN5oE","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"XLnB1":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>intersection);
var _internmap = require("internmap");
function intersection(values, ...others) {
    values = new (0, _internmap.InternSet)(values);
    others = others.map(set);
    out: for (const value of values){
        for (const other of others)if (!other.has(value)) {
            values.delete(value);
            continue out;
        }
    }
    return values;
}
function set(values) {
    return values instanceof (0, _internmap.InternSet) ? values : new (0, _internmap.InternSet)(values);
}

},{"internmap":"lN5oE","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"5pv38":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>subset);
var _supersetJs = require("./superset.js");
var _supersetJsDefault = parcelHelpers.interopDefault(_supersetJs);
function subset(values, other) {
    return (0, _supersetJsDefault.default)(other, values);
}

},{"./superset.js":"dQOGc","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"dQOGc":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>superset);
function superset(values, other) {
    const iterator = values[Symbol.iterator](), set = new Set();
    for (const o of other){
        const io = intern(o);
        if (set.has(io)) continue;
        let value, done;
        while({ value, done } = iterator.next()){
            if (done) return false;
            const ivalue = intern(value);
            set.add(ivalue);
            if (Object.is(io, ivalue)) break;
        }
    }
    return true;
}
function intern(value) {
    return value !== null && typeof value === "object" ? value.valueOf() : value;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"bPXjL":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>union);
var _internmap = require("internmap");
function union(...others) {
    const set = new (0, _internmap.InternSet)();
    for (const other of others)for (const o of other)set.add(o);
    return set;
}

},{"internmap":"lN5oE","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"MGGB7":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "initRange", ()=>initRange);
parcelHelpers.export(exports, "initInterpolator", ()=>initInterpolator);
function initRange(domain, range) {
    switch(arguments.length){
        case 0:
            break;
        case 1:
            this.range(domain);
            break;
        default:
            this.range(range).domain(domain);
            break;
    }
    return this;
}
function initInterpolator(domain, interpolator) {
    switch(arguments.length){
        case 0:
            break;
        case 1:
            if (typeof domain === "function") this.interpolator(domain);
            else this.range(domain);
            break;
        default:
            this.domain(domain);
            if (typeof interpolator === "function") this.interpolator(interpolator);
            else this.range(interpolator);
            break;
    }
    return this;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9md62":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "implicit", ()=>implicit);
parcelHelpers.export(exports, "default", ()=>ordinal);
var _d3Array = require("d3-array");
var _initJs = require("./init.js");
const implicit = Symbol("implicit");
function ordinal() {
    var index = new (0, _d3Array.InternMap)(), domain = [], range = [], unknown = implicit;
    function scale(d) {
        let i = index.get(d);
        if (i === undefined) {
            if (unknown !== implicit) return unknown;
            index.set(d, i = domain.push(d) - 1);
        }
        return range[i % range.length];
    }
    scale.domain = function(_) {
        if (!arguments.length) return domain.slice();
        domain = [], index = new (0, _d3Array.InternMap)();
        for (const value of _){
            if (index.has(value)) continue;
            index.set(value, domain.push(value) - 1);
        }
        return scale;
    };
    scale.range = function(_) {
        return arguments.length ? (range = Array.from(_), scale) : range.slice();
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    scale.copy = function() {
        return ordinal(domain, range).unknown(unknown);
    };
    (0, _initJs.initRange).apply(scale, arguments);
    return scale;
}

},{"d3-array":"bmqp6","./init.js":"MGGB7","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"5y58A":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "linearish", ()=>linearish);
parcelHelpers.export(exports, "default", ()=>linear);
var _d3Array = require("d3-array");
var _continuousJs = require("./continuous.js");
var _continuousJsDefault = parcelHelpers.interopDefault(_continuousJs);
var _initJs = require("./init.js");
var _tickFormatJs = require("./tickFormat.js");
var _tickFormatJsDefault = parcelHelpers.interopDefault(_tickFormatJs);
function linearish(scale) {
    var domain = scale.domain;
    scale.ticks = function(count) {
        var d = domain();
        return (0, _d3Array.ticks)(d[0], d[d.length - 1], count == null ? 10 : count);
    };
    scale.tickFormat = function(count, specifier) {
        var d = domain();
        return (0, _tickFormatJsDefault.default)(d[0], d[d.length - 1], count == null ? 10 : count, specifier);
    };
    scale.nice = function(count) {
        if (count == null) count = 10;
        var d = domain();
        var i0 = 0;
        var i1 = d.length - 1;
        var start = d[i0];
        var stop = d[i1];
        var prestep;
        var step;
        var maxIter = 10;
        if (stop < start) {
            step = start, start = stop, stop = step;
            step = i0, i0 = i1, i1 = step;
        }
        while(maxIter-- > 0){
            step = (0, _d3Array.tickIncrement)(start, stop, count);
            if (step === prestep) {
                d[i0] = start;
                d[i1] = stop;
                return domain(d);
            } else if (step > 0) {
                start = Math.floor(start / step) * step;
                stop = Math.ceil(stop / step) * step;
            } else if (step < 0) {
                start = Math.ceil(start * step) / step;
                stop = Math.floor(stop * step) / step;
            } else break;
            prestep = step;
        }
        return scale;
    };
    return scale;
}
function linear() {
    var scale = (0, _continuousJsDefault.default)();
    scale.copy = function() {
        return (0, _continuousJs.copy)(scale, linear());
    };
    (0, _initJs.initRange).apply(scale, arguments);
    return linearish(scale);
}

},{"d3-array":"bmqp6","./continuous.js":"kDIa7","./init.js":"MGGB7","./tickFormat.js":"bMo77","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"kDIa7":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "identity", ()=>identity);
parcelHelpers.export(exports, "copy", ()=>copy);
parcelHelpers.export(exports, "transformer", ()=>transformer);
parcelHelpers.export(exports, "default", ()=>continuous);
var _d3Array = require("d3-array");
var _d3Interpolate = require("d3-interpolate");
var _constantJs = require("./constant.js");
var _constantJsDefault = parcelHelpers.interopDefault(_constantJs);
var _numberJs = require("./number.js");
var _numberJsDefault = parcelHelpers.interopDefault(_numberJs);
var unit = [
    0,
    1
];
function identity(x) {
    return x;
}
function normalize(a, b) {
    return (b -= a = +a) ? function(x) {
        return (x - a) / b;
    } : (0, _constantJsDefault.default)(isNaN(b) ? NaN : 0.5);
}
function clamper(a, b) {
    var t;
    if (a > b) t = a, a = b, b = t;
    return function(x) {
        return Math.max(a, Math.min(b, x));
    };
}
// normalize(a, b)(x) takes a domain value x in [a,b] and returns the corresponding parameter t in [0,1].
// interpolate(a, b)(t) takes a parameter t in [0,1] and returns the corresponding range value x in [a,b].
function bimap(domain, range, interpolate) {
    var d0 = domain[0], d1 = domain[1], r0 = range[0], r1 = range[1];
    if (d1 < d0) d0 = normalize(d1, d0), r0 = interpolate(r1, r0);
    else d0 = normalize(d0, d1), r0 = interpolate(r0, r1);
    return function(x) {
        return r0(d0(x));
    };
}
function polymap(domain, range, interpolate) {
    var j = Math.min(domain.length, range.length) - 1, d = new Array(j), r = new Array(j), i = -1;
    // Reverse descending domains.
    if (domain[j] < domain[0]) {
        domain = domain.slice().reverse();
        range = range.slice().reverse();
    }
    while(++i < j){
        d[i] = normalize(domain[i], domain[i + 1]);
        r[i] = interpolate(range[i], range[i + 1]);
    }
    return function(x) {
        var i = (0, _d3Array.bisect)(domain, x, 1, j) - 1;
        return r[i](d[i](x));
    };
}
function copy(source, target) {
    return target.domain(source.domain()).range(source.range()).interpolate(source.interpolate()).clamp(source.clamp()).unknown(source.unknown());
}
function transformer() {
    var domain = unit, range = unit, interpolate = (0, _d3Interpolate.interpolate), transform, untransform, unknown, clamp = identity, piecewise, output, input;
    function rescale() {
        var n = Math.min(domain.length, range.length);
        if (clamp !== identity) clamp = clamper(domain[0], domain[n - 1]);
        piecewise = n > 2 ? polymap : bimap;
        output = input = null;
        return scale;
    }
    function scale(x) {
        return x == null || isNaN(x = +x) ? unknown : (output || (output = piecewise(domain.map(transform), range, interpolate)))(transform(clamp(x)));
    }
    scale.invert = function(y) {
        return clamp(untransform((input || (input = piecewise(range, domain.map(transform), (0, _d3Interpolate.interpolateNumber))))(y)));
    };
    scale.domain = function(_) {
        return arguments.length ? (domain = Array.from(_, (0, _numberJsDefault.default)), rescale()) : domain.slice();
    };
    scale.range = function(_) {
        return arguments.length ? (range = Array.from(_), rescale()) : range.slice();
    };
    scale.rangeRound = function(_) {
        return range = Array.from(_), interpolate = (0, _d3Interpolate.interpolateRound), rescale();
    };
    scale.clamp = function(_) {
        return arguments.length ? (clamp = _ ? true : identity, rescale()) : clamp !== identity;
    };
    scale.interpolate = function(_) {
        return arguments.length ? (interpolate = _, rescale()) : interpolate;
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    return function(t, u) {
        transform = t, untransform = u;
        return rescale();
    };
}
function continuous() {
    return transformer()(identity, identity);
}

},{"d3-array":"bmqp6","d3-interpolate":"6bUMz","./constant.js":"85Vbj","./number.js":"h8aXB","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"85Vbj":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>constants);
function constants(x) {
    return function() {
        return x;
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"h8aXB":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>number);
function number(x) {
    return +x;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"bMo77":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>tickFormat);
var _d3Array = require("d3-array");
var _d3Format = require("d3-format");
function tickFormat(start, stop, count, specifier) {
    var step = (0, _d3Array.tickStep)(start, stop, count), precision;
    specifier = (0, _d3Format.formatSpecifier)(specifier == null ? ",f" : specifier);
    switch(specifier.type){
        case "s":
            var value = Math.max(Math.abs(start), Math.abs(stop));
            if (specifier.precision == null && !isNaN(precision = (0, _d3Format.precisionPrefix)(step, value))) specifier.precision = precision;
            return (0, _d3Format.formatPrefix)(specifier, value);
        case "":
        case "e":
        case "g":
        case "p":
        case "r":
            if (specifier.precision == null && !isNaN(precision = (0, _d3Format.precisionRound)(step, Math.max(Math.abs(start), Math.abs(stop))))) specifier.precision = precision - (specifier.type === "e");
            break;
        case "f":
        case "%":
            if (specifier.precision == null && !isNaN(precision = (0, _d3Format.precisionFixed)(step))) specifier.precision = precision - (specifier.type === "%") * 2;
            break;
    }
    return (0, _d3Format.format)(specifier);
}

},{"d3-array":"bmqp6","d3-format":"bpsrv","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"bpsrv":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "formatDefaultLocale", ()=>(0, _defaultLocaleJsDefault.default));
parcelHelpers.export(exports, "format", ()=>(0, _defaultLocaleJs.format));
parcelHelpers.export(exports, "formatPrefix", ()=>(0, _defaultLocaleJs.formatPrefix));
parcelHelpers.export(exports, "formatLocale", ()=>(0, _localeJsDefault.default));
parcelHelpers.export(exports, "formatSpecifier", ()=>(0, _formatSpecifierJsDefault.default));
parcelHelpers.export(exports, "FormatSpecifier", ()=>(0, _formatSpecifierJs.FormatSpecifier));
parcelHelpers.export(exports, "precisionFixed", ()=>(0, _precisionFixedJsDefault.default));
parcelHelpers.export(exports, "precisionPrefix", ()=>(0, _precisionPrefixJsDefault.default));
parcelHelpers.export(exports, "precisionRound", ()=>(0, _precisionRoundJsDefault.default));
var _defaultLocaleJs = require("./defaultLocale.js");
var _defaultLocaleJsDefault = parcelHelpers.interopDefault(_defaultLocaleJs);
var _localeJs = require("./locale.js");
var _localeJsDefault = parcelHelpers.interopDefault(_localeJs);
var _formatSpecifierJs = require("./formatSpecifier.js");
var _formatSpecifierJsDefault = parcelHelpers.interopDefault(_formatSpecifierJs);
var _precisionFixedJs = require("./precisionFixed.js");
var _precisionFixedJsDefault = parcelHelpers.interopDefault(_precisionFixedJs);
var _precisionPrefixJs = require("./precisionPrefix.js");
var _precisionPrefixJsDefault = parcelHelpers.interopDefault(_precisionPrefixJs);
var _precisionRoundJs = require("./precisionRound.js");
var _precisionRoundJsDefault = parcelHelpers.interopDefault(_precisionRoundJs);

},{"./defaultLocale.js":"1PDW2","./locale.js":false,"./formatSpecifier.js":"h2qMJ","./precisionFixed.js":"bBVpf","./precisionPrefix.js":"fZb92","./precisionRound.js":"6KkXg","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1PDW2":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "format", ()=>format);
parcelHelpers.export(exports, "formatPrefix", ()=>formatPrefix);
parcelHelpers.export(exports, "default", ()=>defaultLocale);
var _localeJs = require("./locale.js");
var _localeJsDefault = parcelHelpers.interopDefault(_localeJs);
var locale;
var format;
var formatPrefix;
defaultLocale({
    decimal: ".",
    thousands: ",",
    grouping: [
        3
    ],
    currency: [
        "$",
        ""
    ],
    minus: "-"
});
function defaultLocale(definition) {
    locale = (0, _localeJsDefault.default)(definition);
    format = locale.format;
    formatPrefix = locale.formatPrefix;
    return locale;
}

},{"./locale.js":"jXvmo","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jXvmo":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(locale) {
        var group = locale.grouping === undefined || locale.thousands === undefined ? (0, _identityJsDefault.default) : (0, _formatGroupJsDefault.default)(map.call(locale.grouping, Number), locale.thousands + ""), currencyPrefix = locale.currency === undefined ? "" : locale.currency[0] + "", currencySuffix = locale.currency === undefined ? "" : locale.currency[1] + "", decimal = locale.decimal === undefined ? "." : locale.decimal + "", numerals = locale.numerals === undefined ? (0, _identityJsDefault.default) : (0, _formatNumeralsJsDefault.default)(map.call(locale.numerals, String)), percent = locale.percent === undefined ? "%" : locale.percent + "", minus = locale.minus === undefined ? "-" : locale.minus + "", nan = locale.nan === undefined ? "NaN" : locale.nan + "";
        function newFormat(specifier) {
            specifier = (0, _formatSpecifierJsDefault.default)(specifier);
            var fill = specifier.fill, align = specifier.align, sign = specifier.sign, symbol = specifier.symbol, zero = specifier.zero, width = specifier.width, comma = specifier.comma, precision = specifier.precision, trim = specifier.trim, type = specifier.type;
            // The "n" type is an alias for ",g".
            if (type === "n") comma = true, type = "g";
            else if (!(0, _formatTypesJsDefault.default)[type]) precision === undefined && (precision = 12), trim = true, type = "g";
            // If zero fill is specified, padding goes after sign and before digits.
            if (zero || fill === "0" && align === "=") zero = true, fill = "0", align = "=";
            // Compute the prefix and suffix.
            // For SI-prefix, the suffix is lazily computed.
            var prefix = symbol === "$" ? currencyPrefix : symbol === "#" && /[boxX]/.test(type) ? "0" + type.toLowerCase() : "", suffix = symbol === "$" ? currencySuffix : /[%p]/.test(type) ? percent : "";
            // What format function should we use?
            // Is this an integer type?
            // Can this type generate exponential notation?
            var formatType = (0, _formatTypesJsDefault.default)[type], maybeSuffix = /[defgprs%]/.test(type);
            // Set the default precision if not specified,
            // or clamp the specified precision to the supported range.
            // For significant precision, it must be in [1, 21].
            // For fixed precision, it must be in [0, 20].
            precision = precision === undefined ? 6 : /[gprs]/.test(type) ? Math.max(1, Math.min(21, precision)) : Math.max(0, Math.min(20, precision));
            function format(value) {
                var valuePrefix = prefix, valueSuffix = suffix, i, n, c;
                if (type === "c") {
                    valueSuffix = formatType(value) + valueSuffix;
                    value = "";
                } else {
                    value = +value;
                    // Determine the sign. -0 is not less than 0, but 1 / -0 is!
                    var valueNegative = value < 0 || 1 / value < 0;
                    // Perform the initial formatting.
                    value = isNaN(value) ? nan : formatType(Math.abs(value), precision);
                    // Trim insignificant zeros.
                    if (trim) value = (0, _formatTrimJsDefault.default)(value);
                    // If a negative value rounds to zero after formatting, and no explicit positive sign is requested, hide the sign.
                    if (valueNegative && +value === 0 && sign !== "+") valueNegative = false;
                    // Compute the prefix and suffix.
                    valuePrefix = (valueNegative ? sign === "(" ? sign : minus : sign === "-" || sign === "(" ? "" : sign) + valuePrefix;
                    valueSuffix = (type === "s" ? prefixes[8 + (0, _formatPrefixAutoJs.prefixExponent) / 3] : "") + valueSuffix + (valueNegative && sign === "(" ? ")" : "");
                    // Break the formatted value into the integer “value” part that can be
                    // grouped, and fractional or exponential “suffix” part that is not.
                    if (maybeSuffix) {
                        i = -1, n = value.length;
                        while(++i < n)if (c = value.charCodeAt(i), 48 > c || c > 57) {
                            valueSuffix = (c === 46 ? decimal + value.slice(i + 1) : value.slice(i)) + valueSuffix;
                            value = value.slice(0, i);
                            break;
                        }
                    }
                }
                // If the fill character is not "0", grouping is applied before padding.
                if (comma && !zero) value = group(value, Infinity);
                // Compute the padding.
                var length = valuePrefix.length + value.length + valueSuffix.length, padding = length < width ? new Array(width - length + 1).join(fill) : "";
                // If the fill character is "0", grouping is applied after padding.
                if (comma && zero) value = group(padding + value, padding.length ? width - valueSuffix.length : Infinity), padding = "";
                // Reconstruct the final output based on the desired alignment.
                switch(align){
                    case "<":
                        value = valuePrefix + value + valueSuffix + padding;
                        break;
                    case "=":
                        value = valuePrefix + padding + value + valueSuffix;
                        break;
                    case "^":
                        value = padding.slice(0, length = padding.length >> 1) + valuePrefix + value + valueSuffix + padding.slice(length);
                        break;
                    default:
                        value = padding + valuePrefix + value + valueSuffix;
                        break;
                }
                return numerals(value);
            }
            format.toString = function() {
                return specifier + "";
            };
            return format;
        }
        function formatPrefix(specifier, value) {
            var f = newFormat((specifier = (0, _formatSpecifierJsDefault.default)(specifier), specifier.type = "f", specifier)), e = Math.max(-8, Math.min(8, Math.floor((0, _exponentJsDefault.default)(value) / 3))) * 3, k = Math.pow(10, -e), prefix = prefixes[8 + e / 3];
            return function(value) {
                return f(k * value) + prefix;
            };
        }
        return {
            format: newFormat,
            formatPrefix: formatPrefix
        };
    });
var _exponentJs = require("./exponent.js");
var _exponentJsDefault = parcelHelpers.interopDefault(_exponentJs);
var _formatGroupJs = require("./formatGroup.js");
var _formatGroupJsDefault = parcelHelpers.interopDefault(_formatGroupJs);
var _formatNumeralsJs = require("./formatNumerals.js");
var _formatNumeralsJsDefault = parcelHelpers.interopDefault(_formatNumeralsJs);
var _formatSpecifierJs = require("./formatSpecifier.js");
var _formatSpecifierJsDefault = parcelHelpers.interopDefault(_formatSpecifierJs);
var _formatTrimJs = require("./formatTrim.js");
var _formatTrimJsDefault = parcelHelpers.interopDefault(_formatTrimJs);
var _formatTypesJs = require("./formatTypes.js");
var _formatTypesJsDefault = parcelHelpers.interopDefault(_formatTypesJs);
var _formatPrefixAutoJs = require("./formatPrefixAuto.js");
var _identityJs = require("./identity.js");
var _identityJsDefault = parcelHelpers.interopDefault(_identityJs);
var map = Array.prototype.map, prefixes = [
    "y",
    "z",
    "a",
    "f",
    "p",
    "n",
    "\xb5",
    "m",
    "",
    "k",
    "M",
    "G",
    "T",
    "P",
    "E",
    "Z",
    "Y"
];

},{"./exponent.js":"iZKDx","./formatGroup.js":"8qiip","./formatNumerals.js":"7dxnh","./formatSpecifier.js":"h2qMJ","./formatTrim.js":"cfmz5","./formatTypes.js":"jV6Fn","./formatPrefixAuto.js":"hO2bO","./identity.js":"7vC28","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"iZKDx":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(x) {
        return x = (0, _formatDecimalJs.formatDecimalParts)(Math.abs(x)), x ? x[1] : NaN;
    });
var _formatDecimalJs = require("./formatDecimal.js");

},{"./formatDecimal.js":"fFGcX","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"fFGcX":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(x) {
        return Math.abs(x = Math.round(x)) >= 1e21 ? x.toLocaleString("en").replace(/,/g, "") : x.toString(10);
    });
// Computes the decimal coefficient and exponent of the specified number x with
// significant digits p, where x is positive and p is in [1, 21] or undefined.
// For example, formatDecimalParts(1.23) returns ["123", 0].
parcelHelpers.export(exports, "formatDecimalParts", ()=>formatDecimalParts);
function formatDecimalParts(x, p) {
    if ((i = (x = p ? x.toExponential(p - 1) : x.toExponential()).indexOf("e")) < 0) return null; // NaN, ±Infinity
    var i, coefficient = x.slice(0, i);
    // The string returned by toExponential either has the form \d\.\d+e[-+]\d+
    // (e.g., 1.2e+3) or the form \de[-+]\d+ (e.g., 1e+3).
    return [
        coefficient.length > 1 ? coefficient[0] + coefficient.slice(2) : coefficient,
        +x.slice(i + 1)
    ];
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8qiip":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(grouping, thousands) {
        return function(value, width) {
            var i = value.length, t = [], j = 0, g = grouping[0], length = 0;
            while(i > 0 && g > 0){
                if (length + g + 1 > width) g = Math.max(1, width - length);
                t.push(value.substring(i -= g, i + g));
                if ((length += g + 1) > width) break;
                g = grouping[j = (j + 1) % grouping.length];
            }
            return t.reverse().join(thousands);
        };
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7dxnh":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(numerals) {
        return function(value) {
            return value.replace(/[0-9]/g, function(i) {
                return numerals[+i];
            });
        };
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"h2qMJ":[function(require,module,exports) {
// [[fill]align][sign][symbol][0][width][,][.precision][~][type]
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>formatSpecifier);
parcelHelpers.export(exports, "FormatSpecifier", ()=>FormatSpecifier);
var re = /^(?:(.)?([<>=^]))?([+\-( ])?([$#])?(0)?(\d+)?(,)?(\.\d+)?(~)?([a-z%])?$/i;
function formatSpecifier(specifier) {
    if (!(match = re.exec(specifier))) throw new Error("invalid format: " + specifier);
    var match;
    return new FormatSpecifier({
        fill: match[1],
        align: match[2],
        sign: match[3],
        symbol: match[4],
        zero: match[5],
        width: match[6],
        comma: match[7],
        precision: match[8] && match[8].slice(1),
        trim: match[9],
        type: match[10]
    });
}
formatSpecifier.prototype = FormatSpecifier.prototype; // instanceof
function FormatSpecifier(specifier) {
    this.fill = specifier.fill === undefined ? " " : specifier.fill + "";
    this.align = specifier.align === undefined ? ">" : specifier.align + "";
    this.sign = specifier.sign === undefined ? "-" : specifier.sign + "";
    this.symbol = specifier.symbol === undefined ? "" : specifier.symbol + "";
    this.zero = !!specifier.zero;
    this.width = specifier.width === undefined ? undefined : +specifier.width;
    this.comma = !!specifier.comma;
    this.precision = specifier.precision === undefined ? undefined : +specifier.precision;
    this.trim = !!specifier.trim;
    this.type = specifier.type === undefined ? "" : specifier.type + "";
}
FormatSpecifier.prototype.toString = function() {
    return this.fill + this.align + this.sign + this.symbol + (this.zero ? "0" : "") + (this.width === undefined ? "" : Math.max(1, this.width | 0)) + (this.comma ? "," : "") + (this.precision === undefined ? "" : "." + Math.max(0, this.precision | 0)) + (this.trim ? "~" : "") + this.type;
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"cfmz5":[function(require,module,exports) {
// Trims insignificant zeros, e.g., replaces 1.2000k with 1.2k.
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(s) {
        out: for(var n = s.length, i = 1, i0 = -1, i1; i < n; ++i)switch(s[i]){
            case ".":
                i0 = i1 = i;
                break;
            case "0":
                if (i0 === 0) i0 = i;
                i1 = i;
                break;
            default:
                if (!+s[i]) break out;
                if (i0 > 0) i0 = 0;
                break;
        }
        return i0 > 0 ? s.slice(0, i0) + s.slice(i1 + 1) : s;
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jV6Fn":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _formatDecimalJs = require("./formatDecimal.js");
var _formatDecimalJsDefault = parcelHelpers.interopDefault(_formatDecimalJs);
var _formatPrefixAutoJs = require("./formatPrefixAuto.js");
var _formatPrefixAutoJsDefault = parcelHelpers.interopDefault(_formatPrefixAutoJs);
var _formatRoundedJs = require("./formatRounded.js");
var _formatRoundedJsDefault = parcelHelpers.interopDefault(_formatRoundedJs);
exports.default = {
    "%": function(x, p) {
        return (x * 100).toFixed(p);
    },
    "b": function(x) {
        return Math.round(x).toString(2);
    },
    "c": function(x) {
        return x + "";
    },
    "d": (0, _formatDecimalJsDefault.default),
    "e": function(x, p) {
        return x.toExponential(p);
    },
    "f": function(x, p) {
        return x.toFixed(p);
    },
    "g": function(x, p) {
        return x.toPrecision(p);
    },
    "o": function(x) {
        return Math.round(x).toString(8);
    },
    "p": function(x, p) {
        return (0, _formatRoundedJsDefault.default)(x * 100, p);
    },
    "r": (0, _formatRoundedJsDefault.default),
    "s": (0, _formatPrefixAutoJsDefault.default),
    "X": function(x) {
        return Math.round(x).toString(16).toUpperCase();
    },
    "x": function(x) {
        return Math.round(x).toString(16);
    }
};

},{"./formatDecimal.js":"fFGcX","./formatPrefixAuto.js":"hO2bO","./formatRounded.js":"3kgZT","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hO2bO":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "prefixExponent", ()=>prefixExponent);
parcelHelpers.export(exports, "default", ()=>function(x, p) {
        var d = (0, _formatDecimalJs.formatDecimalParts)(x, p);
        if (!d) return x + "";
        var coefficient = d[0], exponent = d[1], i = exponent - (prefixExponent = Math.max(-8, Math.min(8, Math.floor(exponent / 3))) * 3) + 1, n = coefficient.length;
        return i === n ? coefficient : i > n ? coefficient + new Array(i - n + 1).join("0") : i > 0 ? coefficient.slice(0, i) + "." + coefficient.slice(i) : "0." + new Array(1 - i).join("0") + (0, _formatDecimalJs.formatDecimalParts)(x, Math.max(0, p + i - 1))[0]; // less than 1y!
    });
var _formatDecimalJs = require("./formatDecimal.js");
var prefixExponent;

},{"./formatDecimal.js":"fFGcX","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3kgZT":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(x, p) {
        var d = (0, _formatDecimalJs.formatDecimalParts)(x, p);
        if (!d) return x + "";
        var coefficient = d[0], exponent = d[1];
        return exponent < 0 ? "0." + new Array(-exponent).join("0") + coefficient : coefficient.length > exponent + 1 ? coefficient.slice(0, exponent + 1) + "." + coefficient.slice(exponent + 1) : coefficient + new Array(exponent - coefficient.length + 2).join("0");
    });
var _formatDecimalJs = require("./formatDecimal.js");

},{"./formatDecimal.js":"fFGcX","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7vC28":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(x) {
        return x;
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"bBVpf":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(step) {
        return Math.max(0, -(0, _exponentJsDefault.default)(Math.abs(step)));
    });
var _exponentJs = require("./exponent.js");
var _exponentJsDefault = parcelHelpers.interopDefault(_exponentJs);

},{"./exponent.js":"iZKDx","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"fZb92":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(step, value) {
        return Math.max(0, Math.max(-8, Math.min(8, Math.floor((0, _exponentJsDefault.default)(value) / 3))) * 3 - (0, _exponentJsDefault.default)(Math.abs(step)));
    });
var _exponentJs = require("./exponent.js");
var _exponentJsDefault = parcelHelpers.interopDefault(_exponentJs);

},{"./exponent.js":"iZKDx","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6KkXg":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(step, max) {
        step = Math.abs(step), max = Math.abs(max) - step;
        return Math.max(0, (0, _exponentJsDefault.default)(max) - (0, _exponentJsDefault.default)(step)) + 1;
    });
var _exponentJs = require("./exponent.js");
var _exponentJsDefault = parcelHelpers.interopDefault(_exponentJs);

},{"./exponent.js":"iZKDx","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"ie2vG":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "loggish", ()=>loggish);
parcelHelpers.export(exports, "default", ()=>log);
var _d3Array = require("d3-array");
var _d3Format = require("d3-format");
var _niceJs = require("./nice.js");
var _niceJsDefault = parcelHelpers.interopDefault(_niceJs);
var _continuousJs = require("./continuous.js");
var _initJs = require("./init.js");
function transformLog(x) {
    return Math.log(x);
}
function transformExp(x) {
    return Math.exp(x);
}
function transformLogn(x) {
    return -Math.log(-x);
}
function transformExpn(x) {
    return -Math.exp(-x);
}
function pow10(x) {
    return isFinite(x) ? +("1e" + x) : x < 0 ? 0 : x;
}
function powp(base) {
    return base === 10 ? pow10 : base === Math.E ? Math.exp : (x)=>Math.pow(base, x);
}
function logp(base) {
    return base === Math.E ? Math.log : base === 10 && Math.log10 || base === 2 && Math.log2 || (base = Math.log(base), (x)=>Math.log(x) / base);
}
function reflect(f) {
    return (x, k)=>-f(-x, k);
}
function loggish(transform) {
    const scale = transform(transformLog, transformExp);
    const domain = scale.domain;
    let base = 10;
    let logs;
    let pows;
    function rescale() {
        logs = logp(base), pows = powp(base);
        if (domain()[0] < 0) {
            logs = reflect(logs), pows = reflect(pows);
            transform(transformLogn, transformExpn);
        } else transform(transformLog, transformExp);
        return scale;
    }
    scale.base = function(_) {
        return arguments.length ? (base = +_, rescale()) : base;
    };
    scale.domain = function(_) {
        return arguments.length ? (domain(_), rescale()) : domain();
    };
    scale.ticks = (count)=>{
        const d = domain();
        let u = d[0];
        let v = d[d.length - 1];
        const r = v < u;
        if (r) [u, v] = [
            v,
            u
        ];
        let i = logs(u);
        let j = logs(v);
        let k;
        let t;
        const n = count == null ? 10 : +count;
        let z = [];
        if (!(base % 1) && j - i < n) {
            i = Math.floor(i), j = Math.ceil(j);
            if (u > 0) for(; i <= j; ++i)for(k = 1; k < base; ++k){
                t = i < 0 ? k / pows(-i) : k * pows(i);
                if (t < u) continue;
                if (t > v) break;
                z.push(t);
            }
            else for(; i <= j; ++i)for(k = base - 1; k >= 1; --k){
                t = i > 0 ? k / pows(-i) : k * pows(i);
                if (t < u) continue;
                if (t > v) break;
                z.push(t);
            }
            if (z.length * 2 < n) z = (0, _d3Array.ticks)(u, v, n);
        } else z = (0, _d3Array.ticks)(i, j, Math.min(j - i, n)).map(pows);
        return r ? z.reverse() : z;
    };
    scale.tickFormat = (count, specifier)=>{
        if (count == null) count = 10;
        if (specifier == null) specifier = base === 10 ? "s" : ",";
        if (typeof specifier !== "function") {
            if (!(base % 1) && (specifier = (0, _d3Format.formatSpecifier)(specifier)).precision == null) specifier.trim = true;
            specifier = (0, _d3Format.format)(specifier);
        }
        if (count === Infinity) return specifier;
        const k = Math.max(1, base * count / scale.ticks().length); // TODO fast estimate?
        return (d)=>{
            let i = d / pows(Math.round(logs(d)));
            if (i * base < base - 0.5) i *= base;
            return i <= k ? specifier(d) : "";
        };
    };
    scale.nice = ()=>{
        return domain((0, _niceJsDefault.default)(domain(), {
            floor: (x)=>pows(Math.floor(logs(x))),
            ceil: (x)=>pows(Math.ceil(logs(x)))
        }));
    };
    return scale;
}
function log() {
    const scale = loggish((0, _continuousJs.transformer)()).domain([
        1,
        10
    ]);
    scale.copy = ()=>(0, _continuousJs.copy)(scale, log()).base(scale.base());
    (0, _initJs.initRange).apply(scale, arguments);
    return scale;
}

},{"d3-array":"bmqp6","d3-format":"bpsrv","./nice.js":"fMpaN","./continuous.js":"kDIa7","./init.js":"MGGB7","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"fMpaN":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>nice);
function nice(domain, interval) {
    domain = domain.slice();
    var i0 = 0, i1 = domain.length - 1, x0 = domain[i0], x1 = domain[i1], t;
    if (x1 < x0) {
        t = i0, i0 = i1, i1 = t;
        t = x0, x0 = x1, x1 = t;
    }
    domain[i0] = interval.floor(x0);
    domain[i1] = interval.ceil(x1);
    return domain;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3luv5":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "symlogish", ()=>symlogish);
parcelHelpers.export(exports, "default", ()=>symlog);
var _linearJs = require("./linear.js");
var _continuousJs = require("./continuous.js");
var _initJs = require("./init.js");
function transformSymlog(c) {
    return function(x) {
        return Math.sign(x) * Math.log1p(Math.abs(x / c));
    };
}
function transformSymexp(c) {
    return function(x) {
        return Math.sign(x) * Math.expm1(Math.abs(x)) * c;
    };
}
function symlogish(transform) {
    var c = 1, scale = transform(transformSymlog(c), transformSymexp(c));
    scale.constant = function(_) {
        return arguments.length ? transform(transformSymlog(c = +_), transformSymexp(c)) : c;
    };
    return (0, _linearJs.linearish)(scale);
}
function symlog() {
    var scale = symlogish((0, _continuousJs.transformer)());
    scale.copy = function() {
        return (0, _continuousJs.copy)(scale, symlog()).constant(scale.constant());
    };
    return (0, _initJs.initRange).apply(scale, arguments);
}

},{"./linear.js":"5y58A","./continuous.js":"kDIa7","./init.js":"MGGB7","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"15HKe":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "powish", ()=>powish);
parcelHelpers.export(exports, "default", ()=>pow);
parcelHelpers.export(exports, "sqrt", ()=>sqrt);
var _linearJs = require("./linear.js");
var _continuousJs = require("./continuous.js");
var _initJs = require("./init.js");
function transformPow(exponent) {
    return function(x) {
        return x < 0 ? -Math.pow(-x, exponent) : Math.pow(x, exponent);
    };
}
function transformSqrt(x) {
    return x < 0 ? -Math.sqrt(-x) : Math.sqrt(x);
}
function transformSquare(x) {
    return x < 0 ? -x * x : x * x;
}
function powish(transform) {
    var scale = transform((0, _continuousJs.identity), (0, _continuousJs.identity)), exponent = 1;
    function rescale() {
        return exponent === 1 ? transform((0, _continuousJs.identity), (0, _continuousJs.identity)) : exponent === 0.5 ? transform(transformSqrt, transformSquare) : transform(transformPow(exponent), transformPow(1 / exponent));
    }
    scale.exponent = function(_) {
        return arguments.length ? (exponent = +_, rescale()) : exponent;
    };
    return (0, _linearJs.linearish)(scale);
}
function pow() {
    var scale = powish((0, _continuousJs.transformer)());
    scale.copy = function() {
        return (0, _continuousJs.copy)(scale, pow()).exponent(scale.exponent());
    };
    (0, _initJs.initRange).apply(scale, arguments);
    return scale;
}
function sqrt() {
    return pow.apply(null, arguments).exponent(0.5);
}

},{"./linear.js":"5y58A","./continuous.js":"kDIa7","./init.js":"MGGB7","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9QtkS":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>quantize);
var _d3Array = require("d3-array");
var _linearJs = require("./linear.js");
var _initJs = require("./init.js");
function quantize() {
    var x0 = 0, x1 = 1, n = 1, domain = [
        0.5
    ], range = [
        0,
        1
    ], unknown;
    function scale(x) {
        return x != null && x <= x ? range[(0, _d3Array.bisect)(domain, x, 0, n)] : unknown;
    }
    function rescale() {
        var i = -1;
        domain = new Array(n);
        while(++i < n)domain[i] = ((i + 1) * x1 - (i - n) * x0) / (n + 1);
        return scale;
    }
    scale.domain = function(_) {
        return arguments.length ? ([x0, x1] = _, x0 = +x0, x1 = +x1, rescale()) : [
            x0,
            x1
        ];
    };
    scale.range = function(_) {
        return arguments.length ? (n = (range = Array.from(_)).length - 1, rescale()) : range.slice();
    };
    scale.invertExtent = function(y) {
        var i = range.indexOf(y);
        return i < 0 ? [
            NaN,
            NaN
        ] : i < 1 ? [
            x0,
            domain[0]
        ] : i >= n ? [
            domain[n - 1],
            x1
        ] : [
            domain[i - 1],
            domain[i]
        ];
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : scale;
    };
    scale.thresholds = function() {
        return domain.slice();
    };
    scale.copy = function() {
        return quantize().domain([
            x0,
            x1
        ]).range(range).unknown(unknown);
    };
    return (0, _initJs.initRange).apply((0, _linearJs.linearish)(scale), arguments);
}

},{"d3-array":"bmqp6","./linear.js":"5y58A","./init.js":"MGGB7","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"fNFf4":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "calendar", ()=>calendar);
parcelHelpers.export(exports, "default", ()=>time);
var _d3Time = require("d3-time");
var _d3TimeFormat = require("d3-time-format");
var _continuousJs = require("./continuous.js");
var _continuousJsDefault = parcelHelpers.interopDefault(_continuousJs);
var _initJs = require("./init.js");
var _niceJs = require("./nice.js");
var _niceJsDefault = parcelHelpers.interopDefault(_niceJs);
function date(t) {
    return new Date(t);
}
function number(t) {
    return t instanceof Date ? +t : +new Date(+t);
}
function calendar(ticks, tickInterval, year, month, week, day, hour, minute, second, format) {
    var scale = (0, _continuousJsDefault.default)(), invert = scale.invert, domain = scale.domain;
    var formatMillisecond = format(".%L"), formatSecond = format(":%S"), formatMinute = format("%I:%M"), formatHour = format("%I %p"), formatDay = format("%a %d"), formatWeek = format("%b %d"), formatMonth = format("%B"), formatYear = format("%Y");
    function tickFormat(date) {
        return (second(date) < date ? formatMillisecond : minute(date) < date ? formatSecond : hour(date) < date ? formatMinute : day(date) < date ? formatHour : month(date) < date ? week(date) < date ? formatDay : formatWeek : year(date) < date ? formatMonth : formatYear)(date);
    }
    scale.invert = function(y) {
        return new Date(invert(y));
    };
    scale.domain = function(_) {
        return arguments.length ? domain(Array.from(_, number)) : domain().map(date);
    };
    scale.ticks = function(interval) {
        var d = domain();
        return ticks(d[0], d[d.length - 1], interval == null ? 10 : interval);
    };
    scale.tickFormat = function(count, specifier) {
        return specifier == null ? tickFormat : format(specifier);
    };
    scale.nice = function(interval) {
        var d = domain();
        if (!interval || typeof interval.range !== "function") interval = tickInterval(d[0], d[d.length - 1], interval == null ? 10 : interval);
        return interval ? domain((0, _niceJsDefault.default)(d, interval)) : scale;
    };
    scale.copy = function() {
        return (0, _continuousJs.copy)(scale, calendar(ticks, tickInterval, year, month, week, day, hour, minute, second, format));
    };
    return scale;
}
function time() {
    return (0, _initJs.initRange).apply(calendar((0, _d3Time.timeTicks), (0, _d3Time.timeTickInterval), (0, _d3Time.timeYear), (0, _d3Time.timeMonth), (0, _d3Time.timeWeek), (0, _d3Time.timeDay), (0, _d3Time.timeHour), (0, _d3Time.timeMinute), (0, _d3Time.timeSecond), (0, _d3TimeFormat.timeFormat)).domain([
        new Date(2000, 0, 1),
        new Date(2000, 0, 2)
    ]), arguments);
}

},{"d3-time":"ctZNU","d3-time-format":"1JsiF","./continuous.js":"kDIa7","./init.js":"MGGB7","./nice.js":"fMpaN","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"ctZNU":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "timeInterval", ()=>(0, _intervalJs.timeInterval));
parcelHelpers.export(exports, "utcMillisecond", ()=>(0, _millisecondJs.millisecond));
parcelHelpers.export(exports, "utcMilliseconds", ()=>(0, _millisecondJs.milliseconds));
parcelHelpers.export(exports, "timeMillisecond", ()=>(0, _millisecondJs.millisecond));
parcelHelpers.export(exports, "timeMilliseconds", ()=>(0, _millisecondJs.milliseconds));
parcelHelpers.export(exports, "utcSecond", ()=>(0, _secondJs.second));
parcelHelpers.export(exports, "utcSeconds", ()=>(0, _secondJs.seconds));
parcelHelpers.export(exports, "timeSecond", ()=>(0, _secondJs.second));
parcelHelpers.export(exports, "timeSeconds", ()=>(0, _secondJs.seconds));
parcelHelpers.export(exports, "timeMinute", ()=>(0, _minuteJs.timeMinute));
parcelHelpers.export(exports, "timeMinutes", ()=>(0, _minuteJs.timeMinutes));
parcelHelpers.export(exports, "utcMinute", ()=>(0, _minuteJs.utcMinute));
parcelHelpers.export(exports, "utcMinutes", ()=>(0, _minuteJs.utcMinutes));
parcelHelpers.export(exports, "timeHour", ()=>(0, _hourJs.timeHour));
parcelHelpers.export(exports, "timeHours", ()=>(0, _hourJs.timeHours));
parcelHelpers.export(exports, "utcHour", ()=>(0, _hourJs.utcHour));
parcelHelpers.export(exports, "utcHours", ()=>(0, _hourJs.utcHours));
parcelHelpers.export(exports, "timeDay", ()=>(0, _dayJs.timeDay));
parcelHelpers.export(exports, "timeDays", ()=>(0, _dayJs.timeDays));
parcelHelpers.export(exports, "utcDay", ()=>(0, _dayJs.utcDay));
parcelHelpers.export(exports, "utcDays", ()=>(0, _dayJs.utcDays));
parcelHelpers.export(exports, "unixDay", ()=>(0, _dayJs.unixDay));
parcelHelpers.export(exports, "unixDays", ()=>(0, _dayJs.unixDays));
parcelHelpers.export(exports, "timeWeek", ()=>(0, _weekJs.timeSunday));
parcelHelpers.export(exports, "timeWeeks", ()=>(0, _weekJs.timeSundays));
parcelHelpers.export(exports, "timeSunday", ()=>(0, _weekJs.timeSunday));
parcelHelpers.export(exports, "timeSundays", ()=>(0, _weekJs.timeSundays));
parcelHelpers.export(exports, "timeMonday", ()=>(0, _weekJs.timeMonday));
parcelHelpers.export(exports, "timeMondays", ()=>(0, _weekJs.timeMondays));
parcelHelpers.export(exports, "timeTuesday", ()=>(0, _weekJs.timeTuesday));
parcelHelpers.export(exports, "timeTuesdays", ()=>(0, _weekJs.timeTuesdays));
parcelHelpers.export(exports, "timeWednesday", ()=>(0, _weekJs.timeWednesday));
parcelHelpers.export(exports, "timeWednesdays", ()=>(0, _weekJs.timeWednesdays));
parcelHelpers.export(exports, "timeThursday", ()=>(0, _weekJs.timeThursday));
parcelHelpers.export(exports, "timeThursdays", ()=>(0, _weekJs.timeThursdays));
parcelHelpers.export(exports, "timeFriday", ()=>(0, _weekJs.timeFriday));
parcelHelpers.export(exports, "timeFridays", ()=>(0, _weekJs.timeFridays));
parcelHelpers.export(exports, "timeSaturday", ()=>(0, _weekJs.timeSaturday));
parcelHelpers.export(exports, "timeSaturdays", ()=>(0, _weekJs.timeSaturdays));
parcelHelpers.export(exports, "utcWeek", ()=>(0, _weekJs.utcSunday));
parcelHelpers.export(exports, "utcWeeks", ()=>(0, _weekJs.utcSundays));
parcelHelpers.export(exports, "utcSunday", ()=>(0, _weekJs.utcSunday));
parcelHelpers.export(exports, "utcSundays", ()=>(0, _weekJs.utcSundays));
parcelHelpers.export(exports, "utcMonday", ()=>(0, _weekJs.utcMonday));
parcelHelpers.export(exports, "utcMondays", ()=>(0, _weekJs.utcMondays));
parcelHelpers.export(exports, "utcTuesday", ()=>(0, _weekJs.utcTuesday));
parcelHelpers.export(exports, "utcTuesdays", ()=>(0, _weekJs.utcTuesdays));
parcelHelpers.export(exports, "utcWednesday", ()=>(0, _weekJs.utcWednesday));
parcelHelpers.export(exports, "utcWednesdays", ()=>(0, _weekJs.utcWednesdays));
parcelHelpers.export(exports, "utcThursday", ()=>(0, _weekJs.utcThursday));
parcelHelpers.export(exports, "utcThursdays", ()=>(0, _weekJs.utcThursdays));
parcelHelpers.export(exports, "utcFriday", ()=>(0, _weekJs.utcFriday));
parcelHelpers.export(exports, "utcFridays", ()=>(0, _weekJs.utcFridays));
parcelHelpers.export(exports, "utcSaturday", ()=>(0, _weekJs.utcSaturday));
parcelHelpers.export(exports, "utcSaturdays", ()=>(0, _weekJs.utcSaturdays));
parcelHelpers.export(exports, "timeMonth", ()=>(0, _monthJs.timeMonth));
parcelHelpers.export(exports, "timeMonths", ()=>(0, _monthJs.timeMonths));
parcelHelpers.export(exports, "utcMonth", ()=>(0, _monthJs.utcMonth));
parcelHelpers.export(exports, "utcMonths", ()=>(0, _monthJs.utcMonths));
parcelHelpers.export(exports, "timeYear", ()=>(0, _yearJs.timeYear));
parcelHelpers.export(exports, "timeYears", ()=>(0, _yearJs.timeYears));
parcelHelpers.export(exports, "utcYear", ()=>(0, _yearJs.utcYear));
parcelHelpers.export(exports, "utcYears", ()=>(0, _yearJs.utcYears));
parcelHelpers.export(exports, "utcTicks", ()=>(0, _ticksJs.utcTicks));
parcelHelpers.export(exports, "utcTickInterval", ()=>(0, _ticksJs.utcTickInterval));
parcelHelpers.export(exports, "timeTicks", ()=>(0, _ticksJs.timeTicks));
parcelHelpers.export(exports, "timeTickInterval", ()=>(0, _ticksJs.timeTickInterval));
var _intervalJs = require("./interval.js");
var _millisecondJs = require("./millisecond.js");
var _secondJs = require("./second.js");
var _minuteJs = require("./minute.js");
var _hourJs = require("./hour.js");
var _dayJs = require("./day.js");
var _weekJs = require("./week.js");
var _monthJs = require("./month.js");
var _yearJs = require("./year.js");
var _ticksJs = require("./ticks.js");

},{"./interval.js":false,"./millisecond.js":false,"./second.js":"cuY1L","./minute.js":"iHa6c","./hour.js":"jznfw","./day.js":"2lg3X","./week.js":"8gIjL","./month.js":"jV0v3","./year.js":"9wCnA","./ticks.js":"7eHC0","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"5FYEa":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "timeInterval", ()=>timeInterval);
const t0 = new Date, t1 = new Date;
function timeInterval(floori, offseti, count, field) {
    function interval(date) {
        return floori(date = arguments.length === 0 ? new Date : new Date(+date)), date;
    }
    interval.floor = (date)=>{
        return floori(date = new Date(+date)), date;
    };
    interval.ceil = (date)=>{
        return floori(date = new Date(date - 1)), offseti(date, 1), floori(date), date;
    };
    interval.round = (date)=>{
        const d0 = interval(date), d1 = interval.ceil(date);
        return date - d0 < d1 - date ? d0 : d1;
    };
    interval.offset = (date, step)=>{
        return offseti(date = new Date(+date), step == null ? 1 : Math.floor(step)), date;
    };
    interval.range = (start, stop, step)=>{
        const range = [];
        start = interval.ceil(start);
        step = step == null ? 1 : Math.floor(step);
        if (!(start < stop) || !(step > 0)) return range; // also handles Invalid Date
        let previous;
        do range.push(previous = new Date(+start)), offseti(start, step), floori(start);
        while (previous < start && start < stop);
        return range;
    };
    interval.filter = (test)=>{
        return timeInterval((date)=>{
            if (date >= date) while(floori(date), !test(date))date.setTime(date - 1);
        }, (date, step)=>{
            if (date >= date) {
                if (step < 0) while(++step <= 0){
                    while(offseti(date, -1), !test(date)); // eslint-disable-line no-empty
                }
                else while(--step >= 0){
                    while(offseti(date, 1), !test(date)); // eslint-disable-line no-empty
                }
            }
        });
    };
    if (count) {
        interval.count = (start, end)=>{
            t0.setTime(+start), t1.setTime(+end);
            floori(t0), floori(t1);
            return Math.floor(count(t0, t1));
        };
        interval.every = (step)=>{
            step = Math.floor(step);
            return !isFinite(step) || !(step > 0) ? null : !(step > 1) ? interval : interval.filter(field ? (d)=>field(d) % step === 0 : (d)=>interval.count(0, d) % step === 0);
        };
    }
    return interval;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"bNJ9Y":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "millisecond", ()=>millisecond);
parcelHelpers.export(exports, "milliseconds", ()=>milliseconds);
var _intervalJs = require("./interval.js");
const millisecond = (0, _intervalJs.timeInterval)(()=>{
// noop
}, (date, step)=>{
    date.setTime(+date + step);
}, (start, end)=>{
    return end - start;
});
// An optimized implementation for this simple case.
millisecond.every = (k)=>{
    k = Math.floor(k);
    if (!isFinite(k) || !(k > 0)) return null;
    if (!(k > 1)) return millisecond;
    return (0, _intervalJs.timeInterval)((date)=>{
        date.setTime(Math.floor(date / k) * k);
    }, (date, step)=>{
        date.setTime(+date + step * k);
    }, (start, end)=>{
        return (end - start) / k;
    });
};
const milliseconds = millisecond.range;

},{"./interval.js":"5FYEa","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"cuY1L":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "second", ()=>second);
parcelHelpers.export(exports, "seconds", ()=>seconds);
var _intervalJs = require("./interval.js");
var _durationJs = require("./duration.js");
const second = (0, _intervalJs.timeInterval)((date)=>{
    date.setTime(date - date.getMilliseconds());
}, (date, step)=>{
    date.setTime(+date + step * (0, _durationJs.durationSecond));
}, (start, end)=>{
    return (end - start) / (0, _durationJs.durationSecond);
}, (date)=>{
    return date.getUTCSeconds();
});
const seconds = second.range;

},{"./interval.js":"5FYEa","./duration.js":"5wR5D","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"5wR5D":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "durationSecond", ()=>durationSecond);
parcelHelpers.export(exports, "durationMinute", ()=>durationMinute);
parcelHelpers.export(exports, "durationHour", ()=>durationHour);
parcelHelpers.export(exports, "durationDay", ()=>durationDay);
parcelHelpers.export(exports, "durationWeek", ()=>durationWeek);
parcelHelpers.export(exports, "durationMonth", ()=>durationMonth);
parcelHelpers.export(exports, "durationYear", ()=>durationYear);
const durationSecond = 1000;
const durationMinute = durationSecond * 60;
const durationHour = durationMinute * 60;
const durationDay = durationHour * 24;
const durationWeek = durationDay * 7;
const durationMonth = durationDay * 30;
const durationYear = durationDay * 365;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"iHa6c":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "timeMinute", ()=>timeMinute);
parcelHelpers.export(exports, "timeMinutes", ()=>timeMinutes);
parcelHelpers.export(exports, "utcMinute", ()=>utcMinute);
parcelHelpers.export(exports, "utcMinutes", ()=>utcMinutes);
var _intervalJs = require("./interval.js");
var _durationJs = require("./duration.js");
const timeMinute = (0, _intervalJs.timeInterval)((date)=>{
    date.setTime(date - date.getMilliseconds() - date.getSeconds() * (0, _durationJs.durationSecond));
}, (date, step)=>{
    date.setTime(+date + step * (0, _durationJs.durationMinute));
}, (start, end)=>{
    return (end - start) / (0, _durationJs.durationMinute);
}, (date)=>{
    return date.getMinutes();
});
const timeMinutes = timeMinute.range;
const utcMinute = (0, _intervalJs.timeInterval)((date)=>{
    date.setUTCSeconds(0, 0);
}, (date, step)=>{
    date.setTime(+date + step * (0, _durationJs.durationMinute));
}, (start, end)=>{
    return (end - start) / (0, _durationJs.durationMinute);
}, (date)=>{
    return date.getUTCMinutes();
});
const utcMinutes = utcMinute.range;

},{"./interval.js":"5FYEa","./duration.js":"5wR5D","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jznfw":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "timeHour", ()=>timeHour);
parcelHelpers.export(exports, "timeHours", ()=>timeHours);
parcelHelpers.export(exports, "utcHour", ()=>utcHour);
parcelHelpers.export(exports, "utcHours", ()=>utcHours);
var _intervalJs = require("./interval.js");
var _durationJs = require("./duration.js");
const timeHour = (0, _intervalJs.timeInterval)((date)=>{
    date.setTime(date - date.getMilliseconds() - date.getSeconds() * (0, _durationJs.durationSecond) - date.getMinutes() * (0, _durationJs.durationMinute));
}, (date, step)=>{
    date.setTime(+date + step * (0, _durationJs.durationHour));
}, (start, end)=>{
    return (end - start) / (0, _durationJs.durationHour);
}, (date)=>{
    return date.getHours();
});
const timeHours = timeHour.range;
const utcHour = (0, _intervalJs.timeInterval)((date)=>{
    date.setUTCMinutes(0, 0, 0);
}, (date, step)=>{
    date.setTime(+date + step * (0, _durationJs.durationHour));
}, (start, end)=>{
    return (end - start) / (0, _durationJs.durationHour);
}, (date)=>{
    return date.getUTCHours();
});
const utcHours = utcHour.range;

},{"./interval.js":"5FYEa","./duration.js":"5wR5D","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2lg3X":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "timeDay", ()=>timeDay);
parcelHelpers.export(exports, "timeDays", ()=>timeDays);
parcelHelpers.export(exports, "utcDay", ()=>utcDay);
parcelHelpers.export(exports, "utcDays", ()=>utcDays);
parcelHelpers.export(exports, "unixDay", ()=>unixDay);
parcelHelpers.export(exports, "unixDays", ()=>unixDays);
var _intervalJs = require("./interval.js");
var _durationJs = require("./duration.js");
const timeDay = (0, _intervalJs.timeInterval)((date)=>date.setHours(0, 0, 0, 0), (date, step)=>date.setDate(date.getDate() + step), (start, end)=>(end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * (0, _durationJs.durationMinute)) / (0, _durationJs.durationDay), (date)=>date.getDate() - 1);
const timeDays = timeDay.range;
const utcDay = (0, _intervalJs.timeInterval)((date)=>{
    date.setUTCHours(0, 0, 0, 0);
}, (date, step)=>{
    date.setUTCDate(date.getUTCDate() + step);
}, (start, end)=>{
    return (end - start) / (0, _durationJs.durationDay);
}, (date)=>{
    return date.getUTCDate() - 1;
});
const utcDays = utcDay.range;
const unixDay = (0, _intervalJs.timeInterval)((date)=>{
    date.setUTCHours(0, 0, 0, 0);
}, (date, step)=>{
    date.setUTCDate(date.getUTCDate() + step);
}, (start, end)=>{
    return (end - start) / (0, _durationJs.durationDay);
}, (date)=>{
    return Math.floor(date / (0, _durationJs.durationDay));
});
const unixDays = unixDay.range;

},{"./interval.js":"5FYEa","./duration.js":"5wR5D","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8gIjL":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "timeSunday", ()=>timeSunday);
parcelHelpers.export(exports, "timeMonday", ()=>timeMonday);
parcelHelpers.export(exports, "timeTuesday", ()=>timeTuesday);
parcelHelpers.export(exports, "timeWednesday", ()=>timeWednesday);
parcelHelpers.export(exports, "timeThursday", ()=>timeThursday);
parcelHelpers.export(exports, "timeFriday", ()=>timeFriday);
parcelHelpers.export(exports, "timeSaturday", ()=>timeSaturday);
parcelHelpers.export(exports, "timeSundays", ()=>timeSundays);
parcelHelpers.export(exports, "timeMondays", ()=>timeMondays);
parcelHelpers.export(exports, "timeTuesdays", ()=>timeTuesdays);
parcelHelpers.export(exports, "timeWednesdays", ()=>timeWednesdays);
parcelHelpers.export(exports, "timeThursdays", ()=>timeThursdays);
parcelHelpers.export(exports, "timeFridays", ()=>timeFridays);
parcelHelpers.export(exports, "timeSaturdays", ()=>timeSaturdays);
parcelHelpers.export(exports, "utcSunday", ()=>utcSunday);
parcelHelpers.export(exports, "utcMonday", ()=>utcMonday);
parcelHelpers.export(exports, "utcTuesday", ()=>utcTuesday);
parcelHelpers.export(exports, "utcWednesday", ()=>utcWednesday);
parcelHelpers.export(exports, "utcThursday", ()=>utcThursday);
parcelHelpers.export(exports, "utcFriday", ()=>utcFriday);
parcelHelpers.export(exports, "utcSaturday", ()=>utcSaturday);
parcelHelpers.export(exports, "utcSundays", ()=>utcSundays);
parcelHelpers.export(exports, "utcMondays", ()=>utcMondays);
parcelHelpers.export(exports, "utcTuesdays", ()=>utcTuesdays);
parcelHelpers.export(exports, "utcWednesdays", ()=>utcWednesdays);
parcelHelpers.export(exports, "utcThursdays", ()=>utcThursdays);
parcelHelpers.export(exports, "utcFridays", ()=>utcFridays);
parcelHelpers.export(exports, "utcSaturdays", ()=>utcSaturdays);
var _intervalJs = require("./interval.js");
var _durationJs = require("./duration.js");
function timeWeekday(i) {
    return (0, _intervalJs.timeInterval)((date)=>{
        date.setDate(date.getDate() - (date.getDay() + 7 - i) % 7);
        date.setHours(0, 0, 0, 0);
    }, (date, step)=>{
        date.setDate(date.getDate() + step * 7);
    }, (start, end)=>{
        return (end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * (0, _durationJs.durationMinute)) / (0, _durationJs.durationWeek);
    });
}
const timeSunday = timeWeekday(0);
const timeMonday = timeWeekday(1);
const timeTuesday = timeWeekday(2);
const timeWednesday = timeWeekday(3);
const timeThursday = timeWeekday(4);
const timeFriday = timeWeekday(5);
const timeSaturday = timeWeekday(6);
const timeSundays = timeSunday.range;
const timeMondays = timeMonday.range;
const timeTuesdays = timeTuesday.range;
const timeWednesdays = timeWednesday.range;
const timeThursdays = timeThursday.range;
const timeFridays = timeFriday.range;
const timeSaturdays = timeSaturday.range;
function utcWeekday(i) {
    return (0, _intervalJs.timeInterval)((date)=>{
        date.setUTCDate(date.getUTCDate() - (date.getUTCDay() + 7 - i) % 7);
        date.setUTCHours(0, 0, 0, 0);
    }, (date, step)=>{
        date.setUTCDate(date.getUTCDate() + step * 7);
    }, (start, end)=>{
        return (end - start) / (0, _durationJs.durationWeek);
    });
}
const utcSunday = utcWeekday(0);
const utcMonday = utcWeekday(1);
const utcTuesday = utcWeekday(2);
const utcWednesday = utcWeekday(3);
const utcThursday = utcWeekday(4);
const utcFriday = utcWeekday(5);
const utcSaturday = utcWeekday(6);
const utcSundays = utcSunday.range;
const utcMondays = utcMonday.range;
const utcTuesdays = utcTuesday.range;
const utcWednesdays = utcWednesday.range;
const utcThursdays = utcThursday.range;
const utcFridays = utcFriday.range;
const utcSaturdays = utcSaturday.range;

},{"./interval.js":"5FYEa","./duration.js":"5wR5D","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jV0v3":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "timeMonth", ()=>timeMonth);
parcelHelpers.export(exports, "timeMonths", ()=>timeMonths);
parcelHelpers.export(exports, "utcMonth", ()=>utcMonth);
parcelHelpers.export(exports, "utcMonths", ()=>utcMonths);
var _intervalJs = require("./interval.js");
const timeMonth = (0, _intervalJs.timeInterval)((date)=>{
    date.setDate(1);
    date.setHours(0, 0, 0, 0);
}, (date, step)=>{
    date.setMonth(date.getMonth() + step);
}, (start, end)=>{
    return end.getMonth() - start.getMonth() + (end.getFullYear() - start.getFullYear()) * 12;
}, (date)=>{
    return date.getMonth();
});
const timeMonths = timeMonth.range;
const utcMonth = (0, _intervalJs.timeInterval)((date)=>{
    date.setUTCDate(1);
    date.setUTCHours(0, 0, 0, 0);
}, (date, step)=>{
    date.setUTCMonth(date.getUTCMonth() + step);
}, (start, end)=>{
    return end.getUTCMonth() - start.getUTCMonth() + (end.getUTCFullYear() - start.getUTCFullYear()) * 12;
}, (date)=>{
    return date.getUTCMonth();
});
const utcMonths = utcMonth.range;

},{"./interval.js":"5FYEa","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9wCnA":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "timeYear", ()=>timeYear);
parcelHelpers.export(exports, "timeYears", ()=>timeYears);
parcelHelpers.export(exports, "utcYear", ()=>utcYear);
parcelHelpers.export(exports, "utcYears", ()=>utcYears);
var _intervalJs = require("./interval.js");
const timeYear = (0, _intervalJs.timeInterval)((date)=>{
    date.setMonth(0, 1);
    date.setHours(0, 0, 0, 0);
}, (date, step)=>{
    date.setFullYear(date.getFullYear() + step);
}, (start, end)=>{
    return end.getFullYear() - start.getFullYear();
}, (date)=>{
    return date.getFullYear();
});
// An optimized implementation for this simple case.
timeYear.every = (k)=>{
    return !isFinite(k = Math.floor(k)) || !(k > 0) ? null : (0, _intervalJs.timeInterval)((date)=>{
        date.setFullYear(Math.floor(date.getFullYear() / k) * k);
        date.setMonth(0, 1);
        date.setHours(0, 0, 0, 0);
    }, (date, step)=>{
        date.setFullYear(date.getFullYear() + step * k);
    });
};
const timeYears = timeYear.range;
const utcYear = (0, _intervalJs.timeInterval)((date)=>{
    date.setUTCMonth(0, 1);
    date.setUTCHours(0, 0, 0, 0);
}, (date, step)=>{
    date.setUTCFullYear(date.getUTCFullYear() + step);
}, (start, end)=>{
    return end.getUTCFullYear() - start.getUTCFullYear();
}, (date)=>{
    return date.getUTCFullYear();
});
// An optimized implementation for this simple case.
utcYear.every = (k)=>{
    return !isFinite(k = Math.floor(k)) || !(k > 0) ? null : (0, _intervalJs.timeInterval)((date)=>{
        date.setUTCFullYear(Math.floor(date.getUTCFullYear() / k) * k);
        date.setUTCMonth(0, 1);
        date.setUTCHours(0, 0, 0, 0);
    }, (date, step)=>{
        date.setUTCFullYear(date.getUTCFullYear() + step * k);
    });
};
const utcYears = utcYear.range;

},{"./interval.js":"5FYEa","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7eHC0":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "utcTicks", ()=>utcTicks);
parcelHelpers.export(exports, "utcTickInterval", ()=>utcTickInterval);
parcelHelpers.export(exports, "timeTicks", ()=>timeTicks);
parcelHelpers.export(exports, "timeTickInterval", ()=>timeTickInterval);
var _d3Array = require("d3-array");
var _durationJs = require("./duration.js");
var _millisecondJs = require("./millisecond.js");
var _secondJs = require("./second.js");
var _minuteJs = require("./minute.js");
var _hourJs = require("./hour.js");
var _dayJs = require("./day.js");
var _weekJs = require("./week.js");
var _monthJs = require("./month.js");
var _yearJs = require("./year.js");
function ticker(year, month, week, day, hour, minute) {
    const tickIntervals = [
        [
            (0, _secondJs.second),
            1,
            (0, _durationJs.durationSecond)
        ],
        [
            (0, _secondJs.second),
            5,
            5 * (0, _durationJs.durationSecond)
        ],
        [
            (0, _secondJs.second),
            15,
            15 * (0, _durationJs.durationSecond)
        ],
        [
            (0, _secondJs.second),
            30,
            30 * (0, _durationJs.durationSecond)
        ],
        [
            minute,
            1,
            (0, _durationJs.durationMinute)
        ],
        [
            minute,
            5,
            5 * (0, _durationJs.durationMinute)
        ],
        [
            minute,
            15,
            15 * (0, _durationJs.durationMinute)
        ],
        [
            minute,
            30,
            30 * (0, _durationJs.durationMinute)
        ],
        [
            hour,
            1,
            (0, _durationJs.durationHour)
        ],
        [
            hour,
            3,
            3 * (0, _durationJs.durationHour)
        ],
        [
            hour,
            6,
            6 * (0, _durationJs.durationHour)
        ],
        [
            hour,
            12,
            12 * (0, _durationJs.durationHour)
        ],
        [
            day,
            1,
            (0, _durationJs.durationDay)
        ],
        [
            day,
            2,
            2 * (0, _durationJs.durationDay)
        ],
        [
            week,
            1,
            (0, _durationJs.durationWeek)
        ],
        [
            month,
            1,
            (0, _durationJs.durationMonth)
        ],
        [
            month,
            3,
            3 * (0, _durationJs.durationMonth)
        ],
        [
            year,
            1,
            (0, _durationJs.durationYear)
        ]
    ];
    function ticks(start, stop, count) {
        const reverse = stop < start;
        if (reverse) [start, stop] = [
            stop,
            start
        ];
        const interval = count && typeof count.range === "function" ? count : tickInterval(start, stop, count);
        const ticks = interval ? interval.range(start, +stop + 1) : []; // inclusive stop
        return reverse ? ticks.reverse() : ticks;
    }
    function tickInterval(start, stop, count) {
        const target = Math.abs(stop - start) / count;
        const i = (0, _d3Array.bisector)(([, , step])=>step).right(tickIntervals, target);
        if (i === tickIntervals.length) return year.every((0, _d3Array.tickStep)(start / (0, _durationJs.durationYear), stop / (0, _durationJs.durationYear), count));
        if (i === 0) return (0, _millisecondJs.millisecond).every(Math.max((0, _d3Array.tickStep)(start, stop, count), 1));
        const [t, step] = tickIntervals[target / tickIntervals[i - 1][2] < tickIntervals[i][2] / target ? i - 1 : i];
        return t.every(step);
    }
    return [
        ticks,
        tickInterval
    ];
}
const [utcTicks, utcTickInterval] = ticker((0, _yearJs.utcYear), (0, _monthJs.utcMonth), (0, _weekJs.utcSunday), (0, _dayJs.unixDay), (0, _hourJs.utcHour), (0, _minuteJs.utcMinute));
const [timeTicks, timeTickInterval] = ticker((0, _yearJs.timeYear), (0, _monthJs.timeMonth), (0, _weekJs.timeSunday), (0, _dayJs.timeDay), (0, _hourJs.timeHour), (0, _minuteJs.timeMinute));

},{"d3-array":"bmqp6","./duration.js":"5wR5D","./millisecond.js":"bNJ9Y","./second.js":"cuY1L","./minute.js":"iHa6c","./hour.js":"jznfw","./day.js":"2lg3X","./week.js":"8gIjL","./month.js":"jV0v3","./year.js":"9wCnA","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1JsiF":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "timeFormatDefaultLocale", ()=>(0, _defaultLocaleJsDefault.default));
parcelHelpers.export(exports, "timeFormat", ()=>(0, _defaultLocaleJs.timeFormat));
parcelHelpers.export(exports, "timeParse", ()=>(0, _defaultLocaleJs.timeParse));
parcelHelpers.export(exports, "utcFormat", ()=>(0, _defaultLocaleJs.utcFormat));
parcelHelpers.export(exports, "utcParse", ()=>(0, _defaultLocaleJs.utcParse));
parcelHelpers.export(exports, "timeFormatLocale", ()=>(0, _localeJsDefault.default));
parcelHelpers.export(exports, "isoFormat", ()=>(0, _isoFormatJsDefault.default));
parcelHelpers.export(exports, "isoParse", ()=>(0, _isoParseJsDefault.default));
var _defaultLocaleJs = require("./defaultLocale.js");
var _defaultLocaleJsDefault = parcelHelpers.interopDefault(_defaultLocaleJs);
var _localeJs = require("./locale.js");
var _localeJsDefault = parcelHelpers.interopDefault(_localeJs);
var _isoFormatJs = require("./isoFormat.js");
var _isoFormatJsDefault = parcelHelpers.interopDefault(_isoFormatJs);
var _isoParseJs = require("./isoParse.js");
var _isoParseJsDefault = parcelHelpers.interopDefault(_isoParseJs);

},{"./defaultLocale.js":"1i7Hq","./locale.js":false,"./isoFormat.js":false,"./isoParse.js":false,"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1i7Hq":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "timeFormat", ()=>timeFormat);
parcelHelpers.export(exports, "timeParse", ()=>timeParse);
parcelHelpers.export(exports, "utcFormat", ()=>utcFormat);
parcelHelpers.export(exports, "utcParse", ()=>utcParse);
parcelHelpers.export(exports, "default", ()=>defaultLocale);
var _localeJs = require("./locale.js");
var _localeJsDefault = parcelHelpers.interopDefault(_localeJs);
var locale;
var timeFormat;
var timeParse;
var utcFormat;
var utcParse;
defaultLocale({
    dateTime: "%x, %X",
    date: "%-m/%-d/%Y",
    time: "%-I:%M:%S %p",
    periods: [
        "AM",
        "PM"
    ],
    days: [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday"
    ],
    shortDays: [
        "Sun",
        "Mon",
        "Tue",
        "Wed",
        "Thu",
        "Fri",
        "Sat"
    ],
    months: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
    ],
    shortMonths: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec"
    ]
});
function defaultLocale(definition) {
    locale = (0, _localeJsDefault.default)(definition);
    timeFormat = locale.format;
    timeParse = locale.parse;
    utcFormat = locale.utcFormat;
    utcParse = locale.utcParse;
    return locale;
}

},{"./locale.js":"8B5N5","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8B5N5":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>formatLocale);
var _d3Time = require("d3-time");
function localDate(d) {
    if (0 <= d.y && d.y < 100) {
        var date = new Date(-1, d.m, d.d, d.H, d.M, d.S, d.L);
        date.setFullYear(d.y);
        return date;
    }
    return new Date(d.y, d.m, d.d, d.H, d.M, d.S, d.L);
}
function utcDate(d) {
    if (0 <= d.y && d.y < 100) {
        var date = new Date(Date.UTC(-1, d.m, d.d, d.H, d.M, d.S, d.L));
        date.setUTCFullYear(d.y);
        return date;
    }
    return new Date(Date.UTC(d.y, d.m, d.d, d.H, d.M, d.S, d.L));
}
function newDate(y, m, d) {
    return {
        y: y,
        m: m,
        d: d,
        H: 0,
        M: 0,
        S: 0,
        L: 0
    };
}
function formatLocale(locale) {
    var locale_dateTime = locale.dateTime, locale_date = locale.date, locale_time = locale.time, locale_periods = locale.periods, locale_weekdays = locale.days, locale_shortWeekdays = locale.shortDays, locale_months = locale.months, locale_shortMonths = locale.shortMonths;
    var periodRe = formatRe(locale_periods), periodLookup = formatLookup(locale_periods), weekdayRe = formatRe(locale_weekdays), weekdayLookup = formatLookup(locale_weekdays), shortWeekdayRe = formatRe(locale_shortWeekdays), shortWeekdayLookup = formatLookup(locale_shortWeekdays), monthRe = formatRe(locale_months), monthLookup = formatLookup(locale_months), shortMonthRe = formatRe(locale_shortMonths), shortMonthLookup = formatLookup(locale_shortMonths);
    var formats = {
        "a": formatShortWeekday,
        "A": formatWeekday,
        "b": formatShortMonth,
        "B": formatMonth,
        "c": null,
        "d": formatDayOfMonth,
        "e": formatDayOfMonth,
        "f": formatMicroseconds,
        "g": formatYearISO,
        "G": formatFullYearISO,
        "H": formatHour24,
        "I": formatHour12,
        "j": formatDayOfYear,
        "L": formatMilliseconds,
        "m": formatMonthNumber,
        "M": formatMinutes,
        "p": formatPeriod,
        "q": formatQuarter,
        "Q": formatUnixTimestamp,
        "s": formatUnixTimestampSeconds,
        "S": formatSeconds,
        "u": formatWeekdayNumberMonday,
        "U": formatWeekNumberSunday,
        "V": formatWeekNumberISO,
        "w": formatWeekdayNumberSunday,
        "W": formatWeekNumberMonday,
        "x": null,
        "X": null,
        "y": formatYear,
        "Y": formatFullYear,
        "Z": formatZone,
        "%": formatLiteralPercent
    };
    var utcFormats = {
        "a": formatUTCShortWeekday,
        "A": formatUTCWeekday,
        "b": formatUTCShortMonth,
        "B": formatUTCMonth,
        "c": null,
        "d": formatUTCDayOfMonth,
        "e": formatUTCDayOfMonth,
        "f": formatUTCMicroseconds,
        "g": formatUTCYearISO,
        "G": formatUTCFullYearISO,
        "H": formatUTCHour24,
        "I": formatUTCHour12,
        "j": formatUTCDayOfYear,
        "L": formatUTCMilliseconds,
        "m": formatUTCMonthNumber,
        "M": formatUTCMinutes,
        "p": formatUTCPeriod,
        "q": formatUTCQuarter,
        "Q": formatUnixTimestamp,
        "s": formatUnixTimestampSeconds,
        "S": formatUTCSeconds,
        "u": formatUTCWeekdayNumberMonday,
        "U": formatUTCWeekNumberSunday,
        "V": formatUTCWeekNumberISO,
        "w": formatUTCWeekdayNumberSunday,
        "W": formatUTCWeekNumberMonday,
        "x": null,
        "X": null,
        "y": formatUTCYear,
        "Y": formatUTCFullYear,
        "Z": formatUTCZone,
        "%": formatLiteralPercent
    };
    var parses = {
        "a": parseShortWeekday,
        "A": parseWeekday,
        "b": parseShortMonth,
        "B": parseMonth,
        "c": parseLocaleDateTime,
        "d": parseDayOfMonth,
        "e": parseDayOfMonth,
        "f": parseMicroseconds,
        "g": parseYear,
        "G": parseFullYear,
        "H": parseHour24,
        "I": parseHour24,
        "j": parseDayOfYear,
        "L": parseMilliseconds,
        "m": parseMonthNumber,
        "M": parseMinutes,
        "p": parsePeriod,
        "q": parseQuarter,
        "Q": parseUnixTimestamp,
        "s": parseUnixTimestampSeconds,
        "S": parseSeconds,
        "u": parseWeekdayNumberMonday,
        "U": parseWeekNumberSunday,
        "V": parseWeekNumberISO,
        "w": parseWeekdayNumberSunday,
        "W": parseWeekNumberMonday,
        "x": parseLocaleDate,
        "X": parseLocaleTime,
        "y": parseYear,
        "Y": parseFullYear,
        "Z": parseZone,
        "%": parseLiteralPercent
    };
    // These recursive directive definitions must be deferred.
    formats.x = newFormat(locale_date, formats);
    formats.X = newFormat(locale_time, formats);
    formats.c = newFormat(locale_dateTime, formats);
    utcFormats.x = newFormat(locale_date, utcFormats);
    utcFormats.X = newFormat(locale_time, utcFormats);
    utcFormats.c = newFormat(locale_dateTime, utcFormats);
    function newFormat(specifier, formats) {
        return function(date) {
            var string = [], i = -1, j = 0, n = specifier.length, c, pad, format;
            if (!(date instanceof Date)) date = new Date(+date);
            while(++i < n)if (specifier.charCodeAt(i) === 37) {
                string.push(specifier.slice(j, i));
                if ((pad = pads[c = specifier.charAt(++i)]) != null) c = specifier.charAt(++i);
                else pad = c === "e" ? " " : "0";
                if (format = formats[c]) c = format(date, pad);
                string.push(c);
                j = i + 1;
            }
            string.push(specifier.slice(j, i));
            return string.join("");
        };
    }
    function newParse(specifier, Z) {
        return function(string) {
            var d = newDate(1900, undefined, 1), i = parseSpecifier(d, specifier, string += "", 0), week, day;
            if (i != string.length) return null;
            // If a UNIX timestamp is specified, return it.
            if ("Q" in d) return new Date(d.Q);
            if ("s" in d) return new Date(d.s * 1000 + ("L" in d ? d.L : 0));
            // If this is utcParse, never use the local timezone.
            if (Z && !("Z" in d)) d.Z = 0;
            // The am-pm flag is 0 for AM, and 1 for PM.
            if ("p" in d) d.H = d.H % 12 + d.p * 12;
            // If the month was not specified, inherit from the quarter.
            if (d.m === undefined) d.m = "q" in d ? d.q : 0;
            // Convert day-of-week and week-of-year to day-of-year.
            if ("V" in d) {
                if (d.V < 1 || d.V > 53) return null;
                if (!("w" in d)) d.w = 1;
                if ("Z" in d) {
                    week = utcDate(newDate(d.y, 0, 1)), day = week.getUTCDay();
                    week = day > 4 || day === 0 ? (0, _d3Time.utcMonday).ceil(week) : (0, _d3Time.utcMonday)(week);
                    week = (0, _d3Time.utcDay).offset(week, (d.V - 1) * 7);
                    d.y = week.getUTCFullYear();
                    d.m = week.getUTCMonth();
                    d.d = week.getUTCDate() + (d.w + 6) % 7;
                } else {
                    week = localDate(newDate(d.y, 0, 1)), day = week.getDay();
                    week = day > 4 || day === 0 ? (0, _d3Time.timeMonday).ceil(week) : (0, _d3Time.timeMonday)(week);
                    week = (0, _d3Time.timeDay).offset(week, (d.V - 1) * 7);
                    d.y = week.getFullYear();
                    d.m = week.getMonth();
                    d.d = week.getDate() + (d.w + 6) % 7;
                }
            } else if ("W" in d || "U" in d) {
                if (!("w" in d)) d.w = "u" in d ? d.u % 7 : "W" in d ? 1 : 0;
                day = "Z" in d ? utcDate(newDate(d.y, 0, 1)).getUTCDay() : localDate(newDate(d.y, 0, 1)).getDay();
                d.m = 0;
                d.d = "W" in d ? (d.w + 6) % 7 + d.W * 7 - (day + 5) % 7 : d.w + d.U * 7 - (day + 6) % 7;
            }
            // If a time zone is specified, all fields are interpreted as UTC and then
            // offset according to the specified time zone.
            if ("Z" in d) {
                d.H += d.Z / 100 | 0;
                d.M += d.Z % 100;
                return utcDate(d);
            }
            // Otherwise, all fields are in local time.
            return localDate(d);
        };
    }
    function parseSpecifier(d, specifier, string, j) {
        var i = 0, n = specifier.length, m = string.length, c, parse;
        while(i < n){
            if (j >= m) return -1;
            c = specifier.charCodeAt(i++);
            if (c === 37) {
                c = specifier.charAt(i++);
                parse = parses[c in pads ? specifier.charAt(i++) : c];
                if (!parse || (j = parse(d, string, j)) < 0) return -1;
            } else if (c != string.charCodeAt(j++)) return -1;
        }
        return j;
    }
    function parsePeriod(d, string, i) {
        var n = periodRe.exec(string.slice(i));
        return n ? (d.p = periodLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function parseShortWeekday(d, string, i) {
        var n = shortWeekdayRe.exec(string.slice(i));
        return n ? (d.w = shortWeekdayLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function parseWeekday(d, string, i) {
        var n = weekdayRe.exec(string.slice(i));
        return n ? (d.w = weekdayLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function parseShortMonth(d, string, i) {
        var n = shortMonthRe.exec(string.slice(i));
        return n ? (d.m = shortMonthLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function parseMonth(d, string, i) {
        var n = monthRe.exec(string.slice(i));
        return n ? (d.m = monthLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function parseLocaleDateTime(d, string, i) {
        return parseSpecifier(d, locale_dateTime, string, i);
    }
    function parseLocaleDate(d, string, i) {
        return parseSpecifier(d, locale_date, string, i);
    }
    function parseLocaleTime(d, string, i) {
        return parseSpecifier(d, locale_time, string, i);
    }
    function formatShortWeekday(d) {
        return locale_shortWeekdays[d.getDay()];
    }
    function formatWeekday(d) {
        return locale_weekdays[d.getDay()];
    }
    function formatShortMonth(d) {
        return locale_shortMonths[d.getMonth()];
    }
    function formatMonth(d) {
        return locale_months[d.getMonth()];
    }
    function formatPeriod(d) {
        return locale_periods[+(d.getHours() >= 12)];
    }
    function formatQuarter(d) {
        return 1 + ~~(d.getMonth() / 3);
    }
    function formatUTCShortWeekday(d) {
        return locale_shortWeekdays[d.getUTCDay()];
    }
    function formatUTCWeekday(d) {
        return locale_weekdays[d.getUTCDay()];
    }
    function formatUTCShortMonth(d) {
        return locale_shortMonths[d.getUTCMonth()];
    }
    function formatUTCMonth(d) {
        return locale_months[d.getUTCMonth()];
    }
    function formatUTCPeriod(d) {
        return locale_periods[+(d.getUTCHours() >= 12)];
    }
    function formatUTCQuarter(d) {
        return 1 + ~~(d.getUTCMonth() / 3);
    }
    return {
        format: function(specifier) {
            var f = newFormat(specifier += "", formats);
            f.toString = function() {
                return specifier;
            };
            return f;
        },
        parse: function(specifier) {
            var p = newParse(specifier += "", false);
            p.toString = function() {
                return specifier;
            };
            return p;
        },
        utcFormat: function(specifier) {
            var f = newFormat(specifier += "", utcFormats);
            f.toString = function() {
                return specifier;
            };
            return f;
        },
        utcParse: function(specifier) {
            var p = newParse(specifier += "", true);
            p.toString = function() {
                return specifier;
            };
            return p;
        }
    };
}
var pads = {
    "-": "",
    "_": " ",
    "0": "0"
}, numberRe = /^\s*\d+/, percentRe = /^%/, requoteRe = /[\\^$*+?|[\]().{}]/g;
function pad(value, fill, width) {
    var sign = value < 0 ? "-" : "", string = (sign ? -value : value) + "", length = string.length;
    return sign + (length < width ? new Array(width - length + 1).join(fill) + string : string);
}
function requote(s) {
    return s.replace(requoteRe, "\\$&");
}
function formatRe(names) {
    return new RegExp("^(?:" + names.map(requote).join("|") + ")", "i");
}
function formatLookup(names) {
    return new Map(names.map((name, i)=>[
            name.toLowerCase(),
            i
        ]));
}
function parseWeekdayNumberSunday(d, string, i) {
    var n = numberRe.exec(string.slice(i, i + 1));
    return n ? (d.w = +n[0], i + n[0].length) : -1;
}
function parseWeekdayNumberMonday(d, string, i) {
    var n = numberRe.exec(string.slice(i, i + 1));
    return n ? (d.u = +n[0], i + n[0].length) : -1;
}
function parseWeekNumberSunday(d, string, i) {
    var n = numberRe.exec(string.slice(i, i + 2));
    return n ? (d.U = +n[0], i + n[0].length) : -1;
}
function parseWeekNumberISO(d, string, i) {
    var n = numberRe.exec(string.slice(i, i + 2));
    return n ? (d.V = +n[0], i + n[0].length) : -1;
}
function parseWeekNumberMonday(d, string, i) {
    var n = numberRe.exec(string.slice(i, i + 2));
    return n ? (d.W = +n[0], i + n[0].length) : -1;
}
function parseFullYear(d, string, i) {
    var n = numberRe.exec(string.slice(i, i + 4));
    return n ? (d.y = +n[0], i + n[0].length) : -1;
}
function parseYear(d, string, i) {
    var n = numberRe.exec(string.slice(i, i + 2));
    return n ? (d.y = +n[0] + (+n[0] > 68 ? 1900 : 2000), i + n[0].length) : -1;
}
function parseZone(d, string, i) {
    var n = /^(Z)|([+-]\d\d)(?::?(\d\d))?/.exec(string.slice(i, i + 6));
    return n ? (d.Z = n[1] ? 0 : -(n[2] + (n[3] || "00")), i + n[0].length) : -1;
}
function parseQuarter(d, string, i) {
    var n = numberRe.exec(string.slice(i, i + 1));
    return n ? (d.q = n[0] * 3 - 3, i + n[0].length) : -1;
}
function parseMonthNumber(d, string, i) {
    var n = numberRe.exec(string.slice(i, i + 2));
    return n ? (d.m = n[0] - 1, i + n[0].length) : -1;
}
function parseDayOfMonth(d, string, i) {
    var n = numberRe.exec(string.slice(i, i + 2));
    return n ? (d.d = +n[0], i + n[0].length) : -1;
}
function parseDayOfYear(d, string, i) {
    var n = numberRe.exec(string.slice(i, i + 3));
    return n ? (d.m = 0, d.d = +n[0], i + n[0].length) : -1;
}
function parseHour24(d, string, i) {
    var n = numberRe.exec(string.slice(i, i + 2));
    return n ? (d.H = +n[0], i + n[0].length) : -1;
}
function parseMinutes(d, string, i) {
    var n = numberRe.exec(string.slice(i, i + 2));
    return n ? (d.M = +n[0], i + n[0].length) : -1;
}
function parseSeconds(d, string, i) {
    var n = numberRe.exec(string.slice(i, i + 2));
    return n ? (d.S = +n[0], i + n[0].length) : -1;
}
function parseMilliseconds(d, string, i) {
    var n = numberRe.exec(string.slice(i, i + 3));
    return n ? (d.L = +n[0], i + n[0].length) : -1;
}
function parseMicroseconds(d, string, i) {
    var n = numberRe.exec(string.slice(i, i + 6));
    return n ? (d.L = Math.floor(n[0] / 1000), i + n[0].length) : -1;
}
function parseLiteralPercent(d, string, i) {
    var n = percentRe.exec(string.slice(i, i + 1));
    return n ? i + n[0].length : -1;
}
function parseUnixTimestamp(d, string, i) {
    var n = numberRe.exec(string.slice(i));
    return n ? (d.Q = +n[0], i + n[0].length) : -1;
}
function parseUnixTimestampSeconds(d, string, i) {
    var n = numberRe.exec(string.slice(i));
    return n ? (d.s = +n[0], i + n[0].length) : -1;
}
function formatDayOfMonth(d, p) {
    return pad(d.getDate(), p, 2);
}
function formatHour24(d, p) {
    return pad(d.getHours(), p, 2);
}
function formatHour12(d, p) {
    return pad(d.getHours() % 12 || 12, p, 2);
}
function formatDayOfYear(d, p) {
    return pad(1 + (0, _d3Time.timeDay).count((0, _d3Time.timeYear)(d), d), p, 3);
}
function formatMilliseconds(d, p) {
    return pad(d.getMilliseconds(), p, 3);
}
function formatMicroseconds(d, p) {
    return formatMilliseconds(d, p) + "000";
}
function formatMonthNumber(d, p) {
    return pad(d.getMonth() + 1, p, 2);
}
function formatMinutes(d, p) {
    return pad(d.getMinutes(), p, 2);
}
function formatSeconds(d, p) {
    return pad(d.getSeconds(), p, 2);
}
function formatWeekdayNumberMonday(d) {
    var day = d.getDay();
    return day === 0 ? 7 : day;
}
function formatWeekNumberSunday(d, p) {
    return pad((0, _d3Time.timeSunday).count((0, _d3Time.timeYear)(d) - 1, d), p, 2);
}
function dISO(d) {
    var day = d.getDay();
    return day >= 4 || day === 0 ? (0, _d3Time.timeThursday)(d) : (0, _d3Time.timeThursday).ceil(d);
}
function formatWeekNumberISO(d, p) {
    d = dISO(d);
    return pad((0, _d3Time.timeThursday).count((0, _d3Time.timeYear)(d), d) + ((0, _d3Time.timeYear)(d).getDay() === 4), p, 2);
}
function formatWeekdayNumberSunday(d) {
    return d.getDay();
}
function formatWeekNumberMonday(d, p) {
    return pad((0, _d3Time.timeMonday).count((0, _d3Time.timeYear)(d) - 1, d), p, 2);
}
function formatYear(d, p) {
    return pad(d.getFullYear() % 100, p, 2);
}
function formatYearISO(d, p) {
    d = dISO(d);
    return pad(d.getFullYear() % 100, p, 2);
}
function formatFullYear(d, p) {
    return pad(d.getFullYear() % 10000, p, 4);
}
function formatFullYearISO(d, p) {
    var day = d.getDay();
    d = day >= 4 || day === 0 ? (0, _d3Time.timeThursday)(d) : (0, _d3Time.timeThursday).ceil(d);
    return pad(d.getFullYear() % 10000, p, 4);
}
function formatZone(d) {
    var z = d.getTimezoneOffset();
    return (z > 0 ? "-" : (z *= -1, "+")) + pad(z / 60 | 0, "0", 2) + pad(z % 60, "0", 2);
}
function formatUTCDayOfMonth(d, p) {
    return pad(d.getUTCDate(), p, 2);
}
function formatUTCHour24(d, p) {
    return pad(d.getUTCHours(), p, 2);
}
function formatUTCHour12(d, p) {
    return pad(d.getUTCHours() % 12 || 12, p, 2);
}
function formatUTCDayOfYear(d, p) {
    return pad(1 + (0, _d3Time.utcDay).count((0, _d3Time.utcYear)(d), d), p, 3);
}
function formatUTCMilliseconds(d, p) {
    return pad(d.getUTCMilliseconds(), p, 3);
}
function formatUTCMicroseconds(d, p) {
    return formatUTCMilliseconds(d, p) + "000";
}
function formatUTCMonthNumber(d, p) {
    return pad(d.getUTCMonth() + 1, p, 2);
}
function formatUTCMinutes(d, p) {
    return pad(d.getUTCMinutes(), p, 2);
}
function formatUTCSeconds(d, p) {
    return pad(d.getUTCSeconds(), p, 2);
}
function formatUTCWeekdayNumberMonday(d) {
    var dow = d.getUTCDay();
    return dow === 0 ? 7 : dow;
}
function formatUTCWeekNumberSunday(d, p) {
    return pad((0, _d3Time.utcSunday).count((0, _d3Time.utcYear)(d) - 1, d), p, 2);
}
function UTCdISO(d) {
    var day = d.getUTCDay();
    return day >= 4 || day === 0 ? (0, _d3Time.utcThursday)(d) : (0, _d3Time.utcThursday).ceil(d);
}
function formatUTCWeekNumberISO(d, p) {
    d = UTCdISO(d);
    return pad((0, _d3Time.utcThursday).count((0, _d3Time.utcYear)(d), d) + ((0, _d3Time.utcYear)(d).getUTCDay() === 4), p, 2);
}
function formatUTCWeekdayNumberSunday(d) {
    return d.getUTCDay();
}
function formatUTCWeekNumberMonday(d, p) {
    return pad((0, _d3Time.utcMonday).count((0, _d3Time.utcYear)(d) - 1, d), p, 2);
}
function formatUTCYear(d, p) {
    return pad(d.getUTCFullYear() % 100, p, 2);
}
function formatUTCYearISO(d, p) {
    d = UTCdISO(d);
    return pad(d.getUTCFullYear() % 100, p, 2);
}
function formatUTCFullYear(d, p) {
    return pad(d.getUTCFullYear() % 10000, p, 4);
}
function formatUTCFullYearISO(d, p) {
    var day = d.getUTCDay();
    d = day >= 4 || day === 0 ? (0, _d3Time.utcThursday)(d) : (0, _d3Time.utcThursday).ceil(d);
    return pad(d.getUTCFullYear() % 10000, p, 4);
}
function formatUTCZone() {
    return "+0000";
}
function formatLiteralPercent() {
    return "%";
}
function formatUnixTimestamp(d) {
    return +d;
}
function formatUnixTimestampSeconds(d) {
    return Math.floor(+d / 1000);
}

},{"d3-time":"2sGu6","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2sGu6":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "timeInterval", ()=>(0, _intervalJsDefault.default));
parcelHelpers.export(exports, "timeMillisecond", ()=>(0, _millisecondJsDefault.default));
parcelHelpers.export(exports, "timeMilliseconds", ()=>(0, _millisecondJs.milliseconds));
parcelHelpers.export(exports, "utcMillisecond", ()=>(0, _millisecondJsDefault.default));
parcelHelpers.export(exports, "utcMilliseconds", ()=>(0, _millisecondJs.milliseconds));
parcelHelpers.export(exports, "timeSecond", ()=>(0, _secondJsDefault.default));
parcelHelpers.export(exports, "timeSeconds", ()=>(0, _secondJs.seconds));
parcelHelpers.export(exports, "utcSecond", ()=>(0, _secondJsDefault.default));
parcelHelpers.export(exports, "utcSeconds", ()=>(0, _secondJs.seconds));
parcelHelpers.export(exports, "timeMinute", ()=>(0, _minuteJsDefault.default));
parcelHelpers.export(exports, "timeMinutes", ()=>(0, _minuteJs.minutes));
parcelHelpers.export(exports, "timeHour", ()=>(0, _hourJsDefault.default));
parcelHelpers.export(exports, "timeHours", ()=>(0, _hourJs.hours));
parcelHelpers.export(exports, "timeDay", ()=>(0, _dayJsDefault.default));
parcelHelpers.export(exports, "timeDays", ()=>(0, _dayJs.days));
parcelHelpers.export(exports, "timeWeek", ()=>(0, _weekJs.sunday));
parcelHelpers.export(exports, "timeWeeks", ()=>(0, _weekJs.sundays));
parcelHelpers.export(exports, "timeSunday", ()=>(0, _weekJs.sunday));
parcelHelpers.export(exports, "timeSundays", ()=>(0, _weekJs.sundays));
parcelHelpers.export(exports, "timeMonday", ()=>(0, _weekJs.monday));
parcelHelpers.export(exports, "timeMondays", ()=>(0, _weekJs.mondays));
parcelHelpers.export(exports, "timeTuesday", ()=>(0, _weekJs.tuesday));
parcelHelpers.export(exports, "timeTuesdays", ()=>(0, _weekJs.tuesdays));
parcelHelpers.export(exports, "timeWednesday", ()=>(0, _weekJs.wednesday));
parcelHelpers.export(exports, "timeWednesdays", ()=>(0, _weekJs.wednesdays));
parcelHelpers.export(exports, "timeThursday", ()=>(0, _weekJs.thursday));
parcelHelpers.export(exports, "timeThursdays", ()=>(0, _weekJs.thursdays));
parcelHelpers.export(exports, "timeFriday", ()=>(0, _weekJs.friday));
parcelHelpers.export(exports, "timeFridays", ()=>(0, _weekJs.fridays));
parcelHelpers.export(exports, "timeSaturday", ()=>(0, _weekJs.saturday));
parcelHelpers.export(exports, "timeSaturdays", ()=>(0, _weekJs.saturdays));
parcelHelpers.export(exports, "timeMonth", ()=>(0, _monthJsDefault.default));
parcelHelpers.export(exports, "timeMonths", ()=>(0, _monthJs.months));
parcelHelpers.export(exports, "timeYear", ()=>(0, _yearJsDefault.default));
parcelHelpers.export(exports, "timeYears", ()=>(0, _yearJs.years));
parcelHelpers.export(exports, "utcMinute", ()=>(0, _utcMinuteJsDefault.default));
parcelHelpers.export(exports, "utcMinutes", ()=>(0, _utcMinuteJs.utcMinutes));
parcelHelpers.export(exports, "utcHour", ()=>(0, _utcHourJsDefault.default));
parcelHelpers.export(exports, "utcHours", ()=>(0, _utcHourJs.utcHours));
parcelHelpers.export(exports, "utcDay", ()=>(0, _utcDayJsDefault.default));
parcelHelpers.export(exports, "utcDays", ()=>(0, _utcDayJs.utcDays));
parcelHelpers.export(exports, "utcWeek", ()=>(0, _utcWeekJs.utcSunday));
parcelHelpers.export(exports, "utcWeeks", ()=>(0, _utcWeekJs.utcSundays));
parcelHelpers.export(exports, "utcSunday", ()=>(0, _utcWeekJs.utcSunday));
parcelHelpers.export(exports, "utcSundays", ()=>(0, _utcWeekJs.utcSundays));
parcelHelpers.export(exports, "utcMonday", ()=>(0, _utcWeekJs.utcMonday));
parcelHelpers.export(exports, "utcMondays", ()=>(0, _utcWeekJs.utcMondays));
parcelHelpers.export(exports, "utcTuesday", ()=>(0, _utcWeekJs.utcTuesday));
parcelHelpers.export(exports, "utcTuesdays", ()=>(0, _utcWeekJs.utcTuesdays));
parcelHelpers.export(exports, "utcWednesday", ()=>(0, _utcWeekJs.utcWednesday));
parcelHelpers.export(exports, "utcWednesdays", ()=>(0, _utcWeekJs.utcWednesdays));
parcelHelpers.export(exports, "utcThursday", ()=>(0, _utcWeekJs.utcThursday));
parcelHelpers.export(exports, "utcThursdays", ()=>(0, _utcWeekJs.utcThursdays));
parcelHelpers.export(exports, "utcFriday", ()=>(0, _utcWeekJs.utcFriday));
parcelHelpers.export(exports, "utcFridays", ()=>(0, _utcWeekJs.utcFridays));
parcelHelpers.export(exports, "utcSaturday", ()=>(0, _utcWeekJs.utcSaturday));
parcelHelpers.export(exports, "utcSaturdays", ()=>(0, _utcWeekJs.utcSaturdays));
parcelHelpers.export(exports, "utcMonth", ()=>(0, _utcMonthJsDefault.default));
parcelHelpers.export(exports, "utcMonths", ()=>(0, _utcMonthJs.utcMonths));
parcelHelpers.export(exports, "utcYear", ()=>(0, _utcYearJsDefault.default));
parcelHelpers.export(exports, "utcYears", ()=>(0, _utcYearJs.utcYears));
var _intervalJs = require("./interval.js");
var _intervalJsDefault = parcelHelpers.interopDefault(_intervalJs);
var _millisecondJs = require("./millisecond.js");
var _millisecondJsDefault = parcelHelpers.interopDefault(_millisecondJs);
var _secondJs = require("./second.js");
var _secondJsDefault = parcelHelpers.interopDefault(_secondJs);
var _minuteJs = require("./minute.js");
var _minuteJsDefault = parcelHelpers.interopDefault(_minuteJs);
var _hourJs = require("./hour.js");
var _hourJsDefault = parcelHelpers.interopDefault(_hourJs);
var _dayJs = require("./day.js");
var _dayJsDefault = parcelHelpers.interopDefault(_dayJs);
var _weekJs = require("./week.js");
var _monthJs = require("./month.js");
var _monthJsDefault = parcelHelpers.interopDefault(_monthJs);
var _yearJs = require("./year.js");
var _yearJsDefault = parcelHelpers.interopDefault(_yearJs);
var _utcMinuteJs = require("./utcMinute.js");
var _utcMinuteJsDefault = parcelHelpers.interopDefault(_utcMinuteJs);
var _utcHourJs = require("./utcHour.js");
var _utcHourJsDefault = parcelHelpers.interopDefault(_utcHourJs);
var _utcDayJs = require("./utcDay.js");
var _utcDayJsDefault = parcelHelpers.interopDefault(_utcDayJs);
var _utcWeekJs = require("./utcWeek.js");
var _utcMonthJs = require("./utcMonth.js");
var _utcMonthJsDefault = parcelHelpers.interopDefault(_utcMonthJs);
var _utcYearJs = require("./utcYear.js");
var _utcYearJsDefault = parcelHelpers.interopDefault(_utcYearJs);

},{"./interval.js":"5Ne2N","./millisecond.js":"b25OP","./second.js":"8Xc9m","./minute.js":"fvnSK","./hour.js":"aciVO","./day.js":"8aVya","./week.js":"g5HGY","./month.js":"9kzXt","./year.js":"e8dyM","./utcMinute.js":"8gHTE","./utcHour.js":"bkAwD","./utcDay.js":"65MQO","./utcWeek.js":"8xBiZ","./utcMonth.js":"4okog","./utcYear.js":"2VdZh","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"5Ne2N":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>newInterval);
var t0 = new Date, t1 = new Date;
function newInterval(floori, offseti, count, field) {
    function interval(date) {
        return floori(date = arguments.length === 0 ? new Date : new Date(+date)), date;
    }
    interval.floor = function(date) {
        return floori(date = new Date(+date)), date;
    };
    interval.ceil = function(date) {
        return floori(date = new Date(date - 1)), offseti(date, 1), floori(date), date;
    };
    interval.round = function(date) {
        var d0 = interval(date), d1 = interval.ceil(date);
        return date - d0 < d1 - date ? d0 : d1;
    };
    interval.offset = function(date, step) {
        return offseti(date = new Date(+date), step == null ? 1 : Math.floor(step)), date;
    };
    interval.range = function(start, stop, step) {
        var range = [], previous;
        start = interval.ceil(start);
        step = step == null ? 1 : Math.floor(step);
        if (!(start < stop) || !(step > 0)) return range; // also handles Invalid Date
        do range.push(previous = new Date(+start)), offseti(start, step), floori(start);
        while (previous < start && start < stop);
        return range;
    };
    interval.filter = function(test) {
        return newInterval(function(date) {
            if (date >= date) while(floori(date), !test(date))date.setTime(date - 1);
        }, function(date, step) {
            if (date >= date) {
                if (step < 0) while(++step <= 0){
                    while(offseti(date, -1), !test(date)); // eslint-disable-line no-empty
                }
                else while(--step >= 0){
                    while(offseti(date, 1), !test(date)); // eslint-disable-line no-empty
                }
            }
        });
    };
    if (count) {
        interval.count = function(start, end) {
            t0.setTime(+start), t1.setTime(+end);
            floori(t0), floori(t1);
            return Math.floor(count(t0, t1));
        };
        interval.every = function(step) {
            step = Math.floor(step);
            return !isFinite(step) || !(step > 0) ? null : !(step > 1) ? interval : interval.filter(field ? function(d) {
                return field(d) % step === 0;
            } : function(d) {
                return interval.count(0, d) % step === 0;
            });
        };
    }
    return interval;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"b25OP":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "milliseconds", ()=>milliseconds);
var _intervalJs = require("./interval.js");
var _intervalJsDefault = parcelHelpers.interopDefault(_intervalJs);
var millisecond = (0, _intervalJsDefault.default)(function() {
// noop
}, function(date, step) {
    date.setTime(+date + step);
}, function(start, end) {
    return end - start;
});
// An optimized implementation for this simple case.
millisecond.every = function(k) {
    k = Math.floor(k);
    if (!isFinite(k) || !(k > 0)) return null;
    if (!(k > 1)) return millisecond;
    return (0, _intervalJsDefault.default)(function(date) {
        date.setTime(Math.floor(date / k) * k);
    }, function(date, step) {
        date.setTime(+date + step * k);
    }, function(start, end) {
        return (end - start) / k;
    });
};
exports.default = millisecond;
var milliseconds = millisecond.range;

},{"./interval.js":"5Ne2N","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8Xc9m":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "seconds", ()=>seconds);
var _intervalJs = require("./interval.js");
var _intervalJsDefault = parcelHelpers.interopDefault(_intervalJs);
var _durationJs = require("./duration.js");
var second = (0, _intervalJsDefault.default)(function(date) {
    date.setTime(date - date.getMilliseconds());
}, function(date, step) {
    date.setTime(+date + step * (0, _durationJs.durationSecond));
}, function(start, end) {
    return (end - start) / (0, _durationJs.durationSecond);
}, function(date) {
    return date.getUTCSeconds();
});
exports.default = second;
var seconds = second.range;

},{"./interval.js":"5Ne2N","./duration.js":"hBt9s","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hBt9s":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "durationSecond", ()=>durationSecond);
parcelHelpers.export(exports, "durationMinute", ()=>durationMinute);
parcelHelpers.export(exports, "durationHour", ()=>durationHour);
parcelHelpers.export(exports, "durationDay", ()=>durationDay);
parcelHelpers.export(exports, "durationWeek", ()=>durationWeek);
var durationSecond = 1e3;
var durationMinute = 6e4;
var durationHour = 36e5;
var durationDay = 864e5;
var durationWeek = 6048e5;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"fvnSK":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "minutes", ()=>minutes);
var _intervalJs = require("./interval.js");
var _intervalJsDefault = parcelHelpers.interopDefault(_intervalJs);
var _durationJs = require("./duration.js");
var minute = (0, _intervalJsDefault.default)(function(date) {
    date.setTime(date - date.getMilliseconds() - date.getSeconds() * (0, _durationJs.durationSecond));
}, function(date, step) {
    date.setTime(+date + step * (0, _durationJs.durationMinute));
}, function(start, end) {
    return (end - start) / (0, _durationJs.durationMinute);
}, function(date) {
    return date.getMinutes();
});
exports.default = minute;
var minutes = minute.range;

},{"./interval.js":"5Ne2N","./duration.js":"hBt9s","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"aciVO":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "hours", ()=>hours);
var _intervalJs = require("./interval.js");
var _intervalJsDefault = parcelHelpers.interopDefault(_intervalJs);
var _durationJs = require("./duration.js");
var hour = (0, _intervalJsDefault.default)(function(date) {
    date.setTime(date - date.getMilliseconds() - date.getSeconds() * (0, _durationJs.durationSecond) - date.getMinutes() * (0, _durationJs.durationMinute));
}, function(date, step) {
    date.setTime(+date + step * (0, _durationJs.durationHour));
}, function(start, end) {
    return (end - start) / (0, _durationJs.durationHour);
}, function(date) {
    return date.getHours();
});
exports.default = hour;
var hours = hour.range;

},{"./interval.js":"5Ne2N","./duration.js":"hBt9s","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8aVya":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "days", ()=>days);
var _intervalJs = require("./interval.js");
var _intervalJsDefault = parcelHelpers.interopDefault(_intervalJs);
var _durationJs = require("./duration.js");
var day = (0, _intervalJsDefault.default)(function(date) {
    date.setHours(0, 0, 0, 0);
}, function(date, step) {
    date.setDate(date.getDate() + step);
}, function(start, end) {
    return (end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * (0, _durationJs.durationMinute)) / (0, _durationJs.durationDay);
}, function(date) {
    return date.getDate() - 1;
});
exports.default = day;
var days = day.range;

},{"./interval.js":"5Ne2N","./duration.js":"hBt9s","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"g5HGY":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "sunday", ()=>sunday);
parcelHelpers.export(exports, "monday", ()=>monday);
parcelHelpers.export(exports, "tuesday", ()=>tuesday);
parcelHelpers.export(exports, "wednesday", ()=>wednesday);
parcelHelpers.export(exports, "thursday", ()=>thursday);
parcelHelpers.export(exports, "friday", ()=>friday);
parcelHelpers.export(exports, "saturday", ()=>saturday);
parcelHelpers.export(exports, "sundays", ()=>sundays);
parcelHelpers.export(exports, "mondays", ()=>mondays);
parcelHelpers.export(exports, "tuesdays", ()=>tuesdays);
parcelHelpers.export(exports, "wednesdays", ()=>wednesdays);
parcelHelpers.export(exports, "thursdays", ()=>thursdays);
parcelHelpers.export(exports, "fridays", ()=>fridays);
parcelHelpers.export(exports, "saturdays", ()=>saturdays);
var _intervalJs = require("./interval.js");
var _intervalJsDefault = parcelHelpers.interopDefault(_intervalJs);
var _durationJs = require("./duration.js");
function weekday(i) {
    return (0, _intervalJsDefault.default)(function(date) {
        date.setDate(date.getDate() - (date.getDay() + 7 - i) % 7);
        date.setHours(0, 0, 0, 0);
    }, function(date, step) {
        date.setDate(date.getDate() + step * 7);
    }, function(start, end) {
        return (end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * (0, _durationJs.durationMinute)) / (0, _durationJs.durationWeek);
    });
}
var sunday = weekday(0);
var monday = weekday(1);
var tuesday = weekday(2);
var wednesday = weekday(3);
var thursday = weekday(4);
var friday = weekday(5);
var saturday = weekday(6);
var sundays = sunday.range;
var mondays = monday.range;
var tuesdays = tuesday.range;
var wednesdays = wednesday.range;
var thursdays = thursday.range;
var fridays = friday.range;
var saturdays = saturday.range;

},{"./interval.js":"5Ne2N","./duration.js":"hBt9s","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9kzXt":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "months", ()=>months);
var _intervalJs = require("./interval.js");
var _intervalJsDefault = parcelHelpers.interopDefault(_intervalJs);
var month = (0, _intervalJsDefault.default)(function(date) {
    date.setDate(1);
    date.setHours(0, 0, 0, 0);
}, function(date, step) {
    date.setMonth(date.getMonth() + step);
}, function(start, end) {
    return end.getMonth() - start.getMonth() + (end.getFullYear() - start.getFullYear()) * 12;
}, function(date) {
    return date.getMonth();
});
exports.default = month;
var months = month.range;

},{"./interval.js":"5Ne2N","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"e8dyM":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "years", ()=>years);
var _intervalJs = require("./interval.js");
var _intervalJsDefault = parcelHelpers.interopDefault(_intervalJs);
var year = (0, _intervalJsDefault.default)(function(date) {
    date.setMonth(0, 1);
    date.setHours(0, 0, 0, 0);
}, function(date, step) {
    date.setFullYear(date.getFullYear() + step);
}, function(start, end) {
    return end.getFullYear() - start.getFullYear();
}, function(date) {
    return date.getFullYear();
});
// An optimized implementation for this simple case.
year.every = function(k) {
    return !isFinite(k = Math.floor(k)) || !(k > 0) ? null : (0, _intervalJsDefault.default)(function(date) {
        date.setFullYear(Math.floor(date.getFullYear() / k) * k);
        date.setMonth(0, 1);
        date.setHours(0, 0, 0, 0);
    }, function(date, step) {
        date.setFullYear(date.getFullYear() + step * k);
    });
};
exports.default = year;
var years = year.range;

},{"./interval.js":"5Ne2N","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8gHTE":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "utcMinutes", ()=>utcMinutes);
var _intervalJs = require("./interval.js");
var _intervalJsDefault = parcelHelpers.interopDefault(_intervalJs);
var _durationJs = require("./duration.js");
var utcMinute = (0, _intervalJsDefault.default)(function(date) {
    date.setUTCSeconds(0, 0);
}, function(date, step) {
    date.setTime(+date + step * (0, _durationJs.durationMinute));
}, function(start, end) {
    return (end - start) / (0, _durationJs.durationMinute);
}, function(date) {
    return date.getUTCMinutes();
});
exports.default = utcMinute;
var utcMinutes = utcMinute.range;

},{"./interval.js":"5Ne2N","./duration.js":"hBt9s","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"bkAwD":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "utcHours", ()=>utcHours);
var _intervalJs = require("./interval.js");
var _intervalJsDefault = parcelHelpers.interopDefault(_intervalJs);
var _durationJs = require("./duration.js");
var utcHour = (0, _intervalJsDefault.default)(function(date) {
    date.setUTCMinutes(0, 0, 0);
}, function(date, step) {
    date.setTime(+date + step * (0, _durationJs.durationHour));
}, function(start, end) {
    return (end - start) / (0, _durationJs.durationHour);
}, function(date) {
    return date.getUTCHours();
});
exports.default = utcHour;
var utcHours = utcHour.range;

},{"./interval.js":"5Ne2N","./duration.js":"hBt9s","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"65MQO":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "utcDays", ()=>utcDays);
var _intervalJs = require("./interval.js");
var _intervalJsDefault = parcelHelpers.interopDefault(_intervalJs);
var _durationJs = require("./duration.js");
var utcDay = (0, _intervalJsDefault.default)(function(date) {
    date.setUTCHours(0, 0, 0, 0);
}, function(date, step) {
    date.setUTCDate(date.getUTCDate() + step);
}, function(start, end) {
    return (end - start) / (0, _durationJs.durationDay);
}, function(date) {
    return date.getUTCDate() - 1;
});
exports.default = utcDay;
var utcDays = utcDay.range;

},{"./interval.js":"5Ne2N","./duration.js":"hBt9s","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8xBiZ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "utcSunday", ()=>utcSunday);
parcelHelpers.export(exports, "utcMonday", ()=>utcMonday);
parcelHelpers.export(exports, "utcTuesday", ()=>utcTuesday);
parcelHelpers.export(exports, "utcWednesday", ()=>utcWednesday);
parcelHelpers.export(exports, "utcThursday", ()=>utcThursday);
parcelHelpers.export(exports, "utcFriday", ()=>utcFriday);
parcelHelpers.export(exports, "utcSaturday", ()=>utcSaturday);
parcelHelpers.export(exports, "utcSundays", ()=>utcSundays);
parcelHelpers.export(exports, "utcMondays", ()=>utcMondays);
parcelHelpers.export(exports, "utcTuesdays", ()=>utcTuesdays);
parcelHelpers.export(exports, "utcWednesdays", ()=>utcWednesdays);
parcelHelpers.export(exports, "utcThursdays", ()=>utcThursdays);
parcelHelpers.export(exports, "utcFridays", ()=>utcFridays);
parcelHelpers.export(exports, "utcSaturdays", ()=>utcSaturdays);
var _intervalJs = require("./interval.js");
var _intervalJsDefault = parcelHelpers.interopDefault(_intervalJs);
var _durationJs = require("./duration.js");
function utcWeekday(i) {
    return (0, _intervalJsDefault.default)(function(date) {
        date.setUTCDate(date.getUTCDate() - (date.getUTCDay() + 7 - i) % 7);
        date.setUTCHours(0, 0, 0, 0);
    }, function(date, step) {
        date.setUTCDate(date.getUTCDate() + step * 7);
    }, function(start, end) {
        return (end - start) / (0, _durationJs.durationWeek);
    });
}
var utcSunday = utcWeekday(0);
var utcMonday = utcWeekday(1);
var utcTuesday = utcWeekday(2);
var utcWednesday = utcWeekday(3);
var utcThursday = utcWeekday(4);
var utcFriday = utcWeekday(5);
var utcSaturday = utcWeekday(6);
var utcSundays = utcSunday.range;
var utcMondays = utcMonday.range;
var utcTuesdays = utcTuesday.range;
var utcWednesdays = utcWednesday.range;
var utcThursdays = utcThursday.range;
var utcFridays = utcFriday.range;
var utcSaturdays = utcSaturday.range;

},{"./interval.js":"5Ne2N","./duration.js":"hBt9s","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4okog":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "utcMonths", ()=>utcMonths);
var _intervalJs = require("./interval.js");
var _intervalJsDefault = parcelHelpers.interopDefault(_intervalJs);
var utcMonth = (0, _intervalJsDefault.default)(function(date) {
    date.setUTCDate(1);
    date.setUTCHours(0, 0, 0, 0);
}, function(date, step) {
    date.setUTCMonth(date.getUTCMonth() + step);
}, function(start, end) {
    return end.getUTCMonth() - start.getUTCMonth() + (end.getUTCFullYear() - start.getUTCFullYear()) * 12;
}, function(date) {
    return date.getUTCMonth();
});
exports.default = utcMonth;
var utcMonths = utcMonth.range;

},{"./interval.js":"5Ne2N","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2VdZh":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "utcYears", ()=>utcYears);
var _intervalJs = require("./interval.js");
var _intervalJsDefault = parcelHelpers.interopDefault(_intervalJs);
var utcYear = (0, _intervalJsDefault.default)(function(date) {
    date.setUTCMonth(0, 1);
    date.setUTCHours(0, 0, 0, 0);
}, function(date, step) {
    date.setUTCFullYear(date.getUTCFullYear() + step);
}, function(start, end) {
    return end.getUTCFullYear() - start.getUTCFullYear();
}, function(date) {
    return date.getUTCFullYear();
});
// An optimized implementation for this simple case.
utcYear.every = function(k) {
    return !isFinite(k = Math.floor(k)) || !(k > 0) ? null : (0, _intervalJsDefault.default)(function(date) {
        date.setUTCFullYear(Math.floor(date.getUTCFullYear() / k) * k);
        date.setUTCMonth(0, 1);
        date.setUTCHours(0, 0, 0, 0);
    }, function(date, step) {
        date.setUTCFullYear(date.getUTCFullYear() + step * k);
    });
};
exports.default = utcYear;
var utcYears = utcYear.range;

},{"./interval.js":"5Ne2N","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"98eKC":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>utcTime);
var _d3Time = require("d3-time");
var _d3TimeFormat = require("d3-time-format");
var _timeJs = require("./time.js");
var _initJs = require("./init.js");
function utcTime() {
    return (0, _initJs.initRange).apply((0, _timeJs.calendar)((0, _d3Time.utcTicks), (0, _d3Time.utcTickInterval), (0, _d3Time.utcYear), (0, _d3Time.utcMonth), (0, _d3Time.utcWeek), (0, _d3Time.utcDay), (0, _d3Time.utcHour), (0, _d3Time.utcMinute), (0, _d3Time.utcSecond), (0, _d3TimeFormat.utcFormat)).domain([
        Date.UTC(2000, 0, 1),
        Date.UTC(2000, 0, 2)
    ]), arguments);
}

},{"d3-time":"ctZNU","d3-time-format":"1JsiF","./time.js":"fNFf4","./init.js":"MGGB7","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"g41Hh":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "copy", ()=>copy);
parcelHelpers.export(exports, "default", ()=>sequential);
parcelHelpers.export(exports, "sequentialLog", ()=>sequentialLog);
parcelHelpers.export(exports, "sequentialSymlog", ()=>sequentialSymlog);
parcelHelpers.export(exports, "sequentialPow", ()=>sequentialPow);
parcelHelpers.export(exports, "sequentialSqrt", ()=>sequentialSqrt);
var _d3Interpolate = require("d3-interpolate");
var _continuousJs = require("./continuous.js");
var _initJs = require("./init.js");
var _linearJs = require("./linear.js");
var _logJs = require("./log.js");
var _symlogJs = require("./symlog.js");
var _powJs = require("./pow.js");
function transformer() {
    var x0 = 0, x1 = 1, t0, t1, k10, transform, interpolator = (0, _continuousJs.identity), clamp = false, unknown;
    function scale(x) {
        return x == null || isNaN(x = +x) ? unknown : interpolator(k10 === 0 ? 0.5 : (x = (transform(x) - t0) * k10, clamp ? Math.max(0, Math.min(1, x)) : x));
    }
    scale.domain = function(_) {
        return arguments.length ? ([x0, x1] = _, t0 = transform(x0 = +x0), t1 = transform(x1 = +x1), k10 = t0 === t1 ? 0 : 1 / (t1 - t0), scale) : [
            x0,
            x1
        ];
    };
    scale.clamp = function(_) {
        return arguments.length ? (clamp = !!_, scale) : clamp;
    };
    scale.interpolator = function(_) {
        return arguments.length ? (interpolator = _, scale) : interpolator;
    };
    function range(interpolate) {
        return function(_) {
            var r0, r1;
            return arguments.length ? ([r0, r1] = _, interpolator = interpolate(r0, r1), scale) : [
                interpolator(0),
                interpolator(1)
            ];
        };
    }
    scale.range = range((0, _d3Interpolate.interpolate));
    scale.rangeRound = range((0, _d3Interpolate.interpolateRound));
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    return function(t) {
        transform = t, t0 = t(x0), t1 = t(x1), k10 = t0 === t1 ? 0 : 1 / (t1 - t0);
        return scale;
    };
}
function copy(source, target) {
    return target.domain(source.domain()).interpolator(source.interpolator()).clamp(source.clamp()).unknown(source.unknown());
}
function sequential() {
    var scale = (0, _linearJs.linearish)(transformer()((0, _continuousJs.identity)));
    scale.copy = function() {
        return copy(scale, sequential());
    };
    return (0, _initJs.initInterpolator).apply(scale, arguments);
}
function sequentialLog() {
    var scale = (0, _logJs.loggish)(transformer()).domain([
        1,
        10
    ]);
    scale.copy = function() {
        return copy(scale, sequentialLog()).base(scale.base());
    };
    return (0, _initJs.initInterpolator).apply(scale, arguments);
}
function sequentialSymlog() {
    var scale = (0, _symlogJs.symlogish)(transformer());
    scale.copy = function() {
        return copy(scale, sequentialSymlog()).constant(scale.constant());
    };
    return (0, _initJs.initInterpolator).apply(scale, arguments);
}
function sequentialPow() {
    var scale = (0, _powJs.powish)(transformer());
    scale.copy = function() {
        return copy(scale, sequentialPow()).exponent(scale.exponent());
    };
    return (0, _initJs.initInterpolator).apply(scale, arguments);
}
function sequentialSqrt() {
    return sequentialPow.apply(null, arguments).exponent(0.5);
}

},{"d3-interpolate":"6bUMz","./continuous.js":"kDIa7","./init.js":"MGGB7","./linear.js":"5y58A","./log.js":"ie2vG","./symlog.js":"3luv5","./pow.js":"15HKe","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"lGrfG":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>diverging);
parcelHelpers.export(exports, "divergingLog", ()=>divergingLog);
parcelHelpers.export(exports, "divergingSymlog", ()=>divergingSymlog);
parcelHelpers.export(exports, "divergingPow", ()=>divergingPow);
parcelHelpers.export(exports, "divergingSqrt", ()=>divergingSqrt);
var _d3Interpolate = require("d3-interpolate");
var _continuousJs = require("./continuous.js");
var _initJs = require("./init.js");
var _linearJs = require("./linear.js");
var _logJs = require("./log.js");
var _sequentialJs = require("./sequential.js");
var _symlogJs = require("./symlog.js");
var _powJs = require("./pow.js");
function transformer() {
    var x0 = 0, x1 = 0.5, x2 = 1, s = 1, t0, t1, t2, k10, k21, interpolator = (0, _continuousJs.identity), transform, clamp = false, unknown;
    function scale(x) {
        return isNaN(x = +x) ? unknown : (x = 0.5 + ((x = +transform(x)) - t1) * (s * x < s * t1 ? k10 : k21), interpolator(clamp ? Math.max(0, Math.min(1, x)) : x));
    }
    scale.domain = function(_) {
        return arguments.length ? ([x0, x1, x2] = _, t0 = transform(x0 = +x0), t1 = transform(x1 = +x1), t2 = transform(x2 = +x2), k10 = t0 === t1 ? 0 : 0.5 / (t1 - t0), k21 = t1 === t2 ? 0 : 0.5 / (t2 - t1), s = t1 < t0 ? -1 : 1, scale) : [
            x0,
            x1,
            x2
        ];
    };
    scale.clamp = function(_) {
        return arguments.length ? (clamp = !!_, scale) : clamp;
    };
    scale.interpolator = function(_) {
        return arguments.length ? (interpolator = _, scale) : interpolator;
    };
    function range(interpolate) {
        return function(_) {
            var r0, r1, r2;
            return arguments.length ? ([r0, r1, r2] = _, interpolator = (0, _d3Interpolate.piecewise)(interpolate, [
                r0,
                r1,
                r2
            ]), scale) : [
                interpolator(0),
                interpolator(0.5),
                interpolator(1)
            ];
        };
    }
    scale.range = range((0, _d3Interpolate.interpolate));
    scale.rangeRound = range((0, _d3Interpolate.interpolateRound));
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    return function(t) {
        transform = t, t0 = t(x0), t1 = t(x1), t2 = t(x2), k10 = t0 === t1 ? 0 : 0.5 / (t1 - t0), k21 = t1 === t2 ? 0 : 0.5 / (t2 - t1), s = t1 < t0 ? -1 : 1;
        return scale;
    };
}
function diverging() {
    var scale = (0, _linearJs.linearish)(transformer()((0, _continuousJs.identity)));
    scale.copy = function() {
        return (0, _sequentialJs.copy)(scale, diverging());
    };
    return (0, _initJs.initInterpolator).apply(scale, arguments);
}
function divergingLog() {
    var scale = (0, _logJs.loggish)(transformer()).domain([
        0.1,
        1,
        10
    ]);
    scale.copy = function() {
        return (0, _sequentialJs.copy)(scale, divergingLog()).base(scale.base());
    };
    return (0, _initJs.initInterpolator).apply(scale, arguments);
}
function divergingSymlog() {
    var scale = (0, _symlogJs.symlogish)(transformer());
    scale.copy = function() {
        return (0, _sequentialJs.copy)(scale, divergingSymlog()).constant(scale.constant());
    };
    return (0, _initJs.initInterpolator).apply(scale, arguments);
}
function divergingPow() {
    var scale = (0, _powJs.powish)(transformer());
    scale.copy = function() {
        return (0, _sequentialJs.copy)(scale, divergingPow()).exponent(scale.exponent());
    };
    return (0, _initJs.initInterpolator).apply(scale, arguments);
}
function divergingSqrt() {
    return divergingPow.apply(null, arguments).exponent(0.5);
}

},{"d3-interpolate":"6bUMz","./continuous.js":"kDIa7","./init.js":"MGGB7","./linear.js":"5y58A","./log.js":"ie2vG","./sequential.js":"g41Hh","./symlog.js":"3luv5","./pow.js":"15HKe","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3BbmN":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "schemeCategory10", ()=>(0, _category10JsDefault.default));
parcelHelpers.export(exports, "schemeAccent", ()=>(0, _accentJsDefault.default));
parcelHelpers.export(exports, "schemeDark2", ()=>(0, _dark2JsDefault.default));
parcelHelpers.export(exports, "schemeObservable10", ()=>(0, _observable10JsDefault.default));
parcelHelpers.export(exports, "schemePaired", ()=>(0, _pairedJsDefault.default));
parcelHelpers.export(exports, "schemePastel1", ()=>(0, _pastel1JsDefault.default));
parcelHelpers.export(exports, "schemePastel2", ()=>(0, _pastel2JsDefault.default));
parcelHelpers.export(exports, "schemeSet1", ()=>(0, _set1JsDefault.default));
parcelHelpers.export(exports, "schemeSet2", ()=>(0, _set2JsDefault.default));
parcelHelpers.export(exports, "schemeSet3", ()=>(0, _set3JsDefault.default));
parcelHelpers.export(exports, "schemeTableau10", ()=>(0, _tableau10JsDefault.default));
parcelHelpers.export(exports, "interpolateBrBG", ()=>(0, _brBGJsDefault.default));
parcelHelpers.export(exports, "schemeBrBG", ()=>(0, _brBGJs.scheme));
parcelHelpers.export(exports, "interpolatePRGn", ()=>(0, _prgnJsDefault.default));
parcelHelpers.export(exports, "schemePRGn", ()=>(0, _prgnJs.scheme));
parcelHelpers.export(exports, "interpolatePiYG", ()=>(0, _piYGJsDefault.default));
parcelHelpers.export(exports, "schemePiYG", ()=>(0, _piYGJs.scheme));
parcelHelpers.export(exports, "interpolatePuOr", ()=>(0, _puOrJsDefault.default));
parcelHelpers.export(exports, "schemePuOr", ()=>(0, _puOrJs.scheme));
parcelHelpers.export(exports, "interpolateRdBu", ()=>(0, _rdBuJsDefault.default));
parcelHelpers.export(exports, "schemeRdBu", ()=>(0, _rdBuJs.scheme));
parcelHelpers.export(exports, "interpolateRdGy", ()=>(0, _rdGyJsDefault.default));
parcelHelpers.export(exports, "schemeRdGy", ()=>(0, _rdGyJs.scheme));
parcelHelpers.export(exports, "interpolateRdYlBu", ()=>(0, _rdYlBuJsDefault.default));
parcelHelpers.export(exports, "schemeRdYlBu", ()=>(0, _rdYlBuJs.scheme));
parcelHelpers.export(exports, "interpolateRdYlGn", ()=>(0, _rdYlGnJsDefault.default));
parcelHelpers.export(exports, "schemeRdYlGn", ()=>(0, _rdYlGnJs.scheme));
parcelHelpers.export(exports, "interpolateSpectral", ()=>(0, _spectralJsDefault.default));
parcelHelpers.export(exports, "schemeSpectral", ()=>(0, _spectralJs.scheme));
parcelHelpers.export(exports, "interpolateBuGn", ()=>(0, _buGnJsDefault.default));
parcelHelpers.export(exports, "schemeBuGn", ()=>(0, _buGnJs.scheme));
parcelHelpers.export(exports, "interpolateBuPu", ()=>(0, _buPuJsDefault.default));
parcelHelpers.export(exports, "schemeBuPu", ()=>(0, _buPuJs.scheme));
parcelHelpers.export(exports, "interpolateGnBu", ()=>(0, _gnBuJsDefault.default));
parcelHelpers.export(exports, "schemeGnBu", ()=>(0, _gnBuJs.scheme));
parcelHelpers.export(exports, "interpolateOrRd", ()=>(0, _orRdJsDefault.default));
parcelHelpers.export(exports, "schemeOrRd", ()=>(0, _orRdJs.scheme));
parcelHelpers.export(exports, "interpolatePuBuGn", ()=>(0, _puBuGnJsDefault.default));
parcelHelpers.export(exports, "schemePuBuGn", ()=>(0, _puBuGnJs.scheme));
parcelHelpers.export(exports, "interpolatePuBu", ()=>(0, _puBuJsDefault.default));
parcelHelpers.export(exports, "schemePuBu", ()=>(0, _puBuJs.scheme));
parcelHelpers.export(exports, "interpolatePuRd", ()=>(0, _puRdJsDefault.default));
parcelHelpers.export(exports, "schemePuRd", ()=>(0, _puRdJs.scheme));
parcelHelpers.export(exports, "interpolateRdPu", ()=>(0, _rdPuJsDefault.default));
parcelHelpers.export(exports, "schemeRdPu", ()=>(0, _rdPuJs.scheme));
parcelHelpers.export(exports, "interpolateYlGnBu", ()=>(0, _ylGnBuJsDefault.default));
parcelHelpers.export(exports, "schemeYlGnBu", ()=>(0, _ylGnBuJs.scheme));
parcelHelpers.export(exports, "interpolateYlGn", ()=>(0, _ylGnJsDefault.default));
parcelHelpers.export(exports, "schemeYlGn", ()=>(0, _ylGnJs.scheme));
parcelHelpers.export(exports, "interpolateYlOrBr", ()=>(0, _ylOrBrJsDefault.default));
parcelHelpers.export(exports, "schemeYlOrBr", ()=>(0, _ylOrBrJs.scheme));
parcelHelpers.export(exports, "interpolateYlOrRd", ()=>(0, _ylOrRdJsDefault.default));
parcelHelpers.export(exports, "schemeYlOrRd", ()=>(0, _ylOrRdJs.scheme));
parcelHelpers.export(exports, "interpolateBlues", ()=>(0, _bluesJsDefault.default));
parcelHelpers.export(exports, "schemeBlues", ()=>(0, _bluesJs.scheme));
parcelHelpers.export(exports, "interpolateGreens", ()=>(0, _greensJsDefault.default));
parcelHelpers.export(exports, "schemeGreens", ()=>(0, _greensJs.scheme));
parcelHelpers.export(exports, "interpolateGreys", ()=>(0, _greysJsDefault.default));
parcelHelpers.export(exports, "schemeGreys", ()=>(0, _greysJs.scheme));
parcelHelpers.export(exports, "interpolatePurples", ()=>(0, _purplesJsDefault.default));
parcelHelpers.export(exports, "schemePurples", ()=>(0, _purplesJs.scheme));
parcelHelpers.export(exports, "interpolateReds", ()=>(0, _redsJsDefault.default));
parcelHelpers.export(exports, "schemeReds", ()=>(0, _redsJs.scheme));
parcelHelpers.export(exports, "interpolateOranges", ()=>(0, _orangesJsDefault.default));
parcelHelpers.export(exports, "schemeOranges", ()=>(0, _orangesJs.scheme));
parcelHelpers.export(exports, "interpolateCividis", ()=>(0, _cividisJsDefault.default));
parcelHelpers.export(exports, "interpolateCubehelixDefault", ()=>(0, _cubehelixJsDefault.default));
parcelHelpers.export(exports, "interpolateRainbow", ()=>(0, _rainbowJsDefault.default));
parcelHelpers.export(exports, "interpolateWarm", ()=>(0, _rainbowJs.warm));
parcelHelpers.export(exports, "interpolateCool", ()=>(0, _rainbowJs.cool));
parcelHelpers.export(exports, "interpolateSinebow", ()=>(0, _sinebowJsDefault.default));
parcelHelpers.export(exports, "interpolateTurbo", ()=>(0, _turboJsDefault.default));
parcelHelpers.export(exports, "interpolateViridis", ()=>(0, _viridisJsDefault.default));
parcelHelpers.export(exports, "interpolateMagma", ()=>(0, _viridisJs.magma));
parcelHelpers.export(exports, "interpolateInferno", ()=>(0, _viridisJs.inferno));
parcelHelpers.export(exports, "interpolatePlasma", ()=>(0, _viridisJs.plasma));
var _category10Js = require("./categorical/category10.js");
var _category10JsDefault = parcelHelpers.interopDefault(_category10Js);
var _accentJs = require("./categorical/Accent.js");
var _accentJsDefault = parcelHelpers.interopDefault(_accentJs);
var _dark2Js = require("./categorical/Dark2.js");
var _dark2JsDefault = parcelHelpers.interopDefault(_dark2Js);
var _observable10Js = require("./categorical/observable10.js");
var _observable10JsDefault = parcelHelpers.interopDefault(_observable10Js);
var _pairedJs = require("./categorical/Paired.js");
var _pairedJsDefault = parcelHelpers.interopDefault(_pairedJs);
var _pastel1Js = require("./categorical/Pastel1.js");
var _pastel1JsDefault = parcelHelpers.interopDefault(_pastel1Js);
var _pastel2Js = require("./categorical/Pastel2.js");
var _pastel2JsDefault = parcelHelpers.interopDefault(_pastel2Js);
var _set1Js = require("./categorical/Set1.js");
var _set1JsDefault = parcelHelpers.interopDefault(_set1Js);
var _set2Js = require("./categorical/Set2.js");
var _set2JsDefault = parcelHelpers.interopDefault(_set2Js);
var _set3Js = require("./categorical/Set3.js");
var _set3JsDefault = parcelHelpers.interopDefault(_set3Js);
var _tableau10Js = require("./categorical/Tableau10.js");
var _tableau10JsDefault = parcelHelpers.interopDefault(_tableau10Js);
var _brBGJs = require("./diverging/BrBG.js");
var _brBGJsDefault = parcelHelpers.interopDefault(_brBGJs);
var _prgnJs = require("./diverging/PRGn.js");
var _prgnJsDefault = parcelHelpers.interopDefault(_prgnJs);
var _piYGJs = require("./diverging/PiYG.js");
var _piYGJsDefault = parcelHelpers.interopDefault(_piYGJs);
var _puOrJs = require("./diverging/PuOr.js");
var _puOrJsDefault = parcelHelpers.interopDefault(_puOrJs);
var _rdBuJs = require("./diverging/RdBu.js");
var _rdBuJsDefault = parcelHelpers.interopDefault(_rdBuJs);
var _rdGyJs = require("./diverging/RdGy.js");
var _rdGyJsDefault = parcelHelpers.interopDefault(_rdGyJs);
var _rdYlBuJs = require("./diverging/RdYlBu.js");
var _rdYlBuJsDefault = parcelHelpers.interopDefault(_rdYlBuJs);
var _rdYlGnJs = require("./diverging/RdYlGn.js");
var _rdYlGnJsDefault = parcelHelpers.interopDefault(_rdYlGnJs);
var _spectralJs = require("./diverging/Spectral.js");
var _spectralJsDefault = parcelHelpers.interopDefault(_spectralJs);
var _buGnJs = require("./sequential-multi/BuGn.js");
var _buGnJsDefault = parcelHelpers.interopDefault(_buGnJs);
var _buPuJs = require("./sequential-multi/BuPu.js");
var _buPuJsDefault = parcelHelpers.interopDefault(_buPuJs);
var _gnBuJs = require("./sequential-multi/GnBu.js");
var _gnBuJsDefault = parcelHelpers.interopDefault(_gnBuJs);
var _orRdJs = require("./sequential-multi/OrRd.js");
var _orRdJsDefault = parcelHelpers.interopDefault(_orRdJs);
var _puBuGnJs = require("./sequential-multi/PuBuGn.js");
var _puBuGnJsDefault = parcelHelpers.interopDefault(_puBuGnJs);
var _puBuJs = require("./sequential-multi/PuBu.js");
var _puBuJsDefault = parcelHelpers.interopDefault(_puBuJs);
var _puRdJs = require("./sequential-multi/PuRd.js");
var _puRdJsDefault = parcelHelpers.interopDefault(_puRdJs);
var _rdPuJs = require("./sequential-multi/RdPu.js");
var _rdPuJsDefault = parcelHelpers.interopDefault(_rdPuJs);
var _ylGnBuJs = require("./sequential-multi/YlGnBu.js");
var _ylGnBuJsDefault = parcelHelpers.interopDefault(_ylGnBuJs);
var _ylGnJs = require("./sequential-multi/YlGn.js");
var _ylGnJsDefault = parcelHelpers.interopDefault(_ylGnJs);
var _ylOrBrJs = require("./sequential-multi/YlOrBr.js");
var _ylOrBrJsDefault = parcelHelpers.interopDefault(_ylOrBrJs);
var _ylOrRdJs = require("./sequential-multi/YlOrRd.js");
var _ylOrRdJsDefault = parcelHelpers.interopDefault(_ylOrRdJs);
var _bluesJs = require("./sequential-single/Blues.js");
var _bluesJsDefault = parcelHelpers.interopDefault(_bluesJs);
var _greensJs = require("./sequential-single/Greens.js");
var _greensJsDefault = parcelHelpers.interopDefault(_greensJs);
var _greysJs = require("./sequential-single/Greys.js");
var _greysJsDefault = parcelHelpers.interopDefault(_greysJs);
var _purplesJs = require("./sequential-single/Purples.js");
var _purplesJsDefault = parcelHelpers.interopDefault(_purplesJs);
var _redsJs = require("./sequential-single/Reds.js");
var _redsJsDefault = parcelHelpers.interopDefault(_redsJs);
var _orangesJs = require("./sequential-single/Oranges.js");
var _orangesJsDefault = parcelHelpers.interopDefault(_orangesJs);
var _cividisJs = require("./sequential-multi/cividis.js");
var _cividisJsDefault = parcelHelpers.interopDefault(_cividisJs);
var _cubehelixJs = require("./sequential-multi/cubehelix.js");
var _cubehelixJsDefault = parcelHelpers.interopDefault(_cubehelixJs);
var _rainbowJs = require("./sequential-multi/rainbow.js");
var _rainbowJsDefault = parcelHelpers.interopDefault(_rainbowJs);
var _sinebowJs = require("./sequential-multi/sinebow.js");
var _sinebowJsDefault = parcelHelpers.interopDefault(_sinebowJs);
var _turboJs = require("./sequential-multi/turbo.js");
var _turboJsDefault = parcelHelpers.interopDefault(_turboJs);
var _viridisJs = require("./sequential-multi/viridis.js");
var _viridisJsDefault = parcelHelpers.interopDefault(_viridisJs);

},{"./categorical/category10.js":"1T8Lf","./categorical/Accent.js":"az1Ba","./categorical/Dark2.js":"hsCMX","./categorical/observable10.js":false,"./categorical/Paired.js":"lHUvi","./categorical/Pastel1.js":"7ODNA","./categorical/Pastel2.js":"fWbCt","./categorical/Set1.js":"ileVS","./categorical/Set2.js":"dTa0F","./categorical/Set3.js":"1nmER","./categorical/Tableau10.js":"iNodC","./diverging/BrBG.js":"loWV0","./diverging/PRGn.js":"30Rk0","./diverging/PiYG.js":"3lhEK","./diverging/PuOr.js":"ccKPq","./diverging/RdBu.js":"6Jhuk","./diverging/RdGy.js":"7Hhax","./diverging/RdYlBu.js":"7lbDT","./diverging/RdYlGn.js":"9FZGW","./diverging/Spectral.js":"4MCNh","./sequential-multi/BuGn.js":"1TwTg","./sequential-multi/BuPu.js":"j3jES","./sequential-multi/GnBu.js":"bySQe","./sequential-multi/OrRd.js":"8VZnN","./sequential-multi/PuBuGn.js":"2K5Ej","./sequential-multi/PuBu.js":"8fdCd","./sequential-multi/PuRd.js":"aJKkL","./sequential-multi/RdPu.js":"9ySTJ","./sequential-multi/YlGnBu.js":"2TcfG","./sequential-multi/YlGn.js":"hQXZ5","./sequential-multi/YlOrBr.js":"ch1eY","./sequential-multi/YlOrRd.js":"8MjbV","./sequential-single/Blues.js":"jVWkM","./sequential-single/Greens.js":"cfEkZ","./sequential-single/Greys.js":"1xVV2","./sequential-single/Purples.js":"lL1CO","./sequential-single/Reds.js":"kI8hE","./sequential-single/Oranges.js":"0579W","./sequential-multi/cividis.js":"gAYHh","./sequential-multi/cubehelix.js":"eM61s","./sequential-multi/rainbow.js":"gyM7b","./sequential-multi/sinebow.js":"fPIMT","./sequential-multi/turbo.js":"FXmo8","./sequential-multi/viridis.js":"74Dtg","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1T8Lf":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _colorsJs = require("../colors.js");
var _colorsJsDefault = parcelHelpers.interopDefault(_colorsJs);
exports.default = (0, _colorsJsDefault.default)("1f77b4ff7f0e2ca02cd627289467bd8c564be377c27f7f7fbcbd2217becf");

},{"../colors.js":"29Jx6","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"29Jx6":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(specifier) {
        var n = specifier.length / 6 | 0, colors = new Array(n), i = 0;
        while(i < n)colors[i] = "#" + specifier.slice(i * 6, ++i * 6);
        return colors;
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"az1Ba":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _colorsJs = require("../colors.js");
var _colorsJsDefault = parcelHelpers.interopDefault(_colorsJs);
exports.default = (0, _colorsJsDefault.default)("7fc97fbeaed4fdc086ffff99386cb0f0027fbf5b17666666");

},{"../colors.js":"29Jx6","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hsCMX":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _colorsJs = require("../colors.js");
var _colorsJsDefault = parcelHelpers.interopDefault(_colorsJs);
exports.default = (0, _colorsJsDefault.default)("1b9e77d95f027570b3e7298a66a61ee6ab02a6761d666666");

},{"../colors.js":"29Jx6","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"lHUvi":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _colorsJs = require("../colors.js");
var _colorsJsDefault = parcelHelpers.interopDefault(_colorsJs);
exports.default = (0, _colorsJsDefault.default)("a6cee31f78b4b2df8a33a02cfb9a99e31a1cfdbf6fff7f00cab2d66a3d9affff99b15928");

},{"../colors.js":"29Jx6","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7ODNA":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _colorsJs = require("../colors.js");
var _colorsJsDefault = parcelHelpers.interopDefault(_colorsJs);
exports.default = (0, _colorsJsDefault.default)("fbb4aeb3cde3ccebc5decbe4fed9a6ffffcce5d8bdfddaecf2f2f2");

},{"../colors.js":"29Jx6","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"fWbCt":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _colorsJs = require("../colors.js");
var _colorsJsDefault = parcelHelpers.interopDefault(_colorsJs);
exports.default = (0, _colorsJsDefault.default)("b3e2cdfdcdaccbd5e8f4cae4e6f5c9fff2aef1e2cccccccc");

},{"../colors.js":"29Jx6","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"ileVS":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _colorsJs = require("../colors.js");
var _colorsJsDefault = parcelHelpers.interopDefault(_colorsJs);
exports.default = (0, _colorsJsDefault.default)("e41a1c377eb84daf4a984ea3ff7f00ffff33a65628f781bf999999");

},{"../colors.js":"29Jx6","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"dTa0F":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _colorsJs = require("../colors.js");
var _colorsJsDefault = parcelHelpers.interopDefault(_colorsJs);
exports.default = (0, _colorsJsDefault.default)("66c2a5fc8d628da0cbe78ac3a6d854ffd92fe5c494b3b3b3");

},{"../colors.js":"29Jx6","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1nmER":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _colorsJs = require("../colors.js");
var _colorsJsDefault = parcelHelpers.interopDefault(_colorsJs);
exports.default = (0, _colorsJsDefault.default)("8dd3c7ffffb3bebadafb807280b1d3fdb462b3de69fccde5d9d9d9bc80bdccebc5ffed6f");

},{"../colors.js":"29Jx6","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"iNodC":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _colorsJs = require("../colors.js");
var _colorsJsDefault = parcelHelpers.interopDefault(_colorsJs);
exports.default = (0, _colorsJsDefault.default)("4e79a7f28e2ce1575976b7b259a14fedc949af7aa1ff9da79c755fbab0ab");

},{"../colors.js":"29Jx6","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"loWV0":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "scheme", ()=>scheme);
var _colorsJs = require("../colors.js");
var _colorsJsDefault = parcelHelpers.interopDefault(_colorsJs);
var _rampJs = require("../ramp.js");
var _rampJsDefault = parcelHelpers.interopDefault(_rampJs);
var scheme = new Array(3).concat("d8b365f5f5f55ab4ac", "a6611adfc27d80cdc1018571", "a6611adfc27df5f5f580cdc1018571", "8c510ad8b365f6e8c3c7eae55ab4ac01665e", "8c510ad8b365f6e8c3f5f5f5c7eae55ab4ac01665e", "8c510abf812ddfc27df6e8c3c7eae580cdc135978f01665e", "8c510abf812ddfc27df6e8c3f5f5f5c7eae580cdc135978f01665e", "5430058c510abf812ddfc27df6e8c3c7eae580cdc135978f01665e003c30", "5430058c510abf812ddfc27df6e8c3f5f5f5c7eae580cdc135978f01665e003c30").map((0, _colorsJsDefault.default));
exports.default = (0, _rampJsDefault.default)(scheme);

},{"../colors.js":"29Jx6","../ramp.js":"3qYrI","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3qYrI":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _d3Interpolate = require("d3-interpolate");
exports.default = (scheme)=>(0, _d3Interpolate.interpolateRgbBasis)(scheme[scheme.length - 1]);

},{"d3-interpolate":"6bUMz","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"30Rk0":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "scheme", ()=>scheme);
var _colorsJs = require("../colors.js");
var _colorsJsDefault = parcelHelpers.interopDefault(_colorsJs);
var _rampJs = require("../ramp.js");
var _rampJsDefault = parcelHelpers.interopDefault(_rampJs);
var scheme = new Array(3).concat("af8dc3f7f7f77fbf7b", "7b3294c2a5cfa6dba0008837", "7b3294c2a5cff7f7f7a6dba0008837", "762a83af8dc3e7d4e8d9f0d37fbf7b1b7837", "762a83af8dc3e7d4e8f7f7f7d9f0d37fbf7b1b7837", "762a839970abc2a5cfe7d4e8d9f0d3a6dba05aae611b7837", "762a839970abc2a5cfe7d4e8f7f7f7d9f0d3a6dba05aae611b7837", "40004b762a839970abc2a5cfe7d4e8d9f0d3a6dba05aae611b783700441b", "40004b762a839970abc2a5cfe7d4e8f7f7f7d9f0d3a6dba05aae611b783700441b").map((0, _colorsJsDefault.default));
exports.default = (0, _rampJsDefault.default)(scheme);

},{"../colors.js":"29Jx6","../ramp.js":"3qYrI","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3lhEK":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "scheme", ()=>scheme);
var _colorsJs = require("../colors.js");
var _colorsJsDefault = parcelHelpers.interopDefault(_colorsJs);
var _rampJs = require("../ramp.js");
var _rampJsDefault = parcelHelpers.interopDefault(_rampJs);
var scheme = new Array(3).concat("e9a3c9f7f7f7a1d76a", "d01c8bf1b6dab8e1864dac26", "d01c8bf1b6daf7f7f7b8e1864dac26", "c51b7de9a3c9fde0efe6f5d0a1d76a4d9221", "c51b7de9a3c9fde0eff7f7f7e6f5d0a1d76a4d9221", "c51b7dde77aef1b6dafde0efe6f5d0b8e1867fbc414d9221", "c51b7dde77aef1b6dafde0eff7f7f7e6f5d0b8e1867fbc414d9221", "8e0152c51b7dde77aef1b6dafde0efe6f5d0b8e1867fbc414d9221276419", "8e0152c51b7dde77aef1b6dafde0eff7f7f7e6f5d0b8e1867fbc414d9221276419").map((0, _colorsJsDefault.default));
exports.default = (0, _rampJsDefault.default)(scheme);

},{"../colors.js":"29Jx6","../ramp.js":"3qYrI","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"ccKPq":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "scheme", ()=>scheme);
var _colorsJs = require("../colors.js");
var _colorsJsDefault = parcelHelpers.interopDefault(_colorsJs);
var _rampJs = require("../ramp.js");
var _rampJsDefault = parcelHelpers.interopDefault(_rampJs);
var scheme = new Array(3).concat("998ec3f7f7f7f1a340", "5e3c99b2abd2fdb863e66101", "5e3c99b2abd2f7f7f7fdb863e66101", "542788998ec3d8daebfee0b6f1a340b35806", "542788998ec3d8daebf7f7f7fee0b6f1a340b35806", "5427888073acb2abd2d8daebfee0b6fdb863e08214b35806", "5427888073acb2abd2d8daebf7f7f7fee0b6fdb863e08214b35806", "2d004b5427888073acb2abd2d8daebfee0b6fdb863e08214b358067f3b08", "2d004b5427888073acb2abd2d8daebf7f7f7fee0b6fdb863e08214b358067f3b08").map((0, _colorsJsDefault.default));
exports.default = (0, _rampJsDefault.default)(scheme);

},{"../colors.js":"29Jx6","../ramp.js":"3qYrI","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6Jhuk":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "scheme", ()=>scheme);
var _colorsJs = require("../colors.js");
var _colorsJsDefault = parcelHelpers.interopDefault(_colorsJs);
var _rampJs = require("../ramp.js");
var _rampJsDefault = parcelHelpers.interopDefault(_rampJs);
var scheme = new Array(3).concat("ef8a62f7f7f767a9cf", "ca0020f4a58292c5de0571b0", "ca0020f4a582f7f7f792c5de0571b0", "b2182bef8a62fddbc7d1e5f067a9cf2166ac", "b2182bef8a62fddbc7f7f7f7d1e5f067a9cf2166ac", "b2182bd6604df4a582fddbc7d1e5f092c5de4393c32166ac", "b2182bd6604df4a582fddbc7f7f7f7d1e5f092c5de4393c32166ac", "67001fb2182bd6604df4a582fddbc7d1e5f092c5de4393c32166ac053061", "67001fb2182bd6604df4a582fddbc7f7f7f7d1e5f092c5de4393c32166ac053061").map((0, _colorsJsDefault.default));
exports.default = (0, _rampJsDefault.default)(scheme);

},{"../colors.js":"29Jx6","../ramp.js":"3qYrI","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7Hhax":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "scheme", ()=>scheme);
var _colorsJs = require("../colors.js");
var _colorsJsDefault = parcelHelpers.interopDefault(_colorsJs);
var _rampJs = require("../ramp.js");
var _rampJsDefault = parcelHelpers.interopDefault(_rampJs);
var scheme = new Array(3).concat("ef8a62ffffff999999", "ca0020f4a582bababa404040", "ca0020f4a582ffffffbababa404040", "b2182bef8a62fddbc7e0e0e09999994d4d4d", "b2182bef8a62fddbc7ffffffe0e0e09999994d4d4d", "b2182bd6604df4a582fddbc7e0e0e0bababa8787874d4d4d", "b2182bd6604df4a582fddbc7ffffffe0e0e0bababa8787874d4d4d", "67001fb2182bd6604df4a582fddbc7e0e0e0bababa8787874d4d4d1a1a1a", "67001fb2182bd6604df4a582fddbc7ffffffe0e0e0bababa8787874d4d4d1a1a1a").map((0, _colorsJsDefault.default));
exports.default = (0, _rampJsDefault.default)(scheme);

},{"../colors.js":"29Jx6","../ramp.js":"3qYrI","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7lbDT":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "scheme", ()=>scheme);
var _colorsJs = require("../colors.js");
var _colorsJsDefault = parcelHelpers.interopDefault(_colorsJs);
var _rampJs = require("../ramp.js");
var _rampJsDefault = parcelHelpers.interopDefault(_rampJs);
var scheme = new Array(3).concat("fc8d59ffffbf91bfdb", "d7191cfdae61abd9e92c7bb6", "d7191cfdae61ffffbfabd9e92c7bb6", "d73027fc8d59fee090e0f3f891bfdb4575b4", "d73027fc8d59fee090ffffbfe0f3f891bfdb4575b4", "d73027f46d43fdae61fee090e0f3f8abd9e974add14575b4", "d73027f46d43fdae61fee090ffffbfe0f3f8abd9e974add14575b4", "a50026d73027f46d43fdae61fee090e0f3f8abd9e974add14575b4313695", "a50026d73027f46d43fdae61fee090ffffbfe0f3f8abd9e974add14575b4313695").map((0, _colorsJsDefault.default));
exports.default = (0, _rampJsDefault.default)(scheme);

},{"../colors.js":"29Jx6","../ramp.js":"3qYrI","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9FZGW":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "scheme", ()=>scheme);
var _colorsJs = require("../colors.js");
var _colorsJsDefault = parcelHelpers.interopDefault(_colorsJs);
var _rampJs = require("../ramp.js");
var _rampJsDefault = parcelHelpers.interopDefault(_rampJs);
var scheme = new Array(3).concat("fc8d59ffffbf91cf60", "d7191cfdae61a6d96a1a9641", "d7191cfdae61ffffbfa6d96a1a9641", "d73027fc8d59fee08bd9ef8b91cf601a9850", "d73027fc8d59fee08bffffbfd9ef8b91cf601a9850", "d73027f46d43fdae61fee08bd9ef8ba6d96a66bd631a9850", "d73027f46d43fdae61fee08bffffbfd9ef8ba6d96a66bd631a9850", "a50026d73027f46d43fdae61fee08bd9ef8ba6d96a66bd631a9850006837", "a50026d73027f46d43fdae61fee08bffffbfd9ef8ba6d96a66bd631a9850006837").map((0, _colorsJsDefault.default));
exports.default = (0, _rampJsDefault.default)(scheme);

},{"../colors.js":"29Jx6","../ramp.js":"3qYrI","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4MCNh":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "scheme", ()=>scheme);
var _colorsJs = require("../colors.js");
var _colorsJsDefault = parcelHelpers.interopDefault(_colorsJs);
var _rampJs = require("../ramp.js");
var _rampJsDefault = parcelHelpers.interopDefault(_rampJs);
var scheme = new Array(3).concat("fc8d59ffffbf99d594", "d7191cfdae61abdda42b83ba", "d7191cfdae61ffffbfabdda42b83ba", "d53e4ffc8d59fee08be6f59899d5943288bd", "d53e4ffc8d59fee08bffffbfe6f59899d5943288bd", "d53e4ff46d43fdae61fee08be6f598abdda466c2a53288bd", "d53e4ff46d43fdae61fee08bffffbfe6f598abdda466c2a53288bd", "9e0142d53e4ff46d43fdae61fee08be6f598abdda466c2a53288bd5e4fa2", "9e0142d53e4ff46d43fdae61fee08bffffbfe6f598abdda466c2a53288bd5e4fa2").map((0, _colorsJsDefault.default));
exports.default = (0, _rampJsDefault.default)(scheme);

},{"../colors.js":"29Jx6","../ramp.js":"3qYrI","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1TwTg":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "scheme", ()=>scheme);
var _colorsJs = require("../colors.js");
var _colorsJsDefault = parcelHelpers.interopDefault(_colorsJs);
var _rampJs = require("../ramp.js");
var _rampJsDefault = parcelHelpers.interopDefault(_rampJs);
var scheme = new Array(3).concat("e5f5f999d8c92ca25f", "edf8fbb2e2e266c2a4238b45", "edf8fbb2e2e266c2a42ca25f006d2c", "edf8fbccece699d8c966c2a42ca25f006d2c", "edf8fbccece699d8c966c2a441ae76238b45005824", "f7fcfde5f5f9ccece699d8c966c2a441ae76238b45005824", "f7fcfde5f5f9ccece699d8c966c2a441ae76238b45006d2c00441b").map((0, _colorsJsDefault.default));
exports.default = (0, _rampJsDefault.default)(scheme);

},{"../colors.js":"29Jx6","../ramp.js":"3qYrI","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"j3jES":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "scheme", ()=>scheme);
var _colorsJs = require("../colors.js");
var _colorsJsDefault = parcelHelpers.interopDefault(_colorsJs);
var _rampJs = require("../ramp.js");
var _rampJsDefault = parcelHelpers.interopDefault(_rampJs);
var scheme = new Array(3).concat("e0ecf49ebcda8856a7", "edf8fbb3cde38c96c688419d", "edf8fbb3cde38c96c68856a7810f7c", "edf8fbbfd3e69ebcda8c96c68856a7810f7c", "edf8fbbfd3e69ebcda8c96c68c6bb188419d6e016b", "f7fcfde0ecf4bfd3e69ebcda8c96c68c6bb188419d6e016b", "f7fcfde0ecf4bfd3e69ebcda8c96c68c6bb188419d810f7c4d004b").map((0, _colorsJsDefault.default));
exports.default = (0, _rampJsDefault.default)(scheme);

},{"../colors.js":"29Jx6","../ramp.js":"3qYrI","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"bySQe":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "scheme", ()=>scheme);
var _colorsJs = require("../colors.js");
var _colorsJsDefault = parcelHelpers.interopDefault(_colorsJs);
var _rampJs = require("../ramp.js");
var _rampJsDefault = parcelHelpers.interopDefault(_rampJs);
var scheme = new Array(3).concat("e0f3dba8ddb543a2ca", "f0f9e8bae4bc7bccc42b8cbe", "f0f9e8bae4bc7bccc443a2ca0868ac", "f0f9e8ccebc5a8ddb57bccc443a2ca0868ac", "f0f9e8ccebc5a8ddb57bccc44eb3d32b8cbe08589e", "f7fcf0e0f3dbccebc5a8ddb57bccc44eb3d32b8cbe08589e", "f7fcf0e0f3dbccebc5a8ddb57bccc44eb3d32b8cbe0868ac084081").map((0, _colorsJsDefault.default));
exports.default = (0, _rampJsDefault.default)(scheme);

},{"../colors.js":"29Jx6","../ramp.js":"3qYrI","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8VZnN":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "scheme", ()=>scheme);
var _colorsJs = require("../colors.js");
var _colorsJsDefault = parcelHelpers.interopDefault(_colorsJs);
var _rampJs = require("../ramp.js");
var _rampJsDefault = parcelHelpers.interopDefault(_rampJs);
var scheme = new Array(3).concat("fee8c8fdbb84e34a33", "fef0d9fdcc8afc8d59d7301f", "fef0d9fdcc8afc8d59e34a33b30000", "fef0d9fdd49efdbb84fc8d59e34a33b30000", "fef0d9fdd49efdbb84fc8d59ef6548d7301f990000", "fff7ecfee8c8fdd49efdbb84fc8d59ef6548d7301f990000", "fff7ecfee8c8fdd49efdbb84fc8d59ef6548d7301fb300007f0000").map((0, _colorsJsDefault.default));
exports.default = (0, _rampJsDefault.default)(scheme);

},{"../colors.js":"29Jx6","../ramp.js":"3qYrI","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2K5Ej":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "scheme", ()=>scheme);
var _colorsJs = require("../colors.js");
var _colorsJsDefault = parcelHelpers.interopDefault(_colorsJs);
var _rampJs = require("../ramp.js");
var _rampJsDefault = parcelHelpers.interopDefault(_rampJs);
var scheme = new Array(3).concat("ece2f0a6bddb1c9099", "f6eff7bdc9e167a9cf02818a", "f6eff7bdc9e167a9cf1c9099016c59", "f6eff7d0d1e6a6bddb67a9cf1c9099016c59", "f6eff7d0d1e6a6bddb67a9cf3690c002818a016450", "fff7fbece2f0d0d1e6a6bddb67a9cf3690c002818a016450", "fff7fbece2f0d0d1e6a6bddb67a9cf3690c002818a016c59014636").map((0, _colorsJsDefault.default));
exports.default = (0, _rampJsDefault.default)(scheme);

},{"../colors.js":"29Jx6","../ramp.js":"3qYrI","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8fdCd":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "scheme", ()=>scheme);
var _colorsJs = require("../colors.js");
var _colorsJsDefault = parcelHelpers.interopDefault(_colorsJs);
var _rampJs = require("../ramp.js");
var _rampJsDefault = parcelHelpers.interopDefault(_rampJs);
var scheme = new Array(3).concat("ece7f2a6bddb2b8cbe", "f1eef6bdc9e174a9cf0570b0", "f1eef6bdc9e174a9cf2b8cbe045a8d", "f1eef6d0d1e6a6bddb74a9cf2b8cbe045a8d", "f1eef6d0d1e6a6bddb74a9cf3690c00570b0034e7b", "fff7fbece7f2d0d1e6a6bddb74a9cf3690c00570b0034e7b", "fff7fbece7f2d0d1e6a6bddb74a9cf3690c00570b0045a8d023858").map((0, _colorsJsDefault.default));
exports.default = (0, _rampJsDefault.default)(scheme);

},{"../colors.js":"29Jx6","../ramp.js":"3qYrI","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"aJKkL":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "scheme", ()=>scheme);
var _colorsJs = require("../colors.js");
var _colorsJsDefault = parcelHelpers.interopDefault(_colorsJs);
var _rampJs = require("../ramp.js");
var _rampJsDefault = parcelHelpers.interopDefault(_rampJs);
var scheme = new Array(3).concat("e7e1efc994c7dd1c77", "f1eef6d7b5d8df65b0ce1256", "f1eef6d7b5d8df65b0dd1c77980043", "f1eef6d4b9dac994c7df65b0dd1c77980043", "f1eef6d4b9dac994c7df65b0e7298ace125691003f", "f7f4f9e7e1efd4b9dac994c7df65b0e7298ace125691003f", "f7f4f9e7e1efd4b9dac994c7df65b0e7298ace125698004367001f").map((0, _colorsJsDefault.default));
exports.default = (0, _rampJsDefault.default)(scheme);

},{"../colors.js":"29Jx6","../ramp.js":"3qYrI","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9ySTJ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "scheme", ()=>scheme);
var _colorsJs = require("../colors.js");
var _colorsJsDefault = parcelHelpers.interopDefault(_colorsJs);
var _rampJs = require("../ramp.js");
var _rampJsDefault = parcelHelpers.interopDefault(_rampJs);
var scheme = new Array(3).concat("fde0ddfa9fb5c51b8a", "feebe2fbb4b9f768a1ae017e", "feebe2fbb4b9f768a1c51b8a7a0177", "feebe2fcc5c0fa9fb5f768a1c51b8a7a0177", "feebe2fcc5c0fa9fb5f768a1dd3497ae017e7a0177", "fff7f3fde0ddfcc5c0fa9fb5f768a1dd3497ae017e7a0177", "fff7f3fde0ddfcc5c0fa9fb5f768a1dd3497ae017e7a017749006a").map((0, _colorsJsDefault.default));
exports.default = (0, _rampJsDefault.default)(scheme);

},{"../colors.js":"29Jx6","../ramp.js":"3qYrI","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2TcfG":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "scheme", ()=>scheme);
var _colorsJs = require("../colors.js");
var _colorsJsDefault = parcelHelpers.interopDefault(_colorsJs);
var _rampJs = require("../ramp.js");
var _rampJsDefault = parcelHelpers.interopDefault(_rampJs);
var scheme = new Array(3).concat("edf8b17fcdbb2c7fb8", "ffffcca1dab441b6c4225ea8", "ffffcca1dab441b6c42c7fb8253494", "ffffccc7e9b47fcdbb41b6c42c7fb8253494", "ffffccc7e9b47fcdbb41b6c41d91c0225ea80c2c84", "ffffd9edf8b1c7e9b47fcdbb41b6c41d91c0225ea80c2c84", "ffffd9edf8b1c7e9b47fcdbb41b6c41d91c0225ea8253494081d58").map((0, _colorsJsDefault.default));
exports.default = (0, _rampJsDefault.default)(scheme);

},{"../colors.js":"29Jx6","../ramp.js":"3qYrI","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hQXZ5":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "scheme", ()=>scheme);
var _colorsJs = require("../colors.js");
var _colorsJsDefault = parcelHelpers.interopDefault(_colorsJs);
var _rampJs = require("../ramp.js");
var _rampJsDefault = parcelHelpers.interopDefault(_rampJs);
var scheme = new Array(3).concat("f7fcb9addd8e31a354", "ffffccc2e69978c679238443", "ffffccc2e69978c67931a354006837", "ffffccd9f0a3addd8e78c67931a354006837", "ffffccd9f0a3addd8e78c67941ab5d238443005a32", "ffffe5f7fcb9d9f0a3addd8e78c67941ab5d238443005a32", "ffffe5f7fcb9d9f0a3addd8e78c67941ab5d238443006837004529").map((0, _colorsJsDefault.default));
exports.default = (0, _rampJsDefault.default)(scheme);

},{"../colors.js":"29Jx6","../ramp.js":"3qYrI","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"ch1eY":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "scheme", ()=>scheme);
var _colorsJs = require("../colors.js");
var _colorsJsDefault = parcelHelpers.interopDefault(_colorsJs);
var _rampJs = require("../ramp.js");
var _rampJsDefault = parcelHelpers.interopDefault(_rampJs);
var scheme = new Array(3).concat("fff7bcfec44fd95f0e", "ffffd4fed98efe9929cc4c02", "ffffd4fed98efe9929d95f0e993404", "ffffd4fee391fec44ffe9929d95f0e993404", "ffffd4fee391fec44ffe9929ec7014cc4c028c2d04", "ffffe5fff7bcfee391fec44ffe9929ec7014cc4c028c2d04", "ffffe5fff7bcfee391fec44ffe9929ec7014cc4c02993404662506").map((0, _colorsJsDefault.default));
exports.default = (0, _rampJsDefault.default)(scheme);

},{"../colors.js":"29Jx6","../ramp.js":"3qYrI","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8MjbV":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "scheme", ()=>scheme);
var _colorsJs = require("../colors.js");
var _colorsJsDefault = parcelHelpers.interopDefault(_colorsJs);
var _rampJs = require("../ramp.js");
var _rampJsDefault = parcelHelpers.interopDefault(_rampJs);
var scheme = new Array(3).concat("ffeda0feb24cf03b20", "ffffb2fecc5cfd8d3ce31a1c", "ffffb2fecc5cfd8d3cf03b20bd0026", "ffffb2fed976feb24cfd8d3cf03b20bd0026", "ffffb2fed976feb24cfd8d3cfc4e2ae31a1cb10026", "ffffccffeda0fed976feb24cfd8d3cfc4e2ae31a1cb10026", "ffffccffeda0fed976feb24cfd8d3cfc4e2ae31a1cbd0026800026").map((0, _colorsJsDefault.default));
exports.default = (0, _rampJsDefault.default)(scheme);

},{"../colors.js":"29Jx6","../ramp.js":"3qYrI","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jVWkM":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "scheme", ()=>scheme);
var _colorsJs = require("../colors.js");
var _colorsJsDefault = parcelHelpers.interopDefault(_colorsJs);
var _rampJs = require("../ramp.js");
var _rampJsDefault = parcelHelpers.interopDefault(_rampJs);
var scheme = new Array(3).concat("deebf79ecae13182bd", "eff3ffbdd7e76baed62171b5", "eff3ffbdd7e76baed63182bd08519c", "eff3ffc6dbef9ecae16baed63182bd08519c", "eff3ffc6dbef9ecae16baed64292c62171b5084594", "f7fbffdeebf7c6dbef9ecae16baed64292c62171b5084594", "f7fbffdeebf7c6dbef9ecae16baed64292c62171b508519c08306b").map((0, _colorsJsDefault.default));
exports.default = (0, _rampJsDefault.default)(scheme);

},{"../colors.js":"29Jx6","../ramp.js":"3qYrI","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"cfEkZ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "scheme", ()=>scheme);
var _colorsJs = require("../colors.js");
var _colorsJsDefault = parcelHelpers.interopDefault(_colorsJs);
var _rampJs = require("../ramp.js");
var _rampJsDefault = parcelHelpers.interopDefault(_rampJs);
var scheme = new Array(3).concat("e5f5e0a1d99b31a354", "edf8e9bae4b374c476238b45", "edf8e9bae4b374c47631a354006d2c", "edf8e9c7e9c0a1d99b74c47631a354006d2c", "edf8e9c7e9c0a1d99b74c47641ab5d238b45005a32", "f7fcf5e5f5e0c7e9c0a1d99b74c47641ab5d238b45005a32", "f7fcf5e5f5e0c7e9c0a1d99b74c47641ab5d238b45006d2c00441b").map((0, _colorsJsDefault.default));
exports.default = (0, _rampJsDefault.default)(scheme);

},{"../colors.js":"29Jx6","../ramp.js":"3qYrI","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1xVV2":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "scheme", ()=>scheme);
var _colorsJs = require("../colors.js");
var _colorsJsDefault = parcelHelpers.interopDefault(_colorsJs);
var _rampJs = require("../ramp.js");
var _rampJsDefault = parcelHelpers.interopDefault(_rampJs);
var scheme = new Array(3).concat("f0f0f0bdbdbd636363", "f7f7f7cccccc969696525252", "f7f7f7cccccc969696636363252525", "f7f7f7d9d9d9bdbdbd969696636363252525", "f7f7f7d9d9d9bdbdbd969696737373525252252525", "fffffff0f0f0d9d9d9bdbdbd969696737373525252252525", "fffffff0f0f0d9d9d9bdbdbd969696737373525252252525000000").map((0, _colorsJsDefault.default));
exports.default = (0, _rampJsDefault.default)(scheme);

},{"../colors.js":"29Jx6","../ramp.js":"3qYrI","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"lL1CO":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "scheme", ()=>scheme);
var _colorsJs = require("../colors.js");
var _colorsJsDefault = parcelHelpers.interopDefault(_colorsJs);
var _rampJs = require("../ramp.js");
var _rampJsDefault = parcelHelpers.interopDefault(_rampJs);
var scheme = new Array(3).concat("efedf5bcbddc756bb1", "f2f0f7cbc9e29e9ac86a51a3", "f2f0f7cbc9e29e9ac8756bb154278f", "f2f0f7dadaebbcbddc9e9ac8756bb154278f", "f2f0f7dadaebbcbddc9e9ac8807dba6a51a34a1486", "fcfbfdefedf5dadaebbcbddc9e9ac8807dba6a51a34a1486", "fcfbfdefedf5dadaebbcbddc9e9ac8807dba6a51a354278f3f007d").map((0, _colorsJsDefault.default));
exports.default = (0, _rampJsDefault.default)(scheme);

},{"../colors.js":"29Jx6","../ramp.js":"3qYrI","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"kI8hE":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "scheme", ()=>scheme);
var _colorsJs = require("../colors.js");
var _colorsJsDefault = parcelHelpers.interopDefault(_colorsJs);
var _rampJs = require("../ramp.js");
var _rampJsDefault = parcelHelpers.interopDefault(_rampJs);
var scheme = new Array(3).concat("fee0d2fc9272de2d26", "fee5d9fcae91fb6a4acb181d", "fee5d9fcae91fb6a4ade2d26a50f15", "fee5d9fcbba1fc9272fb6a4ade2d26a50f15", "fee5d9fcbba1fc9272fb6a4aef3b2ccb181d99000d", "fff5f0fee0d2fcbba1fc9272fb6a4aef3b2ccb181d99000d", "fff5f0fee0d2fcbba1fc9272fb6a4aef3b2ccb181da50f1567000d").map((0, _colorsJsDefault.default));
exports.default = (0, _rampJsDefault.default)(scheme);

},{"../colors.js":"29Jx6","../ramp.js":"3qYrI","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"0579W":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "scheme", ()=>scheme);
var _colorsJs = require("../colors.js");
var _colorsJsDefault = parcelHelpers.interopDefault(_colorsJs);
var _rampJs = require("../ramp.js");
var _rampJsDefault = parcelHelpers.interopDefault(_rampJs);
var scheme = new Array(3).concat("fee6cefdae6be6550d", "feeddefdbe85fd8d3cd94701", "feeddefdbe85fd8d3ce6550da63603", "feeddefdd0a2fdae6bfd8d3ce6550da63603", "feeddefdd0a2fdae6bfd8d3cf16913d948018c2d04", "fff5ebfee6cefdd0a2fdae6bfd8d3cf16913d948018c2d04", "fff5ebfee6cefdd0a2fdae6bfd8d3cf16913d94801a636037f2704").map((0, _colorsJsDefault.default));
exports.default = (0, _rampJsDefault.default)(scheme);

},{"../colors.js":"29Jx6","../ramp.js":"3qYrI","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"gAYHh":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(t) {
        t = Math.max(0, Math.min(1, t));
        return "rgb(" + Math.max(0, Math.min(255, Math.round(-4.54 - t * (35.34 - t * (2381.73 - t * (6402.7 - t * (7024.72 - t * 2710.57))))))) + ", " + Math.max(0, Math.min(255, Math.round(32.49 + t * (170.73 + t * (52.82 - t * (131.46 - t * (176.58 - t * 67.37))))))) + ", " + Math.max(0, Math.min(255, Math.round(81.24 + t * (442.36 - t * (2482.43 - t * (6167.24 - t * (6614.94 - t * 2475.67))))))) + ")";
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"eM61s":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _d3Color = require("d3-color");
var _d3Interpolate = require("d3-interpolate");
exports.default = (0, _d3Interpolate.interpolateCubehelixLong)((0, _d3Color.cubehelix)(300, 0.5, 0.0), (0, _d3Color.cubehelix)(-240, 0.5, 1.0));

},{"d3-color":"euMEi","d3-interpolate":"6bUMz","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"gyM7b":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "warm", ()=>warm);
parcelHelpers.export(exports, "cool", ()=>cool);
parcelHelpers.export(exports, "default", ()=>function(t) {
        if (t < 0 || t > 1) t -= Math.floor(t);
        var ts = Math.abs(t - 0.5);
        c.h = 360 * t - 100;
        c.s = 1.5 - 1.5 * ts;
        c.l = 0.8 - 0.9 * ts;
        return c + "";
    });
var _d3Color = require("d3-color");
var _d3Interpolate = require("d3-interpolate");
var warm = (0, _d3Interpolate.interpolateCubehelixLong)((0, _d3Color.cubehelix)(-100, 0.75, 0.35), (0, _d3Color.cubehelix)(80, 1.50, 0.8));
var cool = (0, _d3Interpolate.interpolateCubehelixLong)((0, _d3Color.cubehelix)(260, 0.75, 0.35), (0, _d3Color.cubehelix)(80, 1.50, 0.8));
var c = (0, _d3Color.cubehelix)();

},{"d3-color":"euMEi","d3-interpolate":"6bUMz","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"fPIMT":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(t) {
        var x;
        t = (0.5 - t) * Math.PI;
        c.r = 255 * (x = Math.sin(t)) * x;
        c.g = 255 * (x = Math.sin(t + pi_1_3)) * x;
        c.b = 255 * (x = Math.sin(t + pi_2_3)) * x;
        return c + "";
    });
var _d3Color = require("d3-color");
var c = (0, _d3Color.rgb)(), pi_1_3 = Math.PI / 3, pi_2_3 = Math.PI * 2 / 3;

},{"d3-color":"euMEi","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"FXmo8":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(t) {
        t = Math.max(0, Math.min(1, t));
        return "rgb(" + Math.max(0, Math.min(255, Math.round(34.61 + t * (1172.33 - t * (10793.56 - t * (33300.12 - t * (38394.49 - t * 14825.05))))))) + ", " + Math.max(0, Math.min(255, Math.round(23.31 + t * (557.33 + t * (1225.33 - t * (3574.96 - t * (1073.77 + t * 707.56))))))) + ", " + Math.max(0, Math.min(255, Math.round(27.2 + t * (3211.1 - t * (15327.97 - t * (27814 - t * (22569.18 - t * 6838.66))))))) + ")";
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"74Dtg":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "magma", ()=>magma);
parcelHelpers.export(exports, "inferno", ()=>inferno);
parcelHelpers.export(exports, "plasma", ()=>plasma);
var _colorsJs = require("../colors.js");
var _colorsJsDefault = parcelHelpers.interopDefault(_colorsJs);
function ramp(range) {
    var n = range.length;
    return function(t) {
        return range[Math.max(0, Math.min(n - 1, Math.floor(t * n)))];
    };
}
exports.default = ramp((0, _colorsJsDefault.default)("44015444025645045745055946075a46085c460a5d460b5e470d60470e6147106347116447136548146748166848176948186a481a6c481b6d481c6e481d6f481f70482071482173482374482475482576482677482878482979472a7a472c7a472d7b472e7c472f7d46307e46327e46337f463480453581453781453882443983443a83443b84433d84433e85423f854240864241864142874144874045884046883f47883f48893e49893e4a893e4c8a3d4d8a3d4e8a3c4f8a3c508b3b518b3b528b3a538b3a548c39558c39568c38588c38598c375a8c375b8d365c8d365d8d355e8d355f8d34608d34618d33628d33638d32648e32658e31668e31678e31688e30698e306a8e2f6b8e2f6c8e2e6d8e2e6e8e2e6f8e2d708e2d718e2c718e2c728e2c738e2b748e2b758e2a768e2a778e2a788e29798e297a8e297b8e287c8e287d8e277e8e277f8e27808e26818e26828e26828e25838e25848e25858e24868e24878e23888e23898e238a8d228b8d228c8d228d8d218e8d218f8d21908d21918c20928c20928c20938c1f948c1f958b1f968b1f978b1f988b1f998a1f9a8a1e9b8a1e9c891e9d891f9e891f9f881fa0881fa1881fa1871fa28720a38620a48621a58521a68522a78522a88423a98324aa8325ab8225ac8226ad8127ad8128ae8029af7f2ab07f2cb17e2db27d2eb37c2fb47c31b57b32b67a34b67935b77937b87838b9773aba763bbb753dbc743fbc7340bd7242be7144bf7046c06f48c16e4ac16d4cc26c4ec36b50c46a52c56954c56856c66758c7655ac8645cc8635ec96260ca6063cb5f65cb5e67cc5c69cd5b6ccd5a6ece5870cf5773d05675d05477d1537ad1517cd2507fd34e81d34d84d44b86d54989d5488bd6468ed64590d74393d74195d84098d83e9bd93c9dd93ba0da39a2da37a5db36a8db34aadc32addc30b0dd2fb2dd2db5de2bb8de29bade28bddf26c0df25c2df23c5e021c8e020cae11fcde11dd0e11cd2e21bd5e21ad8e219dae319dde318dfe318e2e418e5e419e7e419eae51aece51befe51cf1e51df4e61ef6e620f8e621fbe723fde725"));
var magma = ramp((0, _colorsJsDefault.default)("00000401000501010601010802010902020b02020d03030f03031204041405041606051806051a07061c08071e0907200a08220b09240c09260d0a290e0b2b100b2d110c2f120d31130d34140e36150e38160f3b180f3d19103f1a10421c10441d11471e114920114b21114e22115024125325125527125829115a2a115c2c115f2d11612f116331116533106734106936106b38106c390f6e3b0f703d0f713f0f72400f74420f75440f764510774710784910784a10794c117a4e117b4f127b51127c52137c54137d56147d57157e59157e5a167e5c167f5d177f5f187f601880621980641a80651a80671b80681c816a1c816b1d816d1d816e1e81701f81721f817320817521817621817822817922827b23827c23827e24828025828125818326818426818627818827818928818b29818c29818e2a81902a81912b81932b80942c80962c80982d80992d809b2e7f9c2e7f9e2f7fa02f7fa1307ea3307ea5317ea6317da8327daa337dab337cad347cae347bb0357bb2357bb3367ab5367ab73779b83779ba3878bc3978bd3977bf3a77c03a76c23b75c43c75c53c74c73d73c83e73ca3e72cc3f71cd4071cf4070d0416fd2426fd3436ed5446dd6456cd8456cd9466bdb476adc4869de4968df4a68e04c67e24d66e34e65e44f64e55064e75263e85362e95462ea5661eb5760ec5860ed5a5fee5b5eef5d5ef05f5ef1605df2625df2645cf3655cf4675cf4695cf56b5cf66c5cf66e5cf7705cf7725cf8745cf8765cf9785df9795df97b5dfa7d5efa7f5efa815ffb835ffb8560fb8761fc8961fc8a62fc8c63fc8e64fc9065fd9266fd9467fd9668fd9869fd9a6afd9b6bfe9d6cfe9f6dfea16efea36ffea571fea772fea973feaa74feac76feae77feb078feb27afeb47bfeb67cfeb77efeb97ffebb81febd82febf84fec185fec287fec488fec68afec88cfeca8dfecc8ffecd90fecf92fed194fed395fed597fed799fed89afdda9cfddc9efddea0fde0a1fde2a3fde3a5fde5a7fde7a9fde9aafdebacfcecaefceeb0fcf0b2fcf2b4fcf4b6fcf6b8fcf7b9fcf9bbfcfbbdfcfdbf"));
var inferno = ramp((0, _colorsJsDefault.default)("00000401000501010601010802010a02020c02020e03021004031204031405041706041907051b08051d09061f0a07220b07240c08260d08290e092b10092d110a30120a32140b34150b37160b39180c3c190c3e1b0c411c0c431e0c451f0c48210c4a230c4c240c4f260c51280b53290b552b0b572d0b592f0a5b310a5c320a5e340a5f3609613809623909633b09643d09653e0966400a67420a68440a68450a69470b6a490b6a4a0c6b4c0c6b4d0d6c4f0d6c510e6c520e6d540f6d550f6d57106e59106e5a116e5c126e5d126e5f136e61136e62146e64156e65156e67166e69166e6a176e6c186e6d186e6f196e71196e721a6e741a6e751b6e771c6d781c6d7a1d6d7c1d6d7d1e6d7f1e6c801f6c82206c84206b85216b87216b88226a8a226a8c23698d23698f24699025689225689326679526679727669827669a28659b29649d29649f2a63a02a63a22b62a32c61a52c60a62d60a82e5fa92e5eab2f5ead305dae305cb0315bb1325ab3325ab43359b63458b73557b93556ba3655bc3754bd3853bf3952c03a51c13a50c33b4fc43c4ec63d4dc73e4cc83f4bca404acb4149cc4248ce4347cf4446d04545d24644d34743d44842d54a41d74b3fd84c3ed94d3dda4e3cdb503bdd513ade5238df5337e05536e15635e25734e35933e45a31e55c30e65d2fe75e2ee8602de9612bea632aeb6429eb6628ec6726ed6925ee6a24ef6c23ef6e21f06f20f1711ff1731df2741cf3761bf37819f47918f57b17f57d15f67e14f68013f78212f78410f8850ff8870ef8890cf98b0bf98c0af98e09fa9008fa9207fa9407fb9606fb9706fb9906fb9b06fb9d07fc9f07fca108fca309fca50afca60cfca80dfcaa0ffcac11fcae12fcb014fcb216fcb418fbb61afbb81dfbba1ffbbc21fbbe23fac026fac228fac42afac62df9c72ff9c932f9cb35f8cd37f8cf3af7d13df7d340f6d543f6d746f5d949f5db4cf4dd4ff4df53f4e156f3e35af3e55df2e661f2e865f2ea69f1ec6df1ed71f1ef75f1f179f2f27df2f482f3f586f3f68af4f88ef5f992f6fa96f8fb9af9fc9dfafda1fcffa4"));
var plasma = ramp((0, _colorsJsDefault.default)("0d088710078813078916078a19068c1b068d1d068e20068f2206902406912605912805922a05932c05942e05952f059631059733059735049837049938049a3a049a3c049b3e049c3f049c41049d43039e44039e46039f48039f4903a04b03a14c02a14e02a25002a25102a35302a35502a45601a45801a45901a55b01a55c01a65e01a66001a66100a76300a76400a76600a76700a86900a86a00a86c00a86e00a86f00a87100a87201a87401a87501a87701a87801a87a02a87b02a87d03a87e03a88004a88104a78305a78405a78606a68707a68808a68a09a58b0aa58d0ba58e0ca48f0da4910ea3920fa39410a29511a19613a19814a099159f9a169f9c179e9d189d9e199da01a9ca11b9ba21d9aa31e9aa51f99a62098a72197a82296aa2395ab2494ac2694ad2793ae2892b02991b12a90b22b8fb32c8eb42e8db52f8cb6308bb7318ab83289ba3388bb3488bc3587bd3786be3885bf3984c03a83c13b82c23c81c33d80c43e7fc5407ec6417dc7427cc8437bc9447aca457acb4679cc4778cc4977cd4a76ce4b75cf4c74d04d73d14e72d24f71d35171d45270d5536fd5546ed6556dd7566cd8576bd9586ada5a6ada5b69db5c68dc5d67dd5e66de5f65de6164df6263e06363e16462e26561e26660e3685fe4695ee56a5de56b5de66c5ce76e5be76f5ae87059e97158e97257ea7457eb7556eb7655ec7754ed7953ed7a52ee7b51ef7c51ef7e50f07f4ff0804ef1814df1834cf2844bf3854bf3874af48849f48948f58b47f58c46f68d45f68f44f79044f79143f79342f89441f89540f9973ff9983ef99a3efa9b3dfa9c3cfa9e3bfb9f3afba139fba238fca338fca537fca636fca835fca934fdab33fdac33fdae32fdaf31fdb130fdb22ffdb42ffdb52efeb72dfeb82cfeba2cfebb2bfebd2afebe2afec029fdc229fdc328fdc527fdc627fdc827fdca26fdcb26fccd25fcce25fcd025fcd225fbd324fbd524fbd724fad824fada24f9dc24f9dd25f8df25f8e125f7e225f7e425f6e626f6e826f5e926f5eb27f4ed27f3ee27f3f027f2f227f1f426f1f525f0f724f0f921"));

},{"../colors.js":"29Jx6","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"5Gv7h":[function(require,module,exports) {
/**
 * Gets the last element of `array`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to query.
 * @returns {*} Returns the last element of `array`.
 * @example
 *
 * _.last([1, 2, 3]);
 * // => 3
 */ function last(array) {
    var length = array == null ? 0 : array.length;
    return length ? array[length - 1] : undefined;
}
module.exports = last;

},{}],"b7eTA":[function(require,module,exports) {
var basePick = require("e13834df88faab8"), flatRest = require("7f4b4cdb31764f87");
/**
 * Creates an object composed of the picked `object` properties.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The source object.
 * @param {...(string|string[])} [paths] The property paths to pick.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.pick(object, ['a', 'c']);
 * // => { 'a': 1, 'c': 3 }
 */ var pick = flatRest(function(object, paths) {
    return object == null ? {} : basePick(object, paths);
});
module.exports = pick;

},{"e13834df88faab8":"edqla","7f4b4cdb31764f87":"er0dC"}],"edqla":[function(require,module,exports) {
var basePickBy = require("4620eb0b3c4f1463"), hasIn = require("c697490fd5f67a25");
/**
 * The base implementation of `_.pick` without support for individual
 * property identifiers.
 *
 * @private
 * @param {Object} object The source object.
 * @param {string[]} paths The property paths to pick.
 * @returns {Object} Returns the new object.
 */ function basePick(object, paths) {
    return basePickBy(object, paths, function(value, path) {
        return hasIn(object, path);
    });
}
module.exports = basePick;

},{"4620eb0b3c4f1463":"kExgw","c697490fd5f67a25":"8Kjtp"}],"kExgw":[function(require,module,exports) {
var baseGet = require("d8aa974fba65e61e"), baseSet = require("b07dbab95dca4167"), castPath = require("64b51364f27b9088");
/**
 * The base implementation of  `_.pickBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The source object.
 * @param {string[]} paths The property paths to pick.
 * @param {Function} predicate The function invoked per property.
 * @returns {Object} Returns the new object.
 */ function basePickBy(object, paths, predicate) {
    var index = -1, length = paths.length, result = {};
    while(++index < length){
        var path = paths[index], value = baseGet(object, path);
        if (predicate(value, path)) baseSet(result, castPath(path, object), value);
    }
    return result;
}
module.exports = basePickBy;

},{"d8aa974fba65e61e":"51EsY","b07dbab95dca4167":"k40cK","64b51364f27b9088":"Q3Xos"}],"er0dC":[function(require,module,exports) {
var flatten = require("199f7cbd69032298"), overRest = require("aa5c38699e42775a"), setToString = require("6a66c8b3fbd122d5");
/**
 * A specialized version of `baseRest` which flattens the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @returns {Function} Returns the new function.
 */ function flatRest(func) {
    return setToString(overRest(func, undefined, flatten), func + "");
}
module.exports = flatRest;

},{"199f7cbd69032298":"cBlpT","aa5c38699e42775a":"atctO","6a66c8b3fbd122d5":"dubzo"}],"cBlpT":[function(require,module,exports) {
var baseFlatten = require("a35d6abfacb4b52b");
/**
 * Flattens `array` a single level deep.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to flatten.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * _.flatten([1, [2, [3, [4]], 5]]);
 * // => [1, 2, [3, [4]], 5]
 */ function flatten(array) {
    var length = array == null ? 0 : array.length;
    return length ? baseFlatten(array, 1) : [];
}
module.exports = flatten;

},{"a35d6abfacb4b52b":"9VsYJ"}],"9VsYJ":[function(require,module,exports) {
var arrayPush = require("d752582e5b174691"), isFlattenable = require("ec5f080ebf5764e8");
/**
 * The base implementation of `_.flatten` with support for restricting flattening.
 *
 * @private
 * @param {Array} array The array to flatten.
 * @param {number} depth The maximum recursion depth.
 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
 * @param {Array} [result=[]] The initial result value.
 * @returns {Array} Returns the new flattened array.
 */ function baseFlatten(array, depth, predicate, isStrict, result) {
    var index = -1, length = array.length;
    predicate || (predicate = isFlattenable);
    result || (result = []);
    while(++index < length){
        var value = array[index];
        if (depth > 0 && predicate(value)) {
            if (depth > 1) // Recursively flatten arrays (susceptible to call stack limits).
            baseFlatten(value, depth - 1, predicate, isStrict, result);
            else arrayPush(result, value);
        } else if (!isStrict) result[result.length] = value;
    }
    return result;
}
module.exports = baseFlatten;

},{"d752582e5b174691":"gD9AH","ec5f080ebf5764e8":"bz1Mj"}],"bz1Mj":[function(require,module,exports) {
var Symbol = require("dde07f6ab8ba5eb5"), isArguments = require("ee6f325d7f5309b1"), isArray = require("ff8d93236e335297");
/** Built-in value references. */ var spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined;
/**
 * Checks if `value` is a flattenable `arguments` object or array.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
 */ function isFlattenable(value) {
    return isArray(value) || isArguments(value) || !!(spreadableSymbol && value && value[spreadableSymbol]);
}
module.exports = isFlattenable;

},{"dde07f6ab8ba5eb5":"e0ngr","ee6f325d7f5309b1":"asnYU","ff8d93236e335297":"2VsjV"}],"64pmh":[function(require,module,exports) {
var baseIsEqual = require("7b71d3bc42bb6f3e");
/**
 * Performs a deep comparison between two values to determine if they are
 * equivalent.
 *
 * **Note:** This method supports comparing arrays, array buffers, booleans,
 * date objects, error objects, maps, numbers, `Object` objects, regexes,
 * sets, strings, symbols, and typed arrays. `Object` objects are compared
 * by their own, not inherited, enumerable properties. Functions and DOM
 * nodes are compared by strict equality, i.e. `===`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.isEqual(object, other);
 * // => true
 *
 * object === other;
 * // => false
 */ function isEqual(value, other) {
    return baseIsEqual(value, other);
}
module.exports = isEqual;

},{"7b71d3bc42bb6f3e":"dlEAt"}],"5TAzq":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Axes", ()=>V);
parcelHelpers.export(exports, "Axis", ()=>z);
parcelHelpers.export(exports, "AxisTick", ()=>X);
parcelHelpers.export(exports, "Grid", ()=>j);
parcelHelpers.export(exports, "GridLine", ()=>C);
parcelHelpers.export(exports, "GridLines", ()=>D);
parcelHelpers.export(exports, "NonMemoizedAxis", ()=>B);
parcelHelpers.export(exports, "defaultAxisProps", ()=>Y);
parcelHelpers.export(exports, "positions", ()=>R);
parcelHelpers.export(exports, "renderAxesToCanvas", ()=>W);
parcelHelpers.export(exports, "renderAxisToCanvas", ()=>E);
parcelHelpers.export(exports, "renderGridLinesToCanvas", ()=>q);
var _react = require("react");
var _core = require("@nivo/core");
var _theming = require("@nivo/theming");
var _text = require("@nivo/text");
var _web = require("@react-spring/web");
var _d3TimeFormat = require("d3-time-format");
var _d3Format = require("d3-format");
var _scales = require("@nivo/scales");
var _jsxRuntime = require("react/jsx-runtime");
function A() {
    return A = Object.assign ? Object.assign.bind() : function(t) {
        for(var e = 1; e < arguments.length; e++){
            var i = arguments[e];
            for(var n in i)({}).hasOwnProperty.call(i, n) && (t[n] = i[n]);
        }
        return t;
    }, A.apply(null, arguments);
}
var T = function(t) {
    var e, i = t.axis, n = t.scale, r = t.ticksPosition, o = t.tickValues, l = t.tickSize, c = t.tickPadding, s = t.tickRotation, f = t.truncateTickAt, d = t.engine, u = void 0 === d ? "svg" : d, x = (0, _scales.getScaleTicks)(n, o), m = (0, _core.textPropsByEngine)[u], y = "bandwidth" in n ? (0, _scales.centerScale)(n) : n, g = {
        lineX: 0,
        lineY: 0
    }, v = {
        textX: 0,
        textY: 0
    }, k = "object" == typeof document && "rtl" === document.dir, b = m.align.center, P = m.baseline.center;
    "x" === i ? (e = function(t) {
        var e;
        return {
            x: null != (e = y(t)) ? e : 0,
            y: 0
        };
    }, g.lineY = l * ("after" === r ? 1 : -1), v.textY = (l + c) * ("after" === r ? 1 : -1), P = "after" === r ? m.baseline.top : m.baseline.bottom, 0 === s ? b = m.align.center : "after" === r && s < 0 || "before" === r && s > 0 ? (b = m.align[k ? "left" : "right"], P = m.baseline.center) : ("after" === r && s > 0 || "before" === r && s < 0) && (b = m.align[k ? "right" : "left"], P = m.baseline.center)) : (e = function(t) {
        var e;
        return {
            x: 0,
            y: null != (e = y(t)) ? e : 0
        };
    }, g.lineX = l * ("after" === r ? 1 : -1), v.textX = (l + c) * ("after" === r ? 1 : -1), b = "after" === r ? m.align.left : m.align.right);
    return {
        ticks: x.map(function(t) {
            var i = "string" == typeof t ? function(t) {
                var e = String(t).length;
                return f && f > 0 && e > f ? "" + String(t).slice(0, f).concat("...") : "" + t;
            }(t) : t;
            return A({
                key: t instanceof Date ? "" + t.valueOf() : "" + t,
                value: i
            }, e(t), g, v);
        }),
        textAlign: b,
        textBaseline: P
    };
}, w = function(t, e) {
    if (void 0 === t || "function" == typeof t) return t;
    if ("time" === e.type) {
        var i = (0, _d3TimeFormat.timeFormat)(t);
        return function(t) {
            return i(t instanceof Date ? t : new Date(t));
        };
    }
    return (0, _d3Format.format)(t);
}, O = function(t) {
    var e, i = t.width, n = t.height, r = t.scale, a = t.axis, o = t.values, l = (e = o, Array.isArray(e) ? o : void 0) || (0, _scales.getScaleTicks)(r, o), c = "bandwidth" in r ? (0, _scales.centerScale)(r) : r, s = "x" === a ? l.map(function(t) {
        var e, i;
        return {
            key: t instanceof Date ? "" + t.valueOf() : "" + t,
            x1: null != (e = c(t)) ? e : 0,
            x2: null != (i = c(t)) ? i : 0,
            y1: 0,
            y2: n
        };
    }) : l.map(function(t) {
        var e, n;
        return {
            key: t instanceof Date ? "" + t.valueOf() : "" + t,
            x1: 0,
            x2: i,
            y1: null != (e = c(t)) ? e : 0,
            y2: null != (n = c(t)) ? n : 0
        };
    });
    return s;
}, X = (0, _react.memo)(function(t) {
    var e, n = t.value, r = t.format, a = t.lineX, o = t.lineY, l = t.onClick, c = t.textBaseline, s = t.textAnchor, f = t.theme, u = t.animatedProps, x = null != (e = null == r ? void 0 : r(n)) ? e : n, y = (0, _react.useMemo)(function() {
        var t = {
            opacity: u.opacity
        };
        return l ? {
            style: A({}, t, {
                cursor: "pointer"
            }),
            onClick: function(t) {
                return l(t, x);
            }
        } : {
            style: t
        };
    }, [
        u.opacity,
        l,
        x
    ]);
    return (0, _jsxRuntime.jsxs)((0, _web.animated).g, A({
        transform: u.transform
    }, y, {
        children: [
            (0, _jsxRuntime.jsx)("line", {
                x1: 0,
                x2: a,
                y1: 0,
                y2: o,
                style: f.line
            }),
            (0, _jsxRuntime.jsx)((0, _text.Text), {
                dominantBaseline: c,
                textAnchor: s,
                transform: u.textTransform,
                style: f.text,
                children: "" + x
            })
        ]
    }));
}), Y = {
    tickSize: 5,
    tickPadding: 5,
    tickRotation: 0,
    legendPosition: "middle",
    legendOffset: 0
}, B = function(e) {
    var r = e.axis, a = e.scale, l = e.x, f = void 0 === l ? 0 : l, u = e.y, x = void 0 === u ? 0 : u, v = e.length, k = e.ticksPosition, h = e.tickValues, p = e.tickSize, O = void 0 === p ? Y.tickSize : p, B = e.tickPadding, z = void 0 === B ? Y.tickPadding : B, R = e.tickRotation, V = void 0 === R ? Y.tickRotation : R, C = e.format, D = e.renderTick, j = void 0 === D ? X : D, E = e.truncateTickAt, W = e.legend, q = e.legendPosition, H = void 0 === q ? Y.legendPosition : q, I = e.legendOffset, F = void 0 === I ? Y.legendOffset : I, G = e.style, J = e.onClick, K = e.ariaHidden, L = (0, _theming.useTheme)(), M = (0, _theming.useExtendedAxisTheme)(L.axis, G), N = (0, _react.useMemo)(function() {
        return w(C, a);
    }, [
        C,
        a
    ]), Q = T({
        axis: r,
        scale: a,
        ticksPosition: k,
        tickValues: h,
        tickSize: O,
        tickPadding: z,
        tickRotation: V,
        truncateTickAt: E
    }), U = Q.ticks, Z = Q.textAlign, $ = Q.textBaseline, _ = null;
    if (void 0 !== W) {
        var tt, et = 0, it = 0, nt = 0;
        "y" === r ? (nt = -90, et = F, "start" === H ? (tt = "start", it = v) : "middle" === H ? (tt = "middle", it = v / 2) : "end" === H && (tt = "end")) : (it = F, "start" === H ? tt = "start" : "middle" === H ? (tt = "middle", et = v / 2) : "end" === H && (tt = "end", et = v)), _ = (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
            children: (0, _jsxRuntime.jsx)((0, _text.Text), {
                transform: "translate(" + et + ", " + it + ") rotate(" + nt + ")",
                textAnchor: tt,
                style: A({}, M.legend.text, {
                    dominantBaseline: "central"
                }),
                children: W
            })
        });
    }
    var rt = (0, _core.useMotionConfig)(), at = rt.animate, ot = rt.config, lt = (0, _web.useSpring)({
        transform: "translate(" + f + "," + x + ")",
        lineX2: "x" === r ? v : 0,
        lineY2: "x" === r ? 0 : v,
        config: ot,
        immediate: !at
    }), ct = (0, _react.useCallback)(function(t) {
        return {
            opacity: 1,
            transform: "translate(" + t.x + "," + t.y + ")",
            textTransform: "translate(" + t.textX + "," + t.textY + ") rotate(" + V + ")"
        };
    }, [
        V
    ]), st = (0, _react.useCallback)(function(t) {
        return {
            opacity: 0,
            transform: "translate(" + t.x + "," + t.y + ")",
            textTransform: "translate(" + t.textX + "," + t.textY + ") rotate(" + V + ")"
        };
    }, [
        V
    ]), ft = (0, _web.useTransition)(U, {
        keys: function(t) {
            return t.key;
        },
        initial: ct,
        from: st,
        enter: ct,
        update: ct,
        leave: {
            opacity: 0
        },
        config: ot,
        immediate: !at
    });
    return (0, _jsxRuntime.jsxs)((0, _web.animated).g, {
        transform: lt.transform,
        "aria-hidden": K,
        children: [
            ft(function(e, i, n, r) {
                return _react.createElement(j, A({
                    tickIndex: r,
                    format: N,
                    rotate: V,
                    textBaseline: $,
                    textAnchor: Z,
                    truncateTickAt: E,
                    animatedProps: e,
                    theme: M.ticks
                }, i, J ? {
                    onClick: J
                } : {}));
            }),
            (0, _jsxRuntime.jsx)((0, _web.animated).line, {
                style: M.domain.line,
                x1: 0,
                x2: lt.lineX2,
                y1: 0,
                y2: lt.lineY2
            }),
            _
        ]
    });
}, z = (0, _react.memo)(B), R = [
    "top",
    "right",
    "bottom",
    "left"
], V = (0, _react.memo)(function(t) {
    var e = t.xScale, i = t.yScale, n = t.width, r = t.height, a = {
        top: t.top,
        right: t.right,
        bottom: t.bottom,
        left: t.left
    };
    return (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
        children: R.map(function(t) {
            var o = a[t];
            if (!o) return null;
            var l = "top" === t || "bottom" === t;
            return (0, _jsxRuntime.jsx)(z, A({}, o, {
                axis: l ? "x" : "y",
                x: "right" === t ? n : 0,
                y: "bottom" === t ? r : 0,
                scale: l ? e : i,
                length: l ? n : r,
                ticksPosition: "top" === t || "left" === t ? "before" : "after",
                truncateTickAt: o.truncateTickAt
            }), t);
        })
    });
}), C = (0, _react.memo)(function(t) {
    var e = t.animatedProps, i = (0, _theming.useTheme)();
    return (0, _jsxRuntime.jsx)((0, _web.animated).line, A({}, e, i.grid.line));
}), D = (0, _react.memo)(function(t) {
    var e = t.lines, i = (0, _core.useMotionConfig)(), n = i.animate, a = i.config, l = (0, _web.useTransition)(e, {
        keys: function(t) {
            return t.key;
        },
        initial: function(t) {
            return {
                opacity: 1,
                x1: t.x1,
                x2: t.x2,
                y1: t.y1,
                y2: t.y2
            };
        },
        from: function(t) {
            return {
                opacity: 0,
                x1: t.x1,
                x2: t.x2,
                y1: t.y1,
                y2: t.y2
            };
        },
        enter: function(t) {
            return {
                opacity: 1,
                x1: t.x1,
                x2: t.x2,
                y1: t.y1,
                y2: t.y2
            };
        },
        update: function(t) {
            return {
                opacity: 1,
                x1: t.x1,
                x2: t.x2,
                y1: t.y1,
                y2: t.y2
            };
        },
        leave: {
            opacity: 0
        },
        config: a,
        immediate: !n
    });
    return (0, _jsxRuntime.jsx)("g", {
        children: l(function(t, e) {
            return (0, _react.createElement)(C, A({}, e, {
                key: e.key,
                animatedProps: t
            }));
        })
    });
}), j = (0, _react.memo)(function(t) {
    var e = t.width, n = t.height, r = t.xScale, a = t.yScale, o = t.xValues, l = t.yValues, c = (0, _react.useMemo)(function() {
        return !!r && O({
            width: e,
            height: n,
            scale: r,
            axis: "x",
            values: o
        });
    }, [
        r,
        o,
        e,
        n
    ]), s = (0, _react.useMemo)(function() {
        return !!a && O({
            width: e,
            height: n,
            scale: a,
            axis: "y",
            values: l
        });
    }, [
        n,
        e,
        a,
        l
    ]);
    return (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            c && (0, _jsxRuntime.jsx)(D, {
                lines: c
            }),
            s && (0, _jsxRuntime.jsx)(D, {
                lines: s
            })
        ]
    });
}), E = function(t, e) {
    var i, n, r = e.axis, a = e.scale, o = e.x, c = void 0 === o ? 0 : o, s = e.y, d = void 0 === s ? 0 : s, m = e.length, y = e.ticksPosition, g = e.tickValues, v = e.tickSize, k = void 0 === v ? Y.tickSize : v, h = e.tickPadding, p = void 0 === h ? Y.tickPadding : h, b = e.tickRotation, P = void 0 === b ? Y.tickRotation : b, S = e.format, A = e.legend, w = e.legendPosition, O = void 0 === w ? Y.legendPosition : w, X = e.legendOffset, B = void 0 === X ? Y.legendOffset : X, z = e.theme, R = e.style, V = T({
        axis: r,
        scale: a,
        ticksPosition: y,
        tickValues: g,
        tickSize: k,
        tickPadding: p,
        tickRotation: P,
        engine: "canvas"
    }), C = V.ticks, D = V.textAlign, j = V.textBaseline;
    t.save(), t.translate(c, d);
    var E = (0, _theming.extendAxisTheme)(z.axis, R);
    t.textAlign = D, t.textBaseline = j, (0, _text.setCanvasFont)(t, E.ticks.text);
    var W = null != (i = E.domain.line.strokeWidth) ? i : 0;
    "string" != typeof W && W > 0 && (t.lineWidth = W, t.lineCap = "square", E.domain.line.stroke && (t.strokeStyle = E.domain.line.stroke), t.beginPath(), t.moveTo(0, 0), t.lineTo("x" === r ? m : 0, "x" === r ? 0 : m), t.stroke());
    var q = "function" == typeof S ? S : function(t) {
        return "" + t;
    }, H = null != (n = E.ticks.line.strokeWidth) ? n : 0, I = "string" != typeof H && H > 0;
    if (C.forEach(function(e) {
        I && (t.lineWidth = H, t.lineCap = "square", E.ticks.line.stroke && (t.strokeStyle = E.ticks.line.stroke), t.beginPath(), t.moveTo(e.x, e.y), t.lineTo(e.x + e.lineX, e.y + e.lineY), t.stroke());
        var i = q(e.value);
        t.save(), t.translate(e.x + e.textX, e.y + e.textY), t.rotate((0, _core.degreesToRadians)(P)), (0, _text.drawCanvasText)(t, E.ticks.text, "" + i), t.fillText("" + i, 0, 0), t.restore();
    }), void 0 !== A) {
        var F = 0, G = 0, J = 0, K = "center";
        "y" === r ? (J = -90, F = B, "start" === O ? (K = "start", G = m) : "middle" === O ? (K = "center", G = m / 2) : "end" === O && (K = "end")) : (G = B, "start" === O ? K = "start" : "middle" === O ? (K = "center", F = m / 2) : "end" === O && (K = "end", F = m)), t.translate(F, G), t.rotate((0, _core.degreesToRadians)(J)), (0, _text.setCanvasFont)(t, E.legend.text), E.legend.text.fill && (t.fillStyle = E.legend.text.fill), t.textAlign = K, t.textBaseline = "middle", (0, _text.drawCanvasText)(t, E.legend.text, A);
    }
    t.restore();
}, W = function(t, e) {
    var i = e.xScale, n = e.yScale, r = e.width, a = e.height, o = e.top, l = e.right, c = e.bottom, s = e.left, f = e.theme, d = {
        top: o,
        right: l,
        bottom: c,
        left: s
    };
    R.forEach(function(e) {
        var o = d[e];
        if (!o) return null;
        var l = "top" === e || "bottom" === e, c = "top" === e || "left" === e ? "before" : "after", s = l ? i : n, u = w(o.format, s);
        E(t, A({}, o, {
            axis: l ? "x" : "y",
            x: "right" === e ? r : 0,
            y: "bottom" === e ? a : 0,
            scale: s,
            format: u,
            length: l ? r : a,
            ticksPosition: c,
            theme: f
        }));
    });
}, q = function(t, e) {
    var i = e.width, n = e.height, r = e.scale, a = e.axis, o = e.values;
    O({
        width: i,
        height: n,
        scale: r,
        axis: a,
        values: o
    }).forEach(function(e) {
        t.beginPath(), t.moveTo(e.x1, e.y1), t.lineTo(e.x2, e.y2), t.stroke();
    });
};

},{"react":"6uln9","@nivo/core":"3e9EB","@nivo/theming":"kiBiP","@nivo/text":"5EjSJ","@react-spring/web":"39JSM","d3-time-format":"1JsiF","d3-format":"bpsrv","@nivo/scales":"8SXu8","react/jsx-runtime":"gaGEj","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"5EjSJ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Text", ()=>b);
parcelHelpers.export(exports, "drawCanvasText", ()=>d);
parcelHelpers.export(exports, "getTextAlignFromBoxAnchor", ()=>f);
parcelHelpers.export(exports, "getTextBaselineFromBoxAnchor", ()=>u);
parcelHelpers.export(exports, "setCanvasFont", ()=>a);
var _web = require("@react-spring/web");
var _jsxRuntime = require("react/jsx-runtime");
var r = {
    center: "center",
    "top-left": "start",
    top: "center",
    "top-right": "end",
    right: "end",
    "bottom-right": "end",
    bottom: "center",
    "bottom-left": "start",
    left: "start"
}, i = {
    start: "end",
    center: "center",
    end: "start"
}, l = {
    center: "center",
    "top-left": "top",
    top: "top",
    "top-right": "top",
    right: "center",
    "bottom-right": "bottom",
    bottom: "bottom",
    "bottom-left": "bottom",
    left: "center"
}, c = {
    top: "bottom",
    center: "center",
    bottom: "top"
}, f = function(t, e) {
    void 0 === e && (e = !1);
    var o = r[t];
    return e ? i[o] : o;
}, u = function(t, e) {
    void 0 === e && (e = !1);
    var o = l[t];
    return e ? c[o] : o;
}, a = function(t, e) {
    t.font = (e.fontWeight ? e.fontWeight + " " : "") + e.fontSize + "px " + e.fontFamily;
}, d = function(t, e, o, n, r) {
    void 0 === n && (n = 0), void 0 === r && (r = 0), e.outlineWidth > 0 && (t.strokeStyle = e.outlineColor, t.lineWidth = 2 * e.outlineWidth, t.lineJoin = "round", t.strokeText(o, n, r)), t.fillStyle = e.fill, t.fillText(o, n, r);
};
function p() {
    return p = Object.assign ? Object.assign.bind() : function(t) {
        for(var e = 1; e < arguments.length; e++){
            var o = arguments[e];
            for(var n in o)({}).hasOwnProperty.call(o, n) && (t[n] = o[n]);
        }
        return t;
    }, p.apply(null, arguments);
}
function s(t, e) {
    if (null == t) return {};
    var o = {};
    for(var n in t)if (({}).hasOwnProperty.call(t, n)) {
        if (-1 !== e.indexOf(n)) continue;
        o[n] = t[n];
    }
    return o;
}
var h = [
    "style",
    "children"
], m = [
    "outlineWidth",
    "outlineColor",
    "outlineOpacity"
], b = function(r) {
    var i = r.style, l = r.children, c = s(r, h), f = i.outlineWidth, u = i.outlineColor, a = i.outlineOpacity, d = s(i, m);
    return (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            f > 0 && (0, _jsxRuntime.jsx)((0, _web.animated).text, p({}, c, {
                style: p({}, d, {
                    strokeWidth: 2 * f,
                    stroke: u,
                    strokeOpacity: a,
                    strokeLinejoin: "round"
                }),
                children: l
            })),
            (0, _jsxRuntime.jsx)((0, _web.animated).text, p({}, c, {
                style: d,
                children: l
            }))
        ]
    });
};

},{"@react-spring/web":"39JSM","react/jsx-runtime":"gaGEj","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8SXu8":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "bandScaleDefaults", ()=>en);
parcelHelpers.export(exports, "castBandScale", ()=>an);
parcelHelpers.export(exports, "castLinearScale", ()=>_);
parcelHelpers.export(exports, "castPointScale", ()=>tn);
parcelHelpers.export(exports, "centerScale", ()=>Mn);
parcelHelpers.export(exports, "compareDateValues", ()=>vn);
parcelHelpers.export(exports, "compareValues", ()=>ln);
parcelHelpers.export(exports, "computeScale", ()=>pn);
parcelHelpers.export(exports, "computeXYScalesForSeries", ()=>hn);
parcelHelpers.export(exports, "createBandScale", ()=>rn);
parcelHelpers.export(exports, "createDateNormalizer", ()=>X);
parcelHelpers.export(exports, "createLinearScale", ()=>Z);
parcelHelpers.export(exports, "createLogScale", ()=>sn);
parcelHelpers.export(exports, "createPointScale", ()=>nn);
parcelHelpers.export(exports, "createPrecisionMethod", ()=>W);
parcelHelpers.export(exports, "createSymlogScale", ()=>mn);
parcelHelpers.export(exports, "createTimeScale", ()=>un);
parcelHelpers.export(exports, "generateSeriesAxis", ()=>xn);
parcelHelpers.export(exports, "generateSeriesXY", ()=>gn);
parcelHelpers.export(exports, "getOtherAxis", ()=>fn);
parcelHelpers.export(exports, "getScaleTicks", ()=>Cn);
parcelHelpers.export(exports, "isReversibleScaleSpec", ()=>Un);
parcelHelpers.export(exports, "linearScaleDefaults", ()=>Y);
parcelHelpers.export(exports, "logScaleDefaults", ()=>cn);
parcelHelpers.export(exports, "precisionCutOffs", ()=>L);
parcelHelpers.export(exports, "precisionCutOffsByType", ()=>Q);
parcelHelpers.export(exports, "stackAxis", ()=>kn);
parcelHelpers.export(exports, "symlogScaleDefaults", ()=>dn);
parcelHelpers.export(exports, "timePrecisions", ()=>K);
parcelHelpers.export(exports, "timeScaleDefaults", ()=>on);
var _uniqJs = require("lodash/uniq.js");
var _uniqJsDefault = parcelHelpers.interopDefault(_uniqJs);
var _uniqByJs = require("lodash/uniqBy.js");
var _uniqByJsDefault = parcelHelpers.interopDefault(_uniqByJs);
var _sortByJs = require("lodash/sortBy.js");
var _sortByJsDefault = parcelHelpers.interopDefault(_sortByJs);
var _lastJs = require("lodash/last.js");
var _lastJsDefault = parcelHelpers.interopDefault(_lastJs);
var _isDateJs = require("lodash/isDate.js");
var _isDateJsDefault = parcelHelpers.interopDefault(_isDateJs);
var _d3TimeFormat = require("d3-time-format");
var _d3Scale = require("d3-scale");
var _d3Interpolate = require("d3-interpolate");
var _d3Time = require("d3-time");
function J() {
    return J = Object.assign ? Object.assign.bind() : function(n) {
        for(var t = 1; t < arguments.length; t++){
            var e = arguments[t];
            for(var r in e)({}).hasOwnProperty.call(e, r) && (n[r] = e[r]);
        }
        return n;
    }, J.apply(null, arguments);
}
var K = [
    "millisecond",
    "second",
    "minute",
    "hour",
    "day",
    "month",
    "year"
], L = [
    function(n) {
        return n.setMilliseconds(0);
    },
    function(n) {
        return n.setSeconds(0);
    },
    function(n) {
        return n.setMinutes(0);
    },
    function(n) {
        return n.setHours(0);
    },
    function(n) {
        return n.setDate(1);
    },
    function(n) {
        return n.setMonth(0);
    }
], Q = {
    millisecond: [],
    second: L.slice(0, 1),
    minute: L.slice(0, 2),
    hour: L.slice(0, 3),
    day: L.slice(0, 4),
    month: L.slice(0, 5),
    year: L.slice(0, 6)
}, W = function(n) {
    return function(t) {
        return Q[n].forEach(function(n) {
            n(t);
        }), t;
    };
}, X = function(n) {
    var t = n.format, e = void 0 === t ? "native" : t, r = n.precision, i = void 0 === r ? "millisecond" : r, u = n.useUTC, c = void 0 === u || u, s = W(i);
    return function(n) {
        if (void 0 === n) return n;
        if ("native" === e || n instanceof Date) return s(n);
        var t = c ? (0, _d3TimeFormat.utcParse)(e) : (0, _d3TimeFormat.timeParse)(e);
        return s(t(n));
    };
}, Y = {
    type: "linear",
    min: 0,
    max: "auto",
    stacked: !1,
    reverse: !1,
    clamp: !1,
    nice: !0,
    round: !1
}, Z = function(n, t, e, r) {
    var i, a, o, c, s = n.min, d = void 0 === s ? Y.min : s, m = n.max, f = void 0 === m ? Y.max : m, l = n.stacked, y = void 0 === l ? Y.stacked : l, h = n.reverse, g = void 0 === h ? Y.reverse : h, x = n.clamp, k = void 0 === x ? Y.clamp : x, T = n.nice, b = void 0 === T ? Y.nice : T, M = n.round, w = void 0 === M ? Y.round : M;
    "auto" === d ? i = !0 === y ? null != (a = t.minStacked) ? a : 0 : t.min : i = d;
    "auto" === f ? o = !0 === y ? null != (c = t.maxStacked) ? c : 0 : t.max : o = f;
    var E = (0, _d3Scale.scaleLinear)().range("x" === r ? [
        0,
        e
    ] : [
        e,
        0
    ]).interpolate(w ? (0, _d3Interpolate.interpolateRound) : (0, _d3Interpolate.interpolateNumber)).domain(g ? [
        o,
        i
    ] : [
        i,
        o
    ]).clamp(k);
    return !0 === b ? E.nice() : "number" == typeof b && E.nice(b), _(E, y);
}, _ = function(n, t) {
    void 0 === t && (t = !1);
    var e = n;
    return e.type = "linear", e.stacked = t, e;
}, nn = function(n, t, e) {
    var r = (0, _d3Scale.scalePoint)().range([
        0,
        e
    ]).domain(t.all);
    return r.type = "point", r;
}, tn = function(n) {
    var t = n;
    return t.type = "point", t;
}, en = {
    type: "band",
    round: !1
}, rn = function(n, t, e, r) {
    var i = n.round, a = void 0 === i ? en.round : i, o = (0, _d3Scale.scaleBand)().range("x" === r ? [
        0,
        e
    ] : [
        e,
        0
    ]).domain(t.all).round(a);
    return an(o);
}, an = function(n) {
    var t = n;
    return t.type = "band", t;
}, on = {
    type: "time",
    format: "native",
    precision: "millisecond",
    min: "auto",
    max: "auto",
    useUTC: !0,
    nice: !1
}, un = function(n, t, e) {
    var r, i, a = n.format, o = void 0 === a ? on.format : a, u = n.precision, c = void 0 === u ? on.precision : u, s = n.min, f = void 0 === s ? on.min : s, l = n.max, v = void 0 === l ? on.max : l, p = n.useUTC, y = void 0 === p ? on.useUTC : p, h = n.nice, g = void 0 === h ? on.nice : h, x = X({
        format: o,
        precision: c,
        useUTC: y
    });
    r = "auto" === f ? x(t.min) : "native" !== o ? x(f) : f, i = "auto" === v ? x(t.max) : "native" !== o ? x(v) : v;
    var k = y ? (0, _d3Scale.scaleUtc)() : (0, _d3Scale.scaleTime)();
    k.range([
        0,
        e
    ]), r && i && k.domain([
        r,
        i
    ]), !0 === g ? k.nice() : "object" != typeof g && "number" != typeof g || k.nice(g);
    var T = k;
    return T.type = "time", T.useUTC = y, T;
}, cn = {
    type: "log",
    base: 10,
    min: "auto",
    max: "auto",
    round: !1,
    reverse: !1,
    nice: !0
}, sn = function(n, t, e, r) {
    var i, a = n.base, o = void 0 === a ? cn.base : a, u = n.min, c = void 0 === u ? cn.min : u, s = n.max, d = void 0 === s ? cn.max : s, m = n.round, l = void 0 === m ? cn.round : m, v = n.reverse, p = void 0 === v ? cn.reverse : v, y = n.nice, h = void 0 === y ? cn.nice : y;
    if (t.all.some(function(n) {
        return 0 === n;
    })) throw new Error("a log scale domain must not include or cross zero");
    var g, x, k = !1;
    if (t.all.filter(function(n) {
        return null != n;
    }).forEach(function(n) {
        k || (void 0 === i ? i = Math.sign(n) : Math.sign(n) !== i && (k = !0));
    }), k) throw new Error("a log scale domain must be strictly-positive or strictly-negative");
    g = "auto" === c ? t.min : c, x = "auto" === d ? t.max : d;
    var T = (0, _d3Scale.scaleLog)().base(o), b = "x" === r ? [
        0,
        e
    ] : [
        e,
        0
    ];
    !0 === l ? T.rangeRound(b) : T.range(b), !0 === p ? T.domain([
        x,
        g
    ]) : T.domain([
        g,
        x
    ]), !0 === h ? T.nice() : "number" == typeof h && T.nice(h);
    var M = T;
    return M.type = "log", M;
}, dn = {
    type: "symlog",
    constant: 1,
    min: "auto",
    max: "auto",
    round: !1,
    reverse: !1,
    nice: !0
}, mn = function(n, t, e, r) {
    var i, a, o = n.constant, u = void 0 === o ? dn.constant : o, c = n.min, s = void 0 === c ? dn.min : c, d = n.max, m = void 0 === d ? dn.max : d, f = n.round, v = void 0 === f ? dn.round : f, p = n.reverse, y = void 0 === p ? dn.reverse : p, h = n.nice, g = void 0 === h ? dn.nice : h;
    i = "auto" === s ? t.min : s, a = "auto" === m ? t.max : m;
    var x = (0, _d3Scale.scaleSymlog)().constant(u), k = "x" === r ? [
        0,
        e
    ] : [
        e,
        0
    ];
    !0 === v ? x.rangeRound(k) : x.range(k), !0 === y ? x.domain([
        a,
        i
    ]) : x.domain([
        i,
        a
    ]), !0 === g ? x.nice() : "number" == typeof g && x.nice(g);
    var T = x;
    return T.type = "symlog", T;
}, fn = function(n) {
    return "x" === n ? "y" : "x";
}, ln = function(n, t) {
    return n === t;
}, vn = function(n, t) {
    return n.getTime() === t.getTime();
};
function pn(n, t, e, r) {
    switch(n.type){
        case "linear":
            return Z(n, t, e, r);
        case "point":
            return nn(0, t, e);
        case "band":
            return rn(n, t, e, r);
        case "time":
            return un(n, t, e);
        case "log":
            return sn(n, t, e, r);
        case "symlog":
            return mn(n, t, e, r);
        default:
            throw new Error("invalid scale spec");
    }
}
var yn = function(n, t, e) {
    var r;
    if ("stacked" in e && e.stacked) {
        var i = n.data["x" === t ? "xStacked" : "yStacked"];
        return null == i ? null : e(i);
    }
    return null != (r = e(n.data[t])) ? r : null;
}, hn = function(n, t, e, r, i) {
    var a = n.map(function(n) {
        return function(n) {
            return J({}, n, {
                data: n.data.map(function(n) {
                    return {
                        data: J({}, n)
                    };
                })
            });
        }(n);
    }), o = gn(a, t, e);
    "stacked" in t && !0 === t.stacked && Tn(o, a), "stacked" in e && !0 === e.stacked && bn(o, a);
    var u = pn(t, o.x, r, "x"), c = pn(e, o.y, i, "y"), s = a.map(function(n) {
        return J({}, n, {
            data: n.data.map(function(n) {
                return J({}, n, {
                    position: {
                        x: yn(n, "x", u),
                        y: yn(n, "y", c)
                    }
                });
            })
        });
    });
    return J({}, o, {
        series: s,
        xScale: u,
        yScale: c
    });
}, gn = function(n, t, e) {
    return {
        x: xn(n, "x", t),
        y: xn(n, "y", e)
    };
}, xn = function(i, a, o, u) {
    var c = void 0 === u ? {} : u, s = c.getValue, d = void 0 === s ? function(n) {
        return n.data[a];
    } : s, m = c.setValue, f = void 0 === m ? function(n, t) {
        n.data[a] = t;
    } : m;
    if ("linear" === o.type) i.forEach(function(n) {
        n.data.forEach(function(n) {
            var t = d(n);
            t && f(n, parseFloat(String(t)));
        });
    });
    else if ("time" === o.type && "native" !== o.format) {
        var l = X(o);
        i.forEach(function(n) {
            n.data.forEach(function(n) {
                var t = d(n);
                t && f(n, l(t));
            });
        });
    }
    var v = [];
    switch(i.forEach(function(n) {
        n.data.forEach(function(n) {
            v.push(d(n));
        });
    }), o.type){
        case "linear":
            var p = (0, _sortByJsDefault.default)((0, _uniqJsDefault.default)(v).filter(function(n) {
                return null !== n;
            }), function(n) {
                return n;
            });
            return {
                all: p,
                min: Math.min.apply(Math, p),
                max: Math.max.apply(Math, p)
            };
        case "time":
            var y = (0, _uniqByJsDefault.default)(v, function(n) {
                return n.getTime();
            }).slice(0).sort(function(n, t) {
                return t.getTime() - n.getTime();
            }).reverse();
            return {
                all: y,
                min: y[0],
                max: (0, _lastJsDefault.default)(y)
            };
        default:
            var h = (0, _uniqJsDefault.default)(v);
            return {
                all: h,
                min: h[0],
                max: (0, _lastJsDefault.default)(h)
            };
    }
}, kn = function(n, t, e) {
    var a = fn(n), o = [];
    t[a].all.forEach(function(t) {
        var u = (0, _isDateJsDefault.default)(t) ? vn : ln, c = [];
        e.forEach(function(e) {
            var i = e.data.find(function(n) {
                return u(n.data[a], t);
            }), s = null, d = null;
            if (void 0 !== i) {
                if (null !== (s = i.data[n])) {
                    var m = (0, _lastJsDefault.default)(c);
                    void 0 === m ? d = s : null !== m && (d = m + s);
                }
                i.data["x" === n ? "xStacked" : "yStacked"] = d;
            }
            c.push(d), null !== d && o.push(d);
        });
    }), t[n].minStacked = Math.min.apply(Math, o), t[n].maxStacked = Math.max.apply(Math, o);
}, Tn = function(n, t) {
    return kn("x", n, t);
}, bn = function(n, t) {
    return kn("y", n, t);
}, Mn = function(n) {
    var t = n.bandwidth();
    if (0 === t) return n;
    var e = t / 2;
    return n.round() && (e = Math.round(e)), function(t) {
        var r;
        return (null != (r = n(t)) ? r : 0) + e;
    };
}, wn = {
    millisecond: [
        (0, _d3Time.timeMillisecond),
        (0, _d3Time.utcMillisecond)
    ],
    second: [
        (0, _d3Time.timeSecond),
        (0, _d3Time.utcSecond)
    ],
    minute: [
        (0, _d3Time.timeMinute),
        (0, _d3Time.utcMinute)
    ],
    hour: [
        (0, _d3Time.timeHour),
        (0, _d3Time.utcHour)
    ],
    day: [
        (0, _d3Time.timeInterval)(function(n) {
            return n.setHours(0, 0, 0, 0);
        }, function(n, t) {
            return n.setDate(n.getDate() + t);
        }, function(n, t) {
            return (t.getTime() - n.getTime()) / 864e5;
        }, function(n) {
            return Math.floor(n.getTime() / 864e5);
        }),
        (0, _d3Time.timeInterval)(function(n) {
            return n.setUTCHours(0, 0, 0, 0);
        }, function(n, t) {
            return n.setUTCDate(n.getUTCDate() + t);
        }, function(n, t) {
            return (t.getTime() - n.getTime()) / 864e5;
        }, function(n) {
            return Math.floor(n.getTime() / 864e5);
        })
    ],
    week: [
        (0, _d3Time.timeWeek),
        (0, _d3Time.utcWeek)
    ],
    sunday: [
        (0, _d3Time.timeSunday),
        (0, _d3Time.utcSunday)
    ],
    monday: [
        (0, _d3Time.timeMonday),
        (0, _d3Time.utcMonday)
    ],
    tuesday: [
        (0, _d3Time.timeTuesday),
        (0, _d3Time.utcTuesday)
    ],
    wednesday: [
        (0, _d3Time.timeWednesday),
        (0, _d3Time.utcWednesday)
    ],
    thursday: [
        (0, _d3Time.timeThursday),
        (0, _d3Time.utcThursday)
    ],
    friday: [
        (0, _d3Time.timeFriday),
        (0, _d3Time.utcFriday)
    ],
    saturday: [
        (0, _d3Time.timeSaturday),
        (0, _d3Time.utcSaturday)
    ],
    month: [
        (0, _d3Time.timeMonth),
        (0, _d3Time.utcMonth)
    ],
    year: [
        (0, _d3Time.timeYear),
        (0, _d3Time.utcYear)
    ]
}, En = Object.keys(wn), Sn = new RegExp("^every\\s*(\\d+)?\\s*(" + En.join("|") + ")s?$", "i"), Cn = function(n, t) {
    if (Array.isArray(t)) return t;
    if ("string" == typeof t && "useUTC" in n) {
        var e = t.match(Sn);
        if (e) {
            var r = e[1], i = e[2], a = wn[i][n.useUTC ? 1 : 0];
            if ("day" === i) {
                var o, u, c = n.domain(), s = c[0], d = c[1], m = new Date(d);
                return m.setDate(m.getDate() + 1), null != (o = null == (u = a.every(Number(null != r ? r : 1))) ? void 0 : u.range(s, m)) ? o : [];
            }
            if (void 0 === r) return n.ticks(a);
            var f = a.every(Number(r));
            if (f) return n.ticks(f);
        }
        throw new Error("Invalid tickValues: " + t);
    }
    if ("ticks" in n) {
        if (void 0 === t) return n.ticks();
        if ("number" == typeof (l = t) && isFinite(l) && Math.floor(l) === l) return n.ticks(t);
    }
    var l;
    return n.domain();
}, Un = function(n) {
    return "linear" === n.type || "log" === n.type || "symlog" === n.type;
};

},{"lodash/uniq.js":"z30nX","lodash/uniqBy.js":"5pHXK","lodash/sortBy.js":"8KMzB","lodash/last.js":"5Gv7h","lodash/isDate.js":"5ZAOe","d3-time-format":"1JsiF","d3-scale":"7BK9l","d3-interpolate":"6bUMz","d3-time":"2sGu6","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"z30nX":[function(require,module,exports) {
var baseUniq = require("8e268641906a92b2");
/**
 * Creates a duplicate-free version of an array, using
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons, in which only the first occurrence of each element
 * is kept. The order of result values is determined by the order they occur
 * in the array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @returns {Array} Returns the new duplicate free array.
 * @example
 *
 * _.uniq([2, 1, 2]);
 * // => [2, 1]
 */ function uniq(array) {
    return array && array.length ? baseUniq(array) : [];
}
module.exports = uniq;

},{"8e268641906a92b2":"gPtnc"}],"gPtnc":[function(require,module,exports) {
var SetCache = require("56c8470806d11628"), arrayIncludes = require("a1d85be956e037a9"), arrayIncludesWith = require("8cd18f86a4a2c118"), cacheHas = require("3acf9f4a3a78c511"), createSet = require("19b77385b4f7775a"), setToArray = require("4568580f7416eb83");
/** Used as the size to enable large array optimizations. */ var LARGE_ARRAY_SIZE = 200;
/**
 * The base implementation of `_.uniqBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 */ function baseUniq(array, iteratee, comparator) {
    var index = -1, includes = arrayIncludes, length = array.length, isCommon = true, result = [], seen = result;
    if (comparator) {
        isCommon = false;
        includes = arrayIncludesWith;
    } else if (length >= LARGE_ARRAY_SIZE) {
        var set = iteratee ? null : createSet(array);
        if (set) return setToArray(set);
        isCommon = false;
        includes = cacheHas;
        seen = new SetCache;
    } else seen = iteratee ? [] : result;
    outer: while(++index < length){
        var value = array[index], computed = iteratee ? iteratee(value) : value;
        value = comparator || value !== 0 ? value : 0;
        if (isCommon && computed === computed) {
            var seenIndex = seen.length;
            while(seenIndex--){
                if (seen[seenIndex] === computed) continue outer;
            }
            if (iteratee) seen.push(computed);
            result.push(value);
        } else if (!includes(seen, computed, comparator)) {
            if (seen !== result) seen.push(computed);
            result.push(value);
        }
    }
    return result;
}
module.exports = baseUniq;

},{"56c8470806d11628":"8LOJe","a1d85be956e037a9":"894B4","8cd18f86a4a2c118":"7U6V2","3acf9f4a3a78c511":"tTji9","19b77385b4f7775a":"b31ml","4568580f7416eb83":"29rq3"}],"b31ml":[function(require,module,exports) {
var Set = require("17777365baf8e16"), noop = require("a02c367b3608ccee"), setToArray = require("cd8d0af6a14b2f7d");
/** Used as references for various `Number` constants. */ var INFINITY = 1 / 0;
/**
 * Creates a set object of `values`.
 *
 * @private
 * @param {Array} values The values to add to the set.
 * @returns {Object} Returns the new set.
 */ var createSet = !(Set && 1 / setToArray(new Set([
    ,
    -0
]))[1] == INFINITY) ? noop : function(values) {
    return new Set(values);
};
module.exports = createSet;

},{"17777365baf8e16":"9vgKa","a02c367b3608ccee":"8qs1l","cd8d0af6a14b2f7d":"29rq3"}],"8qs1l":[function(require,module,exports) {
/**
 * This method returns `undefined`.
 *
 * @static
 * @memberOf _
 * @since 2.3.0
 * @category Util
 * @example
 *
 * _.times(2, _.noop);
 * // => [undefined, undefined]
 */ function noop() {
// No operation performed.
}
module.exports = noop;

},{}],"5pHXK":[function(require,module,exports) {
var baseIteratee = require("ce9604aad32f97ab"), baseUniq = require("9fbd8e46e11f49c4");
/**
 * This method is like `_.uniq` except that it accepts `iteratee` which is
 * invoked for each element in `array` to generate the criterion by which
 * uniqueness is computed. The order of result values is determined by the
 * order they occur in the array. The iteratee is invoked with one argument:
 * (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 * @example
 *
 * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
 * // => [2.1, 1.2]
 *
 * // The `_.property` iteratee shorthand.
 * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
 * // => [{ 'x': 1 }, { 'x': 2 }]
 */ function uniqBy(array, iteratee) {
    return array && array.length ? baseUniq(array, baseIteratee(iteratee, 2)) : [];
}
module.exports = uniqBy;

},{"ce9604aad32f97ab":"l2cSI","9fbd8e46e11f49c4":"gPtnc"}],"8KMzB":[function(require,module,exports) {
var baseFlatten = require("7dd3b18d381f1f29"), baseOrderBy = require("2553e45e897c3cba"), baseRest = require("9df1e918b0eea173"), isIterateeCall = require("36218471fd8f4dda");
/**
 * Creates an array of elements, sorted in ascending order by the results of
 * running each element in a collection thru each iteratee. This method
 * performs a stable sort, that is, it preserves the original sort order of
 * equal elements. The iteratees are invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {...(Function|Function[])} [iteratees=[_.identity]]
 *  The iteratees to sort by.
 * @returns {Array} Returns the new sorted array.
 * @example
 *
 * var users = [
 *   { 'user': 'fred',   'age': 48 },
 *   { 'user': 'barney', 'age': 36 },
 *   { 'user': 'fred',   'age': 30 },
 *   { 'user': 'barney', 'age': 34 }
 * ];
 *
 * _.sortBy(users, [function(o) { return o.user; }]);
 * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
 *
 * _.sortBy(users, ['user', 'age']);
 * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
 */ var sortBy = baseRest(function(collection, iteratees) {
    if (collection == null) return [];
    var length = iteratees.length;
    if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) iteratees = [];
    else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) iteratees = [
        iteratees[0]
    ];
    return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
});
module.exports = sortBy;

},{"7dd3b18d381f1f29":"9VsYJ","2553e45e897c3cba":"5dJj0","9df1e918b0eea173":"9p3xS","36218471fd8f4dda":"hr6A6"}],"5dJj0":[function(require,module,exports) {
var arrayMap = require("8b3be8ab05c5c021"), baseGet = require("56eb179604ce4d19"), baseIteratee = require("41950d167c7e12b5"), baseMap = require("b09740a39499ec43"), baseSortBy = require("35a9013ca73ef017"), baseUnary = require("b387a5b76e29e664"), compareMultiple = require("2ab709818f44804c"), identity = require("5cb379329c706719"), isArray = require("8acdbb462385356c");
/**
 * The base implementation of `_.orderBy` without param guards.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
 * @param {string[]} orders The sort orders of `iteratees`.
 * @returns {Array} Returns the new sorted array.
 */ function baseOrderBy(collection, iteratees, orders) {
    if (iteratees.length) iteratees = arrayMap(iteratees, function(iteratee) {
        if (isArray(iteratee)) return function(value) {
            return baseGet(value, iteratee.length === 1 ? iteratee[0] : iteratee);
        };
        return iteratee;
    });
    else iteratees = [
        identity
    ];
    var index = -1;
    iteratees = arrayMap(iteratees, baseUnary(baseIteratee));
    var result = baseMap(collection, function(value, key, collection) {
        var criteria = arrayMap(iteratees, function(iteratee) {
            return iteratee(value);
        });
        return {
            "criteria": criteria,
            "index": ++index,
            "value": value
        };
    });
    return baseSortBy(result, function(object, other) {
        return compareMultiple(object, other, orders);
    });
}
module.exports = baseOrderBy;

},{"8b3be8ab05c5c021":"fahvZ","56eb179604ce4d19":"51EsY","41950d167c7e12b5":"l2cSI","b09740a39499ec43":"8gzMu","35a9013ca73ef017":"4AUGS","b387a5b76e29e664":"993qv","2ab709818f44804c":"kezKB","5cb379329c706719":"71tSl","8acdbb462385356c":"2VsjV"}],"8gzMu":[function(require,module,exports) {
var baseEach = require("488df795cf6fe570"), isArrayLike = require("2924e2db4bb5430d");
/**
 * The base implementation of `_.map` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function baseMap(collection, iteratee) {
    var index = -1, result = isArrayLike(collection) ? Array(collection.length) : [];
    baseEach(collection, function(value, key, collection) {
        result[++index] = iteratee(value, key, collection);
    });
    return result;
}
module.exports = baseMap;

},{"488df795cf6fe570":"ghpxV","2924e2db4bb5430d":"5uWOF"}],"ghpxV":[function(require,module,exports) {
var baseForOwn = require("ee57d32bcdc873cb"), createBaseEach = require("f1e3fc84161ef3ec");
/**
 * The base implementation of `_.forEach` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */ var baseEach = createBaseEach(baseForOwn);
module.exports = baseEach;

},{"ee57d32bcdc873cb":"jQLMG","f1e3fc84161ef3ec":"iDiyk"}],"iDiyk":[function(require,module,exports) {
var isArrayLike = require("49bbd11cbf093bb1");
/**
 * Creates a `baseEach` or `baseEachRight` function.
 *
 * @private
 * @param {Function} eachFunc The function to iterate over a collection.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function createBaseEach(eachFunc, fromRight) {
    return function(collection, iteratee) {
        if (collection == null) return collection;
        if (!isArrayLike(collection)) return eachFunc(collection, iteratee);
        var length = collection.length, index = fromRight ? length : -1, iterable = Object(collection);
        while(fromRight ? index-- : ++index < length){
            if (iteratee(iterable[index], index, iterable) === false) break;
        }
        return collection;
    };
}
module.exports = createBaseEach;

},{"49bbd11cbf093bb1":"5uWOF"}],"4AUGS":[function(require,module,exports) {
/**
 * The base implementation of `_.sortBy` which uses `comparer` to define the
 * sort order of `array` and replaces criteria objects with their corresponding
 * values.
 *
 * @private
 * @param {Array} array The array to sort.
 * @param {Function} comparer The function to define sort order.
 * @returns {Array} Returns `array`.
 */ function baseSortBy(array, comparer) {
    var length = array.length;
    array.sort(comparer);
    while(length--)array[length] = array[length].value;
    return array;
}
module.exports = baseSortBy;

},{}],"kezKB":[function(require,module,exports) {
var compareAscending = require("dd5e23e02b1cd726");
/**
 * Used by `_.orderBy` to compare multiple properties of a value to another
 * and stable sort them.
 *
 * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
 * specify an order of "desc" for descending or "asc" for ascending sort order
 * of corresponding values.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {boolean[]|string[]} orders The order to sort by for each property.
 * @returns {number} Returns the sort order indicator for `object`.
 */ function compareMultiple(object, other, orders) {
    var index = -1, objCriteria = object.criteria, othCriteria = other.criteria, length = objCriteria.length, ordersLength = orders.length;
    while(++index < length){
        var result = compareAscending(objCriteria[index], othCriteria[index]);
        if (result) {
            if (index >= ordersLength) return result;
            var order = orders[index];
            return result * (order == "desc" ? -1 : 1);
        }
    }
    // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
    // that causes it, under certain circumstances, to provide the same value for
    // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
    // for more details.
    //
    // This also ensures a stable sort in V8 and other engines.
    // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
    return object.index - other.index;
}
module.exports = compareMultiple;

},{"dd5e23e02b1cd726":"e59ti"}],"e59ti":[function(require,module,exports) {
var isSymbol = require("a51b63ee8daeecee");
/**
 * Compares values to sort them in ascending order.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {number} Returns the sort order indicator for `value`.
 */ function compareAscending(value, other) {
    if (value !== other) {
        var valIsDefined = value !== undefined, valIsNull = value === null, valIsReflexive = value === value, valIsSymbol = isSymbol(value);
        var othIsDefined = other !== undefined, othIsNull = other === null, othIsReflexive = other === other, othIsSymbol = isSymbol(other);
        if (!othIsNull && !othIsSymbol && !valIsSymbol && value > other || valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol || valIsNull && othIsDefined && othIsReflexive || !valIsDefined && othIsReflexive || !valIsReflexive) return 1;
        if (!valIsNull && !valIsSymbol && !othIsSymbol && value < other || othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol || othIsNull && valIsDefined && valIsReflexive || !othIsDefined && valIsReflexive || !othIsReflexive) return -1;
    }
    return 0;
}
module.exports = compareAscending;

},{"a51b63ee8daeecee":"3DsXL"}],"5ZAOe":[function(require,module,exports) {
var baseIsDate = require("2e5c3fd587c080ab"), baseUnary = require("b707197710f20e35"), nodeUtil = require("50ae594eda1f7546");
/* Node.js helper references. */ var nodeIsDate = nodeUtil && nodeUtil.isDate;
/**
 * Checks if `value` is classified as a `Date` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
 * @example
 *
 * _.isDate(new Date);
 * // => true
 *
 * _.isDate('Mon April 23 2012');
 * // => false
 */ var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;
module.exports = isDate;

},{"2e5c3fd587c080ab":"7DCtz","b707197710f20e35":"993qv","50ae594eda1f7546":"ihImP"}],"7DCtz":[function(require,module,exports) {
var baseGetTag = require("fee9a83fca9b4491"), isObjectLike = require("e3e4be03f1e35653");
/** `Object#toString` result references. */ var dateTag = "[object Date]";
/**
 * The base implementation of `_.isDate` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
 */ function baseIsDate(value) {
    return isObjectLike(value) && baseGetTag(value) == dateTag;
}
module.exports = baseIsDate;

},{"fee9a83fca9b4491":"fQG2h","e3e4be03f1e35653":"5TH1N"}],"kxw7P":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AnchoredContinuousColorsLegendSvg", ()=>Y);
parcelHelpers.export(exports, "BoxLegendSvg", ()=>E);
parcelHelpers.export(exports, "ContinuousColorsLegendSvg", ()=>w);
parcelHelpers.export(exports, "LegendSvg", ()=>H);
parcelHelpers.export(exports, "LegendSvgItem", ()=>B);
parcelHelpers.export(exports, "SymbolCircle", ()=>v);
parcelHelpers.export(exports, "SymbolDiamond", ()=>u);
parcelHelpers.export(exports, "SymbolSquare", ()=>p);
parcelHelpers.export(exports, "SymbolTriangle", ()=>y);
parcelHelpers.export(exports, "computeContinuousColorsLegend", ()=>W);
parcelHelpers.export(exports, "computeDimensions", ()=>A);
parcelHelpers.export(exports, "computeItemLayout", ()=>z);
parcelHelpers.export(exports, "computePositionFromAnchor", ()=>C);
parcelHelpers.export(exports, "continuousColorsLegendDefaults", ()=>x);
parcelHelpers.export(exports, "legendDefaults", ()=>k);
parcelHelpers.export(exports, "renderContinuousColorLegendToCanvas", ()=>M);
parcelHelpers.export(exports, "renderLegendToCanvas", ()=>L);
parcelHelpers.export(exports, "useQuantizeColorScaleLegendData", ()=>P);
var _jsxRuntime = require("react/jsx-runtime");
var _d3Scale = require("d3-scale");
var _core = require("@nivo/core");
var _colors = require("@nivo/colors");
var _react = require("react");
var _theming = require("@nivo/theming");
var _text = require("@nivo/text");
var v = function(e) {
    var i = e.x, n = e.y, o = e.size, r = e.fill, l = e.opacity, a = void 0 === l ? 1 : l, c = e.borderWidth, s = void 0 === c ? 0 : c, d = e.borderColor;
    return (0, _jsxRuntime.jsx)("circle", {
        r: o / 2,
        cx: i + o / 2,
        cy: n + o / 2,
        fill: r,
        opacity: a,
        strokeWidth: s,
        stroke: void 0 === d ? "transparent" : d,
        style: {
            pointerEvents: "none"
        }
    });
}, u = function(e) {
    var i = e.x, n = e.y, o = e.size, r = e.fill, l = e.opacity, a = void 0 === l ? 1 : l, c = e.borderWidth, s = void 0 === c ? 0 : c, d = e.borderColor;
    return (0, _jsxRuntime.jsx)("g", {
        transform: "translate(" + i + "," + n + ")",
        children: (0, _jsxRuntime.jsx)("path", {
            d: "\n                    M" + o / 2 + " 0\n                    L" + .8 * o + " " + o / 2 + "\n                    L" + o / 2 + " " + o + "\n                    L" + .2 * o + " " + o / 2 + "\n                    L" + o / 2 + " 0\n                ",
            fill: r,
            opacity: a,
            strokeWidth: s,
            stroke: void 0 === d ? "transparent" : d,
            style: {
                pointerEvents: "none"
            }
        })
    });
}, p = function(e) {
    var i = e.x, n = e.y, o = e.size, r = e.fill, l = e.opacity, a = void 0 === l ? 1 : l, c = e.borderWidth, s = void 0 === c ? 0 : c, d = e.borderColor;
    return (0, _jsxRuntime.jsx)("rect", {
        x: i,
        y: n,
        fill: r,
        opacity: a,
        strokeWidth: s,
        stroke: void 0 === d ? "transparent" : d,
        width: o,
        height: o,
        style: {
            pointerEvents: "none"
        }
    });
}, y = function(e) {
    var i = e.x, n = e.y, o = e.size, r = e.fill, l = e.opacity, a = void 0 === l ? 1 : l, c = e.borderWidth, s = void 0 === c ? 0 : c, d = e.borderColor;
    return (0, _jsxRuntime.jsx)("g", {
        transform: "translate(" + i + "," + n + ")",
        children: (0, _jsxRuntime.jsx)("path", {
            d: "\n                M" + o / 2 + " 0\n                L" + o + " " + o + "\n                L0 " + o + "\n                L" + o / 2 + " 0\n            ",
            fill: r,
            opacity: a,
            strokeWidth: s,
            stroke: void 0 === d ? "transparent" : d,
            style: {
                pointerEvents: "none"
            }
        })
    });
};
function b() {
    return b = Object.assign ? Object.assign.bind() : function(t) {
        for(var e = 1; e < arguments.length; e++){
            var i = arguments[e];
            for(var n in i)({}).hasOwnProperty.call(i, n) && (t[n] = i[n]);
        }
        return t;
    }, b.apply(null, arguments);
}
var k = {
    translateX: 0,
    translateY: 0,
    padding: 0,
    itemsSpacing: 0,
    itemDirection: "left-to-right",
    justify: !1,
    symbolShape: "square",
    symbolSize: 16,
    symbolSpacing: 8
}, x = {
    length: 200,
    thickness: 16,
    direction: "row",
    tickPosition: "after",
    tickSize: 4,
    tickSpacing: 3,
    tickOverlap: !1,
    tickFormat: function(t) {
        return "" + t;
    },
    titleAlign: "start",
    titleOffset: 4
}, S = {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
}, A = function(t) {
    var e, i = t.direction, n = t.itemsSpacing, o = t.padding, r = t.itemCount, l = t.itemWidth, a = t.itemHeight;
    if ("number" != typeof o && ("object" != typeof (e = o) || Array.isArray(e) || null === e)) throw new Error("Invalid property padding, must be one of: number, object");
    var c = "number" == typeof o ? {
        top: o,
        right: o,
        bottom: o,
        left: o
    } : b({}, S, o), s = c.left + c.right, d = c.top + c.bottom, h = l + s, g = a + d, m = (r - 1) * n;
    return "row" === i ? h = l * r + m + s : "column" === i && (g = a * r + m + d), {
        width: h,
        height: g,
        padding: c
    };
}, C = function(t) {
    var e = t.anchor, i = t.translateX, n = t.translateY, o = t.containerWidth, r = t.containerHeight, l = t.width, a = t.height, c = i, s = n;
    switch(e){
        case "top":
            c += (o - l) / 2;
            break;
        case "top-right":
            c += o - l;
            break;
        case "right":
            c += o - l, s += (r - a) / 2;
            break;
        case "bottom-right":
            c += o - l, s += r - a;
            break;
        case "bottom":
            c += (o - l) / 2, s += r - a;
            break;
        case "bottom-left":
            s += r - a;
            break;
        case "left":
            s += (r - a) / 2;
            break;
        case "center":
            c += (o - l) / 2, s += (r - a) / 2;
    }
    return {
        x: c,
        y: s
    };
}, z = function(t) {
    var e, i, n, o, r, l, a = t.direction, c = t.justify, s = t.symbolSize, d = t.symbolSpacing, h = t.width, g = t.height;
    switch(a){
        case "left-to-right":
            e = 0, i = (g - s) / 2, o = g / 2, l = "central", c ? (n = h, r = "end") : (n = s + d, r = "start");
            break;
        case "right-to-left":
            e = h - s, i = (g - s) / 2, o = g / 2, l = "central", c ? (n = 0, r = "start") : (n = h - s - d, r = "end");
            break;
        case "top-to-bottom":
            e = (h - s) / 2, i = 0, n = h / 2, r = "middle", c ? (o = g, l = "alphabetic") : (o = s + d, l = "text-before-edge");
            break;
        case "bottom-to-top":
            e = (h - s) / 2, i = g - s, n = h / 2, r = "middle", c ? (o = 0, l = "text-before-edge") : (o = g - s - d, l = "alphabetic");
    }
    return {
        symbolX: e,
        symbolY: i,
        labelX: n,
        labelY: o,
        labelAnchor: r,
        labelAlignment: l
    };
}, W = function(t) {
    var e, o = t.scale, l = t.ticks, a = t.length, c = void 0 === a ? x.length : a, s = t.thickness, d = void 0 === s ? x.thickness : s, h = t.direction, g = void 0 === h ? x.direction : h, m = t.tickPosition, f = void 0 === m ? x.tickPosition : m, v = t.tickSize, u = void 0 === v ? x.tickSize : v, p = t.tickSpacing, y = void 0 === p ? x.tickSpacing : p, b = t.tickOverlap, k = void 0 === b ? x.tickOverlap : b, S = t.tickFormat, A = void 0 === S ? x.tickFormat : S, C = t.title, z = t.titleAlign, W = void 0 === z ? x.titleAlign : z, w = t.titleOffset, X = void 0 === w ? x.titleOffset : w, Y = "column" === g ? [].concat(o.domain()).reverse() : o.domain(), O = (0, _d3Scale.scaleLinear)().domain(Y);
    2 === Y.length ? O.range([
        0,
        c
    ]) : 3 === Y.length && O.range([
        0,
        c / 2,
        c
    ]), e = "thresholds" in o ? [
        Y[0]
    ].concat(o.thresholds(), [
        Y[1]
    ]) : Array.isArray(l) ? l : o.ticks(l);
    var B, H, E, j, L, M, P = (0, _colors.computeContinuousColorScaleColorStops)(o, 32), F = (0, _core.getValueFormatter)(A), T = [], V = 0, D = 0;
    if ("row" === g) {
        var R, q, G;
        B = c, H = d, D = 1;
        var I;
        L = 0, E = "start" === W ? 0 : "middle" === W ? c / 2 : c, "before" === f ? (R = -u, q = k ? d : 0, G = -u - y, I = "alphabetic", j = d + X, M = "hanging") : (R = k ? 0 : d, G = (q = d + u) + y, I = "hanging", j = -X, M = "alphabetic"), e.forEach(function(t) {
            var e = O(t);
            T.push({
                x1: e,
                y1: R,
                x2: e,
                y2: q,
                text: F(t),
                textX: e,
                textY: G,
                textHorizontalAlign: "middle",
                textVerticalAlign: I
            });
        });
    } else {
        var _, J, K, N;
        B = d, H = c, V = 1;
        L = -90, j = "start" === W ? c : "middle" === W ? c / 2 : 0, "before" === f ? (J = k ? d : 0, K = (_ = -u) - y, N = "end", E = d + X, M = "hanging") : (_ = k ? 0 : d, K = (J = d + u) + y, N = "start", E = -X, M = "alphabetic"), e.forEach(function(t) {
            var e = O(t);
            T.push({
                x1: _,
                y1: e,
                x2: J,
                y2: e,
                text: F(t),
                textX: K,
                textY: e,
                textHorizontalAlign: N,
                textVerticalAlign: "central"
            });
        });
    }
    return {
        width: B,
        height: H,
        gradientX1: 0,
        gradientY1: V,
        gradientX2: D,
        gradientY2: 0,
        colorStops: P,
        ticks: T,
        titleText: C,
        titleX: E,
        titleY: j,
        titleRotation: L,
        titleHorizontalAlign: W,
        titleVerticalAlign: M
    };
}, w = function(i) {
    var n = i.scale, o = i.ticks, r = i.length, l = void 0 === r ? x.length : r, c = i.thickness, s = void 0 === c ? x.thickness : c, d = i.direction, m = void 0 === d ? x.direction : d, f = i.tickPosition, v = void 0 === f ? x.tickPosition : f, u = i.tickSize, p = void 0 === u ? x.tickSize : u, y = i.tickSpacing, b = void 0 === y ? x.tickSpacing : y, k = i.tickOverlap, S = void 0 === k ? x.tickOverlap : k, A = i.tickFormat, C = void 0 === A ? x.tickFormat : A, z = i.title, w = i.titleAlign, X = void 0 === w ? x.titleAlign : w, Y = i.titleOffset, O = W({
        scale: n,
        ticks: o,
        length: l,
        thickness: s,
        direction: m,
        tickPosition: v,
        tickSize: p,
        tickSpacing: b,
        tickOverlap: S,
        tickFormat: C,
        title: z,
        titleAlign: X,
        titleOffset: void 0 === Y ? x.titleOffset : Y
    }), B = O.width, H = O.height, E = O.gradientX1, j = O.gradientY1, L = O.gradientX2, M = O.gradientY2, P = O.ticks, F = O.colorStops, T = O.titleText, V = O.titleX, D = O.titleY, R = O.titleRotation, q = O.titleVerticalAlign, G = O.titleHorizontalAlign, I = (0, _theming.useTheme)(), _ = "ContinuousColorsLegendSvgGradient." + m + "." + F.map(function(t) {
        return t.stopColor.replace(/[(),\s]/g, "") + "." + t.offset;
    }).join("_");
    return (0, _jsxRuntime.jsxs)("g", {
        children: [
            (0, _jsxRuntime.jsx)("defs", {
                children: (0, _jsxRuntime.jsx)("linearGradient", {
                    id: _,
                    x1: E,
                    y1: j,
                    x2: L,
                    y2: M,
                    children: F.map(function(e) {
                        return (0, _jsxRuntime.jsx)("stop", {
                            offset: e.offset,
                            stopColor: e.stopColor
                        }, e.key);
                    })
                })
            }),
            T && (0, _jsxRuntime.jsx)("text", {
                transform: "translate(" + V + ", " + D + ") rotate(" + R + ")",
                textAnchor: G,
                dominantBaseline: q,
                style: I.legends.title.text,
                children: T
            }),
            (0, _jsxRuntime.jsx)("rect", {
                width: B,
                height: H,
                fill: "url(#" + _
            }),
            P.map(function(i, n) {
                return (0, _jsxRuntime.jsxs)((0, _react.Fragment), {
                    children: [
                        (0, _jsxRuntime.jsx)("line", {
                            x1: i.x1,
                            y1: i.y1,
                            x2: i.x2,
                            y2: i.y2,
                            style: I.legends.ticks.line
                        }),
                        (0, _jsxRuntime.jsx)((0, _text.Text), {
                            x: i.textX,
                            y: i.textY,
                            textAnchor: i.textHorizontalAlign,
                            dominantBaseline: i.textVerticalAlign,
                            style: I.legends.ticks.text,
                            children: i.text
                        })
                    ]
                }, n);
            })
        ]
    });
}, X = [
    "containerWidth",
    "containerHeight",
    "anchor",
    "translateX",
    "translateY",
    "length",
    "thickness",
    "direction"
], Y = function(e) {
    var i, n, o = e.containerWidth, r = e.containerHeight, l = e.anchor, a = e.translateX, c = void 0 === a ? 0 : a, s = e.translateY, d = void 0 === s ? 0 : s, h = e.length, g = void 0 === h ? x.length : h, m = e.thickness, f = void 0 === m ? x.thickness : m, v = e.direction, u = void 0 === v ? x.direction : v, p = function(t, e) {
        if (null == t) return {};
        var i = {};
        for(var n in t)if (({}).hasOwnProperty.call(t, n)) {
            if (-1 !== e.indexOf(n)) continue;
            i[n] = t[n];
        }
        return i;
    }(e, X);
    "row" === u ? (i = g, n = f) : (i = f, n = g);
    var y = C({
        anchor: l,
        translateX: c,
        translateY: d,
        containerWidth: o,
        containerHeight: r,
        width: i,
        height: n
    }), k = y.x, S = y.y;
    return (0, _jsxRuntime.jsx)("g", {
        transform: "translate(" + k + ", " + S + ")",
        children: (0, _jsxRuntime.jsx)(w, b({
            length: g,
            thickness: f,
            direction: u
        }, p))
    });
}, O = {
    circle: v,
    diamond: u,
    square: p,
    triangle: y
}, B = function(i) {
    var n, o, r, a, d, m, f, v, u, p, y, x = i.x, S = i.y, A = i.width, C = i.height, W = i.data, w = i.direction, X = void 0 === w ? k.itemDirection : w, Y = i.justify, B = void 0 === Y ? k.justify : Y, H = i.textColor, E = i.background, j = void 0 === E ? "transparent" : E, L = i.opacity, M = void 0 === L ? 1 : L, P = i.symbolShape, F = void 0 === P ? k.symbolShape : P, T = i.symbolSize, V = void 0 === T ? k.symbolSize : T, D = i.symbolSpacing, R = void 0 === D ? k.symbolSpacing : D, q = i.symbolBorderWidth, G = void 0 === q ? 0 : q, I = i.symbolBorderColor, _ = void 0 === I ? "transparent" : I, J = i.onClick, K = i.onMouseEnter, N = i.onMouseLeave, Q = i.toggleSerie, U = i.effects, Z = (0, _react.useState)({}), $ = Z[0], tt = Z[1], et = (0, _theming.useTheme)(), it = (0, _react.useCallback)(function(t) {
        if (U) {
            var e = U.filter(function(t) {
                return "hover" === t.on;
            }).reduce(function(t, e) {
                return b({}, t, e.style);
            }, {});
            tt(e);
        }
        null == K || K(W, t);
    }, [
        K,
        W,
        U
    ]), nt = (0, _react.useCallback)(function(t) {
        if (U) {
            var e = U.filter(function(t) {
                return "hover" !== t.on;
            }).reduce(function(t, e) {
                return b({}, t, e.style);
            }, {});
            tt(e);
        }
        null == N || N(W, t);
    }, [
        N,
        W,
        U
    ]), ot = z({
        direction: X,
        justify: B,
        symbolSize: null != (n = $.symbolSize) ? n : V,
        symbolSpacing: R,
        width: A,
        height: C
    }), rt = ot.symbolX, lt = ot.symbolY, at = ot.labelX, ct = ot.labelY, st = ot.labelAnchor, dt = ot.labelAlignment, ht = [
        J,
        K,
        N,
        Q
    ].some(function(t) {
        return void 0 !== t;
    }), gt = "function" == typeof F ? F : O[F];
    return (0, _jsxRuntime.jsxs)("g", {
        transform: "translate(" + x + "," + S + ")",
        style: {
            opacity: null != (o = $.itemOpacity) ? o : M
        },
        children: [
            (0, _jsxRuntime.jsx)("rect", {
                width: A,
                height: C,
                fill: null != (r = $.itemBackground) ? r : j,
                style: {
                    cursor: ht ? "pointer" : "auto"
                },
                onClick: function(t) {
                    null == J || J(W, t), null == Q || Q(W.id);
                },
                onMouseEnter: it,
                onMouseLeave: nt
            }),
            _react.createElement(gt, b({
                id: W.id,
                x: rt,
                y: lt,
                size: null != (a = $.symbolSize) ? a : V,
                fill: null != (d = null != (m = W.fill) ? m : W.color) ? d : "black",
                borderWidth: null != (f = $.symbolBorderWidth) ? f : G,
                borderColor: null != (v = $.symbolBorderColor) ? v : _
            }, W.hidden ? et.legends.hidden.symbol : void 0)),
            (0, _jsxRuntime.jsx)((0, _text.Text), {
                textAnchor: st,
                style: b({}, et.legends.text, {
                    fill: null != (u = null != (p = null != (y = $.itemTextColor) ? y : H) ? p : et.legends.text.fill) ? u : "black",
                    dominantBaseline: dt,
                    pointerEvents: "none",
                    userSelect: "none"
                }, W.hidden ? et.legends.hidden.text : void 0),
                x: at,
                y: ct,
                children: W.label
            })
        ]
    });
}, H = function(e) {
    var i = e.data, n = e.x, o = e.y, r = e.direction, l = e.padding, a = void 0 === l ? k.padding : l, c = e.justify, s = e.effects, d = e.itemWidth, h = e.itemHeight, g = e.itemDirection, m = void 0 === g ? k.itemDirection : g, f = e.itemsSpacing, v = void 0 === f ? k.itemsSpacing : f, u = e.itemTextColor, p = e.itemBackground, y = void 0 === p ? "transparent" : p, b = e.itemOpacity, x = void 0 === b ? 1 : b, S = e.symbolShape, C = e.symbolSize, z = e.symbolSpacing, W = e.symbolBorderWidth, w = e.symbolBorderColor, X = e.onClick, Y = e.onMouseEnter, O = e.onMouseLeave, H = e.toggleSerie, E = A({
        itemCount: i.length,
        itemWidth: d,
        itemHeight: h,
        itemsSpacing: v,
        direction: r,
        padding: a
    }).padding, j = "row" === r ? d + v : 0, L = "column" === r ? h + v : 0;
    return (0, _jsxRuntime.jsx)("g", {
        transform: "translate(" + n + "," + o + ")",
        children: i.map(function(e, i) {
            return (0, _jsxRuntime.jsx)(B, {
                data: e,
                x: i * j + E.left,
                y: i * L + E.top,
                width: d,
                height: h,
                direction: m,
                justify: c,
                effects: s,
                textColor: u,
                background: y,
                opacity: x,
                symbolShape: S,
                symbolSize: C,
                symbolSpacing: z,
                symbolBorderWidth: W,
                symbolBorderColor: w,
                onClick: X,
                onMouseEnter: Y,
                onMouseLeave: O,
                toggleSerie: H
            }, i);
        })
    });
}, E = function(e) {
    var i = e.data, n = e.containerWidth, o = e.containerHeight, r = e.translateX, l = void 0 === r ? k.translateX : r, a = e.translateY, c = void 0 === a ? k.translateY : a, s = e.anchor, d = e.direction, h = e.padding, g = void 0 === h ? k.padding : h, m = e.justify, f = e.itemsSpacing, v = void 0 === f ? k.itemsSpacing : f, u = e.itemWidth, p = e.itemHeight, y = e.itemDirection, b = e.itemTextColor, x = e.itemBackground, S = e.itemOpacity, z = e.symbolShape, W = e.symbolSize, w = e.symbolSpacing, X = e.symbolBorderWidth, Y = e.symbolBorderColor, O = e.onClick, B = e.onMouseEnter, E = e.onMouseLeave, j = e.toggleSerie, L = e.effects, M = A({
        itemCount: i.length,
        itemsSpacing: v,
        itemWidth: u,
        itemHeight: p,
        direction: d,
        padding: g
    }), P = M.width, F = M.height, T = C({
        anchor: s,
        translateX: l,
        translateY: c,
        containerWidth: n,
        containerHeight: o,
        width: P,
        height: F
    }), V = T.x, D = T.y;
    return (0, _jsxRuntime.jsx)(H, {
        data: i,
        x: V,
        y: D,
        direction: d,
        padding: g,
        justify: m,
        effects: L,
        itemsSpacing: v,
        itemWidth: u,
        itemHeight: p,
        itemDirection: y,
        itemTextColor: b,
        itemBackground: x,
        itemOpacity: S,
        symbolShape: z,
        symbolSize: W,
        symbolSpacing: w,
        symbolBorderWidth: X,
        symbolBorderColor: Y,
        onClick: O,
        onMouseEnter: B,
        onMouseLeave: E,
        toggleSerie: "boolean" == typeof j ? void 0 : j
    });
}, j = {
    start: "left",
    middle: "center",
    end: "right"
}, L = function(t, e) {
    var i = e.data, n = e.containerWidth, o = e.containerHeight, r = e.translateX, l = void 0 === r ? 0 : r, a = e.translateY, c = void 0 === a ? 0 : a, s = e.anchor, d = e.direction, h = e.padding, g = void 0 === h ? 0 : h, v = e.justify, u = void 0 !== v && v, p = e.itemsSpacing, y = void 0 === p ? 0 : p, k = e.itemWidth, x = e.itemHeight, S = e.itemDirection, W = void 0 === S ? "left-to-right" : S, w = e.itemTextColor, X = e.symbolSize, Y = void 0 === X ? 16 : X, O = e.symbolSpacing, B = void 0 === O ? 8 : O, H = e.theme, E = A({
        itemCount: i.length,
        itemWidth: k,
        itemHeight: x,
        itemsSpacing: y,
        direction: d,
        padding: g
    }), L = E.width, M = E.height, P = E.padding, F = C({
        anchor: s,
        translateX: l,
        translateY: c,
        containerWidth: n,
        containerHeight: o,
        width: L,
        height: M
    }), T = F.x, V = F.y, D = "row" === d ? k + y : 0, R = "column" === d ? x + y : 0;
    t.save(), t.translate(T, V), (0, _text.setCanvasFont)(t, H.legends.text), i.forEach(function(e, i) {
        var n, o = i * D + P.left, r = i * R + P.top, l = z({
            direction: W,
            justify: u,
            symbolSize: Y,
            symbolSpacing: B,
            width: k,
            height: x
        }), a = l.symbolX, c = l.symbolY, s = l.labelX, d = l.labelY, h = l.labelAnchor, g = l.labelAlignment;
        t.fillStyle = null != (n = e.color) ? n : "black", t.fillRect(o + a, r + c, Y, Y), t.textAlign = j[h], "central" === g && (t.textBaseline = "middle"), (0, _text.drawCanvasText)(t, b({}, H.legends.text, {
            fill: null != w ? w : H.legends.text.fill
        }), String(e.label), o + s, r + d);
    }), t.restore();
}, M = function(t, e) {
    var i, n = e.containerWidth, r = e.containerHeight, l = e.anchor, a = e.translateX, c = void 0 === a ? 0 : a, s = e.translateY, d = void 0 === s ? 0 : s, h = e.scale, g = e.length, v = void 0 === g ? x.length : g, u = e.thickness, p = void 0 === u ? x.thickness : u, y = e.direction, b = void 0 === y ? x.direction : y, k = e.ticks, S = e.tickPosition, A = void 0 === S ? x.tickPosition : S, z = e.tickSize, w = void 0 === z ? x.tickSize : z, X = e.tickSpacing, Y = void 0 === X ? x.tickSpacing : X, O = e.tickOverlap, B = void 0 === O ? x.tickOverlap : O, H = e.tickFormat, E = void 0 === H ? x.tickFormat : H, j = e.title, L = e.titleAlign, M = void 0 === L ? x.titleAlign : L, P = e.titleOffset, F = void 0 === P ? x.titleOffset : P, T = e.theme, V = W({
        scale: h,
        ticks: k,
        length: v,
        thickness: p,
        direction: b,
        tickPosition: A,
        tickSize: w,
        tickSpacing: Y,
        tickOverlap: B,
        tickFormat: E,
        title: j,
        titleAlign: M,
        titleOffset: F
    }), D = V.width, R = V.height, q = V.gradientX1, G = V.gradientY1, I = V.gradientX2, _ = V.gradientY2, J = V.colorStops, K = V.ticks, N = V.titleText, Q = V.titleX, U = V.titleY, Z = V.titleRotation, $ = V.titleVerticalAlign, tt = V.titleHorizontalAlign, et = C({
        anchor: l,
        translateX: c,
        translateY: d,
        containerWidth: n,
        containerHeight: r,
        width: D,
        height: R
    }), it = et.x, nt = et.y, ot = {
        font: t.font,
        textAlign: t.textAlign,
        textBaseline: t.textBaseline
    };
    t.save(), t.translate(it, nt);
    var rt = t.createLinearGradient(q * D, G * R, I * D, _ * R);
    J.forEach(function(t) {
        rt.addColorStop(t.offset, t.stopColor);
    }), t.fillStyle = rt, t.fillRect(0, 0, D, R), (0, _text.setCanvasFont)(t, T.legends.ticks.text);
    var lt = null != (i = T.legends.ticks.line.strokeWidth) ? i : 0, at = "string" != typeof lt && lt > 0;
    K.forEach(function(e) {
        at && (t.lineWidth = lt, T.axis.ticks.line.stroke && (t.strokeStyle = T.axis.ticks.line.stroke), t.lineCap = "square", t.beginPath(), t.moveTo(e.x1, e.y1), t.lineTo(e.x2, e.y2), t.stroke()), t.textAlign = "middle" === e.textHorizontalAlign ? "center" : e.textHorizontalAlign, t.textBaseline = "central" === e.textVerticalAlign ? "middle" : e.textVerticalAlign, (0, _text.drawCanvasText)(t, T.legends.ticks.text, e.text, e.textX, e.textY);
    }), N && (t.save(), t.translate(Q, U), t.rotate((0, _core.degreesToRadians)(Z)), (0, _text.setCanvasFont)(t, T.legends.title.text), t.textAlign = "middle" === tt ? "center" : tt, t.textBaseline = $, (0, _text.drawCanvasText)(t, T.legends.title.text, N), t.restore()), t.restore(), t.font = ot.font, t.textAlign = ot.textAlign, t.textBaseline = ot.textBaseline;
}, P = function(t) {
    var e = t.scale, i = t.domain, n = t.reverse, o = void 0 !== n && n, r = t.valueFormat, l = void 0 === r ? function(t) {
        return t;
    } : r, a = t.separator, c = void 0 === a ? " - " : a;
    return (0, _react.useMemo)(function() {
        var t = (null != i ? i : e.range()).map(function(t, i) {
            var n = e.invertExtent(t), o = n[0], r = n[1];
            return {
                id: t,
                index: i,
                extent: [
                    o,
                    r
                ],
                label: "" + l(o) + c + l(r),
                value: e(o),
                color: t
            };
        });
        return o && t.reverse(), t;
    }, [
        i,
        e,
        o,
        c,
        l
    ]);
};

},{"react/jsx-runtime":"gaGEj","d3-scale":"7BK9l","@nivo/core":"3e9EB","@nivo/colors":"kpdUa","react":"6uln9","@nivo/theming":"kiBiP","@nivo/text":"5EjSJ","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"kpdUa":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "categoricalColorSchemeIds", ()=>Ve);
parcelHelpers.export(exports, "categoricalColorSchemes", ()=>Ge);
parcelHelpers.export(exports, "colorInterpolatorIds", ()=>Ne);
parcelHelpers.export(exports, "colorInterpolators", ()=>Le);
parcelHelpers.export(exports, "colorSchemeIds", ()=>Be);
parcelHelpers.export(exports, "colorSchemes", ()=>$e);
parcelHelpers.export(exports, "computeContinuousColorScaleColorStops", ()=>mr);
parcelHelpers.export(exports, "cyclicalColorInterpolators", ()=>Ke);
parcelHelpers.export(exports, "divergingColorInterpolators", ()=>Ue);
parcelHelpers.export(exports, "divergingColorScaleDefaults", ()=>nr);
parcelHelpers.export(exports, "divergingColorSchemeIds", ()=>Re);
parcelHelpers.export(exports, "divergingColorSchemes", ()=>Pe);
parcelHelpers.export(exports, "getContinuousColorScale", ()=>pr);
parcelHelpers.export(exports, "getDivergingColorScale", ()=>tr);
parcelHelpers.export(exports, "getInheritedColorGenerator", ()=>Xe);
parcelHelpers.export(exports, "getOrdinalColorScale", ()=>gr);
parcelHelpers.export(exports, "getQuantizeColorScale", ()=>ur);
parcelHelpers.export(exports, "getSequentialColorScale", ()=>er);
parcelHelpers.export(exports, "isCategoricalColorScheme", ()=>Fe);
parcelHelpers.export(exports, "isContinuousColorScale", ()=>fr);
parcelHelpers.export(exports, "isDivergingColorScaleConfig", ()=>cr);
parcelHelpers.export(exports, "isDivergingColorScheme", ()=>He);
parcelHelpers.export(exports, "isInheritedColorConfigFromContext", ()=>We);
parcelHelpers.export(exports, "isInheritedColorConfigFromTheme", ()=>Qe);
parcelHelpers.export(exports, "isQuantizeColorScaleConfig", ()=>sr);
parcelHelpers.export(exports, "isSequentialColorScaleConfig", ()=>ar);
parcelHelpers.export(exports, "isSequentialColorScheme", ()=>Je);
parcelHelpers.export(exports, "quantizeColorScaleDefaults", ()=>ir);
parcelHelpers.export(exports, "sequentialColorInterpolators", ()=>Te);
parcelHelpers.export(exports, "sequentialColorScaleDefaults", ()=>Ze);
parcelHelpers.export(exports, "sequentialColorSchemeIds", ()=>Me);
parcelHelpers.export(exports, "sequentialColorSchemes", ()=>De);
parcelHelpers.export(exports, "useContinuousColorScale", ()=>dr);
parcelHelpers.export(exports, "useDivergingColorScale", ()=>or);
parcelHelpers.export(exports, "useInheritedColor", ()=>Ye);
parcelHelpers.export(exports, "useOrdinalColorScale", ()=>hr);
parcelHelpers.export(exports, "useQuantizeColorScale", ()=>lr);
parcelHelpers.export(exports, "useSequentialColorScale", ()=>rr);
var _d3ScaleChromatic = require("d3-scale-chromatic");
var _react = require("react");
var _getJs = require("lodash/get.js");
var _getJsDefault = parcelHelpers.interopDefault(_getJs);
var _isPlainObjectJs = require("lodash/isPlainObject.js");
var _isPlainObjectJsDefault = parcelHelpers.interopDefault(_isPlainObjectJs);
var _d3Color = require("d3-color");
var _d3Scale = require("d3-scale");
function Se(e, r) {
    (null == r || r > e.length) && (r = e.length);
    for(var n = 0, t = Array(r); n < r; n++)t[n] = e[n];
    return t;
}
function qe(e, r) {
    var n = "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
    if (n) return (n = n.call(e)).next.bind(n);
    if (Array.isArray(e) || (n = function(e, r) {
        if (e) {
            if ("string" == typeof e) return Se(e, r);
            var n = ({}).toString.call(e).slice(8, -1);
            return "Object" === n && e.constructor && (n = e.constructor.name), "Map" === n || "Set" === n ? Array.from(e) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? Se(e, r) : void 0;
        }
    }(e)) || r && e && "number" == typeof e.length) {
        n && (e = n);
        var t = 0;
        return function() {
            return t >= e.length ? {
                done: !0
            } : {
                done: !1,
                value: e[t++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function Ce() {
    return Ce = Object.assign ? Object.assign.bind() : function(e) {
        for(var r = 1; r < arguments.length; r++){
            var n = arguments[r];
            for(var t in n)({}).hasOwnProperty.call(n, t) && (e[t] = n[t]);
        }
        return e;
    }, Ce.apply(null, arguments);
}
var Ge = {
    nivo: [
        "#e8c1a0",
        "#f47560",
        "#f1e15b",
        "#e8a838",
        "#61cdbb",
        "#97e3d5"
    ],
    category10: (0, _d3ScaleChromatic.schemeCategory10),
    accent: (0, _d3ScaleChromatic.schemeAccent),
    dark2: (0, _d3ScaleChromatic.schemeDark2),
    paired: (0, _d3ScaleChromatic.schemePaired),
    pastel1: (0, _d3ScaleChromatic.schemePastel1),
    pastel2: (0, _d3ScaleChromatic.schemePastel2),
    set1: (0, _d3ScaleChromatic.schemeSet1),
    set2: (0, _d3ScaleChromatic.schemeSet2),
    set3: (0, _d3ScaleChromatic.schemeSet3),
    tableau10: (0, _d3ScaleChromatic.schemeTableau10)
}, Ve = Object.keys(Ge), Pe = {
    brown_blueGreen: (0, _d3ScaleChromatic.schemeBrBG),
    purpleRed_green: (0, _d3ScaleChromatic.schemePRGn),
    pink_yellowGreen: (0, _d3ScaleChromatic.schemePiYG),
    purple_orange: (0, _d3ScaleChromatic.schemePuOr),
    red_blue: (0, _d3ScaleChromatic.schemeRdBu),
    red_grey: (0, _d3ScaleChromatic.schemeRdGy),
    red_yellow_blue: (0, _d3ScaleChromatic.schemeRdYlBu),
    red_yellow_green: (0, _d3ScaleChromatic.schemeRdYlGn),
    spectral: (0, _d3ScaleChromatic.schemeSpectral)
}, Re = Object.keys(Pe), Ue = {
    brown_blueGreen: (0, _d3ScaleChromatic.interpolateBrBG),
    purpleRed_green: (0, _d3ScaleChromatic.interpolatePRGn),
    pink_yellowGreen: (0, _d3ScaleChromatic.interpolatePiYG),
    purple_orange: (0, _d3ScaleChromatic.interpolatePuOr),
    red_blue: (0, _d3ScaleChromatic.interpolateRdBu),
    red_grey: (0, _d3ScaleChromatic.interpolateRdGy),
    red_yellow_blue: (0, _d3ScaleChromatic.interpolateRdYlBu),
    red_yellow_green: (0, _d3ScaleChromatic.interpolateRdYlGn),
    spectral: (0, _d3ScaleChromatic.interpolateSpectral)
}, De = {
    blues: (0, _d3ScaleChromatic.schemeBlues),
    greens: (0, _d3ScaleChromatic.schemeGreens),
    greys: (0, _d3ScaleChromatic.schemeGreys),
    oranges: (0, _d3ScaleChromatic.schemeOranges),
    purples: (0, _d3ScaleChromatic.schemePurples),
    reds: (0, _d3ScaleChromatic.schemeReds),
    blue_green: (0, _d3ScaleChromatic.schemeBuGn),
    blue_purple: (0, _d3ScaleChromatic.schemeBuPu),
    green_blue: (0, _d3ScaleChromatic.schemeGnBu),
    orange_red: (0, _d3ScaleChromatic.schemeOrRd),
    purple_blue_green: (0, _d3ScaleChromatic.schemePuBuGn),
    purple_blue: (0, _d3ScaleChromatic.schemePuBu),
    purple_red: (0, _d3ScaleChromatic.schemePuRd),
    red_purple: (0, _d3ScaleChromatic.schemeRdPu),
    yellow_green_blue: (0, _d3ScaleChromatic.schemeYlGnBu),
    yellow_green: (0, _d3ScaleChromatic.schemeYlGn),
    yellow_orange_brown: (0, _d3ScaleChromatic.schemeYlOrBr),
    yellow_orange_red: (0, _d3ScaleChromatic.schemeYlOrRd)
}, Me = Object.keys(De), Te = {
    blues: (0, _d3ScaleChromatic.interpolateBlues),
    greens: (0, _d3ScaleChromatic.interpolateGreens),
    greys: (0, _d3ScaleChromatic.interpolateGreys),
    oranges: (0, _d3ScaleChromatic.interpolateOranges),
    purples: (0, _d3ScaleChromatic.interpolatePurples),
    reds: (0, _d3ScaleChromatic.interpolateReds),
    turbo: (0, _d3ScaleChromatic.interpolateTurbo),
    viridis: (0, _d3ScaleChromatic.interpolateViridis),
    inferno: (0, _d3ScaleChromatic.interpolateInferno),
    magma: (0, _d3ScaleChromatic.interpolateMagma),
    plasma: (0, _d3ScaleChromatic.interpolatePlasma),
    cividis: (0, _d3ScaleChromatic.interpolateCividis),
    warm: (0, _d3ScaleChromatic.interpolateWarm),
    cool: (0, _d3ScaleChromatic.interpolateCool),
    cubehelixDefault: (0, _d3ScaleChromatic.interpolateCubehelixDefault),
    blue_green: (0, _d3ScaleChromatic.interpolateBuGn),
    blue_purple: (0, _d3ScaleChromatic.interpolateBuPu),
    green_blue: (0, _d3ScaleChromatic.interpolateGnBu),
    orange_red: (0, _d3ScaleChromatic.interpolateOrRd),
    purple_blue_green: (0, _d3ScaleChromatic.interpolatePuBuGn),
    purple_blue: (0, _d3ScaleChromatic.interpolatePuBu),
    purple_red: (0, _d3ScaleChromatic.interpolatePuRd),
    red_purple: (0, _d3ScaleChromatic.interpolateRdPu),
    yellow_green_blue: (0, _d3ScaleChromatic.interpolateYlGnBu),
    yellow_green: (0, _d3ScaleChromatic.interpolateYlGn),
    yellow_orange_brown: (0, _d3ScaleChromatic.interpolateYlOrBr),
    yellow_orange_red: (0, _d3ScaleChromatic.interpolateYlOrRd)
}, $e = Ce({}, Ge, Pe, De), Be = Object.keys($e), Fe = function(e) {
    return Ve.includes(e);
}, He = function(e) {
    return Re.includes(e);
}, Je = function(e) {
    return Me.includes(e);
}, Ke = {
    rainbow: (0, _d3ScaleChromatic.interpolateRainbow),
    sinebow: (0, _d3ScaleChromatic.interpolateSinebow)
}, Le = Ce({}, Ue, Te, Ke), Ne = Object.keys(Le), Qe = function(e) {
    return void 0 !== e.theme;
}, We = function(e) {
    return void 0 !== e.from;
}, Xe = function(e, r) {
    if ("function" == typeof e) return e;
    if ((0, _isPlainObjectJsDefault.default)(e)) {
        if (Qe(e)) {
            if (void 0 === r) throw new Error("Unable to use color from theme as no theme was provided");
            var n = (0, _getJsDefault.default)(r, e.theme);
            if (void 0 === n) throw new Error("Color from theme is undefined at path: '" + e.theme + "'");
            return function() {
                return n;
            };
        }
        if (We(e)) {
            var t = function(r) {
                return (0, _getJsDefault.default)(r, e.from);
            };
            if (Array.isArray(e.modifiers)) {
                for(var o, i = [], u = function() {
                    var e = o.value, r = e[0], n = e[1];
                    if ("brighter" === r) i.push(function(e) {
                        return e.brighter(n);
                    });
                    else if ("darker" === r) i.push(function(e) {
                        return e.darker(n);
                    });
                    else {
                        if ("opacity" !== r) throw new Error("Invalid color modifier: '" + r + "', must be one of: 'brighter', 'darker', 'opacity'");
                        i.push(function(e) {
                            return e.opacity = n, e;
                        });
                    }
                }, l = qe(e.modifiers); !(o = l()).done;)u();
                return 0 === i.length ? t : function(e) {
                    return i.reduce(function(e, r) {
                        return r(e);
                    }, (0, _d3Color.rgb)(t(e))).toString();
                };
            }
            return t;
        }
        throw new Error("Invalid color spec, you should either specify 'theme' or 'from' when using a config object");
    }
    return function() {
        return e;
    };
}, Ye = function(e, r) {
    return (0, _react.useMemo)(function() {
        return Xe(e, r);
    }, [
        e,
        r
    ]);
}, Ze = {
    scheme: "turbo"
}, er = function(e, r) {
    var n = e.minValue, t = e.maxValue, o = void 0 !== n ? n : r.min, i = void 0 !== t ? t : r.max, u = (0, _d3Scale.scaleSequential)().domain([
        o,
        i
    ]).clamp(!0);
    if ("colors" in e) u.range(e.colors);
    else if ("interpolator" in e) u.interpolator(e.interpolator);
    else {
        var l, a = null != (l = e.scheme) ? l : Ze.scheme;
        u.interpolator(Le[a]);
    }
    return u;
}, rr = function(e, r) {
    return (0, _react.useMemo)(function() {
        return er(e, r);
    }, [
        e,
        r
    ]);
}, nr = {
    scheme: "red_yellow_blue",
    divergeAt: .5
}, tr = function(e, r) {
    var n, t = e.minValue, o = e.maxValue, i = void 0 !== t ? t : r.min, u = void 0 !== o ? o : r.max, l = [
        i,
        i + (u - i) / 2,
        u
    ], a = .5 - (null != (n = e.divergeAt) ? n : nr.divergeAt), c = (0, _d3Scale.scaleDiverging)().domain(l).clamp(!0), s = function(e) {
        return String(e);
    };
    if ("colors" in e) s = (0, _d3Scale.scaleDiverging)().domain(l.map(function(e) {
        return e - a * (u - i);
    })).range(e.colors).interpolator();
    else if ("interpolator" in e) s = e.interpolator;
    else {
        var f, p = null != (f = e.scheme) ? f : nr.scheme;
        s = Le[p];
    }
    return c.interpolator(function(e) {
        return s(e + a);
    });
}, or = function(e, r) {
    return (0, _react.useMemo)(function() {
        return tr(e, r);
    }, [
        e,
        r
    ]);
}, ir = {
    scheme: "turbo",
    steps: 7
}, ur = function(e, r) {
    var n = (0, _d3Scale.scaleQuantize)().domain(e.domain || [
        r.min,
        r.max
    ]).nice();
    if ("colors" in e) n.range(e.colors);
    else {
        var t = e.scheme || ir.scheme, o = void 0 === e.steps ? ir.steps : e.steps, i = Le[t], u = Array.from({
            length: o
        }).map(function(e, r) {
            return i(r * (1 / (o - 1)));
        });
        n.range(u);
    }
    return n;
}, lr = function(e, r) {
    return (0, _react.useMemo)(function() {
        return ur(e, r);
    }, [
        e,
        r
    ]);
}, ar = function(e) {
    return "sequential" === e.type;
}, cr = function(e) {
    return "diverging" === e.type;
}, sr = function(e) {
    return "quantize" === e.type;
}, fr = function(e) {
    if (!(0, _isPlainObjectJsDefault.default)(e)) return !1;
    var r = e.type;
    return "sequential" === r || "diverging" === r || "quantize" === r;
}, pr = function(e, r) {
    if (ar(e)) return er(e, r);
    if (cr(e)) return tr(e, r);
    if (sr(e)) return ur(e, r);
    throw new Error("Invalid continuous color scale config");
}, dr = function(e, r) {
    return (0, _react.useMemo)(function() {
        return pr(e, r);
    }, [
        e,
        r
    ]);
}, mr = function(e, r) {
    void 0 === r && (r = 16);
    var n = e.domain();
    if ("thresholds" in e) {
        var t = [], o = (0, _d3Scale.scaleLinear)().domain(n).range([
            0,
            1
        ]);
        return e.range().forEach(function(r, n) {
            var i = e.invertExtent(r), u = i[0], l = i[1];
            t.push({
                key: n + ".0",
                offset: o(u),
                stopColor: r
            }), t.push({
                key: n + ".1",
                offset: o(l),
                stopColor: r
            });
        }), t;
    }
    var i = e.copy();
    return 2 === n.length ? i.domain([
        0,
        1
    ]) : 3 === n.length && i.domain([
        0,
        .5,
        1
    ]), i.ticks(r).map(function(e) {
        return {
            key: "" + e,
            offset: e,
            stopColor: "" + i(e)
        };
    });
}, gr = function(e, r) {
    if ("function" == typeof e) return e;
    var n = "function" == typeof r ? r : function(e) {
        return (0, _getJsDefault.default)(e, r);
    };
    if (Array.isArray(e)) {
        var t = (0, _d3Scale.scaleOrdinal)(e), o = function(e) {
            return t(n(e));
        };
        return o.scale = t, o;
    }
    if ((0, _isPlainObjectJsDefault.default)(e)) {
        if (function(e) {
            return void 0 !== e.datum;
        }(e)) return function(r) {
            return (0, _getJsDefault.default)(r, e.datum);
        };
        if (function(e) {
            return void 0 !== e.scheme;
        }(e)) {
            if (Fe(e.scheme)) {
                var i = (0, _d3Scale.scaleOrdinal)($e[e.scheme]), u = function(e) {
                    return i(n(e));
                };
                return u.scale = i, u;
            }
            if (He(e.scheme)) {
                if (void 0 !== e.size && (e.size < 3 || e.size > 11)) throw new Error("Invalid size '" + e.size + "' for diverging color scheme '" + e.scheme + "', must be between 3~11");
                var l = (0, _d3Scale.scaleOrdinal)($e[e.scheme][e.size || 11]), a = function(e) {
                    return l(n(e));
                };
                return a.scale = l, a;
            }
            if (Je(e.scheme)) {
                if (void 0 !== e.size && (e.size < 3 || e.size > 9)) throw new Error("Invalid size '" + e.size + "' for sequential color scheme '" + e.scheme + "', must be between 3~9");
                var c = (0, _d3Scale.scaleOrdinal)($e[e.scheme][e.size || 9]), s = function(e) {
                    return c(n(e));
                };
                return s.scale = c, s;
            }
        }
        throw new Error("Invalid colors, when using an object, you should either pass a 'datum' or a 'scheme' property");
    }
    return function() {
        return e;
    };
}, hr = function(e, r) {
    return (0, _react.useMemo)(function() {
        return gr(e, r);
    }, [
        e,
        r
    ]);
};

},{"d3-scale-chromatic":"3BbmN","react":"6uln9","lodash/get.js":"8z6tS","lodash/isPlainObject.js":"aYsgZ","d3-color":"euMEi","d3-scale":"7BK9l","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2tTWY":[function(require,module,exports) {
var toString = require("44aae548b0667b1d");
/** Used to generate unique IDs. */ var idCounter = 0;
/**
 * Generates a unique ID. If `prefix` is given, the ID is appended to it.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {string} [prefix=''] The value to prefix the ID with.
 * @returns {string} Returns the unique ID.
 * @example
 *
 * _.uniqueId('contact_');
 * // => 'contact_104'
 *
 * _.uniqueId();
 * // => '105'
 */ function uniqueId(prefix) {
    var id = ++idCounter;
    return toString(prefix) + id;
}
module.exports = uniqueId;

},{"44aae548b0667b1d":"j8269"}],"57p2d":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Mesh", ()=>j);
parcelHelpers.export(exports, "ResponsiveVoronoi", ()=>I);
parcelHelpers.export(exports, "Voronoi", ()=>H);
parcelHelpers.export(exports, "computeMesh", ()=>W);
parcelHelpers.export(exports, "computeMeshPoints", ()=>R);
parcelHelpers.export(exports, "defaultVoronoiProps", ()=>w);
parcelHelpers.export(exports, "renderDebugToCanvas", ()=>G);
parcelHelpers.export(exports, "renderDelaunayPointsToCanvas", ()=>B);
parcelHelpers.export(exports, "renderVoronoiCellToCanvas", ()=>q);
parcelHelpers.export(exports, "renderVoronoiToCanvas", ()=>F);
parcelHelpers.export(exports, "useMesh", ()=>z);
parcelHelpers.export(exports, "useMeshEvents", ()=>U);
parcelHelpers.export(exports, "useVoronoi", ()=>x);
parcelHelpers.export(exports, "useVoronoiLayerContext", ()=>S);
parcelHelpers.export(exports, "useVoronoiMesh", ()=>E);
var _react = require("react");
var _core = require("@nivo/core");
var _d3Scale = require("d3-scale");
var _d3Delaunay = require("d3-delaunay");
var _tooltip = require("@nivo/tooltip");
var _jsxRuntime = require("react/jsx-runtime");
function C() {
    return C = Object.assign ? Object.assign.bind() : function(n) {
        for(var o = 1; o < arguments.length; o++){
            var e = arguments[o];
            for(var i in e)({}).hasOwnProperty.call(e, i) && (n[i] = e[i]);
        }
        return n;
    }, C.apply(null, arguments);
}
function y(n, o) {
    if (null == n) return {};
    var e = {};
    for(var i in n)if (({}).hasOwnProperty.call(n, i)) {
        if (-1 !== o.indexOf(i)) continue;
        e[i] = n[i];
    }
    return e;
}
var w = {
    xDomain: [
        0,
        1
    ],
    yDomain: [
        0,
        1
    ],
    layers: [
        "links",
        "cells",
        "points",
        "bounds"
    ],
    enableLinks: !1,
    linkLineWidth: 1,
    linkLineColor: "#bbbbbb",
    enableCells: !0,
    cellLineWidth: 2,
    cellLineColor: "#000000",
    enablePoints: !0,
    pointSize: 4,
    pointColor: "#666666",
    role: "img"
}, D = function(n) {
    return [
        n.x,
        n.y
    ];
}, L = (0, _core.defaultMargin), T = "cursor", P = "top", R = function(n) {
    var o = n.points, e = n.getNodePosition, i = void 0 === e ? D : e, t = n.margin, l = void 0 === t ? L : t;
    return o.map(function(n) {
        var o = i(n), e = o[0], t = o[1];
        return [
            e + l.left,
            t + l.top
        ];
    });
}, W = function(n) {
    var o = n.points, e = n.width, i = n.height, t = n.margin, l = void 0 === t ? L : t, r = n.debug, u = (0, _d3Delaunay.Delaunay).from(o), a = r ? u.voronoi([
        0,
        0,
        l.left + e + l.right,
        l.top + i + l.bottom
    ]) : void 0;
    return {
        points: o,
        delaunay: u,
        voronoi: a
    };
}, E = function(o) {
    var e = o.points, i = o.getNodePosition, t = void 0 === i ? D : i, l = o.width, r = o.height, u = o.margin, a = void 0 === u ? L : u, d = o.debug;
    return (0, _react.useMemo)(function() {
        return W({
            points: R({
                points: e,
                margin: a,
                getNodePosition: t
            }),
            width: l,
            height: r,
            margin: a,
            debug: d
        });
    }, [
        t,
        e,
        l,
        r,
        a,
        d
    ]);
}, x = function(o) {
    var e = o.data, i = o.width, t = o.height, l = o.xDomain, r = o.yDomain, u = (0, _react.useMemo)(function() {
        return (0, _d3Scale.scaleLinear)().domain(l).range([
            0,
            i
        ]);
    }, [
        l,
        i
    ]), a = (0, _react.useMemo)(function() {
        return (0, _d3Scale.scaleLinear)().domain(r).range([
            0,
            t
        ]);
    }, [
        r,
        t
    ]), d = (0, _react.useMemo)(function() {
        return e.map(function(n) {
            return {
                x: u(n.x),
                y: a(n.y),
                data: n
            };
        });
    }, [
        e,
        u,
        a
    ]);
    return (0, _react.useMemo)(function() {
        var n = (0, _d3Delaunay.Delaunay).from(d.map(function(n) {
            return [
                n.x,
                n.y
            ];
        })), o = n.voronoi([
            0,
            0,
            i,
            t
        ]);
        return {
            points: d,
            delaunay: n,
            voronoi: o
        };
    }, [
        d,
        i,
        t
    ]);
}, S = function(o) {
    var e = o.points, i = o.delaunay, t = o.voronoi;
    return (0, _react.useMemo)(function() {
        return {
            points: e,
            delaunay: i,
            voronoi: t
        };
    }, [
        e,
        i,
        t
    ]);
}, U = function(l) {
    var r = l.elementRef, u = l.nodes, a = l.getNodePosition, h = void 0 === a ? D : a, c = l.delaunay, v = l.setCurrent, f = l.margin, p = void 0 === f ? L : f, g = l.detectionRadius, m = void 0 === g ? 1 / 0 : g, b = l.isInteractive, k = void 0 === b || b, C = l.onMouseEnter, y = l.onMouseMove, w = l.onMouseLeave, R = l.onMouseDown, W = l.onMouseUp, E = l.onClick, x = l.onDoubleClick, S = l.onTouchStart, U = l.onTouchMove, z = l.onTouchEnd, A = l.enableTouchCrosshair, N = void 0 !== A && A, H = l.tooltip, O = l.tooltipPosition, I = void 0 === O ? T : O, j = l.tooltipAnchor, F = void 0 === j ? P : j, B = (0, _react.useState)(null), q = B[0], G = B[1], J = (0, _react.useRef)(null);
    (0, _react.useEffect)(function() {
        J.current = q;
    }, [
        J,
        q
    ]);
    var K = (0, _react.useCallback)(function(n) {
        if (!r.current || 0 === u.length) return null;
        var o = (0, _core.getRelativeCursor)(r.current, n), e = o[0], i = o[1], t = c.find(e, i), l = void 0 !== t ? u[t] : null;
        if (l && m !== 1 / 0) {
            var a = h(l), v = a[0], f = a[1];
            (0, _core.getDistance)(e, i, v + p.left, f + p.top) > m && (t = null, l = null);
        }
        return null === t || null === l ? null : [
            t,
            l
        ];
    }, [
        r,
        c,
        u,
        h,
        p,
        m
    ]), Q = (0, _tooltip.useTooltip)(), V = Q.showTooltipAt, X = Q.showTooltipFromEvent, Y = Q.hideTooltip, Z = (0, _react.useMemo)(function() {
        if (H) return "cursor" === I ? function(n, o) {
            X(H(n), o, F);
        } : function(n) {
            var o = h(n), e = o[0], i = o[1];
            V(H(n), [
                e + p.left,
                i + p.top
            ], F);
        };
    }, [
        V,
        X,
        H,
        I,
        F,
        h,
        p
    ]), $ = (0, _react.useCallback)(function(n) {
        var o = K(n);
        if (G(o), null == v || v(o ? o[1] : null), o) {
            var e = o[1];
            null == Z || Z(e, n), null == C || C(o[1], n);
        }
    }, [
        K,
        G,
        v,
        Z,
        C
    ]), _ = (0, _react.useCallback)(function(n) {
        var o = K(n);
        if (G(o), o) {
            var e = o[0], i = o[1];
            if (null == v || v(i), null == Z || Z(i, n), J.current) {
                var t = J.current, l = t[0], r = t[1];
                e !== l ? null == w || w(r, n) : null == y || y(i, n);
            } else null == C || C(i, n);
        } else null == v || v(null), null == Y || Y(), J.current && (null == w || w(J.current[1], n));
    }, [
        K,
        G,
        v,
        J,
        C,
        y,
        w,
        Z,
        Y
    ]), nn = (0, _react.useCallback)(function(n) {
        G(null), null == v || v(null), Y(), w && J.current && w(J.current[1], n);
    }, [
        G,
        v,
        J,
        Y,
        w
    ]), on = (0, _react.useCallback)(function(n) {
        var o = K(n);
        G(o), o && (null == R || R(o[1], n));
    }, [
        K,
        G,
        R
    ]), en = (0, _react.useCallback)(function(n) {
        var o = K(n);
        G(o), o && (null == W || W(o[1], n));
    }, [
        K,
        G,
        W
    ]), tn = (0, _react.useCallback)(function(n) {
        var o = K(n);
        G(o), o && (null == E || E(o[1], n));
    }, [
        K,
        G,
        E
    ]), ln = (0, _react.useCallback)(function(n) {
        var o = K(n);
        G(o), o && (null == x || x(o[1], n));
    }, [
        K,
        G,
        x
    ]), rn = (0, _react.useCallback)(function(n) {
        var o = K(n);
        N && (G(o), null == v || v(o ? o[1] : null)), o && (null == S || S(o[1], n));
    }, [
        K,
        G,
        v,
        N,
        S
    ]), un = (0, _react.useCallback)(function(n) {
        var o = K(n);
        N && (G(o), null == v || v(o ? o[1] : null)), o && (null == U || U(o[1], n));
    }, [
        K,
        G,
        v,
        N,
        U
    ]), an = (0, _react.useCallback)(function(n) {
        N && (G(null), null == v || v(null)), z && J.current && z(J.current[1], n);
    }, [
        N,
        G,
        v,
        z,
        J
    ]);
    return {
        current: q,
        handleMouseEnter: k ? $ : void 0,
        handleMouseMove: k ? _ : void 0,
        handleMouseLeave: k ? nn : void 0,
        handleMouseDown: k ? on : void 0,
        handleMouseUp: k ? en : void 0,
        handleClick: k ? tn : void 0,
        handleDoubleClick: k ? ln : void 0,
        handleTouchStart: k ? rn : void 0,
        handleTouchMove: k ? un : void 0,
        handleTouchEnd: k ? an : void 0
    };
}, z = function(n) {
    var o = n.elementRef, e = n.nodes, i = n.getNodePosition, t = n.width, l = n.height, r = n.margin, u = void 0 === r ? L : r, a = n.isInteractive, d = void 0 === a || a, s = n.detectionRadius, h = void 0 === s ? 1 / 0 : s, c = n.setCurrent, v = n.onMouseEnter, f = n.onMouseMove, p = n.onMouseLeave, g = n.onMouseDown, M = n.onMouseUp, m = n.onClick, b = n.onDoubleClick, k = n.tooltip, C = n.tooltipPosition, y = void 0 === C ? T : C, w = n.tooltipAnchor, D = void 0 === w ? P : w, R = n.debug, W = E({
        points: e,
        getNodePosition: i,
        width: t,
        height: l,
        margin: u,
        debug: void 0 !== R && R
    }), x = W.delaunay, S = W.voronoi, z = U({
        elementRef: o,
        nodes: e,
        margin: u,
        setCurrent: c,
        delaunay: x,
        detectionRadius: h,
        isInteractive: d,
        onMouseEnter: v,
        onMouseMove: f,
        onMouseLeave: p,
        onMouseDown: g,
        onMouseUp: M,
        onClick: m,
        onDoubleClick: b,
        tooltip: k,
        tooltipPosition: y,
        tooltipAnchor: D
    }), A = z.handleMouseEnter, N = z.handleMouseMove, H = z.handleMouseLeave, O = z.handleMouseDown, I = z.handleMouseUp, j = z.handleClick, F = z.handleDoubleClick;
    return {
        delaunay: x,
        voronoi: S,
        current: z.current,
        handleMouseEnter: A,
        handleMouseMove: N,
        handleMouseLeave: H,
        handleMouseDown: O,
        handleMouseUp: I,
        handleClick: j,
        handleDoubleClick: F
    };
}, A = [
    "theme"
], N = function(n) {
    var o = n.data, e = n.width, i = n.height, t = n.margin, l = n.layers, a = void 0 === l ? w.layers : l, d = n.xDomain, s = void 0 === d ? w.xDomain : d, h = n.yDomain, f = void 0 === h ? w.yDomain : h, p = n.enableLinks, g = void 0 === p ? w.enableLinks : p, M = n.linkLineWidth, b = void 0 === M ? w.linkLineWidth : M, k = n.linkLineColor, C = void 0 === k ? w.linkLineColor : k, y = n.enableCells, D = void 0 === y ? w.enableCells : y, L = n.cellLineWidth, T = void 0 === L ? w.cellLineWidth : L, P = n.cellLineColor, R = void 0 === P ? w.cellLineColor : P, W = n.enablePoints, E = void 0 === W ? w.enableCells : W, U = n.pointSize, z = void 0 === U ? w.pointSize : U, A = n.pointColor, N = void 0 === A ? w.pointColor : A, H = n.role, O = void 0 === H ? w.role : H, I = n.forwardedRef, j = (0, _core.useDimensions)(e, i, t), F = j.outerWidth, B = j.outerHeight, q = j.margin, G = j.innerWidth, J = j.innerHeight, K = x({
        data: o,
        width: G,
        height: J,
        xDomain: s,
        yDomain: f
    }), Q = K.points, V = K.delaunay, X = K.voronoi, Y = {
        links: null,
        cells: null,
        points: null,
        bounds: null
    };
    g && a.includes("links") && (Y.links = (0, _jsxRuntime.jsx)("path", {
        stroke: C,
        strokeWidth: b,
        fill: "none",
        d: V.render()
    }, "links")), D && a.includes("cells") && (Y.cells = (0, _jsxRuntime.jsx)("path", {
        d: X.render(),
        fill: "none",
        stroke: R,
        strokeWidth: T
    }, "cells")), E && a.includes("points") && (Y.points = (0, _jsxRuntime.jsx)("path", {
        stroke: "none",
        fill: N,
        d: V.renderPoints(void 0, z / 2)
    }, "points")), a.includes("bounds") && (Y.bounds = (0, _jsxRuntime.jsx)("path", {
        fill: "none",
        stroke: R,
        strokeWidth: T,
        d: X.renderBounds()
    }, "bounds"));
    var Z = S({
        points: Q,
        delaunay: V,
        voronoi: X
    });
    return (0, _jsxRuntime.jsx)((0, _core.SvgWrapper), {
        width: F,
        height: B,
        margin: q,
        role: O,
        ref: I,
        children: a.map(function(n, o) {
            return void 0 !== Y[n] ? Y[n] : "function" == typeof n ? (0, _jsxRuntime.jsx)((0, _react.Fragment), {
                children: (0, _react.createElement)(n, Z)
            }, o) : null;
        })
    });
}, H = (0, _react.forwardRef)(function(n, o) {
    var e = n.theme, i = y(n, A);
    return (0, _jsxRuntime.jsx)((0, _core.Container), {
        isInteractive: !1,
        animate: !1,
        theme: e,
        children: (0, _jsxRuntime.jsx)(N, C({}, i, {
            forwardedRef: o
        }))
    });
}), O = [
    "defaultWidth",
    "defaultHeight",
    "onResize",
    "debounceResize"
], I = (0, _react.forwardRef)(function(n, o) {
    var e = n.defaultWidth, i = n.defaultHeight, t = n.onResize, l = n.debounceResize, r = y(n, O);
    return (0, _jsxRuntime.jsx)((0, _core.ResponsiveWrapper), {
        defaultWidth: e,
        defaultHeight: i,
        onResize: t,
        debounceResize: l,
        children: function(n) {
            var e = n.width, i = n.height;
            return (0, _jsxRuntime.jsx)(H, C({}, r, {
                width: e,
                height: i,
                ref: o
            }));
        }
    });
}), j = function(o) {
    var i = o.nodes, t = o.width, l = o.height, r = o.margin, u = void 0 === r ? L : r, a = o.getNodePosition, d = o.setCurrent, s = o.onMouseEnter, h = o.onMouseMove, c = o.onMouseLeave, v = o.onMouseDown, f = o.onMouseUp, p = o.onClick, g = o.onDoubleClick, M = o.onTouchStart, C = o.onTouchMove, y = o.onTouchEnd, w = o.enableTouchCrosshair, D = void 0 !== w && w, R = o.detectionRadius, W = void 0 === R ? 1 / 0 : R, x = o.tooltip, S = o.tooltipPosition, z = void 0 === S ? T : S, A = o.tooltipAnchor, N = void 0 === A ? P : A, H = o.debug, O = (0, _react.useRef)(null), I = E({
        points: i,
        getNodePosition: a,
        width: t,
        height: l,
        margin: u,
        debug: H
    }), j = I.delaunay, F = I.voronoi, B = U({
        elementRef: O,
        nodes: i,
        delaunay: j,
        margin: u,
        detectionRadius: W,
        setCurrent: d,
        onMouseEnter: s,
        onMouseMove: h,
        onMouseLeave: c,
        onMouseDown: v,
        onMouseUp: f,
        onClick: p,
        onDoubleClick: g,
        onTouchStart: M,
        onTouchMove: C,
        onTouchEnd: y,
        enableTouchCrosshair: D,
        tooltip: x,
        tooltipPosition: z,
        tooltipAnchor: N
    }), q = B.current, G = B.handleMouseEnter, J = B.handleMouseMove, K = B.handleMouseLeave, Q = B.handleMouseDown, V = B.handleMouseUp, X = B.handleClick, Y = B.handleDoubleClick, Z = B.handleTouchStart, $ = B.handleTouchMove, _ = B.handleTouchEnd, nn = (0, _react.useMemo)(function() {
        if (H && F) return F.render();
    }, [
        H,
        F
    ]);
    return (0, _jsxRuntime.jsxs)("g", {
        ref: O,
        transform: "translate(" + -u.left + "," + -u.top + ")",
        children: [
            H && F && (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                children: [
                    (0, _jsxRuntime.jsx)("path", {
                        d: nn,
                        stroke: "red",
                        strokeWidth: 1,
                        opacity: .75
                    }),
                    W < 1 / 0 && (0, _jsxRuntime.jsx)("path", {
                        stroke: "red",
                        strokeWidth: .35,
                        fill: "none",
                        d: j.renderPoints(void 0, W)
                    }),
                    q && (0, _jsxRuntime.jsx)("path", {
                        fill: "pink",
                        opacity: .35,
                        d: F.renderCell(q[0])
                    })
                ]
            }),
            (0, _jsxRuntime.jsx)("rect", {
                "data-ref": "mesh-interceptor",
                width: u.left + t + u.right,
                height: u.top + l + u.bottom,
                fill: "red",
                opacity: 0,
                style: {
                    cursor: "auto"
                },
                onMouseEnter: G,
                onMouseMove: J,
                onMouseLeave: K,
                onMouseDown: Q,
                onMouseUp: V,
                onTouchStart: Z,
                onTouchMove: $,
                onTouchEnd: _,
                onClick: X,
                onDoubleClick: Y
            })
        ]
    });
}, F = function(n, o) {
    n.save(), n.globalAlpha = .75, n.beginPath(), o.render(n), n.strokeStyle = "red", n.lineWidth = 1, n.stroke(), n.restore();
}, B = function(n, o, e) {
    n.save(), n.globalAlpha = .15, n.beginPath(), o.renderPoints(n, e), n.strokeStyle = "red", n.lineWidth = 1, n.stroke(), n.restore();
}, q = function(n, o, e) {
    n.save(), n.globalAlpha = .35, n.beginPath(), o.renderCell(e, n), n.fillStyle = "pink", n.fill(), n.restore();
}, G = function(n, o) {
    var e = o.delaunay, i = o.voronoi, t = o.detectionRadius, l = o.index;
    F(n, i), t < 1 / 0 && B(n, e, t), null !== l && q(n, i, l);
};

},{"react":"6uln9","@nivo/core":"3e9EB","d3-scale":"7BK9l","d3-delaunay":"bzKr0","@nivo/tooltip":"1CuTy","react/jsx-runtime":"gaGEj","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"bzKr0":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Delaunay", ()=>(0, _delaunayJsDefault.default));
parcelHelpers.export(exports, "Voronoi", ()=>(0, _voronoiJsDefault.default));
var _delaunayJs = require("./delaunay.js");
var _delaunayJsDefault = parcelHelpers.interopDefault(_delaunayJs);
var _voronoiJs = require("./voronoi.js");
var _voronoiJsDefault = parcelHelpers.interopDefault(_voronoiJs);

},{"./delaunay.js":"lFxg8","./voronoi.js":false,"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"lFxg8":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _delaunator = require("delaunator");
var _delaunatorDefault = parcelHelpers.interopDefault(_delaunator);
var _pathJs = require("./path.js");
var _pathJsDefault = parcelHelpers.interopDefault(_pathJs);
var _polygonJs = require("./polygon.js");
var _polygonJsDefault = parcelHelpers.interopDefault(_polygonJs);
var _voronoiJs = require("./voronoi.js");
var _voronoiJsDefault = parcelHelpers.interopDefault(_voronoiJs);
const tau = 2 * Math.PI, pow = Math.pow;
function pointX(p) {
    return p[0];
}
function pointY(p) {
    return p[1];
}
// A triangulation is collinear if all its triangles have a non-null area
function collinear(d) {
    const { triangles, coords } = d;
    for(let i = 0; i < triangles.length; i += 3){
        const a = 2 * triangles[i], b = 2 * triangles[i + 1], c = 2 * triangles[i + 2], cross = (coords[c] - coords[a]) * (coords[b + 1] - coords[a + 1]) - (coords[b] - coords[a]) * (coords[c + 1] - coords[a + 1]);
        if (cross > 1e-10) return false;
    }
    return true;
}
function jitter(x, y, r) {
    return [
        x + Math.sin(x + y) * r,
        y + Math.cos(x - y) * r
    ];
}
class Delaunay {
    static from(points, fx = pointX, fy = pointY, that) {
        return new Delaunay("length" in points ? flatArray(points, fx, fy, that) : Float64Array.from(flatIterable(points, fx, fy, that)));
    }
    constructor(points){
        this._delaunator = new (0, _delaunatorDefault.default)(points);
        this.inedges = new Int32Array(points.length / 2);
        this._hullIndex = new Int32Array(points.length / 2);
        this.points = this._delaunator.coords;
        this._init();
    }
    update() {
        this._delaunator.update();
        this._init();
        return this;
    }
    _init() {
        const d = this._delaunator, points = this.points;
        // check for collinear
        if (d.hull && d.hull.length > 2 && collinear(d)) {
            this.collinear = Int32Array.from({
                length: points.length / 2
            }, (_, i)=>i).sort((i, j)=>points[2 * i] - points[2 * j] || points[2 * i + 1] - points[2 * j + 1]); // for exact neighbors
            const e = this.collinear[0], f = this.collinear[this.collinear.length - 1], bounds = [
                points[2 * e],
                points[2 * e + 1],
                points[2 * f],
                points[2 * f + 1]
            ], r = 1e-8 * Math.hypot(bounds[3] - bounds[1], bounds[2] - bounds[0]);
            for(let i = 0, n = points.length / 2; i < n; ++i){
                const p = jitter(points[2 * i], points[2 * i + 1], r);
                points[2 * i] = p[0];
                points[2 * i + 1] = p[1];
            }
            this._delaunator = new (0, _delaunatorDefault.default)(points);
        } else delete this.collinear;
        const halfedges = this.halfedges = this._delaunator.halfedges;
        const hull = this.hull = this._delaunator.hull;
        const triangles = this.triangles = this._delaunator.triangles;
        const inedges = this.inedges.fill(-1);
        const hullIndex = this._hullIndex.fill(-1);
        // Compute an index from each point to an (arbitrary) incoming halfedge
        // Used to give the first neighbor of each point; for this reason,
        // on the hull we give priority to exterior halfedges
        for(let e = 0, n = halfedges.length; e < n; ++e){
            const p = triangles[e % 3 === 2 ? e - 2 : e + 1];
            if (halfedges[e] === -1 || inedges[p] === -1) inedges[p] = e;
        }
        for(let i = 0, n = hull.length; i < n; ++i)hullIndex[hull[i]] = i;
        // degenerate case: 1 or 2 (distinct) points
        if (hull.length <= 2 && hull.length > 0) {
            this.triangles = new Int32Array(3).fill(-1);
            this.halfedges = new Int32Array(3).fill(-1);
            this.triangles[0] = hull[0];
            inedges[hull[0]] = 1;
            if (hull.length === 2) {
                inedges[hull[1]] = 0;
                this.triangles[1] = hull[1];
                this.triangles[2] = hull[1];
            }
        }
    }
    voronoi(bounds) {
        return new (0, _voronoiJsDefault.default)(this, bounds);
    }
    *neighbors(i) {
        const { inedges, hull, _hullIndex, halfedges, triangles, collinear } = this;
        // degenerate case with several collinear points
        if (collinear) {
            const l = collinear.indexOf(i);
            if (l > 0) yield collinear[l - 1];
            if (l < collinear.length - 1) yield collinear[l + 1];
            return;
        }
        const e0 = inedges[i];
        if (e0 === -1) return; // coincident point
        let e = e0, p0 = -1;
        do {
            yield p0 = triangles[e];
            e = e % 3 === 2 ? e - 2 : e + 1;
            if (triangles[e] !== i) return; // bad triangulation
            e = halfedges[e];
            if (e === -1) {
                const p = hull[(_hullIndex[i] + 1) % hull.length];
                if (p !== p0) yield p;
                return;
            }
        }while (e !== e0);
    }
    find(x, y, i = 0) {
        if ((x = +x, x !== x) || (y = +y, y !== y)) return -1;
        const i0 = i;
        let c;
        while((c = this._step(i, x, y)) >= 0 && c !== i && c !== i0)i = c;
        return c;
    }
    _step(i, x, y) {
        const { inedges, hull, _hullIndex, halfedges, triangles, points } = this;
        if (inedges[i] === -1 || !points.length) return (i + 1) % (points.length >> 1);
        let c = i;
        let dc = pow(x - points[i * 2], 2) + pow(y - points[i * 2 + 1], 2);
        const e0 = inedges[i];
        let e = e0;
        do {
            let t = triangles[e];
            const dt = pow(x - points[t * 2], 2) + pow(y - points[t * 2 + 1], 2);
            if (dt < dc) dc = dt, c = t;
            e = e % 3 === 2 ? e - 2 : e + 1;
            if (triangles[e] !== i) break; // bad triangulation
            e = halfedges[e];
            if (e === -1) {
                e = hull[(_hullIndex[i] + 1) % hull.length];
                if (e !== t) {
                    if (pow(x - points[e * 2], 2) + pow(y - points[e * 2 + 1], 2) < dc) return e;
                }
                break;
            }
        }while (e !== e0);
        return c;
    }
    render(context) {
        const buffer = context == null ? context = new (0, _pathJsDefault.default) : undefined;
        const { points, halfedges, triangles } = this;
        for(let i = 0, n = halfedges.length; i < n; ++i){
            const j = halfedges[i];
            if (j < i) continue;
            const ti = triangles[i] * 2;
            const tj = triangles[j] * 2;
            context.moveTo(points[ti], points[ti + 1]);
            context.lineTo(points[tj], points[tj + 1]);
        }
        this.renderHull(context);
        return buffer && buffer.value();
    }
    renderPoints(context, r) {
        if (r === undefined && (!context || typeof context.moveTo !== "function")) r = context, context = null;
        r = r == undefined ? 2 : +r;
        const buffer = context == null ? context = new (0, _pathJsDefault.default) : undefined;
        const { points } = this;
        for(let i = 0, n = points.length; i < n; i += 2){
            const x = points[i], y = points[i + 1];
            context.moveTo(x + r, y);
            context.arc(x, y, r, 0, tau);
        }
        return buffer && buffer.value();
    }
    renderHull(context) {
        const buffer = context == null ? context = new (0, _pathJsDefault.default) : undefined;
        const { hull, points } = this;
        const h = hull[0] * 2, n = hull.length;
        context.moveTo(points[h], points[h + 1]);
        for(let i = 1; i < n; ++i){
            const h = 2 * hull[i];
            context.lineTo(points[h], points[h + 1]);
        }
        context.closePath();
        return buffer && buffer.value();
    }
    hullPolygon() {
        const polygon = new (0, _polygonJsDefault.default);
        this.renderHull(polygon);
        return polygon.value();
    }
    renderTriangle(i, context) {
        const buffer = context == null ? context = new (0, _pathJsDefault.default) : undefined;
        const { points, triangles } = this;
        const t0 = triangles[i *= 3] * 2;
        const t1 = triangles[i + 1] * 2;
        const t2 = triangles[i + 2] * 2;
        context.moveTo(points[t0], points[t0 + 1]);
        context.lineTo(points[t1], points[t1 + 1]);
        context.lineTo(points[t2], points[t2 + 1]);
        context.closePath();
        return buffer && buffer.value();
    }
    *trianglePolygons() {
        const { triangles } = this;
        for(let i = 0, n = triangles.length / 3; i < n; ++i)yield this.trianglePolygon(i);
    }
    trianglePolygon(i) {
        const polygon = new (0, _polygonJsDefault.default);
        this.renderTriangle(i, polygon);
        return polygon.value();
    }
}
exports.default = Delaunay;
function flatArray(points, fx, fy, that) {
    const n = points.length;
    const array = new Float64Array(n * 2);
    for(let i = 0; i < n; ++i){
        const p = points[i];
        array[i * 2] = fx.call(that, p, i, points);
        array[i * 2 + 1] = fy.call(that, p, i, points);
    }
    return array;
}
function* flatIterable(points, fx, fy, that) {
    let i = 0;
    for (const p of points){
        yield fx.call(that, p, i, points);
        yield fy.call(that, p, i, points);
        ++i;
    }
}

},{"delaunator":"8DmA1","./path.js":"5h4Se","./polygon.js":"aS9sW","./voronoi.js":"gPQ9o","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8DmA1":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _robustPredicates = require("robust-predicates");
const EPSILON = Math.pow(2, -52);
const EDGE_STACK = new Uint32Array(512);
class Delaunator {
    static from(points, getX = defaultGetX, getY = defaultGetY) {
        const n = points.length;
        const coords = new Float64Array(n * 2);
        for(let i = 0; i < n; i++){
            const p = points[i];
            coords[2 * i] = getX(p);
            coords[2 * i + 1] = getY(p);
        }
        return new Delaunator(coords);
    }
    constructor(coords){
        const n = coords.length >> 1;
        if (n > 0 && typeof coords[0] !== "number") throw new Error("Expected coords to contain numbers.");
        this.coords = coords;
        // arrays that will store the triangulation graph
        const maxTriangles = Math.max(2 * n - 5, 0);
        this._triangles = new Uint32Array(maxTriangles * 3);
        this._halfedges = new Int32Array(maxTriangles * 3);
        // temporary arrays for tracking the edges of the advancing convex hull
        this._hashSize = Math.ceil(Math.sqrt(n));
        this._hullPrev = new Uint32Array(n); // edge to prev edge
        this._hullNext = new Uint32Array(n); // edge to next edge
        this._hullTri = new Uint32Array(n); // edge to adjacent triangle
        this._hullHash = new Int32Array(this._hashSize); // angular edge hash
        // temporary arrays for sorting points
        this._ids = new Uint32Array(n);
        this._dists = new Float64Array(n);
        this.update();
    }
    update() {
        const { coords, _hullPrev: hullPrev, _hullNext: hullNext, _hullTri: hullTri, _hullHash: hullHash } = this;
        const n = coords.length >> 1;
        // populate an array of point indices; calculate input data bbox
        let minX = Infinity;
        let minY = Infinity;
        let maxX = -Infinity;
        let maxY = -Infinity;
        for(let i = 0; i < n; i++){
            const x = coords[2 * i];
            const y = coords[2 * i + 1];
            if (x < minX) minX = x;
            if (y < minY) minY = y;
            if (x > maxX) maxX = x;
            if (y > maxY) maxY = y;
            this._ids[i] = i;
        }
        const cx = (minX + maxX) / 2;
        const cy = (minY + maxY) / 2;
        let i0, i1, i2;
        // pick a seed point close to the center
        for(let i = 0, minDist = Infinity; i < n; i++){
            const d = dist(cx, cy, coords[2 * i], coords[2 * i + 1]);
            if (d < minDist) {
                i0 = i;
                minDist = d;
            }
        }
        const i0x = coords[2 * i0];
        const i0y = coords[2 * i0 + 1];
        // find the point closest to the seed
        for(let i = 0, minDist = Infinity; i < n; i++){
            if (i === i0) continue;
            const d = dist(i0x, i0y, coords[2 * i], coords[2 * i + 1]);
            if (d < minDist && d > 0) {
                i1 = i;
                minDist = d;
            }
        }
        let i1x = coords[2 * i1];
        let i1y = coords[2 * i1 + 1];
        let minRadius = Infinity;
        // find the third point which forms the smallest circumcircle with the first two
        for(let i = 0; i < n; i++){
            if (i === i0 || i === i1) continue;
            const r = circumradius(i0x, i0y, i1x, i1y, coords[2 * i], coords[2 * i + 1]);
            if (r < minRadius) {
                i2 = i;
                minRadius = r;
            }
        }
        let i2x = coords[2 * i2];
        let i2y = coords[2 * i2 + 1];
        if (minRadius === Infinity) {
            // order collinear points by dx (or dy if all x are identical)
            // and return the list as a hull
            for(let i = 0; i < n; i++)this._dists[i] = coords[2 * i] - coords[0] || coords[2 * i + 1] - coords[1];
            quicksort(this._ids, this._dists, 0, n - 1);
            const hull = new Uint32Array(n);
            let j = 0;
            for(let i = 0, d0 = -Infinity; i < n; i++){
                const id = this._ids[i];
                const d = this._dists[id];
                if (d > d0) {
                    hull[j++] = id;
                    d0 = d;
                }
            }
            this.hull = hull.subarray(0, j);
            this.triangles = new Uint32Array(0);
            this.halfedges = new Uint32Array(0);
            return;
        }
        // swap the order of the seed points for counter-clockwise orientation
        if ((0, _robustPredicates.orient2d)(i0x, i0y, i1x, i1y, i2x, i2y) < 0) {
            const i = i1;
            const x = i1x;
            const y = i1y;
            i1 = i2;
            i1x = i2x;
            i1y = i2y;
            i2 = i;
            i2x = x;
            i2y = y;
        }
        const center = circumcenter(i0x, i0y, i1x, i1y, i2x, i2y);
        this._cx = center.x;
        this._cy = center.y;
        for(let i = 0; i < n; i++)this._dists[i] = dist(coords[2 * i], coords[2 * i + 1], center.x, center.y);
        // sort the points by distance from the seed triangle circumcenter
        quicksort(this._ids, this._dists, 0, n - 1);
        // set up the seed triangle as the starting hull
        this._hullStart = i0;
        let hullSize = 3;
        hullNext[i0] = hullPrev[i2] = i1;
        hullNext[i1] = hullPrev[i0] = i2;
        hullNext[i2] = hullPrev[i1] = i0;
        hullTri[i0] = 0;
        hullTri[i1] = 1;
        hullTri[i2] = 2;
        hullHash.fill(-1);
        hullHash[this._hashKey(i0x, i0y)] = i0;
        hullHash[this._hashKey(i1x, i1y)] = i1;
        hullHash[this._hashKey(i2x, i2y)] = i2;
        this.trianglesLen = 0;
        this._addTriangle(i0, i1, i2, -1, -1, -1);
        for(let k = 0, xp, yp; k < this._ids.length; k++){
            const i = this._ids[k];
            const x = coords[2 * i];
            const y = coords[2 * i + 1];
            // skip near-duplicate points
            if (k > 0 && Math.abs(x - xp) <= EPSILON && Math.abs(y - yp) <= EPSILON) continue;
            xp = x;
            yp = y;
            // skip seed triangle points
            if (i === i0 || i === i1 || i === i2) continue;
            // find a visible edge on the convex hull using edge hash
            let start = 0;
            for(let j = 0, key = this._hashKey(x, y); j < this._hashSize; j++){
                start = hullHash[(key + j) % this._hashSize];
                if (start !== -1 && start !== hullNext[start]) break;
            }
            start = hullPrev[start];
            let e = start, q;
            while(q = hullNext[e], (0, _robustPredicates.orient2d)(x, y, coords[2 * e], coords[2 * e + 1], coords[2 * q], coords[2 * q + 1]) >= 0){
                e = q;
                if (e === start) {
                    e = -1;
                    break;
                }
            }
            if (e === -1) continue; // likely a near-duplicate point; skip it
            // add the first triangle from the point
            let t = this._addTriangle(e, i, hullNext[e], -1, -1, hullTri[e]);
            // recursively flip triangles from the point until they satisfy the Delaunay condition
            hullTri[i] = this._legalize(t + 2);
            hullTri[e] = t; // keep track of boundary triangles on the hull
            hullSize++;
            // walk forward through the hull, adding more triangles and flipping recursively
            let n = hullNext[e];
            while(q = hullNext[n], (0, _robustPredicates.orient2d)(x, y, coords[2 * n], coords[2 * n + 1], coords[2 * q], coords[2 * q + 1]) < 0){
                t = this._addTriangle(n, i, q, hullTri[i], -1, hullTri[n]);
                hullTri[i] = this._legalize(t + 2);
                hullNext[n] = n; // mark as removed
                hullSize--;
                n = q;
            }
            // walk backward from the other side, adding more triangles and flipping
            if (e === start) while(q = hullPrev[e], (0, _robustPredicates.orient2d)(x, y, coords[2 * q], coords[2 * q + 1], coords[2 * e], coords[2 * e + 1]) < 0){
                t = this._addTriangle(q, i, e, -1, hullTri[e], hullTri[q]);
                this._legalize(t + 2);
                hullTri[q] = t;
                hullNext[e] = e; // mark as removed
                hullSize--;
                e = q;
            }
            // update the hull indices
            this._hullStart = hullPrev[i] = e;
            hullNext[e] = hullPrev[n] = i;
            hullNext[i] = n;
            // save the two new edges in the hash table
            hullHash[this._hashKey(x, y)] = i;
            hullHash[this._hashKey(coords[2 * e], coords[2 * e + 1])] = e;
        }
        this.hull = new Uint32Array(hullSize);
        for(let i = 0, e = this._hullStart; i < hullSize; i++){
            this.hull[i] = e;
            e = hullNext[e];
        }
        // trim typed triangle mesh arrays
        this.triangles = this._triangles.subarray(0, this.trianglesLen);
        this.halfedges = this._halfedges.subarray(0, this.trianglesLen);
    }
    _hashKey(x, y) {
        return Math.floor(pseudoAngle(x - this._cx, y - this._cy) * this._hashSize) % this._hashSize;
    }
    _legalize(a) {
        const { _triangles: triangles, _halfedges: halfedges, coords } = this;
        let i = 0;
        let ar = 0;
        // recursion eliminated with a fixed-size stack
        while(true){
            const b = halfedges[a];
            /* if the pair of triangles doesn't satisfy the Delaunay condition
             * (p1 is inside the circumcircle of [p0, pl, pr]), flip them,
             * then do the same check/flip recursively for the new pair of triangles
             *
             *           pl                    pl
             *          /||\                  /  \
             *       al/ || \bl            al/    \a
             *        /  ||  \              /      \
             *       /  a||b  \    flip    /___ar___\
             *     p0\   ||   /p1   =>   p0\---bl---/p1
             *        \  ||  /              \      /
             *       ar\ || /br             b\    /br
             *          \||/                  \  /
             *           pr                    pr
             */ const a0 = a - a % 3;
            ar = a0 + (a + 2) % 3;
            if (b === -1) {
                if (i === 0) break;
                a = EDGE_STACK[--i];
                continue;
            }
            const b0 = b - b % 3;
            const al = a0 + (a + 1) % 3;
            const bl = b0 + (b + 2) % 3;
            const p0 = triangles[ar];
            const pr = triangles[a];
            const pl = triangles[al];
            const p1 = triangles[bl];
            const illegal = inCircle(coords[2 * p0], coords[2 * p0 + 1], coords[2 * pr], coords[2 * pr + 1], coords[2 * pl], coords[2 * pl + 1], coords[2 * p1], coords[2 * p1 + 1]);
            if (illegal) {
                triangles[a] = p1;
                triangles[b] = p0;
                const hbl = halfedges[bl];
                // edge swapped on the other side of the hull (rare); fix the halfedge reference
                if (hbl === -1) {
                    let e = this._hullStart;
                    do {
                        if (this._hullTri[e] === bl) {
                            this._hullTri[e] = a;
                            break;
                        }
                        e = this._hullPrev[e];
                    }while (e !== this._hullStart);
                }
                this._link(a, hbl);
                this._link(b, halfedges[ar]);
                this._link(ar, bl);
                const br = b0 + (b + 1) % 3;
                // don't worry about hitting the cap: it can only happen on extremely degenerate input
                if (i < EDGE_STACK.length) EDGE_STACK[i++] = br;
            } else {
                if (i === 0) break;
                a = EDGE_STACK[--i];
            }
        }
        return ar;
    }
    _link(a, b) {
        this._halfedges[a] = b;
        if (b !== -1) this._halfedges[b] = a;
    }
    // add a new triangle given vertex indices and adjacent half-edge ids
    _addTriangle(i0, i1, i2, a, b, c) {
        const t = this.trianglesLen;
        this._triangles[t] = i0;
        this._triangles[t + 1] = i1;
        this._triangles[t + 2] = i2;
        this._link(t, a);
        this._link(t + 1, b);
        this._link(t + 2, c);
        this.trianglesLen += 3;
        return t;
    }
}
exports.default = Delaunator;
// monotonically increases with real angle, but doesn't need expensive trigonometry
function pseudoAngle(dx, dy) {
    const p = dx / (Math.abs(dx) + Math.abs(dy));
    return (dy > 0 ? 3 - p : 1 + p) / 4; // [0..1]
}
function dist(ax, ay, bx, by) {
    const dx = ax - bx;
    const dy = ay - by;
    return dx * dx + dy * dy;
}
function inCircle(ax, ay, bx, by, cx, cy, px, py) {
    const dx = ax - px;
    const dy = ay - py;
    const ex = bx - px;
    const ey = by - py;
    const fx = cx - px;
    const fy = cy - py;
    const ap = dx * dx + dy * dy;
    const bp = ex * ex + ey * ey;
    const cp = fx * fx + fy * fy;
    return dx * (ey * cp - bp * fy) - dy * (ex * cp - bp * fx) + ap * (ex * fy - ey * fx) < 0;
}
function circumradius(ax, ay, bx, by, cx, cy) {
    const dx = bx - ax;
    const dy = by - ay;
    const ex = cx - ax;
    const ey = cy - ay;
    const bl = dx * dx + dy * dy;
    const cl = ex * ex + ey * ey;
    const d = 0.5 / (dx * ey - dy * ex);
    const x = (ey * bl - dy * cl) * d;
    const y = (dx * cl - ex * bl) * d;
    return x * x + y * y;
}
function circumcenter(ax, ay, bx, by, cx, cy) {
    const dx = bx - ax;
    const dy = by - ay;
    const ex = cx - ax;
    const ey = cy - ay;
    const bl = dx * dx + dy * dy;
    const cl = ex * ex + ey * ey;
    const d = 0.5 / (dx * ey - dy * ex);
    const x = ax + (ey * bl - dy * cl) * d;
    const y = ay + (dx * cl - ex * bl) * d;
    return {
        x,
        y
    };
}
function quicksort(ids, dists, left, right) {
    if (right - left <= 20) for(let i = left + 1; i <= right; i++){
        const temp = ids[i];
        const tempDist = dists[temp];
        let j = i - 1;
        while(j >= left && dists[ids[j]] > tempDist)ids[j + 1] = ids[j--];
        ids[j + 1] = temp;
    }
    else {
        const median = left + right >> 1;
        let i = left + 1;
        let j = right;
        swap(ids, median, i);
        if (dists[ids[left]] > dists[ids[right]]) swap(ids, left, right);
        if (dists[ids[i]] > dists[ids[right]]) swap(ids, i, right);
        if (dists[ids[left]] > dists[ids[i]]) swap(ids, left, i);
        const temp = ids[i];
        const tempDist = dists[temp];
        while(true){
            do i++;
            while (dists[ids[i]] < tempDist);
            do j--;
            while (dists[ids[j]] > tempDist);
            if (j < i) break;
            swap(ids, i, j);
        }
        ids[left + 1] = ids[j];
        ids[j] = temp;
        if (right - i + 1 >= j - left) {
            quicksort(ids, dists, i, right);
            quicksort(ids, dists, left, j - 1);
        } else {
            quicksort(ids, dists, left, j - 1);
            quicksort(ids, dists, i, right);
        }
    }
}
function swap(arr, i, j) {
    const tmp = arr[i];
    arr[i] = arr[j];
    arr[j] = tmp;
}
function defaultGetX(p) {
    return p[0];
}
function defaultGetY(p) {
    return p[1];
}

},{"robust-predicates":"fqLDZ","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"fqLDZ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "orient2d", ()=>(0, _orient2DJs.orient2d));
parcelHelpers.export(exports, "orient2dfast", ()=>(0, _orient2DJs.orient2dfast));
parcelHelpers.export(exports, "orient3d", ()=>(0, _orient3DJs.orient3d));
parcelHelpers.export(exports, "orient3dfast", ()=>(0, _orient3DJs.orient3dfast));
parcelHelpers.export(exports, "incircle", ()=>(0, _incircleJs.incircle));
parcelHelpers.export(exports, "incirclefast", ()=>(0, _incircleJs.incirclefast));
parcelHelpers.export(exports, "insphere", ()=>(0, _insphereJs.insphere));
parcelHelpers.export(exports, "inspherefast", ()=>(0, _insphereJs.inspherefast));
var _orient2DJs = require("./esm/orient2d.js");
var _orient3DJs = require("./esm/orient3d.js");
var _incircleJs = require("./esm/incircle.js");
var _insphereJs = require("./esm/insphere.js");

},{"./esm/orient2d.js":"7mY7p","./esm/orient3d.js":"bvx5M","./esm/incircle.js":"2300a","./esm/insphere.js":"lx5e5","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7mY7p":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "orient2d", ()=>orient2d);
parcelHelpers.export(exports, "orient2dfast", ()=>orient2dfast);
var _utilJs = require("./util.js");
const ccwerrboundA = (3 + 16 * (0, _utilJs.epsilon)) * (0, _utilJs.epsilon);
const ccwerrboundB = (2 + 12 * (0, _utilJs.epsilon)) * (0, _utilJs.epsilon);
const ccwerrboundC = (9 + 64 * (0, _utilJs.epsilon)) * (0, _utilJs.epsilon) * (0, _utilJs.epsilon);
const B = (0, _utilJs.vec)(4);
const C1 = (0, _utilJs.vec)(8);
const C2 = (0, _utilJs.vec)(12);
const D = (0, _utilJs.vec)(16);
const u = (0, _utilJs.vec)(4);
function orient2dadapt(ax, ay, bx, by, cx, cy, detsum) {
    let acxtail, acytail, bcxtail, bcytail;
    let bvirt, c, ahi, alo, bhi, blo, _i, _j, _0, s1, s0, t1, t0, u3;
    const acx = ax - cx;
    const bcx = bx - cx;
    const acy = ay - cy;
    const bcy = by - cy;
    s1 = acx * bcy;
    c = (0, _utilJs.splitter) * acx;
    ahi = c - (c - acx);
    alo = acx - ahi;
    c = (0, _utilJs.splitter) * bcy;
    bhi = c - (c - bcy);
    blo = bcy - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = acy * bcx;
    c = (0, _utilJs.splitter) * acy;
    ahi = c - (c - acy);
    alo = acy - ahi;
    c = (0, _utilJs.splitter) * bcx;
    bhi = c - (c - bcx);
    blo = bcx - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    B[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    B[1] = _0 - (_i + bvirt) + (bvirt - t1);
    u3 = _j + _i;
    bvirt = u3 - _j;
    B[2] = _j - (u3 - bvirt) + (_i - bvirt);
    B[3] = u3;
    let det = (0, _utilJs.estimate)(4, B);
    let errbound = ccwerrboundB * detsum;
    if (det >= errbound || -det >= errbound) return det;
    bvirt = ax - acx;
    acxtail = ax - (acx + bvirt) + (bvirt - cx);
    bvirt = bx - bcx;
    bcxtail = bx - (bcx + bvirt) + (bvirt - cx);
    bvirt = ay - acy;
    acytail = ay - (acy + bvirt) + (bvirt - cy);
    bvirt = by - bcy;
    bcytail = by - (bcy + bvirt) + (bvirt - cy);
    if (acxtail === 0 && acytail === 0 && bcxtail === 0 && bcytail === 0) return det;
    errbound = ccwerrboundC * detsum + (0, _utilJs.resulterrbound) * Math.abs(det);
    det += acx * bcytail + bcy * acxtail - (acy * bcxtail + bcx * acytail);
    if (det >= errbound || -det >= errbound) return det;
    s1 = acxtail * bcy;
    c = (0, _utilJs.splitter) * acxtail;
    ahi = c - (c - acxtail);
    alo = acxtail - ahi;
    c = (0, _utilJs.splitter) * bcy;
    bhi = c - (c - bcy);
    blo = bcy - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = acytail * bcx;
    c = (0, _utilJs.splitter) * acytail;
    ahi = c - (c - acytail);
    alo = acytail - ahi;
    c = (0, _utilJs.splitter) * bcx;
    bhi = c - (c - bcx);
    blo = bcx - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    u[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    u[1] = _0 - (_i + bvirt) + (bvirt - t1);
    u3 = _j + _i;
    bvirt = u3 - _j;
    u[2] = _j - (u3 - bvirt) + (_i - bvirt);
    u[3] = u3;
    const C1len = (0, _utilJs.sum)(4, B, 4, u, C1);
    s1 = acx * bcytail;
    c = (0, _utilJs.splitter) * acx;
    ahi = c - (c - acx);
    alo = acx - ahi;
    c = (0, _utilJs.splitter) * bcytail;
    bhi = c - (c - bcytail);
    blo = bcytail - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = acy * bcxtail;
    c = (0, _utilJs.splitter) * acy;
    ahi = c - (c - acy);
    alo = acy - ahi;
    c = (0, _utilJs.splitter) * bcxtail;
    bhi = c - (c - bcxtail);
    blo = bcxtail - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    u[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    u[1] = _0 - (_i + bvirt) + (bvirt - t1);
    u3 = _j + _i;
    bvirt = u3 - _j;
    u[2] = _j - (u3 - bvirt) + (_i - bvirt);
    u[3] = u3;
    const C2len = (0, _utilJs.sum)(C1len, C1, 4, u, C2);
    s1 = acxtail * bcytail;
    c = (0, _utilJs.splitter) * acxtail;
    ahi = c - (c - acxtail);
    alo = acxtail - ahi;
    c = (0, _utilJs.splitter) * bcytail;
    bhi = c - (c - bcytail);
    blo = bcytail - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = acytail * bcxtail;
    c = (0, _utilJs.splitter) * acytail;
    ahi = c - (c - acytail);
    alo = acytail - ahi;
    c = (0, _utilJs.splitter) * bcxtail;
    bhi = c - (c - bcxtail);
    blo = bcxtail - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    u[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    u[1] = _0 - (_i + bvirt) + (bvirt - t1);
    u3 = _j + _i;
    bvirt = u3 - _j;
    u[2] = _j - (u3 - bvirt) + (_i - bvirt);
    u[3] = u3;
    const Dlen = (0, _utilJs.sum)(C2len, C2, 4, u, D);
    return D[Dlen - 1];
}
function orient2d(ax, ay, bx, by, cx, cy) {
    const detleft = (ay - cy) * (bx - cx);
    const detright = (ax - cx) * (by - cy);
    const det = detleft - detright;
    const detsum = Math.abs(detleft + detright);
    if (Math.abs(det) >= ccwerrboundA * detsum) return det;
    return -orient2dadapt(ax, ay, bx, by, cx, cy, detsum);
}
function orient2dfast(ax, ay, bx, by, cx, cy) {
    return (ay - cy) * (bx - cx) - (ax - cx) * (by - cy);
}

},{"./util.js":"4o1Gr","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4o1Gr":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "epsilon", ()=>epsilon);
parcelHelpers.export(exports, "splitter", ()=>splitter);
parcelHelpers.export(exports, "resulterrbound", ()=>resulterrbound);
// fast_expansion_sum_zeroelim routine from oritinal code
parcelHelpers.export(exports, "sum", ()=>sum);
parcelHelpers.export(exports, "sum_three", ()=>sum_three);
// scale_expansion_zeroelim routine from oritinal code
parcelHelpers.export(exports, "scale", ()=>scale);
parcelHelpers.export(exports, "negate", ()=>negate);
parcelHelpers.export(exports, "estimate", ()=>estimate);
parcelHelpers.export(exports, "vec", ()=>vec);
const epsilon = 1.1102230246251565e-16;
const splitter = 134217729;
const resulterrbound = (3 + 8 * epsilon) * epsilon;
function sum(elen, e, flen, f, h) {
    let Q, Qnew, hh, bvirt;
    let enow = e[0];
    let fnow = f[0];
    let eindex = 0;
    let findex = 0;
    if (fnow > enow === fnow > -enow) {
        Q = enow;
        enow = e[++eindex];
    } else {
        Q = fnow;
        fnow = f[++findex];
    }
    let hindex = 0;
    if (eindex < elen && findex < flen) {
        if (fnow > enow === fnow > -enow) {
            Qnew = enow + Q;
            hh = Q - (Qnew - enow);
            enow = e[++eindex];
        } else {
            Qnew = fnow + Q;
            hh = Q - (Qnew - fnow);
            fnow = f[++findex];
        }
        Q = Qnew;
        if (hh !== 0) h[hindex++] = hh;
        while(eindex < elen && findex < flen){
            if (fnow > enow === fnow > -enow) {
                Qnew = Q + enow;
                bvirt = Qnew - Q;
                hh = Q - (Qnew - bvirt) + (enow - bvirt);
                enow = e[++eindex];
            } else {
                Qnew = Q + fnow;
                bvirt = Qnew - Q;
                hh = Q - (Qnew - bvirt) + (fnow - bvirt);
                fnow = f[++findex];
            }
            Q = Qnew;
            if (hh !== 0) h[hindex++] = hh;
        }
    }
    while(eindex < elen){
        Qnew = Q + enow;
        bvirt = Qnew - Q;
        hh = Q - (Qnew - bvirt) + (enow - bvirt);
        enow = e[++eindex];
        Q = Qnew;
        if (hh !== 0) h[hindex++] = hh;
    }
    while(findex < flen){
        Qnew = Q + fnow;
        bvirt = Qnew - Q;
        hh = Q - (Qnew - bvirt) + (fnow - bvirt);
        fnow = f[++findex];
        Q = Qnew;
        if (hh !== 0) h[hindex++] = hh;
    }
    if (Q !== 0 || hindex === 0) h[hindex++] = Q;
    return hindex;
}
function sum_three(alen, a, blen, b, clen, c, tmp, out) {
    return sum(sum(alen, a, blen, b, tmp), tmp, clen, c, out);
}
function scale(elen, e, b, h) {
    let Q, sum, hh, product1, product0;
    let bvirt, c, ahi, alo, bhi, blo;
    c = splitter * b;
    bhi = c - (c - b);
    blo = b - bhi;
    let enow = e[0];
    Q = enow * b;
    c = splitter * enow;
    ahi = c - (c - enow);
    alo = enow - ahi;
    hh = alo * blo - (Q - ahi * bhi - alo * bhi - ahi * blo);
    let hindex = 0;
    if (hh !== 0) h[hindex++] = hh;
    for(let i = 1; i < elen; i++){
        enow = e[i];
        product1 = enow * b;
        c = splitter * enow;
        ahi = c - (c - enow);
        alo = enow - ahi;
        product0 = alo * blo - (product1 - ahi * bhi - alo * bhi - ahi * blo);
        sum = Q + product0;
        bvirt = sum - Q;
        hh = Q - (sum - bvirt) + (product0 - bvirt);
        if (hh !== 0) h[hindex++] = hh;
        Q = product1 + sum;
        hh = sum - (Q - product1);
        if (hh !== 0) h[hindex++] = hh;
    }
    if (Q !== 0 || hindex === 0) h[hindex++] = Q;
    return hindex;
}
function negate(elen, e) {
    for(let i = 0; i < elen; i++)e[i] = -e[i];
    return elen;
}
function estimate(elen, e) {
    let Q = e[0];
    for(let i = 1; i < elen; i++)Q += e[i];
    return Q;
}
function vec(n) {
    return new Float64Array(n);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"bvx5M":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "orient3d", ()=>orient3d);
parcelHelpers.export(exports, "orient3dfast", ()=>orient3dfast);
var _utilJs = require("./util.js");
const o3derrboundA = (7 + 56 * (0, _utilJs.epsilon)) * (0, _utilJs.epsilon);
const o3derrboundB = (3 + 28 * (0, _utilJs.epsilon)) * (0, _utilJs.epsilon);
const o3derrboundC = (26 + 288 * (0, _utilJs.epsilon)) * (0, _utilJs.epsilon) * (0, _utilJs.epsilon);
const bc = (0, _utilJs.vec)(4);
const ca = (0, _utilJs.vec)(4);
const ab = (0, _utilJs.vec)(4);
const at_b = (0, _utilJs.vec)(4);
const at_c = (0, _utilJs.vec)(4);
const bt_c = (0, _utilJs.vec)(4);
const bt_a = (0, _utilJs.vec)(4);
const ct_a = (0, _utilJs.vec)(4);
const ct_b = (0, _utilJs.vec)(4);
const bct = (0, _utilJs.vec)(8);
const cat = (0, _utilJs.vec)(8);
const abt = (0, _utilJs.vec)(8);
const u = (0, _utilJs.vec)(4);
const _8 = (0, _utilJs.vec)(8);
const _8b = (0, _utilJs.vec)(8);
const _16 = (0, _utilJs.vec)(8);
const _12 = (0, _utilJs.vec)(12);
let fin = (0, _utilJs.vec)(192);
let fin2 = (0, _utilJs.vec)(192);
function finadd(finlen, alen, a) {
    finlen = (0, _utilJs.sum)(finlen, fin, alen, a, fin2);
    const tmp = fin;
    fin = fin2;
    fin2 = tmp;
    return finlen;
}
function tailinit(xtail, ytail, ax, ay, bx, by, a, b) {
    let bvirt, c, ahi, alo, bhi, blo, _i, _j, _k, _0, s1, s0, t1, t0, u3, negate;
    if (xtail === 0) {
        if (ytail === 0) {
            a[0] = 0;
            b[0] = 0;
            return 1;
        } else {
            negate = -ytail;
            s1 = negate * ax;
            c = (0, _utilJs.splitter) * negate;
            ahi = c - (c - negate);
            alo = negate - ahi;
            c = (0, _utilJs.splitter) * ax;
            bhi = c - (c - ax);
            blo = ax - bhi;
            a[0] = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
            a[1] = s1;
            s1 = ytail * bx;
            c = (0, _utilJs.splitter) * ytail;
            ahi = c - (c - ytail);
            alo = ytail - ahi;
            c = (0, _utilJs.splitter) * bx;
            bhi = c - (c - bx);
            blo = bx - bhi;
            b[0] = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
            b[1] = s1;
            return 2;
        }
    } else if (ytail === 0) {
        s1 = xtail * ay;
        c = (0, _utilJs.splitter) * xtail;
        ahi = c - (c - xtail);
        alo = xtail - ahi;
        c = (0, _utilJs.splitter) * ay;
        bhi = c - (c - ay);
        blo = ay - bhi;
        a[0] = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
        a[1] = s1;
        negate = -xtail;
        s1 = negate * by;
        c = (0, _utilJs.splitter) * negate;
        ahi = c - (c - negate);
        alo = negate - ahi;
        c = (0, _utilJs.splitter) * by;
        bhi = c - (c - by);
        blo = by - bhi;
        b[0] = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
        b[1] = s1;
        return 2;
    } else {
        s1 = xtail * ay;
        c = (0, _utilJs.splitter) * xtail;
        ahi = c - (c - xtail);
        alo = xtail - ahi;
        c = (0, _utilJs.splitter) * ay;
        bhi = c - (c - ay);
        blo = ay - bhi;
        s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
        t1 = ytail * ax;
        c = (0, _utilJs.splitter) * ytail;
        ahi = c - (c - ytail);
        alo = ytail - ahi;
        c = (0, _utilJs.splitter) * ax;
        bhi = c - (c - ax);
        blo = ax - bhi;
        t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
        _i = s0 - t0;
        bvirt = s0 - _i;
        a[0] = s0 - (_i + bvirt) + (bvirt - t0);
        _j = s1 + _i;
        bvirt = _j - s1;
        _0 = s1 - (_j - bvirt) + (_i - bvirt);
        _i = _0 - t1;
        bvirt = _0 - _i;
        a[1] = _0 - (_i + bvirt) + (bvirt - t1);
        u3 = _j + _i;
        bvirt = u3 - _j;
        a[2] = _j - (u3 - bvirt) + (_i - bvirt);
        a[3] = u3;
        s1 = ytail * bx;
        c = (0, _utilJs.splitter) * ytail;
        ahi = c - (c - ytail);
        alo = ytail - ahi;
        c = (0, _utilJs.splitter) * bx;
        bhi = c - (c - bx);
        blo = bx - bhi;
        s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
        t1 = xtail * by;
        c = (0, _utilJs.splitter) * xtail;
        ahi = c - (c - xtail);
        alo = xtail - ahi;
        c = (0, _utilJs.splitter) * by;
        bhi = c - (c - by);
        blo = by - bhi;
        t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
        _i = s0 - t0;
        bvirt = s0 - _i;
        b[0] = s0 - (_i + bvirt) + (bvirt - t0);
        _j = s1 + _i;
        bvirt = _j - s1;
        _0 = s1 - (_j - bvirt) + (_i - bvirt);
        _i = _0 - t1;
        bvirt = _0 - _i;
        b[1] = _0 - (_i + bvirt) + (bvirt - t1);
        u3 = _j + _i;
        bvirt = u3 - _j;
        b[2] = _j - (u3 - bvirt) + (_i - bvirt);
        b[3] = u3;
        return 4;
    }
}
function tailadd(finlen, a, b, k, z) {
    let bvirt, c, ahi, alo, bhi, blo, _i, _j, _k, _0, s1, s0, u3;
    s1 = a * b;
    c = (0, _utilJs.splitter) * a;
    ahi = c - (c - a);
    alo = a - ahi;
    c = (0, _utilJs.splitter) * b;
    bhi = c - (c - b);
    blo = b - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    c = (0, _utilJs.splitter) * k;
    bhi = c - (c - k);
    blo = k - bhi;
    _i = s0 * k;
    c = (0, _utilJs.splitter) * s0;
    ahi = c - (c - s0);
    alo = s0 - ahi;
    u[0] = alo * blo - (_i - ahi * bhi - alo * bhi - ahi * blo);
    _j = s1 * k;
    c = (0, _utilJs.splitter) * s1;
    ahi = c - (c - s1);
    alo = s1 - ahi;
    _0 = alo * blo - (_j - ahi * bhi - alo * bhi - ahi * blo);
    _k = _i + _0;
    bvirt = _k - _i;
    u[1] = _i - (_k - bvirt) + (_0 - bvirt);
    u3 = _j + _k;
    u[2] = _k - (u3 - _j);
    u[3] = u3;
    finlen = finadd(finlen, 4, u);
    if (z !== 0) {
        c = (0, _utilJs.splitter) * z;
        bhi = c - (c - z);
        blo = z - bhi;
        _i = s0 * z;
        c = (0, _utilJs.splitter) * s0;
        ahi = c - (c - s0);
        alo = s0 - ahi;
        u[0] = alo * blo - (_i - ahi * bhi - alo * bhi - ahi * blo);
        _j = s1 * z;
        c = (0, _utilJs.splitter) * s1;
        ahi = c - (c - s1);
        alo = s1 - ahi;
        _0 = alo * blo - (_j - ahi * bhi - alo * bhi - ahi * blo);
        _k = _i + _0;
        bvirt = _k - _i;
        u[1] = _i - (_k - bvirt) + (_0 - bvirt);
        u3 = _j + _k;
        u[2] = _k - (u3 - _j);
        u[3] = u3;
        finlen = finadd(finlen, 4, u);
    }
    return finlen;
}
function orient3dadapt(ax, ay, az, bx, by, bz, cx, cy, cz, dx, dy, dz, permanent) {
    let finlen;
    let adxtail, bdxtail, cdxtail;
    let adytail, bdytail, cdytail;
    let adztail, bdztail, cdztail;
    let bvirt, c, ahi, alo, bhi, blo, _i, _j, _k, _0, s1, s0, t1, t0, u3;
    const adx = ax - dx;
    const bdx = bx - dx;
    const cdx = cx - dx;
    const ady = ay - dy;
    const bdy = by - dy;
    const cdy = cy - dy;
    const adz = az - dz;
    const bdz = bz - dz;
    const cdz = cz - dz;
    s1 = bdx * cdy;
    c = (0, _utilJs.splitter) * bdx;
    ahi = c - (c - bdx);
    alo = bdx - ahi;
    c = (0, _utilJs.splitter) * cdy;
    bhi = c - (c - cdy);
    blo = cdy - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = cdx * bdy;
    c = (0, _utilJs.splitter) * cdx;
    ahi = c - (c - cdx);
    alo = cdx - ahi;
    c = (0, _utilJs.splitter) * bdy;
    bhi = c - (c - bdy);
    blo = bdy - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    bc[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    bc[1] = _0 - (_i + bvirt) + (bvirt - t1);
    u3 = _j + _i;
    bvirt = u3 - _j;
    bc[2] = _j - (u3 - bvirt) + (_i - bvirt);
    bc[3] = u3;
    s1 = cdx * ady;
    c = (0, _utilJs.splitter) * cdx;
    ahi = c - (c - cdx);
    alo = cdx - ahi;
    c = (0, _utilJs.splitter) * ady;
    bhi = c - (c - ady);
    blo = ady - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = adx * cdy;
    c = (0, _utilJs.splitter) * adx;
    ahi = c - (c - adx);
    alo = adx - ahi;
    c = (0, _utilJs.splitter) * cdy;
    bhi = c - (c - cdy);
    blo = cdy - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    ca[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    ca[1] = _0 - (_i + bvirt) + (bvirt - t1);
    u3 = _j + _i;
    bvirt = u3 - _j;
    ca[2] = _j - (u3 - bvirt) + (_i - bvirt);
    ca[3] = u3;
    s1 = adx * bdy;
    c = (0, _utilJs.splitter) * adx;
    ahi = c - (c - adx);
    alo = adx - ahi;
    c = (0, _utilJs.splitter) * bdy;
    bhi = c - (c - bdy);
    blo = bdy - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = bdx * ady;
    c = (0, _utilJs.splitter) * bdx;
    ahi = c - (c - bdx);
    alo = bdx - ahi;
    c = (0, _utilJs.splitter) * ady;
    bhi = c - (c - ady);
    blo = ady - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    ab[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    ab[1] = _0 - (_i + bvirt) + (bvirt - t1);
    u3 = _j + _i;
    bvirt = u3 - _j;
    ab[2] = _j - (u3 - bvirt) + (_i - bvirt);
    ab[3] = u3;
    finlen = (0, _utilJs.sum)((0, _utilJs.sum)((0, _utilJs.scale)(4, bc, adz, _8), _8, (0, _utilJs.scale)(4, ca, bdz, _8b), _8b, _16), _16, (0, _utilJs.scale)(4, ab, cdz, _8), _8, fin);
    let det = (0, _utilJs.estimate)(finlen, fin);
    let errbound = o3derrboundB * permanent;
    if (det >= errbound || -det >= errbound) return det;
    bvirt = ax - adx;
    adxtail = ax - (adx + bvirt) + (bvirt - dx);
    bvirt = bx - bdx;
    bdxtail = bx - (bdx + bvirt) + (bvirt - dx);
    bvirt = cx - cdx;
    cdxtail = cx - (cdx + bvirt) + (bvirt - dx);
    bvirt = ay - ady;
    adytail = ay - (ady + bvirt) + (bvirt - dy);
    bvirt = by - bdy;
    bdytail = by - (bdy + bvirt) + (bvirt - dy);
    bvirt = cy - cdy;
    cdytail = cy - (cdy + bvirt) + (bvirt - dy);
    bvirt = az - adz;
    adztail = az - (adz + bvirt) + (bvirt - dz);
    bvirt = bz - bdz;
    bdztail = bz - (bdz + bvirt) + (bvirt - dz);
    bvirt = cz - cdz;
    cdztail = cz - (cdz + bvirt) + (bvirt - dz);
    if (adxtail === 0 && bdxtail === 0 && cdxtail === 0 && adytail === 0 && bdytail === 0 && cdytail === 0 && adztail === 0 && bdztail === 0 && cdztail === 0) return det;
    errbound = o3derrboundC * permanent + (0, _utilJs.resulterrbound) * Math.abs(det);
    det += adz * (bdx * cdytail + cdy * bdxtail - (bdy * cdxtail + cdx * bdytail)) + adztail * (bdx * cdy - bdy * cdx) + bdz * (cdx * adytail + ady * cdxtail - (cdy * adxtail + adx * cdytail)) + bdztail * (cdx * ady - cdy * adx) + cdz * (adx * bdytail + bdy * adxtail - (ady * bdxtail + bdx * adytail)) + cdztail * (adx * bdy - ady * bdx);
    if (det >= errbound || -det >= errbound) return det;
    const at_len = tailinit(adxtail, adytail, bdx, bdy, cdx, cdy, at_b, at_c);
    const bt_len = tailinit(bdxtail, bdytail, cdx, cdy, adx, ady, bt_c, bt_a);
    const ct_len = tailinit(cdxtail, cdytail, adx, ady, bdx, bdy, ct_a, ct_b);
    const bctlen = (0, _utilJs.sum)(bt_len, bt_c, ct_len, ct_b, bct);
    finlen = finadd(finlen, (0, _utilJs.scale)(bctlen, bct, adz, _16), _16);
    const catlen = (0, _utilJs.sum)(ct_len, ct_a, at_len, at_c, cat);
    finlen = finadd(finlen, (0, _utilJs.scale)(catlen, cat, bdz, _16), _16);
    const abtlen = (0, _utilJs.sum)(at_len, at_b, bt_len, bt_a, abt);
    finlen = finadd(finlen, (0, _utilJs.scale)(abtlen, abt, cdz, _16), _16);
    if (adztail !== 0) {
        finlen = finadd(finlen, (0, _utilJs.scale)(4, bc, adztail, _12), _12);
        finlen = finadd(finlen, (0, _utilJs.scale)(bctlen, bct, adztail, _16), _16);
    }
    if (bdztail !== 0) {
        finlen = finadd(finlen, (0, _utilJs.scale)(4, ca, bdztail, _12), _12);
        finlen = finadd(finlen, (0, _utilJs.scale)(catlen, cat, bdztail, _16), _16);
    }
    if (cdztail !== 0) {
        finlen = finadd(finlen, (0, _utilJs.scale)(4, ab, cdztail, _12), _12);
        finlen = finadd(finlen, (0, _utilJs.scale)(abtlen, abt, cdztail, _16), _16);
    }
    if (adxtail !== 0) {
        if (bdytail !== 0) finlen = tailadd(finlen, adxtail, bdytail, cdz, cdztail);
        if (cdytail !== 0) finlen = tailadd(finlen, -adxtail, cdytail, bdz, bdztail);
    }
    if (bdxtail !== 0) {
        if (cdytail !== 0) finlen = tailadd(finlen, bdxtail, cdytail, adz, adztail);
        if (adytail !== 0) finlen = tailadd(finlen, -bdxtail, adytail, cdz, cdztail);
    }
    if (cdxtail !== 0) {
        if (adytail !== 0) finlen = tailadd(finlen, cdxtail, adytail, bdz, bdztail);
        if (bdytail !== 0) finlen = tailadd(finlen, -cdxtail, bdytail, adz, adztail);
    }
    return fin[finlen - 1];
}
function orient3d(ax, ay, az, bx, by, bz, cx, cy, cz, dx, dy, dz) {
    const adx = ax - dx;
    const bdx = bx - dx;
    const cdx = cx - dx;
    const ady = ay - dy;
    const bdy = by - dy;
    const cdy = cy - dy;
    const adz = az - dz;
    const bdz = bz - dz;
    const cdz = cz - dz;
    const bdxcdy = bdx * cdy;
    const cdxbdy = cdx * bdy;
    const cdxady = cdx * ady;
    const adxcdy = adx * cdy;
    const adxbdy = adx * bdy;
    const bdxady = bdx * ady;
    const det = adz * (bdxcdy - cdxbdy) + bdz * (cdxady - adxcdy) + cdz * (adxbdy - bdxady);
    const permanent = (Math.abs(bdxcdy) + Math.abs(cdxbdy)) * Math.abs(adz) + (Math.abs(cdxady) + Math.abs(adxcdy)) * Math.abs(bdz) + (Math.abs(adxbdy) + Math.abs(bdxady)) * Math.abs(cdz);
    const errbound = o3derrboundA * permanent;
    if (det > errbound || -det > errbound) return det;
    return orient3dadapt(ax, ay, az, bx, by, bz, cx, cy, cz, dx, dy, dz, permanent);
}
function orient3dfast(ax, ay, az, bx, by, bz, cx, cy, cz, dx, dy, dz) {
    const adx = ax - dx;
    const bdx = bx - dx;
    const cdx = cx - dx;
    const ady = ay - dy;
    const bdy = by - dy;
    const cdy = cy - dy;
    const adz = az - dz;
    const bdz = bz - dz;
    const cdz = cz - dz;
    return adx * (bdy * cdz - bdz * cdy) + bdx * (cdy * adz - cdz * ady) + cdx * (ady * bdz - adz * bdy);
}

},{"./util.js":"4o1Gr","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2300a":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "incircle", ()=>incircle);
parcelHelpers.export(exports, "incirclefast", ()=>incirclefast);
var _utilJs = require("./util.js");
const iccerrboundA = (10 + 96 * (0, _utilJs.epsilon)) * (0, _utilJs.epsilon);
const iccerrboundB = (4 + 48 * (0, _utilJs.epsilon)) * (0, _utilJs.epsilon);
const iccerrboundC = (44 + 576 * (0, _utilJs.epsilon)) * (0, _utilJs.epsilon) * (0, _utilJs.epsilon);
const bc = (0, _utilJs.vec)(4);
const ca = (0, _utilJs.vec)(4);
const ab = (0, _utilJs.vec)(4);
const aa = (0, _utilJs.vec)(4);
const bb = (0, _utilJs.vec)(4);
const cc = (0, _utilJs.vec)(4);
const u = (0, _utilJs.vec)(4);
const v = (0, _utilJs.vec)(4);
const axtbc = (0, _utilJs.vec)(8);
const aytbc = (0, _utilJs.vec)(8);
const bxtca = (0, _utilJs.vec)(8);
const bytca = (0, _utilJs.vec)(8);
const cxtab = (0, _utilJs.vec)(8);
const cytab = (0, _utilJs.vec)(8);
const abt = (0, _utilJs.vec)(8);
const bct = (0, _utilJs.vec)(8);
const cat = (0, _utilJs.vec)(8);
const abtt = (0, _utilJs.vec)(4);
const bctt = (0, _utilJs.vec)(4);
const catt = (0, _utilJs.vec)(4);
const _8 = (0, _utilJs.vec)(8);
const _16 = (0, _utilJs.vec)(16);
const _16b = (0, _utilJs.vec)(16);
const _16c = (0, _utilJs.vec)(16);
const _32 = (0, _utilJs.vec)(32);
const _32b = (0, _utilJs.vec)(32);
const _48 = (0, _utilJs.vec)(48);
const _64 = (0, _utilJs.vec)(64);
let fin = (0, _utilJs.vec)(1152);
let fin2 = (0, _utilJs.vec)(1152);
function finadd(finlen, a, alen) {
    finlen = (0, _utilJs.sum)(finlen, fin, a, alen, fin2);
    const tmp = fin;
    fin = fin2;
    fin2 = tmp;
    return finlen;
}
function incircleadapt(ax, ay, bx, by, cx, cy, dx, dy, permanent) {
    let finlen;
    let adxtail, bdxtail, cdxtail, adytail, bdytail, cdytail;
    let axtbclen, aytbclen, bxtcalen, bytcalen, cxtablen, cytablen;
    let abtlen, bctlen, catlen;
    let abttlen, bcttlen, cattlen;
    let n1, n0;
    let bvirt, c, ahi, alo, bhi, blo, _i, _j, _0, s1, s0, t1, t0, u3;
    const adx = ax - dx;
    const bdx = bx - dx;
    const cdx = cx - dx;
    const ady = ay - dy;
    const bdy = by - dy;
    const cdy = cy - dy;
    s1 = bdx * cdy;
    c = (0, _utilJs.splitter) * bdx;
    ahi = c - (c - bdx);
    alo = bdx - ahi;
    c = (0, _utilJs.splitter) * cdy;
    bhi = c - (c - cdy);
    blo = cdy - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = cdx * bdy;
    c = (0, _utilJs.splitter) * cdx;
    ahi = c - (c - cdx);
    alo = cdx - ahi;
    c = (0, _utilJs.splitter) * bdy;
    bhi = c - (c - bdy);
    blo = bdy - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    bc[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    bc[1] = _0 - (_i + bvirt) + (bvirt - t1);
    u3 = _j + _i;
    bvirt = u3 - _j;
    bc[2] = _j - (u3 - bvirt) + (_i - bvirt);
    bc[3] = u3;
    s1 = cdx * ady;
    c = (0, _utilJs.splitter) * cdx;
    ahi = c - (c - cdx);
    alo = cdx - ahi;
    c = (0, _utilJs.splitter) * ady;
    bhi = c - (c - ady);
    blo = ady - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = adx * cdy;
    c = (0, _utilJs.splitter) * adx;
    ahi = c - (c - adx);
    alo = adx - ahi;
    c = (0, _utilJs.splitter) * cdy;
    bhi = c - (c - cdy);
    blo = cdy - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    ca[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    ca[1] = _0 - (_i + bvirt) + (bvirt - t1);
    u3 = _j + _i;
    bvirt = u3 - _j;
    ca[2] = _j - (u3 - bvirt) + (_i - bvirt);
    ca[3] = u3;
    s1 = adx * bdy;
    c = (0, _utilJs.splitter) * adx;
    ahi = c - (c - adx);
    alo = adx - ahi;
    c = (0, _utilJs.splitter) * bdy;
    bhi = c - (c - bdy);
    blo = bdy - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = bdx * ady;
    c = (0, _utilJs.splitter) * bdx;
    ahi = c - (c - bdx);
    alo = bdx - ahi;
    c = (0, _utilJs.splitter) * ady;
    bhi = c - (c - ady);
    blo = ady - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    ab[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    ab[1] = _0 - (_i + bvirt) + (bvirt - t1);
    u3 = _j + _i;
    bvirt = u3 - _j;
    ab[2] = _j - (u3 - bvirt) + (_i - bvirt);
    ab[3] = u3;
    finlen = (0, _utilJs.sum)((0, _utilJs.sum)((0, _utilJs.sum)((0, _utilJs.scale)((0, _utilJs.scale)(4, bc, adx, _8), _8, adx, _16), _16, (0, _utilJs.scale)((0, _utilJs.scale)(4, bc, ady, _8), _8, ady, _16b), _16b, _32), _32, (0, _utilJs.sum)((0, _utilJs.scale)((0, _utilJs.scale)(4, ca, bdx, _8), _8, bdx, _16), _16, (0, _utilJs.scale)((0, _utilJs.scale)(4, ca, bdy, _8), _8, bdy, _16b), _16b, _32b), _32b, _64), _64, (0, _utilJs.sum)((0, _utilJs.scale)((0, _utilJs.scale)(4, ab, cdx, _8), _8, cdx, _16), _16, (0, _utilJs.scale)((0, _utilJs.scale)(4, ab, cdy, _8), _8, cdy, _16b), _16b, _32), _32, fin);
    let det = (0, _utilJs.estimate)(finlen, fin);
    let errbound = iccerrboundB * permanent;
    if (det >= errbound || -det >= errbound) return det;
    bvirt = ax - adx;
    adxtail = ax - (adx + bvirt) + (bvirt - dx);
    bvirt = ay - ady;
    adytail = ay - (ady + bvirt) + (bvirt - dy);
    bvirt = bx - bdx;
    bdxtail = bx - (bdx + bvirt) + (bvirt - dx);
    bvirt = by - bdy;
    bdytail = by - (bdy + bvirt) + (bvirt - dy);
    bvirt = cx - cdx;
    cdxtail = cx - (cdx + bvirt) + (bvirt - dx);
    bvirt = cy - cdy;
    cdytail = cy - (cdy + bvirt) + (bvirt - dy);
    if (adxtail === 0 && bdxtail === 0 && cdxtail === 0 && adytail === 0 && bdytail === 0 && cdytail === 0) return det;
    errbound = iccerrboundC * permanent + (0, _utilJs.resulterrbound) * Math.abs(det);
    det += (adx * adx + ady * ady) * (bdx * cdytail + cdy * bdxtail - (bdy * cdxtail + cdx * bdytail)) + 2 * (adx * adxtail + ady * adytail) * (bdx * cdy - bdy * cdx) + ((bdx * bdx + bdy * bdy) * (cdx * adytail + ady * cdxtail - (cdy * adxtail + adx * cdytail)) + 2 * (bdx * bdxtail + bdy * bdytail) * (cdx * ady - cdy * adx)) + ((cdx * cdx + cdy * cdy) * (adx * bdytail + bdy * adxtail - (ady * bdxtail + bdx * adytail)) + 2 * (cdx * cdxtail + cdy * cdytail) * (adx * bdy - ady * bdx));
    if (det >= errbound || -det >= errbound) return det;
    if (bdxtail !== 0 || bdytail !== 0 || cdxtail !== 0 || cdytail !== 0) {
        s1 = adx * adx;
        c = (0, _utilJs.splitter) * adx;
        ahi = c - (c - adx);
        alo = adx - ahi;
        s0 = alo * alo - (s1 - ahi * ahi - (ahi + ahi) * alo);
        t1 = ady * ady;
        c = (0, _utilJs.splitter) * ady;
        ahi = c - (c - ady);
        alo = ady - ahi;
        t0 = alo * alo - (t1 - ahi * ahi - (ahi + ahi) * alo);
        _i = s0 + t0;
        bvirt = _i - s0;
        aa[0] = s0 - (_i - bvirt) + (t0 - bvirt);
        _j = s1 + _i;
        bvirt = _j - s1;
        _0 = s1 - (_j - bvirt) + (_i - bvirt);
        _i = _0 + t1;
        bvirt = _i - _0;
        aa[1] = _0 - (_i - bvirt) + (t1 - bvirt);
        u3 = _j + _i;
        bvirt = u3 - _j;
        aa[2] = _j - (u3 - bvirt) + (_i - bvirt);
        aa[3] = u3;
    }
    if (cdxtail !== 0 || cdytail !== 0 || adxtail !== 0 || adytail !== 0) {
        s1 = bdx * bdx;
        c = (0, _utilJs.splitter) * bdx;
        ahi = c - (c - bdx);
        alo = bdx - ahi;
        s0 = alo * alo - (s1 - ahi * ahi - (ahi + ahi) * alo);
        t1 = bdy * bdy;
        c = (0, _utilJs.splitter) * bdy;
        ahi = c - (c - bdy);
        alo = bdy - ahi;
        t0 = alo * alo - (t1 - ahi * ahi - (ahi + ahi) * alo);
        _i = s0 + t0;
        bvirt = _i - s0;
        bb[0] = s0 - (_i - bvirt) + (t0 - bvirt);
        _j = s1 + _i;
        bvirt = _j - s1;
        _0 = s1 - (_j - bvirt) + (_i - bvirt);
        _i = _0 + t1;
        bvirt = _i - _0;
        bb[1] = _0 - (_i - bvirt) + (t1 - bvirt);
        u3 = _j + _i;
        bvirt = u3 - _j;
        bb[2] = _j - (u3 - bvirt) + (_i - bvirt);
        bb[3] = u3;
    }
    if (adxtail !== 0 || adytail !== 0 || bdxtail !== 0 || bdytail !== 0) {
        s1 = cdx * cdx;
        c = (0, _utilJs.splitter) * cdx;
        ahi = c - (c - cdx);
        alo = cdx - ahi;
        s0 = alo * alo - (s1 - ahi * ahi - (ahi + ahi) * alo);
        t1 = cdy * cdy;
        c = (0, _utilJs.splitter) * cdy;
        ahi = c - (c - cdy);
        alo = cdy - ahi;
        t0 = alo * alo - (t1 - ahi * ahi - (ahi + ahi) * alo);
        _i = s0 + t0;
        bvirt = _i - s0;
        cc[0] = s0 - (_i - bvirt) + (t0 - bvirt);
        _j = s1 + _i;
        bvirt = _j - s1;
        _0 = s1 - (_j - bvirt) + (_i - bvirt);
        _i = _0 + t1;
        bvirt = _i - _0;
        cc[1] = _0 - (_i - bvirt) + (t1 - bvirt);
        u3 = _j + _i;
        bvirt = u3 - _j;
        cc[2] = _j - (u3 - bvirt) + (_i - bvirt);
        cc[3] = u3;
    }
    if (adxtail !== 0) {
        axtbclen = (0, _utilJs.scale)(4, bc, adxtail, axtbc);
        finlen = finadd(finlen, (0, _utilJs.sum_three)((0, _utilJs.scale)(axtbclen, axtbc, 2 * adx, _16), _16, (0, _utilJs.scale)((0, _utilJs.scale)(4, cc, adxtail, _8), _8, bdy, _16b), _16b, (0, _utilJs.scale)((0, _utilJs.scale)(4, bb, adxtail, _8), _8, -cdy, _16c), _16c, _32, _48), _48);
    }
    if (adytail !== 0) {
        aytbclen = (0, _utilJs.scale)(4, bc, adytail, aytbc);
        finlen = finadd(finlen, (0, _utilJs.sum_three)((0, _utilJs.scale)(aytbclen, aytbc, 2 * ady, _16), _16, (0, _utilJs.scale)((0, _utilJs.scale)(4, bb, adytail, _8), _8, cdx, _16b), _16b, (0, _utilJs.scale)((0, _utilJs.scale)(4, cc, adytail, _8), _8, -bdx, _16c), _16c, _32, _48), _48);
    }
    if (bdxtail !== 0) {
        bxtcalen = (0, _utilJs.scale)(4, ca, bdxtail, bxtca);
        finlen = finadd(finlen, (0, _utilJs.sum_three)((0, _utilJs.scale)(bxtcalen, bxtca, 2 * bdx, _16), _16, (0, _utilJs.scale)((0, _utilJs.scale)(4, aa, bdxtail, _8), _8, cdy, _16b), _16b, (0, _utilJs.scale)((0, _utilJs.scale)(4, cc, bdxtail, _8), _8, -ady, _16c), _16c, _32, _48), _48);
    }
    if (bdytail !== 0) {
        bytcalen = (0, _utilJs.scale)(4, ca, bdytail, bytca);
        finlen = finadd(finlen, (0, _utilJs.sum_three)((0, _utilJs.scale)(bytcalen, bytca, 2 * bdy, _16), _16, (0, _utilJs.scale)((0, _utilJs.scale)(4, cc, bdytail, _8), _8, adx, _16b), _16b, (0, _utilJs.scale)((0, _utilJs.scale)(4, aa, bdytail, _8), _8, -cdx, _16c), _16c, _32, _48), _48);
    }
    if (cdxtail !== 0) {
        cxtablen = (0, _utilJs.scale)(4, ab, cdxtail, cxtab);
        finlen = finadd(finlen, (0, _utilJs.sum_three)((0, _utilJs.scale)(cxtablen, cxtab, 2 * cdx, _16), _16, (0, _utilJs.scale)((0, _utilJs.scale)(4, bb, cdxtail, _8), _8, ady, _16b), _16b, (0, _utilJs.scale)((0, _utilJs.scale)(4, aa, cdxtail, _8), _8, -bdy, _16c), _16c, _32, _48), _48);
    }
    if (cdytail !== 0) {
        cytablen = (0, _utilJs.scale)(4, ab, cdytail, cytab);
        finlen = finadd(finlen, (0, _utilJs.sum_three)((0, _utilJs.scale)(cytablen, cytab, 2 * cdy, _16), _16, (0, _utilJs.scale)((0, _utilJs.scale)(4, aa, cdytail, _8), _8, bdx, _16b), _16b, (0, _utilJs.scale)((0, _utilJs.scale)(4, bb, cdytail, _8), _8, -adx, _16c), _16c, _32, _48), _48);
    }
    if (adxtail !== 0 || adytail !== 0) {
        if (bdxtail !== 0 || bdytail !== 0 || cdxtail !== 0 || cdytail !== 0) {
            s1 = bdxtail * cdy;
            c = (0, _utilJs.splitter) * bdxtail;
            ahi = c - (c - bdxtail);
            alo = bdxtail - ahi;
            c = (0, _utilJs.splitter) * cdy;
            bhi = c - (c - cdy);
            blo = cdy - bhi;
            s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
            t1 = bdx * cdytail;
            c = (0, _utilJs.splitter) * bdx;
            ahi = c - (c - bdx);
            alo = bdx - ahi;
            c = (0, _utilJs.splitter) * cdytail;
            bhi = c - (c - cdytail);
            blo = cdytail - bhi;
            t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
            _i = s0 + t0;
            bvirt = _i - s0;
            u[0] = s0 - (_i - bvirt) + (t0 - bvirt);
            _j = s1 + _i;
            bvirt = _j - s1;
            _0 = s1 - (_j - bvirt) + (_i - bvirt);
            _i = _0 + t1;
            bvirt = _i - _0;
            u[1] = _0 - (_i - bvirt) + (t1 - bvirt);
            u3 = _j + _i;
            bvirt = u3 - _j;
            u[2] = _j - (u3 - bvirt) + (_i - bvirt);
            u[3] = u3;
            s1 = cdxtail * -bdy;
            c = (0, _utilJs.splitter) * cdxtail;
            ahi = c - (c - cdxtail);
            alo = cdxtail - ahi;
            c = (0, _utilJs.splitter) * -bdy;
            bhi = c - (c - -bdy);
            blo = -bdy - bhi;
            s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
            t1 = cdx * -bdytail;
            c = (0, _utilJs.splitter) * cdx;
            ahi = c - (c - cdx);
            alo = cdx - ahi;
            c = (0, _utilJs.splitter) * -bdytail;
            bhi = c - (c - -bdytail);
            blo = -bdytail - bhi;
            t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
            _i = s0 + t0;
            bvirt = _i - s0;
            v[0] = s0 - (_i - bvirt) + (t0 - bvirt);
            _j = s1 + _i;
            bvirt = _j - s1;
            _0 = s1 - (_j - bvirt) + (_i - bvirt);
            _i = _0 + t1;
            bvirt = _i - _0;
            v[1] = _0 - (_i - bvirt) + (t1 - bvirt);
            u3 = _j + _i;
            bvirt = u3 - _j;
            v[2] = _j - (u3 - bvirt) + (_i - bvirt);
            v[3] = u3;
            bctlen = (0, _utilJs.sum)(4, u, 4, v, bct);
            s1 = bdxtail * cdytail;
            c = (0, _utilJs.splitter) * bdxtail;
            ahi = c - (c - bdxtail);
            alo = bdxtail - ahi;
            c = (0, _utilJs.splitter) * cdytail;
            bhi = c - (c - cdytail);
            blo = cdytail - bhi;
            s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
            t1 = cdxtail * bdytail;
            c = (0, _utilJs.splitter) * cdxtail;
            ahi = c - (c - cdxtail);
            alo = cdxtail - ahi;
            c = (0, _utilJs.splitter) * bdytail;
            bhi = c - (c - bdytail);
            blo = bdytail - bhi;
            t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
            _i = s0 - t0;
            bvirt = s0 - _i;
            bctt[0] = s0 - (_i + bvirt) + (bvirt - t0);
            _j = s1 + _i;
            bvirt = _j - s1;
            _0 = s1 - (_j - bvirt) + (_i - bvirt);
            _i = _0 - t1;
            bvirt = _0 - _i;
            bctt[1] = _0 - (_i + bvirt) + (bvirt - t1);
            u3 = _j + _i;
            bvirt = u3 - _j;
            bctt[2] = _j - (u3 - bvirt) + (_i - bvirt);
            bctt[3] = u3;
            bcttlen = 4;
        } else {
            bct[0] = 0;
            bctlen = 1;
            bctt[0] = 0;
            bcttlen = 1;
        }
        if (adxtail !== 0) {
            const len = (0, _utilJs.scale)(bctlen, bct, adxtail, _16c);
            finlen = finadd(finlen, (0, _utilJs.sum)((0, _utilJs.scale)(axtbclen, axtbc, adxtail, _16), _16, (0, _utilJs.scale)(len, _16c, 2 * adx, _32), _32, _48), _48);
            const len2 = (0, _utilJs.scale)(bcttlen, bctt, adxtail, _8);
            finlen = finadd(finlen, (0, _utilJs.sum_three)((0, _utilJs.scale)(len2, _8, 2 * adx, _16), _16, (0, _utilJs.scale)(len2, _8, adxtail, _16b), _16b, (0, _utilJs.scale)(len, _16c, adxtail, _32), _32, _32b, _64), _64);
            if (bdytail !== 0) finlen = finadd(finlen, (0, _utilJs.scale)((0, _utilJs.scale)(4, cc, adxtail, _8), _8, bdytail, _16), _16);
            if (cdytail !== 0) finlen = finadd(finlen, (0, _utilJs.scale)((0, _utilJs.scale)(4, bb, -adxtail, _8), _8, cdytail, _16), _16);
        }
        if (adytail !== 0) {
            const len = (0, _utilJs.scale)(bctlen, bct, adytail, _16c);
            finlen = finadd(finlen, (0, _utilJs.sum)((0, _utilJs.scale)(aytbclen, aytbc, adytail, _16), _16, (0, _utilJs.scale)(len, _16c, 2 * ady, _32), _32, _48), _48);
            const len2 = (0, _utilJs.scale)(bcttlen, bctt, adytail, _8);
            finlen = finadd(finlen, (0, _utilJs.sum_three)((0, _utilJs.scale)(len2, _8, 2 * ady, _16), _16, (0, _utilJs.scale)(len2, _8, adytail, _16b), _16b, (0, _utilJs.scale)(len, _16c, adytail, _32), _32, _32b, _64), _64);
        }
    }
    if (bdxtail !== 0 || bdytail !== 0) {
        if (cdxtail !== 0 || cdytail !== 0 || adxtail !== 0 || adytail !== 0) {
            s1 = cdxtail * ady;
            c = (0, _utilJs.splitter) * cdxtail;
            ahi = c - (c - cdxtail);
            alo = cdxtail - ahi;
            c = (0, _utilJs.splitter) * ady;
            bhi = c - (c - ady);
            blo = ady - bhi;
            s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
            t1 = cdx * adytail;
            c = (0, _utilJs.splitter) * cdx;
            ahi = c - (c - cdx);
            alo = cdx - ahi;
            c = (0, _utilJs.splitter) * adytail;
            bhi = c - (c - adytail);
            blo = adytail - bhi;
            t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
            _i = s0 + t0;
            bvirt = _i - s0;
            u[0] = s0 - (_i - bvirt) + (t0 - bvirt);
            _j = s1 + _i;
            bvirt = _j - s1;
            _0 = s1 - (_j - bvirt) + (_i - bvirt);
            _i = _0 + t1;
            bvirt = _i - _0;
            u[1] = _0 - (_i - bvirt) + (t1 - bvirt);
            u3 = _j + _i;
            bvirt = u3 - _j;
            u[2] = _j - (u3 - bvirt) + (_i - bvirt);
            u[3] = u3;
            n1 = -cdy;
            n0 = -cdytail;
            s1 = adxtail * n1;
            c = (0, _utilJs.splitter) * adxtail;
            ahi = c - (c - adxtail);
            alo = adxtail - ahi;
            c = (0, _utilJs.splitter) * n1;
            bhi = c - (c - n1);
            blo = n1 - bhi;
            s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
            t1 = adx * n0;
            c = (0, _utilJs.splitter) * adx;
            ahi = c - (c - adx);
            alo = adx - ahi;
            c = (0, _utilJs.splitter) * n0;
            bhi = c - (c - n0);
            blo = n0 - bhi;
            t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
            _i = s0 + t0;
            bvirt = _i - s0;
            v[0] = s0 - (_i - bvirt) + (t0 - bvirt);
            _j = s1 + _i;
            bvirt = _j - s1;
            _0 = s1 - (_j - bvirt) + (_i - bvirt);
            _i = _0 + t1;
            bvirt = _i - _0;
            v[1] = _0 - (_i - bvirt) + (t1 - bvirt);
            u3 = _j + _i;
            bvirt = u3 - _j;
            v[2] = _j - (u3 - bvirt) + (_i - bvirt);
            v[3] = u3;
            catlen = (0, _utilJs.sum)(4, u, 4, v, cat);
            s1 = cdxtail * adytail;
            c = (0, _utilJs.splitter) * cdxtail;
            ahi = c - (c - cdxtail);
            alo = cdxtail - ahi;
            c = (0, _utilJs.splitter) * adytail;
            bhi = c - (c - adytail);
            blo = adytail - bhi;
            s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
            t1 = adxtail * cdytail;
            c = (0, _utilJs.splitter) * adxtail;
            ahi = c - (c - adxtail);
            alo = adxtail - ahi;
            c = (0, _utilJs.splitter) * cdytail;
            bhi = c - (c - cdytail);
            blo = cdytail - bhi;
            t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
            _i = s0 - t0;
            bvirt = s0 - _i;
            catt[0] = s0 - (_i + bvirt) + (bvirt - t0);
            _j = s1 + _i;
            bvirt = _j - s1;
            _0 = s1 - (_j - bvirt) + (_i - bvirt);
            _i = _0 - t1;
            bvirt = _0 - _i;
            catt[1] = _0 - (_i + bvirt) + (bvirt - t1);
            u3 = _j + _i;
            bvirt = u3 - _j;
            catt[2] = _j - (u3 - bvirt) + (_i - bvirt);
            catt[3] = u3;
            cattlen = 4;
        } else {
            cat[0] = 0;
            catlen = 1;
            catt[0] = 0;
            cattlen = 1;
        }
        if (bdxtail !== 0) {
            const len = (0, _utilJs.scale)(catlen, cat, bdxtail, _16c);
            finlen = finadd(finlen, (0, _utilJs.sum)((0, _utilJs.scale)(bxtcalen, bxtca, bdxtail, _16), _16, (0, _utilJs.scale)(len, _16c, 2 * bdx, _32), _32, _48), _48);
            const len2 = (0, _utilJs.scale)(cattlen, catt, bdxtail, _8);
            finlen = finadd(finlen, (0, _utilJs.sum_three)((0, _utilJs.scale)(len2, _8, 2 * bdx, _16), _16, (0, _utilJs.scale)(len2, _8, bdxtail, _16b), _16b, (0, _utilJs.scale)(len, _16c, bdxtail, _32), _32, _32b, _64), _64);
            if (cdytail !== 0) finlen = finadd(finlen, (0, _utilJs.scale)((0, _utilJs.scale)(4, aa, bdxtail, _8), _8, cdytail, _16), _16);
            if (adytail !== 0) finlen = finadd(finlen, (0, _utilJs.scale)((0, _utilJs.scale)(4, cc, -bdxtail, _8), _8, adytail, _16), _16);
        }
        if (bdytail !== 0) {
            const len = (0, _utilJs.scale)(catlen, cat, bdytail, _16c);
            finlen = finadd(finlen, (0, _utilJs.sum)((0, _utilJs.scale)(bytcalen, bytca, bdytail, _16), _16, (0, _utilJs.scale)(len, _16c, 2 * bdy, _32), _32, _48), _48);
            const len2 = (0, _utilJs.scale)(cattlen, catt, bdytail, _8);
            finlen = finadd(finlen, (0, _utilJs.sum_three)((0, _utilJs.scale)(len2, _8, 2 * bdy, _16), _16, (0, _utilJs.scale)(len2, _8, bdytail, _16b), _16b, (0, _utilJs.scale)(len, _16c, bdytail, _32), _32, _32b, _64), _64);
        }
    }
    if (cdxtail !== 0 || cdytail !== 0) {
        if (adxtail !== 0 || adytail !== 0 || bdxtail !== 0 || bdytail !== 0) {
            s1 = adxtail * bdy;
            c = (0, _utilJs.splitter) * adxtail;
            ahi = c - (c - adxtail);
            alo = adxtail - ahi;
            c = (0, _utilJs.splitter) * bdy;
            bhi = c - (c - bdy);
            blo = bdy - bhi;
            s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
            t1 = adx * bdytail;
            c = (0, _utilJs.splitter) * adx;
            ahi = c - (c - adx);
            alo = adx - ahi;
            c = (0, _utilJs.splitter) * bdytail;
            bhi = c - (c - bdytail);
            blo = bdytail - bhi;
            t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
            _i = s0 + t0;
            bvirt = _i - s0;
            u[0] = s0 - (_i - bvirt) + (t0 - bvirt);
            _j = s1 + _i;
            bvirt = _j - s1;
            _0 = s1 - (_j - bvirt) + (_i - bvirt);
            _i = _0 + t1;
            bvirt = _i - _0;
            u[1] = _0 - (_i - bvirt) + (t1 - bvirt);
            u3 = _j + _i;
            bvirt = u3 - _j;
            u[2] = _j - (u3 - bvirt) + (_i - bvirt);
            u[3] = u3;
            n1 = -ady;
            n0 = -adytail;
            s1 = bdxtail * n1;
            c = (0, _utilJs.splitter) * bdxtail;
            ahi = c - (c - bdxtail);
            alo = bdxtail - ahi;
            c = (0, _utilJs.splitter) * n1;
            bhi = c - (c - n1);
            blo = n1 - bhi;
            s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
            t1 = bdx * n0;
            c = (0, _utilJs.splitter) * bdx;
            ahi = c - (c - bdx);
            alo = bdx - ahi;
            c = (0, _utilJs.splitter) * n0;
            bhi = c - (c - n0);
            blo = n0 - bhi;
            t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
            _i = s0 + t0;
            bvirt = _i - s0;
            v[0] = s0 - (_i - bvirt) + (t0 - bvirt);
            _j = s1 + _i;
            bvirt = _j - s1;
            _0 = s1 - (_j - bvirt) + (_i - bvirt);
            _i = _0 + t1;
            bvirt = _i - _0;
            v[1] = _0 - (_i - bvirt) + (t1 - bvirt);
            u3 = _j + _i;
            bvirt = u3 - _j;
            v[2] = _j - (u3 - bvirt) + (_i - bvirt);
            v[3] = u3;
            abtlen = (0, _utilJs.sum)(4, u, 4, v, abt);
            s1 = adxtail * bdytail;
            c = (0, _utilJs.splitter) * adxtail;
            ahi = c - (c - adxtail);
            alo = adxtail - ahi;
            c = (0, _utilJs.splitter) * bdytail;
            bhi = c - (c - bdytail);
            blo = bdytail - bhi;
            s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
            t1 = bdxtail * adytail;
            c = (0, _utilJs.splitter) * bdxtail;
            ahi = c - (c - bdxtail);
            alo = bdxtail - ahi;
            c = (0, _utilJs.splitter) * adytail;
            bhi = c - (c - adytail);
            blo = adytail - bhi;
            t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
            _i = s0 - t0;
            bvirt = s0 - _i;
            abtt[0] = s0 - (_i + bvirt) + (bvirt - t0);
            _j = s1 + _i;
            bvirt = _j - s1;
            _0 = s1 - (_j - bvirt) + (_i - bvirt);
            _i = _0 - t1;
            bvirt = _0 - _i;
            abtt[1] = _0 - (_i + bvirt) + (bvirt - t1);
            u3 = _j + _i;
            bvirt = u3 - _j;
            abtt[2] = _j - (u3 - bvirt) + (_i - bvirt);
            abtt[3] = u3;
            abttlen = 4;
        } else {
            abt[0] = 0;
            abtlen = 1;
            abtt[0] = 0;
            abttlen = 1;
        }
        if (cdxtail !== 0) {
            const len = (0, _utilJs.scale)(abtlen, abt, cdxtail, _16c);
            finlen = finadd(finlen, (0, _utilJs.sum)((0, _utilJs.scale)(cxtablen, cxtab, cdxtail, _16), _16, (0, _utilJs.scale)(len, _16c, 2 * cdx, _32), _32, _48), _48);
            const len2 = (0, _utilJs.scale)(abttlen, abtt, cdxtail, _8);
            finlen = finadd(finlen, (0, _utilJs.sum_three)((0, _utilJs.scale)(len2, _8, 2 * cdx, _16), _16, (0, _utilJs.scale)(len2, _8, cdxtail, _16b), _16b, (0, _utilJs.scale)(len, _16c, cdxtail, _32), _32, _32b, _64), _64);
            if (adytail !== 0) finlen = finadd(finlen, (0, _utilJs.scale)((0, _utilJs.scale)(4, bb, cdxtail, _8), _8, adytail, _16), _16);
            if (bdytail !== 0) finlen = finadd(finlen, (0, _utilJs.scale)((0, _utilJs.scale)(4, aa, -cdxtail, _8), _8, bdytail, _16), _16);
        }
        if (cdytail !== 0) {
            const len = (0, _utilJs.scale)(abtlen, abt, cdytail, _16c);
            finlen = finadd(finlen, (0, _utilJs.sum)((0, _utilJs.scale)(cytablen, cytab, cdytail, _16), _16, (0, _utilJs.scale)(len, _16c, 2 * cdy, _32), _32, _48), _48);
            const len2 = (0, _utilJs.scale)(abttlen, abtt, cdytail, _8);
            finlen = finadd(finlen, (0, _utilJs.sum_three)((0, _utilJs.scale)(len2, _8, 2 * cdy, _16), _16, (0, _utilJs.scale)(len2, _8, cdytail, _16b), _16b, (0, _utilJs.scale)(len, _16c, cdytail, _32), _32, _32b, _64), _64);
        }
    }
    return fin[finlen - 1];
}
function incircle(ax, ay, bx, by, cx, cy, dx, dy) {
    const adx = ax - dx;
    const bdx = bx - dx;
    const cdx = cx - dx;
    const ady = ay - dy;
    const bdy = by - dy;
    const cdy = cy - dy;
    const bdxcdy = bdx * cdy;
    const cdxbdy = cdx * bdy;
    const alift = adx * adx + ady * ady;
    const cdxady = cdx * ady;
    const adxcdy = adx * cdy;
    const blift = bdx * bdx + bdy * bdy;
    const adxbdy = adx * bdy;
    const bdxady = bdx * ady;
    const clift = cdx * cdx + cdy * cdy;
    const det = alift * (bdxcdy - cdxbdy) + blift * (cdxady - adxcdy) + clift * (adxbdy - bdxady);
    const permanent = (Math.abs(bdxcdy) + Math.abs(cdxbdy)) * alift + (Math.abs(cdxady) + Math.abs(adxcdy)) * blift + (Math.abs(adxbdy) + Math.abs(bdxady)) * clift;
    const errbound = iccerrboundA * permanent;
    if (det > errbound || -det > errbound) return det;
    return incircleadapt(ax, ay, bx, by, cx, cy, dx, dy, permanent);
}
function incirclefast(ax, ay, bx, by, cx, cy, dx, dy) {
    const adx = ax - dx;
    const ady = ay - dy;
    const bdx = bx - dx;
    const bdy = by - dy;
    const cdx = cx - dx;
    const cdy = cy - dy;
    const abdet = adx * bdy - bdx * ady;
    const bcdet = bdx * cdy - cdx * bdy;
    const cadet = cdx * ady - adx * cdy;
    const alift = adx * adx + ady * ady;
    const blift = bdx * bdx + bdy * bdy;
    const clift = cdx * cdx + cdy * cdy;
    return alift * bcdet + blift * cadet + clift * abdet;
}

},{"./util.js":"4o1Gr","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"lx5e5":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "insphere", ()=>insphere);
parcelHelpers.export(exports, "inspherefast", ()=>inspherefast);
var _utilJs = require("./util.js");
const isperrboundA = (16 + 224 * (0, _utilJs.epsilon)) * (0, _utilJs.epsilon);
const isperrboundB = (5 + 72 * (0, _utilJs.epsilon)) * (0, _utilJs.epsilon);
const isperrboundC = (71 + 1408 * (0, _utilJs.epsilon)) * (0, _utilJs.epsilon) * (0, _utilJs.epsilon);
const ab = (0, _utilJs.vec)(4);
const bc = (0, _utilJs.vec)(4);
const cd = (0, _utilJs.vec)(4);
const de = (0, _utilJs.vec)(4);
const ea = (0, _utilJs.vec)(4);
const ac = (0, _utilJs.vec)(4);
const bd = (0, _utilJs.vec)(4);
const ce = (0, _utilJs.vec)(4);
const da = (0, _utilJs.vec)(4);
const eb = (0, _utilJs.vec)(4);
const abc = (0, _utilJs.vec)(24);
const bcd = (0, _utilJs.vec)(24);
const cde = (0, _utilJs.vec)(24);
const dea = (0, _utilJs.vec)(24);
const eab = (0, _utilJs.vec)(24);
const abd = (0, _utilJs.vec)(24);
const bce = (0, _utilJs.vec)(24);
const cda = (0, _utilJs.vec)(24);
const deb = (0, _utilJs.vec)(24);
const eac = (0, _utilJs.vec)(24);
const adet = (0, _utilJs.vec)(1152);
const bdet = (0, _utilJs.vec)(1152);
const cdet = (0, _utilJs.vec)(1152);
const ddet = (0, _utilJs.vec)(1152);
const edet = (0, _utilJs.vec)(1152);
const abdet = (0, _utilJs.vec)(2304);
const cddet = (0, _utilJs.vec)(2304);
const cdedet = (0, _utilJs.vec)(3456);
const deter = (0, _utilJs.vec)(5760);
const _8 = (0, _utilJs.vec)(8);
const _8b = (0, _utilJs.vec)(8);
const _8c = (0, _utilJs.vec)(8);
const _16 = (0, _utilJs.vec)(16);
const _24 = (0, _utilJs.vec)(24);
const _48 = (0, _utilJs.vec)(48);
const _48b = (0, _utilJs.vec)(48);
const _96 = (0, _utilJs.vec)(96);
const _192 = (0, _utilJs.vec)(192);
const _384x = (0, _utilJs.vec)(384);
const _384y = (0, _utilJs.vec)(384);
const _384z = (0, _utilJs.vec)(384);
const _768 = (0, _utilJs.vec)(768);
function sum_three_scale(a, b, c, az, bz, cz, out) {
    return (0, _utilJs.sum_three)((0, _utilJs.scale)(4, a, az, _8), _8, (0, _utilJs.scale)(4, b, bz, _8b), _8b, (0, _utilJs.scale)(4, c, cz, _8c), _8c, _16, out);
}
function liftexact(alen, a, blen, b, clen, c, dlen, d, x, y, z, out) {
    const len = (0, _utilJs.sum)((0, _utilJs.sum)(alen, a, blen, b, _48), _48, (0, _utilJs.negate)((0, _utilJs.sum)(clen, c, dlen, d, _48b), _48b), _48b, _96);
    return (0, _utilJs.sum_three)((0, _utilJs.scale)((0, _utilJs.scale)(len, _96, x, _192), _192, x, _384x), _384x, (0, _utilJs.scale)((0, _utilJs.scale)(len, _96, y, _192), _192, y, _384y), _384y, (0, _utilJs.scale)((0, _utilJs.scale)(len, _96, z, _192), _192, z, _384z), _384z, _768, out);
}
function insphereexact(ax, ay, az, bx, by, bz, cx, cy, cz, dx, dy, dz, ex, ey, ez) {
    let bvirt, c, ahi, alo, bhi, blo, _i, _j, _0, s1, s0, t1, t0, u3;
    s1 = ax * by;
    c = (0, _utilJs.splitter) * ax;
    ahi = c - (c - ax);
    alo = ax - ahi;
    c = (0, _utilJs.splitter) * by;
    bhi = c - (c - by);
    blo = by - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = bx * ay;
    c = (0, _utilJs.splitter) * bx;
    ahi = c - (c - bx);
    alo = bx - ahi;
    c = (0, _utilJs.splitter) * ay;
    bhi = c - (c - ay);
    blo = ay - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    ab[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    ab[1] = _0 - (_i + bvirt) + (bvirt - t1);
    u3 = _j + _i;
    bvirt = u3 - _j;
    ab[2] = _j - (u3 - bvirt) + (_i - bvirt);
    ab[3] = u3;
    s1 = bx * cy;
    c = (0, _utilJs.splitter) * bx;
    ahi = c - (c - bx);
    alo = bx - ahi;
    c = (0, _utilJs.splitter) * cy;
    bhi = c - (c - cy);
    blo = cy - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = cx * by;
    c = (0, _utilJs.splitter) * cx;
    ahi = c - (c - cx);
    alo = cx - ahi;
    c = (0, _utilJs.splitter) * by;
    bhi = c - (c - by);
    blo = by - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    bc[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    bc[1] = _0 - (_i + bvirt) + (bvirt - t1);
    u3 = _j + _i;
    bvirt = u3 - _j;
    bc[2] = _j - (u3 - bvirt) + (_i - bvirt);
    bc[3] = u3;
    s1 = cx * dy;
    c = (0, _utilJs.splitter) * cx;
    ahi = c - (c - cx);
    alo = cx - ahi;
    c = (0, _utilJs.splitter) * dy;
    bhi = c - (c - dy);
    blo = dy - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = dx * cy;
    c = (0, _utilJs.splitter) * dx;
    ahi = c - (c - dx);
    alo = dx - ahi;
    c = (0, _utilJs.splitter) * cy;
    bhi = c - (c - cy);
    blo = cy - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    cd[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    cd[1] = _0 - (_i + bvirt) + (bvirt - t1);
    u3 = _j + _i;
    bvirt = u3 - _j;
    cd[2] = _j - (u3 - bvirt) + (_i - bvirt);
    cd[3] = u3;
    s1 = dx * ey;
    c = (0, _utilJs.splitter) * dx;
    ahi = c - (c - dx);
    alo = dx - ahi;
    c = (0, _utilJs.splitter) * ey;
    bhi = c - (c - ey);
    blo = ey - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = ex * dy;
    c = (0, _utilJs.splitter) * ex;
    ahi = c - (c - ex);
    alo = ex - ahi;
    c = (0, _utilJs.splitter) * dy;
    bhi = c - (c - dy);
    blo = dy - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    de[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    de[1] = _0 - (_i + bvirt) + (bvirt - t1);
    u3 = _j + _i;
    bvirt = u3 - _j;
    de[2] = _j - (u3 - bvirt) + (_i - bvirt);
    de[3] = u3;
    s1 = ex * ay;
    c = (0, _utilJs.splitter) * ex;
    ahi = c - (c - ex);
    alo = ex - ahi;
    c = (0, _utilJs.splitter) * ay;
    bhi = c - (c - ay);
    blo = ay - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = ax * ey;
    c = (0, _utilJs.splitter) * ax;
    ahi = c - (c - ax);
    alo = ax - ahi;
    c = (0, _utilJs.splitter) * ey;
    bhi = c - (c - ey);
    blo = ey - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    ea[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    ea[1] = _0 - (_i + bvirt) + (bvirt - t1);
    u3 = _j + _i;
    bvirt = u3 - _j;
    ea[2] = _j - (u3 - bvirt) + (_i - bvirt);
    ea[3] = u3;
    s1 = ax * cy;
    c = (0, _utilJs.splitter) * ax;
    ahi = c - (c - ax);
    alo = ax - ahi;
    c = (0, _utilJs.splitter) * cy;
    bhi = c - (c - cy);
    blo = cy - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = cx * ay;
    c = (0, _utilJs.splitter) * cx;
    ahi = c - (c - cx);
    alo = cx - ahi;
    c = (0, _utilJs.splitter) * ay;
    bhi = c - (c - ay);
    blo = ay - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    ac[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    ac[1] = _0 - (_i + bvirt) + (bvirt - t1);
    u3 = _j + _i;
    bvirt = u3 - _j;
    ac[2] = _j - (u3 - bvirt) + (_i - bvirt);
    ac[3] = u3;
    s1 = bx * dy;
    c = (0, _utilJs.splitter) * bx;
    ahi = c - (c - bx);
    alo = bx - ahi;
    c = (0, _utilJs.splitter) * dy;
    bhi = c - (c - dy);
    blo = dy - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = dx * by;
    c = (0, _utilJs.splitter) * dx;
    ahi = c - (c - dx);
    alo = dx - ahi;
    c = (0, _utilJs.splitter) * by;
    bhi = c - (c - by);
    blo = by - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    bd[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    bd[1] = _0 - (_i + bvirt) + (bvirt - t1);
    u3 = _j + _i;
    bvirt = u3 - _j;
    bd[2] = _j - (u3 - bvirt) + (_i - bvirt);
    bd[3] = u3;
    s1 = cx * ey;
    c = (0, _utilJs.splitter) * cx;
    ahi = c - (c - cx);
    alo = cx - ahi;
    c = (0, _utilJs.splitter) * ey;
    bhi = c - (c - ey);
    blo = ey - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = ex * cy;
    c = (0, _utilJs.splitter) * ex;
    ahi = c - (c - ex);
    alo = ex - ahi;
    c = (0, _utilJs.splitter) * cy;
    bhi = c - (c - cy);
    blo = cy - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    ce[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    ce[1] = _0 - (_i + bvirt) + (bvirt - t1);
    u3 = _j + _i;
    bvirt = u3 - _j;
    ce[2] = _j - (u3 - bvirt) + (_i - bvirt);
    ce[3] = u3;
    s1 = dx * ay;
    c = (0, _utilJs.splitter) * dx;
    ahi = c - (c - dx);
    alo = dx - ahi;
    c = (0, _utilJs.splitter) * ay;
    bhi = c - (c - ay);
    blo = ay - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = ax * dy;
    c = (0, _utilJs.splitter) * ax;
    ahi = c - (c - ax);
    alo = ax - ahi;
    c = (0, _utilJs.splitter) * dy;
    bhi = c - (c - dy);
    blo = dy - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    da[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    da[1] = _0 - (_i + bvirt) + (bvirt - t1);
    u3 = _j + _i;
    bvirt = u3 - _j;
    da[2] = _j - (u3 - bvirt) + (_i - bvirt);
    da[3] = u3;
    s1 = ex * by;
    c = (0, _utilJs.splitter) * ex;
    ahi = c - (c - ex);
    alo = ex - ahi;
    c = (0, _utilJs.splitter) * by;
    bhi = c - (c - by);
    blo = by - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = bx * ey;
    c = (0, _utilJs.splitter) * bx;
    ahi = c - (c - bx);
    alo = bx - ahi;
    c = (0, _utilJs.splitter) * ey;
    bhi = c - (c - ey);
    blo = ey - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    eb[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    eb[1] = _0 - (_i + bvirt) + (bvirt - t1);
    u3 = _j + _i;
    bvirt = u3 - _j;
    eb[2] = _j - (u3 - bvirt) + (_i - bvirt);
    eb[3] = u3;
    const abclen = sum_three_scale(ab, bc, ac, cz, az, -bz, abc);
    const bcdlen = sum_three_scale(bc, cd, bd, dz, bz, -cz, bcd);
    const cdelen = sum_three_scale(cd, de, ce, ez, cz, -dz, cde);
    const dealen = sum_three_scale(de, ea, da, az, dz, -ez, dea);
    const eablen = sum_three_scale(ea, ab, eb, bz, ez, -az, eab);
    const abdlen = sum_three_scale(ab, bd, da, dz, az, bz, abd);
    const bcelen = sum_three_scale(bc, ce, eb, ez, bz, cz, bce);
    const cdalen = sum_three_scale(cd, da, ac, az, cz, dz, cda);
    const deblen = sum_three_scale(de, eb, bd, bz, dz, ez, deb);
    const eaclen = sum_three_scale(ea, ac, ce, cz, ez, az, eac);
    const deterlen = (0, _utilJs.sum_three)(liftexact(cdelen, cde, bcelen, bce, deblen, deb, bcdlen, bcd, ax, ay, az, adet), adet, liftexact(dealen, dea, cdalen, cda, eaclen, eac, cdelen, cde, bx, by, bz, bdet), bdet, (0, _utilJs.sum_three)(liftexact(eablen, eab, deblen, deb, abdlen, abd, dealen, dea, cx, cy, cz, cdet), cdet, liftexact(abclen, abc, eaclen, eac, bcelen, bce, eablen, eab, dx, dy, dz, ddet), ddet, liftexact(bcdlen, bcd, abdlen, abd, cdalen, cda, abclen, abc, ex, ey, ez, edet), edet, cddet, cdedet), cdedet, abdet, deter);
    return deter[deterlen - 1];
}
const xdet = (0, _utilJs.vec)(96);
const ydet = (0, _utilJs.vec)(96);
const zdet = (0, _utilJs.vec)(96);
const fin = (0, _utilJs.vec)(1152);
function liftadapt(a, b, c, az, bz, cz, x, y, z, out) {
    const len = sum_three_scale(a, b, c, az, bz, cz, _24);
    return (0, _utilJs.sum_three)((0, _utilJs.scale)((0, _utilJs.scale)(len, _24, x, _48), _48, x, xdet), xdet, (0, _utilJs.scale)((0, _utilJs.scale)(len, _24, y, _48), _48, y, ydet), ydet, (0, _utilJs.scale)((0, _utilJs.scale)(len, _24, z, _48), _48, z, zdet), zdet, _192, out);
}
function insphereadapt(ax, ay, az, bx, by, bz, cx, cy, cz, dx, dy, dz, ex, ey, ez, permanent) {
    let ab3, bc3, cd3, da3, ac3, bd3;
    let aextail, bextail, cextail, dextail;
    let aeytail, beytail, ceytail, deytail;
    let aeztail, beztail, ceztail, deztail;
    let bvirt, c, ahi, alo, bhi, blo, _i, _j, _0, s1, s0, t1, t0;
    const aex = ax - ex;
    const bex = bx - ex;
    const cex = cx - ex;
    const dex = dx - ex;
    const aey = ay - ey;
    const bey = by - ey;
    const cey = cy - ey;
    const dey = dy - ey;
    const aez = az - ez;
    const bez = bz - ez;
    const cez = cz - ez;
    const dez = dz - ez;
    s1 = aex * bey;
    c = (0, _utilJs.splitter) * aex;
    ahi = c - (c - aex);
    alo = aex - ahi;
    c = (0, _utilJs.splitter) * bey;
    bhi = c - (c - bey);
    blo = bey - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = bex * aey;
    c = (0, _utilJs.splitter) * bex;
    ahi = c - (c - bex);
    alo = bex - ahi;
    c = (0, _utilJs.splitter) * aey;
    bhi = c - (c - aey);
    blo = aey - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    ab[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    ab[1] = _0 - (_i + bvirt) + (bvirt - t1);
    ab3 = _j + _i;
    bvirt = ab3 - _j;
    ab[2] = _j - (ab3 - bvirt) + (_i - bvirt);
    ab[3] = ab3;
    s1 = bex * cey;
    c = (0, _utilJs.splitter) * bex;
    ahi = c - (c - bex);
    alo = bex - ahi;
    c = (0, _utilJs.splitter) * cey;
    bhi = c - (c - cey);
    blo = cey - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = cex * bey;
    c = (0, _utilJs.splitter) * cex;
    ahi = c - (c - cex);
    alo = cex - ahi;
    c = (0, _utilJs.splitter) * bey;
    bhi = c - (c - bey);
    blo = bey - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    bc[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    bc[1] = _0 - (_i + bvirt) + (bvirt - t1);
    bc3 = _j + _i;
    bvirt = bc3 - _j;
    bc[2] = _j - (bc3 - bvirt) + (_i - bvirt);
    bc[3] = bc3;
    s1 = cex * dey;
    c = (0, _utilJs.splitter) * cex;
    ahi = c - (c - cex);
    alo = cex - ahi;
    c = (0, _utilJs.splitter) * dey;
    bhi = c - (c - dey);
    blo = dey - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = dex * cey;
    c = (0, _utilJs.splitter) * dex;
    ahi = c - (c - dex);
    alo = dex - ahi;
    c = (0, _utilJs.splitter) * cey;
    bhi = c - (c - cey);
    blo = cey - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    cd[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    cd[1] = _0 - (_i + bvirt) + (bvirt - t1);
    cd3 = _j + _i;
    bvirt = cd3 - _j;
    cd[2] = _j - (cd3 - bvirt) + (_i - bvirt);
    cd[3] = cd3;
    s1 = dex * aey;
    c = (0, _utilJs.splitter) * dex;
    ahi = c - (c - dex);
    alo = dex - ahi;
    c = (0, _utilJs.splitter) * aey;
    bhi = c - (c - aey);
    blo = aey - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = aex * dey;
    c = (0, _utilJs.splitter) * aex;
    ahi = c - (c - aex);
    alo = aex - ahi;
    c = (0, _utilJs.splitter) * dey;
    bhi = c - (c - dey);
    blo = dey - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    da[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    da[1] = _0 - (_i + bvirt) + (bvirt - t1);
    da3 = _j + _i;
    bvirt = da3 - _j;
    da[2] = _j - (da3 - bvirt) + (_i - bvirt);
    da[3] = da3;
    s1 = aex * cey;
    c = (0, _utilJs.splitter) * aex;
    ahi = c - (c - aex);
    alo = aex - ahi;
    c = (0, _utilJs.splitter) * cey;
    bhi = c - (c - cey);
    blo = cey - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = cex * aey;
    c = (0, _utilJs.splitter) * cex;
    ahi = c - (c - cex);
    alo = cex - ahi;
    c = (0, _utilJs.splitter) * aey;
    bhi = c - (c - aey);
    blo = aey - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    ac[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    ac[1] = _0 - (_i + bvirt) + (bvirt - t1);
    ac3 = _j + _i;
    bvirt = ac3 - _j;
    ac[2] = _j - (ac3 - bvirt) + (_i - bvirt);
    ac[3] = ac3;
    s1 = bex * dey;
    c = (0, _utilJs.splitter) * bex;
    ahi = c - (c - bex);
    alo = bex - ahi;
    c = (0, _utilJs.splitter) * dey;
    bhi = c - (c - dey);
    blo = dey - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = dex * bey;
    c = (0, _utilJs.splitter) * dex;
    ahi = c - (c - dex);
    alo = dex - ahi;
    c = (0, _utilJs.splitter) * bey;
    bhi = c - (c - bey);
    blo = bey - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    bd[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    bd[1] = _0 - (_i + bvirt) + (bvirt - t1);
    bd3 = _j + _i;
    bvirt = bd3 - _j;
    bd[2] = _j - (bd3 - bvirt) + (_i - bvirt);
    bd[3] = bd3;
    const finlen = (0, _utilJs.sum)((0, _utilJs.sum)((0, _utilJs.negate)(liftadapt(bc, cd, bd, dez, bez, -cez, aex, aey, aez, adet), adet), adet, liftadapt(cd, da, ac, aez, cez, dez, bex, bey, bez, bdet), bdet, abdet), abdet, (0, _utilJs.sum)((0, _utilJs.negate)(liftadapt(da, ab, bd, bez, dez, aez, cex, cey, cez, cdet), cdet), cdet, liftadapt(ab, bc, ac, cez, aez, -bez, dex, dey, dez, ddet), ddet, cddet), cddet, fin);
    let det = (0, _utilJs.estimate)(finlen, fin);
    let errbound = isperrboundB * permanent;
    if (det >= errbound || -det >= errbound) return det;
    bvirt = ax - aex;
    aextail = ax - (aex + bvirt) + (bvirt - ex);
    bvirt = ay - aey;
    aeytail = ay - (aey + bvirt) + (bvirt - ey);
    bvirt = az - aez;
    aeztail = az - (aez + bvirt) + (bvirt - ez);
    bvirt = bx - bex;
    bextail = bx - (bex + bvirt) + (bvirt - ex);
    bvirt = by - bey;
    beytail = by - (bey + bvirt) + (bvirt - ey);
    bvirt = bz - bez;
    beztail = bz - (bez + bvirt) + (bvirt - ez);
    bvirt = cx - cex;
    cextail = cx - (cex + bvirt) + (bvirt - ex);
    bvirt = cy - cey;
    ceytail = cy - (cey + bvirt) + (bvirt - ey);
    bvirt = cz - cez;
    ceztail = cz - (cez + bvirt) + (bvirt - ez);
    bvirt = dx - dex;
    dextail = dx - (dex + bvirt) + (bvirt - ex);
    bvirt = dy - dey;
    deytail = dy - (dey + bvirt) + (bvirt - ey);
    bvirt = dz - dez;
    deztail = dz - (dez + bvirt) + (bvirt - ez);
    if (aextail === 0 && aeytail === 0 && aeztail === 0 && bextail === 0 && beytail === 0 && beztail === 0 && cextail === 0 && ceytail === 0 && ceztail === 0 && dextail === 0 && deytail === 0 && deztail === 0) return det;
    errbound = isperrboundC * permanent + (0, _utilJs.resulterrbound) * Math.abs(det);
    const abeps = aex * beytail + bey * aextail - (aey * bextail + bex * aeytail);
    const bceps = bex * ceytail + cey * bextail - (bey * cextail + cex * beytail);
    const cdeps = cex * deytail + dey * cextail - (cey * dextail + dex * ceytail);
    const daeps = dex * aeytail + aey * dextail - (dey * aextail + aex * deytail);
    const aceps = aex * ceytail + cey * aextail - (aey * cextail + cex * aeytail);
    const bdeps = bex * deytail + dey * bextail - (bey * dextail + dex * beytail);
    det += (bex * bex + bey * bey + bez * bez) * (cez * daeps + dez * aceps + aez * cdeps + (ceztail * da3 + deztail * ac3 + aeztail * cd3)) + (dex * dex + dey * dey + dez * dez) * (aez * bceps - bez * aceps + cez * abeps + (aeztail * bc3 - beztail * ac3 + ceztail * ab3)) - ((aex * aex + aey * aey + aez * aez) * (bez * cdeps - cez * bdeps + dez * bceps + (beztail * cd3 - ceztail * bd3 + deztail * bc3)) + (cex * cex + cey * cey + cez * cez) * (dez * abeps + aez * bdeps + bez * daeps + (deztail * ab3 + aeztail * bd3 + beztail * da3))) + 2 * ((bex * bextail + bey * beytail + bez * beztail) * (cez * da3 + dez * ac3 + aez * cd3) + (dex * dextail + dey * deytail + dez * deztail) * (aez * bc3 - bez * ac3 + cez * ab3) - ((aex * aextail + aey * aeytail + aez * aeztail) * (bez * cd3 - cez * bd3 + dez * bc3) + (cex * cextail + cey * ceytail + cez * ceztail) * (dez * ab3 + aez * bd3 + bez * da3)));
    if (det >= errbound || -det >= errbound) return det;
    return insphereexact(ax, ay, az, bx, by, bz, cx, cy, cz, dx, dy, dz, ex, ey, ez);
}
function insphere(ax, ay, az, bx, by, bz, cx, cy, cz, dx, dy, dz, ex, ey, ez) {
    const aex = ax - ex;
    const bex = bx - ex;
    const cex = cx - ex;
    const dex = dx - ex;
    const aey = ay - ey;
    const bey = by - ey;
    const cey = cy - ey;
    const dey = dy - ey;
    const aez = az - ez;
    const bez = bz - ez;
    const cez = cz - ez;
    const dez = dz - ez;
    const aexbey = aex * bey;
    const bexaey = bex * aey;
    const ab = aexbey - bexaey;
    const bexcey = bex * cey;
    const cexbey = cex * bey;
    const bc = bexcey - cexbey;
    const cexdey = cex * dey;
    const dexcey = dex * cey;
    const cd = cexdey - dexcey;
    const dexaey = dex * aey;
    const aexdey = aex * dey;
    const da = dexaey - aexdey;
    const aexcey = aex * cey;
    const cexaey = cex * aey;
    const ac = aexcey - cexaey;
    const bexdey = bex * dey;
    const dexbey = dex * bey;
    const bd = bexdey - dexbey;
    const alift = aex * aex + aey * aey + aez * aez;
    const blift = bex * bex + bey * bey + bez * bez;
    const clift = cex * cex + cey * cey + cez * cez;
    const dlift = dex * dex + dey * dey + dez * dez;
    const det = clift * (dez * ab + aez * bd + bez * da) - dlift * (aez * bc - bez * ac + cez * ab) + (alift * (bez * cd - cez * bd + dez * bc) - blift * (cez * da + dez * ac + aez * cd));
    const aezplus = Math.abs(aez);
    const bezplus = Math.abs(bez);
    const cezplus = Math.abs(cez);
    const dezplus = Math.abs(dez);
    const aexbeyplus = Math.abs(aexbey) + Math.abs(bexaey);
    const bexceyplus = Math.abs(bexcey) + Math.abs(cexbey);
    const cexdeyplus = Math.abs(cexdey) + Math.abs(dexcey);
    const dexaeyplus = Math.abs(dexaey) + Math.abs(aexdey);
    const aexceyplus = Math.abs(aexcey) + Math.abs(cexaey);
    const bexdeyplus = Math.abs(bexdey) + Math.abs(dexbey);
    const permanent = (cexdeyplus * bezplus + bexdeyplus * cezplus + bexceyplus * dezplus) * alift + (dexaeyplus * cezplus + aexceyplus * dezplus + cexdeyplus * aezplus) * blift + (aexbeyplus * dezplus + bexdeyplus * aezplus + dexaeyplus * bezplus) * clift + (bexceyplus * aezplus + aexceyplus * bezplus + aexbeyplus * cezplus) * dlift;
    const errbound = isperrboundA * permanent;
    if (det > errbound || -det > errbound) return det;
    return -insphereadapt(ax, ay, az, bx, by, bz, cx, cy, cz, dx, dy, dz, ex, ey, ez, permanent);
}
function inspherefast(pax, pay, paz, pbx, pby, pbz, pcx, pcy, pcz, pdx, pdy, pdz, pex, pey, pez) {
    const aex = pax - pex;
    const bex = pbx - pex;
    const cex = pcx - pex;
    const dex = pdx - pex;
    const aey = pay - pey;
    const bey = pby - pey;
    const cey = pcy - pey;
    const dey = pdy - pey;
    const aez = paz - pez;
    const bez = pbz - pez;
    const cez = pcz - pez;
    const dez = pdz - pez;
    const ab = aex * bey - bex * aey;
    const bc = bex * cey - cex * bey;
    const cd = cex * dey - dex * cey;
    const da = dex * aey - aex * dey;
    const ac = aex * cey - cex * aey;
    const bd = bex * dey - dex * bey;
    const abc = aez * bc - bez * ac + cez * ab;
    const bcd = bez * cd - cez * bd + dez * bc;
    const cda = cez * da + dez * ac + aez * cd;
    const dab = dez * ab + aez * bd + bez * da;
    const alift = aex * aex + aey * aey + aez * aez;
    const blift = bex * bex + bey * bey + bez * bez;
    const clift = cex * cex + cey * cey + cez * cez;
    const dlift = dex * dex + dey * dey + dez * dez;
    return clift * dab - dlift * abc + (alift * bcd - blift * cda);
}

},{"./util.js":"4o1Gr","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"5h4Se":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
const epsilon = 1e-6;
class Path {
    constructor(){
        this._x0 = this._y0 = this._x1 = this._y1 = null; // end of current subpath
        this._ = "";
    }
    moveTo(x, y) {
        this._ += `M${this._x0 = this._x1 = +x},${this._y0 = this._y1 = +y}`;
    }
    closePath() {
        if (this._x1 !== null) {
            this._x1 = this._x0, this._y1 = this._y0;
            this._ += "Z";
        }
    }
    lineTo(x, y) {
        this._ += `L${this._x1 = +x},${this._y1 = +y}`;
    }
    arc(x, y, r) {
        x = +x, y = +y, r = +r;
        const x0 = x + r;
        const y0 = y;
        if (r < 0) throw new Error("negative radius");
        if (this._x1 === null) this._ += `M${x0},${y0}`;
        else if (Math.abs(this._x1 - x0) > epsilon || Math.abs(this._y1 - y0) > epsilon) this._ += "L" + x0 + "," + y0;
        if (!r) return;
        this._ += `A${r},${r},0,1,1,${x - r},${y}A${r},${r},0,1,1,${this._x1 = x0},${this._y1 = y0}`;
    }
    rect(x, y, w, h) {
        this._ += `M${this._x0 = this._x1 = +x},${this._y0 = this._y1 = +y}h${+w}v${+h}h${-w}Z`;
    }
    value() {
        return this._ || null;
    }
}
exports.default = Path;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"aS9sW":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
class Polygon {
    constructor(){
        this._ = [];
    }
    moveTo(x, y) {
        this._.push([
            x,
            y
        ]);
    }
    closePath() {
        this._.push(this._[0].slice());
    }
    lineTo(x, y) {
        this._.push([
            x,
            y
        ]);
    }
    value() {
        return this._.length ? this._ : null;
    }
}
exports.default = Polygon;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"gPQ9o":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _pathJs = require("./path.js");
var _pathJsDefault = parcelHelpers.interopDefault(_pathJs);
var _polygonJs = require("./polygon.js");
var _polygonJsDefault = parcelHelpers.interopDefault(_polygonJs);
class Voronoi {
    constructor(delaunay, [xmin, ymin, xmax, ymax] = [
        0,
        0,
        960,
        500
    ]){
        if (!((xmax = +xmax) >= (xmin = +xmin)) || !((ymax = +ymax) >= (ymin = +ymin))) throw new Error("invalid bounds");
        this.delaunay = delaunay;
        this._circumcenters = new Float64Array(delaunay.points.length * 2);
        this.vectors = new Float64Array(delaunay.points.length * 2);
        this.xmax = xmax, this.xmin = xmin;
        this.ymax = ymax, this.ymin = ymin;
        this._init();
    }
    update() {
        this.delaunay.update();
        this._init();
        return this;
    }
    _init() {
        const { delaunay: { points, hull, triangles }, vectors } = this;
        let bx, by; // lazily computed barycenter of the hull
        // Compute circumcenters.
        const circumcenters = this.circumcenters = this._circumcenters.subarray(0, triangles.length / 3 * 2);
        for(let i = 0, j = 0, n = triangles.length, x, y; i < n; i += 3, j += 2){
            const t1 = triangles[i] * 2;
            const t2 = triangles[i + 1] * 2;
            const t3 = triangles[i + 2] * 2;
            const x1 = points[t1];
            const y1 = points[t1 + 1];
            const x2 = points[t2];
            const y2 = points[t2 + 1];
            const x3 = points[t3];
            const y3 = points[t3 + 1];
            const dx = x2 - x1;
            const dy = y2 - y1;
            const ex = x3 - x1;
            const ey = y3 - y1;
            const ab = (dx * ey - dy * ex) * 2;
            if (Math.abs(ab) < 1e-9) {
                // For a degenerate triangle, the circumcenter is at the infinity, in a
                // direction orthogonal to the halfedge and away from the “center” of
                // the diagram <bx, by>, defined as the hull’s barycenter.
                if (bx === undefined) {
                    bx = by = 0;
                    for (const i of hull)bx += points[i * 2], by += points[i * 2 + 1];
                    bx /= hull.length, by /= hull.length;
                }
                const a = 1e9 * Math.sign((bx - x1) * ey - (by - y1) * ex);
                x = (x1 + x3) / 2 - a * ey;
                y = (y1 + y3) / 2 + a * ex;
            } else {
                const d = 1 / ab;
                const bl = dx * dx + dy * dy;
                const cl = ex * ex + ey * ey;
                x = x1 + (ey * bl - dy * cl) * d;
                y = y1 + (dx * cl - ex * bl) * d;
            }
            circumcenters[j] = x;
            circumcenters[j + 1] = y;
        }
        // Compute exterior cell rays.
        let h = hull[hull.length - 1];
        let p0, p1 = h * 4;
        let x0, x1 = points[2 * h];
        let y0, y1 = points[2 * h + 1];
        vectors.fill(0);
        for(let i = 0; i < hull.length; ++i){
            h = hull[i];
            p0 = p1, x0 = x1, y0 = y1;
            p1 = h * 4, x1 = points[2 * h], y1 = points[2 * h + 1];
            vectors[p0 + 2] = vectors[p1] = y0 - y1;
            vectors[p0 + 3] = vectors[p1 + 1] = x1 - x0;
        }
    }
    render(context) {
        const buffer = context == null ? context = new (0, _pathJsDefault.default) : undefined;
        const { delaunay: { halfedges, inedges, hull }, circumcenters, vectors } = this;
        if (hull.length <= 1) return null;
        for(let i = 0, n = halfedges.length; i < n; ++i){
            const j = halfedges[i];
            if (j < i) continue;
            const ti = Math.floor(i / 3) * 2;
            const tj = Math.floor(j / 3) * 2;
            const xi = circumcenters[ti];
            const yi = circumcenters[ti + 1];
            const xj = circumcenters[tj];
            const yj = circumcenters[tj + 1];
            this._renderSegment(xi, yi, xj, yj, context);
        }
        let h0, h1 = hull[hull.length - 1];
        for(let i = 0; i < hull.length; ++i){
            h0 = h1, h1 = hull[i];
            const t = Math.floor(inedges[h1] / 3) * 2;
            const x = circumcenters[t];
            const y = circumcenters[t + 1];
            const v = h0 * 4;
            const p = this._project(x, y, vectors[v + 2], vectors[v + 3]);
            if (p) this._renderSegment(x, y, p[0], p[1], context);
        }
        return buffer && buffer.value();
    }
    renderBounds(context) {
        const buffer = context == null ? context = new (0, _pathJsDefault.default) : undefined;
        context.rect(this.xmin, this.ymin, this.xmax - this.xmin, this.ymax - this.ymin);
        return buffer && buffer.value();
    }
    renderCell(i, context) {
        const buffer = context == null ? context = new (0, _pathJsDefault.default) : undefined;
        const points = this._clip(i);
        if (points === null || !points.length) return;
        context.moveTo(points[0], points[1]);
        let n = points.length;
        while(points[0] === points[n - 2] && points[1] === points[n - 1] && n > 1)n -= 2;
        for(let i = 2; i < n; i += 2)if (points[i] !== points[i - 2] || points[i + 1] !== points[i - 1]) context.lineTo(points[i], points[i + 1]);
        context.closePath();
        return buffer && buffer.value();
    }
    *cellPolygons() {
        const { delaunay: { points } } = this;
        for(let i = 0, n = points.length / 2; i < n; ++i){
            const cell = this.cellPolygon(i);
            if (cell) cell.index = i, yield cell;
        }
    }
    cellPolygon(i) {
        const polygon = new (0, _polygonJsDefault.default);
        this.renderCell(i, polygon);
        return polygon.value();
    }
    _renderSegment(x0, y0, x1, y1, context) {
        let S;
        const c0 = this._regioncode(x0, y0);
        const c1 = this._regioncode(x1, y1);
        if (c0 === 0 && c1 === 0) {
            context.moveTo(x0, y0);
            context.lineTo(x1, y1);
        } else if (S = this._clipSegment(x0, y0, x1, y1, c0, c1)) {
            context.moveTo(S[0], S[1]);
            context.lineTo(S[2], S[3]);
        }
    }
    contains(i, x, y) {
        if ((x = +x, x !== x) || (y = +y, y !== y)) return false;
        return this.delaunay._step(i, x, y) === i;
    }
    *neighbors(i) {
        const ci = this._clip(i);
        if (ci) for (const j of this.delaunay.neighbors(i)){
            const cj = this._clip(j);
            // find the common edge
            if (cj) loop: for(let ai = 0, li = ci.length; ai < li; ai += 2){
                for(let aj = 0, lj = cj.length; aj < lj; aj += 2)if (ci[ai] === cj[aj] && ci[ai + 1] === cj[aj + 1] && ci[(ai + 2) % li] === cj[(aj + lj - 2) % lj] && ci[(ai + 3) % li] === cj[(aj + lj - 1) % lj]) {
                    yield j;
                    break loop;
                }
            }
        }
    }
    _cell(i) {
        const { circumcenters, delaunay: { inedges, halfedges, triangles } } = this;
        const e0 = inedges[i];
        if (e0 === -1) return null; // coincident point
        const points = [];
        let e = e0;
        do {
            const t = Math.floor(e / 3);
            points.push(circumcenters[t * 2], circumcenters[t * 2 + 1]);
            e = e % 3 === 2 ? e - 2 : e + 1;
            if (triangles[e] !== i) break; // bad triangulation
            e = halfedges[e];
        }while (e !== e0 && e !== -1);
        return points;
    }
    _clip(i) {
        // degenerate case (1 valid point: return the box)
        if (i === 0 && this.delaunay.hull.length === 1) return [
            this.xmax,
            this.ymin,
            this.xmax,
            this.ymax,
            this.xmin,
            this.ymax,
            this.xmin,
            this.ymin
        ];
        const points = this._cell(i);
        if (points === null) return null;
        const { vectors: V } = this;
        const v = i * 4;
        return this._simplify(V[v] || V[v + 1] ? this._clipInfinite(i, points, V[v], V[v + 1], V[v + 2], V[v + 3]) : this._clipFinite(i, points));
    }
    _clipFinite(i, points) {
        const n = points.length;
        let P = null;
        let x0, y0, x1 = points[n - 2], y1 = points[n - 1];
        let c0, c1 = this._regioncode(x1, y1);
        let e0, e1 = 0;
        for(let j = 0; j < n; j += 2){
            x0 = x1, y0 = y1, x1 = points[j], y1 = points[j + 1];
            c0 = c1, c1 = this._regioncode(x1, y1);
            if (c0 === 0 && c1 === 0) {
                e0 = e1, e1 = 0;
                if (P) P.push(x1, y1);
                else P = [
                    x1,
                    y1
                ];
            } else {
                let S, sx0, sy0, sx1, sy1;
                if (c0 === 0) {
                    if ((S = this._clipSegment(x0, y0, x1, y1, c0, c1)) === null) continue;
                    [sx0, sy0, sx1, sy1] = S;
                } else {
                    if ((S = this._clipSegment(x1, y1, x0, y0, c1, c0)) === null) continue;
                    [sx1, sy1, sx0, sy0] = S;
                    e0 = e1, e1 = this._edgecode(sx0, sy0);
                    if (e0 && e1) this._edge(i, e0, e1, P, P.length);
                    if (P) P.push(sx0, sy0);
                    else P = [
                        sx0,
                        sy0
                    ];
                }
                e0 = e1, e1 = this._edgecode(sx1, sy1);
                if (e0 && e1) this._edge(i, e0, e1, P, P.length);
                if (P) P.push(sx1, sy1);
                else P = [
                    sx1,
                    sy1
                ];
            }
        }
        if (P) {
            e0 = e1, e1 = this._edgecode(P[0], P[1]);
            if (e0 && e1) this._edge(i, e0, e1, P, P.length);
        } else if (this.contains(i, (this.xmin + this.xmax) / 2, (this.ymin + this.ymax) / 2)) return [
            this.xmax,
            this.ymin,
            this.xmax,
            this.ymax,
            this.xmin,
            this.ymax,
            this.xmin,
            this.ymin
        ];
        return P;
    }
    _clipSegment(x0, y0, x1, y1, c0, c1) {
        // for more robustness, always consider the segment in the same order
        const flip = c0 < c1;
        if (flip) [x0, y0, x1, y1, c0, c1] = [
            x1,
            y1,
            x0,
            y0,
            c1,
            c0
        ];
        while(true){
            if (c0 === 0 && c1 === 0) return flip ? [
                x1,
                y1,
                x0,
                y0
            ] : [
                x0,
                y0,
                x1,
                y1
            ];
            if (c0 & c1) return null;
            let x, y, c = c0 || c1;
            if (c & 8) x = x0 + (x1 - x0) * (this.ymax - y0) / (y1 - y0), y = this.ymax;
            else if (c & 4) x = x0 + (x1 - x0) * (this.ymin - y0) / (y1 - y0), y = this.ymin;
            else if (c & 2) y = y0 + (y1 - y0) * (this.xmax - x0) / (x1 - x0), x = this.xmax;
            else y = y0 + (y1 - y0) * (this.xmin - x0) / (x1 - x0), x = this.xmin;
            if (c0) x0 = x, y0 = y, c0 = this._regioncode(x0, y0);
            else x1 = x, y1 = y, c1 = this._regioncode(x1, y1);
        }
    }
    _clipInfinite(i, points, vx0, vy0, vxn, vyn) {
        let P = Array.from(points), p;
        if (p = this._project(P[0], P[1], vx0, vy0)) P.unshift(p[0], p[1]);
        if (p = this._project(P[P.length - 2], P[P.length - 1], vxn, vyn)) P.push(p[0], p[1]);
        if (P = this._clipFinite(i, P)) for(let j = 0, n = P.length, c0, c1 = this._edgecode(P[n - 2], P[n - 1]); j < n; j += 2){
            c0 = c1, c1 = this._edgecode(P[j], P[j + 1]);
            if (c0 && c1) j = this._edge(i, c0, c1, P, j), n = P.length;
        }
        else if (this.contains(i, (this.xmin + this.xmax) / 2, (this.ymin + this.ymax) / 2)) P = [
            this.xmin,
            this.ymin,
            this.xmax,
            this.ymin,
            this.xmax,
            this.ymax,
            this.xmin,
            this.ymax
        ];
        return P;
    }
    _edge(i, e0, e1, P, j) {
        while(e0 !== e1){
            let x, y;
            switch(e0){
                case 5:
                    e0 = 4;
                    continue; // top-left
                case 4:
                    e0 = 6, x = this.xmax, y = this.ymin;
                    break; // top
                case 6:
                    e0 = 2;
                    continue; // top-right
                case 2:
                    e0 = 10, x = this.xmax, y = this.ymax;
                    break; // right
                case 10:
                    e0 = 8;
                    continue; // bottom-right
                case 8:
                    e0 = 9, x = this.xmin, y = this.ymax;
                    break; // bottom
                case 9:
                    e0 = 1;
                    continue; // bottom-left
                case 1:
                    e0 = 5, x = this.xmin, y = this.ymin;
                    break; // left
            }
            // Note: this implicitly checks for out of bounds: if P[j] or P[j+1] are
            // undefined, the conditional statement will be executed.
            if ((P[j] !== x || P[j + 1] !== y) && this.contains(i, x, y)) P.splice(j, 0, x, y), j += 2;
        }
        return j;
    }
    _project(x0, y0, vx, vy) {
        let t = Infinity, c, x, y;
        if (vy < 0) {
            if (y0 <= this.ymin) return null;
            if ((c = (this.ymin - y0) / vy) < t) y = this.ymin, x = x0 + (t = c) * vx;
        } else if (vy > 0) {
            if (y0 >= this.ymax) return null;
            if ((c = (this.ymax - y0) / vy) < t) y = this.ymax, x = x0 + (t = c) * vx;
        }
        if (vx > 0) {
            if (x0 >= this.xmax) return null;
            if ((c = (this.xmax - x0) / vx) < t) x = this.xmax, y = y0 + (t = c) * vy;
        } else if (vx < 0) {
            if (x0 <= this.xmin) return null;
            if ((c = (this.xmin - x0) / vx) < t) x = this.xmin, y = y0 + (t = c) * vy;
        }
        return [
            x,
            y
        ];
    }
    _edgecode(x, y) {
        return (x === this.xmin ? 1 : x === this.xmax ? 2 : 0) | (y === this.ymin ? 4 : y === this.ymax ? 8 : 0);
    }
    _regioncode(x, y) {
        return (x < this.xmin ? 1 : x > this.xmax ? 2 : 0) | (y < this.ymin ? 4 : y > this.ymax ? 8 : 0);
    }
    _simplify(P) {
        if (P && P.length > 4) {
            for(let i = 0; i < P.length; i += 2){
                const j = (i + 2) % P.length, k = (i + 4) % P.length;
                if (P[i] === P[j] && P[j] === P[k] || P[i + 1] === P[j + 1] && P[j + 1] === P[k + 1]) P.splice(j, 2), i -= 2;
            }
            if (!P.length) P = null;
        }
        return P;
    }
}
exports.default = Voronoi;

},{"./path.js":"5h4Se","./polygon.js":"aS9sW","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1MLTJ":[function(require,module,exports) {
/**
 * Unified Chart Theme Configuration
 * 
 * This module provides a consistent, modern glass-like styling system
 * for all Nivo charts across the dashboard. All charts should import
 * and use these configurations to maintain visual consistency.
 * 
 * Mac/Retina Optimization Notes:
 * - Font smoothing is applied via CSS for crisp text on Retina displays
 * - Font sizes are designed to scale well at 2x pixel density
 * - Use -webkit-font-smoothing: antialiased for Mac optimization
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "nivoChartTheme", ()=>nivoChartTheme);
parcelHelpers.export(exports, "getChartColorConfig", ()=>getChartColorConfig);
parcelHelpers.export(exports, "generateChartColors", ()=>generateChartColors);
parcelHelpers.export(exports, "generateGlassColorPairs", ()=>generateGlassColorPairs);
parcelHelpers.export(exports, "barChartDefaults", ()=>barChartDefaults);
parcelHelpers.export(exports, "funnelChartDefaults", ()=>funnelChartDefaults);
parcelHelpers.export(exports, "funnelColors", ()=>funnelColors);
parcelHelpers.export(exports, "funnelGlassColors", ()=>funnelGlassColors);
parcelHelpers.export(exports, "pieChartDefaults", ()=>pieChartDefaults);
parcelHelpers.export(exports, "tooltipStyles", ()=>tooltipStyles);
parcelHelpers.export(exports, "dashboardTileStyles", ()=>dashboardTileStyles);
parcelHelpers.export(exports, "baseTileCSS", ()=>baseTileCSS);
parcelHelpers.export(exports, "tileSizeConfig", ()=>tileSizeConfig);
// ==================== EXPORTS FOR DIRECT PALETTE ACCESS ====================
parcelHelpers.export(exports, "chartSequentialBlues", ()=>(0, _colors.chartSequentialBlues));
parcelHelpers.export(exports, "chartGlassBlues", ()=>(0, _colors.chartGlassBlues));
parcelHelpers.export(exports, "chartBorderBlues", ()=>(0, _colors.chartBorderBlues));
parcelHelpers.export(exports, "chart_blue_1", ()=>(0, _colors.chart_blue_1));
parcelHelpers.export(exports, "chart_blue_2", ()=>(0, _colors.chart_blue_2));
parcelHelpers.export(exports, "chart_blue_3", ()=>(0, _colors.chart_blue_3));
parcelHelpers.export(exports, "chart_blue_4", ()=>(0, _colors.chart_blue_4));
parcelHelpers.export(exports, "chart_blue_5", ()=>(0, _colors.chart_blue_5));
parcelHelpers.export(exports, "chart_blue_6", ()=>(0, _colors.chart_blue_6));
parcelHelpers.export(exports, "chart_blue_7", ()=>(0, _colors.chart_blue_7));
parcelHelpers.export(exports, "chart_blue_8", ()=>(0, _colors.chart_blue_8));
parcelHelpers.export(exports, "chart_blue_9", ()=>(0, _colors.chart_blue_9));
parcelHelpers.export(exports, "chart_blue_10", ()=>(0, _colors.chart_blue_10));
parcelHelpers.export(exports, "chart_blue_11", ()=>(0, _colors.chart_blue_11));
parcelHelpers.export(exports, "chart_blue_12", ()=>(0, _colors.chart_blue_12));
var _colors = require("./colors");
const nivoChartTheme = {
    background: "transparent",
    textColor: (0, _colors.color_shades_darkest),
    fontSize: 11,
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
    axis: {
        domain: {
            line: {
                stroke: (0, _colors.color_shades_light),
                strokeWidth: 1
            }
        },
        ticks: {
            line: {
                stroke: (0, _colors.color_shades_light),
                strokeWidth: 1
            },
            text: {
                fontSize: 11,
                fill: (0, _colors.color_shades_darker),
                fontWeight: 500
            }
        },
        legend: {
            text: {
                fontSize: 11,
                fill: (0, _colors.color_shades_darker),
                fontWeight: 600
            }
        }
    },
    grid: {
        line: {
            stroke: (0, _colors.color_shades_light),
            strokeWidth: 1,
            strokeDasharray: "3 3"
        }
    },
    legends: {
        text: {
            fontSize: 11,
            fill: (0, _colors.color_shades_darker),
            fontWeight: 500
        }
    },
    tooltip: {
        container: {
            background: "rgba(255, 255, 255, 0.95)",
            backdropFilter: "blur(8px)",
            color: (0, _colors.color_shades_darkest),
            fontSize: 12,
            borderRadius: "10px",
            boxShadow: "0 4px 20px rgba(0, 0, 0, 0.12), 0 0 0 1px rgba(0, 0, 0, 0.05)",
            padding: "10px 14px",
            border: `1px solid ${(0, _colors.color_shades_light)}`
        }
    },
    labels: {
        text: {
            fontSize: 11,
            fontWeight: 600,
            fill: (0, _colors.color_defaults_white)
        }
    }
};
const getChartColorConfig = (index)=>{
    const safeIndex = index % (0, _colors.chartSequentialBlues).length;
    return {
        fill: (0, _colors.chartGlassBlues)[safeIndex],
        border: (0, _colors.chartBorderBlues)[safeIndex],
        solid: (0, _colors.chartSequentialBlues)[safeIndex]
    };
};
const generateChartColors = (count, useGlass = true)=>{
    if (count <= 0) return [];
    const palette = useGlass ? (0, _colors.chartGlassBlues) : (0, _colors.chartSequentialBlues);
    if (count >= palette.length) // Use all colors
    return [
        ...palette
    ];
    // Spread colors evenly across the palette
    const colors = [];
    const step = (palette.length - 1) / (count - 1 || 1);
    for(let i = 0; i < count; i++){
        const index = Math.round(i * step);
        colors.push(palette[index]);
    }
    return colors;
};
const generateGlassColorPairs = (count, maxPaletteIndex = 11)=>{
    if (count <= 0) return [];
    // Clamp maxPaletteIndex to valid range
    const maxIdx = Math.min(Math.max(maxPaletteIndex, 0), (0, _colors.chartGlassBlues).length - 1);
    const pairs = [];
    const step = maxIdx / (count - 1 || 1);
    for(let i = 0; i < count; i++){
        const index = Math.round(i * step);
        pairs.push({
            fill: (0, _colors.chartGlassBlues)[index],
            border: (0, _colors.chartBorderBlues)[index]
        });
    }
    return pairs;
};
const barChartDefaults = {
    borderRadius: 4,
    borderWidth: 2,
    padding: 0.3,
    innerPadding: 0,
    labelSkipWidth: 32,
    labelSkipHeight: 12,
    labelTextColor: (0, _colors.color_defaults_white),
    enableGridX: true,
    enableGridY: false,
    animate: true,
    motionConfig: "gentle"
};
const funnelChartDefaults = {
    borderWidth: 20,
    currentPartSizeExtension: 10,
    currentBorderWidth: 20,
    beforeSeparatorLength: 100,
    beforeSeparatorOffset: 20,
    afterSeparatorLength: 100,
    afterSeparatorOffset: 20,
    animate: true,
    motionConfig: "gentle"
};
const funnelColors = [
    (0, _colors.chart_blue_1),
    // Total calls - darkest
    (0, _colors.chart_blue_4),
    // Engaged calls - medium
    (0, _colors.chart_blue_7 // Orders placed - lighter
    )
];
const funnelGlassColors = [
    (0, _colors.chart_glass_blue_1),
    (0, _colors.chart_glass_blue_4),
    (0, _colors.chart_glass_blue_7)
];
const pieChartDefaults = {
    innerRadius: 0.5,
    padAngle: 2,
    cornerRadius: 4,
    activeOuterRadiusOffset: 8,
    borderWidth: 2,
    enableArcLinkLabels: false,
    arcLabelsSkipAngle: 15,
    arcLabelsTextColor: (0, _colors.color_defaults_white),
    animate: true,
    motionConfig: "gentle"
};
const tooltipStyles = {
    container: {
        background: "rgba(255, 255, 255, 0.95)",
        backdropFilter: "blur(8px)",
        padding: "12px 16px",
        borderRadius: "10px",
        boxShadow: "0 4px 20px rgba(0, 0, 0, 0.12), 0 0 0 1px rgba(0, 0, 0, 0.05)",
        border: `1px solid ${(0, _colors.color_shades_light)}`,
        minWidth: "180px"
    },
    title: {
        fontWeight: 600,
        marginBottom: 8,
        color: (0, _colors.color_shades_darkest),
        fontSize: "14px"
    },
    value: {
        fontWeight: 600,
        color: (0, _colors.color_shades_darkest),
        fontSize: "18px"
    },
    subtitle: {
        color: (0, _colors.color_shades_darker),
        fontSize: "12px"
    },
    colorIndicator: {
        width: "12px",
        height: "12px",
        borderRadius: "3px",
        border: "1px solid rgba(0, 0, 0, 0.1)"
    }
};
const dashboardTileStyles = {
    base: {
        backgroundColor: (0, _colors.color_defaults_white),
        border: "none",
        borderRadius: "16px",
        padding: "16px",
        boxShadow: "0 1px 3px rgba(0, 0, 0, 0.08)",
        transition: "box-shadow 0.2s ease"
    },
    hover: {
        boxShadow: "0 4px 12px rgba(0, 0, 0, 0.12)"
    },
    mobile: {
        padding: "12px",
        minHeight: "250px"
    }
};
const baseTileCSS = `
    background-color: ${(0, _colors.color_defaults_white)};
    border: none;
    border-radius: 16px;
    padding: 16px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
    transition: box-shadow 0.2s ease;
    overflow: visible;
    display: flex;
    flex-direction: column;
    min-height: 0;
    position: relative;

    &:hover {
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.12);
    }
`;
const tileSizeConfig = {
    // Standard chart tile (half width)
    chart: {
        gridColumn: "span 6",
        gridRow: "span 1",
        mobileMinHeight: "280px"
    },
    // Wide chart tile (full width) - for histograms
    wide: {
        gridColumn: "span 12",
        gridRow: "span 1",
        mobileMinHeight: "280px"
    },
    // Tall chart tile (spans 2 rows) - for vertical charts like transfers
    tall: {
        gridColumn: "7 / span 6",
        gridRow: "1 / span 2",
        mobileMinHeight: "380px"
    },
    // Number tile (1/3 width)
    number: {
        gridColumn: "span 4",
        gridRow: "span 1",
        mobileMinHeight: "150px"
    },
    // Small number tile (1/6 width)
    smallNumber: {
        gridColumn: "span 2",
        gridRow: "span 1",
        mobileMinHeight: "150px"
    }
};

},{"./colors":"1p3OR","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"73v87":[function(require,module,exports) {
module.exports = require("1ab4a285b97d2e2b").getBundleURL("kVLro") + require("45f269e45a4675db").resolve("cIsfi");

},{"1ab4a285b97d2e2b":"c7Tr5","45f269e45a4675db":"fyJL2"}],"43uUb":[function(require,module,exports) {
module.exports = require("85ac8d4409843f94").getBundleURL("kVLro") + require("9fd41e2de1855bb7").resolve("ewuki");

},{"85ac8d4409843f94":"c7Tr5","9fd41e2de1855bb7":"fyJL2"}],"fCPWH":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _defineProperty = require("@babel/runtime/helpers/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _reactSelect = require("react-select");
var _reactSelectDefault = parcelHelpers.interopDefault(_reactSelect);
var _toggleIndicator = require("../general/ToggleIndicator");
var _toggleIndicatorDefault = parcelHelpers.interopDefault(_toggleIndicator);
var _breakpoints = require("../../constants/breakpoints");
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
class AnalyticsSelectField extends (0, _reactDefault.default).Component {
    constructor(...args){
        super(...args);
        (0, _definePropertyDefault.default)(this, "handleChange", (value)=>{
            this.props.onChange(value);
        });
        (0, _definePropertyDefault.default)(this, "handleBlur", ()=>{
            if (this.props.onBlur) this.props.onBlur(true);
        });
    }
    render() {
        const props = {
            ...this.props
        };
        return (0, _react.jsx)("div", {
            className: `${containerStyle} ${props.className} selector`
        }, props.label !== undefined ? (0, _react.jsx)("label", {
            htmlFor: props.name,
            className: labelStyle
        }, props.label) : null, (0, _react.jsx)("div", {
            className: fieldContainer
        }, (0, _react.jsx)((0, _reactSelectDefault.default), {
            id: props.id,
            name: props.name,
            placeholder: props.placeholder,
            value: props.value,
            onChange: this.handleChange.bind(this),
            onBlur: this.handleBlur.bind(this),
            disabled: props.disabled,
            options: props.options,
            clearValueText: props.clearValueText,
            clearable: false,
            className: formSelectStyle,
            arrowRenderer: (p)=>(0, _react.jsx)((0, _toggleIndicatorDefault.default), {
                    direction: p.isOpen ? "up" : "down"
                })
        })));
    }
}
const containerStyle = /*#__PURE__*/ (0, _css.css)({
    name: "s5xdrg",
    styles: "display:flex;align-items:center"
});
const labelStyle = /*#__PURE__*/ (0, _css.css)({
    name: "1b1oh6i",
    styles: "font-style:normal;font-weight:normal;font-size:14px;line-height:20px;margin-right:16px"
});
const formSelectStyle = /*#__PURE__*/ (0, _css.css)({
    name: "16xsj0g",
    styles: "font-family:Muli sans-serif;font-weight:normal;font-style:normal;font-stretch:normal;line-height:normal;letter-spacing:normal;text-align:left;width:100%;.Select{height:32px;}.Select-control{border-radius:4px;height:32px;.Select-value{line-height:32px;}}.Select-placeholder,.Select-value{font-family:Muli;font-size:14px;}.Select-menu-outer{border-bottom-right-radius:4px;border-bottom-left-radius:4px;}.Select-option,Select-noresults{height:32px;font-family:Muli;font-size:14px;}.Select-option:last-child{border-bottom-right-radius:4px;border-bottom-left-radius:4px;}.Select.is-focused:not(.is-open)>.Select-control{border-color:transparent;}"
});
const fieldContainer = /*#__PURE__*/ (0, _css.css)("display:flex;align-items:center;height:32px;width:280px;border-radius:4px;box-shadow:0px 1px 2px rgba(50, 70, 97, 0.1);background:white;img{margin:16px;}", (0, _breakpoints.breakpoint_small), "{width:80%;}", "");
exports.default = AnalyticsSelectField;

},{"@babel/runtime/helpers/defineProperty":"9sJxO","@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","react-select":"1numo","../general/ToggleIndicator":"4eej1","../../constants/breakpoints":"2F01A","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"dvaPH":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _breakdownChart = require("./BreakdownChart");
var _breakdownChartDefault = parcelHelpers.interopDefault(_breakdownChart);
var _analyticsSelectField = require("../analytics/AnalyticsSelectField");
var _analyticsSelectFieldDefault = parcelHelpers.interopDefault(_analyticsSelectField);
var _secondaryLoader = require("../general/SecondaryLoader");
var _secondaryLoaderDefault = parcelHelpers.interopDefault(_secondaryLoader);
var _customScrollbars = require("../structure/CustomScrollbars");
var _customScrollbarsDefault = parcelHelpers.interopDefault(_customScrollbars);
var _colors = require("../../constants/colors");
const BreakdownChartCard = (props)=>(0, _react.jsx)("div", {
        className: containerStyle
    }, (0, _react.jsx)("div", {
        className: "title-section ac-analytics-breakdown-card"
    }, (0, _react.jsx)("h5", null, "Breakdown"), (0, _react.jsx)((0, _analyticsSelectFieldDefault.default), {
        className: "breakdown-select",
        options: props.options?.map((o)=>({
                value: o,
                label: o
            })),
        onChange: (e)=>props.onOptionChange(e.value),
        value: props.selectedOption
    })), props.isLoading ? (0, _react.jsx)("div", {
        className: "loader-container"
    }, (0, _react.jsx)((0, _secondaryLoaderDefault.default), null)) : (0, _react.jsx)((0, _customScrollbarsDefault.default), {
        className: "scroll-container",
        autoHide: true
    }, (0, _react.jsx)((0, _breakdownChartDefault.default), {
        items: props.items,
        secondaryItems: props.secondaryItems,
        showSecondary: props.showSecondary,
        showPrimary: props.showPrimary,
        isLoading: props.isLoading,
        primaryDataLabel: props.primaryDataLabel,
        secondaryDataLabel: props.secondaryDataLabel
    })));
const containerStyle = /*#__PURE__*/ (0, _css.css)("height:468px;width:532px;font-family:Muli;border:1px solid ", (0, _colors.color_shades_dark), ";box-sizing:border-box;border-radius:8px;padding:24px 0;background:white;overflow:hidden;.scroll-container{padding:0;}.title-section{display:flex;align-items:center;margin-bottom:24px;padding:0 32px;h5{font-style:normal;font-weight:normal;font-size:18px;line-height:24px;flex:1;}.breakdown-select{.Select{height:48px;}.Select-control{border-radius:8px;height:48px;.Select-value{line-height:48px;}}.Select-menu-outer{border-bottom-right-radius:8px;border-bottom-left-radius:8px;}.Select-option,Select-noresults{height:48px;font-family:Muli;font-size:14px;line-height:32px;}.Select-option:last-child{border-bottom-right-radius:8px;border-bottom-left-radius:8px;}.Select.is-focused:not(.is-open)>.Select-control{border-color:transparent;}}}.loader-container{display:flex;flex:1;align-items:center;justify-content:center;width:100%;.spinner>div{background:", (0, _colors.color_colors_ocean), ";}}", "");
exports.default = BreakdownChartCard;

},{"@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","./BreakdownChart":"156IE","../analytics/AnalyticsSelectField":"fCPWH","../general/SecondaryLoader":"7zJiF","../structure/CustomScrollbars":"50vFq","../../constants/colors":"1p3OR","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"156IE":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _singleItemGauge = require("./SingleItemGauge");
var _singleItemGaugeDefault = parcelHelpers.interopDefault(_singleItemGauge);
var _lodash = require("lodash");
var _lodashDefault = parcelHelpers.interopDefault(_lodash);
var _colors = require("../../constants/colors");
var _toggleIndicator = require("../general/ToggleIndicator");
var _toggleIndicatorDefault = parcelHelpers.interopDefault(_toggleIndicator);
class BreakdownChart extends (0, _reactDefault.default).Component {
    constructor(props){
        super(props);
        this.state = {
            sort: "primary-desc"
        };
    }
    getOrderedItems() {
        if (this.state.sort == "primary-desc") return (0, _lodashDefault.default).orderBy(this.props.items ?? [], (b)=>b.count, "desc");
        if (this.state.sort == "primary-asc") return (0, _lodashDefault.default).orderBy(this.props.items ?? [], (b)=>b.count, "asc");
        if (this.state.sort == "secondary-desc") return (0, _lodashDefault.default).orderBy(this.props.secondaryItems ?? [], (b)=>b.count, "desc");
        if (this.state.sort == "secondary-asc") return (0, _lodashDefault.default).orderBy(this.props.secondaryItems ?? [], (b)=>b.count, "asc");
    }
    handlePrimarySort() {
        if (this.state.sort == "primary-desc") this.setState({
            ...this.state,
            sort: "primary-asc"
        });
        else this.setState({
            ...this.state,
            sort: "primary-desc"
        });
    }
    handleSecondarySort() {
        if (this.state.sort == "secondary-desc") this.setState({
            ...this.state,
            sort: "secondary-asc"
        });
        else this.setState({
            ...this.state,
            sort: "secondary-desc"
        });
    }
    render() {
        const props = this.props;
        const getSecondary = (item)=>{
            return props.secondaryItems.find((s)=>s.label == item.label);
        };
        return (0, _react.jsx)("div", {
            className: containerStyle
        }, (0, _react.jsx)("div", {
            className: "label-container"
        }, props.showSecondary && (0, _react.jsx)("div", {
            className: "label-item",
            onClick: this.handleSecondarySort.bind(this)
        }, (0, _react.jsx)("p", null, props.secondaryDataLabel), this.state.sort == "secondary-asc" && (0, _react.jsx)((0, _toggleIndicatorDefault.default), {
            type: "triangle",
            className: "toggle-indicator",
            direction: "up"
        }), this.state.sort == "secondary-desc" && (0, _react.jsx)((0, _toggleIndicatorDefault.default), {
            type: "triangle",
            className: "toggle-indicator",
            direction: "down"
        })), props.showPrimary && (0, _react.jsx)("div", {
            className: "label-item",
            onClick: this.handlePrimarySort.bind(this)
        }, (0, _react.jsx)("p", null, props.primaryDataLabel), this.state.sort == "primary-asc" && (0, _react.jsx)((0, _toggleIndicatorDefault.default), {
            type: "triangle",
            className: "toggle-indicator",
            direction: "up"
        }), this.state.sort == "primary-desc" && (0, _react.jsx)((0, _toggleIndicatorDefault.default), {
            type: "triangle",
            className: "toggle-indicator",
            direction: "down"
        }))), this.getOrderedItems()?.map((b, i)=>(0, _react.jsx)("div", {
                key: i,
                className: "breakdown-item"
            }, (0, _react.jsx)("div", {
                className: "icon-container"
            }, b.iconRender ? b.iconRender() : null), (0, _react.jsx)("p", null, b.label), (0, _react.jsx)("div", {
                className: "chart-container"
            }, props.showSecondary && (0, _react.jsx)("div", {
                className: "chart-item"
            }, (0, _react.jsx)("p", null, getSecondary(b)?.percentage?.toFixed(0) ?? 0, "%"), (0, _react.jsx)((0, _singleItemGaugeDefault.default), {
                label: b.label,
                value: getSecondary(b)?.count ?? 0,
                percentage: getSecondary(b)?.percentage ?? 0,
                size: 32
            })), props.showPrimary && (0, _react.jsx)("div", {
                className: "chart-item"
            }, (0, _react.jsx)("p", null, b.percentage?.toFixed(0) ?? 0, "%"), (0, _react.jsx)((0, _singleItemGaugeDefault.default), {
                label: b.label,
                value: b.count ?? 0,
                percentage: b.percentage ?? 0,
                size: 32
            }))))));
    }
}
const containerStyle = /*#__PURE__*/ (0, _css.css)("width:100%;padding:0 32px 48px 32px;display:flex;flex-direction:column;.label-container{display:flex;align-items:center;margin-right:0;margin-left:auto;.label-item{cursor:pointer;display:flex;align-items:center;margin-left:16px;p{color:", (0, _colors.color_text_light), ";font-size:12px;line-height:16px;text-align:right;letter-spacing:0.1em;text-transform:uppercase;}.toggle-indicator{margin-left:4px;.down{border-top:3px solid ", (0, _colors.color_text_light), ";}.up{border-bottom:3px solid ", (0, _colors.color_text_light), ";}}}}.breakdown-item{display:flex;align-items:center;margin:16px 0;width:100%;.icon-container{width:32px;height:auto;display:flex;align-items:center;justify-content:center;>img{width:32px;height:auto;}}>p{margin:0 16px;font-size:16px;line-height:24px;flex:1;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;}.chart-container{margin-right:0;margin-left:auto;height:32px;display:flex;align-items:center;.chart-item{display:flex;align-items:center;>p{margin-right:8px;margin-left:48px;font-style:normal;font-weight:normal;font-size:18px;line-height:24px;}}}}", "");
exports.default = BreakdownChart;

},{"@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","./SingleItemGauge":"cmEzB","lodash":"3hMBK","../../constants/colors":"1p3OR","../general/ToggleIndicator":"4eej1","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"cmEzB":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _pie = require("@nivo/pie");
var _colors = require("../../constants/colors");
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const SingleItemGauge = (props)=>{
    const multiplier = props.percentage / 100;
    const ToolTip = ()=>{
        return (0, _react.jsx)("div", {
            className: tooltipStyle
        }, (0, _react.jsx)("p", {
            className: "value-label"
        }, props.value));
    };
    return (0, _react.jsx)((0, _pie.Pie), {
        data: [
            {
                id: props.label,
                label: props.label,
                value: props.percentage,
                color: (0, _colors.color_colors_ocean)
            },
            {
                id: "empty",
                label: "none",
                value: 100 - props.percentage,
                color: (0, _colors.color_shades_light)
            }
        ],
        width: props.size,
        height: props.size,
        margin: {
            top: 4,
            right: 4,
            bottom: 4,
            left: 4
        },
        enableRadialLabels: false,
        enableSliceLabels: false,
        innerRadius: 0.6,
        colors: (d)=>d.data.color,
        borderWidth: 0,
        fit: false,
        isInteractive: true,
        tooltip: (c)=>ToolTip(),
        borderColor: {
            from: "color",
            modifiers: [
                [
                    "darker",
                    0.2
                ]
            ]
        }
    });
};
const tooltipStyle = /*#__PURE__*/ (0, _css.css)({
    name: "17elpvr",
    styles: "background:white;border-radius:4px;display:flex;flex-direction:column;align-items:center;justify-content:center;position:relative;.value-label{text-align:center;font-weight:600;font-size:18px;line-height:24px;}"
});
exports.default = SingleItemGauge;

},{"@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","@nivo/pie":"131hg","../../constants/colors":"1p3OR","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"131hg":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Pie", ()=>ee);
parcelHelpers.export(exports, "PieCanvas", ()=>re);
parcelHelpers.export(exports, "ResponsivePie", ()=>te);
parcelHelpers.export(exports, "ResponsivePieCanvas", ()=>de);
parcelHelpers.export(exports, "defaultProps", ()=>P);
parcelHelpers.export(exports, "useNormalizedData", ()=>q);
parcelHelpers.export(exports, "usePie", ()=>N);
parcelHelpers.export(exports, "usePieArcs", ()=>J);
parcelHelpers.export(exports, "usePieFromBox", ()=>Q);
parcelHelpers.export(exports, "usePieLayerContext", ()=>U);
var _react = require("react");
var _core = require("@nivo/core");
var _arcs = require("@nivo/arcs");
var _legends = require("@nivo/legends");
var _jsxRuntime = require("react/jsx-runtime");
var _d3Shape = require("d3-shape");
var _colors = require("@nivo/colors");
var _tooltip = require("@nivo/tooltip");
var _theming = require("@nivo/theming");
function E() {
    return E = Object.assign ? Object.assign.bind() : function(e) {
        for(var i = 1; i < arguments.length; i++){
            var t = arguments[i];
            for(var a in t)({}).hasOwnProperty.call(t, a) && (e[a] = t[a]);
        }
        return e;
    }, E.apply(null, arguments);
}
function F(e, i) {
    if (null == e) return {};
    var t = {};
    for(var a in e)if (({}).hasOwnProperty.call(e, a)) {
        if (-1 !== i.indexOf(a)) continue;
        t[a] = e[a];
    }
    return t;
}
var X, Y = function(e) {
    var i = e.width, t = e.height, a = e.legends, n = e.data, r = e.toggleSerie;
    return (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
        children: a.map(function(e, a) {
            var o;
            return (0, _jsxRuntime.jsx)((0, _legends.BoxLegendSvg), E({}, e, {
                containerWidth: i,
                containerHeight: t,
                data: null != (o = e.data) ? o : n,
                toggleSerie: e.toggleSerie ? r : void 0
            }), a);
        })
    });
}, P = {
    id: "id",
    value: "value",
    sortByValue: !1,
    innerRadius: 0,
    padAngle: 0,
    cornerRadius: 0,
    layers: [
        "arcs",
        "arcLinkLabels",
        "arcLabels",
        "legends"
    ],
    startAngle: 0,
    endAngle: 360,
    fit: !0,
    activeInnerRadiusOffset: 0,
    activeOuterRadiusOffset: 0,
    borderWidth: 0,
    borderColor: {
        from: "color",
        modifiers: [
            [
                "darker",
                1
            ]
        ]
    },
    enableArcLabels: !0,
    arcLabel: "formattedValue",
    arcLabelsSkipAngle: 0,
    arcLabelsSkipRadius: 0,
    arcLabelsRadiusOffset: .5,
    arcLabelsTextColor: {
        theme: "labels.text.fill"
    },
    enableArcLinkLabels: !0,
    arcLinkLabel: "id",
    arcLinkLabelsSkipAngle: 0,
    arcLinkLabelsOffset: 0,
    arcLinkLabelsDiagonalLength: 16,
    arcLinkLabelsStraightLength: 24,
    arcLinkLabelsThickness: 1,
    arcLinkLabelsTextOffset: 6,
    arcLinkLabelsTextColor: {
        theme: "labels.text.fill"
    },
    arcLinkLabelsColor: {
        theme: "axis.ticks.line.stroke"
    },
    colors: {
        scheme: "nivo"
    },
    defs: [],
    fill: [],
    isInteractive: !0,
    animate: !0,
    motionConfig: "gentle",
    transitionMode: "innerRadius",
    tooltip: function(e) {
        var i = e.datum;
        return (0, _jsxRuntime.jsx)((0, _tooltip.BasicTooltip), {
            id: i.id,
            value: i.formattedValue,
            enableChip: !0,
            color: i.color
        });
    },
    legends: [],
    role: "img",
    pixelRatio: "undefined" != typeof window && null != (X = window.devicePixelRatio) ? X : 1
}, j = [
    "points"
], q = function(i) {
    var t = i.data, a = i.id, n = void 0 === a ? P.id : a, r = i.value, o = void 0 === r ? P.value : r, d = i.valueFormat, c = i.colors, u = void 0 === c ? P.colors : c, f = (0, _core.usePropertyAccessor)(n), v = (0, _core.usePropertyAccessor)(o), g = (0, _core.useValueFormatter)(d), h = (0, _colors.useOrdinalColorScale)(u, "id");
    return (0, _react.useMemo)(function() {
        return t.map(function(e) {
            var i, t = f(e), a = v(e), n = {
                id: t,
                label: null != (i = e.label) ? i : t,
                hidden: !1,
                value: a,
                formattedValue: g(a),
                data: e
            };
            return E({}, n, {
                color: h(n)
            });
        });
    }, [
        t,
        f,
        v,
        g,
        h
    ]);
}, J = function(a) {
    var n = a.data, r = a.startAngle, o = a.endAngle, d = a.innerRadius, l = a.outerRadius, s = a.padAngle, f = a.sortByValue, v = a.activeId, g = a.activeInnerRadiusOffset, h = a.activeOuterRadiusOffset, L = a.hiddenIds, b = a.forwardLegendData, A = (0, _react.useMemo)(function() {
        var e = (0, _d3Shape.pie)().value(function(e) {
            return e.value;
        }).startAngle((0, _core.degreesToRadians)(r)).endAngle((0, _core.degreesToRadians)(o)).padAngle((0, _core.degreesToRadians)(s));
        return f || e.sortValues(null), e;
    }, [
        r,
        o,
        s,
        f
    ]), p = (0, _react.useMemo)(function() {
        var e = n.filter(function(e) {
            return !L.includes(e.id);
        });
        return {
            dataWithArc: A(e).map(function(e) {
                var i = Math.abs(e.endAngle - e.startAngle);
                return E({}, e.data, {
                    arc: {
                        index: e.index,
                        startAngle: e.startAngle,
                        endAngle: e.endAngle,
                        innerRadius: v === e.data.id ? d - g : d,
                        outerRadius: v === e.data.id ? l + h : l,
                        thickness: l - d,
                        padAngle: e.padAngle,
                        angle: i,
                        angleDeg: (0, _core.radiansToDegrees)(i)
                    }
                });
            }),
            legendData: n.map(function(e) {
                return {
                    id: e.id,
                    label: e.label,
                    color: e.color,
                    hidden: L.includes(e.id),
                    data: e
                };
            })
        };
    }, [
        A,
        n,
        L,
        v,
        d,
        g,
        l,
        h
    ]), R = p.legendData, k = (0, _react.useRef)(b);
    return (0, _react.useEffect)(function() {
        "function" == typeof k.current && k.current(R);
    }, [
        k,
        R
    ]), p;
}, K = function(e) {
    var i = e.activeId, t = e.onActiveIdChange, r = e.defaultActiveId, o = void 0 !== i, d = (0, _react.useState)(o ? null : void 0 === r ? null : r), l = d[0], s = d[1];
    return {
        activeId: o ? i : l,
        setActiveId: (0, _react.useCallback)(function(e) {
            t && t(e), o || s(e);
        }, [
            o,
            t,
            s
        ])
    };
}, N = function(e) {
    var i = e.data, t = e.radius, r = e.innerRadius, o = e.startAngle, d = void 0 === o ? P.startAngle : o, l = e.endAngle, s = void 0 === l ? P.endAngle : l, u = e.padAngle, f = void 0 === u ? P.padAngle : u, v = e.sortByValue, g = void 0 === v ? P.sortByValue : v, h = e.cornerRadius, L = void 0 === h ? P.cornerRadius : h, b = e.activeInnerRadiusOffset, A = void 0 === b ? P.activeInnerRadiusOffset : b, R = e.activeOuterRadiusOffset, k = void 0 === R ? P.activeOuterRadiusOffset : R, m = e.activeId, I = e.onActiveIdChange, O = e.defaultActiveId, C = e.forwardLegendData, w = K({
        activeId: m,
        onActiveIdChange: I,
        defaultActiveId: O
    }), x = w.activeId, W = w.setActiveId, M = (0, _react.useState)([]), y = M[0], S = M[1], T = J({
        data: i,
        startAngle: d,
        endAngle: s,
        innerRadius: r,
        outerRadius: t,
        padAngle: f,
        sortByValue: g,
        activeId: x,
        activeInnerRadiusOffset: A,
        activeOuterRadiusOffset: k,
        hiddenIds: y,
        forwardLegendData: C
    }), D = (0, _react.useCallback)(function(e) {
        S(function(i) {
            return i.indexOf(e) > -1 ? i.filter(function(i) {
                return i !== e;
            }) : [].concat(i, [
                e
            ]);
        });
    }, []);
    return E({}, T, {
        arcGenerator: (0, _arcs.useArcGenerator)({
            cornerRadius: L,
            padAngle: (0, _core.degreesToRadians)(f)
        }),
        setActiveId: W,
        toggleSerie: D
    });
}, Q = function(i) {
    var t = i.data, r = i.width, o = i.height, d = i.innerRadius, l = void 0 === d ? P.innerRadius : d, s = i.startAngle, u = void 0 === s ? P.startAngle : s, f = i.endAngle, v = void 0 === f ? P.endAngle : f, g = i.padAngle, h = void 0 === g ? P.padAngle : g, L = i.sortByValue, b = void 0 === L ? P.sortByValue : L, A = i.cornerRadius, k = void 0 === A ? P.cornerRadius : A, m = i.fit, I = void 0 === m ? P.fit : m, O = i.activeInnerRadiusOffset, C = void 0 === O ? P.activeInnerRadiusOffset : O, w = i.activeOuterRadiusOffset, x = void 0 === w ? P.activeOuterRadiusOffset : w, W = i.activeId, M = i.onActiveIdChange, y = i.defaultActiveId, S = i.forwardLegendData, T = K({
        activeId: W,
        onActiveIdChange: M,
        defaultActiveId: y
    }), D = T.activeId, V = T.setActiveId, B = (0, _react.useState)([]), z = B[0], H = B[1], G = (0, _react.useMemo)(function() {
        var e, i = Math.min(r, o) / 2, t = i * Math.min(l, 1), a = r / 2, n = o / 2;
        if (I) {
            var d = (0, _arcs.computeArcBoundingBox)(a, n, i, u - 90, v - 90), s = d.points, c = F(d, j), f = Math.min(r / c.width, o / c.height), g = {
                width: c.width * f,
                height: c.height * f
            };
            g.x = (r - g.width) / 2, g.y = (o - g.height) / 2, a = (a - c.x) / c.width * c.width * f + g.x, n = (n - c.y) / c.height * c.height * f + g.y, e = {
                box: c,
                ratio: f,
                points: s
            }, i *= f, t *= f;
        }
        return {
            centerX: a,
            centerY: n,
            radius: i,
            innerRadius: t,
            debug: e
        };
    }, [
        r,
        o,
        l,
        u,
        v,
        I
    ]), X = J({
        data: t,
        startAngle: u,
        endAngle: v,
        innerRadius: G.innerRadius,
        outerRadius: G.radius,
        padAngle: h,
        sortByValue: b,
        activeId: D,
        activeInnerRadiusOffset: C,
        activeOuterRadiusOffset: x,
        hiddenIds: z,
        forwardLegendData: S
    }), Y = (0, _react.useCallback)(function(e) {
        H(function(i) {
            return i.indexOf(e) > -1 ? i.filter(function(i) {
                return i !== e;
            }) : [].concat(i, [
                e
            ]);
        });
    }, []);
    return E({
        arcGenerator: (0, _arcs.useArcGenerator)({
            cornerRadius: k,
            padAngle: (0, _core.degreesToRadians)(h)
        }),
        activeId: D,
        setActiveId: V,
        toggleSerie: Y
    }, X, G);
}, U = function(i) {
    var t = i.dataWithArc, a = i.arcGenerator, n = i.centerX, r = i.centerY, o = i.radius, d = i.innerRadius;
    return (0, _react.useMemo)(function() {
        return {
            dataWithArc: t,
            arcGenerator: a,
            centerX: n,
            centerY: r,
            radius: o,
            innerRadius: d
        };
    }, [
        t,
        a,
        n,
        r,
        o,
        d
    ]);
}, Z = function(i) {
    var t = i.center, a = i.data, n = i.arcGenerator, o = i.borderWidth, d = i.borderColor, l = i.isInteractive, s = i.onClick, c = i.onMouseEnter, u = i.onMouseMove, f = i.onMouseLeave, v = i.setActiveId, g = i.tooltip, h = i.transitionMode, L = (0, _tooltip.useTooltip)(), b = L.showTooltipFromEvent, A = L.hideTooltip, p = (0, _react.useMemo)(function() {
        if (l) return function(e, i) {
            null == s || s(e, i);
        };
    }, [
        l,
        s
    ]), R = (0, _react.useMemo)(function() {
        if (l) return function(e, i) {
            b((0, _react.createElement)(g, {
                datum: e
            }), i), v(e.id), null == c || c(e, i);
        };
    }, [
        l,
        b,
        v,
        c,
        g
    ]), m = (0, _react.useMemo)(function() {
        if (l) return function(e, i) {
            b((0, _react.createElement)(g, {
                datum: e
            }), i), null == u || u(e, i);
        };
    }, [
        l,
        b,
        u,
        g
    ]), I = (0, _react.useMemo)(function() {
        if (l) return function(e, i) {
            A(), v(null), null == f || f(e, i);
        };
    }, [
        l,
        A,
        v,
        f
    ]);
    return (0, _jsxRuntime.jsx)((0, _arcs.ArcsLayer), {
        center: t,
        data: a,
        arcGenerator: n,
        borderWidth: o,
        borderColor: d,
        transitionMode: h,
        onClick: p,
        onMouseEnter: R,
        onMouseMove: m,
        onMouseLeave: I
    });
}, $ = [
    "isInteractive",
    "animate",
    "motionConfig",
    "theme",
    "renderWrapper"
], _ = function(e) {
    var i = e.data, t = e.id, a = void 0 === t ? P.id : t, n = e.value, o = void 0 === n ? P.value : n, l = e.valueFormat, s = e.sortByValue, c = void 0 === s ? P.sortByValue : s, u = e.layers, f = void 0 === u ? P.layers : u, L = e.startAngle, b = void 0 === L ? P.startAngle : L, A = e.endAngle, p = void 0 === A ? P.endAngle : A, R = e.padAngle, k = void 0 === R ? P.padAngle : R, O = e.fit, C = void 0 === O ? P.fit : O, w = e.innerRadius, x = void 0 === w ? P.innerRadius : w, W = e.cornerRadius, M = void 0 === W ? P.cornerRadius : W, y = e.activeInnerRadiusOffset, T = void 0 === y ? P.activeInnerRadiusOffset : y, D = e.activeOuterRadiusOffset, V = void 0 === D ? P.activeOuterRadiusOffset : D, B = e.width, z = e.height, H = e.margin, G = e.colors, E = void 0 === G ? P.colors : G, F = e.borderWidth, X = void 0 === F ? P.borderWidth : F, j = e.borderColor, J = void 0 === j ? P.borderColor : j, K = e.enableArcLabels, N = void 0 === K ? P.enableArcLabels : K, $ = e.arcLabel, _ = void 0 === $ ? P.arcLabel : $, ee = e.arcLabelsSkipAngle, ie = void 0 === ee ? P.arcLabelsSkipAngle : ee, te = e.arcLabelsSkipRadius, ae = void 0 === te ? P.arcLabelsSkipRadius : te, ne = e.arcLabelsTextColor, re = void 0 === ne ? P.arcLabelsTextColor : ne, oe = e.arcLabelsRadiusOffset, de = void 0 === oe ? P.arcLabelsRadiusOffset : oe, le = e.arcLabelsComponent, se = e.enableArcLinkLabels, ce = void 0 === se ? P.enableArcLinkLabels : se, ue = e.arcLinkLabel, fe = void 0 === ue ? P.arcLinkLabel : ue, ve = e.arcLinkLabelsSkipAngle, ge = void 0 === ve ? P.arcLinkLabelsSkipAngle : ve, he = e.arcLinkLabelsOffset, Le = void 0 === he ? P.arcLinkLabelsOffset : he, be = e.arcLinkLabelsDiagonalLength, Ae = void 0 === be ? P.arcLinkLabelsDiagonalLength : be, pe = e.arcLinkLabelsStraightLength, Re = void 0 === pe ? P.arcLinkLabelsStraightLength : pe, ke = e.arcLinkLabelsThickness, me = void 0 === ke ? P.arcLinkLabelsThickness : ke, Ie = e.arcLinkLabelsTextOffset, Oe = void 0 === Ie ? P.arcLinkLabelsTextOffset : Ie, Ce = e.arcLinkLabelsTextColor, we = void 0 === Ce ? P.arcLinkLabelsTextColor : Ce, xe = e.arcLinkLabelsColor, We = void 0 === xe ? P.arcLinkLabelsColor : xe, Me = e.arcLinkLabelComponent, ye = e.defs, Se = void 0 === ye ? P.defs : ye, Te = e.fill, De = void 0 === Te ? P.fill : Te, Ve = e.isInteractive, Be = void 0 === Ve ? P.isInteractive : Ve, ze = e.onClick, He = e.onMouseEnter, Ge = e.onMouseMove, Ee = e.onMouseLeave, Fe = e.tooltip, Xe = void 0 === Fe ? P.tooltip : Fe, Ye = e.activeId, Pe = e.onActiveIdChange, je = e.defaultActiveId, qe = e.transitionMode, Je = void 0 === qe ? P.transitionMode : qe, Ke = e.legends, Ne = void 0 === Ke ? P.legends : Ke, Qe = e.forwardLegendData, Ue = e.role, Ze = void 0 === Ue ? P.role : Ue, $e = e.forwardedRef, _e = (0, _core.useDimensions)(B, z, H), ei = _e.outerWidth, ii = _e.outerHeight, ti = _e.margin, ai = _e.innerWidth, ni = _e.innerHeight, ri = q({
        data: i,
        id: a,
        value: o,
        valueFormat: l,
        colors: E
    }), oi = Q({
        data: ri,
        width: ai,
        height: ni,
        fit: C,
        innerRadius: x,
        startAngle: b,
        endAngle: p,
        padAngle: k,
        sortByValue: c,
        cornerRadius: M,
        activeInnerRadiusOffset: T,
        activeOuterRadiusOffset: V,
        activeId: Ye,
        onActiveIdChange: Pe,
        defaultActiveId: je,
        forwardLegendData: Qe
    }), di = oi.dataWithArc, li = oi.legendData, si = oi.arcGenerator, ci = oi.centerX, ui = oi.centerY, fi = oi.radius, vi = oi.innerRadius, gi = oi.setActiveId, hi = oi.toggleSerie, Li = (0, _core.bindDefs)(Se, di, De), bi = {
        arcs: null,
        arcLinkLabels: null,
        arcLabels: null,
        legends: null
    };
    f.includes("arcs") && (bi.arcs = (0, _jsxRuntime.jsx)(Z, {
        center: [
            ci,
            ui
        ],
        data: di,
        arcGenerator: si,
        borderWidth: X,
        borderColor: J,
        isInteractive: Be,
        onClick: ze,
        onMouseEnter: He,
        onMouseMove: Ge,
        onMouseLeave: Ee,
        setActiveId: gi,
        tooltip: Xe,
        transitionMode: Je
    }, "arcs")), ce && f.includes("arcLinkLabels") && (bi.arcLinkLabels = (0, _jsxRuntime.jsx)((0, _arcs.ArcLinkLabelsLayer), {
        center: [
            ci,
            ui
        ],
        data: di,
        label: fe,
        skipAngle: ge,
        offset: Le,
        diagonalLength: Ae,
        straightLength: Re,
        strokeWidth: me,
        textOffset: Oe,
        textColor: we,
        linkColor: We,
        component: Me
    }, "arcLinkLabels")), N && f.includes("arcLabels") && (bi.arcLabels = (0, _jsxRuntime.jsx)((0, _arcs.ArcLabelsLayer), {
        center: [
            ci,
            ui
        ],
        data: di,
        label: _,
        radiusOffset: de,
        skipAngle: ie,
        skipRadius: ae,
        textColor: re,
        transitionMode: Je,
        component: le
    }, "arcLabels")), Ne.length > 0 && f.includes("legends") && (bi.legends = (0, _jsxRuntime.jsx)(Y, {
        width: ai,
        height: ni,
        data: li,
        legends: Ne,
        toggleSerie: hi
    }, "legends"));
    var Ai = U({
        dataWithArc: di,
        arcGenerator: si,
        centerX: ci,
        centerY: ui,
        radius: fi,
        innerRadius: vi
    });
    return (0, _jsxRuntime.jsx)((0, _core.SvgWrapper), {
        width: ei,
        height: ii,
        margin: ti,
        defs: Li,
        role: Ze,
        ref: $e,
        children: f.map(function(e, i) {
            return void 0 !== bi[e] ? bi[e] : "function" == typeof e ? (0, _jsxRuntime.jsx)((0, _react.Fragment), {
                children: (0, _react.createElement)(e, Ai)
            }, i) : null;
        })
    });
}, ee = (0, _react.forwardRef)(function(e, i) {
    var t = e.isInteractive, a = void 0 === t ? P.isInteractive : t, n = e.animate, r = void 0 === n ? P.animate : n, o = e.motionConfig, d = void 0 === o ? P.motionConfig : o, l = e.theme, s = e.renderWrapper, c = F(e, $);
    return (0, _jsxRuntime.jsx)((0, _core.Container), {
        animate: r,
        isInteractive: a,
        motionConfig: d,
        renderWrapper: s,
        theme: l,
        children: (0, _jsxRuntime.jsx)(_, E({
            isInteractive: a
        }, c, {
            forwardedRef: i
        }))
    });
}), ie = [
    "defaultWidth",
    "defaultHeight",
    "onResize",
    "debounceResize"
], te = (0, _react.forwardRef)(function(e, i) {
    var t = e.defaultWidth, a = e.defaultHeight, n = e.onResize, r = e.debounceResize, o = F(e, ie);
    return (0, _jsxRuntime.jsx)((0, _core.ResponsiveWrapper), {
        defaultWidth: t,
        defaultHeight: a,
        onResize: n,
        debounceResize: r,
        children: function(e) {
            var t = e.width, a = e.height;
            return (0, _jsxRuntime.jsx)(ee, E({
                width: t,
                height: a
            }, o, {
                ref: i
            }));
        }
    });
}), ae = [
    "isInteractive",
    "theme",
    "renderWrapper"
], ne = function(a) {
    var n = a.data, o = a.id, d = void 0 === o ? P.id : o, l = a.value, s = void 0 === l ? P.value : l, c = a.valueFormat, u = a.sortByValue, f = void 0 === u ? P.sortByValue : u, g = a.startAngle, h = void 0 === g ? P.startAngle : g, L = a.endAngle, p = void 0 === L ? P.endAngle : L, R = a.padAngle, k = void 0 === R ? P.padAngle : R, m = a.fit, I = void 0 === m ? P.fit : m, M = a.innerRadius, T = void 0 === M ? P.innerRadius : M, D = a.cornerRadius, V = void 0 === D ? P.cornerRadius : D, z = a.activeInnerRadiusOffset, F = void 0 === z ? P.activeInnerRadiusOffset : z, X = a.activeOuterRadiusOffset, Y = void 0 === X ? P.activeOuterRadiusOffset : X, j = a.width, J = a.height, K = a.margin, N = a.pixelRatio, U = void 0 === N ? P.pixelRatio : N, Z = a.colors, $ = void 0 === Z ? P.colors : Z, _ = a.borderWidth, ee = void 0 === _ ? P.borderWidth : _, ie = a.borderColor, te = void 0 === ie ? P.borderColor : ie, ae = a.enableArcLabels, ne = void 0 === ae ? P.enableArcLabels : ae, re = a.arcLabel, oe = void 0 === re ? P.arcLabel : re, de = a.arcLabelsSkipAngle, le = void 0 === de ? P.arcLabelsSkipAngle : de, se = a.arcLabelsTextColor, ce = void 0 === se ? P.arcLabelsTextColor : se, ue = a.arcLabelsRadiusOffset, fe = void 0 === ue ? P.arcLabelsRadiusOffset : ue, ve = a.enableArcLinkLabels, ge = void 0 === ve ? P.enableArcLinkLabels : ve, he = a.arcLinkLabel, Le = void 0 === he ? P.arcLinkLabel : he, be = a.arcLinkLabelsSkipAngle, Ae = void 0 === be ? P.arcLinkLabelsSkipAngle : be, pe = a.arcLinkLabelsOffset, Re = void 0 === pe ? P.arcLinkLabelsOffset : pe, ke = a.arcLinkLabelsDiagonalLength, me = void 0 === ke ? P.arcLinkLabelsDiagonalLength : ke, Ie = a.arcLinkLabelsStraightLength, Oe = void 0 === Ie ? P.arcLinkLabelsStraightLength : Ie, Ce = a.arcLinkLabelsThickness, we = void 0 === Ce ? P.arcLinkLabelsThickness : Ce, xe = a.arcLinkLabelsTextOffset, We = void 0 === xe ? P.arcLinkLabelsTextOffset : xe, Me = a.arcLinkLabelsTextColor, ye = void 0 === Me ? P.arcLinkLabelsTextColor : Me, Se = a.arcLinkLabelsColor, Te = void 0 === Se ? P.arcLinkLabelsColor : Se, De = a.isInteractive, Ve = void 0 === De ? P.isInteractive : De, Be = a.onClick, ze = a.onMouseMove, He = a.tooltip, Ge = void 0 === He ? P.tooltip : He, Ee = a.activeId, Fe = a.onActiveIdChange, Xe = a.defaultActiveId, Ye = a.legends, Pe = void 0 === Ye ? P.legends : Ye, je = a.forwardLegendData, qe = a.role, Je = a.forwardedRef, Ke = (0, _react.useRef)(null), Ne = (0, _theming.useTheme)(), Qe = (0, _core.useDimensions)(j, J, K), Ue = Qe.margin, Ze = Qe.innerWidth, $e = Qe.innerHeight, _e = Qe.outerWidth, ei = Qe.outerHeight, ii = q({
        data: n,
        id: d,
        value: s,
        valueFormat: c,
        colors: $
    }), ti = Q({
        data: ii,
        width: Ze,
        height: $e,
        fit: I,
        innerRadius: T,
        startAngle: h,
        endAngle: p,
        padAngle: k,
        sortByValue: f,
        cornerRadius: V,
        activeInnerRadiusOffset: F,
        activeOuterRadiusOffset: Y,
        activeId: Ee,
        onActiveIdChange: Fe,
        defaultActiveId: Xe,
        forwardLegendData: je
    }), ai = ti.dataWithArc, ni = ti.arcGenerator, ri = ti.centerX, oi = ti.centerY, di = ti.radius, li = ti.innerRadius, si = ti.setActiveId, ci = (0, _colors.useInheritedColor)(te, Ne), ui = (0, _arcs.useArcLabels)({
        data: ai,
        label: oe,
        skipAngle: le,
        offset: fe,
        textColor: ce
    }), fi = (0, _arcs.useArcLinkLabels)({
        data: ai,
        skipAngle: Ae,
        offset: Re,
        diagonalLength: me,
        straightLength: Oe,
        label: Le,
        linkColor: Te,
        textOffset: We,
        textColor: ye
    });
    (0, _react.useEffect)(function() {
        if (Ke.current) {
            Ke.current.width = _e * U, Ke.current.height = ei * U;
            var e = Ke.current.getContext("2d");
            e.scale(U, U), e.fillStyle = Ne.background, e.fillRect(0, 0, _e, ei), e.save(), e.translate(Ue.left, Ue.top), ni.context(e), e.save(), e.translate(ri, oi), ai.forEach(function(i) {
                e.beginPath(), e.fillStyle = i.color, e.strokeStyle = ci(i), e.lineWidth = ee, ni(i.arc), e.fill(), ee > 0 && e.stroke();
            }), !0 === ge && (0, _arcs.drawCanvasArcLinkLabels)(e, fi, Ne, we), !0 === ne && (0, _arcs.drawCanvasArcLabels)(e, ui, Ne), e.restore(), Pe.forEach(function(i) {
                (0, _legends.renderLegendToCanvas)(e, E({}, i, {
                    data: ai,
                    containerWidth: Ze,
                    containerHeight: $e,
                    theme: Ne
                }));
            });
        }
    }, [
        Ke,
        Ze,
        $e,
        _e,
        ei,
        Ue.top,
        Ue.left,
        U,
        ri,
        oi,
        ni,
        ai,
        ee,
        ci,
        ne,
        ui,
        ge,
        fi,
        we,
        Pe,
        Ne
    ]);
    var vi = (0, _react.useMemo)(function() {
        return ai.map(function(e) {
            return E({
                id: e.id
            }, e.arc);
        });
    }, [
        ai
    ]), gi = function(e) {
        if (!Ke.current) return null;
        var i = (0, _core.getRelativeCursor)(Ke.current, e), t = i[0], a = i[1], n = (0, _arcs.findArcUnderCursor)(Ue.left + ri, Ue.top + oi, di, li, vi, t, a);
        return n ? ai.find(function(e) {
            return e.id === n.id;
        }) : null;
    }, hi = (0, _tooltip.useTooltip)(), Li = hi.showTooltipFromEvent, bi = hi.hideTooltip, Ai = function(e) {
        var i = gi(e);
        i ? (null == ze || ze(i, e), si(i.id), Li((0, _react.createElement)(Ge, {
            datum: i
        }), e)) : (si(null), bi());
    };
    return (0, _jsxRuntime.jsx)("canvas", {
        ref: (0, _core.mergeRefs)(Ke, Je),
        width: _e * U,
        height: ei * U,
        style: {
            width: _e,
            height: ei,
            cursor: Ve ? "auto" : "normal"
        },
        onMouseEnter: Ve ? Ai : void 0,
        onMouseMove: Ve ? Ai : void 0,
        onMouseLeave: Ve ? function() {
            bi();
        } : void 0,
        onClick: Ve ? function(e) {
            if (Be) {
                var i = gi(e);
                i && Be(i, e);
            }
        } : void 0,
        role: qe
    });
}, re = (0, _react.forwardRef)(function(e, i) {
    var t = e.isInteractive, a = void 0 === t ? P.isInteractive : t, n = e.theme, r = e.renderWrapper, o = F(e, ae);
    return (0, _jsxRuntime.jsx)((0, _core.Container), {
        isInteractive: a,
        renderWrapper: r,
        theme: n,
        children: (0, _jsxRuntime.jsx)(ne, E({
            isInteractive: a
        }, o, {
            forwardedRef: i
        }))
    });
}), oe = [
    "defaultWidth",
    "defaultHeight",
    "onResize",
    "debounceResize"
], de = (0, _react.forwardRef)(function(e, i) {
    var t = e.defaultWidth, a = e.defaultHeight, n = e.onResize, r = e.debounceResize, o = F(e, oe);
    return (0, _jsxRuntime.jsx)((0, _core.ResponsiveWrapper), {
        defaultWidth: t,
        defaultHeight: a,
        onResize: n,
        debounceResize: r,
        children: function(e) {
            var t = e.width, a = e.height;
            return (0, _jsxRuntime.jsx)(re, E({
                width: t,
                height: a
            }, o, {
                ref: i
            }));
        }
    });
});

},{"react":"6uln9","@nivo/core":"3e9EB","@nivo/arcs":"4piK7","@nivo/legends":"kxw7P","react/jsx-runtime":"gaGEj","d3-shape":"ba4g6","@nivo/colors":"kpdUa","@nivo/tooltip":"1CuTy","@nivo/theming":"kiBiP","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4piK7":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ArcLabelComponent", ()=>F);
parcelHelpers.export(exports, "ArcLabelsLayer", ()=>q);
parcelHelpers.export(exports, "ArcLine", ()=>en);
parcelHelpers.export(exports, "ArcLinkLabelComponent", ()=>nn);
parcelHelpers.export(exports, "ArcLinkLabelsLayer", ()=>Y);
parcelHelpers.export(exports, "ArcShape", ()=>rn);
parcelHelpers.export(exports, "ArcsLayer", ()=>un);
parcelHelpers.export(exports, "arcTransitionModeById", ()=>W);
parcelHelpers.export(exports, "arcTransitionModes", ()=>T);
parcelHelpers.export(exports, "computeArcBoundingBox", ()=>sn);
parcelHelpers.export(exports, "computeArcCenter", ()=>w);
parcelHelpers.export(exports, "computeArcLink", ()=>K);
parcelHelpers.export(exports, "computeArcLinkTextAnchor", ()=>J);
parcelHelpers.export(exports, "drawCanvasArcLabels", ()=>z);
parcelHelpers.export(exports, "drawCanvasArcLinkLabels", ()=>Z);
parcelHelpers.export(exports, "findArcUnderCursor", ()=>dn);
parcelHelpers.export(exports, "interpolateArc", ()=>an);
parcelHelpers.export(exports, "interpolateArcCenter", ()=>B);
parcelHelpers.export(exports, "isCursorInRing", ()=>ln);
parcelHelpers.export(exports, "useAnimatedArc", ()=>cn);
parcelHelpers.export(exports, "useArcCenters", ()=>G);
parcelHelpers.export(exports, "useArcCentersTransition", ()=>S);
parcelHelpers.export(exports, "useArcGenerator", ()=>fn);
parcelHelpers.export(exports, "useArcLabels", ()=>D);
parcelHelpers.export(exports, "useArcLinkLabels", ()=>_);
parcelHelpers.export(exports, "useArcLinkLabelsTransition", ()=>X);
parcelHelpers.export(exports, "useArcLinks", ()=>$);
parcelHelpers.export(exports, "useArcTransitionMode", ()=>j);
parcelHelpers.export(exports, "useArcsTransition", ()=>on);
var _web = require("@react-spring/web");
var _theming = require("@nivo/theming");
var _text = require("@nivo/text");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _core = require("@nivo/core");
var _colors = require("@nivo/colors");
var _d3Shape = require("d3-shape");
function b() {
    return b = Object.assign ? Object.assign.bind() : function(n) {
        for(var t = 1; t < arguments.length; t++){
            var e = arguments[t];
            for(var r in e)({}).hasOwnProperty.call(e, r) && (n[r] = e[r]);
        }
        return n;
    }, b.apply(null, arguments);
}
var L = {
    pointerEvents: "none"
}, P = function(t) {
    var e = t.label, r = t.style, o = (0, _theming.useTheme)();
    return (0, _jsxRuntime.jsx)((0, _web.animated).g, {
        transform: r.transform,
        opacity: r.progress,
        style: L,
        children: (0, _jsxRuntime.jsx)((0, _text.Text), {
            textAnchor: "middle",
            dominantBaseline: "central",
            style: b({}, o.labels.text, {
                fill: r.textColor
            }),
            children: e
        })
    });
}, O = function(n) {
    var t = n % (2 * Math.PI);
    return t < 0 && (t += 2 * Math.PI), t;
}, E = function(n, t) {
    return n.filter(function(n) {
        return Math.abs((0, _core.radiansToDegrees)(n.arc.endAngle - n.arc.startAngle)) >= t;
    });
}, I = function(n, t, e, r, i) {
    return [
        "A",
        n,
        n,
        0,
        t,
        e,
        r,
        i
    ].join(" ");
}, T = [
    "startAngle",
    "middleAngle",
    "endAngle",
    "innerRadius",
    "centerRadius",
    "outerRadius",
    "pushIn",
    "pushOut"
], W = {
    startAngle: {
        enter: function(n) {
            return b({}, n, {
                endAngle: n.startAngle
            });
        },
        update: function(n) {
            return n;
        },
        leave: function(n) {
            return b({}, n, {
                startAngle: n.endAngle
            });
        }
    },
    middleAngle: {
        enter: function(n) {
            var t = n.startAngle + (n.endAngle - n.startAngle) / 2;
            return b({}, n, {
                startAngle: t,
                endAngle: t
            });
        },
        update: function(n) {
            return n;
        },
        leave: function(n) {
            var t = n.startAngle + (n.endAngle - n.startAngle) / 2;
            return b({}, n, {
                startAngle: t,
                endAngle: t
            });
        }
    },
    endAngle: {
        enter: function(n) {
            return b({}, n, {
                startAngle: n.endAngle
            });
        },
        update: function(n) {
            return n;
        },
        leave: function(n) {
            return b({}, n, {
                endAngle: n.startAngle
            });
        }
    },
    innerRadius: {
        enter: function(n) {
            return b({}, n, {
                outerRadius: n.innerRadius
            });
        },
        update: function(n) {
            return n;
        },
        leave: function(n) {
            return b({}, n, {
                innerRadius: n.outerRadius
            });
        }
    },
    centerRadius: {
        enter: function(n) {
            var t = n.innerRadius + (n.outerRadius - n.innerRadius) / 2;
            return b({}, n, {
                innerRadius: t,
                outerRadius: t
            });
        },
        update: function(n) {
            return n;
        },
        leave: function(n) {
            var t = n.innerRadius + (n.outerRadius - n.innerRadius) / 2;
            return b({}, n, {
                innerRadius: t,
                outerRadius: t
            });
        }
    },
    outerRadius: {
        enter: function(n) {
            return b({}, n, {
                innerRadius: n.outerRadius
            });
        },
        update: function(n) {
            return n;
        },
        leave: function(n) {
            return b({}, n, {
                outerRadius: n.innerRadius
            });
        }
    },
    pushIn: {
        enter: function(n) {
            return b({}, n, {
                innerRadius: n.innerRadius - n.outerRadius + n.innerRadius,
                outerRadius: n.innerRadius
            });
        },
        update: function(n) {
            return n;
        },
        leave: function(n) {
            return b({}, n, {
                innerRadius: n.outerRadius,
                outerRadius: n.outerRadius + n.outerRadius - n.innerRadius
            });
        }
    },
    pushOut: {
        enter: function(n) {
            return b({}, n, {
                innerRadius: n.outerRadius,
                outerRadius: n.outerRadius + n.outerRadius - n.innerRadius
            });
        },
        update: function(n) {
            return n;
        },
        leave: function(n) {
            return b({}, n, {
                innerRadius: n.innerRadius - n.outerRadius + n.innerRadius,
                outerRadius: n.innerRadius
            });
        }
    }
}, j = function(n, t) {
    return (0, _react.useMemo)(function() {
        var e = W[n];
        return {
            enter: function(n) {
                return b({
                    progress: 0
                }, e.enter(n.arc), t ? t.enter(n) : {});
            },
            update: function(n) {
                return b({
                    progress: 1
                }, e.update(n.arc), t ? t.update(n) : {});
            },
            leave: function(n) {
                return b({
                    progress: 0
                }, e.leave(n.arc), t ? t.leave(n) : {});
            }
        };
    }, [
        n,
        t
    ]);
}, w = function(n, t) {
    var e = (0, _core.midAngle)(n) - Math.PI / 2, r = n.innerRadius + (n.outerRadius - n.innerRadius) * t;
    return (0, _core.positionFromAngle)(e, r);
}, B = function(n) {
    return function(e, r, i, a) {
        return (0, _web.to)([
            e,
            r,
            i,
            a
        ], function(t, e, r, i) {
            var a = w({
                startAngle: t,
                endAngle: e,
                innerRadius: r,
                outerRadius: i
            }, n);
            return "translate(" + a.x + "," + a.y + ")";
        });
    };
}, S = function(n, t, r, i) {
    void 0 === t && (t = .5), void 0 === r && (r = "innerRadius");
    var a = (0, _core.useMotionConfig)(), o = a.animate, u = a.config, s = j(r, i);
    return {
        transition: (0, _web.useTransition)(n, {
            keys: function(n) {
                return n.id;
            },
            initial: s.update,
            from: s.enter,
            enter: s.update,
            update: s.update,
            leave: s.leave,
            config: u,
            immediate: !o
        }),
        interpolate: B(t)
    };
}, G = function(n) {
    var t = n.data, e = n.offset, r = void 0 === e ? .5 : e, i = n.skipAngle, a = void 0 === i ? 0 : i, o = n.computeExtraProps, u = void 0 === o ? function() {
        return {};
    } : o;
    return (0, _react.useMemo)(function() {
        return E(t, a).map(function(n) {
            var t = w(n.arc, r);
            return b({}, u(n), {
                x: t.x,
                y: t.y,
                data: n
            });
        });
    }, [
        t,
        r,
        a,
        u
    ]);
}, q = function(n) {
    var t = n.center, e = n.data, r = n.transitionMode, a = n.label, o = n.radiusOffset, u = n.skipAngle, l = n.skipRadius, f = n.textColor, p = n.component, h = void 0 === p ? P : p, v = (0, _core.usePropertyAccessor)(a), R = (0, _theming.useTheme)(), x = (0, _colors.useInheritedColor)(f, R), m = (0, _react.useMemo)(function() {
        return e.filter(function(n) {
            var t = Math.abs((0, _core.radiansToDegrees)(n.arc.endAngle - n.arc.startAngle)), e = Math.abs(n.arc.outerRadius - n.arc.innerRadius);
            return t >= u && e >= l;
        });
    }, [
        e,
        u,
        l
    ]), y = S(m, o, r), k = y.transition, C = y.interpolate, b = h;
    return (0, _jsxRuntime.jsx)("g", {
        transform: "translate(" + t[0] + "," + t[1] + ")",
        children: k(function(n, t) {
            return (0, _react.createElement)(b, {
                key: t.id,
                datum: t,
                label: v(t),
                style: {
                    progress: n.progress,
                    transform: C(n.startAngle, n.endAngle, n.innerRadius, n.outerRadius),
                    textColor: x(t)
                }
            });
        })
    });
}, z = function(n, t, e) {
    (0, _text.setCanvasFont)(n, e.labels.text), n.textAlign = "center", n.textBaseline = "middle", t.forEach(function(t) {
        (0, _text.drawCanvasText)(n, b({}, e.labels.text, {
            fill: t.textColor
        }), String(t.label), t.x, t.y);
    });
}, D = function(n) {
    var t = n.data, e = n.offset, r = n.skipAngle, a = n.label, o = n.textColor, u = (0, _core.usePropertyAccessor)(a), s = (0, _theming.useTheme)(), l = (0, _colors.useInheritedColor)(o, s), d = (0, _react.useCallback)(function(n) {
        return {
            label: u(n),
            textColor: l(n)
        };
    }, [
        u,
        l
    ]);
    return G({
        data: t,
        offset: e,
        skipAngle: r,
        computeExtraProps: d
    });
}, F = P, H = function(t) {
    var e = t.label, r = t.style, o = (0, _theming.useTheme)();
    return (0, _jsxRuntime.jsxs)((0, _web.animated).g, {
        opacity: r.opacity,
        children: [
            (0, _jsxRuntime.jsx)((0, _web.animated).path, {
                fill: "none",
                stroke: r.linkColor,
                strokeWidth: r.thickness,
                d: r.path
            }),
            (0, _jsxRuntime.jsx)((0, _text.Text), {
                transform: r.textPosition,
                textAnchor: r.textAnchor,
                dominantBaseline: "central",
                style: b({}, o.labels.text, {
                    fill: r.textColor
                }),
                children: e
            })
        ]
    });
}, J = function(n) {
    var t = O(n.startAngle + (n.endAngle - n.startAngle) / 2 - Math.PI / 2);
    return t < Math.PI / 2 || t > 1.5 * Math.PI ? "start" : "end";
}, K = function(n, t, e, r) {
    var i, a, o = O(n.startAngle + (n.endAngle - n.startAngle) / 2 - Math.PI / 2), u = (0, _core.positionFromAngle)(o, n.outerRadius + t), s = (0, _core.positionFromAngle)(o, n.outerRadius + t + e);
    return o < Math.PI / 2 || o > 1.5 * Math.PI ? (i = "after", a = {
        x: s.x + r,
        y: s.y
    }) : (i = "before", a = {
        x: s.x - r,
        y: s.y
    }), {
        side: i,
        points: [
            u,
            s,
            a
        ]
    };
}, N = (0, _d3Shape.line)().x(function(n) {
    return n.x;
}).y(function(n) {
    return n.y;
}), Q = function(n, e, r, i, a, o, u) {
    return (0, _web.to)([
        n,
        e,
        r,
        i,
        a,
        o,
        u
    ], function(n, t, e, r, i, a, o) {
        var u = K({
            startAngle: n,
            endAngle: t,
            innerRadius: e,
            outerRadius: r
        }, i, a, o).points;
        return N(u);
    });
}, U = function(n, e, r, i) {
    return (0, _web.to)([
        n,
        e,
        r,
        i
    ], function(n, t, e, r) {
        return J({
            startAngle: n,
            endAngle: t,
            innerRadius: e,
            outerRadius: r
        });
    });
}, V = function(n, e, r, i, a, o, u, s) {
    return (0, _web.to)([
        n,
        e,
        r,
        i,
        a,
        o,
        u,
        s
    ], function(n, t, e, r, i, a, o, u) {
        var s = K({
            startAngle: n,
            endAngle: t,
            innerRadius: e,
            outerRadius: r
        }, i, a, o), l = s.points, d = s.side, c = l[2];
        return "before" === d ? c.x -= u : c.x += u, "translate(" + c.x + "," + c.y + ")";
    });
}, X = function(n) {
    var t = n.data, r = n.offset, a = void 0 === r ? 0 : r, o = n.diagonalLength, u = n.straightLength, s = n.skipAngle, l = void 0 === s ? 0 : s, c = n.textOffset, f = n.linkColor, g = n.textColor, p = (0, _core.useMotionConfig)(), h = p.animate, v = p.config, A = (0, _theming.useTheme)(), x = (0, _colors.useInheritedColor)(f, A), m = (0, _colors.useInheritedColor)(g, A), y = function(n, t) {
        return (0, _react.useMemo)(function() {
            return E(n, t);
        }, [
            n,
            t
        ]);
    }(t, l), k = function(n) {
        var t = n.offset, e = n.diagonalLength, r = n.straightLength, i = n.textOffset, a = n.getLinkColor, o = n.getTextColor;
        return (0, _react.useMemo)(function() {
            return {
                enter: function(n) {
                    return {
                        startAngle: n.arc.startAngle,
                        endAngle: n.arc.endAngle,
                        innerRadius: n.arc.innerRadius,
                        outerRadius: n.arc.outerRadius,
                        offset: t,
                        diagonalLength: 0,
                        straightLength: 0,
                        textOffset: i,
                        linkColor: a(n),
                        textColor: o(n),
                        opacity: 0
                    };
                },
                update: function(n) {
                    return {
                        startAngle: n.arc.startAngle,
                        endAngle: n.arc.endAngle,
                        innerRadius: n.arc.innerRadius,
                        outerRadius: n.arc.outerRadius,
                        offset: t,
                        diagonalLength: e,
                        straightLength: r,
                        textOffset: i,
                        linkColor: a(n),
                        textColor: o(n),
                        opacity: 1
                    };
                },
                leave: function(n) {
                    return {
                        startAngle: n.arc.startAngle,
                        endAngle: n.arc.endAngle,
                        innerRadius: n.arc.innerRadius,
                        outerRadius: n.arc.outerRadius,
                        offset: t,
                        diagonalLength: 0,
                        straightLength: 0,
                        textOffset: i,
                        linkColor: a(n),
                        textColor: o(n),
                        opacity: 0
                    };
                }
            };
        }, [
            e,
            r,
            i,
            a,
            o,
            t
        ]);
    }({
        offset: a,
        diagonalLength: o,
        straightLength: u,
        textOffset: c,
        getLinkColor: x,
        getTextColor: m
    });
    return {
        transition: (0, _web.useTransition)(y, {
            keys: function(n) {
                return n.id;
            },
            initial: k.update,
            from: k.enter,
            enter: k.update,
            update: k.update,
            leave: k.leave,
            config: v,
            immediate: !h
        }),
        interpolateLink: Q,
        interpolateTextAnchor: U,
        interpolateTextPosition: V
    };
}, Y = function(n) {
    var t = n.center, e = n.data, r = n.label, i = n.skipAngle, a = n.offset, o = n.diagonalLength, u = n.straightLength, l = n.strokeWidth, d = n.textOffset, f = n.textColor, g = n.linkColor, p = n.component, h = void 0 === p ? H : p, v = (0, _core.usePropertyAccessor)(r), R = X({
        data: e,
        skipAngle: i,
        offset: a,
        diagonalLength: o,
        straightLength: u,
        textOffset: d,
        linkColor: g,
        textColor: f
    }), x = R.transition, m = R.interpolateLink, y = R.interpolateTextAnchor, M = R.interpolateTextPosition, k = h;
    return (0, _jsxRuntime.jsx)("g", {
        transform: "translate(" + t[0] + "," + t[1] + ")",
        children: x(function(n, t) {
            return (0, _react.createElement)(k, {
                key: t.id,
                datum: t,
                label: v(t),
                style: b({}, n, {
                    thickness: l,
                    path: m(n.startAngle, n.endAngle, n.innerRadius, n.outerRadius, n.offset, n.diagonalLength, n.straightLength),
                    textAnchor: y(n.startAngle, n.endAngle, n.innerRadius, n.outerRadius),
                    textPosition: M(n.startAngle, n.endAngle, n.innerRadius, n.outerRadius, n.offset, n.diagonalLength, n.straightLength, n.textOffset)
                })
            });
        })
    });
}, Z = function(n, t, e, r) {
    n.textBaseline = "middle", (0, _text.setCanvasFont)(n, e.labels.text), t.forEach(function(t) {
        n.textAlign = (0, _core.textPropsByEngine).canvas.align[t.textAnchor], (0, _text.drawCanvasText)(n, b({}, e.labels.text, {
            fill: t.textColor
        }), String(t.label), t.x, t.y), n.beginPath(), n.strokeStyle = t.linkColor, n.lineWidth = r, t.points.forEach(function(t, e) {
            0 === e ? n.moveTo(t.x, t.y) : n.lineTo(t.x, t.y);
        }), n.stroke();
    });
}, $ = function(n) {
    var t = n.data, e = n.skipAngle, r = void 0 === e ? 0 : e, i = n.offset, a = void 0 === i ? .5 : i, o = n.diagonalLength, u = n.straightLength, s = n.computeExtraProps, l = void 0 === s ? function() {
        return {};
    } : s, c = (0, _react.useMemo)(function() {
        return t.filter(function(n) {
            return Math.abs((0, _core.radiansToDegrees)(n.arc.endAngle - n.arc.startAngle)) >= r;
        }).map(function(n) {
            return b({}, K(n.arc, a, o, u), {
                data: n
            });
        });
    }, [
        t,
        r,
        a,
        o,
        u
    ]);
    return (0, _react.useMemo)(function() {
        return c.map(function(n) {
            return b({}, l(n), n);
        });
    }, [
        c,
        l
    ]);
}, _ = function(n) {
    var t = n.data, e = n.skipAngle, r = n.offset, a = n.diagonalLength, o = n.straightLength, u = n.textOffset, s = void 0 === u ? 0 : u, l = n.label, d = n.linkColor, c = n.textColor, g = (0, _core.usePropertyAccessor)(l), p = (0, _theming.useTheme)(), h = (0, _colors.useInheritedColor)(d, p), v = (0, _colors.useInheritedColor)(c, p), R = (0, _react.useCallback)(function(n) {
        var t, e = {
            x: n.points[2].x,
            y: n.points[2].y
        };
        return "before" === n.side ? (e.x -= s, t = "end") : (e.x += s, t = "start"), b({}, e, {
            label: g(n.data),
            linkColor: h(n.data),
            textAnchor: t,
            textColor: v(n.data)
        });
    }, [
        g,
        h,
        v,
        s
    ]);
    return $({
        data: t,
        skipAngle: e,
        offset: r,
        diagonalLength: a,
        straightLength: o,
        computeExtraProps: R
    });
}, nn = H, tn = [
    "animated"
], en = function(e) {
    var r = e.animated, i = function(n, t) {
        if (null == n) return {};
        var e = {};
        for(var r in n)if (({}).hasOwnProperty.call(n, r)) {
            if (-1 !== t.indexOf(r)) continue;
            e[r] = n[r];
        }
        return e;
    }(e, tn);
    return (0, _jsxRuntime.jsx)((0, _web.animated).path, b({
        d: (0, _web.to)([
            r.radius,
            r.startAngle,
            r.endAngle
        ], function(n, t, e) {
            return function(n, t, e) {
                var r = Math.min(t, e), i = Math.max(t, e), a = (0, _core.positionFromAngle)((0, _core.degreesToRadians)(i), n), o = (0, _core.positionFromAngle)((0, _core.degreesToRadians)(r), n);
                if (i - r >= 360) {
                    var u = (0, _core.positionFromAngle)((0, _core.degreesToRadians)(r + 180), n);
                    return [
                        "M " + a.x + " " + a.y,
                        I(n, 1, 1, u.x, u.y),
                        "M " + a.x + " " + a.y,
                        I(n, 1, 0, u.x, u.y)
                    ].join(" ");
                }
                var s = i - r <= 180 ? 0 : 1;
                return [
                    "M " + a.x + " " + a.y,
                    I(n, s, 0, o.x, o.y)
                ].join(" ");
            }(n, t, e);
        })
    }, i));
}, rn = function(t) {
    var e = t.datum, r = t.style, i = t.onClick, a = t.onMouseEnter, o = t.onMouseMove, u = t.onMouseLeave, l = (0, _react.useCallback)(function(n) {
        return null == i ? void 0 : i(e, n);
    }, [
        i,
        e
    ]), d = (0, _react.useCallback)(function(n) {
        return null == a ? void 0 : a(e, n);
    }, [
        a,
        e
    ]), c = (0, _react.useCallback)(function(n) {
        return null == o ? void 0 : o(e, n);
    }, [
        o,
        e
    ]), g = (0, _react.useCallback)(function(n) {
        return null == u ? void 0 : u(e, n);
    }, [
        u,
        e
    ]);
    return (0, _jsxRuntime.jsx)((0, _web.animated).path, {
        d: r.path,
        opacity: r.opacity,
        fill: e.fill || r.color,
        stroke: r.borderColor,
        strokeWidth: r.borderWidth,
        onClick: i ? l : void 0,
        onMouseEnter: a ? d : void 0,
        onMouseMove: o ? c : void 0,
        onMouseLeave: u ? g : void 0,
        "data-testid": "arc." + e.id
    });
}, an = function(n, e, r, i, a) {
    return (0, _web.to)([
        n,
        e,
        r,
        i
    ], function(n, t, e, r) {
        return a({
            startAngle: n,
            endAngle: t,
            innerRadius: Math.max(0, e),
            outerRadius: Math.max(0, r)
        });
    });
}, on = function(n, t, r) {
    void 0 === t && (t = "innerRadius");
    var i = (0, _core.useMotionConfig)(), a = i.animate, o = i.config, u = j(t, r);
    return {
        transition: (0, _web.useTransition)(n, {
            keys: function(n) {
                return n.id;
            },
            initial: u.update,
            from: u.enter,
            enter: u.update,
            update: u.update,
            leave: u.leave,
            config: o,
            immediate: !a
        }),
        interpolate: an
    };
}, un = function(n) {
    var t = n.center, e = n.data, r = n.arcGenerator, a = n.borderWidth, o = n.borderColor, u = n.onClick, l = n.onMouseEnter, d = n.onMouseMove, f = n.onMouseLeave, g = n.transitionMode, p = n.component, h = void 0 === p ? rn : p, v = (0, _theming.useTheme)(), R = (0, _colors.useInheritedColor)(o, v), A = on(e, g, {
        enter: function(n) {
            return {
                opacity: 0,
                color: n.color,
                borderColor: R(n)
            };
        },
        update: function(n) {
            return {
                opacity: 1,
                color: n.color,
                borderColor: R(n)
            };
        },
        leave: function(n) {
            return {
                opacity: 0,
                color: n.color,
                borderColor: R(n)
            };
        }
    }), x = A.transition, m = A.interpolate, y = h;
    return (0, _jsxRuntime.jsx)("g", {
        transform: "translate(" + t[0] + "," + t[1] + ")",
        children: x(function(n, t) {
            return (0, _react.createElement)(y, {
                key: t.id,
                datum: t,
                style: b({}, n, {
                    borderWidth: a,
                    path: m(n.startAngle, n.endAngle, n.innerRadius, n.outerRadius, r)
                }),
                onClick: u,
                onMouseEnter: l,
                onMouseMove: d,
                onMouseLeave: f
            });
        })
    });
}, sn = function(n, t, e, r, i, a) {
    void 0 === a && (a = !0);
    var o = [], u = (0, _core.positionFromAngle)((0, _core.degreesToRadians)(r), e);
    o.push([
        u.x,
        u.y
    ]);
    var s = (0, _core.positionFromAngle)((0, _core.degreesToRadians)(i), e);
    o.push([
        s.x,
        s.y
    ]);
    for(var l = Math.round(Math.min(r, i)); l <= Math.round(Math.max(r, i)); l++)if (l % 90 == 0) {
        var d = (0, _core.positionFromAngle)((0, _core.degreesToRadians)(l), e);
        o.push([
            d.x,
            d.y
        ]);
    }
    o = o.map(function(e) {
        var r = e[0], i = e[1];
        return [
            n + r,
            t + i
        ];
    }), a && o.push([
        n,
        t
    ]);
    var c = o.map(function(n) {
        return n[0];
    }), f = o.map(function(n) {
        return n[1];
    }), g = Math.min.apply(Math, c), v = Math.max.apply(Math, c), R = Math.min.apply(Math, f);
    return {
        points: o,
        x: g,
        y: R,
        width: v - g,
        height: Math.max.apply(Math, f) - R
    };
}, ln = function(n, t, e, r, i, a) {
    var o = (0, _core.getDistance)(i, a, n, t);
    return o < e && o > r;
}, dn = function(n, t, e, r, i, a, o) {
    if (ln(n, t, e, r, a, o)) {
        var u = (0, _core.getAngle)(a, o, n, t);
        return i.find(function(n) {
            var t = n.startAngle, e = n.endAngle;
            return u >= t && u < e;
        });
    }
}, cn = function(n, t) {
    var e = (0, _core.useMotionConfig)(), i = e.animate, a = e.config, o = (0, _web.useSpring)({
        startAngle: n.arc.startAngle,
        endAngle: n.arc.endAngle,
        innerRadius: n.arc.innerRadius,
        outerRadius: n.arc.outerRadius,
        config: a,
        immediate: !i
    });
    return b({}, o, {
        path: an(o.startAngle, o.endAngle, o.innerRadius, o.outerRadius, t)
    });
}, fn = function(n) {
    var t = void 0 === n ? {} : n, e = t.cornerRadius, r = void 0 === e ? 0 : e, i = t.padAngle, a = void 0 === i ? 0 : i;
    return (0, _react.useMemo)(function() {
        return (0, _d3Shape.arc)().innerRadius(function(n) {
            return n.innerRadius;
        }).outerRadius(function(n) {
            return n.outerRadius;
        }).cornerRadius(r).padAngle(a);
    }, [
        r,
        a
    ]);
};

},{"@react-spring/web":"39JSM","@nivo/theming":"kiBiP","@nivo/text":"5EjSJ","react/jsx-runtime":"gaGEj","react":"6uln9","@nivo/core":"3e9EB","@nivo/colors":"kpdUa","d3-shape":"ba4g6","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1L0S8":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _colors = require("../../constants/colors");
var _secondaryLoader = require("../general/SecondaryLoader");
var _secondaryLoaderDefault = parcelHelpers.interopDefault(_secondaryLoader);
const deltaDown = require("9a19f019c7d1a4e1");
const deltaUp = require("27bb0db2a5b74bbe");
const AveragesCard = (props)=>(0, _react.jsx)("div", {
        className: containerStyle
    }, (0, _react.jsx)("div", {
        className: "header-container ac-analytics-averages-card"
    }, (0, _react.jsx)("h5", null, "Averages:"), (0, _react.jsx)("p", null, props.comparedDateRangeLabel)), props.isLoading ? (0, _react.jsx)("div", {
        className: "loader-container"
    }, (0, _react.jsx)((0, _secondaryLoaderDefault.default), null)) : props.items?.map((item, i)=>(0, _react.jsx)("div", {
            key: i,
            className: "average-item"
        }, (0, _react.jsx)("p", {
            className: "item-label"
        }, item.title), (0, _react.jsx)("div", {
            className: "item-values-container"
        }, (0, _react.jsx)("p", {
            className: "item-value"
        }, item.value), (0, _react.jsx)("img", {
            src: item.deltaValue > 0 ? deltaUp : deltaDown
        }), props.showValue && (0, _react.jsx)("p", {
            className: "item-delta"
        }, item.deltaValue), props.showValue && props.showPercentage && (0, _react.jsx)("div", {
            className: "item-separator"
        }), props.showPercentage && (0, _react.jsx)("p", {
            className: "item-delta"
        }, Math.round(Math.abs(item.deltaPercentage)), "%")))));
const containerStyle = /*#__PURE__*/ (0, _css.css)("height:80px;width:100%;font-family:Muli;border:1px solid #CBCCD2;box-sizing:border-box;border-radius:8px;padding:0 32px;background:white;display:flex;align-items:center;margin-bottom:128px;.header-container{flex:1;h5{font-weight:normal;font-size:18px;line-height:24px;}p{font-size:12px;line-height:16px;color:", (0, _colors.color_text_light), ";}}.average-item{flex:1;.item-label{font-size:14px;line-height:16px;letter-spacing:0.1em;text-transform:uppercase;color:", (0, _colors.color_text_light), ";}.item-values-container{display:flex;align-items:center;img{margin-left:8px;margin-right:4px;}.item-value{font-size:18px;line-height:24px;}.item-delta{color:", (0, _colors.color_text_light), ";font-size:14px;line-height:20px;}.item-separator{height:16px;width:1px;background :", (0, _colors.color_text_light), ";margin:0 8px;}}}.loader-container{display:flex;flex:1;align-items:center;.spinner>div{background:", (0, _colors.color_colors_ocean), ";}}", "");
exports.default = AveragesCard;

},{"@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","../../constants/colors":"1p3OR","../general/SecondaryLoader":"7zJiF","9a19f019c7d1a4e1":"3WzsL","27bb0db2a5b74bbe":"lBKA8","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3WzsL":[function(require,module,exports) {
module.exports = require("895bfeeef83b0f5a").getBundleURL("kVLro") + require("ff813d6d1867731f").resolve("gjbWf");

},{"895bfeeef83b0f5a":"c7Tr5","ff813d6d1867731f":"fyJL2"}],"lBKA8":[function(require,module,exports) {
module.exports = require("392291f6d1b37989").getBundleURL("kVLro") + require("1febad82060870a").resolve("cxCCA");

},{"392291f6d1b37989":"c7Tr5","1febad82060870a":"fyJL2"}],"gcRsF":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _contentAnalyticsCharts = require("./ContentAnalyticsCharts");
var _contentAnalyticsChartsDefault = parcelHelpers.interopDefault(_contentAnalyticsCharts);
class ContentInteractionsCharts extends (0, _reactDefault.default).Component {
    componentDidMount() {
        this.loadChartData();
    }
    componentDidUpdate(previousProps) {
        if (previousProps.interval !== this.props.interval || JSON.stringify(previousProps.filter) != JSON.stringify(this.props.filter)) this.loadChartData();
    }
    async loadChartData() {
        this.setState({
            ...this.state,
            isLoadingHistograms: true
        });
        this.props.stateContainer.loadPrimaryBreakdown({
            applicationId: this.props.applicationId,
            contentId: this.props.contentId
        }, this.props.filter, this.props.stateContainer.state.currentBreakdown);
        this.props.stateContainer.loadSecondaryBreakdown({
            applicationId: this.props.applicationId,
            contentId: this.props.contentId
        }, this.props.filter, this.props.stateContainer.state.currentBreakdown);
        await this.props.stateContainer.loadPrimaryHistogram({
            applicationId: this.props.applicationId,
            contentId: this.props.contentId
        }, this.props.innerInterval, this.props.filter);
        await this.props.stateContainer.loadSecondaryHistogram({
            applicationId: this.props.applicationId,
            contentId: this.props.contentId
        }, this.props.innerInterval, this.props.filter);
        await this.props.stateContainer.getAverages({
            applicationId: this.props.applicationId,
            contentId: this.props.contentId
        }, this.props.filter);
    }
    render() {
        return (0, _react.jsx)((0, _contentAnalyticsChartsDefault.default), {
            applicationId: this.props.applicationId,
            contentId: this.props.contentId,
            filter: this.props.filter,
            innerInterval: this.props.innerInterval,
            interval: this.props.interval,
            dataType: "Interactions",
            stateContainer: this.props.stateContainer,
            showSecondary: this.props.stateContainer.state.currentDisplayOption?.toLowerCase()?.indexOf("session") > -1,
            showPrimary: this.props.stateContainer.state.currentDisplayOption?.toLowerCase()?.indexOf("interactions") > -1,
            secondaryDataName: "Sessions",
            primaryDataName: "Interactions"
        });
    }
}
exports.default = ContentInteractionsCharts;

},{"@emotion/react":"djZKr","react":"6uln9","./ContentAnalyticsCharts":"jqtRW","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"d2UIf":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _secondaryLoader = require("../../../components/general/SecondaryLoader");
var _secondaryLoaderDefault = parcelHelpers.interopDefault(_secondaryLoader);
var _colors = require("../../../constants/colors");
var _analyticsSelectField = require("../../../components/analytics/AnalyticsSelectField");
var _analyticsSelectFieldDefault = parcelHelpers.interopDefault(_analyticsSelectField);
var _totalCard = require("../../../components/charts/TotalCard");
var _totalCardDefault = parcelHelpers.interopDefault(_totalCard);
class ContentStatistics extends (0, _reactDefault.default).Component {
    componentWillMount() {
        this.loadChartData();
    }
    componentDidUpdate(previousProps) {
        if (previousProps.interval !== this.props.interval || JSON.stringify(previousProps.filter) != JSON.stringify(this.props.filter)) this.loadChartData();
    }
    loadChartData() {
        const { applicationId, contentId, filter } = this.props;
        this.props.stateContainer.loadStats(applicationId, contentId, filter);
    }
    async handleDeltaPeriodChange(option) {
        const { applicationId, contentId, filter, stateContainer } = this.props;
        await stateContainer.handleDeltaPeriodChange(option);
        this.props.stateContainer.loadStats(applicationId, contentId, filter);
    }
    render() {
        const { buildCacheKey } = this.props.stateContainer;
        const previousDates = this.props.stateContainer.getPreviousDates(this.props.filter.startDate, this.props.filter.endDate);
        const totals = this.props.stateContainer.state.contentStats.find((a)=>buildCacheKey(a.id, a.filter) == buildCacheKey(this.props.contentId, this.props.filter))?.data;
        const previousTotals = this.props.stateContainer.state.contentStats.find((a)=>buildCacheKey(a.id, a.filter) == buildCacheKey(this.props.contentId, {
                ...this.props.filter,
                startDate: previousDates.startDate,
                endDate: previousDates.endDate
            }))?.data;
        const deltaUsers = (totals?.totalUsers ?? 0) - (previousTotals?.totalUsers ?? 0);
        const deltaNewUsers = (totals?.totalNewUsers ?? 0) - (previousTotals?.totalNewUsers ?? 0);
        const deltaSessions = (totals?.totalSessions ?? 0) - (previousTotals?.totalSessions ?? 0);
        const deltaRequests = (totals?.totalRequests ?? 0) - (previousTotals?.totalRequests ?? 0);
        return (0, _react.jsx)("div", {
            className: wrapperStyle
        }, (0, _react.jsx)("div", {
            className: "options-row-container"
        }, (0, _react.jsx)("h5", null, "Totals"), (0, _react.jsx)("div", {
            className: "end-container"
        }, (0, _react.jsx)((0, _analyticsSelectFieldDefault.default), {
            label: "Compare to:",
            options: [
                "Previous Period",
                "Same Time Last Year"
            ].map((s)=>({
                    label: s,
                    value: s
                })),
            value: this.props.stateContainer.state.currentDeltaPeriod,
            onChange: (e)=>this.handleDeltaPeriodChange(e.value)
        }), (0, _react.jsx)((0, _analyticsSelectFieldDefault.default), {
            label: "Change in:",
            options: [
                "Value",
                "Percentage",
                "Value & Percentage"
            ].map((s)=>({
                    label: s,
                    value: s
                })),
            value: this.props.stateContainer.state.currentDeltaType,
            onChange: (e)=>this.props.stateContainer.handleDeltaTypeChange(e.value)
        }))), this.props.stateContainer.state.isLoadingTotals || !totals ? (0, _react.jsx)("div", {
            className: "loader-container"
        }, (0, _react.jsx)((0, _secondaryLoaderDefault.default), null)) : (0, _react.jsx)("div", {
            className: "totals-container"
        }, (0, _react.jsx)((0, _totalCardDefault.default), {
            title: "Users",
            value: totals.totalUsers,
            deltaValue: deltaUsers,
            deltaPercentage: Math.round(deltaUsers / (previousTotals?.totalUsers > 0 ? previousTotals?.totalUsers : 1) * 100),
            showPercentage: this.props.stateContainer.state.currentDeltaType.toLocaleLowerCase().indexOf("percentage") > -1,
            showValue: this.props.stateContainer.state.currentDeltaType.toLocaleLowerCase().indexOf("value") > -1
        }), (0, _react.jsx)((0, _totalCardDefault.default), {
            title: "New Users",
            value: totals.totalNewUsers ?? 0,
            deltaValue: deltaNewUsers,
            deltaPercentage: Math.round(deltaNewUsers / (previousTotals?.totalNewUsers > 0 ? previousTotals?.totalNewUsers : 1) * 100),
            showPercentage: this.props.stateContainer.state.currentDeltaType.toLocaleLowerCase().indexOf("percentage") > -1,
            showValue: this.props.stateContainer.state.currentDeltaType.toLocaleLowerCase().indexOf("value") > -1
        }), (0, _react.jsx)((0, _totalCardDefault.default), {
            title: "Sessions",
            value: totals.totalSessions,
            deltaValue: deltaSessions,
            deltaPercentage: Math.round(deltaSessions / (previousTotals?.totalSessions > 0 ? previousTotals?.totalSessions : 1) * 100),
            showPercentage: this.props.stateContainer.state.currentDeltaType.toLocaleLowerCase().indexOf("percentage") > -1,
            showValue: this.props.stateContainer.state.currentDeltaType.toLocaleLowerCase().indexOf("value") > -1
        }), (0, _react.jsx)((0, _totalCardDefault.default), {
            title: "Interactions",
            value: totals.totalRequests,
            deltaValue: deltaRequests,
            deltaPercentage: Math.round(deltaRequests / (previousTotals?.totalRequests > 0 ? previousTotals?.totalRequests : 1) * 100),
            showPercentage: this.props.stateContainer.state.currentDeltaType.toLocaleLowerCase().indexOf("percentage") > -1,
            showValue: this.props.stateContainer.state.currentDeltaType.toLocaleLowerCase().indexOf("value") > -1
        })));
    }
}
const wrapperStyle = /*#__PURE__*/ (0, _css.css)(".options-row-container{display:flex;align-items:center;margin:32px;h5{font-style:normal;font-weight:normal;font-size:18px;line-height:24px;}}.end-container{display:flex;align-items:center;margin-right:0;margin-left:auto;>div{margin-left:24px;}}.loader-container{display:flex;flex:1;align-items:center;justify-content:center;width:100%;.spinner>div{background:", (0, _colors.color_colors_ocean), ";}}.totals-container{display:flex;flex:1;margin:0 16px;}", "");
exports.default = ContentStatistics;

},{"@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","../../../components/general/SecondaryLoader":"7zJiF","../../../constants/colors":"1p3OR","../../../components/analytics/AnalyticsSelectField":"fCPWH","../../../components/charts/TotalCard":"gH7gf","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"gH7gf":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _base = require("@emotion/styled/base");
var _baseDefault = parcelHelpers.interopDefault(_base);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _colors = require("../../constants/colors");
var _conditionalTooltipWrapper = require("../general/ConditionalTooltipWrapper");
var _conditionalTooltipWrapperDefault = parcelHelpers.interopDefault(_conditionalTooltipWrapper);
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const deltaDown = require("85208582c29228e0");
const deltaUp = require("c19fe04ab225debb");
const TotalCard = (props)=>{
    const content = (0, _react.jsx)((0, _conditionalTooltipWrapperDefault.default), {
        place: "top",
        maxWidth: props.tooltipMaxWidth ? props.tooltipMaxWidth : undefined,
        showTooltip: !!props.tooltip?.length,
        text: props.tooltip
    }, (0, _react.jsx)(TotalItem, {
        highlight: props.highlight
    }, (0, _react.jsx)(ItemLabel, null, props.title), props.subtitle && (0, _react.jsx)(ItemLabel, null, props.subtitle), props.icon && (0, _react.jsx)(IconWrapper, null, (0, _react.jsx)(StyledIcon, {
        src: props.icon
    }), props.secondIcon && (0, _react.jsx)(StyledIcon, {
        src: props.secondIcon
    })), (0, _react.jsx)(ItemValuesContainer, null, Array.isArray(props.value) ? props.value.length > 1 && props.value.map((val, index)=>(0, _react.jsx)(ItemValue, {
            key: index
        }, val)) : (0, _react.jsx)(ValueWrapper, null, (0, _react.jsx)(ItemValue, {
        noIcon: !props.icon
    }, props.value, props.showValueAsPercent && "%"), props.isActionCompleteHealthCareCard ? props.hasSpanishCalls ? (0, _react.jsx)(SubValueWrapper, null, (0, _react.jsx)(ActionWrapper, null, (0, _react.jsx)(LanguageTitle, null), (0, _react.jsx)(SubValue, null, "Scheduled"), (0, _react.jsx)(SubValue, null, "Rescheduled"), (0, _react.jsx)(SubValue, null, "Cancelled"), (0, _react.jsx)(SubValue, null, "Checked Next Appt")), (0, _react.jsx)(EnglishWrapper, null, (0, _react.jsx)(LanguageTitle, null, "English"), props.subValue && (0, _react.jsx)(SubValue, null, props.subValue, " "), props.subValue2 && (0, _react.jsx)(SubValue, null, props.subValue2, " "), props.subValue3 && (0, _react.jsx)(SubValue, null, props.subValue3, " "), props.subValue4 && (0, _react.jsx)(SubValue, null, props.subValue4, " ")), (0, _react.jsx)(SpanishWrapper, null, (0, _react.jsx)(LanguageTitle, null, "Spanish"), props.subValueSpanish && (0, _react.jsx)(SubValue, null, props.subValueSpanish, " "), props.subValue2Spanish && (0, _react.jsx)(SubValue, null, props.subValue2Spanish, " "), props.subValue3Spanish && (0, _react.jsx)(SubValue, null, props.subValue3Spanish, " "), props.subValue4Spanish && (0, _react.jsx)(SubValue, null, props.subValue4Spanish, " "))) : (0, _react.jsx)(SubValueWrapper, null, (0, _react.jsx)(ActionWrapper, null, (0, _react.jsx)(LanguageTitle, null), (0, _react.jsx)(SubValue, null, "Scheduled"), (0, _react.jsx)(SubValue, null, "Rescheduled"), (0, _react.jsx)(SubValue, null, "Cancelled"), (0, _react.jsx)(SubValue, null, "Checked Next Appt")), (0, _react.jsx)(EnglishWrapper, null, (0, _react.jsx)(LanguageTitle, null), props.subValue && (0, _react.jsx)(SubValue, null, props.subValue, " "), props.subValue2 && (0, _react.jsx)(SubValue, null, props.subValue2, " "), props.subValue3 && (0, _react.jsx)(SubValue, null, props.subValue3, " "), props.subValue4 && (0, _react.jsx)(SubValue, null, props.subValue4, " "))) : (0, _react.jsx)((0, _reactDefault.default).Fragment, null, props.subValue && (0, _react.jsx)(SubValue, null, props.subValue, " "), props.subValue2 && (0, _react.jsx)(SubValue, null, props.subValue2, " "), props.subValue3 && (0, _react.jsx)(SubValue, null, props.subValue3, " "), props.subValue4 && (0, _react.jsx)(SubValue, null, props.subValue4, " "))), !isNaN(props.deltaValue) && props.deltaValue !== null && (0, _react.jsx)(DeltaImage, {
        src: props.deltaValue > 0 ? deltaUp : deltaDown
    }), !isNaN(props.deltaValue) && props.showValue && (0, _react.jsx)(ItemDelta, null, Math.abs(props.deltaValue)), !isNaN(props.deltaValue) && props.showValue && props.showPercentage && (0, _react.jsx)(ItemSeparator, null), !isNaN(props.deltaValue) && props.showPercentage && (0, _react.jsx)(ItemDelta, null, Math.abs(props.deltaPercentage), "%"))));
    return props.onClick ? (0, _react.jsx)(ButtonWrapper, {
        onClick: props.onClick
    }, (0, _react.jsx)(Container, {
        className: props.className,
        hasSpanishCalls: props.hasSpanishCalls,
        isActionCompleteHealthCareCard: props.isActionCompleteHealthCareCard
    }, content)) : (0, _react.jsx)(Container, {
        className: props.className,
        hasSpanishCalls: props.hasSpanishCalls,
        isActionCompleteHealthCareCard: props.isActionCompleteHealthCareCard
    }, content);
};
const ActionWrapper = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1xrym9217"
})({
    name: "kot5e",
    styles: "display:flex;align-items:flex-start;flex-direction:column;flex-wrap:nowrap;flex:0 0 auto;width:fit-content;min-width:fit-content;overflow:visible"
});
const Container = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1xrym9216"
})("height:96px;flex:1;font-family:Muli;border:1px solid #CBCCD2;box-sizing:border-box;border-radius:8px;padding:", (props)=>props.isActionCompleteHealthCareCard && props.hasSpanishCalls ? "0 4px" : "0 32px", ";background:white;display:flex;align-items:center;justify-content:center;margin:16px;box-shadow:0px 2px 4px rgba(50, 70, 97, 0.1);overflow:hidden;");
const TotalItem = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1xrym9215"
})("flex:1;display:flex;flex-direction:column;align-items:center;justify-content:center;text-align:center;height:100%;width:100%;gap:0px;font-weight:", (props)=>props.highlight ? "bold" : "normal", ";color:", (props)=>props.highlight ? (0, _colors.color_colors_ocean) : "inherit", ";overflow:hidden;");
const ItemLabel = /*#__PURE__*/ (0, _baseDefault.default)("p", {
    target: "e1xrym9214"
})("font-size:14px;line-height:16px;letter-spacing:0.1em;text-transform:uppercase;color:", (0, _colors.color_text_light), ";margin:0;text-align:center;");
const ItemValuesContainer = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1xrym9213"
})({
    name: "1d92hkd",
    styles: "display:flex;align-items:center;justify-content:center;flex:1;padding:0;width:100%;box-sizing:border-box;overflow:hidden"
});
const ValueWrapper = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1xrym9212"
})({
    name: "15nnl8y",
    styles: "display:flex;flex-direction:column;align-items:center;max-width:100%;overflow:hidden"
});
const ItemValue = /*#__PURE__*/ (0, _baseDefault.default)("p", {
    target: "e1xrym9211"
})("font-size:16px;margin:0;margin-bottom:", (props)=>props.noIcon ? "12px" : "0", ";text-align:center;font-weight:600;word-wrap:break-word;overflow-wrap:break-word;");
const SubValue = /*#__PURE__*/ (0, _baseDefault.default)("span", {
    target: "e1xrym9210"
})("color:", (0, _colors.color_text_light), ";font-size:12px;line-height:14px;margin-top:2px;word-wrap:break-word;overflow-wrap:break-word;");
const DeltaImage = /*#__PURE__*/ (0, _baseDefault.default)("img", {
    target: "e1xrym929"
})({
    name: "1rt0uaa",
    styles: "margin-left:8px;margin-right:4px;flex-shrink:0"
});
const ItemDelta = /*#__PURE__*/ (0, _baseDefault.default)("p", {
    target: "e1xrym928"
})("color:", (0, _colors.color_text_light), ";font-size:14px;line-height:20px;margin:0;white-space:nowrap;");
const ItemSeparator = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1xrym927"
})("height:16px;width:1px;background:", (0, _colors.color_text_light), ";margin:0 8px;");
const LanguageTitle = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1xrym926"
})({
    name: "a4mvyo",
    styles: "font-size:8px;min-height:12px;line-height:12px;white-space:nowrap;overflow:visible;margin:0;padding:0"
});
const EnglishWrapper = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1xrym925"
})({
    name: "14qk4cj",
    styles: "display:flex;flex-direction:column;flex-wrap:nowrap;flex:1;min-width:0;overflow:visible"
});
const SpanishWrapper = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1xrym924"
})({
    name: "14qk4cj",
    styles: "display:flex;flex-direction:column;flex-wrap:nowrap;flex:1;min-width:0;overflow:visible"
});
const ButtonWrapper = /*#__PURE__*/ (0, _baseDefault.default)("button", {
    target: "e1xrym923"
})({
    name: "1n9pxbq",
    styles: "background:none;border:none;padding:0;width:100%;cursor:pointer;&:hover{opacity:0.8;}&:disabled{cursor:default;opacity:1;}"
});
const SubValueWrapper = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1xrym922"
})({
    name: "120blni",
    styles: "display:flex;flex-direction:row;margin-top:-8px;padding:2px;max-width:100%;overflow:hidden;box-sizing:border-box;gap:2px"
});
const StyledIcon = /*#__PURE__*/ (0, _baseDefault.default)("img", {
    target: "e1xrym921"
})({
    name: "orbpuh",
    styles: "height:32px;width:32px;flex-shrink:0"
});
const IconWrapper = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1xrym920"
})({
    name: "lxzv0w",
    styles: "display:flex;align-items:center;flex-direction:row;justify-content:center;padding:14px 2px 0px 2px;max-width:100%"
});
exports.default = TotalCard;

},{"@emotion/styled/base":"lSuFu","@emotion/react":"djZKr","react":"6uln9","../../constants/colors":"1p3OR","../general/ConditionalTooltipWrapper":"92m0T","85208582c29228e0":"3WzsL","c19fe04ab225debb":"lBKA8","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7cwN5":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _button = require("../../general/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _colors = require("../../../constants/colors");
const filterIcon = require("9a59ee260df5765a");
const filterBlueIcon = require("c958136f0caa6363");
const FilterToggleButton = (props)=>{
    const renderFilterRight = ()=>{
        // if we have any active filters, show the number. Otherwise show the icon based on expanded state
        if (props.filterCount > 0) return (0, _react.jsx)("div", {
            className: "filter-right filter-count"
        }, (0, _react.jsx)("span", null, props.filterCount));
        else if (props.isExpanded) return (0, _react.jsx)("div", {
            className: "filter-right"
        }, (0, _react.jsx)("img", {
            src: filterBlueIcon
        }));
        else return (0, _react.jsx)("div", {
            className: "filter-right"
        }, (0, _react.jsx)("img", {
            src: filterIcon
        }));
    };
    return (0, _react.jsx)((0, _buttonDefault.default), {
        themes: [
            "white-small",
            "end-tight"
        ],
        className: "ac-analytics-filter-button",
        text: "Filter",
        onClick: props.onClick,
        additionalClasses: props.isExpanded ? expandedStyle : buttonStyle,
        rightComponent: ()=>renderFilterRight()
    });
};
const expandedStyle = /*#__PURE__*/ (0, _css.css)("background:linear-gradient(0deg, rgba(30, 126, 185, 0.07), rgba(30, 126, 185, 0.07)),#FFFFFF;border:1px solid ", (0, _colors.color_text_link), ";color:", (0, _colors.color_text_link), ";.filter-right{margin-left:8px;width:20px;img{width:16px;height:16px;}}.filter-count{border-radius:50%;color:white;display:flex;align-items:center;justify-content:center;background:", (0, _colors.color_text_link), ";width:20px;height:20px;span{font-style:normal;font-weight:600;font-size:10px;line-height:16px;}}", "");
const buttonStyle = /*#__PURE__*/ (0, _css.css)(".filter-right{margin-left:8px;width:20px;img{width:16px;height:16px;}}.filter-count{border-radius:50%;color:white;display:flex;align-items:center;justify-content:center;background:", (0, _colors.color_text_link), ";width:20px;height:20px;span{font-style:normal;font-weight:600;font-size:10px;line-height:16px;}}", "");
exports.default = FilterToggleButton;

},{"@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","../../general/Button":"6ymxN","../../../constants/colors":"1p3OR","9a59ee260df5765a":"12yk6","c958136f0caa6363":"2CYnZ","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"cKU0F":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _filterWrapper = require("./FilterWrapper");
var _filterWrapperDefault = parcelHelpers.interopDefault(_filterWrapper);
var _languageFilter = require("./LanguageFilter");
var _languageFilterDefault = parcelHelpers.interopDefault(_languageFilter);
var _colors = require("../../../constants/colors");
var _deviceTypeFilter = require("./DeviceTypeFilter");
var _deviceTypeFilterDefault = parcelHelpers.interopDefault(_deviceTypeFilter);
var _interfaceTypeFilter = require("./InterfaceTypeFilter");
var _interfaceTypeFilterDefault = parcelHelpers.interopDefault(_interfaceTypeFilter);
var _assistantFilter = require("./AssistantFilter");
var _assistantFilterDefault = parcelHelpers.interopDefault(_assistantFilter);
var _button = require("../../general/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _stylesValues = require("../../../constants/stylesValues");
var _activeFilterIndicator = require("./ActiveFilterIndicator");
var _activeFilterIndicatorDefault = parcelHelpers.interopDefault(_activeFilterIndicator);
var _languageCollectionAvatar = require("../../general/LanguageCollectionAvatar");
var _languageCollectionAvatarDefault = parcelHelpers.interopDefault(_languageCollectionAvatar);
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const clearIcon = require("4c2c0c7ffd14fdc8");
const flagIcon = require("ac17d973b834642b");
const assistantIcon = require("7f4b3c601e80cbbb");
const interfaceTypeIcon = require("ffde06003d891ee2");
const deviceTypeIcon = require("8202702dbfebf6bd");
const customBotIcon = require("b438be087aef6751");
class AnalyticsFilters extends (0, _reactDefault.default).Component {
    constructor(props){
        super(props);
        this.state = {
            currentFilter: props.currentFilter,
            isExpanded: true
        };
    }
    handleConfirmChanges() {
        // map language ids to locales
        let currentFilter = this.state.currentFilter;
        // todo: Aadu Pirn 9/2/21, refactor this entire component and all lanugage filters to just use locales and not language ids.
        currentFilter.locales = [];
        if (currentFilter.languageIds && currentFilter.languageIds.length > 0) currentFilter.languageIds.forEach((id)=>{
            const language = this.props.languages.find((l)=>l.id == id);
            currentFilter.locales.push(language?.shortCode ?? language?.regionCode);
        });
        this.props.onChange(this.state.currentFilter);
        this.setState({
            ...this.state,
            isExpanded: false
        });
    }
    handleLanguageFilterChange(languageIds) {
        this.setState({
            currentFilter: {
                ...this.state.currentFilter,
                languageIds: [
                    ...languageIds
                ]
            }
        });
    }
    handleDeviceChange(deviceIds) {
        this.setState({
            currentFilter: {
                ...this.state.currentFilter,
                deviceTargetIds: [
                    ...deviceIds
                ]
            }
        });
    }
    handleAssistantsChange(assistants) {
        this.setState({
            currentFilter: {
                ...this.state.currentFilter,
                assistants: [
                    ...assistants
                ]
            }
        });
    }
    handleInterfaceChange(interfaces) {
        this.setState({
            currentFilter: {
                ...this.state.currentFilter,
                interfaces: [
                    ...interfaces
                ]
            }
        });
    }
    handleToggleExpand() {
        this.setState({
            ...this.state,
            isExpanded: !this.state.isExpanded
        });
    }
    handleClearFilters() {
        this.setState({
            ...this.state,
            currentFilter: {
                assistants: [],
                deviceTargetIds: [],
                interfaces: [],
                languageIds: []
            }
        });
        this.props.onChange({
            assistants: [],
            deviceTargetIds: [],
            interfaces: [],
            languageIds: []
        });
    }
    handleCancelChanges() {
        this.setState({
            ...this.state,
            currentFilter: this.props.currentFilter,
            isExpanded: false
        });
    }
    isUnfiltered() {
        return !(this.state.currentFilter?.languageIds?.length > 0 || this.state.currentFilter?.assistants?.length > 0 || this.state.currentFilter?.interfaces?.length > 0 || this.state.currentFilter?.deviceTargetIds?.length > 0);
    }
    render() {
        return (0, _react.jsx)("div", {
            className: containerStyle
        }, (0, _react.jsx)("div", {
            className: "active-filter-section"
        }, this.isUnfiltered() ? (0, _react.jsx)("p", {
            className: "ac-analytics-active-filters"
        }, "No Active Filters - Add some below") : (0, _react.jsx)((0, _reactDefault.default).Fragment, null, this.state.currentFilter?.languageIds?.length > 0 && (0, _react.jsx)((0, _activeFilterIndicatorDefault.default), {
            items: [],
            onClear: ()=>this.handleLanguageFilterChange([]),
            limit: 5,
            icon: flagIcon,
            activeFilterRender: ()=>(0, _react.jsx)("div", {
                    className: "language-avatars"
                }, (0, _react.jsx)((0, _languageCollectionAvatarDefault.default), {
                    className: languageCollectionAvatarStyle,
                    limit: 5,
                    languages: this.props.languages.filter((l)=>this.state.currentFilter.languageIds.indexOf(l.id) > -1)
                }))
        }), this.state.currentFilter?.assistants?.length > 0 && (0, _react.jsx)((0, _activeFilterIndicatorDefault.default), {
            items: this.state.currentFilter.assistants.map((a)=>({
                    label: a,
                    icon: this.props.assistants.find((m)=>m.name == a).iconUrl
                })),
            onClear: ()=>this.handleAssistantsChange([]),
            limit: 5,
            icon: assistantIcon
        }), this.state.currentFilter?.deviceTargetIds?.length > 0 && (0, _react.jsx)((0, _activeFilterIndicatorDefault.default), {
            items: this.state.currentFilter.deviceTargetIds.map((a)=>({
                    label: this.props.deviceTargets.find((m)=>m.id == a).displayName,
                    icon: this.props.deviceTargets.find((m)=>m.id == a).iconUrl ?? customBotIcon
                })),
            onClear: ()=>this.handleDeviceChange([]),
            limit: 5,
            icon: deviceTypeIcon
        }), this.state.currentFilter?.interfaces?.length > 0 && (0, _react.jsx)((0, _activeFilterIndicatorDefault.default), {
            items: this.state.currentFilter.interfaces.map((a)=>({
                    label: a,
                    icon: this.props.interfaces.find((m)=>m.name == a).iconUrl
                })),
            onClear: ()=>this.handleInterfaceChange([]),
            limit: 5,
            icon: interfaceTypeIcon
        })), (0, _react.jsx)("div", {
            className: "button-container"
        }, (0, _react.jsx)((0, _buttonDefault.default), {
            text: "Clear All",
            className: "clear-button",
            disabled: this.props.filterCount <= 0,
            rightIcon: clearIcon,
            themes: [
                "flat"
            ],
            onClick: this.handleClearFilters.bind(this)
        }), this.props.currentFilter != this.state.currentFilter ? (0, _react.jsx)((0, _reactDefault.default).Fragment, null, (0, _react.jsx)((0, _buttonDefault.default), {
            text: "Cancel",
            themes: [
                "secondary-small"
            ],
            onClick: this.handleCancelChanges.bind(this)
        }), (0, _react.jsx)((0, _buttonDefault.default), {
            text: "Update Filters",
            themes: [
                "primary-small"
            ],
            onClick: this.handleConfirmChanges.bind(this)
        })) : (0, _react.jsx)((0, _buttonDefault.default), {
            text: "Edit Filters",
            themes: [
                "primary-small"
            ],
            onClick: this.handleToggleExpand.bind(this)
        }))), this.state.isExpanded && (0, _react.jsx)("div", {
            className: "update-filter-section"
        }, (0, _react.jsx)((0, _filterWrapperDefault.default), null, (0, _react.jsx)((0, _languageFilterDefault.default), {
            onChange: this.handleLanguageFilterChange.bind(this),
            languageIds: this.state.currentFilter?.languageIds ?? [],
            languages: this.props.languages ?? []
        })), (0, _react.jsx)((0, _filterWrapperDefault.default), null, (0, _react.jsx)((0, _assistantFilterDefault.default), {
            onChange: this.handleAssistantsChange.bind(this),
            selectedAssistants: this.state.currentFilter?.assistants ?? [],
            assistants: this.props.assistants ?? []
        })), (0, _react.jsx)((0, _filterWrapperDefault.default), null, (0, _react.jsx)((0, _deviceTypeFilterDefault.default), {
            onChange: this.handleDeviceChange.bind(this),
            deviceIds: this.state.currentFilter?.deviceTargetIds ?? [],
            devices: this.props.deviceTargets ?? []
        })), (0, _react.jsx)((0, _filterWrapperDefault.default), null, (0, _react.jsx)((0, _interfaceTypeFilterDefault.default), {
            onChange: this.handleInterfaceChange.bind(this),
            selectedInterfaces: this.state.currentFilter?.interfaces ?? [],
            interfaces: this.props.interfaces ?? []
        }))));
    }
}
const languageCollectionAvatarStyle = /*#__PURE__*/ (0, _css.css)({
    name: "65nz1t",
    styles: "margin-left:-12px"
});
const containerStyle = /*#__PURE__*/ (0, _css.css)("border-bottom:1px solid ", (0, _colors.color_shades_dark), ";background:", (0, _colors.color_shades_lighter), ";padding:0 16px;.active-filter-section{display:flex;align-items:center;padding:24px;border-bottom:", (0, _stylesValues.style_border_default), ";>div{margin-right:16px;}>p{font-style:italic;font-weight:normal;font-size:14px;line-height:20px;}.language-avatars{margin-left:24px;}.button-container{display:flex;align-items:center;margin-right:0;margin-left:auto;button{margin:0;margin-left:16px;}.clear-button{border-right:", (0, _stylesValues.style_border_default), ";border-radius:0;font-weight:600;font-size:14px;line-height:20px;height:32px;padding:0;padding-right:16px;&:disabled{color:", (0, _colors.color_text_light), ";img{filter:grayscale(100%);}}}}}.update-filter-section{display:flex;align-items:center;padding-bottom:24px;}.search-bar{display:flex;align-items:center;padding-bottom:16px;margin:0 16px;border-bottom:1px solid ", (0, _colors.color_shades_dark), ";label{color:", (0, _colors.color_text_default), ";font-size:16px;line-height:24px;}.input-wrapper{background:white;border-radius:8px;border:1px solid ", (0, _colors.color_shades_dark), ";margin-left:12px;flex:1;display:flex;align-items:center;height:48px;padding:0 16px;img{margin-right:12px;}&:focus-within{border:1px solid ", (0, _colors.color_colors_ocean), ";}}input{border:none;background:transparent;flex:1;color:", (0, _colors.color_text_default), ";line-height:20px;font-size:14px;::placeholder{font-style:italic;color:", (0, _colors.color_text_light), ";font-weight:normal;line-height:20px;font-size:14px;}}}.filters-wrapper{display:flex;justify-content:stretch;max-width:100%;flex-basis:0;}", "");
exports.default = AnalyticsFilters;

},{"@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","./FilterWrapper":"4HUGt","./LanguageFilter":"chHLo","../../../constants/colors":"1p3OR","./DeviceTypeFilter":"3InlQ","./InterfaceTypeFilter":"ixbGa","./AssistantFilter":"705mD","../../general/Button":"6ymxN","../../../constants/stylesValues":"dHVVv","./ActiveFilterIndicator":"aOfdQ","../../general/LanguageCollectionAvatar":"crbMk","4c2c0c7ffd14fdc8":"4VpKz","ac17d973b834642b":"i5oyw","7f4b3c601e80cbbb":"3sMzm","ffde06003d891ee2":"2Dt2N","8202702dbfebf6bd":"kyXeL","b438be087aef6751":"a0DXf","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4HUGt":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// used to manage and manipulate the inner styles of the filters 
// against the grouped multi selector
const FilterWrapper = (props)=>(0, _react.jsx)("div", {
        className: wrapperStyle
    }, props.children);
const wrapperStyle = /*#__PURE__*/ (0, _css.css)({
    name: "1t8nlpd",
    styles: "margin:16px 16px 0 16px;flex:1;max-width:24%"
});
exports.default = FilterWrapper;

},{"@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"chHLo":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _filterSelector = require("./FilterSelector");
var _filterSelectorDefault = parcelHelpers.interopDefault(_filterSelector);
var _filterOption = require("./FilterOption");
var _filterOptionDefault = parcelHelpers.interopDefault(_filterOption);
var _languages = require("../../../models/extensions/languages");
var _lodash = require("lodash");
var _lodashDefault = parcelHelpers.interopDefault(_lodash);
var _customScrollbars = require("../../../components/structure/CustomScrollbars");
var _customScrollbarsDefault = parcelHelpers.interopDefault(_customScrollbars);
const flagIcon = require("b07fa1b49a58b6f6");
class LanguageFilter extends (0, _reactDefault.default).Component {
    constructor(props){
        super(props);
        this.state = {
            expandedLanguageIds: []
        };
    }
    getSelectedText() {
        const selectedLangs = this.props.languages?.filter((l)=>this.props.languageIds?.some((id)=>l.id == id));
        return selectedLangs?.map((l)=>l.shortCode)?.join(", ");
    }
    getLanguageGroups() {
        var dict = (0, _lodashDefault.default).groupBy(this.props.languages, (l)=>l.languageGroupCode);
        var groups = Object.keys(dict).map((key)=>({
                key: key,
                label: `${key.toUpperCase()} - ${(0, _languages.getLanguageName)(key)}`,
                subItems: dict[key].map((lang)=>({
                        data: lang,
                        value: lang.id,
                        icon: (0, _languages.getFlagIconForLanguage)(lang),
                        label: (0, _languages.getRegionyNameForLanguage)(lang),
                        groupKey: key,
                        isSelected: this.props.languageIds?.some((id)=>id == lang.id)
                    }))
            }));
        groups = (0, _lodashDefault.default).sortBy(groups, (group)=>group.key);
        return groups;
    }
    handleToggleExpandGroup(key) {
        var expandedKeys = this.state.expandedLanguageIds == null ? [] : this.state.expandedLanguageIds;
        if (expandedKeys.some((l)=>l == key)) expandedKeys.splice(expandedKeys.indexOf(key), 1);
        else expandedKeys.push(key);
        this.setState({
            ...this.state,
            expandedLanguageIds: expandedKeys
        });
    }
    handleToggleSelectGroup(key, group) {
        var languages = this.props.languages?.filter((lang)=>lang.languageGroupCode == key);
        var languageIds = this.props.languageIds ?? [];
        if (group?.subItems?.some((s)=>s.isSelected) && !group?.subItems?.some((s)=>!s.isSelected)) // all languages are selected we should deselect everything in this group
        {
            var newLanguages = languageIds.filter((lId)=>!languages?.some((l)=>l.id == lId));
            this.props.onChange(newLanguages);
        } else this.props.onChange([
            ...languageIds,
            ...languages?.map((l)=>l.id) ?? []
        ]);
    }
    handleToggleLanguage(languageId) {
        var languageIds = this.props.languageIds ?? [];
        if (languageIds.some((l)=>l == languageId)) languageIds.splice(languageIds.indexOf(languageId), 1);
        else languageIds.push(languageId);
        this.props.onChange(languageIds);
    }
    handleClear() {
        this.props.onChange(null);
    }
    render() {
        const groups = this.getLanguageGroups();
        const selectedText = this.getSelectedText();
        return (0, _react.jsx)((0, _filterSelectorDefault.default), {
            label: "Languages",
            icon: flagIcon,
            placeholder: "Any Languages",
            selectedText: selectedText,
            className: "ac-analytics-language-filter",
            onClear: this.handleClear.bind(this)
        }, (0, _react.jsx)((0, _customScrollbarsDefault.default), {
            autoHide: true,
            autoHeight: true,
            autoHeightMax: 400
        }, groups.map((group)=>(0, _react.jsx)((0, _reactDefault.default).Fragment, {
                key: group.key
            }, (0, _react.jsx)((0, _filterOptionDefault.default), {
                title: group.label,
                key: group.key,
                onClick: ()=>this.handleToggleExpandGroup(group.key),
                onCheckClick: ()=>this.handleToggleSelectGroup(group.key, group),
                isPartialSelected: group?.subItems?.some((s)=>s.isSelected) && group?.subItems?.some((s)=>!s.isSelected),
                isSelected: !group.subItems.some((s)=>!s.isSelected),
                isExpanded: this.state.expandedLanguageIds.some((id)=>id == group.key),
                hasChildren: true,
                optionType: "check"
            }), this.state.expandedLanguageIds.some((id)=>id == group.key) && group.subItems.map((item)=>(0, _react.jsx)((0, _filterOptionDefault.default), {
                    title: item.label,
                    icon: item.icon,
                    selectedIcon: item.icon,
                    onClick: ()=>this.handleToggleLanguage(item.value),
                    isSelected: item.isSelected,
                    key: item.value,
                    isChild: true,
                    optionType: "check"
                })))) ?? (0, _react.jsx)("p", null, "No languages available")));
    }
}
exports.default = LanguageFilter;

},{"@emotion/react":"djZKr","react":"6uln9","./FilterSelector":"hq1Wd","./FilterOption":"96AHP","../../../models/extensions/languages":"8E5Oo","lodash":"3hMBK","../../../components/structure/CustomScrollbars":"50vFq","b07fa1b49a58b6f6":"i5oyw","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hq1Wd":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _defineProperty = require("@babel/runtime/helpers/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _toggleIndicator = require("../../../components/general/ToggleIndicator");
var _toggleIndicatorDefault = parcelHelpers.interopDefault(_toggleIndicator);
var _colors = require("../../../constants/colors");
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
class FilterSelector extends (0, _reactDefault.default).Component {
    constructor(props){
        super(props);
        (0, _definePropertyDefault.default)(this, "documentCloser", this.handleDocumentClick.bind(this));
        this.state = {
            isExpanded: false
        };
    }
    componentWillMount() {
        document.addEventListener("click", this.documentCloser, true);
    }
    componentWillUnmount() {
        document.removeEventListener("click", this.documentCloser, true);
    }
    handleDocumentClick(e) {
        if (e.target.closest(".filter-options") || e.target.closest(".filter-field")) return;
        this.setState({
            ...this.state,
            isExpanded: false
        });
    }
    handleToggle() {
        this.setState({
            ...this.state,
            isExpanded: !this.state.isExpanded
        });
    }
    render() {
        return (0, _react.jsx)("div", {
            className: `${containerStyle} ${this.props.className ?? ""}`
        }, (0, _react.jsx)("div", {
            className: "label-container"
        }, (0, _react.jsx)("label", null, this.props.label), this.props.selectedText && (0, _react.jsx)("button", {
            type: "button",
            onClick: this.props.onClear
        }, "Clear")), (0, _react.jsx)("div", {
            className: "filter-field",
            onClick: this.handleToggle.bind(this)
        }, (0, _react.jsx)("img", {
            src: this.props.icon
        }), this.props.selectedText ? (0, _react.jsx)("p", {
            className: "selection-value"
        }, this.props.selectedText) : (0, _react.jsx)("p", {
            className: "placeholder"
        }, this.props.placeholder), (0, _react.jsx)((0, _toggleIndicatorDefault.default), {
            direction: this.state.isExpanded ? "up" : "down"
        })), this.state.isExpanded && (0, _react.jsx)("div", {
            className: "filter-options"
        }, (0, _react.jsx)("div", {
            className: triangleStyle
        }), (0, _react.jsx)("div", {
            className: "inner-options"
        }, this.props.children)));
    }
}
const containerStyle = /*#__PURE__*/ (0, _css.css)("position:relative;min-width:248px;.label-container{display:flex;align-items:center;margin-bottom:8px;label{font-size:12px;margin-left:16px;}button{color:", (0, _colors.color_text_link), ";border:none;background:none;margin-left:auto;margin-right:16px;font-style:normal;font-weight:normal;font-size:12px;cursor:pointer;}}.filter-field{background:white;border:1px solid ", (0, _colors.color_shades_dark), ";box-sizing:border-box;border-radius:4px;height:48px;display:flex;align-items:center;padding:0 16px;cursor:pointer;.placeholder{font-style:italic;font-weight:normal;font-size:14px;line-height:20px;color:#8F97A1;}.toggle-indicator{margin-right:0;margin-left:auto;}p{white-space:nowrap;overflow:hidden;text-overflow:ellipsis;}img{margin-right:12px;}}.filter-options{position:absolute;margin-top:12px;width:100%;z-index:9;.inner-options{position:relative;z-index:1;overflow-x:hidden;border:1px solid ", (0, _colors.color_shades_dark), ";border-radius:8px;width:100%;box-shadow:0 4px 4px 0 ", (0, _colors.dark_grey_blue_10), ";background:white;}}", "");
const triangleStyle = /*#__PURE__*/ (0, _css.css)({
    name: "1yfkf2d",
    styles: "transform:rotate(45deg);width:12px;height:12px;margin-top:-7px;margin-bottom:-6px;border-top:solid 1px #cccccc;border-left:solid 1px #cccccc;background:white;margin-right:16px;margin-left:auto;z-index:10"
});
exports.default = FilterSelector;

},{"@babel/runtime/helpers/defineProperty":"9sJxO","@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","../../../components/general/ToggleIndicator":"4eej1","../../../constants/colors":"1p3OR","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"96AHP":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _colors = require("../../../constants/colors");
var _checkIndicator = require("../../../components/forms/CheckIndicator");
var _checkIndicatorDefault = parcelHelpers.interopDefault(_checkIndicator);
var _toggleIndicator = require("../../../components/general/ToggleIndicator");
var _toggleIndicatorDefault = parcelHelpers.interopDefault(_toggleIndicator);
const FilterOption = (props)=>(0, _react.jsx)("div", {
        className: `${containerStyle} ${props.isChild ? "child" : ""} ${props.isSelected ? "selected" : ""}`,
        onClick: props.onClick
    }, props.optionType == "check" && (0, _react.jsx)((0, _checkIndicatorDefault.default), {
        checked: props.isSelected,
        partial: props.isPartialSelected,
        onClick: (event)=>{
            event.stopPropagation();
            if (props.onCheckClick == null) props.onClick();
            else props.onCheckClick();
        }
    }), props.icon && (0, _react.jsx)("img", {
        className: "option-icon",
        src: props.isSelected ? props.selectedIcon : props.icon
    }), (0, _react.jsx)("p", null, props.title), props.hasChildren && (0, _react.jsx)((0, _toggleIndicatorDefault.default), {
        direction: props.isExpanded ? "up" : "down"
    }));
const containerStyle = /*#__PURE__*/ (0, _css.css)("display:flex;align-items:center;padding:0 16px;height:48px;background:white;border-bottom:1px solid ", (0, _colors.silver_four), ";cursor:pointer;.option-icon{width:24px;height:24px;margin:0 8px 0 0;}&.child{padding-left:45px;border-left:2px solid ", (0, _colors.silver_four), ";background:#FCFDFE;}.toggle-indicator{margi-right:0;margin-left:auto;}&.selected{p{color:#1E7EB9;}}", "");
exports.default = FilterOption;

},{"@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","../../../constants/colors":"1p3OR","../../../components/forms/CheckIndicator":"8zBm6","../../../components/general/ToggleIndicator":"4eej1","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3InlQ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _filterSelector = require("./FilterSelector");
var _filterSelectorDefault = parcelHelpers.interopDefault(_filterSelector);
var _filterOption = require("./FilterOption");
var _filterOptionDefault = parcelHelpers.interopDefault(_filterOption);
var _customScrollbars = require("../../../components/structure/CustomScrollbars");
var _customScrollbarsDefault = parcelHelpers.interopDefault(_customScrollbars);
const deviceTypeIcon = require("60a55d9737561fdc");
const customBotIcon = require("bc3492ad58ec5377");
class DeviceTypeFilter extends (0, _reactDefault.default).Component {
    handleToggleDeviceType(deviceTypeId) {
        var deviceTypeIds = this.props.deviceIds ?? [];
        if (deviceTypeIds.some((l)=>l == deviceTypeId)) deviceTypeIds.splice(deviceTypeIds.indexOf(deviceTypeId), 1);
        else deviceTypeIds.push(deviceTypeId);
        this.props.onChange(deviceTypeIds);
    }
    handleClear() {
        this.props.onChange(null);
    }
    render() {
        const props = this.props;
        const selectedText = props.devices.filter((f)=>props.deviceIds?.some((id)=>id == f.id))?.map((f)=>f.displayName)?.join(", ");
        return (0, _react.jsx)((0, _filterSelectorDefault.default), {
            label: "Device Type",
            icon: deviceTypeIcon,
            placeholder: "All Device Types",
            selectedText: selectedText,
            className: "ac-analytics-device-filter",
            onClear: this.handleClear.bind(this)
        }, (0, _react.jsx)((0, _customScrollbarsDefault.default), {
            autoHide: true,
            autoHeight: true,
            autoHeightMax: 400
        }, (0, _react.jsx)((0, _filterOptionDefault.default), {
            title: "- Select All / None -",
            onClick: ()=>props.onChange([]),
            isSelected: !props.deviceIds,
            isPartialSelected: true,
            optionType: "check"
        }), props.devices.map((f)=>(0, _react.jsx)((0, _filterOptionDefault.default), {
                key: f.id,
                title: f.displayName,
                icon: f.iconUrl ?? customBotIcon,
                selectedIcon: f.iconUrl ?? customBotIcon,
                isSelected: props.deviceIds?.some((id)=>id == f.id),
                optionType: "check",
                onClick: ()=>this.handleToggleDeviceType(f.id)
            }))));
    }
}
exports.default = DeviceTypeFilter;

},{"@emotion/react":"djZKr","react":"6uln9","./FilterSelector":"hq1Wd","./FilterOption":"96AHP","../../../components/structure/CustomScrollbars":"50vFq","60a55d9737561fdc":"kyXeL","bc3492ad58ec5377":"a0DXf","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"kyXeL":[function(require,module,exports) {
module.exports = require("53eaa0d1122933eb").getBundleURL("kVLro") + require("cdced27dd372b8f0").resolve("hnL9I");

},{"53eaa0d1122933eb":"c7Tr5","cdced27dd372b8f0":"fyJL2"}],"ixbGa":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _filterSelector = require("./FilterSelector");
var _filterSelectorDefault = parcelHelpers.interopDefault(_filterSelector);
var _filterOption = require("./FilterOption");
var _filterOptionDefault = parcelHelpers.interopDefault(_filterOption);
var _customScrollbars = require("../../../components/structure/CustomScrollbars");
var _customScrollbarsDefault = parcelHelpers.interopDefault(_customScrollbars);
const interfaceTypeIcon = require("bbbed305bcba0447");
class InterfaceTypeFilter extends (0, _reactDefault.default).Component {
    handleToggleInterfaceType(selectedInterface) {
        var selectedInterfaces = this.props.selectedInterfaces ?? [];
        if (selectedInterfaces.some((l)=>l == selectedInterface)) selectedInterfaces.splice(selectedInterfaces.indexOf(selectedInterface), 1);
        else selectedInterfaces.push(selectedInterface);
        this.props.onChange(selectedInterfaces);
    }
    handleClear() {
        this.props.onChange(null);
    }
    render() {
        const props = this.props;
        const selectedText = props.interfaces.filter((f)=>props.selectedInterfaces?.some((id)=>id == f.name))?.map((f)=>f.name)?.join(", ");
        return (0, _react.jsx)((0, _filterSelectorDefault.default), {
            label: "Interface",
            icon: interfaceTypeIcon,
            placeholder: "All Interfaces",
            selectedText: selectedText,
            className: "ac-analytics-interface-filter",
            onClear: this.handleClear.bind(this)
        }, (0, _react.jsx)((0, _customScrollbarsDefault.default), {
            autoHide: true,
            autoHeight: true,
            autoHeightMax: 400
        }, (0, _react.jsx)((0, _filterOptionDefault.default), {
            title: "- Select All / None -",
            onClick: ()=>props.onChange([]),
            isSelected: !props.selectedInterfaces,
            isPartialSelected: true,
            optionType: "check"
        }), props.interfaces.map((f)=>(0, _react.jsx)((0, _filterOptionDefault.default), {
                key: f.name,
                title: f.name,
                icon: f.iconUrl,
                selectedIcon: f.iconUrl,
                isSelected: props.selectedInterfaces?.some((id)=>id == f.name),
                optionType: "check",
                onClick: ()=>this.handleToggleInterfaceType(f.name)
            }))));
    }
}
exports.default = InterfaceTypeFilter;

},{"@emotion/react":"djZKr","react":"6uln9","./FilterSelector":"hq1Wd","./FilterOption":"96AHP","../../../components/structure/CustomScrollbars":"50vFq","bbbed305bcba0447":"2Dt2N","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2Dt2N":[function(require,module,exports) {
module.exports = require("df9a662dc84de205").getBundleURL("kVLro") + require("8dc901928e5e78cb").resolve("8DP8o");

},{"df9a662dc84de205":"c7Tr5","8dc901928e5e78cb":"fyJL2"}],"705mD":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _filterSelector = require("./FilterSelector");
var _filterSelectorDefault = parcelHelpers.interopDefault(_filterSelector);
var _filterOption = require("./FilterOption");
var _filterOptionDefault = parcelHelpers.interopDefault(_filterOption);
var _customScrollbars = require("../../../components/structure/CustomScrollbars");
var _customScrollbarsDefault = parcelHelpers.interopDefault(_customScrollbars);
const assistantIcon = require("bafca9d526f67e64");
class AssistantFilter extends (0, _reactDefault.default).Component {
    handleToggleAssistantType(selectedAssistant) {
        var selectedAssistants = this.props.selectedAssistants ?? [];
        if (selectedAssistants.some((l)=>l == selectedAssistant)) selectedAssistants.splice(selectedAssistants.indexOf(selectedAssistant), 1);
        else selectedAssistants.push(selectedAssistant);
        this.props.onChange(selectedAssistants);
    }
    handleClear() {
        this.props.onChange(null);
    }
    render() {
        const props = this.props;
        const selectedText = props.assistants.filter((f)=>props.selectedAssistants?.some((id)=>id == f.name))?.map((f)=>f.name)?.join(", ");
        return (0, _react.jsx)((0, _filterSelectorDefault.default), {
            label: "Platform",
            icon: assistantIcon,
            placeholder: "All Assistant Platforms",
            selectedText: selectedText,
            className: "ac-analytics-platform-filter",
            onClear: this.handleClear.bind(this)
        }, (0, _react.jsx)((0, _customScrollbarsDefault.default), {
            autoHide: true,
            autoHeight: true,
            autoHeightMax: 400
        }, (0, _react.jsx)((0, _filterOptionDefault.default), {
            title: "- Select All / None -",
            onClick: ()=>props.onChange([]),
            isSelected: !props.selectedAssistants,
            isPartialSelected: true,
            optionType: "check"
        }), props.assistants.map((f)=>(0, _react.jsx)((0, _filterOptionDefault.default), {
                key: f.name,
                title: f.name,
                icon: f.iconUrl,
                selectedIcon: f.iconUrl,
                isSelected: props.selectedAssistants?.some((id)=>id == f.name),
                optionType: "check",
                onClick: ()=>this.handleToggleAssistantType(f.name)
            }))));
    }
}
exports.default = AssistantFilter;

},{"@emotion/react":"djZKr","react":"6uln9","./FilterSelector":"hq1Wd","./FilterOption":"96AHP","../../../components/structure/CustomScrollbars":"50vFq","bafca9d526f67e64":"3sMzm","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3sMzm":[function(require,module,exports) {
module.exports = require("a1eba13abe98a71a").getBundleURL("kVLro") + require("ed65a1cbffcedc99").resolve("9xLs5");

},{"a1eba13abe98a71a":"c7Tr5","ed65a1cbffcedc99":"fyJL2"}],"aOfdQ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _stylesValues = require("../../../constants/stylesValues");
var _tooltipWrapper = require("../../general/TooltipWrapper");
var _tooltipWrapperDefault = parcelHelpers.interopDefault(_tooltipWrapper);
var _button = require("../../general/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
const clearIcon = require("4a4812f107b0537e");
const ActiveFilterIndicator = (props)=>{
    return (0, _react.jsx)("div", {
        className: `${containerStyle} ac-analytics-active-filters`
    }, (0, _react.jsx)("img", {
        src: props.icon,
        className: "filter-group-icon"
    }), props.activeFilterRender ? props.activeFilterRender() : props.items.map((item, i)=>(0, _react.jsx)((0, _tooltipWrapperDefault.default), {
            key: i,
            text: item.label
        }, (0, _react.jsx)("img", {
            className: "option-icon",
            src: item.icon
        }))), (0, _react.jsx)((0, _buttonDefault.default), {
        icon: clearIcon,
        themes: [
            "icon"
        ],
        onClick: props.onClear,
        className: "clear-button"
    }));
};
const containerStyle = /*#__PURE__*/ (0, _css.css)("background:white;border:", (0, _stylesValues.style_border_default), ";box-sizing:border-box;border-radius:24px;height:40px;padding:0 16px;display:flex;align-items:center;.filter-group-icon{height:24px;border-right:", (0, _stylesValues.style_border_default), ";padding-right:8px;}.option-icon{margin-left:8px;height:24px;}.clear-button{margin:0;margin-left:8px;width:24px;height:24px;padding:0;}", "");
exports.default = ActiveFilterIndicator;

},{"@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","../../../constants/stylesValues":"dHVVv","../../general/TooltipWrapper":"53pWd","../../general/Button":"6ymxN","4a4812f107b0537e":"cy6GT","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"cy6GT":[function(require,module,exports) {
module.exports = require("f01966096173b5ea").getBundleURL("kVLro") + require("40d92520406ad732").resolve("j4b3E");

},{"f01966096173b5ea":"c7Tr5","40d92520406ad732":"fyJL2"}],"4VpKz":[function(require,module,exports) {
module.exports = require("ede4e0a1d0ea58b7").getBundleURL("kVLro") + require("24dc40e36f6543aa").resolve("jgf0L");

},{"ede4e0a1d0ea58b7":"c7Tr5","24dc40e36f6543aa":"fyJL2"}],"1KotO":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _secondaryLoader = require("../../../components/general/SecondaryLoader");
var _secondaryLoaderDefault = parcelHelpers.interopDefault(_secondaryLoader);
var _css = require("@emotion/css");
var _contentNode = require("../../../components/analytics/tracking/ContentNode");
var _contentNodeDefault = parcelHelpers.interopDefault(_contentNode);
var _sessionStartNode = require("../../../components/analytics/tracking/SessionStartNode");
var _sessionStartNodeDefault = parcelHelpers.interopDefault(_sessionStartNode);
var _sessionEndNode = require("../../../components/analytics/tracking/SessionEndNode");
var _sessionEndNodeDefault = parcelHelpers.interopDefault(_sessionEndNode);
var _colors = require("../../../constants/colors");
var _stylesValues = require("../../../constants/stylesValues");
var _customScrollbars = require("../../../components/structure/CustomScrollbars");
var _customScrollbarsDefault = parcelHelpers.interopDefault(_customScrollbars);
var _downTreePaths = require("../../../components/analytics/tracking/DownTreePaths");
var _downTreePathsDefault = parcelHelpers.interopDefault(_downTreePaths);
var _treeRowPager = require("../../../components/analytics/TreeRowPager");
var _treeRowPagerDefault = parcelHelpers.interopDefault(_treeRowPager);
var _lodash = require("lodash");
var _lodashDefault = parcelHelpers.interopDefault(_lodash);
var _conversationScript = require("../../conversationScript");
var _conversationScriptDefault = parcelHelpers.interopDefault(_conversationScript);
var _fullContentNode = require("../../../components/analytics/tracking/FullContentNode");
var _fullContentNodeDefault = parcelHelpers.interopDefault(_fullContentNode);
var _upTreePaths = require("../../../components/analytics/tracking/UpTreePaths");
var _upTreePathsDefault = parcelHelpers.interopDefault(_upTreePaths);
var _analyticsEmptyView = require("../../../components/analytics/AnalyticsEmptyView");
var _analyticsEmptyViewDefault = parcelHelpers.interopDefault(_analyticsEmptyView);
class ContentTrackingPage extends (0, _reactDefault.default).Component {
    constructor(props){
        super(props);
        this.state = {
            selectedNodes: [],
            positionOffsets: []
        };
    }
    componentDidMount() {
        this.reloadData();
    }
    componentDidUpdate(previousProps) {
        if (JSON.stringify(previousProps.filter) != JSON.stringify(this.props.filter)) this.reloadData();
    }
    async reloadData() {
        const result = await this.props.trackingContainer.loadTree(this.props.applicationId, this.props.contentId, this.props.filter);
        const tree = this.props.trackingContainer.findTree(this.props.contentId, this.props.filter);
        let selectedNodes = [];
        if (result?.resultType == "Ok") {
            const contentTree = this.props.trackingContainer.convertToContentTree(tree);
            selectedNodes[1] = contentTree.contentNode;
            await this.props.trackingContainer.loadNodeDetails(this.props.applicationId, this.props.contentId, this.props.filter, [
                ...contentTree.parentNodes,
                contentTree.contentNode,
                ...contentTree.childNodes
            ]);
        }
        if (tree?.data?.childNodes?.length > 3) {
            // check to see if we should set an offset
            // if we have 4 or more, then set the default to far left
            let levelOffset = this.state.positionOffsets.find((l)=>l.level == 0);
            const index = this.state.positionOffsets.indexOf(levelOffset);
            if (levelOffset) {
                levelOffset.offset = -(tree.data.childNodes.length / 2) + 2;
                this.state.positionOffsets[index] = levelOffset;
            } else {
                levelOffset = {
                    level: 0,
                    offset: -(tree.data.childNodes.length / 2) + 2
                };
                this.state.positionOffsets.push(levelOffset);
            }
        }
        this.setState({
            ...this.state,
            selectedNodes,
            positionOffsets: this.state.positionOffsets
        });
    }
    handleContentNodeClick(node, level) {
        let { selectedNodes, positionOffsets } = this.state;
        if (selectedNodes[level]?.contentId == node.contentId) selectedNodes = selectedNodes.slice(0, level);
        else {
            selectedNodes[level] = node;
            if (node.childNodes?.length > 3) {
                // check to see if we should set an offset
                // if we have 4 or more, then set the default to far left
                let levelOffset = positionOffsets.find((l)=>l.level == level + 1);
                const index = positionOffsets.indexOf(levelOffset);
                if (levelOffset) {
                    levelOffset.offset = -(node.childNodes.length / 2) + 2;
                    positionOffsets[index] = levelOffset;
                } else {
                    levelOffset = {
                        level: level + 1,
                        offset: -(node.childNodes.length / 2) + 2
                    };
                    positionOffsets.push(levelOffset);
                }
            }
        }
        this.setState({
            ...this.state,
            selectedNodes,
            positionOffsets
        });
    }
    handleEndNodeClick(level, node) {
        var selectedNodes = this.state.selectedNodes;
        if (selectedNodes[level]?.conversationTrackingNodeType == "SessionEnd") selectedNodes = selectedNodes.slice(0, level);
        else selectedNodes[level] = node;
        this.setState({
            ...this.state,
            selectedNodes
        });
    }
    handleStartNodeClick(level, node) {
        var selectedNodes = this.state.selectedNodes;
        if (selectedNodes[level]?.conversationTrackingNodeType == "SessionStart") selectedNodes = selectedNodes.slice(0, level);
        else selectedNodes[level] = node;
        this.setState({
            ...this.state,
            selectedNodes
        });
    }
    handlePage(level, increment, nodeLength) {
        const positionOffsets = this.state.positionOffsets;
        let levelOffset = positionOffsets.find((l)=>l.level == level);
        const index = positionOffsets.indexOf(levelOffset);
        if (!levelOffset) levelOffset = {
            level,
            offset: 0
        };
        else {
            // limit it so the last node ends in the middle
            if (increment && levelOffset.offset > nodeLength / 2 - 1) return;
            if (!increment && levelOffset.offset < -(nodeLength / 2 - 1)) return;
        }
        if (increment) levelOffset.offset++;
        else levelOffset.offset--;
        if (index > -1) positionOffsets[index] = levelOffset;
        else positionOffsets.push(levelOffset);
        this.setState({
            ...this.state,
            positionOffsets
        });
    }
    getChildNodes(contentTree, totalTree) {
        const selectedParent = this.state.selectedNodes[0];
        if (!selectedParent) return contentTree.childNodes;
        const parentFlow = totalTree.data.childNodes.find((n)=>n.conversationTrackingNodeType == selectedParent.conversationTrackingNodeType && n.contentId == selectedParent.contentId);
        return parentFlow.childNodes[0].childNodes;
    }
    renderRow(nodes, conversationItems, level, label) {
        if (!nodes || nodes.length == 0) return null;
        const selectedNodes = this.state.selectedNodes;
        const selectedNode = nodes.find((n)=>n.conversationTrackingNodeType == "Content" && selectedNodes[level]?.contentId == n.contentId || n.conversationTrackingNodeType == "SessionEnd" && selectedNodes[level]?.conversationTrackingNodeType == "SessionEnd");
        const totalSessions = nodes.map((n)=>n.sessionIds?.length ?? 0).reduce((a, b)=>a + b);
        const nodeOffset = this.state.positionOffsets.find((o)=>o.level == level)?.offset ?? 0;
        const treeRowOffset = /*#__PURE__*/ (0, _css.css)("margin-right:", nodeOffset * 288, "px;", "");
        return (0, _react.jsx)((0, _reactDefault.default).Fragment, null, (0, _react.jsx)("div", {
            className: "tree-row-wrapper"
        }, (0, _react.jsx)("p", {
            className: "section-label"
        }, label), (0, _react.jsx)("div", {
            className: "row-separator"
        }, (0, _react.jsx)("div", {
            className: "row-separator-body"
        })), (0, _react.jsx)("div", {
            className: "pager"
        }, (0, _react.jsx)("div", {
            className: "pager-body"
        }, (0, _react.jsx)((0, _treeRowPagerDefault.default), {
            onRight: ()=>this.handlePage(level, true, nodes.length),
            onLeft: ()=>this.handlePage(level, false, nodes.length),
            canMoveLeft: nodeOffset > -(nodes.length / 2 - 1),
            canMoveRight: nodeOffset <= nodes.length / 2 - 1
        }), (0, _react.jsx)("p", {
            className: "pager-label"
        }, selectedNode ? `${nodes.indexOf(selectedNode) + 1} of ` : "-- of ", " ", nodes.length.toString(), " items")))), (0, _react.jsx)("div", {
            className: `tree-row ${treeRowOffset}`
        }, nodes?.map((n, i)=>{
            if (n.conversationTrackingNodeType == "Content") {
                const contentNode = n;
                const selected = selectedNodes[level]?.contentId == contentNode.contentId;
                return (0, _react.jsx)((0, _contentNodeDefault.default), {
                    id: contentNode.contentId + level,
                    key: i,
                    nodeData: contentNode,
                    percentage: n.sessionIds.length / totalSessions,
                    number: n.sessionIds.length,
                    conversationItem: conversationItems.find((c)=>c.id == contentNode.contentId),
                    selected: selected,
                    childSelected: selectedNodes[level + 1] != null,
                    active: selected || selectedNodes[level] == null,
                    isStart: level == 0,
                    isEnd: level == 2,
                    isLoadingDetails: this.props.trackingContainer.state.isLoadingDetails,
                    onClick: ()=>this.handleContentNodeClick(contentNode, level)
                });
            }
            if (n.conversationTrackingNodeType == "SessionEnd") return (0, _react.jsx)((0, _sessionEndNodeDefault.default), {
                key: i,
                number: n.sessionIds.length,
                selected: selectedNodes[level]?.conversationTrackingNodeType == "SessionEnd",
                percentage: n.sessionIds.length / totalSessions,
                active: selectedNodes[level]?.conversationTrackingNodeType == "SessionEnd" || selectedNodes[level] == null,
                onClick: ()=>this.handleEndNodeClick(level, n)
            });
            if (n.conversationTrackingNodeType == "SessionStart") return (0, _react.jsx)((0, _sessionStartNodeDefault.default), {
                key: i,
                selected: selectedNodes[level]?.conversationTrackingNodeType == "SessionStart",
                percentage: n.sessionIds.length / totalSessions,
                active: selectedNodes[level]?.conversationTrackingNodeType == "SessionStart" || selectedNodes[level] == null,
                onClick: ()=>this.handleStartNodeClick(level, n)
            });
        })));
    }
    render() {
        const { trackingContainer } = this.props;
        const tree = trackingContainer.findTree(this.props.contentId, this.props.filter);
        if (trackingContainer.state.isLoading || !tree) return (0, _react.jsx)("div", {
            className: loaderContainer
        }, (0, _react.jsx)((0, _secondaryLoaderDefault.default), null));
        const contentTree = trackingContainer.convertToContentTree(tree);
        const filteredChildNodes = this.getChildNodes(contentTree, tree);
        const childItems = (0, _lodashDefault.default).sortBy(filteredChildNodes, (n)=>n.sessionIds?.length ?? 0).reverse();
        const parentItems = (0, _lodashDefault.default).sortBy(contentTree.parentNodes, (n)=>n.sessionIds?.length ?? 0).reverse();
        const selectedChild = filteredChildNodes.find((c)=>c.conversationTrackingNodeType == this.state.selectedNodes[2]?.conversationTrackingNodeType && c.contentId == this.state.selectedNodes[2]?.contentId);
        const selectedParent = contentTree.parentNodes.find((c)=>c.conversationTrackingNodeType == this.state.selectedNodes[0]?.conversationTrackingNodeType && c.contentId == this.state.selectedNodes[0]?.contentId);
        return (0, _react.jsx)("div", {
            className: wrapperStyle
        }, (0, _react.jsx)((0, _customScrollbarsDefault.default), null, parentItems?.length > 0 ? (0, _react.jsx)("div", {
            className: "tree-container"
        }, this.renderRow(parentItems, tree.conversationItems, 0, "Preceeded by"), (0, _react.jsx)((0, _upTreePathsDefault.default), {
            topIndex: parentItems.indexOf(selectedParent) > -1 ? parentItems.indexOf(selectedParent) : 0,
            topLength: contentTree.parentNodes.length,
            activeIndex: parentItems.indexOf(selectedParent),
            topNodes: parentItems,
            nodeOffset: 0,
            topNodeOffset: this.state.positionOffsets.find((o)=>o.level == 0)?.offset ?? 0
        }), (0, _react.jsx)("div", {
            className: "tree-row-wrapper"
        }, (0, _react.jsx)("p", {
            className: "section-label"
        }, "Current Conversation"), (0, _react.jsx)("div", {
            className: "row-separator"
        }, (0, _react.jsx)("div", {
            className: "row-separator-body"
        })), (0, _react.jsx)("div", {
            className: `tree-row`
        }, (0, _react.jsx)((0, _fullContentNodeDefault.default), {
            id: contentTree.contentNode?.contentId ?? "content",
            nodeData: contentTree.contentNode,
            conversationItem: this.props.contentItem,
            selected: selectedParent != null,
            childSelected: this.state.selectedNodes[2] != null,
            active: true,
            isLoadingDetails: this.props.trackingContainer.state.isLoadingDetails,
            featureTypeId: this.props.featureTypeId
        }))), (0, _react.jsx)((0, _downTreePathsDefault.default), {
            prevIndex: 0,
            prevLength: 1,
            activeIndex: childItems.indexOf(selectedChild),
            nodes: childItems,
            nodeOffset: this.state.positionOffsets.find((o)=>o.level == 2)?.offset ?? 0,
            prevNodeOffset: 0
        }), this.renderRow(childItems, tree.conversationItems, 2, "Followed by")) : (0, _react.jsx)((0, _analyticsEmptyViewDefault.default), null)), (0, _react.jsx)("div", {
            className: "conversation-preview-container"
        }, (0, _react.jsx)((0, _customScrollbarsDefault.default), null, (0, _react.jsx)((0, _conversationScriptDefault.default), {
            nodes: this.state.selectedNodes ?? [],
            applicationId: this.props.applicationId,
            hasStart: this.state.selectedNodes[0]?.conversationTrackingNodeType == "SessionStart"
        }))));
    }
}
const loaderContainer = /*#__PURE__*/ (0, _css.css)("display:flex;flex:1;align-items:center;justify-content:center;width:100%;margin:64px 0;.spinner>div{background:", (0, _colors.color_colors_ocean), ";}", "");
const wrapperStyle = /*#__PURE__*/ (0, _css.css)("display:flex;height:100%;background:white;.tree-container{display:flex;flex-direction:column;align-items:center;padding:128px 0;overflow-x:hidden;}.tree-row-wrapper{width:100%;position:relative;.section-label{position:absolute;font-size:18px;line-height:24px;color:", (0, _colors.color_text_light), ";background:white;margin:0 32px;top:-108px;}}.tree-row{display:flex;align-items:center;justify-content:center;}.row-separator{position:relative;width:100%;.row-separator-body{height:1px;bottom:80px;left:0;right:0;position:absolute;border-top:", (0, _stylesValues.style_border_default), ";}}.pager{position:relative;width:100%;z-index:6;.pager-body{bottom:52px;right:32;position:absolute;display:flex;flex-direction:column;align-items:flex-end;.pager-label{color:", (0, _colors.color_text_light), ";font-size:10px;line-height:16px;text-align:right;background:white;}}}.conversation-preview-container{background:", (0, _colors.color_shades_lighter), ";min-width:576px;height:100%;border-left:", (0, _stylesValues.style_border_default), ";}", "");
exports.default = ContentTrackingPage;

},{"@emotion/react":"djZKr","react":"6uln9","../../../components/general/SecondaryLoader":"7zJiF","@emotion/css":"awUBr","../../../components/analytics/tracking/ContentNode":"1GmZZ","../../../components/analytics/tracking/SessionStartNode":"5EUlV","../../../components/analytics/tracking/SessionEndNode":"8f380","../../../constants/colors":"1p3OR","../../../constants/stylesValues":"dHVVv","../../../components/structure/CustomScrollbars":"50vFq","../../../components/analytics/tracking/DownTreePaths":"3kOiR","../../../components/analytics/TreeRowPager":"8fXD2","lodash":"3hMBK","../../conversationScript":"2y8Bz","../../../components/analytics/tracking/FullContentNode":"5zUjg","../../../components/analytics/tracking/UpTreePaths":"i829J","../../../components/analytics/AnalyticsEmptyView":"fSMut","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1GmZZ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _stylesValues = require("../../../constants/stylesValues");
var _colors = require("../../../constants/colors");
var _tooltipWrapper = require("../../general/TooltipWrapper");
var _tooltipWrapperDefault = parcelHelpers.interopDefault(_tooltipWrapper);
var _nodeSocket = require("./NodeSocket");
var _nodeSocketDefault = parcelHelpers.interopDefault(_nodeSocket);
var _extensions = require("../../../models/extensions");
var _featureTypeIds = require("../../../constants/featureTypeIds");
const ContentNode = (props)=>{
    let percentage = props.percentage * 100;
    percentage = percentage !== Math.round(percentage) ? percentage.toFixed(2) : percentage;
    const getTitle = ()=>{
        if (props.conversationItem?.title) return props.conversationItem.title;
        if (props.isLoadingDetails) return "Loading";
        return "- Deleted -";
    };
    return (0, _react.jsx)("div", {
        className: `${containerStyle} ${props.active ? "active" : "inactive"} ${props.selected ? "selected" : "unselected"}`,
        id: props.id
    }, (0, _react.jsx)("div", {
        className: "percentage-container ac-analytics-track-node-percentage"
    }, (0, _react.jsx)("p", null, percentage, "% (", props.number, ")")), (0, _react.jsx)("div", {
        className: "node-card ac-analytics-track-node-card",
        onClick: props.onClick
    }, !props.isStart && (0, _react.jsx)("div", {
        className: "in-socket"
    }, (0, _react.jsx)((0, _nodeSocketDefault.default), {
        direction: "in",
        active: props.selected
    })), (0, _react.jsx)("div", {
        className: "feature-icon-container"
    }), (0, _react.jsx)("div", {
        className: "card-body"
    }, (0, _react.jsx)((0, _tooltipWrapperDefault.default), {
        place: "top",
        text: getTitle()
    }, (0, _react.jsx)("p", null, getTitle()))), (0, _react.jsx)("img", {
        className: "feature-icon",
        src: (0, _extensions.getFeatureTypeIcon)(props.conversationItem?.featureTypeId ?? props.nodeData.featureTypeId ?? (0, _featureTypeIds.FallbackFeatureTypeId))
    }), !props.isEnd && (0, _react.jsx)("div", {
        className: "out-socket"
    }, (0, _react.jsx)((0, _nodeSocketDefault.default), {
        direction: "out",
        active: props.childSelected
    }))), !props.isStart && (0, _react.jsx)("div", {
        className: "circle"
    }));
};
const containerStyle = /*#__PURE__*/ (0, _css.css)("width:120px;margin:0 12px;position:relative;.circle{width:8px;height:8px;position:absolute;border-radius:50%;top:-84px;left:57px;background:", (0, _colors.color_variants_royalty_light_10), ";border:1px solid ", (0, _colors.color_variants_royalty_light_20), ";}.percentage-container{display:flex;position:absolute;top:-32px;right:0;background:", (0, _colors.color_defaults_white), ";z-index:5;padding:4px;border-radius:3px;border:1px solid ", (0, _colors.color_colors_royalty), ";>p{margin-right:0;margin-left:auto;color:", (0, _colors.color_colors_royalty), ";text-align:right;font-style:normal;font-weight:normal;font-size:12px;line-height:16px;}}.node-card{cursor:pointer;width:120px;height:80px;border-radius:4px;border:", (0, _stylesValues.style_border_default), ";background:", (0, _colors.color_shades_light), ";padding:8px 0;position:relative;.feature-icon-container{position:absolute;top:-4px;left:-8px;width:32px;height:32px;border:", (0, _stylesValues.style_border_default), ";border-radius:4px;background:white;}.feature-icon{position:absolute;top:2px;left:-2px;height:20px;}.card-body{background:white;height:64px;display:flex;align-items:center;justify-content:center;padding:8px;position:absolute;left:0;right:0;>p{font-size:12px;line-height:16px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;}}.out-socket{display:flex;align-items:center;justify-content:center;width:120px;position:absolute;bottom:-5px;z-index:3;}.in-socket{display:flex;align-items:center;justify-content:center;width:120px;position:absolute;top:-5px;z-index:3;}}&.inactive{opacity:0.4;}&.selected{.circle{background :", (0, _colors.color_colors_royalty), ";border:2px solid white;z-index:3;left:56px;top:-85px;width:10px;height:10px;}}", "");
exports.default = ContentNode;

},{"@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","../../../constants/stylesValues":"dHVVv","../../../constants/colors":"1p3OR","../../general/TooltipWrapper":"53pWd","./NodeSocket":"f8m4F","../../../models/extensions":"7h01B","../../../constants/featureTypeIds":"hPLMP","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"f8m4F":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _colors = require("../../../constants/colors");
var _stylesValues = require("../../../constants/stylesValues");
const inIcon = require("78f853dc379d980b");
const outIcon = require("b4acce98157f56c4");
const NodeSocket = (props)=>(0, _react.jsx)("div", {
        className: `${containerStyle} ${props.className ?? ""} ${props.active ? "active" : "inactive"}`
    }, (0, _react.jsx)("img", {
        src: props.direction == "in" ? inIcon : outIcon
    }));
const containerStyle = /*#__PURE__*/ (0, _css.css)("display:flex;align-items:center;justify-content:center;width:20px;height:20px;border:", (0, _stylesValues.style_border_default), ";border-radius:4px;background:", (0, _colors.color_variants_royalty_light_10), ";&.active{border:1px solid ", (0, _colors.color_colors_royalty), ";}", "");
exports.default = NodeSocket;

},{"@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","../../../constants/colors":"1p3OR","../../../constants/stylesValues":"dHVVv","78f853dc379d980b":"bHFcR","b4acce98157f56c4":"gq5Lz","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"bHFcR":[function(require,module,exports) {
module.exports = require("446b94683d129410").getBundleURL("kVLro") + require("e8ffe03a83e319f9").resolve("7dnOd");

},{"446b94683d129410":"c7Tr5","e8ffe03a83e319f9":"fyJL2"}],"gq5Lz":[function(require,module,exports) {
module.exports = require("921c44192bddfe5").getBundleURL("kVLro") + require("e8d0f3f5c7b0a71c").resolve("jJusO");

},{"921c44192bddfe5":"c7Tr5","e8d0f3f5c7b0a71c":"fyJL2"}],"5EUlV":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _stylesValues = require("../../../constants/stylesValues");
var _colors = require("../../../constants/colors");
var _nodeSocket = require("./NodeSocket");
var _nodeSocketDefault = parcelHelpers.interopDefault(_nodeSocket);
const powerIcon = require("9fcbc593cf4cc983");
const SessionStartNode = (props)=>{
    let percentage = props.percentage == null ? null : props.percentage * 100;
    if (percentage != null) percentage = percentage !== Math.round(percentage) ? percentage.toFixed(2) : percentage;
    return (0, _react.jsx)("div", {
        className: `${containerStyle} ${props.active ? "active" : "inactive"}`,
        id: "start-session-node"
    }, (0, _react.jsx)("div", {
        className: "percentage-container"
    }, percentage != null && (0, _react.jsx)("p", null, percentage, "%")), (0, _react.jsx)("div", {
        className: "node-card",
        onClick: props.onClick
    }, (0, _react.jsx)("div", {
        className: "card-body"
    }, (0, _react.jsx)("img", {
        src: powerIcon,
        alt: "session starts"
    }), (0, _react.jsx)("p", null, "Session Starts")), (0, _react.jsx)("div", {
        className: "out-socket"
    }, (0, _react.jsx)((0, _nodeSocketDefault.default), {
        direction: "out",
        active: props.selected
    }))));
};
const containerStyle = /*#__PURE__*/ (0, _css.css)("width:120px;margin:0 12px;position:relative;&.inactive{opacity:0.4;}.percentage-container{display:flex;position:absolute;top:-16px;right:0;>p{margin-right:0;margin-left:auto;color:", (0, _colors.color_colors_royalty), ";text-align:right;font-style:normal;font-weight:normal;font-size:12px;line-height:16px;}}.node-card{cursor:pointer;width:120px;height:80px;border-radius:4px;border:", (0, _stylesValues.style_border_default), ";background:", (0, _colors.color_colors_growth), ";padding:8px 0;position:relative;.card-body{background:white;height:64px;display:flex;align-items:center;justify-content:center;padding:16px;>p{text-align:right;font-size:12px;line-height:16px;}}.out-socket{display:flex;align-items:center;justify-content:center;width:120px;position:absolute;bottom:-5px;z-index:3;}}", "");
exports.default = SessionStartNode;

},{"@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","../../../constants/stylesValues":"dHVVv","../../../constants/colors":"1p3OR","./NodeSocket":"f8m4F","9fcbc593cf4cc983":"dqBYI","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"dqBYI":[function(require,module,exports) {
module.exports = require("d043d2eb7781a274").getBundleURL("kVLro") + require("411e5c915c1e3e1").resolve("3wv11");

},{"d043d2eb7781a274":"c7Tr5","411e5c915c1e3e1":"fyJL2"}],"8f380":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _stylesValues = require("../../../constants/stylesValues");
var _colors = require("../../../constants/colors");
var _nodeSocket = require("./NodeSocket");
var _nodeSocketDefault = parcelHelpers.interopDefault(_nodeSocket);
const finishIcon = require("d896cb58126ef520");
const SessionEndNode = (props)=>{
    let percentage = props.percentage * 100;
    percentage = percentage !== Math.round(percentage) ? percentage.toFixed(2) : percentage;
    return (0, _react.jsx)("div", {
        className: `${containerStyle} ${props.active ? "active" : "inactive"} ${props.selected ? "selected" : "unselected"}`
    }, (0, _react.jsx)("div", {
        className: "percentage-container"
    }, (0, _react.jsx)("p", null, percentage, "%")), (0, _react.jsx)("div", {
        className: "node-card",
        onClick: props.onClick
    }, (0, _react.jsx)("div", {
        className: "in-socket"
    }, (0, _react.jsx)((0, _nodeSocketDefault.default), {
        direction: "in",
        active: props.selected
    })), (0, _react.jsx)("div", {
        className: "card-body"
    }, (0, _react.jsx)("p", null, "Session Ends"), (0, _react.jsx)("img", {
        src: finishIcon,
        alt: "session ends"
    }))), (0, _react.jsx)("div", {
        className: "circle"
    }));
};
const containerStyle = /*#__PURE__*/ (0, _css.css)("width:120px;margin:0 12px;position:relative;.circle{width:8px;height:8px;position:absolute;border-radius:50%;top:-84px;left:55px;background:", (0, _colors.color_variants_royalty_light_10), ";border:1px solid ", (0, _colors.color_variants_royalty_light_20), ";box-sizing:content-box;}.percentage-container{display:flex;position:absolute;top:-32px;right:0;background:", (0, _colors.color_defaults_white), ";z-index:5;padding:4px;border-radius:3px;border:1px solid ", (0, _colors.color_colors_royalty), ";>p{margin-right:0;margin-left:auto;color:", (0, _colors.color_colors_royalty), ";text-align:right;font-style:normal;font-weight:normal;font-size:12px;line-height:16px;}}.node-card{cursor:pointer;width:120px;height:80px;border-radius:4px;border:", (0, _stylesValues.style_border_default), ";background:#E2A6AE;padding:8px 0;position:relative;.card-body{background:white;height:64px;display:flex;align-items:center;justify-content:center;padding:16px;>p{text-align:left;font-size:12px;line-height:16px;}}.in-socket{display:flex;align-items:center;justify-content:center;width:120px;position:absolute;top:-5px;z-index:3;}}&.inactive{opacity:0.4;}&.selected{.circle{background :", (0, _colors.color_colors_royalty), ";border:2px solid white;z-index:3;left:54.5px;top:-85px;}}", "");
exports.default = SessionEndNode;

},{"@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","../../../constants/stylesValues":"dHVVv","../../../constants/colors":"1p3OR","./NodeSocket":"f8m4F","d896cb58126ef520":"iTLXM","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"iTLXM":[function(require,module,exports) {
module.exports = require("7fda424fdd9ef8ee").getBundleURL("kVLro") + require("7044617c0afd9d9e").resolve("l1UlD");

},{"7fda424fdd9ef8ee":"c7Tr5","7044617c0afd9d9e":"fyJL2"}],"3kOiR":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _treePath = require("./TreePath");
var _treePathDefault = parcelHelpers.interopDefault(_treePath);
const NODE_WIDTH = 144; // the width of a node including margins
const DownTreePaths = (props)=>{
    const directionMultiplier = (length, index, prevLength, prevIndex)=>{
        const currentPositionOffset = length / 2 - index + props.nodeOffset;
        const prevPositionOffset = prevLength / 2 - prevIndex + props.prevNodeOffset;
        return prevPositionOffset - currentPositionOffset;
    };
    const totalWidth = NODE_WIDTH * (props.prevLength > props.nodes.length ? props.prevLength : props.nodes.length) * (Math.abs(props.prevNodeOffset) > Math.abs(props.nodeOffset) ? Math.abs(props.prevNodeOffset) : Math.abs(props.nodeOffset) + 1);
    const totalSessions = props.nodes.length == 0 ? 0 : props.nodes.map((n)=>n.sessionIds?.length ?? 0).reduce((a, b)=>a + b);
    const containerStyle = /*#__PURE__*/ (0, _css.css)("position:relative;width:", totalWidth, "px;height:170px;", "");
    // each tree path is an SVG that is the width of the larger of the two rows it is being drawn between.
    // we calculate the offset from the center left or right of the top row and account for border-box (hence the -1)
    // we then draw the svg from the offset within a coordinate plane the size of the width of the container and the height
    // and go down, then over the direction width difference from the offset to the bottom row offset
    // and then draw the line down to the point.
    return (0, _react.jsx)("div", {
        className: containerStyle
    }, props.nodes.map((n, i)=>{
        const percentage = (n.sessionIds?.length ?? 0) / totalSessions;
        return (0, _react.jsx)((0, _treePathDefault.default), {
            key: i,
            direction: directionMultiplier(props.nodes.length, i, props.prevLength, props.prevIndex) > 0 ? "down-right" : "down-left",
            width: NODE_WIDTH * directionMultiplier(props.nodes.length, i, props.prevLength, props.prevIndex),
            containerWidth: totalWidth,
            offset: (props.prevLength / 2 - (props.prevIndex - props.prevNodeOffset)) * NODE_WIDTH - NODE_WIDTH / 2 - 1,
            height: 170,
            lineSize: Math.round(19 * percentage),
            active: props.activeIndex == i
        });
    }));
};
exports.default = DownTreePaths;

},{"@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","./TreePath":"2wP0q","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2wP0q":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _colors = require("../../../constants/colors");
const TreePath = (props)=>{
    const svgStyle = /*#__PURE__*/ (0, _css.css)("position:absolute;margin-bottom:16px;width:", props.containerWidth, "px;height:", Math.abs(props.height), "px;overflow:visible;", props.active ? "z-index: 2;" : "", " path{stroke:", props.active ? (0, _colors.color_colors_royalty) : (0, _colors.color_variants_royalty_light_20), ";stroke-width:", props.lineSize + 1, "px;fill:transparent;}", "");
    const center = props.containerWidth / 2 - props.offset;
    // special case for straight line line up
    if (props.width == 0) return (0, _react.jsx)("svg", {
        viewBox: `0, 0, ${props.containerWidth}, ${props.height}`,
        className: `${svgStyle} ${props.direction}`
    }, (0, _react.jsx)("path", {
        d: `
                M ${center},0
                L ${center},${props.height}
            `
    }));
    return (0, _react.jsx)("svg", {
        viewBox: `0, 0, ${props.containerWidth}, ${props.height}`,
        className: `${svgStyle} ${props.direction}`
    }, props.direction == "down-right" && (0, _react.jsx)("path", {
        d: `
            M ${center},0
            L ${center},${props.height / 4}
            Q ${center},${props.height / 4 + 10}
              ${center + 10},${props.height / 4 + 10}
            L ${center + props.width - 10},${props.height / 4 + 10}
            Q ${center + props.width},${props.height / 4 + 10}
              ${center + props.width},${props.height / 4 + 20}
            L ${center + props.width},${props.height}
        `
    }), props.direction == "down-left" && (0, _react.jsx)("path", {
        d: `
            M ${center},0
            L ${center},${props.height / 4}
            Q ${center},${props.height / 4 + 10}
              ${center - 10},${props.height / 4 + 10}
            L ${center + props.width + 10},${props.height / 4 + 10}
            Q ${center + props.width},${props.height / 4 + 10}
              ${center + props.width},${props.height / 4 + 20}
            L ${center + props.width},${props.height}
        `
    }), props.direction == "up-left" && (0, _react.jsx)("path", {
        d: `
            M ${center},${props.height}
            L ${center},${props.height / 4 + 20}
            Q ${center},${props.height / 4 + 10}
              ${center - 10},${props.height / 4 + 10}
            L ${center + props.width + 10},${props.height / 4 + 10}
            Q ${center + props.width},${props.height / 4 + 10}
              ${center + props.width},${props.height / 4}
            L ${center + props.width},0
        `
    }), props.direction == "up-right" && (0, _react.jsx)("path", {
        d: `
            M ${center},${props.height}
            L ${center},${props.height / 4 + 20}
            Q ${center},${props.height / 4 + 10}
              ${center + 10},${props.height / 4 + 10}
            L ${center + props.width - 10},${props.height / 4 + 10}
            Q ${center + props.width},${props.height / 4 + 10}
              ${center + props.width},${props.height / 4}
            L ${center + props.width},0
        `
    }));
};
exports.default = TreePath;

},{"@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","../../../constants/colors":"1p3OR","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8fXD2":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _stylesValues = require("../../constants/stylesValues");
var _colors = require("../../constants/colors");
const leftIcon = require("82174cd9ea059476");
const rightIcon = require("d9889c26af6b0ff0");
var leftInterval;
var rightInterval;
const TreeRowPager = (props)=>{
    const handleLeftDown = ()=>{
        props.onLeft();
        if (leftInterval) clearInterval(leftInterval);
        if (rightInterval) clearInterval(rightInterval);
        leftInterval = setInterval(()=>{
            props.onLeft();
        }, 200);
    };
    const handleRightDown = ()=>{
        props.onRight();
        if (leftInterval) clearInterval(leftInterval);
        if (rightInterval) clearInterval(rightInterval);
        rightInterval = setInterval(()=>{
            props.onRight();
        }, 200);
    };
    const handleLeftUp = ()=>{
        clearInterval(leftInterval);
    };
    const handleRightUp = ()=>{
        clearInterval(rightInterval);
    };
    return (0, _react.jsx)("div", {
        className: `${containerStyle} ac-analytics-tracking-pager`
    }, (0, _react.jsx)("img", {
        src: leftIcon,
        onMouseDown: handleLeftDown,
        onMouseUp: handleLeftUp,
        className: props.canMoveLeft ? "enabled" : "disabled"
    }), (0, _react.jsx)("div", {
        className: "separator"
    }), (0, _react.jsx)("img", {
        src: rightIcon,
        onMouseDown: handleRightDown,
        onMouseUp: handleRightUp,
        className: props.canMoveRight ? "enabled" : "disabled"
    }));
};
const containerStyle = /*#__PURE__*/ (0, _css.css)("width:48px;height:24px;border-radius:16px;border:", (0, _stylesValues.style_border_default), ";background:white;display:flex;align-items:center;z-index:5;>img{cursor:pointer;padding:4px;flex:1;margin:3px;}.separator{width:1px;height:12px;background:", (0, _colors.color_shades_dark), ";}.disabled{opacity:0.5;}", "");
exports.default = TreeRowPager;

},{"@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","../../constants/stylesValues":"dHVVv","../../constants/colors":"1p3OR","82174cd9ea059476":"gF9tR","d9889c26af6b0ff0":"jI5WJ","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"gF9tR":[function(require,module,exports) {
module.exports = require("536ae1ed6e50e2d").getBundleURL("kVLro") + require("4de1aac6d78186a9").resolve("73Kic");

},{"536ae1ed6e50e2d":"c7Tr5","4de1aac6d78186a9":"fyJL2"}],"jI5WJ":[function(require,module,exports) {
module.exports = require("94fc0c2ce96d8bbf").getBundleURL("kVLro") + require("f158f634f9b3cde1").resolve("1hl0m");

},{"94fc0c2ce96d8bbf":"c7Tr5","f158f634f9b3cde1":"fyJL2"}],"2y8Bz":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _unstated = require("unstated");
var _applicationContainer = require("../../state/containers/ApplicationContainer");
var _applicationContainerDefault = parcelHelpers.interopDefault(_applicationContainer);
var _customRequestContainer = require("../../state/containers/CustomRequestContainer");
var _customRequestContainerDefault = parcelHelpers.interopDefault(_customRequestContainer);
var _exitMessageContainer = require("../../state/containers/ExitMessageContainer");
var _exitMessageContainerDefault = parcelHelpers.interopDefault(_exitMessageContainer);
var _fallbackMessageContainer = require("../../state/containers/FallbackMessageContainer");
var _fallbackMessageContainerDefault = parcelHelpers.interopDefault(_fallbackMessageContainer);
var _helpMessageContainer = require("../../state/containers/HelpMessageContainer");
var _helpMessageContainerDefault = parcelHelpers.interopDefault(_helpMessageContainer);
var _latestMessageContainer = require("../../state/containers/LatestMessageContainer");
var _latestMessageContainerDefault = parcelHelpers.interopDefault(_latestMessageContainer);
var _numberRangeContainer = require("../../state/containers/NumberRangeContainer");
var _numberRangeContainerDefault = parcelHelpers.interopDefault(_numberRangeContainer);
var _questionAnswerContainer = require("../../state/containers/QuestionAnswerContainer");
var _questionAnswerContainerDefault = parcelHelpers.interopDefault(_questionAnswerContainer);
var _simpleChoiceContainer = require("../../state/containers/SimpleChoiceContainer");
var _simpleChoiceContainerDefault = parcelHelpers.interopDefault(_simpleChoiceContainer);
var _welcomeMessageContainer = require("../../state/containers/WelcomeMessageContainer");
var _welcomeMessageContainerDefault = parcelHelpers.interopDefault(_welcomeMessageContainer);
var _scriptPreview = require("./components/ScriptPreview");
var _scriptPreviewDefault = parcelHelpers.interopDefault(_scriptPreview);
const ConversationScript = (props)=>(0, _react.jsx)((0, _unstated.Subscribe), {
        to: [
            (0, _welcomeMessageContainerDefault.default),
            (0, _helpMessageContainerDefault.default),
            (0, _fallbackMessageContainerDefault.default),
            (0, _exitMessageContainerDefault.default),
            (0, _questionAnswerContainerDefault.default),
            (0, _latestMessageContainerDefault.default),
            (0, _simpleChoiceContainerDefault.default),
            (0, _numberRangeContainerDefault.default),
            (0, _customRequestContainerDefault.default),
            (0, _applicationContainerDefault.default)
        ]
    }, (welcomeContainer, helpContainer, fallbackContainer, exitContainer, questionAnswerContainer, latestMessageContainer, simpleChoiceContainer, numberRangeContainer, customRequestContainer, appContainer)=>(0, _react.jsx)((0, _scriptPreviewDefault.default), {
            welcomeContainer: welcomeContainer,
            helpContainer: helpContainer,
            fallbackContainer: fallbackContainer,
            exitContainer: exitContainer,
            questionAnswerContainer: questionAnswerContainer,
            latestMessageContainer: latestMessageContainer,
            simpleChoiceContainer: simpleChoiceContainer,
            numberRangeContainer: numberRangeContainer,
            customRequestContainer: customRequestContainer,
            appContainer: appContainer,
            applicationId: props.applicationId,
            nodes: props.nodes,
            hasStart: props.hasStart
        }));
exports.default = ConversationScript;

},{"@emotion/react":"djZKr","react":"6uln9","unstated":"grh7p","../../state/containers/ApplicationContainer":"cuqi2","../../state/containers/CustomRequestContainer":"aVO05","../../state/containers/ExitMessageContainer":"lSKl8","../../state/containers/FallbackMessageContainer":"kKZMo","../../state/containers/HelpMessageContainer":"2oQaX","../../state/containers/LatestMessageContainer":"1Hdqb","../../state/containers/NumberRangeContainer":"an6iC","../../state/containers/QuestionAnswerContainer":"hfasy","../../state/containers/SimpleChoiceContainer":"hO0x5","../../state/containers/WelcomeMessageContainer":"j3orW","./components/ScriptPreview":"eDHB4","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"eDHB4":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _turnItem = require("./TurnItem");
var _turnItemDefault = parcelHelpers.interopDefault(_turnItem);
var _sessionStartItem = require("./SessionStartItem");
var _sessionStartItemDefault = parcelHelpers.interopDefault(_sessionStartItem);
var _sessionEndItem = require("./SessionEndItem");
var _sessionEndItemDefault = parcelHelpers.interopDefault(_sessionEndItem);
var _featureTypeIds = require("../../../constants/featureTypeIds");
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
class ScriptPreview extends (0, _reactDefault.default).Component {
    constructor(props){
        super(props);
        this.containers = [
            props.welcomeContainer,
            props.helpContainer,
            props.fallbackContainer,
            props.exitContainer,
            props.questionAnswerContainer,
            props.latestMessageContainer,
            props.simpleChoiceContainer,
            props.numberRangeContainer,
            props.customRequestContainer
        ];
    }
    render() {
        return (0, _react.jsx)("div", {
            className: containerStyle
        }, this.props.hasStart && (0, _react.jsx)((0, _sessionStartItemDefault.default), null), this.props.nodes?.filter((n)=>n != null)?.map((n, i)=>{
            if (n.conversationTrackingNodeType == "Content") {
                const contentNode = n;
                return (0, _react.jsx)((0, _turnItemDefault.default), {
                    key: i,
                    node: contentNode,
                    fallbackContainer: this.props.fallbackContainer,
                    container: this.containers.find((c)=>c.featureTypeId == (contentNode.featureTypeId ?? (0, _featureTypeIds.FallbackFeatureTypeId))),
                    application: this.props.appContainer.state.currentApp
                });
            }
            if (n.conversationTrackingNodeType == "SessionEnd") return (0, _react.jsx)((0, _sessionEndItemDefault.default), {
                key: i
            });
        }));
    }
}
exports.default = ScriptPreview;
const containerStyle = /*#__PURE__*/ (0, _css.css)({
    name: "1k4w0v3",
    styles: "margin-bottom:80px;padding-top:32px"
});

},{"@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","./TurnItem":"8L1oC","./SessionStartItem":"asBTb","./SessionEndItem":"S2Vxc","../../../constants/featureTypeIds":"hPLMP","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8L1oC":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _secondaryLoader = require("../../../components/general/SecondaryLoader");
var _secondaryLoaderDefault = parcelHelpers.interopDefault(_secondaryLoader);
var _colors = require("../../../constants/colors");
var _stylesValues = require("../../../constants/stylesValues");
var _extensions = require("../../../models/extensions");
var _featureTypeIds = require("../../../constants/featureTypeIds");
var _chatConversationFlowViewer = require("../../../components/messagePreviews/ChatConversationFlowViewer");
var _chatConversationFlowViewerDefault = parcelHelpers.interopDefault(_chatConversationFlowViewer);
var _deletedVariationBubble = require("../../../components/messagePreviews/DeletedVariationBubble");
var _deletedVariationBubbleDefault = parcelHelpers.interopDefault(_deletedVariationBubble);
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const expandIcon = require("9e2ea417cad74f56");
class TurnItem extends (0, _reactDefault.default).Component {
    async componentDidMount() {
        const contentItem = this.props.container?.findById(this.props.node.contentId);
        if (!contentItem) {
            const result = await this.props.container?.findFullById(this.props.node.contentId);
            if (result?.resultType != "Ok") this.props.fallbackContainer.findFullById(this.props.node.contentId);
        }
    }
    async componentDidUpdate(prevProps) {
        if (this.props.node?.contentId != prevProps.node?.contentId) {
            const contentItem = this.props.container?.findById(this.props.node.contentId);
            if (!contentItem) {
                const result = await this.props.container?.findFullById(this.props.node.contentId);
                if (result?.resultType != "Ok") this.props.fallbackContainer.findFullById(this.props.node.contentId);
            }
        }
    }
    render() {
        let contentItem = this.props.container.findById(this.props.node.contentId);
        const fallback = this.props.fallbackContainer.findById(this.props.node.contentId);
        if (fallback) contentItem = fallback;
        if (this.props.container.state.isLoadingFull || this.props.fallbackContainer.state.isLoadingFull) return (0, _react.jsx)("div", {
            className: loaderContainer
        }, (0, _react.jsx)((0, _secondaryLoaderDefault.default), null));
        if (!contentItem) return (0, _react.jsx)("div", {
            className: deletedContainer
        }, (0, _react.jsx)((0, _deletedVariationBubbleDefault.default), null));
        return (0, _react.jsx)("div", {
            className: containerStyle
        }, (0, _react.jsx)("div", {
            className: "turn-header"
        }, (0, _react.jsx)("div", {
            className: "item-title-container"
        }, (0, _react.jsx)("img", {
            src: (0, _extensions.getSmallLightFeatureTypeIcon)(fallback ? (0, _featureTypeIds.FallbackFeatureTypeId) : this.props.node.featureTypeId ?? (0, _featureTypeIds.FallbackFeatureTypeId))
        }), (0, _react.jsx)("p", {
            className: "content-item-title"
        }, contentItem?.title ?? "Unknown")), (0, _react.jsx)("a", {
            href: `${(0, _extensions.getEditUrl)(contentItem?.id, contentItem?.applicationFeatureId, fallback ? (0, _featureTypeIds.FallbackFeatureTypeId) : this.props.node.featureTypeId ?? (0, _featureTypeIds.FallbackFeatureTypeId))}analytics/tracking${window.location.search}`,
            target: "_blank"
        }, (0, _react.jsx)("p", null, "Open"), (0, _react.jsx)("img", {
            src: expandIcon
        }))), (0, _react.jsx)("div", {
            className: "preview-container"
        }, (0, _react.jsx)((0, _chatConversationFlowViewerDefault.default), {
            conversationItems: (fallback ? this.props.fallbackContainer : this.props.container).getSimpleSampleFlows(contentItem, this.props.application),
            mediaContainer: null,
            applicationId: this.props.application.id,
            endSession: null,
            responseContainer: null,
            targets: null,
            noHighlights: true
        })));
    }
}
exports.default = TurnItem;
const containerStyle = /*#__PURE__*/ (0, _css.css)("border-top:", (0, _stylesValues.style_border_default), ";margin-bottom:16px;.turn-header{display:flex;align-items:center;margin-top:-20px;padding:0 32px;width:100%;>*{background :", (0, _colors.color_shades_lighter), ";}img{width:16px;height:auto;}.item-title-container{display:flex;align-items:center;padding:8px;>p{color:", (0, _colors.color_text_light), ";font-style:normal;font-weight:normal;font-size:14px;line-height:20px;margin-left:8px;}}>a{color:", (0, _colors.color_text_link), ";padding:8px;display:flex;align-items:center;margin-right:0;margin-left:auto;font-size:14px;line-height:20px;>img{margin-left:8px;}}}.preview-container{padding-bottom:16px;}", "");
const loaderContainer = /*#__PURE__*/ (0, _css.css)("display:flex;flex:1;align-items:center;justify-content:center;width:100%;margin:64px 0;.spinner>div{background:", (0, _colors.color_colors_ocean), ";}", "");
const deletedContainer = /*#__PURE__*/ (0, _css.css)({
    name: "kf1qua",
    styles: "width:100%;display:flex;flex-direction:column;overflow:hidden;margin-bottom:64px"
});

},{"@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","../../../components/general/SecondaryLoader":"7zJiF","../../../constants/colors":"1p3OR","../../../constants/stylesValues":"dHVVv","../../../models/extensions":"7h01B","../../../constants/featureTypeIds":"hPLMP","../../../components/messagePreviews/ChatConversationFlowViewer":"3CD6K","../../../components/messagePreviews/DeletedVariationBubble":"doIhF","9e2ea417cad74f56":"5ttMr","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3CD6K":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _userVariationsBubble = require("./UserVariationsBubble");
var _userVariationsBubbleDefault = parcelHelpers.interopDefault(_userVariationsBubble);
var _deviceChatVariationBubble = require("./DeviceChatVariationBubble");
var _deviceChatVariationBubbleDefault = parcelHelpers.interopDefault(_deviceChatVariationBubble);
var _conversationBranchSwitcher = require("../structure/ConversationFlow/ConversationBranchSwitcher");
var _conversationBranchSwitcherDefault = parcelHelpers.interopDefault(_conversationBranchSwitcher);
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const containerStyle = /*#__PURE__*/ (0, _css.css)({
    name: "1jzrm29",
    styles: "width:100%;display:flex;flex-direction:column;overflow:hidden"
});
class ChatConversationFlowViewer extends (0, _reactDefault.default).Component {
    componentWillMount() {
        this.setState({
            deviceTarget: this.props.targets ? this.props.targets[0] : null
        });
    }
    handleTargetChange(target) {
        this.setState({
            ...this.state,
            deviceTarget: target
        });
    }
    renderBlock(conversationItem, index) {
        return (0, _react.jsx)("div", {
            key: index
        }, (0, _react.jsx)((0, _userVariationsBubbleDefault.default), {
            title: conversationItem.requestTitle,
            variations: conversationItem.requests,
            noHighlights: this.props.noHighlights
        }), (0, _react.jsx)((0, _deviceChatVariationBubbleDefault.default), {
            title: conversationItem.responseTitle,
            variations: conversationItem.responses,
            reprompt: conversationItem.reprompt,
            followUp: conversationItem.followUp,
            deviceTargetId: this.props.responseContainer?.state?.deviceTargets?.find((d)=>!d.supportsSsml && d.supportsDisplayText)?.id,
            assistant: "chat",
            noHighlights: this.props.noHighlights
        }), conversationItem.children && conversationItem.children.length > 0 ? this.renderBranch(conversationItem.children) : null);
    }
    renderBranch(conversationItems) {
        if (conversationItems && conversationItems.length > 1) return (0, _react.jsx)((0, _conversationBranchSwitcherDefault.default), {
            position: 0
        }, conversationItems.map((c, i)=>this.renderBlock(c, i)));
        return conversationItems.map((c, i)=>this.renderBlock(c, i));
    }
    render() {
        return (0, _react.jsx)("div", null, (0, _react.jsx)("div", {
            className: containerStyle
        }, this.renderBranch(this.props.conversationItems), this.props.emptyLabel ? (0, _react.jsx)("p", {
            className: "empty-label-container"
        }, this.props.emptyLabel) : null));
    }
}
exports.default = ChatConversationFlowViewer;

},{"@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","./UserVariationsBubble":"2ASHP","./DeviceChatVariationBubble":"aIuxi","../structure/ConversationFlow/ConversationBranchSwitcher":"jVxKF","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2ASHP":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _horizontalSeparator = require("../structure/HorizontalSeparator");
var _horizontalSeparatorDefault = parcelHelpers.interopDefault(_horizontalSeparator);
var _positionIndicator = require("../structure/ConversationFlow/PositionIndicator");
var _positionIndicatorDefault = parcelHelpers.interopDefault(_positionIndicator);
var _colors = require("../../constants/colors");
var _dompurify = require("dompurify");
var _dompurifyDefault = parcelHelpers.interopDefault(_dompurify);
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const openQuoteIcon = require("79d5897ded68d0e7");
const closeQuoteIcon = require("599c7bf816dc0dda");
const userIcon = require("5e71def6781f781d");
class UserVariationsBubble extends (0, _reactDefault.default).Component {
    componentWillMount() {
        this.setState({
            position: 0
        });
    }
    buildLabel(item) {
        if (!item) return null;
        if (!this.props.noHighlights) item.highlights.forEach((highlight)=>{
            item.content = item.content.replace(highlight, `<span>${highlight}</span>`);
        });
        return (0, _react.jsx)("p", {
            className: inputStyle,
            key: item.id,
            dangerouslySetInnerHTML: {
                __html: (0, _dompurifyDefault.default).sanitize(item.content)
            }
        });
    }
    handlePositionChange(position) {
        this.setState({
            ...this.state,
            position
        });
    }
    render() {
        const { title, variations } = this.props;
        if (!variations) return null;
        return (0, _react.jsx)("div", {
            className: `${containerStyle} ${this.props.className}`
        }, (0, _react.jsx)("img", {
            src: userIcon
        }), (0, _react.jsx)("div", {
            className: bubbleContainer(this.props.bubbleWidthPercentage ?? 75)
        }, title ? (0, _react.jsx)((0, _reactDefault.default).Fragment, null, " ", (0, _react.jsx)("span", {
            className: "title"
        }, title), (0, _react.jsx)((0, _horizontalSeparatorDefault.default), null), " ") : null, (0, _react.jsx)("img", {
            className: "open-quote",
            src: openQuoteIcon
        }), (0, _react.jsx)("div", {
            className: "content-container"
        }, this.buildLabel(variations[this.state.position]), (0, _react.jsx)("p", {
            className: "detail"
        }, this.props.detail)), (0, _react.jsx)("img", {
            className: "close-quote",
            src: closeQuoteIcon
        }), variations.length > 1 ? (0, _react.jsx)((0, _reactDefault.default).Fragment, null, (0, _react.jsx)((0, _horizontalSeparatorDefault.default), null), (0, _react.jsx)("div", {
            className: "carousel-container"
        }, (0, _react.jsx)("span", null, `VARIATION: ${this.state.position + 1} of ${variations.length}`), (0, _react.jsx)((0, _positionIndicatorDefault.default), {
            count: variations.length,
            position: this.state.position,
            onChange: this.handlePositionChange.bind(this)
        }))) : null));
    }
}
const containerStyle = /*#__PURE__*/ (0, _css.css)({
    name: "84huzn",
    styles: "display:flex;align-items:start;>img{background:white;border-radius:50%;margin-top:30px;margin-right:12px;margin-left:12px;}"
});
const bubbleContainer = (bubbleWidth)=>{
    return /*#__PURE__*/ (0, _css.css)("margin:30px 80px 0 0;border:solid 1px ", (0, _colors.greeny_blue), ";box-shadow:-1px 4px 10px 0 ", (0, _colors.dark_grey_blue_20), ";background:white;border-radius:0 10px 10px 10px;padding:24px;display:flex;position:relative;flex-direction:column;flex:1;@media only screen and (min-width: 1240px){max-width:", bubbleWidth, "%;margin-right:auto;margin-left:0;}.content-container{overflow-y:hidden;margin-left:12px;.detail{font-size:10px;margin-top:24px;}}.title{font-family:Muli;font-size:18px;font-weight:600;font-style:normal;font-stretch:normal;line-height:normal;letter-spacing:normal;color:", (0, _colors.dark_grey_blue), ";margin-bottom:24px;}.fade{display:none;width:100%;height:12px;background:linear-gradient(to top, #ffffff, rgba(255, 255, 255, 0));}.open-quote{margin-left:0;margin-right:auto;margin-bottom:16px;margin-top:16px;}.close-quote{margin-right:0;margin-left:auto;margin-bottom:16px;margin-top:0;}.carousel-container{display:flex;align-items:center;justify-content:center;flex-direction:column;margin-top:16px;span{margin-bottom:8px;font-size:10px;font-weight:normal;font-stretch:normal;line-height:normal;letter-spacing:0.4px;text-align:center;color:", (0, _colors.cool_grey), ";}}", "");
};
const inputStyle = /*#__PURE__*/ (0, _css.css)("font-family:Muli;font-size:14px;font-weight:normal;font-style:normal;font-stretch:normal;line-height:normal;letter-spacing:normal;color:", (0, _colors.dark_grey_blue), ";margin-top:12px;span{background:", (0, _colors.highlight_green), ";}", "");
exports.default = UserVariationsBubble;

},{"@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","../structure/HorizontalSeparator":"Pw3HQ","../structure/ConversationFlow/PositionIndicator":"39CHS","../../constants/colors":"1p3OR","dompurify":"5cPaM","79d5897ded68d0e7":"fsPJR","599c7bf816dc0dda":"qzmjz","5e71def6781f781d":"fM7ms","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"39CHS":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _toggleIndicator = require("../../general/ToggleIndicator");
var _toggleIndicatorDefault = parcelHelpers.interopDefault(_toggleIndicator);
var _colors = require("../../../constants/colors");
const indicatorContainer = /*#__PURE__*/ (0, _css.css)("display:flex;align-items:center;.toggle-indicator{cursor:pointer;border-color:", (0, _colors.cool_grey), ";}", "");
const indicatorStyle = /*#__PURE__*/ (0, _css.css)("width:10px;height:10px;border:solid 1px ", (0, _colors.cool_grey), ";border-radius:50%;margin:3px 4px;cursor:pointer;", "");
const selectedIndicatorStyle = /*#__PURE__*/ (0, _css.css)("background:", (0, _colors.cool_grey), ";", "");
const PositionIndicator = (props)=>{
    const createIndicators = ()=>{
        const items = [];
        for(var i = 0; i < props.count; i++){
            const position = i;
            items.push((0, _react.jsx)("div", {
                key: i,
                className: `${indicatorStyle} ${i == props.position ? selectedIndicatorStyle : ""}`,
                onClick: ()=>props.onChange(position)
            }));
        }
        return items;
    };
    return (0, _react.jsx)("div", {
        className: indicatorContainer
    }, (0, _react.jsx)((0, _toggleIndicatorDefault.default), {
        direction: "left",
        onClick: ()=>{
            if (props.position > 0) props.onChange(props.position - 1);
            else props.onChange(props.count - 1);
        }
    }), createIndicators(), (0, _react.jsx)((0, _toggleIndicatorDefault.default), {
        direction: "right",
        onClick: ()=>{
            if (props.position < props.count - 1) props.onChange(props.position + 1);
            else props.onChange(0);
        }
    }));
};
exports.default = PositionIndicator;

},{"@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","../../general/ToggleIndicator":"4eej1","../../../constants/colors":"1p3OR","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"5cPaM":[function(require,module,exports) {
/*! @license DOMPurify 3.3.1 | (c) Cure53 and other contributors | Released under the Apache license 2.0 and Mozilla Public License 2.0 | github.com/cure53/DOMPurify/blob/3.3.1/LICENSE */ (function(global, factory) {
    module.exports = factory();
})(this, function() {
    "use strict";
    const { entries, setPrototypeOf, isFrozen, getPrototypeOf, getOwnPropertyDescriptor } = Object;
    let { freeze, seal, create } = Object; // eslint-disable-line import/no-mutable-exports
    let { apply, construct } = typeof Reflect !== "undefined" && Reflect;
    if (!freeze) freeze = function freeze(x) {
        return x;
    };
    if (!seal) seal = function seal(x) {
        return x;
    };
    if (!apply) apply = function apply(func, thisArg) {
        for(var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)args[_key - 2] = arguments[_key];
        return func.apply(thisArg, args);
    };
    if (!construct) construct = function construct(Func) {
        for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
        return new Func(...args);
    };
    const arrayForEach = unapply(Array.prototype.forEach);
    const arrayLastIndexOf = unapply(Array.prototype.lastIndexOf);
    const arrayPop = unapply(Array.prototype.pop);
    const arrayPush = unapply(Array.prototype.push);
    const arraySplice = unapply(Array.prototype.splice);
    const stringToLowerCase = unapply(String.prototype.toLowerCase);
    const stringToString = unapply(String.prototype.toString);
    const stringMatch = unapply(String.prototype.match);
    const stringReplace = unapply(String.prototype.replace);
    const stringIndexOf = unapply(String.prototype.indexOf);
    const stringTrim = unapply(String.prototype.trim);
    const objectHasOwnProperty = unapply(Object.prototype.hasOwnProperty);
    const regExpTest = unapply(RegExp.prototype.test);
    const typeErrorCreate = unconstruct(TypeError);
    /**
   * Creates a new function that calls the given function with a specified thisArg and arguments.
   *
   * @param func - The function to be wrapped and called.
   * @returns A new function that calls the given function with a specified thisArg and arguments.
   */ function unapply(func) {
        return function(thisArg) {
            if (thisArg instanceof RegExp) thisArg.lastIndex = 0;
            for(var _len3 = arguments.length, args = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++)args[_key3 - 1] = arguments[_key3];
            return apply(func, thisArg, args);
        };
    }
    /**
   * Creates a new function that constructs an instance of the given constructor function with the provided arguments.
   *
   * @param func - The constructor function to be wrapped and called.
   * @returns A new function that constructs an instance of the given constructor function with the provided arguments.
   */ function unconstruct(Func) {
        return function() {
            for(var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++)args[_key4] = arguments[_key4];
            return construct(Func, args);
        };
    }
    /**
   * Add properties to a lookup table
   *
   * @param set - The set to which elements will be added.
   * @param array - The array containing elements to be added to the set.
   * @param transformCaseFunc - An optional function to transform the case of each element before adding to the set.
   * @returns The modified set with added elements.
   */ function addToSet(set, array) {
        let transformCaseFunc = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : stringToLowerCase;
        if (setPrototypeOf) // Make 'in' and truthy checks like Boolean(set.constructor)
        // independent of any properties defined on Object.prototype.
        // Prevent prototype setters from intercepting set as a this value.
        setPrototypeOf(set, null);
        let l = array.length;
        while(l--){
            let element = array[l];
            if (typeof element === "string") {
                const lcElement = transformCaseFunc(element);
                if (lcElement !== element) {
                    // Config presets (e.g. tags.js, attrs.js) are immutable.
                    if (!isFrozen(array)) array[l] = lcElement;
                    element = lcElement;
                }
            }
            set[element] = true;
        }
        return set;
    }
    /**
   * Clean up an array to harden against CSPP
   *
   * @param array - The array to be cleaned.
   * @returns The cleaned version of the array
   */ function cleanArray(array) {
        for(let index = 0; index < array.length; index++){
            const isPropertyExist = objectHasOwnProperty(array, index);
            if (!isPropertyExist) array[index] = null;
        }
        return array;
    }
    /**
   * Shallow clone an object
   *
   * @param object - The object to be cloned.
   * @returns A new object that copies the original.
   */ function clone(object) {
        const newObject = create(null);
        for (const [property, value] of entries(object)){
            const isPropertyExist = objectHasOwnProperty(object, property);
            if (isPropertyExist) {
                if (Array.isArray(value)) newObject[property] = cleanArray(value);
                else if (value && typeof value === "object" && value.constructor === Object) newObject[property] = clone(value);
                else newObject[property] = value;
            }
        }
        return newObject;
    }
    /**
   * This method automatically checks if the prop is function or getter and behaves accordingly.
   *
   * @param object - The object to look up the getter function in its prototype chain.
   * @param prop - The property name for which to find the getter function.
   * @returns The getter function found in the prototype chain or a fallback function.
   */ function lookupGetter(object, prop) {
        while(object !== null){
            const desc = getOwnPropertyDescriptor(object, prop);
            if (desc) {
                if (desc.get) return unapply(desc.get);
                if (typeof desc.value === "function") return unapply(desc.value);
            }
            object = getPrototypeOf(object);
        }
        function fallbackValue() {
            return null;
        }
        return fallbackValue;
    }
    const html$1 = freeze([
        "a",
        "abbr",
        "acronym",
        "address",
        "area",
        "article",
        "aside",
        "audio",
        "b",
        "bdi",
        "bdo",
        "big",
        "blink",
        "blockquote",
        "body",
        "br",
        "button",
        "canvas",
        "caption",
        "center",
        "cite",
        "code",
        "col",
        "colgroup",
        "content",
        "data",
        "datalist",
        "dd",
        "decorator",
        "del",
        "details",
        "dfn",
        "dialog",
        "dir",
        "div",
        "dl",
        "dt",
        "element",
        "em",
        "fieldset",
        "figcaption",
        "figure",
        "font",
        "footer",
        "form",
        "h1",
        "h2",
        "h3",
        "h4",
        "h5",
        "h6",
        "head",
        "header",
        "hgroup",
        "hr",
        "html",
        "i",
        "img",
        "input",
        "ins",
        "kbd",
        "label",
        "legend",
        "li",
        "main",
        "map",
        "mark",
        "marquee",
        "menu",
        "menuitem",
        "meter",
        "nav",
        "nobr",
        "ol",
        "optgroup",
        "option",
        "output",
        "p",
        "picture",
        "pre",
        "progress",
        "q",
        "rp",
        "rt",
        "ruby",
        "s",
        "samp",
        "search",
        "section",
        "select",
        "shadow",
        "slot",
        "small",
        "source",
        "spacer",
        "span",
        "strike",
        "strong",
        "style",
        "sub",
        "summary",
        "sup",
        "table",
        "tbody",
        "td",
        "template",
        "textarea",
        "tfoot",
        "th",
        "thead",
        "time",
        "tr",
        "track",
        "tt",
        "u",
        "ul",
        "var",
        "video",
        "wbr"
    ]);
    const svg$1 = freeze([
        "svg",
        "a",
        "altglyph",
        "altglyphdef",
        "altglyphitem",
        "animatecolor",
        "animatemotion",
        "animatetransform",
        "circle",
        "clippath",
        "defs",
        "desc",
        "ellipse",
        "enterkeyhint",
        "exportparts",
        "filter",
        "font",
        "g",
        "glyph",
        "glyphref",
        "hkern",
        "image",
        "inputmode",
        "line",
        "lineargradient",
        "marker",
        "mask",
        "metadata",
        "mpath",
        "part",
        "path",
        "pattern",
        "polygon",
        "polyline",
        "radialgradient",
        "rect",
        "stop",
        "style",
        "switch",
        "symbol",
        "text",
        "textpath",
        "title",
        "tref",
        "tspan",
        "view",
        "vkern"
    ]);
    const svgFilters = freeze([
        "feBlend",
        "feColorMatrix",
        "feComponentTransfer",
        "feComposite",
        "feConvolveMatrix",
        "feDiffuseLighting",
        "feDisplacementMap",
        "feDistantLight",
        "feDropShadow",
        "feFlood",
        "feFuncA",
        "feFuncB",
        "feFuncG",
        "feFuncR",
        "feGaussianBlur",
        "feImage",
        "feMerge",
        "feMergeNode",
        "feMorphology",
        "feOffset",
        "fePointLight",
        "feSpecularLighting",
        "feSpotLight",
        "feTile",
        "feTurbulence"
    ]);
    // List of SVG elements that are disallowed by default.
    // We still need to know them so that we can do namespace
    // checks properly in case one wants to add them to
    // allow-list.
    const svgDisallowed = freeze([
        "animate",
        "color-profile",
        "cursor",
        "discard",
        "font-face",
        "font-face-format",
        "font-face-name",
        "font-face-src",
        "font-face-uri",
        "foreignobject",
        "hatch",
        "hatchpath",
        "mesh",
        "meshgradient",
        "meshpatch",
        "meshrow",
        "missing-glyph",
        "script",
        "set",
        "solidcolor",
        "unknown",
        "use"
    ]);
    const mathMl$1 = freeze([
        "math",
        "menclose",
        "merror",
        "mfenced",
        "mfrac",
        "mglyph",
        "mi",
        "mlabeledtr",
        "mmultiscripts",
        "mn",
        "mo",
        "mover",
        "mpadded",
        "mphantom",
        "mroot",
        "mrow",
        "ms",
        "mspace",
        "msqrt",
        "mstyle",
        "msub",
        "msup",
        "msubsup",
        "mtable",
        "mtd",
        "mtext",
        "mtr",
        "munder",
        "munderover",
        "mprescripts"
    ]);
    // Similarly to SVG, we want to know all MathML elements,
    // even those that we disallow by default.
    const mathMlDisallowed = freeze([
        "maction",
        "maligngroup",
        "malignmark",
        "mlongdiv",
        "mscarries",
        "mscarry",
        "msgroup",
        "mstack",
        "msline",
        "msrow",
        "semantics",
        "annotation",
        "annotation-xml",
        "mprescripts",
        "none"
    ]);
    const text = freeze([
        "#text"
    ]);
    const html = freeze([
        "accept",
        "action",
        "align",
        "alt",
        "autocapitalize",
        "autocomplete",
        "autopictureinpicture",
        "autoplay",
        "background",
        "bgcolor",
        "border",
        "capture",
        "cellpadding",
        "cellspacing",
        "checked",
        "cite",
        "class",
        "clear",
        "color",
        "cols",
        "colspan",
        "controls",
        "controlslist",
        "coords",
        "crossorigin",
        "datetime",
        "decoding",
        "default",
        "dir",
        "disabled",
        "disablepictureinpicture",
        "disableremoteplayback",
        "download",
        "draggable",
        "enctype",
        "enterkeyhint",
        "exportparts",
        "face",
        "for",
        "headers",
        "height",
        "hidden",
        "high",
        "href",
        "hreflang",
        "id",
        "inert",
        "inputmode",
        "integrity",
        "ismap",
        "kind",
        "label",
        "lang",
        "list",
        "loading",
        "loop",
        "low",
        "max",
        "maxlength",
        "media",
        "method",
        "min",
        "minlength",
        "multiple",
        "muted",
        "name",
        "nonce",
        "noshade",
        "novalidate",
        "nowrap",
        "open",
        "optimum",
        "part",
        "pattern",
        "placeholder",
        "playsinline",
        "popover",
        "popovertarget",
        "popovertargetaction",
        "poster",
        "preload",
        "pubdate",
        "radiogroup",
        "readonly",
        "rel",
        "required",
        "rev",
        "reversed",
        "role",
        "rows",
        "rowspan",
        "spellcheck",
        "scope",
        "selected",
        "shape",
        "size",
        "sizes",
        "slot",
        "span",
        "srclang",
        "start",
        "src",
        "srcset",
        "step",
        "style",
        "summary",
        "tabindex",
        "title",
        "translate",
        "type",
        "usemap",
        "valign",
        "value",
        "width",
        "wrap",
        "xmlns",
        "slot"
    ]);
    const svg = freeze([
        "accent-height",
        "accumulate",
        "additive",
        "alignment-baseline",
        "amplitude",
        "ascent",
        "attributename",
        "attributetype",
        "azimuth",
        "basefrequency",
        "baseline-shift",
        "begin",
        "bias",
        "by",
        "class",
        "clip",
        "clippathunits",
        "clip-path",
        "clip-rule",
        "color",
        "color-interpolation",
        "color-interpolation-filters",
        "color-profile",
        "color-rendering",
        "cx",
        "cy",
        "d",
        "dx",
        "dy",
        "diffuseconstant",
        "direction",
        "display",
        "divisor",
        "dur",
        "edgemode",
        "elevation",
        "end",
        "exponent",
        "fill",
        "fill-opacity",
        "fill-rule",
        "filter",
        "filterunits",
        "flood-color",
        "flood-opacity",
        "font-family",
        "font-size",
        "font-size-adjust",
        "font-stretch",
        "font-style",
        "font-variant",
        "font-weight",
        "fx",
        "fy",
        "g1",
        "g2",
        "glyph-name",
        "glyphref",
        "gradientunits",
        "gradienttransform",
        "height",
        "href",
        "id",
        "image-rendering",
        "in",
        "in2",
        "intercept",
        "k",
        "k1",
        "k2",
        "k3",
        "k4",
        "kerning",
        "keypoints",
        "keysplines",
        "keytimes",
        "lang",
        "lengthadjust",
        "letter-spacing",
        "kernelmatrix",
        "kernelunitlength",
        "lighting-color",
        "local",
        "marker-end",
        "marker-mid",
        "marker-start",
        "markerheight",
        "markerunits",
        "markerwidth",
        "maskcontentunits",
        "maskunits",
        "max",
        "mask",
        "mask-type",
        "media",
        "method",
        "mode",
        "min",
        "name",
        "numoctaves",
        "offset",
        "operator",
        "opacity",
        "order",
        "orient",
        "orientation",
        "origin",
        "overflow",
        "paint-order",
        "path",
        "pathlength",
        "patterncontentunits",
        "patterntransform",
        "patternunits",
        "points",
        "preservealpha",
        "preserveaspectratio",
        "primitiveunits",
        "r",
        "rx",
        "ry",
        "radius",
        "refx",
        "refy",
        "repeatcount",
        "repeatdur",
        "restart",
        "result",
        "rotate",
        "scale",
        "seed",
        "shape-rendering",
        "slope",
        "specularconstant",
        "specularexponent",
        "spreadmethod",
        "startoffset",
        "stddeviation",
        "stitchtiles",
        "stop-color",
        "stop-opacity",
        "stroke-dasharray",
        "stroke-dashoffset",
        "stroke-linecap",
        "stroke-linejoin",
        "stroke-miterlimit",
        "stroke-opacity",
        "stroke",
        "stroke-width",
        "style",
        "surfacescale",
        "systemlanguage",
        "tabindex",
        "tablevalues",
        "targetx",
        "targety",
        "transform",
        "transform-origin",
        "text-anchor",
        "text-decoration",
        "text-rendering",
        "textlength",
        "type",
        "u1",
        "u2",
        "unicode",
        "values",
        "viewbox",
        "visibility",
        "version",
        "vert-adv-y",
        "vert-origin-x",
        "vert-origin-y",
        "width",
        "word-spacing",
        "wrap",
        "writing-mode",
        "xchannelselector",
        "ychannelselector",
        "x",
        "x1",
        "x2",
        "xmlns",
        "y",
        "y1",
        "y2",
        "z",
        "zoomandpan"
    ]);
    const mathMl = freeze([
        "accent",
        "accentunder",
        "align",
        "bevelled",
        "close",
        "columnsalign",
        "columnlines",
        "columnspan",
        "denomalign",
        "depth",
        "dir",
        "display",
        "displaystyle",
        "encoding",
        "fence",
        "frame",
        "height",
        "href",
        "id",
        "largeop",
        "length",
        "linethickness",
        "lspace",
        "lquote",
        "mathbackground",
        "mathcolor",
        "mathsize",
        "mathvariant",
        "maxsize",
        "minsize",
        "movablelimits",
        "notation",
        "numalign",
        "open",
        "rowalign",
        "rowlines",
        "rowspacing",
        "rowspan",
        "rspace",
        "rquote",
        "scriptlevel",
        "scriptminsize",
        "scriptsizemultiplier",
        "selection",
        "separator",
        "separators",
        "stretchy",
        "subscriptshift",
        "supscriptshift",
        "symmetric",
        "voffset",
        "width",
        "xmlns"
    ]);
    const xml = freeze([
        "xlink:href",
        "xml:id",
        "xlink:title",
        "xml:space",
        "xmlns:xlink"
    ]);
    // eslint-disable-next-line unicorn/better-regex
    const MUSTACHE_EXPR = seal(/\{\{[\w\W]*|[\w\W]*\}\}/gm); // Specify template detection regex for SAFE_FOR_TEMPLATES mode
    const ERB_EXPR = seal(/<%[\w\W]*|[\w\W]*%>/gm);
    const TMPLIT_EXPR = seal(/\$\{[\w\W]*/gm); // eslint-disable-line unicorn/better-regex
    const DATA_ATTR = seal(/^data-[\-\w.\u00B7-\uFFFF]+$/); // eslint-disable-line no-useless-escape
    const ARIA_ATTR = seal(/^aria-[\-\w]+$/); // eslint-disable-line no-useless-escape
    const IS_ALLOWED_URI = seal(/^(?:(?:(?:f|ht)tps?|mailto|tel|callto|sms|cid|xmpp|matrix):|[^a-z]|[a-z+.\-]+(?:[^a-z+.\-:]|$))/i // eslint-disable-line no-useless-escape
    );
    const IS_SCRIPT_OR_DATA = seal(/^(?:\w+script|data):/i);
    const ATTR_WHITESPACE = seal(/[\u0000-\u0020\u00A0\u1680\u180E\u2000-\u2029\u205F\u3000]/g // eslint-disable-line no-control-regex
    );
    const DOCTYPE_NAME = seal(/^html$/i);
    const CUSTOM_ELEMENT = seal(/^[a-z][.\w]*(-[.\w]+)+$/i);
    var EXPRESSIONS = /*#__PURE__*/ Object.freeze({
        __proto__: null,
        ARIA_ATTR: ARIA_ATTR,
        ATTR_WHITESPACE: ATTR_WHITESPACE,
        CUSTOM_ELEMENT: CUSTOM_ELEMENT,
        DATA_ATTR: DATA_ATTR,
        DOCTYPE_NAME: DOCTYPE_NAME,
        ERB_EXPR: ERB_EXPR,
        IS_ALLOWED_URI: IS_ALLOWED_URI,
        IS_SCRIPT_OR_DATA: IS_SCRIPT_OR_DATA,
        MUSTACHE_EXPR: MUSTACHE_EXPR,
        TMPLIT_EXPR: TMPLIT_EXPR
    });
    /* eslint-disable @typescript-eslint/indent */ // https://developer.mozilla.org/en-US/docs/Web/API/Node/nodeType
    const NODE_TYPE = {
        element: 1,
        attribute: 2,
        text: 3,
        cdataSection: 4,
        entityReference: 5,
        // Deprecated
        entityNode: 6,
        // Deprecated
        progressingInstruction: 7,
        comment: 8,
        document: 9,
        documentType: 10,
        documentFragment: 11,
        notation: 12 // Deprecated
    };
    const getGlobal = function getGlobal() {
        return typeof window === "undefined" ? null : window;
    };
    /**
   * Creates a no-op policy for internal use only.
   * Don't export this function outside this module!
   * @param trustedTypes The policy factory.
   * @param purifyHostElement The Script element used to load DOMPurify (to determine policy name suffix).
   * @return The policy created (or null, if Trusted Types
   * are not supported or creating the policy failed).
   */ const _createTrustedTypesPolicy = function _createTrustedTypesPolicy(trustedTypes, purifyHostElement) {
        if (typeof trustedTypes !== "object" || typeof trustedTypes.createPolicy !== "function") return null;
        // Allow the callers to control the unique policy name
        // by adding a data-tt-policy-suffix to the script element with the DOMPurify.
        // Policy creation with duplicate names throws in Trusted Types.
        let suffix = null;
        const ATTR_NAME = "data-tt-policy-suffix";
        if (purifyHostElement && purifyHostElement.hasAttribute(ATTR_NAME)) suffix = purifyHostElement.getAttribute(ATTR_NAME);
        const policyName = "dompurify" + (suffix ? "#" + suffix : "");
        try {
            return trustedTypes.createPolicy(policyName, {
                createHTML (html) {
                    return html;
                },
                createScriptURL (scriptUrl) {
                    return scriptUrl;
                }
            });
        } catch (_) {
            // Policy creation failed (most likely another DOMPurify script has
            // already run). Skip creating the policy, as this will only cause errors
            // if TT are enforced.
            console.warn("TrustedTypes policy " + policyName + " could not be created.");
            return null;
        }
    };
    const _createHooksMap = function _createHooksMap() {
        return {
            afterSanitizeAttributes: [],
            afterSanitizeElements: [],
            afterSanitizeShadowDOM: [],
            beforeSanitizeAttributes: [],
            beforeSanitizeElements: [],
            beforeSanitizeShadowDOM: [],
            uponSanitizeAttribute: [],
            uponSanitizeElement: [],
            uponSanitizeShadowNode: []
        };
    };
    function createDOMPurify() {
        let window1 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : getGlobal();
        const DOMPurify = (root)=>createDOMPurify(root);
        DOMPurify.version = "3.3.1";
        DOMPurify.removed = [];
        if (!window1 || !window1.document || window1.document.nodeType !== NODE_TYPE.document || !window1.Element) {
            // Not running in a browser, provide a factory function
            // so that you can pass your own Window
            DOMPurify.isSupported = false;
            return DOMPurify;
        }
        let { document } = window1;
        const originalDocument = document;
        const currentScript = originalDocument.currentScript;
        const { DocumentFragment, HTMLTemplateElement, Node, Element, NodeFilter, NamedNodeMap = window1.NamedNodeMap || window1.MozNamedAttrMap, HTMLFormElement, DOMParser, trustedTypes } = window1;
        const ElementPrototype = Element.prototype;
        const cloneNode = lookupGetter(ElementPrototype, "cloneNode");
        const remove = lookupGetter(ElementPrototype, "remove");
        const getNextSibling = lookupGetter(ElementPrototype, "nextSibling");
        const getChildNodes = lookupGetter(ElementPrototype, "childNodes");
        const getParentNode = lookupGetter(ElementPrototype, "parentNode");
        // As per issue #47, the web-components registry is inherited by a
        // new document created via createHTMLDocument. As per the spec
        // (http://w3c.github.io/webcomponents/spec/custom/#creating-and-passing-registries)
        // a new empty registry is used when creating a template contents owner
        // document, so we use that as our parent document to ensure nothing
        // is inherited.
        if (typeof HTMLTemplateElement === "function") {
            const template = document.createElement("template");
            if (template.content && template.content.ownerDocument) document = template.content.ownerDocument;
        }
        let trustedTypesPolicy;
        let emptyHTML = "";
        const { implementation, createNodeIterator, createDocumentFragment, getElementsByTagName } = document;
        const { importNode } = originalDocument;
        let hooks = _createHooksMap();
        /**
     * Expose whether this browser supports running the full DOMPurify.
     */ DOMPurify.isSupported = typeof entries === "function" && typeof getParentNode === "function" && implementation && implementation.createHTMLDocument !== undefined;
        const { MUSTACHE_EXPR, ERB_EXPR, TMPLIT_EXPR, DATA_ATTR, ARIA_ATTR, IS_SCRIPT_OR_DATA, ATTR_WHITESPACE, CUSTOM_ELEMENT } = EXPRESSIONS;
        let { IS_ALLOWED_URI: IS_ALLOWED_URI$1 } = EXPRESSIONS;
        /**
     * We consider the elements and attributes below to be safe. Ideally
     * don't add any new ones but feel free to remove unwanted ones.
     */ /* allowed element names */ let ALLOWED_TAGS = null;
        const DEFAULT_ALLOWED_TAGS = addToSet({}, [
            ...html$1,
            ...svg$1,
            ...svgFilters,
            ...mathMl$1,
            ...text
        ]);
        /* Allowed attribute names */ let ALLOWED_ATTR = null;
        const DEFAULT_ALLOWED_ATTR = addToSet({}, [
            ...html,
            ...svg,
            ...mathMl,
            ...xml
        ]);
        /*
     * Configure how DOMPurify should handle custom elements and their attributes as well as customized built-in elements.
     * @property {RegExp|Function|null} tagNameCheck one of [null, regexPattern, predicate]. Default: `null` (disallow any custom elements)
     * @property {RegExp|Function|null} attributeNameCheck one of [null, regexPattern, predicate]. Default: `null` (disallow any attributes not on the allow list)
     * @property {boolean} allowCustomizedBuiltInElements allow custom elements derived from built-ins if they pass CUSTOM_ELEMENT_HANDLING.tagNameCheck. Default: `false`.
     */ let CUSTOM_ELEMENT_HANDLING = Object.seal(create(null, {
            tagNameCheck: {
                writable: true,
                configurable: false,
                enumerable: true,
                value: null
            },
            attributeNameCheck: {
                writable: true,
                configurable: false,
                enumerable: true,
                value: null
            },
            allowCustomizedBuiltInElements: {
                writable: true,
                configurable: false,
                enumerable: true,
                value: false
            }
        }));
        /* Explicitly forbidden tags (overrides ALLOWED_TAGS/ADD_TAGS) */ let FORBID_TAGS = null;
        /* Explicitly forbidden attributes (overrides ALLOWED_ATTR/ADD_ATTR) */ let FORBID_ATTR = null;
        /* Config object to store ADD_TAGS/ADD_ATTR functions (when used as functions) */ const EXTRA_ELEMENT_HANDLING = Object.seal(create(null, {
            tagCheck: {
                writable: true,
                configurable: false,
                enumerable: true,
                value: null
            },
            attributeCheck: {
                writable: true,
                configurable: false,
                enumerable: true,
                value: null
            }
        }));
        /* Decide if ARIA attributes are okay */ let ALLOW_ARIA_ATTR = true;
        /* Decide if custom data attributes are okay */ let ALLOW_DATA_ATTR = true;
        /* Decide if unknown protocols are okay */ let ALLOW_UNKNOWN_PROTOCOLS = false;
        /* Decide if self-closing tags in attributes are allowed.
     * Usually removed due to a mXSS issue in jQuery 3.0 */ let ALLOW_SELF_CLOSE_IN_ATTR = true;
        /* Output should be safe for common template engines.
     * This means, DOMPurify removes data attributes, mustaches and ERB
     */ let SAFE_FOR_TEMPLATES = false;
        /* Output should be safe even for XML used within HTML and alike.
     * This means, DOMPurify removes comments when containing risky content.
     */ let SAFE_FOR_XML = true;
        /* Decide if document with <html>... should be returned */ let WHOLE_DOCUMENT = false;
        /* Track whether config is already set on this instance of DOMPurify. */ let SET_CONFIG = false;
        /* Decide if all elements (e.g. style, script) must be children of
     * document.body. By default, browsers might move them to document.head */ let FORCE_BODY = false;
        /* Decide if a DOM `HTMLBodyElement` should be returned, instead of a html
     * string (or a TrustedHTML object if Trusted Types are supported).
     * If `WHOLE_DOCUMENT` is enabled a `HTMLHtmlElement` will be returned instead
     */ let RETURN_DOM = false;
        /* Decide if a DOM `DocumentFragment` should be returned, instead of a html
     * string  (or a TrustedHTML object if Trusted Types are supported) */ let RETURN_DOM_FRAGMENT = false;
        /* Try to return a Trusted Type object instead of a string, return a string in
     * case Trusted Types are not supported  */ let RETURN_TRUSTED_TYPE = false;
        /* Output should be free from DOM clobbering attacks?
     * This sanitizes markups named with colliding, clobberable built-in DOM APIs.
     */ let SANITIZE_DOM = true;
        /* Achieve full DOM Clobbering protection by isolating the namespace of named
     * properties and JS variables, mitigating attacks that abuse the HTML/DOM spec rules.
     *
     * HTML/DOM spec rules that enable DOM Clobbering:
     *   - Named Access on Window (§7.3.3)
     *   - DOM Tree Accessors (§3.1.5)
     *   - Form Element Parent-Child Relations (§4.10.3)
     *   - Iframe srcdoc / Nested WindowProxies (§4.8.5)
     *   - HTMLCollection (§4.2.10.2)
     *
     * Namespace isolation is implemented by prefixing `id` and `name` attributes
     * with a constant string, i.e., `user-content-`
     */ let SANITIZE_NAMED_PROPS = false;
        const SANITIZE_NAMED_PROPS_PREFIX = "user-content-";
        /* Keep element content when removing element? */ let KEEP_CONTENT = true;
        /* If a `Node` is passed to sanitize(), then performs sanitization in-place instead
     * of importing it into a new Document and returning a sanitized copy */ let IN_PLACE = false;
        /* Allow usage of profiles like html, svg and mathMl */ let USE_PROFILES = {};
        /* Tags to ignore content of when KEEP_CONTENT is true */ let FORBID_CONTENTS = null;
        const DEFAULT_FORBID_CONTENTS = addToSet({}, [
            "annotation-xml",
            "audio",
            "colgroup",
            "desc",
            "foreignobject",
            "head",
            "iframe",
            "math",
            "mi",
            "mn",
            "mo",
            "ms",
            "mtext",
            "noembed",
            "noframes",
            "noscript",
            "plaintext",
            "script",
            "style",
            "svg",
            "template",
            "thead",
            "title",
            "video",
            "xmp"
        ]);
        /* Tags that are safe for data: URIs */ let DATA_URI_TAGS = null;
        const DEFAULT_DATA_URI_TAGS = addToSet({}, [
            "audio",
            "video",
            "img",
            "source",
            "image",
            "track"
        ]);
        /* Attributes safe for values like "javascript:" */ let URI_SAFE_ATTRIBUTES = null;
        const DEFAULT_URI_SAFE_ATTRIBUTES = addToSet({}, [
            "alt",
            "class",
            "for",
            "id",
            "label",
            "name",
            "pattern",
            "placeholder",
            "role",
            "summary",
            "title",
            "value",
            "style",
            "xmlns"
        ]);
        const MATHML_NAMESPACE = "http://www.w3.org/1998/Math/MathML";
        const SVG_NAMESPACE = "http://www.w3.org/2000/svg";
        const HTML_NAMESPACE = "http://www.w3.org/1999/xhtml";
        /* Document namespace */ let NAMESPACE = HTML_NAMESPACE;
        let IS_EMPTY_INPUT = false;
        /* Allowed XHTML+XML namespaces */ let ALLOWED_NAMESPACES = null;
        const DEFAULT_ALLOWED_NAMESPACES = addToSet({}, [
            MATHML_NAMESPACE,
            SVG_NAMESPACE,
            HTML_NAMESPACE
        ], stringToString);
        let MATHML_TEXT_INTEGRATION_POINTS = addToSet({}, [
            "mi",
            "mo",
            "mn",
            "ms",
            "mtext"
        ]);
        let HTML_INTEGRATION_POINTS = addToSet({}, [
            "annotation-xml"
        ]);
        // Certain elements are allowed in both SVG and HTML
        // namespace. We need to specify them explicitly
        // so that they don't get erroneously deleted from
        // HTML namespace.
        const COMMON_SVG_AND_HTML_ELEMENTS = addToSet({}, [
            "title",
            "style",
            "font",
            "a",
            "script"
        ]);
        /* Parsing of strict XHTML documents */ let PARSER_MEDIA_TYPE = null;
        const SUPPORTED_PARSER_MEDIA_TYPES = [
            "application/xhtml+xml",
            "text/html"
        ];
        const DEFAULT_PARSER_MEDIA_TYPE = "text/html";
        let transformCaseFunc = null;
        /* Keep a reference to config to pass to hooks */ let CONFIG = null;
        /* Ideally, do not touch anything below this line */ /* ______________________________________________ */ const formElement = document.createElement("form");
        const isRegexOrFunction = function isRegexOrFunction(testValue) {
            return testValue instanceof RegExp || testValue instanceof Function;
        };
        /**
     * _parseConfig
     *
     * @param cfg optional config literal
     */ // eslint-disable-next-line complexity
        const _parseConfig = function _parseConfig() {
            let cfg = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
            if (CONFIG && CONFIG === cfg) return;
            /* Shield configuration object from tampering */ if (!cfg || typeof cfg !== "object") cfg = {};
            /* Shield configuration object from prototype pollution */ cfg = clone(cfg);
            PARSER_MEDIA_TYPE = // eslint-disable-next-line unicorn/prefer-includes
            SUPPORTED_PARSER_MEDIA_TYPES.indexOf(cfg.PARSER_MEDIA_TYPE) === -1 ? DEFAULT_PARSER_MEDIA_TYPE : cfg.PARSER_MEDIA_TYPE;
            // HTML tags and attributes are not case-sensitive, converting to lowercase. Keeping XHTML as is.
            transformCaseFunc = PARSER_MEDIA_TYPE === "application/xhtml+xml" ? stringToString : stringToLowerCase;
            /* Set configuration parameters */ ALLOWED_TAGS = objectHasOwnProperty(cfg, "ALLOWED_TAGS") ? addToSet({}, cfg.ALLOWED_TAGS, transformCaseFunc) : DEFAULT_ALLOWED_TAGS;
            ALLOWED_ATTR = objectHasOwnProperty(cfg, "ALLOWED_ATTR") ? addToSet({}, cfg.ALLOWED_ATTR, transformCaseFunc) : DEFAULT_ALLOWED_ATTR;
            ALLOWED_NAMESPACES = objectHasOwnProperty(cfg, "ALLOWED_NAMESPACES") ? addToSet({}, cfg.ALLOWED_NAMESPACES, stringToString) : DEFAULT_ALLOWED_NAMESPACES;
            URI_SAFE_ATTRIBUTES = objectHasOwnProperty(cfg, "ADD_URI_SAFE_ATTR") ? addToSet(clone(DEFAULT_URI_SAFE_ATTRIBUTES), cfg.ADD_URI_SAFE_ATTR, transformCaseFunc) : DEFAULT_URI_SAFE_ATTRIBUTES;
            DATA_URI_TAGS = objectHasOwnProperty(cfg, "ADD_DATA_URI_TAGS") ? addToSet(clone(DEFAULT_DATA_URI_TAGS), cfg.ADD_DATA_URI_TAGS, transformCaseFunc) : DEFAULT_DATA_URI_TAGS;
            FORBID_CONTENTS = objectHasOwnProperty(cfg, "FORBID_CONTENTS") ? addToSet({}, cfg.FORBID_CONTENTS, transformCaseFunc) : DEFAULT_FORBID_CONTENTS;
            FORBID_TAGS = objectHasOwnProperty(cfg, "FORBID_TAGS") ? addToSet({}, cfg.FORBID_TAGS, transformCaseFunc) : clone({});
            FORBID_ATTR = objectHasOwnProperty(cfg, "FORBID_ATTR") ? addToSet({}, cfg.FORBID_ATTR, transformCaseFunc) : clone({});
            USE_PROFILES = objectHasOwnProperty(cfg, "USE_PROFILES") ? cfg.USE_PROFILES : false;
            ALLOW_ARIA_ATTR = cfg.ALLOW_ARIA_ATTR !== false; // Default true
            ALLOW_DATA_ATTR = cfg.ALLOW_DATA_ATTR !== false; // Default true
            ALLOW_UNKNOWN_PROTOCOLS = cfg.ALLOW_UNKNOWN_PROTOCOLS || false; // Default false
            ALLOW_SELF_CLOSE_IN_ATTR = cfg.ALLOW_SELF_CLOSE_IN_ATTR !== false; // Default true
            SAFE_FOR_TEMPLATES = cfg.SAFE_FOR_TEMPLATES || false; // Default false
            SAFE_FOR_XML = cfg.SAFE_FOR_XML !== false; // Default true
            WHOLE_DOCUMENT = cfg.WHOLE_DOCUMENT || false; // Default false
            RETURN_DOM = cfg.RETURN_DOM || false; // Default false
            RETURN_DOM_FRAGMENT = cfg.RETURN_DOM_FRAGMENT || false; // Default false
            RETURN_TRUSTED_TYPE = cfg.RETURN_TRUSTED_TYPE || false; // Default false
            FORCE_BODY = cfg.FORCE_BODY || false; // Default false
            SANITIZE_DOM = cfg.SANITIZE_DOM !== false; // Default true
            SANITIZE_NAMED_PROPS = cfg.SANITIZE_NAMED_PROPS || false; // Default false
            KEEP_CONTENT = cfg.KEEP_CONTENT !== false; // Default true
            IN_PLACE = cfg.IN_PLACE || false; // Default false
            IS_ALLOWED_URI$1 = cfg.ALLOWED_URI_REGEXP || IS_ALLOWED_URI;
            NAMESPACE = cfg.NAMESPACE || HTML_NAMESPACE;
            MATHML_TEXT_INTEGRATION_POINTS = cfg.MATHML_TEXT_INTEGRATION_POINTS || MATHML_TEXT_INTEGRATION_POINTS;
            HTML_INTEGRATION_POINTS = cfg.HTML_INTEGRATION_POINTS || HTML_INTEGRATION_POINTS;
            CUSTOM_ELEMENT_HANDLING = cfg.CUSTOM_ELEMENT_HANDLING || {};
            if (cfg.CUSTOM_ELEMENT_HANDLING && isRegexOrFunction(cfg.CUSTOM_ELEMENT_HANDLING.tagNameCheck)) CUSTOM_ELEMENT_HANDLING.tagNameCheck = cfg.CUSTOM_ELEMENT_HANDLING.tagNameCheck;
            if (cfg.CUSTOM_ELEMENT_HANDLING && isRegexOrFunction(cfg.CUSTOM_ELEMENT_HANDLING.attributeNameCheck)) CUSTOM_ELEMENT_HANDLING.attributeNameCheck = cfg.CUSTOM_ELEMENT_HANDLING.attributeNameCheck;
            if (cfg.CUSTOM_ELEMENT_HANDLING && typeof cfg.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements === "boolean") CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements = cfg.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements;
            if (SAFE_FOR_TEMPLATES) ALLOW_DATA_ATTR = false;
            if (RETURN_DOM_FRAGMENT) RETURN_DOM = true;
            /* Parse profile info */ if (USE_PROFILES) {
                ALLOWED_TAGS = addToSet({}, text);
                ALLOWED_ATTR = [];
                if (USE_PROFILES.html === true) {
                    addToSet(ALLOWED_TAGS, html$1);
                    addToSet(ALLOWED_ATTR, html);
                }
                if (USE_PROFILES.svg === true) {
                    addToSet(ALLOWED_TAGS, svg$1);
                    addToSet(ALLOWED_ATTR, svg);
                    addToSet(ALLOWED_ATTR, xml);
                }
                if (USE_PROFILES.svgFilters === true) {
                    addToSet(ALLOWED_TAGS, svgFilters);
                    addToSet(ALLOWED_ATTR, svg);
                    addToSet(ALLOWED_ATTR, xml);
                }
                if (USE_PROFILES.mathMl === true) {
                    addToSet(ALLOWED_TAGS, mathMl$1);
                    addToSet(ALLOWED_ATTR, mathMl);
                    addToSet(ALLOWED_ATTR, xml);
                }
            }
            /* Merge configuration parameters */ if (cfg.ADD_TAGS) {
                if (typeof cfg.ADD_TAGS === "function") EXTRA_ELEMENT_HANDLING.tagCheck = cfg.ADD_TAGS;
                else {
                    if (ALLOWED_TAGS === DEFAULT_ALLOWED_TAGS) ALLOWED_TAGS = clone(ALLOWED_TAGS);
                    addToSet(ALLOWED_TAGS, cfg.ADD_TAGS, transformCaseFunc);
                }
            }
            if (cfg.ADD_ATTR) {
                if (typeof cfg.ADD_ATTR === "function") EXTRA_ELEMENT_HANDLING.attributeCheck = cfg.ADD_ATTR;
                else {
                    if (ALLOWED_ATTR === DEFAULT_ALLOWED_ATTR) ALLOWED_ATTR = clone(ALLOWED_ATTR);
                    addToSet(ALLOWED_ATTR, cfg.ADD_ATTR, transformCaseFunc);
                }
            }
            if (cfg.ADD_URI_SAFE_ATTR) addToSet(URI_SAFE_ATTRIBUTES, cfg.ADD_URI_SAFE_ATTR, transformCaseFunc);
            if (cfg.FORBID_CONTENTS) {
                if (FORBID_CONTENTS === DEFAULT_FORBID_CONTENTS) FORBID_CONTENTS = clone(FORBID_CONTENTS);
                addToSet(FORBID_CONTENTS, cfg.FORBID_CONTENTS, transformCaseFunc);
            }
            if (cfg.ADD_FORBID_CONTENTS) {
                if (FORBID_CONTENTS === DEFAULT_FORBID_CONTENTS) FORBID_CONTENTS = clone(FORBID_CONTENTS);
                addToSet(FORBID_CONTENTS, cfg.ADD_FORBID_CONTENTS, transformCaseFunc);
            }
            /* Add #text in case KEEP_CONTENT is set to true */ if (KEEP_CONTENT) ALLOWED_TAGS["#text"] = true;
            /* Add html, head and body to ALLOWED_TAGS in case WHOLE_DOCUMENT is true */ if (WHOLE_DOCUMENT) addToSet(ALLOWED_TAGS, [
                "html",
                "head",
                "body"
            ]);
            /* Add tbody to ALLOWED_TAGS in case tables are permitted, see #286, #365 */ if (ALLOWED_TAGS.table) {
                addToSet(ALLOWED_TAGS, [
                    "tbody"
                ]);
                delete FORBID_TAGS.tbody;
            }
            if (cfg.TRUSTED_TYPES_POLICY) {
                if (typeof cfg.TRUSTED_TYPES_POLICY.createHTML !== "function") throw typeErrorCreate('TRUSTED_TYPES_POLICY configuration option must provide a "createHTML" hook.');
                if (typeof cfg.TRUSTED_TYPES_POLICY.createScriptURL !== "function") throw typeErrorCreate('TRUSTED_TYPES_POLICY configuration option must provide a "createScriptURL" hook.');
                // Overwrite existing TrustedTypes policy.
                trustedTypesPolicy = cfg.TRUSTED_TYPES_POLICY;
                // Sign local variables required by `sanitize`.
                emptyHTML = trustedTypesPolicy.createHTML("");
            } else {
                // Uninitialized policy, attempt to initialize the internal dompurify policy.
                if (trustedTypesPolicy === undefined) trustedTypesPolicy = _createTrustedTypesPolicy(trustedTypes, currentScript);
                // If creating the internal policy succeeded sign internal variables.
                if (trustedTypesPolicy !== null && typeof emptyHTML === "string") emptyHTML = trustedTypesPolicy.createHTML("");
            }
            // Prevent further manipulation of configuration.
            // Not available in IE8, Safari 5, etc.
            if (freeze) freeze(cfg);
            CONFIG = cfg;
        };
        /* Keep track of all possible SVG and MathML tags
     * so that we can perform the namespace checks
     * correctly. */ const ALL_SVG_TAGS = addToSet({}, [
            ...svg$1,
            ...svgFilters,
            ...svgDisallowed
        ]);
        const ALL_MATHML_TAGS = addToSet({}, [
            ...mathMl$1,
            ...mathMlDisallowed
        ]);
        /**
     * @param element a DOM element whose namespace is being checked
     * @returns Return false if the element has a
     *  namespace that a spec-compliant parser would never
     *  return. Return true otherwise.
     */ const _checkValidNamespace = function _checkValidNamespace(element) {
            let parent = getParentNode(element);
            // In JSDOM, if we're inside shadow DOM, then parentNode
            // can be null. We just simulate parent in this case.
            if (!parent || !parent.tagName) parent = {
                namespaceURI: NAMESPACE,
                tagName: "template"
            };
            const tagName = stringToLowerCase(element.tagName);
            const parentTagName = stringToLowerCase(parent.tagName);
            if (!ALLOWED_NAMESPACES[element.namespaceURI]) return false;
            if (element.namespaceURI === SVG_NAMESPACE) {
                // The only way to switch from HTML namespace to SVG
                // is via <svg>. If it happens via any other tag, then
                // it should be killed.
                if (parent.namespaceURI === HTML_NAMESPACE) return tagName === "svg";
                // The only way to switch from MathML to SVG is via`
                // svg if parent is either <annotation-xml> or MathML
                // text integration points.
                if (parent.namespaceURI === MATHML_NAMESPACE) return tagName === "svg" && (parentTagName === "annotation-xml" || MATHML_TEXT_INTEGRATION_POINTS[parentTagName]);
                // We only allow elements that are defined in SVG
                // spec. All others are disallowed in SVG namespace.
                return Boolean(ALL_SVG_TAGS[tagName]);
            }
            if (element.namespaceURI === MATHML_NAMESPACE) {
                // The only way to switch from HTML namespace to MathML
                // is via <math>. If it happens via any other tag, then
                // it should be killed.
                if (parent.namespaceURI === HTML_NAMESPACE) return tagName === "math";
                // The only way to switch from SVG to MathML is via
                // <math> and HTML integration points
                if (parent.namespaceURI === SVG_NAMESPACE) return tagName === "math" && HTML_INTEGRATION_POINTS[parentTagName];
                // We only allow elements that are defined in MathML
                // spec. All others are disallowed in MathML namespace.
                return Boolean(ALL_MATHML_TAGS[tagName]);
            }
            if (element.namespaceURI === HTML_NAMESPACE) {
                // The only way to switch from SVG to HTML is via
                // HTML integration points, and from MathML to HTML
                // is via MathML text integration points
                if (parent.namespaceURI === SVG_NAMESPACE && !HTML_INTEGRATION_POINTS[parentTagName]) return false;
                if (parent.namespaceURI === MATHML_NAMESPACE && !MATHML_TEXT_INTEGRATION_POINTS[parentTagName]) return false;
                // We disallow tags that are specific for MathML
                // or SVG and should never appear in HTML namespace
                return !ALL_MATHML_TAGS[tagName] && (COMMON_SVG_AND_HTML_ELEMENTS[tagName] || !ALL_SVG_TAGS[tagName]);
            }
            // For XHTML and XML documents that support custom namespaces
            if (PARSER_MEDIA_TYPE === "application/xhtml+xml" && ALLOWED_NAMESPACES[element.namespaceURI]) return true;
            // The code should never reach this place (this means
            // that the element somehow got namespace that is not
            // HTML, SVG, MathML or allowed via ALLOWED_NAMESPACES).
            // Return false just in case.
            return false;
        };
        /**
     * _forceRemove
     *
     * @param node a DOM node
     */ const _forceRemove = function _forceRemove(node) {
            arrayPush(DOMPurify.removed, {
                element: node
            });
            try {
                // eslint-disable-next-line unicorn/prefer-dom-node-remove
                getParentNode(node).removeChild(node);
            } catch (_) {
                remove(node);
            }
        };
        /**
     * _removeAttribute
     *
     * @param name an Attribute name
     * @param element a DOM node
     */ const _removeAttribute = function _removeAttribute(name, element) {
            try {
                arrayPush(DOMPurify.removed, {
                    attribute: element.getAttributeNode(name),
                    from: element
                });
            } catch (_) {
                arrayPush(DOMPurify.removed, {
                    attribute: null,
                    from: element
                });
            }
            element.removeAttribute(name);
            // We void attribute values for unremovable "is" attributes
            if (name === "is") {
                if (RETURN_DOM || RETURN_DOM_FRAGMENT) try {
                    _forceRemove(element);
                } catch (_) {}
                else try {
                    element.setAttribute(name, "");
                } catch (_) {}
            }
        };
        /**
     * _initDocument
     *
     * @param dirty - a string of dirty markup
     * @return a DOM, filled with the dirty markup
     */ const _initDocument = function _initDocument(dirty) {
            /* Create a HTML document */ let doc = null;
            let leadingWhitespace = null;
            if (FORCE_BODY) dirty = "<remove></remove>" + dirty;
            else {
                /* If FORCE_BODY isn't used, leading whitespace needs to be preserved manually */ const matches = stringMatch(dirty, /^[\r\n\t ]+/);
                leadingWhitespace = matches && matches[0];
            }
            if (PARSER_MEDIA_TYPE === "application/xhtml+xml" && NAMESPACE === HTML_NAMESPACE) // Root of XHTML doc must contain xmlns declaration (see https://www.w3.org/TR/xhtml1/normative.html#strict)
            dirty = '<html xmlns="http://www.w3.org/1999/xhtml"><head></head><body>' + dirty + "</body></html>";
            const dirtyPayload = trustedTypesPolicy ? trustedTypesPolicy.createHTML(dirty) : dirty;
            /*
       * Use the DOMParser API by default, fallback later if needs be
       * DOMParser not work for svg when has multiple root element.
       */ if (NAMESPACE === HTML_NAMESPACE) try {
                doc = new DOMParser().parseFromString(dirtyPayload, PARSER_MEDIA_TYPE);
            } catch (_) {}
            /* Use createHTMLDocument in case DOMParser is not available */ if (!doc || !doc.documentElement) {
                doc = implementation.createDocument(NAMESPACE, "template", null);
                try {
                    doc.documentElement.innerHTML = IS_EMPTY_INPUT ? emptyHTML : dirtyPayload;
                } catch (_) {
                // Syntax error if dirtyPayload is invalid xml
                }
            }
            const body = doc.body || doc.documentElement;
            if (dirty && leadingWhitespace) body.insertBefore(document.createTextNode(leadingWhitespace), body.childNodes[0] || null);
            /* Work on whole document or just its body */ if (NAMESPACE === HTML_NAMESPACE) return getElementsByTagName.call(doc, WHOLE_DOCUMENT ? "html" : "body")[0];
            return WHOLE_DOCUMENT ? doc.documentElement : body;
        };
        /**
     * Creates a NodeIterator object that you can use to traverse filtered lists of nodes or elements in a document.
     *
     * @param root The root element or node to start traversing on.
     * @return The created NodeIterator
     */ const _createNodeIterator = function _createNodeIterator(root) {
            return createNodeIterator.call(root.ownerDocument || root, root, // eslint-disable-next-line no-bitwise
            NodeFilter.SHOW_ELEMENT | NodeFilter.SHOW_COMMENT | NodeFilter.SHOW_TEXT | NodeFilter.SHOW_PROCESSING_INSTRUCTION | NodeFilter.SHOW_CDATA_SECTION, null);
        };
        /**
     * _isClobbered
     *
     * @param element element to check for clobbering attacks
     * @return true if clobbered, false if safe
     */ const _isClobbered = function _isClobbered(element) {
            return element instanceof HTMLFormElement && (typeof element.nodeName !== "string" || typeof element.textContent !== "string" || typeof element.removeChild !== "function" || !(element.attributes instanceof NamedNodeMap) || typeof element.removeAttribute !== "function" || typeof element.setAttribute !== "function" || typeof element.namespaceURI !== "string" || typeof element.insertBefore !== "function" || typeof element.hasChildNodes !== "function");
        };
        /**
     * Checks whether the given object is a DOM node.
     *
     * @param value object to check whether it's a DOM node
     * @return true is object is a DOM node
     */ const _isNode = function _isNode(value) {
            return typeof Node === "function" && value instanceof Node;
        };
        function _executeHooks(hooks, currentNode, data) {
            arrayForEach(hooks, (hook)=>{
                hook.call(DOMPurify, currentNode, data, CONFIG);
            });
        }
        /**
     * _sanitizeElements
     *
     * @protect nodeName
     * @protect textContent
     * @protect removeChild
     * @param currentNode to check for permission to exist
     * @return true if node was killed, false if left alive
     */ const _sanitizeElements = function _sanitizeElements(currentNode) {
            let content = null;
            /* Execute a hook if present */ _executeHooks(hooks.beforeSanitizeElements, currentNode, null);
            /* Check if element is clobbered or can clobber */ if (_isClobbered(currentNode)) {
                _forceRemove(currentNode);
                return true;
            }
            /* Now let's check the element's type and name */ const tagName = transformCaseFunc(currentNode.nodeName);
            /* Execute a hook if present */ _executeHooks(hooks.uponSanitizeElement, currentNode, {
                tagName,
                allowedTags: ALLOWED_TAGS
            });
            /* Detect mXSS attempts abusing namespace confusion */ if (SAFE_FOR_XML && currentNode.hasChildNodes() && !_isNode(currentNode.firstElementChild) && regExpTest(/<[/\w!]/g, currentNode.innerHTML) && regExpTest(/<[/\w!]/g, currentNode.textContent)) {
                _forceRemove(currentNode);
                return true;
            }
            /* Remove any occurrence of processing instructions */ if (currentNode.nodeType === NODE_TYPE.progressingInstruction) {
                _forceRemove(currentNode);
                return true;
            }
            /* Remove any kind of possibly harmful comments */ if (SAFE_FOR_XML && currentNode.nodeType === NODE_TYPE.comment && regExpTest(/<[/\w]/g, currentNode.data)) {
                _forceRemove(currentNode);
                return true;
            }
            /* Remove element if anything forbids its presence */ if (!(EXTRA_ELEMENT_HANDLING.tagCheck instanceof Function && EXTRA_ELEMENT_HANDLING.tagCheck(tagName)) && (!ALLOWED_TAGS[tagName] || FORBID_TAGS[tagName])) {
                /* Check if we have a custom element to handle */ if (!FORBID_TAGS[tagName] && _isBasicCustomElement(tagName)) {
                    if (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.tagNameCheck, tagName)) return false;
                    if (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.tagNameCheck(tagName)) return false;
                }
                /* Keep content except for bad-listed elements */ if (KEEP_CONTENT && !FORBID_CONTENTS[tagName]) {
                    const parentNode = getParentNode(currentNode) || currentNode.parentNode;
                    const childNodes = getChildNodes(currentNode) || currentNode.childNodes;
                    if (childNodes && parentNode) {
                        const childCount = childNodes.length;
                        for(let i = childCount - 1; i >= 0; --i){
                            const childClone = cloneNode(childNodes[i], true);
                            childClone.__removalCount = (currentNode.__removalCount || 0) + 1;
                            parentNode.insertBefore(childClone, getNextSibling(currentNode));
                        }
                    }
                }
                _forceRemove(currentNode);
                return true;
            }
            /* Check whether element has a valid namespace */ if (currentNode instanceof Element && !_checkValidNamespace(currentNode)) {
                _forceRemove(currentNode);
                return true;
            }
            /* Make sure that older browsers don't get fallback-tag mXSS */ if ((tagName === "noscript" || tagName === "noembed" || tagName === "noframes") && regExpTest(/<\/no(script|embed|frames)/i, currentNode.innerHTML)) {
                _forceRemove(currentNode);
                return true;
            }
            /* Sanitize element content to be template-safe */ if (SAFE_FOR_TEMPLATES && currentNode.nodeType === NODE_TYPE.text) {
                /* Get the element's text content */ content = currentNode.textContent;
                arrayForEach([
                    MUSTACHE_EXPR,
                    ERB_EXPR,
                    TMPLIT_EXPR
                ], (expr)=>{
                    content = stringReplace(content, expr, " ");
                });
                if (currentNode.textContent !== content) {
                    arrayPush(DOMPurify.removed, {
                        element: currentNode.cloneNode()
                    });
                    currentNode.textContent = content;
                }
            }
            /* Execute a hook if present */ _executeHooks(hooks.afterSanitizeElements, currentNode, null);
            return false;
        };
        /**
     * _isValidAttribute
     *
     * @param lcTag Lowercase tag name of containing element.
     * @param lcName Lowercase attribute name.
     * @param value Attribute value.
     * @return Returns true if `value` is valid, otherwise false.
     */ // eslint-disable-next-line complexity
        const _isValidAttribute = function _isValidAttribute(lcTag, lcName, value) {
            /* Make sure attribute cannot clobber */ if (SANITIZE_DOM && (lcName === "id" || lcName === "name") && (value in document || value in formElement)) return false;
            /* Allow valid data-* attributes: At least one character after "-"
          (https://html.spec.whatwg.org/multipage/dom.html#embedding-custom-non-visible-data-with-the-data-*-attributes)
          XML-compatible (https://html.spec.whatwg.org/multipage/infrastructure.html#xml-compatible and http://www.w3.org/TR/xml/#d0e804)
          We don't need to check the value; it's always URI safe. */ if (ALLOW_DATA_ATTR && !FORBID_ATTR[lcName] && regExpTest(DATA_ATTR, lcName)) ;
            else if (ALLOW_ARIA_ATTR && regExpTest(ARIA_ATTR, lcName)) ;
            else if (EXTRA_ELEMENT_HANDLING.attributeCheck instanceof Function && EXTRA_ELEMENT_HANDLING.attributeCheck(lcName, lcTag)) ;
            else if (!ALLOWED_ATTR[lcName] || FORBID_ATTR[lcName]) {
                if (// First condition does a very basic check if a) it's basically a valid custom element tagname AND
                // b) if the tagName passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
                // and c) if the attribute name passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.attributeNameCheck
                _isBasicCustomElement(lcTag) && (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.tagNameCheck, lcTag) || CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.tagNameCheck(lcTag)) && (CUSTOM_ELEMENT_HANDLING.attributeNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.attributeNameCheck, lcName) || CUSTOM_ELEMENT_HANDLING.attributeNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.attributeNameCheck(lcName, lcTag)) || // Alternative, second condition checks if it's an `is`-attribute, AND
                // the value passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
                lcName === "is" && CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements && (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.tagNameCheck, value) || CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.tagNameCheck(value))) ;
                else return false;
            /* Check value is safe. First, is attr inert? If so, is safe */ } else if (URI_SAFE_ATTRIBUTES[lcName]) ;
            else if (regExpTest(IS_ALLOWED_URI$1, stringReplace(value, ATTR_WHITESPACE, ""))) ;
            else if ((lcName === "src" || lcName === "xlink:href" || lcName === "href") && lcTag !== "script" && stringIndexOf(value, "data:") === 0 && DATA_URI_TAGS[lcTag]) ;
            else if (ALLOW_UNKNOWN_PROTOCOLS && !regExpTest(IS_SCRIPT_OR_DATA, stringReplace(value, ATTR_WHITESPACE, ""))) ;
            else if (value) return false;
            return true;
        };
        /**
     * _isBasicCustomElement
     * checks if at least one dash is included in tagName, and it's not the first char
     * for more sophisticated checking see https://github.com/sindresorhus/validate-element-name
     *
     * @param tagName name of the tag of the node to sanitize
     * @returns Returns true if the tag name meets the basic criteria for a custom element, otherwise false.
     */ const _isBasicCustomElement = function _isBasicCustomElement(tagName) {
            return tagName !== "annotation-xml" && stringMatch(tagName, CUSTOM_ELEMENT);
        };
        /**
     * _sanitizeAttributes
     *
     * @protect attributes
     * @protect nodeName
     * @protect removeAttribute
     * @protect setAttribute
     *
     * @param currentNode to sanitize
     */ const _sanitizeAttributes = function _sanitizeAttributes(currentNode) {
            /* Execute a hook if present */ _executeHooks(hooks.beforeSanitizeAttributes, currentNode, null);
            const { attributes } = currentNode;
            /* Check if we have attributes; if not we might have a text node */ if (!attributes || _isClobbered(currentNode)) return;
            const hookEvent = {
                attrName: "",
                attrValue: "",
                keepAttr: true,
                allowedAttributes: ALLOWED_ATTR,
                forceKeepAttr: undefined
            };
            let l = attributes.length;
            /* Go backwards over all attributes; safely remove bad ones */ while(l--){
                const attr = attributes[l];
                const { name, namespaceURI, value: attrValue } = attr;
                const lcName = transformCaseFunc(name);
                const initValue = attrValue;
                let value = name === "value" ? initValue : stringTrim(initValue);
                /* Execute a hook if present */ hookEvent.attrName = lcName;
                hookEvent.attrValue = value;
                hookEvent.keepAttr = true;
                hookEvent.forceKeepAttr = undefined; // Allows developers to see this is a property they can set
                _executeHooks(hooks.uponSanitizeAttribute, currentNode, hookEvent);
                value = hookEvent.attrValue;
                /* Full DOM Clobbering protection via namespace isolation,
         * Prefix id and name attributes with `user-content-`
         */ if (SANITIZE_NAMED_PROPS && (lcName === "id" || lcName === "name")) {
                    // Remove the attribute with this value
                    _removeAttribute(name, currentNode);
                    // Prefix the value and later re-create the attribute with the sanitized value
                    value = SANITIZE_NAMED_PROPS_PREFIX + value;
                }
                /* Work around a security issue with comments inside attributes */ if (SAFE_FOR_XML && regExpTest(/((--!?|])>)|<\/(style|title|textarea)/i, value)) {
                    _removeAttribute(name, currentNode);
                    continue;
                }
                /* Make sure we cannot easily use animated hrefs, even if animations are allowed */ if (lcName === "attributename" && stringMatch(value, "href")) {
                    _removeAttribute(name, currentNode);
                    continue;
                }
                /* Did the hooks approve of the attribute? */ if (hookEvent.forceKeepAttr) continue;
                /* Did the hooks approve of the attribute? */ if (!hookEvent.keepAttr) {
                    _removeAttribute(name, currentNode);
                    continue;
                }
                /* Work around a security issue in jQuery 3.0 */ if (!ALLOW_SELF_CLOSE_IN_ATTR && regExpTest(/\/>/i, value)) {
                    _removeAttribute(name, currentNode);
                    continue;
                }
                /* Sanitize attribute content to be template-safe */ if (SAFE_FOR_TEMPLATES) arrayForEach([
                    MUSTACHE_EXPR,
                    ERB_EXPR,
                    TMPLIT_EXPR
                ], (expr)=>{
                    value = stringReplace(value, expr, " ");
                });
                /* Is `value` valid for this attribute? */ const lcTag = transformCaseFunc(currentNode.nodeName);
                if (!_isValidAttribute(lcTag, lcName, value)) {
                    _removeAttribute(name, currentNode);
                    continue;
                }
                /* Handle attributes that require Trusted Types */ if (trustedTypesPolicy && typeof trustedTypes === "object" && typeof trustedTypes.getAttributeType === "function") {
                    if (namespaceURI) ;
                    else switch(trustedTypes.getAttributeType(lcTag, lcName)){
                        case "TrustedHTML":
                            value = trustedTypesPolicy.createHTML(value);
                            break;
                        case "TrustedScriptURL":
                            value = trustedTypesPolicy.createScriptURL(value);
                            break;
                    }
                }
                /* Handle invalid data-* attribute set by try-catching it */ if (value !== initValue) try {
                    if (namespaceURI) currentNode.setAttributeNS(namespaceURI, name, value);
                    else /* Fallback to setAttribute() for browser-unrecognized namespaces e.g. "x-schema". */ currentNode.setAttribute(name, value);
                    if (_isClobbered(currentNode)) _forceRemove(currentNode);
                    else arrayPop(DOMPurify.removed);
                } catch (_) {
                    _removeAttribute(name, currentNode);
                }
            }
            /* Execute a hook if present */ _executeHooks(hooks.afterSanitizeAttributes, currentNode, null);
        };
        /**
     * _sanitizeShadowDOM
     *
     * @param fragment to iterate over recursively
     */ const _sanitizeShadowDOM = function _sanitizeShadowDOM(fragment) {
            let shadowNode = null;
            const shadowIterator = _createNodeIterator(fragment);
            /* Execute a hook if present */ _executeHooks(hooks.beforeSanitizeShadowDOM, fragment, null);
            while(shadowNode = shadowIterator.nextNode()){
                /* Execute a hook if present */ _executeHooks(hooks.uponSanitizeShadowNode, shadowNode, null);
                /* Sanitize tags and elements */ _sanitizeElements(shadowNode);
                /* Check attributes next */ _sanitizeAttributes(shadowNode);
                /* Deep shadow DOM detected */ if (shadowNode.content instanceof DocumentFragment) _sanitizeShadowDOM(shadowNode.content);
            }
            /* Execute a hook if present */ _executeHooks(hooks.afterSanitizeShadowDOM, fragment, null);
        };
        // eslint-disable-next-line complexity
        DOMPurify.sanitize = function(dirty) {
            let cfg = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
            let body = null;
            let importedNode = null;
            let currentNode = null;
            let returnNode = null;
            /* Make sure we have a string to sanitize.
        DO NOT return early, as this will return the wrong type if
        the user has requested a DOM object rather than a string */ IS_EMPTY_INPUT = !dirty;
            if (IS_EMPTY_INPUT) dirty = "<!-->";
            /* Stringify, in case dirty is an object */ if (typeof dirty !== "string" && !_isNode(dirty)) {
                if (typeof dirty.toString === "function") {
                    dirty = dirty.toString();
                    if (typeof dirty !== "string") throw typeErrorCreate("dirty is not a string, aborting");
                } else throw typeErrorCreate("toString is not a function");
            }
            /* Return dirty HTML if DOMPurify cannot run */ if (!DOMPurify.isSupported) return dirty;
            /* Assign config vars */ if (!SET_CONFIG) _parseConfig(cfg);
            /* Clean up removed elements */ DOMPurify.removed = [];
            /* Check if dirty is correctly typed for IN_PLACE */ if (typeof dirty === "string") IN_PLACE = false;
            if (IN_PLACE) /* Do some early pre-sanitization to avoid unsafe root nodes */ {
                if (dirty.nodeName) {
                    const tagName = transformCaseFunc(dirty.nodeName);
                    if (!ALLOWED_TAGS[tagName] || FORBID_TAGS[tagName]) throw typeErrorCreate("root node is forbidden and cannot be sanitized in-place");
                }
            } else if (dirty instanceof Node) {
                /* If dirty is a DOM element, append to an empty document to avoid
           elements being stripped by the parser */ body = _initDocument("<!---->");
                importedNode = body.ownerDocument.importNode(dirty, true);
                if (importedNode.nodeType === NODE_TYPE.element && importedNode.nodeName === "BODY") /* Node is already a body, use as is */ body = importedNode;
                else if (importedNode.nodeName === "HTML") body = importedNode;
                else // eslint-disable-next-line unicorn/prefer-dom-node-append
                body.appendChild(importedNode);
            } else {
                /* Exit directly if we have nothing to do */ if (!RETURN_DOM && !SAFE_FOR_TEMPLATES && !WHOLE_DOCUMENT && // eslint-disable-next-line unicorn/prefer-includes
                dirty.indexOf("<") === -1) return trustedTypesPolicy && RETURN_TRUSTED_TYPE ? trustedTypesPolicy.createHTML(dirty) : dirty;
                /* Initialize the document to work on */ body = _initDocument(dirty);
                /* Check we have a DOM node from the data */ if (!body) return RETURN_DOM ? null : RETURN_TRUSTED_TYPE ? emptyHTML : "";
            }
            /* Remove first element node (ours) if FORCE_BODY is set */ if (body && FORCE_BODY) _forceRemove(body.firstChild);
            /* Get node iterator */ const nodeIterator = _createNodeIterator(IN_PLACE ? dirty : body);
            /* Now start iterating over the created document */ while(currentNode = nodeIterator.nextNode()){
                /* Sanitize tags and elements */ _sanitizeElements(currentNode);
                /* Check attributes next */ _sanitizeAttributes(currentNode);
                /* Shadow DOM detected, sanitize it */ if (currentNode.content instanceof DocumentFragment) _sanitizeShadowDOM(currentNode.content);
            }
            /* If we sanitized `dirty` in-place, return it. */ if (IN_PLACE) return dirty;
            /* Return sanitized string or DOM */ if (RETURN_DOM) {
                if (RETURN_DOM_FRAGMENT) {
                    returnNode = createDocumentFragment.call(body.ownerDocument);
                    while(body.firstChild)// eslint-disable-next-line unicorn/prefer-dom-node-append
                    returnNode.appendChild(body.firstChild);
                } else returnNode = body;
                if (ALLOWED_ATTR.shadowroot || ALLOWED_ATTR.shadowrootmode) /*
            AdoptNode() is not used because internal state is not reset
            (e.g. the past names map of a HTMLFormElement), this is safe
            in theory but we would rather not risk another attack vector.
            The state that is cloned by importNode() is explicitly defined
            by the specs.
          */ returnNode = importNode.call(originalDocument, returnNode, true);
                return returnNode;
            }
            let serializedHTML = WHOLE_DOCUMENT ? body.outerHTML : body.innerHTML;
            /* Serialize doctype if allowed */ if (WHOLE_DOCUMENT && ALLOWED_TAGS["!doctype"] && body.ownerDocument && body.ownerDocument.doctype && body.ownerDocument.doctype.name && regExpTest(DOCTYPE_NAME, body.ownerDocument.doctype.name)) serializedHTML = "<!DOCTYPE " + body.ownerDocument.doctype.name + ">\n" + serializedHTML;
            /* Sanitize final string template-safe */ if (SAFE_FOR_TEMPLATES) arrayForEach([
                MUSTACHE_EXPR,
                ERB_EXPR,
                TMPLIT_EXPR
            ], (expr)=>{
                serializedHTML = stringReplace(serializedHTML, expr, " ");
            });
            return trustedTypesPolicy && RETURN_TRUSTED_TYPE ? trustedTypesPolicy.createHTML(serializedHTML) : serializedHTML;
        };
        DOMPurify.setConfig = function() {
            let cfg = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
            _parseConfig(cfg);
            SET_CONFIG = true;
        };
        DOMPurify.clearConfig = function() {
            CONFIG = null;
            SET_CONFIG = false;
        };
        DOMPurify.isValidAttribute = function(tag, attr, value) {
            /* Initialize shared config vars if necessary. */ if (!CONFIG) _parseConfig({});
            const lcTag = transformCaseFunc(tag);
            const lcName = transformCaseFunc(attr);
            return _isValidAttribute(lcTag, lcName, value);
        };
        DOMPurify.addHook = function(entryPoint, hookFunction) {
            if (typeof hookFunction !== "function") return;
            arrayPush(hooks[entryPoint], hookFunction);
        };
        DOMPurify.removeHook = function(entryPoint, hookFunction) {
            if (hookFunction !== undefined) {
                const index = arrayLastIndexOf(hooks[entryPoint], hookFunction);
                return index === -1 ? undefined : arraySplice(hooks[entryPoint], index, 1)[0];
            }
            return arrayPop(hooks[entryPoint]);
        };
        DOMPurify.removeHooks = function(entryPoint) {
            hooks[entryPoint] = [];
        };
        DOMPurify.removeAllHooks = function() {
            hooks = _createHooksMap();
        };
        return DOMPurify;
    }
    var purify = createDOMPurify();
    return purify;
});

},{}],"fsPJR":[function(require,module,exports) {
module.exports = require("20c7f788fd1bc58").getBundleURL("kVLro") + require("bc15bfb1c689a4ed").resolve("7j6KX");

},{"20c7f788fd1bc58":"c7Tr5","bc15bfb1c689a4ed":"fyJL2"}],"qzmjz":[function(require,module,exports) {
module.exports = require("7296341762e04db9").getBundleURL("kVLro") + require("27fcb67a241d5fa5").resolve("aFOXA");

},{"7296341762e04db9":"c7Tr5","27fcb67a241d5fa5":"fyJL2"}],"fM7ms":[function(require,module,exports) {
module.exports = require("48b6dd77b4394372").getBundleURL("kVLro") + require("9696d5f662d41848").resolve("gQIj4");

},{"48b6dd77b4394372":"c7Tr5","9696d5f662d41848":"fyJL2"}],"aIuxi":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _horizontalSeparator = require("../structure/HorizontalSeparator");
var _horizontalSeparatorDefault = parcelHelpers.interopDefault(_horizontalSeparator);
var _positionIndicator = require("../structure/ConversationFlow/PositionIndicator");
var _positionIndicatorDefault = parcelHelpers.interopDefault(_positionIndicator);
var _colors = require("../../constants/colors");
var _dompurify = require("dompurify");
var _dompurifyDefault = parcelHelpers.interopDefault(_dompurify);
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const openQuoteIcon = require("1c44018a7251c815");
const closeQuoteIcon = require("f881392e6b7b50d7");
const deviceIcon = require("8d06d90f1134da40");
const containerStyle = /*#__PURE__*/ (0, _css.css)({
    name: "84huzn",
    styles: "display:flex;align-items:start;>img{background:white;border-radius:50%;margin-top:30px;margin-right:12px;margin-left:12px;}"
});
const bubbleStyle = /*#__PURE__*/ (0, _css.css)("margin:30px 0 0 80px;border:solid 1px ", (0, _colors.dark_sky_blue), ";box-shadow:-1px 4px 10px 0 ", (0, _colors.dark_grey_blue_20), ";background:white;border-radius:10px 0 10px 10px;padding:24px;display:flex;flex-direction:column;flex:1;@media only screen and (min-width: 1240px){max-width:75%;margin-right:0;margin-left:auto;}.title{font-family:Muli;font-size:18px;font-weight:600;font-style:normal;font-stretch:normal;line-height:normal;letter-spacing:normal;color:", (0, _colors.dark_grey_blue), ";margin-bottom:24px;}.open-quote{margin-left:0;margin-right:auto;margin-bottom:16px;margin-top:16px;}.close-quote{margin-right:0;margin-left:auto;margin-bottom:16px;margin-top:0;}.placeholder{text-align:center;font-style:italic;color:", (0, _colors.cool_grey), ";}.carousel-container{display:flex;align-items:center;justify-content:center;flex-direction:column;margin-top:16px;span{margin-bottom:8px;font-size:10px;font-weight:normal;font-stretch:normal;line-height:normal;letter-spacing:0.4px;text-align:center;color:", (0, _colors.cool_grey), ";}}", "");
const inputStyle = /*#__PURE__*/ (0, _css.css)("font-family:Muli;font-size:14px;font-weight:normal;font-style:normal;font-stretch:normal;line-height:normal;letter-spacing:normal;color:", (0, _colors.dark_grey_blue), ";margin-top:12px;span{background:", (0, _colors.highlight_blue), ";}", "");
const followUpDetail = /*#__PURE__*/ (0, _css.css)("background:white;margin-top:-9px;margin-left:8px;padding:0 4px;font-family:Muli;font-size:12px;font-weight:normal;font-style:normal;font-stretch:normal;line-height:normal;letter-spacing:0.5px;color:", (0, _colors.cool_grey), ";position:absolute;", "");
const followUpContainer = /*#__PURE__*/ (0, _css.css)({
    name: "n4zvey",
    styles: "position:relative;margin:48px 0 16px 0;p{margin-top:48px;}"
});
class DeviceChatVariationsBubble extends (0, _reactDefault.default).Component {
    componentWillMount() {
        this.setState({
            position: 0,
            audioResponses: []
        });
    }
    getSsmlContent(conversationResponse) {
        var customResponse = conversationResponse.mediaResponseContainer ? conversationResponse.mediaResponseContainer.responses.find((r)=>r.deviceTargetId == this.props.deviceTargetId && r.displayText != null) : null;
        if (customResponse) return customResponse.displayText;
        return conversationResponse.content;
    }
    buildLabel(item) {
        // strip tags from ssml first
        const ssml = this.getVariationSsml(item, false);
        const stripTagRegex = /<\/?[^>]+(>|$)/g;
        var displayText = ssml;
        displayText = displayText.replace(stripTagRegex, "");
        if (!this.props.noHighlights) item.highlights.forEach((highlight)=>{
            displayText = displayText.replace(highlight.replace(stripTagRegex, ""), `<span>${highlight}</span>`);
        });
        return (0, _react.jsx)("p", {
            className: inputStyle,
            key: item.id,
            dangerouslySetInnerHTML: {
                __html: (0, _dompurifyDefault.default).sanitize(displayText)
            }
        });
    }
    getVariationSsml(item, includeFollowUp) {
        var ssml = item.content;
        var customResponse = item.mediaResponseContainer ? item.mediaResponseContainer.responses.find((r)=>r.deviceTargetId == this.props.deviceTargetId && r.readoutOverride != null) : null;
        if (customResponse) ssml = customResponse.readoutOverride;
        if (includeFollowUp && this.props.followUp) ssml += `<break time=".5s"/> ${this.props.followUp.content}`;
        return ssml;
    }
    handlePositionChange(position) {
        this.setState({
            ...this.state,
            position
        });
    }
    stripTags(ssml) {
        const stripTagRegex = /<\/?[^>]+(>|$)/g;
        var displayText = ssml;
        displayText = displayText.replace(stripTagRegex, "");
        return displayText;
    }
    render() {
        const { title, variations } = this.props;
        if (!variations) return null;
        return (0, _react.jsx)("div", {
            className: containerStyle
        }, (0, _react.jsx)("div", {
            className: `${bubbleStyle} ac-output-message-preview`
        }, title && (0, _react.jsx)((0, _reactDefault.default).Fragment, null, (0, _react.jsx)("span", {
            className: "title"
        }, title), (0, _react.jsx)((0, _horizontalSeparatorDefault.default), null)), (0, _react.jsx)("img", {
            className: "open-quote",
            src: openQuoteIcon
        }), (0, _react.jsx)("div", {
            className: "content-container"
        }, variations.some((v)=>v.content != "") ? this.buildLabel(variations[this.state.position]) : (0, _react.jsx)("p", {
            className: "placeholder"
        }, "Enter your response to see here"), this.props.followUp ? (0, _react.jsx)("div", {
            className: followUpContainer
        }, (0, _react.jsx)((0, _horizontalSeparatorDefault.default), null), (0, _react.jsx)("span", {
            className: followUpDetail
        }, "& Then…"), (0, _react.jsx)("p", {
            className: inputStyle
        }, this.props.noHighlights ? this.stripTags(this.props.followUp.content) : (0, _react.jsx)("span", null, this.stripTags(this.props.followUp.content)))) : null), (0, _react.jsx)("img", {
            className: "close-quote",
            src: closeQuoteIcon
        }), variations.length > 1 ? (0, _react.jsx)((0, _reactDefault.default).Fragment, null, (0, _react.jsx)((0, _horizontalSeparatorDefault.default), null), (0, _react.jsx)("div", {
            className: "carousel-container"
        }, (0, _react.jsx)("span", null, `VARIATION: ${this.state.position + 1} of ${variations.length}`), (0, _react.jsx)((0, _positionIndicatorDefault.default), {
            count: variations.length,
            position: this.state.position,
            onChange: this.handlePositionChange.bind(this)
        }))) : null), (0, _react.jsx)("img", {
            src: deviceIcon
        }));
    }
}
exports.default = DeviceChatVariationsBubble;

},{"@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","../structure/HorizontalSeparator":"Pw3HQ","../structure/ConversationFlow/PositionIndicator":"39CHS","../../constants/colors":"1p3OR","dompurify":"5cPaM","1c44018a7251c815":"fsPJR","f881392e6b7b50d7":"qzmjz","8d06d90f1134da40":"2nj1V","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jVxKF":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _colors = require("../../../constants/colors");
var _horizontalSeparator = require("../HorizontalSeparator");
var _horizontalSeparatorDefault = parcelHelpers.interopDefault(_horizontalSeparator);
var _toggleIndicator = require("../../general/ToggleIndicator");
var _toggleIndicatorDefault = parcelHelpers.interopDefault(_toggleIndicator);
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const forkIcon = require("b9eeac3a7e3c3e6a");
const indicatorStyle = /*#__PURE__*/ (0, _css.css)("width:10px;height:10px;border:solid 1px ", (0, _colors.cool_grey), ";border-radius:50%;margin:3px 4px;cursor:pointer;", "");
const selectedIndicatorStyle = /*#__PURE__*/ (0, _css.css)("background:", (0, _colors.cool_grey), ";", "");
const headerStyle = /*#__PURE__*/ (0, _css.css)({
    name: "10cxce8",
    styles: "display:flex;align-items:center;width:100%;margin-top:32px"
});
const innerHeaderStyle = /*#__PURE__*/ (0, _css.css)("flex:1;height:64px;display:flex;align-items:center;border-radius:32px;background-color:#ffffff;border:solid 1px ", (0, _colors.color_shades_dark), ";padding:0 8px;span{display:block;font-family:Muli;font-size:11px;font-weight:normal;font-style:normal;font-stretch:normal;line-height:normal;letter-spacing:0.5px;color:", (0, _colors.cool_grey), ";}", "");
const iconContainer = /*#__PURE__*/ (0, _css.css)({
    name: "1hmn5jf",
    styles: "min-width:40px;min-height:40px;background-color:#304562;border-radius:50%;margin-right:24px;display:flex;align-items:center;justify-content:center"
});
const indicatorContainer = /*#__PURE__*/ (0, _css.css)("display:flex;align-items:center;min-width:180px;.toggle-indicator{cursor:pointer;border-color:", (0, _colors.cool_grey), ";}", "");
class ConversationBranchSwitcher extends (0, _reactDefault.default).Component {
    componentWillMount() {
        this.setState({
            position: this.props.position
        });
    }
    componentDidUpdate(previousProps) {
        if (previousProps.position != this.props.position) this.setState({
            position: this.props.position
        });
    }
    setPosition(position) {
        if (position == this.state.position) return;
        this.setState({
            position: position
        });
    }
    getChildren() {
        return (0, _reactDefault.default).Children.map(this.props.children, (x)=>x);
    }
    render() {
        var children = this.getChildren();
        return (0, _react.jsx)("div", null, (0, _react.jsx)("div", {
            className: headerStyle
        }, (0, _react.jsx)((0, _horizontalSeparatorDefault.default), null), (0, _react.jsx)("div", {
            className: innerHeaderStyle
        }, (0, _react.jsx)("div", {
            className: iconContainer
        }, (0, _react.jsx)("img", {
            src: forkIcon
        })), (0, _react.jsx)("div", null, (0, _react.jsx)("span", null, "Conversation Forks Here"), (0, _react.jsx)("div", {
            className: indicatorContainer
        }, (0, _react.jsx)((0, _toggleIndicatorDefault.default), {
            direction: "left",
            onClick: ()=>{
                if (this.state.position > 0) this.setPosition(this.state.position - 1);
                else this.setPosition(children.length - 1);
            }
        }), children.map((x, i)=>(0, _react.jsx)("div", {
                key: i,
                className: `${indicatorStyle} ${i == this.state.position ? selectedIndicatorStyle : ""}`,
                onClick: ()=>this.setPosition(i)
            })), (0, _react.jsx)((0, _toggleIndicatorDefault.default), {
            direction: "right",
            onClick: ()=>{
                if (this.state.position < children.length - 1) this.setPosition(this.state.position + 1);
                else this.setPosition(0);
            }
        })))), (0, _react.jsx)((0, _horizontalSeparatorDefault.default), null)), children.filter((child, index)=>index == this.state.position));
    }
}
exports.default = ConversationBranchSwitcher;

},{"@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","../../../constants/colors":"1p3OR","../HorizontalSeparator":"Pw3HQ","../../general/ToggleIndicator":"4eej1","b9eeac3a7e3c3e6a":"6W1hC","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6W1hC":[function(require,module,exports) {
module.exports = require("aef5a9ca6df67216").getBundleURL("kVLro") + require("decd76ff2762691a").resolve("gRuNA");

},{"aef5a9ca6df67216":"c7Tr5","decd76ff2762691a":"fyJL2"}],"doIhF":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _horizontalSeparator = require("../structure/HorizontalSeparator");
var _horizontalSeparatorDefault = parcelHelpers.interopDefault(_horizontalSeparator);
var _colors = require("../../constants/colors");
var _stylesValues = require("../../constants/stylesValues");
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const deviceIcon = require("4952c4af7ab99e52");
const DeletedVariationBubble = ()=>(0, _react.jsx)("div", {
        className: containerStyle
    }, (0, _react.jsx)("div", {
        className: bubbleStyle
    }, (0, _react.jsx)((0, _reactDefault.default).Fragment, null, (0, _react.jsx)("span", {
        className: "title"
    }, "- Deleted - "), (0, _react.jsx)((0, _horizontalSeparatorDefault.default), null)), (0, _react.jsx)("div", {
        className: "content-container"
    }, (0, _react.jsx)("p", null, "[This content has been deleted]"))), (0, _react.jsx)("img", {
        src: deviceIcon
    }));
const containerStyle = /*#__PURE__*/ (0, _css.css)({
    name: "84huzn",
    styles: "display:flex;align-items:start;>img{background:white;border-radius:50%;margin-top:30px;margin-right:12px;margin-left:12px;}"
});
const bubbleStyle = /*#__PURE__*/ (0, _css.css)("margin:30px 0 0 80px;border:", (0, _stylesValues.style_border_default), ";background:white;border-radius:10px 0 10px 10px;padding:24px;display:flex;flex-direction:column;flex:1;@media only screen and (min-width: 1240px){max-width:75%;margin-right:0;margin-left:auto;}.title{font-family:Muli;font-size:18px;font-style:italic;color:", (0, _colors.dark_grey_blue), ";margin-bottom:24px;}.content-container{margin:48px 48px;}", "");
exports.default = DeletedVariationBubble;

},{"@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","../structure/HorizontalSeparator":"Pw3HQ","../../constants/colors":"1p3OR","../../constants/stylesValues":"dHVVv","4952c4af7ab99e52":"dSC54","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"dSC54":[function(require,module,exports) {
module.exports = require("f552f31321197f68").getBundleURL("kVLro") + require("383829342e845de").resolve("5Hfcw");

},{"f552f31321197f68":"c7Tr5","383829342e845de":"fyJL2"}],"5ttMr":[function(require,module,exports) {
module.exports = require("2d9cedc3605948f7").getBundleURL("kVLro") + require("d9ea53030de0668").resolve("aNXMI");

},{"2d9cedc3605948f7":"c7Tr5","d9ea53030de0668":"fyJL2"}],"asBTb":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _css = require("@emotion/css");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _colors = require("../../../constants/colors");
var _stylesValues = require("../../../constants/stylesValues");
const powerIcon = require("9da0b730afdea9cb");
const SessionStartItem = ()=>(0, _react.jsx)("div", {
        className: containerStyle
    }, (0, _react.jsx)("div", {
        className: "top-row"
    }, (0, _react.jsx)("div", {
        className: "line"
    }), (0, _react.jsx)("div", {
        className: "icon-container"
    }, (0, _react.jsx)("img", {
        src: powerIcon
    })), (0, _react.jsx)("div", {
        className: "line"
    })), (0, _react.jsx)("p", null, "Session Starts"));
const containerStyle = /*#__PURE__*/ (0, _css.css)("display:flex;flex-direction:column;align-items:center;width:100%;margin-bottom:32px;.top-row{display:flex;align-items:center;justify-content:center;.line{width:48px;height:1px;background:", (0, _colors.color_shades_dark), ";}.icon-container{margin:0 24px;background:white;width:48px;height:48px;border-radius:50%;display:flex;align-items:center;justify-content:center;border:", (0, _stylesValues.style_border_default), ";}}>p{margin-top:8px;color:", (0, _colors.color_text_light), ";font-style:normal;font-weight:normal;font-size:12px;line-height:16px;text-align:center;}", "");
exports.default = SessionStartItem;

},{"@emotion/react":"djZKr","@emotion/css":"awUBr","react":"6uln9","../../../constants/colors":"1p3OR","../../../constants/stylesValues":"dHVVv","9da0b730afdea9cb":"dqBYI","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"S2Vxc":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _css = require("@emotion/css");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _colors = require("../../../constants/colors");
var _stylesValues = require("../../../constants/stylesValues");
const endIcon = require("245f1d8b42826783");
const SessionEndItem = ()=>(0, _react.jsx)("div", {
        className: containerStyle
    }, (0, _react.jsx)("div", {
        className: "top-row"
    }, (0, _react.jsx)("div", {
        className: "line"
    }), (0, _react.jsx)("div", {
        className: "icon-container"
    }, (0, _react.jsx)("img", {
        src: endIcon
    })), (0, _react.jsx)("div", {
        className: "line"
    })), (0, _react.jsx)("p", null, "Session Ends"));
const containerStyle = /*#__PURE__*/ (0, _css.css)("display:flex;flex-direction:column;align-items:center;width:100%;margin:32px 0;.top-row{display:flex;align-items:center;justify-content:center;.line{width:48px;height:1px;background:", (0, _colors.color_shades_dark), ";}.icon-container{margin:0 24px;background:white;width:48px;height:48px;border-radius:50%;display:flex;align-items:center;justify-content:center;border:", (0, _stylesValues.style_border_default), ";}}>p{margin-top:8px;color:", (0, _colors.color_text_light), ";font-style:normal;font-weight:normal;font-size:12px;line-height:16px;text-align:center;}", "");
exports.default = SessionEndItem;

},{"@emotion/react":"djZKr","@emotion/css":"awUBr","react":"6uln9","../../../constants/colors":"1p3OR","../../../constants/stylesValues":"dHVVv","245f1d8b42826783":"iTLXM","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"5zUjg":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _stylesValues = require("../../../constants/stylesValues");
var _colors = require("../../../constants/colors");
var _tooltipWrapper = require("../../general/TooltipWrapper");
var _tooltipWrapperDefault = parcelHelpers.interopDefault(_tooltipWrapper);
var _nodeSocket = require("./NodeSocket");
var _nodeSocketDefault = parcelHelpers.interopDefault(_nodeSocket);
var _extensions = require("../../../models/extensions");
var _featureTypeIds = require("../../../constants/featureTypeIds");
const FullContentNode = (props)=>{
    const getTitle = ()=>{
        if (props.conversationItem?.title) return props.conversationItem.title;
        if (props.isLoadingDetails) return "Loading";
        return "Deleted";
    };
    return (0, _react.jsx)("div", {
        className: `${containerStyle} ${props.active ? "active" : "inactive"} ${props.selected ? "selected" : "unselected"}`,
        id: props.id
    }, (0, _react.jsx)("div", {
        className: "node-card"
    }, (0, _react.jsx)("div", {
        className: "in-socket"
    }, (0, _react.jsx)((0, _nodeSocketDefault.default), {
        direction: "in",
        active: props.selected
    })), (0, _react.jsx)("div", {
        className: "card-body"
    }, (0, _react.jsx)("div", {
        className: "card-top"
    }, (0, _react.jsx)("img", {
        src: (0, _extensions.getFeatureTypeIcon)(props.featureTypeId ?? (0, _featureTypeIds.FallbackFeatureTypeId))
    }), (0, _react.jsx)("p", null, (0, _extensions.getDefaultFeatureTypeName)(props.featureTypeId ?? (0, _featureTypeIds.FallbackFeatureTypeId)))), (0, _react.jsx)("div", {
        className: "card-bottom"
    }, (0, _react.jsx)((0, _tooltipWrapperDefault.default), {
        place: "top",
        text: props.conversationItem?.title
    }, (0, _react.jsx)("p", null, getTitle())))), (0, _react.jsx)("div", {
        className: "out-socket"
    }, (0, _react.jsx)((0, _nodeSocketDefault.default), {
        direction: "out",
        active: props.childSelected
    }))), (0, _react.jsx)("div", {
        className: "circle"
    }));
};
const containerStyle = /*#__PURE__*/ (0, _css.css)("width:192px;margin:0 12px;height:248px;position:relative;.circle{width:8px;height:8px;position:absolute;border-radius:50%;top:-84px;left:92px;background:", (0, _colors.color_variants_royalty_light_10), ";border:1px solid ", (0, _colors.color_variants_royalty_light_10), ";box-sizing:content-box;}.percentage-container{display:flex;position:absolute;top:-16px;right:0;>p{margin-right:0;margin-left:auto;color:", (0, _colors.color_colors_royalty), ";text-align:right;font-style:normal;font-weight:normal;font-size:12px;line-height:16px;}}.node-card{cursor:pointer;width:192px;height:248px;border-radius:4px;border:", (0, _stylesValues.style_border_default), ";background:", (0, _colors.color_shades_light), ";padding:32px 0;position:relative;.card-body{background:white;padding:8px;position:absolute;left:0;right:0;top:32px;bottom:32px;.card-top{border-bottom:", (0, _stylesValues.style_border_default), ";padding:16px 12px;display:flex;align-items:flex-end;height:50%;>p{margin-left:8px;color:", (0, _colors.color_text_light), ";font-size:12px;line-height:16px;}}.card-bottom{display:flex;align-items:center;justify-content:center;height:50%;>p{font-size:14px;line-height:16px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;}}}.out-socket{display:flex;align-items:center;justify-content:center;width:192px;position:absolute;bottom:-5px;z-index:3;}.in-socket{display:flex;align-items:center;justify-content:center;width:192px;position:absolute;top:-5px;z-index:3;}}&.inactive{opacity:0.4;}&.selected{.circle{background :", (0, _colors.color_colors_royalty), ";border:2px solid white;z-index:3;left:90px;top:-85px;}}", "");
exports.default = FullContentNode;

},{"@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","../../../constants/stylesValues":"dHVVv","../../../constants/colors":"1p3OR","../../general/TooltipWrapper":"53pWd","./NodeSocket":"f8m4F","../../../models/extensions":"7h01B","../../../constants/featureTypeIds":"hPLMP","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"i829J":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _treePath = require("./TreePath");
var _treePathDefault = parcelHelpers.interopDefault(_treePath);
const NODE_WIDTH = 144; // the width of a node including margins
const UpTreePaths = (props)=>{
    const directionMultiplier = (length, index, prevLength, prevIndex)=>{
        const currentPositionOffset = length / 2 - index - props.nodeOffset;
        const topPositionOffset = prevLength / 2 - prevIndex - props.topNodeOffset;
        return currentPositionOffset - topPositionOffset;
    };
    const totalWidth = NODE_WIDTH * (props.topLength > props.topNodes.length ? props.topLength : props.topNodes.length) * (Math.abs(props.topNodeOffset) > Math.abs(props.nodeOffset) ? Math.abs(props.topNodeOffset) : Math.abs(props.nodeOffset) + 1);
    const totalSessions = props.topNodes.length == 0 ? 0 : props.topNodes.map((n)=>n.sessionIds?.length ?? 0).reduce((a, b)=>a + b);
    const containerStyle = /*#__PURE__*/ (0, _css.css)("position:relative;width:", totalWidth, "px;height:170px;", "");
    // each tree path is an SVG that is the width of the larger of the two rows it is being drawn between.
    // we calculate the offset from the center left or right of the top row and account for border-box (hence the -1)
    // we then draw the svg from the offset within a coordinate plane the size of the width of the container and the height
    // and go down, then over the direction width difference from the offset to the bottom row offset
    // and then draw the line down to the point.
    return (0, _react.jsx)("div", {
        className: containerStyle
    }, props.topNodes.map((n, i)=>{
        const percentage = (n.sessionIds?.length ?? 0) / totalSessions;
        return (0, _react.jsx)((0, _treePathDefault.default), {
            key: i,
            direction: directionMultiplier(props.topNodes.length, i, 1, 0) < 0 ? "up-right" : "up-left",
            width: NODE_WIDTH * directionMultiplier(props.topNodes.length, i, 1, 0) * -1,
            containerWidth: totalWidth,
            offset: 0,
            height: 170,
            lineSize: Math.round(19 * percentage),
            active: props.activeIndex == i
        });
    }));
};
exports.default = UpTreePaths;

},{"@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","./TreePath":"2wP0q","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"fSMut":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _colors = require("../../constants/colors");
const emptyImage = require("538c175264815409");
const AnalyticsEmptyView = ()=>(0, _react.jsx)("div", {
        className: containerStyle
    }, (0, _react.jsx)("img", {
        src: emptyImage
    }), (0, _react.jsx)("h2", null, "No sessions found for this view"), (0, _react.jsx)("p", null, "If you expect there to be activity for this timeframe, check to see if you have any active filters that could be restricting what appears"));
const containerStyle = /*#__PURE__*/ (0, _css.css)("width:100%;height:100%;display:flex;flex-direction:column;align-items:center;text-align:center;padding:64px 32px;>h2{margin:32px 0 0 8px;font-size:24px;line-height:32px;}>p{color:", (0, _colors.color_text_light), ";font-size:14px;line-height:20px;}", "");
exports.default = AnalyticsEmptyView;

},{"@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","../../constants/colors":"1p3OR","538c175264815409":"kufz8","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"kufz8":[function(require,module,exports) {
module.exports = require("36585ada6626617e").getBundleURL("kVLro") + require("470025afd3f9c72a").resolve("i3jdS");

},{"36585ada6626617e":"c7Tr5","470025afd3f9c72a":"fyJL2"}],"klvAV":[function(require,module,exports) {
"use strict";
const strictUriEncode = require("5752d3663915398f");
const decodeComponent = require("4cbbda34882b91a3");
const splitOnFirst = require("53494decacb36d1b");
const filterObject = require("dfb8fa56cbbad4a5");
const isNullOrUndefined = (value)=>value === null || value === undefined;
function encoderForArrayFormat(options) {
    switch(options.arrayFormat){
        case "index":
            return (key)=>(result, value)=>{
                    const index = result.length;
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === "") return result;
                    if (value === null) return [
                        ...result,
                        [
                            encode(key, options),
                            "[",
                            index,
                            "]"
                        ].join("")
                    ];
                    return [
                        ...result,
                        [
                            encode(key, options),
                            "[",
                            encode(index, options),
                            "]=",
                            encode(value, options)
                        ].join("")
                    ];
                };
        case "bracket":
            return (key)=>(result, value)=>{
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === "") return result;
                    if (value === null) return [
                        ...result,
                        [
                            encode(key, options),
                            "[]"
                        ].join("")
                    ];
                    return [
                        ...result,
                        [
                            encode(key, options),
                            "[]=",
                            encode(value, options)
                        ].join("")
                    ];
                };
        case "comma":
        case "separator":
            return (key)=>(result, value)=>{
                    if (value === null || value === undefined || value.length === 0) return result;
                    if (result.length === 0) return [
                        [
                            encode(key, options),
                            "=",
                            encode(value, options)
                        ].join("")
                    ];
                    return [
                        [
                            result,
                            encode(value, options)
                        ].join(options.arrayFormatSeparator)
                    ];
                };
        default:
            return (key)=>(result, value)=>{
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === "") return result;
                    if (value === null) return [
                        ...result,
                        encode(key, options)
                    ];
                    return [
                        ...result,
                        [
                            encode(key, options),
                            "=",
                            encode(value, options)
                        ].join("")
                    ];
                };
    }
}
function parserForArrayFormat(options) {
    let result;
    switch(options.arrayFormat){
        case "index":
            return (key, value, accumulator)=>{
                result = /\[(\d*)\]$/.exec(key);
                key = key.replace(/\[\d*\]$/, "");
                if (!result) {
                    accumulator[key] = value;
                    return;
                }
                if (accumulator[key] === undefined) accumulator[key] = {};
                accumulator[key][result[1]] = value;
            };
        case "bracket":
            return (key, value, accumulator)=>{
                result = /(\[\])$/.exec(key);
                key = key.replace(/\[\]$/, "");
                if (!result) {
                    accumulator[key] = value;
                    return;
                }
                if (accumulator[key] === undefined) {
                    accumulator[key] = [
                        value
                    ];
                    return;
                }
                accumulator[key] = [].concat(accumulator[key], value);
            };
        case "comma":
        case "separator":
            return (key, value, accumulator)=>{
                const isArray = typeof value === "string" && value.includes(options.arrayFormatSeparator);
                const isEncodedArray = typeof value === "string" && !isArray && decode(value, options).includes(options.arrayFormatSeparator);
                value = isEncodedArray ? decode(value, options) : value;
                const newValue = isArray || isEncodedArray ? value.split(options.arrayFormatSeparator).map((item)=>decode(item, options)) : value === null ? value : decode(value, options);
                accumulator[key] = newValue;
            };
        default:
            return (key, value, accumulator)=>{
                if (accumulator[key] === undefined) {
                    accumulator[key] = value;
                    return;
                }
                accumulator[key] = [].concat(accumulator[key], value);
            };
    }
}
function validateArrayFormatSeparator(value) {
    if (typeof value !== "string" || value.length !== 1) throw new TypeError("arrayFormatSeparator must be single character string");
}
function encode(value, options) {
    if (options.encode) return options.strict ? strictUriEncode(value) : encodeURIComponent(value);
    return value;
}
function decode(value, options) {
    if (options.decode) return decodeComponent(value);
    return value;
}
function keysSorter(input) {
    if (Array.isArray(input)) return input.sort();
    if (typeof input === "object") return keysSorter(Object.keys(input)).sort((a, b)=>Number(a) - Number(b)).map((key)=>input[key]);
    return input;
}
function removeHash(input) {
    const hashStart = input.indexOf("#");
    if (hashStart !== -1) input = input.slice(0, hashStart);
    return input;
}
function getHash(url) {
    let hash = "";
    const hashStart = url.indexOf("#");
    if (hashStart !== -1) hash = url.slice(hashStart);
    return hash;
}
function extract(input) {
    input = removeHash(input);
    const queryStart = input.indexOf("?");
    if (queryStart === -1) return "";
    return input.slice(queryStart + 1);
}
function parseValue(value, options) {
    if (options.parseNumbers && !Number.isNaN(Number(value)) && typeof value === "string" && value.trim() !== "") value = Number(value);
    else if (options.parseBooleans && value !== null && (value.toLowerCase() === "true" || value.toLowerCase() === "false")) value = value.toLowerCase() === "true";
    return value;
}
function parse(query, options) {
    options = Object.assign({
        decode: true,
        sort: true,
        arrayFormat: "none",
        arrayFormatSeparator: ",",
        parseNumbers: false,
        parseBooleans: false
    }, options);
    validateArrayFormatSeparator(options.arrayFormatSeparator);
    const formatter = parserForArrayFormat(options);
    // Create an object with no prototype
    const ret = Object.create(null);
    if (typeof query !== "string") return ret;
    query = query.trim().replace(/^[?#&]/, "");
    if (!query) return ret;
    for (const param of query.split("&")){
        if (param === "") continue;
        let [key, value] = splitOnFirst(options.decode ? param.replace(/\+/g, " ") : param, "=");
        // Missing `=` should be `null`:
        // http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
        value = value === undefined ? null : [
            "comma",
            "separator"
        ].includes(options.arrayFormat) ? value : decode(value, options);
        formatter(decode(key, options), value, ret);
    }
    for (const key of Object.keys(ret)){
        const value = ret[key];
        if (typeof value === "object" && value !== null) for (const k of Object.keys(value))value[k] = parseValue(value[k], options);
        else ret[key] = parseValue(value, options);
    }
    if (options.sort === false) return ret;
    return (options.sort === true ? Object.keys(ret).sort() : Object.keys(ret).sort(options.sort)).reduce((result, key)=>{
        const value = ret[key];
        if (Boolean(value) && typeof value === "object" && !Array.isArray(value)) // Sort object keys, not values
        result[key] = keysSorter(value);
        else result[key] = value;
        return result;
    }, Object.create(null));
}
exports.extract = extract;
exports.parse = parse;
exports.stringify = (object, options)=>{
    if (!object) return "";
    options = Object.assign({
        encode: true,
        strict: true,
        arrayFormat: "none",
        arrayFormatSeparator: ","
    }, options);
    validateArrayFormatSeparator(options.arrayFormatSeparator);
    const shouldFilter = (key)=>options.skipNull && isNullOrUndefined(object[key]) || options.skipEmptyString && object[key] === "";
    const formatter = encoderForArrayFormat(options);
    const objectCopy = {};
    for (const key of Object.keys(object))if (!shouldFilter(key)) objectCopy[key] = object[key];
    const keys = Object.keys(objectCopy);
    if (options.sort !== false) keys.sort(options.sort);
    return keys.map((key)=>{
        const value = object[key];
        if (value === undefined) return "";
        if (value === null) return encode(key, options);
        if (Array.isArray(value)) return value.reduce(formatter(key), []).join("&");
        return encode(key, options) + "=" + encode(value, options);
    }).filter((x)=>x.length > 0).join("&");
};
exports.parseUrl = (url, options)=>{
    options = Object.assign({
        decode: true
    }, options);
    const [url_, hash] = splitOnFirst(url, "#");
    return Object.assign({
        url: url_.split("?")[0] || "",
        query: parse(extract(url), options)
    }, options && options.parseFragmentIdentifier && hash ? {
        fragmentIdentifier: decode(hash, options)
    } : {});
};
exports.stringifyUrl = (object, options)=>{
    options = Object.assign({
        encode: true,
        strict: true
    }, options);
    const url = removeHash(object.url).split("?")[0] || "";
    const queryFromUrl = exports.extract(object.url);
    const parsedQueryFromUrl = exports.parse(queryFromUrl, {
        sort: false
    });
    const query = Object.assign(parsedQueryFromUrl, object.query);
    let queryString = exports.stringify(query, options);
    if (queryString) queryString = `?${queryString}`;
    let hash = getHash(object.url);
    if (object.fragmentIdentifier) hash = `#${encode(object.fragmentIdentifier, options)}`;
    return `${url}${queryString}${hash}`;
};
exports.pick = (input, filter, options)=>{
    options = Object.assign({
        parseFragmentIdentifier: true
    }, options);
    const { url, query, fragmentIdentifier } = exports.parseUrl(input, options);
    return exports.stringifyUrl({
        url,
        query: filterObject(query, filter),
        fragmentIdentifier
    }, options);
};
exports.exclude = (input, filter, options)=>{
    const exclusionFilter = Array.isArray(filter) ? (key)=>!filter.includes(key) : (key, value)=>!filter(key, value);
    return exports.pick(input, exclusionFilter, options);
};

},{"5752d3663915398f":"kO7zY","4cbbda34882b91a3":"5LMgi","53494decacb36d1b":"fCebu","dfb8fa56cbbad4a5":"fy1Dy"}],"kO7zY":[function(require,module,exports) {
"use strict";
module.exports = (str)=>encodeURIComponent(str).replace(/[!'()*]/g, (x)=>`%${x.charCodeAt(0).toString(16).toUpperCase()}`);

},{}],"5LMgi":[function(require,module,exports) {
"use strict";
var token = "%[a-f0-9]{2}";
var singleMatcher = new RegExp("(" + token + ")|([^%]+?)", "gi");
var multiMatcher = new RegExp("(" + token + ")+", "gi");
function decodeComponents(components, split) {
    try {
        // Try to decode the entire string first
        return [
            decodeURIComponent(components.join(""))
        ];
    } catch (err) {
    // Do nothing
    }
    if (components.length === 1) return components;
    split = split || 1;
    // Split the array in 2 parts
    var left = components.slice(0, split);
    var right = components.slice(split);
    return Array.prototype.concat.call([], decodeComponents(left), decodeComponents(right));
}
function decode(input) {
    try {
        return decodeURIComponent(input);
    } catch (err) {
        var tokens = input.match(singleMatcher) || [];
        for(var i = 1; i < tokens.length; i++){
            input = decodeComponents(tokens, i).join("");
            tokens = input.match(singleMatcher) || [];
        }
        return input;
    }
}
function customDecodeURIComponent(input) {
    // Keep track of all the replacements and prefill the map with the `BOM`
    var replaceMap = {
        "%FE%FF": "��",
        "%FF%FE": "��"
    };
    var match = multiMatcher.exec(input);
    while(match){
        try {
            // Decode as big chunks as possible
            replaceMap[match[0]] = decodeURIComponent(match[0]);
        } catch (err) {
            var result = decode(match[0]);
            if (result !== match[0]) replaceMap[match[0]] = result;
        }
        match = multiMatcher.exec(input);
    }
    // Add `%C2` at the end of the map to make sure it does not replace the combinator before everything else
    replaceMap["%C2"] = "�";
    var entries = Object.keys(replaceMap);
    for(var i = 0; i < entries.length; i++){
        // Replace all decoded components
        var key = entries[i];
        input = input.replace(new RegExp(key, "g"), replaceMap[key]);
    }
    return input;
}
module.exports = function(encodedURI) {
    if (typeof encodedURI !== "string") throw new TypeError("Expected `encodedURI` to be of type `string`, got `" + typeof encodedURI + "`");
    try {
        encodedURI = encodedURI.replace(/\+/g, " ");
        // Try the built in decoder first
        return decodeURIComponent(encodedURI);
    } catch (err) {
        // Fallback to a more advanced decoder
        return customDecodeURIComponent(encodedURI);
    }
};

},{}],"fCebu":[function(require,module,exports) {
"use strict";
module.exports = (string, separator)=>{
    if (!(typeof string === "string" && typeof separator === "string")) throw new TypeError("Expected the arguments to be of type `string`");
    if (separator === "") return [
        string
    ];
    const separatorIndex = string.indexOf(separator);
    if (separatorIndex === -1) return [
        string
    ];
    return [
        string.slice(0, separatorIndex),
        string.slice(separatorIndex + separator.length)
    ];
};

},{}],"fy1Dy":[function(require,module,exports) {
"use strict";
module.exports = function(obj, predicate) {
    var ret = {};
    var keys = Object.keys(obj);
    var isArr = Array.isArray(predicate);
    for(var i = 0; i < keys.length; i++){
        var key = keys[i];
        var val = obj[key];
        if (isArr ? predicate.indexOf(key) !== -1 : predicate(key, val, obj)) ret[key] = val;
    }
    return ret;
};

},{}],"WpI1B":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _defineProperty = require("@babel/runtime/helpers/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _api = require("../../api");
var _genericAnalyticsContainer = require("./GenericAnalyticsContainer");
var _genericAnalyticsContainerDefault = parcelHelpers.interopDefault(_genericAnalyticsContainer);
var _featureTypeIds = require("../../constants/featureTypeIds");
class ContentTrackingContainer extends (0, _genericAnalyticsContainerDefault.default) {
    constructor(){
        super();
        (0, _definePropertyDefault.default)(this, "displayOptions", []);
        this.state = {
            isLoading: false,
            isLoadingDetails: false,
            errors: [],
            trees: []
        };
    }
    async loadTree(applicationId, contentId, filter) {
        await this.setLoading(true);
        try {
            const result = await _api.getContentConversationTracking(applicationId, contentId, filter);
            const trees = this.state.trees;
            if (result?.resultType == "Ok") trees.push({
                id: contentId,
                filter: filter,
                data: {
                    childNodes: result.data,
                    conversationTrackingNodeType: null,
                    requestIds: [],
                    sessionIds: []
                },
                conversationItems: []
            });
            await this.setState({
                ...this.state,
                isLoading: false,
                trees,
                errors: []
            });
            return result;
        } catch  {
            await this.setLoading(false);
        }
    }
    async loadNodeDetails(applicationId, contentId, filter, nodes) {
        await this.setLoadingDetails(true);
        try {
            if (nodes.length < 1) return null;
            const result = await _api.bulkLoadDetails({
                applicationId: applicationId,
                content: nodes.filter((c)=>c.conversationTrackingNodeType == "Content")?.map((c)=>({
                        id: c.contentId,
                        featureTypeId: c.featureTypeId ?? (0, _featureTypeIds.FallbackFeatureTypeId)
                    }))
            });
            if (result?.resultType == "Ok") {
                const trees = this.state.trees;
                const tree = this.findTree(contentId, filter);
                const index = trees.indexOf(tree);
                if (!tree) return null;
                const conversationItems = tree.conversationItems ?? [];
                result?.data?.forEach((c)=>{
                    if (!conversationItems.some((ci)=>c.id == ci.id)) conversationItems.push(c);
                });
                tree.conversationItems = conversationItems;
                trees[index] = tree;
                await this.setState({
                    ...this.state,
                    isLoadingDetails: false,
                    trees,
                    errors: []
                });
                // if we have any that were not found, try them in fallback
                const missedNodes = nodes?.filter((c)=>c.conversationTrackingNodeType == "Content" && !result.data?.some((r)=>r.id == c?.contentId));
                if (missedNodes?.length > 0) {
                    const result = await _api.bulkLoadDetails({
                        applicationId: applicationId,
                        content: missedNodes?.map((c)=>({
                                id: c.contentId,
                                featureTypeId: (0, _featureTypeIds.FallbackFeatureTypeId)
                            }))
                    });
                    if (result?.resultType == "Ok") {
                        const trees = this.state.trees;
                        const tree = this.findTree(contentId, filter);
                        const index = trees.indexOf(tree);
                        if (!tree) return null;
                        const conversationItems = tree.conversationItems ?? [];
                        result?.data?.forEach((c)=>{
                            if (!conversationItems.some((ci)=>c.id == ci.id)) conversationItems.push(c);
                        });
                        tree.conversationItems = conversationItems;
                        trees[index] = tree;
                        await this.setState({
                            ...this.state,
                            isLoadingDetails: false,
                            trees,
                            errors: []
                        });
                    }
                }
            }
            return result;
        } catch  {
            await this.setLoadingDetails(false);
        }
    }
    convertToContentTree(tree) {
        const childNodes = [];
        tree.data.childNodes.forEach((parent)=>{
            parent.childNodes[0].childNodes.forEach((child)=>{
                if (!childNodes.some((c)=>c.conversationTrackingNodeType == child.conversationTrackingNodeType && c?.contentId == child?.contentId)) childNodes.push(child);
            });
        });
        return {
            parentNodes: tree.data.childNodes,
            contentNode: tree.data.childNodes[0]?.childNodes[0],
            childNodes: childNodes
        };
    }
    setLoadingDetails(isLoadingDetails) {
        this.setState({
            ...this.state,
            isLoadingDetails
        });
    }
    findTree(contentId, filter) {
        return this.state.trees.find((h)=>this.buildCacheKey(h.id, h.filter) == this.buildCacheKey(contentId, filter));
    }
}
exports.default = ContentTrackingContainer;

},{"@babel/runtime/helpers/defineProperty":"9sJxO","../../api":"loxM6","./GenericAnalyticsContainer":"3eKoF","../../constants/featureTypeIds":"hPLMP","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7u8KD":[function(require,module,exports) {
module.exports = require("ae88676e72bdf3dd").getBundleURL("kVLro") + require("5529a63560f84d05").resolve("lynOG");

},{"ae88676e72bdf3dd":"c7Tr5","5529a63560f84d05":"fyJL2"}],"gwpgo":[function(require,module,exports) {
module.exports = require("eaad4481c659bed4").getBundleURL("kVLro") + require("fd9dc2410b761c39").resolve("3ZQUW");

},{"eaad4481c659bed4":"c7Tr5","fd9dc2410b761c39":"fyJL2"}],"dStWl":[function(require,module,exports) {
module.exports = require("e2f2984ede1b7170").getBundleURL("kVLro") + require("d8876db91f0e0d22").resolve("4tfZn");

},{"e2f2984ede1b7170":"c7Tr5","d8876db91f0e0d22":"fyJL2"}],"dt39z":[function(require,module,exports) {
module.exports = require("6d50a0032d95bd9b").getBundleURL("kVLro") + require("8e01dfaf166ae44b").resolve("9PPbP");

},{"6d50a0032d95bd9b":"c7Tr5","8e01dfaf166ae44b":"fyJL2"}],"6668N":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _colors = require("../../constants/colors");
const containerStyle = /*#__PURE__*/ (0, _css.css)("margin-right:64px;.incomplete-indicator{margin-left:60px;}padding-left:24px;.status{label{color:", (0, _colors.color_shades_light), ";}}.incomplete-indicator{span{color:white;}}", "");
const HeaderStatusContainer = (props)=>(0, _react.jsx)("div", {
        className: containerStyle
    }, props.children);
exports.default = HeaderStatusContainer;

},{"@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","../../constants/colors":"1p3OR","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"btY5V":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _unstated = require("unstated");
var _api = require("../../api");
var _platforms = require("../../models/extensions/platforms");
const speakerIcon = require("887bdb448fd2f77c");
const screenIcon = require("7e13b69b8eb98750");
const chatIcon = require("ae4b58d37d085599");
class ApplicationAnalyticsFacetContainer extends (0, _unstated.Container) {
    constructor(){
        super();
        this.state = {
            assistants: [],
            deviceTargets: [],
            interfaces: [
                {
                    name: "Audio",
                    iconUrl: speakerIcon
                },
                {
                    name: "Screen",
                    iconUrl: screenIcon
                },
                {
                    name: "Chat",
                    iconUrl: chatIcon
                }
            ],
            errors: [],
            isLoading: false
        };
    }
    getDeviceTargets() {
        // if we already have targets return them
        if (this.state.deviceTargets.length > 0) return new Promise((resolve)=>{
            resolve({
                data: this.state.deviceTargets,
                errors: [],
                resultType: "Ok"
            });
        });
        this.setLoading(true);
        var promise = _api.getAllDeviceTargets();
        promise.then((result)=>{
            if (result.resultType == "Ok") this.setState({
                ...this.state,
                errors: [],
                deviceTargets: result.data,
                isLoading: false
            });
            else this.setState({
                ...this.state,
                errors: result.errors,
                isLoading: false
            });
        }).catch((error)=>{
            this.setState({
                ...this.state,
                errors: [
                    error
                ],
                isLoading: false
            });
        });
        return promise;
    }
    convertFilter(startDate, endDate, filterState, deviceTargets) {
        const filter = {
            startDate: startDate,
            endDate: endDate,
            assistants: filterState.assistants,
            languageIds: filterState.languageIds,
            locales: filterState.locales
        };
        // aggregate the explicit devicetarget ids and the interface types
        const deviceTargetIds = filterState.deviceTargetIds ?? [];
        if (filterState?.interfaces?.some((i)=>i.toLocaleLowerCase() == "screen")) {
            const screenDevices = deviceTargets.filter((d)=>d.supportsForegroundImages)?.map((d)=>d.id);
            deviceTargetIds.push(...screenDevices);
        }
        if (filterState?.interfaces?.some((i)=>i.toLocaleLowerCase() == "audio")) {
            const audioDevices = deviceTargets.filter((d)=>d.supportsRichAudio && !d.supportsForegroundImages)?.map((d)=>d.id);
            deviceTargetIds.push(...audioDevices);
        }
        if (filterState?.interfaces?.some((i)=>i.toLocaleLowerCase() == "chat")) {
            const chatDevices = deviceTargets.filter((d)=>d.supportsDisplayText && !d.supportsRichAudio)?.map((d)=>d.id);
            deviceTargetIds.push(...chatDevices);
        }
        filter.deviceTargetIds = deviceTargetIds;
        return filter;
    }
    async getAssistants(applicationId, startDate, endDate) {
        this.setLoading(true);
        try {
            const assistantNamesResult = await _api.getApplicationUniqueAssistants(applicationId, {
                startDate,
                endDate
            });
            const assistants = assistantNamesResult?.data?.map((n)=>({
                    name: n,
                    iconUrl: (0, _platforms.getPlatformIcon)(n)
                })) ?? [];
            this.setState({
                ...this.state,
                isLoading: false,
                assistants: assistants
            });
        } catch  {
            this.setLoading(false);
        }
    }
    setLoading(isLoading) {
        this.setState({
            ...this.state,
            isLoading
        });
    }
}
exports.default = ApplicationAnalyticsFacetContainer;

},{"unstated":"grh7p","../../api":"loxM6","../../models/extensions/platforms":"fObhx","887bdb448fd2f77c":"9pEQA","7e13b69b8eb98750":"9l70Q","ae4b58d37d085599":"3u7X8","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"bSD86":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _extends = require("@babel/runtime/helpers/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _base = require("@emotion/styled/base");
var _baseDefault = parcelHelpers.interopDefault(_base);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _unstated = require("unstated");
var _textField = require("../../components/forms/TextField");
var _textFieldDefault = parcelHelpers.interopDefault(_textField);
var _button = require("../../components/general/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _modalHeader = require("../../components/general/ModalHeader");
var _modalHeaderDefault = parcelHelpers.interopDefault(_modalHeader);
var _pageError = require("../../components/general/PageError");
var _pageErrorDefault = parcelHelpers.interopDefault(_pageError);
var _warningLabel = require("../../components/general/WarningLabel");
var _warningLabelDefault = parcelHelpers.interopDefault(_warningLabel);
var _footerBar = require("../../components/structure/FooterBar");
var _footerBarDefault = parcelHelpers.interopDefault(_footerBar);
var _horizontalSeparator = require("../../components/structure/HorizontalSeparator");
var _horizontalSeparatorDefault = parcelHelpers.interopDefault(_horizontalSeparator);
var _smallModalLayout = require("../../components/structure/SmallModalLayout");
var _smallModalLayoutDefault = parcelHelpers.interopDefault(_smallModalLayout);
var _colors = require("../../constants/colors");
var _extensions = require("../../models/extensions");
var _applicationBackupVersionsContainer = require("../../state/containers/ApplicationBackupVersionsContainer");
var _applicationBackupVersionsContainerDefault = parcelHelpers.interopDefault(_applicationBackupVersionsContainer);
var _applicationEnvironmentsContainer = require("../../state/containers/ApplicationEnvironmentsContainer");
var _applicationEnvironmentsContainerDefault = parcelHelpers.interopDefault(_applicationEnvironmentsContainer);
var _featureContainer = require("../../state/containers/FeatureContainer");
var _featureContainerDefault = parcelHelpers.interopDefault(_featureContainer);
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const darkPage = require("e1c382bc36b01082");
const darkFolderFile = require("162a48fe495f35b7");
const yellowInfoCircle = require("bf8629aed0d41efb");
const doorLocked = require("2480d1ff8e4c969e");
const arrowRight = require("386f1860b0de27bc");
const doorUnlocked = require("c3776d8bb95f1be1");
const InnerPartialPublishForm = (props)=>{
    const [name, setName] = (0, _react1.useState)(props.isUnpublishing ? "Unpublished" : "Published");
    const [publishingContentItems, setPublishingContentItems] = (0, _react1.useState)([]);
    const [loading, setLoading] = (0, _react1.useState)(true);
    const [selectedContentCount, setSelectedContentCount] = (0, _react1.useState)(0);
    const [contentInFoldersCount, setContentInFoldersCount] = (0, _react1.useState)(0);
    const [warningIsVisible, setWarningIsVisible] = (0, _react1.useState)(true);
    const rootAction = props.isUnpublishing ? "Unpublish" : "Publish";
    (0, _react1.useEffect)(()=>{
        const initialLoad = async ()=>{
            const hasFolders = !(props.applicationFeatureIds === undefined || props.applicationFeatureIds.length == 0);
            if (props.defaultContentItemName && props.contentItems?.length == 1 && !hasFolders) {
                setName(`${rootAction}ing ${props.defaultContentItemName}`);
                setPublishingContentItems(props.contentItems);
                setSelectedContentCount(1);
            } else {
                let toPublish = [
                    ...props.contentItems
                ];
                setSelectedContentCount(toPublish.length);
                if (hasFolders) {
                    let folders = [];
                    const loadChildFolders = async (folderId)=>{
                        const childFolders = await props.featureContainer.getFeaturesForParent(folderId);
                        if (!(childFolders === undefined || childFolders.length == 0)) childFolders.forEach((f)=>loadChildFolders(f.id));
                        folders = [
                            ...folders,
                            folderId
                        ];
                    };
                    for(let i = 0; i < props.applicationFeatureIds.length; i++)await loadChildFolders(props.applicationFeatureIds[i]);
                    let contentInFolders = [];
                    for(let i = 0; i < folders.length; i++){
                        const folderId = folders[i];
                        const content = await props.featureContainer.getContentItemsForAppFeature(folderId);
                        contentInFolders = [
                            ...contentInFolders,
                            ...content.data.map((c)=>{
                                return {
                                    contentId: c.id,
                                    featureTypeId: c.featureTypeId
                                };
                            })
                        ];
                    }
                    setContentInFoldersCount(contentInFolders.length);
                    toPublish = [
                        ...toPublish,
                        ...contentInFolders
                    ];
                }
                let defaultName = `${rootAction}ed 1 content item`;
                if (toPublish.length > 1) defaultName = `${rootAction}ed ${toPublish.length} content items`;
                setName(defaultName);
                setPublishingContentItems(toPublish);
            }
            await setLoading(false);
        };
        initialLoad();
    }, [
        props.isUnpublishing
    ]);
    const handleSubmit = async ()=>{
        setLoading(true);
        if (props.isUnpublishing) {
            await props.environmentsContainer.unpublishContentItems(props.environmentId, {
                name: name,
                contentItems: publishingContentItems
            });
            setLoading(false);
            props.onClose();
            return;
        } else {
            const backupAndPublishResult = await props.environmentsContainer.queuePartialBackupAndPublish(props.applicationId, props.environmentId, {
                name: name ?? `${rootAction}ed`,
                description: "",
                contentItems: publishingContentItems
            });
            if (backupAndPublishResult?.resultType == "Ok") {
                await props.environmentsContainer.addPublish(backupAndPublishResult.data.publish);
                props.backupsContainer.waitForBackup(backupAndPublishResult.data.backup.id);
                props.environmentsContainer.waitForPublish(backupAndPublishResult.data.publish.id);
                props.history.push((0, _extensions.getFeatureContentUrl)(props.applicationId, props.applicationFeatureId));
                setLoading(false);
                props.onClose();
                return;
            }
        }
        // Error occured
        setLoading(false);
    };
    const handlePublishModalWarningClose = ()=>{
        setWarningIsVisible(false);
    };
    const handleKeyDown = (e)=>{
        e.stopPropagation();
        if (loading) return;
        if (e.key === "Enter") handleSubmit();
        if (e.key === "Escape") props.onClose();
    };
    return (0, _react.jsx)(PartialPublishModal, {
        isVisible: true,
        onClose: props.onClose
    }, (0, _react.jsx)(ModalForm, {
        tabIndex: 0,
        onKeyDown: handleKeyDown
    }, (0, _react.jsx)((0, _modalHeaderDefault.default), {
        title: rootAction,
        onClose: props.onClose
    }), (0, _react.jsx)("div", {
        className: "modal-body"
    }, (0, _react.jsx)(PublishConfirmationHeader, null, "Kick off a Partial ", rootAction, "?"), (0, _react.jsx)("p", {
        className: "margin-bottom"
    }, "This will ", rootAction.toLocaleLowerCase(), " all changes found in the selected content item(s). Any content items that share components like follow-ups or reprompts will not be ", rootAction.toLocaleLowerCase(), "ed."), props.showClosedAccessWarning && warningIsVisible && !props.isUnpublishing && (0, _react.jsx)((0, _warningLabelDefault.default), {
        onClose: handlePublishModalWarningClose.bind(undefined),
        closable: true,
        image: yellowInfoCircle,
        text: 'You are publishing an item set to "No Access" and it will not be hit by users'
    }), (0, _react.jsx)((0, _textFieldDefault.default), {
        autoFocus: true,
        useForm: false,
        value: name,
        name: "name",
        placeholder: "Enter name here",
        label: "Name",
        onChange: (e)=>setName(e.target.value),
        readOnly: loading
    }), (0, _react.jsx)((0, _horizontalSeparatorDefault.default), null), (0, _react.jsx)(PublishConfirmationHeader, {
        className: "summary"
    }, "Summary"), (0, _react.jsx)("p", {
        className: "margin-bottom"
    }, `${rootAction}ing your selected content`), selectedContentCount > 0 && (0, _react.jsx)(SummaryRow, null, (0, _react.jsx)("img", {
        src: darkPage
    }), (0, _react.jsx)("p", null, `${selectedContentCount} Conversation item${selectedContentCount == 1 ? "" : "s"}`)), contentInFoldersCount > 0 && (0, _react.jsx)(SummaryRow, null, (0, _react.jsx)("img", {
        src: darkFolderFile
    }), (0, _react.jsx)("p", null, `${contentInFoldersCount} Conversation item${contentInFoldersCount == 1 ? "" : "s"} in selected folders`))), (0, _react.jsx)((0, _footerBarDefault.default), null, (0, _react.jsx)((0, _buttonDefault.default), {
        type: "button",
        themes: [
            "primary",
            "start"
        ],
        text: rootAction,
        onClick: handleSubmit,
        disabled: loading,
        loading: loading
    }), (0, _react.jsx)((0, _buttonDefault.default), {
        type: "button",
        themes: [
            "secondary",
            "end"
        ],
        text: "Cancel",
        onClick: ()=>props.onClose(),
        disabled: loading,
        loading: loading
    })), (0, _react.jsx)((0, _pageErrorDefault.default), {
        errors: [
            ...props.backupsContainer?.state?.errors ?? [],
            ...props.environmentsContainer?.state?.errors ?? []
        ],
        onClear: ()=>{
            props.backupsContainer.clearErrors();
            props.environmentsContainer.clearErrors();
        }
    })));
};
const PartialPublishForm = (props)=>(0, _react.jsx)((0, _unstated.Subscribe), {
        to: [
            (0, _applicationBackupVersionsContainerDefault.default),
            (0, _applicationEnvironmentsContainerDefault.default),
            (0, _featureContainerDefault.default)
        ]
    }, (backupsContainer, environmentsContainer, featureContainer)=>(0, _react.jsx)(InnerPartialPublishForm, (0, _extendsDefault.default)({}, props, {
            featureContainer: featureContainer,
            environmentId: environmentsContainer.findPrimaryEnvironment(props.applicationId)?.id,
            backupsContainer: backupsContainer,
            environmentsContainer: environmentsContainer
        })));
const SummaryRow = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e16xm0te3"
})({
    name: "1ehabg8",
    styles: "display:flex;margin:8px 0px 16px 0px;p{margin-bottom:0px;}img{margin-right:8px;}"
});
const PublishConfirmationHeader = /*#__PURE__*/ (0, _baseDefault.default)("h5", {
    target: "e16xm0te2"
})("font-family:Muli;font-style:normal;font-weight:normal;font-size:16px;line-height:24px;color:", (0, _colors.color_text_default), ";margin-top:24px;margin-bottom:16px;&.summary{margin:16px 0 8px 0;}");
const PartialPublishModal = /*#__PURE__*/ (0, _baseDefault.default)((0, _smallModalLayoutDefault.default), {
    target: "e16xm0te1"
})({
    name: "j9bqec",
    styles: "max-width:615px"
});
const ModalForm = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e16xm0te0"
})({
    name: "d0xc0n",
    styles: "min-height:600px;height:auto;.modal-body{padding:0 32px;margin-bottom:150px;height:100%;flex:1;h4{font-style:normal;font-weight:normal;font-size:18px;line-height:24px;}p{font-style:normal;font-weight:normal;font-size:14px;line-height:20px;}.margin-bottom{margin:0 0 24px 0;}}"
});
exports.default = PartialPublishForm;

},{"@babel/runtime/helpers/extends":"4iKIP","@emotion/styled/base":"lSuFu","@emotion/react":"djZKr","react":"6uln9","unstated":"grh7p","../../components/forms/TextField":"7a7bh","../../components/general/Button":"6ymxN","../../components/general/ModalHeader":"aUACx","../../components/general/PageError":"ezFTm","../../components/general/WarningLabel":"2Tr48","../../components/structure/FooterBar":"bibRL","../../components/structure/HorizontalSeparator":"Pw3HQ","../../components/structure/SmallModalLayout":"khwvt","../../constants/colors":"1p3OR","../../models/extensions":"7h01B","../../state/containers/ApplicationBackupVersionsContainer":"6rA1P","../../state/containers/ApplicationEnvironmentsContainer":"jCULY","../../state/containers/FeatureContainer":"4ApGg","e1c382bc36b01082":"8q1aI","162a48fe495f35b7":"bTeYH","bf8629aed0d41efb":"k0Bys","2480d1ff8e4c969e":"1vDlO","386f1860b0de27bc":"lHfkJ","c3776d8bb95f1be1":"2hCDL","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2Tr48":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _base = require("@emotion/styled/base");
var _baseDefault = parcelHelpers.interopDefault(_base);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _colors = require("../../constants/colors");
var _button = require("./Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
const closeIcon = require("51fdb8c43c2c5643");
const WarningLabel = (props)=>{
    return (0, _react.jsx)(WarningLabelWrapper, null, (0, _react.jsx)("div", {
        className: props.closable ? "wrapper-with-close" : "wrapper-no-close"
    }, (0, _react.jsx)("img", {
        src: props.image
    }), (0, _react.jsx)("p", null, props.text), props.closable && (0, _react.jsx)((0, _buttonDefault.default), {
        themes: [
            "end-tight",
            "icon"
        ],
        icon: closeIcon,
        onClick: props.onClose
    })));
};
const WarningLabelWrapper = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1eg8l820"
})("border-radius:12px;background:", (0, _colors.color_variants_gold_light), ";border:1px solid ", (0, _colors.color_colors_gold), ";width:auto;margin-bottom:16px;.wrapper-with-close{display:flex;align-items:center;flex-direction:row;padding-left:24px;padding-right:16px;}.wrapper-no-close{display:flex;align-items:center;flex-direction:row;padding:18px 16px 18px 24px;}img{margin-right:25px;}button{img{width:20px;height:20px;}}");
exports.default = WarningLabel;

},{"@emotion/styled/base":"lSuFu","@emotion/react":"djZKr","react":"6uln9","../../constants/colors":"1p3OR","./Button":"6ymxN","51fdb8c43c2c5643":"93VwA","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8q1aI":[function(require,module,exports) {
module.exports = require("d0ea9eea22d0051b").getBundleURL("kVLro") + require("631690d028824708").resolve("dzPZL");

},{"d0ea9eea22d0051b":"c7Tr5","631690d028824708":"fyJL2"}],"bTeYH":[function(require,module,exports) {
module.exports = require("2ef37b1c13fca5db").getBundleURL("kVLro") + require("102cb9ef9f185de7").resolve("k0fG8");

},{"2ef37b1c13fca5db":"c7Tr5","102cb9ef9f185de7":"fyJL2"}],"lHfkJ":[function(require,module,exports) {
module.exports = require("c227e3cfcfdfd5a3").getBundleURL("kVLro") + require("5a420fc1bf02155f").resolve("itQnm");

},{"c227e3cfcfdfd5a3":"c7Tr5","5a420fc1bf02155f":"fyJL2"}],"iwYJ0":[function(require,module,exports) {
module.exports = require("e0fd2078f96ec44e").getBundleURL("kVLro") + require("a9b2e83a09b9b6a9").resolve("aMrRE");

},{"e0fd2078f96ec44e":"c7Tr5","a9b2e83a09b9b6a9":"fyJL2"}],"aoV7Y":[function(require,module,exports) {
module.exports = require("51c8307356fa26e5").getBundleURL("kVLro") + require("d28ad7ebb362b6be").resolve("fWVcB");

},{"51c8307356fa26e5":"c7Tr5","d28ad7ebb362b6be":"fyJL2"}],"9Jasv":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _unstated = require("unstated");
var _helpMessageContentForm = require("./components/HelpMessageContentForm");
var _helpMessageContentFormDefault = parcelHelpers.interopDefault(_helpMessageContentForm);
var _helpMessageContainer = require("../../state/containers/HelpMessageContainer");
var _helpMessageContainerDefault = parcelHelpers.interopDefault(_helpMessageContainer);
var _applicationContainer = require("../../state/containers/ApplicationContainer");
var _applicationContainerDefault = parcelHelpers.interopDefault(_applicationContainer);
var _titleStateContainer = require("../../state/containers/TitleStateContainer");
var _titleStateContainerDefault = parcelHelpers.interopDefault(_titleStateContainer);
var _followUpContainer = require("../../state/containers/FollowUpContainer");
var _followUpContainerDefault = parcelHelpers.interopDefault(_followUpContainer);
var _repromptContainer = require("../../state/containers/RepromptContainer");
var _repromptContainerDefault = parcelHelpers.interopDefault(_repromptContainer);
var _mediaResponseContainer = require("../../state/containers/MediaResponseContainer");
var _mediaResponseContainerDefault = parcelHelpers.interopDefault(_mediaResponseContainer);
var _navigationBarFormPage = require("../formScenes/NavigationBarFormPage");
var _navigationBarFormPageDefault = parcelHelpers.interopDefault(_navigationBarFormPage);
var _genericCreateContentItemPage = require("../formScenes/GenericCreateContentItemPage");
var _genericCreateContentItemPageDefault = parcelHelpers.interopDefault(_genericCreateContentItemPage);
var _featureContainer = require("../../state/containers/FeatureContainer");
var _featureContainerDefault = parcelHelpers.interopDefault(_featureContainer);
var _featureTypeIds = require("../../constants/featureTypeIds");
class CreateHelpMessage extends (0, _navigationBarFormPageDefault.default) {
    render() {
        return (0, _react.jsx)((0, _unstated.Subscribe), {
            to: [
                (0, _helpMessageContainerDefault.default),
                (0, _applicationContainerDefault.default),
                (0, _titleStateContainerDefault.default),
                (0, _repromptContainerDefault.default),
                (0, _followUpContainerDefault.default),
                (0, _mediaResponseContainerDefault.default),
                (0, _featureContainerDefault.default)
            ]
        }, (helpContainer, appContainer, titleContainer, repromptContainer, followUpContainer, responseContainer, featureContainer)=>{
            return (0, _react.jsx)((0, _genericCreateContentItemPageDefault.default), {
                stateContainer: helpContainer,
                titleContainer: titleContainer,
                applicationContainer: appContainer,
                defaultTitle: "New Help Message",
                history: this.props.history,
                location: this.props.location,
                match: this.props.match,
                staticContext: this.props.staticContext,
                featureContainer: featureContainer,
                featureTypeId: (0, _featureTypeIds.HelpMessagesFeatureTypeId),
                formRender: (application, assistantApplication, onPublish, onSubmit, onAccessTypeChange)=>(0, _react.jsx)((0, _helpMessageContentFormDefault.default), {
                        location: this.props.location,
                        application: application,
                        applicationFeatureId: this.props.match.params.applicationFeatureId,
                        stateContainer: helpContainer,
                        assistantApplication: assistantApplication,
                        appContainer: appContainer,
                        followUpContainer: followUpContainer,
                        repromptContainer: repromptContainer,
                        featureContainer: featureContainer,
                        responseStateContainer: responseContainer,
                        onAccessTypeChange: onAccessTypeChange,
                        onShowPublishModal: onPublish,
                        history: this.props.history,
                        isSaving: helpContainer.state.isSaving,
                        onSubmit: onSubmit
                    })
            });
        });
    }
}
exports.default = CreateHelpMessage;

},{"@emotion/react":"djZKr","react":"6uln9","unstated":"grh7p","./components/HelpMessageContentForm":"6PHb9","../../state/containers/HelpMessageContainer":"2oQaX","../../state/containers/ApplicationContainer":"cuqi2","../../state/containers/TitleStateContainer":"2osOD","../../state/containers/FollowUpContainer":"rm9OA","../../state/containers/RepromptContainer":"5vKMV","../../state/containers/MediaResponseContainer":"1ccrV","../formScenes/NavigationBarFormPage":"4ZcAE","../formScenes/GenericCreateContentItemPage":"dUUA3","../../state/containers/FeatureContainer":"4ApGg","../../constants/featureTypeIds":"hPLMP","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6PHb9":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _formik = require("formik");
var _yup = require("yup");
var _helpMessageForm = require("../../formScenes/HelpMessageForm");
var _helpMessageFormDefault = parcelHelpers.interopDefault(_helpMessageForm);
const HelpMessageContentForm = (0, _formik.withFormik)({
    mapPropsToValues: (props)=>({
            responses: [
                {
                    content: ""
                }
            ],
            title: "Untitled Help Message",
            followUpSelection: "end",
            repromptSelection: "end",
            sensitiveConversationChange: "None",
            entryType: "open",
            requiresParent: false,
            isLive: true,
            languages: props.application?.languages.find((l)=>l.id == props.application?.defaultLanguageId) ? [
                props.application?.languages.find((l)=>l.id == props.application?.defaultLanguageId)
            ] : [],
            webhookChainingType: "NoChaining"
        }),
    validationSchema: _yup.object().shape({
        title: _yup.string().required("You must enter a title"),
        responses: _yup.array().of(_yup.object().shape({
            content: _yup.string().required("You must enter a response variation")
        })).required("You must enter at least 1 response variation").min(1, "You must enter at least 1 response variation")
    }),
    validateOnMount: true,
    handleSubmit: (values, { props, setStatus, setFieldValue })=>{
        setStatus({
            submitting: true
        });
        return props.onSubmit(props.stateContainer.mapFormDataToModel({
            applicationFeatureId: props.applicationFeatureId,
            applicationId: props.application?.id,
            responses: []
        }, values));
    }
})((0, _helpMessageFormDefault.default));
exports.default = HelpMessageContentForm;

},{"formik":"3YnOK","yup":"j2SJU","../../formScenes/HelpMessageForm":"hiYsm","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hiYsm":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _defineProperty = require("@babel/runtime/helpers/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _pageContainer = require("../../components/structure/PageContainer");
var _pageContainerDefault = parcelHelpers.interopDefault(_pageContainer);
var _titleTextField = require("../../components/forms/TitleTextField");
var _titleTextFieldDefault = parcelHelpers.interopDefault(_titleTextField);
var _followUpForm = require("../followUpForm");
var _followUpFormDefault = parcelHelpers.interopDefault(_followUpForm);
var _loader = require("../../components/general/Loader");
var _loaderDefault = parcelHelpers.interopDefault(_loader);
var _featureTypeIds = require("../../constants/featureTypeIds");
var _contentLanguageMultiSelector = require("../../components/forms/ContentLanguageMultiSelector");
var _contentLanguageMultiSelectorDefault = parcelHelpers.interopDefault(_contentLanguageMultiSelector);
var _contentPage = require("../contentPage");
var _contentPageDefault = parcelHelpers.interopDefault(_contentPage);
var _relatedContentMenu = require("../relatedContentMenu");
var _relatedContentMenuDefault = parcelHelpers.interopDefault(_relatedContentMenu);
var _scrollablePanelBody = require("../../components/structure/ScrollablePanelBody");
var _scrollablePanelBodyDefault = parcelHelpers.interopDefault(_scrollablePanelBody);
var _panelTitle = require("../contentPage/components/PanelTitle");
var _panelTitleDefault = parcelHelpers.interopDefault(_panelTitle);
var _contentCollapsingSection = require("../../components/structure/ContentCollapsingSection");
var _contentCollapsingSectionDefault = parcelHelpers.interopDefault(_contentCollapsingSection);
var _contentSectionTitle = require("../contentPage/components/ContentSectionTitle");
var _contentSectionTitleDefault = parcelHelpers.interopDefault(_contentSectionTitle);
var _extensions = require("../../models/extensions");
var _pageError = require("../../components/general/PageError");
var _pageErrorDefault = parcelHelpers.interopDefault(_pageError);
var _conversationItemActionButtonToolbar = require("./components/ConversationItemActionButtonToolbar");
var _conversationItemActionButtonToolbarDefault = parcelHelpers.interopDefault(_conversationItemActionButtonToolbar);
var _templateLockedBanner = require("../../components/general/TemplateLockedBanner");
var _templateLockedBannerDefault = parcelHelpers.interopDefault(_templateLockedBanner);
var _conversationItemFieldSet = require("../../components/forms/ConversationItemFieldSet");
var _conversationItemFieldSetDefault = parcelHelpers.interopDefault(_conversationItemFieldSet);
var _contentInfoOptions = require("../../components/structure/ContentInfoOptions");
var _contentInfoOptionsDefault = parcelHelpers.interopDefault(_contentInfoOptions);
var _responsesManager = require("../responsesManager");
var _responsesManagerDefault = parcelHelpers.interopDefault(_responsesManager);
var _dirtyFormPrompt = require("./components/DirtyFormPrompt");
var _sensitiveDataOptions = require("../contentPage/components/SensitiveDataOptions");
var _sensitiveDataOptionsDefault = parcelHelpers.interopDefault(_sensitiveDataOptions);
var _disableForFeatureFlagOptions = require("../contentPage/components/DisableForFeatureFlagOptions");
var _disableForFeatureFlagOptionsDefault = parcelHelpers.interopDefault(_disableForFeatureFlagOptions);
var _contentItemTestCaseViewer = require("./ContentItemTestCaseViewer");
var _contentItemTestCaseViewerDefault = parcelHelpers.interopDefault(_contentItemTestCaseViewer);
const contentInfoIcon = require("b97d1f7a279f0974");
const continueIcon = require("6adbf9112e93d73e");
class HelpMessageForm extends (0, _followUpFormDefault.default) {
    constructor(...args){
        super(...args);
        (0, _definePropertyDefault.default)(this, "handleResponseIdFromSim", (id)=>{
            this.setState({
                simulatedResponseId: id
            });
        });
    }
    componentDidUpdate(prevProps, prevState) {
        super.componentDidUpdate(prevProps, prevState);
    }
    handleAsyncSubmit(onSuccess) {
        if (this.manualValidate()) return this.props.onSubmit(this.props.stateContainer.mapFormDataToModel(this.props.helpMessage, this.props.values), onSuccess);
    }
    handleDiscardChanges() {
        this.handleFinish();
    }
    handleContentItemOptionSelected(option, event) {
        event.stopPropagation();
        if (option == "Manage Webhooks") this.showWebhookInstanceManager();
        else if (option == "Duplicate") this.handleCopy();
        else if (option == "Delete") this.handleDelete();
    }
    handleDelete() {
        const confirmed = confirm("Are you sure you want to delete this?");
        if (confirmed) this.props.stateContainer.delete(this.props.helpMessage.id).then(()=>{
            this.handleFinish();
        });
    }
    handleCopy() {
        this.handleAsyncSubmit(()=>{
            this.props.stateContainer.copy(this.props.helpMessage.id).then((r2)=>{
                if (r2.resultType == "Ok") this.props.history.push(`/v/${r2.data.applicationFeatureId}/helpmessages/${r2.data.id}`);
            });
        });
    }
    getMenuTreeRoots() {
        return [
            this.getContentInfoTreeItem(),
            ...this.getResponsesTreeItems(this.props.values.responses)
        ];
    }
    getContentItem() {
        return this.props.helpMessage;
    }
    handleResponsesChange(responseGroups) {
        this.props.setFieldValue("responses", this.getResponsesFromGroups(responseGroups));
    }
    render() {
        const props = {
            ...this.props
        };
        const isLoading = props.stateContainer.state.isSaving;
        const isDisabled = isLoading || this.props.isTemplateOwned;
        const responseGroups = this.getResponseGroups(this.props.values.responses);
        const { simulatedResponseId } = this.state;
        if (this.props.responseStateContainer.state.isLoading || !this.props.application) return (0, _react.jsx)((0, _loaderDefault.default), null);
        return (0, _react.jsx)((0, _reactDefault.default).Fragment, null, (0, _react.jsx)("form", {
            onSubmit: props.handleSubmit
        }, (0, _react.jsx)((0, _dirtyFormPrompt.DirtyFormPrompt), {
            allowPrompt: props.status?.submitting != true
        }), (0, _react.jsx)((0, _contentPageDefault.default), {
            relatedContentRender: ()=>(0, _react.jsx)((0, _relatedContentMenuDefault.default), {
                    parentContentId: this.props.previousContentId,
                    conversationItem: {
                        ...this.props.helpMessage,
                        featureTypeId: (0, _featureTypeIds.HelpMessagesFeatureTypeId)
                    },
                    history: this.props.history,
                    featureTypeId: (0, _featureTypeIds.HelpMessagesFeatureTypeId),
                    followUp: responseGroups?.[0]?.firstResponse?.followUp,
                    contentId: this.props.helpMessage?.id,
                    onClose: this.props.onToggleNavigation,
                    onSave: this.handleAsyncSubmit.bind(this)
                }),
            treeRender: this.renderTree.bind(this),
            formPanelRender: ()=>(0, _react.jsx)((0, _pageContainerDefault.default), {
                    fill: true
                }, (0, _react.jsx)((0, _conversationItemActionButtonToolbarDefault.default), {
                    errors: Object.values(props.errors),
                    validateForm: props.validateForm,
                    publishDisabled: this.props.assistantApplication == null,
                    saveDisabled: Object.keys(props.errors).length > 0,
                    contentItem: props.helpMessage,
                    isLoading: isLoading,
                    handleDiscardChanges: this.handleDiscardChanges.bind(this),
                    handlePublishing: this.handleSaveAndPublish.bind(this),
                    submitForm: props.submitForm
                }), props.helpMessage?.createdFromId && (0, _react.jsx)((0, _templateLockedBannerDefault.default), {
                    isLoading: props.stateContainer.state.isTogglingSync,
                    isLinked: props.isTemplateOwned,
                    onRelink: this.handleToggleRelinkModal.bind(this),
                    onUnlink: ()=>this.props.onToggleSync(this.props.helpMessage.id, true)
                }), (0, _react.jsx)((0, _conversationItemFieldSetDefault.default), {
                    disabled: isDisabled,
                    withBanner: props.helpMessage?.createdFromId != null
                }, (0, _react.jsx)((0, _scrollablePanelBodyDefault.default), {
                    className: "scrollable-body"
                }, (0, _react.jsx)((0, _panelTitleDefault.default), {
                    title: "Content Editing",
                    detail: "Here’s where you can fill in the info about this content and determine the course of the conversation by filling in the relevant details."
                }), (0, _react.jsx)((0, _contentCollapsingSectionDefault.default), {
                    title: "Content Info",
                    id: "contentInfo",
                    icon: contentInfoIcon,
                    titleRightRowComponent: (0, _react.jsx)((0, _contentInfoOptionsDefault.default), {
                        webhookCount: this.props.stateContainer.state.webhookUpdates?.webhookInstances?.length ?? this.props.stateContainer.state.attachedWebhooks?.length ?? 0,
                        options: this.getOptions(this.props.helpMessage != null),
                        optionSelected: this.handleContentItemOptionSelected.bind(this),
                        manageWebhooks: this.showWebhookInstanceManager.bind(this),
                        showSensitiveConversation: this.state.showSensitiveConversation,
                        toggleSensitiveConversation: ()=>{
                            this.toggleSensitiveConversation();
                        },
                        showDisabledForFeatures: this.state.showDisabledForFeatureFlags,
                        toggleDisabledForFeatures: ()=>{
                            this.toggleDisableForFeatureFlags();
                        },
                        flagsSelected: props.values.disabledForFeatureFlagIds?.length
                    })
                }, this.state.showSensitiveConversation && (0, _react.jsx)((0, _sensitiveDataOptionsDefault.default), {
                    selectedOption: props.values.sensitiveConversationChange ?? "None",
                    onChange: (value)=>{
                        props.setFieldValue("sensitiveConversationChange", value);
                    }
                }), this.state.showDisabledForFeatureFlags && (0, _react.jsx)((0, _disableForFeatureFlagOptionsDefault.default), {
                    appContainer: this.props.appContainer,
                    onChange: (value)=>{
                        props.setFieldValue("disabledForFeatureFlagIds", value);
                    },
                    selectedFeatureFlags: props.values.disabledForFeatureFlagIds
                }), (0, _react.jsx)((0, _contentSectionTitleDefault.default), {
                    title: "Help Message Conversation",
                    icon: (0, _extensions.getFeatureTypeIcon)((0, _featureTypeIds.HelpMessagesFeatureTypeId), true)
                }), (0, _react.jsx)((0, _titleTextFieldDefault.default), {
                    id: "contentTitle",
                    disabled: isDisabled,
                    name: "title",
                    placeholder: "For display only",
                    value: props.values.title,
                    label: "Title",
                    onChange: props.handleChange,
                    onBlur: props.handleBlur
                }), (0, _react.jsx)((0, _contentLanguageMultiSelectorDefault.default), {
                    id: "contentLanguage",
                    disabled: isDisabled,
                    label: "Language / Region",
                    languages: props.application.languages,
                    selectedLanguageIds: props.values.languages.map((l)=>l.id),
                    onChange: this.handleLanguagesChange.bind(this)
                }), this.renderOptions(false, isDisabled)), (0, _react.jsx)((0, _responsesManagerDefault.default), {
                    applicationId: this.props.application.id,
                    applicationFeatureId: this.props.applicationFeatureId,
                    languages: this.props.values.languages,
                    responseGroups: responseGroups,
                    showError: this.showError.bind(this),
                    getConditionsKey: (c)=>this.getConditionsKey(c),
                    isDisabled: isDisabled,
                    onChange: this.handleResponsesChange.bind(this),
                    onBlur: this.props.handleBlur,
                    emptyFollowUpOptionText: "Default - await further user input",
                    emptyFollowUpOptionIcon: continueIcon,
                    simulatedResponseId: simulatedResponseId,
                    responseIdToNamesRef: this.responseIdToNamesRef,
                    contentItemTitle: this.props.values.title
                }))), (0, _react.jsx)((0, _pageErrorDefault.default), {
                    errors: this.props?.stateContainer?.state?.errors ?? [],
                    onClear: this.handleClearError.bind(this)
                })),
            testCasesRender: ()=>(0, _react.jsx)((0, _contentItemTestCaseViewerDefault.default), {
                    application: this.props.application,
                    contentItemId: this.props.helpMessage?.id,
                    getResponseId: this.handleResponseIdFromSim,
                    responseIdToNamesRef: this.responseIdToNamesRef
                })
        })), this.renderRelinkSyncWarning(), this.renderWebhookInstanceManager(this.props.application.id, this.props.helpMessage?.id, (0, _featureTypeIds.HelpMessagesFeatureTypeId), this.props.values.webhookChainingType));
    }
}
exports.default = HelpMessageForm;

},{"@babel/runtime/helpers/defineProperty":"9sJxO","@emotion/react":"djZKr","react":"6uln9","../../components/structure/PageContainer":"hc1r8","../../components/forms/TitleTextField":"6fj1a","../followUpForm":"5HXc2","../../components/general/Loader":"bnV5T","../../constants/featureTypeIds":"hPLMP","../../components/forms/ContentLanguageMultiSelector":"4SbwP","../contentPage":"6VyMV","../relatedContentMenu":"aWiMy","../../components/structure/ScrollablePanelBody":"6LRg3","../contentPage/components/PanelTitle":"anVUR","../../components/structure/ContentCollapsingSection":"1CUms","../contentPage/components/ContentSectionTitle":"5RGHr","../../models/extensions":"7h01B","../../components/general/PageError":"ezFTm","./components/ConversationItemActionButtonToolbar":"TGPQ9","../../components/general/TemplateLockedBanner":"gMkKq","../../components/forms/ConversationItemFieldSet":"8a3oA","../../components/structure/ContentInfoOptions":"6Ozsc","../responsesManager":"jtCYo","./components/DirtyFormPrompt":"i9WDI","../contentPage/components/SensitiveDataOptions":"oXWpd","../contentPage/components/DisableForFeatureFlagOptions":"67JXM","./ContentItemTestCaseViewer":"6EkXj","b97d1f7a279f0974":"fKr4T","6adbf9112e93d73e":"d8BS5","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"d8BS5":[function(require,module,exports) {
module.exports = require("8962ed139404e857").getBundleURL("kVLro") + require("ab07a00507c32539").resolve("jbYMJ");

},{"8962ed139404e857":"c7Tr5","ab07a00507c32539":"fyJL2"}],"4ZcAE":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _queryString = require("query-string");
var _queryStringDefault = parcelHelpers.interopDefault(_queryString);
class NavigationBarFormPage extends (0, _reactDefault.default).Component {
    handleToggleNavigation() {
        localStorage.setItem("isNavigationBarOpen", "" + !this.state.isNavigationBarOpen);
        this.setState({
            ...this.state,
            isNavigationBarOpen: !this.state.isNavigationBarOpen
        });
    }
    getPreviousContentId() {
        const params = (0, _queryStringDefault.default)?.parse(this.props.location.search);
        if (!params || !params.previousContentId) return null;
        return params.previousContentId;
    }
    setSaving(isSaving) {
        this.setState({
            ...this.state,
            isSaving
        });
    }
}
exports.default = NavigationBarFormPage;

},{"react":"6uln9","query-string":"klvAV","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"akYlo":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _unstated = require("unstated");
var _helpMessageContainer = require("../../state/containers/HelpMessageContainer");
var _helpMessageContainerDefault = parcelHelpers.interopDefault(_helpMessageContainer);
var _editHelpMessageForm = require("./components/EditHelpMessageForm");
var _editHelpMessageFormDefault = parcelHelpers.interopDefault(_editHelpMessageForm);
var _applicationContainer = require("../../state/containers/ApplicationContainer");
var _applicationContainerDefault = parcelHelpers.interopDefault(_applicationContainer);
var _titleStateContainer = require("../../state/containers/TitleStateContainer");
var _titleStateContainerDefault = parcelHelpers.interopDefault(_titleStateContainer);
var _followUpContainer = require("../../state/containers/FollowUpContainer");
var _followUpContainerDefault = parcelHelpers.interopDefault(_followUpContainer);
var _repromptContainer = require("../../state/containers/RepromptContainer");
var _repromptContainerDefault = parcelHelpers.interopDefault(_repromptContainer);
var _mediaResponseContainer = require("../../state/containers/MediaResponseContainer");
var _mediaResponseContainerDefault = parcelHelpers.interopDefault(_mediaResponseContainer);
var _genericEditContentItemPage = require("../formScenes/GenericEditContentItemPage");
var _genericEditContentItemPageDefault = parcelHelpers.interopDefault(_genericEditContentItemPage);
var _featureContainer = require("../../state/containers/FeatureContainer");
var _featureContainerDefault = parcelHelpers.interopDefault(_featureContainer);
var _featureTypeIds = require("../../constants/featureTypeIds");
var _queryString = require("query-string");
var _queryStringDefault = parcelHelpers.interopDefault(_queryString);
var _applicationEnvironmentsContainer = require("../../state/containers/ApplicationEnvironmentsContainer");
var _applicationEnvironmentsContainerDefault = parcelHelpers.interopDefault(_applicationEnvironmentsContainer);
var _applicationBackupVersionsContainer = require("../../state/containers/ApplicationBackupVersionsContainer");
var _applicationBackupVersionsContainerDefault = parcelHelpers.interopDefault(_applicationBackupVersionsContainer);
class EditHelpMessage extends (0, _reactDefault.default).Component {
    render() {
        return (0, _react.jsx)((0, _unstated.Subscribe), {
            key: this.props.match.params.helpMessageId + this.props.match.params.applicationFeatureId,
            to: [
                (0, _helpMessageContainerDefault.default),
                (0, _applicationContainerDefault.default),
                (0, _titleStateContainerDefault.default),
                (0, _repromptContainerDefault.default),
                (0, _followUpContainerDefault.default),
                (0, _mediaResponseContainerDefault.default),
                (0, _featureContainerDefault.default),
                (0, _applicationEnvironmentsContainerDefault.default),
                (0, _applicationBackupVersionsContainerDefault.default)
            ]
        }, (helpContainer, appContainer, titleContainer, repromptContainer, followUpContainer, responseContainer, featureContainer, environmentsContainer, backupsContainer)=>{
            return (0, _react.jsx)((0, _genericEditContentItemPageDefault.default), {
                stateContainer: helpContainer,
                environmentsContainer: environmentsContainer,
                backupsContainer: backupsContainer,
                titleContainer: titleContainer,
                applicationContainer: appContainer,
                defaultTitle: "Edit Help Message",
                contentItemId: this.props.match.params.helpMessageId,
                history: this.props.history,
                location: this.props.location,
                match: this.props.match,
                staticContext: this.props.staticContext,
                featureContainer: featureContainer,
                featureTypeId: (0, _featureTypeIds.HelpMessagesFeatureTypeId),
                formRender: (contentItem, application, isTemplateOwned, assistantApplication, onShowPublishModal, onSubmit, toggleSync, onAccessTypeChange)=>(0, _react.jsx)((0, _editHelpMessageFormDefault.default), {
                        location: this.props.location,
                        application: application,
                        applicationFeatureId: this.props.match.params.applicationFeatureId,
                        helpMessage: contentItem,
                        stateContainer: helpContainer,
                        appContainer: appContainer,
                        followUpContainer: followUpContainer,
                        repromptContainer: repromptContainer,
                        responseStateContainer: responseContainer,
                        featureContainer: featureContainer,
                        assistantApplication: assistantApplication,
                        onShowPublishModal: onShowPublishModal,
                        onAccessTypeChange: onAccessTypeChange,
                        onSubmit: onSubmit,
                        onToggleSync: toggleSync,
                        previousContentId: (0, _queryStringDefault.default)?.parse(this.props.location.search)?.previousContentId,
                        history: this.props.history,
                        isSaving: helpContainer.state.isSaving,
                        isTemplateOwned: isTemplateOwned
                    })
            });
        });
    }
}
exports.default = EditHelpMessage;

},{"@emotion/react":"djZKr","react":"6uln9","unstated":"grh7p","../../state/containers/HelpMessageContainer":"2oQaX","./components/EditHelpMessageForm":"3ejkb","../../state/containers/ApplicationContainer":"cuqi2","../../state/containers/TitleStateContainer":"2osOD","../../state/containers/FollowUpContainer":"rm9OA","../../state/containers/RepromptContainer":"5vKMV","../../state/containers/MediaResponseContainer":"1ccrV","../formScenes/GenericEditContentItemPage":"6RzEJ","../../state/containers/FeatureContainer":"4ApGg","../../constants/featureTypeIds":"hPLMP","query-string":"klvAV","../../state/containers/ApplicationEnvironmentsContainer":"jCULY","../../state/containers/ApplicationBackupVersionsContainer":"6rA1P","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3ejkb":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _formik = require("formik");
var _yup = require("yup");
var _helpMessageForm = require("../../formScenes/HelpMessageForm");
var _helpMessageFormDefault = parcelHelpers.interopDefault(_helpMessageForm);
const EditHelpMessageForm = (0, _formik.withFormik)({
    mapPropsToValues: (props)=>({
            title: props.helpMessage.title,
            requiresParent: props.helpMessage.requiresParent,
            responses: props.helpMessage.responses.length > 0 ? props.helpMessage.responses : [
                {
                    content: ""
                }
            ],
            languages: props.helpMessage.languages,
            isLive: props.helpMessage.isLive,
            webhookChainingType: props.helpMessage.webhookChainingType,
            sensitiveConversationChange: props.helpMessage.sensitiveConversationChange ?? "None",
            disabledForFeatureFlagIds: props.helpMessage?.disabledForFeatureFlagIds
        }),
    validationSchema: _yup.object().shape({
        title: _yup.string().required("You must enter a title"),
        responses: _yup.array().of(_yup.object().shape({
            content: _yup.string().required("You must enter an response variation")
        })).required("You must enter at least 1 response variation").min(1, "You must enter at least 1 response variation")
    }),
    validateOnMount: true,
    handleSubmit: (values, { props, setStatus })=>{
        setStatus({
            submitting: true
        });
        return props.onSubmit(props.stateContainer.mapFormDataToModel(props.helpMessage, values));
    }
})((0, _helpMessageFormDefault.default));
exports.default = EditHelpMessageForm;

},{"formik":"3YnOK","yup":"j2SJU","../../formScenes/HelpMessageForm":"hiYsm","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"86aVV":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _unstated = require("unstated");
var _organizationDashboardContent = require("./components/OrganizationDashboardContent");
var _organizationDashboardContentDefault = parcelHelpers.interopDefault(_organizationDashboardContent);
var _organizationContainer = require("../../state/containers/OrganizationContainer");
var _organizationContainerDefault = parcelHelpers.interopDefault(_organizationContainer);
var _titleStateContainer = require("../../state/containers/TitleStateContainer");
var _titleStateContainerDefault = parcelHelpers.interopDefault(_titleStateContainer);
var _applicationContainer = require("../../state/containers/ApplicationContainer");
var _applicationContainerDefault = parcelHelpers.interopDefault(_applicationContainer);
class OrganizationDashboard extends (0, _reactDefault.default).Component {
    render() {
        return (0, _react.jsx)((0, _unstated.Subscribe), {
            to: [
                (0, _organizationContainerDefault.default),
                (0, _applicationContainerDefault.default),
                (0, _titleStateContainerDefault.default)
            ]
        }, (orgContainer, appContainer, titleContainer)=>(0, _react.jsx)((0, _organizationDashboardContentDefault.default), {
                history: this.props.history,
                orgsContainer: orgContainer,
                titleContainer: titleContainer,
                appContainer: appContainer
            }));
    }
}
exports.default = OrganizationDashboard;

},{"@emotion/react":"djZKr","react":"6uln9","unstated":"grh7p","./components/OrganizationDashboardContent":"amx9d","../../state/containers/OrganizationContainer":"dlbaM","../../state/containers/TitleStateContainer":"2osOD","../../state/containers/ApplicationContainer":"cuqi2","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"amx9d":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _reactTabs = require("react-tabs");
var _organizationApplications = require("../../organizationApplications");
var _organizationApplicationsDefault = parcelHelpers.interopDefault(_organizationApplications);
var _organizationMembers = require("../../organizationMembers");
var _organizationMembersDefault = parcelHelpers.interopDefault(_organizationMembers);
var _organizationSettings = require("../../organizationSettings");
var _organizationSettingsDefault = parcelHelpers.interopDefault(_organizationSettings);
var _fullPageTabbedPanel = require("../../../components/structure/Panels/FullPageTabbedPanel");
var _fullPageTabbedPanelDefault = parcelHelpers.interopDefault(_fullPageTabbedPanel);
var _logo = require("../../dashboardHeader/components/Logo");
var _logoDefault = parcelHelpers.interopDefault(_logo);
var _dashboardHeader = require("../../dashboardHeader");
var _dashboardHeaderDefault = parcelHelpers.interopDefault(_dashboardHeader);
var _profileMenu = require("../../profileMenu");
var _profileMenuDefault = parcelHelpers.interopDefault(_profileMenu);
var _applicationSelectorMenu = require("../../applicationSelectorMenu");
var _applicationSelectorMenuDefault = parcelHelpers.interopDefault(_applicationSelectorMenu);
var _headerSeparator = require("../../../components/structure/Panels/HeaderSeparator");
var _headerSeparatorDefault = parcelHelpers.interopDefault(_headerSeparator);
var _scrollablePanelBody = require("../../../components/structure/ScrollablePanelBody");
var _scrollablePanelBodyDefault = parcelHelpers.interopDefault(_scrollablePanelBody);
var _organizationTemplates = require("../../organizationTemplates");
var _organizationTemplatesDefault = parcelHelpers.interopDefault(_organizationTemplates);
var _organizationAnalytics = require("../../organizationAnalytics");
var _organizationAnalyticsDefault = parcelHelpers.interopDefault(_organizationAnalytics);
const appsIcon = require("ada4d439787b76eb");
const membersIcon = require("ab4d9ddf0a5e264a");
const settingsIcon = require("2acf8cfeda9f4fcb");
const builderIcon = require("437ae74fb4dc2a54");
const analyticsIcon = require("667db866e40457e2");
const membersTabName = "members";
const settingsTabName = "orgSettings";
const templatesTabName = "templates";
const modulesTabName = "modules";
const analyticsTabName = "orgAnalytics";
const OrganizationDashboardContent = (props)=>{
    (0, _react1.useEffect)(()=>{
        updateTitle();
    }, [
        location.href
    ]);
    const updateTitle = ()=>{
        props.titleContainer.setTitleView(props.orgsContainer.state.currentOrganization.name, null, null);
    };
    const handleTabSelection = (index, last)=>{
        if (index == last) return;
        const urlStart = "/v";
        const tabPaths = [
            "",
            // index 0: default ("/v")
            `/${membersTabName}`,
            // index 1: "/v/members"
            `/${modulesTabName}`,
            // index 2: "/v/modules"
            `/${analyticsTabName}`,
            // index 3: "/v/orgAnalytics"
            `/${settingsTabName}` // index 4: "/v/orgSettings"
        ];
        const newPath = urlStart + (tabPaths[index] || "");
        props.history.push(newPath);
    };
    const getSelectedIndex = ()=>{
        if (location.href.indexOf(membersTabName) > -1) return 1;
        if (location.href.indexOf(templatesTabName) > -1 || location.href.indexOf(modulesTabName) > -1) return 2;
        if (location.href.indexOf(analyticsTabName) > -1) return 3;
        if (location.href.indexOf(settingsTabName) > -1) return 4;
        return 0;
    };
    return (0, _react.jsx)((0, _fullPageTabbedPanelDefault.default), {
        tabs: [
            {
                title: "Apps",
                icon: appsIcon,
                selectedIcon: appsIcon,
                className: "ac-org-apps-tab"
            },
            {
                title: "Members",
                icon: membersIcon,
                selectedIcon: membersIcon,
                className: "ac-org-members-tab"
            },
            {
                title: "Module Builder",
                icon: builderIcon,
                selectedIcon: builderIcon,
                className: "ac-org-builder-tab"
            },
            {
                title: "Analytics",
                icon: analyticsIcon,
                selectedIcon: analyticsIcon,
                className: "ac-org-settings-tab"
            },
            {
                title: "Settings",
                icon: settingsIcon,
                selectedIcon: settingsIcon,
                className: "ac-org-settings-tab"
            }
        ],
        onTabSelected: handleTabSelection.bind(undefined),
        selectedIndex: getSelectedIndex(),
        leftRender: ()=>(0, _react.jsx)((0, _reactDefault.default).Fragment, null, (0, _react.jsx)((0, _logoDefault.default), {
                isFull: true,
                isInverse: true
            }), (0, _react.jsx)((0, _applicationSelectorMenuDefault.default), {
                organizationId: props.orgsContainer.state.currentOrganization?.id,
                application: null,
                appContainer: props.appContainer
            })),
        titleRender: ()=>(0, _react.jsx)((0, _dashboardHeaderDefault.default), null),
        rightRender: ()=>(0, _react.jsx)((0, _reactDefault.default).Fragment, null, (0, _react.jsx)((0, _headerSeparatorDefault.default), null), (0, _react.jsx)((0, _profileMenuDefault.default), null))
    }, (0, _react.jsx)((0, _reactTabs.TabPanel), null, (0, _react.jsx)((0, _scrollablePanelBodyDefault.default), null, (0, _react.jsx)((0, _organizationApplicationsDefault.default), null))), (0, _react.jsx)((0, _reactTabs.TabPanel), null, (0, _react.jsx)((0, _scrollablePanelBodyDefault.default), null, (0, _react.jsx)((0, _organizationMembersDefault.default), {
        history: props.history
    }))), (0, _react.jsx)((0, _reactTabs.TabPanel), null, (0, _react.jsx)((0, _organizationTemplatesDefault.default), {
        history: props.history
    })), (0, _react.jsx)((0, _reactTabs.TabPanel), null, (0, _react.jsx)((0, _organizationAnalyticsDefault.default), {
        history: props.history
    })), (0, _react.jsx)((0, _reactTabs.TabPanel), null, (0, _react.jsx)((0, _organizationSettingsDefault.default), {
        history: props.history
    })));
};
exports.default = OrganizationDashboardContent;

},{"@emotion/react":"djZKr","react":"6uln9","react-tabs":"92Sgf","../../organizationApplications":"bGrHS","../../organizationMembers":"aN1yJ","../../organizationSettings":"1XvZK","../../../components/structure/Panels/FullPageTabbedPanel":"72bEo","../../dashboardHeader/components/Logo":"8VQkf","../../dashboardHeader":"6RpIg","../../profileMenu":"irOVp","../../applicationSelectorMenu":"bMOSh","../../../components/structure/Panels/HeaderSeparator":"c2pZO","../../../components/structure/ScrollablePanelBody":"6LRg3","../../organizationTemplates":"5g98N","../../organizationAnalytics":"8hfqi","ada4d439787b76eb":"faw9Z","ab4d9ddf0a5e264a":"gWS0M","2acf8cfeda9f4fcb":"5Agu1","437ae74fb4dc2a54":"1d7sY","667db866e40457e2":"7VuKq","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"bGrHS":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _unstated = require("unstated");
var _applicationContainer = require("../../state/containers/ApplicationContainer");
var _applicationContainerDefault = parcelHelpers.interopDefault(_applicationContainer);
var _applicationListView = require("./components/ApplicationListView");
var _applicationListViewDefault = parcelHelpers.interopDefault(_applicationListView);
var _organizationContainer = require("../../state/containers/OrganizationContainer");
var _organizationContainerDefault = parcelHelpers.interopDefault(_organizationContainer);
var _subscriptionContainer = require("../../state/containers/SubscriptionContainer");
var _subscriptionContainerDefault = parcelHelpers.interopDefault(_subscriptionContainer);
var _webhookContainer = require("../../state/containers/WebhookContainer");
var _webhookContainerDefault = parcelHelpers.interopDefault(_webhookContainer);
var _memberContainer = require("../../state/containers/MemberContainer");
var _memberContainerDefault = parcelHelpers.interopDefault(_memberContainer);
var _userContainer = require("../../state/containers/UserContainer");
var _userContainerDefault = parcelHelpers.interopDefault(_userContainer);
const OrganizationApplications = ()=>(0, _react.jsx)((0, _unstated.Subscribe), {
        to: [
            (0, _applicationContainerDefault.default),
            (0, _organizationContainerDefault.default),
            (0, _subscriptionContainerDefault.default),
            (0, _webhookContainerDefault.default),
            (0, _memberContainerDefault.default),
            (0, _userContainerDefault.default)
        ]
    }, (appContainer, orgContainer, subContainer, webhookContainer, memberContainer, userContainer)=>{
        return (0, _react.jsx)((0, _applicationListViewDefault.default), {
            appsContainer: appContainer,
            orgContainer: orgContainer,
            webhookContainer: webhookContainer,
            subContainer: subContainer,
            userContainer: userContainer,
            memberContainer: memberContainer,
            organizationId: orgContainer.state.currentOrganization?.id
        });
    });
exports.default = OrganizationApplications;

},{"@emotion/react":"djZKr","react":"6uln9","unstated":"grh7p","../../state/containers/ApplicationContainer":"cuqi2","./components/ApplicationListView":"j6IwH","../../state/containers/OrganizationContainer":"dlbaM","../../state/containers/SubscriptionContainer":"4h6sJ","../../state/containers/WebhookContainer":"4VCcR","../../state/containers/MemberContainer":"iYQOb","../../state/containers/UserContainer":"jDrDR","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"j6IwH":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _loader = require("../../../components/general/Loader");
var _loaderDefault = parcelHelpers.interopDefault(_loader);
var _applicationCard = require("./ApplicationCard");
var _applicationCardDefault = parcelHelpers.interopDefault(_applicationCard);
var _roundedTwoOptionButton = require("../../../components/forms/RoundedTwoOptionButton");
var _roundedTwoOptionButtonDefault = parcelHelpers.interopDefault(_roundedTwoOptionButton);
var _numberIncrementSelector = require("../../../components/forms/NumberIncrementSelector");
var _numberIncrementSelectorDefault = parcelHelpers.interopDefault(_numberIncrementSelector);
var _colors = require("../../../constants/colors");
var _searchField = require("../../../components/forms/SearchField");
var _searchFieldDefault = parcelHelpers.interopDefault(_searchField);
var _verticalSeparator = require("../../../components/structure/VerticalSeparator");
var _verticalSeparatorDefault = parcelHelpers.interopDefault(_verticalSeparator);
var _button = require("../../../components/general/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _reactRouterDom = require("react-router-dom");
var _applicationTableItem = require("./ApplicationTableItem");
var _applicationTableItemDefault = parcelHelpers.interopDefault(_applicationTableItem);
var _tooltipWrapper = require("../../../components/general/TooltipWrapper");
var _tooltipWrapperDefault = parcelHelpers.interopDefault(_tooltipWrapper);
var _flatRoundedSelectField = require("../../../components/forms/FlatRoundedSelectField");
var _flatRoundedSelectFieldDefault = parcelHelpers.interopDefault(_flatRoundedSelectField);
var _horizontalContainer = require("../../../components/structure/HorizontalContainer");
var _horizontalContainerDefault = parcelHelpers.interopDefault(_horizontalContainer);
var _confirmationDialog = require("../../../components/structure/ConfirmationDialog");
var _confirmationDialogDefault = parcelHelpers.interopDefault(_confirmationDialog);
var _deleteConfirmation = require("../../featureContent/components/DeleteConfirmation");
var _deleteConfirmationDefault = parcelHelpers.interopDefault(_deleteConfirmation);
var _webhookInstanceManager = require("../../webhookInstanceManager");
var _webhookInstanceManagerDefault = parcelHelpers.interopDefault(_webhookInstanceManager);
var _telephonyDeploymentContainer = require("../../../hooks/TelephonyDeploymentContainer");
var _telephonyDeploymentContainerDefault = parcelHelpers.interopDefault(_telephonyDeploymentContainer);
var _emptyView = require("../../applicationModules/components/EmptyView");
var _emptyViewDefault = parcelHelpers.interopDefault(_emptyView);
var _breakpoints = require("../../../../shared/constants/breakpoints");
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const addIcon = require("5393119f1cb098c9");
const WAIT_INTERVAL = 500;
const ENTER_KEY = 13;
const ApplicationListView = (props)=>{
    const [view, setView] = (0, _react1.useState)(props.appsContainer.state.applicationListPreferences?.view);
    const [page, setPage] = (0, _react1.useState)(1);
    const [take, setTake] = (0, _react1.useState)(props.appsContainer.state.applicationListPreferences?.take);
    const [search, setSearch] = (0, _react1.useState)("");
    const [sortBy, setSortBy] = (0, _react1.useState)(props.appsContainer.state.applicationListPreferences?.sortBy);
    const [deleteApplicationId, setDeleteApplicationId] = (0, _react1.useState)();
    const [webhookInstanceApplicationId, setWebhookInstanceApplicationId] = (0, _react1.useState)();
    const telephonyDeploymentContainer = (0, _telephonyDeploymentContainerDefault.default).useContainer();
    const timerRef = (0, _reactDefault.default).useRef(null);
    const reloadApps = ()=>{
        const promise = props.appsContainer.searchForOrgApplications(props.organizationId, page, take, sortBy, search);
        promise.then((result)=>{
            let apps = result.data.applications ?? [];
            let appIds = apps.map((a)=>a.id);
            props.appsContainer.getFolderAndItemCountsForApplications(props.organizationId, appIds);
        });
    };
    (0, _react1.useEffect)(()=>{
        const fetchData = async ()=>{
            if (!props.userContainer.state.currentUser) await props.userContainer.getUser();
            await props.memberContainer.checkIsOrgAdmin(props.organizationId, props.userContainer.state.currentUser?.id);
            props.subContainer.loadSubscription(props.organizationId);
        };
        fetchData();
    }, []);
    (0, _react1.useEffect)(()=>{
        reloadApps();
    }, [
        page,
        take,
        sortBy,
        search
    ]);
    const onOptionSelect = async (appId, option)=>{
        if (option === "Delete") setDeleteApplicationId(appId);
        else if (option === "Webhooks") setWebhookInstanceApplicationId(appId);
    };
    const closeModals = ()=>{
        setDeleteApplicationId(null);
        setWebhookInstanceApplicationId(null);
    };
    const deleteApplication = async ()=>{
        if (deleteApplicationId !== null) {
            const telephonyResponse = await telephonyDeploymentContainer.getTelephonyDeployments(deleteApplicationId);
            if (telephonyResponse.data) {
                const telephonyDeploymentsToDelete = telephonyResponse?.data?.filter((telephonyDeployment)=>telephonyDeployment.applicationId === deleteApplicationId);
                if (telephonyDeploymentsToDelete.length > 0) for (const telephonyDeployment of telephonyDeploymentsToDelete)await telephonyDeploymentContainer.deleteTelephonyDeployment(deleteApplicationId, telephonyDeployment.phoneNumber);
            }
            await props.appsContainer.disableApplication(deleteApplicationId);
            reloadApps();
            closeModals();
        }
    };
    const renderApplicationCards = (apps)=>{
        return apps.length === 0 ? (0, _react.jsx)((0, _emptyViewDefault.default), {
            imageStyle: emptyViewImageStyle,
            title: "It's quiet in here!",
            description: ""
        }) : (0, _react.jsx)("div", {
            className: appCardContainer
        }, apps.map((app)=>(0, _react.jsx)((0, _applicationCardDefault.default), {
                onOptionSelect: onOptionSelect,
                key: app.id,
                app: app,
                counts: props.appsContainer.getFolderAndItemCount(app.id)
            })));
    };
    const renderApplicationTable = (apps)=>{
        return apps.length === 0 ? (0, _react.jsx)((0, _emptyViewDefault.default), {
            imageStyle: emptyViewImageStyle,
            title: "It's quiet in here!",
            description: ""
        }) : (0, _react.jsx)("div", {
            className: appTableContainer
        }, (0, _react.jsx)("div", {
            className: "top-row"
        }, (0, _react.jsx)("div", {
            className: "apps"
        }, "APPS"), (0, _react.jsx)("div", {
            className: "content"
        }, "CONTENT"), (0, _react.jsx)("div", {
            className: "participants"
        }, "PARTICIPANTS")), apps.map((app)=>(0, _react.jsx)((0, _applicationTableItemDefault.default), {
                onOptionSelect: onOptionSelect,
                key: app.id,
                app: app,
                counts: props.appsContainer.getFolderAndItemCount(app.id)
            })));
    };
    const incrementPage = ()=>{
        const total = props.appsContainer.state.applicationsCount;
        const nextAppToLoadIndex = page * take + 1;
        if (nextAppToLoadIndex <= total) setPage((prevPage)=>prevPage + 1);
    };
    const decrementPage = ()=>{
        if (page !== 1) setPage((prevPage)=>prevPage - 1);
    };
    const toggleView = ()=>{
        const newView = view === "card" ? "table" : "card";
        setView(newView);
        props.appsContainer.updateApplicationListPreferences({
            take,
            sortBy,
            view: newView
        });
    };
    const handleSortByChange = (o)=>{
        const sortByString = o.value.toString();
        props.appsContainer.updateApplicationListPreferences({
            take,
            sortBy: sortByString,
            view
        });
        setSortBy(sortByString);
        setPage(1);
    };
    const handleTakeChange = (o)=>{
        const takeString = o.value.toString();
        const takeNum = parseInt(takeString);
        props.appsContainer.updateApplicationListPreferences({
            take: takeNum,
            sortBy,
            view
        });
        setTake(takeNum);
        setPage(1);
    };
    const handleSearch = (searchEvent)=>{
        clearTimeout(timerRef.current);
        setSearch(searchEvent.target.value);
        setPage(1);
        timerRef.current = setTimeout(reloadApps, WAIT_INTERVAL);
    };
    const handleSearchKeyDown = (e)=>{
        if (e.key === "Enter") reloadApps();
    };
    const renderAddNewButtion = (addNewDisabled)=>{
        return (0, _react.jsx)((0, _reactRouterDom.Link), {
            to: "/v/create-app",
            onClick: (e)=>{
                if (addNewDisabled) e.preventDefault();
            },
            "aria-disabled": addNewDisabled
        }, (0, _react.jsx)((0, _buttonDefault.default), {
            text: "Add New",
            themes: [
                "primary-small"
            ],
            rightIcon: addIcon,
            className: "add-new-button ac-create-app-button",
            disabled: addNewDisabled
        }));
    };
    const applications = props.appsContainer.state.orgApplicationsList ?? [];
    const applicationToDelete = applications.find((a)=>a.id === deleteApplicationId);
    const subsLoading = props.subContainer.state.subscription?.subscriptionType?.maxSandboxes == null || props.appsContainer.state?.orgApplicationsList == null;
    let appsCount = 0;
    let maxApps = 1;
    if (!subsLoading) {
        appsCount = props.appsContainer.state.applicationsCount;
        maxApps = Math.max(props.subContainer.state.subscription.subscriptionType.maxApps, props.subContainer.state.subscription.subscriptionType.maxSandboxes);
    }
    const addNewDisabled = appsCount >= maxApps || !props.memberContainer.state.isOrgAdmin;
    const maxAppsString = maxApps > 100000 ? "∞" : `${maxApps}`;
    const tooltipText = appsCount >= maxApps ? `Your current license allows for the\ncreation of ${maxAppsString} app${appsCount > 1 ? "s" : ""}. To increase this number, please have\nan org admin contact sales@voicify.com` : "You do not have permission to add a new app";
    return (0, _react.jsx)((0, _reactDefault.default).Fragment, null, (0, _react.jsx)((0, _horizontalContainerDefault.default), {
        className: searchAndModify
    }, (0, _react.jsx)((0, _searchFieldDefault.default), {
        id: "1",
        name: "searchField",
        placeholder: "Search",
        disabled: false,
        onChange: handleSearch,
        onKeyDown: handleSearchKeyDown,
        className: searchField
    }), (0, _react.jsx)("div", {
        className: "table-grid"
    }, (0, _react.jsx)((0, _roundedTwoOptionButtonDefault.default), {
        updateViewValue: toggleView,
        selectedOption: view === "table"
    })), (0, _react.jsx)((0, _verticalSeparatorDefault.default), {
        className: "separator"
    }), (0, _react.jsx)("div", {
        className: "app-count"
    }, subsLoading ? "-" : `${appsCount} of ${maxAppsString}`), (0, _react.jsx)("div", {
        className: "apps-name"
    }, "Apps"), addNewDisabled ? (0, _react.jsx)((0, _tooltipWrapperDefault.default), {
        text: tooltipText,
        className: toolTipStyle,
        place: "bottomRight"
    }, renderAddNewButtion(addNewDisabled)) : renderAddNewButtion(addNewDisabled)), (0, _react.jsx)((0, _horizontalContainerDefault.default), {
        className: pageAndSort
    }, (0, _react.jsx)((0, _flatRoundedSelectFieldDefault.default), {
        options: [
            {
                label: "Name - Alphabetical",
                value: "NameAscending"
            },
            {
                label: "Name - Reverse Alphabetical",
                value: "NameDescending"
            },
            {
                label: "Created Date - Oldest First",
                value: "CreatedDateAscending"
            },
            {
                label: "Created Date - Latest First",
                value: "CreatedDateDescending"
            }
        ],
        onChange: handleSortByChange,
        value: sortBy,
        label: "Arrange by",
        className: arrangeBy
    }), (0, _react.jsx)((0, _flatRoundedSelectFieldDefault.default), {
        options: [
            {
                label: "10",
                value: "10"
            },
            {
                label: "25",
                value: "25"
            },
            {
                label: "50",
                value: "50"
            }
        ],
        onChange: handleTakeChange,
        value: `${take}`,
        label: "Display at once",
        className: takeStyle
    }), (0, _react.jsx)("div", {
        className: pageContainer
    }, (0, _react.jsx)("div", {
        className: leftSideLabel
    }, "Page"), (0, _react.jsx)((0, _numberIncrementSelectorDefault.default), {
        useShadow: false,
        selectedNumber: `${page}`,
        updateValue: (b)=>b ? incrementPage() : decrementPage(),
        showNumber: true
    }))), props.appsContainer.state.isLoadingApps ? (0, _react.jsx)((0, _loaderDefault.default), null) : view === "card" ? renderApplicationCards(applications) : renderApplicationTable(applications), deleteApplicationId != null && (0, _react.jsx)((0, _confirmationDialogDefault.default), {
        title: `Delete Application`,
        deleteText: "Yes, Delete",
        isLoading: props.appsContainer.state.isLoadingApps,
        onClose: closeModals,
        onConfirm: deleteApplication
    }, (0, _react.jsx)((0, _deleteConfirmationDefault.default), {
        itemLabel: `${applicationToDelete?.name}?`
    })), (0, _react.jsx)((0, _webhookInstanceManagerDefault.default), {
        show: webhookInstanceApplicationId != null,
        webhookContainerId: webhookInstanceApplicationId,
        applicationId: webhookInstanceApplicationId,
        webhookInstanceScope: "Application",
        onClose: closeModals,
        onFinish: (webhookInstances)=>{
            props.appsContainer.updateWebhookInstancesForApplication(webhookInstanceApplicationId, webhookInstances);
        }
    }));
};
const searchAndModify = /*#__PURE__*/ (0, _css.css)("margin:12px 0 12px 32px;div{box-shadow:none;}.number-container{box-shadow:none;}.field-container{height:32px;border-radius:16px;margin-top:0px;}.table-grid{margin:0px 16px;}.app-count{height:32px;font-style:normal;font-weight:normal;font-size:14px;line-height:20px;color:", (0, _colors.color_shades_darkest), ";text-align:center;background-color:", (0, _colors.color_shades_lighter), ";padding:4px 16px;border-radius:16px;padding-top:6px;}.apps-name{font-size:14px;line-height:20px;height:32px;font-style:normal;font-weight:normal;margin-left:0px;padding:6px 16px 4px 8px;}.add-new-button{margin:0px;margin-right:32px;}.separator{margin-right:16px;height:32px;}", "");
const leftSideLabel = /*#__PURE__*/ (0, _css.css)("font-family:Muli;font-style:normal;font-weight:normal;font-size:12px;line-height:16px;color:", (0, _colors.color_shades_darkest), ";margin-right:16px;margin-top:8px;", "");
const searchField = /*#__PURE__*/ (0, _css.css)({
    name: "1tlmwo2",
    styles: "margin-bottom:0px"
});
const toolTipStyle = /*#__PURE__*/ (0, _css.css)({
    name: "1e92m3l",
    styles: "max-width:240px;right:32px;left:initial!important;span{text-align:center;display:block;padding:0px 8px;}"
});
const pageAndSort = /*#__PURE__*/ (0, _css.css)("border-bottom:1px solid ", (0, _colors.color_shades_dark), ";border-top:1px solid ", (0, _colors.color_shades_dark), ";", "");
const pageContainer = /*#__PURE__*/ (0, _css.css)({
    name: "1a9xpvx",
    styles: "display:flex;flex-direction:row;margin:12px 32px 0px 0px"
});
const arrangeBy = /*#__PURE__*/ (0, _css.css)({
    name: "8gcf24",
    styles: "margin:12px auto 12px 32px;.Select{width:240px;}"
});
const takeStyle = /*#__PURE__*/ (0, _css.css)({
    name: "xpb9ru",
    styles: "margin:12px 32px 12px 0px;.Select{width:80px;}"
});
const appCardContainer = /*#__PURE__*/ (0, _css.css)({
    name: "g2kigj",
    styles: "display:grid;width:100%;padding-right:32px;grid-template-columns:repeat(auto-fill, minmax(260px, 1fr))"
});
const appTableContainer = /*#__PURE__*/ (0, _css.css)("display:flex;flex-direction:column;width:100%;.top-row{display:flex;flex-direction:row;border-bottom:solid 1px ", (0, _colors.color_shades_dark), ";height:40px;padding-left:32px;padding-right:32px;div{margin-top:auto;margin-bottom:auto;font-style:normal;font-weight:normal;font-size:14px;line-height:16px;letter-spacing:0.1em;text-transform:uppercase;color:", (0, _colors.color_shades_darker), ";}.apps{width:50%;}.content{width:30%;}.participants{width:20%;margin-left:-8px;}}", "");
const emptyViewImageStyle = /*#__PURE__*/ (0, _css.css)((0, _breakpoints.breakpoint_small), "{height:350px;width:350px;}", "");
exports.default = ApplicationListView;

},{"@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","../../../components/general/Loader":"bnV5T","./ApplicationCard":"gLtc4","../../../components/forms/RoundedTwoOptionButton":"7kmUj","../../../components/forms/NumberIncrementSelector":"kU0zB","../../../constants/colors":"1p3OR","../../../components/forms/SearchField":"aU10T","../../../components/structure/VerticalSeparator":"aNNRC","../../../components/general/Button":"6ymxN","react-router-dom":"5fzqq","./ApplicationTableItem":"9oFux","../../../components/general/TooltipWrapper":"53pWd","../../../components/forms/FlatRoundedSelectField":"73UnY","../../../components/structure/HorizontalContainer":"eJPfh","../../../components/structure/ConfirmationDialog":"kx7yK","../../featureContent/components/DeleteConfirmation":"9xK2d","../../webhookInstanceManager":"1EIek","../../../hooks/TelephonyDeploymentContainer":"2qU7b","../../applicationModules/components/EmptyView":"ffYYa","../../../../shared/constants/breakpoints":"2F01A","5393119f1cb098c9":"i0YpA","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"gLtc4":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _colors = require("../../../constants/colors");
var _horizontalContainer = require("../../../components/structure/HorizontalContainer");
var _horizontalContainerDefault = parcelHelpers.interopDefault(_horizontalContainer);
var _horizontalSeparator = require("../../../components/structure/HorizontalSeparator");
var _horizontalSeparatorDefault = parcelHelpers.interopDefault(_horizontalSeparator);
var _reactRouterDom = require("react-router-dom");
var _applicationAvatar = require("../../../components/general/ApplicationAvatar");
var _applicationAvatarDefault = parcelHelpers.interopDefault(_applicationAvatar);
var _iconCollectionAvatar = require("../../../components/general/IconCollectionAvatar");
var _iconCollectionAvatarDefault = parcelHelpers.interopDefault(_iconCollectionAvatar);
var _smallOverflowMenu = require("../../../components/general/overflowMenu/SmallOverflowMenu");
var _smallOverflowMenuDefault = parcelHelpers.interopDefault(_smallOverflowMenu);
var _tooltipWrapper = require("../../../components/general/TooltipWrapper");
var _tooltipWrapperDefault = parcelHelpers.interopDefault(_tooltipWrapper);
var _webhookCountTag = require("../../../components/general/WebhookCountTag");
var _webhookCountTagDefault = parcelHelpers.interopDefault(_webhookCountTag);
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const folderIcon = require("6ae92a242e7f8535");
const contentItemIcon = require("84a95933cdfc3153");
const deleteIcon = require("2c8228cb2d8cb1e");
const webhookIcon = require("ddb11db631adf80a");
const ApplicationCard = (props)=>(0, _react.jsx)("div", {
        className: `${cardStyle} ac-app-list-item`
    }, (0, _react.jsx)((0, _reactRouterDom.Link), {
        to: `/v/apps/${props.app.id}`
    }, (0, _react.jsx)((0, _applicationAvatarDefault.default), {
        className: "app-icon",
        app: props.app,
        size: 56
    })), (0, _react.jsx)((0, _reactRouterDom.Link), {
        to: `/v/apps/${props.app.id}`,
        className: `app-name ${props.app.allowsTemplating ? "basis-app" : ""}`
    }, `${props.app.allowsTemplating ? "⬥ " : ""}${props.app.name}`), (0, _react.jsx)((0, _horizontalSeparatorDefault.default), null), (0, _react.jsx)((0, _horizontalContainerDefault.default), {
        className: "counts"
    }, (0, _react.jsx)((0, _tooltipWrapperDefault.default), {
        text: `${props.counts == null ? "-" : props.counts.applicationFeatureCount} Folders`
    }, (0, _react.jsx)("div", {
        className: "count-container"
    }, (0, _react.jsx)("img", {
        src: folderIcon
    }), (0, _react.jsx)("div", null, props.counts == null ? "-" : props.counts.applicationFeatureCount))), (0, _react.jsx)((0, _tooltipWrapperDefault.default), {
        text: `${props.counts == null ? "-" : props.counts.conversationCount} Conversation Items`
    }, (0, _react.jsx)("div", {
        className: "count-container"
    }, (0, _react.jsx)("img", {
        src: contentItemIcon
    }), (0, _react.jsx)("div", null, props.counts == null ? "-" : props.counts.conversationCount)))), (0, _react.jsx)((0, _iconCollectionAvatarDefault.default), {
        className: userAvatars,
        items: props.app.members?.filter((a)=>a.organizationMember.isApiUser == false)?.map((a)=>{
            var collectionItem;
            collectionItem = {
                noImageText: `${a.organizationMember.firstName == null ? "N" : a.organizationMember.firstName[0]} ${a.organizationMember.lastName == null ? "A" : a.organizationMember.lastName[0]}`,
                tooltipText: `${a.organizationMember.firstName == null ? "N" : a.organizationMember.firstName[0]} ${a.organizationMember.lastName == null ? "A" : a.organizationMember.lastName[0]}`,
                imageUrl: a.organizationMember.imageUrl
            };
            return collectionItem;
        }),
        limit: 4
    }), (0, _react.jsx)((0, _smallOverflowMenuDefault.default), {
        className: `${overflowStyle} ac-app-list-item-overflow`,
        buttonClassName: overflowMenuButtonStyle,
        optionClassName: overflowOptionStyle,
        menuClassName: overflowMenuStyle,
        isActive: false,
        onOptionSelected: (option)=>props.onOptionSelect(props.app.id, option),
        options: [
            {
                label: "Webhooks",
                icon: webhookIcon,
                hoverIcon: webhookIcon
            },
            {
                label: "Delete",
                icon: deleteIcon,
                hoverIcon: deleteIcon,
                isDestructive: true
            }
        ]
    }), props.app?.webhookInstances?.length > 0 && (0, _react.jsx)((0, _webhookCountTagDefault.default), {
        onClick: ()=>props.onOptionSelect(props.app.id, "Webhooks"),
        className: webhookCountStyle,
        count: props.app.webhookInstances?.length ?? 0
    }));
const userAvatars = /*#__PURE__*/ (0, _css.css)({
    name: "f7ay7b",
    styles: "justify-content:center"
});
const overflowMenuStyle = /*#__PURE__*/ (0, _css.css)({
    name: "1ct4kew",
    styles: "width:130px;margin-left:0px;right:-11px;z-index:2"
});
const overflowStyle = /*#__PURE__*/ (0, _css.css)({
    name: "kmthlo",
    styles: "position:absolute;top:8px;right:8px"
});
const webhookCountStyle = /*#__PURE__*/ (0, _css.css)({
    name: "t5qbdk",
    styles: "position:absolute;top:8px;left:8px"
});
const overflowOptionStyle = /*#__PURE__*/ (0, _css.css)({
    name: "1aynex2",
    styles: "height:32px;font-style:normal;font-weight:normal;font-size:12px;line-height:16px;width:130px"
});
const overflowMenuButtonStyle = /*#__PURE__*/ (0, _css.css)("border-radius:4px;width:24px;height:24px;border-color:", (0, _colors.color_shades_darker), ";.circle{width:4px;height:4px;border-color:", (0, _colors.color_shades_darker), ";}", "");
const cardStyle = /*#__PURE__*/ (0, _css.css)("border-radius:8px;background-color:white;border:solid 1px ", (0, _colors.silver_four), ";margin:48px 0px 48px 32px;position:relative;padding:16px;position:relative;display:flex;flex-direction:column;.app-icon{top:-28px;left:calc(50% - 28px);position:absolute;box-shadow:none;}.app-name{font-style:normal;font-stretch:normal;line-height:24px;letter-spacing:normal;color:", (0, _colors.color_shades_darkest), ";font-family:Muli;justify-content:center;font-size:18px;margin:32px auto 8px auto;text-align:center;flex-grow:1;&.basis-app{color:", (0, _colors.color_colors_royalty), ";}}.counts{font-family:Muli;font-style:normal;font-weight:normal;font-size:12px;line-height:16px;color:", (0, _colors.color_shades_darker), ";margin:8px 0px;justify-content:center;img{margin-right:4px;margin-bottom:3px;}.count-container{display:flex;align-items:center;}}", "");
exports.default = ApplicationCard;

},{"@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","../../../constants/colors":"1p3OR","../../../components/structure/HorizontalContainer":"eJPfh","../../../components/structure/HorizontalSeparator":"Pw3HQ","react-router-dom":"5fzqq","../../../components/general/ApplicationAvatar":"aA2GK","../../../components/general/IconCollectionAvatar":"j0zcR","../../../components/general/overflowMenu/SmallOverflowMenu":"YJYcI","../../../components/general/TooltipWrapper":"53pWd","../../../components/general/WebhookCountTag":"94GuX","6ae92a242e7f8535":"1ZV9Z","84a95933cdfc3153":"aLhIm","2c8228cb2d8cb1e":"24JPN","ddb11db631adf80a":"e6PIG","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"aA2GK":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _colors = require("../../constants/colors");
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const iconStyle = /*#__PURE__*/ (0, _css.css)({
    name: "gff4s3",
    styles: "border-radius:50%;background:white;width:100%;height:100%;box-sizing:border-box"
});
const containerStyle = /*#__PURE__*/ (0, _css.css)("border-radius:50%;box-shadow:0 2px 4px 0 ", (0, _colors.dark_grey_blue_10), ";border:solid 1px ", (0, _colors.silver_four), ";background:white;display:flex;align-items:center;justify-content:center;box-sizing:border-box;", "");
const nameStyle = /*#__PURE__*/ (0, _css.css)("border-radius:50%;background:white;font-family:Muli;font-size:18px;font-weight:600;font-style:normal;font-stretch:normal;line-height:normal;letter-spacing:-1px;text-align:center;width:100%;height:100%;display:flex;align-items:center;justify-content:center;color:", (0, _colors.color_text_default), ";", "");
const ApplicationAvatar = (props)=>(0, _react.jsx)("div", {
        className: `${containerStyle}  ${props.className !== undefined ? props.className : ""}`,
        style: {
            width: props.size,
            height: props.size,
            minWidth: props.size,
            minHeight: props.size
        }
    }, props.app?.imageUrl !== undefined ? (0, _react.jsx)("img", {
        className: `${iconStyle}`,
        src: props.app?.imageUrl
    }) : (0, _react.jsx)("div", {
        className: nameStyle
    }, (0, _react.jsx)("span", null, props.app?.name[0])));
exports.default = ApplicationAvatar;

},{"@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","../../constants/colors":"1p3OR","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"j0zcR":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _tooltipWrapper = require("./TooltipWrapper");
var _tooltipWrapperDefault = parcelHelpers.interopDefault(_tooltipWrapper);
var _colors = require("../../constants/colors");
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const IconCollectionAvatar = (props)=>(0, _react.jsx)("div", {
        className: containerStyle + (props.className ? ` ${props.className}` : "")
    }, props.items?.slice(0, props.limit).map((i, idx)=>(0, _react.jsx)((0, _tooltipWrapperDefault.default), {
            text: i.tooltipText,
            className: toolTip,
            key: idx
        }, (0, _react.jsx)("div", {
            key: idx,
            className: `item ${props.items.length == 1 ? `single` : ``}`
        }, (0, _react.jsx)("div", {
            className: "inner-app"
        }, i.imageUrl == null ? (0, _react.jsx)("p", null, i.noImageText) : (0, _react.jsx)("img", {
            src: i.imageUrl
        }))))), props.items?.length === props.limit + 1 ? (0, _react.jsx)((0, _tooltipWrapperDefault.default), {
        text: props.items.slice(props.limit).map((l)=>l.tooltipText).join(", "),
        className: toolTip
    }, (0, _react.jsx)("div", {
        className: `item ${props.items.length == 1 ? `single` : ``}`
    }, (0, _react.jsx)("div", {
        className: "inner-app"
    }, props.items[props.limit].imageUrl == null ? (0, _react.jsx)("p", null, props.items[props.limit].noImageText) : (0, _react.jsx)("img", {
        src: props.items[props.limit].imageUrl
    })))) : null, props.items?.slice(props.limit).length > 1 ? (0, _react.jsx)((0, _tooltipWrapperDefault.default), {
        text: props.items.slice(props.limit).map((l)=>l.tooltipText).join(", "),
        className: toolTip
    }, (0, _react.jsx)("div", {
        className: `item ${props.items.length == 1 ? `single` : ``}`
    }, (0, _react.jsx)("div", {
        className: "inner-app overflow-icon"
    }, (0, _react.jsx)("p", null, "+", props.items.slice(props.limit).length)))) : null);
const containerStyle = /*#__PURE__*/ (0, _css.css)("display:flex;margin-left:12px;.inner-app{border-radius:50%;display:flex;align-items:center;justify-content:center;border:2px solid white;&.overflow-icon{margin:2px;color:", (0, _colors.color_shades_darkest), ";font-size:12;}img,p{height:24px;width:24px;border:1px solid ", (0, _colors.cool_grey), ";border-radius:50%;}p{font-size:8px;font-weight:600;font-style:normal;font-stretch:normal;line-height:normal;letter-spacing:-1px;text-align:center;width:24px;height:24px;display:flex;align-items:center;color:", (0, _colors.color_text_default), ";background:", (0, _colors.color_highlights_blue), ";justify-content:center;box-sizing:border-box;}}.item{padding:1px;width:24px;height:24px;max-height:24px;max-width:24px;border-radius:50%;margin-left:-12px;z-index:0;background:white;display:flex;align-items:center;justify-content:center;border:2px solid #ffffff;&:hover{z-index:1;}}", "");
const toolTip = /*#__PURE__*/ (0, _css.css)({
    name: "hrices",
    styles: ".rc-tooltip-inner{max-width:200px;}"
});
exports.default = IconCollectionAvatar;

},{"@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","./TooltipWrapper":"53pWd","../../constants/colors":"1p3OR","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1ZV9Z":[function(require,module,exports) {
module.exports = require("4de8bb3bc92600ef").getBundleURL("kVLro") + require("e25a61356b8fbf1e").resolve("1iAIC");

},{"4de8bb3bc92600ef":"c7Tr5","e25a61356b8fbf1e":"fyJL2"}],"aLhIm":[function(require,module,exports) {
module.exports = require("34fd050689a65e13").getBundleURL("kVLro") + require("efe78790745e5a76").resolve("hDTn2");

},{"34fd050689a65e13":"c7Tr5","efe78790745e5a76":"fyJL2"}],"24JPN":[function(require,module,exports) {
module.exports = require("845c48183a88303a").getBundleURL("kVLro") + require("7bc1cd7d22f59dd5").resolve("27y5H");

},{"845c48183a88303a":"c7Tr5","7bc1cd7d22f59dd5":"fyJL2"}],"9oFux":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _colors = require("../../../constants/colors");
var _horizontalContainer = require("../../../components/structure/HorizontalContainer");
var _horizontalContainerDefault = parcelHelpers.interopDefault(_horizontalContainer);
var _applicationAvatar = require("../../../components/general/ApplicationAvatar");
var _applicationAvatarDefault = parcelHelpers.interopDefault(_applicationAvatar);
var _reactRouterDom = require("react-router-dom");
var _iconCollectionAvatar = require("../../../components/general/IconCollectionAvatar");
var _iconCollectionAvatarDefault = parcelHelpers.interopDefault(_iconCollectionAvatar);
var _smallOverflowMenu = require("../../../components/general/overflowMenu/SmallOverflowMenu");
var _smallOverflowMenuDefault = parcelHelpers.interopDefault(_smallOverflowMenu);
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const folderIcon = require("f7e19b7ce319002a");
const contentItemIcon = require("1762ac7f83d9be6a");
const deleteIcon = require("d68a7ad0b5b1a100");
const webhookIcon = require("fc9d5e2562d808bf");
const ApplicationTableItem = (props)=>(0, _react.jsx)("div", {
        className: `${containerStyle} ac-app-list-item`
    }, (0, _react.jsx)((0, _reactRouterDom.Link), {
        to: `/v/apps/${props.app.id}`,
        className: nameAndIcon
    }, (0, _react.jsx)((0, _applicationAvatarDefault.default), {
        app: props.app,
        size: 42
    }), (0, _react.jsx)("div", {
        className: `${appNameStyle} ${props.app.allowsTemplating ? "basis-app" : ""}`
    }, `${props.app.allowsTemplating ? "⬥ " : ""}${props.app.name}`)), (0, _react.jsx)((0, _horizontalContainerDefault.default), {
        className: "counts"
    }, (0, _react.jsx)("img", {
        className: "folder",
        src: folderIcon
    }), (0, _react.jsx)("div", null, props.counts == null ? "-" : props.counts.applicationFeatureCount), (0, _react.jsx)("img", {
        className: "content",
        src: contentItemIcon
    }), (0, _react.jsx)("div", null, props.counts == null ? "-" : props.counts.conversationCount)), (0, _react.jsx)((0, _iconCollectionAvatarDefault.default), {
        className: "users",
        items: props.app.members?.filter((a)=>a.organizationMember.isApiUser == false)?.map((a)=>{
            var collectionItem;
            collectionItem = {
                noImageText: `${a.organizationMember.firstName == null ? "N" : a.organizationMember.firstName[0]} ${a.organizationMember.lastName == null ? "A" : a.organizationMember.lastName[0]}`,
                tooltipText: `${a.organizationMember.firstName == null ? "N" : a.organizationMember.firstName[0]} ${a.organizationMember.lastName == null ? "A" : a.organizationMember.lastName[0]}`,
                imageUrl: a.organizationMember.imageUrl
            };
            return collectionItem;
        }),
        limit: 4
    }), (0, _react.jsx)((0, _smallOverflowMenuDefault.default), {
        className: `${overflowStyle} ac-app-list-item-overflow`,
        menuClassName: overflowMenuStyle,
        optionClassName: overflowOptionStyle,
        buttonClassName: overflowMenuButtonStyle,
        onOptionSelected: (option)=>props.onOptionSelect(props.app.id, option),
        options: [
            {
                label: "Webhooks",
                icon: webhookIcon,
                hoverIcon: webhookIcon
            },
            {
                label: "Delete",
                icon: deleteIcon,
                hoverIcon: deleteIcon,
                isDestructive: true
            }
        ]
    }));
const overflowMenuStyle = /*#__PURE__*/ (0, _css.css)({
    name: "149fblv",
    styles: "width:120px;margin-left:0px;right:-11px"
});
const overflowOptionStyle = /*#__PURE__*/ (0, _css.css)({
    name: "6a9vw0",
    styles: "height:32px;font-style:normal;font-weight:normal;font-size:12px;line-height:16px;width:120px"
});
const overflowMenuButtonStyle = /*#__PURE__*/ (0, _css.css)("border-radius:4px;width:24px;height:24px;border-color:", (0, _colors.color_shades_darker), ";.circle{width:4px;height:4px;border-color:", (0, _colors.color_shades_darker), ";}", "");
const overflowStyle = /*#__PURE__*/ (0, _css.css)({
    name: "54bfyt",
    styles: "position:absolute;right:32px;top:16px"
});
const containerStyle = /*#__PURE__*/ (0, _css.css)("display:flex;flex-direction:row;position:relative;border-bottom:solid 1px ", (0, _colors.color_shades_dark), ";padding:8px 32px;.counts{width:30%;line-height:24px;margin:auto 8px;color:", (0, _colors.color_shades_darker), ";img{margin-right:4px;}}.users{width:20%;margin:auto 0px;}", "");
const appNameStyle = /*#__PURE__*/ (0, _css.css)("margin-left:16px;font-style:normal;font-weight:normal;font-size:18px;color:", (0, _colors.color_shades_darkest), ";margin-top:auto;margin-bottom:auto;&.basis-app{color:", (0, _colors.color_colors_royalty), ";}", "");
const nameAndIcon = /*#__PURE__*/ (0, _css.css)({
    name: "n0mzer",
    styles: "display:flex;flex-direction:row;width:50%"
});
exports.default = ApplicationTableItem;

},{"@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","../../../constants/colors":"1p3OR","../../../components/structure/HorizontalContainer":"eJPfh","../../../components/general/ApplicationAvatar":"aA2GK","f7e19b7ce319002a":"1ZV9Z","1762ac7f83d9be6a":"aLhIm","react-router-dom":"5fzqq","../../../components/general/IconCollectionAvatar":"j0zcR","../../../components/general/overflowMenu/SmallOverflowMenu":"YJYcI","d68a7ad0b5b1a100":"24JPN","fc9d5e2562d808bf":"e6PIG","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"73UnY":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _colors = require("../../constants/colors");
var _roundedSelectField = require("./RoundedSelectField");
var _roundedSelectFieldDefault = parcelHelpers.interopDefault(_roundedSelectField);
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// component used in building forms with consistent components for look and function
const FlatRoundedSelectField = (props)=>(0, _react.jsx)("div", {
        className: `${containerStyle} ${props.className}`
    }, (0, _react.jsx)("div", {
        className: leftSideLabel
    }, props.label), (0, _react.jsx)((0, _roundedSelectFieldDefault.default), {
        disabled: props.disabled ?? false,
        options: props.options,
        onChange: props.onChange,
        value: props.value
    }));
const containerStyle = /*#__PURE__*/ (0, _css.css)({
    name: "y2zyt0",
    styles: "display:flex;flex-direction:row;.Select-control{box-shadow:none;}"
});
const leftSideLabel = /*#__PURE__*/ (0, _css.css)("font-family:Muli;font-style:normal;font-weight:normal;font-size:12px;line-height:16px;color:", (0, _colors.color_shades_darkest), ";margin-right:16px;margin-top:8px;", "");
exports.default = FlatRoundedSelectField;

},{"@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","../../constants/colors":"1p3OR","./RoundedSelectField":"lAfbC","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2qU7b":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _unstatedNext = require("unstated-next");
var _api = require("../api");
var _phonePlatforms = require("../constants/phonePlatforms");
function useTelephonyDeploymentContainer() {
    const [telephonyDeployments, setTelephonyDeployments] = (0, _react.useState)([]);
    const [isLoading, setIsLoading] = (0, _react.useState)(false);
    const [errors, setErrors] = (0, _react.useState)([]);
    const getTelephonyDeployments = async (currentAppId)=>{
        try {
            setIsLoading(true);
            const result = await _api.getTelephonyDeployments(currentAppId);
            if (result.resultType == "Ok") // Merge new deployments with existing ones, replacing any for the same app
            setTelephonyDeployments((prev)=>{
                const otherAppDeployments = prev.filter((d)=>d.applicationId !== currentAppId);
                return [
                    ...otherAppDeployments,
                    ...result.data
                ];
            });
            else if (result.errors != null && result.errors.length > 0) setErrors([
                ...result.errors
            ]);
            setIsLoading(false);
            return result;
        } catch (error) {
            setErrors([
                error
            ]);
            setIsLoading(false);
        }
    };
    const createTelephonyDeployment = async (currentAppId, request)=>{
        try {
            setIsLoading(true);
            let result;
            if (request.platform === (0, _phonePlatforms.PHONE_PLATFORMS).VONAGE) result = await _api.addTelephonyDeploymentVonage(currentAppId, request);
            else if (request.platform === (0, _phonePlatforms.PHONE_PLATFORMS).TELNYX || !request.platform) // Defaulting to Telnyx if no platform is specified as of 8/14/25
            result = await _api.addTelephonyDeploymentTelnyx(currentAppId, request);
            if (result.errors != null && result.errors.length > 0) setErrors([
                ...result.errors
            ]);
            setIsLoading(false);
            return result;
        } catch (error) {
            setErrors([
                error
            ]);
            setIsLoading(false);
            return error;
        }
    };
    const updateTelephonyDeployment = async (currentAppId, phoneNumber, request)=>{
        try {
            setIsLoading(true);
            const result = await _api.updateTelephonyDeployment(currentAppId, phoneNumber, request);
            if (result.errors != null && result.errors.length > 0) setErrors([
                ...result.errors
            ]);
            setIsLoading(false);
            return result;
        } catch (error) {
            setErrors([
                error
            ]);
            setIsLoading(false);
        }
    };
    const deleteTelephonyDeployment = async (currentAppId, phoneNumber)=>{
        try {
            setIsLoading(true);
            const result = await _api.deleteTelephonyDeployment(currentAppId, phoneNumber);
            if (result.errors != null && result.errors.length > 0) setErrors([
                ...result.errors
            ]);
            setIsLoading(false);
            return result;
        } catch (error) {
            setErrors([
                error
            ]);
            setIsLoading(false);
        }
    };
    const moveTelephonyDeployment = async (currentAppId, phoneNumber, targetApplicationId)=>{
        try {
            setIsLoading(true);
            const result = await _api.moveTelephonyDeployment(currentAppId, phoneNumber, targetApplicationId);
            if (result.errors != null && result.errors.length > 0) setErrors([
                ...result.errors
            ]);
            setIsLoading(false);
            return result;
        } catch (error) {
            setErrors([
                error
            ]);
            setIsLoading(false);
        }
    };
    return {
        isLoading,
        errors,
        clearErrors: ()=>setErrors([]),
        getTelephonyDeployments,
        telephonyDeployments,
        createTelephonyDeployment,
        updateTelephonyDeployment,
        deleteTelephonyDeployment,
        moveTelephonyDeployment
    };
}
const TelephonyDeploymentContainer = (0, _unstatedNext.createContainer)(useTelephonyDeploymentContainer);
exports.default = TelephonyDeploymentContainer;

},{"react":"6uln9","unstated-next":"61zE5","../api":"loxM6","../constants/phonePlatforms":"bZIQ4","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"bZIQ4":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PHONE_PLATFORMS", ()=>PHONE_PLATFORMS);
const PHONE_PLATFORMS = {
    VONAGE: "Vonage",
    TELNYX: "Telnyx"
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"ffYYa":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _reactRouterDom = require("react-router-dom");
var _colors = require("../../../constants/colors");
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const emptyImage = require("7e47158fa21a6aa1");
const EmptyView = ({ title, description, actionLink, actionText, imageStyle, wrapperStyle, noImage })=>(0, _react.jsx)("div", {
        className: `${wrapperStyle && wrapperStyle} ${emptyWrapper}`
    }, !noImage && (0, _react.jsx)("img", {
        src: emptyImage,
        className: imageStyle
    }), (0, _react.jsx)("h4", null, title), (0, _react.jsx)("p", null, description), actionLink && actionText && actionLink.length > 0 && actionText.length > 0 && (0, _react.jsx)((0, _reactRouterDom.Link), {
        to: actionLink,
        className: buttonStyle
    }, actionText));
const emptyWrapper = /*#__PURE__*/ (0, _css.css)({
    name: "1kjaqsq",
    styles: "margin:32px 0;display:flex;flex-direction:column;align-items:center;justify-content:center;flex:1;p{max-width:360px;margin:16px;text-align:center;}"
});
const buttonStyle = /*#__PURE__*/ (0, _css.css)("position:relative;height:50px;white-space:nowrap;border-radius:40px;border:none;padding:0 40px;margin:16px;cursor:pointer;font-family:Muli;font-size:18px;font-weight:600;font-style:normal;font-stretch:normal;letter-spacing:0.4px;text-align:center;color:white;background:", (0, _colors.color_gradients_green_shift), ";display:flex;align-items:center;justify-content:center;&:disabled{background:", (0, _colors.color_gradients_knight_shift), ";&:hover,&:active{background:", (0, _colors.color_gradients_knight_shift), ";}}&:hover{background:", (0, _colors.color_gradients_green_shift_reverse), ";}&:active{box-shadow:inset 0px 0px 32px rgba(0, 0, 0, 0.25);}", "");
exports.default = EmptyView;

},{"@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","react-router-dom":"5fzqq","../../../constants/colors":"1p3OR","7e47158fa21a6aa1":"3LAUC","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4h6sJ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _defineProperty = require("@babel/runtime/helpers/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _unstated = require("unstated");
var _api = require("../../api");
class SubscriptionContainer extends (0, _unstated.Container) {
    constructor(...args){
        super(...args);
        // default state
        (0, _definePropertyDefault.default)(this, "state", {
            isLoading: false,
            subscription: null
        });
    }
    async loadSubscription(organizationId) {
        try {
            this.setLoading(true);
            const subResult = await _api.getOrganizationSubscription(organizationId);
            if (subResult.resultType == "Ok") this.setState({
                ...this.state,
                isLoading: false,
                subscription: subResult.data
            });
            else this.setLoading(false);
        } catch (error) {
            this.setLoading(false);
        }
    }
    setLoading(isLoading) {
        this.setState({
            ...this.state,
            isLoading: isLoading
        });
    }
}
exports.default = SubscriptionContainer;

},{"@babel/runtime/helpers/defineProperty":"9sJxO","unstated":"grh7p","../../api":"loxM6","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"aN1yJ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _unstated = require("unstated");
var _memberContainer = require("../../state/containers/MemberContainer");
var _memberContainerDefault = parcelHelpers.interopDefault(_memberContainer);
var _organizationMemberListView = require("./components/OrganizationMemberListView");
var _organizationMemberListViewDefault = parcelHelpers.interopDefault(_organizationMemberListView);
var _organizationContainer = require("../../state/containers/OrganizationContainer");
var _organizationContainerDefault = parcelHelpers.interopDefault(_organizationContainer);
var _applicationContainer = require("../../state/containers/ApplicationContainer");
var _applicationContainerDefault = parcelHelpers.interopDefault(_applicationContainer);
var _userContainer = require("../../state/containers/UserContainer");
var _userContainerDefault = parcelHelpers.interopDefault(_userContainer);
const OrganizationMembers = (props)=>{
    return (0, _react.jsx)((0, _unstated.Subscribe), {
        to: [
            (0, _memberContainerDefault.default),
            (0, _organizationContainerDefault.default),
            (0, _applicationContainerDefault.default),
            (0, _userContainerDefault.default)
        ]
    }, (memberContainer, orgContainer, appContainer, userContainer, authContainer)=>{
        return (0, _react.jsx)((0, _organizationMemberListViewDefault.default), {
            history: props.history,
            memberContainer: memberContainer,
            organizationId: orgContainer.state.currentOrganization.id,
            appContainer: appContainer,
            userContainer: userContainer,
            organizationContainer: orgContainer,
            authContainer: authContainer
        });
    });
};
exports.default = OrganizationMembers;

},{"@emotion/react":"djZKr","react":"6uln9","unstated":"grh7p","../../state/containers/MemberContainer":"iYQOb","./components/OrganizationMemberListView":"v0Ivf","../../state/containers/OrganizationContainer":"dlbaM","../../state/containers/ApplicationContainer":"cuqi2","../../state/containers/UserContainer":"jDrDR","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"v0Ivf":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _defineProperty = require("@babel/runtime/helpers/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _base = require("@emotion/styled/base");
var _baseDefault = parcelHelpers.interopDefault(_base);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _loader = require("../../../components/general/Loader");
var _loaderDefault = parcelHelpers.interopDefault(_loader);
var _roundedTwoOptionButton = require("../../../components/forms/RoundedTwoOptionButton");
var _roundedTwoOptionButtonDefault = parcelHelpers.interopDefault(_roundedTwoOptionButton);
var _roundedSelectField = require("../../../components/forms/RoundedSelectField");
var _roundedSelectFieldDefault = parcelHelpers.interopDefault(_roundedSelectField);
var _numberIncrementSelector = require("../../../components/forms/NumberIncrementSelector");
var _numberIncrementSelectorDefault = parcelHelpers.interopDefault(_numberIncrementSelector);
var _colors = require("../../../constants/colors");
var _searchField = require("../../../components/forms/SearchField");
var _searchFieldDefault = parcelHelpers.interopDefault(_searchField);
var _button = require("../../../components/general/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _reactRouterDom = require("react-router-dom");
var _flatRoundedSelectField = require("../../../components/forms/FlatRoundedSelectField");
var _flatRoundedSelectFieldDefault = parcelHelpers.interopDefault(_flatRoundedSelectField);
var _horizontalContainer = require("../../../components/structure/HorizontalContainer");
var _horizontalContainerDefault = parcelHelpers.interopDefault(_horizontalContainer);
var _organizationMemberCard = require("./OrganizationMemberCard");
var _organizationMemberCardDefault = parcelHelpers.interopDefault(_organizationMemberCard);
var _confirmationDialog = require("../../../components/structure/ConfirmationDialog");
var _confirmationDialogDefault = parcelHelpers.interopDefault(_confirmationDialog);
var _removeConfirmation = require("../../../components/general/RemoveConfirmation");
var _removeConfirmationDefault = parcelHelpers.interopDefault(_removeConfirmation);
var _organizationMemberTableItem = require("./OrganizationMemberTableItem");
var _organizationMemberTableItemDefault = parcelHelpers.interopDefault(_organizationMemberTableItem);
var _breakpoints = require("../../../constants/breakpoints");
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const addIcon = require("12222516d0a31fa2");
const WAIT_INTERVAL = 500;
const ENTER_KEY = 13;
class OrganizationMemberListView extends (0, _reactDefault.default).Component {
    constructor(props){
        super(props);
        (0, _definePropertyDefault.default)(this, "timer", null);
        this.state = {
            selectedMember: null,
            isRemoveConfirmationVisible: false,
            view: "card",
            page: 1,
            take: "10",
            search: "",
            sortBy: "NameAscending",
            displayedMembers: [],
            previousMembers: [],
            currentMemberId: "",
            isChangeReceiveAnalyticsConfirmationVisible: false
        };
    }
    componentDidMount() {
        this.props.memberContainer.getInvitations(this.props.organizationId);
        this.props.organizationContainer.getSystemRoles();
        if (!this.props.organizationContainer.state.organizations?.length) this.props.organizationContainer.getOrganizations();
        if (this.props.userContainer.state.currentUser == null) this.props.userContainer.getUser();
        this.setState({
            ...this.state,
            sortBy: this.props.memberContainer.state.organizationMemberListPreferences?.sortBy ?? "NameAscending",
            take: this.props.memberContainer.state.organizationMemberListPreferences?.take ?? "10",
            view: this.props.memberContainer.state.organizationMemberListPreferences?.view ?? "card"
        }, this.reloadMembers);
    }
    componentDidUpdate() {
        if (this.props.memberContainer.state.members != null && this.state.previousMembers != this.props.memberContainer.state.members) this.setState({
            ...this.state,
            previousMembers: this.props.memberContainer.state.members
        }, this.recalculateDefaultMembers);
    }
    reloadMembers() {
        this.props.memberContainer.getMembers(this.props.organizationId).then((result)=>this.recalculateMembers(result.data));
    }
    recalculateMembers(members) {
        this.setState({
            ...this.state,
            displayedMembers: this.sortSearchAndPageMembers(members)
        });
    }
    toggleIsRemoveConfirmationVisible() {
        this.setState({
            ...this.state,
            isRemoveConfirmationVisible: !this.state.isRemoveConfirmationVisible
        });
    }
    recalculateDefaultMembers() {
        this.setState({
            ...this.state,
            displayedMembers: this.sortSearchAndPageMembers(this.props.memberContainer.state.members)
        });
    }
    handleChangeRole(memberId, roleName) {
        var role;
        if (roleName == "Administrator") role = this.props.organizationContainer.state.systemRoles.find((r)=>r.isAdmin);
        else role = this.props.organizationContainer.state.systemRoles.find((r)=>!r.isAdmin && r.canEdit);
        this.props.memberContainer.updateMemberRole(memberId, role.id).then((result)=>this.reloadMembers());
    }
    renderCards(members, invitations) {
        var admins = this.props.memberContainer.state.members.filter((m)=>m.isAdmin);
        var currentMember = this.props.memberContainer.state.members.find((m)=>m.userId == this.props.userContainer.state.currentUser?.id);
        var oneAdmin = admins.length < 2;
        return (0, _react.jsx)("div", {
            className: orgCardContainer
        }, members.map((member)=>(0, _react.jsx)((0, _organizationMemberCardDefault.default), {
                key: member.id,
                remove: ()=>this.showRemoveMember(member, currentMember.id),
                changeReceiveAnalyticsEmail: ()=>this.updateMemberReceivesAnalyticsEmail(member),
                allowRoleChange: (!member.isAdmin || !oneAdmin) && currentMember?.isAdmin,
                updateRole: this.handleChangeRole.bind(this),
                member: member,
                allowRemove: member.id == currentMember?.id || member.isAdmin && oneAdmin
            })), invitations.map((invitation)=>(0, _react.jsx)((0, _organizationMemberCardDefault.default), {
                key: invitation.id,
                invitation: invitation,
                remove: ()=>this.props.memberContainer.revokeInvitation(invitation.id),
                resendInvitation: ()=>this.resendInvitation(invitation)
            })));
    }
    renderTable(members, invitations) {
        var admins = this.props.memberContainer.state.members.filter((m)=>m.isAdmin);
        var currentMember = this.props.memberContainer.state.members.find((m)=>m.userId == this.props.userContainer.state.currentUser?.id);
        var oneAdmin = admins.length < 2;
        return (0, _react.jsx)("div", {
            className: tableContainer
        }, (0, _react.jsx)("div", {
            className: "top-row"
        }, (0, _react.jsx)("div", {
            className: "user"
        }, "USER"), (0, _react.jsx)("div", {
            className: "email"
        }, "EMAIL"), (0, _react.jsx)("div", {
            className: "organization-role"
        }, "ORGANIZATION ROLE"), (0, _react.jsx)("div", {
            className: "participant-in"
        }, "PARTICIPANT IN"), (0, _react.jsx)("div", {
            className: "receives-analytics"
        }, "RECEIVES ANALYTICS EMAIL")), members.map((member)=>(0, _react.jsx)((0, _organizationMemberTableItemDefault.default), {
                remove: ()=>this.showRemoveMember(member, currentMember?.id),
                changeReceiveAnalyticsEmail: ()=>this.updateMemberReceivesAnalyticsEmail(member),
                allowRoleChange: (!member.isAdmin || !oneAdmin) && currentMember?.isAdmin,
                updateRole: this.handleChangeRole.bind(this),
                member: member,
                allowRemove: currentMember?.id == member.id || member.isAdmin && oneAdmin
            })), invitations.map((invitation)=>(0, _react.jsx)((0, _organizationMemberTableItemDefault.default), {
                invitation: invitation,
                remove: ()=>this.props.memberContainer.revokeInvitation(invitation.id),
                resendInvitation: ()=>this.resendInvitation(invitation)
            })));
    }
    incrementPage() {
        const total = this.props.memberContainer.state.members.length;
        const nextAppToLoadIndex = this.state.page * parseInt(this.state.take) + 1;
        if (nextAppToLoadIndex <= total) this.setState({
            ...this.state,
            page: this.state.page + 1
        }, this.recalculateDefaultMembers);
    }
    decrementPage() {
        if (this.state.page > 1) this.setState({
            ...this.state,
            page: this.state.page - 1
        }, this.recalculateDefaultMembers);
    }
    resendInvitation(invitation) {
        this.props.memberContainer.resendInvitation(this.props.organizationId, invitation);
    }
    toggleView() {
        var newView = this.state.view == "card" ? "table" : "card";
        this.setState({
            ...this.state,
            view: newView
        });
        this.props.memberContainer.updateOrganizationMemberListPreferences({
            take: this.state.take,
            sortBy: this.state.sortBy,
            view: newView
        });
    }
    handleSortByChange(o) {
        const sortByString = o.value.toString();
        this.setState({
            ...this.state,
            sortBy: sortByString,
            page: 1
        }, this.recalculateDefaultMembers);
        this.props.memberContainer.updateOrganizationMemberListPreferences({
            take: this.state.take,
            sortBy: sortByString,
            view: this.state.view
        });
    }
    handleTakeChange(o) {
        const takeString = o.value.toString();
        this.setState({
            ...this.state,
            take: takeString
        }, this.recalculateDefaultMembers);
        this.props.memberContainer.updateOrganizationMemberListPreferences({
            take: takeString,
            sortBy: this.state.sortBy,
            view: this.state.view
        });
    }
    handleSearch(searchEvent) {
        clearTimeout(this.timer);
        this.setState({
            ...this.state,
            search: searchEvent.target.value
        });
        this.timer = setTimeout(this.recalculateMembers.bind(this), WAIT_INTERVAL);
    }
    renderAppListDropdown(options, onChange, value, label, className) {
        return (0, _react.jsx)("div", {
            className: `${pageAndSortDropdown} ${className}`
        }, (0, _react.jsx)("div", {
            className: leftSideLabel
        }, label), (0, _react.jsx)((0, _roundedSelectFieldDefault.default), {
            options: options,
            onChange: onChange,
            value: value
        }));
    }
    handleSearchKeyDown(e) {
        if (e.keyCode === ENTER_KEY) this.recalculateDefaultMembers();
    }
    renderAddNewButton() {
        var currentMember = this.props.memberContainer.state.members.find((m)=>m.userId == this.props.userContainer.state.currentUser?.id);
        if (currentMember?.isAdmin != true) return (0, _react.jsx)((0, _buttonDefault.default), {
            text: "Add New",
            disabled: true,
            themes: [
                "primary-small"
            ],
            rightIcon: addIcon,
            className: "add-new-button ac-members-add-button"
        });
        return (0, _react.jsx)((0, _reactRouterDom.Link), {
            to: "/v/members/invite"
        }, (0, _react.jsx)((0, _buttonDefault.default), {
            text: "Add New",
            themes: [
                "primary-small"
            ],
            rightIcon: addIcon,
            className: "add-new-button ac-members-add-button"
        }));
    }
    showRemoveMember(member, currentMemberId) {
        this.setState({
            ...this.state,
            selectedMember: member,
            isRemoveConfirmationVisible: true,
            currentMemberId: currentMemberId
        });
    }
    removeMember() {
        if (this.state.selectedMember.id != this.state.currentMemberId) this.props.memberContainer.removeMemberFromOrg(this.state.selectedMember.id).then((result)=>{
            this.toggleIsRemoveConfirmationVisible();
        });
        else this.props.memberContainer.leaveOrganization(this.state.selectedMember.id, this.props.organizationId).then((result)=>{
            if (this.props.organizationContainer.state.organizations.length > 1) location.pathname = "/orgs";
            else location.pathname = "/v/logout";
        });
    }
    updateMemberReceivesAnalyticsEmail(member) {
        this.props.memberContainer.updateMemberReceivesAnalyticsEmail(member.id, !member.receivesAnalyticsEmail);
    }
    sortSearchAndPageMembers(members) {
        const search = this.state.search;
        const page = this.state.page;
        const take = parseInt(this.state.take);
        const sortBy = this.state.sortBy;
        if (members && search.toLowerCase()) members = members.filter((m)=>`${m.firstName.toLowerCase()} ${m.lastName.toLowerCase()} ${m.email.toLowerCase}`.includes(search.toLowerCase())) ?? [];
        else members = this.props.memberContainer.state.members;
        let compareFunction = null;
        switch(sortBy){
            case "NameAscending":
                compareFunction = (a, b)=>`${a.firstName} ${a.lastName}`.localeCompare(`${b.firstName} ${b.lastName}`);
                break;
            case "NameDescending":
                compareFunction = (a, b)=>-1 * `${a.firstName} ${a.lastName}`.localeCompare(`${b.firstName} ${b.lastName}`);
                break;
            case "CreatedDateAscending":
                compareFunction = (a, b)=>new Date(a.createdDate) > new Date(b.createdDate) ? -1 : new Date(a.createdDate) == new Date(b.createdDate) ? 0 : 1;
                break;
            case "CreatedDateDescending":
                compareFunction = (a, b)=>new Date(a.createdDate) > new Date(b.createdDate) ? 1 : new Date(a.createdDate) == new Date(b.createdDate) ? 0 : -1;
                break;
        }
        members = members?.sort(compareFunction);
        if (members?.length > 0) {
            const startingIndex = 0 + (page - 1) * take;
            if (startingIndex < members.length) {
                let endingIndex = startingIndex + take;
                if (endingIndex >= members.length) endingIndex = members.length;
                members = members.slice(startingIndex, endingIndex);
            }
        }
        return members;
    }
    render() {
        const invitations = this.props.memberContainer.state.invitations ?? [];
        return (0, _react.jsx)("div", null, (0, _react.jsx)((0, _horizontalContainerDefault.default), {
            className: searchAndModify
        }, (0, _react.jsx)((0, _searchFieldDefault.default), {
            id: "1",
            name: "searchField",
            placeholder: "Search",
            disabled: false,
            onChange: this.handleSearch.bind(this),
            onKeyDown: this.handleSearchKeyDown.bind(this),
            className: searchField
        }), (0, _react.jsx)("div", {
            className: "table-grid"
        }, (0, _react.jsx)((0, _roundedTwoOptionButtonDefault.default), {
            updateViewValue: this.toggleView.bind(this),
            selectedOption: this.state.view == "table"
        })), this.renderAddNewButton()), (0, _react.jsx)((0, _horizontalContainerDefault.default), {
            className: pageAndSort
        }, (0, _react.jsx)((0, _flatRoundedSelectFieldDefault.default), {
            options: [
                {
                    label: "Name - Alphabetical",
                    value: "NameAscending"
                },
                {
                    label: "Name - Reverse Alphabetical",
                    value: "NameDescending"
                },
                {
                    label: "Date Added - Oldest First",
                    value: "CreatedDateAscending"
                },
                {
                    label: "Date Added - Latest First",
                    value: "CreatedDateDescending"
                }
            ],
            onChange: this.handleSortByChange.bind(this),
            value: this.state.sortBy,
            label: "Arrange by",
            className: arrangeBy
        }), (0, _react.jsx)((0, _flatRoundedSelectFieldDefault.default), {
            options: [
                {
                    label: "10",
                    value: "10"
                },
                {
                    label: "25",
                    value: "25"
                },
                {
                    label: "50",
                    value: "50"
                }
            ],
            onChange: this.handleTakeChange.bind(this),
            value: this.state.take,
            label: "Display at once",
            className: take
        }), (0, _react.jsx)("div", {
            className: pageContainer
        }, (0, _react.jsx)("div", {
            className: leftSideLabel
        }, "Page"), (0, _react.jsx)((0, _numberIncrementSelectorDefault.default), {
            selectedNumber: `${this.state.page}`,
            updateValue: (b)=>b ? this.incrementPage() : this.decrementPage(),
            showNumber: true
        }))), this.state.isRemoveConfirmationVisible && (0, _react.jsx)((0, _confirmationDialogDefault.default), {
            title: "Remove",
            deleteText: "Yes, Remove",
            isLoading: this.props.memberContainer.state.isUpdating,
            onClose: this.toggleIsRemoveConfirmationVisible.bind(this),
            onConfirm: this.removeMember.bind(this)
        }, (0, _react.jsx)((0, _removeConfirmationDefault.default), {
            memberName: this.state.selectedMember.firstName + " " + this.state.selectedMember.lastName,
            customText: this.state.selectedMember.id == this.state.currentMemberId && this.props.organizationContainer.state.organizations.length == 1 ? "Removing yourself from this organization will return you to the login screen." : undefined
        })), this.props.memberContainer.state.isLoadingMembers ? (0, _react.jsx)((0, _loaderDefault.default), null) : this.state.view == "card" ? this.renderCards(this.state.displayedMembers, invitations) : this.renderTable(this.state.displayedMembers, invitations));
    }
}
const searchAndModify = /*#__PURE__*/ (0, _css.css)("display:flex;flex-direction:row;margin:12px 0 12px 32px;div{box-shadow:none;}.centerer{box-shadow:none;}.field-container{height:32px;border-radius:16px;margin-top:0px;}.table-grid{margin:0px 16px;", (0, _breakpoints.breakpoint_small), "{display:none;}}.apps-name{font-size:14px;line-height:20px;height:32px;font-style:normal;font-weight:normal;padding:6px 16px 4px 8px;}.add-new-button{margin:0px;margin-right:32px;}.separator{margin-right:16px;height:32px;}", "");
const searchField = /*#__PURE__*/ (0, _css.css)({
    name: "1tlmwo2",
    styles: "margin-bottom:0px"
});
const pageAndSort = /*#__PURE__*/ (0, _css.css)("display:flex;flex-direction:row;width:100%;border-bottom:1px solid ", (0, _colors.color_shades_dark), ";border-top:1px solid ", (0, _colors.color_shades_dark), ";", (0, _breakpoints.breakpoint_small), "{display:none;}", "");
const pageAndSortDropdown = /*#__PURE__*/ (0, _css.css)({
    name: "y2zyt0",
    styles: "display:flex;flex-direction:row;.Select-control{box-shadow:none;}"
});
const pageContainer = /*#__PURE__*/ (0, _css.css)({
    name: "ra1h3f",
    styles: "display:flex;flex-direction:row;margin:12px 32px 0px 0px;.page-selector{box-shadow:none;}"
});
const leftSideLabel = /*#__PURE__*/ (0, _css.css)("font-family:Muli;font-style:normal;font-weight:normal;font-size:12px;line-height:16px;color:", (0, _colors.color_shades_darkest), ";margin-right:16px;margin-top:8px;", "");
const arrangeBy = /*#__PURE__*/ (0, _css.css)({
    name: "8gcf24",
    styles: "margin:12px auto 12px 32px;.Select{width:240px;}"
});
const take = /*#__PURE__*/ (0, _css.css)({
    name: "xpb9ru",
    styles: "margin:12px 32px 12px 0px;.Select{width:80px;}"
});
const orgCardContainer = /*#__PURE__*/ (0, _css.css)("display:flex;flex-wrap:wrap;flex-direction:row;width:100%;", (0, _breakpoints.breakpoint_small), "{justify-content:center;}", "");
const ReceiveAnalyticsEmailConfirmationContainer = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1gvamj90"
})("display:flex;flex-direction:column;align-items:center;justify-content:center;margin:64px;p{font-family:Muli;font-size:18px;font-weight:normal;font-style:normal;font-stretch:normal;line-height:normal;letter-spacing:0.5px;text-align:center;color:", (0, _colors.dark_grey_blue), ";}");
const tableContainer = /*#__PURE__*/ (0, _css.css)("display:flex;flex-direction:column;width:100%;.top-row{display:flex;flex-direction:row;border-bottom:solid 1px ", (0, _colors.color_shades_dark), ";height:40px;padding-left:32px;padding-right:32px;div{margin-top:auto;margin-bottom:auto;font-style:normal;font-weight:normal;font-size:14px;line-height:16px;letter-spacing:0.1em;text-transform:uppercase;color:", (0, _colors.color_shades_darker), ";}.user{width:28%;}.email{width:20%;}.organization-role{width:20%;}.participant-in{width:15%;}.receives-analytics{width:15%;}}", "");
exports.default = OrganizationMemberListView;

},{"@babel/runtime/helpers/defineProperty":"9sJxO","@emotion/styled/base":"lSuFu","@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","../../../components/general/Loader":"bnV5T","../../../components/forms/RoundedTwoOptionButton":"7kmUj","../../../components/forms/RoundedSelectField":"lAfbC","../../../components/forms/NumberIncrementSelector":"kU0zB","../../../constants/colors":"1p3OR","../../../components/forms/SearchField":"aU10T","../../../components/general/Button":"6ymxN","react-router-dom":"5fzqq","../../../components/forms/FlatRoundedSelectField":"73UnY","../../../components/structure/HorizontalContainer":"eJPfh","./OrganizationMemberCard":"ku1GM","../../../components/structure/ConfirmationDialog":"kx7yK","../../../components/general/RemoveConfirmation":"elIoY","./OrganizationMemberTableItem":"amkvu","../../../constants/breakpoints":"2F01A","12222516d0a31fa2":"i0YpA","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"ku1GM":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _base = require("@emotion/styled/base");
var _baseDefault = parcelHelpers.interopDefault(_base);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _colors = require("../../../constants/colors");
var _horizontalContainer = require("../../../components/structure/HorizontalContainer");
var _horizontalContainerDefault = parcelHelpers.interopDefault(_horizontalContainer);
var _horizontalSeparator = require("../../../components/structure/HorizontalSeparator");
var _horizontalSeparatorDefault = parcelHelpers.interopDefault(_horizontalSeparator);
var _userAvatar = require("../../../components/general/UserAvatar");
var _userAvatarDefault = parcelHelpers.interopDefault(_userAvatar);
var _iconCollectionAvatar = require("../../../components/general/IconCollectionAvatar");
var _iconCollectionAvatarDefault = parcelHelpers.interopDefault(_iconCollectionAvatar);
var _overflowMenu = require("../../../components/general/overflowMenu/OverflowMenu");
var _overflowMenuDefault = parcelHelpers.interopDefault(_overflowMenu);
var _toggleIndicator = require("../../../components/general/ToggleIndicator");
var _toggleIndicatorDefault = parcelHelpers.interopDefault(_toggleIndicator);
var _button = require("../../../components/general/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _checkboxField = require("../../../components/forms/CheckboxField");
var _checkboxFieldDefault = parcelHelpers.interopDefault(_checkboxField);
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const removeMember = require("4ad3c3f136dac67d");
const removeMemberDisabled = require("a6a9bd82e70dea15");
const resendMail = require("5eebea3b6ca38eec");
const copyIcon = require("d304908abd65c5a");
class OrganizationMemberCard extends (0, _reactDefault.default).Component {
    constructor(props){
        super(props);
        this.state = {
            showRoleDropdown: false,
            copyBtnText: "Copy Link"
        };
    }
    copyLink() {
        const element = document.createElement("textarea");
        element.value = `${location.host}/acceptinvitation/${this.props.invitation?.id}`;
        document.body.appendChild(element);
        element.select();
        document.execCommand("copy");
        document.body.removeChild(element);
        this.setState({
            ...this.state,
            copyBtnText: "Copied"
        });
        setTimeout(()=>{
            this.setState({
                ...this.state,
                copyBtnText: "Copy Link"
            });
        }, 3000);
    }
    toggleRoleDropdown() {
        this.setState({
            ...this.state,
            showRoleDropdown: !this.state.showRoleDropdown
        });
    }
    selectRole(role) {
        if (this.props.allowRoleChange) this.props.updateRole(this.props.member.id, role);
    }
    render() {
        const member = this.props.member;
        const invitation = this.props.invitation;
        const firstName = member == null ? "New" : member.firstName;
        const lastName = member == null ? "User" : member.lastName;
        const email = member == null ? invitation?.email : member.email;
        const noImageText = member == null ? "?" : null;
        let memberRole = member?.isAdmin ? "Administrator" : "Contributor";
        if (member == null) memberRole = invitation?.isAdmin ? "Administrator" : "Contributor";
        const appMemberships = member?.applicationMemberships ?? [];
        return (0, _react.jsx)("div", {
            className: cardStyle,
            key: member?.id ?? invitation?.id
        }, (0, _react.jsx)("div", {
            className: `${innerCard} ac-members-item`
        }, (0, _react.jsx)((0, _userAvatarDefault.default), {
            className: "member-icon",
            firstName: firstName,
            lastName: lastName,
            noImageText: noImageText,
            src: member?.imageUrl,
            size: 56,
            noBackground: true,
            noShadow: true
        }), (0, _react.jsx)("div", {
            className: "spacer"
        }), (0, _react.jsx)((0, _horizontalSeparatorDefault.default), null), (0, _react.jsx)((0, _horizontalContainerDefault.default), {
            className: "member-details"
        }, (0, _react.jsx)("div", {
            className: "center-vertically"
        }, (0, _react.jsx)("div", {
            className: "member-name"
        }, `${firstName} ${lastName}`), (0, _react.jsx)("div", {
            className: "member-email ac-member-email"
        }, email))), (0, _react.jsx)((0, _horizontalSeparatorDefault.default), null), member == null ? (0, _react.jsx)((0, _reactDefault.default).Fragment, null, (0, _react.jsx)("div", {
            className: "resend"
        }, (0, _react.jsx)("h5", null, "Invite Sent"), (0, _react.jsx)((0, _buttonDefault.default), {
            text: "Resend",
            themes: [
                "small-flat"
            ],
            onClick: ()=>this.props.resendInvitation(),
            rightIcon: resendMail,
            className: resendBtnClassName
        })), (0, _react.jsx)(RemoveCopyLinkWrapper, null, (0, _react.jsx)((0, _buttonDefault.default), {
            text: "Remove",
            themes: [
                "small-flat"
            ],
            onClick: this.props.allowRoleChange ? this.props.remove : null,
            icon: this.props.allowRoleChange ? removeMember : removeMemberDisabled,
            className: `${this.props.allowRoleChange ? "" : "disabled"} ${removeBtnClassName}`,
            disabled: !this.props.allowRoleChange
        }), (0, _react.jsx)((0, _buttonDefault.default), {
            text: this.state.copyBtnText,
            themes: [
                "small-flat"
            ],
            onClick: this.copyLink.bind(this),
            rightIcon: copyIcon,
            iconClassName: copyIconStyle,
            className: copyBtnStyle
        }))) : (0, _react.jsx)((0, _reactDefault.default).Fragment, null, (0, _react.jsx)("div", {
            className: "participant-in"
        }, "PARTICIPANT IN"), (0, _react.jsx)((0, _iconCollectionAvatarDefault.default), {
            className: "app-collection ac-members-apps",
            items: appMemberships.map((a)=>{
                var collectionItem;
                collectionItem = {
                    noImageText: `${a.applicationName == null ? "NA" : a.applicationName[0]}`,
                    tooltipText: a.applicationName,
                    imageUrl: a.applicationImageUrl
                };
                return collectionItem;
            }),
            limit: 4
        }), (0, _react.jsx)("div", null, (0, _react.jsx)(StyledCheckboxField, {
            label: "Receives Analytics Email",
            labelStyle: toolTipLabelStyle,
            checked: member.receivesAnalyticsEmail ?? false,
            onChange: (e)=>this.props.changeReceiveAnalyticsEmail(),
            tooltip: "Receives monthly analytics report via email",
            tooltipStyle: tooltipStyle
        }), this.props.allowRemove ? (0, _react.jsx)("div", {
            className: `${removeMemberStyle}`,
            onClick: this.props.remove
        }, (0, _react.jsx)("img", {
            src: removeMember
        }), "Remove") : (0, _react.jsx)("div", {
            className: `${removeMemberStyle} ${this.props.allowRoleChange ? "" : "disabled"}`,
            onClick: this.props.allowRoleChange ? this.props.remove : null
        }, (0, _react.jsx)("img", {
            src: this.props.allowRoleChange ? removeMember : removeMemberDisabled
        }), "Remove"))), (0, _react.jsx)("div", {
            className: memberRoleDropdownStyle
        }, (0, _react.jsx)("div", {
            onClick: this.toggleRoleDropdown.bind(this),
            className: "current-role ac-member-role"
        }, (0, _react.jsx)("div", null, memberRole), this.props.member != null && (0, _react.jsx)((0, _toggleIndicatorDefault.default), {
            className: chevronStyle,
            direction: this.state.showRoleDropdown ? "up" : "down"
        })), this.state.showRoleDropdown && this.props.member != null && (0, _react.jsx)((0, _overflowMenuDefault.default), {
            className: "overflow-menu",
            optionClassName: "overflow-option",
            onClose: this.toggleRoleDropdown.bind(this),
            onOptionSelected: this.selectRole.bind(this),
            options: [
                {
                    isDisabled: !this.props.allowRoleChange,
                    label: "Administrator"
                },
                {
                    isDisabled: !this.props.allowRoleChange,
                    label: "Contributor"
                }
            ]
        }))));
    }
}
const removeMemberStyle = /*#__PURE__*/ (0, _css.css)("cursor:pointer;display:flex;flex-direction:row;color:", (0, _colors.color_colors_ocean), ";font-style:normal;font-weight:normal;font-size:14px;img{margin-right:4px;}&.disabled{cursor:initial;color:", (0, _colors.color_shades_dark), ";svg{fill:", (0, _colors.color_shades_dark), ";}}&.invitation{margin-top:48px;}", "");
const tooltipStyle = /*#__PURE__*/ (0, _css.css)("width:20px;height:20px;margin-top:2px;margin-left:8px;border:solid 1px ", (0, _colors.text_blue), ";span{color:", (0, _colors.text_blue), ";}", "");
const toolTipLabelStyle = /*#__PURE__*/ (0, _css.css)({
    name: "vh5nmu",
    styles: "font-size:13px"
});
const memberRoleDropdownStyle = /*#__PURE__*/ (0, _css.css)("position:absolute;right:16px;top:12px;.current-role{cursor:pointer;font-style:normal;font-weight:normal;font-size:12px;line-height:16px;text-align:right;color:", (0, _colors.color_shades_darkest), ";display:flex;flex-direction:row;}.overflow-menu{width:120px;right:-14px;}.overflow-option{height:32px;font-style:normal;font-weight:normal;font-size:12px;line-height:16px;}", "");
const chevronStyle = /*#__PURE__*/ (0, _css.css)({
    name: "584u9k",
    styles: "margin-left:8px;margin-top:6px;margin-right:6px"
});
const cardStyle = /*#__PURE__*/ (0, _css.css)("width:250px;min-height:210px;border-radius:8px;background-color:white;border:solid 1px ", (0, _colors.silver_four), ";margin:48px 0px 48px 32px;position:relative;.member-icon{top:-28px;left:24px;position:absolute;}.spacer{height:20px;}.member-details{display:flex;flex-direction:column;margin:12px 0px;min-height:68px;}.center-vertically{margin:auto 0px;}.member-name{font-style:normal;font-stretch:normal;line-height:24px;letter-spacing:normal;color:", (0, _colors.color_shades_darkest), ";font-size:18px;}.member-email{font-style:normal;font-stretch:normal;line-height:20px;letter-spacing:normal;color:", (0, _colors.color_shades_darkest), ";display:flex;font-size:14px;margin:0px;}.counts{font-family:Muli;font-style:normal;font-weight:normal;font-size:12px;line-height:16px;color:", (0, _colors.color_shades_darker), ";margin:8px 0px;justify-content:center;img{margin-right:4px;margin-bottom:3px;}}.app-collection{margin-left:12px;margin-top:12px;}.participant-in{font-size:12px;line-height:16px;margin-top:12px;color:", (0, _colors.color_shades_darker), ";}.invite-link{width:202px;height:32px;padding:8px 12px;border-radius:4px;border:1px solid ", (0, _colors.color_shades_dark), ";box-sizing:border-box;margin:12px 0px;box-shadow:inset 0px 1px 2px rgba(50, 70, 97, 0.1);}.direct-link{font-style:normal;font-weight:normal;font-size:12px;line-height:16px;color:", (0, _colors.color_shades_darker), ";display:flex;flex-direction:row;margin-top:8px;}.resend{display:flex;align-items:center;justify-content:space-between;align-content:center;h5{font-style:italic;font-size:14px;font-weight:400;opacity:0.8;}}.link{color:", (0, _colors.color_colors_ocean), ";cursor:pointer;}", "");
const innerCard = /*#__PURE__*/ (0, _css.css)({
    name: "10rtstj",
    styles: "padding:16px"
});
const copyIconStyle = /*#__PURE__*/ (0, _css.css)({
    name: "1cjitc6",
    styles: "width:16px"
});
const copyBtnStyle = /*#__PURE__*/ (0, _css.css)({
    name: "1brnwzh",
    styles: "margin:0;height:20px"
});
const RemoveCopyLinkWrapper = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "eovfdsx1"
})({
    name: "11w8k43",
    styles: "display:flex;align-items:center;justify-content:space-between;align-content:center;font-size:14px;margin-top:40px"
});
const removeBtnClassName = /*#__PURE__*/ (0, _css.css)("display:flex;height:20px;align-items:center;justify-content:center;align-content:center;margin:0;font-size:14px;&.disabled{color:", (0, _colors.color_shades_dark), ";svg{fill:", (0, _colors.color_shades_dark), ";}}", "");
const resendBtnClassName = /*#__PURE__*/ (0, _css.css)({
    name: "cfjpzu",
    styles: "margin:0px"
});
const StyledCheckboxField = /*#__PURE__*/ (0, _baseDefault.default)((0, _checkboxFieldDefault.default), {
    target: "eovfdsx0"
})({
    name: "c3gjx4",
    styles: "margin-top:16px;margin-bottom:-10px"
});
exports.default = OrganizationMemberCard;

},{"@emotion/styled/base":"lSuFu","@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","../../../constants/colors":"1p3OR","../../../components/structure/HorizontalContainer":"eJPfh","../../../components/structure/HorizontalSeparator":"Pw3HQ","../../../components/general/UserAvatar":"avuDP","../../../components/general/IconCollectionAvatar":"j0zcR","../../../components/general/overflowMenu/OverflowMenu":"2V2SB","../../../components/general/ToggleIndicator":"4eej1","../../../components/general/Button":"6ymxN","../../../components/forms/CheckboxField":"3S5Oy","4ad3c3f136dac67d":"aCrOt","a6a9bd82e70dea15":"lzRgz","5eebea3b6ca38eec":"aoSZS","d304908abd65c5a":"1jL91","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"aCrOt":[function(require,module,exports) {
module.exports = require("e07d673a48c0b890").getBundleURL("kVLro") + require("1da13ec6587af3c0").resolve("lCNCl");

},{"e07d673a48c0b890":"c7Tr5","1da13ec6587af3c0":"fyJL2"}],"lzRgz":[function(require,module,exports) {
module.exports = require("a32be07a8674d4ac").getBundleURL("kVLro") + require("1e1d44999f199560").resolve("fldCq");

},{"a32be07a8674d4ac":"c7Tr5","1e1d44999f199560":"fyJL2"}],"aoSZS":[function(require,module,exports) {
module.exports = require("cabfcdaa880aa074").getBundleURL("kVLro") + require("d4904ec76de56a9a").resolve("lMV5C");

},{"cabfcdaa880aa074":"c7Tr5","d4904ec76de56a9a":"fyJL2"}],"amkvu":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _base = require("@emotion/styled/base");
var _baseDefault = parcelHelpers.interopDefault(_base);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _colors = require("../../../constants/colors");
var _iconCollectionAvatar = require("../../../components/general/IconCollectionAvatar");
var _iconCollectionAvatarDefault = parcelHelpers.interopDefault(_iconCollectionAvatar);
var _userAvatar = require("../../../components/general/UserAvatar");
var _userAvatarDefault = parcelHelpers.interopDefault(_userAvatar);
var _toggleIndicator = require("../../../components/general/ToggleIndicator");
var _toggleIndicatorDefault = parcelHelpers.interopDefault(_toggleIndicator);
var _overflowMenu = require("../../../components/general/overflowMenu/OverflowMenu");
var _overflowMenuDefault = parcelHelpers.interopDefault(_overflowMenu);
var _checkboxField = require("../../../components/forms/CheckboxField");
var _checkboxFieldDefault = parcelHelpers.interopDefault(_checkboxField);
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const removeIcon = require("3d2db40c6b5b62a8");
const removeMemberDisabled = require("d582c9f996e81850");
const copyImage = require("a99be954234cb31d");
const resendMail = require("9d62426d78332f69");
class OrganizationMemberTableItem extends (0, _reactDefault.default).Component {
    constructor(props){
        super(props);
        this.state = {
            showRoleDropdown: false
        };
    }
    copyLink() {
        const element = document.createElement("textarea");
        element.value = `${location.host}/acceptinvitation/${this.props.invitation?.id}`;
        document.body.appendChild(element);
        element.select();
        document.execCommand("copy");
        document.body.removeChild(element);
    }
    toggleRoleDropdown() {
        this.setState({
            ...this.state,
            showRoleDropdown: !this.state.showRoleDropdown
        });
    }
    selectRole(role) {
        if (this.props.allowRoleChange) this.props.updateRole(this.props.member.id, role);
    }
    render() {
        const member = this.props.member;
        const invitation = this.props.invitation;
        const firstName = member == null ? "New" : member?.firstName;
        const lastName = member == null ? "User" : member?.lastName;
        const email = member == null ? invitation?.email : member?.email;
        const noImageText = member == null ? "?" : null;
        let memberRole = member?.isAdmin ? "Administrator" : "Contributor";
        if (member == null) memberRole = invitation?.isAdmin ? "Administrator" : "Contributor";
        return (0, _react.jsx)("div", {
            className: `${containerStyle} ac-members-item`,
            key: member?.id ?? invitation?.id
        }, (0, _react.jsx)("div", {
            className: nameAndIcon
        }, (0, _react.jsx)((0, _userAvatarDefault.default), {
            className: "member-icon",
            firstName: firstName,
            lastName: lastName,
            noImageText: noImageText,
            src: member?.imageUrl,
            size: 42,
            noBackground: true,
            noShadow: true
        }), (0, _react.jsx)("div", {
            className: nameStyle
        }, `${firstName} ${lastName}`)), (0, _react.jsx)("div", {
            className: `${emailStyle} ac-member-email`
        }, email), this.props.member == null ? (0, _react.jsx)("div", {
            className: `${roleStyle} ac-member-role`
        }, (0, _react.jsx)("div", null, memberRole)) : (0, _react.jsx)("div", {
            className: `${roleStyle} ac-member-role`
        }, (0, _react.jsx)("div", {
            className: "current-role",
            onClick: this.toggleRoleDropdown.bind(this)
        }, (0, _react.jsx)("div", null, memberRole), (0, _react.jsx)((0, _toggleIndicatorDefault.default), {
            className: chevronStyle,
            direction: this.state.showRoleDropdown ? "up" : "down"
        }), this.state.showRoleDropdown && (0, _react.jsx)((0, _overflowMenuDefault.default), {
            className: overflowMenuStyle,
            optionClassName: overflowMenuItemStyle,
            onClose: this.toggleRoleDropdown.bind(this),
            onOptionSelected: this.selectRole.bind(this),
            options: [
                {
                    isDisabled: !this.props.allowRoleChange,
                    label: "Administrator"
                },
                {
                    isDisabled: !this.props.allowRoleChange,
                    label: "Contributor"
                }
            ]
        }))), this.props.member == null ? (0, _react.jsx)("div", {
            className: inviteStyle
        }, (0, _react.jsx)("div", {
            className: `${inviteSentStyle} ac-invite-sent`
        }, "Invite Sent"), (0, _react.jsx)("img", {
            onClick: ()=>this.props.resendInvitation(),
            className: `${resendMailStyle} ac-invite-resend`,
            src: resendMail
        })) : (0, _react.jsx)((0, _iconCollectionAvatarDefault.default), {
            className: `${appCollectionStyle} ac-members-apps`,
            items: member?.applicationMemberships.map((a)=>{
                var collectionItem;
                collectionItem = {
                    noImageText: `${a.applicationName == null ? "NA" : a.applicationName[0]}`,
                    tooltipText: a.applicationName,
                    imageUrl: a.applicationImageUrl
                };
                return collectionItem;
            }),
            limit: 4
        }), (0, _react.jsx)("div", {
            className: receivesAnalyticsEmailStyle
        }, (0, _react.jsx)(StyledCheckboxField, {
            label: "",
            checked: member.receivesAnalyticsEmail ?? false,
            disabled: this.props.changeReceiveAnalyticsEmail === undefined,
            onChange: (e)=>this.props.changeReceiveAnalyticsEmail()
        })), this.props.allowRemove ? (0, _react.jsx)("img", {
            src: removeIcon,
            className: `${removeIconStyle} ac-member-remove`,
            onClick: this.props.remove
        }) : (0, _react.jsx)("img", {
            src: this.props.allowRoleChange ? removeIcon : removeMemberDisabled,
            className: `${removeIconStyle} ${this.props.allowRoleChange ? "" : "disabled"} ac-member-remove`,
            onClick: this.props.allowRoleChange ? this.props.remove : null
        }));
    }
}
var nameAndIconWidth = "28%";
var emailWidth = "20%";
var roleWidth = "20%";
var appCollectionWidth = "20%";
var receivesAnalyticsWidth = "10%";
const inviteStyle = /*#__PURE__*/ (0, _css.css)({
    name: "1qsu145",
    styles: "display:flex;flex-direction:row;width:20%;margin-right:12px"
});
const resendMailStyle = /*#__PURE__*/ (0, _css.css)({
    name: "1oi7h8n",
    styles: "width:20px;height:20px;margin:15px 16px 0px 8px;cursor:pointer"
});
const copyLinkStyle = /*#__PURE__*/ (0, _css.css)("width:36px;height:32px;border:1px solid ", (0, _colors.color_shades_dark), ";border-radius:4px 0px 0px 4px;border-right:none;background:white;cursor:pointer;margin-top:8px;img{margin-top:5px;margin-left:6px;width:20px;height:20px;}", "");
const inviteSentStyle = /*#__PURE__*/ (0, _css.css)({
    name: "55drez",
    styles: "font-style:italic;font-weight:normal;font-size:14px;line-height:20px;margin:13px 8px 0px 0px"
});
const containerStyle = /*#__PURE__*/ (0, _css.css)("display:flex;flex-direction:row;position:relative;border-bottom:solid 1px ", (0, _colors.color_shades_dark), ";padding:8px 32px;.counts{width:30%;line-height:24px;margin:auto 8px;color:", (0, _colors.color_shades_darker), ";img{margin-right:4px;}}", "");
const overflowMenuStyle = /*#__PURE__*/ (0, _css.css)({
    name: "ugkf4l",
    styles: "width:120px;top:14px;margin-left:0px;left:-8px"
});
const overflowMenuItemStyle = /*#__PURE__*/ (0, _css.css)({
    name: "1n29wzc",
    styles: "height:32px;font-style:normal;font-weight:normal;font-size:12px;line-height:16px"
});
const removeIconStyle = /*#__PURE__*/ (0, _css.css)({
    name: "w14oor",
    styles: "width:24px;height:25px;margin-top:12px;cursor:pointer;&.disabled{cursor:not-allowed;}"
});
const chevronStyle = /*#__PURE__*/ (0, _css.css)({
    name: "584u9k",
    styles: "margin-left:8px;margin-top:6px;margin-right:6px"
});
const nameAndIcon = /*#__PURE__*/ (0, _css.css)("display:flex;flex-direction:row;width:", nameAndIconWidth, ";", "");
const nameStyle = /*#__PURE__*/ (0, _css.css)("font-style:normal;font-weight:normal;font-size:18px;color:", (0, _colors.color_shades_darkest), ";margin:auto 8px;margin-left:16px;", "");
const emailStyle = /*#__PURE__*/ (0, _css.css)("width:", emailWidth, ";font-style:normal;font-weight:normal;font-size:14px;line-height:20px;color:", (0, _colors.color_shades_darkest), ";margin-top:11px;", "");
const roleStyle = /*#__PURE__*/ (0, _css.css)("width:", roleWidth, ";font-style:normal;font-weight:normal;font-size:14px;line-height:20px;color:", (0, _colors.color_shades_darkest), ";margin-top:12px;cursor:pointer;.current-role{position:relative;display:flex;flex-direction:row;}", "");
const appCollectionStyle = /*#__PURE__*/ (0, _css.css)("width:", appCollectionWidth, ";margin-top:auto;margin-bottom:auto;", "");
const receivesAnalyticsEmailStyle = /*#__PURE__*/ (0, _css.css)("width:", receivesAnalyticsWidth, ";", "");
const inviteInput = /*#__PURE__*/ (0, _css.css)("width:202px;height:32px;box-shadow:none;padding:8px 12px;border-radius:0px 4px 4px 0px;border:1px solid ", (0, _colors.color_shades_dark), ";box-sizing:border-box;margin:8px 0px;box-shadow:inset 0px 1px 2px rgba(50, 70, 97, 0.1);", "");
const StyledCheckboxField = /*#__PURE__*/ (0, _baseDefault.default)((0, _checkboxFieldDefault.default), {
    target: "e1kh6r4t0"
})({
    name: "c3gjx4",
    styles: "margin-top:16px;margin-bottom:-10px"
});
exports.default = OrganizationMemberTableItem;

},{"@emotion/styled/base":"lSuFu","@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","../../../constants/colors":"1p3OR","../../../components/general/IconCollectionAvatar":"j0zcR","../../../components/general/UserAvatar":"avuDP","../../../components/general/ToggleIndicator":"4eej1","../../../components/general/overflowMenu/OverflowMenu":"2V2SB","../../../components/forms/CheckboxField":"3S5Oy","3d2db40c6b5b62a8":"beC9C","d582c9f996e81850":"lzRgz","a99be954234cb31d":"1jL91","9d62426d78332f69":"aoSZS","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"beC9C":[function(require,module,exports) {
module.exports = require("a06871a666dd4f4c").getBundleURL("kVLro") + require("6257f7a227fd3fe4").resolve("5a9Y1");

},{"a06871a666dd4f4c":"c7Tr5","6257f7a227fd3fe4":"fyJL2"}],"1XvZK":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _unstated = require("unstated");
var _organizationContainer = require("../../state/containers/OrganizationContainer");
var _organizationContainerDefault = parcelHelpers.interopDefault(_organizationContainer);
var _mediaContainer = require("../../state/containers/MediaContainer");
var _mediaContainerDefault = parcelHelpers.interopDefault(_mediaContainer);
var _deploymentAccountsContainer = require("../../state/containers/DeploymentAccountsContainer");
var _deploymentAccountsContainerDefault = parcelHelpers.interopDefault(_deploymentAccountsContainer);
var _apiKeyContainer = require("../../state/containers/ApiKeyContainer");
var _apiKeyContainerDefault = parcelHelpers.interopDefault(_apiKeyContainer);
var _memberContainer = require("../../state/containers/MemberContainer");
var _memberContainerDefault = parcelHelpers.interopDefault(_memberContainer);
var _userContainer = require("../../state/containers/UserContainer");
var _userContainerDefault = parcelHelpers.interopDefault(_userContainer);
var _applicationContainer = require("../../state/containers/ApplicationContainer");
var _applicationContainerDefault = parcelHelpers.interopDefault(_applicationContainer);
var _appliedApplicationTemplateContainer = require("../../state/containers/AppliedApplicationTemplateContainer");
var _appliedApplicationTemplateContainerDefault = parcelHelpers.interopDefault(_appliedApplicationTemplateContainer);
var _applicationEnvironmentsContainer = require("../../state/containers/ApplicationEnvironmentsContainer");
var _applicationEnvironmentsContainerDefault = parcelHelpers.interopDefault(_applicationEnvironmentsContainer);
var _organizationSettingsTabs = require("./components/OrganizationSettingsTabs");
var _organizationSettingsTabsDefault = parcelHelpers.interopDefault(_organizationSettingsTabs);
const OrganizationSettings = (props)=>(0, _react.jsx)((0, _unstated.Subscribe), {
        to: [
            (0, _organizationContainerDefault.default),
            (0, _mediaContainerDefault.default),
            (0, _deploymentAccountsContainerDefault.default),
            (0, _apiKeyContainerDefault.default),
            (0, _memberContainerDefault.default),
            (0, _userContainerDefault.default),
            (0, _applicationContainerDefault.default),
            (0, _appliedApplicationTemplateContainerDefault.default),
            (0, _applicationEnvironmentsContainerDefault.default)
        ]
    }, (orgContainer, mediaContainer, deploymentContainer, apiKeyContainer, memberContainer, userContainer, applicationContainer, appliedTemplateContainer, applicationEnvironmentsContainer)=>{
        return (0, _react.jsx)((0, _organizationSettingsTabsDefault.default), {
            history: props.history,
            orgContainer: orgContainer,
            mediaContainer: mediaContainer,
            memberContainer: memberContainer,
            deploymentContainer: deploymentContainer,
            apiKeyContainer: apiKeyContainer,
            userContainer: userContainer,
            applicationContainer: applicationContainer,
            appliedTemplateContainer: appliedTemplateContainer,
            applicationEnvironmentsContainer: applicationEnvironmentsContainer
        });
    });
exports.default = OrganizationSettings;

},{"@emotion/react":"djZKr","react":"6uln9","unstated":"grh7p","../../state/containers/OrganizationContainer":"dlbaM","../../state/containers/MediaContainer":"ch6Xu","../../state/containers/DeploymentAccountsContainer":"h0NaQ","../../state/containers/ApiKeyContainer":"5kgHP","../../state/containers/MemberContainer":"iYQOb","../../state/containers/UserContainer":"jDrDR","../../state/containers/ApplicationContainer":"cuqi2","../../state/containers/AppliedApplicationTemplateContainer":"3XuX7","../../state/containers/ApplicationEnvironmentsContainer":"jCULY","./components/OrganizationSettingsTabs":"g3268","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"h0NaQ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _defineProperty = require("@babel/runtime/helpers/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _unstated = require("unstated");
var _api = require("../../api");
var _lodash = require("lodash");
var _lodashDefault = parcelHelpers.interopDefault(_lodash);
class DeploymentAccountsContainer extends (0, _unstated.Container) {
    constructor(...args){
        super(...args);
        (0, _definePropertyDefault.default)(this, "state", {
            accountToApplicationLinks: [],
            errors: []
        });
    }
    reset() {
        this.setState({
            errors: [],
            accountToApplicationLinks: []
        });
    }
    async updateDeploymentAccountLinksToApplications(organizationId) {
        try {
            this.reset();
            let linksByPlatform = [];
            const amazonLinksPromise = _api.getApplicationsLinkedToAmazon(organizationId);
            const dialogFlowLinksPromise = _api.getApplicationsLinkedToDialogflow(organizationId);
            const results = await Promise.all([
                amazonLinksPromise,
                dialogFlowLinksPromise
            ]);
            results.forEach((r)=>{
                if (r.resultType == "Ok") r.data?.forEach((link)=>{
                    const existingLink = linksByPlatform.find((l)=>l.id == link.id);
                    if (existingLink) existingLink.applicationIds = [
                        ...new Set([
                            ...existingLink.applicationIds,
                            ...link.applicationIds
                        ])
                    ];
                    else linksByPlatform.push(link);
                });
            });
            if (linksByPlatform?.length > 0) this.setState({
                ...this.state,
                accountToApplicationLinks: linksByPlatform
            });
        } catch (err) {
            this.setState({
                ...this.state,
                errors: [
                    err.toString()
                ]
            });
        }
    }
    getAmazonAuthUrl(request) {
        return _api.getAmazonAuthUrl(request).then((results)=>{
            if (results.resultType != "Ok") this.setState({
                ...this.state,
                errors: results.errors
            });
            else return results.data;
        }).catch((err)=>{
            this.setState({
                ...this.state,
                errors: err
            });
        });
    }
    getGoogleAuthUrl(request) {
        return _api.getDialogflowAuthUrl(request).then((results)=>{
            if (results.resultType != "Ok") this.setState({
                ...this.state,
                errors: results.errors
            });
            else return results.data;
        }).catch((err)=>{
            this.setState({
                ...this.state,
                errors: err
            });
        });
    }
    removeGoogleCredentials(tokenId) {
        if (!tokenId) return;
        const links = this.state.accountToApplicationLinks;
        (0, _lodashDefault.default).remove(links, (l)=>l.id === tokenId);
        // This is used for either Google Actions Builder or Dialogflow to remove Google account by tokenId
        return _api.removeGoogleCredentials(tokenId).then((results)=>{
            if (results.resultType == "Ok") {
                this.setState({
                    ...this.state,
                    accountToApplicationLinks: links
                });
                return results;
            } else this.setState({
                ...this.state,
                errors: results.errors
            });
        }).catch((err)=>{
            this.setState({
                ...this.state,
                errors: err
            });
        });
    }
    removeAmazonCredentials(tokenId) {
        if (!tokenId) return;
        const links = this.state.accountToApplicationLinks;
        (0, _lodashDefault.default).remove(links, (l)=>l.id === tokenId);
        this.setState({
            ...this.state,
            accountToApplicationLinks: links
        });
        return _api.removeAmazonCredentials(tokenId).then((results)=>{
            if (results.resultType == "Ok") {
                this.setState({
                    ...this.state,
                    accountToApplicationLinks: links
                });
                return results;
            } else this.setState({
                ...this.state,
                errors: results.errors
            });
        }).catch((err)=>{
            this.setState({
                ...this.state,
                errors: err
            });
        });
    }
}
exports.default = DeploymentAccountsContainer;

},{"@babel/runtime/helpers/defineProperty":"9sJxO","unstated":"grh7p","../../api":"loxM6","lodash":"3hMBK","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"5kgHP":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _defineProperty = require("@babel/runtime/helpers/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _unstated = require("unstated");
var _api = require("../../api");
class ApiKeyContainer extends (0, _unstated.Container) {
    constructor(...args){
        super(...args);
        // default state
        (0, _definePropertyDefault.default)(this, "state", this.getInitialState());
    }
    getInitialState() {
        return {
            isLoading: false,
            apiKeys: [],
            errors: []
        };
    }
    async loadOrganizationApiKeys(organizationId) {
        try {
            await this.setLoading(true);
            var result = await _api.getOrganizationApiKeys(organizationId);
            if (result.resultType == "Ok") await this.setState({
                ...this.state,
                isLoading: false,
                apiKeys: result.data
            });
            else await this.setState({
                ...this.state,
                isLoading: false,
                errors: result.errors
            });
            return result;
        } catch (error) {
            await this.setState({
                ...this.state,
                isLoading: false,
                errors: [
                    error
                ]
            });
            return {
                resultType: "InternalError",
                data: null,
                errors: [
                    error
                ]
            };
        }
    }
    async createOrgAdminApiKey(organizationId, request) {
        try {
            await this.setLoading(true);
            var result = await _api.createOrganizationAdminApiKey(organizationId, request);
            if (result.resultType == "Ok") await this.setLoading(false);
            else await this.setState({
                ...this.state,
                isLoading: false,
                errors: result.errors
            });
            return result;
        } catch (error) {
            await this.setState({
                ...this.state,
                isLoading: false,
                errors: [
                    error
                ]
            });
            return {
                resultType: "InternalError",
                data: null,
                errors: [
                    error
                ]
            };
        }
    }
    async deleteApiKey(apiKeyId) {
        try {
            await this.setLoading(true);
            var result = await _api.deleteApiKey(apiKeyId);
            if (result.resultType == "Ok") {
                let apiKeys = this.state.apiKeys;
                const existingIdx = apiKeys.findIndex((a)=>a.id == apiKeyId);
                if (existingIdx > -1) {
                    apiKeys.splice(existingIdx, 1);
                    await this.setState({
                        ...this.state,
                        apiKeys: apiKeys,
                        isLoading: false
                    });
                } else await this.setLoading(false);
            } else await this.setState({
                ...this.state,
                isLoading: false,
                errors: result.errors
            });
            return result;
        } catch (error) {
            await this.setState({
                ...this.state,
                isLoading: false,
                errors: [
                    error
                ]
            });
            return {
                resultType: "InternalError",
                data: null,
                errors: [
                    error
                ]
            };
        }
    }
    async setLoading(isLoading) {
        await this.setState({
            ...this.state,
            isLoading: isLoading
        });
    }
}
exports.default = ApiKeyContainer;

},{"@babel/runtime/helpers/defineProperty":"9sJxO","unstated":"grh7p","../../api":"loxM6","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3XuX7":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _defineProperty = require("@babel/runtime/helpers/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _unstated = require("unstated");
var _api = require("../../api");
var _lodash = require("lodash");
var _lodashDefault = parcelHelpers.interopDefault(_lodash);
class AppliedApplicationTemplateContainer extends (0, _unstated.Container) {
    constructor(...args){
        super(...args);
        // Track original values for change detection
        (0, _definePropertyDefault.default)(this, "originalValuesMap", new Map());
        // default state
        (0, _definePropertyDefault.default)(this, "state", {
            appliedTemplates: [],
            perApplicationAppliedTemplates: [],
            isLoading: false,
            isSaving: false,
            isWaitingForTemplateSync: true,
            errors: [],
            templateSyncErrors: [],
            appliedTemplateSyncId: null,
            multipleTemplateSyncsStatus: "none"
        });
    }
    loadAppliedTemplates(applicationId) {
        this.setLoading(true);
        const promise = _api.getAppliedApplicationTemplatesForApp(applicationId);
        promise.then((result)=>{
            if (result.resultType == "Ok") {
                const appliedForms = result.data;
                appliedForms.forEach((appliedForm)=>{
                    // find applied forms with dynamic form urls and create the values cache. 
                    if (appliedForm.templateForm.templateConfiguration.dynamicFormUrl) {
                        const allValues = appliedForm.templateFormFieldValues;
                        if (allValues && allValues.length > 0) {
                            const dynamicValues = allValues.filter((v)=>v.dynamicFormFieldId || v.dynamicFormFieldName) ?? [];
                            const standardValues = allValues.filter((v)=>v.templateFormFieldId) ?? [];
                            appliedForm.templateFormFieldValues = standardValues;
                            appliedForm.dynamicFormFieldValuesCache = dynamicValues; // values cache will be used when we add dynamic sections
                        }
                    }
                    // apply form field info to existing values
                    appliedForm.templateForm?.templateFormSections.forEach((section)=>{
                        section?.templateFormFields?.forEach((field)=>{
                            const value = appliedForm.templateFormFieldValues.find((v)=>v.templateFormFieldId == field.id);
                            if (value) {
                                value.fieldType = field.fieldType;
                                value.associatedVariable = field.associatedVariable;
                                value.label = field.label;
                                value.tip = field.tip;
                                value.title = field.title;
                                value.placeholder = field.placeholder;
                                value.defaultValue = field.defaultValue;
                            }
                        });
                    });
                    // Store original values for change detection
                    this.captureOriginalValues(appliedForm.id, appliedForm.templateFormFieldValues);
                });
                const applicationAppliedTemplates = {
                    applicationId: applicationId,
                    appliedTemplates: appliedForms
                };
                const newPerApp = this.state.perApplicationAppliedTemplates.filter((m)=>m.applicationId != applicationId);
                this.setState({
                    ...this.state,
                    isLoading: false,
                    appliedTemplates: appliedForms,
                    perApplicationAppliedTemplates: [
                        ...newPerApp,
                        applicationAppliedTemplates
                    ],
                    errors: []
                });
            } else this.setState({
                ...this.state,
                isLoading: false,
                errors: result.errors
            });
        }).catch((e)=>{
            this.setState({
                ...this.state,
                isLoading: false,
                errors: [
                    e?.toString()
                ]
            });
        });
        return promise;
    }
    /**
   * Capture original values for change detection
   */ captureOriginalValues(appliedTemplateId, values) {
        this.originalValuesMap.set(appliedTemplateId, JSON.parse(JSON.stringify(values || [])));
    }
    /**
   * Get original values for a template
   */ getOriginalValues(appliedTemplateId) {
        return this.originalValuesMap.get(appliedTemplateId) || [];
    }
    /**
   * Get all original values for all templates (used by Spark)
   */ getAllOriginalValues() {
        const allValues = [];
        this.originalValuesMap.forEach((values)=>{
            allValues.push(...values);
        });
        return allValues;
    }
    /**
   * Calculate changes in modal-friendly format
   * Returns array of changed fields with before/after values
   */ getChangedFieldsForDisplay(appliedTemplateId, currentValues) {
        const originalValues = this.originalValuesMap.get(appliedTemplateId) || [];
        const changes = [];
        // Check for modified and added fields
        currentValues?.forEach((currentField)=>{
            let originalField = null;
            // Try to find matching original field
            if (currentField.id) originalField = originalValues.find((v)=>v.id === currentField.id);
            else if (currentField.templateFormFieldId) originalField = originalValues.find((v)=>v.templateFormFieldId === currentField.templateFormFieldId && v.appliedApplicationTemplateId === currentField.appliedApplicationTemplateId);
            else if (currentField.dynamicFormFieldName) originalField = originalValues.find((v)=>v.dynamicFormFieldName === currentField.dynamicFormFieldName);
            const fieldName = currentField.title || currentField.label || currentField.dynamicFormFieldName || "Untitled Field";
            if (!originalField) // Field was added
            {
                if (currentField.value && currentField.value.trim() !== "") changes.push({
                    fieldName,
                    oldValue: "",
                    newValue: currentField.value,
                    state: "Added"
                });
            } else if (originalField.value !== currentField.value) // Field was modified
            changes.push({
                fieldName,
                oldValue: originalField.value || "",
                newValue: currentField.value || "",
                state: "Modified"
            });
        });
        // Check for removed fields
        originalValues?.forEach((originalField)=>{
            let currentField = null;
            // Try to find matching current field
            if (originalField.id) currentField = currentValues.find((v)=>v.id === originalField.id);
            else if (originalField.templateFormFieldId) currentField = currentValues.find((v)=>v.templateFormFieldId === originalField.templateFormFieldId && v.appliedApplicationTemplateId === originalField.appliedApplicationTemplateId);
            else if (originalField.dynamicFormFieldName) currentField = currentValues.find((v)=>v.dynamicFormFieldName === originalField.dynamicFormFieldName);
            if (!currentField && originalField.value && originalField.value.trim() !== "") {
                const fieldName = originalField.title || originalField.label || originalField.dynamicFormFieldName || "Untitled Field";
                changes.push({
                    fieldName,
                    oldValue: originalField.value,
                    newValue: "",
                    state: "Removed"
                });
            }
        });
        return changes;
    }
    /**
   * Calculate changes for multiple templates (Spark)
   */ getAllChangedFieldsForDisplay(currentValuesByTemplate) {
        const allChanges = [];
        currentValuesByTemplate.forEach((currentValues, templateId)=>{
            const changes = this.getChangedFieldsForDisplay(templateId, currentValues);
            allChanges.push(...changes);
        });
        return allChanges;
    }
    /**
   * Detect which fields have been modified
   */ getModifiedFields(appliedTemplateId, currentValues) {
        const originalValues = this.originalValuesMap.get(appliedTemplateId) || [];
        const modifiedFields = [];
        currentValues?.forEach((currentField)=>{
            let originalField = null;
            // Try to find matching original field
            if (currentField.id) originalField = originalValues.find((v)=>v.id === currentField.id);
            else if (currentField.templateFormFieldId) originalField = originalValues.find((v)=>v.templateFormFieldId === currentField.templateFormFieldId && v.appliedApplicationTemplateId === currentField.appliedApplicationTemplateId);
            else if (currentField.dynamicFormFieldName) originalField = originalValues.find((v)=>v.dynamicFormFieldName === currentField.dynamicFormFieldName);
            // If no original or value changed, it's modified
            if (!originalField || originalField.value !== currentField.value) modifiedFields.push(currentField);
        });
        return modifiedFields;
    }
    async updateAppliedTemplate(appliedTemplateId, model) {
        try {
            await this.setSaving(true);
            const result = await _api.updateAppliedApplicationTemplate(appliedTemplateId, model);
            if (result.resultType == "Ok") {
                const appliedTemplates = this.state.appliedTemplates;
                const existingAppliedTemplate = appliedTemplates.find((m)=>m.id == appliedTemplateId);
                if (existingAppliedTemplate != null) appliedTemplates[appliedTemplates.indexOf(existingAppliedTemplate)] = result.data;
                else appliedTemplates.push(result.data);
                await this.setState({
                    ...this.state,
                    isSaving: false,
                    appliedTemplates,
                    errors: []
                });
            } else await this.setState({
                ...this.state,
                isSaving: false,
                errors: result.errors
            });
            return result;
        } catch (e) {
            await this.setState({
                ...this.state,
                isSaving: false,
                errors: [
                    e?.toString()
                ]
            });
        }
    }
    async insertDynamicFormSection(appliedTemplateId, dynamicFormSection, finishedSection) {
        // first find applied template
        const appliedTemplates = this.state.appliedTemplates;
        const appliedTemplate = appliedTemplates.find((m)=>m.id == appliedTemplateId);
        if (!appliedTemplate) return;
        // add dynamic section as next section to fill out
        let sections = [
            ...appliedTemplate.templateForm.templateFormSections
        ];
        dynamicFormSection.priority = finishedSection.priority + .0001;
        sections.push(dynamicFormSection);
        sections = (0, _lodashDefault.default).sortBy(sections, (s)=>s.priority);
        // find any values in our dynamic values cache that we have for the fields in this dynamic section
        var values = appliedTemplate.templateFormFieldValues;
        var dynamicValuesCache = appliedTemplate.dynamicFormFieldValuesCache;
        dynamicFormSection.dynamicFormFields.forEach((f)=>{
            var cachedValue = dynamicValuesCache?.find((v)=>f.name && v.dynamicFormFieldName == f.name);
            if (cachedValue) values.push(cachedValue);
        });
        // update applied template and set state
        appliedTemplates[appliedTemplates.indexOf(appliedTemplate)].templateForm.templateFormSections = sections;
        appliedTemplates[appliedTemplates.indexOf(appliedTemplate)].templateFormFieldValues = values;
        await this.setState({
            ...this.state,
            appliedTemplates
        });
        return dynamicFormSection;
    }
    async removeDynamicFormSection(appliedTemplateId, sectionName) {
        // first find applied template
        const appliedTemplates = this.state.appliedTemplates;
        const appliedTemplate = appliedTemplates.find((m)=>m.id == appliedTemplateId);
        if (!appliedTemplate) return;
        // remove the dynamic section
        let sections = [
            ...appliedTemplate.templateForm.templateFormSections
        ];
        let sectionIndex = sections.findIndex((s)=>s.name == sectionName);
        sections.splice(sectionIndex, 1);
        // update applied template and set state
        appliedTemplates[appliedTemplates.indexOf(appliedTemplate)].templateForm.templateFormSections = sections;
        await this.setState({
            ...this.state,
            appliedTemplates
        });
    }
    finishFormSection(appliedTemplateId, model) {
        try {
            const appliedTemplates = this.state.appliedTemplates;
            const appliedTemplate = appliedTemplates.find((m)=>m.id == appliedTemplateId);
            model.fieldValues = this.stripValuesNotInSections(appliedTemplate, model.fieldValues);
            // if there's no existing applied template something went wrong. 
            if (appliedTemplate == null) {
                this.setState({
                    ...this.state,
                    isSaving: false,
                    errors: [
                        "No applied template loaded"
                    ]
                });
                return;
            }
            appliedTemplates[appliedTemplates.indexOf(appliedTemplate)].templateFormFieldValues = model.fieldValues;
        } catch (e) {
            this.setState({
                ...this.state,
                isSaving: false,
                errors: [
                    e?.toString()
                ]
            });
        }
    }
    /**
   * UNIFIED SAVE METHOD - Consolidates saveForm, finalizeForm, and finalizeForms
   * Handles both intermediate saves and final synchronization
   */ async saveTemplateFields(applicationId, appliedTemplateId, currentFieldValues, options) {
        this.setSaving(true);
        try {
            const appliedTemplates = this.state.appliedTemplates;
            const appliedTemplate = appliedTemplates.find((m)=>m.id === appliedTemplateId);
            if (!appliedTemplate) {
                await this.setState({
                    ...this.state,
                    isSaving: false,
                    errors: [
                        "No applied template loaded"
                    ]
                });
                return {
                    resultType: "Error",
                    errors: [
                        "No applied template loaded"
                    ]
                };
            }
            let fieldValuesToSave = currentFieldValues;
            // If using modified fields only, fetch latest and merge
            if (options?.useModifiedFieldsOnly) {
                const modifiedFields = this.getModifiedFields(appliedTemplateId, currentFieldValues);
                if (modifiedFields.length > 0) {
                    const latestTemplateResult = await _api.findAppliedApplicationTemplate(appliedTemplateId);
                    if (latestTemplateResult.resultType === "Ok") fieldValuesToSave = this.mergeModifiedFields(latestTemplateResult.data.templateFormFieldValues, modifiedFields);
                }
            }
            const strippedFieldValues = this.stripValuesNotInSections(appliedTemplate, fieldValuesToSave);
            // Prepare the update request
            const updateRequest = {
                ...appliedTemplate,
                templateFormFieldValues: strippedFieldValues,
                dynamicFormSections: appliedTemplate.templateForm.templateFormSections.filter((s)=>s?.name),
                publishToEnvironmentId: options?.publishToEnvironmentId
            };
            // If finalize is requested, go directly to sync (Voicify & Spark pattern)
            // The sync endpoint handles both updating and syncing in one call
            if (options?.finalize) {
                const isConcurrentSync = !!options?.concurrentSyncKey;
                await this.setState({
                    ...this.state,
                    appliedTemplates,
                    isWaitingForTemplateSync: true,
                    multipleTemplateSyncsStatus: isConcurrentSync ? "syncing" : "none",
                    templateSyncErrors: [],
                    errors: []
                });
                let syncResult;
                if (appliedTemplate.templateForm.templateConfiguration.finalizeFormUrl) {
                    const request = {
                        applicationId: applicationId,
                        data: updateRequest
                    };
                    syncResult = await _api.finalizeDynamicForm(appliedTemplateId, request);
                } else // This endpoint does: PUT UpdateAppliedApplicationTemplateForm (updates + syncs)
                syncResult = await _api.queueUpdateApplicationFromTemplateFormsSync(applicationId, appliedTemplateId, updateRequest);
                if (syncResult.resultType === "Ok") {
                    if (syncResult.data.errors && syncResult.data.errors.length > 0) {
                        await this.setState({
                            ...this.state,
                            isSaving: false,
                            isWaitingForTemplateSync: false,
                            multipleTemplateSyncsStatus: isConcurrentSync ? "error" : "none",
                            templateSyncErrors: syncResult.data.errors
                        });
                        return {
                            resultType: "Ok",
                            data: appliedTemplate
                        };
                    } else if (!syncResult.data.appliedTemplateSyncId && !syncResult.data.id) {
                        await this.setState({
                            ...this.state,
                            isSaving: false,
                            isWaitingForTemplateSync: false,
                            multipleTemplateSyncsStatus: isConcurrentSync ? "success" : "none",
                            templateSyncErrors: []
                        });
                        return {
                            resultType: "Ok",
                            data: appliedTemplate
                        };
                    } else {
                        await this.setState({
                            ...this.state,
                            appliedTemplateSyncId: syncResult.data.appliedTemplateSyncId || syncResult.data.id,
                            isSaving: false,
                            templateSyncErrors: []
                        });
                        // Wait for sync to complete in the background
                        this.waitForSyncToComplete();
                        // Return sync result with the sync ID
                        return syncResult;
                    }
                } else {
                    await this.setState({
                        ...this.state,
                        isSaving: false,
                        isWaitingForTemplateSync: false,
                        multipleTemplateSyncsStatus: isConcurrentSync ? "error" : "none",
                        templateSyncErrors: syncResult.errors
                    });
                    return syncResult;
                }
            } else {
                // Not finalizing - just a regular save (intermediate save)
                // This does a PUT to update the template without syncing
                const updateResult = await _api.updateAppliedApplicationTemplate(appliedTemplateId, updateRequest);
                if (updateResult.resultType !== "Ok") {
                    await this.setState({
                        ...this.state,
                        isSaving: false,
                        errors: updateResult.errors
                    });
                    return updateResult;
                }
                // Update local state
                const index = appliedTemplates.indexOf(appliedTemplate);
                appliedTemplates[index] = updateResult.data;
                // Update original values after successful save
                this.captureOriginalValues(appliedTemplateId, updateResult.data.templateFormFieldValues);
                await this.setState({
                    ...this.state,
                    appliedTemplates,
                    isSaving: false,
                    errors: []
                });
                return updateResult;
            }
        } catch (e) {
            await this.setState({
                ...this.state,
                isSaving: false,
                isWaitingForTemplateSync: false,
                errors: [
                    e?.toString()
                ]
            });
            return {
                resultType: "Error",
                errors: [
                    e?.toString()
                ]
            };
        }
    }
    /**
   * Helper method to merge modified fields with latest values
   */ mergeModifiedFields(latestValues, modifiedFields) {
        const modifiedFieldsMap = new Map();
        modifiedFields.forEach((field)=>{
            const key = this.getFieldKey(field);
            if (key) modifiedFieldsMap.set(key, field);
        });
        // Start with latest values, replace with modifications
        const merged = latestValues.map((latestField)=>{
            const key = this.getFieldKey(latestField);
            const modifiedField = modifiedFieldsMap.get(key);
            return modifiedField || latestField;
        });
        // Add any new fields
        modifiedFields.forEach((modifiedField)=>{
            const key = this.getFieldKey(modifiedField);
            const existsInLatest = latestValues.some((latestField)=>this.getFieldKey(latestField) === key);
            if (!existsInLatest) merged.push(modifiedField);
        });
        return merged;
    }
    /**
   * Generate a unique key for field matching
   */ getFieldKey(field) {
        if (field.id) return `id:${field.id}`;
        else if (field.templateFormFieldId) {
            let key = `templateFormFieldId:${field.templateFormFieldId}`;
            if (field.appliedApplicationTemplateId) key += `:appliedAppId:${field.appliedApplicationTemplateId}`;
            return key;
        } else if (field.dynamicFormFieldName) return `dynamicFormFieldName:${field.dynamicFormFieldName}`;
        return "";
    }
    syncronousUpdateApplicationFromAppliedTemplate(applicationId, appliedTemplateId, model) {
        this.setSaving(true);
        const appliedTemplate = this.state.appliedTemplates.find((m)=>m.id == appliedTemplateId);
        model.dynamicFormSections = appliedTemplate.templateForm.templateFormSections.filter((s)=>s?.name);
        const promise = _api.updateApplicationFromTemplateForms(applicationId, appliedTemplateId, model);
        promise.then((result)=>{
            if (result.resultType == "Ok") this.setState({
                ...this.state,
                isSaving: false,
                errors: []
            });
            else this.setState({
                ...this.state,
                isSaving: false,
                errors: result.errors
            });
        }).catch((e)=>{
            this.setState({
                ...this.state,
                isSaving: false,
                errors: [
                    e?.toString()
                ]
            });
        });
        return promise;
    }
    stripValuesNotInSections(appliedTemplate, values) {
        const updatedValues = [];
        appliedTemplate.templateForm.templateFormSections?.forEach((section)=>{
            const fields = section.dynamicFormFields && section.dynamicFormFields.length > 0 ? section.dynamicFormFields : section.templateFormFields;
            fields?.forEach((field)=>{
                if (field.name) {
                    const value = values.find((v)=>v.dynamicFormFieldName == field.name);
                    if (value) updatedValues.push(value);
                } else {
                    const value = values.find((v)=>v.templateFormFieldId == field.id);
                    if (value) updatedValues.push(value);
                }
            });
        });
        return updatedValues;
    }
    async waitForSyncToComplete() {
        try {
            if (!this.state.appliedTemplateSyncId) {
                await this.setState({
                    ...this.state,
                    isWaitingForTemplateSync: false,
                    appliedTemplateSyncId: null,
                    multipleTemplateSyncsStatus: "error",
                    templateSyncErrors: [
                        "We couldn't start syncing your assistant because the server didn't provide a tracking ID for this sync request. Your changes may not have been saved. Please try saving again in a few minutes. If the problem persists, contact Voicify support with the time this occurred."
                    ]
                });
                return;
            }
            // Store the sync ID to poll - don't rely on state in the loop
            const syncIdToMonitor = this.state.appliedTemplateSyncId;
            let continuePolling = true;
            // Add timeout to prevent infinite polling (5 minutes max)
            const maxPollingTime = 300000; // 5 minutes in milliseconds
            const startTime = Date.now();
            while(continuePolling){
                // Check if we've exceeded the max polling time
                if (Date.now() - startTime > maxPollingTime) {
                    await this.setState({
                        ...this.state,
                        isWaitingForTemplateSync: false,
                        appliedTemplateSyncId: null,
                        multipleTemplateSyncsStatus: "error",
                        templateSyncErrors: [
                            "Voicify is currently experiencing high sync volume or a temporary technical issue, and your sync request timed out after 5 minutes. Please try again in a few minutes. If the issue continues, reach out to your Voicify contact for support."
                        ]
                    });
                    return;
                }
                // Check if sync was cancelled (state was cleared)
                if (!this.state.appliedTemplateSyncId || this.state.appliedTemplateSyncId !== syncIdToMonitor) {
                    // User navigated away or sync was cancelled
                    continuePolling = false;
                    return;
                }
                const result = await _api.getAppliedTemplateSync(syncIdToMonitor);
                if (result.resultType == "Ok") {
                    const sync = result.data;
                    switch(sync.stage){
                        case "Processing":
                        case "Queued":
                            // Still processing, wait and continue polling
                            // Using 5 seconds to balance responsiveness with API load
                            await new Promise((r)=>setTimeout(r, 5000));
                            break;
                        case "Complete":
                            // Sync complete - stop polling
                            continuePolling = false;
                            if (sync.error) await this.setState({
                                ...this.state,
                                isWaitingForTemplateSync: false,
                                appliedTemplateSyncId: null,
                                multipleTemplateSyncsStatus: "error",
                                templateSyncErrors: [
                                    sync.error
                                ]
                            });
                            else await this.setState({
                                ...this.state,
                                isWaitingForTemplateSync: false,
                                appliedTemplateSyncId: null,
                                multipleTemplateSyncsStatus: "success",
                                errors: []
                            });
                            break;
                        default:
                            // Unknown stage - stop polling with error
                            continuePolling = false;
                            await this.setState({
                                ...this.state,
                                isWaitingForTemplateSync: false,
                                appliedTemplateSyncId: null,
                                multipleTemplateSyncsStatus: "error",
                                templateSyncErrors: [
                                    "We ran into an unexpected issue while syncing your assistant. Please try again in a few minutes. If the issue continues, reach out to your Voicify contact for support."
                                ]
                            });
                    }
                } else {
                    // API error - stop polling
                    continuePolling = false;
                    await this.setState({
                        ...this.state,
                        isWaitingForTemplateSync: false,
                        appliedTemplateSyncId: null,
                        multipleTemplateSyncsStatus: "error",
                        templateSyncErrors: result.errors
                    });
                }
            }
        } catch (e) {
            await this.setState({
                ...this.state,
                isSaving: false,
                isWaitingForTemplateSync: false,
                multipleTemplateSyncsStatus: "error",
                templateSyncErrors: [
                    e?.toString()
                ]
            });
        }
    }
    async addAppliedTemplateToApp(applicationId, templateConfigId) {
        try {
            await this.setSaving(true);
            const result = await _api.addAppliedApplicationTemplate(applicationId, templateConfigId);
            if (result.resultType == "Ok") {
                const appliedTemplates = this.state.appliedTemplates;
                appliedTemplates.push(result.data);
                await this.setState({
                    ...this.state,
                    appliedTemplates,
                    isSaving: false,
                    errors: []
                });
            } else await this.setState({
                ...this.state,
                isSaving: false,
                errors: result.errors
            });
            return result;
        } catch (e) {
            await this.setState({
                ...this.state,
                isSaving: false,
                errors: [
                    e?.toString()
                ]
            });
        }
    }
    async autoGenerateAppliedApplicationTemplateFieldValues(applicationId, request) {
        try {
            await this.setSaving(true);
            const result = await _api.autoGenerateAppliedApplicationTemplateFieldValues(applicationId, request);
            if (result.resultType == "Ok") {
                const updatedAppliedTemplates = result.data;
                const errorsList = [];
                for (const updatedAppliedTemplate of updatedAppliedTemplates){
                    const appliedTemplateToReplaceIndex = this.state.appliedTemplates.findIndex((m)=>m.id == updatedAppliedTemplate.id);
                    if (appliedTemplateToReplaceIndex > -1) this.state.appliedTemplates[appliedTemplateToReplaceIndex] = updatedAppliedTemplate;
                    else errorsList.push(`Unable to find applied template with id ${updatedAppliedTemplate.id}`);
                }
                await this.setState({
                    ...this.state,
                    appliedTemplates: this.state.appliedTemplates,
                    isSaving: false,
                    errors: errorsList
                });
            }
            return result;
        } catch (e) {
            this.setState({
                ...this.state,
                isSaving: false,
                errors: [
                    e?.toString()
                ]
            });
        }
    }
    removeAppliedTemplate(applicationId, appliedTemplateId, successCallback) {
        this.setSaving(true);
        const promise = _api.removeAppliedApplicationTemplate(applicationId, appliedTemplateId);
        promise.then((result)=>{
            if (result.resultType == "Ok") this.setState({
                ...this.state,
                errors: [],
                isSaving: false
            }).then(()=>successCallback(result));
            else this.setState({
                ...this.state,
                errors: result.errors,
                isSaving: false
            });
        }).catch((e)=>{
            this.setState({
                ...this.state,
                errors: [
                    e?.toString()
                ],
                isSaving: false
            });
        });
        return promise;
    }
    getLoadedTemplatesForApp(applicationId) {
        return this.state.appliedTemplates?.filter((t)=>t.appliedApplicationId == applicationId) ?? [];
    }
    getCurrentStatus(appliedTemplate) {
        if (!appliedTemplate) return "not-enabled";
        const incompleteSections = this.getIncompleteSections(appliedTemplate);
        if (incompleteSections.length > 0) return "incomplete";
        if (appliedTemplate?.lastSyncedDate) return "synced";
        return "complete";
    }
    getIsSectionOfCurrentComplete(appliedTemplate, section) {
        if (!appliedTemplate || !section) return false;
        const currentSection = appliedTemplate?.templateForm?.templateFormSections?.find((s)=>section?.name && s?.name == section?.name || section?.id && s?.id == section?.id);
        let fields = currentSection?.templateFormFields;
        if (!fields) fields = currentSection?.dynamicFormFields;
        const values = appliedTemplate?.templateFormFieldValues;
        if (!fields) return false;
        let isComplete = true;
        fields.forEach((field)=>{
            if (field?.isRequired) {
                const value = values?.find((v)=>field?.id && field.id == v.templateFormFieldId || field?.name && field.name == v.dynamicFormFieldName);
                // A field is incomplete if the value is missing, null, undefined, an empty string, or only whitespace
                if (!value || value.value === null || value.value === undefined || value.value === "" || value.value.trim() === "") isComplete = false;
            }
        });
        return isComplete;
    }
    getIncompleteSections(appliedTemplate) {
        return appliedTemplate?.templateForm?.templateFormSections?.filter((s)=>!this.getIsSectionOfCurrentComplete(appliedTemplate, s)) ?? [];
    }
    clearErrors() {
        this.setState({
            ...this.state,
            errors: []
        });
    }
    setLoading(isLoading) {
        this.setState({
            ...this.state,
            isLoading
        });
    }
    async setSaving(isSaving) {
        await this.setState({
            ...this.state,
            isSaving
        });
    }
}
exports.default = AppliedApplicationTemplateContainer;

},{"@babel/runtime/helpers/defineProperty":"9sJxO","unstated":"grh7p","../../api":"loxM6","lodash":"3hMBK","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"g3268":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _tabContainerPanel = require("../../../components/structure/Panels/TabContainerPanel");
var _tabContainerPanelDefault = parcelHelpers.interopDefault(_tabContainerPanel);
var _reactTabs = require("react-tabs");
var _scrollablePanelBody = require("../../../components/structure/ScrollablePanelBody");
var _scrollablePanelBodyDefault = parcelHelpers.interopDefault(_scrollablePanelBody);
var _organizationInfoSettings = require("./OrganizationInfoSettings");
var _organizationInfoSettingsDefault = parcelHelpers.interopDefault(_organizationInfoSettings);
var _apiKeySettings = require("./ApiKeySettings");
var _apiKeySettingsDefault = parcelHelpers.interopDefault(_apiKeySettings);
var _generateApiKeyModal = require("./GenerateApiKeyModal");
var _generateApiKeyModalDefault = parcelHelpers.interopDefault(_generateApiKeyModal);
var _organizationDeploymentAccounts = require("./OrganizationDeploymentAccounts");
var _organizationDeploymentAccountsDefault = parcelHelpers.interopDefault(_organizationDeploymentAccounts);
var _organizationVariablesSettings = require("./OrganizationVariablesSettings");
var _organizationVariablesSettingsDefault = parcelHelpers.interopDefault(_organizationVariablesSettings);
var _organizationManagementSettings = require("./OrganizationManagementSettings");
var _organizationManagementSettingsDefault = parcelHelpers.interopDefault(_organizationManagementSettings);
var _organizationHealthcareManagementSettings = require("./OrganizationHealthcareManagementSettings");
var _organizationHealthcareManagementSettingsDefault = parcelHelpers.interopDefault(_organizationHealthcareManagementSettings);
var _responseVariableTestSettings = require("./ResponseVariableTestSettings");
var _responseVariableTestSettingsDefault = parcelHelpers.interopDefault(_responseVariableTestSettings);
var _button = require("../../../components/general/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _loader = require("../../../components/general/Loader");
var _loaderDefault = parcelHelpers.interopDefault(_loader);
var _scheduledEmailForm = require("../../../components/forms/ScheduledEmailForm");
var _scheduledEmailFormDefault = parcelHelpers.interopDefault(_scheduledEmailForm);
var _css = require("@emotion/css");
var _featureFlagIds = require("../../../constants/featureFlagIds");
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const apiKeyBlue = require("74e1d8baa5f95c0c");
const apiKeyDark = require("60c6aa730f983355");
const credentialsDark = require("bc389f67ad5ae7ae");
const credentialsBlue = require("cd1910116b37d4ed");
const basicInfoBlue = require("24c8500951dc3e0a");
const basicInfoDark = require("e0af2ced95f2f4db");
const addIcon = require("7e424225f71d80ba");
const constantsIcon = require("ee2b9db0d3ea1bc1");
const constantsBlueIcon = require("6fc972307686313");
const sendEmailIcon = require("38dee411eabfa2c");
const responseVarIcon = require("b1835453597ff6b1");
const responseVarBlueIcon = require("9a85a09cea874b07");
class OrganizationSettingsTabs extends (0, _reactDefault.default).Component {
    constructor(props){
        super(props);
        this.state = {
            isNewApiKeyModal: false,
            hasHealthcareApps: null
        };
    }
    async componentDidMount() {
        if (!this.props.userContainer.state.currentUser) await this.props.userContainer.getUser();
        await this.props.memberContainer.checkIsOrgAdmin(this.props.orgContainer.state.currentOrganization?.id, this.props.userContainer.state.currentUser?.id);
        // Load apps and check for healthcare
        const organizationId = this.props.orgContainer.state.currentOrganization?.id;
        if (organizationId) {
            // Check if apps are already loaded for this org
            const existingApps = this.props.applicationContainer.state.baseOrgApplications;
            const existingOrgId = this.props.applicationContainer.state.organizationId;
            if (existingApps?.length > 0 && existingOrgId === organizationId) {
                // Apps already loaded for this org - use them directly
                const hasHealthcare = existingApps.some((app)=>app.featureFlags?.some((flag)=>flag.id === (0, _featureFlagIds.HealthcareSchedulingFeatureFlagId))) || false;
                this.setState({
                    hasHealthcareApps: hasHealthcare
                });
            } else {
                // Need to load apps
                const result = await this.props.applicationContainer.getBaseApplicationsForOrg(organizationId);
                const apps = result?.data || this.props.applicationContainer.state.baseOrgApplications || [];
                const hasHealthcare = apps.some((app)=>app.featureFlags?.some((flag)=>flag.id === (0, _featureFlagIds.HealthcareSchedulingFeatureFlagId))) || false;
                this.setState({
                    hasHealthcareApps: hasHealthcare
                });
            }
        } else this.setState({
            hasHealthcareApps: false
        });
    }
    getSelectedIndex() {
        if (location.href.indexOf("apiKeys") > -1) return 1;
        if (location.href.indexOf("credentials") > -1) return 2;
        if (location.href.indexOf("constants") > -1) return 3;
        if (location.href.indexOf("management") > -1) return 4;
        if (location.href.indexOf("responseVariables") > -1) return 5;
        if (location.href.indexOf("emails") > -1) return 6;
        return 0;
    }
    handleTabSelection(index, last) {
        if (index == last) return;
        const urlStart = "/v/orgSettings/";
        if (index == 0) this.props.history.push(urlStart + window.location.search);
        if (index == 1) this.props.history.push(urlStart + "apiKeys" + window.location.search);
        if (index == 2) this.props.history.push(urlStart + "credentials" + window.location.search);
        if (index == 3) this.props.history.push(urlStart + "constants" + window.location.search);
        if (index == 4) this.props.history.push(urlStart + "management" + window.location.search);
        if (index == 5) this.props.history.push(urlStart + "responseVariables" + window.location.search);
        if (index == 6) this.props.history.push(urlStart + "emails" + window.location.search);
    }
    renderAddNewApiKeyButton() {
        if (this.getSelectedIndex() == 1 && this.props.memberContainer.state.isOrgAdmin) return (0, _react.jsx)((0, _buttonDefault.default), {
            themes: [
                "primary-small"
            ],
            text: "Add New",
            onClick: ()=>this.toggleNewApiKeyModal(),
            type: "button",
            rightIcon: addIcon
        });
        return null;
    }
    toggleNewApiKeyModal() {
        this.setState({
            ...this.state,
            isNewApiKeyModal: !this.state.isNewApiKeyModal
        });
    }
    render() {
        return (0, _react.jsx)((0, _tabContainerPanelDefault.default), {
            selectedIndex: this.getSelectedIndex(),
            onTabSelected: this.handleTabSelection.bind(this),
            tabs: [
                {
                    title: "Basic Info",
                    icon: basicInfoDark,
                    className: "ac-org-settings-basic-info",
                    selectedIcon: basicInfoBlue
                },
                {
                    title: "Api Keys",
                    icon: apiKeyDark,
                    className: "ac-org-settings-api-keys",
                    selectedIcon: apiKeyBlue
                },
                {
                    title: "Credentials",
                    icon: credentialsDark,
                    className: "ac-org-settings-credentials",
                    selectedIcon: credentialsBlue
                },
                {
                    title: "Constants",
                    icon: constantsIcon,
                    className: "ac-org-settings-constants",
                    selectedIcon: constantsBlueIcon
                },
                {
                    title: "Management",
                    icon: constantsIcon,
                    className: "ac-org-settings-management",
                    selectedIcon: constantsBlueIcon
                },
                {
                    title: "Debugger",
                    icon: responseVarIcon,
                    className: "ac-org-settings-response-variables",
                    selectedIcon: responseVarBlueIcon
                },
                {
                    title: "Emails",
                    icon: sendEmailIcon,
                    selectedIcon: sendEmailIcon
                }
            ],
            additionalHeaderContent: this.renderAddNewApiKeyButton.bind(this)
        }, (0, _react.jsx)((0, _reactTabs.TabPanel), null, (0, _react.jsx)((0, _scrollablePanelBodyDefault.default), {
            className: paddedBody
        }, (0, _react.jsx)((0, _organizationInfoSettingsDefault.default), {
            orgContainer: this.props.orgContainer,
            mediaContainer: this.props.mediaContainer
        }))), (0, _react.jsx)((0, _reactTabs.TabPanel), null, (0, _react.jsx)((0, _apiKeySettingsDefault.default), {
            isOrgAdmin: this.props.memberContainer.state.isOrgAdmin,
            orgContainer: this.props.orgContainer,
            apiKeyContainer: this.props.apiKeyContainer
        }), this.state.isNewApiKeyModal && (0, _react.jsx)((0, _generateApiKeyModalDefault.default), {
            apiKeyContainer: this.props.apiKeyContainer,
            onClose: this.toggleNewApiKeyModal.bind(this),
            organizationId: this.props.orgContainer.state.currentOrganization?.id
        })), (0, _react.jsx)((0, _reactTabs.TabPanel), null, (0, _react.jsx)((0, _scrollablePanelBodyDefault.default), {
            className: paddedBody
        }, (0, _react.jsx)((0, _organizationDeploymentAccountsDefault.default), {
            organizationId: this.props.orgContainer.state.currentOrganization.id,
            deploymentAccountsContainer: this.props.deploymentContainer
        }))), (0, _react.jsx)((0, _reactTabs.TabPanel), null, (0, _react.jsx)((0, _scrollablePanelBodyDefault.default), {
            className: paddedBody
        }, (0, _react.jsx)((0, _organizationVariablesSettingsDefault.default), {
            organizationId: this.props.orgContainer.state.currentOrganization.id
        }))), (0, _react.jsx)((0, _reactTabs.TabPanel), null, (0, _react.jsx)((0, _scrollablePanelBodyDefault.default), {
            className: paddedBody
        }, this.state.hasHealthcareApps === null ? (0, _react.jsx)((0, _loaderDefault.default), null) : this.state.hasHealthcareApps ? (0, _react.jsx)((0, _organizationHealthcareManagementSettingsDefault.default), {
            organizationId: this.props.orgContainer.state.currentOrganization.id,
            applicationContainer: this.props.applicationContainer,
            appliedTemplateContainer: this.props.appliedTemplateContainer,
            applicationEnvironmentsContainer: this.props.applicationEnvironmentsContainer
        }) : (0, _react.jsx)((0, _organizationManagementSettingsDefault.default), {
            organizationId: this.props.orgContainer.state.currentOrganization.id,
            applicationContainer: this.props.applicationContainer,
            appliedTemplateContainer: this.props.appliedTemplateContainer,
            applicationEnvironmentsContainer: this.props.applicationEnvironmentsContainer
        }))), (0, _react.jsx)((0, _reactTabs.TabPanel), null, (0, _react.jsx)((0, _scrollablePanelBodyDefault.default), {
            className: paddedBody
        }, (0, _react.jsx)((0, _responseVariableTestSettingsDefault.default), {
            organizationId: this.props.orgContainer.state.currentOrganization.id
        }))), (0, _react.jsx)((0, _reactTabs.TabPanel), null, (0, _react.jsx)((0, _scrollablePanelBodyDefault.default), {
            className: paddedBody,
            autoHeight: true,
            autoHeightMax: "calc(100vh - 136px)"
        }, (0, _react.jsx)((0, _scheduledEmailFormDefault.default), {
            organizationId: this.props.orgContainer.state.currentOrganization?.id,
            orgName: this.props.orgContainer.state.currentOrganization.name,
            appContainer: this.props.applicationContainer
        }))));
    }
}
const paddedBody = /*#__PURE__*/ (0, _css.css)({
    name: "knjsbg",
    styles: "padding:32px"
});
exports.default = OrganizationSettingsTabs;

},{"@emotion/react":"djZKr","react":"6uln9","../../../components/structure/Panels/TabContainerPanel":"iDHIJ","react-tabs":"92Sgf","../../../components/structure/ScrollablePanelBody":"6LRg3","./OrganizationInfoSettings":"2if5X","./ApiKeySettings":"9QOyU","./GenerateApiKeyModal":"bgMIw","./OrganizationDeploymentAccounts":"8uc0l","./OrganizationVariablesSettings":"ibVtw","./OrganizationManagementSettings":"icUDW","./OrganizationHealthcareManagementSettings":"cjH2w","./ResponseVariableTestSettings":"25z2G","../../../components/general/Button":"6ymxN","../../../components/general/Loader":"bnV5T","../../../components/forms/ScheduledEmailForm":"9dGV0","@emotion/css":"awUBr","../../../constants/featureFlagIds":"33vuW","74e1d8baa5f95c0c":"cFUKV","60c6aa730f983355":"l664n","bc389f67ad5ae7ae":"fZ9GS","cd1910116b37d4ed":"hn74a","24c8500951dc3e0a":"eKCse","e0af2ced95f2f4db":"eR20j","7e424225f71d80ba":"i0YpA","ee2b9db0d3ea1bc1":"amyk0","6fc972307686313":"adACm","38dee411eabfa2c":"dWSJG","b1835453597ff6b1":"23bLn","9a85a09cea874b07":"ixkJq","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2if5X":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _settingsCard = require("../../../components/structure/SettingsCard");
var _settingsCardDefault = parcelHelpers.interopDefault(_settingsCard);
var _updateOrganizationForm = require("./UpdateOrganizationForm");
var _updateOrganizationFormDefault = parcelHelpers.interopDefault(_updateOrganizationForm);
var _sparkContainer = require("../../../hooks/SparkContainer");
var _sparkContainerDefault = parcelHelpers.interopDefault(_sparkContainer);
var _moduleConsts = require("../../../constants/sparkConstants/moduleConsts");
const OrganizationInfoSettings = (props)=>{
    const sparkContainer = (0, _sparkContainerDefault.default).useContainer();
    (0, _react1.useEffect)(()=>{
        if (sparkContainer.inSpark) updateCommonAppNames();
    }, [
        props.commonApp
    ]);
    const updateCommonAppNames = async ()=>{
        if (props.commonApp) {
            const orgTemplateConfigs = await props.templateConfigurationContainer.getOrganizationTemplates(props.orgContainer?.state?.currentOrganization?.id);
            const commonAppTemplateConfigs = orgTemplateConfigs.data.filter((templateConfig)=>templateConfig.templateApplicationId === props.commonApp?.id);
            // Check if it's an AI answering app that's already correctly configured
            if (props.commonApp?.name === (0, _moduleConsts.aiAnsweringCommonAppName) && commonAppTemplateConfigs[0]?.name === (0, _moduleConsts.aiAnsweringCustomModuleName)) return;
            // Check if it's a dental scheduling app that's already correctly configured
            if (props.commonApp?.name === (0, _moduleConsts.aiDentalSchedulingCommonAppName) && commonAppTemplateConfigs[0]?.name === (0, _moduleConsts.aiDentalSchedulingCustomModuleName)) return;
            // Determine the correct app name and module name based on the template configuration
            let targetAppName = (0, _moduleConsts.aiAnsweringCommonAppName);
            let targetModuleName = (0, _moduleConsts.aiAnsweringCustomModuleName);
            if (commonAppTemplateConfigs.length > 0) // Check if this is a dental scheduling configuration
            {
                if (commonAppTemplateConfigs[0].name === (0, _moduleConsts.aiDentalSchedulingCustomModuleName) || commonAppTemplateConfigs[0].description?.includes("Shared Configuration")) {
                    targetAppName = (0, _moduleConsts.aiDentalSchedulingCommonAppName);
                    targetModuleName = (0, _moduleConsts.aiDentalSchedulingCustomModuleName);
                }
            }
            // update common app name
            if (props.commonApp?.name !== targetAppName) {
                const updatedApplication = {
                    ...props.commonApp,
                    name: targetAppName
                };
                props.appContainer.updateApplication(props.commonApp?.id, updatedApplication);
            }
            // update common app template config/module name
            if (orgTemplateConfigs) {
                if (commonAppTemplateConfigs) {
                    if (commonAppTemplateConfigs.length === 1) {
                        if (commonAppTemplateConfigs[0].name !== targetModuleName) {
                            const commonAppUpdatedTemplateConfiguration = {
                                ...commonAppTemplateConfigs[0],
                                name: targetModuleName
                            };
                            await props.templateConfigurationContainer.updateTemplateConfiguration(commonAppUpdatedTemplateConfiguration);
                        }
                    }
                }
            }
        }
    };
    return (0, _react.jsx)((0, _settingsCardDefault.default), {
        title: "Organization Information"
    }, (0, _react.jsx)((0, _updateOrganizationFormDefault.default), {
        orgContainer: props.orgContainer,
        mediaContainer: props.mediaContainer
    }));
};
exports.default = OrganizationInfoSettings;

},{"@emotion/react":"djZKr","react":"6uln9","../../../components/structure/SettingsCard":"liIw4","./UpdateOrganizationForm":"l2cFR","../../../hooks/SparkContainer":"jzXzx","../../../constants/sparkConstants/moduleConsts":"e2wLw","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"liIw4":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _base = require("@emotion/styled/base");
var _baseDefault = parcelHelpers.interopDefault(_base);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _colors = require("../../constants/colors");
var _horizontalSeparator = require("./HorizontalSeparator");
var _horizontalSeparatorDefault = parcelHelpers.interopDefault(_horizontalSeparator);
var _loader = require("../general/Loader");
var _loaderDefault = parcelHelpers.interopDefault(_loader);
var _breakpoints = require("../../constants/breakpoints");
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const SettingsCard = (props)=>{
    const LoaderWrapper = /*#__PURE__*/ (0, _baseDefault.default)("div", {
        target: "e795rmu1"
    })({
        name: "13udsys",
        styles: "height:100%"
    });
    const StyledLoader = /*#__PURE__*/ (0, _baseDefault.default)((0, _loaderDefault.default), {
        target: "e795rmu0"
    })({
        name: "1vcob1d",
        styles: "display:flex;justify-content:center;align-items:center"
    });
    const cardStyle = /*#__PURE__*/ (0, _css.css)("border-radius:10px;background-color:#ffffff;border:solid 1px ", (0, _colors.silver_two), ";margin-bottom:32px;flex-grow:0;font-family:Muli;font-weight:normal;font-style:normal;font-stretch:normal;line-height:normal;letter-spacing:normal;color:", (0, _colors.dark_grey_blue), ";h4{font-size:18px;font-weight:600;margin-bottom:24px;}.section{padding:32px 0;}", "");
    const titleStyle = /*#__PURE__*/ (0, _css.css)("display:flex;flex-direction:row;align-items:center;margin-bottom:16px;padding:32px 32px ", props?.subtitle?.length > 0 ? 0 : 12, "px 32px;>h3{font-size:23px;margin:0 10px;}", (0, _breakpoints.breakpoint_small), "{h3{font-size:18px;}}", "");
    const bodyStyle = /*#__PURE__*/ (0, _css.css)("padding:32px;", (0, _breakpoints.breakpoint_small), "{padding:16px;}", "");
    const descriptionStyle = /*#__PURE__*/ (0, _css.css)("color:", (0, _colors.color_shades_dark), ";font-size:14px;font-weight:normal;margin:0 10px;padding:0 32px 12px 32px;", (0, _breakpoints.breakpoint_small), "{padding:0 16px 16px 16px;font-size:12px;}", "");
    return (0, _react.jsx)((0, _reactDefault.default).Fragment, null, props.isLoading ? (0, _react.jsx)(LoaderWrapper, null, (0, _react.jsx)(StyledLoader, null)) : (0, _react.jsx)("div", {
        className: cardStyle
    }, props.title !== undefined ? (0, _react.jsx)((0, _reactDefault.default).Fragment, null, (0, _react.jsx)("div", {
        className: titleStyle
    }, props.icon !== undefined ? (0, _react.jsx)("img", {
        src: props.icon,
        alt: "icon"
    }) : null, (0, _react.jsx)("h3", null, props.title)), props?.subtitle?.length > 0 && (0, _react.jsx)("h4", {
        className: descriptionStyle
    }, props.subtitle), (0, _react.jsx)((0, _horizontalSeparatorDefault.default), null)) : null, (0, _react.jsx)("div", {
        className: props.bodyStyle ? props.bodyStyle : bodyStyle
    }, props.children)));
};
exports.default = SettingsCard;

},{"@emotion/styled/base":"lSuFu","@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","../../constants/colors":"1p3OR","./HorizontalSeparator":"Pw3HQ","../general/Loader":"bnV5T","../../constants/breakpoints":"2F01A","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"l2cFR":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _formik = require("formik");
var _yup = require("yup");
var _organizationInformationForm = require("../../formScenes/OrganizationInformationForm");
var _organizationInformationFormDefault = parcelHelpers.interopDefault(_organizationInformationForm);
const UpdateOrganizationForm = (0, _formik.withFormik)({
    mapPropsToValues: (props)=>({
            name: props.orgContainer.state.currentOrganization.name ? props.orgContainer.state.currentOrganization.name : "",
            isMultiLingual: props.orgContainer.state.currentOrganization.isMultiLingual || false,
            imageUri: props.orgContainer.state.currentOrganization.imageUri || ""
        }),
    validationSchema: _yup.object().shape({
        name: _yup.string().required("You must enter a name for your organization").min(2, "You must enter a longer name")
    }),
    handleSubmit: (values, { props })=>{
        props.orgContainer.updateOrganizationInfo({
            name: values.name,
            description: props.orgContainer.state.currentOrganization.description || "",
            imageUri: values.imageUri,
            isMultiLingual: values.isMultiLingual
        });
    }
})((0, _organizationInformationFormDefault.default));
exports.default = UpdateOrganizationForm;

},{"formik":"3YnOK","yup":"j2SJU","../../formScenes/OrganizationInformationForm":"1HXuU","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1HXuU":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _base = require("@emotion/styled/base");
var _baseDefault = parcelHelpers.interopDefault(_base);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _button = require("../../components/general/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _textField = require("../../components/forms/TextField");
var _textFieldDefault = parcelHelpers.interopDefault(_textField);
var _pageError = require("../../components/general/PageError");
var _pageErrorDefault = parcelHelpers.interopDefault(_pageError);
var _switch = require("../../components/forms/Switch");
var _switchDefault = parcelHelpers.interopDefault(_switch);
var _organizationAvatarUpload = require("../../components/general/OrganizationAvatarUpload");
var _organizationAvatarUploadDefault = parcelHelpers.interopDefault(_organizationAvatarUpload);
var _css = require("@emotion/css");
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const OrganizationInformationForm = (props)=>{
    const isLoading = props.orgContainer.state.isUpdating;
    const currentOrganization = props.orgContainer.state.currentOrganization;
    const [avatarUploadErrors, setAvatarUploadErrors] = (0, _react1.useState)([]);
    const [descriptionError, setDescriptionError] = (0, _react1.useState)([]);
    const clearAvatarUploadErrors = ()=>{
        setAvatarUploadErrors([]);
    };
    const clearDescriptionError = ()=>{
        setDescriptionError([]);
    };
    const isMissingDescription = !currentOrganization?.description;
    return (0, _react.jsx)("form", {
        onSubmit: props.handleSubmit
    }, (0, _react.jsx)((0, _pageErrorDefault.default), {
        errors: avatarUploadErrors,
        onClear: clearAvatarUploadErrors
    }), (0, _react.jsx)((0, _pageErrorDefault.default), {
        errors: descriptionError,
        onClear: clearDescriptionError
    }), isMissingDescription && (0, _react.jsx)(DescriptionWarning, null, "A description is required to update organization settings. Please add a description at ", (0, _react.jsx)("a", {
        href: "https://app.voicify.com",
        target: "_blank",
        rel: "noopener noreferrer"
    }, "app.voicify.com")), (0, _react.jsx)((0, _textFieldDefault.default), {
        name: "name",
        disabled: isLoading,
        required: true,
        value: props.values.name,
        label: "Organization Name",
        labelStyle: labelStyle,
        customRequiredLabelStyle: customRequiredLabelStyle,
        placeholder: "What's the name of your organization?",
        onChange: props.handleChange,
        onBlur: props.handleBlur
    }), (0, _react.jsx)((0, _organizationAvatarUploadDefault.default), {
        organizationId: currentOrganization?.id,
        organizationName: currentOrganization?.name,
        currentImageUri: currentOrganization?.imageUri,
        orgContainer: props.orgContainer,
        mediaContainer: props.mediaContainer,
        size: "small",
        showLabel: true,
        showHint: true,
        isLoading: props.orgContainer.state.isLoadingOrgs,
        onError: setAvatarUploadErrors,
        onClearError: clearAvatarUploadErrors
    }), (0, _react.jsx)(SwitchSection, null, (0, _react.jsx)((0, _switchDefault.default), {
        name: "isMultiLingual",
        checked: props.values.isMultiLingual || false,
        onChange: (checked)=>props.setFieldValue("isMultiLingual", checked),
        label: "Supports Multiple Languages",
        labelStyle: switchLabelStyle,
        disabled: isLoading
    })), (0, _react.jsx)((0, _buttonDefault.default), {
        loading: isLoading,
        disabled: isLoading || isMissingDescription,
        themes: [
            "primary"
        ],
        text: "Save",
        type: "submit"
    }));
};
const SwitchSection = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "eqj4ft51"
})({
    name: "6oh125",
    styles: "margin:16px 16px 24px 0px"
});
const DescriptionWarning = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "eqj4ft50"
})({
    name: "rsbdg3",
    styles: "background:#fff3cd;border:1px solid #ffc107;border-radius:8px;padding:12px 16px;margin-bottom:16px;color:#856404;font-size:14px;line-height:1.5;a{color:#856404;font-weight:bold;text-decoration:underline;}"
});
const switchLabelStyle = /*#__PURE__*/ (0, _css.css)({
    name: "ofgjbn",
    styles: "font-size:14px;font-weight:600"
});
const labelStyle = /*#__PURE__*/ (0, _css.css)({
    name: "ofgjbn",
    styles: "font-size:14px;font-weight:600"
});
const customRequiredLabelStyle = /*#__PURE__*/ (0, _css.css)({
    name: "13f7953",
    styles: "font-size:14px;color:red;margin-left:2px;font-weight:600"
});
exports.default = OrganizationInformationForm;

},{"@emotion/styled/base":"lSuFu","@emotion/react":"djZKr","react":"6uln9","../../components/general/Button":"6ymxN","../../components/forms/TextField":"7a7bh","../../components/general/PageError":"ezFTm","../../components/forms/Switch":"8kkL9","../../components/general/OrganizationAvatarUpload":"ec78T","@emotion/css":"awUBr","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"ec78T":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _base = require("@emotion/styled/base");
var _baseDefault = parcelHelpers.interopDefault(_base);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _userAvatar = require("./UserAvatar");
var _userAvatarDefault = parcelHelpers.interopDefault(_userAvatar);
var _secondaryLoader = require("./SecondaryLoader");
var _secondaryLoaderDefault = parcelHelpers.interopDefault(_secondaryLoader);
var _colors = require("../../constants/colors");
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const OrganizationAvatarUpload = ({ organizationId, organizationName, currentImageUri, orgContainer, mediaContainer, size = "small", showLabel = false, showHint = false, isLoading = false, onError, onClearError, onUploadSuccess })=>{
    const [customAvatarUrl, setCustomAvatarUrl] = (0, _react1.useState)(null);
    const [isUploadingAvatar, setIsUploadingAvatar] = (0, _react1.useState)(false);
    const avatarInputRef = (0, _react1.useRef)(null);
    const avatarSize = size === "large" ? 175 : 120;
    const wrapperSize = size === "large" ? 215 : 140;
    const ringSize = size === "large" ? 195 : 135;
    const innerRingSize = size === "large" ? 183 : 126;
    const overlayIconSize = size === "large" ? 32 : 24;
    const overlayTextSize = size === "large" ? 12 : 11;
    const handleAvatarClick = ()=>{
        avatarInputRef.current?.click();
    };
    const handleAvatarFileChange = async (event)=>{
        const file = event.target.files?.[0];
        if (file) {
            // Validate file type
            const validTypes = [
                "image/jpeg",
                "image/png",
                "image/gif",
                "image/webp"
            ];
            if (!validTypes.includes(file.type)) {
                onError?.([
                    "Invalid file type. Please select a JPG, PNG, GIF, or WebP image."
                ]);
                return;
            }
            // Validate file size (max 5MB)
            const maxSize = 5242880;
            if (file.size > maxSize) {
                const fileSizeMB = (file.size / 1048576).toFixed(2);
                onError?.([
                    `Image is too large (${fileSizeMB}MB). Please select an image under 5MB.`
                ]);
                return;
            }
            // Clear any previous errors
            onClearError?.();
            setIsUploadingAvatar(true);
            try {
                // Upload the image to get a URL
                const uploadResult = await mediaContainer.uploadOrganizationMedia(organizationId, file.name, file, "", ()=>{});
                if (uploadResult.resultType === "Ok" && uploadResult.data) {
                    const imageUrl = uploadResult.data;
                    // Update the organization with the new image URL
                    await orgContainer.updateOrganizationInfo({
                        name: organizationName,
                        description: orgContainer.state.currentOrganization?.description,
                        imageUri: imageUrl
                    });
                    // Check if there were errors from the organization update
                    if (orgContainer.state.errors && orgContainer.state.errors.length > 0) onError?.(orgContainer.state.errors);
                    else {
                        // Update local state with the new image URL
                        setCustomAvatarUrl(imageUrl);
                        onUploadSuccess?.(imageUrl);
                    }
                } else onError?.([
                    "Failed to upload image. Please try a smaller file or different format (JPG, PNG recommended)."
                ]);
            } catch (error) {
                let errorMessage = "Failed to upload image. ";
                if (error?.message?.toLowerCase().includes("network") || error?.message?.toLowerCase().includes("fetch")) errorMessage += "Please check your internet connection and try again.";
                else if (error?.message?.toLowerCase().includes("timeout")) errorMessage += "The upload timed out. Try a smaller image or check your connection.";
                else if (error?.message?.toLowerCase().includes("413") || error?.message?.toLowerCase().includes("too large")) errorMessage += "The file is too large. Please select an image under 5MB.";
                else if (error?.message?.toLowerCase().includes("401") || error?.message?.toLowerCase().includes("403") || error?.message?.toLowerCase().includes("unauthorized")) errorMessage += "You do not have permission to upload images. Please contact your administrator.";
                else if (error?.message?.toLowerCase().includes("unsupported") || error?.message?.toLowerCase().includes("format")) errorMessage += "Unsupported file format. Please use JPG, PNG, GIF, or WebP.";
                else if (error?.message) errorMessage += error.message;
                else errorMessage += "Please try a smaller file size (under 5MB) or a different image format (JPG, PNG recommended).";
                onError?.([
                    errorMessage
                ]);
            } finally{
                setIsUploadingAvatar(false);
                // Reset the input so the same file can be selected again if needed
                if (avatarInputRef.current) avatarInputRef.current.value = "";
            }
        }
    };
    const getCurrentAvatarUrl = ()=>{
        if (customAvatarUrl) return customAvatarUrl;
        return currentImageUri || null;
    };
    const getOrgInitials = ()=>{
        if (!organizationName) return "ORG";
        return organizationName.split(" ").map((word)=>word.charAt(0)).join("").toUpperCase().substring(0, 3);
    };
    const showLoading = isLoading || isUploadingAvatar;
    return (0, _react.jsx)(AvatarSection, null, showLabel && (0, _react.jsx)(AvatarLabel, null, "Organization Logo"), (0, _react.jsx)("input", {
        type: "file",
        ref: avatarInputRef,
        onChange: handleAvatarFileChange,
        accept: "image/*",
        style: {
            display: "none"
        }
    }), showLoading ? (0, _react.jsx)(AvatarLoaderWrapper, {
        onClick: handleAvatarClick,
        wrapperSize: wrapperSize
    }, (0, _react.jsx)(AvatarRing, {
        ringSize: ringSize
    }), (0, _react.jsx)(AvatarInnerRing, {
        innerRingSize: innerRingSize
    }), (0, _react.jsx)(AvatarLoaderContent, {
        avatarSize: avatarSize
    }, (0, _react.jsx)((0, _secondaryLoaderDefault.default), {
        className: "grey"
    }))) : (0, _react.jsx)(ClickableAvatarWrapper, {
        onClick: handleAvatarClick,
        title: "Click to change avatar",
        wrapperSize: wrapperSize,
        avatarSize: avatarSize
    }, (0, _react.jsx)(AvatarRing, {
        ringSize: ringSize
    }), (0, _react.jsx)(AvatarInnerRing, {
        innerRingSize: innerRingSize
    }), (0, _react.jsx)((0, _userAvatarDefault.default), {
        firstName: organizationName || "O",
        lastName: "",
        src: getCurrentAvatarUrl(),
        size: avatarSize,
        noShadow: true,
        noImageText: getOrgInitials()
    }), (0, _react.jsx)(AvatarUploadOverlay, {
        avatarSize: avatarSize
    }, (0, _react.jsx)(AvatarUploadIcon, {
        viewBox: "0 0 24 24",
        iconSize: overlayIconSize
    }, (0, _react.jsx)("path", {
        d: "M19.35 10.04C18.67 6.59 15.64 4 12 4 9.11 4 6.6 5.64 5.35 8.04 2.34 8.36 0 10.91 0 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.65-4.96zM14 13v4h-4v-4H7l5-5 5 5h-3z"
    })), (0, _react.jsx)(AvatarUploadText, {
        fontSize: overlayTextSize
    }, "Change"))), showHint && (0, _react.jsx)(AvatarHint, null, "Click to upload a new avatar (.png | .jpeg | .jpg | max 5MB)"));
};
const AvatarSection = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1kiyegs10"
})("");
const AvatarLabel = /*#__PURE__*/ (0, _baseDefault.default)("label", {
    target: "e1kiyegs9"
})({
    name: "bp8sdz",
    styles: "display:block;font-family:Muli;font-size:14px;text-align:left;margin:0 16px 12px 4px;font-weight:600"
});
const AvatarHint = /*#__PURE__*/ (0, _baseDefault.default)("p", {
    target: "e1kiyegs8"
})("font-size:12px;color:", (0, _colors.color_shades_dark), ";margin-top:8px;margin-bottom:0;");
const AvatarLoaderWrapper = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1kiyegs7"
})("position:relative;display:flex;align-items:center;justify-content:center;width:", (props)=>props.wrapperSize, "px;height:", (props)=>props.wrapperSize, "px;cursor:pointer;");
const AvatarLoaderContent = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1kiyegs6"
})("position:absolute;display:flex;align-items:center;justify-content:center;width:", (props)=>props.avatarSize, "px;height:", (props)=>props.avatarSize, "px;border-radius:50%;background:", (0, _colors.color_defaults_white), ";z-index:2;");
const ClickableAvatarWrapper = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1kiyegs5"
})("position:relative;display:flex;align-items:center;justify-content:center;width:", (props)=>props.wrapperSize, "px;height:", (props)=>props.wrapperSize, "px;cursor:pointer;&::before{content:'';position:absolute;width:", (props)=>props.avatarSize, "px;height:", (props)=>props.avatarSize, "px;border-radius:50%;background:", (0, _colors.color_defaults_white), ";z-index:1;}>*:not(:first-child):not(:nth-child(2)){z-index:2;}&:hover{>div:last-of-type{opacity:1;}}");
const AvatarRing = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1kiyegs4"
})("position:absolute;width:", (props)=>props.ringSize, "px;height:", (props)=>props.ringSize, "px;border-radius:50%;background:", (0, _colors.voicify_spark_lightest), ";opacity:0.6;");
const AvatarInnerRing = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1kiyegs3"
})("position:absolute;width:", (props)=>props.innerRingSize, "px;height:", (props)=>props.innerRingSize, "px;border-radius:50%;border:2px solid ", (0, _colors.voicify_spark_light), ";background:transparent;");
const AvatarUploadOverlay = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1kiyegs2"
})("position:absolute;width:", (props)=>props.avatarSize, "px;height:", (props)=>props.avatarSize, "px;border-radius:50%;background:rgba(0, 0, 0, 0.5);display:flex;flex-direction:column;align-items:center;justify-content:center;opacity:0;transition:opacity 0.2s ease;z-index:10;pointer-events:none;");
const AvatarUploadIcon = /*#__PURE__*/ (0, _baseDefault.default)("svg", {
    target: "e1kiyegs1"
})("width:", (props)=>props.iconSize, "px;height:", (props)=>props.iconSize, "px;fill:", (0, _colors.color_defaults_white), ";margin-bottom:4px;");
const AvatarUploadText = /*#__PURE__*/ (0, _baseDefault.default)("span", {
    target: "e1kiyegs0"
})("color:", (0, _colors.color_defaults_white), ";font-size:", (props)=>props.fontSize, "px;font-weight:600;");
exports.default = OrganizationAvatarUpload;

},{"@emotion/styled/base":"lSuFu","@emotion/react":"djZKr","react":"6uln9","./UserAvatar":"avuDP","./SecondaryLoader":"7zJiF","../../constants/colors":"1p3OR","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"e2wLw":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "aiAnsweringCustomModuleName", ()=>aiAnsweringCustomModuleName);
parcelHelpers.export(exports, "aiAnsweringCommonAppName", ()=>aiAnsweringCommonAppName);
parcelHelpers.export(exports, "aiOrderingCustomModuleName", ()=>aiOrderingCustomModuleName);
parcelHelpers.export(exports, "aiOrderingCommonAppName", ()=>aiOrderingCommonAppName);
parcelHelpers.export(exports, "aiDentalSchedulingCustomModuleName", ()=>aiDentalSchedulingCustomModuleName);
parcelHelpers.export(exports, "aiDentalSchedulingCommonAppName", ()=>aiDentalSchedulingCommonAppName);
const aiAnsweringCustomModuleName = "Shared Topics Module";
const aiAnsweringCommonAppName = "Shared Topics";
const aiOrderingCustomModuleName = "Shared Topics Module";
const aiOrderingCommonAppName = "Shared Topics";
const aiDentalSchedulingCustomModuleName = "Shared Configuration Module";
const aiDentalSchedulingCommonAppName = "Shared Configuration";

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9QOyU":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _base = require("@emotion/styled/base");
var _baseDefault = parcelHelpers.interopDefault(_base);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _sortedTable = require("../../../components/structure/SortedTable");
var _sortedTableDefault = parcelHelpers.interopDefault(_sortedTable);
var _lodash = require("lodash");
var _lodashDefault = parcelHelpers.interopDefault(_lodash);
var _tableHeader = require("../../../components/general/TableHeader");
var _tableHeaderDefault = parcelHelpers.interopDefault(_tableHeader);
var _tableCell = require("../../../components/general/TableCell");
var _tableCellDefault = parcelHelpers.interopDefault(_tableCell);
var _moment = require("moment");
var _momentDefault = parcelHelpers.interopDefault(_moment);
var _css = require("@emotion/css");
var _colors = require("../../../constants/colors");
var _userAvatar = require("../../../components/general/UserAvatar");
var _userAvatarDefault = parcelHelpers.interopDefault(_userAvatar);
var _horizontalContainer = require("../../../components/structure/HorizontalContainer");
var _horizontalContainerDefault = parcelHelpers.interopDefault(_horizontalContainer);
var _deleteConfirmation = require("../../featureContent/components/DeleteConfirmation");
var _deleteConfirmationDefault = parcelHelpers.interopDefault(_deleteConfirmation);
var _confirmationDialog = require("../../../components/structure/ConfirmationDialog");
var _confirmationDialogDefault = parcelHelpers.interopDefault(_confirmationDialog);
var _customScrollbars = require("../../../components/structure/CustomScrollbars");
var _customScrollbarsDefault = parcelHelpers.interopDefault(_customScrollbars);
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const deleteIcon = require("63ac47dede3443eb");
const alertCircle = require("e1ab75c2f930c6ac");
const noApiKeys = require("8af552852d1c3520");
const infoCircle = require("f8d8ebb36745254d");
const noPermissionApiKeys = require("d3980710c9207ff6");
class ApiKeySettings extends (0, _reactDefault.default).Component {
    constructor(props){
        super(props);
        this.state = {
            deleteApiKey: null
        };
    }
    async componentDidMount() {
        await this.props.apiKeyContainer.loadOrganizationApiKeys(this.props.orgContainer.state.currentOrganization.id);
    }
    async showDeleteModal(apiKeyModel) {
        await this.setState({
            ...this.state,
            deleteApiKey: apiKeyModel
        });
    }
    async finishDeleteModal() {
        await this.props.apiKeyContainer.deleteApiKey(this.state.deleteApiKey.id);
        await this.props.apiKeyContainer.loadOrganizationApiKeys(this.props.orgContainer.state.currentOrganization.id);
        this.setState({
            ...this.state,
            deleteApiKey: null
        });
    }
    async closeDeleteModal() {
        await this.setState({
            ...this.state,
            deleteApiKey: null
        });
    }
    render() {
        const apiKeys = (0, _lodashDefault.default).orderBy(this.props.apiKeyContainer.state.apiKeys, (a)=>a.expirationDate, "asc");
        const columns = [
            {
                id: "name",
                Header: (0, _react.jsx)((0, _tableHeaderDefault.default), {
                    text: "NAME"
                }),
                accessor: (m)=>m,
                Cell: (row)=>(0, _react.jsx)((0, _tableCellDefault.default), {
                        className: apiKeyCellStyle
                    }, (0, _react.jsx)("span", null, row.value.name))
            },
            {
                id: "expiration",
                Header: (0, _react.jsx)((0, _tableHeaderDefault.default), {
                    text: "EXPIRES"
                }),
                accessor: (m)=>m,
                Cell: (row)=>(0, _react.jsx)((0, _tableCellDefault.default), {
                        className: `${expirationDateStyle} ${row.value.expirationDate != null && (0, _momentDefault.default)().isAfter(row.value.expirationDate) ? "expired" : ""}`
                    }, (0, _react.jsx)((0, _horizontalContainerDefault.default), null, row.value.expirationDate == null ? "Never" : (0, _momentDefault.default)(row.value.expirationDate).format("MM/DD/YYYY"), row.value.expirationDate != null && (0, _momentDefault.default)().isAfter(row.value.expirationDate) && (0, _react.jsx)("img", {
                        src: alertCircle
                    })))
            },
            {
                id: "created-by",
                Header: (0, _react.jsx)((0, _tableHeaderDefault.default), {
                    text: "CREATED BY"
                }),
                accessor: (m)=>m,
                Cell: (row)=>(0, _react.jsx)((0, _tableCellDefault.default), {
                        className: apiKeyCellStyle
                    }, row.value.createdByUserModel?.lastName && (0, _react.jsx)((0, _horizontalContainerDefault.default), null, (0, _react.jsx)((0, _userAvatarDefault.default), {
                        noBackground: true,
                        lastName: row.value.createdByUserModel.lastName,
                        firstName: row.value.createdByUserModel.firstName,
                        src: row.value.createdByUserModel.imageUrl,
                        size: 32
                    }), (0, _react.jsx)("div", {
                        className: createdByUserName
                    }, `${row.value.createdByUserModel.firstName} ${row.value.createdByUserModel.lastName}`)))
            },
            {
                id: "delete",
                Header: (0, _react.jsx)((0, _tableHeaderDefault.default), {
                    text: ""
                }),
                accessor: (m)=>m,
                width: 50,
                Cell: (row)=>(0, _react.jsx)((0, _tableCellDefault.default), {
                        className: apiKeyCellStyle
                    }, (0, _react.jsx)("img", {
                        onClick: ()=>this.showDeleteModal(row.value),
                        className: deleteStyle,
                        src: deleteIcon
                    }))
            }
        ];
        return (0, _react.jsx)("div", {
            className: containerStyle
        }, (0, _react.jsx)((0, _customScrollbarsDefault.default), {
            autoHide: true
        }, (0, _react.jsx)("div", {
            className: "api-key-header border-header"
        }, (0, _react.jsx)(MainHeader, null, "Manage your API Keys"), (0, _react.jsx)(SubHeader, null, "API Keys can be used to access Voicify's API's to extend apps in this organization using the integrations framework."), (0, _react.jsx)(SubHeader, null, "For more information on our integrations framework and how to use these keys check out our knowledge center ", (0, _react.jsx)("a", {
            target: "_blank",
            href: "https://support.voicify.com/knowledge/how-do-i-create-api-keys"
        }, "here.")), (0, _react.jsx)("div", {
            className: warningCss
        }, (0, _react.jsx)("img", {
            src: infoCircle
        }), (0, _react.jsx)(SubHeader, null, "Keys generated here will have access to your organization. ", (0, _react.jsx)("b", null, "Keep them secure.")))), this.props.isOrgAdmin ? apiKeys && apiKeys.length > 0 ? (0, _react.jsx)("div", {
            className: tableContainer
        }, (0, _react.jsx)((0, _sortedTableDefault.default), {
            noDataText: "No API Keys generated yet",
            className: tableStyle,
            columns: columns,
            data: apiKeys
        })) : (0, _react.jsx)((0, _reactDefault.default).Fragment, null, (0, _react.jsx)("img", {
            className: fullWidthImage,
            src: noApiKeys
        }), (0, _react.jsx)(NoKeysText, null, "No API Keys have been generated yet")) : (0, _react.jsx)((0, _reactDefault.default).Fragment, null, (0, _react.jsx)("img", {
            className: fullWidthImage,
            src: noPermissionApiKeys
        }), (0, _react.jsx)(NoKeysText, null, "Only Organization Administrators have access to API Keys")), this.state.deleteApiKey && (0, _react.jsx)((0, _confirmationDialogDefault.default), {
            title: "Delete",
            deleteText: "Yes, Delete",
            isLoading: this.props.apiKeyContainer.state.isLoading,
            onClose: this.closeDeleteModal.bind(this),
            onConfirm: this.finishDeleteModal.bind(this)
        }, (0, _react.jsx)((0, _deleteConfirmationDefault.default), {
            itemLabel: `the ${this.state.deleteApiKey.name} API Key? This will immediately revoke its access to Voicify API's.`
        }))));
    }
}
const expirationDateStyle = /*#__PURE__*/ (0, _css.css)("&.expired{color:", (0, _colors.color_colors_decline), ";}img{margin-left:8px;margin-top:-2px;}", "");
const NoKeysText = /*#__PURE__*/ (0, _baseDefault.default)("p", {
    target: "e18j4ejx2"
})(`
    font-style: normal;
    font-weight: normal;
    font-size: 24px;
    line-height: 32px;
    text-align: center;
    color: ${(0, _colors.color_shades_darkest)};
`, "");
const tableContainer = /*#__PURE__*/ (0, _css.css)({
    name: "19m8dgf",
    styles: "margin-bottom:250px"
});
const fullWidthImage = /*#__PURE__*/ (0, _css.css)({
    name: "1653418",
    styles: "width:100%;height:50%;margin-left:auto;margin-right:auto"
});
const warningCss = /*#__PURE__*/ (0, _css.css)("width:100%;border:1px solid ", (0, _colors.color_colors_gold), ";background:", (0, _colors.color_colors_gold_background), ";display:flex;border-radius:8px;padding:16px 24px;margin-top:16px;img{margin-right:12px;}", "");
const containerStyle = /*#__PURE__*/ (0, _css.css)("font-style:normal;font-weight:normal;.api-key-header{padding:32px;}.border-header{border-bottom:solid 1px ", (0, _colors.silver_two), ";}", "");
const MainHeader = /*#__PURE__*/ (0, _baseDefault.default)("h2", {
    target: "e18j4ejx1"
})(`
    font-size: 18px;
    line-height: 24px;
    margin-bottom: 16px;
`, "");
const SubHeader = /*#__PURE__*/ (0, _baseDefault.default)("h3", {
    target: "e18j4ejx0"
})(`
    font-size: 14px;
    line-height: 20px;
    font-weight: normal;
`, "");
const apiKeyCellStyle = /*#__PURE__*/ (0, _css.css)({
    name: "d3v9zr",
    styles: "overflow:hidden"
});
const createdByUserName = /*#__PURE__*/ (0, _css.css)({
    name: "1oo7gve",
    styles: "font-size:14px;line-height:20px;margin-top:8px"
});
const deleteStyle = /*#__PURE__*/ (0, _css.css)({
    name: "e0dnmk",
    styles: "cursor:pointer"
});
const tableStyle = /*#__PURE__*/ (0, _css.css)({
    name: "1fzxxkz",
    styles: "border:none;.rt-noData{margin-top:30px;}"
});
exports.default = ApiKeySettings;

},{"@emotion/styled/base":"lSuFu","@emotion/react":"djZKr","react":"6uln9","../../../components/structure/SortedTable":"2MhF3","lodash":"3hMBK","../../../components/general/TableHeader":"9EPgz","../../../components/general/TableCell":"2zNzE","moment":"2meyw","@emotion/css":"awUBr","../../../constants/colors":"1p3OR","../../../components/general/UserAvatar":"avuDP","../../../components/structure/HorizontalContainer":"eJPfh","../../featureContent/components/DeleteConfirmation":"9xK2d","../../../components/structure/ConfirmationDialog":"kx7yK","../../../components/structure/CustomScrollbars":"50vFq","63ac47dede3443eb":"bG6Op","e1ab75c2f930c6ac":"cRA6k","8af552852d1c3520":"bzBpH","f8d8ebb36745254d":"k0Bys","d3980710c9207ff6":"lV1fp","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2MhF3":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _reactTable = require("react-table");
var _reactTableDefault = parcelHelpers.interopDefault(_reactTable);
var _colors = require("../../constants/colors");
// component wrapping the react-table component to allow for consistent styles and functionality
class SortedTable extends (0, _reactDefault.default).Component {
    constructor(props){
        super(props);
        this.state = {
            pageSize: props.pageSize ? props.pageSize : localStorage.getItem("defaultPageSize") ? parseInt(localStorage.getItem("defaultPageSize")) : 20
        };
    }
    handlePageSizeChange(size) {
        this.setState({
            ...this.state,
            pageSize: size
        });
        localStorage.setItem("defaultPageSize", size.toString());
    }
    render() {
        const props = this.props;
        return (0, _react.jsx)((0, _reactTableDefault.default), {
            className: `${tableStyles} ${props.className}`,
            data: props.data,
            columns: props.columns,
            noDataText: props.noDataText,
            showPagination: props.showPagination !== true ? false : true,
            onPageSizeChange: this.handlePageSizeChange.bind(this),
            showPaginationBottom: props.showPagination,
            pageSize: this.state.pageSize,
            getTrProps: props.getTrProps,
            minRows: 1
        });
    }
}
const tableStyles = /*#__PURE__*/ (0, _css.css)("border-radius:10px;border:solid 1px #cccccc;overflow:hidden;&.no-border{border-width:0;}.rt-table{background:white;overflow:hidden;.rt-thead,.rt-thead -header{padding:0 16px;height:60px;box-shadow:none;border-bottom:solid 1px #cccccc;.rt-th{height:60px;border:none;box-shadow:none;div{height:100%;}}}.rt-tbody{min-height:64px;.rt-tr-group{min-height:52px;border-bottom:solid 1px #cccccc;.rt-tr{background:transparent;padding:0 16px;border:none;overflow:visible;}}}div.rt-td{background:transparent;align-self:center;overflow:visible;}}.pagination-bottom{height:45px;font-family:Muli;.-pagination{height:100%;button,.-btn{color:", (0, _colors.ocean_blue), ";background:none;border:none;&:disabled{opacity:.5;}}}}", "");
exports.default = SortedTable;

},{"@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","react-table":"e4yqY","../../constants/colors":"1p3OR","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"bzBpH":[function(require,module,exports) {
module.exports = require("9752115085389caf").getBundleURL("kVLro") + require("a0eb087b54872b26").resolve("gJzQ9");

},{"9752115085389caf":"c7Tr5","a0eb087b54872b26":"fyJL2"}],"lV1fp":[function(require,module,exports) {
module.exports = require("88476ca4e1a834c1").getBundleURL("kVLro") + require("d4a00e6b76c75b48").resolve("gscvL");

},{"88476ca4e1a834c1":"c7Tr5","d4a00e6b76c75b48":"fyJL2"}],"bgMIw":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _extends = require("@babel/runtime/helpers/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("@emotion/react");
var _css = require("@emotion/css");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _keyModalLayout = require("../../../components/structure/KeyModalLayout");
var _keyModalLayoutDefault = parcelHelpers.interopDefault(_keyModalLayout);
var _modalLayout = require("../../../components/structure/ModalLayout");
var _modalLayoutDefault = parcelHelpers.interopDefault(_modalLayout);
var _newApiKeyForm = require("./NewApiKeyForm");
var _newApiKeyFormDefault = parcelHelpers.interopDefault(_newApiKeyForm);
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const GenerateApiKeyModal = (props)=>{
    const [keyResult, setKeyResult] = (0, _react1.useState)(null);
    const handleFinishForm = (result)=>{
        setKeyResult(result);
    };
    const isLoading = props.apiKeyContainer.state.isLoading;
    return (0, _react.jsx)((0, _modalLayoutDefault.default), {
        className: modalStyle,
        isVisible: true,
        onClose: props.onClose
    }, keyResult == null ? (0, _react.jsx)((0, _newApiKeyFormDefault.default), (0, _extendsDefault.default)({}, props, {
        onFinish: handleFinishForm
    })) : (0, _react.jsx)((0, _keyModalLayoutDefault.default), {
        modalTitle: "Generate API Key",
        handleClose: props.onClose,
        token: keyResult.key,
        isLoading: isLoading
    }));
};
const modalStyle = /*#__PURE__*/ (0, _css.css)({
    name: "e4xxdn",
    styles: "width:60vw;height:50vh"
});
exports.default = GenerateApiKeyModal;

},{"@babel/runtime/helpers/extends":"4iKIP","@emotion/react":"djZKr","@emotion/css":"awUBr","react":"6uln9","../../../components/structure/KeyModalLayout":"QILh0","../../../components/structure/ModalLayout":"b1cO3","./NewApiKeyForm":"1i8ke","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"QILh0":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _base = require("@emotion/styled/base");
var _baseDefault = parcelHelpers.interopDefault(_base);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _colors = require("../../constants/colors");
var _stylesValues = require("../../constants/stylesValues");
var _horizontalContainer = require("./HorizontalContainer");
var _horizontalContainerDefault = parcelHelpers.interopDefault(_horizontalContainer);
var _modalTitle = require("../general/ModalTitle");
var _modalTitleDefault = parcelHelpers.interopDefault(_modalTitle);
var _button = require("../general/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _customScrollbars = require("./CustomScrollbars");
var _customScrollbarsDefault = parcelHelpers.interopDefault(_customScrollbars);
var _textField = require("../forms/TextField");
var _textFieldDefault = parcelHelpers.interopDefault(_textField);
var _footerBar = require("./FooterBar");
var _footerBarDefault = parcelHelpers.interopDefault(_footerBar);
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const closeIcon = require("f13d87c8b9f8c59d");
const copyIcon = require("360702b9f2245c82");
const KeyModalLayout = (props)=>{
    const [copied, setCopied] = (0, _react1.useState)(false);
    const handleCopyKey = (key)=>{
        const textField = document.createElement("textarea");
        textField.innerText = key;
        document.body.appendChild(textField);
        textField.select();
        document.execCommand("copy");
        textField.remove();
        setCopied(true);
        setTimeout(()=>setCopied(false), 2000);
    };
    return (0, _react.jsx)("div", {
        className: containerStyle
    }, (0, _react.jsx)((0, _horizontalContainerDefault.default), {
        className: modalTitleContainer
    }, (0, _react.jsx)(TitleWrapper, null, (0, _react.jsx)((0, _modalTitleDefault.default), null, props.modalTitle)), (0, _react.jsx)(CloseButtonWrapper, null, (0, _react.jsx)((0, _buttonDefault.default), {
        className: closeButton,
        themes: [
            "start-tight",
            "icon"
        ],
        icon: closeIcon,
        onClick: props.handleClose
    }))), (0, _react.jsx)((0, _customScrollbarsDefault.default), {
        autoHide: true,
        autoHeight: true,
        autoHeightMin: "calc(100vh - 200px)",
        autoHeightMax: "calc(100vh - 200px)"
    }, (0, _react.jsx)("div", {
        className: "main-body"
    }, (0, _react.jsx)("p", {
        className: "generated-warning"
    }, "This key will only be generated once and shown while this screen is active."), (0, _react.jsx)((0, _textFieldDefault.default), {
        readOnly: true,
        value: props.token || "",
        useForm: false,
        onBlur: ()=>null,
        label: `Key`
    }), (0, _react.jsx)("div", {
        onClick: ()=>handleCopyKey(props.token),
        className: "copy-key"
    }, (0, _react.jsx)("img", {
        src: copyIcon
    }), (0, _react.jsx)("p", null, copied ? "Copied!" : "Copy key to clipboard")))), (0, _react.jsx)("div", {
        className: bodyContainer
    }, (0, _react.jsx)((0, _footerBarDefault.default), {
        className: footerStyle
    }, (0, _react.jsx)((0, _buttonDefault.default), {
        disabled: props.isLoading,
        themes: [
            "primary",
            "wide"
        ],
        text: "Close",
        type: "button",
        onClick: props.handleClose
    }))));
};
const modalTitleContainer = /*#__PURE__*/ (0, _css.css)("background:white;padding:0 32px;justify-content:space-between;align-items:center;border-top-right-radius:20px;border-top-left-radius:20px;border-bottom:", (0, _stylesValues.style_border_default), ";img{margin-right:16px;}", "");
const containerStyle = /*#__PURE__*/ (0, _css.css)(".main-body{padding:32px;background:", (0, _colors.blue_white), ";height:100%;.Select-option{z-index:10;}}.generated-warning{font-style:normal;font-weight:normal;font-size:14px;line-height:20px;color:", (0, _colors.color_shades_darkest), ";margin-bottom:32px;}.copy-key{display:flex;font-style:normal;font-weight:normal;font-size:14px;line-height:20px;cursor:pointer;color:", (0, _colors.color_colors_ocean), ";margin-top:40px;img{margin-right:8px;}}", "");
const TitleWrapper = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e14ouwyy1"
})({
    name: "s5xdrg",
    styles: "display:flex;align-items:center"
});
const CloseButtonWrapper = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e14ouwyy0"
})("display:flex;padding-left:28.5px;border-left:", (0, _stylesValues.style_border_default), ";");
const bodyContainer = /*#__PURE__*/ (0, _css.css)("padding:32px;background:", (0, _colors.color_variants_main_bg), ";flex:1;border-bottom-right-radius:20px;border-bottom-left-radius:20px;", "");
const footerStyle = /*#__PURE__*/ (0, _css.css)({
    name: "joji84",
    styles: "position:fixed;border-bottom-right-radius:20px;border-bottom-left-radius:20px;padding:0 32px"
});
const closeButton = /*#__PURE__*/ (0, _css.css)({
    name: "xjgief",
    styles: "margin-right:-8px;margin-left:0"
});
exports.default = KeyModalLayout;

},{"@emotion/styled/base":"lSuFu","@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","../../constants/colors":"1p3OR","../../constants/stylesValues":"dHVVv","./HorizontalContainer":"eJPfh","../general/ModalTitle":"hIp2B","../general/Button":"6ymxN","./CustomScrollbars":"50vFq","../forms/TextField":"7a7bh","./FooterBar":"bibRL","f13d87c8b9f8c59d":"93VwA","360702b9f2245c82":"6HqvT","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6HqvT":[function(require,module,exports) {
module.exports = require("a3543572df5a046e").getBundleURL("kVLro") + require("b2219dd6305bc8d9").resolve("hP1SX");

},{"a3543572df5a046e":"c7Tr5","b2219dd6305bc8d9":"fyJL2"}],"1i8ke":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _base = require("@emotion/styled/base");
var _baseDefault = parcelHelpers.interopDefault(_base);
var _react = require("@emotion/react");
var _css = require("@emotion/css");
var _formik = require("formik");
var _moment = require("moment");
var _momentDefault = parcelHelpers.interopDefault(_moment);
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _yup = require("yup");
var _dateTimeField = require("../../../components/forms/DateTimeField");
var _dateTimeFieldDefault = parcelHelpers.interopDefault(_dateTimeField);
var _selectField = require("../../../components/forms/SelectField");
var _selectFieldDefault = parcelHelpers.interopDefault(_selectField);
var _textField = require("../../../components/forms/TextField");
var _textFieldDefault = parcelHelpers.interopDefault(_textField);
var _button = require("../../../components/general/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _modalTitle = require("../../../components/general/ModalTitle");
var _modalTitleDefault = parcelHelpers.interopDefault(_modalTitle);
var _customScrollbars = require("../../../components/structure/CustomScrollbars");
var _customScrollbarsDefault = parcelHelpers.interopDefault(_customScrollbars);
var _footerBar = require("../../../components/structure/FooterBar");
var _footerBarDefault = parcelHelpers.interopDefault(_footerBar);
var _horizontalContainer = require("../../../components/structure/HorizontalContainer");
var _horizontalContainerDefault = parcelHelpers.interopDefault(_horizontalContainer);
var _colors = require("../../../constants/colors");
var _stylesValues = require("../../../constants/stylesValues");
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const closeIcon = require("9c77033cd86e65c0");
const NewApiKeyFormComponent = (props)=>{
    const handleExpirationTypeChange = (value)=>{
        const finalValue = value === null ? null : value.value;
        props.setFieldValue("expirationType", finalValue);
        if (value.value == "7") {
            const newExpirationDate = (0, _momentDefault.default)().add(7, "day").format("YYYY-MM-DD");
            props.setFieldValue("expirationDate", newExpirationDate);
        } else if (value.value == "30") {
            const newExpirationDate = (0, _momentDefault.default)().add(30, "day").format("YYYY-MM-DD");
            props.setFieldValue("expirationDate", newExpirationDate);
        } else if (value.value == "year") {
            const newExpirationDate = (0, _momentDefault.default)().add(1, "year").format("YYYY-MM-DD");
            props.setFieldValue("expirationDate", newExpirationDate);
        } else if (value.value == "none") props.setFieldValue("expirationDate", "");
    };
    const handleExpirationTypeBlur = (blur)=>{
        props.setFieldTouched("expirationType", blur);
    };
    const handleExpirationDateChange = (e)=>{
        props.setFieldValue("expirationType", "custom");
        props.setFieldValue("expirationDate", (0, _momentDefault.default)(e.target.value, "YYYY-MM-DD").format("YYYY-MM-DD"));
    };
    const isLoading = props.apiKeyContainer.state.isLoading;
    return (0, _react.jsx)("form", {
        onSubmit: props.handleSubmit
    }, (0, _react.jsx)("div", {
        className: containerStyle
    }, (0, _react.jsx)((0, _horizontalContainerDefault.default), {
        className: modalTitleContainer
    }, (0, _react.jsx)(TitleWrapper, null, (0, _react.jsx)((0, _modalTitleDefault.default), null, "Generate API Key")), (0, _react.jsx)(CloseButtonWrapper, null, (0, _react.jsx)((0, _buttonDefault.default), {
        className: closeButton,
        themes: [
            "start-tight",
            "icon"
        ],
        icon: closeIcon,
        onClick: props.onClose
    }))), (0, _react.jsx)((0, _customScrollbarsDefault.default), {
        className: "scrollable-area",
        autoHide: true,
        autoHeight: true,
        autoHeightMin: "calc(100vh - 200px)",
        autoHeightMax: "calc(100vh - 200px)"
    }, (0, _react.jsx)("div", {
        className: "main-body"
    }, (0, _react.jsx)((0, _textFieldDefault.default), {
        name: `name`,
        value: props.values.name,
        placeholder: "Enter key",
        label: `Name`,
        onChange: props.handleChange,
        onBlur: props.handleBlur
    }), (0, _react.jsx)((0, _horizontalContainerDefault.default), null, (0, _react.jsx)((0, _selectFieldDefault.default), {
        className: "expiration-type",
        options: [
            {
                value: "none",
                label: "None"
            },
            {
                value: "7",
                label: "Today +7 days"
            },
            {
                value: "30",
                label: "Today +30 days"
            },
            {
                value: "year",
                label: "Today +1 year"
            },
            {
                value: "custom",
                label: "Custom"
            }
        ],
        onChange: handleExpirationTypeChange,
        onBlur: handleExpirationTypeBlur,
        label: "Expiration:",
        clearable: false,
        disabled: isLoading,
        useFormTheme: true,
        value: props.values.expirationType,
        name: "expirationType"
    }), (0, _react.jsx)((0, _dateTimeFieldDefault.default), {
        label: "Expires on:",
        disabled: isLoading,
        value: props.values.expirationDate,
        onChange: handleExpirationDateChange,
        name: "expirationDate",
        onBlur: props.handleBlur
    })))), (0, _react.jsx)((0, _footerBarDefault.default), null, (0, _react.jsx)((0, _buttonDefault.default), {
        loading: isLoading,
        disabled: isLoading,
        themes: [
            "primary",
            "wide"
        ],
        text: "Generate Key",
        type: "submit"
    }), (0, _react.jsx)((0, _buttonDefault.default), {
        disabled: isLoading,
        themes: [
            "white",
            "end"
        ],
        text: "Cancel",
        type: "button",
        onClick: props.onClose.bind(undefined)
    }))));
};
const NewApiKeyForm = (0, _formik.withFormik)({
    mapPropsToValues: (props)=>{
        return {
            name: "",
            expirationDate: (0, _momentDefault.default)().add(30, "day").format("YYYY-MM-DD"),
            expirationType: "30"
        };
    },
    validationSchema: _yup.object().shape({
        name: _yup.string().required("You must specify a name.")
    }),
    handleSubmit: async (values, { props })=>{
        const request = {
            name: values.name,
            utcExpirationDateTime: values.expirationDate
        };
        var result = await props.apiKeyContainer.createOrgAdminApiKey(props.organizationId, request);
        if (result.resultType == "Ok") {
            props.apiKeyContainer.loadOrganizationApiKeys(props.organizationId);
            props.onFinish(result.data);
        }
    }
})(NewApiKeyFormComponent);
const modalTitleContainer = /*#__PURE__*/ (0, _css.css)("background:white;padding:0 32px;justify-content:space-between;align-items:center;border-top-right-radius:20px;border-top-left-radius:20px;border-bottom:", (0, _stylesValues.style_border_default), ";img{margin-right:16px;}", "");
const TitleWrapper = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1yg0tob1"
})({
    name: "s5xdrg",
    styles: "display:flex;align-items:center"
});
const CloseButtonWrapper = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1yg0tob0"
})("display:flex;padding-left:28.5px;border-left:", (0, _stylesValues.style_border_default), ";");
const closeButton = /*#__PURE__*/ (0, _css.css)({
    name: "xjgief",
    styles: "margin-right:-8px;margin-left:0"
});
const containerStyle = /*#__PURE__*/ (0, _css.css)(".main-body{padding:32px;background:", (0, _colors.blue_white), ";height:100%;.Select-option{z-index:10;}}.expiration-type{width:50%;}.generated-warning{font-style:normal;font-weight:normal;font-size:14px;line-height:20px;color:", (0, _colors.color_shades_darkest), ";margin-bottom:32px;}.copy-key{display:flex;font-style:normal;font-weight:normal;font-size:14px;line-height:20px;cursor:pointer;color:", (0, _colors.color_colors_ocean), ";margin-top:40px;img{margin-right:8px;}}", "");
exports.default = NewApiKeyForm;

},{"@emotion/styled/base":"lSuFu","@emotion/react":"djZKr","@emotion/css":"awUBr","formik":"3YnOK","moment":"2meyw","react":"6uln9","yup":"j2SJU","../../../components/forms/DateTimeField":"2GWq6","../../../components/forms/SelectField":"405B3","../../../components/forms/TextField":"7a7bh","../../../components/general/Button":"6ymxN","../../../components/general/ModalTitle":"hIp2B","../../../components/structure/CustomScrollbars":"50vFq","../../../components/structure/FooterBar":"bibRL","../../../components/structure/HorizontalContainer":"eJPfh","../../../constants/colors":"1p3OR","../../../constants/stylesValues":"dHVVv","9c77033cd86e65c0":"93VwA","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2GWq6":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _colors = require("../../constants/colors");
var _fieldError = require("./FieldError");
var _fieldErrorDefault = parcelHelpers.interopDefault(_fieldError);
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const calendarIcon = require("15c8babb54b1d6ec");
const DateInputField = (props)=>(0, _react.jsx)("div", {
        className: `${containerStyle} ${props.className}`
    }, (0, _react.jsx)("div", {
        className: labelContainer
    }, props.labelIcon && (0, _react.jsx)("img", {
        src: props.labelIcon
    }), props.label !== undefined ? (0, _react.jsx)("label", {
        htmlFor: props.name,
        className: labelStyle
    }, props.label) : null), (0, _react.jsx)("div", {
        className: fieldWrapper
    }, (0, _react.jsx)("div", {
        className: `${fieldContainer}  ${props.disabled ? "disabled" : ""} field-container`
    }, (0, _react.jsx)("img", {
        src: calendarIcon
    }), (0, _react.jsx)("input", {
        className: textFieldStyles,
        type: "date",
        name: props.name,
        autoFocus: props.autoFocus,
        value: props.value,
        onChange: props.onChange,
        onBlur: props.onBlur,
        onFocus: props.onFocus,
        disabled: props.disabled
    }))), props?.useForm ? (0, _react.jsx)((0, _fieldErrorDefault.default), {
        name: name
    }) : null);
const textFieldStyles = /*#__PURE__*/ (0, _css.css)("color:", (0, _colors.dark_grey_blue), ";font-family:Muli;text-align:left;width:100%;border-radius:5px;border:none;padding:12px 16px;font-size:14px;background:transparent;::placeholder{font-weight:normal;font-style:italic;letter-spacing:normal;color:", (0, _colors.cool_grey), ";}", "");
const containerStyle = /*#__PURE__*/ (0, _css.css)({
    name: "11j4wuo",
    styles: "margin-bottom:24px;flex:1;&.tight{margin-bottom:16px;label{margin:8px 16px 0 16px;}}"
});
const labelStyle = /*#__PURE__*/ (0, _css.css)({
    name: "1m6o4l9",
    styles: "font-family:Muli;font-size:14px;font-weight:600;text-align:left;margin:0 16px"
});
const labelContainer = /*#__PURE__*/ (0, _css.css)({
    name: "shwixj",
    styles: "display:flex;align-items:center;height:22px"
});
const fieldContainer = /*#__PURE__*/ (0, _css.css)("background:#FFFFFF;border:1px solid ", (0, _colors.color_shades_dark), ";box-sizing:border-box;box-shadow:inset 0px 1px 2px rgba(50, 70, 97, 0.1);border-radius:8px;display:flex;align-items:center;padding:0 8px;>img{width:20px;height:20px;}input{border:none;background:transparent;box-shadow:none;margin-left:12px;font-family:Muli;font-style:normal;font-weight:normal;font-size:14px;line-height:20px;&::-webkit-calendar-picker-indicator,&::-webkit-inner-spin-button{display:none;}}height:60px;width:100%;border-radius:5px;border:solid 1px ", (0, _colors.color_shades_dark), ";background:white;margin-top:8px;img{margin:16px;}&.disabled{background:", (0, _colors.pale_grey), ";input{background:", (0, _colors.pale_grey), ";}}", "");
const separatorStyle = /*#__PURE__*/ (0, _css.css)({
    name: "zdz8xi",
    styles: "height:30px"
});
const fieldWrapper = /*#__PURE__*/ (0, _css.css)({
    name: "fhxb3m",
    styles: "display:flex;flex-direction:row;align-items:center"
});
exports.default = DateInputField;

},{"@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","../../constants/colors":"1p3OR","./FieldError":"fDxhz","15c8babb54b1d6ec":"jTABg","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8uc0l":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _settingsCard = require("../../../components/structure/SettingsCard");
var _settingsCardDefault = parcelHelpers.interopDefault(_settingsCard);
var _css = require("@emotion/css");
var _deploymentAccounts = require("../../deploymentAccounts");
var _deploymentAccountsDefault = parcelHelpers.interopDefault(_deploymentAccounts);
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const amazonButton = require("11de00ac4adf6f04");
const googleButton = require("54fb88fe363ad435");
const loginHeader = /*#__PURE__*/ (0, _css.css)({
    name: "1u5wmk",
    styles: "display:flex;flex-wrap:wrap;flex-direction:row;justify-content:flex-end;align-items:center;margin-bottom:10px;>span{margin:8px;}"
});
const amazonLogin = /*#__PURE__*/ (0, _css.css)({
    name: "1hx2a19",
    styles: "width:170px;height:40px;cursor:pointer"
});
const googleLogin = /*#__PURE__*/ (0, _css.css)({
    name: "63b5f4",
    styles: "width:185px;height:45px;cursor:pointer"
});
class OrganizationDeploymentAccounts extends (0, _reactDefault.default).Component {
    loginWithAmazon() {
        this.props.deploymentAccountsContainer.getAmazonAuthUrl({
            organizationId: this.props.organizationId
        }).then((url)=>{
            if (url) window.open(url, "_self");
        });
    }
    loginWithGoogle() {
        this.props.deploymentAccountsContainer.getGoogleAuthUrl({
            organizationId: this.props.organizationId
        }).then((url)=>{
            if (url) window.open(url, "_self");
        });
    }
    render() {
        return (0, _react.jsx)((0, _settingsCardDefault.default), {
            title: "Deployments"
        }, (0, _react.jsx)("div", {
            className: loginHeader
        }, (0, _react.jsx)("span", null, "Link/Update an account: "), (0, _react.jsx)("span", null, (0, _react.jsx)("img", {
            src: amazonButton,
            className: amazonLogin,
            onClick: this.loginWithAmazon.bind(this)
        })), (0, _react.jsx)("span", null, (0, _react.jsx)("img", {
            src: googleButton,
            className: googleLogin,
            onClick: this.loginWithGoogle.bind(this)
        }))), (0, _react.jsx)((0, _deploymentAccountsDefault.default), {
            organizationId: this.props.organizationId
        }));
    }
}
exports.default = OrganizationDeploymentAccounts;

},{"@emotion/react":"djZKr","react":"6uln9","../../../components/structure/SettingsCard":"liIw4","@emotion/css":"awUBr","../../deploymentAccounts":"hVQ8n","11de00ac4adf6f04":"bI1tn","54fb88fe363ad435":"kz8Cp","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hVQ8n":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _unstated = require("unstated");
var _deploymentAccountsContainer = require("../../state/containers/DeploymentAccountsContainer");
var _deploymentAccountsContainerDefault = parcelHelpers.interopDefault(_deploymentAccountsContainer);
var _deploymentAccountsListView = require("./components/DeploymentAccountsListView");
var _deploymentAccountsListViewDefault = parcelHelpers.interopDefault(_deploymentAccountsListView);
var _applicationContainer = require("../../state/containers/ApplicationContainer");
var _applicationContainerDefault = parcelHelpers.interopDefault(_applicationContainer);
class DeploymentAccounts extends (0, _reactDefault.default).Component {
    render() {
        return (0, _react.jsx)((0, _unstated.Subscribe), {
            to: [
                (0, _deploymentAccountsContainerDefault.default),
                (0, _applicationContainerDefault.default)
            ]
        }, (deploymentAccounts, applications)=>{
            return (0, _react.jsx)((0, _deploymentAccountsListViewDefault.default), {
                organizationId: this.props.organizationId,
                deploymentAccountsContainer: deploymentAccounts,
                appContainer: applications
            });
        });
    }
}
exports.default = DeploymentAccounts;

},{"@emotion/react":"djZKr","react":"6uln9","unstated":"grh7p","../../state/containers/DeploymentAccountsContainer":"h0NaQ","./components/DeploymentAccountsListView":"2AeN7","../../state/containers/ApplicationContainer":"cuqi2","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2AeN7":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _sortedTable = require("../../../components/structure/SortedTable");
var _sortedTableDefault = parcelHelpers.interopDefault(_sortedTable);
var _tableCell = require("../../../components/general/TableCell");
var _tableCellDefault = parcelHelpers.interopDefault(_tableCell);
var _tableHeader = require("../../../components/general/TableHeader");
var _tableHeaderDefault = parcelHelpers.interopDefault(_tableHeader);
var _applicationAvatar = require("../../../components/general/ApplicationAvatar");
var _applicationAvatarDefault = parcelHelpers.interopDefault(_applicationAvatar);
var _css = require("@emotion/css");
var _button = require("../../../components/general/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _pageError = require("../../../components/general/PageError");
var _pageErrorDefault = parcelHelpers.interopDefault(_pageError);
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const alexaIcon = require("728e1eda9a75b107");
const googleIcon = require("d23ab96686eab317");
const rowContent = /*#__PURE__*/ (0, _css.css)({
    name: "1c0wg9p",
    styles: "display:flex;flex-wrap:wrap;flex-direction:row;align-content:center;>*{margin-right:12px;}"
});
const anchorRight = /*#__PURE__*/ (0, _css.css)({
    name: "zh6f5p",
    styles: "right:10px;position:absolute"
});
const platformIconMapping = (platform)=>{
    switch(platform){
        case "Alexa":
            return alexaIcon;
        case "Google":
            return googleIcon;
    }
};
const DeploymentAccountsListView = (props)=>{
    (0, _react1.useEffect)(()=>{
        props.deploymentAccountsContainer.updateDeploymentAccountLinksToApplications(props.organizationId);
    }, [
        props.organizationId
    ]);
    const removeCredentials = (l)=>{
        var rm = confirm("Are you sure you want to remove this account and any links to Voicify applications?");
        if (rm) switch(l.platform){
            case "Alexa":
                props.deploymentAccountsContainer.removeAmazonCredentials(l.id);
                break;
            case "Google":
                props.deploymentAccountsContainer.removeGoogleCredentials(l.id);
                break;
        }
    };
    const { accountToApplicationLinks } = props.deploymentAccountsContainer.state;
    const columns = [
        {
            id: "account",
            Header: (0, _react.jsx)((0, _tableHeaderDefault.default), {
                text: "ACCOUNT"
            }),
            accessor: (l)=>l.userName,
            Cell: (row)=>(0, _react.jsx)((0, _tableCellDefault.default), null, (0, _react.jsx)("span", {
                    className: rowContent
                }, row.value))
        },
        {
            id: "platform",
            Header: (0, _react.jsx)((0, _tableHeaderDefault.default), {
                text: "PLATFORM"
            }),
            accessor: (l)=>l.platform,
            Cell: (row)=>(0, _react.jsx)((0, _tableCellDefault.default), null, (0, _react.jsx)("span", {
                    className: rowContent
                }, (0, _react.jsx)("img", {
                    src: platformIconMapping(row.value)
                }), row.value))
        },
        {
            id: "apps",
            Header: (0, _react.jsx)((0, _tableHeaderDefault.default), {
                text: "LINKED APPS"
            }),
            accessor: (l)=>l.applicationIds,
            Cell: (row)=>(0, _react.jsx)((0, _tableCellDefault.default), null, (0, _react.jsx)("div", {
                    className: rowContent
                }, (0, _react.jsx)((0, _applicationAvatarDefault.default), {
                    size: 32,
                    app: {
                        name: `${row.value.length}`
                    },
                    key: "App"
                })))
        },
        {
            id: "removeCredentials",
            accessor: (l)=>l,
            Cell: (row)=>(0, _react.jsx)((0, _tableCellDefault.default), null, (0, _react.jsx)("span", {
                    className: anchorRight
                }, (0, _react.jsx)((0, _buttonDefault.default), {
                    themes: [
                        "small-circle"
                    ],
                    text: "x",
                    onClick: removeCredentials.bind(undefined, row.value)
                })))
        }
    ];
    return (0, _react.jsx)("div", null, (0, _react.jsx)((0, _sortedTableDefault.default), {
        data: accountToApplicationLinks,
        columns: columns
    }), (0, _react.jsx)((0, _pageErrorDefault.default), {
        errors: props.deploymentAccountsContainer.state.errors
    }));
};
exports.default = DeploymentAccountsListView;

},{"@emotion/react":"djZKr","react":"6uln9","../../../components/structure/SortedTable":"2MhF3","../../../components/general/TableCell":"2zNzE","../../../components/general/TableHeader":"9EPgz","../../../components/general/ApplicationAvatar":"aA2GK","@emotion/css":"awUBr","../../../components/general/Button":"6ymxN","../../../components/general/PageError":"ezFTm","728e1eda9a75b107":"9tBiK","d23ab96686eab317":"fgahh","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9tBiK":[function(require,module,exports) {
module.exports = require("d8b23dda14371ed").getBundleURL("kVLro") + require("83152efd1024d19").resolve("7D9mM");

},{"d8b23dda14371ed":"c7Tr5","83152efd1024d19":"fyJL2"}],"fgahh":[function(require,module,exports) {
module.exports = require("1affe051b1b30611").getBundleURL("kVLro") + require("96ba171680a149ea").resolve("g47pj");

},{"1affe051b1b30611":"c7Tr5","96ba171680a149ea":"fyJL2"}],"bI1tn":[function(require,module,exports) {
module.exports = require("3eadf1138b040b00").getBundleURL("kVLro") + require("8303488760297f8c").resolve("iguqi");

},{"3eadf1138b040b00":"c7Tr5","8303488760297f8c":"fyJL2"}],"kz8Cp":[function(require,module,exports) {
module.exports = require("40db7c98287acd12").getBundleURL("kVLro") + require("6d58ab3eccd86353").resolve("lfI2B");

},{"40db7c98287acd12":"c7Tr5","6d58ab3eccd86353":"fyJL2"}],"ibVtw":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _settingsCard = require("../../../components/structure/SettingsCard");
var _settingsCardDefault = parcelHelpers.interopDefault(_settingsCard);
var _organizationVariablesList = require("./OrganizationVariablesList");
var _organizationVariablesListDefault = parcelHelpers.interopDefault(_organizationVariablesList);
var _organizationVariablesContainer = require("../../../hooks/OrganizationVariablesContainer");
var _organizationVariablesContainerDefault = parcelHelpers.interopDefault(_organizationVariablesContainer);
const OrganizationVariablesSettings = (props)=>{
    if (!props.organizationId) return (0, _react.jsx)("div", null, "No organization ID provided");
    return (0, _react.jsx)((0, _organizationVariablesContainerDefault.default).Provider, null, (0, _react.jsx)((0, _settingsCardDefault.default), {
        title: "Organization Constants"
    }, (0, _react.jsx)((0, _organizationVariablesListDefault.default), {
        organizationId: props.organizationId
    })));
};
exports.default = OrganizationVariablesSettings;

},{"@emotion/react":"djZKr","react":"6uln9","../../../components/structure/SettingsCard":"liIw4","./OrganizationVariablesList":"nZEVh","../../../hooks/OrganizationVariablesContainer":"8P6B2","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"nZEVh":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _base = require("@emotion/styled/base");
var _baseDefault = parcelHelpers.interopDefault(_base);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _organizationVariablesContainer = require("../../../hooks/OrganizationVariablesContainer");
var _organizationVariablesContainerDefault = parcelHelpers.interopDefault(_organizationVariablesContainer);
var _button = require("../../../components/general/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _searchField = require("../../../components/forms/SearchField");
var _searchFieldDefault = parcelHelpers.interopDefault(_searchField);
var _customScrollbars = require("../../../components/structure/CustomScrollbars");
var _customScrollbarsDefault = parcelHelpers.interopDefault(_customScrollbars);
var _colors = require("../../../constants/colors");
var _organizationVariableEditModal = require("./OrganizationVariableEditModal");
var _organizationVariableEditModalDefault = parcelHelpers.interopDefault(_organizationVariableEditModal);
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const addIcon = require("cebffc30ecfa771a");
const Header = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1fgk1w72"
})({
    name: "1uutyey",
    styles: "display:flex;justify-content:space-between;align-items:center;margin-bottom:8px;padding-bottom:4px"
});
const Title = /*#__PURE__*/ (0, _baseDefault.default)("span", {
    target: "e1fgk1w71"
})("margin:0;font-size:14px;font-weight:600;color:", (0, _colors.color_shades_darkest), ";line-height:1;");
const AddButton = /*#__PURE__*/ (0, _baseDefault.default)((0, _buttonDefault.default), {
    target: "e1fgk1w70"
})({
    name: "qklzi8",
    styles: "height:24px;width:24px;min-height:24px;min-width:24px;margin-top:4px;margin-bottom:4px"
});
const OrganizationVariablesList = (props)=>{
    const variablesContainer = (0, _organizationVariablesContainerDefault.default).useContainer();
    const [isEditModalOpen, setIsEditModalOpen] = (0, _react1.useState)(false);
    const [selectedVariable, setSelectedVariable] = (0, _react1.useState)(null);
    const [searchTerm, setSearchTerm] = (0, _react1.useState)("");
    const [isLoading, setIsLoading] = (0, _react1.useState)(true);
    (0, _react1.useEffect)(()=>{
        const loadVariables = async ()=>{
            if (props.organizationId) {
                setIsLoading(true);
                try {
                    await variablesContainer.loadOrganizationVariablesByOrganizationId(props.organizationId);
                } catch (error) {
                    console.error("Error loading organization variables:", error);
                } finally{
                    setIsLoading(false);
                }
            } else setIsLoading(false);
        };
        loadVariables();
    }, [
        props.organizationId
    ]);
    const handleCreateVariable = ()=>{
        setSelectedVariable({
            name: "",
            value: "",
            organizationId: props.organizationId
        });
        setIsEditModalOpen(true);
    };
    const handleEditVariable = (variable)=>{
        setSelectedVariable(variable);
        setIsEditModalOpen(true);
    };
    const handleCloseModal = ()=>{
        setIsEditModalOpen(false);
        setSelectedVariable(null);
    };
    const handleSaveVariable = async (variable)=>{
        if (variable.id) await variablesContainer.updateOrganizationVariable(variable.id, variable);
        else await variablesContainer.createOrganizationVariable(variable);
        handleCloseModal();
    };
    const handleDeleteVariable = async (variable)=>{
        if (variable.id && window.confirm(`Are you sure you want to delete the constant "${variable.name}"?`)) {
            await variablesContainer.deleteOrganizationVariable(variable.id);
            handleCloseModal();
        }
    };
    const handleSearchChange = (e)=>{
        setSearchTerm(e.target.value);
    };
    const handleClearSearch = ()=>{
        setSearchTerm("");
    };
    const filteredVariables = variablesContainer.organizationVariables?.filter((variable)=>variable.name.toLowerCase().includes(searchTerm.toLowerCase())) || [];
    if (!props.organizationId) return (0, _react.jsx)("div", {
        className: containerStyle
    }, (0, _react.jsx)("div", {
        className: "empty-state"
    }, (0, _react.jsx)("p", null, "No organization selected.")));
    return (0, _react.jsx)("div", {
        className: containerStyle
    }, (0, _react.jsx)(Header, null, (0, _react.jsx)(Title, null, "Organization Constants"), (0, _react.jsx)(AddButton, {
        themes: [
            "icon"
        ],
        icon: addIcon,
        onClick: handleCreateVariable
    })), (0, _react.jsx)((0, _searchFieldDefault.default), {
        placeholder: "Search constants by name...",
        value: searchTerm,
        onChange: handleSearchChange,
        handleClear: handleClearSearch,
        className: "search-field-compact",
        boxType: "square"
    }), (0, _react.jsx)("div", {
        className: "variables-list"
    }, (0, _react.jsx)((0, _customScrollbarsDefault.default), {
        autoHide: true
    }, (0, _react.jsx)("div", {
        className: "scrollable-content"
    }, isLoading ? (0, _react.jsx)("div", {
        className: "empty-state"
    }, (0, _react.jsx)("p", null, "Loading constants...")) : filteredVariables.length === 0 ? (0, _react.jsx)("div", {
        className: "empty-state"
    }, searchTerm ? (0, _react.jsx)("p", null, 'No constants found matching "', searchTerm, '". Try a different search term.') : (0, _react.jsx)("p", null, "No constants found. Click the + button to create your first constant.")) : filteredVariables.map((variable)=>(0, _react.jsx)("div", {
            key: variable.id,
            className: "variable-item",
            onClick: ()=>handleEditVariable(variable)
        }, (0, _react.jsx)("div", {
            className: "variable-name"
        }, variable.name), (0, _react.jsx)("div", {
            className: "variable-value"
        }, variable.value)))))), isEditModalOpen && selectedVariable && (0, _react.jsx)((0, _organizationVariableEditModalDefault.default), {
        variable: selectedVariable,
        isVisible: isEditModalOpen,
        onClose: handleCloseModal,
        onSave: handleSaveVariable,
        onDelete: handleDeleteVariable
    }));
};
const containerStyle = /*#__PURE__*/ (0, _css.css)("padding:12px 16px 16px 16px;height:100%;display:flex;flex-direction:column;.search-field-compact{margin-bottom:8px!important;flex:none!important;>div:first-child{display:none!important;}>div:last-child>div{margin-top:0!important;}}.variables-list{flex:1;overflow:hidden;}.scrollable-content{padding-bottom:48px;}.empty-state{display:flex;align-items:center;justify-content:center;height:100px;color:", (0, _colors.color_shades_darker), ";font-style:italic;text-align:center;}.variable-item{padding:12px;border:1px solid ", (0, _colors.color_shades_dark), ";border-radius:8px;margin-bottom:8px;cursor:pointer;transition:all 0.2s ease;&:hover{border-color:", (0, _colors.color_colors_ocean), ";background-color:rgba(46, 125, 206, 0.05);}.variable-name{font-weight:600;font-size:14px;color:", (0, _colors.color_shades_darkest), ";margin-bottom:4px;}.variable-value{font-size:12px;color:", (0, _colors.color_shades_darker), ";word-break:break-all;overflow:hidden;text-overflow:ellipsis;display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;}}", "");
exports.default = OrganizationVariablesList;

},{"@emotion/styled/base":"lSuFu","@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","../../../hooks/OrganizationVariablesContainer":"8P6B2","../../../components/general/Button":"6ymxN","../../../components/forms/SearchField":"aU10T","../../../components/structure/CustomScrollbars":"50vFq","../../../constants/colors":"1p3OR","./OrganizationVariableEditModal":"14nnu","cebffc30ecfa771a":"6cI2N","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8P6B2":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _unstatedNext = require("unstated-next");
var _api = require("../api");
function useOrganizationVariablesContainer() {
    const [organizationVariables, setOrganizationVariables] = (0, _react.useState)([]);
    const [selectedOrganizationVariable, setSelectedOrganizationVariable] = (0, _react.useState)({});
    const [errors, setErrors] = (0, _react.useState)([]);
    const [currentOrgId, setCurrentOrgId] = (0, _react.useState)(null);
    const loadOrganizationVariablesByOrganizationId = async (organizationId)=>{
        try {
            const result = await _api.getOrganizationVariablesByOrganizationId(organizationId);
            if (result.resultType == "Ok") setOrganizationVariables(result.data);
            else setErrors(result.errors);
            return result;
        } catch (e) {
            setErrors(e);
        }
    };
    const loadOrganizationVariableById = async (organizationVariableId)=>{
        try {
            const result = await _api.getOrganizationVariableById(organizationVariableId);
            if (result.resultType == "Ok") setSelectedOrganizationVariable(result.data);
            else setErrors(result.errors);
            return result;
        } catch (e) {
            setErrors(e);
        }
    };
    const createOrganizationVariable = async (model)=>{
        try {
            const result = await _api.createOrganizationVariable(model);
            if (result.resultType == "Ok") setOrganizationVariables([
                ...organizationVariables,
                result.data
            ]);
            else setErrors(result.errors);
            return result;
        } catch (e) {
            setErrors(e);
        }
    };
    const updateOrganizationVariable = async (organizationVariableId, model)=>{
        try {
            const result = await _api.updateOrganizationVariable(organizationVariableId, model);
            if (result.resultType == "Ok") {
                const updatedVariables = organizationVariables.map((variable)=>variable.id === organizationVariableId ? result.data : variable);
                setOrganizationVariables(updatedVariables);
                setSelectedOrganizationVariable(result.data);
            } else setErrors(result.errors);
            return result;
        } catch (e) {
            setErrors(e);
        }
    };
    const deleteOrganizationVariable = async (organizationVariableId)=>{
        try {
            const result = await _api.deleteOrganizationVariable(organizationVariableId);
            if (result.resultType == "Ok") {
                const filteredVariables = organizationVariables.filter((variable)=>variable.id !== organizationVariableId);
                setOrganizationVariables(filteredVariables);
            } else setErrors(result.errors);
            return result;
        } catch (e) {
            setErrors(e);
        }
    };
    const clearErrors = ()=>{
        setErrors([]);
    };
    return {
        organizationVariables,
        setOrganizationVariables,
        selectedOrganizationVariable,
        setSelectedOrganizationVariable,
        errors,
        setErrors,
        loadOrganizationVariablesByOrganizationId,
        loadOrganizationVariableById,
        createOrganizationVariable,
        updateOrganizationVariable,
        deleteOrganizationVariable,
        clearErrors,
        setCurrentOrgId
    };
}
const OrganizationVariablesContainer = (0, _unstatedNext.createContainer)(useOrganizationVariablesContainer);
exports.default = OrganizationVariablesContainer;

},{"react":"6uln9","unstated-next":"61zE5","../api":"loxM6","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"14nnu":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _modalLayout = require("../../../components/structure/ModalLayout");
var _modalLayoutDefault = parcelHelpers.interopDefault(_modalLayout);
var _footerBar = require("../../../components/structure/FooterBar");
var _footerBarDefault = parcelHelpers.interopDefault(_footerBar);
var _textField = require("../../../components/forms/TextField");
var _textFieldDefault = parcelHelpers.interopDefault(_textField);
var _textAreaField = require("../../../components/forms/TextAreaField");
var _textAreaFieldDefault = parcelHelpers.interopDefault(_textAreaField);
var _button = require("../../../components/general/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _colors = require("../../../constants/colors");
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const closeIcon = require("aadd67beb07b3273");
const deleteIcon = require("8af829075811b1f5");
const OrganizationVariableEditModal = (props)=>{
    const [name, setName] = (0, _react1.useState)(props.variable.name || "");
    const [value, setValue] = (0, _react1.useState)(props.variable.value || "");
    const [nameError, setNameError] = (0, _react1.useState)("");
    const [valueError, setValueError] = (0, _react1.useState)("");
    (0, _react1.useEffect)(()=>{
        setName(props.variable.name || "");
        setValue(props.variable.value || "");
        setNameError("");
        setValueError("");
    }, [
        props.variable
    ]);
    const validateForm = ()=>{
        let isValid = true;
        if (!name.trim()) {
            setNameError("Constant name is required");
            isValid = false;
        } else setNameError("");
        if (!value.trim()) {
            setValueError("Constant value is required");
            isValid = false;
        } else setValueError("");
        return isValid;
    };
    const handleSave = ()=>{
        if (validateForm()) {
            const updatedVariable = {
                ...props.variable,
                name: name.trim(),
                value: value.trim()
            };
            props.onSave(updatedVariable);
        }
    };
    const handleDelete = ()=>{
        props.onDelete(props.variable);
    };
    const isNewVariable = !props.variable.id;
    return (0, _react.jsx)((0, _modalLayoutDefault.default), {
        className: modalStyle,
        isVisible: props.isVisible,
        onClose: props.onClose,
        zIndex: 1010
    }, (0, _react.jsx)("div", {
        className: containerStyle
    }, (0, _react.jsx)("div", {
        className: "header-wrapper"
    }, (0, _react.jsx)("h2", null, isNewVariable ? "Create Constant" : "Edit Constant"), (0, _react.jsx)((0, _buttonDefault.default), {
        className: "close-icon",
        themes: [
            "end-tight",
            "icon"
        ],
        icon: closeIcon,
        type: "button",
        onClick: props.onClose
    })), !isNewVariable && (0, _react.jsx)("div", {
        onClick: handleDelete,
        className: "delete-confirmation"
    }, (0, _react.jsx)("div", null, "Delete Constant"), (0, _react.jsx)("img", {
        src: deleteIcon,
        alt: "Delete"
    })), (0, _react.jsx)("div", {
        className: "form-container"
    }, (0, _react.jsx)((0, _textFieldDefault.default), {
        name: "name",
        value: name,
        placeholder: "Enter constant name",
        label: "Constant Name",
        onChange: (e)=>setName(e.target.value),
        useForm: false
    }), nameError && (0, _react.jsx)("div", {
        className: "error-message"
    }, nameError), (0, _react.jsx)((0, _textAreaFieldDefault.default), {
        name: "value",
        value: value,
        placeholder: "Enter constant value",
        label: "Constant Value",
        onChange: (e)=>setValue(e.target.value),
        minRows: 8,
        maxRows: 25,
        useForm: false
    }), valueError && (0, _react.jsx)("div", {
        className: "error-message"
    }, valueError)), (0, _react.jsx)((0, _footerBarDefault.default), null, (0, _react.jsx)((0, _buttonDefault.default), {
        themes: [
            "primary",
            "wide"
        ],
        onClick: handleSave,
        text: isNewVariable ? "Create" : "Save",
        type: "button"
    }), (0, _react.jsx)((0, _buttonDefault.default), {
        themes: [
            "white",
            "end"
        ],
        onClick: props.onClose,
        text: "Cancel",
        type: "button"
    }))));
};
const modalStyle = /*#__PURE__*/ (0, _css.css)({
    name: "oi79z1",
    styles: "width:66vw;height:auto;max-height:80vh;min-height:850px;display:flex;flex-direction:column"
});
const containerStyle = /*#__PURE__*/ (0, _css.css)("display:flex;flex-direction:column;height:100%;max-height:80vh;overflow:hidden;.header-wrapper{display:flex;justify-content:space-between;align-items:center;padding:24px 32px 16px 32px;border-bottom:solid 1px ", (0, _colors.color_shades_dark), ";flex-shrink:0;h2{margin:0;font-size:24px;font-weight:600;color:", (0, _colors.color_shades_darkest), ";}.close-icon{cursor:pointer;}}.delete-confirmation{color:", (0, _colors.color_colors_ocean), ";position:absolute;right:32px;top:120px;cursor:pointer;display:flex;align-items:center;z-index:1;div{font-style:normal;font-weight:normal;font-size:14px;line-height:20px;margin-right:8px;}img{width:16px;height:16px;}&:hover{opacity:0.7;}}.form-container{padding:32px;padding-bottom:16px;flex:1;overflow-y:auto;min-height:0;.error-message{color:#e74c3c;font-size:12px;margin-top:4px;margin-bottom:16px;}}", "");
exports.default = OrganizationVariableEditModal;

},{"@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","../../../components/structure/ModalLayout":"b1cO3","../../../components/structure/FooterBar":"bibRL","../../../components/forms/TextField":"7a7bh","../../../components/forms/TextAreaField":"fE54C","../../../components/general/Button":"6ymxN","../../../constants/colors":"1p3OR","aadd67beb07b3273":"93VwA","8af829075811b1f5":"f9rzT","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"icUDW":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _base = require("@emotion/styled/base");
var _baseDefault = parcelHelpers.interopDefault(_base);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _api = require("../../../api");
var _button = require("../../../components/general/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _loader = require("../../../components/general/Loader");
var _loaderDefault = parcelHelpers.interopDefault(_loader);
var _pageError = require("../../../components/general/PageError");
var _pageErrorDefault = parcelHelpers.interopDefault(_pageError);
var _colors = require("../../../constants/colors");
var _confirmationDialog = require("../../../components/structure/ConfirmationDialog");
var _confirmationDialogDefault = parcelHelpers.interopDefault(_confirmationDialog);
var _warningConfirmation = require("../../../components/general/WarningConfirmation");
var _warningConfirmationDefault = parcelHelpers.interopDefault(_warningConfirmation);
var _moduleConsts = require("../../../constants/sparkConstants/moduleConsts");
var _xlsx = require("xlsx");
var _menuContainer = require("../../../hooks/MenuContainer");
var _menuContainerDefault = parcelHelpers.interopDefault(_menuContainer);
var _menuSyncContainer = require("../../../hooks/MenuSyncContainer");
var _menuSyncContainerDefault = parcelHelpers.interopDefault(_menuSyncContainer);
var _useBulkAppOperations = require("../../../hooks/useBulkAppOperations");
var _useBulkAppOperationsDefault = parcelHelpers.interopDefault(_useBulkAppOperations);
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const OrganizationManagementSettings = ({ organizationId, applicationContainer, appliedTemplateContainer, applicationEnvironmentsContainer })=>{
    const [errors, setErrors] = (0, _react1.useState)([]);
    const [showConfirmationModal, setShowConfirmationModal] = (0, _react1.useState)(false);
    const [selectedApps, setSelectedApps] = (0, _react1.useState)(new Set());
    const [sharedTopicsApp, setSharedTopicsApp] = (0, _react1.useState)(null);
    const [locationSpecificFields, setLocationSpecificFields] = (0, _react1.useState)([]);
    const [isLoadingSharedTopics, setIsLoadingSharedTopics] = (0, _react1.useState)(false);
    const [selectedFields, setSelectedFields] = (0, _react1.useState)(new Set());
    const [isImporting, setIsImporting] = (0, _react1.useState)(false);
    const [importProgress, setImportProgress] = (0, _react1.useState)("");
    const [importedData, setImportedData] = (0, _react1.useState)(null);
    const [isApplying, setIsApplying] = (0, _react1.useState)(false);
    const [posConfigKey, setPosConfigKey] = (0, _react1.useState)("");
    const [posConfigValue, setPosConfigValue] = (0, _react1.useState)("");
    const [isUpdatingPosConfig, setIsUpdatingPosConfig] = (0, _react1.useState)(false);
    const [menuItemCounts, setMenuItemCounts] = (0, _react1.useState)(new Map());
    const [showManageMenuApps, setShowManageMenuApps] = (0, _react1.useState)(false);
    const [menuSyncApiKey, setMenuSyncApiKey] = (0, _react1.useState)("");
    const [menuSyncConfig, setMenuSyncConfig] = (0, _react1.useState)("");
    const [searchTerm, setSearchTerm] = (0, _react1.useState)("");
    const [refreshCacheApiKey, setRefreshCacheApiKey] = (0, _react1.useState)("");
    const [isMenuProcessing, setIsMenuProcessing] = (0, _react1.useState)(false);
    const menuContainer = (0, _menuContainerDefault.default).useContainer();
    const menuSyncContainer = (0, _menuSyncContainerDefault.default).useContainer();
    // Bulk app operations hook
    const { isProcessing: isModuleSyncing, logs: bulkOperationLogs, syncApps, publishApps, clearLogs } = (0, _useBulkAppOperationsDefault.default)({
        appliedTemplateContainer,
        applicationEnvironmentsContainer
    });
    // Combined processing state
    const isPublishing = isModuleSyncing || isMenuProcessing;
    (0, _react1.useEffect)(()=>{
        // Apps are already loaded by parent component (OrganizationSettingsTabs)
        // No need to call getBaseApplicationsForOrg here
        if (appliedTemplateContainer) loadSharedTopicsFields();
    }, [
        organizationId
    ]);
    // Filter out manage menu apps themselves - use same logic as ApplicationDashboard
    // Keep location apps that have associated manage menu apps
    const appsWithMenuManagement = applicationContainer.state.baseOrgApplications.filter((app)=>{
        // If showing manage menu apps, include everything
        if (showManageMenuApps) return true;
        // Filter out apps that ARE manage menu apps based on their name
        if (app?.name?.toLowerCase()?.includes("manage menu") || app?.name?.toLowerCase()?.includes("manage entities") || app?.name?.toLowerCase()?.startsWith("x -") && app?.name?.toLowerCase()?.endsWith("menu")) return false;
        // Filter out apps that ARE referenced as manage menu apps by other apps
        if (applicationContainer.state.baseOrgApplications.some((a)=>a.manageMenuApplicationId === app.id)) return false;
        return true;
    });
    // Filter apps based on search term with advanced syntax
    // Supports: !"exclude"|term1|term2 format
    // Pipe separates AND conditions, !" before quoted text means exclude
    const filteredApps = appsWithMenuManagement.filter((app)=>{
        if (!searchTerm.trim()) return true;
        const appName = app.name?.toLowerCase() || "";
        // Split by pipe to get individual search terms
        const terms = searchTerm.split("|").map((t)=>t.trim()).filter((t)=>t);
        // Separate exclusion terms and inclusion terms
        const exclusionTerms = [];
        const inclusionTerms = [];
        terms.forEach((term)=>{
            // Check if it's an exclusion term: !"text" or !'text'
            const exclusionMatch = term.match(/^!"(.+)"$/) || term.match(/^!'(.+)'$/);
            if (exclusionMatch) exclusionTerms.push(exclusionMatch[1].toLowerCase());
            else {
                // Remove quotes if present for regular terms
                const cleanTerm = term.replace(/^["']|["']$/g, "");
                inclusionTerms.push(cleanTerm.toLowerCase());
            }
        });
        // First check exclusions - if any exclusion term is found, exclude this app
        for (const excludeTerm of exclusionTerms){
            if (appName.includes(excludeTerm)) return false;
        }
        // If no inclusion terms, show all (that aren't excluded)
        if (inclusionTerms.length === 0) return true;
        // Check if ALL inclusion terms match (AND logic)
        return inclusionTerms.every((term)=>appName.includes(term));
    });
    const loadMenuItemCounts = async ()=>{
        const counts = new Map();
        for (const app of appsWithMenuManagement){
            if (!app.manageMenuApplicationId) {
                console.warn(`App ${app.name} has no manageMenuApplicationId`);
                continue;
            }
            try {
                // Get menu items for main app
                const mainResult = await _api.getVoicifyMenuItems(app.id);
                const mainCount = mainResult?.resultType === "Ok" && mainResult.data ? mainResult.data.length : 0;
                // Get menu items for manage menu app
                const manageResult = await _api.getVoicifyMenuItems(app.manageMenuApplicationId);
                const manageCount = manageResult?.resultType === "Ok" && manageResult.data ? manageResult.data.length : 0;
                counts.set(app.id, {
                    main: mainCount,
                    manage: manageCount
                });
            } catch (error) {
                console.error(`Error loading menu items for ${app.name}:`, error);
            }
        }
        setMenuItemCounts(counts);
    };
    const loadSharedTopicsFields = async ()=>{
        setIsLoadingSharedTopics(true);
        try {
            // Get all org applications - use loadAll: true to ensure we get all apps
            const appsResult = await applicationContainer.searchForOrgApplications(organizationId, 1, 50, undefined, undefined, true);
            const apps = appsResult?.data?.applications ?? [];
            // Find the Shared Topics app - try exact match first, then partial match
            let sharedTopics = apps.find((app)=>app.name?.toLowerCase()?.trim() === (0, _moduleConsts.aiAnsweringCommonAppName).toLowerCase() && app.allowsTemplating);
            // If not found, try partial match
            if (!sharedTopics) sharedTopics = apps.find((app)=>app.name?.toLowerCase()?.includes("shared topics") && app.allowsTemplating);
            // If still not found, try without allowsTemplating requirement
            if (!sharedTopics) sharedTopics = apps.find((app)=>app.name?.toLowerCase()?.includes("shared topics"));
            console.log("Found shared topics app:", sharedTopics);
            if (sharedTopics && appliedTemplateContainer) {
                setSharedTopicsApp(sharedTopics);
                // Load applied templates for the shared topics app
                const appliedTemplatesResult = await appliedTemplateContainer.loadAppliedTemplates(sharedTopics.id);
                if (appliedTemplatesResult?.resultType === "Ok") {
                    const appliedTemplates = appliedTemplatesResult.data;
                    // Extract location-specific fields
                    const locationFields = [];
                    const fieldSet = new Set();
                    appliedTemplates.forEach((appliedTemplate)=>{
                        appliedTemplate.templateForm?.templateFormSections?.forEach((section)=>{
                            section.templateFormFields?.forEach((field)=>{
                                // A field is location-specific if it has a value matching its associated variable
                                const fieldValue = appliedTemplate.templateFormFieldValues?.find((v)=>v.templateFormFieldId === field.id);
                                if (fieldValue?.associatedVariable && fieldValue.associatedVariable === fieldValue.value) // Use title as unique identifier to avoid duplicates
                                {
                                    if (!fieldSet.has(field.title)) {
                                        fieldSet.add(field.title);
                                        locationFields.push({
                                            ...field,
                                            name: section.title // Store section title for display
                                        });
                                    }
                                }
                            });
                        });
                    });
                    setLocationSpecificFields(locationFields);
                }
            }
        } catch (error) {
            console.error("Error loading shared topics fields:", error);
        } finally{
            setIsLoadingSharedTopics(false);
        }
    };
    const toggleAppSelection = (appId)=>{
        const newSelected = new Set(selectedApps);
        if (newSelected.has(appId)) newSelected.delete(appId);
        else newSelected.add(appId);
        setSelectedApps(newSelected);
    };
    const toggleSelectAll = ()=>{
        if (selectedApps.size === appsWithMenuManagement.length) setSelectedApps(new Set());
        else setSelectedApps(new Set(appsWithMenuManagement.map((app)=>app.id)));
    };
    const selectNonManageMenuOnly = ()=>{
        const nonManageMenuApps = appsWithMenuManagement.filter((app)=>!app.name.toLowerCase().includes("manage menu"));
        setSelectedApps(new Set(nonManageMenuApps.map((app)=>app.id)));
    };
    const selectVisibleApps = ()=>{
        setSelectedApps(new Set(filteredApps.map((app)=>app.id)));
    };
    const toggleFieldSelection = (fieldTitle)=>{
        const newSelected = new Set(selectedFields);
        if (newSelected.has(fieldTitle)) newSelected.delete(fieldTitle);
        else newSelected.add(fieldTitle);
        setSelectedFields(newSelected);
    };
    const toggleAllFields = ()=>{
        if (selectedFields.size === locationSpecificFields.length) setSelectedFields(new Set());
        else setSelectedFields(new Set(locationSpecificFields.map((field)=>field.title)));
    };
    const importFromExcel = async (event)=>{
        const file = event.target.files?.[0];
        if (!file) return;
        try {
            setIsImporting(true);
            setErrors([]);
            setImportProgress("Reading Excel file...");
            // Read the file
            const data = await file.arrayBuffer();
            const workbook = _xlsx.read(data);
            const worksheet = workbook.Sheets[workbook.SheetNames[0]];
            const jsonData = _xlsx.utils.sheet_to_json(worksheet, {
                header: 1
            });
            if (jsonData.length < 2) {
                setErrors([
                    "Excel file is empty or has no data rows"
                ]);
                return;
            }
            // Parse headers and data
            const headers = jsonData[0];
            const dataRows = jsonData.slice(1);
            // Validate required columns
            const locationIdIndex = headers.findIndex((h)=>h === "Location ID");
            const locationNameIndex = headers.findIndex((h)=>h === "Location Name");
            if (locationIdIndex === -1 || locationNameIndex === -1) {
                setErrors([
                    'Excel file must have "Location ID" and "Location Name" columns'
                ]);
                return;
            }
            // Get field columns (everything after Location ID and Location Name)
            const fieldHeaders = headers.slice(2);
            setImportProgress(`Validating ${dataRows.length} locations...`);
            const validationErrors = [];
            const parsedData = [];
            // Validate and parse data without saving
            for(let i = 0; i < dataRows.length; i++){
                const row = dataRows[i];
                const locationId = row[locationIdIndex];
                const locationName = row[locationNameIndex];
                if (!locationId) continue;
                setImportProgress(`Validating ${i + 1}/${dataRows.length}: ${locationName || locationId}...`);
                // Find the application by id (matching the export which uses app.id)
                let app = applicationContainer.state.baseOrgApplications.find((a)=>a.id === locationId);
                if (!app) {
                    validationErrors.push(`Location not found: ${locationName || locationId}`);
                    continue;
                }
                // Parse field changes
                const fieldChanges = [];
                for(let fieldIndex = 0; fieldIndex < fieldHeaders.length; fieldIndex++){
                    const fieldTitle = fieldHeaders[fieldIndex];
                    const newValue = row[2 + fieldIndex]; // +2 to skip Location ID and Location Name
                    if (newValue !== undefined && newValue !== null && newValue !== "") fieldChanges.push({
                        fieldTitle,
                        newValue: String(newValue)
                    });
                }
                if (fieldChanges.length > 0) parsedData.push({
                    locationId,
                    locationName: locationName || app.name,
                    appId: app.id,
                    fieldChanges
                });
            }
            setImportProgress("");
            if (parsedData.length === 0) {
                setErrors([
                    "No valid data found in Excel file"
                ]);
                return;
            }
            // Store imported data for preview
            setImportedData(parsedData);
            if (validationErrors.length > 0) setErrors([
                `Loaded ${parsedData.length} locations from Excel with ${validationErrors.length} warnings. Click "Apply Changes" to save the updates.`,
                ...validationErrors.slice(0, 10),
                ...validationErrors.length > 10 ? [
                    `...and ${validationErrors.length - 10} more warnings`
                ] : []
            ]);
            else setErrors([
                `Successfully loaded ${parsedData.length} locations from Excel. Review the changes below and click "Apply Changes" to save.`
            ]);
        } catch (error) {
            console.error("Error importing Excel:", error);
            setErrors([
                "Error importing Excel: " + error.toString()
            ]);
        } finally{
            setIsImporting(false);
            setImportProgress("");
            // Reset file input
            event.target.value = "";
        }
    };
    const applyChanges = async ()=>{
        if (!importedData || importedData.length === 0) {
            setErrors([
                "No imported data to apply"
            ]);
            return;
        }
        try {
            setIsApplying(true);
            setErrors([]);
            setImportProgress("Applying changes...");
            let successCount = 0;
            let errorCount = 0;
            const applyErrors = [];
            for(let i = 0; i < importedData.length; i++){
                const locationData = importedData[i];
                console.log(locationData);
                setImportProgress(`Applying ${i + 1}/${importedData.length}: ${locationData.locationName}...`);
                try {
                    // Load applied templates for this app
                    const appliedTemplatesResult = await appliedTemplateContainer.loadAppliedTemplates(locationData.appId);
                    if (appliedTemplatesResult?.resultType !== "Ok") {
                        applyErrors.push(`Failed to load templates for ${locationData.locationName}`);
                        errorCount++;
                        continue;
                    }
                    const appliedTemplates = appliedTemplatesResult.data;
                    // Process each field change
                    for (const fieldChange of locationData.fieldChanges){
                        // Find the applied template and field that matches this field title
                        let updated = false;
                        for (const appliedTemplate of appliedTemplates){
                            for (const section of appliedTemplate.templateForm?.templateFormSections || []){
                                const field = section.templateFormFields?.find((f)=>f.title === fieldChange.fieldTitle);
                                if (field) {
                                    console.log(field.title);
                                    // Find or create the field value
                                    let fieldValue = appliedTemplate.templateFormFieldValues?.find((v)=>v.templateFormFieldId === field.id);
                                    if (!fieldValue) {
                                        console.log("here1");
                                        fieldValue = {
                                            templateFormFieldId: field.id,
                                            value: fieldChange.newValue,
                                            associatedVariable: field.associatedVariable,
                                            label: field.label,
                                            fieldType: field.fieldType,
                                            placeholder: field.placeholder,
                                            defaultValue: field.defaultValue,
                                            tip: field.tip,
                                            title: field.title,
                                            appliedApplicationTemplateId: appliedTemplate.id
                                        };
                                        appliedTemplate.templateFormFieldValues.push(fieldValue);
                                    } else {
                                        console.log("here2");
                                        fieldValue.value = fieldChange.newValue;
                                    }
                                    updated = true;
                                    break;
                                }
                            }
                            if (updated) break;
                        }
                    }
                    // Save updated templates using updateAppliedTemplate for each template
                    let allSuccess = true;
                    console.log(appliedTemplates);
                    for (const appliedTemplate of appliedTemplates){
                        const updateRequest = {
                            templateFormFieldValues: appliedTemplate.templateFormFieldValues,
                            dynamicFormSections: appliedTemplate.templateForm.templateFormSections.filter((s)=>s?.name)
                        };
                        const result = await appliedTemplateContainer.updateAppliedTemplate(appliedTemplate.id, updateRequest);
                        if (result?.resultType !== "Ok") {
                            allSuccess = false;
                            break;
                        }
                    }
                    if (allSuccess) successCount++;
                    else {
                        applyErrors.push(`Failed to save updates for ${locationData.locationName}`);
                        errorCount++;
                    }
                } catch (error) {
                    console.error(`Error applying changes for location ${locationData.locationName}:`, error);
                    applyErrors.push(`Error applying changes to ${locationData.locationName}: ${error.toString()}`);
                    errorCount++;
                }
            }
            setImportProgress("");
            if (applyErrors.length > 0) setErrors([
                `Applied changes with ${successCount} successes and ${errorCount} errors:`,
                ...applyErrors.slice(0, 10),
                ...applyErrors.length > 10 ? [
                    `...and ${applyErrors.length - 10} more errors`
                ] : []
            ]);
            else {
                setErrors([
                    `Successfully applied changes to ${successCount} locations!`
                ]);
                setImportedData(null); // Clear imported data after successful apply
            }
        } catch (error) {
            console.error("Error applying changes:", error);
            setErrors([
                "Error applying changes: " + error.toString()
            ]);
        } finally{
            setIsApplying(false);
            setImportProgress("");
        }
    };
    const updateApplicationSecretsInPosConfig = async ()=>{
        if (selectedApps.size === 0) {
            setErrors([
                "Please select at least one location"
            ]);
            return;
        }
        try {
            setIsUpdatingPosConfig(true);
            setErrors([]);
            setImportProgress("Updating application secrets in POS config...");
            const selectedApplications = appsWithMenuManagement.filter((app)=>selectedApps.has(app.id));
            let successCount = 0;
            let errorCount = 0;
            const updateErrors = [];
            for(let i = 0; i < selectedApplications.length; i++){
                const app = selectedApplications[i];
                setImportProgress(`Updating ${i + 1}/${selectedApplications.length}: ${app.name}...`);
                try {
                    if (!app.secret) {
                        updateErrors.push(`${app.name} has no application secret`);
                        errorCount++;
                        continue;
                    }
                    // Get current POS config
                    const currentConfigResult = await _api.getPOSConfig(app.id);
                    let configObj = {};
                    // Parse existing config if it exists
                    if (currentConfigResult?.resultType === "Ok" && currentConfigResult.data) try {
                        configObj = JSON.parse(currentConfigResult.data);
                    } catch (parseError) {
                        console.warn(`Failed to parse existing config for ${app.name}, starting fresh`, parseError);
                    }
                    // Update the applicationSecret key with the app's secret
                    configObj["applicationSecret"] = app.secret;
                    // Stringify and update
                    const newConfigString = JSON.stringify(configObj, null, 2);
                    const updateResult = await _api.updatePOSConfig(app.id, newConfigString);
                    if (updateResult?.resultType === "Ok") {
                        // Call refresh cache if API key is provided
                        if (refreshCacheApiKey && app.posLocationId && app.posName) {
                            setImportProgress(`Refreshing cache ${i + 1}/${selectedApplications.length}: ${app.name}...`);
                            try {
                                await _api.refreshPOSCache(app.id, app.posLocationId, refreshCacheApiKey, app.posName);
                            } catch (cacheError) {
                                console.warn(`Failed to refresh cache for ${app.name}:`, cacheError);
                            }
                        }
                        successCount++;
                    } else {
                        updateErrors.push(`Failed to update ${app.name}: ${updateResult?.errors?.join(", ")}`);
                        errorCount++;
                    }
                } catch (error) {
                    console.error(`Error updating application secret for ${app.name}:`, error);
                    updateErrors.push(`Error updating ${app.name}: ${error.toString()}`);
                    errorCount++;
                }
            }
            setImportProgress("");
            if (updateErrors.length > 0) setErrors([
                `Updated application secrets with ${successCount} successes and ${errorCount} errors:`,
                ...updateErrors.slice(0, 10),
                ...updateErrors.length > 10 ? [
                    `...and ${updateErrors.length - 10} more errors`
                ] : []
            ]);
            else setErrors([
                `Successfully updated application secrets in POS config for ${successCount} locations!`
            ]);
        } catch (error) {
            console.error("Error updating application secrets:", error);
            setErrors([
                "Error updating application secrets: " + error.toString()
            ]);
        } finally{
            setIsUpdatingPosConfig(false);
            setImportProgress("");
        }
    };
    const generateMenuSyncConfig = ()=>{
        if (selectedApps.size === 0) {
            setErrors([
                "Please select at least one location"
            ]);
            return;
        }
        if (!menuSyncApiKey) {
            setErrors([
                "Please provide an API key"
            ]);
            return;
        }
        try {
            setErrors([]);
            const selectedApplications = appsWithMenuManagement.filter((app)=>selectedApps.has(app.id));
            if (selectedApplications.length === 0) {
                setErrors([
                    "No applications selected"
                ]);
                return;
            }
            // First selected app is primary, rest are secondary
            const [primaryApp, ...secondaryApps] = selectedApplications;
            const config = {
                menuConfiguration: {
                    primaryLocation: {
                        manageMenuApplicationId: primaryApp.manageMenuApplicationId || "",
                        manageMenuApplicationName: applicationContainer.state.orgApplicationsList.find((a)=>a.id == primaryApp.manageMenuApplicationId)?.name,
                        liveApplicationId: primaryApp.id,
                        liveApplicationName: primaryApp.name,
                        apiKey: menuSyncApiKey
                    },
                    secondaryLocations: secondaryApps.map((app)=>({
                            manageMenuApplicationId: app.manageMenuApplicationId || "",
                            manageMenuApplicationName: applicationContainer.state.orgApplicationsList.find((a)=>a.id == app.manageMenuApplicationId)?.name || "",
                            liveApplicationId: app.id,
                            liveApplicationName: app.name,
                            apiKey: menuSyncApiKey
                        }))
                }
            };
            const configJson = JSON.stringify(config, null, 2);
            setMenuSyncConfig(configJson);
            setErrors([
                `Generated menu sync configuration for ${selectedApplications.length} location${selectedApplications.length > 1 ? "s" : ""}`
            ]);
        } catch (error) {
            console.error("Error generating menu sync config:", error);
            setErrors([
                "Error generating menu sync config: " + error.toString()
            ]);
        }
    };
    const copyMenuSyncConfig = ()=>{
        if (!menuSyncConfig) {
            setErrors([
                "No configuration to copy. Please generate the configuration first."
            ]);
            return;
        }
        navigator.clipboard.writeText(menuSyncConfig).then(()=>{
            setErrors([
                "Configuration copied to clipboard!"
            ]);
        }).catch((err)=>{
            console.error("Failed to copy:", err);
            setErrors([
                "Failed to copy configuration to clipboard"
            ]);
        });
    };
    const updatePosConfigForSelectedLocations = async ()=>{
        if (selectedApps.size === 0) {
            setErrors([
                "Please select at least one location"
            ]);
            return;
        }
        if (!posConfigKey || !posConfigValue) {
            setErrors([
                "Please enter both a key and value for the POS config update"
            ]);
            return;
        }
        try {
            setIsUpdatingPosConfig(true);
            setErrors([]);
            setImportProgress("Updating POS config...");
            const selectedApplications = appsWithMenuManagement.filter((app)=>selectedApps.has(app.id));
            let successCount = 0;
            let errorCount = 0;
            const updateErrors = [];
            for(let i = 0; i < selectedApplications.length; i++){
                const app = selectedApplications[i];
                setImportProgress(`Updating ${i + 1}/${selectedApplications.length}: ${app.name}...`);
                try {
                    // Get current POS config
                    const currentConfigResult = await _api.getPOSConfig(app.id);
                    let configObj = {};
                    // Parse existing config if it exists
                    if (currentConfigResult?.resultType === "Ok" && currentConfigResult.data) try {
                        configObj = JSON.parse(currentConfigResult.data);
                    } catch (parseError) {
                        // If parsing fails, start with empty object
                        console.warn(`Failed to parse existing config for ${app.name}, starting fresh`, parseError);
                    }
                    // Update or add the key
                    // Try to parse the value as JSON first (for arrays, objects, etc.)
                    let parsedValue;
                    try {
                        parsedValue = JSON.parse(posConfigValue);
                    } catch  {
                        // If it's not valid JSON, use it as a string
                        parsedValue = posConfigValue;
                    }
                    configObj[posConfigKey] = parsedValue;
                    // Stringify and update
                    const newConfigString = JSON.stringify(configObj, null, 2);
                    const updateResult = await _api.updatePOSConfig(app.id, newConfigString);
                    if (updateResult?.resultType === "Ok") {
                        // Call refresh cache if API key is provided
                        if (refreshCacheApiKey && app.posLocationId && app.posName) {
                            setImportProgress(`Refreshing cache ${i + 1}/${selectedApplications.length}: ${app.name}...`);
                            try {
                                const response = await _api.refreshPOSCache(app.id, app.posLocationId, refreshCacheApiKey, app.posName);
                                console.log(response);
                            } catch (cacheError) {
                                console.warn(`Failed to refresh cache for ${app.name}:`, cacheError);
                            }
                        }
                        successCount++;
                    } else {
                        updateErrors.push(`Failed to update ${app.name}: ${updateResult?.errors?.join(", ")}`);
                        errorCount++;
                    }
                } catch (error) {
                    console.error(`Error updating POS config for ${app.name}:`, error);
                    updateErrors.push(`Error updating ${app.name}: ${error.toString()}`);
                    errorCount++;
                }
            }
            setImportProgress("");
            if (updateErrors.length > 0) setErrors([
                `Updated POS config with ${successCount} successes and ${errorCount} errors:`,
                ...updateErrors.slice(0, 10),
                ...updateErrors.length > 10 ? [
                    `...and ${updateErrors.length - 10} more errors`
                ] : []
            ]);
            else {
                setErrors([
                    `Successfully updated POS config for ${successCount} locations! Key "${posConfigKey}" set to "${posConfigValue}"`
                ]);
                // Clear inputs after successful update
                setPosConfigKey("");
                setPosConfigValue("");
            }
        } catch (error) {
            console.error("Error updating POS config:", error);
            setErrors([
                "Error updating POS config: " + error.toString()
            ]);
        } finally{
            setIsUpdatingPosConfig(false);
            setImportProgress("");
        }
    };
    const exportToExcel = async ()=>{
        if (selectedApps.size === 0 || selectedFields.size === 0) {
            setErrors([
                "Please select at least one application/location and one field to export"
            ]);
            return;
        }
        try {
            setIsLoadingSharedTopics(true);
            // Prepare data for Excel - use the selected apps from Menu Management section
            const selectedApplications = appsWithMenuManagement.filter((app)=>selectedApps.has(app.id));
            const selectedFieldsList = locationSpecificFields.filter((field)=>selectedFields.has(field.title));
            // Create header row
            const headers = [
                "Location ID",
                "Location Name",
                ...selectedFieldsList.map((field)=>field.title)
            ];
            // Create data rows with actual field values
            const data = [];
            for (const app of selectedApplications){
                const row = [
                    app.id,
                    app.name
                ];
                // Load applied templates for this location app
                if (appliedTemplateContainer) {
                    const appliedTemplatesResult = await appliedTemplateContainer.loadAppliedTemplates(app.id);
                    if (appliedTemplatesResult?.resultType === "Ok") {
                        const appliedTemplates = appliedTemplatesResult.data;
                        // For each selected field, find its value in this location's templates
                        for (const selectedField of selectedFieldsList){
                            let fieldValue = "";
                            // Search through all applied templates for this location
                            for (const template of appliedTemplates){
                                // Find the field by title
                                const field = template.templateForm?.templateFormSections?.flatMap((section)=>section.templateFormFields)?.find((f)=>f.title === selectedField.title);
                                if (field) {
                                    // Find the value for this field
                                    const value = template.templateFormFieldValues?.find((v)=>v.templateFormFieldId === field.id);
                                    if (value?.value) {
                                        fieldValue = value.value;
                                        break;
                                    }
                                }
                            }
                            row.push(fieldValue);
                        }
                    } else // If we can't load templates, add empty cells
                    selectedFieldsList.forEach(()=>row.push(""));
                } else // If no template container, add empty cells
                selectedFieldsList.forEach(()=>row.push(""));
                data.push(row);
            }
            // Create worksheet
            const ws = _xlsx.utils.aoa_to_sheet([
                headers,
                ...data
            ]);
            // Create workbook
            const wb = _xlsx.utils.book_new();
            _xlsx.utils.book_append_sheet(wb, ws, "Location Specific Topics");
            // Generate file name with timestamp
            const timestamp = new Date().toISOString().split("T")[0];
            const fileName = `location_specific_topics_${timestamp}.xlsx`;
            // Save file
            _xlsx.writeFile(wb, fileName);
        } catch (error) {
            console.error("Error exporting to Excel:", error);
            setErrors([
                "Error exporting to Excel: " + error.toString()
            ]);
        } finally{
            setIsLoadingSharedTopics(false);
        }
    };
    const publishAllMenus = async ()=>{
        setIsMenuProcessing(true);
        setErrors([]);
        try {
            const selectedApplications = appsWithMenuManagement.filter((app)=>selectedApps.has(app.id));
            if (selectedApplications.length === 0) {
                setErrors([
                    "No applications selected"
                ]);
                return;
            }
            let publishedCount = 0;
            let skippedCount = 0;
            let errorCount = 0;
            for (const app of selectedApplications){
                if (!app.manageMenuApplicationId) {
                    setErrors((prevErrors)=>[
                            ...prevErrors,
                            `⚠ ${app.name}: No manage menu application configured (skipped)`
                        ]);
                    skippedCount++;
                    continue;
                }
                try {
                    await menuContainer.publishAllChanges(app, organizationId);
                    setErrors((prevErrors)=>[
                            ...prevErrors,
                            `✓ ${app.name}: Successfully published`
                        ]);
                    publishedCount++;
                } catch (error) {
                    setErrors((prevErrors)=>[
                            ...prevErrors,
                            `✗ ${app.name}: ${error.toString()}`
                        ]);
                    errorCount++;
                }
            }
            // Add summary
            setErrors((prevErrors)=>[
                    `\nSummary: ${publishedCount} published, ${skippedCount} skipped, ${errorCount} errors`,
                    ...prevErrors
                ]);
        } catch (error) {
            setErrors((prevErrors)=>[
                    ...prevErrors,
                    `Fatal error: ${error.toString()}`
                ]);
        } finally{
            setIsMenuProcessing(false);
            setShowConfirmationModal(false);
        }
    };
    const syncMenusWithPOS = async ()=>{
        if (selectedApps.size === 0) {
            setErrors([
                "Please select at least one location"
            ]);
            return;
        }
        setIsMenuProcessing(true);
        setErrors([]);
        try {
            const selectedApplications = appsWithMenuManagement.filter((app)=>selectedApps.has(app.id));
            const batchSize = 6;
            let syncedCount = 0;
            let errorCount = 0;
            let skippedCount = 0;
            setErrors([
                `Syncing menus with POS for ${selectedApplications.length} locations in batches of ${batchSize}...`
            ]);
            // Process in batches of 6
            for(let i = 0; i < selectedApplications.length; i += batchSize){
                const batch = selectedApplications.slice(i, i + batchSize);
                const batchNumber = Math.floor(i / batchSize) + 1;
                const totalBatches = Math.ceil(selectedApplications.length / batchSize);
                setErrors((prevErrors)=>[
                        ...prevErrors,
                        `\nProcessing batch ${batchNumber}/${totalBatches} (${batch.length} locations)...`
                    ]);
                // Start all syncs in the batch
                const batchResults = [];
                for (const app of batch){
                    const overallIndex = i + batch.indexOf(app) + 1;
                    if (!app.manageMenuApplicationId || !app.posLocationId || !app.posName) {
                        setErrors((prevErrors)=>[
                                ...prevErrors,
                                `#${overallIndex}/${selectedApplications.length} ⚠ ${app.name}: Missing required config (skipped)`
                            ]);
                        skippedCount++;
                        batchResults.push({
                            app,
                            started: false
                        });
                        continue;
                    }
                    try {
                        setErrors((prevErrors)=>[
                                ...prevErrors,
                                `#${overallIndex}/${selectedApplications.length} Starting menu sync for ${app.name}...`
                            ]);
                        await menuContainer.syncMenuWithPOS(app, {
                            retainAugmentation: true,
                            retainMenuBooleans: true,
                            addSynonymsOnly: false,
                            disableNewMenuItems: false,
                            orgId: organizationId
                        });
                        batchResults.push({
                            app,
                            started: true
                        });
                    } catch (error) {
                        setErrors((prevErrors)=>[
                                ...prevErrors,
                                `#${overallIndex}/${selectedApplications.length} ✗ ${app.name}: ${error.toString()}`
                            ]);
                        errorCount++;
                        batchResults.push({
                            app,
                            started: false
                        });
                    }
                }
                // Wait for all syncs in the batch to complete
                const appsToWaitFor = batchResults.filter((r)=>r.started).map((r)=>r.app);
                if (appsToWaitFor.length > 0) {
                    setErrors((prevErrors)=>[
                            ...prevErrors,
                            `Waiting for batch ${batchNumber}/${totalBatches} to complete (${appsToWaitFor.length} syncing)...`
                        ]);
                    let allComplete = false;
                    let waitAttempts = 0;
                    const maxWaitAttempts = 300; // 5 minutes max wait (300 * 1 second)
                    while(!allComplete && waitAttempts < maxWaitAttempts){
                        await new Promise((resolve)=>setTimeout(resolve, 1000)); // Wait 1 second
                        waitAttempts++;
                        // Check if all apps in batch are done syncing
                        const stillSyncing = appsToWaitFor.filter((app)=>menuSyncContainer.isApplicationSyncing(app.id));
                        if (stillSyncing.length === 0) {
                            allComplete = true;
                            syncedCount += appsToWaitFor.length;
                            setErrors((prevErrors)=>[
                                    ...prevErrors,
                                    `✓ Batch ${batchNumber}/${totalBatches} complete!`
                                ]);
                        } else if (waitAttempts % 10 === 0) // Log progress every 10 seconds
                        setErrors((prevErrors)=>[
                                ...prevErrors,
                                `Still waiting... ${stillSyncing.length} locations syncing (${waitAttempts}s elapsed)`
                            ]);
                    }
                    if (!allComplete) {
                        setErrors((prevErrors)=>[
                                ...prevErrors,
                                `⚠ Batch ${batchNumber}/${totalBatches} timed out after ${maxWaitAttempts} seconds`
                            ]);
                        errorCount += appsToWaitFor.length;
                    }
                }
            }
            setErrors((prevErrors)=>[
                    ...prevErrors,
                    `\n✓ Menu sync with POS completed: ${syncedCount} successful, ${skippedCount} skipped, ${errorCount} errors`
                ]);
        } catch (error) {
            setErrors((prevErrors)=>[
                    ...prevErrors,
                    `Fatal error: ${error.toString()}`
                ]);
        } finally{
            setIsMenuProcessing(false);
        }
    };
    const publishTemplatesForSelectedLocations = async ()=>{
        if (selectedApps.size === 0) {
            setErrors([
                "Please select at least one location"
            ]);
            return;
        }
        const selectedApplications = appsWithMenuManagement.filter((app)=>selectedApps.has(app.id));
        await publishApps(selectedApplications);
    };
    const moduleSyncAllLocations = async ()=>{
        // Sync all location apps (except shared topics and manage menu apps)
        const locationApps = applicationContainer.state.baseOrgApplications.filter((app)=>!app.name.toLowerCase().includes("manage menu") && app.id !== sharedTopicsApp?.id);
        await syncApps(locationApps, sharedTopicsApp);
        setShowConfirmationModal(false);
    };
    const moduleSyncSelectedLocations = async ()=>{
        if (selectedApps.size === 0) {
            setErrors([
                "Please select at least one location"
            ]);
            return;
        }
        const selectedApplications = appsWithMenuManagement.filter((app)=>selectedApps.has(app.id));
        await syncApps(selectedApplications, sharedTopicsApp);
    };
    // Parent component (OrganizationSettingsTabs) handles loading state
    // No need to show loader here
    return (0, _react.jsx)(Container, null, (0, _react.jsx)(Header, null, (0, _react.jsx)(Title, null, "Menu Management"), (0, _react.jsx)(Description, null, "Train and publish menus for all applications in this organization")), appsWithMenuManagement.length === 0 ? (0, _react.jsx)(EmptyState, null, (0, _react.jsx)(EmptyStateText, null, "No applications with menu management found in this organization.")) : (0, _react.jsx)((0, _reactDefault.default).Fragment, null, (0, _react.jsx)(SearchBar, null, (0, _react.jsx)(SearchInput, {
        type: "text",
        placeholder: 'Search by name (e.g., location1|location2|!"exclude")',
        value: searchTerm,
        onChange: (e)=>setSearchTerm(e.target.value)
    }), (0, _react.jsx)(SearchInfo, null, searchTerm ? `Showing ${filteredApps.length} of ${appsWithMenuManagement.length} applications` : 'Use | to separate search terms (AND). Use !"text" to exclude apps containing text. Example: !"[FD]"|!"[TJ]"')), (0, _react.jsx)(ActionsBar, null, (0, _react.jsx)(SelectionControls, null, (0, _react.jsx)(SelectionInfo, null, (0, _react.jsx)(Checkbox, {
        type: "checkbox",
        checked: selectedApps.size === appsWithMenuManagement.length,
        onChange: toggleSelectAll
    }), (0, _react.jsx)("span", null, selectedApps.size, " of ", appsWithMenuManagement.length, " selected")), (0, _react.jsx)((0, _buttonDefault.default), {
        themes: [
            "secondary-small"
        ],
        text: "Select Non-Manage Menu Only",
        onClick: selectNonManageMenuOnly
    }), (0, _react.jsx)((0, _buttonDefault.default), {
        themes: [
            "secondary-small"
        ],
        text: `Select Visible (${filteredApps.length})`,
        onClick: selectVisibleApps,
        disabled: filteredApps.length === 0
    }), (0, _react.jsx)((0, _buttonDefault.default), {
        themes: [
            "secondary-small"
        ],
        text: "Load Menu Counts",
        onClick: loadMenuItemCounts
    }), (0, _react.jsx)((0, _buttonDefault.default), {
        themes: [
            "secondary-small"
        ],
        text: showManageMenuApps ? "Hide Manage Menu Apps" : "Show Manage Menu Apps",
        onClick: ()=>setShowManageMenuApps(!showManageMenuApps)
    })), (0, _react.jsx)(ButtonGroup, null, (0, _react.jsx)((0, _buttonDefault.default), {
        themes: [
            "secondary"
        ],
        text: "Module Sync All Locations",
        onClick: moduleSyncAllLocations,
        disabled: isPublishing || !sharedTopicsApp
    }), (0, _react.jsx)((0, _buttonDefault.default), {
        themes: [
            "secondary"
        ],
        text: `Module Sync Selected (${selectedApps.size})`,
        onClick: moduleSyncSelectedLocations,
        disabled: selectedApps.size === 0 || isPublishing || !sharedTopicsApp
    }), (0, _react.jsx)((0, _buttonDefault.default), {
        themes: [
            "secondary"
        ],
        text: `Backup and Publish (${selectedApps.size})`,
        onClick: publishTemplatesForSelectedLocations,
        disabled: selectedApps.size === 0 || isPublishing || !applicationEnvironmentsContainer
    }), (0, _react.jsx)((0, _buttonDefault.default), {
        themes: [
            "secondary"
        ],
        text: `Sync with POS (${selectedApps.size})`,
        onClick: syncMenusWithPOS,
        disabled: selectedApps.size === 0 || isPublishing
    }), (0, _react.jsx)((0, _buttonDefault.default), {
        themes: [
            "primary"
        ],
        text: `Publish ${selectedApps.size} ${selectedApps.size === 1 ? "Menu" : "Menus"}`,
        onClick: ()=>setShowConfirmationModal(true),
        disabled: selectedApps.size === 0 || isPublishing
    }))), bulkOperationLogs.length > 0 && (0, _react.jsx)(SyncLogSection, null, (0, _react.jsx)(SyncLogHeader, null, (0, _react.jsx)("span", null, "Sync Progress"), !isPublishing && (0, _react.jsx)((0, _buttonDefault.default), {
        themes: [
            "secondary-small"
        ],
        text: "Clear Log",
        onClick: clearLogs
    })), (0, _react.jsx)(SyncLogArea, null, bulkOperationLogs.map((log, index)=>(0, _react.jsx)(SyncLogLine, {
            key: index
        }, log)))), (0, _react.jsx)(ApplicationsList, null, filteredApps.map((app)=>(0, _react.jsx)(ApplicationCard, {
            key: app.id,
            selected: selectedApps.has(app.id)
        }, (0, _react.jsx)(CardContent, {
            onClick: ()=>toggleAppSelection(app.id)
        }, (0, _react.jsx)(Checkbox, {
            type: "checkbox",
            checked: selectedApps.has(app.id),
            onChange: ()=>toggleAppSelection(app.id),
            onClick: (e)=>e.stopPropagation()
        }), (0, _react.jsx)(ApplicationInfo, null, (0, _react.jsx)(ApplicationName, null, app.name), app.posName && (0, _react.jsx)(ApplicationMeta, null, "POS: ", app.posName), menuItemCounts.has(app.id) && (0, _react.jsx)((0, _reactDefault.default).Fragment, null, (0, _react.jsx)(ApplicationMeta, null, "Main App Menu Items: ", menuItemCounts.get(app.id)?.main ?? 0), (0, _react.jsx)(ApplicationMeta, null, "Manage Menu Items: ", menuItemCounts.get(app.id)?.manage ?? 0)))))))), showConfirmationModal && (0, _react.jsx)((0, _confirmationDialogDefault.default), {
        title: "Publish Menus",
        deleteText: "Yes, Publish",
        warning: true,
        disabled: isPublishing,
        onClose: ()=>setShowConfirmationModal(false),
        onConfirm: publishAllMenus
    }, isPublishing ? (0, _react.jsx)((0, _loaderDefault.default), null) : (0, _react.jsx)((0, _warningConfirmationDefault.default), {
        useWarningColor: true,
        text: `Are you sure you want to train and publish menus for ${selectedApps.size} ${selectedApps.size === 1 ? "application" : "applications"}? This will update the live assistants with the latest menu changes.`
    })), (0, _react.jsx)(Header, {
        style: {
            marginTop: "48px"
        }
    }, (0, _react.jsx)(Title, null, "POS Config Update"), (0, _react.jsx)(Description, null, "Update or add a specific key-value pair in the POS config JSON for selected locations. Optionally provide an API key to refresh the cache after updating.")), (0, _react.jsx)(PosConfigSection, null, (0, _react.jsx)(InputGroup, null, (0, _react.jsx)(Label, null, "Refresh Cache API Key (Optional)"), (0, _react.jsx)(Input, {
        type: "text",
        placeholder: "Enter x-api-key for cache refresh (optional)",
        value: refreshCacheApiKey,
        onChange: (e)=>setRefreshCacheApiKey(e.target.value),
        disabled: isUpdatingPosConfig
    })), (0, _react.jsx)(QuickActionWrapper, null, (0, _react.jsx)((0, _buttonDefault.default), {
        themes: [
            "secondary"
        ],
        text: isUpdatingPosConfig ? "Updating..." : `Update Application Secrets for ${selectedApps.size} ${selectedApps.size === 1 ? "Location" : "Locations"}`,
        onClick: updateApplicationSecretsInPosConfig,
        disabled: selectedApps.size === 0 || isUpdatingPosConfig
    })), (0, _react.jsx)(Divider, null, "OR"), (0, _react.jsx)(PosConfigInputs, null, (0, _react.jsx)(InputGroup, null, (0, _react.jsx)(Label, null, "Config Key"), (0, _react.jsx)(Input, {
        type: "text",
        placeholder: "e.g., storeNumber",
        value: posConfigKey,
        onChange: (e)=>setPosConfigKey(e.target.value),
        disabled: isUpdatingPosConfig
    })), (0, _react.jsx)(InputGroup, null, (0, _react.jsx)(Label, null, "Config Value"), (0, _react.jsx)(Input, {
        type: "text",
        placeholder: "e.g., 12345",
        value: posConfigValue,
        onChange: (e)=>setPosConfigValue(e.target.value),
        disabled: isUpdatingPosConfig
    }))), (0, _react.jsx)((0, _buttonDefault.default), {
        themes: [
            "primary"
        ],
        text: isUpdatingPosConfig ? "Updating..." : `Update Custom Key for ${selectedApps.size} ${selectedApps.size === 1 ? "Location" : "Locations"}`,
        onClick: updatePosConfigForSelectedLocations,
        disabled: selectedApps.size === 0 || isUpdatingPosConfig || !posConfigKey || !posConfigValue
    }), importProgress && isUpdatingPosConfig && (0, _react.jsx)(ProgressText, null, importProgress)), (0, _react.jsx)(Header, {
        style: {
            marginTop: "48px"
        }
    }, (0, _react.jsx)(Title, null, "Generate Menu Sync Config"), (0, _react.jsx)(Description, null, "Generate a menu sync configuration JSON for selected locations. The first selected location will be the primary location, and the rest will be secondary locations. All locations will use the same API key.")), (0, _react.jsx)(MenuSyncSection, null, (0, _react.jsx)(InputGroup, null, (0, _react.jsx)(Label, null, "API Key"), (0, _react.jsx)(Input, {
        type: "text",
        placeholder: "Enter API key for all locations",
        value: menuSyncApiKey,
        onChange: (e)=>setMenuSyncApiKey(e.target.value)
    })), (0, _react.jsx)(ButtonGroup, null, (0, _react.jsx)((0, _buttonDefault.default), {
        themes: [
            "primary"
        ],
        text: `Generate Config for ${selectedApps.size} Location${selectedApps.size === 1 ? "" : "s"}`,
        onClick: generateMenuSyncConfig,
        disabled: selectedApps.size === 0 || !menuSyncApiKey
    }), menuSyncConfig && (0, _react.jsx)((0, _buttonDefault.default), {
        themes: [
            "secondary"
        ],
        text: "Copy to Clipboard",
        onClick: copyMenuSyncConfig
    })), menuSyncConfig && (0, _react.jsx)(ConfigDisplay, null, (0, _react.jsx)(ConfigHeader, null, "Generated Configuration:"), (0, _react.jsx)(ConfigCode, null, menuSyncConfig))), appliedTemplateContainer && (0, _react.jsx)((0, _reactDefault.default).Fragment, null, (0, _react.jsx)(Header, {
        style: {
            marginTop: "48px"
        }
    }, (0, _react.jsx)(Title, null, "Location-Specific Topics Export"), (0, _react.jsx)(Description, null, "Select locations and topics to export as an Excel spreadsheet")), isLoadingSharedTopics ? (0, _react.jsx)((0, _loaderDefault.default), null) : !sharedTopicsApp ? (0, _react.jsx)(EmptyState, null, (0, _react.jsx)(EmptyStateText, null, "No Shared Topics application found in this organization.")) : locationSpecificFields.length === 0 ? (0, _react.jsx)(EmptyState, null, (0, _react.jsx)(EmptyStateText, null, "No location-specific topics configured yet.")) : (0, _react.jsx)((0, _reactDefault.default).Fragment, null, (0, _react.jsx)(SelectionSection, null, (0, _react.jsx)(SectionHeader, null, (0, _react.jsx)(SectionTitle, null, "Select Topics"), (0, _react.jsx)(SelectionInfo, null, (0, _react.jsx)(Checkbox, {
        type: "checkbox",
        checked: selectedFields.size === locationSpecificFields.length && locationSpecificFields.length > 0,
        onChange: toggleAllFields
    }), (0, _react.jsx)("span", null, selectedFields.size, " of ", locationSpecificFields.length, " selected"))), (0, _react.jsx)(FieldsList, null, locationSpecificFields.map((field, index)=>(0, _react.jsx)(FieldCard, {
            key: `${field.id}-${index}`,
            selected: selectedFields.has(field.title),
            onClick: ()=>toggleFieldSelection(field.title)
        }, (0, _react.jsx)(Checkbox, {
            type: "checkbox",
            checked: selectedFields.has(field.title),
            onChange: ()=>toggleFieldSelection(field.title),
            onClick: (e)=>e.stopPropagation()
        }), (0, _react.jsx)(FieldInfo, null, (0, _react.jsx)(FieldTitle, null, field.title), field.name && (0, _react.jsx)(FieldSection, null, "Section: ", field.name), field.tip && (0, _react.jsx)(FieldDescription, null, field.tip)))))), (0, _react.jsx)(Header, {
        style: {
            marginTop: "32px"
        }
    }, (0, _react.jsx)(Title, null, "Import & Export"), (0, _react.jsx)(Description, null, 'Import an Excel file to bulk update location-specific topics. The Excel file should have "Location ID" and "Location Name" columns, followed by the topic field columns. You can export data first to get the correct format.')), (0, _react.jsx)(ImportExportButtonWrapper, null, (0, _react.jsx)(ImportButtonWrapper, null, (0, _react.jsx)("input", {
        type: "file",
        accept: ".xlsx,.xls",
        onChange: importFromExcel,
        style: {
            display: "none"
        },
        id: "excel-import-input",
        disabled: isImporting || isApplying
    }), (0, _react.jsx)("label", {
        htmlFor: "excel-import-input"
    }, (0, _react.jsx)((0, _buttonDefault.default), {
        themes: [
            "secondary"
        ],
        text: isImporting ? "Importing..." : "Import from Excel",
        onClick: ()=>document.getElementById("excel-import-input")?.click(),
        disabled: isImporting || isApplying
    })), importProgress && (0, _react.jsx)(ProgressText, null, importProgress)), (0, _react.jsx)((0, _buttonDefault.default), {
        themes: [
            "primary"
        ],
        text: `Export to Excel (${selectedApps.size} locations, ${selectedFields.size} topics)`,
        onClick: exportToExcel,
        disabled: selectedApps.size === 0 || selectedFields.size === 0 || isImporting || isApplying
    })), importedData && importedData.length > 0 && (0, _react.jsx)((0, _reactDefault.default).Fragment, null, (0, _react.jsx)(Header, {
        style: {
            marginTop: "32px"
        }
    }, (0, _react.jsx)(Title, null, "Review Imported Changes"), (0, _react.jsx)(Description, null, 'Review the imported data below. Click "Apply Changes" to save these updates to the database.')), (0, _react.jsx)(ImportPreviewSection, null, (0, _react.jsx)(ImportPreviewHeader, null, (0, _react.jsx)("span", null, importedData.length, " locations with pending changes"), (0, _react.jsx)((0, _buttonDefault.default), {
        themes: [
            "primary"
        ],
        text: isApplying ? "Applying..." : `Apply Changes to ${importedData.length} Locations`,
        onClick: applyChanges,
        disabled: isApplying || isImporting
    })), (0, _react.jsx)(ImportPreviewList, null, importedData.slice(0, 10).map((location, index)=>(0, _react.jsx)(ImportPreviewCard, {
            key: index
        }, (0, _react.jsx)(LocationHeader, null, (0, _react.jsx)(LocationName, null, location.locationName), (0, _react.jsx)(LocationId, null, "ID: ", location.locationId)), (0, _react.jsx)(FieldChangesList, null, location.fieldChanges.map((change, changeIndex)=>(0, _react.jsx)(FieldChangeItem, {
                key: changeIndex
            }, (0, _react.jsx)(FieldChangeLabel, null, change.fieldTitle, ":"), (0, _react.jsx)(FieldChangeValue, null, change.newValue)))))), importedData.length > 10 && (0, _react.jsx)(MoreLocationsNote, null, "...and ", importedData.length - 10, " more locations")))))), (0, _react.jsx)((0, _pageErrorDefault.default), {
        errors: errors
    }));
};
const Container = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "eymp2xk59"
})({
    name: "klisov",
    styles: "display:flex;flex-direction:column;gap:24px"
});
const Header = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "eymp2xk58"
})({
    name: "3w0yoi",
    styles: "display:flex;flex-direction:column;gap:8px"
});
const Title = /*#__PURE__*/ (0, _baseDefault.default)("h2", {
    target: "eymp2xk57"
})({
    name: "18q5szo",
    styles: "margin:0;font-size:24px;font-weight:600"
});
const Description = /*#__PURE__*/ (0, _baseDefault.default)("p", {
    target: "eymp2xk56"
})({
    name: "4nmj52",
    styles: "margin:0;color:#666;font-size:14px"
});
const EmptyState = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "eymp2xk55"
})("display:flex;align-items:center;justify-content:center;padding:48px 24px;background:", (0, _colors.color_defaults_white), ";border:1px solid ", (0, _colors.color_shades_dark), ";border-radius:8px;");
const EmptyStateText = /*#__PURE__*/ (0, _baseDefault.default)("p", {
    target: "eymp2xk54"
})({
    name: "18fxd5b",
    styles: "color:#666;font-size:14px;margin:0"
});
const ActionsBar = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "eymp2xk53"
})("display:flex;flex-direction:column;gap:16px;padding:16px;background:", (0, _colors.color_defaults_white), ";border:1px solid ", (0, _colors.color_shades_dark), ";border-radius:8px;@media (min-width: 1200px){flex-direction:row;justify-content:space-between;align-items:center;}");
const SelectionControls = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "eymp2xk52"
})({
    name: "15a9qhe",
    styles: "display:flex;align-items:center;flex-wrap:wrap;gap:12px"
});
const ButtonGroup = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "eymp2xk51"
})({
    name: "15a9qhe",
    styles: "display:flex;align-items:center;flex-wrap:wrap;gap:12px"
});
const SelectionInfo = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "eymp2xk50"
})({
    name: "1pqrhzx",
    styles: "display:flex;align-items:center;gap:12px;font-size:14px"
});
const Checkbox = /*#__PURE__*/ (0, _baseDefault.default)("input", {
    target: "eymp2xk49"
})({
    name: "1yczt5p",
    styles: "width:18px;height:18px;cursor:pointer"
});
const ApplicationsList = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "eymp2xk48"
})({
    name: "1mhgfxj",
    styles: "display:grid;grid-template-columns:repeat(auto-fill, minmax(300px, 1fr));gap:16px"
});
const ApplicationCard = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "eymp2xk47"
})("border:2px solid ", (props)=>props.selected ? (0, _colors.color_highlights_blue) : (0, _colors.color_shades_dark), ";border-radius:8px;background:", (0, _colors.color_defaults_white), ";transition:all 0.2s ease;cursor:pointer;&:hover{transform:translateY(-2px);box-shadow:0 4px 12px rgba(0, 0, 0, 0.1);}");
const CardContent = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "eymp2xk46"
})({
    name: "1i89dxw",
    styles: "display:flex;align-items:flex-start;gap:12px;padding:16px"
});
const ApplicationInfo = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "eymp2xk45"
})({
    name: "1tcizyl",
    styles: "display:flex;flex-direction:column;gap:4px;flex:1"
});
const ApplicationName = /*#__PURE__*/ (0, _baseDefault.default)("h3", {
    target: "eymp2xk44"
})({
    name: "1kpbwcc",
    styles: "margin:0;font-size:16px;font-weight:600"
});
const ApplicationMeta = /*#__PURE__*/ (0, _baseDefault.default)("p", {
    target: "eymp2xk43"
})({
    name: "rsfbxs",
    styles: "margin:0;font-size:13px;color:#666"
});
const SelectionSection = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "eymp2xk42"
})({
    name: "g6c5vq",
    styles: "display:flex;flex-direction:column;gap:16px;margin-bottom:32px"
});
const SectionHeader = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "eymp2xk41"
})("display:flex;justify-content:space-between;align-items:center;padding:16px;background:", (0, _colors.color_defaults_white), ";border:1px solid ", (0, _colors.color_shades_dark), ";border-radius:8px;");
const SectionTitle = /*#__PURE__*/ (0, _baseDefault.default)("h3", {
    target: "eymp2xk40"
})({
    name: "8c0djx",
    styles: "margin:0;font-size:18px;font-weight:600"
});
const FieldsList = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "eymp2xk39"
})({
    name: "lg2yyu",
    styles: "display:grid;grid-template-columns:repeat(auto-fill, minmax(280px, 1fr));gap:16px"
});
const FieldCard = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "eymp2xk38"
})("padding:16px;background:", (0, _colors.color_defaults_white), ";border:2px solid ", (props)=>props.selected ? (0, _colors.color_highlights_blue) : (0, _colors.color_shades_dark), ";border-radius:8px;display:flex;align-items:flex-start;gap:12px;cursor:", (props)=>props.selected !== undefined ? "pointer" : "default", ";transition:all 0.2s ease;", (props)=>props.selected !== undefined && `
        &:hover {
            transform: translateY(-2px);
            box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
        }
    `, ";");
const FieldInfo = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "eymp2xk37"
})({
    name: "pl5a4v",
    styles: "display:flex;flex-direction:column;gap:8px;flex:1"
});
const FieldTitle = /*#__PURE__*/ (0, _baseDefault.default)("h4", {
    target: "eymp2xk36"
})({
    name: "ldr8xp",
    styles: "margin:0;font-size:14px;font-weight:600;color:#333"
});
const FieldSection = /*#__PURE__*/ (0, _baseDefault.default)("p", {
    target: "eymp2xk35"
})("margin:0;font-size:12px;color:", (0, _colors.color_highlights_blue), ";font-weight:500;");
const FieldDescription = /*#__PURE__*/ (0, _baseDefault.default)("p", {
    target: "eymp2xk34"
})({
    name: "11td22w",
    styles: "margin:0;font-size:12px;color:#666;line-height:1.4"
});
const ExportButtonWrapper = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "eymp2xk33"
})({
    name: "bbldrs",
    styles: "display:flex;justify-content:flex-end;margin-top:24px"
});
const ImportExportButtonWrapper = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "eymp2xk32"
})({
    name: "c1eqtc",
    styles: "display:flex;justify-content:space-between;align-items:center;margin-top:24px;gap:16px"
});
const ImportButtonWrapper = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "eymp2xk31"
})({
    name: "3w0yoi",
    styles: "display:flex;flex-direction:column;gap:8px"
});
const ProgressText = /*#__PURE__*/ (0, _baseDefault.default)("p", {
    target: "eymp2xk30"
})("margin:0;font-size:13px;color:", (0, _colors.color_highlights_blue), ";font-weight:500;");
const ImportPreviewSection = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "eymp2xk29"
})({
    name: "anhfq1",
    styles: "display:flex;flex-direction:column;gap:16px;margin-top:16px"
});
const ImportPreviewHeader = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "eymp2xk28"
})("display:flex;justify-content:space-between;align-items:center;padding:16px;background:", (0, _colors.color_defaults_white), ";border:2px solid ", (0, _colors.color_highlights_blue), ";border-radius:8px;font-weight:600;");
const ImportPreviewList = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "eymp2xk27"
})({
    name: "tw4sx",
    styles: "display:flex;flex-direction:column;gap:12px"
});
const ImportPreviewCard = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "eymp2xk26"
})("padding:16px;background:", (0, _colors.color_defaults_white), ";border:1px solid ", (0, _colors.color_shades_dark), ";border-radius:8px;");
const LocationHeader = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "eymp2xk25"
})("display:flex;justify-content:space-between;align-items:center;margin-bottom:12px;padding-bottom:12px;border-bottom:1px solid ", (0, _colors.color_shades_dark), ";");
const LocationName = /*#__PURE__*/ (0, _baseDefault.default)("h4", {
    target: "eymp2xk24"
})({
    name: "6d7a74",
    styles: "margin:0;font-size:16px;font-weight:600;color:#333"
});
const LocationId = /*#__PURE__*/ (0, _baseDefault.default)("span", {
    target: "eymp2xk23"
})({
    name: "w3pehn",
    styles: "font-size:13px;color:#666"
});
const FieldChangesList = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "eymp2xk22"
})({
    name: "3w0yoi",
    styles: "display:flex;flex-direction:column;gap:8px"
});
const FieldChangeItem = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "eymp2xk21"
})({
    name: "urqszi",
    styles: "display:flex;flex-direction:column;gap:4px"
});
const FieldChangeLabel = /*#__PURE__*/ (0, _baseDefault.default)("span", {
    target: "eymp2xk20"
})("font-size:12px;font-weight:600;color:", (0, _colors.color_highlights_blue), ";");
const FieldChangeValue = /*#__PURE__*/ (0, _baseDefault.default)("span", {
    target: "eymp2xk19"
})({
    name: "1c5xglk",
    styles: "font-size:14px;color:#333;padding:8px;background:#f5f5f5;border-radius:4px"
});
const MoreLocationsNote = /*#__PURE__*/ (0, _baseDefault.default)("p", {
    target: "eymp2xk18"
})("margin:0;padding:16px;text-align:center;font-size:14px;color:#666;font-style:italic;background:", (0, _colors.color_defaults_white), ";border:1px dashed ", (0, _colors.color_shades_dark), ";border-radius:8px;");
const PosConfigSection = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "eymp2xk17"
})("display:flex;flex-direction:column;gap:16px;padding:24px;background:", (0, _colors.color_defaults_white), ";border:1px solid ", (0, _colors.color_shades_dark), ";border-radius:8px;");
const PosConfigInputs = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "eymp2xk16"
})({
    name: "hwt67g",
    styles: "display:grid;grid-template-columns:1fr 1fr;gap:16px"
});
const InputGroup = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "eymp2xk15"
})({
    name: "3w0yoi",
    styles: "display:flex;flex-direction:column;gap:8px"
});
const Label = /*#__PURE__*/ (0, _baseDefault.default)("label", {
    target: "eymp2xk14"
})({
    name: "i8c6z6",
    styles: "font-size:14px;font-weight:600;color:#333"
});
const Input = /*#__PURE__*/ (0, _baseDefault.default)("input", {
    target: "eymp2xk13"
})("padding:10px 12px;font-size:14px;border:1px solid ", (0, _colors.color_shades_dark), ";border-radius:4px;background:", (0, _colors.color_defaults_white), ";color:#333;&:focus{outline:none;border-color:", (0, _colors.color_highlights_blue), ";}&:disabled{background:#f5f5f5;cursor:not-allowed;}&::placeholder{color:#999;}");
const SearchBar = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "eymp2xk12"
})("display:flex;flex-direction:column;gap:8px;padding:16px;background:", (0, _colors.color_defaults_white), ";border:1px solid ", (0, _colors.color_shades_dark), ";border-radius:8px;");
const SearchInput = /*#__PURE__*/ (0, _baseDefault.default)("input", {
    target: "eymp2xk11"
})("padding:12px 16px;font-size:14px;border:1px solid ", (0, _colors.color_shades_dark), ";border-radius:4px;background:", (0, _colors.color_defaults_white), ";color:#333;&:focus{outline:none;border-color:", (0, _colors.color_highlights_blue), ";box-shadow:0 0 0 2px rgba(0, 123, 255, 0.1);}&::placeholder{color:#999;}");
const SearchInfo = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "eymp2xk10"
})({
    name: "16olgyj",
    styles: "font-size:13px;color:#666;font-style:italic"
});
const QuickActionWrapper = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "eymp2xk9"
})({
    name: "e3viwr",
    styles: "display:flex;justify-content:center;width:100%"
});
const Divider = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "eymp2xk8"
})("display:flex;align-items:center;text-align:center;color:#999;font-size:14px;font-weight:600;margin:8px 0;&::before,&::after{content:'';flex:1;border-bottom:1px solid ", (0, _colors.color_shades_dark), ";}&::before{margin-right:16px;}&::after{margin-left:16px;}");
const MenuSyncSection = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "eymp2xk7"
})("display:flex;flex-direction:column;gap:16px;padding:24px;background:", (0, _colors.color_defaults_white), ";border:1px solid ", (0, _colors.color_shades_dark), ";border-radius:8px;");
const ConfigDisplay = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "eymp2xk6"
})({
    name: "4b9zd2",
    styles: "display:flex;flex-direction:column;gap:12px;margin-top:8px"
});
const ConfigHeader = /*#__PURE__*/ (0, _baseDefault.default)("h4", {
    target: "eymp2xk5"
})({
    name: "ldr8xp",
    styles: "margin:0;font-size:14px;font-weight:600;color:#333"
});
const ConfigCode = /*#__PURE__*/ (0, _baseDefault.default)("pre", {
    target: "eymp2xk4"
})("margin:0;padding:16px;background:#f5f5f5;border:1px solid ", (0, _colors.color_shades_dark), ";border-radius:4px;font-size:13px;font-family:'Monaco','Menlo','Ubuntu Mono','Consolas','source-code-pro',monospace;overflow-x:auto;color:#333;line-height:1.5;");
const SyncLogSection = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "eymp2xk3"
})({
    name: "md2v54",
    styles: "display:flex;flex-direction:column;gap:8px;margin:16px 0"
});
const SyncLogHeader = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "eymp2xk2"
})({
    name: "6szydq",
    styles: "display:flex;justify-content:space-between;align-items:center;font-size:14px;font-weight:600;color:#333"
});
const SyncLogArea = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "eymp2xk1"
})({
    name: "pxgao7",
    styles: "max-height:300px;overflow-y:auto;padding:16px;background:#1e1e1e;border-radius:8px;font-family:'Monaco','Menlo','Ubuntu Mono','Consolas',monospace;font-size:12px"
});
const SyncLogLine = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "eymp2xk0"
})({
    name: "22hqym",
    styles: "color:#d4d4d4;line-height:1.6;white-space:pre-wrap;word-break:break-word;&:nth-of-type(odd){color:#9cdcfe;}"
});
exports.default = OrganizationManagementSettings;

},{"@emotion/styled/base":"lSuFu","@emotion/react":"djZKr","react":"6uln9","../../../api":"loxM6","../../../components/general/Button":"6ymxN","../../../components/general/Loader":"bnV5T","../../../components/general/PageError":"ezFTm","../../../constants/colors":"1p3OR","../../../components/structure/ConfirmationDialog":"kx7yK","../../../components/general/WarningConfirmation":"9OccO","../../../constants/sparkConstants/moduleConsts":"e2wLw","xlsx":"1jrO6","../../../hooks/MenuContainer":"kshI5","../../../hooks/MenuSyncContainer":"dn6gk","../../../hooks/useBulkAppOperations":"kJJQi","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1jrO6":[function(require,module,exports) {
/*! xlsx.js (C) 2013-present SheetJS -- http://sheetjs.com */ /* vim: set ts=2: */ /*exported XLSX */ /*global process:false, Buffer:false, ArrayBuffer:false, DataView:false, Deno:false */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "set_cptable", ()=>set_cptable);
parcelHelpers.export(exports, "set_fs", ()=>set_fs);
parcelHelpers.export(exports, "version", ()=>version);
parcelHelpers.export(exports, "parse_xlscfb", ()=>parse_xlscfb);
parcelHelpers.export(exports, "parse_zip", ()=>parse_zip);
parcelHelpers.export(exports, "read", ()=>readSync);
parcelHelpers.export(exports, "readFile", ()=>readFileSync);
parcelHelpers.export(exports, "readFileSync", ()=>readFileSync);
parcelHelpers.export(exports, "write", ()=>writeSync);
parcelHelpers.export(exports, "writeFile", ()=>writeFileSync);
parcelHelpers.export(exports, "writeFileSync", ()=>writeFileSync);
parcelHelpers.export(exports, "writeFileAsync", ()=>writeFileAsync);
parcelHelpers.export(exports, "writeXLSX", ()=>writeSyncXLSX);
parcelHelpers.export(exports, "writeFileXLSX", ()=>writeFileSyncXLSX);
parcelHelpers.export(exports, "utils", ()=>utils);
parcelHelpers.export(exports, "stream", ()=>__stream);
parcelHelpers.export(exports, "SSF", ()=>SSF);
parcelHelpers.export(exports, "CFB", ()=>CFB);
var Buffer = require("f481c164bc92069e").Buffer;
var process = require("1e1b0fdaf6fdd859");
var XLSX = {};
XLSX.version = "0.18.5";
var current_codepage = 1200, current_ansi = 1252;
var VALID_ANSI = [
    874,
    932,
    936,
    949,
    950,
    1250,
    1251,
    1252,
    1253,
    1254,
    1255,
    1256,
    1257,
    1258,
    10000
];
/* ECMA-376 Part I 18.4.1 charset to codepage mapping */ var CS2CP = {
    /*::[*/ 0: 1252,
    /* ANSI */ /*::[*/ 1: 65001,
    /* DEFAULT */ /*::[*/ 2: 65001,
    /* SYMBOL */ /*::[*/ 77: 10000,
    /* MAC */ /*::[*/ 128: 932,
    /* SHIFTJIS */ /*::[*/ 129: 949,
    /* HANGUL */ /*::[*/ 130: 1361,
    /* JOHAB */ /*::[*/ 134: 936,
    /* GB2312 */ /*::[*/ 136: 950,
    /* CHINESEBIG5 */ /*::[*/ 161: 1253,
    /* GREEK */ /*::[*/ 162: 1254,
    /* TURKISH */ /*::[*/ 163: 1258,
    /* VIETNAMESE */ /*::[*/ 177: 1255,
    /* HEBREW */ /*::[*/ 178: 1256,
    /* ARABIC */ /*::[*/ 186: 1257,
    /* BALTIC */ /*::[*/ 204: 1251,
    /* RUSSIAN */ /*::[*/ 222: 874,
    /* THAI */ /*::[*/ 238: 1250,
    /* EASTEUROPE */ /*::[*/ 255: 1252,
    /* OEM */ /*::[*/ 69: 6969 /* MISC */ 
} /*:any*/ ;
var set_ansi = function(cp /*:number*/ ) {
    if (VALID_ANSI.indexOf(cp) == -1) return;
    current_ansi = CS2CP[0] = cp;
};
function reset_ansi() {
    set_ansi(1252);
}
var set_cp = function(cp /*:number*/ ) {
    current_codepage = cp;
    set_ansi(cp);
};
function reset_cp() {
    set_cp(1200);
    reset_ansi();
}
function char_codes(data /*:string*/ ) /*:Array<number>*/ {
    var o /*:Array<number>*/  = [];
    for(var i = 0, len = data.length; i < len; ++i)o[i] = data.charCodeAt(i);
    return o;
}
function utf16leread(data /*:string*/ ) /*:string*/ {
    var o /*:Array<string>*/  = [];
    for(var i = 0; i < data.length >> 1; ++i)o[i] = String.fromCharCode(data.charCodeAt(2 * i) + (data.charCodeAt(2 * i + 1) << 8));
    return o.join("");
}
function utf16beread(data /*:string*/ ) /*:string*/ {
    var o /*:Array<string>*/  = [];
    for(var i = 0; i < data.length >> 1; ++i)o[i] = String.fromCharCode(data.charCodeAt(2 * i + 1) + (data.charCodeAt(2 * i) << 8));
    return o.join("");
}
var debom = function(data /*:string*/ ) /*:string*/ {
    var c1 = data.charCodeAt(0), c2 = data.charCodeAt(1);
    if (c1 == 0xFF && c2 == 0xFE) return utf16leread(data.slice(2));
    if (c1 == 0xFE && c2 == 0xFF) return utf16beread(data.slice(2));
    if (c1 == 0xFEFF) return data.slice(1);
    return data;
};
var _getchar = function _gc1(x /*:number*/ ) /*:string*/ {
    return String.fromCharCode(x);
};
var _getansi = function _ga1(x /*:number*/ ) /*:string*/ {
    return String.fromCharCode(x);
};
var $cptable;
function set_cptable(cptable) {
    $cptable = cptable;
    set_cp = function(cp /*:number*/ ) {
        current_codepage = cp;
        set_ansi(cp);
    };
    debom = function(data /*:string*/ ) {
        if (data.charCodeAt(0) === 0xFF && data.charCodeAt(1) === 0xFE) return $cptable.utils.decode(1200, char_codes(data.slice(2)));
        return data;
    };
    _getchar = function _gc2(x /*:number*/ ) /*:string*/ {
        if (current_codepage === 1200) return String.fromCharCode(x);
        return $cptable.utils.decode(current_codepage, [
            x & 255,
            x >> 8
        ])[0];
    };
    _getansi = function _ga2(x /*:number*/ ) /*:string*/ {
        return $cptable.utils.decode(current_ansi, [
            x
        ])[0];
    };
    cpdoit();
}
var DENSE = null;
var DIF_XL = true;
var Base64_map = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
function Base64_encode(input) {
    var o = "";
    var c1 = 0, c2 = 0, c3 = 0, e1 = 0, e2 = 0, e3 = 0, e4 = 0;
    for(var i = 0; i < input.length;){
        c1 = input.charCodeAt(i++);
        e1 = c1 >> 2;
        c2 = input.charCodeAt(i++);
        e2 = (c1 & 3) << 4 | c2 >> 4;
        c3 = input.charCodeAt(i++);
        e3 = (c2 & 15) << 2 | c3 >> 6;
        e4 = c3 & 63;
        if (isNaN(c2)) e3 = e4 = 64;
        else if (isNaN(c3)) e4 = 64;
        o += Base64_map.charAt(e1) + Base64_map.charAt(e2) + Base64_map.charAt(e3) + Base64_map.charAt(e4);
    }
    return o;
}
function Base64_decode(input) {
    var o = "";
    var c1 = 0, c2 = 0, c3 = 0, e1 = 0, e2 = 0, e3 = 0, e4 = 0;
    input = input.replace(/[^\w\+\/\=]/g, "");
    for(var i = 0; i < input.length;){
        e1 = Base64_map.indexOf(input.charAt(i++));
        e2 = Base64_map.indexOf(input.charAt(i++));
        c1 = e1 << 2 | e2 >> 4;
        o += String.fromCharCode(c1);
        e3 = Base64_map.indexOf(input.charAt(i++));
        c2 = (e2 & 15) << 4 | e3 >> 2;
        if (e3 !== 64) o += String.fromCharCode(c2);
        e4 = Base64_map.indexOf(input.charAt(i++));
        c3 = (e3 & 3) << 6 | e4;
        if (e4 !== 64) o += String.fromCharCode(c3);
    }
    return o;
}
var has_buf = /*#__PURE__*/ function() {
    return typeof Buffer !== "undefined" && typeof process !== "undefined" && typeof process.versions !== "undefined" && !!process.versions.node;
}();
var Buffer_from = /*#__PURE__*/ function() {
    if (typeof Buffer !== "undefined") {
        var nbfs = !Buffer.from;
        if (!nbfs) try {
            Buffer.from("foo", "utf8");
        } catch (e) {
            nbfs = true;
        }
        return nbfs ? function(buf, enc) {
            return enc ? new Buffer(buf, enc) : new Buffer(buf);
        } : Buffer.from.bind(Buffer);
    }
    return function() {};
}();
function new_raw_buf(len /*:number*/ ) {
    /* jshint -W056 */ if (has_buf) return Buffer.alloc ? Buffer.alloc(len) : new Buffer(len);
    return typeof Uint8Array != "undefined" ? new Uint8Array(len) : new Array(len);
/* jshint +W056 */ }
function new_unsafe_buf(len /*:number*/ ) {
    /* jshint -W056 */ if (has_buf) return Buffer.allocUnsafe ? Buffer.allocUnsafe(len) : new Buffer(len);
    return typeof Uint8Array != "undefined" ? new Uint8Array(len) : new Array(len);
/* jshint +W056 */ }
var s2a = function s2a(s /*:string*/ ) /*:any*/ {
    if (has_buf) return Buffer_from(s, "binary");
    return s.split("").map(function(x /*:string*/ ) /*:number*/ {
        return x.charCodeAt(0) & 0xff;
    });
};
function s2ab(s /*:string*/ ) /*:any*/ {
    if (typeof ArrayBuffer === "undefined") return s2a(s);
    var buf = new ArrayBuffer(s.length), view = new Uint8Array(buf);
    for(var i = 0; i != s.length; ++i)view[i] = s.charCodeAt(i) & 0xFF;
    return buf;
}
function a2s(data /*:any*/ ) /*:string*/ {
    if (Array.isArray(data)) return data.map(function(c) {
        return String.fromCharCode(c);
    }).join("");
    var o /*:Array<string>*/  = [];
    for(var i = 0; i < data.length; ++i)o[i] = String.fromCharCode(data[i]);
    return o.join("");
}
function a2u(data /*:Array<number>*/ ) /*:Uint8Array*/ {
    if (typeof Uint8Array === "undefined") throw new Error("Unsupported");
    return new Uint8Array(data);
}
function ab2a(data /*:ArrayBuffer|Uint8Array*/ ) /*:Array<number>*/ {
    if (typeof ArrayBuffer == "undefined") throw new Error("Unsupported");
    if (data instanceof ArrayBuffer) return ab2a(new Uint8Array(data));
    /*:: if(data instanceof ArrayBuffer) throw new Error("unreachable"); */ var o = new Array(data.length);
    for(var i = 0; i < data.length; ++i)o[i] = data[i];
    return o;
}
var bconcat = has_buf ? function(bufs) {
    return Buffer.concat(bufs.map(function(buf) {
        return Buffer.isBuffer(buf) ? buf : Buffer_from(buf);
    }));
} : function(bufs) {
    if (typeof Uint8Array !== "undefined") {
        var i = 0, maxlen = 0;
        for(i = 0; i < bufs.length; ++i)maxlen += bufs[i].length;
        var o = new Uint8Array(maxlen);
        var len = 0;
        for(i = 0, maxlen = 0; i < bufs.length; maxlen += len, ++i){
            len = bufs[i].length;
            if (bufs[i] instanceof Uint8Array) o.set(bufs[i], maxlen);
            else if (typeof bufs[i] == "string") throw "wtf";
            else o.set(new Uint8Array(bufs[i]), maxlen);
        }
        return o;
    }
    return [].concat.apply([], bufs.map(function(buf) {
        return Array.isArray(buf) ? buf : [].slice.call(buf);
    }));
};
function utf8decode(content /*:string*/ ) {
    var out = [], widx = 0, L = content.length + 250;
    var o = new_raw_buf(content.length + 255);
    for(var ridx = 0; ridx < content.length; ++ridx){
        var c = content.charCodeAt(ridx);
        if (c < 0x80) o[widx++] = c;
        else if (c < 0x800) {
            o[widx++] = 192 | c >> 6 & 31;
            o[widx++] = 128 | c & 63;
        } else if (c >= 0xD800 && c < 0xE000) {
            c = (c & 1023) + 64;
            var d = content.charCodeAt(++ridx) & 1023;
            o[widx++] = 240 | c >> 8 & 7;
            o[widx++] = 128 | c >> 2 & 63;
            o[widx++] = 128 | d >> 6 & 15 | (c & 3) << 4;
            o[widx++] = 128 | d & 63;
        } else {
            o[widx++] = 224 | c >> 12 & 15;
            o[widx++] = 128 | c >> 6 & 63;
            o[widx++] = 128 | c & 63;
        }
        if (widx > L) {
            out.push(o.slice(0, widx));
            widx = 0;
            o = new_raw_buf(65535);
            L = 65530;
        }
    }
    out.push(o.slice(0, widx));
    return bconcat(out);
}
var chr0 = /\u0000/g, chr1 = /[\u0001-\u0006]/g;
/*::
declare type Block = any;
declare type BufArray = {
	newblk(sz:number):Block;
	next(sz:number):Block;
	end():any;
	push(buf:Block):void;
};

type RecordHopperCB = {(d:any, Rn:string, RT:number):?boolean;};

type EvertType = {[string]:string};
type EvertNumType = {[string]:number};
type EvertArrType = {[string]:Array<string>};

type StringConv = {(string):string};

*/ /* ssf.js (C) 2013-present SheetJS -- http://sheetjs.com */ /*jshint -W041 */ function _strrev(x /*:string*/ ) /*:string*/ {
    var o = "", i = x.length - 1;
    while(i >= 0)o += x.charAt(i--);
    return o;
}
function pad0(v /*:any*/ , d /*:number*/ ) /*:string*/ {
    var t = "" + v;
    return t.length >= d ? t : fill("0", d - t.length) + t;
}
function pad_(v /*:any*/ , d /*:number*/ ) /*:string*/ {
    var t = "" + v;
    return t.length >= d ? t : fill(" ", d - t.length) + t;
}
function rpad_(v /*:any*/ , d /*:number*/ ) /*:string*/ {
    var t = "" + v;
    return t.length >= d ? t : t + fill(" ", d - t.length);
}
function pad0r1(v /*:any*/ , d /*:number*/ ) /*:string*/ {
    var t = "" + Math.round(v);
    return t.length >= d ? t : fill("0", d - t.length) + t;
}
function pad0r2(v /*:any*/ , d /*:number*/ ) /*:string*/ {
    var t = "" + v;
    return t.length >= d ? t : fill("0", d - t.length) + t;
}
var p2_32 = /*#__PURE__*/ Math.pow(2, 32);
function pad0r(v /*:any*/ , d /*:number*/ ) /*:string*/ {
    if (v > p2_32 || v < -p2_32) return pad0r1(v, d);
    var i = Math.round(v);
    return pad0r2(i, d);
}
/* yes, in 2022 this is still faster than string compare */ function SSF_isgeneral(s /*:string*/ , i /*:?number*/ ) /*:boolean*/ {
    i = i || 0;
    return s.length >= 7 + i && (s.charCodeAt(i) | 32) === 103 && (s.charCodeAt(i + 1) | 32) === 101 && (s.charCodeAt(i + 2) | 32) === 110 && (s.charCodeAt(i + 3) | 32) === 101 && (s.charCodeAt(i + 4) | 32) === 114 && (s.charCodeAt(i + 5) | 32) === 97 && (s.charCodeAt(i + 6) | 32) === 108;
}
var days /*:Array<Array<string> >*/  = [
    [
        "Sun",
        "Sunday"
    ],
    [
        "Mon",
        "Monday"
    ],
    [
        "Tue",
        "Tuesday"
    ],
    [
        "Wed",
        "Wednesday"
    ],
    [
        "Thu",
        "Thursday"
    ],
    [
        "Fri",
        "Friday"
    ],
    [
        "Sat",
        "Saturday"
    ]
];
var months /*:Array<Array<string> >*/  = [
    [
        "J",
        "Jan",
        "January"
    ],
    [
        "F",
        "Feb",
        "February"
    ],
    [
        "M",
        "Mar",
        "March"
    ],
    [
        "A",
        "Apr",
        "April"
    ],
    [
        "M",
        "May",
        "May"
    ],
    [
        "J",
        "Jun",
        "June"
    ],
    [
        "J",
        "Jul",
        "July"
    ],
    [
        "A",
        "Aug",
        "August"
    ],
    [
        "S",
        "Sep",
        "September"
    ],
    [
        "O",
        "Oct",
        "October"
    ],
    [
        "N",
        "Nov",
        "November"
    ],
    [
        "D",
        "Dec",
        "December"
    ]
];
function SSF_init_table(t /*:any*/ ) {
    if (!t) t = {};
    t[0] = "General";
    t[1] = "0";
    t[2] = "0.00";
    t[3] = "#,##0";
    t[4] = "#,##0.00";
    t[9] = "0%";
    t[10] = "0.00%";
    t[11] = "0.00E+00";
    t[12] = "# ?/?";
    t[13] = "# ??/??";
    t[14] = "m/d/yy";
    t[15] = "d-mmm-yy";
    t[16] = "d-mmm";
    t[17] = "mmm-yy";
    t[18] = "h:mm AM/PM";
    t[19] = "h:mm:ss AM/PM";
    t[20] = "h:mm";
    t[21] = "h:mm:ss";
    t[22] = "m/d/yy h:mm";
    t[37] = "#,##0 ;(#,##0)";
    t[38] = "#,##0 ;[Red](#,##0)";
    t[39] = "#,##0.00;(#,##0.00)";
    t[40] = "#,##0.00;[Red](#,##0.00)";
    t[45] = "mm:ss";
    t[46] = "[h]:mm:ss";
    t[47] = "mmss.0";
    t[48] = "##0.0E+0";
    t[49] = "@";
    t[56] = '"上午/下午 "hh"時"mm"分"ss"秒 "';
    return t;
}
/* repeated to satiate webpack */ var table_fmt = {
    0: "General",
    1: "0",
    2: "0.00",
    3: "#,##0",
    4: "#,##0.00",
    9: "0%",
    10: "0.00%",
    11: "0.00E+00",
    12: "# ?/?",
    13: "# ??/??",
    14: "m/d/yy",
    15: "d-mmm-yy",
    16: "d-mmm",
    17: "mmm-yy",
    18: "h:mm AM/PM",
    19: "h:mm:ss AM/PM",
    20: "h:mm",
    21: "h:mm:ss",
    22: "m/d/yy h:mm",
    37: "#,##0 ;(#,##0)",
    38: "#,##0 ;[Red](#,##0)",
    39: "#,##0.00;(#,##0.00)",
    40: "#,##0.00;[Red](#,##0.00)",
    45: "mm:ss",
    46: "[h]:mm:ss",
    47: "mmss.0",
    48: "##0.0E+0",
    49: "@",
    56: '"上午/下午 "hh"時"mm"分"ss"秒 "'
};
/* Defaults determined by systematically testing in Excel 2019 */ /* These formats appear to default to other formats in the table */ var SSF_default_map = {
    5: 37,
    6: 38,
    7: 39,
    8: 40,
    23: 0,
    24: 0,
    25: 0,
    26: 0,
    27: 14,
    28: 14,
    29: 14,
    30: 14,
    31: 14,
    50: 14,
    51: 14,
    52: 14,
    53: 14,
    54: 14,
    55: 14,
    56: 14,
    57: 14,
    58: 14,
    59: 1,
    60: 2,
    61: 3,
    62: 4,
    67: 9,
    68: 10,
    69: 12,
    70: 13,
    71: 14,
    72: 14,
    73: 15,
    74: 16,
    75: 17,
    76: 20,
    77: 21,
    78: 22,
    79: 45,
    80: 46,
    81: 47,
    82: 0 // 82 ->  0 ... 65536 -> 0 (omitted)
};
/* These formats technically refer to Accounting formats with no equivalent */ var SSF_default_str = {
    //  5 -- Currency,   0 decimal, black negative
    5: '"$"#,##0_);\\("$"#,##0\\)',
    63: '"$"#,##0_);\\("$"#,##0\\)',
    //  6 -- Currency,   0 decimal, red   negative
    6: '"$"#,##0_);[Red]\\("$"#,##0\\)',
    64: '"$"#,##0_);[Red]\\("$"#,##0\\)',
    //  7 -- Currency,   2 decimal, black negative
    7: '"$"#,##0.00_);\\("$"#,##0.00\\)',
    65: '"$"#,##0.00_);\\("$"#,##0.00\\)',
    //  8 -- Currency,   2 decimal, red   negative
    8: '"$"#,##0.00_);[Red]\\("$"#,##0.00\\)',
    66: '"$"#,##0.00_);[Red]\\("$"#,##0.00\\)',
    // 41 -- Accounting, 0 decimal, No Symbol
    41: '_(* #,##0_);_(* \\(#,##0\\);_(* "-"_);_(@_)',
    // 42 -- Accounting, 0 decimal, $  Symbol
    42: '_("$"* #,##0_);_("$"* \\(#,##0\\);_("$"* "-"_);_(@_)',
    // 43 -- Accounting, 2 decimal, No Symbol
    43: '_(* #,##0.00_);_(* \\(#,##0.00\\);_(* "-"??_);_(@_)',
    // 44 -- Accounting, 2 decimal, $  Symbol
    44: '_("$"* #,##0.00_);_("$"* \\(#,##0.00\\);_("$"* "-"??_);_(@_)'
};
function SSF_frac(x /*:number*/ , D /*:number*/ , mixed /*:?boolean*/ ) /*:Array<number>*/ {
    var sgn = x < 0 ? -1 : 1;
    var B = x * sgn;
    var P_2 = 0, P_1 = 1, P = 0;
    var Q_2 = 1, Q_1 = 0, Q = 0;
    var A = Math.floor(B);
    while(Q_1 < D){
        A = Math.floor(B);
        P = A * P_1 + P_2;
        Q = A * Q_1 + Q_2;
        if (B - A < 0.00000005) break;
        B = 1 / (B - A);
        P_2 = P_1;
        P_1 = P;
        Q_2 = Q_1;
        Q_1 = Q;
    }
    if (Q > D) {
        if (Q_1 > D) {
            Q = Q_2;
            P = P_2;
        } else {
            Q = Q_1;
            P = P_1;
        }
    }
    if (!mixed) return [
        0,
        sgn * P,
        Q
    ];
    var q = Math.floor(sgn * P / Q);
    return [
        q,
        sgn * P - q * Q,
        Q
    ];
}
function SSF_parse_date_code(v /*:number*/ , opts /*:?any*/ , b2 /*:?boolean*/ ) {
    if (v > 2958465 || v < 0) return null;
    var date = v | 0, time = Math.floor(86400 * (v - date)), dow = 0;
    var dout = [];
    var out = {
        D: date,
        T: time,
        u: 86400 * (v - date) - time,
        y: 0,
        m: 0,
        d: 0,
        H: 0,
        M: 0,
        S: 0,
        q: 0
    };
    if (Math.abs(out.u) < 1e-6) out.u = 0;
    if (opts && opts.date1904) date += 1462;
    if (out.u > 0.9999) {
        out.u = 0;
        if (++time == 86400) {
            out.T = time = 0;
            ++date;
            ++out.D;
        }
    }
    if (date === 60) {
        dout = b2 ? [
            1317,
            10,
            29
        ] : [
            1900,
            2,
            29
        ];
        dow = 3;
    } else if (date === 0) {
        dout = b2 ? [
            1317,
            8,
            29
        ] : [
            1900,
            1,
            0
        ];
        dow = 6;
    } else {
        if (date > 60) --date;
        /* 1 = Jan 1 1900 in Gregorian */ var d = new Date(1900, 0, 1);
        d.setDate(d.getDate() + date - 1);
        dout = [
            d.getFullYear(),
            d.getMonth() + 1,
            d.getDate()
        ];
        dow = d.getDay();
        if (date < 60) dow = (dow + 6) % 7;
        if (b2) dow = SSF_fix_hijri(d, dout);
    }
    out.y = dout[0];
    out.m = dout[1];
    out.d = dout[2];
    out.S = time % 60;
    time = Math.floor(time / 60);
    out.M = time % 60;
    time = Math.floor(time / 60);
    out.H = time;
    out.q = dow;
    return out;
}
var SSFbasedate = /*#__PURE__*/ new Date(1899, 11, 31, 0, 0, 0);
var SSFdnthresh = /*#__PURE__*/ SSFbasedate.getTime();
var SSFbase1904 = /*#__PURE__*/ new Date(1900, 2, 1, 0, 0, 0);
function datenum_local(v /*:Date*/ , date1904 /*:?boolean*/ ) /*:number*/ {
    var epoch = /*#__PURE__*/ v.getTime();
    if (date1904) epoch -= 126230400000;
    else if (v >= SSFbase1904) epoch += 86400000;
    return (epoch - (SSFdnthresh + /*#__PURE__*/ (v.getTimezoneOffset() - /*#__PURE__*/ SSFbasedate.getTimezoneOffset()) * 60000)) / 86400000;
}
/* ECMA-376 18.8.30 numFmt*/ /* Note: `toPrecision` uses standard form when prec > E and E >= -6 */ /* exponent >= -9 and <= 9 */ function SSF_strip_decimal(o /*:string*/ ) /*:string*/ {
    return o.indexOf(".") == -1 ? o : o.replace(/(?:\.0*|(\.\d*[1-9])0+)$/, "$1");
}
/* General Exponential always shows 2 digits exp and trims the mantissa */ function SSF_normalize_exp(o /*:string*/ ) /*:string*/ {
    if (o.indexOf("E") == -1) return o;
    return o.replace(/(?:\.0*|(\.\d*[1-9])0+)[Ee]/, "$1E").replace(/(E[+-])(\d)$/, "$10$2");
}
/* exponent >= -9 and <= 9 */ function SSF_small_exp(v /*:number*/ ) /*:string*/ {
    var w = v < 0 ? 12 : 11;
    var o = SSF_strip_decimal(v.toFixed(12));
    if (o.length <= w) return o;
    o = v.toPrecision(10);
    if (o.length <= w) return o;
    return v.toExponential(5);
}
/* exponent >= 11 or <= -10 likely exponential */ function SSF_large_exp(v /*:number*/ ) /*:string*/ {
    var o = SSF_strip_decimal(v.toFixed(11));
    return o.length > (v < 0 ? 12 : 11) || o === "0" || o === "-0" ? v.toPrecision(6) : o;
}
function SSF_general_num(v /*:number*/ ) /*:string*/ {
    var V = Math.floor(Math.log(Math.abs(v)) * Math.LOG10E), o;
    if (V >= -4 && V <= -1) o = v.toPrecision(10 + V);
    else if (Math.abs(V) <= 9) o = SSF_small_exp(v);
    else if (V === 10) o = v.toFixed(10).substr(0, 12);
    else o = SSF_large_exp(v);
    return SSF_strip_decimal(SSF_normalize_exp(o.toUpperCase()));
}
/*
	"General" rules:
	- text is passed through ("@")
	- booleans are rendered as TRUE/FALSE
	- "up to 11 characters" displayed for numbers
	- Default date format (code 14) used for Dates

	The longest 32-bit integer text is "-2147483648", exactly 11 chars
	TODO: technically the display depends on the width of the cell
*/ function SSF_general(v /*:any*/ , opts /*:any*/ ) {
    switch(typeof v){
        case "string":
            return v;
        case "boolean":
            return v ? "TRUE" : "FALSE";
        case "number":
            return (v | 0) === v ? v.toString(10) : SSF_general_num(v);
        case "undefined":
            return "";
        case "object":
            if (v == null) return "";
            if (v instanceof Date) return SSF_format(14, datenum_local(v, opts && opts.date1904), opts);
    }
    throw new Error("unsupported value in General format: " + v);
}
function SSF_fix_hijri(date /*:Date*/ , o /*:[number, number, number]*/ ) {
    /* TODO: properly adjust y/m/d and  */ o[0] -= 581;
    var dow = date.getDay();
    if (date < 60) dow = (dow + 6) % 7;
    return dow;
}
//var THAI_DIGITS = "\u0E50\u0E51\u0E52\u0E53\u0E54\u0E55\u0E56\u0E57\u0E58\u0E59".split("");
function SSF_write_date(type /*:number*/ , fmt /*:string*/ , val, ss0 /*:?number*/ ) /*:string*/ {
    var o = "", ss = 0, tt = 0, y = val.y, out, outl = 0;
    switch(type){
        case 98:
            /* 'b' buddhist year */ y = val.y + 543;
        /* falls through */ case 121:
            /* 'y' year */ switch(fmt.length){
                case 1:
                case 2:
                    out = y % 100;
                    outl = 2;
                    break;
                default:
                    out = y % 10000;
                    outl = 4;
                    break;
            }
            break;
        case 109:
            /* 'm' month */ switch(fmt.length){
                case 1:
                case 2:
                    out = val.m;
                    outl = fmt.length;
                    break;
                case 3:
                    return months[val.m - 1][1];
                case 5:
                    return months[val.m - 1][0];
                default:
                    return months[val.m - 1][2];
            }
            break;
        case 100:
            /* 'd' day */ switch(fmt.length){
                case 1:
                case 2:
                    out = val.d;
                    outl = fmt.length;
                    break;
                case 3:
                    return days[val.q][0];
                default:
                    return days[val.q][1];
            }
            break;
        case 104:
            /* 'h' 12-hour */ switch(fmt.length){
                case 1:
                case 2:
                    out = 1 + (val.H + 11) % 12;
                    outl = fmt.length;
                    break;
                default:
                    throw "bad hour format: " + fmt;
            }
            break;
        case 72:
            /* 'H' 24-hour */ switch(fmt.length){
                case 1:
                case 2:
                    out = val.H;
                    outl = fmt.length;
                    break;
                default:
                    throw "bad hour format: " + fmt;
            }
            break;
        case 77:
            /* 'M' minutes */ switch(fmt.length){
                case 1:
                case 2:
                    out = val.M;
                    outl = fmt.length;
                    break;
                default:
                    throw "bad minute format: " + fmt;
            }
            break;
        case 115:
            /* 's' seconds */ if (fmt != "s" && fmt != "ss" && fmt != ".0" && fmt != ".00" && fmt != ".000") throw "bad second format: " + fmt;
            if (val.u === 0 && (fmt == "s" || fmt == "ss")) return pad0(val.S, fmt.length);
            /*::if(!ss0) ss0 = 0; */ if (ss0 >= 2) tt = ss0 === 3 ? 1000 : 100;
            else tt = ss0 === 1 ? 10 : 1;
            ss = Math.round(tt * (val.S + val.u));
            if (ss >= 60 * tt) ss = 0;
            if (fmt === "s") return ss === 0 ? "0" : "" + ss / tt;
            o = pad0(ss, 2 + ss0);
            if (fmt === "ss") return o.substr(0, 2);
            return "." + o.substr(2, fmt.length - 1);
        case 90:
            /* 'Z' absolute time */ switch(fmt){
                case "[h]":
                case "[hh]":
                    out = val.D * 24 + val.H;
                    break;
                case "[m]":
                case "[mm]":
                    out = (val.D * 24 + val.H) * 60 + val.M;
                    break;
                case "[s]":
                case "[ss]":
                    out = ((val.D * 24 + val.H) * 60 + val.M) * 60 + Math.round(val.S + val.u);
                    break;
                default:
                    throw "bad abstime format: " + fmt;
            }
            outl = fmt.length === 3 ? 1 : 2;
            break;
        case 101:
            /* 'e' era */ out = y;
            outl = 1;
            break;
    }
    var outstr = outl > 0 ? pad0(out, outl) : "";
    return outstr;
}
/*jshint -W086 */ /*jshint +W086 */ function commaify(s /*:string*/ ) /*:string*/ {
    var w = 3;
    if (s.length <= w) return s;
    var j = s.length % w, o = s.substr(0, j);
    for(; j != s.length; j += w)o += (o.length > 0 ? "," : "") + s.substr(j, w);
    return o;
}
var pct1 = /%/g;
function write_num_pct(type /*:string*/ , fmt /*:string*/ , val /*:number*/ ) /*:string*/ {
    var sfmt = fmt.replace(pct1, ""), mul = fmt.length - sfmt.length;
    return write_num(type, sfmt, val * Math.pow(10, 2 * mul)) + fill("%", mul);
}
function write_num_cm(type /*:string*/ , fmt /*:string*/ , val /*:number*/ ) /*:string*/ {
    var idx = fmt.length - 1;
    while(fmt.charCodeAt(idx - 1) === 44)--idx;
    return write_num(type, fmt.substr(0, idx), val / Math.pow(10, 3 * (fmt.length - idx)));
}
function write_num_exp(fmt /*:string*/ , val /*:number*/ ) /*:string*/ {
    var o /*:string*/ ;
    var idx = fmt.indexOf("E") - fmt.indexOf(".") - 1;
    if (fmt.match(/^#+0.0E\+0$/)) {
        if (val == 0) return "0.0E+0";
        else if (val < 0) return "-" + write_num_exp(fmt, -val);
        var period = fmt.indexOf(".");
        if (period === -1) period = fmt.indexOf("E");
        var ee = Math.floor(Math.log(val) * Math.LOG10E) % period;
        if (ee < 0) ee += period;
        o = (val / Math.pow(10, ee)).toPrecision(idx + 1 + (period + ee) % period);
        if (o.indexOf("e") === -1) {
            var fakee = Math.floor(Math.log(val) * Math.LOG10E);
            if (o.indexOf(".") === -1) o = o.charAt(0) + "." + o.substr(1) + "E+" + (fakee - o.length + ee);
            else o += "E+" + (fakee - ee);
            while(o.substr(0, 2) === "0."){
                o = o.charAt(0) + o.substr(2, period) + "." + o.substr(2 + period);
                o = o.replace(/^0+([1-9])/, "$1").replace(/^0+\./, "0.");
            }
            o = o.replace(/\+-/, "-");
        }
        o = o.replace(/^([+-]?)(\d*)\.(\d*)[Ee]/, function($$, $1, $2, $3) {
            return $1 + $2 + $3.substr(0, (period + ee) % period) + "." + $3.substr(ee) + "E";
        });
    } else o = val.toExponential(idx);
    if (fmt.match(/E\+00$/) && o.match(/e[+-]\d$/)) o = o.substr(0, o.length - 1) + "0" + o.charAt(o.length - 1);
    if (fmt.match(/E\-/) && o.match(/e\+/)) o = o.replace(/e\+/, "e");
    return o.replace("e", "E");
}
var frac1 = /# (\?+)( ?)\/( ?)(\d+)/;
function write_num_f1(r /*:Array<string>*/ , aval /*:number*/ , sign /*:string*/ ) /*:string*/ {
    var den = parseInt(r[4], 10), rr = Math.round(aval * den), base = Math.floor(rr / den);
    var myn = rr - base * den, myd = den;
    return sign + (base === 0 ? "" : "" + base) + " " + (myn === 0 ? fill(" ", r[1].length + 1 + r[4].length) : pad_(myn, r[1].length) + r[2] + "/" + r[3] + pad0(myd, r[4].length));
}
function write_num_f2(r /*:Array<string>*/ , aval /*:number*/ , sign /*:string*/ ) /*:string*/ {
    return sign + (aval === 0 ? "" : "" + aval) + fill(" ", r[1].length + 2 + r[4].length);
}
var dec1 = /^#*0*\.([0#]+)/;
var closeparen = /\).*[0#]/;
var phone = /\(###\) ###\\?-####/;
function hashq(str /*:string*/ ) /*:string*/ {
    var o = "", cc;
    for(var i = 0; i != str.length; ++i)switch(cc = str.charCodeAt(i)){
        case 35:
            break;
        case 63:
            o += " ";
            break;
        case 48:
            o += "0";
            break;
        default:
            o += String.fromCharCode(cc);
    }
    return o;
}
function rnd(val /*:number*/ , d /*:number*/ ) /*:string*/ {
    var dd = Math.pow(10, d);
    return "" + Math.round(val * dd) / dd;
}
function dec(val /*:number*/ , d /*:number*/ ) /*:number*/ {
    var _frac = val - Math.floor(val), dd = Math.pow(10, d);
    if (d < ("" + Math.round(_frac * dd)).length) return 0;
    return Math.round(_frac * dd);
}
function carry(val /*:number*/ , d /*:number*/ ) /*:number*/ {
    if (d < ("" + Math.round((val - Math.floor(val)) * Math.pow(10, d))).length) return 1;
    return 0;
}
function flr(val /*:number*/ ) /*:string*/ {
    if (val < 2147483647 && val > -2147483648) return "" + (val >= 0 ? val | 0 : val - 1 | 0);
    return "" + Math.floor(val);
}
function write_num_flt(type /*:string*/ , fmt /*:string*/ , val /*:number*/ ) /*:string*/ {
    if (type.charCodeAt(0) === 40 && !fmt.match(closeparen)) {
        var ffmt = fmt.replace(/\( */, "").replace(/ \)/, "").replace(/\)/, "");
        if (val >= 0) return write_num_flt("n", ffmt, val);
        return "(" + write_num_flt("n", ffmt, -val) + ")";
    }
    if (fmt.charCodeAt(fmt.length - 1) === 44) return write_num_cm(type, fmt, val);
    if (fmt.indexOf("%") !== -1) return write_num_pct(type, fmt, val);
    if (fmt.indexOf("E") !== -1) return write_num_exp(fmt, val);
    if (fmt.charCodeAt(0) === 36) return "$" + write_num_flt(type, fmt.substr(fmt.charAt(1) == " " ? 2 : 1), val);
    var o;
    var r /*:?Array<string>*/ , ri, ff, aval = Math.abs(val), sign = val < 0 ? "-" : "";
    if (fmt.match(/^00+$/)) return sign + pad0r(aval, fmt.length);
    if (fmt.match(/^[#?]+$/)) {
        o = pad0r(val, 0);
        if (o === "0") o = "";
        return o.length > fmt.length ? o : hashq(fmt.substr(0, fmt.length - o.length)) + o;
    }
    if (r = fmt.match(frac1)) return write_num_f1(r, aval, sign);
    if (fmt.match(/^#+0+$/)) return sign + pad0r(aval, fmt.length - fmt.indexOf("0"));
    if (r = fmt.match(dec1)) {
        o = rnd(val, r[1].length).replace(/^([^\.]+)$/, "$1." + hashq(r[1])).replace(/\.$/, "." + hashq(r[1])).replace(/\.(\d*)$/, function($$, $1) {
            return "." + $1 + fill("0", hashq(/*::(*/ r /*::||[""])*/ [1]).length - $1.length);
        });
        return fmt.indexOf("0.") !== -1 ? o : o.replace(/^0\./, ".");
    }
    fmt = fmt.replace(/^#+([0.])/, "$1");
    if (r = fmt.match(/^(0*)\.(#*)$/)) return sign + rnd(aval, r[2].length).replace(/\.(\d*[1-9])0*$/, ".$1").replace(/^(-?\d*)$/, "$1.").replace(/^0\./, r[1].length ? "0." : ".");
    if (r = fmt.match(/^#{1,3},##0(\.?)$/)) return sign + commaify(pad0r(aval, 0));
    if (r = fmt.match(/^#,##0\.([#0]*0)$/)) return val < 0 ? "-" + write_num_flt(type, fmt, -val) : commaify("" + (Math.floor(val) + carry(val, r[1].length))) + "." + pad0(dec(val, r[1].length), r[1].length);
    if (r = fmt.match(/^#,#*,#0/)) return write_num_flt(type, fmt.replace(/^#,#*,/, ""), val);
    if (r = fmt.match(/^([0#]+)(\\?-([0#]+))+$/)) {
        o = _strrev(write_num_flt(type, fmt.replace(/[\\-]/g, ""), val));
        ri = 0;
        return _strrev(_strrev(fmt.replace(/\\/g, "")).replace(/[0#]/g, function(x) {
            return ri < o.length ? o.charAt(ri++) : x === "0" ? "0" : "";
        }));
    }
    if (fmt.match(phone)) {
        o = write_num_flt(type, "##########", val);
        return "(" + o.substr(0, 3) + ") " + o.substr(3, 3) + "-" + o.substr(6);
    }
    var oa = "";
    if (r = fmt.match(/^([#0?]+)( ?)\/( ?)([#0?]+)/)) {
        ri = Math.min(/*::String(*/ r[4]/*::)*/ .length, 7);
        ff = SSF_frac(aval, Math.pow(10, ri) - 1, false);
        o = "" + sign;
        oa = write_num("n", /*::String(*/ r[1], ff[1]);
        if (oa.charAt(oa.length - 1) == " ") oa = oa.substr(0, oa.length - 1) + "0";
        o += oa + /*::String(*/ r[2] + "/" + /*::String(*/ r[3] /*::)*/ ;
        oa = rpad_(ff[2], ri);
        if (oa.length < r[4].length) oa = hashq(r[4].substr(r[4].length - oa.length)) + oa;
        o += oa;
        return o;
    }
    if (r = fmt.match(/^# ([#0?]+)( ?)\/( ?)([#0?]+)/)) {
        ri = Math.min(Math.max(r[1].length, r[4].length), 7);
        ff = SSF_frac(aval, Math.pow(10, ri) - 1, true);
        return sign + (ff[0] || (ff[1] ? "" : "0")) + " " + (ff[1] ? pad_(ff[1], ri) + r[2] + "/" + r[3] + rpad_(ff[2], ri) : fill(" ", 2 * ri + 1 + r[2].length + r[3].length));
    }
    if (r = fmt.match(/^[#0?]+$/)) {
        o = pad0r(val, 0);
        if (fmt.length <= o.length) return o;
        return hashq(fmt.substr(0, fmt.length - o.length)) + o;
    }
    if (r = fmt.match(/^([#0?]+)\.([#0]+)$/)) {
        o = "" + val.toFixed(Math.min(r[2].length, 10)).replace(/([^0])0+$/, "$1");
        ri = o.indexOf(".");
        var lres = fmt.indexOf(".") - ri, rres = fmt.length - o.length - lres;
        return hashq(fmt.substr(0, lres) + o + fmt.substr(fmt.length - rres));
    }
    if (r = fmt.match(/^00,000\.([#0]*0)$/)) {
        ri = dec(val, r[1].length);
        return val < 0 ? "-" + write_num_flt(type, fmt, -val) : commaify(flr(val)).replace(/^\d,\d{3}$/, "0$&").replace(/^\d*$/, function($$) {
            return "00," + ($$.length < 3 ? pad0(0, 3 - $$.length) : "") + $$;
        }) + "." + pad0(ri, r[1].length);
    }
    switch(fmt){
        case "###,##0.00":
            return write_num_flt(type, "#,##0.00", val);
        case "###,###":
        case "##,###":
        case "#,###":
            var x = commaify(pad0r(aval, 0));
            return x !== "0" ? sign + x : "";
        case "###,###.00":
            return write_num_flt(type, "###,##0.00", val).replace(/^0\./, ".");
        case "#,###.00":
            return write_num_flt(type, "#,##0.00", val).replace(/^0\./, ".");
        default:
    }
    throw new Error("unsupported format |" + fmt + "|");
}
function write_num_cm2(type /*:string*/ , fmt /*:string*/ , val /*:number*/ ) /*:string*/ {
    var idx = fmt.length - 1;
    while(fmt.charCodeAt(idx - 1) === 44)--idx;
    return write_num(type, fmt.substr(0, idx), val / Math.pow(10, 3 * (fmt.length - idx)));
}
function write_num_pct2(type /*:string*/ , fmt /*:string*/ , val /*:number*/ ) /*:string*/ {
    var sfmt = fmt.replace(pct1, ""), mul = fmt.length - sfmt.length;
    return write_num(type, sfmt, val * Math.pow(10, 2 * mul)) + fill("%", mul);
}
function write_num_exp2(fmt /*:string*/ , val /*:number*/ ) /*:string*/ {
    var o /*:string*/ ;
    var idx = fmt.indexOf("E") - fmt.indexOf(".") - 1;
    if (fmt.match(/^#+0.0E\+0$/)) {
        if (val == 0) return "0.0E+0";
        else if (val < 0) return "-" + write_num_exp2(fmt, -val);
        var period = fmt.indexOf(".");
        if (period === -1) period = fmt.indexOf("E");
        var ee = Math.floor(Math.log(val) * Math.LOG10E) % period;
        if (ee < 0) ee += period;
        o = (val / Math.pow(10, ee)).toPrecision(idx + 1 + (period + ee) % period);
        if (!o.match(/[Ee]/)) {
            var fakee = Math.floor(Math.log(val) * Math.LOG10E);
            if (o.indexOf(".") === -1) o = o.charAt(0) + "." + o.substr(1) + "E+" + (fakee - o.length + ee);
            else o += "E+" + (fakee - ee);
            o = o.replace(/\+-/, "-");
        }
        o = o.replace(/^([+-]?)(\d*)\.(\d*)[Ee]/, function($$, $1, $2, $3) {
            return $1 + $2 + $3.substr(0, (period + ee) % period) + "." + $3.substr(ee) + "E";
        });
    } else o = val.toExponential(idx);
    if (fmt.match(/E\+00$/) && o.match(/e[+-]\d$/)) o = o.substr(0, o.length - 1) + "0" + o.charAt(o.length - 1);
    if (fmt.match(/E\-/) && o.match(/e\+/)) o = o.replace(/e\+/, "e");
    return o.replace("e", "E");
}
function write_num_int(type /*:string*/ , fmt /*:string*/ , val /*:number*/ ) /*:string*/ {
    if (type.charCodeAt(0) === 40 && !fmt.match(closeparen)) {
        var ffmt = fmt.replace(/\( */, "").replace(/ \)/, "").replace(/\)/, "");
        if (val >= 0) return write_num_int("n", ffmt, val);
        return "(" + write_num_int("n", ffmt, -val) + ")";
    }
    if (fmt.charCodeAt(fmt.length - 1) === 44) return write_num_cm2(type, fmt, val);
    if (fmt.indexOf("%") !== -1) return write_num_pct2(type, fmt, val);
    if (fmt.indexOf("E") !== -1) return write_num_exp2(fmt, val);
    if (fmt.charCodeAt(0) === 36) return "$" + write_num_int(type, fmt.substr(fmt.charAt(1) == " " ? 2 : 1), val);
    var o;
    var r /*:?Array<string>*/ , ri, ff, aval = Math.abs(val), sign = val < 0 ? "-" : "";
    if (fmt.match(/^00+$/)) return sign + pad0(aval, fmt.length);
    if (fmt.match(/^[#?]+$/)) {
        o = "" + val;
        if (val === 0) o = "";
        return o.length > fmt.length ? o : hashq(fmt.substr(0, fmt.length - o.length)) + o;
    }
    if (r = fmt.match(frac1)) return write_num_f2(r, aval, sign);
    if (fmt.match(/^#+0+$/)) return sign + pad0(aval, fmt.length - fmt.indexOf("0"));
    if (r = fmt.match(dec1)) {
        /*:: if(!Array.isArray(r)) throw new Error("unreachable"); */ o = ("" + val).replace(/^([^\.]+)$/, "$1." + hashq(r[1])).replace(/\.$/, "." + hashq(r[1]));
        o = o.replace(/\.(\d*)$/, function($$, $1) {
            /*:: if(!Array.isArray(r)) throw new Error("unreachable"); */ return "." + $1 + fill("0", hashq(r[1]).length - $1.length);
        });
        return fmt.indexOf("0.") !== -1 ? o : o.replace(/^0\./, ".");
    }
    fmt = fmt.replace(/^#+([0.])/, "$1");
    if (r = fmt.match(/^(0*)\.(#*)$/)) return sign + ("" + aval).replace(/\.(\d*[1-9])0*$/, ".$1").replace(/^(-?\d*)$/, "$1.").replace(/^0\./, r[1].length ? "0." : ".");
    if (r = fmt.match(/^#{1,3},##0(\.?)$/)) return sign + commaify("" + aval);
    if (r = fmt.match(/^#,##0\.([#0]*0)$/)) return val < 0 ? "-" + write_num_int(type, fmt, -val) : commaify("" + val) + "." + fill("0", r[1].length);
    if (r = fmt.match(/^#,#*,#0/)) return write_num_int(type, fmt.replace(/^#,#*,/, ""), val);
    if (r = fmt.match(/^([0#]+)(\\?-([0#]+))+$/)) {
        o = _strrev(write_num_int(type, fmt.replace(/[\\-]/g, ""), val));
        ri = 0;
        return _strrev(_strrev(fmt.replace(/\\/g, "")).replace(/[0#]/g, function(x) {
            return ri < o.length ? o.charAt(ri++) : x === "0" ? "0" : "";
        }));
    }
    if (fmt.match(phone)) {
        o = write_num_int(type, "##########", val);
        return "(" + o.substr(0, 3) + ") " + o.substr(3, 3) + "-" + o.substr(6);
    }
    var oa = "";
    if (r = fmt.match(/^([#0?]+)( ?)\/( ?)([#0?]+)/)) {
        ri = Math.min(/*::String(*/ r[4]/*::)*/ .length, 7);
        ff = SSF_frac(aval, Math.pow(10, ri) - 1, false);
        o = "" + sign;
        oa = write_num("n", /*::String(*/ r[1], ff[1]);
        if (oa.charAt(oa.length - 1) == " ") oa = oa.substr(0, oa.length - 1) + "0";
        o += oa + /*::String(*/ r[2] + "/" + /*::String(*/ r[3] /*::)*/ ;
        oa = rpad_(ff[2], ri);
        if (oa.length < r[4].length) oa = hashq(r[4].substr(r[4].length - oa.length)) + oa;
        o += oa;
        return o;
    }
    if (r = fmt.match(/^# ([#0?]+)( ?)\/( ?)([#0?]+)/)) {
        ri = Math.min(Math.max(r[1].length, r[4].length), 7);
        ff = SSF_frac(aval, Math.pow(10, ri) - 1, true);
        return sign + (ff[0] || (ff[1] ? "" : "0")) + " " + (ff[1] ? pad_(ff[1], ri) + r[2] + "/" + r[3] + rpad_(ff[2], ri) : fill(" ", 2 * ri + 1 + r[2].length + r[3].length));
    }
    if (r = fmt.match(/^[#0?]+$/)) {
        o = "" + val;
        if (fmt.length <= o.length) return o;
        return hashq(fmt.substr(0, fmt.length - o.length)) + o;
    }
    if (r = fmt.match(/^([#0]+)\.([#0]+)$/)) {
        o = "" + val.toFixed(Math.min(r[2].length, 10)).replace(/([^0])0+$/, "$1");
        ri = o.indexOf(".");
        var lres = fmt.indexOf(".") - ri, rres = fmt.length - o.length - lres;
        return hashq(fmt.substr(0, lres) + o + fmt.substr(fmt.length - rres));
    }
    if (r = fmt.match(/^00,000\.([#0]*0)$/)) return val < 0 ? "-" + write_num_int(type, fmt, -val) : commaify("" + val).replace(/^\d,\d{3}$/, "0$&").replace(/^\d*$/, function($$) {
        return "00," + ($$.length < 3 ? pad0(0, 3 - $$.length) : "") + $$;
    }) + "." + pad0(0, r[1].length);
    switch(fmt){
        case "###,###":
        case "##,###":
        case "#,###":
            var x = commaify("" + aval);
            return x !== "0" ? sign + x : "";
        default:
            if (fmt.match(/\.[0#?]*$/)) return write_num_int(type, fmt.slice(0, fmt.lastIndexOf(".")), val) + hashq(fmt.slice(fmt.lastIndexOf(".")));
    }
    throw new Error("unsupported format |" + fmt + "|");
}
function write_num(type /*:string*/ , fmt /*:string*/ , val /*:number*/ ) /*:string*/ {
    return (val | 0) === val ? write_num_int(type, fmt, val) : write_num_flt(type, fmt, val);
}
function SSF_split_fmt(fmt /*:string*/ ) /*:Array<string>*/ {
    var out /*:Array<string>*/  = [];
    var in_str = false /*, cc*/ ;
    for(var i = 0, j = 0; i < fmt.length; ++i)switch(/*cc=*/ fmt.charCodeAt(i)){
        case 34:
            /* '"' */ in_str = !in_str;
            break;
        case 95:
        case 42:
        case 92:
            /* '_' '*' '\\' */ ++i;
            break;
        case 59:
            /* ';' */ out[out.length] = fmt.substr(j, i - j);
            j = i + 1;
    }
    out[out.length] = fmt.substr(j);
    if (in_str === true) throw new Error("Format |" + fmt + "| unterminated string ");
    return out;
}
var SSF_abstime = /\[[HhMmSs\u0E0A\u0E19\u0E17]*\]/;
function fmt_is_date(fmt /*:string*/ ) /*:boolean*/ {
    var i = 0, /*cc = 0,*/ c = "", o = "";
    while(i < fmt.length)switch(c = fmt.charAt(i)){
        case "G":
            if (SSF_isgeneral(fmt, i)) i += 6;
            i++;
            break;
        case '"':
            for(; /*cc=*/ fmt.charCodeAt(++i) !== 34 && i < fmt.length;);
            ++i;
            break;
        case "\\":
            i += 2;
            break;
        case "_":
            i += 2;
            break;
        case "@":
            ++i;
            break;
        case "B":
        case "b":
            if (fmt.charAt(i + 1) === "1" || fmt.charAt(i + 1) === "2") return true;
        /* falls through */ case "M":
        case "D":
        case "Y":
        case "H":
        case "S":
        case "E":
        /* falls through */ case "m":
        case "d":
        case "y":
        case "h":
        case "s":
        case "e":
        case "g":
            return true;
        case "A":
        case "a":
        case "上":
            if (fmt.substr(i, 3).toUpperCase() === "A/P") return true;
            if (fmt.substr(i, 5).toUpperCase() === "AM/PM") return true;
            if (fmt.substr(i, 5).toUpperCase() === "上午/下午") return true;
            ++i;
            break;
        case "[":
            o = c;
            while(fmt.charAt(i++) !== "]" && i < fmt.length)o += fmt.charAt(i);
            if (o.match(SSF_abstime)) return true;
            break;
        case ".":
        /* falls through */ case "0":
        case "#":
            while(i < fmt.length && ("0#?.,E+-%".indexOf(c = fmt.charAt(++i)) > -1 || c == "\\" && fmt.charAt(i + 1) == "-" && "0#".indexOf(fmt.charAt(i + 2)) > -1));
            break;
        case "?":
            while(fmt.charAt(++i) === c);
            break;
        case "*":
            ++i;
            if (fmt.charAt(i) == " " || fmt.charAt(i) == "*") ++i;
            break;
        case "(":
        case ")":
            ++i;
            break;
        case "1":
        case "2":
        case "3":
        case "4":
        case "5":
        case "6":
        case "7":
        case "8":
        case "9":
            while(i < fmt.length && "0123456789".indexOf(fmt.charAt(++i)) > -1);
            break;
        case " ":
            ++i;
            break;
        default:
            ++i;
            break;
    }
    return false;
}
function eval_fmt(fmt /*:string*/ , v /*:any*/ , opts /*:any*/ , flen /*:number*/ ) {
    var out = [], o = "", i = 0, c = "", lst = "t", dt, j, cc;
    var hr = "H";
    /* Tokenize */ while(i < fmt.length)switch(c = fmt.charAt(i)){
        case "G":
            /* General */ if (!SSF_isgeneral(fmt, i)) throw new Error("unrecognized character " + c + " in " + fmt);
            out[out.length] = {
                t: "G",
                v: "General"
            };
            i += 7;
            break;
        case '"':
            /* Literal text */ for(o = ""; (cc = fmt.charCodeAt(++i)) !== 34 && i < fmt.length;)o += String.fromCharCode(cc);
            out[out.length] = {
                t: "t",
                v: o
            };
            ++i;
            break;
        case "\\":
            var w = fmt.charAt(++i), t = w === "(" || w === ")" ? w : "t";
            out[out.length] = {
                t: t,
                v: w
            };
            ++i;
            break;
        case "_":
            out[out.length] = {
                t: "t",
                v: " "
            };
            i += 2;
            break;
        case "@":
            /* Text Placeholder */ out[out.length] = {
                t: "T",
                v: v
            };
            ++i;
            break;
        case "B":
        case "b":
            if (fmt.charAt(i + 1) === "1" || fmt.charAt(i + 1) === "2") {
                if (dt == null) {
                    dt = SSF_parse_date_code(v, opts, fmt.charAt(i + 1) === "2");
                    if (dt == null) return "";
                }
                out[out.length] = {
                    t: "X",
                    v: fmt.substr(i, 2)
                };
                lst = c;
                i += 2;
                break;
            }
        /* falls through */ case "M":
        case "D":
        case "Y":
        case "H":
        case "S":
        case "E":
            c = c.toLowerCase();
        /* falls through */ case "m":
        case "d":
        case "y":
        case "h":
        case "s":
        case "e":
        case "g":
            if (v < 0) return "";
            if (dt == null) {
                dt = SSF_parse_date_code(v, opts);
                if (dt == null) return "";
            }
            o = c;
            while(++i < fmt.length && fmt.charAt(i).toLowerCase() === c)o += c;
            if (c === "m" && lst.toLowerCase() === "h") c = "M";
            if (c === "h") c = hr;
            out[out.length] = {
                t: c,
                v: o
            };
            lst = c;
            break;
        case "A":
        case "a":
        case "上":
            var q = {
                t: c,
                v: c
            };
            if (dt == null) dt = SSF_parse_date_code(v, opts);
            if (fmt.substr(i, 3).toUpperCase() === "A/P") {
                if (dt != null) q.v = dt.H >= 12 ? "P" : "A";
                q.t = "T";
                hr = "h";
                i += 3;
            } else if (fmt.substr(i, 5).toUpperCase() === "AM/PM") {
                if (dt != null) q.v = dt.H >= 12 ? "PM" : "AM";
                q.t = "T";
                i += 5;
                hr = "h";
            } else if (fmt.substr(i, 5).toUpperCase() === "上午/下午") {
                if (dt != null) q.v = dt.H >= 12 ? "下午" : "上午";
                q.t = "T";
                i += 5;
                hr = "h";
            } else {
                q.t = "t";
                ++i;
            }
            if (dt == null && q.t === "T") return "";
            out[out.length] = q;
            lst = c;
            break;
        case "[":
            o = c;
            while(fmt.charAt(i++) !== "]" && i < fmt.length)o += fmt.charAt(i);
            if (o.slice(-1) !== "]") throw 'unterminated "[" block: |' + o + "|";
            if (o.match(SSF_abstime)) {
                if (dt == null) {
                    dt = SSF_parse_date_code(v, opts);
                    if (dt == null) return "";
                }
                out[out.length] = {
                    t: "Z",
                    v: o.toLowerCase()
                };
                lst = o.charAt(1);
            } else if (o.indexOf("$") > -1) {
                o = (o.match(/\$([^-\[\]]*)/) || [])[1] || "$";
                if (!fmt_is_date(fmt)) out[out.length] = {
                    t: "t",
                    v: o
                };
            }
            break;
        /* Numbers */ case ".":
            if (dt != null) {
                o = c;
                while(++i < fmt.length && (c = fmt.charAt(i)) === "0")o += c;
                out[out.length] = {
                    t: "s",
                    v: o
                };
                break;
            }
        /* falls through */ case "0":
        case "#":
            o = c;
            while(++i < fmt.length && "0#?.,E+-%".indexOf(c = fmt.charAt(i)) > -1)o += c;
            out[out.length] = {
                t: "n",
                v: o
            };
            break;
        case "?":
            o = c;
            while(fmt.charAt(++i) === c)o += c;
            out[out.length] = {
                t: c,
                v: o
            };
            lst = c;
            break;
        case "*":
            ++i;
            if (fmt.charAt(i) == " " || fmt.charAt(i) == "*") ++i;
            break; // **
        case "(":
        case ")":
            out[out.length] = {
                t: flen === 1 ? "t" : c,
                v: c
            };
            ++i;
            break;
        case "1":
        case "2":
        case "3":
        case "4":
        case "5":
        case "6":
        case "7":
        case "8":
        case "9":
            o = c;
            while(i < fmt.length && "0123456789".indexOf(fmt.charAt(++i)) > -1)o += fmt.charAt(i);
            out[out.length] = {
                t: "D",
                v: o
            };
            break;
        case " ":
            out[out.length] = {
                t: c,
                v: c
            };
            ++i;
            break;
        case "$":
            out[out.length] = {
                t: "t",
                v: "$"
            };
            ++i;
            break;
        default:
            if (",$-+/():!^&'~{}<>=€acfijklopqrtuvwxzP".indexOf(c) === -1) throw new Error("unrecognized character " + c + " in " + fmt);
            out[out.length] = {
                t: "t",
                v: c
            };
            ++i;
            break;
    }
    /* Scan for date/time parts */ var bt = 0, ss0 = 0, ssm;
    for(i = out.length - 1, lst = "t"; i >= 0; --i)switch(out[i].t){
        case "h":
        case "H":
            out[i].t = hr;
            lst = "h";
            if (bt < 1) bt = 1;
            break;
        case "s":
            if (ssm = out[i].v.match(/\.0+$/)) ss0 = Math.max(ss0, ssm[0].length - 1);
            if (bt < 3) bt = 3;
        /* falls through */ case "d":
        case "y":
        case "M":
        case "e":
            lst = out[i].t;
            break;
        case "m":
            if (lst === "s") {
                out[i].t = "M";
                if (bt < 2) bt = 2;
            }
            break;
        case "X":
            break;
        case "Z":
            if (bt < 1 && out[i].v.match(/[Hh]/)) bt = 1;
            if (bt < 2 && out[i].v.match(/[Mm]/)) bt = 2;
            if (bt < 3 && out[i].v.match(/[Ss]/)) bt = 3;
    }
    /* time rounding depends on presence of minute / second / usec fields */ switch(bt){
        case 0:
            break;
        case 1:
            /*::if(!dt) break;*/ if (dt.u >= 0.5) {
                dt.u = 0;
                ++dt.S;
            }
            if (dt.S >= 60) {
                dt.S = 0;
                ++dt.M;
            }
            if (dt.M >= 60) {
                dt.M = 0;
                ++dt.H;
            }
            break;
        case 2:
            /*::if(!dt) break;*/ if (dt.u >= 0.5) {
                dt.u = 0;
                ++dt.S;
            }
            if (dt.S >= 60) {
                dt.S = 0;
                ++dt.M;
            }
            break;
    }
    /* replace fields */ var nstr = "", jj;
    for(i = 0; i < out.length; ++i)switch(out[i].t){
        case "t":
        case "T":
        case " ":
        case "D":
            break;
        case "X":
            out[i].v = "";
            out[i].t = ";";
            break;
        case "d":
        case "m":
        case "y":
        case "h":
        case "H":
        case "M":
        case "s":
        case "e":
        case "b":
        case "Z":
            /*::if(!dt) throw "unreachable"; */ out[i].v = SSF_write_date(out[i].t.charCodeAt(0), out[i].v, dt, ss0);
            out[i].t = "t";
            break;
        case "n":
        case "?":
            jj = i + 1;
            while(out[jj] != null && ((c = out[jj].t) === "?" || c === "D" || (c === " " || c === "t") && out[jj + 1] != null && (out[jj + 1].t === "?" || out[jj + 1].t === "t" && out[jj + 1].v === "/") || out[i].t === "(" && (c === " " || c === "n" || c === ")") || c === "t" && (out[jj].v === "/" || out[jj].v === " " && out[jj + 1] != null && out[jj + 1].t == "?"))){
                out[i].v += out[jj].v;
                out[jj] = {
                    v: "",
                    t: ";"
                };
                ++jj;
            }
            nstr += out[i].v;
            i = jj - 1;
            break;
        case "G":
            out[i].t = "t";
            out[i].v = SSF_general(v, opts);
            break;
    }
    var vv = "", myv, ostr;
    if (nstr.length > 0) {
        if (nstr.charCodeAt(0) == 40) /* '(' */ {
            myv = v < 0 && nstr.charCodeAt(0) === 45 ? -v : v;
            ostr = write_num("n", nstr, myv);
        } else {
            myv = v < 0 && flen > 1 ? -v : v;
            ostr = write_num("n", nstr, myv);
            if (myv < 0 && out[0] && out[0].t == "t") {
                ostr = ostr.substr(1);
                out[0].v = "-" + out[0].v;
            }
        }
        jj = ostr.length - 1;
        var decpt = out.length;
        for(i = 0; i < out.length; ++i)if (out[i] != null && out[i].t != "t" && out[i].v.indexOf(".") > -1) {
            decpt = i;
            break;
        }
        var lasti = out.length;
        if (decpt === out.length && ostr.indexOf("E") === -1) {
            for(i = out.length - 1; i >= 0; --i){
                if (out[i] == null || "n?".indexOf(out[i].t) === -1) continue;
                if (jj >= out[i].v.length - 1) {
                    jj -= out[i].v.length;
                    out[i].v = ostr.substr(jj + 1, out[i].v.length);
                } else if (jj < 0) out[i].v = "";
                else {
                    out[i].v = ostr.substr(0, jj + 1);
                    jj = -1;
                }
                out[i].t = "t";
                lasti = i;
            }
            if (jj >= 0 && lasti < out.length) out[lasti].v = ostr.substr(0, jj + 1) + out[lasti].v;
        } else if (decpt !== out.length && ostr.indexOf("E") === -1) {
            jj = ostr.indexOf(".") - 1;
            for(i = decpt; i >= 0; --i){
                if (out[i] == null || "n?".indexOf(out[i].t) === -1) continue;
                j = out[i].v.indexOf(".") > -1 && i === decpt ? out[i].v.indexOf(".") - 1 : out[i].v.length - 1;
                vv = out[i].v.substr(j + 1);
                for(; j >= 0; --j)if (jj >= 0 && (out[i].v.charAt(j) === "0" || out[i].v.charAt(j) === "#")) vv = ostr.charAt(jj--) + vv;
                out[i].v = vv;
                out[i].t = "t";
                lasti = i;
            }
            if (jj >= 0 && lasti < out.length) out[lasti].v = ostr.substr(0, jj + 1) + out[lasti].v;
            jj = ostr.indexOf(".") + 1;
            for(i = decpt; i < out.length; ++i){
                if (out[i] == null || "n?(".indexOf(out[i].t) === -1 && i !== decpt) continue;
                j = out[i].v.indexOf(".") > -1 && i === decpt ? out[i].v.indexOf(".") + 1 : 0;
                vv = out[i].v.substr(0, j);
                for(; j < out[i].v.length; ++j)if (jj < ostr.length) vv += ostr.charAt(jj++);
                out[i].v = vv;
                out[i].t = "t";
                lasti = i;
            }
        }
    }
    for(i = 0; i < out.length; ++i)if (out[i] != null && "n?".indexOf(out[i].t) > -1) {
        myv = flen > 1 && v < 0 && i > 0 && out[i - 1].v === "-" ? -v : v;
        out[i].v = write_num(out[i].t, out[i].v, myv);
        out[i].t = "t";
    }
    var retval = "";
    for(i = 0; i !== out.length; ++i)if (out[i] != null) retval += out[i].v;
    return retval;
}
var cfregex2 = /\[(=|>[=]?|<[>=]?)(-?\d+(?:\.\d*)?)\]/;
function chkcond(v, rr) {
    if (rr == null) return false;
    var thresh = parseFloat(rr[2]);
    switch(rr[1]){
        case "=":
            if (v == thresh) return true;
            break;
        case ">":
            if (v > thresh) return true;
            break;
        case "<":
            if (v < thresh) return true;
            break;
        case "<>":
            if (v != thresh) return true;
            break;
        case ">=":
            if (v >= thresh) return true;
            break;
        case "<=":
            if (v <= thresh) return true;
            break;
    }
    return false;
}
function choose_fmt(f /*:string*/ , v /*:any*/ ) {
    var fmt = SSF_split_fmt(f);
    var l = fmt.length, lat = fmt[l - 1].indexOf("@");
    if (l < 4 && lat > -1) --l;
    if (fmt.length > 4) throw new Error("cannot find right format for |" + fmt.join("|") + "|");
    if (typeof v !== "number") return [
        4,
        fmt.length === 4 || lat > -1 ? fmt[fmt.length - 1] : "@"
    ];
    switch(fmt.length){
        case 1:
            fmt = lat > -1 ? [
                "General",
                "General",
                "General",
                fmt[0]
            ] : [
                fmt[0],
                fmt[0],
                fmt[0],
                "@"
            ];
            break;
        case 2:
            fmt = lat > -1 ? [
                fmt[0],
                fmt[0],
                fmt[0],
                fmt[1]
            ] : [
                fmt[0],
                fmt[1],
                fmt[0],
                "@"
            ];
            break;
        case 3:
            fmt = lat > -1 ? [
                fmt[0],
                fmt[1],
                fmt[0],
                fmt[2]
            ] : [
                fmt[0],
                fmt[1],
                fmt[2],
                "@"
            ];
            break;
        case 4:
            break;
    }
    var ff = v > 0 ? fmt[0] : v < 0 ? fmt[1] : fmt[2];
    if (fmt[0].indexOf("[") === -1 && fmt[1].indexOf("[") === -1) return [
        l,
        ff
    ];
    if (fmt[0].match(/\[[=<>]/) != null || fmt[1].match(/\[[=<>]/) != null) {
        var m1 = fmt[0].match(cfregex2);
        var m2 = fmt[1].match(cfregex2);
        return chkcond(v, m1) ? [
            l,
            fmt[0]
        ] : chkcond(v, m2) ? [
            l,
            fmt[1]
        ] : [
            l,
            fmt[m1 != null && m2 != null ? 2 : 1]
        ];
    }
    return [
        l,
        ff
    ];
}
function SSF_format(fmt /*:string|number*/ , v /*:any*/ , o /*:?any*/ ) {
    if (o == null) o = {};
    var sfmt = "";
    switch(typeof fmt){
        case "string":
            if (fmt == "m/d/yy" && o.dateNF) sfmt = o.dateNF;
            else sfmt = fmt;
            break;
        case "number":
            if (fmt == 14 && o.dateNF) sfmt = o.dateNF;
            else sfmt = (o.table != null ? o.table /*:any*/  : table_fmt)[fmt];
            if (sfmt == null) sfmt = o.table && o.table[SSF_default_map[fmt]] || table_fmt[SSF_default_map[fmt]];
            if (sfmt == null) sfmt = SSF_default_str[fmt] || "General";
            break;
    }
    if (SSF_isgeneral(sfmt, 0)) return SSF_general(v, o);
    if (v instanceof Date) v = datenum_local(v, o.date1904);
    var f = choose_fmt(sfmt, v);
    if (SSF_isgeneral(f[1])) return SSF_general(v, o);
    if (v === true) v = "TRUE";
    else if (v === false) v = "FALSE";
    else if (v === "" || v == null) return "";
    return eval_fmt(f[1], v, o, f[0]);
}
function SSF_load(fmt /*:string*/ , idx /*:?number*/ ) /*:number*/ {
    if (typeof idx != "number") {
        idx = +idx || -1;
        /*::if(typeof idx != 'number') return 0x188; */ for(var i = 0; i < 0x0188; ++i){
            /*::if(typeof idx != 'number') return 0x188; */ if (table_fmt[i] == undefined) {
                if (idx < 0) idx = i;
                continue;
            }
            if (table_fmt[i] == fmt) {
                idx = i;
                break;
            }
        }
        /*::if(typeof idx != 'number') return 0x188; */ if (idx < 0) idx = 0x187;
    }
    /*::if(typeof idx != 'number') return 0x188; */ table_fmt[idx] = fmt;
    return idx;
}
function SSF_load_table(tbl /*:SSFTable*/ ) /*:void*/ {
    for(var i = 0; i != 0x0188; ++i)if (tbl[i] !== undefined) SSF_load(tbl[i], i);
}
function make_ssf() {
    table_fmt = SSF_init_table();
}
var SSF = {
    format: SSF_format,
    load: SSF_load,
    _table: table_fmt,
    load_table: SSF_load_table,
    parse_date_code: SSF_parse_date_code,
    is_date: fmt_is_date,
    get_table: function get_table() {
        return SSF._table = table_fmt;
    }
};
var SSFImplicit /*{[number]:string}*/  = {
    "5": '"$"#,##0_);\\("$"#,##0\\)',
    "6": '"$"#,##0_);[Red]\\("$"#,##0\\)',
    "7": '"$"#,##0.00_);\\("$"#,##0.00\\)',
    "8": '"$"#,##0.00_);[Red]\\("$"#,##0.00\\)',
    "23": "General",
    "24": "General",
    "25": "General",
    "26": "General",
    "27": "m/d/yy",
    "28": "m/d/yy",
    "29": "m/d/yy",
    "30": "m/d/yy",
    "31": "m/d/yy",
    "32": "h:mm:ss",
    "33": "h:mm:ss",
    "34": "h:mm:ss",
    "35": "h:mm:ss",
    "36": "m/d/yy",
    "41": '_(* #,##0_);_(* (#,##0);_(* "-"_);_(@_)',
    "42": '_("$"* #,##0_);_("$"* (#,##0);_("$"* "-"_);_(@_)',
    "43": '_(* #,##0.00_);_(* (#,##0.00);_(* "-"??_);_(@_)',
    "44": '_("$"* #,##0.00_);_("$"* (#,##0.00);_("$"* "-"??_);_(@_)',
    "50": "m/d/yy",
    "51": "m/d/yy",
    "52": "m/d/yy",
    "53": "m/d/yy",
    "54": "m/d/yy",
    "55": "m/d/yy",
    "56": "m/d/yy",
    "57": "m/d/yy",
    "58": "m/d/yy",
    "59": "0",
    "60": "0.00",
    "61": "#,##0",
    "62": "#,##0.00",
    "63": '"$"#,##0_);\\("$"#,##0\\)',
    "64": '"$"#,##0_);[Red]\\("$"#,##0\\)',
    "65": '"$"#,##0.00_);\\("$"#,##0.00\\)',
    "66": '"$"#,##0.00_);[Red]\\("$"#,##0.00\\)',
    "67": "0%",
    "68": "0.00%",
    "69": "# ?/?",
    "70": "# ??/??",
    "71": "m/d/yy",
    "72": "m/d/yy",
    "73": "d-mmm-yy",
    "74": "d-mmm",
    "75": "mmm-yy",
    "76": "h:mm",
    "77": "h:mm:ss",
    "78": "m/d/yy h:mm",
    "79": "mm:ss",
    "80": "[h]:mm:ss",
    "81": "mmss.0"
} /*:any*/ ;
/* dateNF parse TODO: move to SSF */ var dateNFregex = /[dD]+|[mM]+|[yYeE]+|[Hh]+|[Ss]+/g;
function dateNF_regex(dateNF /*:string|number*/ ) /*:RegExp*/ {
    var fmt = typeof dateNF == "number" ? table_fmt[dateNF] : dateNF;
    fmt = fmt.replace(dateNFregex, "(\\d+)");
    return new RegExp("^" + fmt + "$");
}
function dateNF_fix(str /*:string*/ , dateNF /*:string*/ , match /*:Array<string>*/ ) /*:string*/ {
    var Y = -1, m = -1, d = -1, H = -1, M = -1, S = -1;
    (dateNF.match(dateNFregex) || []).forEach(function(n, i) {
        var v = parseInt(match[i + 1], 10);
        switch(n.toLowerCase().charAt(0)){
            case "y":
                Y = v;
                break;
            case "d":
                d = v;
                break;
            case "h":
                H = v;
                break;
            case "s":
                S = v;
                break;
            case "m":
                if (H >= 0) M = v;
                else m = v;
                break;
        }
    });
    if (S >= 0 && M == -1 && m >= 0) {
        M = m;
        m = -1;
    }
    var datestr = ("" + (Y >= 0 ? Y : new Date().getFullYear())).slice(-4) + "-" + ("00" + (m >= 1 ? m : 1)).slice(-2) + "-" + ("00" + (d >= 1 ? d : 1)).slice(-2);
    if (datestr.length == 7) datestr = "0" + datestr;
    if (datestr.length == 8) datestr = "20" + datestr;
    var timestr = ("00" + (H >= 0 ? H : 0)).slice(-2) + ":" + ("00" + (M >= 0 ? M : 0)).slice(-2) + ":" + ("00" + (S >= 0 ? S : 0)).slice(-2);
    if (H == -1 && M == -1 && S == -1) return datestr;
    if (Y == -1 && m == -1 && d == -1) return timestr;
    return datestr + "T" + timestr;
}
/*::
declare var ReadShift:any;
declare var CheckField:any;
declare var prep_blob:any;
declare var __readUInt32LE:any;
declare var __readInt32LE:any;
declare var __toBuffer:any;
declare var __utf16le:any;
declare var bconcat:any;
declare var s2a:any;
declare var chr0:any;
declare var chr1:any;
declare var has_buf:boolean;
declare var new_buf:any;
declare var new_raw_buf:any;
declare var new_unsafe_buf:any;
declare var Buffer_from:any;
*/ /* cfb.js (C) 2013-present SheetJS -- http://sheetjs.com */ /* vim: set ts=2: */ /*jshint eqnull:true */ /*exported CFB */ /*global Uint8Array:false, Uint16Array:false */ /*::
type SectorEntry = {
	name?:string;
	nodes?:Array<number>;
	data:RawBytes;
};
type SectorList = {
	[k:string|number]:SectorEntry;
	name:?string;
	fat_addrs:Array<number>;
	ssz:number;
}
type CFBFiles = {[n:string]:CFBEntry};
*/ /* crc32.js (C) 2014-present SheetJS -- http://sheetjs.com */ /* vim: set ts=2: */ /*exported CRC32 */ var CRC32 = /*#__PURE__*/ function() {
    var CRC32 = {};
    CRC32.version = "1.2.0";
    /* see perf/crc32table.js */ /*global Int32Array */ function signed_crc_table() /*:any*/ {
        var c = 0, table /*:Array<number>*/  = new Array(256);
        for(var n = 0; n != 256; ++n){
            c = n;
            c = c & 1 ? -306674912 ^ c >>> 1 : c >>> 1;
            c = c & 1 ? -306674912 ^ c >>> 1 : c >>> 1;
            c = c & 1 ? -306674912 ^ c >>> 1 : c >>> 1;
            c = c & 1 ? -306674912 ^ c >>> 1 : c >>> 1;
            c = c & 1 ? -306674912 ^ c >>> 1 : c >>> 1;
            c = c & 1 ? -306674912 ^ c >>> 1 : c >>> 1;
            c = c & 1 ? -306674912 ^ c >>> 1 : c >>> 1;
            c = c & 1 ? -306674912 ^ c >>> 1 : c >>> 1;
            table[n] = c;
        }
        return typeof Int32Array !== "undefined" ? new Int32Array(table) : table;
    }
    var T0 = signed_crc_table();
    function slice_by_16_tables(T) {
        var c = 0, v = 0, n = 0, table /*:Array<number>*/  = typeof Int32Array !== "undefined" ? new Int32Array(4096) : new Array(4096);
        for(n = 0; n != 256; ++n)table[n] = T[n];
        for(n = 0; n != 256; ++n){
            v = T[n];
            for(c = 256 + n; c < 4096; c += 256)v = table[c] = v >>> 8 ^ T[v & 0xFF];
        }
        var out = [];
        for(n = 1; n != 16; ++n)out[n - 1] = typeof Int32Array !== "undefined" ? table.subarray(n * 256, n * 256 + 256) : table.slice(n * 256, n * 256 + 256);
        return out;
    }
    var TT = slice_by_16_tables(T0);
    var T1 = TT[0], T2 = TT[1], T3 = TT[2], T4 = TT[3], T5 = TT[4];
    var T6 = TT[5], T7 = TT[6], T8 = TT[7], T9 = TT[8], Ta = TT[9];
    var Tb = TT[10], Tc = TT[11], Td = TT[12], Te = TT[13], Tf = TT[14];
    function crc32_bstr(bstr /*:string*/ , seed /*:number*/ ) /*:number*/ {
        var C = seed /*:: ? 0 : 0 */  ^ -1;
        for(var i = 0, L = bstr.length; i < L;)C = C >>> 8 ^ T0[(C ^ bstr.charCodeAt(i++)) & 0xFF];
        return ~C;
    }
    function crc32_buf(B /*:Uint8Array|Array<number>*/ , seed /*:number*/ ) /*:number*/ {
        var C = seed /*:: ? 0 : 0 */  ^ -1, L = B.length - 15, i = 0;
        for(; i < L;)C = Tf[B[i++] ^ C & 255] ^ Te[B[i++] ^ C >> 8 & 255] ^ Td[B[i++] ^ C >> 16 & 255] ^ Tc[B[i++] ^ C >>> 24] ^ Tb[B[i++]] ^ Ta[B[i++]] ^ T9[B[i++]] ^ T8[B[i++]] ^ T7[B[i++]] ^ T6[B[i++]] ^ T5[B[i++]] ^ T4[B[i++]] ^ T3[B[i++]] ^ T2[B[i++]] ^ T1[B[i++]] ^ T0[B[i++]];
        L += 15;
        while(i < L)C = C >>> 8 ^ T0[(C ^ B[i++]) & 0xFF];
        return ~C;
    }
    function crc32_str(str /*:string*/ , seed /*:number*/ ) /*:number*/ {
        var C = seed ^ -1;
        for(var i = 0, L = str.length, c = 0, d = 0; i < L;){
            c = str.charCodeAt(i++);
            if (c < 0x80) C = C >>> 8 ^ T0[(C ^ c) & 0xFF];
            else if (c < 0x800) {
                C = C >>> 8 ^ T0[(C ^ (192 | c >> 6 & 31)) & 0xFF];
                C = C >>> 8 ^ T0[(C ^ (128 | c & 63)) & 0xFF];
            } else if (c >= 0xD800 && c < 0xE000) {
                c = (c & 1023) + 64;
                d = str.charCodeAt(i++) & 1023;
                C = C >>> 8 ^ T0[(C ^ (240 | c >> 8 & 7)) & 0xFF];
                C = C >>> 8 ^ T0[(C ^ (128 | c >> 2 & 63)) & 0xFF];
                C = C >>> 8 ^ T0[(C ^ (128 | d >> 6 & 15 | (c & 3) << 4)) & 0xFF];
                C = C >>> 8 ^ T0[(C ^ (128 | d & 63)) & 0xFF];
            } else {
                C = C >>> 8 ^ T0[(C ^ (224 | c >> 12 & 15)) & 0xFF];
                C = C >>> 8 ^ T0[(C ^ (128 | c >> 6 & 63)) & 0xFF];
                C = C >>> 8 ^ T0[(C ^ (128 | c & 63)) & 0xFF];
            }
        }
        return ~C;
    }
    CRC32.table = T0;
    CRC32.bstr = crc32_bstr;
    CRC32.buf = crc32_buf;
    CRC32.str = crc32_str;
    return CRC32;
}();
/* [MS-CFB] v20171201 */ var CFB = /*#__PURE__*/ function _CFB() {
    var exports = {};
    exports.version = "1.2.1";
    /* [MS-CFB] 2.6.4 */ function namecmp(l /*:string*/ , r /*:string*/ ) /*:number*/ {
        var L = l.split("/"), R = r.split("/");
        for(var i = 0, c = 0, Z = Math.min(L.length, R.length); i < Z; ++i){
            if (c = L[i].length - R[i].length) return c;
            if (L[i] != R[i]) return L[i] < R[i] ? -1 : 1;
        }
        return L.length - R.length;
    }
    function dirname(p /*:string*/ ) /*:string*/ {
        if (p.charAt(p.length - 1) == "/") return p.slice(0, -1).indexOf("/") === -1 ? p : dirname(p.slice(0, -1));
        var c = p.lastIndexOf("/");
        return c === -1 ? p : p.slice(0, c + 1);
    }
    function filename(p /*:string*/ ) /*:string*/ {
        if (p.charAt(p.length - 1) == "/") return filename(p.slice(0, -1));
        var c = p.lastIndexOf("/");
        return c === -1 ? p : p.slice(c + 1);
    }
    /* -------------------------------------------------------------------------- */ /* DOS Date format:
   high|YYYYYYYm.mmmddddd.HHHHHMMM.MMMSSSSS|low
   add 1980 to stored year
   stored second should be doubled
*/ /* write JS date to buf as a DOS date */ function write_dos_date(buf /*:CFBlob*/ , date /*:Date|string*/ ) {
        if (typeof date === "string") date = new Date(date);
        var hms /*:number*/  = date.getHours();
        hms = hms << 6 | date.getMinutes();
        hms = hms << 5 | date.getSeconds() >>> 1;
        buf.write_shift(2, hms);
        var ymd /*:number*/  = date.getFullYear() - 1980;
        ymd = ymd << 4 | date.getMonth() + 1;
        ymd = ymd << 5 | date.getDate();
        buf.write_shift(2, ymd);
    }
    /* read four bytes from buf and interpret as a DOS date */ function parse_dos_date(buf /*:CFBlob*/ ) /*:Date*/ {
        var hms = buf.read_shift(2) & 0xFFFF;
        var ymd = buf.read_shift(2) & 0xFFFF;
        var val = new Date();
        var d = ymd & 0x1F;
        ymd >>>= 5;
        var m = ymd & 0x0F;
        ymd >>>= 4;
        val.setMilliseconds(0);
        val.setFullYear(ymd + 1980);
        val.setMonth(m - 1);
        val.setDate(d);
        var S = hms & 0x1F;
        hms >>>= 5;
        var M = hms & 0x3F;
        hms >>>= 6;
        val.setHours(hms);
        val.setMinutes(M);
        val.setSeconds(S << 1);
        return val;
    }
    function parse_extra_field(blob /*:CFBlob*/ ) /*:any*/ {
        prep_blob(blob, 0);
        var o = /*::(*/ {} /*:: :any)*/ ;
        var flags = 0;
        while(blob.l <= blob.length - 4){
            var type = blob.read_shift(2);
            var sz = blob.read_shift(2), tgt = blob.l + sz;
            var p = {};
            switch(type){
                /* UNIX-style Timestamps */ case 0x5455:
                    flags = blob.read_shift(1);
                    if (flags & 1) p.mtime = blob.read_shift(4);
                    /* for some reason, CD flag corresponds to LFH */ if (sz > 5) {
                        if (flags & 2) p.atime = blob.read_shift(4);
                        if (flags & 4) p.ctime = blob.read_shift(4);
                    }
                    if (p.mtime) p.mt = new Date(p.mtime * 1000);
                    break;
            }
            blob.l = tgt;
            o[type] = p;
        }
        return o;
    }
    var fs /*:: = require('fs'); */ ;
    function get_fs() {
        return fs || (fs = {});
    }
    function parse(file /*:RawBytes*/ , options /*:CFBReadOpts*/ ) /*:CFBContainer*/ {
        if (file[0] == 0x50 && file[1] == 0x4b) return parse_zip(file, options);
        if ((file[0] | 0x20) == 0x6d && (file[1] | 0x20) == 0x69) return parse_mad(file, options);
        if (file.length < 512) throw new Error("CFB file size " + file.length + " < 512");
        var mver = 3;
        var ssz = 512;
        var nmfs = 0; // number of mini FAT sectors
        var difat_sec_cnt = 0;
        var dir_start = 0;
        var minifat_start = 0;
        var difat_start = 0;
        var fat_addrs /*:Array<number>*/  = []; // locations of FAT sectors
        /* [MS-CFB] 2.2 Compound File Header */ var blob /*:CFBlob*/  = /*::(*/ file.slice(0, 512) /*:: :any)*/ ;
        prep_blob(blob, 0);
        /* major version */ var mv = check_get_mver(blob);
        mver = mv[0];
        switch(mver){
            case 3:
                ssz = 512;
                break;
            case 4:
                ssz = 4096;
                break;
            case 0:
                if (mv[1] == 0) return parse_zip(file, options);
            /* falls through */ default:
                throw new Error("Major Version: Expected 3 or 4 saw " + mver);
        }
        /* reprocess header */ if (ssz !== 512) {
            blob = /*::(*/ file.slice(0, ssz) /*:: :any)*/ ;
            prep_blob(blob, 28 /* blob.l */ );
        }
        /* Save header for final object */ var header /*:RawBytes*/  = file.slice(0, ssz);
        check_shifts(blob, mver);
        // Number of Directory Sectors
        var dir_cnt /*:number*/  = blob.read_shift(4, "i");
        if (mver === 3 && dir_cnt !== 0) throw new Error("# Directory Sectors: Expected 0 saw " + dir_cnt);
        // Number of FAT Sectors
        blob.l += 4;
        // First Directory Sector Location
        dir_start = blob.read_shift(4, "i");
        // Transaction Signature
        blob.l += 4;
        // Mini Stream Cutoff Size
        blob.chk("00100000", "Mini Stream Cutoff Size: ");
        // First Mini FAT Sector Location
        minifat_start = blob.read_shift(4, "i");
        // Number of Mini FAT Sectors
        nmfs = blob.read_shift(4, "i");
        // First DIFAT sector location
        difat_start = blob.read_shift(4, "i");
        // Number of DIFAT Sectors
        difat_sec_cnt = blob.read_shift(4, "i");
        // Grab FAT Sector Locations
        for(var q = -1, j = 0; j < 109; ++j){
            q = blob.read_shift(4, "i");
            if (q < 0) break;
            fat_addrs[j] = q;
        }
        /** Break the file up into sectors */ var sectors /*:Array<RawBytes>*/  = sectorify(file, ssz);
        sleuth_fat(difat_start, difat_sec_cnt, sectors, ssz, fat_addrs);
        /** Chains */ var sector_list /*:SectorList*/  = make_sector_list(sectors, dir_start, fat_addrs, ssz);
        sector_list[dir_start].name = "!Directory";
        if (nmfs > 0 && minifat_start !== ENDOFCHAIN) sector_list[minifat_start].name = "!MiniFAT";
        sector_list[fat_addrs[0]].name = "!FAT";
        sector_list.fat_addrs = fat_addrs;
        sector_list.ssz = ssz;
        /* [MS-CFB] 2.6.1 Compound File Directory Entry */ var files /*:CFBFiles*/  = {}, Paths /*:Array<string>*/  = [], FileIndex /*:CFBFileIndex*/  = [], FullPaths /*:Array<string>*/  = [];
        read_directory(dir_start, sector_list, sectors, Paths, nmfs, files, FileIndex, minifat_start);
        build_full_paths(FileIndex, FullPaths, Paths);
        Paths.shift();
        var o = {
            FileIndex: FileIndex,
            FullPaths: FullPaths
        };
        // $FlowIgnore
        if (options && options.raw) o.raw = {
            header: header,
            sectors: sectors
        };
        return o;
    } // parse
    /* [MS-CFB] 2.2 Compound File Header -- read up to major version */ function check_get_mver(blob /*:CFBlob*/ ) /*:[number, number]*/ {
        if (blob[blob.l] == 0x50 && blob[blob.l + 1] == 0x4b) return [
            0,
            0
        ];
        // header signature 8
        blob.chk(HEADER_SIGNATURE, "Header Signature: ");
        // clsid 16
        //blob.chk(HEADER_CLSID, 'CLSID: ');
        blob.l += 16;
        // minor version 2
        var mver /*:number*/  = blob.read_shift(2, "u");
        return [
            blob.read_shift(2, "u"),
            mver
        ];
    }
    function check_shifts(blob /*:CFBlob*/ , mver /*:number*/ ) /*:void*/ {
        var shift = 0x09;
        // Byte Order
        //blob.chk('feff', 'Byte Order: '); // note: some writers put 0xffff
        blob.l += 2;
        // Sector Shift
        switch(shift = blob.read_shift(2)){
            case 0x09:
                if (mver != 3) throw new Error("Sector Shift: Expected 9 saw " + shift);
                break;
            case 0x0c:
                if (mver != 4) throw new Error("Sector Shift: Expected 12 saw " + shift);
                break;
            default:
                throw new Error("Sector Shift: Expected 9 or 12 saw " + shift);
        }
        // Mini Sector Shift
        blob.chk("0600", "Mini Sector Shift: ");
        // Reserved
        blob.chk("000000000000", "Reserved: ");
    }
    /** Break the file up into sectors */ function sectorify(file /*:RawBytes*/ , ssz /*:number*/ ) /*:Array<RawBytes>*/ {
        var nsectors = Math.ceil(file.length / ssz) - 1;
        var sectors /*:Array<RawBytes>*/  = [];
        for(var i = 1; i < nsectors; ++i)sectors[i - 1] = file.slice(i * ssz, (i + 1) * ssz);
        sectors[nsectors - 1] = file.slice(nsectors * ssz);
        return sectors;
    }
    /* [MS-CFB] 2.6.4 Red-Black Tree */ function build_full_paths(FI /*:CFBFileIndex*/ , FP /*:Array<string>*/ , Paths /*:Array<string>*/ ) /*:void*/ {
        var i = 0, L = 0, R = 0, C = 0, j = 0, pl = Paths.length;
        var dad /*:Array<number>*/  = [], q /*:Array<number>*/  = [];
        for(; i < pl; ++i){
            dad[i] = q[i] = i;
            FP[i] = Paths[i];
        }
        for(; j < q.length; ++j){
            i = q[j];
            L = FI[i].L;
            R = FI[i].R;
            C = FI[i].C;
            if (dad[i] === i) {
                if (L !== -1 /*NOSTREAM*/  && dad[L] !== L) dad[i] = dad[L];
                if (R !== -1 && dad[R] !== R) dad[i] = dad[R];
            }
            if (C !== -1 /*NOSTREAM*/ ) dad[C] = i;
            if (L !== -1 && i != dad[i]) {
                dad[L] = dad[i];
                if (q.lastIndexOf(L) < j) q.push(L);
            }
            if (R !== -1 && i != dad[i]) {
                dad[R] = dad[i];
                if (q.lastIndexOf(R) < j) q.push(R);
            }
        }
        for(i = 1; i < pl; ++i)if (dad[i] === i) {
            if (R !== -1 /*NOSTREAM*/  && dad[R] !== R) dad[i] = dad[R];
            else if (L !== -1 && dad[L] !== L) dad[i] = dad[L];
        }
        for(i = 1; i < pl; ++i){
            if (FI[i].type === 0 /* unknown */ ) continue;
            j = i;
            if (j != dad[j]) do {
                j = dad[j];
                FP[i] = FP[j] + "/" + FP[i];
            }while (j !== 0 && -1 !== dad[j] && j != dad[j]);
            dad[i] = -1;
        }
        FP[0] += "/";
        for(i = 1; i < pl; ++i)if (FI[i].type !== 2 /* stream */ ) FP[i] += "/";
    }
    function get_mfat_entry(entry /*:CFBEntry*/ , payload /*:RawBytes*/ , mini /*:?RawBytes*/ ) /*:CFBlob*/ {
        var start = entry.start, size = entry.size;
        //return (payload.slice(start*MSSZ, start*MSSZ + size)/*:any*/);
        var o = [];
        var idx = start;
        while(mini && size > 0 && idx >= 0){
            o.push(payload.slice(idx * MSSZ, idx * MSSZ + MSSZ));
            size -= MSSZ;
            idx = __readInt32LE(mini, idx * 4);
        }
        if (o.length === 0) return new_buf(0);
        return bconcat(o).slice(0, entry.size);
    }
    /** Chase down the rest of the DIFAT chain to build a comprehensive list
    DIFAT chains by storing the next sector number as the last 32 bits */ function sleuth_fat(idx /*:number*/ , cnt /*:number*/ , sectors /*:Array<RawBytes>*/ , ssz /*:number*/ , fat_addrs) /*:void*/ {
        var q /*:number*/  = ENDOFCHAIN;
        if (idx === ENDOFCHAIN) {
            if (cnt !== 0) throw new Error("DIFAT chain shorter than expected");
        } else if (idx !== -1 /*FREESECT*/ ) {
            var sector = sectors[idx], m = (ssz >>> 2) - 1;
            if (!sector) return;
            for(var i = 0; i < m; ++i){
                if ((q = __readInt32LE(sector, i * 4)) === ENDOFCHAIN) break;
                fat_addrs.push(q);
            }
            sleuth_fat(__readInt32LE(sector, ssz - 4), cnt - 1, sectors, ssz, fat_addrs);
        }
    }
    /** Follow the linked list of sectors for a given starting point */ function get_sector_list(sectors /*:Array<RawBytes>*/ , start /*:number*/ , fat_addrs /*:Array<number>*/ , ssz /*:number*/ , chkd /*:?Array<boolean>*/ ) /*:SectorEntry*/ {
        var buf /*:Array<number>*/  = [], buf_chain /*:Array<any>*/  = [];
        if (!chkd) chkd = [];
        var modulus = ssz - 1, j = 0, jj = 0;
        for(j = start; j >= 0;){
            chkd[j] = true;
            buf[buf.length] = j;
            buf_chain.push(sectors[j]);
            var addr = fat_addrs[Math.floor(j * 4 / ssz)];
            jj = j * 4 & modulus;
            if (ssz < 4 + jj) throw new Error("FAT boundary crossed: " + j + " 4 " + ssz);
            if (!sectors[addr]) break;
            j = __readInt32LE(sectors[addr], jj);
        }
        return {
            nodes: buf,
            data: __toBuffer([
                buf_chain
            ])
        };
    }
    /** Chase down the sector linked lists */ function make_sector_list(sectors /*:Array<RawBytes>*/ , dir_start /*:number*/ , fat_addrs /*:Array<number>*/ , ssz /*:number*/ ) /*:SectorList*/ {
        var sl = sectors.length, sector_list /*:SectorList*/  = [];
        var chkd /*:Array<boolean>*/  = [], buf /*:Array<number>*/  = [], buf_chain /*:Array<RawBytes>*/  = [];
        var modulus = ssz - 1, i = 0, j = 0, k = 0, jj = 0;
        for(i = 0; i < sl; ++i){
            buf = [];
            k = i + dir_start;
            if (k >= sl) k -= sl;
            if (chkd[k]) continue;
            buf_chain = [];
            var seen = [];
            for(j = k; j >= 0;){
                seen[j] = true;
                chkd[j] = true;
                buf[buf.length] = j;
                buf_chain.push(sectors[j]);
                var addr /*:number*/  = fat_addrs[Math.floor(j * 4 / ssz)];
                jj = j * 4 & modulus;
                if (ssz < 4 + jj) throw new Error("FAT boundary crossed: " + j + " 4 " + ssz);
                if (!sectors[addr]) break;
                j = __readInt32LE(sectors[addr], jj);
                if (seen[j]) break;
            }
            sector_list[k] = {
                nodes: buf,
                data: __toBuffer([
                    buf_chain
                ])
            } /*:SectorEntry*/ ;
        }
        return sector_list;
    }
    /* [MS-CFB] 2.6.1 Compound File Directory Entry */ function read_directory(dir_start /*:number*/ , sector_list /*:SectorList*/ , sectors /*:Array<RawBytes>*/ , Paths /*:Array<string>*/ , nmfs, files, FileIndex, mini) {
        var minifat_store = 0, pl = Paths.length ? 2 : 0;
        var sector = sector_list[dir_start].data;
        var i = 0, namelen = 0, name;
        for(; i < sector.length; i += 128){
            var blob /*:CFBlob*/  = /*::(*/ sector.slice(i, i + 128) /*:: :any)*/ ;
            prep_blob(blob, 64);
            namelen = blob.read_shift(2);
            name = __utf16le(blob, 0, namelen - pl);
            Paths.push(name);
            var o /*:CFBEntry*/  = {
                name: name,
                type: blob.read_shift(1),
                color: blob.read_shift(1),
                L: blob.read_shift(4, "i"),
                R: blob.read_shift(4, "i"),
                C: blob.read_shift(4, "i"),
                clsid: blob.read_shift(16),
                state: blob.read_shift(4, "i"),
                start: 0,
                size: 0
            };
            var ctime /*:number*/  = blob.read_shift(2) + blob.read_shift(2) + blob.read_shift(2) + blob.read_shift(2);
            if (ctime !== 0) o.ct = read_date(blob, blob.l - 8);
            var mtime /*:number*/  = blob.read_shift(2) + blob.read_shift(2) + blob.read_shift(2) + blob.read_shift(2);
            if (mtime !== 0) o.mt = read_date(blob, blob.l - 8);
            o.start = blob.read_shift(4, "i");
            o.size = blob.read_shift(4, "i");
            if (o.size < 0 && o.start < 0) {
                o.size = o.type = 0;
                o.start = ENDOFCHAIN;
                o.name = "";
            }
            if (o.type === 5) {
                minifat_store = o.start;
                if (nmfs > 0 && minifat_store !== ENDOFCHAIN) sector_list[minifat_store].name = "!StreamData";
            /*minifat_size = o.size;*/ } else if (o.size >= 4096 /* MSCSZ */ ) {
                o.storage = "fat";
                if (sector_list[o.start] === undefined) sector_list[o.start] = get_sector_list(sectors, o.start, sector_list.fat_addrs, sector_list.ssz);
                sector_list[o.start].name = o.name;
                o.content = sector_list[o.start].data.slice(0, o.size);
            } else {
                o.storage = "minifat";
                if (o.size < 0) o.size = 0;
                else if (minifat_store !== ENDOFCHAIN && o.start !== ENDOFCHAIN && sector_list[minifat_store]) o.content = get_mfat_entry(o, sector_list[minifat_store].data, (sector_list[mini] || {}).data);
            }
            if (o.content) prep_blob(o.content, 0);
            files[name] = o;
            FileIndex.push(o);
        }
    }
    function read_date(blob /*:RawBytes|CFBlob*/ , offset /*:number*/ ) /*:Date*/ {
        return new Date((__readUInt32LE(blob, offset + 4) / 1e7 * Math.pow(2, 32) + __readUInt32LE(blob, offset) / 1e7 - 11644473600) * 1000);
    }
    function read_file(filename /*:string*/ , options /*:CFBReadOpts*/ ) {
        get_fs();
        return parse(fs.readFileSync(filename), options);
    }
    function read(blob /*:RawBytes|string*/ , options /*:CFBReadOpts*/ ) {
        var type = options && options.type;
        if (!type) {
            if (has_buf && Buffer.isBuffer(blob)) type = "buffer";
        }
        switch(type || "base64"){
            case "file":
                /*:: if(typeof blob !== 'string') throw "Must pass a filename when type='file'"; */ return read_file(blob, options);
            case "base64":
                /*:: if(typeof blob !== 'string') throw "Must pass a base64-encoded binary string when type='file'"; */ return parse(s2a(Base64_decode(blob)), options);
            case "binary":
                /*:: if(typeof blob !== 'string') throw "Must pass a binary string when type='file'"; */ return parse(s2a(blob), options);
        }
        return parse(/*::typeof blob == 'string' ? new Buffer(blob, 'utf-8') : */ blob, options);
    }
    function init_cfb(cfb /*:CFBContainer*/ , opts /*:?any*/ ) /*:void*/ {
        var o = opts || {}, root = o.root || "Root Entry";
        if (!cfb.FullPaths) cfb.FullPaths = [];
        if (!cfb.FileIndex) cfb.FileIndex = [];
        if (cfb.FullPaths.length !== cfb.FileIndex.length) throw new Error("inconsistent CFB structure");
        if (cfb.FullPaths.length === 0) {
            cfb.FullPaths[0] = root + "/";
            cfb.FileIndex[0] = {
                name: root,
                type: 5
            } /*:any*/ ;
        }
        if (o.CLSID) cfb.FileIndex[0].clsid = o.CLSID;
        seed_cfb(cfb);
    }
    function seed_cfb(cfb /*:CFBContainer*/ ) /*:void*/ {
        var nm = "\x01Sh33tJ5";
        if (CFB.find(cfb, "/" + nm)) return;
        var p = new_buf(4);
        p[0] = 55;
        p[1] = p[3] = 50;
        p[2] = 54;
        cfb.FileIndex.push({
            name: nm,
            type: 2,
            content: p,
            size: 4,
            L: 69,
            R: 69,
            C: 69
        } /*:any*/ );
        cfb.FullPaths.push(cfb.FullPaths[0] + nm);
        rebuild_cfb(cfb);
    }
    function rebuild_cfb(cfb /*:CFBContainer*/ , f /*:?boolean*/ ) /*:void*/ {
        init_cfb(cfb);
        var gc = false, s = false;
        for(var i = cfb.FullPaths.length - 1; i >= 0; --i){
            var _file = cfb.FileIndex[i];
            switch(_file.type){
                case 0:
                    if (s) gc = true;
                    else {
                        cfb.FileIndex.pop();
                        cfb.FullPaths.pop();
                    }
                    break;
                case 1:
                case 2:
                case 5:
                    s = true;
                    if (isNaN(_file.R * _file.L * _file.C)) gc = true;
                    if (_file.R > -1 && _file.L > -1 && _file.R == _file.L) gc = true;
                    break;
                default:
                    gc = true;
                    break;
            }
        }
        if (!gc && !f) return;
        var now = new Date(1987, 1, 19), j = 0;
        // Track which names exist
        var fullPaths = Object.create ? Object.create(null) : {};
        var data /*:Array<[string, CFBEntry]>*/  = [];
        for(i = 0; i < cfb.FullPaths.length; ++i){
            fullPaths[cfb.FullPaths[i]] = true;
            if (cfb.FileIndex[i].type === 0) continue;
            data.push([
                cfb.FullPaths[i],
                cfb.FileIndex[i]
            ]);
        }
        for(i = 0; i < data.length; ++i){
            var dad = dirname(data[i][0]);
            s = fullPaths[dad];
            if (!s) {
                data.push([
                    dad,
                    {
                        name: filename(dad).replace("/", ""),
                        type: 1,
                        clsid: HEADER_CLSID,
                        ct: now,
                        mt: now,
                        content: null
                    } /*:any*/ 
                ]);
                // Add name to set
                fullPaths[dad] = true;
            }
        }
        data.sort(function(x, y) {
            return namecmp(x[0], y[0]);
        });
        cfb.FullPaths = [];
        cfb.FileIndex = [];
        for(i = 0; i < data.length; ++i){
            cfb.FullPaths[i] = data[i][0];
            cfb.FileIndex[i] = data[i][1];
        }
        for(i = 0; i < data.length; ++i){
            var elt = cfb.FileIndex[i];
            var nm = cfb.FullPaths[i];
            elt.name = filename(nm).replace("/", "");
            elt.L = elt.R = elt.C = -(elt.color = 1);
            elt.size = elt.content ? elt.content.length : 0;
            elt.start = 0;
            elt.clsid = elt.clsid || HEADER_CLSID;
            if (i === 0) {
                elt.C = data.length > 1 ? 1 : -1;
                elt.size = 0;
                elt.type = 5;
            } else if (nm.slice(-1) == "/") {
                for(j = i + 1; j < data.length; ++j)if (dirname(cfb.FullPaths[j]) == nm) break;
                elt.C = j >= data.length ? -1 : j;
                for(j = i + 1; j < data.length; ++j)if (dirname(cfb.FullPaths[j]) == dirname(nm)) break;
                elt.R = j >= data.length ? -1 : j;
                elt.type = 1;
            } else {
                if (dirname(cfb.FullPaths[i + 1] || "") == dirname(nm)) elt.R = i + 1;
                elt.type = 2;
            }
        }
    }
    function _write(cfb /*:CFBContainer*/ , options /*:CFBWriteOpts*/ ) /*:RawBytes|string*/ {
        var _opts = options || {};
        /* MAD is order-sensitive, skip rebuild and sort */ if (_opts.fileType == "mad") return write_mad(cfb, _opts);
        rebuild_cfb(cfb);
        switch(_opts.fileType){
            case "zip":
                return write_zip(cfb, _opts);
        }
        var L = function(cfb /*:CFBContainer*/ ) /*:Array<number>*/ {
            var mini_size = 0, fat_size = 0;
            for(var i = 0; i < cfb.FileIndex.length; ++i){
                var file = cfb.FileIndex[i];
                if (!file.content) continue;
                /*:: if(file.content == null) throw new Error("unreachable"); */ var flen = file.content.length;
                if (flen > 0) {
                    if (flen < 0x1000) mini_size += flen + 0x3F >> 6;
                    else fat_size += flen + 0x01FF >> 9;
                }
            }
            var dir_cnt = cfb.FullPaths.length + 3 >> 2;
            var mini_cnt = mini_size + 7 >> 3;
            var mfat_cnt = mini_size + 0x7F >> 7;
            var fat_base = mini_cnt + fat_size + dir_cnt + mfat_cnt;
            var fat_cnt = fat_base + 0x7F >> 7;
            var difat_cnt = fat_cnt <= 109 ? 0 : Math.ceil((fat_cnt - 109) / 0x7F);
            while(fat_base + fat_cnt + difat_cnt + 0x7F >> 7 > fat_cnt)difat_cnt = ++fat_cnt <= 109 ? 0 : Math.ceil((fat_cnt - 109) / 0x7F);
            var L = [
                1,
                difat_cnt,
                fat_cnt,
                mfat_cnt,
                dir_cnt,
                fat_size,
                mini_size,
                0
            ];
            cfb.FileIndex[0].size = mini_size << 6;
            L[7] = (cfb.FileIndex[0].start = L[0] + L[1] + L[2] + L[3] + L[4] + L[5]) + (L[6] + 7 >> 3);
            return L;
        }(cfb);
        var o = new_buf(L[7] << 9);
        var i = 0, T = 0;
        for(i = 0; i < 8; ++i)o.write_shift(1, HEADER_SIG[i]);
        for(i = 0; i < 8; ++i)o.write_shift(2, 0);
        o.write_shift(2, 0x003E);
        o.write_shift(2, 0x0003);
        o.write_shift(2, 0xFFFE);
        o.write_shift(2, 0x0009);
        o.write_shift(2, 0x0006);
        for(i = 0; i < 3; ++i)o.write_shift(2, 0);
        o.write_shift(4, 0);
        o.write_shift(4, L[2]);
        o.write_shift(4, L[0] + L[1] + L[2] + L[3] - 1);
        o.write_shift(4, 0);
        o.write_shift(4, 4096);
        o.write_shift(4, L[3] ? L[0] + L[1] + L[2] - 1 : ENDOFCHAIN);
        o.write_shift(4, L[3]);
        o.write_shift(-4, L[1] ? L[0] - 1 : ENDOFCHAIN);
        o.write_shift(4, L[1]);
        for(i = 0; i < 109; ++i)o.write_shift(-4, i < L[2] ? L[1] + i : -1);
        if (L[1]) for(T = 0; T < L[1]; ++T){
            for(; i < 236 + T * 127; ++i)o.write_shift(-4, i < L[2] ? L[1] + i : -1);
            o.write_shift(-4, T === L[1] - 1 ? ENDOFCHAIN : T + 1);
        }
        var chainit = function(w /*:number*/ ) /*:void*/ {
            for(T += w; i < T - 1; ++i)o.write_shift(-4, i + 1);
            if (w) {
                ++i;
                o.write_shift(-4, ENDOFCHAIN);
            }
        };
        T = i = 0;
        for(T += L[1]; i < T; ++i)o.write_shift(-4, consts.DIFSECT);
        for(T += L[2]; i < T; ++i)o.write_shift(-4, consts.FATSECT);
        chainit(L[3]);
        chainit(L[4]);
        var j /*:number*/  = 0, flen /*:number*/  = 0;
        var file /*:CFBEntry*/  = cfb.FileIndex[0];
        for(; j < cfb.FileIndex.length; ++j){
            file = cfb.FileIndex[j];
            if (!file.content) continue;
            /*:: if(file.content == null) throw new Error("unreachable"); */ flen = file.content.length;
            if (flen < 0x1000) continue;
            file.start = T;
            chainit(flen + 0x01FF >> 9);
        }
        chainit(L[6] + 7 >> 3);
        while(o.l & 0x1FF)o.write_shift(-4, consts.ENDOFCHAIN);
        T = i = 0;
        for(j = 0; j < cfb.FileIndex.length; ++j){
            file = cfb.FileIndex[j];
            if (!file.content) continue;
            /*:: if(file.content == null) throw new Error("unreachable"); */ flen = file.content.length;
            if (!flen || flen >= 0x1000) continue;
            file.start = T;
            chainit(flen + 0x3F >> 6);
        }
        while(o.l & 0x1FF)o.write_shift(-4, consts.ENDOFCHAIN);
        for(i = 0; i < L[4] << 2; ++i){
            var nm = cfb.FullPaths[i];
            if (!nm || nm.length === 0) {
                for(j = 0; j < 17; ++j)o.write_shift(4, 0);
                for(j = 0; j < 3; ++j)o.write_shift(4, -1);
                for(j = 0; j < 12; ++j)o.write_shift(4, 0);
                continue;
            }
            file = cfb.FileIndex[i];
            if (i === 0) file.start = file.size ? file.start - 1 : ENDOFCHAIN;
            var _nm /*:string*/  = i === 0 && _opts.root || file.name;
            flen = 2 * (_nm.length + 1);
            o.write_shift(64, _nm, "utf16le");
            o.write_shift(2, flen);
            o.write_shift(1, file.type);
            o.write_shift(1, file.color);
            o.write_shift(-4, file.L);
            o.write_shift(-4, file.R);
            o.write_shift(-4, file.C);
            if (!file.clsid) for(j = 0; j < 4; ++j)o.write_shift(4, 0);
            else o.write_shift(16, file.clsid, "hex");
            o.write_shift(4, file.state || 0);
            o.write_shift(4, 0);
            o.write_shift(4, 0);
            o.write_shift(4, 0);
            o.write_shift(4, 0);
            o.write_shift(4, file.start);
            o.write_shift(4, file.size);
            o.write_shift(4, 0);
        }
        for(i = 1; i < cfb.FileIndex.length; ++i){
            file = cfb.FileIndex[i];
            /*:: if(!file.content) throw new Error("unreachable"); */ if (file.size >= 0x1000) {
                o.l = file.start + 1 << 9;
                if (has_buf && Buffer.isBuffer(file.content)) {
                    file.content.copy(o, o.l, 0, file.size);
                    // o is a 0-filled Buffer so just set next offset
                    o.l += file.size + 511 & -512;
                } else {
                    for(j = 0; j < file.size; ++j)o.write_shift(1, file.content[j]);
                    for(; j & 0x1FF; ++j)o.write_shift(1, 0);
                }
            }
        }
        for(i = 1; i < cfb.FileIndex.length; ++i){
            file = cfb.FileIndex[i];
            /*:: if(!file.content) throw new Error("unreachable"); */ if (file.size > 0 && file.size < 0x1000) {
                if (has_buf && Buffer.isBuffer(file.content)) {
                    file.content.copy(o, o.l, 0, file.size);
                    // o is a 0-filled Buffer so just set next offset
                    o.l += file.size + 63 & -64;
                } else {
                    for(j = 0; j < file.size; ++j)o.write_shift(1, file.content[j]);
                    for(; j & 0x3F; ++j)o.write_shift(1, 0);
                }
            }
        }
        if (has_buf) o.l = o.length;
        else // When using Buffer, already 0-filled
        while(o.l < o.length)o.write_shift(1, 0);
        return o;
    }
    /* [MS-CFB] 2.6.4 (Unicode 3.0.1 case conversion) */ function find(cfb /*:CFBContainer*/ , path /*:string*/ ) /*:?CFBEntry*/ {
        var UCFullPaths /*:Array<string>*/  = cfb.FullPaths.map(function(x) {
            return x.toUpperCase();
        });
        var UCPaths /*:Array<string>*/  = UCFullPaths.map(function(x) {
            var y = x.split("/");
            return y[y.length - (x.slice(-1) == "/" ? 2 : 1)];
        });
        var k /*:boolean*/  = false;
        if (path.charCodeAt(0) === 47 /* "/" */ ) {
            k = true;
            path = UCFullPaths[0].slice(0, -1) + path;
        } else k = path.indexOf("/") !== -1;
        var UCPath /*:string*/  = path.toUpperCase();
        var w /*:number*/  = k === true ? UCFullPaths.indexOf(UCPath) : UCPaths.indexOf(UCPath);
        if (w !== -1) return cfb.FileIndex[w];
        var m = !UCPath.match(chr1);
        UCPath = UCPath.replace(chr0, "");
        if (m) UCPath = UCPath.replace(chr1, "!");
        for(w = 0; w < UCFullPaths.length; ++w){
            if ((m ? UCFullPaths[w].replace(chr1, "!") : UCFullPaths[w]).replace(chr0, "") == UCPath) return cfb.FileIndex[w];
            if ((m ? UCPaths[w].replace(chr1, "!") : UCPaths[w]).replace(chr0, "") == UCPath) return cfb.FileIndex[w];
        }
        return null;
    }
    /** CFB Constants */ var MSSZ = 64; /* Mini Sector Size = 1<<6 */ 
    //var MSCSZ = 4096; /* Mini Stream Cutoff Size */
    /* 2.1 Compound File Sector Numbers and Types */ var ENDOFCHAIN = -2;
    /* 2.2 Compound File Header */ var HEADER_SIGNATURE = "d0cf11e0a1b11ae1";
    var HEADER_SIG = [
        0xD0,
        0xCF,
        0x11,
        0xE0,
        0xA1,
        0xB1,
        0x1A,
        0xE1
    ];
    var HEADER_CLSID = "00000000000000000000000000000000";
    var consts = {
        /* 2.1 Compund File Sector Numbers and Types */ MAXREGSECT: -6,
        DIFSECT: -4,
        FATSECT: -3,
        ENDOFCHAIN: ENDOFCHAIN,
        FREESECT: -1,
        /* 2.2 Compound File Header */ HEADER_SIGNATURE: HEADER_SIGNATURE,
        HEADER_MINOR_VERSION: "3e00",
        MAXREGSID: -6,
        NOSTREAM: -1,
        HEADER_CLSID: HEADER_CLSID,
        /* 2.6.1 Compound File Directory Entry */ EntryTypes: [
            "unknown",
            "storage",
            "stream",
            "lockbytes",
            "property",
            "root"
        ]
    };
    function write_file(cfb /*:CFBContainer*/ , filename /*:string*/ , options /*:CFBWriteOpts*/ ) /*:void*/ {
        get_fs();
        var o = _write(cfb, options);
        /*:: if(typeof Buffer == 'undefined' || !Buffer.isBuffer(o) || !(o instanceof Buffer)) throw new Error("unreachable"); */ fs.writeFileSync(filename, o);
    }
    function a2s(o /*:RawBytes*/ ) /*:string*/ {
        var out = new Array(o.length);
        for(var i = 0; i < o.length; ++i)out[i] = String.fromCharCode(o[i]);
        return out.join("");
    }
    function write(cfb /*:CFBContainer*/ , options /*:CFBWriteOpts*/ ) /*:RawBytes|string*/ {
        var o = _write(cfb, options);
        switch(options && options.type || "buffer"){
            case "file":
                get_fs();
                fs.writeFileSync(options.filename, o /*:any*/ );
                return o;
            case "binary":
                return typeof o == "string" ? o : a2s(o);
            case "base64":
                return Base64_encode(typeof o == "string" ? o : a2s(o));
            case "buffer":
                if (has_buf) return Buffer.isBuffer(o) ? o : Buffer_from(o);
            /* falls through */ case "array":
                return typeof o == "string" ? s2a(o) : o;
        }
        return o;
    }
    /* node < 8.1 zlib does not expose bytesRead, so default to pure JS */ var _zlib;
    function use_zlib(zlib) {
        try {
            var InflateRaw = zlib.InflateRaw;
            var InflRaw = new InflateRaw();
            InflRaw._processChunk(new Uint8Array([
                3,
                0
            ]), InflRaw._finishFlushFlag);
            if (InflRaw.bytesRead) _zlib = zlib;
            else throw new Error("zlib does not expose bytesRead");
        } catch (e) {
            console.error("cannot use native zlib: " + (e.message || e));
        }
    }
    function _inflateRawSync(payload, usz) {
        if (!_zlib) return _inflate(payload, usz);
        var InflateRaw = _zlib.InflateRaw;
        var InflRaw = new InflateRaw();
        var out = InflRaw._processChunk(payload.slice(payload.l), InflRaw._finishFlushFlag);
        payload.l += InflRaw.bytesRead;
        return out;
    }
    function _deflateRawSync(payload) {
        return _zlib ? _zlib.deflateRawSync(payload) : _deflate(payload);
    }
    var CLEN_ORDER = [
        16,
        17,
        18,
        0,
        8,
        7,
        9,
        6,
        10,
        5,
        11,
        4,
        12,
        3,
        13,
        2,
        14,
        1,
        15
    ];
    /*  LEN_ID = [ 257, 258, 259, 260, 261, 262, 263, 264, 265, 266, 267, 268, 269, 270, 271, 272, 273, 274, 275, 276, 277, 278, 279, 280, 281, 282, 283, 284, 285 ]; */ var LEN_LN = [
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        10,
        11,
        13,
        15,
        17,
        19,
        23,
        27,
        31,
        35,
        43,
        51,
        59,
        67,
        83,
        99,
        115,
        131,
        163,
        195,
        227,
        258
    ];
    /*  DST_ID = [  0,  1,  2,  3,  4,  5,  6,  7,  8,  9, 10, 11, 12, 13,  14,  15,  16,  17,  18,  19,   20,   21,   22,   23,   24,   25,   26,    27,    28,    29 ]; */ var DST_LN = [
        1,
        2,
        3,
        4,
        5,
        7,
        9,
        13,
        17,
        25,
        33,
        49,
        65,
        97,
        129,
        193,
        257,
        385,
        513,
        769,
        1025,
        1537,
        2049,
        3073,
        4097,
        6145,
        8193,
        12289,
        16385,
        24577
    ];
    function bit_swap_8(n) {
        var t = (n << 1 | n << 11) & 0x22110 | (n << 5 | n << 15) & 0x88440;
        return (t >> 16 | t >> 8 | t) & 0xFF;
    }
    var use_typed_arrays = typeof Uint8Array !== "undefined";
    var bitswap8 = use_typed_arrays ? new Uint8Array(256) : [];
    for(var q = 0; q < 256; ++q)bitswap8[q] = bit_swap_8(q);
    function bit_swap_n(n, b) {
        var rev = bitswap8[n & 0xFF];
        if (b <= 8) return rev >>> 8 - b;
        rev = rev << 8 | bitswap8[n >> 8 & 0xFF];
        if (b <= 16) return rev >>> 16 - b;
        rev = rev << 8 | bitswap8[n >> 16 & 0xFF];
        return rev >>> 24 - b;
    }
    /* helpers for unaligned bit reads */ function read_bits_2(buf, bl) {
        var w = bl & 7, h = bl >>> 3;
        return (buf[h] | (w <= 6 ? 0 : buf[h + 1] << 8)) >>> w & 0x03;
    }
    function read_bits_3(buf, bl) {
        var w = bl & 7, h = bl >>> 3;
        return (buf[h] | (w <= 5 ? 0 : buf[h + 1] << 8)) >>> w & 0x07;
    }
    function read_bits_4(buf, bl) {
        var w = bl & 7, h = bl >>> 3;
        return (buf[h] | (w <= 4 ? 0 : buf[h + 1] << 8)) >>> w & 0x0F;
    }
    function read_bits_5(buf, bl) {
        var w = bl & 7, h = bl >>> 3;
        return (buf[h] | (w <= 3 ? 0 : buf[h + 1] << 8)) >>> w & 0x1F;
    }
    function read_bits_7(buf, bl) {
        var w = bl & 7, h = bl >>> 3;
        return (buf[h] | (w <= 1 ? 0 : buf[h + 1] << 8)) >>> w & 0x7F;
    }
    /* works up to n = 3 * 8 + 1 = 25 */ function read_bits_n(buf, bl, n) {
        var w = bl & 7, h = bl >>> 3, f = (1 << n) - 1;
        var v = buf[h] >>> w;
        if (n < 8 - w) return v & f;
        v |= buf[h + 1] << 8 - w;
        if (n < 16 - w) return v & f;
        v |= buf[h + 2] << 16 - w;
        if (n < 24 - w) return v & f;
        v |= buf[h + 3] << 24 - w;
        return v & f;
    }
    /* helpers for unaligned bit writes */ function write_bits_3(buf, bl, v) {
        var w = bl & 7, h = bl >>> 3;
        if (w <= 5) buf[h] |= (v & 7) << w;
        else {
            buf[h] |= v << w & 0xFF;
            buf[h + 1] = (v & 7) >> 8 - w;
        }
        return bl + 3;
    }
    function write_bits_1(buf, bl, v) {
        var w = bl & 7, h = bl >>> 3;
        v = (v & 1) << w;
        buf[h] |= v;
        return bl + 1;
    }
    function write_bits_8(buf, bl, v) {
        var w = bl & 7, h = bl >>> 3;
        v <<= w;
        buf[h] |= v & 0xFF;
        v >>>= 8;
        buf[h + 1] = v;
        return bl + 8;
    }
    function write_bits_16(buf, bl, v) {
        var w = bl & 7, h = bl >>> 3;
        v <<= w;
        buf[h] |= v & 0xFF;
        v >>>= 8;
        buf[h + 1] = v & 0xFF;
        buf[h + 2] = v >>> 8;
        return bl + 16;
    }
    /* until ArrayBuffer#realloc is a thing, fake a realloc */ function realloc(b, sz /*:number*/ ) {
        var L = b.length, M = 2 * L > sz ? 2 * L : sz + 5, i = 0;
        if (L >= sz) return b;
        if (has_buf) {
            var o = new_unsafe_buf(M);
            // $FlowIgnore
            if (b.copy) b.copy(o);
            else for(; i < b.length; ++i)o[i] = b[i];
            return o;
        } else if (use_typed_arrays) {
            var a = new Uint8Array(M);
            if (a.set) a.set(b);
            else for(; i < L; ++i)a[i] = b[i];
            return a;
        }
        b.length = M;
        return b;
    }
    /* zero-filled arrays for older browsers */ function zero_fill_array(n) {
        var o = new Array(n);
        for(var i = 0; i < n; ++i)o[i] = 0;
        return o;
    }
    /* build tree (used for literals and lengths) */ function build_tree(clens, cmap, MAX /*:number*/ ) /*:number*/ {
        var maxlen = 1, w = 0, i = 0, j = 0, ccode = 0, L = clens.length;
        var bl_count = use_typed_arrays ? new Uint16Array(32) : zero_fill_array(32);
        for(i = 0; i < 32; ++i)bl_count[i] = 0;
        for(i = L; i < MAX; ++i)clens[i] = 0;
        L = clens.length;
        var ctree = use_typed_arrays ? new Uint16Array(L) : zero_fill_array(L); // []
        /* build code tree */ for(i = 0; i < L; ++i){
            bl_count[w = clens[i]]++;
            if (maxlen < w) maxlen = w;
            ctree[i] = 0;
        }
        bl_count[0] = 0;
        for(i = 1; i <= maxlen; ++i)bl_count[i + 16] = ccode = ccode + bl_count[i - 1] << 1;
        for(i = 0; i < L; ++i){
            ccode = clens[i];
            if (ccode != 0) ctree[i] = bl_count[ccode + 16]++;
        }
        /* cmap[maxlen + 4 bits] = (off&15) + (lit<<4) reverse mapping */ var cleni = 0;
        for(i = 0; i < L; ++i){
            cleni = clens[i];
            if (cleni != 0) {
                ccode = bit_swap_n(ctree[i], maxlen) >> maxlen - cleni;
                for(j = (1 << maxlen + 4 - cleni) - 1; j >= 0; --j)cmap[ccode | j << cleni] = cleni & 15 | i << 4;
            }
        }
        return maxlen;
    }
    /* Fixed Huffman */ var fix_lmap = use_typed_arrays ? new Uint16Array(512) : zero_fill_array(512);
    var fix_dmap = use_typed_arrays ? new Uint16Array(32) : zero_fill_array(32);
    if (!use_typed_arrays) {
        for(var i = 0; i < 512; ++i)fix_lmap[i] = 0;
        for(i = 0; i < 32; ++i)fix_dmap[i] = 0;
    }
    (function() {
        var dlens /*:Array<number>*/  = [];
        var i = 0;
        for(; i < 32; i++)dlens.push(5);
        build_tree(dlens, fix_dmap, 32);
        var clens /*:Array<number>*/  = [];
        i = 0;
        for(; i <= 143; i++)clens.push(8);
        for(; i <= 255; i++)clens.push(9);
        for(; i <= 279; i++)clens.push(7);
        for(; i <= 287; i++)clens.push(8);
        build_tree(clens, fix_lmap, 288);
    })();
    var _deflateRaw = /*#__PURE__*/ function _deflateRawIIFE() {
        var DST_LN_RE = use_typed_arrays ? new Uint8Array(0x8000) : [];
        var j = 0, k = 0;
        for(; j < DST_LN.length - 1; ++j)for(; k < DST_LN[j + 1]; ++k)DST_LN_RE[k] = j;
        for(; k < 32768; ++k)DST_LN_RE[k] = 29;
        var LEN_LN_RE = use_typed_arrays ? new Uint8Array(0x103) : [];
        for(j = 0, k = 0; j < LEN_LN.length - 1; ++j)for(; k < LEN_LN[j + 1]; ++k)LEN_LN_RE[k] = j;
        function write_stored(data, out) {
            var boff = 0;
            while(boff < data.length){
                var L = Math.min(0xFFFF, data.length - boff);
                var h = boff + L == data.length;
                out.write_shift(1, +h);
                out.write_shift(2, L);
                out.write_shift(2, ~L & 0xFFFF);
                while(L-- > 0)out[out.l++] = data[boff++];
            }
            return out.l;
        }
        /* Fixed Huffman */ function write_huff_fixed(data, out) {
            var bl = 0;
            var boff = 0;
            var addrs = use_typed_arrays ? new Uint16Array(0x8000) : [];
            while(boff < data.length){
                var L = /* data.length - boff; */ Math.min(0xFFFF, data.length - boff);
                /* write a stored block for short data */ if (L < 10) {
                    bl = write_bits_3(out, bl, +!!(boff + L == data.length)); // jshint ignore:line
                    if (bl & 7) bl += 8 - (bl & 7);
                    out.l = bl / 8 | 0;
                    out.write_shift(2, L);
                    out.write_shift(2, ~L & 0xFFFF);
                    while(L-- > 0)out[out.l++] = data[boff++];
                    bl = out.l * 8;
                    continue;
                }
                bl = write_bits_3(out, bl, +!!(boff + L == data.length) + 2); // jshint ignore:line
                var hash = 0;
                while(L-- > 0){
                    var d = data[boff];
                    hash = (hash << 5 ^ d) & 0x7FFF;
                    var match = -1, mlen = 0;
                    if (match = addrs[hash]) {
                        match |= boff & -32768;
                        if (match > boff) match -= 0x8000;
                        if (match < boff) while(data[match + mlen] == data[boff + mlen] && mlen < 250)++mlen;
                    }
                    if (mlen > 2) {
                        /* Copy Token  */ d = LEN_LN_RE[mlen];
                        if (d <= 22) bl = write_bits_8(out, bl, bitswap8[d + 1] >> 1) - 1;
                        else {
                            write_bits_8(out, bl, 3);
                            bl += 5;
                            write_bits_8(out, bl, bitswap8[d - 23] >> 5);
                            bl += 3;
                        }
                        var len_eb = d < 8 ? 0 : d - 4 >> 2;
                        if (len_eb > 0) {
                            write_bits_16(out, bl, mlen - LEN_LN[d]);
                            bl += len_eb;
                        }
                        d = DST_LN_RE[boff - match];
                        bl = write_bits_8(out, bl, bitswap8[d] >> 3);
                        bl -= 3;
                        var dst_eb = d < 4 ? 0 : d - 2 >> 1;
                        if (dst_eb > 0) {
                            write_bits_16(out, bl, boff - match - DST_LN[d]);
                            bl += dst_eb;
                        }
                        for(var q = 0; q < mlen; ++q){
                            addrs[hash] = boff & 0x7FFF;
                            hash = (hash << 5 ^ data[boff]) & 0x7FFF;
                            ++boff;
                        }
                        L -= mlen - 1;
                    } else {
                        /* Literal Token */ if (d <= 143) d = d + 48;
                        else bl = write_bits_1(out, bl, 1);
                        bl = write_bits_8(out, bl, bitswap8[d]);
                        addrs[hash] = boff & 0x7FFF;
                        ++boff;
                    }
                }
                bl = write_bits_8(out, bl, 0) - 1;
            }
            out.l = (bl + 7) / 8 | 0;
            return out.l;
        }
        return function _deflateRaw(data, out) {
            if (data.length < 8) return write_stored(data, out);
            return write_huff_fixed(data, out);
        };
    }();
    function _deflate(data) {
        var buf = new_buf(50 + Math.floor(data.length * 1.1));
        var off = _deflateRaw(data, buf);
        return buf.slice(0, off);
    }
    /* modified inflate function also moves original read head */ var dyn_lmap = use_typed_arrays ? new Uint16Array(32768) : zero_fill_array(32768);
    var dyn_dmap = use_typed_arrays ? new Uint16Array(32768) : zero_fill_array(32768);
    var dyn_cmap = use_typed_arrays ? new Uint16Array(128) : zero_fill_array(128);
    var dyn_len_1 = 1, dyn_len_2 = 1;
    /* 5.5.3 Expanding Huffman Codes */ function dyn(data, boff /*:number*/ ) {
        /* nomenclature from RFC1951 refers to bit values; these are offset by the implicit constant */ var _HLIT = read_bits_5(data, boff) + 257;
        boff += 5;
        var _HDIST = read_bits_5(data, boff) + 1;
        boff += 5;
        var _HCLEN = read_bits_4(data, boff) + 4;
        boff += 4;
        var w = 0;
        /* grab and store code lengths */ var clens = use_typed_arrays ? new Uint8Array(19) : zero_fill_array(19);
        var ctree = [
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ];
        var maxlen = 1;
        var bl_count = use_typed_arrays ? new Uint8Array(8) : zero_fill_array(8);
        var next_code = use_typed_arrays ? new Uint8Array(8) : zero_fill_array(8);
        var L = clens.length; /* 19 */ 
        for(var i = 0; i < _HCLEN; ++i){
            clens[CLEN_ORDER[i]] = w = read_bits_3(data, boff);
            if (maxlen < w) maxlen = w;
            bl_count[w]++;
            boff += 3;
        }
        /* build code tree */ var ccode = 0;
        bl_count[0] = 0;
        for(i = 1; i <= maxlen; ++i)next_code[i] = ccode = ccode + bl_count[i - 1] << 1;
        for(i = 0; i < L; ++i)if ((ccode = clens[i]) != 0) ctree[i] = next_code[ccode]++;
        /* cmap[7 bits from stream] = (off&7) + (lit<<3) */ var cleni = 0;
        for(i = 0; i < L; ++i){
            cleni = clens[i];
            if (cleni != 0) {
                ccode = bitswap8[ctree[i]] >> 8 - cleni;
                for(var j = (1 << 7 - cleni) - 1; j >= 0; --j)dyn_cmap[ccode | j << cleni] = cleni & 7 | i << 3;
            }
        }
        /* read literal and dist codes at once */ var hcodes /*:Array<number>*/  = [];
        maxlen = 1;
        for(; hcodes.length < _HLIT + _HDIST;){
            ccode = dyn_cmap[read_bits_7(data, boff)];
            boff += ccode & 7;
            switch(ccode >>>= 3){
                case 16:
                    w = 3 + read_bits_2(data, boff);
                    boff += 2;
                    ccode = hcodes[hcodes.length - 1];
                    while(w-- > 0)hcodes.push(ccode);
                    break;
                case 17:
                    w = 3 + read_bits_3(data, boff);
                    boff += 3;
                    while(w-- > 0)hcodes.push(0);
                    break;
                case 18:
                    w = 11 + read_bits_7(data, boff);
                    boff += 7;
                    while(w-- > 0)hcodes.push(0);
                    break;
                default:
                    hcodes.push(ccode);
                    if (maxlen < ccode) maxlen = ccode;
                    break;
            }
        }
        /* build literal / length trees */ var h1 = hcodes.slice(0, _HLIT), h2 = hcodes.slice(_HLIT);
        for(i = _HLIT; i < 286; ++i)h1[i] = 0;
        for(i = _HDIST; i < 30; ++i)h2[i] = 0;
        dyn_len_1 = build_tree(h1, dyn_lmap, 286);
        dyn_len_2 = build_tree(h2, dyn_dmap, 30);
        return boff;
    }
    /* return [ data, bytesRead ] */ function inflate(data, usz /*:number*/ ) {
        /* shortcircuit for empty buffer [0x03, 0x00] */ if (data[0] == 3 && !(data[1] & 0x3)) return [
            new_raw_buf(usz),
            2
        ];
        /* bit offset */ var boff = 0;
        /* header includes final bit and type bits */ var header = 0;
        var outbuf = new_unsafe_buf(usz ? usz : 262144);
        var woff = 0;
        var OL = outbuf.length >>> 0;
        var max_len_1 = 0, max_len_2 = 0;
        while((header & 1) == 0){
            header = read_bits_3(data, boff);
            boff += 3;
            if (header >>> 1 == 0) {
                /* Stored block */ if (boff & 7) boff += 8 - (boff & 7);
                /* 2 bytes sz, 2 bytes bit inverse */ var sz = data[boff >>> 3] | data[(boff >>> 3) + 1] << 8;
                boff += 32;
                /* push sz bytes */ if (sz > 0) {
                    if (!usz && OL < woff + sz) {
                        outbuf = realloc(outbuf, woff + sz);
                        OL = outbuf.length;
                    }
                    while(sz-- > 0){
                        outbuf[woff++] = data[boff >>> 3];
                        boff += 8;
                    }
                }
                continue;
            } else if (header >> 1 == 1) {
                /* Fixed Huffman */ max_len_1 = 9;
                max_len_2 = 5;
            } else {
                /* Dynamic Huffman */ boff = dyn(data, boff);
                max_len_1 = dyn_len_1;
                max_len_2 = dyn_len_2;
            }
            for(;;){
                if (!usz && OL < woff + 32767) {
                    outbuf = realloc(outbuf, woff + 32767);
                    OL = outbuf.length;
                }
                /* ingest code and move read head */ var bits = read_bits_n(data, boff, max_len_1);
                var code = header >>> 1 == 1 ? fix_lmap[bits] : dyn_lmap[bits];
                boff += code & 15;
                code >>>= 4;
                /* 0-255 are literals, 256 is end of block token, 257+ are copy tokens */ if ((code >>> 8 & 0xFF) === 0) outbuf[woff++] = code;
                else if (code == 256) break;
                else {
                    code -= 257;
                    var len_eb = code < 8 ? 0 : code - 4 >> 2;
                    if (len_eb > 5) len_eb = 0;
                    var tgt = woff + LEN_LN[code];
                    /* length extra bits */ if (len_eb > 0) {
                        tgt += read_bits_n(data, boff, len_eb);
                        boff += len_eb;
                    }
                    /* dist code */ bits = read_bits_n(data, boff, max_len_2);
                    code = header >>> 1 == 1 ? fix_dmap[bits] : dyn_dmap[bits];
                    boff += code & 15;
                    code >>>= 4;
                    var dst_eb = code < 4 ? 0 : code - 2 >> 1;
                    var dst = DST_LN[code];
                    /* dist extra bits */ if (dst_eb > 0) {
                        dst += read_bits_n(data, boff, dst_eb);
                        boff += dst_eb;
                    }
                    /* in the common case, manual byte copy is faster than TA set / Buffer copy */ if (!usz && OL < tgt) {
                        outbuf = realloc(outbuf, tgt + 100);
                        OL = outbuf.length;
                    }
                    while(woff < tgt){
                        outbuf[woff] = outbuf[woff - dst];
                        ++woff;
                    }
                }
            }
        }
        if (usz) return [
            outbuf,
            boff + 7 >>> 3
        ];
        return [
            outbuf.slice(0, woff),
            boff + 7 >>> 3
        ];
    }
    function _inflate(payload, usz) {
        var data = payload.slice(payload.l || 0);
        var out = inflate(data, usz);
        payload.l += out[1];
        return out[0];
    }
    function warn_or_throw(wrn, msg) {
        if (wrn) {
            if (typeof console !== "undefined") console.error(msg);
        } else throw new Error(msg);
    }
    function parse_zip(file /*:RawBytes*/ , options /*:CFBReadOpts*/ ) /*:CFBContainer*/ {
        var blob /*:CFBlob*/  = /*::(*/ file /*:: :any)*/ ;
        prep_blob(blob, 0);
        var FileIndex /*:CFBFileIndex*/  = [], FullPaths /*:Array<string>*/  = [];
        var o = {
            FileIndex: FileIndex,
            FullPaths: FullPaths
        };
        init_cfb(o, {
            root: options.root
        });
        /* find end of central directory, start just after signature */ var i = blob.length - 4;
        while((blob[i] != 0x50 || blob[i + 1] != 0x4b || blob[i + 2] != 0x05 || blob[i + 3] != 0x06) && i >= 0)--i;
        blob.l = i + 4;
        /* parse end of central directory */ blob.l += 4;
        var fcnt = blob.read_shift(2);
        blob.l += 6;
        var start_cd = blob.read_shift(4);
        /* parse central directory */ blob.l = start_cd;
        for(i = 0; i < fcnt; ++i){
            /* trust local file header instead of CD entry */ blob.l += 20;
            var csz = blob.read_shift(4);
            var usz = blob.read_shift(4);
            var namelen = blob.read_shift(2);
            var efsz = blob.read_shift(2);
            var fcsz = blob.read_shift(2);
            blob.l += 8;
            var offset = blob.read_shift(4);
            var EF = parse_extra_field(/*::(*/ blob.slice(blob.l + namelen, blob.l + namelen + efsz));
            blob.l += namelen + efsz + fcsz;
            var L = blob.l;
            blob.l = offset + 4;
            parse_local_file(blob, csz, usz, o, EF);
            blob.l = L;
        }
        return o;
    }
    /* head starts just after local file header signature */ function parse_local_file(blob /*:CFBlob*/ , csz /*:number*/ , usz /*:number*/ , o /*:CFBContainer*/ , EF) {
        /* [local file header] */ blob.l += 2;
        var flags = blob.read_shift(2);
        var meth = blob.read_shift(2);
        var date = parse_dos_date(blob);
        if (flags & 0x2041) throw new Error("Unsupported ZIP encryption");
        var crc32 = blob.read_shift(4);
        var _csz = blob.read_shift(4);
        var _usz = blob.read_shift(4);
        var namelen = blob.read_shift(2);
        var efsz = blob.read_shift(2);
        // TODO: flags & (1<<11) // UTF8
        var name = "";
        for(var i = 0; i < namelen; ++i)name += String.fromCharCode(blob[blob.l++]);
        if (efsz) {
            var ef = parse_extra_field(/*::(*/ blob.slice(blob.l, blob.l + efsz));
            if ((ef[0x5455] || {}).mt) date = ef[0x5455].mt;
            if (((EF || {})[0x5455] || {}).mt) date = EF[0x5455].mt;
        }
        blob.l += efsz;
        /* [encryption header] */ /* [file data] */ var data = blob.slice(blob.l, blob.l + _csz);
        switch(meth){
            case 8:
                data = _inflateRawSync(blob, _usz);
                break;
            case 0:
                break; // TODO: scan for magic number
            default:
                throw new Error("Unsupported ZIP Compression method " + meth);
        }
        /* [data descriptor] */ var wrn = false;
        if (flags & 8) {
            crc32 = blob.read_shift(4);
            if (crc32 == 0x08074b50) {
                crc32 = blob.read_shift(4);
                wrn = true;
            }
            _csz = blob.read_shift(4);
            _usz = blob.read_shift(4);
        }
        if (_csz != csz) warn_or_throw(wrn, "Bad compressed size: " + csz + " != " + _csz);
        if (_usz != usz) warn_or_throw(wrn, "Bad uncompressed size: " + usz + " != " + _usz);
        //var _crc32 = CRC32.buf(data, 0);
        //if((crc32>>0) != (_crc32>>0)) warn_or_throw(wrn, "Bad CRC32 checksum: " + crc32 + " != " + _crc32);
        cfb_add(o, name, data, {
            unsafe: true,
            mt: date
        });
    }
    function write_zip(cfb /*:CFBContainer*/ , options /*:CFBWriteOpts*/ ) /*:RawBytes*/ {
        var _opts = options || {};
        var out = [], cdirs = [];
        var o /*:CFBlob*/  = new_buf(1);
        var method = _opts.compression ? 8 : 0, flags = 0;
        var desc = false;
        if (desc) flags |= 8;
        var i = 0, j = 0;
        var start_cd = 0, fcnt = 0;
        var root = cfb.FullPaths[0], fp = root, fi = cfb.FileIndex[0];
        var crcs = [];
        var sz_cd = 0;
        for(i = 1; i < cfb.FullPaths.length; ++i){
            fp = cfb.FullPaths[i].slice(root.length);
            fi = cfb.FileIndex[i];
            if (!fi.size || !fi.content || fp == "\x01Sh33tJ5") continue;
            var start = start_cd;
            /* TODO: CP437 filename */ var namebuf = new_buf(fp.length);
            for(j = 0; j < fp.length; ++j)namebuf.write_shift(1, fp.charCodeAt(j) & 0x7F);
            namebuf = namebuf.slice(0, namebuf.l);
            crcs[fcnt] = CRC32.buf(/*::((*/ fi.content /*::||[]):any)*/ , 0);
            var outbuf = fi.content /*::||[]*/ ;
            if (method == 8) outbuf = _deflateRawSync(outbuf);
            /* local file header */ o = new_buf(30);
            o.write_shift(4, 0x04034b50);
            o.write_shift(2, 20);
            o.write_shift(2, flags);
            o.write_shift(2, method);
            /* TODO: last mod file time/date */ if (fi.mt) write_dos_date(o, fi.mt);
            else o.write_shift(4, 0);
            o.write_shift(-4, flags & 8 ? 0 : crcs[fcnt]);
            o.write_shift(4, flags & 8 ? 0 : outbuf.length);
            o.write_shift(4, flags & 8 ? 0 : /*::(*/ fi.content /*::||[])*/ .length);
            o.write_shift(2, namebuf.length);
            o.write_shift(2, 0);
            start_cd += o.length;
            out.push(o);
            start_cd += namebuf.length;
            out.push(namebuf);
            /* TODO: extra fields? */ /* TODO: encryption header ? */ start_cd += outbuf.length;
            out.push(outbuf);
            /* data descriptor */ if (flags & 8) {
                o = new_buf(12);
                o.write_shift(-4, crcs[fcnt]);
                o.write_shift(4, outbuf.length);
                o.write_shift(4, /*::(*/ fi.content /*::||[])*/ .length);
                start_cd += o.l;
                out.push(o);
            }
            /* central directory */ o = new_buf(46);
            o.write_shift(4, 0x02014b50);
            o.write_shift(2, 0);
            o.write_shift(2, 20);
            o.write_shift(2, flags);
            o.write_shift(2, method);
            o.write_shift(4, 0); /* TODO: last mod file time/date */ 
            o.write_shift(-4, crcs[fcnt]);
            o.write_shift(4, outbuf.length);
            o.write_shift(4, /*::(*/ fi.content /*::||[])*/ .length);
            o.write_shift(2, namebuf.length);
            o.write_shift(2, 0);
            o.write_shift(2, 0);
            o.write_shift(2, 0);
            o.write_shift(2, 0);
            o.write_shift(4, 0);
            o.write_shift(4, start);
            sz_cd += o.l;
            cdirs.push(o);
            sz_cd += namebuf.length;
            cdirs.push(namebuf);
            ++fcnt;
        }
        /* end of central directory */ o = new_buf(22);
        o.write_shift(4, 0x06054b50);
        o.write_shift(2, 0);
        o.write_shift(2, 0);
        o.write_shift(2, fcnt);
        o.write_shift(2, fcnt);
        o.write_shift(4, sz_cd);
        o.write_shift(4, start_cd);
        o.write_shift(2, 0);
        return bconcat([
            bconcat(out /*:any*/ ),
            bconcat(cdirs),
            o
        ]);
    }
    var ContentTypeMap = {
        "htm": "text/html",
        "xml": "text/xml",
        "gif": "image/gif",
        "jpg": "image/jpeg",
        "png": "image/png",
        "mso": "application/x-mso",
        "thmx": "application/vnd.ms-officetheme",
        "sh33tj5": "application/octet-stream"
    } /*:any*/ ;
    function get_content_type(fi /*:CFBEntry*/ , fp /*:string*/ ) /*:string*/ {
        if (fi.ctype) return fi.ctype;
        var ext = fi.name || "", m = ext.match(/\.([^\.]+)$/);
        if (m && ContentTypeMap[m[1]]) return ContentTypeMap[m[1]];
        if (fp) {
            m = (ext = fp).match(/[\.\\]([^\.\\])+$/);
            if (m && ContentTypeMap[m[1]]) return ContentTypeMap[m[1]];
        }
        return "application/octet-stream";
    }
    /* 76 character chunks TODO: intertwine encoding */ function write_base64_76(bstr /*:string*/ ) /*:string*/ {
        var data = Base64_encode(bstr);
        var o = [];
        for(var i = 0; i < data.length; i += 76)o.push(data.slice(i, i + 76));
        return o.join("\r\n") + "\r\n";
    }
    /*
Rules for QP:
	- escape =## applies for all non-display characters and literal "="
	- space or tab at end of line must be encoded
	- \r\n newlines can be preserved, but bare \r and \n must be escaped
	- lines must not exceed 76 characters, use soft breaks =\r\n

TODO: Some files from word appear to write line extensions with bare equals:

```
<table class=3DMsoTableGrid border=3D1 cellspacing=3D0 cellpadding=3D0 width=
="70%"
```
*/ function write_quoted_printable(text /*:string*/ ) /*:string*/ {
        var encoded = text.replace(/[\x00-\x08\x0B\x0C\x0E-\x1F\x7E-\xFF=]/g, function(c) {
            var w = c.charCodeAt(0).toString(16).toUpperCase();
            return "=" + (w.length == 1 ? "0" + w : w);
        });
        encoded = encoded.replace(/ $/mg, "=20").replace(/\t$/mg, "=09");
        if (encoded.charAt(0) == "\n") encoded = "=0D" + encoded.slice(1);
        encoded = encoded.replace(/\r(?!\n)/mg, "=0D").replace(/\n\n/mg, "\n=0A").replace(/([^\r\n])\n/mg, "$1=0A");
        var o /*:Array<string>*/  = [], split = encoded.split("\r\n");
        for(var si = 0; si < split.length; ++si){
            var str = split[si];
            if (str.length == 0) {
                o.push("");
                continue;
            }
            for(var i = 0; i < str.length;){
                var end = 76;
                var tmp = str.slice(i, i + end);
                if (tmp.charAt(end - 1) == "=") end--;
                else if (tmp.charAt(end - 2) == "=") end -= 2;
                else if (tmp.charAt(end - 3) == "=") end -= 3;
                tmp = str.slice(i, i + end);
                i += end;
                if (i < str.length) tmp += "=";
                o.push(tmp);
            }
        }
        return o.join("\r\n");
    }
    function parse_quoted_printable(data /*:Array<string>*/ ) /*:RawBytes*/ {
        var o = [];
        /* unify long lines */ for(var di = 0; di < data.length; ++di){
            var line = data[di];
            while(di <= data.length && line.charAt(line.length - 1) == "=")line = line.slice(0, line.length - 1) + data[++di];
            o.push(line);
        }
        /* decode */ for(var oi = 0; oi < o.length; ++oi)o[oi] = o[oi].replace(/[=][0-9A-Fa-f]{2}/g, function($$) {
            return String.fromCharCode(parseInt($$.slice(1), 16));
        });
        return s2a(o.join("\r\n"));
    }
    function parse_mime(cfb /*:CFBContainer*/ , data /*:Array<string>*/ , root /*:string*/ ) /*:void*/ {
        var fname = "", cte = "", ctype = "", fdata;
        var di = 0;
        for(; di < 10; ++di){
            var line = data[di];
            if (!line || line.match(/^\s*$/)) break;
            var m = line.match(/^(.*?):\s*([^\s].*)$/);
            if (m) switch(m[1].toLowerCase()){
                case "content-location":
                    fname = m[2].trim();
                    break;
                case "content-type":
                    ctype = m[2].trim();
                    break;
                case "content-transfer-encoding":
                    cte = m[2].trim();
                    break;
            }
        }
        ++di;
        switch(cte.toLowerCase()){
            case "base64":
                fdata = s2a(Base64_decode(data.slice(di).join("")));
                break;
            case "quoted-printable":
                fdata = parse_quoted_printable(data.slice(di));
                break;
            default:
                throw new Error("Unsupported Content-Transfer-Encoding " + cte);
        }
        var file = cfb_add(cfb, fname.slice(root.length), fdata, {
            unsafe: true
        });
        if (ctype) file.ctype = ctype;
    }
    function parse_mad(file /*:RawBytes*/ , options /*:CFBReadOpts*/ ) /*:CFBContainer*/ {
        if (a2s(file.slice(0, 13)).toLowerCase() != "mime-version:") throw new Error("Unsupported MAD header");
        var root = options && options.root || "";
        // $FlowIgnore
        var data = (has_buf && Buffer.isBuffer(file) ? file.toString("binary") : a2s(file)).split("\r\n");
        var di = 0, row = "";
        /* if root is not specified, scan for the common prefix */ for(di = 0; di < data.length; ++di){
            row = data[di];
            if (!/^Content-Location:/i.test(row)) continue;
            row = row.slice(row.indexOf("file"));
            if (!root) root = row.slice(0, row.lastIndexOf("/") + 1);
            if (row.slice(0, root.length) == root) continue;
            while(root.length > 0){
                root = root.slice(0, root.length - 1);
                root = root.slice(0, root.lastIndexOf("/") + 1);
                if (row.slice(0, root.length) == root) break;
            }
        }
        var mboundary = (data[1] || "").match(/boundary="(.*?)"/);
        if (!mboundary) throw new Error("MAD cannot find boundary");
        var boundary = "--" + (mboundary[1] || "");
        var FileIndex /*:CFBFileIndex*/  = [], FullPaths /*:Array<string>*/  = [];
        var o = {
            FileIndex: FileIndex,
            FullPaths: FullPaths
        };
        init_cfb(o);
        var start_di, fcnt = 0;
        for(di = 0; di < data.length; ++di){
            var line = data[di];
            if (line !== boundary && line !== boundary + "--") continue;
            if (fcnt++) parse_mime(o, data.slice(start_di, di), root);
            start_di = di;
        }
        return o;
    }
    function write_mad(cfb /*:CFBContainer*/ , options /*:CFBWriteOpts*/ ) /*:string*/ {
        var opts = options || {};
        var boundary = opts.boundary || "SheetJS";
        boundary = "------=" + boundary;
        var out = [
            "MIME-Version: 1.0",
            'Content-Type: multipart/related; boundary="' + boundary.slice(2) + '"',
            "",
            "",
            ""
        ];
        var root = cfb.FullPaths[0], fp = root, fi = cfb.FileIndex[0];
        for(var i = 1; i < cfb.FullPaths.length; ++i){
            fp = cfb.FullPaths[i].slice(root.length);
            fi = cfb.FileIndex[i];
            if (!fi.size || !fi.content || fp == "\x01Sh33tJ5") continue;
            /* Normalize filename */ fp = fp.replace(/[\x00-\x08\x0B\x0C\x0E-\x1F\x7E-\xFF]/g, function(c) {
                return "_x" + c.charCodeAt(0).toString(16) + "_";
            }).replace(/[\u0080-\uFFFF]/g, function(u) {
                return "_u" + u.charCodeAt(0).toString(16) + "_";
            });
            /* Extract content as binary string */ var ca = fi.content;
            // $FlowIgnore
            var cstr = has_buf && Buffer.isBuffer(ca) ? ca.toString("binary") : a2s(ca);
            /* 4/5 of first 1024 chars ascii -> quoted printable, else base64 */ var dispcnt = 0, L = Math.min(1024, cstr.length), cc = 0;
            for(var csl = 0; csl <= L; ++csl)if ((cc = cstr.charCodeAt(csl)) >= 0x20 && cc < 0x80) ++dispcnt;
            var qp = dispcnt >= L * 4 / 5;
            out.push(boundary);
            out.push("Content-Location: " + (opts.root || "file:///C:/SheetJS/") + fp);
            out.push("Content-Transfer-Encoding: " + (qp ? "quoted-printable" : "base64"));
            out.push("Content-Type: " + get_content_type(fi, fp));
            out.push("");
            out.push(qp ? write_quoted_printable(cstr) : write_base64_76(cstr));
        }
        out.push(boundary + "--\r\n");
        return out.join("\r\n");
    }
    function cfb_new(opts /*:?any*/ ) /*:CFBContainer*/ {
        var o /*:CFBContainer*/  = {} /*:any*/ ;
        init_cfb(o, opts);
        return o;
    }
    function cfb_add(cfb /*:CFBContainer*/ , name /*:string*/ , content /*:?RawBytes*/ , opts /*:?any*/ ) /*:CFBEntry*/ {
        var unsafe = opts && opts.unsafe;
        if (!unsafe) init_cfb(cfb);
        var file = !unsafe && CFB.find(cfb, name);
        if (!file) {
            var fpath /*:string*/  = cfb.FullPaths[0];
            if (name.slice(0, fpath.length) == fpath) fpath = name;
            else {
                if (fpath.slice(-1) != "/") fpath += "/";
                fpath = (fpath + name).replace("//", "/");
            }
            file = {
                name: filename(name),
                type: 2
            } /*:any*/ ;
            cfb.FileIndex.push(file);
            cfb.FullPaths.push(fpath);
            if (!unsafe) CFB.utils.cfb_gc(cfb);
        }
        /*:: if(!file) throw new Error("unreachable"); */ file.content = content /*:any*/ ;
        file.size = content ? content.length : 0;
        if (opts) {
            if (opts.CLSID) file.clsid = opts.CLSID;
            if (opts.mt) file.mt = opts.mt;
            if (opts.ct) file.ct = opts.ct;
        }
        return file;
    }
    function cfb_del(cfb /*:CFBContainer*/ , name /*:string*/ ) /*:boolean*/ {
        init_cfb(cfb);
        var file = CFB.find(cfb, name);
        if (file) {
            for(var j = 0; j < cfb.FileIndex.length; ++j)if (cfb.FileIndex[j] == file) {
                cfb.FileIndex.splice(j, 1);
                cfb.FullPaths.splice(j, 1);
                return true;
            }
        }
        return false;
    }
    function cfb_mov(cfb /*:CFBContainer*/ , old_name /*:string*/ , new_name /*:string*/ ) /*:boolean*/ {
        init_cfb(cfb);
        var file = CFB.find(cfb, old_name);
        if (file) {
            for(var j = 0; j < cfb.FileIndex.length; ++j)if (cfb.FileIndex[j] == file) {
                cfb.FileIndex[j].name = filename(new_name);
                cfb.FullPaths[j] = new_name;
                return true;
            }
        }
        return false;
    }
    function cfb_gc(cfb /*:CFBContainer*/ ) /*:void*/ {
        rebuild_cfb(cfb, true);
    }
    exports.find = find;
    exports.read = read;
    exports.parse = parse;
    exports.write = write;
    exports.writeFile = write_file;
    exports.utils = {
        cfb_new: cfb_new,
        cfb_add: cfb_add,
        cfb_del: cfb_del,
        cfb_mov: cfb_mov,
        cfb_gc: cfb_gc,
        ReadShift: ReadShift,
        CheckField: CheckField,
        prep_blob: prep_blob,
        bconcat: bconcat,
        use_zlib: use_zlib,
        _deflateRaw: _deflate,
        _inflateRaw: _inflate,
        consts: consts
    };
    return exports;
}();
let _fs = void 0;
function set_fs(fs) {
    _fs = fs;
}
/* normalize data for blob ctor */ function blobify(data) {
    if (typeof data === "string") return s2ab(data);
    if (Array.isArray(data)) return a2u(data);
    return data;
}
/* write or download file */ function write_dl(fname /*:string*/ , payload /*:any*/ , enc /*:?string*/ ) {
    /*global IE_SaveFile, Blob, navigator, saveAs, document, File, chrome */ if (typeof _fs !== "undefined" && _fs.writeFileSync) return enc ? _fs.writeFileSync(fname, payload, enc) : _fs.writeFileSync(fname, payload);
    if (typeof Deno !== "undefined") {
        /* in this spot, it's safe to assume typed arrays and TextEncoder/TextDecoder exist */ if (enc && typeof payload == "string") switch(enc){
            case "utf8":
                payload = new TextEncoder(enc).encode(payload);
                break;
            case "binary":
                payload = s2ab(payload);
                break;
            /* TODO: binary equivalent */ default:
                throw new Error("Unsupported encoding " + enc);
        }
        return Deno.writeFileSync(fname, payload);
    }
    var data = enc == "utf8" ? utf8write(payload) : payload;
    /*:: declare var IE_SaveFile: any; */ if (typeof IE_SaveFile !== "undefined") return IE_SaveFile(data, fname);
    if (typeof Blob !== "undefined") {
        var blob = new Blob([
            blobify(data)
        ], {
            type: "application/octet-stream"
        });
        /*:: declare var navigator: any; */ if (typeof navigator !== "undefined" && navigator.msSaveBlob) return navigator.msSaveBlob(blob, fname);
        /*:: declare var saveAs: any; */ if (typeof saveAs !== "undefined") return saveAs(blob, fname);
        if (typeof URL !== "undefined" && typeof document !== "undefined" && document.createElement && URL.createObjectURL) {
            var url = URL.createObjectURL(blob);
            /*:: declare var chrome: any; */ if (typeof chrome === "object" && typeof (chrome.downloads || {}).download == "function") {
                if (URL.revokeObjectURL && typeof setTimeout !== "undefined") setTimeout(function() {
                    URL.revokeObjectURL(url);
                }, 60000);
                return chrome.downloads.download({
                    url: url,
                    filename: fname,
                    saveAs: true
                });
            }
            var a = document.createElement("a");
            if (a.download != null) {
                /*:: if(document.body == null) throw new Error("unreachable"); */ a.download = fname;
                a.href = url;
                document.body.appendChild(a);
                a.click();
                /*:: if(document.body == null) throw new Error("unreachable"); */ document.body.removeChild(a);
                if (URL.revokeObjectURL && typeof setTimeout !== "undefined") setTimeout(function() {
                    URL.revokeObjectURL(url);
                }, 60000);
                return url;
            }
        }
    }
    // $FlowIgnore
    if (typeof $ !== "undefined" && typeof File !== "undefined" && typeof Folder !== "undefined") try {
        // $FlowIgnore
        var out = File(fname);
        out.open("w");
        out.encoding = "binary";
        if (Array.isArray(payload)) payload = a2s(payload);
        out.write(payload);
        out.close();
        return payload;
    } catch (e) {
        if (!e.message || !e.message.match(/onstruct/)) throw e;
    }
    throw new Error("cannot save file " + fname);
}
/* read binary data from file */ function read_binary(path /*:string*/ ) {
    if (typeof _fs !== "undefined") return _fs.readFileSync(path);
    if (typeof Deno !== "undefined") return Deno.readFileSync(path);
    // $FlowIgnore
    if (typeof $ !== "undefined" && typeof File !== "undefined" && typeof Folder !== "undefined") try {
        // $FlowIgnore
        var infile = File(path);
        infile.open("r");
        infile.encoding = "binary";
        var data = infile.read();
        infile.close();
        return data;
    } catch (e) {
        if (!e.message || !e.message.match(/onstruct/)) throw e;
    }
    throw new Error("Cannot access file " + path);
}
function keys(o /*:any*/ ) /*:Array<any>*/ {
    var ks = Object.keys(o), o2 = [];
    for(var i = 0; i < ks.length; ++i)if (Object.prototype.hasOwnProperty.call(o, ks[i])) o2.push(ks[i]);
    return o2;
}
function evert_key(obj /*:any*/ , key /*:string*/ ) /*:EvertType*/ {
    var o = [], K = keys(obj);
    for(var i = 0; i !== K.length; ++i)if (o[obj[K[i]][key]] == null) o[obj[K[i]][key]] = K[i];
    return o;
}
function evert(obj /*:any*/ ) /*:EvertType*/ {
    var o = [], K = keys(obj);
    for(var i = 0; i !== K.length; ++i)o[obj[K[i]]] = K[i];
    return o;
}
function evert_num(obj /*:any*/ ) /*:EvertNumType*/ {
    var o = [], K = keys(obj);
    for(var i = 0; i !== K.length; ++i)o[obj[K[i]]] = parseInt(K[i], 10);
    return o;
}
function evert_arr(obj /*:any*/ ) /*:EvertArrType*/ {
    var o /*:EvertArrType*/  = [], K = keys(obj);
    for(var i = 0; i !== K.length; ++i){
        if (o[obj[K[i]]] == null) o[obj[K[i]]] = [];
        o[obj[K[i]]].push(K[i]);
    }
    return o;
}
var basedate = /*#__PURE__*/ new Date(1899, 11, 30, 0, 0, 0); // 2209161600000
function datenum(v /*:Date*/ , date1904 /*:?boolean*/ ) /*:number*/ {
    var epoch = /*#__PURE__*/ v.getTime();
    if (date1904) epoch -= 126316800000;
    var dnthresh = /*#__PURE__*/ basedate.getTime() + /*#__PURE__*/ (v.getTimezoneOffset() - /*#__PURE__*/ basedate.getTimezoneOffset()) * 60000;
    return (epoch - dnthresh) / 86400000;
}
var refdate = /*#__PURE__*/ new Date();
var dnthresh = /*#__PURE__*/ basedate.getTime() + /*#__PURE__*/ (refdate.getTimezoneOffset() - /*#__PURE__*/ basedate.getTimezoneOffset()) * 60000;
var refoffset = /*#__PURE__*/ refdate.getTimezoneOffset();
function numdate(v /*:number*/ ) /*:Date*/ {
    var out = new Date();
    out.setTime(v * 86400000 + dnthresh);
    if (out.getTimezoneOffset() !== refoffset) out.setTime(out.getTime() + (out.getTimezoneOffset() - refoffset) * 60000);
    return out;
}
/* ISO 8601 Duration */ function parse_isodur(s) {
    var sec = 0, mt = 0, time = false;
    var m = s.match(/P([0-9\.]+Y)?([0-9\.]+M)?([0-9\.]+D)?T([0-9\.]+H)?([0-9\.]+M)?([0-9\.]+S)?/);
    if (!m) throw new Error("|" + s + "| is not an ISO8601 Duration");
    for(var i = 1; i != m.length; ++i){
        if (!m[i]) continue;
        mt = 1;
        if (i > 3) time = true;
        switch(m[i].slice(m[i].length - 1)){
            case "Y":
                throw new Error("Unsupported ISO Duration Field: " + m[i].slice(m[i].length - 1));
            case "D":
                mt *= 24;
            /* falls through */ case "H":
                mt *= 60;
            /* falls through */ case "M":
                if (!time) throw new Error("Unsupported ISO Duration Field: M");
                else mt *= 60;
            /* falls through */ case "S":
                break;
        }
        sec += mt * parseInt(m[i], 10);
    }
    return sec;
}
var good_pd_date_1 = /*#__PURE__*/ new Date("2017-02-19T19:06:09.000Z");
var good_pd_date = /*#__PURE__*/ isNaN(/*#__PURE__*/ good_pd_date_1.getFullYear()) ? /*#__PURE__*/ new Date("2/19/17") : good_pd_date_1;
var good_pd = /*#__PURE__*/ good_pd_date.getFullYear() == 2017;
/* parses a date as a local date */ function parseDate(str /*:string|Date*/ , fixdate /*:?number*/ ) /*:Date*/ {
    var d = new Date(str);
    if (good_pd) {
        /*:: if(fixdate == null) fixdate = 0; */ if (fixdate > 0) d.setTime(d.getTime() + d.getTimezoneOffset() * 60000);
        else if (fixdate < 0) d.setTime(d.getTime() - d.getTimezoneOffset() * 60000);
        return d;
    }
    if (str instanceof Date) return str;
    if (good_pd_date.getFullYear() == 1917 && !isNaN(d.getFullYear())) {
        var s = d.getFullYear();
        if (str.indexOf("" + s) > -1) return d;
        d.setFullYear(d.getFullYear() + 100);
        return d;
    }
    var n = str.match(/\d+/g) || [
        "2017",
        "2",
        "19",
        "0",
        "0",
        "0"
    ];
    var out = new Date(+n[0], +n[1] - 1, +n[2], +n[3] || 0, +n[4] || 0, +n[5] || 0);
    if (str.indexOf("Z") > -1) out = new Date(out.getTime() - out.getTimezoneOffset() * 60000);
    return out;
}
function cc2str(arr /*:Array<number>*/ , debomit) /*:string*/ {
    if (has_buf && Buffer.isBuffer(arr)) {
        if (debomit) {
            if (arr[0] == 0xFF && arr[1] == 0xFE) return utf8write(arr.slice(2).toString("utf16le"));
            if (arr[1] == 0xFE && arr[2] == 0xFF) return utf8write(utf16beread(arr.slice(2).toString("binary")));
        }
        return arr.toString("binary");
    }
    if (typeof TextDecoder !== "undefined") try {
        if (debomit) {
            if (arr[0] == 0xFF && arr[1] == 0xFE) return utf8write(new TextDecoder("utf-16le").decode(arr.slice(2)));
            if (arr[0] == 0xFE && arr[1] == 0xFF) return utf8write(new TextDecoder("utf-16be").decode(arr.slice(2)));
        }
        var rev = {
            "€": "\x80",
            "‚": "\x82",
            "ƒ": "\x83",
            "„": "\x84",
            "…": "\x85",
            "†": "\x86",
            "‡": "\x87",
            "ˆ": "\x88",
            "‰": "\x89",
            "Š": "\x8a",
            "‹": "\x8b",
            "Œ": "\x8c",
            "Ž": "\x8e",
            "‘": "\x91",
            "’": "\x92",
            "“": "\x93",
            "”": "\x94",
            "•": "\x95",
            "–": "\x96",
            "—": "\x97",
            "˜": "\x98",
            "™": "\x99",
            "š": "\x9a",
            "›": "\x9b",
            "œ": "\x9c",
            "ž": "\x9e",
            "Ÿ": "\x9f"
        };
        if (Array.isArray(arr)) arr = new Uint8Array(arr);
        return new TextDecoder("latin1").decode(arr).replace(/[€‚ƒ„…†‡ˆ‰Š‹ŒŽ‘’“”•–—˜™š›œžŸ]/g, function(c) {
            return rev[c] || c;
        });
    } catch (e) {}
    var o = [];
    for(var i = 0; i != arr.length; ++i)o.push(String.fromCharCode(arr[i]));
    return o.join("");
}
function dup(o /*:any*/ ) /*:any*/ {
    if (typeof JSON != "undefined" && !Array.isArray(o)) return JSON.parse(JSON.stringify(o));
    if (typeof o != "object" || o == null) return o;
    if (o instanceof Date) return new Date(o.getTime());
    var out = {};
    for(var k in o)if (Object.prototype.hasOwnProperty.call(o, k)) out[k] = dup(o[k]);
    return out;
}
function fill(c /*:string*/ , l /*:number*/ ) /*:string*/ {
    var o = "";
    while(o.length < l)o += c;
    return o;
}
/* TODO: stress test */ function fuzzynum(s /*:string*/ ) /*:number*/ {
    var v /*:number*/  = Number(s);
    if (!isNaN(v)) return isFinite(v) ? v : NaN;
    if (!/\d/.test(s)) return v;
    var wt = 1;
    var ss = s.replace(/([\d]),([\d])/g, "$1$2").replace(/[$]/g, "").replace(/[%]/g, function() {
        wt *= 100;
        return "";
    });
    if (!isNaN(v = Number(ss))) return v / wt;
    ss = ss.replace(/[(](.*)[)]/, function($$, $1) {
        wt = -wt;
        return $1;
    });
    if (!isNaN(v = Number(ss))) return v / wt;
    return v;
}
var lower_months = [
    "january",
    "february",
    "march",
    "april",
    "may",
    "june",
    "july",
    "august",
    "september",
    "october",
    "november",
    "december"
];
function fuzzydate(s /*:string*/ ) /*:Date*/ {
    var o = new Date(s), n = new Date(NaN);
    var y = o.getYear(), m = o.getMonth(), d = o.getDate();
    if (isNaN(d)) return n;
    var lower = s.toLowerCase();
    if (lower.match(/jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec/)) {
        lower = lower.replace(/[^a-z]/g, "").replace(/([^a-z]|^)[ap]m?([^a-z]|$)/, "");
        if (lower.length > 3 && lower_months.indexOf(lower) == -1) return n;
    } else if (lower.match(/[a-z]/)) return n;
    if (y < 0 || y > 8099) return n;
    if ((m > 0 || d > 1) && y != 101) return o;
    if (s.match(/[^-0-9:,\/\\]/)) return n;
    return o;
}
var split_regex = /*#__PURE__*/ function() {
    var safe_split_regex = "abacaba".split(/(:?b)/i).length == 5;
    return function split_regex(str /*:string*/ , re, def /*:string*/ ) /*:Array<string>*/ {
        if (safe_split_regex || typeof re == "string") return str.split(re);
        var p = str.split(re), o = [
            p[0]
        ];
        for(var i = 1; i < p.length; ++i){
            o.push(def);
            o.push(p[i]);
        }
        return o;
    };
}();
function getdatastr(data) /*:?string*/ {
    if (!data) return null;
    if (data.content && data.type) return cc2str(data.content, true);
    if (data.data) return debom(data.data);
    if (data.asNodeBuffer && has_buf) return debom(data.asNodeBuffer().toString("binary"));
    if (data.asBinary) return debom(data.asBinary());
    if (data._data && data._data.getContent) return debom(cc2str(Array.prototype.slice.call(data._data.getContent(), 0)));
    return null;
}
function getdatabin(data) {
    if (!data) return null;
    if (data.data) return char_codes(data.data);
    if (data.asNodeBuffer && has_buf) return data.asNodeBuffer();
    if (data._data && data._data.getContent) {
        var o = data._data.getContent();
        if (typeof o == "string") return char_codes(o);
        return Array.prototype.slice.call(o);
    }
    if (data.content && data.type) return data.content;
    return null;
}
function getdata(data) {
    return data && data.name.slice(-4) === ".bin" ? getdatabin(data) : getdatastr(data);
}
/* Part 2 Section 10.1.2 "Mapping Content Types" Names are case-insensitive */ /* OASIS does not comment on filename case sensitivity */ function safegetzipfile(zip, file /*:string*/ ) {
    var k = zip.FullPaths || keys(zip.files);
    var f = file.toLowerCase().replace(/[\/]/g, "\\"), g = f.replace(/\\/g, "/");
    for(var i = 0; i < k.length; ++i){
        var n = k[i].replace(/^Root Entry[\/]/, "").toLowerCase();
        if (f == n || g == n) return zip.files ? zip.files[k[i]] : zip.FileIndex[i];
    }
    return null;
}
function getzipfile(zip, file /*:string*/ ) {
    var o = safegetzipfile(zip, file);
    if (o == null) throw new Error("Cannot find file " + file + " in zip");
    return o;
}
function getzipdata(zip, file /*:string*/ , safe /*:?boolean*/ ) /*:any*/ {
    if (!safe) return getdata(getzipfile(zip, file));
    if (!file) return null;
    try {
        return getzipdata(zip, file);
    } catch (e) {
        return null;
    }
}
function getzipstr(zip, file /*:string*/ , safe /*:?boolean*/ ) /*:?string*/ {
    if (!safe) return getdatastr(getzipfile(zip, file));
    if (!file) return null;
    try {
        return getzipstr(zip, file);
    } catch (e) {
        return null;
    }
}
function getzipbin(zip, file /*:string*/ , safe /*:?boolean*/ ) /*:any*/ {
    if (!safe) return getdatabin(getzipfile(zip, file));
    if (!file) return null;
    try {
        return getzipbin(zip, file);
    } catch (e) {
        return null;
    }
}
function zipentries(zip) {
    var k = zip.FullPaths || keys(zip.files), o = [];
    for(var i = 0; i < k.length; ++i)if (k[i].slice(-1) != "/") o.push(k[i].replace(/^Root Entry[\/]/, ""));
    return o.sort();
}
function zip_add_file(zip, path, content) {
    if (zip.FullPaths) {
        if (typeof content == "string") {
            var res;
            if (has_buf) res = Buffer_from(content);
            else res = utf8decode(content);
            return CFB.utils.cfb_add(zip, path, res);
        }
        CFB.utils.cfb_add(zip, path, content);
    } else zip.file(path, content);
}
function zip_new() {
    return CFB.utils.cfb_new();
}
function zip_read(d, o) {
    switch(o.type){
        case "base64":
            return CFB.read(d, {
                type: "base64"
            });
        case "binary":
            return CFB.read(d, {
                type: "binary"
            });
        case "buffer":
        case "array":
            return CFB.read(d, {
                type: "buffer"
            });
    }
    throw new Error("Unrecognized type " + o.type);
}
function resolve_path(path /*:string*/ , base /*:string*/ ) /*:string*/ {
    if (path.charAt(0) == "/") return path.slice(1);
    var result = base.split("/");
    if (base.slice(-1) != "/") result.pop(); // folder path
    var target = path.split("/");
    while(target.length !== 0){
        var step = target.shift();
        if (step === "..") result.pop();
        else if (step !== ".") result.push(step);
    }
    return result.join("/");
}
var XML_HEADER = '<?xml version="1.0" encoding="UTF-8" standalone="yes"?>\r\n';
var attregexg = /([^"\s?>\/]+)\s*=\s*((?:")([^"]*)(?:")|(?:')([^']*)(?:')|([^'">\s]+))/g;
var tagregex1 = /<[\/\?]?[a-zA-Z0-9:_-]+(?:\s+[^"\s?>\/]+\s*=\s*(?:"[^"]*"|'[^']*'|[^'">\s=]+))*\s*[\/\?]?>/mg, tagregex2 = /<[^>]*>/g;
var tagregex = /*#__PURE__*/ XML_HEADER.match(tagregex1) ? tagregex1 : tagregex2;
var nsregex = /<\w*:/, nsregex2 = /<(\/?)\w+:/;
function parsexmltag(tag /*:string*/ , skip_root /*:?boolean*/ , skip_LC /*:?boolean*/ ) /*:any*/ {
    var z = {} /*:any*/ ;
    var eq = 0, c = 0;
    for(; eq !== tag.length; ++eq)if ((c = tag.charCodeAt(eq)) === 32 || c === 10 || c === 13) break;
    if (!skip_root) z[0] = tag.slice(0, eq);
    if (eq === tag.length) return z;
    var m = tag.match(attregexg), j = 0, v = "", i = 0, q = "", cc = "", quot = 1;
    if (m) for(i = 0; i != m.length; ++i){
        cc = m[i];
        for(c = 0; c != cc.length; ++c)if (cc.charCodeAt(c) === 61) break;
        q = cc.slice(0, c).trim();
        while(cc.charCodeAt(c + 1) == 32)++c;
        quot = (eq = cc.charCodeAt(c + 1)) == 34 || eq == 39 ? 1 : 0;
        v = cc.slice(c + 1 + quot, cc.length - quot);
        for(j = 0; j != q.length; ++j)if (q.charCodeAt(j) === 58) break;
        if (j === q.length) {
            if (q.indexOf("_") > 0) q = q.slice(0, q.indexOf("_")); // from ods
            z[q] = v;
            if (!skip_LC) z[q.toLowerCase()] = v;
        } else {
            var k = (j === 5 && q.slice(0, 5) === "xmlns" ? "xmlns" : "") + q.slice(j + 1);
            if (z[k] && q.slice(j - 3, j) == "ext") continue; // from ods
            z[k] = v;
            if (!skip_LC) z[k.toLowerCase()] = v;
        }
    }
    return z;
}
function strip_ns(x /*:string*/ ) /*:string*/ {
    return x.replace(nsregex2, "<$1");
}
var encodings = {
    "&quot;": '"',
    "&apos;": "'",
    "&gt;": ">",
    "&lt;": "<",
    "&amp;": "&"
};
var rencoding = /*#__PURE__*/ evert(encodings);
//var rencstr = "&<>'\"".split("");
// TODO: CP remap (need to read file version to determine OS)
var unescapexml /*:StringConv*/  = /*#__PURE__*/ function() {
    /* 22.4.2.4 bstr (Basic String) */ var encregex = /&(?:quot|apos|gt|lt|amp|#x?([\da-fA-F]+));/ig, coderegex = /_x([\da-fA-F]{4})_/ig;
    return function unescapexml(text /*:string*/ ) /*:string*/ {
        var s = text + "", i = s.indexOf("<![CDATA[");
        if (i == -1) return s.replace(encregex, function($$, $1) {
            return encodings[$$] || String.fromCharCode(parseInt($1, $$.indexOf("x") > -1 ? 16 : 10)) || $$;
        }).replace(coderegex, function(m, c) {
            return String.fromCharCode(parseInt(c, 16));
        });
        var j = s.indexOf("]]>");
        return unescapexml(s.slice(0, i)) + s.slice(i + 9, j) + unescapexml(s.slice(j + 3));
    };
}();
var decregex = /[&<>'"]/g, charegex = /[\u0000-\u0008\u000b-\u001f]/g;
function escapexml(text /*:string*/ ) /*:string*/ {
    var s = text + "";
    return s.replace(decregex, function(y) {
        return rencoding[y];
    }).replace(charegex, function(s) {
        return "_x" + ("000" + s.charCodeAt(0).toString(16)).slice(-4) + "_";
    });
}
function escapexmltag(text /*:string*/ ) /*:string*/ {
    return escapexml(text).replace(/ /g, "_x0020_");
}
var htmlcharegex = /[\u0000-\u001f]/g;
function escapehtml(text /*:string*/ ) /*:string*/ {
    var s = text + "";
    return s.replace(decregex, function(y) {
        return rencoding[y];
    }).replace(/\n/g, "<br/>").replace(htmlcharegex, function(s) {
        return "&#x" + ("000" + s.charCodeAt(0).toString(16)).slice(-4) + ";";
    });
}
function escapexlml(text /*:string*/ ) /*:string*/ {
    var s = text + "";
    return s.replace(decregex, function(y) {
        return rencoding[y];
    }).replace(htmlcharegex, function(s) {
        return "&#x" + s.charCodeAt(0).toString(16).toUpperCase() + ";";
    });
}
/* TODO: handle codepages */ var xlml_fixstr /*:StringConv*/  = /*#__PURE__*/ function() {
    var entregex = /&#(\d+);/g;
    function entrepl($$ /*:string*/ , $1 /*:string*/ ) /*:string*/ {
        return String.fromCharCode(parseInt($1, 10));
    }
    return function xlml_fixstr(str /*:string*/ ) /*:string*/ {
        return str.replace(entregex, entrepl);
    };
}();
function xlml_unfixstr(str /*:string*/ ) /*:string*/ {
    return str.replace(/(\r\n|[\r\n])/g, "&#10;");
}
function parsexmlbool(value /*:any*/ ) /*:boolean*/ {
    switch(value){
        case 1:
        case true:
        case "1":
        case "true":
        case "TRUE":
            return true;
        /* case '0': case 'false': case 'FALSE':*/ default:
            return false;
    }
}
function utf8reada(orig /*:string*/ ) /*:string*/ {
    var out = "", i = 0, c = 0, d = 0, e = 0, f = 0, w = 0;
    while(i < orig.length){
        c = orig.charCodeAt(i++);
        if (c < 128) {
            out += String.fromCharCode(c);
            continue;
        }
        d = orig.charCodeAt(i++);
        if (c > 191 && c < 224) {
            f = (c & 31) << 6;
            f |= d & 63;
            out += String.fromCharCode(f);
            continue;
        }
        e = orig.charCodeAt(i++);
        if (c < 240) {
            out += String.fromCharCode((c & 15) << 12 | (d & 63) << 6 | e & 63);
            continue;
        }
        f = orig.charCodeAt(i++);
        w = ((c & 7) << 18 | (d & 63) << 12 | (e & 63) << 6 | f & 63) - 65536;
        out += String.fromCharCode(0xD800 + (w >>> 10 & 1023));
        out += String.fromCharCode(0xDC00 + (w & 1023));
    }
    return out;
}
function utf8readb(data) {
    var out = new_raw_buf(2 * data.length), w, i, j = 1, k = 0, ww = 0, c;
    for(i = 0; i < data.length; i += j){
        j = 1;
        if ((c = data.charCodeAt(i)) < 128) w = c;
        else if (c < 224) {
            w = (c & 31) * 64 + (data.charCodeAt(i + 1) & 63);
            j = 2;
        } else if (c < 240) {
            w = (c & 15) * 4096 + (data.charCodeAt(i + 1) & 63) * 64 + (data.charCodeAt(i + 2) & 63);
            j = 3;
        } else {
            j = 4;
            w = (c & 7) * 262144 + (data.charCodeAt(i + 1) & 63) * 4096 + (data.charCodeAt(i + 2) & 63) * 64 + (data.charCodeAt(i + 3) & 63);
            w -= 65536;
            ww = 0xD800 + (w >>> 10 & 1023);
            w = 0xDC00 + (w & 1023);
        }
        if (ww !== 0) {
            out[k++] = ww & 255;
            out[k++] = ww >>> 8;
            ww = 0;
        }
        out[k++] = w % 256;
        out[k++] = w >>> 8;
    }
    return out.slice(0, k).toString("ucs2");
}
function utf8readc(data) {
    return Buffer_from(data, "binary").toString("utf8");
}
var utf8corpus = "foo bar baz\xe2\x98\x83\xf0\x9f\x8d\xa3";
var utf8read = has_buf && /*#__PURE__*/ (utf8readc(utf8corpus) == /*#__PURE__*/ utf8reada(utf8corpus) && utf8readc || /*#__PURE__*/ utf8readb(utf8corpus) == /*#__PURE__*/ utf8reada(utf8corpus) && utf8readb) || utf8reada;
var utf8write /*:StringConv*/  = has_buf ? function(data) {
    return Buffer_from(data, "utf8").toString("binary");
} : function(orig /*:string*/ ) /*:string*/ {
    var out /*:Array<string>*/  = [], i = 0, c = 0, d = 0;
    while(i < orig.length){
        c = orig.charCodeAt(i++);
        switch(true){
            case c < 128:
                out.push(String.fromCharCode(c));
                break;
            case c < 2048:
                out.push(String.fromCharCode(192 + (c >> 6)));
                out.push(String.fromCharCode(128 + (c & 63)));
                break;
            case c >= 55296 && c < 57344:
                c -= 55296;
                d = orig.charCodeAt(i++) - 56320 + (c << 10);
                out.push(String.fromCharCode(240 + (d >> 18 & 7)));
                out.push(String.fromCharCode(144 + (d >> 12 & 63)));
                out.push(String.fromCharCode(128 + (d >> 6 & 63)));
                out.push(String.fromCharCode(128 + (d & 63)));
                break;
            default:
                out.push(String.fromCharCode(224 + (c >> 12)));
                out.push(String.fromCharCode(128 + (c >> 6 & 63)));
                out.push(String.fromCharCode(128 + (c & 63)));
        }
    }
    return out.join("");
};
// matches <foo>...</foo> extracts content
var matchtag = /*#__PURE__*/ function() {
    var mtcache /*:{[k:string]:RegExp}*/  = {} /*:any*/ ;
    return function matchtag(f /*:string*/ , g /*:?string*/ ) /*:RegExp*/ {
        var t = f + "|" + (g || "");
        if (mtcache[t]) return mtcache[t];
        return mtcache[t] = new RegExp("<(?:\\w+:)?" + f + '(?: xml:space="preserve")?(?:[^>]*)>([\\s\\S]*?)</(?:\\w+:)?' + f + ">", g || "");
    };
}();
var htmldecode /*:{(s:string):string}*/  = /*#__PURE__*/ function() {
    var entities /*:Array<[RegExp, string]>*/  = [
        [
            "nbsp",
            " "
        ],
        [
            "middot",
            "\xb7"
        ],
        [
            "quot",
            '"'
        ],
        [
            "apos",
            "'"
        ],
        [
            "gt",
            ">"
        ],
        [
            "lt",
            "<"
        ],
        [
            "amp",
            "&"
        ]
    ].map(function(x /*:[string, string]*/ ) {
        return [
            new RegExp("&" + x[0] + ";", "ig"),
            x[1]
        ];
    });
    return function htmldecode(str /*:string*/ ) /*:string*/ {
        var o = str// Remove new lines and spaces from start of content
        .replace(/^[\t\n\r ]+/, "")// Remove new lines and spaces from end of content
        .replace(/[\t\n\r ]+$/, "")// Added line which removes any white space characters after and before html tags
        .replace(/>\s+/g, ">").replace(/\s+</g, "<")// Replace remaining new lines and spaces with space
        .replace(/[\t\n\r ]+/g, " ")// Replace <br> tags with new lines
        .replace(/<\s*[bB][rR]\s*\/?>/g, "\n")// Strip HTML elements
        .replace(/<[^>]*>/g, "");
        for(var i = 0; i < entities.length; ++i)o = o.replace(entities[i][0], entities[i][1]);
        return o;
    };
}();
var vtregex = /*#__PURE__*/ function() {
    var vt_cache = {};
    return function vt_regex(bt) {
        if (vt_cache[bt] !== undefined) return vt_cache[bt];
        return vt_cache[bt] = new RegExp("<(?:vt:)?" + bt + ">([\\s\\S]*?)</(?:vt:)?" + bt + ">", "g");
    };
}();
var vtvregex = /<\/?(?:vt:)?variant>/g, vtmregex = /<(?:vt:)([^>]*)>([\s\S]*)</;
function parseVector(data /*:string*/ , opts) /*:Array<{v:string,t:string}>*/ {
    var h = parsexmltag(data);
    var matches /*:Array<string>*/  = data.match(vtregex(h.baseType)) || [];
    var res /*:Array<any>*/  = [];
    if (matches.length != h.size) {
        if (opts.WTF) throw new Error("unexpected vector length " + matches.length + " != " + h.size);
        return res;
    }
    matches.forEach(function(x /*:string*/ ) {
        var v = x.replace(vtvregex, "").match(vtmregex);
        if (v) res.push({
            v: utf8read(v[2]),
            t: v[1]
        });
    });
    return res;
}
var wtregex = /(^\s|\s$|\n)/;
function writetag(f /*:string*/ , g /*:string*/ ) /*:string*/ {
    return "<" + f + (g.match(wtregex) ? ' xml:space="preserve"' : "") + ">" + g + "</" + f + ">";
}
function wxt_helper(h) /*:string*/ {
    return keys(h).map(function(k) {
        return " " + k + '="' + h[k] + '"';
    }).join("");
}
function writextag(f /*:string*/ , g /*:?string*/ , h) {
    return "<" + f + (h != null ? wxt_helper(h) : "") + (g != null ? (g.match(wtregex) ? ' xml:space="preserve"' : "") + ">" + g + "</" + f : "/") + ">";
}
function write_w3cdtf(d /*:Date*/ , t /*:?boolean*/ ) /*:string*/ {
    try {
        return d.toISOString().replace(/\.\d*/, "");
    } catch (e) {
        if (t) throw e;
    }
    return "";
}
function write_vt(s, xlsx /*:?boolean*/ ) /*:string*/ {
    switch(typeof s){
        case "string":
            var o = writextag("vt:lpwstr", escapexml(s));
            if (xlsx) o = o.replace(/&quot;/g, "_x0022_");
            return o;
        case "number":
            return writextag((s | 0) == s ? "vt:i4" : "vt:r8", escapexml(String(s)));
        case "boolean":
            return writextag("vt:bool", s ? "true" : "false");
    }
    if (s instanceof Date) return writextag("vt:filetime", write_w3cdtf(s));
    throw new Error("Unable to serialize " + s);
}
function xlml_normalize(d) /*:string*/ {
    if (has_buf && /*::typeof Buffer !== "undefined" && d != null && d instanceof Buffer &&*/ Buffer.isBuffer(d)) return d.toString("utf8");
    if (typeof d === "string") return d;
    /* duktape */ if (typeof Uint8Array !== "undefined" && d instanceof Uint8Array) return utf8read(a2s(ab2a(d)));
    throw new Error("Bad input format: expected Buffer or string");
}
/* UOS uses CJK in tags */ var xlmlregex = /<(\/?)([^\s?><!\/:]*:|)([^\s?<>:\/]+)(?:[\s?:\/][^>]*)?>/mg;
//var xlmlregex = /<(\/?)([a-z0-9]*:|)(\w+)[^>]*>/mg;
var XMLNS = {
    CORE_PROPS: "http://schemas.openxmlformats.org/package/2006/metadata/core-properties",
    CUST_PROPS: "http://schemas.openxmlformats.org/officeDocument/2006/custom-properties",
    EXT_PROPS: "http://schemas.openxmlformats.org/officeDocument/2006/extended-properties",
    CT: "http://schemas.openxmlformats.org/package/2006/content-types",
    RELS: "http://schemas.openxmlformats.org/package/2006/relationships",
    TCMNT: "http://schemas.microsoft.com/office/spreadsheetml/2018/threadedcomments",
    "dc": "http://purl.org/dc/elements/1.1/",
    "dcterms": "http://purl.org/dc/terms/",
    "dcmitype": "http://purl.org/dc/dcmitype/",
    "mx": "http://schemas.microsoft.com/office/mac/excel/2008/main",
    "r": "http://schemas.openxmlformats.org/officeDocument/2006/relationships",
    "sjs": "http://schemas.openxmlformats.org/package/2006/sheetjs/core-properties",
    "vt": "http://schemas.openxmlformats.org/officeDocument/2006/docPropsVTypes",
    "xsi": "http://www.w3.org/2001/XMLSchema-instance",
    "xsd": "http://www.w3.org/2001/XMLSchema"
} /*:any*/ ;
var XMLNS_main = [
    "http://schemas.openxmlformats.org/spreadsheetml/2006/main",
    "http://purl.oclc.org/ooxml/spreadsheetml/main",
    "http://schemas.microsoft.com/office/excel/2006/main",
    "http://schemas.microsoft.com/office/excel/2006/2"
];
var XLMLNS = {
    "o": "urn:schemas-microsoft-com:office:office",
    "x": "urn:schemas-microsoft-com:office:excel",
    "ss": "urn:schemas-microsoft-com:office:spreadsheet",
    "dt": "uuid:C2F41010-65B3-11d1-A29F-00AA00C14882",
    "mv": "http://macVmlSchemaUri",
    "v": "urn:schemas-microsoft-com:vml",
    "html": "http://www.w3.org/TR/REC-html40"
} /*:any*/ ;
function read_double_le(b /*:RawBytes|CFBlob*/ , idx /*:number*/ ) /*:number*/ {
    var s = 1 - 2 * (b[idx + 7] >>> 7);
    var e = ((b[idx + 7] & 0x7f) << 4) + (b[idx + 6] >>> 4 & 0x0f);
    var m = b[idx + 6] & 0x0f;
    for(var i = 5; i >= 0; --i)m = m * 256 + b[idx + i];
    if (e == 0x7ff) return m == 0 ? s * Infinity : NaN;
    if (e == 0) e = -1022;
    else {
        e -= 1023;
        m += Math.pow(2, 52);
    }
    return s * Math.pow(2, e - 52) * m;
}
function write_double_le(b /*:RawBytes|CFBlob*/ , v /*:number*/ , idx /*:number*/ ) {
    var bs = (v < 0 || 1 / v == -Infinity ? 1 : 0) << 7, e = 0, m = 0;
    var av = bs ? -v : v;
    if (!isFinite(av)) {
        e = 0x7ff;
        m = isNaN(v) ? 0x6969 : 0;
    } else if (av == 0) e = m = 0;
    else {
        e = Math.floor(Math.log(av) / Math.LN2);
        m = av * Math.pow(2, 52 - e);
        if (e <= -1023 && (!isFinite(m) || m < Math.pow(2, 52))) e = -1022;
        else {
            m -= Math.pow(2, 52);
            e += 1023;
        }
    }
    for(var i = 0; i <= 5; ++i, m /= 256)b[idx + i] = m & 0xff;
    b[idx + 6] = (e & 0x0f) << 4 | m & 0xf;
    b[idx + 7] = e >> 4 | bs;
}
var ___toBuffer = function(bufs /*:Array<Array<RawBytes> >*/ ) /*:RawBytes*/ {
    var x = [], w = 10240;
    for(var i = 0; i < bufs[0].length; ++i)if (bufs[0][i]) for(var j = 0, L = bufs[0][i].length; j < L; j += w)x.push.apply(x, bufs[0][i].slice(j, j + w));
    return x;
};
var __toBuffer = has_buf ? function(bufs) {
    return bufs[0].length > 0 && Buffer.isBuffer(bufs[0][0]) ? Buffer.concat(bufs[0].map(function(x) {
        return Buffer.isBuffer(x) ? x : Buffer_from(x);
    })) : ___toBuffer(bufs);
} : ___toBuffer;
var ___utf16le = function(b /*:RawBytes|CFBlob*/ , s /*:number*/ , e /*:number*/ ) /*:string*/ {
    var ss /*:Array<string>*/  = [];
    for(var i = s; i < e; i += 2)ss.push(String.fromCharCode(__readUInt16LE(b, i)));
    return ss.join("").replace(chr0, "");
};
var __utf16le = has_buf ? function(b /*:RawBytes|CFBlob*/ , s /*:number*/ , e /*:number*/ ) /*:string*/ {
    if (!Buffer.isBuffer(b)) return ___utf16le(b, s, e);
    return b.toString("utf16le", s, e).replace(chr0, "") /*.replace(chr1,'!')*/ ;
} : ___utf16le;
var ___hexlify = function(b /*:RawBytes|CFBlob*/ , s /*:number*/ , l /*:number*/ ) /*:string*/ {
    var ss /*:Array<string>*/  = [];
    for(var i = s; i < s + l; ++i)ss.push(("0" + b[i].toString(16)).slice(-2));
    return ss.join("");
};
var __hexlify = has_buf ? function(b /*:RawBytes|CFBlob*/ , s /*:number*/ , l /*:number*/ ) /*:string*/ {
    return Buffer.isBuffer(b) ? b.toString("hex", s, s + l) : ___hexlify(b, s, l);
} : ___hexlify;
var ___utf8 = function(b /*:RawBytes|CFBlob*/ , s /*:number*/ , e /*:number*/ ) {
    var ss = [];
    for(var i = s; i < e; i++)ss.push(String.fromCharCode(__readUInt8(b, i)));
    return ss.join("");
};
var __utf8 = has_buf ? function utf8_b(b /*:RawBytes|CFBlob*/ , s /*:number*/ , e /*:number*/ ) {
    return Buffer.isBuffer(b) ? b.toString("utf8", s, e) : ___utf8(b, s, e);
} : ___utf8;
var ___lpstr = function(b /*:RawBytes|CFBlob*/ , i /*:number*/ ) {
    var len = __readUInt32LE(b, i);
    return len > 0 ? __utf8(b, i + 4, i + 4 + len - 1) : "";
};
var __lpstr = ___lpstr;
var ___cpstr = function(b /*:RawBytes|CFBlob*/ , i /*:number*/ ) {
    var len = __readUInt32LE(b, i);
    return len > 0 ? __utf8(b, i + 4, i + 4 + len - 1) : "";
};
var __cpstr = ___cpstr;
var ___lpwstr = function(b /*:RawBytes|CFBlob*/ , i /*:number*/ ) {
    var len = 2 * __readUInt32LE(b, i);
    return len > 0 ? __utf8(b, i + 4, i + 4 + len - 1) : "";
};
var __lpwstr = ___lpwstr;
var ___lpp4 = function lpp4_(b /*:RawBytes|CFBlob*/ , i /*:number*/ ) {
    var len = __readUInt32LE(b, i);
    return len > 0 ? __utf16le(b, i + 4, i + 4 + len) : "";
};
var __lpp4 = ___lpp4;
var ___8lpp4 = function(b /*:RawBytes|CFBlob*/ , i /*:number*/ ) {
    var len = __readUInt32LE(b, i);
    return len > 0 ? __utf8(b, i + 4, i + 4 + len) : "";
};
var __8lpp4 = ___8lpp4;
var ___double = function(b /*:RawBytes|CFBlob*/ , idx /*:number*/ ) {
    return read_double_le(b, idx);
};
var __double = ___double;
var is_buf = function is_buf_a(a) {
    return Array.isArray(a) || typeof Uint8Array !== "undefined" && a instanceof Uint8Array;
};
if (has_buf /*:: && typeof Buffer !== 'undefined'*/ ) {
    __lpstr = function lpstr_b(b /*:RawBytes|CFBlob*/ , i /*:number*/ ) {
        if (!Buffer.isBuffer(b)) return ___lpstr(b, i);
        var len = b.readUInt32LE(i);
        return len > 0 ? b.toString("utf8", i + 4, i + 4 + len - 1) : "";
    };
    __cpstr = function cpstr_b(b /*:RawBytes|CFBlob*/ , i /*:number*/ ) {
        if (!Buffer.isBuffer(b)) return ___cpstr(b, i);
        var len = b.readUInt32LE(i);
        return len > 0 ? b.toString("utf8", i + 4, i + 4 + len - 1) : "";
    };
    __lpwstr = function lpwstr_b(b /*:RawBytes|CFBlob*/ , i /*:number*/ ) {
        if (!Buffer.isBuffer(b)) return ___lpwstr(b, i);
        var len = 2 * b.readUInt32LE(i);
        return b.toString("utf16le", i + 4, i + 4 + len - 1);
    };
    __lpp4 = function lpp4_b(b /*:RawBytes|CFBlob*/ , i /*:number*/ ) {
        if (!Buffer.isBuffer(b)) return ___lpp4(b, i);
        var len = b.readUInt32LE(i);
        return b.toString("utf16le", i + 4, i + 4 + len);
    };
    __8lpp4 = function lpp4_8b(b /*:RawBytes|CFBlob*/ , i /*:number*/ ) {
        if (!Buffer.isBuffer(b)) return ___8lpp4(b, i);
        var len = b.readUInt32LE(i);
        return b.toString("utf8", i + 4, i + 4 + len);
    };
    __double = function double_(b /*:RawBytes|CFBlob*/ , i /*:number*/ ) {
        if (Buffer.isBuffer(b)) return b.readDoubleLE(i);
        return ___double(b, i);
    };
    is_buf = function is_buf_b(a) {
        return Buffer.isBuffer(a) || Array.isArray(a) || typeof Uint8Array !== "undefined" && a instanceof Uint8Array;
    };
}
/* from js-xls */ function cpdoit() {
    __utf16le = function(b /*:RawBytes|CFBlob*/ , s /*:number*/ , e /*:number*/ ) {
        return $cptable.utils.decode(1200, b.slice(s, e)).replace(chr0, "");
    };
    __utf8 = function(b /*:RawBytes|CFBlob*/ , s /*:number*/ , e /*:number*/ ) {
        return $cptable.utils.decode(65001, b.slice(s, e));
    };
    __lpstr = function(b /*:RawBytes|CFBlob*/ , i /*:number*/ ) {
        var len = __readUInt32LE(b, i);
        return len > 0 ? $cptable.utils.decode(current_ansi, b.slice(i + 4, i + 4 + len - 1)) : "";
    };
    __cpstr = function(b /*:RawBytes|CFBlob*/ , i /*:number*/ ) {
        var len = __readUInt32LE(b, i);
        return len > 0 ? $cptable.utils.decode(current_codepage, b.slice(i + 4, i + 4 + len - 1)) : "";
    };
    __lpwstr = function(b /*:RawBytes|CFBlob*/ , i /*:number*/ ) {
        var len = 2 * __readUInt32LE(b, i);
        return len > 0 ? $cptable.utils.decode(1200, b.slice(i + 4, i + 4 + len - 1)) : "";
    };
    __lpp4 = function(b /*:RawBytes|CFBlob*/ , i /*:number*/ ) {
        var len = __readUInt32LE(b, i);
        return len > 0 ? $cptable.utils.decode(1200, b.slice(i + 4, i + 4 + len)) : "";
    };
    __8lpp4 = function(b /*:RawBytes|CFBlob*/ , i /*:number*/ ) {
        var len = __readUInt32LE(b, i);
        return len > 0 ? $cptable.utils.decode(65001, b.slice(i + 4, i + 4 + len)) : "";
    };
}
if (typeof $cptable !== "undefined") cpdoit();
var __readUInt8 = function(b /*:RawBytes|CFBlob*/ , idx /*:number*/ ) /*:number*/ {
    return b[idx];
};
var __readUInt16LE = function(b /*:RawBytes|CFBlob*/ , idx /*:number*/ ) /*:number*/ {
    return b[idx + 1] * 256 + b[idx];
};
var __readInt16LE = function(b /*:RawBytes|CFBlob*/ , idx /*:number*/ ) /*:number*/ {
    var u = b[idx + 1] * 256 + b[idx];
    return u < 0x8000 ? u : (0xffff - u + 1) * -1;
};
var __readUInt32LE = function(b /*:RawBytes|CFBlob*/ , idx /*:number*/ ) /*:number*/ {
    return b[idx + 3] * 16777216 + (b[idx + 2] << 16) + (b[idx + 1] << 8) + b[idx];
};
var __readInt32LE = function(b /*:RawBytes|CFBlob*/ , idx /*:number*/ ) /*:number*/ {
    return b[idx + 3] << 24 | b[idx + 2] << 16 | b[idx + 1] << 8 | b[idx];
};
var __readInt32BE = function(b /*:RawBytes|CFBlob*/ , idx /*:number*/ ) /*:number*/ {
    return b[idx] << 24 | b[idx + 1] << 16 | b[idx + 2] << 8 | b[idx + 3];
};
function ReadShift(size /*:number*/ , t /*:?string*/ ) /*:number|string*/ {
    var o = "", oI /*:: :number = 0*/ , oR, oo = [], w, vv, i, loc;
    switch(t){
        case "dbcs":
            loc = this.l;
            if (has_buf && Buffer.isBuffer(this)) o = this.slice(this.l, this.l + 2 * size).toString("utf16le");
            else for(i = 0; i < size; ++i){
                o += String.fromCharCode(__readUInt16LE(this, loc));
                loc += 2;
            }
            size *= 2;
            break;
        case "utf8":
            o = __utf8(this, this.l, this.l + size);
            break;
        case "utf16le":
            size *= 2;
            o = __utf16le(this, this.l, this.l + size);
            break;
        case "wstr":
            if (typeof $cptable !== "undefined") o = $cptable.utils.decode(current_codepage, this.slice(this.l, this.l + 2 * size));
            else return ReadShift.call(this, size, "dbcs");
            size = 2 * size;
            break;
        /* [MS-OLEDS] 2.1.4 LengthPrefixedAnsiString */ case "lpstr-ansi":
            o = __lpstr(this, this.l);
            size = 4 + __readUInt32LE(this, this.l);
            break;
        case "lpstr-cp":
            o = __cpstr(this, this.l);
            size = 4 + __readUInt32LE(this, this.l);
            break;
        /* [MS-OLEDS] 2.1.5 LengthPrefixedUnicodeString */ case "lpwstr":
            o = __lpwstr(this, this.l);
            size = 4 + 2 * __readUInt32LE(this, this.l);
            break;
        /* [MS-OFFCRYPTO] 2.1.2 Length-Prefixed Padded Unicode String (UNICODE-LP-P4) */ case "lpp4":
            size = 4 + __readUInt32LE(this, this.l);
            o = __lpp4(this, this.l);
            if (size & 0x02) size += 2;
            break;
        /* [MS-OFFCRYPTO] 2.1.3 Length-Prefixed UTF-8 String (UTF-8-LP-P4) */ case "8lpp4":
            size = 4 + __readUInt32LE(this, this.l);
            o = __8lpp4(this, this.l);
            if (size & 0x03) size += 4 - (size & 0x03);
            break;
        case "cstr":
            size = 0;
            o = "";
            while((w = __readUInt8(this, this.l + size++)) !== 0)oo.push(_getchar(w));
            o = oo.join("");
            break;
        case "_wstr":
            size = 0;
            o = "";
            while((w = __readUInt16LE(this, this.l + size)) !== 0){
                oo.push(_getchar(w));
                size += 2;
            }
            size += 2;
            o = oo.join("");
            break;
        /* sbcs and dbcs support continue records in the SST way TODO codepages */ case "dbcs-cont":
            o = "";
            loc = this.l;
            for(i = 0; i < size; ++i){
                if (this.lens && this.lens.indexOf(loc) !== -1) {
                    w = __readUInt8(this, loc);
                    this.l = loc + 1;
                    vv = ReadShift.call(this, size - i, w ? "dbcs-cont" : "sbcs-cont");
                    return oo.join("") + vv;
                }
                oo.push(_getchar(__readUInt16LE(this, loc)));
                loc += 2;
            }
            o = oo.join("");
            size *= 2;
            break;
        case "cpstr":
            if (typeof $cptable !== "undefined") {
                o = $cptable.utils.decode(current_codepage, this.slice(this.l, this.l + size));
                break;
            }
        /* falls through */ case "sbcs-cont":
            o = "";
            loc = this.l;
            for(i = 0; i != size; ++i){
                if (this.lens && this.lens.indexOf(loc) !== -1) {
                    w = __readUInt8(this, loc);
                    this.l = loc + 1;
                    vv = ReadShift.call(this, size - i, w ? "dbcs-cont" : "sbcs-cont");
                    return oo.join("") + vv;
                }
                oo.push(_getchar(__readUInt8(this, loc)));
                loc += 1;
            }
            o = oo.join("");
            break;
        default:
            switch(size){
                case 1:
                    oI = __readUInt8(this, this.l);
                    this.l++;
                    return oI;
                case 2:
                    oI = (t === "i" ? __readInt16LE : __readUInt16LE)(this, this.l);
                    this.l += 2;
                    return oI;
                case 4:
                case -4:
                    if (t === "i" || (this[this.l + 3] & 0x80) === 0) {
                        oI = (size > 0 ? __readInt32LE : __readInt32BE)(this, this.l);
                        this.l += 4;
                        return oI;
                    } else {
                        oR = __readUInt32LE(this, this.l);
                        this.l += 4;
                    }
                    return oR;
                case 8:
                case -8:
                    if (t === "f") {
                        if (size == 8) oR = __double(this, this.l);
                        else oR = __double([
                            this[this.l + 7],
                            this[this.l + 6],
                            this[this.l + 5],
                            this[this.l + 4],
                            this[this.l + 3],
                            this[this.l + 2],
                            this[this.l + 1],
                            this[this.l + 0]
                        ], 0);
                        this.l += 8;
                        return oR;
                    } else size = 8;
                /* falls through */ case 16:
                    o = __hexlify(this, this.l, size);
                    break;
            }
    }
    this.l += size;
    return o;
}
var __writeUInt32LE = function(b /*:RawBytes|CFBlob*/ , val /*:number*/ , idx /*:number*/ ) /*:void*/ {
    b[idx] = val & 0xFF;
    b[idx + 1] = val >>> 8 & 0xFF;
    b[idx + 2] = val >>> 16 & 0xFF;
    b[idx + 3] = val >>> 24 & 0xFF;
};
var __writeInt32LE = function(b /*:RawBytes|CFBlob*/ , val /*:number*/ , idx /*:number*/ ) /*:void*/ {
    b[idx] = val & 0xFF;
    b[idx + 1] = val >> 8 & 0xFF;
    b[idx + 2] = val >> 16 & 0xFF;
    b[idx + 3] = val >> 24 & 0xFF;
};
var __writeUInt16LE = function(b /*:RawBytes|CFBlob*/ , val /*:number*/ , idx /*:number*/ ) /*:void*/ {
    b[idx] = val & 0xFF;
    b[idx + 1] = val >>> 8 & 0xFF;
};
function WriteShift(t /*:number*/ , val /*:string|number*/ , f /*:?string*/ ) /*:any*/ {
    var size = 0, i = 0;
    if (f === "dbcs") {
        /*:: if(typeof val !== 'string') throw new Error("unreachable"); */ for(i = 0; i != val.length; ++i)__writeUInt16LE(this, val.charCodeAt(i), this.l + 2 * i);
        size = 2 * val.length;
    } else if (f === "sbcs") {
        if (typeof $cptable !== "undefined" && current_ansi == 874) /* TODO: use tables directly, don't encode */ /*:: if(typeof val !== "string") throw new Error("unreachable"); */ for(i = 0; i != val.length; ++i){
            var cppayload = $cptable.utils.encode(current_ansi, val.charAt(i));
            this[this.l + i] = cppayload[0];
        }
        else {
            /*:: if(typeof val !== 'string') throw new Error("unreachable"); */ val = val.replace(/[^\x00-\x7F]/g, "_");
            /*:: if(typeof val !== 'string') throw new Error("unreachable"); */ for(i = 0; i != val.length; ++i)this[this.l + i] = val.charCodeAt(i) & 0xFF;
        }
        size = val.length;
    } else if (f === "hex") {
        for(; i < t; ++i)/*:: if(typeof val !== "string") throw new Error("unreachable"); */ this[this.l++] = parseInt(val.slice(2 * i, 2 * i + 2), 16) || 0;
        return this;
    } else if (f === "utf16le") {
        /*:: if(typeof val !== "string") throw new Error("unreachable"); */ var end /*:number*/  = Math.min(this.l + t, this.length);
        for(i = 0; i < Math.min(val.length, t); ++i){
            var cc = val.charCodeAt(i);
            this[this.l++] = cc & 0xff;
            this[this.l++] = cc >> 8;
        }
        while(this.l < end)this[this.l++] = 0;
        return this;
    } else /*:: if(typeof val === 'number') */ switch(t){
        case 1:
            size = 1;
            this[this.l] = val & 0xFF;
            break;
        case 2:
            size = 2;
            this[this.l] = val & 0xFF;
            val >>>= 8;
            this[this.l + 1] = val & 0xFF;
            break;
        case 3:
            size = 3;
            this[this.l] = val & 0xFF;
            val >>>= 8;
            this[this.l + 1] = val & 0xFF;
            val >>>= 8;
            this[this.l + 2] = val & 0xFF;
            break;
        case 4:
            size = 4;
            __writeUInt32LE(this, val, this.l);
            break;
        case 8:
            size = 8;
            if (f === "f") {
                write_double_le(this, val, this.l);
                break;
            }
        /* falls through */ case 16:
            break;
        case -4:
            size = 4;
            __writeInt32LE(this, val, this.l);
            break;
    }
    this.l += size;
    return this;
}
function CheckField(hexstr /*:string*/ , fld /*:string*/ ) /*:void*/ {
    var m = __hexlify(this, this.l, hexstr.length >> 1);
    if (m !== hexstr) throw new Error(fld + "Expected " + hexstr + " saw " + m);
    this.l += hexstr.length >> 1;
}
function prep_blob(blob, pos /*:number*/ ) /*:void*/ {
    blob.l = pos;
    blob.read_shift = /*::(*/ ReadShift /*:: :any)*/ ;
    blob.chk = CheckField;
    blob.write_shift = WriteShift;
}
function parsenoop(blob, length /*:: :number, opts?:any */ ) {
    blob.l += length;
}
function new_buf(sz /*:number*/ ) /*:Block*/ {
    var o = new_raw_buf(sz);
    prep_blob(o, 0);
    return o;
}
/* [MS-XLSB] 2.1.4 Record */ function recordhopper(data, cb /*:RecordHopperCB*/ , opts /*:?any*/ ) {
    if (!data) return;
    var tmpbyte, cntbyte, length;
    prep_blob(data, data.l || 0);
    var L = data.length, RT = 0, tgt = 0;
    while(data.l < L){
        RT = data.read_shift(1);
        if (RT & 0x80) RT = (RT & 0x7F) + ((data.read_shift(1) & 0x7F) << 7);
        var R = XLSBRecordEnum[RT] || XLSBRecordEnum[0xFFFF];
        tmpbyte = data.read_shift(1);
        length = tmpbyte & 0x7F;
        for(cntbyte = 1; cntbyte < 4 && tmpbyte & 0x80; ++cntbyte)length += ((tmpbyte = data.read_shift(1)) & 0x7F) << 7 * cntbyte;
        tgt = data.l + length;
        var d = R.f && R.f(data, length, opts);
        data.l = tgt;
        if (cb(d, R, RT)) return;
    }
}
/* control buffer usage for fixed-length buffers */ function buf_array() /*:BufArray*/ {
    var bufs /*:Array<Block>*/  = [], blksz = has_buf ? 256 : 2048;
    var newblk = function ba_newblk(sz /*:number*/ ) /*:Block*/ {
        var o /*:Block*/  = new_buf(sz);
        prep_blob(o, 0);
        return o;
    };
    var curbuf /*:Block*/  = newblk(blksz);
    var endbuf = function ba_endbuf() {
        if (!curbuf) return;
        if (curbuf.length > curbuf.l) {
            curbuf = curbuf.slice(0, curbuf.l);
            curbuf.l = curbuf.length;
        }
        if (curbuf.length > 0) bufs.push(curbuf);
        curbuf = null;
    };
    var next = function ba_next(sz /*:number*/ ) /*:Block*/ {
        if (curbuf && sz < curbuf.length - curbuf.l) return curbuf;
        endbuf();
        return curbuf = newblk(Math.max(sz + 1, blksz));
    };
    var end = function ba_end() {
        endbuf();
        return bconcat(bufs);
    };
    var push = function ba_push(buf) {
        endbuf();
        curbuf = buf;
        if (curbuf.l == null) curbuf.l = curbuf.length;
        next(blksz);
    };
    return {
        next: next,
        push: push,
        end: end,
        _bufs: bufs
    } /*:any*/ ;
}
function write_record(ba /*:BufArray*/ , type /*:number*/ , payload, length /*:?number*/ ) {
    var t /*:number*/  = +type, l;
    if (isNaN(t)) return; // TODO: throw something here?
    if (!length) length = XLSBRecordEnum[t].p || (payload || []).length || 0;
    l = 1 + (t >= 0x80 ? 1 : 0) + 1 /* + length*/ ;
    if (length >= 0x80) ++l;
    if (length >= 0x4000) ++l;
    if (length >= 0x200000) ++l;
    var o = ba.next(l);
    if (t <= 0x7F) o.write_shift(1, t);
    else {
        o.write_shift(1, (t & 0x7F) + 0x80);
        o.write_shift(1, t >> 7);
    }
    for(var i = 0; i != 4; ++i)if (length >= 0x80) {
        o.write_shift(1, (length & 0x7F) + 0x80);
        length >>= 7;
    } else {
        o.write_shift(1, length);
        break;
    }
    if (/*:: length != null &&*/ length > 0 && is_buf(payload)) ba.push(payload);
}
/* XLS ranges enforced */ function shift_cell_xls(cell /*:CellAddress*/ , tgt /*:any*/ , opts /*:?any*/ ) /*:CellAddress*/ {
    var out = dup(cell);
    if (tgt.s) {
        if (out.cRel) out.c += tgt.s.c;
        if (out.rRel) out.r += tgt.s.r;
    } else {
        if (out.cRel) out.c += tgt.c;
        if (out.rRel) out.r += tgt.r;
    }
    if (!opts || opts.biff < 12) {
        while(out.c >= 0x100)out.c -= 0x100;
        while(out.r >= 0x10000)out.r -= 0x10000;
    }
    return out;
}
function shift_range_xls(cell, range, opts) {
    var out = dup(cell);
    out.s = shift_cell_xls(out.s, range.s, opts);
    out.e = shift_cell_xls(out.e, range.s, opts);
    return out;
}
function encode_cell_xls(c /*:CellAddress*/ , biff /*:number*/ ) /*:string*/ {
    if (c.cRel && c.c < 0) {
        c = dup(c);
        while(c.c < 0)c.c += biff > 8 ? 0x4000 : 0x100;
    }
    if (c.rRel && c.r < 0) {
        c = dup(c);
        while(c.r < 0)c.r += biff > 8 ? 0x100000 : biff > 5 ? 0x10000 : 0x4000;
    }
    var s = encode_cell(c);
    if (!c.cRel && c.cRel != null) s = fix_col(s);
    if (!c.rRel && c.rRel != null) s = fix_row(s);
    return s;
}
function encode_range_xls(r, opts) /*:string*/ {
    if (r.s.r == 0 && !r.s.rRel) {
        if (r.e.r == (opts.biff >= 12 ? 0xFFFFF : opts.biff >= 8 ? 0x10000 : 0x4000) && !r.e.rRel) return (r.s.cRel ? "" : "$") + encode_col(r.s.c) + ":" + (r.e.cRel ? "" : "$") + encode_col(r.e.c);
    }
    if (r.s.c == 0 && !r.s.cRel) {
        if (r.e.c == (opts.biff >= 12 ? 0x3FFF : 0xFF) && !r.e.cRel) return (r.s.rRel ? "" : "$") + encode_row(r.s.r) + ":" + (r.e.rRel ? "" : "$") + encode_row(r.e.r);
    }
    return encode_cell_xls(r.s, opts.biff) + ":" + encode_cell_xls(r.e, opts.biff);
}
function decode_row(rowstr /*:string*/ ) /*:number*/ {
    return parseInt(unfix_row(rowstr), 10) - 1;
}
function encode_row(row /*:number*/ ) /*:string*/ {
    return "" + (row + 1);
}
function fix_row(cstr /*:string*/ ) /*:string*/ {
    return cstr.replace(/([A-Z]|^)(\d+)$/, "$1$$$2");
}
function unfix_row(cstr /*:string*/ ) /*:string*/ {
    return cstr.replace(/\$(\d+)$/, "$1");
}
function decode_col(colstr /*:string*/ ) /*:number*/ {
    var c = unfix_col(colstr), d = 0, i = 0;
    for(; i !== c.length; ++i)d = 26 * d + c.charCodeAt(i) - 64;
    return d - 1;
}
function encode_col(col /*:number*/ ) /*:string*/ {
    if (col < 0) throw new Error("invalid column " + col);
    var s = "";
    for(++col; col; col = Math.floor((col - 1) / 26))s = String.fromCharCode((col - 1) % 26 + 65) + s;
    return s;
}
function fix_col(cstr /*:string*/ ) /*:string*/ {
    return cstr.replace(/^([A-Z])/, "$$$1");
}
function unfix_col(cstr /*:string*/ ) /*:string*/ {
    return cstr.replace(/^\$([A-Z])/, "$1");
}
function split_cell(cstr /*:string*/ ) /*:Array<string>*/ {
    return cstr.replace(/(\$?[A-Z]*)(\$?\d*)/, "$1,$2").split(",");
}
//function decode_cell(cstr/*:string*/)/*:CellAddress*/ { var splt = split_cell(cstr); return { c:decode_col(splt[0]), r:decode_row(splt[1]) }; }
function decode_cell(cstr /*:string*/ ) /*:CellAddress*/ {
    var R = 0, C = 0;
    for(var i = 0; i < cstr.length; ++i){
        var cc = cstr.charCodeAt(i);
        if (cc >= 48 && cc <= 57) R = 10 * R + (cc - 48);
        else if (cc >= 65 && cc <= 90) C = 26 * C + (cc - 64);
    }
    return {
        c: C - 1,
        r: R - 1
    };
}
//function encode_cell(cell/*:CellAddress*/)/*:string*/ { return encode_col(cell.c) + encode_row(cell.r); }
function encode_cell(cell /*:CellAddress*/ ) /*:string*/ {
    var col = cell.c + 1;
    var s = "";
    for(; col; col = (col - 1) / 26 | 0)s = String.fromCharCode((col - 1) % 26 + 65) + s;
    return s + (cell.r + 1);
}
function decode_range(range /*:string*/ ) /*:Range*/ {
    var idx = range.indexOf(":");
    if (idx == -1) return {
        s: decode_cell(range),
        e: decode_cell(range)
    };
    return {
        s: decode_cell(range.slice(0, idx)),
        e: decode_cell(range.slice(idx + 1))
    };
}
/*# if only one arg, it is assumed to be a Range.  If 2 args, both are cell addresses */ function encode_range(cs /*:CellAddrSpec|Range*/ , ce /*:?CellAddrSpec*/ ) /*:string*/ {
    if (typeof ce === "undefined" || typeof ce === "number") /*:: if(!(cs instanceof Range)) throw "unreachable"; */ return encode_range(cs.s, cs.e);
    /*:: if((cs instanceof Range)) throw "unreachable"; */ if (typeof cs !== "string") cs = encode_cell(cs /*:any*/ );
    if (typeof ce !== "string") ce = encode_cell(ce /*:any*/ );
    /*:: if(typeof cs !== 'string') throw "unreachable"; */ /*:: if(typeof ce !== 'string') throw "unreachable"; */ return cs == ce ? cs : cs + ":" + ce;
}
function safe_decode_range(range /*:string*/ ) /*:Range*/ {
    var o = {
        s: {
            c: 0,
            r: 0
        },
        e: {
            c: 0,
            r: 0
        }
    };
    var idx = 0, i = 0, cc = 0;
    var len = range.length;
    for(idx = 0; i < len; ++i){
        if ((cc = range.charCodeAt(i) - 64) < 1 || cc > 26) break;
        idx = 26 * idx + cc;
    }
    o.s.c = --idx;
    for(idx = 0; i < len; ++i){
        if ((cc = range.charCodeAt(i) - 48) < 0 || cc > 9) break;
        idx = 10 * idx + cc;
    }
    o.s.r = --idx;
    if (i === len || cc != 10) {
        o.e.c = o.s.c;
        o.e.r = o.s.r;
        return o;
    }
    ++i;
    for(idx = 0; i != len; ++i){
        if ((cc = range.charCodeAt(i) - 64) < 1 || cc > 26) break;
        idx = 26 * idx + cc;
    }
    o.e.c = --idx;
    for(idx = 0; i != len; ++i){
        if ((cc = range.charCodeAt(i) - 48) < 0 || cc > 9) break;
        idx = 10 * idx + cc;
    }
    o.e.r = --idx;
    return o;
}
function safe_format_cell(cell /*:Cell*/ , v /*:any*/ ) {
    var q = cell.t == "d" && v instanceof Date;
    if (cell.z != null) try {
        return cell.w = SSF_format(cell.z, q ? datenum(v) : v);
    } catch (e) {}
    try {
        return cell.w = SSF_format((cell.XF || {}).numFmtId || (q ? 14 : 0), q ? datenum(v) : v);
    } catch (e) {
        return "" + v;
    }
}
function format_cell(cell /*:Cell*/ , v /*:any*/ , o /*:any*/ ) {
    if (cell == null || cell.t == null || cell.t == "z") return "";
    if (cell.w !== undefined) return cell.w;
    if (cell.t == "d" && !cell.z && o && o.dateNF) cell.z = o.dateNF;
    if (cell.t == "e") return BErr[cell.v] || cell.v;
    if (v == undefined) return safe_format_cell(cell, cell.v);
    return safe_format_cell(cell, v);
}
function sheet_to_workbook(sheet /*:Worksheet*/ , opts) /*:Workbook*/ {
    var n = opts && opts.sheet ? opts.sheet : "Sheet1";
    var sheets = {};
    sheets[n] = sheet;
    return {
        SheetNames: [
            n
        ],
        Sheets: sheets
    };
}
function sheet_add_aoa(_ws /*:?Worksheet*/ , data /*:AOA*/ , opts /*:?any*/ ) /*:Worksheet*/ {
    var o = opts || {};
    var dense = _ws ? Array.isArray(_ws) : o.dense;
    if (DENSE != null && dense == null) dense = DENSE;
    var ws /*:Worksheet*/  = _ws || (dense ? [] : {} /*:any*/ );
    var _R = 0, _C = 0;
    if (ws && o.origin != null) {
        if (typeof o.origin == "number") _R = o.origin;
        else {
            var _origin /*:CellAddress*/  = typeof o.origin == "string" ? decode_cell(o.origin) : o.origin;
            _R = _origin.r;
            _C = _origin.c;
        }
        if (!ws["!ref"]) ws["!ref"] = "A1:A1";
    }
    var range /*:Range*/  = {
        s: {
            c: 10000000,
            r: 10000000
        },
        e: {
            c: 0,
            r: 0
        }
    } /*:any*/ ;
    if (ws["!ref"]) {
        var _range = safe_decode_range(ws["!ref"]);
        range.s.c = _range.s.c;
        range.s.r = _range.s.r;
        range.e.c = Math.max(range.e.c, _range.e.c);
        range.e.r = Math.max(range.e.r, _range.e.r);
        if (_R == -1) range.e.r = _R = _range.e.r + 1;
    }
    for(var R = 0; R != data.length; ++R){
        if (!data[R]) continue;
        if (!Array.isArray(data[R])) throw new Error("aoa_to_sheet expects an array of arrays");
        for(var C = 0; C != data[R].length; ++C){
            if (typeof data[R][C] === "undefined") continue;
            var cell /*:Cell*/  = {
                v: data[R][C]
            } /*:any*/ ;
            var __R = _R + R, __C = _C + C;
            if (range.s.r > __R) range.s.r = __R;
            if (range.s.c > __C) range.s.c = __C;
            if (range.e.r < __R) range.e.r = __R;
            if (range.e.c < __C) range.e.c = __C;
            if (data[R][C] && typeof data[R][C] === "object" && !Array.isArray(data[R][C]) && !(data[R][C] instanceof Date)) cell = data[R][C];
            else {
                if (Array.isArray(cell.v)) {
                    cell.f = data[R][C][1];
                    cell.v = cell.v[0];
                }
                if (cell.v === null) {
                    if (cell.f) cell.t = "n";
                    else if (o.nullError) {
                        cell.t = "e";
                        cell.v = 0;
                    } else if (!o.sheetStubs) continue;
                    else cell.t = "z";
                } else if (typeof cell.v === "number") cell.t = "n";
                else if (typeof cell.v === "boolean") cell.t = "b";
                else if (cell.v instanceof Date) {
                    cell.z = o.dateNF || table_fmt[14];
                    if (o.cellDates) {
                        cell.t = "d";
                        cell.w = SSF_format(cell.z, datenum(cell.v));
                    } else {
                        cell.t = "n";
                        cell.v = datenum(cell.v);
                        cell.w = SSF_format(cell.z, cell.v);
                    }
                } else cell.t = "s";
            }
            if (dense) {
                if (!ws[__R]) ws[__R] = [];
                if (ws[__R][__C] && ws[__R][__C].z) cell.z = ws[__R][__C].z;
                ws[__R][__C] = cell;
            } else {
                var cell_ref = encode_cell({
                    c: __C,
                    r: __R
                } /*:any*/ );
                if (ws[cell_ref] && ws[cell_ref].z) cell.z = ws[cell_ref].z;
                ws[cell_ref] = cell;
            }
        }
    }
    if (range.s.c < 10000000) ws["!ref"] = encode_range(range);
    return ws;
}
function aoa_to_sheet(data /*:AOA*/ , opts /*:?any*/ ) /*:Worksheet*/ {
    return sheet_add_aoa(null, data, opts);
}
function parse_Int32LE(data) {
    return data.read_shift(4, "i");
}
function write_UInt32LE(x /*:number*/ , o) {
    if (!o) o = new_buf(4);
    o.write_shift(4, x);
    return o;
}
/* [MS-XLSB] 2.5.168 */ function parse_XLWideString(data /*::, length*/ ) /*:string*/ {
    var cchCharacters = data.read_shift(4);
    return cchCharacters === 0 ? "" : data.read_shift(cchCharacters, "dbcs");
}
function write_XLWideString(data /*:string*/ , o) {
    var _null = false;
    if (o == null) {
        _null = true;
        o = new_buf(4 + 2 * data.length);
    }
    o.write_shift(4, data.length);
    if (data.length > 0) o.write_shift(0, data, "dbcs");
    return _null ? o.slice(0, o.l) : o;
}
/* [MS-XLSB] 2.5.91 */ //function parse_LPWideString(data/*::, length*/)/*:string*/ {
//	var cchCharacters = data.read_shift(2);
//	return cchCharacters === 0 ? "" : data.read_shift(cchCharacters, "utf16le");
//}
/* [MS-XLSB] 2.5.143 */ function parse_StrRun(data) {
    return {
        ich: data.read_shift(2),
        ifnt: data.read_shift(2)
    };
}
function write_StrRun(run, o) {
    if (!o) o = new_buf(4);
    o.write_shift(2, run.ich || 0);
    o.write_shift(2, run.ifnt || 0);
    return o;
}
/* [MS-XLSB] 2.5.121 */ function parse_RichStr(data, length /*:number*/ ) /*:XLString*/ {
    var start = data.l;
    var flags = data.read_shift(1);
    var str = parse_XLWideString(data);
    var rgsStrRun = [];
    var z = {
        t: str,
        h: str
    } /*:any*/ ;
    if ((flags & 1) !== 0) {
        /* TODO: formatted string */ var dwSizeStrRun = data.read_shift(4);
        for(var i = 0; i != dwSizeStrRun; ++i)rgsStrRun.push(parse_StrRun(data));
        z.r = rgsStrRun;
    } else z.r = [
        {
            ich: 0,
            ifnt: 0
        }
    ];
    //if((flags & 2) !== 0) { /* fExtStr */
    //	/* TODO: phonetic string */
    //}
    data.l = start + length;
    return z;
}
function write_RichStr(str /*:XLString*/ , o /*:?Block*/ ) /*:Block*/ {
    /* TODO: formatted string */ var _null = false;
    if (o == null) {
        _null = true;
        o = new_buf(15 + 4 * str.t.length);
    }
    o.write_shift(1, 0);
    write_XLWideString(str.t, o);
    return _null ? o.slice(0, o.l) : o;
}
/* [MS-XLSB] 2.4.328 BrtCommentText (RichStr w/1 run) */ var parse_BrtCommentText = parse_RichStr;
function write_BrtCommentText(str /*:XLString*/ , o /*:?Block*/ ) /*:Block*/ {
    /* TODO: formatted string */ var _null = false;
    if (o == null) {
        _null = true;
        o = new_buf(23 + 4 * str.t.length);
    }
    o.write_shift(1, 1);
    write_XLWideString(str.t, o);
    o.write_shift(4, 1);
    write_StrRun({
        ich: 0,
        ifnt: 0
    }, o);
    return _null ? o.slice(0, o.l) : o;
}
/* [MS-XLSB] 2.5.9 */ function parse_XLSBCell(data) /*:any*/ {
    var col = data.read_shift(4);
    var iStyleRef = data.read_shift(2);
    iStyleRef += data.read_shift(1) << 16;
    data.l++; //var fPhShow = data.read_shift(1);
    return {
        c: col,
        iStyleRef: iStyleRef
    };
}
function write_XLSBCell(cell /*:any*/ , o /*:?Block*/ ) {
    if (o == null) o = new_buf(8);
    o.write_shift(-4, cell.c);
    o.write_shift(3, cell.iStyleRef || cell.s);
    o.write_shift(1, 0); /* fPhShow */ 
    return o;
}
/* Short XLSB Cell does not include column */ function parse_XLSBShortCell(data) /*:any*/ {
    var iStyleRef = data.read_shift(2);
    iStyleRef += data.read_shift(1) << 16;
    data.l++; //var fPhShow = data.read_shift(1);
    return {
        c: -1,
        iStyleRef: iStyleRef
    };
}
function write_XLSBShortCell(cell /*:any*/ , o /*:?Block*/ ) {
    if (o == null) o = new_buf(4);
    o.write_shift(3, cell.iStyleRef || cell.s);
    o.write_shift(1, 0); /* fPhShow */ 
    return o;
}
/* [MS-XLSB] 2.5.21 */ var parse_XLSBCodeName = parse_XLWideString;
var write_XLSBCodeName = write_XLWideString;
/* [MS-XLSB] 2.5.166 */ function parse_XLNullableWideString(data /*::, length*/ ) /*:string*/ {
    var cchCharacters = data.read_shift(4);
    return cchCharacters === 0 || cchCharacters === 0xFFFFFFFF ? "" : data.read_shift(cchCharacters, "dbcs");
}
function write_XLNullableWideString(data /*:string*/ , o) {
    var _null = false;
    if (o == null) {
        _null = true;
        o = new_buf(127);
    }
    o.write_shift(4, data.length > 0 ? data.length : 0xFFFFFFFF);
    if (data.length > 0) o.write_shift(0, data, "dbcs");
    return _null ? o.slice(0, o.l) : o;
}
/* [MS-XLSB] 2.5.165 */ var parse_XLNameWideString = parse_XLWideString;
//var write_XLNameWideString = write_XLWideString;
/* [MS-XLSB] 2.5.114 */ var parse_RelID = parse_XLNullableWideString;
var write_RelID = write_XLNullableWideString;
/* [MS-XLS] 2.5.217 ; [MS-XLSB] 2.5.122 */ function parse_RkNumber(data) /*:number*/ {
    var b = data.slice(data.l, data.l + 4);
    var fX100 = b[0] & 1, fInt = b[0] & 2;
    data.l += 4;
    var RK = fInt === 0 ? __double([
        0,
        0,
        0,
        0,
        b[0] & 0xFC,
        b[1],
        b[2],
        b[3]
    ], 0) : __readInt32LE(b, 0) >> 2;
    return fX100 ? RK / 100 : RK;
}
function write_RkNumber(data /*:number*/ , o) {
    if (o == null) o = new_buf(4);
    var fX100 = 0, fInt = 0, d100 = data * 100;
    if (data == (data | 0) && data >= -536870912 && data < 536870912) fInt = 1;
    else if (d100 == (d100 | 0) && d100 >= -536870912 && d100 < 536870912) {
        fInt = 1;
        fX100 = 1;
    }
    if (fInt) o.write_shift(-4, ((fX100 ? d100 : data) << 2) + (fX100 + 2));
    else throw new Error("unsupported RkNumber " + data); // TODO
}
/* [MS-XLSB] 2.5.117 RfX */ function parse_RfX(data /*::, length*/ ) /*:Range*/ {
    var cell /*:Range*/  = {
        s: {},
        e: {}
    } /*:any*/ ;
    cell.s.r = data.read_shift(4);
    cell.e.r = data.read_shift(4);
    cell.s.c = data.read_shift(4);
    cell.e.c = data.read_shift(4);
    return cell;
}
function write_RfX(r /*:Range*/ , o) {
    if (!o) o = new_buf(16);
    o.write_shift(4, r.s.r);
    o.write_shift(4, r.e.r);
    o.write_shift(4, r.s.c);
    o.write_shift(4, r.e.c);
    return o;
}
/* [MS-XLSB] 2.5.153 UncheckedRfX */ var parse_UncheckedRfX = parse_RfX;
var write_UncheckedRfX = write_RfX;
/* [MS-XLSB] 2.5.155 UncheckedSqRfX */ //function parse_UncheckedSqRfX(data) {
//	var cnt = data.read_shift(4);
//	var out = [];
//	for(var i = 0; i < cnt; ++i) {
//		var rng = parse_UncheckedRfX(data);
//		out.push(encode_range(rng));
//	}
//	return out.join(",");
//}
//function write_UncheckedSqRfX(sqrfx/*:string*/) {
//	var parts = sqrfx.split(/\s*,\s*/);
//	var o = new_buf(4); o.write_shift(4, parts.length);
//	var out = [o];
//	parts.forEach(function(rng) {
//		out.push(write_UncheckedRfX(safe_decode_range(rng)));
//	});
//	return bconcat(out);
//}
/* [MS-XLS] 2.5.342 ; [MS-XLSB] 2.5.171 */ /* TODO: error checking, NaN and Infinity values are not valid Xnum */ function parse_Xnum(data /*::, length*/ ) {
    if (data.length - data.l < 8) throw "XLS Xnum Buffer underflow";
    return data.read_shift(8, "f");
}
function write_Xnum(data, o) {
    return (o || new_buf(8)).write_shift(8, data, "f");
}
/* [MS-XLSB] 2.4.324 BrtColor */ function parse_BrtColor(data /*::, length*/ ) {
    var out = {};
    var d = data.read_shift(1);
    //var fValidRGB = d & 1;
    var xColorType = d >>> 1;
    var index = data.read_shift(1);
    var nTS = data.read_shift(2, "i");
    var bR = data.read_shift(1);
    var bG = data.read_shift(1);
    var bB = data.read_shift(1);
    data.l++; //var bAlpha = data.read_shift(1);
    switch(xColorType){
        case 0:
            out.auto = 1;
            break;
        case 1:
            out.index = index;
            var icv = XLSIcv[index];
            /* automatic pseudo index 81 */ if (icv) out.rgb = rgb2Hex(icv);
            break;
        case 2:
            /* if(!fValidRGB) throw new Error("invalid"); */ out.rgb = rgb2Hex([
                bR,
                bG,
                bB
            ]);
            break;
        case 3:
            out.theme = index;
            break;
    }
    if (nTS != 0) out.tint = nTS > 0 ? nTS / 32767 : nTS / 32768;
    return out;
}
function write_BrtColor(color, o) {
    if (!o) o = new_buf(8);
    if (!color || color.auto) {
        o.write_shift(4, 0);
        o.write_shift(4, 0);
        return o;
    }
    if (color.index != null) {
        o.write_shift(1, 0x02);
        o.write_shift(1, color.index);
    } else if (color.theme != null) {
        o.write_shift(1, 0x06);
        o.write_shift(1, color.theme);
    } else {
        o.write_shift(1, 0x05);
        o.write_shift(1, 0);
    }
    var nTS = color.tint || 0;
    if (nTS > 0) nTS *= 32767;
    else if (nTS < 0) nTS *= 32768;
    o.write_shift(2, nTS);
    if (!color.rgb || color.theme != null) {
        o.write_shift(2, 0);
        o.write_shift(1, 0);
        o.write_shift(1, 0);
    } else {
        var rgb = color.rgb || "FFFFFF";
        if (typeof rgb == "number") rgb = ("000000" + rgb.toString(16)).slice(-6);
        o.write_shift(1, parseInt(rgb.slice(0, 2), 16));
        o.write_shift(1, parseInt(rgb.slice(2, 4), 16));
        o.write_shift(1, parseInt(rgb.slice(4, 6), 16));
        o.write_shift(1, 0xFF);
    }
    return o;
}
/* [MS-XLSB] 2.5.52 */ function parse_FontFlags(data /*::, length, opts*/ ) {
    var d = data.read_shift(1);
    data.l++;
    var out = {
        fBold: d & 0x01,
        fItalic: d & 0x02,
        fUnderline: d & 0x04,
        fStrikeout: d & 0x08,
        fOutline: d & 0x10,
        fShadow: d & 0x20,
        fCondense: d & 0x40,
        fExtend: d & 0x80
    };
    return out;
}
function write_FontFlags(font, o) {
    if (!o) o = new_buf(2);
    var grbit = (font.italic ? 0x02 : 0) | (font.strike ? 0x08 : 0) | (font.outline ? 0x10 : 0) | (font.shadow ? 0x20 : 0) | (font.condense ? 0x40 : 0) | (font.extend ? 0x80 : 0);
    o.write_shift(1, grbit);
    o.write_shift(1, 0);
    return o;
}
/* [MS-OLEDS] 2.3.1 and 2.3.2 */ function parse_ClipboardFormatOrString(o, w /*:number*/ ) /*:string*/ {
    // $FlowIgnore
    var ClipFmt = {
        2: "BITMAP",
        3: "METAFILEPICT",
        8: "DIB",
        14: "ENHMETAFILE"
    };
    var m /*:number*/  = o.read_shift(4);
    switch(m){
        case 0x00000000:
            return "";
        case 0xffffffff:
        case 0xfffffffe:
            return ClipFmt[o.read_shift(4)] || "";
    }
    if (m > 0x190) throw new Error("Unsupported Clipboard: " + m.toString(16));
    o.l -= 4;
    return o.read_shift(0, w == 1 ? "lpstr" : "lpwstr");
}
function parse_ClipboardFormatOrAnsiString(o) {
    return parse_ClipboardFormatOrString(o, 1);
}
function parse_ClipboardFormatOrUnicodeString(o) {
    return parse_ClipboardFormatOrString(o, 2);
}
/* [MS-OLEPS] 2.2 PropertyType */ // Note: some tree shakers cannot handle VT_VECTOR | $CONST, hence extra vars
//var VT_EMPTY    = 0x0000;
//var VT_NULL     = 0x0001;
var VT_I2 = 0x0002;
var VT_I4 = 0x0003;
//var VT_R4       = 0x0004;
//var VT_R8       = 0x0005;
//var VT_CY       = 0x0006;
//var VT_DATE     = 0x0007;
//var VT_BSTR     = 0x0008;
//var VT_ERROR    = 0x000A;
var VT_BOOL = 0x000B;
var VT_VARIANT = 0x000C;
//var VT_DECIMAL  = 0x000E;
//var VT_I1       = 0x0010;
//var VT_UI1      = 0x0011;
//var VT_UI2      = 0x0012;
var VT_UI4 = 0x0013;
//var VT_I8       = 0x0014;
//var VT_UI8      = 0x0015;
//var VT_INT      = 0x0016;
//var VT_UINT     = 0x0017;
var VT_LPSTR = 0x001E;
//var VT_LPWSTR   = 0x001F;
var VT_FILETIME = 0x0040;
var VT_BLOB = 0x0041;
//var VT_STREAM   = 0x0042;
//var VT_STORAGE  = 0x0043;
//var VT_STREAMED_Object  = 0x0044;
//var VT_STORED_Object    = 0x0045;
//var VT_BLOB_Object      = 0x0046;
var VT_CF = 0x0047;
//var VT_CLSID    = 0x0048;
//var VT_VERSIONED_STREAM = 0x0049;
var VT_VECTOR = 0x1000;
var VT_VECTOR_VARIANT = 0x100C;
var VT_VECTOR_LPSTR = 0x101E;
//var VT_ARRAY    = 0x2000;
var VT_STRING = 0x0050; // 2.3.3.1.11 VtString
var VT_USTR = 0x0051; // 2.3.3.1.12 VtUnalignedString
var VT_CUSTOM = [
    VT_STRING,
    VT_USTR
];
/* [MS-OSHARED] 2.3.3.2.2.1 Document Summary Information PIDDSI */ var DocSummaryPIDDSI = {
    /*::[*/ 0x01: {
        n: "CodePage",
        t: VT_I2
    },
    /*::[*/ 0x02: {
        n: "Category",
        t: VT_STRING
    },
    /*::[*/ 0x03: {
        n: "PresentationFormat",
        t: VT_STRING
    },
    /*::[*/ 0x04: {
        n: "ByteCount",
        t: VT_I4
    },
    /*::[*/ 0x05: {
        n: "LineCount",
        t: VT_I4
    },
    /*::[*/ 0x06: {
        n: "ParagraphCount",
        t: VT_I4
    },
    /*::[*/ 0x07: {
        n: "SlideCount",
        t: VT_I4
    },
    /*::[*/ 0x08: {
        n: "NoteCount",
        t: VT_I4
    },
    /*::[*/ 0x09: {
        n: "HiddenCount",
        t: VT_I4
    },
    /*::[*/ 0x0a: {
        n: "MultimediaClipCount",
        t: VT_I4
    },
    /*::[*/ 0x0b: {
        n: "ScaleCrop",
        t: VT_BOOL
    },
    /*::[*/ 0x0c: {
        n: "HeadingPairs",
        t: VT_VECTOR_VARIANT /* VT_VECTOR | VT_VARIANT */ 
    },
    /*::[*/ 0x0d: {
        n: "TitlesOfParts",
        t: VT_VECTOR_LPSTR /* VT_VECTOR | VT_LPSTR */ 
    },
    /*::[*/ 0x0e: {
        n: "Manager",
        t: VT_STRING
    },
    /*::[*/ 0x0f: {
        n: "Company",
        t: VT_STRING
    },
    /*::[*/ 0x10: {
        n: "LinksUpToDate",
        t: VT_BOOL
    },
    /*::[*/ 0x11: {
        n: "CharacterCount",
        t: VT_I4
    },
    /*::[*/ 0x13: {
        n: "SharedDoc",
        t: VT_BOOL
    },
    /*::[*/ 0x16: {
        n: "HyperlinksChanged",
        t: VT_BOOL
    },
    /*::[*/ 0x17: {
        n: "AppVersion",
        t: VT_I4,
        p: "version"
    },
    /*::[*/ 0x18: {
        n: "DigSig",
        t: VT_BLOB
    },
    /*::[*/ 0x1A: {
        n: "ContentType",
        t: VT_STRING
    },
    /*::[*/ 0x1B: {
        n: "ContentStatus",
        t: VT_STRING
    },
    /*::[*/ 0x1C: {
        n: "Language",
        t: VT_STRING
    },
    /*::[*/ 0x1D: {
        n: "Version",
        t: VT_STRING
    },
    /*::[*/ 0xFF: {},
    /* [MS-OLEPS] 2.18 */ /*::[*/ 0x80000000: {
        n: "Locale",
        t: VT_UI4
    },
    /*::[*/ 0x80000003: {
        n: "Behavior",
        t: VT_UI4
    },
    /*::[*/ 0x72627262: {}
};
/* [MS-OSHARED] 2.3.3.2.1.1 Summary Information Property Set PIDSI */ var SummaryPIDSI = {
    /*::[*/ 0x01: {
        n: "CodePage",
        t: VT_I2
    },
    /*::[*/ 0x02: {
        n: "Title",
        t: VT_STRING
    },
    /*::[*/ 0x03: {
        n: "Subject",
        t: VT_STRING
    },
    /*::[*/ 0x04: {
        n: "Author",
        t: VT_STRING
    },
    /*::[*/ 0x05: {
        n: "Keywords",
        t: VT_STRING
    },
    /*::[*/ 0x06: {
        n: "Comments",
        t: VT_STRING
    },
    /*::[*/ 0x07: {
        n: "Template",
        t: VT_STRING
    },
    /*::[*/ 0x08: {
        n: "LastAuthor",
        t: VT_STRING
    },
    /*::[*/ 0x09: {
        n: "RevNumber",
        t: VT_STRING
    },
    /*::[*/ 0x0A: {
        n: "EditTime",
        t: VT_FILETIME
    },
    /*::[*/ 0x0B: {
        n: "LastPrinted",
        t: VT_FILETIME
    },
    /*::[*/ 0x0C: {
        n: "CreatedDate",
        t: VT_FILETIME
    },
    /*::[*/ 0x0D: {
        n: "ModifiedDate",
        t: VT_FILETIME
    },
    /*::[*/ 0x0E: {
        n: "PageCount",
        t: VT_I4
    },
    /*::[*/ 0x0F: {
        n: "WordCount",
        t: VT_I4
    },
    /*::[*/ 0x10: {
        n: "CharCount",
        t: VT_I4
    },
    /*::[*/ 0x11: {
        n: "Thumbnail",
        t: VT_CF
    },
    /*::[*/ 0x12: {
        n: "Application",
        t: VT_STRING
    },
    /*::[*/ 0x13: {
        n: "DocSecurity",
        t: VT_I4
    },
    /*::[*/ 0xFF: {},
    /* [MS-OLEPS] 2.18 */ /*::[*/ 0x80000000: {
        n: "Locale",
        t: VT_UI4
    },
    /*::[*/ 0x80000003: {
        n: "Behavior",
        t: VT_UI4
    },
    /*::[*/ 0x72627262: {}
};
/* [MS-XLS] 2.4.63 Country/Region codes */ var CountryEnum = {
    /*::[*/ 0x0001: "US",
    /*::[*/ 0x0002: "CA",
    /*::[*/ 0x0003: "",
    /*::[*/ 0x0007: "RU",
    /*::[*/ 0x0014: "EG",
    /*::[*/ 0x001E: "GR",
    /*::[*/ 0x001F: "NL",
    /*::[*/ 0x0020: "BE",
    /*::[*/ 0x0021: "FR",
    /*::[*/ 0x0022: "ES",
    /*::[*/ 0x0024: "HU",
    /*::[*/ 0x0027: "IT",
    /*::[*/ 0x0029: "CH",
    /*::[*/ 0x002B: "AT",
    /*::[*/ 0x002C: "GB",
    /*::[*/ 0x002D: "DK",
    /*::[*/ 0x002E: "SE",
    /*::[*/ 0x002F: "NO",
    /*::[*/ 0x0030: "PL",
    /*::[*/ 0x0031: "DE",
    /*::[*/ 0x0034: "MX",
    /*::[*/ 0x0037: "BR",
    /*::[*/ 0x003d: "AU",
    /*::[*/ 0x0040: "NZ",
    /*::[*/ 0x0042: "TH",
    /*::[*/ 0x0051: "JP",
    /*::[*/ 0x0052: "KR",
    /*::[*/ 0x0054: "VN",
    /*::[*/ 0x0056: "CN",
    /*::[*/ 0x005A: "TR",
    /*::[*/ 0x0069: "JS",
    /*::[*/ 0x00D5: "DZ",
    /*::[*/ 0x00D8: "MA",
    /*::[*/ 0x00DA: "LY",
    /*::[*/ 0x015F: "PT",
    /*::[*/ 0x0162: "IS",
    /*::[*/ 0x0166: "FI",
    /*::[*/ 0x01A4: "CZ",
    /*::[*/ 0x0376: "TW",
    /*::[*/ 0x03C1: "LB",
    /*::[*/ 0x03C2: "JO",
    /*::[*/ 0x03C3: "SY",
    /*::[*/ 0x03C4: "IQ",
    /*::[*/ 0x03C5: "KW",
    /*::[*/ 0x03C6: "SA",
    /*::[*/ 0x03CB: "AE",
    /*::[*/ 0x03CC: "IL",
    /*::[*/ 0x03CE: "QA",
    /*::[*/ 0x03D5: "IR",
    /*::[*/ 0xFFFF: "US" // United States
};
/* [MS-XLS] 2.5.127 */ var XLSFillPattern = [
    null,
    "solid",
    "mediumGray",
    "darkGray",
    "lightGray",
    "darkHorizontal",
    "darkVertical",
    "darkDown",
    "darkUp",
    "darkGrid",
    "darkTrellis",
    "lightHorizontal",
    "lightVertical",
    "lightDown",
    "lightUp",
    "lightGrid",
    "lightTrellis",
    "gray125",
    "gray0625"
];
function rgbify(arr /*:Array<number>*/ ) /*:Array<[number, number, number]>*/ {
    return arr.map(function(x) {
        return [
            x >> 16 & 255,
            x >> 8 & 255,
            x & 255
        ];
    });
}
/* [MS-XLS] 2.5.161 */ /* [MS-XLSB] 2.5.75 Icv */ var _XLSIcv = /*#__PURE__*/ rgbify([
    /* Color Constants */ 0x000000,
    0xFFFFFF,
    0xFF0000,
    0x00FF00,
    0x0000FF,
    0xFFFF00,
    0xFF00FF,
    0x00FFFF,
    /* Overridable Defaults */ 0x000000,
    0xFFFFFF,
    0xFF0000,
    0x00FF00,
    0x0000FF,
    0xFFFF00,
    0xFF00FF,
    0x00FFFF,
    0x800000,
    0x008000,
    0x000080,
    0x808000,
    0x800080,
    0x008080,
    0xC0C0C0,
    0x808080,
    0x9999FF,
    0x993366,
    0xFFFFCC,
    0xCCFFFF,
    0x660066,
    0xFF8080,
    0x0066CC,
    0xCCCCFF,
    0x000080,
    0xFF00FF,
    0xFFFF00,
    0x00FFFF,
    0x800080,
    0x800000,
    0x008080,
    0x0000FF,
    0x00CCFF,
    0xCCFFFF,
    0xCCFFCC,
    0xFFFF99,
    0x99CCFF,
    0xFF99CC,
    0xCC99FF,
    0xFFCC99,
    0x3366FF,
    0x33CCCC,
    0x99CC00,
    0xFFCC00,
    0xFF9900,
    0xFF6600,
    0x666699,
    0x969696,
    0x003366,
    0x339966,
    0x003300,
    0x333300,
    0x993300,
    0x993366,
    0x333399,
    0x333333,
    /* Other entries to appease BIFF8/12 */ 0xFFFFFF,
    /* 0x40 icvForeground ?? */ 0x000000,
    /* 0x41 icvBackground ?? */ 0x000000,
    /* 0x42 icvFrame ?? */ 0x000000,
    /* 0x43 icv3D ?? */ 0x000000,
    /* 0x44 icv3DText ?? */ 0x000000,
    /* 0x45 icv3DHilite ?? */ 0x000000,
    /* 0x46 icv3DShadow ?? */ 0x000000,
    /* 0x47 icvHilite ?? */ 0x000000,
    /* 0x48 icvCtlText ?? */ 0x000000,
    /* 0x49 icvCtlScrl ?? */ 0x000000,
    /* 0x4A icvCtlInv ?? */ 0x000000,
    /* 0x4B icvCtlBody ?? */ 0x000000,
    /* 0x4C icvCtlFrame ?? */ 0x000000,
    /* 0x4D icvCtlFore ?? */ 0x000000,
    /* 0x4E icvCtlBack ?? */ 0x000000,
    /* 0x4F icvCtlNeutral */ 0x000000,
    /* 0x50 icvInfoBk ?? */ 0x000000 /* 0x51 icvInfoText ?? */ 
]);
var XLSIcv = /*#__PURE__*/ dup(_XLSIcv);
/* [MS-XLSB] 2.5.97.2 */ var BErr = {
    /*::[*/ 0x00: "#NULL!",
    /*::[*/ 0x07: "#DIV/0!",
    /*::[*/ 0x0F: "#VALUE!",
    /*::[*/ 0x17: "#REF!",
    /*::[*/ 0x1D: "#NAME?",
    /*::[*/ 0x24: "#NUM!",
    /*::[*/ 0x2A: "#N/A",
    /*::[*/ 0x2B: "#GETTING_DATA",
    /*::[*/ 0xFF: "#WTF?"
};
//var RBErr = evert_num(BErr);
var RBErr = {
    "#NULL!": 0x00,
    "#DIV/0!": 0x07,
    "#VALUE!": 0x0F,
    "#REF!": 0x17,
    "#NAME?": 0x1D,
    "#NUM!": 0x24,
    "#N/A": 0x2A,
    "#GETTING_DATA": 0x2B,
    "#WTF?": 0xFF
};
/* Parts enumerated in OPC spec, MS-XLSB and MS-XLSX */ /* 12.3 Part Summary <SpreadsheetML> */ /* 14.2 Part Summary <DrawingML> */ /* [MS-XLSX] 2.1 Part Enumerations ; [MS-XLSB] 2.1.7 Part Enumeration */ var ct2type /*{[string]:string}*/  = {
    /* Workbook */ "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet.main+xml": "workbooks",
    "application/vnd.ms-excel.sheet.macroEnabled.main+xml": "workbooks",
    "application/vnd.ms-excel.sheet.binary.macroEnabled.main": "workbooks",
    "application/vnd.ms-excel.addin.macroEnabled.main+xml": "workbooks",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.template.main+xml": "workbooks",
    /* Worksheet */ "application/vnd.openxmlformats-officedocument.spreadsheetml.worksheet+xml": "sheets",
    "application/vnd.ms-excel.worksheet": "sheets",
    "application/vnd.ms-excel.binIndexWs": "TODO",
    /* Binary Index */ /* Chartsheet */ "application/vnd.openxmlformats-officedocument.spreadsheetml.chartsheet+xml": "charts",
    "application/vnd.ms-excel.chartsheet": "charts",
    /* Macrosheet */ "application/vnd.ms-excel.macrosheet+xml": "macros",
    "application/vnd.ms-excel.macrosheet": "macros",
    "application/vnd.ms-excel.intlmacrosheet": "TODO",
    "application/vnd.ms-excel.binIndexMs": "TODO",
    /* Binary Index */ /* Dialogsheet */ "application/vnd.openxmlformats-officedocument.spreadsheetml.dialogsheet+xml": "dialogs",
    "application/vnd.ms-excel.dialogsheet": "dialogs",
    /* Shared Strings */ "application/vnd.openxmlformats-officedocument.spreadsheetml.sharedStrings+xml": "strs",
    "application/vnd.ms-excel.sharedStrings": "strs",
    /* Styles */ "application/vnd.openxmlformats-officedocument.spreadsheetml.styles+xml": "styles",
    "application/vnd.ms-excel.styles": "styles",
    /* File Properties */ "application/vnd.openxmlformats-package.core-properties+xml": "coreprops",
    "application/vnd.openxmlformats-officedocument.custom-properties+xml": "custprops",
    "application/vnd.openxmlformats-officedocument.extended-properties+xml": "extprops",
    /* Custom Data Properties */ "application/vnd.openxmlformats-officedocument.customXmlProperties+xml": "TODO",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.customProperty": "TODO",
    /* Comments */ "application/vnd.openxmlformats-officedocument.spreadsheetml.comments+xml": "comments",
    "application/vnd.ms-excel.comments": "comments",
    "application/vnd.ms-excel.threadedcomments+xml": "threadedcomments",
    "application/vnd.ms-excel.person+xml": "people",
    /* Metadata (Stock/Geography and Dynamic Array) */ "application/vnd.openxmlformats-officedocument.spreadsheetml.sheetMetadata+xml": "metadata",
    "application/vnd.ms-excel.sheetMetadata": "metadata",
    /* PivotTable */ "application/vnd.ms-excel.pivotTable": "TODO",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.pivotTable+xml": "TODO",
    /* Chart Objects */ "application/vnd.openxmlformats-officedocument.drawingml.chart+xml": "TODO",
    /* Chart Colors */ "application/vnd.ms-office.chartcolorstyle+xml": "TODO",
    /* Chart Style */ "application/vnd.ms-office.chartstyle+xml": "TODO",
    /* Chart Advanced */ "application/vnd.ms-office.chartex+xml": "TODO",
    /* Calculation Chain */ "application/vnd.ms-excel.calcChain": "calcchains",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.calcChain+xml": "calcchains",
    /* Printer Settings */ "application/vnd.openxmlformats-officedocument.spreadsheetml.printerSettings": "TODO",
    /* ActiveX */ "application/vnd.ms-office.activeX": "TODO",
    "application/vnd.ms-office.activeX+xml": "TODO",
    /* Custom Toolbars */ "application/vnd.ms-excel.attachedToolbars": "TODO",
    /* External Data Connections */ "application/vnd.ms-excel.connections": "TODO",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.connections+xml": "TODO",
    /* External Links */ "application/vnd.ms-excel.externalLink": "links",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.externalLink+xml": "links",
    /* PivotCache */ "application/vnd.ms-excel.pivotCacheDefinition": "TODO",
    "application/vnd.ms-excel.pivotCacheRecords": "TODO",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.pivotCacheDefinition+xml": "TODO",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.pivotCacheRecords+xml": "TODO",
    /* Query Table */ "application/vnd.ms-excel.queryTable": "TODO",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.queryTable+xml": "TODO",
    /* Shared Workbook */ "application/vnd.ms-excel.userNames": "TODO",
    "application/vnd.ms-excel.revisionHeaders": "TODO",
    "application/vnd.ms-excel.revisionLog": "TODO",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.revisionHeaders+xml": "TODO",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.revisionLog+xml": "TODO",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.userNames+xml": "TODO",
    /* Single Cell Table */ "application/vnd.ms-excel.tableSingleCells": "TODO",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.tableSingleCells+xml": "TODO",
    /* Slicer */ "application/vnd.ms-excel.slicer": "TODO",
    "application/vnd.ms-excel.slicerCache": "TODO",
    "application/vnd.ms-excel.slicer+xml": "TODO",
    "application/vnd.ms-excel.slicerCache+xml": "TODO",
    /* Sort Map */ "application/vnd.ms-excel.wsSortMap": "TODO",
    /* Table */ "application/vnd.ms-excel.table": "TODO",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.table+xml": "TODO",
    /* Themes */ "application/vnd.openxmlformats-officedocument.theme+xml": "themes",
    /* Theme Override */ "application/vnd.openxmlformats-officedocument.themeOverride+xml": "TODO",
    /* Timeline */ "application/vnd.ms-excel.Timeline+xml": "TODO",
    /* verify */ "application/vnd.ms-excel.TimelineCache+xml": "TODO",
    /* verify */ /* VBA */ "application/vnd.ms-office.vbaProject": "vba",
    "application/vnd.ms-office.vbaProjectSignature": "TODO",
    /* Volatile Dependencies */ "application/vnd.ms-office.volatileDependencies": "TODO",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.volatileDependencies+xml": "TODO",
    /* Control Properties */ "application/vnd.ms-excel.controlproperties+xml": "TODO",
    /* Data Model */ "application/vnd.openxmlformats-officedocument.model+data": "TODO",
    /* Survey */ "application/vnd.ms-excel.Survey+xml": "TODO",
    /* Drawing */ "application/vnd.openxmlformats-officedocument.drawing+xml": "drawings",
    "application/vnd.openxmlformats-officedocument.drawingml.chartshapes+xml": "TODO",
    "application/vnd.openxmlformats-officedocument.drawingml.diagramColors+xml": "TODO",
    "application/vnd.openxmlformats-officedocument.drawingml.diagramData+xml": "TODO",
    "application/vnd.openxmlformats-officedocument.drawingml.diagramLayout+xml": "TODO",
    "application/vnd.openxmlformats-officedocument.drawingml.diagramStyle+xml": "TODO",
    /* VML */ "application/vnd.openxmlformats-officedocument.vmlDrawing": "TODO",
    "application/vnd.openxmlformats-package.relationships+xml": "rels",
    "application/vnd.openxmlformats-officedocument.oleObject": "TODO",
    /* Image */ "image/png": "TODO",
    "sheet": "js"
} /*:any*/ ;
var CT_LIST = {
    workbooks: {
        xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet.main+xml",
        xlsm: "application/vnd.ms-excel.sheet.macroEnabled.main+xml",
        xlsb: "application/vnd.ms-excel.sheet.binary.macroEnabled.main",
        xlam: "application/vnd.ms-excel.addin.macroEnabled.main+xml",
        xltx: "application/vnd.openxmlformats-officedocument.spreadsheetml.template.main+xml"
    },
    strs: {
        xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.sharedStrings+xml",
        xlsb: "application/vnd.ms-excel.sharedStrings"
    },
    comments: {
        xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.comments+xml",
        xlsb: "application/vnd.ms-excel.comments"
    },
    sheets: {
        xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.worksheet+xml",
        xlsb: "application/vnd.ms-excel.worksheet"
    },
    charts: {
        xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.chartsheet+xml",
        xlsb: "application/vnd.ms-excel.chartsheet"
    },
    dialogs: {
        xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.dialogsheet+xml",
        xlsb: "application/vnd.ms-excel.dialogsheet"
    },
    macros: {
        xlsx: "application/vnd.ms-excel.macrosheet+xml",
        xlsb: "application/vnd.ms-excel.macrosheet"
    },
    metadata: {
        xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheetMetadata+xml",
        xlsb: "application/vnd.ms-excel.sheetMetadata"
    },
    styles: {
        xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.styles+xml",
        xlsb: "application/vnd.ms-excel.styles"
    }
};
function new_ct() /*:any*/ {
    return {
        workbooks: [],
        sheets: [],
        charts: [],
        dialogs: [],
        macros: [],
        rels: [],
        strs: [],
        comments: [],
        threadedcomments: [],
        links: [],
        coreprops: [],
        extprops: [],
        custprops: [],
        themes: [],
        styles: [],
        calcchains: [],
        vba: [],
        drawings: [],
        metadata: [],
        people: [],
        TODO: [],
        xmlns: ""
    } /*:any*/ ;
}
function parse_ct(data /*:?string*/ ) {
    var ct = new_ct();
    if (!data || !data.match) return ct;
    var ctext = {};
    (data.match(tagregex) || []).forEach(function(x) {
        var y = parsexmltag(x);
        switch(y[0].replace(nsregex, "<")){
            case "<?xml":
                break;
            case "<Types":
                ct.xmlns = y["xmlns" + (y[0].match(/<(\w+):/) || [
                    "",
                    ""
                ])[1]];
                break;
            case "<Default":
                ctext[y.Extension] = y.ContentType;
                break;
            case "<Override":
                if (ct[ct2type[y.ContentType]] !== undefined) ct[ct2type[y.ContentType]].push(y.PartName);
                break;
        }
    });
    if (ct.xmlns !== XMLNS.CT) throw new Error("Unknown Namespace: " + ct.xmlns);
    ct.calcchain = ct.calcchains.length > 0 ? ct.calcchains[0] : "";
    ct.sst = ct.strs.length > 0 ? ct.strs[0] : "";
    ct.style = ct.styles.length > 0 ? ct.styles[0] : "";
    ct.defaults = ctext;
    delete ct.calcchains;
    return ct;
}
function write_ct(ct, opts) /*:string*/ {
    var type2ct /*{[string]:Array<string>}*/  = evert_arr(ct2type);
    var o /*:Array<string>*/  = [], v;
    o[o.length] = XML_HEADER;
    o[o.length] = writextag("Types", null, {
        "xmlns": XMLNS.CT,
        "xmlns:xsd": XMLNS.xsd,
        "xmlns:xsi": XMLNS.xsi
    });
    o = o.concat([
        [
            "xml",
            "application/xml"
        ],
        [
            "bin",
            "application/vnd.ms-excel.sheet.binary.macroEnabled.main"
        ],
        [
            "vml",
            "application/vnd.openxmlformats-officedocument.vmlDrawing"
        ],
        [
            "data",
            "application/vnd.openxmlformats-officedocument.model+data"
        ],
        /* from test files */ [
            "bmp",
            "image/bmp"
        ],
        [
            "png",
            "image/png"
        ],
        [
            "gif",
            "image/gif"
        ],
        [
            "emf",
            "image/x-emf"
        ],
        [
            "wmf",
            "image/x-wmf"
        ],
        [
            "jpg",
            "image/jpeg"
        ],
        [
            "jpeg",
            "image/jpeg"
        ],
        [
            "tif",
            "image/tiff"
        ],
        [
            "tiff",
            "image/tiff"
        ],
        [
            "pdf",
            "application/pdf"
        ],
        [
            "rels",
            "application/vnd.openxmlformats-package.relationships+xml"
        ]
    ].map(function(x) {
        return writextag("Default", null, {
            "Extension": x[0],
            "ContentType": x[1]
        });
    }));
    /* only write first instance */ var f1 = function(w) {
        if (ct[w] && ct[w].length > 0) {
            v = ct[w][0];
            o[o.length] = writextag("Override", null, {
                "PartName": (v[0] == "/" ? "" : "/") + v,
                "ContentType": CT_LIST[w][opts.bookType] || CT_LIST[w]["xlsx"]
            });
        }
    };
    /* book type-specific */ var f2 = function(w) {
        (ct[w] || []).forEach(function(v) {
            o[o.length] = writextag("Override", null, {
                "PartName": (v[0] == "/" ? "" : "/") + v,
                "ContentType": CT_LIST[w][opts.bookType] || CT_LIST[w]["xlsx"]
            });
        });
    };
    /* standard type */ var f3 = function(t) {
        (ct[t] || []).forEach(function(v) {
            o[o.length] = writextag("Override", null, {
                "PartName": (v[0] == "/" ? "" : "/") + v,
                "ContentType": type2ct[t][0]
            });
        });
    };
    f1("workbooks");
    f2("sheets");
    f2("charts");
    f3("themes");
    [
        "strs",
        "styles"
    ].forEach(f1);
    [
        "coreprops",
        "extprops",
        "custprops"
    ].forEach(f3);
    f3("vba");
    f3("comments");
    f3("threadedcomments");
    f3("drawings");
    f2("metadata");
    f3("people");
    if (o.length > 2) {
        o[o.length] = "</Types>";
        o[1] = o[1].replace("/>", ">");
    }
    return o.join("");
}
/* 9.3 Relationships */ var RELS = {
    WB: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/officeDocument",
    SHEET: "http://sheetjs.openxmlformats.org/officeDocument/2006/relationships/officeDocument",
    HLINK: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/hyperlink",
    VML: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/vmlDrawing",
    XPATH: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/externalLinkPath",
    XMISS: "http://schemas.microsoft.com/office/2006/relationships/xlExternalLinkPath/xlPathMissing",
    XLINK: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/externalLink",
    CXML: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/customXml",
    CXMLP: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/customXmlProps",
    CMNT: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/comments",
    CORE_PROPS: "http://schemas.openxmlformats.org/package/2006/relationships/metadata/core-properties",
    EXT_PROPS: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/extended-properties",
    CUST_PROPS: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/custom-properties",
    SST: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/sharedStrings",
    STY: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/styles",
    THEME: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/theme",
    CHART: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/chart",
    CHARTEX: "http://schemas.microsoft.com/office/2014/relationships/chartEx",
    CS: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/chartsheet",
    WS: [
        "http://schemas.openxmlformats.org/officeDocument/2006/relationships/worksheet",
        "http://purl.oclc.org/ooxml/officeDocument/relationships/worksheet"
    ],
    DS: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/dialogsheet",
    MS: "http://schemas.microsoft.com/office/2006/relationships/xlMacrosheet",
    IMG: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/image",
    DRAW: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/drawing",
    XLMETA: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/sheetMetadata",
    TCMNT: "http://schemas.microsoft.com/office/2017/10/relationships/threadedComment",
    PEOPLE: "http://schemas.microsoft.com/office/2017/10/relationships/person",
    VBA: "http://schemas.microsoft.com/office/2006/relationships/vbaProject"
} /*:any*/ ;
/* 9.3.3 Representing Relationships */ function get_rels_path(file /*:string*/ ) /*:string*/ {
    var n = file.lastIndexOf("/");
    return file.slice(0, n + 1) + "_rels/" + file.slice(n + 1) + ".rels";
}
function parse_rels(data /*:?string*/ , currentFilePath /*:string*/ ) {
    var rels = {
        "!id": {}
    };
    if (!data) return rels;
    if (currentFilePath.charAt(0) !== "/") currentFilePath = "/" + currentFilePath;
    var hash = {};
    (data.match(tagregex) || []).forEach(function(x) {
        var y = parsexmltag(x);
        /* 9.3.2.2 OPC_Relationships */ if (y[0] === "<Relationship") {
            var rel = {};
            rel.Type = y.Type;
            rel.Target = y.Target;
            rel.Id = y.Id;
            if (y.TargetMode) rel.TargetMode = y.TargetMode;
            var canonictarget = y.TargetMode === "External" ? y.Target : resolve_path(y.Target, currentFilePath);
            rels[canonictarget] = rel;
            hash[y.Id] = rel;
        }
    });
    rels["!id"] = hash;
    return rels;
}
/* TODO */ function write_rels(rels) /*:string*/ {
    var o = [
        XML_HEADER,
        writextag("Relationships", null, {
            //'xmlns:ns0': XMLNS.RELS,
            "xmlns": XMLNS.RELS
        })
    ];
    keys(rels["!id"]).forEach(function(rid) {
        o[o.length] = writextag("Relationship", null, rels["!id"][rid]);
    });
    if (o.length > 2) {
        o[o.length] = "</Relationships>";
        o[1] = o[1].replace("/>", ">");
    }
    return o.join("");
}
function add_rels(rels, rId /*:number*/ , f, type, relobj, targetmode /*:?string*/ ) /*:number*/ {
    if (!relobj) relobj = {};
    if (!rels["!id"]) rels["!id"] = {};
    if (!rels["!idx"]) rels["!idx"] = 1;
    if (rId < 0) for(rId = rels["!idx"]; rels["!id"]["rId" + rId]; ++rId);
    rels["!idx"] = rId + 1;
    relobj.Id = "rId" + rId;
    relobj.Type = type;
    relobj.Target = f;
    if (targetmode) relobj.TargetMode = targetmode;
    else if ([
        RELS.HLINK,
        RELS.XPATH,
        RELS.XMISS
    ].indexOf(relobj.Type) > -1) relobj.TargetMode = "External";
    if (rels["!id"][relobj.Id]) throw new Error("Cannot rewrite rId " + rId);
    rels["!id"][relobj.Id] = relobj;
    rels[("/" + relobj.Target).replace("//", "/")] = relobj;
    return rId;
}
/* Open Document Format for Office Applications (OpenDocument) Version 1.2 */ /* Part 3 Section 4 Manifest File */ var CT_ODS = "application/vnd.oasis.opendocument.spreadsheet";
function parse_manifest(d, opts) {
    var str = xlml_normalize(d);
    var Rn;
    var FEtag;
    while(Rn = xlmlregex.exec(str))switch(Rn[3]){
        case "manifest":
            break; // 4.2 <manifest:manifest>
        case "file-entry":
            FEtag = parsexmltag(Rn[0], false);
            if (FEtag.path == "/" && FEtag.type !== CT_ODS) throw new Error("This OpenDocument is not a spreadsheet");
            break;
        case "encryption-data":
        case "algorithm":
        case "start-key-generation":
        case "key-derivation":
            throw new Error("Unsupported ODS Encryption");
        default:
            if (opts && opts.WTF) throw Rn;
    }
}
function write_manifest(manifest /*:Array<Array<string> >*/ ) /*:string*/ {
    var o = [
        XML_HEADER
    ];
    o.push('<manifest:manifest xmlns:manifest="urn:oasis:names:tc:opendocument:xmlns:manifest:1.0" manifest:version="1.2">\n');
    o.push('  <manifest:file-entry manifest:full-path="/" manifest:version="1.2" manifest:media-type="application/vnd.oasis.opendocument.spreadsheet"/>\n');
    for(var i = 0; i < manifest.length; ++i)o.push('  <manifest:file-entry manifest:full-path="' + manifest[i][0] + '" manifest:media-type="' + manifest[i][1] + '"/>\n');
    o.push("</manifest:manifest>");
    return o.join("");
}
/* Part 3 Section 6 Metadata Manifest File */ function write_rdf_type(file /*:string*/ , res /*:string*/ , tag /*:?string*/ ) {
    return [
        '  <rdf:Description rdf:about="' + file + '">\n',
        '    <rdf:type rdf:resource="http://docs.oasis-open.org/ns/office/1.2/meta/' + (tag || "odf") + "#" + res + '"/>\n',
        "  </rdf:Description>\n"
    ].join("");
}
function write_rdf_has(base /*:string*/ , file /*:string*/ ) {
    return [
        '  <rdf:Description rdf:about="' + base + '">\n',
        '    <ns0:hasPart xmlns:ns0="http://docs.oasis-open.org/ns/office/1.2/meta/pkg#" rdf:resource="' + file + '"/>\n',
        "  </rdf:Description>\n"
    ].join("");
}
function write_rdf(rdf) {
    var o = [
        XML_HEADER
    ];
    o.push('<rdf:RDF xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#">\n');
    for(var i = 0; i != rdf.length; ++i){
        o.push(write_rdf_type(rdf[i][0], rdf[i][1]));
        o.push(write_rdf_has("", rdf[i][0]));
    }
    o.push(write_rdf_type("", "Document", "pkg"));
    o.push("</rdf:RDF>");
    return o.join("");
}
/* TODO: pull properties */ function write_meta_ods() /*:string*/ {
    return '<office:document-meta xmlns:office="urn:oasis:names:tc:opendocument:xmlns:office:1.0" xmlns:meta="urn:oasis:names:tc:opendocument:xmlns:meta:1.0" xmlns:dc="http://purl.org/dc/elements/1.1/" xmlns:xlink="http://www.w3.org/1999/xlink" office:version="1.2"><office:meta><meta:generator>SheetJS ' + XLSX.version + "</meta:generator></office:meta></office:document-meta>";
}
/* ECMA-376 Part II 11.1 Core Properties Part */ /* [MS-OSHARED] 2.3.3.2.[1-2].1 (PIDSI/PIDDSI) */ var CORE_PROPS /*:Array<Array<string> >*/  = [
    [
        "cp:category",
        "Category"
    ],
    [
        "cp:contentStatus",
        "ContentStatus"
    ],
    [
        "cp:keywords",
        "Keywords"
    ],
    [
        "cp:lastModifiedBy",
        "LastAuthor"
    ],
    [
        "cp:lastPrinted",
        "LastPrinted"
    ],
    [
        "cp:revision",
        "RevNumber"
    ],
    [
        "cp:version",
        "Version"
    ],
    [
        "dc:creator",
        "Author"
    ],
    [
        "dc:description",
        "Comments"
    ],
    [
        "dc:identifier",
        "Identifier"
    ],
    [
        "dc:language",
        "Language"
    ],
    [
        "dc:subject",
        "Subject"
    ],
    [
        "dc:title",
        "Title"
    ],
    [
        "dcterms:created",
        "CreatedDate",
        "date"
    ],
    [
        "dcterms:modified",
        "ModifiedDate",
        "date"
    ]
];
var CORE_PROPS_REGEX /*:Array<RegExp>*/  = /*#__PURE__*/ function() {
    var r = new Array(CORE_PROPS.length);
    for(var i = 0; i < CORE_PROPS.length; ++i){
        var f = CORE_PROPS[i];
        var g = "(?:" + f[0].slice(0, f[0].indexOf(":")) + ":)" + f[0].slice(f[0].indexOf(":") + 1);
        r[i] = new RegExp("<" + g + "[^>]*>([\\s\\S]*?)</" + g + ">");
    }
    return r;
}();
function parse_core_props(data) {
    var p = {};
    data = utf8read(data);
    for(var i = 0; i < CORE_PROPS.length; ++i){
        var f = CORE_PROPS[i], cur = data.match(CORE_PROPS_REGEX[i]);
        if (cur != null && cur.length > 0) p[f[1]] = unescapexml(cur[1]);
        if (f[2] === "date" && p[f[1]]) p[f[1]] = parseDate(p[f[1]]);
    }
    return p;
}
function cp_doit(f, g, h, o, p) {
    if (p[f] != null || g == null || g === "") return;
    p[f] = g;
    g = escapexml(g);
    o[o.length] = h ? writextag(f, g, h) : writetag(f, g);
}
function write_core_props(cp, _opts) {
    var opts = _opts || {};
    var o = [
        XML_HEADER,
        writextag("cp:coreProperties", null, {
            //'xmlns': XMLNS.CORE_PROPS,
            "xmlns:cp": XMLNS.CORE_PROPS,
            "xmlns:dc": XMLNS.dc,
            "xmlns:dcterms": XMLNS.dcterms,
            "xmlns:dcmitype": XMLNS.dcmitype,
            "xmlns:xsi": XMLNS.xsi
        })
    ], p = {};
    if (!cp && !opts.Props) return o.join("");
    if (cp) {
        if (cp.CreatedDate != null) cp_doit("dcterms:created", typeof cp.CreatedDate === "string" ? cp.CreatedDate : write_w3cdtf(cp.CreatedDate, opts.WTF), {
            "xsi:type": "dcterms:W3CDTF"
        }, o, p);
        if (cp.ModifiedDate != null) cp_doit("dcterms:modified", typeof cp.ModifiedDate === "string" ? cp.ModifiedDate : write_w3cdtf(cp.ModifiedDate, opts.WTF), {
            "xsi:type": "dcterms:W3CDTF"
        }, o, p);
    }
    for(var i = 0; i != CORE_PROPS.length; ++i){
        var f = CORE_PROPS[i];
        var v = opts.Props && opts.Props[f[1]] != null ? opts.Props[f[1]] : cp ? cp[f[1]] : null;
        if (v === true) v = "1";
        else if (v === false) v = "0";
        else if (typeof v == "number") v = String(v);
        if (v != null) cp_doit(f[0], v, null, o, p);
    }
    if (o.length > 2) {
        o[o.length] = "</cp:coreProperties>";
        o[1] = o[1].replace("/>", ">");
    }
    return o.join("");
}
/* 15.2.12.3 Extended File Properties Part */ /* [MS-OSHARED] 2.3.3.2.[1-2].1 (PIDSI/PIDDSI) */ var EXT_PROPS /*:Array<Array<string> >*/  = [
    [
        "Application",
        "Application",
        "string"
    ],
    [
        "AppVersion",
        "AppVersion",
        "string"
    ],
    [
        "Company",
        "Company",
        "string"
    ],
    [
        "DocSecurity",
        "DocSecurity",
        "string"
    ],
    [
        "Manager",
        "Manager",
        "string"
    ],
    [
        "HyperlinksChanged",
        "HyperlinksChanged",
        "bool"
    ],
    [
        "SharedDoc",
        "SharedDoc",
        "bool"
    ],
    [
        "LinksUpToDate",
        "LinksUpToDate",
        "bool"
    ],
    [
        "ScaleCrop",
        "ScaleCrop",
        "bool"
    ],
    [
        "HeadingPairs",
        "HeadingPairs",
        "raw"
    ],
    [
        "TitlesOfParts",
        "TitlesOfParts",
        "raw"
    ]
];
var PseudoPropsPairs = [
    "Worksheets",
    "SheetNames",
    "NamedRanges",
    "DefinedNames",
    "Chartsheets",
    "ChartNames"
];
function load_props_pairs(HP /*:string|Array<Array<any>>*/ , TOP, props, opts) {
    var v = [];
    if (typeof HP == "string") v = parseVector(HP, opts);
    else for(var j = 0; j < HP.length; ++j)v = v.concat(HP[j].map(function(hp) {
        return {
            v: hp
        };
    }));
    var parts = typeof TOP == "string" ? parseVector(TOP, opts).map(function(x) {
        return x.v;
    }) : TOP;
    var idx = 0, len = 0;
    if (parts.length > 0) for(var i = 0; i !== v.length; i += 2){
        len = +v[i + 1].v;
        switch(v[i].v){
            case "Worksheets":
            case "工作表":
            case "Листы":
            case "أوراق العمل":
            case "ワークシート":
            case "גליונות עבודה":
            case "Arbeitsbl\xe4tter":
            case "\xc7alışma Sayfaları":
            case "Feuilles de calcul":
            case "Fogli di lavoro":
            case "Folhas de c\xe1lculo":
            case "Planilhas":
            case "Regneark":
            case "Hojas de c\xe1lculo":
            case "Werkbladen":
                props.Worksheets = len;
                props.SheetNames = parts.slice(idx, idx + len);
                break;
            case "Named Ranges":
            case "Rangos con nombre":
            case "名前付き一覧":
            case "Benannte Bereiche":
            case "Navngivne omr\xe5der":
                props.NamedRanges = len;
                props.DefinedNames = parts.slice(idx, idx + len);
                break;
            case "Charts":
            case "Diagramme":
                props.Chartsheets = len;
                props.ChartNames = parts.slice(idx, idx + len);
                break;
        }
        idx += len;
    }
}
function parse_ext_props(data, p, opts) {
    var q = {};
    if (!p) p = {};
    data = utf8read(data);
    EXT_PROPS.forEach(function(f) {
        var xml = (data.match(matchtag(f[0])) || [])[1];
        switch(f[2]){
            case "string":
                if (xml) p[f[1]] = unescapexml(xml);
                break;
            case "bool":
                p[f[1]] = xml === "true";
                break;
            case "raw":
                var cur = data.match(new RegExp("<" + f[0] + "[^>]*>([\\s\\S]*?)</" + f[0] + ">"));
                if (cur && cur.length > 0) q[f[1]] = cur[1];
                break;
        }
    });
    if (q.HeadingPairs && q.TitlesOfParts) load_props_pairs(q.HeadingPairs, q.TitlesOfParts, p, opts);
    return p;
}
function write_ext_props(cp /*::, opts*/ ) /*:string*/ {
    var o /*:Array<string>*/  = [], W = writextag;
    if (!cp) cp = {};
    cp.Application = "SheetJS";
    o[o.length] = XML_HEADER;
    o[o.length] = writextag("Properties", null, {
        "xmlns": XMLNS.EXT_PROPS,
        "xmlns:vt": XMLNS.vt
    });
    EXT_PROPS.forEach(function(f) {
        if (cp[f[1]] === undefined) return;
        var v;
        switch(f[2]){
            case "string":
                v = escapexml(String(cp[f[1]]));
                break;
            case "bool":
                v = cp[f[1]] ? "true" : "false";
                break;
        }
        if (v !== undefined) o[o.length] = W(f[0], v);
    });
    /* TODO: HeadingPairs, TitlesOfParts */ o[o.length] = W("HeadingPairs", W("vt:vector", W("vt:variant", "<vt:lpstr>Worksheets</vt:lpstr>") + W("vt:variant", W("vt:i4", String(cp.Worksheets))), {
        size: 2,
        baseType: "variant"
    }));
    o[o.length] = W("TitlesOfParts", W("vt:vector", cp.SheetNames.map(function(s) {
        return "<vt:lpstr>" + escapexml(s) + "</vt:lpstr>";
    }).join(""), {
        size: cp.Worksheets,
        baseType: "lpstr"
    }));
    if (o.length > 2) {
        o[o.length] = "</Properties>";
        o[1] = o[1].replace("/>", ">");
    }
    return o.join("");
}
/* 15.2.12.2 Custom File Properties Part */ var custregex = /<[^>]+>[^<]*/g;
function parse_cust_props(data /*:string*/ , opts) {
    var p = {}, name = "";
    var m = data.match(custregex);
    if (m) for(var i = 0; i != m.length; ++i){
        var x = m[i], y = parsexmltag(x);
        switch(y[0]){
            case "<?xml":
                break;
            case "<Properties":
                break;
            case "<property":
                name = unescapexml(y.name);
                break;
            case "</property>":
                name = null;
                break;
            default:
                if (x.indexOf("<vt:") === 0) {
                    var toks = x.split(">");
                    var type = toks[0].slice(4), text = toks[1];
                    /* 22.4.2.32 (CT_Variant). Omit the binary types from 22.4 (Variant Types) */ switch(type){
                        case "lpstr":
                        case "bstr":
                        case "lpwstr":
                            p[name] = unescapexml(text);
                            break;
                        case "bool":
                            p[name] = parsexmlbool(text);
                            break;
                        case "i1":
                        case "i2":
                        case "i4":
                        case "i8":
                        case "int":
                        case "uint":
                            p[name] = parseInt(text, 10);
                            break;
                        case "r4":
                        case "r8":
                        case "decimal":
                            p[name] = parseFloat(text);
                            break;
                        case "filetime":
                        case "date":
                            p[name] = parseDate(text);
                            break;
                        case "cy":
                        case "error":
                            p[name] = unescapexml(text);
                            break;
                        default:
                            if (type.slice(-1) == "/") break;
                            if (opts.WTF && typeof console !== "undefined") console.warn("Unexpected", x, type, toks);
                    }
                } else if (x.slice(0, 2) === "</") ;
                else if (opts.WTF) throw new Error(x);
        }
    }
    return p;
}
function write_cust_props(cp /*::, opts*/ ) /*:string*/ {
    var o = [
        XML_HEADER,
        writextag("Properties", null, {
            "xmlns": XMLNS.CUST_PROPS,
            "xmlns:vt": XMLNS.vt
        })
    ];
    if (!cp) return o.join("");
    var pid = 1;
    keys(cp).forEach(function custprop(k) {
        ++pid;
        o[o.length] = writextag("property", write_vt(cp[k], true), {
            "fmtid": "{D5CDD505-2E9C-101B-9397-08002B2CF9AE}",
            "pid": pid,
            "name": escapexml(k)
        });
    });
    if (o.length > 2) {
        o[o.length] = "</Properties>";
        o[1] = o[1].replace("/>", ">");
    }
    return o.join("");
}
/* Common Name -> XLML Name */ var XLMLDocPropsMap = {
    Title: "Title",
    Subject: "Subject",
    Author: "Author",
    Keywords: "Keywords",
    Comments: "Description",
    LastAuthor: "LastAuthor",
    RevNumber: "Revision",
    Application: "AppName",
    /* TotalTime: 'TotalTime', */ LastPrinted: "LastPrinted",
    CreatedDate: "Created",
    ModifiedDate: "LastSaved",
    /* Pages */ /* Words */ /* Characters */ Category: "Category",
    /* PresentationFormat */ Manager: "Manager",
    Company: "Company",
    /* Guid */ /* HyperlinkBase */ /* Bytes */ /* Lines */ /* Paragraphs */ /* CharactersWithSpaces */ AppVersion: "Version",
    ContentStatus: "ContentStatus",
    /* NOTE: missing from schema */ Identifier: "Identifier",
    /* NOTE: missing from schema */ Language: "Language" /* NOTE: missing from schema */ 
};
var evert_XLMLDPM;
function xlml_set_prop(Props, tag /*:string*/ , val) {
    if (!evert_XLMLDPM) evert_XLMLDPM = evert(XLMLDocPropsMap);
    tag = evert_XLMLDPM[tag] || tag;
    Props[tag] = val;
}
function xlml_write_docprops(Props, opts) {
    var o /*:Array<string>*/  = [];
    keys(XLMLDocPropsMap).map(function(m) {
        for(var i = 0; i < CORE_PROPS.length; ++i)if (CORE_PROPS[i][1] == m) return CORE_PROPS[i];
        for(i = 0; i < EXT_PROPS.length; ++i)if (EXT_PROPS[i][1] == m) return EXT_PROPS[i];
        throw m;
    }).forEach(function(p) {
        if (Props[p[1]] == null) return;
        var m = opts && opts.Props && opts.Props[p[1]] != null ? opts.Props[p[1]] : Props[p[1]];
        switch(p[2]){
            case "date":
                m = new Date(m).toISOString().replace(/\.\d*Z/, "Z");
                break;
        }
        if (typeof m == "number") m = String(m);
        else if (m === true || m === false) m = m ? "1" : "0";
        else if (m instanceof Date) m = new Date(m).toISOString().replace(/\.\d*Z/, "");
        o.push(writetag(XLMLDocPropsMap[p[1]] || p[1], m));
    });
    return writextag("DocumentProperties", o.join(""), {
        xmlns: XLMLNS.o
    });
}
function xlml_write_custprops(Props, Custprops /*::, opts*/ ) {
    var BLACKLIST = [
        "Worksheets",
        "SheetNames"
    ];
    var T = "CustomDocumentProperties";
    var o /*:Array<string>*/  = [];
    if (Props) keys(Props).forEach(function(k) {
        /*:: if(!Props) return; */ if (!Object.prototype.hasOwnProperty.call(Props, k)) return;
        for(var i = 0; i < CORE_PROPS.length; ++i)if (k == CORE_PROPS[i][1]) return;
        for(i = 0; i < EXT_PROPS.length; ++i)if (k == EXT_PROPS[i][1]) return;
        for(i = 0; i < BLACKLIST.length; ++i)if (k == BLACKLIST[i]) return;
        var m = Props[k];
        var t = "string";
        if (typeof m == "number") {
            t = "float";
            m = String(m);
        } else if (m === true || m === false) {
            t = "boolean";
            m = m ? "1" : "0";
        } else m = String(m);
        o.push(writextag(escapexmltag(k), m, {
            "dt:dt": t
        }));
    });
    if (Custprops) keys(Custprops).forEach(function(k) {
        /*:: if(!Custprops) return; */ if (!Object.prototype.hasOwnProperty.call(Custprops, k)) return;
        if (Props && Object.prototype.hasOwnProperty.call(Props, k)) return;
        var m = Custprops[k];
        var t = "string";
        if (typeof m == "number") {
            t = "float";
            m = String(m);
        } else if (m === true || m === false) {
            t = "boolean";
            m = m ? "1" : "0";
        } else if (m instanceof Date) {
            t = "dateTime.tz";
            m = m.toISOString();
        } else m = String(m);
        o.push(writextag(escapexmltag(k), m, {
            "dt:dt": t
        }));
    });
    return "<" + T + ' xmlns="' + XLMLNS.o + '">' + o.join("") + "</" + T + ">";
}
/* [MS-DTYP] 2.3.3 FILETIME */ /* [MS-OLEDS] 2.1.3 FILETIME (Packet Version) */ /* [MS-OLEPS] 2.8 FILETIME (Packet Version) */ function parse_FILETIME(blob) {
    var dwLowDateTime = blob.read_shift(4), dwHighDateTime = blob.read_shift(4);
    return new Date((dwHighDateTime / 1e7 * Math.pow(2, 32) + dwLowDateTime / 1e7 - 11644473600) * 1000).toISOString().replace(/\.000/, "");
}
function write_FILETIME(time /*:string|Date*/ ) {
    var date = typeof time == "string" ? new Date(Date.parse(time)) : time;
    var t = date.getTime() / 1000 + 11644473600;
    var l = t % Math.pow(2, 32), h = (t - l) / Math.pow(2, 32);
    l *= 1e7;
    h *= 1e7;
    var w = l / Math.pow(2, 32) | 0;
    if (w > 0) {
        l = l % Math.pow(2, 32);
        h += w;
    }
    var o = new_buf(8);
    o.write_shift(4, l);
    o.write_shift(4, h);
    return o;
}
/* [MS-OSHARED] 2.3.3.1.4 Lpstr */ function parse_lpstr(blob, type, pad /*:?number*/ ) {
    var start = blob.l;
    var str = blob.read_shift(0, "lpstr-cp");
    if (pad) while(blob.l - start & 3)++blob.l;
    return str;
}
/* [MS-OSHARED] 2.3.3.1.6 Lpwstr */ function parse_lpwstr(blob, type, pad) {
    var str = blob.read_shift(0, "lpwstr");
    if (pad) blob.l += 4 - (str.length + 1 & 3) & 3;
    return str;
}
/* [MS-OSHARED] 2.3.3.1.11 VtString */ /* [MS-OSHARED] 2.3.3.1.12 VtUnalignedString */ function parse_VtStringBase(blob, stringType, pad) {
    if (stringType === 0x1F /*VT_LPWSTR*/ ) return parse_lpwstr(blob);
    return parse_lpstr(blob, stringType, pad);
}
function parse_VtString(blob, t /*:number*/ , pad /*:?boolean*/ ) {
    return parse_VtStringBase(blob, t, pad === false ? 0 : 4);
}
function parse_VtUnalignedString(blob, t /*:number*/ ) {
    if (!t) throw new Error("VtUnalignedString must have positive length");
    return parse_VtStringBase(blob, t, 0);
}
/* [MS-OSHARED] 2.3.3.1.7 VtVecLpwstrValue */ function parse_VtVecLpwstrValue(blob) /*:Array<string>*/ {
    var length = blob.read_shift(4);
    var ret /*:Array<string>*/  = [];
    for(var i = 0; i != length; ++i){
        var start = blob.l;
        ret[i] = blob.read_shift(0, "lpwstr").replace(chr0, "");
        if (blob.l - start & 0x02) blob.l += 2;
    }
    return ret;
}
/* [MS-OSHARED] 2.3.3.1.9 VtVecUnalignedLpstrValue */ function parse_VtVecUnalignedLpstrValue(blob) /*:Array<string>*/ {
    var length = blob.read_shift(4);
    var ret /*:Array<string>*/  = [];
    for(var i = 0; i != length; ++i)ret[i] = blob.read_shift(0, "lpstr-cp").replace(chr0, "");
    return ret;
}
/* [MS-OSHARED] 2.3.3.1.13 VtHeadingPair */ function parse_VtHeadingPair(blob) {
    var start = blob.l;
    var headingString = parse_TypedPropertyValue(blob, VT_USTR);
    if (blob[blob.l] == 0x00 && blob[blob.l + 1] == 0x00 && blob.l - start & 0x02) blob.l += 2;
    var headerParts = parse_TypedPropertyValue(blob, VT_I4);
    return [
        headingString,
        headerParts
    ];
}
/* [MS-OSHARED] 2.3.3.1.14 VtVecHeadingPairValue */ function parse_VtVecHeadingPairValue(blob) {
    var cElements = blob.read_shift(4);
    var out = [];
    for(var i = 0; i < cElements / 2; ++i)out.push(parse_VtHeadingPair(blob));
    return out;
}
/* [MS-OLEPS] 2.18.1 Dictionary (uses 2.17, 2.16) */ function parse_dictionary(blob, CodePage) {
    var cnt = blob.read_shift(4);
    var dict /*:{[number]:string}*/  = {} /*:any*/ ;
    for(var j = 0; j != cnt; ++j){
        var pid = blob.read_shift(4);
        var len = blob.read_shift(4);
        dict[pid] = blob.read_shift(len, CodePage === 0x4B0 ? "utf16le" : "utf8").replace(chr0, "").replace(chr1, "!");
        if (CodePage === 0x4B0 && len % 2) blob.l += 2;
    }
    if (blob.l & 3) blob.l = blob.l >> 3 << 2;
    return dict;
}
/* [MS-OLEPS] 2.9 BLOB */ function parse_BLOB(blob) {
    var size = blob.read_shift(4);
    var bytes = blob.slice(blob.l, blob.l + size);
    blob.l += size;
    if ((size & 3) > 0) blob.l += 4 - (size & 3) & 3;
    return bytes;
}
/* [MS-OLEPS] 2.11 ClipboardData */ function parse_ClipboardData(blob) {
    // TODO
    var o = {};
    o.Size = blob.read_shift(4);
    //o.Format = blob.read_shift(4);
    blob.l += o.Size + 3 - (o.Size - 1) % 4;
    return o;
}
/* [MS-OLEPS] 2.15 TypedPropertyValue */ function parse_TypedPropertyValue(blob, type /*:number*/ , _opts) /*:any*/ {
    var t = blob.read_shift(2), ret, opts = _opts || {};
    blob.l += 2;
    if (type !== VT_VARIANT) {
        if (t !== type && VT_CUSTOM.indexOf(type) === -1 && !((type & 0xFFFE) == 0x101E && (t & 0xFFFE) == 0x101E)) throw new Error("Expected type " + type + " saw " + t);
    }
    switch(type === VT_VARIANT ? t : type){
        case 0x02 /*VT_I2*/ :
            ret = blob.read_shift(2, "i");
            if (!opts.raw) blob.l += 2;
            return ret;
        case 0x03 /*VT_I4*/ :
            ret = blob.read_shift(4, "i");
            return ret;
        case 0x0B /*VT_BOOL*/ :
            return blob.read_shift(4) !== 0x0;
        case 0x13 /*VT_UI4*/ :
            ret = blob.read_shift(4);
            return ret;
        case 0x1E /*VT_LPSTR*/ :
            return parse_lpstr(blob, t, 4).replace(chr0, "");
        case 0x1F /*VT_LPWSTR*/ :
            return parse_lpwstr(blob);
        case 0x40 /*VT_FILETIME*/ :
            return parse_FILETIME(blob);
        case 0x41 /*VT_BLOB*/ :
            return parse_BLOB(blob);
        case 0x47 /*VT_CF*/ :
            return parse_ClipboardData(blob);
        case 0x50 /*VT_STRING*/ :
            return parse_VtString(blob, t, !opts.raw).replace(chr0, "");
        case 0x51 /*VT_USTR*/ :
            return parse_VtUnalignedString(blob, t /*, 4*/ ).replace(chr0, "");
        case 0x100C /*VT_VECTOR|VT_VARIANT*/ :
            return parse_VtVecHeadingPairValue(blob);
        case 0x101E /*VT_VECTOR|VT_LPSTR*/ :
        case 0x101F /*VT_VECTOR|VT_LPWSTR*/ :
            return t == 0x101F ? parse_VtVecLpwstrValue(blob) : parse_VtVecUnalignedLpstrValue(blob);
        default:
            throw new Error("TypedPropertyValue unrecognized type " + type + " " + t);
    }
}
function write_TypedPropertyValue(type /*:number*/ , value) {
    var o = new_buf(4), p = new_buf(4);
    o.write_shift(4, type == 0x50 ? 0x1F : type);
    switch(type){
        case 0x03 /*VT_I4*/ :
            p.write_shift(-4, value);
            break;
        case 0x05 /*VT_I4*/ :
            p = new_buf(8);
            p.write_shift(8, value, "f");
            break;
        case 0x0B /*VT_BOOL*/ :
            p.write_shift(4, value ? 0x01 : 0x00);
            break;
        case 0x40 /*VT_FILETIME*/ :
            /*:: if(typeof value !== "string" && !(value instanceof Date)) throw "unreachable"; */ p = write_FILETIME(value);
            break;
        case 0x1F /*VT_LPWSTR*/ :
        case 0x50 /*VT_STRING*/ :
            /*:: if(typeof value !== "string") throw "unreachable"; */ p = new_buf(4 + 2 * (value.length + 1) + (value.length % 2 ? 0 : 2));
            p.write_shift(4, value.length + 1);
            p.write_shift(0, value, "dbcs");
            while(p.l != p.length)p.write_shift(1, 0);
            break;
        default:
            throw new Error("TypedPropertyValue unrecognized type " + type + " " + value);
    }
    return bconcat([
        o,
        p
    ]);
}
/* [MS-OLEPS] 2.20 PropertySet */ function parse_PropertySet(blob, PIDSI) {
    var start_addr = blob.l;
    var size = blob.read_shift(4);
    var NumProps = blob.read_shift(4);
    var Props = [], i = 0;
    var CodePage = 0;
    var Dictionary = -1, DictObj /*:{[number]:string}*/  = {} /*:any*/ ;
    for(i = 0; i != NumProps; ++i){
        var PropID = blob.read_shift(4);
        var Offset = blob.read_shift(4);
        Props[i] = [
            PropID,
            Offset + start_addr
        ];
    }
    Props.sort(function(x, y) {
        return x[1] - y[1];
    });
    var PropH = {};
    for(i = 0; i != NumProps; ++i){
        if (blob.l !== Props[i][1]) {
            var fail = true;
            if (i > 0 && PIDSI) switch(PIDSI[Props[i - 1][0]].t){
                case 0x02 /*VT_I2*/ :
                    if (blob.l + 2 === Props[i][1]) {
                        blob.l += 2;
                        fail = false;
                    }
                    break;
                case 0x50 /*VT_STRING*/ :
                    if (blob.l <= Props[i][1]) {
                        blob.l = Props[i][1];
                        fail = false;
                    }
                    break;
                case 0x100C /*VT_VECTOR|VT_VARIANT*/ :
                    if (blob.l <= Props[i][1]) {
                        blob.l = Props[i][1];
                        fail = false;
                    }
                    break;
            }
            if ((!PIDSI || i == 0) && blob.l <= Props[i][1]) {
                fail = false;
                blob.l = Props[i][1];
            }
            if (fail) throw new Error("Read Error: Expected address " + Props[i][1] + " at " + blob.l + " :" + i);
        }
        if (PIDSI) {
            var piddsi = PIDSI[Props[i][0]];
            PropH[piddsi.n] = parse_TypedPropertyValue(blob, piddsi.t, {
                raw: true
            });
            if (piddsi.p === "version") PropH[piddsi.n] = String(PropH[piddsi.n] >> 16) + "." + ("0000" + String(PropH[piddsi.n] & 0xFFFF)).slice(-4);
            if (piddsi.n == "CodePage") switch(PropH[piddsi.n]){
                case 0:
                    PropH[piddsi.n] = 1252;
                /* falls through */ case 874:
                case 932:
                case 936:
                case 949:
                case 950:
                case 1250:
                case 1251:
                case 1253:
                case 1254:
                case 1255:
                case 1256:
                case 1257:
                case 1258:
                case 10000:
                case 1200:
                case 1201:
                case 1252:
                case 65000:
                case -536:
                case 65001:
                case -535:
                    set_cp(CodePage = PropH[piddsi.n] >>> 0 & 0xFFFF);
                    break;
                default:
                    throw new Error("Unsupported CodePage: " + PropH[piddsi.n]);
            }
        } else {
            if (Props[i][0] === 0x1) {
                CodePage = PropH.CodePage = parse_TypedPropertyValue(blob, VT_I2);
                set_cp(CodePage);
                if (Dictionary !== -1) {
                    var oldpos = blob.l;
                    blob.l = Props[Dictionary][1];
                    DictObj = parse_dictionary(blob, CodePage);
                    blob.l = oldpos;
                }
            } else if (Props[i][0] === 0) {
                if (CodePage === 0) {
                    Dictionary = i;
                    blob.l = Props[i + 1][1];
                    continue;
                }
                DictObj = parse_dictionary(blob, CodePage);
            } else {
                var name = DictObj[Props[i][0]];
                var val;
                /* [MS-OSHARED] 2.3.3.2.3.1.2 + PROPVARIANT */ switch(blob[blob.l]){
                    case 0x41 /*VT_BLOB*/ :
                        blob.l += 4;
                        val = parse_BLOB(blob);
                        break;
                    case 0x1E /*VT_LPSTR*/ :
                        blob.l += 4;
                        val = parse_VtString(blob, blob[blob.l - 4]).replace(/\u0000+$/, "");
                        break;
                    case 0x1F /*VT_LPWSTR*/ :
                        blob.l += 4;
                        val = parse_VtString(blob, blob[blob.l - 4]).replace(/\u0000+$/, "");
                        break;
                    case 0x03 /*VT_I4*/ :
                        blob.l += 4;
                        val = blob.read_shift(4, "i");
                        break;
                    case 0x13 /*VT_UI4*/ :
                        blob.l += 4;
                        val = blob.read_shift(4);
                        break;
                    case 0x05 /*VT_R8*/ :
                        blob.l += 4;
                        val = blob.read_shift(8, "f");
                        break;
                    case 0x0B /*VT_BOOL*/ :
                        blob.l += 4;
                        val = parsebool(blob, 4);
                        break;
                    case 0x40 /*VT_FILETIME*/ :
                        blob.l += 4;
                        val = parseDate(parse_FILETIME(blob));
                        break;
                    default:
                        throw new Error("unparsed value: " + blob[blob.l]);
                }
                PropH[name] = val;
            }
        }
    }
    blob.l = start_addr + size; /* step ahead to skip padding */ 
    return PropH;
}
var XLSPSSkip = [
    "CodePage",
    "Thumbnail",
    "_PID_LINKBASE",
    "_PID_HLINKS",
    "SystemIdentifier",
    "FMTID"
]; //.concat(PseudoPropsPairs);
function guess_property_type(val /*:any*/ ) /*:number*/ {
    switch(typeof val){
        case "boolean":
            return 0x0B;
        case "number":
            return (val | 0) == val ? 0x03 : 0x05;
        case "string":
            return 0x1F;
        case "object":
            if (val instanceof Date) return 0x40;
            break;
    }
    return -1;
}
function write_PropertySet(entries, RE, PIDSI) {
    var hdr = new_buf(8), piao = [], prop = [];
    var sz = 8, i = 0;
    var pr = new_buf(8), pio = new_buf(8);
    pr.write_shift(4, 0x0002);
    pr.write_shift(4, 0x04B0);
    pio.write_shift(4, 0x0001);
    prop.push(pr);
    piao.push(pio);
    sz += 8 + pr.length;
    if (!RE) {
        pio = new_buf(8);
        pio.write_shift(4, 0);
        piao.unshift(pio);
        var bufs = [
            new_buf(4)
        ];
        bufs[0].write_shift(4, entries.length);
        for(i = 0; i < entries.length; ++i){
            var value = entries[i][0];
            pr = new_buf(8 + 2 * (value.length + 1) + (value.length % 2 ? 0 : 2));
            pr.write_shift(4, i + 2);
            pr.write_shift(4, value.length + 1);
            pr.write_shift(0, value, "dbcs");
            while(pr.l != pr.length)pr.write_shift(1, 0);
            bufs.push(pr);
        }
        pr = bconcat(bufs);
        prop.unshift(pr);
        sz += 8 + pr.length;
    }
    for(i = 0; i < entries.length; ++i){
        if (RE && !RE[entries[i][0]]) continue;
        if (XLSPSSkip.indexOf(entries[i][0]) > -1 || PseudoPropsPairs.indexOf(entries[i][0]) > -1) continue;
        if (entries[i][1] == null) continue;
        var val = entries[i][1], idx = 0;
        if (RE) {
            idx = +RE[entries[i][0]];
            var pinfo = PIDSI /*:: || {}*/ [idx] /*:: || {} */ ;
            if (pinfo.p == "version" && typeof val == "string") {
                /*:: if(typeof val !== "string") throw "unreachable"; */ var arr = val.split(".");
                val = (+arr[0] << 16) + (+arr[1] || 0);
            }
            pr = write_TypedPropertyValue(pinfo.t, val);
        } else {
            var T = guess_property_type(val);
            if (T == -1) {
                T = 0x1F;
                val = String(val);
            }
            pr = write_TypedPropertyValue(T, val);
        }
        prop.push(pr);
        pio = new_buf(8);
        pio.write_shift(4, !RE ? 2 + i : idx);
        piao.push(pio);
        sz += 8 + pr.length;
    }
    var w = 8 * (prop.length + 1);
    for(i = 0; i < prop.length; ++i){
        piao[i].write_shift(4, w);
        w += prop[i].length;
    }
    hdr.write_shift(4, sz);
    hdr.write_shift(4, prop.length);
    return bconcat([
        hdr
    ].concat(piao).concat(prop));
}
/* [MS-OLEPS] 2.21 PropertySetStream */ function parse_PropertySetStream(file, PIDSI, clsid) {
    var blob = file.content;
    if (!blob) return {} /*:any*/ ;
    prep_blob(blob, 0);
    var NumSets, FMTID0, FMTID1, Offset0, Offset1 = 0;
    blob.chk("feff", "Byte Order: ");
    /*var vers = */ blob.read_shift(2); // TODO: check version
    var SystemIdentifier = blob.read_shift(4);
    var CLSID = blob.read_shift(16);
    if (CLSID !== CFB.utils.consts.HEADER_CLSID && CLSID !== clsid) throw new Error("Bad PropertySet CLSID " + CLSID);
    NumSets = blob.read_shift(4);
    if (NumSets !== 1 && NumSets !== 2) throw new Error("Unrecognized #Sets: " + NumSets);
    FMTID0 = blob.read_shift(16);
    Offset0 = blob.read_shift(4);
    if (NumSets === 1 && Offset0 !== blob.l) throw new Error("Length mismatch: " + Offset0 + " !== " + blob.l);
    else if (NumSets === 2) {
        FMTID1 = blob.read_shift(16);
        Offset1 = blob.read_shift(4);
    }
    var PSet0 = parse_PropertySet(blob, PIDSI);
    var rval = {
        SystemIdentifier: SystemIdentifier
    } /*:any*/ ;
    for(var y in PSet0)rval[y] = PSet0[y];
    //rval.blob = blob;
    rval.FMTID = FMTID0;
    //rval.PSet0 = PSet0;
    if (NumSets === 1) return rval;
    if (Offset1 - blob.l == 2) blob.l += 2;
    if (blob.l !== Offset1) throw new Error("Length mismatch 2: " + blob.l + " !== " + Offset1);
    var PSet1;
    try {
        PSet1 = parse_PropertySet(blob, null);
    } catch (e) {}
    for(y in PSet1)rval[y] = PSet1[y];
    rval.FMTID = [
        FMTID0,
        FMTID1
    ]; // TODO: verify FMTID0/1
    return rval;
}
function write_PropertySetStream(entries, clsid, RE, PIDSI /*:{[key:string|number]:any}*/ , entries2 /*:?any*/ , clsid2 /*:?any*/ ) {
    var hdr = new_buf(entries2 ? 68 : 48);
    var bufs = [
        hdr
    ];
    hdr.write_shift(2, 0xFFFE);
    hdr.write_shift(2, 0x0000); /* TODO: type 1 props */ 
    hdr.write_shift(4, 0x32363237);
    hdr.write_shift(16, CFB.utils.consts.HEADER_CLSID, "hex");
    hdr.write_shift(4, entries2 ? 2 : 1);
    hdr.write_shift(16, clsid, "hex");
    hdr.write_shift(4, entries2 ? 68 : 48);
    var ps0 = write_PropertySet(entries, RE, PIDSI);
    bufs.push(ps0);
    if (entries2) {
        var ps1 = write_PropertySet(entries2, null, null);
        hdr.write_shift(16, clsid2, "hex");
        hdr.write_shift(4, 68 + ps0.length);
        bufs.push(ps1);
    }
    return bconcat(bufs);
}
function parsenoop2(blob, length) {
    blob.read_shift(length);
    return null;
}
function writezeroes(n, o) {
    if (!o) o = new_buf(n);
    for(var j = 0; j < n; ++j)o.write_shift(1, 0);
    return o;
}
function parslurp(blob, length, cb) {
    var arr = [], target = blob.l + length;
    while(blob.l < target)arr.push(cb(blob, target - blob.l));
    if (target !== blob.l) throw new Error("Slurp error");
    return arr;
}
function parsebool(blob, length /*:number*/ ) {
    return blob.read_shift(length) === 0x1;
}
function writebool(v /*:any*/ , o) {
    if (!o) o = new_buf(2);
    o.write_shift(2, +!!v);
    return o;
}
function parseuint16(blob /*::, length:?number, opts:?any*/ ) {
    return blob.read_shift(2, "u");
}
function writeuint16(v /*:number*/ , o) {
    if (!o) o = new_buf(2);
    o.write_shift(2, v);
    return o;
}
function parseuint16a(blob, length /*:: :?number, opts:?any*/ ) {
    return parslurp(blob, length, parseuint16);
}
/* --- 2.5 Structures --- */ /* [MS-XLS] 2.5.10 Bes (boolean or error) */ function parse_Bes(blob /*::, length*/ ) {
    var v = blob.read_shift(1), t = blob.read_shift(1);
    return t === 0x01 ? v : v === 0x01;
}
function write_Bes(v, t /*:string*/ , o) {
    if (!o) o = new_buf(2);
    o.write_shift(1, t == "e" ? +v : +!!v);
    o.write_shift(1, t == "e" ? 1 : 0);
    return o;
}
/* [MS-XLS] 2.5.240 ShortXLUnicodeString */ function parse_ShortXLUnicodeString(blob, length, opts) {
    var cch = blob.read_shift(opts && opts.biff >= 12 ? 2 : 1);
    var encoding = "sbcs-cont";
    var cp = current_codepage;
    if (opts && opts.biff >= 8) current_codepage = 1200;
    if (!opts || opts.biff == 8) {
        var fHighByte = blob.read_shift(1);
        if (fHighByte) encoding = "dbcs-cont";
    } else if (opts.biff == 12) encoding = "wstr";
    if (opts.biff >= 2 && opts.biff <= 5) encoding = "cpstr";
    var o = cch ? blob.read_shift(cch, encoding) : "";
    current_codepage = cp;
    return o;
}
/* 2.5.293 XLUnicodeRichExtendedString */ function parse_XLUnicodeRichExtendedString(blob) {
    var cp = current_codepage;
    current_codepage = 1200;
    var cch = blob.read_shift(2), flags = blob.read_shift(1);
    var /*fHighByte = flags & 0x1,*/ fExtSt = flags & 0x4, fRichSt = flags & 0x8;
    var width = 1 + (flags & 0x1); // 0x0 -> utf8, 0x1 -> dbcs
    var cRun = 0, cbExtRst;
    var z = {};
    if (fRichSt) cRun = blob.read_shift(2);
    if (fExtSt) cbExtRst = blob.read_shift(4);
    var encoding = width == 2 ? "dbcs-cont" : "sbcs-cont";
    var msg = cch === 0 ? "" : blob.read_shift(cch, encoding);
    if (fRichSt) blob.l += 4 * cRun; //TODO: parse this
    if (fExtSt) blob.l += cbExtRst; //TODO: parse this
    z.t = msg;
    if (!fRichSt) {
        z.raw = "<t>" + z.t + "</t>";
        z.r = z.t;
    }
    current_codepage = cp;
    return z;
}
function write_XLUnicodeRichExtendedString(xlstr /*:: :XLString, opts*/ ) {
    var str = xlstr.t || "", nfmts = 1;
    var hdr = new_buf(3 + (nfmts > 1 ? 2 : 0));
    hdr.write_shift(2, str.length);
    hdr.write_shift(1, (nfmts > 1 ? 0x08 : 0x00) | 0x01);
    if (nfmts > 1) hdr.write_shift(2, nfmts);
    var otext = new_buf(2 * str.length);
    otext.write_shift(2 * str.length, str, "utf16le");
    var out = [
        hdr,
        otext
    ];
    return bconcat(out);
}
/* 2.5.296 XLUnicodeStringNoCch */ function parse_XLUnicodeStringNoCch(blob, cch, opts) {
    var retval;
    if (opts) {
        if (opts.biff >= 2 && opts.biff <= 5) return blob.read_shift(cch, "cpstr");
        if (opts.biff >= 12) return blob.read_shift(cch, "dbcs-cont");
    }
    var fHighByte = blob.read_shift(1);
    if (fHighByte === 0) retval = blob.read_shift(cch, "sbcs-cont");
    else retval = blob.read_shift(cch, "dbcs-cont");
    return retval;
}
/* 2.5.294 XLUnicodeString */ function parse_XLUnicodeString(blob, length, opts) {
    var cch = blob.read_shift(opts && opts.biff == 2 ? 1 : 2);
    if (cch === 0) {
        blob.l++;
        return "";
    }
    return parse_XLUnicodeStringNoCch(blob, cch, opts);
}
/* BIFF5 override */ function parse_XLUnicodeString2(blob, length, opts) {
    if (opts.biff > 5) return parse_XLUnicodeString(blob, length, opts);
    var cch = blob.read_shift(1);
    if (cch === 0) {
        blob.l++;
        return "";
    }
    return blob.read_shift(cch, opts.biff <= 4 || !blob.lens ? "cpstr" : "sbcs-cont");
}
/* TODO: BIFF5 and lower, codepage awareness */ function write_XLUnicodeString(str, opts, o) {
    if (!o) o = new_buf(3 + 2 * str.length);
    o.write_shift(2, str.length);
    o.write_shift(1, 1);
    o.write_shift(31, str, "utf16le");
    return o;
}
/* [MS-XLS] 2.5.61 ControlInfo */ function parse_ControlInfo(blob /*::, length, opts*/ ) {
    var flags = blob.read_shift(1);
    blob.l++;
    var accel = blob.read_shift(2);
    blob.l += 2;
    return [
        flags,
        accel
    ];
}
/* [MS-OSHARED] 2.3.7.6 URLMoniker TODO: flags */ function parse_URLMoniker(blob /*::, length, opts*/ ) {
    var len = blob.read_shift(4), start = blob.l;
    var extra = false;
    if (len > 24) {
        /* look ahead */ blob.l += len - 24;
        if (blob.read_shift(16) === "795881f43b1d7f48af2c825dc4852763") extra = true;
        blob.l = start;
    }
    var url = blob.read_shift((extra ? len - 24 : len) >> 1, "utf16le").replace(chr0, "");
    if (extra) blob.l += 24;
    return url;
}
/* [MS-OSHARED] 2.3.7.8 FileMoniker TODO: all fields */ function parse_FileMoniker(blob /*::, length*/ ) {
    var cAnti = blob.read_shift(2);
    var preamble = "";
    while(cAnti-- > 0)preamble += "../";
    var ansiPath = blob.read_shift(0, "lpstr-ansi");
    blob.l += 2; //var endServer = blob.read_shift(2);
    if (blob.read_shift(2) != 0xDEAD) throw new Error("Bad FileMoniker");
    var sz = blob.read_shift(4);
    if (sz === 0) return preamble + ansiPath.replace(/\\/g, "/");
    var bytes = blob.read_shift(4);
    if (blob.read_shift(2) != 3) throw new Error("Bad FileMoniker");
    var unicodePath = blob.read_shift(bytes >> 1, "utf16le").replace(chr0, "");
    return preamble + unicodePath;
}
/* [MS-OSHARED] 2.3.7.2 HyperlinkMoniker TODO: all the monikers */ function parse_HyperlinkMoniker(blob, length) {
    var clsid = blob.read_shift(16);
    length -= 16;
    switch(clsid){
        case "e0c9ea79f9bace118c8200aa004ba90b":
            return parse_URLMoniker(blob, length);
        case "0303000000000000c000000000000046":
            return parse_FileMoniker(blob, length);
        default:
            throw new Error("Unsupported Moniker " + clsid);
    }
}
/* [MS-OSHARED] 2.3.7.9 HyperlinkString */ function parse_HyperlinkString(blob /*::, length*/ ) {
    var len = blob.read_shift(4);
    var o = len > 0 ? blob.read_shift(len, "utf16le").replace(chr0, "") : "";
    return o;
}
function write_HyperlinkString(str /*:string*/ , o) {
    if (!o) o = new_buf(6 + str.length * 2);
    o.write_shift(4, 1 + str.length);
    for(var i = 0; i < str.length; ++i)o.write_shift(2, str.charCodeAt(i));
    o.write_shift(2, 0);
    return o;
}
/* [MS-OSHARED] 2.3.7.1 Hyperlink Object */ function parse_Hyperlink(blob, length) /*:Hyperlink*/ {
    var end = blob.l + length;
    var sVer = blob.read_shift(4);
    if (sVer !== 2) throw new Error("Unrecognized streamVersion: " + sVer);
    var flags = blob.read_shift(2);
    blob.l += 2;
    var displayName, targetFrameName, moniker, oleMoniker, Loc = "", guid, fileTime;
    if (flags & 0x0010) displayName = parse_HyperlinkString(blob, end - blob.l);
    if (flags & 0x0080) targetFrameName = parse_HyperlinkString(blob, end - blob.l);
    if ((flags & 0x0101) === 0x0101) moniker = parse_HyperlinkString(blob, end - blob.l);
    if ((flags & 0x0101) === 0x0001) oleMoniker = parse_HyperlinkMoniker(blob, end - blob.l);
    if (flags & 0x0008) Loc = parse_HyperlinkString(blob, end - blob.l);
    if (flags & 0x0020) guid = blob.read_shift(16);
    if (flags & 0x0040) fileTime = parse_FILETIME(blob /*, 8*/ );
    blob.l = end;
    var target = targetFrameName || moniker || oleMoniker || "";
    if (target && Loc) target += "#" + Loc;
    if (!target) target = "#" + Loc;
    if (flags & 0x0002 && target.charAt(0) == "/" && target.charAt(1) != "/") target = "file://" + target;
    var out = {
        Target: target
    } /*:any*/ ;
    if (guid) out.guid = guid;
    if (fileTime) out.time = fileTime;
    if (displayName) out.Tooltip = displayName;
    return out;
}
function write_Hyperlink(hl) {
    var out = new_buf(512), i = 0;
    var Target = hl.Target;
    if (Target.slice(0, 7) == "file://") Target = Target.slice(7);
    var hashidx = Target.indexOf("#");
    var F = hashidx > -1 ? 0x1f : 0x17;
    switch(Target.charAt(0)){
        case "#":
            F = 0x1c;
            break;
        case ".":
            F &= -3;
            break;
    }
    out.write_shift(4, 2);
    out.write_shift(4, F);
    var data = [
        8,
        6815827,
        6619237,
        4849780,
        83
    ];
    for(i = 0; i < data.length; ++i)out.write_shift(4, data[i]);
    if (F == 0x1C) {
        Target = Target.slice(1);
        write_HyperlinkString(Target, out);
    } else if (F & 0x02) {
        data = "e0 c9 ea 79 f9 ba ce 11 8c 82 00 aa 00 4b a9 0b".split(" ");
        for(i = 0; i < data.length; ++i)out.write_shift(1, parseInt(data[i], 16));
        var Pretarget = hashidx > -1 ? Target.slice(0, hashidx) : Target;
        out.write_shift(4, 2 * (Pretarget.length + 1));
        for(i = 0; i < Pretarget.length; ++i)out.write_shift(2, Pretarget.charCodeAt(i));
        out.write_shift(2, 0);
        if (F & 0x08) write_HyperlinkString(hashidx > -1 ? Target.slice(hashidx + 1) : "", out);
    } else {
        data = "03 03 00 00 00 00 00 00 c0 00 00 00 00 00 00 46".split(" ");
        for(i = 0; i < data.length; ++i)out.write_shift(1, parseInt(data[i], 16));
        var P = 0;
        while(Target.slice(P * 3, P * 3 + 3) == "../" || Target.slice(P * 3, P * 3 + 3) == "..\\")++P;
        out.write_shift(2, P);
        out.write_shift(4, Target.length - 3 * P + 1);
        for(i = 0; i < Target.length - 3 * P; ++i)out.write_shift(1, Target.charCodeAt(i + 3 * P) & 0xFF);
        out.write_shift(1, 0);
        out.write_shift(2, 0xFFFF);
        out.write_shift(2, 0xDEAD);
        for(i = 0; i < 6; ++i)out.write_shift(4, 0);
    }
    return out.slice(0, out.l);
}
/* 2.5.178 LongRGBA */ function parse_LongRGBA(blob /*::, length*/ ) {
    var r = blob.read_shift(1), g = blob.read_shift(1), b = blob.read_shift(1), a = blob.read_shift(1);
    return [
        r,
        g,
        b,
        a
    ];
}
/* 2.5.177 LongRGB */ function parse_LongRGB(blob, length) {
    var x = parse_LongRGBA(blob, length);
    x[3] = 0;
    return x;
}
/* [MS-XLS] 2.5.19 */ function parse_XLSCell(blob /*::, length*/ ) /*:Cell*/ {
    var rw = blob.read_shift(2); // 0-indexed
    var col = blob.read_shift(2);
    var ixfe = blob.read_shift(2);
    return {
        r: rw,
        c: col,
        ixfe: ixfe
    } /*:any*/ ;
}
function write_XLSCell(R /*:number*/ , C /*:number*/ , ixfe /*:?number*/ , o) {
    if (!o) o = new_buf(6);
    o.write_shift(2, R);
    o.write_shift(2, C);
    o.write_shift(2, ixfe || 0);
    return o;
}
/* [MS-XLS] 2.5.134 */ function parse_frtHeader(blob) {
    var rt = blob.read_shift(2);
    var flags = blob.read_shift(2); // TODO: parse these flags
    blob.l += 8;
    return {
        type: rt,
        flags: flags
    };
}
function parse_OptXLUnicodeString(blob, length, opts) {
    return length === 0 ? "" : parse_XLUnicodeString2(blob, length, opts);
}
/* [MS-XLS] 2.5.344 */ function parse_XTI(blob, length, opts) {
    var w = opts.biff > 8 ? 4 : 2;
    var iSupBook = blob.read_shift(w), itabFirst = blob.read_shift(w, "i"), itabLast = blob.read_shift(w, "i");
    return [
        iSupBook,
        itabFirst,
        itabLast
    ];
}
/* [MS-XLS] 2.5.218 */ function parse_RkRec(blob) {
    var ixfe = blob.read_shift(2);
    var RK = parse_RkNumber(blob);
    return [
        ixfe,
        RK
    ];
}
/* [MS-XLS] 2.5.1 */ function parse_AddinUdf(blob, length, opts) {
    blob.l += 4;
    length -= 4;
    var l = blob.l + length;
    var udfName = parse_ShortXLUnicodeString(blob, length, opts);
    var cb = blob.read_shift(2);
    l -= blob.l;
    if (cb !== l) throw new Error("Malformed AddinUdf: padding = " + l + " != " + cb);
    blob.l += cb;
    return udfName;
}
/* [MS-XLS] 2.5.209 TODO: Check sizes */ function parse_Ref8U(blob /*::, length*/ ) {
    var rwFirst = blob.read_shift(2);
    var rwLast = blob.read_shift(2);
    var colFirst = blob.read_shift(2);
    var colLast = blob.read_shift(2);
    return {
        s: {
            c: colFirst,
            r: rwFirst
        },
        e: {
            c: colLast,
            r: rwLast
        }
    };
}
function write_Ref8U(r /*:Range*/ , o) {
    if (!o) o = new_buf(8);
    o.write_shift(2, r.s.r);
    o.write_shift(2, r.e.r);
    o.write_shift(2, r.s.c);
    o.write_shift(2, r.e.c);
    return o;
}
/* [MS-XLS] 2.5.211 */ function parse_RefU(blob /*::, length*/ ) {
    var rwFirst = blob.read_shift(2);
    var rwLast = blob.read_shift(2);
    var colFirst = blob.read_shift(1);
    var colLast = blob.read_shift(1);
    return {
        s: {
            c: colFirst,
            r: rwFirst
        },
        e: {
            c: colLast,
            r: rwLast
        }
    };
}
/* [MS-XLS] 2.5.207 */ var parse_Ref = parse_RefU;
/* [MS-XLS] 2.5.143 */ function parse_FtCmo(blob /*::, length*/ ) {
    blob.l += 4;
    var ot = blob.read_shift(2);
    var id = blob.read_shift(2);
    var flags = blob.read_shift(2);
    blob.l += 12;
    return [
        id,
        ot,
        flags
    ];
}
/* [MS-XLS] 2.5.149 */ function parse_FtNts(blob) {
    var out = {};
    blob.l += 4;
    blob.l += 16; // GUID TODO
    out.fSharedNote = blob.read_shift(2);
    blob.l += 4;
    return out;
}
/* [MS-XLS] 2.5.142 */ function parse_FtCf(blob) {
    var out = {};
    blob.l += 4;
    blob.cf = blob.read_shift(2);
    return out;
}
/* [MS-XLS] 2.5.140 - 2.5.154 and friends */ function parse_FtSkip(blob) {
    blob.l += 2;
    blob.l += blob.read_shift(2);
}
var FtTab = {
    /*::[*/ 0x00: parse_FtSkip,
    /* FtEnd */ /*::[*/ 0x04: parse_FtSkip,
    /* FtMacro */ /*::[*/ 0x05: parse_FtSkip,
    /* FtButton */ /*::[*/ 0x06: parse_FtSkip,
    /* FtGmo */ /*::[*/ 0x07: parse_FtCf,
    /* FtCf */ /*::[*/ 0x08: parse_FtSkip,
    /* FtPioGrbit */ /*::[*/ 0x09: parse_FtSkip,
    /* FtPictFmla */ /*::[*/ 0x0A: parse_FtSkip,
    /* FtCbls */ /*::[*/ 0x0B: parse_FtSkip,
    /* FtRbo */ /*::[*/ 0x0C: parse_FtSkip,
    /* FtSbs */ /*::[*/ 0x0D: parse_FtNts,
    /* FtNts */ /*::[*/ 0x0E: parse_FtSkip,
    /* FtSbsFmla */ /*::[*/ 0x0F: parse_FtSkip,
    /* FtGboData */ /*::[*/ 0x10: parse_FtSkip,
    /* FtEdoData */ /*::[*/ 0x11: parse_FtSkip,
    /* FtRboData */ /*::[*/ 0x12: parse_FtSkip,
    /* FtCblsData */ /*::[*/ 0x13: parse_FtSkip,
    /* FtLbsData */ /*::[*/ 0x14: parse_FtSkip,
    /* FtCblsFmla */ /*::[*/ 0x15: parse_FtCmo
};
function parse_FtArray(blob, length /*::, ot*/ ) {
    var tgt = blob.l + length;
    var fts = [];
    while(blob.l < tgt){
        var ft = blob.read_shift(2);
        blob.l -= 2;
        try {
            fts.push(FtTab[ft](blob, tgt - blob.l));
        } catch (e) {
            blob.l = tgt;
            return fts;
        }
    }
    if (blob.l != tgt) blob.l = tgt; //throw new Error("bad Object Ft-sequence");
    return fts;
}
/* --- 2.4 Records --- */ /* [MS-XLS] 2.4.21 */ function parse_BOF(blob, length) {
    var o = {
        BIFFVer: 0,
        dt: 0
    };
    o.BIFFVer = blob.read_shift(2);
    length -= 2;
    if (length >= 2) {
        o.dt = blob.read_shift(2);
        blob.l -= 2;
    }
    switch(o.BIFFVer){
        case 0x0600:
        /* BIFF8 */ case 0x0500:
        /* BIFF5 */ case 0x0400:
        /* BIFF4 */ case 0x0300:
        /* BIFF3 */ case 0x0200:
        /* BIFF2 */ case 0x0002:
        case 0x0007:
            break;
        default:
            if (length > 6) throw new Error("Unexpected BIFF Ver " + o.BIFFVer);
    }
    blob.read_shift(length);
    return o;
}
function write_BOF(wb /*:Workbook*/ , t /*:number*/ , o) {
    var h = 0x0600, w = 16;
    switch(o.bookType){
        case "biff8":
            break;
        case "biff5":
            h = 0x0500;
            w = 8;
            break;
        case "biff4":
            h = 0x0004;
            w = 6;
            break;
        case "biff3":
            h = 0x0003;
            w = 6;
            break;
        case "biff2":
            h = 0x0002;
            w = 4;
            break;
        case "xla":
            break;
        default:
            throw new Error("unsupported BIFF version");
    }
    var out = new_buf(w);
    out.write_shift(2, h);
    out.write_shift(2, t);
    if (w > 4) out.write_shift(2, 0x7262);
    if (w > 6) out.write_shift(2, 0x07CD);
    if (w > 8) {
        out.write_shift(2, 0xC009);
        out.write_shift(2, 0x0001);
        out.write_shift(2, 0x0706);
        out.write_shift(2, 0x0000);
    }
    return out;
}
/* [MS-XLS] 2.4.146 */ function parse_InterfaceHdr(blob, length) {
    if (length === 0) return 0x04b0;
    blob.read_shift(2);
    return 0x04b0;
}
/* [MS-XLS] 2.4.349 */ function parse_WriteAccess(blob, length, opts) {
    if (opts.enc) {
        blob.l += length;
        return "";
    }
    var l = blob.l;
    // TODO: make sure XLUnicodeString doesnt overrun
    var UserName = parse_XLUnicodeString2(blob, 0, opts);
    blob.read_shift(length + l - blob.l);
    return UserName;
}
function write_WriteAccess(s /*:string*/ , opts) {
    var b8 = !opts || opts.biff == 8;
    var o = new_buf(b8 ? 112 : 54);
    o.write_shift(opts.biff == 8 ? 2 : 1, 7);
    if (b8) o.write_shift(1, 0);
    o.write_shift(4, 0x33336853);
    o.write_shift(4, 0x00534A74 | (b8 ? 0 : 0x20000000));
    while(o.l < o.length)o.write_shift(1, b8 ? 0 : 32);
    return o;
}
/* [MS-XLS] 2.4.351 */ function parse_WsBool(blob, length, opts) {
    var flags = opts && opts.biff == 8 || length == 2 ? blob.read_shift(2) : (blob.l += length, 0);
    return {
        fDialog: flags & 0x10,
        fBelow: flags & 0x40,
        fRight: flags & 0x80
    };
}
/* [MS-XLS] 2.4.28 */ function parse_BoundSheet8(blob, length, opts) {
    var pos = blob.read_shift(4);
    var hidden = blob.read_shift(1) & 0x03;
    var dt = blob.read_shift(1);
    switch(dt){
        case 0:
            dt = "Worksheet";
            break;
        case 1:
            dt = "Macrosheet";
            break;
        case 2:
            dt = "Chartsheet";
            break;
        case 6:
            dt = "VBAModule";
            break;
    }
    var name = parse_ShortXLUnicodeString(blob, 0, opts);
    if (name.length === 0) name = "Sheet1";
    return {
        pos: pos,
        hs: hidden,
        dt: dt,
        name: name
    };
}
function write_BoundSheet8(data, opts) {
    var w = !opts || opts.biff >= 8 ? 2 : 1;
    var o = new_buf(8 + w * data.name.length);
    o.write_shift(4, data.pos);
    o.write_shift(1, data.hs || 0);
    o.write_shift(1, data.dt);
    o.write_shift(1, data.name.length);
    if (opts.biff >= 8) o.write_shift(1, 1);
    o.write_shift(w * data.name.length, data.name, opts.biff < 8 ? "sbcs" : "utf16le");
    var out = o.slice(0, o.l);
    out.l = o.l;
    return out;
}
/* [MS-XLS] 2.4.265 TODO */ function parse_SST(blob, length) /*:SST*/ {
    var end = blob.l + length;
    var cnt = blob.read_shift(4);
    var ucnt = blob.read_shift(4);
    var strs /*:SST*/  = [];
    for(var i = 0; i != ucnt && blob.l < end; ++i)strs.push(parse_XLUnicodeRichExtendedString(blob));
    strs.Count = cnt;
    strs.Unique = ucnt;
    return strs;
}
function write_SST(sst, opts) {
    var header = new_buf(8);
    header.write_shift(4, sst.Count);
    header.write_shift(4, sst.Unique);
    var strs = [];
    for(var j = 0; j < sst.length; ++j)strs[j] = write_XLUnicodeRichExtendedString(sst[j], opts);
    var o = bconcat([
        header
    ].concat(strs));
    /*::(*/ o /*:: :any)*/ .parts = [
        header.length
    ].concat(strs.map(function(str) {
        return str.length;
    }));
    return o;
}
/* [MS-XLS] 2.4.107 */ function parse_ExtSST(blob, length) {
    var extsst = {};
    extsst.dsst = blob.read_shift(2);
    blob.l += length - 2;
    return extsst;
}
/* [MS-XLS] 2.4.221 TODO: check BIFF2-4 */ function parse_Row(blob) {
    var z = {} /*:any*/ ;
    z.r = blob.read_shift(2);
    z.c = blob.read_shift(2);
    z.cnt = blob.read_shift(2) - z.c;
    var miyRw = blob.read_shift(2);
    blob.l += 4; // reserved(2), unused(2)
    var flags = blob.read_shift(1); // various flags
    blob.l += 3; // reserved(8), ixfe(12), flags(4)
    if (flags & 0x07) z.level = flags & 0x07;
    // collapsed: flags & 0x10
    if (flags & 0x20) z.hidden = true;
    if (flags & 0x40) z.hpt = miyRw / 20;
    return z;
}
/* [MS-XLS] 2.4.125 */ function parse_ForceFullCalculation(blob) {
    var header = parse_frtHeader(blob);
    if (header.type != 0x08A3) throw new Error("Invalid Future Record " + header.type);
    var fullcalc = blob.read_shift(4);
    return fullcalc !== 0x0;
}
/* [MS-XLS] 2.4.215 rt */ function parse_RecalcId(blob) {
    blob.read_shift(2);
    return blob.read_shift(4);
}
/* [MS-XLS] 2.4.87 */ function parse_DefaultRowHeight(blob, length, opts) {
    var f = 0;
    if (!(opts && opts.biff == 2)) f = blob.read_shift(2);
    var miyRw = blob.read_shift(2);
    if (opts && opts.biff == 2) {
        f = 1 - (miyRw >> 15);
        miyRw &= 0x7fff;
    }
    var fl = {
        Unsynced: f & 1,
        DyZero: (f & 2) >> 1,
        ExAsc: (f & 4) >> 2,
        ExDsc: (f & 8) >> 3
    };
    return [
        fl,
        miyRw
    ];
}
/* [MS-XLS] 2.4.345 TODO */ function parse_Window1(blob) {
    var xWn = blob.read_shift(2), yWn = blob.read_shift(2), dxWn = blob.read_shift(2), dyWn = blob.read_shift(2);
    var flags = blob.read_shift(2), iTabCur = blob.read_shift(2), iTabFirst = blob.read_shift(2);
    var ctabSel = blob.read_shift(2), wTabRatio = blob.read_shift(2);
    return {
        Pos: [
            xWn,
            yWn
        ],
        Dim: [
            dxWn,
            dyWn
        ],
        Flags: flags,
        CurTab: iTabCur,
        FirstTab: iTabFirst,
        Selected: ctabSel,
        TabRatio: wTabRatio
    };
}
function write_Window1() {
    var o = new_buf(18);
    o.write_shift(2, 0);
    o.write_shift(2, 0);
    o.write_shift(2, 0x7260);
    o.write_shift(2, 0x44c0);
    o.write_shift(2, 0x38);
    o.write_shift(2, 0);
    o.write_shift(2, 0);
    o.write_shift(2, 1);
    o.write_shift(2, 0x01f4);
    return o;
}
/* [MS-XLS] 2.4.346 TODO */ function parse_Window2(blob, length, opts) {
    if (opts && opts.biff >= 2 && opts.biff < 5) return {};
    var f = blob.read_shift(2);
    return {
        RTL: f & 0x40
    };
}
function write_Window2(view) {
    var o = new_buf(18), f = 0x6b6;
    if (view && view.RTL) f |= 0x40;
    o.write_shift(2, f);
    o.write_shift(4, 0);
    o.write_shift(4, 64);
    o.write_shift(4, 0);
    o.write_shift(4, 0);
    return o;
}
/* [MS-XLS] 2.4.189 TODO */ function parse_Pane() {}
/* [MS-XLS] 2.4.122 TODO */ function parse_Font(blob, length, opts) {
    var o /*:any*/  = {
        dyHeight: blob.read_shift(2),
        fl: blob.read_shift(2)
    };
    switch(opts && opts.biff || 8){
        case 2:
            break;
        case 3:
        case 4:
            blob.l += 2;
            break;
        default:
            blob.l += 10;
            break;
    }
    o.name = parse_ShortXLUnicodeString(blob, 0, opts);
    return o;
}
function write_Font(data, opts) {
    var name = data.name || "Arial";
    var b5 = opts && opts.biff == 5, w = b5 ? 15 + name.length : 16 + 2 * name.length;
    var o = new_buf(w);
    o.write_shift(2, (data.sz || 12) * 20);
    o.write_shift(4, 0);
    o.write_shift(2, 400);
    o.write_shift(4, 0);
    o.write_shift(2, 0);
    o.write_shift(1, name.length);
    if (!b5) o.write_shift(1, 1);
    o.write_shift((b5 ? 1 : 2) * name.length, name, b5 ? "sbcs" : "utf16le");
    return o;
}
/* [MS-XLS] 2.4.149 */ function parse_LabelSst(blob) {
    var cell = parse_XLSCell(blob);
    cell.isst = blob.read_shift(4);
    return cell;
}
function write_LabelSst(R /*:number*/ , C /*:number*/ , v /*:number*/ , os /*:number*/  /*::, opts*/ ) {
    var o = new_buf(10);
    write_XLSCell(R, C, os, o);
    o.write_shift(4, v);
    return o;
}
/* [MS-XLS] 2.4.148 */ function parse_Label(blob, length, opts) {
    if (opts.biffguess && opts.biff == 2) opts.biff = 5;
    var target = blob.l + length;
    var cell = parse_XLSCell(blob, 6);
    if (opts.biff == 2) blob.l++;
    var str = parse_XLUnicodeString(blob, target - blob.l, opts);
    cell.val = str;
    return cell;
}
function write_Label(R /*:number*/ , C /*:number*/ , v /*:string*/ , os /*:number*/ , opts) {
    var b8 = !opts || opts.biff == 8;
    var o = new_buf(8 + +b8 + (1 + b8) * v.length);
    write_XLSCell(R, C, os, o);
    o.write_shift(2, v.length);
    if (b8) o.write_shift(1, 1);
    o.write_shift((1 + b8) * v.length, v, b8 ? "utf16le" : "sbcs");
    return o;
}
/* [MS-XLS] 2.4.126 Number Formats */ function parse_Format(blob, length, opts) {
    var numFmtId = blob.read_shift(2);
    var fmtstr = parse_XLUnicodeString2(blob, 0, opts);
    return [
        numFmtId,
        fmtstr
    ];
}
function write_Format(i /*:number*/ , f /*:string*/ , opts, o) {
    var b5 = opts && opts.biff == 5;
    if (!o) o = new_buf(b5 ? 3 + f.length : 5 + 2 * f.length);
    o.write_shift(2, i);
    o.write_shift(b5 ? 1 : 2, f.length);
    if (!b5) o.write_shift(1, 1);
    o.write_shift((b5 ? 1 : 2) * f.length, f, b5 ? "sbcs" : "utf16le");
    var out = o.length > o.l ? o.slice(0, o.l) : o;
    if (out.l == null) out.l = out.length;
    return out;
}
var parse_BIFF2Format = parse_XLUnicodeString2;
/* [MS-XLS] 2.4.90 */ function parse_Dimensions(blob, length, opts) {
    var end = blob.l + length;
    var w = opts.biff == 8 || !opts.biff ? 4 : 2;
    var r = blob.read_shift(w), R = blob.read_shift(w);
    var c = blob.read_shift(2), C = blob.read_shift(2);
    blob.l = end;
    return {
        s: {
            r: r,
            c: c
        },
        e: {
            r: R,
            c: C
        }
    };
}
function write_Dimensions(range, opts) {
    var w = opts.biff == 8 || !opts.biff ? 4 : 2;
    var o = new_buf(2 * w + 6);
    o.write_shift(w, range.s.r);
    o.write_shift(w, range.e.r + 1);
    o.write_shift(2, range.s.c);
    o.write_shift(2, range.e.c + 1);
    o.write_shift(2, 0);
    return o;
}
/* [MS-XLS] 2.4.220 */ function parse_RK(blob) {
    var rw = blob.read_shift(2), col = blob.read_shift(2);
    var rkrec = parse_RkRec(blob);
    return {
        r: rw,
        c: col,
        ixfe: rkrec[0],
        rknum: rkrec[1]
    };
}
/* [MS-XLS] 2.4.175 */ function parse_MulRk(blob, length) {
    var target = blob.l + length - 2;
    var rw = blob.read_shift(2), col = blob.read_shift(2);
    var rkrecs = [];
    while(blob.l < target)rkrecs.push(parse_RkRec(blob));
    if (blob.l !== target) throw new Error("MulRK read error");
    var lastcol = blob.read_shift(2);
    if (rkrecs.length != lastcol - col + 1) throw new Error("MulRK length mismatch");
    return {
        r: rw,
        c: col,
        C: lastcol,
        rkrec: rkrecs
    };
}
/* [MS-XLS] 2.4.174 */ function parse_MulBlank(blob, length) {
    var target = blob.l + length - 2;
    var rw = blob.read_shift(2), col = blob.read_shift(2);
    var ixfes = [];
    while(blob.l < target)ixfes.push(blob.read_shift(2));
    if (blob.l !== target) throw new Error("MulBlank read error");
    var lastcol = blob.read_shift(2);
    if (ixfes.length != lastcol - col + 1) throw new Error("MulBlank length mismatch");
    return {
        r: rw,
        c: col,
        C: lastcol,
        ixfe: ixfes
    };
}
/* [MS-XLS] 2.5.20 2.5.249 TODO: interpret values here */ function parse_CellStyleXF(blob, length, style, opts) {
    var o = {};
    var a = blob.read_shift(4), b = blob.read_shift(4);
    var c = blob.read_shift(4), d = blob.read_shift(2);
    o.patternType = XLSFillPattern[c >> 26];
    if (!opts.cellStyles) return o;
    o.alc = a & 0x07;
    o.fWrap = a >> 3 & 0x01;
    o.alcV = a >> 4 & 0x07;
    o.fJustLast = a >> 7 & 0x01;
    o.trot = a >> 8 & 0xFF;
    o.cIndent = a >> 16 & 0x0F;
    o.fShrinkToFit = a >> 20 & 0x01;
    o.iReadOrder = a >> 22 & 0x02;
    o.fAtrNum = a >> 26 & 0x01;
    o.fAtrFnt = a >> 27 & 0x01;
    o.fAtrAlc = a >> 28 & 0x01;
    o.fAtrBdr = a >> 29 & 0x01;
    o.fAtrPat = a >> 30 & 0x01;
    o.fAtrProt = a >> 31 & 0x01;
    o.dgLeft = b & 0x0F;
    o.dgRight = b >> 4 & 0x0F;
    o.dgTop = b >> 8 & 0x0F;
    o.dgBottom = b >> 12 & 0x0F;
    o.icvLeft = b >> 16 & 0x7F;
    o.icvRight = b >> 23 & 0x7F;
    o.grbitDiag = b >> 30 & 0x03;
    o.icvTop = c & 0x7F;
    o.icvBottom = c >> 7 & 0x7F;
    o.icvDiag = c >> 14 & 0x7F;
    o.dgDiag = c >> 21 & 0x0F;
    o.icvFore = d & 0x7F;
    o.icvBack = d >> 7 & 0x7F;
    o.fsxButton = d >> 14 & 0x01;
    return o;
}
//function parse_CellXF(blob, length, opts) {return parse_CellStyleXF(blob,length,0, opts);}
//function parse_StyleXF(blob, length, opts) {return parse_CellStyleXF(blob,length,1, opts);}
/* [MS-XLS] 2.4.353 TODO: actually do this right */ function parse_XF(blob, length, opts) {
    var o = {};
    o.ifnt = blob.read_shift(2);
    o.numFmtId = blob.read_shift(2);
    o.flags = blob.read_shift(2);
    o.fStyle = o.flags >> 2 & 0x01;
    length -= 6;
    o.data = parse_CellStyleXF(blob, length, o.fStyle, opts);
    return o;
}
function write_XF(data, ixfeP, opts, o) {
    var b5 = opts && opts.biff == 5;
    if (!o) o = new_buf(b5 ? 16 : 20);
    o.write_shift(2, 0);
    if (data.style) {
        o.write_shift(2, data.numFmtId || 0);
        o.write_shift(2, 0xFFF4);
    } else {
        o.write_shift(2, data.numFmtId || 0);
        o.write_shift(2, ixfeP << 4);
    }
    var f = 0;
    if (data.numFmtId > 0 && b5) f |= 0x0400;
    o.write_shift(4, f);
    o.write_shift(4, 0);
    if (!b5) o.write_shift(4, 0);
    o.write_shift(2, 0);
    return o;
}
/* [MS-XLS] 2.4.134 */ function parse_Guts(blob) {
    blob.l += 4;
    var out = [
        blob.read_shift(2),
        blob.read_shift(2)
    ];
    if (out[0] !== 0) out[0]--;
    if (out[1] !== 0) out[1]--;
    if (out[0] > 7 || out[1] > 7) throw new Error("Bad Gutters: " + out.join("|"));
    return out;
}
function write_Guts(guts /*:Array<number>*/ ) {
    var o = new_buf(8);
    o.write_shift(4, 0);
    o.write_shift(2, guts[0] ? guts[0] + 1 : 0);
    o.write_shift(2, guts[1] ? guts[1] + 1 : 0);
    return o;
}
/* [MS-XLS] 2.4.24 */ function parse_BoolErr(blob, length, opts) {
    var cell = parse_XLSCell(blob, 6);
    if (opts.biff == 2 || length == 9) ++blob.l;
    var val = parse_Bes(blob, 2);
    cell.val = val;
    cell.t = val === true || val === false ? "b" : "e";
    return cell;
}
function write_BoolErr(R /*:number*/ , C /*:number*/ , v, os /*:number*/ , opts, t /*:string*/ ) {
    var o = new_buf(8);
    write_XLSCell(R, C, os, o);
    write_Bes(v, t, o);
    return o;
}
/* [MS-XLS] 2.4.180 Number */ function parse_Number(blob, length, opts) {
    if (opts.biffguess && opts.biff == 2) opts.biff = 5;
    var cell = parse_XLSCell(blob, 6);
    var xnum = parse_Xnum(blob, 8);
    cell.val = xnum;
    return cell;
}
function write_Number(R /*:number*/ , C /*:number*/ , v, os /*:: :number, opts*/ ) {
    var o = new_buf(14);
    write_XLSCell(R, C, os, o);
    write_Xnum(v, o);
    return o;
}
var parse_XLHeaderFooter = parse_OptXLUnicodeString; // TODO: parse 2.4.136
/* [MS-XLS] 2.4.271 */ function parse_SupBook(blob, length, opts) {
    var end = blob.l + length;
    var ctab = blob.read_shift(2);
    var cch = blob.read_shift(2);
    opts.sbcch = cch;
    if (cch == 0x0401 || cch == 0x3A01) return [
        cch,
        ctab
    ];
    if (cch < 0x01 || cch > 0xff) throw new Error("Unexpected SupBook type: " + cch);
    var virtPath = parse_XLUnicodeStringNoCch(blob, cch);
    /* TODO: 2.5.277 Virtual Path */ var rgst = [];
    while(end > blob.l)rgst.push(parse_XLUnicodeString(blob));
    return [
        cch,
        ctab,
        virtPath,
        rgst
    ];
}
/* [MS-XLS] 2.4.105 TODO */ function parse_ExternName(blob, length, opts) {
    var flags = blob.read_shift(2);
    var body;
    var o = {
        fBuiltIn: flags & 0x01,
        fWantAdvise: flags >>> 1 & 0x01,
        fWantPict: flags >>> 2 & 0x01,
        fOle: flags >>> 3 & 0x01,
        fOleLink: flags >>> 4 & 0x01,
        cf: flags >>> 5 & 0x3FF,
        fIcon: flags >>> 15 & 0x01
    } /*:any*/ ;
    if (opts.sbcch === 0x3A01) body = parse_AddinUdf(blob, length - 2, opts);
    //else throw new Error("unsupported SupBook cch: " + opts.sbcch);
    o.body = body || blob.read_shift(length - 2);
    if (typeof body === "string") o.Name = body;
    return o;
}
/* [MS-XLS] 2.4.150 TODO */ var XLSLblBuiltIn = [
    "_xlnm.Consolidate_Area",
    "_xlnm.Auto_Open",
    "_xlnm.Auto_Close",
    "_xlnm.Extract",
    "_xlnm.Database",
    "_xlnm.Criteria",
    "_xlnm.Print_Area",
    "_xlnm.Print_Titles",
    "_xlnm.Recorder",
    "_xlnm.Data_Form",
    "_xlnm.Auto_Activate",
    "_xlnm.Auto_Deactivate",
    "_xlnm.Sheet_Title",
    "_xlnm._FilterDatabase"
];
function parse_Lbl(blob, length, opts) {
    var target = blob.l + length;
    var flags = blob.read_shift(2);
    var chKey = blob.read_shift(1);
    var cch = blob.read_shift(1);
    var cce = blob.read_shift(opts && opts.biff == 2 ? 1 : 2);
    var itab = 0;
    if (!opts || opts.biff >= 5) {
        if (opts.biff != 5) blob.l += 2;
        itab = blob.read_shift(2);
        if (opts.biff == 5) blob.l += 2;
        blob.l += 4;
    }
    var name = parse_XLUnicodeStringNoCch(blob, cch, opts);
    if (flags & 0x20) name = XLSLblBuiltIn[name.charCodeAt(0)];
    var npflen = target - blob.l;
    if (opts && opts.biff == 2) --npflen;
    /*jshint -W018 */ var rgce = target == blob.l || cce === 0 || !(npflen > 0) ? [] : parse_NameParsedFormula(blob, npflen, opts, cce);
    /*jshint +W018 */ return {
        chKey: chKey,
        Name: name,
        itab: itab,
        rgce: rgce
    };
}
/* [MS-XLS] 2.4.106 TODO: verify filename encoding */ function parse_ExternSheet(blob, length, opts) {
    if (opts.biff < 8) return parse_BIFF5ExternSheet(blob, length, opts);
    var o = [], target = blob.l + length, len = blob.read_shift(opts.biff > 8 ? 4 : 2);
    while(len-- !== 0)o.push(parse_XTI(blob, opts.biff > 8 ? 12 : 6, opts));
    // [iSupBook, itabFirst, itabLast];
    if (blob.l != target) throw new Error("Bad ExternSheet: " + blob.l + " != " + target);
    return o;
}
function parse_BIFF5ExternSheet(blob, length, opts) {
    if (blob[blob.l + 1] == 0x03) blob[blob.l]++;
    var o = parse_ShortXLUnicodeString(blob, length, opts);
    return o.charCodeAt(0) == 0x03 ? o.slice(1) : o;
}
/* [MS-XLS] 2.4.176 TODO: check older biff */ function parse_NameCmt(blob, length, opts) {
    if (opts.biff < 8) {
        blob.l += length;
        return;
    }
    var cchName = blob.read_shift(2);
    var cchComment = blob.read_shift(2);
    var name = parse_XLUnicodeStringNoCch(blob, cchName, opts);
    var comment = parse_XLUnicodeStringNoCch(blob, cchComment, opts);
    return [
        name,
        comment
    ];
}
/* [MS-XLS] 2.4.260 */ function parse_ShrFmla(blob, length, opts) {
    var ref = parse_RefU(blob, 6);
    blob.l++;
    var cUse = blob.read_shift(1);
    length -= 8;
    return [
        parse_SharedParsedFormula(blob, length, opts),
        cUse,
        ref
    ];
}
/* [MS-XLS] 2.4.4 TODO */ function parse_Array(blob, length, opts) {
    var ref = parse_Ref(blob, 6);
    /* TODO: fAlwaysCalc */ switch(opts.biff){
        case 2:
            blob.l++;
            length -= 7;
            break;
        case 3:
        case 4:
            blob.l += 2;
            length -= 8;
            break;
        default:
            blob.l += 6;
            length -= 12;
    }
    return [
        ref,
        parse_ArrayParsedFormula(blob, length, opts, ref)
    ];
}
/* [MS-XLS] 2.4.173 */ function parse_MTRSettings(blob) {
    var fMTREnabled = blob.read_shift(4) !== 0x00;
    var fUserSetThreadCount = blob.read_shift(4) !== 0x00;
    var cUserThreadCount = blob.read_shift(4);
    return [
        fMTREnabled,
        fUserSetThreadCount,
        cUserThreadCount
    ];
}
/* [MS-XLS] 2.5.186 TODO: BIFF5 */ function parse_NoteSh(blob, length, opts) {
    if (opts.biff < 8) return;
    var row = blob.read_shift(2), col = blob.read_shift(2);
    var flags = blob.read_shift(2), idObj = blob.read_shift(2);
    var stAuthor = parse_XLUnicodeString2(blob, 0, opts);
    if (opts.biff < 8) blob.read_shift(1);
    return [
        {
            r: row,
            c: col
        },
        stAuthor,
        idObj,
        flags
    ];
}
/* [MS-XLS] 2.4.179 */ function parse_Note(blob, length, opts) {
    /* TODO: Support revisions */ return parse_NoteSh(blob, length, opts);
}
/* [MS-XLS] 2.4.168 */ function parse_MergeCells(blob, length) /*:Array<Range>*/ {
    var merges /*:Array<Range>*/  = [];
    var cmcs = blob.read_shift(2);
    while(cmcs--)merges.push(parse_Ref8U(blob, length));
    return merges;
}
function write_MergeCells(merges /*:Array<Range>*/ ) {
    var o = new_buf(2 + merges.length * 8);
    o.write_shift(2, merges.length);
    for(var i = 0; i < merges.length; ++i)write_Ref8U(merges[i], o);
    return o;
}
/* [MS-XLS] 2.4.181 TODO: parse all the things! */ function parse_Obj(blob, length, opts) {
    if (opts && opts.biff < 8) return parse_BIFF5Obj(blob, length, opts);
    var cmo = parse_FtCmo(blob, 22); // id, ot, flags
    var fts = parse_FtArray(blob, length - 22, cmo[1]);
    return {
        cmo: cmo,
        ft: fts
    };
}
/* from older spec */ var parse_BIFF5OT = {
    0x08: function(blob, length) {
        var tgt = blob.l + length;
        blob.l += 10; // todo
        var cf = blob.read_shift(2);
        blob.l += 4;
        blob.l += 2; //var cbPictFmla = blob.read_shift(2);
        blob.l += 2;
        blob.l += 2; //var grbit = blob.read_shift(2);
        blob.l += 4;
        var cchName = blob.read_shift(1);
        blob.l += cchName; // TODO: stName
        blob.l = tgt; // TODO: fmla
        return {
            fmt: cf
        };
    }
};
function parse_BIFF5Obj(blob, length, opts) {
    blob.l += 4; //var cnt = blob.read_shift(4);
    var ot = blob.read_shift(2);
    var id = blob.read_shift(2);
    var grbit = blob.read_shift(2);
    blob.l += 2; //var colL = blob.read_shift(2);
    blob.l += 2; //var dxL = blob.read_shift(2);
    blob.l += 2; //var rwT = blob.read_shift(2);
    blob.l += 2; //var dyT = blob.read_shift(2);
    blob.l += 2; //var colR = blob.read_shift(2);
    blob.l += 2; //var dxR = blob.read_shift(2);
    blob.l += 2; //var rwB = blob.read_shift(2);
    blob.l += 2; //var dyB = blob.read_shift(2);
    blob.l += 2; //var cbMacro = blob.read_shift(2);
    blob.l += 6;
    length -= 36;
    var fts = [];
    fts.push((parse_BIFF5OT[ot] || parsenoop)(blob, length, opts));
    return {
        cmo: [
            id,
            ot,
            grbit
        ],
        ft: fts
    };
}
/* [MS-XLS] 2.4.329 TODO: parse properly */ function parse_TxO(blob, length, opts) {
    var s = blob.l;
    var texts = "";
    try {
        blob.l += 4;
        var ot = (opts.lastobj || {
            cmo: [
                0,
                0
            ]
        }).cmo[1];
        var controlInfo; // eslint-disable-line no-unused-vars
        if ([
            0,
            5,
            7,
            11,
            12,
            14
        ].indexOf(ot) == -1) blob.l += 6;
        else controlInfo = parse_ControlInfo(blob, 6, opts); // eslint-disable-line no-unused-vars
        var cchText = blob.read_shift(2);
        /*var cbRuns = */ blob.read_shift(2);
        /*var ifntEmpty = */ parseuint16(blob, 2);
        var len = blob.read_shift(2);
        blob.l += len;
        //var fmla = parse_ObjFmla(blob, s + length - blob.l);
        for(var i = 1; i < blob.lens.length - 1; ++i){
            if (blob.l - s != blob.lens[i]) throw new Error("TxO: bad continue record");
            var hdr = blob[blob.l];
            var t = parse_XLUnicodeStringNoCch(blob, blob.lens[i + 1] - blob.lens[i] - 1);
            texts += t;
            if (texts.length >= (hdr ? cchText : 2 * cchText)) break;
        }
        if (texts.length !== cchText && texts.length !== cchText * 2) throw new Error("cchText: " + cchText + " != " + texts.length);
        blob.l = s + length;
        /* [MS-XLS] 2.5.272 TxORuns */ //	var rgTxoRuns = [];
        //	for(var j = 0; j != cbRuns/8-1; ++j) blob.l += 8;
        //	var cchText2 = blob.read_shift(2);
        //	if(cchText2 !== cchText) throw new Error("TxOLastRun mismatch: " + cchText2 + " " + cchText);
        //	blob.l += 6;
        //	if(s + length != blob.l) throw new Error("TxO " + (s + length) + ", at " + blob.l);
        return {
            t: texts
        };
    } catch (e) {
        blob.l = s + length;
        return {
            t: texts
        };
    }
}
/* [MS-XLS] 2.4.140 */ function parse_HLink(blob, length) {
    var ref = parse_Ref8U(blob, 8);
    blob.l += 16; /* CLSID */ 
    var hlink = parse_Hyperlink(blob, length - 24);
    return [
        ref,
        hlink
    ];
}
function write_HLink(hl) {
    var O = new_buf(24);
    var ref = decode_cell(hl[0]);
    O.write_shift(2, ref.r);
    O.write_shift(2, ref.r);
    O.write_shift(2, ref.c);
    O.write_shift(2, ref.c);
    var clsid = "d0 c9 ea 79 f9 ba ce 11 8c 82 00 aa 00 4b a9 0b".split(" ");
    for(var i = 0; i < 16; ++i)O.write_shift(1, parseInt(clsid[i], 16));
    return bconcat([
        O,
        write_Hyperlink(hl[1])
    ]);
}
/* [MS-XLS] 2.4.141 */ function parse_HLinkTooltip(blob, length) {
    blob.read_shift(2);
    var ref = parse_Ref8U(blob, 8);
    var wzTooltip = blob.read_shift((length - 10) / 2, "dbcs-cont");
    wzTooltip = wzTooltip.replace(chr0, "");
    return [
        ref,
        wzTooltip
    ];
}
function write_HLinkTooltip(hl) {
    var TT = hl[1].Tooltip;
    var O = new_buf(10 + 2 * (TT.length + 1));
    O.write_shift(2, 0x0800);
    var ref = decode_cell(hl[0]);
    O.write_shift(2, ref.r);
    O.write_shift(2, ref.r);
    O.write_shift(2, ref.c);
    O.write_shift(2, ref.c);
    for(var i = 0; i < TT.length; ++i)O.write_shift(2, TT.charCodeAt(i));
    O.write_shift(2, 0);
    return O;
}
/* [MS-XLS] 2.4.63 */ function parse_Country(blob) /*:[string|number, string|number]*/ {
    var o = [
        0,
        0
    ], d;
    d = blob.read_shift(2);
    o[0] = CountryEnum[d] || d;
    d = blob.read_shift(2);
    o[1] = CountryEnum[d] || d;
    return o;
}
function write_Country(o) {
    if (!o) o = new_buf(4);
    o.write_shift(2, 0x01);
    o.write_shift(2, 0x01);
    return o;
}
/* [MS-XLS] 2.4.50 ClrtClient */ function parse_ClrtClient(blob) {
    var ccv = blob.read_shift(2);
    var o = [];
    while(ccv-- > 0)o.push(parse_LongRGB(blob, 8));
    return o;
}
/* [MS-XLS] 2.4.188 */ function parse_Palette(blob) {
    var ccv = blob.read_shift(2);
    var o = [];
    while(ccv-- > 0)o.push(parse_LongRGB(blob, 8));
    return o;
}
/* [MS-XLS] 2.4.354 */ function parse_XFCRC(blob) {
    blob.l += 2;
    var o = {
        cxfs: 0,
        crc: 0
    };
    o.cxfs = blob.read_shift(2);
    o.crc = blob.read_shift(4);
    return o;
}
/* [MS-XLS] 2.4.53 TODO: parse flags */ /* [MS-XLSB] 2.4.323 TODO: parse flags */ function parse_ColInfo(blob, length, opts) {
    if (!opts.cellStyles) return parsenoop(blob, length);
    var w = opts && opts.biff >= 12 ? 4 : 2;
    var colFirst = blob.read_shift(w);
    var colLast = blob.read_shift(w);
    var coldx = blob.read_shift(w);
    var ixfe = blob.read_shift(w);
    var flags = blob.read_shift(2);
    if (w == 2) blob.l += 2;
    var o = {
        s: colFirst,
        e: colLast,
        w: coldx,
        ixfe: ixfe,
        flags: flags
    } /*:any*/ ;
    if (opts.biff >= 5 || !opts.biff) o.level = flags >> 8 & 0x7;
    return o;
}
function write_ColInfo(col, idx) {
    var o = new_buf(12);
    o.write_shift(2, idx);
    o.write_shift(2, idx);
    o.write_shift(2, col.width * 256);
    o.write_shift(2, 0);
    var f = 0;
    if (col.hidden) f |= 1;
    o.write_shift(1, f);
    f = col.level || 0;
    o.write_shift(1, f);
    o.write_shift(2, 0);
    return o;
}
/* [MS-XLS] 2.4.257 */ function parse_Setup(blob, length) {
    var o = {};
    if (length < 32) return o;
    blob.l += 16;
    o.header = parse_Xnum(blob, 8);
    o.footer = parse_Xnum(blob, 8);
    blob.l += 2;
    return o;
}
/* [MS-XLS] 2.4.261 */ function parse_ShtProps(blob, length, opts) {
    var def = {
        area: false
    };
    if (opts.biff != 5) {
        blob.l += length;
        return def;
    }
    var d = blob.read_shift(1);
    blob.l += 3;
    if (d & 0x10) def.area = true;
    return def;
}
/* [MS-XLS] 2.4.241 */ function write_RRTabId(n /*:number*/ ) {
    var out = new_buf(2 * n);
    for(var i = 0; i < n; ++i)out.write_shift(2, i + 1);
    return out;
}
var parse_Blank = parse_XLSCell; /* [MS-XLS] 2.4.20 Just the cell */ 
var parse_Scl = parseuint16a; /* [MS-XLS] 2.4.247 num, den */ 
var parse_String = parse_XLUnicodeString; /* [MS-XLS] 2.4.268 */ 
/* --- Specific to versions before BIFF8 --- */ function parse_ImData(blob) {
    var cf = blob.read_shift(2);
    var env = blob.read_shift(2);
    var lcb = blob.read_shift(4);
    var o = {
        fmt: cf,
        env: env,
        len: lcb,
        data: blob.slice(blob.l, blob.l + lcb)
    };
    blob.l += lcb;
    return o;
}
/* BIFF2_??? where ??? is the name from [XLS] */ function parse_BIFF2STR(blob, length, opts) {
    if (opts.biffguess && opts.biff == 5) opts.biff = 2;
    var cell = parse_XLSCell(blob, 6);
    ++blob.l;
    var str = parse_XLUnicodeString2(blob, length - 7, opts);
    cell.t = "str";
    cell.val = str;
    return cell;
}
function parse_BIFF2NUM(blob /*::, length*/ ) {
    var cell = parse_XLSCell(blob, 6);
    ++blob.l;
    var num = parse_Xnum(blob, 8);
    cell.t = "n";
    cell.val = num;
    return cell;
}
function write_BIFF2NUM(r /*:number*/ , c /*:number*/ , val /*:number*/ ) {
    var out = new_buf(15);
    write_BIFF2Cell(out, r, c);
    out.write_shift(8, val, "f");
    return out;
}
function parse_BIFF2INT(blob) {
    var cell = parse_XLSCell(blob, 6);
    ++blob.l;
    var num = blob.read_shift(2);
    cell.t = "n";
    cell.val = num;
    return cell;
}
function write_BIFF2INT(r /*:number*/ , c /*:number*/ , val /*:number*/ ) {
    var out = new_buf(9);
    write_BIFF2Cell(out, r, c);
    out.write_shift(2, val);
    return out;
}
function parse_BIFF2STRING(blob) {
    var cch = blob.read_shift(1);
    if (cch === 0) {
        blob.l++;
        return "";
    }
    return blob.read_shift(cch, "sbcs-cont");
}
/* TODO: convert to BIFF8 font struct */ function parse_BIFF2FONTXTRA(blob, length) {
    blob.l += 6; // unknown
    blob.l += 2; // font weight "bls"
    blob.l += 1; // charset
    blob.l += 3; // unknown
    blob.l += 1; // font family
    blob.l += length - 13;
}
/* TODO: parse rich text runs */ function parse_RString(blob, length, opts) {
    var end = blob.l + length;
    var cell = parse_XLSCell(blob, 6);
    var cch = blob.read_shift(2);
    var str = parse_XLUnicodeStringNoCch(blob, cch, opts);
    blob.l = end;
    cell.t = "str";
    cell.val = str;
    return cell;
}
/* from js-harb (C) 2014-present  SheetJS */ var DBF_SUPPORTED_VERSIONS = [
    0x02,
    0x03,
    0x30,
    0x31,
    0x83,
    0x8B,
    0x8C,
    0xF5
];
var DBF = /*#__PURE__*/ function() {
    var dbf_codepage_map = {
        /* Code Pages Supported by Visual FoxPro */ /*::[*/ 0x01: 437,
        /*::[*/ 0x02: 850,
        /*::[*/ 0x03: 1252,
        /*::[*/ 0x04: 10000,
        /*::[*/ 0x64: 852,
        /*::[*/ 0x65: 866,
        /*::[*/ 0x66: 865,
        /*::[*/ 0x67: 861,
        /*::[*/ 0x68: 895,
        /*::[*/ 0x69: 620,
        /*::[*/ 0x6A: 737,
        /*::[*/ 0x6B: 857,
        /*::[*/ 0x78: 950,
        /*::[*/ 0x79: 949,
        /*::[*/ 0x7A: 936,
        /*::[*/ 0x7B: 932,
        /*::[*/ 0x7C: 874,
        /*::[*/ 0x7D: 1255,
        /*::[*/ 0x7E: 1256,
        /*::[*/ 0x96: 10007,
        /*::[*/ 0x97: 10029,
        /*::[*/ 0x98: 10006,
        /*::[*/ 0xC8: 1250,
        /*::[*/ 0xC9: 1251,
        /*::[*/ 0xCA: 1254,
        /*::[*/ 0xCB: 1253,
        /* shapefile DBF extension */ /*::[*/ 0x00: 20127,
        /*::[*/ 0x08: 865,
        /*::[*/ 0x09: 437,
        /*::[*/ 0x0A: 850,
        /*::[*/ 0x0B: 437,
        /*::[*/ 0x0D: 437,
        /*::[*/ 0x0E: 850,
        /*::[*/ 0x0F: 437,
        /*::[*/ 0x10: 850,
        /*::[*/ 0x11: 437,
        /*::[*/ 0x12: 850,
        /*::[*/ 0x13: 932,
        /*::[*/ 0x14: 850,
        /*::[*/ 0x15: 437,
        /*::[*/ 0x16: 850,
        /*::[*/ 0x17: 865,
        /*::[*/ 0x18: 437,
        /*::[*/ 0x19: 437,
        /*::[*/ 0x1A: 850,
        /*::[*/ 0x1B: 437,
        /*::[*/ 0x1C: 863,
        /*::[*/ 0x1D: 850,
        /*::[*/ 0x1F: 852,
        /*::[*/ 0x22: 852,
        /*::[*/ 0x23: 852,
        /*::[*/ 0x24: 860,
        /*::[*/ 0x25: 850,
        /*::[*/ 0x26: 866,
        /*::[*/ 0x37: 850,
        /*::[*/ 0x40: 852,
        /*::[*/ 0x4D: 936,
        /*::[*/ 0x4E: 949,
        /*::[*/ 0x4F: 950,
        /*::[*/ 0x50: 874,
        /*::[*/ 0x57: 1252,
        /*::[*/ 0x58: 1252,
        /*::[*/ 0x59: 1252,
        /*::[*/ 0x6C: 863,
        /*::[*/ 0x86: 737,
        /*::[*/ 0x87: 852,
        /*::[*/ 0x88: 857,
        /*::[*/ 0xCC: 1257,
        /*::[*/ 0xFF: 16969
    };
    var dbf_reverse_map = evert({
        /*::[*/ 0x01: 437,
        /*::[*/ 0x02: 850,
        /*::[*/ 0x03: 1252,
        /*::[*/ 0x04: 10000,
        /*::[*/ 0x64: 852,
        /*::[*/ 0x65: 866,
        /*::[*/ 0x66: 865,
        /*::[*/ 0x67: 861,
        /*::[*/ 0x68: 895,
        /*::[*/ 0x69: 620,
        /*::[*/ 0x6A: 737,
        /*::[*/ 0x6B: 857,
        /*::[*/ 0x78: 950,
        /*::[*/ 0x79: 949,
        /*::[*/ 0x7A: 936,
        /*::[*/ 0x7B: 932,
        /*::[*/ 0x7C: 874,
        /*::[*/ 0x7D: 1255,
        /*::[*/ 0x7E: 1256,
        /*::[*/ 0x96: 10007,
        /*::[*/ 0x97: 10029,
        /*::[*/ 0x98: 10006,
        /*::[*/ 0xC8: 1250,
        /*::[*/ 0xC9: 1251,
        /*::[*/ 0xCA: 1254,
        /*::[*/ 0xCB: 1253,
        /*::[*/ 0x00: 20127
    });
    /* TODO: find an actual specification */ function dbf_to_aoa(buf, opts) /*:AOA*/ {
        var out /*:AOA*/  = [];
        var d /*:Block*/  = new_raw_buf(1);
        switch(opts.type){
            case "base64":
                d = s2a(Base64_decode(buf));
                break;
            case "binary":
                d = s2a(buf);
                break;
            case "buffer":
            case "array":
                d = buf;
                break;
        }
        prep_blob(d, 0);
        /* header */ var ft = d.read_shift(1);
        var memo = !!(ft & 0x88);
        var vfp = false, l7 = false;
        switch(ft){
            case 0x02:
                break; // dBASE II
            case 0x03:
                break; // dBASE III
            case 0x30:
                vfp = true;
                memo = true;
                break; // VFP
            case 0x31:
                vfp = true;
                memo = true;
                break; // VFP with autoincrement
            // 0x43 dBASE IV SQL table files
            // 0x63 dBASE IV SQL system files
            case 0x83:
                break; // dBASE III with memo
            case 0x8B:
                break; // dBASE IV with memo
            case 0x8C:
                l7 = true;
                break; // dBASE Level 7 with memo
            // case 0xCB dBASE IV SQL table files with memo
            case 0xF5:
                break; // FoxPro 2.x with memo
            // case 0xFB FoxBASE
            default:
                throw new Error("DBF Unsupported Version: " + ft.toString(16));
        }
        var nrow = 0, fpos = 0x0209;
        if (ft == 0x02) nrow = d.read_shift(2);
        d.l += 3; // dBASE II stores DDMMYY date, others use YYMMDD
        if (ft != 0x02) nrow = d.read_shift(4);
        if (nrow > 1048576) nrow = 1e6;
        if (ft != 0x02) fpos = d.read_shift(2); // header length
        var rlen = d.read_shift(2); // record length
        var /*flags = 0,*/ current_cp = opts.codepage || 1252;
        if (ft != 0x02) {
            d.l += 16;
            /*flags = */ d.read_shift(1);
            //if(memo && ((flags & 0x02) === 0)) throw new Error("DBF Flags " + flags.toString(16) + " ft " + ft.toString(16));
            /* codepage present in FoxPro and dBASE Level 7 */ if (d[d.l] !== 0) current_cp = dbf_codepage_map[d[d.l]];
            d.l += 1;
            d.l += 2;
        }
        if (l7) d.l += 36; // Level 7: 32 byte "Language driver name", 4 byte reserved
        /*:: type DBFField = { name:string; len:number; type:string; } */ var fields /*:Array<DBFField>*/  = [], field /*:DBFField*/  = {} /*:any*/ ;
        var hend = Math.min(d.length, ft == 0x02 ? 0x209 : fpos - 10 - (vfp ? 264 : 0));
        var ww = l7 ? 32 : 11;
        while(d.l < hend && d[d.l] != 0x0d){
            field = {} /*:any*/ ;
            field.name = $cptable.utils.decode(current_cp, d.slice(d.l, d.l + ww)).replace(/[\u0000\r\n].*$/g, "");
            d.l += ww;
            field.type = String.fromCharCode(d.read_shift(1));
            if (ft != 0x02 && !l7) field.offset = d.read_shift(4);
            field.len = d.read_shift(1);
            if (ft == 0x02) field.offset = d.read_shift(2);
            field.dec = d.read_shift(1);
            if (field.name.length) fields.push(field);
            if (ft != 0x02) d.l += l7 ? 13 : 14;
            switch(field.type){
                case "B":
                    if ((!vfp || field.len != 8) && opts.WTF) console.log("Skipping " + field.name + ":" + field.type);
                    break;
                case "G":
                case "P":
                    if (opts.WTF) console.log("Skipping " + field.name + ":" + field.type);
                    break;
                case "+":
                case "0":
                case "@":
                case "C":
                case "D":
                case "F":
                case "I":
                case "L":
                case "M":
                case "N":
                case "O":
                case "T":
                case "Y":
                    break;
                default:
                    throw new Error("Unknown Field Type: " + field.type);
            }
        }
        if (d[d.l] !== 0x0D) d.l = fpos - 1;
        if (d.read_shift(1) !== 0x0D) throw new Error("DBF Terminator not found " + d.l + " " + d[d.l]);
        d.l = fpos;
        /* data */ var R = 0, C = 0;
        out[0] = [];
        for(C = 0; C != fields.length; ++C)out[0][C] = fields[C].name;
        while(nrow-- > 0){
            if (d[d.l] === 0x2A) {
                // TODO: record marked as deleted -- create a hidden row?
                d.l += rlen;
                continue;
            }
            ++d.l;
            out[++R] = [];
            C = 0;
            for(C = 0; C != fields.length; ++C){
                var dd = d.slice(d.l, d.l + fields[C].len);
                d.l += fields[C].len;
                prep_blob(dd, 0);
                var s = $cptable.utils.decode(current_cp, dd);
                switch(fields[C].type){
                    case "C":
                        // NOTE: it is conventional to write '  /  /  ' for empty dates
                        if (s.trim().length) out[R][C] = s.replace(/\s+$/, "");
                        break;
                    case "D":
                        if (s.length === 8) out[R][C] = new Date(+s.slice(0, 4), +s.slice(4, 6) - 1, +s.slice(6, 8));
                        else out[R][C] = s;
                        break;
                    case "F":
                        out[R][C] = parseFloat(s.trim());
                        break;
                    case "+":
                    case "I":
                        out[R][C] = l7 ? dd.read_shift(-4, "i") ^ 0x80000000 : dd.read_shift(4, "i");
                        break;
                    case "L":
                        switch(s.trim().toUpperCase()){
                            case "Y":
                            case "T":
                                out[R][C] = true;
                                break;
                            case "N":
                            case "F":
                                out[R][C] = false;
                                break;
                            case "":
                            case "?":
                                break;
                            default:
                                throw new Error("DBF Unrecognized L:|" + s + "|");
                        }
                        break;
                    case "M":
                        /* TODO: handle memo files */ if (!memo) throw new Error("DBF Unexpected MEMO for type " + ft.toString(16));
                        out[R][C] = "##MEMO##" + (l7 ? parseInt(s.trim(), 10) : dd.read_shift(4));
                        break;
                    case "N":
                        s = s.replace(/\u0000/g, "").trim();
                        // NOTE: dBASE II interprets "  .  " as 0
                        if (s && s != ".") out[R][C] = +s || 0;
                        break;
                    case "@":
                        // NOTE: dBASE specs appear to be incorrect
                        out[R][C] = new Date(dd.read_shift(-8, "f") - 0x388317533400);
                        break;
                    case "T":
                        out[R][C] = new Date((dd.read_shift(4) - 0x253D8C) * 0x5265C00 + dd.read_shift(4));
                        break;
                    case "Y":
                        out[R][C] = dd.read_shift(4, "i") / 1e4 + dd.read_shift(4, "i") / 1e4 * Math.pow(2, 32);
                        break;
                    case "O":
                        out[R][C] = -dd.read_shift(-8, "f");
                        break;
                    case "B":
                        if (vfp && fields[C].len == 8) {
                            out[R][C] = dd.read_shift(8, "f");
                            break;
                        }
                    /* falls through */ case "G":
                    case "P":
                        dd.l += fields[C].len;
                        break;
                    case "0":
                        if (fields[C].name === "_NullFlags") break;
                    /* falls through */ default:
                        throw new Error("DBF Unsupported data type " + fields[C].type);
                }
            }
        }
        if (ft != 0x02) {
            if (d.l < d.length && d[d.l++] != 0x1A) throw new Error("DBF EOF Marker missing " + (d.l - 1) + " of " + d.length + " " + d[d.l - 1].toString(16));
        }
        if (opts && opts.sheetRows) out = out.slice(0, opts.sheetRows);
        opts.DBF = fields;
        return out;
    }
    function dbf_to_sheet(buf, opts) /*:Worksheet*/ {
        var o = opts || {};
        if (!o.dateNF) o.dateNF = "yyyymmdd";
        var ws = aoa_to_sheet(dbf_to_aoa(buf, o), o);
        ws["!cols"] = o.DBF.map(function(field) {
            return {
                wch: field.len,
                DBF: field
            };
        });
        delete o.DBF;
        return ws;
    }
    function dbf_to_workbook(buf, opts) /*:Workbook*/ {
        try {
            return sheet_to_workbook(dbf_to_sheet(buf, opts), opts);
        } catch (e) {
            if (opts && opts.WTF) throw e;
        }
        return {
            SheetNames: [],
            Sheets: {}
        };
    }
    var _RLEN = {
        "B": 8,
        "C": 250,
        "L": 1,
        "D": 8,
        "?": 0,
        "": 0
    };
    function sheet_to_dbf(ws /*:Worksheet*/ , opts /*:WriteOpts*/ ) {
        var o = opts || {};
        if (+o.codepage >= 0) set_cp(+o.codepage);
        if (o.type == "string") throw new Error("Cannot write DBF to JS string");
        var ba = buf_array();
        var aoa /*:AOA*/  = sheet_to_json(ws, {
            header: 1,
            raw: true,
            cellDates: true
        });
        var headers = aoa[0], data = aoa.slice(1), cols = ws["!cols"] || [];
        var i = 0, j = 0, hcnt = 0, rlen = 1;
        for(i = 0; i < headers.length; ++i){
            if (((cols[i] || {}).DBF || {}).name) {
                headers[i] = cols[i].DBF.name;
                ++hcnt;
                continue;
            }
            if (headers[i] == null) continue;
            ++hcnt;
            if (typeof headers[i] === "number") headers[i] = headers[i].toString(10);
            if (typeof headers[i] !== "string") throw new Error("DBF Invalid column name " + headers[i] + " |" + typeof headers[i] + "|");
            if (headers.indexOf(headers[i]) !== i) {
                for(j = 0; j < 1024; ++j)if (headers.indexOf(headers[i] + "_" + j) == -1) {
                    headers[i] += "_" + j;
                    break;
                }
            }
        }
        var range = safe_decode_range(ws["!ref"]);
        var coltypes /*:Array<string>*/  = [];
        var colwidths /*:Array<number>*/  = [];
        var coldecimals /*:Array<number>*/  = [];
        for(i = 0; i <= range.e.c - range.s.c; ++i){
            var guess = "", _guess = "", maxlen = 0;
            var col /*:Array<any>*/  = [];
            for(j = 0; j < data.length; ++j)if (data[j][i] != null) col.push(data[j][i]);
            if (col.length == 0 || headers[i] == null) {
                coltypes[i] = "?";
                continue;
            }
            for(j = 0; j < col.length; ++j){
                switch(typeof col[j]){
                    /* TODO: check if L2 compat is desired */ case "number":
                        _guess = "B";
                        break;
                    case "string":
                        _guess = "C";
                        break;
                    case "boolean":
                        _guess = "L";
                        break;
                    case "object":
                        _guess = col[j] instanceof Date ? "D" : "C";
                        break;
                    default:
                        _guess = "C";
                }
                maxlen = Math.max(maxlen, String(col[j]).length);
                guess = guess && guess != _guess ? "C" : _guess;
            //if(guess == 'C') break;
            }
            if (maxlen > 250) maxlen = 250;
            _guess = ((cols[i] || {}).DBF || {}).type;
            /* TODO: more fine grained control over DBF type resolution */ if (_guess == "C") {
                if (cols[i].DBF.len > maxlen) maxlen = cols[i].DBF.len;
            }
            if (guess == "B" && _guess == "N") {
                guess = "N";
                coldecimals[i] = cols[i].DBF.dec;
                maxlen = cols[i].DBF.len;
            }
            colwidths[i] = guess == "C" || _guess == "N" ? maxlen : _RLEN[guess] || 0;
            rlen += colwidths[i];
            coltypes[i] = guess;
        }
        var h = ba.next(32);
        h.write_shift(4, 0x13021130);
        h.write_shift(4, data.length);
        h.write_shift(2, 296 + 32 * hcnt);
        h.write_shift(2, rlen);
        for(i = 0; i < 4; ++i)h.write_shift(4, 0);
        h.write_shift(4, 0x00000000 | (+dbf_reverse_map[/*::String(*/ current_ansi /*::)*/ ] || 0x03) << 8);
        for(i = 0, j = 0; i < headers.length; ++i){
            if (headers[i] == null) continue;
            var hf = ba.next(32);
            var _f = (headers[i].slice(-10) + "\x00\x00\x00\x00\x00\x00\x00\x00\x00\x00\x00").slice(0, 11);
            hf.write_shift(1, _f, "sbcs");
            hf.write_shift(1, coltypes[i] == "?" ? "C" : coltypes[i], "sbcs");
            hf.write_shift(4, j);
            hf.write_shift(1, colwidths[i] || _RLEN[coltypes[i]] || 0);
            hf.write_shift(1, coldecimals[i] || 0);
            hf.write_shift(1, 0x02);
            hf.write_shift(4, 0);
            hf.write_shift(1, 0);
            hf.write_shift(4, 0);
            hf.write_shift(4, 0);
            j += colwidths[i] || _RLEN[coltypes[i]] || 0;
        }
        var hb = ba.next(264);
        hb.write_shift(4, 0x0000000D);
        for(i = 0; i < 65; ++i)hb.write_shift(4, 0x00000000);
        for(i = 0; i < data.length; ++i){
            var rout = ba.next(rlen);
            rout.write_shift(1, 0);
            for(j = 0; j < headers.length; ++j){
                if (headers[j] == null) continue;
                switch(coltypes[j]){
                    case "L":
                        rout.write_shift(1, data[i][j] == null ? 0x3F : data[i][j] ? 0x54 : 0x46);
                        break;
                    case "B":
                        rout.write_shift(8, data[i][j] || 0, "f");
                        break;
                    case "N":
                        var _n = "0";
                        if (typeof data[i][j] == "number") _n = data[i][j].toFixed(coldecimals[j] || 0);
                        for(hcnt = 0; hcnt < colwidths[j] - _n.length; ++hcnt)rout.write_shift(1, 0x20);
                        rout.write_shift(1, _n, "sbcs");
                        break;
                    case "D":
                        if (!data[i][j]) rout.write_shift(8, "00000000", "sbcs");
                        else {
                            rout.write_shift(4, ("0000" + data[i][j].getFullYear()).slice(-4), "sbcs");
                            rout.write_shift(2, ("00" + (data[i][j].getMonth() + 1)).slice(-2), "sbcs");
                            rout.write_shift(2, ("00" + data[i][j].getDate()).slice(-2), "sbcs");
                        }
                        break;
                    case "C":
                        var _s = String(data[i][j] != null ? data[i][j] : "").slice(0, colwidths[j]);
                        rout.write_shift(1, _s, "sbcs");
                        for(hcnt = 0; hcnt < colwidths[j] - _s.length; ++hcnt)rout.write_shift(1, 0x20);
                        break;
                }
            }
        // data
        }
        ba.next(1).write_shift(1, 0x1A);
        return ba.end();
    }
    return {
        to_workbook: dbf_to_workbook,
        to_sheet: dbf_to_sheet,
        from_sheet: sheet_to_dbf
    };
}();
var SYLK = /*#__PURE__*/ function() {
    /* TODO: stress test sequences */ var sylk_escapes = {
        AA: "\xc0",
        BA: "\xc1",
        CA: "\xc2",
        DA: 195,
        HA: "\xc4",
        JA: 197,
        AE: "\xc8",
        BE: "\xc9",
        CE: "\xca",
        HE: "\xcb",
        AI: "\xcc",
        BI: "\xcd",
        CI: "\xce",
        HI: "\xcf",
        AO: "\xd2",
        BO: "\xd3",
        CO: "\xd4",
        DO: 213,
        HO: "\xd6",
        AU: "\xd9",
        BU: "\xda",
        CU: "\xdb",
        HU: "\xdc",
        Aa: "\xe0",
        Ba: "\xe1",
        Ca: "\xe2",
        Da: 227,
        Ha: "\xe4",
        Ja: 229,
        Ae: "\xe8",
        Be: "\xe9",
        Ce: "\xea",
        He: "\xeb",
        Ai: "\xec",
        Bi: "\xed",
        Ci: "\xee",
        Hi: "\xef",
        Ao: "\xf2",
        Bo: "\xf3",
        Co: "\xf4",
        Do: 245,
        Ho: "\xf6",
        Au: "\xf9",
        Bu: "\xfa",
        Cu: "\xfb",
        Hu: "\xfc",
        KC: "\xc7",
        Kc: "\xe7",
        q: "\xe6",
        z: "œ",
        a: "\xc6",
        j: "Œ",
        DN: 209,
        Dn: 241,
        Hy: 255,
        S: 169,
        c: 170,
        R: 174,
        "B ": 180,
        /*::[*/ 0: 176,
        /*::[*/ 1: 177,
        /*::[*/ 2: 178,
        /*::[*/ 3: 179,
        /*::[*/ 5: 181,
        /*::[*/ 6: 182,
        /*::[*/ 7: 183,
        Q: 185,
        k: 186,
        b: 208,
        i: 216,
        l: 222,
        s: 240,
        y: 248,
        "!": 161,
        '"': 162,
        "#": 163,
        "(": 164,
        "%": 165,
        "'": 167,
        "H ": 168,
        "+": 171,
        ";": 187,
        "<": 188,
        "=": 189,
        ">": 190,
        "?": 191,
        "{": 223
    } /*:any*/ ;
    var sylk_char_regex = new RegExp("\x1bN(" + keys(sylk_escapes).join("|").replace(/\|\|\|/, "|\\||").replace(/([?()+])/g, "\\$1") + "|\\|)", "gm");
    var sylk_char_fn = function(_, $1) {
        var o = sylk_escapes[$1];
        return typeof o == "number" ? _getansi(o) : o;
    };
    var decode_sylk_char = function($$, $1, $2) {
        var newcc = $1.charCodeAt(0) - 0x20 << 4 | $2.charCodeAt(0) - 0x30;
        return newcc == 59 ? $$ : _getansi(newcc);
    };
    sylk_escapes["|"] = 254;
    /* TODO: find an actual specification */ function sylk_to_aoa(d /*:RawData*/ , opts) /*:[AOA, Worksheet]*/ {
        switch(opts.type){
            case "base64":
                return sylk_to_aoa_str(Base64_decode(d), opts);
            case "binary":
                return sylk_to_aoa_str(d, opts);
            case "buffer":
                return sylk_to_aoa_str(has_buf && Buffer.isBuffer(d) ? d.toString("binary") : a2s(d), opts);
            case "array":
                return sylk_to_aoa_str(cc2str(d), opts);
        }
        throw new Error("Unrecognized type " + opts.type);
    }
    function sylk_to_aoa_str(str /*:string*/ , opts) /*:[AOA, Worksheet]*/ {
        var records = str.split(/[\n\r]+/), R = -1, C = -1, ri = 0, rj = 0, arr /*:AOA*/  = [];
        var formats /*:Array<string>*/  = [];
        var next_cell_format /*:string|null*/  = null;
        var sht = {}, rowinfo /*:Array<RowInfo>*/  = [], colinfo /*:Array<ColInfo>*/  = [], cw /*:Array<string>*/  = [];
        var Mval = 0, j;
        if (+opts.codepage >= 0) set_cp(+opts.codepage);
        for(; ri !== records.length; ++ri){
            Mval = 0;
            var rstr = records[ri].trim().replace(/\x1B([\x20-\x2F])([\x30-\x3F])/g, decode_sylk_char).replace(sylk_char_regex, sylk_char_fn);
            var record = rstr.replace(/;;/g, "\x00").split(";").map(function(x) {
                return x.replace(/\u0000/g, ";");
            });
            var RT = record[0], val;
            if (rstr.length > 0) switch(RT){
                case "ID":
                    break; /* header */ 
                case "E":
                    break; /* EOF */ 
                case "B":
                    break; /* dimensions */ 
                case "O":
                    break; /* options? */ 
                case "W":
                    break; /* window? */ 
                case "P":
                    if (record[1].charAt(0) == "P") formats.push(rstr.slice(3).replace(/;;/g, ";"));
                    break;
                case "C":
                    var C_seen_K = false, C_seen_X = false, C_seen_S = false, C_seen_E = false, _R = -1, _C = -1;
                    for(rj = 1; rj < record.length; ++rj)switch(record[rj].charAt(0)){
                        case "A":
                            break; // TODO: comment
                        case "X":
                            C = parseInt(record[rj].slice(1)) - 1;
                            C_seen_X = true;
                            break;
                        case "Y":
                            R = parseInt(record[rj].slice(1)) - 1;
                            if (!C_seen_X) C = 0;
                            for(j = arr.length; j <= R; ++j)arr[j] = [];
                            break;
                        case "K":
                            val = record[rj].slice(1);
                            if (val.charAt(0) === '"') val = val.slice(1, val.length - 1);
                            else if (val === "TRUE") val = true;
                            else if (val === "FALSE") val = false;
                            else if (!isNaN(fuzzynum(val))) {
                                val = fuzzynum(val);
                                if (next_cell_format !== null && fmt_is_date(next_cell_format)) val = numdate(val);
                            } else if (!isNaN(fuzzydate(val).getDate())) val = parseDate(val);
                            if (typeof $cptable !== "undefined" && typeof val == "string" && (opts || {}).type != "string" && (opts || {}).codepage) val = $cptable.utils.decode(opts.codepage, val);
                            C_seen_K = true;
                            break;
                        case "E":
                            C_seen_E = true;
                            var formula = rc_to_a1(record[rj].slice(1), {
                                r: R,
                                c: C
                            });
                            arr[R][C] = [
                                arr[R][C],
                                formula
                            ];
                            break;
                        case "S":
                            C_seen_S = true;
                            arr[R][C] = [
                                arr[R][C],
                                "S5S"
                            ];
                            break;
                        case "G":
                            break; // unknown
                        case "R":
                            _R = parseInt(record[rj].slice(1)) - 1;
                            break;
                        case "C":
                            _C = parseInt(record[rj].slice(1)) - 1;
                            break;
                        default:
                            if (opts && opts.WTF) throw new Error("SYLK bad record " + rstr);
                    }
                    if (C_seen_K) {
                        if (arr[R][C] && arr[R][C].length == 2) arr[R][C][0] = val;
                        else arr[R][C] = val;
                        next_cell_format = null;
                    }
                    if (C_seen_S) {
                        if (C_seen_E) throw new Error("SYLK shared formula cannot have own formula");
                        var shrbase = _R > -1 && arr[_R][_C];
                        if (!shrbase || !shrbase[1]) throw new Error("SYLK shared formula cannot find base");
                        arr[R][C][1] = shift_formula_str(shrbase[1], {
                            r: R - _R,
                            c: C - _C
                        });
                    }
                    break;
                case "F":
                    var F_seen = 0;
                    for(rj = 1; rj < record.length; ++rj)switch(record[rj].charAt(0)){
                        case "X":
                            C = parseInt(record[rj].slice(1)) - 1;
                            ++F_seen;
                            break;
                        case "Y":
                            R = parseInt(record[rj].slice(1)) - 1; /*C = 0;*/ 
                            for(j = arr.length; j <= R; ++j)arr[j] = [];
                            break;
                        case "M":
                            Mval = parseInt(record[rj].slice(1)) / 20;
                            break;
                        case "F":
                            break; /* ??? */ 
                        case "G":
                            break; /* hide grid */ 
                        case "P":
                            next_cell_format = formats[parseInt(record[rj].slice(1))];
                            break;
                        case "S":
                            break; /* cell style */ 
                        case "D":
                            break; /* column */ 
                        case "N":
                            break; /* font */ 
                        case "W":
                            cw = record[rj].slice(1).split(" ");
                            for(j = parseInt(cw[0], 10); j <= parseInt(cw[1], 10); ++j){
                                Mval = parseInt(cw[2], 10);
                                colinfo[j - 1] = Mval === 0 ? {
                                    hidden: true
                                } : {
                                    wch: Mval
                                };
                                process_col(colinfo[j - 1]);
                            }
                            break;
                        case "C":
                            /* default column format */ C = parseInt(record[rj].slice(1)) - 1;
                            if (!colinfo[C]) colinfo[C] = {};
                            break;
                        case "R":
                            /* row properties */ R = parseInt(record[rj].slice(1)) - 1;
                            if (!rowinfo[R]) rowinfo[R] = {};
                            if (Mval > 0) {
                                rowinfo[R].hpt = Mval;
                                rowinfo[R].hpx = pt2px(Mval);
                            } else if (Mval === 0) rowinfo[R].hidden = true;
                            break;
                        default:
                            if (opts && opts.WTF) throw new Error("SYLK bad record " + rstr);
                    }
                    if (F_seen < 1) next_cell_format = null;
                    break;
                default:
                    if (opts && opts.WTF) throw new Error("SYLK bad record " + rstr);
            }
        }
        if (rowinfo.length > 0) sht["!rows"] = rowinfo;
        if (colinfo.length > 0) sht["!cols"] = colinfo;
        if (opts && opts.sheetRows) arr = arr.slice(0, opts.sheetRows);
        return [
            arr,
            sht
        ];
    }
    function sylk_to_sheet(d /*:RawData*/ , opts) /*:Worksheet*/ {
        var aoasht = sylk_to_aoa(d, opts);
        var aoa = aoasht[0], ws = aoasht[1];
        var o = aoa_to_sheet(aoa, opts);
        keys(ws).forEach(function(k) {
            o[k] = ws[k];
        });
        return o;
    }
    function sylk_to_workbook(d /*:RawData*/ , opts) /*:Workbook*/ {
        return sheet_to_workbook(sylk_to_sheet(d, opts), opts);
    }
    function write_ws_cell_sylk(cell /*:Cell*/ , ws /*:Worksheet*/ , R /*:number*/ , C /*:number*/  /*::, opts*/ ) /*:string*/ {
        var o = "C;Y" + (R + 1) + ";X" + (C + 1) + ";K";
        switch(cell.t){
            case "n":
                o += cell.v || 0;
                if (cell.f && !cell.F) o += ";E" + a1_to_rc(cell.f, {
                    r: R,
                    c: C
                });
                break;
            case "b":
                o += cell.v ? "TRUE" : "FALSE";
                break;
            case "e":
                o += cell.w || cell.v;
                break;
            case "d":
                o += '"' + (cell.w || cell.v) + '"';
                break;
            case "s":
                o += '"' + cell.v.replace(/"/g, "").replace(/;/g, ";;") + '"';
                break;
        }
        return o;
    }
    function write_ws_cols_sylk(out, cols) {
        cols.forEach(function(col, i) {
            var rec = "F;W" + (i + 1) + " " + (i + 1) + " ";
            if (col.hidden) rec += "0";
            else {
                if (typeof col.width == "number" && !col.wpx) col.wpx = width2px(col.width);
                if (typeof col.wpx == "number" && !col.wch) col.wch = px2char(col.wpx);
                if (typeof col.wch == "number") rec += Math.round(col.wch);
            }
            if (rec.charAt(rec.length - 1) != " ") out.push(rec);
        });
    }
    function write_ws_rows_sylk(out /*:Array<string>*/ , rows /*:Array<RowInfo>*/ ) {
        rows.forEach(function(row, i) {
            var rec = "F;";
            if (row.hidden) rec += "M0;";
            else if (row.hpt) rec += "M" + 20 * row.hpt + ";";
            else if (row.hpx) rec += "M" + 20 * px2pt(row.hpx) + ";";
            if (rec.length > 2) out.push(rec + "R" + (i + 1));
        });
    }
    function sheet_to_sylk(ws /*:Worksheet*/ , opts /*:?any*/ ) /*:string*/ {
        var preamble /*:Array<string>*/  = [
            "ID;PWXL;N;E"
        ], o /*:Array<string>*/  = [];
        var r = safe_decode_range(ws["!ref"]), cell /*:Cell*/ ;
        var dense = Array.isArray(ws);
        var RS = "\r\n";
        preamble.push("P;PGeneral");
        preamble.push("F;P0;DG0G8;M255");
        if (ws["!cols"]) write_ws_cols_sylk(preamble, ws["!cols"]);
        if (ws["!rows"]) write_ws_rows_sylk(preamble, ws["!rows"]);
        preamble.push("B;Y" + (r.e.r - r.s.r + 1) + ";X" + (r.e.c - r.s.c + 1) + ";D" + [
            r.s.c,
            r.s.r,
            r.e.c,
            r.e.r
        ].join(" "));
        for(var R = r.s.r; R <= r.e.r; ++R)for(var C = r.s.c; C <= r.e.c; ++C){
            var coord = encode_cell({
                r: R,
                c: C
            });
            cell = dense ? (ws[R] || [])[C] : ws[coord];
            if (!cell || cell.v == null && (!cell.f || cell.F)) continue;
            o.push(write_ws_cell_sylk(cell, ws, R, C, opts));
        }
        return preamble.join(RS) + RS + o.join(RS) + RS + "E" + RS;
    }
    return {
        to_workbook: sylk_to_workbook,
        to_sheet: sylk_to_sheet,
        from_sheet: sheet_to_sylk
    };
}();
var DIF = /*#__PURE__*/ function() {
    function dif_to_aoa(d /*:RawData*/ , opts) /*:AOA*/ {
        switch(opts.type){
            case "base64":
                return dif_to_aoa_str(Base64_decode(d), opts);
            case "binary":
                return dif_to_aoa_str(d, opts);
            case "buffer":
                return dif_to_aoa_str(has_buf && Buffer.isBuffer(d) ? d.toString("binary") : a2s(d), opts);
            case "array":
                return dif_to_aoa_str(cc2str(d), opts);
        }
        throw new Error("Unrecognized type " + opts.type);
    }
    function dif_to_aoa_str(str /*:string*/ , opts) /*:AOA*/ {
        var records = str.split("\n"), R = -1, C = -1, ri = 0, arr /*:AOA*/  = [];
        for(; ri !== records.length; ++ri){
            if (records[ri].trim() === "BOT") {
                arr[++R] = [];
                C = 0;
                continue;
            }
            if (R < 0) continue;
            var metadata = records[ri].trim().split(",");
            var type = metadata[0], value = metadata[1];
            ++ri;
            var data = records[ri] || "";
            while((data.match(/["]/g) || []).length & 1 && ri < records.length - 1)data += "\n" + records[++ri];
            data = data.trim();
            switch(+type){
                case -1:
                    if (data === "BOT") {
                        arr[++R] = [];
                        C = 0;
                        continue;
                    } else if (data !== "EOD") throw new Error("Unrecognized DIF special command " + data);
                    break;
                case 0:
                    if (data === "TRUE") arr[R][C] = true;
                    else if (data === "FALSE") arr[R][C] = false;
                    else if (!isNaN(fuzzynum(value))) arr[R][C] = fuzzynum(value);
                    else if (!isNaN(fuzzydate(value).getDate())) arr[R][C] = parseDate(value);
                    else arr[R][C] = value;
                    ++C;
                    break;
                case 1:
                    data = data.slice(1, data.length - 1);
                    data = data.replace(/""/g, '"');
                    if (DIF_XL && data && data.match(/^=".*"$/)) data = data.slice(2, -1);
                    arr[R][C++] = data !== "" ? data : null;
                    break;
            }
            if (data === "EOD") break;
        }
        if (opts && opts.sheetRows) arr = arr.slice(0, opts.sheetRows);
        return arr;
    }
    function dif_to_sheet(str /*:string*/ , opts) /*:Worksheet*/ {
        return aoa_to_sheet(dif_to_aoa(str, opts), opts);
    }
    function dif_to_workbook(str /*:string*/ , opts) /*:Workbook*/ {
        return sheet_to_workbook(dif_to_sheet(str, opts), opts);
    }
    var sheet_to_dif = /*#__PURE__*/ function() {
        var push_field = function pf(o /*:Array<string>*/ , topic /*:string*/ , v /*:number*/ , n /*:number*/ , s /*:string*/ ) {
            o.push(topic);
            o.push(v + "," + n);
            o.push('"' + s.replace(/"/g, '""') + '"');
        };
        var push_value = function po(o /*:Array<string>*/ , type /*:number*/ , v /*:any*/ , s /*:string*/ ) {
            o.push(type + "," + v);
            o.push(type == 1 ? '"' + s.replace(/"/g, '""') + '"' : s);
        };
        return function sheet_to_dif(ws /*:Worksheet*/  /*::, opts:?any*/ ) /*:string*/ {
            var o /*:Array<string>*/  = [];
            var r = safe_decode_range(ws["!ref"]), cell /*:Cell*/ ;
            var dense = Array.isArray(ws);
            push_field(o, "TABLE", 0, 1, "sheetjs");
            push_field(o, "VECTORS", 0, r.e.r - r.s.r + 1, "");
            push_field(o, "TUPLES", 0, r.e.c - r.s.c + 1, "");
            push_field(o, "DATA", 0, 0, "");
            for(var R = r.s.r; R <= r.e.r; ++R){
                push_value(o, -1, 0, "BOT");
                for(var C = r.s.c; C <= r.e.c; ++C){
                    var coord = encode_cell({
                        r: R,
                        c: C
                    });
                    cell = dense ? (ws[R] || [])[C] : ws[coord];
                    if (!cell) {
                        push_value(o, 1, 0, "");
                        continue;
                    }
                    switch(cell.t){
                        case "n":
                            var val = DIF_XL ? cell.w : cell.v;
                            if (!val && cell.v != null) val = cell.v;
                            if (val == null) {
                                if (DIF_XL && cell.f && !cell.F) push_value(o, 1, 0, "=" + cell.f);
                                else push_value(o, 1, 0, "");
                            } else push_value(o, 0, val, "V");
                            break;
                        case "b":
                            push_value(o, 0, cell.v ? 1 : 0, cell.v ? "TRUE" : "FALSE");
                            break;
                        case "s":
                            push_value(o, 1, 0, !DIF_XL || isNaN(cell.v) ? cell.v : '="' + cell.v + '"');
                            break;
                        case "d":
                            if (!cell.w) cell.w = SSF_format(cell.z || table_fmt[14], datenum(parseDate(cell.v)));
                            if (DIF_XL) push_value(o, 0, cell.w, "V");
                            else push_value(o, 1, 0, cell.w);
                            break;
                        default:
                            push_value(o, 1, 0, "");
                    }
                }
            }
            push_value(o, -1, 0, "EOD");
            var RS = "\r\n";
            var oo = o.join(RS);
            //while((oo.length & 0x7F) != 0) oo += "\0";
            return oo;
        };
    }();
    return {
        to_workbook: dif_to_workbook,
        to_sheet: dif_to_sheet,
        from_sheet: sheet_to_dif
    };
}();
var ETH = /*#__PURE__*/ function() {
    function decode(s /*:string*/ ) /*:string*/ {
        return s.replace(/\\b/g, "\\").replace(/\\c/g, ":").replace(/\\n/g, "\n");
    }
    function encode(s /*:string*/ ) /*:string*/ {
        return s.replace(/\\/g, "\\b").replace(/:/g, "\\c").replace(/\n/g, "\\n");
    }
    function eth_to_aoa(str /*:string*/ , opts) /*:AOA*/ {
        var records = str.split("\n"), R = -1, C = -1, ri = 0, arr /*:AOA*/  = [];
        for(; ri !== records.length; ++ri){
            var record = records[ri].trim().split(":");
            if (record[0] !== "cell") continue;
            var addr = decode_cell(record[1]);
            if (arr.length <= addr.r) {
                for(R = arr.length; R <= addr.r; ++R)if (!arr[R]) arr[R] = [];
            }
            R = addr.r;
            C = addr.c;
            switch(record[2]){
                case "t":
                    arr[R][C] = decode(record[3]);
                    break;
                case "v":
                    arr[R][C] = +record[3];
                    break;
                case "vtf":
                    var _f = record[record.length - 1];
                /* falls through */ case "vtc":
                    switch(record[3]){
                        case "nl":
                            arr[R][C] = +record[4] ? true : false;
                            break;
                        default:
                            arr[R][C] = +record[4];
                            break;
                    }
                    if (record[2] == "vtf") arr[R][C] = [
                        arr[R][C],
                        _f
                    ];
            }
        }
        if (opts && opts.sheetRows) arr = arr.slice(0, opts.sheetRows);
        return arr;
    }
    function eth_to_sheet(d /*:string*/ , opts) /*:Worksheet*/ {
        return aoa_to_sheet(eth_to_aoa(d, opts), opts);
    }
    function eth_to_workbook(d /*:string*/ , opts) /*:Workbook*/ {
        return sheet_to_workbook(eth_to_sheet(d, opts), opts);
    }
    var header = [
        "socialcalc:version:1.5",
        "MIME-Version: 1.0",
        "Content-Type: multipart/mixed; boundary=SocialCalcSpreadsheetControlSave"
    ].join("\n");
    var sep = [
        "--SocialCalcSpreadsheetControlSave",
        "Content-type: text/plain; charset=UTF-8"
    ].join("\n") + "\n";
    /* TODO: the other parts */ var meta = [
        "# SocialCalc Spreadsheet Control Save",
        "part:sheet"
    ].join("\n");
    var end = "--SocialCalcSpreadsheetControlSave--";
    function sheet_to_eth_data(ws /*:Worksheet*/ ) /*:string*/ {
        if (!ws || !ws["!ref"]) return "";
        var o /*:Array<string>*/  = [], oo /*:Array<string>*/  = [], cell, coord = "";
        var r = decode_range(ws["!ref"]);
        var dense = Array.isArray(ws);
        for(var R = r.s.r; R <= r.e.r; ++R)for(var C = r.s.c; C <= r.e.c; ++C){
            coord = encode_cell({
                r: R,
                c: C
            });
            cell = dense ? (ws[R] || [])[C] : ws[coord];
            if (!cell || cell.v == null || cell.t === "z") continue;
            oo = [
                "cell",
                coord,
                "t"
            ];
            switch(cell.t){
                case "s":
                case "str":
                    oo.push(encode(cell.v));
                    break;
                case "n":
                    if (!cell.f) {
                        oo[2] = "v";
                        oo[3] = cell.v;
                    } else {
                        oo[2] = "vtf";
                        oo[3] = "n";
                        oo[4] = cell.v;
                        oo[5] = encode(cell.f);
                    }
                    break;
                case "b":
                    oo[2] = "vt" + (cell.f ? "f" : "c");
                    oo[3] = "nl";
                    oo[4] = cell.v ? "1" : "0";
                    oo[5] = encode(cell.f || (cell.v ? "TRUE" : "FALSE"));
                    break;
                case "d":
                    var t = datenum(parseDate(cell.v));
                    oo[2] = "vtc";
                    oo[3] = "nd";
                    oo[4] = "" + t;
                    oo[5] = cell.w || SSF_format(cell.z || table_fmt[14], t);
                    break;
                case "e":
                    continue;
            }
            o.push(oo.join(":"));
        }
        o.push("sheet:c:" + (r.e.c - r.s.c + 1) + ":r:" + (r.e.r - r.s.r + 1) + ":tvf:1");
        o.push("valueformat:1:text-wiki");
        //o.push("copiedfrom:" + ws['!ref']); // clipboard only
        return o.join("\n");
    }
    function sheet_to_eth(ws /*:Worksheet*/  /*::, opts:?any*/ ) /*:string*/ {
        return [
            header,
            sep,
            meta,
            sep,
            sheet_to_eth_data(ws),
            end
        ].join("\n");
    // return ["version:1.5", sheet_to_eth_data(ws)].join("\n"); // clipboard form
    }
    return {
        to_workbook: eth_to_workbook,
        to_sheet: eth_to_sheet,
        from_sheet: sheet_to_eth
    };
}();
var PRN = /*#__PURE__*/ function() {
    function set_text_arr(data /*:string*/ , arr /*:AOA*/ , R /*:number*/ , C /*:number*/ , o /*:any*/ ) {
        if (o.raw) arr[R][C] = data;
        else if (data === "") ;
        else if (data === "TRUE") arr[R][C] = true;
        else if (data === "FALSE") arr[R][C] = false;
        else if (!isNaN(fuzzynum(data))) arr[R][C] = fuzzynum(data);
        else if (!isNaN(fuzzydate(data).getDate())) arr[R][C] = parseDate(data);
        else arr[R][C] = data;
    }
    function prn_to_aoa_str(f /*:string*/ , opts) /*:AOA*/ {
        var o = opts || {};
        var arr /*:AOA*/  = [];
        if (!f || f.length === 0) return arr;
        var lines = f.split(/[\r\n]/);
        var L = lines.length - 1;
        while(L >= 0 && lines[L].length === 0)--L;
        var start = 10, idx = 0;
        var R = 0;
        for(; R <= L; ++R){
            idx = lines[R].indexOf(" ");
            if (idx == -1) idx = lines[R].length;
            else idx++;
            start = Math.max(start, idx);
        }
        for(R = 0; R <= L; ++R){
            arr[R] = [];
            /* TODO: confirm that widths are always 10 */ var C = 0;
            set_text_arr(lines[R].slice(0, start).trim(), arr, R, C, o);
            for(C = 1; C <= (lines[R].length - start) / 10 + 1; ++C)set_text_arr(lines[R].slice(start + (C - 1) * 10, start + C * 10).trim(), arr, R, C, o);
        }
        if (o.sheetRows) arr = arr.slice(0, o.sheetRows);
        return arr;
    }
    // List of accepted CSV separators
    var guess_seps = {
        /*::[*/ 0x2C: ",",
        /*::[*/ 0x09: "	",
        /*::[*/ 0x3B: ";",
        /*::[*/ 0x7C: "|"
    };
    // CSV separator weights to be used in case of equal numbers
    var guess_sep_weights = {
        /*::[*/ 0x2C: 3,
        /*::[*/ 0x09: 2,
        /*::[*/ 0x3B: 1,
        /*::[*/ 0x7C: 0
    };
    function guess_sep(str) {
        var cnt = {}, instr = false, end = 0, cc = 0;
        for(; end < str.length; ++end){
            if ((cc = str.charCodeAt(end)) == 0x22) instr = !instr;
            else if (!instr && cc in guess_seps) cnt[cc] = (cnt[cc] || 0) + 1;
        }
        cc = [];
        for(end in cnt)if (Object.prototype.hasOwnProperty.call(cnt, end)) cc.push([
            cnt[end],
            end
        ]);
        if (!cc.length) {
            cnt = guess_sep_weights;
            for(end in cnt)if (Object.prototype.hasOwnProperty.call(cnt, end)) cc.push([
                cnt[end],
                end
            ]);
        }
        cc.sort(function(a, b) {
            return a[0] - b[0] || guess_sep_weights[a[1]] - guess_sep_weights[b[1]];
        });
        return guess_seps[cc.pop()[1]] || 0x2C;
    }
    function dsv_to_sheet_str(str /*:string*/ , opts) /*:Worksheet*/ {
        var o = opts || {};
        var sep = "";
        if (DENSE != null && o.dense == null) o.dense = DENSE;
        var ws /*:Worksheet*/  = o.dense ? [] : {} /*:any*/ ;
        var range /*:Range*/  = {
            s: {
                c: 0,
                r: 0
            },
            e: {
                c: 0,
                r: 0
            }
        } /*:any*/ ;
        if (str.slice(0, 4) == "sep=") {
            // If the line ends in \r\n
            if (str.charCodeAt(5) == 13 && str.charCodeAt(6) == 10) {
                sep = str.charAt(4);
                str = str.slice(7);
            } else if (str.charCodeAt(5) == 13 || str.charCodeAt(5) == 10) {
                sep = str.charAt(4);
                str = str.slice(6);
            } else sep = guess_sep(str.slice(0, 1024));
        } else if (o && o.FS) sep = o.FS;
        else sep = guess_sep(str.slice(0, 1024));
        var R = 0, C = 0, v = 0;
        var start = 0, end = 0, sepcc = sep.charCodeAt(0), instr = false, cc = 0, startcc = str.charCodeAt(0);
        str = str.replace(/\r\n/mg, "\n");
        var _re /*:?RegExp*/  = o.dateNF != null ? dateNF_regex(o.dateNF) : null;
        function finish_cell() {
            var s = str.slice(start, end);
            var cell = {} /*:any*/ ;
            if (s.charAt(0) == '"' && s.charAt(s.length - 1) == '"') s = s.slice(1, -1).replace(/""/g, '"');
            if (s.length === 0) cell.t = "z";
            else if (o.raw) {
                cell.t = "s";
                cell.v = s;
            } else if (s.trim().length === 0) {
                cell.t = "s";
                cell.v = s;
            } else if (s.charCodeAt(0) == 0x3D) {
                if (s.charCodeAt(1) == 0x22 && s.charCodeAt(s.length - 1) == 0x22) {
                    cell.t = "s";
                    cell.v = s.slice(2, -1).replace(/""/g, '"');
                } else if (fuzzyfmla(s)) {
                    cell.t = "n";
                    cell.f = s.slice(1);
                } else {
                    cell.t = "s";
                    cell.v = s;
                }
            } else if (s == "TRUE") {
                cell.t = "b";
                cell.v = true;
            } else if (s == "FALSE") {
                cell.t = "b";
                cell.v = false;
            } else if (!isNaN(v = fuzzynum(s))) {
                cell.t = "n";
                if (o.cellText !== false) cell.w = s;
                cell.v = v;
            } else if (!isNaN(fuzzydate(s).getDate()) || _re && s.match(_re)) {
                cell.z = o.dateNF || table_fmt[14];
                var k = 0;
                if (_re && s.match(_re)) {
                    s = dateNF_fix(s, o.dateNF, s.match(_re) || []);
                    k = 1;
                }
                if (o.cellDates) {
                    cell.t = "d";
                    cell.v = parseDate(s, k);
                } else {
                    cell.t = "n";
                    cell.v = datenum(parseDate(s, k));
                }
                if (o.cellText !== false) cell.w = SSF_format(cell.z, cell.v instanceof Date ? datenum(cell.v) : cell.v);
                if (!o.cellNF) delete cell.z;
            } else {
                cell.t = "s";
                cell.v = s;
            }
            if (cell.t == "z") ;
            else if (o.dense) {
                if (!ws[R]) ws[R] = [];
                ws[R][C] = cell;
            } else ws[encode_cell({
                c: C,
                r: R
            })] = cell;
            start = end + 1;
            startcc = str.charCodeAt(start);
            if (range.e.c < C) range.e.c = C;
            if (range.e.r < R) range.e.r = R;
            if (cc == sepcc) ++C;
            else {
                C = 0;
                ++R;
                if (o.sheetRows && o.sheetRows <= R) return true;
            }
        }
        outer: for(; end < str.length; ++end)switch(cc = str.charCodeAt(end)){
            case 0x22:
                if (startcc === 0x22) instr = !instr;
                break;
            case sepcc:
            case 0x0a:
            case 0x0d:
                if (!instr && finish_cell()) break outer;
                break;
            default:
                break;
        }
        if (end - start > 0) finish_cell();
        ws["!ref"] = encode_range(range);
        return ws;
    }
    function prn_to_sheet_str(str /*:string*/ , opts) /*:Worksheet*/ {
        if (!(opts && opts.PRN)) return dsv_to_sheet_str(str, opts);
        if (opts.FS) return dsv_to_sheet_str(str, opts);
        if (str.slice(0, 4) == "sep=") return dsv_to_sheet_str(str, opts);
        if (str.indexOf("	") >= 0 || str.indexOf(",") >= 0 || str.indexOf(";") >= 0) return dsv_to_sheet_str(str, opts);
        return aoa_to_sheet(prn_to_aoa_str(str, opts), opts);
    }
    function prn_to_sheet(d /*:RawData*/ , opts) /*:Worksheet*/ {
        var str = "", bytes = opts.type == "string" ? [
            0,
            0,
            0,
            0
        ] : firstbyte(d, opts);
        switch(opts.type){
            case "base64":
                str = Base64_decode(d);
                break;
            case "binary":
                str = d;
                break;
            case "buffer":
                if (opts.codepage == 65001) str = d.toString("utf8"); // TODO: test if buf
                else if (opts.codepage && typeof $cptable !== "undefined") str = $cptable.utils.decode(opts.codepage, d);
                else str = has_buf && Buffer.isBuffer(d) ? d.toString("binary") : a2s(d);
                break;
            case "array":
                str = cc2str(d);
                break;
            case "string":
                str = d;
                break;
            default:
                throw new Error("Unrecognized type " + opts.type);
        }
        if (bytes[0] == 0xEF && bytes[1] == 0xBB && bytes[2] == 0xBF) str = utf8read(str.slice(3));
        else if (opts.type != "string" && opts.type != "buffer" && opts.codepage == 65001) str = utf8read(str);
        else if (opts.type == "binary" && typeof $cptable !== "undefined" && opts.codepage) str = $cptable.utils.decode(opts.codepage, $cptable.utils.encode(28591, str));
        if (str.slice(0, 19) == "socialcalc:version:") return ETH.to_sheet(opts.type == "string" ? str : utf8read(str), opts);
        return prn_to_sheet_str(str, opts);
    }
    function prn_to_workbook(d /*:RawData*/ , opts) /*:Workbook*/ {
        return sheet_to_workbook(prn_to_sheet(d, opts), opts);
    }
    function sheet_to_prn(ws /*:Worksheet*/  /*::, opts:?any*/ ) /*:string*/ {
        var o /*:Array<string>*/  = [];
        var r = safe_decode_range(ws["!ref"]), cell /*:Cell*/ ;
        var dense = Array.isArray(ws);
        for(var R = r.s.r; R <= r.e.r; ++R){
            var oo /*:Array<string>*/  = [];
            for(var C = r.s.c; C <= r.e.c; ++C){
                var coord = encode_cell({
                    r: R,
                    c: C
                });
                cell = dense ? (ws[R] || [])[C] : ws[coord];
                if (!cell || cell.v == null) {
                    oo.push("          ");
                    continue;
                }
                var w = (cell.w || (format_cell(cell), cell.w) || "").slice(0, 10);
                while(w.length < 10)w += " ";
                oo.push(w + (C === 0 ? " " : ""));
            }
            o.push(oo.join(""));
        }
        return o.join("\n");
    }
    return {
        to_workbook: prn_to_workbook,
        to_sheet: prn_to_sheet,
        from_sheet: sheet_to_prn
    };
}();
/* Excel defaults to SYLK but warns if data is not valid */ function read_wb_ID(d, opts) {
    var o = opts || {}, OLD_WTF = !!o.WTF;
    o.WTF = true;
    try {
        var out = SYLK.to_workbook(d, o);
        o.WTF = OLD_WTF;
        return out;
    } catch (e) {
        o.WTF = OLD_WTF;
        if (!e.message.match(/SYLK bad record ID/) && OLD_WTF) throw e;
        return PRN.to_workbook(d, opts);
    }
}
var WK_ = /*#__PURE__*/ function() {
    function lotushopper(data, cb /*:RecordHopperCB*/ , opts /*:any*/ ) {
        if (!data) return;
        prep_blob(data, data.l || 0);
        var Enum = opts.Enum || WK1Enum;
        while(data.l < data.length){
            var RT = data.read_shift(2);
            var R = Enum[RT] || Enum[0xFFFF];
            var length = data.read_shift(2);
            var tgt = data.l + length;
            var d = R.f && R.f(data, length, opts);
            data.l = tgt;
            if (cb(d, R, RT)) return;
        }
    }
    function lotus_to_workbook(d /*:RawData*/ , opts) {
        switch(opts.type){
            case "base64":
                return lotus_to_workbook_buf(s2a(Base64_decode(d)), opts);
            case "binary":
                return lotus_to_workbook_buf(s2a(d), opts);
            case "buffer":
            case "array":
                return lotus_to_workbook_buf(d, opts);
        }
        throw "Unsupported type " + opts.type;
    }
    function lotus_to_workbook_buf(d, opts) /*:Workbook*/ {
        if (!d) return d;
        var o = opts || {};
        if (DENSE != null && o.dense == null) o.dense = DENSE;
        var s /*:Worksheet*/  = o.dense ? [] : {}, n = "Sheet1", next_n = "", sidx = 0;
        var sheets = {}, snames = [], realnames = [];
        var refguess = {
            s: {
                r: 0,
                c: 0
            },
            e: {
                r: 0,
                c: 0
            }
        };
        var sheetRows = o.sheetRows || 0;
        if (d[2] == 0x00) {
            if (d[3] == 0x08 || d[3] == 0x09) {
                if (d.length >= 16 && d[14] == 0x05 && d[15] === 0x6c) throw new Error("Unsupported Works 3 for Mac file");
            }
        }
        if (d[2] == 0x02) {
            o.Enum = WK1Enum;
            lotushopper(d, function(val, R, RT) {
                switch(RT){
                    case 0x00:
                        /* BOF */ o.vers = val;
                        if (val >= 0x1000) o.qpro = true;
                        break;
                    case 0x06:
                        refguess = val;
                        break; /* RANGE */ 
                    case 0xCC:
                        if (val) next_n = val;
                        break; /* SHEETNAMECS */ 
                    case 0xDE:
                        next_n = val;
                        break; /* SHEETNAMELP */ 
                    case 0x0F:
                    /* LABEL */ case 0x33:
                        /* STRING */ if (!o.qpro) val[1].v = val[1].v.slice(1);
                    /* falls through */ case 0x0D:
                    /* INTEGER */ case 0x0E:
                    /* NUMBER */ case 0x10:
                        /* FORMULA */ /* TODO: actual translation of the format code */ if (RT == 0x0E && (val[2] & 0x70) == 0x70 && (val[2] & 0x0F) > 1 && (val[2] & 0x0F) < 15) {
                            val[1].z = o.dateNF || table_fmt[14];
                            if (o.cellDates) {
                                val[1].t = "d";
                                val[1].v = numdate(val[1].v);
                            }
                        }
                        if (o.qpro) {
                            if (val[3] > sidx) {
                                s["!ref"] = encode_range(refguess);
                                sheets[n] = s;
                                snames.push(n);
                                s = o.dense ? [] : {};
                                refguess = {
                                    s: {
                                        r: 0,
                                        c: 0
                                    },
                                    e: {
                                        r: 0,
                                        c: 0
                                    }
                                };
                                sidx = val[3];
                                n = next_n || "Sheet" + (sidx + 1);
                                next_n = "";
                            }
                        }
                        var tmpcell = o.dense ? (s[val[0].r] || [])[val[0].c] : s[encode_cell(val[0])];
                        if (tmpcell) {
                            tmpcell.t = val[1].t;
                            tmpcell.v = val[1].v;
                            if (val[1].z != null) tmpcell.z = val[1].z;
                            if (val[1].f != null) tmpcell.f = val[1].f;
                            break;
                        }
                        if (o.dense) {
                            if (!s[val[0].r]) s[val[0].r] = [];
                            s[val[0].r][val[0].c] = val[1];
                        } else s[encode_cell(val[0])] = val[1];
                        break;
                    default:
                }
            }, o);
        } else if (d[2] == 0x1A || d[2] == 0x0E) {
            o.Enum = WK3Enum;
            if (d[2] == 0x0E) {
                o.qpro = true;
                d.l = 0;
            }
            lotushopper(d, function(val, R, RT) {
                switch(RT){
                    case 0xCC:
                        n = val;
                        break; /* SHEETNAMECS */ 
                    case 0x16:
                        /* LABEL16 */ val[1].v = val[1].v.slice(1);
                    /* falls through */ case 0x17:
                    /* NUMBER17 */ case 0x18:
                    /* NUMBER18 */ case 0x19:
                    /* FORMULA19 */ case 0x25:
                    /* NUMBER25 */ case 0x27:
                    /* NUMBER27 */ case 0x28:
                        /* FORMULA28 */ if (val[3] > sidx) {
                            s["!ref"] = encode_range(refguess);
                            sheets[n] = s;
                            snames.push(n);
                            s = o.dense ? [] : {};
                            refguess = {
                                s: {
                                    r: 0,
                                    c: 0
                                },
                                e: {
                                    r: 0,
                                    c: 0
                                }
                            };
                            sidx = val[3];
                            n = "Sheet" + (sidx + 1);
                        }
                        if (sheetRows > 0 && val[0].r >= sheetRows) break;
                        if (o.dense) {
                            if (!s[val[0].r]) s[val[0].r] = [];
                            s[val[0].r][val[0].c] = val[1];
                        } else s[encode_cell(val[0])] = val[1];
                        if (refguess.e.c < val[0].c) refguess.e.c = val[0].c;
                        if (refguess.e.r < val[0].r) refguess.e.r = val[0].r;
                        break;
                    case 0x1B:
                        /* XFORMAT */ if (val[0x36b0]) realnames[val[0x36b0][0]] = val[0x36b0][1];
                        break;
                    case 0x0601:
                        /* SHEETINFOQP */ realnames[val[0]] = val[1];
                        if (val[0] == sidx) n = val[1];
                        break;
                    default:
                        break;
                }
            }, o);
        } else throw new Error("Unrecognized LOTUS BOF " + d[2]);
        s["!ref"] = encode_range(refguess);
        sheets[next_n || n] = s;
        snames.push(next_n || n);
        if (!realnames.length) return {
            SheetNames: snames,
            Sheets: sheets
        };
        var osheets = {}, rnames = [];
        /* TODO: verify no collisions */ for(var i = 0; i < realnames.length; ++i)if (sheets[snames[i]]) {
            rnames.push(realnames[i] || snames[i]);
            osheets[realnames[i]] = sheets[realnames[i]] || sheets[snames[i]];
        } else {
            rnames.push(realnames[i]);
            osheets[realnames[i]] = {
                "!ref": "A1"
            };
        }
        return {
            SheetNames: rnames,
            Sheets: osheets
        };
    }
    function sheet_to_wk1(ws /*:Worksheet*/ , opts /*:WriteOpts*/ ) {
        var o = opts || {};
        if (+o.codepage >= 0) set_cp(+o.codepage);
        if (o.type == "string") throw new Error("Cannot write WK1 to JS string");
        var ba = buf_array();
        var range = safe_decode_range(ws["!ref"]);
        var dense = Array.isArray(ws);
        var cols = [];
        write_biff_rec(ba, 0x00, write_BOF_WK1(0x0406));
        write_biff_rec(ba, 0x06, write_RANGE(range));
        var max_R = Math.min(range.e.r, 8191);
        for(var R = range.s.r; R <= max_R; ++R){
            var rr = encode_row(R);
            for(var C = range.s.c; C <= range.e.c; ++C){
                if (R === range.s.r) cols[C] = encode_col(C);
                var ref = cols[C] + rr;
                var cell = dense ? (ws[R] || [])[C] : ws[ref];
                if (!cell || cell.t == "z") continue;
                /* TODO: formula records */ if (cell.t == "n") {
                    if ((cell.v | 0) == cell.v && cell.v >= -32768 && cell.v <= 32767) write_biff_rec(ba, 0x0d, write_INTEGER(R, C, cell.v));
                    else write_biff_rec(ba, 0x0e, write_NUMBER(R, C, cell.v));
                } else {
                    var str = format_cell(cell);
                    write_biff_rec(ba, 0x0F, write_LABEL(R, C, str.slice(0, 239)));
                }
            }
        }
        write_biff_rec(ba, 0x01);
        return ba.end();
    }
    function book_to_wk3(wb /*:Workbook*/ , opts /*:WriteOpts*/ ) {
        var o = opts || {};
        if (+o.codepage >= 0) set_cp(+o.codepage);
        if (o.type == "string") throw new Error("Cannot write WK3 to JS string");
        var ba = buf_array();
        write_biff_rec(ba, 0x00, write_BOF_WK3(wb));
        for(var i = 0, cnt = 0; i < wb.SheetNames.length; ++i)if ((wb.Sheets[wb.SheetNames[i]] || {})["!ref"]) write_biff_rec(ba, 0x1b, write_XFORMAT_SHEETNAME(wb.SheetNames[i], cnt++));
        var wsidx = 0;
        for(i = 0; i < wb.SheetNames.length; ++i){
            var ws = wb.Sheets[wb.SheetNames[i]];
            if (!ws || !ws["!ref"]) continue;
            var range = safe_decode_range(ws["!ref"]);
            var dense = Array.isArray(ws);
            var cols = [];
            var max_R = Math.min(range.e.r, 8191);
            for(var R = range.s.r; R <= max_R; ++R){
                var rr = encode_row(R);
                for(var C = range.s.c; C <= range.e.c; ++C){
                    if (R === range.s.r) cols[C] = encode_col(C);
                    var ref = cols[C] + rr;
                    var cell = dense ? (ws[R] || [])[C] : ws[ref];
                    if (!cell || cell.t == "z") continue;
                    /* TODO: FORMULA19 NUMBER18 records */ if (cell.t == "n") write_biff_rec(ba, 0x17, write_NUMBER_17(R, C, wsidx, cell.v));
                    else {
                        var str = format_cell(cell);
                        /* TODO: max len? */ write_biff_rec(ba, 0x16, write_LABEL_16(R, C, wsidx, str.slice(0, 239)));
                    }
                }
            }
            ++wsidx;
        }
        write_biff_rec(ba, 0x01);
        return ba.end();
    }
    function write_BOF_WK1(v /*:number*/ ) {
        var out = new_buf(2);
        out.write_shift(2, v);
        return out;
    }
    function write_BOF_WK3(wb /*:Workbook*/ ) {
        var out = new_buf(26);
        out.write_shift(2, 0x1000);
        out.write_shift(2, 0x0004);
        out.write_shift(4, 0x0000);
        var rows = 0, cols = 0, wscnt = 0;
        for(var i = 0; i < wb.SheetNames.length; ++i){
            var name = wb.SheetNames[i];
            var ws = wb.Sheets[name];
            if (!ws || !ws["!ref"]) continue;
            ++wscnt;
            var range = decode_range(ws["!ref"]);
            if (rows < range.e.r) rows = range.e.r;
            if (cols < range.e.c) cols = range.e.c;
        }
        if (rows > 8191) rows = 8191;
        out.write_shift(2, rows);
        out.write_shift(1, wscnt);
        out.write_shift(1, cols);
        out.write_shift(2, 0x00);
        out.write_shift(2, 0x00);
        out.write_shift(1, 0x01);
        out.write_shift(1, 0x02);
        out.write_shift(4, 0);
        out.write_shift(4, 0);
        return out;
    }
    function parse_RANGE(blob, length, opts) {
        var o = {
            s: {
                c: 0,
                r: 0
            },
            e: {
                c: 0,
                r: 0
            }
        };
        if (length == 8 && opts.qpro) {
            o.s.c = blob.read_shift(1);
            blob.l++;
            o.s.r = blob.read_shift(2);
            o.e.c = blob.read_shift(1);
            blob.l++;
            o.e.r = blob.read_shift(2);
            return o;
        }
        o.s.c = blob.read_shift(2);
        o.s.r = blob.read_shift(2);
        if (length == 12 && opts.qpro) blob.l += 2;
        o.e.c = blob.read_shift(2);
        o.e.r = blob.read_shift(2);
        if (length == 12 && opts.qpro) blob.l += 2;
        if (o.s.c == 0xFFFF) o.s.c = o.e.c = o.s.r = o.e.r = 0;
        return o;
    }
    function write_RANGE(range) {
        var out = new_buf(8);
        out.write_shift(2, range.s.c);
        out.write_shift(2, range.s.r);
        out.write_shift(2, range.e.c);
        out.write_shift(2, range.e.r);
        return out;
    }
    function parse_cell(blob, length, opts) {
        var o = [
            {
                c: 0,
                r: 0
            },
            {
                t: "n",
                v: 0
            },
            0,
            0
        ];
        if (opts.qpro && opts.vers != 0x5120) {
            o[0].c = blob.read_shift(1);
            o[3] = blob.read_shift(1);
            o[0].r = blob.read_shift(2);
            blob.l += 2;
        } else {
            o[2] = blob.read_shift(1);
            o[0].c = blob.read_shift(2);
            o[0].r = blob.read_shift(2);
        }
        return o;
    }
    function parse_LABEL(blob, length, opts) {
        var tgt = blob.l + length;
        var o = parse_cell(blob, length, opts);
        o[1].t = "s";
        if (opts.vers == 0x5120) {
            blob.l++;
            var len = blob.read_shift(1);
            o[1].v = blob.read_shift(len, "utf8");
            return o;
        }
        if (opts.qpro) blob.l++;
        o[1].v = blob.read_shift(tgt - blob.l, "cstr");
        return o;
    }
    function write_LABEL(R, C, s) {
        /* TODO: encoding */ var o = new_buf(7 + s.length);
        o.write_shift(1, 0xFF);
        o.write_shift(2, C);
        o.write_shift(2, R);
        o.write_shift(1, 0x27); // ??
        for(var i = 0; i < o.length; ++i){
            var cc = s.charCodeAt(i);
            o.write_shift(1, cc >= 0x80 ? 0x5F : cc);
        }
        o.write_shift(1, 0);
        return o;
    }
    function parse_INTEGER(blob, length, opts) {
        var o = parse_cell(blob, length, opts);
        o[1].v = blob.read_shift(2, "i");
        return o;
    }
    function write_INTEGER(R, C, v) {
        var o = new_buf(7);
        o.write_shift(1, 0xFF);
        o.write_shift(2, C);
        o.write_shift(2, R);
        o.write_shift(2, v, "i");
        return o;
    }
    function parse_NUMBER(blob, length, opts) {
        var o = parse_cell(blob, length, opts);
        o[1].v = blob.read_shift(8, "f");
        return o;
    }
    function write_NUMBER(R, C, v) {
        var o = new_buf(13);
        o.write_shift(1, 0xFF);
        o.write_shift(2, C);
        o.write_shift(2, R);
        o.write_shift(8, v, "f");
        return o;
    }
    function parse_FORMULA(blob, length, opts) {
        var tgt = blob.l + length;
        var o = parse_cell(blob, length, opts);
        /* TODO: formula */ o[1].v = blob.read_shift(8, "f");
        if (opts.qpro) blob.l = tgt;
        else {
            var flen = blob.read_shift(2);
            wk1_fmla_to_csf(blob.slice(blob.l, blob.l + flen), o);
            blob.l += flen;
        }
        return o;
    }
    function wk1_parse_rc(B, V, col) {
        var rel = V & 0x8000;
        V &= -32769;
        V = (rel ? B : 0) + (V >= 0x2000 ? V - 0x4000 : V);
        return (rel ? "" : "$") + (col ? encode_col(V) : encode_row(V));
    }
    /* var oprec = [
		8, 8, 8, 8, 8, 8, 8, 8, 6, 4, 4, 5, 5, 7, 3, 3,
		3, 3, 3, 3, 1, 1, 2, 6, 8, 8, 8, 8, 8, 8, 8, 8
	]; */ /* TODO: flesh out */ var FuncTab = {
        0x33: [
            "FALSE",
            0
        ],
        0x34: [
            "TRUE",
            0
        ],
        0x46: [
            "LEN",
            1
        ],
        0x50: [
            "SUM",
            69
        ],
        0x51: [
            "AVERAGEA",
            69
        ],
        0x52: [
            "COUNTA",
            69
        ],
        0x53: [
            "MINA",
            69
        ],
        0x54: [
            "MAXA",
            69
        ],
        0x6F: [
            "T",
            1
        ]
    };
    var BinOpTab = [
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "+",
        "-",
        "*",
        "/",
        "^",
        "=",
        "<>",
        "<=",
        ">=",
        "<",
        ">",
        "",
        "",
        "",
        "",
        "&",
        "",
        "",
        "",
        "",
        "",
        "",
        "" // eslint-disable-line no-mixed-spaces-and-tabs
    ];
    function wk1_fmla_to_csf(blob, o) {
        prep_blob(blob, 0);
        var out = [], argc = 0, R = "", C = "", argL = "", argR = "";
        while(blob.l < blob.length){
            var cc = blob[blob.l++];
            switch(cc){
                case 0x00:
                    out.push(blob.read_shift(8, "f"));
                    break;
                case 0x01:
                    C = wk1_parse_rc(o[0].c, blob.read_shift(2), true);
                    R = wk1_parse_rc(o[0].r, blob.read_shift(2), false);
                    out.push(C + R);
                    break;
                case 0x02:
                    var c = wk1_parse_rc(o[0].c, blob.read_shift(2), true);
                    var r = wk1_parse_rc(o[0].r, blob.read_shift(2), false);
                    C = wk1_parse_rc(o[0].c, blob.read_shift(2), true);
                    R = wk1_parse_rc(o[0].r, blob.read_shift(2), false);
                    out.push(c + r + ":" + C + R);
                    break;
                case 0x03:
                    if (blob.l < blob.length) {
                        console.error("WK1 premature formula end");
                        return;
                    }
                    break;
                case 0x04:
                    out.push("(" + out.pop() + ")");
                    break;
                case 0x05:
                    out.push(blob.read_shift(2));
                    break;
                case 0x06:
                    /* TODO: text encoding */ var Z = "";
                    while(cc = blob[blob.l++])Z += String.fromCharCode(cc);
                    out.push('"' + Z.replace(/"/g, '""') + '"');
                    break;
                case 0x08:
                    out.push("-" + out.pop());
                    break;
                case 0x17:
                    out.push("+" + out.pop());
                    break;
                case 0x16:
                    out.push("NOT(" + out.pop() + ")");
                    break;
                case 0x14:
                case 0x15:
                    argR = out.pop();
                    argL = out.pop();
                    out.push([
                        "AND",
                        "OR"
                    ][cc - 0x14] + "(" + argL + "," + argR + ")");
                    break;
                default:
                    if (cc < 0x20 && BinOpTab[cc]) {
                        argR = out.pop();
                        argL = out.pop();
                        out.push(argL + BinOpTab[cc] + argR);
                    } else if (FuncTab[cc]) {
                        argc = FuncTab[cc][1];
                        if (argc == 69) argc = blob[blob.l++];
                        if (argc > out.length) {
                            console.error("WK1 bad formula parse 0x" + cc.toString(16) + ":|" + out.join("|") + "|");
                            return;
                        }
                        var args = out.slice(-argc);
                        out.length -= argc;
                        out.push(FuncTab[cc][0] + "(" + args.join(",") + ")");
                    } else if (cc <= 0x07) return console.error("WK1 invalid opcode " + cc.toString(16));
                    else if (cc <= 0x18) return console.error("WK1 unsupported op " + cc.toString(16));
                    else if (cc <= 0x1E) return console.error("WK1 invalid opcode " + cc.toString(16));
                    else if (cc <= 0x73) return console.error("WK1 unsupported function opcode " + cc.toString(16));
                    else return console.error("WK1 unrecognized opcode " + cc.toString(16));
            }
        }
        if (out.length == 1) o[1].f = "" + out[0];
        else console.error("WK1 bad formula parse |" + out.join("|") + "|");
    }
    function parse_cell_3(blob /*::, length*/ ) {
        var o = [
            {
                c: 0,
                r: 0
            },
            {
                t: "n",
                v: 0
            },
            0
        ];
        o[0].r = blob.read_shift(2);
        o[3] = blob[blob.l++];
        o[0].c = blob[blob.l++];
        return o;
    }
    function parse_LABEL_16(blob, length) {
        var o = parse_cell_3(blob, length);
        o[1].t = "s";
        o[1].v = blob.read_shift(length - 4, "cstr");
        return o;
    }
    function write_LABEL_16(R, C, wsidx, s) {
        /* TODO: encoding */ var o = new_buf(6 + s.length);
        o.write_shift(2, R);
        o.write_shift(1, wsidx);
        o.write_shift(1, C);
        o.write_shift(1, 0x27);
        for(var i = 0; i < s.length; ++i){
            var cc = s.charCodeAt(i);
            o.write_shift(1, cc >= 0x80 ? 0x5F : cc);
        }
        o.write_shift(1, 0);
        return o;
    }
    function parse_NUMBER_18(blob, length) {
        var o = parse_cell_3(blob, length);
        o[1].v = blob.read_shift(2);
        var v = o[1].v >> 1;
        if (o[1].v & 0x1) switch(v & 0x07){
            case 0:
                v = (v >> 3) * 5000;
                break;
            case 1:
                v = (v >> 3) * 500;
                break;
            case 2:
                v = (v >> 3) / 20;
                break;
            case 3:
                v = (v >> 3) / 200;
                break;
            case 4:
                v = (v >> 3) / 2000;
                break;
            case 5:
                v = (v >> 3) / 20000;
                break;
            case 6:
                v = (v >> 3) / 16;
                break;
            case 7:
                v = (v >> 3) / 64;
                break;
        }
        o[1].v = v;
        return o;
    }
    function parse_NUMBER_17(blob, length) {
        var o = parse_cell_3(blob, length);
        var v1 = blob.read_shift(4);
        var v2 = blob.read_shift(4);
        var e = blob.read_shift(2);
        if (e == 0xFFFF) {
            if (v1 === 0 && v2 === 0xC0000000) {
                o[1].t = "e";
                o[1].v = 0x0F;
            } else if (v1 === 0 && v2 === 0xD0000000) {
                o[1].t = "e";
                o[1].v = 0x2A;
            } else o[1].v = 0;
            return o;
        }
        var s = e & 0x8000;
        e = (e & 0x7FFF) - 16446;
        o[1].v = (1 - s * 2) * (v2 * Math.pow(2, e + 32) + v1 * Math.pow(2, e));
        return o;
    }
    function write_NUMBER_17(R, C, wsidx, v) {
        var o = new_buf(14);
        o.write_shift(2, R);
        o.write_shift(1, wsidx);
        o.write_shift(1, C);
        if (v == 0) {
            o.write_shift(4, 0);
            o.write_shift(4, 0);
            o.write_shift(2, 0xFFFF);
            return o;
        }
        var s = 0, e = 0, v1 = 0, v2 = 0;
        if (v < 0) {
            s = 1;
            v = -v;
        }
        e = Math.log2(v) | 0;
        v /= Math.pow(2, e - 31);
        v2 = v >>> 0;
        if ((v2 & 0x80000000) == 0) {
            v /= 2;
            ++e;
            v2 = v >>> 0;
        }
        v -= v2;
        v2 |= 0x80000000;
        v2 >>>= 0;
        v *= Math.pow(2, 32);
        v1 = v >>> 0;
        o.write_shift(4, v1);
        o.write_shift(4, v2);
        e += 0x3FFF + (s ? 0x8000 : 0);
        o.write_shift(2, e);
        return o;
    }
    function parse_FORMULA_19(blob, length) {
        var o = parse_NUMBER_17(blob, 14);
        blob.l += length - 14; /* TODO: WK3 formula */ 
        return o;
    }
    function parse_NUMBER_25(blob, length) {
        var o = parse_cell_3(blob, length);
        var v1 = blob.read_shift(4);
        o[1].v = v1 >> 6;
        return o;
    }
    function parse_NUMBER_27(blob, length) {
        var o = parse_cell_3(blob, length);
        var v1 = blob.read_shift(8, "f");
        o[1].v = v1;
        return o;
    }
    function parse_FORMULA_28(blob, length) {
        var o = parse_NUMBER_27(blob, 14);
        blob.l += length - 10; /* TODO: formula */ 
        return o;
    }
    function parse_SHEETNAMECS(blob, length) {
        return blob[blob.l + length - 1] == 0 ? blob.read_shift(length, "cstr") : "";
    }
    function parse_SHEETNAMELP(blob, length) {
        var len = blob[blob.l++];
        if (len > length - 1) len = length - 1;
        var o = "";
        while(o.length < len)o += String.fromCharCode(blob[blob.l++]);
        return o;
    }
    function parse_SHEETINFOQP(blob, length, opts) {
        if (!opts.qpro || length < 21) return;
        var id = blob.read_shift(1);
        blob.l += 17;
        blob.l += 1; //var len = blob.read_shift(1);
        blob.l += 2;
        var nm = blob.read_shift(length - 21, "cstr");
        return [
            id,
            nm
        ];
    }
    function parse_XFORMAT(blob, length) {
        var o = {}, tgt = blob.l + length;
        while(blob.l < tgt){
            var dt = blob.read_shift(2);
            if (dt == 0x36b0) {
                o[dt] = [
                    0,
                    ""
                ];
                o[dt][0] = blob.read_shift(2);
                while(blob[blob.l]){
                    o[dt][1] += String.fromCharCode(blob[blob.l]);
                    blob.l++;
                }
                blob.l++;
            }
        // TODO: 0x3a99 ??
        }
        return o;
    }
    function write_XFORMAT_SHEETNAME(name, wsidx) {
        var out = new_buf(5 + name.length);
        out.write_shift(2, 0x36b0);
        out.write_shift(2, wsidx);
        for(var i = 0; i < name.length; ++i){
            var cc = name.charCodeAt(i);
            out[out.l++] = cc > 0x7F ? 0x5F : cc;
        }
        out[out.l++] = 0;
        return out;
    }
    var WK1Enum = {
        /*::[*/ 0x0000: {
            n: "BOF",
            f: parseuint16
        },
        /*::[*/ 0x0001: {
            n: "EOF"
        },
        /*::[*/ 0x0002: {
            n: "CALCMODE"
        },
        /*::[*/ 0x0003: {
            n: "CALCORDER"
        },
        /*::[*/ 0x0004: {
            n: "SPLIT"
        },
        /*::[*/ 0x0005: {
            n: "SYNC"
        },
        /*::[*/ 0x0006: {
            n: "RANGE",
            f: parse_RANGE
        },
        /*::[*/ 0x0007: {
            n: "WINDOW1"
        },
        /*::[*/ 0x0008: {
            n: "COLW1"
        },
        /*::[*/ 0x0009: {
            n: "WINTWO"
        },
        /*::[*/ 0x000A: {
            n: "COLW2"
        },
        /*::[*/ 0x000B: {
            n: "NAME"
        },
        /*::[*/ 0x000C: {
            n: "BLANK"
        },
        /*::[*/ 0x000D: {
            n: "INTEGER",
            f: parse_INTEGER
        },
        /*::[*/ 0x000E: {
            n: "NUMBER",
            f: parse_NUMBER
        },
        /*::[*/ 0x000F: {
            n: "LABEL",
            f: parse_LABEL
        },
        /*::[*/ 0x0010: {
            n: "FORMULA",
            f: parse_FORMULA
        },
        /*::[*/ 0x0018: {
            n: "TABLE"
        },
        /*::[*/ 0x0019: {
            n: "ORANGE"
        },
        /*::[*/ 0x001A: {
            n: "PRANGE"
        },
        /*::[*/ 0x001B: {
            n: "SRANGE"
        },
        /*::[*/ 0x001C: {
            n: "FRANGE"
        },
        /*::[*/ 0x001D: {
            n: "KRANGE1"
        },
        /*::[*/ 0x0020: {
            n: "HRANGE"
        },
        /*::[*/ 0x0023: {
            n: "KRANGE2"
        },
        /*::[*/ 0x0024: {
            n: "PROTEC"
        },
        /*::[*/ 0x0025: {
            n: "FOOTER"
        },
        /*::[*/ 0x0026: {
            n: "HEADER"
        },
        /*::[*/ 0x0027: {
            n: "SETUP"
        },
        /*::[*/ 0x0028: {
            n: "MARGINS"
        },
        /*::[*/ 0x0029: {
            n: "LABELFMT"
        },
        /*::[*/ 0x002A: {
            n: "TITLES"
        },
        /*::[*/ 0x002B: {
            n: "SHEETJS"
        },
        /*::[*/ 0x002D: {
            n: "GRAPH"
        },
        /*::[*/ 0x002E: {
            n: "NGRAPH"
        },
        /*::[*/ 0x002F: {
            n: "CALCCOUNT"
        },
        /*::[*/ 0x0030: {
            n: "UNFORMATTED"
        },
        /*::[*/ 0x0031: {
            n: "CURSORW12"
        },
        /*::[*/ 0x0032: {
            n: "WINDOW"
        },
        /*::[*/ 0x0033: {
            n: "STRING",
            f: parse_LABEL
        },
        /*::[*/ 0x0037: {
            n: "PASSWORD"
        },
        /*::[*/ 0x0038: {
            n: "LOCKED"
        },
        /*::[*/ 0x003C: {
            n: "QUERY"
        },
        /*::[*/ 0x003D: {
            n: "QUERYNAME"
        },
        /*::[*/ 0x003E: {
            n: "PRINT"
        },
        /*::[*/ 0x003F: {
            n: "PRINTNAME"
        },
        /*::[*/ 0x0040: {
            n: "GRAPH2"
        },
        /*::[*/ 0x0041: {
            n: "GRAPHNAME"
        },
        /*::[*/ 0x0042: {
            n: "ZOOM"
        },
        /*::[*/ 0x0043: {
            n: "SYMSPLIT"
        },
        /*::[*/ 0x0044: {
            n: "NSROWS"
        },
        /*::[*/ 0x0045: {
            n: "NSCOLS"
        },
        /*::[*/ 0x0046: {
            n: "RULER"
        },
        /*::[*/ 0x0047: {
            n: "NNAME"
        },
        /*::[*/ 0x0048: {
            n: "ACOMM"
        },
        /*::[*/ 0x0049: {
            n: "AMACRO"
        },
        /*::[*/ 0x004A: {
            n: "PARSE"
        },
        /*::[*/ 0x0066: {
            n: "PRANGES??"
        },
        /*::[*/ 0x0067: {
            n: "RRANGES??"
        },
        /*::[*/ 0x0068: {
            n: "FNAME??"
        },
        /*::[*/ 0x0069: {
            n: "MRANGES??"
        },
        /*::[*/ 0x00CC: {
            n: "SHEETNAMECS",
            f: parse_SHEETNAMECS
        },
        /*::[*/ 0x00DE: {
            n: "SHEETNAMELP",
            f: parse_SHEETNAMELP
        },
        /*::[*/ 0xFFFF: {
            n: ""
        }
    };
    var WK3Enum = {
        /*::[*/ 0x0000: {
            n: "BOF"
        },
        /*::[*/ 0x0001: {
            n: "EOF"
        },
        /*::[*/ 0x0002: {
            n: "PASSWORD"
        },
        /*::[*/ 0x0003: {
            n: "CALCSET"
        },
        /*::[*/ 0x0004: {
            n: "WINDOWSET"
        },
        /*::[*/ 0x0005: {
            n: "SHEETCELLPTR"
        },
        /*::[*/ 0x0006: {
            n: "SHEETLAYOUT"
        },
        /*::[*/ 0x0007: {
            n: "COLUMNWIDTH"
        },
        /*::[*/ 0x0008: {
            n: "HIDDENCOLUMN"
        },
        /*::[*/ 0x0009: {
            n: "USERRANGE"
        },
        /*::[*/ 0x000A: {
            n: "SYSTEMRANGE"
        },
        /*::[*/ 0x000B: {
            n: "ZEROFORCE"
        },
        /*::[*/ 0x000C: {
            n: "SORTKEYDIR"
        },
        /*::[*/ 0x000D: {
            n: "FILESEAL"
        },
        /*::[*/ 0x000E: {
            n: "DATAFILLNUMS"
        },
        /*::[*/ 0x000F: {
            n: "PRINTMAIN"
        },
        /*::[*/ 0x0010: {
            n: "PRINTSTRING"
        },
        /*::[*/ 0x0011: {
            n: "GRAPHMAIN"
        },
        /*::[*/ 0x0012: {
            n: "GRAPHSTRING"
        },
        /*::[*/ 0x0013: {
            n: "??"
        },
        /*::[*/ 0x0014: {
            n: "ERRCELL"
        },
        /*::[*/ 0x0015: {
            n: "NACELL"
        },
        /*::[*/ 0x0016: {
            n: "LABEL16",
            f: parse_LABEL_16
        },
        /*::[*/ 0x0017: {
            n: "NUMBER17",
            f: parse_NUMBER_17
        },
        /*::[*/ 0x0018: {
            n: "NUMBER18",
            f: parse_NUMBER_18
        },
        /*::[*/ 0x0019: {
            n: "FORMULA19",
            f: parse_FORMULA_19
        },
        /*::[*/ 0x001A: {
            n: "FORMULA1A"
        },
        /*::[*/ 0x001B: {
            n: "XFORMAT",
            f: parse_XFORMAT
        },
        /*::[*/ 0x001C: {
            n: "DTLABELMISC"
        },
        /*::[*/ 0x001D: {
            n: "DTLABELCELL"
        },
        /*::[*/ 0x001E: {
            n: "GRAPHWINDOW"
        },
        /*::[*/ 0x001F: {
            n: "CPA"
        },
        /*::[*/ 0x0020: {
            n: "LPLAUTO"
        },
        /*::[*/ 0x0021: {
            n: "QUERY"
        },
        /*::[*/ 0x0022: {
            n: "HIDDENSHEET"
        },
        /*::[*/ 0x0023: {
            n: "??"
        },
        /*::[*/ 0x0025: {
            n: "NUMBER25",
            f: parse_NUMBER_25
        },
        /*::[*/ 0x0026: {
            n: "??"
        },
        /*::[*/ 0x0027: {
            n: "NUMBER27",
            f: parse_NUMBER_27
        },
        /*::[*/ 0x0028: {
            n: "FORMULA28",
            f: parse_FORMULA_28
        },
        /*::[*/ 0x008E: {
            n: "??"
        },
        /*::[*/ 0x0093: {
            n: "??"
        },
        /*::[*/ 0x0096: {
            n: "??"
        },
        /*::[*/ 0x0097: {
            n: "??"
        },
        /*::[*/ 0x0098: {
            n: "??"
        },
        /*::[*/ 0x0099: {
            n: "??"
        },
        /*::[*/ 0x009A: {
            n: "??"
        },
        /*::[*/ 0x009B: {
            n: "??"
        },
        /*::[*/ 0x009C: {
            n: "??"
        },
        /*::[*/ 0x00A3: {
            n: "??"
        },
        /*::[*/ 0x00AE: {
            n: "??"
        },
        /*::[*/ 0x00AF: {
            n: "??"
        },
        /*::[*/ 0x00B0: {
            n: "??"
        },
        /*::[*/ 0x00B1: {
            n: "??"
        },
        /*::[*/ 0x00B8: {
            n: "??"
        },
        /*::[*/ 0x00B9: {
            n: "??"
        },
        /*::[*/ 0x00BA: {
            n: "??"
        },
        /*::[*/ 0x00BB: {
            n: "??"
        },
        /*::[*/ 0x00BC: {
            n: "??"
        },
        /*::[*/ 0x00C3: {
            n: "??"
        },
        /*::[*/ 0x00C9: {
            n: "??"
        },
        /*::[*/ 0x00CC: {
            n: "SHEETNAMECS",
            f: parse_SHEETNAMECS
        },
        /*::[*/ 0x00CD: {
            n: "??"
        },
        /*::[*/ 0x00CE: {
            n: "??"
        },
        /*::[*/ 0x00CF: {
            n: "??"
        },
        /*::[*/ 0x00D0: {
            n: "??"
        },
        /*::[*/ 0x0100: {
            n: "??"
        },
        /*::[*/ 0x0103: {
            n: "??"
        },
        /*::[*/ 0x0104: {
            n: "??"
        },
        /*::[*/ 0x0105: {
            n: "??"
        },
        /*::[*/ 0x0106: {
            n: "??"
        },
        /*::[*/ 0x0107: {
            n: "??"
        },
        /*::[*/ 0x0109: {
            n: "??"
        },
        /*::[*/ 0x010A: {
            n: "??"
        },
        /*::[*/ 0x010B: {
            n: "??"
        },
        /*::[*/ 0x010C: {
            n: "??"
        },
        /*::[*/ 0x010E: {
            n: "??"
        },
        /*::[*/ 0x010F: {
            n: "??"
        },
        /*::[*/ 0x0180: {
            n: "??"
        },
        /*::[*/ 0x0185: {
            n: "??"
        },
        /*::[*/ 0x0186: {
            n: "??"
        },
        /*::[*/ 0x0189: {
            n: "??"
        },
        /*::[*/ 0x018C: {
            n: "??"
        },
        /*::[*/ 0x0200: {
            n: "??"
        },
        /*::[*/ 0x0202: {
            n: "??"
        },
        /*::[*/ 0x0201: {
            n: "??"
        },
        /*::[*/ 0x0204: {
            n: "??"
        },
        /*::[*/ 0x0205: {
            n: "??"
        },
        /*::[*/ 0x0280: {
            n: "??"
        },
        /*::[*/ 0x0281: {
            n: "??"
        },
        /*::[*/ 0x0282: {
            n: "??"
        },
        /*::[*/ 0x0283: {
            n: "??"
        },
        /*::[*/ 0x0284: {
            n: "??"
        },
        /*::[*/ 0x0285: {
            n: "??"
        },
        /*::[*/ 0x0286: {
            n: "??"
        },
        /*::[*/ 0x0287: {
            n: "??"
        },
        /*::[*/ 0x0288: {
            n: "??"
        },
        /*::[*/ 0x0292: {
            n: "??"
        },
        /*::[*/ 0x0293: {
            n: "??"
        },
        /*::[*/ 0x0294: {
            n: "??"
        },
        /*::[*/ 0x0295: {
            n: "??"
        },
        /*::[*/ 0x0296: {
            n: "??"
        },
        /*::[*/ 0x0299: {
            n: "??"
        },
        /*::[*/ 0x029A: {
            n: "??"
        },
        /*::[*/ 0x0300: {
            n: "??"
        },
        /*::[*/ 0x0304: {
            n: "??"
        },
        /*::[*/ 0x0601: {
            n: "SHEETINFOQP",
            f: parse_SHEETINFOQP
        },
        /*::[*/ 0x0640: {
            n: "??"
        },
        /*::[*/ 0x0642: {
            n: "??"
        },
        /*::[*/ 0x0701: {
            n: "??"
        },
        /*::[*/ 0x0702: {
            n: "??"
        },
        /*::[*/ 0x0703: {
            n: "??"
        },
        /*::[*/ 0x0704: {
            n: "??"
        },
        /*::[*/ 0x0780: {
            n: "??"
        },
        /*::[*/ 0x0800: {
            n: "??"
        },
        /*::[*/ 0x0801: {
            n: "??"
        },
        /*::[*/ 0x0804: {
            n: "??"
        },
        /*::[*/ 0x0A80: {
            n: "??"
        },
        /*::[*/ 0x2AF6: {
            n: "??"
        },
        /*::[*/ 0x3231: {
            n: "??"
        },
        /*::[*/ 0x6E49: {
            n: "??"
        },
        /*::[*/ 0x6F44: {
            n: "??"
        },
        /*::[*/ 0xFFFF: {
            n: ""
        }
    };
    return {
        sheet_to_wk1: sheet_to_wk1,
        book_to_wk3: book_to_wk3,
        to_workbook: lotus_to_workbook
    };
}();
/* 18.4.7 rPr CT_RPrElt */ function parse_rpr(rpr) {
    var font = {}, m = rpr.match(tagregex), i = 0;
    var pass = false;
    if (m) for(; i != m.length; ++i){
        var y = parsexmltag(m[i]);
        switch(y[0].replace(/\w*:/g, "")){
            /* 18.8.12 condense CT_BooleanProperty */ /* ** not required . */ case "<condense":
                break;
            /* 18.8.17 extend CT_BooleanProperty */ /* ** not required . */ case "<extend":
                break;
            /* 18.8.36 shadow CT_BooleanProperty */ /* ** not required . */ case "<shadow":
                if (!y.val) break;
            /* falls through */ case "<shadow>":
            case "<shadow/>":
                font.shadow = 1;
                break;
            case "</shadow>":
                break;
            /* 18.4.1 charset CT_IntProperty TODO */ case "<charset":
                if (y.val == "1") break;
                font.cp = CS2CP[parseInt(y.val, 10)];
                break;
            /* 18.4.2 outline CT_BooleanProperty TODO */ case "<outline":
                if (!y.val) break;
            /* falls through */ case "<outline>":
            case "<outline/>":
                font.outline = 1;
                break;
            case "</outline>":
                break;
            /* 18.4.5 rFont CT_FontName */ case "<rFont":
                font.name = y.val;
                break;
            /* 18.4.11 sz CT_FontSize */ case "<sz":
                font.sz = y.val;
                break;
            /* 18.4.10 strike CT_BooleanProperty */ case "<strike":
                if (!y.val) break;
            /* falls through */ case "<strike>":
            case "<strike/>":
                font.strike = 1;
                break;
            case "</strike>":
                break;
            /* 18.4.13 u CT_UnderlineProperty */ case "<u":
                if (!y.val) break;
                switch(y.val){
                    case "double":
                        font.uval = "double";
                        break;
                    case "singleAccounting":
                        font.uval = "single-accounting";
                        break;
                    case "doubleAccounting":
                        font.uval = "double-accounting";
                        break;
                }
            /* falls through */ case "<u>":
            case "<u/>":
                font.u = 1;
                break;
            case "</u>":
                break;
            /* 18.8.2 b */ case "<b":
                if (y.val == "0") break;
            /* falls through */ case "<b>":
            case "<b/>":
                font.b = 1;
                break;
            case "</b>":
                break;
            /* 18.8.26 i */ case "<i":
                if (y.val == "0") break;
            /* falls through */ case "<i>":
            case "<i/>":
                font.i = 1;
                break;
            case "</i>":
                break;
            /* 18.3.1.15 color CT_Color TODO: tint, theme, auto, indexed */ case "<color":
                if (y.rgb) font.color = y.rgb.slice(2, 8);
                break;
            case "<color>":
            case "<color/>":
            case "</color>":
                break;
            /* 18.8.18 family ST_FontFamily */ case "<family":
                font.family = y.val;
                break;
            case "<family>":
            case "<family/>":
            case "</family>":
                break;
            /* 18.4.14 vertAlign CT_VerticalAlignFontProperty TODO */ case "<vertAlign":
                font.valign = y.val;
                break;
            case "<vertAlign>":
            case "<vertAlign/>":
            case "</vertAlign>":
                break;
            /* 18.8.35 scheme CT_FontScheme TODO */ case "<scheme":
                break;
            case "<scheme>":
            case "<scheme/>":
            case "</scheme>":
                break;
            /* 18.2.10 extLst CT_ExtensionList ? */ case "<extLst":
            case "<extLst>":
            case "</extLst>":
                break;
            case "<ext":
                pass = true;
                break;
            case "</ext>":
                pass = false;
                break;
            default:
                if (y[0].charCodeAt(1) !== 47 && !pass) throw new Error("Unrecognized rich format " + y[0]);
        }
    }
    return font;
}
var parse_rs = /*#__PURE__*/ function() {
    var tregex = matchtag("t"), rpregex = matchtag("rPr");
    /* 18.4.4 r CT_RElt */ function parse_r(r) {
        /* 18.4.12 t ST_Xstring */ var t = r.match(tregex) /*, cp = 65001*/ ;
        if (!t) return {
            t: "s",
            v: ""
        };
        var o /*:Cell*/  = {
            t: "s",
            v: unescapexml(t[1])
        } /*:any*/ ;
        var rpr = r.match(rpregex);
        if (rpr) o.s = parse_rpr(rpr[1]);
        return o;
    }
    var rregex = /<(?:\w+:)?r>/g, rend = /<\/(?:\w+:)?r>/;
    return function parse_rs(rs) {
        return rs.replace(rregex, "").split(rend).map(parse_r).filter(function(r) {
            return r.v;
        });
    };
}();
/* Parse a list of <r> tags */ var rs_to_html = /*#__PURE__*/ function parse_rs_factory() {
    var nlregex = /(\r\n|\n)/g;
    function parse_rpr2(font, intro, outro) {
        var style /*:Array<string>*/  = [];
        if (font.u) style.push("text-decoration: underline;");
        if (font.uval) style.push("text-underline-style:" + font.uval + ";");
        if (font.sz) style.push("font-size:" + font.sz + "pt;");
        if (font.outline) style.push("text-effect: outline;");
        if (font.shadow) style.push("text-shadow: auto;");
        intro.push('<span style="' + style.join("") + '">');
        if (font.b) {
            intro.push("<b>");
            outro.push("</b>");
        }
        if (font.i) {
            intro.push("<i>");
            outro.push("</i>");
        }
        if (font.strike) {
            intro.push("<s>");
            outro.push("</s>");
        }
        var align = font.valign || "";
        if (align == "superscript" || align == "super") align = "sup";
        else if (align == "subscript") align = "sub";
        if (align != "") {
            intro.push("<" + align + ">");
            outro.push("</" + align + ">");
        }
        outro.push("</span>");
        return font;
    }
    /* 18.4.4 r CT_RElt */ function r_to_html(r) {
        var terms /*:[Array<string>, string, Array<string>]*/  = [
            [],
            r.v,
            []
        ];
        if (!r.v) return "";
        if (r.s) parse_rpr2(r.s, terms[0], terms[2]);
        return terms[0].join("") + terms[1].replace(nlregex, "<br/>") + terms[2].join("");
    }
    return function parse_rs(rs) {
        return rs.map(r_to_html).join("");
    };
}();
/* 18.4.8 si CT_Rst */ var sitregex = /<(?:\w+:)?t[^>]*>([^<]*)<\/(?:\w+:)?t>/g, sirregex = /<(?:\w+:)?r>/;
var sirphregex = /<(?:\w+:)?rPh.*?>([\s\S]*?)<\/(?:\w+:)?rPh>/g;
function parse_si(x, opts) {
    var html = opts ? opts.cellHTML : true;
    var z = {};
    if (!x) return {
        t: ""
    };
    //var y;
    /* 18.4.12 t ST_Xstring (Plaintext String) */ // TODO: is whitespace actually valid here?
    if (x.match(/^\s*<(?:\w+:)?t[^>]*>/)) {
        z.t = unescapexml(utf8read(x.slice(x.indexOf(">") + 1).split(/<\/(?:\w+:)?t>/)[0] || ""));
        z.r = utf8read(x);
        if (html) z.h = escapehtml(z.t);
    } else if (/*y = */ x.match(sirregex)) {
        z.r = utf8read(x);
        z.t = unescapexml(utf8read((x.replace(sirphregex, "").match(sitregex) || []).join("").replace(tagregex, "")));
        if (html) z.h = rs_to_html(parse_rs(z.r));
    }
    /* 18.4.3 phoneticPr CT_PhoneticPr (TODO: needed for Asian support) */ /* 18.4.6 rPh CT_PhoneticRun (TODO: needed for Asian support) */ return z;
}
/* 18.4 Shared String Table */ var sstr0 = /<(?:\w+:)?sst([^>]*)>([\s\S]*)<\/(?:\w+:)?sst>/;
var sstr1 = /<(?:\w+:)?(?:si|sstItem)>/g;
var sstr2 = /<\/(?:\w+:)?(?:si|sstItem)>/;
function parse_sst_xml(data /*:string*/ , opts) /*:SST*/ {
    var s /*:SST*/  = [], ss = "";
    if (!data) return s;
    /* 18.4.9 sst CT_Sst */ var sst = data.match(sstr0);
    if (sst) {
        ss = sst[2].replace(sstr1, "").split(sstr2);
        for(var i = 0; i != ss.length; ++i){
            var o = parse_si(ss[i].trim(), opts);
            if (o != null) s[s.length] = o;
        }
        sst = parsexmltag(sst[1]);
        s.Count = sst.count;
        s.Unique = sst.uniqueCount;
    }
    return s;
}
var straywsregex = /^\s|\s$|[\t\n\r]/;
function write_sst_xml(sst /*:SST*/ , opts) /*:string*/ {
    if (!opts.bookSST) return "";
    var o = [
        XML_HEADER
    ];
    o[o.length] = writextag("sst", null, {
        xmlns: XMLNS_main[0],
        count: sst.Count,
        uniqueCount: sst.Unique
    });
    for(var i = 0; i != sst.length; ++i){
        if (sst[i] == null) continue;
        var s /*:XLString*/  = sst[i];
        var sitag = "<si>";
        if (s.r) sitag += s.r;
        else {
            sitag += "<t";
            if (!s.t) s.t = "";
            if (s.t.match(straywsregex)) sitag += ' xml:space="preserve"';
            sitag += ">" + escapexml(s.t) + "</t>";
        }
        sitag += "</si>";
        o[o.length] = sitag;
    }
    if (o.length > 2) {
        o[o.length] = "</sst>";
        o[1] = o[1].replace("/>", ">");
    }
    return o.join("");
}
/* [MS-XLSB] 2.4.221 BrtBeginSst */ function parse_BrtBeginSst(data) {
    return [
        data.read_shift(4),
        data.read_shift(4)
    ];
}
/* [MS-XLSB] 2.1.7.45 Shared Strings */ function parse_sst_bin(data, opts) /*:SST*/ {
    var s /*:SST*/  = [];
    var pass = false;
    recordhopper(data, function hopper_sst(val, R, RT) {
        switch(RT){
            case 0x009F:
                /* BrtBeginSst */ s.Count = val[0];
                s.Unique = val[1];
                break;
            case 0x0013:
                /* BrtSSTItem */ s.push(val);
                break;
            case 0x00A0:
                /* BrtEndSst */ return true;
            case 0x0023:
                /* BrtFRTBegin */ pass = true;
                break;
            case 0x0024:
                /* BrtFRTEnd */ pass = false;
                break;
            default:
                R.T;
                if (!pass || opts.WTF) throw new Error("Unexpected record 0x" + RT.toString(16));
        }
    });
    return s;
}
function write_BrtBeginSst(sst, o) {
    if (!o) o = new_buf(8);
    o.write_shift(4, sst.Count);
    o.write_shift(4, sst.Unique);
    return o;
}
var write_BrtSSTItem = write_RichStr;
function write_sst_bin(sst /*::, opts*/ ) {
    var ba = buf_array();
    write_record(ba, 0x009F /* BrtBeginSst */ , write_BrtBeginSst(sst));
    for(var i = 0; i < sst.length; ++i)write_record(ba, 0x0013 /* BrtSSTItem */ , write_BrtSSTItem(sst[i]));
    /* FRTSST */ write_record(ba, 0x00A0 /* BrtEndSst */ );
    return ba.end();
}
function _JS2ANSI(str /*:string*/ ) /*:Array<number>*/ {
    if (typeof $cptable !== "undefined") return $cptable.utils.encode(current_ansi, str);
    var o /*:Array<number>*/  = [], oo = str.split("");
    for(var i = 0; i < oo.length; ++i)o[i] = oo[i].charCodeAt(0);
    return o;
}
/* [MS-OFFCRYPTO] 2.1.4 Version */ function parse_CRYPTOVersion(blob, length /*:?number*/ ) {
    var o /*:any*/  = {};
    o.Major = blob.read_shift(2);
    o.Minor = blob.read_shift(2);
    /*:: if(length == null) return o; */ if (length >= 4) blob.l += length - 4;
    return o;
}
/* [MS-OFFCRYPTO] 2.1.5 DataSpaceVersionInfo */ function parse_DataSpaceVersionInfo(blob) {
    var o = {};
    o.id = blob.read_shift(0, "lpp4");
    o.R = parse_CRYPTOVersion(blob, 4);
    o.U = parse_CRYPTOVersion(blob, 4);
    o.W = parse_CRYPTOVersion(blob, 4);
    return o;
}
/* [MS-OFFCRYPTO] 2.1.6.1 DataSpaceMapEntry Structure */ function parse_DataSpaceMapEntry(blob) {
    var len = blob.read_shift(4);
    var end = blob.l + len - 4;
    var o = {};
    var cnt = blob.read_shift(4);
    var comps /*:Array<{t:number, v:string}>*/  = [];
    /* [MS-OFFCRYPTO] 2.1.6.2 DataSpaceReferenceComponent Structure */ while(cnt-- > 0)comps.push({
        t: blob.read_shift(4),
        v: blob.read_shift(0, "lpp4")
    });
    o.name = blob.read_shift(0, "lpp4");
    o.comps = comps;
    if (blob.l != end) throw new Error("Bad DataSpaceMapEntry: " + blob.l + " != " + end);
    return o;
}
/* [MS-OFFCRYPTO] 2.1.6 DataSpaceMap */ function parse_DataSpaceMap(blob) {
    var o = [];
    blob.l += 4; // must be 0x8
    var cnt = blob.read_shift(4);
    while(cnt-- > 0)o.push(parse_DataSpaceMapEntry(blob));
    return o;
}
/* [MS-OFFCRYPTO] 2.1.7 DataSpaceDefinition */ function parse_DataSpaceDefinition(blob) /*:Array<string>*/ {
    var o /*:Array<string>*/  = [];
    blob.l += 4; // must be 0x8
    var cnt = blob.read_shift(4);
    while(cnt-- > 0)o.push(blob.read_shift(0, "lpp4"));
    return o;
}
/* [MS-OFFCRYPTO] 2.1.8 DataSpaceDefinition */ function parse_TransformInfoHeader(blob) {
    var o = {};
    /*var len = */ blob.read_shift(4);
    blob.l += 4; // must be 0x1
    o.id = blob.read_shift(0, "lpp4");
    o.name = blob.read_shift(0, "lpp4");
    o.R = parse_CRYPTOVersion(blob, 4);
    o.U = parse_CRYPTOVersion(blob, 4);
    o.W = parse_CRYPTOVersion(blob, 4);
    return o;
}
function parse_Primary(blob) {
    /* [MS-OFFCRYPTO] 2.2.6 IRMDSTransformInfo */ var hdr = parse_TransformInfoHeader(blob);
    /* [MS-OFFCRYPTO] 2.1.9 EncryptionTransformInfo */ hdr.ename = blob.read_shift(0, "8lpp4");
    hdr.blksz = blob.read_shift(4);
    hdr.cmode = blob.read_shift(4);
    if (blob.read_shift(4) != 0x04) throw new Error("Bad !Primary record");
    return hdr;
}
/* [MS-OFFCRYPTO] 2.3.2 Encryption Header */ function parse_EncryptionHeader(blob, length /*:number*/ ) {
    var tgt = blob.l + length;
    var o = {};
    o.Flags = blob.read_shift(4) & 0x3F;
    blob.l += 4;
    o.AlgID = blob.read_shift(4);
    var valid = false;
    switch(o.AlgID){
        case 0x660E:
        case 0x660F:
        case 0x6610:
            valid = o.Flags == 0x24;
            break;
        case 0x6801:
            valid = o.Flags == 0x04;
            break;
        case 0:
            valid = o.Flags == 0x10 || o.Flags == 0x04 || o.Flags == 0x24;
            break;
        default:
            throw "Unrecognized encryption algorithm: " + o.AlgID;
    }
    if (!valid) throw new Error("Encryption Flags/AlgID mismatch");
    o.AlgIDHash = blob.read_shift(4);
    o.KeySize = blob.read_shift(4);
    o.ProviderType = blob.read_shift(4);
    blob.l += 8;
    o.CSPName = blob.read_shift(tgt - blob.l >> 1, "utf16le");
    blob.l = tgt;
    return o;
}
/* [MS-OFFCRYPTO] 2.3.3 Encryption Verifier */ function parse_EncryptionVerifier(blob, length /*:number*/ ) {
    var o = {}, tgt = blob.l + length;
    blob.l += 4; // SaltSize must be 0x10
    o.Salt = blob.slice(blob.l, blob.l + 16);
    blob.l += 16;
    o.Verifier = blob.slice(blob.l, blob.l + 16);
    blob.l += 16;
    /*var sz = */ blob.read_shift(4);
    o.VerifierHash = blob.slice(blob.l, tgt);
    blob.l = tgt;
    return o;
}
/* [MS-OFFCRYPTO] 2.3.4.* EncryptionInfo Stream */ function parse_EncryptionInfo(blob) {
    var vers = parse_CRYPTOVersion(blob);
    switch(vers.Minor){
        case 0x02:
            return [
                vers.Minor,
                parse_EncInfoStd(blob, vers)
            ];
        case 0x03:
            return [
                vers.Minor,
                parse_EncInfoExt(blob, vers)
            ];
        case 0x04:
            return [
                vers.Minor,
                parse_EncInfoAgl(blob, vers)
            ];
    }
    throw new Error("ECMA-376 Encrypted file unrecognized Version: " + vers.Minor);
}
/* [MS-OFFCRYPTO] 2.3.4.5  EncryptionInfo Stream (Standard Encryption) */ function parse_EncInfoStd(blob /*::, vers*/ ) {
    var flags = blob.read_shift(4);
    if ((flags & 0x3F) != 0x24) throw new Error("EncryptionInfo mismatch");
    var sz = blob.read_shift(4);
    //var tgt = blob.l + sz;
    var hdr = parse_EncryptionHeader(blob, sz);
    var verifier = parse_EncryptionVerifier(blob, blob.length - blob.l);
    return {
        t: "Std",
        h: hdr,
        v: verifier
    };
}
/* [MS-OFFCRYPTO] 2.3.4.6  EncryptionInfo Stream (Extensible Encryption) */ function parse_EncInfoExt() {
    throw new Error("File is password-protected: ECMA-376 Extensible");
}
/* [MS-OFFCRYPTO] 2.3.4.10 EncryptionInfo Stream (Agile Encryption) */ function parse_EncInfoAgl(blob /*::, vers*/ ) {
    var KeyData = [
        "saltSize",
        "blockSize",
        "keyBits",
        "hashSize",
        "cipherAlgorithm",
        "cipherChaining",
        "hashAlgorithm",
        "saltValue"
    ];
    blob.l += 4;
    var xml = blob.read_shift(blob.length - blob.l, "utf8");
    var o = {};
    xml.replace(tagregex, function xml_agile(x) {
        var y /*:any*/  = parsexmltag(x);
        switch(strip_ns(y[0])){
            case "<?xml":
                break;
            case "<encryption":
            case "</encryption>":
                break;
            case "<keyData":
                KeyData.forEach(function(k) {
                    o[k] = y[k];
                });
                break;
            case "<dataIntegrity":
                o.encryptedHmacKey = y.encryptedHmacKey;
                o.encryptedHmacValue = y.encryptedHmacValue;
                break;
            case "<keyEncryptors>":
            case "<keyEncryptors":
                o.encs = [];
                break;
            case "</keyEncryptors>":
                break;
            case "<keyEncryptor":
                o.uri = y.uri;
                break;
            case "</keyEncryptor>":
                break;
            case "<encryptedKey":
                o.encs.push(y);
                break;
            default:
                throw y[0];
        }
    });
    return o;
}
/* [MS-OFFCRYPTO] 2.3.5.1 RC4 CryptoAPI Encryption Header */ function parse_RC4CryptoHeader(blob, length /*:number*/ ) {
    var o = {};
    var vers = o.EncryptionVersionInfo = parse_CRYPTOVersion(blob, 4);
    length -= 4;
    if (vers.Minor != 2) throw new Error("unrecognized minor version code: " + vers.Minor);
    if (vers.Major > 4 || vers.Major < 2) throw new Error("unrecognized major version code: " + vers.Major);
    o.Flags = blob.read_shift(4);
    length -= 4;
    var sz = blob.read_shift(4);
    length -= 4;
    o.EncryptionHeader = parse_EncryptionHeader(blob, sz);
    length -= sz;
    o.EncryptionVerifier = parse_EncryptionVerifier(blob, length);
    return o;
}
/* [MS-OFFCRYPTO] 2.3.6.1 RC4 Encryption Header */ function parse_RC4Header(blob /*::, length*/ ) {
    var o = {};
    var vers = o.EncryptionVersionInfo = parse_CRYPTOVersion(blob, 4);
    if (vers.Major != 1 || vers.Minor != 1) throw "unrecognized version code " + vers.Major + " : " + vers.Minor;
    o.Salt = blob.read_shift(16);
    o.EncryptedVerifier = blob.read_shift(16);
    o.EncryptedVerifierHash = blob.read_shift(16);
    return o;
}
/* [MS-OFFCRYPTO] 2.3.7.1 Binary Document Password Verifier Derivation */ function crypto_CreatePasswordVerifier_Method1(Password /*:string*/ ) {
    var Verifier = 0x0000, PasswordArray;
    var PasswordDecoded = _JS2ANSI(Password);
    var len = PasswordDecoded.length + 1, i, PasswordByte;
    var Intermediate1, Intermediate2, Intermediate3;
    PasswordArray = new_raw_buf(len);
    PasswordArray[0] = PasswordDecoded.length;
    for(i = 1; i != len; ++i)PasswordArray[i] = PasswordDecoded[i - 1];
    for(i = len - 1; i >= 0; --i){
        PasswordByte = PasswordArray[i];
        Intermediate1 = (Verifier & 0x4000) === 0x0000 ? 0 : 1;
        Intermediate2 = Verifier << 1 & 0x7FFF;
        Intermediate3 = Intermediate1 | Intermediate2;
        Verifier = Intermediate3 ^ PasswordByte;
    }
    return Verifier ^ 0xCE4B;
}
/* [MS-OFFCRYPTO] 2.3.7.2 Binary Document XOR Array Initialization */ var crypto_CreateXorArray_Method1 = /*#__PURE__*/ function() {
    var PadArray = [
        0xBB,
        0xFF,
        0xFF,
        0xBA,
        0xFF,
        0xFF,
        0xB9,
        0x80,
        0x00,
        0xBE,
        0x0F,
        0x00,
        0xBF,
        0x0F,
        0x00
    ];
    var InitialCode = [
        0xE1F0,
        0x1D0F,
        0xCC9C,
        0x84C0,
        0x110C,
        0x0E10,
        0xF1CE,
        0x313E,
        0x1872,
        0xE139,
        0xD40F,
        0x84F9,
        0x280C,
        0xA96A,
        0x4EC3
    ];
    var XorMatrix = [
        0xAEFC,
        0x4DD9,
        0x9BB2,
        0x2745,
        0x4E8A,
        0x9D14,
        0x2A09,
        0x7B61,
        0xF6C2,
        0xFDA5,
        0xEB6B,
        0xC6F7,
        0x9DCF,
        0x2BBF,
        0x4563,
        0x8AC6,
        0x05AD,
        0x0B5A,
        0x16B4,
        0x2D68,
        0x5AD0,
        0x0375,
        0x06EA,
        0x0DD4,
        0x1BA8,
        0x3750,
        0x6EA0,
        0xDD40,
        0xD849,
        0xA0B3,
        0x5147,
        0xA28E,
        0x553D,
        0xAA7A,
        0x44D5,
        0x6F45,
        0xDE8A,
        0xAD35,
        0x4A4B,
        0x9496,
        0x390D,
        0x721A,
        0xEB23,
        0xC667,
        0x9CEF,
        0x29FF,
        0x53FE,
        0xA7FC,
        0x5FD9,
        0x47D3,
        0x8FA6,
        0x0F6D,
        0x1EDA,
        0x3DB4,
        0x7B68,
        0xF6D0,
        0xB861,
        0x60E3,
        0xC1C6,
        0x93AD,
        0x377B,
        0x6EF6,
        0xDDEC,
        0x45A0,
        0x8B40,
        0x06A1,
        0x0D42,
        0x1A84,
        0x3508,
        0x6A10,
        0xAA51,
        0x4483,
        0x8906,
        0x022D,
        0x045A,
        0x08B4,
        0x1168,
        0x76B4,
        0xED68,
        0xCAF1,
        0x85C3,
        0x1BA7,
        0x374E,
        0x6E9C,
        0x3730,
        0x6E60,
        0xDCC0,
        0xA9A1,
        0x4363,
        0x86C6,
        0x1DAD,
        0x3331,
        0x6662,
        0xCCC4,
        0x89A9,
        0x0373,
        0x06E6,
        0x0DCC,
        0x1021,
        0x2042,
        0x4084,
        0x8108,
        0x1231,
        0x2462,
        0x48C4
    ];
    var Ror = function(Byte) {
        return (Byte / 2 | Byte * 128) & 0xFF;
    };
    var XorRor = function(byte1, byte2) {
        return Ror(byte1 ^ byte2);
    };
    var CreateXorKey_Method1 = function(Password) {
        var XorKey = InitialCode[Password.length - 1];
        var CurrentElement = 0x68;
        for(var i = Password.length - 1; i >= 0; --i){
            var Char = Password[i];
            for(var j = 0; j != 7; ++j){
                if (Char & 0x40) XorKey ^= XorMatrix[CurrentElement];
                Char *= 2;
                --CurrentElement;
            }
        }
        return XorKey;
    };
    return function(password /*:string*/ ) {
        var Password = _JS2ANSI(password);
        var XorKey = CreateXorKey_Method1(Password);
        var Index = Password.length;
        var ObfuscationArray = new_raw_buf(16);
        for(var i = 0; i != 16; ++i)ObfuscationArray[i] = 0x00;
        var Temp, PasswordLastChar, PadIndex;
        if ((Index & 1) === 1) {
            Temp = XorKey >> 8;
            ObfuscationArray[Index] = XorRor(PadArray[0], Temp);
            --Index;
            Temp = XorKey & 0xFF;
            PasswordLastChar = Password[Password.length - 1];
            ObfuscationArray[Index] = XorRor(PasswordLastChar, Temp);
        }
        while(Index > 0){
            --Index;
            Temp = XorKey >> 8;
            ObfuscationArray[Index] = XorRor(Password[Index], Temp);
            --Index;
            Temp = XorKey & 0xFF;
            ObfuscationArray[Index] = XorRor(Password[Index], Temp);
        }
        Index = 15;
        PadIndex = 15 - Password.length;
        while(PadIndex > 0){
            Temp = XorKey >> 8;
            ObfuscationArray[Index] = XorRor(PadArray[PadIndex], Temp);
            --Index;
            --PadIndex;
            Temp = XorKey & 0xFF;
            ObfuscationArray[Index] = XorRor(Password[Index], Temp);
            --Index;
            --PadIndex;
        }
        return ObfuscationArray;
    };
}();
/* [MS-OFFCRYPTO] 2.3.7.3 Binary Document XOR Data Transformation Method 1 */ var crypto_DecryptData_Method1 = function(password /*:string*/ , Data, XorArrayIndex, XorArray, O) {
    /* If XorArray is set, use it; if O is not set, make changes in-place */ if (!O) O = Data;
    if (!XorArray) XorArray = crypto_CreateXorArray_Method1(password);
    var Index, Value;
    for(Index = 0; Index != Data.length; ++Index){
        Value = Data[Index];
        Value ^= XorArray[XorArrayIndex];
        Value = (Value >> 5 | Value << 3) & 0xFF;
        O[Index] = Value;
        ++XorArrayIndex;
    }
    return [
        O,
        XorArrayIndex,
        XorArray
    ];
};
var crypto_MakeXorDecryptor = function(password /*:string*/ ) {
    var XorArrayIndex = 0, XorArray = crypto_CreateXorArray_Method1(password);
    return function(Data) {
        var O = crypto_DecryptData_Method1("", Data, XorArrayIndex, XorArray);
        XorArrayIndex = O[1];
        return O[0];
    };
};
/* 2.5.343 */ function parse_XORObfuscation(blob, length, opts, out) {
    var o = {
        key: parseuint16(blob),
        verificationBytes: parseuint16(blob)
    } /*:any*/ ;
    if (opts.password) o.verifier = crypto_CreatePasswordVerifier_Method1(opts.password);
    out.valid = o.verificationBytes === o.verifier;
    if (out.valid) out.insitu = crypto_MakeXorDecryptor(opts.password);
    return o;
}
/* 2.4.117 */ function parse_FilePassHeader(blob, length /*:number*/ , oo) {
    var o = oo || {};
    o.Info = blob.read_shift(2);
    blob.l -= 2;
    if (o.Info === 1) o.Data = parse_RC4Header(blob, length);
    else o.Data = parse_RC4CryptoHeader(blob, length);
    return o;
}
function parse_FilePass(blob, length /*:number*/ , opts) {
    var o = {
        Type: opts.biff >= 8 ? blob.read_shift(2) : 0
    } /*:any*/ ; /* wEncryptionType */ 
    if (o.Type) parse_FilePassHeader(blob, length - 2, o);
    else parse_XORObfuscation(blob, opts.biff >= 8 ? length : length - 2, opts, o);
    return o;
}
var RTF = /*#__PURE__*/ function() {
    function rtf_to_sheet(d /*:RawData*/ , opts) /*:Worksheet*/ {
        switch(opts.type){
            case "base64":
                return rtf_to_sheet_str(Base64_decode(d), opts);
            case "binary":
                return rtf_to_sheet_str(d, opts);
            case "buffer":
                return rtf_to_sheet_str(has_buf && Buffer.isBuffer(d) ? d.toString("binary") : a2s(d), opts);
            case "array":
                return rtf_to_sheet_str(cc2str(d), opts);
        }
        throw new Error("Unrecognized type " + opts.type);
    }
    /* TODO: this is a stub */ function rtf_to_sheet_str(str /*:string*/ , opts) /*:Worksheet*/ {
        var o = opts || {};
        var ws /*:Worksheet*/  = o.dense ? [] : {} /*:any*/ ;
        var rows = str.match(/\\trowd.*?\\row\b/g);
        if (!rows.length) throw new Error("RTF missing table");
        var range /*:Range*/  = {
            s: {
                c: 0,
                r: 0
            },
            e: {
                c: 0,
                r: rows.length - 1
            }
        } /*:any*/ ;
        rows.forEach(function(rowtf, R) {
            if (Array.isArray(ws)) ws[R] = [];
            var rtfre = /\\\w+\b/g;
            var last_index = 0;
            var res;
            var C = -1;
            while(res = rtfre.exec(rowtf)){
                switch(res[0]){
                    case "\\cell":
                        var data = rowtf.slice(last_index, rtfre.lastIndex - res[0].length);
                        if (data[0] == " ") data = data.slice(1);
                        ++C;
                        if (data.length) {
                            // TODO: value parsing, including codepage adjustments
                            var cell = {
                                v: data,
                                t: "s"
                            };
                            if (Array.isArray(ws)) ws[R][C] = cell;
                            else ws[encode_cell({
                                r: R,
                                c: C
                            })] = cell;
                        }
                        break;
                }
                last_index = rtfre.lastIndex;
            }
            if (C > range.e.c) range.e.c = C;
        });
        ws["!ref"] = encode_range(range);
        return ws;
    }
    function rtf_to_workbook(d /*:RawData*/ , opts) /*:Workbook*/ {
        return sheet_to_workbook(rtf_to_sheet(d, opts), opts);
    }
    /* TODO: this is a stub */ function sheet_to_rtf(ws /*:Worksheet*/  /*::, opts*/ ) /*:string*/ {
        var o = [
            "{\\rtf1\\ansi"
        ];
        var r = safe_decode_range(ws["!ref"]), cell /*:Cell*/ ;
        var dense = Array.isArray(ws);
        for(var R = r.s.r; R <= r.e.r; ++R){
            o.push("\\trowd\\trautofit1");
            for(var C = r.s.c; C <= r.e.c; ++C)o.push("\\cellx" + (C + 1));
            o.push("\\pard\\intbl");
            for(C = r.s.c; C <= r.e.c; ++C){
                var coord = encode_cell({
                    r: R,
                    c: C
                });
                cell = dense ? (ws[R] || [])[C] : ws[coord];
                if (!cell || cell.v == null && (!cell.f || cell.F)) continue;
                o.push(" " + (cell.w || (format_cell(cell), cell.w)));
                o.push("\\cell");
            }
            o.push("\\pard\\intbl\\row");
        }
        return o.join("") + "}";
    }
    return {
        to_workbook: rtf_to_workbook,
        to_sheet: rtf_to_sheet,
        from_sheet: sheet_to_rtf
    };
}();
function hex2RGB(h) {
    var o = h.slice(h[0] === "#" ? 1 : 0).slice(0, 6);
    return [
        parseInt(o.slice(0, 2), 16),
        parseInt(o.slice(2, 4), 16),
        parseInt(o.slice(4, 6), 16)
    ];
}
function rgb2Hex(rgb) {
    for(var i = 0, o = 1; i != 3; ++i)o = o * 256 + (rgb[i] > 255 ? 255 : rgb[i] < 0 ? 0 : rgb[i]);
    return o.toString(16).toUpperCase().slice(1);
}
function rgb2HSL(rgb) {
    var R = rgb[0] / 255, G = rgb[1] / 255, B = rgb[2] / 255;
    var M = Math.max(R, G, B), m = Math.min(R, G, B), C = M - m;
    if (C === 0) return [
        0,
        0,
        R
    ];
    var H6 = 0, S = 0, L2 = M + m;
    S = C / (L2 > 1 ? 2 - L2 : L2);
    switch(M){
        case R:
            H6 = ((G - B) / C + 6) % 6;
            break;
        case G:
            H6 = (B - R) / C + 2;
            break;
        case B:
            H6 = (R - G) / C + 4;
            break;
    }
    return [
        H6 / 6,
        S,
        L2 / 2
    ];
}
function hsl2RGB(hsl) {
    var H = hsl[0], S = hsl[1], L = hsl[2];
    var C = S * 2 * (L < 0.5 ? L : 1 - L), m = L - C / 2;
    var rgb = [
        m,
        m,
        m
    ], h6 = 6 * H;
    var X;
    if (S !== 0) switch(h6 | 0){
        case 0:
        case 6:
            X = C * h6;
            rgb[0] += C;
            rgb[1] += X;
            break;
        case 1:
            X = C * (2 - h6);
            rgb[0] += X;
            rgb[1] += C;
            break;
        case 2:
            X = C * (h6 - 2);
            rgb[1] += C;
            rgb[2] += X;
            break;
        case 3:
            X = C * (4 - h6);
            rgb[1] += X;
            rgb[2] += C;
            break;
        case 4:
            X = C * (h6 - 4);
            rgb[2] += C;
            rgb[0] += X;
            break;
        case 5:
            X = C * (6 - h6);
            rgb[2] += X;
            rgb[0] += C;
            break;
    }
    for(var i = 0; i != 3; ++i)rgb[i] = Math.round(rgb[i] * 255);
    return rgb;
}
/* 18.8.3 bgColor tint algorithm */ function rgb_tint(hex, tint) {
    if (tint === 0) return hex;
    var hsl = rgb2HSL(hex2RGB(hex));
    if (tint < 0) hsl[2] = hsl[2] * (1 + tint);
    else hsl[2] = 1 - (1 - hsl[2]) * (1 - tint);
    return rgb2Hex(hsl2RGB(hsl));
}
/* 18.3.1.13 width calculations */ /* [MS-OI29500] 2.1.595 Column Width & Formatting */ var DEF_MDW = 6, MAX_MDW = 15, MIN_MDW = 1, MDW = DEF_MDW;
function width2px(width) {
    return Math.floor((width + Math.round(128 / MDW) / 256) * MDW);
}
function px2char(px) {
    return Math.floor((px - 5) / MDW * 100 + 0.5) / 100;
}
function char2width(chr) {
    return Math.round((chr * MDW + 5) / MDW * 256) / 256;
}
//function px2char_(px) { return (((px - 5)/MDW * 100 + 0.5))/100; }
//function char2width_(chr) { return (((chr * MDW + 5)/MDW*256))/256; }
function cycle_width(collw) {
    return char2width(px2char(width2px(collw)));
}
/* XLSX/XLSB/XLS specify width in units of MDW */ function find_mdw_colw(collw) {
    var delta = Math.abs(collw - cycle_width(collw)), _MDW = MDW;
    if (delta > 0.005) {
        for(MDW = MIN_MDW; MDW < MAX_MDW; ++MDW)if (Math.abs(collw - cycle_width(collw)) <= delta) {
            delta = Math.abs(collw - cycle_width(collw));
            _MDW = MDW;
        }
    }
    MDW = _MDW;
}
/* XLML specifies width in terms of pixels */ /*function find_mdw_wpx(wpx) {
	var delta = Infinity, guess = 0, _MDW = MIN_MDW;
	for(MDW=MIN_MDW; MDW<MAX_MDW; ++MDW) {
		guess = char2width_(px2char_(wpx))*256;
		guess = (guess) % 1;
		if(guess > 0.5) guess--;
		if(Math.abs(guess) < delta) { delta = Math.abs(guess); _MDW = MDW; }
	}
	MDW = _MDW;
}*/ function process_col(coll /*:ColInfo*/ ) {
    if (coll.width) {
        coll.wpx = width2px(coll.width);
        coll.wch = px2char(coll.wpx);
        coll.MDW = MDW;
    } else if (coll.wpx) {
        coll.wch = px2char(coll.wpx);
        coll.width = char2width(coll.wch);
        coll.MDW = MDW;
    } else if (typeof coll.wch == "number") {
        coll.width = char2width(coll.wch);
        coll.wpx = width2px(coll.width);
        coll.MDW = MDW;
    }
    if (coll.customWidth) delete coll.customWidth;
}
var DEF_PPI = 96, PPI = DEF_PPI;
function px2pt(px) {
    return px * 96 / PPI;
}
function pt2px(pt) {
    return pt * PPI / 96;
}
/* [MS-EXSPXML3] 2.4.54 ST_enmPattern */ var XLMLPatternTypeMap = {
    "None": "none",
    "Solid": "solid",
    "Gray50": "mediumGray",
    "Gray75": "darkGray",
    "Gray25": "lightGray",
    "HorzStripe": "darkHorizontal",
    "VertStripe": "darkVertical",
    "ReverseDiagStripe": "darkDown",
    "DiagStripe": "darkUp",
    "DiagCross": "darkGrid",
    "ThickDiagCross": "darkTrellis",
    "ThinHorzStripe": "lightHorizontal",
    "ThinVertStripe": "lightVertical",
    "ThinReverseDiagStripe": "lightDown",
    "ThinHorzCross": "lightGrid"
};
/* 18.8.5 borders CT_Borders */ function parse_borders(t, styles, themes, opts) {
    styles.Borders = [];
    var border = {};
    var pass = false;
    (t[0].match(tagregex) || []).forEach(function(x) {
        var y = parsexmltag(x);
        switch(strip_ns(y[0])){
            case "<borders":
            case "<borders>":
            case "</borders>":
                break;
            /* 18.8.4 border CT_Border */ case "<border":
            case "<border>":
            case "<border/>":
                border = /*::(*/ {} /*:: :any)*/ ;
                if (y.diagonalUp) border.diagonalUp = parsexmlbool(y.diagonalUp);
                if (y.diagonalDown) border.diagonalDown = parsexmlbool(y.diagonalDown);
                styles.Borders.push(border);
                break;
            case "</border>":
                break;
            /* note: not in spec, appears to be CT_BorderPr */ case "<left/>":
                break;
            case "<left":
            case "<left>":
                break;
            case "</left>":
                break;
            /* note: not in spec, appears to be CT_BorderPr */ case "<right/>":
                break;
            case "<right":
            case "<right>":
                break;
            case "</right>":
                break;
            /* 18.8.43 top CT_BorderPr */ case "<top/>":
                break;
            case "<top":
            case "<top>":
                break;
            case "</top>":
                break;
            /* 18.8.6 bottom CT_BorderPr */ case "<bottom/>":
                break;
            case "<bottom":
            case "<bottom>":
                break;
            case "</bottom>":
                break;
            /* 18.8.13 diagonal CT_BorderPr */ case "<diagonal":
            case "<diagonal>":
            case "<diagonal/>":
                break;
            case "</diagonal>":
                break;
            /* 18.8.25 horizontal CT_BorderPr */ case "<horizontal":
            case "<horizontal>":
            case "<horizontal/>":
                break;
            case "</horizontal>":
                break;
            /* 18.8.44 vertical CT_BorderPr */ case "<vertical":
            case "<vertical>":
            case "<vertical/>":
                break;
            case "</vertical>":
                break;
            /* 18.8.37 start CT_BorderPr */ case "<start":
            case "<start>":
            case "<start/>":
                break;
            case "</start>":
                break;
            /* 18.8.16 end CT_BorderPr */ case "<end":
            case "<end>":
            case "<end/>":
                break;
            case "</end>":
                break;
            /* 18.8.? color CT_Color */ case "<color":
            case "<color>":
                break;
            case "<color/>":
            case "</color>":
                break;
            /* 18.2.10 extLst CT_ExtensionList ? */ case "<extLst":
            case "<extLst>":
            case "</extLst>":
                break;
            case "<ext":
                pass = true;
                break;
            case "</ext>":
                pass = false;
                break;
            default:
                if (opts && opts.WTF) {
                    if (!pass) throw new Error("unrecognized " + y[0] + " in borders");
                }
        }
    });
}
/* 18.8.21 fills CT_Fills */ function parse_fills(t, styles, themes, opts) {
    styles.Fills = [];
    var fill = {};
    var pass = false;
    (t[0].match(tagregex) || []).forEach(function(x) {
        var y = parsexmltag(x);
        switch(strip_ns(y[0])){
            case "<fills":
            case "<fills>":
            case "</fills>":
                break;
            /* 18.8.20 fill CT_Fill */ case "<fill>":
            case "<fill":
            case "<fill/>":
                fill = {};
                styles.Fills.push(fill);
                break;
            case "</fill>":
                break;
            /* 18.8.24 gradientFill CT_GradientFill */ case "<gradientFill>":
                break;
            case "<gradientFill":
            case "</gradientFill>":
                styles.Fills.push(fill);
                fill = {};
                break;
            /* 18.8.32 patternFill CT_PatternFill */ case "<patternFill":
            case "<patternFill>":
                if (y.patternType) fill.patternType = y.patternType;
                break;
            case "<patternFill/>":
            case "</patternFill>":
                break;
            /* 18.8.3 bgColor CT_Color */ case "<bgColor":
                if (!fill.bgColor) fill.bgColor = {};
                if (y.indexed) fill.bgColor.indexed = parseInt(y.indexed, 10);
                if (y.theme) fill.bgColor.theme = parseInt(y.theme, 10);
                if (y.tint) fill.bgColor.tint = parseFloat(y.tint);
                /* Excel uses ARGB strings */ if (y.rgb) fill.bgColor.rgb = y.rgb.slice(-6);
                break;
            case "<bgColor/>":
            case "</bgColor>":
                break;
            /* 18.8.19 fgColor CT_Color */ case "<fgColor":
                if (!fill.fgColor) fill.fgColor = {};
                if (y.theme) fill.fgColor.theme = parseInt(y.theme, 10);
                if (y.tint) fill.fgColor.tint = parseFloat(y.tint);
                /* Excel uses ARGB strings */ if (y.rgb != null) fill.fgColor.rgb = y.rgb.slice(-6);
                break;
            case "<fgColor/>":
            case "</fgColor>":
                break;
            /* 18.8.38 stop CT_GradientStop */ case "<stop":
            case "<stop/>":
                break;
            case "</stop>":
                break;
            /* 18.8.? color CT_Color */ case "<color":
            case "<color/>":
                break;
            case "</color>":
                break;
            /* 18.2.10 extLst CT_ExtensionList ? */ case "<extLst":
            case "<extLst>":
            case "</extLst>":
                break;
            case "<ext":
                pass = true;
                break;
            case "</ext>":
                pass = false;
                break;
            default:
                if (opts && opts.WTF) {
                    if (!pass) throw new Error("unrecognized " + y[0] + " in fills");
                }
        }
    });
}
/* 18.8.23 fonts CT_Fonts */ function parse_fonts(t, styles, themes, opts) {
    styles.Fonts = [];
    var font = {};
    var pass = false;
    (t[0].match(tagregex) || []).forEach(function(x) {
        var y = parsexmltag(x);
        switch(strip_ns(y[0])){
            case "<fonts":
            case "<fonts>":
            case "</fonts>":
                break;
            /* 18.8.22 font CT_Font */ case "<font":
            case "<font>":
                break;
            case "</font>":
            case "<font/>":
                styles.Fonts.push(font);
                font = {};
                break;
            /* 18.8.29 name CT_FontName */ case "<name":
                if (y.val) font.name = utf8read(y.val);
                break;
            case "<name/>":
            case "</name>":
                break;
            /* 18.8.2  b CT_BooleanProperty */ case "<b":
                font.bold = y.val ? parsexmlbool(y.val) : 1;
                break;
            case "<b/>":
                font.bold = 1;
                break;
            /* 18.8.26 i CT_BooleanProperty */ case "<i":
                font.italic = y.val ? parsexmlbool(y.val) : 1;
                break;
            case "<i/>":
                font.italic = 1;
                break;
            /* 18.4.13 u CT_UnderlineProperty */ case "<u":
                switch(y.val){
                    case "none":
                        font.underline = 0x00;
                        break;
                    case "single":
                        font.underline = 0x01;
                        break;
                    case "double":
                        font.underline = 0x02;
                        break;
                    case "singleAccounting":
                        font.underline = 0x21;
                        break;
                    case "doubleAccounting":
                        font.underline = 0x22;
                        break;
                }
                break;
            case "<u/>":
                font.underline = 1;
                break;
            /* 18.4.10 strike CT_BooleanProperty */ case "<strike":
                font.strike = y.val ? parsexmlbool(y.val) : 1;
                break;
            case "<strike/>":
                font.strike = 1;
                break;
            /* 18.4.2  outline CT_BooleanProperty */ case "<outline":
                font.outline = y.val ? parsexmlbool(y.val) : 1;
                break;
            case "<outline/>":
                font.outline = 1;
                break;
            /* 18.8.36 shadow CT_BooleanProperty */ case "<shadow":
                font.shadow = y.val ? parsexmlbool(y.val) : 1;
                break;
            case "<shadow/>":
                font.shadow = 1;
                break;
            /* 18.8.12 condense CT_BooleanProperty */ case "<condense":
                font.condense = y.val ? parsexmlbool(y.val) : 1;
                break;
            case "<condense/>":
                font.condense = 1;
                break;
            /* 18.8.17 extend CT_BooleanProperty */ case "<extend":
                font.extend = y.val ? parsexmlbool(y.val) : 1;
                break;
            case "<extend/>":
                font.extend = 1;
                break;
            /* 18.4.11 sz CT_FontSize */ case "<sz":
                if (y.val) font.sz = +y.val;
                break;
            case "<sz/>":
            case "</sz>":
                break;
            /* 18.4.14 vertAlign CT_VerticalAlignFontProperty */ case "<vertAlign":
                if (y.val) font.vertAlign = y.val;
                break;
            case "<vertAlign/>":
            case "</vertAlign>":
                break;
            /* 18.8.18 family CT_FontFamily */ case "<family":
                if (y.val) font.family = parseInt(y.val, 10);
                break;
            case "<family/>":
            case "</family>":
                break;
            /* 18.8.35 scheme CT_FontScheme */ case "<scheme":
                if (y.val) font.scheme = y.val;
                break;
            case "<scheme/>":
            case "</scheme>":
                break;
            /* 18.4.1 charset CT_IntProperty */ case "<charset":
                if (y.val == "1") break;
                y.codepage = CS2CP[parseInt(y.val, 10)];
                break;
            /* 18.?.? color CT_Color */ case "<color":
                if (!font.color) font.color = {};
                if (y.auto) font.color.auto = parsexmlbool(y.auto);
                if (y.rgb) font.color.rgb = y.rgb.slice(-6);
                else if (y.indexed) {
                    font.color.index = parseInt(y.indexed, 10);
                    var icv = XLSIcv[font.color.index];
                    if (font.color.index == 81) icv = XLSIcv[1];
                    if (!icv) icv = XLSIcv[1]; //throw new Error(x); // note: 206 is valid
                    font.color.rgb = icv[0].toString(16) + icv[1].toString(16) + icv[2].toString(16);
                } else if (y.theme) {
                    font.color.theme = parseInt(y.theme, 10);
                    if (y.tint) font.color.tint = parseFloat(y.tint);
                    if (y.theme && themes.themeElements && themes.themeElements.clrScheme) font.color.rgb = rgb_tint(themes.themeElements.clrScheme[font.color.theme].rgb, font.color.tint || 0);
                }
                break;
            case "<color/>":
            case "</color>":
                break;
            /* note: sometimes mc:AlternateContent appears bare */ case "<AlternateContent":
                pass = true;
                break;
            case "</AlternateContent>":
                pass = false;
                break;
            /* 18.2.10 extLst CT_ExtensionList ? */ case "<extLst":
            case "<extLst>":
            case "</extLst>":
                break;
            case "<ext":
                pass = true;
                break;
            case "</ext>":
                pass = false;
                break;
            default:
                if (opts && opts.WTF) {
                    if (!pass) throw new Error("unrecognized " + y[0] + " in fonts");
                }
        }
    });
}
/* 18.8.31 numFmts CT_NumFmts */ function parse_numFmts(t, styles, opts) {
    styles.NumberFmt = [];
    var k /*Array<number>*/  = keys(table_fmt);
    for(var i = 0; i < k.length; ++i)styles.NumberFmt[k[i]] = table_fmt[k[i]];
    var m = t[0].match(tagregex);
    if (!m) return;
    for(i = 0; i < m.length; ++i){
        var y = parsexmltag(m[i]);
        switch(strip_ns(y[0])){
            case "<numFmts":
            case "</numFmts>":
            case "<numFmts/>":
            case "<numFmts>":
                break;
            case "<numFmt":
                var f = unescapexml(utf8read(y.formatCode)), j = parseInt(y.numFmtId, 10);
                styles.NumberFmt[j] = f;
                if (j > 0) {
                    if (j > 0x188) {
                        for(j = 0x188; j > 0x3c; --j)if (styles.NumberFmt[j] == null) break;
                        styles.NumberFmt[j] = f;
                    }
                    SSF_load(f, j);
                }
                break;
            case "</numFmt>":
                break;
            default:
                if (opts.WTF) throw new Error("unrecognized " + y[0] + " in numFmts");
        }
    }
}
function write_numFmts(NF /*:{[n:number|string]:string}*/  /*::, opts*/ ) {
    var o = [
        "<numFmts>"
    ];
    [
        [
            5,
            8
        ],
        [
            23,
            26
        ],
        [
            41,
            44
        ],
        [
            /*63*/ 50,
            /*66],[164,*/ 392
        ]
    ].forEach(function(r) {
        for(var i = r[0]; i <= r[1]; ++i)if (NF[i] != null) o[o.length] = writextag("numFmt", null, {
            numFmtId: i,
            formatCode: escapexml(NF[i])
        });
    });
    if (o.length === 1) return "";
    o[o.length] = "</numFmts>";
    o[0] = writextag("numFmts", null, {
        count: o.length - 2
    }).replace("/>", ">");
    return o.join("");
}
/* 18.8.10 cellXfs CT_CellXfs */ var cellXF_uint = [
    "numFmtId",
    "fillId",
    "fontId",
    "borderId",
    "xfId"
];
var cellXF_bool = [
    "applyAlignment",
    "applyBorder",
    "applyFill",
    "applyFont",
    "applyNumberFormat",
    "applyProtection",
    "pivotButton",
    "quotePrefix"
];
function parse_cellXfs(t, styles, opts) {
    styles.CellXf = [];
    var xf;
    var pass = false;
    (t[0].match(tagregex) || []).forEach(function(x) {
        var y = parsexmltag(x), i = 0;
        switch(strip_ns(y[0])){
            case "<cellXfs":
            case "<cellXfs>":
            case "<cellXfs/>":
            case "</cellXfs>":
                break;
            /* 18.8.45 xf CT_Xf */ case "<xf":
            case "<xf/>":
                xf = y;
                delete xf[0];
                for(i = 0; i < cellXF_uint.length; ++i)if (xf[cellXF_uint[i]]) xf[cellXF_uint[i]] = parseInt(xf[cellXF_uint[i]], 10);
                for(i = 0; i < cellXF_bool.length; ++i)if (xf[cellXF_bool[i]]) xf[cellXF_bool[i]] = parsexmlbool(xf[cellXF_bool[i]]);
                if (styles.NumberFmt && xf.numFmtId > 0x188) {
                    for(i = 0x188; i > 0x3c; --i)if (styles.NumberFmt[xf.numFmtId] == styles.NumberFmt[i]) {
                        xf.numFmtId = i;
                        break;
                    }
                }
                styles.CellXf.push(xf);
                break;
            case "</xf>":
                break;
            /* 18.8.1 alignment CT_CellAlignment */ case "<alignment":
            case "<alignment/>":
                var alignment = {};
                if (y.vertical) alignment.vertical = y.vertical;
                if (y.horizontal) alignment.horizontal = y.horizontal;
                if (y.textRotation != null) alignment.textRotation = y.textRotation;
                if (y.indent) alignment.indent = y.indent;
                if (y.wrapText) alignment.wrapText = parsexmlbool(y.wrapText);
                xf.alignment = alignment;
                break;
            case "</alignment>":
                break;
            /* 18.8.33 protection CT_CellProtection */ case "<protection":
                break;
            case "</protection>":
            case "<protection/>":
                break;
            /* note: sometimes mc:AlternateContent appears bare */ case "<AlternateContent":
                pass = true;
                break;
            case "</AlternateContent>":
                pass = false;
                break;
            /* 18.2.10 extLst CT_ExtensionList ? */ case "<extLst":
            case "<extLst>":
            case "</extLst>":
                break;
            case "<ext":
                pass = true;
                break;
            case "</ext>":
                pass = false;
                break;
            default:
                if (opts && opts.WTF) {
                    if (!pass) throw new Error("unrecognized " + y[0] + " in cellXfs");
                }
        }
    });
}
function write_cellXfs(cellXfs) /*:string*/ {
    var o /*:Array<string>*/  = [];
    o[o.length] = writextag("cellXfs", null);
    cellXfs.forEach(function(c) {
        o[o.length] = writextag("xf", null, c);
    });
    o[o.length] = "</cellXfs>";
    if (o.length === 2) return "";
    o[0] = writextag("cellXfs", null, {
        count: o.length - 2
    }).replace("/>", ">");
    return o.join("");
}
/* 18.8 Styles CT_Stylesheet*/ var parse_sty_xml = /*#__PURE__*/ function make_pstyx() {
    var numFmtRegex = /<(?:\w+:)?numFmts([^>]*)>[\S\s]*?<\/(?:\w+:)?numFmts>/;
    var cellXfRegex = /<(?:\w+:)?cellXfs([^>]*)>[\S\s]*?<\/(?:\w+:)?cellXfs>/;
    var fillsRegex = /<(?:\w+:)?fills([^>]*)>[\S\s]*?<\/(?:\w+:)?fills>/;
    var fontsRegex = /<(?:\w+:)?fonts([^>]*)>[\S\s]*?<\/(?:\w+:)?fonts>/;
    var bordersRegex = /<(?:\w+:)?borders([^>]*)>[\S\s]*?<\/(?:\w+:)?borders>/;
    return function parse_sty_xml(data, themes, opts) {
        var styles = {};
        if (!data) return styles;
        data = data.replace(/<!--([\s\S]*?)-->/mg, "").replace(/<!DOCTYPE[^\[]*\[[^\]]*\]>/gm, "");
        /* 18.8.39 styleSheet CT_Stylesheet */ var t;
        /* 18.8.31 numFmts CT_NumFmts ? */ if (t = data.match(numFmtRegex)) parse_numFmts(t, styles, opts);
        /* 18.8.23 fonts CT_Fonts ? */ if (t = data.match(fontsRegex)) parse_fonts(t, styles, themes, opts);
        /* 18.8.21 fills CT_Fills ? */ if (t = data.match(fillsRegex)) parse_fills(t, styles, themes, opts);
        /* 18.8.5  borders CT_Borders ? */ if (t = data.match(bordersRegex)) parse_borders(t, styles, themes, opts);
        /* 18.8.9  cellStyleXfs CT_CellStyleXfs ? */ /* 18.8.8  cellStyles CT_CellStyles ? */ /* 18.8.10 cellXfs CT_CellXfs ? */ if (t = data.match(cellXfRegex)) parse_cellXfs(t, styles, opts);
        /* 18.8.15 dxfs CT_Dxfs ? */ /* 18.8.42 tableStyles CT_TableStyles ? */ /* 18.8.11 colors CT_Colors ? */ /* 18.2.10 extLst CT_ExtensionList ? */ return styles;
    };
}();
function write_sty_xml(wb /*:Workbook*/ , opts) /*:string*/ {
    var o = [
        XML_HEADER,
        writextag("styleSheet", null, {
            "xmlns": XMLNS_main[0],
            "xmlns:vt": XMLNS.vt
        })
    ], w;
    if (wb.SSF && (w = write_numFmts(wb.SSF)) != null) o[o.length] = w;
    o[o.length] = '<fonts count="1"><font><sz val="12"/><color theme="1"/><name val="Calibri"/><family val="2"/><scheme val="minor"/></font></fonts>';
    o[o.length] = '<fills count="2"><fill><patternFill patternType="none"/></fill><fill><patternFill patternType="gray125"/></fill></fills>';
    o[o.length] = '<borders count="1"><border><left/><right/><top/><bottom/><diagonal/></border></borders>';
    o[o.length] = '<cellStyleXfs count="1"><xf numFmtId="0" fontId="0" fillId="0" borderId="0"/></cellStyleXfs>';
    if (w = write_cellXfs(opts.cellXfs)) o[o.length] = w;
    o[o.length] = '<cellStyles count="1"><cellStyle name="Normal" xfId="0" builtinId="0"/></cellStyles>';
    o[o.length] = '<dxfs count="0"/>';
    o[o.length] = '<tableStyles count="0" defaultTableStyle="TableStyleMedium9" defaultPivotStyle="PivotStyleMedium4"/>';
    if (o.length > 2) {
        o[o.length] = "</styleSheet>";
        o[1] = o[1].replace("/>", ">");
    }
    return o.join("");
}
/* [MS-XLSB] 2.4.657 BrtFmt */ function parse_BrtFmt(data, length /*:number*/ ) {
    var numFmtId = data.read_shift(2);
    var stFmtCode = parse_XLWideString(data, length - 2);
    return [
        numFmtId,
        stFmtCode
    ];
}
function write_BrtFmt(i /*:number*/ , f /*:string*/ , o) {
    if (!o) o = new_buf(6 + 4 * f.length);
    o.write_shift(2, i);
    write_XLWideString(f, o);
    var out = o.length > o.l ? o.slice(0, o.l) : o;
    if (o.l == null) o.l = o.length;
    return out;
}
/* [MS-XLSB] 2.4.659 BrtFont TODO */ function parse_BrtFont(data, length /*:number*/ , opts) {
    var out = {} /*:any*/ ;
    out.sz = data.read_shift(2) / 20;
    var grbit = parse_FontFlags(data, 2, opts);
    if (grbit.fItalic) out.italic = 1;
    if (grbit.fCondense) out.condense = 1;
    if (grbit.fExtend) out.extend = 1;
    if (grbit.fShadow) out.shadow = 1;
    if (grbit.fOutline) out.outline = 1;
    if (grbit.fStrikeout) out.strike = 1;
    var bls = data.read_shift(2);
    if (bls === 0x02BC) out.bold = 1;
    switch(data.read_shift(2)){
        /* case 0: out.vertAlign = "baseline"; break; */ case 1:
            out.vertAlign = "superscript";
            break;
        case 2:
            out.vertAlign = "subscript";
            break;
    }
    var underline = data.read_shift(1);
    if (underline != 0) out.underline = underline;
    var family = data.read_shift(1);
    if (family > 0) out.family = family;
    var bCharSet = data.read_shift(1);
    if (bCharSet > 0) out.charset = bCharSet;
    data.l++;
    out.color = parse_BrtColor(data, 8);
    switch(data.read_shift(1)){
        /* case 0: out.scheme = "none": break; */ case 1:
            out.scheme = "major";
            break;
        case 2:
            out.scheme = "minor";
            break;
    }
    out.name = parse_XLWideString(data, length - 21);
    return out;
}
function write_BrtFont(font /*:any*/ , o) {
    if (!o) o = new_buf(153);
    o.write_shift(2, font.sz * 20);
    write_FontFlags(font, o);
    o.write_shift(2, font.bold ? 0x02BC : 0x0190);
    var sss = 0;
    if (font.vertAlign == "superscript") sss = 1;
    else if (font.vertAlign == "subscript") sss = 2;
    o.write_shift(2, sss);
    o.write_shift(1, font.underline || 0);
    o.write_shift(1, font.family || 0);
    o.write_shift(1, font.charset || 0);
    o.write_shift(1, 0);
    write_BrtColor(font.color, o);
    var scheme = 0;
    if (font.scheme == "major") scheme = 1;
    if (font.scheme == "minor") scheme = 2;
    o.write_shift(1, scheme);
    write_XLWideString(font.name, o);
    return o.length > o.l ? o.slice(0, o.l) : o;
}
/* [MS-XLSB] 2.4.650 BrtFill */ var XLSBFillPTNames = [
    "none",
    "solid",
    "mediumGray",
    "darkGray",
    "lightGray",
    "darkHorizontal",
    "darkVertical",
    "darkDown",
    "darkUp",
    "darkGrid",
    "darkTrellis",
    "lightHorizontal",
    "lightVertical",
    "lightDown",
    "lightUp",
    "lightGrid",
    "lightTrellis",
    "gray125",
    "gray0625"
];
var rev_XLSBFillPTNames /*:EvertNumType*/ ;
/* TODO: gradient fill representation */ var parse_BrtFill = parsenoop;
function write_BrtFill(fill, o) {
    if (!o) o = new_buf(84);
    if (!rev_XLSBFillPTNames) rev_XLSBFillPTNames = evert(XLSBFillPTNames);
    var fls /*:number*/  = rev_XLSBFillPTNames[fill.patternType];
    if (fls == null) fls = 0x28;
    o.write_shift(4, fls);
    var j = 0;
    if (fls != 0x28) {
        /* TODO: custom FG Color */ write_BrtColor({
            auto: 1
        }, o);
        /* TODO: custom BG Color */ write_BrtColor({
            auto: 1
        }, o);
        for(; j < 12; ++j)o.write_shift(4, 0);
    } else {
        for(; j < 4; ++j)o.write_shift(4, 0);
        for(; j < 12; ++j)o.write_shift(4, 0); /* TODO */ 
    /* iGradientType */ /* xnumDegree */ /* xnumFillToLeft */ /* xnumFillToRight */ /* xnumFillToTop */ /* xnumFillToBottom */ /* cNumStop */ /* xfillGradientStop */ }
    return o.length > o.l ? o.slice(0, o.l) : o;
}
/* [MS-XLSB] 2.4.824 BrtXF */ function parse_BrtXF(data, length /*:number*/ ) {
    var tgt = data.l + length;
    var ixfeParent = data.read_shift(2);
    var ifmt = data.read_shift(2);
    data.l = tgt;
    return {
        ixfe: ixfeParent,
        numFmtId: ifmt
    };
}
function write_BrtXF(data, ixfeP, o) {
    if (!o) o = new_buf(16);
    o.write_shift(2, ixfeP || 0);
    o.write_shift(2, data.numFmtId || 0);
    o.write_shift(2, 0); /* iFont */ 
    o.write_shift(2, 0); /* iFill */ 
    o.write_shift(2, 0); /* ixBorder */ 
    o.write_shift(1, 0); /* trot */ 
    o.write_shift(1, 0); /* indent */ 
    var flow = 0;
    o.write_shift(1, flow); /* flags */ 
    o.write_shift(1, 0); /* flags */ 
    o.write_shift(1, 0); /* xfGrbitAtr */ 
    o.write_shift(1, 0);
    return o;
}
/* [MS-XLSB] 2.5.4 Blxf TODO */ function write_Blxf(data, o) {
    if (!o) o = new_buf(10);
    o.write_shift(1, 0); /* dg */ 
    o.write_shift(1, 0);
    o.write_shift(4, 0); /* color */ 
    o.write_shift(4, 0); /* color */ 
    return o;
}
/* [MS-XLSB] 2.4.302 BrtBorder TODO */ var parse_BrtBorder = parsenoop;
function write_BrtBorder(border, o) {
    if (!o) o = new_buf(51);
    o.write_shift(1, 0); /* diagonal */ 
    write_Blxf(null, o); /* top */ 
    write_Blxf(null, o); /* bottom */ 
    write_Blxf(null, o); /* left */ 
    write_Blxf(null, o); /* right */ 
    write_Blxf(null, o); /* diag */ 
    return o.length > o.l ? o.slice(0, o.l) : o;
}
/* [MS-XLSB] 2.4.763 BrtStyle TODO */ function write_BrtStyle(style, o) {
    if (!o) o = new_buf(52);
    o.write_shift(4, style.xfId);
    o.write_shift(2, 1);
    o.write_shift(1, +style.builtinId);
    o.write_shift(1, 0); /* iLevel */ 
    write_XLNullableWideString(style.name || "", o);
    return o.length > o.l ? o.slice(0, o.l) : o;
}
/* [MS-XLSB] 2.4.272 BrtBeginTableStyles */ function write_BrtBeginTableStyles(cnt, defTableStyle, defPivotStyle) {
    var o = new_buf(2052);
    o.write_shift(4, cnt);
    write_XLNullableWideString(defTableStyle, o);
    write_XLNullableWideString(defPivotStyle, o);
    return o.length > o.l ? o.slice(0, o.l) : o;
}
/* [MS-XLSB] 2.1.7.50 Styles */ function parse_sty_bin(data, themes, opts) {
    var styles = {};
    styles.NumberFmt = [];
    for(var y in table_fmt)styles.NumberFmt[y] = table_fmt[y];
    styles.CellXf = [];
    styles.Fonts = [];
    var state /*:Array<string>*/  = [];
    var pass = false;
    recordhopper(data, function hopper_sty(val, R, RT) {
        switch(RT){
            case 0x002C:
                /* BrtFmt */ styles.NumberFmt[val[0]] = val[1];
                SSF_load(val[1], val[0]);
                break;
            case 0x002B:
                /* BrtFont */ styles.Fonts.push(val);
                if (val.color.theme != null && themes && themes.themeElements && themes.themeElements.clrScheme) val.color.rgb = rgb_tint(themes.themeElements.clrScheme[val.color.theme].rgb, val.color.tint || 0);
                break;
            case 0x0401:
                break;
            case 0x002D:
                break;
            case 0x002E:
                break;
            case 0x002F:
                /* BrtXF */ if (state[state.length - 1] == 0x0269 /* BrtBeginCellXFs */ ) styles.CellXf.push(val);
                break;
            case 0x0030:
            /* BrtStyle */ case 0x01FB:
            /* BrtDXF */ case 0x023C:
            /* BrtMRUColor */ case 0x01DB:
                break;
            case 0x0493:
            /* BrtDXF14 */ case 0x0836:
            /* BrtDXF15 */ case 0x046A:
            /* BrtSlicerStyleElement */ case 0x0200:
            /* BrtTableStyleElement */ case 0x082F:
            /* BrtTimelineStyleElement */ case 0x0C00:
                break;
            case 0x0023:
                /* BrtFRTBegin */ pass = true;
                break;
            case 0x0024:
                /* BrtFRTEnd */ pass = false;
                break;
            case 0x0025:
                /* BrtACBegin */ state.push(RT);
                pass = true;
                break;
            case 0x0026:
                /* BrtACEnd */ state.pop();
                pass = false;
                break;
            default:
                if (R.T > 0) state.push(RT);
                else if (R.T < 0) state.pop();
                else if (!pass || opts.WTF && state[state.length - 1] != 0x0025 /* BrtACBegin */ ) throw new Error("Unexpected record 0x" + RT.toString(16));
        }
    });
    return styles;
}
function write_FMTS_bin(ba, NF /*:?SSFTable*/ ) {
    if (!NF) return;
    var cnt = 0;
    [
        [
            5,
            8
        ],
        [
            23,
            26
        ],
        [
            41,
            44
        ],
        [
            /*63*/ 50,
            /*66],[164,*/ 392
        ]
    ].forEach(function(r) {
        /*:: if(!NF) return; */ for(var i = r[0]; i <= r[1]; ++i)if (NF[i] != null) ++cnt;
    });
    if (cnt == 0) return;
    write_record(ba, 0x0267 /* BrtBeginFmts */ , write_UInt32LE(cnt));
    [
        [
            5,
            8
        ],
        [
            23,
            26
        ],
        [
            41,
            44
        ],
        [
            /*63*/ 50,
            /*66],[164,*/ 392
        ]
    ].forEach(function(r) {
        /*:: if(!NF) return; */ for(var i = r[0]; i <= r[1]; ++i)if (NF[i] != null) write_record(ba, 0x002C /* BrtFmt */ , write_BrtFmt(i, NF[i]));
    });
    write_record(ba, 0x0268 /* BrtEndFmts */ );
}
function write_FONTS_bin(ba /*::, data*/ ) {
    var cnt = 1;
    if (cnt == 0) return;
    write_record(ba, 0x0263 /* BrtBeginFonts */ , write_UInt32LE(cnt));
    write_record(ba, 0x002B /* BrtFont */ , write_BrtFont({
        sz: 12,
        color: {
            theme: 1
        },
        name: "Calibri",
        family: 2,
        scheme: "minor"
    }));
    /* 1*65491BrtFont [ACFONTS] */ write_record(ba, 0x0264 /* BrtEndFonts */ );
}
function write_FILLS_bin(ba /*::, data*/ ) {
    var cnt = 2;
    if (cnt == 0) return;
    write_record(ba, 0x025B /* BrtBeginFills */ , write_UInt32LE(cnt));
    write_record(ba, 0x002D /* BrtFill */ , write_BrtFill({
        patternType: "none"
    }));
    write_record(ba, 0x002D /* BrtFill */ , write_BrtFill({
        patternType: "gray125"
    }));
    /* 1*65431BrtFill */ write_record(ba, 0x025C /* BrtEndFills */ );
}
function write_BORDERS_bin(ba /*::, data*/ ) {
    var cnt = 1;
    if (cnt == 0) return;
    write_record(ba, 0x0265 /* BrtBeginBorders */ , write_UInt32LE(cnt));
    write_record(ba, 0x002E /* BrtBorder */ , write_BrtBorder({}));
    /* 1*65430BrtBorder */ write_record(ba, 0x0266 /* BrtEndBorders */ );
}
function write_CELLSTYLEXFS_bin(ba /*::, data*/ ) {
    var cnt = 1;
    write_record(ba, 0x0272 /* BrtBeginCellStyleXFs */ , write_UInt32LE(cnt));
    write_record(ba, 0x002F /* BrtXF */ , write_BrtXF({
        numFmtId: 0,
        fontId: 0,
        fillId: 0,
        borderId: 0
    }, 0xFFFF));
    /* 1*65430(BrtXF *FRT) */ write_record(ba, 0x0273 /* BrtEndCellStyleXFs */ );
}
function write_CELLXFS_bin(ba, data) {
    write_record(ba, 0x0269 /* BrtBeginCellXFs */ , write_UInt32LE(data.length));
    data.forEach(function(c) {
        write_record(ba, 0x002F /* BrtXF */ , write_BrtXF(c, 0));
    });
    /* 1*65430(BrtXF *FRT) */ write_record(ba, 0x026A /* BrtEndCellXFs */ );
}
function write_STYLES_bin(ba /*::, data*/ ) {
    var cnt = 1;
    write_record(ba, 0x026B /* BrtBeginStyles */ , write_UInt32LE(cnt));
    write_record(ba, 0x0030 /* BrtStyle */ , write_BrtStyle({
        xfId: 0,
        builtinId: 0,
        name: "Normal"
    }));
    /* 1*65430(BrtStyle *FRT) */ write_record(ba, 0x026C /* BrtEndStyles */ );
}
function write_DXFS_bin(ba /*::, data*/ ) {
    var cnt = 0;
    write_record(ba, 0x01F9 /* BrtBeginDXFs */ , write_UInt32LE(cnt));
    /* *2147483647(BrtDXF *FRT) */ write_record(ba, 0x01FA /* BrtEndDXFs */ );
}
function write_TABLESTYLES_bin(ba /*::, data*/ ) {
    var cnt = 0;
    write_record(ba, 0x01FC /* BrtBeginTableStyles */ , write_BrtBeginTableStyles(cnt, "TableStyleMedium9", "PivotStyleMedium4"));
    /* *TABLESTYLE */ write_record(ba, 0x01FD /* BrtEndTableStyles */ );
}
function write_COLORPALETTE_bin() {
    return;
/* BrtBeginColorPalette [INDEXEDCOLORS] [MRUCOLORS] BrtEndColorPalette */ }
/* [MS-XLSB] 2.1.7.50 Styles */ function write_sty_bin(wb, opts) {
    var ba = buf_array();
    write_record(ba, 0x0116 /* BrtBeginStyleSheet */ );
    write_FMTS_bin(ba, wb.SSF);
    write_FONTS_bin(ba, wb);
    write_FILLS_bin(ba, wb);
    write_BORDERS_bin(ba, wb);
    write_CELLSTYLEXFS_bin(ba, wb);
    write_CELLXFS_bin(ba, opts.cellXfs);
    write_STYLES_bin(ba, wb);
    write_DXFS_bin(ba, wb);
    write_TABLESTYLES_bin(ba, wb);
    write_COLORPALETTE_bin(ba, wb);
    /* FRTSTYLESHEET*/ write_record(ba, 0x0117 /* BrtEndStyleSheet */ );
    return ba.end();
}
/* Even though theme layout is dk1 lt1 dk2 lt2, true order is lt1 dk1 lt2 dk2 */ var XLSXThemeClrScheme = [
    "</a:lt1>",
    "</a:dk1>",
    "</a:lt2>",
    "</a:dk2>",
    "</a:accent1>",
    "</a:accent2>",
    "</a:accent3>",
    "</a:accent4>",
    "</a:accent5>",
    "</a:accent6>",
    "</a:hlink>",
    "</a:folHlink>"
];
/* 20.1.6.2 clrScheme CT_ColorScheme */ function parse_clrScheme(t, themes, opts) {
    themes.themeElements.clrScheme = [];
    var color = {};
    (t[0].match(tagregex) || []).forEach(function(x) {
        var y = parsexmltag(x);
        switch(y[0]){
            /* 20.1.6.2 clrScheme (Color Scheme) CT_ColorScheme */ case "<a:clrScheme":
            case "</a:clrScheme>":
                break;
            /* 20.1.2.3.32 srgbClr CT_SRgbColor */ case "<a:srgbClr":
                color.rgb = y.val;
                break;
            /* 20.1.2.3.33 sysClr CT_SystemColor */ case "<a:sysClr":
                color.rgb = y.lastClr;
                break;
            /* 20.1.4.1.1 accent1 (Accent 1) */ /* 20.1.4.1.2 accent2 (Accent 2) */ /* 20.1.4.1.3 accent3 (Accent 3) */ /* 20.1.4.1.4 accent4 (Accent 4) */ /* 20.1.4.1.5 accent5 (Accent 5) */ /* 20.1.4.1.6 accent6 (Accent 6) */ /* 20.1.4.1.9 dk1 (Dark 1) */ /* 20.1.4.1.10 dk2 (Dark 2) */ /* 20.1.4.1.15 folHlink (Followed Hyperlink) */ /* 20.1.4.1.19 hlink (Hyperlink) */ /* 20.1.4.1.22 lt1 (Light 1) */ /* 20.1.4.1.23 lt2 (Light 2) */ case "<a:dk1>":
            case "</a:dk1>":
            case "<a:lt1>":
            case "</a:lt1>":
            case "<a:dk2>":
            case "</a:dk2>":
            case "<a:lt2>":
            case "</a:lt2>":
            case "<a:accent1>":
            case "</a:accent1>":
            case "<a:accent2>":
            case "</a:accent2>":
            case "<a:accent3>":
            case "</a:accent3>":
            case "<a:accent4>":
            case "</a:accent4>":
            case "<a:accent5>":
            case "</a:accent5>":
            case "<a:accent6>":
            case "</a:accent6>":
            case "<a:hlink>":
            case "</a:hlink>":
            case "<a:folHlink>":
            case "</a:folHlink>":
                if (y[0].charAt(1) === "/") {
                    themes.themeElements.clrScheme[XLSXThemeClrScheme.indexOf(y[0])] = color;
                    color = {};
                } else color.name = y[0].slice(3, y[0].length - 1);
                break;
            default:
                if (opts && opts.WTF) throw new Error("Unrecognized " + y[0] + " in clrScheme");
        }
    });
}
/* 20.1.4.1.18 fontScheme CT_FontScheme */ function parse_fontScheme() {}
/* 20.1.4.1.15 fmtScheme CT_StyleMatrix */ function parse_fmtScheme() {}
var clrsregex = /<a:clrScheme([^>]*)>[\s\S]*<\/a:clrScheme>/;
var fntsregex = /<a:fontScheme([^>]*)>[\s\S]*<\/a:fontScheme>/;
var fmtsregex = /<a:fmtScheme([^>]*)>[\s\S]*<\/a:fmtScheme>/;
/* 20.1.6.10 themeElements CT_BaseStyles */ function parse_themeElements(data, themes, opts) {
    themes.themeElements = {};
    var t;
    [
        /* clrScheme CT_ColorScheme */ [
            "clrScheme",
            clrsregex,
            parse_clrScheme
        ],
        /* fontScheme CT_FontScheme */ [
            "fontScheme",
            fntsregex,
            parse_fontScheme
        ],
        /* fmtScheme CT_StyleMatrix */ [
            "fmtScheme",
            fmtsregex,
            parse_fmtScheme
        ]
    ].forEach(function(m) {
        if (!(t = data.match(m[1]))) throw new Error(m[0] + " not found in themeElements");
        m[2](t, themes, opts);
    });
}
var themeltregex = /<a:themeElements([^>]*)>[\s\S]*<\/a:themeElements>/;
/* 14.2.7 Theme Part */ function parse_theme_xml(data /*:string*/ , opts) {
    /* 20.1.6.9 theme CT_OfficeStyleSheet */ if (!data || data.length === 0) data = write_theme();
    var t;
    var themes = {};
    /* themeElements CT_BaseStyles */ if (!(t = data.match(themeltregex))) throw new Error("themeElements not found in theme");
    parse_themeElements(t[0], themes, opts);
    themes.raw = data;
    return themes;
}
function write_theme(Themes, opts) /*:string*/ {
    if (opts && opts.themeXLSX) return opts.themeXLSX;
    if (Themes && typeof Themes.raw == "string") return Themes.raw;
    var o = [
        XML_HEADER
    ];
    o[o.length] = '<a:theme xmlns:a="http://schemas.openxmlformats.org/drawingml/2006/main" name="Office Theme">';
    o[o.length] = "<a:themeElements>";
    o[o.length] = '<a:clrScheme name="Office">';
    o[o.length] = '<a:dk1><a:sysClr val="windowText" lastClr="000000"/></a:dk1>';
    o[o.length] = '<a:lt1><a:sysClr val="window" lastClr="FFFFFF"/></a:lt1>';
    o[o.length] = '<a:dk2><a:srgbClr val="1F497D"/></a:dk2>';
    o[o.length] = '<a:lt2><a:srgbClr val="EEECE1"/></a:lt2>';
    o[o.length] = '<a:accent1><a:srgbClr val="4F81BD"/></a:accent1>';
    o[o.length] = '<a:accent2><a:srgbClr val="C0504D"/></a:accent2>';
    o[o.length] = '<a:accent3><a:srgbClr val="9BBB59"/></a:accent3>';
    o[o.length] = '<a:accent4><a:srgbClr val="8064A2"/></a:accent4>';
    o[o.length] = '<a:accent5><a:srgbClr val="4BACC6"/></a:accent5>';
    o[o.length] = '<a:accent6><a:srgbClr val="F79646"/></a:accent6>';
    o[o.length] = '<a:hlink><a:srgbClr val="0000FF"/></a:hlink>';
    o[o.length] = '<a:folHlink><a:srgbClr val="800080"/></a:folHlink>';
    o[o.length] = "</a:clrScheme>";
    o[o.length] = '<a:fontScheme name="Office">';
    o[o.length] = "<a:majorFont>";
    o[o.length] = '<a:latin typeface="Cambria"/>';
    o[o.length] = '<a:ea typeface=""/>';
    o[o.length] = '<a:cs typeface=""/>';
    o[o.length] = '<a:font script="Jpan" typeface="ＭＳ Ｐゴシック"/>';
    o[o.length] = '<a:font script="Hang" typeface="맑은 고딕"/>';
    o[o.length] = '<a:font script="Hans" typeface="宋体"/>';
    o[o.length] = '<a:font script="Hant" typeface="新細明體"/>';
    o[o.length] = '<a:font script="Arab" typeface="Times New Roman"/>';
    o[o.length] = '<a:font script="Hebr" typeface="Times New Roman"/>';
    o[o.length] = '<a:font script="Thai" typeface="Tahoma"/>';
    o[o.length] = '<a:font script="Ethi" typeface="Nyala"/>';
    o[o.length] = '<a:font script="Beng" typeface="Vrinda"/>';
    o[o.length] = '<a:font script="Gujr" typeface="Shruti"/>';
    o[o.length] = '<a:font script="Khmr" typeface="MoolBoran"/>';
    o[o.length] = '<a:font script="Knda" typeface="Tunga"/>';
    o[o.length] = '<a:font script="Guru" typeface="Raavi"/>';
    o[o.length] = '<a:font script="Cans" typeface="Euphemia"/>';
    o[o.length] = '<a:font script="Cher" typeface="Plantagenet Cherokee"/>';
    o[o.length] = '<a:font script="Yiii" typeface="Microsoft Yi Baiti"/>';
    o[o.length] = '<a:font script="Tibt" typeface="Microsoft Himalaya"/>';
    o[o.length] = '<a:font script="Thaa" typeface="MV Boli"/>';
    o[o.length] = '<a:font script="Deva" typeface="Mangal"/>';
    o[o.length] = '<a:font script="Telu" typeface="Gautami"/>';
    o[o.length] = '<a:font script="Taml" typeface="Latha"/>';
    o[o.length] = '<a:font script="Syrc" typeface="Estrangelo Edessa"/>';
    o[o.length] = '<a:font script="Orya" typeface="Kalinga"/>';
    o[o.length] = '<a:font script="Mlym" typeface="Kartika"/>';
    o[o.length] = '<a:font script="Laoo" typeface="DokChampa"/>';
    o[o.length] = '<a:font script="Sinh" typeface="Iskoola Pota"/>';
    o[o.length] = '<a:font script="Mong" typeface="Mongolian Baiti"/>';
    o[o.length] = '<a:font script="Viet" typeface="Times New Roman"/>';
    o[o.length] = '<a:font script="Uigh" typeface="Microsoft Uighur"/>';
    o[o.length] = '<a:font script="Geor" typeface="Sylfaen"/>';
    o[o.length] = "</a:majorFont>";
    o[o.length] = "<a:minorFont>";
    o[o.length] = '<a:latin typeface="Calibri"/>';
    o[o.length] = '<a:ea typeface=""/>';
    o[o.length] = '<a:cs typeface=""/>';
    o[o.length] = '<a:font script="Jpan" typeface="ＭＳ Ｐゴシック"/>';
    o[o.length] = '<a:font script="Hang" typeface="맑은 고딕"/>';
    o[o.length] = '<a:font script="Hans" typeface="宋体"/>';
    o[o.length] = '<a:font script="Hant" typeface="新細明體"/>';
    o[o.length] = '<a:font script="Arab" typeface="Arial"/>';
    o[o.length] = '<a:font script="Hebr" typeface="Arial"/>';
    o[o.length] = '<a:font script="Thai" typeface="Tahoma"/>';
    o[o.length] = '<a:font script="Ethi" typeface="Nyala"/>';
    o[o.length] = '<a:font script="Beng" typeface="Vrinda"/>';
    o[o.length] = '<a:font script="Gujr" typeface="Shruti"/>';
    o[o.length] = '<a:font script="Khmr" typeface="DaunPenh"/>';
    o[o.length] = '<a:font script="Knda" typeface="Tunga"/>';
    o[o.length] = '<a:font script="Guru" typeface="Raavi"/>';
    o[o.length] = '<a:font script="Cans" typeface="Euphemia"/>';
    o[o.length] = '<a:font script="Cher" typeface="Plantagenet Cherokee"/>';
    o[o.length] = '<a:font script="Yiii" typeface="Microsoft Yi Baiti"/>';
    o[o.length] = '<a:font script="Tibt" typeface="Microsoft Himalaya"/>';
    o[o.length] = '<a:font script="Thaa" typeface="MV Boli"/>';
    o[o.length] = '<a:font script="Deva" typeface="Mangal"/>';
    o[o.length] = '<a:font script="Telu" typeface="Gautami"/>';
    o[o.length] = '<a:font script="Taml" typeface="Latha"/>';
    o[o.length] = '<a:font script="Syrc" typeface="Estrangelo Edessa"/>';
    o[o.length] = '<a:font script="Orya" typeface="Kalinga"/>';
    o[o.length] = '<a:font script="Mlym" typeface="Kartika"/>';
    o[o.length] = '<a:font script="Laoo" typeface="DokChampa"/>';
    o[o.length] = '<a:font script="Sinh" typeface="Iskoola Pota"/>';
    o[o.length] = '<a:font script="Mong" typeface="Mongolian Baiti"/>';
    o[o.length] = '<a:font script="Viet" typeface="Arial"/>';
    o[o.length] = '<a:font script="Uigh" typeface="Microsoft Uighur"/>';
    o[o.length] = '<a:font script="Geor" typeface="Sylfaen"/>';
    o[o.length] = "</a:minorFont>";
    o[o.length] = "</a:fontScheme>";
    o[o.length] = '<a:fmtScheme name="Office">';
    o[o.length] = "<a:fillStyleLst>";
    o[o.length] = '<a:solidFill><a:schemeClr val="phClr"/></a:solidFill>';
    o[o.length] = '<a:gradFill rotWithShape="1">';
    o[o.length] = "<a:gsLst>";
    o[o.length] = '<a:gs pos="0"><a:schemeClr val="phClr"><a:tint val="50000"/><a:satMod val="300000"/></a:schemeClr></a:gs>';
    o[o.length] = '<a:gs pos="35000"><a:schemeClr val="phClr"><a:tint val="37000"/><a:satMod val="300000"/></a:schemeClr></a:gs>';
    o[o.length] = '<a:gs pos="100000"><a:schemeClr val="phClr"><a:tint val="15000"/><a:satMod val="350000"/></a:schemeClr></a:gs>';
    o[o.length] = "</a:gsLst>";
    o[o.length] = '<a:lin ang="16200000" scaled="1"/>';
    o[o.length] = "</a:gradFill>";
    o[o.length] = '<a:gradFill rotWithShape="1">';
    o[o.length] = "<a:gsLst>";
    o[o.length] = '<a:gs pos="0"><a:schemeClr val="phClr"><a:tint val="100000"/><a:shade val="100000"/><a:satMod val="130000"/></a:schemeClr></a:gs>';
    o[o.length] = '<a:gs pos="100000"><a:schemeClr val="phClr"><a:tint val="50000"/><a:shade val="100000"/><a:satMod val="350000"/></a:schemeClr></a:gs>';
    o[o.length] = "</a:gsLst>";
    o[o.length] = '<a:lin ang="16200000" scaled="0"/>';
    o[o.length] = "</a:gradFill>";
    o[o.length] = "</a:fillStyleLst>";
    o[o.length] = "<a:lnStyleLst>";
    o[o.length] = '<a:ln w="9525" cap="flat" cmpd="sng" algn="ctr"><a:solidFill><a:schemeClr val="phClr"><a:shade val="95000"/><a:satMod val="105000"/></a:schemeClr></a:solidFill><a:prstDash val="solid"/></a:ln>';
    o[o.length] = '<a:ln w="25400" cap="flat" cmpd="sng" algn="ctr"><a:solidFill><a:schemeClr val="phClr"/></a:solidFill><a:prstDash val="solid"/></a:ln>';
    o[o.length] = '<a:ln w="38100" cap="flat" cmpd="sng" algn="ctr"><a:solidFill><a:schemeClr val="phClr"/></a:solidFill><a:prstDash val="solid"/></a:ln>';
    o[o.length] = "</a:lnStyleLst>";
    o[o.length] = "<a:effectStyleLst>";
    o[o.length] = "<a:effectStyle>";
    o[o.length] = "<a:effectLst>";
    o[o.length] = '<a:outerShdw blurRad="40000" dist="20000" dir="5400000" rotWithShape="0"><a:srgbClr val="000000"><a:alpha val="38000"/></a:srgbClr></a:outerShdw>';
    o[o.length] = "</a:effectLst>";
    o[o.length] = "</a:effectStyle>";
    o[o.length] = "<a:effectStyle>";
    o[o.length] = "<a:effectLst>";
    o[o.length] = '<a:outerShdw blurRad="40000" dist="23000" dir="5400000" rotWithShape="0"><a:srgbClr val="000000"><a:alpha val="35000"/></a:srgbClr></a:outerShdw>';
    o[o.length] = "</a:effectLst>";
    o[o.length] = "</a:effectStyle>";
    o[o.length] = "<a:effectStyle>";
    o[o.length] = "<a:effectLst>";
    o[o.length] = '<a:outerShdw blurRad="40000" dist="23000" dir="5400000" rotWithShape="0"><a:srgbClr val="000000"><a:alpha val="35000"/></a:srgbClr></a:outerShdw>';
    o[o.length] = "</a:effectLst>";
    o[o.length] = '<a:scene3d><a:camera prst="orthographicFront"><a:rot lat="0" lon="0" rev="0"/></a:camera><a:lightRig rig="threePt" dir="t"><a:rot lat="0" lon="0" rev="1200000"/></a:lightRig></a:scene3d>';
    o[o.length] = '<a:sp3d><a:bevelT w="63500" h="25400"/></a:sp3d>';
    o[o.length] = "</a:effectStyle>";
    o[o.length] = "</a:effectStyleLst>";
    o[o.length] = "<a:bgFillStyleLst>";
    o[o.length] = '<a:solidFill><a:schemeClr val="phClr"/></a:solidFill>';
    o[o.length] = '<a:gradFill rotWithShape="1">';
    o[o.length] = "<a:gsLst>";
    o[o.length] = '<a:gs pos="0"><a:schemeClr val="phClr"><a:tint val="40000"/><a:satMod val="350000"/></a:schemeClr></a:gs>';
    o[o.length] = '<a:gs pos="40000"><a:schemeClr val="phClr"><a:tint val="45000"/><a:shade val="99000"/><a:satMod val="350000"/></a:schemeClr></a:gs>';
    o[o.length] = '<a:gs pos="100000"><a:schemeClr val="phClr"><a:shade val="20000"/><a:satMod val="255000"/></a:schemeClr></a:gs>';
    o[o.length] = "</a:gsLst>";
    o[o.length] = '<a:path path="circle"><a:fillToRect l="50000" t="-80000" r="50000" b="180000"/></a:path>';
    o[o.length] = "</a:gradFill>";
    o[o.length] = '<a:gradFill rotWithShape="1">';
    o[o.length] = "<a:gsLst>";
    o[o.length] = '<a:gs pos="0"><a:schemeClr val="phClr"><a:tint val="80000"/><a:satMod val="300000"/></a:schemeClr></a:gs>';
    o[o.length] = '<a:gs pos="100000"><a:schemeClr val="phClr"><a:shade val="30000"/><a:satMod val="200000"/></a:schemeClr></a:gs>';
    o[o.length] = "</a:gsLst>";
    o[o.length] = '<a:path path="circle"><a:fillToRect l="50000" t="50000" r="50000" b="50000"/></a:path>';
    o[o.length] = "</a:gradFill>";
    o[o.length] = "</a:bgFillStyleLst>";
    o[o.length] = "</a:fmtScheme>";
    o[o.length] = "</a:themeElements>";
    o[o.length] = "<a:objectDefaults>";
    o[o.length] = "<a:spDef>";
    o[o.length] = '<a:spPr/><a:bodyPr/><a:lstStyle/><a:style><a:lnRef idx="1"><a:schemeClr val="accent1"/></a:lnRef><a:fillRef idx="3"><a:schemeClr val="accent1"/></a:fillRef><a:effectRef idx="2"><a:schemeClr val="accent1"/></a:effectRef><a:fontRef idx="minor"><a:schemeClr val="lt1"/></a:fontRef></a:style>';
    o[o.length] = "</a:spDef>";
    o[o.length] = "<a:lnDef>";
    o[o.length] = '<a:spPr/><a:bodyPr/><a:lstStyle/><a:style><a:lnRef idx="2"><a:schemeClr val="accent1"/></a:lnRef><a:fillRef idx="0"><a:schemeClr val="accent1"/></a:fillRef><a:effectRef idx="1"><a:schemeClr val="accent1"/></a:effectRef><a:fontRef idx="minor"><a:schemeClr val="tx1"/></a:fontRef></a:style>';
    o[o.length] = "</a:lnDef>";
    o[o.length] = "</a:objectDefaults>";
    o[o.length] = "<a:extraClrSchemeLst/>";
    o[o.length] = "</a:theme>";
    return o.join("");
}
/* [MS-XLS] 2.4.326 TODO: payload is a zip file */ function parse_Theme(blob, length, opts) {
    var end = blob.l + length;
    var dwThemeVersion = blob.read_shift(4);
    if (dwThemeVersion === 124226) return;
    if (!opts.cellStyles) {
        blob.l = end;
        return;
    }
    var data = blob.slice(blob.l);
    blob.l = end;
    var zip;
    try {
        zip = zip_read(data, {
            type: "array"
        });
    } catch (e) {
        return;
    }
    var themeXML = getzipstr(zip, "theme/theme/theme1.xml", true);
    if (!themeXML) return;
    return parse_theme_xml(themeXML, opts);
}
/* 2.5.49 */ function parse_ColorTheme(blob /*::, length*/ ) {
    return blob.read_shift(4);
}
/* 2.5.155 */ function parse_FullColorExt(blob /*::, length*/ ) {
    var o = {};
    o.xclrType = blob.read_shift(2);
    o.nTintShade = blob.read_shift(2);
    switch(o.xclrType){
        case 0:
            blob.l += 4;
            break;
        case 1:
            o.xclrValue = parse_IcvXF(blob, 4);
            break;
        case 2:
            o.xclrValue = parse_LongRGBA(blob, 4);
            break;
        case 3:
            o.xclrValue = parse_ColorTheme(blob, 4);
            break;
        case 4:
            blob.l += 4;
            break;
    }
    blob.l += 8;
    return o;
}
/* 2.5.164 TODO: read 7 bits*/ function parse_IcvXF(blob, length) {
    return parsenoop(blob, length);
}
/* 2.5.280 */ function parse_XFExtGradient(blob, length) {
    return parsenoop(blob, length);
}
/* [MS-XLS] 2.5.108 */ function parse_ExtProp(blob /*::, length*/ ) /*:Array<any>*/ {
    var extType = blob.read_shift(2);
    var cb = blob.read_shift(2) - 4;
    var o = [
        extType
    ];
    switch(extType){
        case 0x04:
        case 0x05:
        case 0x07:
        case 0x08:
        case 0x09:
        case 0x0A:
        case 0x0B:
        case 0x0D:
            o[1] = parse_FullColorExt(blob, cb);
            break;
        case 0x06:
            o[1] = parse_XFExtGradient(blob, cb);
            break;
        case 0x0E:
        case 0x0F:
            o[1] = blob.read_shift(cb === 1 ? 1 : 2);
            break;
        default:
            throw new Error("Unrecognized ExtProp type: " + extType + " " + cb);
    }
    return o;
}
/* 2.4.355 */ function parse_XFExt(blob, length) {
    var end = blob.l + length;
    blob.l += 2;
    var ixfe = blob.read_shift(2);
    blob.l += 2;
    var cexts = blob.read_shift(2);
    var ext /*:AOA*/  = [];
    while(cexts-- > 0)ext.push(parse_ExtProp(blob, end - blob.l));
    return {
        ixfe: ixfe,
        ext: ext
    };
}
/* xf is an XF, see parse_XFExt for xfext */ function update_xfext(xf, xfext) {
    xfext.forEach(function(xfe) {
        xfe[0];
    });
}
function parse_BrtMdtinfo(data, length) {
    return {
        flags: data.read_shift(4),
        version: data.read_shift(4),
        name: parse_XLWideString(data, length - 8)
    };
}
function write_BrtMdtinfo(data) {
    var o = new_buf(12 + 2 * data.name.length);
    o.write_shift(4, data.flags);
    o.write_shift(4, data.version);
    write_XLWideString(data.name, o);
    return o.slice(0, o.l);
}
function parse_BrtMdb(data) {
    var out = [];
    var cnt = data.read_shift(4);
    while(cnt-- > 0)out.push([
        data.read_shift(4),
        data.read_shift(4)
    ]);
    return out;
}
function write_BrtMdb(mdb) {
    var o = new_buf(4 + 8 * mdb.length);
    o.write_shift(4, mdb.length);
    for(var i = 0; i < mdb.length; ++i){
        o.write_shift(4, mdb[i][0]);
        o.write_shift(4, mdb[i][1]);
    }
    return o;
}
function write_BrtBeginEsfmd(cnt, name) {
    var o = new_buf(8 + 2 * name.length);
    o.write_shift(4, cnt);
    write_XLWideString(name, o);
    return o.slice(0, o.l);
}
function parse_BrtBeginEsmdb(data) {
    data.l += 4;
    return data.read_shift(4) != 0;
}
function write_BrtBeginEsmdb(cnt, cm) {
    var o = new_buf(8);
    o.write_shift(4, cnt);
    o.write_shift(4, cm ? 1 : 0);
    return o;
}
function parse_xlmeta_bin(data, name, _opts) {
    var out = {
        Types: [],
        Cell: [],
        Value: []
    };
    var opts = _opts || {};
    var state = [];
    var pass = false;
    var metatype = 2;
    recordhopper(data, function(val, R, RT) {
        switch(RT){
            case 335:
                out.Types.push({
                    name: val.name
                });
                break;
            case 51:
                val.forEach(function(r) {
                    if (metatype == 1) out.Cell.push({
                        type: out.Types[r[0] - 1].name,
                        index: r[1]
                    });
                    else if (metatype == 0) out.Value.push({
                        type: out.Types[r[0] - 1].name,
                        index: r[1]
                    });
                });
                break;
            case 337:
                metatype = val ? 1 : 0;
                break;
            case 338:
                metatype = 2;
                break;
            case 35:
                state.push(RT);
                pass = true;
                break;
            case 36:
                state.pop();
                pass = false;
                break;
            default:
                if (R.T) ;
                else if (!pass || opts.WTF && state[state.length - 1] != 35) throw new Error("Unexpected record 0x" + RT.toString(16));
        }
    });
    return out;
}
function write_xlmeta_bin() {
    var ba = buf_array();
    write_record(ba, 332);
    write_record(ba, 334, write_UInt32LE(1));
    write_record(ba, 335, write_BrtMdtinfo({
        name: "XLDAPR",
        version: 12e4,
        flags: 3496657072
    }));
    write_record(ba, 336);
    write_record(ba, 339, write_BrtBeginEsfmd(1, "XLDAPR"));
    write_record(ba, 52);
    write_record(ba, 35, write_UInt32LE(514));
    write_record(ba, 4096, write_UInt32LE(0));
    write_record(ba, 4097, writeuint16(1));
    write_record(ba, 36);
    write_record(ba, 53);
    write_record(ba, 340);
    write_record(ba, 337, write_BrtBeginEsmdb(1, true));
    write_record(ba, 51, write_BrtMdb([
        [
            1,
            0
        ]
    ]));
    write_record(ba, 338);
    write_record(ba, 333);
    return ba.end();
}
function parse_xlmeta_xml(data, name, opts) {
    var out = {
        Types: [],
        Cell: [],
        Value: []
    };
    if (!data) return out;
    var pass = false;
    var metatype = 2;
    var lastmeta;
    data.replace(tagregex, function(x) {
        var y = parsexmltag(x);
        switch(strip_ns(y[0])){
            case "<?xml":
                break;
            case "<metadata":
            case "</metadata>":
                break;
            case "<metadataTypes":
            case "</metadataTypes>":
                break;
            case "<metadataType":
                out.Types.push({
                    name: y.name
                });
                break;
            case "</metadataType>":
                break;
            case "<futureMetadata":
                for(var j = 0; j < out.Types.length; ++j)if (out.Types[j].name == y.name) lastmeta = out.Types[j];
                break;
            case "</futureMetadata>":
                break;
            case "<bk>":
                break;
            case "</bk>":
                break;
            case "<rc":
                if (metatype == 1) out.Cell.push({
                    type: out.Types[y.t - 1].name,
                    index: +y.v
                });
                else if (metatype == 0) out.Value.push({
                    type: out.Types[y.t - 1].name,
                    index: +y.v
                });
                break;
            case "</rc>":
                break;
            case "<cellMetadata":
                metatype = 1;
                break;
            case "</cellMetadata>":
                metatype = 2;
                break;
            case "<valueMetadata":
                metatype = 0;
                break;
            case "</valueMetadata>":
                metatype = 2;
                break;
            case "<extLst":
            case "<extLst>":
            case "</extLst>":
            case "<extLst/>":
                break;
            case "<ext":
                pass = true;
                break;
            case "</ext>":
                pass = false;
                break;
            case "<rvb":
                if (!lastmeta) break;
                if (!lastmeta.offsets) lastmeta.offsets = [];
                lastmeta.offsets.push(+y.i);
                break;
            default:
                if (!pass && opts.WTF) throw new Error("unrecognized " + y[0] + " in metadata");
        }
        return x;
    });
    return out;
}
function write_xlmeta_xml() {
    var o = [
        XML_HEADER
    ];
    o.push('<metadata xmlns="http://schemas.openxmlformats.org/spreadsheetml/2006/main" xmlns:xlrd="http://schemas.microsoft.com/office/spreadsheetml/2017/richdata" xmlns:xda="http://schemas.microsoft.com/office/spreadsheetml/2017/dynamicarray">\n  <metadataTypes count="1">\n    <metadataType name="XLDAPR" minSupportedVersion="120000" copy="1" pasteAll="1" pasteValues="1" merge="1" splitFirst="1" rowColShift="1" clearFormats="1" clearComments="1" assign="1" coerce="1" cellMeta="1"/>\n  </metadataTypes>\n  <futureMetadata name="XLDAPR" count="1">\n    <bk>\n      <extLst>\n        <ext uri="{bdbb8cdc-fa1e-496e-a857-3c3f30c029c3}">\n          <xda:dynamicArrayProperties fDynamic="1" fCollapsed="0"/>\n        </ext>\n      </extLst>\n    </bk>\n  </futureMetadata>\n  <cellMetadata count="1">\n    <bk>\n      <rc t="1" v="0"/>\n    </bk>\n  </cellMetadata>\n</metadata>');
    return o.join("");
}
/* 18.6 Calculation Chain */ function parse_cc_xml(data /*::, name, opts*/ ) /*:Array<any>*/ {
    var d = [];
    if (!data) return d;
    var i = 1;
    (data.match(tagregex) || []).forEach(function(x) {
        var y = parsexmltag(x);
        switch(y[0]){
            case "<?xml":
                break;
            /* 18.6.2  calcChain CT_CalcChain 1 */ case "<calcChain":
            case "<calcChain>":
            case "</calcChain>":
                break;
            /* 18.6.1  c CT_CalcCell 1 */ case "<c":
                delete y[0];
                if (y.i) i = y.i;
                else y.i = i;
                d.push(y);
                break;
        }
    });
    return d;
}
//function write_cc_xml(data, opts) { }
/* [MS-XLSB] 2.6.4.1 */ function parse_BrtCalcChainItem$(data) {
    var out = {};
    out.i = data.read_shift(4);
    var cell = {};
    cell.r = data.read_shift(4);
    cell.c = data.read_shift(4);
    out.r = encode_cell(cell);
    var flags = data.read_shift(1);
    if (flags & 0x2) out.l = "1";
    if (flags & 0x8) out.a = "1";
    return out;
}
/* 18.6 Calculation Chain */ function parse_cc_bin(data, name, opts) {
    var out = [];
    var pass = false;
    recordhopper(data, function hopper_cc(val, R, RT) {
        switch(RT){
            case 0x003F:
                /* 'BrtCalcChainItem$' */ out.push(val);
                break;
            default:
                if (R.T) ;
                else if (!pass || opts.WTF) throw new Error("Unexpected record 0x" + RT.toString(16));
        }
    });
    return out;
}
//function write_cc_bin(data, opts) { }
/* 18.14 Supplementary Workbook Data */ function parse_xlink_xml() {
//var opts = _opts || {};
//if(opts.WTF) throw "XLSX External Link";
}
/* [MS-XLSB] 2.1.7.25 External Link */ function parse_xlink_bin(data, rel, name /*:string*/ , _opts) {
    if (!data) return data;
    var opts = _opts || {};
    var pass = false, end = false;
    recordhopper(data, function xlink_parse(val, R, RT) {
        if (end) return;
        switch(RT){
            case 0x0167:
            /* 'BrtSupTabs' */ case 0x016B:
            /* 'BrtExternTableStart' */ case 0x016C:
            /* 'BrtExternTableEnd' */ case 0x016E:
            /* 'BrtExternRowHdr' */ case 0x016F:
            /* 'BrtExternCellBlank' */ case 0x0170:
            /* 'BrtExternCellReal' */ case 0x0171:
            /* 'BrtExternCellBool' */ case 0x0172:
            /* 'BrtExternCellError' */ case 0x0173:
            /* 'BrtExternCellString' */ case 0x01D8:
            /* 'BrtExternValueMeta' */ case 0x0241:
            /* 'BrtSupNameStart' */ case 0x0242:
            /* 'BrtSupNameValueStart' */ case 0x0243:
            /* 'BrtSupNameValueEnd' */ case 0x0244:
            /* 'BrtSupNameNum' */ case 0x0245:
            /* 'BrtSupNameErr' */ case 0x0246:
            /* 'BrtSupNameSt' */ case 0x0247:
            /* 'BrtSupNameNil' */ case 0x0248:
            /* 'BrtSupNameBool' */ case 0x0249:
            /* 'BrtSupNameFmla' */ case 0x024A:
            /* 'BrtSupNameBits' */ case 0x024B:
                break;
            case 0x0023:
                /* 'BrtFRTBegin' */ pass = true;
                break;
            case 0x0024:
                /* 'BrtFRTEnd' */ pass = false;
                break;
            default:
                if (R.T) ;
                else if (!pass || opts.WTF) throw new Error("Unexpected record 0x" + RT.toString(16));
        }
    }, opts);
}
/* 20.5 DrawingML - SpreadsheetML Drawing */ /* 20.5.2.35 wsDr CT_Drawing */ function parse_drawing(data, rels /*:any*/ ) {
    if (!data) return "??";
    /*
	  Chartsheet Drawing:
	   - 20.5.2.35 wsDr CT_Drawing
	    - 20.5.2.1  absoluteAnchor CT_AbsoluteAnchor
	     - 20.5.2.16 graphicFrame CT_GraphicalObjectFrame
	      - 20.1.2.2.16 graphic CT_GraphicalObject
	       - 20.1.2.2.17 graphicData CT_GraphicalObjectData
          - chart reference
	   the actual type is based on the URI of the graphicData
		TODO: handle embedded charts and other types of graphics
	*/ var id = (data.match(/<c:chart [^>]*r:id="([^"]*)"/) || [
        "",
        ""
    ])[1];
    return rels["!id"][id].Target;
}
/* L.5.5.2 SpreadsheetML Comments + VML Schema */ var _shapeid = 1024;
function write_comments_vml(rId /*:number*/ , comments) {
    var csize = [
        21600,
        21600
    ];
    /* L.5.2.1.2 Path Attribute */ var bbox = [
        "m0,0l0",
        csize[1],
        csize[0],
        csize[1],
        csize[0],
        "0xe"
    ].join(",");
    var o = [
        writextag("xml", null, {
            "xmlns:v": XLMLNS.v,
            "xmlns:o": XLMLNS.o,
            "xmlns:x": XLMLNS.x,
            "xmlns:mv": XLMLNS.mv
        }).replace(/\/>/, ">"),
        writextag("o:shapelayout", writextag("o:idmap", null, {
            "v:ext": "edit",
            "data": rId
        }), {
            "v:ext": "edit"
        }),
        writextag("v:shapetype", [
            writextag("v:stroke", null, {
                joinstyle: "miter"
            }),
            writextag("v:path", null, {
                gradientshapeok: "t",
                "o:connecttype": "rect"
            })
        ].join(""), {
            id: "_x0000_t202",
            "o:spt": 202,
            coordsize: csize.join(","),
            path: bbox
        })
    ];
    while(_shapeid < rId * 1000)_shapeid += 1000;
    comments.forEach(function(x) {
        var c = decode_cell(x[0]);
        var fillopts = /*::(*/ {
            "color2": "#BEFF82",
            "type": "gradient"
        } /*:: :any)*/ ;
        if (fillopts.type == "gradient") fillopts.angle = "-180";
        var fillparm = fillopts.type == "gradient" ? writextag("o:fill", null, {
            type: "gradientUnscaled",
            "v:ext": "view"
        }) : null;
        var fillxml = writextag("v:fill", fillparm, fillopts);
        var shadata = {
            on: "t",
            "obscured": "t"
        } /*:any*/ ;
        ++_shapeid;
        o = o.concat([
            "<v:shape" + wxt_helper({
                id: "_x0000_s" + _shapeid,
                type: "#_x0000_t202",
                style: "position:absolute; margin-left:80pt;margin-top:5pt;width:104pt;height:64pt;z-index:10" + (x[1].hidden ? ";visibility:hidden" : ""),
                fillcolor: "#ECFAD4",
                strokecolor: "#edeaa1"
            }) + ">",
            fillxml,
            writextag("v:shadow", null, shadata),
            writextag("v:path", null, {
                "o:connecttype": "none"
            }),
            '<v:textbox><div style="text-align:left"></div></v:textbox>',
            '<x:ClientData ObjectType="Note">',
            "<x:MoveWithCells/>",
            "<x:SizeWithCells/>",
            /* Part 4 19.4.2.3 Anchor (Anchor) */ writetag("x:Anchor", [
                c.c + 1,
                0,
                c.r + 1,
                0,
                c.c + 3,
                20,
                c.r + 5,
                20
            ].join(",")),
            writetag("x:AutoFill", "False"),
            writetag("x:Row", String(c.r)),
            writetag("x:Column", String(c.c)),
            x[1].hidden ? "" : "<x:Visible/>",
            "</x:ClientData>",
            "</v:shape>"
        ]);
    });
    o.push("</xml>");
    return o.join("");
}
function sheet_insert_comments(sheet, comments /*:Array<RawComment>*/ , threaded /*:boolean*/ , people /*:?Array<any>*/ ) {
    var dense = Array.isArray(sheet);
    var cell /*:Cell*/ ;
    comments.forEach(function(comment) {
        var r = decode_cell(comment.ref);
        if (dense) {
            if (!sheet[r.r]) sheet[r.r] = [];
            cell = sheet[r.r][r.c];
        } else cell = sheet[comment.ref];
        if (!cell) {
            cell = {
                t: "z"
            } /*:any*/ ;
            if (dense) sheet[r.r][r.c] = cell;
            else sheet[comment.ref] = cell;
            var range = safe_decode_range(sheet["!ref"] || "BDWGO1000001:A1");
            if (range.s.r > r.r) range.s.r = r.r;
            if (range.e.r < r.r) range.e.r = r.r;
            if (range.s.c > r.c) range.s.c = r.c;
            if (range.e.c < r.c) range.e.c = r.c;
            var encoded = encode_range(range);
            if (encoded !== sheet["!ref"]) sheet["!ref"] = encoded;
        }
        if (!cell.c) cell.c = [];
        var o /*:Comment*/  = {
            a: comment.author,
            t: comment.t,
            r: comment.r,
            T: threaded
        };
        if (comment.h) o.h = comment.h;
        /* threaded comments always override */ for(var i = cell.c.length - 1; i >= 0; --i){
            if (!threaded && cell.c[i].T) return;
            if (threaded && !cell.c[i].T) cell.c.splice(i, 1);
        }
        if (threaded && people) {
            for(i = 0; i < people.length; ++i)if (o.a == people[i].id) {
                o.a = people[i].name || o.a;
                break;
            }
        }
        cell.c.push(o);
    });
}
/* 18.7 Comments */ function parse_comments_xml(data /*:string*/ , opts) /*:Array<RawComment>*/ {
    /* 18.7.6 CT_Comments */ if (data.match(/<(?:\w+:)?comments *\/>/)) return [];
    var authors /*:Array<string>*/  = [];
    var commentList /*:Array<RawComment>*/  = [];
    var authtag = data.match(/<(?:\w+:)?authors>([\s\S]*)<\/(?:\w+:)?authors>/);
    if (authtag && authtag[1]) authtag[1].split(/<\/\w*:?author>/).forEach(function(x) {
        if (x === "" || x.trim() === "") return;
        var a = x.match(/<(?:\w+:)?author[^>]*>(.*)/);
        if (a) authors.push(a[1]);
    });
    var cmnttag = data.match(/<(?:\w+:)?commentList>([\s\S]*)<\/(?:\w+:)?commentList>/);
    if (cmnttag && cmnttag[1]) cmnttag[1].split(/<\/\w*:?comment>/).forEach(function(x) {
        if (x === "" || x.trim() === "") return;
        var cm = x.match(/<(?:\w+:)?comment[^>]*>/);
        if (!cm) return;
        var y = parsexmltag(cm[0]);
        var comment /*:RawComment*/  = {
            author: y.authorId && authors[y.authorId] || "sheetjsghost",
            ref: y.ref,
            guid: y.guid
        } /*:any*/ ;
        var cell = decode_cell(y.ref);
        if (opts.sheetRows && opts.sheetRows <= cell.r) return;
        var textMatch = x.match(/<(?:\w+:)?text>([\s\S]*)<\/(?:\w+:)?text>/);
        var rt = !!textMatch && !!textMatch[1] && parse_si(textMatch[1]) || {
            r: "",
            t: "",
            h: ""
        };
        comment.r = rt.r;
        if (rt.r == "<t></t>") rt.t = rt.h = "";
        comment.t = (rt.t || "").replace(/\r\n/g, "\n").replace(/\r/g, "\n");
        if (opts.cellHTML) comment.h = rt.h;
        commentList.push(comment);
    });
    return commentList;
}
function write_comments_xml(data /*::, opts*/ ) {
    var o = [
        XML_HEADER,
        writextag("comments", null, {
            "xmlns": XMLNS_main[0]
        })
    ];
    var iauthor /*:Array<string>*/  = [];
    o.push("<authors>");
    data.forEach(function(x) {
        x[1].forEach(function(w) {
            var a = escapexml(w.a);
            if (iauthor.indexOf(a) == -1) {
                iauthor.push(a);
                o.push("<author>" + a + "</author>");
            }
            if (w.T && w.ID && iauthor.indexOf("tc=" + w.ID) == -1) {
                iauthor.push("tc=" + w.ID);
                o.push("<author>tc=" + w.ID + "</author>");
            }
        });
    });
    if (iauthor.length == 0) {
        iauthor.push("SheetJ5");
        o.push("<author>SheetJ5</author>");
    }
    o.push("</authors>");
    o.push("<commentList>");
    data.forEach(function(d) {
        /* 18.7.3 CT_Comment */ var lastauthor = 0, ts = [];
        if (d[1][0] && d[1][0].T && d[1][0].ID) lastauthor = iauthor.indexOf("tc=" + d[1][0].ID);
        else d[1].forEach(function(c) {
            if (c.a) lastauthor = iauthor.indexOf(escapexml(c.a));
            ts.push(c.t || "");
        });
        o.push('<comment ref="' + d[0] + '" authorId="' + lastauthor + '"><text>');
        if (ts.length <= 1) o.push(writetag("t", escapexml(ts[0] || "")));
        else {
            /* based on Threaded Comments -> Comments projection */ var t = "Comment:\n    " + ts[0] + "\n";
            for(var i = 1; i < ts.length; ++i)t += "Reply:\n    " + ts[i] + "\n";
            o.push(writetag("t", escapexml(t)));
        }
        o.push("</text></comment>");
    });
    o.push("</commentList>");
    if (o.length > 2) {
        o[o.length] = "</comments>";
        o[1] = o[1].replace("/>", ">");
    }
    return o.join("");
}
/* [MS-XLSX] 2.1.17 */ function parse_tcmnt_xml(data /*:string*/ , opts) /*:Array<RawComment>*/ {
    var out = [];
    var pass = false, comment = {}, tidx = 0;
    data.replace(tagregex, function xml_tcmnt(x, idx) {
        var y /*:any*/  = parsexmltag(x);
        switch(strip_ns(y[0])){
            case "<?xml":
                break;
            /* 2.6.207 ThreadedComments CT_ThreadedComments */ case "<ThreadedComments":
                break;
            case "</ThreadedComments>":
                break;
            /* 2.6.205 threadedComment CT_ThreadedComment */ case "<threadedComment":
                comment = {
                    author: y.personId,
                    guid: y.id,
                    ref: y.ref,
                    T: 1
                };
                break;
            case "</threadedComment>":
                if (comment.t != null) out.push(comment);
                break;
            case "<text>":
            case "<text":
                tidx = idx + x.length;
                break;
            case "</text>":
                comment.t = data.slice(tidx, idx).replace(/\r\n/g, "\n").replace(/\r/g, "\n");
                break;
            /* 2.6.206 mentions CT_ThreadedCommentMentions TODO */ case "<mentions":
            case "<mentions>":
                pass = true;
                break;
            case "</mentions>":
                pass = false;
                break;
            /* 2.6.202 mention CT_Mention TODO */ /* 18.2.10 extLst CT_ExtensionList ? */ case "<extLst":
            case "<extLst>":
            case "</extLst>":
            case "<extLst/>":
                break;
            /* 18.2.7  ext CT_Extension + */ case "<ext":
                pass = true;
                break;
            case "</ext>":
                pass = false;
                break;
            default:
                if (!pass && opts.WTF) throw new Error("unrecognized " + y[0] + " in threaded comments");
        }
        return x;
    });
    return out;
}
function write_tcmnt_xml(comments, people, opts) {
    var o = [
        XML_HEADER,
        writextag("ThreadedComments", null, {
            "xmlns": XMLNS.TCMNT
        }).replace(/[\/]>/, ">")
    ];
    comments.forEach(function(carr) {
        var rootid = "";
        (carr[1] || []).forEach(function(c, idx) {
            if (!c.T) {
                delete c.ID;
                return;
            }
            if (c.a && people.indexOf(c.a) == -1) people.push(c.a);
            var tcopts = {
                ref: carr[0],
                id: "{54EE7951-7262-4200-6969-" + ("000000000000" + opts.tcid++).slice(-12) + "}"
            };
            if (idx == 0) rootid = tcopts.id;
            else tcopts.parentId = rootid;
            c.ID = tcopts.id;
            if (c.a) tcopts.personId = "{54EE7950-7262-4200-6969-" + ("000000000000" + people.indexOf(c.a)).slice(-12) + "}";
            o.push(writextag("threadedComment", writetag("text", c.t || ""), tcopts));
        });
    });
    o.push("</ThreadedComments>");
    return o.join("");
}
/* [MS-XLSX] 2.1.18 */ function parse_people_xml(data /*:string*/ , opts) {
    var out = [];
    var pass = false;
    data.replace(tagregex, function xml_tcmnt(x) {
        var y /*:any*/  = parsexmltag(x);
        switch(strip_ns(y[0])){
            case "<?xml":
                break;
            /* 2.4.85 personList CT_PersonList */ case "<personList":
                break;
            case "</personList>":
                break;
            /* 2.6.203 person CT_Person TODO: providers */ case "<person":
                out.push({
                    name: y.displayname,
                    id: y.id
                });
                break;
            case "</person>":
                break;
            /* 18.2.10 extLst CT_ExtensionList ? */ case "<extLst":
            case "<extLst>":
            case "</extLst>":
            case "<extLst/>":
                break;
            /* 18.2.7  ext CT_Extension + */ case "<ext":
                pass = true;
                break;
            case "</ext>":
                pass = false;
                break;
            default:
                if (!pass && opts.WTF) throw new Error("unrecognized " + y[0] + " in threaded comments");
        }
        return x;
    });
    return out;
}
function write_people_xml(people /*, opts*/ ) {
    var o = [
        XML_HEADER,
        writextag("personList", null, {
            "xmlns": XMLNS.TCMNT,
            "xmlns:x": XMLNS_main[0]
        }).replace(/[\/]>/, ">")
    ];
    people.forEach(function(person, idx) {
        o.push(writextag("person", null, {
            displayName: person,
            id: "{54EE7950-7262-4200-6969-" + ("000000000000" + idx).slice(-12) + "}",
            userId: person,
            providerId: "None"
        }));
    });
    o.push("</personList>");
    return o.join("");
}
/* [MS-XLSB] 2.4.28 BrtBeginComment */ function parse_BrtBeginComment(data) {
    var out = {};
    out.iauthor = data.read_shift(4);
    var rfx = parse_UncheckedRfX(data, 16);
    out.rfx = rfx.s;
    out.ref = encode_cell(rfx.s);
    data.l += 16; /*var guid = parse_GUID(data); */ 
    return out;
}
function write_BrtBeginComment(data, o) {
    if (o == null) o = new_buf(36);
    o.write_shift(4, data[1].iauthor);
    write_UncheckedRfX(data[0], o);
    o.write_shift(4, 0);
    o.write_shift(4, 0);
    o.write_shift(4, 0);
    o.write_shift(4, 0);
    return o;
}
/* [MS-XLSB] 2.4.327 BrtCommentAuthor */ var parse_BrtCommentAuthor = parse_XLWideString;
function write_BrtCommentAuthor(data) {
    return write_XLWideString(data.slice(0, 54));
}
/* [MS-XLSB] 2.1.7.8 Comments */ function parse_comments_bin(data, opts) /*:Array<RawComment>*/ {
    var out /*:Array<RawComment>*/  = [];
    var authors /*:Array<string>*/  = [];
    var c = {};
    var pass = false;
    recordhopper(data, function hopper_cmnt(val, R, RT) {
        switch(RT){
            case 0x0278:
                /* 'BrtCommentAuthor' */ authors.push(val);
                break;
            case 0x027B:
                /* 'BrtBeginComment' */ c = val;
                break;
            case 0x027D:
                /* 'BrtCommentText' */ c.t = val.t;
                c.h = val.h;
                c.r = val.r;
                break;
            case 0x027C:
                /* 'BrtEndComment' */ c.author = authors[c.iauthor];
                delete c /*:any*/ .iauthor;
                if (opts.sheetRows && c.rfx && opts.sheetRows <= c.rfx.r) break;
                if (!c.t) c.t = "";
                delete c.rfx;
                out.push(c);
                break;
            case 0x0C00:
                break;
            case 0x0023:
                /* 'BrtFRTBegin' */ pass = true;
                break;
            case 0x0024:
                /* 'BrtFRTEnd' */ pass = false;
                break;
            case 0x0025:
                break;
            case 0x0026:
                break;
            default:
                if (R.T) ;
                else if (!pass || opts.WTF) throw new Error("Unexpected record 0x" + RT.toString(16));
        }
    });
    return out;
}
function write_comments_bin(data /*::, opts*/ ) {
    var ba = buf_array();
    var iauthor /*:Array<string>*/  = [];
    write_record(ba, 0x0274 /* BrtBeginComments */ );
    write_record(ba, 0x0276 /* BrtBeginCommentAuthors */ );
    data.forEach(function(comment) {
        comment[1].forEach(function(c) {
            if (iauthor.indexOf(c.a) > -1) return;
            iauthor.push(c.a.slice(0, 54));
            write_record(ba, 0x0278 /* BrtCommentAuthor */ , write_BrtCommentAuthor(c.a));
        });
    });
    write_record(ba, 0x0277 /* BrtEndCommentAuthors */ );
    write_record(ba, 0x0279 /* BrtBeginCommentList */ );
    data.forEach(function(comment) {
        comment[1].forEach(function(c) {
            c.iauthor = iauthor.indexOf(c.a);
            var range = {
                s: decode_cell(comment[0]),
                e: decode_cell(comment[0])
            };
            write_record(ba, 0x027B /* BrtBeginComment */ , write_BrtBeginComment([
                range,
                c
            ]));
            if (c.t && c.t.length > 0) write_record(ba, 0x027D /* BrtCommentText */ , write_BrtCommentText(c));
            write_record(ba, 0x027C /* BrtEndComment */ );
            delete c.iauthor;
        });
    });
    write_record(ba, 0x027A /* BrtEndCommentList */ );
    write_record(ba, 0x0275 /* BrtEndComments */ );
    return ba.end();
}
var CT_VBA = "application/vnd.ms-office.vbaProject";
function make_vba_xls(cfb) {
    var newcfb = CFB.utils.cfb_new({
        root: "R"
    });
    cfb.FullPaths.forEach(function(p, i) {
        if (p.slice(-1) === "/" || !p.match(/_VBA_PROJECT_CUR/)) return;
        var newpath = p.replace(/^[^\/]*/, "R").replace(/\/_VBA_PROJECT_CUR\u0000*/, "");
        CFB.utils.cfb_add(newcfb, newpath, cfb.FileIndex[i].content);
    });
    return CFB.write(newcfb);
}
function fill_vba_xls(cfb, vba) {
    vba.FullPaths.forEach(function(p, i) {
        if (i == 0) return;
        var newpath = p.replace(/[^\/]*[\/]/, "/_VBA_PROJECT_CUR/");
        if (newpath.slice(-1) !== "/") CFB.utils.cfb_add(cfb, newpath, vba.FileIndex[i].content);
    });
}
var VBAFMTS = [
    "xlsb",
    "xlsm",
    "xlam",
    "biff8",
    "xla"
];
/* macro and dialog sheet stubs */ function parse_ds_bin() /*:Worksheet*/ {
    return {
        "!type": "dialog"
    };
}
function parse_ds_xml() /*:Worksheet*/ {
    return {
        "!type": "dialog"
    };
}
function parse_ms_bin() /*:Worksheet*/ {
    return {
        "!type": "macro"
    };
}
function parse_ms_xml() /*:Worksheet*/ {
    return {
        "!type": "macro"
    };
}
/* TODO: it will be useful to parse the function str */ var rc_to_a1 = /*#__PURE__*/ function() {
    var rcregex = /(^|[^A-Za-z_])R(\[?-?\d+\]|[1-9]\d*|)C(\[?-?\d+\]|[1-9]\d*|)(?![A-Za-z0-9_])/g;
    var rcbase /*:Cell*/  = {
        r: 0,
        c: 0
    } /*:any*/ ;
    function rcfunc($$, $1, $2, $3) {
        var cRel = false, rRel = false;
        if ($2.length == 0) rRel = true;
        else if ($2.charAt(0) == "[") {
            rRel = true;
            $2 = $2.slice(1, -1);
        }
        if ($3.length == 0) cRel = true;
        else if ($3.charAt(0) == "[") {
            cRel = true;
            $3 = $3.slice(1, -1);
        }
        var R = $2.length > 0 ? parseInt($2, 10) | 0 : 0, C = $3.length > 0 ? parseInt($3, 10) | 0 : 0;
        if (cRel) C += rcbase.c;
        else --C;
        if (rRel) R += rcbase.r;
        else --R;
        return $1 + (cRel ? "" : "$") + encode_col(C) + (rRel ? "" : "$") + encode_row(R);
    }
    return function rc_to_a1(fstr /*:string*/ , base /*:Cell*/ ) /*:string*/ {
        rcbase = base;
        return fstr.replace(rcregex, rcfunc);
    };
}();
var crefregex = /(^|[^._A-Z0-9])([$]?)([A-Z]{1,2}|[A-W][A-Z]{2}|X[A-E][A-Z]|XF[A-D])([$]?)(10[0-3]\d{4}|104[0-7]\d{3}|1048[0-4]\d{2}|10485[0-6]\d|104857[0-6]|[1-9]\d{0,5})(?![_.\(A-Za-z0-9])/g;
var a1_to_rc = /*#__PURE__*/ function() {
    return function a1_to_rc(fstr /*:string*/ , base /*:CellAddress*/ ) {
        return fstr.replace(crefregex, function($0, $1, $2, $3, $4, $5) {
            var c = decode_col($3) - ($2 ? 0 : base.c);
            var r = decode_row($5) - ($4 ? 0 : base.r);
            var R = r == 0 ? "" : !$4 ? "[" + r + "]" : r + 1;
            var C = c == 0 ? "" : !$2 ? "[" + c + "]" : c + 1;
            return $1 + "R" + R + "C" + C;
        });
    };
}();
/* no defined name can collide with a valid cell address A1:XFD1048576 ... except LOG10! */ function shift_formula_str(f /*:string*/ , delta /*:Cell*/ ) /*:string*/ {
    return f.replace(crefregex, function($0, $1, $2, $3, $4, $5) {
        return $1 + ($2 == "$" ? $2 + $3 : encode_col(decode_col($3) + delta.c)) + ($4 == "$" ? $4 + $5 : encode_row(decode_row($5) + delta.r));
    });
}
function shift_formula_xlsx(f /*:string*/ , range /*:string*/ , cell /*:string*/ ) /*:string*/ {
    var r = decode_range(range), s = r.s, c = decode_cell(cell);
    var delta = {
        r: c.r - s.r,
        c: c.c - s.c
    };
    return shift_formula_str(f, delta);
}
/* TODO: parse formula */ function fuzzyfmla(f /*:string*/ ) /*:boolean*/ {
    if (f.length == 1) return false;
    return true;
}
function _xlfn(f /*:string*/ ) /*:string*/ {
    return f.replace(/_xlfn\./g, "");
}
function parseread1(blob) {
    blob.l += 1;
    return;
}
/* [MS-XLS] 2.5.51 */ function parse_ColRelU(blob, length) {
    var c = blob.read_shift(length == 1 ? 1 : 2);
    return [
        c & 0x3FFF,
        c >> 14 & 1,
        c >> 15 & 1
    ];
}
/* [MS-XLS] 2.5.198.105 ; [MS-XLSB] 2.5.97.89 */ function parse_RgceArea(blob, length, opts) {
    var w = 2;
    if (opts) {
        if (opts.biff >= 2 && opts.biff <= 5) return parse_RgceArea_BIFF2(blob, length, opts);
        else if (opts.biff == 12) w = 4;
    }
    var r = blob.read_shift(w), R = blob.read_shift(w);
    var c = parse_ColRelU(blob, 2);
    var C = parse_ColRelU(blob, 2);
    return {
        s: {
            r: r,
            c: c[0],
            cRel: c[1],
            rRel: c[2]
        },
        e: {
            r: R,
            c: C[0],
            cRel: C[1],
            rRel: C[2]
        }
    };
}
/* BIFF 2-5 encodes flags in the row field */ function parse_RgceArea_BIFF2(blob /*::, length, opts*/ ) {
    var r = parse_ColRelU(blob, 2), R = parse_ColRelU(blob, 2);
    var c = blob.read_shift(1);
    var C = blob.read_shift(1);
    return {
        s: {
            r: r[0],
            c: c,
            cRel: r[1],
            rRel: r[2]
        },
        e: {
            r: R[0],
            c: C,
            cRel: R[1],
            rRel: R[2]
        }
    };
}
/* [MS-XLS] 2.5.198.105 ; [MS-XLSB] 2.5.97.90 */ function parse_RgceAreaRel(blob, length, opts) {
    if (opts.biff < 8) return parse_RgceArea_BIFF2(blob, length, opts);
    var r = blob.read_shift(opts.biff == 12 ? 4 : 2), R = blob.read_shift(opts.biff == 12 ? 4 : 2);
    var c = parse_ColRelU(blob, 2);
    var C = parse_ColRelU(blob, 2);
    return {
        s: {
            r: r,
            c: c[0],
            cRel: c[1],
            rRel: c[2]
        },
        e: {
            r: R,
            c: C[0],
            cRel: C[1],
            rRel: C[2]
        }
    };
}
/* [MS-XLS] 2.5.198.109 ; [MS-XLSB] 2.5.97.91 */ function parse_RgceLoc(blob, length, opts) {
    if (opts && opts.biff >= 2 && opts.biff <= 5) return parse_RgceLoc_BIFF2(blob, length, opts);
    var r = blob.read_shift(opts && opts.biff == 12 ? 4 : 2);
    var c = parse_ColRelU(blob, 2);
    return {
        r: r,
        c: c[0],
        cRel: c[1],
        rRel: c[2]
    };
}
function parse_RgceLoc_BIFF2(blob /*::, length, opts*/ ) {
    var r = parse_ColRelU(blob, 2);
    var c = blob.read_shift(1);
    return {
        r: r[0],
        c: c,
        cRel: r[1],
        rRel: r[2]
    };
}
/* [MS-XLS] 2.5.198.107, 2.5.47 */ function parse_RgceElfLoc(blob /*::, length, opts*/ ) {
    var r = blob.read_shift(2);
    var c = blob.read_shift(2);
    return {
        r: r,
        c: c & 0xFF,
        fQuoted: !!(c & 0x4000),
        cRel: c >> 15,
        rRel: c >> 15
    };
}
/* [MS-XLS] 2.5.198.111 ; [MS-XLSB] 2.5.97.92 TODO */ function parse_RgceLocRel(blob, length, opts) {
    var biff = opts && opts.biff ? opts.biff : 8;
    if (biff >= 2 && biff <= 5) return parse_RgceLocRel_BIFF2(blob, length, opts);
    var r = blob.read_shift(biff >= 12 ? 4 : 2);
    var cl = blob.read_shift(2);
    var cRel = (cl & 0x4000) >> 14, rRel = (cl & 0x8000) >> 15;
    cl &= 0x3FFF;
    if (rRel == 1) while(r > 0x7FFFF)r -= 0x100000;
    if (cRel == 1) while(cl > 0x1FFF)cl = cl - 0x4000;
    return {
        r: r,
        c: cl,
        cRel: cRel,
        rRel: rRel
    };
}
function parse_RgceLocRel_BIFF2(blob /*::, length:number, opts*/ ) {
    var rl = blob.read_shift(2);
    var c = blob.read_shift(1);
    var rRel = (rl & 0x8000) >> 15, cRel = (rl & 0x4000) >> 14;
    rl &= 0x3FFF;
    if (rRel == 1 && rl >= 0x2000) rl = rl - 0x4000;
    if (cRel == 1 && c >= 0x80) c = c - 0x100;
    return {
        r: rl,
        c: c,
        cRel: cRel,
        rRel: rRel
    };
}
/* [MS-XLS] 2.5.198.27 ; [MS-XLSB] 2.5.97.18 */ function parse_PtgArea(blob, length, opts) {
    var type = (blob[blob.l++] & 0x60) >> 5;
    var area = parse_RgceArea(blob, opts.biff >= 2 && opts.biff <= 5 ? 6 : 8, opts);
    return [
        type,
        area
    ];
}
/* [MS-XLS] 2.5.198.28 ; [MS-XLSB] 2.5.97.19 */ function parse_PtgArea3d(blob, length, opts) {
    var type = (blob[blob.l++] & 0x60) >> 5;
    var ixti = blob.read_shift(2, "i");
    var w = 8;
    if (opts) switch(opts.biff){
        case 5:
            blob.l += 12;
            w = 6;
            break;
        case 12:
            w = 12;
            break;
    }
    var area = parse_RgceArea(blob, w, opts);
    return [
        type,
        ixti,
        area
    ];
}
/* [MS-XLS] 2.5.198.29 ; [MS-XLSB] 2.5.97.20 */ function parse_PtgAreaErr(blob, length, opts) {
    var type = (blob[blob.l++] & 0x60) >> 5;
    blob.l += opts && opts.biff > 8 ? 12 : opts.biff < 8 ? 6 : 8;
    return [
        type
    ];
}
/* [MS-XLS] 2.5.198.30 ; [MS-XLSB] 2.5.97.21 */ function parse_PtgAreaErr3d(blob, length, opts) {
    var type = (blob[blob.l++] & 0x60) >> 5;
    var ixti = blob.read_shift(2);
    var w = 8;
    if (opts) switch(opts.biff){
        case 5:
            blob.l += 12;
            w = 6;
            break;
        case 12:
            w = 12;
            break;
    }
    blob.l += w;
    return [
        type,
        ixti
    ];
}
/* [MS-XLS] 2.5.198.31 ; [MS-XLSB] 2.5.97.22 */ function parse_PtgAreaN(blob, length, opts) {
    var type = (blob[blob.l++] & 0x60) >> 5;
    var area = parse_RgceAreaRel(blob, length - 1, opts);
    return [
        type,
        area
    ];
}
/* [MS-XLS] 2.5.198.32 ; [MS-XLSB] 2.5.97.23 */ function parse_PtgArray(blob, length, opts) {
    var type = (blob[blob.l++] & 0x60) >> 5;
    blob.l += opts.biff == 2 ? 6 : opts.biff == 12 ? 14 : 7;
    return [
        type
    ];
}
/* [MS-XLS] 2.5.198.33 ; [MS-XLSB] 2.5.97.24 */ function parse_PtgAttrBaxcel(blob) {
    var bitSemi = blob[blob.l + 1] & 0x01; /* 1 = volatile */ 
    var bitBaxcel = 1;
    blob.l += 4;
    return [
        bitSemi,
        bitBaxcel
    ];
}
/* [MS-XLS] 2.5.198.34 ; [MS-XLSB] 2.5.97.25 */ function parse_PtgAttrChoose(blob, length, opts) /*:Array<number>*/ {
    blob.l += 2;
    var offset = blob.read_shift(opts && opts.biff == 2 ? 1 : 2);
    var o /*:Array<number>*/  = [];
    /* offset is 1 less than the number of elements */ for(var i = 0; i <= offset; ++i)o.push(blob.read_shift(opts && opts.biff == 2 ? 1 : 2));
    return o;
}
/* [MS-XLS] 2.5.198.35 ; [MS-XLSB] 2.5.97.26 */ function parse_PtgAttrGoto(blob, length, opts) {
    var bitGoto = blob[blob.l + 1] & 0xFF ? 1 : 0;
    blob.l += 2;
    return [
        bitGoto,
        blob.read_shift(opts && opts.biff == 2 ? 1 : 2)
    ];
}
/* [MS-XLS] 2.5.198.36 ; [MS-XLSB] 2.5.97.27 */ function parse_PtgAttrIf(blob, length, opts) {
    var bitIf = blob[blob.l + 1] & 0xFF ? 1 : 0;
    blob.l += 2;
    return [
        bitIf,
        blob.read_shift(opts && opts.biff == 2 ? 1 : 2)
    ];
}
/* [MS-XLSB] 2.5.97.28 */ function parse_PtgAttrIfError(blob) {
    var bitIf = blob[blob.l + 1] & 0xFF ? 1 : 0;
    blob.l += 2;
    return [
        bitIf,
        blob.read_shift(2)
    ];
}
/* [MS-XLS] 2.5.198.37 ; [MS-XLSB] 2.5.97.29 */ function parse_PtgAttrSemi(blob, length, opts) {
    var bitSemi = blob[blob.l + 1] & 0xFF ? 1 : 0;
    blob.l += opts && opts.biff == 2 ? 3 : 4;
    return [
        bitSemi
    ];
}
/* [MS-XLS] 2.5.198.40 ; [MS-XLSB] 2.5.97.32 */ function parse_PtgAttrSpaceType(blob /*::, length*/ ) {
    var type = blob.read_shift(1), cch = blob.read_shift(1);
    return [
        type,
        cch
    ];
}
/* [MS-XLS] 2.5.198.38 ; [MS-XLSB] 2.5.97.30 */ function parse_PtgAttrSpace(blob) {
    blob.read_shift(2);
    return parse_PtgAttrSpaceType(blob, 2);
}
/* [MS-XLS] 2.5.198.39 ; [MS-XLSB] 2.5.97.31 */ function parse_PtgAttrSpaceSemi(blob) {
    blob.read_shift(2);
    return parse_PtgAttrSpaceType(blob, 2);
}
/* [MS-XLS] 2.5.198.84 ; [MS-XLSB] 2.5.97.68 TODO */ function parse_PtgRef(blob, length, opts) {
    //var ptg = blob[blob.l] & 0x1F;
    var type = (blob[blob.l] & 0x60) >> 5;
    blob.l += 1;
    var loc = parse_RgceLoc(blob, 0, opts);
    return [
        type,
        loc
    ];
}
/* [MS-XLS] 2.5.198.88 ; [MS-XLSB] 2.5.97.72 TODO */ function parse_PtgRefN(blob, length, opts) {
    var type = (blob[blob.l] & 0x60) >> 5;
    blob.l += 1;
    var loc = parse_RgceLocRel(blob, 0, opts);
    return [
        type,
        loc
    ];
}
/* [MS-XLS] 2.5.198.85 ; [MS-XLSB] 2.5.97.69 TODO */ function parse_PtgRef3d(blob, length, opts) {
    var type = (blob[blob.l] & 0x60) >> 5;
    blob.l += 1;
    var ixti = blob.read_shift(2); // XtiIndex
    if (opts && opts.biff == 5) blob.l += 12;
    var loc = parse_RgceLoc(blob, 0, opts); // TODO: or RgceLocRel
    return [
        type,
        ixti,
        loc
    ];
}
/* [MS-XLS] 2.5.198.62 ; [MS-XLSB] 2.5.97.45 TODO */ function parse_PtgFunc(blob, length, opts) {
    //var ptg = blob[blob.l] & 0x1F;
    var type = (blob[blob.l] & 0x60) >> 5;
    blob.l += 1;
    var iftab = blob.read_shift(opts && opts.biff <= 3 ? 1 : 2);
    return [
        FtabArgc[iftab],
        Ftab[iftab],
        type
    ];
}
/* [MS-XLS] 2.5.198.63 ; [MS-XLSB] 2.5.97.46 TODO */ function parse_PtgFuncVar(blob, length, opts) {
    var type = blob[blob.l++];
    var cparams = blob.read_shift(1), tab = opts && opts.biff <= 3 ? [
        type == 0x58 ? -1 : 0,
        blob.read_shift(1)
    ] : parsetab(blob);
    return [
        cparams,
        (tab[0] === 0 ? Ftab : Cetab)[tab[1]]
    ];
}
function parsetab(blob) {
    return [
        blob[blob.l + 1] >> 7,
        blob.read_shift(2) & 0x7FFF
    ];
}
/* [MS-XLS] 2.5.198.41 ; [MS-XLSB] 2.5.97.33 */ function parse_PtgAttrSum(blob, length, opts) {
    blob.l += opts && opts.biff == 2 ? 3 : 4;
    return;
}
/* [MS-XLS] 2.5.198.58 ; [MS-XLSB] 2.5.97.40 */ function parse_PtgExp(blob, length, opts) {
    blob.l++;
    if (opts && opts.biff == 12) return [
        blob.read_shift(4, "i"),
        0
    ];
    var row = blob.read_shift(2);
    var col = blob.read_shift(opts && opts.biff == 2 ? 1 : 2);
    return [
        row,
        col
    ];
}
/* [MS-XLS] 2.5.198.57 ; [MS-XLSB] 2.5.97.39 */ function parse_PtgErr(blob) {
    blob.l++;
    return BErr[blob.read_shift(1)];
}
/* [MS-XLS] 2.5.198.66 ; [MS-XLSB] 2.5.97.49 */ function parse_PtgInt(blob) {
    blob.l++;
    return blob.read_shift(2);
}
/* [MS-XLS] 2.5.198.42 ; [MS-XLSB] 2.5.97.34 */ function parse_PtgBool(blob) {
    blob.l++;
    return blob.read_shift(1) !== 0;
}
/* [MS-XLS] 2.5.198.79 ; [MS-XLSB] 2.5.97.63 */ function parse_PtgNum(blob) {
    blob.l++;
    return parse_Xnum(blob, 8);
}
/* [MS-XLS] 2.5.198.89 ; [MS-XLSB] 2.5.97.74 */ function parse_PtgStr(blob, length, opts) {
    blob.l++;
    return parse_ShortXLUnicodeString(blob, length - 1, opts);
}
/* [MS-XLS] 2.5.192.112 + 2.5.192.11{3,4,5,6,7} */ /* [MS-XLSB] 2.5.97.93 + 2.5.97.9{4,5,6,7} */ function parse_SerAr(blob, biff /*:number*/ ) {
    var val = [
        blob.read_shift(1)
    ];
    if (biff == 12) switch(val[0]){
        case 0x02:
            val[0] = 0x04;
            break; /* SerBool */ 
        case 0x04:
            val[0] = 0x10;
            break; /* SerErr */ 
        case 0x00:
            val[0] = 0x01;
            break; /* SerNum */ 
        case 0x01:
            val[0] = 0x02;
            break; /* SerStr */ 
    }
    switch(val[0]){
        case 0x04:
            /* SerBool -- boolean */ val[1] = parsebool(blob, 1) ? "TRUE" : "FALSE";
            if (biff != 12) blob.l += 7;
            break;
        case 0x25:
        /* appears to be an alias */ case 0x10:
            /* SerErr -- error */ val[1] = BErr[blob[blob.l]];
            blob.l += biff == 12 ? 4 : 8;
            break;
        case 0x00:
            /* SerNil -- honestly, I'm not sure how to reproduce this */ blob.l += 8;
            break;
        case 0x01:
            /* SerNum -- Xnum */ val[1] = parse_Xnum(blob, 8);
            break;
        case 0x02:
            /* SerStr -- XLUnicodeString (<256 chars) */ val[1] = parse_XLUnicodeString2(blob, 0, {
                biff: biff > 0 && biff < 8 ? 2 : biff
            });
            break;
        default:
            throw new Error("Bad SerAr: " + val[0]); /* Unreachable */ 
    }
    return val;
}
/* [MS-XLS] 2.5.198.61 ; [MS-XLSB] 2.5.97.44 */ function parse_PtgExtraMem(blob, cce, opts) {
    var count = blob.read_shift(opts.biff == 12 ? 4 : 2);
    var out /*:Array<Range>*/  = [];
    for(var i = 0; i != count; ++i)out.push((opts.biff == 12 ? parse_UncheckedRfX : parse_Ref8U)(blob, 8));
    return out;
}
/* [MS-XLS] 2.5.198.59 ; [MS-XLSB] 2.5.97.41 */ function parse_PtgExtraArray(blob, length, opts) {
    var rows = 0, cols = 0;
    if (opts.biff == 12) {
        rows = blob.read_shift(4); // DRw
        cols = blob.read_shift(4); // DCol
    } else {
        cols = 1 + blob.read_shift(1); //DColByteU
        rows = 1 + blob.read_shift(2); //DRw
    }
    if (opts.biff >= 2 && opts.biff < 8) {
        --rows;
        if (--cols == 0) cols = 0x100;
    }
    // $FlowIgnore
    for(var i = 0, o /*:Array<Array<any>>*/  = []; i != rows && (o[i] = []); ++i)for(var j = 0; j != cols; ++j)o[i][j] = parse_SerAr(blob, opts.biff);
    return o;
}
/* [MS-XLS] 2.5.198.76 ; [MS-XLSB] 2.5.97.60 */ function parse_PtgName(blob, length, opts) {
    var type = blob.read_shift(1) >>> 5 & 0x03;
    var w = !opts || opts.biff >= 8 ? 4 : 2;
    var nameindex = blob.read_shift(w);
    switch(opts.biff){
        case 2:
            blob.l += 5;
            break;
        case 3:
        case 4:
            blob.l += 8;
            break;
        case 5:
            blob.l += 12;
            break;
    }
    return [
        type,
        0,
        nameindex
    ];
}
/* [MS-XLS] 2.5.198.77 ; [MS-XLSB] 2.5.97.61 */ function parse_PtgNameX(blob, length, opts) {
    if (opts.biff == 5) return parse_PtgNameX_BIFF5(blob, length, opts);
    var type = blob.read_shift(1) >>> 5 & 0x03;
    var ixti = blob.read_shift(2); // XtiIndex
    var nameindex = blob.read_shift(4);
    return [
        type,
        ixti,
        nameindex
    ];
}
function parse_PtgNameX_BIFF5(blob /*::, length, opts*/ ) {
    var type = blob.read_shift(1) >>> 5 & 0x03;
    var ixti = blob.read_shift(2, "i"); // XtiIndex
    blob.l += 8;
    var nameindex = blob.read_shift(2);
    blob.l += 12;
    return [
        type,
        ixti,
        nameindex
    ];
}
/* [MS-XLS] 2.5.198.70 ; [MS-XLSB] 2.5.97.54 */ function parse_PtgMemArea(blob, length, opts) {
    var type = blob.read_shift(1) >>> 5 & 0x03;
    blob.l += opts && opts.biff == 2 ? 3 : 4;
    var cce = blob.read_shift(opts && opts.biff == 2 ? 1 : 2);
    return [
        type,
        cce
    ];
}
/* [MS-XLS] 2.5.198.72 ; [MS-XLSB] 2.5.97.56 */ function parse_PtgMemFunc(blob, length, opts) {
    var type = blob.read_shift(1) >>> 5 & 0x03;
    var cce = blob.read_shift(opts && opts.biff == 2 ? 1 : 2);
    return [
        type,
        cce
    ];
}
/* [MS-XLS] 2.5.198.86 ; [MS-XLSB] 2.5.97.69 */ function parse_PtgRefErr(blob, length, opts) {
    var type = blob.read_shift(1) >>> 5 & 0x03;
    blob.l += 4;
    if (opts.biff < 8) blob.l--;
    if (opts.biff == 12) blob.l += 2;
    return [
        type
    ];
}
/* [MS-XLS] 2.5.198.87 ; [MS-XLSB] 2.5.97.71 */ function parse_PtgRefErr3d(blob, length, opts) {
    var type = (blob[blob.l++] & 0x60) >> 5;
    var ixti = blob.read_shift(2);
    var w = 4;
    if (opts) switch(opts.biff){
        case 5:
            w = 15;
            break;
        case 12:
            w = 6;
            break;
    }
    blob.l += w;
    return [
        type,
        ixti
    ];
}
/* [MS-XLS] 2.5.198.71 ; [MS-XLSB] 2.5.97.55 */ var parse_PtgMemErr = parsenoop;
/* [MS-XLS] 2.5.198.73  ; [MS-XLSB] 2.5.97.57 */ var parse_PtgMemNoMem = parsenoop;
/* [MS-XLS] 2.5.198.92 */ var parse_PtgTbl = parsenoop;
function parse_PtgElfLoc(blob, length, opts) {
    blob.l += 2;
    return [
        parse_RgceElfLoc(blob, 4, opts)
    ];
}
function parse_PtgElfNoop(blob /*::, length, opts*/ ) {
    blob.l += 6;
    return [];
}
/* [MS-XLS] 2.5.198.46 */ var parse_PtgElfCol = parse_PtgElfLoc;
/* [MS-XLS] 2.5.198.47 */ var parse_PtgElfColS = parse_PtgElfNoop;
/* [MS-XLS] 2.5.198.48 */ var parse_PtgElfColSV = parse_PtgElfNoop;
/* [MS-XLS] 2.5.198.49 */ var parse_PtgElfColV = parse_PtgElfLoc;
/* [MS-XLS] 2.5.198.50 */ function parse_PtgElfLel(blob /*::, length, opts*/ ) {
    blob.l += 2;
    return [
        parseuint16(blob),
        blob.read_shift(2) & 0x01
    ];
}
/* [MS-XLS] 2.5.198.51 */ var parse_PtgElfRadical = parse_PtgElfLoc;
/* [MS-XLS] 2.5.198.52 */ var parse_PtgElfRadicalLel = parse_PtgElfLel;
/* [MS-XLS] 2.5.198.53 */ var parse_PtgElfRadicalS = parse_PtgElfNoop;
/* [MS-XLS] 2.5.198.54 */ var parse_PtgElfRw = parse_PtgElfLoc;
/* [MS-XLS] 2.5.198.55 */ var parse_PtgElfRwV = parse_PtgElfLoc;
/* [MS-XLSB] 2.5.97.52 TODO */ var PtgListRT = [
    "Data",
    "All",
    "Headers",
    "??",
    "?Data2",
    "??",
    "?DataHeaders",
    "??",
    "Totals",
    "??",
    "??",
    "??",
    "?DataTotals",
    "??",
    "??",
    "??",
    "?Current"
];
function parse_PtgList(blob /*::, length, opts*/ ) {
    blob.l += 2;
    var ixti = blob.read_shift(2);
    var flags = blob.read_shift(2);
    var idx = blob.read_shift(4);
    var c = blob.read_shift(2);
    var C = blob.read_shift(2);
    var rt = PtgListRT[flags >> 2 & 0x1F];
    return {
        ixti: ixti,
        coltype: flags & 0x3,
        rt: rt,
        idx: idx,
        c: c,
        C: C
    };
}
/* [MS-XLS] 2.5.198.91 ; [MS-XLSB] 2.5.97.76 */ function parse_PtgSxName(blob /*::, length, opts*/ ) {
    blob.l += 2;
    return [
        blob.read_shift(4)
    ];
}
/* [XLS] old spec */ function parse_PtgSheet(blob, length, opts) {
    blob.l += 5;
    blob.l += 2;
    blob.l += opts.biff == 2 ? 1 : 4;
    return [
        "PTGSHEET"
    ];
}
function parse_PtgEndSheet(blob, length, opts) {
    blob.l += opts.biff == 2 ? 4 : 5;
    return [
        "PTGENDSHEET"
    ];
}
function parse_PtgMemAreaN(blob /*::, length, opts*/ ) {
    var type = blob.read_shift(1) >>> 5 & 0x03;
    var cce = blob.read_shift(2);
    return [
        type,
        cce
    ];
}
function parse_PtgMemNoMemN(blob /*::, length, opts*/ ) {
    var type = blob.read_shift(1) >>> 5 & 0x03;
    var cce = blob.read_shift(2);
    return [
        type,
        cce
    ];
}
function parse_PtgAttrNoop(blob /*::, length, opts*/ ) {
    blob.l += 4;
    return [
        0,
        0
    ];
}
/* [MS-XLS] 2.5.198.25 ; [MS-XLSB] 2.5.97.16 */ var PtgTypes = {
    /*::[*/ 0x01: {
        n: "PtgExp",
        f: parse_PtgExp
    },
    /*::[*/ 0x02: {
        n: "PtgTbl",
        f: parse_PtgTbl
    },
    /*::[*/ 0x03: {
        n: "PtgAdd",
        f: parseread1
    },
    /*::[*/ 0x04: {
        n: "PtgSub",
        f: parseread1
    },
    /*::[*/ 0x05: {
        n: "PtgMul",
        f: parseread1
    },
    /*::[*/ 0x06: {
        n: "PtgDiv",
        f: parseread1
    },
    /*::[*/ 0x07: {
        n: "PtgPower",
        f: parseread1
    },
    /*::[*/ 0x08: {
        n: "PtgConcat",
        f: parseread1
    },
    /*::[*/ 0x09: {
        n: "PtgLt",
        f: parseread1
    },
    /*::[*/ 0x0A: {
        n: "PtgLe",
        f: parseread1
    },
    /*::[*/ 0x0B: {
        n: "PtgEq",
        f: parseread1
    },
    /*::[*/ 0x0C: {
        n: "PtgGe",
        f: parseread1
    },
    /*::[*/ 0x0D: {
        n: "PtgGt",
        f: parseread1
    },
    /*::[*/ 0x0E: {
        n: "PtgNe",
        f: parseread1
    },
    /*::[*/ 0x0F: {
        n: "PtgIsect",
        f: parseread1
    },
    /*::[*/ 0x10: {
        n: "PtgUnion",
        f: parseread1
    },
    /*::[*/ 0x11: {
        n: "PtgRange",
        f: parseread1
    },
    /*::[*/ 0x12: {
        n: "PtgUplus",
        f: parseread1
    },
    /*::[*/ 0x13: {
        n: "PtgUminus",
        f: parseread1
    },
    /*::[*/ 0x14: {
        n: "PtgPercent",
        f: parseread1
    },
    /*::[*/ 0x15: {
        n: "PtgParen",
        f: parseread1
    },
    /*::[*/ 0x16: {
        n: "PtgMissArg",
        f: parseread1
    },
    /*::[*/ 0x17: {
        n: "PtgStr",
        f: parse_PtgStr
    },
    /*::[*/ 0x1A: {
        n: "PtgSheet",
        f: parse_PtgSheet
    },
    /*::[*/ 0x1B: {
        n: "PtgEndSheet",
        f: parse_PtgEndSheet
    },
    /*::[*/ 0x1C: {
        n: "PtgErr",
        f: parse_PtgErr
    },
    /*::[*/ 0x1D: {
        n: "PtgBool",
        f: parse_PtgBool
    },
    /*::[*/ 0x1E: {
        n: "PtgInt",
        f: parse_PtgInt
    },
    /*::[*/ 0x1F: {
        n: "PtgNum",
        f: parse_PtgNum
    },
    /*::[*/ 0x20: {
        n: "PtgArray",
        f: parse_PtgArray
    },
    /*::[*/ 0x21: {
        n: "PtgFunc",
        f: parse_PtgFunc
    },
    /*::[*/ 0x22: {
        n: "PtgFuncVar",
        f: parse_PtgFuncVar
    },
    /*::[*/ 0x23: {
        n: "PtgName",
        f: parse_PtgName
    },
    /*::[*/ 0x24: {
        n: "PtgRef",
        f: parse_PtgRef
    },
    /*::[*/ 0x25: {
        n: "PtgArea",
        f: parse_PtgArea
    },
    /*::[*/ 0x26: {
        n: "PtgMemArea",
        f: parse_PtgMemArea
    },
    /*::[*/ 0x27: {
        n: "PtgMemErr",
        f: parse_PtgMemErr
    },
    /*::[*/ 0x28: {
        n: "PtgMemNoMem",
        f: parse_PtgMemNoMem
    },
    /*::[*/ 0x29: {
        n: "PtgMemFunc",
        f: parse_PtgMemFunc
    },
    /*::[*/ 0x2A: {
        n: "PtgRefErr",
        f: parse_PtgRefErr
    },
    /*::[*/ 0x2B: {
        n: "PtgAreaErr",
        f: parse_PtgAreaErr
    },
    /*::[*/ 0x2C: {
        n: "PtgRefN",
        f: parse_PtgRefN
    },
    /*::[*/ 0x2D: {
        n: "PtgAreaN",
        f: parse_PtgAreaN
    },
    /*::[*/ 0x2E: {
        n: "PtgMemAreaN",
        f: parse_PtgMemAreaN
    },
    /*::[*/ 0x2F: {
        n: "PtgMemNoMemN",
        f: parse_PtgMemNoMemN
    },
    /*::[*/ 0x39: {
        n: "PtgNameX",
        f: parse_PtgNameX
    },
    /*::[*/ 0x3A: {
        n: "PtgRef3d",
        f: parse_PtgRef3d
    },
    /*::[*/ 0x3B: {
        n: "PtgArea3d",
        f: parse_PtgArea3d
    },
    /*::[*/ 0x3C: {
        n: "PtgRefErr3d",
        f: parse_PtgRefErr3d
    },
    /*::[*/ 0x3D: {
        n: "PtgAreaErr3d",
        f: parse_PtgAreaErr3d
    },
    /*::[*/ 0xFF: {}
};
/* These are duplicated in the PtgTypes table */ var PtgDupes = {
    /*::[*/ 0x40: 0x20,
    /*::[*/ 0x60: 0x20,
    /*::[*/ 0x41: 0x21,
    /*::[*/ 0x61: 0x21,
    /*::[*/ 0x42: 0x22,
    /*::[*/ 0x62: 0x22,
    /*::[*/ 0x43: 0x23,
    /*::[*/ 0x63: 0x23,
    /*::[*/ 0x44: 0x24,
    /*::[*/ 0x64: 0x24,
    /*::[*/ 0x45: 0x25,
    /*::[*/ 0x65: 0x25,
    /*::[*/ 0x46: 0x26,
    /*::[*/ 0x66: 0x26,
    /*::[*/ 0x47: 0x27,
    /*::[*/ 0x67: 0x27,
    /*::[*/ 0x48: 0x28,
    /*::[*/ 0x68: 0x28,
    /*::[*/ 0x49: 0x29,
    /*::[*/ 0x69: 0x29,
    /*::[*/ 0x4A: 0x2A,
    /*::[*/ 0x6A: 0x2A,
    /*::[*/ 0x4B: 0x2B,
    /*::[*/ 0x6B: 0x2B,
    /*::[*/ 0x4C: 0x2C,
    /*::[*/ 0x6C: 0x2C,
    /*::[*/ 0x4D: 0x2D,
    /*::[*/ 0x6D: 0x2D,
    /*::[*/ 0x4E: 0x2E,
    /*::[*/ 0x6E: 0x2E,
    /*::[*/ 0x4F: 0x2F,
    /*::[*/ 0x6F: 0x2F,
    /*::[*/ 0x58: 0x22,
    /*::[*/ 0x78: 0x22,
    /*::[*/ 0x59: 0x39,
    /*::[*/ 0x79: 0x39,
    /*::[*/ 0x5A: 0x3A,
    /*::[*/ 0x7A: 0x3A,
    /*::[*/ 0x5B: 0x3B,
    /*::[*/ 0x7B: 0x3B,
    /*::[*/ 0x5C: 0x3C,
    /*::[*/ 0x7C: 0x3C,
    /*::[*/ 0x5D: 0x3D,
    /*::[*/ 0x7D: 0x3D
};
var Ptg18 = {
    /*::[*/ 0x01: {
        n: "PtgElfLel",
        f: parse_PtgElfLel
    },
    /*::[*/ 0x02: {
        n: "PtgElfRw",
        f: parse_PtgElfRw
    },
    /*::[*/ 0x03: {
        n: "PtgElfCol",
        f: parse_PtgElfCol
    },
    /*::[*/ 0x06: {
        n: "PtgElfRwV",
        f: parse_PtgElfRwV
    },
    /*::[*/ 0x07: {
        n: "PtgElfColV",
        f: parse_PtgElfColV
    },
    /*::[*/ 0x0A: {
        n: "PtgElfRadical",
        f: parse_PtgElfRadical
    },
    /*::[*/ 0x0B: {
        n: "PtgElfRadicalS",
        f: parse_PtgElfRadicalS
    },
    /*::[*/ 0x0D: {
        n: "PtgElfColS",
        f: parse_PtgElfColS
    },
    /*::[*/ 0x0F: {
        n: "PtgElfColSV",
        f: parse_PtgElfColSV
    },
    /*::[*/ 0x10: {
        n: "PtgElfRadicalLel",
        f: parse_PtgElfRadicalLel
    },
    /*::[*/ 0x19: {
        n: "PtgList",
        f: parse_PtgList
    },
    /*::[*/ 0x1D: {
        n: "PtgSxName",
        f: parse_PtgSxName
    },
    /*::[*/ 0xFF: {}
};
var Ptg19 = {
    /*::[*/ 0x00: {
        n: "PtgAttrNoop",
        f: parse_PtgAttrNoop
    },
    /*::[*/ 0x01: {
        n: "PtgAttrSemi",
        f: parse_PtgAttrSemi
    },
    /*::[*/ 0x02: {
        n: "PtgAttrIf",
        f: parse_PtgAttrIf
    },
    /*::[*/ 0x04: {
        n: "PtgAttrChoose",
        f: parse_PtgAttrChoose
    },
    /*::[*/ 0x08: {
        n: "PtgAttrGoto",
        f: parse_PtgAttrGoto
    },
    /*::[*/ 0x10: {
        n: "PtgAttrSum",
        f: parse_PtgAttrSum
    },
    /*::[*/ 0x20: {
        n: "PtgAttrBaxcel",
        f: parse_PtgAttrBaxcel
    },
    /*::[*/ 0x21: {
        n: "PtgAttrBaxcel",
        f: parse_PtgAttrBaxcel
    },
    /*::[*/ 0x40: {
        n: "PtgAttrSpace",
        f: parse_PtgAttrSpace
    },
    /*::[*/ 0x41: {
        n: "PtgAttrSpaceSemi",
        f: parse_PtgAttrSpaceSemi
    },
    /*::[*/ 0x80: {
        n: "PtgAttrIfError",
        f: parse_PtgAttrIfError
    },
    /*::[*/ 0xFF: {}
};
/* [MS-XLS] 2.5.198.103 ; [MS-XLSB] 2.5.97.87 */ function parse_RgbExtra(blob, length, rgce, opts) {
    if (opts.biff < 8) return parsenoop(blob, length);
    var target = blob.l + length;
    var o = [];
    for(var i = 0; i !== rgce.length; ++i)switch(rgce[i][0]){
        case "PtgArray":
            /* PtgArray -> PtgExtraArray */ rgce[i][1] = parse_PtgExtraArray(blob, 0, opts);
            o.push(rgce[i][1]);
            break;
        case "PtgMemArea":
            /* PtgMemArea -> PtgExtraMem */ rgce[i][2] = parse_PtgExtraMem(blob, rgce[i][1], opts);
            o.push(rgce[i][2]);
            break;
        case "PtgExp":
            /* PtgExp -> PtgExtraCol */ if (opts && opts.biff == 12) {
                rgce[i][1][1] = blob.read_shift(4);
                o.push(rgce[i][1]);
            }
            break;
        case "PtgList":
        /* TODO: PtgList -> PtgExtraList */ case "PtgElfRadicalS":
        /* TODO: PtgElfRadicalS -> PtgExtraElf */ case "PtgElfColS":
        /* TODO: PtgElfColS -> PtgExtraElf */ case "PtgElfColSV":
            /* TODO: PtgElfColSV -> PtgExtraElf */ throw "Unsupported " + rgce[i][0];
        default:
            break;
    }
    length = target - blob.l;
    /* note: this is technically an error but Excel disregards */ //if(target !== blob.l && blob.l !== target - length) throw new Error(target + " != " + blob.l);
    if (length !== 0) o.push(parsenoop(blob, length));
    return o;
}
/* [MS-XLS] 2.5.198.104 ; [MS-XLSB] 2.5.97.88 */ function parse_Rgce(blob, length, opts) {
    var target = blob.l + length;
    var R, id, ptgs = [];
    while(target != blob.l){
        length = target - blob.l;
        id = blob[blob.l];
        R = PtgTypes[id] || PtgTypes[PtgDupes[id]];
        if (id === 0x18 || id === 0x19) R = (id === 0x18 ? Ptg18 : Ptg19)[blob[blob.l + 1]];
        if (!R || !R.f) parsenoop(blob, length);
        else ptgs.push([
            R.n,
            R.f(blob, length, opts)
        ]);
    }
    return ptgs;
}
function stringify_array(f /*:Array<Array<string>>*/ ) /*:string*/ {
    var o /*:Array<string>*/  = [];
    for(var i = 0; i < f.length; ++i){
        var x = f[i], r /*:Array<string>*/  = [];
        for(var j = 0; j < x.length; ++j){
            var y = x[j];
            if (y) switch(y[0]){
                // TODO: handle embedded quotes
                case 0x02:
                    /*:: if(typeof y[1] != 'string') throw "unreachable"; */ r.push('"' + y[1].replace(/"/g, '""') + '"');
                    break;
                default:
                    r.push(y[1]);
            }
            else r.push("");
        }
        o.push(r.join(","));
    }
    return o.join(";");
}
/* [MS-XLS] 2.2.2 ; [MS-XLSB] 2.2.2 TODO */ var PtgBinOp = {
    PtgAdd: "+",
    PtgConcat: "&",
    PtgDiv: "/",
    PtgEq: "=",
    PtgGe: ">=",
    PtgGt: ">",
    PtgLe: "<=",
    PtgLt: "<",
    PtgMul: "*",
    PtgNe: "<>",
    PtgPower: "^",
    PtgSub: "-"
};
// List of invalid characters needs to be tested further
function formula_quote_sheet_name(sname /*:string*/ , opts) /*:string*/ {
    if (!sname && !(opts && opts.biff <= 5 && opts.biff >= 2)) throw new Error("empty sheet name");
    if (/[^\w\u4E00-\u9FFF\u3040-\u30FF]/.test(sname)) return "'" + sname + "'";
    return sname;
}
function get_ixti_raw(supbooks, ixti /*:number*/ , opts) /*:string*/ {
    if (!supbooks) return "SH33TJSERR0";
    if (opts.biff > 8 && (!supbooks.XTI || !supbooks.XTI[ixti])) return supbooks.SheetNames[ixti];
    if (!supbooks.XTI) return "SH33TJSERR6";
    var XTI = supbooks.XTI[ixti];
    if (opts.biff < 8) {
        if (ixti > 10000) ixti -= 65536;
        if (ixti < 0) ixti = -ixti;
        return ixti == 0 ? "" : supbooks.XTI[ixti - 1];
    }
    if (!XTI) return "SH33TJSERR1";
    var o = "";
    if (opts.biff > 8) switch(supbooks[XTI[0]][0]){
        case 0x0165:
            /* 'BrtSupSelf' */ o = XTI[1] == -1 ? "#REF" : supbooks.SheetNames[XTI[1]];
            return XTI[1] == XTI[2] ? o : o + ":" + supbooks.SheetNames[XTI[2]];
        case 0x0166:
            /* 'BrtSupSame' */ if (opts.SID != null) return supbooks.SheetNames[opts.SID];
            return "SH33TJSSAME" + supbooks[XTI[0]][0];
        case 0x0163:
        /* 'BrtSupBookSrc' */ /* falls through */ default:
            return "SH33TJSSRC" + supbooks[XTI[0]][0];
    }
    switch(supbooks[XTI[0]][0][0]){
        case 0x0401:
            o = XTI[1] == -1 ? "#REF" : supbooks.SheetNames[XTI[1]] || "SH33TJSERR3";
            return XTI[1] == XTI[2] ? o : o + ":" + supbooks.SheetNames[XTI[2]];
        case 0x3A01:
            return supbooks[XTI[0]].slice(1).map(function(name) {
                return name.Name;
            }).join(";;"); //return "SH33TJSERR8";
        default:
            if (!supbooks[XTI[0]][0][3]) return "SH33TJSERR2";
            o = XTI[1] == -1 ? "#REF" : supbooks[XTI[0]][0][3][XTI[1]] || "SH33TJSERR4";
            return XTI[1] == XTI[2] ? o : o + ":" + supbooks[XTI[0]][0][3][XTI[2]];
    }
}
function get_ixti(supbooks, ixti /*:number*/ , opts) /*:string*/ {
    var ixtiraw = get_ixti_raw(supbooks, ixti, opts);
    return ixtiraw == "#REF" ? ixtiraw : formula_quote_sheet_name(ixtiraw, opts);
}
function stringify_formula(formula /*Array<any>*/ , range, cell /*:any*/ , supbooks, opts) /*:string*/ {
    var biff = opts && opts.biff || 8;
    var _range = /*range != null ? range :*/ {
        s: {
            c: 0,
            r: 0
        },
        e: {
            c: 0,
            r: 0
        }
    };
    var stack /*:Array<string>*/  = [], e1, e2, /*::type,*/ c /*:CellAddress*/ , ixti = 0, nameidx = 0, r, sname = "";
    if (!formula[0] || !formula[0][0]) return "";
    var last_sp = -1, sp = "";
    for(var ff = 0, fflen = formula[0].length; ff < fflen; ++ff){
        var f = formula[0][ff];
        switch(f[0]){
            case "PtgUminus":
                /* [MS-XLS] 2.5.198.93 */ stack.push("-" + stack.pop());
                break;
            case "PtgUplus":
                /* [MS-XLS] 2.5.198.95 */ stack.push("+" + stack.pop());
                break;
            case "PtgPercent":
                /* [MS-XLS] 2.5.198.81 */ stack.push(stack.pop() + "%");
                break;
            case "PtgAdd":
            /* [MS-XLS] 2.5.198.26 */ case "PtgConcat":
            /* [MS-XLS] 2.5.198.43 */ case "PtgDiv":
            /* [MS-XLS] 2.5.198.45 */ case "PtgEq":
            /* [MS-XLS] 2.5.198.56 */ case "PtgGe":
            /* [MS-XLS] 2.5.198.64 */ case "PtgGt":
            /* [MS-XLS] 2.5.198.65 */ case "PtgLe":
            /* [MS-XLS] 2.5.198.68 */ case "PtgLt":
            /* [MS-XLS] 2.5.198.69 */ case "PtgMul":
            /* [MS-XLS] 2.5.198.75 */ case "PtgNe":
            /* [MS-XLS] 2.5.198.78 */ case "PtgPower":
            /* [MS-XLS] 2.5.198.82 */ case "PtgSub":
                /* [MS-XLS] 2.5.198.90 */ e1 = stack.pop();
                e2 = stack.pop();
                if (last_sp >= 0) {
                    switch(formula[0][last_sp][1][0]){
                        case 0:
                            // $FlowIgnore
                            sp = fill(" ", formula[0][last_sp][1][1]);
                            break;
                        case 1:
                            // $FlowIgnore
                            sp = fill("\r", formula[0][last_sp][1][1]);
                            break;
                        default:
                            sp = "";
                            // $FlowIgnore
                            if (opts.WTF) throw new Error("Unexpected PtgAttrSpaceType " + formula[0][last_sp][1][0]);
                    }
                    e2 = e2 + sp;
                    last_sp = -1;
                }
                stack.push(e2 + PtgBinOp[f[0]] + e1);
                break;
            case "PtgIsect":
                /* [MS-XLS] 2.5.198.67 */ e1 = stack.pop();
                e2 = stack.pop();
                stack.push(e2 + " " + e1);
                break;
            case "PtgUnion":
                /* [MS-XLS] 2.5.198.94 */ e1 = stack.pop();
                e2 = stack.pop();
                stack.push(e2 + "," + e1);
                break;
            case "PtgRange":
                /* [MS-XLS] 2.5.198.83 */ e1 = stack.pop();
                e2 = stack.pop();
                stack.push(e2 + ":" + e1);
                break;
            case "PtgAttrChoose":
                break;
            case "PtgAttrGoto":
                break;
            case "PtgAttrIf":
                break;
            case "PtgAttrIfError":
                break;
            case "PtgRef":
                /* [MS-XLS] 2.5.198.84 */ /*::type = f[1][0]; */ c = shift_cell_xls(f[1][1], _range, opts);
                stack.push(encode_cell_xls(c, biff));
                break;
            case "PtgRefN":
                /* [MS-XLS] 2.5.198.88 */ /*::type = f[1][0]; */ c = cell ? shift_cell_xls(f[1][1], cell, opts) : f[1][1];
                stack.push(encode_cell_xls(c, biff));
                break;
            case "PtgRef3d":
                /* [MS-XLS] 2.5.198.85 */ /*::type = f[1][0]; */ ixti = /*::Number(*/ f[1][1] /*::)*/ ;
                c = shift_cell_xls(f[1][2], _range, opts);
                sname = get_ixti(supbooks, ixti, opts);
                var w = sname; /* IE9 fails on defined names */  // eslint-disable-line no-unused-vars
                stack.push(sname + "!" + encode_cell_xls(c, biff));
                break;
            case "PtgFunc":
            /* [MS-XLS] 2.5.198.62 */ case "PtgFuncVar":
                /* [MS-XLS] 2.5.198.63 */ /* f[1] = [argc, func, type] */ var argc /*:number*/  = f[1][0], func /*:string*/  = f[1][1];
                if (!argc) argc = 0;
                argc &= 0x7F;
                var args = argc == 0 ? [] : stack.slice(-argc);
                stack.length -= argc;
                if (func === "User") func = args.shift();
                stack.push(func + "(" + args.join(",") + ")");
                break;
            case "PtgBool":
                /* [MS-XLS] 2.5.198.42 */ stack.push(f[1] ? "TRUE" : "FALSE");
                break;
            case "PtgInt":
                /* [MS-XLS] 2.5.198.66 */ stack.push(/*::String(*/ f[1]);
                break;
            case "PtgNum":
                /* [MS-XLS] 2.5.198.79 TODO: precision? */ stack.push(String(f[1]));
                break;
            case "PtgStr":
                /* [MS-XLS] 2.5.198.89 */ // $FlowIgnore
                stack.push('"' + f[1].replace(/"/g, '""') + '"');
                break;
            case "PtgErr":
                /* [MS-XLS] 2.5.198.57 */ stack.push(/*::String(*/ f[1]);
                break;
            case "PtgAreaN":
                /* [MS-XLS] 2.5.198.31 TODO */ /*::type = f[1][0]; */ r = shift_range_xls(f[1][1], cell ? {
                    s: cell
                } : _range, opts);
                stack.push(encode_range_xls(r /*:any*/ , opts));
                break;
            case "PtgArea":
                /* [MS-XLS] 2.5.198.27 TODO: fixed points */ /*::type = f[1][0]; */ r = shift_range_xls(f[1][1], _range, opts);
                stack.push(encode_range_xls(r /*:any*/ , opts));
                break;
            case "PtgArea3d":
                /* [MS-XLS] 2.5.198.28 TODO */ /*::type = f[1][0]; */ ixti = /*::Number(*/ f[1][1] /*::)*/ ;
                r = f[1][2];
                sname = get_ixti(supbooks, ixti, opts);
                stack.push(sname + "!" + encode_range_xls(r /*:any*/ , opts));
                break;
            case "PtgAttrSum":
                /* [MS-XLS] 2.5.198.41 */ stack.push("SUM(" + stack.pop() + ")");
                break;
            case "PtgAttrBaxcel":
            /* [MS-XLS] 2.5.198.33 */ case "PtgAttrSemi":
                break;
            case "PtgName":
                /* [MS-XLS] 2.5.198.76 ; [MS-XLSB] 2.5.97.60 TODO: revisions */ /* f[1] = type, 0, nameindex */ nameidx = f[1][2];
                var lbl = (supbooks.names || [])[nameidx - 1] || (supbooks[0] || [])[nameidx];
                var name = lbl ? lbl.Name : "SH33TJSNAME" + String(nameidx);
                /* [MS-XLSB] 2.5.97.10 Ftab -- last verified 20220204 */ if (name && name.slice(0, 6) == "_xlfn." && !opts.xlfn) name = name.slice(6);
                stack.push(name);
                break;
            case "PtgNameX":
                /* [MS-XLS] 2.5.198.77 ; [MS-XLSB] 2.5.97.61 TODO: revisions */ /* f[1] = type, ixti, nameindex */ var bookidx /*:number*/  = f[1][1];
                nameidx = f[1][2];
                var externbook;
                /* TODO: Properly handle missing values -- this should be using get_ixti_raw primarily */ if (opts.biff <= 5) {
                    if (bookidx < 0) bookidx = -bookidx;
                    if (supbooks[bookidx]) externbook = supbooks[bookidx][nameidx];
                } else {
                    var o = "";
                    if (((supbooks[bookidx] || [])[0] || [])[0] == 0x3A01) ;
                    else if (((supbooks[bookidx] || [])[0] || [])[0] == 0x0401) {
                        if (supbooks[bookidx][nameidx] && supbooks[bookidx][nameidx].itab > 0) o = supbooks.SheetNames[supbooks[bookidx][nameidx].itab - 1] + "!";
                    } else o = supbooks.SheetNames[nameidx - 1] + "!";
                    if (supbooks[bookidx] && supbooks[bookidx][nameidx]) o += supbooks[bookidx][nameidx].Name;
                    else if (supbooks[0] && supbooks[0][nameidx]) o += supbooks[0][nameidx].Name;
                    else {
                        var ixtidata = (get_ixti_raw(supbooks, bookidx, opts) || "").split(";;");
                        if (ixtidata[nameidx - 1]) o = ixtidata[nameidx - 1]; // TODO: confirm this is correct
                        else o += "SH33TJSERRX";
                    }
                    stack.push(o);
                    break;
                }
                if (!externbook) externbook = {
                    Name: "SH33TJSERRY"
                };
                stack.push(externbook.Name);
                break;
            case "PtgParen":
                /* [MS-XLS] 2.5.198.80 */ var lp = "(", rp = ")";
                if (last_sp >= 0) {
                    sp = "";
                    switch(formula[0][last_sp][1][0]){
                        // $FlowIgnore
                        case 2:
                            lp = fill(" ", formula[0][last_sp][1][1]) + lp;
                            break;
                        // $FlowIgnore
                        case 3:
                            lp = fill("\r", formula[0][last_sp][1][1]) + lp;
                            break;
                        // $FlowIgnore
                        case 4:
                            rp = fill(" ", formula[0][last_sp][1][1]) + rp;
                            break;
                        // $FlowIgnore
                        case 5:
                            rp = fill("\r", formula[0][last_sp][1][1]) + rp;
                            break;
                        default:
                            // $FlowIgnore
                            if (opts.WTF) throw new Error("Unexpected PtgAttrSpaceType " + formula[0][last_sp][1][0]);
                    }
                    last_sp = -1;
                }
                stack.push(lp + stack.pop() + rp);
                break;
            case "PtgRefErr":
                /* [MS-XLS] 2.5.198.86 */ stack.push("#REF!");
                break;
            case "PtgRefErr3d":
                /* [MS-XLS] 2.5.198.87 */ stack.push("#REF!");
                break;
            case "PtgExp":
                /* [MS-XLS] 2.5.198.58 TODO */ c = {
                    c: f[1][1],
                    r: f[1][0]
                };
                var q = {
                    c: cell.c,
                    r: cell.r
                } /*:any*/ ;
                if (supbooks.sharedf[encode_cell(c)]) {
                    var parsedf = supbooks.sharedf[encode_cell(c)];
                    stack.push(stringify_formula(parsedf, _range, q, supbooks, opts));
                } else {
                    var fnd = false;
                    for(e1 = 0; e1 != supbooks.arrayf.length; ++e1){
                        /* TODO: should be something like range_has */ e2 = supbooks.arrayf[e1];
                        if (c.c < e2[0].s.c || c.c > e2[0].e.c) continue;
                        if (c.r < e2[0].s.r || c.r > e2[0].e.r) continue;
                        stack.push(stringify_formula(e2[1], _range, q, supbooks, opts));
                        fnd = true;
                        break;
                    }
                    if (!fnd) stack.push(/*::String(*/ f[1]);
                }
                break;
            case "PtgArray":
                /* [MS-XLS] 2.5.198.32 TODO */ stack.push("{" + stringify_array(/*::(*/ f[1]) + "}");
                break;
            case "PtgMemArea":
                break;
            case "PtgAttrSpace":
            /* [MS-XLS] 2.5.198.38 */ case "PtgAttrSpaceSemi":
                /* [MS-XLS] 2.5.198.39 */ last_sp = ff;
                break;
            case "PtgTbl":
                break;
            case "PtgMemErr":
                break;
            case "PtgMissArg":
                /* [MS-XLS] 2.5.198.74 */ stack.push("");
                break;
            case "PtgAreaErr":
                /* [MS-XLS] 2.5.198.29 */ stack.push("#REF!");
                break;
            case "PtgAreaErr3d":
                /* [MS-XLS] 2.5.198.30 */ stack.push("#REF!");
                break;
            case "PtgList":
                /* [MS-XLSB] 2.5.97.52 */ // $FlowIgnore
                stack.push("Table" + f[1].idx + "[#" + f[1].rt + "]");
                break;
            case "PtgMemAreaN":
            case "PtgMemNoMemN":
            case "PtgAttrNoop":
            case "PtgSheet":
            case "PtgEndSheet":
                break;
            case "PtgMemFunc":
                break;
            case "PtgMemNoMem":
                break;
            case "PtgElfCol":
            /* [MS-XLS] 2.5.198.46 */ case "PtgElfColS":
            /* [MS-XLS] 2.5.198.47 */ case "PtgElfColSV":
            /* [MS-XLS] 2.5.198.48 */ case "PtgElfColV":
            /* [MS-XLS] 2.5.198.49 */ case "PtgElfLel":
            /* [MS-XLS] 2.5.198.50 */ case "PtgElfRadical":
            /* [MS-XLS] 2.5.198.51 */ case "PtgElfRadicalLel":
            /* [MS-XLS] 2.5.198.52 */ case "PtgElfRadicalS":
            /* [MS-XLS] 2.5.198.53 */ case "PtgElfRw":
            /* [MS-XLS] 2.5.198.54 */ case "PtgElfRwV":
                /* [MS-XLS] 2.5.198.55 */ throw new Error("Unsupported ELFs");
            case "PtgSxName":
                /* [MS-XLS] 2.5.198.91 TODO -- find a test case */ throw new Error("Unrecognized Formula Token: " + String(f));
            default:
                throw new Error("Unrecognized Formula Token: " + String(f));
        }
        var PtgNonDisp = [
            "PtgAttrSpace",
            "PtgAttrSpaceSemi",
            "PtgAttrGoto"
        ];
        if (opts.biff != 3) {
            if (last_sp >= 0 && PtgNonDisp.indexOf(formula[0][ff][0]) == -1) {
                f = formula[0][last_sp];
                var _left = true;
                switch(f[1][0]){
                    /* note: some bad XLSB files omit the PtgParen */ case 4:
                        _left = false;
                    /* falls through */ case 0:
                        // $FlowIgnore
                        sp = fill(" ", f[1][1]);
                        break;
                    case 5:
                        _left = false;
                    /* falls through */ case 1:
                        // $FlowIgnore
                        sp = fill("\r", f[1][1]);
                        break;
                    default:
                        sp = "";
                        // $FlowIgnore
                        if (opts.WTF) throw new Error("Unexpected PtgAttrSpaceType " + f[1][0]);
                }
                stack.push((_left ? sp : "") + stack.pop() + (_left ? "" : sp));
                last_sp = -1;
            }
        }
    }
    if (stack.length > 1 && opts.WTF) throw new Error("bad formula stack");
    return stack[0];
}
/* [MS-XLS] 2.5.198.1 TODO */ function parse_ArrayParsedFormula(blob, length, opts /*::, ref*/ ) {
    var target = blob.l + length, len = opts.biff == 2 ? 1 : 2;
    var rgcb, cce = blob.read_shift(len); // length of rgce
    if (cce == 0xFFFF) return [
        [],
        parsenoop(blob, length - 2)
    ];
    var rgce = parse_Rgce(blob, cce, opts);
    if (length !== cce + len) rgcb = parse_RgbExtra(blob, length - cce - len, rgce, opts);
    blob.l = target;
    return [
        rgce,
        rgcb
    ];
}
/* [MS-XLS] 2.5.198.3 TODO */ function parse_XLSCellParsedFormula(blob, length, opts) {
    var target = blob.l + length, len = opts.biff == 2 ? 1 : 2;
    var rgcb, cce = blob.read_shift(len); // length of rgce
    if (cce == 0xFFFF) return [
        [],
        parsenoop(blob, length - 2)
    ];
    var rgce = parse_Rgce(blob, cce, opts);
    if (length !== cce + len) rgcb = parse_RgbExtra(blob, length - cce - len, rgce, opts);
    blob.l = target;
    return [
        rgce,
        rgcb
    ];
}
/* [MS-XLS] 2.5.198.21 */ function parse_NameParsedFormula(blob, length, opts, cce) {
    var target = blob.l + length;
    var rgce = parse_Rgce(blob, cce, opts);
    var rgcb;
    if (target !== blob.l) rgcb = parse_RgbExtra(blob, target - blob.l, rgce, opts);
    return [
        rgce,
        rgcb
    ];
}
/* [MS-XLS] 2.5.198.118 TODO */ function parse_SharedParsedFormula(blob, length, opts) {
    var target = blob.l + length;
    var rgcb, cce = blob.read_shift(2); // length of rgce
    var rgce = parse_Rgce(blob, cce, opts);
    if (cce == 0xFFFF) return [
        [],
        parsenoop(blob, length - 2)
    ];
    if (length !== cce + 2) rgcb = parse_RgbExtra(blob, target - cce - 2, rgce, opts);
    return [
        rgce,
        rgcb
    ];
}
/* [MS-XLS] 2.5.133 TODO: how to emit empty strings? */ function parse_FormulaValue(blob /*::, length*/ ) {
    var b;
    if (__readUInt16LE(blob, blob.l + 6) !== 0xFFFF) return [
        parse_Xnum(blob),
        "n"
    ];
    switch(blob[blob.l]){
        case 0x00:
            blob.l += 8;
            return [
                "String",
                "s"
            ];
        case 0x01:
            b = blob[blob.l + 2] === 0x1;
            blob.l += 8;
            return [
                b,
                "b"
            ];
        case 0x02:
            b = blob[blob.l + 2];
            blob.l += 8;
            return [
                b,
                "e"
            ];
        case 0x03:
            blob.l += 8;
            return [
                "",
                "s"
            ];
    }
    return [];
}
function write_FormulaValue(value) {
    if (value == null) {
        // Blank String Value
        var o = new_buf(8);
        o.write_shift(1, 0x03);
        o.write_shift(1, 0);
        o.write_shift(2, 0);
        o.write_shift(2, 0);
        o.write_shift(2, 0xFFFF);
        return o;
    } else if (typeof value == "number") return write_Xnum(value);
    return write_Xnum(0);
}
/* [MS-XLS] 2.4.127 TODO */ function parse_Formula(blob, length, opts) {
    var end = blob.l + length;
    var cell = parse_XLSCell(blob, 6);
    if (opts.biff == 2) ++blob.l;
    var val = parse_FormulaValue(blob, 8);
    var flags = blob.read_shift(1);
    if (opts.biff != 2) {
        blob.read_shift(1);
        if (opts.biff >= 5) /*var chn = */ blob.read_shift(4);
    }
    var cbf = parse_XLSCellParsedFormula(blob, end - blob.l, opts);
    return {
        cell: cell,
        val: val[0],
        formula: cbf,
        shared: flags >> 3 & 1,
        tt: val[1]
    };
}
function write_Formula(cell /*:Cell*/ , R /*:number*/ , C /*:number*/ , opts, os /*:number*/ ) {
    // Cell
    var o1 = write_XLSCell(R, C, os);
    // FormulaValue
    var o2 = write_FormulaValue(cell.v);
    // flags + cache
    var o3 = new_buf(6);
    var flags = 33;
    o3.write_shift(2, flags);
    o3.write_shift(4, 0);
    // CellParsedFormula
    var bf = new_buf(cell.bf.length);
    for(var i = 0; i < cell.bf.length; ++i)bf[i] = cell.bf[i];
    var out = bconcat([
        o1,
        o2,
        o3,
        bf
    ]);
    return out;
}
/* XLSB Parsed Formula records have the same shape */ function parse_XLSBParsedFormula(data, length, opts) {
    var cce = data.read_shift(4);
    var rgce = parse_Rgce(data, cce, opts);
    var cb = data.read_shift(4);
    var rgcb = cb > 0 ? parse_RgbExtra(data, cb, rgce, opts) : null;
    return [
        rgce,
        rgcb
    ];
}
/* [MS-XLSB] 2.5.97.1 ArrayParsedFormula */ var parse_XLSBArrayParsedFormula = parse_XLSBParsedFormula;
/* [MS-XLSB] 2.5.97.4 CellParsedFormula */ var parse_XLSBCellParsedFormula = parse_XLSBParsedFormula;
/* [MS-XLSB] 2.5.97.8 DVParsedFormula */ //var parse_XLSBDVParsedFormula = parse_XLSBParsedFormula;
/* [MS-XLSB] 2.5.97.9 FRTParsedFormula */ //var parse_XLSBFRTParsedFormula = parse_XLSBParsedFormula2;
/* [MS-XLSB] 2.5.97.12 NameParsedFormula */ var parse_XLSBNameParsedFormula = parse_XLSBParsedFormula;
/* [MS-XLSB] 2.5.97.98 SharedParsedFormula */ var parse_XLSBSharedParsedFormula = parse_XLSBParsedFormula;
var Cetab = {
    0: "BEEP",
    1: "OPEN",
    2: "OPEN.LINKS",
    3: "CLOSE.ALL",
    4: "SAVE",
    5: "SAVE.AS",
    6: "FILE.DELETE",
    7: "PAGE.SETUP",
    8: "PRINT",
    9: "PRINTER.SETUP",
    10: "QUIT",
    11: "NEW.WINDOW",
    12: "ARRANGE.ALL",
    13: "WINDOW.SIZE",
    14: "WINDOW.MOVE",
    15: "FULL",
    16: "CLOSE",
    17: "RUN",
    22: "SET.PRINT.AREA",
    23: "SET.PRINT.TITLES",
    24: "SET.PAGE.BREAK",
    25: "REMOVE.PAGE.BREAK",
    26: "FONT",
    27: "DISPLAY",
    28: "PROTECT.DOCUMENT",
    29: "PRECISION",
    30: "A1.R1C1",
    31: "CALCULATE.NOW",
    32: "CALCULATION",
    34: "DATA.FIND",
    35: "EXTRACT",
    36: "DATA.DELETE",
    37: "SET.DATABASE",
    38: "SET.CRITERIA",
    39: "SORT",
    40: "DATA.SERIES",
    41: "TABLE",
    42: "FORMAT.NUMBER",
    43: "ALIGNMENT",
    44: "STYLE",
    45: "BORDER",
    46: "CELL.PROTECTION",
    47: "COLUMN.WIDTH",
    48: "UNDO",
    49: "CUT",
    50: "COPY",
    51: "PASTE",
    52: "CLEAR",
    53: "PASTE.SPECIAL",
    54: "EDIT.DELETE",
    55: "INSERT",
    56: "FILL.RIGHT",
    57: "FILL.DOWN",
    61: "DEFINE.NAME",
    62: "CREATE.NAMES",
    63: "FORMULA.GOTO",
    64: "FORMULA.FIND",
    65: "SELECT.LAST.CELL",
    66: "SHOW.ACTIVE.CELL",
    67: "GALLERY.AREA",
    68: "GALLERY.BAR",
    69: "GALLERY.COLUMN",
    70: "GALLERY.LINE",
    71: "GALLERY.PIE",
    72: "GALLERY.SCATTER",
    73: "COMBINATION",
    74: "PREFERRED",
    75: "ADD.OVERLAY",
    76: "GRIDLINES",
    77: "SET.PREFERRED",
    78: "AXES",
    79: "LEGEND",
    80: "ATTACH.TEXT",
    81: "ADD.ARROW",
    82: "SELECT.CHART",
    83: "SELECT.PLOT.AREA",
    84: "PATTERNS",
    85: "MAIN.CHART",
    86: "OVERLAY",
    87: "SCALE",
    88: "FORMAT.LEGEND",
    89: "FORMAT.TEXT",
    90: "EDIT.REPEAT",
    91: "PARSE",
    92: "JUSTIFY",
    93: "HIDE",
    94: "UNHIDE",
    95: "WORKSPACE",
    96: "FORMULA",
    97: "FORMULA.FILL",
    98: "FORMULA.ARRAY",
    99: "DATA.FIND.NEXT",
    100: "DATA.FIND.PREV",
    101: "FORMULA.FIND.NEXT",
    102: "FORMULA.FIND.PREV",
    103: "ACTIVATE",
    104: "ACTIVATE.NEXT",
    105: "ACTIVATE.PREV",
    106: "UNLOCKED.NEXT",
    107: "UNLOCKED.PREV",
    108: "COPY.PICTURE",
    109: "SELECT",
    110: "DELETE.NAME",
    111: "DELETE.FORMAT",
    112: "VLINE",
    113: "HLINE",
    114: "VPAGE",
    115: "HPAGE",
    116: "VSCROLL",
    117: "HSCROLL",
    118: "ALERT",
    119: "NEW",
    120: "CANCEL.COPY",
    121: "SHOW.CLIPBOARD",
    122: "MESSAGE",
    124: "PASTE.LINK",
    125: "APP.ACTIVATE",
    126: "DELETE.ARROW",
    127: "ROW.HEIGHT",
    128: "FORMAT.MOVE",
    129: "FORMAT.SIZE",
    130: "FORMULA.REPLACE",
    131: "SEND.KEYS",
    132: "SELECT.SPECIAL",
    133: "APPLY.NAMES",
    134: "REPLACE.FONT",
    135: "FREEZE.PANES",
    136: "SHOW.INFO",
    137: "SPLIT",
    138: "ON.WINDOW",
    139: "ON.DATA",
    140: "DISABLE.INPUT",
    142: "OUTLINE",
    143: "LIST.NAMES",
    144: "FILE.CLOSE",
    145: "SAVE.WORKBOOK",
    146: "DATA.FORM",
    147: "COPY.CHART",
    148: "ON.TIME",
    149: "WAIT",
    150: "FORMAT.FONT",
    151: "FILL.UP",
    152: "FILL.LEFT",
    153: "DELETE.OVERLAY",
    155: "SHORT.MENUS",
    159: "SET.UPDATE.STATUS",
    161: "COLOR.PALETTE",
    162: "DELETE.STYLE",
    163: "WINDOW.RESTORE",
    164: "WINDOW.MAXIMIZE",
    166: "CHANGE.LINK",
    167: "CALCULATE.DOCUMENT",
    168: "ON.KEY",
    169: "APP.RESTORE",
    170: "APP.MOVE",
    171: "APP.SIZE",
    172: "APP.MINIMIZE",
    173: "APP.MAXIMIZE",
    174: "BRING.TO.FRONT",
    175: "SEND.TO.BACK",
    185: "MAIN.CHART.TYPE",
    186: "OVERLAY.CHART.TYPE",
    187: "SELECT.END",
    188: "OPEN.MAIL",
    189: "SEND.MAIL",
    190: "STANDARD.FONT",
    191: "CONSOLIDATE",
    192: "SORT.SPECIAL",
    193: "GALLERY.3D.AREA",
    194: "GALLERY.3D.COLUMN",
    195: "GALLERY.3D.LINE",
    196: "GALLERY.3D.PIE",
    197: "VIEW.3D",
    198: "GOAL.SEEK",
    199: "WORKGROUP",
    200: "FILL.GROUP",
    201: "UPDATE.LINK",
    202: "PROMOTE",
    203: "DEMOTE",
    204: "SHOW.DETAIL",
    206: "UNGROUP",
    207: "OBJECT.PROPERTIES",
    208: "SAVE.NEW.OBJECT",
    209: "SHARE",
    210: "SHARE.NAME",
    211: "DUPLICATE",
    212: "APPLY.STYLE",
    213: "ASSIGN.TO.OBJECT",
    214: "OBJECT.PROTECTION",
    215: "HIDE.OBJECT",
    216: "SET.EXTRACT",
    217: "CREATE.PUBLISHER",
    218: "SUBSCRIBE.TO",
    219: "ATTRIBUTES",
    220: "SHOW.TOOLBAR",
    222: "PRINT.PREVIEW",
    223: "EDIT.COLOR",
    224: "SHOW.LEVELS",
    225: "FORMAT.MAIN",
    226: "FORMAT.OVERLAY",
    227: "ON.RECALC",
    228: "EDIT.SERIES",
    229: "DEFINE.STYLE",
    240: "LINE.PRINT",
    243: "ENTER.DATA",
    249: "GALLERY.RADAR",
    250: "MERGE.STYLES",
    251: "EDITION.OPTIONS",
    252: "PASTE.PICTURE",
    253: "PASTE.PICTURE.LINK",
    254: "SPELLING",
    256: "ZOOM",
    259: "INSERT.OBJECT",
    260: "WINDOW.MINIMIZE",
    265: "SOUND.NOTE",
    266: "SOUND.PLAY",
    267: "FORMAT.SHAPE",
    268: "EXTEND.POLYGON",
    269: "FORMAT.AUTO",
    272: "GALLERY.3D.BAR",
    273: "GALLERY.3D.SURFACE",
    274: "FILL.AUTO",
    276: "CUSTOMIZE.TOOLBAR",
    277: "ADD.TOOL",
    278: "EDIT.OBJECT",
    279: "ON.DOUBLECLICK",
    280: "ON.ENTRY",
    281: "WORKBOOK.ADD",
    282: "WORKBOOK.MOVE",
    283: "WORKBOOK.COPY",
    284: "WORKBOOK.OPTIONS",
    285: "SAVE.WORKSPACE",
    288: "CHART.WIZARD",
    289: "DELETE.TOOL",
    290: "MOVE.TOOL",
    291: "WORKBOOK.SELECT",
    292: "WORKBOOK.ACTIVATE",
    293: "ASSIGN.TO.TOOL",
    295: "COPY.TOOL",
    296: "RESET.TOOL",
    297: "CONSTRAIN.NUMERIC",
    298: "PASTE.TOOL",
    302: "WORKBOOK.NEW",
    305: "SCENARIO.CELLS",
    306: "SCENARIO.DELETE",
    307: "SCENARIO.ADD",
    308: "SCENARIO.EDIT",
    309: "SCENARIO.SHOW",
    310: "SCENARIO.SHOW.NEXT",
    311: "SCENARIO.SUMMARY",
    312: "PIVOT.TABLE.WIZARD",
    313: "PIVOT.FIELD.PROPERTIES",
    314: "PIVOT.FIELD",
    315: "PIVOT.ITEM",
    316: "PIVOT.ADD.FIELDS",
    318: "OPTIONS.CALCULATION",
    319: "OPTIONS.EDIT",
    320: "OPTIONS.VIEW",
    321: "ADDIN.MANAGER",
    322: "MENU.EDITOR",
    323: "ATTACH.TOOLBARS",
    324: "VBAActivate",
    325: "OPTIONS.CHART",
    328: "VBA.INSERT.FILE",
    330: "VBA.PROCEDURE.DEFINITION",
    336: "ROUTING.SLIP",
    338: "ROUTE.DOCUMENT",
    339: "MAIL.LOGON",
    342: "INSERT.PICTURE",
    343: "EDIT.TOOL",
    344: "GALLERY.DOUGHNUT",
    350: "CHART.TREND",
    352: "PIVOT.ITEM.PROPERTIES",
    354: "WORKBOOK.INSERT",
    355: "OPTIONS.TRANSITION",
    356: "OPTIONS.GENERAL",
    370: "FILTER.ADVANCED",
    373: "MAIL.ADD.MAILER",
    374: "MAIL.DELETE.MAILER",
    375: "MAIL.REPLY",
    376: "MAIL.REPLY.ALL",
    377: "MAIL.FORWARD",
    378: "MAIL.NEXT.LETTER",
    379: "DATA.LABEL",
    380: "INSERT.TITLE",
    381: "FONT.PROPERTIES",
    382: "MACRO.OPTIONS",
    383: "WORKBOOK.HIDE",
    384: "WORKBOOK.UNHIDE",
    385: "WORKBOOK.DELETE",
    386: "WORKBOOK.NAME",
    388: "GALLERY.CUSTOM",
    390: "ADD.CHART.AUTOFORMAT",
    391: "DELETE.CHART.AUTOFORMAT",
    392: "CHART.ADD.DATA",
    393: "AUTO.OUTLINE",
    394: "TAB.ORDER",
    395: "SHOW.DIALOG",
    396: "SELECT.ALL",
    397: "UNGROUP.SHEETS",
    398: "SUBTOTAL.CREATE",
    399: "SUBTOTAL.REMOVE",
    400: "RENAME.OBJECT",
    412: "WORKBOOK.SCROLL",
    413: "WORKBOOK.NEXT",
    414: "WORKBOOK.PREV",
    415: "WORKBOOK.TAB.SPLIT",
    416: "FULL.SCREEN",
    417: "WORKBOOK.PROTECT",
    420: "SCROLLBAR.PROPERTIES",
    421: "PIVOT.SHOW.PAGES",
    422: "TEXT.TO.COLUMNS",
    423: "FORMAT.CHARTTYPE",
    424: "LINK.FORMAT",
    425: "TRACER.DISPLAY",
    430: "TRACER.NAVIGATE",
    431: "TRACER.CLEAR",
    432: "TRACER.ERROR",
    433: "PIVOT.FIELD.GROUP",
    434: "PIVOT.FIELD.UNGROUP",
    435: "CHECKBOX.PROPERTIES",
    436: "LABEL.PROPERTIES",
    437: "LISTBOX.PROPERTIES",
    438: "EDITBOX.PROPERTIES",
    439: "PIVOT.REFRESH",
    440: "LINK.COMBO",
    441: "OPEN.TEXT",
    442: "HIDE.DIALOG",
    443: "SET.DIALOG.FOCUS",
    444: "ENABLE.OBJECT",
    445: "PUSHBUTTON.PROPERTIES",
    446: "SET.DIALOG.DEFAULT",
    447: "FILTER",
    448: "FILTER.SHOW.ALL",
    449: "CLEAR.OUTLINE",
    450: "FUNCTION.WIZARD",
    451: "ADD.LIST.ITEM",
    452: "SET.LIST.ITEM",
    453: "REMOVE.LIST.ITEM",
    454: "SELECT.LIST.ITEM",
    455: "SET.CONTROL.VALUE",
    456: "SAVE.COPY.AS",
    458: "OPTIONS.LISTS.ADD",
    459: "OPTIONS.LISTS.DELETE",
    460: "SERIES.AXES",
    461: "SERIES.X",
    462: "SERIES.Y",
    463: "ERRORBAR.X",
    464: "ERRORBAR.Y",
    465: "FORMAT.CHART",
    466: "SERIES.ORDER",
    467: "MAIL.LOGOFF",
    468: "CLEAR.ROUTING.SLIP",
    469: "APP.ACTIVATE.MICROSOFT",
    470: "MAIL.EDIT.MAILER",
    471: "ON.SHEET",
    472: "STANDARD.WIDTH",
    473: "SCENARIO.MERGE",
    474: "SUMMARY.INFO",
    475: "FIND.FILE",
    476: "ACTIVE.CELL.FONT",
    477: "ENABLE.TIPWIZARD",
    478: "VBA.MAKE.ADDIN",
    480: "INSERTDATATABLE",
    481: "WORKGROUP.OPTIONS",
    482: "MAIL.SEND.MAILER",
    485: "AUTOCORRECT",
    489: "POST.DOCUMENT",
    491: "PICKLIST",
    493: "VIEW.SHOW",
    494: "VIEW.DEFINE",
    495: "VIEW.DELETE",
    509: "SHEET.BACKGROUND",
    510: "INSERT.MAP.OBJECT",
    511: "OPTIONS.MENONO",
    517: "MSOCHECKS",
    518: "NORMAL",
    519: "LAYOUT",
    520: "RM.PRINT.AREA",
    521: "CLEAR.PRINT.AREA",
    522: "ADD.PRINT.AREA",
    523: "MOVE.BRK",
    545: "HIDECURR.NOTE",
    546: "HIDEALL.NOTES",
    547: "DELETE.NOTE",
    548: "TRAVERSE.NOTES",
    549: "ACTIVATE.NOTES",
    620: "PROTECT.REVISIONS",
    621: "UNPROTECT.REVISIONS",
    647: "OPTIONS.ME",
    653: "WEB.PUBLISH",
    667: "NEWWEBQUERY",
    673: "PIVOT.TABLE.CHART",
    753: "OPTIONS.SAVE",
    755: "OPTIONS.SPELL",
    808: "HIDEALL.INKANNOTS"
};
var Ftab = {
    0: "COUNT",
    1: "IF",
    2: "ISNA",
    3: "ISERROR",
    4: "SUM",
    5: "AVERAGE",
    6: "MIN",
    7: "MAX",
    8: "ROW",
    9: "COLUMN",
    10: "NA",
    11: "NPV",
    12: "STDEV",
    13: "DOLLAR",
    14: "FIXED",
    15: "SIN",
    16: "COS",
    17: "TAN",
    18: "ATAN",
    19: "PI",
    20: "SQRT",
    21: "EXP",
    22: "LN",
    23: "LOG10",
    24: "ABS",
    25: "INT",
    26: "SIGN",
    27: "ROUND",
    28: "LOOKUP",
    29: "INDEX",
    30: "REPT",
    31: "MID",
    32: "LEN",
    33: "VALUE",
    34: "TRUE",
    35: "FALSE",
    36: "AND",
    37: "OR",
    38: "NOT",
    39: "MOD",
    40: "DCOUNT",
    41: "DSUM",
    42: "DAVERAGE",
    43: "DMIN",
    44: "DMAX",
    45: "DSTDEV",
    46: "VAR",
    47: "DVAR",
    48: "TEXT",
    49: "LINEST",
    50: "TREND",
    51: "LOGEST",
    52: "GROWTH",
    53: "GOTO",
    54: "HALT",
    55: "RETURN",
    56: "PV",
    57: "FV",
    58: "NPER",
    59: "PMT",
    60: "RATE",
    61: "MIRR",
    62: "IRR",
    63: "RAND",
    64: "MATCH",
    65: "DATE",
    66: "TIME",
    67: "DAY",
    68: "MONTH",
    69: "YEAR",
    70: "WEEKDAY",
    71: "HOUR",
    72: "MINUTE",
    73: "SECOND",
    74: "NOW",
    75: "AREAS",
    76: "ROWS",
    77: "COLUMNS",
    78: "OFFSET",
    79: "ABSREF",
    80: "RELREF",
    81: "ARGUMENT",
    82: "SEARCH",
    83: "TRANSPOSE",
    84: "ERROR",
    85: "STEP",
    86: "TYPE",
    87: "ECHO",
    88: "SET.NAME",
    89: "CALLER",
    90: "DEREF",
    91: "WINDOWS",
    92: "SERIES",
    93: "DOCUMENTS",
    94: "ACTIVE.CELL",
    95: "SELECTION",
    96: "RESULT",
    97: "ATAN2",
    98: "ASIN",
    99: "ACOS",
    100: "CHOOSE",
    101: "HLOOKUP",
    102: "VLOOKUP",
    103: "LINKS",
    104: "INPUT",
    105: "ISREF",
    106: "GET.FORMULA",
    107: "GET.NAME",
    108: "SET.VALUE",
    109: "LOG",
    110: "EXEC",
    111: "CHAR",
    112: "LOWER",
    113: "UPPER",
    114: "PROPER",
    115: "LEFT",
    116: "RIGHT",
    117: "EXACT",
    118: "TRIM",
    119: "REPLACE",
    120: "SUBSTITUTE",
    121: "CODE",
    122: "NAMES",
    123: "DIRECTORY",
    124: "FIND",
    125: "CELL",
    126: "ISERR",
    127: "ISTEXT",
    128: "ISNUMBER",
    129: "ISBLANK",
    130: "T",
    131: "N",
    132: "FOPEN",
    133: "FCLOSE",
    134: "FSIZE",
    135: "FREADLN",
    136: "FREAD",
    137: "FWRITELN",
    138: "FWRITE",
    139: "FPOS",
    140: "DATEVALUE",
    141: "TIMEVALUE",
    142: "SLN",
    143: "SYD",
    144: "DDB",
    145: "GET.DEF",
    146: "REFTEXT",
    147: "TEXTREF",
    148: "INDIRECT",
    149: "REGISTER",
    150: "CALL",
    151: "ADD.BAR",
    152: "ADD.MENU",
    153: "ADD.COMMAND",
    154: "ENABLE.COMMAND",
    155: "CHECK.COMMAND",
    156: "RENAME.COMMAND",
    157: "SHOW.BAR",
    158: "DELETE.MENU",
    159: "DELETE.COMMAND",
    160: "GET.CHART.ITEM",
    161: "DIALOG.BOX",
    162: "CLEAN",
    163: "MDETERM",
    164: "MINVERSE",
    165: "MMULT",
    166: "FILES",
    167: "IPMT",
    168: "PPMT",
    169: "COUNTA",
    170: "CANCEL.KEY",
    171: "FOR",
    172: "WHILE",
    173: "BREAK",
    174: "NEXT",
    175: "INITIATE",
    176: "REQUEST",
    177: "POKE",
    178: "EXECUTE",
    179: "TERMINATE",
    180: "RESTART",
    181: "HELP",
    182: "GET.BAR",
    183: "PRODUCT",
    184: "FACT",
    185: "GET.CELL",
    186: "GET.WORKSPACE",
    187: "GET.WINDOW",
    188: "GET.DOCUMENT",
    189: "DPRODUCT",
    190: "ISNONTEXT",
    191: "GET.NOTE",
    192: "NOTE",
    193: "STDEVP",
    194: "VARP",
    195: "DSTDEVP",
    196: "DVARP",
    197: "TRUNC",
    198: "ISLOGICAL",
    199: "DCOUNTA",
    200: "DELETE.BAR",
    201: "UNREGISTER",
    204: "USDOLLAR",
    205: "FINDB",
    206: "SEARCHB",
    207: "REPLACEB",
    208: "LEFTB",
    209: "RIGHTB",
    210: "MIDB",
    211: "LENB",
    212: "ROUNDUP",
    213: "ROUNDDOWN",
    214: "ASC",
    215: "DBCS",
    216: "RANK",
    219: "ADDRESS",
    220: "DAYS360",
    221: "TODAY",
    222: "VDB",
    223: "ELSE",
    224: "ELSE.IF",
    225: "END.IF",
    226: "FOR.CELL",
    227: "MEDIAN",
    228: "SUMPRODUCT",
    229: "SINH",
    230: "COSH",
    231: "TANH",
    232: "ASINH",
    233: "ACOSH",
    234: "ATANH",
    235: "DGET",
    236: "CREATE.OBJECT",
    237: "VOLATILE",
    238: "LAST.ERROR",
    239: "CUSTOM.UNDO",
    240: "CUSTOM.REPEAT",
    241: "FORMULA.CONVERT",
    242: "GET.LINK.INFO",
    243: "TEXT.BOX",
    244: "INFO",
    245: "GROUP",
    246: "GET.OBJECT",
    247: "DB",
    248: "PAUSE",
    251: "RESUME",
    252: "FREQUENCY",
    253: "ADD.TOOLBAR",
    254: "DELETE.TOOLBAR",
    255: "User",
    256: "RESET.TOOLBAR",
    257: "EVALUATE",
    258: "GET.TOOLBAR",
    259: "GET.TOOL",
    260: "SPELLING.CHECK",
    261: "ERROR.TYPE",
    262: "APP.TITLE",
    263: "WINDOW.TITLE",
    264: "SAVE.TOOLBAR",
    265: "ENABLE.TOOL",
    266: "PRESS.TOOL",
    267: "REGISTER.ID",
    268: "GET.WORKBOOK",
    269: "AVEDEV",
    270: "BETADIST",
    271: "GAMMALN",
    272: "BETAINV",
    273: "BINOMDIST",
    274: "CHIDIST",
    275: "CHIINV",
    276: "COMBIN",
    277: "CONFIDENCE",
    278: "CRITBINOM",
    279: "EVEN",
    280: "EXPONDIST",
    281: "FDIST",
    282: "FINV",
    283: "FISHER",
    284: "FISHERINV",
    285: "FLOOR",
    286: "GAMMADIST",
    287: "GAMMAINV",
    288: "CEILING",
    289: "HYPGEOMDIST",
    290: "LOGNORMDIST",
    291: "LOGINV",
    292: "NEGBINOMDIST",
    293: "NORMDIST",
    294: "NORMSDIST",
    295: "NORMINV",
    296: "NORMSINV",
    297: "STANDARDIZE",
    298: "ODD",
    299: "PERMUT",
    300: "POISSON",
    301: "TDIST",
    302: "WEIBULL",
    303: "SUMXMY2",
    304: "SUMX2MY2",
    305: "SUMX2PY2",
    306: "CHITEST",
    307: "CORREL",
    308: "COVAR",
    309: "FORECAST",
    310: "FTEST",
    311: "INTERCEPT",
    312: "PEARSON",
    313: "RSQ",
    314: "STEYX",
    315: "SLOPE",
    316: "TTEST",
    317: "PROB",
    318: "DEVSQ",
    319: "GEOMEAN",
    320: "HARMEAN",
    321: "SUMSQ",
    322: "KURT",
    323: "SKEW",
    324: "ZTEST",
    325: "LARGE",
    326: "SMALL",
    327: "QUARTILE",
    328: "PERCENTILE",
    329: "PERCENTRANK",
    330: "MODE",
    331: "TRIMMEAN",
    332: "TINV",
    334: "MOVIE.COMMAND",
    335: "GET.MOVIE",
    336: "CONCATENATE",
    337: "POWER",
    338: "PIVOT.ADD.DATA",
    339: "GET.PIVOT.TABLE",
    340: "GET.PIVOT.FIELD",
    341: "GET.PIVOT.ITEM",
    342: "RADIANS",
    343: "DEGREES",
    344: "SUBTOTAL",
    345: "SUMIF",
    346: "COUNTIF",
    347: "COUNTBLANK",
    348: "SCENARIO.GET",
    349: "OPTIONS.LISTS.GET",
    350: "ISPMT",
    351: "DATEDIF",
    352: "DATESTRING",
    353: "NUMBERSTRING",
    354: "ROMAN",
    355: "OPEN.DIALOG",
    356: "SAVE.DIALOG",
    357: "VIEW.GET",
    358: "GETPIVOTDATA",
    359: "HYPERLINK",
    360: "PHONETIC",
    361: "AVERAGEA",
    362: "MAXA",
    363: "MINA",
    364: "STDEVPA",
    365: "VARPA",
    366: "STDEVA",
    367: "VARA",
    368: "BAHTTEXT",
    369: "THAIDAYOFWEEK",
    370: "THAIDIGIT",
    371: "THAIMONTHOFYEAR",
    372: "THAINUMSOUND",
    373: "THAINUMSTRING",
    374: "THAISTRINGLENGTH",
    375: "ISTHAIDIGIT",
    376: "ROUNDBAHTDOWN",
    377: "ROUNDBAHTUP",
    378: "THAIYEAR",
    379: "RTD",
    380: "CUBEVALUE",
    381: "CUBEMEMBER",
    382: "CUBEMEMBERPROPERTY",
    383: "CUBERANKEDMEMBER",
    384: "HEX2BIN",
    385: "HEX2DEC",
    386: "HEX2OCT",
    387: "DEC2BIN",
    388: "DEC2HEX",
    389: "DEC2OCT",
    390: "OCT2BIN",
    391: "OCT2HEX",
    392: "OCT2DEC",
    393: "BIN2DEC",
    394: "BIN2OCT",
    395: "BIN2HEX",
    396: "IMSUB",
    397: "IMDIV",
    398: "IMPOWER",
    399: "IMABS",
    400: "IMSQRT",
    401: "IMLN",
    402: "IMLOG2",
    403: "IMLOG10",
    404: "IMSIN",
    405: "IMCOS",
    406: "IMEXP",
    407: "IMARGUMENT",
    408: "IMCONJUGATE",
    409: "IMAGINARY",
    410: "IMREAL",
    411: "COMPLEX",
    412: "IMSUM",
    413: "IMPRODUCT",
    414: "SERIESSUM",
    415: "FACTDOUBLE",
    416: "SQRTPI",
    417: "QUOTIENT",
    418: "DELTA",
    419: "GESTEP",
    420: "ISEVEN",
    421: "ISODD",
    422: "MROUND",
    423: "ERF",
    424: "ERFC",
    425: "BESSELJ",
    426: "BESSELK",
    427: "BESSELY",
    428: "BESSELI",
    429: "XIRR",
    430: "XNPV",
    431: "PRICEMAT",
    432: "YIELDMAT",
    433: "INTRATE",
    434: "RECEIVED",
    435: "DISC",
    436: "PRICEDISC",
    437: "YIELDDISC",
    438: "TBILLEQ",
    439: "TBILLPRICE",
    440: "TBILLYIELD",
    441: "PRICE",
    442: "YIELD",
    443: "DOLLARDE",
    444: "DOLLARFR",
    445: "NOMINAL",
    446: "EFFECT",
    447: "CUMPRINC",
    448: "CUMIPMT",
    449: "EDATE",
    450: "EOMONTH",
    451: "YEARFRAC",
    452: "COUPDAYBS",
    453: "COUPDAYS",
    454: "COUPDAYSNC",
    455: "COUPNCD",
    456: "COUPNUM",
    457: "COUPPCD",
    458: "DURATION",
    459: "MDURATION",
    460: "ODDLPRICE",
    461: "ODDLYIELD",
    462: "ODDFPRICE",
    463: "ODDFYIELD",
    464: "RANDBETWEEN",
    465: "WEEKNUM",
    466: "AMORDEGRC",
    467: "AMORLINC",
    468: "CONVERT",
    724: "SHEETJS",
    469: "ACCRINT",
    470: "ACCRINTM",
    471: "WORKDAY",
    472: "NETWORKDAYS",
    473: "GCD",
    474: "MULTINOMIAL",
    475: "LCM",
    476: "FVSCHEDULE",
    477: "CUBEKPIMEMBER",
    478: "CUBESET",
    479: "CUBESETCOUNT",
    480: "IFERROR",
    481: "COUNTIFS",
    482: "SUMIFS",
    483: "AVERAGEIF",
    484: "AVERAGEIFS"
};
var FtabArgc = {
    2: 1,
    3: 1,
    10: 0,
    15: 1,
    16: 1,
    17: 1,
    18: 1,
    19: 0,
    20: 1,
    21: 1,
    22: 1,
    23: 1,
    24: 1,
    25: 1,
    26: 1,
    27: 2,
    30: 2,
    31: 3,
    32: 1,
    33: 1,
    34: 0,
    35: 0,
    38: 1,
    39: 2,
    40: 3,
    41: 3,
    42: 3,
    43: 3,
    44: 3,
    45: 3,
    47: 3,
    48: 2,
    53: 1,
    61: 3,
    63: 0,
    65: 3,
    66: 3,
    67: 1,
    68: 1,
    69: 1,
    70: 1,
    71: 1,
    72: 1,
    73: 1,
    74: 0,
    75: 1,
    76: 1,
    77: 1,
    79: 2,
    80: 2,
    83: 1,
    85: 0,
    86: 1,
    89: 0,
    90: 1,
    94: 0,
    95: 0,
    97: 2,
    98: 1,
    99: 1,
    101: 3,
    102: 3,
    105: 1,
    106: 1,
    108: 2,
    111: 1,
    112: 1,
    113: 1,
    114: 1,
    117: 2,
    118: 1,
    119: 4,
    121: 1,
    126: 1,
    127: 1,
    128: 1,
    129: 1,
    130: 1,
    131: 1,
    133: 1,
    134: 1,
    135: 1,
    136: 2,
    137: 2,
    138: 2,
    140: 1,
    141: 1,
    142: 3,
    143: 4,
    144: 4,
    161: 1,
    162: 1,
    163: 1,
    164: 1,
    165: 2,
    172: 1,
    175: 2,
    176: 2,
    177: 3,
    178: 2,
    179: 1,
    184: 1,
    186: 1,
    189: 3,
    190: 1,
    195: 3,
    196: 3,
    197: 1,
    198: 1,
    199: 3,
    201: 1,
    207: 4,
    210: 3,
    211: 1,
    212: 2,
    213: 2,
    214: 1,
    215: 1,
    225: 0,
    229: 1,
    230: 1,
    231: 1,
    232: 1,
    233: 1,
    234: 1,
    235: 3,
    244: 1,
    247: 4,
    252: 2,
    257: 1,
    261: 1,
    271: 1,
    273: 4,
    274: 2,
    275: 2,
    276: 2,
    277: 3,
    278: 3,
    279: 1,
    280: 3,
    281: 3,
    282: 3,
    283: 1,
    284: 1,
    285: 2,
    286: 4,
    287: 3,
    288: 2,
    289: 4,
    290: 3,
    291: 3,
    292: 3,
    293: 4,
    294: 1,
    295: 3,
    296: 1,
    297: 3,
    298: 1,
    299: 2,
    300: 3,
    301: 3,
    302: 4,
    303: 2,
    304: 2,
    305: 2,
    306: 2,
    307: 2,
    308: 2,
    309: 3,
    310: 2,
    311: 2,
    312: 2,
    313: 2,
    314: 2,
    315: 2,
    316: 4,
    325: 2,
    326: 2,
    327: 2,
    328: 2,
    331: 2,
    332: 2,
    337: 2,
    342: 1,
    343: 1,
    346: 2,
    347: 1,
    350: 4,
    351: 3,
    352: 1,
    353: 2,
    360: 1,
    368: 1,
    369: 1,
    370: 1,
    371: 1,
    372: 1,
    373: 1,
    374: 1,
    375: 1,
    376: 1,
    377: 1,
    378: 1,
    382: 3,
    385: 1,
    392: 1,
    393: 1,
    396: 2,
    397: 2,
    398: 2,
    399: 1,
    400: 1,
    401: 1,
    402: 1,
    403: 1,
    404: 1,
    405: 1,
    406: 1,
    407: 1,
    408: 1,
    409: 1,
    410: 1,
    414: 4,
    415: 1,
    416: 1,
    417: 2,
    420: 1,
    421: 1,
    422: 2,
    424: 1,
    425: 2,
    426: 2,
    427: 2,
    428: 2,
    430: 3,
    438: 3,
    439: 3,
    440: 3,
    443: 2,
    444: 2,
    445: 2,
    446: 2,
    447: 6,
    448: 6,
    449: 2,
    450: 2,
    464: 2,
    468: 3,
    476: 2,
    479: 1,
    480: 2,
    65535: 0
};
/* Part 3 TODO: actually parse formulae */ function ods_to_csf_formula(f /*:string*/ ) /*:string*/ {
    if (f.slice(0, 3) == "of:") f = f.slice(3);
    /* 5.2 Basic Expressions */ if (f.charCodeAt(0) == 61) {
        f = f.slice(1);
        if (f.charCodeAt(0) == 61) f = f.slice(1);
    }
    f = f.replace(/COM\.MICROSOFT\./g, "");
    /* Part 3 Section 5.8 References */ f = f.replace(/\[((?:\.[A-Z]+[0-9]+)(?::\.[A-Z]+[0-9]+)?)\]/g, function($$, $1) {
        return $1.replace(/\./g, "");
    });
    /* TODO: something other than this */ f = f.replace(/\[.(#[A-Z]*[?!])\]/g, "$1");
    return f.replace(/[;~]/g, ",").replace(/\|/g, ";");
}
function csf_to_ods_formula(f /*:string*/ ) /*:string*/ {
    var o = "of:=" + f.replace(crefregex, "$1[.$2$3$4$5]").replace(/\]:\[/g, ":");
    /* TODO: something other than this */ return o.replace(/;/g, "|").replace(/,/g, ";");
}
function ods_to_csf_3D(r /*:string*/ ) /*:[string, string]*/ {
    var a = r.split(":");
    var s = a[0].split(".")[0];
    return [
        s,
        a[0].split(".")[1] + (a.length > 1 ? ":" + (a[1].split(".")[1] || a[1].split(".")[0]) : "")
    ];
}
function csf_to_ods_3D(r /*:string*/ ) /*:string*/ {
    return r.replace(/\./, "!");
}
var strs = {}; // shared strings
var _ssfopts = {}; // spreadsheet formatting options
/*global Map */ var browser_has_Map = typeof Map !== "undefined";
function get_sst_id(sst /*:SST*/ , str /*:string*/ , rev) /*:number*/ {
    var i = 0, len = sst.length;
    if (rev) {
        if (browser_has_Map ? rev.has(str) : Object.prototype.hasOwnProperty.call(rev, str)) {
            var revarr = browser_has_Map ? rev.get(str) : rev[str];
            for(; i < revarr.length; ++i)if (sst[revarr[i]].t === str) {
                sst.Count++;
                return revarr[i];
            }
        }
    } else for(; i < len; ++i)if (sst[i].t === str) {
        sst.Count++;
        return i;
    }
    sst[len] = {
        t: str
    } /*:any*/ ;
    sst.Count++;
    sst.Unique++;
    if (rev) {
        if (browser_has_Map) {
            if (!rev.has(str)) rev.set(str, []);
            rev.get(str).push(len);
        } else {
            if (!Object.prototype.hasOwnProperty.call(rev, str)) rev[str] = [];
            rev[str].push(len);
        }
    }
    return len;
}
function col_obj_w(C /*:number*/ , col) {
    var p = {
        min: C + 1,
        max: C + 1
    } /*:any*/ ;
    /* wch (chars), wpx (pixels) */ var wch = -1;
    if (col.MDW) MDW = col.MDW;
    if (col.width != null) p.customWidth = 1;
    else if (col.wpx != null) wch = px2char(col.wpx);
    else if (col.wch != null) wch = col.wch;
    if (wch > -1) {
        p.width = char2width(wch);
        p.customWidth = 1;
    } else if (col.width != null) p.width = col.width;
    if (col.hidden) p.hidden = true;
    if (col.level != null) p.outlineLevel = p.level = col.level;
    return p;
}
function default_margins(margins /*:Margins*/ , mode /*:?string*/ ) {
    if (!margins) return;
    var defs = [
        0.7,
        0.7,
        0.75,
        0.75,
        0.3,
        0.3
    ];
    if (mode == "xlml") defs = [
        1,
        1,
        1,
        1,
        0.5,
        0.5
    ];
    if (margins.left == null) margins.left = defs[0];
    if (margins.right == null) margins.right = defs[1];
    if (margins.top == null) margins.top = defs[2];
    if (margins.bottom == null) margins.bottom = defs[3];
    if (margins.header == null) margins.header = defs[4];
    if (margins.footer == null) margins.footer = defs[5];
}
function get_cell_style(styles /*:Array<any>*/ , cell /*:Cell*/ , opts) {
    var z = opts.revssf[cell.z != null ? cell.z : "General"];
    var i = 0x3c, len = styles.length;
    if (z == null && opts.ssf) {
        for(; i < 0x188; ++i)if (opts.ssf[i] == null) {
            SSF_load(cell.z, i);
            // $FlowIgnore
            opts.ssf[i] = cell.z;
            opts.revssf[cell.z] = z = i;
            break;
        }
    }
    for(i = 0; i != len; ++i)if (styles[i].numFmtId === z) return i;
    styles[len] = {
        numFmtId: z,
        fontId: 0,
        fillId: 0,
        borderId: 0,
        xfId: 0,
        applyNumberFormat: 1
    };
    return len;
}
function safe_format(p /*:Cell*/ , fmtid /*:number*/ , fillid /*:?number*/ , opts, themes, styles) {
    try {
        if (opts.cellNF) p.z = table_fmt[fmtid];
    } catch (e) {
        if (opts.WTF) throw e;
    }
    if (p.t === "z" && !opts.cellStyles) return;
    if (p.t === "d" && typeof p.v === "string") p.v = parseDate(p.v);
    if ((!opts || opts.cellText !== false) && p.t !== "z") try {
        if (table_fmt[fmtid] == null) SSF_load(SSFImplicit[fmtid] || "General", fmtid);
        if (p.t === "e") p.w = p.w || BErr[p.v];
        else if (fmtid === 0) {
            if (p.t === "n") {
                if ((p.v | 0) === p.v) p.w = p.v.toString(10);
                else p.w = SSF_general_num(p.v);
            } else if (p.t === "d") {
                var dd = datenum(p.v);
                if ((dd | 0) === dd) p.w = dd.toString(10);
                else p.w = SSF_general_num(dd);
            } else if (p.v === undefined) return "";
            else p.w = SSF_general(p.v, _ssfopts);
        } else if (p.t === "d") p.w = SSF_format(fmtid, datenum(p.v), _ssfopts);
        else p.w = SSF_format(fmtid, p.v, _ssfopts);
    } catch (e) {
        if (opts.WTF) throw e;
    }
    if (!opts.cellStyles) return;
    if (fillid != null) try {
        p.s = styles.Fills[fillid];
        if (p.s.fgColor && p.s.fgColor.theme && !p.s.fgColor.rgb) {
            p.s.fgColor.rgb = rgb_tint(themes.themeElements.clrScheme[p.s.fgColor.theme].rgb, p.s.fgColor.tint || 0);
            if (opts.WTF) p.s.fgColor.raw_rgb = themes.themeElements.clrScheme[p.s.fgColor.theme].rgb;
        }
        if (p.s.bgColor && p.s.bgColor.theme) {
            p.s.bgColor.rgb = rgb_tint(themes.themeElements.clrScheme[p.s.bgColor.theme].rgb, p.s.bgColor.tint || 0);
            if (opts.WTF) p.s.bgColor.raw_rgb = themes.themeElements.clrScheme[p.s.bgColor.theme].rgb;
        }
    } catch (e) {
        if (opts.WTF && styles.Fills) throw e;
    }
}
function check_ws(ws /*:Worksheet*/ , sname /*:string*/ , i /*:number*/ ) {
    if (ws && ws["!ref"]) {
        var range = safe_decode_range(ws["!ref"]);
        if (range.e.c < range.s.c || range.e.r < range.s.r) throw new Error("Bad range (" + i + "): " + ws["!ref"]);
    }
}
function parse_ws_xml_dim(ws /*:Worksheet*/ , s /*:string*/ ) {
    var d = safe_decode_range(s);
    if (d.s.r <= d.e.r && d.s.c <= d.e.c && d.s.r >= 0 && d.s.c >= 0) ws["!ref"] = encode_range(d);
}
var mergecregex = /<(?:\w:)?mergeCell ref="[A-Z0-9:]+"\s*[\/]?>/g;
var sheetdataregex = /<(?:\w+:)?sheetData[^>]*>([\s\S]*)<\/(?:\w+:)?sheetData>/;
var hlinkregex = /<(?:\w:)?hyperlink [^>]*>/mg;
var dimregex = /"(\w*:\w*)"/;
var colregex = /<(?:\w:)?col\b[^>]*[\/]?>/g;
var afregex = /<(?:\w:)?autoFilter[^>]*([\/]|>([\s\S]*)<\/(?:\w:)?autoFilter)>/g;
var marginregex = /<(?:\w:)?pageMargins[^>]*\/>/g;
var sheetprregex = /<(?:\w:)?sheetPr\b(?:[^>a-z][^>]*)?\/>/;
var sheetprregex2 = /<(?:\w:)?sheetPr[^>]*(?:[\/]|>([\s\S]*)<\/(?:\w:)?sheetPr)>/;
var svsregex = /<(?:\w:)?sheetViews[^>]*(?:[\/]|>([\s\S]*)<\/(?:\w:)?sheetViews)>/;
/* 18.3 Worksheets */ function parse_ws_xml(data /*:?string*/ , opts, idx /*:number*/ , rels, wb /*:WBWBProps*/ , themes, styles) /*:Worksheet*/ {
    if (!data) return data;
    if (!rels) rels = {
        "!id": {}
    };
    if (DENSE != null && opts.dense == null) opts.dense = DENSE;
    /* 18.3.1.99 worksheet CT_Worksheet */ var s = opts.dense ? [] : {} /*:any*/ ;
    var refguess /*:Range*/  = {
        s: {
            r: 2000000,
            c: 2000000
        },
        e: {
            r: 0,
            c: 0
        }
    } /*:any*/ ;
    var data1 = "", data2 = "";
    var mtch /*:?any*/  = data.match(sheetdataregex);
    if (mtch) {
        data1 = data.slice(0, mtch.index);
        data2 = data.slice(mtch.index + mtch[0].length);
    } else data1 = data2 = data;
    /* 18.3.1.82 sheetPr CT_SheetPr */ var sheetPr = data1.match(sheetprregex);
    if (sheetPr) parse_ws_xml_sheetpr(sheetPr[0], s, wb, idx);
    else if (sheetPr = data1.match(sheetprregex2)) parse_ws_xml_sheetpr2(sheetPr[0], sheetPr[1] || "", s, wb, idx, styles, themes);
    /* 18.3.1.35 dimension CT_SheetDimension */ var ridx = (data1.match(/<(?:\w*:)?dimension/) || {
        index: -1
    }).index;
    if (ridx > 0) {
        var ref = data1.slice(ridx, ridx + 50).match(dimregex);
        if (ref) parse_ws_xml_dim(s, ref[1]);
    }
    /* 18.3.1.88 sheetViews CT_SheetViews */ var svs = data1.match(svsregex);
    if (svs && svs[1]) parse_ws_xml_sheetviews(svs[1], wb);
    /* 18.3.1.17 cols CT_Cols */ var columns /*:Array<ColInfo>*/  = [];
    if (opts.cellStyles) {
        /* 18.3.1.13 col CT_Col */ var cols = data1.match(colregex);
        if (cols) parse_ws_xml_cols(columns, cols);
    }
    /* 18.3.1.80 sheetData CT_SheetData ? */ if (mtch) parse_ws_xml_data(mtch[1], s, opts, refguess, themes, styles);
    /* 18.3.1.2  autoFilter CT_AutoFilter */ var afilter = data2.match(afregex);
    if (afilter) s["!autofilter"] = parse_ws_xml_autofilter(afilter[0]);
    /* 18.3.1.55 mergeCells CT_MergeCells */ var merges /*:Array<Range>*/  = [];
    var _merge = data2.match(mergecregex);
    if (_merge) for(ridx = 0; ridx != _merge.length; ++ridx)merges[ridx] = safe_decode_range(_merge[ridx].slice(_merge[ridx].indexOf('"') + 1));
    /* 18.3.1.48 hyperlinks CT_Hyperlinks */ var hlink = data2.match(hlinkregex);
    if (hlink) parse_ws_xml_hlinks(s, hlink, rels);
    /* 18.3.1.62 pageMargins CT_PageMargins */ var margins = data2.match(marginregex);
    if (margins) s["!margins"] = parse_ws_xml_margins(parsexmltag(margins[0]));
    if (!s["!ref"] && refguess.e.c >= refguess.s.c && refguess.e.r >= refguess.s.r) s["!ref"] = encode_range(refguess);
    if (opts.sheetRows > 0 && s["!ref"]) {
        var tmpref = safe_decode_range(s["!ref"]);
        if (opts.sheetRows <= +tmpref.e.r) {
            tmpref.e.r = opts.sheetRows - 1;
            if (tmpref.e.r > refguess.e.r) tmpref.e.r = refguess.e.r;
            if (tmpref.e.r < tmpref.s.r) tmpref.s.r = tmpref.e.r;
            if (tmpref.e.c > refguess.e.c) tmpref.e.c = refguess.e.c;
            if (tmpref.e.c < tmpref.s.c) tmpref.s.c = tmpref.e.c;
            s["!fullref"] = s["!ref"];
            s["!ref"] = encode_range(tmpref);
        }
    }
    if (columns.length > 0) s["!cols"] = columns;
    if (merges.length > 0) s["!merges"] = merges;
    return s;
}
function write_ws_xml_merges(merges /*:Array<Range>*/ ) /*:string*/ {
    if (merges.length === 0) return "";
    var o = '<mergeCells count="' + merges.length + '">';
    for(var i = 0; i != merges.length; ++i)o += '<mergeCell ref="' + encode_range(merges[i]) + '"/>';
    return o + "</mergeCells>";
}
/* 18.3.1.82-3 sheetPr CT_ChartsheetPr / CT_SheetPr */ function parse_ws_xml_sheetpr(sheetPr /*:string*/ , s, wb /*:WBWBProps*/ , idx /*:number*/ ) {
    var data = parsexmltag(sheetPr);
    if (!wb.Sheets[idx]) wb.Sheets[idx] = {};
    if (data.codeName) wb.Sheets[idx].CodeName = unescapexml(utf8read(data.codeName));
}
function parse_ws_xml_sheetpr2(sheetPr /*:string*/ , body /*:string*/ , s, wb /*:WBWBProps*/ , idx /*:number*/ ) {
    parse_ws_xml_sheetpr(sheetPr.slice(0, sheetPr.indexOf(">")), s, wb, idx);
}
function write_ws_xml_sheetpr(ws, wb, idx, opts, o) {
    var needed = false;
    var props = {}, payload = null;
    if (opts.bookType !== "xlsx" && wb.vbaraw) {
        var cname = wb.SheetNames[idx];
        try {
            if (wb.Workbook) cname = wb.Workbook.Sheets[idx].CodeName || cname;
        } catch (e) {}
        needed = true;
        props.codeName = utf8write(escapexml(cname));
    }
    if (ws && ws["!outline"]) {
        var outlineprops = {
            summaryBelow: 1,
            summaryRight: 1
        };
        if (ws["!outline"].above) outlineprops.summaryBelow = 0;
        if (ws["!outline"].left) outlineprops.summaryRight = 0;
        payload = (payload || "") + writextag("outlinePr", null, outlineprops);
    }
    if (!needed && !payload) return;
    o[o.length] = writextag("sheetPr", payload, props);
}
/* 18.3.1.85 sheetProtection CT_SheetProtection */ var sheetprot_deffalse = [
    "objects",
    "scenarios",
    "selectLockedCells",
    "selectUnlockedCells"
];
var sheetprot_deftrue = [
    "formatColumns",
    "formatRows",
    "formatCells",
    "insertColumns",
    "insertRows",
    "insertHyperlinks",
    "deleteColumns",
    "deleteRows",
    "sort",
    "autoFilter",
    "pivotTables"
];
function write_ws_xml_protection(sp) /*:string*/ {
    // algorithmName, hashValue, saltValue, spinCount
    var o = {
        sheet: 1
    } /*:any*/ ;
    sheetprot_deffalse.forEach(function(n) {
        if (sp[n] != null && sp[n]) o[n] = "1";
    });
    sheetprot_deftrue.forEach(function(n) {
        if (sp[n] != null && !sp[n]) o[n] = "0";
    });
    /* TODO: algorithm */ if (sp.password) o.password = crypto_CreatePasswordVerifier_Method1(sp.password).toString(16).toUpperCase();
    return writextag("sheetProtection", null, o);
}
function parse_ws_xml_hlinks(s, data /*:Array<string>*/ , rels) {
    var dense = Array.isArray(s);
    for(var i = 0; i != data.length; ++i){
        var val = parsexmltag(utf8read(data[i]), true);
        if (!val.ref) return;
        var rel = ((rels || {})["!id"] || [])[val.id];
        if (rel) {
            val.Target = rel.Target;
            if (val.location) val.Target += "#" + unescapexml(val.location);
        } else {
            val.Target = "#" + unescapexml(val.location);
            rel = {
                Target: val.Target,
                TargetMode: "Internal"
            };
        }
        val.Rel = rel;
        if (val.tooltip) {
            val.Tooltip = val.tooltip;
            delete val.tooltip;
        }
        var rng = safe_decode_range(val.ref);
        for(var R = rng.s.r; R <= rng.e.r; ++R)for(var C = rng.s.c; C <= rng.e.c; ++C){
            var addr = encode_cell({
                c: C,
                r: R
            });
            if (dense) {
                if (!s[R]) s[R] = [];
                if (!s[R][C]) s[R][C] = {
                    t: "z",
                    v: undefined
                };
                s[R][C].l = val;
            } else {
                if (!s[addr]) s[addr] = {
                    t: "z",
                    v: undefined
                };
                s[addr].l = val;
            }
        }
    }
}
function parse_ws_xml_margins(margin) {
    var o = {};
    [
        "left",
        "right",
        "top",
        "bottom",
        "header",
        "footer"
    ].forEach(function(k) {
        if (margin[k]) o[k] = parseFloat(margin[k]);
    });
    return o;
}
function write_ws_xml_margins(margin) /*:string*/ {
    default_margins(margin);
    return writextag("pageMargins", null, margin);
}
function parse_ws_xml_cols(columns, cols) {
    var seencol = false;
    for(var coli = 0; coli != cols.length; ++coli){
        var coll = parsexmltag(cols[coli], true);
        if (coll.hidden) coll.hidden = parsexmlbool(coll.hidden);
        var colm = parseInt(coll.min, 10) - 1, colM = parseInt(coll.max, 10) - 1;
        if (coll.outlineLevel) coll.level = +coll.outlineLevel || 0;
        delete coll.min;
        delete coll.max;
        coll.width = +coll.width;
        if (!seencol && coll.width) {
            seencol = true;
            find_mdw_colw(coll.width);
        }
        process_col(coll);
        while(colm <= colM)columns[colm++] = dup(coll);
    }
}
function write_ws_xml_cols(ws, cols) /*:string*/ {
    var o = [
        "<cols>"
    ], col;
    for(var i = 0; i != cols.length; ++i){
        if (!(col = cols[i])) continue;
        o[o.length] = writextag("col", null, col_obj_w(i, col));
    }
    o[o.length] = "</cols>";
    return o.join("");
}
function parse_ws_xml_autofilter(data /*:string*/ ) {
    var o = {
        ref: (data.match(/ref="([^"]*)"/) || [])[1]
    };
    return o;
}
function write_ws_xml_autofilter(data, ws, wb, idx) /*:string*/ {
    var ref = typeof data.ref == "string" ? data.ref : encode_range(data.ref);
    if (!wb.Workbook) wb.Workbook = {
        Sheets: []
    } /*:any*/ ;
    if (!wb.Workbook.Names) wb.Workbook.Names = [];
    var names /*: Array<any> */  = wb.Workbook.Names;
    var range = decode_range(ref);
    if (range.s.r == range.e.r) {
        range.e.r = decode_range(ws["!ref"]).e.r;
        ref = encode_range(range);
    }
    for(var i = 0; i < names.length; ++i){
        var name = names[i];
        if (name.Name != "_xlnm._FilterDatabase") continue;
        if (name.Sheet != idx) continue;
        name.Ref = "'" + wb.SheetNames[idx] + "'!" + ref;
        break;
    }
    if (i == names.length) names.push({
        Name: "_xlnm._FilterDatabase",
        Sheet: idx,
        Ref: "'" + wb.SheetNames[idx] + "'!" + ref
    });
    return writextag("autoFilter", null, {
        ref: ref
    });
}
/* 18.3.1.88 sheetViews CT_SheetViews */ /* 18.3.1.87 sheetView CT_SheetView */ var sviewregex = /<(?:\w:)?sheetView(?:[^>a-z][^>]*)?\/?>/;
function parse_ws_xml_sheetviews(data, wb /*:WBWBProps*/ ) {
    if (!wb.Views) wb.Views = [
        {}
    ];
    (data.match(sviewregex) || []).forEach(function(r /*:string*/ , i /*:number*/ ) {
        var tag = parsexmltag(r);
        // $FlowIgnore
        if (!wb.Views[i]) wb.Views[i] = {};
        // $FlowIgnore
        if (+tag.zoomScale) wb.Views[i].zoom = +tag.zoomScale;
        // $FlowIgnore
        if (parsexmlbool(tag.rightToLeft)) wb.Views[i].RTL = true;
    });
}
function write_ws_xml_sheetviews(ws, opts, idx, wb) /*:string*/ {
    var sview = {
        workbookViewId: "0"
    } /*:any*/ ;
    // $FlowIgnore
    if ((((wb || {}).Workbook || {}).Views || [])[0]) sview.rightToLeft = wb.Workbook.Views[0].RTL ? "1" : "0";
    return writextag("sheetViews", writextag("sheetView", null, sview), {});
}
function write_ws_xml_cell(cell /*:Cell*/ , ref, ws, opts /*::, idx, wb*/ ) /*:string*/ {
    if (cell.c) ws["!comments"].push([
        ref,
        cell.c
    ]);
    if (cell.v === undefined && typeof cell.f !== "string" || cell.t === "z" && !cell.f) return "";
    var vv = "";
    var oldt = cell.t, oldv = cell.v;
    if (cell.t !== "z") switch(cell.t){
        case "b":
            vv = cell.v ? "1" : "0";
            break;
        case "n":
            vv = "" + cell.v;
            break;
        case "e":
            vv = BErr[cell.v];
            break;
        case "d":
            if (opts && opts.cellDates) vv = parseDate(cell.v, -1).toISOString();
            else {
                cell = dup(cell);
                cell.t = "n";
                vv = "" + (cell.v = datenum(parseDate(cell.v)));
            }
            if (typeof cell.z === "undefined") cell.z = table_fmt[14];
            break;
        default:
            vv = cell.v;
            break;
    }
    var v = writetag("v", escapexml(vv)), o = {
        r: ref
    } /*:any*/ ;
    /* TODO: cell style */ var os = get_cell_style(opts.cellXfs, cell, opts);
    if (os !== 0) o.s = os;
    switch(cell.t){
        case "n":
            break;
        case "d":
            o.t = "d";
            break;
        case "b":
            o.t = "b";
            break;
        case "e":
            o.t = "e";
            break;
        case "z":
            break;
        default:
            if (cell.v == null) {
                delete cell.t;
                break;
            }
            if (cell.v.length > 32767) throw new Error("Text length must not exceed 32767 characters");
            if (opts && opts.bookSST) {
                v = writetag("v", "" + get_sst_id(opts.Strings, cell.v, opts.revStrings));
                o.t = "s";
                break;
            }
            o.t = "str";
            break;
    }
    if (cell.t != oldt) {
        cell.t = oldt;
        cell.v = oldv;
    }
    if (typeof cell.f == "string" && cell.f) {
        var ff = cell.F && cell.F.slice(0, ref.length) == ref ? {
            t: "array",
            ref: cell.F
        } : null;
        v = writextag("f", escapexml(cell.f), ff) + (cell.v != null ? v : "");
    }
    if (cell.l) ws["!links"].push([
        ref,
        cell.l
    ]);
    if (cell.D) o.cm = 1;
    return writextag("c", v, o);
}
var parse_ws_xml_data = /*#__PURE__*/ function() {
    var cellregex = /<(?:\w+:)?c[ \/>]/, rowregex = /<\/(?:\w+:)?row>/;
    var rregex = /r=["']([^"']*)["']/, isregex = /<(?:\w+:)?is>([\S\s]*?)<\/(?:\w+:)?is>/;
    var refregex = /ref=["']([^"']*)["']/;
    var match_v = matchtag("v"), match_f = matchtag("f");
    return function parse_ws_xml_data(sdata /*:string*/ , s, opts, guess /*:Range*/ , themes, styles) {
        var ri = 0, x = "", cells /*:Array<string>*/  = [], cref /*:?Array<string>*/  = [], idx = 0, i = 0, cc = 0, d = "", p /*:any*/ ;
        var tag, tagr = 0, tagc = 0;
        var sstr, ftag;
        var fmtid = 0, fillid = 0;
        var do_format = Array.isArray(styles.CellXf), cf;
        var arrayf /*:Array<[Range, string]>*/  = [];
        var sharedf = [];
        var dense = Array.isArray(s);
        var rows /*:Array<RowInfo>*/  = [], rowobj = {}, rowrite = false;
        var sheetStubs = !!opts.sheetStubs;
        for(var marr = sdata.split(rowregex), mt = 0, marrlen = marr.length; mt != marrlen; ++mt){
            x = marr[mt].trim();
            var xlen = x.length;
            if (xlen === 0) continue;
            /* 18.3.1.73 row CT_Row */ var rstarti = 0;
            outa: for(ri = 0; ri < xlen; ++ri)switch(/*x.charCodeAt(ri)*/ x[ri]){
                case ">" /*62*/ :
                    if (/*x.charCodeAt(ri-1) != 47*/ x[ri - 1] != "/") {
                        ++ri;
                        break outa;
                    }
                    if (opts && opts.cellStyles) {
                        // TODO: avoid duplication
                        tag = parsexmltag(x.slice(rstarti, ri), true);
                        tagr = tag.r != null ? parseInt(tag.r, 10) : tagr + 1;
                        tagc = -1;
                        if (opts.sheetRows && opts.sheetRows < tagr) continue;
                        rowobj = {};
                        rowrite = false;
                        if (tag.ht) {
                            rowrite = true;
                            rowobj.hpt = parseFloat(tag.ht);
                            rowobj.hpx = pt2px(rowobj.hpt);
                        }
                        if (tag.hidden == "1") {
                            rowrite = true;
                            rowobj.hidden = true;
                        }
                        if (tag.outlineLevel != null) {
                            rowrite = true;
                            rowobj.level = +tag.outlineLevel;
                        }
                        if (rowrite) rows[tagr - 1] = rowobj;
                    }
                    break;
                case "<" /*60*/ :
                    rstarti = ri;
                    break;
            }
            if (rstarti >= ri) break;
            tag = parsexmltag(x.slice(rstarti, ri), true);
            tagr = tag.r != null ? parseInt(tag.r, 10) : tagr + 1;
            tagc = -1;
            if (opts.sheetRows && opts.sheetRows < tagr) continue;
            if (guess.s.r > tagr - 1) guess.s.r = tagr - 1;
            if (guess.e.r < tagr - 1) guess.e.r = tagr - 1;
            if (opts && opts.cellStyles) {
                rowobj = {};
                rowrite = false;
                if (tag.ht) {
                    rowrite = true;
                    rowobj.hpt = parseFloat(tag.ht);
                    rowobj.hpx = pt2px(rowobj.hpt);
                }
                if (tag.hidden == "1") {
                    rowrite = true;
                    rowobj.hidden = true;
                }
                if (tag.outlineLevel != null) {
                    rowrite = true;
                    rowobj.level = +tag.outlineLevel;
                }
                if (rowrite) rows[tagr - 1] = rowobj;
            }
            /* 18.3.1.4 c CT_Cell */ cells = x.slice(ri).split(cellregex);
            for(var rslice = 0; rslice != cells.length; ++rslice)if (cells[rslice].trim().charAt(0) != "<") break;
            cells = cells.slice(rslice);
            for(ri = 0; ri != cells.length; ++ri){
                x = cells[ri].trim();
                if (x.length === 0) continue;
                cref = x.match(rregex);
                idx = ri;
                i = 0;
                cc = 0;
                x = "<c " + (x.slice(0, 1) == "<" ? ">" : "") + x;
                if (cref != null && cref.length === 2) {
                    idx = 0;
                    d = cref[1];
                    for(i = 0; i != d.length; ++i){
                        if ((cc = d.charCodeAt(i) - 64) < 1 || cc > 26) break;
                        idx = 26 * idx + cc;
                    }
                    --idx;
                    tagc = idx;
                } else ++tagc;
                for(i = 0; i != x.length; ++i)if (x.charCodeAt(i) === 62) break;
                ++i;
                tag = parsexmltag(x.slice(0, i), true);
                if (!tag.r) tag.r = encode_cell({
                    r: tagr - 1,
                    c: tagc
                });
                d = x.slice(i);
                p = {
                    t: ""
                } /*:any*/ ;
                if ((cref = d.match(match_v)) != null && /*::cref != null && */ cref[1] !== "") p.v = unescapexml(cref[1]);
                if (opts.cellFormula) {
                    if ((cref = d.match(match_f)) != null && /*::cref != null && */ cref[1] !== "") {
                        /* TODO: match against XLSXFutureFunctions */ p.f = unescapexml(utf8read(cref[1])).replace(/\r\n/g, "\n");
                        if (!opts.xlfn) p.f = _xlfn(p.f);
                        if (/*::cref != null && cref[0] != null && */ cref[0].indexOf('t="array"') > -1) {
                            p.F = (d.match(refregex) || [])[1];
                            if (p.F.indexOf(":") > -1) arrayf.push([
                                safe_decode_range(p.F),
                                p.F
                            ]);
                        } else if (/*::cref != null && cref[0] != null && */ cref[0].indexOf('t="shared"') > -1) {
                            // TODO: parse formula
                            ftag = parsexmltag(cref[0]);
                            var ___f = unescapexml(utf8read(cref[1]));
                            if (!opts.xlfn) ___f = _xlfn(___f);
                            sharedf[parseInt(ftag.si, 10)] = [
                                ftag,
                                ___f,
                                tag.r
                            ];
                        }
                    } else if (cref = d.match(/<f[^>]*\/>/)) {
                        ftag = parsexmltag(cref[0]);
                        if (sharedf[ftag.si]) p.f = shift_formula_xlsx(sharedf[ftag.si][1], sharedf[ftag.si][2], tag.r);
                    }
                    /* TODO: factor out contains logic */ var _tag = decode_cell(tag.r);
                    for(i = 0; i < arrayf.length; ++i)if (_tag.r >= arrayf[i][0].s.r && _tag.r <= arrayf[i][0].e.r) {
                        if (_tag.c >= arrayf[i][0].s.c && _tag.c <= arrayf[i][0].e.c) p.F = arrayf[i][1];
                    }
                }
                if (tag.t == null && p.v === undefined) {
                    if (p.f || p.F) {
                        p.v = 0;
                        p.t = "n";
                    } else if (!sheetStubs) continue;
                    else p.t = "z";
                } else p.t = tag.t || "n";
                if (guess.s.c > tagc) guess.s.c = tagc;
                if (guess.e.c < tagc) guess.e.c = tagc;
                /* 18.18.11 t ST_CellType */ switch(p.t){
                    case "n":
                        if (p.v == "" || p.v == null) {
                            if (!sheetStubs) continue;
                            p.t = "z";
                        } else p.v = parseFloat(p.v);
                        break;
                    case "s":
                        if (typeof p.v == "undefined") {
                            if (!sheetStubs) continue;
                            p.t = "z";
                        } else {
                            sstr = strs[parseInt(p.v, 10)];
                            p.v = sstr.t;
                            p.r = sstr.r;
                            if (opts.cellHTML) p.h = sstr.h;
                        }
                        break;
                    case "str":
                        p.t = "s";
                        p.v = p.v != null ? utf8read(p.v) : "";
                        if (opts.cellHTML) p.h = escapehtml(p.v);
                        break;
                    case "inlineStr":
                        cref = d.match(isregex);
                        p.t = "s";
                        if (cref != null && (sstr = parse_si(cref[1]))) {
                            p.v = sstr.t;
                            if (opts.cellHTML) p.h = sstr.h;
                        } else p.v = "";
                        break;
                    case "b":
                        p.v = parsexmlbool(p.v);
                        break;
                    case "d":
                        if (opts.cellDates) p.v = parseDate(p.v, 1);
                        else {
                            p.v = datenum(parseDate(p.v, 1));
                            p.t = "n";
                        }
                        break;
                    /* error string in .w, number in .v */ case "e":
                        if (!opts || opts.cellText !== false) p.w = p.v;
                        p.v = RBErr[p.v];
                        break;
                }
                /* formatting */ fmtid = fillid = 0;
                cf = null;
                if (do_format && tag.s !== undefined) {
                    cf = styles.CellXf[tag.s];
                    if (cf != null) {
                        if (cf.numFmtId != null) fmtid = cf.numFmtId;
                        if (opts.cellStyles) {
                            if (cf.fillId != null) fillid = cf.fillId;
                        }
                    }
                }
                safe_format(p, fmtid, fillid, opts, themes, styles);
                if (opts.cellDates && do_format && p.t == "n" && fmt_is_date(table_fmt[fmtid])) {
                    p.t = "d";
                    p.v = numdate(p.v);
                }
                if (tag.cm && opts.xlmeta) {
                    var cm = (opts.xlmeta.Cell || [])[+tag.cm - 1];
                    if (cm && cm.type == "XLDAPR") p.D = true;
                }
                if (dense) {
                    var _r = decode_cell(tag.r);
                    if (!s[_r.r]) s[_r.r] = [];
                    s[_r.r][_r.c] = p;
                } else s[tag.r] = p;
            }
        }
        if (rows.length > 0) s["!rows"] = rows;
    };
}();
function write_ws_xml_data(ws /*:Worksheet*/ , opts, idx /*:number*/ , wb /*:Workbook*/  /*::, rels*/ ) /*:string*/ {
    var o /*:Array<string>*/  = [], r /*:Array<string>*/  = [], range = safe_decode_range(ws["!ref"]), cell = "", ref, rr = "", cols /*:Array<string>*/  = [], R = 0, C = 0, rows = ws["!rows"];
    var dense = Array.isArray(ws);
    var params = {
        r: rr
    } /*:any*/ , row /*:RowInfo*/ , height = -1;
    for(C = range.s.c; C <= range.e.c; ++C)cols[C] = encode_col(C);
    for(R = range.s.r; R <= range.e.r; ++R){
        r = [];
        rr = encode_row(R);
        for(C = range.s.c; C <= range.e.c; ++C){
            ref = cols[C] + rr;
            var _cell = dense ? (ws[R] || [])[C] : ws[ref];
            if (_cell === undefined) continue;
            if ((cell = write_ws_xml_cell(_cell, ref, ws, opts, idx, wb)) != null) r.push(cell);
        }
        if (r.length > 0 || rows && rows[R]) {
            params = {
                r: rr
            } /*:any*/ ;
            if (rows && rows[R]) {
                row = rows[R];
                if (row.hidden) params.hidden = 1;
                height = -1;
                if (row.hpx) height = px2pt(row.hpx);
                else if (row.hpt) height = row.hpt;
                if (height > -1) {
                    params.ht = height;
                    params.customHeight = 1;
                }
                if (row.level) params.outlineLevel = row.level;
            }
            o[o.length] = writextag("row", r.join(""), params);
        }
    }
    if (rows) {
        for(; R < rows.length; ++R)if (rows && rows[R]) {
            params = {
                r: R + 1
            } /*:any*/ ;
            row = rows[R];
            if (row.hidden) params.hidden = 1;
            height = -1;
            if (row.hpx) height = px2pt(row.hpx);
            else if (row.hpt) height = row.hpt;
            if (height > -1) {
                params.ht = height;
                params.customHeight = 1;
            }
            if (row.level) params.outlineLevel = row.level;
            o[o.length] = writextag("row", "", params);
        }
    }
    return o.join("");
}
function write_ws_xml(idx /*:number*/ , opts, wb /*:Workbook*/ , rels) /*:string*/ {
    var o = [
        XML_HEADER,
        writextag("worksheet", null, {
            "xmlns": XMLNS_main[0],
            "xmlns:r": XMLNS.r
        })
    ];
    var s = wb.SheetNames[idx], sidx = 0, rdata = "";
    var ws = wb.Sheets[s];
    if (ws == null) ws = {};
    var ref = ws["!ref"] || "A1";
    var range = safe_decode_range(ref);
    if (range.e.c > 0x3FFF || range.e.r > 0xFFFFF) {
        if (opts.WTF) throw new Error("Range " + ref + " exceeds format limit A1:XFD1048576");
        range.e.c = Math.min(range.e.c, 0x3FFF);
        range.e.r = Math.min(range.e.c, 0xFFFFF);
        ref = encode_range(range);
    }
    if (!rels) rels = {};
    ws["!comments"] = [];
    var _drawing = [];
    write_ws_xml_sheetpr(ws, wb, idx, opts, o);
    o[o.length] = writextag("dimension", null, {
        "ref": ref
    });
    o[o.length] = write_ws_xml_sheetviews(ws, opts, idx, wb);
    /* TODO: store in WB, process styles */ if (opts.sheetFormat) o[o.length] = writextag("sheetFormatPr", null, {
        defaultRowHeight: opts.sheetFormat.defaultRowHeight || "16",
        baseColWidth: opts.sheetFormat.baseColWidth || "10",
        outlineLevelRow: opts.sheetFormat.outlineLevelRow || "7"
    });
    if (ws["!cols"] != null && ws["!cols"].length > 0) o[o.length] = write_ws_xml_cols(ws, ws["!cols"]);
    o[sidx = o.length] = "<sheetData/>";
    ws["!links"] = [];
    if (ws["!ref"] != null) {
        rdata = write_ws_xml_data(ws, opts, idx, wb, rels);
        if (rdata.length > 0) o[o.length] = rdata;
    }
    if (o.length > sidx + 1) {
        o[o.length] = "</sheetData>";
        o[sidx] = o[sidx].replace("/>", ">");
    }
    /* sheetCalcPr */ if (ws["!protect"]) o[o.length] = write_ws_xml_protection(ws["!protect"]);
    /* protectedRanges */ /* scenarios */ if (ws["!autofilter"] != null) o[o.length] = write_ws_xml_autofilter(ws["!autofilter"], ws, wb, idx);
    /* sortState */ /* dataConsolidate */ /* customSheetViews */ if (ws["!merges"] != null && ws["!merges"].length > 0) o[o.length] = write_ws_xml_merges(ws["!merges"]);
    /* phoneticPr */ /* conditionalFormatting */ /* dataValidations */ var relc = -1, rel, rId = -1;
    if (/*::(*/ ws["!links"]/*::||[])*/ .length > 0) {
        o[o.length] = "<hyperlinks>";
        /*::(*/ ws["!links"]/*::||[])*/ .forEach(function(l) {
            if (!l[1].Target) return;
            rel = {
                "ref": l[0]
            } /*:any*/ ;
            if (l[1].Target.charAt(0) != "#") {
                rId = add_rels(rels, -1, escapexml(l[1].Target).replace(/#.*$/, ""), RELS.HLINK);
                rel["r:id"] = "rId" + rId;
            }
            if ((relc = l[1].Target.indexOf("#")) > -1) rel.location = escapexml(l[1].Target.slice(relc + 1));
            if (l[1].Tooltip) rel.tooltip = escapexml(l[1].Tooltip);
            o[o.length] = writextag("hyperlink", null, rel);
        });
        o[o.length] = "</hyperlinks>";
    }
    delete ws["!links"];
    /* printOptions */ if (ws["!margins"] != null) o[o.length] = write_ws_xml_margins(ws["!margins"]);
    /* pageSetup */ /* headerFooter */ /* rowBreaks */ /* colBreaks */ /* customProperties */ /* cellWatches */ if (!opts || opts.ignoreEC || opts.ignoreEC == void 0) o[o.length] = writetag("ignoredErrors", writextag("ignoredError", null, {
        numberStoredAsText: 1,
        sqref: ref
    }));
    /* smartTags */ if (_drawing.length > 0) {
        rId = add_rels(rels, -1, "../drawings/drawing" + (idx + 1) + ".xml", RELS.DRAW);
        o[o.length] = writextag("drawing", null, {
            "r:id": "rId" + rId
        });
        ws["!drawing"] = _drawing;
    }
    if (ws["!comments"].length > 0) {
        rId = add_rels(rels, -1, "../drawings/vmlDrawing" + (idx + 1) + ".vml", RELS.VML);
        o[o.length] = writextag("legacyDrawing", null, {
            "r:id": "rId" + rId
        });
        ws["!legacy"] = rId;
    }
    /* legacyDrawingHF */ /* picture */ /* oleObjects */ /* controls */ /* webPublishItems */ /* tableParts */ /* extLst */ if (o.length > 1) {
        o[o.length] = "</worksheet>";
        o[1] = o[1].replace("/>", ">");
    }
    return o.join("");
}
/* [MS-XLSB] 2.4.726 BrtRowHdr */ function parse_BrtRowHdr(data, length) {
    var z = {} /*:any*/ ;
    var tgt = data.l + length;
    z.r = data.read_shift(4);
    data.l += 4; // TODO: ixfe
    var miyRw = data.read_shift(2);
    data.l += 1; // TODO: top/bot padding
    var flags = data.read_shift(1);
    data.l = tgt;
    if (flags & 0x07) z.level = flags & 0x07;
    if (flags & 0x10) z.hidden = true;
    if (flags & 0x20) z.hpt = miyRw / 20;
    return z;
}
function write_BrtRowHdr(R /*:number*/ , range, ws) {
    var o = new_buf(145);
    var row = (ws["!rows"] || [])[R] || {};
    o.write_shift(4, R);
    o.write_shift(4, 0); /* TODO: ixfe */ 
    var miyRw = 0x0140;
    if (row.hpx) miyRw = px2pt(row.hpx) * 20;
    else if (row.hpt) miyRw = row.hpt * 20;
    o.write_shift(2, miyRw);
    o.write_shift(1, 0); /* top/bot padding */ 
    var flags = 0x0;
    if (row.level) flags |= row.level;
    if (row.hidden) flags |= 0x10;
    if (row.hpx || row.hpt) flags |= 0x20;
    o.write_shift(1, flags);
    o.write_shift(1, 0); /* phonetic guide */ 
    /* [MS-XLSB] 2.5.8 BrtColSpan explains the mechanism */ var ncolspan = 0, lcs = o.l;
    o.l += 4;
    var caddr = {
        r: R,
        c: 0
    };
    for(var i = 0; i < 16; ++i){
        if (range.s.c > i + 1 << 10 || range.e.c < i << 10) continue;
        var first = -1, last = -1;
        for(var j = i << 10; j < i + 1 << 10; ++j){
            caddr.c = j;
            var cell = Array.isArray(ws) ? (ws[caddr.r] || [])[caddr.c] : ws[encode_cell(caddr)];
            if (cell) {
                if (first < 0) first = j;
                last = j;
            }
        }
        if (first < 0) continue;
        ++ncolspan;
        o.write_shift(4, first);
        o.write_shift(4, last);
    }
    var l = o.l;
    o.l = lcs;
    o.write_shift(4, ncolspan);
    o.l = l;
    return o.length > o.l ? o.slice(0, o.l) : o;
}
function write_row_header(ba, ws, range, R) {
    var o = write_BrtRowHdr(R, range, ws);
    if (o.length > 17 || (ws["!rows"] || [])[R]) write_record(ba, 0x0000 /* BrtRowHdr */ , o);
}
/* [MS-XLSB] 2.4.820 BrtWsDim */ var parse_BrtWsDim = parse_UncheckedRfX;
var write_BrtWsDim = write_UncheckedRfX;
/* [MS-XLSB] 2.4.821 BrtWsFmtInfo */ function parse_BrtWsFmtInfo() {}
//function write_BrtWsFmtInfo(ws, o) { }
/* [MS-XLSB] 2.4.823 BrtWsProp */ function parse_BrtWsProp(data, length) {
    var z = {};
    var f = data[data.l];
    ++data.l;
    z.above = !(f & 0x40);
    z.left = !(f & 0x80);
    /* TODO: pull flags */ data.l += 18;
    z.name = parse_XLSBCodeName(data, length - 19);
    return z;
}
function write_BrtWsProp(str, outl, o) {
    if (o == null) o = new_buf(84 + 4 * str.length);
    var f = 0xC0;
    if (outl) {
        if (outl.above) f &= -65;
        if (outl.left) f &= -129;
    }
    o.write_shift(1, f);
    for(var i = 1; i < 3; ++i)o.write_shift(1, 0);
    write_BrtColor({
        auto: 1
    }, o);
    o.write_shift(-4, -1);
    o.write_shift(-4, -1);
    write_XLSBCodeName(str, o);
    return o.slice(0, o.l);
}
/* [MS-XLSB] 2.4.306 BrtCellBlank */ function parse_BrtCellBlank(data) {
    var cell = parse_XLSBCell(data);
    return [
        cell
    ];
}
function write_BrtCellBlank(cell, ncell, o) {
    if (o == null) o = new_buf(8);
    return write_XLSBCell(ncell, o);
}
function parse_BrtShortBlank(data) {
    var cell = parse_XLSBShortCell(data);
    return [
        cell
    ];
}
function write_BrtShortBlank(cell, ncell, o) {
    if (o == null) o = new_buf(4);
    return write_XLSBShortCell(ncell, o);
}
/* [MS-XLSB] 2.4.307 BrtCellBool */ function parse_BrtCellBool(data) {
    var cell = parse_XLSBCell(data);
    var fBool = data.read_shift(1);
    return [
        cell,
        fBool,
        "b"
    ];
}
function write_BrtCellBool(cell, ncell, o) {
    if (o == null) o = new_buf(9);
    write_XLSBCell(ncell, o);
    o.write_shift(1, cell.v ? 1 : 0);
    return o;
}
function parse_BrtShortBool(data) {
    var cell = parse_XLSBShortCell(data);
    var fBool = data.read_shift(1);
    return [
        cell,
        fBool,
        "b"
    ];
}
function write_BrtShortBool(cell, ncell, o) {
    if (o == null) o = new_buf(5);
    write_XLSBShortCell(ncell, o);
    o.write_shift(1, cell.v ? 1 : 0);
    return o;
}
/* [MS-XLSB] 2.4.308 BrtCellError */ function parse_BrtCellError(data) {
    var cell = parse_XLSBCell(data);
    var bError = data.read_shift(1);
    return [
        cell,
        bError,
        "e"
    ];
}
function write_BrtCellError(cell, ncell, o) {
    if (o == null) o = new_buf(9);
    write_XLSBCell(ncell, o);
    o.write_shift(1, cell.v);
    return o;
}
function parse_BrtShortError(data) {
    var cell = parse_XLSBShortCell(data);
    var bError = data.read_shift(1);
    return [
        cell,
        bError,
        "e"
    ];
}
function write_BrtShortError(cell, ncell, o) {
    if (o == null) o = new_buf(8);
    write_XLSBShortCell(ncell, o);
    o.write_shift(1, cell.v);
    o.write_shift(2, 0);
    o.write_shift(1, 0);
    return o;
}
/* [MS-XLSB] 2.4.311 BrtCellIsst */ function parse_BrtCellIsst(data) {
    var cell = parse_XLSBCell(data);
    var isst = data.read_shift(4);
    return [
        cell,
        isst,
        "s"
    ];
}
function write_BrtCellIsst(cell, ncell, o) {
    if (o == null) o = new_buf(12);
    write_XLSBCell(ncell, o);
    o.write_shift(4, ncell.v);
    return o;
}
function parse_BrtShortIsst(data) {
    var cell = parse_XLSBShortCell(data);
    var isst = data.read_shift(4);
    return [
        cell,
        isst,
        "s"
    ];
}
function write_BrtShortIsst(cell, ncell, o) {
    if (o == null) o = new_buf(8);
    write_XLSBShortCell(ncell, o);
    o.write_shift(4, ncell.v);
    return o;
}
/* [MS-XLSB] 2.4.313 BrtCellReal */ function parse_BrtCellReal(data) {
    var cell = parse_XLSBCell(data);
    var value = parse_Xnum(data);
    return [
        cell,
        value,
        "n"
    ];
}
function write_BrtCellReal(cell, ncell, o) {
    if (o == null) o = new_buf(16);
    write_XLSBCell(ncell, o);
    write_Xnum(cell.v, o);
    return o;
}
function parse_BrtShortReal(data) {
    var cell = parse_XLSBShortCell(data);
    var value = parse_Xnum(data);
    return [
        cell,
        value,
        "n"
    ];
}
function write_BrtShortReal(cell, ncell, o) {
    if (o == null) o = new_buf(12);
    write_XLSBShortCell(ncell, o);
    write_Xnum(cell.v, o);
    return o;
}
/* [MS-XLSB] 2.4.314 BrtCellRk */ function parse_BrtCellRk(data) {
    var cell = parse_XLSBCell(data);
    var value = parse_RkNumber(data);
    return [
        cell,
        value,
        "n"
    ];
}
function write_BrtCellRk(cell, ncell, o) {
    if (o == null) o = new_buf(12);
    write_XLSBCell(ncell, o);
    write_RkNumber(cell.v, o);
    return o;
}
function parse_BrtShortRk(data) {
    var cell = parse_XLSBShortCell(data);
    var value = parse_RkNumber(data);
    return [
        cell,
        value,
        "n"
    ];
}
function write_BrtShortRk(cell, ncell, o) {
    if (o == null) o = new_buf(8);
    write_XLSBShortCell(ncell, o);
    write_RkNumber(cell.v, o);
    return o;
}
/* [MS-XLSB] 2.4.323 BrtCellRString */ function parse_BrtCellRString(data) {
    var cell = parse_XLSBCell(data);
    var value = parse_RichStr(data);
    return [
        cell,
        value,
        "is"
    ];
}
/* [MS-XLSB] 2.4.317 BrtCellSt */ function parse_BrtCellSt(data) {
    var cell = parse_XLSBCell(data);
    var value = parse_XLWideString(data);
    return [
        cell,
        value,
        "str"
    ];
}
function write_BrtCellSt(cell, ncell, o) {
    if (o == null) o = new_buf(12 + 4 * cell.v.length);
    write_XLSBCell(ncell, o);
    write_XLWideString(cell.v, o);
    return o.length > o.l ? o.slice(0, o.l) : o;
}
function parse_BrtShortSt(data) {
    var cell = parse_XLSBShortCell(data);
    var value = parse_XLWideString(data);
    return [
        cell,
        value,
        "str"
    ];
}
function write_BrtShortSt(cell, ncell, o) {
    if (o == null) o = new_buf(8 + 4 * cell.v.length);
    write_XLSBShortCell(ncell, o);
    write_XLWideString(cell.v, o);
    return o.length > o.l ? o.slice(0, o.l) : o;
}
/* [MS-XLSB] 2.4.653 BrtFmlaBool */ function parse_BrtFmlaBool(data, length, opts) {
    var end = data.l + length;
    var cell = parse_XLSBCell(data);
    cell.r = opts["!row"];
    var value = data.read_shift(1);
    var o = [
        cell,
        value,
        "b"
    ];
    if (opts.cellFormula) {
        data.l += 2;
        var formula = parse_XLSBCellParsedFormula(data, end - data.l, opts);
        o[3] = stringify_formula(formula, null, cell, opts.supbooks, opts); /* TODO */ 
    } else data.l = end;
    return o;
}
/* [MS-XLSB] 2.4.654 BrtFmlaError */ function parse_BrtFmlaError(data, length, opts) {
    var end = data.l + length;
    var cell = parse_XLSBCell(data);
    cell.r = opts["!row"];
    var value = data.read_shift(1);
    var o = [
        cell,
        value,
        "e"
    ];
    if (opts.cellFormula) {
        data.l += 2;
        var formula = parse_XLSBCellParsedFormula(data, end - data.l, opts);
        o[3] = stringify_formula(formula, null, cell, opts.supbooks, opts); /* TODO */ 
    } else data.l = end;
    return o;
}
/* [MS-XLSB] 2.4.655 BrtFmlaNum */ function parse_BrtFmlaNum(data, length, opts) {
    var end = data.l + length;
    var cell = parse_XLSBCell(data);
    cell.r = opts["!row"];
    var value = parse_Xnum(data);
    var o = [
        cell,
        value,
        "n"
    ];
    if (opts.cellFormula) {
        data.l += 2;
        var formula = parse_XLSBCellParsedFormula(data, end - data.l, opts);
        o[3] = stringify_formula(formula, null, cell, opts.supbooks, opts); /* TODO */ 
    } else data.l = end;
    return o;
}
/* [MS-XLSB] 2.4.656 BrtFmlaString */ function parse_BrtFmlaString(data, length, opts) {
    var end = data.l + length;
    var cell = parse_XLSBCell(data);
    cell.r = opts["!row"];
    var value = parse_XLWideString(data);
    var o = [
        cell,
        value,
        "str"
    ];
    if (opts.cellFormula) {
        data.l += 2;
        var formula = parse_XLSBCellParsedFormula(data, end - data.l, opts);
        o[3] = stringify_formula(formula, null, cell, opts.supbooks, opts); /* TODO */ 
    } else data.l = end;
    return o;
}
/* [MS-XLSB] 2.4.682 BrtMergeCell */ var parse_BrtMergeCell = parse_UncheckedRfX;
var write_BrtMergeCell = write_UncheckedRfX;
/* [MS-XLSB] 2.4.107 BrtBeginMergeCells */ function write_BrtBeginMergeCells(cnt, o) {
    if (o == null) o = new_buf(4);
    o.write_shift(4, cnt);
    return o;
}
/* [MS-XLSB] 2.4.662 BrtHLink */ function parse_BrtHLink(data, length /*::, opts*/ ) {
    var end = data.l + length;
    var rfx = parse_UncheckedRfX(data, 16);
    var relId = parse_XLNullableWideString(data);
    var loc = parse_XLWideString(data);
    var tooltip = parse_XLWideString(data);
    var display = parse_XLWideString(data);
    data.l = end;
    var o = {
        rfx: rfx,
        relId: relId,
        loc: loc,
        display: display
    } /*:any*/ ;
    if (tooltip) o.Tooltip = tooltip;
    return o;
}
function write_BrtHLink(l, rId) {
    var o = new_buf(50 + 4 * (l[1].Target.length + (l[1].Tooltip || "").length));
    write_UncheckedRfX({
        s: decode_cell(l[0]),
        e: decode_cell(l[0])
    }, o);
    write_RelID("rId" + rId, o);
    var locidx = l[1].Target.indexOf("#");
    var loc = locidx == -1 ? "" : l[1].Target.slice(locidx + 1);
    write_XLWideString(loc || "", o);
    write_XLWideString(l[1].Tooltip || "", o);
    write_XLWideString("", o);
    return o.slice(0, o.l);
}
/* [MS-XLSB] 2.4.692 BrtPane */ function parse_BrtPane() {}
/* [MS-XLSB] 2.4.6 BrtArrFmla */ function parse_BrtArrFmla(data, length, opts) {
    var end = data.l + length;
    var rfx = parse_RfX(data, 16);
    var fAlwaysCalc = data.read_shift(1);
    var o = [
        rfx
    ];
    o[2] = fAlwaysCalc;
    if (opts.cellFormula) {
        var formula = parse_XLSBArrayParsedFormula(data, end - data.l, opts);
        o[1] = formula;
    } else data.l = end;
    return o;
}
/* [MS-XLSB] 2.4.750 BrtShrFmla */ function parse_BrtShrFmla(data, length, opts) {
    var end = data.l + length;
    var rfx = parse_UncheckedRfX(data, 16);
    var o = [
        rfx
    ];
    if (opts.cellFormula) {
        var formula = parse_XLSBSharedParsedFormula(data, end - data.l, opts);
        o[1] = formula;
        data.l = end;
    } else data.l = end;
    return o;
}
/* [MS-XLSB] 2.4.323 BrtColInfo */ /* TODO: once XLS ColInfo is set, combine the functions */ function write_BrtColInfo(C /*:number*/ , col, o) {
    if (o == null) o = new_buf(18);
    var p = col_obj_w(C, col);
    o.write_shift(-4, C);
    o.write_shift(-4, C);
    o.write_shift(4, (p.width || 10) * 256);
    o.write_shift(4, 0 /*ixfe*/ ); // style
    var flags = 0;
    if (col.hidden) flags |= 0x01;
    if (typeof p.width == "number") flags |= 0x02;
    if (col.level) flags |= col.level << 8;
    o.write_shift(2, flags); // bit flag
    return o;
}
/* [MS-XLSB] 2.4.678 BrtMargins */ var BrtMarginKeys = [
    "left",
    "right",
    "top",
    "bottom",
    "header",
    "footer"
];
function parse_BrtMargins(data /*::, length, opts*/ ) /*:Margins*/ {
    var margins = {} /*:any*/ ;
    BrtMarginKeys.forEach(function(k) {
        margins[k] = parse_Xnum(data, 8);
    });
    return margins;
}
function write_BrtMargins(margins /*:Margins*/ , o) {
    if (o == null) o = new_buf(48);
    default_margins(margins);
    BrtMarginKeys.forEach(function(k) {
        write_Xnum(margins /*:any*/ [k], o);
    });
    return o;
}
/* [MS-XLSB] 2.4.299 BrtBeginWsView */ function parse_BrtBeginWsView(data /*::, length, opts*/ ) {
    var f = data.read_shift(2);
    data.l += 28;
    return {
        RTL: f & 0x20
    };
}
function write_BrtBeginWsView(ws, Workbook, o) {
    if (o == null) o = new_buf(30);
    var f = 0x39c;
    if ((((Workbook || {}).Views || [])[0] || {}).RTL) f |= 0x20;
    o.write_shift(2, f); // bit flag
    o.write_shift(4, 0);
    o.write_shift(4, 0); // view first row
    o.write_shift(4, 0); // view first col
    o.write_shift(1, 0); // gridline color ICV
    o.write_shift(1, 0);
    o.write_shift(2, 0);
    o.write_shift(2, 100); // zoom scale
    o.write_shift(2, 0);
    o.write_shift(2, 0);
    o.write_shift(2, 0);
    o.write_shift(4, 0); // workbook view id
    return o;
}
/* [MS-XLSB] 2.4.309 BrtCellIgnoreEC */ function write_BrtCellIgnoreEC(ref) {
    var o = new_buf(24);
    o.write_shift(4, 4);
    o.write_shift(4, 1);
    write_UncheckedRfX(ref, o);
    return o;
}
/* [MS-XLSB] 2.4.748 BrtSheetProtection */ function write_BrtSheetProtection(sp, o) {
    if (o == null) o = new_buf(66);
    o.write_shift(2, sp.password ? crypto_CreatePasswordVerifier_Method1(sp.password) : 0);
    o.write_shift(4, 1); // this record should not be written if no protection
    [
        [
            "objects",
            false
        ],
        [
            "scenarios",
            false
        ],
        [
            "formatCells",
            true
        ],
        [
            "formatColumns",
            true
        ],
        [
            "formatRows",
            true
        ],
        [
            "insertColumns",
            true
        ],
        [
            "insertRows",
            true
        ],
        [
            "insertHyperlinks",
            true
        ],
        [
            "deleteColumns",
            true
        ],
        [
            "deleteRows",
            true
        ],
        [
            "selectLockedCells",
            false
        ],
        [
            "sort",
            true
        ],
        [
            "autoFilter",
            true
        ],
        [
            "pivotTables",
            true
        ],
        [
            "selectUnlockedCells",
            false
        ] // fSelUnlockedCells
    ].forEach(function(n) {
        /*:: if(o == null) throw "unreachable"; */ if (n[1]) o.write_shift(4, sp[n[0]] != null && !sp[n[0]] ? 1 : 0);
        else o.write_shift(4, sp[n[0]] != null && sp[n[0]] ? 0 : 1);
    });
    return o;
}
function parse_BrtDVal() {}
function parse_BrtDVal14() {}
/* [MS-XLSB] 2.1.7.61 Worksheet */ function parse_ws_bin(data, _opts, idx, rels, wb /*:WBWBProps*/ , themes, styles) /*:Worksheet*/ {
    if (!data) return data;
    var opts = _opts || {};
    if (!rels) rels = {
        "!id": {}
    };
    if (DENSE != null && opts.dense == null) opts.dense = DENSE;
    var s /*:Worksheet*/  = opts.dense ? [] : {};
    var ref;
    var refguess = {
        s: {
            r: 2000000,
            c: 2000000
        },
        e: {
            r: 0,
            c: 0
        }
    };
    var state /*:Array<string>*/  = [];
    var pass = false, end = false;
    var row, p, cf, R, C, addr, sstr, rr, cell /*:Cell*/ ;
    var merges /*:Array<Range>*/  = [];
    opts.biff = 12;
    opts["!row"] = 0;
    var ai = 0, af = false;
    var arrayf /*:Array<[Range, string]>*/  = [];
    var sharedf = {};
    var supbooks = opts.supbooks || /*::(*/ wb /*:: :any)*/ .supbooks || [
        []
    ];
    supbooks.sharedf = sharedf;
    supbooks.arrayf = arrayf;
    supbooks.SheetNames = wb.SheetNames || wb.Sheets.map(function(x) {
        return x.name;
    });
    if (!opts.supbooks) {
        opts.supbooks = supbooks;
        if (wb.Names) for(var i = 0; i < wb.Names.length; ++i)supbooks[0][i + 1] = wb.Names[i];
    }
    var colinfo /*:Array<ColInfo>*/  = [], rowinfo /*:Array<RowInfo>*/  = [];
    var seencol = false;
    XLSBRecordEnum[0x0010] = {
        n: "BrtShortReal",
        f: parse_BrtShortReal
    };
    var cm, vm;
    recordhopper(data, function ws_parse(val, RR, RT) {
        if (end) return;
        switch(RT){
            case 0x0094:
                /* 'BrtWsDim' */ ref = val;
                break;
            case 0x0000:
                /* 'BrtRowHdr' */ row = val;
                if (opts.sheetRows && opts.sheetRows <= row.r) end = true;
                rr = encode_row(R = row.r);
                opts["!row"] = row.r;
                if (val.hidden || val.hpt || val.level != null) {
                    if (val.hpt) val.hpx = pt2px(val.hpt);
                    rowinfo[val.r] = val;
                }
                break;
            case 0x0002:
            /* 'BrtCellRk' */ case 0x0003:
            /* 'BrtCellError' */ case 0x0004:
            /* 'BrtCellBool' */ case 0x0005:
            /* 'BrtCellReal' */ case 0x0006:
            /* 'BrtCellSt' */ case 0x0007:
            /* 'BrtCellIsst' */ case 0x0008:
            /* 'BrtFmlaString' */ case 0x0009:
            /* 'BrtFmlaNum' */ case 0x000A:
            /* 'BrtFmlaBool' */ case 0x000B:
            /* 'BrtFmlaError' */ case 0x000D:
            /* 'BrtShortRk' */ case 0x000E:
            /* 'BrtShortError' */ case 0x000F:
            /* 'BrtShortBool' */ case 0x0010:
            /* 'BrtShortReal' */ case 0x0011:
            /* 'BrtShortSt' */ case 0x0012:
            /* 'BrtShortIsst' */ case 0x003E:
                /* 'BrtCellRString' */ p = {
                    t: val[2]
                } /*:any*/ ;
                switch(val[2]){
                    case "n":
                        p.v = val[1];
                        break;
                    case "s":
                        sstr = strs[val[1]];
                        p.v = sstr.t;
                        p.r = sstr.r;
                        break;
                    case "b":
                        p.v = val[1] ? true : false;
                        break;
                    case "e":
                        p.v = val[1];
                        if (opts.cellText !== false) p.w = BErr[p.v];
                        break;
                    case "str":
                        p.t = "s";
                        p.v = val[1];
                        break;
                    case "is":
                        p.t = "s";
                        p.v = val[1].t;
                        break;
                }
                if (cf = styles.CellXf[val[0].iStyleRef]) safe_format(p, cf.numFmtId, null, opts, themes, styles);
                C = val[0].c == -1 ? C + 1 : val[0].c;
                if (opts.dense) {
                    if (!s[R]) s[R] = [];
                    s[R][C] = p;
                } else s[encode_col(C) + rr] = p;
                if (opts.cellFormula) {
                    af = false;
                    for(ai = 0; ai < arrayf.length; ++ai){
                        var aii = arrayf[ai];
                        if (row.r >= aii[0].s.r && row.r <= aii[0].e.r) {
                            if (C >= aii[0].s.c && C <= aii[0].e.c) {
                                p.F = encode_range(aii[0]);
                                af = true;
                            }
                        }
                    }
                    if (!af && val.length > 3) p.f = val[3];
                }
                if (refguess.s.r > row.r) refguess.s.r = row.r;
                if (refguess.s.c > C) refguess.s.c = C;
                if (refguess.e.r < row.r) refguess.e.r = row.r;
                if (refguess.e.c < C) refguess.e.c = C;
                if (opts.cellDates && cf && p.t == "n" && fmt_is_date(table_fmt[cf.numFmtId])) {
                    var _d = SSF_parse_date_code(p.v);
                    if (_d) {
                        p.t = "d";
                        p.v = new Date(_d.y, _d.m - 1, _d.d, _d.H, _d.M, _d.S, _d.u);
                    }
                }
                if (cm) {
                    if (cm.type == "XLDAPR") p.D = true;
                    cm = void 0;
                }
                if (vm) vm = void 0;
                break;
            case 0x0001:
            /* 'BrtCellBlank' */ case 0x000C:
                /* 'BrtShortBlank' */ if (!opts.sheetStubs || pass) break;
                p = {
                    t: "z",
                    v: void 0
                } /*:any*/ ;
                C = val[0].c == -1 ? C + 1 : val[0].c;
                if (opts.dense) {
                    if (!s[R]) s[R] = [];
                    s[R][C] = p;
                } else s[encode_col(C) + rr] = p;
                if (refguess.s.r > row.r) refguess.s.r = row.r;
                if (refguess.s.c > C) refguess.s.c = C;
                if (refguess.e.r < row.r) refguess.e.r = row.r;
                if (refguess.e.c < C) refguess.e.c = C;
                if (cm) {
                    if (cm.type == "XLDAPR") p.D = true;
                    cm = void 0;
                }
                if (vm) vm = void 0;
                break;
            case 0x00B0:
                /* 'BrtMergeCell' */ merges.push(val);
                break;
            case 0x0031:
                cm = ((opts.xlmeta || {}).Cell || [])[val - 1];
                break;
            case 0x01EE:
                /* 'BrtHLink' */ var rel = rels["!id"][val.relId];
                if (rel) {
                    val.Target = rel.Target;
                    if (val.loc) val.Target += "#" + val.loc;
                    val.Rel = rel;
                } else if (val.relId == "") val.Target = "#" + val.loc;
                for(R = val.rfx.s.r; R <= val.rfx.e.r; ++R)for(C = val.rfx.s.c; C <= val.rfx.e.c; ++C)if (opts.dense) {
                    if (!s[R]) s[R] = [];
                    if (!s[R][C]) s[R][C] = {
                        t: "z",
                        v: undefined
                    };
                    s[R][C].l = val;
                } else {
                    addr = encode_cell({
                        c: C,
                        r: R
                    });
                    if (!s[addr]) s[addr] = {
                        t: "z",
                        v: undefined
                    };
                    s[addr].l = val;
                }
                break;
            case 0x01AA:
                /* 'BrtArrFmla' */ if (!opts.cellFormula) break;
                arrayf.push(val);
                cell = opts.dense ? s[R][C] : s[encode_col(C) + rr];
                cell.f = stringify_formula(val[1], refguess, {
                    r: row.r,
                    c: C
                }, supbooks, opts);
                cell.F = encode_range(val[0]);
                break;
            case 0x01AB:
                /* 'BrtShrFmla' */ if (!opts.cellFormula) break;
                sharedf[encode_cell(val[0].s)] = val[1];
                cell = opts.dense ? s[R][C] : s[encode_col(C) + rr];
                cell.f = stringify_formula(val[1], refguess, {
                    r: row.r,
                    c: C
                }, supbooks, opts);
                break;
            /* identical to 'ColInfo' in XLS */ case 0x003C:
                /* 'BrtColInfo' */ if (!opts.cellStyles) break;
                while(val.e >= val.s){
                    colinfo[val.e--] = {
                        width: val.w / 256,
                        hidden: !!(val.flags & 0x01),
                        level: val.level
                    };
                    if (!seencol) {
                        seencol = true;
                        find_mdw_colw(val.w / 256);
                    }
                    process_col(colinfo[val.e + 1]);
                }
                break;
            case 0x00A1:
                /* 'BrtBeginAFilter' */ s["!autofilter"] = {
                    ref: encode_range(val)
                };
                break;
            case 0x01DC:
                /* 'BrtMargins' */ s["!margins"] = val;
                break;
            case 0x0093:
                /* 'BrtWsProp' */ if (!wb.Sheets[idx]) wb.Sheets[idx] = {};
                if (val.name) wb.Sheets[idx].CodeName = val.name;
                if (val.above || val.left) s["!outline"] = {
                    above: val.above,
                    left: val.left
                };
                break;
            case 0x0089:
                /* 'BrtBeginWsView' */ if (!wb.Views) wb.Views = [
                    {}
                ];
                if (!wb.Views[0]) wb.Views[0] = {};
                if (val.RTL) wb.Views[0].RTL = true;
                break;
            case 0x01E5:
                break;
            case 0x0040:
            /* 'BrtDVal' */ case 0x041D:
                break;
            case 0x0097:
                break;
            case 0x0098:
            /* 'BrtSel' */ case 0x00AF:
            /* 'BrtAFilterDateGroupItem' */ case 0x0284:
            /* 'BrtActiveX' */ case 0x0271:
            /* 'BrtBigName' */ case 0x0232:
            /* 'BrtBkHim' */ case 0x018C:
            /* 'BrtBrk' */ case 0x0458:
            /* 'BrtCFIcon' */ case 0x047A:
            /* 'BrtCFRuleExt' */ case 0x01D7:
            /* 'BrtCFVO' */ case 0x041A:
            /* 'BrtCFVO14' */ case 0x0289:
            /* 'BrtCellIgnoreEC' */ case 0x0451:
            /* 'BrtCellIgnoreEC14' */ case 0x024D:
            /* 'BrtCellSmartTagProperty' */ case 0x025F:
            /* 'BrtCellWatch' */ case 0x0234:
            /* 'BrtColor' */ case 0x041F:
            /* 'BrtColor14' */ case 0x00A8:
            /* 'BrtColorFilter' */ case 0x00AE:
            /* 'BrtCustomFilter' */ case 0x049C:
            /* 'BrtCustomFilter14' */ case 0x01F3:
            /* 'BrtDRef' */ case 0x01FB:
            /* 'BrtDXF' */ case 0x0226:
            /* 'BrtDrawing' */ case 0x00AB:
            /* 'BrtDynamicFilter' */ case 0x00A7:
            /* 'BrtFilter' */ case 0x0499:
            /* 'BrtFilter14' */ case 0x00A9:
            /* 'BrtIconFilter' */ case 0x049D:
            /* 'BrtIconFilter14' */ case 0x0227:
            /* 'BrtLegacyDrawing' */ case 0x0228:
            /* 'BrtLegacyDrawingHF' */ case 0x0295:
            /* 'BrtListPart' */ case 0x027F:
            /* 'BrtOleObject' */ case 0x01DE:
            /* 'BrtPageSetup' */ case 0x0219:
            /* 'BrtPhoneticInfo' */ case 0x01DD:
            /* 'BrtPrintOptions' */ case 0x0218:
            /* 'BrtRangeProtection' */ case 0x044F:
            /* 'BrtRangeProtection14' */ case 0x02A8:
            /* 'BrtRangeProtectionIso' */ case 0x0450:
            /* 'BrtRangeProtectionIso14' */ case 0x0400:
            /* 'BrtRwDescent' */ case 0x0297:
            /* 'BrtSheetCalcProp' */ case 0x0217:
            /* 'BrtSheetProtection' */ case 0x02A6:
            /* 'BrtSheetProtectionIso' */ case 0x01F8:
            /* 'BrtSlc' */ case 0x0413:
            /* 'BrtSparkline' */ case 0x01AC:
            /* 'BrtTable' */ case 0x00AA:
            /* 'BrtTop10Filter' */ case 0x0C00:
            /* 'BrtUid' */ case 0x0032:
            /* 'BrtValueMeta' */ case 0x0816:
            /* 'BrtWebExtension' */ case 0x0415:
                break;
            case 0x0023:
                /* 'BrtFRTBegin' */ pass = true;
                break;
            case 0x0024:
                /* 'BrtFRTEnd' */ pass = false;
                break;
            case 0x0025:
                /* 'BrtACBegin' */ state.push(RT);
                pass = true;
                break;
            case 0x0026:
                /* 'BrtACEnd' */ state.pop();
                pass = false;
                break;
            default:
                if (RR.T) ;
                else if (!pass || opts.WTF) throw new Error("Unexpected record 0x" + RT.toString(16));
        }
    }, opts);
    delete opts.supbooks;
    delete opts["!row"];
    if (!s["!ref"] && (refguess.s.r < 2000000 || ref && (ref.e.r > 0 || ref.e.c > 0 || ref.s.r > 0 || ref.s.c > 0))) s["!ref"] = encode_range(ref || refguess);
    if (opts.sheetRows && s["!ref"]) {
        var tmpref = safe_decode_range(s["!ref"]);
        if (opts.sheetRows <= +tmpref.e.r) {
            tmpref.e.r = opts.sheetRows - 1;
            if (tmpref.e.r > refguess.e.r) tmpref.e.r = refguess.e.r;
            if (tmpref.e.r < tmpref.s.r) tmpref.s.r = tmpref.e.r;
            if (tmpref.e.c > refguess.e.c) tmpref.e.c = refguess.e.c;
            if (tmpref.e.c < tmpref.s.c) tmpref.s.c = tmpref.e.c;
            s["!fullref"] = s["!ref"];
            s["!ref"] = encode_range(tmpref);
        }
    }
    if (merges.length > 0) s["!merges"] = merges;
    if (colinfo.length > 0) s["!cols"] = colinfo;
    if (rowinfo.length > 0) s["!rows"] = rowinfo;
    return s;
}
/* TODO: something useful -- this is a stub */ function write_ws_bin_cell(ba /*:BufArray*/ , cell /*:Cell*/ , R /*:number*/ , C /*:number*/ , opts, ws /*:Worksheet*/ , last_seen /*:boolean*/ ) /*:boolean*/ {
    if (cell.v === undefined) return false;
    var vv = "";
    switch(cell.t){
        case "b":
            vv = cell.v ? "1" : "0";
            break;
        case "d":
            cell = dup(cell);
            cell.z = cell.z || table_fmt[14];
            cell.v = datenum(parseDate(cell.v));
            cell.t = "n";
            break;
        /* falls through */ case "n":
        case "e":
            vv = "" + cell.v;
            break;
        default:
            vv = cell.v;
            break;
    }
    var o /*:any*/  = {
        r: R,
        c: C
    } /*:any*/ ;
    /* TODO: cell style */ o.s = get_cell_style(opts.cellXfs, cell, opts);
    if (cell.l) ws["!links"].push([
        encode_cell(o),
        cell.l
    ]);
    if (cell.c) ws["!comments"].push([
        encode_cell(o),
        cell.c
    ]);
    switch(cell.t){
        case "s":
        case "str":
            if (opts.bookSST) {
                vv = get_sst_id(opts.Strings, cell.v /*:any*/ , opts.revStrings);
                o.t = "s";
                o.v = vv;
                if (last_seen) write_record(ba, 0x0012 /* BrtShortIsst */ , write_BrtShortIsst(cell, o));
                else write_record(ba, 0x0007 /* BrtCellIsst */ , write_BrtCellIsst(cell, o));
            } else {
                o.t = "str";
                if (last_seen) write_record(ba, 0x0011 /* BrtShortSt */ , write_BrtShortSt(cell, o));
                else write_record(ba, 0x0006 /* BrtCellSt */ , write_BrtCellSt(cell, o));
            }
            return true;
        case "n":
            /* TODO: determine threshold for Real vs RK */ if (cell.v == (cell.v | 0) && cell.v > -1000 && cell.v < 1000) {
                if (last_seen) write_record(ba, 0x000D /* BrtShortRk */ , write_BrtShortRk(cell, o));
                else write_record(ba, 0x0002 /* BrtCellRk */ , write_BrtCellRk(cell, o));
            } else if (last_seen) write_record(ba, 0x0010 /* BrtShortReal */ , write_BrtShortReal(cell, o));
            else write_record(ba, 0x0005 /* BrtCellReal */ , write_BrtCellReal(cell, o));
            return true;
        case "b":
            o.t = "b";
            if (last_seen) write_record(ba, 0x000F /* BrtShortBool */ , write_BrtShortBool(cell, o));
            else write_record(ba, 0x0004 /* BrtCellBool */ , write_BrtCellBool(cell, o));
            return true;
        case "e":
            o.t = "e";
            if (last_seen) write_record(ba, 0x000E /* BrtShortError */ , write_BrtShortError(cell, o));
            else write_record(ba, 0x0003 /* BrtCellError */ , write_BrtCellError(cell, o));
            return true;
    }
    if (last_seen) write_record(ba, 0x000C /* BrtShortBlank */ , write_BrtShortBlank(cell, o));
    else write_record(ba, 0x0001 /* BrtCellBlank */ , write_BrtCellBlank(cell, o));
    return true;
}
function write_CELLTABLE(ba, ws /*:Worksheet*/ , idx /*:number*/ , opts /*::, wb:Workbook*/ ) {
    var range = safe_decode_range(ws["!ref"] || "A1"), ref, rr = "", cols /*:Array<string>*/  = [];
    write_record(ba, 0x0091 /* BrtBeginSheetData */ );
    var dense = Array.isArray(ws);
    var cap = range.e.r;
    if (ws["!rows"]) cap = Math.max(range.e.r, ws["!rows"].length - 1);
    for(var R = range.s.r; R <= cap; ++R){
        rr = encode_row(R);
        /* [ACCELLTABLE] */ /* BrtRowHdr */ write_row_header(ba, ws, range, R);
        var last_seen = false;
        if (R <= range.e.r) for(var C = range.s.c; C <= range.e.c; ++C){
            /* *16384CELL */ if (R === range.s.r) cols[C] = encode_col(C);
            ref = cols[C] + rr;
            var cell = dense ? (ws[R] || [])[C] : ws[ref];
            if (!cell) {
                last_seen = false;
                continue;
            }
            /* write cell */ last_seen = write_ws_bin_cell(ba, cell, R, C, opts, ws, last_seen);
        }
    }
    write_record(ba, 0x0092 /* BrtEndSheetData */ );
}
function write_MERGECELLS(ba, ws /*:Worksheet*/ ) {
    if (!ws || !ws["!merges"]) return;
    write_record(ba, 0x00B1 /* BrtBeginMergeCells */ , write_BrtBeginMergeCells(ws["!merges"].length));
    ws["!merges"].forEach(function(m) {
        write_record(ba, 0x00B0 /* BrtMergeCell */ , write_BrtMergeCell(m));
    });
    write_record(ba, 0x00B2 /* BrtEndMergeCells */ );
}
function write_COLINFOS(ba, ws /*:Worksheet*/  /*::, idx:number, opts, wb:Workbook*/ ) {
    if (!ws || !ws["!cols"]) return;
    write_record(ba, 0x0186 /* BrtBeginColInfos */ );
    ws["!cols"].forEach(function(m, i) {
        if (m) write_record(ba, 0x003C /* 'BrtColInfo' */ , write_BrtColInfo(i, m));
    });
    write_record(ba, 0x0187 /* BrtEndColInfos */ );
}
function write_IGNOREECS(ba, ws /*:Worksheet*/ ) {
    if (!ws || !ws["!ref"]) return;
    write_record(ba, 0x0288 /* BrtBeginCellIgnoreECs */ );
    write_record(ba, 0x0289 /* BrtCellIgnoreEC */ , write_BrtCellIgnoreEC(safe_decode_range(ws["!ref"])));
    write_record(ba, 0x028A /* BrtEndCellIgnoreECs */ );
}
function write_HLINKS(ba, ws /*:Worksheet*/ , rels) {
    /* *BrtHLink */ ws["!links"].forEach(function(l) {
        if (!l[1].Target) return;
        var rId = add_rels(rels, -1, l[1].Target.replace(/#.*$/, ""), RELS.HLINK);
        write_record(ba, 0x01EE /* BrtHLink */ , write_BrtHLink(l, rId));
    });
    delete ws["!links"];
}
function write_LEGACYDRAWING(ba, ws /*:Worksheet*/ , idx /*:number*/ , rels) {
    /* [BrtLegacyDrawing] */ if (ws["!comments"].length > 0) {
        var rId = add_rels(rels, -1, "../drawings/vmlDrawing" + (idx + 1) + ".vml", RELS.VML);
        write_record(ba, 0x0227 /* BrtLegacyDrawing */ , write_RelID("rId" + rId));
        ws["!legacy"] = rId;
    }
}
function write_AUTOFILTER(ba, ws, wb, idx) {
    if (!ws["!autofilter"]) return;
    var data = ws["!autofilter"];
    var ref = typeof data.ref === "string" ? data.ref : encode_range(data.ref);
    /* Update FilterDatabase defined name for the worksheet */ if (!wb.Workbook) wb.Workbook = {
        Sheets: []
    } /*:any*/ ;
    if (!wb.Workbook.Names) wb.Workbook.Names = [];
    var names /*: Array<any> */  = wb.Workbook.Names;
    var range = decode_range(ref);
    if (range.s.r == range.e.r) {
        range.e.r = decode_range(ws["!ref"]).e.r;
        ref = encode_range(range);
    }
    for(var i = 0; i < names.length; ++i){
        var name = names[i];
        if (name.Name != "_xlnm._FilterDatabase") continue;
        if (name.Sheet != idx) continue;
        name.Ref = "'" + wb.SheetNames[idx] + "'!" + ref;
        break;
    }
    if (i == names.length) names.push({
        Name: "_xlnm._FilterDatabase",
        Sheet: idx,
        Ref: "'" + wb.SheetNames[idx] + "'!" + ref
    });
    write_record(ba, 0x00A1 /* BrtBeginAFilter */ , write_UncheckedRfX(safe_decode_range(ref)));
    /* *FILTERCOLUMN */ /* [SORTSTATE] */ /* BrtEndAFilter */ write_record(ba, 0x00A2 /* BrtEndAFilter */ );
}
function write_WSVIEWS2(ba, ws, Workbook) {
    write_record(ba, 0x0085 /* BrtBeginWsViews */ );
    /* [ACUID] */ write_record(ba, 0x0089 /* BrtBeginWsView */ , write_BrtBeginWsView(ws, Workbook));
    /* [BrtPane] */ /* *4BrtSel */ /* *4SXSELECT */ /* *FRT */ write_record(ba, 0x008A /* BrtEndWsView */ );
    /* *FRT */ write_record(ba, 0x0086 /* BrtEndWsViews */ );
}
function write_WSFMTINFO() {
/* [ACWSFMTINFO] */ // write_record(ba, 0x01E5 /* BrtWsFmtInfo */, write_BrtWsFmtInfo(ws));
}
function write_SHEETPROTECT(ba, ws) {
    if (!ws["!protect"]) return;
    /* [BrtSheetProtectionIso] */ write_record(ba, 0x0217 /* BrtSheetProtection */ , write_BrtSheetProtection(ws["!protect"]));
}
function write_ws_bin(idx /*:number*/ , opts, wb /*:Workbook*/ , rels) {
    var ba = buf_array();
    var s = wb.SheetNames[idx], ws = wb.Sheets[s] || {};
    var c /*:string*/  = s;
    try {
        if (wb && wb.Workbook) c = wb.Workbook.Sheets[idx].CodeName || c;
    } catch (e) {}
    var r = safe_decode_range(ws["!ref"] || "A1");
    if (r.e.c > 0x3FFF || r.e.r > 0xFFFFF) {
        if (opts.WTF) throw new Error("Range " + (ws["!ref"] || "A1") + " exceeds format limit A1:XFD1048576");
        r.e.c = Math.min(r.e.c, 0x3FFF);
        r.e.r = Math.min(r.e.c, 0xFFFFF);
    }
    ws["!links"] = [];
    /* passed back to write_zip and removed there */ ws["!comments"] = [];
    write_record(ba, 0x0081 /* BrtBeginSheet */ );
    if (wb.vbaraw || ws["!outline"]) write_record(ba, 0x0093 /* BrtWsProp */ , write_BrtWsProp(c, ws["!outline"]));
    write_record(ba, 0x0094 /* BrtWsDim */ , write_BrtWsDim(r));
    write_WSVIEWS2(ba, ws, wb.Workbook);
    write_WSFMTINFO(ba, ws);
    write_COLINFOS(ba, ws, idx, opts, wb);
    write_CELLTABLE(ba, ws, idx, opts, wb);
    /* [BrtSheetCalcProp] */ write_SHEETPROTECT(ba, ws);
    /* *([BrtRangeProtectionIso] BrtRangeProtection) */ /* [SCENMAN] */ write_AUTOFILTER(ba, ws, wb, idx);
    /* [SORTSTATE] */ /* [DCON] */ /* [USERSHVIEWS] */ write_MERGECELLS(ba, ws);
    /* [BrtPhoneticInfo] */ /* *CONDITIONALFORMATTING */ /* [DVALS] */ write_HLINKS(ba, ws, rels);
    /* [BrtPrintOptions] */ if (ws["!margins"]) write_record(ba, 0x01DC /* BrtMargins */ , write_BrtMargins(ws["!margins"]));
    /* [BrtPageSetup] */ /* [HEADERFOOTER] */ /* [RWBRK] */ /* [COLBRK] */ /* *BrtBigName */ /* [CELLWATCHES] */ if (!opts || opts.ignoreEC || opts.ignoreEC == void 0) write_IGNOREECS(ba, ws);
    /* [SMARTTAGS] */ /* [BrtDrawing] */ write_LEGACYDRAWING(ba, ws, idx, rels);
    /* [BrtLegacyDrawingHF] */ /* [BrtBkHim] */ /* [OLEOBJECTS] */ /* [ACTIVEXCONTROLS] */ /* [WEBPUBITEMS] */ /* [LISTPARTS] */ /* FRTWORKSHEET */ write_record(ba, 0x0082 /* BrtEndSheet */ );
    return ba.end();
}
function parse_Cache(data /*:string*/ ) /*:[Array<number|string>, string, ?string]*/ {
    var col /*:Array<number|string>*/  = [];
    var num = data.match(/^<c:numCache>/);
    var f;
    /* 21.2.2.150 pt CT_NumVal */ (data.match(/<c:pt idx="(\d*)">(.*?)<\/c:pt>/mg) || []).forEach(function(pt) {
        var q = pt.match(/<c:pt idx="(\d*?)"><c:v>(.*)<\/c:v><\/c:pt>/);
        if (!q) return;
        col[+q[1]] = num ? +q[2] : q[2];
    });
    /* 21.2.2.71 formatCode CT_Xstring */ var nf = unescapexml((data.match(/<c:formatCode>([\s\S]*?)<\/c:formatCode>/) || [
        "",
        "General"
    ])[1]);
    (data.match(/<c:f>(.*?)<\/c:f>/mg) || []).forEach(function(F) {
        f = F.replace(/<.*?>/g, "");
    });
    return [
        col,
        nf,
        f
    ];
}
/* 21.2 DrawingML - Charts */ function parse_chart(data /*:?string*/ , name /*:string*/ , opts, rels, wb, csheet) {
    var cs /*:Worksheet*/  = csheet || {
        "!type": "chart"
    };
    if (!data) return csheet;
    /* 21.2.2.27 chart CT_Chart */ var C = 0, R = 0, col = "A";
    var refguess = {
        s: {
            r: 2000000,
            c: 2000000
        },
        e: {
            r: 0,
            c: 0
        }
    };
    /* 21.2.2.120 numCache CT_NumData */ (data.match(/<c:numCache>[\s\S]*?<\/c:numCache>/gm) || []).forEach(function(nc) {
        var cache = parse_Cache(nc);
        refguess.s.r = refguess.s.c = 0;
        refguess.e.c = C;
        col = encode_col(C);
        cache[0].forEach(function(n, i) {
            cs[col + encode_row(i)] = {
                t: "n",
                v: n,
                z: cache[1]
            };
            R = i;
        });
        if (refguess.e.r < R) refguess.e.r = R;
        ++C;
    });
    if (C > 0) cs["!ref"] = encode_range(refguess);
    return cs;
}
/* 18.3 Worksheets also covers Chartsheets */ function parse_cs_xml(data /*:?string*/ , opts, idx /*:number*/ , rels, wb /*::, themes, styles*/ ) /*:Worksheet*/ {
    if (!data) return data;
    /* 18.3.1.12 chartsheet CT_ChartSheet */ if (!rels) rels = {
        "!id": {}
    };
    var s = {
        "!type": "chart",
        "!drawel": null,
        "!rel": ""
    } /*:any*/ ;
    var m;
    /* 18.3.1.83 sheetPr CT_ChartsheetPr */ var sheetPr = data.match(sheetprregex);
    if (sheetPr) parse_ws_xml_sheetpr(sheetPr[0], s, wb, idx);
    /* 18.3.1.36 drawing CT_Drawing */ if (m = data.match(/drawing r:id="(.*?)"/)) s["!rel"] = m[1];
    if (rels["!id"][s["!rel"]]) s["!drawel"] = rels["!id"][s["!rel"]];
    return s;
}
function write_cs_xml(idx /*:number*/ , opts, wb /*:Workbook*/ , rels) /*:string*/ {
    var o = [
        XML_HEADER,
        writextag("chartsheet", null, {
            "xmlns": XMLNS_main[0],
            "xmlns:r": XMLNS.r
        })
    ];
    o[o.length] = writextag("drawing", null, {
        "r:id": "rId1"
    });
    add_rels(rels, -1, "../drawings/drawing" + (idx + 1) + ".xml", RELS.DRAW);
    if (o.length > 2) {
        o[o.length] = "</chartsheet>";
        o[1] = o[1].replace("/>", ">");
    }
    return o.join("");
}
/* [MS-XLSB] 2.4.331 BrtCsProp */ function parse_BrtCsProp(data, length /*:number*/ ) {
    data.l += 10;
    var name = parse_XLWideString(data, length - 10);
    return {
        name: name
    };
}
/* [MS-XLSB] 2.1.7.7 Chart Sheet */ function parse_cs_bin(data, opts, idx /*:number*/ , rels, wb /*::, themes, styles*/ ) /*:Worksheet*/ {
    if (!data) return data;
    if (!rels) rels = {
        "!id": {}
    };
    var s = {
        "!type": "chart",
        "!drawel": null,
        "!rel": ""
    };
    var state /*:Array<string>*/  = [];
    var pass = false;
    recordhopper(data, function cs_parse(val, R, RT) {
        switch(RT){
            case 0x0226:
                /* 'BrtDrawing' */ s["!rel"] = val;
                break;
            case 0x028B:
                /* 'BrtCsProp' */ if (!wb.Sheets[idx]) wb.Sheets[idx] = {};
                if (val.name) wb.Sheets[idx].CodeName = val.name;
                break;
            case 0x0232:
            /* 'BrtBkHim' */ case 0x028C:
            /* 'BrtCsPageSetup' */ case 0x029D:
            /* 'BrtCsProtection' */ case 0x02A7:
            /* 'BrtCsProtectionIso' */ case 0x0227:
            /* 'BrtLegacyDrawing' */ case 0x0228:
            /* 'BrtLegacyDrawingHF' */ case 0x01DC:
            /* 'BrtMargins' */ case 0x0C00:
                break;
            case 0x0023:
                /* 'BrtFRTBegin' */ pass = true;
                break;
            case 0x0024:
                /* 'BrtFRTEnd' */ pass = false;
                break;
            case 0x0025:
                /* 'BrtACBegin' */ state.push(RT);
                break;
            case 0x0026:
                /* 'BrtACEnd' */ state.pop();
                break;
            default:
                if (R.T > 0) state.push(RT);
                else if (R.T < 0) state.pop();
                else if (!pass || opts.WTF) throw new Error("Unexpected record 0x" + RT.toString(16));
        }
    }, opts);
    if (rels["!id"][s["!rel"]]) s["!drawel"] = rels["!id"][s["!rel"]];
    return s;
}
function write_cs_bin() {
    var ba = buf_array();
    write_record(ba, 0x0081 /* BrtBeginSheet */ );
    /* [BrtCsProp] */ /* CSVIEWS */ /* [[BrtCsProtectionIso] BrtCsProtection] */ /* [USERCSVIEWS] */ /* [BrtMargins] */ /* [BrtCsPageSetup] */ /* [HEADERFOOTER] */ /* BrtDrawing */ /* [BrtLegacyDrawing] */ /* [BrtLegacyDrawingHF] */ /* [BrtBkHim] */ /* [WEBPUBITEMS] */ /* FRTCHARTSHEET */ write_record(ba, 0x0082 /* BrtEndSheet */ );
    return ba.end();
}
/* 18.2.28 (CT_WorkbookProtection) Defaults */ var WBPropsDef = [
    [
        "allowRefreshQuery",
        false,
        "bool"
    ],
    [
        "autoCompressPictures",
        true,
        "bool"
    ],
    [
        "backupFile",
        false,
        "bool"
    ],
    [
        "checkCompatibility",
        false,
        "bool"
    ],
    [
        "CodeName",
        ""
    ],
    [
        "date1904",
        false,
        "bool"
    ],
    [
        "defaultThemeVersion",
        0,
        "int"
    ],
    [
        "filterPrivacy",
        false,
        "bool"
    ],
    [
        "hidePivotFieldList",
        false,
        "bool"
    ],
    [
        "promptedSolutions",
        false,
        "bool"
    ],
    [
        "publishItems",
        false,
        "bool"
    ],
    [
        "refreshAllConnections",
        false,
        "bool"
    ],
    [
        "saveExternalLinkValues",
        true,
        "bool"
    ],
    [
        "showBorderUnselectedTables",
        true,
        "bool"
    ],
    [
        "showInkAnnotation",
        true,
        "bool"
    ],
    [
        "showObjects",
        "all"
    ],
    [
        "showPivotChartFilter",
        false,
        "bool"
    ],
    [
        "updateLinks",
        "userSet"
    ]
];
/* 18.2.30 (CT_BookView) Defaults */ var WBViewDef = [
    [
        "activeTab",
        0,
        "int"
    ],
    [
        "autoFilterDateGrouping",
        true,
        "bool"
    ],
    [
        "firstSheet",
        0,
        "int"
    ],
    [
        "minimized",
        false,
        "bool"
    ],
    [
        "showHorizontalScroll",
        true,
        "bool"
    ],
    [
        "showSheetTabs",
        true,
        "bool"
    ],
    [
        "showVerticalScroll",
        true,
        "bool"
    ],
    [
        "tabRatio",
        600,
        "int"
    ],
    [
        "visibility",
        "visible"
    ]
];
/* 18.2.19 (CT_Sheet) Defaults */ var SheetDef = [];
/* 18.2.2  (CT_CalcPr) Defaults */ var CalcPrDef = [
    [
        "calcCompleted",
        "true"
    ],
    [
        "calcMode",
        "auto"
    ],
    [
        "calcOnSave",
        "true"
    ],
    [
        "concurrentCalc",
        "true"
    ],
    [
        "fullCalcOnLoad",
        "false"
    ],
    [
        "fullPrecision",
        "true"
    ],
    [
        "iterate",
        "false"
    ],
    [
        "iterateCount",
        "100"
    ],
    [
        "iterateDelta",
        "0.001"
    ],
    [
        "refMode",
        "A1"
    ]
];
/* 18.2.3 (CT_CustomWorkbookView) Defaults */ /*var CustomWBViewDef = [
	['autoUpdate', 'false'],
	['changesSavedWin', 'false'],
	['includeHiddenRowCol', 'true'],
	['includePrintSettings', 'true'],
	['maximized', 'false'],
	['minimized', 'false'],
	['onlySync', 'false'],
	['personalView', 'false'],
	['showComments', 'commIndicator'],
	['showFormulaBar', 'true'],
	['showHorizontalScroll', 'true'],
	['showObjects', 'all'],
	['showSheetTabs', 'true'],
	['showStatusbar', 'true'],
	['showVerticalScroll', 'true'],
	['tabRatio', '600'],
	['xWindow', '0'],
	['yWindow', '0']
];*/ function push_defaults_array(target, defaults) {
    for(var j = 0; j != target.length; ++j){
        var w = target[j];
        for(var i = 0; i != defaults.length; ++i){
            var z = defaults[i];
            if (w[z[0]] == null) w[z[0]] = z[1];
            else switch(z[2]){
                case "bool":
                    if (typeof w[z[0]] == "string") w[z[0]] = parsexmlbool(w[z[0]]);
                    break;
                case "int":
                    if (typeof w[z[0]] == "string") w[z[0]] = parseInt(w[z[0]], 10);
                    break;
            }
        }
    }
}
function push_defaults(target, defaults) {
    for(var i = 0; i != defaults.length; ++i){
        var z = defaults[i];
        if (target[z[0]] == null) target[z[0]] = z[1];
        else switch(z[2]){
            case "bool":
                if (typeof target[z[0]] == "string") target[z[0]] = parsexmlbool(target[z[0]]);
                break;
            case "int":
                if (typeof target[z[0]] == "string") target[z[0]] = parseInt(target[z[0]], 10);
                break;
        }
    }
}
function parse_wb_defaults(wb) {
    push_defaults(wb.WBProps, WBPropsDef);
    push_defaults(wb.CalcPr, CalcPrDef);
    push_defaults_array(wb.WBView, WBViewDef);
    push_defaults_array(wb.Sheets, SheetDef);
    _ssfopts.date1904 = parsexmlbool(wb.WBProps.date1904);
}
function safe1904(wb /*:Workbook*/ ) /*:string*/ {
    /* TODO: store date1904 somewhere else */ if (!wb.Workbook) return "false";
    if (!wb.Workbook.WBProps) return "false";
    return parsexmlbool(wb.Workbook.WBProps.date1904) ? "true" : "false";
}
var badchars = /*#__PURE__*/ "][*?/\\".split("");
function check_ws_name(n /*:string*/ , safe /*:?boolean*/ ) /*:boolean*/ {
    if (n.length > 31) {
        if (safe) return false;
        throw new Error("Sheet names cannot exceed 31 chars");
    }
    var _good = true;
    badchars.forEach(function(c) {
        if (n.indexOf(c) == -1) return;
        if (!safe) throw new Error("Sheet name cannot contain : \\ / ? * [ ]");
        _good = false;
    });
    return _good;
}
function check_wb_names(N, S, codes) {
    N.forEach(function(n, i) {
        check_ws_name(n);
        for(var j = 0; j < i; ++j)if (n == N[j]) throw new Error("Duplicate Sheet Name: " + n);
        if (codes) {
            var cn = S && S[i] && S[i].CodeName || n;
            if (cn.charCodeAt(0) == 95 && cn.length > 22) throw new Error("Bad Code Name: Worksheet" + cn);
        }
    });
}
function check_wb(wb) {
    if (!wb || !wb.SheetNames || !wb.Sheets) throw new Error("Invalid Workbook");
    if (!wb.SheetNames.length) throw new Error("Workbook is empty");
    var Sheets = wb.Workbook && wb.Workbook.Sheets || [];
    check_wb_names(wb.SheetNames, Sheets, !!wb.vbaraw);
    for(var i = 0; i < wb.SheetNames.length; ++i)check_ws(wb.Sheets[wb.SheetNames[i]], wb.SheetNames[i], i);
/* TODO: validate workbook */ }
/* 18.2 Workbook */ var wbnsregex = /<\w+:workbook/;
function parse_wb_xml(data, opts) /*:WorkbookFile*/ {
    if (!data) throw new Error("Could not find file");
    var wb = /*::(*/ {
        AppVersion: {},
        WBProps: {},
        WBView: [],
        Sheets: [],
        CalcPr: {},
        Names: [],
        xmlns: ""
    } /*::)*/ ;
    var pass = false, xmlns = "xmlns";
    var dname = {}, dnstart = 0;
    data.replace(tagregex, function xml_wb(x, idx) {
        var y /*:any*/  = parsexmltag(x);
        switch(strip_ns(y[0])){
            case "<?xml":
                break;
            /* 18.2.27 workbook CT_Workbook 1 */ case "<workbook":
                if (x.match(wbnsregex)) xmlns = "xmlns" + x.match(/<(\w+):/)[1];
                wb.xmlns = y[xmlns];
                break;
            case "</workbook>":
                break;
            /* 18.2.13 fileVersion CT_FileVersion ? */ case "<fileVersion":
                delete y[0];
                wb.AppVersion = y;
                break;
            case "<fileVersion/>":
            case "</fileVersion>":
                break;
            /* 18.2.12 fileSharing CT_FileSharing ? */ case "<fileSharing":
                break;
            case "<fileSharing/>":
                break;
            /* 18.2.28 workbookPr CT_WorkbookPr ? */ case "<workbookPr":
            case "<workbookPr/>":
                WBPropsDef.forEach(function(w) {
                    if (y[w[0]] == null) return;
                    switch(w[2]){
                        case "bool":
                            wb.WBProps[w[0]] = parsexmlbool(y[w[0]]);
                            break;
                        case "int":
                            wb.WBProps[w[0]] = parseInt(y[w[0]], 10);
                            break;
                        default:
                            wb.WBProps[w[0]] = y[w[0]];
                    }
                });
                if (y.codeName) wb.WBProps.CodeName = utf8read(y.codeName);
                break;
            case "</workbookPr>":
                break;
            /* 18.2.29 workbookProtection CT_WorkbookProtection ? */ case "<workbookProtection":
                break;
            case "<workbookProtection/>":
                break;
            /* 18.2.1  bookViews CT_BookViews ? */ case "<bookViews":
            case "<bookViews>":
            case "</bookViews>":
                break;
            /* 18.2.30   workbookView CT_BookView + */ case "<workbookView":
            case "<workbookView/>":
                delete y[0];
                wb.WBView.push(y);
                break;
            case "</workbookView>":
                break;
            /* 18.2.20 sheets CT_Sheets 1 */ case "<sheets":
            case "<sheets>":
            case "</sheets>":
                break; // aggregate sheet
            /* 18.2.19   sheet CT_Sheet + */ case "<sheet":
                switch(y.state){
                    case "hidden":
                        y.Hidden = 1;
                        break;
                    case "veryHidden":
                        y.Hidden = 2;
                        break;
                    default:
                        y.Hidden = 0;
                }
                delete y.state;
                y.name = unescapexml(utf8read(y.name));
                delete y[0];
                wb.Sheets.push(y);
                break;
            case "</sheet>":
                break;
            /* 18.2.15 functionGroups CT_FunctionGroups ? */ case "<functionGroups":
            case "<functionGroups/>":
                break;
            /* 18.2.14   functionGroup CT_FunctionGroup + */ case "<functionGroup":
                break;
            /* 18.2.9  externalReferences CT_ExternalReferences ? */ case "<externalReferences":
            case "</externalReferences>":
            case "<externalReferences>":
                break;
            /* 18.2.8    externalReference CT_ExternalReference + */ case "<externalReference":
                break;
            /* 18.2.6  definedNames CT_DefinedNames ? */ case "<definedNames/>":
                break;
            case "<definedNames>":
            case "<definedNames":
                pass = true;
                break;
            case "</definedNames>":
                pass = false;
                break;
            /* 18.2.5    definedName CT_DefinedName + */ case "<definedName":
                dname = {};
                dname.Name = utf8read(y.name);
                if (y.comment) dname.Comment = y.comment;
                if (y.localSheetId) dname.Sheet = +y.localSheetId;
                if (parsexmlbool(y.hidden || "0")) dname.Hidden = true;
                dnstart = idx + x.length;
                break;
            case "</definedName>":
                dname.Ref = unescapexml(utf8read(data.slice(dnstart, idx)));
                wb.Names.push(dname);
                break;
            case "<definedName/>":
                break;
            /* 18.2.2  calcPr CT_CalcPr ? */ case "<calcPr":
                delete y[0];
                wb.CalcPr = y;
                break;
            case "<calcPr/>":
                delete y[0];
                wb.CalcPr = y;
                break;
            case "</calcPr>":
                break;
            /* 18.2.16 oleSize CT_OleSize ? (ref required) */ case "<oleSize":
                break;
            /* 18.2.4  customWorkbookViews CT_CustomWorkbookViews ? */ case "<customWorkbookViews>":
            case "</customWorkbookViews>":
            case "<customWorkbookViews":
                break;
            /* 18.2.3  customWorkbookView CT_CustomWorkbookView + */ case "<customWorkbookView":
            case "</customWorkbookView>":
                break;
            /* 18.2.18 pivotCaches CT_PivotCaches ? */ case "<pivotCaches>":
            case "</pivotCaches>":
            case "<pivotCaches":
                break;
            /* 18.2.17 pivotCache CT_PivotCache ? */ case "<pivotCache":
                break;
            /* 18.2.21 smartTagPr CT_SmartTagPr ? */ case "<smartTagPr":
            case "<smartTagPr/>":
                break;
            /* 18.2.23 smartTagTypes CT_SmartTagTypes ? */ case "<smartTagTypes":
            case "<smartTagTypes>":
            case "</smartTagTypes>":
                break;
            /* 18.2.22 smartTagType CT_SmartTagType ? */ case "<smartTagType":
                break;
            /* 18.2.24 webPublishing CT_WebPublishing ? */ case "<webPublishing":
            case "<webPublishing/>":
                break;
            /* 18.2.11 fileRecoveryPr CT_FileRecoveryPr ? */ case "<fileRecoveryPr":
            case "<fileRecoveryPr/>":
                break;
            /* 18.2.26 webPublishObjects CT_WebPublishObjects ? */ case "<webPublishObjects>":
            case "<webPublishObjects":
            case "</webPublishObjects>":
                break;
            /* 18.2.25 webPublishObject CT_WebPublishObject ? */ case "<webPublishObject":
                break;
            /* 18.2.10 extLst CT_ExtensionList ? */ case "<extLst":
            case "<extLst>":
            case "</extLst>":
            case "<extLst/>":
                break;
            /* 18.2.7  ext CT_Extension + */ case "<ext":
                pass = true;
                break; //TODO: check with versions of excel
            case "</ext>":
                pass = false;
                break;
            /* Others */ case "<ArchID":
                break;
            case "<AlternateContent":
            case "<AlternateContent>":
                pass = true;
                break;
            case "</AlternateContent>":
                pass = false;
                break;
            /* TODO */ case "<revisionPtr":
                break;
            default:
                if (!pass && opts.WTF) throw new Error("unrecognized " + y[0] + " in workbook");
        }
        return x;
    });
    if (XMLNS_main.indexOf(wb.xmlns) === -1) throw new Error("Unknown Namespace: " + wb.xmlns);
    parse_wb_defaults(wb);
    return wb;
}
function write_wb_xml(wb /*:Workbook*/  /*::, opts:?WriteOpts*/ ) /*:string*/ {
    var o = [
        XML_HEADER
    ];
    o[o.length] = writextag("workbook", null, {
        "xmlns": XMLNS_main[0],
        //'xmlns:mx': XMLNS.mx,
        //'xmlns:s': XMLNS_main[0],
        "xmlns:r": XMLNS.r
    });
    var write_names = wb.Workbook && (wb.Workbook.Names || []).length > 0;
    /* fileVersion */ /* fileSharing */ var workbookPr /*:any*/  = {
        codeName: "ThisWorkbook"
    } /*:any*/ ;
    if (wb.Workbook && wb.Workbook.WBProps) {
        WBPropsDef.forEach(function(x) {
            /*:: if(!wb.Workbook || !wb.Workbook.WBProps) throw "unreachable"; */ if (wb.Workbook.WBProps[x[0]] == null) return;
            if (wb.Workbook.WBProps[x[0]] == x[1]) return;
            workbookPr[x[0]] = wb.Workbook.WBProps[x[0]];
        });
        /*:: if(!wb.Workbook || !wb.Workbook.WBProps) throw "unreachable"; */ if (wb.Workbook.WBProps.CodeName) {
            workbookPr.codeName = wb.Workbook.WBProps.CodeName;
            delete workbookPr.CodeName;
        }
    }
    o[o.length] = writextag("workbookPr", null, workbookPr);
    /* workbookProtection */ var sheets = wb.Workbook && wb.Workbook.Sheets || [];
    var i = 0;
    /* bookViews only written if first worksheet is hidden */ if (sheets && sheets[0] && !!sheets[0].Hidden) {
        o[o.length] = "<bookViews>";
        for(i = 0; i != wb.SheetNames.length; ++i){
            if (!sheets[i]) break;
            if (!sheets[i].Hidden) break;
        }
        if (i == wb.SheetNames.length) i = 0;
        o[o.length] = '<workbookView firstSheet="' + i + '" activeTab="' + i + '"/>';
        o[o.length] = "</bookViews>";
    }
    o[o.length] = "<sheets>";
    for(i = 0; i != wb.SheetNames.length; ++i){
        var sht = {
            name: escapexml(wb.SheetNames[i].slice(0, 31))
        } /*:any*/ ;
        sht.sheetId = "" + (i + 1);
        sht["r:id"] = "rId" + (i + 1);
        if (sheets[i]) switch(sheets[i].Hidden){
            case 1:
                sht.state = "hidden";
                break;
            case 2:
                sht.state = "veryHidden";
                break;
        }
        o[o.length] = writextag("sheet", null, sht);
    }
    o[o.length] = "</sheets>";
    /* functionGroups */ /* externalReferences */ if (write_names) {
        o[o.length] = "<definedNames>";
        if (wb.Workbook && wb.Workbook.Names) wb.Workbook.Names.forEach(function(n) {
            var d /*:any*/  = {
                name: n.Name
            };
            if (n.Comment) d.comment = n.Comment;
            if (n.Sheet != null) d.localSheetId = "" + n.Sheet;
            if (n.Hidden) d.hidden = "1";
            if (!n.Ref) return;
            o[o.length] = writextag("definedName", escapexml(n.Ref), d);
        });
        o[o.length] = "</definedNames>";
    }
    /* calcPr */ /* oleSize */ /* customWorkbookViews */ /* pivotCaches */ /* smartTagPr */ /* smartTagTypes */ /* webPublishing */ /* fileRecoveryPr */ /* webPublishObjects */ /* extLst */ if (o.length > 2) {
        o[o.length] = "</workbook>";
        o[1] = o[1].replace("/>", ">");
    }
    return o.join("");
}
/* [MS-XLSB] 2.4.304 BrtBundleSh */ function parse_BrtBundleSh(data, length /*:number*/ ) {
    var z = {};
    z.Hidden = data.read_shift(4); //hsState ST_SheetState
    z.iTabID = data.read_shift(4);
    z.strRelID = parse_RelID(data, length - 8);
    z.name = parse_XLWideString(data);
    return z;
}
function write_BrtBundleSh(data, o) {
    if (!o) o = new_buf(127);
    o.write_shift(4, data.Hidden);
    o.write_shift(4, data.iTabID);
    write_RelID(data.strRelID, o);
    write_XLWideString(data.name.slice(0, 31), o);
    return o.length > o.l ? o.slice(0, o.l) : o;
}
/* [MS-XLSB] 2.4.815 BrtWbProp */ function parse_BrtWbProp(data, length) /*:WBProps*/ {
    var o /*:WBProps*/  = {} /*:any*/ ;
    var flags = data.read_shift(4);
    o.defaultThemeVersion = data.read_shift(4);
    var strName = length > 8 ? parse_XLWideString(data) : "";
    if (strName.length > 0) o.CodeName = strName;
    o.autoCompressPictures = !!(flags & 0x10000);
    o.backupFile = !!(flags & 0x40);
    o.checkCompatibility = !!(flags & 0x1000);
    o.date1904 = !!(flags & 0x01);
    o.filterPrivacy = !!(flags & 0x08);
    o.hidePivotFieldList = !!(flags & 0x400);
    o.promptedSolutions = !!(flags & 0x10);
    o.publishItems = !!(flags & 0x800);
    o.refreshAllConnections = !!(flags & 0x40000);
    o.saveExternalLinkValues = !!(flags & 0x80);
    o.showBorderUnselectedTables = !!(flags & 0x04);
    o.showInkAnnotation = !!(flags & 0x20);
    o.showObjects = [
        "all",
        "placeholders",
        "none"
    ][flags >> 13 & 0x03];
    o.showPivotChartFilter = !!(flags & 0x8000);
    o.updateLinks = [
        "userSet",
        "never",
        "always"
    ][flags >> 8 & 0x03];
    return o;
}
function write_BrtWbProp(data /*:?WBProps*/ , o) {
    if (!o) o = new_buf(72);
    var flags = 0;
    if (data) /* TODO: mirror parse_BrtWbProp fields */ {
        if (data.filterPrivacy) flags |= 0x08;
    }
    o.write_shift(4, flags);
    o.write_shift(4, 0);
    write_XLSBCodeName(data && data.CodeName || "ThisWorkbook", o);
    return o.slice(0, o.l);
}
function parse_BrtFRTArchID$(data, length) {
    var o = {};
    data.read_shift(4);
    o.ArchID = data.read_shift(4);
    data.l += length - 8;
    return o;
}
/* [MS-XLSB] 2.4.687 BrtName */ function parse_BrtName(data, length, opts) {
    var end = data.l + length;
    data.l += 4; //var flags = data.read_shift(4);
    data.l += 1; //var chKey = data.read_shift(1);
    var itab = data.read_shift(4);
    var name = parse_XLNameWideString(data);
    var formula = parse_XLSBNameParsedFormula(data, 0, opts);
    var comment = parse_XLNullableWideString(data);
    //if(0 /* fProc */) {
    // unusedstring1: XLNullableWideString
    // description: XLNullableWideString
    // helpTopic: XLNullableWideString
    // unusedstring2: XLNullableWideString
    //}
    data.l = end;
    var out = {
        Name: name,
        Ptg: formula
    } /*:any*/ ;
    if (itab < 0xFFFFFFF) out.Sheet = itab;
    if (comment) out.Comment = comment;
    return out;
}
/* [MS-XLSB] 2.1.7.61 Workbook */ function parse_wb_bin(data, opts) /*:WorkbookFile*/ {
    var wb = {
        AppVersion: {},
        WBProps: {},
        WBView: [],
        Sheets: [],
        CalcPr: {},
        xmlns: ""
    };
    var state /*:Array<string>*/  = [];
    var pass = false;
    if (!opts) opts = {};
    opts.biff = 12;
    var Names = [];
    var supbooks = [
        []
    ];
    supbooks.SheetNames = [];
    supbooks.XTI = [];
    XLSBRecordEnum[0x0010] = {
        n: "BrtFRTArchID$",
        f: parse_BrtFRTArchID$
    };
    recordhopper(data, function hopper_wb(val, R, RT) {
        switch(RT){
            case 0x009C:
                /* 'BrtBundleSh' */ supbooks.SheetNames.push(val.name);
                wb.Sheets.push(val);
                break;
            case 0x0099:
                /* 'BrtWbProp' */ wb.WBProps = val;
                break;
            case 0x0027:
                /* 'BrtName' */ if (val.Sheet != null) opts.SID = val.Sheet;
                val.Ref = stringify_formula(val.Ptg, null, null, supbooks, opts);
                delete opts.SID;
                delete val.Ptg;
                Names.push(val);
                break;
            case 0x040C:
                break;
            case 0x0165:
            /* 'BrtSupSelf' */ case 0x0166:
            /* 'BrtSupSame' */ case 0x0163:
            /* 'BrtSupBookSrc' */ case 0x029B:
                /* 'BrtSupAddin' */ if (!supbooks[0].length) supbooks[0] = [
                    RT,
                    val
                ];
                else supbooks.push([
                    RT,
                    val
                ]);
                supbooks[supbooks.length - 1].XTI = [];
                break;
            case 0x016A:
                /* 'BrtExternSheet' */ if (supbooks.length === 0) {
                    supbooks[0] = [];
                    supbooks[0].XTI = [];
                }
                supbooks[supbooks.length - 1].XTI = supbooks[supbooks.length - 1].XTI.concat(val);
                supbooks.XTI = supbooks.XTI.concat(val);
                break;
            case 0x0169:
                break;
            case 0x0817:
            /* 'BrtAbsPath15' */ case 0x009E:
            /* 'BrtBookView' */ case 0x008F:
            /* 'BrtBeginBundleShs' */ case 0x0298:
            /* 'BrtBeginFnGroup' */ case 0x0161:
                break;
            /* case 'BrtModelTimeGroupingCalcCol' */ case 0x0C00:
            /* 'BrtUid' */ case 0x0C01:
            /* 'BrtRevisionPtr' */ case 0x0216:
            /* 'BrtBookProtection' */ case 0x02A5:
            /* 'BrtBookProtectionIso' */ case 0x009D:
            /* 'BrtCalcProp' */ case 0x0262:
            /* 'BrtCrashRecErr' */ case 0x0802:
            /* 'BrtDecoupledPivotCacheID' */ case 0x009B:
            /* 'BrtFileRecover' */ case 0x0224:
            /* 'BrtFileSharing' */ case 0x02A4:
            /* 'BrtFileSharingIso' */ case 0x0080:
            /* 'BrtFileVersion' */ case 0x0299:
            /* 'BrtFnGroup' */ case 0x0850:
            /* 'BrtModelRelationship' */ case 0x084D:
            /* 'BrtModelTable' */ case 0x0225:
            /* 'BrtOleSize' */ case 0x0805:
            /* 'BrtPivotTableRef' */ case 0x0254:
            /* 'BrtSmartTagType' */ case 0x081C:
            /* 'BrtTableSlicerCacheID' */ case 0x081B:
            /* 'BrtTableSlicerCacheIDs' */ case 0x0822:
            /* 'BrtTimelineCachePivotCacheID' */ case 0x018D:
            /* 'BrtUserBookView' */ case 0x009A:
            /* 'BrtWbFactoid' */ case 0x045D:
            /* 'BrtWbProp14' */ case 0x0229:
            /* 'BrtWebOpt' */ case 0x082B:
                break;
            case 0x0023:
                /* 'BrtFRTBegin' */ state.push(RT);
                pass = true;
                break;
            case 0x0024:
                /* 'BrtFRTEnd' */ state.pop();
                pass = false;
                break;
            case 0x0025:
                /* 'BrtACBegin' */ state.push(RT);
                pass = true;
                break;
            case 0x0026:
                /* 'BrtACEnd' */ state.pop();
                pass = false;
                break;
            case 0x0010:
                break;
            default:
                if (R.T) ;
                else if (!pass || opts.WTF && state[state.length - 1] != 0x0025 /* BrtACBegin */  && state[state.length - 1] != 0x0023 /* BrtFRTBegin */ ) throw new Error("Unexpected record 0x" + RT.toString(16));
        }
    }, opts);
    parse_wb_defaults(wb);
    // $FlowIgnore
    wb.Names = Names;
    wb /*:any*/ .supbooks = supbooks;
    return wb;
}
function write_BUNDLESHS(ba, wb /*::, opts*/ ) {
    write_record(ba, 0x008F /* BrtBeginBundleShs */ );
    for(var idx = 0; idx != wb.SheetNames.length; ++idx){
        var viz = wb.Workbook && wb.Workbook.Sheets && wb.Workbook.Sheets[idx] && wb.Workbook.Sheets[idx].Hidden || 0;
        var d = {
            Hidden: viz,
            iTabID: idx + 1,
            strRelID: "rId" + (idx + 1),
            name: wb.SheetNames[idx]
        };
        write_record(ba, 0x009C /* BrtBundleSh */ , write_BrtBundleSh(d));
    }
    write_record(ba, 0x0090 /* BrtEndBundleShs */ );
}
/* [MS-XLSB] 2.4.649 BrtFileVersion */ function write_BrtFileVersion(data, o) {
    if (!o) o = new_buf(127);
    for(var i = 0; i != 4; ++i)o.write_shift(4, 0);
    write_XLWideString("SheetJS", o);
    write_XLWideString(XLSX.version, o);
    write_XLWideString(XLSX.version, o);
    write_XLWideString("7262", o);
    return o.length > o.l ? o.slice(0, o.l) : o;
}
/* [MS-XLSB] 2.4.301 BrtBookView */ function write_BrtBookView(idx, o) {
    if (!o) o = new_buf(29);
    o.write_shift(-4, 0);
    o.write_shift(-4, 460);
    o.write_shift(4, 28800);
    o.write_shift(4, 17600);
    o.write_shift(4, 500);
    o.write_shift(4, idx);
    o.write_shift(4, idx);
    var flags = 0x78;
    o.write_shift(1, flags);
    return o.length > o.l ? o.slice(0, o.l) : o;
}
function write_BOOKVIEWS(ba, wb /*::, opts*/ ) {
    /* required if hidden tab appears before visible tab */ if (!wb.Workbook || !wb.Workbook.Sheets) return;
    var sheets = wb.Workbook.Sheets;
    var i = 0, vistab = -1, hidden = -1;
    for(; i < sheets.length; ++i){
        if (!sheets[i] || !sheets[i].Hidden && vistab == -1) vistab = i;
        else if (sheets[i].Hidden == 1 && hidden == -1) hidden = i;
    }
    if (hidden > vistab) return;
    write_record(ba, 0x0087 /* BrtBeginBookViews */ );
    write_record(ba, 0x009E /* BrtBookView */ , write_BrtBookView(vistab));
    /* 1*(BrtBookView *FRT) */ write_record(ba, 0x0088 /* BrtEndBookViews */ );
}
/* [MS-XLSB] 2.4.305 BrtCalcProp */ /*function write_BrtCalcProp(data, o) {
	if(!o) o = new_buf(26);
	o.write_shift(4,0); // force recalc
	o.write_shift(4,1);
	o.write_shift(4,0);
	write_Xnum(0, o);
	o.write_shift(-4, 1023);
	o.write_shift(1, 0x33);
	o.write_shift(1, 0x00);
	return o;
}*/ /* [MS-XLSB] 2.4.646 BrtFileRecover */ /*function write_BrtFileRecover(data, o) {
	if(!o) o = new_buf(1);
	o.write_shift(1,0);
	return o;
}*/ /* [MS-XLSB] 2.1.7.61 Workbook */ function write_wb_bin(wb, opts) {
    var ba = buf_array();
    write_record(ba, 0x0083 /* BrtBeginBook */ );
    write_record(ba, 0x0080 /* BrtFileVersion */ , write_BrtFileVersion());
    /* [[BrtFileSharingIso] BrtFileSharing] */ write_record(ba, 0x0099 /* BrtWbProp */ , write_BrtWbProp(wb.Workbook && wb.Workbook.WBProps || null));
    /* [ACABSPATH] */ /* [[BrtBookProtectionIso] BrtBookProtection] */ write_BOOKVIEWS(ba, wb, opts);
    write_BUNDLESHS(ba, wb, opts);
    /* [FNGROUP] */ /* [EXTERNALS] */ /* *BrtName */ /* write_record(ba, 0x009D BrtCalcProp, write_BrtCalcProp()); */ /* [BrtOleSize] */ /* *(BrtUserBookView *FRT) */ /* [PIVOTCACHEIDS] */ /* [BrtWbFactoid] */ /* [SMARTTAGTYPES] */ /* [BrtWebOpt] */ /* write_record(ba, 0x009B BrtFileRecover, write_BrtFileRecover()); */ /* [WEBPUBITEMS] */ /* [CRERRS] */ /* FRTWORKBOOK */ write_record(ba, 0x0084 /* BrtEndBook */ );
    return ba.end();
}
function parse_wb(data, name /*:string*/ , opts) /*:WorkbookFile*/ {
    if (name.slice(-4) === ".bin") return parse_wb_bin(data /*:any*/ , opts);
    return parse_wb_xml(data /*:any*/ , opts);
}
function parse_ws(data, name /*:string*/ , idx /*:number*/ , opts, rels, wb, themes, styles) /*:Worksheet*/ {
    if (name.slice(-4) === ".bin") return parse_ws_bin(data /*:any*/ , opts, idx, rels, wb, themes, styles);
    return parse_ws_xml(data /*:any*/ , opts, idx, rels, wb, themes, styles);
}
function parse_cs(data, name /*:string*/ , idx /*:number*/ , opts, rels, wb, themes, styles) /*:Worksheet*/ {
    if (name.slice(-4) === ".bin") return parse_cs_bin(data /*:any*/ , opts, idx, rels, wb, themes, styles);
    return parse_cs_xml(data /*:any*/ , opts, idx, rels, wb, themes, styles);
}
function parse_ms(data, name /*:string*/ , idx /*:number*/ , opts, rels, wb, themes, styles) /*:Worksheet*/ {
    if (name.slice(-4) === ".bin") return parse_ms_bin(data /*:any*/ , opts, idx, rels, wb, themes, styles);
    return parse_ms_xml(data /*:any*/ , opts, idx, rels, wb, themes, styles);
}
function parse_ds(data, name /*:string*/ , idx /*:number*/ , opts, rels, wb, themes, styles) /*:Worksheet*/ {
    if (name.slice(-4) === ".bin") return parse_ds_bin(data /*:any*/ , opts, idx, rels, wb, themes, styles);
    return parse_ds_xml(data /*:any*/ , opts, idx, rels, wb, themes, styles);
}
function parse_sty(data, name /*:string*/ , themes, opts) {
    if (name.slice(-4) === ".bin") return parse_sty_bin(data /*:any*/ , themes, opts);
    return parse_sty_xml(data /*:any*/ , themes, opts);
}
function parse_theme(data /*:string*/ , name /*:string*/ , opts) {
    return parse_theme_xml(data, opts);
}
function parse_sst(data, name /*:string*/ , opts) /*:SST*/ {
    if (name.slice(-4) === ".bin") return parse_sst_bin(data /*:any*/ , opts);
    return parse_sst_xml(data /*:any*/ , opts);
}
function parse_cmnt(data, name /*:string*/ , opts) /*:Array<RawComment>*/ {
    if (name.slice(-4) === ".bin") return parse_comments_bin(data /*:any*/ , opts);
    return parse_comments_xml(data /*:any*/ , opts);
}
function parse_cc(data, name /*:string*/ , opts) {
    if (name.slice(-4) === ".bin") return parse_cc_bin(data /*:any*/ , name, opts);
    return parse_cc_xml(data /*:any*/ , name, opts);
}
function parse_xlink(data, rel, name /*:string*/ , opts) {
    if (name.slice(-4) === ".bin") return parse_xlink_bin(data /*:any*/ , rel, name, opts);
    return parse_xlink_xml(data /*:any*/ , rel, name, opts);
}
function parse_xlmeta(data, name /*:string*/ , opts) {
    if (name.slice(-4) === ".bin") return parse_xlmeta_bin(data /*:any*/ , name, opts);
    return parse_xlmeta_xml(data /*:any*/ , name, opts);
}
function write_wb(wb, name /*:string*/ , opts) {
    return (name.slice(-4) === ".bin" ? write_wb_bin : write_wb_xml)(wb, opts);
}
function write_ws(data /*:number*/ , name /*:string*/ , opts, wb /*:Workbook*/ , rels) {
    return (name.slice(-4) === ".bin" ? write_ws_bin : write_ws_xml)(data, opts, wb, rels);
}
// eslint-disable-next-line no-unused-vars
function write_cs(data /*:number*/ , name /*:string*/ , opts, wb /*:Workbook*/ , rels) {
    return (name.slice(-4) === ".bin" ? write_cs_bin : write_cs_xml)(data, opts, wb, rels);
}
function write_sty(data, name /*:string*/ , opts) {
    return (name.slice(-4) === ".bin" ? write_sty_bin : write_sty_xml)(data, opts);
}
function write_sst(data /*:SST*/ , name /*:string*/ , opts) {
    return (name.slice(-4) === ".bin" ? write_sst_bin : write_sst_xml)(data, opts);
}
function write_cmnt(data /*:Array<any>*/ , name /*:string*/ , opts) {
    return (name.slice(-4) === ".bin" ? write_comments_bin : write_comments_xml)(data, opts);
}
/*
function write_cc(data, name:string, opts) {
	return (name.slice(-4)===".bin" ? write_cc_bin : write_cc_xml)(data, opts);
}
*/ function write_xlmeta(name /*:string*/ ) {
    return (name.slice(-4) === ".bin" ? write_xlmeta_bin : write_xlmeta_xml)();
}
var attregexg2 = /([\w:]+)=((?:")([^"]*)(?:")|(?:')([^']*)(?:'))/g;
var attregex2 = /([\w:]+)=((?:")(?:[^"]*)(?:")|(?:')(?:[^']*)(?:'))/;
function xlml_parsexmltag(tag /*:string*/ , skip_root /*:?boolean*/ ) {
    var words = tag.split(/\s+/);
    var z /*:any*/  = [];
    if (!skip_root) z[0] = words[0];
    if (words.length === 1) return z;
    var m = tag.match(attregexg2), y, j, w, i;
    if (m) for(i = 0; i != m.length; ++i){
        y = m[i].match(attregex2);
        /*:: if(!y || !y[2]) continue; */ if ((j = y[1].indexOf(":")) === -1) z[y[1]] = y[2].slice(1, y[2].length - 1);
        else {
            if (y[1].slice(0, 6) === "xmlns:") w = "xmlns" + y[1].slice(6);
            else w = y[1].slice(j + 1);
            z[w] = y[2].slice(1, y[2].length - 1);
        }
    }
    return z;
}
function xlml_parsexmltagobj(tag /*:string*/ ) {
    var words = tag.split(/\s+/);
    var z = {};
    if (words.length === 1) return z;
    var m = tag.match(attregexg2), y, j, w, i;
    if (m) for(i = 0; i != m.length; ++i){
        y = m[i].match(attregex2);
        /*:: if(!y || !y[2]) continue; */ if ((j = y[1].indexOf(":")) === -1) z[y[1]] = y[2].slice(1, y[2].length - 1);
        else {
            if (y[1].slice(0, 6) === "xmlns:") w = "xmlns" + y[1].slice(6);
            else w = y[1].slice(j + 1);
            z[w] = y[2].slice(1, y[2].length - 1);
        }
    }
    return z;
}
// ----
/* map from xlml named formats to SSF TODO: localize */ var XLMLFormatMap /*: {[string]:string}*/ ;
function xlml_format(format, value) /*:string*/ {
    var fmt = XLMLFormatMap[format] || unescapexml(format);
    if (fmt === "General") return SSF_general(value);
    return SSF_format(fmt, value);
}
function xlml_set_custprop(Custprops, key, cp, val /*:string*/ ) {
    var oval /*:any*/  = val;
    switch((cp[0].match(/dt:dt="([\w.]+)"/) || [
        "",
        ""
    ])[1]){
        case "boolean":
            oval = parsexmlbool(val);
            break;
        case "i2":
        case "int":
            oval = parseInt(val, 10);
            break;
        case "r4":
        case "float":
            oval = parseFloat(val);
            break;
        case "date":
        case "dateTime.tz":
            oval = parseDate(val);
            break;
        case "i8":
        case "string":
        case "fixed":
        case "uuid":
        case "bin.base64":
            break;
        default:
            throw new Error("bad custprop:" + cp[0]);
    }
    Custprops[unescapexml(key)] = oval;
}
function safe_format_xlml(cell /*:Cell*/ , nf, o) {
    if (cell.t === "z") return;
    if (!o || o.cellText !== false) try {
        if (cell.t === "e") cell.w = cell.w || BErr[cell.v];
        else if (nf === "General") {
            if (cell.t === "n") {
                if ((cell.v | 0) === cell.v) cell.w = cell.v.toString(10);
                else cell.w = SSF_general_num(cell.v);
            } else cell.w = SSF_general(cell.v);
        } else cell.w = xlml_format(nf || "General", cell.v);
    } catch (e) {
        if (o.WTF) throw e;
    }
    try {
        var z = XLMLFormatMap[nf] || nf || "General";
        if (o.cellNF) cell.z = z;
        if (o.cellDates && cell.t == "n" && fmt_is_date(z)) {
            var _d = SSF_parse_date_code(cell.v);
            if (_d) {
                cell.t = "d";
                cell.v = new Date(_d.y, _d.m - 1, _d.d, _d.H, _d.M, _d.S, _d.u);
            }
        }
    } catch (e) {
        if (o.WTF) throw e;
    }
}
function process_style_xlml(styles, stag, opts) {
    if (opts.cellStyles) {
        if (stag.Interior) {
            var I = stag.Interior;
            if (I.Pattern) I.patternType = XLMLPatternTypeMap[I.Pattern] || I.Pattern;
        }
    }
    styles[stag.ID] = stag;
}
/* TODO: there must exist some form of OSP-blessed spec */ function parse_xlml_data(xml, ss, data, cell /*:any*/ , base, styles, csty, row, arrayf, o) {
    var nf = "General", sid = cell.StyleID, S = {};
    o = o || {};
    var interiors = [];
    var i = 0;
    if (sid === undefined && row) sid = row.StyleID;
    if (sid === undefined && csty) sid = csty.StyleID;
    while(styles[sid] !== undefined){
        if (styles[sid].nf) nf = styles[sid].nf;
        if (styles[sid].Interior) interiors.push(styles[sid].Interior);
        if (!styles[sid].Parent) break;
        sid = styles[sid].Parent;
    }
    switch(data.Type){
        case "Boolean":
            cell.t = "b";
            cell.v = parsexmlbool(xml);
            break;
        case "String":
            cell.t = "s";
            cell.r = xlml_fixstr(unescapexml(xml));
            cell.v = xml.indexOf("<") > -1 ? unescapexml(ss || xml).replace(/<.*?>/g, "") : cell.r; // todo: BR etc
            break;
        case "DateTime":
            if (xml.slice(-1) != "Z") xml += "Z";
            cell.v = (parseDate(xml) - new Date(Date.UTC(1899, 11, 30))) / 86400000;
            if (cell.v !== cell.v) cell.v = unescapexml(xml);
            else if (cell.v < 60) cell.v = cell.v - 1;
            if (!nf || nf == "General") nf = "yyyy-mm-dd";
        /* falls through */ case "Number":
            if (cell.v === undefined) cell.v = +xml;
            if (!cell.t) cell.t = "n";
            break;
        case "Error":
            cell.t = "e";
            cell.v = RBErr[xml];
            if (o.cellText !== false) cell.w = xml;
            break;
        default:
            if (xml == "" && ss == "") cell.t = "z";
            else {
                cell.t = "s";
                cell.v = xlml_fixstr(ss || xml);
            }
            break;
    }
    safe_format_xlml(cell, nf, o);
    if (o.cellFormula !== false) {
        if (cell.Formula) {
            var fstr = unescapexml(cell.Formula);
            /* strictly speaking, the leading = is required but some writers omit */ if (fstr.charCodeAt(0) == 61 /* = */ ) fstr = fstr.slice(1);
            cell.f = rc_to_a1(fstr, base);
            delete cell.Formula;
            if (cell.ArrayRange == "RC") cell.F = rc_to_a1("RC:RC", base);
            else if (cell.ArrayRange) {
                cell.F = rc_to_a1(cell.ArrayRange, base);
                arrayf.push([
                    safe_decode_range(cell.F),
                    cell.F
                ]);
            }
        } else {
            for(i = 0; i < arrayf.length; ++i)if (base.r >= arrayf[i][0].s.r && base.r <= arrayf[i][0].e.r) {
                if (base.c >= arrayf[i][0].s.c && base.c <= arrayf[i][0].e.c) cell.F = arrayf[i][1];
            }
        }
    }
    if (o.cellStyles) {
        interiors.forEach(function(x) {
            if (!S.patternType && x.patternType) S.patternType = x.patternType;
        });
        cell.s = S;
    }
    if (cell.StyleID !== undefined) cell.ixfe = cell.StyleID;
}
function xlml_clean_comment(comment /*:any*/ ) {
    comment.t = comment.v || "";
    comment.t = comment.t.replace(/\r\n/g, "\n").replace(/\r/g, "\n");
    comment.v = comment.w = comment.ixfe = undefined;
}
/* TODO: Everything */ function parse_xlml_xml(d, _opts) /*:Workbook*/ {
    var opts = _opts || {};
    make_ssf();
    var str = debom(xlml_normalize(d));
    if (opts.type == "binary" || opts.type == "array" || opts.type == "base64") {
        if (typeof $cptable !== "undefined") str = $cptable.utils.decode(65001, char_codes(str));
        else str = utf8read(str);
    }
    var opening = str.slice(0, 1024).toLowerCase(), ishtml = false;
    opening = opening.replace(/".*?"/g, "");
    if ((opening.indexOf(">") & 1023) > Math.min(opening.indexOf(",") & 1023, opening.indexOf(";") & 1023)) {
        var _o = dup(opts);
        _o.type = "string";
        return PRN.to_workbook(str, _o);
    }
    if (opening.indexOf("<?xml") == -1) [
        "html",
        "table",
        "head",
        "meta",
        "script",
        "style",
        "div"
    ].forEach(function(tag) {
        if (opening.indexOf("<" + tag) >= 0) ishtml = true;
    });
    if (ishtml) return html_to_workbook(str, opts);
    XLMLFormatMap = {
        "General Number": "General",
        "General Date": table_fmt[22],
        "Long Date": "dddd, mmmm dd, yyyy",
        "Medium Date": table_fmt[15],
        "Short Date": table_fmt[14],
        "Long Time": table_fmt[19],
        "Medium Time": table_fmt[18],
        "Short Time": table_fmt[20],
        "Currency": '"$"#,##0.00_);[Red]\\("$"#,##0.00\\)',
        "Fixed": table_fmt[2],
        "Standard": table_fmt[4],
        "Percent": table_fmt[10],
        "Scientific": table_fmt[11],
        "Yes/No": '"Yes";"Yes";"No";@',
        "True/False": '"True";"True";"False";@',
        "On/Off": '"Yes";"Yes";"No";@'
    } /*:any*/ ;
    var Rn;
    var state = [], tmp;
    if (DENSE != null && opts.dense == null) opts.dense = DENSE;
    var sheets = {}, sheetnames /*:Array<string>*/  = [], cursheet /*:Worksheet*/  = opts.dense ? [] : {}, sheetname = "";
    var cell = {} /*:any*/ , row = {}; // eslint-disable-line no-unused-vars
    var dtag = xlml_parsexmltag('<Data ss:Type="String">'), didx = 0;
    var c = 0, r = 0;
    var refguess /*:Range*/  = {
        s: {
            r: 2000000,
            c: 2000000
        },
        e: {
            r: 0,
            c: 0
        }
    };
    var styles = {}, stag = {};
    var ss = "", fidx = 0;
    var merges /*:Array<Range>*/  = [];
    var Props = {}, Custprops = {}, pidx = 0, cp = [];
    var comments /*:Array<Comment>*/  = [], comment /*:Comment*/  = {} /*:any*/ ;
    var cstys = [], csty, seencol = false;
    var arrayf /*:Array<[Range, string]>*/  = [];
    var rowinfo /*:Array<RowInfo>*/  = [], rowobj = {}, cc = 0, rr = 0;
    var Workbook /*:WBWBProps*/  = {
        Sheets: [],
        WBProps: {
            date1904: false
        }
    } /*:any*/ , wsprops = {};
    xlmlregex.lastIndex = 0;
    str = str.replace(/<!--([\s\S]*?)-->/mg, "");
    var raw_Rn3 = "";
    while(Rn = xlmlregex.exec(str))switch(Rn[3] = (raw_Rn3 = Rn[3]).toLowerCase()){
        case "data" /*case 'Data'*/ :
            if (raw_Rn3 == "data") {
                if (Rn[1] === "/") {
                    if ((tmp = state.pop())[0] !== Rn[3]) throw new Error("Bad state: " + tmp.join("|"));
                } else if (Rn[0].charAt(Rn[0].length - 2) !== "/") state.push([
                    Rn[3],
                    true
                ]);
                break;
            }
            if (state[state.length - 1][1]) break;
            if (Rn[1] === "/") parse_xlml_data(str.slice(didx, Rn.index), ss, dtag, state[state.length - 1][0] == /*"Comment"*/ "comment" ? comment : cell, {
                c: c,
                r: r
            }, styles, cstys[c], row, arrayf, opts);
            else {
                ss = "";
                dtag = xlml_parsexmltag(Rn[0]);
                didx = Rn.index + Rn[0].length;
            }
            break;
        case "cell" /*case 'Cell'*/ :
            if (Rn[1] === "/") {
                if (comments.length > 0) cell.c = comments;
                if ((!opts.sheetRows || opts.sheetRows > r) && cell.v !== undefined) {
                    if (opts.dense) {
                        if (!cursheet[r]) cursheet[r] = [];
                        cursheet[r][c] = cell;
                    } else cursheet[encode_col(c) + encode_row(r)] = cell;
                }
                if (cell.HRef) {
                    cell.l = {
                        Target: unescapexml(cell.HRef)
                    } /*:any*/ ;
                    if (cell.HRefScreenTip) cell.l.Tooltip = cell.HRefScreenTip;
                    delete cell.HRef;
                    delete cell.HRefScreenTip;
                }
                if (cell.MergeAcross || cell.MergeDown) {
                    cc = c + (parseInt(cell.MergeAcross, 10) | 0);
                    rr = r + (parseInt(cell.MergeDown, 10) | 0);
                    merges.push({
                        s: {
                            c: c,
                            r: r
                        },
                        e: {
                            c: cc,
                            r: rr
                        }
                    });
                }
                if (!opts.sheetStubs) {
                    if (cell.MergeAcross) c = cc + 1;
                    else ++c;
                } else if (cell.MergeAcross || cell.MergeDown) {
                    /*:: if(!cc) cc = 0; if(!rr) rr = 0; */ for(var cma = c; cma <= cc; ++cma){
                        for(var cmd = r; cmd <= rr; ++cmd)if (cma > c || cmd > r) {
                            if (opts.dense) {
                                if (!cursheet[cmd]) cursheet[cmd] = [];
                                cursheet[cmd][cma] = {
                                    t: "z"
                                };
                            } else cursheet[encode_col(cma) + encode_row(cmd)] = {
                                t: "z"
                            };
                        }
                    }
                    c = cc + 1;
                } else ++c;
            } else {
                cell = xlml_parsexmltagobj(Rn[0]);
                if (cell.Index) c = +cell.Index - 1;
                if (c < refguess.s.c) refguess.s.c = c;
                if (c > refguess.e.c) refguess.e.c = c;
                if (Rn[0].slice(-2) === "/>") ++c;
                comments = [];
            }
            break;
        case "row" /*case 'Row'*/ :
            if (Rn[1] === "/" || Rn[0].slice(-2) === "/>") {
                if (r < refguess.s.r) refguess.s.r = r;
                if (r > refguess.e.r) refguess.e.r = r;
                if (Rn[0].slice(-2) === "/>") {
                    row = xlml_parsexmltag(Rn[0]);
                    if (row.Index) r = +row.Index - 1;
                }
                c = 0;
                ++r;
            } else {
                row = xlml_parsexmltag(Rn[0]);
                if (row.Index) r = +row.Index - 1;
                rowobj = {};
                if (row.AutoFitHeight == "0" || row.Height) {
                    rowobj.hpx = parseInt(row.Height, 10);
                    rowobj.hpt = px2pt(rowobj.hpx);
                    rowinfo[r] = rowobj;
                }
                if (row.Hidden == "1") {
                    rowobj.hidden = true;
                    rowinfo[r] = rowobj;
                }
            }
            break;
        case "worksheet" /*case 'Worksheet'*/ :
            /* TODO: read range from FullRows/FullColumns */ if (Rn[1] === "/") {
                if ((tmp = state.pop())[0] !== Rn[3]) throw new Error("Bad state: " + tmp.join("|"));
                sheetnames.push(sheetname);
                if (refguess.s.r <= refguess.e.r && refguess.s.c <= refguess.e.c) {
                    cursheet["!ref"] = encode_range(refguess);
                    if (opts.sheetRows && opts.sheetRows <= refguess.e.r) {
                        cursheet["!fullref"] = cursheet["!ref"];
                        refguess.e.r = opts.sheetRows - 1;
                        cursheet["!ref"] = encode_range(refguess);
                    }
                }
                if (merges.length) cursheet["!merges"] = merges;
                if (cstys.length > 0) cursheet["!cols"] = cstys;
                if (rowinfo.length > 0) cursheet["!rows"] = rowinfo;
                sheets[sheetname] = cursheet;
            } else {
                refguess = {
                    s: {
                        r: 2000000,
                        c: 2000000
                    },
                    e: {
                        r: 0,
                        c: 0
                    }
                };
                r = c = 0;
                state.push([
                    Rn[3],
                    false
                ]);
                tmp = xlml_parsexmltag(Rn[0]);
                sheetname = unescapexml(tmp.Name);
                cursheet = opts.dense ? [] : {};
                merges = [];
                arrayf = [];
                rowinfo = [];
                wsprops = {
                    name: sheetname,
                    Hidden: 0
                };
                Workbook.Sheets.push(wsprops);
            }
            break;
        case "table" /*case 'Table'*/ :
            if (Rn[1] === "/") {
                if ((tmp = state.pop())[0] !== Rn[3]) throw new Error("Bad state: " + tmp.join("|"));
            } else if (Rn[0].slice(-2) == "/>") break;
            else {
                state.push([
                    Rn[3],
                    false
                ]);
                cstys = [];
                seencol = false;
            }
            break;
        case "style" /*case 'Style'*/ :
            if (Rn[1] === "/") process_style_xlml(styles, stag, opts);
            else stag = xlml_parsexmltag(Rn[0]);
            break;
        case "numberformat" /*case 'NumberFormat'*/ :
            stag.nf = unescapexml(xlml_parsexmltag(Rn[0]).Format || "General");
            if (XLMLFormatMap[stag.nf]) stag.nf = XLMLFormatMap[stag.nf];
            for(var ssfidx = 0; ssfidx != 0x188; ++ssfidx)if (table_fmt[ssfidx] == stag.nf) break;
            if (ssfidx == 0x188) {
                for(ssfidx = 0x39; ssfidx != 0x188; ++ssfidx)if (table_fmt[ssfidx] == null) {
                    SSF_load(stag.nf, ssfidx);
                    break;
                }
            }
            break;
        case "column" /*case 'Column'*/ :
            if (state[state.length - 1][0] !== /*'Table'*/ "table") break;
            csty = xlml_parsexmltag(Rn[0]);
            if (csty.Hidden) {
                csty.hidden = true;
                delete csty.Hidden;
            }
            if (csty.Width) csty.wpx = parseInt(csty.Width, 10);
            if (!seencol && csty.wpx > 10) {
                seencol = true;
                MDW = DEF_MDW; //find_mdw_wpx(csty.wpx);
                for(var _col = 0; _col < cstys.length; ++_col)if (cstys[_col]) process_col(cstys[_col]);
            }
            if (seencol) process_col(csty);
            cstys[csty.Index - 1 || cstys.length] = csty;
            for(var i = 0; i < +csty.Span; ++i)cstys[cstys.length] = dup(csty);
            break;
        case "namedrange" /*case 'NamedRange'*/ :
            if (Rn[1] === "/") break;
            if (!Workbook.Names) Workbook.Names = [];
            var _NamedRange = parsexmltag(Rn[0]);
            var _DefinedName /*:DefinedName*/  = {
                Name: _NamedRange.Name,
                Ref: rc_to_a1(_NamedRange.RefersTo.slice(1), {
                    r: 0,
                    c: 0
                })
            } /*:any*/ ;
            if (Workbook.Sheets.length > 0) _DefinedName.Sheet = Workbook.Sheets.length - 1;
            /*:: if(Workbook.Names) */ Workbook.Names.push(_DefinedName);
            break;
        case "namedcell" /*case 'NamedCell'*/ :
            break;
        case "b" /*case 'B'*/ :
            break;
        case "i" /*case 'I'*/ :
            break;
        case "u" /*case 'U'*/ :
            break;
        case "s" /*case 'S'*/ :
            break;
        case "em" /*case 'EM'*/ :
            break;
        case "h2" /*case 'H2'*/ :
            break;
        case "h3" /*case 'H3'*/ :
            break;
        case "sub" /*case 'Sub'*/ :
            break;
        case "sup" /*case 'Sup'*/ :
            break;
        case "span" /*case 'Span'*/ :
            break;
        case "alignment" /*case 'Alignment'*/ :
            break;
        case "borders" /*case 'Borders'*/ :
            break;
        case "border" /*case 'Border'*/ :
            break;
        case "font" /*case 'Font'*/ :
            if (Rn[0].slice(-2) === "/>") break;
            else if (Rn[1] === "/") ss += str.slice(fidx, Rn.index);
            else fidx = Rn.index + Rn[0].length;
            break;
        case "interior" /*case 'Interior'*/ :
            if (!opts.cellStyles) break;
            stag.Interior = xlml_parsexmltag(Rn[0]);
            break;
        case "protection" /*case 'Protection'*/ :
            break;
        case "author" /*case 'Author'*/ :
        case "title" /*case 'Title'*/ :
        case "description" /*case 'Description'*/ :
        case "created" /*case 'Created'*/ :
        case "keywords" /*case 'Keywords'*/ :
        case "subject" /*case 'Subject'*/ :
        case "category" /*case 'Category'*/ :
        case "company" /*case 'Company'*/ :
        case "lastauthor" /*case 'LastAuthor'*/ :
        case "lastsaved" /*case 'LastSaved'*/ :
        case "lastprinted" /*case 'LastPrinted'*/ :
        case "version" /*case 'Version'*/ :
        case "revision" /*case 'Revision'*/ :
        case "totaltime" /*case 'TotalTime'*/ :
        case "hyperlinkbase" /*case 'HyperlinkBase'*/ :
        case "manager" /*case 'Manager'*/ :
        case "contentstatus" /*case 'ContentStatus'*/ :
        case "identifier" /*case 'Identifier'*/ :
        case "language" /*case 'Language'*/ :
        case "appname" /*case 'AppName'*/ :
            if (Rn[0].slice(-2) === "/>") break;
            else if (Rn[1] === "/") xlml_set_prop(Props, raw_Rn3, str.slice(pidx, Rn.index));
            else pidx = Rn.index + Rn[0].length;
            break;
        case "paragraphs" /*case 'Paragraphs'*/ :
            break;
        case "styles" /*case 'Styles'*/ :
        case "workbook" /*case 'Workbook'*/ :
            if (Rn[1] === "/") {
                if ((tmp = state.pop())[0] !== Rn[3]) throw new Error("Bad state: " + tmp.join("|"));
            } else state.push([
                Rn[3],
                false
            ]);
            break;
        case "comment" /*case 'Comment'*/ :
            if (Rn[1] === "/") {
                if ((tmp = state.pop())[0] !== Rn[3]) throw new Error("Bad state: " + tmp.join("|"));
                xlml_clean_comment(comment);
                comments.push(comment);
            } else {
                state.push([
                    Rn[3],
                    false
                ]);
                tmp = xlml_parsexmltag(Rn[0]);
                comment = {
                    a: tmp.Author
                } /*:any*/ ;
            }
            break;
        case "autofilter" /*case 'AutoFilter'*/ :
            if (Rn[1] === "/") {
                if ((tmp = state.pop())[0] !== Rn[3]) throw new Error("Bad state: " + tmp.join("|"));
            } else if (Rn[0].charAt(Rn[0].length - 2) !== "/") {
                var AutoFilter = xlml_parsexmltag(Rn[0]);
                cursheet["!autofilter"] = {
                    ref: rc_to_a1(AutoFilter.Range).replace(/\$/g, "")
                };
                state.push([
                    Rn[3],
                    true
                ]);
            }
            break;
        case "name" /*case 'Name'*/ :
            break;
        case "datavalidation" /*case 'DataValidation'*/ :
            if (Rn[1] === "/") {
                if ((tmp = state.pop())[0] !== Rn[3]) throw new Error("Bad state: " + tmp.join("|"));
            } else if (Rn[0].charAt(Rn[0].length - 2) !== "/") state.push([
                Rn[3],
                true
            ]);
            break;
        case "pixelsperinch" /*case 'PixelsPerInch'*/ :
            break;
        case "componentoptions" /*case 'ComponentOptions'*/ :
        case "documentproperties" /*case 'DocumentProperties'*/ :
        case "customdocumentproperties" /*case 'CustomDocumentProperties'*/ :
        case "officedocumentsettings" /*case 'OfficeDocumentSettings'*/ :
        case "pivottable" /*case 'PivotTable'*/ :
        case "pivotcache" /*case 'PivotCache'*/ :
        case "names" /*case 'Names'*/ :
        case "mapinfo" /*case 'MapInfo'*/ :
        case "pagebreaks" /*case 'PageBreaks'*/ :
        case "querytable" /*case 'QueryTable'*/ :
        case "sorting" /*case 'Sorting'*/ :
        case "schema" /*case 'Schema'*/ :
        case "conditionalformatting" /*case 'ConditionalFormatting'*/ :
        case "smarttagtype" /*case 'SmartTagType'*/ :
        case "smarttags" /*case 'SmartTags'*/ :
        case "excelworkbook" /*case 'ExcelWorkbook'*/ :
        case "workbookoptions" /*case 'WorkbookOptions'*/ :
        case "worksheetoptions" /*case 'WorksheetOptions'*/ :
            if (Rn[1] === "/") {
                if ((tmp = state.pop())[0] !== Rn[3]) throw new Error("Bad state: " + tmp.join("|"));
            } else if (Rn[0].charAt(Rn[0].length - 2) !== "/") state.push([
                Rn[3],
                true
            ]);
            break;
        case "null" /*case 'Null'*/ :
            break;
        default:
            /* FODS file root is <office:document> */ if (state.length == 0 && Rn[3] == "document") return parse_fods(str, opts);
            /* UOS file root is <uof:UOF> */ if (state.length == 0 && Rn[3] == "uof" /*"UOF"*/ ) return parse_fods(str, opts);
            var seen = true;
            switch(state[state.length - 1][0]){
                /* OfficeDocumentSettings */ case "officedocumentsettings" /*case 'OfficeDocumentSettings'*/ :
                    switch(Rn[3]){
                        case "allowpng" /*case 'AllowPNG'*/ :
                            break;
                        case "removepersonalinformation" /*case 'RemovePersonalInformation'*/ :
                            break;
                        case "downloadcomponents" /*case 'DownloadComponents'*/ :
                            break;
                        case "locationofcomponents" /*case 'LocationOfComponents'*/ :
                            break;
                        case "colors" /*case 'Colors'*/ :
                            break;
                        case "color" /*case 'Color'*/ :
                            break;
                        case "index" /*case 'Index'*/ :
                            break;
                        case "rgb" /*case 'RGB'*/ :
                            break;
                        case "targetscreensize" /*case 'TargetScreenSize'*/ :
                            break;
                        case "readonlyrecommended" /*case 'ReadOnlyRecommended'*/ :
                            break;
                        default:
                            seen = false;
                    }
                    break;
                /* ComponentOptions */ case "componentoptions" /*case 'ComponentOptions'*/ :
                    switch(Rn[3]){
                        case "toolbar" /*case 'Toolbar'*/ :
                            break;
                        case "hideofficelogo" /*case 'HideOfficeLogo'*/ :
                            break;
                        case "spreadsheetautofit" /*case 'SpreadsheetAutoFit'*/ :
                            break;
                        case "label" /*case 'Label'*/ :
                            break;
                        case "caption" /*case 'Caption'*/ :
                            break;
                        case "maxheight" /*case 'MaxHeight'*/ :
                            break;
                        case "maxwidth" /*case 'MaxWidth'*/ :
                            break;
                        case "nextsheetnumber" /*case 'NextSheetNumber'*/ :
                            break;
                        default:
                            seen = false;
                    }
                    break;
                /* ExcelWorkbook */ case "excelworkbook" /*case 'ExcelWorkbook'*/ :
                    switch(Rn[3]){
                        case "date1904" /*case 'Date1904'*/ :
                            /*:: if(!Workbook.WBProps) Workbook.WBProps = {}; */ Workbook.WBProps.date1904 = true;
                            break;
                        case "windowheight" /*case 'WindowHeight'*/ :
                            break;
                        case "windowwidth" /*case 'WindowWidth'*/ :
                            break;
                        case "windowtopx" /*case 'WindowTopX'*/ :
                            break;
                        case "windowtopy" /*case 'WindowTopY'*/ :
                            break;
                        case "tabratio" /*case 'TabRatio'*/ :
                            break;
                        case "protectstructure" /*case 'ProtectStructure'*/ :
                            break;
                        case "protectwindow" /*case 'ProtectWindow'*/ :
                            break;
                        case "protectwindows" /*case 'ProtectWindows'*/ :
                            break;
                        case "activesheet" /*case 'ActiveSheet'*/ :
                            break;
                        case "displayinknotes" /*case 'DisplayInkNotes'*/ :
                            break;
                        case "firstvisiblesheet" /*case 'FirstVisibleSheet'*/ :
                            break;
                        case "supbook" /*case 'SupBook'*/ :
                            break;
                        case "sheetname" /*case 'SheetName'*/ :
                            break;
                        case "sheetindex" /*case 'SheetIndex'*/ :
                            break;
                        case "sheetindexfirst" /*case 'SheetIndexFirst'*/ :
                            break;
                        case "sheetindexlast" /*case 'SheetIndexLast'*/ :
                            break;
                        case "dll" /*case 'Dll'*/ :
                            break;
                        case "acceptlabelsinformulas" /*case 'AcceptLabelsInFormulas'*/ :
                            break;
                        case "donotsavelinkvalues" /*case 'DoNotSaveLinkValues'*/ :
                            break;
                        case "iteration" /*case 'Iteration'*/ :
                            break;
                        case "maxiterations" /*case 'MaxIterations'*/ :
                            break;
                        case "maxchange" /*case 'MaxChange'*/ :
                            break;
                        case "path" /*case 'Path'*/ :
                            break;
                        case "xct" /*case 'Xct'*/ :
                            break;
                        case "count" /*case 'Count'*/ :
                            break;
                        case "selectedsheets" /*case 'SelectedSheets'*/ :
                            break;
                        case "calculation" /*case 'Calculation'*/ :
                            break;
                        case "uncalced" /*case 'Uncalced'*/ :
                            break;
                        case "startupprompt" /*case 'StartupPrompt'*/ :
                            break;
                        case "crn" /*case 'Crn'*/ :
                            break;
                        case "externname" /*case 'ExternName'*/ :
                            break;
                        case "formula" /*case 'Formula'*/ :
                            break;
                        case "colfirst" /*case 'ColFirst'*/ :
                            break;
                        case "collast" /*case 'ColLast'*/ :
                            break;
                        case "wantadvise" /*case 'WantAdvise'*/ :
                            break;
                        case "boolean" /*case 'Boolean'*/ :
                            break;
                        case "error" /*case 'Error'*/ :
                            break;
                        case "text" /*case 'Text'*/ :
                            break;
                        case "ole" /*case 'OLE'*/ :
                            break;
                        case "noautorecover" /*case 'NoAutoRecover'*/ :
                            break;
                        case "publishobjects" /*case 'PublishObjects'*/ :
                            break;
                        case "donotcalculatebeforesave" /*case 'DoNotCalculateBeforeSave'*/ :
                            break;
                        case "number" /*case 'Number'*/ :
                            break;
                        case "refmoder1c1" /*case 'RefModeR1C1'*/ :
                            break;
                        case "embedsavesmarttags" /*case 'EmbedSaveSmartTags'*/ :
                            break;
                        default:
                            seen = false;
                    }
                    break;
                /* WorkbookOptions */ case "workbookoptions" /*case 'WorkbookOptions'*/ :
                    switch(Rn[3]){
                        case "owcversion" /*case 'OWCVersion'*/ :
                            break;
                        case "height" /*case 'Height'*/ :
                            break;
                        case "width" /*case 'Width'*/ :
                            break;
                        default:
                            seen = false;
                    }
                    break;
                /* WorksheetOptions */ case "worksheetoptions" /*case 'WorksheetOptions'*/ :
                    switch(Rn[3]){
                        case "visible" /*case 'Visible'*/ :
                            if (Rn[0].slice(-2) === "/>") ;
                            else if (Rn[1] === "/") switch(str.slice(pidx, Rn.index)){
                                case "SheetHidden":
                                    wsprops.Hidden = 1;
                                    break;
                                case "SheetVeryHidden":
                                    wsprops.Hidden = 2;
                                    break;
                            }
                            else pidx = Rn.index + Rn[0].length;
                            break;
                        case "header" /*case 'Header'*/ :
                            if (!cursheet["!margins"]) default_margins(cursheet["!margins"] = {}, "xlml");
                            if (!isNaN(+parsexmltag(Rn[0]).Margin)) cursheet["!margins"].header = +parsexmltag(Rn[0]).Margin;
                            break;
                        case "footer" /*case 'Footer'*/ :
                            if (!cursheet["!margins"]) default_margins(cursheet["!margins"] = {}, "xlml");
                            if (!isNaN(+parsexmltag(Rn[0]).Margin)) cursheet["!margins"].footer = +parsexmltag(Rn[0]).Margin;
                            break;
                        case "pagemargins" /*case 'PageMargins'*/ :
                            var pagemargins = parsexmltag(Rn[0]);
                            if (!cursheet["!margins"]) default_margins(cursheet["!margins"] = {}, "xlml");
                            if (!isNaN(+pagemargins.Top)) cursheet["!margins"].top = +pagemargins.Top;
                            if (!isNaN(+pagemargins.Left)) cursheet["!margins"].left = +pagemargins.Left;
                            if (!isNaN(+pagemargins.Right)) cursheet["!margins"].right = +pagemargins.Right;
                            if (!isNaN(+pagemargins.Bottom)) cursheet["!margins"].bottom = +pagemargins.Bottom;
                            break;
                        case "displayrighttoleft" /*case 'DisplayRightToLeft'*/ :
                            if (!Workbook.Views) Workbook.Views = [];
                            if (!Workbook.Views[0]) Workbook.Views[0] = {};
                            Workbook.Views[0].RTL = true;
                            break;
                        case "freezepanes" /*case 'FreezePanes'*/ :
                            break;
                        case "frozennosplit" /*case 'FrozenNoSplit'*/ :
                            break;
                        case "splithorizontal" /*case 'SplitHorizontal'*/ :
                        case "splitvertical" /*case 'SplitVertical'*/ :
                            break;
                        case "donotdisplaygridlines" /*case 'DoNotDisplayGridlines'*/ :
                            break;
                        case "activerow" /*case 'ActiveRow'*/ :
                            break;
                        case "activecol" /*case 'ActiveCol'*/ :
                            break;
                        case "toprowbottompane" /*case 'TopRowBottomPane'*/ :
                            break;
                        case "leftcolumnrightpane" /*case 'LeftColumnRightPane'*/ :
                            break;
                        case "unsynced" /*case 'Unsynced'*/ :
                            break;
                        case "print" /*case 'Print'*/ :
                            break;
                        case "printerrors" /*case 'PrintErrors'*/ :
                            break;
                        case "panes" /*case 'Panes'*/ :
                            break;
                        case "scale" /*case 'Scale'*/ :
                            break;
                        case "pane" /*case 'Pane'*/ :
                            break;
                        case "number" /*case 'Number'*/ :
                            break;
                        case "layout" /*case 'Layout'*/ :
                            break;
                        case "pagesetup" /*case 'PageSetup'*/ :
                            break;
                        case "selected" /*case 'Selected'*/ :
                            break;
                        case "protectobjects" /*case 'ProtectObjects'*/ :
                            break;
                        case "enableselection" /*case 'EnableSelection'*/ :
                            break;
                        case "protectscenarios" /*case 'ProtectScenarios'*/ :
                            break;
                        case "validprinterinfo" /*case 'ValidPrinterInfo'*/ :
                            break;
                        case "horizontalresolution" /*case 'HorizontalResolution'*/ :
                            break;
                        case "verticalresolution" /*case 'VerticalResolution'*/ :
                            break;
                        case "numberofcopies" /*case 'NumberofCopies'*/ :
                            break;
                        case "activepane" /*case 'ActivePane'*/ :
                            break;
                        case "toprowvisible" /*case 'TopRowVisible'*/ :
                            break;
                        case "leftcolumnvisible" /*case 'LeftColumnVisible'*/ :
                            break;
                        case "fittopage" /*case 'FitToPage'*/ :
                            break;
                        case "rangeselection" /*case 'RangeSelection'*/ :
                            break;
                        case "papersizeindex" /*case 'PaperSizeIndex'*/ :
                            break;
                        case "pagelayoutzoom" /*case 'PageLayoutZoom'*/ :
                            break;
                        case "pagebreakzoom" /*case 'PageBreakZoom'*/ :
                            break;
                        case "filteron" /*case 'FilterOn'*/ :
                            break;
                        case "fitwidth" /*case 'FitWidth'*/ :
                            break;
                        case "fitheight" /*case 'FitHeight'*/ :
                            break;
                        case "commentslayout" /*case 'CommentsLayout'*/ :
                            break;
                        case "zoom" /*case 'Zoom'*/ :
                            break;
                        case "lefttoright" /*case 'LeftToRight'*/ :
                            break;
                        case "gridlines" /*case 'Gridlines'*/ :
                            break;
                        case "allowsort" /*case 'AllowSort'*/ :
                            break;
                        case "allowfilter" /*case 'AllowFilter'*/ :
                            break;
                        case "allowinsertrows" /*case 'AllowInsertRows'*/ :
                            break;
                        case "allowdeleterows" /*case 'AllowDeleteRows'*/ :
                            break;
                        case "allowinsertcols" /*case 'AllowInsertCols'*/ :
                            break;
                        case "allowdeletecols" /*case 'AllowDeleteCols'*/ :
                            break;
                        case "allowinserthyperlinks" /*case 'AllowInsertHyperlinks'*/ :
                            break;
                        case "allowformatcells" /*case 'AllowFormatCells'*/ :
                            break;
                        case "allowsizecols" /*case 'AllowSizeCols'*/ :
                            break;
                        case "allowsizerows" /*case 'AllowSizeRows'*/ :
                            break;
                        case "nosummaryrowsbelowdetail" /*case 'NoSummaryRowsBelowDetail'*/ :
                            if (!cursheet["!outline"]) cursheet["!outline"] = {};
                            cursheet["!outline"].above = true;
                            break;
                        case "tabcolorindex" /*case 'TabColorIndex'*/ :
                            break;
                        case "donotdisplayheadings" /*case 'DoNotDisplayHeadings'*/ :
                            break;
                        case "showpagelayoutzoom" /*case 'ShowPageLayoutZoom'*/ :
                            break;
                        case "nosummarycolumnsrightdetail" /*case 'NoSummaryColumnsRightDetail'*/ :
                            if (!cursheet["!outline"]) cursheet["!outline"] = {};
                            cursheet["!outline"].left = true;
                            break;
                        case "blackandwhite" /*case 'BlackAndWhite'*/ :
                            break;
                        case "donotdisplayzeros" /*case 'DoNotDisplayZeros'*/ :
                            break;
                        case "displaypagebreak" /*case 'DisplayPageBreak'*/ :
                            break;
                        case "rowcolheadings" /*case 'RowColHeadings'*/ :
                            break;
                        case "donotdisplayoutline" /*case 'DoNotDisplayOutline'*/ :
                            break;
                        case "noorientation" /*case 'NoOrientation'*/ :
                            break;
                        case "allowusepivottables" /*case 'AllowUsePivotTables'*/ :
                            break;
                        case "zeroheight" /*case 'ZeroHeight'*/ :
                            break;
                        case "viewablerange" /*case 'ViewableRange'*/ :
                            break;
                        case "selection" /*case 'Selection'*/ :
                            break;
                        case "protectcontents" /*case 'ProtectContents'*/ :
                            break;
                        default:
                            seen = false;
                    }
                    break;
                /* PivotTable */ case "pivottable" /*case 'PivotTable'*/ :
                case "pivotcache" /*case 'PivotCache'*/ :
                    switch(Rn[3]){
                        case "immediateitemsondrop" /*case 'ImmediateItemsOnDrop'*/ :
                            break;
                        case "showpagemultipleitemlabel" /*case 'ShowPageMultipleItemLabel'*/ :
                            break;
                        case "compactrowindent" /*case 'CompactRowIndent'*/ :
                            break;
                        case "location" /*case 'Location'*/ :
                            break;
                        case "pivotfield" /*case 'PivotField'*/ :
                            break;
                        case "orientation" /*case 'Orientation'*/ :
                            break;
                        case "layoutform" /*case 'LayoutForm'*/ :
                            break;
                        case "layoutsubtotallocation" /*case 'LayoutSubtotalLocation'*/ :
                            break;
                        case "layoutcompactrow" /*case 'LayoutCompactRow'*/ :
                            break;
                        case "position" /*case 'Position'*/ :
                            break;
                        case "pivotitem" /*case 'PivotItem'*/ :
                            break;
                        case "datatype" /*case 'DataType'*/ :
                            break;
                        case "datafield" /*case 'DataField'*/ :
                            break;
                        case "sourcename" /*case 'SourceName'*/ :
                            break;
                        case "parentfield" /*case 'ParentField'*/ :
                            break;
                        case "ptlineitems" /*case 'PTLineItems'*/ :
                            break;
                        case "ptlineitem" /*case 'PTLineItem'*/ :
                            break;
                        case "countofsameitems" /*case 'CountOfSameItems'*/ :
                            break;
                        case "item" /*case 'Item'*/ :
                            break;
                        case "itemtype" /*case 'ItemType'*/ :
                            break;
                        case "ptsource" /*case 'PTSource'*/ :
                            break;
                        case "cacheindex" /*case 'CacheIndex'*/ :
                            break;
                        case "consolidationreference" /*case 'ConsolidationReference'*/ :
                            break;
                        case "filename" /*case 'FileName'*/ :
                            break;
                        case "reference" /*case 'Reference'*/ :
                            break;
                        case "nocolumngrand" /*case 'NoColumnGrand'*/ :
                            break;
                        case "norowgrand" /*case 'NoRowGrand'*/ :
                            break;
                        case "blanklineafteritems" /*case 'BlankLineAfterItems'*/ :
                            break;
                        case "hidden" /*case 'Hidden'*/ :
                            break;
                        case "subtotal" /*case 'Subtotal'*/ :
                            break;
                        case "basefield" /*case 'BaseField'*/ :
                            break;
                        case "mapchilditems" /*case 'MapChildItems'*/ :
                            break;
                        case "function" /*case 'Function'*/ :
                            break;
                        case "refreshonfileopen" /*case 'RefreshOnFileOpen'*/ :
                            break;
                        case "printsettitles" /*case 'PrintSetTitles'*/ :
                            break;
                        case "mergelabels" /*case 'MergeLabels'*/ :
                            break;
                        case "defaultversion" /*case 'DefaultVersion'*/ :
                            break;
                        case "refreshname" /*case 'RefreshName'*/ :
                            break;
                        case "refreshdate" /*case 'RefreshDate'*/ :
                            break;
                        case "refreshdatecopy" /*case 'RefreshDateCopy'*/ :
                            break;
                        case "versionlastrefresh" /*case 'VersionLastRefresh'*/ :
                            break;
                        case "versionlastupdate" /*case 'VersionLastUpdate'*/ :
                            break;
                        case "versionupdateablemin" /*case 'VersionUpdateableMin'*/ :
                            break;
                        case "versionrefreshablemin" /*case 'VersionRefreshableMin'*/ :
                            break;
                        case "calculation" /*case 'Calculation'*/ :
                            break;
                        default:
                            seen = false;
                    }
                    break;
                /* PageBreaks */ case "pagebreaks" /*case 'PageBreaks'*/ :
                    switch(Rn[3]){
                        case "colbreaks" /*case 'ColBreaks'*/ :
                            break;
                        case "colbreak" /*case 'ColBreak'*/ :
                            break;
                        case "rowbreaks" /*case 'RowBreaks'*/ :
                            break;
                        case "rowbreak" /*case 'RowBreak'*/ :
                            break;
                        case "colstart" /*case 'ColStart'*/ :
                            break;
                        case "colend" /*case 'ColEnd'*/ :
                            break;
                        case "rowend" /*case 'RowEnd'*/ :
                            break;
                        default:
                            seen = false;
                    }
                    break;
                /* AutoFilter */ case "autofilter" /*case 'AutoFilter'*/ :
                    switch(Rn[3]){
                        case "autofiltercolumn" /*case 'AutoFilterColumn'*/ :
                            break;
                        case "autofiltercondition" /*case 'AutoFilterCondition'*/ :
                            break;
                        case "autofilterand" /*case 'AutoFilterAnd'*/ :
                            break;
                        case "autofilteror" /*case 'AutoFilterOr'*/ :
                            break;
                        default:
                            seen = false;
                    }
                    break;
                /* QueryTable */ case "querytable" /*case 'QueryTable'*/ :
                    switch(Rn[3]){
                        case "id" /*case 'Id'*/ :
                            break;
                        case "autoformatfont" /*case 'AutoFormatFont'*/ :
                            break;
                        case "autoformatpattern" /*case 'AutoFormatPattern'*/ :
                            break;
                        case "querysource" /*case 'QuerySource'*/ :
                            break;
                        case "querytype" /*case 'QueryType'*/ :
                            break;
                        case "enableredirections" /*case 'EnableRedirections'*/ :
                            break;
                        case "refreshedinxl9" /*case 'RefreshedInXl9'*/ :
                            break;
                        case "urlstring" /*case 'URLString'*/ :
                            break;
                        case "htmltables" /*case 'HTMLTables'*/ :
                            break;
                        case "connection" /*case 'Connection'*/ :
                            break;
                        case "commandtext" /*case 'CommandText'*/ :
                            break;
                        case "refreshinfo" /*case 'RefreshInfo'*/ :
                            break;
                        case "notitles" /*case 'NoTitles'*/ :
                            break;
                        case "nextid" /*case 'NextId'*/ :
                            break;
                        case "columninfo" /*case 'ColumnInfo'*/ :
                            break;
                        case "overwritecells" /*case 'OverwriteCells'*/ :
                            break;
                        case "donotpromptforfile" /*case 'DoNotPromptForFile'*/ :
                            break;
                        case "textwizardsettings" /*case 'TextWizardSettings'*/ :
                            break;
                        case "source" /*case 'Source'*/ :
                            break;
                        case "number" /*case 'Number'*/ :
                            break;
                        case "decimal" /*case 'Decimal'*/ :
                            break;
                        case "thousandseparator" /*case 'ThousandSeparator'*/ :
                            break;
                        case "trailingminusnumbers" /*case 'TrailingMinusNumbers'*/ :
                            break;
                        case "formatsettings" /*case 'FormatSettings'*/ :
                            break;
                        case "fieldtype" /*case 'FieldType'*/ :
                            break;
                        case "delimiters" /*case 'Delimiters'*/ :
                            break;
                        case "tab" /*case 'Tab'*/ :
                            break;
                        case "comma" /*case 'Comma'*/ :
                            break;
                        case "autoformatname" /*case 'AutoFormatName'*/ :
                            break;
                        case "versionlastedit" /*case 'VersionLastEdit'*/ :
                            break;
                        case "versionlastrefresh" /*case 'VersionLastRefresh'*/ :
                            break;
                        default:
                            seen = false;
                    }
                    break;
                case "datavalidation" /*case 'DataValidation'*/ :
                    switch(Rn[3]){
                        case "range" /*case 'Range'*/ :
                            break;
                        case "type" /*case 'Type'*/ :
                            break;
                        case "min" /*case 'Min'*/ :
                            break;
                        case "max" /*case 'Max'*/ :
                            break;
                        case "sort" /*case 'Sort'*/ :
                            break;
                        case "descending" /*case 'Descending'*/ :
                            break;
                        case "order" /*case 'Order'*/ :
                            break;
                        case "casesensitive" /*case 'CaseSensitive'*/ :
                            break;
                        case "value" /*case 'Value'*/ :
                            break;
                        case "errorstyle" /*case 'ErrorStyle'*/ :
                            break;
                        case "errormessage" /*case 'ErrorMessage'*/ :
                            break;
                        case "errortitle" /*case 'ErrorTitle'*/ :
                            break;
                        case "inputmessage" /*case 'InputMessage'*/ :
                            break;
                        case "inputtitle" /*case 'InputTitle'*/ :
                            break;
                        case "combohide" /*case 'ComboHide'*/ :
                            break;
                        case "inputhide" /*case 'InputHide'*/ :
                            break;
                        case "condition" /*case 'Condition'*/ :
                            break;
                        case "qualifier" /*case 'Qualifier'*/ :
                            break;
                        case "useblank" /*case 'UseBlank'*/ :
                            break;
                        case "value1" /*case 'Value1'*/ :
                            break;
                        case "value2" /*case 'Value2'*/ :
                            break;
                        case "format" /*case 'Format'*/ :
                            break;
                        case "cellrangelist" /*case 'CellRangeList'*/ :
                            break;
                        default:
                            seen = false;
                    }
                    break;
                case "sorting" /*case 'Sorting'*/ :
                case "conditionalformatting" /*case 'ConditionalFormatting'*/ :
                    switch(Rn[3]){
                        case "range" /*case 'Range'*/ :
                            break;
                        case "type" /*case 'Type'*/ :
                            break;
                        case "min" /*case 'Min'*/ :
                            break;
                        case "max" /*case 'Max'*/ :
                            break;
                        case "sort" /*case 'Sort'*/ :
                            break;
                        case "descending" /*case 'Descending'*/ :
                            break;
                        case "order" /*case 'Order'*/ :
                            break;
                        case "casesensitive" /*case 'CaseSensitive'*/ :
                            break;
                        case "value" /*case 'Value'*/ :
                            break;
                        case "errorstyle" /*case 'ErrorStyle'*/ :
                            break;
                        case "errormessage" /*case 'ErrorMessage'*/ :
                            break;
                        case "errortitle" /*case 'ErrorTitle'*/ :
                            break;
                        case "cellrangelist" /*case 'CellRangeList'*/ :
                            break;
                        case "inputmessage" /*case 'InputMessage'*/ :
                            break;
                        case "inputtitle" /*case 'InputTitle'*/ :
                            break;
                        case "combohide" /*case 'ComboHide'*/ :
                            break;
                        case "inputhide" /*case 'InputHide'*/ :
                            break;
                        case "condition" /*case 'Condition'*/ :
                            break;
                        case "qualifier" /*case 'Qualifier'*/ :
                            break;
                        case "useblank" /*case 'UseBlank'*/ :
                            break;
                        case "value1" /*case 'Value1'*/ :
                            break;
                        case "value2" /*case 'Value2'*/ :
                            break;
                        case "format" /*case 'Format'*/ :
                            break;
                        default:
                            seen = false;
                    }
                    break;
                /* MapInfo (schema) */ case "mapinfo" /*case 'MapInfo'*/ :
                case "schema" /*case 'Schema'*/ :
                case "data" /*case 'data'*/ :
                    switch(Rn[3]){
                        case "map" /*case 'Map'*/ :
                            break;
                        case "entry" /*case 'Entry'*/ :
                            break;
                        case "range" /*case 'Range'*/ :
                            break;
                        case "xpath" /*case 'XPath'*/ :
                            break;
                        case "field" /*case 'Field'*/ :
                            break;
                        case "xsdtype" /*case 'XSDType'*/ :
                            break;
                        case "filteron" /*case 'FilterOn'*/ :
                            break;
                        case "aggregate" /*case 'Aggregate'*/ :
                            break;
                        case "elementtype" /*case 'ElementType'*/ :
                            break;
                        case "attributetype" /*case 'AttributeType'*/ :
                            break;
                        /* These are from xsd (XML Schema Definition) */ case "schema" /*case 'schema'*/ :
                        case "element" /*case 'element'*/ :
                        case "complextype" /*case 'complexType'*/ :
                        case "datatype" /*case 'datatype'*/ :
                        case "all" /*case 'all'*/ :
                        case "attribute" /*case 'attribute'*/ :
                        case "extends" /*case 'extends'*/ :
                            break;
                        case "row" /*case 'row'*/ :
                            break;
                        default:
                            seen = false;
                    }
                    break;
                /* SmartTags (can be anything) */ case "smarttags" /*case 'SmartTags'*/ :
                    break;
                default:
                    seen = false;
                    break;
            }
            if (seen) break;
            /* CustomDocumentProperties */ if (Rn[3].match(/!\[CDATA/)) break;
            if (!state[state.length - 1][1]) throw "Unrecognized tag: " + Rn[3] + "|" + state.join("|");
            if (state[state.length - 1][0] === /*'CustomDocumentProperties'*/ "customdocumentproperties") {
                if (Rn[0].slice(-2) === "/>") break;
                else if (Rn[1] === "/") xlml_set_custprop(Custprops, raw_Rn3, cp, str.slice(pidx, Rn.index));
                else {
                    cp = Rn;
                    pidx = Rn.index + Rn[0].length;
                }
                break;
            }
            if (opts.WTF) throw "Unrecognized tag: " + Rn[3] + "|" + state.join("|");
    }
    var out = {} /*:any*/ ;
    if (!opts.bookSheets && !opts.bookProps) out.Sheets = sheets;
    out.SheetNames = sheetnames;
    out.Workbook = Workbook;
    out.SSF = dup(table_fmt);
    out.Props = Props;
    out.Custprops = Custprops;
    return out;
}
function parse_xlml(data /*:RawBytes|string*/ , opts) /*:Workbook*/ {
    fix_read_opts(opts = opts || {});
    switch(opts.type || "base64"){
        case "base64":
            return parse_xlml_xml(Base64_decode(data), opts);
        case "binary":
        case "buffer":
        case "file":
            return parse_xlml_xml(data, opts);
        case "array":
            return parse_xlml_xml(a2s(data), opts);
    }
/*:: throw new Error("unsupported type " + opts.type); */ }
/* TODO */ function write_props_xlml(wb /*:Workbook*/ , opts) /*:string*/ {
    var o /*:Array<string>*/  = [];
    /* DocumentProperties */ if (wb.Props) o.push(xlml_write_docprops(wb.Props, opts));
    /* CustomDocumentProperties */ if (wb.Custprops) o.push(xlml_write_custprops(wb.Props, wb.Custprops, opts));
    return o.join("");
}
/* TODO */ function write_wb_xlml() /*:string*/ {
    /* OfficeDocumentSettings */ /* ExcelWorkbook */ return "";
}
/* TODO */ function write_sty_xlml(wb, opts) /*:string*/ {
    /* Styles */ var styles /*:Array<string>*/  = [
        '<Style ss:ID="Default" ss:Name="Normal"><NumberFormat/></Style>'
    ];
    opts.cellXfs.forEach(function(xf, id) {
        var payload /*:Array<string>*/  = [];
        payload.push(writextag("NumberFormat", null, {
            "ss:Format": escapexml(table_fmt[xf.numFmtId])
        }));
        var o = /*::(*/ {
            "ss:ID": "s" + (21 + id)
        } /*:: :any)*/ ;
        styles.push(writextag("Style", payload.join(""), o));
    });
    return writextag("Styles", styles.join(""));
}
function write_name_xlml(n) {
    return writextag("NamedRange", null, {
        "ss:Name": n.Name,
        "ss:RefersTo": "=" + a1_to_rc(n.Ref, {
            r: 0,
            c: 0
        })
    });
}
function write_names_xlml(wb /*::, opts*/ ) /*:string*/ {
    if (!((wb || {}).Workbook || {}).Names) return "";
    /*:: if(!wb || !wb.Workbook || !wb.Workbook.Names) throw new Error("unreachable"); */ var names /*:Array<any>*/  = wb.Workbook.Names;
    var out /*:Array<string>*/  = [];
    for(var i = 0; i < names.length; ++i){
        var n = names[i];
        if (n.Sheet != null) continue;
        if (n.Name.match(/^_xlfn\./)) continue;
        out.push(write_name_xlml(n));
    }
    return writextag("Names", out.join(""));
}
function write_ws_xlml_names(ws /*:Worksheet*/ , opts, idx /*:number*/ , wb /*:Workbook*/ ) /*:string*/ {
    if (!ws) return "";
    if (!((wb || {}).Workbook || {}).Names) return "";
    /*:: if(!wb || !wb.Workbook || !wb.Workbook.Names) throw new Error("unreachable"); */ var names /*:Array<any>*/  = wb.Workbook.Names;
    var out /*:Array<string>*/  = [];
    for(var i = 0; i < names.length; ++i){
        var n = names[i];
        if (n.Sheet != idx) continue;
        /*switch(n.Name) {
			case "_": continue;
		}*/ if (n.Name.match(/^_xlfn\./)) continue;
        out.push(write_name_xlml(n));
    }
    return out.join("");
}
/* WorksheetOptions */ function write_ws_xlml_wsopts(ws /*:Worksheet*/ , opts, idx /*:number*/ , wb /*:Workbook*/ ) /*:string*/ {
    if (!ws) return "";
    var o /*:Array<string>*/  = [];
    /* NOTE: spec technically allows any order, but stick with implied order */ /* FitToPage */ /* DoNotDisplayColHeaders */ /* DoNotDisplayRowHeaders */ /* ViewableRange */ /* Selection */ /* GridlineColor */ /* Name */ /* ExcelWorksheetType */ /* IntlMacro */ /* Unsynced */ /* Selected */ /* CodeName */ if (ws["!margins"]) {
        o.push("<PageSetup>");
        if (ws["!margins"].header) o.push(writextag("Header", null, {
            "x:Margin": ws["!margins"].header
        }));
        if (ws["!margins"].footer) o.push(writextag("Footer", null, {
            "x:Margin": ws["!margins"].footer
        }));
        o.push(writextag("PageMargins", null, {
            "x:Bottom": ws["!margins"].bottom || "0.75",
            "x:Left": ws["!margins"].left || "0.7",
            "x:Right": ws["!margins"].right || "0.7",
            "x:Top": ws["!margins"].top || "0.75"
        }));
        o.push("</PageSetup>");
    }
    /* PageSetup */ /* DisplayPageBreak */ /* TransitionExpressionEvaluation */ /* TransitionFormulaEntry */ /* Print */ /* Zoom */ /* PageLayoutZoom */ /* PageBreakZoom */ /* ShowPageBreakZoom */ /* DefaultRowHeight */ /* DefaultColumnWidth */ /* StandardWidth */ if (wb && wb.Workbook && wb.Workbook.Sheets && wb.Workbook.Sheets[idx]) {
        /* Visible */ if (wb.Workbook.Sheets[idx].Hidden) o.push(writextag("Visible", wb.Workbook.Sheets[idx].Hidden == 1 ? "SheetHidden" : "SheetVeryHidden", {}));
        else {
            /* Selected */ for(var i = 0; i < idx; ++i)if (wb.Workbook.Sheets[i] && !wb.Workbook.Sheets[i].Hidden) break;
            if (i == idx) o.push("<Selected/>");
        }
    }
    /* LeftColumnVisible */ if (((((wb || {}).Workbook || {}).Views || [])[0] || {}).RTL) o.push("<DisplayRightToLeft/>");
    /* GridlineColorIndex */ /* DisplayFormulas */ /* DoNotDisplayGridlines */ /* DoNotDisplayHeadings */ /* DoNotDisplayOutline */ /* ApplyAutomaticOutlineStyles */ /* NoSummaryRowsBelowDetail */ /* NoSummaryColumnsRightDetail */ /* DoNotDisplayZeros */ /* ActiveRow */ /* ActiveColumn */ /* FilterOn */ /* RangeSelection */ /* TopRowVisible */ /* TopRowBottomPane */ /* LeftColumnRightPane */ /* ActivePane */ /* SplitHorizontal */ /* SplitVertical */ /* FreezePanes */ /* FrozenNoSplit */ /* TabColorIndex */ /* Panes */ /* NOTE: Password not supported in XLML Format */ if (ws["!protect"]) {
        o.push(writetag("ProtectContents", "True"));
        if (ws["!protect"].objects) o.push(writetag("ProtectObjects", "True"));
        if (ws["!protect"].scenarios) o.push(writetag("ProtectScenarios", "True"));
        if (ws["!protect"].selectLockedCells != null && !ws["!protect"].selectLockedCells) o.push(writetag("EnableSelection", "NoSelection"));
        else if (ws["!protect"].selectUnlockedCells != null && !ws["!protect"].selectUnlockedCells) o.push(writetag("EnableSelection", "UnlockedCells"));
        [
            [
                "formatCells",
                "AllowFormatCells"
            ],
            [
                "formatColumns",
                "AllowSizeCols"
            ],
            [
                "formatRows",
                "AllowSizeRows"
            ],
            [
                "insertColumns",
                "AllowInsertCols"
            ],
            [
                "insertRows",
                "AllowInsertRows"
            ],
            [
                "insertHyperlinks",
                "AllowInsertHyperlinks"
            ],
            [
                "deleteColumns",
                "AllowDeleteCols"
            ],
            [
                "deleteRows",
                "AllowDeleteRows"
            ],
            [
                "sort",
                "AllowSort"
            ],
            [
                "autoFilter",
                "AllowFilter"
            ],
            [
                "pivotTables",
                "AllowUsePivotTables"
            ]
        ].forEach(function(x) {
            if (ws["!protect"][x[0]]) o.push("<" + x[1] + "/>");
        });
    }
    if (o.length == 0) return "";
    return writextag("WorksheetOptions", o.join(""), {
        xmlns: XLMLNS.x
    });
}
function write_ws_xlml_comment(comments /*:Array<any>*/ ) /*:string*/ {
    return comments.map(function(c) {
        // TODO: formatted text
        var t = xlml_unfixstr(c.t || "");
        var d = writextag("ss:Data", t, {
            "xmlns": "http://www.w3.org/TR/REC-html40"
        });
        return writextag("Comment", d, {
            "ss:Author": c.a
        });
    }).join("");
}
function write_ws_xlml_cell(cell, ref /*:string*/ , ws, opts, idx /*:number*/ , wb, addr) /*:string*/ {
    if (!cell || cell.v == undefined && cell.f == undefined) return "";
    var attr = {};
    if (cell.f) attr["ss:Formula"] = "=" + escapexml(a1_to_rc(cell.f, addr));
    if (cell.F && cell.F.slice(0, ref.length) == ref) {
        var end = decode_cell(cell.F.slice(ref.length + 1));
        attr["ss:ArrayRange"] = "RC:R" + (end.r == addr.r ? "" : "[" + (end.r - addr.r) + "]") + "C" + (end.c == addr.c ? "" : "[" + (end.c - addr.c) + "]");
    }
    if (cell.l && cell.l.Target) {
        attr["ss:HRef"] = escapexml(cell.l.Target);
        if (cell.l.Tooltip) attr["x:HRefScreenTip"] = escapexml(cell.l.Tooltip);
    }
    if (ws["!merges"]) {
        var marr = ws["!merges"];
        for(var mi = 0; mi != marr.length; ++mi){
            if (marr[mi].s.c != addr.c || marr[mi].s.r != addr.r) continue;
            if (marr[mi].e.c > marr[mi].s.c) attr["ss:MergeAcross"] = marr[mi].e.c - marr[mi].s.c;
            if (marr[mi].e.r > marr[mi].s.r) attr["ss:MergeDown"] = marr[mi].e.r - marr[mi].s.r;
        }
    }
    var t = "", p = "";
    switch(cell.t){
        case "z":
            if (!opts.sheetStubs) return "";
            break;
        case "n":
            t = "Number";
            p = String(cell.v);
            break;
        case "b":
            t = "Boolean";
            p = cell.v ? "1" : "0";
            break;
        case "e":
            t = "Error";
            p = BErr[cell.v];
            break;
        case "d":
            t = "DateTime";
            p = new Date(cell.v).toISOString();
            if (cell.z == null) cell.z = cell.z || table_fmt[14];
            break;
        case "s":
            t = "String";
            p = escapexlml(cell.v || "");
            break;
    }
    /* TODO: cell style */ var os = get_cell_style(opts.cellXfs, cell, opts);
    attr["ss:StyleID"] = "s" + (21 + os);
    attr["ss:Index"] = addr.c + 1;
    var _v = cell.v != null ? p : "";
    var m = cell.t == "z" ? "" : '<Data ss:Type="' + t + '">' + _v + "</Data>";
    if ((cell.c || []).length > 0) m += write_ws_xlml_comment(cell.c);
    return writextag("Cell", m, attr);
}
function write_ws_xlml_row(R /*:number*/ , row) /*:string*/ {
    var o = '<Row ss:Index="' + (R + 1) + '"';
    if (row) {
        if (row.hpt && !row.hpx) row.hpx = pt2px(row.hpt);
        if (row.hpx) o += ' ss:AutoFitHeight="0" ss:Height="' + row.hpx + '"';
        if (row.hidden) o += ' ss:Hidden="1"';
    }
    return o + ">";
}
/* TODO */ function write_ws_xlml_table(ws /*:Worksheet*/ , opts, idx /*:number*/ , wb /*:Workbook*/ ) /*:string*/ {
    if (!ws["!ref"]) return "";
    var range /*:Range*/  = safe_decode_range(ws["!ref"]);
    var marr /*:Array<Range>*/  = ws["!merges"] || [], mi = 0;
    var o /*:Array<string>*/  = [];
    if (ws["!cols"]) ws["!cols"].forEach(function(n, i) {
        process_col(n);
        var w = !!n.width;
        var p = col_obj_w(i, n);
        var k /*:any*/  = {
            "ss:Index": i + 1
        };
        if (w) k["ss:Width"] = width2px(p.width);
        if (n.hidden) k["ss:Hidden"] = "1";
        o.push(writextag("Column", null, k));
    });
    var dense = Array.isArray(ws);
    for(var R = range.s.r; R <= range.e.r; ++R){
        var row = [
            write_ws_xlml_row(R, (ws["!rows"] || [])[R])
        ];
        for(var C = range.s.c; C <= range.e.c; ++C){
            var skip = false;
            for(mi = 0; mi != marr.length; ++mi){
                if (marr[mi].s.c > C) continue;
                if (marr[mi].s.r > R) continue;
                if (marr[mi].e.c < C) continue;
                if (marr[mi].e.r < R) continue;
                if (marr[mi].s.c != C || marr[mi].s.r != R) skip = true;
                break;
            }
            if (skip) continue;
            var addr = {
                r: R,
                c: C
            };
            var ref = encode_cell(addr), cell = dense ? (ws[R] || [])[C] : ws[ref];
            row.push(write_ws_xlml_cell(cell, ref, ws, opts, idx, wb, addr));
        }
        row.push("</Row>");
        if (row.length > 2) o.push(row.join(""));
    }
    return o.join("");
}
function write_ws_xlml(idx /*:number*/ , opts, wb /*:Workbook*/ ) /*:string*/ {
    var o /*:Array<string>*/  = [];
    var s = wb.SheetNames[idx];
    var ws = wb.Sheets[s];
    var t /*:string*/  = ws ? write_ws_xlml_names(ws, opts, idx, wb) : "";
    if (t.length > 0) o.push("<Names>" + t + "</Names>");
    /* Table */ t = ws ? write_ws_xlml_table(ws, opts, idx, wb) : "";
    if (t.length > 0) o.push("<Table>" + t + "</Table>");
    /* WorksheetOptions */ o.push(write_ws_xlml_wsopts(ws, opts, idx, wb));
    return o.join("");
}
function write_xlml(wb, opts) /*:string*/ {
    if (!opts) opts = {};
    if (!wb.SSF) wb.SSF = dup(table_fmt);
    if (wb.SSF) {
        make_ssf();
        SSF_load_table(wb.SSF);
        // $FlowIgnore
        opts.revssf = evert_num(wb.SSF);
        opts.revssf[wb.SSF[65535]] = 0;
        opts.ssf = wb.SSF;
        opts.cellXfs = [];
        get_cell_style(opts.cellXfs, {}, {
            revssf: {
                "General": 0
            }
        });
    }
    var d /*:Array<string>*/  = [];
    d.push(write_props_xlml(wb, opts));
    d.push(write_wb_xlml(wb, opts));
    d.push("");
    d.push("");
    for(var i = 0; i < wb.SheetNames.length; ++i)d.push(writextag("Worksheet", write_ws_xlml(i, opts, wb), {
        "ss:Name": escapexml(wb.SheetNames[i])
    }));
    d[2] = write_sty_xlml(wb, opts);
    d[3] = write_names_xlml(wb, opts);
    return XML_HEADER + writextag("Workbook", d.join(""), {
        "xmlns": XLMLNS.ss,
        "xmlns:o": XLMLNS.o,
        "xmlns:x": XLMLNS.x,
        "xmlns:ss": XLMLNS.ss,
        "xmlns:dt": XLMLNS.dt,
        "xmlns:html": XLMLNS.html
    });
}
/* [MS-OLEDS] 2.3.8 CompObjStream */ function parse_compobj(obj /*:CFBEntry*/ ) {
    var v = {};
    var o = obj.content;
    /*:: if(o == null) return; */ /* [MS-OLEDS] 2.3.7 CompObjHeader -- All fields MUST be ignored */ o.l = 28;
    v.AnsiUserType = o.read_shift(0, "lpstr-ansi");
    v.AnsiClipboardFormat = parse_ClipboardFormatOrAnsiString(o);
    if (o.length - o.l <= 4) return v;
    var m /*:number*/  = o.read_shift(4);
    if (m == 0 || m > 40) return v;
    o.l -= 4;
    v.Reserved1 = o.read_shift(0, "lpstr-ansi");
    if (o.length - o.l <= 4) return v;
    m = o.read_shift(4);
    if (m !== 0x71b239f4) return v;
    v.UnicodeClipboardFormat = parse_ClipboardFormatOrUnicodeString(o);
    m = o.read_shift(4);
    if (m == 0 || m > 40) return v;
    o.l -= 4;
    v.Reserved2 = o.read_shift(0, "lpwstr");
}
/*
	Continue logic for:
	- 2.4.58 Continue          0x003c
	- 2.4.59 ContinueBigName   0x043c
	- 2.4.60 ContinueFrt       0x0812
	- 2.4.61 ContinueFrt11     0x0875
	- 2.4.62 ContinueFrt12     0x087f
*/ var CONTINUE_RT = [
    0x003c,
    0x043c,
    0x0812,
    0x0875,
    0x087f
];
function slurp(RecordType, R, blob, length /*:number*/ , opts) /*:any*/ {
    var l = length;
    var bufs = [];
    var d = blob.slice(blob.l, blob.l + l);
    if (opts && opts.enc && opts.enc.insitu && d.length > 0) switch(RecordType){
        case 0x0009:
        case 0x0209:
        case 0x0409:
        case 0x0809 /* BOF */ :
        case 0x002f /* FilePass */ :
        case 0x0195 /* FileLock */ :
        case 0x00e1 /* InterfaceHdr */ :
        case 0x0196 /* RRDInfo */ :
        case 0x0138 /* RRDHead */ :
        case 0x0194 /* UsrExcl */ :
        case 0x000a /* EOF */ :
            break;
        case 0x0085 /* BoundSheet8 */ :
            break;
        default:
            opts.enc.insitu(d);
    }
    bufs.push(d);
    blob.l += l;
    var nextrt = __readUInt16LE(blob, blob.l), next = XLSRecordEnum[nextrt];
    var start = 0;
    while(next != null && CONTINUE_RT.indexOf(nextrt) > -1){
        l = __readUInt16LE(blob, blob.l + 2);
        start = blob.l + 4;
        if (nextrt == 0x0812 /* ContinueFrt */ ) start += 4;
        else if (nextrt == 0x0875 || nextrt == 0x087f) start += 12;
        d = blob.slice(start, blob.l + 4 + l);
        bufs.push(d);
        blob.l += 4 + l;
        next = XLSRecordEnum[nextrt = __readUInt16LE(blob, blob.l)];
    }
    var b = bconcat(bufs);
    prep_blob(b, 0);
    var ll = 0;
    b.lens = [];
    for(var j = 0; j < bufs.length; ++j){
        b.lens.push(ll);
        ll += bufs[j].length;
    }
    if (b.length < length) throw "XLS Record 0x" + RecordType.toString(16) + " Truncated: " + b.length + " < " + length;
    return R.f(b, b.length, opts);
}
function safe_format_xf(p /*:any*/ , opts /*:ParseOpts*/ , date1904 /*:?boolean*/ ) {
    if (p.t === "z") return;
    if (!p.XF) return;
    var fmtid = 0;
    try {
        fmtid = p.z || p.XF.numFmtId || 0;
        if (opts.cellNF) p.z = table_fmt[fmtid];
    } catch (e) {
        if (opts.WTF) throw e;
    }
    if (!opts || opts.cellText !== false) try {
        if (p.t === "e") p.w = p.w || BErr[p.v];
        else if (fmtid === 0 || fmtid == "General") {
            if (p.t === "n") {
                if ((p.v | 0) === p.v) p.w = p.v.toString(10);
                else p.w = SSF_general_num(p.v);
            } else p.w = SSF_general(p.v);
        } else p.w = SSF_format(fmtid, p.v, {
            date1904: !!date1904,
            dateNF: opts && opts.dateNF
        });
    } catch (e) {
        if (opts.WTF) throw e;
    }
    if (opts.cellDates && fmtid && p.t == "n" && fmt_is_date(table_fmt[fmtid] || String(fmtid))) {
        var _d = SSF_parse_date_code(p.v);
        if (_d) {
            p.t = "d";
            p.v = new Date(_d.y, _d.m - 1, _d.d, _d.H, _d.M, _d.S, _d.u);
        }
    }
}
function make_cell(val, ixfe, t) /*:Cell*/ {
    return {
        v: val,
        ixfe: ixfe,
        t: t
    } /*:any*/ ;
}
// 2.3.2
function parse_workbook(blob, options /*:ParseOpts*/ ) /*:Workbook*/ {
    var wb = {
        opts: {}
    } /*:any*/ ;
    var Sheets = {};
    if (DENSE != null && options.dense == null) options.dense = DENSE;
    var out /*:Worksheet*/  = options.dense ? [] : {};
    var Directory = {};
    var range /*:Range*/  = {} /*:any*/ ;
    var last_formula = null;
    var sst /*:SST*/  = [];
    var cur_sheet = "";
    var Preamble = {};
    var lastcell, last_cell = "", cc /*:Cell*/ , cmnt, rngC, rngR;
    var sharedf = {};
    var arrayf /*:Array<[Range, string]>*/  = [];
    var temp_val /*:Cell*/ ;
    var country;
    var XFs = []; /* XF records */ 
    var palette /*:Array<[number, number, number]>*/  = [];
    var Workbook /*:WBWBProps*/  = {
        Sheets: [],
        WBProps: {
            date1904: false
        },
        Views: [
            {}
        ]
    } /*:any*/ , wsprops = {};
    var get_rgb = function getrgb(icv /*:number*/ ) /*:[number, number, number]*/ {
        if (icv < 8) return XLSIcv[icv];
        if (icv < 64) return palette[icv - 8] || XLSIcv[icv];
        return XLSIcv[icv];
    };
    var process_cell_style = function pcs(cell, line /*:any*/ , options) {
        var xfd = line.XF.data;
        if (!xfd || !xfd.patternType || !options || !options.cellStyles) return;
        line.s = {} /*:any*/ ;
        line.s.patternType = xfd.patternType;
        var t;
        if (t = rgb2Hex(get_rgb(xfd.icvFore))) line.s.fgColor = {
            rgb: t
        };
        if (t = rgb2Hex(get_rgb(xfd.icvBack))) line.s.bgColor = {
            rgb: t
        };
    };
    var addcell = function addcell(cell /*:any*/ , line /*:any*/ , options /*:any*/ ) {
        if (file_depth > 1) return;
        if (options.sheetRows && cell.r >= options.sheetRows) return;
        if (options.cellStyles && line.XF && line.XF.data) process_cell_style(cell, line, options);
        delete line.ixfe;
        delete line.XF;
        lastcell = cell;
        last_cell = encode_cell(cell);
        if (!range || !range.s || !range.e) range = {
            s: {
                r: 0,
                c: 0
            },
            e: {
                r: 0,
                c: 0
            }
        };
        if (cell.r < range.s.r) range.s.r = cell.r;
        if (cell.c < range.s.c) range.s.c = cell.c;
        if (cell.r + 1 > range.e.r) range.e.r = cell.r + 1;
        if (cell.c + 1 > range.e.c) range.e.c = cell.c + 1;
        if (options.cellFormula && line.f) for(var afi = 0; afi < arrayf.length; ++afi){
            if (arrayf[afi][0].s.c > cell.c || arrayf[afi][0].s.r > cell.r) continue;
            if (arrayf[afi][0].e.c < cell.c || arrayf[afi][0].e.r < cell.r) continue;
            line.F = encode_range(arrayf[afi][0]);
            if (arrayf[afi][0].s.c != cell.c || arrayf[afi][0].s.r != cell.r) delete line.f;
            if (line.f) line.f = "" + stringify_formula(arrayf[afi][1], range, cell, supbooks, opts);
            break;
        }
        if (options.dense) {
            if (!out[cell.r]) out[cell.r] = [];
            out[cell.r][cell.c] = line;
        } else out[last_cell] = line;
    };
    var opts = {
        enc: false,
        sbcch: 0,
        snames: [],
        sharedf: sharedf,
        arrayf: arrayf,
        rrtabid: [],
        lastuser: "",
        biff: 8,
        codepage: 0,
        winlocked: 0,
        cellStyles: !!options && !!options.cellStyles,
        WTF: !!options && !!options.wtf
    } /*:any*/ ;
    if (options.password) opts.password = options.password;
    var themes;
    var merges /*:Array<Range>*/  = [];
    var objects = [];
    var colinfo /*:Array<ColInfo>*/  = [], rowinfo /*:Array<RowInfo>*/  = [];
    var seencol = false;
    var supbooks = []; // 1-indexed, will hold extern names
    supbooks.SheetNames = opts.snames;
    supbooks.sharedf = opts.sharedf;
    supbooks.arrayf = opts.arrayf;
    supbooks.names = [];
    supbooks.XTI = [];
    var last_RT = 0;
    var file_depth = 0; /* TODO: make a real stack */ 
    var BIFF2Fmt = 0, BIFF2FmtTable /*:Array<string>*/  = [];
    var FilterDatabases = []; /* TODO: sort out supbooks and process elsewhere */ 
    var last_lbl /*:?DefinedName*/ ;
    /* explicit override for some broken writers */ opts.codepage = 1200;
    set_cp(1200);
    var seen_codepage = false;
    while(blob.l < blob.length - 1){
        var s = blob.l;
        var RecordType = blob.read_shift(2);
        if (RecordType === 0 && last_RT === 0x000a /* EOF */ ) break;
        var length = blob.l === blob.length ? 0 : blob.read_shift(2);
        var R = XLSRecordEnum[RecordType];
        //console.log(RecordType.toString(16), RecordType, R, blob.l, length, blob.length);
        //if(!R) console.log(blob.slice(blob.l, blob.l + length));
        if (R && R.f) {
            if (options.bookSheets) {
                if (last_RT === 0x0085 /* BoundSheet8 */  && RecordType !== 0x0085 /* R.n !== 'BoundSheet8' */ ) break;
            }
            last_RT = RecordType;
            if (R.r === 2 || R.r == 12) {
                var rt = blob.read_shift(2);
                length -= 2;
                if (!opts.enc && rt !== RecordType && ((rt & 0xFF) << 8 | rt >> 8) !== RecordType) throw new Error("rt mismatch: " + rt + "!=" + RecordType);
                if (R.r == 12) {
                    blob.l += 10;
                    length -= 10;
                } // skip FRT
            }
            //console.error(R,blob.l,length,blob.length);
            var val /*:any*/  = {} /*:any*/ ;
            if (RecordType === 0x000a /* EOF */ ) val = /*::(*/ R.f(blob, length, opts) /*:: :any)*/ ;
            else val = /*::(*/ slurp(RecordType, R, blob, length, opts) /*:: :any)*/ ;
            /*:: val = (val:any); */ if (file_depth == 0 && [
                0x0009,
                0x0209,
                0x0409,
                0x0809
            ].indexOf(last_RT) === -1 /* 'BOF' */ ) continue;
            switch(RecordType){
                case 0x0022 /* Date1904 */ :
                    /*:: if(!Workbook.WBProps) Workbook.WBProps = {}; */ wb.opts.Date1904 = Workbook.WBProps.date1904 = val;
                    break;
                case 0x0086 /* WriteProtect */ :
                    wb.opts.WriteProtect = true;
                    break;
                case 0x002f /* FilePass */ :
                    if (!opts.enc) blob.l = 0;
                    opts.enc = val;
                    if (!options.password) throw new Error("File is password-protected");
                    if (val.valid == null) throw new Error("Encryption scheme unsupported");
                    if (!val.valid) throw new Error("Password is incorrect");
                    break;
                case 0x005c /* WriteAccess */ :
                    opts.lastuser = val;
                    break;
                case 0x0042 /* CodePage */ :
                    var cpval = Number(val);
                    /* overrides based on test cases */ switch(cpval){
                        case 0x5212:
                            cpval = 1200;
                            break;
                        case 0x8000:
                            cpval = 10000;
                            break;
                        case 0x8001:
                            cpval = 1252;
                            break;
                    }
                    set_cp(opts.codepage = cpval);
                    seen_codepage = true;
                    break;
                case 0x013d /* RRTabId */ :
                    opts.rrtabid = val;
                    break;
                case 0x0019 /* WinProtect */ :
                    opts.winlocked = val;
                    break;
                case 0x01b7 /* RefreshAll */ :
                    wb.opts["RefreshAll"] = val;
                    break;
                case 0x000c /* CalcCount */ :
                    wb.opts["CalcCount"] = val;
                    break;
                case 0x0010 /* CalcDelta */ :
                    wb.opts["CalcDelta"] = val;
                    break;
                case 0x0011 /* CalcIter */ :
                    wb.opts["CalcIter"] = val;
                    break;
                case 0x000d /* CalcMode */ :
                    wb.opts["CalcMode"] = val;
                    break;
                case 0x000e /* CalcPrecision */ :
                    wb.opts["CalcPrecision"] = val;
                    break;
                case 0x005f /* CalcSaveRecalc */ :
                    wb.opts["CalcSaveRecalc"] = val;
                    break;
                case 0x000f /* CalcRefMode */ :
                    opts.CalcRefMode = val;
                    break; // TODO: implement R1C1
                case 0x08a3 /* ForceFullCalculation */ :
                    wb.opts.FullCalc = val;
                    break;
                case 0x0081 /* WsBool */ :
                    if (val.fDialog) out["!type"] = "dialog";
                    if (!val.fBelow) (out["!outline"] || (out["!outline"] = {})).above = true;
                    if (!val.fRight) (out["!outline"] || (out["!outline"] = {})).left = true;
                    break; // TODO
                case 0x00e0 /* XF */ :
                    XFs.push(val);
                    break;
                case 0x01ae /* SupBook */ :
                    supbooks.push([
                        val
                    ]);
                    supbooks[supbooks.length - 1].XTI = [];
                    break;
                case 0x0023:
                case 0x0223 /* ExternName */ :
                    supbooks[supbooks.length - 1].push(val);
                    break;
                case 0x0018:
                case 0x0218 /* Lbl */ :
                    last_lbl = {
                        Name: val.Name,
                        Ref: stringify_formula(val.rgce, range, null, supbooks, opts)
                    } /*:DefinedName*/ ;
                    if (val.itab > 0) last_lbl.Sheet = val.itab - 1;
                    supbooks.names.push(last_lbl);
                    if (!supbooks[0]) {
                        supbooks[0] = [];
                        supbooks[0].XTI = [];
                    }
                    supbooks[supbooks.length - 1].push(val);
                    if (val.Name == "_xlnm._FilterDatabase" && val.itab > 0) {
                        if (val.rgce && val.rgce[0] && val.rgce[0][0] && val.rgce[0][0][0] == "PtgArea3d") FilterDatabases[val.itab - 1] = {
                            ref: encode_range(val.rgce[0][0][1][2])
                        };
                    }
                    break;
                case 0x0016 /* ExternCount */ :
                    opts.ExternCount = val;
                    break;
                case 0x0017 /* ExternSheet */ :
                    if (supbooks.length == 0) {
                        supbooks[0] = [];
                        supbooks[0].XTI = [];
                    }
                    supbooks[supbooks.length - 1].XTI = supbooks[supbooks.length - 1].XTI.concat(val);
                    supbooks.XTI = supbooks.XTI.concat(val);
                    break;
                case 0x0894 /* NameCmt */ :
                    /* TODO: search for correct name */ if (opts.biff < 8) break;
                    if (last_lbl != null) last_lbl.Comment = val[1];
                    break;
                case 0x0012 /* Protect */ :
                    out["!protect"] = val;
                    break; /* for sheet or book */ 
                case 0x0013 /* Password */ :
                    if (val !== 0 && opts.WTF) console.error("Password verifier: " + val);
                    break;
                case 0x0085 /* BoundSheet8 */ :
                    Directory[val.pos] = val;
                    opts.snames.push(val.name);
                    break;
                case 0x000a /* EOF */ :
                    if (--file_depth) break;
                    if (range.e) {
                        if (range.e.r > 0 && range.e.c > 0) {
                            range.e.r--;
                            range.e.c--;
                            out["!ref"] = encode_range(range);
                            if (options.sheetRows && options.sheetRows <= range.e.r) {
                                var tmpri = range.e.r;
                                range.e.r = options.sheetRows - 1;
                                out["!fullref"] = out["!ref"];
                                out["!ref"] = encode_range(range);
                                range.e.r = tmpri;
                            }
                            range.e.r++;
                            range.e.c++;
                        }
                        if (merges.length > 0) out["!merges"] = merges;
                        if (objects.length > 0) out["!objects"] = objects;
                        if (colinfo.length > 0) out["!cols"] = colinfo;
                        if (rowinfo.length > 0) out["!rows"] = rowinfo;
                        Workbook.Sheets.push(wsprops);
                    }
                    if (cur_sheet === "") Preamble = out;
                    else Sheets[cur_sheet] = out;
                    out = options.dense ? [] : {};
                    break;
                case 0x0009:
                case 0x0209:
                case 0x0409:
                case 0x0809 /* BOF */ :
                    if (opts.biff === 8) opts.biff = ({
                        /*::[*/ 0x0009: 2,
                        /*::[*/ 0x0209: 3,
                        /*::[*/ 0x0409: 4
                    })[RecordType] || ({
                        /*::[*/ 0x0200: 2,
                        /*::[*/ 0x0300: 3,
                        /*::[*/ 0x0400: 4,
                        /*::[*/ 0x0500: 5,
                        /*::[*/ 0x0600: 8,
                        /*::[*/ 0x0002: 2,
                        /*::[*/ 0x0007: 2
                    })[val.BIFFVer] || 8;
                    opts.biffguess = val.BIFFVer == 0;
                    if (val.BIFFVer == 0 && val.dt == 0x1000) {
                        opts.biff = 5;
                        seen_codepage = true;
                        set_cp(opts.codepage = 28591);
                    }
                    if (opts.biff == 8 && val.BIFFVer == 0 && val.dt == 16) opts.biff = 2;
                    if (file_depth++) break;
                    out = options.dense ? [] : {};
                    if (opts.biff < 8 && !seen_codepage) {
                        seen_codepage = true;
                        set_cp(opts.codepage = options.codepage || 1252);
                    }
                    if (opts.biff < 5 || val.BIFFVer == 0 && val.dt == 0x1000) {
                        if (cur_sheet === "") cur_sheet = "Sheet1";
                        range = {
                            s: {
                                r: 0,
                                c: 0
                            },
                            e: {
                                r: 0,
                                c: 0
                            }
                        };
                        /* fake BoundSheet8 */ var fakebs8 = {
                            pos: blob.l - length,
                            name: cur_sheet
                        };
                        Directory[fakebs8.pos] = fakebs8;
                        opts.snames.push(cur_sheet);
                    } else cur_sheet = (Directory[s] || {
                        name: ""
                    }).name;
                    if (val.dt == 0x20) out["!type"] = "chart";
                    if (val.dt == 0x40) out["!type"] = "macro";
                    merges = [];
                    objects = [];
                    opts.arrayf = arrayf = [];
                    colinfo = [];
                    rowinfo = [];
                    seencol = false;
                    wsprops = {
                        Hidden: (Directory[s] || {
                            hs: 0
                        }).hs,
                        name: cur_sheet
                    };
                    break;
                case 0x0203 /* Number */ :
                case 0x0003 /* BIFF2NUM */ :
                case 0x0002 /* BIFF2INT */ :
                    if (out["!type"] == "chart") {
                        if (options.dense ? (out[val.r] || [])[val.c] : out[encode_cell({
                            c: val.c,
                            r: val.r
                        })]) ++val.c;
                    }
                    temp_val = {
                        ixfe: val.ixfe,
                        XF: XFs[val.ixfe] || {},
                        v: val.val,
                        t: "n"
                    } /*:any*/ ;
                    if (BIFF2Fmt > 0) temp_val.z = BIFF2FmtTable[temp_val.ixfe >> 8 & 0x3F];
                    safe_format_xf(temp_val, options, wb.opts.Date1904);
                    addcell({
                        c: val.c,
                        r: val.r
                    }, temp_val, options);
                    break;
                case 0x0005:
                case 0x0205 /* BoolErr */ :
                    temp_val = {
                        ixfe: val.ixfe,
                        XF: XFs[val.ixfe],
                        v: val.val,
                        t: val.t
                    } /*:any*/ ;
                    if (BIFF2Fmt > 0) temp_val.z = BIFF2FmtTable[temp_val.ixfe >> 8 & 0x3F];
                    safe_format_xf(temp_val, options, wb.opts.Date1904);
                    addcell({
                        c: val.c,
                        r: val.r
                    }, temp_val, options);
                    break;
                case 0x027e /* RK */ :
                    temp_val = {
                        ixfe: val.ixfe,
                        XF: XFs[val.ixfe],
                        v: val.rknum,
                        t: "n"
                    } /*:any*/ ;
                    if (BIFF2Fmt > 0) temp_val.z = BIFF2FmtTable[temp_val.ixfe >> 8 & 0x3F];
                    safe_format_xf(temp_val, options, wb.opts.Date1904);
                    addcell({
                        c: val.c,
                        r: val.r
                    }, temp_val, options);
                    break;
                case 0x00bd /* MulRk */ :
                    for(var j = val.c; j <= val.C; ++j){
                        var ixfe = val.rkrec[j - val.c][0];
                        temp_val = {
                            ixfe: ixfe,
                            XF: XFs[ixfe],
                            v: val.rkrec[j - val.c][1],
                            t: "n"
                        } /*:any*/ ;
                        if (BIFF2Fmt > 0) temp_val.z = BIFF2FmtTable[temp_val.ixfe >> 8 & 0x3F];
                        safe_format_xf(temp_val, options, wb.opts.Date1904);
                        addcell({
                            c: j,
                            r: val.r
                        }, temp_val, options);
                    }
                    break;
                case 0x0006:
                case 0x0206:
                case 0x0406 /* Formula */ :
                    if (val.val == "String") {
                        last_formula = val;
                        break;
                    }
                    temp_val = make_cell(val.val, val.cell.ixfe, val.tt);
                    temp_val.XF = XFs[temp_val.ixfe];
                    if (options.cellFormula) {
                        var _f = val.formula;
                        if (_f && _f[0] && _f[0][0] && _f[0][0][0] == "PtgExp") {
                            var _fr = _f[0][0][1][0], _fc = _f[0][0][1][1];
                            var _fe = encode_cell({
                                r: _fr,
                                c: _fc
                            });
                            if (sharedf[_fe]) temp_val.f = "" + stringify_formula(val.formula, range, val.cell, supbooks, opts);
                            else temp_val.F = ((options.dense ? (out[_fr] || [])[_fc] : out[_fe]) || {}).F;
                        } else temp_val.f = "" + stringify_formula(val.formula, range, val.cell, supbooks, opts);
                    }
                    if (BIFF2Fmt > 0) temp_val.z = BIFF2FmtTable[temp_val.ixfe >> 8 & 0x3F];
                    safe_format_xf(temp_val, options, wb.opts.Date1904);
                    addcell(val.cell, temp_val, options);
                    last_formula = val;
                    break;
                case 0x0007:
                case 0x0207 /* String */ :
                    if (last_formula) {
                        last_formula.val = val;
                        temp_val = make_cell(val, last_formula.cell.ixfe, "s");
                        temp_val.XF = XFs[temp_val.ixfe];
                        if (options.cellFormula) temp_val.f = "" + stringify_formula(last_formula.formula, range, last_formula.cell, supbooks, opts);
                        if (BIFF2Fmt > 0) temp_val.z = BIFF2FmtTable[temp_val.ixfe >> 8 & 0x3F];
                        safe_format_xf(temp_val, options, wb.opts.Date1904);
                        addcell(last_formula.cell, temp_val, options);
                        last_formula = null;
                    } else throw new Error("String record expects Formula");
                    break;
                case 0x0021:
                case 0x0221 /* Array */ :
                    arrayf.push(val);
                    var _arraystart = encode_cell(val[0].s);
                    cc = options.dense ? (out[val[0].s.r] || [])[val[0].s.c] : out[_arraystart];
                    if (options.cellFormula && cc) {
                        if (!last_formula) break; /* technically unreachable */ 
                        if (!_arraystart || !cc) break;
                        cc.f = "" + stringify_formula(val[1], range, val[0], supbooks, opts);
                        cc.F = encode_range(val[0]);
                    }
                    break;
                case 0x04bc /* ShrFmla */ :
                    if (!options.cellFormula) break;
                    if (last_cell) {
                        /* TODO: capture range */ if (!last_formula) break; /* technically unreachable */ 
                        sharedf[encode_cell(last_formula.cell)] = val[0];
                        cc = options.dense ? (out[last_formula.cell.r] || [])[last_formula.cell.c] : out[encode_cell(last_formula.cell)];
                        (cc || {}).f = "" + stringify_formula(val[0], range, lastcell, supbooks, opts);
                    }
                    break;
                case 0x00fd /* LabelSst */ :
                    temp_val = make_cell(sst[val.isst].t, val.ixfe, "s");
                    if (sst[val.isst].h) temp_val.h = sst[val.isst].h;
                    temp_val.XF = XFs[temp_val.ixfe];
                    if (BIFF2Fmt > 0) temp_val.z = BIFF2FmtTable[temp_val.ixfe >> 8 & 0x3F];
                    safe_format_xf(temp_val, options, wb.opts.Date1904);
                    addcell({
                        c: val.c,
                        r: val.r
                    }, temp_val, options);
                    break;
                case 0x0201 /* Blank */ :
                    if (options.sheetStubs) {
                        temp_val = {
                            ixfe: val.ixfe,
                            XF: XFs[val.ixfe],
                            t: "z"
                        } /*:any*/ ;
                        if (BIFF2Fmt > 0) temp_val.z = BIFF2FmtTable[temp_val.ixfe >> 8 & 0x3F];
                        safe_format_xf(temp_val, options, wb.opts.Date1904);
                        addcell({
                            c: val.c,
                            r: val.r
                        }, temp_val, options);
                    }
                    break;
                case 0x00be /* MulBlank */ :
                    if (options.sheetStubs) for(var _j = val.c; _j <= val.C; ++_j){
                        var _ixfe = val.ixfe[_j - val.c];
                        temp_val = {
                            ixfe: _ixfe,
                            XF: XFs[_ixfe],
                            t: "z"
                        } /*:any*/ ;
                        if (BIFF2Fmt > 0) temp_val.z = BIFF2FmtTable[temp_val.ixfe >> 8 & 0x3F];
                        safe_format_xf(temp_val, options, wb.opts.Date1904);
                        addcell({
                            c: _j,
                            r: val.r
                        }, temp_val, options);
                    }
                    break;
                case 0x00d6 /* RString */ :
                case 0x0204 /* Label */ :
                case 0x0004 /* BIFF2STR */ :
                    temp_val = make_cell(val.val, val.ixfe, "s");
                    temp_val.XF = XFs[temp_val.ixfe];
                    if (BIFF2Fmt > 0) temp_val.z = BIFF2FmtTable[temp_val.ixfe >> 8 & 0x3F];
                    safe_format_xf(temp_val, options, wb.opts.Date1904);
                    addcell({
                        c: val.c,
                        r: val.r
                    }, temp_val, options);
                    break;
                case 0x0000:
                case 0x0200 /* Dimensions */ :
                    if (file_depth === 1) range = val; /* TODO: stack */ 
                    break;
                case 0x00fc /* SST */ :
                    sst = val;
                    break;
                case 0x041e /* Format */ :
                    if (opts.biff == 4) {
                        BIFF2FmtTable[BIFF2Fmt++] = val[1];
                        for(var b4idx = 0; b4idx < BIFF2Fmt + 163; ++b4idx)if (table_fmt[b4idx] == val[1]) break;
                        if (b4idx >= 163) SSF_load(val[1], BIFF2Fmt + 163);
                    } else SSF_load(val[1], val[0]);
                    break;
                case 0x001e /* BIFF2FORMAT */ :
                    BIFF2FmtTable[BIFF2Fmt++] = val;
                    for(var b2idx = 0; b2idx < BIFF2Fmt + 163; ++b2idx)if (table_fmt[b2idx] == val) break;
                    if (b2idx >= 163) SSF_load(val, BIFF2Fmt + 163);
                    break;
                case 0x00e5 /* MergeCells */ :
                    merges = merges.concat(val);
                    break;
                case 0x005d /* Obj */ :
                    objects[val.cmo[0]] = opts.lastobj = val;
                    break;
                case 0x01b6 /* TxO */ :
                    opts.lastobj.TxO = val;
                    break;
                case 0x007f /* ImData */ :
                    opts.lastobj.ImData = val;
                    break;
                case 0x01b8 /* HLink */ :
                    for(rngR = val[0].s.r; rngR <= val[0].e.r; ++rngR)for(rngC = val[0].s.c; rngC <= val[0].e.c; ++rngC){
                        cc = options.dense ? (out[rngR] || [])[rngC] : out[encode_cell({
                            c: rngC,
                            r: rngR
                        })];
                        if (cc) cc.l = val[1];
                    }
                    break;
                case 0x0800 /* HLinkTooltip */ :
                    for(rngR = val[0].s.r; rngR <= val[0].e.r; ++rngR)for(rngC = val[0].s.c; rngC <= val[0].e.c; ++rngC){
                        cc = options.dense ? (out[rngR] || [])[rngC] : out[encode_cell({
                            c: rngC,
                            r: rngR
                        })];
                        if (cc && cc.l) cc.l.Tooltip = val[1];
                    }
                    break;
                case 0x001c /* Note */ :
                    if (opts.biff <= 5 && opts.biff >= 2) break; /* TODO: BIFF5 */ 
                    cc = options.dense ? (out[val[0].r] || [])[val[0].c] : out[encode_cell(val[0])];
                    var noteobj = objects[val[2]];
                    if (!cc) {
                        if (options.dense) {
                            if (!out[val[0].r]) out[val[0].r] = [];
                            cc = out[val[0].r][val[0].c] = {
                                t: "z"
                            } /*:any*/ ;
                        } else cc = out[encode_cell(val[0])] = {
                            t: "z"
                        } /*:any*/ ;
                        range.e.r = Math.max(range.e.r, val[0].r);
                        range.s.r = Math.min(range.s.r, val[0].r);
                        range.e.c = Math.max(range.e.c, val[0].c);
                        range.s.c = Math.min(range.s.c, val[0].c);
                    }
                    if (!cc.c) cc.c = [];
                    cmnt = {
                        a: val[1],
                        t: noteobj.TxO.t
                    };
                    cc.c.push(cmnt);
                    break;
                case 0x087d /* XFExt */ :
                    update_xfext(XFs[val.ixfe], val.ext);
                    break;
                case 0x007d /* ColInfo */ :
                    if (!opts.cellStyles) break;
                    while(val.e >= val.s){
                        colinfo[val.e--] = {
                            width: val.w / 256,
                            level: val.level || 0,
                            hidden: !!(val.flags & 1)
                        };
                        if (!seencol) {
                            seencol = true;
                            find_mdw_colw(val.w / 256);
                        }
                        process_col(colinfo[val.e + 1]);
                    }
                    break;
                case 0x0208 /* Row */ :
                    var rowobj = {};
                    if (val.level != null) {
                        rowinfo[val.r] = rowobj;
                        rowobj.level = val.level;
                    }
                    if (val.hidden) {
                        rowinfo[val.r] = rowobj;
                        rowobj.hidden = true;
                    }
                    if (val.hpt) {
                        rowinfo[val.r] = rowobj;
                        rowobj.hpt = val.hpt;
                        rowobj.hpx = pt2px(val.hpt);
                    }
                    break;
                case 0x0026 /* LeftMargin */ :
                case 0x0027 /* RightMargin */ :
                case 0x0028 /* TopMargin */ :
                case 0x0029 /* BottomMargin */ :
                    if (!out["!margins"]) default_margins(out["!margins"] = {});
                    out["!margins"][({
                        0x26: "left",
                        0x27: "right",
                        0x28: "top",
                        0x29: "bottom"
                    })[RecordType]] = val;
                    break;
                case 0x00a1 /* Setup */ :
                    if (!out["!margins"]) default_margins(out["!margins"] = {});
                    out["!margins"].header = val.header;
                    out["!margins"].footer = val.footer;
                    break;
                case 0x023e /* Window2 */ :
                    // $FlowIgnore
                    if (val.RTL) Workbook.Views[0].RTL = true;
                    break;
                case 0x0092 /* Palette */ :
                    palette = val;
                    break;
                case 0x0896 /* Theme */ :
                    themes = val;
                    break;
                case 0x008c /* Country */ :
                    country = val;
                    break;
                case 0x01ba /* CodeName */ :
                    /*:: if(!Workbook.WBProps) Workbook.WBProps = {}; */ if (!cur_sheet) Workbook.WBProps.CodeName = val || "ThisWorkbook";
                    else wsprops.CodeName = val || wsprops.name;
                    break;
            }
        } else {
            if (!R) console.error("Missing Info for XLS Record 0x" + RecordType.toString(16));
            blob.l += length;
        }
    }
    wb.SheetNames = keys(Directory).sort(function(a, b) {
        return Number(a) - Number(b);
    }).map(function(x) {
        return Directory[x].name;
    });
    if (!options.bookSheets) wb.Sheets = Sheets;
    if (!wb.SheetNames.length && Preamble["!ref"]) {
        wb.SheetNames.push("Sheet1");
        /*jshint -W069 */ if (wb.Sheets) wb.Sheets["Sheet1"] = Preamble;
    /*jshint +W069 */ } else wb.Preamble = Preamble;
    if (wb.Sheets) FilterDatabases.forEach(function(r, i) {
        wb.Sheets[wb.SheetNames[i]]["!autofilter"] = r;
    });
    wb.Strings = sst;
    wb.SSF = dup(table_fmt);
    if (opts.enc) wb.Encryption = opts.enc;
    if (themes) wb.Themes = themes;
    wb.Metadata = {};
    if (country !== undefined) wb.Metadata.Country = country;
    if (supbooks.names.length > 0) Workbook.Names = supbooks.names;
    wb.Workbook = Workbook;
    return wb;
}
/* TODO: split props*/ var PSCLSID = {
    SI: "e0859ff2f94f6810ab9108002b27b3d9",
    DSI: "02d5cdd59c2e1b10939708002b2cf9ae",
    UDI: "05d5cdd59c2e1b10939708002b2cf9ae"
};
function parse_xls_props(cfb /*:CFBContainer*/ , props, o) {
    /* [MS-OSHARED] 2.3.3.2.2 Document Summary Information Property Set */ var DSI = CFB.find(cfb, "/!DocumentSummaryInformation");
    if (DSI && DSI.size > 0) try {
        var DocSummary = parse_PropertySetStream(DSI, DocSummaryPIDDSI, PSCLSID.DSI);
        for(var d in DocSummary)props[d] = DocSummary[d];
    } catch (e) {
        if (o.WTF) throw e; /* empty */ 
    }
    /* [MS-OSHARED] 2.3.3.2.1 Summary Information Property Set*/ var SI = CFB.find(cfb, "/!SummaryInformation");
    if (SI && SI.size > 0) try {
        var Summary = parse_PropertySetStream(SI, SummaryPIDSI, PSCLSID.SI);
        for(var s in Summary)if (props[s] == null) props[s] = Summary[s];
    } catch (e) {
        if (o.WTF) throw e; /* empty */ 
    }
    if (props.HeadingPairs && props.TitlesOfParts) {
        load_props_pairs(props.HeadingPairs, props.TitlesOfParts, props, o);
        delete props.HeadingPairs;
        delete props.TitlesOfParts;
    }
}
function write_xls_props(wb /*:Workbook*/ , cfb /*:CFBContainer*/ ) {
    var DSEntries = [], SEntries = [], CEntries = [];
    var i = 0, Keys;
    var DocSummaryRE /*:{[key:string]:string}*/  = evert_key(DocSummaryPIDDSI, "n");
    var SummaryRE /*:{[key:string]:string}*/  = evert_key(SummaryPIDSI, "n");
    if (wb.Props) {
        Keys = keys(wb.Props);
        // $FlowIgnore
        for(i = 0; i < Keys.length; ++i)(Object.prototype.hasOwnProperty.call(DocSummaryRE, Keys[i]) ? DSEntries : Object.prototype.hasOwnProperty.call(SummaryRE, Keys[i]) ? SEntries : CEntries).push([
            Keys[i],
            wb.Props[Keys[i]]
        ]);
    }
    if (wb.Custprops) {
        Keys = keys(wb.Custprops);
        // $FlowIgnore
        for(i = 0; i < Keys.length; ++i)if (!Object.prototype.hasOwnProperty.call(wb.Props || {}, Keys[i])) (Object.prototype.hasOwnProperty.call(DocSummaryRE, Keys[i]) ? DSEntries : Object.prototype.hasOwnProperty.call(SummaryRE, Keys[i]) ? SEntries : CEntries).push([
            Keys[i],
            wb.Custprops[Keys[i]]
        ]);
    }
    var CEntries2 = [];
    for(i = 0; i < CEntries.length; ++i){
        if (XLSPSSkip.indexOf(CEntries[i][0]) > -1 || PseudoPropsPairs.indexOf(CEntries[i][0]) > -1) continue;
        if (CEntries[i][1] == null) continue;
        CEntries2.push(CEntries[i]);
    }
    if (SEntries.length) CFB.utils.cfb_add(cfb, "/\x05SummaryInformation", write_PropertySetStream(SEntries, PSCLSID.SI, SummaryRE, SummaryPIDSI));
    if (DSEntries.length || CEntries2.length) CFB.utils.cfb_add(cfb, "/\x05DocumentSummaryInformation", write_PropertySetStream(DSEntries, PSCLSID.DSI, DocSummaryRE, DocSummaryPIDDSI, CEntries2.length ? CEntries2 : null, PSCLSID.UDI));
}
function parse_xlscfb(cfb /*:any*/ , options /*:?ParseOpts*/ ) /*:Workbook*/ {
    if (!options) options = {};
    fix_read_opts(options);
    reset_cp();
    if (options.codepage) set_ansi(options.codepage);
    var CompObj /*:?CFBEntry*/ , WB /*:?any*/ ;
    if (cfb.FullPaths) {
        if (CFB.find(cfb, "/encryption")) throw new Error("File is password-protected");
        CompObj = CFB.find(cfb, "!CompObj");
        WB = CFB.find(cfb, "/Workbook") || CFB.find(cfb, "/Book");
    } else {
        switch(options.type){
            case "base64":
                cfb = s2a(Base64_decode(cfb));
                break;
            case "binary":
                cfb = s2a(cfb);
                break;
            case "buffer":
                break;
            case "array":
                if (!Array.isArray(cfb)) cfb = Array.prototype.slice.call(cfb);
                break;
        }
        prep_blob(cfb, 0);
        WB = {
            content: cfb
        } /*:any*/ ;
    }
    var /*::CompObjP, */ WorkbookP /*:: :Workbook = XLSX.utils.book_new(); */ ;
    var _data /*:?any*/ ;
    if (CompObj) /*::CompObjP = */ parse_compobj(CompObj);
    if (options.bookProps && !options.bookSheets) WorkbookP = {} /*:any*/ ;
    else /*:: if(cfb instanceof CFBContainer) */ {
        var T = has_buf ? "buffer" : "array";
        if (WB && WB.content) WorkbookP = parse_workbook(WB.content, options);
        else if ((_data = CFB.find(cfb, "PerfectOffice_MAIN")) && _data.content) WorkbookP = WK_.to_workbook(_data.content, (options.type = T, options));
        else if ((_data = CFB.find(cfb, "NativeContent_MAIN")) && _data.content) WorkbookP = WK_.to_workbook(_data.content, (options.type = T, options));
        else if ((_data = CFB.find(cfb, "MN0")) && _data.content) throw new Error("Unsupported Works 4 for Mac file");
        else throw new Error("Cannot find Workbook stream");
        if (options.bookVBA && cfb.FullPaths && CFB.find(cfb, "/_VBA_PROJECT_CUR/VBA/dir")) WorkbookP.vbaraw = make_vba_xls(cfb);
    }
    var props = {};
    if (cfb.FullPaths) parse_xls_props(/*::((*/ cfb /*:: :any):CFBContainer)*/ , props, options);
    WorkbookP.Props = WorkbookP.Custprops = props; /* TODO: split up properties */ 
    if (options.bookFiles) WorkbookP.cfb = cfb;
    /*WorkbookP.CompObjP = CompObjP; // TODO: storage? */ return WorkbookP;
}
function write_xlscfb(wb /*:Workbook*/ , opts /*:WriteOpts*/ ) /*:CFBContainer*/ {
    var o = opts || {};
    var cfb = CFB.utils.cfb_new({
        root: "R"
    });
    var wbpath = "/Workbook";
    switch(o.bookType || "xls"){
        case "xls":
            o.bookType = "biff8";
        /* falls through */ case "xla":
            if (!o.bookType) o.bookType = "xla";
        /* falls through */ case "biff8":
            wbpath = "/Workbook";
            o.biff = 8;
            break;
        case "biff5":
            wbpath = "/Book";
            o.biff = 5;
            break;
        default:
            throw new Error("invalid type " + o.bookType + " for XLS CFB");
    }
    CFB.utils.cfb_add(cfb, wbpath, write_biff_buf(wb, o));
    if (o.biff == 8 && (wb.Props || wb.Custprops)) write_xls_props(wb, cfb);
    // TODO: SI, DSI, CO
    if (o.biff == 8 && wb.vbaraw) fill_vba_xls(cfb, CFB.read(wb.vbaraw, {
        type: typeof wb.vbaraw == "string" ? "binary" : "buffer"
    }));
    return cfb;
}
/* [MS-XLSB] 2.3 Record Enumeration */ var XLSBRecordEnum = {
    /*::[*/ 0x0000: {
        f: parse_BrtRowHdr
    },
    /*::[*/ 0x0001: {
        f: parse_BrtCellBlank
    },
    /*::[*/ 0x0002: {
        f: parse_BrtCellRk
    },
    /*::[*/ 0x0003: {
        f: parse_BrtCellError
    },
    /*::[*/ 0x0004: {
        f: parse_BrtCellBool
    },
    /*::[*/ 0x0005: {
        f: parse_BrtCellReal
    },
    /*::[*/ 0x0006: {
        f: parse_BrtCellSt
    },
    /*::[*/ 0x0007: {
        f: parse_BrtCellIsst
    },
    /*::[*/ 0x0008: {
        f: parse_BrtFmlaString
    },
    /*::[*/ 0x0009: {
        f: parse_BrtFmlaNum
    },
    /*::[*/ 0x000A: {
        f: parse_BrtFmlaBool
    },
    /*::[*/ 0x000B: {
        f: parse_BrtFmlaError
    },
    /*::[*/ 0x000C: {
        f: parse_BrtShortBlank
    },
    /*::[*/ 0x000D: {
        f: parse_BrtShortRk
    },
    /*::[*/ 0x000E: {
        f: parse_BrtShortError
    },
    /*::[*/ 0x000F: {
        f: parse_BrtShortBool
    },
    /*::[*/ 0x0010: {
        f: parse_BrtShortReal
    },
    /*::[*/ 0x0011: {
        f: parse_BrtShortSt
    },
    /*::[*/ 0x0012: {
        f: parse_BrtShortIsst
    },
    /*::[*/ 0x0013: {
        f: parse_RichStr
    },
    /*::[*/ 0x0014: {},
    /*::[*/ 0x0015: {},
    /*::[*/ 0x0016: {},
    /*::[*/ 0x0017: {},
    /*::[*/ 0x0018: {},
    /*::[*/ 0x0019: {},
    /*::[*/ 0x001A: {},
    /*::[*/ 0x001B: {},
    /*::[*/ 0x001C: {},
    /*::[*/ 0x001D: {},
    /*::[*/ 0x001E: {},
    /*::[*/ 0x001F: {},
    /*::[*/ 0x0020: {},
    /*::[*/ 0x0021: {},
    /*::[*/ 0x0022: {},
    /*::[*/ 0x0023: {
        T: 1
    },
    /*::[*/ 0x0024: {
        T: -1
    },
    /*::[*/ 0x0025: {
        T: 1
    },
    /*::[*/ 0x0026: {
        T: -1
    },
    /*::[*/ 0x0027: {
        f: parse_BrtName
    },
    /*::[*/ 0x0028: {},
    /*::[*/ 0x002A: {},
    /*::[*/ 0x002B: {
        f: parse_BrtFont
    },
    /*::[*/ 0x002C: {
        f: parse_BrtFmt
    },
    /*::[*/ 0x002D: {
        f: parse_BrtFill
    },
    /*::[*/ 0x002E: {
        f: parse_BrtBorder
    },
    /*::[*/ 0x002F: {
        f: parse_BrtXF
    },
    /*::[*/ 0x0030: {},
    /*::[*/ 0x0031: {
        f: parse_Int32LE
    },
    /*::[*/ 0x0032: {},
    /*::[*/ 0x0033: {
        f: parse_BrtMdb
    },
    /*::[*/ 0x0034: {
        T: 1
    },
    /*::[*/ 0x0035: {
        T: -1
    },
    /*::[*/ 0x0036: {
        T: 1
    },
    /*::[*/ 0x0037: {
        T: -1
    },
    /*::[*/ 0x0038: {
        T: 1
    },
    /*::[*/ 0x0039: {
        T: -1
    },
    /*::[*/ 0x003A: {},
    /*::[*/ 0x003B: {},
    /*::[*/ 0x003C: {
        f: parse_ColInfo
    },
    /*::[*/ 0x003E: {
        f: parse_BrtCellRString
    },
    /*::[*/ 0x003F: {
        f: parse_BrtCalcChainItem$
    },
    /*::[*/ 0x0040: {
        f: parse_BrtDVal
    },
    /*::[*/ 0x0041: {},
    /*::[*/ 0x0042: {},
    /*::[*/ 0x0043: {},
    /*::[*/ 0x0044: {},
    /*::[*/ 0x0045: {},
    /*::[*/ 0x0046: {},
    /*::[*/ 0x0080: {},
    /*::[*/ 0x0081: {
        T: 1
    },
    /*::[*/ 0x0082: {
        T: -1
    },
    /*::[*/ 0x0083: {
        T: 1,
        f: parsenoop,
        p: 0
    },
    /*::[*/ 0x0084: {
        T: -1
    },
    /*::[*/ 0x0085: {
        T: 1
    },
    /*::[*/ 0x0086: {
        T: -1
    },
    /*::[*/ 0x0087: {
        T: 1
    },
    /*::[*/ 0x0088: {
        T: -1
    },
    /*::[*/ 0x0089: {
        T: 1,
        f: parse_BrtBeginWsView
    },
    /*::[*/ 0x008A: {
        T: -1
    },
    /*::[*/ 0x008B: {
        T: 1
    },
    /*::[*/ 0x008C: {
        T: -1
    },
    /*::[*/ 0x008D: {
        T: 1
    },
    /*::[*/ 0x008E: {
        T: -1
    },
    /*::[*/ 0x008F: {
        T: 1
    },
    /*::[*/ 0x0090: {
        T: -1
    },
    /*::[*/ 0x0091: {
        T: 1
    },
    /*::[*/ 0x0092: {
        T: -1
    },
    /*::[*/ 0x0093: {
        f: parse_BrtWsProp
    },
    /*::[*/ 0x0094: {
        f: parse_BrtWsDim,
        p: 16
    },
    /*::[*/ 0x0097: {
        f: parse_BrtPane
    },
    /*::[*/ 0x0098: {},
    /*::[*/ 0x0099: {
        f: parse_BrtWbProp
    },
    /*::[*/ 0x009A: {},
    /*::[*/ 0x009B: {},
    /*::[*/ 0x009C: {
        f: parse_BrtBundleSh
    },
    /*::[*/ 0x009D: {},
    /*::[*/ 0x009E: {},
    /*::[*/ 0x009F: {
        T: 1,
        f: parse_BrtBeginSst
    },
    /*::[*/ 0x00A0: {
        T: -1
    },
    /*::[*/ 0x00A1: {
        T: 1,
        f: parse_UncheckedRfX
    },
    /*::[*/ 0x00A2: {
        T: -1
    },
    /*::[*/ 0x00A3: {
        T: 1
    },
    /*::[*/ 0x00A4: {
        T: -1
    },
    /*::[*/ 0x00A5: {
        T: 1
    },
    /*::[*/ 0x00A6: {
        T: -1
    },
    /*::[*/ 0x00A7: {},
    /*::[*/ 0x00A8: {},
    /*::[*/ 0x00A9: {},
    /*::[*/ 0x00AA: {},
    /*::[*/ 0x00AB: {},
    /*::[*/ 0x00AC: {
        T: 1
    },
    /*::[*/ 0x00AD: {
        T: -1
    },
    /*::[*/ 0x00AE: {},
    /*::[*/ 0x00AF: {},
    /*::[*/ 0x00B0: {
        f: parse_BrtMergeCell
    },
    /*::[*/ 0x00B1: {
        T: 1
    },
    /*::[*/ 0x00B2: {
        T: -1
    },
    /*::[*/ 0x00B3: {
        T: 1
    },
    /*::[*/ 0x00B4: {
        T: -1
    },
    /*::[*/ 0x00B5: {
        T: 1
    },
    /*::[*/ 0x00B6: {
        T: -1
    },
    /*::[*/ 0x00B7: {
        T: 1
    },
    /*::[*/ 0x00B8: {
        T: -1
    },
    /*::[*/ 0x00B9: {
        T: 1
    },
    /*::[*/ 0x00BA: {
        T: -1
    },
    /*::[*/ 0x00BB: {
        T: 1
    },
    /*::[*/ 0x00BC: {
        T: -1
    },
    /*::[*/ 0x00BD: {
        T: 1
    },
    /*::[*/ 0x00BE: {
        T: -1
    },
    /*::[*/ 0x00BF: {
        T: 1
    },
    /*::[*/ 0x00C0: {
        T: -1
    },
    /*::[*/ 0x00C1: {
        T: 1
    },
    /*::[*/ 0x00C2: {
        T: -1
    },
    /*::[*/ 0x00C3: {
        T: 1
    },
    /*::[*/ 0x00C4: {
        T: -1
    },
    /*::[*/ 0x00C5: {
        T: 1
    },
    /*::[*/ 0x00C6: {
        T: -1
    },
    /*::[*/ 0x00C7: {
        T: 1
    },
    /*::[*/ 0x00C8: {
        T: -1
    },
    /*::[*/ 0x00C9: {
        T: 1
    },
    /*::[*/ 0x00CA: {
        T: -1
    },
    /*::[*/ 0x00CB: {
        T: 1
    },
    /*::[*/ 0x00CC: {
        T: -1
    },
    /*::[*/ 0x00CD: {
        T: 1
    },
    /*::[*/ 0x00CE: {
        T: -1
    },
    /*::[*/ 0x00CF: {
        T: 1
    },
    /*::[*/ 0x00D0: {
        T: -1
    },
    /*::[*/ 0x00D1: {
        T: 1
    },
    /*::[*/ 0x00D2: {
        T: -1
    },
    /*::[*/ 0x00D3: {
        T: 1
    },
    /*::[*/ 0x00D4: {
        T: -1
    },
    /*::[*/ 0x00D5: {
        T: 1
    },
    /*::[*/ 0x00D6: {
        T: -1
    },
    /*::[*/ 0x00D7: {
        T: 1
    },
    /*::[*/ 0x00D8: {
        T: -1
    },
    /*::[*/ 0x00D9: {
        T: 1
    },
    /*::[*/ 0x00DA: {
        T: -1
    },
    /*::[*/ 0x00DB: {
        T: 1
    },
    /*::[*/ 0x00DC: {
        T: -1
    },
    /*::[*/ 0x00DD: {
        T: 1
    },
    /*::[*/ 0x00DE: {
        T: -1
    },
    /*::[*/ 0x00DF: {
        T: 1
    },
    /*::[*/ 0x00E0: {
        T: -1
    },
    /*::[*/ 0x00E1: {
        T: 1
    },
    /*::[*/ 0x00E2: {
        T: -1
    },
    /*::[*/ 0x00E3: {
        T: 1
    },
    /*::[*/ 0x00E4: {
        T: -1
    },
    /*::[*/ 0x00E5: {
        T: 1
    },
    /*::[*/ 0x00E6: {
        T: -1
    },
    /*::[*/ 0x00E7: {
        T: 1
    },
    /*::[*/ 0x00E8: {
        T: -1
    },
    /*::[*/ 0x00E9: {
        T: 1
    },
    /*::[*/ 0x00EA: {
        T: -1
    },
    /*::[*/ 0x00EB: {
        T: 1
    },
    /*::[*/ 0x00EC: {
        T: -1
    },
    /*::[*/ 0x00ED: {
        T: 1
    },
    /*::[*/ 0x00EE: {
        T: -1
    },
    /*::[*/ 0x00EF: {
        T: 1
    },
    /*::[*/ 0x00F0: {
        T: -1
    },
    /*::[*/ 0x00F1: {
        T: 1
    },
    /*::[*/ 0x00F2: {
        T: -1
    },
    /*::[*/ 0x00F3: {
        T: 1
    },
    /*::[*/ 0x00F4: {
        T: -1
    },
    /*::[*/ 0x00F5: {
        T: 1
    },
    /*::[*/ 0x00F6: {
        T: -1
    },
    /*::[*/ 0x00F7: {
        T: 1
    },
    /*::[*/ 0x00F8: {
        T: -1
    },
    /*::[*/ 0x00F9: {
        T: 1
    },
    /*::[*/ 0x00FA: {
        T: -1
    },
    /*::[*/ 0x00FB: {
        T: 1
    },
    /*::[*/ 0x00FC: {
        T: -1
    },
    /*::[*/ 0x00FD: {
        T: 1
    },
    /*::[*/ 0x00FE: {
        T: -1
    },
    /*::[*/ 0x00FF: {
        T: 1
    },
    /*::[*/ 0x0100: {
        T: -1
    },
    /*::[*/ 0x0101: {
        T: 1
    },
    /*::[*/ 0x0102: {
        T: -1
    },
    /*::[*/ 0x0103: {
        T: 1
    },
    /*::[*/ 0x0104: {
        T: -1
    },
    /*::[*/ 0x0105: {
        T: 1
    },
    /*::[*/ 0x0106: {
        T: -1
    },
    /*::[*/ 0x0107: {
        T: 1
    },
    /*::[*/ 0x0108: {
        T: -1
    },
    /*::[*/ 0x0109: {
        T: 1
    },
    /*::[*/ 0x010A: {
        T: -1
    },
    /*::[*/ 0x010B: {
        T: 1
    },
    /*::[*/ 0x010C: {
        T: -1
    },
    /*::[*/ 0x010D: {
        T: 1
    },
    /*::[*/ 0x010E: {
        T: -1
    },
    /*::[*/ 0x010F: {
        T: 1
    },
    /*::[*/ 0x0110: {
        T: -1
    },
    /*::[*/ 0x0111: {
        T: 1
    },
    /*::[*/ 0x0112: {
        T: -1
    },
    /*::[*/ 0x0113: {
        T: 1
    },
    /*::[*/ 0x0114: {
        T: -1
    },
    /*::[*/ 0x0115: {},
    /*::[*/ 0x0116: {
        T: 1
    },
    /*::[*/ 0x0117: {
        T: -1
    },
    /*::[*/ 0x0118: {
        T: 1
    },
    /*::[*/ 0x0119: {
        T: -1
    },
    /*::[*/ 0x011A: {
        T: 1
    },
    /*::[*/ 0x011B: {
        T: 1
    },
    /*::[*/ 0x011C: {
        T: -1
    },
    /*::[*/ 0x011D: {
        T: 1
    },
    /*::[*/ 0x011E: {
        T: -1
    },
    /*::[*/ 0x011F: {
        T: 1
    },
    /*::[*/ 0x0120: {
        T: -1
    },
    /*::[*/ 0x0121: {
        T: 1
    },
    /*::[*/ 0x0122: {
        T: -1
    },
    /*::[*/ 0x0123: {
        T: 1
    },
    /*::[*/ 0x0124: {
        T: -1
    },
    /*::[*/ 0x0125: {
        T: 1
    },
    /*::[*/ 0x0126: {
        T: -1
    },
    /*::[*/ 0x0127: {
        T: 1
    },
    /*::[*/ 0x0128: {
        T: -1
    },
    /*::[*/ 0x0129: {
        T: 1
    },
    /*::[*/ 0x012A: {
        T: -1
    },
    /*::[*/ 0x012B: {
        T: 1
    },
    /*::[*/ 0x012C: {
        T: -1
    },
    /*::[*/ 0x012D: {
        T: 1
    },
    /*::[*/ 0x012E: {
        T: -1
    },
    /*::[*/ 0x012F: {
        T: 1
    },
    /*::[*/ 0x0130: {
        T: -1
    },
    /*::[*/ 0x0131: {
        T: 1
    },
    /*::[*/ 0x0132: {
        T: -1
    },
    /*::[*/ 0x0133: {
        T: 1
    },
    /*::[*/ 0x0134: {
        T: -1
    },
    /*::[*/ 0x0135: {
        T: 1
    },
    /*::[*/ 0x0136: {
        T: -1
    },
    /*::[*/ 0x0137: {
        T: 1
    },
    /*::[*/ 0x0138: {
        T: -1
    },
    /*::[*/ 0x0139: {
        T: -1
    },
    /*::[*/ 0x013A: {
        T: 1
    },
    /*::[*/ 0x013B: {
        T: -1
    },
    /*::[*/ 0x013C: {
        T: 1
    },
    /*::[*/ 0x013D: {
        T: -1
    },
    /*::[*/ 0x013E: {
        T: 1
    },
    /*::[*/ 0x013F: {
        T: -1
    },
    /*::[*/ 0x0140: {
        T: 1
    },
    /*::[*/ 0x0141: {
        T: -1
    },
    /*::[*/ 0x0142: {
        T: 1
    },
    /*::[*/ 0x0143: {
        T: -1
    },
    /*::[*/ 0x0144: {
        T: 1
    },
    /*::[*/ 0x0145: {
        T: -1
    },
    /*::[*/ 0x0146: {
        T: 1
    },
    /*::[*/ 0x0147: {
        T: -1
    },
    /*::[*/ 0x0148: {
        T: 1
    },
    /*::[*/ 0x0149: {
        T: -1
    },
    /*::[*/ 0x014A: {
        T: 1
    },
    /*::[*/ 0x014B: {
        T: -1
    },
    /*::[*/ 0x014C: {
        T: 1
    },
    /*::[*/ 0x014D: {
        T: -1
    },
    /*::[*/ 0x014E: {
        T: 1
    },
    /*::[*/ 0x014F: {
        f: parse_BrtMdtinfo
    },
    /*::[*/ 0x0150: {
        T: -1
    },
    /*::[*/ 0x0151: {
        f: parse_BrtBeginEsmdb,
        T: 1
    },
    /*::[*/ 0x0152: {
        T: -1
    },
    /*::[*/ 0x0153: {
        T: 1
    },
    /*::[*/ 0x0154: {
        T: -1
    },
    /*::[*/ 0x0155: {
        T: 1
    },
    /*::[*/ 0x0156: {
        T: -1
    },
    /*::[*/ 0x0157: {
        T: 1
    },
    /*::[*/ 0x0158: {
        T: -1
    },
    /*::[*/ 0x0159: {
        T: 1
    },
    /*::[*/ 0x015A: {
        T: -1
    },
    /*::[*/ 0x015B: {
        T: 1
    },
    /*::[*/ 0x015C: {
        T: -1
    },
    /*::[*/ 0x015D: {
        T: 1
    },
    /*::[*/ 0x015E: {
        T: -1
    },
    /*::[*/ 0x015F: {},
    /*::[*/ 0x0160: {},
    /*::[*/ 0x0161: {
        T: 1
    },
    /*::[*/ 0x0162: {
        T: -1
    },
    /*::[*/ 0x0163: {
        f: parse_RelID
    },
    /*::[*/ 0x0165: {},
    /*::[*/ 0x0166: {},
    /*::[*/ 0x0167: {},
    /*::[*/ 0x0168: {
        T: 1
    },
    /*::[*/ 0x0169: {},
    /*::[*/ 0x016A: {
        f: parse_ExternSheet
    },
    /*::[*/ 0x016B: {},
    /*::[*/ 0x016C: {},
    /*::[*/ 0x016E: {},
    /*::[*/ 0x016F: {},
    /*::[*/ 0x0170: {},
    /*::[*/ 0x0171: {},
    /*::[*/ 0x0172: {},
    /*::[*/ 0x0173: {},
    /*::[*/ 0x0174: {
        T: 1
    },
    /*::[*/ 0x0175: {
        T: -1
    },
    /*::[*/ 0x0176: {
        T: 1
    },
    /*::[*/ 0x0177: {
        T: -1
    },
    /*::[*/ 0x0178: {
        T: 1
    },
    /*::[*/ 0x0179: {
        T: -1
    },
    /*::[*/ 0x017A: {
        T: 1
    },
    /*::[*/ 0x017B: {
        T: -1
    },
    /*::[*/ 0x017C: {
        T: 1
    },
    /*::[*/ 0x017D: {
        T: -1
    },
    /*::[*/ 0x017E: {
        T: 1
    },
    /*::[*/ 0x017F: {
        T: -1
    },
    /*::[*/ 0x0180: {
        T: 1
    },
    /*::[*/ 0x0181: {
        T: -1
    },
    /*::[*/ 0x0182: {
        T: 1
    },
    /*::[*/ 0x0183: {
        T: -1
    },
    /*::[*/ 0x0184: {
        T: 1
    },
    /*::[*/ 0x0185: {
        T: -1
    },
    /*::[*/ 0x0186: {
        T: 1
    },
    /*::[*/ 0x0187: {
        T: -1
    },
    /*::[*/ 0x0188: {
        T: 1
    },
    /*::[*/ 0x0189: {
        T: -1
    },
    /*::[*/ 0x018A: {
        T: 1
    },
    /*::[*/ 0x018B: {
        T: -1
    },
    /*::[*/ 0x018C: {},
    /*::[*/ 0x018D: {},
    /*::[*/ 0x018E: {},
    /*::[*/ 0x018F: {},
    /*::[*/ 0x0190: {},
    /*::[*/ 0x0191: {
        T: 1
    },
    /*::[*/ 0x0193: {},
    /*::[*/ 0x0194: {},
    /*::[*/ 0x0195: {},
    /*::[*/ 0x0196: {},
    /*::[*/ 0x0197: {},
    /*::[*/ 0x0198: {},
    /*::[*/ 0x0199: {},
    /*::[*/ 0x019A: {},
    /*::[*/ 0x019B: {},
    /*::[*/ 0x019C: {},
    /*::[*/ 0x019D: {},
    /*::[*/ 0x019E: {},
    /*::[*/ 0x019F: {},
    /*::[*/ 0x01A0: {},
    /*::[*/ 0x01A1: {},
    /*::[*/ 0x01A2: {},
    /*::[*/ 0x01A3: {},
    /*::[*/ 0x01A4: {},
    /*::[*/ 0x01A5: {},
    /*::[*/ 0x01A6: {
        T: 1
    },
    /*::[*/ 0x01A7: {
        T: 1
    },
    /*::[*/ 0x01A8: {
        T: -1
    },
    /*::[*/ 0x01A9: {
        T: -1
    },
    /*::[*/ 0x01AA: {
        f: parse_BrtArrFmla
    },
    /*::[*/ 0x01AB: {
        f: parse_BrtShrFmla
    },
    /*::[*/ 0x01AC: {},
    /*::[*/ 0x01AD: {
        T: 1
    },
    /*::[*/ 0x01AE: {
        T: -1
    },
    /*::[*/ 0x01AF: {
        T: 1
    },
    /*::[*/ 0x01B0: {
        T: -1
    },
    /*::[*/ 0x01B1: {
        T: 1
    },
    /*::[*/ 0x01B2: {
        T: -1
    },
    /*::[*/ 0x01B3: {
        T: 1
    },
    /*::[*/ 0x01B4: {
        T: -1
    },
    /*::[*/ 0x01B5: {
        T: 1
    },
    /*::[*/ 0x01B6: {
        T: -1
    },
    /*::[*/ 0x01B7: {
        T: 1
    },
    /*::[*/ 0x01B8: {
        T: -1
    },
    /*::[*/ 0x01B9: {
        T: 1
    },
    /*::[*/ 0x01BA: {
        T: -1
    },
    /*::[*/ 0x01BB: {
        T: 1
    },
    /*::[*/ 0x01BC: {
        T: -1
    },
    /*::[*/ 0x01BD: {
        T: 1
    },
    /*::[*/ 0x01BE: {
        T: -1
    },
    /*::[*/ 0x01BF: {
        T: 1
    },
    /*::[*/ 0x01C0: {
        T: -1
    },
    /*::[*/ 0x01C1: {
        T: 1
    },
    /*::[*/ 0x01C2: {
        T: -1
    },
    /*::[*/ 0x01C3: {
        T: 1
    },
    /*::[*/ 0x01C4: {
        T: -1
    },
    /*::[*/ 0x01C5: {
        T: 1
    },
    /*::[*/ 0x01C6: {
        T: -1
    },
    /*::[*/ 0x01C7: {
        T: 1
    },
    /*::[*/ 0x01C8: {
        T: -1
    },
    /*::[*/ 0x01C9: {
        T: 1
    },
    /*::[*/ 0x01CA: {
        T: -1
    },
    /*::[*/ 0x01CB: {
        T: 1
    },
    /*::[*/ 0x01CC: {
        T: -1
    },
    /*::[*/ 0x01CD: {
        T: 1
    },
    /*::[*/ 0x01CE: {
        T: -1
    },
    /*::[*/ 0x01CF: {
        T: 1
    },
    /*::[*/ 0x01D0: {
        T: -1
    },
    /*::[*/ 0x01D1: {
        T: 1
    },
    /*::[*/ 0x01D2: {
        T: -1
    },
    /*::[*/ 0x01D3: {
        T: 1
    },
    /*::[*/ 0x01D4: {
        T: -1
    },
    /*::[*/ 0x01D5: {
        T: 1
    },
    /*::[*/ 0x01D6: {
        T: -1
    },
    /*::[*/ 0x01D7: {},
    /*::[*/ 0x01D8: {},
    /*::[*/ 0x01D9: {
        T: 1
    },
    /*::[*/ 0x01DA: {
        T: -1
    },
    /*::[*/ 0x01DB: {},
    /*::[*/ 0x01DC: {
        f: parse_BrtMargins
    },
    /*::[*/ 0x01DD: {},
    /*::[*/ 0x01DE: {},
    /*::[*/ 0x01DF: {
        T: 1
    },
    /*::[*/ 0x01E0: {
        T: -1
    },
    /*::[*/ 0x01E1: {
        T: 1
    },
    /*::[*/ 0x01E2: {
        T: -1
    },
    /*::[*/ 0x01E3: {
        T: 1
    },
    /*::[*/ 0x01E4: {
        T: -1
    },
    /*::[*/ 0x01E5: {
        f: parse_BrtWsFmtInfo
    },
    /*::[*/ 0x01E6: {
        T: 1
    },
    /*::[*/ 0x01E7: {
        T: -1
    },
    /*::[*/ 0x01E8: {
        T: 1
    },
    /*::[*/ 0x01E9: {
        T: -1
    },
    /*::[*/ 0x01EA: {
        T: 1
    },
    /*::[*/ 0x01EB: {
        T: -1
    },
    /*::[*/ 0x01EC: {
        T: 1
    },
    /*::[*/ 0x01ED: {
        T: -1
    },
    /*::[*/ 0x01EE: {
        f: parse_BrtHLink
    },
    /*::[*/ 0x01EF: {
        T: 1
    },
    /*::[*/ 0x01F0: {
        T: -1
    },
    /*::[*/ 0x01F1: {
        T: 1
    },
    /*::[*/ 0x01F2: {
        T: -1
    },
    /*::[*/ 0x01F3: {},
    /*::[*/ 0x01F4: {
        T: 1
    },
    /*::[*/ 0x01F5: {
        T: -1
    },
    /*::[*/ 0x01F6: {
        T: 1
    },
    /*::[*/ 0x01F7: {
        T: -1
    },
    /*::[*/ 0x01F8: {},
    /*::[*/ 0x01F9: {
        T: 1
    },
    /*::[*/ 0x01FA: {
        T: -1
    },
    /*::[*/ 0x01FB: {},
    /*::[*/ 0x01FC: {
        T: 1
    },
    /*::[*/ 0x01FD: {
        T: -1
    },
    /*::[*/ 0x01FE: {
        T: 1
    },
    /*::[*/ 0x01FF: {
        T: -1
    },
    /*::[*/ 0x0200: {},
    /*::[*/ 0x0201: {},
    /*::[*/ 0x0202: {
        T: 1
    },
    /*::[*/ 0x0203: {
        T: -1
    },
    /*::[*/ 0x0204: {
        T: 1
    },
    /*::[*/ 0x0205: {
        T: -1
    },
    /*::[*/ 0x0206: {
        T: 1
    },
    /*::[*/ 0x0207: {
        T: -1
    },
    /*::[*/ 0x0208: {
        T: 1
    },
    /*::[*/ 0x0209: {
        T: -1
    },
    /*::[*/ 0x020A: {},
    /*::[*/ 0x020B: {},
    /*::[*/ 0x020C: {},
    /*::[*/ 0x020D: {},
    /*::[*/ 0x020E: {},
    /*::[*/ 0x020F: {},
    /*::[*/ 0x0210: {
        T: 1
    },
    /*::[*/ 0x0211: {
        T: -1
    },
    /*::[*/ 0x0212: {
        T: 1
    },
    /*::[*/ 0x0213: {
        T: -1
    },
    /*::[*/ 0x0214: {
        T: 1
    },
    /*::[*/ 0x0215: {
        T: -1
    },
    /*::[*/ 0x0216: {},
    /*::[*/ 0x0217: {},
    /*::[*/ 0x0218: {},
    /*::[*/ 0x0219: {},
    /*::[*/ 0x021A: {
        T: 1
    },
    /*::[*/ 0x021B: {
        T: -1
    },
    /*::[*/ 0x021C: {
        T: 1
    },
    /*::[*/ 0x021D: {
        T: -1
    },
    /*::[*/ 0x021E: {
        T: 1
    },
    /*::[*/ 0x0224: {},
    /*::[*/ 0x0225: {},
    /*::[*/ 0x0226: {
        f: parse_RelID
    },
    /*::[*/ 0x0227: {},
    /*::[*/ 0x0228: {},
    /*::[*/ 0x0229: {},
    /*::[*/ 0x022A: {
        T: 1
    },
    /*::[*/ 0x022B: {
        T: -1
    },
    /*::[*/ 0x022C: {
        T: 1
    },
    /*::[*/ 0x022D: {
        T: -1
    },
    /*::[*/ 0x022E: {
        T: 1
    },
    /*::[*/ 0x022F: {
        T: -1
    },
    /*::[*/ 0x0230: {
        T: 1
    },
    /*::[*/ 0x0231: {
        T: -1
    },
    /*::[*/ 0x0232: {},
    /*::[*/ 0x0234: {},
    /*::[*/ 0x0235: {
        T: 1
    },
    /*::[*/ 0x0236: {
        T: -1
    },
    /*::[*/ 0x0239: {
        T: 1
    },
    /*::[*/ 0x023A: {
        T: -1
    },
    /*::[*/ 0x023C: {},
    /*::[*/ 0x023D: {
        T: 1
    },
    /*::[*/ 0x023E: {
        T: -1
    },
    /*::[*/ 0x0241: {},
    /*::[*/ 0x0242: {},
    /*::[*/ 0x0243: {},
    /*::[*/ 0x0244: {},
    /*::[*/ 0x0245: {},
    /*::[*/ 0x0246: {},
    /*::[*/ 0x0247: {},
    /*::[*/ 0x0248: {},
    /*::[*/ 0x0249: {},
    /*::[*/ 0x024A: {},
    /*::[*/ 0x024B: {},
    /*::[*/ 0x024C: {
        T: -1
    },
    /*::[*/ 0x024D: {},
    /*::[*/ 0x024E: {
        T: 1
    },
    /*::[*/ 0x024F: {
        T: -1
    },
    /*::[*/ 0x0250: {
        T: 1
    },
    /*::[*/ 0x0251: {
        T: -1
    },
    /*::[*/ 0x0252: {
        T: 1
    },
    /*::[*/ 0x0253: {
        T: -1
    },
    /*::[*/ 0x0254: {},
    /*::[*/ 0x0255: {
        T: 1
    },
    /*::[*/ 0x0256: {
        T: -1
    },
    /*::[*/ 0x0257: {
        T: 1
    },
    /*::[*/ 0x0258: {
        T: -1
    },
    /*::[*/ 0x0259: {
        T: 1
    },
    /*::[*/ 0x025A: {
        T: -1
    },
    /*::[*/ 0x025B: {
        T: 1
    },
    /*::[*/ 0x025C: {
        T: -1
    },
    /*::[*/ 0x025D: {
        T: 1
    },
    /*::[*/ 0x025E: {
        T: -1
    },
    /*::[*/ 0x025F: {},
    /*::[*/ 0x0260: {
        T: 1
    },
    /*::[*/ 0x0261: {
        T: -1
    },
    /*::[*/ 0x0262: {},
    /*::[*/ 0x0263: {
        T: 1
    },
    /*::[*/ 0x0264: {
        T: -1
    },
    /*::[*/ 0x0265: {
        T: 1
    },
    /*::[*/ 0x0266: {
        T: -1
    },
    /*::[*/ 0x0267: {
        T: 1
    },
    /*::[*/ 0x0268: {
        T: -1
    },
    /*::[*/ 0x0269: {
        T: 1
    },
    /*::[*/ 0x026A: {
        T: -1
    },
    /*::[*/ 0x026B: {
        T: 1
    },
    /*::[*/ 0x026C: {
        T: -1
    },
    /*::[*/ 0x0271: {},
    /*::[*/ 0x0272: {
        T: 1
    },
    /*::[*/ 0x0273: {
        T: -1
    },
    /*::[*/ 0x0274: {
        T: 1
    },
    /*::[*/ 0x0275: {
        T: -1
    },
    /*::[*/ 0x0276: {
        T: 1
    },
    /*::[*/ 0x0277: {
        T: -1
    },
    /*::[*/ 0x0278: {
        f: parse_BrtCommentAuthor
    },
    /*::[*/ 0x0279: {
        T: 1
    },
    /*::[*/ 0x027A: {
        T: -1
    },
    /*::[*/ 0x027B: {
        T: 1,
        f: parse_BrtBeginComment
    },
    /*::[*/ 0x027C: {
        T: -1
    },
    /*::[*/ 0x027D: {
        f: parse_BrtCommentText
    },
    /*::[*/ 0x027E: {
        T: 1
    },
    /*::[*/ 0x027F: {},
    /*::[*/ 0x0280: {
        T: -1
    },
    /*::[*/ 0x0281: {
        T: 1
    },
    /*::[*/ 0x0282: {
        T: -1
    },
    /*::[*/ 0x0283: {
        T: 1
    },
    /*::[*/ 0x0284: {},
    /*::[*/ 0x0285: {
        T: -1
    },
    /*::[*/ 0x0286: {
        T: 1
    },
    /*::[*/ 0x0288: {
        T: 1
    },
    /*::[*/ 0x0289: {},
    /*::[*/ 0x028A: {
        T: -1
    },
    /*::[*/ 0x028B: {
        f: parse_BrtCsProp
    },
    /*::[*/ 0x028C: {},
    /*::[*/ 0x028D: {
        T: 1
    },
    /*::[*/ 0x028E: {
        T: -1
    },
    /*::[*/ 0x028F: {
        T: 1
    },
    /*::[*/ 0x0290: {
        T: -1
    },
    /*::[*/ 0x0291: {
        T: 1
    },
    /*::[*/ 0x0292: {
        T: -1
    },
    /*::[*/ 0x0293: {},
    /*::[*/ 0x0294: {
        T: 1
    },
    /*::[*/ 0x0295: {},
    /*::[*/ 0x0296: {
        T: -1
    },
    /*::[*/ 0x0297: {},
    /*::[*/ 0x0298: {
        T: 1
    },
    /*::[*/ 0x0299: {},
    /*::[*/ 0x029A: {
        T: -1
    },
    /*::[*/ 0x029B: {},
    /*::[*/ 0x029C: {},
    /*::[*/ 0x029D: {},
    /*::[*/ 0x029F: {
        T: 1
    },
    /*::[*/ 0x02A0: {
        T: -1
    },
    /*::[*/ 0x02A1: {
        T: 1
    },
    /*::[*/ 0x02A2: {
        T: -1
    },
    /*::[*/ 0x02A3: {},
    /*::[*/ 0x02A4: {},
    /*::[*/ 0x02A5: {},
    /*::[*/ 0x02A6: {},
    /*::[*/ 0x02A7: {},
    /*::[*/ 0x02A8: {},
    /*::[*/ 0x02A9: {},
    /*::[*/ 0x0400: {},
    /*::[*/ 0x0401: {},
    /*::[*/ 0x0402: {
        T: 1
    },
    /*::[*/ 0x0403: {
        T: -1
    },
    /*::[*/ 0x0404: {
        T: 1
    },
    /*::[*/ 0x0405: {
        T: -1
    },
    /*::[*/ 0x0406: {},
    /*::[*/ 0x0407: {
        T: 1
    },
    /*::[*/ 0x0408: {
        T: -1
    },
    /*::[*/ 0x0409: {
        T: 1
    },
    /*::[*/ 0x040A: {
        T: -1
    },
    /*::[*/ 0x040B: {},
    /*::[*/ 0x040C: {},
    /*::[*/ 0x040D: {},
    /*::[*/ 0x040E: {
        T: 1
    },
    /*::[*/ 0x040F: {
        T: -1
    },
    /*::[*/ 0x0410: {},
    /*::[*/ 0x0411: {
        T: 1
    },
    /*::[*/ 0x0412: {
        T: -1
    },
    /*::[*/ 0x0413: {},
    /*::[*/ 0x0414: {},
    /*::[*/ 0x0415: {},
    /*::[*/ 0x0416: {
        T: 1
    },
    /*::[*/ 0x0417: {
        T: -1
    },
    /*::[*/ 0x0418: {
        T: 1
    },
    /*::[*/ 0x0419: {
        T: -1
    },
    /*::[*/ 0x041A: {},
    /*::[*/ 0x041B: {
        T: 1
    },
    /*::[*/ 0x041C: {
        T: 1
    },
    /*::[*/ 0x041D: {
        f: parse_BrtDVal14
    },
    /*::[*/ 0x041E: {
        T: 1
    },
    /*::[*/ 0x041F: {},
    /*::[*/ 0x0420: {
        T: 1
    },
    /*::[*/ 0x0421: {
        T: -1
    },
    /*::[*/ 0x0422: {
        T: 1
    },
    /*::[*/ 0x0423: {
        T: -1
    },
    /*::[*/ 0x0425: {},
    /*::[*/ 0x0426: {
        T: 1
    },
    /*::[*/ 0x0427: {
        T: -1
    },
    /*::[*/ 0x0428: {
        T: 1
    },
    /*::[*/ 0x0429: {
        T: -1
    },
    /*::[*/ 0x042A: {
        T: 1
    },
    /*::[*/ 0x042B: {
        T: -1
    },
    /*::[*/ 0x042C: {
        T: 1
    },
    /*::[*/ 0x042D: {
        T: -1
    },
    /*::[*/ 0x042E: {
        T: 1
    },
    /*::[*/ 0x042F: {
        T: -1
    },
    /*::[*/ 0x0430: {
        T: 1
    },
    /*::[*/ 0x0431: {
        T: -1
    },
    /*::[*/ 0x0433: {
        T: 1
    },
    /*::[*/ 0x0434: {
        T: -1
    },
    /*::[*/ 0x0435: {
        T: 1
    },
    /*::[*/ 0x0436: {
        T: -1
    },
    /*::[*/ 0x0437: {
        T: 1
    },
    /*::[*/ 0x0438: {
        T: -1
    },
    /*::[*/ 0x0439: {
        T: 1
    },
    /*::[*/ 0x043A: {
        T: -1
    },
    /*::[*/ 0x043B: {
        T: 1
    },
    /*::[*/ 0x043C: {
        T: -1
    },
    /*::[*/ 0x043D: {},
    /*::[*/ 0x043E: {
        T: 1
    },
    /*::[*/ 0x043F: {
        T: -1
    },
    /*::[*/ 0x0440: {
        T: 1
    },
    /*::[*/ 0x0441: {
        T: -1
    },
    /*::[*/ 0x0442: {
        T: 1
    },
    /*::[*/ 0x0443: {
        T: -1
    },
    /*::[*/ 0x0444: {
        T: 1
    },
    /*::[*/ 0x0445: {
        T: -1
    },
    /*::[*/ 0x0446: {
        T: 1
    },
    /*::[*/ 0x0447: {
        T: -1
    },
    /*::[*/ 0x0448: {},
    /*::[*/ 0x0449: {
        T: 1
    },
    /*::[*/ 0x044A: {},
    /*::[*/ 0x044B: {
        T: -1
    },
    /*::[*/ 0x044C: {
        T: 1
    },
    /*::[*/ 0x044D: {
        T: -1
    },
    /*::[*/ 0x044E: {},
    /*::[*/ 0x044F: {},
    /*::[*/ 0x0450: {},
    /*::[*/ 0x0451: {},
    /*::[*/ 0x0457: {},
    /*::[*/ 0x0458: {},
    /*::[*/ 0x0459: {
        T: 1
    },
    /*::[*/ 0x045A: {
        T: -1
    },
    /*::[*/ 0x045B: {
        T: 1
    },
    /*::[*/ 0x045C: {
        T: -1
    },
    /*::[*/ 0x045D: {},
    /*::[*/ 0x045E: {
        T: 1
    },
    /*::[*/ 0x045F: {
        T: -1
    },
    /*::[*/ 0x0460: {
        T: 1
    },
    /*::[*/ 0x0461: {
        T: -1
    },
    /*::[*/ 0x0462: {
        T: 1
    },
    /*::[*/ 0x0463: {
        T: -1
    },
    /*::[*/ 0x0464: {
        T: 1
    },
    /*::[*/ 0x0465: {
        T: -1
    },
    /*::[*/ 0x0466: {},
    /*::[*/ 0x0468: {
        T: 1
    },
    /*::[*/ 0x0469: {
        T: -1
    },
    /*::[*/ 0x046A: {},
    /*::[*/ 0x046B: {
        T: 1
    },
    /*::[*/ 0x046C: {
        T: -1
    },
    /*::[*/ 0x046D: {
        T: 1
    },
    /*::[*/ 0x046E: {
        T: -1
    },
    /*::[*/ 0x046F: {
        T: 1
    },
    /*::[*/ 0x0470: {
        T: -1
    },
    /*::[*/ 0x0471: {
        T: 1
    },
    /*::[*/ 0x0472: {
        T: -1
    },
    /*::[*/ 0x0473: {
        T: 1
    },
    /*::[*/ 0x0474: {
        T: -1
    },
    /*::[*/ 0x0475: {},
    /*::[*/ 0x0476: {
        T: 1
    },
    /*::[*/ 0x0477: {
        T: -1
    },
    /*::[*/ 0x0478: {
        T: 1
    },
    /*::[*/ 0x0479: {
        T: -1
    },
    /*::[*/ 0x047A: {},
    /*::[*/ 0x047B: {
        T: 1
    },
    /*::[*/ 0x047C: {
        T: -1
    },
    /*::[*/ 0x047D: {
        T: 1
    },
    /*::[*/ 0x047E: {
        T: -1
    },
    /*::[*/ 0x0480: {
        T: 1
    },
    /*::[*/ 0x0481: {
        T: -1
    },
    /*::[*/ 0x0482: {
        T: -1
    },
    /*::[*/ 0x0483: {
        T: -1
    },
    /*::[*/ 0x0484: {
        T: -1
    },
    /*::[*/ 0x0485: {
        T: 1
    },
    /*::[*/ 0x0486: {
        T: -1
    },
    /*::[*/ 0x0487: {
        T: 1
    },
    /*::[*/ 0x0488: {
        T: -1
    },
    /*::[*/ 0x0489: {
        T: 1
    },
    /*::[*/ 0x048A: {
        T: -1
    },
    /*::[*/ 0x048B: {
        T: 1
    },
    /*::[*/ 0x048C: {
        T: -1
    },
    /*::[*/ 0x048D: {
        T: 1
    },
    /*::[*/ 0x048E: {
        T: -1
    },
    /*::[*/ 0x048F: {
        T: 1
    },
    /*::[*/ 0x0490: {
        T: -1
    },
    /*::[*/ 0x0491: {
        T: 1
    },
    /*::[*/ 0x0492: {
        T: -1
    },
    /*::[*/ 0x0493: {},
    /*::[*/ 0x0494: {
        T: 1
    },
    /*::[*/ 0x0495: {
        T: -1
    },
    /*::[*/ 0x0499: {},
    /*::[*/ 0x049A: {
        T: 1
    },
    /*::[*/ 0x049C: {},
    /*::[*/ 0x049D: {},
    /*::[*/ 0x049E: {},
    /*::[*/ 0x0800: {
        T: 1
    },
    /*::[*/ 0x0801: {
        T: -1
    },
    /*::[*/ 0x0802: {},
    /*::[*/ 0x0803: {
        T: 1
    },
    /*::[*/ 0x0804: {
        T: -1
    },
    /*::[*/ 0x0805: {},
    /*::[*/ 0x0806: {},
    /*::[*/ 0x0807: {
        T: 1
    },
    /*::[*/ 0x0808: {
        T: -1
    },
    /*::[*/ 0x0809: {
        T: 1
    },
    /*::[*/ 0x080A: {
        T: -1
    },
    /*::[*/ 0x080C: {},
    /*::[*/ 0x0813: {},
    /*::[*/ 0x0814: {
        T: 1
    },
    /*::[*/ 0x0815: {
        T: -1
    },
    /*::[*/ 0x0816: {},
    /*::[*/ 0x0817: {},
    /*::[*/ 0x0818: {
        T: 1
    },
    /*::[*/ 0x0819: {
        T: -1
    },
    /*::[*/ 0x081B: {},
    /*::[*/ 0x081C: {},
    /*::[*/ 0x081D: {
        T: 1
    },
    /*::[*/ 0x081E: {
        T: -1
    },
    /*::[*/ 0x081F: {},
    /*::[*/ 0x0820: {
        T: 1
    },
    /*::[*/ 0x0821: {
        T: -1
    },
    /*::[*/ 0x0822: {},
    /*::[*/ 0x0823: {
        T: 1
    },
    /*::[*/ 0x0824: {
        T: -1
    },
    /*::[*/ 0x0825: {
        T: 1
    },
    /*::[*/ 0x0826: {
        T: -1
    },
    /*::[*/ 0x0827: {
        T: 1
    },
    /*::[*/ 0x0828: {
        T: -1
    },
    /*::[*/ 0x0829: {
        T: 1
    },
    /*::[*/ 0x082A: {
        T: -1
    },
    /*::[*/ 0x082B: {},
    /*::[*/ 0x082C: {},
    /*::[*/ 0x082D: {
        T: 1
    },
    /*::[*/ 0x082E: {
        T: -1
    },
    /*::[*/ 0x082F: {},
    /*::[*/ 0x0830: {
        T: 1
    },
    /*::[*/ 0x0831: {
        T: -1
    },
    /*::[*/ 0x0832: {
        T: 1
    },
    /*::[*/ 0x0833: {
        T: -1
    },
    /*::[*/ 0x0834: {
        T: 1
    },
    /*::[*/ 0x0835: {
        T: -1
    },
    /*::[*/ 0x0836: {},
    /*::[*/ 0x0837: {
        T: 1
    },
    /*::[*/ 0x0838: {
        T: -1
    },
    /*::[*/ 0x0839: {},
    /*::[*/ 0x083A: {
        T: 1
    },
    /*::[*/ 0x083B: {
        T: -1
    },
    /*::[*/ 0x083C: {},
    /*::[*/ 0x083D: {
        T: 1
    },
    /*::[*/ 0x083E: {
        T: -1
    },
    /*::[*/ 0x083F: {
        T: 1
    },
    /*::[*/ 0x0840: {
        T: -1
    },
    /*::[*/ 0x0841: {
        T: 1
    },
    /*::[*/ 0x0842: {
        T: -1
    },
    /*::[*/ 0x0843: {},
    /*::[*/ 0x0844: {},
    /*::[*/ 0x0845: {},
    /*::[*/ 0x0846: {
        T: 1
    },
    /*::[*/ 0x0847: {
        T: -1
    },
    /*::[*/ 0x0848: {},
    /*::[*/ 0x0849: {
        T: 1
    },
    /*::[*/ 0x084A: {
        T: -1
    },
    /*::[*/ 0x084B: {
        T: 1
    },
    /*::[*/ 0x084C: {
        T: -1
    },
    /*::[*/ 0x084D: {},
    /*::[*/ 0x084E: {
        T: 1
    },
    /*::[*/ 0x084F: {
        T: -1
    },
    /*::[*/ 0x0850: {},
    /*::[*/ 0x0851: {
        T: 1
    },
    /*::[*/ 0x0852: {
        T: -1
    },
    /*::[*/ 0x0853: {
        T: 1
    },
    /*::[*/ 0x0854: {
        T: -1
    },
    /*::[*/ 0x0855: {
        T: 1
    },
    /*::[*/ 0x0856: {},
    /*::[*/ 0x0857: {},
    /*::[*/ 0x0858: {},
    /*::[*/ 0x0859: {
        T: 1
    },
    /*::[*/ 0x085A: {
        T: -1
    },
    /*::[*/ 0x085B: {
        T: 1
    },
    /*::[*/ 0x085C: {
        T: -1
    },
    /*::[*/ 0x085D: {},
    /*::[*/ 0x0C00: {},
    /*::[*/ 0x0C01: {},
    /*::[*/ 0x1000: {
        T: 1
    },
    /*::[*/ 0x1001: {
        T: -1
    },
    /*::[*/ 0x138A: {
        T: 1
    },
    /*::[*/ 0x138B: {
        T: -1
    },
    /*::[*/ 0x13D9: {
        T: 1
    },
    /*::[*/ 0x13DA: {
        T: -1
    },
    /*::[*/ 0x13DB: {},
    /*::[*/ 0x13DC: {
        T: 1
    },
    /*::[*/ 0x13DD: {
        T: -1
    },
    /*::[*/ 0x13DE: {
        T: 1
    },
    /*::[*/ 0x13DF: {
        T: -1
    },
    /*::[*/ 0x13E0: {},
    /*::[*/ 0x13E1: {},
    /*::[*/ 0x13E2: {},
    /*::[*/ 0x13E4: {
        T: 1
    },
    /*::[*/ 0x13E5: {
        T: -1
    },
    /*::[*/ 0x13E6: {},
    /*::[*/ 0x13E7: {
        T: 1
    },
    /*::[*/ 0x13E8: {
        T: -1
    },
    /*::[*/ 0x13E9: {},
    /*::[*/ 0x13EB: {},
    /*::[*/ 0xFFFF: {
        n: ""
    }
};
/* [MS-XLS] 2.3 Record Enumeration (and other sources) */ var XLSRecordEnum = {
    /* [MS-XLS] 2.3 Record Enumeration 2021-08-17 */ /*::[*/ 0x0006: {
        f: parse_Formula
    },
    /*::[*/ 0x000a: {
        f: parsenoop2
    },
    /*::[*/ 0x000c: {
        f: parseuint16
    },
    /*::[*/ 0x000d: {
        f: parseuint16
    },
    /*::[*/ 0x000e: {
        f: parsebool
    },
    /*::[*/ 0x000f: {
        f: parsebool
    },
    /*::[*/ 0x0010: {
        f: parse_Xnum
    },
    /*::[*/ 0x0011: {
        f: parsebool
    },
    /*::[*/ 0x0012: {
        f: parsebool
    },
    /*::[*/ 0x0013: {
        f: parseuint16
    },
    /*::[*/ 0x0014: {
        f: parse_XLHeaderFooter
    },
    /*::[*/ 0x0015: {
        f: parse_XLHeaderFooter
    },
    /*::[*/ 0x0017: {
        f: parse_ExternSheet
    },
    /*::[*/ 0x0018: {
        f: parse_Lbl
    },
    /*::[*/ 0x0019: {
        f: parsebool
    },
    /*::[*/ 0x001a: {},
    /*::[*/ 0x001b: {},
    /*::[*/ 0x001c: {
        f: parse_Note
    },
    /*::[*/ 0x001d: {},
    /*::[*/ 0x0022: {
        f: parsebool
    },
    /*::[*/ 0x0023: {
        f: parse_ExternName
    },
    /*::[*/ 0x0026: {
        f: parse_Xnum
    },
    /*::[*/ 0x0027: {
        f: parse_Xnum
    },
    /*::[*/ 0x0028: {
        f: parse_Xnum
    },
    /*::[*/ 0x0029: {
        f: parse_Xnum
    },
    /*::[*/ 0x002a: {
        f: parsebool
    },
    /*::[*/ 0x002b: {
        f: parsebool
    },
    /*::[*/ 0x002f: {
        f: parse_FilePass
    },
    /*::[*/ 0x0031: {
        f: parse_Font
    },
    /*::[*/ 0x0033: {
        f: parseuint16
    },
    /*::[*/ 0x003c: {},
    /*::[*/ 0x003d: {
        f: parse_Window1
    },
    /*::[*/ 0x0040: {
        f: parsebool
    },
    /*::[*/ 0x0041: {
        f: parse_Pane
    },
    /*::[*/ 0x0042: {
        f: parseuint16
    },
    /*::[*/ 0x004d: {},
    /*::[*/ 0x0050: {},
    /*::[*/ 0x0051: {},
    /*::[*/ 0x0052: {},
    /*::[*/ 0x0055: {
        f: parseuint16
    },
    /*::[*/ 0x0059: {},
    /*::[*/ 0x005a: {},
    /*::[*/ 0x005b: {},
    /*::[*/ 0x005c: {
        f: parse_WriteAccess
    },
    /*::[*/ 0x005d: {
        f: parse_Obj
    },
    /*::[*/ 0x005e: {},
    /*::[*/ 0x005f: {
        f: parsebool
    },
    /*::[*/ 0x0060: {},
    /*::[*/ 0x0061: {},
    /*::[*/ 0x0063: {
        f: parsebool
    },
    /*::[*/ 0x007d: {
        f: parse_ColInfo
    },
    /*::[*/ 0x0080: {
        f: parse_Guts
    },
    /*::[*/ 0x0081: {
        f: parse_WsBool
    },
    /*::[*/ 0x0082: {
        f: parseuint16
    },
    /*::[*/ 0x0083: {
        f: parsebool
    },
    /*::[*/ 0x0084: {
        f: parsebool
    },
    /*::[*/ 0x0085: {
        f: parse_BoundSheet8
    },
    /*::[*/ 0x0086: {},
    /*::[*/ 0x008c: {
        f: parse_Country
    },
    /*::[*/ 0x008d: {
        f: parseuint16
    },
    /*::[*/ 0x0090: {},
    /*::[*/ 0x0092: {
        f: parse_Palette
    },
    /*::[*/ 0x0097: {},
    /*::[*/ 0x0098: {},
    /*::[*/ 0x0099: {},
    /*::[*/ 0x009a: {},
    /*::[*/ 0x009b: {},
    /*::[*/ 0x009c: {
        f: parseuint16
    },
    /*::[*/ 0x009d: {},
    /*::[*/ 0x009e: {},
    /*::[*/ 0x00a0: {
        f: parse_Scl
    },
    /*::[*/ 0x00a1: {
        f: parse_Setup
    },
    /*::[*/ 0x00ae: {},
    /*::[*/ 0x00af: {},
    /*::[*/ 0x00b0: {},
    /*::[*/ 0x00b1: {},
    /*::[*/ 0x00b2: {},
    /*::[*/ 0x00b4: {},
    /*::[*/ 0x00b5: {},
    /*::[*/ 0x00b6: {},
    /*::[*/ 0x00b8: {},
    /*::[*/ 0x00b9: {},
    /*::[*/ 0x00bd: {
        f: parse_MulRk
    },
    /*::[*/ 0x00be: {
        f: parse_MulBlank
    },
    /*::[*/ 0x00c1: {
        f: parsenoop2
    },
    /*::[*/ 0x00c5: {},
    /*::[*/ 0x00c6: {},
    /*::[*/ 0x00c7: {},
    /*::[*/ 0x00c8: {},
    /*::[*/ 0x00c9: {},
    /*::[*/ 0x00ca: {
        f: parsebool
    },
    /*::[*/ 0x00cb: {},
    /*::[*/ 0x00cc: {},
    /*::[*/ 0x00cd: {},
    /*::[*/ 0x00ce: {},
    /*::[*/ 0x00cf: {},
    /*::[*/ 0x00d0: {},
    /*::[*/ 0x00d1: {},
    /*::[*/ 0x00d2: {},
    /*::[*/ 0x00d3: {},
    /*::[*/ 0x00d5: {},
    /*::[*/ 0x00d7: {},
    /*::[*/ 0x00d8: {},
    /*::[*/ 0x00d9: {},
    /*::[*/ 0x00da: {
        f: parseuint16
    },
    /*::[*/ 0x00dc: {},
    /*::[*/ 0x00dd: {
        f: parsebool
    },
    /*::[*/ 0x00de: {},
    /*::[*/ 0x00e0: {
        f: parse_XF
    },
    /*::[*/ 0x00e1: {
        f: parse_InterfaceHdr
    },
    /*::[*/ 0x00e2: {
        f: parsenoop2
    },
    /*::[*/ 0x00e3: {},
    /*::[*/ 0x00e5: {
        f: parse_MergeCells
    },
    /*::[*/ 0x00e9: {},
    /*::[*/ 0x00eb: {},
    /*::[*/ 0x00ec: {},
    /*::[*/ 0x00ed: {},
    /*::[*/ 0x00ef: {},
    /*::[*/ 0x00f0: {},
    /*::[*/ 0x00f1: {},
    /*::[*/ 0x00f2: {},
    /*::[*/ 0x00f4: {},
    /*::[*/ 0x00f5: {},
    /*::[*/ 0x00f6: {},
    /*::[*/ 0x00f7: {},
    /*::[*/ 0x00f8: {},
    /*::[*/ 0x00f9: {},
    /*::[*/ 0x00fb: {},
    /*::[*/ 0x00fc: {
        f: parse_SST
    },
    /*::[*/ 0x00fd: {
        f: parse_LabelSst
    },
    /*::[*/ 0x00ff: {
        f: parse_ExtSST
    },
    /*::[*/ 0x0100: {},
    /*::[*/ 0x0103: {},
    /*::[*/ 0x0122: {},
    /*::[*/ 0x0137: {},
    /*::[*/ 0x0138: {},
    /*::[*/ 0x013b: {},
    /*::[*/ 0x013d: {
        f: parseuint16a
    },
    /*::[*/ 0x013e: {},
    /*::[*/ 0x013f: {},
    /*::[*/ 0x0140: {},
    /*::[*/ 0x014a: {},
    /*::[*/ 0x014b: {},
    /*::[*/ 0x014d: {},
    /*::[*/ 0x014e: {},
    /*::[*/ 0x014f: {},
    /*::[*/ 0x0150: {},
    /*::[*/ 0x0151: {},
    /*::[*/ 0x0152: {},
    /*::[*/ 0x0153: {},
    /*::[*/ 0x0154: {},
    /*::[*/ 0x015f: {},
    /*::[*/ 0x0160: {
        f: parsebool
    },
    /*::[*/ 0x0161: {
        f: parsenoop2
    },
    /*::[*/ 0x0191: {},
    /*::[*/ 0x0192: {},
    /*::[*/ 0x0193: {},
    /*::[*/ 0x0194: {},
    /*::[*/ 0x0195: {},
    /*::[*/ 0x0196: {},
    /*::[*/ 0x0197: {},
    /*::[*/ 0x0198: {},
    /*::[*/ 0x01a9: {},
    /*::[*/ 0x01aa: {},
    /*::[*/ 0x01ab: {},
    /*::[*/ 0x01ac: {},
    /*::[*/ 0x01ad: {},
    /*::[*/ 0x01ae: {
        f: parse_SupBook
    },
    /*::[*/ 0x01af: {
        f: parsebool
    },
    /*::[*/ 0x01b0: {},
    /*::[*/ 0x01b1: {},
    /*::[*/ 0x01b2: {},
    /*::[*/ 0x01b5: {},
    /*::[*/ 0x01b6: {
        f: parse_TxO
    },
    /*::[*/ 0x01b7: {
        f: parsebool
    },
    /*::[*/ 0x01b8: {
        f: parse_HLink
    },
    /*::[*/ 0x01b9: {},
    /*::[*/ 0x01ba: {
        f: parse_XLUnicodeString
    },
    /*::[*/ 0x01bb: {},
    /*::[*/ 0x01bc: {
        f: parseuint16
    },
    /*::[*/ 0x01bd: {},
    /*::[*/ 0x01be: {},
    /*::[*/ 0x01c0: {
        f: parsenoop2
    },
    /*::[*/ 0x01c1: {
        f: parse_RecalcId,
        r: 2
    },
    /*::[*/ 0x01c2: {
        f: parsenoop2
    },
    /*::[*/ 0x0200: {
        f: parse_Dimensions
    },
    /*::[*/ 0x0201: {
        f: parse_Blank
    },
    /*::[*/ 0x0203: {
        f: parse_Number
    },
    /*::[*/ 0x0204: {
        f: parse_Label
    },
    /*::[*/ 0x0205: {
        f: parse_BoolErr
    },
    /*::[*/ 0x0207: {
        f: parse_String
    },
    /*::[*/ 0x0208: {
        f: parse_Row
    },
    /*::[*/ 0x020b: {},
    /*::[*/ 0x0221: {
        f: parse_Array
    },
    /*::[*/ 0x0225: {
        f: parse_DefaultRowHeight
    },
    /*::[*/ 0x0236: {},
    /*::[*/ 0x023e: {
        f: parse_Window2
    },
    /*::[*/ 0x027e: {
        f: parse_RK
    },
    /*::[*/ 0x0293: {},
    /*::[*/ 0x0418: {},
    /*::[*/ 0x041e: {
        f: parse_Format
    },
    /*::[*/ 0x043c: {},
    /*::[*/ 0x04bc: {
        f: parse_ShrFmla
    },
    /*::[*/ 0x0800: {
        f: parse_HLinkTooltip
    },
    /*::[*/ 0x0801: {},
    /*::[*/ 0x0802: {},
    /*::[*/ 0x0803: {},
    /*::[*/ 0x0804: {},
    /*::[*/ 0x0805: {},
    /*::[*/ 0x0806: {},
    /*::[*/ 0x0807: {},
    /*::[*/ 0x0808: {},
    /*::[*/ 0x0809: {
        f: parse_BOF
    },
    /*::[*/ 0x080a: {},
    /*::[*/ 0x080b: {},
    /*::[*/ 0x080c: {},
    /*::[*/ 0x080d: {},
    /*::[*/ 0x080e: {},
    /*::[*/ 0x080f: {},
    /*::[*/ 0x0810: {},
    /*::[*/ 0x0812: {},
    /*::[*/ 0x0813: {},
    /*::[*/ 0x0850: {},
    /*::[*/ 0x0851: {},
    /*::[*/ 0x0852: {},
    /*::[*/ 0x0853: {},
    /*::[*/ 0x0854: {},
    /*::[*/ 0x0855: {},
    /*::[*/ 0x0856: {},
    /*::[*/ 0x0857: {},
    /*::[*/ 0x0858: {},
    /*::[*/ 0x0859: {},
    /*::[*/ 0x085a: {},
    /*::[*/ 0x0862: {},
    /*::[*/ 0x0863: {
        r: 12
    },
    /*::[*/ 0x0864: {},
    /*::[*/ 0x0865: {},
    /*::[*/ 0x0866: {},
    /*::[*/ 0x0867: {
        f: parsenoop2
    },
    /*::[*/ 0x0868: {},
    /*::[*/ 0x086a: {},
    /*::[*/ 0x086b: {},
    /*::[*/ 0x086c: {},
    /*::[*/ 0x0871: {},
    /*::[*/ 0x0872: {},
    /*::[*/ 0x0874: {},
    /*::[*/ 0x0875: {},
    /*::[*/ 0x0876: {},
    /*::[*/ 0x0877: {},
    /*::[*/ 0x0878: {},
    /*::[*/ 0x0879: {},
    /*::[*/ 0x087a: {},
    /*::[*/ 0x087b: {},
    /*::[*/ 0x087c: {
        f: parse_XFCRC,
        r: 12
    },
    /*::[*/ 0x087d: {
        f: parse_XFExt,
        r: 12
    },
    /*::[*/ 0x087e: {},
    /*::[*/ 0x087f: {},
    /*::[*/ 0x0884: {},
    /*::[*/ 0x0885: {},
    /*::[*/ 0x0886: {},
    /*::[*/ 0x0887: {},
    /*::[*/ 0x0888: {},
    /*::[*/ 0x0889: {},
    /*::[*/ 0x088a: {},
    /*::[*/ 0x088b: {},
    /*::[*/ 0x088c: {
        f: parsebool,
        r: 12
    },
    /*::[*/ 0x088d: {},
    /*::[*/ 0x088e: {
        r: 12
    },
    /*::[*/ 0x088f: {},
    /*::[*/ 0x0890: {},
    /*::[*/ 0x0892: {},
    /*::[*/ 0x0893: {},
    /*::[*/ 0x0894: {
        f: parse_NameCmt,
        r: 12
    },
    /*::[*/ 0x0895: {},
    /*::[*/ 0x0896: {
        f: parse_Theme,
        r: 12
    },
    /*::[*/ 0x0897: {},
    /*::[*/ 0x0898: {},
    /*::[*/ 0x0899: {},
    /*::[*/ 0x089a: {
        f: parse_MTRSettings,
        r: 12
    },
    /*::[*/ 0x089b: {
        f: parsenoop2
    },
    /*::[*/ 0x089c: {},
    /*::[*/ 0x089d: {},
    /*::[*/ 0x089e: {},
    /*::[*/ 0x089f: {},
    /*::[*/ 0x08a3: {
        f: parse_ForceFullCalculation
    },
    /*::[*/ 0x08a4: {},
    /*::[*/ 0x08a5: {},
    /*::[*/ 0x08a6: {},
    /*::[*/ 0x08a7: {},
    /*::[*/ 0x1001: {},
    /*::[*/ 0x1002: {},
    /*::[*/ 0x1003: {},
    /*::[*/ 0x1006: {},
    /*::[*/ 0x1007: {},
    /*::[*/ 0x1009: {},
    /*::[*/ 0x100a: {},
    /*::[*/ 0x100b: {},
    /*::[*/ 0x100c: {},
    /*::[*/ 0x100d: {},
    /*::[*/ 0x1014: {},
    /*::[*/ 0x1015: {},
    /*::[*/ 0x1016: {},
    /*::[*/ 0x1017: {},
    /*::[*/ 0x1018: {},
    /*::[*/ 0x1019: {},
    /*::[*/ 0x101a: {},
    /*::[*/ 0x101b: {},
    /*::[*/ 0x101c: {},
    /*::[*/ 0x101d: {},
    /*::[*/ 0x101e: {},
    /*::[*/ 0x101f: {},
    /*::[*/ 0x1020: {},
    /*::[*/ 0x1021: {},
    /*::[*/ 0x1022: {},
    /*::[*/ 0x1024: {},
    /*::[*/ 0x1025: {},
    /*::[*/ 0x1026: {
        f: parseuint16
    },
    /*::[*/ 0x1027: {},
    /*::[*/ 0x1032: {},
    /*::[*/ 0x1033: {},
    /*::[*/ 0x1034: {},
    /*::[*/ 0x1035: {},
    /*::[*/ 0x103a: {},
    /*::[*/ 0x103c: {},
    /*::[*/ 0x103d: {},
    /*::[*/ 0x103e: {},
    /*::[*/ 0x103f: {},
    /*::[*/ 0x1040: {},
    /*::[*/ 0x1041: {},
    /*::[*/ 0x1043: {},
    /*::[*/ 0x1044: {
        f: parse_ShtProps
    },
    /*::[*/ 0x1045: {},
    /*::[*/ 0x1046: {},
    /*::[*/ 0x1048: {},
    /*::[*/ 0x104a: {},
    /*::[*/ 0x104b: {},
    /*::[*/ 0x104e: {},
    /*::[*/ 0x104f: {},
    /*::[*/ 0x1050: {},
    /*::[*/ 0x1051: {},
    /*::[*/ 0x105b: {},
    /*::[*/ 0x105c: {
        f: parse_ClrtClient
    },
    /*::[*/ 0x105d: {},
    /*::[*/ 0x105f: {},
    /*::[*/ 0x1060: {},
    /*::[*/ 0x1061: {},
    /*::[*/ 0x1062: {},
    /*::[*/ 0x1063: {},
    /*::[*/ 0x1064: {},
    /*::[*/ 0x1065: {},
    /*::[*/ 0x1066: {},
    /*::[*/ 0x1067: {},
    /*::[*/ 0x1068: {},
    /*::[*/ 0x0000: {
        f: parse_Dimensions
    },
    /*::[*/ 0x0001: {},
    /*::[*/ 0x0002: {
        f: parse_BIFF2INT
    },
    /*::[*/ 0x0003: {
        f: parse_BIFF2NUM
    },
    /*::[*/ 0x0004: {
        f: parse_BIFF2STR
    },
    /*::[*/ 0x0005: {
        f: parse_BoolErr
    },
    /*::[*/ 0x0007: {
        f: parse_BIFF2STRING
    },
    /*::[*/ 0x0008: {},
    /*::[*/ 0x0009: {
        f: parse_BOF
    },
    /*::[*/ 0x000b: {},
    /*::[*/ 0x0016: {
        f: parseuint16
    },
    /*::[*/ 0x001e: {
        f: parse_BIFF2Format
    },
    /*::[*/ 0x001f: {},
    /* 16-bit cnt of BIFF2FORMAT records */ /*::[*/ 0x0020: {},
    /*::[*/ 0x0021: {
        f: parse_Array
    },
    /*::[*/ 0x0024: {},
    /*::[*/ 0x0025: {
        f: parse_DefaultRowHeight
    },
    // 0x2c ??
    // 0x2d ??
    // 0x2e ??
    // 0x30 FONTCOUNT: number of fonts
    /*::[*/ 0x0032: {
        f: parse_BIFF2FONTXTRA
    },
    // 0x35: INFOOPTS
    // 0x36: TABLE (BIFF2 only)
    // 0x37: TABLE2 (BIFF2 only)
    // 0x38: WNDESK
    // 0x39 ??
    // 0x3a: BEGINPREF
    // 0x3b: ENDPREF
    /*::[*/ 0x003e: {},
    // 0x3f ??
    // 0x46: SHOWSCROLL
    // 0x47: SHOWFORMULA
    // 0x48: STATUSBAR
    // 0x49: SHORTMENUS
    // 0x4A:
    // 0x4B:
    // 0x4C:
    // 0x4E:
    // 0x4F:
    // 0x58: TOOLBAR (BIFF3)
    /* - - - */ /*::[*/ 0x0034: {},
    /*::[*/ 0x0043: {},
    /*::[*/ 0x0044: {
        f: parseuint16
    },
    /*::[*/ 0x0045: {},
    /*::[*/ 0x0056: {},
    /* 16-bit cnt, similar to BIFF2 */ /*::[*/ 0x007e: {},
    /* Not necessarily same as 0x027e */ /*::[*/ 0x007f: {
        f: parse_ImData
    },
    /*::[*/ 0x0087: {},
    /*::[*/ 0x0088: {},
    /*::[*/ 0x0089: {},
    // 0x8A
    // 0x8B LH: alternate menu key flag (BIFF3/4)
    // 0x8E
    // 0x8F
    /*::[*/ 0x0091: {},
    // 0x93 STYLE
    /*::[*/ 0x0094: {},
    /*::[*/ 0x0095: {},
    /*::[*/ 0x0096: {},
    // 0xA2 FNPROTO: function prototypes (BIFF4)
    // 0xA3
    // 0xA8
    /*::[*/ 0x00a9: {},
    /*::[*/ 0x00ab: {},
    /*::[*/ 0x00bc: {},
    /* Not necessarily same as 0x04bc */ /*::[*/ 0x00bf: {},
    /*::[*/ 0x00c0: {},
    /*::[*/ 0x00c2: {},
    /*::[*/ 0x00c3: {},
    /*::[*/ 0x00d6: {
        f: parse_RString
    },
    /*::[*/ 0x00df: {},
    /*::[*/ 0x00ea: {},
    /*::[*/ 0x0162: {},
    /*::[*/ 0x01a5: {},
    /*::[*/ 0x0206: {
        f: parse_Formula
    },
    /*::[*/ 0x0209: {
        f: parse_BOF
    },
    /*::[*/ 0x0218: {
        f: parse_Lbl
    },
    /*::[*/ 0x0223: {
        f: parse_ExternName
    },
    /*::[*/ 0x0231: {},
    /*::[*/ 0x0243: {},
    /*::[*/ 0x0406: {
        f: parse_Formula
    },
    /*::[*/ 0x0409: {
        f: parse_BOF
    },
    /*::[*/ 0x0443: {},
    /*::[*/ 0x086d: {},
    /*::[*/ 0x0873: {},
    /*::[*/ 0x0881: {},
    /*::[*/ 0x08c0: {},
    /*::[*/ 0x08c1: {},
    /*::[*/ 0x08c2: {},
    /*::[*/ 0x08c3: {},
    /*::[*/ 0x08c4: {},
    /*::[*/ 0x08c5: {},
    /*::[*/ 0x08c6: {},
    /*::[*/ 0x08c7: {},
    /*::[*/ 0x08c8: {},
    /*::[*/ 0x08c9: {},
    /*::[*/ 0x08ca: {},
    /*::[*/ 0x08cb: {},
    /*::[*/ 0x08d6: {
        r: 12
    },
    /*::[*/ 0x7262: {}
};
function write_biff_rec(ba /*:BufArray*/ , type /*:number*/ , payload, length /*:?number*/ ) /*:void*/ {
    var t /*:number*/  = type;
    if (isNaN(t)) return;
    var len = length || (payload || []).length || 0;
    var o = ba.next(4);
    o.write_shift(2, t);
    o.write_shift(2, len);
    if (/*:: len != null &&*/ len > 0 && is_buf(payload)) ba.push(payload);
}
function write_biff_continue(ba /*:BufArray*/ , type /*:number*/ , payload, length /*:?number*/ ) /*:void*/ {
    var len = length || (payload || []).length || 0;
    if (len <= 8224) return write_biff_rec(ba, type, payload, len);
    var t = type;
    if (isNaN(t)) return;
    var parts = payload.parts || [], sidx = 0;
    var i = 0, w = 0;
    while(w + (parts[sidx] || 8224) <= 8224){
        w += parts[sidx] || 8224;
        sidx++;
    }
    var o = ba.next(4);
    o.write_shift(2, t);
    o.write_shift(2, w);
    ba.push(payload.slice(i, i + w));
    i += w;
    while(i < len){
        o = ba.next(4);
        o.write_shift(2, 0x3c); // TODO: figure out correct continue type
        w = 0;
        while(w + (parts[sidx] || 8224) <= 8224){
            w += parts[sidx] || 8224;
            sidx++;
        }
        o.write_shift(2, w);
        ba.push(payload.slice(i, i + w));
        i += w;
    }
}
function write_BIFF2Cell(out, r /*:number*/ , c /*:number*/ ) {
    if (!out) out = new_buf(7);
    out.write_shift(2, r);
    out.write_shift(2, c);
    out.write_shift(2, 0);
    out.write_shift(1, 0);
    return out;
}
function write_BIFF2BERR(r /*:number*/ , c /*:number*/ , val, t /*:?string*/ ) {
    var out = new_buf(9);
    write_BIFF2Cell(out, r, c);
    write_Bes(val, t || "b", out);
    return out;
}
/* TODO: codepage, large strings */ function write_BIFF2LABEL(r /*:number*/ , c /*:number*/ , val) {
    var out = new_buf(8 + 2 * val.length);
    write_BIFF2Cell(out, r, c);
    out.write_shift(1, val.length);
    out.write_shift(val.length, val, "sbcs");
    return out.l < out.length ? out.slice(0, out.l) : out;
}
function write_ws_biff2_cell(ba /*:BufArray*/ , cell /*:Cell*/ , R /*:number*/ , C /*:number*/  /*::, opts*/ ) {
    if (cell.v != null) switch(cell.t){
        case "d":
        case "n":
            var v = cell.t == "d" ? datenum(parseDate(cell.v)) : cell.v;
            if (v == (v | 0) && v >= 0 && v < 65536) write_biff_rec(ba, 0x0002, write_BIFF2INT(R, C, v));
            else write_biff_rec(ba, 0x0003, write_BIFF2NUM(R, C, v));
            return;
        case "b":
        case "e":
            write_biff_rec(ba, 0x0005, write_BIFF2BERR(R, C, cell.v, cell.t));
            return;
        /* TODO: codepage, sst */ case "s":
        case "str":
            write_biff_rec(ba, 0x0004, write_BIFF2LABEL(R, C, (cell.v || "").slice(0, 255)));
            return;
    }
    write_biff_rec(ba, 0x0001, write_BIFF2Cell(null, R, C));
}
function write_ws_biff2(ba /*:BufArray*/ , ws /*:Worksheet*/ , idx /*:number*/ , opts /*::, wb:Workbook*/ ) {
    var dense = Array.isArray(ws);
    var range = safe_decode_range(ws["!ref"] || "A1"), ref /*:string*/ , rr = "", cols /*:Array<string>*/  = [];
    if (range.e.c > 0xFF || range.e.r > 0x3FFF) {
        if (opts.WTF) throw new Error("Range " + (ws["!ref"] || "A1") + " exceeds format limit A1:IV16384");
        range.e.c = Math.min(range.e.c, 0xFF);
        range.e.r = Math.min(range.e.c, 0x3FFF);
        ref = encode_range(range);
    }
    for(var R = range.s.r; R <= range.e.r; ++R){
        rr = encode_row(R);
        for(var C = range.s.c; C <= range.e.c; ++C){
            if (R === range.s.r) cols[C] = encode_col(C);
            ref = cols[C] + rr;
            var cell = dense ? (ws[R] || [])[C] : ws[ref];
            if (!cell) continue;
            /* write cell */ write_ws_biff2_cell(ba, cell, R, C, opts);
        }
    }
}
/* Based on test files */ function write_biff2_buf(wb /*:Workbook*/ , opts /*:WriteOpts*/ ) {
    var o = opts || {};
    if (DENSE != null && o.dense == null) o.dense = DENSE;
    var ba = buf_array();
    var idx = 0;
    for(var i = 0; i < wb.SheetNames.length; ++i)if (wb.SheetNames[i] == o.sheet) idx = i;
    if (idx == 0 && !!o.sheet && wb.SheetNames[0] != o.sheet) throw new Error("Sheet not found: " + o.sheet);
    write_biff_rec(ba, o.biff == 4 ? 0x0409 : o.biff == 3 ? 0x0209 : 0x0009, write_BOF(wb, 0x10, o));
    /* ... */ write_ws_biff2(ba, wb.Sheets[wb.SheetNames[idx]], idx, o, wb);
    /* ... */ write_biff_rec(ba, 0x000A);
    return ba.end();
}
function write_FONTS_biff8(ba, data, opts) {
    write_biff_rec(ba, 0x0031 /* Font */ , write_Font({
        sz: 12,
        color: {
            theme: 1
        },
        name: "Arial",
        family: 2,
        scheme: "minor"
    }, opts));
}
function write_FMTS_biff8(ba, NF /*:?SSFTable*/ , opts) {
    if (!NF) return;
    [
        [
            5,
            8
        ],
        [
            23,
            26
        ],
        [
            41,
            44
        ],
        [
            /*63*/ 50,
            /*66],[164,*/ 392
        ]
    ].forEach(function(r) {
        /*:: if(!NF) return; */ for(var i = r[0]; i <= r[1]; ++i)if (NF[i] != null) write_biff_rec(ba, 0x041E /* Format */ , write_Format(i, NF[i], opts));
    });
}
function write_FEAT(ba, ws) {
    /* [MS-XLS] 2.4.112 */ var o = new_buf(19);
    o.write_shift(4, 0x867);
    o.write_shift(4, 0);
    o.write_shift(4, 0);
    o.write_shift(2, 3);
    o.write_shift(1, 1);
    o.write_shift(4, 0);
    write_biff_rec(ba, 0x0867 /* FeatHdr */ , o);
    /* [MS-XLS] 2.4.111 */ o = new_buf(39);
    o.write_shift(4, 0x868);
    o.write_shift(4, 0);
    o.write_shift(4, 0);
    o.write_shift(2, 3);
    o.write_shift(1, 0);
    o.write_shift(4, 0);
    o.write_shift(2, 1);
    o.write_shift(4, 4);
    o.write_shift(2, 0);
    write_Ref8U(safe_decode_range(ws["!ref"] || "A1"), o);
    o.write_shift(4, 4);
    write_biff_rec(ba, 0x0868 /* Feat */ , o);
}
function write_CELLXFS_biff8(ba, opts) {
    for(var i = 0; i < 16; ++i)write_biff_rec(ba, 0x00e0 /* XF */ , write_XF({
        numFmtId: 0,
        style: true
    }, 0, opts));
    opts.cellXfs.forEach(function(c) {
        write_biff_rec(ba, 0x00e0 /* XF */ , write_XF(c, 0, opts));
    });
}
function write_ws_biff8_hlinks(ba /*:BufArray*/ , ws) {
    for(var R = 0; R < ws["!links"].length; ++R){
        var HL = ws["!links"][R];
        write_biff_rec(ba, 0x01b8 /* HLink */ , write_HLink(HL));
        if (HL[1].Tooltip) write_biff_rec(ba, 0x0800 /* HLinkTooltip */ , write_HLinkTooltip(HL));
    }
    delete ws["!links"];
}
function write_ws_cols_biff8(ba, cols) {
    if (!cols) return;
    var cnt = 0;
    cols.forEach(function(col, idx) {
        if (++cnt <= 256 && col) write_biff_rec(ba, 0x007d /* ColInfo */ , write_ColInfo(col_obj_w(idx, col), idx));
    });
}
function write_ws_biff8_cell(ba /*:BufArray*/ , cell /*:Cell*/ , R /*:number*/ , C /*:number*/ , opts) {
    var os = 16 + get_cell_style(opts.cellXfs, cell, opts);
    if (cell.v == null && !cell.bf) {
        write_biff_rec(ba, 0x0201 /* Blank */ , write_XLSCell(R, C, os));
        return;
    }
    if (cell.bf) write_biff_rec(ba, 0x0006 /* Formula */ , write_Formula(cell, R, C, opts, os));
    else switch(cell.t){
        case "d":
        case "n":
            var v = cell.t == "d" ? datenum(parseDate(cell.v)) : cell.v;
            /* TODO: emit RK as appropriate */ write_biff_rec(ba, 0x0203 /* Number */ , write_Number(R, C, v, os, opts));
            break;
        case "b":
        case "e":
            write_biff_rec(ba, 0x0205 /* BoolErr */ , write_BoolErr(R, C, cell.v, os, opts, cell.t));
            break;
        /* TODO: codepage, sst */ case "s":
        case "str":
            if (opts.bookSST) {
                var isst = get_sst_id(opts.Strings, cell.v, opts.revStrings);
                write_biff_rec(ba, 0x00fd /* LabelSst */ , write_LabelSst(R, C, isst, os, opts));
            } else write_biff_rec(ba, 0x0204 /* Label */ , write_Label(R, C, (cell.v || "").slice(0, 255), os, opts));
            break;
        default:
            write_biff_rec(ba, 0x0201 /* Blank */ , write_XLSCell(R, C, os));
    }
}
/* [MS-XLS] 2.1.7.20.5 */ function write_ws_biff8(idx /*:number*/ , opts, wb /*:Workbook*/ ) {
    var ba = buf_array();
    var s = wb.SheetNames[idx], ws = wb.Sheets[s] || {};
    var _WB /*:WBWBProps*/  = (wb || {}).Workbook || {} /*:any*/ ;
    var _sheet /*:WBWSProp*/  = (_WB.Sheets || [])[idx] || {} /*:any*/ ;
    var dense = Array.isArray(ws);
    var b8 = opts.biff == 8;
    var ref /*:string*/ , rr = "", cols /*:Array<string>*/  = [];
    var range = safe_decode_range(ws["!ref"] || "A1");
    var MAX_ROWS = b8 ? 65536 : 16384;
    if (range.e.c > 0xFF || range.e.r >= MAX_ROWS) {
        if (opts.WTF) throw new Error("Range " + (ws["!ref"] || "A1") + " exceeds format limit A1:IV16384");
        range.e.c = Math.min(range.e.c, 0xFF);
        range.e.r = Math.min(range.e.c, MAX_ROWS - 1);
    }
    write_biff_rec(ba, 0x0809, write_BOF(wb, 0x10, opts));
    /* [Uncalced] Index */ write_biff_rec(ba, 0x000d /* CalcMode */ , writeuint16(1));
    write_biff_rec(ba, 0x000c /* CalcCount */ , writeuint16(100));
    write_biff_rec(ba, 0x000f /* CalcRefMode */ , writebool(true));
    write_biff_rec(ba, 0x0011 /* CalcIter */ , writebool(false));
    write_biff_rec(ba, 0x0010 /* CalcDelta */ , write_Xnum(0.001));
    write_biff_rec(ba, 0x005f /* CalcSaveRecalc */ , writebool(true));
    write_biff_rec(ba, 0x002a /* PrintRowCol */ , writebool(false));
    write_biff_rec(ba, 0x002b /* PrintGrid */ , writebool(false));
    write_biff_rec(ba, 0x0082 /* GridSet */ , writeuint16(1));
    write_biff_rec(ba, 0x0080 /* Guts */ , write_Guts([
        0,
        0
    ]));
    /* DefaultRowHeight WsBool [Sync] [LPr] [HorizontalPageBreaks] [VerticalPageBreaks] */ /* Header (string) */ /* Footer (string) */ write_biff_rec(ba, 0x0083 /* HCenter */ , writebool(false));
    write_biff_rec(ba, 0x0084 /* VCenter */ , writebool(false));
    /* ... */ if (b8) write_ws_cols_biff8(ba, ws["!cols"]);
    /* ... */ write_biff_rec(ba, 0x200, write_Dimensions(range, opts));
    /* ... */ if (b8) ws["!links"] = [];
    for(var R = range.s.r; R <= range.e.r; ++R){
        rr = encode_row(R);
        for(var C = range.s.c; C <= range.e.c; ++C){
            if (R === range.s.r) cols[C] = encode_col(C);
            ref = cols[C] + rr;
            var cell = dense ? (ws[R] || [])[C] : ws[ref];
            if (!cell) continue;
            /* write cell */ write_ws_biff8_cell(ba, cell, R, C, opts);
            if (b8 && cell.l) ws["!links"].push([
                ref,
                cell.l
            ]);
        }
    }
    var cname /*:string*/  = _sheet.CodeName || _sheet.name || s;
    /* ... */ if (b8) write_biff_rec(ba, 0x023e /* Window2 */ , write_Window2((_WB.Views || [])[0]));
    /* ... */ if (b8 && (ws["!merges"] || []).length) write_biff_rec(ba, 0x00e5 /* MergeCells */ , write_MergeCells(ws["!merges"]));
    /* [LRng] *QUERYTABLE [PHONETICINFO] CONDFMTS */ if (b8) write_ws_biff8_hlinks(ba, ws);
    /* [DVAL] */ write_biff_rec(ba, 0x01ba /* CodeName */ , write_XLUnicodeString(cname, opts));
    /* *WebPub *CellWatch [SheetExt] */ if (b8) write_FEAT(ba, ws);
    /* *FEAT11 *RECORD12 */ write_biff_rec(ba, 0x000a /* EOF */ );
    return ba.end();
}
/* [MS-XLS] 2.1.7.20.3 */ function write_biff8_global(wb /*:Workbook*/ , bufs, opts /*:WriteOpts*/ ) {
    var A = buf_array();
    var _WB /*:WBWBProps*/  = (wb || {}).Workbook || {} /*:any*/ ;
    var _sheets /*:Array<WBWSProp>*/  = _WB.Sheets || [];
    var _wb /*:WBProps*/  = /*::((*/ _WB.WBProps || {} /*:: ):any)*/ ;
    var b8 = opts.biff == 8, b5 = opts.biff == 5;
    write_biff_rec(A, 0x0809, write_BOF(wb, 0x05, opts));
    if (opts.bookType == "xla") write_biff_rec(A, 0x0087 /* Addin */ );
    write_biff_rec(A, 0x00e1 /* InterfaceHdr */ , b8 ? writeuint16(0x04b0) : null);
    write_biff_rec(A, 0x00c1 /* Mms */ , writezeroes(2));
    if (b5) write_biff_rec(A, 0x00bf /* ToolbarHdr */ );
    if (b5) write_biff_rec(A, 0x00c0 /* ToolbarEnd */ );
    write_biff_rec(A, 0x00e2 /* InterfaceEnd */ );
    write_biff_rec(A, 0x005c /* WriteAccess */ , write_WriteAccess("SheetJS", opts));
    /* [FileSharing] */ write_biff_rec(A, 0x0042 /* CodePage */ , writeuint16(b8 ? 0x04b0 : 0x04E4));
    /* *2047 Lel */ if (b8) write_biff_rec(A, 0x0161 /* DSF */ , writeuint16(0));
    if (b8) write_biff_rec(A, 0x01c0 /* Excel9File */ );
    write_biff_rec(A, 0x013d /* RRTabId */ , write_RRTabId(wb.SheetNames.length));
    if (b8 && wb.vbaraw) write_biff_rec(A, 0x00d3 /* ObProj */ );
    /* [ObNoMacros] */ if (b8 && wb.vbaraw) {
        var cname /*:string*/  = _wb.CodeName || "ThisWorkbook";
        write_biff_rec(A, 0x01ba /* CodeName */ , write_XLUnicodeString(cname, opts));
    }
    write_biff_rec(A, 0x009c /* BuiltInFnGroupCount */ , writeuint16(0x11));
    /* *FnGroupName *FnGrp12 */ /* *Lbl */ /* [OleObjectSize] */ write_biff_rec(A, 0x0019 /* WinProtect */ , writebool(false));
    write_biff_rec(A, 0x0012 /* Protect */ , writebool(false));
    write_biff_rec(A, 0x0013 /* Password */ , writeuint16(0));
    if (b8) write_biff_rec(A, 0x01af /* Prot4Rev */ , writebool(false));
    if (b8) write_biff_rec(A, 0x01bc /* Prot4RevPass */ , writeuint16(0));
    write_biff_rec(A, 0x003d /* Window1 */ , write_Window1(opts));
    write_biff_rec(A, 0x0040 /* Backup */ , writebool(false));
    write_biff_rec(A, 0x008d /* HideObj */ , writeuint16(0));
    write_biff_rec(A, 0x0022 /* Date1904 */ , writebool(safe1904(wb) == "true"));
    write_biff_rec(A, 0x000e /* CalcPrecision */ , writebool(true));
    if (b8) write_biff_rec(A, 0x01b7 /* RefreshAll */ , writebool(false));
    write_biff_rec(A, 0x00DA /* BookBool */ , writeuint16(0));
    /* ... */ write_FONTS_biff8(A, wb, opts);
    write_FMTS_biff8(A, wb.SSF, opts);
    write_CELLXFS_biff8(A, opts);
    /* ... */ if (b8) write_biff_rec(A, 0x0160 /* UsesELFs */ , writebool(false));
    var a = A.end();
    var C = buf_array();
    /* METADATA [MTRSettings] [ForceFullCalculation] */ if (b8) write_biff_rec(C, 0x008C, write_Country());
    /* *SUPBOOK *LBL *RTD [RecalcId] *HFPicture *MSODRAWINGGROUP */ /* BIFF8: [SST *Continue] ExtSST */ if (b8 && opts.Strings) write_biff_continue(C, 0x00FC, write_SST(opts.Strings, opts));
    /* *WebPub [WOpt] [CrErr] [BookExt] *FeatHdr *DConn [THEME] [CompressPictures] [Compat12] [GUIDTypeLib] */ write_biff_rec(C, 0x000A /* EOF */ );
    var c = C.end();
    var B = buf_array();
    var blen = 0, j = 0;
    for(j = 0; j < wb.SheetNames.length; ++j)blen += (b8 ? 12 : 11) + (b8 ? 2 : 1) * wb.SheetNames[j].length;
    var start = a.length + blen + c.length;
    for(j = 0; j < wb.SheetNames.length; ++j){
        var _sheet /*:WBWSProp*/  = _sheets[j] || {} /*:any*/ ;
        write_biff_rec(B, 0x0085 /* BoundSheet8 */ , write_BoundSheet8({
            pos: start,
            hs: _sheet.Hidden || 0,
            dt: 0,
            name: wb.SheetNames[j]
        }, opts));
        start += bufs[j].length;
    }
    /* 1*BoundSheet8 */ var b = B.end();
    if (blen != b.length) throw new Error("BS8 " + blen + " != " + b.length);
    var out = [];
    if (a.length) out.push(a);
    if (b.length) out.push(b);
    if (c.length) out.push(c);
    return bconcat(out);
}
/* [MS-XLS] 2.1.7.20 Workbook Stream */ function write_biff8_buf(wb /*:Workbook*/ , opts /*:WriteOpts*/ ) {
    var o = opts || {};
    var bufs = [];
    if (wb && !wb.SSF) wb.SSF = dup(table_fmt);
    if (wb && wb.SSF) {
        make_ssf();
        SSF_load_table(wb.SSF);
        // $FlowIgnore
        o.revssf = evert_num(wb.SSF);
        o.revssf[wb.SSF[65535]] = 0;
        o.ssf = wb.SSF;
    }
    o.Strings = /*::((*/ [] /*:: :any):SST)*/ ;
    o.Strings.Count = 0;
    o.Strings.Unique = 0;
    fix_write_opts(o);
    o.cellXfs = [];
    get_cell_style(o.cellXfs, {}, {
        revssf: {
            "General": 0
        }
    });
    if (!wb.Props) wb.Props = {};
    for(var i = 0; i < wb.SheetNames.length; ++i)bufs[bufs.length] = write_ws_biff8(i, o, wb);
    bufs.unshift(write_biff8_global(wb, bufs, o));
    return bconcat(bufs);
}
function write_biff_buf(wb /*:Workbook*/ , opts /*:WriteOpts*/ ) {
    for(var i = 0; i <= wb.SheetNames.length; ++i){
        var ws = wb.Sheets[wb.SheetNames[i]];
        if (!ws || !ws["!ref"]) continue;
        var range = decode_range(ws["!ref"]);
        if (range.e.c > 255) {
            if (typeof console != "undefined" && console.error) console.error("Worksheet '" + wb.SheetNames[i] + "' extends beyond column IV (255).  Data may be lost.");
        }
    }
    var o = opts || {};
    switch(o.biff || 2){
        case 8:
        case 5:
            return write_biff8_buf(wb, opts);
        case 4:
        case 3:
        case 2:
            return write_biff2_buf(wb, opts);
    }
    throw new Error("invalid type " + o.bookType + " for BIFF");
}
/* note: browser DOM element cannot see mso- style attrs, must parse */ function html_to_sheet(str /*:string*/ , _opts) /*:Workbook*/ {
    var opts = _opts || {};
    if (DENSE != null && opts.dense == null) opts.dense = DENSE;
    var ws /*:Worksheet*/  = opts.dense ? [] : {} /*:any*/ ;
    str = str.replace(/<!--.*?-->/g, "");
    var mtch /*:any*/  = str.match(/<table/i);
    if (!mtch) throw new Error("Invalid HTML: could not find <table>");
    var mtch2 /*:any*/  = str.match(/<\/table/i);
    var i /*:number*/  = mtch.index, j /*:number*/  = mtch2 && mtch2.index || str.length;
    var rows = split_regex(str.slice(i, j), /(:?<tr[^>]*>)/i, "<tr>");
    var R = -1, C = 0, RS = 0, CS = 0;
    var range /*:Range*/  = {
        s: {
            r: 10000000,
            c: 10000000
        },
        e: {
            r: 0,
            c: 0
        }
    };
    var merges /*:Array<Range>*/  = [];
    for(i = 0; i < rows.length; ++i){
        var row = rows[i].trim();
        var hd = row.slice(0, 3).toLowerCase();
        if (hd == "<tr") {
            ++R;
            if (opts.sheetRows && opts.sheetRows <= R) {
                --R;
                break;
            }
            C = 0;
            continue;
        }
        if (hd != "<td" && hd != "<th") continue;
        var cells = row.split(/<\/t[dh]>/i);
        for(j = 0; j < cells.length; ++j){
            var cell = cells[j].trim();
            if (!cell.match(/<t[dh]/i)) continue;
            var m = cell, cc = 0;
            /* TODO: parse styles etc */ while(m.charAt(0) == "<" && (cc = m.indexOf(">")) > -1)m = m.slice(cc + 1);
            for(var midx = 0; midx < merges.length; ++midx){
                var _merge /*:Range*/  = merges[midx];
                if (_merge.s.c == C && _merge.s.r < R && R <= _merge.e.r) {
                    C = _merge.e.c + 1;
                    midx = -1;
                }
            }
            var tag = parsexmltag(cell.slice(0, cell.indexOf(">")));
            CS = tag.colspan ? +tag.colspan : 1;
            if ((RS = +tag.rowspan) > 1 || CS > 1) merges.push({
                s: {
                    r: R,
                    c: C
                },
                e: {
                    r: R + (RS || 1) - 1,
                    c: C + CS - 1
                }
            });
            var _t /*:string*/  = tag.t || tag["data-t"] || "";
            /* TODO: generate stub cells */ if (!m.length) {
                C += CS;
                continue;
            }
            m = htmldecode(m);
            if (range.s.r > R) range.s.r = R;
            if (range.e.r < R) range.e.r = R;
            if (range.s.c > C) range.s.c = C;
            if (range.e.c < C) range.e.c = C;
            if (!m.length) {
                C += CS;
                continue;
            }
            var o /*:Cell*/  = {
                t: "s",
                v: m
            };
            if (opts.raw || !m.trim().length || _t == "s") ;
            else if (m === "TRUE") o = {
                t: "b",
                v: true
            };
            else if (m === "FALSE") o = {
                t: "b",
                v: false
            };
            else if (!isNaN(fuzzynum(m))) o = {
                t: "n",
                v: fuzzynum(m)
            };
            else if (!isNaN(fuzzydate(m).getDate())) {
                o = {
                    t: "d",
                    v: parseDate(m)
                } /*:any*/ ;
                if (!opts.cellDates) o = {
                    t: "n",
                    v: datenum(o.v)
                } /*:any*/ ;
                o.z = opts.dateNF || table_fmt[14];
            }
            if (opts.dense) {
                if (!ws[R]) ws[R] = [];
                ws[R][C] = o;
            } else ws[encode_cell({
                r: R,
                c: C
            })] = o;
            C += CS;
        }
    }
    ws["!ref"] = encode_range(range);
    if (merges.length) ws["!merges"] = merges;
    return ws;
}
function make_html_row(ws /*:Worksheet*/ , r /*:Range*/ , R /*:number*/ , o /*:Sheet2HTMLOpts*/ ) /*:string*/ {
    var M /*:Array<Range>*/  = ws["!merges"] || [];
    var oo /*:Array<string>*/  = [];
    for(var C = r.s.c; C <= r.e.c; ++C){
        var RS = 0, CS = 0;
        for(var j = 0; j < M.length; ++j){
            if (M[j].s.r > R || M[j].s.c > C) continue;
            if (M[j].e.r < R || M[j].e.c < C) continue;
            if (M[j].s.r < R || M[j].s.c < C) {
                RS = -1;
                break;
            }
            RS = M[j].e.r - M[j].s.r + 1;
            CS = M[j].e.c - M[j].s.c + 1;
            break;
        }
        if (RS < 0) continue;
        var coord = encode_cell({
            r: R,
            c: C
        });
        var cell = o.dense ? (ws[R] || [])[C] : ws[coord];
        /* TODO: html entities */ var w = cell && cell.v != null && (cell.h || escapehtml(cell.w || (format_cell(cell), cell.w) || "")) || "";
        var sp = {} /*:any*/ ;
        if (RS > 1) sp.rowspan = RS;
        if (CS > 1) sp.colspan = CS;
        if (o.editable) w = '<span contenteditable="true">' + w + "</span>";
        else if (cell) {
            sp["data-t"] = cell && cell.t || "z";
            if (cell.v != null) sp["data-v"] = cell.v;
            if (cell.z != null) sp["data-z"] = cell.z;
            if (cell.l && (cell.l.Target || "#").charAt(0) != "#") w = '<a href="' + cell.l.Target + '">' + w + "</a>";
        }
        sp.id = (o.id || "sjs") + "-" + coord;
        oo.push(writextag("td", w, sp));
    }
    var preamble = "<tr>";
    return preamble + oo.join("") + "</tr>";
}
var HTML_BEGIN = '<html><head><meta charset="utf-8"/><title>SheetJS Table Export</title></head><body>';
var HTML_END = "</body></html>";
function html_to_workbook(str /*:string*/ , opts) /*:Workbook*/ {
    var mtch = str.match(/<table[\s\S]*?>[\s\S]*?<\/table>/gi);
    if (!mtch || mtch.length == 0) throw new Error("Invalid HTML: could not find <table>");
    if (mtch.length == 1) return sheet_to_workbook(html_to_sheet(mtch[0], opts), opts);
    var wb = book_new();
    mtch.forEach(function(s, idx) {
        book_append_sheet(wb, html_to_sheet(s, opts), "Sheet" + (idx + 1));
    });
    return wb;
}
function make_html_preamble(ws /*:Worksheet*/ , R /*:Range*/ , o /*:Sheet2HTMLOpts*/ ) /*:string*/ {
    var out /*:Array<string>*/  = [];
    return out.join("") + "<table" + (o && o.id ? ' id="' + o.id + '"' : "") + ">";
}
function sheet_to_html(ws /*:Worksheet*/ , opts /*:?Sheet2HTMLOpts*/  /*, wb:?Workbook*/ ) /*:string*/ {
    var o = opts || {};
    var header = o.header != null ? o.header : HTML_BEGIN;
    var footer = o.footer != null ? o.footer : HTML_END;
    var out /*:Array<string>*/  = [
        header
    ];
    var r = decode_range(ws["!ref"]);
    o.dense = Array.isArray(ws);
    out.push(make_html_preamble(ws, r, o));
    for(var R = r.s.r; R <= r.e.r; ++R)out.push(make_html_row(ws, r, R, o));
    out.push("</table>" + footer);
    return out.join("");
}
function sheet_add_dom(ws /*:Worksheet*/ , table /*:HTMLElement*/ , _opts /*:?any*/ ) /*:Worksheet*/ {
    var opts = _opts || {};
    if (DENSE != null) opts.dense = DENSE;
    var or_R = 0, or_C = 0;
    if (opts.origin != null) {
        if (typeof opts.origin == "number") or_R = opts.origin;
        else {
            var _origin /*:CellAddress*/  = typeof opts.origin == "string" ? decode_cell(opts.origin) : opts.origin;
            or_R = _origin.r;
            or_C = _origin.c;
        }
    }
    var rows /*:HTMLCollection<HTMLTableRowElement>*/  = table.getElementsByTagName("tr");
    var sheetRows = Math.min(opts.sheetRows || 10000000, rows.length);
    var range /*:Range*/  = {
        s: {
            r: 0,
            c: 0
        },
        e: {
            r: or_R,
            c: or_C
        }
    };
    if (ws["!ref"]) {
        var _range /*:Range*/  = decode_range(ws["!ref"]);
        range.s.r = Math.min(range.s.r, _range.s.r);
        range.s.c = Math.min(range.s.c, _range.s.c);
        range.e.r = Math.max(range.e.r, _range.e.r);
        range.e.c = Math.max(range.e.c, _range.e.c);
        if (or_R == -1) range.e.r = or_R = _range.e.r + 1;
    }
    var merges /*:Array<Range>*/  = [], midx = 0;
    var rowinfo /*:Array<RowInfo>*/  = ws["!rows"] || (ws["!rows"] = []);
    var _R = 0, R = 0, _C = 0, C = 0, RS = 0, CS = 0;
    if (!ws["!cols"]) ws["!cols"] = [];
    for(; _R < rows.length && R < sheetRows; ++_R){
        var row /*:HTMLTableRowElement*/  = rows[_R];
        if (is_dom_element_hidden(row)) {
            if (opts.display) continue;
            rowinfo[R] = {
                hidden: true
            };
        }
        var elts /*:HTMLCollection<HTMLTableCellElement>*/  = row.children /*:any*/ ;
        for(_C = C = 0; _C < elts.length; ++_C){
            var elt /*:HTMLTableCellElement*/  = elts[_C];
            if (opts.display && is_dom_element_hidden(elt)) continue;
            var v /*:?string*/  = elt.hasAttribute("data-v") ? elt.getAttribute("data-v") : elt.hasAttribute("v") ? elt.getAttribute("v") : htmldecode(elt.innerHTML);
            var z /*:?string*/  = elt.getAttribute("data-z") || elt.getAttribute("z");
            for(midx = 0; midx < merges.length; ++midx){
                var m /*:Range*/  = merges[midx];
                if (m.s.c == C + or_C && m.s.r < R + or_R && R + or_R <= m.e.r) {
                    C = m.e.c + 1 - or_C;
                    midx = -1;
                }
            }
            /* TODO: figure out how to extract nonstandard mso- style */ CS = +elt.getAttribute("colspan") || 1;
            if ((RS = +elt.getAttribute("rowspan") || 1) > 1 || CS > 1) merges.push({
                s: {
                    r: R + or_R,
                    c: C + or_C
                },
                e: {
                    r: R + or_R + (RS || 1) - 1,
                    c: C + or_C + (CS || 1) - 1
                }
            });
            var o /*:Cell*/  = {
                t: "s",
                v: v
            };
            var _t /*:string*/  = elt.getAttribute("data-t") || elt.getAttribute("t") || "";
            if (v != null) {
                if (v.length == 0) o.t = _t || "z";
                else if (opts.raw || v.trim().length == 0 || _t == "s") ;
                else if (v === "TRUE") o = {
                    t: "b",
                    v: true
                };
                else if (v === "FALSE") o = {
                    t: "b",
                    v: false
                };
                else if (!isNaN(fuzzynum(v))) o = {
                    t: "n",
                    v: fuzzynum(v)
                };
                else if (!isNaN(fuzzydate(v).getDate())) {
                    o = {
                        t: "d",
                        v: parseDate(v)
                    } /*:any*/ ;
                    if (!opts.cellDates) o = {
                        t: "n",
                        v: datenum(o.v)
                    } /*:any*/ ;
                    o.z = opts.dateNF || table_fmt[14];
                }
            }
            if (o.z === undefined && z != null) o.z = z;
            /* The first link is used.  Links are assumed to be fully specified.
			 * TODO: The right way to process relative links is to make a new <a> */ var l = "", Aelts = elt.getElementsByTagName("A");
            if (Aelts && Aelts.length) {
                for(var Aelti = 0; Aelti < Aelts.length; ++Aelti)if (Aelts[Aelti].hasAttribute("href")) {
                    l = Aelts[Aelti].getAttribute("href");
                    if (l.charAt(0) != "#") break;
                }
            }
            if (l && l.charAt(0) != "#") o.l = {
                Target: l
            };
            if (opts.dense) {
                if (!ws[R + or_R]) ws[R + or_R] = [];
                ws[R + or_R][C + or_C] = o;
            } else ws[encode_cell({
                c: C + or_C,
                r: R + or_R
            })] = o;
            if (range.e.c < C + or_C) range.e.c = C + or_C;
            C += CS;
        }
        ++R;
    }
    if (merges.length) ws["!merges"] = (ws["!merges"] || []).concat(merges);
    range.e.r = Math.max(range.e.r, R - 1 + or_R);
    ws["!ref"] = encode_range(range);
    if (R >= sheetRows) ws["!fullref"] = encode_range((range.e.r = rows.length - _R + R - 1 + or_R, range)); // We can count the real number of rows to parse but we don't to improve the performance
    return ws;
}
function parse_dom_table(table /*:HTMLElement*/ , _opts /*:?any*/ ) /*:Worksheet*/ {
    var opts = _opts || {};
    var ws /*:Worksheet*/  = opts.dense ? [] : {} /*:any*/ ;
    return sheet_add_dom(ws, table, _opts);
}
function table_to_book(table /*:HTMLElement*/ , opts /*:?any*/ ) /*:Workbook*/ {
    return sheet_to_workbook(parse_dom_table(table, opts), opts);
}
function is_dom_element_hidden(element /*:HTMLElement*/ ) /*:boolean*/ {
    var display /*:string*/  = "";
    var get_computed_style /*:?function*/  = get_get_computed_style_function(element);
    if (get_computed_style) display = get_computed_style(element).getPropertyValue("display");
    if (!display) display = element.style && element.style.display;
    return display === "none";
}
/* global getComputedStyle */ function get_get_computed_style_function(element /*:HTMLElement*/ ) /*:?function*/ {
    // The proper getComputedStyle implementation is the one defined in the element window
    if (element.ownerDocument.defaultView && typeof element.ownerDocument.defaultView.getComputedStyle === "function") return element.ownerDocument.defaultView.getComputedStyle;
    // If it is not available, try to get one from the global namespace
    if (typeof getComputedStyle === "function") return getComputedStyle;
    return null;
}
/* OpenDocument */ function parse_text_p(text /*:string*/  /*::, tag*/ ) /*:Array<any>*/ {
    /* 6.1.2 White Space Characters */ var fixed = text.replace(/[\t\r\n]/g, " ").trim().replace(/ +/g, " ").replace(/<text:s\/>/g, " ").replace(/<text:s text:c="(\d+)"\/>/g, function($$, $1) {
        return Array(parseInt($1, 10) + 1).join(" ");
    }).replace(/<text:tab[^>]*\/>/g, "	").replace(/<text:line-break\/>/g, "\n");
    var v = unescapexml(fixed.replace(/<[^>]*>/g, ""));
    return [
        v
    ];
}
var number_formats_ods = {
    /* ods name: [short ssf fmt, long ssf fmt] */ day: [
        "d",
        "dd"
    ],
    month: [
        "m",
        "mm"
    ],
    year: [
        "y",
        "yy"
    ],
    hours: [
        "h",
        "hh"
    ],
    minutes: [
        "m",
        "mm"
    ],
    seconds: [
        "s",
        "ss"
    ],
    "am-pm": [
        "A/P",
        "AM/PM"
    ],
    "day-of-week": [
        "ddd",
        "dddd"
    ],
    era: [
        "e",
        "ee"
    ],
    /* there is no native representation of LO "Q" format */ quarter: [
        "\\Qm",
        'm\\"th quarter"'
    ]
};
function parse_content_xml(d /*:string*/ , _opts) /*:Workbook*/ {
    var opts = _opts || {};
    if (DENSE != null && opts.dense == null) opts.dense = DENSE;
    var str = xlml_normalize(d);
    var state /*:Array<any>*/  = [], tmp;
    var tag /*:: = {}*/ ;
    var NFtag = {
        name: ""
    }, NF = "", pidx = 0;
    var sheetag /*:: = {name:"", '名称':""}*/ ;
    var rowtag /*:: = {'行号':""}*/ ;
    var Sheets = {}, SheetNames /*:Array<string>*/  = [];
    var ws = opts.dense ? [] : {} /*:any*/ ;
    var Rn, q /*:: :any = ({t:"", v:null, z:null, w:"",c:[],}:any)*/ ;
    var ctag = {
        value: ""
    } /*:any*/ ;
    var textp = "", textpidx = 0, textptag /*:: = {}*/ ;
    var textR = [];
    var R = -1, C = -1, range = {
        s: {
            r: 1000000,
            c: 10000000
        },
        e: {
            r: 0,
            c: 0
        }
    };
    var row_ol = 0;
    var number_format_map = {};
    var merges /*:Array<Range>*/  = [], mrange = {}, mR = 0, mC = 0;
    var rowinfo /*:Array<RowInfo>*/  = [], rowpeat = 1, colpeat = 1;
    var arrayf /*:Array<[Range, string]>*/  = [];
    var WB = {
        Names: []
    };
    var atag = {} /*:any*/ ;
    var _Ref /*:[string, string]*/  = [
        "",
        ""
    ];
    var comments /*:Array<Comment>*/  = [], comment /*:Comment*/  = {} /*:any*/ ;
    var creator = "", creatoridx = 0;
    var isstub = false, intable = false;
    var i = 0;
    xlmlregex.lastIndex = 0;
    str = str.replace(/<!--([\s\S]*?)-->/mg, "").replace(/<!DOCTYPE[^\[]*\[[^\]]*\]>/gm, "");
    while(Rn = xlmlregex.exec(str))switch(Rn[3] = Rn[3].replace(/_.*$/, "")){
        case "table":
        case "工作表":
            if (Rn[1] === "/") {
                if (range.e.c >= range.s.c && range.e.r >= range.s.r) ws["!ref"] = encode_range(range);
                else ws["!ref"] = "A1:A1";
                if (opts.sheetRows > 0 && opts.sheetRows <= range.e.r) {
                    ws["!fullref"] = ws["!ref"];
                    range.e.r = opts.sheetRows - 1;
                    ws["!ref"] = encode_range(range);
                }
                if (merges.length) ws["!merges"] = merges;
                if (rowinfo.length) ws["!rows"] = rowinfo;
                sheetag.name = sheetag["名称"] || sheetag.name;
                if (typeof JSON !== "undefined") JSON.stringify(sheetag);
                SheetNames.push(sheetag.name);
                Sheets[sheetag.name] = ws;
                intable = false;
            } else if (Rn[0].charAt(Rn[0].length - 2) !== "/") {
                sheetag = parsexmltag(Rn[0], false);
                R = C = -1;
                range.s.r = range.s.c = 10000000;
                range.e.r = range.e.c = 0;
                ws = opts.dense ? [] : {} /*:any*/ ;
                merges = [];
                rowinfo = [];
                intable = true;
            }
            break;
        case "table-row-group":
            if (Rn[1] === "/") --row_ol;
            else ++row_ol;
            break;
        case "table-row":
        case "行":
            if (Rn[1] === "/") {
                R += rowpeat;
                rowpeat = 1;
                break;
            }
            rowtag = parsexmltag(Rn[0], false);
            if (rowtag["行号"]) R = rowtag["行号"] - 1;
            else if (R == -1) R = 0;
            rowpeat = +rowtag["number-rows-repeated"] || 1;
            /* TODO: remove magic */ if (rowpeat < 10) {
                for(i = 0; i < rowpeat; ++i)if (row_ol > 0) rowinfo[R + i] = {
                    level: row_ol
                };
            }
            C = -1;
            break;
        case "covered-table-cell":
            if (Rn[1] !== "/") ++C;
            if (opts.sheetStubs) {
                if (opts.dense) {
                    if (!ws[R]) ws[R] = [];
                    ws[R][C] = {
                        t: "z"
                    };
                } else ws[encode_cell({
                    r: R,
                    c: C
                })] = {
                    t: "z"
                };
            }
            textp = "";
            textR = [];
            break; /* stub */ 
        case "table-cell":
        case "数据":
            if (Rn[0].charAt(Rn[0].length - 2) === "/") {
                ++C;
                ctag = parsexmltag(Rn[0], false);
                colpeat = parseInt(ctag["number-columns-repeated"] || "1", 10);
                q = {
                    t: "z",
                    v: null
                } /*:any*/ ;
                if (ctag.formula && opts.cellFormula != false) q.f = ods_to_csf_formula(unescapexml(ctag.formula));
                if ((ctag["数据类型"] || ctag["value-type"]) == "string") {
                    q.t = "s";
                    q.v = unescapexml(ctag["string-value"] || "");
                    if (opts.dense) {
                        if (!ws[R]) ws[R] = [];
                        ws[R][C] = q;
                    } else ws[encode_cell({
                        r: R,
                        c: C
                    })] = q;
                }
                C += colpeat - 1;
            } else if (Rn[1] !== "/") {
                ++C;
                textp = "";
                textpidx = 0;
                textR = [];
                colpeat = 1;
                var rptR = rowpeat ? R + rowpeat - 1 : R;
                if (C > range.e.c) range.e.c = C;
                if (C < range.s.c) range.s.c = C;
                if (R < range.s.r) range.s.r = R;
                if (rptR > range.e.r) range.e.r = rptR;
                ctag = parsexmltag(Rn[0], false);
                comments = [];
                comment = {} /*:any*/ ;
                q = {
                    t: ctag["数据类型"] || ctag["value-type"],
                    v: null
                } /*:any*/ ;
                if (opts.cellFormula) {
                    if (ctag.formula) ctag.formula = unescapexml(ctag.formula);
                    if (ctag["number-matrix-columns-spanned"] && ctag["number-matrix-rows-spanned"]) {
                        mR = parseInt(ctag["number-matrix-rows-spanned"], 10) || 0;
                        mC = parseInt(ctag["number-matrix-columns-spanned"], 10) || 0;
                        mrange = {
                            s: {
                                r: R,
                                c: C
                            },
                            e: {
                                r: R + mR - 1,
                                c: C + mC - 1
                            }
                        };
                        q.F = encode_range(mrange);
                        arrayf.push([
                            mrange,
                            q.F
                        ]);
                    }
                    if (ctag.formula) q.f = ods_to_csf_formula(ctag.formula);
                    else for(i = 0; i < arrayf.length; ++i)if (R >= arrayf[i][0].s.r && R <= arrayf[i][0].e.r) {
                        if (C >= arrayf[i][0].s.c && C <= arrayf[i][0].e.c) q.F = arrayf[i][1];
                    }
                }
                if (ctag["number-columns-spanned"] || ctag["number-rows-spanned"]) {
                    mR = parseInt(ctag["number-rows-spanned"], 10) || 0;
                    mC = parseInt(ctag["number-columns-spanned"], 10) || 0;
                    mrange = {
                        s: {
                            r: R,
                            c: C
                        },
                        e: {
                            r: R + mR - 1,
                            c: C + mC - 1
                        }
                    };
                    merges.push(mrange);
                }
                /* 19.675.2 table:number-columns-repeated */ if (ctag["number-columns-repeated"]) colpeat = parseInt(ctag["number-columns-repeated"], 10);
                /* 19.385 office:value-type */ switch(q.t){
                    case "boolean":
                        q.t = "b";
                        q.v = parsexmlbool(ctag["boolean-value"]);
                        break;
                    case "float":
                        q.t = "n";
                        q.v = parseFloat(ctag.value);
                        break;
                    case "percentage":
                        q.t = "n";
                        q.v = parseFloat(ctag.value);
                        break;
                    case "currency":
                        q.t = "n";
                        q.v = parseFloat(ctag.value);
                        break;
                    case "date":
                        q.t = "d";
                        q.v = parseDate(ctag["date-value"]);
                        if (!opts.cellDates) {
                            q.t = "n";
                            q.v = datenum(q.v);
                        }
                        q.z = "m/d/yy";
                        break;
                    case "time":
                        q.t = "n";
                        q.v = parse_isodur(ctag["time-value"]) / 86400;
                        if (opts.cellDates) {
                            q.t = "d";
                            q.v = numdate(q.v);
                        }
                        q.z = "HH:MM:SS";
                        break;
                    case "number":
                        q.t = "n";
                        q.v = parseFloat(ctag["数据数值"]);
                        break;
                    default:
                        if (q.t === "string" || q.t === "text" || !q.t) {
                            q.t = "s";
                            if (ctag["string-value"] != null) {
                                textp = unescapexml(ctag["string-value"]);
                                textR = [];
                            }
                        } else throw new Error("Unsupported value type " + q.t);
                }
            } else {
                isstub = false;
                if (q.t === "s") {
                    q.v = textp || "";
                    if (textR.length) q.R = textR;
                    isstub = textpidx == 0;
                }
                if (atag.Target) q.l = atag;
                if (comments.length > 0) {
                    q.c = comments;
                    comments = [];
                }
                if (textp && opts.cellText !== false) q.w = textp;
                if (isstub) {
                    q.t = "z";
                    delete q.v;
                }
                if (!isstub || opts.sheetStubs) {
                    if (!(opts.sheetRows && opts.sheetRows <= R)) for(var rpt = 0; rpt < rowpeat; ++rpt){
                        colpeat = parseInt(ctag["number-columns-repeated"] || "1", 10);
                        if (opts.dense) {
                            if (!ws[R + rpt]) ws[R + rpt] = [];
                            ws[R + rpt][C] = rpt == 0 ? q : dup(q);
                            while(--colpeat > 0)ws[R + rpt][C + colpeat] = dup(q);
                        } else {
                            ws[encode_cell({
                                r: R + rpt,
                                c: C
                            })] = q;
                            while(--colpeat > 0)ws[encode_cell({
                                r: R + rpt,
                                c: C + colpeat
                            })] = dup(q);
                        }
                        if (range.e.c <= C) range.e.c = C;
                    }
                }
                colpeat = parseInt(ctag["number-columns-repeated"] || "1", 10);
                C += colpeat - 1;
                colpeat = 0;
                q = {};
                textp = "";
                textR = [];
            }
            atag = {} /*:any*/ ;
            break; // 9.1.4 <table:table-cell>
        /* pure state */ case "document":
        case "document-content":
        case "电子表格文档":
        case "spreadsheet":
        case "主体":
        case "scripts":
        case "styles":
        case "font-face-decls":
        case "master-styles":
            if (Rn[1] === "/") {
                if ((tmp = state.pop())[0] !== Rn[3]) throw "Bad state: " + tmp;
            } else if (Rn[0].charAt(Rn[0].length - 2) !== "/") state.push([
                Rn[3],
                true
            ]);
            break;
        case "annotation":
            if (Rn[1] === "/") {
                if ((tmp = state.pop())[0] !== Rn[3]) throw "Bad state: " + tmp;
                comment.t = textp;
                if (textR.length) /*::(*/ comment /*:: :any)*/ .R = textR;
                comment.a = creator;
                comments.push(comment);
            } else if (Rn[0].charAt(Rn[0].length - 2) !== "/") state.push([
                Rn[3],
                false
            ]);
            creator = "";
            creatoridx = 0;
            textp = "";
            textpidx = 0;
            textR = [];
            break;
        case "creator":
            if (Rn[1] === "/") creator = str.slice(creatoridx, Rn.index);
            else creatoridx = Rn.index + Rn[0].length;
            break;
        /* ignore state */ case "meta":
        case "元数据":
        case "settings":
        case "config-item-set":
        case "config-item-map-indexed":
        case "config-item-map-entry":
        case "config-item-map-named":
        case "shapes":
        case "frame":
        case "text-box":
        case "image":
        case "data-pilot-tables":
        case "list-style":
        case "form":
        case "dde-links":
        case "event-listeners":
        case "chart":
            if (Rn[1] === "/") {
                if ((tmp = state.pop())[0] !== Rn[3]) throw "Bad state: " + tmp;
            } else if (Rn[0].charAt(Rn[0].length - 2) !== "/") state.push([
                Rn[3],
                false
            ]);
            textp = "";
            textpidx = 0;
            textR = [];
            break;
        case "scientific-number":
            break;
        case "currency-symbol":
            break;
        case "currency-style":
            break;
        case "number-style":
        case "percentage-style":
        case "date-style":
        case "time-style":
            if (Rn[1] === "/") {
                number_format_map[NFtag.name] = NF;
                if ((tmp = state.pop())[0] !== Rn[3]) throw "Bad state: " + tmp;
            } else if (Rn[0].charAt(Rn[0].length - 2) !== "/") {
                NF = "";
                NFtag = parsexmltag(Rn[0], false);
                state.push([
                    Rn[3],
                    true
                ]);
            }
            break;
        case "script":
            break; // 3.13 <office:script>
        case "libraries":
            break; // TODO: <ooo:libraries>
        case "automatic-styles":
            break; // 3.15.3 <office:automatic-styles>
        case "default-style":
        case "page-layout":
            break; // TODO: <style:page-layout>
        case "style":
            break;
        case "map":
            break; // 16.3 <style:map>
        case "font-face":
            break; // 16.21 <style:font-face>
        case "paragraph-properties":
            break; // 17.6 <style:paragraph-properties>
        case "table-properties":
            break; // 17.15 <style:table-properties>
        case "table-column-properties":
            break; // 17.16 <style:table-column-properties>
        case "table-row-properties":
            break; // 17.17 <style:table-row-properties>
        case "table-cell-properties":
            break; // 17.18 <style:table-cell-properties>
        case "number":
            switch(state[state.length - 1][0]){
                case "time-style":
                case "date-style":
                    tag = parsexmltag(Rn[0], false);
                    NF += number_formats_ods[Rn[3]][tag.style === "long" ? 1 : 0];
                    break;
            }
            break;
        case "fraction":
            break; // TODO 16.27.6 <number:fraction>
        case "day":
        case "month":
        case "year":
        case "era":
        case "day-of-week":
        case "week-of-year":
        case "quarter":
        case "hours":
        case "minutes":
        case "seconds":
        case "am-pm":
            switch(state[state.length - 1][0]){
                case "time-style":
                case "date-style":
                    tag = parsexmltag(Rn[0], false);
                    NF += number_formats_ods[Rn[3]][tag.style === "long" ? 1 : 0];
                    break;
            }
            break;
        case "boolean-style":
            break; // 16.27.23 <number:boolean-style>
        case "boolean":
            break; // 16.27.24 <number:boolean>
        case "text-style":
            break; // 16.27.25 <number:text-style>
        case "text":
            if (Rn[0].slice(-2) === "/>") break;
            else if (Rn[1] === "/") switch(state[state.length - 1][0]){
                case "number-style":
                case "date-style":
                case "time-style":
                    NF += str.slice(pidx, Rn.index);
                    break;
            }
            else pidx = Rn.index + Rn[0].length;
            break;
        case "named-range":
            tag = parsexmltag(Rn[0], false);
            _Ref = ods_to_csf_3D(tag["cell-range-address"]);
            var nrange = {
                Name: tag.name,
                Ref: _Ref[0] + "!" + _Ref[1]
            } /*:any*/ ;
            if (intable) nrange.Sheet = SheetNames.length;
            WB.Names.push(nrange);
            break;
        case "text-content":
            break; // 16.27.27 <number:text-content>
        case "text-properties":
            break; // 16.27.27 <style:text-properties>
        case "embedded-text":
            break; // 16.27.4 <number:embedded-text>
        case "body":
        case "电子表格":
            break; // 3.3 16.9.6 19.726.3
        case "forms":
            break; // 12.25.2 13.2
        case "table-column":
            break; // 9.1.6 <table:table-column>
        case "table-header-rows":
            break; // 9.1.7 <table:table-header-rows>
        case "table-rows":
            break; // 9.1.12 <table:table-rows>
        /* TODO: outline levels */ case "table-column-group":
            break; // 9.1.10 <table:table-column-group>
        case "table-header-columns":
            break; // 9.1.11 <table:table-header-columns>
        case "table-columns":
            break; // 9.1.12 <table:table-columns>
        case "null-date":
            break; // 9.4.2 <table:null-date> TODO: date1904
        case "graphic-properties":
            break; // 17.21 <style:graphic-properties>
        case "calculation-settings":
            break; // 9.4.1 <table:calculation-settings>
        case "named-expressions":
            break; // 9.4.11 <table:named-expressions>
        case "label-range":
            break; // 9.4.9 <table:label-range>
        case "label-ranges":
            break; // 9.4.10 <table:label-ranges>
        case "named-expression":
            break; // 9.4.13 <table:named-expression>
        case "sort":
            break; // 9.4.19 <table:sort>
        case "sort-by":
            break; // 9.4.20 <table:sort-by>
        case "sort-groups":
            break; // 9.4.22 <table:sort-groups>
        case "tab":
            break; // 6.1.4 <text:tab>
        case "line-break":
            break; // 6.1.5 <text:line-break>
        case "span":
            break; // 6.1.7 <text:span>
        case "p":
        case "文本串":
            if ([
                "master-styles"
            ].indexOf(state[state.length - 1][0]) > -1) break;
            if (Rn[1] === "/" && (!ctag || !ctag["string-value"])) {
                var ptp = parse_text_p(str.slice(textpidx, Rn.index), textptag);
                textp = (textp.length > 0 ? textp + "\n" : "") + ptp[0];
            } else {
                textptag = parsexmltag(Rn[0], false);
                textpidx = Rn.index + Rn[0].length;
            }
            break; // <text:p>
        case "s":
            break; // <text:s>
        case "database-range":
            if (Rn[1] === "/") break;
            try {
                _Ref = ods_to_csf_3D(parsexmltag(Rn[0])["target-range-address"]);
                Sheets[_Ref[0]]["!autofilter"] = {
                    ref: _Ref[1]
                };
            } catch (e) {}
            break;
        case "date":
            break; // <*:date>
        case "object":
            break; // 10.4.6.2 <draw:object>
        case "title":
        case "标题":
            break; // <*:title> OR <uof:标题>
        case "desc":
            break; // <*:desc>
        case "binary-data":
            break; // 10.4.5 TODO: b64 blob
        /* 9.2 Advanced Tables */ case "table-source":
            break; // 9.2.6
        case "scenario":
            break; // 9.2.6
        case "iteration":
            break; // 9.4.3 <table:iteration>
        case "content-validations":
            break; // 9.4.4 <table:
        case "content-validation":
            break; // 9.4.5 <table:
        case "help-message":
            break; // 9.4.6 <table:
        case "error-message":
            break; // 9.4.7 <table:
        case "database-ranges":
            break; // 9.4.14 <table:database-ranges>
        case "filter":
            break; // 9.5.2 <table:filter>
        case "filter-and":
            break; // 9.5.3 <table:filter-and>
        case "filter-or":
            break; // 9.5.4 <table:filter-or>
        case "filter-condition":
            break; // 9.5.5 <table:filter-condition>
        case "list-level-style-bullet":
            break; // 16.31 <text:
        case "list-level-style-number":
            break; // 16.32 <text:
        case "list-level-properties":
            break; // 17.19 <style:
        /* 7.3 Document Fields */ case "sender-firstname":
        case "sender-lastname":
        case "sender-initials":
        case "sender-title":
        case "sender-position":
        case "sender-email":
        case "sender-phone-private":
        case "sender-fax":
        case "sender-company":
        case "sender-phone-work":
        case "sender-street":
        case "sender-city":
        case "sender-postal-code":
        case "sender-country":
        case "sender-state-or-province":
        case "author-name":
        case "author-initials":
        case "chapter":
        case "file-name":
        case "template-name":
        case "sheet-name":
            break;
        case "event-listener":
            break;
        /* TODO: FODS Properties */ case "initial-creator":
        case "creation-date":
        case "print-date":
        case "generator":
        case "document-statistic":
        case "user-defined":
        case "editing-duration":
        case "editing-cycles":
            break;
        /* TODO: FODS Config */ case "config-item":
            break;
        /* TODO: style tokens */ case "page-number":
            break; // TODO <text:page-number>
        case "page-count":
            break; // TODO <text:page-count>
        case "time":
            break; // TODO <text:time>
        /* 9.3 Advanced Table Cells */ case "cell-range-source":
            break; // 9.3.1 <table:
        case "detective":
            break; // 9.3.2 <table:
        case "operation":
            break; // 9.3.3 <table:
        case "highlighted-range":
            break; // 9.3.4 <table:
        /* 9.6 Data Pilot Tables <table: */ case "data-pilot-table":
        case "source-cell-range":
        case "source-service":
        case "data-pilot-field":
        case "data-pilot-level":
        case "data-pilot-subtotals":
        case "data-pilot-subtotal":
        case "data-pilot-members":
        case "data-pilot-member":
        case "data-pilot-display-info":
        case "data-pilot-sort-info":
        case "data-pilot-layout-info":
        case "data-pilot-field-reference":
        case "data-pilot-groups":
        case "data-pilot-group":
        case "data-pilot-group-member":
            break;
        /* 10.3 Drawing Shapes */ case "rect":
            break;
        /* 14.6 DDE Connections */ case "dde-connection-decls":
        case "dde-connection-decl":
        case "dde-link":
        case "dde-source":
            break;
        case "properties":
            break; // 13.7 <form:properties>
        case "property":
            break; // 13.8 <form:property>
        case "a":
            if (Rn[1] !== "/") {
                atag = parsexmltag(Rn[0], false);
                if (!atag.href) break;
                atag.Target = unescapexml(atag.href);
                delete atag.href;
                if (atag.Target.charAt(0) == "#" && atag.Target.indexOf(".") > -1) {
                    _Ref = ods_to_csf_3D(atag.Target.slice(1));
                    atag.Target = "#" + _Ref[0] + "!" + _Ref[1];
                } else if (atag.Target.match(/^\.\.[\\\/]/)) atag.Target = atag.Target.slice(3);
            }
            break;
        /* non-standard */ case "table-protection":
            break;
        case "data-pilot-grand-total":
            break; // <table:
        case "office-document-common-attrs":
            break; // bare
        default:
            switch(Rn[2]){
                case "dc:":
                case "calcext:":
                case "loext:":
                case "ooo:":
                case "chartooo:":
                case "draw:":
                case "style:":
                case "chart:":
                case "form:":
                case "uof:":
                case "表:":
                case "字:":
                    break;
                default:
                    if (opts.WTF) throw new Error(Rn);
            }
    }
    var out /*:Workbook*/  = {
        Sheets: Sheets,
        SheetNames: SheetNames,
        Workbook: WB
    } /*:any*/ ;
    if (opts.bookSheets) delete /*::(*/ out /*:: :any)*/ .Sheets;
    return out;
}
function parse_ods(zip /*:ZIPFile*/ , opts /*:?ParseOpts*/ ) /*:Workbook*/ {
    opts = opts || {} /*:any*/ ;
    if (safegetzipfile(zip, "META-INF/manifest.xml")) parse_manifest(getzipdata(zip, "META-INF/manifest.xml"), opts);
    var content = getzipstr(zip, "content.xml");
    if (!content) throw new Error("Missing content.xml in ODS / UOF file");
    var wb = parse_content_xml(utf8read(content), opts);
    if (safegetzipfile(zip, "meta.xml")) wb.Props = parse_core_props(getzipdata(zip, "meta.xml"));
    return wb;
}
function parse_fods(data /*:string*/ , opts /*:?ParseOpts*/ ) /*:Workbook*/ {
    return parse_content_xml(data, opts);
}
/* OpenDocument */ var write_styles_ods /*:{(wb:any, opts:any):string}*/  = /* @__PURE__ */ function() {
    var master_styles = [
        "<office:master-styles>",
        '<style:master-page style:name="mp1" style:page-layout-name="mp1">',
        "<style:header/>",
        '<style:header-left style:display="false"/>',
        "<style:footer/>",
        '<style:footer-left style:display="false"/>',
        "</style:master-page>",
        "</office:master-styles>"
    ].join("");
    var payload = "<office:document-styles " + wxt_helper({
        "xmlns:office": "urn:oasis:names:tc:opendocument:xmlns:office:1.0",
        "xmlns:table": "urn:oasis:names:tc:opendocument:xmlns:table:1.0",
        "xmlns:style": "urn:oasis:names:tc:opendocument:xmlns:style:1.0",
        "xmlns:text": "urn:oasis:names:tc:opendocument:xmlns:text:1.0",
        "xmlns:draw": "urn:oasis:names:tc:opendocument:xmlns:drawing:1.0",
        "xmlns:fo": "urn:oasis:names:tc:opendocument:xmlns:xsl-fo-compatible:1.0",
        "xmlns:xlink": "http://www.w3.org/1999/xlink",
        "xmlns:dc": "http://purl.org/dc/elements/1.1/",
        "xmlns:number": "urn:oasis:names:tc:opendocument:xmlns:datastyle:1.0",
        "xmlns:svg": "urn:oasis:names:tc:opendocument:xmlns:svg-compatible:1.0",
        "xmlns:of": "urn:oasis:names:tc:opendocument:xmlns:of:1.2",
        "office:version": "1.2"
    }) + ">" + master_styles + "</office:document-styles>";
    return function wso() {
        return XML_HEADER + payload;
    };
}();
var write_content_ods /*:{(wb:any, opts:any):string}*/  = /* @__PURE__ */ function() {
    /* 6.1.2 White Space Characters */ var write_text_p = function(text /*:string*/ ) /*:string*/ {
        return escapexml(text).replace(/  +/g, function($$) {
            return '<text:s text:c="' + $$.length + '"/>';
        }).replace(/\t/g, "<text:tab/>").replace(/\n/g, "</text:p><text:p>").replace(/^ /, "<text:s/>").replace(/ $/, "<text:s/>");
    };
    var null_cell_xml = "          <table:table-cell />\n";
    var covered_cell_xml = "          <table:covered-table-cell/>\n";
    var write_ws = function(ws, wb /*:Workbook*/ , i /*:number*/  /*::, opts*/ ) /*:string*/ {
        /* Section 9 Tables */ var o /*:Array<string>*/  = [];
        o.push('      <table:table table:name="' + escapexml(wb.SheetNames[i]) + '" table:style-name="ta1">\n');
        var R = 0, C = 0, range = decode_range(ws["!ref"] || "A1");
        var marr /*:Array<Range>*/  = ws["!merges"] || [], mi = 0;
        var dense = Array.isArray(ws);
        if (ws["!cols"]) for(C = 0; C <= range.e.c; ++C)o.push("        <table:table-column" + (ws["!cols"][C] ? ' table:style-name="co' + ws["!cols"][C].ods + '"' : "") + "></table:table-column>\n");
        var H = "", ROWS = ws["!rows"] || [];
        for(R = 0; R < range.s.r; ++R){
            H = ROWS[R] ? ' table:style-name="ro' + ROWS[R].ods + '"' : "";
            o.push("        <table:table-row" + H + "></table:table-row>\n");
        }
        for(; R <= range.e.r; ++R){
            H = ROWS[R] ? ' table:style-name="ro' + ROWS[R].ods + '"' : "";
            o.push("        <table:table-row" + H + ">\n");
            for(C = 0; C < range.s.c; ++C)o.push(null_cell_xml);
            for(; C <= range.e.c; ++C){
                var skip = false, ct = {}, textp = "";
                for(mi = 0; mi != marr.length; ++mi){
                    if (marr[mi].s.c > C) continue;
                    if (marr[mi].s.r > R) continue;
                    if (marr[mi].e.c < C) continue;
                    if (marr[mi].e.r < R) continue;
                    if (marr[mi].s.c != C || marr[mi].s.r != R) skip = true;
                    ct["table:number-columns-spanned"] = marr[mi].e.c - marr[mi].s.c + 1;
                    ct["table:number-rows-spanned"] = marr[mi].e.r - marr[mi].s.r + 1;
                    break;
                }
                if (skip) {
                    o.push(covered_cell_xml);
                    continue;
                }
                var ref = encode_cell({
                    r: R,
                    c: C
                }), cell = dense ? (ws[R] || [])[C] : ws[ref];
                if (cell && cell.f) {
                    ct["table:formula"] = escapexml(csf_to_ods_formula(cell.f));
                    if (cell.F) {
                        if (cell.F.slice(0, ref.length) == ref) {
                            var _Fref = decode_range(cell.F);
                            ct["table:number-matrix-columns-spanned"] = _Fref.e.c - _Fref.s.c + 1;
                            ct["table:number-matrix-rows-spanned"] = _Fref.e.r - _Fref.s.r + 1;
                        }
                    }
                }
                if (!cell) {
                    o.push(null_cell_xml);
                    continue;
                }
                switch(cell.t){
                    case "b":
                        textp = cell.v ? "TRUE" : "FALSE";
                        ct["office:value-type"] = "boolean";
                        ct["office:boolean-value"] = cell.v ? "true" : "false";
                        break;
                    case "n":
                        textp = cell.w || String(cell.v || 0);
                        ct["office:value-type"] = "float";
                        ct["office:value"] = cell.v || 0;
                        break;
                    case "s":
                    case "str":
                        textp = cell.v == null ? "" : cell.v;
                        ct["office:value-type"] = "string";
                        break;
                    case "d":
                        textp = cell.w || parseDate(cell.v).toISOString();
                        ct["office:value-type"] = "date";
                        ct["office:date-value"] = parseDate(cell.v).toISOString();
                        ct["table:style-name"] = "ce1";
                        break;
                    //case 'e':
                    default:
                        o.push(null_cell_xml);
                        continue;
                }
                var text_p = write_text_p(textp);
                if (cell.l && cell.l.Target) {
                    var _tgt = cell.l.Target;
                    _tgt = _tgt.charAt(0) == "#" ? "#" + csf_to_ods_3D(_tgt.slice(1)) : _tgt;
                    // TODO: choose correct parent path format based on link delimiters
                    if (_tgt.charAt(0) != "#" && !_tgt.match(/^\w+:/)) _tgt = "../" + _tgt;
                    text_p = writextag("text:a", text_p, {
                        "xlink:href": _tgt.replace(/&/g, "&amp;")
                    });
                }
                o.push("          " + writextag("table:table-cell", writextag("text:p", text_p, {}), ct) + "\n");
            }
            o.push("        </table:table-row>\n");
        }
        o.push("      </table:table>\n");
        return o.join("");
    };
    var write_automatic_styles_ods = function(o /*:Array<string>*/ , wb) {
        o.push(" <office:automatic-styles>\n");
        o.push('  <number:date-style style:name="N37" number:automatic-order="true">\n');
        o.push('   <number:month number:style="long"/>\n');
        o.push("   <number:text>/</number:text>\n");
        o.push('   <number:day number:style="long"/>\n');
        o.push("   <number:text>/</number:text>\n");
        o.push("   <number:year/>\n");
        o.push("  </number:date-style>\n");
        /* column styles */ var cidx = 0;
        wb.SheetNames.map(function(n) {
            return wb.Sheets[n];
        }).forEach(function(ws) {
            if (!ws) return;
            if (ws["!cols"]) {
                for(var C = 0; C < ws["!cols"].length; ++C)if (ws["!cols"][C]) {
                    var colobj = ws["!cols"][C];
                    if (colobj.width == null && colobj.wpx == null && colobj.wch == null) continue;
                    process_col(colobj);
                    colobj.ods = cidx;
                    var w = ws["!cols"][C].wpx + "px";
                    o.push('  <style:style style:name="co' + cidx + '" style:family="table-column">\n');
                    o.push('   <style:table-column-properties fo:break-before="auto" style:column-width="' + w + '"/>\n');
                    o.push("  </style:style>\n");
                    ++cidx;
                }
            }
        });
        /* row styles */ var ridx = 0;
        wb.SheetNames.map(function(n) {
            return wb.Sheets[n];
        }).forEach(function(ws) {
            if (!ws) return;
            if (ws["!rows"]) {
                for(var R = 0; R < ws["!rows"].length; ++R)if (ws["!rows"][R]) {
                    ws["!rows"][R].ods = ridx;
                    var h = ws["!rows"][R].hpx + "px";
                    o.push('  <style:style style:name="ro' + ridx + '" style:family="table-row">\n');
                    o.push('   <style:table-row-properties fo:break-before="auto" style:row-height="' + h + '"/>\n');
                    o.push("  </style:style>\n");
                    ++ridx;
                }
            }
        });
        /* table */ o.push('  <style:style style:name="ta1" style:family="table" style:master-page-name="mp1">\n');
        o.push('   <style:table-properties table:display="true" style:writing-mode="lr-tb"/>\n');
        o.push("  </style:style>\n");
        /* table cells, text */ o.push('  <style:style style:name="ce1" style:family="table-cell" style:parent-style-name="Default" style:data-style-name="N37"/>\n');
        /* page-layout */ o.push(" </office:automatic-styles>\n");
    };
    return function wcx(wb, opts) {
        var o = [
            XML_HEADER
        ];
        /* 3.1.3.2 */ var attr = wxt_helper({
            "xmlns:office": "urn:oasis:names:tc:opendocument:xmlns:office:1.0",
            "xmlns:table": "urn:oasis:names:tc:opendocument:xmlns:table:1.0",
            "xmlns:style": "urn:oasis:names:tc:opendocument:xmlns:style:1.0",
            "xmlns:text": "urn:oasis:names:tc:opendocument:xmlns:text:1.0",
            "xmlns:draw": "urn:oasis:names:tc:opendocument:xmlns:drawing:1.0",
            "xmlns:fo": "urn:oasis:names:tc:opendocument:xmlns:xsl-fo-compatible:1.0",
            "xmlns:xlink": "http://www.w3.org/1999/xlink",
            "xmlns:dc": "http://purl.org/dc/elements/1.1/",
            "xmlns:meta": "urn:oasis:names:tc:opendocument:xmlns:meta:1.0",
            "xmlns:number": "urn:oasis:names:tc:opendocument:xmlns:datastyle:1.0",
            "xmlns:presentation": "urn:oasis:names:tc:opendocument:xmlns:presentation:1.0",
            "xmlns:svg": "urn:oasis:names:tc:opendocument:xmlns:svg-compatible:1.0",
            "xmlns:chart": "urn:oasis:names:tc:opendocument:xmlns:chart:1.0",
            "xmlns:dr3d": "urn:oasis:names:tc:opendocument:xmlns:dr3d:1.0",
            "xmlns:math": "http://www.w3.org/1998/Math/MathML",
            "xmlns:form": "urn:oasis:names:tc:opendocument:xmlns:form:1.0",
            "xmlns:script": "urn:oasis:names:tc:opendocument:xmlns:script:1.0",
            "xmlns:ooo": "http://openoffice.org/2004/office",
            "xmlns:ooow": "http://openoffice.org/2004/writer",
            "xmlns:oooc": "http://openoffice.org/2004/calc",
            "xmlns:dom": "http://www.w3.org/2001/xml-events",
            "xmlns:xforms": "http://www.w3.org/2002/xforms",
            "xmlns:xsd": "http://www.w3.org/2001/XMLSchema",
            "xmlns:xsi": "http://www.w3.org/2001/XMLSchema-instance",
            "xmlns:sheet": "urn:oasis:names:tc:opendocument:sh33tjs:1.0",
            "xmlns:rpt": "http://openoffice.org/2005/report",
            "xmlns:of": "urn:oasis:names:tc:opendocument:xmlns:of:1.2",
            "xmlns:xhtml": "http://www.w3.org/1999/xhtml",
            "xmlns:grddl": "http://www.w3.org/2003/g/data-view#",
            "xmlns:tableooo": "http://openoffice.org/2009/table",
            "xmlns:drawooo": "http://openoffice.org/2010/draw",
            "xmlns:calcext": "urn:org:documentfoundation:names:experimental:calc:xmlns:calcext:1.0",
            "xmlns:loext": "urn:org:documentfoundation:names:experimental:office:xmlns:loext:1.0",
            "xmlns:field": "urn:openoffice:names:experimental:ooo-ms-interop:xmlns:field:1.0",
            "xmlns:formx": "urn:openoffice:names:experimental:ooxml-odf-interop:xmlns:form:1.0",
            "xmlns:css3t": "http://www.w3.org/TR/css3-text/",
            "office:version": "1.2"
        });
        var fods = wxt_helper({
            "xmlns:config": "urn:oasis:names:tc:opendocument:xmlns:config:1.0",
            "office:mimetype": "application/vnd.oasis.opendocument.spreadsheet"
        });
        if (opts.bookType == "fods") {
            o.push("<office:document" + attr + fods + ">\n");
            o.push(write_meta_ods().replace(/office:document-meta/g, "office:meta"));
        // TODO: settings (equiv of settings.xml for ODS)
        } else o.push("<office:document-content" + attr + ">\n");
        // o.push('  <office:scripts/>\n');
        write_automatic_styles_ods(o, wb);
        o.push("  <office:body>\n");
        o.push("    <office:spreadsheet>\n");
        for(var i = 0; i != wb.SheetNames.length; ++i)o.push(write_ws(wb.Sheets[wb.SheetNames[i]], wb, i, opts));
        o.push("    </office:spreadsheet>\n");
        o.push("  </office:body>\n");
        if (opts.bookType == "fods") o.push("</office:document>");
        else o.push("</office:document-content>");
        return o.join("");
    };
}();
function write_ods(wb /*:any*/ , opts /*:any*/ ) {
    if (opts.bookType == "fods") return write_content_ods(wb, opts);
    var zip = zip_new();
    var f = "";
    var manifest /*:Array<Array<string> >*/  = [];
    var rdf /*:Array<[string, string]>*/  = [];
    /* Part 3 Section 3.3 MIME Media Type */ f = "mimetype";
    zip_add_file(zip, f, "application/vnd.oasis.opendocument.spreadsheet");
    /* Part 1 Section 2.2 Documents */ f = "content.xml";
    zip_add_file(zip, f, write_content_ods(wb, opts));
    manifest.push([
        f,
        "text/xml"
    ]);
    rdf.push([
        f,
        "ContentFile"
    ]);
    /* TODO: these are hard-coded styles to satiate excel */ f = "styles.xml";
    zip_add_file(zip, f, write_styles_ods(wb, opts));
    manifest.push([
        f,
        "text/xml"
    ]);
    rdf.push([
        f,
        "StylesFile"
    ]);
    /* TODO: this is hard-coded to satiate excel */ f = "meta.xml";
    zip_add_file(zip, f, XML_HEADER + write_meta_ods());
    manifest.push([
        f,
        "text/xml"
    ]);
    rdf.push([
        f,
        "MetadataFile"
    ]);
    /* Part 3 Section 6 Metadata Manifest File */ f = "manifest.rdf";
    zip_add_file(zip, f, write_rdf(rdf /*, opts*/ ));
    manifest.push([
        f,
        "application/rdf+xml"
    ]);
    /* Part 3 Section 4 Manifest File */ f = "META-INF/manifest.xml";
    zip_add_file(zip, f, write_manifest(manifest /*, opts*/ ));
    return zip;
}
/*! sheetjs (C) 2013-present SheetJS -- http://sheetjs.com */ function u8_to_dataview(array) {
    return new DataView(array.buffer, array.byteOffset, array.byteLength);
}
function u8str(u8) {
    return typeof TextDecoder != "undefined" ? new TextDecoder().decode(u8) : utf8read(a2s(u8));
}
function stru8(str) {
    return typeof TextEncoder != "undefined" ? new TextEncoder().encode(str) : s2a(utf8write(str));
}
function u8contains(body, search) {
    outer: for(var L = 0; L <= body.length - search.length; ++L){
        for(var j = 0; j < search.length; ++j)if (body[L + j] != search[j]) continue outer;
        return true;
    }
    return false;
}
function u8concat(u8a) {
    var len = u8a.reduce(function(acc, x) {
        return acc + x.length;
    }, 0);
    var out = new Uint8Array(len);
    var off = 0;
    u8a.forEach(function(u8) {
        out.set(u8, off);
        off += u8.length;
    });
    return out;
}
function popcnt(x) {
    x -= x >> 1 & 1431655765;
    x = (x & 858993459) + (x >> 2 & 858993459);
    return (x + (x >> 4) & 252645135) * 16843009 >>> 24;
}
function readDecimal128LE(buf, offset) {
    var exp = (buf[offset + 15] & 127) << 7 | buf[offset + 14] >> 1;
    var mantissa = buf[offset + 14] & 1;
    for(var j = offset + 13; j >= offset; --j)mantissa = mantissa * 256 + buf[j];
    return (buf[offset + 15] & 128 ? -mantissa : mantissa) * Math.pow(10, exp - 6176);
}
function writeDecimal128LE(buf, offset, value) {
    var exp = Math.floor(value == 0 ? 0 : Math.LOG10E * Math.log(Math.abs(value))) + 6176 - 20;
    var mantissa = value / Math.pow(10, exp - 6176);
    buf[offset + 15] |= exp >> 7;
    buf[offset + 14] |= (exp & 127) << 1;
    for(var i = 0; mantissa >= 1; ++i, mantissa /= 256)buf[offset + i] = mantissa & 255;
    buf[offset + 15] |= value >= 0 ? 0 : 128;
}
function parse_varint49(buf, ptr) {
    var l = ptr ? ptr[0] : 0;
    var usz = buf[l] & 127;
    varint: if (buf[l++] >= 128) {
        usz |= (buf[l] & 127) << 7;
        if (buf[l++] < 128) break varint;
        usz |= (buf[l] & 127) << 14;
        if (buf[l++] < 128) break varint;
        usz |= (buf[l] & 127) << 21;
        if (buf[l++] < 128) break varint;
        usz += (buf[l] & 127) * Math.pow(2, 28);
        ++l;
        if (buf[l++] < 128) break varint;
        usz += (buf[l] & 127) * Math.pow(2, 35);
        ++l;
        if (buf[l++] < 128) break varint;
        usz += (buf[l] & 127) * Math.pow(2, 42);
        ++l;
        if (buf[l++] < 128) break varint;
    }
    if (ptr) ptr[0] = l;
    return usz;
}
function write_varint49(v) {
    var usz = new Uint8Array(7);
    usz[0] = v & 127;
    var L = 1;
    sz: if (v > 127) {
        usz[L - 1] |= 128;
        usz[L] = v >> 7 & 127;
        ++L;
        if (v <= 16383) break sz;
        usz[L - 1] |= 128;
        usz[L] = v >> 14 & 127;
        ++L;
        if (v <= 2097151) break sz;
        usz[L - 1] |= 128;
        usz[L] = v >> 21 & 127;
        ++L;
        if (v <= 268435455) break sz;
        usz[L - 1] |= 128;
        usz[L] = v / 256 >>> 21 & 127;
        ++L;
        if (v <= 34359738367) break sz;
        usz[L - 1] |= 128;
        usz[L] = v / 65536 >>> 21 & 127;
        ++L;
        if (v <= 4398046511103) break sz;
        usz[L - 1] |= 128;
        usz[L] = v / 16777216 >>> 21 & 127;
        ++L;
    }
    return usz.slice(0, L);
}
function varint_to_i32(buf) {
    var l = 0, i32 = buf[l] & 127;
    varint: if (buf[l++] >= 128) {
        i32 |= (buf[l] & 127) << 7;
        if (buf[l++] < 128) break varint;
        i32 |= (buf[l] & 127) << 14;
        if (buf[l++] < 128) break varint;
        i32 |= (buf[l] & 127) << 21;
        if (buf[l++] < 128) break varint;
        i32 |= (buf[l] & 127) << 28;
    }
    return i32;
}
function parse_shallow(buf) {
    var out = [], ptr = [
        0
    ];
    while(ptr[0] < buf.length){
        var off = ptr[0];
        var num = parse_varint49(buf, ptr);
        var type = num & 7;
        num = Math.floor(num / 8);
        var len = 0;
        var res;
        if (num == 0) break;
        switch(type){
            case 0:
                var l = ptr[0];
                while(buf[ptr[0]++] >= 128);
                res = buf.slice(l, ptr[0]);
                break;
            case 5:
                len = 4;
                res = buf.slice(ptr[0], ptr[0] + len);
                ptr[0] += len;
                break;
            case 1:
                len = 8;
                res = buf.slice(ptr[0], ptr[0] + len);
                ptr[0] += len;
                break;
            case 2:
                len = parse_varint49(buf, ptr);
                res = buf.slice(ptr[0], ptr[0] + len);
                ptr[0] += len;
                break;
            case 3:
            case 4:
            default:
                throw new Error("PB Type ".concat(type, " for Field ").concat(num, " at offset ").concat(off));
        }
        var v = {
            data: res,
            type: type
        };
        if (out[num] == null) out[num] = [
            v
        ];
        else out[num].push(v);
    }
    return out;
}
function write_shallow(proto) {
    var out = [];
    proto.forEach(function(field, idx) {
        field.forEach(function(item) {
            if (!item.data) return;
            out.push(write_varint49(idx * 8 + item.type));
            if (item.type == 2) out.push(write_varint49(item.data.length));
            out.push(item.data);
        });
    });
    return u8concat(out);
}
function mappa(data, cb) {
    return (data == null ? void 0 : data.map(function(d) {
        return cb(d.data);
    })) || [];
}
function parse_iwa_file(buf) {
    var _a;
    var out = [], ptr = [
        0
    ];
    while(ptr[0] < buf.length){
        var len = parse_varint49(buf, ptr);
        var ai = parse_shallow(buf.slice(ptr[0], ptr[0] + len));
        ptr[0] += len;
        var res = {
            id: varint_to_i32(ai[1][0].data),
            messages: []
        };
        ai[2].forEach(function(b) {
            var mi = parse_shallow(b.data);
            var fl = varint_to_i32(mi[3][0].data);
            res.messages.push({
                meta: mi,
                data: buf.slice(ptr[0], ptr[0] + fl)
            });
            ptr[0] += fl;
        });
        if ((_a = ai[3]) == null ? void 0 : _a[0]) res.merge = varint_to_i32(ai[3][0].data) >>> 0 > 0;
        out.push(res);
    }
    return out;
}
function write_iwa_file(ias) {
    var bufs = [];
    ias.forEach(function(ia) {
        var ai = [];
        ai[1] = [
            {
                data: write_varint49(ia.id),
                type: 0
            }
        ];
        ai[2] = [];
        if (ia.merge != null) ai[3] = [
            {
                data: write_varint49(+!!ia.merge),
                type: 0
            }
        ];
        var midata = [];
        ia.messages.forEach(function(mi) {
            midata.push(mi.data);
            mi.meta[3] = [
                {
                    type: 0,
                    data: write_varint49(mi.data.length)
                }
            ];
            ai[2].push({
                data: write_shallow(mi.meta),
                type: 2
            });
        });
        var aipayload = write_shallow(ai);
        bufs.push(write_varint49(aipayload.length));
        bufs.push(aipayload);
        midata.forEach(function(mid) {
            return bufs.push(mid);
        });
    });
    return u8concat(bufs);
}
function parse_snappy_chunk(type, buf) {
    if (type != 0) throw new Error("Unexpected Snappy chunk type ".concat(type));
    var ptr = [
        0
    ];
    var usz = parse_varint49(buf, ptr);
    var chunks = [];
    while(ptr[0] < buf.length){
        var tag = buf[ptr[0]] & 3;
        if (tag == 0) {
            var len = buf[ptr[0]++] >> 2;
            if (len < 60) ++len;
            else {
                var c = len - 59;
                len = buf[ptr[0]];
                if (c > 1) len |= buf[ptr[0] + 1] << 8;
                if (c > 2) len |= buf[ptr[0] + 2] << 16;
                if (c > 3) len |= buf[ptr[0] + 3] << 24;
                len >>>= 0;
                len++;
                ptr[0] += c;
            }
            chunks.push(buf.slice(ptr[0], ptr[0] + len));
            ptr[0] += len;
            continue;
        } else {
            var offset = 0, length = 0;
            if (tag == 1) {
                length = (buf[ptr[0]] >> 2 & 7) + 4;
                offset = (buf[ptr[0]++] & 224) << 3;
                offset |= buf[ptr[0]++];
            } else {
                length = (buf[ptr[0]++] >> 2) + 1;
                if (tag == 2) {
                    offset = buf[ptr[0]] | buf[ptr[0] + 1] << 8;
                    ptr[0] += 2;
                } else {
                    offset = (buf[ptr[0]] | buf[ptr[0] + 1] << 8 | buf[ptr[0] + 2] << 16 | buf[ptr[0] + 3] << 24) >>> 0;
                    ptr[0] += 4;
                }
            }
            chunks = [
                u8concat(chunks)
            ];
            if (offset == 0) throw new Error("Invalid offset 0");
            if (offset > chunks[0].length) throw new Error("Invalid offset beyond length");
            if (length >= offset) {
                chunks.push(chunks[0].slice(-offset));
                length -= offset;
                while(length >= chunks[chunks.length - 1].length){
                    chunks.push(chunks[chunks.length - 1]);
                    length -= chunks[chunks.length - 1].length;
                }
            }
            chunks.push(chunks[0].slice(-offset, -offset + length));
        }
    }
    var o = u8concat(chunks);
    if (o.length != usz) throw new Error("Unexpected length: ".concat(o.length, " != ").concat(usz));
    return o;
}
function decompress_iwa_file(buf) {
    var out = [];
    var l = 0;
    while(l < buf.length){
        var t = buf[l++];
        var len = buf[l] | buf[l + 1] << 8 | buf[l + 2] << 16;
        l += 3;
        out.push(parse_snappy_chunk(t, buf.slice(l, l + len)));
        l += len;
    }
    if (l !== buf.length) throw new Error("data is not a valid framed stream!");
    return u8concat(out);
}
function compress_iwa_file(buf) {
    var out = [];
    var l = 0;
    while(l < buf.length){
        var c = Math.min(buf.length - l, 268435455);
        var frame = new Uint8Array(4);
        out.push(frame);
        var usz = write_varint49(c);
        var L = usz.length;
        out.push(usz);
        if (c <= 60) {
            L++;
            out.push(new Uint8Array([
                c - 1 << 2
            ]));
        } else if (c <= 256) {
            L += 2;
            out.push(new Uint8Array([
                240,
                c - 1 & 255
            ]));
        } else if (c <= 65536) {
            L += 3;
            out.push(new Uint8Array([
                244,
                c - 1 & 255,
                c - 1 >> 8 & 255
            ]));
        } else if (c <= 16777216) {
            L += 4;
            out.push(new Uint8Array([
                248,
                c - 1 & 255,
                c - 1 >> 8 & 255,
                c - 1 >> 16 & 255
            ]));
        } else if (c <= 4294967296) {
            L += 5;
            out.push(new Uint8Array([
                252,
                c - 1 & 255,
                c - 1 >> 8 & 255,
                c - 1 >> 16 & 255,
                c - 1 >>> 24 & 255
            ]));
        }
        out.push(buf.slice(l, l + c));
        L += c;
        frame[0] = 0;
        frame[1] = L & 255;
        frame[2] = L >> 8 & 255;
        frame[3] = L >> 16 & 255;
        l += c;
    }
    return u8concat(out);
}
function parse_old_storage(buf, sst, rsst, v) {
    var dv = u8_to_dataview(buf);
    var flags = dv.getUint32(4, true);
    var data_offset = (v > 1 ? 12 : 8) + popcnt(flags & (v > 1 ? 3470 : 398)) * 4;
    var ridx = -1, sidx = -1, ieee = NaN, dt = new Date(2001, 0, 1);
    if (flags & 512) {
        ridx = dv.getUint32(data_offset, true);
        data_offset += 4;
    }
    data_offset += popcnt(flags & (v > 1 ? 12288 : 4096)) * 4;
    if (flags & 16) {
        sidx = dv.getUint32(data_offset, true);
        data_offset += 4;
    }
    if (flags & 32) {
        ieee = dv.getFloat64(data_offset, true);
        data_offset += 8;
    }
    if (flags & 64) {
        dt.setTime(dt.getTime() + dv.getFloat64(data_offset, true) * 1e3);
        data_offset += 8;
    }
    var ret;
    switch(buf[2]){
        case 0:
            break;
        case 2:
            ret = {
                t: "n",
                v: ieee
            };
            break;
        case 3:
            ret = {
                t: "s",
                v: sst[sidx]
            };
            break;
        case 5:
            ret = {
                t: "d",
                v: dt
            };
            break;
        case 6:
            ret = {
                t: "b",
                v: ieee > 0
            };
            break;
        case 7:
            ret = {
                t: "n",
                v: ieee / 86400
            };
            break;
        case 8:
            ret = {
                t: "e",
                v: 0
            };
            break;
        case 9:
            if (ridx > -1) ret = {
                t: "s",
                v: rsst[ridx]
            };
            else if (sidx > -1) ret = {
                t: "s",
                v: sst[sidx]
            };
            else if (!isNaN(ieee)) ret = {
                t: "n",
                v: ieee
            };
            else throw new Error("Unsupported cell type ".concat(buf.slice(0, 4)));
            break;
        default:
            throw new Error("Unsupported cell type ".concat(buf.slice(0, 4)));
    }
    return ret;
}
function parse_new_storage(buf, sst, rsst) {
    var dv = u8_to_dataview(buf);
    var flags = dv.getUint32(8, true);
    var data_offset = 12;
    var ridx = -1, sidx = -1, d128 = NaN, ieee = NaN, dt = new Date(2001, 0, 1);
    if (flags & 1) {
        d128 = readDecimal128LE(buf, data_offset);
        data_offset += 16;
    }
    if (flags & 2) {
        ieee = dv.getFloat64(data_offset, true);
        data_offset += 8;
    }
    if (flags & 4) {
        dt.setTime(dt.getTime() + dv.getFloat64(data_offset, true) * 1e3);
        data_offset += 8;
    }
    if (flags & 8) {
        sidx = dv.getUint32(data_offset, true);
        data_offset += 4;
    }
    if (flags & 16) {
        ridx = dv.getUint32(data_offset, true);
        data_offset += 4;
    }
    var ret;
    switch(buf[1]){
        case 0:
            break;
        case 2:
            ret = {
                t: "n",
                v: d128
            };
            break;
        case 3:
            ret = {
                t: "s",
                v: sst[sidx]
            };
            break;
        case 5:
            ret = {
                t: "d",
                v: dt
            };
            break;
        case 6:
            ret = {
                t: "b",
                v: ieee > 0
            };
            break;
        case 7:
            ret = {
                t: "n",
                v: ieee / 86400
            };
            break;
        case 8:
            ret = {
                t: "e",
                v: 0
            };
            break;
        case 9:
            if (ridx > -1) ret = {
                t: "s",
                v: rsst[ridx]
            };
            else throw new Error("Unsupported cell type ".concat(buf[1], " : ").concat(flags & 31, " : ").concat(buf.slice(0, 4)));
            break;
        case 10:
            ret = {
                t: "n",
                v: d128
            };
            break;
        default:
            throw new Error("Unsupported cell type ".concat(buf[1], " : ").concat(flags & 31, " : ").concat(buf.slice(0, 4)));
    }
    return ret;
}
function write_new_storage(cell, sst) {
    var out = new Uint8Array(32), dv = u8_to_dataview(out), l = 12, flags = 0;
    out[0] = 5;
    switch(cell.t){
        case "n":
            out[1] = 2;
            writeDecimal128LE(out, l, cell.v);
            flags |= 1;
            l += 16;
            break;
        case "b":
            out[1] = 6;
            dv.setFloat64(l, cell.v ? 1 : 0, true);
            flags |= 2;
            l += 8;
            break;
        case "s":
            if (sst.indexOf(cell.v) == -1) throw new Error("Value ".concat(cell.v, " missing from SST!"));
            out[1] = 3;
            dv.setUint32(l, sst.indexOf(cell.v), true);
            flags |= 8;
            l += 4;
            break;
        default:
            throw "unsupported cell type " + cell.t;
    }
    dv.setUint32(8, flags, true);
    return out.slice(0, l);
}
function write_old_storage(cell, sst) {
    var out = new Uint8Array(32), dv = u8_to_dataview(out), l = 12, flags = 0;
    out[0] = 3;
    switch(cell.t){
        case "n":
            out[2] = 2;
            dv.setFloat64(l, cell.v, true);
            flags |= 32;
            l += 8;
            break;
        case "b":
            out[2] = 6;
            dv.setFloat64(l, cell.v ? 1 : 0, true);
            flags |= 32;
            l += 8;
            break;
        case "s":
            if (sst.indexOf(cell.v) == -1) throw new Error("Value ".concat(cell.v, " missing from SST!"));
            out[2] = 3;
            dv.setUint32(l, sst.indexOf(cell.v), true);
            flags |= 16;
            l += 4;
            break;
        default:
            throw "unsupported cell type " + cell.t;
    }
    dv.setUint32(4, flags, true);
    return out.slice(0, l);
}
function parse_cell_storage(buf, sst, rsst) {
    switch(buf[0]){
        case 0:
        case 1:
        case 2:
        case 3:
            return parse_old_storage(buf, sst, rsst, buf[0]);
        case 5:
            return parse_new_storage(buf, sst, rsst);
        default:
            throw new Error("Unsupported payload version ".concat(buf[0]));
    }
}
function parse_TSP_Reference(buf) {
    var pb = parse_shallow(buf);
    return parse_varint49(pb[1][0].data);
}
function write_TSP_Reference(idx) {
    var out = [];
    out[1] = [
        {
            type: 0,
            data: write_varint49(idx)
        }
    ];
    return write_shallow(out);
}
function parse_TST_TableDataList(M, root) {
    var pb = parse_shallow(root.data);
    var type = varint_to_i32(pb[1][0].data);
    var entries = pb[3];
    var data = [];
    (entries || []).forEach(function(entry) {
        var le = parse_shallow(entry.data);
        var key = varint_to_i32(le[1][0].data) >>> 0;
        switch(type){
            case 1:
                data[key] = u8str(le[3][0].data);
                break;
            case 8:
                var rt = M[parse_TSP_Reference(le[9][0].data)][0];
                var rtp = parse_shallow(rt.data);
                var rtpref = M[parse_TSP_Reference(rtp[1][0].data)][0];
                var mtype = varint_to_i32(rtpref.meta[1][0].data);
                if (mtype != 2001) throw new Error("2000 unexpected reference to ".concat(mtype));
                var tswpsa = parse_shallow(rtpref.data);
                data[key] = tswpsa[3].map(function(x) {
                    return u8str(x.data);
                }).join("");
                break;
        }
    });
    return data;
}
function parse_TST_TileRowInfo(u8, type) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l, _m, _n;
    var pb = parse_shallow(u8);
    var R = varint_to_i32(pb[1][0].data) >>> 0;
    var cnt = varint_to_i32(pb[2][0].data) >>> 0;
    var wide_offsets = ((_b = (_a = pb[8]) == null ? void 0 : _a[0]) == null ? void 0 : _b.data) && varint_to_i32(pb[8][0].data) > 0 || false;
    var used_storage_u8, used_storage;
    if (((_d = (_c = pb[7]) == null ? void 0 : _c[0]) == null ? void 0 : _d.data) && type != 0) {
        used_storage_u8 = (_f = (_e = pb[7]) == null ? void 0 : _e[0]) == null ? void 0 : _f.data;
        used_storage = (_h = (_g = pb[6]) == null ? void 0 : _g[0]) == null ? void 0 : _h.data;
    } else if (((_j = (_i = pb[4]) == null ? void 0 : _i[0]) == null ? void 0 : _j.data) && type != 1) {
        used_storage_u8 = (_l = (_k = pb[4]) == null ? void 0 : _k[0]) == null ? void 0 : _l.data;
        used_storage = (_n = (_m = pb[3]) == null ? void 0 : _m[0]) == null ? void 0 : _n.data;
    } else throw "NUMBERS Tile missing ".concat(type, " cell storage");
    var width = wide_offsets ? 4 : 1;
    var used_storage_offsets = u8_to_dataview(used_storage_u8);
    var offsets = [];
    for(var C = 0; C < used_storage_u8.length / 2; ++C){
        var off = used_storage_offsets.getUint16(C * 2, true);
        if (off < 65535) offsets.push([
            C,
            off
        ]);
    }
    if (offsets.length != cnt) throw "Expected ".concat(cnt, " cells, found ").concat(offsets.length);
    var cells = [];
    for(C = 0; C < offsets.length - 1; ++C)cells[offsets[C][0]] = used_storage.subarray(offsets[C][1] * width, offsets[C + 1][1] * width);
    if (offsets.length >= 1) cells[offsets[offsets.length - 1][0]] = used_storage.subarray(offsets[offsets.length - 1][1] * width);
    return {
        R: R,
        cells: cells
    };
}
function parse_TST_Tile(M, root) {
    var _a;
    var pb = parse_shallow(root.data);
    var storage = ((_a = pb == null ? void 0 : pb[7]) == null ? void 0 : _a[0]) ? varint_to_i32(pb[7][0].data) >>> 0 > 0 ? 1 : 0 : -1;
    var ri = mappa(pb[5], function(u8) {
        return parse_TST_TileRowInfo(u8, storage);
    });
    return {
        nrows: varint_to_i32(pb[4][0].data) >>> 0,
        data: ri.reduce(function(acc, x) {
            if (!acc[x.R]) acc[x.R] = [];
            x.cells.forEach(function(cell, C) {
                if (acc[x.R][C]) throw new Error("Duplicate cell r=".concat(x.R, " c=").concat(C));
                acc[x.R][C] = cell;
            });
            return acc;
        }, [])
    };
}
function parse_TST_TableModelArchive(M, root, ws) {
    var _a;
    var pb = parse_shallow(root.data);
    var range = {
        s: {
            r: 0,
            c: 0
        },
        e: {
            r: 0,
            c: 0
        }
    };
    range.e.r = (varint_to_i32(pb[6][0].data) >>> 0) - 1;
    if (range.e.r < 0) throw new Error("Invalid row varint ".concat(pb[6][0].data));
    range.e.c = (varint_to_i32(pb[7][0].data) >>> 0) - 1;
    if (range.e.c < 0) throw new Error("Invalid col varint ".concat(pb[7][0].data));
    ws["!ref"] = encode_range(range);
    var store = parse_shallow(pb[4][0].data);
    var sst = parse_TST_TableDataList(M, M[parse_TSP_Reference(store[4][0].data)][0]);
    var rsst = ((_a = store[17]) == null ? void 0 : _a[0]) ? parse_TST_TableDataList(M, M[parse_TSP_Reference(store[17][0].data)][0]) : [];
    var tile = parse_shallow(store[3][0].data);
    var _R = 0;
    tile[1].forEach(function(t) {
        var tl = parse_shallow(t.data);
        var ref = M[parse_TSP_Reference(tl[2][0].data)][0];
        var mtype = varint_to_i32(ref.meta[1][0].data);
        if (mtype != 6002) throw new Error("6001 unexpected reference to ".concat(mtype));
        var _tile = parse_TST_Tile(M, ref);
        _tile.data.forEach(function(row, R) {
            row.forEach(function(buf, C) {
                var addr = encode_cell({
                    r: _R + R,
                    c: C
                });
                var res = parse_cell_storage(buf, sst, rsst);
                if (res) ws[addr] = res;
            });
        });
        _R += _tile.nrows;
    });
}
function parse_TST_TableInfoArchive(M, root) {
    var pb = parse_shallow(root.data);
    var out = {
        "!ref": "A1"
    };
    var tableref = M[parse_TSP_Reference(pb[2][0].data)];
    var mtype = varint_to_i32(tableref[0].meta[1][0].data);
    if (mtype != 6001) throw new Error("6000 unexpected reference to ".concat(mtype));
    parse_TST_TableModelArchive(M, tableref[0], out);
    return out;
}
function parse_TN_SheetArchive(M, root) {
    var _a;
    var pb = parse_shallow(root.data);
    var out = {
        name: ((_a = pb[1]) == null ? void 0 : _a[0]) ? u8str(pb[1][0].data) : "",
        sheets: []
    };
    var shapeoffs = mappa(pb[2], parse_TSP_Reference);
    shapeoffs.forEach(function(off) {
        M[off].forEach(function(m) {
            var mtype = varint_to_i32(m.meta[1][0].data);
            if (mtype == 6e3) out.sheets.push(parse_TST_TableInfoArchive(M, m));
        });
    });
    return out;
}
function parse_TN_DocumentArchive(M, root) {
    var out = book_new();
    var pb = parse_shallow(root.data);
    var sheetoffs = mappa(pb[1], parse_TSP_Reference);
    sheetoffs.forEach(function(off) {
        M[off].forEach(function(m) {
            var mtype = varint_to_i32(m.meta[1][0].data);
            if (mtype == 2) {
                var root2 = parse_TN_SheetArchive(M, m);
                root2.sheets.forEach(function(sheet, idx) {
                    book_append_sheet(out, sheet, idx == 0 ? root2.name : root2.name + "_" + idx, true);
                });
            }
        });
    });
    if (out.SheetNames.length == 0) throw new Error("Empty NUMBERS file");
    return out;
}
function parse_numbers_iwa(cfb) {
    var _a, _b, _c, _d;
    var M = {}, indices = [];
    cfb.FullPaths.forEach(function(p) {
        if (p.match(/\.iwpv2/)) throw new Error("Unsupported password protection");
    });
    cfb.FileIndex.forEach(function(s) {
        if (!s.name.match(/\.iwa$/)) return;
        var o;
        try {
            o = decompress_iwa_file(s.content);
        } catch (e) {
            return console.log("?? " + s.content.length + " " + (e.message || e));
        }
        var packets;
        try {
            packets = parse_iwa_file(o);
        } catch (e) {
            return console.log("## " + (e.message || e));
        }
        packets.forEach(function(packet) {
            M[packet.id] = packet.messages;
            indices.push(packet.id);
        });
    });
    if (!indices.length) throw new Error("File has no messages");
    var docroot = ((_d = (_c = (_b = (_a = M == null ? void 0 : M[1]) == null ? void 0 : _a[0]) == null ? void 0 : _b.meta) == null ? void 0 : _c[1]) == null ? void 0 : _d[0].data) && varint_to_i32(M[1][0].meta[1][0].data) == 1 && M[1][0];
    if (!docroot) indices.forEach(function(idx) {
        M[idx].forEach(function(iwam) {
            var mtype = varint_to_i32(iwam.meta[1][0].data) >>> 0;
            if (mtype == 1) {
                if (!docroot) docroot = iwam;
                else throw new Error("Document has multiple roots");
            }
        });
    });
    if (!docroot) throw new Error("Cannot find Document root");
    return parse_TN_DocumentArchive(M, docroot);
}
function write_tile_row(tri, data, SST) {
    var _a, _b, _c, _d;
    if (!((_a = tri[6]) == null ? void 0 : _a[0]) || !((_b = tri[7]) == null ? void 0 : _b[0])) throw "Mutation only works on post-BNC storages!";
    var wide_offsets = ((_d = (_c = tri[8]) == null ? void 0 : _c[0]) == null ? void 0 : _d.data) && varint_to_i32(tri[8][0].data) > 0 || false;
    if (wide_offsets) throw "Math only works with normal offsets";
    var cnt = 0;
    var dv = u8_to_dataview(tri[7][0].data), last_offset = 0, cell_storage = [];
    var _dv = u8_to_dataview(tri[4][0].data), _last_offset = 0, _cell_storage = [];
    for(var C = 0; C < data.length; ++C){
        if (data[C] == null) {
            dv.setUint16(C * 2, 65535, true);
            _dv.setUint16(C * 2, 65535);
            continue;
        }
        dv.setUint16(C * 2, last_offset, true);
        _dv.setUint16(C * 2, _last_offset, true);
        var celload, _celload;
        switch(typeof data[C]){
            case "string":
                celload = write_new_storage({
                    t: "s",
                    v: data[C]
                }, SST);
                _celload = write_old_storage({
                    t: "s",
                    v: data[C]
                }, SST);
                break;
            case "number":
                celload = write_new_storage({
                    t: "n",
                    v: data[C]
                }, SST);
                _celload = write_old_storage({
                    t: "n",
                    v: data[C]
                }, SST);
                break;
            case "boolean":
                celload = write_new_storage({
                    t: "b",
                    v: data[C]
                }, SST);
                _celload = write_old_storage({
                    t: "b",
                    v: data[C]
                }, SST);
                break;
            default:
                throw new Error("Unsupported value " + data[C]);
        }
        cell_storage.push(celload);
        last_offset += celload.length;
        _cell_storage.push(_celload);
        _last_offset += _celload.length;
        ++cnt;
    }
    tri[2][0].data = write_varint49(cnt);
    for(; C < tri[7][0].data.length / 2; ++C){
        dv.setUint16(C * 2, 65535, true);
        _dv.setUint16(C * 2, 65535, true);
    }
    tri[6][0].data = u8concat(cell_storage);
    tri[3][0].data = u8concat(_cell_storage);
    return cnt;
}
function write_numbers_iwa(wb, opts) {
    if (!opts || !opts.numbers) throw new Error("Must pass a `numbers` option -- check the README");
    var ws = wb.Sheets[wb.SheetNames[0]];
    if (wb.SheetNames.length > 1) console.error("The Numbers writer currently writes only the first table");
    var range = decode_range(ws["!ref"]);
    range.s.r = range.s.c = 0;
    var trunc = false;
    if (range.e.c > 9) {
        trunc = true;
        range.e.c = 9;
    }
    if (range.e.r > 49) {
        trunc = true;
        range.e.r = 49;
    }
    if (trunc) console.error("The Numbers writer is currently limited to ".concat(encode_range(range)));
    var data = sheet_to_json(ws, {
        range: range,
        header: 1
    });
    var SST = [
        "~Sh33tJ5~"
    ];
    data.forEach(function(row) {
        return row.forEach(function(cell) {
            if (typeof cell == "string") SST.push(cell);
        });
    });
    var dependents = {};
    var indices = [];
    var cfb = CFB.read(opts.numbers, {
        type: "base64"
    });
    cfb.FileIndex.map(function(fi, idx) {
        return [
            fi,
            cfb.FullPaths[idx]
        ];
    }).forEach(function(row) {
        var fi = row[0], fp = row[1];
        if (fi.type != 2) return;
        if (!fi.name.match(/\.iwa/)) return;
        var old_content = fi.content;
        var raw1 = decompress_iwa_file(old_content);
        var x2 = parse_iwa_file(raw1);
        x2.forEach(function(packet2) {
            indices.push(packet2.id);
            dependents[packet2.id] = {
                deps: [],
                location: fp,
                type: varint_to_i32(packet2.messages[0].meta[1][0].data)
            };
        });
    });
    indices.sort(function(x2, y2) {
        return x2 - y2;
    });
    var indices_varint = indices.filter(function(x2) {
        return x2 > 1;
    }).map(function(x2) {
        return [
            x2,
            write_varint49(x2)
        ];
    });
    cfb.FileIndex.map(function(fi, idx) {
        return [
            fi,
            cfb.FullPaths[idx]
        ];
    }).forEach(function(row) {
        var fi = row[0], fp = row[1];
        if (!fi.name.match(/\.iwa/)) return;
        var x2 = parse_iwa_file(decompress_iwa_file(fi.content));
        x2.forEach(function(ia) {
            ia.messages.forEach(function(m) {
                indices_varint.forEach(function(ivi) {
                    if (ia.messages.some(function(mess) {
                        return varint_to_i32(mess.meta[1][0].data) != 11006 && u8contains(mess.data, ivi[1]);
                    })) dependents[ivi[0]].deps.push(ia.id);
                });
            });
        });
    });
    function get_unique_msgid() {
        for(var i = 927262; i < 2e6; ++i)if (!dependents[i]) return i;
        throw new Error("Too many messages");
    }
    var entry = CFB.find(cfb, dependents[1].location);
    var x = parse_iwa_file(decompress_iwa_file(entry.content));
    var docroot;
    for(var xi = 0; xi < x.length; ++xi){
        var packet = x[xi];
        if (packet.id == 1) docroot = packet;
    }
    var sheetrootref = parse_TSP_Reference(parse_shallow(docroot.messages[0].data)[1][0].data);
    entry = CFB.find(cfb, dependents[sheetrootref].location);
    x = parse_iwa_file(decompress_iwa_file(entry.content));
    for(xi = 0; xi < x.length; ++xi){
        packet = x[xi];
        if (packet.id == sheetrootref) docroot = packet;
    }
    sheetrootref = parse_TSP_Reference(parse_shallow(docroot.messages[0].data)[2][0].data);
    entry = CFB.find(cfb, dependents[sheetrootref].location);
    x = parse_iwa_file(decompress_iwa_file(entry.content));
    for(xi = 0; xi < x.length; ++xi){
        packet = x[xi];
        if (packet.id == sheetrootref) docroot = packet;
    }
    sheetrootref = parse_TSP_Reference(parse_shallow(docroot.messages[0].data)[2][0].data);
    entry = CFB.find(cfb, dependents[sheetrootref].location);
    x = parse_iwa_file(decompress_iwa_file(entry.content));
    for(xi = 0; xi < x.length; ++xi){
        packet = x[xi];
        if (packet.id == sheetrootref) docroot = packet;
    }
    var pb = parse_shallow(docroot.messages[0].data);
    pb[6][0].data = write_varint49(range.e.r + 1);
    pb[7][0].data = write_varint49(range.e.c + 1);
    var cruidsref = parse_TSP_Reference(pb[46][0].data);
    var oldbucket = CFB.find(cfb, dependents[cruidsref].location);
    var _x = parse_iwa_file(decompress_iwa_file(oldbucket.content));
    for(var j = 0; j < _x.length; ++j){
        if (_x[j].id == cruidsref) break;
    }
    if (_x[j].id != cruidsref) throw "Bad ColumnRowUIDMapArchive";
    var cruids = parse_shallow(_x[j].messages[0].data);
    cruids[1] = [];
    cruids[2] = [], cruids[3] = [];
    for(var C = 0; C <= range.e.c; ++C){
        var uuid = [];
        uuid[1] = uuid[2] = [
            {
                type: 0,
                data: write_varint49(C + 420690)
            }
        ];
        cruids[1].push({
            type: 2,
            data: write_shallow(uuid)
        });
        cruids[2].push({
            type: 0,
            data: write_varint49(C)
        });
        cruids[3].push({
            type: 0,
            data: write_varint49(C)
        });
    }
    cruids[4] = [];
    cruids[5] = [], cruids[6] = [];
    for(var R = 0; R <= range.e.r; ++R){
        uuid = [];
        uuid[1] = uuid[2] = [
            {
                type: 0,
                data: write_varint49(R + 726270)
            }
        ];
        cruids[4].push({
            type: 2,
            data: write_shallow(uuid)
        });
        cruids[5].push({
            type: 0,
            data: write_varint49(R)
        });
        cruids[6].push({
            type: 0,
            data: write_varint49(R)
        });
    }
    _x[j].messages[0].data = write_shallow(cruids);
    oldbucket.content = compress_iwa_file(write_iwa_file(_x));
    oldbucket.size = oldbucket.content.length;
    delete pb[46];
    var store = parse_shallow(pb[4][0].data);
    store[7][0].data = write_varint49(range.e.r + 1);
    var row_headers = parse_shallow(store[1][0].data);
    var row_header_ref = parse_TSP_Reference(row_headers[2][0].data);
    oldbucket = CFB.find(cfb, dependents[row_header_ref].location);
    _x = parse_iwa_file(decompress_iwa_file(oldbucket.content));
    if (_x[0].id != row_header_ref) throw "Bad HeaderStorageBucket";
    var base_bucket = parse_shallow(_x[0].messages[0].data);
    for(R = 0; R < data.length; ++R){
        var _bucket = parse_shallow(base_bucket[2][0].data);
        _bucket[1][0].data = write_varint49(R);
        _bucket[4][0].data = write_varint49(data[R].length);
        base_bucket[2][R] = {
            type: base_bucket[2][0].type,
            data: write_shallow(_bucket)
        };
    }
    _x[0].messages[0].data = write_shallow(base_bucket);
    oldbucket.content = compress_iwa_file(write_iwa_file(_x));
    oldbucket.size = oldbucket.content.length;
    var col_header_ref = parse_TSP_Reference(store[2][0].data);
    oldbucket = CFB.find(cfb, dependents[col_header_ref].location);
    _x = parse_iwa_file(decompress_iwa_file(oldbucket.content));
    if (_x[0].id != col_header_ref) throw "Bad HeaderStorageBucket";
    base_bucket = parse_shallow(_x[0].messages[0].data);
    for(C = 0; C <= range.e.c; ++C){
        _bucket = parse_shallow(base_bucket[2][0].data);
        _bucket[1][0].data = write_varint49(C);
        _bucket[4][0].data = write_varint49(range.e.r + 1);
        base_bucket[2][C] = {
            type: base_bucket[2][0].type,
            data: write_shallow(_bucket)
        };
    }
    _x[0].messages[0].data = write_shallow(base_bucket);
    oldbucket.content = compress_iwa_file(write_iwa_file(_x));
    oldbucket.size = oldbucket.content.length;
    var sstref = parse_TSP_Reference(store[4][0].data);
    (function() {
        var sentry = CFB.find(cfb, dependents[sstref].location);
        var sx = parse_iwa_file(decompress_iwa_file(sentry.content));
        var sstroot;
        for(var sxi = 0; sxi < sx.length; ++sxi){
            var packet2 = sx[sxi];
            if (packet2.id == sstref) sstroot = packet2;
        }
        var sstdata = parse_shallow(sstroot.messages[0].data);
        sstdata[3] = [];
        var newsst = [];
        SST.forEach(function(str, i) {
            newsst[1] = [
                {
                    type: 0,
                    data: write_varint49(i)
                }
            ];
            newsst[2] = [
                {
                    type: 0,
                    data: write_varint49(1)
                }
            ];
            newsst[3] = [
                {
                    type: 2,
                    data: stru8(str)
                }
            ];
            sstdata[3].push({
                type: 2,
                data: write_shallow(newsst)
            });
        });
        sstroot.messages[0].data = write_shallow(sstdata);
        var sy = write_iwa_file(sx);
        var raw32 = compress_iwa_file(sy);
        sentry.content = raw32;
        sentry.size = sentry.content.length;
    })();
    var tile = parse_shallow(store[3][0].data);
    var t = tile[1][0];
    delete tile[2];
    var tl = parse_shallow(t.data);
    var tileref = parse_TSP_Reference(tl[2][0].data);
    (function() {
        var tentry = CFB.find(cfb, dependents[tileref].location);
        var tx = parse_iwa_file(decompress_iwa_file(tentry.content));
        var tileroot;
        for(var sxi = 0; sxi < tx.length; ++sxi){
            var packet2 = tx[sxi];
            if (packet2.id == tileref) tileroot = packet2;
        }
        var tiledata = parse_shallow(tileroot.messages[0].data);
        delete tiledata[6];
        delete tile[7];
        var rowload = new Uint8Array(tiledata[5][0].data);
        tiledata[5] = [];
        var cnt = 0;
        for(var R2 = 0; R2 <= range.e.r; ++R2){
            var tilerow = parse_shallow(rowload);
            cnt += write_tile_row(tilerow, data[R2], SST);
            tilerow[1][0].data = write_varint49(R2);
            tiledata[5].push({
                data: write_shallow(tilerow),
                type: 2
            });
        }
        tiledata[1] = [
            {
                type: 0,
                data: write_varint49(range.e.c + 1)
            }
        ];
        tiledata[2] = [
            {
                type: 0,
                data: write_varint49(range.e.r + 1)
            }
        ];
        tiledata[3] = [
            {
                type: 0,
                data: write_varint49(cnt)
            }
        ];
        tiledata[4] = [
            {
                type: 0,
                data: write_varint49(range.e.r + 1)
            }
        ];
        tileroot.messages[0].data = write_shallow(tiledata);
        var ty = write_iwa_file(tx);
        var raw32 = compress_iwa_file(ty);
        tentry.content = raw32;
        tentry.size = tentry.content.length;
    })();
    t.data = write_shallow(tl);
    store[3][0].data = write_shallow(tile);
    pb[4][0].data = write_shallow(store);
    docroot.messages[0].data = write_shallow(pb);
    var y = write_iwa_file(x);
    var raw3 = compress_iwa_file(y);
    entry.content = raw3;
    entry.size = entry.content.length;
    return cfb;
}
function fix_opts_func(defaults /*:Array<Array<any> >*/ ) /*:{(o:any):void}*/ {
    return function fix_opts(opts) {
        for(var i = 0; i != defaults.length; ++i){
            var d = defaults[i];
            if (opts[d[0]] === undefined) opts[d[0]] = d[1];
            if (d[2] === "n") opts[d[0]] = Number(opts[d[0]]);
        }
    };
}
function fix_read_opts(opts) {
    fix_opts_func([
        [
            "cellNF",
            false
        ],
        /* emit cell number format string as .z */ [
            "cellHTML",
            true
        ],
        /* emit html string as .h */ [
            "cellFormula",
            true
        ],
        /* emit formulae as .f */ [
            "cellStyles",
            false
        ],
        /* emits style/theme as .s */ [
            "cellText",
            true
        ],
        /* emit formatted text as .w */ [
            "cellDates",
            false
        ],
        /* emit date cells with type `d` */ [
            "sheetStubs",
            false
        ],
        /* emit empty cells */ [
            "sheetRows",
            0,
            "n"
        ],
        /* read n rows (0 = read all rows) */ [
            "bookDeps",
            false
        ],
        /* parse calculation chains */ [
            "bookSheets",
            false
        ],
        /* only try to get sheet names (no Sheets) */ [
            "bookProps",
            false
        ],
        /* only try to get properties (no Sheets) */ [
            "bookFiles",
            false
        ],
        /* include raw file structure (keys, files, cfb) */ [
            "bookVBA",
            false
        ],
        /* include vba raw data (vbaraw) */ [
            "password",
            ""
        ],
        /* password */ [
            "WTF",
            false
        ]
    ])(opts);
}
function fix_write_opts(opts) {
    fix_opts_func([
        [
            "cellDates",
            false
        ],
        /* write date cells with type `d` */ [
            "bookSST",
            false
        ],
        /* Generate Shared String Table */ [
            "bookType",
            "xlsx"
        ],
        /* Type of workbook (xlsx/m/b) */ [
            "compression",
            false
        ],
        /* Use file compression */ [
            "WTF",
            false
        ]
    ])(opts);
}
function get_sheet_type(n /*:string*/ ) /*:string*/ {
    if (RELS.WS.indexOf(n) > -1) return "sheet";
    if (RELS.CS && n == RELS.CS) return "chart";
    if (RELS.DS && n == RELS.DS) return "dialog";
    if (RELS.MS && n == RELS.MS) return "macro";
    return n && n.length ? n : "sheet";
}
function safe_parse_wbrels(wbrels, sheets) {
    if (!wbrels) return 0;
    try {
        wbrels = sheets.map(function pwbr(w) {
            if (!w.id) w.id = w.strRelID;
            return [
                w.name,
                wbrels["!id"][w.id].Target,
                get_sheet_type(wbrels["!id"][w.id].Type)
            ];
        });
    } catch (e) {
        return null;
    }
    return !wbrels || wbrels.length === 0 ? null : wbrels;
}
function safe_parse_sheet(zip, path /*:string*/ , relsPath /*:string*/ , sheet, idx /*:number*/ , sheetRels, sheets, stype /*:string*/ , opts, wb, themes, styles) {
    try {
        sheetRels[sheet] = parse_rels(getzipstr(zip, relsPath, true), path);
        var data = getzipdata(zip, path);
        var _ws;
        switch(stype){
            case "sheet":
                _ws = parse_ws(data, path, idx, opts, sheetRels[sheet], wb, themes, styles);
                break;
            case "chart":
                _ws = parse_cs(data, path, idx, opts, sheetRels[sheet], wb, themes, styles);
                if (!_ws || !_ws["!drawel"]) break;
                var dfile = resolve_path(_ws["!drawel"].Target, path);
                var drelsp = get_rels_path(dfile);
                var draw = parse_drawing(getzipstr(zip, dfile, true), parse_rels(getzipstr(zip, drelsp, true), dfile));
                var chartp = resolve_path(draw, dfile);
                var crelsp = get_rels_path(chartp);
                _ws = parse_chart(getzipstr(zip, chartp, true), chartp, opts, parse_rels(getzipstr(zip, crelsp, true), chartp), wb, _ws);
                break;
            case "macro":
                _ws = parse_ms(data, path, idx, opts, sheetRels[sheet], wb, themes, styles);
                break;
            case "dialog":
                _ws = parse_ds(data, path, idx, opts, sheetRels[sheet], wb, themes, styles);
                break;
            default:
                throw new Error("Unrecognized sheet type " + stype);
        }
        sheets[sheet] = _ws;
        /* scan rels for comments and threaded comments */ var tcomments = [];
        if (sheetRels && sheetRels[sheet]) keys(sheetRels[sheet]).forEach(function(n) {
            var dfile = "";
            if (sheetRels[sheet][n].Type == RELS.CMNT) {
                dfile = resolve_path(sheetRels[sheet][n].Target, path);
                var comments = parse_cmnt(getzipdata(zip, dfile, true), dfile, opts);
                if (!comments || !comments.length) return;
                sheet_insert_comments(_ws, comments, false);
            }
            if (sheetRels[sheet][n].Type == RELS.TCMNT) {
                dfile = resolve_path(sheetRels[sheet][n].Target, path);
                tcomments = tcomments.concat(parse_tcmnt_xml(getzipdata(zip, dfile, true), opts));
            }
        });
        if (tcomments && tcomments.length) sheet_insert_comments(_ws, tcomments, true, opts.people || []);
    } catch (e) {
        if (opts.WTF) throw e;
    }
}
function strip_front_slash(x /*:string*/ ) /*:string*/ {
    return x.charAt(0) == "/" ? x.slice(1) : x;
}
function parse_zip(zip /*:ZIP*/ , opts /*:?ParseOpts*/ ) /*:Workbook*/ {
    make_ssf();
    opts = opts || {};
    fix_read_opts(opts);
    /* OpenDocument Part 3 Section 2.2.1 OpenDocument Package */ if (safegetzipfile(zip, "META-INF/manifest.xml")) return parse_ods(zip, opts);
    /* UOC */ if (safegetzipfile(zip, "objectdata.xml")) return parse_ods(zip, opts);
    /* Numbers */ if (safegetzipfile(zip, "Index/Document.iwa")) {
        if (typeof Uint8Array == "undefined") throw new Error("NUMBERS file parsing requires Uint8Array support");
        if (typeof parse_numbers_iwa != "undefined") {
            if (zip.FileIndex) return parse_numbers_iwa(zip);
            var _zip = CFB.utils.cfb_new();
            zipentries(zip).forEach(function(e) {
                zip_add_file(_zip, e, getzipbin(zip, e));
            });
            return parse_numbers_iwa(_zip);
        }
        throw new Error("Unsupported NUMBERS file");
    }
    if (!safegetzipfile(zip, "[Content_Types].xml")) {
        if (safegetzipfile(zip, "index.xml.gz")) throw new Error("Unsupported NUMBERS 08 file");
        if (safegetzipfile(zip, "index.xml")) throw new Error("Unsupported NUMBERS 09 file");
        throw new Error("Unsupported ZIP file");
    }
    var entries = zipentries(zip);
    var dir = parse_ct(getzipstr(zip, "[Content_Types].xml"));
    var xlsb = false;
    var sheets, binname;
    if (dir.workbooks.length === 0) {
        binname = "xl/workbook.xml";
        if (getzipdata(zip, binname, true)) dir.workbooks.push(binname);
    }
    if (dir.workbooks.length === 0) {
        binname = "xl/workbook.bin";
        if (!getzipdata(zip, binname, true)) throw new Error("Could not find workbook");
        dir.workbooks.push(binname);
        xlsb = true;
    }
    if (dir.workbooks[0].slice(-3) == "bin") xlsb = true;
    var themes = {} /*:any*/ ;
    var styles = {} /*:any*/ ;
    if (!opts.bookSheets && !opts.bookProps) {
        strs = [];
        if (dir.sst) try {
            strs = parse_sst(getzipdata(zip, strip_front_slash(dir.sst)), dir.sst, opts);
        } catch (e) {
            if (opts.WTF) throw e;
        }
        if (opts.cellStyles && dir.themes.length) themes = parse_theme(getzipstr(zip, dir.themes[0].replace(/^\//, ""), true) || "", dir.themes[0], opts);
        if (dir.style) styles = parse_sty(getzipdata(zip, strip_front_slash(dir.style)), dir.style, themes, opts);
    }
    /*var externbooks = */ dir.links.map(function(link) {
        try {
            var rels = parse_rels(getzipstr(zip, get_rels_path(strip_front_slash(link))), link);
            return parse_xlink(getzipdata(zip, strip_front_slash(link)), rels, link, opts);
        } catch (e) {}
    });
    var wb = parse_wb(getzipdata(zip, strip_front_slash(dir.workbooks[0])), dir.workbooks[0], opts);
    var props = {}, propdata = "";
    if (dir.coreprops.length) {
        propdata = getzipdata(zip, strip_front_slash(dir.coreprops[0]), true);
        if (propdata) props = parse_core_props(propdata);
        if (dir.extprops.length !== 0) {
            propdata = getzipdata(zip, strip_front_slash(dir.extprops[0]), true);
            if (propdata) parse_ext_props(propdata, props, opts);
        }
    }
    var custprops = {};
    if (!opts.bookSheets || opts.bookProps) {
        if (dir.custprops.length !== 0) {
            propdata = getzipstr(zip, strip_front_slash(dir.custprops[0]), true);
            if (propdata) custprops = parse_cust_props(propdata, opts);
        }
    }
    var out = {} /*:any*/ ;
    if (opts.bookSheets || opts.bookProps) {
        if (wb.Sheets) sheets = wb.Sheets.map(function pluck(x) {
            return x.name;
        });
        else if (props.Worksheets && props.SheetNames.length > 0) sheets = props.SheetNames;
        if (opts.bookProps) {
            out.Props = props;
            out.Custprops = custprops;
        }
        if (opts.bookSheets && typeof sheets !== "undefined") out.SheetNames = sheets;
        if (opts.bookSheets ? out.SheetNames : opts.bookProps) return out;
    }
    sheets = {};
    var deps = {};
    if (opts.bookDeps && dir.calcchain) deps = parse_cc(getzipdata(zip, strip_front_slash(dir.calcchain)), dir.calcchain, opts);
    var i = 0;
    var sheetRels = {} /*:any*/ ;
    var path, relsPath;
    var wbsheets = wb.Sheets;
    props.Worksheets = wbsheets.length;
    props.SheetNames = [];
    for(var j = 0; j != wbsheets.length; ++j)props.SheetNames[j] = wbsheets[j].name;
    var wbext = xlsb ? "bin" : "xml";
    var wbrelsi = dir.workbooks[0].lastIndexOf("/");
    var wbrelsfile = (dir.workbooks[0].slice(0, wbrelsi + 1) + "_rels/" + dir.workbooks[0].slice(wbrelsi + 1) + ".rels").replace(/^\//, "");
    if (!safegetzipfile(zip, wbrelsfile)) wbrelsfile = "xl/_rels/workbook." + wbext + ".rels";
    var wbrels = parse_rels(getzipstr(zip, wbrelsfile, true), wbrelsfile.replace(/_rels.*/, "s5s"));
    if ((dir.metadata || []).length >= 1) /* TODO: MDX and other types of metadata */ opts.xlmeta = parse_xlmeta(getzipdata(zip, strip_front_slash(dir.metadata[0])), dir.metadata[0], opts);
    if ((dir.people || []).length >= 1) opts.people = parse_people_xml(getzipdata(zip, strip_front_slash(dir.people[0])), opts);
    if (wbrels) wbrels = safe_parse_wbrels(wbrels, wb.Sheets);
    /* Numbers iOS hack */ var nmode = getzipdata(zip, "xl/worksheets/sheet.xml", true) ? 1 : 0;
    wsloop: for(i = 0; i != props.Worksheets; ++i){
        var stype = "sheet";
        if (wbrels && wbrels[i]) {
            path = "xl/" + wbrels[i][1].replace(/[\/]?xl\//, "");
            if (!safegetzipfile(zip, path)) path = wbrels[i][1];
            if (!safegetzipfile(zip, path)) path = wbrelsfile.replace(/_rels\/.*$/, "") + wbrels[i][1];
            stype = wbrels[i][2];
        } else {
            path = "xl/worksheets/sheet" + (i + 1 - nmode) + "." + wbext;
            path = path.replace(/sheet0\./, "sheet.");
        }
        relsPath = path.replace(/^(.*)(\/)([^\/]*)$/, "$1/_rels/$3.rels");
        if (opts && opts.sheets != null) switch(typeof opts.sheets){
            case "number":
                if (i != opts.sheets) continue wsloop;
                break;
            case "string":
                if (props.SheetNames[i].toLowerCase() != opts.sheets.toLowerCase()) continue wsloop;
                break;
            default:
                if (Array.isArray && Array.isArray(opts.sheets)) {
                    var snjseen = false;
                    for(var snj = 0; snj != opts.sheets.length; ++snj){
                        if (typeof opts.sheets[snj] == "number" && opts.sheets[snj] == i) snjseen = 1;
                        if (typeof opts.sheets[snj] == "string" && opts.sheets[snj].toLowerCase() == props.SheetNames[i].toLowerCase()) snjseen = 1;
                    }
                    if (!snjseen) continue wsloop;
                }
        }
        safe_parse_sheet(zip, path, relsPath, props.SheetNames[i], i, sheetRels, sheets, stype, opts, wb, themes, styles);
    }
    out = {
        Directory: dir,
        Workbook: wb,
        Props: props,
        Custprops: custprops,
        Deps: deps,
        Sheets: sheets,
        SheetNames: props.SheetNames,
        Strings: strs,
        Styles: styles,
        Themes: themes,
        SSF: dup(table_fmt)
    } /*:any*/ ;
    if (opts && opts.bookFiles) {
        if (zip.files) {
            out.keys = entries;
            out.files = zip.files;
        } else {
            out.keys = [];
            out.files = {};
            zip.FullPaths.forEach(function(p, idx) {
                p = p.replace(/^Root Entry[\/]/, "");
                out.keys.push(p);
                out.files[p] = zip.FileIndex[idx];
            });
        }
    }
    if (opts && opts.bookVBA) {
        if (dir.vba.length > 0) out.vbaraw = getzipdata(zip, strip_front_slash(dir.vba[0]), true);
        else if (dir.defaults && dir.defaults.bin === CT_VBA) out.vbaraw = getzipdata(zip, "xl/vbaProject.bin", true);
    }
    return out;
}
/* [MS-OFFCRYPTO] 2.1.1 */ function parse_xlsxcfb(cfb, _opts /*:?ParseOpts*/ ) /*:Workbook*/ {
    var opts = _opts || {};
    var f = "Workbook", data = CFB.find(cfb, f);
    try {
        f = "/!DataSpaces/Version";
        data = CFB.find(cfb, f);
        if (!data || !data.content) throw new Error("ECMA-376 Encrypted file missing " + f);
        /*var version = */ parse_DataSpaceVersionInfo(data.content);
        /* 2.3.4.1 */ f = "/!DataSpaces/DataSpaceMap";
        data = CFB.find(cfb, f);
        if (!data || !data.content) throw new Error("ECMA-376 Encrypted file missing " + f);
        var dsm = parse_DataSpaceMap(data.content);
        if (dsm.length !== 1 || dsm[0].comps.length !== 1 || dsm[0].comps[0].t !== 0 || dsm[0].name !== "StrongEncryptionDataSpace" || dsm[0].comps[0].v !== "EncryptedPackage") throw new Error("ECMA-376 Encrypted file bad " + f);
        /* 2.3.4.2 */ f = "/!DataSpaces/DataSpaceInfo/StrongEncryptionDataSpace";
        data = CFB.find(cfb, f);
        if (!data || !data.content) throw new Error("ECMA-376 Encrypted file missing " + f);
        var seds = parse_DataSpaceDefinition(data.content);
        if (seds.length != 1 || seds[0] != "StrongEncryptionTransform") throw new Error("ECMA-376 Encrypted file bad " + f);
        /* 2.3.4.3 */ f = "/!DataSpaces/TransformInfo/StrongEncryptionTransform/!Primary";
        data = CFB.find(cfb, f);
        if (!data || !data.content) throw new Error("ECMA-376 Encrypted file missing " + f);
        /*var hdr = */ parse_Primary(data.content);
    } catch (e) {}
    f = "/EncryptionInfo";
    data = CFB.find(cfb, f);
    if (!data || !data.content) throw new Error("ECMA-376 Encrypted file missing " + f);
    var einfo = parse_EncryptionInfo(data.content);
    /* 2.3.4.4 */ f = "/EncryptedPackage";
    data = CFB.find(cfb, f);
    if (!data || !data.content) throw new Error("ECMA-376 Encrypted file missing " + f);
    /*global decrypt_agile */ /*:: declare var decrypt_agile:any; */ if (einfo[0] == 0x04 && typeof decrypt_agile !== "undefined") return decrypt_agile(einfo[1], data.content, opts.password || "", opts);
    /*global decrypt_std76 */ /*:: declare var decrypt_std76:any; */ if (einfo[0] == 0x02 && typeof decrypt_std76 !== "undefined") return decrypt_std76(einfo[1], data.content, opts.password || "", opts);
    throw new Error("File is password-protected");
}
function write_zip(wb /*:Workbook*/ , opts /*:WriteOpts*/ ) /*:ZIP*/ {
    if (opts.bookType == "ods") return write_ods(wb, opts);
    if (opts.bookType == "numbers") return write_numbers_iwa(wb, opts);
    if (opts.bookType == "xlsb") return write_zip_xlsxb(wb, opts);
    return write_zip_xlsx(wb, opts);
}
/* XLSX and XLSB writing are very similar.  Originally they were unified in one
   export function.  This is horrible for tree shaking in the common case (most
   applications need to export files in one format) so this function supports
   both formats while write_zip_xlsx only handles XLSX */ function write_zip_xlsxb(wb /*:Workbook*/ , opts /*:WriteOpts*/ ) /*:ZIP*/ {
    _shapeid = 1024;
    if (wb && !wb.SSF) wb.SSF = dup(table_fmt);
    if (wb && wb.SSF) {
        make_ssf();
        SSF_load_table(wb.SSF);
        // $FlowIgnore
        opts.revssf = evert_num(wb.SSF);
        opts.revssf[wb.SSF[65535]] = 0;
        opts.ssf = wb.SSF;
    }
    opts.rels = {};
    opts.wbrels = {};
    opts.Strings = /*::((*/ [] /*:: :any):SST)*/ ;
    opts.Strings.Count = 0;
    opts.Strings.Unique = 0;
    if (browser_has_Map) opts.revStrings = new Map();
    else {
        opts.revStrings = {};
        opts.revStrings.foo = [];
        delete opts.revStrings.foo;
    }
    var wbext = opts.bookType == "xlsb" ? "bin" : "xml";
    var vbafmt = VBAFMTS.indexOf(opts.bookType) > -1;
    var ct = new_ct();
    fix_write_opts(opts = opts || {});
    var zip = zip_new();
    var f = "", rId = 0;
    opts.cellXfs = [];
    get_cell_style(opts.cellXfs, {}, {
        revssf: {
            "General": 0
        }
    });
    if (!wb.Props) wb.Props = {};
    f = "docProps/core.xml";
    zip_add_file(zip, f, write_core_props(wb.Props, opts));
    ct.coreprops.push(f);
    add_rels(opts.rels, 2, f, RELS.CORE_PROPS);
    /*::if(!wb.Props) throw "unreachable"; */ f = "docProps/app.xml";
    if (wb.Props && wb.Props.SheetNames) ;
    else if (!wb.Workbook || !wb.Workbook.Sheets) wb.Props.SheetNames = wb.SheetNames;
    else {
        var _sn = [];
        for(var _i = 0; _i < wb.SheetNames.length; ++_i)if ((wb.Workbook.Sheets[_i] || {}).Hidden != 2) _sn.push(wb.SheetNames[_i]);
        wb.Props.SheetNames = _sn;
    }
    wb.Props.Worksheets = wb.Props.SheetNames.length;
    zip_add_file(zip, f, write_ext_props(wb.Props, opts));
    ct.extprops.push(f);
    add_rels(opts.rels, 3, f, RELS.EXT_PROPS);
    if (wb.Custprops !== wb.Props && keys(wb.Custprops || {}).length > 0) {
        f = "docProps/custom.xml";
        zip_add_file(zip, f, write_cust_props(wb.Custprops, opts));
        ct.custprops.push(f);
        add_rels(opts.rels, 4, f, RELS.CUST_PROPS);
    }
    for(rId = 1; rId <= wb.SheetNames.length; ++rId){
        var wsrels = {
            "!id": {}
        };
        var ws = wb.Sheets[wb.SheetNames[rId - 1]];
        var _type = (ws || {})["!type"] || "sheet";
        _type;
        f = "xl/worksheets/sheet" + rId + "." + wbext;
        zip_add_file(zip, f, write_ws(rId - 1, f, opts, wb, wsrels));
        ct.sheets.push(f);
        add_rels(opts.wbrels, -1, "worksheets/sheet" + rId + "." + wbext, RELS.WS[0]);
        if (ws) {
            var comments = ws["!comments"];
            var need_vml = false;
            var cf = "";
            if (comments && comments.length > 0) {
                cf = "xl/comments" + rId + "." + wbext;
                zip_add_file(zip, cf, write_cmnt(comments, cf, opts));
                ct.comments.push(cf);
                add_rels(wsrels, -1, "../comments" + rId + "." + wbext, RELS.CMNT);
                need_vml = true;
            }
            if (ws["!legacy"]) {
                if (need_vml) zip_add_file(zip, "xl/drawings/vmlDrawing" + rId + ".vml", write_comments_vml(rId, ws["!comments"]));
            }
            delete ws["!comments"];
            delete ws["!legacy"];
        }
        if (wsrels["!id"].rId1) zip_add_file(zip, get_rels_path(f), write_rels(wsrels));
    }
    if (opts.Strings != null && opts.Strings.length > 0) {
        f = "xl/sharedStrings." + wbext;
        zip_add_file(zip, f, write_sst(opts.Strings, f, opts));
        ct.strs.push(f);
        add_rels(opts.wbrels, -1, "sharedStrings." + wbext, RELS.SST);
    }
    f = "xl/workbook." + wbext;
    zip_add_file(zip, f, write_wb(wb, f, opts));
    ct.workbooks.push(f);
    add_rels(opts.rels, 1, f, RELS.WB);
    /* TODO: something more intelligent with themes */ f = "xl/theme/theme1.xml";
    zip_add_file(zip, f, write_theme(wb.Themes, opts));
    ct.themes.push(f);
    add_rels(opts.wbrels, -1, "theme/theme1.xml", RELS.THEME);
    /* TODO: something more intelligent with styles */ f = "xl/styles." + wbext;
    zip_add_file(zip, f, write_sty(wb, f, opts));
    ct.styles.push(f);
    add_rels(opts.wbrels, -1, "styles." + wbext, RELS.STY);
    if (wb.vbaraw && vbafmt) {
        f = "xl/vbaProject.bin";
        zip_add_file(zip, f, wb.vbaraw);
        ct.vba.push(f);
        add_rels(opts.wbrels, -1, "vbaProject.bin", RELS.VBA);
    }
    f = "xl/metadata." + wbext;
    zip_add_file(zip, f, write_xlmeta(f));
    ct.metadata.push(f);
    add_rels(opts.wbrels, -1, "metadata." + wbext, RELS.XLMETA);
    zip_add_file(zip, "[Content_Types].xml", write_ct(ct, opts));
    zip_add_file(zip, "_rels/.rels", write_rels(opts.rels));
    zip_add_file(zip, "xl/_rels/workbook." + wbext + ".rels", write_rels(opts.wbrels));
    delete opts.revssf;
    delete opts.ssf;
    return zip;
}
function write_zip_xlsx(wb /*:Workbook*/ , opts /*:WriteOpts*/ ) /*:ZIP*/ {
    _shapeid = 1024;
    if (wb && !wb.SSF) wb.SSF = dup(table_fmt);
    if (wb && wb.SSF) {
        make_ssf();
        SSF_load_table(wb.SSF);
        // $FlowIgnore
        opts.revssf = evert_num(wb.SSF);
        opts.revssf[wb.SSF[65535]] = 0;
        opts.ssf = wb.SSF;
    }
    opts.rels = {};
    opts.wbrels = {};
    opts.Strings = /*::((*/ [] /*:: :any):SST)*/ ;
    opts.Strings.Count = 0;
    opts.Strings.Unique = 0;
    if (browser_has_Map) opts.revStrings = new Map();
    else {
        opts.revStrings = {};
        opts.revStrings.foo = [];
        delete opts.revStrings.foo;
    }
    var wbext = "xml";
    var vbafmt = VBAFMTS.indexOf(opts.bookType) > -1;
    var ct = new_ct();
    fix_write_opts(opts = opts || {});
    var zip = zip_new();
    var f = "", rId = 0;
    opts.cellXfs = [];
    get_cell_style(opts.cellXfs, {}, {
        revssf: {
            "General": 0
        }
    });
    if (!wb.Props) wb.Props = {};
    f = "docProps/core.xml";
    zip_add_file(zip, f, write_core_props(wb.Props, opts));
    ct.coreprops.push(f);
    add_rels(opts.rels, 2, f, RELS.CORE_PROPS);
    /*::if(!wb.Props) throw "unreachable"; */ f = "docProps/app.xml";
    if (wb.Props && wb.Props.SheetNames) ;
    else if (!wb.Workbook || !wb.Workbook.Sheets) wb.Props.SheetNames = wb.SheetNames;
    else {
        var _sn = [];
        for(var _i = 0; _i < wb.SheetNames.length; ++_i)if ((wb.Workbook.Sheets[_i] || {}).Hidden != 2) _sn.push(wb.SheetNames[_i]);
        wb.Props.SheetNames = _sn;
    }
    wb.Props.Worksheets = wb.Props.SheetNames.length;
    zip_add_file(zip, f, write_ext_props(wb.Props, opts));
    ct.extprops.push(f);
    add_rels(opts.rels, 3, f, RELS.EXT_PROPS);
    if (wb.Custprops !== wb.Props && keys(wb.Custprops || {}).length > 0) {
        f = "docProps/custom.xml";
        zip_add_file(zip, f, write_cust_props(wb.Custprops, opts));
        ct.custprops.push(f);
        add_rels(opts.rels, 4, f, RELS.CUST_PROPS);
    }
    var people = [
        "SheetJ5"
    ];
    opts.tcid = 0;
    for(rId = 1; rId <= wb.SheetNames.length; ++rId){
        var wsrels = {
            "!id": {}
        };
        var ws = wb.Sheets[wb.SheetNames[rId - 1]];
        var _type = (ws || {})["!type"] || "sheet";
        _type;
        f = "xl/worksheets/sheet" + rId + "." + wbext;
        zip_add_file(zip, f, write_ws_xml(rId - 1, opts, wb, wsrels));
        ct.sheets.push(f);
        add_rels(opts.wbrels, -1, "worksheets/sheet" + rId + "." + wbext, RELS.WS[0]);
        if (ws) {
            var comments = ws["!comments"];
            var need_vml = false;
            var cf = "";
            if (comments && comments.length > 0) {
                var needtc = false;
                comments.forEach(function(carr) {
                    carr[1].forEach(function(c) {
                        if (c.T == true) needtc = true;
                    });
                });
                if (needtc) {
                    cf = "xl/threadedComments/threadedComment" + rId + "." + wbext;
                    zip_add_file(zip, cf, write_tcmnt_xml(comments, people, opts));
                    ct.threadedcomments.push(cf);
                    add_rels(wsrels, -1, "../threadedComments/threadedComment" + rId + "." + wbext, RELS.TCMNT);
                }
                cf = "xl/comments" + rId + "." + wbext;
                zip_add_file(zip, cf, write_comments_xml(comments, opts));
                ct.comments.push(cf);
                add_rels(wsrels, -1, "../comments" + rId + "." + wbext, RELS.CMNT);
                need_vml = true;
            }
            if (ws["!legacy"]) {
                if (need_vml) zip_add_file(zip, "xl/drawings/vmlDrawing" + rId + ".vml", write_comments_vml(rId, ws["!comments"]));
            }
            delete ws["!comments"];
            delete ws["!legacy"];
        }
        if (wsrels["!id"].rId1) zip_add_file(zip, get_rels_path(f), write_rels(wsrels));
    }
    if (opts.Strings != null && opts.Strings.length > 0) {
        f = "xl/sharedStrings." + wbext;
        zip_add_file(zip, f, write_sst_xml(opts.Strings, opts));
        ct.strs.push(f);
        add_rels(opts.wbrels, -1, "sharedStrings." + wbext, RELS.SST);
    }
    f = "xl/workbook." + wbext;
    zip_add_file(zip, f, write_wb_xml(wb, opts));
    ct.workbooks.push(f);
    add_rels(opts.rels, 1, f, RELS.WB);
    /* TODO: something more intelligent with themes */ f = "xl/theme/theme1.xml";
    zip_add_file(zip, f, write_theme(wb.Themes, opts));
    ct.themes.push(f);
    add_rels(opts.wbrels, -1, "theme/theme1.xml", RELS.THEME);
    /* TODO: something more intelligent with styles */ f = "xl/styles." + wbext;
    zip_add_file(zip, f, write_sty_xml(wb, opts));
    ct.styles.push(f);
    add_rels(opts.wbrels, -1, "styles." + wbext, RELS.STY);
    if (wb.vbaraw && vbafmt) {
        f = "xl/vbaProject.bin";
        zip_add_file(zip, f, wb.vbaraw);
        ct.vba.push(f);
        add_rels(opts.wbrels, -1, "vbaProject.bin", RELS.VBA);
    }
    f = "xl/metadata." + wbext;
    zip_add_file(zip, f, write_xlmeta_xml());
    ct.metadata.push(f);
    add_rels(opts.wbrels, -1, "metadata." + wbext, RELS.XLMETA);
    if (people.length > 1) {
        f = "xl/persons/person.xml";
        zip_add_file(zip, f, write_people_xml(people, opts));
        ct.people.push(f);
        add_rels(opts.wbrels, -1, "persons/person.xml", RELS.PEOPLE);
    }
    zip_add_file(zip, "[Content_Types].xml", write_ct(ct, opts));
    zip_add_file(zip, "_rels/.rels", write_rels(opts.rels));
    zip_add_file(zip, "xl/_rels/workbook." + wbext + ".rels", write_rels(opts.wbrels));
    delete opts.revssf;
    delete opts.ssf;
    return zip;
}
function firstbyte(f /*:RawData*/ , o /*:?TypeOpts*/ ) /*:Array<number>*/ {
    var x = "";
    switch((o || {}).type || "base64"){
        case "buffer":
            return [
                f[0],
                f[1],
                f[2],
                f[3],
                f[4],
                f[5],
                f[6],
                f[7]
            ];
        case "base64":
            x = Base64_decode(f.slice(0, 12));
            break;
        case "binary":
            x = f;
            break;
        case "array":
            return [
                f[0],
                f[1],
                f[2],
                f[3],
                f[4],
                f[5],
                f[6],
                f[7]
            ];
        default:
            throw new Error("Unrecognized type " + (o && o.type || "undefined"));
    }
    return [
        x.charCodeAt(0),
        x.charCodeAt(1),
        x.charCodeAt(2),
        x.charCodeAt(3),
        x.charCodeAt(4),
        x.charCodeAt(5),
        x.charCodeAt(6),
        x.charCodeAt(7)
    ];
}
function read_cfb(cfb /*:CFBContainer*/ , opts /*:?ParseOpts*/ ) /*:Workbook*/ {
    if (CFB.find(cfb, "EncryptedPackage")) return parse_xlsxcfb(cfb, opts);
    return parse_xlscfb(cfb, opts);
}
function read_zip(data /*:RawData*/ , opts /*:?ParseOpts*/ ) /*:Workbook*/ {
    var zip, d = data;
    var o = opts || {};
    if (!o.type) o.type = has_buf && Buffer.isBuffer(data) ? "buffer" : "base64";
    zip = zip_read(d, o);
    return parse_zip(zip, o);
}
function read_plaintext(data /*:string*/ , o /*:ParseOpts*/ ) /*:Workbook*/ {
    var i = 0;
    main: while(i < data.length)switch(data.charCodeAt(i)){
        case 0x0A:
        case 0x0D:
        case 0x20:
            ++i;
            break;
        case 0x3C:
            return parse_xlml(data.slice(i), o);
        default:
            break main;
    }
    return PRN.to_workbook(data, o);
}
function read_plaintext_raw(data /*:RawData*/ , o /*:ParseOpts*/ ) /*:Workbook*/ {
    var str = "", bytes = firstbyte(data, o);
    switch(o.type){
        case "base64":
            str = Base64_decode(data);
            break;
        case "binary":
            str = data;
            break;
        case "buffer":
            str = data.toString("binary");
            break;
        case "array":
            str = cc2str(data);
            break;
        default:
            throw new Error("Unrecognized type " + o.type);
    }
    if (bytes[0] == 0xEF && bytes[1] == 0xBB && bytes[2] == 0xBF) str = utf8read(str);
    o.type = "binary";
    return read_plaintext(str, o);
}
function read_utf16(data /*:RawData*/ , o /*:ParseOpts*/ ) /*:Workbook*/ {
    var d = data;
    if (o.type == "base64") d = Base64_decode(d);
    d = $cptable.utils.decode(1200, d.slice(2), "str");
    o.type = "binary";
    return read_plaintext(d, o);
}
function bstrify(data /*:string*/ ) /*:string*/ {
    return !data.match(/[^\x00-\x7F]/) ? data : utf8write(data);
}
function read_prn(data, d, o, str) {
    if (str) {
        o.type = "string";
        return PRN.to_workbook(data, o);
    }
    return PRN.to_workbook(d, o);
}
function readSync(data /*:RawData*/ , opts /*:?ParseOpts*/ ) /*:Workbook*/ {
    reset_cp();
    var o = opts || {};
    if (typeof ArrayBuffer !== "undefined" && data instanceof ArrayBuffer) return readSync(new Uint8Array(data), (o = dup(o), o.type = "array", o));
    if (typeof Uint8Array !== "undefined" && data instanceof Uint8Array && !o.type) o.type = typeof Deno !== "undefined" ? "buffer" : "array";
    var d = data, n = [
        0,
        0,
        0,
        0
    ], str = false;
    if (o.cellStyles) {
        o.cellNF = true;
        o.sheetStubs = true;
    }
    _ssfopts = {};
    if (o.dateNF) _ssfopts.dateNF = o.dateNF;
    if (!o.type) o.type = has_buf && Buffer.isBuffer(data) ? "buffer" : "base64";
    if (o.type == "file") {
        o.type = has_buf ? "buffer" : "binary";
        d = read_binary(data);
        if (typeof Uint8Array !== "undefined" && !has_buf) o.type = "array";
    }
    if (o.type == "string") {
        str = true;
        o.type = "binary";
        o.codepage = 65001;
        d = bstrify(data);
    }
    if (o.type == "array" && typeof Uint8Array !== "undefined" && data instanceof Uint8Array && typeof ArrayBuffer !== "undefined") {
        // $FlowIgnore
        var ab = new ArrayBuffer(3), vu = new Uint8Array(ab);
        vu.foo = "bar";
        // $FlowIgnore
        if (!vu.foo) {
            o = dup(o);
            o.type = "array";
            return readSync(ab2a(d), o);
        }
    }
    switch((n = firstbyte(d, o))[0]){
        case 0xD0:
            if (n[1] === 0xCF && n[2] === 0x11 && n[3] === 0xE0 && n[4] === 0xA1 && n[5] === 0xB1 && n[6] === 0x1A && n[7] === 0xE1) return read_cfb(CFB.read(d, o), o);
            break;
        case 0x09:
            if (n[1] <= 0x08) return parse_xlscfb(d, o);
            break;
        case 0x3C:
            return parse_xlml(d, o);
        case 0x49:
            if (n[1] === 0x49 && n[2] === 0x2a && n[3] === 0x00) throw new Error("TIFF Image File is not a spreadsheet");
            if (n[1] === 0x44) return read_wb_ID(d, o);
            break;
        case 0x54:
            if (n[1] === 0x41 && n[2] === 0x42 && n[3] === 0x4C) return DIF.to_workbook(d, o);
            break;
        case 0x50:
            return n[1] === 0x4B && n[2] < 0x09 && n[3] < 0x09 ? read_zip(d, o) : read_prn(data, d, o, str);
        case 0xEF:
            return n[3] === 0x3C ? parse_xlml(d, o) : read_prn(data, d, o, str);
        case 0xFF:
            if (n[1] === 0xFE) return read_utf16(d, o);
            else if (n[1] === 0x00 && n[2] === 0x02 && n[3] === 0x00) return WK_.to_workbook(d, o);
            break;
        case 0x00:
            if (n[1] === 0x00) {
                if (n[2] >= 0x02 && n[3] === 0x00) return WK_.to_workbook(d, o);
                if (n[2] === 0x00 && (n[3] === 0x08 || n[3] === 0x09)) return WK_.to_workbook(d, o);
            }
            break;
        case 0x03:
        case 0x83:
        case 0x8B:
        case 0x8C:
            return DBF.to_workbook(d, o);
        case 0x7B:
            if (n[1] === 0x5C && n[2] === 0x72 && n[3] === 0x74) return RTF.to_workbook(d, o);
            break;
        case 0x0A:
        case 0x0D:
        case 0x20:
            return read_plaintext_raw(d, o);
        case 0x89:
            if (n[1] === 0x50 && n[2] === 0x4E && n[3] === 0x47) throw new Error("PNG Image File is not a spreadsheet");
            break;
    }
    if (DBF_SUPPORTED_VERSIONS.indexOf(n[0]) > -1 && n[2] <= 12 && n[3] <= 31) return DBF.to_workbook(d, o);
    return read_prn(data, d, o, str);
}
function readFileSync(filename /*:string*/ , opts /*:?ParseOpts*/ ) /*:Workbook*/ {
    var o = opts || {};
    o.type = "file";
    return readSync(filename, o);
}
function write_cfb_ctr(cfb /*:CFBContainer*/ , o /*:WriteOpts*/ ) /*:any*/ {
    switch(o.type){
        case "base64":
        case "binary":
            break;
        case "buffer":
        case "array":
            o.type = "";
            break;
        case "file":
            return write_dl(o.file, CFB.write(cfb, {
                type: has_buf ? "buffer" : ""
            }));
        case "string":
            throw new Error("'string' output type invalid for '" + o.bookType + "' files");
        default:
            throw new Error("Unrecognized type " + o.type);
    }
    return CFB.write(cfb, o);
}
/*:: declare var encrypt_agile:any; */ function write_zip_type(wb /*:Workbook*/ , opts /*:?WriteOpts*/ ) /*:any*/ {
    var o = dup(opts || {});
    var z = write_zip(wb, o);
    return write_zip_denouement(z, o);
}
function write_zip_typeXLSX(wb /*:Workbook*/ , opts /*:?WriteOpts*/ ) /*:any*/ {
    var o = dup(opts || {});
    var z = write_zip_xlsx(wb, o);
    return write_zip_denouement(z, o);
}
function write_zip_denouement(z /*:any*/ , o /*:?WriteOpts*/ ) /*:any*/ {
    var oopts = {};
    var ftype = has_buf ? "nodebuffer" : typeof Uint8Array !== "undefined" ? "array" : "string";
    if (o.compression) oopts.compression = "DEFLATE";
    if (o.password) oopts.type = ftype;
    else switch(o.type){
        case "base64":
            oopts.type = "base64";
            break;
        case "binary":
            oopts.type = "string";
            break;
        case "string":
            throw new Error("'string' output type invalid for '" + o.bookType + "' files");
        case "buffer":
        case "file":
            oopts.type = ftype;
            break;
        default:
            throw new Error("Unrecognized type " + o.type);
    }
    var out = z.FullPaths ? CFB.write(z, {
        fileType: "zip",
        type: /*::(*/ {
            "nodebuffer": "buffer",
            "string": "binary"
        } /*:: :any)*/ [oopts.type] || oopts.type,
        compression: !!o.compression
    }) : z.generate(oopts);
    if (typeof Deno !== "undefined") {
        if (typeof out == "string") {
            if (o.type == "binary" || o.type == "base64") return out;
            out = new Uint8Array(s2ab(out));
        }
    }
    /*jshint -W083 */ if (o.password && typeof encrypt_agile !== "undefined") return write_cfb_ctr(encrypt_agile(out, o.password), o); // eslint-disable-line no-undef
    /*jshint +W083 */ if (o.type === "file") return write_dl(o.file, out);
    return o.type == "string" ? utf8read(/*::(*/ out /*:: :any)*/ ) : out;
}
function write_cfb_type(wb /*:Workbook*/ , opts /*:?WriteOpts*/ ) /*:any*/ {
    var o = opts || {};
    var cfb /*:CFBContainer*/  = write_xlscfb(wb, o);
    return write_cfb_ctr(cfb, o);
}
function write_string_type(out /*:string*/ , opts /*:WriteOpts*/ , bom /*:?string*/ ) /*:any*/ {
    if (!bom) bom = "";
    var o = bom + out;
    switch(opts.type){
        case "base64":
            return Base64_encode(utf8write(o));
        case "binary":
            return utf8write(o);
        case "string":
            return out;
        case "file":
            return write_dl(opts.file, o, "utf8");
        case "buffer":
            if (has_buf) return Buffer_from(o, "utf8");
            else if (typeof TextEncoder !== "undefined") return new TextEncoder().encode(o);
            else return write_string_type(o, {
                type: "binary"
            }).split("").map(function(c) {
                return c.charCodeAt(0);
            });
    }
    throw new Error("Unrecognized type " + opts.type);
}
function write_stxt_type(out /*:string*/ , opts /*:WriteOpts*/ ) /*:any*/ {
    switch(opts.type){
        case "base64":
            return Base64_encode(out);
        case "binary":
            return out;
        case "string":
            return out; /* override in sheet_to_txt */ 
        case "file":
            return write_dl(opts.file, out, "binary");
        case "buffer":
            if (has_buf) return Buffer_from(out, "binary");
            else return out.split("").map(function(c) {
                return c.charCodeAt(0);
            });
    }
    throw new Error("Unrecognized type " + opts.type);
}
/* TODO: test consistency */ function write_binary_type(out, opts /*:WriteOpts*/ ) /*:any*/ {
    switch(opts.type){
        case "string":
        case "base64":
        case "binary":
            var bstr = "";
            // $FlowIgnore
            for(var i = 0; i < out.length; ++i)bstr += String.fromCharCode(out[i]);
            return opts.type == "base64" ? Base64_encode(bstr) : opts.type == "string" ? utf8read(bstr) : bstr;
        case "file":
            return write_dl(opts.file, out);
        case "buffer":
            return out;
        default:
            throw new Error("Unrecognized type " + opts.type);
    }
}
function writeSyncXLSX(wb /*:Workbook*/ , opts /*:?WriteOpts*/ ) {
    reset_cp();
    check_wb(wb);
    var o = dup(opts || {});
    if (o.cellStyles) {
        o.cellNF = true;
        o.sheetStubs = true;
    }
    if (o.type == "array") {
        o.type = "binary";
        var out /*:string*/  = writeSyncXLSX(wb, o);
        o.type = "array";
        return s2ab(out);
    }
    return write_zip_typeXLSX(wb, o);
}
function writeSync(wb /*:Workbook*/ , opts /*:?WriteOpts*/ ) {
    reset_cp();
    check_wb(wb);
    var o = dup(opts || {});
    if (o.cellStyles) {
        o.cellNF = true;
        o.sheetStubs = true;
    }
    if (o.type == "array") {
        o.type = "binary";
        var out /*:string*/  = writeSync(wb, o);
        o.type = "array";
        return s2ab(out);
    }
    var idx = 0;
    if (o.sheet) {
        if (typeof o.sheet == "number") idx = o.sheet;
        else idx = wb.SheetNames.indexOf(o.sheet);
        if (!wb.SheetNames[idx]) throw new Error("Sheet not found: " + o.sheet + " : " + typeof o.sheet);
    }
    switch(o.bookType || "xlsb"){
        case "xml":
        case "xlml":
            return write_string_type(write_xlml(wb, o), o);
        case "slk":
        case "sylk":
            return write_string_type(SYLK.from_sheet(wb.Sheets[wb.SheetNames[idx]], o), o);
        case "htm":
        case "html":
            return write_string_type(sheet_to_html(wb.Sheets[wb.SheetNames[idx]], o), o);
        case "txt":
            return write_stxt_type(sheet_to_txt(wb.Sheets[wb.SheetNames[idx]], o), o);
        case "csv":
            return write_string_type(sheet_to_csv(wb.Sheets[wb.SheetNames[idx]], o), o, "\uFEFF");
        case "dif":
            return write_string_type(DIF.from_sheet(wb.Sheets[wb.SheetNames[idx]], o), o);
        case "dbf":
            return write_binary_type(DBF.from_sheet(wb.Sheets[wb.SheetNames[idx]], o), o);
        case "prn":
            return write_string_type(PRN.from_sheet(wb.Sheets[wb.SheetNames[idx]], o), o);
        case "rtf":
            return write_string_type(RTF.from_sheet(wb.Sheets[wb.SheetNames[idx]], o), o);
        case "eth":
            return write_string_type(ETH.from_sheet(wb.Sheets[wb.SheetNames[idx]], o), o);
        case "fods":
            return write_string_type(write_ods(wb, o), o);
        case "wk1":
            return write_binary_type(WK_.sheet_to_wk1(wb.Sheets[wb.SheetNames[idx]], o), o);
        case "wk3":
            return write_binary_type(WK_.book_to_wk3(wb, o), o);
        case "biff2":
            if (!o.biff) o.biff = 2; /* falls through */ 
        case "biff3":
            if (!o.biff) o.biff = 3; /* falls through */ 
        case "biff4":
            if (!o.biff) o.biff = 4;
            return write_binary_type(write_biff_buf(wb, o), o);
        case "biff5":
            if (!o.biff) o.biff = 5; /* falls through */ 
        case "biff8":
        case "xla":
        case "xls":
            if (!o.biff) o.biff = 8;
            return write_cfb_type(wb, o);
        case "xlsx":
        case "xlsm":
        case "xlam":
        case "xlsb":
        case "numbers":
        case "ods":
            return write_zip_type(wb, o);
        default:
            throw new Error("Unrecognized bookType |" + o.bookType + "|");
    }
}
function resolve_book_type(o /*:WriteFileOpts*/ ) {
    if (o.bookType) return;
    var _BT = {
        "xls": "biff8",
        "htm": "html",
        "slk": "sylk",
        "socialcalc": "eth",
        "Sh33tJS": "WTF"
    };
    var ext = o.file.slice(o.file.lastIndexOf(".")).toLowerCase();
    if (ext.match(/^\.[a-z]+$/)) o.bookType = ext.slice(1);
    o.bookType = _BT[o.bookType] || o.bookType;
}
function writeFileSync(wb /*:Workbook*/ , filename /*:string*/ , opts /*:?WriteFileOpts*/ ) {
    var o = opts || {};
    o.type = "file";
    o.file = filename;
    resolve_book_type(o);
    return writeSync(wb, o);
}
function writeFileSyncXLSX(wb /*:Workbook*/ , filename /*:string*/ , opts /*:?WriteFileOpts*/ ) {
    var o = opts || {};
    o.type = "file";
    o.file = filename;
    resolve_book_type(o);
    return writeSyncXLSX(wb, o);
}
function writeFileAsync(filename /*:string*/ , wb /*:Workbook*/ , opts /*:?WriteFileOpts*/ , cb /*:?(e?:ErrnoError)=>void*/ ) {
    var o = opts || {};
    o.type = "file";
    o.file = filename;
    resolve_book_type(o);
    o.type = "buffer";
    var _cb = cb;
    if (!(_cb instanceof Function)) _cb = opts /*:any*/ ;
    return _fs.writeFile(filename, writeSync(wb, o), _cb);
}
/*::
type MJRObject = {
	row: any;
	isempty: boolean;
};
*/ function make_json_row(sheet /*:Worksheet*/ , r /*:Range*/ , R /*:number*/ , cols /*:Array<string>*/ , header /*:number*/ , hdr /*:Array<any>*/ , dense /*:boolean*/ , o /*:Sheet2JSONOpts*/ ) /*:MJRObject*/ {
    var rr = encode_row(R);
    var defval = o.defval, raw = o.raw || !Object.prototype.hasOwnProperty.call(o, "raw");
    var isempty = true;
    var row /*:any*/  = header === 1 ? [] : {};
    if (header !== 1) {
        if (Object.defineProperty) try {
            Object.defineProperty(row, "__rowNum__", {
                value: R,
                enumerable: false
            });
        } catch (e) {
            row.__rowNum__ = R;
        }
        else row.__rowNum__ = R;
    }
    if (!dense || sheet[R]) for(var C = r.s.c; C <= r.e.c; ++C){
        var val = dense ? sheet[R][C] : sheet[cols[C] + rr];
        if (val === undefined || val.t === undefined) {
            if (defval === undefined) continue;
            if (hdr[C] != null) row[hdr[C]] = defval;
            continue;
        }
        var v = val.v;
        switch(val.t){
            case "z":
                if (v == null) break;
                continue;
            case "e":
                v = v == 0 ? null : void 0;
                break;
            case "s":
            case "d":
            case "b":
            case "n":
                break;
            default:
                throw new Error("unrecognized type " + val.t);
        }
        if (hdr[C] != null) {
            if (v == null) {
                if (val.t == "e" && v === null) row[hdr[C]] = null;
                else if (defval !== undefined) row[hdr[C]] = defval;
                else if (raw && v === null) row[hdr[C]] = null;
                else continue;
            } else row[hdr[C]] = raw && (val.t !== "n" || val.t === "n" && o.rawNumbers !== false) ? v : format_cell(val, v, o);
            if (v != null) isempty = false;
        }
    }
    return {
        row: row,
        isempty: isempty
    };
}
function sheet_to_json(sheet /*:Worksheet*/ , opts /*:?Sheet2JSONOpts*/ ) {
    if (sheet == null || sheet["!ref"] == null) return [];
    var val = {
        t: "n",
        v: 0
    }, header = 0, offset = 1, hdr /*:Array<any>*/  = [], v = 0, vv = "";
    var r = {
        s: {
            r: 0,
            c: 0
        },
        e: {
            r: 0,
            c: 0
        }
    };
    var o = opts || {};
    var range = o.range != null ? o.range : sheet["!ref"];
    if (o.header === 1) header = 1;
    else if (o.header === "A") header = 2;
    else if (Array.isArray(o.header)) header = 3;
    else if (o.header == null) header = 0;
    switch(typeof range){
        case "string":
            r = safe_decode_range(range);
            break;
        case "number":
            r = safe_decode_range(sheet["!ref"]);
            r.s.r = range;
            break;
        default:
            r = range;
    }
    if (header > 0) offset = 0;
    var rr = encode_row(r.s.r);
    var cols /*:Array<string>*/  = [];
    var out /*:Array<any>*/  = [];
    var outi = 0, counter = 0;
    var dense = Array.isArray(sheet);
    var R = r.s.r, C = 0;
    var header_cnt = {};
    if (dense && !sheet[R]) sheet[R] = [];
    var colinfo /*:Array<ColInfo>*/  = o.skipHidden && sheet["!cols"] || [];
    var rowinfo /*:Array<ColInfo>*/  = o.skipHidden && sheet["!rows"] || [];
    for(C = r.s.c; C <= r.e.c; ++C){
        if ((colinfo[C] || {}).hidden) continue;
        cols[C] = encode_col(C);
        val = dense ? sheet[R][C] : sheet[cols[C] + rr];
        switch(header){
            case 1:
                hdr[C] = C - r.s.c;
                break;
            case 2:
                hdr[C] = cols[C];
                break;
            case 3:
                hdr[C] = o.header[C - r.s.c];
                break;
            default:
                if (val == null) val = {
                    w: "__EMPTY",
                    t: "s"
                };
                vv = v = format_cell(val, null, o);
                counter = header_cnt[v] || 0;
                if (!counter) header_cnt[v] = 1;
                else {
                    do vv = v + "_" + counter++;
                    while (header_cnt[vv]);
                    header_cnt[v] = counter;
                    header_cnt[vv] = 1;
                }
                hdr[C] = vv;
        }
    }
    for(R = r.s.r + offset; R <= r.e.r; ++R){
        if ((rowinfo[R] || {}).hidden) continue;
        var row = make_json_row(sheet, r, R, cols, header, hdr, dense, o);
        if (row.isempty === false || (header === 1 ? o.blankrows !== false : !!o.blankrows)) out[outi++] = row.row;
    }
    out.length = outi;
    return out;
}
var qreg = /"/g;
function make_csv_row(sheet /*:Worksheet*/ , r /*:Range*/ , R /*:number*/ , cols /*:Array<string>*/ , fs /*:number*/ , rs /*:number*/ , FS /*:string*/ , o /*:Sheet2CSVOpts*/ ) /*:?string*/ {
    var isempty = true;
    var row /*:Array<string>*/  = [], txt = "", rr = encode_row(R);
    for(var C = r.s.c; C <= r.e.c; ++C){
        if (!cols[C]) continue;
        var val = o.dense ? (sheet[R] || [])[C] : sheet[cols[C] + rr];
        if (val == null) txt = "";
        else if (val.v != null) {
            isempty = false;
            txt = "" + (o.rawNumbers && val.t == "n" ? val.v : format_cell(val, null, o));
            for(var i = 0, cc = 0; i !== txt.length; ++i)if ((cc = txt.charCodeAt(i)) === fs || cc === rs || cc === 34 || o.forceQuotes) {
                txt = '"' + txt.replace(qreg, '""') + '"';
                break;
            }
            if (txt == "ID") txt = '"ID"';
        } else if (val.f != null && !val.F) {
            isempty = false;
            txt = "=" + val.f;
            if (txt.indexOf(",") >= 0) txt = '"' + txt.replace(qreg, '""') + '"';
        } else txt = "";
        /* NOTE: Excel CSV does not support array formulae */ row.push(txt);
    }
    if (o.blankrows === false && isempty) return null;
    return row.join(FS);
}
function sheet_to_csv(sheet /*:Worksheet*/ , opts /*:?Sheet2CSVOpts*/ ) /*:string*/ {
    var out /*:Array<string>*/  = [];
    var o = opts == null ? {} : opts;
    if (sheet == null || sheet["!ref"] == null) return "";
    var r = safe_decode_range(sheet["!ref"]);
    var FS = o.FS !== undefined ? o.FS : ",", fs = FS.charCodeAt(0);
    var RS = o.RS !== undefined ? o.RS : "\n", rs = RS.charCodeAt(0);
    var endregex = new RegExp((FS == "|" ? "\\|" : FS) + "+$");
    var row = "", cols /*:Array<string>*/  = [];
    o.dense = Array.isArray(sheet);
    var colinfo /*:Array<ColInfo>*/  = o.skipHidden && sheet["!cols"] || [];
    var rowinfo /*:Array<ColInfo>*/  = o.skipHidden && sheet["!rows"] || [];
    for(var C = r.s.c; C <= r.e.c; ++C)if (!(colinfo[C] || {}).hidden) cols[C] = encode_col(C);
    var w = 0;
    for(var R = r.s.r; R <= r.e.r; ++R){
        if ((rowinfo[R] || {}).hidden) continue;
        row = make_csv_row(sheet, r, R, cols, fs, rs, FS, o);
        if (row == null) continue;
        if (o.strip) row = row.replace(endregex, "");
        if (row || o.blankrows !== false) out.push((w++ ? RS : "") + row);
    }
    delete o.dense;
    return out.join("");
}
function sheet_to_txt(sheet /*:Worksheet*/ , opts /*:?Sheet2CSVOpts*/ ) {
    if (!opts) opts = {};
    opts.FS = "	";
    opts.RS = "\n";
    var s = sheet_to_csv(sheet, opts);
    if (typeof $cptable == "undefined" || opts.type == "string") return s;
    var o = $cptable.utils.encode(1200, s, "str");
    return String.fromCharCode(255) + String.fromCharCode(254) + o;
}
function sheet_to_formulae(sheet /*:Worksheet*/ ) /*:Array<string>*/ {
    var y = "", x, val = "";
    if (sheet == null || sheet["!ref"] == null) return [];
    var r = safe_decode_range(sheet["!ref"]), rr = "", cols /*:Array<string>*/  = [], C;
    var cmds /*:Array<string>*/  = [];
    var dense = Array.isArray(sheet);
    for(C = r.s.c; C <= r.e.c; ++C)cols[C] = encode_col(C);
    for(var R = r.s.r; R <= r.e.r; ++R){
        rr = encode_row(R);
        for(C = r.s.c; C <= r.e.c; ++C){
            y = cols[C] + rr;
            x = dense ? (sheet[R] || [])[C] : sheet[y];
            val = "";
            if (x === undefined) continue;
            else if (x.F != null) {
                y = x.F;
                if (!x.f) continue;
                val = x.f;
                if (y.indexOf(":") == -1) y = y + ":" + y;
            }
            if (x.f != null) val = x.f;
            else if (x.t == "z") continue;
            else if (x.t == "n" && x.v != null) val = "" + x.v;
            else if (x.t == "b") val = x.v ? "TRUE" : "FALSE";
            else if (x.w !== undefined) val = "'" + x.w;
            else if (x.v === undefined) continue;
            else if (x.t == "s") val = "'" + x.v;
            else val = "" + x.v;
            cmds[cmds.length] = y + "=" + val;
        }
    }
    return cmds;
}
function sheet_add_json(_ws /*:?Worksheet*/ , js /*:Array<any>*/ , opts) /*:Worksheet*/ {
    var o = opts || {};
    var offset = +!o.skipHeader;
    var ws /*:Worksheet*/  = _ws || {} /*:any*/ ;
    var _R = 0, _C = 0;
    if (ws && o.origin != null) {
        if (typeof o.origin == "number") _R = o.origin;
        else {
            var _origin /*:CellAddress*/  = typeof o.origin == "string" ? decode_cell(o.origin) : o.origin;
            _R = _origin.r;
            _C = _origin.c;
        }
    }
    var cell /*:Cell*/ ;
    var range /*:Range*/  = {
        s: {
            c: 0,
            r: 0
        },
        e: {
            c: _C,
            r: _R + js.length - 1 + offset
        }
    } /*:any*/ ;
    if (ws["!ref"]) {
        var _range = safe_decode_range(ws["!ref"]);
        range.e.c = Math.max(range.e.c, _range.e.c);
        range.e.r = Math.max(range.e.r, _range.e.r);
        if (_R == -1) {
            _R = _range.e.r + 1;
            range.e.r = _R + js.length - 1 + offset;
        }
    } else if (_R == -1) {
        _R = 0;
        range.e.r = js.length - 1 + offset;
    }
    var hdr /*:Array<string>*/  = o.header || [], C = 0;
    js.forEach(function(JS, R /*:number*/ ) {
        keys(JS).forEach(function(k) {
            if ((C = hdr.indexOf(k)) == -1) hdr[C = hdr.length] = k;
            var v = JS[k];
            var t = "z";
            var z = "";
            var ref = encode_cell({
                c: _C + C,
                r: _R + R + offset
            });
            cell = ws_get_cell_stub(ws, ref);
            if (v && typeof v === "object" && !(v instanceof Date)) ws[ref] = v;
            else {
                if (typeof v == "number") t = "n";
                else if (typeof v == "boolean") t = "b";
                else if (typeof v == "string") t = "s";
                else if (v instanceof Date) {
                    t = "d";
                    if (!o.cellDates) {
                        t = "n";
                        v = datenum(v);
                    }
                    z = o.dateNF || table_fmt[14];
                } else if (v === null && o.nullError) {
                    t = "e";
                    v = 0;
                }
                if (!cell) ws[ref] = cell = {
                    t: t,
                    v: v
                } /*:any*/ ;
                else {
                    cell.t = t;
                    cell.v = v;
                    delete cell.w;
                    delete cell.R;
                    if (z) cell.z = z;
                }
                if (z) cell.z = z;
            }
        });
    });
    range.e.c = Math.max(range.e.c, _C + hdr.length - 1);
    var __R = encode_row(_R);
    if (offset) for(C = 0; C < hdr.length; ++C)ws[encode_col(C + _C) + __R] = {
        t: "s",
        v: hdr[C]
    };
    ws["!ref"] = encode_range(range);
    return ws;
}
function json_to_sheet(js /*:Array<any>*/ , opts) /*:Worksheet*/ {
    return sheet_add_json(null, js, opts);
}
/* get cell, creating a stub if necessary */ function ws_get_cell_stub(ws /*:Worksheet*/ , R, C /*:?number*/ ) /*:Cell*/ {
    /* A1 cell address */ if (typeof R == "string") {
        /* dense */ if (Array.isArray(ws)) {
            var RC = decode_cell(R);
            if (!ws[RC.r]) ws[RC.r] = [];
            return ws[RC.r][RC.c] || (ws[RC.r][RC.c] = {
                t: "z"
            });
        }
        return ws[R] || (ws[R] = {
            t: "z"
        });
    }
    /* cell address object */ if (typeof R != "number") return ws_get_cell_stub(ws, encode_cell(R));
    /* R and C are 0-based indices */ return ws_get_cell_stub(ws, encode_cell({
        r: R,
        c: C || 0
    }));
}
/* find sheet index for given name / validate index */ function wb_sheet_idx(wb /*:Workbook*/ , sh /*:number|string*/ ) {
    if (typeof sh == "number") {
        if (sh >= 0 && wb.SheetNames.length > sh) return sh;
        throw new Error("Cannot find sheet # " + sh);
    } else if (typeof sh == "string") {
        var idx = wb.SheetNames.indexOf(sh);
        if (idx > -1) return idx;
        throw new Error("Cannot find sheet name |" + sh + "|");
    } else throw new Error("Cannot find sheet |" + sh + "|");
}
/* simple blank workbook object */ function book_new() /*:Workbook*/ {
    return {
        SheetNames: [],
        Sheets: {}
    };
}
/* add a worksheet to the end of a given workbook */ function book_append_sheet(wb /*:Workbook*/ , ws /*:Worksheet*/ , name /*:?string*/ , roll /*:?boolean*/ ) /*:string*/ {
    var i = 1;
    if (!name) {
        for(; i <= 0xFFFF; ++i, name = undefined)if (wb.SheetNames.indexOf(name = "Sheet" + i) == -1) break;
    }
    if (!name || wb.SheetNames.length >= 0xFFFF) throw new Error("Too many worksheets");
    if (roll && wb.SheetNames.indexOf(name) >= 0) {
        var m = name.match(/(^.*?)(\d+)$/);
        i = m && +m[2] || 0;
        var root = m && m[1] || name;
        for(++i; i <= 0xFFFF; ++i)if (wb.SheetNames.indexOf(name = root + i) == -1) break;
    }
    check_ws_name(name);
    if (wb.SheetNames.indexOf(name) >= 0) throw new Error("Worksheet with name |" + name + "| already exists!");
    wb.SheetNames.push(name);
    wb.Sheets[name] = ws;
    return name;
}
/* set sheet visibility (visible/hidden/very hidden) */ function book_set_sheet_visibility(wb /*:Workbook*/ , sh /*:number|string*/ , vis /*:number*/ ) {
    if (!wb.Workbook) wb.Workbook = {};
    if (!wb.Workbook.Sheets) wb.Workbook.Sheets = [];
    var idx = wb_sheet_idx(wb, sh);
    // $FlowIgnore
    if (!wb.Workbook.Sheets[idx]) wb.Workbook.Sheets[idx] = {};
    switch(vis){
        case 0:
        case 1:
        case 2:
            break;
        default:
            throw new Error("Bad sheet visibility setting " + vis);
    }
    // $FlowIgnore
    wb.Workbook.Sheets[idx].Hidden = vis;
}
/* set number format */ function cell_set_number_format(cell /*:Cell*/ , fmt /*:string|number*/ ) {
    cell.z = fmt;
    return cell;
}
/* set cell hyperlink */ function cell_set_hyperlink(cell /*:Cell*/ , target /*:string*/ , tooltip /*:?string*/ ) {
    if (!target) delete cell.l;
    else {
        cell.l = {
            Target: target
        } /*:Hyperlink*/ ;
        if (tooltip) cell.l.Tooltip = tooltip;
    }
    return cell;
}
function cell_set_internal_link(cell /*:Cell*/ , range /*:string*/ , tooltip /*:?string*/ ) {
    return cell_set_hyperlink(cell, "#" + range, tooltip);
}
/* add to cell comments */ function cell_add_comment(cell /*:Cell*/ , text /*:string*/ , author /*:?string*/ ) {
    if (!cell.c) cell.c = [];
    cell.c.push({
        t: text,
        a: author || "SheetJS"
    });
}
/* set array formula and flush related cells */ function sheet_set_array_formula(ws /*:Worksheet*/ , range, formula /*:string*/ , dynamic /*:boolean*/ ) {
    var rng = typeof range != "string" ? range : safe_decode_range(range);
    var rngstr = typeof range == "string" ? range : encode_range(range);
    for(var R = rng.s.r; R <= rng.e.r; ++R)for(var C = rng.s.c; C <= rng.e.c; ++C){
        var cell = ws_get_cell_stub(ws, R, C);
        cell.t = "n";
        cell.F = rngstr;
        delete cell.v;
        if (R == rng.s.r && C == rng.s.c) {
            cell.f = formula;
            if (dynamic) cell.D = true;
        }
    }
    return ws;
}
var utils /*:any*/  = {
    encode_col: encode_col,
    encode_row: encode_row,
    encode_cell: encode_cell,
    encode_range: encode_range,
    decode_col: decode_col,
    decode_row: decode_row,
    split_cell: split_cell,
    decode_cell: decode_cell,
    decode_range: decode_range,
    format_cell: format_cell,
    sheet_add_aoa: sheet_add_aoa,
    sheet_add_json: sheet_add_json,
    sheet_add_dom: sheet_add_dom,
    aoa_to_sheet: aoa_to_sheet,
    json_to_sheet: json_to_sheet,
    table_to_sheet: parse_dom_table,
    table_to_book: table_to_book,
    sheet_to_csv: sheet_to_csv,
    sheet_to_txt: sheet_to_txt,
    sheet_to_json: sheet_to_json,
    sheet_to_html: sheet_to_html,
    sheet_to_formulae: sheet_to_formulae,
    sheet_to_row_object_array: sheet_to_json,
    sheet_get_cell: ws_get_cell_stub,
    book_new: book_new,
    book_append_sheet: book_append_sheet,
    book_set_sheet_visibility: book_set_sheet_visibility,
    cell_set_number_format: cell_set_number_format,
    cell_set_hyperlink: cell_set_hyperlink,
    cell_set_internal_link: cell_set_internal_link,
    cell_add_comment: cell_add_comment,
    sheet_set_array_formula: sheet_set_array_formula,
    consts: {
        SHEET_VISIBLE: 0,
        SHEET_HIDDEN: 1,
        SHEET_VERY_HIDDEN: 2
    }
};
var _Readable;
function set_readable(R) {
    _Readable = R;
}
function write_csv_stream(sheet /*:Worksheet*/ , opts /*:?Sheet2CSVOpts*/ ) {
    var stream = _Readable();
    var o = opts == null ? {} : opts;
    if (sheet == null || sheet["!ref"] == null) {
        stream.push(null);
        return stream;
    }
    var r = safe_decode_range(sheet["!ref"]);
    var FS = o.FS !== undefined ? o.FS : ",", fs = FS.charCodeAt(0);
    var RS = o.RS !== undefined ? o.RS : "\n", rs = RS.charCodeAt(0);
    var endregex = new RegExp((FS == "|" ? "\\|" : FS) + "+$");
    var row /*:?string*/  = "", cols /*:Array<string>*/  = [];
    o.dense = Array.isArray(sheet);
    var colinfo /*:Array<ColInfo>*/  = o.skipHidden && sheet["!cols"] || [];
    var rowinfo /*:Array<RowInfo>*/  = o.skipHidden && sheet["!rows"] || [];
    for(var C = r.s.c; C <= r.e.c; ++C)if (!(colinfo[C] || {}).hidden) cols[C] = encode_col(C);
    var R = r.s.r;
    var BOM = false, w = 0;
    stream._read = function() {
        if (!BOM) {
            BOM = true;
            return stream.push("\uFEFF");
        }
        while(R <= r.e.r){
            ++R;
            if ((rowinfo[R - 1] || {}).hidden) continue;
            row = make_csv_row(sheet, r, R - 1, cols, fs, rs, FS, o);
            if (row != null) {
                if (o.strip) row = row.replace(endregex, "");
                if (row || o.blankrows !== false) return stream.push((w++ ? RS : "") + row);
            }
        }
        return stream.push(null);
    };
    return stream;
}
function write_html_stream(ws /*:Worksheet*/ , opts /*:?Sheet2HTMLOpts*/ ) {
    var stream = _Readable();
    var o = opts || {};
    var header = o.header != null ? o.header : HTML_BEGIN;
    var footer = o.footer != null ? o.footer : HTML_END;
    stream.push(header);
    var r = decode_range(ws["!ref"]);
    o.dense = Array.isArray(ws);
    stream.push(make_html_preamble(ws, r, o));
    var R = r.s.r;
    var end = false;
    stream._read = function() {
        if (R > r.e.r) {
            if (!end) {
                end = true;
                stream.push("</table>" + footer);
            }
            return stream.push(null);
        }
        while(R <= r.e.r){
            stream.push(make_html_row(ws, r, R, o));
            ++R;
            break;
        }
    };
    return stream;
}
function write_json_stream(sheet /*:Worksheet*/ , opts /*:?Sheet2CSVOpts*/ ) {
    var stream = _Readable({
        objectMode: true
    });
    if (sheet == null || sheet["!ref"] == null) {
        stream.push(null);
        return stream;
    }
    var val = {
        t: "n",
        v: 0
    }, header = 0, offset = 1, hdr /*:Array<any>*/  = [], v = 0, vv = "";
    var r = {
        s: {
            r: 0,
            c: 0
        },
        e: {
            r: 0,
            c: 0
        }
    };
    var o = opts || {};
    var range = o.range != null ? o.range : sheet["!ref"];
    if (o.header === 1) header = 1;
    else if (o.header === "A") header = 2;
    else if (Array.isArray(o.header)) header = 3;
    switch(typeof range){
        case "string":
            r = safe_decode_range(range);
            break;
        case "number":
            r = safe_decode_range(sheet["!ref"]);
            r.s.r = range;
            break;
        default:
            r = range;
    }
    if (header > 0) offset = 0;
    var rr = encode_row(r.s.r);
    var cols /*:Array<string>*/  = [];
    var counter = 0;
    var dense = Array.isArray(sheet);
    var R = r.s.r, C = 0;
    var header_cnt = {};
    if (dense && !sheet[R]) sheet[R] = [];
    var colinfo /*:Array<ColInfo>*/  = o.skipHidden && sheet["!cols"] || [];
    var rowinfo /*:Array<RowInfo>*/  = o.skipHidden && sheet["!rows"] || [];
    for(C = r.s.c; C <= r.e.c; ++C){
        if ((colinfo[C] || {}).hidden) continue;
        cols[C] = encode_col(C);
        val = dense ? sheet[R][C] : sheet[cols[C] + rr];
        switch(header){
            case 1:
                hdr[C] = C - r.s.c;
                break;
            case 2:
                hdr[C] = cols[C];
                break;
            case 3:
                hdr[C] = o.header[C - r.s.c];
                break;
            default:
                if (val == null) val = {
                    w: "__EMPTY",
                    t: "s"
                };
                vv = v = format_cell(val, null, o);
                counter = header_cnt[v] || 0;
                if (!counter) header_cnt[v] = 1;
                else {
                    do vv = v + "_" + counter++;
                    while (header_cnt[vv]);
                    header_cnt[v] = counter;
                    header_cnt[vv] = 1;
                }
                hdr[C] = vv;
        }
    }
    R = r.s.r + offset;
    stream._read = function() {
        while(R <= r.e.r){
            if ((rowinfo[R - 1] || {}).hidden) continue;
            var row = make_json_row(sheet, r, R, cols, header, hdr, dense, o);
            ++R;
            if (row.isempty === false || (header === 1 ? o.blankrows !== false : !!o.blankrows)) {
                stream.push(row.row);
                return;
            }
        }
        return stream.push(null);
    };
    return stream;
}
var __stream = {
    to_json: write_json_stream,
    to_html: write_html_stream,
    to_csv: write_csv_stream,
    set_readable: set_readable
};
const version = XLSX.version;

},{"f481c164bc92069e":"13Pcp","1e1b0fdaf6fdd859":"13Pcp","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"13Pcp":[function(require,module,exports) {
"use strict";

},{}],"kshI5":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getMenuSyncModuleId", ()=>getMenuSyncModuleId);
var _react = require("react");
var _unstatedNext = require("unstated-next");
var _api = require("../api");
var _applicationNlpMenuContainer = require("./ApplicationNlpMenuContainer");
var _applicationNlpMenuContainerDefault = parcelHelpers.interopDefault(_applicationNlpMenuContainer);
var _uuid = require("uuid");
var _lodash = require("lodash");
var _lodashDefault = parcelHelpers.interopDefault(_lodash);
var _interactionModelContainer = require("./InteractionModelContainer");
var _interactionModelContainerDefault = parcelHelpers.interopDefault(_interactionModelContainer);
var _menuSyncContainer = require("./MenuSyncContainer");
var _menuSyncContainerDefault = parcelHelpers.interopDefault(_menuSyncContainer);
var _featureFlagIds = require("../constants/featureFlagIds");
const getMenuSyncModuleId = ()=>{
    return "af153c7e-faed-4068-9ee7-5dba38a1aca5";
};
function useMenuContainer() {
    const [liveMenuItems, setLiveMenuItems] = (0, _react.useState)([]);
    const [fetchingMenu, setFetchingMenu] = (0, _react.useState)(false);
    const [menuItems, setMenuItems] = (0, _react.useState)([]);
    const [menuItem, setMenuItem] = (0, _react.useState)(null);
    const [originalMenuItem, setOriginalMenuItem] = (0, _react.useState)(null);
    const [categories, setCategories] = (0, _react.useState)([]);
    const [activeEditId, setActiveEditId] = (0, _react.useState)("");
    const [isMenuItemEdited, setIsMenuItemEdited] = (0, _react.useState)(false);
    const [showConfirmationModal, setShowConfirmationModal] = (0, _react.useState)(false);
    const [errors, setErrors] = (0, _react.useState)([]);
    const [loadingPOSMenuSync, setLoadingPOSMenuSync] = (0, _react.useState)(false);
    const [ladingPublishAllChanges, setLoadingPublishAllChanges] = (0, _react.useState)(false);
    const [matchingItemsWithSameOptionGroupOrSizeGroup, setmatchingItemsWithSameOptionGroupOrSizeGroup] = (0, _react.useState)();
    const [showAskToUpdateOtherItemsModal, setShowAskToUpdateOtherItemsModal] = (0, _react.useState)(false);
    const [itemsToNotAugment, setItemsToNotAugment] = (0, _react.useState)([]);
    const [pendingMenuItemUpdates, setPendingMenuItemUpdates] = (0, _react.useState)([]);
    const [sizeName, setSizeName] = (0, _react.useState)("");
    const [optionGroupsToAugment, setOptionGroupsToAugment] = (0, _react.useState)([]);
    const [loadingMenuDiff, setLoadingMenuDiff] = (0, _react.useState)(false);
    const [menuSyncRequest, setMenuSyncRequest] = (0, _react.useState)(null);
    const [path, setPath] = (0, _react.useState)([]);
    const menuSyncContainer = (0, _menuSyncContainerDefault.default).useContainer();
    const [isLoadingMenu, setIsLoadingMenu] = (0, _react.useState)(false);
    const [menuItemAugmentStatus, setMenuItemAugmentStatus] = (0, _react.useState)(null);
    const applicationNlpMenuContainer = (0, _applicationNlpMenuContainerDefault.default).useContainer();
    const interactionModelContainer = (0, _interactionModelContainerDefault.default).useContainer();
    async function retrieveEntireMenu(applicationId) {
        var menuItemResult = await _api.getVoicifyMenuItems(applicationId);
        const checkOptionGroup = (group)=>{
            if (!group.referenceId?.length) group.referenceId = (0, _uuid.v4)();
            for (const option of group.options){
                if (option?.optionGroups?.length) for (const subGroup of option.optionGroups)checkOptionGroup(subGroup);
            }
        };
        const checkSizeGroup = (group)=>{
            if (group?.sizes?.length) for (const size of group.sizes){
                if (size?.optionGroups?.length) for (const subGroup of size.optionGroups)checkOptionGroup(subGroup);
            }
        };
        // ensure all option groups have reference ids
        if (menuItemResult?.data?.length) for (const item of menuItemResult.data){
            if (item.optionGroups?.length) for (const group of item.optionGroups)checkOptionGroup(group);
            if (item.sizeGroups?.length) for (const group of item.sizeGroups)checkSizeGroup(group);
        }
        return menuItemResult;
    }
    (0, _react.useEffect)(()=>{
        if (!menuItems?.length) {
            setPendingMenuItemUpdates([]);
            return;
        }
        if (!liveMenuItems?.length) {
            setPendingMenuItemUpdates([]);
            return;
        }
        let updates = [];
        for (const item of menuItems){
            const liveItem = liveMenuItems.find((i)=>i.id === item.id);
            if (item.isDisabled) {
                if (liveItem) updates.push({
                    menuItemId: item.id,
                    menuItemName: item.originalName,
                    diffs: []
                });
                continue;
            }
            if (!liveItem) {
                updates.push({
                    menuItemId: item.id,
                    menuItemName: item.originalName,
                    diffs: []
                });
                continue;
            }
            // identify properties that are different between live item and item
            const copy1 = JSON.parse(JSON.stringify(item));
            const copy2 = JSON.parse(JSON.stringify(liveItem));
            copy1.applicationId = "";
            copy2.applicationId = "";
            const diffs = findChangesInMenuItems(copy1, copy2, true);
            if (diffs.length) updates.push({
                menuItemId: item.id,
                menuItemName: item.originalName,
                diffs
            });
        }
        setPendingMenuItemUpdates(updates);
    }, [
        menuItems,
        liveMenuItems
    ]);
    async function getLiveMenu(applicationid) {
        try {
            const menuResponse = await _api.getVoicifyMenuItems(applicationid);
            if (menuResponse.resultType === "Ok" && menuResponse.data.length > 0) setLiveMenuItems([
                ...menuResponse.data
            ]);
        } catch  {}
    }
    async function getMenu(applicationId) {
        try {
            setIsLoadingMenu(true);
            const menuResponse = await retrieveEntireMenu(applicationId);
            if (menuResponse.errors && menuResponse.errors.length > 0) setErrors(menuResponse.errors);
            if (menuResponse.resultType === "Ok" && menuResponse.data.length > 0) {
                setMenuItems([
                    ...menuResponse.data
                ]);
                const categoriesSet = new Set();
                categoriesSet.add("All");
                for (const item of menuResponse.data)if (typeof item.attributes?.data?.category !== "undefined") categoriesSet.add(item.attributes?.data.category);
                if (categoriesSet.size === 1) categoriesSet.delete("All");
                setCategories(Array.from(categoriesSet.values()));
            }
            setIsLoadingMenu(false);
        } catch (error) {
            setIsLoadingMenu(false);
            setErrors([
                error
            ]);
        }
    }
    async function loadMenuSyncModule(applicationId) {
        const appliedTemplates = await _api.getAppliedApplicationTemplatesForApp(applicationId);
        if (appliedTemplates?.resultType == "Ok") {
            const appliedModule = appliedTemplates?.data?.find((t)=>t?.templateForm?.templateConfigurationId === getMenuSyncModuleId());
            if (appliedModule) {
                // found a menu sync module applied here. Set the request.
                const request = {
                    templateFormFieldValues: [
                        ...appliedModule?.templateFormFieldValues
                    ],
                    name: appliedModule.name ?? "",
                    appliedTemplateId: appliedModule?.id
                };
                setMenuSyncRequest(request);
                return;
            }
        }
        setMenuSyncRequest(null);
    }
    async function submitMenuSyncRequest(applicationId) {
        if (menuSyncRequest) await _api.finalizeDynamicForm(menuSyncRequest.appliedTemplateId, {
            applicationId: applicationId,
            data: menuSyncRequest
        });
    }
    async function getMenuItem(applicationId, menuItemId) {
        try {
            setIsLoadingMenu(true);
            const menuResponse = await _api.getVoicifyMenuItems(applicationId, menuItemId);
            if (menuResponse.errors && menuResponse.errors.length > 0) {
                setErrors(menuResponse.errors);
                setIsLoadingMenu(false);
            }
            if (menuResponse.resultType === "Ok" && menuResponse.data.length > 0) {
                setMenuItem({
                    ...menuResponse.data[0]
                });
                setOriginalMenuItem(JSON.parse(JSON.stringify(menuResponse.data[0])));
                setIsLoadingMenu(false);
                return menuResponse.data[0];
            }
            setIsLoadingMenu(false);
        } catch (error) {
            setIsLoadingMenu(false);
            setErrors([
                error
            ]);
        }
    }
    function resetMenuItemSelections() {
        setMenuItem(null);
        setActiveEditId(null);
        setIsMenuItemEdited(false);
        setPath([]);
    }
    function updateMenuItem(menuItem, changedObj, changedProperty, persistentPropertiesOverride) {
        //do not allow updates during the augment process
        if (menuItemAugmentStatus) return;
        // the data dictionary can't have persistent properties. add the data dictionary to persistent properties instead via persistent properties overide
        if (persistentPropertiesOverride) {
            if (!persistentPropertiesOverride.changedObj.persistentProperties?.length) persistentPropertiesOverride.changedObj.persistentProperties = [];
            if (!persistentPropertiesOverride.changedObj.persistentProperties.includes(persistentPropertiesOverride.changedProperty) && persistentPropertiesOverride.changedProperty?.length) persistentPropertiesOverride.changedObj.persistentProperties.push(persistentPropertiesOverride.changedProperty);
        } else {
            if (!changedObj.persistentProperties?.length) changedObj.persistentProperties = [];
            if (!changedObj.persistentProperties.includes(changedProperty) && changedProperty?.length) changedObj.persistentProperties.push(changedProperty);
        }
        setIsMenuItemEdited(true);
        setMenuItem({
            ...menuItem
        });
    }
    async function updateMenu(updatedItem, applicationId) {
        await applicationNlpMenuContainer.updateVoicifyMenuItem(applicationId, updatedItem);
    }
    function handleDisableEnableCategory(categoryIndexToUpdate, enableDisable, applicationId) {
        const filteredItems = menuItems.filter(({ attributes })=>attributes?.data?.category === categories[categoryIndexToUpdate]);
        const updatedMenuItems = menuItems.map((item)=>{
            const matchingItem = filteredItems.find((filteredItem)=>filteredItem.id === item.id);
            //Since "All" is the first Category, it needs to go through all the items
            if (categoryIndexToUpdate === 0) {
                if ((item.isDisabled ?? false) !== enableDisable) {
                    //Only call the API if isDisabled is changed
                    const result = {
                        ...item,
                        isDisabled: enableDisable
                    };
                    updateMenu(result, applicationId);
                    return result;
                }
                return item;
            } else {
                if (matchingItem && (item.isDisabled ?? false) !== enableDisable) {
                    //Only call the API if isDisabled is changed
                    const result = {
                        ...item,
                        isDisabled: enableDisable
                    };
                    updateMenu(result, applicationId);
                    return result;
                }
                return item;
            }
        });
        setMenuItems(updatedMenuItems);
        setShowConfirmationModal(false);
    }
    async function syncMenuWithPOS(application, options) {
        setLoadingPOSMenuSync(true);
        const request = {
            ...options,
            locationId: application.posLocationId,
            posName: application.posName,
            manageMenuApplicationId: application.manageMenuApplicationId,
            liveApplicationId: application.id,
            updateLiveApplication: false,
            skipEntityExapnsion: true,
            skipMenuAugmentation: true
        };
        const result = await _api.initiateMenuUpdate(request);
        if (result?.resultType !== "Ok") setErrors(result.errors);
        setLoadingPOSMenuSync(false);
        setShowConfirmationModal(false);
    }
    async function publishAllChanges(application, orgId) {
        setLoadingPublishAllChanges(true);
        // generate a guid
        const processId = (0, _uuid.v4)();
        const request = {
            menuConfiguration: {
                primaryLocation: {
                    manageMenuApplicationId: application.manageMenuApplicationId,
                    manageMenuApplicationName: application.name,
                    liveApplicationId: application.id,
                    liveApplicationName: application.name
                }
            },
            orgId: orgId,
            processId: processId
        };
        const result = await _api.syncMenus(request);
        if (result?.resultType !== "Ok") setErrors(result.errors);
        menuSyncContainer.startMenuSync(application.id, processId);
        setLoadingPublishAllChanges(false);
        setShowConfirmationModal(false);
    }
    const findOptionGroupAndSizeGroupsNeedAugment = (menuItemToUse, diffKeys)=>{
        const optionGroupsThatNeedReAugment = [];
        const sizeGroupsThatNeedReAugment = [];
        for (const diff of diffKeys){
            const key = diff.key; //optionGroups.1.isDisabled
            const path = key?.split(".");
            let isOptionGroup = false;
            let isSizeGroup = false;
            let isOption = false;
            let isSize = false;
            //get the last optionGroup or sizeGroup
            for (const property of path.slice().reverse()){
                //slice so that it does not mutate the original
                if (property === "optionGroups") {
                    isOptionGroup = true;
                    break;
                } else if (property === "sizeGroups") {
                    isSizeGroup = true;
                    break;
                } else if (property === "sizes") {
                    isSize = true;
                    break;
                } else if (property === "options") {
                    isOption = true;
                    break;
                }
            }
            let numberOfStepsBack = -3;
            if (key.includes("numberOfRequiredOptions")) numberOfStepsBack = -1;
            const mainGroupPath = path.slice(0, numberOfStepsBack); //-3 to go back to the main group eg. "optionGroups".1.isDisabled
            let changedGroup = getItemByPath(menuItemToUse, mainGroupPath, diff.diff) ?? menuItemToUse["sizeGroups"][0]?.sizes.find((s)=>normalizeName(s.name) === normalizeName(sizeName))?.optionGroups[0];
            if (changedGroup && key.includes("numberOfRequiredOptions")) {
                if (isOptionGroup) optionGroupsThatNeedReAugment.push({
                    changedGroup,
                    index: mainGroupPath.slice(-1)
                });
                if (isSizeGroup && typeof mainGroupPath.slice(-1)[0] === "string") sizeGroupsThatNeedReAugment.push({
                    changedGroup,
                    index: parseInt(mainGroupPath.slice(-1)[0])
                });
            }
            if (changedGroup && (key.includes("colloquialName") || key.includes("isDisabled"))) {
                if (isOption) optionGroupsThatNeedReAugment.push({
                    changedGroup,
                    index: mainGroupPath.slice(-1)
                });
                if ((isSizeGroup || isSize) && typeof mainGroupPath.slice(-1)[0] === "string") sizeGroupsThatNeedReAugment.push({
                    changedGroup,
                    index: parseInt(mainGroupPath.slice(-1)[0])
                });
            }
        }
        return {
            optionGroupsThatNeedReAugment,
            sizeGroupsThatNeedReAugment
        };
    };
    /**
   * get the clean/required data needed for augmenting the menu item
   * @returns null if the menu item does not require augment
   */ function getCleanedMenuItemForAugment() {
        let menuItemToAugment = null;
        const diffs = findChangesInMenuItems(originalMenuItem, menuItem);
        const { optionGroupsThatNeedReAugment, sizeGroupsThatNeedReAugment } = findOptionGroupAndSizeGroupsNeedAugment(menuItem, diffs);
        const optionGroupReferenceIds = optionGroupsThatNeedReAugment.map((obj)=>obj.changedGroup.referenceId).filter((item)=>item);
        const sizeGroupIndecies = sizeGroupsThatNeedReAugment.map((obj)=>obj.index);
        //is a reaugment needed
        if (optionGroupReferenceIds.length > 0 || sizeGroupIndecies.length > 0) menuItemToAugment = {
            itemId: menuItem.id,
            optionGroupReferenceIdsToAugment: [
                ...new Set(optionGroupReferenceIds)
            ],
            sizeGroupIndeciesToAugment: sizeGroupIndecies?.length ? [
                0
            ] : []
        };
        return menuItemToAugment;
    }
    function getItemByPath(obj, path, matchName) {
        let item = obj;
        for(let i = 0; i < path.length; i++){
            const pathI = path[i];
            if (i !== 0 && path[i - 1] === "optionGroups") {
                if (matchName) item = item?.find((i)=>normalizeName(i.name) === normalizeName(matchName));
                else item = item?.find((i)=>i.referenceId === pathI);
            } else if (i !== 0 && path[i - 1] === "sizeGroups") {
                if (item?.length) item = item[0];
                else item = null;
            } else if (i !== 0 && path[i - 1] === "options") item = item?.find((i)=>i.id === pathI);
            else if (i !== 0 && path[i - 1] === "sizes") item = item?.find((i)=>i.id === pathI);
            else if (item && (pathI in item || Number(pathI) in item)) item = item[isNaN(Number(pathI)) ? pathI : Number(pathI)];
        }
        return item;
    }
    function findChangesInMenuItems(original = originalMenuItem, current = menuItem, skipIfOriginalDisabled = false) {
        let differences = {};
        function findDifferences(obj1, obj2, path = []) {
            const isDisabledCase = skipIfOriginalDisabled && obj1?.isDisabled;
            if (isDisabledCase) return;
            // If the objects are the same, no need to record a difference.
            if ((0, _lodashDefault.default).isEqual(obj1, obj2)) return;
            if ((0, _lodashDefault.default).isArray(obj1) && (0, _lodashDefault.default).isArray(obj2)) {
                let lastKey = "";
                let optionGroups = false;
                let sizeGroups = false;
                let optionsSizes = false;
                if (path?.length) {
                    lastKey = path[path.length - 1];
                    if (lastKey === "optionGroups") optionGroups = true;
                    else if (lastKey === "sizeGroups") sizeGroups = true;
                    else if (lastKey === "options" || lastKey === "sizes") optionsSizes = true;
                }
                if (optionGroups) {
                    const allIds = new Set([
                        ...obj1.map((o)=>o.referenceId),
                        ...obj2.map((o)=>o.referenceId)
                    ]);
                    allIds.forEach((key)=>{
                        if (!key?.includes("editId")) {
                            const o1 = obj1.find((o1)=>o1.referenceId === key);
                            const o2 = obj2.find((o2)=>o2.referenceId === key);
                            findDifferences(o1, o2, [
                                ...path,
                                key
                            ]);
                        }
                    });
                }
                if (sizeGroups) {
                    const sizeGroup1 = obj1?.length ? obj1[0] : null;
                    const sizeGroup2 = obj2?.length ? obj2[0] : null;
                    findDifferences(sizeGroup1, sizeGroup2, [
                        ...path,
                        "sizeGroup"
                    ]);
                } else if (optionsSizes) {
                    const allIds = new Set([
                        ...obj1.map((o)=>o.id),
                        ...obj2.map((o)=>o.id)
                    ]);
                    allIds.forEach((key)=>{
                        if (!key?.includes("editId")) {
                            const o1 = obj1.find((o1)=>o1.id === key);
                            const o2 = obj2.find((o2)=>o2.id === key);
                            findDifferences(o1, o2, [
                                ...path,
                                key
                            ]);
                        }
                    });
                } else {
                    // we need to order arrays by id if we have it, then name, then reference id, then original name
                    let sorted1 = obj1?.filter((item)=>!skipIfOriginalDisabled || !item?.isDisabled);
                    sorted1 = sorted1.sort((a, b)=>{
                        if (a?.id?.length) return a.id > b.id ? 1 : -1;
                        else if (a?.originalName?.length) return a.originalName > b.originalName ? 1 : -1;
                        else if (a?.referenceId?.length) return a.referenceId > b.referenceId ? 1 : -1;
                        else if (a?.name?.length) return a.name > b.name ? 1 : -1;
                        return 1;
                    });
                    const sorted2 = obj2?.sort((a, b)=>{
                        if (a?.id?.length) return a.id > b.id ? 1 : -1;
                        else if (a?.originalName?.length) return a.originalName > b.originalName ? 1 : -1;
                        else if (a?.referenceId?.length) return a.referenceId > b.referenceId ? 1 : -1;
                        else if (a?.name?.length) return a.name > b.name ? 1 : -1;
                        return 1;
                    });
                    const allKeys = new Set([
                        ...Object.keys(sorted1),
                        ...Object.keys(sorted2)
                    ]);
                    allKeys.forEach((key)=>{
                        if (!key.includes("editId")) findDifferences(sorted1[key], sorted2[key], [
                            ...path,
                            key
                        ]);
                    });
                }
            } else if ((0, _lodashDefault.default).isObject(obj1) && (0, _lodashDefault.default).isObject(obj2)) {
                const allKeys = new Set([
                    ...Object.keys(obj1),
                    ...Object.keys(obj2)
                ]);
                allKeys.forEach((key)=>{
                    if (!key.includes("editId")) findDifferences(obj1[key], obj2[key], [
                        ...path,
                        key
                    ]);
                });
            } else differences[path.join(".")] = {
                original: obj1,
                current: obj2
            };
        }
        findDifferences(original, current);
        return Object.entries(differences).map(([k, v])=>({
                key: k,
                value: v
            }));
    }
    const handleItemNameDescriptionCategoryChange = (modified, foundMatchedItems, diff)=>{
        let existingItem = foundMatchedItems.find((t)=>t.updatedItem.id === menuItem.id);
        if (existingItem) existingItem.diffs.push({
            key: diff.key,
            diff: modified,
            newValue: diff.value?.current ?? false,
            originalValue: diff.value?.original ?? false
        });
        else {
            const data = {
                updatedItem: menuItem,
                //It is already updated
                diffs: [
                    {
                        key: diff.key,
                        diff: modified,
                        newValue: diff.value?.current ?? false,
                        originalValue: diff.value?.original ?? false
                    }
                ]
            };
            foundMatchedItems.push(data);
        }
    };
    const normalizeName = (name)=>name.trim().toLowerCase();
    const deepEqual = (obj1, obj2)=>{
        return JSON.stringify(obj1) === JSON.stringify(obj2);
    };
    /**
   * Finds the matching items based on the current changes.
   * @param applicationId 
   */ async function askToUpdateOtherItems(applicationId) {
        const diffs = findChangesInMenuItems(originalMenuItem, menuItem);
        const prompts = [
            "initialPromptOverride",
            "simpleInitialPromptOverride",
            "numberedInitialPromptOverride",
            "promptOverride",
            "colloquialName",
            "isDisabled"
        ];
        setFetchingMenu(true);
        let entireMenu;
        const result = await retrieveEntireMenu(applicationId);
        if (result.resultType === "Ok") entireMenu = JSON.parse(JSON.stringify(result.data));
        setFetchingMenu(false);
        const formattedMenuItems = entireMenu.map((menuItem)=>{
            return {
                menuItem: menuItem
            };
        });
        const foundMatchedItems = [];
        const loadedGroups = interactionModelContainer.loadGroups(formattedMenuItems);
        for (const diff of diffs){
            if (diff.key.includes("persistentProperties") || diff.key.includes("editId")) continue;
            //If an option inside the sizeGroups is changed:
            let sizeName = "";
            let sizeGroupIdInKey = "";
            if (diff.key.includes("sizeGroups") && diff.key.includes("optionGroups") && diff.key.split(".")[0] === "sizeGroups") {
                sizeGroupIdInKey = diff.key.split(".").slice(0, 4)[3]; //Get the size Id from the key
                sizeName = menuItem.sizeGroups[0].sizes.find((size)=>size.id === sizeGroupIdInKey).name;
                setSizeName(sizeName); //The sizeName is used in the augmentation process to find the optionGroup
                diff.key = diff.key.split(".").slice(4).join("."); //Remove sizeGroups.sizes and change the it to optionGroups.<refID>.options.<refId>.isDisabled.
            }
            const optionGroupOrSizeGroupKey = diff.key.split("."); // optionGroups.<refID>.options.<refID>.isDisabled ||    optionGroups.<refID>.options.<refID>.optionGroups.<refID>.options.<refID>
            const mainPropertyKey = optionGroupOrSizeGroupKey[0]; //        ↑ look here
            const editedIndex = optionGroupOrSizeGroupKey[3];
            const propertyToChange = optionGroupOrSizeGroupKey[optionGroupOrSizeGroupKey.length - 1];
            let editedOptionGroupName;
            let editedSizeGroupPrompt;
            let editedSizeGroupName;
            let modified;
            let originalOptionName = "";
            let modifiedPath = [];
            let currentGroup = menuItem;
            let currentOptionGroup;
            if (mainPropertyKey === "colloquialName" || mainPropertyKey === "attributes") {
                switch(mainPropertyKey){
                    case "colloquialName":
                        handleItemNameDescriptionCategoryChange("Item Referred to As", foundMatchedItems, diff);
                        break;
                    case "attributes":
                        //attributes.data.description
                        let text;
                        if (optionGroupOrSizeGroupKey[1] === "data" && optionGroupOrSizeGroupKey[2] === "category") text = "Category";
                        else if (optionGroupOrSizeGroupKey[1] === "description") text = "Description";
                        else break;
                        handleItemNameDescriptionCategoryChange(text, foundMatchedItems, diff);
                        break;
                }
                continue;
            }
            //Finding the changes made:
            for(let i = 0; i < optionGroupOrSizeGroupKey.length; i++){
                const key = optionGroupOrSizeGroupKey[i];
                if (key === "optionGroups" && currentGroup && "optionGroups" in currentGroup) {
                    const groupIndex = optionGroupOrSizeGroupKey[++i]; // Get the index of the optionGroup
                    //If there is a sizeGroupId key, it means that an optionGroup is edited in a sizeGroup
                    if (sizeGroupIdInKey !== "" && "sizeGroups" in currentGroup) currentGroup = currentGroup.sizeGroups[0].sizes?.find((og)=>og?.id === sizeGroupIdInKey).optionGroups?.find((og)=>og?.referenceId === groupIndex);
                    else currentGroup = currentGroup.optionGroups?.find((og)=>og?.referenceId === groupIndex);
                    currentOptionGroup = currentGroup;
                    editedOptionGroupName = currentGroup?.name ?? currentGroup?.referenceId;
                    modifiedPath.push(currentGroup?.name ?? currentGroup?.referenceId); // Append the name of the optionGroup
                } else if (key === "options" && currentGroup && "options" in currentGroup) {
                    const optionIndex = optionGroupOrSizeGroupKey[++i]; // Get the index of the option
                    currentGroup = currentGroup.options?.find((o)=>o.id === optionIndex);
                    if (currentGroup) {
                        modifiedPath.push(currentGroup.name); // Append the name of the option
                        originalOptionName = currentGroup.name;
                    }
                } else if (key === "promptIfNoSelections") //eg: key optionGroups.0.options.1.promptIfNoSelections
                modifiedPath.push(propertyToChange);
                else if (key === "numberOfRequiredOptions") modifiedPath.push(propertyToChange);
                else if (key === "isDisabled") modifiedPath.push(propertyToChange);
            }
            let valueToUpdate;
            if (mainPropertyKey === "optionGroups" || diff.key.includes("options")) {
                modified = modifiedPath.join(" - ");
                if (currentGroup) valueToUpdate = currentGroup[propertyToChange];
            } else if (mainPropertyKey === "sizeGroups") {
                editedSizeGroupPrompt = menuItem.sizeGroups[0]?.promptOverride;
                modified = `${editedSizeGroupPrompt}`;
                valueToUpdate = menuItem.sizeGroups[0][propertyToChange];
                if (editedIndex) {
                    editedSizeGroupName = menuItem.sizeGroups[0]?.sizes?.find((s)=>s.id === editedIndex)?.name;
                    modified = `${editedSizeGroupPrompt} -  ${editedSizeGroupName}`;
                    valueToUpdate = menuItem.sizeGroups[0].sizes?.find((s)=>s.id === editedIndex)[propertyToChange];
                }
            }
            if (mainPropertyKey === "sizeGroups" && !diff.key.includes("optionGroups")) entireMenu.forEach((item)=>{
                for (const sizeGroup of item.sizeGroups)if (sizeGroup.promptOverride === editedSizeGroupPrompt) {
                    let existingItem = foundMatchedItems.find((t)=>t.updatedItem.id === item.id);
                    let originalValue;
                    if (editedIndex) {
                        const targetSize = sizeGroup.sizes.find((s)=>s.name.toLowerCase() === menuItem.sizeGroups[0].sizes?.find((s)=>s.id === editedIndex).name.toLowerCase());
                        if (targetSize) {
                            originalValue = targetSize[propertyToChange];
                            targetSize[propertyToChange] = valueToUpdate;
                            targetSize.persistentProperties = menuItem.sizeGroups[0].sizes?.find((s)=>s.id === editedIndex)?.persistentProperties;
                        } else // We need to skip if it doesn't have the size
                        return;
                    } else if (propertyToChange === "isDisabled") {
                        originalValue = sizeGroup[propertyToChange];
                        sizeGroup[propertyToChange] = valueToUpdate;
                    }
                    if (existingItem) {
                        const targetSizeExisting = existingItem.updatedItem.sizeGroups.find((s)=>s.promptOverride === editedSizeGroupPrompt);
                        if (editedIndex) {
                            const targetSizeInExisting = targetSizeExisting?.sizes?.find((s)=>s.name.toLowerCase() === menuItem.sizeGroups[0].sizes?.find((s)=>s.id === editedIndex).name.toLowerCase());
                            if (!targetSizeInExisting) return;
                            originalValue = targetSizeInExisting[propertyToChange];
                            targetSizeInExisting[propertyToChange] = valueToUpdate;
                            targetSizeInExisting.persistentProperties = menuItem.sizeGroups[0].sizes?.find((s)=>s.id === editedIndex)?.persistentProperties;
                        } else {
                            originalValue = targetSizeExisting[propertyToChange];
                            targetSizeExisting[propertyToChange] = valueToUpdate;
                            targetSizeExisting.persistentProperties = menuItem.sizeGroups[0].sizes?.find((s)=>s.id === editedIndex)?.persistentProperties;
                        }
                        if (originalValue === valueToUpdate) break;
                        existingItem.diffs.push({
                            key: diff.key,
                            diff: modified,
                            newValue: diff.value?.current ?? false,
                            originalValue: originalValue ?? false
                        });
                    } else {
                        if (originalValue === valueToUpdate) break;
                        const data = {
                            updatedItem: item,
                            diffs: [
                                {
                                    key: diff.key,
                                    diff: modified,
                                    newValue: diff.value?.current ?? false,
                                    originalValue: originalValue ?? false
                                }
                            ]
                        };
                        foundMatchedItems.push(data);
                    }
                }
            });
            else {
                //Find the optionGroups by edited optionGroup name
                const matches = loadedGroups.uniqueGroups.filter((uniqueGroup)=>{
                    if ("optionGroup" in uniqueGroup) {
                        if (uniqueGroup.optionGroup.name.toLowerCase() === editedOptionGroupName?.toLowerCase()) {
                            //If prompt is changed in the advanced settings. The number of options in the optionGroup has to match. The names should also match
                            if (!diff.key.includes("options") && prompts.includes(propertyToChange)) {
                                if (currentOptionGroup.options.length === uniqueGroup.optionGroup.options.length) {
                                    const sortedArr1 = currentOptionGroup.options.sort((a, b)=>normalizeName(a.name).localeCompare(normalizeName(b.name)));
                                    const sortedArr2 = uniqueGroup.optionGroup.options.sort((a, b)=>normalizeName(a.name).localeCompare(normalizeName(b.name)));
                                    for(let i = 0; i < sortedArr1.length; i++){
                                        if (normalizeName(sortedArr1[i].name) !== normalizeName(sortedArr2[i].name)) return false;
                                    }
                                    return true;
                                } else return false;
                            }
                            // For option-level changes, only match if the option exists in the group
                            if (originalOptionName) return uniqueGroup.optionGroup.options.some((option)=>normalizeName(option.name) === normalizeName(originalOptionName));
                            else if (propertyToChange === "isDisabled" || propertyToChange === "promptIfNoSelections" || propertyToChange === "numberOfRequiredOptions") {
                                if (currentOptionGroup.options.length !== uniqueGroup.optionGroup.options.length) return false;
                                const sortedCurrent = currentOptionGroup.options.sort((a, b)=>normalizeName(a.name).localeCompare(normalizeName(b.name)));
                                const sortedUnique = uniqueGroup.optionGroup.options.sort((a, b)=>normalizeName(a.name).localeCompare(normalizeName(b.name)));
                                return sortedCurrent.every((option, index)=>normalizeName(option.name) === normalizeName(sortedUnique[index].name));
                            }
                        }
                    }
                    return false;
                });
                //Find the items with matches optionGroup
                let matchingItemsIndexes = [];
                for (const match of matches){
                    const foundItem = loadedGroups.matchingGroups.find((obj)=>match.editId in obj)?.[match.editId];
                    if (foundItem) matchingItemsIndexes.push(foundItem);
                }
                let itemOriginalValue = {
                    value: "",
                    id: "",
                    persistentProperties: currentGroup?.persistentProperties
                };
                for (const itemIndexes of matchingItemsIndexes){
                    let existingItems = foundMatchedItems.filter((it)=>itemIndexes.includes(it.updatedItem.id));
                    if (existingItems.length > 0) //If item already exists, only update the specific property and push new data to diffs
                    for (const existingItem of existingItems){
                        let whatsChanged = buildWhatsChanged(sizeGroupIdInKey, sizeName, editedOptionGroupName, originalOptionName);
                        let optionGroupToUse = getOptionGroupToUse(existingItem.updatedItem, sizeGroupIdInKey, sizeName);
                        if (optionGroupToUse === null) continue;
                        itemOriginalValue.id = existingItem.updatedItem.id;
                        findOptionGroupByNameAndUpdateValue(optionGroupToUse, editedOptionGroupName, propertyToChange, originalOptionName, valueToUpdate, prompts, itemOriginalValue, diff.key); //Find and update the existingItem
                        if (itemOriginalValue.value === valueToUpdate) break;
                        const newData = {
                            key: diff.key,
                            diff: editedOptionGroupName,
                            newValue: diff.value?.current ?? false,
                            whatsChanged,
                            originalValue: itemOriginalValue.value ?? false
                        };
                        //Make sure it doesn't exist
                        if (!existingItem.diffs.some((obj)=>deepEqual(obj, newData))) existingItem.diffs.push(newData);
                    }
                    else {
                        let foundItemsInMenu = entireMenu.filter((menuI)=>itemIndexes.includes(menuI.id));
                        for (const foundItemInMenu of foundItemsInMenu){
                            let whatsChanged = buildWhatsChanged(sizeGroupIdInKey, sizeName, editedOptionGroupName, originalOptionName);
                            let optionGroupToUse = getOptionGroupToUse(foundItemInMenu, sizeGroupIdInKey, sizeName);
                            if (optionGroupToUse === null) continue;
                            itemOriginalValue.id = foundItemInMenu.id;
                            findOptionGroupByNameAndUpdateValue(optionGroupToUse, editedOptionGroupName, propertyToChange, originalOptionName, valueToUpdate, prompts, itemOriginalValue, diff.key);
                            if (itemOriginalValue.value === valueToUpdate) break;
                            const data = {
                                updatedItem: foundItemInMenu,
                                diffs: [
                                    {
                                        key: diff.key,
                                        diff: editedOptionGroupName,
                                        whatsChanged,
                                        newValue: diff.value?.current ?? false,
                                        originalValue: itemOriginalValue.value ?? false
                                    }
                                ]
                            };
                            foundMatchedItems.push(data);
                        }
                    }
                }
            }
            const itemIndex = foundMatchedItems.findIndex((item)=>item.updatedItem.originalName.toLowerCase() === menuItem.originalName.toLowerCase());
            if (itemIndex !== -1) {
                const [item] = foundMatchedItems.splice(itemIndex, 1);
                foundMatchedItems.unshift(item);
            }
        }
        setmatchingItemsWithSameOptionGroupOrSizeGroup(foundMatchedItems);
        if (foundMatchedItems.length > 1) setShowAskToUpdateOtherItemsModal(true);
        return foundMatchedItems;
    }
    const getOptionGroupToUse = (item, sizeGroupIdInKey, sizeName)=>{
        let optionGroupToUse = item.optionGroups;
        if (sizeGroupIdInKey !== "") {
            const foundSize = item.sizeGroups[0].sizes.find((size)=>normalizeName(size.name) === normalizeName(sizeName));
            if (!foundSize) return null; // or return whatever makes sense here
            optionGroupToUse = foundSize.optionGroups;
        }
        return optionGroupToUse;
    };
    const buildWhatsChanged = (sizeGroupIdInKey, sizeName, editedOptionGroupName, originalOptionName)=>{
        if (sizeGroupIdInKey !== "") return `Sizes - ${sizeName} - ${editedOptionGroupName} - ${originalOptionName}`;
        return `${editedOptionGroupName} - ${originalOptionName}`;
    };
    async function saveAndAugmentAll(application, orgId) {
        const applicationId = application.manageMenuApplicationId;
        const menuItemsToAugment = [];
        let entireMenu = menuItems;
        if (entireMenu.length === 0) {
            const result = await retrieveEntireMenu(applicationId);
            if (result.resultType === "Ok") entireMenu = result.data;
        }
        const organizedOptionGroupToAugment = Object.values(optionGroupsToAugment.reduce((acc, { optionGroupRefId, menuItemId })=>{
            // Initialize the object for this menuItemId if it doesn't exist
            if (!acc[menuItemId]) acc[menuItemId] = {
                menuItemId,
                optionGroupRefIds: []
            };
            // Add the optionGroupRefId to the array for this menuItemId
            acc[menuItemId].optionGroupRefIds.push(optionGroupRefId);
            return acc;
        }, {}));
        const isGenAIFoodOrdering = application.featureFlags?.some((flag)=>flag.id === (0, _featureFlagIds.GenAIFoodOrdering));
        for (const matchedItem of matchingItemsWithSameOptionGroupOrSizeGroup){
            //If item id is in the itemsToNotAugment, do not save or augment it
            if (itemsToNotAugment.includes(matchedItem.updatedItem.id)) continue;
            const { optionGroupsThatNeedReAugment, sizeGroupsThatNeedReAugment } = findOptionGroupAndSizeGroupsNeedAugment(matchedItem.updatedItem, matchedItem.diffs);
            let optionGroupReferenceIds = optionGroupsThatNeedReAugment.map((obj)=>obj.changedGroup.referenceId).filter((item)=>item);
            const matchedItemOptionGroups = organizedOptionGroupToAugment.find((it)=>it.menuItemId === matchedItem.updatedItem.id);
            if (matchedItemOptionGroups) optionGroupReferenceIds = matchedItemOptionGroups.optionGroupRefIds;
            const sizeGroupIndecies = sizeGroupsThatNeedReAugment.map((obj)=>obj.index);
            //Augment needed
            if (optionGroupReferenceIds.length > 0 || sizeGroupIndecies.length > 0) {
                menuItemsToAugment.push({
                    itemId: matchedItem.updatedItem.id,
                    optionGroupReferenceIdsToAugment: [
                        ...new Set(optionGroupReferenceIds)
                    ],
                    sizeGroupIndeciesToAugment: sizeGroupIndecies?.length ? [
                        0
                    ] : []
                });
                if (menuItemsToAugment.length > 0 && !isGenAIFoodOrdering) matchedItem.updatedItem.lastAugmentStartTime = new Date().getTime().toString(); //Set the start time
            }
            // Save the updated menu items
            const menuUpdateResponse = await applicationNlpMenuContainer.updateVoicifyMenuItem(applicationId, matchedItem.updatedItem);
            if (menuUpdateResponse.resultType !== "Ok") setErrors(menuUpdateResponse.errors);
        }
        const augmentRequest = {
            applicationId,
            forceAugment: true,
            generateMenuItemColloquialNames: false,
            //no need to regenerate colloquial name for the menu item
            generateForOptionGroups: true,
            generateForSizeGroups: true,
            propertiesToAugment: [],
            menuItemsToAugment: menuItemsToAugment,
            orgId: orgId
        };
        if (menuItemsToAugment.length > 0 && !isGenAIFoodOrdering) {
            applicationNlpMenuContainer.augmentMenu(augmentRequest);
            setMenuItemAugmentStatus("loading");
        }
        setShowAskToUpdateOtherItemsModal(false);
    }
    /**
   * Finds the matching option in a menu item and updates the value
   * @param optionGroups 
   * @param groupName option group name
   * @param propertyToChange 
   * @param optionOriginalName the unchanged name of the option
   * @param newValue value to be set
   * @returns null
   */ const findOptionGroupByNameAndUpdateValue = (optionGroups, groupName, propertyToChange, optionOriginalName, newValue, prompts, itemOriginalValue, key)=>{
        // Base case: Iterate over all option groups at the current level
        for (let group of optionGroups){
            // Check if the current optionGroup name matches the groupName
            if (normalizeName(group.name) === normalizeName(groupName)) {
                // Handle prompt changes at the optionGroup level
                if (!key.includes("options") && prompts.includes(propertyToChange)) {
                    itemOriginalValue.value = group[propertyToChange];
                    group[propertyToChange] = newValue;
                    group.persistentProperties = itemOriginalValue.persistentProperties;
                    if (propertyToChange === "colloquialName") setOptionGroupsToAugment((prev)=>[
                            ...prev,
                            {
                                optionGroupRefId: group.referenceId,
                                menuItemId: itemOriginalValue.id
                            }
                        ]);
                    return;
                }
                const countOptionGroups = (key.match(/optionGroups/g) || []).length;
                const countOptions = (key.match(/options/g) || []).length;
                // Only update the group properties if we're at the correct nesting level
                if (countOptionGroups - countOptions === 1 && (propertyToChange === "isDisabled" || propertyToChange === "numberOfRequiredOptions" || propertyToChange === "promptIfNoSelections") && propertyToChange in group) {
                    // Store the original value before updating
                    itemOriginalValue.value = group[propertyToChange];
                    // Only update if the value is actually different
                    if (group[propertyToChange] !== newValue) {
                        group[propertyToChange] = newValue;
                        group.persistentProperties = itemOriginalValue.persistentProperties;
                        if (propertyToChange === "isDisabled" || propertyToChange === "numberOfRequiredOptions") setOptionGroupsToAugment((prev)=>[
                                ...prev,
                                {
                                    optionGroupRefId: group.referenceId,
                                    menuItemId: itemOriginalValue.id
                                }
                            ]);
                    }
                    return;
                }
                // Handle option-level changes
                if (optionOriginalName) {
                    const foundOption = group.options.find((option)=>normalizeName(option.name) === normalizeName(optionOriginalName));
                    if (foundOption) {
                        itemOriginalValue.value = foundOption[propertyToChange];
                        // Only update if the value is actually different
                        if (foundOption[propertyToChange] !== newValue) {
                            foundOption[propertyToChange] = newValue;
                            foundOption.persistentProperties = itemOriginalValue.persistentProperties;
                            if (propertyToChange === "colloquialName") setOptionGroupsToAugment((prev)=>[
                                    ...prev,
                                    {
                                        optionGroupRefId: group.referenceId,
                                        menuItemId: itemOriginalValue.id
                                    }
                                ]);
                        }
                        return;
                    }
                }
            }
            // Recursively check nested option groups
            if (group.options) {
                for (let option of group.options)if (option.optionGroups?.length > 0) {
                    const result = findOptionGroupByNameAndUpdateValue(option.optionGroups, groupName, propertyToChange, optionOriginalName, newValue, prompts, itemOriginalValue, key);
                    if (result !== null) return result;
                }
            }
        }
        return null;
    };
    const getMenuItemsDiff = async (application)=>{
        setLoadingMenuDiff(true);
        try {
            const newMenu = await applicationNlpMenuContainer.getTransformedMenu(application.manageMenuApplicationId, application.posName, application.posLocationId);
            if (newMenu.errors?.length > 0 || !newMenu.data || !newMenu.data.data) {
                setErrors(newMenu.errors ?? [
                    "An error occurred while fetching the menu."
                ]);
                setLoadingMenuDiff(false);
                return;
            }
            const differences = {};
            const transformedMenuItems = newMenu.data?.data?.menuItems || [];
            const currentMenuItems = menuItems || [];
            // Check for removed items (in current but not in transformed)
            for (const currentItem of currentMenuItems){
                const exists = transformedMenuItems.some((t)=>normalizeName(t.originalName) === normalizeName(currentItem.originalName));
                if (!exists) differences[currentItem.originalName] = [
                    "Item removed"
                ];
            }
            // Check for new items and changes (in transformed but not in current)
            for (const transformedItem of transformedMenuItems){
                let currentItem = currentMenuItems.find((c)=>normalizeName(c.originalName) === normalizeName(transformedItem.originalName));
                const currentItemById = currentMenuItems.find((c)=>normalizeName(c.id) === normalizeName(transformedItem.id));
                if (currentItemById) currentItem = currentItemById;
                if (!currentItem) differences[transformedItem.originalName] = [
                    "New item"
                ];
                else {
                    const itemDifferences = getMenuItemDifferences(currentItem, transformedItem);
                    if (itemDifferences.length > 0) differences[currentItem.originalName] = itemDifferences;
                }
            }
            setLoadingMenuDiff(false);
            return differences;
        } catch (error) {
            setErrors([
                error.toString()
            ]);
            setLoadingMenuDiff(false);
            return {};
        }
    };
    const getMenuItemDifferences = (current, transformed)=>{
        const differences = [];
        if (current.originalName !== transformed.originalName) differences.push("Name changed");
        // Check option groups
        if ((current.optionGroups?.length || 0) !== (transformed.optionGroups?.length || 0)) differences.push("Number of option groups changed");
        else if (current.optionGroups && transformed.optionGroups) {
            const optionChanges = getOptionGroupChanges(current.optionGroups, transformed.optionGroups);
            differences.push(...optionChanges);
        }
        // Check size groups
        if ((current.sizeGroups?.length || 0) !== (transformed.sizeGroups?.length || 0)) differences.push("Number of size groups changed");
        else if (current.sizeGroups && transformed.sizeGroups) {
            const sizeChanges = getSizeGroupChanges(current.sizeGroups, transformed.sizeGroups);
            differences.push(...sizeChanges);
        }
        return differences;
    };
    const getOptionGroupChanges = (current, transformed)=>{
        const changes = [];
        for (const currentGroup of current){
            const transformedGroup = transformed.find((g)=>g.name === currentGroup.name);
            if (!transformedGroup) {
                changes.push(`option group '${currentGroup.name}' removed`);
                continue;
            }
            // Compare options within groups
            const currentOptions = currentGroup.options?.map((o)=>o.name) || [];
            const transformedOptions = transformedGroup.options?.map((o)=>o.name) || [];
            const addedOptions = transformedOptions.filter((o)=>!currentOptions.includes(o));
            const removedOptions = currentOptions.filter((o)=>!transformedOptions.includes(o));
            addedOptions.forEach((added)=>{
                changes.push(`option - ${added} added`);
            });
            removedOptions.forEach((removed)=>{
                changes.push(`option - ${removed} removed`);
            });
            for (let currentOption of currentGroup.options){
                let transformedOption = transformedGroup.options.find((o)=>o.id == currentOption.id);
                if (!transformedOption) transformedOption = transformedGroup.options.find((o)=>o.name == currentOption.name);
                if (transformedOption) {
                    let currentOptionCopy = JSON.parse(JSON.stringify(currentOption));
                    currentOptionCopy.persistentProperties = undefined;
                    currentOptionCopy.attributes.persistentProperties = undefined;
                    currentOptionCopy.disableInferencing = undefined;
                    currentOptionCopy.isDisabled = undefined;
                    transformedOption.modifier = undefined;
                    if (!areJsonsEqual(currentOptionCopy, transformedOption)) changes.push(`option - ${currentOption.name} changed`);
                }
            }
        }
        // Check for new groups
        const newGroups = transformed.filter((g)=>!current.some((c)=>c.name === g.name));
        newGroups.forEach((newGroup)=>{
            changes.push(`option group '${newGroup.name}' added`);
        });
        return changes;
    };
    const getSizeGroupChanges = (current, transformed)=>{
        const changes = [];
        for(let i = 0; i < current.length; i++){
            const currentSizes = current[i].sizes?.map((s)=>s.name) || [];
            const transformedSizes = transformed[i].sizes?.map((s)=>s.name) || [];
            const addedSizes = transformedSizes.filter((s)=>!currentSizes.includes(s));
            const removedSizes = currentSizes.filter((s)=>!transformedSizes.includes(s));
            addedSizes.forEach((added)=>{
                changes.push(`size - ${added} added`);
            });
            removedSizes.forEach((removed)=>{
                changes.push(`size - ${removed} removed`);
            });
        }
        return changes;
    };
    function areJsonsEqual(a, b) {
        return deepEqualIgnoringExtra(a, b) && deepEqualIgnoringExtra(b, a);
    }
    function deepEqualIgnoringExtra(a, b) {
        if (a === b) return true;
        if (typeof a !== typeof b) return false;
        if (Array.isArray(a) && Array.isArray(b)) {
            if (a.length !== b.length) return false;
            return a.every((item, index)=>deepEqualIgnoringExtra(item, b[index]));
        }
        if (typeof a === "object" && a !== null && b !== null) {
            const sharedKeys = Object.keys(a).filter((key)=>key in b);
            return sharedKeys.every((key)=>deepEqualIgnoringExtra(a[key], b[key]));
        }
        return false;
    }
    return {
        menuItem,
        activeEditId,
        path,
        isLoadingMenu,
        loadingMenuDiff,
        menuItems,
        categories,
        isMenuItemEdited,
        menuItemAugmentStatus,
        setActiveEditId,
        setMenuItem,
        setPath,
        getMenu,
        getLiveMenu,
        setCategories,
        setMenuItems,
        resetMenuItemSelections,
        updateMenuItem,
        updateMenu,
        handleDisableEnableCategory,
        syncMenuWithPOS,
        showConfirmationModal,
        setShowConfirmationModal,
        errors,
        loadingPOSMenuSync,
        publishAllChanges,
        ladingPublishAllChanges,
        setOriginalMenuItem,
        getMenuItem,
        setMenuItemAugmentStatus,
        getCleanedMenuItemForAugment,
        showAskToUpdateOtherItemsModal,
        setShowAskToUpdateOtherItemsModal,
        askToUpdateOtherItems,
        setmatchingItemsWithSameOptionGroupOrSizeGroup,
        matchingItemsWithSameOptionGroupOrSizeGroup,
        findChangesInMenuItems,
        itemsToNotAugment,
        setItemsToNotAugment,
        saveAndAugmentAll,
        pendingMenuItemUpdates,
        fetchingMenu,
        getMenuItemsDiff,
        loadMenuSyncModule,
        menuSyncRequest,
        submitMenuSyncRequest
    };
}
const MenuContainer = (0, _unstatedNext.createContainer)(useMenuContainer);
exports.default = MenuContainer;

},{"react":"6uln9","unstated-next":"61zE5","../api":"loxM6","./ApplicationNlpMenuContainer":"jposS","uuid":"klst7","lodash":"3hMBK","./InteractionModelContainer":"5cw5C","./MenuSyncContainer":"dn6gk","../constants/featureFlagIds":"33vuW","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jposS":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _unstatedNext = require("unstated-next");
var _api = require("../api");
function useApplicationNlpMenuContainer() {
    const [isLoading, setIsLoading] = (0, _react.useState)(false);
    const [errors, setErrors] = (0, _react.useState)([]);
    const [menuItems, setMenuItems] = (0, _react.useState)([]);
    const loadAllMenuItems = async (applicationId)=>{
        try {
            setIsLoading(true);
            const result = await _api.getVoicifyMenuItems(applicationId);
            if (result.resultType == "Ok") setMenuItems(result.data);
            else if (result.errors != null && result.errors.length > 0) setErrors([
                ...result.errors
            ]);
            setIsLoading(false);
            return result;
        } catch (error) {
            setErrors([
                error
            ]);
            setIsLoading(false);
        }
    };
    const updateMenuItems = async (applicationId, menuItems)=>{
        try {
            setIsLoading(true);
            const result = await _api.updateVoicifyMenuItems(applicationId, menuItems);
            if (result.errors != null && result.errors.length > 0) setErrors([
                ...result.errors
            ]);
            setIsLoading(false);
            return result;
        } catch (error) {
            setErrors([
                error
            ]);
            setIsLoading(false);
        }
    };
    const augmentMenu = async (request)=>{
        try {
            setIsLoading(true);
            const result = await _api.augmentMenu(request);
            if (result.errors != null && result.errors.length > 0) setErrors([
                ...result.errors
            ]);
            setIsLoading(false);
            return result;
        } catch (error) {
            setErrors([
                error
            ]);
            setIsLoading(false);
        }
    };
    const addVoicifyMenuItem = async (applicationId, request)=>{
        try {
            setIsLoading(true);
            const result = await _api.addVoicifyMenuItem(applicationId, request);
            if (result.errors != null && result.errors.length > 0) setErrors([
                ...result.errors
            ]);
            setIsLoading(false);
            return result;
        } catch (error) {
            setErrors([
                error
            ]);
            setIsLoading(false);
        }
    };
    const updateVoicifyMenuItem = async (applicationId, request)=>{
        try {
            setIsLoading(true);
            const result = await _api.updateVoicifyMenuItem(applicationId, request);
            if (result.errors != null && result.errors.length > 0) setErrors([
                ...result.errors
            ]);
            setIsLoading(false);
            return result;
        } catch (error) {
            setErrors([
                error
            ]);
            setIsLoading(false);
        }
    };
    const getTransformedMenu = async (applicationId, posName, locationId)=>{
        try {
            setIsLoading(true);
            const result = await _api.getTransformedMenu(applicationId, posName, locationId);
            if (result.errors != null && result.errors.length > 0) setErrors([
                ...result.errors
            ]);
            setIsLoading(false);
            return result;
        } catch (error) {
            setErrors([
                error
            ]);
            setIsLoading(false);
        }
    };
    const deleteVoicifyMenuItem = async (applicationId, menuItemId)=>{
        try {
            setIsLoading(true);
            const result = await _api.deleteVoicifyMenuItem(applicationId, menuItemId);
            if (result.errors != null && result.errors.length > 0) setErrors([
                ...result.errors
            ]);
            setIsLoading(false);
            return result;
        } catch (error) {
            setErrors([
                error
            ]);
            setIsLoading(false);
        }
    };
    const clearErrors = ()=>{
        setErrors([]);
    };
    return {
        updateMenuItems,
        loadAllMenuItems,
        menuItems,
        isLoading,
        errors,
        clearErrors,
        addVoicifyMenuItem,
        updateVoicifyMenuItem,
        deleteVoicifyMenuItem,
        augmentMenu,
        getTransformedMenu
    };
}
const ApplicationNlpMenuContainer = (0, _unstatedNext.createContainer)(useApplicationNlpMenuContainer);
exports.default = ApplicationNlpMenuContainer;

},{"react":"6uln9","unstated-next":"61zE5","../api":"loxM6","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"klst7":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "v1", ()=>(0, _v1JsDefault.default));
parcelHelpers.export(exports, "v3", ()=>(0, _v3JsDefault.default));
parcelHelpers.export(exports, "v4", ()=>(0, _v4JsDefault.default));
parcelHelpers.export(exports, "v5", ()=>(0, _v5JsDefault.default));
parcelHelpers.export(exports, "NIL", ()=>(0, _nilJsDefault.default));
parcelHelpers.export(exports, "version", ()=>(0, _versionJsDefault.default));
parcelHelpers.export(exports, "validate", ()=>(0, _validateJsDefault.default));
parcelHelpers.export(exports, "stringify", ()=>(0, _stringifyJsDefault.default));
parcelHelpers.export(exports, "parse", ()=>(0, _parseJsDefault.default));
var _v1Js = require("./v1.js");
var _v1JsDefault = parcelHelpers.interopDefault(_v1Js);
var _v3Js = require("./v3.js");
var _v3JsDefault = parcelHelpers.interopDefault(_v3Js);
var _v4Js = require("./v4.js");
var _v4JsDefault = parcelHelpers.interopDefault(_v4Js);
var _v5Js = require("./v5.js");
var _v5JsDefault = parcelHelpers.interopDefault(_v5Js);
var _nilJs = require("./nil.js");
var _nilJsDefault = parcelHelpers.interopDefault(_nilJs);
var _versionJs = require("./version.js");
var _versionJsDefault = parcelHelpers.interopDefault(_versionJs);
var _validateJs = require("./validate.js");
var _validateJsDefault = parcelHelpers.interopDefault(_validateJs);
var _stringifyJs = require("./stringify.js");
var _stringifyJsDefault = parcelHelpers.interopDefault(_stringifyJs);
var _parseJs = require("./parse.js");
var _parseJsDefault = parcelHelpers.interopDefault(_parseJs);

},{"./v1.js":false,"./v3.js":false,"./v4.js":"fpA4M","./v5.js":false,"./nil.js":false,"./version.js":false,"./validate.js":false,"./stringify.js":false,"./parse.js":false,"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"fpA4M":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _rngJs = require("./rng.js");
var _rngJsDefault = parcelHelpers.interopDefault(_rngJs);
var _stringifyJs = require("./stringify.js");
var _stringifyJsDefault = parcelHelpers.interopDefault(_stringifyJs);
function v4(options, buf, offset) {
    options = options || {};
    var rnds = options.random || (options.rng || (0, _rngJsDefault.default))(); // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
    rnds[6] = rnds[6] & 0x0f | 0x40;
    rnds[8] = rnds[8] & 0x3f | 0x80; // Copy bytes to buffer, if provided
    if (buf) {
        offset = offset || 0;
        for(var i = 0; i < 16; ++i)buf[offset + i] = rnds[i];
        return buf;
    }
    return (0, _stringifyJsDefault.default)(rnds);
}
exports.default = v4;

},{"./rng.js":"lpvWd","./stringify.js":"fHrI1","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"lpvWd":[function(require,module,exports) {
// Unique ID creation requires a high quality random # generator. In the browser we therefore
// require the crypto API and do not support built-in fallback to lower quality random number
// generators (like Math.random()).
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>rng);
var getRandomValues;
var rnds8 = new Uint8Array(16);
function rng() {
    // lazy load so that environments that need to polyfill have a chance to do so
    if (!getRandomValues) {
        // getRandomValues needs to be invoked in a context where "this" is a Crypto implementation. Also,
        // find the complete implementation of crypto (msCrypto) on IE11.
        getRandomValues = typeof crypto !== "undefined" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto !== "undefined" && typeof msCrypto.getRandomValues === "function" && msCrypto.getRandomValues.bind(msCrypto);
        if (!getRandomValues) throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
    }
    return getRandomValues(rnds8);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"fHrI1":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _validateJs = require("./validate.js");
var _validateJsDefault = parcelHelpers.interopDefault(_validateJs);
/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */ var byteToHex = [];
for(var i = 0; i < 256; ++i)byteToHex.push((i + 0x100).toString(16).substr(1));
function stringify(arr) {
    var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    // Note: Be careful editing this code!  It's been tuned for performance
    // and works in ways you may not expect. See https://github.com/uuidjs/uuid/pull/434
    var uuid = (byteToHex[arr[offset + 0]] + byteToHex[arr[offset + 1]] + byteToHex[arr[offset + 2]] + byteToHex[arr[offset + 3]] + "-" + byteToHex[arr[offset + 4]] + byteToHex[arr[offset + 5]] + "-" + byteToHex[arr[offset + 6]] + byteToHex[arr[offset + 7]] + "-" + byteToHex[arr[offset + 8]] + byteToHex[arr[offset + 9]] + "-" + byteToHex[arr[offset + 10]] + byteToHex[arr[offset + 11]] + byteToHex[arr[offset + 12]] + byteToHex[arr[offset + 13]] + byteToHex[arr[offset + 14]] + byteToHex[arr[offset + 15]]).toLowerCase(); // Consistency check for valid UUID.  If this throws, it's likely due to one
    // of the following:
    // - One or more input array values don't map to a hex octet (leading to
    // "undefined" in the uuid)
    // - Invalid input values for the RFC `version` or `variant` fields
    if (!(0, _validateJsDefault.default)(uuid)) throw TypeError("Stringified UUID is invalid");
    return uuid;
}
exports.default = stringify;

},{"./validate.js":"d35r5","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"d35r5":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _regexJs = require("./regex.js");
var _regexJsDefault = parcelHelpers.interopDefault(_regexJs);
function validate(uuid) {
    return typeof uuid === "string" && (0, _regexJsDefault.default).test(uuid);
}
exports.default = validate;

},{"./regex.js":"agidw","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"agidw":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"5cw5C":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _unstatedNext = require("unstated-next");
var _api = require("../api");
var _uuid = require("uuid");
function useInteractionModelContainer() {
    const [interactionModels, setInteractionModel] = (0, _react.useState)([]);
    const [errors, setErrors] = (0, _react.useState)([]);
    const [isLoading, setIsLoading] = (0, _react.useState)(false);
    const [currentApplicationId, setCurrentApplicationId] = (0, _react.useState)(null);
    const [editedMenuItems, setEditedMenuItems] = (0, _react.useState)([]);
    const [sizeGroupsList, setSizeGroupsList] = (0, _react.useState)();
    const [sizeGroupMatches, setSizeGroupMatches] = (0, _react.useState)();
    const [optionGroupsList, setOptionGroupsList] = (0, _react.useState)();
    const [optionGroupMatches, setOptionGroupMatches] = (0, _react.useState)();
    const loadInteractionModels = async (applicationId, inLanguages)=>{
        try {
            setIsLoading(true);
            const promises = [];
            for(let i = 0; i < inLanguages.length; i++)promises.push(_api.getInteractionModelByLocale(applicationId, inLanguages[i].shortCode));
            const results = await Promise.all(promises);
            const newInteractionModels = [];
            for(let i = 0; i < results.length; ++i){
                const result = results[i];
                if (result.resultType != "Ok") {
                    setErrors([
                        ...errors,
                        ...result.errors,
                        "Unable to load Interaction Model"
                    ]);
                    setIsLoading(false);
                    return;
                }
                newInteractionModels.push(result.data);
            }
            setInteractionModel(newInteractionModels);
            setCurrentApplicationId(applicationId);
            setIsLoading(false);
            return {
                resultType: "Ok",
                data: newInteractionModels,
                errors: null
            };
        } catch (e) {
            setErrors([
                e?.toString(),
                "Unable to load Interaction Models"
            ]);
            setIsLoading(false);
            return {
                resultType: "Invalid",
                data: null,
                errors: [
                    e.toString()
                ]
            };
        }
    };
    const updateNlpEntitiesAndInteractionModelForApplication = async (applicationId, request)=>{
        try {
            setIsLoading(true);
            const result = await _api.updateNlpEntitiesAndInteractionModelForApplication(applicationId, request);
            if (result?.resultType === "Ok") {
                setIsLoading(false);
                return result;
            } else await setErrors([
                ...errors,
                ...result.errors,
                "Unable to Update Application NLP Entities and Interaction Model"
            ]);
            setIsLoading(false);
        } catch (e) {
            setErrors([
                e?.toString(),
                "Unable to Update Application NLP Entities and Interaction Model"
            ]);
            setIsLoading(false);
        }
    };
    const updateInteractionModel = async (applicationId, languageShortCode, request)=>{
        try {
            setIsLoading(true);
            const result = await _api.commitUpdateToInteractionModel(applicationId, languageShortCode, request);
            if (result?.resultType === "Ok") {
                setIsLoading(false);
                return result;
            } else await setErrors([
                ...errors,
                ...result.errors,
                "Unable to Update Interaction Model"
            ]);
            setIsLoading(false);
        } catch (e) {
            setErrors([
                e?.toString(),
                "Unable to Update Interaction Model"
            ]);
            setIsLoading(false);
        }
    };
    const clearErrors = ()=>{
        setErrors([]);
    };
    const loadGroups = (menuItems, menuEditorView = "Option Groups")=>{
        const uniqueGroups = [];
        const matchingGroups = [];
        const updatedMenuItems = [
            ...menuItems
        ];
        for (const updatedMenuItem of updatedMenuItems){
            let groupsForMenuItem = [];
            groupsForMenuItem = getAllOptionGroups(updatedMenuItem.menuItem);
            for (const group of groupsForMenuItem){
                let editedGroup;
                if ("options" in group) editedGroup = createOptionGroupForEditing(group);
                else if ("sizes" in group) editedGroup = createSizeGroupForEditing(group);
                let foundMatch = false;
                for (const uniqueGroup of uniqueGroups){
                    let theyMatch = false;
                    if ("optionGroup" in editedGroup && "optionGroup" in uniqueGroup) theyMatch = groupsMatch(editedGroup.optionGroup, uniqueGroup.optionGroup);
                    else if ("sizeGroup" in editedGroup && "sizeGroup" in uniqueGroup) theyMatch = groupsMatch(editedGroup.sizeGroup, uniqueGroup.sizeGroup);
                    if (theyMatch) {
                        foundMatch = true;
                        group.editId = uniqueGroup.editId;
                        if ("options" in group && "optionGroup" in uniqueGroup) for (const optionGroupOption of group.options)optionGroupOption.editId = uniqueGroup.optionGroup.options.find((uniqueOptionGroupOption)=>{
                            return optionKey(uniqueOptionGroupOption) === optionKey(optionGroupOption);
                        })?.editId;
                        else if ("sizes" in group && "sizeGroup" in uniqueGroup) for (const sizeGroupSize of group.sizes)sizeGroupSize.editId = uniqueGroup.sizeGroup.sizes.find((uniqueSizeGroupSize)=>{
                            return optionKey(uniqueSizeGroupSize) === optionKey(sizeGroupSize);
                        })?.editId;
                        const matchIndex = matchingGroups.findIndex((match)=>{
                            return match[group.editId];
                        });
                        // add menu item id to existing optionGroup
                        if (!matchingGroups[matchIndex][group.editId].includes(updatedMenuItem.menuItem.id)) matchingGroups[matchIndex][group.editId].push(updatedMenuItem.menuItem.id);
                        break;
                    }
                }
                if (!foundMatch) {
                    editedGroup.editId = (0, _uuid.v4)();
                    group.editId = editedGroup.editId;
                    if ("options" in group && "optionGroup" in editedGroup) for (const optionGroupOption of group.options){
                        optionGroupOption.editId = (0, _uuid.v4)();
                        const option = editedGroup.optionGroup.options.find((uniqueOptionGroupOption)=>{
                            return optionKey(uniqueOptionGroupOption) === optionKey(optionGroupOption);
                        });
                        option.editId = optionGroupOption.editId;
                    }
                    else if ("sizes" in group && "sizeGroup" in editedGroup) for (const sizeGroupSize of group.sizes){
                        sizeGroupSize.editId = (0, _uuid.v4)();
                        const size = editedGroup.sizeGroup.sizes.find((uniqueSizeGroupSize)=>{
                            return optionKey(uniqueSizeGroupSize) === optionKey(sizeGroupSize);
                        });
                        size.editId = sizeGroupSize.editId;
                    }
                    uniqueGroups.push(editedGroup);
                    matchingGroups.push({
                        [editedGroup.editId]: [
                            updatedMenuItem.menuItem.id
                        ]
                    });
                }
            }
            // sort option groups alphabetically
            if (menuEditorView === "Option Groups") uniqueGroups.sort((a, b)=>{
                if ("optionGroup" in a && "optionGroup" in b) {
                    if (a.optionGroup.name < b.optionGroup.name) return -1;
                    if (a.optionGroup.name > b.optionGroup.name) return 1;
                }
                return 0;
            });
            setEditedMenuItems(updatedMenuItems);
            if (menuEditorView === "Option Groups") {
                setOptionGroupsList(uniqueGroups);
                setOptionGroupMatches(matchingGroups);
            } else {
                setSizeGroupsList(uniqueGroups);
                setSizeGroupMatches(matchingGroups);
            }
        }
        return {
            uniqueGroups,
            matchingGroups
        };
    };
    const getAllOptionGroups = (item)=>{
        const optionGroupsList = [
            ...item.optionGroups ?? []
        ];
        for (const optionGroup of item.optionGroups){
            for (const option of optionGroup?.options)if (option?.optionGroups?.length > 0) optionGroupsList.push(...getAllOptionGroups(option));
        }
        if ("sizeGroups" in item) for (const sizeGroup of item.sizeGroups){
            for (const size of sizeGroup?.sizes)if (size?.optionGroups?.length > 0) optionGroupsList.push(...getAllOptionGroups(size));
        }
        return optionGroupsList;
    };
    const createOptionGroupForEditing = (optionGroup)=>{
        let editedOptionGroup;
        if (!optionGroup) editedOptionGroup = {
            optionGroup: {
                referenceId: undefined,
                name: undefined,
                colloquialName: undefined,
                numberOfRequiredOptions: undefined,
                maxSelections: undefined,
                limiter: undefined,
                promptOverride: undefined,
                initialPromptOverride: undefined,
                simpleInitialPromptOverride: undefined,
                numberedInitialPromptOverride: undefined,
                automaticallyAddDefault: undefined,
                isRequired: undefined,
                promptIfNoSelections: undefined,
                options: []
            },
            editId: undefined
        };
        else editedOptionGroup = {
            optionGroup: {
                ...optionGroup,
                editId: undefined,
                referenceId: undefined,
                options: optionGroup.options?.map((option)=>{
                    let editedOption;
                    if (!option) editedOption = {
                        id: undefined,
                        parentId: undefined,
                        name: undefined,
                        colloquialName: undefined,
                        modifier: undefined,
                        default: undefined,
                        fixed: undefined,
                        isPrimaryOption: undefined,
                        ignoreForReadout: undefined,
                        hasQuantity: undefined,
                        defaultQuantity: undefined,
                        minQuantity: undefined,
                        maxQuantity: undefined,
                        disableInferencing: undefined,
                        optionGroups: undefined,
                        editId: undefined
                    };
                    else editedOption = option;
                    return {
                        ...editedOption,
                        optionGroups: undefined,
                        id: undefined,
                        parentId: undefined
                    };
                }) || []
            }
        };
        editedOptionGroup.optionGroup.options?.forEach((o)=>{
            if (o) {
                const excludeProperties = [
                    "editId",
                    "referenceId",
                    "id",
                    "parentId",
                    "options"
                ];
                Object.keys(o).forEach((key)=>{
                    if (!excludeProperties.includes(key) && o[key] === null || o[key] === undefined) delete o[key];
                });
            }
        });
        sortOptionsOrSizes(editedOptionGroup.optionGroup.options);
        return editedOptionGroup;
    };
    const createSizeGroupForEditing = (menuItemSizeGroup)=>{
        let editedSizeGroup;
        if (!menuItemSizeGroup) editedSizeGroup = {
            sizeGroup: {
                numberOfRequiredSizes: undefined,
                promptOverride: undefined,
                sizes: [],
                initialPromptOverride: undefined,
                numberedInitialPromptOverride: undefined
            },
            editId: undefined
        };
        else editedSizeGroup = {
            sizeGroup: {
                ...menuItemSizeGroup,
                editId: undefined,
                sizes: menuItemSizeGroup.sizes?.map((size)=>{
                    let editedSize;
                    if (!size) editedSize = {
                        id: undefined,
                        name: undefined,
                        colloquialName: undefined,
                        default: undefined,
                        fixed: undefined,
                        ignoreForReadout: undefined,
                        disableInferencing: undefined,
                        optionGroups: undefined
                    };
                    else editedSize = size;
                    return {
                        ...editedSize,
                        optionGroups: undefined,
                        id: undefined,
                        parentId: undefined
                    };
                }) || []
            }
        };
        editedSizeGroup.sizeGroup.sizes?.forEach((size)=>{
            if (sizeGroupMatches) {
                const excludeProperties = [
                    "editId",
                    "sizes"
                ];
                Object.keys(setSizeGroupsList).forEach((key)=>{
                    if (!excludeProperties.includes(key) && size[key] === null || size[key] === undefined) delete size[key];
                });
            }
        });
        sortOptionsOrSizes(editedSizeGroup.sizeGroup.sizes);
        return editedSizeGroup;
    };
    const sortOptionsOrSizes = (sizesOrOptions)=>{
        sizesOrOptions?.sort((a, b)=>{
            if (!a || !a.name) return -1;
            if (!b || !b.name) return 1;
            const key1 = optionKey(a);
            const key2 = optionKey(b);
            const nameA = key1.toLowerCase();
            const nameB = key2.toLowerCase();
            if (nameA < nameB) return -1;
            if (nameA > nameB) return 1;
            return 0;
        });
    };
    const groupsMatch = (obj1, obj2)=>{
        const excludeProperties = [
            "editId",
            "referenceId",
            "id",
            "parentId"
        ];
        const deepEqual = (val1, val2, exclude = [])=>{
            if (val1 === val2) return true;
            if (typeof val1 !== "object" || val1 === null || typeof val2 !== "object" || val2 === null) return false;
            if (Array.isArray(val1) && Array.isArray(val2)) {
                if (val1.length !== val2.length) return false;
                for(let i = 0; i < val1.length; i++){
                    if (!deepEqual(val1[i], val2[i], exclude)) return false;
                }
                return true;
            }
            const keys1 = Object.keys(val1);
            const keys2 = Object.keys(val2);
            const validKeys1 = keys1.filter((key)=>!exclude.includes(key));
            const validKeys2 = keys2.filter((key)=>!exclude.includes(key));
            if (validKeys1.length !== validKeys2.length) return false;
            for (const key of validKeys1){
                if (!validKeys2.includes(key)) return false;
                if (!deepEqual(val1[key], val2[key], exclude)) return false;
            }
            return true;
        };
        return deepEqual(obj1, obj2, excludeProperties);
    };
    const optionKey = (option)=>{
        return `${option?.name ?? "unknown-name"}-${option.modifier ?? "unknown-modifier"}`;
    };
    return {
        interactionModels,
        errors,
        isLoading,
        currentApplicationId,
        setErrors,
        clearErrors,
        loadInteractionModels,
        updateNlpEntitiesAndInteractionModelForApplication,
        updateInteractionModel,
        loadGroups,
        sizeGroupMatches,
        setSizeGroupMatches,
        optionGroupMatches,
        optionGroupsList,
        setOptionGroupsList,
        setOptionGroupMatches,
        sizeGroupsList,
        setSizeGroupsList,
        editedMenuItems,
        setEditedMenuItems
    };
}
const InteractionModelContainer = (0, _unstatedNext.createContainer)(useInteractionModelContainer);
exports.default = InteractionModelContainer;

},{"react":"6uln9","unstated-next":"61zE5","../api":"loxM6","uuid":"klst7","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"dn6gk":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _unstatedNext = require("unstated-next");
var _notificationsContainer = require("./NotificationsContainer");
var _notificationsContainerDefault = parcelHelpers.interopDefault(_notificationsContainer);
var _keys = require("../constants/Keys");
var _moment = require("moment");
var _momentDefault = parcelHelpers.interopDefault(_moment);
function useMenuSyncContainer() {
    const notificationContainer = (0, _notificationsContainerDefault.default).useContainer();
    const [syncingMenus, setSyncingMenus] = (0, _react.useState)([]);
    const [counter, setCounter] = (0, _react.useState)(0);
    const [isPolling, setIsPolling] = (0, _react.useState)(false);
    (0, _react.useEffect)(()=>{
        const storedState = getStoredState();
        setSyncingMenus(storedState);
    }, []);
    (0, _react.useEffect)(()=>{
        asyncPoll();
    }, [
        counter
    ]);
    const asyncPoll = async ()=>{
        // wait 3 seconds first
        await new Promise((resolve)=>setTimeout(resolve, 3000));
        const notifications = (await notificationContainer.getNotifications())?.data;
        if (!notifications?.length) return;
        const newSyncingMenus = [];
        for (const sync of syncingMenus){
            if ((0, _momentDefault.default)().diff(sync.syncStart, "minutes") > 15) continue;
            if (notifications.some((n)=>n?.markdown?.endsWith(sync.processId))) continue;
            newSyncingMenus.push(sync);
        }
        setSyncingMenus(newSyncingMenus);
        storeState(newSyncingMenus);
        if (!newSyncingMenus.length) setIsPolling(false);
        else setCounter(counter + 1);
    };
    const getStoredState = ()=>{
        let storedState = [];
        const storedTrainingState = localStorage.getItem((0, _keys.VOICIFY_MENU_SYNC_STATE));
        if (storedTrainingState) storedState = JSON.parse(storedTrainingState);
        return storedState;
    };
    const storeState = (state)=>{
        const json = JSON.stringify(state);
        localStorage.setItem((0, _keys.VOICIFY_MENU_SYNC_STATE), json);
    };
    const isApplicationSyncing = (applicationId)=>{
        const sync = syncingMenus.find((s)=>s.applicationId == applicationId);
        if (!sync) return false;
        if ((0, _momentDefault.default)().diff(sync.syncStart, "minutes") > 5) {
            const newSyncingMenus = syncingMenus.filter((s)=>s.applicationId !== applicationId);
            setSyncingMenus(newSyncingMenus);
            storeState(newSyncingMenus);
            return false;
        }
        return true;
    };
    const startMenuSync = async (applicationId, processId)=>{
        const newArr = [
            ...syncingMenus,
            {
                applicationId,
                processId,
                syncStart: (0, _momentDefault.default)()
            }
        ];
        setSyncingMenus(newArr);
        storeState(newArr);
        if (!isPolling) setCounter(counter + 1);
    };
    return {
        isApplicationSyncing,
        startMenuSync,
        syncingMenus
    };
}
const MenuSyncContainer = (0, _unstatedNext.createContainer)(useMenuSyncContainer);
exports.default = MenuSyncContainer;

},{"react":"6uln9","unstated-next":"61zE5","./NotificationsContainer":"hNroK","../constants/Keys":"4iC9Z","moment":"2meyw","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hNroK":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _unstatedNext = require("unstated-next");
var _api = require("../api");
function useNotificationsContainer() {
    const [isLoading, setIsLoading] = (0, _react.useState)(false);
    const [notifications, setNotifications] = (0, _react.useState)([]);
    const [errors, setErrors] = (0, _react.useState)([]);
    const getNotifications = async ()=>{
        try {
            setIsLoading(true);
            const result = await _api.getAllNotifications();
            if (result.resultType == "Ok") {
                const newNots = result.data.sort(function(a, b) {
                    return new Date(b.startDate).getTime() - new Date(a.startDate).getTime();
                });
                setNotifications(newNots);
                setErrors([]);
            } else setErrors(result.errors);
            setIsLoading(false);
            return result;
        } catch (e) {
            setIsLoading(false);
            setErrors(e);
        }
    };
    const markAllNotificationsAsRead = async ()=>{
        try {
            setIsLoading(true);
            const result = await _api.markAllNotificationsAsRead();
            if (result.resultType == "Ok") {
                const newNotifications = [
                    ...notifications
                ];
                newNotifications.forEach((n)=>n.isRead = true);
                setNotifications(newNotifications);
                setErrors([]);
            } else setErrors(result.errors);
            setIsLoading(false);
            return result;
        } catch (e) {
            setIsLoading(false);
            setErrors(e);
        }
    };
    const markNotificationAsRead = async (notificationId)=>{
        try {
            setIsLoading(true);
            const result = await _api.markNotificationAsRead(notificationId);
            if (result.resultType == "Ok") {
                const newNotifications = [
                    ...notifications
                ];
                newNotifications.find((n)=>n.id === notificationId).isRead = true;
                setNotifications(newNotifications);
                setErrors([]);
            } else setErrors(result.errors);
            setIsLoading(false);
            return result;
        } catch (e) {
            setIsLoading(false);
            setErrors(e);
        }
    };
    const clearErrors = ()=>{
        setErrors([]);
    };
    return {
        isLoading,
        notifications,
        setNotifications,
        errors,
        clearErrors,
        markAllNotificationsAsRead,
        markNotificationAsRead,
        getNotifications
    };
}
const NotificationsContainer = (0, _unstatedNext.createContainer)(useNotificationsContainer);
exports.default = NotificationsContainer;

},{"react":"6uln9","unstated-next":"61zE5","../api":"loxM6","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"33vuW":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "FoodOrderingFeatureFlagId", ()=>FoodOrderingFeatureFlagId);
parcelHelpers.export(exports, "AIAnsweringFeatureFlagId", ()=>AIAnsweringFeatureFlagId);
parcelHelpers.export(exports, "GenAIFoodOrdering", ()=>GenAIFoodOrdering);
parcelHelpers.export(exports, "OutboundCallFeatureFlagId", ()=>OutboundCallFeatureFlagId);
parcelHelpers.export(exports, "HealthcareSchedulingFeatureFlagId", ()=>HealthcareSchedulingFeatureFlagId);
parcelHelpers.export(exports, "GENERATIVE_CALL_REVIEW_FEATURE_FLAG_IDS", ()=>GENERATIVE_CALL_REVIEW_FEATURE_FLAG_IDS);
const FoodOrderingFeatureFlagId = "30b79e69-62ad-4f9d-b7a4-befaa12e9c86";
const AIAnsweringFeatureFlagId = "a3d1f8ce-3f0a-4dbe-b3b5-653d3f16b022";
const GenAIFoodOrdering = "4a8e0e9f-82bb-4504-b288-58e1d755cecb";
const OutboundCallFeatureFlagId = "78bcb04d-c8d2-4cbb-adab-1816f9ff2043";
const HealthcareSchedulingFeatureFlagId = "90473acb-7f54-453a-933b-4602f901741f";
const GENERATIVE_CALL_REVIEW_FEATURE_FLAG_IDS = [
    FoodOrderingFeatureFlagId,
    GenAIFoodOrdering,
    HealthcareSchedulingFeatureFlagId
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"kJJQi":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useBulkAppOperations", ()=>useBulkAppOperations);
var _react = require("react");
var _api = require("../api");
const useBulkAppOperations = (options)=>{
    const { appliedTemplateContainer, applicationEnvironmentsContainer } = options;
    const [isProcessing, setIsProcessing] = (0, _react.useState)(false);
    const [logs, setLogs] = (0, _react.useState)([]);
    const addLog = (0, _react.useCallback)((messages)=>{
        setLogs((prev)=>[
                ...prev,
                ...messages
            ]);
        messages.forEach((msg)=>console.log(msg));
    }, []);
    const clearLogs = (0, _react.useCallback)(()=>{
        setLogs([]);
    }, []);
    const syncSingleModule = (0, _react.useCallback)(async (appId, moduleId, syncName, denom, numerator)=>{
        try {
            const moduleResult = await _api.findAppliedApplicationTemplate(moduleId);
            if (moduleResult.resultType !== "Ok") {
                const error = `Error loading module: ${moduleResult.errors?.join(", ")}`;
                console.error(error);
                return error;
            }
            const formFieldValues = moduleResult.data.templateFormFieldValues;
            const name = moduleResult.data.name;
            const payload = {
                templateFormFieldValues: formFieldValues,
                dynamicFormSections: moduleResult.data.templateForm?.templateFormSections?.filter((s)=>s?.name) || []
            };
            const queueSyncResult = await _api.queueUpdateApplicationFromTemplateFormsSync(appId, moduleId, payload);
            if (queueSyncResult.resultType !== "Ok") {
                const error = `Error queuing module sync: ${queueSyncResult.errors?.join(", ")}`;
                console.error(error);
                return error;
            }
            const syncId = queueSyncResult.data.id;
            let complete = false;
            const secondWait = 4;
            const secondsLimit = 600;
            const tryLimit = secondsLimit / secondWait;
            let tries = 0;
            while(!complete){
                if (tries >= tryLimit) {
                    const error = `#${numerator}/${denom} Module stuck: ${name} after ${secondsLimit} seconds`;
                    console.error(error);
                    return error;
                }
                const syncStatusResult = await _api.getAppliedTemplateSync(syncId);
                if (syncStatusResult.resultType !== "Ok") {
                    const error = `Error loading module sync: ${syncStatusResult.errors?.join(", ")}`;
                    console.error(error);
                    return error;
                }
                const stage = syncStatusResult.data.stage;
                if (stage === "Unknown") {
                    const error = `Error syncing: ${syncStatusResult.data?.error}`;
                    console.error(error);
                    return error;
                } else if (stage === "Queued" || stage === "Processing") {
                    await new Promise((resolve)=>setTimeout(resolve, secondWait * 1000));
                    tries++;
                    addLog([
                        `#${numerator}/${denom} Waiting for ${syncName} sync, stage: ${stage} (${tries}/${tryLimit})`
                    ]);
                } else if (stage === "Complete") {
                    console.log(`${syncName} module sync complete`);
                    complete = true;
                    return null;
                } else {
                    const error = `Error syncing unrecognized status: ${stage}`;
                    console.error(error);
                    return error;
                }
            }
            return null;
        } catch (error) {
            const errorMsg = `Exception syncing module ${syncName}: ${error.toString()}`;
            console.error(errorMsg);
            return errorMsg;
        }
    }, [
        addLog
    ]);
    const syncApps = (0, _react.useCallback)(async (apps, sharedTopicsApp, concurrencyLimit = 8)=>{
        if (!appliedTemplateContainer) {
            addLog([
                "Applied template container not available"
            ]);
            return {
                successCount: 0,
                errorCount: 0
            };
        }
        if (apps.length === 0) {
            addLog([
                "No applications to sync"
            ]);
            return {
                successCount: 0,
                errorCount: 0
            };
        }
        setIsProcessing(true);
        clearLogs();
        let successCount = 0;
        let errorCount = 0;
        try {
            const startDate = new Date();
            // Sync shared topics app first if provided
            if (sharedTopicsApp) {
                addLog([
                    `Starting sync for ${sharedTopicsApp.name}...`
                ]);
                const appliedTemplatesResult = await appliedTemplateContainer.loadAppliedTemplates(sharedTopicsApp.id);
                if (appliedTemplatesResult?.resultType === "Ok" && appliedTemplatesResult.data.length > 0) for (const appliedTemplate of appliedTemplatesResult.data){
                    addLog([
                        `Syncing ${sharedTopicsApp.name} - ${appliedTemplate.name}...`
                    ]);
                    const result = await syncSingleModule(sharedTopicsApp.id, appliedTemplate.id, sharedTopicsApp.name, 1, 1);
                    if (result) {
                        addLog([
                            `✗ ${sharedTopicsApp.name} - ${appliedTemplate.name}: ${result}`
                        ]);
                        setIsProcessing(false);
                        return {
                            successCount,
                            errorCount: errorCount + 1
                        };
                    } else addLog([
                        `✓ ${sharedTopicsApp.name} - ${appliedTemplate.name}: Complete`
                    ]);
                }
            }
            // Filter out shared topics app from location apps
            const locationApps = apps.filter((app)=>app.id !== sharedTopicsApp?.id);
            if (locationApps.length === 0) {
                const endDate = new Date();
                const duration = (endDate.getTime() - startDate.getTime()) / 1000;
                addLog([
                    `\n✓ Module sync completed: ${successCount} successful, ${errorCount} failed`,
                    `Total duration: ${duration} seconds`
                ]);
                setIsProcessing(false);
                return {
                    successCount,
                    errorCount
                };
            }
            addLog([
                `\nSyncing ${locationApps.length} location apps...`
            ]);
            let appQueue = [
                ...locationApps
            ];
            let counter = 0;
            const appsCount = appQueue.length;
            const worker = async (workerIdx)=>{
                while(appQueue.length > 0){
                    const app = appQueue.shift();
                    if (!app) return;
                    counter++;
                    const subCounter = counter;
                    try {
                        addLog([
                            `#${subCounter}/${appsCount}[Worker ${workerIdx}] Starting ${app.name}...`
                        ]);
                        const appliedTemplatesResult = await appliedTemplateContainer.loadAppliedTemplates(app.id);
                        if (appliedTemplatesResult?.resultType === "Ok" && appliedTemplatesResult.data.length > 0) {
                            for (const appliedTemplate of appliedTemplatesResult.data){
                                const result = await syncSingleModule(app.id, appliedTemplate.id, app.name, appsCount, subCounter);
                                if (result) {
                                    appQueue.length = 0;
                                    throw new Error(result);
                                }
                            }
                            successCount++;
                            addLog([
                                `#${subCounter}/${appsCount} ✓ ${app.name}: Complete`
                            ]);
                        }
                    } catch (error) {
                        errorCount++;
                        appQueue.length = 0;
                        addLog([
                            `#${subCounter}/${appsCount} ✗ ${app.name}: ${error.toString()}`
                        ]);
                        throw error;
                    }
                }
            };
            const workers = [];
            for(let i = 0; i < Math.min(concurrencyLimit, locationApps.length); i++)workers.push(worker(i));
            try {
                await Promise.all(workers);
            } catch (error) {
                console.error("One of the syncs failed, stopping all work");
                addLog([
                    `\n✗ Sync stopped due to error: ${error.toString()}`
                ]);
                setIsProcessing(false);
                return {
                    successCount,
                    errorCount
                };
            }
            const endDate = new Date();
            const duration = (endDate.getTime() - startDate.getTime()) / 1000;
            addLog([
                `\n✓ Module sync completed: ${successCount} successful, ${errorCount} failed`,
                `Total duration: ${duration} seconds`
            ]);
        } catch (error) {
            addLog([
                `Fatal error: ${error.toString()}`
            ]);
        } finally{
            setIsProcessing(false);
        }
        return {
            successCount,
            errorCount
        };
    }, [
        appliedTemplateContainer,
        syncSingleModule,
        addLog,
        clearLogs
    ]);
    const publishApps = (0, _react.useCallback)(async (apps, concurrencyLimit = 7)=>{
        if (!applicationEnvironmentsContainer) {
            addLog([
                "Application environments container not available"
            ]);
            return {
                successCount: 0,
                errorCount: 0
            };
        }
        if (apps.length === 0) {
            addLog([
                "No applications to publish"
            ]);
            return {
                successCount: 0,
                errorCount: 0
            };
        }
        setIsProcessing(true);
        clearLogs();
        let successCount = 0;
        let errorCount = 0;
        try {
            const startDate = new Date();
            const totalCount = apps.length;
            addLog([
                `Publishing templates for ${totalCount} locations with concurrency limit of ${concurrencyLimit}...`
            ]);
            const publishSingleApp = async (app, index)=>{
                try {
                    addLog([
                        `#${index}/${totalCount} Starting publish for ${app.name}...`
                    ]);
                    const assistantAppResult = await _api.getAssistantApplication(app.id);
                    if (assistantAppResult.resultType !== "Ok") {
                        const error = `Error loading assistant application: ${assistantAppResult.errors?.join(", ")}`;
                        addLog([
                            `#${index}/${totalCount} ✗ ${app.name}: ${error}`
                        ]);
                        return {
                            success: false,
                            appName: app.name,
                            error
                        };
                    }
                    const envId = assistantAppResult.data.environments?.find((e)=>e.name === "Production")?.id;
                    if (!envId?.length) {
                        const error = "No production environment found";
                        addLog([
                            `#${index}/${totalCount} ✗ ${app.name}: ${error}`
                        ]);
                        return {
                            success: false,
                            appName: app.name,
                            error
                        };
                    }
                    const backupResult = await _api.queueBackupAndPublishApplication(app.id, envId, {
                        name: `Bulk template publish - ${new Date().toISOString()}`
                    });
                    if (backupResult.resultType !== "Ok") {
                        const error = `Error queuing backup and publish: ${backupResult.errors?.join(", ")}`;
                        addLog([
                            `#${index}/${totalCount} ✗ ${app.name}: ${error}`
                        ]);
                        return {
                            success: false,
                            appName: app.name,
                            error
                        };
                    }
                    const publishId = backupResult.data.publish.id;
                    addLog([
                        `#${index}/${totalCount} Publish queued for ${app.name}, waiting for completion...`
                    ]);
                    const waitResult = await applicationEnvironmentsContainer.waitForPublish(publishId);
                    if (waitResult?.resultType === "Ok") {
                        addLog([
                            `#${index}/${totalCount} ✓ ${app.name}: Publish completed successfully`
                        ]);
                        return {
                            success: true,
                            appName: app.name
                        };
                    } else {
                        const error = waitResult?.errors?.join(", ") || "Publish failed or timed out";
                        addLog([
                            `#${index}/${totalCount} ✗ ${app.name}: ${error}`
                        ]);
                        return {
                            success: false,
                            appName: app.name,
                            error
                        };
                    }
                } catch (error) {
                    const errorMsg = error.toString();
                    addLog([
                        `#${index}/${totalCount} ✗ ${app.name}: ${errorMsg}`
                    ]);
                    return {
                        success: false,
                        appName: app.name,
                        error: errorMsg
                    };
                }
            };
            let appQueue = [
                ...apps
            ];
            let counter = 0;
            const worker = async ()=>{
                while(appQueue.length > 0){
                    const app = appQueue.shift();
                    if (!app) break;
                    counter++;
                    const currentIndex = counter;
                    const result = await publishSingleApp(app, currentIndex);
                    if (result.success) successCount++;
                    else errorCount++;
                }
            };
            const workers = [];
            for(let i = 0; i < Math.min(concurrencyLimit, apps.length); i++)workers.push(worker());
            await Promise.all(workers);
            const endDate = new Date();
            const duration = (endDate.getTime() - startDate.getTime()) / 1000;
            addLog([
                `\n✓ Template publish completed: ${successCount} successful, ${errorCount} failed`,
                `Total duration: ${duration} seconds`
            ]);
        } catch (error) {
            addLog([
                `Fatal error: ${error.toString()}`
            ]);
        } finally{
            setIsProcessing(false);
        }
        return {
            successCount,
            errorCount
        };
    }, [
        applicationEnvironmentsContainer,
        addLog,
        clearLogs
    ]);
    return {
        isProcessing,
        logs,
        syncSingleModule,
        syncApps,
        publishApps,
        clearLogs
    };
};
exports.default = useBulkAppOperations;

},{"react":"6uln9","../api":"loxM6","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"cjH2w":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _base = require("@emotion/styled/base");
var _baseDefault = parcelHelpers.interopDefault(_base);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _button = require("../../../components/general/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _loader = require("../../../components/general/Loader");
var _loaderDefault = parcelHelpers.interopDefault(_loader);
var _pageError = require("../../../components/general/PageError");
var _pageErrorDefault = parcelHelpers.interopDefault(_pageError);
var _styledDropdown = require("../../applicationSettings/components/customAssistantConfigurations/StyledDropdown");
var _styledDropdownDefault = parcelHelpers.interopDefault(_styledDropdown);
var _colors = require("../../../constants/colors");
var _moduleConsts = require("../../../constants/sparkConstants/moduleConsts");
var _medicalIntegrationConfigContainer = require("../../../hooks/MedicalIntegrationConfigContainer");
var _medicalIntegrationConfigContainerDefault = parcelHelpers.interopDefault(_medicalIntegrationConfigContainer);
var _useBulkAppOperations = require("../../../hooks/useBulkAppOperations");
var _useBulkAppOperationsDefault = parcelHelpers.interopDefault(_useBulkAppOperations);
var _xlsx = require("xlsx");
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// Practice Management System options
const PRACTICE_MANAGEMENT_SYSTEMS = [
    "Denticon",
    "Dentrix Ascend",
    "Cloud 9",
    "Open Dental",
    "Custom"
];
const OrganizationHealthcareManagementSettingsInner = ({ organizationId, applicationContainer, appliedTemplateContainer, applicationEnvironmentsContainer })=>{
    const [errors, setErrors] = (0, _react1.useState)([]);
    const [successMessage, setSuccessMessage] = (0, _react1.useState)(null);
    const [selectedApps, setSelectedApps] = (0, _react1.useState)(new Set());
    const [sharedTopicsApp, setSharedTopicsApp] = (0, _react1.useState)(null);
    const [locationSpecificFields, setLocationSpecificFields] = (0, _react1.useState)([]);
    const [isLoadingSharedTopics, setIsLoadingSharedTopics] = (0, _react1.useState)(false);
    const [selectedFields, setSelectedFields] = (0, _react1.useState)(new Set());
    const [isImporting, setIsImporting] = (0, _react1.useState)(false);
    const [importProgress, setImportProgress] = (0, _react1.useState)("");
    const [importedData, setImportedData] = (0, _react1.useState)(null);
    const [isApplying, setIsApplying] = (0, _react1.useState)(false);
    const [searchTerm, setSearchTerm] = (0, _react1.useState)("");
    // Bulk app operations hook
    const { isProcessing: isPublishing, logs: bulkOperationLogs, syncApps, publishApps, clearLogs } = (0, _useBulkAppOperationsDefault.default)({
        appliedTemplateContainer,
        applicationEnvironmentsContainer
    });
    // Medical Integration Configuration - use container
    const medicalConfigContainer = (0, _medicalIntegrationConfigContainerDefault.default).useContainer();
    const [selectedMedicalConfig, setSelectedMedicalConfig] = (0, _react1.useState)(null);
    const [isCreatingNewConfig, setIsCreatingNewConfig] = (0, _react1.useState)(false);
    const [copiedConfigId, setCopiedConfigId] = (0, _react1.useState)(null);
    const [isCustomPMS, setIsCustomPMS] = (0, _react1.useState)(false);
    const [medicalConfigForm, setMedicalConfigForm] = (0, _react1.useState)({
        organizationId: organizationId,
        clientName: "",
        configuration: "{}",
        integrationType: ""
    });
    // Helper to check if a value is a known PMS option (excluding 'Custom')
    const isKnownPMS = (value)=>{
        return PRACTICE_MANAGEMENT_SYSTEMS.slice(0, -1).includes(value);
    };
    (0, _react1.useEffect)(()=>{
        // Apps are already loaded by parent component (OrganizationSettingsTabs)
        if (appliedTemplateContainer) loadSharedTopicsFields();
    }, [
        organizationId
    ]);
    // Medical Integration Configuration functions
    const loadMedicalConfigs = async ()=>{
        setSuccessMessage(null);
        setErrors([]);
        const result = await medicalConfigContainer.loadConfigsByOrganizationId(organizationId);
        if (result.resultType === "Ok") setSuccessMessage(`Successfully loaded ${result.data?.length || 0} medical integration configuration(s)`);
        else setErrors([
            "Failed to load medical integration configurations: " + (result.errors?.join(", ") || "Unknown error")
        ]);
    };
    const selectMedicalConfig = (config)=>{
        setSuccessMessage(null);
        setErrors([]);
        setSelectedMedicalConfig(config);
        medicalConfigContainer.selectConfig(config);
        setIsCreatingNewConfig(false);
        setIsCustomPMS(!isKnownPMS(config.integrationType));
        setMedicalConfigForm({
            id: config.id,
            organizationId: config.organizationId,
            clientName: config.clientName,
            configuration: config.configuration,
            integrationType: config.integrationType
        });
    };
    const startNewMedicalConfig = ()=>{
        setSuccessMessage(null);
        setErrors([]);
        setSelectedMedicalConfig(null);
        medicalConfigContainer.selectConfig(null);
        setIsCreatingNewConfig(true);
        setIsCustomPMS(false);
        setMedicalConfigForm({
            organizationId: organizationId,
            clientName: "",
            configuration: "{}",
            integrationType: ""
        });
    };
    const cancelMedicalConfigEdit = ()=>{
        setSuccessMessage(null);
        setErrors([]);
        setSelectedMedicalConfig(null);
        medicalConfigContainer.selectConfig(null);
        setIsCreatingNewConfig(false);
        setIsCustomPMS(false);
        setMedicalConfigForm({
            organizationId: organizationId,
            clientName: "",
            configuration: "{}",
            integrationType: ""
        });
    };
    const saveMedicalConfig = async ()=>{
        if (!medicalConfigForm.clientName.trim()) {
            setSuccessMessage(null);
            setErrors([
                "Client Name is required"
            ]);
            return;
        }
        if (!medicalConfigForm.integrationType.trim()) {
            setSuccessMessage(null);
            setErrors([
                "Integration Type is required"
            ]);
            return;
        }
        // Validate JSON
        try {
            JSON.parse(medicalConfigForm.configuration);
        } catch (e) {
            setSuccessMessage(null);
            setErrors([
                "Configuration must be valid JSON"
            ]);
            return;
        }
        setErrors([]);
        setSuccessMessage(null);
        let result;
        if (isCreatingNewConfig) result = await medicalConfigContainer.createConfig(medicalConfigForm);
        else if (selectedMedicalConfig?.id) result = await medicalConfigContainer.updateConfig(selectedMedicalConfig.id, medicalConfigForm);
        else {
            setErrors([
                "No configuration selected for update"
            ]);
            return;
        }
        if (result.resultType === "Ok") {
            setSuccessMessage(`Successfully ${isCreatingNewConfig ? "created" : "updated"} medical integration configuration`);
            // Reload configs after create to ensure we have the new config with its ID
            if (isCreatingNewConfig) await medicalConfigContainer.loadConfigsByOrganizationId(organizationId);
            cancelMedicalConfigEdit();
        } else setErrors([
            `Failed to ${isCreatingNewConfig ? "create" : "update"} configuration: ` + (result.errors?.join(", ") || "Unknown error")
        ]);
    };
    const formatJson = ()=>{
        try {
            const parsed = JSON.parse(medicalConfigForm.configuration);
            setMedicalConfigForm({
                ...medicalConfigForm,
                configuration: JSON.stringify(parsed, null, 2)
            });
        } catch (e) {
            setErrors([
                "Cannot format: Configuration is not valid JSON"
            ]);
        }
    };
    // Filter applications for healthcare organizations
    const healthcareApps = applicationContainer.state.baseOrgApplications.filter((app)=>{
        // Filter out any apps that might be system apps
        if (app?.name?.toLowerCase()?.includes("manage menu") || app?.name?.toLowerCase()?.includes("manage entities") || app?.name?.toLowerCase()?.startsWith("x -") && app?.name?.toLowerCase()?.endsWith("menu")) return false;
        return true;
    });
    // Filter apps based on search term
    const filteredApps = healthcareApps.filter((app)=>{
        if (!searchTerm.trim()) return true;
        const appName = app.name?.toLowerCase() || "";
        const terms = searchTerm.split("|").map((t)=>t.trim()).filter((t)=>t);
        const exclusionTerms = [];
        const inclusionTerms = [];
        terms.forEach((term)=>{
            const exclusionMatch = term.match(/^!"(.+)"$/) || term.match(/^!'(.+)'$/);
            if (exclusionMatch) exclusionTerms.push(exclusionMatch[1].toLowerCase());
            else {
                const cleanTerm = term.replace(/^["']|["']$/g, "");
                inclusionTerms.push(cleanTerm.toLowerCase());
            }
        });
        for (const excludeTerm of exclusionTerms){
            if (appName.includes(excludeTerm)) return false;
        }
        if (inclusionTerms.length === 0) return true;
        return inclusionTerms.every((term)=>appName.includes(term));
    });
    const loadSharedTopicsFields = async ()=>{
        setIsLoadingSharedTopics(true);
        try {
            const appsResult = await applicationContainer.searchForOrgApplications(organizationId, 1, 50, undefined, undefined, true);
            const apps = appsResult?.data?.applications ?? [];
            let sharedTopics = apps.find((app)=>app.name?.toLowerCase()?.trim() === (0, _moduleConsts.aiDentalSchedulingCommonAppName).toLowerCase() && app.allowsTemplating);
            if (!sharedTopics) sharedTopics = apps.find((app)=>app.name?.toLowerCase()?.includes("shared topics") && app.allowsTemplating);
            if (!sharedTopics) sharedTopics = apps.find((app)=>app.name?.toLowerCase()?.includes("shared topics"));
            if (sharedTopics && appliedTemplateContainer) {
                setSharedTopicsApp(sharedTopics);
                const appliedTemplatesResult = await appliedTemplateContainer.loadAppliedTemplates(sharedTopics.id);
                if (appliedTemplatesResult?.resultType === "Ok") {
                    const appliedTemplates = appliedTemplatesResult.data;
                    const locationFields = [];
                    const fieldSet = new Set();
                    appliedTemplates.forEach((appliedTemplate)=>{
                        appliedTemplate.templateForm?.templateFormSections?.forEach((section)=>{
                            section.templateFormFields?.forEach((field)=>{
                                const fieldValue = appliedTemplate.templateFormFieldValues?.find((v)=>v.templateFormFieldId === field.id);
                                if (fieldValue?.associatedVariable && fieldValue.associatedVariable === fieldValue.value) {
                                    if (!fieldSet.has(field.title)) {
                                        fieldSet.add(field.title);
                                        locationFields.push({
                                            ...field,
                                            name: section.title
                                        });
                                    }
                                }
                            });
                        });
                    });
                    setLocationSpecificFields(locationFields);
                }
            }
        } catch (error) {
            console.error("Error loading shared topics fields:", error);
        } finally{
            setIsLoadingSharedTopics(false);
        }
    };
    const toggleAppSelection = (appId)=>{
        const newSelected = new Set(selectedApps);
        if (newSelected.has(appId)) newSelected.delete(appId);
        else newSelected.add(appId);
        setSelectedApps(newSelected);
    };
    const toggleSelectAll = ()=>{
        if (selectedApps.size === healthcareApps.length) setSelectedApps(new Set());
        else setSelectedApps(new Set(healthcareApps.map((app)=>app.id)));
    };
    const selectVisibleApps = ()=>{
        setSelectedApps(new Set(filteredApps.map((app)=>app.id)));
    };
    const toggleFieldSelection = (fieldTitle)=>{
        const newSelected = new Set(selectedFields);
        if (newSelected.has(fieldTitle)) newSelected.delete(fieldTitle);
        else newSelected.add(fieldTitle);
        setSelectedFields(newSelected);
    };
    const toggleAllFields = ()=>{
        if (selectedFields.size === locationSpecificFields.length) setSelectedFields(new Set());
        else setSelectedFields(new Set(locationSpecificFields.map((field)=>field.title)));
    };
    const publishTemplatesForSelectedLocations = async ()=>{
        if (selectedApps.size === 0) {
            setErrors([
                "Please select at least one location"
            ]);
            return;
        }
        const selectedApplications = healthcareApps.filter((app)=>selectedApps.has(app.id));
        await publishApps(selectedApplications);
    };
    const moduleSyncSelectedLocations = async ()=>{
        if (selectedApps.size === 0) {
            setErrors([
                "Please select at least one location"
            ]);
            return;
        }
        const selectedApplications = healthcareApps.filter((app)=>selectedApps.has(app.id));
        await syncApps(selectedApplications, sharedTopicsApp);
    };
    const importFromExcel = async (event)=>{
        const file = event.target.files?.[0];
        if (!file) return;
        try {
            setIsImporting(true);
            setErrors([]);
            setImportProgress("Reading Excel file...");
            const data = await file.arrayBuffer();
            const workbook = _xlsx.read(data);
            const worksheet = workbook.Sheets[workbook.SheetNames[0]];
            const jsonData = _xlsx.utils.sheet_to_json(worksheet, {
                header: 1
            });
            if (jsonData.length < 2) {
                setErrors([
                    "Excel file is empty or has no data rows"
                ]);
                return;
            }
            const headers = jsonData[0];
            const dataRows = jsonData.slice(1);
            const locationIdIndex = headers.findIndex((h)=>h === "Location ID");
            const locationNameIndex = headers.findIndex((h)=>h === "Location Name");
            if (locationIdIndex === -1 || locationNameIndex === -1) {
                setErrors([
                    'Excel file must have "Location ID" and "Location Name" columns'
                ]);
                return;
            }
            const fieldHeaders = headers.slice(2);
            setImportProgress(`Validating ${dataRows.length} locations...`);
            const validationErrors = [];
            const parsedData = [];
            for(let i = 0; i < dataRows.length; i++){
                const row = dataRows[i];
                const locationId = row[locationIdIndex];
                const locationName = row[locationNameIndex];
                if (!locationId) continue;
                setImportProgress(`Validating ${i + 1}/${dataRows.length}: ${locationName || locationId}...`);
                let app = applicationContainer.state.baseOrgApplications.find((a)=>a.id === locationId);
                if (!app) {
                    validationErrors.push(`Location not found: ${locationName || locationId}`);
                    continue;
                }
                const fieldChanges = [];
                for(let fieldIndex = 0; fieldIndex < fieldHeaders.length; fieldIndex++){
                    const fieldTitle = fieldHeaders[fieldIndex];
                    const newValue = row[2 + fieldIndex];
                    if (newValue !== undefined && newValue !== null && newValue !== "") fieldChanges.push({
                        fieldTitle,
                        newValue: String(newValue)
                    });
                }
                if (fieldChanges.length > 0) parsedData.push({
                    locationId,
                    locationName: locationName || app.name,
                    appId: app.id,
                    fieldChanges
                });
            }
            setImportProgress("");
            if (parsedData.length === 0) {
                setErrors([
                    "No valid data found in Excel file"
                ]);
                return;
            }
            setImportedData(parsedData);
            if (validationErrors.length > 0) setErrors([
                `Loaded ${parsedData.length} locations from Excel with ${validationErrors.length} warnings. Click "Apply Changes" to save the updates.`,
                ...validationErrors.slice(0, 10),
                ...validationErrors.length > 10 ? [
                    `...and ${validationErrors.length - 10} more warnings`
                ] : []
            ]);
            else setErrors([
                `Successfully loaded ${parsedData.length} locations from Excel. Review the changes below and click "Apply Changes" to save.`
            ]);
        } catch (error) {
            console.error("Error importing Excel:", error);
            setErrors([
                "Error importing Excel: " + error.toString()
            ]);
        } finally{
            setIsImporting(false);
            setImportProgress("");
            event.target.value = "";
        }
    };
    const applyChanges = async ()=>{
        if (!importedData || importedData.length === 0) {
            setErrors([
                "No imported data to apply"
            ]);
            return;
        }
        try {
            setIsApplying(true);
            setErrors([]);
            setImportProgress("Applying changes...");
            let successCount = 0;
            let errorCount = 0;
            const applyErrors = [];
            for(let i = 0; i < importedData.length; i++){
                const locationData = importedData[i];
                setImportProgress(`Applying ${i + 1}/${importedData.length}: ${locationData.locationName}...`);
                try {
                    const appliedTemplatesResult = await appliedTemplateContainer.loadAppliedTemplates(locationData.appId);
                    if (appliedTemplatesResult?.resultType !== "Ok") {
                        applyErrors.push(`Failed to load templates for ${locationData.locationName}`);
                        errorCount++;
                        continue;
                    }
                    const appliedTemplates = appliedTemplatesResult.data;
                    for (const fieldChange of locationData.fieldChanges){
                        let updated = false;
                        for (const appliedTemplate of appliedTemplates){
                            for (const section of appliedTemplate.templateForm?.templateFormSections || []){
                                const field = section.templateFormFields?.find((f)=>f.title === fieldChange.fieldTitle);
                                if (field) {
                                    let fieldValue = appliedTemplate.templateFormFieldValues?.find((v)=>v.templateFormFieldId === field.id);
                                    if (!fieldValue) {
                                        fieldValue = {
                                            templateFormFieldId: field.id,
                                            value: fieldChange.newValue,
                                            associatedVariable: field.associatedVariable,
                                            label: field.label,
                                            fieldType: field.fieldType,
                                            placeholder: field.placeholder,
                                            defaultValue: field.defaultValue,
                                            tip: field.tip,
                                            title: field.title,
                                            appliedApplicationTemplateId: appliedTemplate.id
                                        };
                                        appliedTemplate.templateFormFieldValues.push(fieldValue);
                                    } else fieldValue.value = fieldChange.newValue;
                                    updated = true;
                                    break;
                                }
                            }
                            if (updated) break;
                        }
                    }
                    let allSuccess = true;
                    for (const appliedTemplate of appliedTemplates){
                        const updateRequest = {
                            templateFormFieldValues: appliedTemplate.templateFormFieldValues,
                            dynamicFormSections: appliedTemplate.templateForm.templateFormSections.filter((s)=>s?.name)
                        };
                        const result = await appliedTemplateContainer.updateAppliedTemplate(appliedTemplate.id, updateRequest);
                        if (result?.resultType !== "Ok") {
                            allSuccess = false;
                            break;
                        }
                    }
                    if (allSuccess) successCount++;
                    else {
                        applyErrors.push(`Failed to save updates for ${locationData.locationName}`);
                        errorCount++;
                    }
                } catch (error) {
                    console.error(`Error applying changes for location ${locationData.locationName}:`, error);
                    applyErrors.push(`Error applying changes to ${locationData.locationName}: ${error.toString()}`);
                    errorCount++;
                }
            }
            setImportProgress("");
            if (applyErrors.length > 0) setErrors([
                `Applied changes with ${successCount} successes and ${errorCount} errors:`,
                ...applyErrors.slice(0, 10),
                ...applyErrors.length > 10 ? [
                    `...and ${applyErrors.length - 10} more errors`
                ] : []
            ]);
            else {
                setErrors([
                    `Successfully applied changes to ${successCount} locations!`
                ]);
                setImportedData(null);
            }
        } catch (error) {
            console.error("Error applying changes:", error);
            setErrors([
                "Error applying changes: " + error.toString()
            ]);
        } finally{
            setIsApplying(false);
            setImportProgress("");
        }
    };
    const exportToExcel = async ()=>{
        if (selectedApps.size === 0 || selectedFields.size === 0) {
            setErrors([
                "Please select at least one application/location and one field to export"
            ]);
            return;
        }
        try {
            setIsLoadingSharedTopics(true);
            const selectedApplications = healthcareApps.filter((app)=>selectedApps.has(app.id));
            const selectedFieldsList = locationSpecificFields.filter((field)=>selectedFields.has(field.title));
            const headers = [
                "Location ID",
                "Location Name",
                ...selectedFieldsList.map((field)=>field.title)
            ];
            const data = [];
            for (const app of selectedApplications){
                const row = [
                    app.id,
                    app.name
                ];
                if (appliedTemplateContainer) {
                    const appliedTemplatesResult = await appliedTemplateContainer.loadAppliedTemplates(app.id);
                    if (appliedTemplatesResult?.resultType === "Ok") {
                        const appliedTemplates = appliedTemplatesResult.data;
                        for (const selectedField of selectedFieldsList){
                            let fieldValue = "";
                            for (const template of appliedTemplates){
                                const field = template.templateForm?.templateFormSections?.flatMap((section)=>section.templateFormFields ?? [])?.find((f)=>f.title === selectedField.title);
                                if (field) {
                                    const value = template.templateFormFieldValues?.find((v)=>v.templateFormFieldId === field.id);
                                    if (value?.value) {
                                        fieldValue = value.value;
                                        break;
                                    }
                                }
                            }
                            row.push(fieldValue);
                        }
                    } else selectedFieldsList.forEach(()=>row.push(""));
                } else selectedFieldsList.forEach(()=>row.push(""));
                data.push(row);
            }
            const ws = _xlsx.utils.aoa_to_sheet([
                headers,
                ...data
            ]);
            const wb = _xlsx.utils.book_new();
            _xlsx.utils.book_append_sheet(wb, ws, "Location Specific Topics");
            const timestamp = new Date().toISOString().split("T")[0];
            const fileName = `healthcare_location_topics_${timestamp}.xlsx`;
            _xlsx.writeFile(wb, fileName);
        } catch (error) {
            console.error("Error exporting to Excel:", error);
            setErrors([
                "Error exporting to Excel: " + error.toString()
            ]);
        } finally{
            setIsLoadingSharedTopics(false);
        }
    };
    // Parent component (OrganizationSettingsTabs) handles loading state
    // No need to show loader here
    return (0, _react.jsx)(Container, null, (0, _react.jsx)(Header, null, (0, _react.jsx)(Title, null, "Medical Integration Configuration"), (0, _react.jsx)(Description, null, "Manage medical integration configurations for this organization. Load existing configurations, create new ones, or update existing ones.")), (0, _react.jsx)(MedicalConfigSection, null, (0, _react.jsx)(MedicalConfigActions, null, (0, _react.jsx)((0, _buttonDefault.default), {
        themes: [
            "secondary"
        ],
        text: medicalConfigContainer.isLoading ? "Loading..." : "Load Configurations",
        onClick: loadMedicalConfigs,
        disabled: medicalConfigContainer.isLoading
    }), (0, _react.jsx)((0, _buttonDefault.default), {
        themes: [
            "primary"
        ],
        text: "Create New Configuration",
        onClick: startNewMedicalConfig,
        disabled: medicalConfigContainer.isLoading || medicalConfigContainer.isSaving
    })), medicalConfigContainer.medicalConfigs.length > 0 && (0, _react.jsx)(MedicalConfigList, null, (0, _react.jsx)(MedicalConfigListHeader, null, "Existing Configurations (", medicalConfigContainer.medicalConfigs.length, ")"), medicalConfigContainer.medicalConfigs.filter((config)=>config && config.id).map((config)=>(0, _react.jsx)(MedicalConfigCard, {
            key: config.id,
            selected: selectedMedicalConfig?.id === config.id,
            onClick: ()=>selectMedicalConfig(config)
        }, (0, _react.jsx)(MedicalConfigCardContent, null, (0, _react.jsx)(MedicalConfigName, null, config.clientName), (0, _react.jsx)(MedicalConfigType, null, "PMS: ", config.integrationType), (0, _react.jsx)(MedicalConfigIdRow, null, (0, _react.jsx)(MedicalConfigId, null, "ID: ", config.id), (0, _react.jsx)(CopyButton, {
            onClick: (e)=>{
                e.stopPropagation();
                navigator.clipboard.writeText(config.id || "");
                setCopiedConfigId(config.id || null);
                setTimeout(()=>setCopiedConfigId(null), 2000);
            },
            title: "Copy Configuration ID"
        }, copiedConfigId === config.id ? "Copied!" : "Copy ID")))))), (isCreatingNewConfig || selectedMedicalConfig) && (0, _react.jsx)(MedicalConfigForm, null, (0, _react.jsx)(MedicalConfigFormHeader, null, isCreatingNewConfig ? "Create New Configuration" : `Edit: ${selectedMedicalConfig?.clientName}`), (0, _react.jsx)(InputGroup, null, (0, _react.jsx)(Label, null, "Client Name *"), (0, _react.jsx)(Input, {
        type: "text",
        placeholder: "Enter client name",
        value: medicalConfigForm.clientName,
        onChange: (e)=>setMedicalConfigForm({
                ...medicalConfigForm,
                clientName: e.target.value
            }),
        disabled: medicalConfigContainer.isSaving
    })), (0, _react.jsx)(InputGroup, null, (0, _react.jsx)(PracticeManagementDropdown, {
        label: "Practice Management System *",
        fieldName: "integrationType",
        placeholder: "Select Practice Management System",
        options: PRACTICE_MANAGEMENT_SYSTEMS.map((pms)=>({
                label: pms,
                value: pms
            })),
        value: isCustomPMS ? "Custom" : medicalConfigForm.integrationType,
        handleOnChange: (fieldName, value)=>{
            if (value === "Custom") {
                setIsCustomPMS(true);
                // Clear the integrationType so user can type fresh
                setMedicalConfigForm({
                    ...medicalConfigForm,
                    integrationType: ""
                });
            } else {
                setIsCustomPMS(false);
                setMedicalConfigForm({
                    ...medicalConfigForm,
                    integrationType: value
                });
            }
        },
        disabled: medicalConfigContainer.isSaving
    }), isCustomPMS && (0, _react.jsx)(Input, {
        type: "text",
        placeholder: "Enter custom practice management system",
        value: medicalConfigForm.integrationType,
        onChange: (e)=>setMedicalConfigForm({
                ...medicalConfigForm,
                integrationType: e.target.value
            }),
        disabled: medicalConfigContainer.isSaving,
        style: {
            marginTop: "8px"
        }
    })), (0, _react.jsx)(InputGroup, null, (0, _react.jsx)(LabelRow, null, (0, _react.jsx)(Label, null, "Configuration (JSON) *"), (0, _react.jsx)((0, _buttonDefault.default), {
        themes: [
            "secondary-small"
        ],
        text: "Format JSON",
        onClick: formatJson,
        disabled: medicalConfigContainer.isSaving
    })), (0, _react.jsx)(ConfigTextarea, {
        placeholder: '{"key": "value"}',
        value: medicalConfigForm.configuration,
        onChange: (e)=>setMedicalConfigForm({
                ...medicalConfigForm,
                configuration: e.target.value
            }),
        disabled: medicalConfigContainer.isSaving,
        rows: 10
    })), (0, _react.jsx)(MedicalConfigFormActions, null, (0, _react.jsx)((0, _buttonDefault.default), {
        themes: [
            "secondary"
        ],
        text: "Cancel",
        onClick: cancelMedicalConfigEdit,
        disabled: medicalConfigContainer.isSaving
    }), (0, _react.jsx)((0, _buttonDefault.default), {
        themes: [
            "primary"
        ],
        text: medicalConfigContainer.isSaving ? "Saving..." : isCreatingNewConfig ? "Create Configuration" : "Update Configuration",
        onClick: saveMedicalConfig,
        disabled: medicalConfigContainer.isSaving
    })))), (0, _react.jsx)(Divider, null), (0, _react.jsx)(Header, null, (0, _react.jsx)(Title, null, "Healthcare Location Management"), (0, _react.jsx)(Description, null, "Manage healthcare locations and sync templates for dental/medical applications")), healthcareApps.length === 0 ? (0, _react.jsx)(EmptyState, null, (0, _react.jsx)(EmptyStateText, null, "No healthcare applications found in this organization.")) : (0, _react.jsx)((0, _reactDefault.default).Fragment, null, (0, _react.jsx)(SearchBar, null, (0, _react.jsx)(SearchInput, {
        type: "text",
        placeholder: 'Search by name (e.g., location1|location2|!"exclude")',
        value: searchTerm,
        onChange: (e)=>setSearchTerm(e.target.value)
    }), (0, _react.jsx)(SearchInfo, null, searchTerm ? `Showing ${filteredApps.length} of ${healthcareApps.length} applications` : 'Use | to separate search terms (AND). Use !"text" to exclude apps containing text.')), (0, _react.jsx)(ActionsBar, null, (0, _react.jsx)(SelectionControls, null, (0, _react.jsx)(SelectionInfo, null, (0, _react.jsx)(Checkbox, {
        type: "checkbox",
        checked: selectedApps.size === healthcareApps.length,
        onChange: toggleSelectAll
    }), (0, _react.jsx)("span", null, selectedApps.size, " of ", healthcareApps.length, " selected")), (0, _react.jsx)((0, _buttonDefault.default), {
        themes: [
            "secondary-small"
        ],
        text: `Select Visible (${filteredApps.length})`,
        onClick: selectVisibleApps,
        disabled: filteredApps.length === 0
    })), (0, _react.jsx)(ButtonGroup, null, (0, _react.jsx)((0, _buttonDefault.default), {
        themes: [
            "secondary"
        ],
        text: `Module Sync Selected (${selectedApps.size})`,
        onClick: moduleSyncSelectedLocations,
        disabled: selectedApps.size === 0 || isPublishing || !sharedTopicsApp
    }), (0, _react.jsx)((0, _buttonDefault.default), {
        themes: [
            "primary"
        ],
        text: `Backup and Publish (${selectedApps.size})`,
        onClick: publishTemplatesForSelectedLocations,
        disabled: selectedApps.size === 0 || isPublishing || !applicationEnvironmentsContainer
    }))), bulkOperationLogs.length > 0 && (0, _react.jsx)(SyncLogSection, null, (0, _react.jsx)(SyncLogHeader, null, (0, _react.jsx)("span", null, "Sync Progress"), !isPublishing && (0, _react.jsx)((0, _buttonDefault.default), {
        themes: [
            "secondary-small"
        ],
        text: "Clear Log",
        onClick: clearLogs
    })), (0, _react.jsx)(SyncLogArea, null, bulkOperationLogs.map((log, index)=>(0, _react.jsx)(SyncLogLine, {
            key: index
        }, log)))), (0, _react.jsx)(ApplicationsList, null, filteredApps.map((app)=>(0, _react.jsx)(ApplicationCard, {
            key: app.id,
            selected: selectedApps.has(app.id)
        }, (0, _react.jsx)(CardContent, {
            onClick: ()=>toggleAppSelection(app.id)
        }, (0, _react.jsx)(Checkbox, {
            type: "checkbox",
            checked: selectedApps.has(app.id),
            onChange: ()=>toggleAppSelection(app.id),
            onClick: (e)=>e.stopPropagation()
        }), (0, _react.jsx)(ApplicationInfo, null, (0, _react.jsx)(ApplicationName, null, app.name))))))), appliedTemplateContainer && (0, _react.jsx)((0, _reactDefault.default).Fragment, null, (0, _react.jsx)(Header, {
        style: {
            marginTop: "48px"
        }
    }, (0, _react.jsx)(Title, null, "Location-Specific Topics Export"), (0, _react.jsx)(Description, null, "Select locations and topics to export as an Excel spreadsheet")), isLoadingSharedTopics ? (0, _react.jsx)(InlineLoaderWrapper, null, (0, _react.jsx)((0, _loaderDefault.default), null)) : !sharedTopicsApp ? (0, _react.jsx)(EmptyState, null, (0, _react.jsx)(EmptyStateText, null, "No Shared Topics application found in this organization.")) : locationSpecificFields.length === 0 ? (0, _react.jsx)(EmptyState, null, (0, _react.jsx)(EmptyStateText, null, "No location-specific topics configured yet.")) : (0, _react.jsx)((0, _reactDefault.default).Fragment, null, (0, _react.jsx)(SelectionSection, null, (0, _react.jsx)(SectionHeader, null, (0, _react.jsx)(SectionTitle, null, "Select Topics"), (0, _react.jsx)(SelectionInfo, null, (0, _react.jsx)(Checkbox, {
        type: "checkbox",
        checked: selectedFields.size === locationSpecificFields.length && locationSpecificFields.length > 0,
        onChange: toggleAllFields
    }), (0, _react.jsx)("span", null, selectedFields.size, " of ", locationSpecificFields.length, " selected"))), (0, _react.jsx)(FieldsList, null, locationSpecificFields.map((field, index)=>(0, _react.jsx)(FieldCard, {
            key: `${field.id}-${index}`,
            selected: selectedFields.has(field.title),
            onClick: ()=>toggleFieldSelection(field.title)
        }, (0, _react.jsx)(Checkbox, {
            type: "checkbox",
            checked: selectedFields.has(field.title),
            onChange: ()=>toggleFieldSelection(field.title),
            onClick: (e)=>e.stopPropagation()
        }), (0, _react.jsx)(FieldInfo, null, (0, _react.jsx)(FieldTitle, null, field.title), field.name && (0, _react.jsx)(FieldSection, null, "Section: ", field.name), field.tip && (0, _react.jsx)(FieldDescription, null, field.tip)))))), (0, _react.jsx)(Header, {
        style: {
            marginTop: "32px"
        }
    }, (0, _react.jsx)(Title, null, "Import & Export"), (0, _react.jsx)(Description, null, 'Import an Excel file to bulk update location-specific topics. The Excel file should have "Location ID" and "Location Name" columns, followed by the topic field columns.')), (0, _react.jsx)(ImportExportButtonWrapper, null, (0, _react.jsx)(ImportButtonWrapper, null, (0, _react.jsx)("input", {
        type: "file",
        accept: ".xlsx,.xls",
        onChange: importFromExcel,
        style: {
            display: "none"
        },
        id: "excel-import-input-healthcare",
        disabled: isImporting || isApplying
    }), (0, _react.jsx)("label", {
        htmlFor: "excel-import-input-healthcare"
    }, (0, _react.jsx)((0, _buttonDefault.default), {
        themes: [
            "secondary"
        ],
        text: isImporting ? "Importing..." : "Import from Excel",
        onClick: ()=>document.getElementById("excel-import-input-healthcare")?.click(),
        disabled: isImporting || isApplying
    })), importProgress && (0, _react.jsx)(ProgressText, null, importProgress)), (0, _react.jsx)((0, _buttonDefault.default), {
        themes: [
            "primary"
        ],
        text: `Export to Excel (${selectedApps.size} locations, ${selectedFields.size} topics)`,
        onClick: exportToExcel,
        disabled: selectedApps.size === 0 || selectedFields.size === 0 || isImporting || isApplying
    })), importedData && importedData.length > 0 && (0, _react.jsx)((0, _reactDefault.default).Fragment, null, (0, _react.jsx)(Header, {
        style: {
            marginTop: "32px"
        }
    }, (0, _react.jsx)(Title, null, "Review Imported Changes"), (0, _react.jsx)(Description, null, 'Review the imported data below. Click "Apply Changes" to save these updates.')), (0, _react.jsx)(ImportPreviewSection, null, (0, _react.jsx)(ImportPreviewHeader, null, (0, _react.jsx)("span", null, importedData.length, " locations with pending changes"), (0, _react.jsx)((0, _buttonDefault.default), {
        themes: [
            "primary"
        ],
        text: isApplying ? "Applying..." : `Apply Changes to ${importedData.length} Locations`,
        onClick: applyChanges,
        disabled: isApplying || isImporting
    })), (0, _react.jsx)(ImportPreviewList, null, importedData.slice(0, 10).map((location, index)=>(0, _react.jsx)(ImportPreviewCard, {
            key: index
        }, (0, _react.jsx)(LocationHeader, null, (0, _react.jsx)(LocationName, null, location.locationName), (0, _react.jsx)(LocationId, null, "ID: ", location.locationId)), (0, _react.jsx)(FieldChangesList, null, location.fieldChanges.map((change, changeIndex)=>(0, _react.jsx)(FieldChangeItem, {
                key: changeIndex
            }, (0, _react.jsx)(FieldChangeLabel, null, change.fieldTitle, ":"), (0, _react.jsx)(FieldChangeValue, null, change.newValue)))))), importedData.length > 10 && (0, _react.jsx)(MoreLocationsNote, null, "...and ", importedData.length - 10, " more locations")))))), successMessage && (0, _react.jsx)((0, _pageErrorDefault.default), {
        errors: [
            successMessage
        ],
        type: "success"
    }), (0, _react.jsx)((0, _pageErrorDefault.default), {
        errors: errors
    }));
};
// Wrapper component that provides the MedicalIntegrationConfigContainer
const OrganizationHealthcareManagementSettings = (props)=>{
    return (0, _react.jsx)((0, _medicalIntegrationConfigContainerDefault.default).Provider, null, (0, _react.jsx)(OrganizationHealthcareManagementSettingsInner, props));
};
const PracticeManagementDropdown = /*#__PURE__*/ (0, _baseDefault.default)((0, _styledDropdownDefault.default), {
    target: "e1hgro9768"
})({
    name: "61fd5i",
    styles: ".Select-control{border-radius:4px!important;}.Select-menu-outer{border-radius:4px!important;}"
});
const Container = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1hgro9767"
})({
    name: "klisov",
    styles: "display:flex;flex-direction:column;gap:24px"
});
const Header = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1hgro9766"
})({
    name: "3w0yoi",
    styles: "display:flex;flex-direction:column;gap:8px"
});
const Title = /*#__PURE__*/ (0, _baseDefault.default)("h2", {
    target: "e1hgro9765"
})({
    name: "18q5szo",
    styles: "margin:0;font-size:24px;font-weight:600"
});
const Description = /*#__PURE__*/ (0, _baseDefault.default)("p", {
    target: "e1hgro9764"
})({
    name: "4nmj52",
    styles: "margin:0;color:#666;font-size:14px"
});
const EmptyState = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1hgro9763"
})("display:flex;align-items:center;justify-content:center;padding:48px 24px;background:", (0, _colors.color_defaults_white), ";border:1px solid ", (0, _colors.color_shades_dark), ";border-radius:8px;");
const EmptyStateText = /*#__PURE__*/ (0, _baseDefault.default)("p", {
    target: "e1hgro9762"
})({
    name: "18fxd5b",
    styles: "color:#666;font-size:14px;margin:0"
});
const ActionsBar = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1hgro9761"
})("display:flex;flex-direction:column;gap:16px;padding:16px;background:", (0, _colors.color_defaults_white), ";border:1px solid ", (0, _colors.color_shades_dark), ";border-radius:8px;@media (min-width: 1200px){flex-direction:row;justify-content:space-between;align-items:center;}");
const SelectionControls = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1hgro9760"
})({
    name: "15a9qhe",
    styles: "display:flex;align-items:center;flex-wrap:wrap;gap:12px"
});
const ButtonGroup = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1hgro9759"
})({
    name: "15a9qhe",
    styles: "display:flex;align-items:center;flex-wrap:wrap;gap:12px"
});
const SelectionInfo = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1hgro9758"
})({
    name: "1pqrhzx",
    styles: "display:flex;align-items:center;gap:12px;font-size:14px"
});
const Checkbox = /*#__PURE__*/ (0, _baseDefault.default)("input", {
    target: "e1hgro9757"
})({
    name: "1yczt5p",
    styles: "width:18px;height:18px;cursor:pointer"
});
const ApplicationsList = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1hgro9756"
})({
    name: "1mhgfxj",
    styles: "display:grid;grid-template-columns:repeat(auto-fill, minmax(300px, 1fr));gap:16px"
});
const ApplicationCard = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1hgro9755"
})("border:2px solid ", (props)=>props.selected ? (0, _colors.color_highlights_blue) : (0, _colors.color_shades_dark), ";border-radius:8px;background:", (0, _colors.color_defaults_white), ";transition:all 0.2s ease;cursor:pointer;&:hover{transform:translateY(-2px);box-shadow:0 4px 12px rgba(0, 0, 0, 0.1);}");
const CardContent = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1hgro9754"
})({
    name: "1i89dxw",
    styles: "display:flex;align-items:flex-start;gap:12px;padding:16px"
});
const ApplicationInfo = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1hgro9753"
})({
    name: "1tcizyl",
    styles: "display:flex;flex-direction:column;gap:4px;flex:1"
});
const ApplicationName = /*#__PURE__*/ (0, _baseDefault.default)("h3", {
    target: "e1hgro9752"
})({
    name: "1kpbwcc",
    styles: "margin:0;font-size:16px;font-weight:600"
});
const SelectionSection = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1hgro9751"
})({
    name: "g6c5vq",
    styles: "display:flex;flex-direction:column;gap:16px;margin-bottom:32px"
});
const SectionHeader = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1hgro9750"
})("display:flex;justify-content:space-between;align-items:center;padding:16px;background:", (0, _colors.color_defaults_white), ";border:1px solid ", (0, _colors.color_shades_dark), ";border-radius:8px;");
const SectionTitle = /*#__PURE__*/ (0, _baseDefault.default)("h3", {
    target: "e1hgro9749"
})({
    name: "8c0djx",
    styles: "margin:0;font-size:18px;font-weight:600"
});
const FieldsList = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1hgro9748"
})({
    name: "lg2yyu",
    styles: "display:grid;grid-template-columns:repeat(auto-fill, minmax(280px, 1fr));gap:16px"
});
const FieldCard = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1hgro9747"
})("padding:16px;background:", (0, _colors.color_defaults_white), ";border:2px solid ", (props)=>props.selected ? (0, _colors.color_highlights_blue) : (0, _colors.color_shades_dark), ";border-radius:8px;display:flex;align-items:flex-start;gap:12px;cursor:", (props)=>props.selected !== undefined ? "pointer" : "default", ";transition:all 0.2s ease;", (props)=>props.selected !== undefined && `
        &:hover {
            transform: translateY(-2px);
            box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
        }
    `, ";");
const FieldInfo = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1hgro9746"
})({
    name: "pl5a4v",
    styles: "display:flex;flex-direction:column;gap:8px;flex:1"
});
const FieldTitle = /*#__PURE__*/ (0, _baseDefault.default)("h4", {
    target: "e1hgro9745"
})({
    name: "ldr8xp",
    styles: "margin:0;font-size:14px;font-weight:600;color:#333"
});
const FieldSection = /*#__PURE__*/ (0, _baseDefault.default)("p", {
    target: "e1hgro9744"
})("margin:0;font-size:12px;color:", (0, _colors.color_highlights_blue), ";font-weight:500;");
const FieldDescription = /*#__PURE__*/ (0, _baseDefault.default)("p", {
    target: "e1hgro9743"
})({
    name: "11td22w",
    styles: "margin:0;font-size:12px;color:#666;line-height:1.4"
});
const ImportExportButtonWrapper = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1hgro9742"
})({
    name: "c1eqtc",
    styles: "display:flex;justify-content:space-between;align-items:center;margin-top:24px;gap:16px"
});
const ImportButtonWrapper = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1hgro9741"
})({
    name: "3w0yoi",
    styles: "display:flex;flex-direction:column;gap:8px"
});
const ProgressText = /*#__PURE__*/ (0, _baseDefault.default)("p", {
    target: "e1hgro9740"
})("margin:0;font-size:13px;color:", (0, _colors.color_highlights_blue), ";font-weight:500;");
const ImportPreviewSection = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1hgro9739"
})({
    name: "anhfq1",
    styles: "display:flex;flex-direction:column;gap:16px;margin-top:16px"
});
const ImportPreviewHeader = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1hgro9738"
})("display:flex;justify-content:space-between;align-items:center;padding:16px;background:", (0, _colors.color_defaults_white), ";border:2px solid ", (0, _colors.color_highlights_blue), ";border-radius:8px;font-weight:600;");
const ImportPreviewList = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1hgro9737"
})({
    name: "tw4sx",
    styles: "display:flex;flex-direction:column;gap:12px"
});
const ImportPreviewCard = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1hgro9736"
})("padding:16px;background:", (0, _colors.color_defaults_white), ";border:1px solid ", (0, _colors.color_shades_dark), ";border-radius:8px;");
const LocationHeader = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1hgro9735"
})("display:flex;justify-content:space-between;align-items:center;margin-bottom:12px;padding-bottom:12px;border-bottom:1px solid ", (0, _colors.color_shades_dark), ";");
const LocationName = /*#__PURE__*/ (0, _baseDefault.default)("h4", {
    target: "e1hgro9734"
})({
    name: "6d7a74",
    styles: "margin:0;font-size:16px;font-weight:600;color:#333"
});
const LocationId = /*#__PURE__*/ (0, _baseDefault.default)("span", {
    target: "e1hgro9733"
})({
    name: "w3pehn",
    styles: "font-size:13px;color:#666"
});
const FieldChangesList = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1hgro9732"
})({
    name: "3w0yoi",
    styles: "display:flex;flex-direction:column;gap:8px"
});
const FieldChangeItem = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1hgro9731"
})({
    name: "urqszi",
    styles: "display:flex;flex-direction:column;gap:4px"
});
const FieldChangeLabel = /*#__PURE__*/ (0, _baseDefault.default)("span", {
    target: "e1hgro9730"
})("font-size:12px;font-weight:600;color:", (0, _colors.color_highlights_blue), ";");
const FieldChangeValue = /*#__PURE__*/ (0, _baseDefault.default)("span", {
    target: "e1hgro9729"
})({
    name: "1c5xglk",
    styles: "font-size:14px;color:#333;padding:8px;background:#f5f5f5;border-radius:4px"
});
const MoreLocationsNote = /*#__PURE__*/ (0, _baseDefault.default)("p", {
    target: "e1hgro9728"
})("margin:0;padding:16px;text-align:center;font-size:14px;color:#666;font-style:italic;background:", (0, _colors.color_defaults_white), ";border:1px dashed ", (0, _colors.color_shades_dark), ";border-radius:8px;");
const SearchBar = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1hgro9727"
})("display:flex;flex-direction:column;gap:8px;padding:16px;background:", (0, _colors.color_defaults_white), ";border:1px solid ", (0, _colors.color_shades_dark), ";border-radius:8px;");
const SearchInput = /*#__PURE__*/ (0, _baseDefault.default)("input", {
    target: "e1hgro9726"
})("padding:12px 16px;font-size:14px;border:1px solid ", (0, _colors.color_shades_dark), ";border-radius:4px;background:", (0, _colors.color_defaults_white), ";color:#333;&:focus{outline:none;border-color:", (0, _colors.color_highlights_blue), ";box-shadow:0 0 0 2px rgba(0, 123, 255, 0.1);}&::placeholder{color:#999;}");
const SearchInfo = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1hgro9725"
})({
    name: "16olgyj",
    styles: "font-size:13px;color:#666;font-style:italic"
});
// Medical Integration Configuration styled components
const MedicalConfigSection = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1hgro9724"
})("display:flex;flex-direction:column;gap:24px;padding:24px;background:", (0, _colors.color_defaults_white), ";border:1px solid ", (0, _colors.color_shades_dark), ";border-radius:8px;");
const MedicalConfigActions = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1hgro9723"
})({
    name: "3mberf",
    styles: "display:flex;gap:12px;flex-wrap:wrap"
});
const MedicalConfigList = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1hgro9722"
})({
    name: "tw4sx",
    styles: "display:flex;flex-direction:column;gap:12px"
});
const MedicalConfigListHeader = /*#__PURE__*/ (0, _baseDefault.default)("h4", {
    target: "e1hgro9721"
})({
    name: "6d7a74",
    styles: "margin:0;font-size:16px;font-weight:600;color:#333"
});
const MedicalConfigCard = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1hgro9720"
})("padding:16px;background:", (props)=>props.selected ? "#f0f7ff" : (0, _colors.color_defaults_white), ";border:2px solid ", (props)=>props.selected ? (0, _colors.color_highlights_blue) : (0, _colors.color_shades_dark), ";border-radius:8px;cursor:pointer;transition:all 0.2s ease;&:hover{border-color:", (0, _colors.color_highlights_blue), ";box-shadow:0 2px 8px rgba(0, 0, 0, 0.1);}");
const MedicalConfigCardContent = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1hgro9719"
})({
    name: "urqszi",
    styles: "display:flex;flex-direction:column;gap:4px"
});
const MedicalConfigName = /*#__PURE__*/ (0, _baseDefault.default)("h5", {
    target: "e1hgro9718"
})({
    name: "6d7a74",
    styles: "margin:0;font-size:16px;font-weight:600;color:#333"
});
const MedicalConfigType = /*#__PURE__*/ (0, _baseDefault.default)("span", {
    target: "e1hgro9717"
})({
    name: "1s77352",
    styles: "font-size:14px;color:#555;font-weight:500"
});
const MedicalConfigIdRow = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1hgro9716"
})({
    name: "1yydxi7",
    styles: "display:flex;align-items:center;gap:8px"
});
const MedicalConfigId = /*#__PURE__*/ (0, _baseDefault.default)("span", {
    target: "e1hgro9715"
})({
    name: "864o3w",
    styles: "font-size:12px;color:#666;font-family:'Monaco','Menlo','Ubuntu Mono','Consolas',monospace"
});
const CopyButton = /*#__PURE__*/ (0, _baseDefault.default)("button", {
    target: "e1hgro9714"
})("background:", (0, _colors.color_highlights_blue), ";color:white;border:none;border-radius:4px;padding:4px 8px;font-size:11px;cursor:pointer;font-weight:500;transition:background 0.2s;&:hover{background:#0056b3;}&:active{background:#004494;}");
const MedicalConfigForm = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1hgro9713"
})("display:flex;flex-direction:column;gap:16px;padding:24px;background:#f9f9f9;border:1px solid ", (0, _colors.color_shades_dark), ";border-radius:8px;");
const MedicalConfigFormHeader = /*#__PURE__*/ (0, _baseDefault.default)("h4", {
    target: "e1hgro9712"
})({
    name: "b1hbuv",
    styles: "margin:0;font-size:18px;font-weight:600;color:#333"
});
const MedicalConfigFormActions = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1hgro9711"
})({
    name: "1yhhxc8",
    styles: "display:flex;gap:12px;justify-content:flex-end;margin-top:8px"
});
const InputGroup = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1hgro9710"
})({
    name: "3w0yoi",
    styles: "display:flex;flex-direction:column;gap:8px"
});
const LabelRow = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1hgro979"
})({
    name: "1066lcq",
    styles: "display:flex;justify-content:space-between;align-items:center"
});
const Label = /*#__PURE__*/ (0, _baseDefault.default)("label", {
    target: "e1hgro978"
})({
    name: "i8c6z6",
    styles: "font-size:14px;font-weight:600;color:#333"
});
const Input = /*#__PURE__*/ (0, _baseDefault.default)("input", {
    target: "e1hgro977"
})("padding:10px 12px;font-size:14px;border:1px solid ", (0, _colors.color_shades_dark), ";border-radius:4px;background:", (0, _colors.color_defaults_white), ";color:#333;&:focus{outline:none;border-color:", (0, _colors.color_highlights_blue), ";}&:disabled{background:#f5f5f5;cursor:not-allowed;}&::placeholder{color:#999;}");
const ConfigTextarea = /*#__PURE__*/ (0, _baseDefault.default)("textarea", {
    target: "e1hgro976"
})("padding:12px;font-size:13px;font-family:'Monaco','Menlo','Ubuntu Mono','Consolas',monospace;border:1px solid ", (0, _colors.color_shades_dark), ";border-radius:4px;background:", (0, _colors.color_defaults_white), ";color:#333;resize:vertical;min-height:150px;&:focus{outline:none;border-color:", (0, _colors.color_highlights_blue), ";}&:disabled{background:#f5f5f5;cursor:not-allowed;}&::placeholder{color:#999;}");
const Divider = /*#__PURE__*/ (0, _baseDefault.default)("hr", {
    target: "e1hgro975"
})("border:none;border-top:1px solid ", (0, _colors.color_shades_dark), ";margin:24px 0;");
const InlineLoaderWrapper = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1hgro974"
})({
    name: "bckrt",
    styles: "display:flex;justify-content:center;align-items:center;padding:40px 0;position:relative;svg{position:static;margin:0;}"
});
const SyncLogSection = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1hgro973"
})({
    name: "md2v54",
    styles: "display:flex;flex-direction:column;gap:8px;margin:16px 0"
});
const SyncLogHeader = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1hgro972"
})({
    name: "6szydq",
    styles: "display:flex;justify-content:space-between;align-items:center;font-size:14px;font-weight:600;color:#333"
});
const SyncLogArea = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1hgro971"
})({
    name: "pxgao7",
    styles: "max-height:300px;overflow-y:auto;padding:16px;background:#1e1e1e;border-radius:8px;font-family:'Monaco','Menlo','Ubuntu Mono','Consolas',monospace;font-size:12px"
});
const SyncLogLine = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1hgro970"
})({
    name: "22hqym",
    styles: "color:#d4d4d4;line-height:1.6;white-space:pre-wrap;word-break:break-word;&:nth-of-type(odd){color:#9cdcfe;}"
});
exports.default = OrganizationHealthcareManagementSettings;

},{"@emotion/styled/base":"lSuFu","@emotion/react":"djZKr","react":"6uln9","../../../components/general/Button":"6ymxN","../../../components/general/Loader":"bnV5T","../../../components/general/PageError":"ezFTm","../../applicationSettings/components/customAssistantConfigurations/StyledDropdown":"hjrMo","../../../constants/colors":"1p3OR","../../../constants/sparkConstants/moduleConsts":"e2wLw","../../../hooks/MedicalIntegrationConfigContainer":"gYoSH","../../../hooks/useBulkAppOperations":"kJJQi","xlsx":"1jrO6","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"gYoSH":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _unstatedNext = require("unstated-next");
var _api = require("../api");
function useMedicalIntegrationConfigContainer() {
    const [medicalConfigs, setMedicalConfigs] = (0, _react.useState)([]);
    const [selectedConfig, setSelectedConfig] = (0, _react.useState)(null);
    const [isLoading, setIsLoading] = (0, _react.useState)(false);
    const [isSaving, setIsSaving] = (0, _react.useState)(false);
    const [errors, setErrors] = (0, _react.useState)([]);
    const loadConfigsByOrganizationId = async (organizationId)=>{
        setIsLoading(true);
        setErrors([]);
        try {
            const result = await _api.getMedicalIntegrationConfigsByOrganizationId(organizationId);
            if (result.resultType === "Ok") setMedicalConfigs(result.data || []);
            else setErrors(result.errors || [
                "Failed to load configurations"
            ]);
            return result;
        } catch (e) {
            const errorMessage = e?.toString() || "Unknown error";
            setErrors([
                errorMessage
            ]);
            return {
                resultType: "InternalError",
                errors: [
                    errorMessage
                ],
                data: null
            };
        } finally{
            setIsLoading(false);
        }
    };
    const createConfig = async (model)=>{
        setIsSaving(true);
        setErrors([]);
        try {
            const result = await _api.createMedicalIntegrationConfig(model);
            if (result.resultType === "Ok" && result.data) setMedicalConfigs((prev)=>[
                    ...prev,
                    result.data
                ]);
            else setErrors(result.errors || [
                "Failed to create configuration"
            ]);
            return result;
        } catch (e) {
            const errorMessage = e?.toString() || "Unknown error";
            setErrors([
                errorMessage
            ]);
            return {
                resultType: "InternalError",
                errors: [
                    errorMessage
                ],
                data: null
            };
        } finally{
            setIsSaving(false);
        }
    };
    const updateConfig = async (configId, model)=>{
        setIsSaving(true);
        setErrors([]);
        try {
            const result = await _api.updateMedicalIntegrationConfig(configId, model);
            if (result.resultType === "Ok") {
                // Use result.data if available, otherwise use the model we sent with the configId
                const updatedConfig = result.data || {
                    ...model,
                    id: configId
                };
                const updatedConfigs = medicalConfigs.map((config)=>config.id === configId ? updatedConfig : config);
                setMedicalConfigs(updatedConfigs);
                setSelectedConfig(updatedConfig);
            } else setErrors(result.errors || [
                "Failed to update configuration"
            ]);
            return result;
        } catch (e) {
            const errorMessage = e?.toString() || "Unknown error";
            setErrors([
                errorMessage
            ]);
            return {
                resultType: "InternalError",
                errors: [
                    errorMessage
                ],
                data: null
            };
        } finally{
            setIsSaving(false);
        }
    };
    const selectConfig = (config)=>{
        setSelectedConfig(config);
    };
    const clearErrors = ()=>{
        setErrors([]);
    };
    const clearConfigs = ()=>{
        setMedicalConfigs([]);
        setSelectedConfig(null);
    };
    return {
        medicalConfigs,
        setMedicalConfigs,
        selectedConfig,
        isLoading,
        isSaving,
        errors,
        loadConfigsByOrganizationId,
        createConfig,
        updateConfig,
        selectConfig,
        clearErrors,
        clearConfigs
    };
}
const MedicalIntegrationConfigContainer = (0, _unstatedNext.createContainer)(useMedicalIntegrationConfigContainer);
exports.default = MedicalIntegrationConfigContainer;

},{"react":"6uln9","unstated-next":"61zE5","../api":"loxM6","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"25z2G":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _extends = require("@babel/runtime/helpers/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _settingsCard = require("../../../components/structure/SettingsCard");
var _settingsCardDefault = parcelHelpers.interopDefault(_settingsCard);
var _useResponseVariableTester = require("../../../hooks/useResponseVariableTester");
var _responseVariableTesterUI = require("../../../components/general/ResponseVariableTesterUI");
var _responseVariableTesterUIDefault = parcelHelpers.interopDefault(_responseVariableTesterUI);
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const DOCS_URL = "https://dev.azure.com/voicify/Voicify-Api/_wiki/wikis/Voicify-Api.wiki/39/Response-Variables?anchor=nesting-and-combining-features";
const ResponseVariableTestSettings = (props)=>{
    const tester = (0, _useResponseVariableTester.useResponseVariableTester)({
        debounceMs: 750
    });
    if (!props.organizationId) return (0, _react.jsx)((0, _settingsCardDefault.default), {
        title: "Response Variable Testing"
    }, (0, _react.jsx)("div", {
        className: containerStyle
    }, (0, _react.jsx)("p", null, "No organization selected.")));
    return (0, _react.jsx)((0, _settingsCardDefault.default), {
        title: "Response Variable Testing",
        subtitle: "Test response variable replacement with custom values"
    }, (0, _react.jsx)("div", {
        className: containerStyle
    }, (0, _react.jsx)((0, _responseVariableTesterUIDefault.default), (0, _extendsDefault.default)({}, tester, {
        docsUrl: DOCS_URL,
        placeholder: "Hello {{session.name}}, your order total is {{constant.currency}}{{session.order.total}}. Your loyalty level is {{user.tier}}."
    }))));
};
const containerStyle = /*#__PURE__*/ (0, _css.css)({
    name: "1tk8yx0",
    styles: "padding:8px"
});
exports.default = ResponseVariableTestSettings;

},{"@babel/runtime/helpers/extends":"4iKIP","@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","../../../components/structure/SettingsCard":"liIw4","../../../hooks/useResponseVariableTester":"ataUW","../../../components/general/ResponseVariableTesterUI":"cuEg7","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9dGV0":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _base = require("@emotion/styled/base");
var _baseDefault = parcelHelpers.interopDefault(_base);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _button = require("../../components/general/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _customScrollbars = require("../../components/structure/CustomScrollbars");
var _customScrollbarsDefault = parcelHelpers.interopDefault(_customScrollbars);
var _scheduledAnalyticsEmailContainer = require("../../hooks/ScheduledAnalyticsEmailContainer");
var _scheduledAnalyticsEmailContainerDefault = parcelHelpers.interopDefault(_scheduledAnalyticsEmailContainer);
var _textField = require("../../components/forms/TextField");
var _textFieldDefault = parcelHelpers.interopDefault(_textField);
var _styledDropdown = require("../../scenes/applicationSettings/components/customAssistantConfigurations/StyledDropdown");
var _styledDropdownDefault = parcelHelpers.interopDefault(_styledDropdown);
var _api = require("../../api");
var _metricsToExcludeModal = require("./MetricsToExcludeModal");
var _metricsToExcludeModalDefault = parcelHelpers.interopDefault(_metricsToExcludeModal);
var _colors = require("../../constants/colors");
var _stylesValues = require("../../constants/stylesValues");
var _featureFlagIds = require("../../constants/featureFlagIds");
var _settingsCard = require("../structure/SettingsCard");
var _settingsCardDefault = parcelHelpers.interopDefault(_settingsCard);
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const trashIcon = require("9596e91e4141c24f");
/** A thin editable view model for a row in the table */ const ScheduledEmailForm = ({ organizationId, orgName, appContainer, isSparkView })=>{
    const scheduled = (0, _scheduledAnalyticsEmailContainerDefault.default).useContainer();
    const [applications, setApplications] = (0, _react1.useState)([]);
    const [metricsToExcludeRow, setMetricsToExcludeRow] = (0, _react1.useState)(null);
    const [featureFlag, setFeatureFlag] = (0, _react1.useState)(null);
    // Local editing state
    const [rows, setRows] = (0, _react1.useState)([]);
    const [filterEmail, setFilterEmail] = (0, _react1.useState)("__all__");
    const [nextDatesUpdated, setNextDatesUpdated] = (0, _react1.useState)(new Set());
    const DAY_TO_REVIEW_FROM_OPTIONS = [
        {
            label: "Last Email",
            value: "LastEmail"
        },
        {
            label: "First of the month",
            value: "FirstOfMonth"
        },
        {
            label: "First of the year",
            value: "FirstOfYear"
        }
    ];
    // Load org rows on mount if not already present
    (0, _react1.useEffect)(()=>{
        if (!organizationId) return;
        scheduled.loadForOrganization(organizationId);
    }, [
        organizationId
    ]);
    (0, _react1.useEffect)(()=>{
        //Load all the apps for the org
        (async ()=>{
            const result = await (0, _api.getApplicationsForOrg)(organizationId);
            const appsToKeep = result.data.filter((e)=>!e.name.includes("Shared Topics") && !e.name.includes("Manage Menu"));
            if (result.resultType === "Ok" && result.data) setApplications(appsToKeep);
        })();
    }, [
        organizationId
    ]);
    (0, _react1.useEffect)(()=>{
        (async ()=>{
            const result = await appContainer.getApplicationsForOrg(organizationId);
            if (result.resultType !== "Ok") {
                setFeatureFlag((0, _featureFlagIds.FoodOrderingFeatureFlagId));
                return;
            }
            const featureFlags = result.data.map((app)=>app.featureFlags).flat();
            if (featureFlags.filter((ff)=>ff.id === (0, _featureFlagIds.FoodOrderingFeatureFlagId))?.length > 0) setFeatureFlag((0, _featureFlagIds.FoodOrderingFeatureFlagId));
            else if (featureFlags.filter((ff)=>ff.id === (0, _featureFlagIds.HealthcareSchedulingFeatureFlagId))?.length > 0) setFeatureFlag((0, _featureFlagIds.HealthcareSchedulingFeatureFlagId));
            else setFeatureFlag((0, _featureFlagIds.FoodOrderingFeatureFlagId));
        })();
    }, [
        organizationId
    ]);
    const toISODate = (d)=>{
        const y = d.getUTCFullYear();
        const m = String(d.getUTCMonth() + 1).padStart(2, "0");
        const day = String(d.getUTCDate()).padStart(2, "0");
        const out = `${y}-${m}-${day}`;
        return out;
    };
    const addDaysUTC = (d, days)=>{
        // normalize to UTC midnight to avoid TZ drift
        const base = new Date(Date.UTC(d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate()));
        base.setUTCDate(base.getUTCDate() + days);
        return base;
    };
    const initialRows = (0, _react1.useMemo)(()=>{
        const rows = scheduled.getForOrganization(organizationId, "created", "desc").map((e, index)=>{
            const hasStart = e?.emailStartDate != null;
            const startDate = hasStart ? new Date(e.emailStartDate) : null; // handles Date or ISO string
            const days = Number(e.daysTillNextEmail ?? 7);
            let nextDate = null;
            if (startDate) {
                if (e.numberEmailsSent > 0) {
                    const lastSent = addDaysUTC(startDate, days * e.numberEmailsSent);
                    nextDate = addDaysUTC(lastSent, days);
                } else // first send is at the configured start date
                nextDate = startDate;
            }
            return {
                tempId: index,
                id: e.id,
                organizationId: e.organizationId,
                applicationId: e.applicationId ?? null,
                email: e.email ?? "",
                dateOfNextEmail: nextDate ? toISODate(nextDate) : undefined,
                // "YYYY-MM-DD"
                dayToReviewFrom: e.dayToReviewFrom ?? null,
                daysTillNextEmail: days,
                metricsToExclude: e.metricsToExclude ?? []
            };
        });
        return rows;
    }, [
        organizationId,
        scheduled.emails
    ]);
    (0, _react1.useEffect)(()=>{
        setRows(initialRows);
    }, [
        initialRows.length
    ]); // eslint-disable-line react-hooks/exhaustive-deps
    // Build dropdown options for App scope, first option is "Full Organization"
    const appScopeOptions = (0, _react1.useMemo)(()=>[
            {
                label: "Full Organization",
                value: "__org__"
            },
            ...applications.map((a)=>({
                    label: a.name,
                    value: a.id
                })).sort((a, b)=>a.label.localeCompare(b.label, undefined, {
                    sensitivity: "base"
                }))
        ], [
        applications
    ]);
    const appNameById = (0, _react1.useMemo)(()=>{
        const map = {};
        for (const a of applications)map[a.id] = a.name;
        return map;
    }, [
        applications
    ]);
    // Filter by recipient selector (unique recipients)
    const uniqueRecipients = (0, _react1.useMemo)(()=>{
        const set = new Set(rows.map((r)=>r.email).filter(Boolean));
        return [
            "__all__",
            ...Array.from(set)
        ];
    }, [
        rows
    ]);
    const filteredRows = (0, _react1.useMemo)(()=>{
        if (filterEmail === "__all__") return rows.filter((r)=>!r._isDeleted);
        return rows.filter((r)=>!r._isDeleted && r.email === filterEmail);
    }, [
        rows,
        filterEmail
    ]);
    const onChangeRow = (index, patch)=>{
        setRows((prev)=>{
            const next = [
                ...prev
            ];
            next[index] = {
                ...next[index],
                ...patch,
                _dirty: true
            };
            return next;
        });
    };
    const onAddRow = ()=>{
        const prevId = rows?.length > 0 ? rows[rows.length - 1].tempId : -1;
        setRows((prev)=>[
                {
                    tempId: prevId + 1,
                    _isNew: true,
                    organizationId: organizationId,
                    id: null,
                    applicationId: null,
                    email: "placeholder@email.com",
                    dayToReviewFrom: null,
                    dateOfNextEmail: new Date().toISOString(),
                    daysTillNextEmail: 7,
                    metricsToExclude: []
                },
                ...prev
            ]);
    };
    const onRemoveRow = (index)=>{
        setRows((prev)=>{
            const row = prev[index];
            // New rows can be dropped immediately; existing rows are marked for delete
            if (row._isNew) return prev.filter((_, i)=>i !== index);
            const next = [
                ...prev
            ];
            next[index] = {
                ...row,
                _isDeleted: true,
                _dirty: true
            };
            return next;
        });
    };
    const emailValidator = (value)=>{
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailRegex.test(value) ? null : "Please enter a valid email address";
    };
    const saveAll = async ()=>{
        // Save in three phases: deletes, updates, creates
        // (So that new rows don't conflict and deletes happen first)
        const toDelete = rows.filter((r)=>r.id && r._isDeleted);
        const toUpdate = rows.filter((r)=>r.id && !r._isDeleted && r._dirty);
        const toCreate = rows.filter((r)=>r._isNew && !r._isDeleted);
        // deletes
        for (const r of toDelete)await scheduled.remove(r.id);
        // updates
        for (const r of toUpdate){
            const dateOfNext = r.dateOfNextEmail ? new Date(r.dateOfNextEmail) : null;
            //If the next date to send or frequency is changed, reset the start date and number of emails sent
            if (nextDatesUpdated.has(rows.indexOf(r))) await scheduled.update({
                id: r.id,
                organizationId: r.organizationId,
                applicationId: r.applicationId,
                email: r.email,
                emailStartDate: dateOfNext,
                numberEmailsSent: 0,
                dayToReviewFrom: r.dayToReviewFrom,
                daysTillNextEmail: r.daysTillNextEmail,
                metricsToExclude: r.metricsToExclude
            });
            else await scheduled.update({
                id: r.id,
                organizationId: r.organizationId,
                applicationId: r.applicationId,
                email: r.email,
                dayToReviewFrom: r.dayToReviewFrom,
                daysTillNextEmail: r.daysTillNextEmail,
                metricsToExclude: r.metricsToExclude
            });
        }
        // creates
        for (const r of toCreate){
            const dateOfNext = r.dateOfNextEmail ? new Date(r.dateOfNextEmail) : new Date();
            await scheduled.create({
                organizationId: r.organizationId,
                applicationId: r.applicationId,
                email: r.email,
                emailStartDate: dateOfNext,
                dayToReviewFrom: r.dayToReviewFrom,
                daysTillNextEmail: r.daysTillNextEmail,
                metricsToExclude: r.metricsToExclude
            });
        }
    };
    const isSaveDisabled = (0, _react1.useMemo)(()=>{
        // basic validation: all non-deleted rows must have recipient email
        for (const r of rows){
            if (r._isDeleted) continue;
            if (!r.email?.trim()) return true;
        }
        return false;
    }, [
        rows
    ]);
    return (0, _react.jsx)((0, _settingsCardDefault.default), {
        title: "Email Configuration",
        subtitle: "Configure scheduled email updates about assistants and organization-wide preformance"
    }, (0, _react.jsx)(EmailConfigurationWrapper, null, (0, _react.jsx)(ControlsRow, null, (0, _react.jsx)(LeftControls, null, (0, _react.jsx)(FilterLabel, null, "Filter by Recipient"), (0, _react.jsx)(StyledFilterDropdown, {
        options: uniqueRecipients.map((e)=>({
                label: e === "__all__" ? "All Recipients" : e,
                value: e
            })),
        value: filterEmail,
        handleOnChange: (_, v)=>setFilterEmail(String(v)),
        size: "small",
        openMenuAbove: false
    }))), (0, _react.jsx)(TableShell, null, (0, _react.jsx)(HeaderRow, null, (0, _react.jsx)(TableLabelWrapper, null, "Recipient"), (0, _react.jsx)(TableLabelWrapper, null, "Scope"), (0, _react.jsx)(TableLabelWrapper, null, "Begin Review"), (0, _react.jsx)(TableLabelWrapper, null, "Frequency (Days)"), (0, _react.jsx)(TableLabelWrapper, null, "Metrics"), (0, _react.jsx)(TableLabelWrapper, null)), (0, _react.jsx)(Scrollable, null, (0, _react.jsx)((0, _customScrollbarsDefault.default), {
        autoHide: true,
        autoHeight: true,
        autoHeightMax: 420
    }, filteredRows.length === 0 || filteredRows === null ? (0, _react.jsx)(EmptyState, null, "No rows to display.") : filteredRows.map((r, visibleIndex)=>{
        // map back to its true index in rows
        const rowIndex = rows.findIndex((x)=>x === filteredRows[visibleIndex]);
        return (0, _react.jsx)(BodyRow, {
            key: rowKey(r, rowIndex),
            isTop: rowIndex === 0,
            isBottom: rowIndex === filteredRows?.length - 1
        }, (0, _react.jsx)(RowComponent, null, (0, _react.jsx)(StyledTextField, {
            height: "33",
            id: `${rowIndex}`,
            name: `recipient-${rowIndex}`,
            value: r.email,
            type: "email",
            placeholder: "email@company.com",
            onChange: (e)=>onChangeRow(rowIndex, {
                    email: e.target.value
                }),
            validate: emailValidator,
            useForm: false,
            fontSize: 13
        })), (0, _react.jsx)(RowComponent, null, (0, _react.jsx)(StyledTableDropdown, {
            fieldName: `app-${rowIndex}`,
            value: r.applicationId ?? "__org__",
            options: appScopeOptions,
            searchable: true,
            size: "small",
            handleOnChange: (_, v)=>onChangeRow(rowIndex, {
                    applicationId: v === "__org__" ? null : String(v)
                }),
            openMenuAbove: false
        })), (0, _react.jsx)(RowComponent, null, (0, _react.jsx)(StyledTableDropdown, {
            fieldName: `review-${rowIndex}`,
            value: r.dayToReviewFrom,
            options: DAY_TO_REVIEW_FROM_OPTIONS,
            size: "small",
            handleOnChange: (_, v)=>onChangeRow(rowIndex, {
                    dayToReviewFrom: String(v)
                }),
            openMenuAbove: false
        })), (0, _react.jsx)(RowComponent, null, (0, _react.jsx)(Incrementer, null, (0, _react.jsx)("button", {
            type: "button",
            onClick: ()=>{
                const updatedSet = new Set(nextDatesUpdated);
                updatedSet.add(rowIndex);
                setNextDatesUpdated(updatedSet);
                onChangeRow(rowIndex, {
                    daysTillNextEmail: Math.max(1, (r.daysTillNextEmail ?? 1) - 1)
                });
            }
        }, "−"), (0, _react.jsx)("input", {
            type: "number",
            min: 1,
            value: r.daysTillNextEmail ?? 1,
            onChange: (e)=>{
                const updatedSet = new Set(nextDatesUpdated);
                updatedSet.add(rowIndex);
                setNextDatesUpdated(updatedSet);
                onChangeRow(rowIndex, {
                    daysTillNextEmail: Math.max(1, Number(e.target.value) || 1)
                });
            }
        }), (0, _react.jsx)("button", {
            type: "button",
            onClick: ()=>{
                const updatedSet = new Set(nextDatesUpdated);
                updatedSet.add(rowIndex);
                setNextDatesUpdated(updatedSet);
                onChangeRow(rowIndex, {
                    daysTillNextEmail: (r.daysTillNextEmail ?? 1) + 1
                });
            }
        }, "+"))), (0, _react.jsx)(RowComponent, null, (0, _react.jsx)(PreviewButton, {
            themes: [
                "secondary-small",
                "fill"
            ],
            onClick: ()=>setMetricsToExcludeRow(r),
            text: "Preview"
        })), (0, _react.jsx)(RowComponent, null, (0, _react.jsx)(RemoveButton, {
            type: "button",
            onClick: ()=>onRemoveRow(rowIndex),
            title: "Remove row"
        }, (0, _react.jsx)("img", {
            src: trashIcon,
            alt: "Remove"
        }))), metricsToExcludeRow === r && (0, _react.jsx)((0, _metricsToExcludeModalDefault.default), {
            isVisible: metricsToExcludeRow === r,
            orgId: organizationId,
            orgName: orgName,
            appContainer: appContainer,
            initialSelected: r.metricsToExclude,
            onSave: (selected)=>{
                setMetricsToExcludeRow(null);
                onChangeRow(rowIndex, {
                    metricsToExclude: selected
                });
            },
            onClose: ()=>setMetricsToExcludeRow(null),
            featureFlag: featureFlag,
            isSparkView: isSparkView
        }));
    })))), (0, _react.jsx)(ControlsRow, null, (0, _react.jsx)(AddRowWrapper, null, (0, _react.jsx)(AddRowButton, {
        themes: [
            "secondary"
        ],
        type: "button",
        text: "+ Add Row",
        onClick: onAddRow,
        className: addRowClass
    })), (0, _react.jsx)(RightControls, null, (0, _react.jsx)(SaveChangesButton, {
        themes: [
            "primary",
            "start"
        ],
        text: "Save Changes",
        onClick: saveAll,
        disabled: scheduled.isLoading || isSaveDisabled,
        loading: scheduled.isLoading
    })))));
};
function rowKey(r, idx) {
    return r.id ?? `new-${idx}`;
}
/* ====== STYLES (RESPONSIVE) ====== */ const SaveChangesButton = /*#__PURE__*/ (0, _baseDefault.default)((0, _buttonDefault.default), {
    target: "e1jd8lm20"
})({
    name: "1sb8cc6",
    styles: "margin-right:0;@media (max-width: 768px){width:auto;min-width:140px;}@media (max-width: 480px){width:100%;max-width:200px;}"
});
const AddRowWrapper = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1jd8lm19"
})({
    name: "zdozp6",
    styles: "margin-left:0;@media (max-width: 768px){width:100%;display:flex;justify-content:center;}"
});
const AddRowButton = /*#__PURE__*/ (0, _baseDefault.default)((0, _buttonDefault.default), {
    target: "e1jd8lm18"
})({
    name: "94ezrj",
    styles: "margin-left:0;@media (max-width: 768px){width:auto;min-width:140px;}@media (max-width: 480px){width:100%;max-width:200px;}"
});
const EmailConfigurationWrapper = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1jd8lm17"
})({
    name: "ymw0ci",
    styles: "margin:0;padding:0;width:100%;@media (max-width: 768px){padding:0 8px;}@media (max-width: 480px){padding:0 4px;}"
});
const ControlsRow = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1jd8lm16"
})({
    name: "o5si0k",
    styles: "display:flex;justify-content:space-between;align-items:center;margin:6px 0 12px 0;gap:12px;flex-wrap:wrap;@media (max-width: 768px){flex-direction:column;align-items:stretch;gap:16px;margin:12px 0 16px 0;}@media (max-width: 480px){margin:8px 0 12px 0;gap:12px;}"
});
const LeftControls = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1jd8lm15"
})({
    name: "1cswimw",
    styles: "display:flex;align-items:center;margin-left:12px;gap:12px;@media (max-width: 768px){margin-left:0;justify-content:center;flex-wrap:wrap;width:100%;}@media (max-width: 480px){flex-direction:column;align-items:stretch;gap:8px;}"
});
const RightControls = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1jd8lm14"
})({
    name: "s0xblw",
    styles: "display:flex;align-items:center;gap:8px;@media (max-width: 768px){justify-content:center;width:100%;flex-wrap:wrap;}@media (max-width: 480px){flex-direction:column;align-items:stretch;gap:12px;}"
});
const FilterLabel = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1jd8lm13"
})("font-size:13px;color:", (0, _colors.color_shades_darkest), ";position:relative;font-weight:600;margin-right:12px;white-space:nowrap;@media (max-width: 768px){margin-right:0;text-align:center;margin-bottom:8px;}@media (max-width: 480px){font-size:14px;margin-bottom:4px;}");
const TableShell = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1jd8lm12"
})({
    name: "1f6030p",
    styles: "position:relative;overflow-x:auto;width:100%;border-radius:8px;@media (max-width: 768px){margin:0 -8px;border-radius:0;}@media (max-width: 480px){margin:0 -4px;}"
});
/**
 * Shared grid template for header + rows:
 *  1) Recipient
 *  2) Scope
 *  3) Begin Review
 *  4) Next Email Date
 *  5) Frequency
 *  6) Metrics
 *  7) Trash
 */ const tableGridTemplate = `
    minmax(180px, 1.8fr)
    minmax(180px, 1.4fr)
    minmax(180px, 1.4fr)
    minmax(120px, 1.1fr)
    minmax(120px, 1.1fr)
    auto
`;
const HeaderRow = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1jd8lm11"
})("display:grid;grid-template-columns:", tableGridTemplate, ";column-gap:8px;padding:8px 12px;border-bottom:", (0, _stylesValues.style_border_default), ";background:", (0, _colors.color_shades_light), ";position:sticky;top:0;z-index:2;min-width:900px;");
const TableLabelWrapper = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1jd8lm10"
})("font-weight:600;font-size:13px;color:", (0, _colors.color_shades_darkest), ";padding:4px 0;white-space:nowrap;");
const Scrollable = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1jd8lm9"
})({
    name: "o6dy0o",
    styles: "max-height:420px"
});
const BodyRow = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1jd8lm8"
})("display:grid;grid-template-columns:", tableGridTemplate, ";column-gap:8px;padding:8px 12px;background:", (0, _colors.color_defaults_white), ";border-left:", (0, _stylesValues.style_border_default), ";border-right:", (0, _stylesValues.style_border_default), ";border-bottom:", (0, _stylesValues.style_border_default), ";border-top:", (p)=>p.isTop ? (0, _stylesValues.style_border_default) : "none", ";min-width:900px;border-radius:", (p)=>p.isTop && p.isBottom ? "8px" : p.isBottom ? "0 0 8px 8px" : "0", ';&[data-deleted="1"]{opacity:0.55;}');
const addRowClass = /*#__PURE__*/ (0, _css.css)("", "");
const RowComponent = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1jd8lm7"
})({
    name: "1x17g94",
    styles: "display:flex;align-items:center;width:100%"
});
const Incrementer = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1jd8lm6"
})("display:inline-flex;align-items:center;border:", (0, _stylesValues.style_border_default), ";border-radius:6px;overflow:hidden;height:36px;width:100%;max-width:160px;button{width:36px;height:36px;border:none;background:#f3f3f3;font-size:18px;cursor:pointer;flex-shrink:0;}input{flex:1;min-width:0;text-align:center;border:none;outline:none;height:100%;font-size:13px;}");
const RemoveButton = /*#__PURE__*/ (0, _baseDefault.default)("button", {
    target: "e1jd8lm5"
})({
    name: "yjpjjd",
    styles: "background:none;border:none;cursor:pointer;padding:0;display:inline-flex;align-items:center;justify-content:center;width:32px;height:32px;img{width:16px;height:16px;}"
});
const EmptyState = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1jd8lm4"
})({
    name: "1q7yr8w",
    styles: "padding:16px;font-size:13px;color:#666;text-align:center;@media (max-width: 768px){padding:24px 16px;font-size:14px;}@media (max-width: 480px){padding:20px 12px;}"
});
const StyledTextField = /*#__PURE__*/ (0, _baseDefault.default)((0, _textFieldDefault.default), {
    target: "e1jd8lm3"
})("max-width:75%;height:", (props)=>props.height || "auto", ";.field-container{height:", (props)=>props.height || "auto", ";width:100%;}.field-container input{height:", (props)=>props.height || "auto", ";width:100%;}");
const StyledFilterDropdown = /*#__PURE__*/ (0, _baseDefault.default)((0, _styledDropdownDefault.default), {
    target: "e1jd8lm2"
})({
    name: "1rpkye7",
    styles: "min-width:200px;width:100%;@media (max-width: 768px){width:100%;max-width:300px;}@media (max-width: 480px){min-width:auto;width:100%;}"
});
const StyledTableDropdown = /*#__PURE__*/ (0, _baseDefault.default)((0, _styledDropdownDefault.default), {
    target: "e1jd8lm1"
})({
    name: "1tll1i4",
    styles: "width:100%;min-width:180px"
});
const PreviewButton = /*#__PURE__*/ (0, _baseDefault.default)((0, _buttonDefault.default), {
    target: "e1jd8lm0"
})({
    name: "nkj3yf",
    styles: "width:100%;max-width:140px"
});
exports.default = ScheduledEmailForm;

},{"@emotion/styled/base":"lSuFu","@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","../../components/general/Button":"6ymxN","../../components/structure/CustomScrollbars":"50vFq","../../hooks/ScheduledAnalyticsEmailContainer":"4KJ2O","../../components/forms/TextField":"7a7bh","../../scenes/applicationSettings/components/customAssistantConfigurations/StyledDropdown":"hjrMo","../../api":"loxM6","./MetricsToExcludeModal":"6NX8J","../../constants/colors":"1p3OR","../../constants/stylesValues":"dHVVv","../../constants/featureFlagIds":"33vuW","../structure/SettingsCard":"liIw4","9596e91e4141c24f":"7eyKJ","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4KJ2O":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _unstatedNext = require("unstated-next");
var _scheduledAnalyticsEmail = require("../api/controllers/scheduledAnalyticsEmail");
const compare = (a, b)=>{
    if (a == null && b == null) return 0;
    if (a == null) return -1;
    if (b == null) return 1;
    if (a instanceof Date || b instanceof Date) {
        const da = a instanceof Date ? a.getTime() : new Date(a).getTime();
        const db = b instanceof Date ? b.getTime() : new Date(b).getTime();
        return da - db;
    }
    if (typeof a === "number" && typeof b === "number") return a - b;
    return String(a).localeCompare(String(b));
};
const sorter = (key, order = "asc")=>{
    return (a, b)=>{
        let valA;
        let valB;
        switch(key){
            case "organization":
                valA = a.organizationId;
                valB = b.organizationId;
                break;
            case "application":
                valA = a.applicationId;
                valB = b.applicationId;
                break;
            case "created":
                valA = a.eventDate ? new Date(a.eventDate) : null;
                valB = b.eventDate ? new Date(b.eventDate) : null;
                break;
            case "email":
                // if your model stores recipient email at e.email
                valA = a?.email ?? "";
                valB = b?.email ?? "";
                break;
            case "startDate":
                valA = a.emailStartDate ? new Date(a.emailStartDate) : null;
                valB = b.emailStartDate ? new Date(b.emailStartDate) : null;
                break;
            case "id":
            default:
                valA = a.id;
                valB = b.id;
                break;
        }
        const base = compare(valA, valB);
        return order === "asc" ? base : -base;
    };
};
/**
 * A small in-memory index for quick access/grouping.
 */ const indexEmails = (list)=>{
    const byId = {};
    const byOrg = {};
    const byApp = {};
    const byOrgApp = {};
    for (const e of list){
        if (!e?.id) continue;
        byId[e.id] = e;
        if (e.organizationId) {
            if (!byOrg[e.organizationId]) byOrg[e.organizationId] = [];
            byOrg[e.organizationId].push(e);
        }
        if (e.applicationId) {
            if (!byApp[e.applicationId]) byApp[e.applicationId] = [];
            byApp[e.applicationId].push(e);
        }
        if (e.organizationId && e.applicationId) {
            const key = `${e.organizationId}|${e.applicationId}`;
            if (!byOrgApp[key]) byOrgApp[key] = [];
            byOrgApp[key].push(e);
        }
    }
    return {
        byId,
        byOrg,
        byApp,
        byOrgApp
    };
};
const mergeDistinct = (existing, incoming)=>{
    const seen = new Set();
    const out = [];
    for (const e of existing)if (e?.id) {
        seen.add(e.id);
        out.push(e);
    }
    for (const e of incoming)if (e?.id && !seen.has(e.id)) {
        seen.add(e.id);
        out.push(e);
    }
    return out;
};
const useScheduledAnalyticsEmailContainer = ()=>{
    const [isLoading, setIsLoading] = (0, _react.useState)(false);
    const [errors, setErrors] = (0, _react.useState)([]);
    const [emails, setEmails] = (0, _react.useState)([]);
    // Track fine-grained loading states for specific keys
    const loadingOrg = (0, _react.useRef)(new Set());
    const loadingOrgApp = (0, _react.useRef)(new Set());
    const { byId, byOrg, byApp, byOrgApp } = (0, _react.useMemo)(()=>indexEmails(emails), [
        emails
    ]);
    const setError = (0, _react.useCallback)((msg)=>{
        setErrors((prev)=>msg ? [
                ...prev,
                msg
            ] : prev);
    }, []);
    const clearErrors = (0, _react.useCallback)(()=>setErrors([]), []);
    // ---------- LOADERS ----------
    const loadForOrganization = (0, _react.useCallback)(async (organizationId)=>{
        if (!organizationId) return;
        loadingOrg.current.add(organizationId);
        setIsLoading(true);
        try {
            const res = await _scheduledAnalyticsEmail.getScheduledEmailsForOrganization(organizationId);
            if (res.resultType === "Ok") {
                console.log(res);
                // Replace existing entries for this org with the fresh ones
                const existingWithoutOrg = emails.filter((e)=>e.organizationId !== organizationId);
                setEmails(mergeDistinct(existingWithoutOrg, res.data || []));
            } else setError(res.errors?.[0] || `Failed to load emails for org ${organizationId}`);
        } catch (err) {
            setError(err?.message || `Failed to load emails for org ${organizationId}`);
        } finally{
            loadingOrg.current.delete(organizationId);
            setIsLoading(loadingOrg.current.size > 0 || loadingOrgApp.current.size > 0);
        }
    }, [
        emails,
        setError
    ]);
    const loadForApplication = (0, _react.useCallback)(async (applicationId, organizationId)=>{
        if (!applicationId || !organizationId) return;
        const key = `${organizationId}|${applicationId}`;
        loadingOrgApp.current.add(key);
        setIsLoading(true);
        try {
            const res = await _scheduledAnalyticsEmail.getResponsesForApplication(applicationId, organizationId);
            if (res.resultType === "Ok") {
                // Remove existing rows for this org+app, then add fresh ones
                const existingWithoutKey = emails.filter((e)=>!(e.organizationId === organizationId && e.applicationId === applicationId));
                setEmails(mergeDistinct(existingWithoutKey, res.data || []));
            } else setError(res.errors?.[0] || `Failed to load emails for app ${applicationId} in org ${organizationId}`);
        } catch (err) {
            setError(err?.message || `Failed to load emails for app ${applicationId} in org ${organizationId}`);
        } finally{
            loadingOrgApp.current.delete(key);
            setIsLoading(loadingOrg.current.size > 0 || loadingOrgApp.current.size > 0);
        }
    }, [
        emails,
        setError
    ]);
    // ---------- CRUD (optimistic) ----------
    const create = (0, _react.useCallback)(async (email)=>{
        // optimistic insert (temporary negative id if needed)
        const tempId = email.id || `temp-${Math.random().toString(36).slice(2)}`;
        const optimistic = {
            ...email,
            id: tempId
        };
        setEmails((prev)=>[
                optimistic,
                ...prev
            ]);
        try {
            const res = await _scheduledAnalyticsEmail.createScheduledEmail(email);
            if (res.resultType === "Ok" && res.data) {
                // replace temp with real
                setEmails((prev)=>prev.map((e)=>e.id === tempId ? res.data : e));
                return res.data;
            } else {
                // rollback
                setEmails((prev)=>prev.filter((e)=>e.id !== tempId));
                setError(res.errors?.[0] || "Failed to create scheduled email");
                console.log(res.errors);
            }
        } catch (err) {
            setEmails((prev)=>prev.filter((e)=>e.id !== tempId));
            setError(err?.message || "Failed to create scheduled email");
            console.log(err);
        }
        return null;
    }, [
        setError
    ]);
    const update = (0, _react.useCallback)(async (email)=>{
        if (!email?.id) return null;
        // optimistic update
        const prevSnapshot = byId[email.id];
        setEmails((prev)=>prev.map((e)=>e.id === email.id ? {
                    ...prevSnapshot,
                    ...email
                } : e));
        try {
            const res = await _scheduledAnalyticsEmail.updateScheduledEmail(email);
            if (res.resultType === "Ok" && res.data) {
                // ensure we use the server response
                setEmails((prev)=>prev.map((e)=>e.id === email.id ? res.data : e));
                return res.data;
            } else {
                // rollback
                setEmails((prev)=>prev.map((e)=>e.id === email.id ? prevSnapshot : e));
                setError(res.errors?.[0] || "Failed to update scheduled email");
            }
        } catch (err) {
            setEmails((prev)=>prev.map((e)=>e.id === email.id ? prevSnapshot : e));
            setError(err?.message || "Failed to update scheduled email");
        }
        return null;
    }, [
        byId,
        setError
    ]);
    const remove = (0, _react.useCallback)(async (emailId)=>{
        if (!emailId) return false;
        const prev = byId[emailId];
        if (!prev) return false;
        // optimistic remove
        setEmails((cur)=>cur.filter((e)=>e.id !== emailId));
        try {
            const res = await _scheduledAnalyticsEmail.deleteScheduledEmail(emailId);
            if (res.resultType === "Ok") return true;
            else {
                // rollback
                setEmails((cur)=>[
                        prev,
                        ...cur
                    ]);
                setError(res.errors?.[0] || "Failed to delete scheduled email");
            }
        } catch (err) {
            setEmails((cur)=>[
                    prev,
                    ...cur
                ]);
            setError(err?.message || "Failed to delete scheduled email");
        }
        return false;
    }, [
        byId,
        setError
    ]);
    const preview = (0, _react.useCallback)(async (orgId, orgName, excludedMetrics, featureFlagId, appId, appName)=>{
        if (!orgId) return null;
        const request = {
            organizationId: orgId,
            applicationId: appId,
            metricsToExclude: excludedMetrics,
            featureFlagId: featureFlagId,
            orgName: orgName,
            appName: appName
        };
        try {
            const res = await _scheduledAnalyticsEmail.previewScheduledEmail(request);
            if (res.resultType === "Ok") return res.data;
            else setError(res.errors?.[0] || "Failed to delete scheduled email");
        } catch (err) {
            setError(err?.message || "Failed to delete scheduled email");
        }
        return null;
    }, [
        byId,
        setError
    ]);
    // ---------- SELECTORS / HELPERS ----------
    const getById = (0, _react.useCallback)((id)=>byId[id], [
        byId
    ]);
    const getForOrganization = (0, _react.useCallback)((organizationId, sortBy = "created", order = "desc")=>{
        const arr = byOrg[organizationId] || [];
        return [
            ...arr
        ].sort(sorter(sortBy, order));
    }, [
        byOrg
    ]);
    const getForApplication = (0, _react.useCallback)((applicationId, sortBy = "created", order = "desc")=>{
        const arr = byApp[applicationId] || [];
        return [
            ...arr
        ].sort(sorter(sortBy, order));
    }, [
        byApp
    ]);
    const getForOrgAndApp = (0, _react.useCallback)((organizationId, applicationId, sortBy = "created", order = "desc")=>{
        const key = `${organizationId}|${applicationId}`;
        const arr = byOrgApp[key] || [];
        return [
            ...arr
        ].sort(sorter(sortBy, order));
    }, [
        byOrgApp
    ]);
    const listSortedByOrganization = (0, _react.useCallback)((order = "asc")=>[
            ...emails
        ].sort(sorter("organization", order)), [
        emails
    ]);
    const listSortedByApplication = (0, _react.useCallback)((order = "asc")=>[
            ...emails
        ].sort(sorter("application", order)), [
        emails
    ]);
    const refreshOrg = (0, _react.useCallback)((organizationId)=>loadForOrganization(organizationId), [
        loadForOrganization
    ]);
    const refreshApp = (0, _react.useCallback)((applicationId, organizationId)=>loadForApplication(applicationId, organizationId), [
        loadForApplication
    ]);
    const clearAll = (0, _react.useCallback)(()=>{
        setEmails([]);
        clearErrors();
    }, [
        clearErrors
    ]);
    return {
        // state
        isLoading,
        errors,
        emails,
        // indexes
        byId,
        byOrg,
        byApp,
        byOrgApp,
        // loaders
        loadForOrganization,
        loadForApplication,
        refreshOrg,
        refreshApp,
        // crud
        create,
        update,
        remove,
        preview,
        // selectors
        getById,
        getForOrganization,
        getForApplication,
        getForOrgAndApp,
        listSortedByOrganization,
        listSortedByApplication,
        // utils
        clearErrors,
        clearAll
    };
};
const ScheduledAnalyticsEmailContainer = (0, _unstatedNext.createContainer)(useScheduledAnalyticsEmailContainer);
exports.default = ScheduledAnalyticsEmailContainer;

},{"react":"6uln9","unstated-next":"61zE5","../api/controllers/scheduledAnalyticsEmail":"k7EIZ","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"k7EIZ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getScheduledEmailsForOrganization", ()=>getScheduledEmailsForOrganization);
parcelHelpers.export(exports, "getResponsesForApplication", ()=>getResponsesForApplication);
parcelHelpers.export(exports, "createScheduledEmail", ()=>createScheduledEmail);
parcelHelpers.export(exports, "updateScheduledEmail", ()=>updateScheduledEmail);
parcelHelpers.export(exports, "deleteScheduledEmail", ()=>deleteScheduledEmail);
parcelHelpers.export(exports, "previewScheduledEmail", ()=>previewScheduledEmail);
var _generic = require("./generic");
const getScheduledEmailsForOrganization = (organizationId)=>{
    return (0, _generic.sendGet)("/ScheduledAnalyticsEmails/getScheduledOverviewEmails?" + `organizationId=${organizationId}`);
};
const getResponsesForApplication = (appId, organizationId)=>{
    return (0, _generic.sendGet)("/ScheduledAnalyticsEmails/getScheduledOverviewEmails?" + `applicationId=${appId}&organizationId=${organizationId}`);
};
const createScheduledEmail = (email)=>{
    return (0, _generic.sendPost)("/ScheduledAnalyticsEmails/createScheduledOverviewEmail", email);
};
const updateScheduledEmail = (email)=>{
    return (0, _generic.sendPut)("/ScheduledAnalyticsEmails/updateScheduledOverviewEmail", email);
};
const deleteScheduledEmail = (emailId)=>{
    return (0, _generic.sendDelete)("/ScheduledAnalyticsEmails/deletedScheduledOverviewEmail?" + `scheduledAnalyticsEmailId=${emailId}`);
};
const previewScheduledEmail = (request)=>{
    return (0, _generic.sendPost)("/ScheduledAnalyticsEmails/previewScheduledOverviewEmail", request);
};

},{"./generic":"6oGDt","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6NX8J":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _base = require("@emotion/styled/base");
var _baseDefault = parcelHelpers.interopDefault(_base);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _modalHeader = require("../../components/general/ModalHeader");
var _modalHeaderDefault = parcelHelpers.interopDefault(_modalHeader);
var _button = require("../../components/general/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _customScrollbars = require("../../components/structure/CustomScrollbars");
var _customScrollbarsDefault = parcelHelpers.interopDefault(_customScrollbars);
var _scheduledAnalyticsEmailContainer = require("../../hooks/ScheduledAnalyticsEmailContainer");
var _scheduledAnalyticsEmailContainerDefault = parcelHelpers.interopDefault(_scheduledAnalyticsEmailContainer);
var _metricsToExclude = require("../../constants/analyticsConstants/metricsToExclude");
var _stylesValues = require("../../constants/stylesValues");
var _colors = require("../../constants/colors");
var _smallModalLayout = require("../structure/SmallModalLayout");
var _smallModalLayoutDefault = parcelHelpers.interopDefault(_smallModalLayout);
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const SplitAnalyticsEmailModal = ({ isVisible, orgId, orgName, appId, featureFlag, appContainer, initialSelected: initialExcluded, onSave, onClose, title = "Email Preview", leftTitle = "Metrics to Include", rightTitle = "Email Preview", isSparkView = false })=>{
    const scheduled = (0, _scheduledAnalyticsEmailContainerDefault.default).useContainer();
    const iframeRef = (0, _react1.useRef)(null);
    const [appName, setAppName] = (0, _react1.useState)(null);
    const [html, setHtml] = (0, _react1.useState)("");
    const [fitWidth, setFitWidth] = (0, _react1.useState)(true);
    const [iframeHeight, setIframeHeight] = (0, _react1.useState)(640);
    const StyledButton = /*#__PURE__*/ (0, _baseDefault.default)((0, _buttonDefault.default), {
        target: "e1tnfxcc11"
    })({
        name: "nbjuba",
        styles: "position:relative;left:-15px;height:30px;width:90px;font-size:13px"
    });
    const PanesWrapper = /*#__PURE__*/ (0, _baseDefault.default)("div", {
        target: "e1tnfxcc10"
    })({
        name: "16srgin",
        styles: "display:flex;align-items:stretch;gap:0;padding:0 18px 0 18px;min-height:560px"
    });
    const LeftPane = /*#__PURE__*/ (0, _baseDefault.default)("section", {
        target: "e1tnfxcc9"
    })("display:flex;flex-direction:column;min-width:260px;border-right:", (0, _stylesValues.style_border_default), ";padding:12px 16px 0 16px;flex:1 1 0;");
    const RightPane = /*#__PURE__*/ (0, _baseDefault.default)("section", {
        target: "e1tnfxcc8"
    })({
        name: "izesjh",
        styles: "display:flex;flex-direction:column;min-width:320px;padding:12px 16px 0 16px;flex:1 1 0"
    });
    const PaneHeader = /*#__PURE__*/ (0, _baseDefault.default)("h3", {
        target: "e1tnfxcc7"
    })({
        name: "1pljkfx",
        styles: "margin:0 0 0 0;font-size:14px;font-weight:600;padding:4px 18px 0 18px"
    });
    const ControlsRow = /*#__PURE__*/ (0, _baseDefault.default)("div", {
        target: "e1tnfxcc6"
    })({
        name: "1eegsku",
        styles: "display:flex;justify-content:space-between;align-items:center;padding:4px 0px 4px 16px"
    });
    const muted = /*#__PURE__*/ (0, _css.css)("font-size:13px;color:", (0, _colors.color_shades_darkest), ";opacity:0.85;", "");
    const PaneBody = /*#__PURE__*/ (0, _baseDefault.default)("div", {
        target: "e1tnfxcc5"
    })("border-top:", (0, _stylesValues.style_border_default), ";");
    const Grid = /*#__PURE__*/ (0, _baseDefault.default)("div", {
        target: "e1tnfxcc4"
    })({
        name: "1g8nuv2",
        styles: "display:grid;grid-template-columns:1fr 1fr;gap:8px 16px;padding-right:6px;@media (max-width: 900px){grid-template-columns:1fr;}"
    });
    const MetricCell = /*#__PURE__*/ (0, _baseDefault.default)("div", {
        target: "e1tnfxcc3"
    })({
        name: "1ud9i0q",
        styles: "padding:8px 0"
    });
    const CheckboxLabel = /*#__PURE__*/ (0, _baseDefault.default)("label", {
        target: "e1tnfxcc2"
    })({
        name: "9hdwae",
        styles: "display:inline-flex;align-items:center;gap:10px;font-size:13px;input{width:16px;height:16px;margin:0;}"
    });
    const PreviewShell = /*#__PURE__*/ (0, _baseDefault.default)("div", {
        target: "e1tnfxcc1"
    })((p)=>!p.fitWidth ? `overflow-x: auto;` : ``, ";");
    const FrameWrap = /*#__PURE__*/ (0, _baseDefault.default)("div", {
        target: "e1tnfxcc0"
    })("display:flex;justify-content:", (p)=>p.fitWidth ? "stretch" : "flex-start", ";align-items:flex-start;", (p)=>!p.fitWidth ? `
            background: repeating-linear-gradient(
            45deg,
            #fafafa,
            #fafafa 10px,
            #f6f6f6 10px,
            #f6f6f6 20px
            );
            padding: 12px;
            border-radius: 8px;
        ` : ``, ";");
    // ----- LEFT PANE: Metrics selection (include toggles) -----
    let metrics = (0, _metricsToExclude.METRICS_TO_EXCLUDE)(featureFlag); // [key,label][]
    const SPARK_VIEW_EXCLUDED_METRICS = new Set();
    //Todo: if isSparkView, filter out metrics we don't want to show clients
    if (isSparkView) metrics = metrics.filter(([key])=>!SPARK_VIEW_EXCLUDED_METRICS.has(key));
    // Convert "excluded" seed into an "included set" for checkbox UX
    const initialIncluded = (0, _react1.useMemo)(()=>{
        const excludedSet = new Set(initialExcluded);
        return metrics.filter(([key])=>!excludedSet.has(key)).map(([key])=>key);
    }, [
        featureFlag,
        JSON.stringify(initialExcluded)
    ]);
    const [includedSet, setIncludedSet] = (0, _react1.useState)(new Set(initialIncluded));
    (0, _react1.useEffect)(()=>{
        // keep in sync when re-opening or props change
        if (isVisible) setIncludedSet(new Set(initialIncluded));
    }, [
        isVisible,
        initialIncluded.join("|")
    ]);
    const toggle = (key)=>{
        setIncludedSet((prev)=>{
            const next = new Set(prev);
            if (next.has(key)) next.delete(key);
            else next.add(key);
            return next;
        });
    };
    const selectAll = ()=>{
        if (includedSet.size === metrics.length) setIncludedSet(new Set());
        else setIncludedSet(new Set(metrics.map((m)=>m[0])));
    };
    // derived excluded list (for saving and for preview input)
    const excludedList = (0, _react1.useMemo)(()=>metrics.filter(([key])=>!includedSet.has(key)).map(([key])=>key), [
        includedSet,
        featureFlag
    ]);
    const anyChanges = (0, _react1.useMemo)(()=>{
        const a = [
            ...excludedList
        ].sort().join("|");
        const b = [
            ...initialExcluded || []
        ].sort().join("|");
        return a !== b;
    }, [
        excludedList,
        initialExcluded
    ]);
    // resolve app name (once per open)
    (0, _react1.useEffect)(()=>{
        if (!isVisible) return;
        (async ()=>{
            try {
                const result = await appContainer.getApplicationsForOrg(orgId);
                const selectedApp = result?.data?.find((a)=>a.id === appId);
                setAppName(selectedApp?.name ?? null);
            } catch  {
                setAppName(null);
            }
        })();
    }, [
        isVisible,
        orgId,
        appId,
        appContainer
    ]);
    // load/refresh preview whenever pane is open + dependencies change
    (0, _react1.useEffect)(()=>{
        if (!isVisible) {
            setHtml("");
            return;
        }
        let cancelled = false;
        (async ()=>{
            try {
                const res = await scheduled.preview(orgId, orgName, excludedList, // IMPORTANT: pass excluded metrics
                featureFlag, appId, appName ?? undefined);
                if (!cancelled && res != null) setHtml(res);
            } catch (err) {
                console.error("Failed to load preview:", err);
                if (!cancelled) setHtml("<p>Failed to load preview.</p>");
            }
        })();
        return ()=>{
            cancelled = true;
        };
    }, [
        isVisible,
        orgId,
        orgName,
        appId,
        appName,
        featureFlag,
        excludedList.join("|"),
        // change preview when metrics change
        scheduled
    ]);
    const srcDoc = (0, _react1.useMemo)(()=>{
        const hasHtmlTag = /<html[\s>]/i.test(html || "");
        if (hasHtmlTag) return html || "<!doctype html><html><body><p>No content.</p></body></html>";
        // wrap fragments
        return `<!doctype html>
<html>
  <head>
    <meta charset="utf-8"/>
    <meta name="viewport" content="width=device-width, initial-scale=1"/>
    <style>
      html, body { margin:0; padding:0; background:#fff; }
      body { -webkit-font-smoothing: antialiased; text-rendering: optimizeLegibility; }
      img { max-width: 100%; height: auto; }
      table { border-collapse: collapse; }
    </style>
  </head>
  <body>${html || "<p>No content.</p>"}</body>
</html>`;
    }, [
        html
    ]);
    const handleLoad = (0, _react1.useCallback)(()=>{
        const iframe = iframeRef.current;
        if (!iframe) return;
        try {
            const doc = iframe.contentDocument || iframe.contentWindow?.document;
            if (!doc) return;
            // ensure white bg for readability
            const baseStyle = doc.createElement("style");
            baseStyle.innerHTML = `html,body{margin:0} body{background:#fff}`;
            doc.head?.appendChild(baseStyle);
            const h = Math.max(doc.body?.scrollHeight || 0, doc.documentElement?.scrollHeight || 0, 640);
            setIframeHeight(Math.min(h, 1800));
        } catch  {
        // ignore
        }
    }, []);
    // reset zoom/height each time it opens
    (0, _react1.useEffect)(()=>{
        if (isVisible) {
            setFitWidth(true);
            setIframeHeight(640);
        }
    }, [
        isVisible
    ]);
    // ----- Save / Cancel -----
    const handleSave = ()=>onSave(excludedList);
    return (0, _react.jsx)((0, _smallModalLayoutDefault.default), {
        isVisible: isVisible,
        onClose: onClose
    }, (0, _react.jsx)((0, _modalHeaderDefault.default), {
        title: title,
        onClose: onClose
    }), (0, _react.jsx)(ControlsRow, null, (0, _react.jsx)("span", {
        className: muted
    }, "Data is randomly generated for demonstration.")), (0, _react.jsx)(PaneBody, null, (0, _react.jsx)(PreviewShell, {
        fitWidth: fitWidth
    }, (0, _react.jsx)((0, _customScrollbarsDefault.default), {
        autoHide: true,
        autoHeight: true,
        autoHeightMax: 520
    }, (0, _react.jsx)(FrameWrap, {
        fitWidth: fitWidth
    }, (0, _react.jsx)("iframe", {
        ref: iframeRef,
        title: "Email Preview",
        sandbox: "allow-same-origin allow-popups allow-popups-to-escape-sandbox",
        srcDoc: srcDoc,
        onLoad: handleLoad,
        style: {
            width: fitWidth ? "100%" : 800,
            height: iframeHeight,
            border: "none",
            background: "#fff"
        }
    }))))));
};
exports.default = SplitAnalyticsEmailModal;

},{"@emotion/styled/base":"lSuFu","@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","../../components/general/ModalHeader":"aUACx","../../components/general/Button":"6ymxN","../../components/structure/CustomScrollbars":"50vFq","../../hooks/ScheduledAnalyticsEmailContainer":"4KJ2O","../../constants/analyticsConstants/metricsToExclude":"ewvgO","../../constants/stylesValues":"dHVVv","../../constants/colors":"1p3OR","../structure/SmallModalLayout":"khwvt","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"ewvgO":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "METRICS_TO_EXCLUDE", ()=>METRICS_TO_EXCLUDE);
var _featureFlagIds = require("../featureFlagIds");
const UNIVERSAL_METRICS_TO_EXCLUDE = [
    [
        "TotalEngagementCount",
        "Total Engagement Count"
    ],
    [
        "NoInteraction",
        "No Interaction"
    ],
    [
        "ImmediateTransfer",
        "Immediate Transfer"
    ],
    [
        "Other",
        "Miscellaneous Calls"
    ],
    [
        "Transfers",
        "Transfers"
    ],
    [
        "AiIssue",
        "AI Issue"
    ],
    [
        "UnsupportedCustomerRequest",
        "Unsupported Customer Request"
    ],
    [
        "CustomerFrustration",
        "Customer Frustration"
    ],
    [
        "CustomerDelight",
        "Customer Delight"
    ]
];
const FOOD_ORDERING_METRICS_TO_EXCLUDE = [
    [
        "ActionCompletedRate",
        "Order Placed Rate"
    ],
    [
        "ActionCompleted",
        "Order Placed"
    ],
    [
        "UpsellSuccessfulRate",
        "Upsell Successful Rate"
    ],
    [
        "ActionAttempted",
        "Order Attempted"
    ],
    [
        "UPSELL_ATTEMPTED",
        "Attempted Upsells"
    ],
    [
        "UPSELL_SUCCESSFUl",
        "Successful Upsells"
    ]
];
const HEALTHCARE_METRICS_TO_EXCLUDE = [
    [
        "ActionCompletedRate",
        "Appointment Modification Success Rate"
    ],
    [
        "ActionCompleted",
        "Appointment Successfully Booked"
    ],
    [
        "APPOINTMENT_RESCHEDULED",
        "Appointment Successfully Rescheduled"
    ],
    [
        "APPOINTMENT_CANCELLED",
        "Appointment Successfully Cancelled"
    ],
    [
        "SCHEDULE_ATTEMPTED",
        "Appointment Booking Attempted"
    ],
    [
        "RESCHEDULE_ATTEMPTED",
        "Appointment Reschedule Attempted"
    ],
    [
        "CANCELLATION_ATTEMPTED",
        "Appointment Cancellation Attempted"
    ],
    [
        "SPANISH",
        "Spanish Calls"
    ],
    [
        "UNSUPPORTED_APPOINTMENT_TYPE",
        "Unsupported Appointment Type Requests"
    ],
    [
        "CHECK_NEXT_APPOINTMENT",
        "Requests For Checking New Appointments"
    ],
    [
        "NEW_PATIENT",
        "Number of New Patient Calls"
    ]
];
const GENERIC_METRICS_TO_EXCLUDE = [
    [
        "ActionCompletedRate",
        "Action Completed Rate"
    ],
    [
        "ActionAttempted",
        "Action Attempted"
    ],
    [
        "ActionCompleted",
        "Action Completed"
    ]
];
const METRICS_TO_EXCLUDE = (featureFlagId)=>{
    let metrics = UNIVERSAL_METRICS_TO_EXCLUDE;
    if (featureFlagId === (0, _featureFlagIds.FoodOrderingFeatureFlagId)) {
        metrics = metrics.concat(FOOD_ORDERING_METRICS_TO_EXCLUDE);
        return metrics;
    } else if (featureFlagId === (0, _featureFlagIds.HealthcareSchedulingFeatureFlagId)) {
        metrics = metrics.concat(HEALTHCARE_METRICS_TO_EXCLUDE);
        return metrics;
    } else {
        metrics = metrics.concat(GENERIC_METRICS_TO_EXCLUDE);
        return metrics;
    }
};

},{"../featureFlagIds":"33vuW","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"cFUKV":[function(require,module,exports) {
module.exports = require("a262736cbddbcafb").getBundleURL("kVLro") + require("1ac2de2f4f49e43b").resolve("duFyu");

},{"a262736cbddbcafb":"c7Tr5","1ac2de2f4f49e43b":"fyJL2"}],"l664n":[function(require,module,exports) {
module.exports = require("87f6ead6990ce39b").getBundleURL("kVLro") + require("e081e23d27278961").resolve("hDLVK");

},{"87f6ead6990ce39b":"c7Tr5","e081e23d27278961":"fyJL2"}],"fZ9GS":[function(require,module,exports) {
module.exports = require("8a773f257cc2a1b5").getBundleURL("kVLro") + require("67fe258ff47e75b5").resolve("1gM9p");

},{"8a773f257cc2a1b5":"c7Tr5","67fe258ff47e75b5":"fyJL2"}],"hn74a":[function(require,module,exports) {
module.exports = require("7300c01e5bcb08d8").getBundleURL("kVLro") + require("2bb76d7c2e6a562e").resolve("bo93q");

},{"7300c01e5bcb08d8":"c7Tr5","2bb76d7c2e6a562e":"fyJL2"}],"eKCse":[function(require,module,exports) {
module.exports = require("5a46ad14f0555306").getBundleURL("kVLro") + require("fed5f63bd98b91a").resolve("iSPSI");

},{"5a46ad14f0555306":"c7Tr5","fed5f63bd98b91a":"fyJL2"}],"eR20j":[function(require,module,exports) {
module.exports = require("3cf7fdae15644479").getBundleURL("kVLro") + require("2961a2ef118d8e88").resolve("53d5W");

},{"3cf7fdae15644479":"c7Tr5","2961a2ef118d8e88":"fyJL2"}],"amyk0":[function(require,module,exports) {
module.exports = require("17c09fe8ae699643").getBundleURL("kVLro") + require("3f3878c1f4b248c0").resolve("lFT6N");

},{"17c09fe8ae699643":"c7Tr5","3f3878c1f4b248c0":"fyJL2"}],"adACm":[function(require,module,exports) {
module.exports = require("9ee1f63eac76ecbc").getBundleURL("kVLro") + require("49aedcfc5c31165c").resolve("6cfKa");

},{"9ee1f63eac76ecbc":"c7Tr5","49aedcfc5c31165c":"fyJL2"}],"dWSJG":[function(require,module,exports) {
module.exports = require("78f6ca779a86a641").getBundleURL("kVLro") + require("394f23ae7464ce6f").resolve("bGnFq");

},{"78f6ca779a86a641":"c7Tr5","394f23ae7464ce6f":"fyJL2"}],"23bLn":[function(require,module,exports) {
module.exports = require("c44fe7ff7c7cfcdf").getBundleURL("kVLro") + require("82c655f0ac2d071d").resolve("4oLZ9");

},{"c44fe7ff7c7cfcdf":"c7Tr5","82c655f0ac2d071d":"fyJL2"}],"8VQkf":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _reactRouterDom = require("react-router-dom");
var _breakpoints = require("../../../constants/breakpoints");
const iconUrl = require("217b5f3aaf704651");
const logoUrl = require("e1e7ebe2db75cc17");
const inverseLogo = require("45f365c8dc75bae1");
const Logo = (props)=>(0, _react.jsx)("div", {
        className: logoStyle
    }, (0, _react.jsx)((0, _reactRouterDom.Link), {
        to: props?.linkOverride?.length ? props.linkOverride : "/v"
    }, props.isFull ? (0, _react.jsx)("img", {
        src: props.isInverse ? inverseLogo : logoUrl,
        className: props.imgClassName || "logo",
        alt: "Voicify"
    }) : (0, _react.jsx)("img", {
        src: iconUrl,
        className: props.imgClassName || "icon",
        alt: "Voicify"
    })));
const logoStyle = /*#__PURE__*/ (0, _css.css)("padding-left:24px;img{padding:0 4px;margin-right:24px;}.icon{height:42px;margin-right:12px;}", (0, _breakpoints.breakpoint_small), "{img{margin-right:0;padding:0;}.logo{width:100px;}}", "");
exports.default = Logo;

},{"@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","react-router-dom":"5fzqq","../../../constants/breakpoints":"2F01A","217b5f3aaf704651":"e2QPt","e1e7ebe2db75cc17":"8bozS","45f365c8dc75bae1":"a3tAP","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"e2QPt":[function(require,module,exports) {
module.exports = require("53601c6199ee").getBundleURL("kVLro") + require("fd9453cf71ccec3e").resolve("hXQY8");

},{"53601c6199ee":"c7Tr5","fd9453cf71ccec3e":"fyJL2"}],"a3tAP":[function(require,module,exports) {
module.exports = require("15bb8b6dae44a9b").getBundleURL("kVLro") + require("a808c1a0af20d3a0").resolve("5PIug");

},{"15bb8b6dae44a9b":"c7Tr5","a808c1a0af20d3a0":"fyJL2"}],"6RpIg":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _unstated = require("unstated");
var _titleStateContainer = require("../../state/containers/TitleStateContainer");
var _titleStateContainerDefault = parcelHelpers.interopDefault(_titleStateContainer);
var _headerTitleView = require("../../components/structure/HeaderTitleView");
var _headerTitleViewDefault = parcelHelpers.interopDefault(_headerTitleView);
var _applicationContainer = require("../../state/containers/ApplicationContainer");
var _applicationContainerDefault = parcelHelpers.interopDefault(_applicationContainer);
const DashboardHeader = (props)=>{
    return (0, _react.jsx)((0, _unstated.Subscribe), {
        to: [
            (0, _applicationContainerDefault.default),
            (0, _titleStateContainerDefault.default)
        ]
    }, (appContainer, titleContainer)=>{
        return (0, _react.jsx)((0, _headerTitleViewDefault.default), {
            text: titleContainer.state.title,
            app: appContainer.state.currentApp,
            forceTitle: props.forceTitle,
            breadcrumb: !props.noBreadCrumb && titleContainer.state.breadcrumb
        });
    });
};
exports.default = DashboardHeader;

},{"@emotion/react":"djZKr","react":"6uln9","unstated":"grh7p","../../state/containers/TitleStateContainer":"2osOD","../../components/structure/HeaderTitleView":"4unvp","../../state/containers/ApplicationContainer":"cuqi2","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"irOVp":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _unstated = require("unstated");
var _organizationContainer = require("../../state/containers/OrganizationContainer");
var _organizationContainerDefault = parcelHelpers.interopDefault(_organizationContainer);
var _userContainer = require("../../state/containers/UserContainer");
var _userContainerDefault = parcelHelpers.interopDefault(_userContainer);
var _authContainer = require("../../state/containers/AuthContainer");
var _authContainerDefault = parcelHelpers.interopDefault(_authContainer);
var _profile = require("./components/Profile");
var _profileDefault = parcelHelpers.interopDefault(_profile);
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const ProfileMenu = ()=>{
    return (0, _react.jsx)((0, _unstated.Subscribe), {
        to: [
            (0, _organizationContainerDefault.default),
            (0, _userContainerDefault.default),
            (0, _authContainerDefault.default)
        ]
    }, (orgContainer, userContainer, authContainer)=>{
        return (0, _react.jsx)("div", {
            className: containerStyle
        }, (0, _react.jsx)((0, _profileDefault.default), {
            organizationContainer: orgContainer,
            userContainer: userContainer,
            authContainer: authContainer
        }));
    });
};
exports.default = ProfileMenu;
const containerStyle = /*#__PURE__*/ (0, _css.css)({
    name: "1bvl9fx",
    styles: "margin-right:32px;margin-left:24px"
});

},{"@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","unstated":"grh7p","../../state/containers/OrganizationContainer":"dlbaM","../../state/containers/UserContainer":"jDrDR","../../state/containers/AuthContainer":"cl1Qb","./components/Profile":"jncbB","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jncbB":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _colors = require("../../../constants/colors");
var _accountPanel = require("./AccountPanel");
var _accountPanelDefault = parcelHelpers.interopDefault(_accountPanel);
var _verticalSeparator = require("../../../components/structure/VerticalSeparator");
var _verticalSeparatorDefault = parcelHelpers.interopDefault(_verticalSeparator);
var _slideInSlideOutComponent = require("../../../components/structure/SlideInSlideOutComponent");
var _slideInSlideOutComponentDefault = parcelHelpers.interopDefault(_slideInSlideOutComponent);
var _userAvatar = require("../../../components/general/UserAvatar");
var _userAvatarDefault = parcelHelpers.interopDefault(_userAvatar);
var _notificationsContainer = require("../../../hooks/NotificationsContainer");
var _notificationsContainerDefault = parcelHelpers.interopDefault(_notificationsContainer);
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const Profile = (props)=>{
    const notificationsHook = (0, _notificationsContainerDefault.default).useContainer();
    const [isMenuOpen, setMenuOpen] = (0, _react1.useState)(false);
    (0, _react1.useEffect)(()=>{
        props.userContainer.getUser();
        props.organizationContainer.getOrganizations();
    }, []);
    const getUnreadNotificationsCount = (notifications)=>{
        return notifications.filter((n)=>!n.isRead).length;
    };
    if (props.userContainer.state.currentUser === null) return null;
    const unreadNotificationsCount = getUnreadNotificationsCount(notificationsHook.notifications) ?? 0;
    const currentUser = props.userContainer.state.currentUser;
    return (0, _react.jsx)("div", null, (0, _react.jsx)("div", {
        className: containerStyle,
        onClick: ()=>setMenuOpen(!isMenuOpen)
    }, (0, _react.jsx)((0, _verticalSeparatorDefault.default), {
        className: verticalSeparator
    }), unreadNotificationsCount > 0 && (0, _react.jsx)("div", {
        className: unreadCount
    }, unreadNotificationsCount), currentUser != null && (0, _react.jsx)((0, _userAvatarDefault.default), {
        className: `${avatarStyle}${unreadNotificationsCount > 0 ? " alert" : "'"} ac-user-profile-avatar`,
        lastName: currentUser?.lastName,
        firstName: currentUser?.firstName,
        src: currentUser?.imageUrl,
        size: 40
    })), (0, _react.jsx)((0, _slideInSlideOutComponentDefault.default), {
        styleName: "userProfileStyle",
        direction: "left",
        showChildren: isMenuOpen
    }, (0, _react.jsx)((0, _accountPanelDefault.default), {
        key: "accountPanel",
        organizationContainer: props.organizationContainer,
        userContainer: props.userContainer,
        authContainer: props.authContainer,
        onClose: ()=>setMenuOpen(false)
    })));
};
const containerStyle = /*#__PURE__*/ (0, _css.css)({
    name: "vl1cqz",
    styles: "display:flex;align-items:center;cursor:pointer;flex-direction:row;position:relative"
});
const unreadCount = /*#__PURE__*/ (0, _css.css)("background-color:", (0, _colors.color_colors_decline), ";border-radius:50%;width:16px;height:16px;font-size:12px;line-height:16px;align-items:center;text-align:center;position:absolute;top:-2px;right:6px;", "");
const avatarStyle = /*#__PURE__*/ (0, _css.css)("margin-right:8px;border-radius:50%;&.alert{border:solid 2px ", (0, _colors.color_colors_decline), ";}", "");
const verticalSeparator = /*#__PURE__*/ (0, _css.css)("background:", (0, _colors.color_shades_darker), ";", "");
exports.default = Profile;

},{"@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","../../../constants/colors":"1p3OR","./AccountPanel":"hcdKM","../../../components/structure/VerticalSeparator":"aNNRC","../../../components/structure/SlideInSlideOutComponent":"bwTqS","../../../components/general/UserAvatar":"avuDP","../../../hooks/NotificationsContainer":"hNroK","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hcdKM":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _base = require("@emotion/styled/base");
var _baseDefault = parcelHelpers.interopDefault(_base);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _colors = require("../../../constants/colors");
var _verticalSeparator = require("../../../components/structure/VerticalSeparator");
var _verticalSeparatorDefault = parcelHelpers.interopDefault(_verticalSeparator);
var _reactTabs = require("react-tabs");
var _tabContainerPanel = require("../../../components/structure/Panels/TabContainerPanel");
var _tabContainerPanelDefault = parcelHelpers.interopDefault(_tabContainerPanel);
var _button = require("../../../components/general/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _platformHelpMenu = require("../../platformHelpMenu");
var _platformHelpMenuDefault = parcelHelpers.interopDefault(_platformHelpMenu);
var _organizationsMenuItem = require("./OrganizationsMenuItem");
var _organizationsMenuItemDefault = parcelHelpers.interopDefault(_organizationsMenuItem);
var _notificationsList = require("./NotificationsList");
var _notificationsListDefault = parcelHelpers.interopDefault(_notificationsList);
var _reactRouterDom = require("react-router-dom");
var _userSettings = require("./UserSettings");
var _userSettingsDefault = parcelHelpers.interopDefault(_userSettings);
var _pageError = require("../../../components/general/PageError");
var _pageErrorDefault = parcelHelpers.interopDefault(_pageError);
var _scrollablePanelBody = require("../../../components/structure/ScrollablePanelBody");
var _scrollablePanelBodyDefault = parcelHelpers.interopDefault(_scrollablePanelBody);
var _stylesValues = require("../../../constants/stylesValues");
var _supportAssistant = require("../../platformHelpMenu/SupportAssistant");
var _supportAssistantDefault = parcelHelpers.interopDefault(_supportAssistant);
var _overflowMenu = require("../../../components/general/overflowMenu/OverflowMenu");
var _overflowMenuDefault = parcelHelpers.interopDefault(_overflowMenu);
var _toggleIndicator = require("../../../components/general/ToggleIndicator");
var _toggleIndicatorDefault = parcelHelpers.interopDefault(_toggleIndicator);
var _notificationsContainer = require("../../../hooks/NotificationsContainer");
var _notificationsContainerDefault = parcelHelpers.interopDefault(_notificationsContainer);
var _breakpoints = require("../../../constants/breakpoints");
var _searchField = require("../../../components/forms/SearchField");
var _searchFieldDefault = parcelHelpers.interopDefault(_searchField);
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const closeIcon = require("67b91bf6510c7c4b");
const help = require("32969f8faafb7d30");
const helpSelected = require("e951262b69b30c0e");
const notifications = require("239195b7627d6651");
const notificationsSelected = require("cb6c3cc486600f44");
const notificationsAvailable = require("43b478af529fb49f");
const notificationsAvailableSelected = require("8fd24febe8ccd2e3");
const organization = require("ee95c733b07ff908");
const organizationSelected = require("917b60a71c816d10");
const userSettings = require("aefacfc25db2add0");
const userSettingsSelected = require("95042c6e3abb8677");
const signoutIcon = require("dd3d51583d3d3570");
const markAsSeenIcon = require("770c45d11349071f");
const AccountPanel = ({ onClose, organizationContainer, userContainer, authContainer })=>{
    const [selectedIndex, setSelectedIndex] = (0, _react1.useState)(0);
    const [showChat, setShowChat] = (0, _react1.useState)(true);
    const [showMenu, setShowMenu] = (0, _react1.useState)(false);
    const [searchFieldValue, setSearchFieldValue] = (0, _react1.useState)("");
    const notificationsHook = (0, _notificationsContainerDefault.default).useContainer();
    (0, _react1.useEffect)(()=>{
        // subscribe event
        document.addEventListener("click", handleDocumentClick);
        return ()=>{
            // unsubscribe event
            document.removeEventListener("click", handleDocumentClick);
        };
    }, []);
    const handleDocumentClick = (e)=>{
        if (e.target.closest(`.${accountPanelStyle}`)) return;
        if (e.target.closest(".ac-user-profile-avatar")) return;
        onClose();
    };
    const handleOrganizationSelected = async (org)=>{
        await organizationContainer.setCurrentOrgById(org.id);
        location.href = "/v";
    };
    const checkUnreadNotifications = (notifications)=>{
        return notifications.some((n)=>!n.isRead);
    };
    const clearErrors = ()=>{
        notificationsHook.clearErrors();
        userContainer.clearErrors();
        organizationContainer.clearErrors();
    };
    const hasUnreadNotifications = checkUnreadNotifications(notificationsHook.notifications);
    const errors = [
        ...userContainer.state.errors,
        ...notificationsHook.errors,
        ...organizationContainer.state.errors
    ];
    const openNewTab = (url)=>{
        const win = window.open(url, "_blank");
        win.focus();
    };
    const handleMenuOptionSelected = (label, e)=>{
        e.preventDefault();
        e.stopPropagation();
        switch(label){
            case "Getting Started Tutorials":
                openNewTab("https://app.voicify.com?appcue=ee2ca7a4-4168-4c5b-b755-1c3da3ee7df6");
                break;
            case "Open the Knowledge Center":
                openNewTab("https://support.voicify.com");
                break;
            case "Voicify Support Assistant":
                setShowChat(true);
                break;
            case "Contact Support":
                setShowChat(false);
                break;
        }
    };
    const helpDropdownOptions = [
        {
            label: "Getting Started Tutorials"
        },
        {
            label: "Open the Knowledge Center"
        },
        {
            label: "Voicify Support Assistant"
        },
        {
            label: "Contact Support"
        }
    ];
    const filteredOrganizations = organizationContainer.state.organizations.filter((org)=>{
        if (!searchFieldValue) return true;
        const name = org.name || "";
        return name.toLowerCase().includes(searchFieldValue.toLowerCase());
    });
    return (0, _react.jsx)("div", {
        className: `${accountPanelStyle}`
    }, (0, _react.jsx)("div", {
        className: headerStyle
    }, (0, _react.jsx)("div", {
        className: "title"
    }, " Your Account"), (0, _react.jsx)("span", null), (0, _react.jsx)((0, _verticalSeparatorDefault.default), {
        className: verticalSeparator
    }), (0, _react.jsx)("button", {
        className: "close-button",
        type: "button",
        onClick: ()=>onClose()
    }, (0, _react.jsx)("img", {
        src: closeIcon
    }))), (0, _react.jsx)("div", {
        className: signOutStyle
    }, (0, _react.jsx)((0, _verticalSeparatorDefault.default), {
        className: `${verticalSeparator} ${signOutVerticalSeparator}`
    }), (0, _react.jsx)((0, _reactRouterDom.Link), {
        to: "/v/logout"
    }, (0, _react.jsx)((0, _buttonDefault.default), {
        themes: [
            "secondary-small"
        ],
        text: "Sign Out",
        type: "button",
        rightIcon: signoutIcon
    }))), (0, _react.jsx)((0, _tabContainerPanelDefault.default), {
        className: tabContainerPanelStyle,
        tabs: [
            {
                title: "Notifications",
                icon: hasUnreadNotifications ? notificationsAvailable : notifications,
                selectedIcon: hasUnreadNotifications ? notificationsAvailableSelected : notificationsSelected
            },
            {
                title: "Settings",
                icon: userSettings,
                selectedIcon: userSettingsSelected
            },
            {
                title: "Organization",
                icon: organization,
                selectedIcon: organizationSelected
            },
            {
                title: "Help",
                icon: help,
                selectedIcon: helpSelected
            }
        ],
        onTabSelected: (newIndex)=>{
            setSelectedIndex(newIndex);
        },
        selectedIndex: selectedIndex
    }, (0, _react.jsx)((0, _reactTabs.TabPanel), null, (0, _react.jsx)((0, _scrollablePanelBodyDefault.default), {
        className: noPadding
    }, (0, _react.jsx)(TabTitleWrapper, {
        className: notificationsHeaderStyle
    }, (0, _react.jsx)(TabTitle, null, "Notifications"), (0, _react.jsx)("span", null), (0, _react.jsx)("div", {
        onClick: ()=>notificationsHook.markAllNotificationsAsRead(),
        className: "markAsSeen"
    }, "Mark all as seen"), (0, _react.jsx)("img", {
        className: markAsSeenIconStyle,
        onClick: ()=>notificationsHook.markAllNotificationsAsRead(),
        src: markAsSeenIcon
    })), (0, _react.jsx)((0, _notificationsListDefault.default), null))), (0, _react.jsx)((0, _reactTabs.TabPanel), null, (0, _react.jsx)((0, _scrollablePanelBodyDefault.default), {
        className: noPadding
    }, (0, _react.jsx)((0, _userSettingsDefault.default), {
        userContainer: userContainer,
        authContainer: authContainer
    }))), (0, _react.jsx)((0, _reactTabs.TabPanel), {
        className: orgContainerStyle
    }, (0, _react.jsx)((0, _scrollablePanelBodyDefault.default), {
        className: noPadding
    }, (0, _react.jsx)(PanelTitleWrapper, null, (0, _react.jsx)(TabTitleWrapper, null, (0, _react.jsx)(TabTitle, null, "Organization"), (0, _react.jsx)(OrganizationSearchBar, {
        placeholder: "Search organizations",
        value: searchFieldValue,
        onChange: (e)=>setSearchFieldValue(e.target.value),
        boxType: "square"
    }))), filteredOrganizations.length === 0 ? (0, _react.jsx)(NoOrganizationsMessage, null, "You aren't a member of any organizations that match that search.") : (0, _react.jsx)((0, _organizationsMenuItemDefault.default), {
        organizationContainer: organizationContainer,
        userContainer: userContainer,
        onOrganizationSelected: handleOrganizationSelected,
        organizations: filteredOrganizations,
        currentOrganization: organizationContainer.state.currentOrganization
    }))), (0, _react.jsx)((0, _reactTabs.TabPanel), null, (0, _react.jsx)((0, _scrollablePanelBodyDefault.default), {
        className: `${noPadding} ${darkBackgroundStyle}`
    }, (0, _react.jsx)(TabTitleWrapper, null, (0, _react.jsx)(TabTitle, null, "Help & Support"), (0, _react.jsx)(MenuLinkWrapper, {
        onClick: ()=>setShowMenu(!showMenu)
    }, (0, _react.jsx)(MenuLink, null, "Menu"), showMenu ? (0, _react.jsx)(ArrowWrapper, null, (0, _react.jsx)(Arrow, {
        direction: "up"
    })) : (0, _react.jsx)(ArrowWrapper, null, (0, _react.jsx)(Arrow, {
        direction: "down"
    }))), showMenu && (0, _react.jsx)(AccountOverflowMenu, {
        options: helpDropdownOptions,
        onClose: ()=>setShowMenu(false),
        onOptionSelected: handleMenuOptionSelected,
        optionClassName: overflowOptionStyle
    })), showChat ? (0, _react.jsx)((0, _supportAssistantDefault.default), {
        userContainer: userContainer
    }) : (0, _react.jsx)((0, _platformHelpMenuDefault.default), null)))), (0, _react.jsx)((0, _pageErrorDefault.default), {
        onClear: ()=>clearErrors(),
        errors: errors
    }));
};
const NoOrganizationsMessage = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1swsjzf9"
})("padding:24px;text-align:center;color:", (0, _colors.color_shades_darker), ";font-size:16px;");
const OrganizationSearchBar = /*#__PURE__*/ (0, _baseDefault.default)((0, _searchFieldDefault.default), {
    target: "e1swsjzf8"
})({
    name: "r28jha",
    styles: "flex-grow:1;margin:16px 32px 16px 16px;div>.field-container{height:32px;box-shadow:none;border-radius:8px;margin:0;padding:0;}input::placeholder{font-size:0.75rem;}"
});
const PanelTitleWrapper = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1swsjzf7"
})({
    name: "bcffy2",
    styles: "display:flex;align-items:center;justify-content:space-between"
});
const tabContainerPanelStyle = /*#__PURE__*/ (0, _css.css)({
    name: "v7xhlk",
    styles: ".panel-tab-list{margin-left:12px;}"
});
const markAsSeenIconStyle = /*#__PURE__*/ (0, _css.css)({
    name: "1itlbq1",
    styles: "width:24px;height:24px;margin-top:16px"
});
const TabTitle = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1swsjzf6"
})({
    name: "hhyoc3",
    styles: "margin-left:32px"
});
const overflowOptionStyle = /*#__PURE__*/ (0, _css.css)({
    name: "10wdqcd",
    styles: "height:48px;p{font-size:14px;font-weight:400;padding:14px;:first-child{:hover{border-top-right-radius:12px;border-top-left-radius:12px;}}:last-child{:hover{border-bottom-right-radius:12px;border-bottom-left-radius:12px;}}}"
});
const MenuLinkWrapper = /*#__PURE__*/ (0, _baseDefault.default)("button", {
    target: "e1swsjzf5"
})({
    name: "5pfa6d",
    styles: "display:flex;align-items:center;border:none;background-color:transparent;outline:none;margin-right:32px"
});
const MenuLink = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1swsjzf4"
})("cursor:pointer;font-size:16px;font-family:Muli;color:", (0, _colors.color_shades_darkest), ";");
const ArrowWrapper = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1swsjzf3"
})({
    name: "2cp9od",
    styles: "margin:8px"
});
const Arrow = /*#__PURE__*/ (0, _baseDefault.default)((0, _toggleIndicatorDefault.default), {
    target: "e1swsjzf2"
})({
    name: "11f9gim",
    styles: "height:8px;width:8px"
});
const AccountOverflowMenu = /*#__PURE__*/ (0, _baseDefault.default)((0, _overflowMenuDefault.default), {
    target: "e1swsjzf1"
})("margin-top:272px;margin-left:228px;", (0, _breakpoints.breakpoint_small), "{margin-left:24px;}");
const darkBackgroundStyle = /*#__PURE__*/ (0, _css.css)("background:", (0, _colors.color_shades_lighter), ";height:100%;", "");
const TabTitleWrapper = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1swsjzf0"
})("display:flex;align-items:center;justify-content:space-between;height:56px;border-bottom:", (0, _stylesValues.style_border_default), ";font-size:18px;line-height:24px;background:white;flex:1;");
const orgContainerStyle = /*#__PURE__*/ (0, _css.css)("background:", (0, _colors.color_shades_lighter), ";", "");
const notificationsHeaderStyle = /*#__PURE__*/ (0, _css.css)("display:flex;flex-direction:row;padding-right:32px;.markAsSeen{font-size:14px;cursor:pointer;margin-right:8px;line-height:20px;color:", (0, _colors.color_colors_ocean), ";}img{cursor:pointer;width:24px;}span{flex-grow:1;}", "");
const signOutStyle = /*#__PURE__*/ (0, _css.css)("display:flex;flex-direction:row;z-index:3;height:32px;top:75px;right:10;position:absolute;", (0, _breakpoints.breakpoint_small), "{top:32px;right:200px;}", "");
const headerStyle = /*#__PURE__*/ (0, _css.css)("padding-left:32px;padding-top:16px;padding-bottom:16px;display:flex;flex-direction:row;height:79px;align-items:center;border-bottom:", (0, _stylesValues.style_border_default), ";span{flex-grow:1;}.title{font-size:24px;padding-bottom:8px;line-height:32px;height:32px;}.close-button{margin-left:32px;margin-right:36px;cursor:pointer;background:none;border:none;height:32px;width:32px;img{height:32px;width:32px;}}", (0, _breakpoints.breakpoint_small), "{padding:32px 0 64px 32px;}", "");
const verticalSeparator = /*#__PURE__*/ (0, _css.css)("background:", (0, _colors.color_shades_dark), ";height:32px;", (0, _breakpoints.breakpoint_small), "{display:none;}", "");
const signOutVerticalSeparator = /*#__PURE__*/ (0, _css.css)({
    name: "s9veqp",
    styles: "top:14px;position:relative"
});
const accountPanelStyle = /*#__PURE__*/ (0, _css.css)("height:100vh;width:576px;z-index:2;position:absolute;top:0px;right:0px;border:", (0, _stylesValues.style_border_default), ";box-shadow:0px 4px 20px ", (0, _colors.color_variants_shadow_10), ";font-family:Muli;font-style:normal;font-weight:normal;background-color:white;color:", (0, _colors.color_shades_darkest), ";", (0, _breakpoints.breakpoint_small), "{width:100%;display:flex;flex-direction:column;}", "");
const noPadding = /*#__PURE__*/ (0, _css.css)({
    name: "52b1oc",
    styles: "padding:0px"
});
exports.default = AccountPanel;

},{"@emotion/styled/base":"lSuFu","@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","../../../constants/colors":"1p3OR","../../../components/structure/VerticalSeparator":"aNNRC","react-tabs":"92Sgf","../../../components/structure/Panels/TabContainerPanel":"iDHIJ","../../../components/general/Button":"6ymxN","../../platformHelpMenu":"vLYfb","./OrganizationsMenuItem":"lAlwS","./NotificationsList":"8eN20","react-router-dom":"5fzqq","./UserSettings":"677X0","../../../components/general/PageError":"ezFTm","../../../components/structure/ScrollablePanelBody":"6LRg3","../../../constants/stylesValues":"dHVVv","../../platformHelpMenu/SupportAssistant":"kp24t","../../../components/general/overflowMenu/OverflowMenu":"2V2SB","../../../components/general/ToggleIndicator":"4eej1","../../../hooks/NotificationsContainer":"hNroK","../../../constants/breakpoints":"2F01A","../../../components/forms/SearchField":"aU10T","67b91bf6510c7c4b":"93VwA","32969f8faafb7d30":"7jLfW","e951262b69b30c0e":"dFyoP","239195b7627d6651":"bPg4S","cb6c3cc486600f44":"bw4xY","43b478af529fb49f":"10RQZ","8fd24febe8ccd2e3":"c1BYu","ee95c733b07ff908":"cknkQ","917b60a71c816d10":"gkLOu","aefacfc25db2add0":"cBwYr","95042c6e3abb8677":"fo2p6","dd3d51583d3d3570":"iiBgF","770c45d11349071f":"jze6E","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"vLYfb":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _reactHubspotForm = require("react-hubspot-form");
var _reactHubspotFormDefault = parcelHelpers.interopDefault(_reactHubspotForm);
var _css = require("@emotion/css");
var _loader = require("../../components/general/Loader");
var _loaderDefault = parcelHelpers.interopDefault(_loader);
var _colors = require("../../constants/colors");
const PlatformHelpMenu = ()=>(0, _react.jsx)("div", {
        className: formContainer
    }, (0, _react.jsx)("div", {
        className: "form"
    }, (0, _react.jsx)("h4", null, "Contact Us"), (0, _react.jsx)((0, _reactHubspotFormDefault.default), {
        portalId: "4829283",
        formId: "396bff7c-4366-48d4-9e3e-f981364f07e4",
        loading: (0, _react.jsx)((0, _loaderDefault.default), null)
    })));
const formContainer = /*#__PURE__*/ (0, _css.css)("width:100%;position:relative;padding-top:32px;padding-bottom:128px;.form{margin:32px;margin-top:0px;padding:32px;background:white;border-radius:8px;position:relative;background:white;border:1px solid ", (0, _colors.color_shades_dark), ";h4{color:", (0, _colors.color_text_default), ";margin-bottom:24px;font-style:normal;font-weight:normal;font-size:18px;line-height:24px;}}", "");
exports.default = PlatformHelpMenu;

},{"@emotion/react":"djZKr","react":"6uln9","react-hubspot-form":"9Jr87","@emotion/css":"awUBr","../../components/general/Loader":"bnV5T","../../constants/colors":"1p3OR","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9Jr87":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var _createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
var _react = require("708b3ee0f5fd3ff3");
var _react2 = _interopRequireDefault(_react);
var _reactDom = require("dda9805b5e645ed7");
var _reactDom2 = _interopRequireDefault(_reactDom);
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var globalId = 0;
var HubspotForm = function(_React$Component) {
    _inherits(HubspotForm, _React$Component);
    function HubspotForm(props) {
        _classCallCheck(this, HubspotForm);
        var _this = _possibleConstructorReturn(this, (HubspotForm.__proto__ || Object.getPrototypeOf(HubspotForm)).call(this, props));
        _this.state = {
            loaded: false
        };
        _this.id = globalId++;
        _this.createForm = _this.createForm.bind(_this);
        _this.findFormElement = _this.findFormElement.bind(_this);
        return _this;
    }
    _createClass(HubspotForm, [
        {
            key: "createForm",
            value: function createForm() {
                var _this2 = this;
                if (window.hbspt) {
                    // protect against component unmounting before window.hbspt is available
                    if (this.el === null) return;
                    var props = _extends({}, this.props);
                    delete props.loading;
                    delete props.onSubmit;
                    delete props.onReady;
                    var options = _extends({}, props, {
                        target: "#" + this.el.getAttribute("id"),
                        onFormSubmit: function onFormSubmit($form) {
                            // ref: https://developers.hubspot.com/docs/methods/forms/advanced_form_options
                            var formData = $form.serializeArray();
                            _this2.props.onSubmit(formData);
                        }
                    });
                    window.hbspt.forms.create(options);
                    return true;
                } else setTimeout(this.createForm, 1);
            }
        },
        {
            key: "loadScript",
            value: function loadScript() {
                var _this3 = this;
                var script = document.createElement("script");
                script.defer = true;
                script.onload = function() {
                    _this3.createForm();
                    _this3.findFormElement();
                };
                script.src = "//js.hsforms.net/forms/v2.js";
                document.head.appendChild(script);
            }
        },
        {
            key: "findFormElement",
            value: function findFormElement() {
                // protect against component unmounting before form is added
                if (this.el === null) return;
                var form = this.el.querySelector("iframe");
                if (form) {
                    this.setState({
                        loaded: true
                    });
                    if (this.props.onReady) this.props.onReady(form);
                } else setTimeout(this.findFormElement, 1);
            }
        },
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                if (!window.hbspt && !this.props.noScript) this.loadScript();
                else {
                    this.createForm();
                    this.findFormElement();
                }
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {}
        },
        {
            key: "render",
            value: function render() {
                var _this4 = this;
                return _react2.default.createElement("div", null, _react2.default.createElement("div", {
                    ref: function ref(el) {
                        return _this4.el = el;
                    },
                    id: "reactHubspotForm" + this.id,
                    style: {
                        display: this.state.loaded ? "block" : "none"
                    }
                }), !this.state.loaded && this.props.loading);
            }
        }
    ]);
    return HubspotForm;
}(_react2.default.Component);
exports.default = HubspotForm;
module.exports = exports["default"];

},{"708b3ee0f5fd3ff3":"6uln9","dda9805b5e645ed7":"b8T3j"}],"lAlwS":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _base = require("@emotion/styled/base");
var _baseDefault = parcelHelpers.interopDefault(_base);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _colors = require("../../../constants/colors");
var _reactRouterDom = require("react-router-dom");
var _horizontalSeparator = require("../../../components/structure/HorizontalSeparator");
var _horizontalSeparatorDefault = parcelHelpers.interopDefault(_horizontalSeparator);
var _featureFlagIds = require("../../../constants/featureFlagIds");
var _orgSetupContainer = require("../../../hooks/OrgSetupContainer");
var _orgSetupContainerDefault = parcelHelpers.interopDefault(_orgSetupContainer);
var _button = require("../../../components/general/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _sparkContainer = require("../../../hooks/SparkContainer");
var _sparkContainerDefault = parcelHelpers.interopDefault(_sparkContainer);
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const addOrgIcon = require("fe3d73ceb4ce75d5");
const organizationIcon = require("7337e3213e916259");
const OrganizationsMenuItem = (props)=>{
    const [addingAnOrganization, setAddingAnOrganization] = (0, _react1.useState)(false);
    const orgSetupContainer = (0, _orgSetupContainerDefault.default).useContainer();
    const sparkContainer = (0, _sparkContainerDefault.default).useContainer();
    const newOrgListItem = (0, _react1.useRef)(null);
    const orgNameTextInput = (0, _react1.useRef)(null);
    (0, _react1.useEffect)(()=>{
        orgNameTextInput.current?.focus();
    }, [
        addingAnOrganization
    ]);
    (0, _react1.useEffect)(()=>{
        const handleClickOutside = (event)=>{
            if (newOrgListItem.current && !newOrgListItem.current.contains(event.target)) setAddingAnOrganization(false);
        };
        document.body.addEventListener("click", handleClickOutside);
        return ()=>{
            document.body.removeEventListener("click", handleClickOutside);
        };
    }, [
        newOrgListItem
    ]);
    const handleOrgNameSubmitNameKeyUp = (e)=>{
        e.stopPropagation();
        if (e.key === "Enter") handleOrgNameSubmit(e);
        else if (e.key === "Escape") setAddingAnOrganization(false);
    };
    const handleOrgNameSubmit = async (e)=>{
        e.stopPropagation();
        const orgName = orgNameTextInput.current?.value;
        if (orgName) {
            let newOrganizationRequest;
            if (sparkContainer.inSpark) newOrganizationRequest = {
                organizationName: orgName,
                featureFlagId: (0, _featureFlagIds.AIAnsweringFeatureFlagId)
            };
            else newOrganizationRequest = {
                organizationName: orgName,
                featureFlagId: (0, _featureFlagIds.FoodOrderingFeatureFlagId)
            };
            const setupOrgResponse = await orgSetupContainer.setupOrg(newOrganizationRequest);
            if (setupOrgResponse.resultType === "Ok") {
                const newOrg = {
                    id: setupOrgResponse.data.id,
                    secret: setupOrgResponse.data.secret,
                    name: setupOrgResponse.data.name,
                    description: setupOrgResponse.data.description,
                    instructionsMarkdown: setupOrgResponse.data.instructionsMarkdown ?? ""
                };
                props.onOrganizationSelected(newOrg);
            }
            setAddingAnOrganization(false);
        }
    };
    const renderHorizontalSeparator = (index)=>{
        if (index !== props.organizations.length - 1) return (0, _react.jsx)((0, _horizontalSeparatorDefault.default), null);
        else {
            if (props.userContainer.state.currentUser.canCreateOrganizations) return (0, _react.jsx)((0, _horizontalSeparatorDefault.default), null);
        }
    };
    const handleNewOrgSetupClick = (e)=>{
        e.preventDefault();
        e.stopPropagation();
        setAddingAnOrganization(true);
    };
    return (0, _react.jsx)("div", {
        className: containerStyle
    }, (0, _react.jsx)("div", {
        className: listContainerStyle
    }, (0, _react.jsx)("div", {
        className: listInnerContainerStyle
    }, props.organizations.length > 0 ? props.organizations.map((org, index)=>(0, _react.jsx)("div", {
            key: org.id
        }, (0, _react.jsx)((0, _reactRouterDom.Link), {
            to: "/v",
            className: `${listItemStyle} ${org.id == props.currentOrganization.id ? currentOrgStyle : ""}`,
            onClick: ()=>props.onOrganizationSelected(org)
        }, (0, _react.jsx)("p", null, org.name)), renderHorizontalSeparator(index))) : (0, _react.jsx)("p", {
        className: emptyLabelStyle
    }, "This is where you'll see other organizations you're a member of."), props.userContainer.state.currentUser.canCreateOrganizations ? addingAnOrganization ? (0, _react.jsx)("div", {
        className: listItemStyle,
        ref: newOrgListItem
    }, (0, _react.jsx)(NameInput, {
        type: "text",
        placeholder: "Enter the new organization's name here",
        ref: orgNameTextInput,
        onClick: (e)=>e.stopPropagation(),
        onKeyUp: (e)=>handleOrgNameSubmitNameKeyUp(e)
    }), (0, _react.jsx)(StyledButton, {
        disabled: orgNameTextInput.current?.value === "" || orgSetupContainer.isLoading,
        loading: orgSetupContainer.isLoading,
        themes: [
            "primary-small"
        ],
        text: "Create",
        type: "button",
        onClick: (e)=>handleOrgNameSubmit(e)
    })) : (0, _react.jsx)((0, _reactRouterDom.Link), {
        to: "/v",
        className: addOrgListItemStyle,
        onClick: (e)=>handleNewOrgSetupClick(e)
    }, (0, _react.jsx)("p", null, "Create a New Organization"), (0, _react.jsx)(AddOrgIcon, {
        src: addOrgIcon,
        alt: "Add Organization"
    }), (0, _react.jsx)(OrgIcon, {
        src: organizationIcon,
        alt: "Organization"
    })) : null)));
};
const StyledButton = /*#__PURE__*/ (0, _baseDefault.default)((0, _buttonDefault.default), {
    target: "e1wblz5w3"
})({
    name: "14iqihm",
    styles: "height:28px;width:28px;border-radius:18px;font-size:10px"
});
const AddOrgIcon = /*#__PURE__*/ (0, _baseDefault.default)("img", {
    target: "e1wblz5w2"
})({
    name: "1oaeivz",
    styles: "margin-right:8px"
});
const OrgIcon = /*#__PURE__*/ (0, _baseDefault.default)("img", {
    target: "e1wblz5w1"
})({
    name: "82c8w5",
    styles: "margin-right:22px"
});
const NameInput = /*#__PURE__*/ (0, _baseDefault.default)("input", {
    target: "e1wblz5w0"
})("border:none;height:36px;font-family:Muli;font-size:14px;font-weight:600;font-style:normal;font-stretch:normal;line-height:normal;letter-spacing:normal;text-align:right;color:", (0, _colors.dark_grey_blue), ";flex:1;margin-right:0px;");
const listContainerStyle = /*#__PURE__*/ (0, _css.css)("padding:32px;background:", (0, _colors.color_shades_lighter), ";", "");
const listInnerContainerStyle = /*#__PURE__*/ (0, _css.css)({
    name: "d4n4sj",
    styles: "border-radius:8px;background-color:white;border:solid 1px #cccccc"
});
const addOrgListItemStyle = /*#__PURE__*/ (0, _css.css)("height:48px;font-family:Muli;font-size:14px;font-weight:600;font-style:normal;font-stretch:normal;line-height:normal;letter-spacing:normal;text-align:right;color:", (0, _colors.dark_grey_blue), ";display:flex;align-items:center;p{margin-right:8px;margin-left:auto;}&:hover{color:", (0, _colors.ocean_blue), ";}", "");
const listItemStyle = /*#__PURE__*/ (0, _css.css)("height:48px;font-family:Muli;font-size:14px;font-weight:600;font-style:normal;font-stretch:normal;line-height:normal;letter-spacing:normal;text-align:right;color:", (0, _colors.dark_grey_blue), ";display:flex;align-items:center;p{margin-right:22px;margin-left:auto;}p:hover{color:", (0, _colors.ocean_blue), ";}", "");
const emptyLabelStyle = /*#__PURE__*/ (0, _css.css)("height:48px;font-family:Muli;font-size:14px;font-weight:600;font-style:normal;font-stretch:normal;line-height:normal;letter-spacing:normal;text-align:center;color:", (0, _colors.dark_grey_blue), ";display:flex;align-items:center;padding:8px;", "");
const currentOrgStyle = /*#__PURE__*/ (0, _css.css)("color:", (0, _colors.ocean_blue), ";", "");
const containerStyle = /*#__PURE__*/ (0, _css.css)({
    name: "1j6uqpk",
    styles: "overflow:hidden;border-radius:0 0 20px 20px;margin-bottom:124px"
});
exports.default = OrganizationsMenuItem;

},{"@emotion/styled/base":"lSuFu","@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","../../../constants/colors":"1p3OR","react-router-dom":"5fzqq","../../../components/structure/HorizontalSeparator":"Pw3HQ","../../../constants/featureFlagIds":"33vuW","../../../hooks/OrgSetupContainer":"bXGCB","../../../components/general/Button":"6ymxN","../../../hooks/SparkContainer":"jzXzx","fe3d73ceb4ce75d5":"iho9h","7337e3213e916259":"cknkQ","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"bXGCB":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _unstatedNext = require("unstated-next");
var _api = require("../api");
function useOrgSetupContainer() {
    const [errors, setErrors] = (0, _react.useState)([]);
    const [isLoading, setIsLoading] = (0, _react.useState)(false);
    const [orgSetup, setOrgSetup] = (0, _react.useState)(null);
    const setupOrg = async (orgSetupRequest)=>{
        try {
            setIsLoading(true);
            const result = await _api.setupOrgForFeature(orgSetupRequest);
            if (result.resultType == "Ok") setOrgSetup(result.data);
            else if (result.errors != null && result.errors.length > 0) setErrors([
                ...result.errors
            ]);
            setIsLoading(false);
            return result;
        } catch (error) {
            setErrors([
                error
            ]);
            setIsLoading(false);
        }
    };
    return {
        errors,
        isLoading,
        setupOrg,
        orgSetup
    };
}
const OrgSetupContainer = (0, _unstatedNext.createContainer)(useOrgSetupContainer);
exports.default = OrgSetupContainer;

},{"react":"6uln9","unstated-next":"61zE5","../api":"loxM6","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"iho9h":[function(require,module,exports) {
module.exports = require("de4134846fee87e6").getBundleURL("kVLro") + require("fd965212a12527f2").resolve("krIsa");

},{"de4134846fee87e6":"c7Tr5","fd965212a12527f2":"fyJL2"}],"cknkQ":[function(require,module,exports) {
module.exports = require("40d57e2cd1ce1a26").getBundleURL("kVLro") + require("9091eb562880a856").resolve("7EcFB");

},{"40d57e2cd1ce1a26":"c7Tr5","9091eb562880a856":"fyJL2"}],"8eN20":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _css = require("@emotion/css");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _colors = require("../../../constants/colors");
var _notificationsContainer = require("../../../hooks/NotificationsContainer");
var _notificationsContainerDefault = parcelHelpers.interopDefault(_notificationsContainer);
var _notificationListItem = require("./NotificationListItem");
var _notificationListItemDefault = parcelHelpers.interopDefault(_notificationListItem);
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const notificationsNone = require("9ea105c97556c22e");
const NotificationsList = ()=>{
    const notificationsHook = (0, _notificationsContainerDefault.default).useContainer();
    const markNotificationAsRead = (idx)=>{
        var notification = notificationsHook.notifications[idx];
        if (!notification.isRead) notificationsHook.markNotificationAsRead(notification.id);
    };
    const notifications = notificationsHook.notifications;
    return (0, _react.jsx)("div", {
        className: containerStyle
    }, notifications.length > 0 ? notifications.map((n, idx)=>(0, _react.jsx)("div", {
            key: idx + "div"
        }, (0, _react.jsx)((0, _notificationListItemDefault.default), {
            notification: n,
            key: idx,
            onTouch: ()=>markNotificationAsRead(idx)
        }))) : (0, _react.jsx)("div", {
        className: noNotifications
    }, (0, _react.jsx)("img", {
        src: notificationsNone
    }), (0, _react.jsx)("div", null, "No Notifications Yet...")));
};
const containerStyle = /*#__PURE__*/ (0, _css.css)({
    name: "fz9j9u",
    styles: "overflow:hidden;margin-bottom:136px"
});
const noNotifications = /*#__PURE__*/ (0, _css.css)("font-style:italic;font-size:16px;line-height:24px;padding-top:64px;text-align:center;color:", (0, _colors.color_shades_darker), ";img{height:72px;width:72px;margin-bottom:24px;}", "");
exports.default = NotificationsList;

},{"@emotion/react":"djZKr","@emotion/css":"awUBr","react":"6uln9","../../../constants/colors":"1p3OR","../../../hooks/NotificationsContainer":"hNroK","./NotificationListItem":"4p82u","9ea105c97556c22e":"jJvIY","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4p82u":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _colors = require("../../../constants/colors");
var _reactMarkdown = require("react-markdown");
var _reactMarkdownDefault = parcelHelpers.interopDefault(_reactMarkdown);
var _moment = require("moment");
var _momentDefault = parcelHelpers.interopDefault(_moment);
var _toggleIndicator = require("../../../components/general/ToggleIndicator");
var _toggleIndicatorDefault = parcelHelpers.interopDefault(_toggleIndicator);
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const productUpdateIcon = require("4da6380818eb765");
const alertIcon = require("dbf0523953e812d0");
const infoIcon = require("4898c2df1c59b8c1");
class NotificationsListItem extends (0, _reactDefault.default).Component {
    componentWillMount() {
        this.setState({
            isExpanded: false
        });
    }
    getNotificationTypeImage(type) {
        switch(type){
            case "ProductUpdate":
                return productUpdateIcon;
            case "Issue":
                return alertIcon;
            case "Information":
            default:
                return infoIcon;
        }
    }
    getNotificationTypeText(type) {
        switch(type){
            case "ProductUpdate":
                return "PRODUCT UPDATE";
            case "Issue":
                return "ISSUE";
            case "Information":
            default:
                return "INFORMATION";
        }
    }
    renderStartDate(startDate) {
        const date = new Date(startDate);
        const today = new Date();
        if (date.toDateString() == today.toDateString()) return `Today, ${(0, _momentDefault.default)(date).format("h:mm A")}`;
        return `${(0, _momentDefault.default)(date).format("MMM Do, YYYY h:mm A")}`;
    }
    toggleExpand() {
        this.setState({
            ...this.state,
            isExpanded: !this.state.isExpanded
        });
    }
    render() {
        return (0, _react.jsx)("div", {
            onClick: ()=>this.props.onTouch(),
            className: `${containerStyle} ${this.props.notification.isRead ? `read` : `unread`}`
        }, (0, _react.jsx)((0, _toggleIndicatorDefault.default), {
            onClick: ()=>this.toggleExpand(),
            direction: this.state.isExpanded ? "down" : "right",
            className: expandStyle,
            type: "triangle"
        }), (0, _react.jsx)("div", {
            onClick: ()=>this.toggleExpand(),
            className: typeIconStyle
        }, (0, _react.jsx)("img", {
            src: this.getNotificationTypeImage(this.props.notification.notificationType)
        })), (0, _react.jsx)("div", null, (0, _react.jsx)("div", {
            className: "notificationType"
        }, `${this.getNotificationTypeText(this.props.notification.notificationType)} - ${this.renderStartDate(this.props.notification.startDate)}`), (0, _react.jsx)("div", {
            className: "title"
        }, this.props.notification.title), (0, _react.jsx)("div", {
            className: `${markdown}${this.state.isExpanded ? "" : " collapsed"}`
        }, (0, _react.jsx)((0, _reactMarkdownDefault.default), {
            source: this.props.notification.markdown,
            renderers: {
                link: (props)=>{
                    return (0, _react.jsx)("a", {
                        href: props.href,
                        target: "_blank"
                    }, props.children);
                }
            }
        })), !this.state.isExpanded && (0, _react.jsx)("div", {
            className: `${fadeOutStyle} ${this.props.notification.isRead ? "read" : "unread"}`
        }), (0, _react.jsx)("div", {
            onClick: ()=>this.toggleExpand(),
            className: "readMore"
        }, (0, _react.jsx)((0, _toggleIndicatorDefault.default), {
            className: chevronStyle,
            direction: this.state.isExpanded ? "up" : "down"
        }), this.state.isExpanded ? "Collapse" : "Read More")));
    }
}
const containerStyle = /*#__PURE__*/ (0, _css.css)("border-bottom:1px solid ", (0, _colors.color_shades_dark), ";padding:24px 32px;padding-bottom:16px;position:relative;padding-left:18px;display:flex;flex-direction:row;&.read{background-color:white;}&.unread{background-color:", (0, _colors.color_variants_ocean_light_opaque), ";}.title{font-size:16px;line-height:24px;z-index:4;margin-bottom:8px;}.subtitle{z-index:4;font-size:14px;line-height:20px;margin-bottom:8px;}.notificationType{font-size:12px;line-height:16px;color:", (0, _colors.color_shades_darker), ";margin-bottom:8px;}.readMore{font-size:14px;line-height:20px;cursor:pointer;margin-top:8px;margin-bottom:8px;display:flex;flex-direction:row;color:", (0, _colors.color_colors_ocean), ";}", "");
const chevronStyle = /*#__PURE__*/ (0, _css.css)("border-left:solid 1px ", (0, _colors.color_colors_ocean), ";border-top:solid 1px ", (0, _colors.color_colors_ocean), ";margin-top:6px;margin-right:6px;", "");
const fadeOutStyle = /*#__PURE__*/ (0, _css.css)({
    name: "yeqp1l",
    styles: "height:24px;left:-68px;right:-32px;bottom:50px;position:absolute;&.read{background:linear-gradient(0deg, #FFFFFF 33.33%, rgba(255, 255, 255, 0) 100%);}&.unread{background:linear-gradient(0deg, #EDF5FA 33.33%, rgba(237, 245, 250, 0.992188) 33.34%, rgba(237, 245, 250, 0) 100%);}"
});
const typeIconStyle = /*#__PURE__*/ (0, _css.css)({
    name: "17f92o",
    styles: "margin-right:12px;cursor:pointer"
});
const expandStyle = /*#__PURE__*/ (0, _css.css)({
    name: "fskriu",
    styles: "margin-top:9px;margin-right:10px;cursor:pointer"
});
const markdown = /*#__PURE__*/ (0, _css.css)("z-index:3;font-family:Muli;font-style:normal;font-stretch:normal;font-size:14px;width:476px;line-height:20px;word-wrap:break-word;min-height:90px;&.collapsed{height:60px;min-height:60px;overflow:hidden;text-overflow:ellipsis;}p{font-size:14px;line-height:20px;margin:8px 0;}ul,ol{padding-left:24px;margin:12px 0;li{margin:4px;}}h1{margin-bottom:16px;margin-top:16px;font-size:24px;font-weight:bold;}h2{margin-bottom:16px;margin-top:16px;font-size:20px;font-weight:bold;}h3{margin-bottom:16px;margin-top:16px;font-size:18px;font-weight:bold;}h4{margin-bottom:16px;margin-top:16px;font-size:16px;font-weight:bold;}h5{margin-bottom:16px;margin-top:16px;font-size:14px;font-weight:bold italic;}h6{margin-bottom:16px;margin-top:16px;font-size:14px;font-weight:bold;}img{max-width:calc(100% - 32px);margin:0 16px;}a{color:", (0, _colors.color_text_link), ";}", "");
exports.default = NotificationsListItem;

},{"@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","../../../constants/colors":"1p3OR","react-markdown":"6G7AH","moment":"2meyw","../../../components/general/ToggleIndicator":"4eej1","4da6380818eb765":"iQ5pr","dbf0523953e812d0":"amBHO","4898c2df1c59b8c1":"3Pubw","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"iQ5pr":[function(require,module,exports) {
module.exports = require("62f1bdc3c31e66ca").getBundleURL("kVLro") + require("ff79cb74d0999cd").resolve("4jiQ3");

},{"62f1bdc3c31e66ca":"c7Tr5","ff79cb74d0999cd":"fyJL2"}],"amBHO":[function(require,module,exports) {
module.exports = require("149d2c8f7b89d816").getBundleURL("kVLro") + require("8c3102b1429a52a").resolve("fryQQ");

},{"149d2c8f7b89d816":"c7Tr5","8c3102b1429a52a":"fyJL2"}],"3Pubw":[function(require,module,exports) {
module.exports = require("ec4e3fd4cb5e967").getBundleURL("kVLro") + require("4657ed722a63b8aa").resolve("b3CnV");

},{"ec4e3fd4cb5e967":"c7Tr5","4657ed722a63b8aa":"fyJL2"}],"jJvIY":[function(require,module,exports) {
module.exports = require("a1bfa29cb089d2c0").getBundleURL("kVLro") + require("4225de84e778f252").resolve("5UKXw");

},{"a1bfa29cb089d2c0":"c7Tr5","4225de84e778f252":"fyJL2"}],"677X0":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _colors = require("../../../constants/colors");
var _personalInfoForm = require("./PersonalInfoForm");
var _personalInfoFormDefault = parcelHelpers.interopDefault(_personalInfoForm);
var _userAvatar = require("../../../components/general/UserAvatar");
var _userAvatarDefault = parcelHelpers.interopDefault(_userAvatar);
var _reactDropzone = require("react-dropzone");
var _reactDropzoneDefault = parcelHelpers.interopDefault(_reactDropzone);
var _changePasswordForm = require("./ChangePasswordForm");
var _changePasswordFormDefault = parcelHelpers.interopDefault(_changePasswordForm);
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const pencil = require("fd31b1b32d86b05c");
class UserSettings extends (0, _reactDefault.default).Component {
    componentWillMount() {
        this.setState({
            ...this.state,
            imageUrl: this.props.userContainer.state.currentUser.imageUrl
        });
    }
    handleFilePicked(files) {
        if (files.length > 0) {
            this.readDataUrl(files[0]);
            this.props.userContainer.updateUserImage(files[0]);
        } else this.setState({
            ...this.state,
            imageUrl: undefined
        });
    }
    readDataUrl(file) {
        const reader = new FileReader();
        reader.onloadend = (e)=>{
            this.setState({
                ...this.state,
                imageUrl: reader.result.toString()
            });
        };
        reader.readAsDataURL(file);
    }
    render() {
        const currentUser = this.props.userContainer.state.currentUser;
        return (0, _react.jsx)("div", {
            className: containerStyle
        }, (0, _react.jsx)("div", {
            className: tabTitleStyle
        }, (0, _react.jsx)("div", {
            className: "title"
        }, "Account Settings"), (0, _react.jsx)((0, _userAvatarDefault.default), {
            className: userImage,
            size: 80,
            firstName: currentUser.firstName,
            lastName: currentUser.lastName,
            src: currentUser.imageUrl ?? null
        }), (0, _react.jsx)((0, _reactDropzoneDefault.default), {
            ref: (node)=>{
                this.dropZone = node;
            },
            onDrop: this.handleFilePicked.bind(this),
            style: dropzoneStyle,
            accept: ".png,.jpg,.jpeg",
            multiple: false
        }, (0, _react.jsx)("div", {
            className: editImageStyle
        }, "Edit Image"), (0, _react.jsx)("img", {
            className: pencilStyle,
            src: pencil
        }))), (0, _react.jsx)("div", {
            className: formsContainer
        }, (0, _react.jsx)((0, _personalInfoFormDefault.default), {
            userContainer: this.props.userContainer
        }), (0, _react.jsx)((0, _changePasswordFormDefault.default), {
            userContainer: this.props.userContainer,
            authContainer: this.props.authContainer
        })));
    }
}
const pencilStyle = /*#__PURE__*/ (0, _css.css)({
    name: "1q4vxyr",
    styles: "margin-left:8px"
});
const editImageStyle = /*#__PURE__*/ (0, _css.css)({
    name: "1muarzf",
    styles: "font-size:16px;line-height:24px"
});
const tabTitleStyle = /*#__PURE__*/ (0, _css.css)("height:120px;border-bottom:1px solid ", (0, _colors.color_shades_dark), ";font-size:18px;position:relative;line-height:24px;.title{padding-left:32px;padding-top:16px;}", "");
const dropzoneStyle = {
    position: "absolute",
    top: 88,
    border: "none",
    display: "flex",
    flexDirection: "row",
    cursor: "pointer",
    color: (0, _colors.color_colors_ocean),
    right: 32
};
const userImage = /*#__PURE__*/ (0, _css.css)({
    name: "75owxo",
    styles: "position:absolute;z-index:4;top:64px;left:33px;margin:0px"
});
const formsContainer = /*#__PURE__*/ (0, _css.css)("background-color:", (0, _colors.color_shades_lighter), ";padding:40px 32px;", "");
const containerStyle = /*#__PURE__*/ (0, _css.css)({
    name: "pfyrfr",
    styles: "margin-bottom:80px;width:100%;overflow-x:hidden"
});
exports.default = UserSettings;

},{"@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","../../../constants/colors":"1p3OR","./PersonalInfoForm":"5Opvp","../../../components/general/UserAvatar":"avuDP","react-dropzone":"46RRi","./ChangePasswordForm":"3vQvz","fd31b1b32d86b05c":"4uAZr","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"5Opvp":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _formik = require("formik");
var _yup = require("yup");
var _formFieldsContainer = require("../../../components/structure/FormFieldsContainer");
var _formFieldsContainerDefault = parcelHelpers.interopDefault(_formFieldsContainer);
var _textField = require("../../../components/forms/TextField");
var _textFieldDefault = parcelHelpers.interopDefault(_textField);
var _button = require("../../../components/general/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _loader = require("../../../components/general/Loader");
var _loaderDefault = parcelHelpers.interopDefault(_loader);
var _css = require("@emotion/css");
var _colors = require("../../../constants/colors");
var _horizontalSeparator = require("../../../components/structure/HorizontalSeparator");
var _horizontalSeparatorDefault = parcelHelpers.interopDefault(_horizontalSeparator);
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
class InnerForm extends (0, _reactDefault.default).Component {
    componentWillMount() {
        if (this.props.userContainer.state.currentUser == null) this.props.userContainer.getUser().then((result)=>{
            this.setState({
                ...this.state,
                imageUrl: this.props.userContainer.state.currentUser.imageUrl
            });
        });
        else this.setState({
            ...this.state,
            imageUrl: this.props.userContainer.state.currentUser.imageUrl
        });
    }
    handleImageSelected(file) {
        this.readDataUrl(file);
        this.props.setFieldValue("imageFile", file);
    }
    readDataUrl(file) {
        const reader = new FileReader();
        reader.onloadend = (e)=>{
            this.setState({
                ...this.state,
                imageUrl: reader.result.toString()
            });
        };
        reader.readAsDataURL(file);
    }
    render() {
        const props = {
            ...this.props
        };
        const isLoading = props.userContainer.state.isLoading;
        return (0, _react.jsx)("div", {
            className: containerStyle
        }, props.userContainer.state.currentUser == null ? (0, _react.jsx)((0, _loaderDefault.default), null) : (0, _react.jsx)("form", {
            onSubmit: props.handleSubmit
        }, (0, _react.jsx)("div", {
            className: "title"
        }, "Personal Info"), (0, _react.jsx)((0, _horizontalSeparatorDefault.default), null), (0, _react.jsx)((0, _formFieldsContainerDefault.default), {
            className: fieldsContainerStyle
        }, (0, _react.jsx)((0, _textFieldDefault.default), {
            name: "firstName",
            required: true,
            value: props.values.firstName,
            label: "First Name",
            placeholder: "What name do you go by?",
            onChange: props.handleChange,
            onBlur: props.handleBlur,
            disabled: isLoading
        }), (0, _react.jsx)((0, _textFieldDefault.default), {
            name: "lastName",
            required: true,
            value: props.values.lastName,
            label: "Last Name",
            placeholder: "What's your family name?",
            onChange: props.handleChange,
            onBlur: props.handleBlur,
            disabled: isLoading
        })), (0, _react.jsx)((0, _horizontalSeparatorDefault.default), null), (0, _react.jsx)((0, _buttonDefault.default), {
            className: "submit-button",
            loading: isLoading,
            disabled: isLoading,
            themes: [
                "primary"
            ],
            text: "Update",
            type: "submit"
        })));
    }
}
const PersonalInfoForm = (0, _formik.withFormik)({
    mapPropsToValues: (props)=>({
            firstName: props.userContainer?.state?.currentUser?.firstName ?? "",
            lastName: props.userContainer?.state?.currentUser?.lastName ?? ""
        }),
    validationSchema: _yup.object().shape({
        firstName: _yup.string().required("You must enter your first name"),
        lastName: _yup.string().required("You must enter your last name")
    }),
    handleSubmit: (values, { props })=>{
        props.userContainer.updateUserDetails({
            firstName: values.firstName,
            lastName: values.lastName
        });
    }
})(InnerForm);
exports.default = PersonalInfoForm;
const fieldsContainerStyle = /*#__PURE__*/ (0, _css.css)({
    name: "1fb3wl7",
    styles: "margin-top:12px;margin-bottom:32px"
});
const containerStyle = /*#__PURE__*/ (0, _css.css)("border:1px solid ", (0, _colors.color_shades_dark), ";background:white;border-radius:8px;margin-bottom:32px;padding:24px 32px;padding-bottom:0px;.submit-button{margin-left:0px;}.title{font-size:16px;line-height:24px;padding-bottom:16px;}", "");

},{"@emotion/react":"djZKr","react":"6uln9","formik":"3YnOK","yup":"j2SJU","../../../components/structure/FormFieldsContainer":"h3hzh","../../../components/forms/TextField":"7a7bh","../../../components/general/Button":"6ymxN","../../../components/general/Loader":"bnV5T","@emotion/css":"awUBr","../../../constants/colors":"1p3OR","../../../components/structure/HorizontalSeparator":"Pw3HQ","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3vQvz":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _formik = require("formik");
var _yup = require("yup");
var _formFieldsContainer = require("../../../components/structure/FormFieldsContainer");
var _formFieldsContainerDefault = parcelHelpers.interopDefault(_formFieldsContainer);
var _textField = require("../../../components/forms/TextField");
var _textFieldDefault = parcelHelpers.interopDefault(_textField);
var _button = require("../../../components/general/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _loader = require("../../../components/general/Loader");
var _loaderDefault = parcelHelpers.interopDefault(_loader);
var _css = require("@emotion/css");
var _colors = require("../../../constants/colors");
var _horizontalSeparator = require("../../../components/structure/HorizontalSeparator");
var _horizontalSeparatorDefault = parcelHelpers.interopDefault(_horizontalSeparator);
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
class InnerForm extends (0, _reactDefault.default).Component {
    componentWillMount() {
        if (this.props.userContainer.state.currentUser == null) this.props.userContainer.getUser().then((result)=>{
            this.setState({
                ...this.state,
                imageUrl: this.props.userContainer.state.currentUser.imageUrl
            });
        });
        else this.setState({
            ...this.state,
            imageUrl: this.props.userContainer.state.currentUser.imageUrl
        });
    }
    handleImageSelected(file) {
        this.readDataUrl(file);
        this.props.setFieldValue("imageFile", file);
    }
    readDataUrl(file) {
        const reader = new FileReader();
        reader.onloadend = (e)=>{
            this.setState({
                ...this.state,
                imageUrl: reader.result.toString()
            });
        };
        reader.readAsDataURL(file);
    }
    render() {
        const props = {
            ...this.props
        };
        const isLoading = props.userContainer.state.isLoading;
        return (0, _react.jsx)("div", {
            className: containerStyle
        }, props.userContainer.state.currentUser == null ? (0, _react.jsx)((0, _loaderDefault.default), null) : (0, _react.jsx)("form", {
            onSubmit: props.handleSubmit
        }, (0, _react.jsx)("div", {
            className: "title"
        }, "Change Password"), (0, _react.jsx)((0, _horizontalSeparatorDefault.default), null), (0, _react.jsx)((0, _formFieldsContainerDefault.default), {
            className: fieldsContainerStyle
        }, (0, _react.jsx)((0, _textFieldDefault.default), {
            name: "oldPassword",
            type: "password",
            value: props.values.oldPassword,
            label: "Old Password",
            placeholder: "Enter your old password",
            onChange: props.handleChange,
            onBlur: props.handleBlur,
            disabled: isLoading
        }), (0, _react.jsx)((0, _textFieldDefault.default), {
            name: "changePassword",
            type: "password",
            value: props.values.changePassword,
            label: "Change Password",
            placeholder: "It's a secret to everybody",
            onChange: props.handleChange,
            onBlur: props.handleBlur,
            disabled: isLoading
        }), (0, _react.jsx)((0, _textFieldDefault.default), {
            name: "confirmPassword",
            type: "password",
            value: props.values.confirmPassword,
            label: "Confirm Password",
            placeholder: "One more time",
            onChange: props.handleChange,
            onBlur: props.handleBlur,
            disabled: isLoading
        })), (0, _react.jsx)((0, _horizontalSeparatorDefault.default), null), (0, _react.jsx)((0, _buttonDefault.default), {
            className: "submit-button",
            loading: isLoading,
            disabled: isLoading,
            themes: [
                "primary"
            ],
            text: "Update",
            type: "submit"
        })));
    }
}
const ChangePasswordForm = (0, _formik.withFormik)({
    mapPropsToValues: (props)=>({
            oldPassword: "",
            changePassword: "",
            confirmPassword: ""
        }),
    validationSchema: _yup.object().shape({
        oldPassword: _yup.string().required("You must enter your old password"),
        changePassword: _yup.string(),
        confirmPassword: _yup.string().when("changePassword", {
            is: (val)=>val !== undefined && val.length > 0,
            then: _yup.string().required("You must confirm your password"),
            otherwise: _yup.string()
        })
    }),
    handleSubmit: (values, { props })=>{
        props.userContainer.changeUserPassword({
            oldPassword: values.oldPassword,
            newPassword: values.changePassword,
            newPasswordConfirmation: values.confirmPassword
        }).then((result)=>{
            if (result.resultType === "Ok") {
                // Password changed successfully, log out the user
                props.authContainer.signOut();
                window.location.href = `${window.location.origin.toString()}/login`;
            }
        });
    }
})(InnerForm);
exports.default = ChangePasswordForm;
const fieldsContainerStyle = /*#__PURE__*/ (0, _css.css)({
    name: "1fb3wl7",
    styles: "margin-top:12px;margin-bottom:32px"
});
const containerStyle = /*#__PURE__*/ (0, _css.css)("border:1px solid ", (0, _colors.color_shades_dark), ";background:white;border-radius:8px;margin-bottom:32px;padding:24px 32px;padding-bottom:0px;.submit-button{margin-left:0px;}.title{font-size:16px;line-height:24px;padding-bottom:16px;}", "");

},{"@emotion/react":"djZKr","react":"6uln9","formik":"3YnOK","yup":"j2SJU","../../../components/structure/FormFieldsContainer":"h3hzh","../../../components/forms/TextField":"7a7bh","../../../components/general/Button":"6ymxN","../../../components/general/Loader":"bnV5T","@emotion/css":"awUBr","../../../constants/colors":"1p3OR","../../../components/structure/HorizontalSeparator":"Pw3HQ","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4uAZr":[function(require,module,exports) {
module.exports = require("da3106ec18603252").getBundleURL("kVLro") + require("3bcd1effc1772a35").resolve("gFMb5");

},{"da3106ec18603252":"c7Tr5","3bcd1effc1772a35":"fyJL2"}],"kp24t":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _base = require("@emotion/styled/base");
var _baseDefault = parcelHelpers.interopDefault(_base);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _supportAssistantHook = require("./hooks/SupportAssistantHook");
var _css = require("@emotion/css");
var _uuid = require("uuid");
var _conversationHistoryItem = require("./components/ConversationHistoryItem");
var _conversationHistoryItemDefault = parcelHelpers.interopDefault(_conversationHistoryItem);
var _customScrollbars = require("../../components/structure/CustomScrollbars");
var _customScrollbarsDefault = parcelHelpers.interopDefault(_customScrollbars);
var _colors = require("../../constants/colors");
var _stylesValues = require("../../constants/stylesValues");
var _deviceLoadingChatBubble = require("../../components/messagePreviews/DeviceLoadingChatBubble");
var _deviceLoadingChatBubbleDefault = parcelHelpers.interopDefault(_deviceLoadingChatBubble);
var _button = require("../../components/general/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _breakpoints = require("../../constants/breakpoints");
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const sendIcon = require("976131131e21cf49");
const micIcon = require("f53aadf5b0774447");
const botAvatar = require("b3e5799dcc5f045c");
const SupportAssistant = ({ userContainer })=>{
    const [isMicOpen, setIsMicOpen] = (0, _react1.useState)(false);
    const [allowMicInput, setAllowMicInput] = (0, _react1.useState)(true);
    const [userInputText, setUserInputText] = (0, _react1.useState)("");
    const scrollingRef = (0, _react1.useRef)(null);
    const voicify = (0, _supportAssistantHook.useSupportAssistant)();
    (0, _react1.useEffect)(()=>{
        if (scrollingRef && scrollingRef.current) scrollingRef.current.scrollIntoView({
            block: "end"
        });
    });
    (0, _react1.useEffect)(()=>{
        if (voicify.appId) voicify.startSession();
    }, [
        voicify.appId
    ]);
    const user = userContainer.state.currentUser;
    const userImage = user?.imageUrl;
    const userFirstName = user?.firstName;
    const userLastName = user?.lastName;
    if (allowMicInput && !window["SpeechRecognition"] && !window["webkitSpeechRecognition"]) setAllowMicInput(false);
    const SpeechRecognition = window["SpeechRecognition"] || window["webkitSpeechRecognition"];
    let recognition = SpeechRecognition ? new SpeechRecognition() : null;
    if (recognition) {
        recognition.lang = "en-US";
        // This runs when the speech recognition service starts
        recognition.onstart = function() {
            // start recognition
            setIsMicOpen(true);
        };
        recognition.onerror = ()=>{
            setIsMicOpen(false);
        };
        recognition.onspeechend = function() {
            // when user is done speaking
            recognition.stop();
            setIsMicOpen(false);
        };
        // This runs when the speech recognition service returns result
        recognition.onresult = async function(e) {
            const transcript = e.results[0][0].transcript;
            const history = await voicify.addUserHistory(transcript);
            setUserInputText("");
            voicify.makeRequest(transcript, history);
        };
    }
    const handleStartListening = ()=>{
        recognition.start();
    };
    const handleChange = (e)=>{
        e.preventDefault();
        setUserInputText(e.target.value);
    };
    const handleRestartClick = (e)=>{
        e.stopPropagation();
        voicify.resetSession();
        voicify.startSession();
    };
    const handleSubmit = async ()=>{
        const history = await voicify.addUserHistory(userInputText);
        setUserInputText("");
        await voicify.makeRequest(userInputText, history);
    };
    const onKeyDown = (e)=>{
        if (e.key === "Enter") handleSubmit();
    };
    const handleHintSubmit = async (hint, e)=>{
        e.stopPropagation();
        const history = await voicify.addUserHistory(hint);
        setUserInputText("");
        await voicify.makeRequest(hint, history);
    };
    return (0, _react.jsx)((0, _reactDefault.default).Fragment, null, (0, _react.jsx)(ChatContainer, null, (0, _react.jsx)(ChatBody, null, (0, _react.jsx)((0, _customScrollbarsDefault.default), null, (0, _react.jsx)(ConversationItemContainer, null, (0, _react.jsx)((0, _reactDefault.default).Fragment, null, voicify.conversationHistory.map((conversationHistoryItem)=>{
        return (0, _react.jsx)((0, _conversationHistoryItemDefault.default), {
            key: (0, _uuid.v4)(),
            conversationHistoryItem: conversationHistoryItem,
            userImage: userImage,
            userFirstName: userFirstName,
            userLastName: userLastName
        });
    })), voicify.loading ? (0, _react.jsx)((0, _deviceLoadingChatBubbleDefault.default), {
        icon: botAvatar,
        iconClassName: BotAvatarStyle
    }) : null, (0, _react.jsx)("div", {
        ref: scrollingRef
    })))), (0, _react.jsx)(ChatFooterWrapper, null, (0, _react.jsx)(ChatFooter, null, !voicify.loading && (0, _react.jsx)(HintButtonWrapper, null, voicify.hints?.map((hint)=>{
        return (0, _react.jsx)((0, _buttonDefault.default), {
            className: "hint-button",
            type: "button",
            key: (0, _uuid.v4)(),
            themes: [
                "white-small"
            ],
            onClick: (e)=>handleHintSubmit(hint, e),
            text: hint
        });
    }), (0, _react.jsx)((0, _buttonDefault.default), {
        className: "hint-button",
        type: "button",
        themes: [
            "white-small"
        ],
        onClick: (e)=>voicify.loading ? null : handleRestartClick(e),
        text: "Restart"
    })), (0, _react.jsx)(ChatInputContainer, null, recognition && allowMicInput && (0, _react.jsx)(MicStyleContainer, {
        type: "button",
        onClick: handleStartListening
    }, (0, _react.jsx)(Mic, {
        src: micIcon
    }), isMicOpen ? (0, _react.jsx)(MicText, null, "Listenting") : (0, _react.jsx)(MicText, null, "Click to Speak")), (0, _react.jsx)(ChatInput, {
        onKeyDown: onKeyDown,
        type: "text",
        placeholder: "Type something here",
        value: userInputText,
        onChange: handleChange
    }), (0, _react.jsx)(SendButton, {
        type: "submit",
        onClick: handleSubmit
    }, (0, _react.jsx)("img", {
        src: sendIcon
    })))))));
};
const BotAvatarStyle = /*#__PURE__*/ (0, _css.css)("border:1px solid ", (0, _colors.color_shades_dark), ";background:white;height:24px;width:24px;padding:1px;", "");
const HintButtonWrapper = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "eci2jxk11"
})("display:flex;flex-wrap:wrap;margin-top:8px;.hint-button{font-family:Muli;font-weight:400;font-size:14px;color:", (0, _colors.color_shades_darkest), ";margin:0 8px 8px 0;}");
const MicStyleContainer = /*#__PURE__*/ (0, _baseDefault.default)("button", {
    target: "eci2jxk10"
})("border:none;background-color:transparent;outline:none;display:flex;flex-direction:column;justify-content:center;align-items:center;width:20%;border-right:", (0, _stylesValues.style_border_default), ";");
const Mic = /*#__PURE__*/ (0, _baseDefault.default)("img", {
    target: "eci2jxk9"
})({
    name: "j1dva3",
    styles: "height:32px;width:32px"
});
const MicText = /*#__PURE__*/ (0, _baseDefault.default)("p", {
    target: "eci2jxk8"
})("color:", (0, _colors.color_shades_darkest), ";font-size:10px;font-family:Muli;padding:2px 0;");
const ChatContainer = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "eci2jxk7"
})({
    name: "1ga50h7",
    styles: "display:flex;flex-direction:column;align-items:center;height:calc(100vh - 200px)"
});
const ChatBody = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "eci2jxk6"
})("color:", (0, _colors.color_shades_darkest), ";background-color:", (0, _colors.color_shades_lighter), ";font-family:Muli;width:550px;height:calc(100vh - 400px);display:flex;flex-direction:column;", (0, _breakpoints.breakpoint_small), "{width:100%;}");
const ChatFooterWrapper = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "eci2jxk5"
})("display:flex;width:550px;justify-content:center;", (0, _breakpoints.breakpoint_small), "{width:100%;}");
const ChatFooter = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "eci2jxk4"
})("display:flex;flex-direction:column;justify-content:flex-end;color:", (0, _colors.color_shades_darkest), ";background-color:", (0, _colors.color_shades_lighter), ";font-family:Muli;width:515px;height:200px;", (0, _breakpoints.breakpoint_small), "{width:100%;align-items:center;}");
const ChatInputContainer = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "eci2jxk3"
})("border:", (0, _stylesValues.style_border_default), ";box-shadow:0px 4px 10px rgba(50, 70, 97, 0.1);border-radius:12px;height:72px;width:515px;margin:1rem 0;background-color:white;display:flex;", (0, _breakpoints.breakpoint_small), "{width:90%;}");
const ChatInput = /*#__PURE__*/ (0, _baseDefault.default)("input", {
    target: "eci2jxk2"
})("width:70%;font-family:Muli;font-size:16px;line-height:24px;flex-grow:1;margin:1rem;border:none;outline:none;::placeholder{color:", (0, _colors.color_shades_darker), ";font-style:italic;}");
const SendButton = /*#__PURE__*/ (0, _baseDefault.default)("button", {
    target: "eci2jxk1"
})({
    name: "ckosx2",
    styles: "margin:1rem;border:none;outline:none;background:transparent;border-radius:10%;width:10%"
});
const ConversationItemContainer = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "eci2jxk0"
})("display:flex;flex-direction:column;height:70px;font-family:Muli;font-weight:400;font-size:14px;color:", (0, _colors.color_shades_darkest), ";");
exports.default = SupportAssistant;

},{"@emotion/styled/base":"lSuFu","@emotion/react":"djZKr","react":"6uln9","./hooks/SupportAssistantHook":"dCLzc","@emotion/css":"awUBr","uuid":"klst7","./components/ConversationHistoryItem":"e09gw","../../components/structure/CustomScrollbars":"50vFq","../../constants/colors":"1p3OR","../../constants/stylesValues":"dHVVv","../../components/messagePreviews/DeviceLoadingChatBubble":"gT9AU","../../components/general/Button":"6ymxN","../../constants/breakpoints":"2F01A","976131131e21cf49":"aZNhW","f53aadf5b0774447":"9L5RG","b3e5799dcc5f045c":"076vb","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"dCLzc":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useSupportAssistant", ()=>useSupportAssistant);
var _react = require("react");
var _uuid = require("uuid");
var _voicifySdkAssistant = require("@voicify/voicify-sdk-assistant");
var _keys = require("../../../constants/Keys");
var _urls = require("../../../constants/Urls");
function useSupportAssistant() {
    const [hints, setHints] = (0, _react.useState)([]);
    const [conversationHistory, setConversationHistory] = (0, _react.useState)([]);
    const [userId, setUserId] = (0, _react.useState)((0, _uuid.v4)());
    const [sessionId, setSessionId] = (0, _react.useState)((0, _uuid.v4)());
    const [loading, setLoading] = (0, _react.useState)(true);
    const voicifyApi = new (0, _voicifySdkAssistant.CustomAssistantApi)({
        basePath: (0, _urls.getSupportAssistantBaseUrl)()
    });
    const appId = (0, _keys.SUPPORT_APPLICATION_ID);
    const appSecret = (0, _keys.SUPPORT_APPLICATION_SECRET);
    const buildRequest = (input)=>{
        return {
            requestId: (0, _uuid.v4)(),
            user: {
                id: userId,
                name: userId
            },
            device: {
                id: "Support Assistant",
                name: "Support Assistant",
                supportsDisplayText: true,
                supportsTextInput: true
            },
            context: {
                channel: "Support Assistant",
                locale: "en-US",
                sessionId: sessionId,
                requestType: "IntentRequest",
                originalInput: input,
                requiresLanguageUnderstanding: true
            }
        };
    };
    const buildWelcomeRequest = ()=>{
        return {
            requestId: (0, _uuid.v4)(),
            user: {
                id: userId,
                name: userId
            },
            device: {
                id: "Support Assistant",
                name: "Support Assistant",
                supportsDisplayText: true,
                supportsTextInput: true
            },
            context: {
                channel: "Support Assistant",
                requestName: "VoicifyWelcome",
                locale: "en-US",
                sessionId: sessionId,
                requestType: "IntentRequest",
                originalInput: "automatic app start",
                requiresLanguageUnderstanding: false
            }
        };
    };
    const startSession = async ()=>{
        try {
            setLoading(true);
            const result = await voicifyApi.handleRequest(buildWelcomeRequest(), appId, appSecret);
            await addBotHistory(result.displayText, []);
            setHints(result.hints);
            setLoading(false);
        } catch (e) {
            console.log("error:", e);
            setLoading(false);
        }
    };
    const resetSession = ()=>{
        setSessionId((0, _uuid.v4)());
        setUserId((0, _uuid.v4)());
    };
    const addUserHistory = (userString, history = null)=>{
        let conversationHistoryCopy = history !== null ? history : [
            ...conversationHistory
        ];
        conversationHistoryCopy.push({
            "user": userString
        });
        setConversationHistory(conversationHistoryCopy);
        return conversationHistoryCopy;
    };
    const addBotHistory = (botString, history = null)=>{
        let conversationHistoryCopy = history !== null ? history : [
            ...conversationHistory
        ];
        conversationHistoryCopy.push({
            "bot": botString
        });
        setConversationHistory(conversationHistoryCopy);
        return conversationHistoryCopy;
    };
    const makeRequest = async (input, history)=>{
        try {
            setLoading(true);
            const result = await voicifyApi.handleRequest(buildRequest(input), appId, appSecret);
            await addBotHistory(result.displayText, history);
            setHints(result.hints);
            setLoading(false);
        } catch (e) {
            console.log("error:", e);
            setLoading(false);
        }
    };
    return {
        startSession,
        resetSession,
        addUserHistory,
        makeRequest,
        hints,
        conversationHistory,
        loading,
        appId
    };
}

},{"react":"6uln9","uuid":"klst7","@voicify/voicify-sdk-assistant":"folZP","../../../constants/Keys":"4iC9Z","../../../constants/Urls":"iTopY","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"folZP":[function(require,module,exports) {
"use strict";
// tslint:disable
/**
 * Voicify Assistant API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: V1
 *
 *
 * NOTE: This file is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the file manually.
 */ var __createBinding = this && this.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, {
        enumerable: true,
        get: function() {
            return m[k];
        }
    });
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var __exportStar = this && this.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !exports1.hasOwnProperty(p)) __createBinding(exports1, m, p);
};
Object.defineProperty(exports, "__esModule", {
    value: true
});
__exportStar(require("9d4529fc15cdb526"), exports);
__exportStar(require("24fbb32638d083a1"), exports);

},{"9d4529fc15cdb526":"kOoth","24fbb32638d083a1":"6g26t"}],"kOoth":[function(require,module,exports) {
"use strict";
/// <reference path="./custom.d.ts" />
// tslint:disable
/**
 * Voicify Assistant API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: V1
 *
 *
 * NOTE: This file is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the file manually.
 */ Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.UserProfileApi = exports.UserProfileApiFactory = exports.UserProfileApiFp = exports.UserProfileApiFetchParamCreator = exports.HealthCheckApi = exports.HealthCheckApiFactory = exports.HealthCheckApiFp = exports.HealthCheckApiFetchParamCreator = exports.GoogleAssistantApi = exports.GoogleAssistantApiFactory = exports.GoogleAssistantApiFp = exports.GoogleAssistantApiFetchParamCreator = exports.DialogflowApi = exports.DialogflowApiFactory = exports.DialogflowApiFp = exports.DialogflowApiFetchParamCreator = exports.CustomAssistantApi = exports.CustomAssistantApiFactory = exports.CustomAssistantApiFp = exports.CustomAssistantApiFetchParamCreator = exports.BotServiceApi = exports.BotServiceApiFactory = exports.BotServiceApiFp = exports.BotServiceApiFetchParamCreator = exports.BixbyApi = exports.BixbyApiFactory = exports.BixbyApiFp = exports.BixbyApiFetchParamCreator = exports.AlexaApi = exports.AlexaApiFactory = exports.AlexaApiFp = exports.AlexaApiFetchParamCreator = exports.ViewportShape = exports.PlayBehavior = exports.LocationServiceStatus = exports.LocationServiceAccess = exports.RequiredError = exports.BaseAPI = exports.COLLECTION_FORMATS = void 0;
const url = require("5dc88633267177ac");
const portableFetch = require("8f66ef2f593d0e35");
const BASE_PATH = "/".replace(/\/+$/, "");
/**
 *
 * @export
 */ exports.COLLECTION_FORMATS = {
    csv: ",",
    ssv: " ",
    tsv: "	",
    pipes: "|"
};
/**
 *
 * @export
 * @class BaseAPI
 */ class BaseAPI {
    constructor(configuration, basePath = BASE_PATH, fetch = portableFetch){
        this.basePath = basePath;
        this.fetch = fetch;
        if (configuration) {
            this.configuration = configuration;
            this.basePath = configuration.basePath || this.basePath;
        }
    }
}
exports.BaseAPI = BaseAPI;
/**
 *
 * @export
 * @class RequiredError
 * @extends {Error}
 */ class RequiredError extends Error {
    constructor(field, msg){
        super(msg);
        this.field = field;
    }
}
exports.RequiredError = RequiredError;
/**
 *
 * @export
 * @enum {string}
 */ var LocationServiceAccess;
(function(LocationServiceAccess) {
    LocationServiceAccess[LocationServiceAccess["ENABLED"] = "ENABLED"] = "ENABLED";
    LocationServiceAccess[LocationServiceAccess["DISABLED"] = "DISABLED"] = "DISABLED";
})(LocationServiceAccess = exports.LocationServiceAccess || (exports.LocationServiceAccess = {}));
/**
 *
 * @export
 * @enum {string}
 */ var LocationServiceStatus;
(function(LocationServiceStatus) {
    LocationServiceStatus[LocationServiceStatus["RUNNING"] = "RUNNING"] = "RUNNING";
    LocationServiceStatus[LocationServiceStatus["STOPPED"] = "STOPPED"] = "STOPPED";
})(LocationServiceStatus = exports.LocationServiceStatus || (exports.LocationServiceStatus = {}));
/**
 *
 * @export
 * @enum {string}
 */ var PlayBehavior;
(function(PlayBehavior) {
    PlayBehavior[PlayBehavior["REPLACEALL"] = "REPLACE_ALL"] = "REPLACEALL";
    PlayBehavior[PlayBehavior["ENQUEUE"] = "ENQUEUE"] = "ENQUEUE";
    PlayBehavior[PlayBehavior["REPLACEENQUEUED"] = "REPLACE_ENQUEUED"] = "REPLACEENQUEUED";
})(PlayBehavior = exports.PlayBehavior || (exports.PlayBehavior = {}));
/**
 *
 * @export
 * @enum {string}
 */ var ViewportShape;
(function(ViewportShape) {
    ViewportShape[ViewportShape["SQUARE"] = "SQUARE"] = "SQUARE";
    ViewportShape[ViewportShape["RECTANGLE"] = "RECTANGLE"] = "RECTANGLE";
    ViewportShape[ViewportShape["ROUND"] = "ROUND"] = "ROUND";
})(ViewportShape = exports.ViewportShape || (exports.ViewportShape = {}));
/**
 * AlexaApi - fetch parameter creator
 * @export
 */ exports.AlexaApiFetchParamCreator = function(configuration) {
    return {
        /**
         *
         * @param {APLSkillRequest} [body]
         * @param {string} [applicationId]
         * @param {string} [applicationSecret]
         * @param {string} [environmentId]
         * @param {boolean} [noTracking]
         * @param {boolean} [useDraftContent]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */ handleLocalRequest (body, applicationId, applicationSecret, environmentId, noTracking, useDraftContent, options = {}) {
            const localVarPath = `/api/Alexa/HandleRequest`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({
                method: "POST"
            }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === "function" ? configuration.apiKey("Authorization") : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            // authentication X-Api-Key required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === "function" ? configuration.apiKey("X-Api-Key") : configuration.apiKey;
                localVarHeaderParameter["X-Api-Key"] = localVarApiKeyValue;
            }
            if (applicationId !== undefined) localVarQueryParameter["applicationId"] = applicationId;
            if (applicationSecret !== undefined) localVarQueryParameter["applicationSecret"] = applicationSecret;
            if (environmentId !== undefined) localVarQueryParameter["environmentId"] = environmentId;
            if (noTracking !== undefined) localVarQueryParameter["noTracking"] = noTracking;
            if (useDraftContent !== undefined) localVarQueryParameter["useDraftContent"] = useDraftContent;
            localVarHeaderParameter["Content-Type"] = "application/json-patch+json";
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = true;
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(body || {}) : body || "";
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
         *
         * @param {APLSkillRequest} [body]
         * @param {string} [applicationId]
         * @param {string} [applicationSecret]
         * @param {string} [environmentId]
         * @param {boolean} [noTracking]
         * @param {boolean} [useDraftContent]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */ handleSignedRequest (body, applicationId, applicationSecret, environmentId, noTracking, useDraftContent, options = {}) {
            const localVarPath = `/api/Alexa/HandleSignedRequest`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({
                method: "POST"
            }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === "function" ? configuration.apiKey("Authorization") : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            // authentication X-Api-Key required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === "function" ? configuration.apiKey("X-Api-Key") : configuration.apiKey;
                localVarHeaderParameter["X-Api-Key"] = localVarApiKeyValue;
            }
            if (applicationId !== undefined) localVarQueryParameter["applicationId"] = applicationId;
            if (applicationSecret !== undefined) localVarQueryParameter["applicationSecret"] = applicationSecret;
            if (environmentId !== undefined) localVarQueryParameter["environmentId"] = environmentId;
            if (noTracking !== undefined) localVarQueryParameter["noTracking"] = noTracking;
            if (useDraftContent !== undefined) localVarQueryParameter["useDraftContent"] = useDraftContent;
            localVarHeaderParameter["Content-Type"] = "application/json-patch+json";
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = true;
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(body || {}) : body || "";
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions
            };
        }
    };
};
/**
 * AlexaApi - functional programming interface
 * @export
 */ exports.AlexaApiFp = function(configuration) {
    return {
        /**
         *
         * @param {APLSkillRequest} [body]
         * @param {string} [applicationId]
         * @param {string} [applicationSecret]
         * @param {string} [environmentId]
         * @param {boolean} [noTracking]
         * @param {boolean} [useDraftContent]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */ handleLocalRequest (body, applicationId, applicationSecret, environmentId, noTracking, useDraftContent, options) {
            const localVarFetchArgs = exports.AlexaApiFetchParamCreator(configuration).handleLocalRequest(body, applicationId, applicationSecret, environmentId, noTracking, useDraftContent, options);
            return (fetch = portableFetch, basePath = BASE_PATH)=>{
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response)=>{
                    if (response.status >= 200 && response.status < 300) return response.json();
                    else throw response;
                });
            };
        },
        /**
         *
         * @param {APLSkillRequest} [body]
         * @param {string} [applicationId]
         * @param {string} [applicationSecret]
         * @param {string} [environmentId]
         * @param {boolean} [noTracking]
         * @param {boolean} [useDraftContent]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */ handleSignedRequest (body, applicationId, applicationSecret, environmentId, noTracking, useDraftContent, options) {
            const localVarFetchArgs = exports.AlexaApiFetchParamCreator(configuration).handleSignedRequest(body, applicationId, applicationSecret, environmentId, noTracking, useDraftContent, options);
            return (fetch = portableFetch, basePath = BASE_PATH)=>{
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response)=>{
                    if (response.status >= 200 && response.status < 300) return response.json();
                    else throw response;
                });
            };
        }
    };
};
/**
 * AlexaApi - factory interface
 * @export
 */ exports.AlexaApiFactory = function(configuration, fetch, basePath) {
    return {
        /**
         *
         * @param {APLSkillRequest} [body]
         * @param {string} [applicationId]
         * @param {string} [applicationSecret]
         * @param {string} [environmentId]
         * @param {boolean} [noTracking]
         * @param {boolean} [useDraftContent]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */ handleLocalRequest (body, applicationId, applicationSecret, environmentId, noTracking, useDraftContent, options) {
            return exports.AlexaApiFp(configuration).handleLocalRequest(body, applicationId, applicationSecret, environmentId, noTracking, useDraftContent, options)(fetch, basePath);
        },
        /**
         *
         * @param {APLSkillRequest} [body]
         * @param {string} [applicationId]
         * @param {string} [applicationSecret]
         * @param {string} [environmentId]
         * @param {boolean} [noTracking]
         * @param {boolean} [useDraftContent]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */ handleSignedRequest (body, applicationId, applicationSecret, environmentId, noTracking, useDraftContent, options) {
            return exports.AlexaApiFp(configuration).handleSignedRequest(body, applicationId, applicationSecret, environmentId, noTracking, useDraftContent, options)(fetch, basePath);
        }
    };
};
/**
 * AlexaApi - object-oriented interface
 * @export
 * @class AlexaApi
 * @extends {BaseAPI}
 */ class AlexaApi extends BaseAPI {
    /**
     *
     * @param {APLSkillRequest} [body]
     * @param {string} [applicationId]
     * @param {string} [applicationSecret]
     * @param {string} [environmentId]
     * @param {boolean} [noTracking]
     * @param {boolean} [useDraftContent]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AlexaApi
     */ handleLocalRequest(body, applicationId, applicationSecret, environmentId, noTracking, useDraftContent, options) {
        return exports.AlexaApiFp(this.configuration).handleLocalRequest(body, applicationId, applicationSecret, environmentId, noTracking, useDraftContent, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @param {APLSkillRequest} [body]
     * @param {string} [applicationId]
     * @param {string} [applicationSecret]
     * @param {string} [environmentId]
     * @param {boolean} [noTracking]
     * @param {boolean} [useDraftContent]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AlexaApi
     */ handleSignedRequest(body, applicationId, applicationSecret, environmentId, noTracking, useDraftContent, options) {
        return exports.AlexaApiFp(this.configuration).handleSignedRequest(body, applicationId, applicationSecret, environmentId, noTracking, useDraftContent, options)(this.fetch, this.basePath);
    }
}
exports.AlexaApi = AlexaApi;
/**
 * BixbyApi - fetch parameter creator
 * @export
 */ exports.BixbyApiFetchParamCreator = function(configuration) {
    return {
        /**
         *
         * @param {string} actionName
         * @param {{ [key: string]: any; }} [body]
         * @param {string} [applicationId]
         * @param {string} [applicationSecret]
         * @param {string} [environmentId]
         * @param {boolean} [noTracking]
         * @param {boolean} [useDraftContent]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */ handleCustomRequest (actionName, body, applicationId, applicationSecret, environmentId, noTracking, useDraftContent, options = {}) {
            // verify required parameter 'actionName' is not null or undefined
            if (actionName === null || actionName === undefined) throw new RequiredError("actionName", "Required parameter actionName was null or undefined when calling handleCustomRequest.");
            const localVarPath = `/api/Bixby/HandleRequest/Custom/{actionName}`.replace(`{${"actionName"}}`, encodeURIComponent(String(actionName)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({
                method: "POST"
            }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === "function" ? configuration.apiKey("Authorization") : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            // authentication X-Api-Key required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === "function" ? configuration.apiKey("X-Api-Key") : configuration.apiKey;
                localVarHeaderParameter["X-Api-Key"] = localVarApiKeyValue;
            }
            if (applicationId !== undefined) localVarQueryParameter["applicationId"] = applicationId;
            if (applicationSecret !== undefined) localVarQueryParameter["applicationSecret"] = applicationSecret;
            if (environmentId !== undefined) localVarQueryParameter["environmentId"] = environmentId;
            if (noTracking !== undefined) localVarQueryParameter["noTracking"] = noTracking;
            if (useDraftContent !== undefined) localVarQueryParameter["useDraftContent"] = useDraftContent;
            localVarHeaderParameter["Content-Type"] = "application/json-patch+json";
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = true;
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(body || {}) : body || "";
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
         *
         * @param {{ [key: string]: any; }} [body]
         * @param {string} [applicationId]
         * @param {string} [applicationSecret]
         * @param {string} [environmentId]
         * @param {boolean} [noTracking]
         * @param {boolean} [useDraftContent]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */ handleDynamicRequest (body, applicationId, applicationSecret, environmentId, noTracking, useDraftContent, options = {}) {
            const localVarPath = `/api/Bixby/HandleRequest/Dynamic`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({
                method: "POST"
            }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === "function" ? configuration.apiKey("Authorization") : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            // authentication X-Api-Key required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === "function" ? configuration.apiKey("X-Api-Key") : configuration.apiKey;
                localVarHeaderParameter["X-Api-Key"] = localVarApiKeyValue;
            }
            if (applicationId !== undefined) localVarQueryParameter["applicationId"] = applicationId;
            if (applicationSecret !== undefined) localVarQueryParameter["applicationSecret"] = applicationSecret;
            if (environmentId !== undefined) localVarQueryParameter["environmentId"] = environmentId;
            if (noTracking !== undefined) localVarQueryParameter["noTracking"] = noTracking;
            if (useDraftContent !== undefined) localVarQueryParameter["useDraftContent"] = useDraftContent;
            localVarHeaderParameter["Content-Type"] = "application/json-patch+json";
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = true;
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(body || {}) : body || "";
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
         *
         * @param {{ [key: string]: any; }} [body]
         * @param {string} [applicationId]
         * @param {string} [applicationSecret]
         * @param {string} [environmentId]
         * @param {boolean} [noTracking]
         * @param {boolean} [useDraftContent]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */ handleGeneralQuestionRequest (body, applicationId, applicationSecret, environmentId, noTracking, useDraftContent, options = {}) {
            const localVarPath = `/api/Bixby/HandleRequest/GeneralQuestion`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({
                method: "POST"
            }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === "function" ? configuration.apiKey("Authorization") : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            // authentication X-Api-Key required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === "function" ? configuration.apiKey("X-Api-Key") : configuration.apiKey;
                localVarHeaderParameter["X-Api-Key"] = localVarApiKeyValue;
            }
            if (applicationId !== undefined) localVarQueryParameter["applicationId"] = applicationId;
            if (applicationSecret !== undefined) localVarQueryParameter["applicationSecret"] = applicationSecret;
            if (environmentId !== undefined) localVarQueryParameter["environmentId"] = environmentId;
            if (noTracking !== undefined) localVarQueryParameter["noTracking"] = noTracking;
            if (useDraftContent !== undefined) localVarQueryParameter["useDraftContent"] = useDraftContent;
            localVarHeaderParameter["Content-Type"] = "application/json-patch+json";
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = true;
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(body || {}) : body || "";
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
         *
         * @param {{ [key: string]: any; }} [body]
         * @param {string} [applicationId]
         * @param {string} [applicationSecret]
         * @param {string} [environmentId]
         * @param {boolean} [noTracking]
         * @param {boolean} [useDraftContent]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */ handleGoToStepRequest (body, applicationId, applicationSecret, environmentId, noTracking, useDraftContent, options = {}) {
            const localVarPath = `/api/Bixby/HandleRequest/GoToStep`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({
                method: "POST"
            }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === "function" ? configuration.apiKey("Authorization") : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            // authentication X-Api-Key required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === "function" ? configuration.apiKey("X-Api-Key") : configuration.apiKey;
                localVarHeaderParameter["X-Api-Key"] = localVarApiKeyValue;
            }
            if (applicationId !== undefined) localVarQueryParameter["applicationId"] = applicationId;
            if (applicationSecret !== undefined) localVarQueryParameter["applicationSecret"] = applicationSecret;
            if (environmentId !== undefined) localVarQueryParameter["environmentId"] = environmentId;
            if (noTracking !== undefined) localVarQueryParameter["noTracking"] = noTracking;
            if (useDraftContent !== undefined) localVarQueryParameter["useDraftContent"] = useDraftContent;
            localVarHeaderParameter["Content-Type"] = "application/json-patch+json";
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = true;
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(body || {}) : body || "";
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
         *
         * @param {{ [key: string]: any; }} [body]
         * @param {string} [applicationId]
         * @param {string} [applicationSecret]
         * @param {string} [environmentId]
         * @param {boolean} [noTracking]
         * @param {boolean} [useDraftContent]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */ handleHelpRequest (body, applicationId, applicationSecret, environmentId, noTracking, useDraftContent, options = {}) {
            const localVarPath = `/api/Bixby/HandleRequest/Help`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({
                method: "POST"
            }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === "function" ? configuration.apiKey("Authorization") : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            // authentication X-Api-Key required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === "function" ? configuration.apiKey("X-Api-Key") : configuration.apiKey;
                localVarHeaderParameter["X-Api-Key"] = localVarApiKeyValue;
            }
            if (applicationId !== undefined) localVarQueryParameter["applicationId"] = applicationId;
            if (applicationSecret !== undefined) localVarQueryParameter["applicationSecret"] = applicationSecret;
            if (environmentId !== undefined) localVarQueryParameter["environmentId"] = environmentId;
            if (noTracking !== undefined) localVarQueryParameter["noTracking"] = noTracking;
            if (useDraftContent !== undefined) localVarQueryParameter["useDraftContent"] = useDraftContent;
            localVarHeaderParameter["Content-Type"] = "application/json-patch+json";
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = true;
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(body || {}) : body || "";
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
         *
         * @param {{ [key: string]: any; }} [body]
         * @param {string} [applicationId]
         * @param {string} [applicationSecret]
         * @param {string} [environmentId]
         * @param {boolean} [noTracking]
         * @param {boolean} [useDraftContent]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */ handleLatestMessageRequest (body, applicationId, applicationSecret, environmentId, noTracking, useDraftContent, options = {}) {
            const localVarPath = `/api/Bixby/HandleRequest/LatestMessage`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({
                method: "POST"
            }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === "function" ? configuration.apiKey("Authorization") : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            // authentication X-Api-Key required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === "function" ? configuration.apiKey("X-Api-Key") : configuration.apiKey;
                localVarHeaderParameter["X-Api-Key"] = localVarApiKeyValue;
            }
            if (applicationId !== undefined) localVarQueryParameter["applicationId"] = applicationId;
            if (applicationSecret !== undefined) localVarQueryParameter["applicationSecret"] = applicationSecret;
            if (environmentId !== undefined) localVarQueryParameter["environmentId"] = environmentId;
            if (noTracking !== undefined) localVarQueryParameter["noTracking"] = noTracking;
            if (useDraftContent !== undefined) localVarQueryParameter["useDraftContent"] = useDraftContent;
            localVarHeaderParameter["Content-Type"] = "application/json-patch+json";
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = true;
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(body || {}) : body || "";
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
         *
         * @param {{ [key: string]: any; }} [body]
         * @param {string} [applicationId]
         * @param {string} [applicationSecret]
         * @param {string} [environmentId]
         * @param {boolean} [noTracking]
         * @param {boolean} [useDraftContent]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */ handleListItemSelectRequest (body, applicationId, applicationSecret, environmentId, noTracking, useDraftContent, options = {}) {
            const localVarPath = `/api/Bixby/HandleRequest/ListItemSelect`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({
                method: "POST"
            }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === "function" ? configuration.apiKey("Authorization") : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            // authentication X-Api-Key required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === "function" ? configuration.apiKey("X-Api-Key") : configuration.apiKey;
                localVarHeaderParameter["X-Api-Key"] = localVarApiKeyValue;
            }
            if (applicationId !== undefined) localVarQueryParameter["applicationId"] = applicationId;
            if (applicationSecret !== undefined) localVarQueryParameter["applicationSecret"] = applicationSecret;
            if (environmentId !== undefined) localVarQueryParameter["environmentId"] = environmentId;
            if (noTracking !== undefined) localVarQueryParameter["noTracking"] = noTracking;
            if (useDraftContent !== undefined) localVarQueryParameter["useDraftContent"] = useDraftContent;
            localVarHeaderParameter["Content-Type"] = "application/json-patch+json";
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = true;
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(body || {}) : body || "";
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
         *
         * @param {{ [key: string]: any; }} [body]
         * @param {string} [applicationId]
         * @param {string} [applicationSecret]
         * @param {string} [environmentId]
         * @param {boolean} [noTracking]
         * @param {boolean} [useDraftContent]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */ handleMoreRequest (body, applicationId, applicationSecret, environmentId, noTracking, useDraftContent, options = {}) {
            const localVarPath = `/api/Bixby/HandleRequest/More`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({
                method: "POST"
            }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === "function" ? configuration.apiKey("Authorization") : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            // authentication X-Api-Key required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === "function" ? configuration.apiKey("X-Api-Key") : configuration.apiKey;
                localVarHeaderParameter["X-Api-Key"] = localVarApiKeyValue;
            }
            if (applicationId !== undefined) localVarQueryParameter["applicationId"] = applicationId;
            if (applicationSecret !== undefined) localVarQueryParameter["applicationSecret"] = applicationSecret;
            if (environmentId !== undefined) localVarQueryParameter["environmentId"] = environmentId;
            if (noTracking !== undefined) localVarQueryParameter["noTracking"] = noTracking;
            if (useDraftContent !== undefined) localVarQueryParameter["useDraftContent"] = useDraftContent;
            localVarHeaderParameter["Content-Type"] = "application/json-patch+json";
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = true;
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(body || {}) : body || "";
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
         *
         * @param {{ [key: string]: any; }} [body]
         * @param {string} [applicationId]
         * @param {string} [applicationSecret]
         * @param {string} [environmentId]
         * @param {boolean} [noTracking]
         * @param {boolean} [useDraftContent]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */ handleNextRequest (body, applicationId, applicationSecret, environmentId, noTracking, useDraftContent, options = {}) {
            const localVarPath = `/api/Bixby/HandleRequest/Next`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({
                method: "POST"
            }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === "function" ? configuration.apiKey("Authorization") : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            // authentication X-Api-Key required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === "function" ? configuration.apiKey("X-Api-Key") : configuration.apiKey;
                localVarHeaderParameter["X-Api-Key"] = localVarApiKeyValue;
            }
            if (applicationId !== undefined) localVarQueryParameter["applicationId"] = applicationId;
            if (applicationSecret !== undefined) localVarQueryParameter["applicationSecret"] = applicationSecret;
            if (environmentId !== undefined) localVarQueryParameter["environmentId"] = environmentId;
            if (noTracking !== undefined) localVarQueryParameter["noTracking"] = noTracking;
            if (useDraftContent !== undefined) localVarQueryParameter["useDraftContent"] = useDraftContent;
            localVarHeaderParameter["Content-Type"] = "application/json-patch+json";
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = true;
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(body || {}) : body || "";
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
         *
         * @param {{ [key: string]: any; }} [body]
         * @param {string} [applicationId]
         * @param {string} [applicationSecret]
         * @param {string} [environmentId]
         * @param {boolean} [noTracking]
         * @param {boolean} [useDraftContent]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */ handleNoRequest (body, applicationId, applicationSecret, environmentId, noTracking, useDraftContent, options = {}) {
            const localVarPath = `/api/Bixby/HandleRequest/No`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({
                method: "POST"
            }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === "function" ? configuration.apiKey("Authorization") : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            // authentication X-Api-Key required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === "function" ? configuration.apiKey("X-Api-Key") : configuration.apiKey;
                localVarHeaderParameter["X-Api-Key"] = localVarApiKeyValue;
            }
            if (applicationId !== undefined) localVarQueryParameter["applicationId"] = applicationId;
            if (applicationSecret !== undefined) localVarQueryParameter["applicationSecret"] = applicationSecret;
            if (environmentId !== undefined) localVarQueryParameter["environmentId"] = environmentId;
            if (noTracking !== undefined) localVarQueryParameter["noTracking"] = noTracking;
            if (useDraftContent !== undefined) localVarQueryParameter["useDraftContent"] = useDraftContent;
            localVarHeaderParameter["Content-Type"] = "application/json-patch+json";
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = true;
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(body || {}) : body || "";
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
         *
         * @param {{ [key: string]: any; }} [body]
         * @param {string} [applicationId]
         * @param {string} [applicationSecret]
         * @param {string} [environmentId]
         * @param {boolean} [noTracking]
         * @param {boolean} [useDraftContent]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */ handleNumberRequest (body, applicationId, applicationSecret, environmentId, noTracking, useDraftContent, options = {}) {
            const localVarPath = `/api/Bixby/HandleRequest/Number`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({
                method: "POST"
            }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === "function" ? configuration.apiKey("Authorization") : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            // authentication X-Api-Key required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === "function" ? configuration.apiKey("X-Api-Key") : configuration.apiKey;
                localVarHeaderParameter["X-Api-Key"] = localVarApiKeyValue;
            }
            if (applicationId !== undefined) localVarQueryParameter["applicationId"] = applicationId;
            if (applicationSecret !== undefined) localVarQueryParameter["applicationSecret"] = applicationSecret;
            if (environmentId !== undefined) localVarQueryParameter["environmentId"] = environmentId;
            if (noTracking !== undefined) localVarQueryParameter["noTracking"] = noTracking;
            if (useDraftContent !== undefined) localVarQueryParameter["useDraftContent"] = useDraftContent;
            localVarHeaderParameter["Content-Type"] = "application/json-patch+json";
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = true;
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(body || {}) : body || "";
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
         *
         * @param {{ [key: string]: any; }} [body]
         * @param {string} [applicationId]
         * @param {string} [applicationSecret]
         * @param {string} [environmentId]
         * @param {boolean} [noTracking]
         * @param {boolean} [useDraftContent]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */ handlePrevisousRequest (body, applicationId, applicationSecret, environmentId, noTracking, useDraftContent, options = {}) {
            const localVarPath = `/api/Bixby/HandleRequest/Previous`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({
                method: "POST"
            }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === "function" ? configuration.apiKey("Authorization") : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            // authentication X-Api-Key required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === "function" ? configuration.apiKey("X-Api-Key") : configuration.apiKey;
                localVarHeaderParameter["X-Api-Key"] = localVarApiKeyValue;
            }
            if (applicationId !== undefined) localVarQueryParameter["applicationId"] = applicationId;
            if (applicationSecret !== undefined) localVarQueryParameter["applicationSecret"] = applicationSecret;
            if (environmentId !== undefined) localVarQueryParameter["environmentId"] = environmentId;
            if (noTracking !== undefined) localVarQueryParameter["noTracking"] = noTracking;
            if (useDraftContent !== undefined) localVarQueryParameter["useDraftContent"] = useDraftContent;
            localVarHeaderParameter["Content-Type"] = "application/json-patch+json";
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = true;
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(body || {}) : body || "";
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
         *
         * @param {{ [key: string]: any; }} [body]
         * @param {string} [applicationId]
         * @param {string} [applicationSecret]
         * @param {string} [environmentId]
         * @param {boolean} [noTracking]
         * @param {boolean} [useDraftContent]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */ handleRecipeDetailsRequest (body, applicationId, applicationSecret, environmentId, noTracking, useDraftContent, options = {}) {
            const localVarPath = `/api/Bixby/HandleRequest/RecipeDetails`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({
                method: "POST"
            }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === "function" ? configuration.apiKey("Authorization") : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            // authentication X-Api-Key required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === "function" ? configuration.apiKey("X-Api-Key") : configuration.apiKey;
                localVarHeaderParameter["X-Api-Key"] = localVarApiKeyValue;
            }
            if (applicationId !== undefined) localVarQueryParameter["applicationId"] = applicationId;
            if (applicationSecret !== undefined) localVarQueryParameter["applicationSecret"] = applicationSecret;
            if (environmentId !== undefined) localVarQueryParameter["environmentId"] = environmentId;
            if (noTracking !== undefined) localVarQueryParameter["noTracking"] = noTracking;
            if (useDraftContent !== undefined) localVarQueryParameter["useDraftContent"] = useDraftContent;
            localVarHeaderParameter["Content-Type"] = "application/json-patch+json";
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = true;
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(body || {}) : body || "";
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
         *
         * @param {{ [key: string]: any; }} [body]
         * @param {string} [applicationId]
         * @param {string} [applicationSecret]
         * @param {string} [environmentId]
         * @param {boolean} [noTracking]
         * @param {boolean} [useDraftContent]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */ handleStartOverRequest (body, applicationId, applicationSecret, environmentId, noTracking, useDraftContent, options = {}) {
            const localVarPath = `/api/Bixby/HandleRequest/StartOver`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({
                method: "POST"
            }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === "function" ? configuration.apiKey("Authorization") : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            // authentication X-Api-Key required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === "function" ? configuration.apiKey("X-Api-Key") : configuration.apiKey;
                localVarHeaderParameter["X-Api-Key"] = localVarApiKeyValue;
            }
            if (applicationId !== undefined) localVarQueryParameter["applicationId"] = applicationId;
            if (applicationSecret !== undefined) localVarQueryParameter["applicationSecret"] = applicationSecret;
            if (environmentId !== undefined) localVarQueryParameter["environmentId"] = environmentId;
            if (noTracking !== undefined) localVarQueryParameter["noTracking"] = noTracking;
            if (useDraftContent !== undefined) localVarQueryParameter["useDraftContent"] = useDraftContent;
            localVarHeaderParameter["Content-Type"] = "application/json-patch+json";
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = true;
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(body || {}) : body || "";
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
         *
         * @param {{ [key: string]: any; }} [body]
         * @param {string} [applicationId]
         * @param {string} [applicationSecret]
         * @param {string} [environmentId]
         * @param {boolean} [noTracking]
         * @param {boolean} [useDraftContent]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */ handleStartRequest (body, applicationId, applicationSecret, environmentId, noTracking, useDraftContent, options = {}) {
            const localVarPath = `/api/Bixby/HandleRequest/Start`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({
                method: "POST"
            }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === "function" ? configuration.apiKey("Authorization") : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            // authentication X-Api-Key required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === "function" ? configuration.apiKey("X-Api-Key") : configuration.apiKey;
                localVarHeaderParameter["X-Api-Key"] = localVarApiKeyValue;
            }
            if (applicationId !== undefined) localVarQueryParameter["applicationId"] = applicationId;
            if (applicationSecret !== undefined) localVarQueryParameter["applicationSecret"] = applicationSecret;
            if (environmentId !== undefined) localVarQueryParameter["environmentId"] = environmentId;
            if (noTracking !== undefined) localVarQueryParameter["noTracking"] = noTracking;
            if (useDraftContent !== undefined) localVarQueryParameter["useDraftContent"] = useDraftContent;
            localVarHeaderParameter["Content-Type"] = "application/json-patch+json";
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = true;
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(body || {}) : body || "";
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
         *
         * @param {{ [key: string]: any; }} [body]
         * @param {string} [applicationId]
         * @param {string} [applicationSecret]
         * @param {string} [environmentId]
         * @param {boolean} [noTracking]
         * @param {boolean} [useDraftContent]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */ handleStopRequest (body, applicationId, applicationSecret, environmentId, noTracking, useDraftContent, options = {}) {
            const localVarPath = `/api/Bixby/HandleRequest/Stop`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({
                method: "POST"
            }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === "function" ? configuration.apiKey("Authorization") : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            // authentication X-Api-Key required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === "function" ? configuration.apiKey("X-Api-Key") : configuration.apiKey;
                localVarHeaderParameter["X-Api-Key"] = localVarApiKeyValue;
            }
            if (applicationId !== undefined) localVarQueryParameter["applicationId"] = applicationId;
            if (applicationSecret !== undefined) localVarQueryParameter["applicationSecret"] = applicationSecret;
            if (environmentId !== undefined) localVarQueryParameter["environmentId"] = environmentId;
            if (noTracking !== undefined) localVarQueryParameter["noTracking"] = noTracking;
            if (useDraftContent !== undefined) localVarQueryParameter["useDraftContent"] = useDraftContent;
            localVarHeaderParameter["Content-Type"] = "application/json-patch+json";
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = true;
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(body || {}) : body || "";
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
         *
         * @param {{ [key: string]: any; }} [body]
         * @param {string} [applicationId]
         * @param {string} [applicationSecret]
         * @param {string} [environmentId]
         * @param {boolean} [noTracking]
         * @param {boolean} [useDraftContent]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */ handleWelcomeRequest (body, applicationId, applicationSecret, environmentId, noTracking, useDraftContent, options = {}) {
            const localVarPath = `/api/Bixby/HandleRequest/Welcome`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({
                method: "POST"
            }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === "function" ? configuration.apiKey("Authorization") : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            // authentication X-Api-Key required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === "function" ? configuration.apiKey("X-Api-Key") : configuration.apiKey;
                localVarHeaderParameter["X-Api-Key"] = localVarApiKeyValue;
            }
            if (applicationId !== undefined) localVarQueryParameter["applicationId"] = applicationId;
            if (applicationSecret !== undefined) localVarQueryParameter["applicationSecret"] = applicationSecret;
            if (environmentId !== undefined) localVarQueryParameter["environmentId"] = environmentId;
            if (noTracking !== undefined) localVarQueryParameter["noTracking"] = noTracking;
            if (useDraftContent !== undefined) localVarQueryParameter["useDraftContent"] = useDraftContent;
            localVarHeaderParameter["Content-Type"] = "application/json-patch+json";
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = true;
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(body || {}) : body || "";
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
         *
         * @param {{ [key: string]: any; }} [body]
         * @param {string} [applicationId]
         * @param {string} [applicationSecret]
         * @param {string} [environmentId]
         * @param {boolean} [noTracking]
         * @param {boolean} [useDraftContent]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */ handleYesRequest (body, applicationId, applicationSecret, environmentId, noTracking, useDraftContent, options = {}) {
            const localVarPath = `/api/Bixby/HandleRequest/Yes`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({
                method: "POST"
            }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === "function" ? configuration.apiKey("Authorization") : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            // authentication X-Api-Key required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === "function" ? configuration.apiKey("X-Api-Key") : configuration.apiKey;
                localVarHeaderParameter["X-Api-Key"] = localVarApiKeyValue;
            }
            if (applicationId !== undefined) localVarQueryParameter["applicationId"] = applicationId;
            if (applicationSecret !== undefined) localVarQueryParameter["applicationSecret"] = applicationSecret;
            if (environmentId !== undefined) localVarQueryParameter["environmentId"] = environmentId;
            if (noTracking !== undefined) localVarQueryParameter["noTracking"] = noTracking;
            if (useDraftContent !== undefined) localVarQueryParameter["useDraftContent"] = useDraftContent;
            localVarHeaderParameter["Content-Type"] = "application/json-patch+json";
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = true;
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(body || {}) : body || "";
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions
            };
        }
    };
};
/**
 * BixbyApi - functional programming interface
 * @export
 */ exports.BixbyApiFp = function(configuration) {
    return {
        /**
         *
         * @param {string} actionName
         * @param {{ [key: string]: any; }} [body]
         * @param {string} [applicationId]
         * @param {string} [applicationSecret]
         * @param {string} [environmentId]
         * @param {boolean} [noTracking]
         * @param {boolean} [useDraftContent]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */ handleCustomRequest (actionName, body, applicationId, applicationSecret, environmentId, noTracking, useDraftContent, options) {
            const localVarFetchArgs = exports.BixbyApiFetchParamCreator(configuration).handleCustomRequest(actionName, body, applicationId, applicationSecret, environmentId, noTracking, useDraftContent, options);
            return (fetch = portableFetch, basePath = BASE_PATH)=>{
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response)=>{
                    if (response.status >= 200 && response.status < 300) return response.json();
                    else throw response;
                });
            };
        },
        /**
         *
         * @param {{ [key: string]: any; }} [body]
         * @param {string} [applicationId]
         * @param {string} [applicationSecret]
         * @param {string} [environmentId]
         * @param {boolean} [noTracking]
         * @param {boolean} [useDraftContent]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */ handleDynamicRequest (body, applicationId, applicationSecret, environmentId, noTracking, useDraftContent, options) {
            const localVarFetchArgs = exports.BixbyApiFetchParamCreator(configuration).handleDynamicRequest(body, applicationId, applicationSecret, environmentId, noTracking, useDraftContent, options);
            return (fetch = portableFetch, basePath = BASE_PATH)=>{
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response)=>{
                    if (response.status >= 200 && response.status < 300) return response.json();
                    else throw response;
                });
            };
        },
        /**
         *
         * @param {{ [key: string]: any; }} [body]
         * @param {string} [applicationId]
         * @param {string} [applicationSecret]
         * @param {string} [environmentId]
         * @param {boolean} [noTracking]
         * @param {boolean} [useDraftContent]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */ handleGeneralQuestionRequest (body, applicationId, applicationSecret, environmentId, noTracking, useDraftContent, options) {
            const localVarFetchArgs = exports.BixbyApiFetchParamCreator(configuration).handleGeneralQuestionRequest(body, applicationId, applicationSecret, environmentId, noTracking, useDraftContent, options);
            return (fetch = portableFetch, basePath = BASE_PATH)=>{
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response)=>{
                    if (response.status >= 200 && response.status < 300) return response.json();
                    else throw response;
                });
            };
        },
        /**
         *
         * @param {{ [key: string]: any; }} [body]
         * @param {string} [applicationId]
         * @param {string} [applicationSecret]
         * @param {string} [environmentId]
         * @param {boolean} [noTracking]
         * @param {boolean} [useDraftContent]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */ handleGoToStepRequest (body, applicationId, applicationSecret, environmentId, noTracking, useDraftContent, options) {
            const localVarFetchArgs = exports.BixbyApiFetchParamCreator(configuration).handleGoToStepRequest(body, applicationId, applicationSecret, environmentId, noTracking, useDraftContent, options);
            return (fetch = portableFetch, basePath = BASE_PATH)=>{
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response)=>{
                    if (response.status >= 200 && response.status < 300) return response.json();
                    else throw response;
                });
            };
        },
        /**
         *
         * @param {{ [key: string]: any; }} [body]
         * @param {string} [applicationId]
         * @param {string} [applicationSecret]
         * @param {string} [environmentId]
         * @param {boolean} [noTracking]
         * @param {boolean} [useDraftContent]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */ handleHelpRequest (body, applicationId, applicationSecret, environmentId, noTracking, useDraftContent, options) {
            const localVarFetchArgs = exports.BixbyApiFetchParamCreator(configuration).handleHelpRequest(body, applicationId, applicationSecret, environmentId, noTracking, useDraftContent, options);
            return (fetch = portableFetch, basePath = BASE_PATH)=>{
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response)=>{
                    if (response.status >= 200 && response.status < 300) return response.json();
                    else throw response;
                });
            };
        },
        /**
         *
         * @param {{ [key: string]: any; }} [body]
         * @param {string} [applicationId]
         * @param {string} [applicationSecret]
         * @param {string} [environmentId]
         * @param {boolean} [noTracking]
         * @param {boolean} [useDraftContent]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */ handleLatestMessageRequest (body, applicationId, applicationSecret, environmentId, noTracking, useDraftContent, options) {
            const localVarFetchArgs = exports.BixbyApiFetchParamCreator(configuration).handleLatestMessageRequest(body, applicationId, applicationSecret, environmentId, noTracking, useDraftContent, options);
            return (fetch = portableFetch, basePath = BASE_PATH)=>{
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response)=>{
                    if (response.status >= 200 && response.status < 300) return response.json();
                    else throw response;
                });
            };
        },
        /**
         *
         * @param {{ [key: string]: any; }} [body]
         * @param {string} [applicationId]
         * @param {string} [applicationSecret]
         * @param {string} [environmentId]
         * @param {boolean} [noTracking]
         * @param {boolean} [useDraftContent]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */ handleListItemSelectRequest (body, applicationId, applicationSecret, environmentId, noTracking, useDraftContent, options) {
            const localVarFetchArgs = exports.BixbyApiFetchParamCreator(configuration).handleListItemSelectRequest(body, applicationId, applicationSecret, environmentId, noTracking, useDraftContent, options);
            return (fetch = portableFetch, basePath = BASE_PATH)=>{
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response)=>{
                    if (response.status >= 200 && response.status < 300) return response.json();
                    else throw response;
                });
            };
        },
        /**
         *
         * @param {{ [key: string]: any; }} [body]
         * @param {string} [applicationId]
         * @param {string} [applicationSecret]
         * @param {string} [environmentId]
         * @param {boolean} [noTracking]
         * @param {boolean} [useDraftContent]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */ handleMoreRequest (body, applicationId, applicationSecret, environmentId, noTracking, useDraftContent, options) {
            const localVarFetchArgs = exports.BixbyApiFetchParamCreator(configuration).handleMoreRequest(body, applicationId, applicationSecret, environmentId, noTracking, useDraftContent, options);
            return (fetch = portableFetch, basePath = BASE_PATH)=>{
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response)=>{
                    if (response.status >= 200 && response.status < 300) return response.json();
                    else throw response;
                });
            };
        },
        /**
         *
         * @param {{ [key: string]: any; }} [body]
         * @param {string} [applicationId]
         * @param {string} [applicationSecret]
         * @param {string} [environmentId]
         * @param {boolean} [noTracking]
         * @param {boolean} [useDraftContent]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */ handleNextRequest (body, applicationId, applicationSecret, environmentId, noTracking, useDraftContent, options) {
            const localVarFetchArgs = exports.BixbyApiFetchParamCreator(configuration).handleNextRequest(body, applicationId, applicationSecret, environmentId, noTracking, useDraftContent, options);
            return (fetch = portableFetch, basePath = BASE_PATH)=>{
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response)=>{
                    if (response.status >= 200 && response.status < 300) return response.json();
                    else throw response;
                });
            };
        },
        /**
         *
         * @param {{ [key: string]: any; }} [body]
         * @param {string} [applicationId]
         * @param {string} [applicationSecret]
         * @param {string} [environmentId]
         * @param {boolean} [noTracking]
         * @param {boolean} [useDraftContent]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */ handleNoRequest (body, applicationId, applicationSecret, environmentId, noTracking, useDraftContent, options) {
            const localVarFetchArgs = exports.BixbyApiFetchParamCreator(configuration).handleNoRequest(body, applicationId, applicationSecret, environmentId, noTracking, useDraftContent, options);
            return (fetch = portableFetch, basePath = BASE_PATH)=>{
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response)=>{
                    if (response.status >= 200 && response.status < 300) return response.json();
                    else throw response;
                });
            };
        },
        /**
         *
         * @param {{ [key: string]: any; }} [body]
         * @param {string} [applicationId]
         * @param {string} [applicationSecret]
         * @param {string} [environmentId]
         * @param {boolean} [noTracking]
         * @param {boolean} [useDraftContent]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */ handleNumberRequest (body, applicationId, applicationSecret, environmentId, noTracking, useDraftContent, options) {
            const localVarFetchArgs = exports.BixbyApiFetchParamCreator(configuration).handleNumberRequest(body, applicationId, applicationSecret, environmentId, noTracking, useDraftContent, options);
            return (fetch = portableFetch, basePath = BASE_PATH)=>{
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response)=>{
                    if (response.status >= 200 && response.status < 300) return response.json();
                    else throw response;
                });
            };
        },
        /**
         *
         * @param {{ [key: string]: any; }} [body]
         * @param {string} [applicationId]
         * @param {string} [applicationSecret]
         * @param {string} [environmentId]
         * @param {boolean} [noTracking]
         * @param {boolean} [useDraftContent]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */ handlePrevisousRequest (body, applicationId, applicationSecret, environmentId, noTracking, useDraftContent, options) {
            const localVarFetchArgs = exports.BixbyApiFetchParamCreator(configuration).handlePrevisousRequest(body, applicationId, applicationSecret, environmentId, noTracking, useDraftContent, options);
            return (fetch = portableFetch, basePath = BASE_PATH)=>{
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response)=>{
                    if (response.status >= 200 && response.status < 300) return response.json();
                    else throw response;
                });
            };
        },
        /**
         *
         * @param {{ [key: string]: any; }} [body]
         * @param {string} [applicationId]
         * @param {string} [applicationSecret]
         * @param {string} [environmentId]
         * @param {boolean} [noTracking]
         * @param {boolean} [useDraftContent]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */ handleRecipeDetailsRequest (body, applicationId, applicationSecret, environmentId, noTracking, useDraftContent, options) {
            const localVarFetchArgs = exports.BixbyApiFetchParamCreator(configuration).handleRecipeDetailsRequest(body, applicationId, applicationSecret, environmentId, noTracking, useDraftContent, options);
            return (fetch = portableFetch, basePath = BASE_PATH)=>{
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response)=>{
                    if (response.status >= 200 && response.status < 300) return response.json();
                    else throw response;
                });
            };
        },
        /**
         *
         * @param {{ [key: string]: any; }} [body]
         * @param {string} [applicationId]
         * @param {string} [applicationSecret]
         * @param {string} [environmentId]
         * @param {boolean} [noTracking]
         * @param {boolean} [useDraftContent]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */ handleStartOverRequest (body, applicationId, applicationSecret, environmentId, noTracking, useDraftContent, options) {
            const localVarFetchArgs = exports.BixbyApiFetchParamCreator(configuration).handleStartOverRequest(body, applicationId, applicationSecret, environmentId, noTracking, useDraftContent, options);
            return (fetch = portableFetch, basePath = BASE_PATH)=>{
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response)=>{
                    if (response.status >= 200 && response.status < 300) return response.json();
                    else throw response;
                });
            };
        },
        /**
         *
         * @param {{ [key: string]: any; }} [body]
         * @param {string} [applicationId]
         * @param {string} [applicationSecret]
         * @param {string} [environmentId]
         * @param {boolean} [noTracking]
         * @param {boolean} [useDraftContent]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */ handleStartRequest (body, applicationId, applicationSecret, environmentId, noTracking, useDraftContent, options) {
            const localVarFetchArgs = exports.BixbyApiFetchParamCreator(configuration).handleStartRequest(body, applicationId, applicationSecret, environmentId, noTracking, useDraftContent, options);
            return (fetch = portableFetch, basePath = BASE_PATH)=>{
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response)=>{
                    if (response.status >= 200 && response.status < 300) return response.json();
                    else throw response;
                });
            };
        },
        /**
         *
         * @param {{ [key: string]: any; }} [body]
         * @param {string} [applicationId]
         * @param {string} [applicationSecret]
         * @param {string} [environmentId]
         * @param {boolean} [noTracking]
         * @param {boolean} [useDraftContent]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */ handleStopRequest (body, applicationId, applicationSecret, environmentId, noTracking, useDraftContent, options) {
            const localVarFetchArgs = exports.BixbyApiFetchParamCreator(configuration).handleStopRequest(body, applicationId, applicationSecret, environmentId, noTracking, useDraftContent, options);
            return (fetch = portableFetch, basePath = BASE_PATH)=>{
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response)=>{
                    if (response.status >= 200 && response.status < 300) return response.json();
                    else throw response;
                });
            };
        },
        /**
         *
         * @param {{ [key: string]: any; }} [body]
         * @param {string} [applicationId]
         * @param {string} [applicationSecret]
         * @param {string} [environmentId]
         * @param {boolean} [noTracking]
         * @param {boolean} [useDraftContent]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */ handleWelcomeRequest (body, applicationId, applicationSecret, environmentId, noTracking, useDraftContent, options) {
            const localVarFetchArgs = exports.BixbyApiFetchParamCreator(configuration).handleWelcomeRequest(body, applicationId, applicationSecret, environmentId, noTracking, useDraftContent, options);
            return (fetch = portableFetch, basePath = BASE_PATH)=>{
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response)=>{
                    if (response.status >= 200 && response.status < 300) return response.json();
                    else throw response;
                });
            };
        },
        /**
         *
         * @param {{ [key: string]: any; }} [body]
         * @param {string} [applicationId]
         * @param {string} [applicationSecret]
         * @param {string} [environmentId]
         * @param {boolean} [noTracking]
         * @param {boolean} [useDraftContent]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */ handleYesRequest (body, applicationId, applicationSecret, environmentId, noTracking, useDraftContent, options) {
            const localVarFetchArgs = exports.BixbyApiFetchParamCreator(configuration).handleYesRequest(body, applicationId, applicationSecret, environmentId, noTracking, useDraftContent, options);
            return (fetch = portableFetch, basePath = BASE_PATH)=>{
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response)=>{
                    if (response.status >= 200 && response.status < 300) return response.json();
                    else throw response;
                });
            };
        }
    };
};
/**
 * BixbyApi - factory interface
 * @export
 */ exports.BixbyApiFactory = function(configuration, fetch, basePath) {
    return {
        /**
         *
         * @param {string} actionName
         * @param {{ [key: string]: any; }} [body]
         * @param {string} [applicationId]
         * @param {string} [applicationSecret]
         * @param {string} [environmentId]
         * @param {boolean} [noTracking]
         * @param {boolean} [useDraftContent]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */ handleCustomRequest (actionName, body, applicationId, applicationSecret, environmentId, noTracking, useDraftContent, options) {
            return exports.BixbyApiFp(configuration).handleCustomRequest(actionName, body, applicationId, applicationSecret, environmentId, noTracking, useDraftContent, options)(fetch, basePath);
        },
        /**
         *
         * @param {{ [key: string]: any; }} [body]
         * @param {string} [applicationId]
         * @param {string} [applicationSecret]
         * @param {string} [environmentId]
         * @param {boolean} [noTracking]
         * @param {boolean} [useDraftContent]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */ handleDynamicRequest (body, applicationId, applicationSecret, environmentId, noTracking, useDraftContent, options) {
            return exports.BixbyApiFp(configuration).handleDynamicRequest(body, applicationId, applicationSecret, environmentId, noTracking, useDraftContent, options)(fetch, basePath);
        },
        /**
         *
         * @param {{ [key: string]: any; }} [body]
         * @param {string} [applicationId]
         * @param {string} [applicationSecret]
         * @param {string} [environmentId]
         * @param {boolean} [noTracking]
         * @param {boolean} [useDraftContent]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */ handleGeneralQuestionRequest (body, applicationId, applicationSecret, environmentId, noTracking, useDraftContent, options) {
            return exports.BixbyApiFp(configuration).handleGeneralQuestionRequest(body, applicationId, applicationSecret, environmentId, noTracking, useDraftContent, options)(fetch, basePath);
        },
        /**
         *
         * @param {{ [key: string]: any; }} [body]
         * @param {string} [applicationId]
         * @param {string} [applicationSecret]
         * @param {string} [environmentId]
         * @param {boolean} [noTracking]
         * @param {boolean} [useDraftContent]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */ handleGoToStepRequest (body, applicationId, applicationSecret, environmentId, noTracking, useDraftContent, options) {
            return exports.BixbyApiFp(configuration).handleGoToStepRequest(body, applicationId, applicationSecret, environmentId, noTracking, useDraftContent, options)(fetch, basePath);
        },
        /**
         *
         * @param {{ [key: string]: any; }} [body]
         * @param {string} [applicationId]
         * @param {string} [applicationSecret]
         * @param {string} [environmentId]
         * @param {boolean} [noTracking]
         * @param {boolean} [useDraftContent]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */ handleHelpRequest (body, applicationId, applicationSecret, environmentId, noTracking, useDraftContent, options) {
            return exports.BixbyApiFp(configuration).handleHelpRequest(body, applicationId, applicationSecret, environmentId, noTracking, useDraftContent, options)(fetch, basePath);
        },
        /**
         *
         * @param {{ [key: string]: any; }} [body]
         * @param {string} [applicationId]
         * @param {string} [applicationSecret]
         * @param {string} [environmentId]
         * @param {boolean} [noTracking]
         * @param {boolean} [useDraftContent]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */ handleLatestMessageRequest (body, applicationId, applicationSecret, environmentId, noTracking, useDraftContent, options) {
            return exports.BixbyApiFp(configuration).handleLatestMessageRequest(body, applicationId, applicationSecret, environmentId, noTracking, useDraftContent, options)(fetch, basePath);
        },
        /**
         *
         * @param {{ [key: string]: any; }} [body]
         * @param {string} [applicationId]
         * @param {string} [applicationSecret]
         * @param {string} [environmentId]
         * @param {boolean} [noTracking]
         * @param {boolean} [useDraftContent]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */ handleListItemSelectRequest (body, applicationId, applicationSecret, environmentId, noTracking, useDraftContent, options) {
            return exports.BixbyApiFp(configuration).handleListItemSelectRequest(body, applicationId, applicationSecret, environmentId, noTracking, useDraftContent, options)(fetch, basePath);
        },
        /**
         *
         * @param {{ [key: string]: any; }} [body]
         * @param {string} [applicationId]
         * @param {string} [applicationSecret]
         * @param {string} [environmentId]
         * @param {boolean} [noTracking]
         * @param {boolean} [useDraftContent]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */ handleMoreRequest (body, applicationId, applicationSecret, environmentId, noTracking, useDraftContent, options) {
            return exports.BixbyApiFp(configuration).handleMoreRequest(body, applicationId, applicationSecret, environmentId, noTracking, useDraftContent, options)(fetch, basePath);
        },
        /**
         *
         * @param {{ [key: string]: any; }} [body]
         * @param {string} [applicationId]
         * @param {string} [applicationSecret]
         * @param {string} [environmentId]
         * @param {boolean} [noTracking]
         * @param {boolean} [useDraftContent]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */ handleNextRequest (body, applicationId, applicationSecret, environmentId, noTracking, useDraftContent, options) {
            return exports.BixbyApiFp(configuration).handleNextRequest(body, applicationId, applicationSecret, environmentId, noTracking, useDraftContent, options)(fetch, basePath);
        },
        /**
         *
         * @param {{ [key: string]: any; }} [body]
         * @param {string} [applicationId]
         * @param {string} [applicationSecret]
         * @param {string} [environmentId]
         * @param {boolean} [noTracking]
         * @param {boolean} [useDraftContent]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */ handleNoRequest (body, applicationId, applicationSecret, environmentId, noTracking, useDraftContent, options) {
            return exports.BixbyApiFp(configuration).handleNoRequest(body, applicationId, applicationSecret, environmentId, noTracking, useDraftContent, options)(fetch, basePath);
        },
        /**
         *
         * @param {{ [key: string]: any; }} [body]
         * @param {string} [applicationId]
         * @param {string} [applicationSecret]
         * @param {string} [environmentId]
         * @param {boolean} [noTracking]
         * @param {boolean} [useDraftContent]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */ handleNumberRequest (body, applicationId, applicationSecret, environmentId, noTracking, useDraftContent, options) {
            return exports.BixbyApiFp(configuration).handleNumberRequest(body, applicationId, applicationSecret, environmentId, noTracking, useDraftContent, options)(fetch, basePath);
        },
        /**
         *
         * @param {{ [key: string]: any; }} [body]
         * @param {string} [applicationId]
         * @param {string} [applicationSecret]
         * @param {string} [environmentId]
         * @param {boolean} [noTracking]
         * @param {boolean} [useDraftContent]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */ handlePrevisousRequest (body, applicationId, applicationSecret, environmentId, noTracking, useDraftContent, options) {
            return exports.BixbyApiFp(configuration).handlePrevisousRequest(body, applicationId, applicationSecret, environmentId, noTracking, useDraftContent, options)(fetch, basePath);
        },
        /**
         *
         * @param {{ [key: string]: any; }} [body]
         * @param {string} [applicationId]
         * @param {string} [applicationSecret]
         * @param {string} [environmentId]
         * @param {boolean} [noTracking]
         * @param {boolean} [useDraftContent]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */ handleRecipeDetailsRequest (body, applicationId, applicationSecret, environmentId, noTracking, useDraftContent, options) {
            return exports.BixbyApiFp(configuration).handleRecipeDetailsRequest(body, applicationId, applicationSecret, environmentId, noTracking, useDraftContent, options)(fetch, basePath);
        },
        /**
         *
         * @param {{ [key: string]: any; }} [body]
         * @param {string} [applicationId]
         * @param {string} [applicationSecret]
         * @param {string} [environmentId]
         * @param {boolean} [noTracking]
         * @param {boolean} [useDraftContent]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */ handleStartOverRequest (body, applicationId, applicationSecret, environmentId, noTracking, useDraftContent, options) {
            return exports.BixbyApiFp(configuration).handleStartOverRequest(body, applicationId, applicationSecret, environmentId, noTracking, useDraftContent, options)(fetch, basePath);
        },
        /**
         *
         * @param {{ [key: string]: any; }} [body]
         * @param {string} [applicationId]
         * @param {string} [applicationSecret]
         * @param {string} [environmentId]
         * @param {boolean} [noTracking]
         * @param {boolean} [useDraftContent]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */ handleStartRequest (body, applicationId, applicationSecret, environmentId, noTracking, useDraftContent, options) {
            return exports.BixbyApiFp(configuration).handleStartRequest(body, applicationId, applicationSecret, environmentId, noTracking, useDraftContent, options)(fetch, basePath);
        },
        /**
         *
         * @param {{ [key: string]: any; }} [body]
         * @param {string} [applicationId]
         * @param {string} [applicationSecret]
         * @param {string} [environmentId]
         * @param {boolean} [noTracking]
         * @param {boolean} [useDraftContent]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */ handleStopRequest (body, applicationId, applicationSecret, environmentId, noTracking, useDraftContent, options) {
            return exports.BixbyApiFp(configuration).handleStopRequest(body, applicationId, applicationSecret, environmentId, noTracking, useDraftContent, options)(fetch, basePath);
        },
        /**
         *
         * @param {{ [key: string]: any; }} [body]
         * @param {string} [applicationId]
         * @param {string} [applicationSecret]
         * @param {string} [environmentId]
         * @param {boolean} [noTracking]
         * @param {boolean} [useDraftContent]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */ handleWelcomeRequest (body, applicationId, applicationSecret, environmentId, noTracking, useDraftContent, options) {
            return exports.BixbyApiFp(configuration).handleWelcomeRequest(body, applicationId, applicationSecret, environmentId, noTracking, useDraftContent, options)(fetch, basePath);
        },
        /**
         *
         * @param {{ [key: string]: any; }} [body]
         * @param {string} [applicationId]
         * @param {string} [applicationSecret]
         * @param {string} [environmentId]
         * @param {boolean} [noTracking]
         * @param {boolean} [useDraftContent]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */ handleYesRequest (body, applicationId, applicationSecret, environmentId, noTracking, useDraftContent, options) {
            return exports.BixbyApiFp(configuration).handleYesRequest(body, applicationId, applicationSecret, environmentId, noTracking, useDraftContent, options)(fetch, basePath);
        }
    };
};
/**
 * BixbyApi - object-oriented interface
 * @export
 * @class BixbyApi
 * @extends {BaseAPI}
 */ class BixbyApi extends BaseAPI {
    /**
     *
     * @param {string} actionName
     * @param {{ [key: string]: any; }} [body]
     * @param {string} [applicationId]
     * @param {string} [applicationSecret]
     * @param {string} [environmentId]
     * @param {boolean} [noTracking]
     * @param {boolean} [useDraftContent]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BixbyApi
     */ handleCustomRequest(actionName, body, applicationId, applicationSecret, environmentId, noTracking, useDraftContent, options) {
        return exports.BixbyApiFp(this.configuration).handleCustomRequest(actionName, body, applicationId, applicationSecret, environmentId, noTracking, useDraftContent, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @param {{ [key: string]: any; }} [body]
     * @param {string} [applicationId]
     * @param {string} [applicationSecret]
     * @param {string} [environmentId]
     * @param {boolean} [noTracking]
     * @param {boolean} [useDraftContent]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BixbyApi
     */ handleDynamicRequest(body, applicationId, applicationSecret, environmentId, noTracking, useDraftContent, options) {
        return exports.BixbyApiFp(this.configuration).handleDynamicRequest(body, applicationId, applicationSecret, environmentId, noTracking, useDraftContent, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @param {{ [key: string]: any; }} [body]
     * @param {string} [applicationId]
     * @param {string} [applicationSecret]
     * @param {string} [environmentId]
     * @param {boolean} [noTracking]
     * @param {boolean} [useDraftContent]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BixbyApi
     */ handleGeneralQuestionRequest(body, applicationId, applicationSecret, environmentId, noTracking, useDraftContent, options) {
        return exports.BixbyApiFp(this.configuration).handleGeneralQuestionRequest(body, applicationId, applicationSecret, environmentId, noTracking, useDraftContent, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @param {{ [key: string]: any; }} [body]
     * @param {string} [applicationId]
     * @param {string} [applicationSecret]
     * @param {string} [environmentId]
     * @param {boolean} [noTracking]
     * @param {boolean} [useDraftContent]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BixbyApi
     */ handleGoToStepRequest(body, applicationId, applicationSecret, environmentId, noTracking, useDraftContent, options) {
        return exports.BixbyApiFp(this.configuration).handleGoToStepRequest(body, applicationId, applicationSecret, environmentId, noTracking, useDraftContent, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @param {{ [key: string]: any; }} [body]
     * @param {string} [applicationId]
     * @param {string} [applicationSecret]
     * @param {string} [environmentId]
     * @param {boolean} [noTracking]
     * @param {boolean} [useDraftContent]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BixbyApi
     */ handleHelpRequest(body, applicationId, applicationSecret, environmentId, noTracking, useDraftContent, options) {
        return exports.BixbyApiFp(this.configuration).handleHelpRequest(body, applicationId, applicationSecret, environmentId, noTracking, useDraftContent, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @param {{ [key: string]: any; }} [body]
     * @param {string} [applicationId]
     * @param {string} [applicationSecret]
     * @param {string} [environmentId]
     * @param {boolean} [noTracking]
     * @param {boolean} [useDraftContent]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BixbyApi
     */ handleLatestMessageRequest(body, applicationId, applicationSecret, environmentId, noTracking, useDraftContent, options) {
        return exports.BixbyApiFp(this.configuration).handleLatestMessageRequest(body, applicationId, applicationSecret, environmentId, noTracking, useDraftContent, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @param {{ [key: string]: any; }} [body]
     * @param {string} [applicationId]
     * @param {string} [applicationSecret]
     * @param {string} [environmentId]
     * @param {boolean} [noTracking]
     * @param {boolean} [useDraftContent]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BixbyApi
     */ handleListItemSelectRequest(body, applicationId, applicationSecret, environmentId, noTracking, useDraftContent, options) {
        return exports.BixbyApiFp(this.configuration).handleListItemSelectRequest(body, applicationId, applicationSecret, environmentId, noTracking, useDraftContent, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @param {{ [key: string]: any; }} [body]
     * @param {string} [applicationId]
     * @param {string} [applicationSecret]
     * @param {string} [environmentId]
     * @param {boolean} [noTracking]
     * @param {boolean} [useDraftContent]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BixbyApi
     */ handleMoreRequest(body, applicationId, applicationSecret, environmentId, noTracking, useDraftContent, options) {
        return exports.BixbyApiFp(this.configuration).handleMoreRequest(body, applicationId, applicationSecret, environmentId, noTracking, useDraftContent, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @param {{ [key: string]: any; }} [body]
     * @param {string} [applicationId]
     * @param {string} [applicationSecret]
     * @param {string} [environmentId]
     * @param {boolean} [noTracking]
     * @param {boolean} [useDraftContent]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BixbyApi
     */ handleNextRequest(body, applicationId, applicationSecret, environmentId, noTracking, useDraftContent, options) {
        return exports.BixbyApiFp(this.configuration).handleNextRequest(body, applicationId, applicationSecret, environmentId, noTracking, useDraftContent, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @param {{ [key: string]: any; }} [body]
     * @param {string} [applicationId]
     * @param {string} [applicationSecret]
     * @param {string} [environmentId]
     * @param {boolean} [noTracking]
     * @param {boolean} [useDraftContent]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BixbyApi
     */ handleNoRequest(body, applicationId, applicationSecret, environmentId, noTracking, useDraftContent, options) {
        return exports.BixbyApiFp(this.configuration).handleNoRequest(body, applicationId, applicationSecret, environmentId, noTracking, useDraftContent, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @param {{ [key: string]: any; }} [body]
     * @param {string} [applicationId]
     * @param {string} [applicationSecret]
     * @param {string} [environmentId]
     * @param {boolean} [noTracking]
     * @param {boolean} [useDraftContent]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BixbyApi
     */ handleNumberRequest(body, applicationId, applicationSecret, environmentId, noTracking, useDraftContent, options) {
        return exports.BixbyApiFp(this.configuration).handleNumberRequest(body, applicationId, applicationSecret, environmentId, noTracking, useDraftContent, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @param {{ [key: string]: any; }} [body]
     * @param {string} [applicationId]
     * @param {string} [applicationSecret]
     * @param {string} [environmentId]
     * @param {boolean} [noTracking]
     * @param {boolean} [useDraftContent]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BixbyApi
     */ handlePrevisousRequest(body, applicationId, applicationSecret, environmentId, noTracking, useDraftContent, options) {
        return exports.BixbyApiFp(this.configuration).handlePrevisousRequest(body, applicationId, applicationSecret, environmentId, noTracking, useDraftContent, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @param {{ [key: string]: any; }} [body]
     * @param {string} [applicationId]
     * @param {string} [applicationSecret]
     * @param {string} [environmentId]
     * @param {boolean} [noTracking]
     * @param {boolean} [useDraftContent]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BixbyApi
     */ handleRecipeDetailsRequest(body, applicationId, applicationSecret, environmentId, noTracking, useDraftContent, options) {
        return exports.BixbyApiFp(this.configuration).handleRecipeDetailsRequest(body, applicationId, applicationSecret, environmentId, noTracking, useDraftContent, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @param {{ [key: string]: any; }} [body]
     * @param {string} [applicationId]
     * @param {string} [applicationSecret]
     * @param {string} [environmentId]
     * @param {boolean} [noTracking]
     * @param {boolean} [useDraftContent]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BixbyApi
     */ handleStartOverRequest(body, applicationId, applicationSecret, environmentId, noTracking, useDraftContent, options) {
        return exports.BixbyApiFp(this.configuration).handleStartOverRequest(body, applicationId, applicationSecret, environmentId, noTracking, useDraftContent, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @param {{ [key: string]: any; }} [body]
     * @param {string} [applicationId]
     * @param {string} [applicationSecret]
     * @param {string} [environmentId]
     * @param {boolean} [noTracking]
     * @param {boolean} [useDraftContent]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BixbyApi
     */ handleStartRequest(body, applicationId, applicationSecret, environmentId, noTracking, useDraftContent, options) {
        return exports.BixbyApiFp(this.configuration).handleStartRequest(body, applicationId, applicationSecret, environmentId, noTracking, useDraftContent, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @param {{ [key: string]: any; }} [body]
     * @param {string} [applicationId]
     * @param {string} [applicationSecret]
     * @param {string} [environmentId]
     * @param {boolean} [noTracking]
     * @param {boolean} [useDraftContent]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BixbyApi
     */ handleStopRequest(body, applicationId, applicationSecret, environmentId, noTracking, useDraftContent, options) {
        return exports.BixbyApiFp(this.configuration).handleStopRequest(body, applicationId, applicationSecret, environmentId, noTracking, useDraftContent, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @param {{ [key: string]: any; }} [body]
     * @param {string} [applicationId]
     * @param {string} [applicationSecret]
     * @param {string} [environmentId]
     * @param {boolean} [noTracking]
     * @param {boolean} [useDraftContent]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BixbyApi
     */ handleWelcomeRequest(body, applicationId, applicationSecret, environmentId, noTracking, useDraftContent, options) {
        return exports.BixbyApiFp(this.configuration).handleWelcomeRequest(body, applicationId, applicationSecret, environmentId, noTracking, useDraftContent, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @param {{ [key: string]: any; }} [body]
     * @param {string} [applicationId]
     * @param {string} [applicationSecret]
     * @param {string} [environmentId]
     * @param {boolean} [noTracking]
     * @param {boolean} [useDraftContent]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BixbyApi
     */ handleYesRequest(body, applicationId, applicationSecret, environmentId, noTracking, useDraftContent, options) {
        return exports.BixbyApiFp(this.configuration).handleYesRequest(body, applicationId, applicationSecret, environmentId, noTracking, useDraftContent, options)(this.fetch, this.basePath);
    }
}
exports.BixbyApi = BixbyApi;
/**
 * BotServiceApi - fetch parameter creator
 * @export
 */ exports.BotServiceApiFetchParamCreator = function(configuration) {
    return {
        /**
         *
         * @param {{ [key: string]: any; }} [body]
         * @param {string} [applicationId]
         * @param {string} [applicationSecret]
         * @param {string} [environmentId]
         * @param {boolean} [noTracking]
         * @param {boolean} [useDraftContent]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */ handleActivityRequest (body, applicationId, applicationSecret, environmentId, noTracking, useDraftContent, options = {}) {
            const localVarPath = `/api/BotService/HandleActivityRequest`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({
                method: "POST"
            }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === "function" ? configuration.apiKey("Authorization") : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            // authentication X-Api-Key required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === "function" ? configuration.apiKey("X-Api-Key") : configuration.apiKey;
                localVarHeaderParameter["X-Api-Key"] = localVarApiKeyValue;
            }
            if (applicationId !== undefined) localVarQueryParameter["applicationId"] = applicationId;
            if (applicationSecret !== undefined) localVarQueryParameter["applicationSecret"] = applicationSecret;
            if (environmentId !== undefined) localVarQueryParameter["environmentId"] = environmentId;
            if (noTracking !== undefined) localVarQueryParameter["noTracking"] = noTracking;
            if (useDraftContent !== undefined) localVarQueryParameter["useDraftContent"] = useDraftContent;
            localVarHeaderParameter["Content-Type"] = "application/json-patch+json";
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = true;
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(body || {}) : body || "";
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
         *
         * @param {string} [applicationId]
         * @param {string} [applicationSecret]
         * @param {string} [nluTool]
         * @param {string} [environmentId]
         * @param {boolean} [noTracking]
         * @param {boolean} [useDraftContent]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */ handleRequest (applicationId, applicationSecret, nluTool, environmentId, noTracking, useDraftContent, options = {}) {
            const localVarPath = `/api/BotService/HandleRequest`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({
                method: "POST"
            }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === "function" ? configuration.apiKey("Authorization") : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            // authentication X-Api-Key required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === "function" ? configuration.apiKey("X-Api-Key") : configuration.apiKey;
                localVarHeaderParameter["X-Api-Key"] = localVarApiKeyValue;
            }
            if (applicationId !== undefined) localVarQueryParameter["applicationId"] = applicationId;
            if (applicationSecret !== undefined) localVarQueryParameter["applicationSecret"] = applicationSecret;
            if (nluTool !== undefined) localVarQueryParameter["nluTool"] = nluTool;
            if (environmentId !== undefined) localVarQueryParameter["environmentId"] = environmentId;
            if (noTracking !== undefined) localVarQueryParameter["noTracking"] = noTracking;
            if (useDraftContent !== undefined) localVarQueryParameter["useDraftContent"] = useDraftContent;
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions
            };
        }
    };
};
/**
 * BotServiceApi - functional programming interface
 * @export
 */ exports.BotServiceApiFp = function(configuration) {
    return {
        /**
         *
         * @param {{ [key: string]: any; }} [body]
         * @param {string} [applicationId]
         * @param {string} [applicationSecret]
         * @param {string} [environmentId]
         * @param {boolean} [noTracking]
         * @param {boolean} [useDraftContent]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */ handleActivityRequest (body, applicationId, applicationSecret, environmentId, noTracking, useDraftContent, options) {
            const localVarFetchArgs = exports.BotServiceApiFetchParamCreator(configuration).handleActivityRequest(body, applicationId, applicationSecret, environmentId, noTracking, useDraftContent, options);
            return (fetch = portableFetch, basePath = BASE_PATH)=>{
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response)=>{
                    if (response.status >= 200 && response.status < 300) return response;
                    else throw response;
                });
            };
        },
        /**
         *
         * @param {string} [applicationId]
         * @param {string} [applicationSecret]
         * @param {string} [nluTool]
         * @param {string} [environmentId]
         * @param {boolean} [noTracking]
         * @param {boolean} [useDraftContent]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */ handleRequest (applicationId, applicationSecret, nluTool, environmentId, noTracking, useDraftContent, options) {
            const localVarFetchArgs = exports.BotServiceApiFetchParamCreator(configuration).handleRequest(applicationId, applicationSecret, nluTool, environmentId, noTracking, useDraftContent, options);
            return (fetch = portableFetch, basePath = BASE_PATH)=>{
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response)=>{
                    if (response.status >= 200 && response.status < 300) return response;
                    else throw response;
                });
            };
        }
    };
};
/**
 * BotServiceApi - factory interface
 * @export
 */ exports.BotServiceApiFactory = function(configuration, fetch, basePath) {
    return {
        /**
         *
         * @param {{ [key: string]: any; }} [body]
         * @param {string} [applicationId]
         * @param {string} [applicationSecret]
         * @param {string} [environmentId]
         * @param {boolean} [noTracking]
         * @param {boolean} [useDraftContent]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */ handleActivityRequest (body, applicationId, applicationSecret, environmentId, noTracking, useDraftContent, options) {
            return exports.BotServiceApiFp(configuration).handleActivityRequest(body, applicationId, applicationSecret, environmentId, noTracking, useDraftContent, options)(fetch, basePath);
        },
        /**
         *
         * @param {string} [applicationId]
         * @param {string} [applicationSecret]
         * @param {string} [nluTool]
         * @param {string} [environmentId]
         * @param {boolean} [noTracking]
         * @param {boolean} [useDraftContent]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */ handleRequest (applicationId, applicationSecret, nluTool, environmentId, noTracking, useDraftContent, options) {
            return exports.BotServiceApiFp(configuration).handleRequest(applicationId, applicationSecret, nluTool, environmentId, noTracking, useDraftContent, options)(fetch, basePath);
        }
    };
};
/**
 * BotServiceApi - object-oriented interface
 * @export
 * @class BotServiceApi
 * @extends {BaseAPI}
 */ class BotServiceApi extends BaseAPI {
    /**
     *
     * @param {{ [key: string]: any; }} [body]
     * @param {string} [applicationId]
     * @param {string} [applicationSecret]
     * @param {string} [environmentId]
     * @param {boolean} [noTracking]
     * @param {boolean} [useDraftContent]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BotServiceApi
     */ handleActivityRequest(body, applicationId, applicationSecret, environmentId, noTracking, useDraftContent, options) {
        return exports.BotServiceApiFp(this.configuration).handleActivityRequest(body, applicationId, applicationSecret, environmentId, noTracking, useDraftContent, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @param {string} [applicationId]
     * @param {string} [applicationSecret]
     * @param {string} [nluTool]
     * @param {string} [environmentId]
     * @param {boolean} [noTracking]
     * @param {boolean} [useDraftContent]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BotServiceApi
     */ handleRequest(applicationId, applicationSecret, nluTool, environmentId, noTracking, useDraftContent, options) {
        return exports.BotServiceApiFp(this.configuration).handleRequest(applicationId, applicationSecret, nluTool, environmentId, noTracking, useDraftContent, options)(this.fetch, this.basePath);
    }
}
exports.BotServiceApi = BotServiceApi;
/**
 * CustomAssistantApi - fetch parameter creator
 * @export
 */ exports.CustomAssistantApiFetchParamCreator = function(configuration) {
    return {
        /**
         *
         * @param {CustomAssistantRequestBody} [body]
         * @param {string} [applicationId]
         * @param {string} [applicationSecret]
         * @param {string} [environmentId]
         * @param {boolean} [noTracking]
         * @param {boolean} [useDraftContent]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */ handleRequest (body, applicationId, applicationSecret, environmentId, noTracking, useDraftContent, options = {}) {
            const localVarPath = `/api/CustomAssistant/HandleRequest`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({
                method: "POST"
            }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === "function" ? configuration.apiKey("Authorization") : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            // authentication X-Api-Key required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === "function" ? configuration.apiKey("X-Api-Key") : configuration.apiKey;
                localVarHeaderParameter["X-Api-Key"] = localVarApiKeyValue;
            }
            if (applicationId !== undefined) localVarQueryParameter["applicationId"] = applicationId;
            if (applicationSecret !== undefined) localVarQueryParameter["applicationSecret"] = applicationSecret;
            if (environmentId !== undefined) localVarQueryParameter["environmentId"] = environmentId;
            if (noTracking !== undefined) localVarQueryParameter["noTracking"] = noTracking;
            if (useDraftContent !== undefined) localVarQueryParameter["useDraftContent"] = useDraftContent;
            localVarHeaderParameter["Content-Type"] = "application/json-patch+json";
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = true;
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(body || {}) : body || "";
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions
            };
        }
    };
};
/**
 * CustomAssistantApi - functional programming interface
 * @export
 */ exports.CustomAssistantApiFp = function(configuration) {
    return {
        /**
         *
         * @param {CustomAssistantRequestBody} [body]
         * @param {string} [applicationId]
         * @param {string} [applicationSecret]
         * @param {string} [environmentId]
         * @param {boolean} [noTracking]
         * @param {boolean} [useDraftContent]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */ handleRequest (body, applicationId, applicationSecret, environmentId, noTracking, useDraftContent, options) {
            const localVarFetchArgs = exports.CustomAssistantApiFetchParamCreator(configuration).handleRequest(body, applicationId, applicationSecret, environmentId, noTracking, useDraftContent, options);
            return (fetch = portableFetch, basePath = BASE_PATH)=>{
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response)=>{
                    if (response.status >= 200 && response.status < 300) return response.json();
                    else throw response;
                });
            };
        }
    };
};
/**
 * CustomAssistantApi - factory interface
 * @export
 */ exports.CustomAssistantApiFactory = function(configuration, fetch, basePath) {
    return {
        /**
         *
         * @param {CustomAssistantRequestBody} [body]
         * @param {string} [applicationId]
         * @param {string} [applicationSecret]
         * @param {string} [environmentId]
         * @param {boolean} [noTracking]
         * @param {boolean} [useDraftContent]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */ handleRequest (body, applicationId, applicationSecret, environmentId, noTracking, useDraftContent, options) {
            return exports.CustomAssistantApiFp(configuration).handleRequest(body, applicationId, applicationSecret, environmentId, noTracking, useDraftContent, options)(fetch, basePath);
        }
    };
};
/**
 * CustomAssistantApi - object-oriented interface
 * @export
 * @class CustomAssistantApi
 * @extends {BaseAPI}
 */ class CustomAssistantApi extends BaseAPI {
    /**
     *
     * @param {CustomAssistantRequestBody} [body]
     * @param {string} [applicationId]
     * @param {string} [applicationSecret]
     * @param {string} [environmentId]
     * @param {boolean} [noTracking]
     * @param {boolean} [useDraftContent]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomAssistantApi
     */ handleRequest(body, applicationId, applicationSecret, environmentId, noTracking, useDraftContent, options) {
        return exports.CustomAssistantApiFp(this.configuration).handleRequest(body, applicationId, applicationSecret, environmentId, noTracking, useDraftContent, options)(this.fetch, this.basePath);
    }
}
exports.CustomAssistantApi = CustomAssistantApi;
/**
 * DialogflowApi - fetch parameter creator
 * @export
 */ exports.DialogflowApiFetchParamCreator = function(configuration) {
    return {
        /**
         *
         * @param {ActionRequest} [body]
         * @param {string} [applicationId]
         * @param {string} [applicationSecret]
         * @param {string} [environmentId]
         * @param {boolean} [noTracking]
         * @param {boolean} [useDraftContent]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */ handleRequest (body, applicationId, applicationSecret, environmentId, noTracking, useDraftContent, options = {}) {
            const localVarPath = `/api/Dialogflow/HandleRequest`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({
                method: "POST"
            }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === "function" ? configuration.apiKey("Authorization") : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            // authentication X-Api-Key required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === "function" ? configuration.apiKey("X-Api-Key") : configuration.apiKey;
                localVarHeaderParameter["X-Api-Key"] = localVarApiKeyValue;
            }
            if (applicationId !== undefined) localVarQueryParameter["applicationId"] = applicationId;
            if (applicationSecret !== undefined) localVarQueryParameter["applicationSecret"] = applicationSecret;
            if (environmentId !== undefined) localVarQueryParameter["environmentId"] = environmentId;
            if (noTracking !== undefined) localVarQueryParameter["noTracking"] = noTracking;
            if (useDraftContent !== undefined) localVarQueryParameter["useDraftContent"] = useDraftContent;
            localVarHeaderParameter["Content-Type"] = "application/json-patch+json";
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = true;
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(body || {}) : body || "";
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions
            };
        }
    };
};
/**
 * DialogflowApi - functional programming interface
 * @export
 */ exports.DialogflowApiFp = function(configuration) {
    return {
        /**
         *
         * @param {ActionRequest} [body]
         * @param {string} [applicationId]
         * @param {string} [applicationSecret]
         * @param {string} [environmentId]
         * @param {boolean} [noTracking]
         * @param {boolean} [useDraftContent]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */ handleRequest (body, applicationId, applicationSecret, environmentId, noTracking, useDraftContent, options) {
            const localVarFetchArgs = exports.DialogflowApiFetchParamCreator(configuration).handleRequest(body, applicationId, applicationSecret, environmentId, noTracking, useDraftContent, options);
            return (fetch = portableFetch, basePath = BASE_PATH)=>{
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response)=>{
                    if (response.status >= 200 && response.status < 300) return response.json();
                    else throw response;
                });
            };
        }
    };
};
/**
 * DialogflowApi - factory interface
 * @export
 */ exports.DialogflowApiFactory = function(configuration, fetch, basePath) {
    return {
        /**
         *
         * @param {ActionRequest} [body]
         * @param {string} [applicationId]
         * @param {string} [applicationSecret]
         * @param {string} [environmentId]
         * @param {boolean} [noTracking]
         * @param {boolean} [useDraftContent]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */ handleRequest (body, applicationId, applicationSecret, environmentId, noTracking, useDraftContent, options) {
            return exports.DialogflowApiFp(configuration).handleRequest(body, applicationId, applicationSecret, environmentId, noTracking, useDraftContent, options)(fetch, basePath);
        }
    };
};
/**
 * DialogflowApi - object-oriented interface
 * @export
 * @class DialogflowApi
 * @extends {BaseAPI}
 */ class DialogflowApi extends BaseAPI {
    /**
     *
     * @param {ActionRequest} [body]
     * @param {string} [applicationId]
     * @param {string} [applicationSecret]
     * @param {string} [environmentId]
     * @param {boolean} [noTracking]
     * @param {boolean} [useDraftContent]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DialogflowApi
     */ handleRequest(body, applicationId, applicationSecret, environmentId, noTracking, useDraftContent, options) {
        return exports.DialogflowApiFp(this.configuration).handleRequest(body, applicationId, applicationSecret, environmentId, noTracking, useDraftContent, options)(this.fetch, this.basePath);
    }
}
exports.DialogflowApi = DialogflowApi;
/**
 * GoogleAssistantApi - fetch parameter creator
 * @export
 */ exports.GoogleAssistantApiFetchParamCreator = function(configuration) {
    return {
        /**
         *
         * @param {GoogleAssistantRequest} [body]
         * @param {string} [applicationId]
         * @param {string} [applicationSecret]
         * @param {string} [environmentId]
         * @param {boolean} [noTracking]
         * @param {boolean} [useDraftContent]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */ handleRequest (body, applicationId, applicationSecret, environmentId, noTracking, useDraftContent, options = {}) {
            const localVarPath = `/api/GoogleAssistant/HandleRequest`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({
                method: "POST"
            }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === "function" ? configuration.apiKey("Authorization") : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            // authentication X-Api-Key required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === "function" ? configuration.apiKey("X-Api-Key") : configuration.apiKey;
                localVarHeaderParameter["X-Api-Key"] = localVarApiKeyValue;
            }
            if (applicationId !== undefined) localVarQueryParameter["applicationId"] = applicationId;
            if (applicationSecret !== undefined) localVarQueryParameter["applicationSecret"] = applicationSecret;
            if (environmentId !== undefined) localVarQueryParameter["environmentId"] = environmentId;
            if (noTracking !== undefined) localVarQueryParameter["noTracking"] = noTracking;
            if (useDraftContent !== undefined) localVarQueryParameter["useDraftContent"] = useDraftContent;
            localVarHeaderParameter["Content-Type"] = "application/json-patch+json";
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = true;
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(body || {}) : body || "";
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions
            };
        }
    };
};
/**
 * GoogleAssistantApi - functional programming interface
 * @export
 */ exports.GoogleAssistantApiFp = function(configuration) {
    return {
        /**
         *
         * @param {GoogleAssistantRequest} [body]
         * @param {string} [applicationId]
         * @param {string} [applicationSecret]
         * @param {string} [environmentId]
         * @param {boolean} [noTracking]
         * @param {boolean} [useDraftContent]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */ handleRequest (body, applicationId, applicationSecret, environmentId, noTracking, useDraftContent, options) {
            const localVarFetchArgs = exports.GoogleAssistantApiFetchParamCreator(configuration).handleRequest(body, applicationId, applicationSecret, environmentId, noTracking, useDraftContent, options);
            return (fetch = portableFetch, basePath = BASE_PATH)=>{
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response)=>{
                    if (response.status >= 200 && response.status < 300) return response.json();
                    else throw response;
                });
            };
        }
    };
};
/**
 * GoogleAssistantApi - factory interface
 * @export
 */ exports.GoogleAssistantApiFactory = function(configuration, fetch, basePath) {
    return {
        /**
         *
         * @param {GoogleAssistantRequest} [body]
         * @param {string} [applicationId]
         * @param {string} [applicationSecret]
         * @param {string} [environmentId]
         * @param {boolean} [noTracking]
         * @param {boolean} [useDraftContent]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */ handleRequest (body, applicationId, applicationSecret, environmentId, noTracking, useDraftContent, options) {
            return exports.GoogleAssistantApiFp(configuration).handleRequest(body, applicationId, applicationSecret, environmentId, noTracking, useDraftContent, options)(fetch, basePath);
        }
    };
};
/**
 * GoogleAssistantApi - object-oriented interface
 * @export
 * @class GoogleAssistantApi
 * @extends {BaseAPI}
 */ class GoogleAssistantApi extends BaseAPI {
    /**
     *
     * @param {GoogleAssistantRequest} [body]
     * @param {string} [applicationId]
     * @param {string} [applicationSecret]
     * @param {string} [environmentId]
     * @param {boolean} [noTracking]
     * @param {boolean} [useDraftContent]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GoogleAssistantApi
     */ handleRequest(body, applicationId, applicationSecret, environmentId, noTracking, useDraftContent, options) {
        return exports.GoogleAssistantApiFp(this.configuration).handleRequest(body, applicationId, applicationSecret, environmentId, noTracking, useDraftContent, options)(this.fetch, this.basePath);
    }
}
exports.GoogleAssistantApi = GoogleAssistantApi;
/**
 * HealthCheckApi - fetch parameter creator
 * @export
 */ exports.HealthCheckApiFetchParamCreator = function(configuration) {
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */ healthCheck (options = {}) {
            const localVarPath = `/api/HealthCheck`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({
                method: "GET"
            }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === "function" ? configuration.apiKey("Authorization") : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            // authentication X-Api-Key required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === "function" ? configuration.apiKey("X-Api-Key") : configuration.apiKey;
                localVarHeaderParameter["X-Api-Key"] = localVarApiKeyValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions
            };
        }
    };
};
/**
 * HealthCheckApi - functional programming interface
 * @export
 */ exports.HealthCheckApiFp = function(configuration) {
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */ healthCheck (options) {
            const localVarFetchArgs = exports.HealthCheckApiFetchParamCreator(configuration).healthCheck(options);
            return (fetch = portableFetch, basePath = BASE_PATH)=>{
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response)=>{
                    if (response.status >= 200 && response.status < 300) return response;
                    else throw response;
                });
            };
        }
    };
};
/**
 * HealthCheckApi - factory interface
 * @export
 */ exports.HealthCheckApiFactory = function(configuration, fetch, basePath) {
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */ healthCheck (options) {
            return exports.HealthCheckApiFp(configuration).healthCheck(options)(fetch, basePath);
        }
    };
};
/**
 * HealthCheckApi - object-oriented interface
 * @export
 * @class HealthCheckApi
 * @extends {BaseAPI}
 */ class HealthCheckApi extends BaseAPI {
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HealthCheckApi
     */ healthCheck(options) {
        return exports.HealthCheckApiFp(this.configuration).healthCheck(options)(this.fetch, this.basePath);
    }
}
exports.HealthCheckApi = HealthCheckApi;
/**
 * UserProfileApi - fetch parameter creator
 * @export
 */ exports.UserProfileApiFetchParamCreator = function(configuration) {
    return {
        /**
         *
         * @param {string} sessionId
         * @param {string} [applicationId]
         * @param {string} [applicationSecret]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */ getSessionAttributes (sessionId, applicationId, applicationSecret, options = {}) {
            // verify required parameter 'sessionId' is not null or undefined
            if (sessionId === null || sessionId === undefined) throw new RequiredError("sessionId", "Required parameter sessionId was null or undefined when calling getSessionAttributes.");
            const localVarPath = `/api/UserProfile/session/{sessionId}`.replace(`{${"sessionId"}}`, encodeURIComponent(String(sessionId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({
                method: "GET"
            }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === "function" ? configuration.apiKey("Authorization") : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            // authentication X-Api-Key required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === "function" ? configuration.apiKey("X-Api-Key") : configuration.apiKey;
                localVarHeaderParameter["X-Api-Key"] = localVarApiKeyValue;
            }
            if (applicationId !== undefined) localVarQueryParameter["applicationId"] = applicationId;
            if (applicationSecret !== undefined) localVarQueryParameter["applicationSecret"] = applicationSecret;
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
         *
         * @param {string} userId
         * @param {string} [applicationId]
         * @param {string} [applicationSecret]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */ getUserProfile (userId, applicationId, applicationSecret, options = {}) {
            // verify required parameter 'userId' is not null or undefined
            if (userId === null || userId === undefined) throw new RequiredError("userId", "Required parameter userId was null or undefined when calling getUserProfile.");
            const localVarPath = `/api/UserProfile/{userId}`.replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({
                method: "GET"
            }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === "function" ? configuration.apiKey("Authorization") : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            // authentication X-Api-Key required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === "function" ? configuration.apiKey("X-Api-Key") : configuration.apiKey;
                localVarHeaderParameter["X-Api-Key"] = localVarApiKeyValue;
            }
            if (applicationId !== undefined) localVarQueryParameter["applicationId"] = applicationId;
            if (applicationSecret !== undefined) localVarQueryParameter["applicationSecret"] = applicationSecret;
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions
            };
        }
    };
};
/**
 * UserProfileApi - functional programming interface
 * @export
 */ exports.UserProfileApiFp = function(configuration) {
    return {
        /**
         *
         * @param {string} sessionId
         * @param {string} [applicationId]
         * @param {string} [applicationSecret]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */ getSessionAttributes (sessionId, applicationId, applicationSecret, options) {
            const localVarFetchArgs = exports.UserProfileApiFetchParamCreator(configuration).getSessionAttributes(sessionId, applicationId, applicationSecret, options);
            return (fetch = portableFetch, basePath = BASE_PATH)=>{
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response)=>{
                    if (response.status >= 200 && response.status < 300) return response.json();
                    else throw response;
                });
            };
        },
        /**
         *
         * @param {string} userId
         * @param {string} [applicationId]
         * @param {string} [applicationSecret]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */ getUserProfile (userId, applicationId, applicationSecret, options) {
            const localVarFetchArgs = exports.UserProfileApiFetchParamCreator(configuration).getUserProfile(userId, applicationId, applicationSecret, options);
            return (fetch = portableFetch, basePath = BASE_PATH)=>{
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response)=>{
                    if (response.status >= 200 && response.status < 300) return response.json();
                    else throw response;
                });
            };
        }
    };
};
/**
 * UserProfileApi - factory interface
 * @export
 */ exports.UserProfileApiFactory = function(configuration, fetch, basePath) {
    return {
        /**
         *
         * @param {string} sessionId
         * @param {string} [applicationId]
         * @param {string} [applicationSecret]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */ getSessionAttributes (sessionId, applicationId, applicationSecret, options) {
            return exports.UserProfileApiFp(configuration).getSessionAttributes(sessionId, applicationId, applicationSecret, options)(fetch, basePath);
        },
        /**
         *
         * @param {string} userId
         * @param {string} [applicationId]
         * @param {string} [applicationSecret]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */ getUserProfile (userId, applicationId, applicationSecret, options) {
            return exports.UserProfileApiFp(configuration).getUserProfile(userId, applicationId, applicationSecret, options)(fetch, basePath);
        }
    };
};
/**
 * UserProfileApi - object-oriented interface
 * @export
 * @class UserProfileApi
 * @extends {BaseAPI}
 */ class UserProfileApi extends BaseAPI {
    /**
     *
     * @param {string} sessionId
     * @param {string} [applicationId]
     * @param {string} [applicationSecret]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserProfileApi
     */ getSessionAttributes(sessionId, applicationId, applicationSecret, options) {
        return exports.UserProfileApiFp(this.configuration).getSessionAttributes(sessionId, applicationId, applicationSecret, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @param {string} userId
     * @param {string} [applicationId]
     * @param {string} [applicationSecret]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserProfileApi
     */ getUserProfile(userId, applicationId, applicationSecret, options) {
        return exports.UserProfileApiFp(this.configuration).getUserProfile(userId, applicationId, applicationSecret, options)(this.fetch, this.basePath);
    }
}
exports.UserProfileApi = UserProfileApi;

},{"5dc88633267177ac":"280SV","8f66ef2f593d0e35":"gpdoD"}],"280SV":[function(require,module,exports) {
/*
 * Copyright Joyent, Inc. and other Node contributors.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a
 * copy of this software and associated documentation files (the
 * "Software"), to deal in the Software without restriction, including
 * without limitation the rights to use, copy, modify, merge, publish,
 * distribute, sublicense, and/or sell copies of the Software, and to permit
 * persons to whom the Software is furnished to do so, subject to the
 * following conditions:
 *
 * The above copyright notice and this permission notice shall be included
 * in all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
 * OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
 * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
 * NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
 * DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
 * OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
 * USE OR OTHER DEALINGS IN THE SOFTWARE.
 */ "use strict";
var punycode = require("6aa635927f16f681");
function Url() {
    this.protocol = null;
    this.slashes = null;
    this.auth = null;
    this.host = null;
    this.port = null;
    this.hostname = null;
    this.hash = null;
    this.search = null;
    this.query = null;
    this.pathname = null;
    this.path = null;
    this.href = null;
}
// Reference: RFC 3986, RFC 1808, RFC 2396
/*
 * define these here so at least they only have to be
 * compiled once on the first module load.
 */ var protocolPattern = /^([a-z0-9.+-]+:)/i, portPattern = /:[0-9]*$/, // Special case for a simple path URL
simplePathPattern = /^(\/\/?(?!\/)[^?\s]*)(\?[^\s]*)?$/, /*
   * RFC 2396: characters reserved for delimiting URLs.
   * We actually just auto-escape these.
   */ delims = [
    "<",
    ">",
    '"',
    "`",
    " ",
    "\r",
    "\n",
    "	"
], // RFC 2396: characters not allowed for various reasons.
unwise = [
    "{",
    "}",
    "|",
    "\\",
    "^",
    "`"
].concat(delims), // Allowed by RFCs, but cause of XSS attacks.  Always escape these.
autoEscape = [
    "'"
].concat(unwise), /*
   * Characters that are never ever allowed in a hostname.
   * Note that any invalid chars are also handled, but these
   * are the ones that are *expected* to be seen, so we fast-path
   * them.
   */ nonHostChars = [
    "%",
    "/",
    "?",
    ";",
    "#"
].concat(autoEscape), hostEndingChars = [
    "/",
    "?",
    "#"
], hostnameMaxLen = 255, hostnamePartPattern = /^[+a-z0-9A-Z_-]{0,63}$/, hostnamePartStart = /^([+a-z0-9A-Z_-]{0,63})(.*)$/, // protocols that can allow "unsafe" and "unwise" chars.
unsafeProtocol = {
    javascript: true,
    "javascript:": true
}, // protocols that never have a hostname.
hostlessProtocol = {
    javascript: true,
    "javascript:": true
}, // protocols that always contain a // bit.
slashedProtocol = {
    http: true,
    https: true,
    ftp: true,
    gopher: true,
    file: true,
    "http:": true,
    "https:": true,
    "ftp:": true,
    "gopher:": true,
    "file:": true
}, querystring = require("6724c84b9b69726b");
function urlParse(url, parseQueryString, slashesDenoteHost) {
    if (url && typeof url === "object" && url instanceof Url) return url;
    var u = new Url();
    u.parse(url, parseQueryString, slashesDenoteHost);
    return u;
}
Url.prototype.parse = function(url, parseQueryString, slashesDenoteHost) {
    if (typeof url !== "string") throw new TypeError("Parameter 'url' must be a string, not " + typeof url);
    /*
   * Copy chrome, IE, opera backslash-handling behavior.
   * Back slashes before the query string get converted to forward slashes
   * See: https://code.google.com/p/chromium/issues/detail?id=25916
   */ var queryIndex = url.indexOf("?"), splitter = queryIndex !== -1 && queryIndex < url.indexOf("#") ? "?" : "#", uSplit = url.split(splitter), slashRegex = /\\/g;
    uSplit[0] = uSplit[0].replace(slashRegex, "/");
    url = uSplit.join(splitter);
    var rest = url;
    /*
   * trim before proceeding.
   * This is to support parse stuff like "  http://foo.com  \n"
   */ rest = rest.trim();
    if (!slashesDenoteHost && url.split("#").length === 1) {
        // Try fast path regexp
        var simplePath = simplePathPattern.exec(rest);
        if (simplePath) {
            this.path = rest;
            this.href = rest;
            this.pathname = simplePath[1];
            if (simplePath[2]) {
                this.search = simplePath[2];
                if (parseQueryString) this.query = querystring.parse(this.search.substr(1));
                else this.query = this.search.substr(1);
            } else if (parseQueryString) {
                this.search = "";
                this.query = {};
            }
            return this;
        }
    }
    var proto = protocolPattern.exec(rest);
    if (proto) {
        proto = proto[0];
        var lowerProto = proto.toLowerCase();
        this.protocol = lowerProto;
        rest = rest.substr(proto.length);
    }
    /*
   * figure out if it's got a host
   * user@server is *always* interpreted as a hostname, and url
   * resolution will treat //foo/bar as host=foo,path=bar because that's
   * how the browser resolves relative URLs.
   */ if (slashesDenoteHost || proto || rest.match(/^\/\/[^@/]+@[^@/]+/)) {
        var slashes = rest.substr(0, 2) === "//";
        if (slashes && !(proto && hostlessProtocol[proto])) {
            rest = rest.substr(2);
            this.slashes = true;
        }
    }
    if (!hostlessProtocol[proto] && (slashes || proto && !slashedProtocol[proto])) {
        /*
     * there's a hostname.
     * the first instance of /, ?, ;, or # ends the host.
     *
     * If there is an @ in the hostname, then non-host chars *are* allowed
     * to the left of the last @ sign, unless some host-ending character
     * comes *before* the @-sign.
     * URLs are obnoxious.
     *
     * ex:
     * http://a@b@c/ => user:a@b host:c
     * http://a@b?@c => user:a host:c path:/?@c
     */ /*
     * v0.12 TODO(isaacs): This is not quite how Chrome does things.
     * Review our test case against browsers more comprehensively.
     */ // find the first instance of any hostEndingChars
        var hostEnd = -1;
        for(var i = 0; i < hostEndingChars.length; i++){
            var hec = rest.indexOf(hostEndingChars[i]);
            if (hec !== -1 && (hostEnd === -1 || hec < hostEnd)) hostEnd = hec;
        }
        /*
     * at this point, either we have an explicit point where the
     * auth portion cannot go past, or the last @ char is the decider.
     */ var auth, atSign;
        if (hostEnd === -1) // atSign can be anywhere.
        atSign = rest.lastIndexOf("@");
        else /*
       * atSign must be in auth portion.
       * http://a@b/c@d => host:b auth:a path:/c@d
       */ atSign = rest.lastIndexOf("@", hostEnd);
        /*
     * Now we have a portion which is definitely the auth.
     * Pull that off.
     */ if (atSign !== -1) {
            auth = rest.slice(0, atSign);
            rest = rest.slice(atSign + 1);
            this.auth = decodeURIComponent(auth);
        }
        // the host is the remaining to the left of the first non-host char
        hostEnd = -1;
        for(var i = 0; i < nonHostChars.length; i++){
            var hec = rest.indexOf(nonHostChars[i]);
            if (hec !== -1 && (hostEnd === -1 || hec < hostEnd)) hostEnd = hec;
        }
        // if we still have not hit it, then the entire thing is a host.
        if (hostEnd === -1) hostEnd = rest.length;
        this.host = rest.slice(0, hostEnd);
        rest = rest.slice(hostEnd);
        // pull out port.
        this.parseHost();
        /*
     * we've indicated that there is a hostname,
     * so even if it's empty, it has to be present.
     */ this.hostname = this.hostname || "";
        /*
     * if hostname begins with [ and ends with ]
     * assume that it's an IPv6 address.
     */ var ipv6Hostname = this.hostname[0] === "[" && this.hostname[this.hostname.length - 1] === "]";
        // validate a little.
        if (!ipv6Hostname) {
            var hostparts = this.hostname.split(/\./);
            for(var i = 0, l = hostparts.length; i < l; i++){
                var part = hostparts[i];
                if (!part) continue;
                if (!part.match(hostnamePartPattern)) {
                    var newpart = "";
                    for(var j = 0, k = part.length; j < k; j++)if (part.charCodeAt(j) > 127) /*
               * we replace non-ASCII char with a temporary placeholder
               * we need this to make sure size of hostname is not
               * broken by replacing non-ASCII by nothing
               */ newpart += "x";
                    else newpart += part[j];
                    // we test again with ASCII char only
                    if (!newpart.match(hostnamePartPattern)) {
                        var validParts = hostparts.slice(0, i);
                        var notHost = hostparts.slice(i + 1);
                        var bit = part.match(hostnamePartStart);
                        if (bit) {
                            validParts.push(bit[1]);
                            notHost.unshift(bit[2]);
                        }
                        if (notHost.length) rest = "/" + notHost.join(".") + rest;
                        this.hostname = validParts.join(".");
                        break;
                    }
                }
            }
        }
        if (this.hostname.length > hostnameMaxLen) this.hostname = "";
        else // hostnames are always lower case.
        this.hostname = this.hostname.toLowerCase();
        if (!ipv6Hostname) /*
       * IDNA Support: Returns a punycoded representation of "domain".
       * It only converts parts of the domain name that
       * have non-ASCII characters, i.e. it doesn't matter if
       * you call it with a domain that already is ASCII-only.
       */ this.hostname = punycode.toASCII(this.hostname);
        var p = this.port ? ":" + this.port : "";
        var h = this.hostname || "";
        this.host = h + p;
        this.href += this.host;
        /*
     * strip [ and ] from the hostname
     * the host field still retains them, though
     */ if (ipv6Hostname) {
            this.hostname = this.hostname.substr(1, this.hostname.length - 2);
            if (rest[0] !== "/") rest = "/" + rest;
        }
    }
    /*
   * now rest is set to the post-host stuff.
   * chop off any delim chars.
   */ if (!unsafeProtocol[lowerProto]) /*
     * First, make 100% sure that any "autoEscape" chars get
     * escaped, even if encodeURIComponent doesn't think they
     * need to be.
     */ for(var i = 0, l = autoEscape.length; i < l; i++){
        var ae = autoEscape[i];
        if (rest.indexOf(ae) === -1) continue;
        var esc = encodeURIComponent(ae);
        if (esc === ae) esc = escape(ae);
        rest = rest.split(ae).join(esc);
    }
    // chop off from the tail first.
    var hash = rest.indexOf("#");
    if (hash !== -1) {
        // got a fragment string.
        this.hash = rest.substr(hash);
        rest = rest.slice(0, hash);
    }
    var qm = rest.indexOf("?");
    if (qm !== -1) {
        this.search = rest.substr(qm);
        this.query = rest.substr(qm + 1);
        if (parseQueryString) this.query = querystring.parse(this.query);
        rest = rest.slice(0, qm);
    } else if (parseQueryString) {
        // no query string, but parseQueryString still requested
        this.search = "";
        this.query = {};
    }
    if (rest) this.pathname = rest;
    if (slashedProtocol[lowerProto] && this.hostname && !this.pathname) this.pathname = "/";
    // to support http.request
    if (this.pathname || this.search) {
        var p = this.pathname || "";
        var s = this.search || "";
        this.path = p + s;
    }
    // finally, reconstruct the href based on what has been validated.
    this.href = this.format();
    return this;
};
// format a parsed object into a url string
function urlFormat(obj) {
    /*
   * ensure it's an object, and not a string url.
   * If it's an obj, this is a no-op.
   * this way, you can call url_format() on strings
   * to clean up potentially wonky urls.
   */ if (typeof obj === "string") obj = urlParse(obj);
    if (!(obj instanceof Url)) return Url.prototype.format.call(obj);
    return obj.format();
}
Url.prototype.format = function() {
    var auth = this.auth || "";
    if (auth) {
        auth = encodeURIComponent(auth);
        auth = auth.replace(/%3A/i, ":");
        auth += "@";
    }
    var protocol = this.protocol || "", pathname = this.pathname || "", hash = this.hash || "", host = false, query = "";
    if (this.host) host = auth + this.host;
    else if (this.hostname) {
        host = auth + (this.hostname.indexOf(":") === -1 ? this.hostname : "[" + this.hostname + "]");
        if (this.port) host += ":" + this.port;
    }
    if (this.query && typeof this.query === "object" && Object.keys(this.query).length) query = querystring.stringify(this.query);
    var search = this.search || query && "?" + query || "";
    if (protocol && protocol.substr(-1) !== ":") protocol += ":";
    /*
   * only the slashedProtocols get the //.  Not mailto:, xmpp:, etc.
   * unless they had them to begin with.
   */ if (this.slashes || (!protocol || slashedProtocol[protocol]) && host !== false) {
        host = "//" + (host || "");
        if (pathname && pathname.charAt(0) !== "/") pathname = "/" + pathname;
    } else if (!host) host = "";
    if (hash && hash.charAt(0) !== "#") hash = "#" + hash;
    if (search && search.charAt(0) !== "?") search = "?" + search;
    pathname = pathname.replace(/[?#]/g, function(match) {
        return encodeURIComponent(match);
    });
    search = search.replace("#", "%23");
    return protocol + host + pathname + search + hash;
};
function urlResolve(source, relative) {
    return urlParse(source, false, true).resolve(relative);
}
Url.prototype.resolve = function(relative) {
    return this.resolveObject(urlParse(relative, false, true)).format();
};
function urlResolveObject(source, relative) {
    if (!source) return relative;
    return urlParse(source, false, true).resolveObject(relative);
}
Url.prototype.resolveObject = function(relative) {
    if (typeof relative === "string") {
        var rel = new Url();
        rel.parse(relative, false, true);
        relative = rel;
    }
    var result = new Url();
    var tkeys = Object.keys(this);
    for(var tk = 0; tk < tkeys.length; tk++){
        var tkey = tkeys[tk];
        result[tkey] = this[tkey];
    }
    /*
   * hash is always overridden, no matter what.
   * even href="" will remove it.
   */ result.hash = relative.hash;
    // if the relative url is empty, then there's nothing left to do here.
    if (relative.href === "") {
        result.href = result.format();
        return result;
    }
    // hrefs like //foo/bar always cut to the protocol.
    if (relative.slashes && !relative.protocol) {
        // take everything except the protocol from relative
        var rkeys = Object.keys(relative);
        for(var rk = 0; rk < rkeys.length; rk++){
            var rkey = rkeys[rk];
            if (rkey !== "protocol") result[rkey] = relative[rkey];
        }
        // urlParse appends trailing / to urls like http://www.example.com
        if (slashedProtocol[result.protocol] && result.hostname && !result.pathname) {
            result.pathname = "/";
            result.path = result.pathname;
        }
        result.href = result.format();
        return result;
    }
    if (relative.protocol && relative.protocol !== result.protocol) {
        /*
     * if it's a known url protocol, then changing
     * the protocol does weird things
     * first, if it's not file:, then we MUST have a host,
     * and if there was a path
     * to begin with, then we MUST have a path.
     * if it is file:, then the host is dropped,
     * because that's known to be hostless.
     * anything else is assumed to be absolute.
     */ if (!slashedProtocol[relative.protocol]) {
            var keys = Object.keys(relative);
            for(var v = 0; v < keys.length; v++){
                var k = keys[v];
                result[k] = relative[k];
            }
            result.href = result.format();
            return result;
        }
        result.protocol = relative.protocol;
        if (!relative.host && !hostlessProtocol[relative.protocol]) {
            var relPath = (relative.pathname || "").split("/");
            while(relPath.length && !(relative.host = relPath.shift()));
            if (!relative.host) relative.host = "";
            if (!relative.hostname) relative.hostname = "";
            if (relPath[0] !== "") relPath.unshift("");
            if (relPath.length < 2) relPath.unshift("");
            result.pathname = relPath.join("/");
        } else result.pathname = relative.pathname;
        result.search = relative.search;
        result.query = relative.query;
        result.host = relative.host || "";
        result.auth = relative.auth;
        result.hostname = relative.hostname || relative.host;
        result.port = relative.port;
        // to support http.request
        if (result.pathname || result.search) {
            var p = result.pathname || "";
            var s = result.search || "";
            result.path = p + s;
        }
        result.slashes = result.slashes || relative.slashes;
        result.href = result.format();
        return result;
    }
    var isSourceAbs = result.pathname && result.pathname.charAt(0) === "/", isRelAbs = relative.host || relative.pathname && relative.pathname.charAt(0) === "/", mustEndAbs = isRelAbs || isSourceAbs || result.host && relative.pathname, removeAllDots = mustEndAbs, srcPath = result.pathname && result.pathname.split("/") || [], relPath = relative.pathname && relative.pathname.split("/") || [], psychotic = result.protocol && !slashedProtocol[result.protocol];
    /*
   * if the url is a non-slashed url, then relative
   * links like ../.. should be able
   * to crawl up to the hostname, as well.  This is strange.
   * result.protocol has already been set by now.
   * Later on, put the first path part into the host field.
   */ if (psychotic) {
        result.hostname = "";
        result.port = null;
        if (result.host) {
            if (srcPath[0] === "") srcPath[0] = result.host;
            else srcPath.unshift(result.host);
        }
        result.host = "";
        if (relative.protocol) {
            relative.hostname = null;
            relative.port = null;
            if (relative.host) {
                if (relPath[0] === "") relPath[0] = relative.host;
                else relPath.unshift(relative.host);
            }
            relative.host = null;
        }
        mustEndAbs = mustEndAbs && (relPath[0] === "" || srcPath[0] === "");
    }
    if (isRelAbs) {
        // it's absolute.
        result.host = relative.host || relative.host === "" ? relative.host : result.host;
        result.hostname = relative.hostname || relative.hostname === "" ? relative.hostname : result.hostname;
        result.search = relative.search;
        result.query = relative.query;
        srcPath = relPath;
    // fall through to the dot-handling below.
    } else if (relPath.length) {
        /*
     * it's relative
     * throw away the existing file, and take the new path instead.
     */ if (!srcPath) srcPath = [];
        srcPath.pop();
        srcPath = srcPath.concat(relPath);
        result.search = relative.search;
        result.query = relative.query;
    } else if (relative.search != null) {
        /*
     * just pull out the search.
     * like href='?foo'.
     * Put this after the other two cases because it simplifies the booleans
     */ if (psychotic) {
            result.host = srcPath.shift();
            result.hostname = result.host;
            /*
       * occationaly the auth can get stuck only in host
       * this especially happens in cases like
       * url.resolveObject('mailto:local1@domain1', 'local2@domain2')
       */ var authInHost = result.host && result.host.indexOf("@") > 0 ? result.host.split("@") : false;
            if (authInHost) {
                result.auth = authInHost.shift();
                result.hostname = authInHost.shift();
                result.host = result.hostname;
            }
        }
        result.search = relative.search;
        result.query = relative.query;
        // to support http.request
        if (result.pathname !== null || result.search !== null) result.path = (result.pathname ? result.pathname : "") + (result.search ? result.search : "");
        result.href = result.format();
        return result;
    }
    if (!srcPath.length) {
        /*
     * no path at all.  easy.
     * we've already handled the other stuff above.
     */ result.pathname = null;
        // to support http.request
        if (result.search) result.path = "/" + result.search;
        else result.path = null;
        result.href = result.format();
        return result;
    }
    /*
   * if a url ENDs in . or .., then it must get a trailing slash.
   * however, if it ends in anything else non-slashy,
   * then it must NOT get a trailing slash.
   */ var last = srcPath.slice(-1)[0];
    var hasTrailingSlash = (result.host || relative.host || srcPath.length > 1) && (last === "." || last === "..") || last === "";
    /*
   * strip single dots, resolve double dots to parent dir
   * if the path tries to go above the root, `up` ends up > 0
   */ var up = 0;
    for(var i = srcPath.length; i >= 0; i--){
        last = srcPath[i];
        if (last === ".") srcPath.splice(i, 1);
        else if (last === "..") {
            srcPath.splice(i, 1);
            up++;
        } else if (up) {
            srcPath.splice(i, 1);
            up--;
        }
    }
    // if the path is allowed to go above the root, restore leading ..s
    if (!mustEndAbs && !removeAllDots) for(; up--; up)srcPath.unshift("..");
    if (mustEndAbs && srcPath[0] !== "" && (!srcPath[0] || srcPath[0].charAt(0) !== "/")) srcPath.unshift("");
    if (hasTrailingSlash && srcPath.join("/").substr(-1) !== "/") srcPath.push("");
    var isAbsolute = srcPath[0] === "" || srcPath[0] && srcPath[0].charAt(0) === "/";
    // put the host back
    if (psychotic) {
        result.hostname = isAbsolute ? "" : srcPath.length ? srcPath.shift() : "";
        result.host = result.hostname;
        /*
     * occationaly the auth can get stuck only in host
     * this especially happens in cases like
     * url.resolveObject('mailto:local1@domain1', 'local2@domain2')
     */ var authInHost = result.host && result.host.indexOf("@") > 0 ? result.host.split("@") : false;
        if (authInHost) {
            result.auth = authInHost.shift();
            result.hostname = authInHost.shift();
            result.host = result.hostname;
        }
    }
    mustEndAbs = mustEndAbs || result.host && srcPath.length;
    if (mustEndAbs && !isAbsolute) srcPath.unshift("");
    if (srcPath.length > 0) result.pathname = srcPath.join("/");
    else {
        result.pathname = null;
        result.path = null;
    }
    // to support request.http
    if (result.pathname !== null || result.search !== null) result.path = (result.pathname ? result.pathname : "") + (result.search ? result.search : "");
    result.auth = relative.auth || result.auth;
    result.slashes = result.slashes || relative.slashes;
    result.href = result.format();
    return result;
};
Url.prototype.parseHost = function() {
    var host = this.host;
    var port = portPattern.exec(host);
    if (port) {
        port = port[0];
        if (port !== ":") this.port = port.substr(1);
        host = host.substr(0, host.length - port.length);
    }
    if (host) this.hostname = host;
};
exports.parse = urlParse;
exports.resolve = urlResolve;
exports.resolveObject = urlResolveObject;
exports.format = urlFormat;
exports.Url = Url;

},{"6aa635927f16f681":"8ORYx","6724c84b9b69726b":"3KnnP"}],"8ORYx":[function(require,module,exports) {
var global = arguments[3];
(function(root) {
    /** Detect free variables */ var freeExports = exports && !exports.nodeType && exports;
    var freeModule = module && !module.nodeType && module;
    var freeGlobal = typeof global == "object" && global;
    if (freeGlobal.global === freeGlobal || freeGlobal.window === freeGlobal || freeGlobal.self === freeGlobal) root = freeGlobal;
    /**
	 * The `punycode` object.
	 * @name punycode
	 * @type Object
	 */ var punycode, /** Highest positive signed 32-bit float value */ maxInt = 2147483647, /** Bootstring parameters */ base = 36, tMin = 1, tMax = 26, skew = 38, damp = 700, initialBias = 72, initialN = 128, delimiter = "-", /** Regular expressions */ regexPunycode = /^xn--/, regexNonASCII = /[^\x20-\x7E]/, regexSeparators = /[\x2E\u3002\uFF0E\uFF61]/g, /** Error messages */ errors = {
        "overflow": "Overflow: input needs wider integers to process",
        "not-basic": "Illegal input >= 0x80 (not a basic code point)",
        "invalid-input": "Invalid input"
    }, /** Convenience shortcuts */ baseMinusTMin = base - tMin, floor = Math.floor, stringFromCharCode = String.fromCharCode, /** Temporary variable */ key;
    /*--------------------------------------------------------------------------*/ /**
	 * A generic error utility function.
	 * @private
	 * @param {String} type The error type.
	 * @returns {Error} Throws a `RangeError` with the applicable error message.
	 */ function error(type) {
        throw new RangeError(errors[type]);
    }
    /**
	 * A generic `Array#map` utility function.
	 * @private
	 * @param {Array} array The array to iterate over.
	 * @param {Function} callback The function that gets called for every array
	 * item.
	 * @returns {Array} A new array of values returned by the callback function.
	 */ function map(array, fn) {
        var length = array.length;
        var result = [];
        while(length--)result[length] = fn(array[length]);
        return result;
    }
    /**
	 * A simple `Array#map`-like wrapper to work with domain name strings or email
	 * addresses.
	 * @private
	 * @param {String} domain The domain name or email address.
	 * @param {Function} callback The function that gets called for every
	 * character.
	 * @returns {Array} A new string of characters returned by the callback
	 * function.
	 */ function mapDomain(string, fn) {
        var parts = string.split("@");
        var result = "";
        if (parts.length > 1) {
            // In email addresses, only the domain name should be punycoded. Leave
            // the local part (i.e. everything up to `@`) intact.
            result = parts[0] + "@";
            string = parts[1];
        }
        // Avoid `split(regex)` for IE8 compatibility. See #17.
        string = string.replace(regexSeparators, ".");
        var labels = string.split(".");
        var encoded = map(labels, fn).join(".");
        return result + encoded;
    }
    /**
	 * Creates an array containing the numeric code points of each Unicode
	 * character in the string. While JavaScript uses UCS-2 internally,
	 * this function will convert a pair of surrogate halves (each of which
	 * UCS-2 exposes as separate characters) into a single code point,
	 * matching UTF-16.
	 * @see `punycode.ucs2.encode`
	 * @see <https://mathiasbynens.be/notes/javascript-encoding>
	 * @memberOf punycode.ucs2
	 * @name decode
	 * @param {String} string The Unicode input string (UCS-2).
	 * @returns {Array} The new array of code points.
	 */ function ucs2decode(string) {
        var output = [], counter = 0, length = string.length, value, extra;
        while(counter < length){
            value = string.charCodeAt(counter++);
            if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
                // high surrogate, and there is a next character
                extra = string.charCodeAt(counter++);
                if ((extra & 0xFC00) == 0xDC00) output.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
                else {
                    // unmatched surrogate; only append this code unit, in case the next
                    // code unit is the high surrogate of a surrogate pair
                    output.push(value);
                    counter--;
                }
            } else output.push(value);
        }
        return output;
    }
    /**
	 * Creates a string based on an array of numeric code points.
	 * @see `punycode.ucs2.decode`
	 * @memberOf punycode.ucs2
	 * @name encode
	 * @param {Array} codePoints The array of numeric code points.
	 * @returns {String} The new Unicode string (UCS-2).
	 */ function ucs2encode(array) {
        return map(array, function(value) {
            var output = "";
            if (value > 0xFFFF) {
                value -= 0x10000;
                output += stringFromCharCode(value >>> 10 & 0x3FF | 0xD800);
                value = 0xDC00 | value & 0x3FF;
            }
            output += stringFromCharCode(value);
            return output;
        }).join("");
    }
    /**
	 * Converts a basic code point into a digit/integer.
	 * @see `digitToBasic()`
	 * @private
	 * @param {Number} codePoint The basic numeric code point value.
	 * @returns {Number} The numeric value of a basic code point (for use in
	 * representing integers) in the range `0` to `base - 1`, or `base` if
	 * the code point does not represent a value.
	 */ function basicToDigit(codePoint) {
        if (codePoint - 48 < 10) return codePoint - 22;
        if (codePoint - 65 < 26) return codePoint - 65;
        if (codePoint - 97 < 26) return codePoint - 97;
        return base;
    }
    /**
	 * Converts a digit/integer into a basic code point.
	 * @see `basicToDigit()`
	 * @private
	 * @param {Number} digit The numeric value of a basic code point.
	 * @returns {Number} The basic code point whose value (when used for
	 * representing integers) is `digit`, which needs to be in the range
	 * `0` to `base - 1`. If `flag` is non-zero, the uppercase form is
	 * used; else, the lowercase form is used. The behavior is undefined
	 * if `flag` is non-zero and `digit` has no uppercase form.
	 */ function digitToBasic(digit, flag) {
        //  0..25 map to ASCII a..z or A..Z
        // 26..35 map to ASCII 0..9
        return digit + 22 + 75 * (digit < 26) - ((flag != 0) << 5);
    }
    /**
	 * Bias adaptation function as per section 3.4 of RFC 3492.
	 * https://tools.ietf.org/html/rfc3492#section-3.4
	 * @private
	 */ function adapt(delta, numPoints, firstTime) {
        var k = 0;
        delta = firstTime ? floor(delta / damp) : delta >> 1;
        delta += floor(delta / numPoints);
        for(; delta > baseMinusTMin * tMax >> 1; k += base)delta = floor(delta / baseMinusTMin);
        return floor(k + (baseMinusTMin + 1) * delta / (delta + skew));
    }
    /**
	 * Converts a Punycode string of ASCII-only symbols to a string of Unicode
	 * symbols.
	 * @memberOf punycode
	 * @param {String} input The Punycode string of ASCII-only symbols.
	 * @returns {String} The resulting string of Unicode symbols.
	 */ function decode(input) {
        // Don't use UCS-2
        var output = [], inputLength = input.length, out, i = 0, n = initialN, bias = initialBias, basic, j, index, oldi, w, k, digit, t, /** Cached calculation results */ baseMinusT;
        // Handle the basic code points: let `basic` be the number of input code
        // points before the last delimiter, or `0` if there is none, then copy
        // the first basic code points to the output.
        basic = input.lastIndexOf(delimiter);
        if (basic < 0) basic = 0;
        for(j = 0; j < basic; ++j){
            // if it's not a basic code point
            if (input.charCodeAt(j) >= 0x80) error("not-basic");
            output.push(input.charCodeAt(j));
        }
        // Main decoding loop: start just after the last delimiter if any basic code
        // points were copied; start at the beginning otherwise.
        for(index = basic > 0 ? basic + 1 : 0; index < inputLength;){
            // `index` is the index of the next character to be consumed.
            // Decode a generalized variable-length integer into `delta`,
            // which gets added to `i`. The overflow checking is easier
            // if we increase `i` as we go, then subtract off its starting
            // value at the end to obtain `delta`.
            for(oldi = i, w = 1, k = base;; k += base){
                if (index >= inputLength) error("invalid-input");
                digit = basicToDigit(input.charCodeAt(index++));
                if (digit >= base || digit > floor((maxInt - i) / w)) error("overflow");
                i += digit * w;
                t = k <= bias ? tMin : k >= bias + tMax ? tMax : k - bias;
                if (digit < t) break;
                baseMinusT = base - t;
                if (w > floor(maxInt / baseMinusT)) error("overflow");
                w *= baseMinusT;
            }
            out = output.length + 1;
            bias = adapt(i - oldi, out, oldi == 0);
            // `i` was supposed to wrap around from `out` to `0`,
            // incrementing `n` each time, so we'll fix that now:
            if (floor(i / out) > maxInt - n) error("overflow");
            n += floor(i / out);
            i %= out;
            // Insert `n` at position `i` of the output
            output.splice(i++, 0, n);
        }
        return ucs2encode(output);
    }
    /**
	 * Converts a string of Unicode symbols (e.g. a domain name label) to a
	 * Punycode string of ASCII-only symbols.
	 * @memberOf punycode
	 * @param {String} input The string of Unicode symbols.
	 * @returns {String} The resulting Punycode string of ASCII-only symbols.
	 */ function encode(input) {
        var n, delta, handledCPCount, basicLength, bias, j, m, q, k, t, currentValue, output = [], /** `inputLength` will hold the number of code points in `input`. */ inputLength, /** Cached calculation results */ handledCPCountPlusOne, baseMinusT, qMinusT;
        // Convert the input in UCS-2 to Unicode
        input = ucs2decode(input);
        // Cache the length
        inputLength = input.length;
        // Initialize the state
        n = initialN;
        delta = 0;
        bias = initialBias;
        // Handle the basic code points
        for(j = 0; j < inputLength; ++j){
            currentValue = input[j];
            if (currentValue < 0x80) output.push(stringFromCharCode(currentValue));
        }
        handledCPCount = basicLength = output.length;
        // `handledCPCount` is the number of code points that have been handled;
        // `basicLength` is the number of basic code points.
        // Finish the basic string - if it is not empty - with a delimiter
        if (basicLength) output.push(delimiter);
        // Main encoding loop:
        while(handledCPCount < inputLength){
            // All non-basic code points < n have been handled already. Find the next
            // larger one:
            for(m = maxInt, j = 0; j < inputLength; ++j){
                currentValue = input[j];
                if (currentValue >= n && currentValue < m) m = currentValue;
            }
            // Increase `delta` enough to advance the decoder's <n,i> state to <m,0>,
            // but guard against overflow
            handledCPCountPlusOne = handledCPCount + 1;
            if (m - n > floor((maxInt - delta) / handledCPCountPlusOne)) error("overflow");
            delta += (m - n) * handledCPCountPlusOne;
            n = m;
            for(j = 0; j < inputLength; ++j){
                currentValue = input[j];
                if (currentValue < n && ++delta > maxInt) error("overflow");
                if (currentValue == n) {
                    // Represent delta as a generalized variable-length integer
                    for(q = delta, k = base;; k += base){
                        t = k <= bias ? tMin : k >= bias + tMax ? tMax : k - bias;
                        if (q < t) break;
                        qMinusT = q - t;
                        baseMinusT = base - t;
                        output.push(stringFromCharCode(digitToBasic(t + qMinusT % baseMinusT, 0)));
                        q = floor(qMinusT / baseMinusT);
                    }
                    output.push(stringFromCharCode(digitToBasic(q, 0)));
                    bias = adapt(delta, handledCPCountPlusOne, handledCPCount == basicLength);
                    delta = 0;
                    ++handledCPCount;
                }
            }
            ++delta;
            ++n;
        }
        return output.join("");
    }
    /**
	 * Converts a Punycode string representing a domain name or an email address
	 * to Unicode. Only the Punycoded parts of the input will be converted, i.e.
	 * it doesn't matter if you call it on a string that has already been
	 * converted to Unicode.
	 * @memberOf punycode
	 * @param {String} input The Punycoded domain name or email address to
	 * convert to Unicode.
	 * @returns {String} The Unicode representation of the given Punycode
	 * string.
	 */ function toUnicode(input) {
        return mapDomain(input, function(string) {
            return regexPunycode.test(string) ? decode(string.slice(4).toLowerCase()) : string;
        });
    }
    /**
	 * Converts a Unicode string representing a domain name or an email address to
	 * Punycode. Only the non-ASCII parts of the domain name will be converted,
	 * i.e. it doesn't matter if you call it with a domain that's already in
	 * ASCII.
	 * @memberOf punycode
	 * @param {String} input The domain name or email address to convert, as a
	 * Unicode string.
	 * @returns {String} The Punycode representation of the given domain name or
	 * email address.
	 */ function toASCII(input) {
        return mapDomain(input, function(string) {
            return regexNonASCII.test(string) ? "xn--" + encode(string) : string;
        });
    }
    /*--------------------------------------------------------------------------*/ /** Define the public API */ punycode = {
        /**
		 * A string representing the current Punycode.js version number.
		 * @memberOf punycode
		 * @type String
		 */ "version": "1.4.1",
        /**
		 * An object of methods to convert from JavaScript's internal character
		 * representation (UCS-2) to Unicode code points, and back.
		 * @see <https://mathiasbynens.be/notes/javascript-encoding>
		 * @memberOf punycode
		 * @type Object
		 */ "ucs2": {
            "decode": ucs2decode,
            "encode": ucs2encode
        },
        "decode": decode,
        "encode": encode,
        "toASCII": toASCII,
        "toUnicode": toUnicode
    };
    /** Expose `punycode` */ // Some AMD build optimizers, like r.js, check for specific condition patterns
    // like the following:
    if (typeof define == "function" && typeof define.amd == "object" && define.amd) define("punycode", function() {
        return punycode;
    });
    else if (freeExports && freeModule) {
        if (module.exports == freeExports) // in Node.js, io.js, or RingoJS v0.8.0+
        freeModule.exports = punycode;
        else // in Narwhal or RingoJS v0.7.0-
        for(key in punycode)punycode.hasOwnProperty(key) && (freeExports[key] = punycode[key]);
    } else // in Rhino or a web browser
    root.punycode = punycode;
})(this);

},{}],"3KnnP":[function(require,module,exports) {
"use strict";
var stringify = require("a472ccaa2f2351e9");
var parse = require("7ffa4249597bf32b");
var formats = require("454df9476704f887");
module.exports = {
    formats: formats,
    parse: parse,
    stringify: stringify
};

},{"a472ccaa2f2351e9":"c65e4","7ffa4249597bf32b":"4TH1Q","454df9476704f887":"4FjOV"}],"c65e4":[function(require,module,exports) {
"use strict";
var getSideChannel = require("6246bbb805756d41");
var utils = require("44263cc7b702ebf");
var formats = require("929f8531a94a537c");
var has = Object.prototype.hasOwnProperty;
var arrayPrefixGenerators = {
    brackets: function brackets(prefix) {
        return prefix + "[]";
    },
    comma: "comma",
    indices: function indices(prefix, key) {
        return prefix + "[" + key + "]";
    },
    repeat: function repeat(prefix) {
        return prefix;
    }
};
var isArray = Array.isArray;
var push = Array.prototype.push;
var pushToArray = function(arr, valueOrArray) {
    push.apply(arr, isArray(valueOrArray) ? valueOrArray : [
        valueOrArray
    ]);
};
var toISO = Date.prototype.toISOString;
var defaultFormat = formats["default"];
var defaults = {
    addQueryPrefix: false,
    allowDots: false,
    charset: "utf-8",
    charsetSentinel: false,
    delimiter: "&",
    encode: true,
    encoder: utils.encode,
    encodeValuesOnly: false,
    format: defaultFormat,
    formatter: formats.formatters[defaultFormat],
    // deprecated
    indices: false,
    serializeDate: function serializeDate(date) {
        return toISO.call(date);
    },
    skipNulls: false,
    strictNullHandling: false
};
var isNonNullishPrimitive = function isNonNullishPrimitive(v) {
    return typeof v === "string" || typeof v === "number" || typeof v === "boolean" || typeof v === "symbol" || typeof v === "bigint";
};
var sentinel = {};
var stringify = function stringify(object, prefix, generateArrayPrefix, commaRoundTrip, strictNullHandling, skipNulls, encoder, filter, sort, allowDots, serializeDate, format, formatter, encodeValuesOnly, charset, sideChannel) {
    var obj = object;
    var tmpSc = sideChannel;
    var step = 0;
    var findFlag = false;
    while((tmpSc = tmpSc.get(sentinel)) !== void 0 && !findFlag){
        // Where object last appeared in the ref tree
        var pos = tmpSc.get(object);
        step += 1;
        if (typeof pos !== "undefined") {
            if (pos === step) throw new RangeError("Cyclic object value");
            else findFlag = true; // Break while
        }
        if (typeof tmpSc.get(sentinel) === "undefined") step = 0;
    }
    if (typeof filter === "function") obj = filter(prefix, obj);
    else if (obj instanceof Date) obj = serializeDate(obj);
    else if (generateArrayPrefix === "comma" && isArray(obj)) obj = utils.maybeMap(obj, function(value) {
        if (value instanceof Date) return serializeDate(value);
        return value;
    });
    if (obj === null) {
        if (strictNullHandling) return encoder && !encodeValuesOnly ? encoder(prefix, defaults.encoder, charset, "key", format) : prefix;
        obj = "";
    }
    if (isNonNullishPrimitive(obj) || utils.isBuffer(obj)) {
        if (encoder) {
            var keyValue = encodeValuesOnly ? prefix : encoder(prefix, defaults.encoder, charset, "key", format);
            return [
                formatter(keyValue) + "=" + formatter(encoder(obj, defaults.encoder, charset, "value", format))
            ];
        }
        return [
            formatter(prefix) + "=" + formatter(String(obj))
        ];
    }
    var values = [];
    if (typeof obj === "undefined") return values;
    var objKeys;
    if (generateArrayPrefix === "comma" && isArray(obj)) {
        // we need to join elements in
        if (encodeValuesOnly && encoder) obj = utils.maybeMap(obj, encoder);
        objKeys = [
            {
                value: obj.length > 0 ? obj.join(",") || null : void 0
            }
        ];
    } else if (isArray(filter)) objKeys = filter;
    else {
        var keys = Object.keys(obj);
        objKeys = sort ? keys.sort(sort) : keys;
    }
    var adjustedPrefix = commaRoundTrip && isArray(obj) && obj.length === 1 ? prefix + "[]" : prefix;
    for(var j = 0; j < objKeys.length; ++j){
        var key = objKeys[j];
        var value = typeof key === "object" && typeof key.value !== "undefined" ? key.value : obj[key];
        if (skipNulls && value === null) continue;
        var keyPrefix = isArray(obj) ? typeof generateArrayPrefix === "function" ? generateArrayPrefix(adjustedPrefix, key) : adjustedPrefix : adjustedPrefix + (allowDots ? "." + key : "[" + key + "]");
        sideChannel.set(object, step);
        var valueSideChannel = getSideChannel();
        valueSideChannel.set(sentinel, sideChannel);
        pushToArray(values, stringify(value, keyPrefix, generateArrayPrefix, commaRoundTrip, strictNullHandling, skipNulls, generateArrayPrefix === "comma" && encodeValuesOnly && isArray(obj) ? null : encoder, filter, sort, allowDots, serializeDate, format, formatter, encodeValuesOnly, charset, valueSideChannel));
    }
    return values;
};
var normalizeStringifyOptions = function normalizeStringifyOptions(opts) {
    if (!opts) return defaults;
    if (opts.encoder !== null && typeof opts.encoder !== "undefined" && typeof opts.encoder !== "function") throw new TypeError("Encoder has to be a function.");
    var charset = opts.charset || defaults.charset;
    if (typeof opts.charset !== "undefined" && opts.charset !== "utf-8" && opts.charset !== "iso-8859-1") throw new TypeError("The charset option must be either utf-8, iso-8859-1, or undefined");
    var format = formats["default"];
    if (typeof opts.format !== "undefined") {
        if (!has.call(formats.formatters, opts.format)) throw new TypeError("Unknown format option provided.");
        format = opts.format;
    }
    var formatter = formats.formatters[format];
    var filter = defaults.filter;
    if (typeof opts.filter === "function" || isArray(opts.filter)) filter = opts.filter;
    return {
        addQueryPrefix: typeof opts.addQueryPrefix === "boolean" ? opts.addQueryPrefix : defaults.addQueryPrefix,
        allowDots: typeof opts.allowDots === "undefined" ? defaults.allowDots : !!opts.allowDots,
        charset: charset,
        charsetSentinel: typeof opts.charsetSentinel === "boolean" ? opts.charsetSentinel : defaults.charsetSentinel,
        delimiter: typeof opts.delimiter === "undefined" ? defaults.delimiter : opts.delimiter,
        encode: typeof opts.encode === "boolean" ? opts.encode : defaults.encode,
        encoder: typeof opts.encoder === "function" ? opts.encoder : defaults.encoder,
        encodeValuesOnly: typeof opts.encodeValuesOnly === "boolean" ? opts.encodeValuesOnly : defaults.encodeValuesOnly,
        filter: filter,
        format: format,
        formatter: formatter,
        serializeDate: typeof opts.serializeDate === "function" ? opts.serializeDate : defaults.serializeDate,
        skipNulls: typeof opts.skipNulls === "boolean" ? opts.skipNulls : defaults.skipNulls,
        sort: typeof opts.sort === "function" ? opts.sort : null,
        strictNullHandling: typeof opts.strictNullHandling === "boolean" ? opts.strictNullHandling : defaults.strictNullHandling
    };
};
module.exports = function(object, opts) {
    var obj = object;
    var options = normalizeStringifyOptions(opts);
    var objKeys;
    var filter;
    if (typeof options.filter === "function") {
        filter = options.filter;
        obj = filter("", obj);
    } else if (isArray(options.filter)) {
        filter = options.filter;
        objKeys = filter;
    }
    var keys = [];
    if (typeof obj !== "object" || obj === null) return "";
    var arrayFormat;
    if (opts && opts.arrayFormat in arrayPrefixGenerators) arrayFormat = opts.arrayFormat;
    else if (opts && "indices" in opts) arrayFormat = opts.indices ? "indices" : "repeat";
    else arrayFormat = "indices";
    var generateArrayPrefix = arrayPrefixGenerators[arrayFormat];
    if (opts && "commaRoundTrip" in opts && typeof opts.commaRoundTrip !== "boolean") throw new TypeError("`commaRoundTrip` must be a boolean, or absent");
    var commaRoundTrip = generateArrayPrefix === "comma" && opts && opts.commaRoundTrip;
    if (!objKeys) objKeys = Object.keys(obj);
    if (options.sort) objKeys.sort(options.sort);
    var sideChannel = getSideChannel();
    for(var i = 0; i < objKeys.length; ++i){
        var key = objKeys[i];
        if (options.skipNulls && obj[key] === null) continue;
        pushToArray(keys, stringify(obj[key], key, generateArrayPrefix, commaRoundTrip, options.strictNullHandling, options.skipNulls, options.encode ? options.encoder : null, options.filter, options.sort, options.allowDots, options.serializeDate, options.format, options.formatter, options.encodeValuesOnly, options.charset, sideChannel));
    }
    var joined = keys.join(options.delimiter);
    var prefix = options.addQueryPrefix === true ? "?" : "";
    if (options.charsetSentinel) {
        if (options.charset === "iso-8859-1") // encodeURIComponent('&#10003;'), the "numeric entity" representation of a checkmark
        prefix += "utf8=%26%2310003%3B&";
        else // encodeURIComponent('✓')
        prefix += "utf8=%E2%9C%93&";
    }
    return joined.length > 0 ? prefix + joined : "";
};

},{"6246bbb805756d41":"kTEaB","44263cc7b702ebf":"3YhBn","929f8531a94a537c":"4FjOV"}],"kTEaB":[function(require,module,exports) {
"use strict";
var GetIntrinsic = require("7911ec51a2dc9f3e");
var callBound = require("125062ab9035288f");
var inspect = require("9f4f5a92d8c6543");
var $TypeError = GetIntrinsic("%TypeError%");
var $WeakMap = GetIntrinsic("%WeakMap%", true);
var $Map = GetIntrinsic("%Map%", true);
var $weakMapGet = callBound("WeakMap.prototype.get", true);
var $weakMapSet = callBound("WeakMap.prototype.set", true);
var $weakMapHas = callBound("WeakMap.prototype.has", true);
var $mapGet = callBound("Map.prototype.get", true);
var $mapSet = callBound("Map.prototype.set", true);
var $mapHas = callBound("Map.prototype.has", true);
/*
 * This function traverses the list returning the node corresponding to the
 * given key.
 *
 * That node is also moved to the head of the list, so that if it's accessed
 * again we don't need to traverse the whole list. By doing so, all the recently
 * used nodes can be accessed relatively quickly.
 */ var listGetNode = function(list, key) {
    for(var prev = list, curr; (curr = prev.next) !== null; prev = curr)if (curr.key === key) {
        prev.next = curr.next;
        curr.next = list.next;
        list.next = curr; // eslint-disable-line no-param-reassign
        return curr;
    }
};
var listGet = function(objects, key) {
    var node = listGetNode(objects, key);
    return node && node.value;
};
var listSet = function(objects, key, value) {
    var node = listGetNode(objects, key);
    if (node) node.value = value;
    else // Prepend the new node to the beginning of the list
    objects.next = {
        key: key,
        next: objects.next,
        value: value
    };
};
var listHas = function(objects, key) {
    return !!listGetNode(objects, key);
};
module.exports = function getSideChannel() {
    var $wm;
    var $m;
    var $o;
    var channel = {
        assert: function(key) {
            if (!channel.has(key)) throw new $TypeError("Side channel does not contain " + inspect(key));
        },
        get: function(key) {
            if ($WeakMap && key && (typeof key === "object" || typeof key === "function")) {
                if ($wm) return $weakMapGet($wm, key);
            } else if ($Map) {
                if ($m) return $mapGet($m, key);
            } else {
                if ($o) return listGet($o, key);
            }
        },
        has: function(key) {
            if ($WeakMap && key && (typeof key === "object" || typeof key === "function")) {
                if ($wm) return $weakMapHas($wm, key);
            } else if ($Map) {
                if ($m) return $mapHas($m, key);
            } else {
                if ($o) return listHas($o, key);
            }
            return false;
        },
        set: function(key, value) {
            if ($WeakMap && key && (typeof key === "object" || typeof key === "function")) {
                if (!$wm) $wm = new $WeakMap();
                $weakMapSet($wm, key, value);
            } else if ($Map) {
                if (!$m) $m = new $Map();
                $mapSet($m, key, value);
            } else {
                if (!$o) /*
					 * Initialize the linked list as an empty node, so that we don't have
					 * to special-case handling of the first node: we can always refer to
					 * it as (previous node).next, instead of something like (list).head
					 */ $o = {
                    key: {},
                    next: null
                };
                listSet($o, key, value);
            }
        }
    };
    return channel;
};

},{"7911ec51a2dc9f3e":"igBhj","125062ab9035288f":"eK6wT","9f4f5a92d8c6543":"87sBP"}],"igBhj":[function(require,module,exports) {
"use strict";
var undefined;
var $SyntaxError = SyntaxError;
var $Function = Function;
var $TypeError = TypeError;
// eslint-disable-next-line consistent-return
var getEvalledConstructor = function(expressionSyntax) {
    try {
        return $Function('"use strict"; return (' + expressionSyntax + ").constructor;")();
    } catch (e) {}
};
var $gOPD = Object.getOwnPropertyDescriptor;
if ($gOPD) try {
    $gOPD({}, "");
} catch (e) {
    $gOPD = null; // this is IE 8, which has a broken gOPD
}
var throwTypeError = function() {
    throw new $TypeError();
};
var ThrowTypeError = $gOPD ? function() {
    try {
        // eslint-disable-next-line no-unused-expressions, no-caller, no-restricted-properties
        arguments.callee; // IE 8 does not throw here
        return throwTypeError;
    } catch (calleeThrows) {
        try {
            // IE 8 throws on Object.getOwnPropertyDescriptor(arguments, '')
            return $gOPD(arguments, "callee").get;
        } catch (gOPDthrows) {
            return throwTypeError;
        }
    }
}() : throwTypeError;
var hasSymbols = require("1f00f712d594ccf")();
var hasProto = require("23730654306aa64c")();
var getProto = Object.getPrototypeOf || (hasProto ? function(x) {
    return x.__proto__;
} // eslint-disable-line no-proto
 : null);
var needsEval = {};
var TypedArray = typeof Uint8Array === "undefined" || !getProto ? undefined : getProto(Uint8Array);
var INTRINSICS = {
    "%AggregateError%": typeof AggregateError === "undefined" ? undefined : AggregateError,
    "%Array%": Array,
    "%ArrayBuffer%": typeof ArrayBuffer === "undefined" ? undefined : ArrayBuffer,
    "%ArrayIteratorPrototype%": hasSymbols && getProto ? getProto([][Symbol.iterator]()) : undefined,
    "%AsyncFromSyncIteratorPrototype%": undefined,
    "%AsyncFunction%": needsEval,
    "%AsyncGenerator%": needsEval,
    "%AsyncGeneratorFunction%": needsEval,
    "%AsyncIteratorPrototype%": needsEval,
    "%Atomics%": typeof Atomics === "undefined" ? undefined : Atomics,
    "%BigInt%": typeof BigInt === "undefined" ? undefined : BigInt,
    "%BigInt64Array%": typeof BigInt64Array === "undefined" ? undefined : BigInt64Array,
    "%BigUint64Array%": typeof BigUint64Array === "undefined" ? undefined : BigUint64Array,
    "%Boolean%": Boolean,
    "%DataView%": typeof DataView === "undefined" ? undefined : DataView,
    "%Date%": Date,
    "%decodeURI%": decodeURI,
    "%decodeURIComponent%": decodeURIComponent,
    "%encodeURI%": encodeURI,
    "%encodeURIComponent%": encodeURIComponent,
    "%Error%": Error,
    "%eval%": eval,
    "%EvalError%": EvalError,
    "%Float32Array%": typeof Float32Array === "undefined" ? undefined : Float32Array,
    "%Float64Array%": typeof Float64Array === "undefined" ? undefined : Float64Array,
    "%FinalizationRegistry%": typeof FinalizationRegistry === "undefined" ? undefined : FinalizationRegistry,
    "%Function%": $Function,
    "%GeneratorFunction%": needsEval,
    "%Int8Array%": typeof Int8Array === "undefined" ? undefined : Int8Array,
    "%Int16Array%": typeof Int16Array === "undefined" ? undefined : Int16Array,
    "%Int32Array%": typeof Int32Array === "undefined" ? undefined : Int32Array,
    "%isFinite%": isFinite,
    "%isNaN%": isNaN,
    "%IteratorPrototype%": hasSymbols && getProto ? getProto(getProto([][Symbol.iterator]())) : undefined,
    "%JSON%": typeof JSON === "object" ? JSON : undefined,
    "%Map%": typeof Map === "undefined" ? undefined : Map,
    "%MapIteratorPrototype%": typeof Map === "undefined" || !hasSymbols || !getProto ? undefined : getProto(new Map()[Symbol.iterator]()),
    "%Math%": Math,
    "%Number%": Number,
    "%Object%": Object,
    "%parseFloat%": parseFloat,
    "%parseInt%": parseInt,
    "%Promise%": typeof Promise === "undefined" ? undefined : Promise,
    "%Proxy%": typeof Proxy === "undefined" ? undefined : Proxy,
    "%RangeError%": RangeError,
    "%ReferenceError%": ReferenceError,
    "%Reflect%": typeof Reflect === "undefined" ? undefined : Reflect,
    "%RegExp%": RegExp,
    "%Set%": typeof Set === "undefined" ? undefined : Set,
    "%SetIteratorPrototype%": typeof Set === "undefined" || !hasSymbols || !getProto ? undefined : getProto(new Set()[Symbol.iterator]()),
    "%SharedArrayBuffer%": typeof SharedArrayBuffer === "undefined" ? undefined : SharedArrayBuffer,
    "%String%": String,
    "%StringIteratorPrototype%": hasSymbols && getProto ? getProto(""[Symbol.iterator]()) : undefined,
    "%Symbol%": hasSymbols ? Symbol : undefined,
    "%SyntaxError%": $SyntaxError,
    "%ThrowTypeError%": ThrowTypeError,
    "%TypedArray%": TypedArray,
    "%TypeError%": $TypeError,
    "%Uint8Array%": typeof Uint8Array === "undefined" ? undefined : Uint8Array,
    "%Uint8ClampedArray%": typeof Uint8ClampedArray === "undefined" ? undefined : Uint8ClampedArray,
    "%Uint16Array%": typeof Uint16Array === "undefined" ? undefined : Uint16Array,
    "%Uint32Array%": typeof Uint32Array === "undefined" ? undefined : Uint32Array,
    "%URIError%": URIError,
    "%WeakMap%": typeof WeakMap === "undefined" ? undefined : WeakMap,
    "%WeakRef%": typeof WeakRef === "undefined" ? undefined : WeakRef,
    "%WeakSet%": typeof WeakSet === "undefined" ? undefined : WeakSet
};
if (getProto) try {
    null.error; // eslint-disable-line no-unused-expressions
} catch (e) {
    // https://github.com/tc39/proposal-shadowrealm/pull/384#issuecomment-1364264229
    var errorProto = getProto(getProto(e));
    INTRINSICS["%Error.prototype%"] = errorProto;
}
var doEval = function doEval(name) {
    var value;
    if (name === "%AsyncFunction%") value = getEvalledConstructor("async function () {}");
    else if (name === "%GeneratorFunction%") value = getEvalledConstructor("function* () {}");
    else if (name === "%AsyncGeneratorFunction%") value = getEvalledConstructor("async function* () {}");
    else if (name === "%AsyncGenerator%") {
        var fn = doEval("%AsyncGeneratorFunction%");
        if (fn) value = fn.prototype;
    } else if (name === "%AsyncIteratorPrototype%") {
        var gen = doEval("%AsyncGenerator%");
        if (gen && getProto) value = getProto(gen.prototype);
    }
    INTRINSICS[name] = value;
    return value;
};
var LEGACY_ALIASES = {
    "%ArrayBufferPrototype%": [
        "ArrayBuffer",
        "prototype"
    ],
    "%ArrayPrototype%": [
        "Array",
        "prototype"
    ],
    "%ArrayProto_entries%": [
        "Array",
        "prototype",
        "entries"
    ],
    "%ArrayProto_forEach%": [
        "Array",
        "prototype",
        "forEach"
    ],
    "%ArrayProto_keys%": [
        "Array",
        "prototype",
        "keys"
    ],
    "%ArrayProto_values%": [
        "Array",
        "prototype",
        "values"
    ],
    "%AsyncFunctionPrototype%": [
        "AsyncFunction",
        "prototype"
    ],
    "%AsyncGenerator%": [
        "AsyncGeneratorFunction",
        "prototype"
    ],
    "%AsyncGeneratorPrototype%": [
        "AsyncGeneratorFunction",
        "prototype",
        "prototype"
    ],
    "%BooleanPrototype%": [
        "Boolean",
        "prototype"
    ],
    "%DataViewPrototype%": [
        "DataView",
        "prototype"
    ],
    "%DatePrototype%": [
        "Date",
        "prototype"
    ],
    "%ErrorPrototype%": [
        "Error",
        "prototype"
    ],
    "%EvalErrorPrototype%": [
        "EvalError",
        "prototype"
    ],
    "%Float32ArrayPrototype%": [
        "Float32Array",
        "prototype"
    ],
    "%Float64ArrayPrototype%": [
        "Float64Array",
        "prototype"
    ],
    "%FunctionPrototype%": [
        "Function",
        "prototype"
    ],
    "%Generator%": [
        "GeneratorFunction",
        "prototype"
    ],
    "%GeneratorPrototype%": [
        "GeneratorFunction",
        "prototype",
        "prototype"
    ],
    "%Int8ArrayPrototype%": [
        "Int8Array",
        "prototype"
    ],
    "%Int16ArrayPrototype%": [
        "Int16Array",
        "prototype"
    ],
    "%Int32ArrayPrototype%": [
        "Int32Array",
        "prototype"
    ],
    "%JSONParse%": [
        "JSON",
        "parse"
    ],
    "%JSONStringify%": [
        "JSON",
        "stringify"
    ],
    "%MapPrototype%": [
        "Map",
        "prototype"
    ],
    "%NumberPrototype%": [
        "Number",
        "prototype"
    ],
    "%ObjectPrototype%": [
        "Object",
        "prototype"
    ],
    "%ObjProto_toString%": [
        "Object",
        "prototype",
        "toString"
    ],
    "%ObjProto_valueOf%": [
        "Object",
        "prototype",
        "valueOf"
    ],
    "%PromisePrototype%": [
        "Promise",
        "prototype"
    ],
    "%PromiseProto_then%": [
        "Promise",
        "prototype",
        "then"
    ],
    "%Promise_all%": [
        "Promise",
        "all"
    ],
    "%Promise_reject%": [
        "Promise",
        "reject"
    ],
    "%Promise_resolve%": [
        "Promise",
        "resolve"
    ],
    "%RangeErrorPrototype%": [
        "RangeError",
        "prototype"
    ],
    "%ReferenceErrorPrototype%": [
        "ReferenceError",
        "prototype"
    ],
    "%RegExpPrototype%": [
        "RegExp",
        "prototype"
    ],
    "%SetPrototype%": [
        "Set",
        "prototype"
    ],
    "%SharedArrayBufferPrototype%": [
        "SharedArrayBuffer",
        "prototype"
    ],
    "%StringPrototype%": [
        "String",
        "prototype"
    ],
    "%SymbolPrototype%": [
        "Symbol",
        "prototype"
    ],
    "%SyntaxErrorPrototype%": [
        "SyntaxError",
        "prototype"
    ],
    "%TypedArrayPrototype%": [
        "TypedArray",
        "prototype"
    ],
    "%TypeErrorPrototype%": [
        "TypeError",
        "prototype"
    ],
    "%Uint8ArrayPrototype%": [
        "Uint8Array",
        "prototype"
    ],
    "%Uint8ClampedArrayPrototype%": [
        "Uint8ClampedArray",
        "prototype"
    ],
    "%Uint16ArrayPrototype%": [
        "Uint16Array",
        "prototype"
    ],
    "%Uint32ArrayPrototype%": [
        "Uint32Array",
        "prototype"
    ],
    "%URIErrorPrototype%": [
        "URIError",
        "prototype"
    ],
    "%WeakMapPrototype%": [
        "WeakMap",
        "prototype"
    ],
    "%WeakSetPrototype%": [
        "WeakSet",
        "prototype"
    ]
};
var bind = require("7c5e688e48cd07b0");
var hasOwn = require("b03d0058935d00bf");
var $concat = bind.call(Function.call, Array.prototype.concat);
var $spliceApply = bind.call(Function.apply, Array.prototype.splice);
var $replace = bind.call(Function.call, String.prototype.replace);
var $strSlice = bind.call(Function.call, String.prototype.slice);
var $exec = bind.call(Function.call, RegExp.prototype.exec);
/* adapted from https://github.com/lodash/lodash/blob/4.17.15/dist/lodash.js#L6735-L6744 */ var rePropName = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
var reEscapeChar = /\\(\\)?/g; /** Used to match backslashes in property paths. */ 
var stringToPath = function stringToPath(string) {
    var first = $strSlice(string, 0, 1);
    var last = $strSlice(string, -1);
    if (first === "%" && last !== "%") throw new $SyntaxError("invalid intrinsic syntax, expected closing `%`");
    else if (last === "%" && first !== "%") throw new $SyntaxError("invalid intrinsic syntax, expected opening `%`");
    var result = [];
    $replace(string, rePropName, function(match, number, quote, subString) {
        result[result.length] = quote ? $replace(subString, reEscapeChar, "$1") : number || match;
    });
    return result;
};
/* end adaptation */ var getBaseIntrinsic = function getBaseIntrinsic(name, allowMissing) {
    var intrinsicName = name;
    var alias;
    if (hasOwn(LEGACY_ALIASES, intrinsicName)) {
        alias = LEGACY_ALIASES[intrinsicName];
        intrinsicName = "%" + alias[0] + "%";
    }
    if (hasOwn(INTRINSICS, intrinsicName)) {
        var value = INTRINSICS[intrinsicName];
        if (value === needsEval) value = doEval(intrinsicName);
        if (typeof value === "undefined" && !allowMissing) throw new $TypeError("intrinsic " + name + " exists, but is not available. Please file an issue!");
        return {
            alias: alias,
            name: intrinsicName,
            value: value
        };
    }
    throw new $SyntaxError("intrinsic " + name + " does not exist!");
};
module.exports = function GetIntrinsic(name, allowMissing) {
    if (typeof name !== "string" || name.length === 0) throw new $TypeError("intrinsic name must be a non-empty string");
    if (arguments.length > 1 && typeof allowMissing !== "boolean") throw new $TypeError('"allowMissing" argument must be a boolean');
    if ($exec(/^%?[^%]*%?$/, name) === null) throw new $SyntaxError("`%` may not be present anywhere but at the beginning and end of the intrinsic name");
    var parts = stringToPath(name);
    var intrinsicBaseName = parts.length > 0 ? parts[0] : "";
    var intrinsic = getBaseIntrinsic("%" + intrinsicBaseName + "%", allowMissing);
    var intrinsicRealName = intrinsic.name;
    var value = intrinsic.value;
    var skipFurtherCaching = false;
    var alias = intrinsic.alias;
    if (alias) {
        intrinsicBaseName = alias[0];
        $spliceApply(parts, $concat([
            0,
            1
        ], alias));
    }
    for(var i = 1, isOwn = true; i < parts.length; i += 1){
        var part = parts[i];
        var first = $strSlice(part, 0, 1);
        var last = $strSlice(part, -1);
        if ((first === '"' || first === "'" || first === "`" || last === '"' || last === "'" || last === "`") && first !== last) throw new $SyntaxError("property names with quotes must have matching quotes");
        if (part === "constructor" || !isOwn) skipFurtherCaching = true;
        intrinsicBaseName += "." + part;
        intrinsicRealName = "%" + intrinsicBaseName + "%";
        if (hasOwn(INTRINSICS, intrinsicRealName)) value = INTRINSICS[intrinsicRealName];
        else if (value != null) {
            if (!(part in value)) {
                if (!allowMissing) throw new $TypeError("base intrinsic for " + name + " exists, but the property is not available.");
                return void 0;
            }
            if ($gOPD && i + 1 >= parts.length) {
                var desc = $gOPD(value, part);
                isOwn = !!desc;
                // By convention, when a data property is converted to an accessor
                // property to emulate a data property that does not suffer from
                // the override mistake, that accessor's getter is marked with
                // an `originalValue` property. Here, when we detect this, we
                // uphold the illusion by pretending to see that original data
                // property, i.e., returning the value rather than the getter
                // itself.
                if (isOwn && "get" in desc && !("originalValue" in desc.get)) value = desc.get;
                else value = value[part];
            } else {
                isOwn = hasOwn(value, part);
                value = value[part];
            }
            if (isOwn && !skipFurtherCaching) INTRINSICS[intrinsicRealName] = value;
        }
    }
    return value;
};

},{"1f00f712d594ccf":"7Qiml","23730654306aa64c":"bIcqy","7c5e688e48cd07b0":"42Rnv","b03d0058935d00bf":"654Bi"}],"7Qiml":[function(require,module,exports) {
"use strict";
var origSymbol = typeof Symbol !== "undefined" && Symbol;
var hasSymbolSham = require("3fb25678c62d2fce");
module.exports = function hasNativeSymbols() {
    if (typeof origSymbol !== "function") return false;
    if (typeof Symbol !== "function") return false;
    if (typeof origSymbol("foo") !== "symbol") return false;
    if (typeof Symbol("bar") !== "symbol") return false;
    return hasSymbolSham();
};

},{"3fb25678c62d2fce":"8apFc"}],"8apFc":[function(require,module,exports) {
"use strict";
/* eslint complexity: [2, 18], max-statements: [2, 33] */ module.exports = function hasSymbols() {
    if (typeof Symbol !== "function" || typeof Object.getOwnPropertySymbols !== "function") return false;
    if (typeof Symbol.iterator === "symbol") return true;
    var obj = {};
    var sym = Symbol("test");
    var symObj = Object(sym);
    if (typeof sym === "string") return false;
    if (Object.prototype.toString.call(sym) !== "[object Symbol]") return false;
    if (Object.prototype.toString.call(symObj) !== "[object Symbol]") return false;
    // temp disabled per https://github.com/ljharb/object.assign/issues/17
    // if (sym instanceof Symbol) { return false; }
    // temp disabled per https://github.com/WebReflection/get-own-property-symbols/issues/4
    // if (!(symObj instanceof Symbol)) { return false; }
    // if (typeof Symbol.prototype.toString !== 'function') { return false; }
    // if (String(sym) !== Symbol.prototype.toString.call(sym)) { return false; }
    var symVal = 42;
    obj[sym] = symVal;
    for(sym in obj)return false;
     // eslint-disable-line no-restricted-syntax, no-unreachable-loop
    if (typeof Object.keys === "function" && Object.keys(obj).length !== 0) return false;
    if (typeof Object.getOwnPropertyNames === "function" && Object.getOwnPropertyNames(obj).length !== 0) return false;
    var syms = Object.getOwnPropertySymbols(obj);
    if (syms.length !== 1 || syms[0] !== sym) return false;
    if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) return false;
    if (typeof Object.getOwnPropertyDescriptor === "function") {
        var descriptor = Object.getOwnPropertyDescriptor(obj, sym);
        if (descriptor.value !== symVal || descriptor.enumerable !== true) return false;
    }
    return true;
};

},{}],"bIcqy":[function(require,module,exports) {
"use strict";
var test = {
    foo: {}
};
var $Object = Object;
module.exports = function hasProto() {
    return ({
        __proto__: test
    }).foo === test.foo && !(({
        __proto__: null
    }) instanceof $Object);
};

},{}],"42Rnv":[function(require,module,exports) {
"use strict";
var implementation = require("12e173b4dbaee960");
module.exports = Function.prototype.bind || implementation;

},{"12e173b4dbaee960":"g2Nry"}],"g2Nry":[function(require,module,exports) {
"use strict";
/* eslint no-invalid-this: 1 */ var ERROR_MESSAGE = "Function.prototype.bind called on incompatible ";
var slice = Array.prototype.slice;
var toStr = Object.prototype.toString;
var funcType = "[object Function]";
module.exports = function bind(that) {
    var target = this;
    if (typeof target !== "function" || toStr.call(target) !== funcType) throw new TypeError(ERROR_MESSAGE + target);
    var args = slice.call(arguments, 1);
    var bound;
    var binder = function() {
        if (this instanceof bound) {
            var result = target.apply(this, args.concat(slice.call(arguments)));
            if (Object(result) === result) return result;
            return this;
        } else return target.apply(that, args.concat(slice.call(arguments)));
    };
    var boundLength = Math.max(0, target.length - args.length);
    var boundArgs = [];
    for(var i = 0; i < boundLength; i++)boundArgs.push("$" + i);
    bound = Function("binder", "return function (" + boundArgs.join(",") + "){ return binder.apply(this,arguments); }")(binder);
    if (target.prototype) {
        var Empty = function Empty() {};
        Empty.prototype = target.prototype;
        bound.prototype = new Empty();
        Empty.prototype = null;
    }
    return bound;
};

},{}],"654Bi":[function(require,module,exports) {
"use strict";
var bind = require("ec4f1e1d3f29fa3e");
module.exports = bind.call(Function.call, Object.prototype.hasOwnProperty);

},{"ec4f1e1d3f29fa3e":"42Rnv"}],"eK6wT":[function(require,module,exports) {
"use strict";
var GetIntrinsic = require("8b08ecb81cf4de17");
var callBind = require("266fc50410cfc4a");
var $indexOf = callBind(GetIntrinsic("String.prototype.indexOf"));
module.exports = function callBoundIntrinsic(name, allowMissing) {
    var intrinsic = GetIntrinsic(name, !!allowMissing);
    if (typeof intrinsic === "function" && $indexOf(name, ".prototype.") > -1) return callBind(intrinsic);
    return intrinsic;
};

},{"8b08ecb81cf4de17":"igBhj","266fc50410cfc4a":"8iKie"}],"8iKie":[function(require,module,exports) {
"use strict";
var bind = require("4f9d84d5de4909bc");
var GetIntrinsic = require("68d2ad3775278f43");
var $apply = GetIntrinsic("%Function.prototype.apply%");
var $call = GetIntrinsic("%Function.prototype.call%");
var $reflectApply = GetIntrinsic("%Reflect.apply%", true) || bind.call($call, $apply);
var $gOPD = GetIntrinsic("%Object.getOwnPropertyDescriptor%", true);
var $defineProperty = GetIntrinsic("%Object.defineProperty%", true);
var $max = GetIntrinsic("%Math.max%");
if ($defineProperty) try {
    $defineProperty({}, "a", {
        value: 1
    });
} catch (e) {
    // IE 8 has a broken defineProperty
    $defineProperty = null;
}
module.exports = function callBind(originalFunction) {
    var func = $reflectApply(bind, $call, arguments);
    if ($gOPD && $defineProperty) {
        var desc = $gOPD(func, "length");
        if (desc.configurable) // original length, plus the receiver, minus any additional arguments (after the receiver)
        $defineProperty(func, "length", {
            value: 1 + $max(0, originalFunction.length - (arguments.length - 1))
        });
    }
    return func;
};
var applyBind = function applyBind() {
    return $reflectApply(bind, $apply, arguments);
};
if ($defineProperty) $defineProperty(module.exports, "apply", {
    value: applyBind
});
else module.exports.apply = applyBind;

},{"4f9d84d5de4909bc":"42Rnv","68d2ad3775278f43":"igBhj"}],"87sBP":[function(require,module,exports) {
var hasMap = typeof Map === "function" && Map.prototype;
var mapSizeDescriptor = Object.getOwnPropertyDescriptor && hasMap ? Object.getOwnPropertyDescriptor(Map.prototype, "size") : null;
var mapSize = hasMap && mapSizeDescriptor && typeof mapSizeDescriptor.get === "function" ? mapSizeDescriptor.get : null;
var mapForEach = hasMap && Map.prototype.forEach;
var hasSet = typeof Set === "function" && Set.prototype;
var setSizeDescriptor = Object.getOwnPropertyDescriptor && hasSet ? Object.getOwnPropertyDescriptor(Set.prototype, "size") : null;
var setSize = hasSet && setSizeDescriptor && typeof setSizeDescriptor.get === "function" ? setSizeDescriptor.get : null;
var setForEach = hasSet && Set.prototype.forEach;
var hasWeakMap = typeof WeakMap === "function" && WeakMap.prototype;
var weakMapHas = hasWeakMap ? WeakMap.prototype.has : null;
var hasWeakSet = typeof WeakSet === "function" && WeakSet.prototype;
var weakSetHas = hasWeakSet ? WeakSet.prototype.has : null;
var hasWeakRef = typeof WeakRef === "function" && WeakRef.prototype;
var weakRefDeref = hasWeakRef ? WeakRef.prototype.deref : null;
var booleanValueOf = Boolean.prototype.valueOf;
var objectToString = Object.prototype.toString;
var functionToString = Function.prototype.toString;
var $match = String.prototype.match;
var $slice = String.prototype.slice;
var $replace = String.prototype.replace;
var $toUpperCase = String.prototype.toUpperCase;
var $toLowerCase = String.prototype.toLowerCase;
var $test = RegExp.prototype.test;
var $concat = Array.prototype.concat;
var $join = Array.prototype.join;
var $arrSlice = Array.prototype.slice;
var $floor = Math.floor;
var bigIntValueOf = typeof BigInt === "function" ? BigInt.prototype.valueOf : null;
var gOPS = Object.getOwnPropertySymbols;
var symToString = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? Symbol.prototype.toString : null;
var hasShammedSymbols = typeof Symbol === "function" && typeof Symbol.iterator === "object";
// ie, `has-tostringtag/shams
var toStringTag = typeof Symbol === "function" && Symbol.toStringTag && (typeof Symbol.toStringTag === hasShammedSymbols ? "object" : "symbol") ? Symbol.toStringTag : null;
var isEnumerable = Object.prototype.propertyIsEnumerable;
var gPO = (typeof Reflect === "function" ? Reflect.getPrototypeOf : Object.getPrototypeOf) || ([].__proto__ === Array.prototype // eslint-disable-line no-proto
 ? function(O) {
    return O.__proto__; // eslint-disable-line no-proto
} : null);
function addNumericSeparator(num, str) {
    if (num === Infinity || num === -Infinity || num !== num || num && num > -1000 && num < 1000 || $test.call(/e/, str)) return str;
    var sepRegex = /[0-9](?=(?:[0-9]{3})+(?![0-9]))/g;
    if (typeof num === "number") {
        var int = num < 0 ? -$floor(-num) : $floor(num); // trunc(num)
        if (int !== num) {
            var intStr = String(int);
            var dec = $slice.call(str, intStr.length + 1);
            return $replace.call(intStr, sepRegex, "$&_") + "." + $replace.call($replace.call(dec, /([0-9]{3})/g, "$&_"), /_$/, "");
        }
    }
    return $replace.call(str, sepRegex, "$&_");
}
var utilInspect = require("faefcb1694f2ad90");
var inspectCustom = utilInspect.custom;
var inspectSymbol = isSymbol(inspectCustom) ? inspectCustom : null;
module.exports = function inspect_(obj, options, depth, seen) {
    var opts = options || {};
    if (has(opts, "quoteStyle") && opts.quoteStyle !== "single" && opts.quoteStyle !== "double") throw new TypeError('option "quoteStyle" must be "single" or "double"');
    if (has(opts, "maxStringLength") && (typeof opts.maxStringLength === "number" ? opts.maxStringLength < 0 && opts.maxStringLength !== Infinity : opts.maxStringLength !== null)) throw new TypeError('option "maxStringLength", if provided, must be a positive integer, Infinity, or `null`');
    var customInspect = has(opts, "customInspect") ? opts.customInspect : true;
    if (typeof customInspect !== "boolean" && customInspect !== "symbol") throw new TypeError("option \"customInspect\", if provided, must be `true`, `false`, or `'symbol'`");
    if (has(opts, "indent") && opts.indent !== null && opts.indent !== "	" && !(parseInt(opts.indent, 10) === opts.indent && opts.indent > 0)) throw new TypeError('option "indent" must be "\\t", an integer > 0, or `null`');
    if (has(opts, "numericSeparator") && typeof opts.numericSeparator !== "boolean") throw new TypeError('option "numericSeparator", if provided, must be `true` or `false`');
    var numericSeparator = opts.numericSeparator;
    if (typeof obj === "undefined") return "undefined";
    if (obj === null) return "null";
    if (typeof obj === "boolean") return obj ? "true" : "false";
    if (typeof obj === "string") return inspectString(obj, opts);
    if (typeof obj === "number") {
        if (obj === 0) return Infinity / obj > 0 ? "0" : "-0";
        var str = String(obj);
        return numericSeparator ? addNumericSeparator(obj, str) : str;
    }
    if (typeof obj === "bigint") {
        var bigIntStr = String(obj) + "n";
        return numericSeparator ? addNumericSeparator(obj, bigIntStr) : bigIntStr;
    }
    var maxDepth = typeof opts.depth === "undefined" ? 5 : opts.depth;
    if (typeof depth === "undefined") depth = 0;
    if (depth >= maxDepth && maxDepth > 0 && typeof obj === "object") return isArray(obj) ? "[Array]" : "[Object]";
    var indent = getIndent(opts, depth);
    if (typeof seen === "undefined") seen = [];
    else if (indexOf(seen, obj) >= 0) return "[Circular]";
    function inspect(value, from, noIndent) {
        if (from) {
            seen = $arrSlice.call(seen);
            seen.push(from);
        }
        if (noIndent) {
            var newOpts = {
                depth: opts.depth
            };
            if (has(opts, "quoteStyle")) newOpts.quoteStyle = opts.quoteStyle;
            return inspect_(value, newOpts, depth + 1, seen);
        }
        return inspect_(value, opts, depth + 1, seen);
    }
    if (typeof obj === "function" && !isRegExp(obj)) {
        var name = nameOf(obj);
        var keys = arrObjKeys(obj, inspect);
        return "[Function" + (name ? ": " + name : " (anonymous)") + "]" + (keys.length > 0 ? " { " + $join.call(keys, ", ") + " }" : "");
    }
    if (isSymbol(obj)) {
        var symString = hasShammedSymbols ? $replace.call(String(obj), /^(Symbol\(.*\))_[^)]*$/, "$1") : symToString.call(obj);
        return typeof obj === "object" && !hasShammedSymbols ? markBoxed(symString) : symString;
    }
    if (isElement(obj)) {
        var s = "<" + $toLowerCase.call(String(obj.nodeName));
        var attrs = obj.attributes || [];
        for(var i = 0; i < attrs.length; i++)s += " " + attrs[i].name + "=" + wrapQuotes(quote(attrs[i].value), "double", opts);
        s += ">";
        if (obj.childNodes && obj.childNodes.length) s += "...";
        s += "</" + $toLowerCase.call(String(obj.nodeName)) + ">";
        return s;
    }
    if (isArray(obj)) {
        if (obj.length === 0) return "[]";
        var xs = arrObjKeys(obj, inspect);
        if (indent && !singleLineValues(xs)) return "[" + indentedJoin(xs, indent) + "]";
        return "[ " + $join.call(xs, ", ") + " ]";
    }
    if (isError(obj)) {
        var parts = arrObjKeys(obj, inspect);
        if (!("cause" in Error.prototype) && "cause" in obj && !isEnumerable.call(obj, "cause")) return "{ [" + String(obj) + "] " + $join.call($concat.call("[cause]: " + inspect(obj.cause), parts), ", ") + " }";
        if (parts.length === 0) return "[" + String(obj) + "]";
        return "{ [" + String(obj) + "] " + $join.call(parts, ", ") + " }";
    }
    if (typeof obj === "object" && customInspect) {
        if (inspectSymbol && typeof obj[inspectSymbol] === "function" && utilInspect) return utilInspect(obj, {
            depth: maxDepth - depth
        });
        else if (customInspect !== "symbol" && typeof obj.inspect === "function") return obj.inspect();
    }
    if (isMap(obj)) {
        var mapParts = [];
        if (mapForEach) mapForEach.call(obj, function(value, key) {
            mapParts.push(inspect(key, obj, true) + " => " + inspect(value, obj));
        });
        return collectionOf("Map", mapSize.call(obj), mapParts, indent);
    }
    if (isSet(obj)) {
        var setParts = [];
        if (setForEach) setForEach.call(obj, function(value) {
            setParts.push(inspect(value, obj));
        });
        return collectionOf("Set", setSize.call(obj), setParts, indent);
    }
    if (isWeakMap(obj)) return weakCollectionOf("WeakMap");
    if (isWeakSet(obj)) return weakCollectionOf("WeakSet");
    if (isWeakRef(obj)) return weakCollectionOf("WeakRef");
    if (isNumber(obj)) return markBoxed(inspect(Number(obj)));
    if (isBigInt(obj)) return markBoxed(inspect(bigIntValueOf.call(obj)));
    if (isBoolean(obj)) return markBoxed(booleanValueOf.call(obj));
    if (isString(obj)) return markBoxed(inspect(String(obj)));
    if (!isDate(obj) && !isRegExp(obj)) {
        var ys = arrObjKeys(obj, inspect);
        var isPlainObject = gPO ? gPO(obj) === Object.prototype : obj instanceof Object || obj.constructor === Object;
        var protoTag = obj instanceof Object ? "" : "null prototype";
        var stringTag = !isPlainObject && toStringTag && Object(obj) === obj && toStringTag in obj ? $slice.call(toStr(obj), 8, -1) : protoTag ? "Object" : "";
        var constructorTag = isPlainObject || typeof obj.constructor !== "function" ? "" : obj.constructor.name ? obj.constructor.name + " " : "";
        var tag = constructorTag + (stringTag || protoTag ? "[" + $join.call($concat.call([], stringTag || [], protoTag || []), ": ") + "] " : "");
        if (ys.length === 0) return tag + "{}";
        if (indent) return tag + "{" + indentedJoin(ys, indent) + "}";
        return tag + "{ " + $join.call(ys, ", ") + " }";
    }
    return String(obj);
};
function wrapQuotes(s, defaultStyle, opts) {
    var quoteChar = (opts.quoteStyle || defaultStyle) === "double" ? '"' : "'";
    return quoteChar + s + quoteChar;
}
function quote(s) {
    return $replace.call(String(s), /"/g, "&quot;");
}
function isArray(obj) {
    return toStr(obj) === "[object Array]" && (!toStringTag || !(typeof obj === "object" && toStringTag in obj));
}
function isDate(obj) {
    return toStr(obj) === "[object Date]" && (!toStringTag || !(typeof obj === "object" && toStringTag in obj));
}
function isRegExp(obj) {
    return toStr(obj) === "[object RegExp]" && (!toStringTag || !(typeof obj === "object" && toStringTag in obj));
}
function isError(obj) {
    return toStr(obj) === "[object Error]" && (!toStringTag || !(typeof obj === "object" && toStringTag in obj));
}
function isString(obj) {
    return toStr(obj) === "[object String]" && (!toStringTag || !(typeof obj === "object" && toStringTag in obj));
}
function isNumber(obj) {
    return toStr(obj) === "[object Number]" && (!toStringTag || !(typeof obj === "object" && toStringTag in obj));
}
function isBoolean(obj) {
    return toStr(obj) === "[object Boolean]" && (!toStringTag || !(typeof obj === "object" && toStringTag in obj));
}
// Symbol and BigInt do have Symbol.toStringTag by spec, so that can't be used to eliminate false positives
function isSymbol(obj) {
    if (hasShammedSymbols) return obj && typeof obj === "object" && obj instanceof Symbol;
    if (typeof obj === "symbol") return true;
    if (!obj || typeof obj !== "object" || !symToString) return false;
    try {
        symToString.call(obj);
        return true;
    } catch (e) {}
    return false;
}
function isBigInt(obj) {
    if (!obj || typeof obj !== "object" || !bigIntValueOf) return false;
    try {
        bigIntValueOf.call(obj);
        return true;
    } catch (e) {}
    return false;
}
var hasOwn = Object.prototype.hasOwnProperty || function(key) {
    return key in this;
};
function has(obj, key) {
    return hasOwn.call(obj, key);
}
function toStr(obj) {
    return objectToString.call(obj);
}
function nameOf(f) {
    if (f.name) return f.name;
    var m = $match.call(functionToString.call(f), /^function\s*([\w$]+)/);
    if (m) return m[1];
    return null;
}
function indexOf(xs, x) {
    if (xs.indexOf) return xs.indexOf(x);
    for(var i = 0, l = xs.length; i < l; i++){
        if (xs[i] === x) return i;
    }
    return -1;
}
function isMap(x) {
    if (!mapSize || !x || typeof x !== "object") return false;
    try {
        mapSize.call(x);
        try {
            setSize.call(x);
        } catch (s) {
            return true;
        }
        return x instanceof Map; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}
function isWeakMap(x) {
    if (!weakMapHas || !x || typeof x !== "object") return false;
    try {
        weakMapHas.call(x, weakMapHas);
        try {
            weakSetHas.call(x, weakSetHas);
        } catch (s) {
            return true;
        }
        return x instanceof WeakMap; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}
function isWeakRef(x) {
    if (!weakRefDeref || !x || typeof x !== "object") return false;
    try {
        weakRefDeref.call(x);
        return true;
    } catch (e) {}
    return false;
}
function isSet(x) {
    if (!setSize || !x || typeof x !== "object") return false;
    try {
        setSize.call(x);
        try {
            mapSize.call(x);
        } catch (m) {
            return true;
        }
        return x instanceof Set; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}
function isWeakSet(x) {
    if (!weakSetHas || !x || typeof x !== "object") return false;
    try {
        weakSetHas.call(x, weakSetHas);
        try {
            weakMapHas.call(x, weakMapHas);
        } catch (s) {
            return true;
        }
        return x instanceof WeakSet; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}
function isElement(x) {
    if (!x || typeof x !== "object") return false;
    if (typeof HTMLElement !== "undefined" && x instanceof HTMLElement) return true;
    return typeof x.nodeName === "string" && typeof x.getAttribute === "function";
}
function inspectString(str, opts) {
    if (str.length > opts.maxStringLength) {
        var remaining = str.length - opts.maxStringLength;
        var trailer = "... " + remaining + " more character" + (remaining > 1 ? "s" : "");
        return inspectString($slice.call(str, 0, opts.maxStringLength), opts) + trailer;
    }
    // eslint-disable-next-line no-control-regex
    var s = $replace.call($replace.call(str, /(['\\])/g, "\\$1"), /[\x00-\x1f]/g, lowbyte);
    return wrapQuotes(s, "single", opts);
}
function lowbyte(c) {
    var n = c.charCodeAt(0);
    var x = {
        8: "b",
        9: "t",
        10: "n",
        12: "f",
        13: "r"
    }[n];
    if (x) return "\\" + x;
    return "\\x" + (n < 0x10 ? "0" : "") + $toUpperCase.call(n.toString(16));
}
function markBoxed(str) {
    return "Object(" + str + ")";
}
function weakCollectionOf(type) {
    return type + " { ? }";
}
function collectionOf(type, size, entries, indent) {
    var joinedEntries = indent ? indentedJoin(entries, indent) : $join.call(entries, ", ");
    return type + " (" + size + ") {" + joinedEntries + "}";
}
function singleLineValues(xs) {
    for(var i = 0; i < xs.length; i++){
        if (indexOf(xs[i], "\n") >= 0) return false;
    }
    return true;
}
function getIndent(opts, depth) {
    var baseIndent;
    if (opts.indent === "	") baseIndent = "	";
    else if (typeof opts.indent === "number" && opts.indent > 0) baseIndent = $join.call(Array(opts.indent + 1), " ");
    else return null;
    return {
        base: baseIndent,
        prev: $join.call(Array(depth + 1), baseIndent)
    };
}
function indentedJoin(xs, indent) {
    if (xs.length === 0) return "";
    var lineJoiner = "\n" + indent.prev + indent.base;
    return lineJoiner + $join.call(xs, "," + lineJoiner) + "\n" + indent.prev;
}
function arrObjKeys(obj, inspect) {
    var isArr = isArray(obj);
    var xs = [];
    if (isArr) {
        xs.length = obj.length;
        for(var i = 0; i < obj.length; i++)xs[i] = has(obj, i) ? inspect(obj[i], obj) : "";
    }
    var syms = typeof gOPS === "function" ? gOPS(obj) : [];
    var symMap;
    if (hasShammedSymbols) {
        symMap = {};
        for(var k = 0; k < syms.length; k++)symMap["$" + syms[k]] = syms[k];
    }
    for(var key in obj){
        if (!has(obj, key)) continue;
         // eslint-disable-line no-restricted-syntax, no-continue
        if (isArr && String(Number(key)) === key && key < obj.length) continue;
         // eslint-disable-line no-restricted-syntax, no-continue
        if (hasShammedSymbols && symMap["$" + key] instanceof Symbol) continue; // eslint-disable-line no-restricted-syntax, no-continue
        else if ($test.call(/[^\w$]/, key)) xs.push(inspect(key, obj) + ": " + inspect(obj[key], obj));
        else xs.push(key + ": " + inspect(obj[key], obj));
    }
    if (typeof gOPS === "function") {
        for(var j = 0; j < syms.length; j++)if (isEnumerable.call(obj, syms[j])) xs.push("[" + inspect(syms[j]) + "]: " + inspect(obj[syms[j]], obj));
    }
    return xs;
}

},{"faefcb1694f2ad90":"13Pcp"}],"3YhBn":[function(require,module,exports) {
"use strict";
var formats = require("7adf3674f81a2c87");
var has = Object.prototype.hasOwnProperty;
var isArray = Array.isArray;
var hexTable = function() {
    var array = [];
    for(var i = 0; i < 256; ++i)array.push("%" + ((i < 16 ? "0" : "") + i.toString(16)).toUpperCase());
    return array;
}();
var compactQueue = function compactQueue(queue) {
    while(queue.length > 1){
        var item = queue.pop();
        var obj = item.obj[item.prop];
        if (isArray(obj)) {
            var compacted = [];
            for(var j = 0; j < obj.length; ++j)if (typeof obj[j] !== "undefined") compacted.push(obj[j]);
            item.obj[item.prop] = compacted;
        }
    }
};
var arrayToObject = function arrayToObject(source, options) {
    var obj = options && options.plainObjects ? Object.create(null) : {};
    for(var i = 0; i < source.length; ++i)if (typeof source[i] !== "undefined") obj[i] = source[i];
    return obj;
};
var merge = function merge(target, source, options) {
    /* eslint no-param-reassign: 0 */ if (!source) return target;
    if (typeof source !== "object") {
        if (isArray(target)) target.push(source);
        else if (target && typeof target === "object") {
            if (options && (options.plainObjects || options.allowPrototypes) || !has.call(Object.prototype, source)) target[source] = true;
        } else return [
            target,
            source
        ];
        return target;
    }
    if (!target || typeof target !== "object") return [
        target
    ].concat(source);
    var mergeTarget = target;
    if (isArray(target) && !isArray(source)) mergeTarget = arrayToObject(target, options);
    if (isArray(target) && isArray(source)) {
        source.forEach(function(item, i) {
            if (has.call(target, i)) {
                var targetItem = target[i];
                if (targetItem && typeof targetItem === "object" && item && typeof item === "object") target[i] = merge(targetItem, item, options);
                else target.push(item);
            } else target[i] = item;
        });
        return target;
    }
    return Object.keys(source).reduce(function(acc, key) {
        var value = source[key];
        if (has.call(acc, key)) acc[key] = merge(acc[key], value, options);
        else acc[key] = value;
        return acc;
    }, mergeTarget);
};
var assign = function assignSingleSource(target, source) {
    return Object.keys(source).reduce(function(acc, key) {
        acc[key] = source[key];
        return acc;
    }, target);
};
var decode = function(str, decoder, charset) {
    var strWithoutPlus = str.replace(/\+/g, " ");
    if (charset === "iso-8859-1") // unescape never throws, no try...catch needed:
    return strWithoutPlus.replace(/%[0-9a-f]{2}/gi, unescape);
    // utf-8
    try {
        return decodeURIComponent(strWithoutPlus);
    } catch (e) {
        return strWithoutPlus;
    }
};
var encode = function encode(str, defaultEncoder, charset, kind, format) {
    // This code was originally written by Brian White (mscdex) for the io.js core querystring library.
    // It has been adapted here for stricter adherence to RFC 3986
    if (str.length === 0) return str;
    var string = str;
    if (typeof str === "symbol") string = Symbol.prototype.toString.call(str);
    else if (typeof str !== "string") string = String(str);
    if (charset === "iso-8859-1") return escape(string).replace(/%u[0-9a-f]{4}/gi, function($0) {
        return "%26%23" + parseInt($0.slice(2), 16) + "%3B";
    });
    var out = "";
    for(var i = 0; i < string.length; ++i){
        var c = string.charCodeAt(i);
        if (c === 0x2D // -
         || c === 0x2E // .
         || c === 0x5F // _
         || c === 0x7E // ~
         || c >= 0x30 && c <= 0x39 // 0-9
         || c >= 0x41 && c <= 0x5A // a-z
         || c >= 0x61 && c <= 0x7A // A-Z
         || format === formats.RFC1738 && (c === 0x28 || c === 0x29) // ( )
        ) {
            out += string.charAt(i);
            continue;
        }
        if (c < 0x80) {
            out = out + hexTable[c];
            continue;
        }
        if (c < 0x800) {
            out = out + (hexTable[0xC0 | c >> 6] + hexTable[0x80 | c & 0x3F]);
            continue;
        }
        if (c < 0xD800 || c >= 0xE000) {
            out = out + (hexTable[0xE0 | c >> 12] + hexTable[0x80 | c >> 6 & 0x3F] + hexTable[0x80 | c & 0x3F]);
            continue;
        }
        i += 1;
        c = 0x10000 + ((c & 0x3FF) << 10 | string.charCodeAt(i) & 0x3FF);
        /* eslint operator-linebreak: [2, "before"] */ out += hexTable[0xF0 | c >> 18] + hexTable[0x80 | c >> 12 & 0x3F] + hexTable[0x80 | c >> 6 & 0x3F] + hexTable[0x80 | c & 0x3F];
    }
    return out;
};
var compact = function compact(value) {
    var queue = [
        {
            obj: {
                o: value
            },
            prop: "o"
        }
    ];
    var refs = [];
    for(var i = 0; i < queue.length; ++i){
        var item = queue[i];
        var obj = item.obj[item.prop];
        var keys = Object.keys(obj);
        for(var j = 0; j < keys.length; ++j){
            var key = keys[j];
            var val = obj[key];
            if (typeof val === "object" && val !== null && refs.indexOf(val) === -1) {
                queue.push({
                    obj: obj,
                    prop: key
                });
                refs.push(val);
            }
        }
    }
    compactQueue(queue);
    return value;
};
var isRegExp = function isRegExp(obj) {
    return Object.prototype.toString.call(obj) === "[object RegExp]";
};
var isBuffer = function isBuffer(obj) {
    if (!obj || typeof obj !== "object") return false;
    return !!(obj.constructor && obj.constructor.isBuffer && obj.constructor.isBuffer(obj));
};
var combine = function combine(a, b) {
    return [].concat(a, b);
};
var maybeMap = function maybeMap(val, fn) {
    if (isArray(val)) {
        var mapped = [];
        for(var i = 0; i < val.length; i += 1)mapped.push(fn(val[i]));
        return mapped;
    }
    return fn(val);
};
module.exports = {
    arrayToObject: arrayToObject,
    assign: assign,
    combine: combine,
    compact: compact,
    decode: decode,
    encode: encode,
    isBuffer: isBuffer,
    isRegExp: isRegExp,
    maybeMap: maybeMap,
    merge: merge
};

},{"7adf3674f81a2c87":"4FjOV"}],"4FjOV":[function(require,module,exports) {
"use strict";
var replace = String.prototype.replace;
var percentTwenties = /%20/g;
var Format = {
    RFC1738: "RFC1738",
    RFC3986: "RFC3986"
};
module.exports = {
    "default": Format.RFC3986,
    formatters: {
        RFC1738: function(value) {
            return replace.call(value, percentTwenties, "+");
        },
        RFC3986: function(value) {
            return String(value);
        }
    },
    RFC1738: Format.RFC1738,
    RFC3986: Format.RFC3986
};

},{}],"4TH1Q":[function(require,module,exports) {
"use strict";
var utils = require("e76649c95dd0e736");
var has = Object.prototype.hasOwnProperty;
var isArray = Array.isArray;
var defaults = {
    allowDots: false,
    allowPrototypes: false,
    allowSparse: false,
    arrayLimit: 20,
    charset: "utf-8",
    charsetSentinel: false,
    comma: false,
    decoder: utils.decode,
    delimiter: "&",
    depth: 5,
    ignoreQueryPrefix: false,
    interpretNumericEntities: false,
    parameterLimit: 1000,
    parseArrays: true,
    plainObjects: false,
    strictNullHandling: false
};
var interpretNumericEntities = function(str) {
    return str.replace(/&#(\d+);/g, function($0, numberStr) {
        return String.fromCharCode(parseInt(numberStr, 10));
    });
};
var parseArrayValue = function(val, options) {
    if (val && typeof val === "string" && options.comma && val.indexOf(",") > -1) return val.split(",");
    return val;
};
// This is what browsers will submit when the ✓ character occurs in an
// application/x-www-form-urlencoded body and the encoding of the page containing
// the form is iso-8859-1, or when the submitted form has an accept-charset
// attribute of iso-8859-1. Presumably also with other charsets that do not contain
// the ✓ character, such as us-ascii.
var isoSentinel = "utf8=%26%2310003%3B"; // encodeURIComponent('&#10003;')
// These are the percent-encoded utf-8 octets representing a checkmark, indicating that the request actually is utf-8 encoded.
var charsetSentinel = "utf8=%E2%9C%93"; // encodeURIComponent('✓')
var parseValues = function parseQueryStringValues(str, options) {
    var obj = {
        __proto__: null
    };
    var cleanStr = options.ignoreQueryPrefix ? str.replace(/^\?/, "") : str;
    var limit = options.parameterLimit === Infinity ? undefined : options.parameterLimit;
    var parts = cleanStr.split(options.delimiter, limit);
    var skipIndex = -1; // Keep track of where the utf8 sentinel was found
    var i;
    var charset = options.charset;
    if (options.charsetSentinel) {
        for(i = 0; i < parts.length; ++i)if (parts[i].indexOf("utf8=") === 0) {
            if (parts[i] === charsetSentinel) charset = "utf-8";
            else if (parts[i] === isoSentinel) charset = "iso-8859-1";
            skipIndex = i;
            i = parts.length; // The eslint settings do not allow break;
        }
    }
    for(i = 0; i < parts.length; ++i){
        if (i === skipIndex) continue;
        var part = parts[i];
        var bracketEqualsPos = part.indexOf("]=");
        var pos = bracketEqualsPos === -1 ? part.indexOf("=") : bracketEqualsPos + 1;
        var key, val;
        if (pos === -1) {
            key = options.decoder(part, defaults.decoder, charset, "key");
            val = options.strictNullHandling ? null : "";
        } else {
            key = options.decoder(part.slice(0, pos), defaults.decoder, charset, "key");
            val = utils.maybeMap(parseArrayValue(part.slice(pos + 1), options), function(encodedVal) {
                return options.decoder(encodedVal, defaults.decoder, charset, "value");
            });
        }
        if (val && options.interpretNumericEntities && charset === "iso-8859-1") val = interpretNumericEntities(val);
        if (part.indexOf("[]=") > -1) val = isArray(val) ? [
            val
        ] : val;
        if (has.call(obj, key)) obj[key] = utils.combine(obj[key], val);
        else obj[key] = val;
    }
    return obj;
};
var parseObject = function(chain, val, options, valuesParsed) {
    var leaf = valuesParsed ? val : parseArrayValue(val, options);
    for(var i = chain.length - 1; i >= 0; --i){
        var obj;
        var root = chain[i];
        if (root === "[]" && options.parseArrays) obj = [].concat(leaf);
        else {
            obj = options.plainObjects ? Object.create(null) : {};
            var cleanRoot = root.charAt(0) === "[" && root.charAt(root.length - 1) === "]" ? root.slice(1, -1) : root;
            var index = parseInt(cleanRoot, 10);
            if (!options.parseArrays && cleanRoot === "") obj = {
                0: leaf
            };
            else if (!isNaN(index) && root !== cleanRoot && String(index) === cleanRoot && index >= 0 && options.parseArrays && index <= options.arrayLimit) {
                obj = [];
                obj[index] = leaf;
            } else if (cleanRoot !== "__proto__") obj[cleanRoot] = leaf;
        }
        leaf = obj;
    }
    return leaf;
};
var parseKeys = function parseQueryStringKeys(givenKey, val, options, valuesParsed) {
    if (!givenKey) return;
    // Transform dot notation to bracket notation
    var key = options.allowDots ? givenKey.replace(/\.([^.[]+)/g, "[$1]") : givenKey;
    // The regex chunks
    var brackets = /(\[[^[\]]*])/;
    var child = /(\[[^[\]]*])/g;
    // Get the parent
    var segment = options.depth > 0 && brackets.exec(key);
    var parent = segment ? key.slice(0, segment.index) : key;
    // Stash the parent if it exists
    var keys = [];
    if (parent) {
        // If we aren't using plain objects, optionally prefix keys that would overwrite object prototype properties
        if (!options.plainObjects && has.call(Object.prototype, parent)) {
            if (!options.allowPrototypes) return;
        }
        keys.push(parent);
    }
    // Loop through children appending to the array until we hit depth
    var i = 0;
    while(options.depth > 0 && (segment = child.exec(key)) !== null && i < options.depth){
        i += 1;
        if (!options.plainObjects && has.call(Object.prototype, segment[1].slice(1, -1))) {
            if (!options.allowPrototypes) return;
        }
        keys.push(segment[1]);
    }
    // If there's a remainder, just add whatever is left
    if (segment) keys.push("[" + key.slice(segment.index) + "]");
    return parseObject(keys, val, options, valuesParsed);
};
var normalizeParseOptions = function normalizeParseOptions(opts) {
    if (!opts) return defaults;
    if (opts.decoder !== null && opts.decoder !== undefined && typeof opts.decoder !== "function") throw new TypeError("Decoder has to be a function.");
    if (typeof opts.charset !== "undefined" && opts.charset !== "utf-8" && opts.charset !== "iso-8859-1") throw new TypeError("The charset option must be either utf-8, iso-8859-1, or undefined");
    var charset = typeof opts.charset === "undefined" ? defaults.charset : opts.charset;
    return {
        allowDots: typeof opts.allowDots === "undefined" ? defaults.allowDots : !!opts.allowDots,
        allowPrototypes: typeof opts.allowPrototypes === "boolean" ? opts.allowPrototypes : defaults.allowPrototypes,
        allowSparse: typeof opts.allowSparse === "boolean" ? opts.allowSparse : defaults.allowSparse,
        arrayLimit: typeof opts.arrayLimit === "number" ? opts.arrayLimit : defaults.arrayLimit,
        charset: charset,
        charsetSentinel: typeof opts.charsetSentinel === "boolean" ? opts.charsetSentinel : defaults.charsetSentinel,
        comma: typeof opts.comma === "boolean" ? opts.comma : defaults.comma,
        decoder: typeof opts.decoder === "function" ? opts.decoder : defaults.decoder,
        delimiter: typeof opts.delimiter === "string" || utils.isRegExp(opts.delimiter) ? opts.delimiter : defaults.delimiter,
        // eslint-disable-next-line no-implicit-coercion, no-extra-parens
        depth: typeof opts.depth === "number" || opts.depth === false ? +opts.depth : defaults.depth,
        ignoreQueryPrefix: opts.ignoreQueryPrefix === true,
        interpretNumericEntities: typeof opts.interpretNumericEntities === "boolean" ? opts.interpretNumericEntities : defaults.interpretNumericEntities,
        parameterLimit: typeof opts.parameterLimit === "number" ? opts.parameterLimit : defaults.parameterLimit,
        parseArrays: opts.parseArrays !== false,
        plainObjects: typeof opts.plainObjects === "boolean" ? opts.plainObjects : defaults.plainObjects,
        strictNullHandling: typeof opts.strictNullHandling === "boolean" ? opts.strictNullHandling : defaults.strictNullHandling
    };
};
module.exports = function(str, opts) {
    var options = normalizeParseOptions(opts);
    if (str === "" || str === null || typeof str === "undefined") return options.plainObjects ? Object.create(null) : {};
    var tempObj = typeof str === "string" ? parseValues(str, options) : str;
    var obj = options.plainObjects ? Object.create(null) : {};
    // Iterate over the keys and setup the new object
    var keys = Object.keys(tempObj);
    for(var i = 0; i < keys.length; ++i){
        var key = keys[i];
        var newObj = parseKeys(key, tempObj[key], options, typeof str === "string");
        obj = utils.merge(obj, newObj, options);
    }
    if (options.allowSparse === true) return obj;
    return utils.compact(obj);
};

},{"e76649c95dd0e736":"3YhBn"}],"gpdoD":[function(require,module,exports) {
// the whatwg-fetch polyfill installs the fetch() function
// on the global object (window or self)
//
// Return that as the export for use in Webpack, Browserify etc.
require("7469aeb5da0d2942");
module.exports = self.fetch.bind(self);

},{"7469aeb5da0d2942":"3NSiq"}],"3NSiq":[function(require,module,exports) {
/* eslint-disable no-prototype-builtins */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Headers", ()=>Headers);
parcelHelpers.export(exports, "Request", ()=>Request);
parcelHelpers.export(exports, "Response", ()=>Response);
parcelHelpers.export(exports, "DOMException", ()=>DOMException);
parcelHelpers.export(exports, "fetch", ()=>fetch);
var global = arguments[3];
var g = typeof globalThis !== "undefined" && globalThis || typeof self !== "undefined" && self || // eslint-disable-next-line no-undef
typeof global !== "undefined" && global || {};
var support = {
    searchParams: "URLSearchParams" in g,
    iterable: "Symbol" in g && "iterator" in Symbol,
    blob: "FileReader" in g && "Blob" in g && function() {
        try {
            new Blob();
            return true;
        } catch (e) {
            return false;
        }
    }(),
    formData: "FormData" in g,
    arrayBuffer: "ArrayBuffer" in g
};
function isDataView(obj) {
    return obj && DataView.prototype.isPrototypeOf(obj);
}
if (support.arrayBuffer) {
    var viewClasses = [
        "[object Int8Array]",
        "[object Uint8Array]",
        "[object Uint8ClampedArray]",
        "[object Int16Array]",
        "[object Uint16Array]",
        "[object Int32Array]",
        "[object Uint32Array]",
        "[object Float32Array]",
        "[object Float64Array]"
    ];
    var isArrayBufferView = ArrayBuffer.isView || function(obj) {
        return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1;
    };
}
function normalizeName(name) {
    if (typeof name !== "string") name = String(name);
    if (/[^a-z0-9\-#$%&'*+.^_`|~!]/i.test(name) || name === "") throw new TypeError('Invalid character in header field name: "' + name + '"');
    return name.toLowerCase();
}
function normalizeValue(value) {
    if (typeof value !== "string") value = String(value);
    return value;
}
// Build a destructive iterator for the value list
function iteratorFor(items) {
    var iterator = {
        next: function() {
            var value = items.shift();
            return {
                done: value === undefined,
                value: value
            };
        }
    };
    if (support.iterable) iterator[Symbol.iterator] = function() {
        return iterator;
    };
    return iterator;
}
function Headers(headers) {
    this.map = {};
    if (headers instanceof Headers) headers.forEach(function(value, name) {
        this.append(name, value);
    }, this);
    else if (Array.isArray(headers)) headers.forEach(function(header) {
        if (header.length != 2) throw new TypeError("Headers constructor: expected name/value pair to be length 2, found" + header.length);
        this.append(header[0], header[1]);
    }, this);
    else if (headers) Object.getOwnPropertyNames(headers).forEach(function(name) {
        this.append(name, headers[name]);
    }, this);
}
Headers.prototype.append = function(name, value) {
    name = normalizeName(name);
    value = normalizeValue(value);
    var oldValue = this.map[name];
    this.map[name] = oldValue ? oldValue + ", " + value : value;
};
Headers.prototype["delete"] = function(name) {
    delete this.map[normalizeName(name)];
};
Headers.prototype.get = function(name) {
    name = normalizeName(name);
    return this.has(name) ? this.map[name] : null;
};
Headers.prototype.has = function(name) {
    return this.map.hasOwnProperty(normalizeName(name));
};
Headers.prototype.set = function(name, value) {
    this.map[normalizeName(name)] = normalizeValue(value);
};
Headers.prototype.forEach = function(callback, thisArg) {
    for(var name in this.map)if (this.map.hasOwnProperty(name)) callback.call(thisArg, this.map[name], name, this);
};
Headers.prototype.keys = function() {
    var items = [];
    this.forEach(function(value, name) {
        items.push(name);
    });
    return iteratorFor(items);
};
Headers.prototype.values = function() {
    var items = [];
    this.forEach(function(value) {
        items.push(value);
    });
    return iteratorFor(items);
};
Headers.prototype.entries = function() {
    var items = [];
    this.forEach(function(value, name) {
        items.push([
            name,
            value
        ]);
    });
    return iteratorFor(items);
};
if (support.iterable) Headers.prototype[Symbol.iterator] = Headers.prototype.entries;
function consumed(body) {
    if (body._noBody) return;
    if (body.bodyUsed) return Promise.reject(new TypeError("Already read"));
    body.bodyUsed = true;
}
function fileReaderReady(reader) {
    return new Promise(function(resolve, reject) {
        reader.onload = function() {
            resolve(reader.result);
        };
        reader.onerror = function() {
            reject(reader.error);
        };
    });
}
function readBlobAsArrayBuffer(blob) {
    var reader = new FileReader();
    var promise = fileReaderReady(reader);
    reader.readAsArrayBuffer(blob);
    return promise;
}
function readBlobAsText(blob) {
    var reader = new FileReader();
    var promise = fileReaderReady(reader);
    var match = /charset=([A-Za-z0-9_-]+)/.exec(blob.type);
    var encoding = match ? match[1] : "utf-8";
    reader.readAsText(blob, encoding);
    return promise;
}
function readArrayBufferAsText(buf) {
    var view = new Uint8Array(buf);
    var chars = new Array(view.length);
    for(var i = 0; i < view.length; i++)chars[i] = String.fromCharCode(view[i]);
    return chars.join("");
}
function bufferClone(buf) {
    if (buf.slice) return buf.slice(0);
    else {
        var view = new Uint8Array(buf.byteLength);
        view.set(new Uint8Array(buf));
        return view.buffer;
    }
}
function Body() {
    this.bodyUsed = false;
    this._initBody = function(body) {
        /*
      fetch-mock wraps the Response object in an ES6 Proxy to
      provide useful test harness features such as flush. However, on
      ES5 browsers without fetch or Proxy support pollyfills must be used;
      the proxy-pollyfill is unable to proxy an attribute unless it exists
      on the object before the Proxy is created. This change ensures
      Response.bodyUsed exists on the instance, while maintaining the
      semantic of setting Request.bodyUsed in the constructor before
      _initBody is called.
    */ // eslint-disable-next-line no-self-assign
        this.bodyUsed = this.bodyUsed;
        this._bodyInit = body;
        if (!body) {
            this._noBody = true;
            this._bodyText = "";
        } else if (typeof body === "string") this._bodyText = body;
        else if (support.blob && Blob.prototype.isPrototypeOf(body)) this._bodyBlob = body;
        else if (support.formData && FormData.prototype.isPrototypeOf(body)) this._bodyFormData = body;
        else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) this._bodyText = body.toString();
        else if (support.arrayBuffer && support.blob && isDataView(body)) {
            this._bodyArrayBuffer = bufferClone(body.buffer);
            // IE 10-11 can't handle a DataView body.
            this._bodyInit = new Blob([
                this._bodyArrayBuffer
            ]);
        } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) this._bodyArrayBuffer = bufferClone(body);
        else this._bodyText = body = Object.prototype.toString.call(body);
        if (!this.headers.get("content-type")) {
            if (typeof body === "string") this.headers.set("content-type", "text/plain;charset=UTF-8");
            else if (this._bodyBlob && this._bodyBlob.type) this.headers.set("content-type", this._bodyBlob.type);
            else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) this.headers.set("content-type", "application/x-www-form-urlencoded;charset=UTF-8");
        }
    };
    if (support.blob) this.blob = function() {
        var rejected = consumed(this);
        if (rejected) return rejected;
        if (this._bodyBlob) return Promise.resolve(this._bodyBlob);
        else if (this._bodyArrayBuffer) return Promise.resolve(new Blob([
            this._bodyArrayBuffer
        ]));
        else if (this._bodyFormData) throw new Error("could not read FormData body as blob");
        else return Promise.resolve(new Blob([
            this._bodyText
        ]));
    };
    this.arrayBuffer = function() {
        if (this._bodyArrayBuffer) {
            var isConsumed = consumed(this);
            if (isConsumed) return isConsumed;
            else if (ArrayBuffer.isView(this._bodyArrayBuffer)) return Promise.resolve(this._bodyArrayBuffer.buffer.slice(this._bodyArrayBuffer.byteOffset, this._bodyArrayBuffer.byteOffset + this._bodyArrayBuffer.byteLength));
            else return Promise.resolve(this._bodyArrayBuffer);
        } else if (support.blob) return this.blob().then(readBlobAsArrayBuffer);
        else throw new Error("could not read as ArrayBuffer");
    };
    this.text = function() {
        var rejected = consumed(this);
        if (rejected) return rejected;
        if (this._bodyBlob) return readBlobAsText(this._bodyBlob);
        else if (this._bodyArrayBuffer) return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer));
        else if (this._bodyFormData) throw new Error("could not read FormData body as text");
        else return Promise.resolve(this._bodyText);
    };
    if (support.formData) this.formData = function() {
        return this.text().then(decode);
    };
    this.json = function() {
        return this.text().then(JSON.parse);
    };
    return this;
}
// HTTP methods whose capitalization should be normalized
var methods = [
    "CONNECT",
    "DELETE",
    "GET",
    "HEAD",
    "OPTIONS",
    "PATCH",
    "POST",
    "PUT",
    "TRACE"
];
function normalizeMethod(method) {
    var upcased = method.toUpperCase();
    return methods.indexOf(upcased) > -1 ? upcased : method;
}
function Request(input, options) {
    if (!(this instanceof Request)) throw new TypeError('Please use the "new" operator, this DOM object constructor cannot be called as a function.');
    options = options || {};
    var body = options.body;
    if (input instanceof Request) {
        if (input.bodyUsed) throw new TypeError("Already read");
        this.url = input.url;
        this.credentials = input.credentials;
        if (!options.headers) this.headers = new Headers(input.headers);
        this.method = input.method;
        this.mode = input.mode;
        this.signal = input.signal;
        if (!body && input._bodyInit != null) {
            body = input._bodyInit;
            input.bodyUsed = true;
        }
    } else this.url = String(input);
    this.credentials = options.credentials || this.credentials || "same-origin";
    if (options.headers || !this.headers) this.headers = new Headers(options.headers);
    this.method = normalizeMethod(options.method || this.method || "GET");
    this.mode = options.mode || this.mode || null;
    this.signal = options.signal || this.signal || function() {
        if ("AbortController" in g) {
            var ctrl = new AbortController();
            return ctrl.signal;
        }
    }();
    this.referrer = null;
    if ((this.method === "GET" || this.method === "HEAD") && body) throw new TypeError("Body not allowed for GET or HEAD requests");
    this._initBody(body);
    if (this.method === "GET" || this.method === "HEAD") {
        if (options.cache === "no-store" || options.cache === "no-cache") {
            // Search for a '_' parameter in the query string
            var reParamSearch = /([?&])_=[^&]*/;
            if (reParamSearch.test(this.url)) // If it already exists then set the value with the current time
            this.url = this.url.replace(reParamSearch, "$1_=" + new Date().getTime());
            else {
                // Otherwise add a new '_' parameter to the end with the current time
                var reQueryString = /\?/;
                this.url += (reQueryString.test(this.url) ? "&" : "?") + "_=" + new Date().getTime();
            }
        }
    }
}
Request.prototype.clone = function() {
    return new Request(this, {
        body: this._bodyInit
    });
};
function decode(body) {
    var form = new FormData();
    body.trim().split("&").forEach(function(bytes) {
        if (bytes) {
            var split = bytes.split("=");
            var name = split.shift().replace(/\+/g, " ");
            var value = split.join("=").replace(/\+/g, " ");
            form.append(decodeURIComponent(name), decodeURIComponent(value));
        }
    });
    return form;
}
function parseHeaders(rawHeaders) {
    var headers = new Headers();
    // Replace instances of \r\n and \n followed by at least one space or horizontal tab with a space
    // https://tools.ietf.org/html/rfc7230#section-3.2
    var preProcessedHeaders = rawHeaders.replace(/\r?\n[\t ]+/g, " ");
    // Avoiding split via regex to work around a common IE11 bug with the core-js 3.6.0 regex polyfill
    // https://github.com/github/fetch/issues/748
    // https://github.com/zloirock/core-js/issues/751
    preProcessedHeaders.split("\r").map(function(header) {
        return header.indexOf("\n") === 0 ? header.substr(1, header.length) : header;
    }).forEach(function(line) {
        var parts = line.split(":");
        var key = parts.shift().trim();
        if (key) {
            var value = parts.join(":").trim();
            try {
                headers.append(key, value);
            } catch (error) {
                console.warn("Response " + error.message);
            }
        }
    });
    return headers;
}
Body.call(Request.prototype);
function Response(bodyInit, options) {
    if (!(this instanceof Response)) throw new TypeError('Please use the "new" operator, this DOM object constructor cannot be called as a function.');
    if (!options) options = {};
    this.type = "default";
    this.status = options.status === undefined ? 200 : options.status;
    if (this.status < 200 || this.status > 599) throw new RangeError("Failed to construct 'Response': The status provided (0) is outside the range [200, 599].");
    this.ok = this.status >= 200 && this.status < 300;
    this.statusText = options.statusText === undefined ? "" : "" + options.statusText;
    this.headers = new Headers(options.headers);
    this.url = options.url || "";
    this._initBody(bodyInit);
}
Body.call(Response.prototype);
Response.prototype.clone = function() {
    return new Response(this._bodyInit, {
        status: this.status,
        statusText: this.statusText,
        headers: new Headers(this.headers),
        url: this.url
    });
};
Response.error = function() {
    var response = new Response(null, {
        status: 200,
        statusText: ""
    });
    response.status = 0;
    response.type = "error";
    return response;
};
var redirectStatuses = [
    301,
    302,
    303,
    307,
    308
];
Response.redirect = function(url, status) {
    if (redirectStatuses.indexOf(status) === -1) throw new RangeError("Invalid status code");
    return new Response(null, {
        status: status,
        headers: {
            location: url
        }
    });
};
var DOMException = g.DOMException;
try {
    new DOMException();
} catch (err) {
    DOMException = function(message, name) {
        this.message = message;
        this.name = name;
        var error = Error(message);
        this.stack = error.stack;
    };
    DOMException.prototype = Object.create(Error.prototype);
    DOMException.prototype.constructor = DOMException;
}
function fetch(input, init) {
    return new Promise(function(resolve, reject) {
        var request = new Request(input, init);
        if (request.signal && request.signal.aborted) return reject(new DOMException("Aborted", "AbortError"));
        var xhr = new XMLHttpRequest();
        function abortXhr() {
            xhr.abort();
        }
        xhr.onload = function() {
            var options = {
                status: xhr.status,
                statusText: xhr.statusText,
                headers: parseHeaders(xhr.getAllResponseHeaders() || "")
            };
            options.url = "responseURL" in xhr ? xhr.responseURL : options.headers.get("X-Request-URL");
            var body = "response" in xhr ? xhr.response : xhr.responseText;
            setTimeout(function() {
                resolve(new Response(body, options));
            }, 0);
        };
        xhr.onerror = function() {
            setTimeout(function() {
                reject(new TypeError("Network request failed"));
            }, 0);
        };
        xhr.ontimeout = function() {
            setTimeout(function() {
                reject(new TypeError("Network request failed"));
            }, 0);
        };
        xhr.onabort = function() {
            setTimeout(function() {
                reject(new DOMException("Aborted", "AbortError"));
            }, 0);
        };
        function fixUrl(url) {
            try {
                return url === "" && g.location.href ? g.location.href : url;
            } catch (e) {
                return url;
            }
        }
        xhr.open(request.method, fixUrl(request.url), true);
        if (request.credentials === "include") xhr.withCredentials = true;
        else if (request.credentials === "omit") xhr.withCredentials = false;
        if ("responseType" in xhr) {
            if (support.blob) xhr.responseType = "blob";
            else if (support.arrayBuffer) xhr.responseType = "arraybuffer";
        }
        if (init && typeof init.headers === "object" && !(init.headers instanceof Headers || g.Headers && init.headers instanceof g.Headers)) {
            var names = [];
            Object.getOwnPropertyNames(init.headers).forEach(function(name) {
                names.push(normalizeName(name));
                xhr.setRequestHeader(name, normalizeValue(init.headers[name]));
            });
            request.headers.forEach(function(value, name) {
                if (names.indexOf(name) === -1) xhr.setRequestHeader(name, value);
            });
        } else request.headers.forEach(function(value, name) {
            xhr.setRequestHeader(name, value);
        });
        if (request.signal) {
            request.signal.addEventListener("abort", abortXhr);
            xhr.onreadystatechange = function() {
                // DONE (success or failure)
                if (xhr.readyState === 4) request.signal.removeEventListener("abort", abortXhr);
            };
        }
        xhr.send(typeof request._bodyInit === "undefined" ? null : request._bodyInit);
    });
}
fetch.polyfill = true;
if (!g.fetch) {
    g.fetch = fetch;
    g.Headers = Headers;
    g.Request = Request;
    g.Response = Response;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6g26t":[function(require,module,exports) {
"use strict";
// tslint:disable
/**
 * Voicify Assistant API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: V1
 *
 *
 * NOTE: This file is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the file manually.
 */ Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Configuration = void 0;
class Configuration {
    constructor(param = {}){
        this.apiKey = param.apiKey;
        this.username = param.username;
        this.password = param.password;
        this.accessToken = param.accessToken;
        this.basePath = param.basePath;
    }
}
exports.Configuration = Configuration;

},{}],"e09gw":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _base = require("@emotion/styled/base");
var _baseDefault = parcelHelpers.interopDefault(_base);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _reactMarkdown = require("react-markdown");
var _reactMarkdownDefault = parcelHelpers.interopDefault(_reactMarkdown);
var _colors = require("../../../constants/colors");
var _userAvatar = require("../../../components/general/UserAvatar");
var _userAvatarDefault = parcelHelpers.interopDefault(_userAvatar);
var _stylesValues = require("../../../constants/stylesValues");
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const botAvatar = require("b0be9017d3b21d6");
const ConversationHistoryItem = ({ conversationHistoryItem, userImage, userFirstName, userLastName })=>{
    return conversationHistoryItem.user ? (0, _react.jsx)(UserConversationItemStyleContainer, null, (0, _react.jsx)((0, _userAvatarDefault.default), {
        src: userImage,
        firstName: userFirstName,
        lastName: userLastName,
        size: 24,
        className: userAvatarStyle
    }), (0, _react.jsx)(UserConversationItem, null, conversationHistoryItem.user)) : (0, _react.jsx)(BotConversationItemStyleContainer, null, (0, _react.jsx)(BotConversationItem, null, (0, _react.jsx)((0, _reactMarkdownDefault.default), {
        children: conversationHistoryItem.bot,
        linkTarget: "_blank"
    })), (0, _react.jsx)(BotAvatar, {
        src: botAvatar
    }));
};
const BotConversationItemStyleContainer = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1sq0v934"
})({
    name: "2yg5db",
    styles: "margin-right:8px;display:flex;justify-content:flex-end;:first-child{margin-top:16px;}"
});
const BotConversationItem = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1sq0v933"
})("background:white;border:", (0, _stylesValues.style_border_default), ";width:fit-content;margin:8px 8px 16px 16px;padding:1rem 2rem;box-shadow:0px 2px 4px ", (0, _colors.color_variants_shadow_10), ";border-radius:12px 0px 12px 12px;word-break:break-word;");
const BotAvatar = /*#__PURE__*/ (0, _baseDefault.default)("img", {
    target: "e1sq0v932"
})("border:", (0, _stylesValues.style_border_default), ";background:white;height:24px;width:24px;padding:1px;margin:16px 8px 0 0;border-radius:50px;");
const UserConversationItemStyleContainer = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1sq0v931"
})({
    name: "2q25hd",
    styles: "margin-top:16px;display:flex;justify-content:flex-start"
});
const UserConversationItem = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1sq0v930"
})("background:white;border:", (0, _stylesValues.style_border_default), ";width:fit-content;margin:0 16px 16px 8px;padding:1rem 2rem;border-radius:12px;box-shadow:0px 2px 4px ", (0, _colors.color_variants_shadow_10), ";border-radius:0px 12px 12px 12px;");
const userAvatarStyle = /*#__PURE__*/ (0, _css.css)("border:", (0, _stylesValues.style_border_default), ";", "");
exports.default = ConversationHistoryItem;

},{"@emotion/styled/base":"lSuFu","@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","react-markdown":"6G7AH","../../../constants/colors":"1p3OR","../../../components/general/UserAvatar":"avuDP","../../../constants/stylesValues":"dHVVv","b0be9017d3b21d6":"076vb","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"076vb":[function(require,module,exports) {
module.exports = require("b7a2f67a4248d7ce").getBundleURL("kVLro") + require("7cd06d1f022f1634").resolve("fjLBi");

},{"b7a2f67a4248d7ce":"c7Tr5","7cd06d1f022f1634":"fyJL2"}],"gT9AU":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _colors = require("../../constants/colors");
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const DeviceLoadingChatBubble = ({ icon, iconClassName })=>(0, _react.jsx)("div", {
        className: containerStyle
    }, (0, _react.jsx)("div", {
        className: bubbleStyle
    }, (0, _react.jsx)("div", {
        className: "content-container"
    }, (0, _react.jsx)("div", {
        className: loadingIndicatorStyle
    }, (0, _react.jsx)("div", {
        className: "indicator"
    })))), iconClassName ? (0, _react.jsx)("img", {
        className: iconClassName,
        src: icon
    }) : (0, _react.jsx)("img", {
        src: icon
    }));
const containerStyle = /*#__PURE__*/ (0, _css.css)({
    name: "84huzn",
    styles: "display:flex;align-items:start;>img{background:white;border-radius:50%;margin-top:30px;margin-right:12px;margin-left:12px;}"
});
const bubbleStyle = /*#__PURE__*/ (0, _css.css)("margin:30px 0 0 115px;border:solid 1px ", (0, _colors.dark_sky_blue), ";box-shadow:-1px 4px 10px 0 ", (0, _colors.dark_grey_blue_20), ";background:white;border-radius:10px 0 10px 10px;padding:24px;display:flex;flex-direction:column;flex:1;max-width:100px;margin-right:0;margin-left:auto;.title{font-family:Muli;font-size:18px;font-weight:600;font-style:normal;font-stretch:normal;line-height:normal;letter-spacing:normal;color:", (0, _colors.dark_grey_blue), ";margin-bottom:24px;}.content-container{margin-left:auto;margin-right:auto;}", "");
const loadingIndicatorStyle = /*#__PURE__*/ (0, _css.css)("right:0px;.indicator{position:relative;left:-9999px;width:10px;height:10px;border-radius:5px;color:", (0, _colors.dark_sky_blue), ";animation:dot-typing 1.5s infinite linear;}@keyframes dot-typing{0%{box-shadow:9984px 0 0 0 ", (0, _colors.dark_sky_blue), ",9999px 0 0 0 ", (0, _colors.dark_sky_blue), ",10014px 0 0 0 ", (0, _colors.dark_sky_blue), ";}16.667%{box-shadow:9984px -10px 0 0 ", (0, _colors.dark_sky_blue), ",9999px 0 0 0 ", (0, _colors.dark_sky_blue), ",10014px 0 0 0 ", (0, _colors.dark_sky_blue), ";}33.333%{box-shadow:9984px 0 0 0 ", (0, _colors.dark_sky_blue), ",9999px 0 0 0 ", (0, _colors.dark_sky_blue), ",10014px 0 0 0 ", (0, _colors.dark_sky_blue), ";}50%{box-shadow:9984px 0 0 0 ", (0, _colors.dark_sky_blue), ",9999px -10px 0 0 ", (0, _colors.dark_sky_blue), ",10014px 0 0 0 ", (0, _colors.dark_sky_blue), ";}66.667%{box-shadow:9984px 0 0 0 ", (0, _colors.dark_sky_blue), ",9999px 0 0 0 ", (0, _colors.dark_sky_blue), ",10014px 0 0 0 ", (0, _colors.dark_sky_blue), ";}83.333%{box-shadow:9984px 0 0 0 ", (0, _colors.dark_sky_blue), ",9999px 0 0 0 ", (0, _colors.dark_sky_blue), ",10014px -10px 0 0 ", (0, _colors.dark_sky_blue), ";}100%{box-shadow:9984px 0 0 0 ", (0, _colors.dark_sky_blue), ",9999px 0 0 0 ", (0, _colors.dark_sky_blue), ",10014px 0 0 0 ", (0, _colors.dark_sky_blue), ";}}", "");
exports.default = DeviceLoadingChatBubble;

},{"@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","../../constants/colors":"1p3OR","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"aZNhW":[function(require,module,exports) {
module.exports = require("8925dfbda3ecf39d").getBundleURL("kVLro") + require("92cfbe8ec074315a").resolve("9ti3x");

},{"8925dfbda3ecf39d":"c7Tr5","92cfbe8ec074315a":"fyJL2"}],"9L5RG":[function(require,module,exports) {
module.exports = require("4b06d8e751f72cda").getBundleURL("kVLro") + require("c68034d93494fed3").resolve("jjex9");

},{"4b06d8e751f72cda":"c7Tr5","c68034d93494fed3":"fyJL2"}],"7jLfW":[function(require,module,exports) {
module.exports = require("f1ed1465b1aa0f6a").getBundleURL("kVLro") + require("c04ee551ab07d062").resolve("assGL");

},{"f1ed1465b1aa0f6a":"c7Tr5","c04ee551ab07d062":"fyJL2"}],"dFyoP":[function(require,module,exports) {
module.exports = require("1a6ad4b71810edf9").getBundleURL("kVLro") + require("ba36402147bf954f").resolve("fTMIj");

},{"1a6ad4b71810edf9":"c7Tr5","ba36402147bf954f":"fyJL2"}],"bPg4S":[function(require,module,exports) {
module.exports = require("bd23cd7285ca030b").getBundleURL("kVLro") + require("34222f69d06bef2").resolve("38cbB");

},{"bd23cd7285ca030b":"c7Tr5","34222f69d06bef2":"fyJL2"}],"bw4xY":[function(require,module,exports) {
module.exports = require("3dc1d684baf5ba32").getBundleURL("kVLro") + require("8b876dd494bc8e3a").resolve("9g4ma");

},{"3dc1d684baf5ba32":"c7Tr5","8b876dd494bc8e3a":"fyJL2"}],"10RQZ":[function(require,module,exports) {
module.exports = require("643cfd949d011608").getBundleURL("kVLro") + require("c88c4fe61028fcec").resolve("2k7AC");

},{"643cfd949d011608":"c7Tr5","c88c4fe61028fcec":"fyJL2"}],"c1BYu":[function(require,module,exports) {
module.exports = require("cd6e44879af1ec4").getBundleURL("kVLro") + require("40f966487666568f").resolve("k0KeP");

},{"cd6e44879af1ec4":"c7Tr5","40f966487666568f":"fyJL2"}],"gkLOu":[function(require,module,exports) {
module.exports = require("aed239211b18fbe8").getBundleURL("kVLro") + require("5bdeb87fc7d229d5").resolve("6qAMs");

},{"aed239211b18fbe8":"c7Tr5","5bdeb87fc7d229d5":"fyJL2"}],"cBwYr":[function(require,module,exports) {
module.exports = require("68724073bbe4087f").getBundleURL("kVLro") + require("66bb158beea37a4c").resolve("hXCjw");

},{"68724073bbe4087f":"c7Tr5","66bb158beea37a4c":"fyJL2"}],"fo2p6":[function(require,module,exports) {
module.exports = require("357ba0fa958cc90").getBundleURL("kVLro") + require("4fb59e5d711714bd").resolve("e62Jw");

},{"357ba0fa958cc90":"c7Tr5","4fb59e5d711714bd":"fyJL2"}],"iiBgF":[function(require,module,exports) {
module.exports = require("5c22052b8234443b").getBundleURL("kVLro") + require("68c60d9457240f97").resolve("88H1E");

},{"5c22052b8234443b":"c7Tr5","68c60d9457240f97":"fyJL2"}],"jze6E":[function(require,module,exports) {
module.exports = require("1d425ece323c3224").getBundleURL("kVLro") + require("321294dba624b783").resolve("eR4mr");

},{"1d425ece323c3224":"c7Tr5","321294dba624b783":"fyJL2"}],"bMOSh":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _currentApplicationSelector = require("./components/CurrentApplicationSelector");
var _currentApplicationSelectorDefault = parcelHelpers.interopDefault(_currentApplicationSelector);
var _applicationSelector = require("./components/ApplicationSelector");
var _applicationSelectorDefault = parcelHelpers.interopDefault(_applicationSelector);
var _slideInSlideOutComponent = require("../../components/structure/SlideInSlideOutComponent");
var _slideInSlideOutComponentDefault = parcelHelpers.interopDefault(_slideInSlideOutComponent);
var _colors = require("../../constants/colors");
var _breakpoints = require("../../constants/breakpoints");
const ApplicationSelectorMenu = (props)=>{
    const [isExpanded, setIsExpanded] = (0, _react1.useState)(false);
    const toggle = ()=>{
        setIsExpanded(!isExpanded);
    };
    return (0, _react.jsx)("div", {
        className: `${applicationSelectorMenuWrapper} ${isExpanded ? "expanded" : ""}`
    }, (0, _react.jsx)((0, _currentApplicationSelectorDefault.default), {
        onToggle: ()=>toggle(),
        application: props.application,
        isMinified: true,
        isOpen: isExpanded
    }), (0, _react.jsx)((0, _slideInSlideOutComponentDefault.default), {
        showChildren: isExpanded,
        styleName: "applicationSelectorSlide",
        direction: "down",
        slideType: "size"
    }, (0, _react.jsx)((0, _applicationSelectorDefault.default), {
        organizationId: props.organizationId,
        appContainer: props.appContainer,
        application: props.application
    })));
};
const applicationSelectorMenuWrapper = /*#__PURE__*/ (0, _css.css)("height:80px;padding-top:16px;&.expanded{background:", (0, _colors.text_blue), ";}", (0, _breakpoints.breakpoint_small), "{display:none;}", "");
exports.default = ApplicationSelectorMenu;

},{"@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","./components/CurrentApplicationSelector":"imvhM","./components/ApplicationSelector":"hNfty","../../components/structure/SlideInSlideOutComponent":"bwTqS","../../constants/colors":"1p3OR","../../constants/breakpoints":"2F01A","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"imvhM":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _applicationAvatar = require("../../../components/general/ApplicationAvatar");
var _applicationAvatarDefault = parcelHelpers.interopDefault(_applicationAvatar);
var _toggleIndicator = require("../../../components/general/ToggleIndicator");
var _toggleIndicatorDefault = parcelHelpers.interopDefault(_toggleIndicator);
var _colors = require("../../../constants/colors");
const appsIcon = require("ac364484410523f9");
const CurrentApplicationSelector = (props)=>(0, _react.jsx)("div", {
        className: `${containerStyle} ${props.isOpen ? "open" : ""} ${props.isMinified ? "minified" : ""} ac-app-picker`,
        onClick: props.onToggle
    }, props.application ? (0, _react.jsx)((0, _applicationAvatarDefault.default), {
        app: props.application,
        size: 42
    }) : (0, _react.jsx)("img", {
        className: "apps-icon",
        src: appsIcon
    }), !props.isMinified && (0, _react.jsx)("div", {
        className: "app-selector-title"
    }, (0, _react.jsx)("p", {
        className: "selection-detail"
    }, "Select an App"), (0, _react.jsx)("p", {
        className: "selection-title"
    }, props.application.name)), (0, _react.jsx)((0, _toggleIndicatorDefault.default), {
        direction: props.isOpen ? "up" : "down",
        className: "toggle-indicator"
    }));
const containerStyle = /*#__PURE__*/ (0, _css.css)("cursor:pointer;display:flex;align-items:center;max-width:100%;height:48px;padding:0 16px;box-sizing:border-box;border-left:1px solid ", (0, _colors.color_shades_darker), ";border-right:1px solid ", (0, _colors.color_shades_darker), ";>img{width:32px;height:32px;padding:5px;}.apps-icon{margin-left:5px;margin-right:5px;}&.minified{.toggle-indicator{border-color:white;margin-left:8px;}}&.open{background:", (0, _colors.text_blue), ";border-left:1px solid transparent;border-right:1px solid transparent;}.app-selector-title{margin:0 12px;p{color:white;}.selection-detail{font-family:Muli;font-style:italic;font-weight:normal;font-size:10px;line-height:16px;}.selection-title{font-family:Muli;font-style:normal;font-weight:normal;font-size:14px;line-height:20px;}}.toggle-indicator{border-color:white;margin-left:auto;margin-right:0;}", "");
exports.default = CurrentApplicationSelector;

},{"@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","../../../components/general/ApplicationAvatar":"aA2GK","../../../components/general/ToggleIndicator":"4eej1","../../../constants/colors":"1p3OR","ac364484410523f9":"hNrC2","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hNfty":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _base = require("@emotion/styled/base");
var _baseDefault = parcelHelpers.interopDefault(_base);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _reactRouterDom = require("react-router-dom");
var _applicationListItem = require("./ApplicationListItem");
var _applicationListItemDefault = parcelHelpers.interopDefault(_applicationListItem);
var _colors = require("../../../constants/colors");
var _customScrollbars = require("../../../components/structure/CustomScrollbars");
var _customScrollbarsDefault = parcelHelpers.interopDefault(_customScrollbars);
var _reactInfiniteScrollHook = require("react-infinite-scroll-hook");
var _reactInfiniteScrollHookDefault = parcelHelpers.interopDefault(_reactInfiniteScrollHook);
const appsIcon = require("e7805a161ba62bc9");
const arrowIcon = require("2e7c0b251da24875");
const addIcon = require("e44b34dfa052b95c");
const ApplicationSelector = (props)=>{
    const [loadingApps, setLoadingApps] = (0, _react1.useState)(false);
    const [hasMoreApps, setHasMoreApps] = (0, _react1.useState)(true);
    const [page, setPage] = (0, _react1.useState)(1);
    const [apps, setApps] = (0, _react1.useState)([]);
    const loadMoreApps = async ()=>{
        setLoadingApps(true);
        var result = await props.appContainer.searchForApplications(props.organizationId, page, 30, "NameAscending", "");
        setPage(page + 1);
        if (result.resultType == "Ok") {
            setApps([
                ...apps,
                ...result.data.applications
            ]);
            if (result.data.applications.length > 29) setHasMoreApps(true);
            else setHasMoreApps(false);
        } else setHasMoreApps(false);
        setLoadingApps(false);
    };
    const [scrollingRef] = (0, _reactInfiniteScrollHookDefault.default)({
        loading: loadingApps,
        hasNextPage: hasMoreApps,
        onLoadMore: loadMoreApps,
        // `rootMargin` is passed to `IntersectionObserver`.
        // We can use it to trigger 'onLoadMore' when the sentry comes near to become
        // visible, instead of becoming fully visible on the screen.
        rootMargin: "0px 0px 400px 0px"
    });
    return (0, _react.jsx)(ApplicationSelectorWrapper, null, (0, _react.jsx)((0, _reactRouterDom.Link), {
        to: "/v",
        className: "all-apps-section"
    }, (0, _react.jsx)("img", {
        className: "start",
        src: appsIcon
    }), (0, _react.jsx)("p", null, "All Apps"), (0, _react.jsx)("img", {
        className: "end",
        src: arrowIcon
    })), (0, _react.jsx)((0, _customScrollbarsDefault.default), {
        autoHide: true,
        className: "apps-container"
    }, apps?.map((a)=>(0, _react.jsx)((0, _applicationListItemDefault.default), {
            key: a.id,
            application: a,
            isSelected: props.application?.id == a.id
        })), (0, _react.jsx)("div", {
        ref: scrollingRef
    })), (0, _react.jsx)((0, _reactRouterDom.Link), {
        to: "/v/create-app",
        className: "add-app-section"
    }, (0, _react.jsx)("img", {
        className: "start",
        src: addIcon
    }), (0, _react.jsx)("p", null, "Add a New App")));
};
const ApplicationSelectorWrapper = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e3be9zb0"
})("background:linear-gradient(0deg, ", (0, _colors.color_colors_ocean), " 0%, #36C4F2 100%, #2BA5D8 100%);margin-top:80px;top:0;left:0;bottom:0;display:flex;flex-direction:column;position:fixed;max-height:calc(100% - 80px);width:288px;z-index:3;from{height:0px;}to{height:calc(100% - 48px);}.start{margin-right:16px;width:24px;height:24px;margin-left:4px;}.all-apps-section{display:flex;align-items:center;border-bottom:1px solid white;height:64px;padding:0 24px;.end{margin-right:0;margin-left:auto;}a,p{font-family:Muli;font-style:italic;font-size:14px;line-height:20px;color:white;}}.apps-container{flex:1;}.add-app-section{margin-bottom:0;margin-top:auto;display:flex;align-items:center;margin:0 24px;height:64px;border-top:1px solid white;a,p{font-family:Muli;font-style:italic;font-size:14px;line-height:20px;color:white;}}");
exports.default = ApplicationSelector;

},{"@emotion/styled/base":"lSuFu","@emotion/react":"djZKr","react":"6uln9","react-router-dom":"5fzqq","./ApplicationListItem":"al7Ww","../../../constants/colors":"1p3OR","../../../components/structure/CustomScrollbars":"50vFq","react-infinite-scroll-hook":"haHPB","e7805a161ba62bc9":"hNrC2","2e7c0b251da24875":"jsDFw","e44b34dfa052b95c":"drv5x","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"al7Ww":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _applicationAvatar = require("../../../components/general/ApplicationAvatar");
var _applicationAvatarDefault = parcelHelpers.interopDefault(_applicationAvatar);
var _reactRouterDom = require("react-router-dom");
var _colors = require("../../../constants/colors");
const ApplicationListItem = (props)=>(0, _react.jsx)((0, _reactRouterDom.Link), {
        to: `/v/apps/${props.application.id}`,
        className: `${containerStyle} ${props.isSelected ? "selected" : ""}`
    }, (0, _react.jsx)((0, _applicationAvatarDefault.default), {
        app: props.application,
        size: 32
    }), !props.isMinified && (0, _react.jsx)("p", null, props.application.name));
const containerStyle = /*#__PURE__*/ (0, _css.css)("display:flex;align-items:center;margin:12px;height:56px;padding:0 12px;border-radius:8px;&.selected{background:", (0, _colors.color_colors_sky), ";}p{color:white;font-style:normal;font-size:14px;line-height:20px;margin:0 12px;}", "");
exports.default = ApplicationListItem;

},{"@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","../../../components/general/ApplicationAvatar":"aA2GK","react-router-dom":"5fzqq","../../../constants/colors":"1p3OR","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"haHPB":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _reactIntersectionObserverHook = require("react-intersection-observer-hook");
var DEFAULT_DELAY_IN_MS = 100;
function useInfiniteScroll(_ref) {
    var loading = _ref.loading, hasNextPage = _ref.hasNextPage, onLoadMore = _ref.onLoadMore, rootMargin = _ref.rootMargin, disabled = _ref.disabled, _ref$delayInMs = _ref.delayInMs, delayInMs = _ref$delayInMs === void 0 ? DEFAULT_DELAY_IN_MS : _ref$delayInMs;
    var _useTrackVisibility = (0, _reactIntersectionObserverHook.useTrackVisibility)({
        rootMargin: rootMargin
    }), ref = _useTrackVisibility[0], _useTrackVisibility$ = _useTrackVisibility[1], rootRef = _useTrackVisibility$.rootRef, isVisible = _useTrackVisibility$.isVisible;
    var shouldLoadMore = !disabled && !loading && isVisible && hasNextPage; // eslint-disable-next-line consistent-return
    (0, _react.useEffect)(function() {
        if (shouldLoadMore) {
            // When we trigger 'onLoadMore' and new items are added to the list,
            // right before they become rendered on the screen, 'loading' becomes false
            // and 'isVisible' can be true for a brief time, based on the scroll position.
            // So, it triggers 'onLoadMore' just after the first one is finished.
            // We use a small delay here to prevent this kind of situations.
            // It can be configured by hook args.
            var timer = setTimeout(function() {
                onLoadMore();
            }, delayInMs);
            return function() {
                clearTimeout(timer);
            };
        }
    }, [
        onLoadMore,
        shouldLoadMore,
        delayInMs
    ]);
    return [
        ref,
        {
            rootRef: rootRef
        }
    ];
}
exports.default = useInfiniteScroll;

},{"react":"6uln9","react-intersection-observer-hook":"9QetI","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9QetI":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useIntersectionObserver", ()=>useIntersectionObserver);
parcelHelpers.export(exports, "useTrackVisibility", ()=>useTrackVisibility);
var _react = require("react");
function createObserverCache() {
    var cachesByRoot = new Map();
    function getObserver(_ref) {
        var root = _ref.root, rootMargin = _ref.rootMargin, threshold = _ref.threshold;
        var cacheByRoot = cachesByRoot.get(root);
        if (!cacheByRoot) {
            cacheByRoot = new Map();
            cachesByRoot.set(root, cacheByRoot);
        }
        var cacheKey = JSON.stringify({
            rootMargin: rootMargin,
            threshold: threshold
        });
        var cachedObserver = cacheByRoot.get(cacheKey);
        if (!cachedObserver) {
            var entryCallbacks = new Map();
            var observer = new IntersectionObserver(function(entries) {
                entries.forEach(function(entry) {
                    var callback = entryCallbacks.get(entry.target);
                    callback == null || callback(entry);
                });
            }, {
                root: root,
                rootMargin: rootMargin,
                threshold: threshold
            });
            cachedObserver = {
                observer: observer,
                entryCallbacks: entryCallbacks
            };
            cacheByRoot.set(cacheKey, cachedObserver);
        }
        return {
            observe: function observe(node, callback) {
                var _cachedObserver, _cachedObserver2;
                (_cachedObserver = cachedObserver) == null || _cachedObserver.entryCallbacks.set(node, callback);
                (_cachedObserver2 = cachedObserver) == null || _cachedObserver2.observer.observe(node);
            },
            unobserve: function unobserve(node) {
                var _cachedObserver3, _cachedObserver4;
                (_cachedObserver3 = cachedObserver) == null || _cachedObserver3.entryCallbacks["delete"](node);
                (_cachedObserver4 = cachedObserver) == null || _cachedObserver4.observer.unobserve(node);
            }
        };
    }
    return {
        getObserver: getObserver
    };
}
var DEFAULT_ROOT_MARGIN = "0px";
var DEFAULT_THRESHOLD = [
    0
];
var observerCache = /*#__PURE__*/ createObserverCache(); // For more info:
// https://developers.google.com/web/updates/2016/04/intersectionobserver
// https://developer.mozilla.org/en-US/docs/Web/API/Intersection_Observer_API
function useIntersectionObserver(args) {
    var _args$rootMargin, _args$threshold;
    var rootMargin = (_args$rootMargin = args == null ? void 0 : args.rootMargin) != null ? _args$rootMargin : DEFAULT_ROOT_MARGIN;
    var threshold = (_args$threshold = args == null ? void 0 : args.threshold) != null ? _args$threshold : DEFAULT_THRESHOLD;
    var nodeRef = (0, _react.useRef)(null);
    var rootRef = (0, _react.useRef)(null);
    var observerRef = (0, _react.useRef)(null);
    var _useState = (0, _react.useState)(), entry = _useState[0], setEntry = _useState[1];
    var observe = (0, _react.useCallback)(function() {
        var node = nodeRef.current;
        if (!node) {
            setEntry(undefined);
            return;
        }
        var observer = observerCache.getObserver({
            root: rootRef.current,
            rootMargin: rootMargin,
            threshold: threshold
        });
        observer.observe(node, function(observedEntry) {
            setEntry(observedEntry);
        });
        observerRef.current = observer;
    }, [
        rootMargin,
        threshold
    ]);
    var unobserve = (0, _react.useCallback)(function() {
        var currentObserver = observerRef.current;
        var node = nodeRef.current;
        if (node) currentObserver == null || currentObserver.unobserve(node);
        observerRef.current = null;
    }, []); // React will call the ref callback with the DOM element when the component mounts,
    // and call it with null when it unmounts.
    // So, we don't need an useEffect etc to unobserve nodes.
    // When nodeRef.current is null, it will be unobserved and observe function
    // won't do anything.
    var refCallback = (0, _react.useCallback)(function(node) {
        unobserve();
        nodeRef.current = node;
        observe();
    }, [
        observe,
        unobserve
    ]);
    var rootRefCallback = (0, _react.useCallback)(function(rootNode) {
        unobserve();
        rootRef.current = rootNode;
        observe();
    }, [
        observe,
        unobserve
    ]);
    return [
        refCallback,
        {
            entry: entry,
            rootRef: rootRefCallback
        }
    ];
}
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function useTrackVisibility(args) {
    var _result$entry;
    var _useIntersectionObser = useIntersectionObserver(args), ref = _useIntersectionObser[0], result = _useIntersectionObser[1];
    var isVisible = Boolean((_result$entry = result.entry) == null ? void 0 : _result$entry.isIntersecting);
    var _useState = (0, _react.useState)(isVisible), wasEverVisible = _useState[0], setWasEverVisible = _useState[1];
    if (isVisible && !wasEverVisible) setWasEverVisible(true);
    return [
        ref,
        _extends({}, result, {
            isVisible: isVisible,
            wasEverVisible: wasEverVisible
        })
    ];
}

},{"react":"6uln9","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jsDFw":[function(require,module,exports) {
module.exports = require("59ffdca4a127c3bd").getBundleURL("kVLro") + require("86107fb74e715000").resolve("4eE93");

},{"59ffdca4a127c3bd":"c7Tr5","86107fb74e715000":"fyJL2"}],"drv5x":[function(require,module,exports) {
module.exports = require("97df23bd4149dc00").getBundleURL("kVLro") + require("6fd00db96d4353b5").resolve("7rnSs");

},{"97df23bd4149dc00":"c7Tr5","6fd00db96d4353b5":"fyJL2"}],"5g98N":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _unstated = require("unstated");
var _organizationContainer = require("../../state/containers/OrganizationContainer");
var _organizationContainerDefault = parcelHelpers.interopDefault(_organizationContainer);
var _templateConfigurationContainer = require("../../state/containers/TemplateConfigurationContainer");
var _templateConfigurationContainerDefault = parcelHelpers.interopDefault(_templateConfigurationContainer);
var _organizationTemplatesListView = require("./components/OrganizationTemplatesListView");
var _organizationTemplatesListViewDefault = parcelHelpers.interopDefault(_organizationTemplatesListView);
const OrganizationTemplates = (props)=>(0, _react.jsx)((0, _unstated.Subscribe), {
        to: [
            (0, _templateConfigurationContainerDefault.default),
            (0, _organizationContainerDefault.default)
        ]
    }, (templatesContainer, orgContainer)=>{
        return (0, _react.jsx)((0, _organizationTemplatesListViewDefault.default), {
            templatesContainer: templatesContainer,
            orgContainer: orgContainer,
            history: props.history
        });
    });
exports.default = OrganizationTemplates;

},{"@emotion/react":"djZKr","react":"6uln9","unstated":"grh7p","../../state/containers/OrganizationContainer":"dlbaM","../../state/containers/TemplateConfigurationContainer":"aJrgZ","./components/OrganizationTemplatesListView":"cgnWw","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"aJrgZ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _unstated = require("unstated");
var _api = require("../../api");
class TemplateConfigurationContainer extends (0, _unstated.Container) {
    // default state
    constructor(){
        super();
        const params = new URLSearchParams(location.search);
        this.state = {
            availableTemplates: [],
            organizationTemplates: [],
            privateTemplates: [],
            categories: [],
            industries: [],
            appliedTemplateCounts: [],
            isLoadingCategories: false,
            isLoadingIndustries: false,
            isLoading: false,
            isSaving: false,
            defaultPageSize: parseInt(params.get("pageSize") ?? localStorage.getItem("modulesPageSize") ?? "25"),
            currentDiscoverPage: parseInt(params.get("page") ?? "1"),
            templateTypeFilter: params.get("templateType"),
            categoryIdFilter: params.get("categoryId"),
            industryIdFilter: params.get("industryId"),
            defaultViewType: localStorage.getItem("modulesViewType") ?? "card",
            defaultSortBy: "NameAscending",
            organizationId: JSON.parse(localStorage.getItem("CURRENT_ORG") ?? "{}")?.id,
            errors: []
        };
    }
    async loadTemplateConfigurationCounts(organizationTemplates) {
        try {
            const templateConfigurationCountArray = [];
            for(var i = 0; i < organizationTemplates.length; i++){
                const template = organizationTemplates[i];
                const result = await _api.getAppliedTemplateFormCounts(template.id);
                if (result.resultType == "Ok") templateConfigurationCountArray.push(result.data);
                else await this.setState({
                    ...this.state,
                    errors: result.errors
                });
            }
            await this.setState({
                ...this.state,
                appliedTemplateCounts: templateConfigurationCountArray,
                errors: []
            });
            return templateConfigurationCountArray;
        } catch (error) {
            await this.setState({
                ...this.state,
                isLoading: false,
                errors: [
                    error
                ]
            });
        }
    }
    getAvailableTemplates(organizationId) {
        this.setLoading(true);
        const promise = _api.getAvailableTemplateConfigurations(organizationId, {
            skip: this.state.defaultPageSize * (this.state.currentDiscoverPage - 1),
            take: this.state.defaultPageSize,
            searchQuery: this.state.searchFilter,
            templateCategoryId: this.state.categoryIdFilter,
            templateIndustryId: this.state.industryIdFilter,
            templateType: this.state.templateTypeFilter,
            sortBy: this.state.defaultSortBy
        });
        promise.then((result)=>{
            if (result.resultType == "Ok") this.setState({
                ...this.state,
                isLoading: false,
                availableTemplates: result.data,
                errors: []
            });
            else this.setState({
                ...this.state,
                isLoading: false,
                errors: result.errors
            });
        }).catch((e)=>{
            this.setState({
                ...this.state,
                isLoading: false,
                errors: [
                    e?.toString()
                ]
            });
        });
        return promise;
    }
    async getOrganizationTemplates(organizationId) {
        try {
            await this.setLoading(true);
            const result = await _api.getOrganizationTemplateConfigurations(organizationId);
            if (result.resultType == "Ok") {
                await this.setState({
                    ...this.state,
                    organizationTemplates: result.data,
                    isLoading: false,
                    errors: []
                });
                this.loadTemplateConfigurationCounts(result.data);
            } else await this.setState({
                ...this.state,
                isLoading: false,
                errors: result.errors
            });
            return result;
        } catch (e) {
            await this.setState({
                ...this.state,
                isLoading: false,
                errors: [
                    e?.toString()
                ]
            });
        }
    }
    getPrivateTemplates(organizationId) {
        this.setLoading(true);
        const promise = _api.getPrivateTemplateConfigurations(organizationId);
        promise.then((result)=>{
            if (result.resultType == "Ok") this.setState({
                ...this.state,
                isLoading: false,
                privateTemplates: result.data,
                errors: []
            });
            else this.setState({
                ...this.state,
                isLoading: false,
                errors: result.errors
            });
        }).catch((e)=>{
            this.setState({
                ...this.state,
                isLoading: false,
                errors: [
                    e?.toString()
                ]
            });
        });
        return promise;
    }
    async createEmptyTemplateConfiguration(orgId, applicationId, dynamicFinalizeUrl) {
        await this.setSaving(true);
        try {
            const result = await _api.createTemplateConfiguration({
                organizationId: orgId,
                templateApplicationId: applicationId ? applicationId : null,
                name: "New Template",
                description: "template description",
                finalizeFormUrl: dynamicFinalizeUrl ? dynamicFinalizeUrl : null,
                templateForm: {
                    templateFormSections: []
                },
                currentVersion: {
                    versionName: "1.0",
                    releaseNotes: "initial template"
                }
            });
            if (result.resultType == "Ok") this.setState({
                ...this.state,
                isSaving: false,
                errors: [],
                organizationTemplates: [
                    ...this.state.organizationTemplates,
                    result.data
                ]
            });
            else this.setState({
                ...this.state,
                isSaving: false,
                errors: result.errors
            });
            return result;
        } catch (e) {
            this.setState({
                ...this.state,
                isSaving: false,
                errors: [
                    e?.toString()
                ]
            });
        }
    }
    updateTemplateConfiguration(template) {
        this.setSaving(true);
        const promise = _api.updateTemplateConfiguration(template.id, template);
        promise.then((result)=>{
            if (result.resultType == "Ok") {
                const templates = this.state.organizationTemplates;
                const templateIndex = templates.findIndex((t)=>t.id == template.id);
                templates[templateIndex] = result.data;
                this.setState({
                    ...this.state,
                    isSaving: false,
                    errors: [],
                    organizationTemplates: templates
                });
            } else this.setState({
                ...this.state,
                isSaving: false,
                errors: result.errors
            });
        }).catch((e)=>{
            this.setState({
                ...this.state,
                isSaving: false,
                errors: [
                    e?.toString()
                ]
            });
        });
        return promise;
    }
    async changeTemplateFilter(newState) {
        // updates state and reloads the templates using it
        await this.setState(newState);
        await this.getAvailableTemplates(this.state.organizationId);
    }
    async loadCategories() {
        await this.setState({
            ...this.state,
            isLoadingCategories: true
        });
        try {
            const result = await _api.getTemplateCategories();
            await this.setState({
                ...this.state,
                isLoadingCategories: false,
                errors: result.errors,
                categories: result.data
            });
            return result;
        } catch (e) {
            await this.setState({
                ...this.state,
                isLoadingCategories: false
            });
            return {
                resultType: "Unexpected",
                errors: [
                    e.toString()
                ]
            };
        }
    }
    async loadIndustries() {
        await this.setState({
            ...this.state,
            isLoadingIndustries: true
        });
        try {
            const result = await _api.getTemplateIndustries();
            await this.setState({
                ...this.state,
                isLoadingIndustries: false,
                errors: result.errors,
                industries: result.data
            });
            return result;
        } catch (e) {
            await this.setState({
                ...this.state,
                isLoadingIndustries: false
            });
            return {
                resultType: "Unexpected",
                errors: [
                    e.toString()
                ]
            };
        }
    }
    async disableTemplateConfiguration(templateConfigurationId) {
        try {
            await this.setLoading(true);
            const result = await _api.disableTemplateConfiguration(templateConfigurationId);
            await this.setState({
                ...this.state,
                isLoading: false,
                errors: result.errors
            });
            return result;
        } catch (e) {
            await this.setState({
                ...this.state,
                isLoadingIndustries: false
            });
            return {
                resultType: "Unexpected",
                errors: [
                    e.toString()
                ]
            };
        }
    }
    async setLoading(isLoading) {
        this.setState({
            ...this.state,
            isLoading
        });
    }
    setSaving(isSaving) {
        this.setState({
            ...this.state,
            isSaving
        });
    }
    clearErrors() {
        this.setState({
            ...this.state,
            errors: []
        });
    }
}
exports.default = TemplateConfigurationContainer;

},{"unstated":"grh7p","../../api":"loxM6","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"cgnWw":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _base = require("@emotion/styled/base");
var _baseDefault = parcelHelpers.interopDefault(_base);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _loader = require("../../../components/general/Loader");
var _loaderDefault = parcelHelpers.interopDefault(_loader);
var _panelHeaderContainer = require("../../../components/structure/Panels/PanelHeaderContainer");
var _panelHeaderContainerDefault = parcelHelpers.interopDefault(_panelHeaderContainer);
var _scrollablePanelBody = require("../../../components/structure/ScrollablePanelBody");
var _scrollablePanelBodyDefault = parcelHelpers.interopDefault(_scrollablePanelBody);
var _button = require("../../../components/general/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _searchField = require("../../../components/forms/SearchField");
var _searchFieldDefault = parcelHelpers.interopDefault(_searchField);
var _organizationTemplateListItem = require("./OrganizationTemplateListItem");
var _organizationTemplateListItemDefault = parcelHelpers.interopDefault(_organizationTemplateListItem);
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const OrganizationTemplatesListView = (props)=>{
    const [searchTerm, setSearchTerm] = (0, _react1.useState)("");
    (0, _react1.useEffect)(()=>{
        if (props.templatesContainer.state.organizationTemplates.length == 0) props.templatesContainer.getOrganizationTemplates(props.orgContainer.state.currentOrganization?.id);
    }, []);
    const handleSearch = (searchEvent)=>{
        setSearchTerm(searchEvent.target.value);
    };
    const handleAddNew = ()=>{
        props.history.push("/v/modules/add");
    };
    if (props.templatesContainer.state.isLoading) return (0, _react.jsx)((0, _loaderDefault.default), null);
    const counts = props.templatesContainer.state.appliedTemplateCounts;
    const filteredTemplates = props.templatesContainer.state.organizationTemplates?.filter((template)=>template.name?.toLowerCase().includes(searchTerm.toLowerCase())) || [];
    // Sort templates with three levels:
    // 1. Most active instances first (descending)
    // 2. Last modified date (descending - most recent first)  
    // 3. Alphabetically by name (ascending)
    const sortedTemplates = [
        ...filteredTemplates
    ].sort((a, b)=>{
        const aInstanceCount = counts?.find((c)=>c.templateConfigurationId === a.id)?.appliedTemplateCount || 0;
        const bInstanceCount = counts?.find((c)=>c.templateConfigurationId === b.id)?.appliedTemplateCount || 0;
        // First level: Sort by active instance count (descending)
        if (aInstanceCount !== bInstanceCount) return bInstanceCount - aInstanceCount;
        // Second level: Sort by modified date (descending - most recent first)
        const aDate = new Date(a.modifiedDate || 0);
        const bDate = new Date(b.modifiedDate || 0);
        if (aDate.getTime() !== bDate.getTime()) return bDate.getTime() - aDate.getTime();
        // Third level: Sort alphabetically by name (ascending)
        const aName = a.name?.toLowerCase() || "";
        const bName = b.name?.toLowerCase() || "";
        return aName.localeCompare(bName);
    });
    return (0, _react.jsx)((0, _reactDefault.default).Fragment, null, (0, _react.jsx)((0, _panelHeaderContainerDefault.default), {
        className: panelHeaderStyle
    }, (0, _react.jsx)(Title, null, "Modules"), (0, _react.jsx)(ModuleSearchAndAddWrapper, null, (0, _react.jsx)(ModuleSearchBar, {
        id: "moduleSearchField",
        className: moduleSearchBarStyle,
        name: "moduleSearchField",
        placeholder: "Search modules",
        value: searchTerm,
        onChange: handleSearch,
        boxType: "square"
    }), (0, _react.jsx)((0, _buttonDefault.default), {
        themes: [
            "primary-small",
            "end"
        ],
        text: "Create New Module",
        onClick: handleAddNew
    }))), (0, _react.jsx)((0, _scrollablePanelBodyDefault.default), {
        className: panelBodyStyle
    }, sortedTemplates?.map((t)=>(0, _react.jsx)((0, _organizationTemplateListItemDefault.default), {
            key: t.id,
            templateConfiguration: t,
            activeInstanceCount: counts?.find((c)=>c.templateConfigurationId == t.id)?.appliedTemplateCount
        }))));
};
const ModuleSearchAndAddWrapper = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1xk9gyy2"
})({
    name: "xb22ao",
    styles: "display:flex;align-items:center;justify-content:center;gap:16px"
});
const Title = /*#__PURE__*/ (0, _baseDefault.default)("h2", {
    target: "e1xk9gyy1"
})("");
const panelHeaderStyle = /*#__PURE__*/ (0, _css.css)({
    name: "1dq55nm",
    styles: "padding:0 32px;display:flex;align-items:center;justify-content:center;gap:16px;button{margin-right:0;margin-left:auto;}h2{font-size:18px;line-height:24px;margin-right:auto;}"
});
const ModuleSearchBar = /*#__PURE__*/ (0, _baseDefault.default)((0, _searchFieldDefault.default), {
    target: "e1xk9gyy0"
})({
    name: "1sg9vvx",
    styles: "flex-grow:1;max-width:300px;div>.field-container{height:36px;box-shadow:none;border-radius:8px;margin:0;padding:0;}input::placeholder{font-size:0.75rem;}"
});
const moduleSearchBarStyle = /*#__PURE__*/ (0, _css.css)({
    name: "1ykowef",
    styles: "margin-bottom:0"
});
const panelBodyStyle = /*#__PURE__*/ (0, _css.css)({
    name: "1uyewve",
    styles: "padding:48px 0;min-height:100%"
});
exports.default = OrganizationTemplatesListView;

},{"@emotion/styled/base":"lSuFu","@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","../../../components/general/Loader":"bnV5T","../../../components/structure/Panels/PanelHeaderContainer":"hUotd","../../../components/structure/ScrollablePanelBody":"6LRg3","../../../components/general/Button":"6ymxN","../../../components/forms/SearchField":"aU10T","./OrganizationTemplateListItem":"ed2oy","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"ed2oy":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _colors = require("../../../constants/colors");
var _languageCollectionAvatar = require("../../../components/general/LanguageCollectionAvatar");
var _languageCollectionAvatarDefault = parcelHelpers.interopDefault(_languageCollectionAvatar);
var _moment = require("moment");
var _momentDefault = parcelHelpers.interopDefault(_moment);
var _reactRouterDom = require("react-router-dom");
const templateUsageIcon = require("c01047a67a4aa1a0");
const moduleIcon = require("84d6b617f8ea9211");
const templateIcon = require("251bbdea0972937d");
const integrationIcon = require("180650608c7fb87b");
const OrganizationTemplateListItem = ({ templateConfiguration, activeInstanceCount })=>{
    const getTypeLabel = ()=>{
        if (templateConfiguration?.templateType == "ContentTemplate") return "Template";
        if (templateConfiguration?.templateType == "Integration") return "Integration";
        return "Module";
    };
    const getTypeIcon = ()=>{
        if (templateConfiguration?.templateType == "ContentTemplate") return templateIcon;
        if (templateConfiguration?.templateType == "Integration") return integrationIcon;
        return moduleIcon;
    };
    return (0, _react.jsx)("div", {
        className: containerStyle
    }, (0, _react.jsx)((0, _reactRouterDom.Link), {
        to: `/v/modules/edit/${templateConfiguration?.id}`,
        className: "list-item-body"
    }, (0, _react.jsx)("div", {
        className: "template-icon"
    }, (0, _react.jsx)("img", {
        src: getTypeIcon()
    })), (0, _react.jsx)("div", {
        className: "template-title"
    }, (0, _react.jsx)("p", {
        className: "section-label"
    }, getTypeLabel()), (0, _react.jsx)("h3", null, templateConfiguration?.name)), (0, _react.jsx)("div", {
        className: "template-modified"
    }, (0, _react.jsx)("div", null, (0, _react.jsx)("p", {
        className: "section-label"
    }, "Last modified"), (0, _react.jsx)("p", {
        className: "modified-date"
    }, (0, _momentDefault.default)(templateConfiguration.modifiedDate).format("MMM DD, YYYY")))), (0, _react.jsx)((0, _languageCollectionAvatarDefault.default), {
        className: "template-languages",
        languages: templateConfiguration?.templateApplication?.languages ?? [],
        limit: 3
    }), (0, _react.jsx)("div", {
        className: "template-usage"
    }, (0, _react.jsx)("div", null, (0, _react.jsx)("p", {
        className: "usage-count"
    }, activeInstanceCount ?? "-"), (0, _react.jsx)("p", {
        className: "usage-label"
    }, "Active Instances")), (0, _react.jsx)("img", {
        src: templateUsageIcon
    }))));
};
const containerStyle = /*#__PURE__*/ (0, _css.css)("height:80px;background:", (0, _colors.color_shades_light), ";width:100%;padding-left:80px;border-top:1px solid ", (0, _colors.color_shades_dark), ";&:last-child{border-bottom:1px solid ", (0, _colors.color_shades_dark), ";}.list-item-body{background:white;display:flex;align-items:center;flex:1;height:100%;color:", (0, _colors.color_text_default), ";.section-label{color:", (0, _colors.color_text_light), ";font-size:12px;line-height:16px;}.template-title{margin-left:32px;margin-right:32px;width:40%;flex:1;}.template-usage,.template-modified{margin-right:32px;width:15%;}.template-modified{text-align:right;}.template-languages{margin-left:32px;}.template-usage{display:flex;align-items:center;justify-content:flex-end;.usage-count{text-align:right;font-weight:600;font-size:18px;line-height:24px;}.usage-label{text-align:right;letter-spacing:0.1em;text-transform:uppercase;font-size:12px;line-height:16px;}img{margin-left:16px;}}}.template-icon{background:white;border:1px solid ", (0, _colors.color_shades_dark), ";box-sizing:border-box;border-radius:8px;padding:8px;width:56px;height:56px;transform:rotate(45deg);display:flex;align-items:center;justify-content:center;margin-left:-28px;img{width:32px;height:32px;transform:rotate(-45deg);}}", "");
exports.default = OrganizationTemplateListItem;

},{"@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","../../../constants/colors":"1p3OR","../../../components/general/LanguageCollectionAvatar":"crbMk","moment":"2meyw","react-router-dom":"5fzqq","c01047a67a4aa1a0":"jOTb3","84d6b617f8ea9211":"9Q23q","251bbdea0972937d":"krour","180650608c7fb87b":"1FNB0","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jOTb3":[function(require,module,exports) {
module.exports = require("c6a22201e7fbb68b").getBundleURL("kVLro") + require("39cd091847ddddd2").resolve("6k31u");

},{"c6a22201e7fbb68b":"c7Tr5","39cd091847ddddd2":"fyJL2"}],"9Q23q":[function(require,module,exports) {
module.exports = require("f93f1a4ee6f2e21").getBundleURL("kVLro") + require("9564312a51842bc").resolve("736bE");

},{"f93f1a4ee6f2e21":"c7Tr5","9564312a51842bc":"fyJL2"}],"krour":[function(require,module,exports) {
module.exports = require("b0d14f1be7704e2c").getBundleURL("kVLro") + require("a678b57924353633").resolve("6v6dK");

},{"b0d14f1be7704e2c":"c7Tr5","a678b57924353633":"fyJL2"}],"1FNB0":[function(require,module,exports) {
module.exports = require("e5b29b706006a59f").getBundleURL("kVLro") + require("566f4577a7c03003").resolve("bUvwL");

},{"e5b29b706006a59f":"c7Tr5","566f4577a7c03003":"fyJL2"}],"8hfqi":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _unstated = require("unstated");
var _organizationContainer = require("../../state/containers/OrganizationContainer");
var _organizationContainerDefault = parcelHelpers.interopDefault(_organizationContainer);
var _templateConfigurationContainer = require("../../state/containers/TemplateConfigurationContainer");
var _templateConfigurationContainerDefault = parcelHelpers.interopDefault(_templateConfigurationContainer);
var _organizationAnalyticsBody = require("./components/OrganizationAnalyticsBody");
var _organizationAnalyticsBodyDefault = parcelHelpers.interopDefault(_organizationAnalyticsBody);
const OrganizationAnalytics = (props)=>(0, _react.jsx)((0, _unstated.Subscribe), {
        to: [
            (0, _templateConfigurationContainerDefault.default),
            (0, _organizationContainerDefault.default)
        ]
    }, ()=>{
        return (0, _react.jsx)((0, _organizationAnalyticsBodyDefault.default), {
            history: props.history
        });
    });
exports.default = OrganizationAnalytics;

},{"@emotion/react":"djZKr","react":"6uln9","unstated":"grh7p","../../state/containers/OrganizationContainer":"dlbaM","../../state/containers/TemplateConfigurationContainer":"aJrgZ","./components/OrganizationAnalyticsBody":"2Ezvx","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2Ezvx":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _moment = require("moment");
var _momentDefault = parcelHelpers.interopDefault(_moment);
var _timeIntervalSelectorHeader = require("../../../components/analytics/TimeIntervalSelectorHeader");
var _timeIntervalSelectorHeaderDefault = parcelHelpers.interopDefault(_timeIntervalSelectorHeader);
var _scrollablePanelBody = require("../../../components/structure/ScrollablePanelBody");
var _scrollablePanelBodyDefault = parcelHelpers.interopDefault(_scrollablePanelBody);
var _dateRangeIntervalPicker = require("../../../components/analytics/DateRangeIntervalPicker");
var _dateRangeIntervalPickerDefault = parcelHelpers.interopDefault(_dateRangeIntervalPicker);
var _css = require("@emotion/css");
var _analyticsDateFormat = require("../../../models/analytics/AnalyticsDateFormat");
var _queryString = require("query-string");
var _queryStringDefault = parcelHelpers.interopDefault(_queryString);
var _organizationAnalyticsPage = require("./OrganizationAnalyticsPage");
var _organizationAnalyticsPageDefault = parcelHelpers.interopDefault(_organizationAnalyticsPage);
var _panelHeaderContainer = require("../../../components/structure/Panels/PanelHeaderContainer");
var _panelHeaderContainerDefault = parcelHelpers.interopDefault(_panelHeaderContainer);
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const OrganizationAnalyticsBody = (props)=>{
    const query = (0, _queryStringDefault.default).parse(window.location.search);
    const [interval, setInterval] = (0, _react1.useState)(query?.interval ?? "past 7 days");
    const [startDate, setStartDate] = (0, _react1.useState)(query?.startDate ?? (0, _momentDefault.default)().startOf("day").subtract(7, "days").format((0, _analyticsDateFormat.DATE_FORMAT)));
    const [endDate, setEndDate] = (0, _react1.useState)(query?.endDate ?? (0, _momentDefault.default)().endOf("day").add(2, "days").format((0, _analyticsDateFormat.DATE_FORMAT)));
    const [isDatePickerExpanded, setIsDatePickerExpanded] = (0, _react1.useState)(false);
    const [filter, setFilter] = (0, _react1.useState)({});
    const handleDateRangeChange = (0, _react1.useCallback)((startDate, endDate, interval)=>{
        setStartDate(startDate);
        setEndDate(endDate);
        setInterval(interval);
        setIsDatePickerExpanded(false);
        setFilter({
            ...filter
        });
        props.history.push({
            search: `?startDate=${startDate}&endDate=${endDate}&interval=${interval}`
        });
    }, [
        props.history
    ]);
    const toggleDatePicker = ()=>{
        setIsDatePickerExpanded(!isDatePickerExpanded);
    };
    const currentFilter = {
        startDate: startDate,
        endDate: endDate
    };
    return (0, _react.jsx)((0, _reactDefault.default).Fragment, null, (0, _react.jsx)((0, _panelHeaderContainerDefault.default), {
        className: panelHeaderStyle
    }, (0, _react.jsx)((0, _timeIntervalSelectorHeaderDefault.default), {
        startDate: startDate,
        endDate: endDate,
        isExpanded: isDatePickerExpanded,
        onClick: toggleDatePicker
    })), (0, _react.jsx)((0, _scrollablePanelBodyDefault.default), null, isDatePickerExpanded && (0, _react.jsx)((0, _dateRangeIntervalPickerDefault.default), {
        startDate: startDate,
        endDate: endDate,
        interval: interval,
        onChange: handleDateRangeChange,
        onClose: toggleDatePicker
    }), (0, _react.jsx)((0, _organizationAnalyticsPageDefault.default), {
        history: props.history,
        filter: currentFilter
    })));
};
const panelHeaderStyle = /*#__PURE__*/ (0, _css.css)({
    name: "1xslzi3",
    styles: "padding:0 0px;button{margin-right:0;margin-left:auto;}h2{font-size:18px;line-height:24px;}"
});
exports.default = OrganizationAnalyticsBody;

},{"@emotion/react":"djZKr","react":"6uln9","moment":"2meyw","../../../components/analytics/TimeIntervalSelectorHeader":"9ttp0","../../../components/structure/ScrollablePanelBody":"6LRg3","../../../components/analytics/DateRangeIntervalPicker":"2sClv","@emotion/css":"awUBr","../../../models/analytics/AnalyticsDateFormat":"ia5MW","query-string":"klvAV","./OrganizationAnalyticsPage":"fYOAo","../../../components/structure/Panels/PanelHeaderContainer":"hUotd","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"fYOAo":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _reactTabs = require("react-tabs");
var _scrollablePanelBody = require("../../../components/structure/ScrollablePanelBody");
var _scrollablePanelBodyDefault = parcelHelpers.interopDefault(_scrollablePanelBody);
var _tabbedLayout = require("../../../components/structure/TabbedLayout");
var _tabbedLayoutDefault = parcelHelpers.interopDefault(_tabbedLayout);
var _organizationOrderingAnalyticsReport = require("./OrganizationOrderingAnalyticsReport");
var _organizationOrderingAnalyticsReportDefault = parcelHelpers.interopDefault(_organizationOrderingAnalyticsReport);
var _orgAnalyticsContainer = require("../../../hooks/OrgAnalyticsContainer");
var _orgAnalyticsContainerDefault = parcelHelpers.interopDefault(_orgAnalyticsContainer);
var _lodash = require("lodash");
const OrganizationAnalyticsPage = (props)=>{
    const orgAnalyticsContainer = (0, _orgAnalyticsContainerDefault.default).useContainer();
    const filterRef = (0, _react1.useRef)(null);
    (0, _react1.useEffect)(()=>{
        const currentOrgId = JSON.parse(localStorage.getItem("CURRENT_ORG"))?.id;
        if (!currentOrgId) return;
        if (!(0, _lodash.isEqual)(filterRef.current, props.filter)) {
            orgAnalyticsContainer.loadOrgAnalytics(currentOrgId, props.filter);
            filterRef.current = props.filter;
        }
    }, [
        props.filter
    ]);
    const handleTabSelection = (index, last)=>{
        if (index == last) return;
        const urlStart = "/v/orgAnalytics/";
        if (index == 0) props.history.push(urlStart);
        if (index == 1) props.history.push(urlStart + "ordering");
    };
    const getSelectedIndex = ()=>{
        if (location.href.indexOf("ordering") > -1) return 1;
        return 0;
    };
    return (0, _react.jsx)((0, _scrollablePanelBodyDefault.default), null, (0, _react.jsx)((0, _tabbedLayoutDefault.default), {
        tabs: [
            "General Performance",
            "Ordering Performance"
        ],
        top: true,
        selectedIndex: getSelectedIndex(),
        onTabSelected: (idx, last)=>handleTabSelection(idx, last)
    }, (0, _react.jsx)((0, _reactTabs.TabPanel), null, (0, _react.jsx)((0, _organizationOrderingAnalyticsReportDefault.default), {
        scope: "general",
        filter: props.filter
    })), (0, _react.jsx)((0, _reactTabs.TabPanel), null, (0, _react.jsx)((0, _organizationOrderingAnalyticsReportDefault.default), {
        scope: "ordering",
        filter: props.filter
    }))));
};
exports.default = OrganizationAnalyticsPage;

},{"@emotion/react":"djZKr","react":"6uln9","react-tabs":"92Sgf","../../../components/structure/ScrollablePanelBody":"6LRg3","../../../components/structure/TabbedLayout":"Hb6hy","./OrganizationOrderingAnalyticsReport":"5rB2R","../../../hooks/OrgAnalyticsContainer":"d3Eao","lodash":"3hMBK","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"5rB2R":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _base = require("@emotion/styled/base");
var _baseDefault = parcelHelpers.interopDefault(_base);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _totalCard = require("../../../components/charts/TotalCard");
var _totalCardDefault = parcelHelpers.interopDefault(_totalCard);
var _loader = require("../../../components/general/Loader");
var _loaderDefault = parcelHelpers.interopDefault(_loader);
var _pageError = require("../../../components/general/PageError");
var _pageErrorDefault = parcelHelpers.interopDefault(_pageError);
var _button = require("../../../components/general/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _reactRouterDom = require("react-router-dom");
var _colors = require("../../../constants/colors");
var _css = require("@emotion/css");
var _orgAnalyticsContainer = require("../../../hooks/OrgAnalyticsContainer");
var _orgAnalyticsContainerDefault = parcelHelpers.interopDefault(_orgAnalyticsContainer);
var _modalLayout = require("../../../components/structure/ModalLayout");
var _modalLayoutDefault = parcelHelpers.interopDefault(_modalLayout);
var _modalHeader = require("../../../components/general/ModalHeader");
var _modalHeaderDefault = parcelHelpers.interopDefault(_modalHeader);
var _sessionReview = require("../../applicationAnalytics/components/SessionReview");
var _sessionReviewDefault = parcelHelpers.interopDefault(_sessionReview);
var _useWindowSize = require("../../../hooks/UseWindowSize");
var _useWindowSizeDefault = parcelHelpers.interopDefault(_useWindowSize);
var _analyticsDateFormat = require("../../../models/analytics/AnalyticsDateFormat");
var _moment = require("moment");
var _momentDefault = parcelHelpers.interopDefault(_moment);
var _collapsingPanel = require("../../../components/structure/Panels/CollapsingPanel");
var _collapsingPanelDefault = parcelHelpers.interopDefault(_collapsingPanel);
var _footerBar = require("../../../components/structure/FooterBar");
var _footerBarDefault = parcelHelpers.interopDefault(_footerBar);
var _urls = require("../../../constants/Urls");
var _codeOutputModal = require("../../simulator/components/CodeOutputModal");
var _codeOutputModalDefault = parcelHelpers.interopDefault(_codeOutputModal);
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const conversationalSuccessIcon = require("328aef346652b114");
const conversationalFailureIcon = require("eef4e1c88af80426");
const orderPlacedIcon = require("cca235c356df0957");
const OrganizationOrderingAnalyticsReport = (props)=>{
    const [eventsToReview, setEventsToReview] = (0, _react1.useState)([]);
    const [sessionIdToReview, setSessionIdToReview] = (0, _react1.useState)("");
    const [eventsToReviewInCode, setEventsToReviewInCode] = (0, _react1.useState)([]);
    const [expandPlacedOrders, setExpandPlacedOrder] = (0, _react1.useState)(false);
    const [expandFailedOrders, setExpandFailedOrders] = (0, _react1.useState)(false);
    const [expandUnsuccessfulSessions, setExpandUnsuccessfulSessions] = (0, _react1.useState)(false);
    const [expandUnsuccessfulTransferSessions, setExpandUnsuccessfulTransferSessions] = (0, _react1.useState)(false);
    const [expandSuccessfulSessions, setExpandSuccessfulSessions] = (0, _react1.useState)(false);
    const [expandSuccessfulUnplaced, setExpandSuccessfulUnplaced] = (0, _react1.useState)(false);
    const [applicationId, setApplicationId] = (0, _react1.useState)("");
    const [copyButtonText, setCopyButtonText] = (0, _react1.useState)("Copy Session");
    const orgAnalyticsContainer = (0, _orgAnalyticsContainerDefault.default).useContainer();
    const windowSize = (0, _useWindowSizeDefault.default)();
    (0, _react1.useEffect)(()=>{
        let load = false;
        if (sessionIdToReview?.length) {
            if (eventsToReview?.length) {
                if (eventsToReview.some((e)=>e?.sessionId === sessionIdToReview)) load = false;
                else load = true;
            } else load = true;
        }
        if (load) {
            if (sessionIdToReview in orgAnalyticsContainer.allEventsCache) setEventsToReview(orgAnalyticsContainer.allEventsCache[sessionIdToReview]);
            else orgAnalyticsContainer.loadAllEventsForSession(sessionIdToReview, applicationId);
        }
    }, [
        sessionIdToReview,
        eventsToReview,
        orgAnalyticsContainer.allEventsCache
    ]);
    const convertEventsForCodeOutputModal = (events)=>{
        var returnObj = {};
        events?.forEach((e, idx)=>{
            returnObj[`${idx}-${e.eventType}`] = e;
        });
        // get last event that is request received
        const lastContentHit = events?.slice()?.reverse()?.find((e)=>e.eventType === "ContentHit");
        if (lastContentHit?.originalRequest?.sessionAttributes) returnObj[`${events.length}-LatestSessionAttributes`] = lastContentHit.originalRequest.sessionAttributes;
        return returnObj;
    };
    const CodeReviewModal = ()=>{
        return (0, _react.jsx)((0, _codeOutputModalDefault.default), {
            title: "JSON",
            closeModal: ()=>setEventsToReviewInCode(null),
            data: convertEventsForCodeOutputModal(eventsToReviewInCode),
            showCodeOutputModal: eventsToReviewInCode?.length > 0
        });
    };
    const clearSessionToReview = ()=>{
        setEventsToReview([]);
        setSessionIdToReview("");
    };
    const resetCopyButtonText = ()=>{
        setCopyButtonText("Copy Session");
    };
    const formatPercentage = (value)=>{
        if (!value) return "0 %";
        if (value < 0) return "None";
        return `${(value * 100).toFixed(2)} %`;
    };
    const handleCopyButtonClick = (url)=>{
        navigator.clipboard.writeText(url);
        setCopyButtonText("Copied!");
    };
    const getStartandEndDate = (sessionId)=>{
        const session = orgAnalyticsContainer.sessions?.find((s)=>s.sessionId === sessionId);
        if (session) {
            const weekBeforeStartDate = new Date(new Date(session?.startDate).getTime() - 604800000).toISOString().split("T")[0];
            const dayAfterStartDate = new Date(new Date(session?.startDate).getTime() + 86400000).toISOString().split("T")[0];
            return `&startDate=${weekBeforeStartDate}&endDate=${dayAfterStartDate}`;
        }
    };
    const CustomSessionReview = ()=>{
        if (!eventsToReview?.length) return (0, _react.jsx)((0, _reactDefault.default).Fragment, null);
        const e = eventsToReview?.length && eventsToReview[0] ? eventsToReview[0] : null;
        return (0, _react.jsx)("div", {
            onClick: (e)=>{
                e.stopPropagation();
            }
        }, (0, _react.jsx)((0, _modalLayoutDefault.default), {
            isVisible: true
        }, (0, _react.jsx)((0, _modalHeaderDefault.default), {
            title: `${(0, _momentDefault.default)(e?.eventDate).format((0, _analyticsDateFormat.SESSION_DATE_FORMAT))}`,
            onClose: ()=>{
                clearSessionToReview();
                resetCopyButtonText();
            }
        }), (0, _react.jsx)((0, _sessionReviewDefault.default), {
            inModal: true,
            manualHeight: windowSize.windowSize.innerHeight * .9 - 168,
            events: eventsToReview ?? [],
            applicationId: applicationId,
            setEventsToShow: setEventsToReviewInCode,
            resetCopyButtonText: resetCopyButtonText,
            sessionId: e?.sessionId
        }), (0, _react.jsx)((0, _footerBarDefault.default), null, (0, _react.jsx)((0, _reactRouterDom.Link), {
            to: `/v/apps/${e?.applicationId}/analytics/sessions?sessionId=${e.sessionId}`,
            target: "_blank",
            rel: "noopener noreferrer",
            onClick: (e)=>{
                e.stopPropagation();
                resetCopyButtonText();
            }
        }, (0, _react.jsx)((0, _buttonDefault.default), {
            disabled: false,
            themes: [
                "secondary"
            ],
            text: "Go To Session",
            onClick: null,
            type: "button"
        })), (0, _react.jsx)("div", null, (0, _react.jsx)((0, _buttonDefault.default), {
            disabled: false,
            themes: [
                "secondary"
            ],
            text: copyButtonText,
            onClick: ()=>handleCopyButtonClick(`${(0, _urls.getBaseUrl)()}/v/apps/${e?.applicationId}/analytics/sessions?sessionId=${e.sessionId}${getStartandEndDate(e.sessionId)}`),
            type: "button"
        })), (0, _react.jsx)(FooterButton, {
            type: "button",
            themes: [
                "secondary"
            ],
            text: "Close",
            onClick: (e)=>{
                clearSessionToReview();
                e.stopPropagation();
                resetCopyButtonText();
            }
        }))));
    };
    const renderCollapsableSessionReview = (sessionsToReview, title, expandBool, setBoolFunc)=>{
        return (0, _react.jsx)((0, _collapsingPanelDefault.default), {
            collapsedView: (0, _react.jsx)(ClickableHeader, {
                onClick: ()=>setBoolFunc(!expandBool)
            }, `${title} (${sessionsToReview.length})`),
            isCollapsed: !expandBool,
            expandedView: (0, _react.jsx)((0, _reactDefault.default).Fragment, null, (0, _react.jsx)(ClickableHeader, {
                onClick: ()=>{
                    setBoolFunc(!expandBool);
                }
            }, `${title} (${sessionsToReview.length})`), sessionsToReview.map((session, idx)=>{
                return (0, _react.jsx)(SessionHeader, {
                    className: orgAnalyticsContainer.loadingSessionId === session.sessionId ? "loading" : "",
                    key: session.sessionId,
                    onClick: ()=>{
                        if (!orgAnalyticsContainer.loadingSessionId.length) setSessionIdToReview(session.sessionId);
                        setApplicationId(session?.applicationId);
                    }
                }, (0, _react.jsx)(SessionHeaderDate, null, `${(0, _momentDefault.default)(session?.startDate ?? new Date()).format((0, _analyticsDateFormat.SESSION_DATE_FORMAT))}`), (0, _react.jsx)(SessionLink, {
                    to: `/v/apps/${session?.applicationId}/analytics/sessions?sessionId=${session.sessionId}`,
                    target: "_blank",
                    rel: "noopener noreferrer",
                    onClick: (e)=>{
                        e.stopPropagation();
                    }
                }, (0, _react.jsx)(SessionLinkButton, {
                    disabled: false,
                    themes: [
                        "secondary-small"
                    ],
                    text: "Full Session",
                    onClick: null,
                    type: "button"
                })));
            }))
        });
    };
    if (orgAnalyticsContainer.loadingSessionsOfAllApplications || orgAnalyticsContainer.loadingOrgAnalytics || orgAnalyticsContainer.loadingCallStatistics || orgAnalyticsContainer.loadingTopIntents || orgAnalyticsContainer.loadingOrdersPlaced || orgAnalyticsContainer.loadingItemAddedToOrder || orgAnalyticsContainer.loadingConversationalSucess || orgAnalyticsContainer.loadingCallTransferredEvents || orgAnalyticsContainer.loadingImmediateCallTransferredEvents) return (0, _react.jsx)((0, _loaderDefault.default), null);
    const alleviatedCalls = orgAnalyticsContainer.sessionIdCount - (orgAnalyticsContainer.transfers + orgAnalyticsContainer.noTransferUnsuccessfulSessions.length);
    return (0, _react.jsx)((0, _reactDefault.default).Fragment, null, props.scope === "general" ? (0, _react.jsx)((0, _reactDefault.default).Fragment, null, (0, _react.jsx)(Header, null, "Organizational Insights"), (0, _react.jsx)(SummaryContainer, null, (0, _react.jsx)(StyledTotalCard, {
        title: "Calls",
        value: orgAnalyticsContainer.sessionIdCount,
        tooltip: "The total number of tracked sessions against this assistant."
    })), (0, _react.jsx)(SummaryContainer, null, (0, _react.jsx)(StyledTotalCard, {
        title: "Assistant successful",
        subtitle: "",
        value: formatPercentage((orgAnalyticsContainer.conversationalSuccessCount + orgAnalyticsContainer.noInteractionCount) / orgAnalyticsContainer.sessionIdCount),
        subValue: `${orgAnalyticsContainer.conversationalSuccessCount + orgAnalyticsContainer.noInteractionCount} of ${orgAnalyticsContainer.sessionIdCount} calls`,
        tooltip: "Assistant was able to handle the customer's request",
        highlight: true,
        className: highlightedTotalCardStyle,
        icon: conversationalSuccessIcon
    }), (0, _react.jsx)(StyledTotalCard, {
        title: "Assistant unsuccessful",
        subtitle: "",
        value: formatPercentage((orgAnalyticsContainer.unsuccessfulButTransfered + orgAnalyticsContainer.noTransferUnsuccessfulSessions.length) / orgAnalyticsContainer.sessionIdCount),
        subValue: `${orgAnalyticsContainer.unsuccessfulButTransfered + orgAnalyticsContainer.noTransferUnsuccessfulSessions.length} of ${orgAnalyticsContainer.sessionIdCount} calls`,
        tooltip: "Assistant was not able to handle the customer's request.",
        highlight: true,
        className: highlightedTotalWarningCardStyle,
        icon: conversationalFailureIcon
    })), (0, _react.jsx)(SummaryContainer, null, (0, _react.jsx)(StyledTotalCard, {
        title: "Successfull conversation",
        subtitle: "",
        value: formatPercentage(orgAnalyticsContainer.conversationalSuccessCount / orgAnalyticsContainer.sessionIdCount),
        subValue: `${orgAnalyticsContainer.conversationalSuccessCount?.toString()} of ${orgAnalyticsContainer.sessionIdCount} calls`,
        tooltip: "Calls handled successfully by the assistant including orders placed and questions and requests completed.",
        highlight: true,
        className: highlightedTotalCardStyle,
        icon: conversationalSuccessIcon
    }), (0, _react.jsx)(StyledTotalCard, {
        title: "Customer unresponsive",
        subtitle: "",
        value: formatPercentage(orgAnalyticsContainer.noInteractionCount / orgAnalyticsContainer.sessionIdCount),
        subValue: `${orgAnalyticsContainer.noInteractionCount?.toString()} of ${orgAnalyticsContainer.sessionIdCount} calls`,
        tooltip: "Calls where the customer did respond to the assistant's welcome message.",
        highlight: true,
        className: highlightedTotalCardStyle,
        icon: conversationalSuccessIcon
    }), (0, _react.jsx)(StyledTotalCard, {
        title: "Transferred customer",
        subtitle: "",
        value: formatPercentage(orgAnalyticsContainer.unsuccessfulButTransfered / orgAnalyticsContainer.sessionIdCount),
        subValue: `${orgAnalyticsContainer.unsuccessfulButTransfered?.toString()} of ${orgAnalyticsContainer.sessionIdCount} calls`,
        tooltip: "Unsuccessful handling of customers request resulted in the call being transferred.",
        highlight: true,
        className: highlightedTotalWarningCardStyle,
        icon: conversationalFailureIcon
    }), (0, _react.jsx)(StyledTotalCard, {
        title: "Didn't transfer customer",
        subtitle: "",
        value: formatPercentage(orgAnalyticsContainer.noTransferUnsuccessfulSessions.length / orgAnalyticsContainer.sessionIdCount),
        subValue: `${orgAnalyticsContainer.noTransferUnsuccessfulSessions.length?.toString()} of ${orgAnalyticsContainer.sessionIdCount} calls`,
        tooltip: "Unsuccessfull call that did not result in the customer being transferred (likely customer hung up).",
        highlight: true,
        className: highlightedTotalWarningCardStyle,
        icon: conversationalFailureIcon
    })), (0, _react.jsx)(SummaryContainer, null, (0, _react.jsx)(StyledTotalCard, {
        title: "Autonomously Completed Calls",
        tooltip: "The total number of calls that were successfully handled by the assistant without the need for a transfer.",
        value: formatPercentage(alleviatedCalls / orgAnalyticsContainer.sessionIdCount),
        subValue: `${alleviatedCalls} calls`
    })), (0, _react.jsx)(SummaryContainer, null, (0, _react.jsx)(StyledTotalCard, {
        title: "Transfer Rate",
        value: formatPercentage(orgAnalyticsContainer.callTransferRate),
        subValue: `${orgAnalyticsContainer.transfers.toString()} ${orgAnalyticsContainer.transfers === 1 ? " transfer" : " transfers"}`,
        tooltip: "% of all calls transfered"
    })), (0, _react.jsx)(SummaryContainer, null, (0, _react.jsx)(StyledTotalCard, {
        title: "Immediate Transfer Rate",
        value: formatPercentage(orgAnalyticsContainer.immediateCallTransferRate),
        subValue: `${orgAnalyticsContainer.immediateTransfers?.toString()} ${orgAnalyticsContainer.immediateTransfers === 1 ? " immediate transfer" : " immediate transfers"}`,
        tooltip: "% of calls immediately transferred."
    }))) : (0, _react.jsx)((0, _reactDefault.default).Fragment, null, (0, _react.jsx)(Header, null, "Organizational Ordering Insights"), (0, _react.jsx)(SummaryContainer, null, (0, _react.jsx)(StyledTotalCard, {
        title: "Order Attempts",
        value: orgAnalyticsContainer.orderAttempts,
        tooltip: "The total number of sessions where any items were added to the order."
    })), (0, _react.jsx)(SummaryContainer, null, (0, _react.jsx)(StyledTotalCard, {
        title: "Assistant Successful",
        subtitle: "(Attempted Orders)",
        value: formatPercentage(orgAnalyticsContainer.attemptedOrdersConversationalSuccessRate),
        subValue: `${orgAnalyticsContainer.conversationalSuccessWithOrderAttemptedCount ?? 0} of ${orgAnalyticsContainer.orderAttempts} calls`,
        tooltip: "Assistant placed the customers order or correctly understood their requests.",
        highlight: true,
        className: highlightedTotalCardStyle,
        icon: conversationalSuccessIcon
    }), (0, _react.jsx)(StyledTotalCard, {
        title: "Assistant Successful, Order Placed",
        subtitle: "(Attempted Orders)",
        value: formatPercentage(orgAnalyticsContainer.orderPlacedRate),
        subValue: `${orgAnalyticsContainer.orderPlacedCount?.toString()} of ${orgAnalyticsContainer.orderAttempts} calls`,
        tooltip: "Orders Placed divided by Order Attempts.",
        highlight: true,
        className: highlightedTotalCardStyle,
        icon: orderPlacedIcon
    })), (0, _react.jsx)(SummaryContainer, null, (0, _react.jsx)(StyledTotalCard, {
        title: "Transfer Rate",
        value: formatPercentage(orgAnalyticsContainer.orderTransferRate),
        subValue: `${orgAnalyticsContainer.orderTransfers} ${orgAnalyticsContainer.orderTransfers === 1 ? " transfer" : " transfers"}`,
        tooltip: "Transfer rate during Order Attempts."
    }))), (0, _react.jsx)("div", {
        className: sessionsDiv
    }, orgAnalyticsContainer.loadingSessionsOfAllApplications ? (0, _react.jsx)("div", {
        className: loadDiv
    }, (0, _react.jsx)((0, _loaderDefault.default), null)) : (0, _react.jsx)((0, _reactDefault.default).Fragment, null, props.scope === "general" ? (0, _react.jsx)((0, _reactDefault.default).Fragment, null, orgAnalyticsContainer.transferUnsuccessfulSessions.length ? renderCollapsableSessionReview(orgAnalyticsContainer.transferUnsuccessfulSessions, "Unsuccessful conversation transfered customer", expandUnsuccessfulSessions, setExpandUnsuccessfulSessions) : null, orgAnalyticsContainer.noTransferUnsuccessfulSessions.length ? renderCollapsableSessionReview(orgAnalyticsContainer.noTransferUnsuccessfulSessions, "Unsuccessful conversation didn't transfer customer", expandUnsuccessfulTransferSessions, setExpandUnsuccessfulTransferSessions) : null, orgAnalyticsContainer.conversationalSuccessSessions.length ? renderCollapsableSessionReview(orgAnalyticsContainer.conversationalSuccessSessions, "Successful conversations", expandSuccessfulSessions, setExpandSuccessfulSessions) : null) : (0, _react.jsx)((0, _reactDefault.default).Fragment, null, orgAnalyticsContainer.ordersPlacedSessions.length ? renderCollapsableSessionReview(orgAnalyticsContainer.ordersPlacedSessions, "Placed Orders", expandPlacedOrders, setExpandPlacedOrder) : null, orgAnalyticsContainer.successfulOrdersNotPlacedSessions.length ? renderCollapsableSessionReview(orgAnalyticsContainer.successfulOrdersNotPlacedSessions, "Successful conversations but order did not place", expandSuccessfulUnplaced, setExpandSuccessfulUnplaced) : null, orgAnalyticsContainer.unsuccessfulOrderSessions.length ? renderCollapsableSessionReview(orgAnalyticsContainer.unsuccessfulOrderSessions, "Unsuccessful conversations", expandFailedOrders, setExpandFailedOrders) : null))), (0, _react.jsx)(Spacer, null), (0, _react.jsx)((0, _pageErrorDefault.default), {
        errors: orgAnalyticsContainer.error ? [
            orgAnalyticsContainer.error
        ] : null
    }), (0, _react.jsx)(CodeReviewModal, null), (0, _react.jsx)(CustomSessionReview, null));
};
const highlightedTotalCardStyle = /*#__PURE__*/ (0, _css.css)("border:1px solid ", (0, _colors.color_colors_ocean), ";box-shadow:0px 4px 8px ", (0, _colors.color_variants_blue_2), ";", "");
const highlightedTotalWarningCardStyle = /*#__PURE__*/ (0, _css.css)("border:1px solid ", (0, _colors.color_shades_darkest), ";box-shadow:0px 4px 8px ", (0, _colors.color_variants_blue_2), ";", "");
const StyledTotalCard = /*#__PURE__*/ (0, _baseDefault.default)((0, _totalCardDefault.default), {
    target: "e1d458r99"
})({
    name: "5ddqek",
    styles: "padding:32px;height:auto;text-align:center;margin:16px 16px 0px 16px"
});
const Header = /*#__PURE__*/ (0, _baseDefault.default)("h3", {
    target: "e1d458r98"
})({
    name: "9nd8j7",
    styles: "margin:16px 32px;margin-top:24px;font-size:18px"
});
const ClickableHeader = /*#__PURE__*/ (0, _baseDefault.default)(Header, {
    target: "e1d458r97"
})({
    name: "e0dnmk",
    styles: "cursor:pointer"
});
const Spacer = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1d458r96"
})({
    name: "1hgqtge",
    styles: "height:100px"
});
const sessionsDiv = /*#__PURE__*/ (0, _css.css)({
    name: "bjn8wh",
    styles: "position:relative"
});
const SummaryContainer = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1d458r95"
})({
    name: "14ujbtq",
    styles: "display:flex;flex:1;margin:0 16px;padding-bottom:16px"
});
const loadDiv = /*#__PURE__*/ (0, _css.css)({
    name: "1mf4agh",
    styles: "margin-top:40px;position:absolute;top:50%;left:50%;transform:translate(-50%, -50%)"
});
const FooterButton = /*#__PURE__*/ (0, _baseDefault.default)((0, _buttonDefault.default), {
    target: "e1d458r94"
})({
    name: "1o3nkn",
    styles: "margin-left:auto"
});
const SessionHeader = /*#__PURE__*/ (0, _baseDefault.default)("h3", {
    target: "e1d458r93"
})("margin-top:24px;margin-bottom:16px;margin-left:24px;margin-right:24px;padding:16px 16px;border:1px solid ", (0, _colors.color_shades_dark), ";cursor:pointer;border-radius:12px 12px 12px 12px;display:flex;flex-direction:row;position:relative;&.loading{cursor:default;background-color:", (0, _colors.color_shades_light), ";}");
const SessionHeaderDate = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1d458r92"
})({
    name: "1j4ms98",
    styles: "margin-top:6px;margin-right:8px;font-weight:lighter;min-width:180px"
});
const SessionLinkButton = /*#__PURE__*/ (0, _baseDefault.default)((0, _buttonDefault.default), {
    target: "e1d458r91"
})({
    name: "ti75j2",
    styles: "margin:0"
});
const SessionLink = /*#__PURE__*/ (0, _baseDefault.default)((0, _reactRouterDom.Link), {
    target: "e1d458r90"
})({
    name: "1o3nkn",
    styles: "margin-left:auto"
});
exports.default = OrganizationOrderingAnalyticsReport;

},{"@emotion/styled/base":"lSuFu","@emotion/react":"djZKr","react":"6uln9","../../../components/charts/TotalCard":"gH7gf","../../../components/general/Loader":"bnV5T","../../../components/general/PageError":"ezFTm","../../../components/general/Button":"6ymxN","react-router-dom":"5fzqq","../../../constants/colors":"1p3OR","@emotion/css":"awUBr","../../../hooks/OrgAnalyticsContainer":"d3Eao","../../../components/structure/ModalLayout":"b1cO3","../../../components/general/ModalHeader":"aUACx","../../applicationAnalytics/components/SessionReview":"bA5x6","../../../hooks/UseWindowSize":"43j9z","../../../models/analytics/AnalyticsDateFormat":"ia5MW","moment":"2meyw","../../../components/structure/Panels/CollapsingPanel":"jVPoD","../../../components/structure/FooterBar":"bibRL","../../../constants/Urls":"iTopY","../../simulator/components/CodeOutputModal":"kbywW","328aef346652b114":"fHvPO","eef4e1c88af80426":"41TbH","cca235c356df0957":"jSys4","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"d3Eao":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _unstatedNext = require("unstated-next");
var _api = require("../api");
var _invalidResult = require("../models/result/InvalidResult");
var _invalidResultDefault = parcelHelpers.interopDefault(_invalidResult);
var _react = require("react");
var _moment = require("moment");
var _momentDefault = parcelHelpers.interopDefault(_moment);
var _engagementAnalyticsTransformers = require("../utils/engagementAnalyticsTransformers");
var _intents = require("../constants/Intents");
function useOrgAnalyticsContainer(props) {
    const [error, setError] = (0, _react.useState)("");
    const [loadingTopIntents, setLoadingTopIntents] = (0, _react.useState)(false);
    const [loadingOrdersPlaced, setLoadingOrdersPlaced] = (0, _react.useState)(false);
    const [loadingCallStatistics, setLoadingCallStatistics] = (0, _react.useState)(false);
    const [loadingConversationalSucess, setLoadingConversationalSuccess] = (0, _react.useState)(false);
    const [loadingItemAddedToOrder, setLoadingItemAddedToOrder] = (0, _react.useState)(false);
    const [loadingOrderTotalStatistics, setLoadingOrderTotalStatistics] = (0, _react.useState)(false);
    const [loadingTopLocationWithHighestNumberOfOrders, setLoadingTopLocationWithHighestNumberOfOrders] = (0, _react.useState)(false);
    const [loadingOrgAnalytics, setLoadingOrgAnalytics] = (0, _react.useState)(false);
    const [loadingOrgApplicationsPerformanceAnalytics, setLoadOrgApplicationsPerformanceAnalytics] = (0, _react.useState)(false);
    const [loadingCallTransferredEvents, setLoadingCallTransferredEvents] = (0, _react.useState)(false);
    const [loadingImmediateCallTransferredEvents, setLoadingImmediateCallTransferredEvents] = (0, _react.useState)(false);
    const [loadingSessionsOfAllApplications, setLoadingSessionsOfAllApplications] = (0, _react.useState)(false);
    const [sessions, setSessions] = (0, _react.useState)([]);
    const [allEventsCache, setAllEventsCache] = (0, _react.useState)({});
    const [loadingSessionId, setLoadingSessionId] = (0, _react.useState)("");
    const [callStatistics, setCallStatistics] = (0, _react.useState)(null);
    const [orderPlacedEvents, setOrderPlacedEvents] = (0, _react.useState)(null);
    const [topIntents, setTopIntents] = (0, _react.useState)(null);
    const [conversationalSuccessEvents, setConversationalSuccessEvents] = (0, _react.useState)(null);
    const [itemAddedConversationalSuccessEvents, setItemAddedConversationalSuccessEvents] = (0, _react.useState)(null);
    const [itemAddedToOrderEvents, setItemAddedToOrderEvents] = (0, _react.useState)(null);
    const [callCompleteEvents, setCallCompleteEvents] = (0, _react.useState)(null);
    const [orderTotalStatistics, setOrderTotalStatistics] = (0, _react.useState)(null);
    const [topLocationsWithNumberOfOrdersPlaced, setTopLocationsWithHighestNumberOfOrders] = (0, _react.useState)(null);
    const [callTransferredEvents, setCallTransferredEvents] = (0, _react.useState)();
    const [immediateCallTransferredEvents, setImmediateCallTransferredEvents] = (0, _react.useState)();
    const [immediateTransfers, setImmediateTransfers] = (0, _react.useState)(0);
    const [transfers, setTransfers] = (0, _react.useState)(0);
    const [callTransferRate, setCallTransferRate] = (0, _react.useState)();
    const [immediateCallTransferRate, setImmediateCallTransferRate] = (0, _react.useState)();
    const [conversationalSuccessRate, setConversationalSuccessRate] = (0, _react.useState)();
    const [orderPlacedCount, setOrdersPlacedCount] = (0, _react.useState)(0);
    const [attemptedOrdersConversationalSuccessRate, setAttemptedOrdersConversationalSuccessRate] = (0, _react.useState)(null);
    const [orderPlacedRate, setOrderPlacedRate] = (0, _react.useState)(null);
    const [orderTransferRate, setOrderTransferRate] = (0, _react.useState)(null);
    const [orderTransfers, setOrderTransfers] = (0, _react.useState)(null);
    const [conversationalSuccessCount, setConversationalSuccessCount] = (0, _react.useState)(null);
    const [conversationalSuccessWithOrderAttemptedCount, setConversationalSuccessWithOrderAttemptedCount] = (0, _react.useState)(null);
    const [orderAttempts, setOrderAttempts] = (0, _react.useState)();
    const [orgApplicationsPerformanceAnalytics, setOrgApplicationsPerformanceAnalytics] = (0, _react.useState)();
    const [unsuccessfulOrderAttempts, setUnsuccessfulOrderAttempts] = (0, _react.useState)(0);
    const [noInteractionCount, setNoInteractionCount] = (0, _react.useState)(0);
    const [unsuccessfulButTransfered, setUnsuccessfulButTransfered] = (0, _react.useState)(0);
    const NUMBER_OF_TOP_LOCATIONS_WITH_HIGHEST_ORDERS = 3;
    const [unsuccessfulOrderSessions, setUnsuccessfulOrderSessions] = (0, _react.useState)([]);
    const [ordersPlacedSessions, setOrdersPlacedSessions] = (0, _react.useState)([]);
    const [successfulOrdersNotPlacedSessions, setSuccessfulOrdersNotPlacedSessions] = (0, _react.useState)([]);
    const [orderTransferredSessionIds, setOrderTransferredSessionIds] = (0, _react.useState)([]);
    const [noOrderSessionIds, setNoOrderSessionIds] = (0, _react.useState)([]);
    const [noTransferUnsuccessfulSessions, setNoTransferUnsuccessfulSessions] = (0, _react.useState)([]);
    const [transferUnsuccessfulSessions, setTransferUnsuccessfulSessions] = (0, _react.useState)([]);
    const [conversationalSuccessSessions, setConversationalSuccessSessions] = (0, _react.useState)([]);
    const [sessionIdCount, setSessionIdCount] = (0, _react.useState)(0);
    const [reloadBool, setReloadBool] = (0, _react.useState)(false);
    // Engagement Analytics State
    // Initialize to true so loader shows on first render until data loads
    const [loadingOrganizationEngagements, setLoadingOrganizationEngagements] = (0, _react.useState)(true);
    const [loadingEngagementsForTagCombo, setLoadingEngagementsForTagCombo] = (0, _react.useState)(false);
    const [loadingTopLevelMetrics, setLoadingTopLevelMetrics] = (0, _react.useState)(false);
    const [loadingOrganizationTopLevelMetrics, setLoadingOrganizationTopLevelMetrics] = (0, _react.useState)(false);
    const [loadingCallVolumeHistogram, setLoadingCallVolumeHistogram] = (0, _react.useState)(false);
    const [loadingOrganizationCallVolumeHistogram, setLoadingOrganizationCallVolumeHistogram] = (0, _react.useState)(false);
    const [loadingAverageCallVolumeHistogram, setLoadingAverageCallVolumeHistogram] = (0, _react.useState)(false);
    const [loadingOrganizationAverageCallVolumeHistogram, setLoadingOrganizationAverageCallVolumeHistogram] = (0, _react.useState)(false);
    const [loadingOrganizationAverageCallVolumeByHourHistogram, setLoadingOrganizationAverageCallVolumeByHourHistogram] = (0, _react.useState)(false);
    const [loadingContainableCallVolumeHistogram, setLoadingContainableCallVolumeHistogram] = (0, _react.useState)(false);
    const [loadingOrganizationContainableCallVolumeHistogram, setLoadingOrganizationContainableCallVolumeHistogram] = (0, _react.useState)(false);
    const [loadingContainedCallVolumeHistogram, setLoadingContainedCallVolumeHistogram] = (0, _react.useState)(false);
    const [loadingOrganizationContainedCallVolumeHistogram, setLoadingOrganizationContainedCallVolumeHistogram] = (0, _react.useState)(false);
    const [loadingAverageContainableCallVolumeHistogram, setLoadingAverageContainableCallVolumeHistogram] = (0, _react.useState)(false);
    const [loadingOrganizationAverageContainableCallVolumeHistogram, setLoadingOrganizationAverageContainableCallVolumeHistogram] = (0, _react.useState)(false);
    const [loadingAverageContainedCallVolumeHistogram, setLoadingAverageContainedCallVolumeHistogram] = (0, _react.useState)(false);
    const [loadingOrganizationAverageContainedCallVolumeHistogram, setLoadingOrganizationAverageContainedCallVolumeHistogram] = (0, _react.useState)(false);
    const [loadingSpanishCallVolumeHistogram, setLoadingSpanishCallVolumeHistogram] = (0, _react.useState)(false);
    const [loadingOrganizationSpanishCallVolumeHistogram, setLoadingOrganizationSpanishCallVolumeHistogram] = (0, _react.useState)(false);
    const [loadingSpanishContainableCallVolumeHistogram, setLoadingSpanishContainableCallVolumeHistogram] = (0, _react.useState)(false);
    const [loadingOrganizationSpanishContainableCallVolumeHistogram, setLoadingOrganizationSpanishContainableCallVolumeHistogram] = (0, _react.useState)(false);
    const [loadingSpanishContainedCallVolumeHistogram, setLoadingSpanishContainedCallVolumeHistogram] = (0, _react.useState)(false);
    const [loadingOrganizationSpanishContainedCallVolumeHistogram, setLoadingOrganizationSpanishContainedCallVolumeHistogram] = (0, _react.useState)(false);
    const [loadingConcurrentCallVolumeHistogram, setLoadingConcurrentCallVolumeHistogram] = (0, _react.useState)(false);
    const [loadingOrganizationConcurrentCallVolumeHistogram, setLoadingOrganizationConcurrentCallVolumeHistogram] = (0, _react.useState)(false);
    const [organizationEngagements, setOrganizationEngagements] = (0, _react.useState)([]);
    const [organizationEngagementsPerApp, setOrganizationEngagementsPerApp] = (0, _react.useState)({});
    const [engagementsForTagCombo, setEngagementsForTagCombo] = (0, _react.useState)([]);
    const [topLevelMetrics, setTopLevelMetrics] = (0, _react.useState)(null);
    const [organizationTopLevelMetrics, setOrganizationTopLevelMetrics] = (0, _react.useState)(null);
    const [organizationTopLevelMetricsPerApp, setOrganizationTopLevelMetricsPerApp] = (0, _react.useState)({});
    const [callVolumeHistogram, setCallVolumeHistogram] = (0, _react.useState)(null);
    const [organizationCallVolumeHistogram, setOrganizationCallVolumeHistogram] = (0, _react.useState)(null);
    const [organizationCallVolumeHistogramPerApp, setOrganizationCallVolumeHistogramPerApp] = (0, _react.useState)({});
    const [averageCallVolumeHistogram, setAverageCallVolumeHistogram] = (0, _react.useState)(null);
    const [organizationAverageCallVolumeHistogram, setOrganizationAverageCallVolumeHistogram] = (0, _react.useState)(null);
    const [organizationAverageCallVolumeHistogramPerApp, setOrganizationAverageCallVolumeHistogramPerApp] = (0, _react.useState)({});
    const [organizationAverageCallVolumeByHourHistogram, setOrganizationAverageCallVolumeByHourHistogram] = (0, _react.useState)(null);
    const [organizationAverageCallVolumeByHourHistogramPerApp, setOrganizationAverageCallVolumeByHourHistogramPerApp] = (0, _react.useState)({});
    const [containableCallVolumeHistogram, setContainableCallVolumeHistogram] = (0, _react.useState)(null);
    const [organizationContainableCallVolumeHistogram, setOrganizationContainableCallVolumeHistogram] = (0, _react.useState)(null);
    const [organizationContainableCallVolumeHistogramPerApp, setOrganizationContainableCallVolumeHistogramPerApp] = (0, _react.useState)({});
    const [containedCallVolumeHistogram, setContainedCallVolumeHistogram] = (0, _react.useState)(null);
    const [organizationContainedCallVolumeHistogram, setOrganizationContainedCallVolumeHistogram] = (0, _react.useState)(null);
    const [organizationContainedCallVolumeHistogramPerApp, setOrganizationContainedCallVolumeHistogramPerApp] = (0, _react.useState)({});
    const [averageContainableCallVolumeHistogram, setAverageContainableCallVolumeHistogram] = (0, _react.useState)(null);
    const [organizationAverageContainableCallVolumeHistogram, setOrganizationAverageContainableCallVolumeHistogram] = (0, _react.useState)(null);
    const [averageContainedCallVolumeHistogram, setAverageContainedCallVolumeHistogram] = (0, _react.useState)(null);
    const [organizationAverageContainedCallVolumeHistogram, setOrganizationAverageContainedCallVolumeHistogram] = (0, _react.useState)(null);
    const [spanishCallVolumeHistogram, setSpanishCallVolumeHistogram] = (0, _react.useState)(null);
    const [organizationSpanishCallVolumeHistogram, setOrganizationSpanishCallVolumeHistogram] = (0, _react.useState)(null);
    const [organizationSpanishCallVolumeHistogramPerApp, setOrganizationSpanishCallVolumeHistogramPerApp] = (0, _react.useState)({});
    const [spanishContainableCallVolumeHistogram, setSpanishContainableCallVolumeHistogram] = (0, _react.useState)(null);
    const [organizationSpanishContainableCallVolumeHistogram, setOrganizationSpanishContainableCallVolumeHistogram] = (0, _react.useState)(null);
    const [organizationSpanishContainableCallVolumeHistogramPerApp, setOrganizationSpanishContainableCallVolumeHistogramPerApp] = (0, _react.useState)({});
    const [spanishContainedCallVolumeHistogram, setSpanishContainedCallVolumeHistogram] = (0, _react.useState)(null);
    const [organizationSpanishContainedCallVolumeHistogram, setOrganizationSpanishContainedCallVolumeHistogram] = (0, _react.useState)(null);
    const [organizationSpanishContainedCallVolumeHistogramPerApp, setOrganizationSpanishContainedCallVolumeHistogramPerApp] = (0, _react.useState)({});
    const [concurrentCallVolumeHistogram, setConcurrentCallVolumeHistogram] = (0, _react.useState)(null);
    const [organizationConcurrentCallVolumeHistogram, setOrganizationConcurrentCallVolumeHistogram] = (0, _react.useState)(null);
    const [organizationConcurrentCallVolumeHistogramPerApp, setOrganizationConcurrentCallVolumeHistogramPerApp] = (0, _react.useState)({});
    // Order Volume State
    const [loadingOrderAttemptedVolumeHistogram, setLoadingOrderAttemptedVolumeHistogram] = (0, _react.useState)(false);
    const [loadingOrganizationOrderAttemptedVolumeHistogram, setLoadingOrganizationOrderAttemptedVolumeHistogram] = (0, _react.useState)(false);
    const [loadingOrderPlacedVolumeHistogram, setLoadingOrderPlacedVolumeHistogram] = (0, _react.useState)(false);
    const [loadingOrganizationOrderPlacedVolumeHistogram, setLoadingOrganizationOrderPlacedVolumeHistogram] = (0, _react.useState)(false);
    const [orderAttemptedVolumeHistogram, setOrderAttemptedVolumeHistogram] = (0, _react.useState)(null);
    const [organizationOrderAttemptedVolumeHistogram, setOrganizationOrderAttemptedVolumeHistogram] = (0, _react.useState)(null);
    const [organizationOrderAttemptedVolumeHistogramPerApp, setOrganizationOrderAttemptedVolumeHistogramPerApp] = (0, _react.useState)({});
    const [orderPlacedVolumeHistogram, setOrderPlacedVolumeHistogram] = (0, _react.useState)(null);
    const [organizationOrderPlacedVolumeHistogram, setOrganizationOrderPlacedVolumeHistogram] = (0, _react.useState)(null);
    const [organizationOrderPlacedVolumeHistogramPerApp, setOrganizationOrderPlacedVolumeHistogramPerApp] = (0, _react.useState)({});
    // Transfer Reasons State
    const [loadingOrganizationTransferReasons, setLoadingOrganizationTransferReasons] = (0, _react.useState)(false);
    const [loadingApplicationTransferReasons, setLoadingApplicationTransferReasons] = (0, _react.useState)(false);
    const [organizationTransferReasons, setOrganizationTransferReasons] = (0, _react.useState)(null);
    const [organizationPlannedTransferReasons, setOrganizationPlannedTransferReasons] = (0, _react.useState)(null);
    const [organizationUnplannedTransferReasons, setOrganizationUnplannedTransferReasons] = (0, _react.useState)(null);
    const [applicationTransferReasons, setApplicationTransferReasons] = (0, _react.useState)(null);
    // Appointments Managed State (for Patient Bookings chart)
    const [loadingScheduledEngagements, setLoadingScheduledEngagements] = (0, _react.useState)(false);
    const [loadingRescheduledEngagements, setLoadingRescheduledEngagements] = (0, _react.useState)(false);
    const [loadingCancelledEngagements, setLoadingCancelledEngagements] = (0, _react.useState)(false);
    const [loadingCheckNextAppointmentEngagements, setLoadingCheckNextAppointmentEngagements] = (0, _react.useState)(false);
    const [scheduledEngagements, setScheduledEngagements] = (0, _react.useState)([]);
    const [rescheduledEngagements, setRescheduledEngagements] = (0, _react.useState)([]);
    const [cancelledEngagements, setCancelledEngagements] = (0, _react.useState)([]);
    const [checkNextAppointmentEngagements, setCheckNextAppointmentEngagements] = (0, _react.useState)([]);
    // Off Hours Engagements State
    const [loadingOffHoursEngagements, setLoadingOffHoursEngagements] = (0, _react.useState)(false);
    const [offHoursEngagements, setOffHoursEngagements] = (0, _react.useState)([]);
    // Spanish Off Hours Engagements State (for language breakdown)
    const [loadingSpanishOffHoursEngagements, setLoadingSpanishOffHoursEngagements] = (0, _react.useState)(false);
    const [spanishOffHoursEngagements, setSpanishOffHoursEngagements] = (0, _react.useState)([]);
    // Transferred Engagements State (for Spanish-level transfer data)
    const [loadingTransferredEngagements, setLoadingTransferredEngagements] = (0, _react.useState)(false);
    const [transferredEngagements, setTransferredEngagements] = (0, _react.useState)([]);
    (0, _react.useEffect)(()=>{
        if (!itemAddedToOrderEvents || !orderPlacedEvents || !conversationalSuccessEvents || !callStatistics || !callCompleteEvents?.length || !sessions.length) return;
        const allSessionIds = getUniqueSessionIds(sessions);
        const itemAddedToOrderSessionIds = getUniqueSessionIds(itemAddedToOrderEvents);
        const callTransferedSessionIds = getUniqueSessionIds(callTransferredEvents);
        const orderAttempts = itemAddedToOrderSessionIds.length;
        setOrderAttempts(orderAttempts);
        const placedSessionIds = getUniqueSessionIds(orderPlacedEvents).filter((id)=>itemAddedToOrderSessionIds.includes(id));
        setOrdersPlacedSessions(matchSessionWithIdsAndSort(placedSessionIds));
        setOrdersPlacedCount(getUniqueSessionIds(orderPlacedEvents)?.length ?? 0);
        const conversationalSuccessEventsOverride = conversationalSuccessEvents.filter((x)=>allSessionIds.includes(x.sessionId));
        setConversationalSuccessEvents(conversationalSuccessEventsOverride);
        const conversationalSuccessEventSessions = getUniqueSessionIds(conversationalSuccessEventsOverride);
        setSessionIdCount(allSessionIds.length);
        const preliminaryUnsuccessList = [];
        const shownConversationalSuccessEvents = [];
        allSessionIds.forEach((sessionId)=>{
            if (conversationalSuccessEventSessions.includes(sessionId)) shownConversationalSuccessEvents.push(sessionId);
            else preliminaryUnsuccessList.push(sessionId);
        });
        setConversationalSuccessSessions(matchSessionWithIdsAndSort(shownConversationalSuccessEvents));
        setConversationalSuccessCount(shownConversationalSuccessEvents.length);
        const finalUnsuccessList = [];
        const tUnsucessTransferIds = [];
        const usuccessOrderAttemptsIds = [];
        if (preliminaryUnsuccessList.length > 0) {
            let unsuccessfulInteractions = preliminaryUnsuccessList.filter((sessionId)=>{
                const callComplete = callCompleteEvents.find((x)=>x.sessionId === sessionId);
                if (callComplete) {
                    if (callComplete.newTTSGenerations + callComplete.cachedTTSGenerations < 2) return false;
                }
                return true;
            });
            setNoInteractionCount(preliminaryUnsuccessList.length - unsuccessfulInteractions.length);
            unsuccessfulInteractions.forEach((sessionId)=>{
                if (callTransferedSessionIds.includes(sessionId)) tUnsucessTransferIds.push(sessionId);
                else finalUnsuccessList.push(sessionId);
                if (itemAddedToOrderSessionIds.includes(sessionId)) usuccessOrderAttemptsIds.push(sessionId);
            });
            setUnsuccessfulOrderAttempts(usuccessOrderAttemptsIds.length);
        }
        setNoTransferUnsuccessfulSessions(matchSessionWithIdsAndSort(finalUnsuccessList));
        setTransferUnsuccessfulSessions(matchSessionWithIdsAndSort(tUnsucessTransferIds));
        setUnsuccessfulButTransfered(tUnsucessTransferIds.length);
        setCallTransferRate(callTransferedSessionIds.length / callStatistics.calls);
        setTransfers(callTransferedSessionIds.length);
        // union of call transferred and order attempted session ids
        const oTransferSessIds = callTransferedSessionIds.filter((x)=>itemAddedToOrderSessionIds.includes(x));
        setOrderTransferredSessionIds(oTransferSessIds);
        const immediateCallTransferedSessionIds = getUniqueSessionIds(immediateCallTransferredEvents);
        setImmediateCallTransferRate(immediateCallTransferedSessionIds.length / callStatistics.calls);
        setImmediateTransfers(immediateCallTransferedSessionIds.length);
        const successfulOrderNotPlacedSessionIds = itemAddedToOrderSessionIds.filter((x)=>!placedSessionIds.includes(x) && conversationalSuccessEventSessions.includes(x));
        setSuccessfulOrdersNotPlacedSessions(matchSessionWithIdsAndSort(successfulOrderNotPlacedSessionIds));
        const noOrderSessions = sessions.filter((x)=>!itemAddedToOrderSessionIds.includes(x.sessionId));
        setNoOrderSessionIds(noOrderSessions.map((s)=>s.sessionId));
        if (!itemAddedToOrderSessionIds?.length) {
            setOrderPlacedRate(-1);
            setOrderTransferRate(-1);
            setOrderTransfers(-1);
        } else {
            setOrderPlacedRate(placedSessionIds.length / itemAddedToOrderSessionIds.length);
            const orderTransferedSessionIds = callTransferedSessionIds.filter((x)=>itemAddedToOrderSessionIds.includes(x));
            setOrderTransfers(orderTransferedSessionIds.length);
            setOrderTransferRate(orderTransferedSessionIds.length / itemAddedToOrderSessionIds.length);
            const allConversationalSuccessRate = shownConversationalSuccessEvents.length / (callStatistics.calls ?? 1);
            setConversationalSuccessRate(allConversationalSuccessRate);
            if (itemAddedToOrderSessionIds?.length > 0) {
                const orderAttemptedConversationalSuccess = itemAddedToOrderSessionIds.filter((id)=>placedSessionIds.includes(id) || shownConversationalSuccessEvents.includes(id));
                setConversationalSuccessWithOrderAttemptedCount(orderAttemptedConversationalSuccess.length);
                const itemAddedConversationalSuccessRate = orderAttemptedConversationalSuccess.length / orderAttempts;
                setAttemptedOrdersConversationalSuccessRate(itemAddedConversationalSuccessRate);
                const temp_unseccessfulOrderSessionIds = itemAddedToOrderSessionIds.filter((x)=>!placedSessionIds.includes(x) && !shownConversationalSuccessEvents.includes(x));
                setUnsuccessfulOrderSessions(matchSessionWithIdsAndSort(temp_unseccessfulOrderSessionIds));
            }
        }
    }, [
        itemAddedToOrderEvents,
        orderPlacedEvents,
        callStatistics,
        callCompleteEvents,
        sessions,
        reloadBool,
        callTransferredEvents
    ]);
    const matchSessionWithIdsAndSort = (ids)=>{
        var tempArr = [];
        for (const sessionId of ids){
            const session = sessions?.find((s)=>s.sessionId === sessionId);
            if (session) tempArr.push(session);
        }
        tempArr.sort((a, b)=>{
            return new Date(b.startDate).getTime() - new Date(a.startDate).getTime();
        });
        return tempArr;
    };
    const getOrgLevelCallStatistics = async (organizationId, filter)=>{
        setLoadingCallStatistics(true);
        const result = await _api.getCallStatistics(organizationId, filter);
        setLoadingCallStatistics(false);
        if (result.resultType === "Ok") setCallStatistics(result.data);
        else {
            setError(result.errors?.[0]);
            return new (0, _invalidResultDefault.default)(result.errors?.[0]);
        }
    };
    const getOrgItemAddedConversationalSuccessEvents = async (organizationId, filter)=>{
        const result = await _api.getItemAddedConversationalSuccessEvents(organizationId, filter);
        if (result.resultType === "Ok") setItemAddedConversationalSuccessEvents(result.data);
        else {
            setError(result.errors?.[0]);
            return new (0, _invalidResultDefault.default)(result.errors?.[0]);
        }
    };
    const getOrgLevelTopIntents = async (organizationId, filter)=>{
        setLoadingTopIntents(true);
        const result = await _api.getTopIntents(organizationId, filter);
        setLoadingTopIntents(false);
        if (result.resultType === "Ok") {
            const intents = [];
            for (const intent of result.data){
                if (!intent.intent?.trim() || (0, _intents.EXCLUDED_TOP_INTENTS).includes(intent.intent)) continue;
                else intents.push(intent);
            }
            const sortedIntents = intents.sort((a, b)=>b.count - a.count);
            const allIntents = [];
            for (const intent of sortedIntents){
                // Add spaces in between capital letters and before punctuation
                const splitIntent = intent.intent.split(/(?=[A-Z.,:;!?-])/).join(" ");
                allIntents.push({
                    name: splitIntent,
                    count: intent.count.toLocaleString()
                });
            }
            setTopIntents(allIntents);
        } else setError(result.errors?.[0]);
    };
    const getOrgLevelOrdersPlaced = async (organizationId, filter)=>{
        setLoadingOrdersPlaced(true);
        const result = await _api.getOrderPlacedEvents(organizationId, filter);
        setLoadingOrdersPlaced(false);
        if (result.resultType === "Ok") setOrderPlacedEvents(result.data);
        else setError(result.errors?.[0]);
    };
    const getOrgLevelConversationalSuccess = async (organizationId, filter)=>{
        setLoadingConversationalSuccess(true);
        const result = await _api.getConversationalSuccessEvents(organizationId, filter);
        setLoadingConversationalSuccess(false);
        if (result.resultType === "Ok") {
            setConversationalSuccessEvents(result.data);
            setReloadBool(true);
        } else setError(result.errors?.[0]);
    };
    const getOrgLevelItemAddedToOrder = async (organizationId, filter)=>{
        setLoadingItemAddedToOrder(true);
        const result = await _api.getItemAddedToOrderEvents(organizationId, filter);
        setLoadingItemAddedToOrder(false);
        if (result.resultType === "Ok") setItemAddedToOrderEvents(result.data);
        else setError(result.errors?.[0]);
    };
    const getOrgLevelCallCompleteEvents = async (organizationId, filter)=>{
        const result = await _api.getOrgCallCompleteEvents(organizationId, filter);
        if (result.resultType === "Ok") setCallCompleteEvents(result.data);
        else setError(result.errors?.[0]);
    };
    const getOrgLevelOrderTotalStatistics = async (organizationId, filter)=>{
        setLoadingOrderTotalStatistics(true);
        const result = await _api.getOrderTotalStatistics(organizationId, filter);
        setLoadingOrderTotalStatistics(false);
        if (result.resultType === "Ok") setOrderTotalStatistics(result.data);
        else setError(result.errors?.[0]);
    };
    const getTopLocationsWithNumberOfOrdersPlaced = async (organizationId, filter)=>{
        setLoadingTopLocationWithHighestNumberOfOrders(true);
        const result = await _api.getTopLocationsWithNumberOfOrdersPlaced(organizationId, filter);
        setLoadingTopLocationWithHighestNumberOfOrders(false);
        if (result.resultType === "Ok") setTopLocationsWithHighestNumberOfOrders(result.data);
        else setError(result.errors?.[0]);
    };
    const getUniqueSessionIds = (events)=>{
        if (!events) return [];
        events = events.filter((x)=>x?.sessionId?.length);
        const grouped = events.reduce((acc, item)=>{
            if (!acc[item.sessionId]) acc[item.sessionId] = [];
            acc[item.sessionId].push(item);
            return acc;
        }, {});
        return Object.keys(grouped);
    };
    // Maximum number of sessions to cache to prevent memory issues
    const MAX_EVENTS_CACHE_SIZE = 50;
    const loadAllEventsForSession = async (sessionId, applicationId)=>{
        if (sessionId in allEventsCache) return allEventsCache[sessionId];
        else {
            setLoadingSessionId(sessionId);
            const allEvents = await _api.getAllEventsForSession(applicationId, sessionId);
            if (allEvents.resultType === "Ok") {
                allEvents.data.forEach((e)=>{
                    if (e.eventDate) e.timestamp = new Date(e.eventDate).getTime();
                });
                // sort by timestamp
                allEvents.data.sort((a, b)=>a.timestamp - b.timestamp);
                const newEventsCache = {
                    ...allEventsCache
                };
                // Limit cache size to prevent memory issues - remove oldest entries if at limit
                const cacheKeys = Object.keys(newEventsCache);
                if (cacheKeys.length >= MAX_EVENTS_CACHE_SIZE) // Remove the first (oldest) entry
                delete newEventsCache[cacheKeys[0]];
                newEventsCache[sessionId] = allEvents.data;
                setAllEventsCache(newEventsCache);
            }
            setLoadingSessionId("");
            return allEvents;
        }
    };
    // Clear the events cache to free memory
    const clearEventsCache = ()=>{
        setAllEventsCache({});
    };
    const getTransferredEvents = async (organizationId, filter)=>{
        setLoadingCallTransferredEvents(true);
        const result = await _api.getCallTransferredEvents(organizationId, filter);
        setLoadingCallTransferredEvents(false);
        if (result.resultType === "Ok") setCallTransferredEvents(result.data);
        else setError(result.errors?.[0]);
    };
    const getImmediateCallTransferredEvents = async (organizationId, filter)=>{
        setLoadingImmediateCallTransferredEvents(true);
        const result = await _api.getImmedirateCallTransferredEvents(organizationId, filter);
        setLoadingImmediateCallTransferredEvents(false);
        if (result.resultType === "Ok") setImmediateCallTransferredEvents(result.data);
        else setError(result.errors?.[0]);
    };
    const getSessionsOfAllApplications = async (organizationId, filter)=>{
        setLoadingSessionsOfAllApplications(true);
        setSessions([]);
        let skip = -1;
        let take = -1;
        let result = await _api.getSessionsByOrganizationId(organizationId, filter, skip, take);
        let tempSessions = [];
        tempSessions = [
            ...tempSessions,
            ...result.data
        ];
        // while (result.resultType === "Ok" && result.data.length === take) {
        //     skip += take;
        //     result = await voicifyApi.getSessionsByOrganizationId(organizationId, filter, skip, take)
        //     tempSessions = [...tempSessions, ...result.data]
        // }
        if (result.resultType !== "Ok") {
            setError(result.errors[0]);
            setLoadingSessionsOfAllApplications(false);
            return;
        }
        setSessions(tempSessions);
        setLoadingSessionsOfAllApplications(false);
    };
    const loadOrgAnalytics = async (organizationId, filter)=>{
        setLoadingOrgAnalytics(true);
        setCallStatistics(null);
        setTopIntents(null);
        setOrdersPlacedCount(0);
        setConversationalSuccessRate(null);
        setOrderTotalStatistics(null);
        setTopLocationsWithHighestNumberOfOrders(null);
        setCallTransferredEvents(null);
        setImmediateCallTransferredEvents(null);
        setItemAddedConversationalSuccessEvents(null);
        setSessionIdCount(0);
        try {
            const orgAnalyticsTasks = [
                getSessionsOfAllApplications(organizationId, filter),
                getOrgLevelCallStatistics(organizationId, filter),
                getOrgLevelTopIntents(organizationId, filter),
                getOrgLevelOrdersPlaced(organizationId, filter),
                getOrgLevelItemAddedToOrder(organizationId, filter),
                getOrgLevelCallCompleteEvents(organizationId, filter),
                getOrgLevelConversationalSuccess(organizationId, filter),
                getOrgLevelOrderTotalStatistics(organizationId, filter),
                getTopLocationsWithNumberOfOrdersPlaced(organizationId, {
                    ...filter,
                    count: NUMBER_OF_TOP_LOCATIONS_WITH_HIGHEST_ORDERS
                }),
                getTransferredEvents(organizationId, filter),
                getImmediateCallTransferredEvents(organizationId, filter),
                getOrgItemAddedConversationalSuccessEvents(organizationId, filter)
            ];
            await Promise.all(orgAnalyticsTasks);
        } catch (error) {
            setError(error);
        } finally{
            setLoadingOrgAnalytics(false);
        }
    };
    const loadOrgApplicationsPerformanceAnalytics = async (organizationId, filter)=>{
        setLoadOrgApplicationsPerformanceAnalytics(true);
        const tasks = [];
        tasks.push(_api.getOrderCompletionBreakDownPerApp(organizationId, filter));
        tasks.push(_api.getConversationalSuccessBreakdownPerApp(organizationId, filter));
        tasks.push(_api.getCallTransferredBreakdownPerApp(organizationId, filter));
        tasks.push(_api.getCallImmediateTransferredBreakdownPerApp(organizationId, filter));
        tasks.push(_api.getAverageOrderTotalBreakdownPerApp(organizationId, filter));
        tasks.push(_api.searchForApplications(organizationId, 0, 50, "NameAscending", ""));
        const results = await Promise.all(tasks);
        const errorResults = results.filter((x)=>x.resultType !== "Ok");
        if (errorResults.length) {
            setError(errorResults[0]);
            return;
        }
        const orderCompletion = results[0].data;
        const conversationalSuccess = results[1].data;
        const callTransferred = results[2].data;
        const callImmediateTransferred = results[3].data;
        const averageOrderTotal = results[4].data;
        const availableApplications = results[5].data;
        const dataMap = new Map();
        // Function to update or add data by applicationId
        const addDataToMap = (array, key, fieldName)=>{
            availableApplications.applications.forEach((app)=>{
                const appId = app.id; // Use app.id from allApps as the key
                if (!dataMap.has(appId)) // If the app is not found in dataMap, add it with default values
                dataMap.set(appId, {
                    applicationId: appId,
                    name: app.name,
                    orderCompletionRate: 0,
                    conversationalSuccessRate: 0,
                    callTransferredRate: 0,
                    callImmediateTransferredRate: 0,
                    averageOrderTotal: 0
                });
            });
            if (array) array.forEach((item)=>{
                const appId = item.applicationId;
                if (!dataMap.has(appId)) dataMap.set(appId, {
                    applicationId: appId
                });
                dataMap.get(appId)[fieldName] = item[key] || "0";
            });
        };
        addDataToMap(orderCompletion.applications, "orderCompletionRate", "orderCompletionRate");
        addDataToMap(conversationalSuccess.applications, "conversationalSuccessRate", "conversationalSuccessRate");
        addDataToMap(callTransferred.applications, "callTransferredRate", "callTransferredRate");
        addDataToMap(callImmediateTransferred.applications, "callImmediateTransferredRate", "callImmediateTransferredRate");
        addDataToMap(averageOrderTotal.applications, "averageOrderTotal", "averageOrderTotal");
        // Convert the map back to an array
        const data = Array.from(dataMap.values());
        setOrgApplicationsPerformanceAnalytics(data);
        setLoadOrgApplicationsPerformanceAnalytics(false);
    };
    // #region Engagement Analytics Functions
    // Helper to flatten grouped engagements (API returns {applicationId: OrganizationEngagement[]})
    const flattenGroupedEngagements = (grouped)=>{
        if (!grouped || typeof grouped !== "object") {
            console.warn("[flattenGroupedEngagements] Received invalid data:", grouped);
            return [];
        }
        return Object.values(grouped).flat();
    };
    // Default page size for engagement pagination - balance between fewer requests and memory usage
    // Increased to 500 for better performance with large datasets (fewer API roundtrips)
    const ENGAGEMENT_PAGE_SIZE = 5000;
    // Maximum engagements cap to prevent unbounded in-memory accumulation
    // Configurable via REACT_APP_MAX_ENGAGEMENTS_CAP env variable or as a parameter to loader functions
    // Default: 200,000 engagements
    const DEFAULT_MAX_ENGAGEMENTS_CAP = 200000;
    const MAX_ENGAGEMENTS_CAP = parseInt("", 10) || DEFAULT_MAX_ENGAGEMENTS_CAP;
    // Organization Engagements - with pagination support for large datasets
    // Pattern based on SessionAnalyticsContainer.loadSessionsForOrgs
    // @param maxEngagementsCap - Optional cap to limit in-memory accumulation (defaults to MAX_ENGAGEMENTS_CAP)
    const loadOrganizationEngagements = async (organizationId, filter, maxEngagementsCap = MAX_ENGAGEMENTS_CAP)=>{
        setLoadingOrganizationEngagements(true);
        setError("");
        // Clear previous data to free memory before loading new data
        setOrganizationEngagements([]);
        setScheduledEngagements([]);
        setRescheduledEngagements([]);
        setCancelledEngagements([]);
        setCheckNextAppointmentEngagements([]);
        let allEngagements = [];
        let skip = 0;
        const pageSize = filter.take ?? ENGAGEMENT_PAGE_SIZE;
        let hasMoreData = true;
        let reachedCap = false;
        try {
            while(hasMoreData){
                // Check if we've reached the cap before fetching more data
                if (allEngagements.length >= maxEngagementsCap) {
                    console.warn(`[loadOrganizationEngagements] Reached maximum engagements cap (${maxEngagementsCap}). ` + `Returning partial results with ${allEngagements.length} engagements. ` + `Consider narrowing the date range or increasing REACT_APP_MAX_ENGAGEMENTS_CAP.`);
                    reachedCap = true;
                    hasMoreData = false;
                    break;
                }
                const paginatedFilter = {
                    ...filter,
                    startDate: (0, _momentDefault.default)(filter.startDate).startOf("day").format("YYYY-MM-DDTHH:mm:ss.SSSZ"),
                    endDate: (0, _momentDefault.default)(filter.endDate).endOf("day").format("YYYY-MM-DDTHH:mm:ss.SSSZ"),
                    timezone: undefined,
                    skip,
                    take: pageSize
                };
                const result = await _api.getOrganizationEngagements(organizationId, paginatedFilter);
                if (result.resultType === "Ok") {
                    const pageEngagements = result.data;
                    allEngagements = [
                        ...allEngagements,
                        ...pageEngagements
                    ];
                    // Check if adding this page exceeded the cap
                    if (allEngagements.length >= maxEngagementsCap) {
                        console.warn(`[loadOrganizationEngagements] Reached maximum engagements cap (${maxEngagementsCap}). ` + `Returning partial results with ${allEngagements.length} engagements. ` + `Consider narrowing the date range or increasing REACT_APP_MAX_ENGAGEMENTS_CAP.`);
                        reachedCap = true;
                        hasMoreData = false;
                    } else if (pageEngagements.length < pageSize || pageEngagements.length === 0) // If we received fewer records than requested or none, we've reached the end
                    hasMoreData = false;
                    else skip += pageSize;
                } else {
                    setError(result.errors?.[0] || "Failed to load engagements");
                    hasMoreData = false;
                }
            }
            setOrganizationEngagements(allEngagements);
            // Return info about whether cap was reached (useful for callers)
            return {
                engagements: allEngagements,
                reachedCap,
                cap: maxEngagementsCap
            };
        } catch (error) {
            console.error("[loadOrganizationEngagements] Error:", error);
            setError(error?.message || "Unknown error loading engagements");
            return {
                engagements: allEngagements,
                reachedCap: false,
                cap: maxEngagementsCap
            };
        } finally{
            setLoadingOrganizationEngagements(false);
        }
    };
    const loadEngagementsForTagCombo = async (organizationId, filter, category, validTags = [], excludedTags = [])=>{
        setLoadingEngagementsForTagCombo(true);
        const result = await _api.getEngagementsForTagCombo(organizationId, filter, category, validTags, excludedTags);
        setLoadingEngagementsForTagCombo(false);
        if (result.resultType === "Ok") setEngagementsForTagCombo(flattenGroupedEngagements(result.data));
        else setError(result.errors?.[0]);
    };
    // Off Hours Engagements
    const loadOffHoursEngagements = async (organizationId, filter)=>{
        setLoadingOffHoursEngagements(true);
        const result = await _api.getEngagementsForTagCombo(organizationId, filter, "", [
            "CALL_DURING_OFF_HOURS"
        ], []);
        setLoadingOffHoursEngagements(false);
        if (result.resultType === "Ok") setOffHoursEngagements(flattenGroupedEngagements(result.data));
        else setError(result.errors?.[0]);
    };
    // Spanish Off Hours Engagements (for language breakdown using CALL_DURING_OFF_HOURS + SPANISH tags)
    const loadSpanishOffHoursEngagements = async (organizationId, filter)=>{
        setLoadingSpanishOffHoursEngagements(true);
        try {
            const result = await _api.getEngagementsForTagCombo(organizationId, filter, "", [
                "CALL_DURING_OFF_HOURS",
                "SPANISH"
            ], []);
            if (result.resultType === "Ok") setSpanishOffHoursEngagements(flattenGroupedEngagements(result.data));
            else setError(result.errors?.[0]);
        } catch (error) {
            setError(error instanceof Error ? error.message : "Failed to load Spanish off-hours engagements");
        } finally{
            setLoadingSpanishOffHoursEngagements(false);
        }
    };
    // Transferred Engagements (for Spanish-level transfer data via cross-referencing)
    const loadTransferredEngagements = async (organizationId, filter)=>{
        setLoadingTransferredEngagements(true);
        const result = await _api.getEngagementsForTagCombo(organizationId, filter, "", [
            "TRANSFERRED"
        ], []);
        setLoadingTransferredEngagements(false);
        if (result.resultType === "Ok") setTransferredEngagements(flattenGroupedEngagements(result.data));
        else setError(result.errors?.[0]);
    };
    // Top Level Metrics
    const loadTopLevelMetrics = async (applicationId, filter)=>{
        setLoadingTopLevelMetrics(true);
        const result = await _api.getTopLevelMetrics(applicationId, filter);
        setLoadingTopLevelMetrics(false);
        if (result.resultType === "Ok") setTopLevelMetrics(result.data);
        else setError(result.errors?.[0]);
    };
    const loadOrganizationTopLevelMetrics = async (organizationId, filter)=>{
        setLoadingOrganizationTopLevelMetrics(true);
        const result = await _api.getOrganizationTopLevelMetrics(organizationId, filter);
        setLoadingOrganizationTopLevelMetrics(false);
        if (result.resultType === "Ok") {
            // API returns Record<applicationId, TopLevelMetrics> - store raw per-app data
            const appMetricsMap = result.data;
            setOrganizationTopLevelMetricsPerApp(appMetricsMap);
            // Also aggregate across all apps for backward compatibility
            const aggregatedMetrics = {
                laborMinutesSaved: 0,
                laborHoursSaved: 0,
                totalCalls: 0,
                containedCalls: 0,
                containableCalls: 0,
                offHoursCalls: 0,
                offHoursScheduledAppts: 0,
                newPatientBookings: 0,
                existingPatientBookings: 0,
                totalBookings: 0,
                orderAttempts: 0,
                ordersPlaced: 0,
                upsellAttempts: 0,
                upsellSuccesses: 0,
                questionsAnswered: 0,
                averageOrderTotal: 0,
                laborHoursSavedApps: [],
                offHoursApps: [],
                offHoursScheduledApptsApps: [],
                newPatientBookingsApps: [],
                ticketApps: [],
                upsellApps: [],
                questionsApps: []
            };
            // Track weighted average for averageOrderTotal
            let totalOrdersForAverage = 0;
            let weightedOrderTotalSum = 0;
            for (const [appId, metrics] of Object.entries(appMetricsMap))if (metrics) {
                aggregatedMetrics.laborMinutesSaved += metrics.laborMinutesSaved ?? 0;
                aggregatedMetrics.totalCalls += metrics.totalEngagementCount ?? metrics.totalCalls ?? 0;
                // Contained calls: use generic containedCalls if present, otherwise scheduling-specific fields,
                // and booking fields only as a final fallback (not added on top)
                const schedulingContainedCalls = (metrics.totalContainedCountEnglish ?? 0) + (metrics.totalContainedCountSpanish ?? 0);
                const bookingContainedFallback = (metrics.totalBookings ?? 0) || (metrics.existingPatientBookings ?? 0);
                if (metrics.containedCalls != null && metrics.containedCalls > 0) aggregatedMetrics.containedCalls += metrics.containedCalls;
                else if (schedulingContainedCalls > 0) aggregatedMetrics.containedCalls += schedulingContainedCalls;
                else aggregatedMetrics.containedCalls += bookingContainedFallback;
                // Containable calls: use generic containableCalls if present, otherwise scheduling attempt fields,
                // and booking fields only as a final fallback (not added on top)
                const schedulingContainableCalls = (metrics.totalScheduleAttemptsEnglish ?? 0) + (metrics.totalScheduleAttemptsSpanish ?? 0) + (metrics.totalRescheduleAttemptsEnglish ?? 0) + (metrics.totalRescheduleAttemptsSpanish ?? 0) + (metrics.totalCancellationAttemptsEnglish ?? 0) + (metrics.totalCancellationAttemptsSpanish ?? 0) + (metrics.totalCheckNextAppointmentAttemptsEnglish ?? 0) + (metrics.totalCheckNextAppointmentAttemptsSpanish ?? 0);
                const bookingContainableFallback = (metrics.totalBookings ?? 0) || (metrics.existingPatientBookings ?? 0);
                if (metrics.containableCalls != null && metrics.containableCalls > 0) aggregatedMetrics.containableCalls += metrics.containableCalls;
                else if (schedulingContainableCalls > 0) aggregatedMetrics.containableCalls += schedulingContainableCalls;
                else aggregatedMetrics.containableCalls += bookingContainableFallback;
                aggregatedMetrics.offHoursCalls += metrics.offHoursCalls ?? 0;
                aggregatedMetrics.offHoursScheduledAppts += metrics.offHoursScheduledAppts ?? 0;
                aggregatedMetrics.newPatientBookings += (metrics.newPatientBookedEnglish ?? 0) + (metrics.newPatientBookedSpanish ?? 0);
                aggregatedMetrics.orderAttempts += metrics.totalOrderAttempts ?? metrics.orderAttempts ?? 0;
                aggregatedMetrics.ordersPlaced += metrics.totalOrdersCompleted ?? metrics.ordersPlaced ?? 0;
                aggregatedMetrics.upsellAttempts += metrics.totalUpsellAttempts ?? metrics.upsellAttempts ?? 0;
                aggregatedMetrics.upsellSuccesses += metrics.totalUpsellsCompleted ?? metrics.upsellSuccesses ?? 0;
                aggregatedMetrics.questionsAnswered += metrics.totalQuestionsAnswered ?? metrics.questionsAnswered ?? 0;
                // Aggregate averageOrderTotal as weighted average
                // Handle various field names from API: averageTicketSize (actual API field), averageOrderTotal, etc.
                const appOrderTotal = metrics.averageTicketSize ?? metrics.averageOrderTotal ?? metrics.AverageOrderTotal ?? metrics.totalAverageOrderValue ?? metrics.TotalAverageOrderValue ?? 0;
                const appOrderCount = metrics.totalOrdersCompleted ?? metrics.TotalOrdersCompleted ?? metrics.ordersPlaced ?? metrics.OrdersPlaced ?? 0;
                if (appOrderTotal > 0) {
                    if (appOrderCount > 0) {
                        weightedOrderTotalSum += appOrderTotal * appOrderCount;
                        totalOrdersForAverage += appOrderCount;
                    } else {
                        // If we have an average but no order count, just use the average directly
                        // This handles cases where only averageOrderTotal is provided
                        weightedOrderTotalSum += appOrderTotal;
                        totalOrdersForAverage += 1;
                    }
                }
                // Add app breakdown for laborHoursSaved
                const laborMinutesEnglish = metrics.laborMinutesSavedEnglish ?? 0;
                const laborMinutesSpanish = metrics.laborMinutesSavedSpanish ?? 0;
                const laborMinutes = laborMinutesEnglish + laborMinutesSpanish || (metrics.laborMinutesSaved ?? 0);
                if (laborMinutes > 0) aggregatedMetrics.laborHoursSavedApps.push({
                    applicationId: appId,
                    applicationName: appId,
                    // Will be resolved by transformer using appNameMap
                    count: laborMinutes / 60,
                    // Convert to hours
                    english: laborMinutesEnglish / 60,
                    spanish: laborMinutesSpanish / 60
                });
                // Add app breakdown for newPatientBookings
                const englishCount = metrics.newPatientBookedEnglish ?? 0;
                const spanishCount = metrics.newPatientBookedSpanish ?? 0;
                const totalCount = englishCount + spanishCount;
                if (totalCount > 0) aggregatedMetrics.newPatientBookingsApps.push({
                    applicationId: appId,
                    applicationName: appId,
                    // Will be resolved by transformer
                    count: totalCount,
                    english: englishCount,
                    spanish: spanishCount
                });
                // Add app breakdown for ticketApps (average order total per app)
                // Handle various field names from API: averageTicketSize (actual API field), averageOrderTotal, etc.
                const ticketAppOrderTotal = metrics.averageTicketSize ?? metrics.averageOrderTotal ?? metrics.AverageOrderTotal ?? metrics.totalAverageOrderValue ?? metrics.TotalAverageOrderValue ?? 0;
                if (ticketAppOrderTotal > 0) aggregatedMetrics.ticketApps.push({
                    applicationId: appId,
                    applicationName: appId,
                    // Will be resolved by transformer using appNameMap
                    count: ticketAppOrderTotal
                });
                // Add app breakdown for upsellApps (successful upsells per app)
                const upsellSuccessCount = metrics.totalUpsellsCompleted ?? metrics.upsellSuccesses ?? 0;
                if (upsellSuccessCount > 0) aggregatedMetrics.upsellApps.push({
                    applicationId: appId,
                    applicationName: appId,
                    // Will be resolved by transformer using appNameMap
                    count: upsellSuccessCount
                });
                // Add app breakdown for questionsApps (questions answered per app)
                const questionsCount = metrics.totalQuestionsAnswered ?? metrics.questionsAnswered ?? 0;
                if (questionsCount > 0) aggregatedMetrics.questionsApps.push({
                    applicationId: appId,
                    applicationName: appId,
                    // Will be resolved by transformer using appNameMap
                    count: questionsCount
                });
            }
            // Convert laborMinutesSaved to laborHoursSaved
            aggregatedMetrics.laborHoursSaved = aggregatedMetrics.laborMinutesSaved / 60;
            // Calculate weighted average for averageOrderTotal
            aggregatedMetrics.averageOrderTotal = totalOrdersForAverage > 0 ? weightedOrderTotalSum / totalOrdersForAverage : 0;
            setOrganizationTopLevelMetrics(aggregatedMetrics);
        } else setError(result.errors?.[0]);
    };
    // Average Call Volume Histograms
    const loadAverageCallVolumeHistogram = async (applicationId, filter)=>{
        setLoadingAverageCallVolumeHistogram(true);
        const result = await _api.getAverageCallVolumeHistogram(applicationId, filter);
        setLoadingAverageCallVolumeHistogram(false);
        if (result.resultType === "Ok") setAverageCallVolumeHistogram(result.data);
        else setError(result.errors?.[0]);
    };
    const loadOrganizationAverageCallVolumeHistogram = async (organizationId, filter)=>{
        setLoadingOrganizationAverageCallVolumeHistogram(true);
        const result = await _api.getOrganizationAverageCallVolumeHistogram(organizationId, filter);
        setLoadingOrganizationAverageCallVolumeHistogram(false);
        if (result.resultType === "Ok") {
            setOrganizationAverageCallVolumeHistogramPerApp(result.data);
            setOrganizationAverageCallVolumeHistogram((0, _engagementAnalyticsTransformers.flattenGroupedHistogramData)(result.data));
        } else setError(result.errors?.[0]);
    };
    const loadOrganizationAverageCallVolumeByHourHistogram = async (organizationId, filter)=>{
        setLoadingOrganizationAverageCallVolumeByHourHistogram(true);
        const result = await _api.getOrganizationAverageCallVolumeHistogram(organizationId, filter);
        setLoadingOrganizationAverageCallVolumeByHourHistogram(false);
        if (result.resultType === "Ok") {
            setOrganizationAverageCallVolumeByHourHistogramPerApp(result.data);
            setOrganizationAverageCallVolumeByHourHistogram((0, _engagementAnalyticsTransformers.flattenGroupedHistogramData)(result.data));
        } else setError(result.errors?.[0]);
    };
    const loadAverageContainableCallVolumeHistogram = async (applicationId, filter)=>{
        setLoadingAverageContainableCallVolumeHistogram(true);
        const result = await _api.getAverageContainableCallVolumeHistogram(applicationId, filter);
        setLoadingAverageContainableCallVolumeHistogram(false);
        if (result.resultType === "Ok") setAverageContainableCallVolumeHistogram(result.data);
        else setError(result.errors?.[0]);
    };
    const loadOrganizationAverageContainableCallVolumeHistogram = async (organizationId, filter)=>{
        setLoadingOrganizationAverageContainableCallVolumeHistogram(true);
        const result = await _api.getOrganizationAverageContainableCallVolumeHistogram(organizationId, filter);
        setLoadingOrganizationAverageContainableCallVolumeHistogram(false);
        if (result.resultType === "Ok") setOrganizationAverageContainableCallVolumeHistogram((0, _engagementAnalyticsTransformers.flattenGroupedHistogramData)(result.data));
        else setError(result.errors?.[0]);
    };
    const loadAverageContainedCallVolumeHistogram = async (applicationId, filter)=>{
        setLoadingAverageContainedCallVolumeHistogram(true);
        const result = await _api.getAverageContainedCallVolumeHistogram(applicationId, filter);
        setLoadingAverageContainedCallVolumeHistogram(false);
        if (result.resultType === "Ok") setAverageContainedCallVolumeHistogram(result.data);
        else setError(result.errors?.[0]);
    };
    const loadOrganizationAverageContainedCallVolumeHistogram = async (organizationId, filter)=>{
        setLoadingOrganizationAverageContainedCallVolumeHistogram(true);
        const result = await _api.getOrganizationAverageContainedCallVolumeHistogram(organizationId, filter);
        setLoadingOrganizationAverageContainedCallVolumeHistogram(false);
        if (result.resultType === "Ok") setOrganizationAverageContainedCallVolumeHistogram((0, _engagementAnalyticsTransformers.flattenGroupedHistogramData)(result.data));
        else setError(result.errors?.[0]);
    };
    // Call Volume Histograms
    const loadCallVolumeHistogram = async (applicationId, filter)=>{
        setLoadingCallVolumeHistogram(true);
        const result = await _api.getCallVolumeHistogram(applicationId, filter);
        setLoadingCallVolumeHistogram(false);
        if (result.resultType === "Ok") setCallVolumeHistogram(result.data);
        else setError(result.errors?.[0]);
    };
    const loadOrganizationCallVolumeHistogram = async (organizationId, filter)=>{
        setLoadingOrganizationCallVolumeHistogram(true);
        const result = await _api.getOrganizationCallVolumeHistogram(organizationId, filter);
        setLoadingOrganizationCallVolumeHistogram(false);
        if (result.resultType === "Ok") {
            // Store raw per-app data for filtering
            setOrganizationCallVolumeHistogramPerApp(result.data);
            // Also flatten for backward compatibility
            setOrganizationCallVolumeHistogram((0, _engagementAnalyticsTransformers.flattenGroupedHistogramData)(result.data));
        } else setError(result.errors?.[0]);
    };
    const loadContainableCallVolumeHistogram = async (applicationId, filter)=>{
        setLoadingContainableCallVolumeHistogram(true);
        const result = await _api.getContainableCallVolumeHistogram(applicationId, filter);
        setLoadingContainableCallVolumeHistogram(false);
        if (result.resultType === "Ok") setContainableCallVolumeHistogram(result.data);
        else setError(result.errors?.[0]);
    };
    const loadOrganizationContainableCallVolumeHistogram = async (organizationId, filter)=>{
        setLoadingOrganizationContainableCallVolumeHistogram(true);
        const result = await _api.getOrganizationContainableCallVolumeHistogram(organizationId, filter);
        setLoadingOrganizationContainableCallVolumeHistogram(false);
        if (result.resultType === "Ok") {
            setOrganizationContainableCallVolumeHistogramPerApp(result.data);
            setOrganizationContainableCallVolumeHistogram((0, _engagementAnalyticsTransformers.flattenGroupedHistogramData)(result.data));
        } else setError(result.errors?.[0]);
    };
    const loadContainedCallVolumeHistogram = async (applicationId, filter)=>{
        setLoadingContainedCallVolumeHistogram(true);
        const result = await _api.getContainedCallVolumeHistogram(applicationId, filter);
        setLoadingContainedCallVolumeHistogram(false);
        if (result.resultType === "Ok") setContainedCallVolumeHistogram(result.data);
        else setError(result.errors?.[0]);
    };
    const loadOrganizationContainedCallVolumeHistogram = async (organizationId, filter)=>{
        setLoadingOrganizationContainedCallVolumeHistogram(true);
        const result = await _api.getOrganizationContainedCallVolumeHistogram(organizationId, filter);
        setLoadingOrganizationContainedCallVolumeHistogram(false);
        if (result.resultType === "Ok") {
            setOrganizationContainedCallVolumeHistogramPerApp(result.data);
            setOrganizationContainedCallVolumeHistogram((0, _engagementAnalyticsTransformers.flattenGroupedHistogramData)(result.data));
        } else setError(result.errors?.[0]);
    };
    // Spanish Call Volume Histograms
    const loadSpanishCallVolumeHistogram = async (applicationId, filter)=>{
        setLoadingSpanishCallVolumeHistogram(true);
        const result = await _api.getSpanishCallVolumeHistogram(applicationId, filter);
        setLoadingSpanishCallVolumeHistogram(false);
        if (result.resultType === "Ok") setSpanishCallVolumeHistogram(result.data);
        else setError(result.errors?.[0]);
    };
    const loadOrganizationSpanishCallVolumeHistogram = async (organizationId, filter)=>{
        setLoadingOrganizationSpanishCallVolumeHistogram(true);
        const result = await _api.getOrganizationSpanishCallVolumeHistogram(organizationId, filter);
        setLoadingOrganizationSpanishCallVolumeHistogram(false);
        if (result.resultType === "Ok") {
            setOrganizationSpanishCallVolumeHistogramPerApp(result.data);
            setOrganizationSpanishCallVolumeHistogram((0, _engagementAnalyticsTransformers.flattenGroupedHistogramData)(result.data));
        } else setError(result.errors?.[0]);
    };
    const loadSpanishContainableCallVolumeHistogram = async (applicationId, filter)=>{
        setLoadingSpanishContainableCallVolumeHistogram(true);
        const result = await _api.getSpanishContainableCallVolumeHistogram(applicationId, filter);
        setLoadingSpanishContainableCallVolumeHistogram(false);
        if (result.resultType === "Ok") setSpanishContainableCallVolumeHistogram(result.data);
        else setError(result.errors?.[0]);
    };
    const loadOrganizationSpanishContainableCallVolumeHistogram = async (organizationId, filter)=>{
        setLoadingOrganizationSpanishContainableCallVolumeHistogram(true);
        const result = await _api.getOrganizationSpanishContainableCallVolumeHistogram(organizationId, filter);
        setLoadingOrganizationSpanishContainableCallVolumeHistogram(false);
        if (result.resultType === "Ok") {
            setOrganizationSpanishContainableCallVolumeHistogramPerApp(result.data);
            setOrganizationSpanishContainableCallVolumeHistogram((0, _engagementAnalyticsTransformers.flattenGroupedHistogramData)(result.data));
        } else setError(result.errors?.[0]);
    };
    const loadSpanishContainedCallVolumeHistogram = async (applicationId, filter)=>{
        setLoadingSpanishContainedCallVolumeHistogram(true);
        const result = await _api.getSpanishContainedCallVolumeHistogram(applicationId, filter);
        setLoadingSpanishContainedCallVolumeHistogram(false);
        if (result.resultType === "Ok") setSpanishContainedCallVolumeHistogram(result.data);
        else setError(result.errors?.[0]);
    };
    const loadOrganizationSpanishContainedCallVolumeHistogram = async (organizationId, filter)=>{
        setLoadingOrganizationSpanishContainedCallVolumeHistogram(true);
        const result = await _api.getOrganizationSpanishContainedCallVolumeHistogram(organizationId, filter);
        setLoadingOrganizationSpanishContainedCallVolumeHistogram(false);
        if (result.resultType === "Ok") {
            setOrganizationSpanishContainedCallVolumeHistogramPerApp(result.data);
            setOrganizationSpanishContainedCallVolumeHistogram((0, _engagementAnalyticsTransformers.flattenGroupedHistogramData)(result.data));
        } else setError(result.errors?.[0]);
    };
    // Concurrent Call Volume Histograms
    const loadConcurrentCallVolumeHistogram = async (applicationId, filter)=>{
        setLoadingConcurrentCallVolumeHistogram(true);
        const result = await _api.getConcurrentCallVolumeHistogram(applicationId, filter);
        setLoadingConcurrentCallVolumeHistogram(false);
        if (result.resultType === "Ok") setConcurrentCallVolumeHistogram(result.data);
        else setError(result.errors?.[0]);
    };
    const loadOrganizationConcurrentCallVolumeHistogram = async (organizationId, filter)=>{
        setLoadingOrganizationConcurrentCallVolumeHistogram(true);
        const result = await _api.getOrganizationConcurrentCallVolumeHistogram(organizationId, filter);
        setLoadingOrganizationConcurrentCallVolumeHistogram(false);
        if (result.resultType === "Ok") {
            setOrganizationConcurrentCallVolumeHistogramPerApp(result.data);
            // Use max-based aggregation for concurrent calls to avoid inflated values
            setOrganizationConcurrentCallVolumeHistogram((0, _engagementAnalyticsTransformers.flattenConcurrentCallHistogramDataFiltered)(result.data));
        } else setError(result.errors?.[0]);
    };
    // #endregion
    // #region Order Volume Histograms
    const loadOrderAttemptedVolumeHistogram = async (applicationId, filter)=>{
        setLoadingOrderAttemptedVolumeHistogram(true);
        const result = await _api.getOrderAttemptedVolume(applicationId, filter);
        setLoadingOrderAttemptedVolumeHistogram(false);
        if (result.resultType === "Ok") setOrderAttemptedVolumeHistogram(result.data);
        else setError(result.errors?.[0]);
    };
    const loadOrganizationOrderAttemptedVolumeHistogram = async (organizationId, filter)=>{
        setLoadingOrganizationOrderAttemptedVolumeHistogram(true);
        const result = await _api.getOrganizationOrderAttemptedVolume(organizationId, filter);
        setLoadingOrganizationOrderAttemptedVolumeHistogram(false);
        if (result.resultType === "Ok") {
            setOrganizationOrderAttemptedVolumeHistogramPerApp(result.data);
            setOrganizationOrderAttemptedVolumeHistogram((0, _engagementAnalyticsTransformers.flattenGroupedHistogramData)(result.data));
        } else setError(result.errors?.[0]);
    };
    const loadOrderPlacedVolumeHistogram = async (applicationId, filter)=>{
        setLoadingOrderPlacedVolumeHistogram(true);
        const result = await _api.getOrderPlacedVolume(applicationId, filter);
        setLoadingOrderPlacedVolumeHistogram(false);
        if (result.resultType === "Ok") setOrderPlacedVolumeHistogram(result.data);
        else setError(result.errors?.[0]);
    };
    const loadOrganizationOrderPlacedVolumeHistogram = async (organizationId, filter)=>{
        setLoadingOrganizationOrderPlacedVolumeHistogram(true);
        const result = await _api.getOrganizationOrderPlacedVolume(organizationId, filter);
        setLoadingOrganizationOrderPlacedVolumeHistogram(false);
        if (result.resultType === "Ok") {
            setOrganizationOrderPlacedVolumeHistogramPerApp(result.data);
            setOrganizationOrderPlacedVolumeHistogram((0, _engagementAnalyticsTransformers.flattenGroupedHistogramData)(result.data));
        } else setError(result.errors?.[0]);
    };
    // #endregion
    // #region Transfer Reasons
    const loadOrganizationTransferReasons = async (organizationId, filter)=>{
        setLoadingOrganizationTransferReasons(true);
        // Load both planned and unplanned transfer reasons in parallel
        const [plannedResult, unplannedResult] = await Promise.all([
            _api.getOrganizationLevelTransferReasons(organizationId, filter, true),
            _api.getOrganizationLevelTransferReasons(organizationId, filter, false)
        ]);
        setLoadingOrganizationTransferReasons(false);
        if (plannedResult.resultType === "Ok") setOrganizationPlannedTransferReasons(plannedResult.data);
        else setError(plannedResult.errors?.[0]);
        if (unplannedResult.resultType === "Ok") setOrganizationUnplannedTransferReasons(unplannedResult.data);
        else setError(unplannedResult.errors?.[0]);
        // Also set the combined organizationTransferReasons for backward compatibility
        // (merging both planned and unplanned into one response)
        if (plannedResult.resultType === "Ok" && unplannedResult.resultType === "Ok") {
            const combined = {};
            // Merge planned data
            Object.entries(plannedResult.data || {}).forEach(([appId, reasons])=>{
                if (!combined[appId]) combined[appId] = {};
                Object.entries(reasons).forEach(([reason, count])=>{
                    combined[appId][reason] = (combined[appId][reason] || 0) + count;
                });
            });
            // Merge unplanned data
            Object.entries(unplannedResult.data || {}).forEach(([appId, reasons])=>{
                if (!combined[appId]) combined[appId] = {};
                Object.entries(reasons).forEach(([reason, count])=>{
                    combined[appId][reason] = (combined[appId][reason] || 0) + count;
                });
            });
            setOrganizationTransferReasons(combined);
        }
    };
    const loadApplicationTransferReasons = async (applicationId, filter, getPlanned = false)=>{
        setLoadingApplicationTransferReasons(true);
        const result = await _api.getApplicationLevelTransferReasons(applicationId, filter, getPlanned);
        setLoadingApplicationTransferReasons(false);
        if (result.resultType === "Ok") setApplicationTransferReasons(result.data);
        else setError(result.errors?.[0]);
    };
    // #endregion
    // #region Appointments Managed Loaders (for Patient Bookings chart)
    // Note: Filters from organizationEngagements client-side by sessionTags
    // to avoid redundant API calls
    // Helper to filter engagements by sessionCategory and sessionTags
    const filterEngagementsByTags = (engagements, category, requiredTags)=>{
        return engagements.filter((e)=>{
            const matchesCategory = e.sessionCategory === category;
            const tags = e.sessionTags || [];
            const hasRequiredTags = requiredTags.every((tag)=>tags.includes(tag));
            return matchesCategory && hasRequiredTags;
        });
    };
    // These individual loaders now filter from organizationEngagements
    // They should only be called AFTER loadOrganizationEngagements has completed
    const filterScheduledEngagementsFromLoaded = ()=>{
        const filtered = filterEngagementsByTags(organizationEngagements, "ACTION_ATTEMPTED", [
            "ACTION_COMPLETED"
        ]);
        setScheduledEngagements(filtered);
    };
    const filterRescheduledEngagementsFromLoaded = ()=>{
        const filtered = filterEngagementsByTags(organizationEngagements, "ACTION_ATTEMPTED", [
            "APPOINTMENT_RESCHEDULED"
        ]);
        setRescheduledEngagements(filtered);
    };
    const filterCancelledEngagementsFromLoaded = ()=>{
        const filtered = filterEngagementsByTags(organizationEngagements, "ACTION_ATTEMPTED", [
            "APPOINTMENT_CANCELLED"
        ]);
        setCancelledEngagements(filtered);
    };
    const filterCheckNextAppointmentEngagementsFromLoaded = ()=>{
        const filtered = filterEngagementsByTags(organizationEngagements, "ACTION_ATTEMPTED", [
            "CHECK_NEXT_APPOINTMENT_COMPLETE"
        ]);
        setCheckNextAppointmentEngagements(filtered);
    };
    // Individual loaders using getEngagementsForTagCombo API for efficient tag-based queries
    const loadScheduledEngagements = async (organizationId, filter)=>{
        setLoadingScheduledEngagements(true);
        const result = await _api.getEngagementsForTagCombo(organizationId, filter, "", [
            "ACTION_COMPLETED"
        ], []);
        setLoadingScheduledEngagements(false);
        if (result.resultType === "Ok") setScheduledEngagements(flattenGroupedEngagements(result.data));
        else setError(result.errors?.[0]);
    };
    const loadRescheduledEngagements = async (organizationId, filter)=>{
        setLoadingRescheduledEngagements(true);
        const result = await _api.getEngagementsForTagCombo(organizationId, filter, "", [
            "APPOINTMENT_RESCHEDULED"
        ], []);
        setLoadingRescheduledEngagements(false);
        if (result.resultType === "Ok") setRescheduledEngagements(flattenGroupedEngagements(result.data));
        else setError(result.errors?.[0]);
    };
    const loadCancelledEngagements = async (organizationId, filter)=>{
        setLoadingCancelledEngagements(true);
        const result = await _api.getEngagementsForTagCombo(organizationId, filter, "", [
            "APPOINTMENT_CANCELLED"
        ], []);
        setLoadingCancelledEngagements(false);
        if (result.resultType === "Ok") setCancelledEngagements(flattenGroupedEngagements(result.data));
        else setError(result.errors?.[0]);
    };
    const loadCheckNextAppointmentEngagements = async (organizationId, filter)=>{
        setLoadingCheckNextAppointmentEngagements(true);
        const result = await _api.getEngagementsForTagCombo(organizationId, filter, "", [
            "CHECK_NEXT_APPOINTMENT_COMPLETE"
        ], []);
        setLoadingCheckNextAppointmentEngagements(false);
        if (result.resultType === "Ok") setCheckNextAppointmentEngagements(flattenGroupedEngagements(result.data));
        else setError(result.errors?.[0]);
    };
    // Load all scheduling events by fetching organizationEngagements once and filtering
    // This also populates organizationEngagements for other uses
    // Pattern based on SessionAnalyticsContainer.loadSessionsForOrgs
    // @param maxEngagementsCap - Optional cap to limit in-memory accumulation (defaults to MAX_ENGAGEMENTS_CAP)
    const loadAllSchedulingEngagements = async (organizationId, filter, maxEngagementsCap = MAX_ENGAGEMENTS_CAP)=>{
        setLoadingScheduledEngagements(true);
        setLoadingRescheduledEngagements(true);
        setLoadingCancelledEngagements(true);
        setLoadingCheckNextAppointmentEngagements(true);
        setLoadingOrganizationEngagements(true);
        setError("");
        // Clear previous data to free memory before loading new data
        setOrganizationEngagements([]);
        setScheduledEngagements([]);
        setRescheduledEngagements([]);
        setCancelledEngagements([]);
        setCheckNextAppointmentEngagements([]);
        let allEngagements = [];
        let skip = 0;
        const pageSize = filter.take ?? ENGAGEMENT_PAGE_SIZE;
        let hasMoreData = true;
        let reachedCap = false;
        try {
            if (!filter?.startDate || !filter?.endDate) {
                const message = "[loadAllSchedulingEngagements] Missing startDate or endDate in filter.";
                console.error(message, {
                    startDate: filter?.startDate,
                    endDate: filter?.endDate
                });
                setError(message);
                return {
                    engagements: allEngagements,
                    reachedCap: false,
                    cap: maxEngagementsCap
                };
            }
            const startMoment = (0, _momentDefault.default)(filter.startDate);
            const endMoment = (0, _momentDefault.default)(filter.endDate);
            if (!startMoment.isValid() || !endMoment.isValid()) {
                const message = "[loadAllSchedulingEngagements] Invalid startDate or endDate in filter.";
                console.error(message, {
                    startDate: filter.startDate,
                    endDate: filter.endDate
                });
                setError(message);
                return {
                    engagements: allEngagements,
                    reachedCap: false,
                    cap: maxEngagementsCap
                };
            }
            const normalizedStartDate = startMoment.startOf("day").format("YYYY-MM-DDTHH:mm:ss.SSSZ");
            const normalizedEndDate = endMoment.endOf("day").format("YYYY-MM-DDTHH:mm:ss.SSSZ");
            while(hasMoreData){
                // Check if we've reached the cap before fetching more data
                if (allEngagements.length >= maxEngagementsCap) {
                    console.warn(`[loadAllSchedulingEngagements] Reached maximum engagements cap (${maxEngagementsCap}). ` + `Returning partial results with ${allEngagements.length} engagements. ` + `Consider narrowing the date range or increasing REACT_APP_MAX_ENGAGEMENTS_CAP.`);
                    reachedCap = true;
                    hasMoreData = false;
                    break;
                }
                const paginatedFilter = {
                    ...filter,
                    startDate: normalizedStartDate,
                    endDate: normalizedEndDate,
                    timezone: undefined,
                    skip,
                    take: pageSize
                };
                const result = await _api.getOrganizationEngagements(organizationId, paginatedFilter);
                if (result.resultType === "Ok") {
                    const pageEngagements = result.data;
                    allEngagements = [
                        ...allEngagements,
                        ...pageEngagements
                    ];
                    // Check if adding this page exceeded the cap
                    if (allEngagements.length >= maxEngagementsCap) {
                        console.warn(`[loadAllSchedulingEngagements] Reached maximum engagements cap (${maxEngagementsCap}). ` + `Returning partial results with ${allEngagements.length} engagements. ` + `Consider narrowing the date range or increasing REACT_APP_MAX_ENGAGEMENTS_CAP.`);
                        reachedCap = true;
                        hasMoreData = false;
                    } else if (pageEngagements.length < pageSize || pageEngagements.length === 0) // If we received fewer records than requested or none, we've reached the end
                    hasMoreData = false;
                    else skip += pageSize;
                } else {
                    setError(result.errors?.[0] || "Failed to load engagements");
                    hasMoreData = false;
                }
            }
            // Store all engagements (this also serves loadOrganizationEngagements)
            setOrganizationEngagements(allEngagements);
            // Filter for each category
            const scheduled = filterEngagementsByTags(allEngagements, "ACTION_ATTEMPTED", [
                "ACTION_COMPLETED"
            ]);
            const rescheduled = filterEngagementsByTags(allEngagements, "ACTION_ATTEMPTED", [
                "APPOINTMENT_RESCHEDULED"
            ]);
            const cancelled = filterEngagementsByTags(allEngagements, "ACTION_ATTEMPTED", [
                "APPOINTMENT_CANCELLED"
            ]);
            const checkNext = filterEngagementsByTags(allEngagements, "ACTION_ATTEMPTED", [
                "CHECK_NEXT_APPOINTMENT_COMPLETE"
            ]);
            setScheduledEngagements(scheduled);
            setRescheduledEngagements(rescheduled);
            setCancelledEngagements(cancelled);
            setCheckNextAppointmentEngagements(checkNext);
            // Return info about whether cap was reached (useful for callers)
            return {
                engagements: allEngagements,
                reachedCap,
                cap: maxEngagementsCap
            };
        } catch (error) {
            console.error("[loadAllSchedulingEngagements] Error:", error);
            setError(error?.message || "Unknown error loading engagements");
            return {
                engagements: allEngagements,
                reachedCap: false,
                cap: maxEngagementsCap
            };
        } finally{
            setLoadingScheduledEngagements(false);
            setLoadingRescheduledEngagements(false);
            setLoadingCancelledEngagements(false);
            setLoadingCheckNextAppointmentEngagements(false);
            setLoadingOrganizationEngagements(false);
        }
    };
    // #endregion
    const resetStats = ()=>{
        setCallStatistics(null);
        setOrdersPlacedCount(0);
        setConversationalSuccessRate(null);
        setTopIntents(null);
        setOrderTotalStatistics(null);
    };
    return {
        getOrgLevelCallStatistics,
        getOrgLevelTopIntents,
        getOrgLevelOrdersPlaced,
        getOrgLevelConversationalSuccess,
        getOrgLevelItemAddedToOrder,
        getOrgLevelOrderTotalStatistics,
        getTopLocationsWithNumberOfOrdersPlaced,
        getSessionsOfAllApplications,
        loadAllEventsForSession,
        clearEventsCache,
        sessions,
        loadOrgAnalytics,
        loadOrgApplicationsPerformanceAnalytics,
        loadingSessionId,
        resetStats,
        allEventsCache,
        orderAttempts,
        callStatistics,
        orderPlacedEvents,
        topIntents,
        conversationalSuccessEvents,
        itemAddedToOrderEvents,
        orderTotalStatistics,
        topLocationsWithNumberOfOrdersPlaced,
        orgApplicationsPerformanceAnalytics,
        orderPlacedRate,
        orderPlacedCount,
        orderTransferRate,
        orderTransfers,
        sessionIdCount,
        conversationalSuccessCount,
        conversationalSuccessWithOrderAttemptedCount,
        conversationalSuccessRate,
        attemptedOrdersConversationalSuccessRate,
        itemAddedConversationalSuccessEvents,
        noTransferUnsuccessfulSessions,
        transferUnsuccessfulSessions,
        transfers,
        immediateTransfers,
        callTransferRate,
        immediateCallTransferRate,
        unsuccessfulOrderSessions,
        ordersPlacedSessions,
        orderTransferredSessionIds,
        noOrderSessionIds,
        error,
        loadingTopIntents,
        loadingOrdersPlaced,
        loadingCallStatistics,
        loadingConversationalSucess,
        loadingItemAddedToOrder,
        loadingOrderTotalStatistics,
        loadingTopLocationWithHighestNumberOfOrders,
        loadingOrgAnalytics,
        loadingOrgApplicationsPerformanceAnalytics,
        loadingCallTransferredEvents,
        loadingImmediateCallTransferredEvents,
        loadingSessionsOfAllApplications,
        noInteractionCount,
        unsuccessfulOrderAttempts,
        unsuccessfulButTransfered,
        conversationalSuccessSessions,
        successfulOrdersNotPlacedSessions,
        // Engagement Analytics Functions
        loadOrganizationEngagements,
        loadEngagementsForTagCombo,
        loadTopLevelMetrics,
        loadOrganizationTopLevelMetrics,
        // Configurable cap for testability - can be passed to loaders or used for documentation
        MAX_ENGAGEMENTS_CAP,
        loadAverageCallVolumeHistogram,
        loadOrganizationAverageCallVolumeHistogram,
        loadOrganizationAverageCallVolumeByHourHistogram,
        loadAverageContainableCallVolumeHistogram,
        loadOrganizationAverageContainableCallVolumeHistogram,
        loadAverageContainedCallVolumeHistogram,
        loadOrganizationAverageContainedCallVolumeHistogram,
        loadCallVolumeHistogram,
        loadOrganizationCallVolumeHistogram,
        loadContainableCallVolumeHistogram,
        loadOrganizationContainableCallVolumeHistogram,
        loadContainedCallVolumeHistogram,
        loadOrganizationContainedCallVolumeHistogram,
        loadSpanishCallVolumeHistogram,
        loadOrganizationSpanishCallVolumeHistogram,
        loadSpanishContainableCallVolumeHistogram,
        loadOrganizationSpanishContainableCallVolumeHistogram,
        loadSpanishContainedCallVolumeHistogram,
        loadOrganizationSpanishContainedCallVolumeHistogram,
        loadConcurrentCallVolumeHistogram,
        loadOrganizationConcurrentCallVolumeHistogram,
        loadOrderAttemptedVolumeHistogram,
        loadOrganizationOrderAttemptedVolumeHistogram,
        loadOrderPlacedVolumeHistogram,
        loadOrganizationOrderPlacedVolumeHistogram,
        // Engagement Analytics State
        organizationEngagements,
        organizationEngagementsPerApp,
        engagementsForTagCombo,
        topLevelMetrics,
        organizationTopLevelMetrics,
        organizationTopLevelMetricsPerApp,
        callVolumeHistogram,
        organizationCallVolumeHistogram,
        organizationCallVolumeHistogramPerApp,
        averageCallVolumeHistogram,
        organizationAverageCallVolumeHistogram,
        organizationAverageCallVolumeHistogramPerApp,
        organizationAverageCallVolumeByHourHistogram,
        organizationAverageCallVolumeByHourHistogramPerApp,
        containableCallVolumeHistogram,
        organizationContainableCallVolumeHistogram,
        organizationContainableCallVolumeHistogramPerApp,
        containedCallVolumeHistogram,
        organizationContainedCallVolumeHistogram,
        organizationContainedCallVolumeHistogramPerApp,
        averageContainableCallVolumeHistogram,
        organizationAverageContainableCallVolumeHistogram,
        averageContainedCallVolumeHistogram,
        organizationAverageContainedCallVolumeHistogram,
        spanishCallVolumeHistogram,
        organizationSpanishCallVolumeHistogram,
        organizationSpanishCallVolumeHistogramPerApp,
        spanishContainableCallVolumeHistogram,
        organizationSpanishContainableCallVolumeHistogram,
        organizationSpanishContainableCallVolumeHistogramPerApp,
        spanishContainedCallVolumeHistogram,
        organizationSpanishContainedCallVolumeHistogram,
        organizationSpanishContainedCallVolumeHistogramPerApp,
        concurrentCallVolumeHistogram,
        organizationConcurrentCallVolumeHistogram,
        organizationConcurrentCallVolumeHistogramPerApp,
        orderAttemptedVolumeHistogram,
        organizationOrderAttemptedVolumeHistogram,
        organizationOrderAttemptedVolumeHistogramPerApp,
        orderPlacedVolumeHistogram,
        organizationOrderPlacedVolumeHistogram,
        organizationOrderPlacedVolumeHistogramPerApp,
        // Engagement Analytics Loading State
        loadingOrganizationEngagements,
        loadingEngagementsForTagCombo,
        loadingTopLevelMetrics,
        loadingOrganizationTopLevelMetrics,
        loadingCallVolumeHistogram,
        loadingOrganizationCallVolumeHistogram,
        loadingAverageCallVolumeHistogram,
        loadingOrganizationAverageCallVolumeHistogram,
        loadingOrganizationAverageCallVolumeByHourHistogram,
        loadingContainableCallVolumeHistogram,
        loadingOrganizationContainableCallVolumeHistogram,
        loadingContainedCallVolumeHistogram,
        loadingOrganizationContainedCallVolumeHistogram,
        loadingAverageContainableCallVolumeHistogram,
        loadingOrganizationAverageContainableCallVolumeHistogram,
        loadingAverageContainedCallVolumeHistogram,
        loadingOrganizationAverageContainedCallVolumeHistogram,
        loadingSpanishCallVolumeHistogram,
        loadingOrganizationSpanishCallVolumeHistogram,
        loadingSpanishContainableCallVolumeHistogram,
        loadingOrganizationSpanishContainableCallVolumeHistogram,
        loadingSpanishContainedCallVolumeHistogram,
        loadingOrganizationSpanishContainedCallVolumeHistogram,
        loadingConcurrentCallVolumeHistogram,
        loadingOrganizationConcurrentCallVolumeHistogram,
        loadingOrderAttemptedVolumeHistogram,
        loadingOrganizationOrderAttemptedVolumeHistogram,
        loadingOrderPlacedVolumeHistogram,
        loadingOrganizationOrderPlacedVolumeHistogram,
        // Transfer Reasons
        loadOrganizationTransferReasons,
        loadApplicationTransferReasons,
        organizationTransferReasons,
        organizationPlannedTransferReasons,
        organizationUnplannedTransferReasons,
        applicationTransferReasons,
        loadingOrganizationTransferReasons,
        loadingApplicationTransferReasons,
        // Appointments Managed (for Patient Bookings)
        loadScheduledEngagements,
        loadRescheduledEngagements,
        loadCancelledEngagements,
        loadCheckNextAppointmentEngagements,
        loadAllSchedulingEngagements,
        scheduledEngagements,
        rescheduledEngagements,
        cancelledEngagements,
        checkNextAppointmentEngagements,
        loadingScheduledEngagements,
        loadingRescheduledEngagements,
        loadingCancelledEngagements,
        loadingCheckNextAppointmentEngagements,
        // Off Hours Engagements
        loadOffHoursEngagements,
        offHoursEngagements,
        loadingOffHoursEngagements,
        // Spanish Off Hours Engagements
        loadSpanishOffHoursEngagements,
        spanishOffHoursEngagements,
        loadingSpanishOffHoursEngagements,
        // Transferred Engagements
        loadTransferredEngagements,
        transferredEngagements,
        loadingTransferredEngagements
    };
}
const OrgAnalyticsContainer = (0, _unstatedNext.createContainer)(useOrgAnalyticsContainer);
exports.default = OrgAnalyticsContainer;

},{"unstated-next":"61zE5","../api":"loxM6","../models/result/InvalidResult":"hpD5G","react":"6uln9","moment":"2meyw","../utils/engagementAnalyticsTransformers":"1LaeU","../constants/Intents":"kgrHM","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1LaeU":[function(require,module,exports) {
/**
 * Data transformation utilities for engagement analytics
 * 
 * These functions transform API responses from the engagement analytics endpoints
 * into formats compatible with the dashboard charts and components.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "flattenGroupedHistogramData", ()=>flattenGroupedHistogramData);
parcelHelpers.export(exports, "transformAppBreakdown", ()=>transformAppBreakdown);
parcelHelpers.export(exports, "flattenGroupedHistogramDataFiltered", ()=>flattenGroupedHistogramDataFiltered);
parcelHelpers.export(exports, "flattenConcurrentCallHistogramDataFiltered", ()=>flattenConcurrentCallHistogramDataFiltered);
parcelHelpers.export(exports, "aggregateTopLevelMetricsFiltered", ()=>aggregateTopLevelMetricsFiltered);
parcelHelpers.export(exports, "filterEngagementsByAppIds", ()=>filterEngagementsByAppIds);
parcelHelpers.export(exports, "filterTransferReasonsByAppIds", ()=>filterTransferReasonsByAppIds);
parcelHelpers.export(exports, "transformAppBreakdowns", ()=>transformAppBreakdowns);
parcelHelpers.export(exports, "transformToHealthcareMetrics", ()=>transformToHealthcareMetrics);
parcelHelpers.export(exports, "transformToFoodOrderingMetrics", ()=>transformToFoodOrderingMetrics);
parcelHelpers.export(exports, "transformHistogramToDataset", ()=>transformHistogramToDataset);
parcelHelpers.export(exports, "transformHistogramsToMultiLineData", ()=>transformHistogramsToMultiLineData);
parcelHelpers.export(exports, "transformSpanishHistogramsToMultiLineData", ()=>transformSpanishHistogramsToMultiLineData);
parcelHelpers.export(exports, "transformOrderVolumeToMultiLineData", ()=>transformOrderVolumeToMultiLineData);
parcelHelpers.export(exports, "transformAverageByHourHistogramToDataset", ()=>transformAverageByHourHistogramToDataset);
parcelHelpers.export(exports, "transformAverageByDayHistogramToDataset", ()=>transformAverageByDayHistogramToDataset);
parcelHelpers.export(exports, "transformConcurrentHistogramToDataset", ()=>transformConcurrentHistogramToDataset);
parcelHelpers.export(exports, "transformTransferReasonsToChartData", ()=>transformTransferReasonsToChartData);
parcelHelpers.export(exports, "transformLegacyTransferReasonsToChartData", ()=>transformLegacyTransferReasonsToChartData);
parcelHelpers.export(exports, "transformTransferReasonsApiToChartData", ()=>transformTransferReasonsApiToChartData);
parcelHelpers.export(exports, "transformSeparateTransferReasonsToChartData", ()=>transformSeparateTransferReasonsToChartData);
parcelHelpers.export(exports, "calculateTransferTotals", ()=>calculateTransferTotals);
parcelHelpers.export(exports, "transformEngagementsToCallRecords", ()=>transformEngagementsToCallRecords);
parcelHelpers.export(exports, "transformContainedCallsData", ()=>transformContainedCallsData);
parcelHelpers.export(exports, "isAnalyticsDataLoading", ()=>isAnalyticsDataLoading);
parcelHelpers.export(exports, "getEmptyHealthcareMetrics", ()=>getEmptyHealthcareMetrics);
parcelHelpers.export(exports, "getEmptyFoodOrderingMetrics", ()=>getEmptyFoodOrderingMetrics);
parcelHelpers.export(exports, "getEmptyHistogramDataset", ()=>getEmptyHistogramDataset);
parcelHelpers.export(exports, "transformToConversionFunnelData", ()=>transformToConversionFunnelData);
parcelHelpers.export(exports, "transformEngagementsToConversionFunnel", ()=>transformEngagementsToConversionFunnel);
parcelHelpers.export(exports, "getEmptyConversionFunnelData", ()=>getEmptyConversionFunnelData);
parcelHelpers.export(exports, "calculateOrderCompletionRate", ()=>calculateOrderCompletionRate);
parcelHelpers.export(exports, "transformEngagementsToPatientBookings", ()=>transformEngagementsToPatientBookings);
parcelHelpers.export(exports, "transformEngagementsToSchedulingEvents", ()=>transformEngagementsToSchedulingEvents);
parcelHelpers.export(exports, "calculateTotalBookings", ()=>calculateTotalBookings);
parcelHelpers.export(exports, "transformTopLevelMetricsToSchedulingEvents", ()=>transformTopLevelMetricsToSchedulingEvents);
var _moment = require("moment");
var _momentDefault = parcelHelpers.interopDefault(_moment);
var _transfersChart = require("../components/charts/TransfersChart");
const flattenGroupedHistogramData = (groupedData)=>{
    if (!groupedData || typeof groupedData !== "object") return null;
    const allEntries = Object.values(groupedData).flat();
    if (allEntries.length === 0) return null;
    // Aggregate counts by date key
    const aggregatedByDate = {};
    allEntries.forEach((entry)=>{
        const dateKey = entry.date || entry.key;
        if (!aggregatedByDate[dateKey]) aggregatedByDate[dateKey] = {
            key: entry.key,
            date: entry.date,
            count: 0
        };
        aggregatedByDate[dateKey].count += entry.count;
    });
    // Convert to sorted array
    const data = Object.values(aggregatedByDate).sort((a, b)=>new Date(a.date).getTime() - new Date(b.date).getTime());
    return {
        id: "aggregated",
        filter: null,
        interval: null,
        data: data
    };
};
const transformAppBreakdown = (apiApp)=>({
        appName: apiApp.applicationName,
        count: apiApp.count,
        english: apiApp.english,
        spanish: apiApp.spanish
    });
const flattenGroupedHistogramDataFiltered = (groupedData, applicationIds)=>{
    if (!groupedData || typeof groupedData !== "object") return null;
    // Convert to Set for efficient lookup
    // When applicationIds is undefined/null, include all apps (initial state before apps load)
    // When applicationIds is an empty Set/Array, return null (user deselected all)
    let appIdSet = null;
    if (applicationIds !== undefined && applicationIds !== null) {
        if (applicationIds instanceof Set) {
            if (applicationIds.size === 0) return null; // Empty filter = no data
            appIdSet = applicationIds;
        } else {
            if (applicationIds.length === 0) return null; // Empty filter = no data
            appIdSet = new Set(applicationIds);
        }
    }
    // Filter entries by applicationIds if provided
    const filteredEntries = [];
    for (const [appId, entries] of Object.entries(groupedData))if (!appIdSet || appIdSet.has(appId)) filteredEntries.push(...entries);
    if (filteredEntries.length === 0) return null;
    // Aggregate counts by date key
    const aggregatedByDate = {};
    filteredEntries.forEach((entry)=>{
        const dateKey = entry.date || entry.key;
        if (!aggregatedByDate[dateKey]) aggregatedByDate[dateKey] = {
            key: entry.key,
            date: entry.date,
            count: 0
        };
        aggregatedByDate[dateKey].count += entry.count;
    });
    // Convert to sorted array
    const data = Object.values(aggregatedByDate).sort((a, b)=>new Date(a.date).getTime() - new Date(b.date).getTime());
    return {
        id: "aggregated-filtered",
        filter: null,
        interval: null,
        data: data
    };
};
const flattenConcurrentCallHistogramDataFiltered = (groupedData, applicationIds)=>{
    if (!groupedData || typeof groupedData !== "object") return null;
    // Convert to Set for efficient lookup
    // When applicationIds is undefined/null, include all apps (initial state before apps load)
    // When applicationIds is an empty Set/Array, return null (user deselected all)
    let appIdSet = null;
    if (applicationIds !== undefined && applicationIds !== null) {
        if (applicationIds instanceof Set) {
            if (applicationIds.size === 0) return null; // Empty filter = no data
            appIdSet = applicationIds;
        } else {
            if (applicationIds.length === 0) return null; // Empty filter = no data
            appIdSet = new Set(applicationIds);
        }
    }
    // Filter entries by applicationIds if provided
    const filteredEntries = [];
    for (const [appId, entries] of Object.entries(groupedData))if (!appIdSet || appIdSet.has(appId)) filteredEntries.push(...entries);
    if (filteredEntries.length === 0) return null;
    // Aggregate by taking MAXIMUM count for each date key (not sum)
    const aggregatedByDate = {};
    filteredEntries.forEach((entry)=>{
        const dateKey = entry.date || entry.key;
        if (!aggregatedByDate[dateKey]) aggregatedByDate[dateKey] = {
            key: entry.key,
            date: entry.date,
            count: entry.count
        };
        else // Take the maximum instead of summing
        aggregatedByDate[dateKey].count = Math.max(aggregatedByDate[dateKey].count, entry.count);
    });
    // Convert to sorted array
    const data = Object.values(aggregatedByDate).sort((a, b)=>new Date(a.date).getTime() - new Date(b.date).getTime());
    return {
        id: "concurrent-max-filtered",
        filter: null,
        interval: null,
        data: data
    };
};
const aggregateTopLevelMetricsFiltered = (perAppMetrics, applicationIds, spanishOnly)=>{
    if (!perAppMetrics || typeof perAppMetrics !== "object") return null;
    // Convert to Set for efficient lookup
    // When applicationIds is undefined/null, include all apps (initial state before apps load)
    // When applicationIds is an empty Set/Array, return null (user deselected all)
    let appIdSet = null;
    if (applicationIds !== undefined && applicationIds !== null) {
        if (applicationIds instanceof Set) {
            if (applicationIds.size === 0) return null; // Empty filter = no data
            appIdSet = applicationIds;
        } else {
            if (applicationIds.length === 0) return null; // Empty filter = no data
            appIdSet = new Set(applicationIds);
        }
    }
    const aggregatedMetrics = {
        laborMinutesSaved: 0,
        laborHoursSaved: 0,
        totalCalls: 0,
        containedCalls: 0,
        containableCalls: 0,
        offHoursCalls: 0,
        offHoursScheduledAppts: 0,
        newPatientBookings: 0,
        existingPatientBookings: 0,
        totalBookings: 0,
        orderAttempts: 0,
        ordersPlaced: 0,
        upsellAttempts: 0,
        upsellSuccesses: 0,
        questionsAnswered: 0,
        averageOrderTotal: 0,
        laborHoursSavedApps: [],
        offHoursApps: [],
        offHoursScheduledApptsApps: [],
        newPatientBookingsApps: [],
        ticketApps: [],
        upsellApps: [],
        questionsApps: []
    };
    // Track weighted average for averageOrderTotal
    let totalOrdersForAverage = 0;
    let weightedOrderTotalSum = 0;
    for (const [appId, metrics] of Object.entries(perAppMetrics)){
        // Skip if filtering and this app is not selected
        if (appIdSet && !appIdSet.has(appId)) continue;
        if (metrics) {
            // When spanishOnly is true, only aggregate Spanish-specific metrics
            if (spanishOnly) {
                aggregatedMetrics.laborMinutesSaved += metrics.laborMinutesSavedSpanish ?? 0;
                aggregatedMetrics.totalCalls += metrics.totalEngagementCountSpanish ?? 0;
                aggregatedMetrics.containedCalls += metrics.totalContainedCountSpanish ?? 0;
                aggregatedMetrics.containableCalls += (metrics.totalScheduleAttemptsSpanish ?? 0) + (metrics.totalRescheduleAttemptsSpanish ?? 0) + (metrics.totalCancellationAttemptsSpanish ?? 0) + (metrics.totalCheckNextAppointmentAttemptsSpanish ?? 0);
                aggregatedMetrics.newPatientBookings += metrics.newPatientBookedSpanish ?? 0;
            } else {
                aggregatedMetrics.laborMinutesSaved += metrics.laborMinutesSaved ?? 0;
                aggregatedMetrics.totalCalls += metrics.totalEngagementCount ?? metrics.totalCalls ?? 0;
                aggregatedMetrics.containedCalls += (metrics.totalContainedCountEnglish ?? 0) + (metrics.totalContainedCountSpanish ?? 0);
                // Containable calls = total scheduling attempts (schedule + reschedule + cancel + check appt)
                aggregatedMetrics.containableCalls += (metrics.totalScheduleAttemptsEnglish ?? 0) + (metrics.totalScheduleAttemptsSpanish ?? 0) + (metrics.totalRescheduleAttemptsEnglish ?? 0) + (metrics.totalRescheduleAttemptsSpanish ?? 0) + (metrics.totalCancellationAttemptsEnglish ?? 0) + (metrics.totalCancellationAttemptsSpanish ?? 0) + (metrics.totalCheckNextAppointmentAttemptsEnglish ?? 0) + (metrics.totalCheckNextAppointmentAttemptsSpanish ?? 0);
                aggregatedMetrics.newPatientBookings += (metrics.newPatientBookedEnglish ?? 0) + (metrics.newPatientBookedSpanish ?? 0);
            }
            aggregatedMetrics.offHoursCalls += metrics.offHoursCalls ?? 0;
            aggregatedMetrics.offHoursScheduledAppts += metrics.offHoursScheduledAppts ?? 0;
            aggregatedMetrics.orderAttempts += metrics.totalOrderAttempts ?? metrics.orderAttempts ?? 0;
            aggregatedMetrics.ordersPlaced += metrics.totalOrdersCompleted ?? metrics.ordersPlaced ?? 0;
            aggregatedMetrics.upsellAttempts += metrics.totalUpsellAttempts ?? metrics.upsellAttempts ?? 0;
            aggregatedMetrics.upsellSuccesses += metrics.totalUpsellsCompleted ?? metrics.upsellSuccesses ?? 0;
            aggregatedMetrics.questionsAnswered += metrics.totalQuestionsAnswered ?? metrics.questionsAnswered ?? 0;
            // Aggregate averageOrderTotal as weighted average
            const appOrderTotal = metrics.averageTicketSize ?? metrics.averageOrderTotal ?? metrics.AverageOrderTotal ?? metrics.totalAverageOrderValue ?? 0;
            const appOrderCount = metrics.totalOrdersCompleted ?? metrics.ordersPlaced ?? 0;
            if (appOrderTotal > 0) {
                if (appOrderCount > 0) {
                    weightedOrderTotalSum += appOrderTotal * appOrderCount;
                    totalOrdersForAverage += appOrderCount;
                } else {
                    weightedOrderTotalSum += appOrderTotal;
                    totalOrdersForAverage += 1;
                }
            }
            // Add app breakdown for laborHoursSaved
            const laborMinutesEnglish = metrics.laborMinutesSavedEnglish ?? 0;
            const laborMinutesSpanish = metrics.laborMinutesSavedSpanish ?? 0;
            const laborMinutes = spanishOnly ? laborMinutesSpanish : laborMinutesEnglish + laborMinutesSpanish || (metrics.laborMinutesSaved ?? 0);
            if (laborMinutes > 0) aggregatedMetrics.laborHoursSavedApps.push({
                applicationId: appId,
                applicationName: appId,
                count: laborMinutes / 60,
                english: spanishOnly ? 0 : laborMinutesEnglish / 60,
                spanish: laborMinutesSpanish / 60
            });
            // Add app breakdown for newPatientBookings
            const englishCount = metrics.newPatientBookedEnglish ?? 0;
            const spanishCount = metrics.newPatientBookedSpanish ?? 0;
            const totalCount = spanishOnly ? spanishCount : englishCount + spanishCount;
            if (totalCount > 0) aggregatedMetrics.newPatientBookingsApps.push({
                applicationId: appId,
                applicationName: appId,
                count: totalCount,
                english: spanishOnly ? 0 : englishCount,
                spanish: spanishCount
            });
            // Add app breakdown for ticketApps
            if (appOrderTotal > 0) aggregatedMetrics.ticketApps.push({
                applicationId: appId,
                applicationName: appId,
                count: appOrderTotal
            });
            // Add app breakdown for upsellApps
            const upsellSuccessCount = metrics.totalUpsellsCompleted ?? metrics.upsellSuccesses ?? 0;
            if (upsellSuccessCount > 0) aggregatedMetrics.upsellApps.push({
                applicationId: appId,
                applicationName: appId,
                count: upsellSuccessCount
            });
            // Add app breakdown for questionsApps
            const questionsCount = metrics.totalQuestionsAnswered ?? metrics.questionsAnswered ?? 0;
            if (questionsCount > 0) aggregatedMetrics.questionsApps.push({
                applicationId: appId,
                applicationName: appId,
                count: questionsCount
            });
        }
    }
    // Convert laborMinutesSaved to laborHoursSaved
    aggregatedMetrics.laborHoursSaved = aggregatedMetrics.laborMinutesSaved / 60;
    // Calculate weighted average for averageOrderTotal
    aggregatedMetrics.averageOrderTotal = totalOrdersForAverage > 0 ? weightedOrderTotalSum / totalOrdersForAverage : 0;
    return aggregatedMetrics;
};
const filterEngagementsByAppIds = (engagements, applicationIds)=>{
    if (!engagements || engagements.length === 0) return [];
    // If no filter provided (undefined/null), return all engagements (initial state)
    if (applicationIds === undefined || applicationIds === null) return engagements;
    // Convert to Set for efficient lookup
    // When applicationIds is an empty Set/Array, return empty (user deselected all)
    let appIdSet;
    if (applicationIds instanceof Set) {
        if (applicationIds.size === 0) return []; // Empty filter = no data
        appIdSet = applicationIds;
    } else {
        if (applicationIds.length === 0) return []; // Empty filter = no data
        appIdSet = new Set(applicationIds);
    }
    return engagements.filter((engagement)=>appIdSet.has(engagement.applicationId));
};
const filterTransferReasonsByAppIds = (transferReasons, applicationIds)=>{
    if (!transferReasons || Object.keys(transferReasons).length === 0) return null;
    // If no filter provided (undefined/null), return all data (initial state)
    if (applicationIds === undefined || applicationIds === null) return transferReasons;
    // Convert to Set for efficient lookup
    // When applicationIds is an empty Set/Array, return null (user deselected all)
    let appIdSet;
    if (applicationIds instanceof Set) {
        if (applicationIds.size === 0) return null; // Empty filter = no data
        appIdSet = applicationIds;
    } else {
        if (applicationIds.length === 0) return null; // Empty filter = no data
        appIdSet = new Set(applicationIds);
    }
    // Filter to only include selected app IDs
    const filtered = {};
    for (const [appId, reasons] of Object.entries(transferReasons))if (appIdSet.has(appId)) filtered[appId] = reasons;
    return Object.keys(filtered).length > 0 ? filtered : null;
};
const transformAppBreakdowns = (apiApps)=>{
    if (!apiApps) return [];
    return apiApps.map(transformAppBreakdown);
};
const transformToHealthcareMetrics = (metrics)=>{
    if (!metrics) return {
        laborHoursSaved: 0,
        offHoursCalls: 0,
        offHoursScheduledAppts: 0,
        containedCallsCount: 0,
        containableCallsCount: 0,
        totalEngagements: 0,
        newPatientBookings: 0,
        laborHoursSavedApps: [],
        offHoursApps: [],
        offHoursScheduledApptsApps: [],
        newPatientBookingsApps: []
    };
    // Convert laborMinutesSaved from API to hours (or use laborHoursSaved if already computed)
    const laborHoursSaved = metrics.laborMinutesSaved !== undefined ? metrics.laborMinutesSaved / 60 : metrics.laborHoursSaved ?? 0;
    return {
        laborHoursSaved,
        offHoursCalls: metrics.offHoursCalls ?? 0,
        offHoursScheduledAppts: metrics.offHoursScheduledAppts ?? 0,
        containedCallsCount: metrics.containedCalls ?? 0,
        containableCallsCount: metrics.containableCalls ?? 0,
        totalEngagements: metrics.totalCalls ?? 0,
        newPatientBookings: metrics.newPatientBookings ?? 0,
        laborHoursSavedApps: transformAppBreakdowns(metrics.laborHoursSavedApps),
        offHoursApps: transformAppBreakdowns(metrics.offHoursApps),
        offHoursScheduledApptsApps: transformAppBreakdowns(metrics.offHoursScheduledApptsApps),
        newPatientBookingsApps: transformAppBreakdowns(metrics.newPatientBookingsApps)
    };
};
const transformToFoodOrderingMetrics = (metrics)=>{
    if (!metrics) return {
        upsellSuccessRate: 0,
        successfulUpsells: 0,
        upsellAttempts: 0,
        averageTicketSize: 0,
        totalSold: 0,
        questionsAnswered: 0,
        laborHoursSaved: 0,
        upsellApps: [],
        ticketApps: [],
        questionsApps: [],
        laborHoursSavedApps: []
    };
    const upsellAttempts = metrics.upsellAttempts ?? 0;
    const upsellSuccesses = metrics.upsellSuccesses ?? 0;
    const upsellRate = upsellAttempts > 0 ? upsellSuccesses / upsellAttempts * 100 : 0;
    // Convert laborMinutesSaved from API to hours (or use laborHoursSaved if already computed)
    const laborHoursSaved = metrics.laborMinutesSaved != null ? metrics.laborMinutesSaved / 60 : metrics.laborHoursSaved ?? 0;
    // Calculate total sold: use totalRevenue if available, otherwise compute from ordersPlaced * averageOrderTotal
    const averageTicket = metrics.averageOrderTotal ?? metrics.averageTicketSize ?? metrics.average_ticket_total ?? 0;
    const totalSold = metrics.totalRevenue ?? (metrics.ordersPlaced ?? 0) * averageTicket;
    return {
        upsellSuccessRate: Math.round(upsellRate * 10) / 10,
        successfulUpsells: upsellSuccesses,
        upsellAttempts: upsellAttempts,
        averageTicketSize: metrics.averageOrderTotal ?? 0,
        totalSold,
        questionsAnswered: metrics.questionsAnswered ?? 0,
        laborHoursSaved,
        upsellApps: transformAppBreakdowns(metrics.upsellApps),
        ticketApps: transformAppBreakdowns(metrics.ticketApps),
        questionsApps: transformAppBreakdowns(metrics.questionsApps),
        laborHoursSavedApps: transformAppBreakdowns(metrics.laborHoursSavedApps)
    };
};
const transformHistogramToDataset = (histogram, datasetId, color)=>{
    if (!histogram || !histogram.data) return {
        id: datasetId,
        color,
        data: []
    };
    // Detect if this is hourly data by checking if multiple points have the same date
    // Hourly data will have 24 points per day with different hours
    const isHourlyData = histogram.data.length > 1 && (()=>{
        const firstDate = (0, _momentDefault.default)(histogram.data[0].date).format("YYYY-MM-DD");
        const secondDate = (0, _momentDefault.default)(histogram.data[1].date).format("YYYY-MM-DD");
        return firstDate === secondDate;
    })();
    const dataPoints = histogram.data.map((point)=>{
        // For hourly data, format as hour (e.g., "2 AM", "12 PM")
        // For daily or longer intervals, format as date (e.g., "Feb 4")
        const xLabel = isHourlyData ? (0, _momentDefault.default)(point.date).format("h A") // "2 AM", "12 PM"
         : (0, _momentDefault.default)(point.date).format("MMM D");
        return {
            x: xLabel,
            y: point.count,
            color: color,
            fullDate: point.date
        };
    });
    return {
        id: datasetId,
        color,
        data: dataPoints
    };
};
const transformHistogramsToMultiLineData = (allCallsHistogram, containableCallsHistogram, containedCallsHistogram, colors)=>{
    const datasets = [];
    // Only add datasets that have data
    if (allCallsHistogram?.data?.length) datasets.push(transformHistogramToDataset(allCallsHistogram, "All Conversations", colors.allCalls));
    if (containableCallsHistogram?.data?.length) datasets.push(transformHistogramToDataset(containableCallsHistogram, "Containable Conversations", colors.containable));
    if (containedCallsHistogram?.data?.length) datasets.push(transformHistogramToDataset(containedCallsHistogram, "Contained Conversations", colors.contained));
    return datasets;
};
const transformSpanishHistogramsToMultiLineData = (spanishCallsHistogram, spanishContainableHistogram, spanishContainedHistogram, colors)=>{
    const datasets = [];
    // Only add datasets that have data
    if (spanishCallsHistogram?.data?.length) datasets.push(transformHistogramToDataset(spanishCallsHistogram, "All Spanish Calls", colors.spanishCalls));
    if (spanishContainableHistogram?.data?.length) datasets.push(transformHistogramToDataset(spanishContainableHistogram, "Spanish Containable Conversations", colors.spanishContainable));
    if (spanishContainedHistogram?.data?.length) datasets.push(transformHistogramToDataset(spanishContainedHistogram, "Spanish Contained Conversations", colors.spanishContained));
    return datasets;
};
const transformOrderVolumeToMultiLineData = (allCallsHistogram, orderAttemptedHistogram, orderPlacedHistogram, colors)=>{
    const datasets = [];
    // Only add datasets that have data
    if (allCallsHistogram?.data?.length) datasets.push(transformHistogramToDataset(allCallsHistogram, "All Conversations", colors.allCalls));
    if (orderAttemptedHistogram?.data?.length) datasets.push(transformHistogramToDataset(orderAttemptedHistogram, "Order Attempted", colors.orderAttempted));
    if (orderPlacedHistogram?.data?.length) datasets.push(transformHistogramToDataset(orderPlacedHistogram, "Order Placed", colors.orderPlaced));
    return datasets;
};
const transformAverageByHourHistogramToDataset = (histogram, datasetId, color)=>{
    if (!histogram || !histogram.data) return {
        id: datasetId,
        color,
        data: []
    };
    const dataPoints = histogram.data.map((point)=>{
        const hour = (0, _momentDefault.default)(point.date).hour();
        const hourLabel = hour === 0 ? "12AM" : hour === 12 ? "12PM" : hour < 12 ? `${hour}AM` : `${hour - 12}PM`;
        return {
            x: hourLabel,
            y: point.count,
            color: color,
            fullDate: point.date
        };
    });
    return {
        id: datasetId,
        color,
        data: dataPoints
    };
};
const transformAverageByDayHistogramToDataset = (histogram, datasetId, color)=>{
    if (!histogram || !histogram.data) return {
        id: datasetId,
        color,
        data: []
    };
    const dataPoints = histogram.data.map((point)=>({
            x: (0, _momentDefault.default)(point.date).format("ddd"),
            y: point.count,
            color: color,
            fullDate: point.date
        }));
    return {
        id: datasetId,
        color,
        data: dataPoints
    };
};
const transformConcurrentHistogramToDataset = (histogram, datasetId, color)=>{
    if (!histogram || !histogram.data) return {
        id: datasetId,
        color,
        data: []
    };
    // Detect if this is hourly data by checking if multiple points have the same date
    const isHourlyData = histogram.data.length > 1 && (()=>{
        const firstDate = (0, _momentDefault.default)(histogram.data[0].date).format("YYYY-MM-DD");
        const secondDate = (0, _momentDefault.default)(histogram.data[1].date).format("YYYY-MM-DD");
        return firstDate === secondDate;
    })();
    const dataPoints = histogram.data.map((point)=>{
        const xLabel = isHourlyData ? (0, _momentDefault.default)(point.date).format("h A") : (0, _momentDefault.default)(point.date).format("MMM D");
        return {
            x: xLabel,
            y: point.count,
            color: color,
            fullDate: point.date
        };
    });
    return {
        id: datasetId,
        color,
        data: dataPoints
    };
};
const transformTransferReasonsToChartData = (transferReasons)=>{
    if (!transferReasons) return [];
    const plannedCategory = {
        category: "Planned"
    };
    const unplannedCategory = {
        category: "Unplanned"
    };
    // Transform planned transfer reasons
    transferReasons.planned?.forEach((reason)=>{
        const reasonKey = reason.reason;
        // Skip Immediate Transfers - they are not containable
        if (reasonKey === (0, _transfersChart.TransferReason).IMMEDIATE_TRANSFER) return;
        plannedCategory[reasonKey] = {
            value: reason.count,
            apps: reason.apps?.map((app)=>({
                    appName: app.applicationName,
                    count: app.count,
                    english: app.english,
                    spanish: app.spanish
                })) || []
        };
    });
    // Transform unplanned transfer reasons
    transferReasons.unplanned?.forEach((reason)=>{
        const reasonKey = reason.reason;
        // Skip Immediate Transfers - they are not containable
        if (reasonKey === (0, _transfersChart.TransferReason).IMMEDIATE_TRANSFER) return;
        unplannedCategory[reasonKey] = {
            value: reason.count,
            apps: reason.apps?.map((app)=>({
                    appName: app.applicationName,
                    count: app.count,
                    english: app.english,
                    spanish: app.spanish
                })) || []
        };
    });
    return [
        plannedCategory,
        unplannedCategory
    ];
};
const transformLegacyTransferReasonsToChartData = (transferReasons)=>{
    if (!transferReasons || transferReasons.length === 0) return [];
    const plannedCategory = {
        category: "Planned"
    };
    const unplannedCategory = {
        category: "Unplanned"
    };
    // Group transfer reasons by planned/unplanned
    transferReasons.forEach((reason)=>{
        if (!reason.reason) return;
        const reasonKey = reason.reason;
        // Skip Immediate Transfers - they are not containable
        if (reasonKey === (0, _transfersChart.TransferReason).IMMEDIATE_TRANSFER) return;
        const targetCategory = reason.isPlanned ? plannedCategory : unplannedCategory;
        targetCategory[reasonKey] = {
            value: reason.count || 0,
            apps: reason.apps?.map((app)=>({
                    appName: app.applicationName,
                    count: app.count,
                    english: app.english,
                    spanish: app.spanish
                })) || []
        };
    });
    return [
        plannedCategory,
        unplannedCategory
    ];
};
const transformTransferReasonsApiToChartData = (apiResponse, appNameMap)=>{
    if (!apiResponse || Object.keys(apiResponse).length === 0) return [];
    const plannedCategory = {
        category: "Planned"
    };
    const unplannedCategory = {
        category: "Unplanned"
    };
    const undeterminedCategory = {
        category: "Undetermined"
    };
    // Aggregate counts by reason across all applications
    const reasonTotals = {};
    // Iterate through each application's transfer reasons
    Object.entries(apiResponse).forEach(([applicationId, reasons])=>{
        Object.entries(reasons).forEach(([reason, count])=>{
            if (count === 0) return; // Skip zero counts
            // Skip Immediate Transfers - they are not containable
            if (reason === (0, _transfersChart.TransferReason).IMMEDIATE_TRANSFER) return;
            if (!reasonTotals[reason]) reasonTotals[reason] = {
                count: 0,
                apps: []
            };
            reasonTotals[reason].count += count;
            reasonTotals[reason].apps.push({
                appId: applicationId,
                count
            });
        });
    });
    // Map aggregated reasons to the correct category (planned vs unplanned vs undetermined)
    Object.entries(reasonTotals).forEach(([reason, data])=>{
        const reasonKey = reason;
        // Check if this reason exists in our enum and determine category
        // null = Undetermined, true = Planned, false = Unplanned
        const isPlanned = (0, _transfersChart.TRANSFER_REASON_IS_PLANNED)[reasonKey];
        const targetCategory = isPlanned === null ? undeterminedCategory : isPlanned ? plannedCategory : unplannedCategory;
        targetCategory[reasonKey] = {
            value: data.count,
            apps: data.apps.map((app)=>({
                    appName: appNameMap?.[app.appId] ?? app.appId,
                    // Use app name from map if available, fallback to appId
                    count: app.count,
                    english: 0,
                    // Not available from this endpoint
                    spanish: 0 // Not available from this endpoint
                }))
        };
    });
    return [
        plannedCategory,
        unplannedCategory,
        undeterminedCategory
    ];
};
const transformSeparateTransferReasonsToChartData = (plannedResponse, unplannedResponse, appNameMap)=>{
    const plannedCategory = {
        category: "Planned"
    };
    const unplannedCategory = {
        category: "Unplanned"
    };
    // Helper function to aggregate reasons from an API response
    const aggregateReasons = (apiResponse, targetCategory)=>{
        if (!apiResponse || Object.keys(apiResponse).length === 0) return;
        const reasonTotals = {};
        Object.entries(apiResponse).forEach(([applicationId, reasons])=>{
            Object.entries(reasons).forEach(([reason, count])=>{
                if (count === 0) return;
                // Skip Immediate Transfers - they are not containable
                if (reason === (0, _transfersChart.TransferReason).IMMEDIATE_TRANSFER) return;
                if (!reasonTotals[reason]) reasonTotals[reason] = {
                    count: 0,
                    apps: []
                };
                reasonTotals[reason].count += count;
                reasonTotals[reason].apps.push({
                    appId: applicationId,
                    count
                });
            });
        });
        Object.entries(reasonTotals).forEach(([reason, data])=>{
            const reasonKey = reason;
            targetCategory[reasonKey] = {
                value: data.count,
                apps: data.apps.map((app)=>({
                        appName: appNameMap?.[app.appId] ?? app.appId,
                        count: app.count,
                        english: 0,
                        spanish: 0
                    }))
            };
        });
    };
    aggregateReasons(plannedResponse, plannedCategory);
    aggregateReasons(unplannedResponse, unplannedCategory);
    return [
        plannedCategory,
        unplannedCategory
    ];
};
const calculateTransferTotals = (transferData)=>{
    let planned = 0;
    let unplanned = 0;
    let undetermined = 0;
    transferData.forEach((categoryData)=>{
        Object.keys(categoryData).forEach((key)=>{
            if (key !== "category") {
                const reasonData = categoryData[key];
                if (reasonData?.value) {
                    if (categoryData.category === "Planned") planned += reasonData.value;
                    else if (categoryData.category === "Unplanned") unplanned += reasonData.value;
                    else if (categoryData.category === "Undetermined") undetermined += reasonData.value;
                }
            }
        });
    });
    return {
        planned,
        unplanned,
        undetermined,
        total: planned + unplanned + undetermined
    };
};
const transformEngagementsToCallRecords = (engagements)=>{
    if (!engagements) return [];
    return engagements.map((engagement)=>({
            id: engagement.id,
            date: engagement.date || (0, _momentDefault.default)(engagement.eventDate || engagement.startDate).format("MM/DD/YYYY"),
            time: engagement.time || (0, _momentDefault.default)(engagement.eventDate || engagement.startDate).format("h:mm A"),
            phoneLastFour: engagement.phoneLastFour || engagement.nativeUserId?.slice(-4) || "****",
            transcriptLink: `/transcripts/${engagement.sessionId || engagement.id}`,
            category: engagement.sessionCategory || engagement.category || "Unknown",
            tags: engagement.sessionTags || engagement.tags || [],
            location: engagement.location || engagement.applicationName || "Unknown"
        }));
};
const transformContainedCallsData = (containedCallsData, defaultColor)=>{
    if (!containedCallsData) return [];
    return containedCallsData.map((item)=>({
            type: item.category,
            count: item.containedCount,
            color: defaultColor,
            apps: item.containedApps?.map((app)=>({
                    appName: app.applicationName,
                    count: app.count,
                    english: app.english,
                    spanish: app.spanish
                })) || [],
            notContainedCount: item.notContainedCount,
            notContainedApps: item.notContainedApps?.map((app)=>({
                    appName: app.applicationName,
                    count: app.count,
                    english: app.english,
                    spanish: app.spanish
                }))
        }));
};
const isAnalyticsDataLoading = (loadingStates)=>{
    return loadingStates.loadingOrganizationEngagements || loadingStates.loadingOrganizationTopLevelMetrics || loadingStates.loadingOrganizationCallVolumeHistogram || loadingStates.loadingOrganizationContainableCallVolumeHistogram || loadingStates.loadingOrganizationContainedCallVolumeHistogram || loadingStates.loadingOrganizationTransferReasons || false;
};
const getEmptyHealthcareMetrics = ()=>({
        laborHoursSaved: 0,
        offHoursCalls: 0,
        offHoursScheduledAppts: 0,
        containedCallsCount: 0,
        totalEngagements: 0,
        newPatientBookings: 0,
        laborHoursSavedApps: [],
        offHoursApps: [],
        offHoursScheduledApptsApps: [],
        newPatientBookingsApps: [],
        containableCallsCount: 0
    });
const getEmptyFoodOrderingMetrics = ()=>({
        upsellSuccessRate: 0,
        successfulUpsells: 0,
        upsellAttempts: 0,
        averageTicketSize: 0,
        totalSold: 0,
        questionsAnswered: 0,
        laborHoursSaved: 0,
        upsellApps: [],
        ticketApps: [],
        questionsApps: [],
        laborHoursSavedApps: []
    });
const getEmptyHistogramDataset = (id, color)=>({
        id,
        color,
        data: []
    });
const transformToConversionFunnelData = (metrics, colors)=>{
    if (!metrics) return getEmptyConversionFunnelData(colors);
    return [
        {
            id: "total-calls",
            label: "Total Calls",
            value: metrics.totalCalls ?? 0,
            color: colors.totalCalls,
            apps: transformAppBreakdowns(metrics.totalCallsApps)
        },
        {
            id: "order-attempts",
            label: "Containable Conversations (Order Attempts)",
            value: metrics.containableCalls ?? metrics.orderAttempts ?? 0,
            color: colors.orderAttempts,
            apps: transformAppBreakdowns(metrics.containableCallsApps ?? metrics.orderAttemptsApps)
        },
        {
            id: "placed-orders",
            label: "Contained Conversations (Placed Orders)",
            value: metrics.containedCalls ?? metrics.ordersPlaced ?? 0,
            color: colors.ordersPlaced,
            apps: transformAppBreakdowns(metrics.containedCallsApps ?? metrics.ordersPlacedApps)
        }
    ];
};
const transformEngagementsToConversionFunnel = (engagements, colors, appNameMap)=>{
    if (!engagements || engagements.length === 0) return getEmptyConversionFunnelData(colors);
    // Count totals and group by application
    const totalCount = engagements.length;
    const actionAttemptedEngagements = engagements.filter((e)=>e.sessionCategory == "ACTION_ATTEMPTED");
    const orderPlacedEngagements = engagements.filter((e)=>e.sessionTags?.includes("ACTION_COMPLETED"));
    // Aggregate by application for total calls
    const totalCallsApps = aggregateEngagementsByAppForFunnel(engagements, appNameMap);
    // Aggregate by application for containable calls
    const containableApps = aggregateEngagementsByAppForFunnel(actionAttemptedEngagements, appNameMap);
    // Aggregate by application for contained calls
    const containedApps = aggregateEngagementsByAppForFunnel(orderPlacedEngagements, appNameMap);
    return [
        {
            id: "total-calls",
            label: "Total Calls",
            value: totalCount,
            color: colors.totalCalls,
            apps: totalCallsApps
        },
        {
            id: "order-attempts",
            label: "Order Attempts",
            value: actionAttemptedEngagements.length,
            color: colors.orderAttempts,
            apps: containableApps
        },
        {
            id: "placed-orders",
            label: "Placed Orders",
            value: orderPlacedEngagements.length,
            color: colors.ordersPlaced,
            apps: containedApps
        }
    ];
};
/**
 * Helper function to aggregate engagements by application for funnel chart
 */ const aggregateEngagementsByAppForFunnel = (engagements, appNameMap)=>{
    const appCounts = new Map();
    engagements.forEach((engagement)=>{
        const appId = engagement.applicationId || "unknown";
        const existing = appCounts.get(appId) || {
            appId,
            count: 0
        };
        existing.count++;
        appCounts.set(appId, existing);
    });
    return Array.from(appCounts.entries()).map(([appId, data])=>({
            appName: appNameMap && appNameMap[appId] || appId,
            count: data.count
        }));
};
const getEmptyConversionFunnelData = (colors)=>[
        {
            id: "total-calls",
            label: "Total Calls",
            value: 0,
            color: colors.totalCalls,
            apps: []
        },
        {
            id: "order-attempts",
            label: "Order Attempts",
            value: 0,
            color: colors.orderAttempts,
            apps: []
        },
        {
            id: "placed-orders",
            label: "Placed Orders",
            value: 0,
            color: colors.ordersPlaced,
            apps: []
        }
    ];
const calculateOrderCompletionRate = (funnelData)=>{
    const totalCalls = funnelData.find((d)=>d.id === "total-calls")?.value ?? 0;
    const ordersPlaced = funnelData.find((d)=>d.id === "placed-orders")?.value ?? 0;
    if (totalCalls === 0) return 0;
    return ordersPlaced / totalCalls * 100;
};
// ==================== PATIENT BOOKINGS TRANSFORMATIONS ====================
/**
 * Patient booking data format for the pie/bar chart
 */ /**
 * Aggregate engagements by application to get app-level counts
 */ const aggregateEngagementsByApp = (engagements, appNameMap)=>{
    const appCounts = new Map();
    engagements.forEach((engagement)=>{
        // Resolve app name: try applicationName first, then lookup by applicationId, then location, then 'Unknown'
        const appName = engagement.applicationName || (appNameMap && engagement.applicationId ? appNameMap[engagement.applicationId] : null) || engagement.location || "Unknown";
        const existing = appCounts.get(appName) || {
            count: 0,
            english: 0,
            spanish: 0
        };
        existing.count++;
        // Check if engagement has Spanish tag (use sessionTags with fallback to tags)
        const tags = engagement.sessionTags || engagement.tags || [];
        const isSpanish = tags.includes("SPANISH");
        if (isSpanish) existing.spanish++;
        else existing.english++;
        appCounts.set(appName, existing);
    });
    return Array.from(appCounts.entries()).map(([appName, data])=>({
            appName,
            count: data.count,
            english: data.english,
            spanish: data.spanish
        }));
};
/**
 * Check if an engagement has the NEW_PATIENT tag
 */ const isNewPatient = (engagement)=>{
    const tags = engagement.sessionTags || engagement.tags || [];
    return tags.includes("NEW_PATIENT");
};
const transformEngagementsToPatientBookings = (scheduledEngagements, colors, appNameMap)=>{
    if (!scheduledEngagements || scheduledEngagements.length === 0) return [
        {
            id: "New Patient",
            label: "New Patient",
            value: 0,
            color: colors.newPatient,
            apps: []
        },
        {
            id: "Existing Patient",
            label: "Existing Patient",
            value: 0,
            color: colors.existingPatient,
            apps: []
        }
    ];
    // Separate engagements by new vs existing patient
    const newPatientEngagements = scheduledEngagements.filter(isNewPatient);
    const existingPatientEngagements = scheduledEngagements.filter((e)=>!isNewPatient(e));
    return [
        {
            id: "New Patient",
            label: "New Patient",
            value: newPatientEngagements.length,
            color: colors.newPatient,
            apps: aggregateEngagementsByApp(newPatientEngagements, appNameMap)
        },
        {
            id: "Existing Patient",
            label: "Existing Patient",
            value: existingPatientEngagements.length,
            color: colors.existingPatient,
            apps: aggregateEngagementsByApp(existingPatientEngagements, appNameMap)
        }
    ];
};
const transformEngagementsToSchedulingEvents = (scheduledEngagements, rescheduledEngagements, cancelledEngagements, checkNextApptEngagements, color, appNameMap)=>{
    return [
        {
            type: "Schedule",
            count: scheduledEngagements?.length ?? 0,
            color,
            apps: aggregateEngagementsByApp(scheduledEngagements || [], appNameMap)
        },
        {
            type: "Reschedule",
            count: rescheduledEngagements?.length ?? 0,
            color,
            apps: aggregateEngagementsByApp(rescheduledEngagements || [], appNameMap)
        },
        {
            type: "Cancel",
            count: cancelledEngagements?.length ?? 0,
            color,
            apps: aggregateEngagementsByApp(cancelledEngagements || [], appNameMap)
        },
        {
            type: "Check Appt",
            count: checkNextApptEngagements?.length ?? 0,
            color,
            apps: aggregateEngagementsByApp(checkNextApptEngagements || [], appNameMap)
        }
    ];
};
const calculateTotalBookings = (data)=>{
    if (!data) return 0;
    return data.reduce((sum, item)=>sum + item.value, 0);
};
const transformTopLevelMetricsToSchedulingEvents = (perAppMetrics, color, appNameMap, applicationIds, spanishOnly)=>{
    if (!perAppMetrics || typeof perAppMetrics !== "object") return [];
    // Convert to Set for efficient lookup
    // When applicationIds is undefined/null, include all apps (initial state before apps load)
    // When applicationIds is an empty Set/Array, return empty (user deselected all)
    let appIdSet = null;
    if (applicationIds !== undefined && applicationIds !== null) {
        if (applicationIds instanceof Set) {
            if (applicationIds.size === 0) return []; // Empty filter = no data
            appIdSet = applicationIds;
        } else {
            if (applicationIds.length === 0) return []; // Empty filter = no data
            appIdSet = new Set(applicationIds);
        }
    }
    // Helper to aggregate metrics for a specific event type
    const aggregateEventType = (getAttempts, getCompleted)=>{
        let totalAttempts = 0;
        let totalCompleted = 0;
        const completedApps = [];
        const notCompletedApps = [];
        for (const [appId, metrics] of Object.entries(perAppMetrics)){
            // Skip if filtering and this app is not selected
            if (appIdSet && !appIdSet.has(appId)) continue;
            if (metrics) {
                const attempts = getAttempts(metrics);
                const completed = getCompleted(metrics);
                // When spanishOnly is true, only use Spanish metrics
                const attemptsTotal = spanishOnly ? attempts.spanish : attempts.english + attempts.spanish;
                const completedTotal = spanishOnly ? completed.spanish : completed.english + completed.spanish;
                const notCompletedTotal = attemptsTotal - completedTotal;
                totalAttempts += attemptsTotal;
                totalCompleted += completedTotal;
                // App name lookup - appNameMap is Record<string, string>
                const appName = appNameMap?.[appId] || appId;
                // Add to completed apps if there are completed events
                if (completedTotal > 0) completedApps.push({
                    appName,
                    count: completedTotal,
                    english: spanishOnly ? 0 : completed.english,
                    spanish: completed.spanish
                });
                // Add to not-completed apps (attempts - completed) if there are any
                if (notCompletedTotal > 0) notCompletedApps.push({
                    appName,
                    count: notCompletedTotal,
                    english: spanishOnly ? 0 : Math.max(0, attempts.english - completed.english),
                    spanish: Math.max(0, attempts.spanish - completed.spanish)
                });
            }
        }
        return {
            totalAttempts,
            totalCompleted,
            notCompleted: totalAttempts - totalCompleted,
            completedApps,
            notCompletedApps
        };
    };
    // Schedule events
    const schedule = aggregateEventType((m)=>({
            english: m.totalScheduleAttemptsEnglish ?? 0,
            spanish: m.totalScheduleAttemptsSpanish ?? 0
        }), (m)=>({
            english: m.totalSchedulesCompletedEnglish ?? 0,
            spanish: m.totalSchedulesCompletedSpanish ?? 0
        }));
    // Reschedule events
    const reschedule = aggregateEventType((m)=>({
            english: m.totalRescheduleAttemptsEnglish ?? 0,
            spanish: m.totalRescheduleAttemptsSpanish ?? 0
        }), (m)=>({
            english: m.totalReschedulesCompletedEnglish ?? 0,
            spanish: m.totalReschedulesCompletedSpanish ?? 0
        }));
    // Cancel events
    const cancel = aggregateEventType((m)=>({
            english: m.totalCancellationAttemptsEnglish ?? 0,
            spanish: m.totalCancellationAttemptsSpanish ?? 0
        }), (m)=>({
            english: m.totalCancellationsCompletedEnglish ?? 0,
            spanish: m.totalCancellationsCompletedSpanish ?? 0
        }));
    // Check appointment events
    const checkAppt = aggregateEventType((m)=>({
            english: m.totalCheckNextAppointmentAttemptsEnglish ?? 0,
            spanish: m.totalCheckNextAppointmentAttemptsSpanish ?? 0
        }), (m)=>({
            english: m.totalCheckNextAppointmentCompletedEnglish ?? 0,
            spanish: m.totalCheckNextAppointmentCompletedSpanish ?? 0
        }));
    return [
        {
            type: "Schedule",
            count: schedule.totalCompleted,
            color,
            apps: schedule.completedApps,
            notContainedCount: schedule.notCompleted,
            notContainedApps: schedule.notCompletedApps
        },
        {
            type: "Reschedule",
            count: reschedule.totalCompleted,
            color,
            apps: reschedule.completedApps,
            notContainedCount: reschedule.notCompleted,
            notContainedApps: reschedule.notCompletedApps
        },
        {
            type: "Cancel",
            count: cancel.totalCompleted,
            color,
            apps: cancel.completedApps,
            notContainedCount: cancel.notCompleted,
            notContainedApps: cancel.notCompletedApps
        },
        {
            type: "Check Appt",
            count: checkAppt.totalCompleted,
            color,
            apps: checkAppt.completedApps,
            notContainedCount: checkAppt.notCompleted,
            notContainedApps: checkAppt.notCompletedApps
        }
    ];
};

},{"moment":"2meyw","../components/charts/TransfersChart":"4lkvB","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4lkvB":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TransferReason", ()=>TransferReason);
parcelHelpers.export(exports, "TRANSFER_REASON_LABELS", ()=>TRANSFER_REASON_LABELS);
parcelHelpers.export(exports, "TRANSFER_REASON_SHORT_LABELS", ()=>TRANSFER_REASON_SHORT_LABELS);
parcelHelpers.export(exports, "TRANSFER_REASON_IS_PLANNED", ()=>TRANSFER_REASON_IS_PLANNED);
parcelHelpers.export(exports, "TransfersChart", ()=>TransfersChart);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _reactDom = require("react-dom");
var _reactDomDefault = parcelHelpers.interopDefault(_reactDom);
var _bar = require("@nivo/bar");
var _colors = require("../../constants/colors");
var _chartTheme = require("../../constants/chartTheme");
let TransferReason = /*#__PURE__*/ function(TransferReason) {
    TransferReason["IMMEDIATE_TRANSFER"] = "IMMEDIATE_TRANSFER";
    TransferReason["UNSUPPORTED_APPOINTMENT_TYPE"] = "UNSUPPORTED_APPOINTMENT_TYPE";
    TransferReason["POS_CONNECTION_ISSUE"] = "POS_CONNECTION_ISSUE";
    TransferReason["PAYMENT_LINK_REFUSED"] = "PAYMENT_LINK_REFUSED";
    TransferReason["PRICING_ISSUE"] = "PRICING_ISSUE";
    TransferReason["END_OF_CALL_TRANSFER"] = "END_OF_CALL_TRANSFER";
    TransferReason["FAQ_CONFIGURED_TRANSFER"] = "FAQ_CONFIGURED_TRANSFER";
    TransferReason["UNSUPPORTED_REQUEST"] = "UNSUPPORTED_REQUEST";
    TransferReason["AI_ISSUE"] = "AI_ISSUE";
    TransferReason["OFF_HOURS_TRANSFER"] = "OFF_HOURS_TRANSFER";
    TransferReason["CUSTOMER_FRUSTRATED"] = "CUSTOMER_FRUSTRATED";
    TransferReason["CALLER_REQUESTED_TRANSFER"] = "CALLER_REQUESTED_TRANSFER";
    TransferReason["UNKNOWN"] = "UNKNOWN";
    return TransferReason;
}({});
const TRANSFER_REASON_LABELS = {
    [TransferReason.IMMEDIATE_TRANSFER]: "Immediate Transfer",
    [TransferReason.UNSUPPORTED_APPOINTMENT_TYPE]: "Unsupported Appointment Type",
    [TransferReason.POS_CONNECTION_ISSUE]: "POS Connection Issue",
    [TransferReason.PAYMENT_LINK_REFUSED]: "Payment Link Refused",
    [TransferReason.PRICING_ISSUE]: "Pricing Issue",
    [TransferReason.END_OF_CALL_TRANSFER]: "End of Call Transfer",
    [TransferReason.FAQ_CONFIGURED_TRANSFER]: "FAQ Configured Transfer",
    [TransferReason.UNSUPPORTED_REQUEST]: "Unsupported Request",
    [TransferReason.AI_ISSUE]: "AI Issue",
    [TransferReason.OFF_HOURS_TRANSFER]: "Off-Hours Transfer",
    [TransferReason.CUSTOMER_FRUSTRATED]: "Customer Frustrated",
    [TransferReason.CALLER_REQUESTED_TRANSFER]: "Caller Requested Transfer",
    [TransferReason.UNKNOWN]: "Undetermined"
};
const TRANSFER_REASON_SHORT_LABELS = {
    [TransferReason.IMMEDIATE_TRANSFER]: "Immediate",
    [TransferReason.UNSUPPORTED_APPOINTMENT_TYPE]: "Unsupported Appt",
    [TransferReason.POS_CONNECTION_ISSUE]: "POS Issue",
    [TransferReason.PAYMENT_LINK_REFUSED]: "Payment Refused",
    [TransferReason.PRICING_ISSUE]: "Pricing Issue",
    [TransferReason.END_OF_CALL_TRANSFER]: "End of Call",
    [TransferReason.FAQ_CONFIGURED_TRANSFER]: "FAQ Transfer",
    [TransferReason.UNSUPPORTED_REQUEST]: "Unsupported Req",
    [TransferReason.AI_ISSUE]: "AI Issue",
    [TransferReason.OFF_HOURS_TRANSFER]: "Off-Hours",
    [TransferReason.CUSTOMER_FRUSTRATED]: "Frustrated",
    [TransferReason.CALLER_REQUESTED_TRANSFER]: "Caller Request",
    [TransferReason.UNKNOWN]: "Undetermined"
};
const TRANSFER_REASON_IS_PLANNED = {
    [TransferReason.IMMEDIATE_TRANSFER]: true,
    [TransferReason.UNSUPPORTED_APPOINTMENT_TYPE]: true,
    [TransferReason.POS_CONNECTION_ISSUE]: false,
    [TransferReason.PAYMENT_LINK_REFUSED]: true,
    [TransferReason.PRICING_ISSUE]: true,
    [TransferReason.END_OF_CALL_TRANSFER]: false,
    [TransferReason.FAQ_CONFIGURED_TRANSFER]: true,
    [TransferReason.UNSUPPORTED_REQUEST]: true,
    [TransferReason.AI_ISSUE]: false,
    [TransferReason.OFF_HOURS_TRANSFER]: true,
    [TransferReason.CUSTOMER_FRUSTRATED]: false,
    [TransferReason.CALLER_REQUESTED_TRANSFER]: true,
    [TransferReason.UNKNOWN]: null // Maps to Undetermined
};
// Transfer category types
// App breakdown for transfer reasons
// Data structure for a transfer reason with app breakdown
// Data structure for stacked bar (original format)
// Data structure for horizontal bar with glass styling
// Color palette for Planned transfers (blues)
const PLANNED_COLORS = [
    {
        fill: "rgba(14, 133, 187, 0.75)",
        border: (0, _colors.chart_blue_2)
    },
    {
        fill: "rgba(27, 165, 220, 0.70)",
        border: (0, _colors.chart_blue_3)
    },
    {
        fill: "rgba(46, 184, 232, 0.65)",
        border: (0, _colors.chart_blue_4)
    },
    {
        fill: "rgba(68, 190, 236, 0.60)",
        border: (0, _colors.chart_blue_5)
    },
    {
        fill: "rgba(94, 200, 239, 0.55)",
        border: (0, _colors.chart_blue_6)
    },
    {
        fill: "rgba(120, 210, 243, 0.50)",
        border: (0, _colors.chart_blue_7)
    },
    {
        fill: "rgba(133, 211, 244, 0.45)",
        border: (0, _colors.chart_blue_7)
    }
];
// Color palette for Unplanned transfers (slate/gray-blue tones)
const UNPLANNED_COLORS = [
    {
        fill: "rgba(71, 85, 105, 0.75)",
        border: (0, _colors.chart_slate_1)
    },
    {
        fill: "rgba(100, 116, 139, 0.70)",
        border: (0, _colors.chart_slate_2)
    },
    {
        fill: "rgba(120, 130, 150, 0.65)",
        border: "#788296"
    },
    {
        fill: "rgba(140, 150, 165, 0.60)",
        border: "#8c96a5"
    },
    {
        fill: "rgba(160, 170, 180, 0.55)",
        border: "#a0aab4"
    },
    {
        fill: "rgba(180, 185, 195, 0.50)",
        border: "#b4b9c3"
    }
];
// Color palette for Undetermined transfers (light blue tones from Voicify Studio)
const UNDETERMINED_COLORS = [
    {
        fill: "rgba(133, 211, 244, 0.75)",
        border: (0, _colors.voicify_spark_medium)
    },
    {
        fill: "rgba(190, 231, 249, 0.70)",
        border: (0, _colors.voicify_spark_light)
    },
    {
        fill: "rgba(226, 243, 252, 0.65)",
        border: (0, _colors.voicify_spark_lighter)
    },
    {
        fill: "rgba(241, 249, 254, 0.60)",
        border: "#d4f0fb"
    },
    {
        fill: "rgba(245, 251, 254, 0.55)",
        border: "#e2f3fc"
    },
    {
        fill: "rgba(250, 253, 255, 0.50)",
        border: "#f1f9fe"
    }
];
const defaultMargin = {
    top: 10,
    right: 50,
    bottom: 40,
    left: 110
};
const TransfersChart = ({ data, showAsPercentage = false, height = 340, enableGridY = true, axisBottomLegend, axisLeftLegend, showTotals = false, showLegend = false, margin = defaultMargin, onExportClick, exportButtonText, renderLegendTooltip, onBarClick, chartLayout = "horizontal-stacked", showCategoryLegend = true, spanishOnly = false, showLanguageBreakdown = true })=>{
    // Mobile detection for responsive axis ticks
    const [isMobile, setIsMobile] = (0, _react1.useState)(typeof window !== "undefined" ? window.innerWidth <= 640 : false);
    // Small laptop detection for legend font scaling (same pattern as ChartTooltip)
    const screenWidth = typeof window !== "undefined" ? window.innerWidth : 1920;
    const isChromebook = screenWidth >= 1024 && screenWidth < 1280;
    const isSmallLaptop = screenWidth >= 1280 && screenWidth < 1440;
    const legendFontSize = isChromebook ? "9px" : isSmallLaptop ? "10px" : "12px";
    const legendFontWeight500 = isChromebook ? 400 : 500;
    // Tooltip font sizes — same scaling ladder as ChartTooltip.tsx
    const ttTitle = isChromebook ? "11px" : isSmallLaptop ? "12px" : "14px";
    const ttValue = isChromebook ? "14px" : isSmallLaptop ? "15px" : "18px";
    const ttSubtitle = isChromebook ? "10px" : isSmallLaptop ? "11px" : "12px";
    const ttBody = isChromebook ? "10px" : isSmallLaptop ? "11px" : "12px";
    const ttSmall = isChromebook ? "9px" : isSmallLaptop ? "10px" : "11px";
    (0, _react1.useEffect)(()=>{
        if (typeof window === "undefined") return;
        const checkMobile = ()=>setIsMobile(window.innerWidth <= 640);
        checkMobile();
        window.addEventListener("resize", checkMobile);
        return ()=>window.removeEventListener("resize", checkMobile);
    }, []);
    // Build stacked bar data for grouped horizontal bars (Planned vs Unplanned only, Undetermined is just counted)
    const buildGroupedStackedData = ()=>{
        const barData = [];
        const reasonMeta = {};
        let plannedTotal = 0;
        let unplannedTotal = 0;
        let undeterminedTotal = 0;
        // Process each category
        data.forEach((categoryItem)=>{
            const category = categoryItem.category;
            const colorPalette = category === "Planned" ? PLANNED_COLORS : category === "Unplanned" ? UNPLANNED_COLORS : UNDETERMINED_COLORS;
            // Extract reasons and their values for this category
            const reasons = [];
            Object.keys(categoryItem).forEach((key)=>{
                if (key !== "category" && Object.values(TransferReason).includes(key)) {
                    const reasonData = categoryItem[key];
                    // Support both new format (object with value/apps) and old format (number)
                    const value = typeof reasonData === "number" ? reasonData : reasonData?.value ?? 0;
                    const apps = typeof reasonData === "object" && reasonData?.apps ? reasonData.apps : [];
                    if (value > 0) reasons.push({
                        key: key,
                        value,
                        apps
                    });
                }
            });
            // Sort by value descending so largest segments are at the bottom (start of bar)
            reasons.sort((a, b)=>b.value - a.value);
            // Create bar data entry for this category (only if it has reasons with data)
            if (reasons.length > 0) {
                // Create bar data entry for this category
                const barEntry = {
                    category
                };
                reasons.forEach((reason, index)=>{
                    const shortLabel = TRANSFER_REASON_SHORT_LABELS[reason.key];
                    barEntry[shortLabel] = reason.value;
                    // Store metadata for tooltip
                    const colorIndex = Math.min(index, colorPalette.length - 1);
                    reasonMeta[shortLabel] = {
                        fullLabel: TRANSFER_REASON_LABELS[reason.key],
                        shortLabel,
                        reasonKey: reason.key,
                        category,
                        fillColor: colorPalette[colorIndex].fill,
                        borderColor: colorPalette[colorIndex].border,
                        apps: reason.apps
                    };
                });
                barData.push(barEntry);
            }
            // Always count totals for all categories
            reasons.forEach((reason)=>{
                if (category === "Planned") plannedTotal += reason.value;
                else if (category === "Unplanned") unplannedTotal += reason.value;
                else undeterminedTotal += reason.value;
            });
        });
        // Get all unique reason keys for the stacked bar
        const allKeys = new Set();
        barData.forEach((entry)=>{
            Object.keys(entry).forEach((key)=>{
                if (key !== "category") allKeys.add(key);
            });
        });
        return {
            barData,
            keys: Array.from(allKeys),
            reasonMeta,
            categoryTotals: {
                planned: plannedTotal,
                unplanned: unplannedTotal,
                undetermined: undeterminedTotal
            }
        };
    };
    const { barData, keys, reasonMeta, categoryTotals } = buildGroupedStackedData();
    const totalTransfers = categoryTotals.planned + categoryTotals.unplanned + categoryTotals.undetermined;
    // Calculate max value for axis and generate mobile-friendly tick values
    const horizontalMaxValue = (0, _react1.useMemo)(()=>{
        let maxVal = 0;
        barData.forEach((row)=>{
            let rowTotal = 0;
            keys.forEach((key)=>{
                if (typeof row[key] === "number") rowTotal += row[key];
            });
            if (rowTotal > maxVal) maxVal = rowTotal;
        });
        return maxVal;
    }, [
        barData,
        keys
    ]);
    // Generate fewer tick values for mobile (3-4 ticks max)
    const mobileTickValues = (0, _react1.useMemo)(()=>{
        if (horizontalMaxValue === 0) return [
            0
        ];
        // Round up to a nice number
        const niceMax = Math.ceil(horizontalMaxValue / 100) * 100;
        const step = Math.ceil(niceMax / 3 / 100) * 100; // 3 intervals
        const ticks = [];
        for(let i = 0; i <= niceMax; i += step)ticks.push(i);
        return ticks;
    }, [
        horizontalMaxValue
    ]);
    // Build vertical bar data for individual bars per transfer reason (used for vertical-by-reason layout)
    const buildVerticalBarData = ()=>{
        const verticalBarData = [];
        const verticalReasonMeta = {};
        // Collect all reasons across all categories
        const allReasons = [];
        data.forEach((categoryItem)=>{
            const category = categoryItem.category;
            Object.keys(categoryItem).forEach((key)=>{
                if (key !== "category" && Object.values(TransferReason).includes(key)) {
                    const reasonData = categoryItem[key];
                    const value = typeof reasonData === "number" ? reasonData : reasonData?.value ?? 0;
                    const apps = typeof reasonData === "object" && reasonData?.apps ? reasonData.apps : [];
                    if (value > 0) allReasons.push({
                        key: key,
                        value,
                        apps,
                        category
                    });
                }
            });
        });
        // Sort by value descending
        allReasons.sort((a, b)=>b.value - a.value);
        // Build bar data and metadata for each reason
        allReasons.forEach((reason, index)=>{
            const shortLabel = TRANSFER_REASON_SHORT_LABELS[reason.key];
            const colorPalette = reason.category === "Planned" ? PLANNED_COLORS : reason.category === "Unplanned" ? UNPLANNED_COLORS : UNDETERMINED_COLORS;
            const colorIndex = Math.min(index % colorPalette.length, colorPalette.length - 1);
            verticalBarData.push({
                reason: shortLabel,
                value: reason.value,
                category: reason.category
            });
            verticalReasonMeta[shortLabel] = {
                fullLabel: TRANSFER_REASON_LABELS[reason.key],
                shortLabel,
                reasonKey: reason.key,
                category: reason.category,
                fillColor: colorPalette[colorIndex].fill,
                borderColor: colorPalette[colorIndex].border,
                apps: reason.apps
            };
        });
        return {
            verticalBarData,
            verticalReasonMeta
        };
    };
    const { verticalBarData, verticalReasonMeta } = chartLayout === "vertical-by-reason" ? buildVerticalBarData() : {
        verticalBarData: [],
        verticalReasonMeta: {}
    };
    // Use appropriate metadata based on layout
    const activeReasonMeta = chartLayout === "vertical-by-reason" ? verticalReasonMeta : reasonMeta;
    // Get color for a bar segment based on its key and category
    const getBarColor = (bar)=>{
        const meta = activeReasonMeta[bar.id] || activeReasonMeta[bar.indexValue];
        return meta?.fillColor || (0, _chartTheme.chartGlassBlues)[0];
    };
    // Portal-based tooltip component that follows cursor
    const PortalTooltip = ({ id, value, indexValue })=>{
        const [position, setPosition] = (0, _reactDefault.default).useState({
            x: 0,
            y: 0
        });
        // For vertical layout, the reason is in indexValue; for horizontal, it's in id
        const meta = activeReasonMeta[id] || activeReasonMeta[indexValue];
        (0, _reactDefault.default).useEffect(()=>{
            // Skip mouse tracking for mobile compact mode
            if (isMobile) return;
            const handleMouseMove = (e)=>{
                setPosition({
                    x: e.clientX,
                    y: e.clientY
                });
            };
            document.addEventListener("mousemove", handleMouseMove);
            return ()=>document.removeEventListener("mousemove", handleMouseMove);
        }, [
            isMobile
        ]);
        if (!meta) return null;
        const percentage = totalTransfers > 0 ? (value / totalTransfers * 100).toFixed(1) : "0";
        const categoryTotal = meta.category === "Planned" ? categoryTotals.planned : meta.category === "Unplanned" ? categoryTotals.unplanned : categoryTotals.undetermined;
        const categoryPercentage = categoryTotal > 0 ? (value / categoryTotal * 100).toFixed(1) : "0";
        // Compact mode for mobile - render inline simplified tooltip
        if (isMobile) return (0, _react.jsx)("div", {
            style: {
                background: "rgba(255, 255, 255, 0.95)",
                backdropFilter: "blur(8px)",
                padding: "10px 14px",
                borderRadius: "10px",
                boxShadow: "0 4px 20px rgba(0, 0, 0, 0.12), 0 0 0 1px rgba(0, 0, 0, 0.05)",
                border: `1px solid ${(0, _colors.color_shades_light)}`,
                maxWidth: "200px",
                textAlign: "center"
            }
        }, (0, _react.jsx)("div", {
            style: {
                marginBottom: 4
            }
        }, (0, _react.jsx)("span", {
            style: {
                ...(0, _chartTheme.tooltipStyles).value,
                fontSize: "14px"
            }
        }, value.toLocaleString()), (0, _react.jsx)("span", {
            style: {
                ...(0, _chartTheme.tooltipStyles).subtitle,
                marginLeft: 4,
                fontSize: "11px"
            }
        }, "transfers")), (0, _react.jsx)("div", {
            style: {
                ...(0, _chartTheme.tooltipStyles).subtitle,
                fontSize: "10px",
                lineHeight: 1.3
            }
        }, percentage, "% of all • ", meta.category), onBarClick && (0, _react.jsx)("div", {
            style: {
                fontSize: "10px",
                color: (0, _colors.color_text_link),
                fontStyle: "italic",
                marginTop: 6
            }
        }, "This view is limited on Mobile. Open on Desktop for full details."));
        // Position tooltip to the left of cursor
        const tooltipWidth = 280;
        const padding = 15;
        const tooltipContent = (0, _react.jsx)("div", {
            style: {
                position: "fixed",
                left: position.x - tooltipWidth - padding,
                top: position.y - 10,
                background: "rgba(255, 255, 255, 0.95)",
                backdropFilter: "blur(8px)",
                padding: "12px 16px",
                borderRadius: "10px",
                boxShadow: "0 4px 20px rgba(0, 0, 0, 0.12), 0 0 0 1px rgba(0, 0, 0, 0.05)",
                border: `1px solid ${(0, _colors.color_shades_light)}`,
                minWidth: "180px",
                zIndex: 99999,
                pointerEvents: "none"
            }
        }, (0, _react.jsx)("div", {
            style: {
                ...(0, _chartTheme.tooltipStyles).title,
                fontSize: ttTitle,
                display: "flex",
                alignItems: "center",
                gap: "8px"
            }
        }, (0, _react.jsx)("span", null, meta.fullLabel), spanishOnly && (0, _react.jsx)("span", {
            style: {
                display: "inline-flex",
                alignItems: "center",
                justifyContent: "center",
                background: (0, _colors.voicify_spark_darker),
                color: "white",
                fontSize: "9px",
                fontWeight: 700,
                padding: "2px 5px",
                borderRadius: "3px",
                letterSpacing: "0.5px",
                flexShrink: 0
            }
        }, "ES")), (0, _react.jsx)("div", {
            style: {
                display: "flex",
                alignItems: "center",
                gap: "8px",
                marginBottom: "6px"
            }
        }, (0, _react.jsx)("div", {
            style: {
                ...(0, _chartTheme.tooltipStyles).colorIndicator,
                backgroundColor: meta.fillColor,
                border: `2px solid ${meta.borderColor}`
            }
        }), (0, _react.jsx)("span", {
            style: {
                ...(0, _chartTheme.tooltipStyles).value,
                fontSize: ttValue
            }
        }, value.toLocaleString()), (0, _react.jsx)("span", {
            style: {
                ...(0, _chartTheme.tooltipStyles).subtitle,
                fontSize: ttSubtitle
            }
        }, "transfers")), (0, _react.jsx)("div", {
            style: {
                ...(0, _chartTheme.tooltipStyles).subtitle,
                fontSize: ttSubtitle
            }
        }, percentage, "% of all transfers"), (0, _react.jsx)("div", {
            style: {
                fontSize: ttSmall,
                color: meta.category === "Planned" ? (0, _colors.chart_blue_2) : meta.category === "Unplanned" ? (0, _colors.chart_slate_1) : (0, _colors.voicify_spark_medium),
                fontWeight: 500,
                marginTop: "8px",
                paddingTop: "8px",
                borderTop: `1px solid ${(0, _colors.color_shades_light)}`
            }
        }, meta.category, " Transfer • ", categoryPercentage, "% of ", meta.category.toLowerCase()), meta.apps && meta.apps.length > 0 && (0, _react.jsx)("div", {
            style: {
                borderTop: `1px solid ${(0, _colors.color_shades_light)}`,
                paddingTop: "8px",
                marginTop: "8px"
            }
        }, (0, _react.jsx)("div", {
            style: {
                fontSize: ttSmall,
                color: (0, _colors.color_shades_darker),
                marginBottom: "6px",
                fontWeight: 600,
                textTransform: "uppercase",
                letterSpacing: "0.5px"
            }
        }, "By Location:"), [
            ...meta.apps
        ].sort((a, b)=>b.count - a.count).slice(0, 5).map((app, index)=>{
            const hasLanguageBreakdown = showLanguageBreakdown && (app.english !== undefined && app.english > 0 || app.spanish !== undefined && app.spanish > 0);
            return (0, _react.jsx)("div", {
                key: index,
                style: {
                    padding: "3px 0",
                    fontSize: ttBody,
                    color: (0, _colors.color_shades_darker),
                    display: "flex",
                    justifyContent: "space-between",
                    flexDirection: hasLanguageBreakdown && !spanishOnly ? "column" : "row"
                }
            }, (0, _react.jsx)("div", {
                style: {
                    display: "flex",
                    justifyContent: "space-between",
                    width: "100%"
                }
            }, (0, _react.jsx)("span", {
                style: {
                    flex: 1,
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                    marginRight: "8px"
                }
            }, app.appName), (0, _react.jsx)("span", {
                style: {
                    fontWeight: 600,
                    color: (0, _colors.color_shades_darkest)
                }
            }, app.count)), hasLanguageBreakdown && !spanishOnly && (0, _react.jsx)("div", {
                style: {
                    display: "flex",
                    gap: "12px",
                    fontSize: ttSubtitle,
                    color: (0, _colors.color_shades_darker),
                    marginTop: "2px",
                    paddingLeft: "8px"
                }
            }, app.english !== undefined && app.english > 0 && (0, _react.jsx)("span", null, "EN: ", app.english), app.spanish !== undefined && app.spanish > 0 && (0, _react.jsx)("span", {
                style: {
                    color: (0, _colors.chart_blue_2)
                }
            }, "ES: ", app.spanish)));
        }), meta.apps.length > 5 && (0, _react.jsx)("div", {
            style: {
                fontSize: ttSmall,
                color: (0, _colors.color_shades_darker),
                fontStyle: "italic",
                marginTop: "4px"
            }
        }, "+", meta.apps.length - 5, " more locations")), onBarClick && (0, _react.jsx)("div", {
            style: {
                borderTop: `1px solid ${(0, _colors.color_shades_light)}`,
                paddingTop: "8px",
                marginTop: "8px",
                fontSize: "11px",
                color: (0, _colors.color_text_link),
                fontStyle: "italic",
                textAlign: "center"
            }
        }, "Click to see more data"));
        return /*#__PURE__*/ (0, _reactDomDefault.default).createPortal(tooltipContent, document.body);
    };
    // Custom tooltip wrapper for nivo
    const CustomTooltip = ({ id, value, indexValue, data: barData })=>{
        return (0, _react.jsx)(PortalTooltip, {
            id: id,
            value: value,
            indexValue: indexValue,
            data: barData
        });
    };
    return (0, _react.jsx)("div", {
        style: {
            height,
            display: "flex",
            flexDirection: "column"
        }
    }, showCategoryLegend && (0, _react.jsx)("div", {
        style: {
            display: "flex",
            justifyContent: "flex-end",
            alignItems: "center",
            marginBottom: "12px",
            paddingLeft: margin.left,
            paddingRight: margin.right
        }
    }, (0, _react.jsx)("div", {
        style: {
            display: "flex",
            gap: isChromebook ? "12px" : isSmallLaptop ? "16px" : "24px"
        }
    }, (0, _react.jsx)("div", {
        style: {
            display: "flex",
            alignItems: "center",
            gap: "6px"
        }
    }, (0, _react.jsx)("div", {
        style: {
            width: "12px",
            height: "12px",
            borderRadius: "3px",
            backgroundColor: PLANNED_COLORS[0].fill,
            border: `2px solid ${PLANNED_COLORS[0].border}`
        }
    }), (0, _react.jsx)("span", {
        style: {
            fontSize: legendFontSize,
            fontWeight: legendFontWeight500,
            color: (0, _colors.color_shades_darker)
        }
    }, "Planned"), renderLegendTooltip && renderLegendTooltip("Planned"), (0, _react.jsx)("span", {
        style: {
            fontSize: legendFontSize,
            fontWeight: 600,
            color: (0, _colors.chart_blue_2)
        }
    }, categoryTotals.planned)), (0, _react.jsx)("div", {
        style: {
            display: "flex",
            alignItems: "center",
            gap: "6px"
        }
    }, (0, _react.jsx)("div", {
        style: {
            width: "12px",
            height: "12px",
            borderRadius: "3px",
            backgroundColor: UNPLANNED_COLORS[0].fill,
            border: `2px solid ${UNPLANNED_COLORS[0].border}`
        }
    }), (0, _react.jsx)("span", {
        style: {
            fontSize: legendFontSize,
            fontWeight: legendFontWeight500,
            color: (0, _colors.color_shades_darker)
        }
    }, "Unplanned"), renderLegendTooltip && renderLegendTooltip("Unplanned"), (0, _react.jsx)("span", {
        style: {
            fontSize: legendFontSize,
            fontWeight: 600,
            color: (0, _colors.chart_slate_1)
        }
    }, categoryTotals.unplanned)), categoryTotals.undetermined > 0 && (0, _react.jsx)("div", {
        style: {
            display: "flex",
            alignItems: "center",
            gap: "6px"
        }
    }, (0, _react.jsx)("div", {
        style: {
            width: "12px",
            height: "12px",
            borderRadius: "3px",
            backgroundColor: UNDETERMINED_COLORS[0].fill,
            border: `2px solid ${UNDETERMINED_COLORS[0].border}`
        }
    }), (0, _react.jsx)("span", {
        style: {
            fontSize: legendFontSize,
            fontWeight: legendFontWeight500,
            color: (0, _colors.color_shades_darker)
        }
    }, "Undetermined"), renderLegendTooltip && renderLegendTooltip("Undetermined"), (0, _react.jsx)("span", {
        style: {
            fontSize: legendFontSize,
            fontWeight: 600,
            color: (0, _colors.voicify_spark_medium)
        }
    }, categoryTotals.undetermined))), onExportClick && (0, _react.jsx)("button", {
        onClick: onExportClick,
        style: {
            padding: "6px 14px",
            background: "#2C3D52",
            color: "white",
            border: "none",
            borderRadius: "16px",
            fontSize: "11px",
            fontWeight: 600,
            cursor: "pointer",
            whiteSpace: "nowrap",
            transition: "all 0.2s ease"
        },
        onMouseEnter: (e)=>{
            e.currentTarget.style.background = "#3a5068";
            e.currentTarget.style.boxShadow = "0 2px 8px rgba(0, 0, 0, 0.15)";
        },
        onMouseLeave: (e)=>{
            e.currentTarget.style.background = "#2C3D52";
            e.currentTarget.style.boxShadow = "none";
        }
    }, exportButtonText || "View Details")), chartLayout === "horizontal-stacked" && (0, _react.jsx)("div", {
        style: {
            flex: 1,
            minHeight: 0
        }
    }, (0, _react.jsx)((0, _bar.ResponsiveBar), {
        data: barData,
        keys: keys,
        indexBy: "category",
        layout: "horizontal",
        margin: {
            ...margin,
            top: 0
        },
        padding: 0.4,
        valueScale: {
            type: "linear"
        },
        indexScale: {
            type: "band",
            round: true
        },
        colors: getBarColor,
        borderRadius: 0,
        borderWidth: 0,
        axisTop: null,
        axisRight: null,
        axisBottom: {
            tickSize: 5,
            tickPadding: 5,
            tickRotation: 0,
            tickValues: isMobile ? mobileTickValues : undefined,
            legend: axisBottomLegend,
            legendPosition: "middle",
            legendOffset: 32,
            renderTick: (tick)=>(0, _react.jsx)("g", {
                    transform: `translate(${tick.x},${tick.y})`
                }, (0, _react.jsx)("text", {
                    textAnchor: "middle",
                    dominantBaseline: "hanging",
                    style: {
                        fontSize: "10px",
                        fill: (0, _colors.color_shades_darker),
                        fontWeight: 500
                    }
                }, tick.value))
        },
        axisLeft: {
            tickSize: 0,
            tickPadding: 16,
            tickRotation: 0,
            renderTick: (tick)=>(0, _react.jsx)("g", {
                    transform: `translate(${tick.x - 8},${tick.y})`
                }, (0, _react.jsx)("text", {
                    textAnchor: "end",
                    dominantBaseline: "middle",
                    style: {
                        fontSize: "11px",
                        fill: tick.value === "Planned" ? (0, _colors.chart_blue_2) : tick.value === "Unplanned" ? (0, _colors.chart_slate_1) : (0, _colors.voicify_spark_medium),
                        fontWeight: 600
                    }
                }, tick.value))
        },
        enableGridX: (0, _chartTheme.barChartDefaults).enableGridX,
        enableGridY: false,
        enableLabel: false,
        theme: (0, _chartTheme.nivoChartTheme),
        tooltip: CustomTooltip,
        onClick: (bar)=>{
            if (onBarClick) {
                const meta = activeReasonMeta[bar.id];
                if (meta) onBarClick({
                    reason: meta.fullLabel,
                    reasonKey: meta.reasonKey,
                    value: bar.value,
                    category: meta.category,
                    apps: meta.apps
                });
            }
        },
        role: "img",
        ariaLabel: "Transfers by reason grouped horizontal stacked bar chart",
        animate: (0, _chartTheme.barChartDefaults).animate,
        motionConfig: (0, _chartTheme.barChartDefaults).motionConfig
    })), chartLayout === "vertical-by-reason" && (0, _react.jsx)("div", {
        style: {
            flex: 1,
            minHeight: 0
        }
    }, (0, _react.jsx)((0, _bar.ResponsiveBar), {
        data: verticalBarData,
        keys: [
            "value"
        ],
        indexBy: "reason",
        layout: "vertical",
        margin: {
            ...margin,
            top: 20,
            bottom: 80
        },
        padding: 0.3,
        valueScale: {
            type: "linear"
        },
        indexScale: {
            type: "band",
            round: true
        },
        colors: (bar)=>{
            const meta = activeReasonMeta[bar.indexValue];
            return meta?.fillColor || (0, _chartTheme.chartGlassBlues)[0];
        },
        borderRadius: 4,
        borderWidth: 0,
        axisTop: null,
        axisRight: null,
        axisBottom: {
            tickSize: 0,
            tickPadding: 12,
            tickRotation: -45,
            legend: axisBottomLegend,
            legendPosition: "middle",
            legendOffset: 70,
            renderTick: (tick)=>{
                const meta = activeReasonMeta[tick.value];
                const fillColor = meta?.category === "Planned" ? (0, _colors.chart_blue_2) : meta?.category === "Unplanned" ? (0, _colors.chart_slate_1) : (0, _colors.voicify_spark_medium);
                // Truncate label if longer than 12 characters
                const label = String(tick.value);
                const truncatedLabel = label.length > 12 ? `${label.substring(0, 10)}...` : label;
                return (0, _react.jsx)("g", {
                    transform: `translate(${tick.x},${tick.y + 4})`
                }, (0, _react.jsx)("text", {
                    textAnchor: "end",
                    dominantBaseline: "middle",
                    transform: "rotate(-45)",
                    style: {
                        fontSize: "10px",
                        fill: fillColor,
                        fontWeight: 500
                    }
                }, truncatedLabel));
            }
        },
        axisLeft: {
            tickSize: 0,
            tickPadding: 8,
            tickRotation: 0,
            legend: axisLeftLegend,
            legendPosition: "middle",
            legendOffset: -40,
            tickValues: 5
        },
        enableGridX: false,
        enableGridY: (0, _chartTheme.barChartDefaults).enableGridY,
        enableLabel: false,
        theme: (0, _chartTheme.nivoChartTheme),
        tooltip: ({ indexValue, value })=>{
            const meta = activeReasonMeta[indexValue];
            if (!meta) return null;
            return (0, _react.jsx)(PortalTooltip, {
                id: indexValue,
                value: value,
                indexValue: indexValue,
                data: {}
            });
        },
        onClick: (bar)=>{
            if (onBarClick) {
                const meta = activeReasonMeta[bar.indexValue];
                if (meta) onBarClick({
                    reason: meta.fullLabel,
                    reasonKey: meta.reasonKey,
                    value: bar.value,
                    category: meta.category,
                    apps: meta.apps
                });
            }
        },
        role: "img",
        ariaLabel: "Transfers by reason vertical bar chart",
        animate: (0, _chartTheme.barChartDefaults).animate,
        motionConfig: (0, _chartTheme.barChartDefaults).motionConfig
    })));
};
exports.default = TransfersChart;

},{"@emotion/react":"djZKr","react":"6uln9","react-dom":"b8T3j","@nivo/bar":"l59ZS","../../constants/colors":"1p3OR","../../constants/chartTheme":"1MLTJ","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"l59ZS":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Bar", ()=>Pe);
parcelHelpers.export(exports, "BarCanvas", ()=>De);
parcelHelpers.export(exports, "BarItem", ()=>ae);
parcelHelpers.export(exports, "BarTooltip", ()=>ne);
parcelHelpers.export(exports, "BarTotals", ()=>Ve);
parcelHelpers.export(exports, "ResponsiveBar", ()=>Xe);
parcelHelpers.export(exports, "ResponsiveBarCanvas", ()=>Ge);
parcelHelpers.export(exports, "canvasDefaultProps", ()=>oe);
parcelHelpers.export(exports, "commonDefaultProps", ()=>le);
parcelHelpers.export(exports, "svgDefaultProps", ()=>re);
var _react = require("react");
var _axes = require("@nivo/axes");
var _core = require("@nivo/core");
var _web = require("@react-spring/web");
var _annotations = require("@nivo/annotations");
var _jsxRuntime = require("react/jsx-runtime");
var _legends = require("@nivo/legends");
var _colors = require("@nivo/colors");
var _theming = require("@nivo/theming");
var _tooltip = require("@nivo/tooltip");
var _text = require("@nivo/text");
var _canvas = require("@nivo/canvas");
var _scales = require("@nivo/scales");
var _d3Shape = require("d3-shape");
var _uniqByJs = require("lodash/uniqBy.js");
var _uniqByJsDefault = parcelHelpers.interopDefault(_uniqByJs);
function Q() {
    return Q = Object.assign ? Object.assign.bind() : function(e) {
        for(var t = 1; t < arguments.length; t++){
            var a = arguments[t];
            for(var i in a)({}).hasOwnProperty.call(a, i) && (e[i] = a[i]);
        }
        return e;
    }, Q.apply(null, arguments);
}
function U(e, t) {
    if (null == e) return {};
    var a = {};
    for(var i in e)if (({}).hasOwnProperty.call(e, i)) {
        if (-1 !== t.indexOf(i)) continue;
        a[i] = e[i];
    }
    return a;
}
var Z, $ = function(e) {
    var t = e.bars, a = e.annotations, i = (0, _annotations.useAnnotations)({
        data: t,
        annotations: a,
        getPosition: function(e) {
            return {
                x: e.x + e.width / 2,
                y: e.y + e.height / 2
            };
        },
        getDimensions: function(e) {
            var t = e.height, a = e.width;
            return {
                width: a,
                height: t,
                size: Math.max(a, t)
            };
        }
    });
    return (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
        children: i.map(function(e, t) {
            return (0, _jsxRuntime.jsx)((0, _annotations.Annotation), Q({}, e), t);
        })
    });
}, ee = function(e) {
    var t = e.width, a = e.height, i = e.legends, n = e.toggleSerie;
    return (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
        children: i.map(function(e, i) {
            var l, r = e[0], o = e[1];
            return (0, _jsxRuntime.jsx)((0, _legends.BoxLegendSvg), Q({}, r, {
                containerWidth: t,
                containerHeight: a,
                data: null != (l = r.data) ? l : o,
                toggleSerie: r.toggleSerie && "keys" === r.dataFrom ? n : void 0
            }), i);
        })
    });
}, te = [
    "data"
], ae = function(i) {
    var n, l = i.bar, r = l.data, o = U(l, te), d = i.style, u = d.borderColor, s = d.color, c = d.height, h = d.labelColor, f = d.labelOpacity, b = d.labelX, g = d.labelY, v = d.transform, m = d.width, p = d.textAnchor, y = i.borderRadius, x = i.borderWidth, S = i.label, k = i.shouldRenderLabel, w = i.isInteractive, L = i.onClick, M = i.onMouseEnter, B = i.onMouseLeave, R = i.tooltip, O = i.isFocusable, I = i.ariaLabel, T = i.ariaLabelledBy, P = i.ariaDescribedBy, E = i.ariaDisabled, F = i.ariaHidden, z = (0, _theming.useTheme)(), X = (0, _tooltip.useTooltip)(), G = X.showTooltipFromEvent, N = X.showTooltipAt, j = X.hideTooltip, K = (0, _react.useMemo)(function() {
        return function() {
            return (0, _react.createElement)(R, Q({}, o, r));
        };
    }, [
        R,
        o,
        r
    ]), _ = (0, _react.useCallback)(function(e) {
        null == L || L(Q({
            color: o.color
        }, r), e);
    }, [
        o,
        r,
        L
    ]), q = (0, _react.useCallback)(function(e) {
        return G(K(), e);
    }, [
        G,
        K
    ]), J = (0, _react.useCallback)(function(e) {
        null == M || M(r, e), G(K(), e);
    }, [
        r,
        M,
        G,
        K
    ]), Z = (0, _react.useCallback)(function(e) {
        null == B || B(r, e), j();
    }, [
        r,
        j,
        B
    ]), $ = (0, _react.useCallback)(function() {
        N(K(), [
            o.absX + o.width / 2,
            o.absY
        ]);
    }, [
        N,
        K,
        o
    ]), ee = (0, _react.useCallback)(function() {
        j();
    }, [
        j
    ]);
    return (0, _jsxRuntime.jsxs)((0, _web.animated).g, {
        transform: v,
        children: [
            (0, _jsxRuntime.jsx)((0, _web.animated).rect, {
                width: (0, _web.to)(m, function(e) {
                    return Math.max(e, 0);
                }),
                height: (0, _web.to)(c, function(e) {
                    return Math.max(e, 0);
                }),
                rx: y,
                ry: y,
                fill: null != (n = r.fill) ? n : s,
                strokeWidth: x,
                stroke: u,
                focusable: O,
                tabIndex: O ? 0 : void 0,
                "aria-label": I ? I(r) : void 0,
                "aria-labelledby": T ? T(r) : void 0,
                "aria-describedby": P ? P(r) : void 0,
                "aria-disabled": E ? E(r) : void 0,
                "aria-hidden": F ? F(r) : void 0,
                onMouseEnter: w ? J : void 0,
                onMouseMove: w ? q : void 0,
                onMouseLeave: w ? Z : void 0,
                onClick: w ? _ : void 0,
                onFocus: w && O ? $ : void 0,
                onBlur: w && O ? ee : void 0,
                "data-testid": "bar.item." + r.id + "." + r.index
            }),
            k && (0, _jsxRuntime.jsx)((0, _text.Text), {
                x: b,
                y: g,
                textAnchor: p,
                dominantBaseline: "central",
                fillOpacity: f,
                style: Q({}, z.labels.text, {
                    pointerEvents: "none",
                    fill: h
                }),
                children: S
            })
        ]
    });
}, ie = [
    "color",
    "label"
], ne = function(e) {
    var t = e.color, a = e.label, i = U(e, ie);
    return (0, _jsxRuntime.jsx)((0, _tooltip.BasicTooltip), {
        id: a,
        value: i.formattedValue,
        enableChip: !0,
        color: t
    });
}, le = {
    indexBy: "id",
    keys: [
        "value"
    ],
    groupMode: "stacked",
    layout: "vertical",
    valueScale: {
        type: "linear",
        nice: !0,
        round: !1
    },
    indexScale: {
        type: "band",
        round: !1
    },
    padding: .1,
    innerPadding: 0,
    enableGridX: !1,
    enableGridY: !0,
    enableLabel: !0,
    label: "formattedValue",
    labelPosition: "middle",
    labelOffset: 0,
    labelSkipWidth: 0,
    labelSkipHeight: 0,
    labelTextColor: {
        theme: "labels.text.fill"
    },
    colorBy: "id",
    colors: {
        scheme: "nivo"
    },
    borderRadius: 0,
    borderWidth: 0,
    borderColor: {
        from: "color"
    },
    isInteractive: !0,
    tooltip: ne,
    tooltipLabel: function(e) {
        return e.id + " - " + e.indexValue;
    },
    legends: [],
    initialHiddenIds: [],
    annotations: [],
    enableTotals: !1,
    totalsOffset: 10
}, re = Q({}, le, {
    layers: [
        "grid",
        "axes",
        "bars",
        "totals",
        "markers",
        "legends",
        "annotations"
    ],
    axisTop: null,
    axisRight: null,
    axisBottom: {},
    axisLeft: {},
    barComponent: ae,
    defs: [],
    fill: [],
    markers: [],
    animate: !0,
    animateOnMount: !1,
    motionConfig: "default",
    role: "img",
    isFocusable: !1
}), oe = Q({}, le, {
    layers: [
        "grid",
        "axes",
        "bars",
        "totals",
        "legends",
        "annotations"
    ],
    axisTop: null,
    axisRight: null,
    axisBottom: {},
    axisLeft: {},
    renderBar: function(e, t) {
        var a = t.bar, i = a.color, n = a.height, l = a.width, r = a.x, o = a.y, d = t.borderColor, u = t.borderRadius, s = t.borderWidth, c = t.label, h = t.shouldRenderLabel, f = t.labelStyle, b = t.labelX, g = t.labelY, v = t.textAnchor;
        e.fillStyle = i, s > 0 && (e.strokeStyle = d, e.lineWidth = s), e.beginPath(), (0, _canvas.roundedRect)(e, r, o, l, n, Math.min(u, n)), e.fill(), s > 0 && e.stroke(), h && (e.textBaseline = "middle", e.textAlign = "middle" === v ? "center" : v, (0, _text.drawCanvasText)(e, f, c, r + b, o + g));
    },
    pixelRatio: "undefined" != typeof window && null != (Z = window.devicePixelRatio) ? Z : 1
}), de = function(e, t, a, i, n, l) {
    return (0, _scales.computeScale)(i, {
        all: e.map(t),
        min: 0,
        max: 0
    }, n, l).padding(a);
}, ue = function(e, t) {
    return e.map(function(e) {
        return Q({}, t.reduce(function(e, t) {
            return e[t] = null, e;
        }, {}), e);
    });
}, se = function(e) {
    return Object.keys(e).reduce(function(t, a) {
        return e[a] && (t[a] = e[a]), t;
    }, {});
}, ce = function(e) {
    return [
        e,
        Number(e)
    ];
};
function he(e, t, a, i) {
    return void 0 === e && (e = le.layout), void 0 === a && (a = le.labelPosition), void 0 === i && (i = le.labelOffset), function(n, l) {
        var r = i * (t ? -1 : 1);
        if ("horizontal" === e) {
            var o = n / 2;
            return "start" === a ? o = t ? n : 0 : "end" === a && (o = t ? 0 : n), {
                labelX: o + r,
                labelY: l / 2,
                textAnchor: "middle" === a ? "middle" : t ? "end" : "start"
            };
        }
        var d = l / 2;
        return "start" === a ? d = t ? 0 : l : "end" === a && (d = t ? l : 0), {
            labelX: n / 2,
            labelY: d - r,
            textAnchor: "middle"
        };
    };
}
var fe = [
    "layout",
    "width",
    "height",
    "padding",
    "innerPadding",
    "valueScale",
    "indexScale",
    "hiddenIds"
], be = function(e, t) {
    return e > t;
}, ge = function(e, t) {
    return e < t;
}, ve = function(e, t) {
    return Array.from(" ".repeat(t - e), function(t, a) {
        return e + a;
    });
}, me = function(e) {
    return be(e, 0) ? 0 : e;
}, pe = function(e, t, a, i) {
    var n = e.data, l = e.formatValue, r = e.getColor, o = e.getIndex, d = e.getTooltipLabel, u = e.innerPadding, s = void 0 === u ? 0 : u, c = e.keys, h = e.xScale, f = e.yScale, b = e.margin, g = a ? ge : be, v = n.map(se), m = [];
    return c.forEach(function(e, a) {
        return ve(0, h.domain().length).forEach(function(u) {
            var c, p, y, x = ce(n[u][e]), S = x[0], k = x[1], w = o(n[u]), L = (null != (c = h(w)) ? c : 0) + t * a + s * a, C = g(p = k, 0) ? null != (y = f(p)) ? y : 0 : i, W = function(e, t) {
                var a;
                return g(e, 0) ? i - t : (null != (a = f(e)) ? a : 0) - i;
            }(k, C), M = {
                id: e,
                value: null === S ? S : k,
                formattedValue: l(k),
                hidden: !1,
                index: u,
                indexValue: w,
                data: v[u]
            };
            m.push({
                key: e + "." + M.indexValue,
                index: m.length,
                data: M,
                x: L,
                y: C,
                absX: b.left + L,
                absY: b.top + C,
                width: t,
                height: W,
                color: r(M),
                label: d(M)
            });
        });
    }), m;
}, ye = function(e, t, a, i) {
    var n = e.data, l = e.formatValue, r = e.getIndex, o = e.getColor, d = e.getTooltipLabel, u = e.keys, s = e.innerPadding, c = void 0 === s ? 0 : s, h = e.xScale, f = e.yScale, b = e.margin, g = a ? ge : be, v = n.map(se), m = [];
    return u.forEach(function(e, a) {
        return ve(0, f.domain().length).forEach(function(u) {
            var s, p, y, x = ce(n[u][e]), S = x[0], k = x[1], w = r(n[u]), L = g(p = k, 0) ? i : null != (y = h(p)) ? y : 0, C = (null != (s = f(w)) ? s : 0) + t * a + c * a, W = function(e, t) {
                var a;
                return g(e, 0) ? (null != (a = h(e)) ? a : 0) - i : i - t;
            }(k, L), M = {
                id: e,
                value: null === S ? S : k,
                formattedValue: l(k),
                hidden: !1,
                index: u,
                indexValue: w,
                data: v[u]
            };
            m.push({
                key: e + "." + M.indexValue,
                index: m.length,
                data: M,
                x: L,
                y: C,
                absX: b.left + L,
                absY: b.top + C,
                width: W,
                height: t,
                color: o(M),
                label: d(M)
            });
        });
    }), m;
}, xe = function(e) {
    var t, a, i, n = e.layout, l = e.width, r = e.height, o = e.padding, d = void 0 === o ? 0 : o, u = e.innerPadding, s = void 0 === u ? 0 : u, c = e.valueScale, h = e.indexScale, f = e.hiddenIds, b = void 0 === f ? [] : f, g = U(e, fe), v = g.keys.filter(function(e) {
        return !b.includes(e);
    }), m = ue(g.data, v), p = "vertical" === n ? [
        "y",
        "x",
        l
    ] : [
        "x",
        "y",
        r
    ], y = p[0], x = p[1], S = p[2], k = de(m, g.getIndex, d, h, S, x), w = "auto" === c.min ? me : function(e) {
        return e;
    }, L = m.reduce(function(e, t) {
        return [].concat(e, v.map(function(e) {
            return t[e];
        }));
    }, []).filter(Boolean), C = w(Math.min.apply(Math, L)), W = (i = Math.max.apply(Math, L), isFinite(i) ? i : 0), M = (0, _scales.computeScale)(c, {
        all: L,
        min: C,
        max: W
    }, "x" === y ? l : r, y), B = "vertical" === n ? [
        k,
        M
    ] : [
        M,
        k
    ], R = B[0], O = B[1], I = (k.bandwidth() - s * (v.length - 1)) / v.length, V = [
        Q({}, g, {
            data: m,
            keys: v,
            innerPadding: s,
            xScale: R,
            yScale: O
        }),
        I,
        null != (t = c.reverse) && t,
        null != (a = M(0)) ? a : 0
    ];
    return {
        xScale: R,
        yScale: O,
        bars: I > 0 ? "vertical" === n ? pe.apply(void 0, V) : ye.apply(void 0, V) : []
    };
}, Se = [
    "data",
    "layout",
    "width",
    "height",
    "padding",
    "valueScale",
    "indexScale",
    "hiddenIds"
], ke = function(e) {
    var t;
    return e.some(Array.isArray) ? ke((t = []).concat.apply(t, e)) : e;
}, we = function(e, t, a) {
    var i = e.formatValue, n = e.getColor, l = e.getIndex, r = e.getTooltipLabel, o = e.innerPadding, d = e.stackedData, u = e.xScale, s = e.yScale, c = e.margin, h = [];
    return d.forEach(function(e) {
        return u.domain().forEach(function(d, f) {
            var b, g, v = e[f], m = null != (b = u(l(v.data))) ? b : 0, p = (null != (g = function(e) {
                return s(e[a ? 0 : 1]);
            }(v)) ? g : 0) + .5 * o, y = function(e, t) {
                var i;
                return (null != (i = s(e[a ? 1 : 0])) ? i : 0) - t;
            }(v, p) - o, x = ce(v.data[e.key]), S = x[0], k = x[1], w = {
                id: e.key,
                value: null === S ? S : k,
                formattedValue: i(k),
                hidden: !1,
                index: f,
                indexValue: d,
                data: se(v.data)
            };
            h.push({
                key: e.key + "." + d,
                index: h.length,
                data: w,
                x: m,
                y: p,
                absX: c.left + m,
                absY: c.top + p,
                width: t,
                height: y,
                color: n(w),
                label: r(w)
            });
        });
    }), h;
}, Le = function(e, t, a) {
    var i = e.formatValue, n = e.getColor, l = e.getIndex, r = e.getTooltipLabel, o = e.innerPadding, d = e.stackedData, u = e.xScale, s = e.yScale, c = e.margin, h = [];
    return d.forEach(function(e) {
        return s.domain().forEach(function(d, f) {
            var b, g, v = e[f], m = null != (b = s(l(v.data))) ? b : 0, p = (null != (g = function(e) {
                return u(e[a ? 1 : 0]);
            }(v)) ? g : 0) + .5 * o, y = function(e, t) {
                var i;
                return (null != (i = u(e[a ? 0 : 1])) ? i : 0) - t;
            }(v, p) - o, x = ce(v.data[e.key]), S = x[0], k = x[1], w = {
                id: e.key,
                value: null === S ? S : k,
                formattedValue: i(k),
                hidden: !1,
                index: f,
                indexValue: d,
                data: se(v.data)
            };
            h.push({
                key: e.key + "." + d,
                index: h.length,
                data: w,
                x: p,
                y: m,
                absX: c.left + p,
                absY: c.top + m,
                width: y,
                height: t,
                color: n(w),
                label: r(w)
            });
        });
    }), h;
}, Ce = function(e) {
    var t, a, i = e.data, n = e.layout, l = e.width, r = e.height, o = e.padding, d = void 0 === o ? 0 : o, u = e.valueScale, s = e.indexScale, c = e.hiddenIds, h = void 0 === c ? [] : c, f = U(e, Se), b = f.keys.filter(function(e) {
        return !h.includes(e);
    }), g = (0, _d3Shape.stack)().keys(b).offset((0, _d3Shape.stackOffsetDiverging))(ue(i, b)), v = "vertical" === n ? [
        "y",
        "x",
        l
    ] : [
        "x",
        "y",
        r
    ], m = v[0], p = v[1], y = v[2], x = de(i, f.getIndex, d, s, y, p), S = (a = ke(g), "log" === u.type ? a.filter(function(e) {
        return 0 !== e;
    }) : a), k = Math.min.apply(Math, S), w = Math.max.apply(Math, S), L = (0, _scales.computeScale)(u, {
        all: S,
        min: k,
        max: w
    }, "x" === m ? l : r, m), C = "vertical" === n ? [
        x,
        L
    ] : [
        L,
        x
    ], W = C[0], M = C[1], B = f.innerPadding > 0 ? f.innerPadding : 0, R = x.bandwidth(), O = [
        Q({}, f, {
            innerPadding: B,
            stackedData: g,
            xScale: W,
            yScale: M
        }),
        R,
        null != (t = u.reverse) && t
    ];
    return {
        xScale: W,
        yScale: M,
        bars: R > 0 ? "vertical" === n ? we.apply(void 0, O) : Le.apply(void 0, O) : []
    };
}, We = function(e) {
    var t = e.bars, a = e.direction, i = e.from, n = e.groupMode, l = e.layout, r = e.legendLabel, o = e.reverse, d = (0, _core.getPropertyAccessor)(null != r ? r : "indexes" === i ? "indexValue" : "id");
    return "indexes" === i ? function(e, t, a) {
        var i = (0, _uniqByJsDefault.default)(e.map(function(e) {
            var t, i;
            return {
                id: null != (t = e.data.indexValue) ? t : "",
                label: a(e.data),
                hidden: e.data.hidden,
                color: null != (i = e.color) ? i : "#000"
            };
        }), function(e) {
            return e.id;
        });
        return "horizontal" === t && i.reverse(), i;
    }(t, l, d) : function(e, t, a, i, n, l) {
        var r = (0, _uniqByJsDefault.default)(e.map(function(e) {
            var t;
            return {
                id: e.data.id,
                label: l(e.data),
                hidden: e.data.hidden,
                color: null != (t = e.color) ? t : "#000"
            };
        }), function(e) {
            return e.id;
        });
        return ("vertical" === t && "stacked" === i && "column" === a && !0 !== n || "horizontal" === t && "stacked" === i && !0 === n) && r.reverse(), r;
    }(t, l, a, n, o, d);
}, Me = function(e, t, a) {
    var i = e.get(t) || 0;
    e.set(t, i + a);
}, Be = function(e, t, a) {
    var i = e.get(t) || 0;
    e.set(t, i + (a > 0 ? a : 0));
}, Re = function(e, t, a) {
    var i = e.get(t) || 0;
    e.set(t, Math.max(i, Number(a)));
}, Oe = function(e, t) {
    var a = e.get(t) || 0;
    e.set(t, a + 1);
}, Ie = function(t) {
    var n, l = t.indexBy, r = void 0 === l ? le.indexBy : l, o = t.keys, d = void 0 === o ? le.keys : o, u = t.label, s = void 0 === u ? le.label : u, c = t.tooltipLabel, h = void 0 === c ? le.tooltipLabel : c, g = t.valueFormat, v = t.colors, m = void 0 === v ? le.colors : v, p = t.colorBy, y = void 0 === p ? le.colorBy : p, x = t.borderColor, S = void 0 === x ? le.borderColor : x, k = t.labelTextColor, w = void 0 === k ? le.labelTextColor : k, L = t.groupMode, C = void 0 === L ? le.groupMode : L, W = t.layout, M = void 0 === W ? le.layout : W, B = t.data, R = t.margin, O = t.width, I = t.height, V = t.padding, T = void 0 === V ? le.padding : V, H = t.innerPadding, P = void 0 === H ? le.innerPadding : H, E = t.valueScale, A = void 0 === E ? le.valueScale : E, X = t.indexScale, Y = void 0 === X ? le.indexScale : X, G = t.initialHiddenIds, N = void 0 === G ? le.initialHiddenIds : G, j = t.enableLabel, K = void 0 === j ? le.enableLabel : j, _ = t.labelSkipWidth, q = void 0 === _ ? le.labelSkipWidth : _, J = t.labelSkipHeight, U = void 0 === J ? le.labelSkipHeight : J, Z = t.legends, $ = void 0 === Z ? le.legends : Z, ee = t.legendLabel, te = t.totalsOffset, ae = void 0 === te ? le.totalsOffset : te, ie = (0, _react.useState)(null != N ? N : []), ne = ie[0], re = ie[1], oe = (0, _react.useCallback)(function(e) {
        re(function(t) {
            return t.indexOf(e) > -1 ? t.filter(function(t) {
                return t !== e;
            }) : [].concat(t, [
                e
            ]);
        });
    }, []), de = (0, _core.usePropertyAccessor)(r), ue = (0, _core.usePropertyAccessor)(s), se = (0, _core.usePropertyAccessor)(h), ce = (0, _core.useValueFormatter)(g), he = (0, _theming.useTheme)(), fe = (0, _colors.useOrdinalColorScale)(m, y), be = (0, _colors.useInheritedColor)(S, he), ge = (0, _colors.useInheritedColor)(w, he), ve = ("grouped" === C ? xe : Ce)({
        layout: M,
        data: B,
        getIndex: de,
        keys: d,
        width: O,
        height: I,
        getColor: fe,
        padding: T,
        innerPadding: P,
        valueScale: A,
        indexScale: Y,
        hiddenIds: ne,
        formatValue: ce,
        getTooltipLabel: se,
        margin: R
    }), me = ve.bars, pe = ve.xScale, ye = ve.yScale, Se = (0, _react.useMemo)(function() {
        return me.filter(function(e) {
            return null !== e.data.value;
        }).map(function(e, t) {
            return Q({}, e, {
                index: t
            });
        });
    }, [
        me
    ]), ke = (0, _react.useCallback)(function(e) {
        var t = e.width, a = e.height;
        return !!K && !(q > 0 && t < q) && !(U > 0 && a < U);
    }, [
        K,
        q,
        U
    ]), we = (0, _react.useMemo)(function() {
        return d.map(function(e) {
            var t = me.find(function(t) {
                return t.data.id === e;
            });
            return Q({}, t, {
                data: Q({
                    id: e
                }, null == t ? void 0 : t.data, {
                    hidden: ne.includes(e)
                })
            });
        });
    }, [
        ne,
        d,
        me
    ]), Le = null != (n = A.reverse) && n, Ie = (0, _react.useMemo)(function() {
        return $.map(function(e) {
            return [
                e,
                We({
                    bars: "keys" === e.dataFrom ? we : me,
                    direction: e.direction,
                    from: e.dataFrom,
                    groupMode: C,
                    layout: M,
                    legendLabel: ee,
                    reverse: Le
                })
            ];
        });
    }, [
        $,
        we,
        me,
        C,
        M,
        ee,
        Le
    ]), Ve = (0, _react.useMemo)(function() {
        return function(e, t, a, i, n, l, r) {
            void 0 === i && (i = le.layout), void 0 === n && (n = le.groupMode);
            var o = [];
            if (0 === e.length) return o;
            var d = new Map, u = e[0].width, s = e[0].height;
            if ("stacked" === n) {
                var c = new Map;
                e.forEach(function(e) {
                    var t = e.data, a = t.indexValue, i = t.value;
                    Me(d, a, Number(i)), Be(c, a, Number(i));
                }), c.forEach(function(e, n) {
                    var c, h, f, b = d.get(n) || 0;
                    "vertical" === i ? (c = t(n), h = a(e), f = a(e / 2)) : (c = t(e), h = a(n), f = t(e / 2)), c += "vertical" === i ? u / 2 : l, h += "vertical" === i ? -l : s / 2, o.push({
                        key: "total_" + n,
                        x: c,
                        y: h,
                        value: b,
                        formattedValue: r(b),
                        animationOffset: f
                    });
                });
            } else if ("grouped" === n) {
                var h = new Map, f = new Map;
                e.forEach(function(e) {
                    var t = e.data, a = t.indexValue, i = t.value;
                    Me(d, a, Number(i)), Re(h, a, Number(i)), Oe(f, a);
                }), h.forEach(function(e, n) {
                    var c, h, b, g = d.get(n) || 0, v = f.get(n);
                    "vertical" === i ? (c = t(n), h = a(e), b = a(e / 2)) : (c = t(e), h = a(n), b = t(e / 2)), c += "vertical" === i ? v * u / 2 : l, h += "vertical" === i ? -l : v * s / 2, o.push({
                        key: "total_" + n,
                        x: c,
                        y: h,
                        value: g,
                        formattedValue: r(g),
                        animationOffset: b
                    });
                });
            }
            return o;
        }(me, pe, ye, M, C, ae, ce);
    }, [
        me,
        pe,
        ye,
        M,
        C,
        ae,
        ce
    ]);
    return {
        bars: me,
        barsWithValue: Se,
        xScale: pe,
        yScale: ye,
        getIndex: de,
        getLabel: ue,
        getTooltipLabel: se,
        formatValue: ce,
        getColor: fe,
        getBorderColor: be,
        getLabelColor: ge,
        shouldRenderBarLabel: ke,
        hiddenIds: ne,
        toggleSerie: oe,
        legendsWithData: Ie,
        barTotals: Ve
    };
}, Ve = function(e) {
    var t = e.data, a = e.springConfig, i = e.animate, n = e.layout, l = void 0 === n ? re.layout : n, r = (0, _theming.useTheme)();
    return (0, _web.useTransition)(t, {
        keys: function(e) {
            return e.key;
        },
        from: function(e) {
            return {
                x: "vertical" === l ? e.x : e.animationOffset,
                y: "vertical" === l ? e.animationOffset : e.y,
                labelOpacity: 0
            };
        },
        enter: function(e) {
            return {
                x: e.x,
                y: e.y,
                labelOpacity: 1
            };
        },
        update: function(e) {
            return {
                x: e.x,
                y: e.y,
                labelOpacity: 1
            };
        },
        leave: function(e) {
            return {
                x: "vertical" === l ? e.x : e.animationOffset,
                y: "vertical" === l ? e.animationOffset : e.y,
                labelOpacity: 0
            };
        },
        config: a,
        immediate: !i,
        initial: i ? void 0 : null
    })(function(e, t) {
        return (0, _jsxRuntime.jsx)((0, _web.animated).text, {
            x: e.x,
            y: e.y,
            fillOpacity: e.labelOpacity,
            style: Q({}, r.labels.text, {
                pointerEvents: "none"
            }),
            fontWeight: "bold",
            fontSize: r.labels.text.fontSize,
            fontFamily: r.labels.text.fontFamily,
            textAnchor: "vertical" === l ? "middle" : "start",
            alignmentBaseline: "vertical" === l ? "alphabetic" : "middle",
            children: t.formattedValue
        }, t.key);
    });
}, Te = [
    "isInteractive",
    "animate",
    "motionConfig",
    "theme",
    "renderWrapper"
], He = function(a) {
    var i, n = a.data, r = a.indexBy, o = a.keys, s = a.margin, c = a.width, h = a.height, f = a.groupMode, b = a.layout, g = a.valueScale, S = a.indexScale, k = a.padding, w = a.innerPadding, L = a.axisTop, C = a.axisRight, W = a.axisBottom, B = void 0 === W ? re.axisBottom : W, R = a.axisLeft, O = void 0 === R ? re.axisLeft : R, I = a.enableGridX, T = void 0 === I ? re.enableGridX : I, H = a.enableGridY, P = void 0 === H ? re.enableGridY : H, E = a.gridXValues, F = a.gridYValues, z = a.layers, D = void 0 === z ? re.layers : z, A = a.barComponent, X = void 0 === A ? re.barComponent : A, Y = a.enableLabel, G = void 0 === Y ? re.enableLabel : Y, N = a.label, j = a.labelSkipWidth, K = void 0 === j ? re.labelSkipWidth : j, _ = a.labelSkipHeight, q = void 0 === _ ? re.labelSkipHeight : _, J = a.labelTextColor, U = a.labelPosition, Z = void 0 === U ? re.labelPosition : U, te = a.labelOffset, ae = void 0 === te ? re.labelOffset : te, ie = a.markers, ne = void 0 === ie ? re.markers : ie, le = a.colorBy, oe = a.colors, de = a.defs, ue = void 0 === de ? re.defs : de, se = a.fill, ce = void 0 === se ? re.fill : se, fe = a.borderRadius, be = void 0 === fe ? re.borderRadius : fe, ge = a.borderWidth, ve = void 0 === ge ? re.borderWidth : ge, me = a.borderColor, pe = a.annotations, ye = void 0 === pe ? re.annotations : pe, xe = a.legendLabel, Se = a.tooltipLabel, ke = a.valueFormat, we = a.isInteractive, Le = void 0 === we ? re.isInteractive : we, Ce = a.tooltip, We = void 0 === Ce ? re.tooltip : Ce, Me = a.onClick, Be = a.onMouseEnter, Re = a.onMouseLeave, Oe = a.legends, Te = a.role, He = void 0 === Te ? re.role : Te, Pe = a.ariaLabel, Ee = a.ariaLabelledBy, Fe = a.ariaDescribedBy, ze = a.isFocusable, De = void 0 === ze ? re.isFocusable : ze, Ae = a.barAriaLabel, Xe = a.barAriaLabelledBy, Ye = a.barAriaDescribedBy, Ge = a.barAriaHidden, Ne = a.barAriaDisabled, je = a.initialHiddenIds, Ke = a.enableTotals, _e = void 0 === Ke ? re.enableTotals : Ke, qe = a.totalsOffset, Je = void 0 === qe ? re.totalsOffset : qe, Qe = a.forwardedRef, Ue = (0, _core.useMotionConfig)(), Ze = Ue.animate, $e = Ue.config, et = (0, _core.useDimensions)(c, h, s), tt = et.outerWidth, at = et.outerHeight, it = et.margin, nt = et.innerWidth, lt = et.innerHeight, rt = Ie({
        indexBy: r,
        label: N,
        tooltipLabel: Se,
        valueFormat: ke,
        colors: oe,
        colorBy: le,
        borderColor: me,
        labelTextColor: J,
        groupMode: f,
        layout: b,
        data: n,
        keys: o,
        margin: it,
        width: nt,
        height: lt,
        padding: k,
        innerPadding: w,
        valueScale: g,
        indexScale: S,
        enableLabel: G,
        labelSkipWidth: K,
        labelSkipHeight: q,
        legends: Oe,
        legendLabel: xe,
        initialHiddenIds: je,
        totalsOffset: Je
    }), ot = rt.bars, dt = rt.barsWithValue, ut = rt.xScale, st = rt.yScale, ct = rt.getLabel, ht = rt.getTooltipLabel, ft = rt.getBorderColor, bt = rt.getLabelColor, gt = rt.shouldRenderBarLabel, vt = rt.toggleSerie, mt = rt.legendsWithData, pt = rt.barTotals, yt = rt.getColor, xt = he(b, null != (i = null == g ? void 0 : g.reverse) && i, Z, ae), St = (0, _web.useTransition)(dt, {
        keys: function(e) {
            return e.key;
        },
        from: function(e) {
            return Q({
                borderColor: ft(e),
                color: e.color,
                height: 0,
                labelColor: bt(e),
                labelOpacity: 0
            }, xt(e.width, e.height), {
                transform: "translate(" + e.x + ", " + (e.y + e.height) + ")",
                width: e.width
            }, "vertical" === b ? {} : {
                height: e.height,
                transform: "translate(" + e.x + ", " + e.y + ")",
                width: 0
            });
        },
        enter: function(e) {
            return Q({
                borderColor: ft(e),
                color: e.color,
                height: e.height,
                labelColor: bt(e),
                labelOpacity: 1
            }, xt(e.width, e.height), {
                transform: "translate(" + e.x + ", " + e.y + ")",
                width: e.width
            });
        },
        update: function(e) {
            return Q({
                borderColor: ft(e),
                color: e.color,
                height: e.height,
                labelColor: bt(e),
                labelOpacity: 1
            }, xt(e.width, e.height), {
                transform: "translate(" + e.x + ", " + e.y + ")",
                width: e.width
            });
        },
        leave: function(e) {
            return Q({
                borderColor: ft(e),
                color: e.color,
                height: 0,
                labelColor: bt(e),
                labelOpacity: 0
            }, xt(e.width, e.height), {
                labelY: 0,
                transform: "translate(" + e.x + ", " + (e.y + e.height) + ")",
                width: e.width
            }, "vertical" === b ? {} : Q({}, xt(e.width, e.height), {
                labelX: 0,
                height: e.height,
                transform: "translate(" + e.x + ", " + e.y + ")",
                width: 0
            }));
        },
        config: $e,
        immediate: !Ze,
        initial: Ze ? void 0 : null
    }), kt = (0, _react.useMemo)(function() {
        return {
            borderRadius: be,
            borderWidth: ve,
            enableLabel: G,
            isInteractive: Le,
            labelSkipWidth: K,
            labelSkipHeight: q,
            onClick: Me,
            onMouseEnter: Be,
            onMouseLeave: Re,
            getTooltipLabel: ht,
            tooltip: We,
            isFocusable: De,
            ariaLabel: Ae,
            ariaLabelledBy: Xe,
            ariaDescribedBy: Ye,
            ariaHidden: Ge,
            ariaDisabled: Ne
        };
    }, [
        be,
        ve,
        G,
        ht,
        Le,
        q,
        K,
        Me,
        Be,
        Re,
        We,
        De,
        Ae,
        Xe,
        Ye,
        Ge,
        Ne
    ]), wt = (0, _core.bindDefs)(ue, ot, ce, {
        dataKey: "data",
        targetKey: "data.fill"
    }), Lt = {
        annotations: null,
        axes: null,
        bars: null,
        grid: null,
        legends: null,
        markers: null,
        totals: null
    };
    D.includes("annotations") && (Lt.annotations = (0, _jsxRuntime.jsx)($, {
        bars: ot,
        annotations: ye
    }, "annotations")), D.includes("axes") && (Lt.axes = (0, _jsxRuntime.jsx)((0, _axes.Axes), {
        xScale: ut,
        yScale: st,
        width: nt,
        height: lt,
        top: L,
        right: C,
        bottom: B,
        left: O
    }, "axes")), D.includes("bars") && (Lt.bars = (0, _jsxRuntime.jsx)((0, _react.Fragment), {
        children: St(function(e, a) {
            return (0, _react.createElement)(X, Q({}, kt, {
                bar: a,
                style: e,
                shouldRenderLabel: gt(a),
                label: ct(a.data)
            }));
        })
    }, "bars")), D.includes("grid") && (Lt.grid = (0, _jsxRuntime.jsx)((0, _axes.Grid), {
        width: nt,
        height: lt,
        xScale: T ? ut : null,
        yScale: P ? st : null,
        xValues: E,
        yValues: F
    }, "grid")), D.includes("legends") && (Lt.legends = (0, _jsxRuntime.jsx)(ee, {
        width: nt,
        height: lt,
        legends: mt,
        toggleSerie: vt
    }, "legends")), D.includes("markers") && (Lt.markers = (0, _jsxRuntime.jsx)((0, _core.CartesianMarkers), {
        markers: ne,
        width: nt,
        height: lt,
        xScale: ut,
        yScale: st
    }, "markers")), D.includes("totals") && _e && (Lt.totals = (0, _jsxRuntime.jsx)(Ve, {
        data: pt,
        springConfig: $e,
        animate: Ze,
        layout: b
    }, "totals"));
    var Ct = Q({}, kt, {
        margin: it,
        width: c,
        height: h,
        innerWidth: nt,
        innerHeight: lt,
        bars: ot,
        legendData: mt,
        enableLabel: G,
        xScale: ut,
        yScale: st,
        tooltip: We,
        getTooltipLabel: ht,
        onClick: Me,
        onMouseEnter: Be,
        onMouseLeave: Re,
        getColor: yt
    });
    return (0, _jsxRuntime.jsx)((0, _core.SvgWrapper), {
        width: tt,
        height: at,
        margin: it,
        defs: wt,
        role: He,
        ariaLabel: Pe,
        ariaLabelledBy: Ee,
        ariaDescribedBy: Fe,
        isFocusable: De,
        ref: Qe,
        children: D.map(function(e, a) {
            var i;
            return "function" == typeof e ? (0, _jsxRuntime.jsx)((0, _react.Fragment), {
                children: (0, _react.createElement)(e, Ct)
            }, a) : null != (i = null == Lt ? void 0 : Lt[e]) ? i : null;
        })
    });
}, Pe = (0, _react.forwardRef)(function(e, t) {
    var a = e.isInteractive, i = void 0 === a ? re.isInteractive : a, n = e.animate, l = void 0 === n ? re.animate : n, r = e.motionConfig, o = void 0 === r ? re.motionConfig : r, d = e.theme, u = e.renderWrapper, s = U(e, Te);
    return (0, _jsxRuntime.jsx)((0, _core.Container), {
        animate: l,
        isInteractive: i,
        motionConfig: o,
        renderWrapper: u,
        theme: d,
        children: (0, _jsxRuntime.jsx)(He, Q({}, s, {
            isInteractive: i,
            forwardedRef: t
        }))
    });
}), Ee = [
    "isInteractive",
    "renderWrapper",
    "theme"
], Fe = function(e, t, a, i) {
    return e.find(function(e) {
        return (0, _core.isCursorInRect)(e.x + t.left, e.y + t.top, e.width, e.height, a, i);
    });
};
var ze = function(i) {
    var n, l = i.data, d = i.indexBy, u = i.keys, h = i.margin, f = i.width, g = i.height, v = i.groupMode, p = i.layout, y = i.valueScale, x = i.indexScale, w = i.padding, L = i.innerPadding, C = i.axisTop, W = i.axisRight, M = i.axisBottom, R = void 0 === M ? oe.axisBottom : M, T = i.axisLeft, H = void 0 === T ? oe.axisLeft : T, P = i.enableGridX, F = void 0 === P ? oe.enableGridX : P, z = i.enableGridY, X = void 0 === z ? oe.enableGridY : z, Y = i.gridXValues, j = i.gridYValues, K = i.labelPosition, _ = void 0 === K ? oe.labelPosition : K, q = i.labelOffset, J = void 0 === q ? oe.labelOffset : q, U = i.layers, Z = void 0 === U ? oe.layers : U, $ = i.renderBar, ee = void 0 === $ ? oe.renderBar : $, te = i.enableLabel, ae = void 0 === te ? oe.enableLabel : te, ie = i.label, ne = i.labelSkipWidth, le = void 0 === ne ? oe.labelSkipWidth : ne, re = i.labelSkipHeight, de = void 0 === re ? oe.labelSkipHeight : re, ue = i.labelTextColor, se = i.colorBy, ce = i.colors, fe = i.borderRadius, be = void 0 === fe ? oe.borderRadius : fe, ge = i.borderWidth, ve = void 0 === ge ? oe.borderWidth : ge, me = i.borderColor, pe = i.annotations, ye = void 0 === pe ? oe.annotations : pe, xe = i.legendLabel, Se = i.tooltipLabel, ke = i.valueFormat, we = i.isInteractive, Le = void 0 === we ? oe.isInteractive : we, Ce = i.tooltip, We = void 0 === Ce ? oe.tooltip : Ce, Me = i.onClick, Be = i.onMouseEnter, Re = i.onMouseLeave, Oe = i.legends, Ve = i.pixelRatio, Te = void 0 === Ve ? oe.pixelRatio : Ve, He = i.role, Pe = i.forwardedRef, Ee = i.enableTotals, ze = void 0 === Ee ? oe.enableTotals : Ee, De = i.totalsOffset, Ae = void 0 === De ? oe.totalsOffset : De, Xe = (0, _react.useRef)(null), Ye = (0, _theming.useTheme)(), Ge = (0, _core.useDimensions)(f, g, h), Ne = Ge.margin, je = Ge.innerWidth, Ke = Ge.innerHeight, _e = Ge.outerWidth, qe = Ge.outerHeight, Je = Ie({
        indexBy: d,
        label: ie,
        tooltipLabel: Se,
        valueFormat: ke,
        colors: ce,
        colorBy: se,
        borderColor: me,
        labelTextColor: ue,
        groupMode: v,
        layout: p,
        data: l,
        keys: u,
        margin: Ne,
        width: je,
        height: Ke,
        padding: w,
        innerPadding: L,
        valueScale: y,
        indexScale: x,
        enableLabel: ae,
        labelSkipWidth: le,
        labelSkipHeight: de,
        legends: Oe,
        legendLabel: xe,
        totalsOffset: Ae
    }), Qe = Je.bars, Ue = Je.barsWithValue, Ze = Je.xScale, $e = Je.yScale, et = Je.getLabel, tt = Je.getTooltipLabel, at = Je.getBorderColor, it = Je.getLabelColor, nt = Je.shouldRenderBarLabel, lt = Je.legendsWithData, rt = Je.barTotals, ot = Je.getColor, dt = (0, _tooltip.useTooltip)(), ut = dt.showTooltipFromEvent, st = dt.hideTooltip, ct = (0, _annotations.useComputedAnnotations)({
        annotations: (0, _annotations.useAnnotations)({
            data: Qe,
            annotations: ye,
            getPosition: function(e) {
                return {
                    x: e.x,
                    y: e.y
                };
            },
            getDimensions: function(e) {
                var t = e.width, a = e.height;
                return {
                    width: t,
                    height: a,
                    size: Math.max(t, a)
                };
            }
        })
    }), ht = (0, _react.useMemo)(function() {
        return {
            borderRadius: be,
            borderWidth: ve,
            isInteractive: Le,
            isFocusable: !1,
            labelSkipWidth: le,
            labelSkipHeight: de,
            margin: Ne,
            width: f,
            height: g,
            innerWidth: je,
            innerHeight: Ke,
            bars: Qe,
            legendData: lt,
            enableLabel: ae,
            xScale: Ze,
            yScale: $e,
            tooltip: We,
            getTooltipLabel: tt,
            onClick: Me,
            onMouseEnter: Be,
            onMouseLeave: Re,
            getColor: ot
        };
    }, [
        be,
        ve,
        Le,
        le,
        de,
        Ne,
        f,
        g,
        je,
        Ke,
        Qe,
        lt,
        ae,
        Ze,
        $e,
        We,
        tt,
        Me,
        Be,
        Re,
        ot
    ]), ft = (0, _core.useValueFormatter)(ke), bt = he(p, null != (n = null == y ? void 0 : y.reverse) && n, _, J);
    (0, _react.useEffect)(function() {
        if (Xe.current) {
            Xe.current.width = _e * Te, Xe.current.height = qe * Te;
            var e = Xe.current.getContext("2d");
            e.scale(Te, Te), e.fillStyle = Ye.background, e.fillRect(0, 0, _e, qe), e.translate(Ne.left, Ne.top), Z.forEach(function(t) {
                "grid" === t ? "number" == typeof Ye.grid.line.strokeWidth && Ye.grid.line.strokeWidth > 0 && (e.lineWidth = Ye.grid.line.strokeWidth, e.strokeStyle = Ye.grid.line.stroke, F && (0, _axes.renderGridLinesToCanvas)(e, {
                    width: je,
                    height: Ke,
                    scale: Ze,
                    axis: "x",
                    values: Y
                }), X && (0, _axes.renderGridLinesToCanvas)(e, {
                    width: je,
                    height: Ke,
                    scale: $e,
                    axis: "y",
                    values: j
                })) : "axes" === t ? (0, _axes.renderAxesToCanvas)(e, {
                    xScale: Ze,
                    yScale: $e,
                    width: je,
                    height: Ke,
                    top: C,
                    right: W,
                    bottom: R,
                    left: H,
                    theme: Ye
                }) : "bars" === t ? ((0, _text.setCanvasFont)(e, Ye.text), Ue.forEach(function(t) {
                    ee(e, Q({
                        bar: t,
                        borderColor: at(t),
                        borderRadius: be,
                        borderWidth: ve,
                        label: et(t.data),
                        shouldRenderLabel: nt(t),
                        labelStyle: Q({}, Ye.labels.text, {
                            fill: it(t)
                        })
                    }, bt(t.width, t.height)));
                })) : "legends" === t ? lt.forEach(function(t) {
                    var a = t[0], i = t[1];
                    (0, _legends.renderLegendToCanvas)(e, Q({}, a, {
                        data: i,
                        containerWidth: je,
                        containerHeight: Ke,
                        theme: Ye
                    }));
                }) : "annotations" === t ? (0, _annotations.renderAnnotationsToCanvas)(e, {
                    annotations: ct,
                    theme: Ye
                }) : "totals" === t && ze ? function(e, t, a, i) {
                    void 0 === i && (i = oe.layout), (0, _text.setCanvasFont)(e, a.labels.text), e.textBaseline = "vertical" === i ? "alphabetic" : "middle", e.textAlign = "vertical" === i ? "center" : "start", t.forEach(function(t) {
                        (0, _text.drawCanvasText)(e, a.labels.text, t.formattedValue, t.x, t.y);
                    });
                }(e, rt, Ye, p) : "function" == typeof t && t(e, ht);
            }), e.save();
        }
    }, [
        R,
        H,
        W,
        C,
        Ue,
        be,
        ve,
        ct,
        F,
        X,
        at,
        et,
        it,
        Y,
        j,
        v,
        g,
        Ke,
        je,
        ht,
        Z,
        p,
        lt,
        Ne.left,
        Ne.top,
        qe,
        _e,
        Te,
        ee,
        Ze,
        $e,
        nt,
        Ye,
        f,
        rt,
        ze,
        ft,
        bt
    ]);
    var gt = (0, _react.useCallback)(function(e) {
        if (Qe && Xe.current) {
            var a = (0, _core.getRelativeCursor)(Xe.current, e), i = a[0], n = a[1], l = Fe(Qe, Ne, i, n);
            void 0 !== l ? (ut((0, _react.createElement)(We, Q({}, l.data, {
                color: l.color,
                label: l.label,
                value: Number(l.data.value)
            })), e), "mouseenter" === e.type && (null == Be || Be(l.data, e))) : st();
        }
    }, [
        st,
        Ne,
        Be,
        Qe,
        ut,
        We
    ]), vt = (0, _react.useCallback)(function(e) {
        if (Qe && Xe.current) {
            st();
            var t = (0, _core.getRelativeCursor)(Xe.current, e), a = t[0], i = t[1], n = Fe(Qe, Ne, a, i);
            n && (null == Re || Re(n.data, e));
        }
    }, [
        st,
        Ne,
        Re,
        Qe
    ]), mt = (0, _react.useCallback)(function(e) {
        if (Qe && Xe.current) {
            var t = (0, _core.getRelativeCursor)(Xe.current, e), a = t[0], i = t[1], n = Fe(Qe, Ne, a, i);
            void 0 !== n && (null == Me || Me(Q({}, n.data, {
                color: n.color
            }), e));
        }
    }, [
        Ne,
        Me,
        Qe
    ]);
    return (0, _jsxRuntime.jsx)("canvas", {
        ref: (0, _core.mergeRefs)(Xe, Pe),
        width: _e * Te,
        height: qe * Te,
        style: {
            width: _e,
            height: qe,
            cursor: Le ? "auto" : "normal"
        },
        onMouseEnter: Le ? gt : void 0,
        onMouseMove: Le ? gt : void 0,
        onMouseLeave: Le ? vt : void 0,
        onClick: Le ? mt : void 0,
        role: He
    });
}, De = (0, _react.forwardRef)(function(e, t) {
    var a = e.isInteractive, i = e.renderWrapper, n = e.theme, l = U(e, Ee);
    return (0, _jsxRuntime.jsx)((0, _core.Container), {
        isInteractive: a,
        renderWrapper: i,
        theme: n,
        animate: !1,
        children: (0, _jsxRuntime.jsx)(ze, Q({}, l, {
            isInteractive: a,
            forwardedRef: t
        }))
    });
}), Ae = [
    "defaultWidth",
    "defaultHeight",
    "onResize",
    "debounceResize"
], Xe = (0, _react.forwardRef)(function(e, t) {
    var a = e.defaultWidth, i = e.defaultHeight, n = e.onResize, l = e.debounceResize, r = U(e, Ae);
    return (0, _jsxRuntime.jsx)((0, _core.ResponsiveWrapper), {
        defaultWidth: a,
        defaultHeight: i,
        onResize: n,
        debounceResize: l,
        children: function(e) {
            var a = e.width, i = e.height;
            return (0, _jsxRuntime.jsx)(Pe, Q({}, r, {
                width: a,
                height: i,
                ref: t
            }));
        }
    });
}), Ye = [
    "defaultWidth",
    "defaultHeight",
    "onResize",
    "debounceResize"
], Ge = (0, _react.forwardRef)(function(e, t) {
    var a = e.defaultWidth, i = e.defaultHeight, n = e.onResize, l = e.debounceResize, r = U(e, Ye);
    return (0, _jsxRuntime.jsx)((0, _core.ResponsiveWrapper), {
        defaultWidth: a,
        defaultHeight: i,
        onResize: n,
        debounceResize: l,
        children: function(e) {
            var a = e.width, i = e.height;
            return (0, _jsxRuntime.jsx)(De, Q({}, r, {
                width: a,
                height: i,
                ref: t
            }));
        }
    });
});

},{"react":"6uln9","@nivo/axes":"5TAzq","@nivo/core":"3e9EB","@react-spring/web":"39JSM","@nivo/annotations":"hhmOD","react/jsx-runtime":"gaGEj","@nivo/legends":"kxw7P","@nivo/colors":"kpdUa","@nivo/theming":"kiBiP","@nivo/tooltip":"1CuTy","@nivo/text":"5EjSJ","@nivo/canvas":"jNgY9","@nivo/scales":"8SXu8","d3-shape":"ba4g6","lodash/uniqBy.js":"5pHXK","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hhmOD":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Annotation", ()=>R);
parcelHelpers.export(exports, "bindAnnotations", ()=>P);
parcelHelpers.export(exports, "computeAnnotation", ()=>S);
parcelHelpers.export(exports, "defaultProps", ()=>k);
parcelHelpers.export(exports, "getLinkAngle", ()=>C);
parcelHelpers.export(exports, "isCanvasNote", ()=>v);
parcelHelpers.export(exports, "isCircleAnnotation", ()=>b);
parcelHelpers.export(exports, "isDotAnnotation", ()=>w);
parcelHelpers.export(exports, "isRectAnnotation", ()=>z);
parcelHelpers.export(exports, "isSvgNote", ()=>W);
parcelHelpers.export(exports, "renderAnnotationsToCanvas", ()=>J);
parcelHelpers.export(exports, "useAnnotations", ()=>O);
parcelHelpers.export(exports, "useComputedAnnotation", ()=>M);
parcelHelpers.export(exports, "useComputedAnnotations", ()=>j);
var _react = require("react");
var _filterJs = require("lodash/filter.js");
var _filterJsDefault = parcelHelpers.interopDefault(_filterJs);
var _isNumberJs = require("lodash/isNumber.js");
var _isNumberJsDefault = parcelHelpers.interopDefault(_isNumberJs);
var _omitJs = require("lodash/omit.js");
var _omitJsDefault = parcelHelpers.interopDefault(_omitJs);
var _core = require("@nivo/core");
var _web = require("@react-spring/web");
var _theming = require("@nivo/theming");
var _jsxRuntime = require("react/jsx-runtime");
function g() {
    return g = Object.assign ? Object.assign.bind() : function(t) {
        for(var n = 1; n < arguments.length; n++){
            var i = arguments[n];
            for(var o in i)({}).hasOwnProperty.call(i, o) && (t[o] = i[o]);
        }
        return t;
    }, g.apply(null, arguments);
}
var k = {
    dotSize: 4,
    noteWidth: 120,
    noteTextOffset: 8,
    animate: !0
}, W = function(n) {
    var i = typeof n;
    return (0, _react.isValidElement)(n) || "string" === i || "function" === i || "object" === i;
}, v = function(t) {
    var n = typeof t;
    return "string" === n || "function" === n;
}, b = function(t) {
    return "circle" === t.type;
}, w = function(t) {
    return "dot" === t.type;
}, z = function(t) {
    return "rect" === t.type;
}, P = function(t) {
    var n = t.data, i = t.annotations, e = t.getPosition, r = t.getDimensions;
    return i.reduce(function(t, i) {
        var s = i.offset || 0;
        return [].concat(t, (0, _filterJsDefault.default)(n, i.match).map(function(t) {
            var n = e(t), o = r(t);
            return (b(i) || z(i)) && (o.size = o.size + 2 * s, o.width = o.width + 2 * s, o.height = o.height + 2 * s), g({}, (0, _omitJsDefault.default)(i, [
                "match",
                "offset"
            ]), n, o, {
                size: i.size || o.size,
                datum: t
            });
        }));
    }, []);
}, C = function(t, n, i, o) {
    var e = Math.atan2(o - n, i - t);
    return (0, _core.normalizeAngleDegrees)((0, _core.radiansToDegrees)(e));
}, S = function(t) {
    var n, i, o = t.x, a = t.y, r = t.noteX, s = t.noteY, h = t.noteWidth, d = void 0 === h ? k.noteWidth : h, c = t.noteTextOffset, f = void 0 === c ? k.noteTextOffset : c;
    if ((0, _isNumberJsDefault.default)(r)) n = o + r;
    else {
        if (void 0 === r.abs) throw new Error("noteX should be either a number or an object containing an 'abs' property");
        n = r.abs;
    }
    if ((0, _isNumberJsDefault.default)(s)) i = a + s;
    else {
        if (void 0 === s.abs) throw new Error("noteY should be either a number or an object containing an 'abs' property");
        i = s.abs;
    }
    var y = o, x = a, m = C(o, a, n, i);
    if (b(t)) {
        var p = (0, _core.positionFromAngle)((0, _core.degreesToRadians)(m), t.size / 2);
        y += p.x, x += p.y;
    }
    if (z(t)) {
        var g = Math.round((m + 90) / 45) % 8;
        0 === g && (x -= t.height / 2), 1 === g && (y += t.width / 2, x -= t.height / 2), 2 === g && (y += t.width / 2), 3 === g && (y += t.width / 2, x += t.height / 2), 4 === g && (x += t.height / 2), 5 === g && (y -= t.width / 2, x += t.height / 2), 6 === g && (y -= t.width / 2), 7 === g && (y -= t.width / 2, x -= t.height / 2);
    }
    var W = n, v = n;
    return (m + 90) % 360 > 180 ? (W -= d, v -= d) : v += d, {
        points: [
            [
                y,
                x
            ],
            [
                n,
                i
            ],
            [
                v,
                i
            ]
        ],
        text: [
            W,
            i - f
        ],
        angle: m + 90
    };
}, O = function(t) {
    var i = t.data, o = t.annotations, e = t.getPosition, a = t.getDimensions;
    return (0, _react.useMemo)(function() {
        return P({
            data: i,
            annotations: o,
            getPosition: e,
            getDimensions: a
        });
    }, [
        i,
        o,
        e,
        a
    ]);
}, j = function(t) {
    var i = t.annotations;
    return (0, _react.useMemo)(function() {
        return i.map(function(t) {
            return g({}, t, {
                computed: S(g({}, t))
            });
        });
    }, [
        i
    ]);
}, M = function(t) {
    return (0, _react.useMemo)(function() {
        return S(t);
    }, [
        t
    ]);
}, T = function(t) {
    var n = t.datum, o = t.x, e = t.y, r = t.note, s = (0, _theming.useTheme)(), l = (0, _core.useMotionConfig)(), u = l.animate, d = l.config, k = (0, _web.useSpring)({
        x: o,
        y: e,
        config: d,
        immediate: !u
    });
    return "function" == typeof r ? (0, _react.createElement)(r, {
        x: o,
        y: e,
        datum: n
    }) : (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            s.annotations.text.outlineWidth > 0 && (0, _jsxRuntime.jsx)((0, _web.animated).text, {
                x: k.x,
                y: k.y,
                style: g({}, s.annotations.text, {
                    strokeLinejoin: "round",
                    strokeWidth: 2 * s.annotations.text.outlineWidth,
                    stroke: s.annotations.text.outlineColor
                }),
                children: r
            }),
            (0, _jsxRuntime.jsx)((0, _web.animated).text, {
                x: k.x,
                y: k.y,
                style: (0, _omitJsDefault.default)(s.annotations.text, [
                    "outlineWidth",
                    "outlineColor"
                ]),
                children: r
            })
        ]
    });
}, E = function(t) {
    var i = t.points, o = t.isOutline, e = void 0 !== o && o, a = (0, _theming.useTheme)(), r = (0, _react.useMemo)(function() {
        var t = i[0];
        return i.slice(1).reduce(function(t, n) {
            return t + " L" + n[0] + "," + n[1];
        }, "M" + t[0] + "," + t[1]);
    }, [
        i
    ]), s = (0, _core.useAnimatedPath)(r);
    if (e && a.annotations.link.outlineWidth <= 0) return null;
    var l = g({}, a.annotations.link);
    return e && (l.strokeLinecap = "square", l.strokeWidth = a.annotations.link.strokeWidth + 2 * a.annotations.link.outlineWidth, l.stroke = a.annotations.link.outlineColor, l.opacity = a.annotations.link.outlineOpacity), (0, _jsxRuntime.jsx)((0, _web.animated).path, {
        fill: "none",
        d: s,
        style: l
    });
}, I = function(t) {
    var n = t.x, i = t.y, o = t.size, e = (0, _theming.useTheme)(), a = (0, _core.useMotionConfig)(), r = a.animate, s = a.config, l = (0, _web.useSpring)({
        x: n,
        y: i,
        radius: o / 2,
        config: s,
        immediate: !r
    });
    return (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            e.annotations.outline.outlineWidth > 0 && (0, _jsxRuntime.jsx)((0, _web.animated).circle, {
                cx: l.x,
                cy: l.y,
                r: l.radius,
                style: g({}, e.annotations.outline, {
                    fill: "none",
                    strokeWidth: e.annotations.outline.strokeWidth + 2 * e.annotations.outline.outlineWidth,
                    stroke: e.annotations.outline.outlineColor,
                    opacity: e.annotations.outline.outlineOpacity
                })
            }),
            (0, _jsxRuntime.jsx)((0, _web.animated).circle, {
                cx: l.x,
                cy: l.y,
                r: l.radius,
                style: e.annotations.outline
            })
        ]
    });
}, D = function(t) {
    var n = t.x, i = t.y, o = t.size, e = void 0 === o ? k.dotSize : o, a = (0, _theming.useTheme)(), r = (0, _core.useMotionConfig)(), s = r.animate, l = r.config, u = (0, _web.useSpring)({
        x: n,
        y: i,
        radius: e / 2,
        config: l,
        immediate: !s
    });
    return (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            a.annotations.outline.outlineWidth > 0 && (0, _jsxRuntime.jsx)((0, _web.animated).circle, {
                cx: u.x,
                cy: u.y,
                r: u.radius,
                style: g({}, a.annotations.outline, {
                    fill: "none",
                    strokeWidth: 2 * a.annotations.outline.outlineWidth,
                    stroke: a.annotations.outline.outlineColor,
                    opacity: a.annotations.outline.outlineOpacity
                })
            }),
            (0, _jsxRuntime.jsx)((0, _web.animated).circle, {
                cx: u.x,
                cy: u.y,
                r: u.radius,
                style: a.annotations.symbol
            })
        ]
    });
}, L = function(t) {
    var n = t.x, i = t.y, o = t.width, e = t.height, a = t.borderRadius, r = void 0 === a ? 6 : a, s = (0, _theming.useTheme)(), l = (0, _core.useMotionConfig)(), u = l.animate, d = l.config, k = (0, _web.useSpring)({
        x: n - o / 2,
        y: i - e / 2,
        width: o,
        height: e,
        config: d,
        immediate: !u
    });
    return (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            s.annotations.outline.outlineWidth > 0 && (0, _jsxRuntime.jsx)((0, _web.animated).rect, {
                x: k.x,
                y: k.y,
                rx: r,
                ry: r,
                width: k.width,
                height: k.height,
                style: g({}, s.annotations.outline, {
                    fill: "none",
                    strokeWidth: s.annotations.outline.strokeWidth + 2 * s.annotations.outline.outlineWidth,
                    stroke: s.annotations.outline.outlineColor,
                    opacity: s.annotations.outline.outlineOpacity
                })
            }),
            (0, _jsxRuntime.jsx)((0, _web.animated).rect, {
                x: k.x,
                y: k.y,
                rx: r,
                ry: r,
                width: k.width,
                height: k.height,
                style: s.annotations.outline
            })
        ]
    });
}, R = function(t) {
    var n = t.datum, i = t.x, o = t.y, e = t.note, a = M(t);
    if (!W(e)) throw new Error("note should be a valid react element");
    return (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            (0, _jsxRuntime.jsx)(E, {
                points: a.points,
                isOutline: !0
            }),
            b(t) && (0, _jsxRuntime.jsx)(I, {
                x: i,
                y: o,
                size: t.size
            }),
            w(t) && (0, _jsxRuntime.jsx)(D, {
                x: i,
                y: o,
                size: t.size
            }),
            z(t) && (0, _jsxRuntime.jsx)(L, {
                x: i,
                y: o,
                width: t.width,
                height: t.height,
                borderRadius: t.borderRadius
            }),
            (0, _jsxRuntime.jsx)(E, {
                points: a.points
            }),
            (0, _jsxRuntime.jsx)(T, {
                datum: n,
                x: a.text[0],
                y: a.text[1],
                note: e
            })
        ]
    });
}, q = function(t, n) {
    n.forEach(function(n, i) {
        var o = n[0], e = n[1];
        0 === i ? t.moveTo(o, e) : t.lineTo(o, e);
    });
}, J = function(t, n) {
    var i = n.annotations, o = n.theme;
    0 !== i.length && (t.save(), i.forEach(function(n) {
        if (!v(n.note)) throw new Error("note is invalid for canvas implementation");
        o.annotations.link.outlineWidth > 0 && (t.lineCap = "square", t.strokeStyle = o.annotations.link.outlineColor, t.lineWidth = o.annotations.link.strokeWidth + 2 * o.annotations.link.outlineWidth, t.beginPath(), q(t, n.computed.points), t.stroke(), t.lineCap = "butt"), b(n) && o.annotations.outline.outlineWidth > 0 && (t.strokeStyle = o.annotations.outline.outlineColor, t.lineWidth = o.annotations.outline.strokeWidth + 2 * o.annotations.outline.outlineWidth, t.beginPath(), t.arc(n.x, n.y, n.size / 2, 0, 2 * Math.PI), t.stroke()), w(n) && o.annotations.symbol.outlineWidth > 0 && (t.strokeStyle = o.annotations.symbol.outlineColor, t.lineWidth = 2 * o.annotations.symbol.outlineWidth, t.beginPath(), t.arc(n.x, n.y, n.size / 2, 0, 2 * Math.PI), t.stroke()), z(n) && o.annotations.outline.outlineWidth > 0 && (t.strokeStyle = o.annotations.outline.outlineColor, t.lineWidth = o.annotations.outline.strokeWidth + 2 * o.annotations.outline.outlineWidth, t.beginPath(), t.rect(n.x - n.width / 2, n.y - n.height / 2, n.width, n.height), t.stroke()), t.strokeStyle = o.annotations.link.stroke, t.lineWidth = o.annotations.link.strokeWidth, t.beginPath(), q(t, n.computed.points), t.stroke(), b(n) && (t.strokeStyle = o.annotations.outline.stroke, t.lineWidth = o.annotations.outline.strokeWidth, t.beginPath(), t.arc(n.x, n.y, n.size / 2, 0, 2 * Math.PI), t.stroke()), w(n) && (t.fillStyle = o.annotations.symbol.fill, t.beginPath(), t.arc(n.x, n.y, n.size / 2, 0, 2 * Math.PI), t.fill()), z(n) && (t.strokeStyle = o.annotations.outline.stroke, t.lineWidth = o.annotations.outline.strokeWidth, t.beginPath(), t.rect(n.x - n.width / 2, n.y - n.height / 2, n.width, n.height), t.stroke()), "function" == typeof n.note ? n.note(t, {
            datum: n.datum,
            x: n.computed.text[0],
            y: n.computed.text[1],
            theme: o
        }) : (t.font = o.annotations.text.fontSize + "px " + o.annotations.text.fontFamily, t.textAlign = "left", t.textBaseline = "alphabetic", t.fillStyle = o.annotations.text.fill, t.strokeStyle = o.annotations.text.outlineColor, t.lineWidth = 2 * o.annotations.text.outlineWidth, o.annotations.text.outlineWidth > 0 && (t.lineJoin = "round", t.strokeText(n.note, n.computed.text[0], n.computed.text[1]), t.lineJoin = "miter"), t.fillText(n.note, n.computed.text[0], n.computed.text[1]));
    }), t.restore());
};

},{"react":"6uln9","lodash/filter.js":"e2x7I","lodash/isNumber.js":"kxW10","lodash/omit.js":"kaoh9","@nivo/core":"3e9EB","@react-spring/web":"39JSM","@nivo/theming":"kiBiP","react/jsx-runtime":"gaGEj","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"e2x7I":[function(require,module,exports) {
var arrayFilter = require("a1b76c4f8942e73e"), baseFilter = require("a430472df6f36dc1"), baseIteratee = require("65ac72656eceb615"), isArray = require("458bf6bb1af9daa2");
/**
 * Iterates over elements of `collection`, returning an array of all elements
 * `predicate` returns truthy for. The predicate is invoked with three
 * arguments: (value, index|key, collection).
 *
 * **Note:** Unlike `_.remove`, this method returns a new array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 * @see _.reject
 * @example
 *
 * var users = [
 *   { 'user': 'barney', 'age': 36, 'active': true },
 *   { 'user': 'fred',   'age': 40, 'active': false }
 * ];
 *
 * _.filter(users, function(o) { return !o.active; });
 * // => objects for ['fred']
 *
 * // The `_.matches` iteratee shorthand.
 * _.filter(users, { 'age': 36, 'active': true });
 * // => objects for ['barney']
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.filter(users, ['active', false]);
 * // => objects for ['fred']
 *
 * // The `_.property` iteratee shorthand.
 * _.filter(users, 'active');
 * // => objects for ['barney']
 *
 * // Combining several predicates using `_.overEvery` or `_.overSome`.
 * _.filter(users, _.overSome([{ 'age': 36 }, ['age', 40]]));
 * // => objects for ['fred', 'barney']
 */ function filter(collection, predicate) {
    var func = isArray(collection) ? arrayFilter : baseFilter;
    return func(collection, baseIteratee(predicate, 3));
}
module.exports = filter;

},{"a1b76c4f8942e73e":"hZr2f","a430472df6f36dc1":"63ok9","65ac72656eceb615":"l2cSI","458bf6bb1af9daa2":"2VsjV"}],"63ok9":[function(require,module,exports) {
var baseEach = require("f9b416bbd850c1fb");
/**
 * The base implementation of `_.filter` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */ function baseFilter(collection, predicate) {
    var result = [];
    baseEach(collection, function(value, index, collection) {
        if (predicate(value, index, collection)) result.push(value);
    });
    return result;
}
module.exports = baseFilter;

},{"f9b416bbd850c1fb":"ghpxV"}],"kxW10":[function(require,module,exports) {
var baseGetTag = require("d5df50bb79e32710"), isObjectLike = require("6ae0825ac2dae50f");
/** `Object#toString` result references. */ var numberTag = "[object Number]";
/**
 * Checks if `value` is classified as a `Number` primitive or object.
 *
 * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
 * classified as numbers, use the `_.isFinite` method.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a number, else `false`.
 * @example
 *
 * _.isNumber(3);
 * // => true
 *
 * _.isNumber(Number.MIN_VALUE);
 * // => true
 *
 * _.isNumber(Infinity);
 * // => true
 *
 * _.isNumber('3');
 * // => false
 */ function isNumber(value) {
    return typeof value == "number" || isObjectLike(value) && baseGetTag(value) == numberTag;
}
module.exports = isNumber;

},{"d5df50bb79e32710":"fQG2h","6ae0825ac2dae50f":"5TH1N"}],"kaoh9":[function(require,module,exports) {
var arrayMap = require("edf8d2f2f36e65cf"), baseClone = require("dd27ddc2340179e5"), baseUnset = require("589767d435c41297"), castPath = require("565c158f6d380e60"), copyObject = require("9b4f3122fc9cc1a6"), customOmitClone = require("1c19467b6c51de37"), flatRest = require("24ab2b6e4b71312a"), getAllKeysIn = require("e20a1a7cbb58999e");
/** Used to compose bitmasks for cloning. */ var CLONE_DEEP_FLAG = 1, CLONE_FLAT_FLAG = 2, CLONE_SYMBOLS_FLAG = 4;
/**
 * The opposite of `_.pick`; this method creates an object composed of the
 * own and inherited enumerable property paths of `object` that are not omitted.
 *
 * **Note:** This method is considerably slower than `_.pick`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The source object.
 * @param {...(string|string[])} [paths] The property paths to omit.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.omit(object, ['a', 'c']);
 * // => { 'b': '2' }
 */ var omit = flatRest(function(object, paths) {
    var result = {};
    if (object == null) return result;
    var isDeep = false;
    paths = arrayMap(paths, function(path) {
        path = castPath(path, object);
        isDeep || (isDeep = path.length > 1);
        return path;
    });
    copyObject(object, getAllKeysIn(object), result);
    if (isDeep) result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
    var length = paths.length;
    while(length--)baseUnset(result, paths[length]);
    return result;
});
module.exports = omit;

},{"edf8d2f2f36e65cf":"fahvZ","dd27ddc2340179e5":"an1MV","589767d435c41297":"27Wat","565c158f6d380e60":"Q3Xos","9b4f3122fc9cc1a6":"d4hzg","1c19467b6c51de37":"6IwDc","24ab2b6e4b71312a":"er0dC","e20a1a7cbb58999e":"7yR5S"}],"an1MV":[function(require,module,exports) {
var Stack = require("c3256a0a192955f9"), arrayEach = require("3a79976eb46af94a"), assignValue = require("bc83a05a4f99d69b"), baseAssign = require("e6b4c3e6c85df6bb"), baseAssignIn = require("f340cc553ba5643c"), cloneBuffer = require("e72e99883a50402d"), copyArray = require("dc840ead07f1054"), copySymbols = require("309288e8ee190af0"), copySymbolsIn = require("687fa30fede0b048"), getAllKeys = require("bb0ba724f98b094d"), getAllKeysIn = require("12bae1dca0e83064"), getTag = require("4c3204eaea28d680"), initCloneArray = require("fd7741200b462cdf"), initCloneByTag = require("f93a1d24ac08e076"), initCloneObject = require("630039e80f692f17"), isArray = require("f37949484ab52dae"), isBuffer = require("ac876cc65d29c86e"), isMap = require("1056c031d98783c0"), isObject = require("1800fb3122907fc2"), isSet = require("31f022f648037bd3"), keys = require("5f3267fbd9848a7d"), keysIn = require("7d3f3bdc4f2e7bb8");
/** Used to compose bitmasks for cloning. */ var CLONE_DEEP_FLAG = 1, CLONE_FLAT_FLAG = 2, CLONE_SYMBOLS_FLAG = 4;
/** `Object#toString` result references. */ var argsTag = "[object Arguments]", arrayTag = "[object Array]", boolTag = "[object Boolean]", dateTag = "[object Date]", errorTag = "[object Error]", funcTag = "[object Function]", genTag = "[object GeneratorFunction]", mapTag = "[object Map]", numberTag = "[object Number]", objectTag = "[object Object]", regexpTag = "[object RegExp]", setTag = "[object Set]", stringTag = "[object String]", symbolTag = "[object Symbol]", weakMapTag = "[object WeakMap]";
var arrayBufferTag = "[object ArrayBuffer]", dataViewTag = "[object DataView]", float32Tag = "[object Float32Array]", float64Tag = "[object Float64Array]", int8Tag = "[object Int8Array]", int16Tag = "[object Int16Array]", int32Tag = "[object Int32Array]", uint8Tag = "[object Uint8Array]", uint8ClampedTag = "[object Uint8ClampedArray]", uint16Tag = "[object Uint16Array]", uint32Tag = "[object Uint32Array]";
/** Used to identify `toStringTag` values supported by `_.clone`. */ var cloneableTags = {};
cloneableTags[argsTag] = cloneableTags[arrayTag] = cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] = cloneableTags[boolTag] = cloneableTags[dateTag] = cloneableTags[float32Tag] = cloneableTags[float64Tag] = cloneableTags[int8Tag] = cloneableTags[int16Tag] = cloneableTags[int32Tag] = cloneableTags[mapTag] = cloneableTags[numberTag] = cloneableTags[objectTag] = cloneableTags[regexpTag] = cloneableTags[setTag] = cloneableTags[stringTag] = cloneableTags[symbolTag] = cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] = cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
cloneableTags[errorTag] = cloneableTags[funcTag] = cloneableTags[weakMapTag] = false;
/**
 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
 * traversed objects.
 *
 * @private
 * @param {*} value The value to clone.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Deep clone
 *  2 - Flatten inherited properties
 *  4 - Clone symbols
 * @param {Function} [customizer] The function to customize cloning.
 * @param {string} [key] The key of `value`.
 * @param {Object} [object] The parent object of `value`.
 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
 * @returns {*} Returns the cloned value.
 */ function baseClone(value, bitmask, customizer, key, object, stack) {
    var result, isDeep = bitmask & CLONE_DEEP_FLAG, isFlat = bitmask & CLONE_FLAT_FLAG, isFull = bitmask & CLONE_SYMBOLS_FLAG;
    if (customizer) result = object ? customizer(value, key, object, stack) : customizer(value);
    if (result !== undefined) return result;
    if (!isObject(value)) return value;
    var isArr = isArray(value);
    if (isArr) {
        result = initCloneArray(value);
        if (!isDeep) return copyArray(value, result);
    } else {
        var tag = getTag(value), isFunc = tag == funcTag || tag == genTag;
        if (isBuffer(value)) return cloneBuffer(value, isDeep);
        if (tag == objectTag || tag == argsTag || isFunc && !object) {
            result = isFlat || isFunc ? {} : initCloneObject(value);
            if (!isDeep) return isFlat ? copySymbolsIn(value, baseAssignIn(result, value)) : copySymbols(value, baseAssign(result, value));
        } else {
            if (!cloneableTags[tag]) return object ? value : {};
            result = initCloneByTag(value, tag, isDeep);
        }
    }
    // Check for circular references and return its corresponding clone.
    stack || (stack = new Stack);
    var stacked = stack.get(value);
    if (stacked) return stacked;
    stack.set(value, result);
    if (isSet(value)) value.forEach(function(subValue) {
        result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
    });
    else if (isMap(value)) value.forEach(function(subValue, key) {
        result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
    });
    var keysFunc = isFull ? isFlat ? getAllKeysIn : getAllKeys : isFlat ? keysIn : keys;
    var props = isArr ? undefined : keysFunc(value);
    arrayEach(props || value, function(subValue, key) {
        if (props) {
            key = subValue;
            subValue = value[key];
        }
        // Recursively populate clone (susceptible to call stack limits).
        assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
    });
    return result;
}
module.exports = baseClone;

},{"c3256a0a192955f9":"l4EdS","3a79976eb46af94a":"inYRG","bc83a05a4f99d69b":"9tFgZ","e6b4c3e6c85df6bb":"ajj4d","f340cc553ba5643c":"67pKN","e72e99883a50402d":"36agR","dc840ead07f1054":"7vKch","309288e8ee190af0":"5qpN6","687fa30fede0b048":"6r021","bb0ba724f98b094d":"glOnZ","12bae1dca0e83064":"7yR5S","4c3204eaea28d680":"4Ug8n","fd7741200b462cdf":"cPo3n","f93a1d24ac08e076":"ayIKS","630039e80f692f17":"eUm3n","f37949484ab52dae":"2VsjV","ac876cc65d29c86e":"kfeDT","1056c031d98783c0":"1jnKE","1800fb3122907fc2":"3TlAp","31f022f648037bd3":"jR6kB","5f3267fbd9848a7d":"cu4o9","7d3f3bdc4f2e7bb8":"1kPzt"}],"inYRG":[function(require,module,exports) {
/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */ function arrayEach(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (iteratee(array[index], index, array) === false) break;
    }
    return array;
}
module.exports = arrayEach;

},{}],"ajj4d":[function(require,module,exports) {
var copyObject = require("c7567f70ddd05963"), keys = require("fcf23a0242ef0da9");
/**
 * The base implementation of `_.assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */ function baseAssign(object, source) {
    return object && copyObject(source, keys(source), object);
}
module.exports = baseAssign;

},{"c7567f70ddd05963":"d4hzg","fcf23a0242ef0da9":"cu4o9"}],"67pKN":[function(require,module,exports) {
var copyObject = require("6f2a44bcb454186d"), keysIn = require("7697a1565646c93");
/**
 * The base implementation of `_.assignIn` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */ function baseAssignIn(object, source) {
    return object && copyObject(source, keysIn(source), object);
}
module.exports = baseAssignIn;

},{"6f2a44bcb454186d":"d4hzg","7697a1565646c93":"1kPzt"}],"5qpN6":[function(require,module,exports) {
var copyObject = require("4cc37626612884ad"), getSymbols = require("39cbde2205d9399c");
/**
 * Copies own symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */ function copySymbols(source, object) {
    return copyObject(source, getSymbols(source), object);
}
module.exports = copySymbols;

},{"4cc37626612884ad":"d4hzg","39cbde2205d9399c":"6Cz6a"}],"6r021":[function(require,module,exports) {
var copyObject = require("73fd77060a6bfcff"), getSymbolsIn = require("9b660e6b0c20d303");
/**
 * Copies own and inherited symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */ function copySymbolsIn(source, object) {
    return copyObject(source, getSymbolsIn(source), object);
}
module.exports = copySymbolsIn;

},{"73fd77060a6bfcff":"d4hzg","9b660e6b0c20d303":"4719b"}],"4719b":[function(require,module,exports) {
var arrayPush = require("2f7c7daf8773557"), getPrototype = require("6ccae2aa7cfa3c66"), getSymbols = require("bdb501682ee9305d"), stubArray = require("7641fe4ae6d2cc96");
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeGetSymbols = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own and inherited enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
    var result = [];
    while(object){
        arrayPush(result, getSymbols(object));
        object = getPrototype(object);
    }
    return result;
};
module.exports = getSymbolsIn;

},{"2f7c7daf8773557":"gD9AH","6ccae2aa7cfa3c66":"lvQrI","bdb501682ee9305d":"6Cz6a","7641fe4ae6d2cc96":"1ayha"}],"7yR5S":[function(require,module,exports) {
var baseGetAllKeys = require("f6d6a583609f5bf6"), getSymbolsIn = require("feede5d0a2d06427"), keysIn = require("287f70f798405911");
/**
 * Creates an array of own and inherited enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function getAllKeysIn(object) {
    return baseGetAllKeys(object, keysIn, getSymbolsIn);
}
module.exports = getAllKeysIn;

},{"f6d6a583609f5bf6":"b9Wvk","feede5d0a2d06427":"4719b","287f70f798405911":"1kPzt"}],"cPo3n":[function(require,module,exports) {
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * Initializes an array clone.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the initialized clone.
 */ function initCloneArray(array) {
    var length = array.length, result = new array.constructor(length);
    // Add properties assigned by `RegExp#exec`.
    if (length && typeof array[0] == "string" && hasOwnProperty.call(array, "index")) {
        result.index = array.index;
        result.input = array.input;
    }
    return result;
}
module.exports = initCloneArray;

},{}],"ayIKS":[function(require,module,exports) {
var cloneArrayBuffer = require("d24f0b9a34d2e38a"), cloneDataView = require("dbf04edaab2ae376"), cloneRegExp = require("763300f2dd9bdaf3"), cloneSymbol = require("c30e64d90e4b92d1"), cloneTypedArray = require("d1edd8349e9ad54d");
/** `Object#toString` result references. */ var boolTag = "[object Boolean]", dateTag = "[object Date]", mapTag = "[object Map]", numberTag = "[object Number]", regexpTag = "[object RegExp]", setTag = "[object Set]", stringTag = "[object String]", symbolTag = "[object Symbol]";
var arrayBufferTag = "[object ArrayBuffer]", dataViewTag = "[object DataView]", float32Tag = "[object Float32Array]", float64Tag = "[object Float64Array]", int8Tag = "[object Int8Array]", int16Tag = "[object Int16Array]", int32Tag = "[object Int32Array]", uint8Tag = "[object Uint8Array]", uint8ClampedTag = "[object Uint8ClampedArray]", uint16Tag = "[object Uint16Array]", uint32Tag = "[object Uint32Array]";
/**
 * Initializes an object clone based on its `toStringTag`.
 *
 * **Note:** This function only supports cloning values with tags of
 * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
 *
 * @private
 * @param {Object} object The object to clone.
 * @param {string} tag The `toStringTag` of the object to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the initialized clone.
 */ function initCloneByTag(object, tag, isDeep) {
    var Ctor = object.constructor;
    switch(tag){
        case arrayBufferTag:
            return cloneArrayBuffer(object);
        case boolTag:
        case dateTag:
            return new Ctor(+object);
        case dataViewTag:
            return cloneDataView(object, isDeep);
        case float32Tag:
        case float64Tag:
        case int8Tag:
        case int16Tag:
        case int32Tag:
        case uint8Tag:
        case uint8ClampedTag:
        case uint16Tag:
        case uint32Tag:
            return cloneTypedArray(object, isDeep);
        case mapTag:
            return new Ctor;
        case numberTag:
        case stringTag:
            return new Ctor(object);
        case regexpTag:
            return cloneRegExp(object);
        case setTag:
            return new Ctor;
        case symbolTag:
            return cloneSymbol(object);
    }
}
module.exports = initCloneByTag;

},{"d24f0b9a34d2e38a":"1MB0T","dbf04edaab2ae376":"3fsub","763300f2dd9bdaf3":"gLzHu","c30e64d90e4b92d1":"j15fj","d1edd8349e9ad54d":"iCbSW"}],"3fsub":[function(require,module,exports) {
var cloneArrayBuffer = require("55b473c4a5622b5a");
/**
 * Creates a clone of `dataView`.
 *
 * @private
 * @param {Object} dataView The data view to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned data view.
 */ function cloneDataView(dataView, isDeep) {
    var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
    return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
}
module.exports = cloneDataView;

},{"55b473c4a5622b5a":"1MB0T"}],"gLzHu":[function(require,module,exports) {
/** Used to match `RegExp` flags from their coerced string values. */ var reFlags = /\w*$/;
/**
 * Creates a clone of `regexp`.
 *
 * @private
 * @param {Object} regexp The regexp to clone.
 * @returns {Object} Returns the cloned regexp.
 */ function cloneRegExp(regexp) {
    var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
    result.lastIndex = regexp.lastIndex;
    return result;
}
module.exports = cloneRegExp;

},{}],"j15fj":[function(require,module,exports) {
var Symbol = require("b88cf659c1f1d984");
/** Used to convert symbols to primitives and strings. */ var symbolProto = Symbol ? Symbol.prototype : undefined, symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;
/**
 * Creates a clone of the `symbol` object.
 *
 * @private
 * @param {Object} symbol The symbol object to clone.
 * @returns {Object} Returns the cloned symbol object.
 */ function cloneSymbol(symbol) {
    return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
}
module.exports = cloneSymbol;

},{"b88cf659c1f1d984":"e0ngr"}],"1jnKE":[function(require,module,exports) {
var baseIsMap = require("bcb4b5290583d129"), baseUnary = require("6a7e6b1a2d9fb1d5"), nodeUtil = require("7d4f449dd306450f");
/* Node.js helper references. */ var nodeIsMap = nodeUtil && nodeUtil.isMap;
/**
 * Checks if `value` is classified as a `Map` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 * @example
 *
 * _.isMap(new Map);
 * // => true
 *
 * _.isMap(new WeakMap);
 * // => false
 */ var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;
module.exports = isMap;

},{"bcb4b5290583d129":"UJ564","6a7e6b1a2d9fb1d5":"993qv","7d4f449dd306450f":"ihImP"}],"UJ564":[function(require,module,exports) {
var getTag = require("f59b9932854175ea"), isObjectLike = require("88260e33e0003386");
/** `Object#toString` result references. */ var mapTag = "[object Map]";
/**
 * The base implementation of `_.isMap` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 */ function baseIsMap(value) {
    return isObjectLike(value) && getTag(value) == mapTag;
}
module.exports = baseIsMap;

},{"f59b9932854175ea":"4Ug8n","88260e33e0003386":"5TH1N"}],"jR6kB":[function(require,module,exports) {
var baseIsSet = require("efa5963001bed2f4"), baseUnary = require("3cb35dba719c68b1"), nodeUtil = require("7a3e899a332ff7be");
/* Node.js helper references. */ var nodeIsSet = nodeUtil && nodeUtil.isSet;
/**
 * Checks if `value` is classified as a `Set` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 * @example
 *
 * _.isSet(new Set);
 * // => true
 *
 * _.isSet(new WeakSet);
 * // => false
 */ var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;
module.exports = isSet;

},{"efa5963001bed2f4":"5xVyE","3cb35dba719c68b1":"993qv","7a3e899a332ff7be":"ihImP"}],"5xVyE":[function(require,module,exports) {
var getTag = require("3451ecb010f954cc"), isObjectLike = require("b6fc875bc5f351c9");
/** `Object#toString` result references. */ var setTag = "[object Set]";
/**
 * The base implementation of `_.isSet` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 */ function baseIsSet(value) {
    return isObjectLike(value) && getTag(value) == setTag;
}
module.exports = baseIsSet;

},{"3451ecb010f954cc":"4Ug8n","b6fc875bc5f351c9":"5TH1N"}],"27Wat":[function(require,module,exports) {
var castPath = require("f9ed36b4ad99fc49"), last = require("bbfbe3a50d8efe39"), parent = require("b7b0084465c39aec"), toKey = require("7b9792fcc4179101");
/**
 * The base implementation of `_.unset`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The property path to unset.
 * @returns {boolean} Returns `true` if the property is deleted, else `false`.
 */ function baseUnset(object, path) {
    path = castPath(path, object);
    object = parent(object, path);
    return object == null || delete object[toKey(last(path))];
}
module.exports = baseUnset;

},{"f9ed36b4ad99fc49":"Q3Xos","bbfbe3a50d8efe39":"5Gv7h","b7b0084465c39aec":"9RpVb","7b9792fcc4179101":"e9p91"}],"9RpVb":[function(require,module,exports) {
var baseGet = require("cbcb75b7339c1ad"), baseSlice = require("3443758a32fd0de1");
/**
 * Gets the parent value at `path` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} path The path to get the parent value of.
 * @returns {*} Returns the parent value.
 */ function parent(object, path) {
    return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
}
module.exports = parent;

},{"cbcb75b7339c1ad":"51EsY","3443758a32fd0de1":"5Vnb5"}],"6IwDc":[function(require,module,exports) {
var isPlainObject = require("e34ef634df1bf68a");
/**
 * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
 * objects.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {string} key The key of the property to inspect.
 * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
 */ function customOmitClone(value) {
    return isPlainObject(value) ? undefined : value;
}
module.exports = customOmitClone;

},{"e34ef634df1bf68a":"aYsgZ"}],"jNgY9":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "roundedRect", ()=>o);
var o = function(o, e, r, a, i, u) {
    u > 0 ? (o.moveTo(e + u, r), o.lineTo(e + a - u, r), o.quadraticCurveTo(e + a, r, e + a, r + u), o.lineTo(e + a, r + i - u), o.quadraticCurveTo(e + a, r + i, e + a - u, r + i), o.lineTo(e + u, r + i), o.quadraticCurveTo(e, r + i, e, r + i - u), o.lineTo(e, r + u), o.quadraticCurveTo(e, r, e + u, r), o.closePath()) : o.rect(e, r, a, i);
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"kgrHM":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "IntentsDisplayNamesWithContentItems", ()=>IntentsDisplayNamesWithContentItems);
parcelHelpers.export(exports, "IntentVoicifyNamesWithContentItems", ()=>IntentVoicifyNamesWithContentItems);
parcelHelpers.export(exports, "EXCLUDED_TOP_INTENTS", ()=>EXCLUDED_TOP_INTENTS);
const IntentsDisplayNamesWithContentItems = [
    "General Question",
    "Latest Messages",
    "Yes",
    "No",
    "Number",
    "Stop",
    "Help"
];
const IntentVoicifyNamesWithContentItems = [
    "GeneralQuestion",
    "WhatsNew",
    "Yes",
    "No",
    "Stop",
    "Number",
    "Help"
];
const EXCLUDED_TOP_INTENTS = [
    "Yes",
    "No",
    "Dynamic",
    "Welcome"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"bA5x6":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _base = require("@emotion/styled/base");
var _baseDefault = parcelHelpers.interopDefault(_base);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _customScrollbars = require("../../../components/structure/CustomScrollbars");
var _customScrollbarsDefault = parcelHelpers.interopDefault(_customScrollbars);
var _colors = require("../../../constants/colors");
var _liveChatBubble = require("./LiveChatBubble");
var _liveChatBubbleDefault = parcelHelpers.interopDefault(_liveChatBubble);
var _button = require("../../../components/general/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _sessionAnalyticsContainer = require("../../../hooks/SessionAnalyticsContainer");
var _sessionAnalyticsContainerDefault = parcelHelpers.interopDefault(_sessionAnalyticsContainer);
var _pageError = require("../../../components/general/PageError");
var _pageErrorDefault = parcelHelpers.interopDefault(_pageError);
var _loader = require("../../../components/general/Loader");
var _loaderDefault = parcelHelpers.interopDefault(_loader);
var _analyticsOrderStateContainer = require("../../../hooks/AnalyticsOrderStateContainer");
var _analyticsOrderStateContainerDefault = parcelHelpers.interopDefault(_analyticsOrderStateContainer);
var _tooltipWrapper = require("../../../components/general/TooltipWrapper");
var _tooltipWrapperDefault = parcelHelpers.interopDefault(_tooltipWrapper);
var _confirmationDialog = require("../../../components/structure/ConfirmationDialog");
var _confirmationDialogDefault = parcelHelpers.interopDefault(_confirmationDialog);
var _warningConfirmation = require("../../../components/general/WarningConfirmation");
var _warningConfirmationDefault = parcelHelpers.interopDefault(_warningConfirmation);
var _breakpoints = require("../../../constants/breakpoints");
var _useIsMobile = require("../../../hooks/UseIsMobile");
var _useIsMobileDefault = parcelHelpers.interopDefault(_useIsMobile);
var _testCaseContainer = require("../../../hooks/TestCaseContainer");
var _testCaseContainerDefault = parcelHelpers.interopDefault(_testCaseContainer);
var _editTestCase = require("../../../components/forms/EditTestCase");
var _editTestCaseDefault = parcelHelpers.interopDefault(_editTestCase);
var _sparkContainer = require("../../../hooks/SparkContainer");
var _sparkContainerDefault = parcelHelpers.interopDefault(_sparkContainer);
var _sessionTags = require("../../../components/analytics/SessionTags");
var _sessionTagsDefault = parcelHelpers.interopDefault(_sessionTags);
var _featureFlagIds = require("../../../constants/featureFlagIds");
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const redXIcon = require("67db686bb3ceec74");
const greenCheckIcon = require("fc6a7004cda60771");
const TagsWrapper = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1wnowjq18"
})("display:flex;flex-wrap:wrap;align-items:flex-start;flex:1;min-width:0;", (0, _breakpoints.breakpoint_small), "{width:100%;}");
const StyledSessionTags = /*#__PURE__*/ (0, _baseDefault.default)((0, _sessionTagsDefault.default), {
    target: "e1wnowjq17"
})("margin:6px 0 0 0;", TagsWrapper, " &{margin:0;width:100%;}");
const ButtonsWrapper = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1wnowjq16"
})("display:flex;flex-shrink:0;justify-content:flex-start;", (0, _breakpoints.breakpoint_small), "{flex-wrap:wrap;width:100%;justify-content:flex-start;}");
const RequestDetails = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1wnowjq15"
})("");
const RelativeWrapper = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1wnowjq14"
})("background-color:", (0, _colors.color_shades_lighter), ";&.in-modal{padding-top:16px;}");
const HistoryBody = /*#__PURE__*/ (0, _baseDefault.default)((0, _customScrollbarsDefault.default), {
    target: "e1wnowjq13"
})("color:", (0, _colors.color_shades_darkest), ";background-color:", (0, _colors.color_shades_lighter), ";", (props)=>props.superSimple ? `` : `    margin-top: 16px;
    margin-bottom: 16px;`, " &.in-modal{margin-top:0px;margin-bottom:0px;}", (0, _breakpoints.breakpoint_small), "{width:100%;}");
const AllConversationsContainer = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1wnowjq12"
})({
    name: "xvcdd7",
    styles: "display:flex;flex-direction:column;padding:0px 16px 16px 16px;overflow-wrap:break-word;word-break:break-word;&.scrollable{padding:0px 16px 16px 16px;}"
});
const HiddenDiv = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1wnowjq11"
})({
    name: "eivff4",
    styles: "display:none"
});
const TopLevelDetailsWrapper = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1wnowjq10"
})("display:flex;flex-direction:column;gap:0px;margin-left:44px;", (0, _breakpoints.breakpoint_small), "{gap:0px;margin-left:0;}");
const StyledButton = /*#__PURE__*/ (0, _baseDefault.default)((0, _buttonDefault.default), {
    target: "e1wnowjq9"
})("width:186px;margin-right:8px;margin-left:8px;&:first-of-type{margin-left:4px;}", (0, _breakpoints.breakpoint_small), "{width:auto;min-width:120px;margin:4px;font-size:12px;padding:0 16px;&:first-of-type{margin-left:4px;}}");
const PhoneNumberWrapper = /*#__PURE__*/ (0, _baseDefault.default)("p", {
    target: "e1wnowjq8"
})("margin:0 0 0 4px;color:", (0, _colors.color_text_light), ";font-size:16px;flex-shrink:0;white-space:nowrap;", (0, _breakpoints.breakpoint_small), "{font-size:14px;margin:0;}");
const SessionPhoneAndTagsWrapper = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1wnowjq7"
})({
    name: "1dkdgde",
    styles: "flex-wrap:wrap;display:flex;flex-direction:column"
});
const SparkInlineWrapper = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1wnowjq6"
})("display:flex;justify-content:space-between;align-items:flex-start;gap:8px;", (0, _breakpoints.breakpoint_small), "{flex-direction:column;gap:6px;}");
const PhoneAndTagsRow = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1wnowjq5"
})("display:flex;align-items:flex-start;gap:8px;flex-wrap:wrap;", (0, _breakpoints.breakpoint_small), "{flex-direction:column;gap:4px;}");
const ConversationCallsWrapper = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1wnowjq4"
})("display:flex;flex-direction:column;gap:8px;margin:0 0 12px 44px;", (0, _breakpoints.breakpoint_small), "{margin:0 0 12px 0;}");
const ConversationCallsHeader = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1wnowjq3"
})("font-size:12px;text-transform:uppercase;letter-spacing:0.6px;color:", (0, _colors.color_text_light), ";");
const ConversationCallsList = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1wnowjq2"
})({
    name: "1usszo4",
    styles: "display:flex;flex-wrap:wrap;gap:0;margin-left:-16px"
});
const ConversationCallsLoader = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1wnowjq1"
})({
    name: "iphf1n",
    styles: "display:flex;align-items:center;padding:4px 0"
});
const ConversationCallPill = /*#__PURE__*/ (0, _baseDefault.default)((0, _buttonDefault.default), {
    target: "e1wnowjq0"
})("border-radius:14px;padding:4px 12px;font-size:12px;font-weight:600;margin-right:-4px;cursor:", (props)=>props.clickable ? "pointer" : "default", ";", (props)=>props.active ? `border-color: ${0, _colors.color_shades_darkest};` : "", ";");
const SessionReview = (props)=>{
    const [recordingsAvailable, setRecordingsAvailable] = (0, _react1.useState)(true);
    const [showOrderPlacedConfirmationModal, setShowOrderPlacedConfirmationModal] = (0, _react1.useState)(false);
    const [orderState, setOrderState] = (0, _react1.useState)();
    const [requestIdEvents, setRequestIdEvents] = (0, _react1.useState)([]);
    const [groupedEvents, setGroupedEvents] = (0, _react1.useState)({});
    const [copyButtonText, setCopyButtonText] = (0, _react1.useState)("Copy Transcript");
    const [fromNumber, setFrom] = (0, _react1.useState)("");
    const [sessionTags, setSessionTags] = (0, _react1.useState)([]);
    const [featureFlag, setFeatureFlag] = (0, _react1.useState)(undefined);
    const [showEditTestCaseModal, setShowEditTestCaseModal] = (0, _react1.useState)(false);
    const [testCaseToEdit, setTestCaseToEdit] = (0, _react1.useState)({});
    const [contentItemId, setContentItemId] = (0, _react1.useState)("");
    const [conversationSessions, setConversationSessions] = (0, _react1.useState)([]);
    const [conversationCallsLoading, setConversationCallsLoading] = (0, _react1.useState)(false);
    const [conversationSwitchingSessionId, setConversationSwitchingSessionId] = (0, _react1.useState)(null);
    const lastConversationKeyRef = (0, _react1.useRef)("");
    const lastLoadedSessionIdRef = (0, _react1.useRef)(null);
    const loadedConversationSessionIdsRef = (0, _react1.useRef)(new Set());
    const fallbackAttemptedSessionIdsRef = (0, _react1.useRef)(new Set());
    const sessionContainer = (0, _sessionAnalyticsContainerDefault.default).useContainer();
    const testCaseContainer = (0, _testCaseContainerDefault.default).useContainer();
    const analyticsOrderStateContainer = (0, _analyticsOrderStateContainerDefault.default).useContainer();
    const sparkContainer = (0, _sparkContainerDefault.default).useContainer();
    const isMobile = (0, _useIsMobileDefault.default)();
    (0, _react1.useEffect)(()=>{
        if (copyButtonText === "Copied!") setCopyButtonText("Copy Transcript");
    }, [
        props.events,
        props.applicationId
    ]);
    (0, _react1.useEffect)(()=>{
        let set = false;
        if (props.events?.length) {
            const contentHits = props.events.filter((e)=>e.eventType === "ContentHit" && e?.originalRequest?.sessionAttributes?.callingNumber?.length);
            if (contentHits?.length) {
                const callingNumber = contentHits[0]?.originalRequest?.sessionAttributes?.callingNumber;
                if (callingNumber) {
                    setFrom(callingNumber);
                    set = true;
                }
            }
        }
        if (!set) setFrom("");
    }, [
        props.events
    ]);
    (0, _react1.useEffect)(()=>{
        const flag = getFeatureFlag();
        setFeatureFlag(flag);
    }, [
        props.applicationId,
        props.application?.featureFlags
    ]);
    (0, _react1.useEffect)(()=>{
        setRequestIdEvents(props.events.filter((e)=>e.requestId?.length).filter((e)=>e.eventType !== "ConversationalSuccess"));
    }, [
        props.events
    ]);
    (0, _react1.useEffect)(()=>{
        if (props.tags) setSessionTags(props.tags);
        else {
            const extractedTags = extractTagsFromEvents(props.events);
            setSessionTags(extractedTags);
        }
    }, [
        props.events,
        props.tags
    ]);
    (0, _react1.useEffect)(()=>{
        const groupedEvents = requestIdEvents.reduce((acc, event)=>{
            if (event.requestId in acc) acc[event.requestId].push(event);
            else acc[event.requestId] = [
                event
            ];
            return acc;
        }, {});
        setGroupedEvents(groupedEvents);
    }, [
        requestIdEvents
    ]);
    (0, _react1.useEffect)(()=>{
        let sessionIdToLoad = null;
        if (props.sessionId) sessionIdToLoad = props.sessionId;
        else {
            const url = new URL(window.location.href);
            const params = new URLSearchParams(url.search);
            sessionIdToLoad = params.get("sessionId");
        }
        if (!sessionIdToLoad?.length) return;
        if (lastLoadedSessionIdRef.current === sessionIdToLoad) return;
        lastLoadedSessionIdRef.current = sessionIdToLoad;
        loadEventsForSession(sessionIdToLoad);
    }, [
        window.location.href,
        props.sessionId
    ]);
    (0, _react1.useEffect)(()=>{
        if (props.showConversationCalls === false) {
            setConversationSessions([]);
            setConversationCallsLoading(false);
            setConversationSwitchingSessionId(null);
            return;
        }
        if (!props.events?.length) return;
        const getEventTime = (event)=>{
            if (event?.eventDate) {
                const time = new Date(event.eventDate).getTime();
                if (!isNaN(time)) return time;
            }
            if (event?.timestamp) {
                const ts = typeof event.timestamp === "number" ? event.timestamp : new Date(event.timestamp).getTime();
                if (!isNaN(ts)) return ts;
            }
            return undefined;
        };
        const getEarliestEventDate = (events)=>{
            if (!events?.length) return undefined;
            let earliest = undefined;
            events.forEach((event)=>{
                const time = getEventTime(event);
                if (time !== undefined && (earliest === undefined || time < earliest)) earliest = time;
            });
            return earliest !== undefined ? new Date(earliest) : undefined;
        };
        const getFromNumber = (events)=>{
            if (!events?.length) return undefined;
            const eventWithFrom = events.find((e)=>e?.from?.length || e?.phoneNumber?.length || e?.originalRequest?.sessionAttributes?.callingNumber?.length);
            return eventWithFrom?.from || eventWithFrom?.phoneNumber || eventWithFrom?.originalRequest?.sessionAttributes?.callingNumber;
        };
        const getSessionSummariesValue = (events)=>{
            const engagementMatch = events.find((e)=>e?.eventType === "EngagementEvent" && e?.sessionSummaries);
            if (engagementMatch) return engagementMatch.sessionSummaries;
            const directMatch = events.find((e)=>e?.sessionSummaries);
            if (directMatch) return directMatch.sessionSummaries;
            return undefined;
        };
        const parseSessionSummaries = (sessionSummaries)=>{
            try {
                if (!sessionSummaries) return [];
                let parsed = sessionSummaries;
                for(let i = 0; i < 2; i++){
                    if (typeof parsed === "string") parsed = JSON.parse(parsed);
                    else break;
                }
                if (Array.isArray(parsed)) return parsed.filter((id)=>typeof id === "string" && id.length);
                if (!parsed || typeof parsed !== "object") return [];
                return Object.keys(parsed);
            } catch  {
                return [];
            }
        };
        const normalizePhone = (input)=>{
            if (!input?.length) return undefined;
            const digits = input.replace(/\D/g, "");
            if (!digits.length) return undefined;
            if (digits.length >= 10) return digits.substring(digits.length - 10);
            return digits;
        };
        const getSessionPhone = (session)=>{
            if (session?.from?.length) return session.from;
            if (session?.phoneNumbers?.length) return session.phoneNumbers[0];
            return undefined;
        };
        const buildConversation = async (sessionSummariesValue, currentSessionId)=>{
            const summarySessionIds = parseSessionSummaries(sessionSummariesValue);
            const allSessionIds = new Set(summarySessionIds.filter((id)=>id?.length));
            if (currentSessionId?.length) allSessionIds.add(currentSessionId);
            if (allSessionIds.size <= 1) {
                setConversationSessions([]);
                setConversationCallsLoading(false);
                return;
            }
            const sessionIdList = Array.from(allSessionIds);
            const newKey = sessionIdList.slice().sort().join("|");
            if (lastConversationKeyRef.current === newKey && conversationSessions.length > 0) {
                setConversationCallsLoading(false);
                return;
            }
            lastConversationKeyRef.current = newKey;
            setConversationCallsLoading(true);
            loadedConversationSessionIdsRef.current = new Set();
            const entries = await Promise.all(sessionIdList.map(async (sessionId)=>{
                let events = [];
                if (sessionId === currentSessionId) events = props.events;
                else {
                    const existingEvents = sessionContainer.events?.[sessionId];
                    if (existingEvents?.length) events = existingEvents;
                    else if (loadedConversationSessionIdsRef.current.has(sessionId)) events = [];
                    else {
                        loadedConversationSessionIdsRef.current.add(sessionId);
                        events = await sessionContainer.loadEventsForSession(props.applicationId, sessionId, true, true);
                    }
                }
                return {
                    sessionId,
                    startDate: getEarliestEventDate(events || []),
                    from: getFromNumber(events || [])
                };
            }));
            const sorted = entries.slice().sort((a, b)=>{
                const aTime = a.startDate ? a.startDate.getTime() : Number.POSITIVE_INFINITY;
                const bTime = b.startDate ? b.startDate.getTime() : Number.POSITIVE_INFINITY;
                return aTime - bTime;
            });
            setConversationSessions(sorted);
            setConversationCallsLoading(false);
        };
        const tryFindEngagementFromNearbyCalls = async (currentSessionId)=>{
            if (fallbackAttemptedSessionIdsRef.current.has(currentSessionId)) return;
            fallbackAttemptedSessionIdsRef.current.add(currentSessionId);
            setConversationCallsLoading(true);
            const currentStartDate = getEarliestEventDate(props.events);
            const currentFrom = normalizePhone(getFromNumber(props.events));
            if (!currentStartDate || !currentFrom) {
                setConversationSessions([]);
                setConversationCallsLoading(false);
                return;
            }
            const allSessions = sessionContainer.sessions?.length ? sessionContainer.sessions : sessionContainer.sessionsForReview;
            if (!allSessions?.length) {
                setConversationSessions([]);
                setConversationCallsLoading(false);
                return;
            }
            const windowMs = 1800000;
            const candidates = allSessions.filter((session)=>{
                if (!session?.startDate) return false;
                if (session.sessionId === currentSessionId) return false;
                const sessionPhone = normalizePhone(getSessionPhone(session));
                if (!sessionPhone || sessionPhone !== currentFrom) return false;
                const sessionTime = new Date(session.startDate).getTime();
                return Math.abs(sessionTime - currentStartDate.getTime()) <= windowMs;
            });
            for (const candidate of candidates){
                const candidateEvents = await sessionContainer.loadEventsForSession(props.applicationId, candidate.sessionId, true, true);
                const candidateSummaries = getSessionSummariesValue(candidateEvents || []);
                if (candidateSummaries) {
                    await buildConversation(candidateSummaries, currentSessionId);
                    return;
                }
            }
            setConversationSessions([]);
            setConversationCallsLoading(false);
        };
        const sessionSummariesValue = getSessionSummariesValue(props.events);
        const currentSessionId = props.sessionId || props.events.find((e)=>e.sessionId)?.sessionId;
        if (!currentSessionId?.length) {
            setConversationSessions([]);
            setConversationCallsLoading(false);
            return;
        }
        if (conversationSwitchingSessionId && currentSessionId === conversationSwitchingSessionId) setConversationSwitchingSessionId(null);
        if (sessionSummariesValue) {
            buildConversation(sessionSummariesValue, currentSessionId);
            return;
        }
        tryFindEngagementFromNearbyCalls(currentSessionId);
    }, [
        props.events,
        props.applicationId,
        props.sessionId,
        props.showConversationCalls
    ]);
    (0, _react1.useEffect)(()=>{
        setRecordingsAvailable(true);
    }, [
        props.events,
        props.applicationId
    ]);
    const getFeatureFlag = ()=>{
        if (props.application?.featureFlags?.some((flag)=>flag.id === (0, _featureFlagIds.FoodOrderingFeatureFlagId))) return "FOOD_ORDERING";
        if (props.application?.featureFlags?.some((flag)=>flag.id === (0, _featureFlagIds.HealthcareSchedulingFeatureFlagId))) return "HEALTHCARE";
        return undefined;
    };
    const extractTagsFromEvents = (events)=>{
        const conversationalSuccessEvents = events.filter((e)=>e.eventType === "ConversationalSuccess");
        if (conversationalSuccessEvents.length > 0) {
            const latestEvent = conversationalSuccessEvents[conversationalSuccessEvents.length - 1];
            return latestEvent.sessionTags || [];
        } else return [];
    };
    const loadOrderState = (events)=>{
        const itemAddedToOrderEvents = events?.find((e)=>e.eventType === "ItemAddedToOrder");
        const analyticsOrderState = analyticsOrderStateContainer.getStoredAnalyticsOrderState();
        if (itemAddedToOrderEvents) {
            const orderPlacedEvent = events?.find((e)=>e.eventType === "OrderPlaced");
            if (orderPlacedEvent) setOrderState("orderPlaced");
            else {
                const orderPlacedInLocalStorage = analyticsOrderState[events[0].sessionId]?.orderPlaced;
                if (orderPlacedInLocalStorage) setOrderState("orderPlaced");
                else setOrderState("orderNotPlaced");
            }
        }
    };
    const loadEventsForSession = async (sessionId, forceLoad)=>{
        let eventsForSession = [];
        if (forceLoad) eventsForSession = await sessionContainer.loadEventsForSession(props.applicationId, sessionId, forceLoad);
        else eventsForSession = await sessionContainer.loadEventsForSession(props.applicationId, sessionId);
        if (eventsForSession.length > 0) loadOrderState(eventsForSession);
    };
    const AlwaysScrollToBottom = ()=>{
        const elementRef = (0, _react1.useRef)();
        (0, _react1.useEffect)(()=>elementRef.current.scrollIntoView());
        return (0, _react.jsx)("div", {
            ref: elementRef
        });
    };
    const loadRecording = async (processed)=>{
        const sessionId = props.events.find((e)=>e.sessionId?.length)?.sessionId;
        const recordingUrl = await sessionContainer.getRecordingUrl(props.applicationId, sessionId, processed);
        if (recordingUrl?.length) // open url in new tab
        window.open(recordingUrl, "_blank");
        else setRecordingsAvailable(false);
    };
    const copyText = (text)=>{
        navigator.clipboard.writeText(text);
    };
    const formatPhoneNumber = (phoneNumber)=>{
        // Remove any non-digit characters from the input number
        const cleanedNumber = phoneNumber?.replace(/\D/g, "");
        const formattedNumber = `(${cleanedNumber?.substring(1, 4)}) ${cleanedNumber?.substring(4, 7)}-${cleanedNumber?.substring(7)}`;
        return formattedNumber;
    };
    const stripSsml = (ssml)=>{
        return ssml.replace(/<[^>]*>/g, "");
    };
    const handleCreateTestCase = async (events)=>{
        const testCase = createTestCase(events);
        setTestCaseToEdit(testCase);
        setShowEditTestCaseModal(true);
    };
    const createTestCase = (events)=>{
        const contentHit = events.find((e)=>e.eventType === "ContentHit");
        const contentItemIdEvents = events.find((e)=>e?.contentId?.length > 0);
        setContentItemId(contentItemIdEvents.contentId);
        if (contentHit?.originalRequest !== null) {
            const testCase = {};
            testCase.text = contentHit.originalRequest.originalInput;
            testCase.sessionState = {
                sessionAttributes: contentHit.originalRequest.sessionAttributes,
                sessionFlags: contentHit.originalRequest.sessionFlags,
                id: contentHit.originalRequest.sessionId
            };
            testCase.userProfile = {
                userId: contentHit.originalRequest.userId,
                userAttributes: contentHit.originalRequest.userAttributes,
                userFlags: contentHit.originalRequest.userFlags
            };
            testCase.name = `New Test Case`;
            if (testCase.sessionState.sessionAttributes["conversationTurnHistoryState"]) {
                testCase.sessionState.sessionAttributes["ConversationTurnHistoryState"] = testCase.sessionState.sessionAttributes["conversationTurnHistoryState"];
                delete testCase.sessionState.sessionAttributes["conversationTurnHistoryState"];
            }
            contentHit?.contentItemId?.length;
            return testCase;
        }
        return {};
    };
    const saveTestCase = async (testCase)=>{
        await testCaseContainer.createTestCase(props.applicationId, testCase);
    };
    // Order state functions
    const markAsOrderPlaced = async ()=>{
        const applicationId = props.applicationId;
        let sessionId;
        if (props.sessionId) sessionId = props.sessionId;
        else sessionId = props.events.find((e)=>e.sessionId?.length)?.sessionId;
        const markOrderAsPlacedResponse = await analyticsOrderStateContainer.markOrderAsPlaced(applicationId, sessionId);
        if (markOrderAsPlacedResponse.resultType === "Ok") {
            setOrderState("orderPlaced");
            // store state in local storage
            const analyticsOrderState = analyticsOrderStateContainer.getStoredAnalyticsOrderState();
            if (analyticsOrderState[sessionId]) analyticsOrderState[sessionId].orderPlaced = true;
            else analyticsOrderState[sessionId] = {
                orderPlaced: true
            };
            analyticsOrderStateContainer.storeAnalyticsOrderState(analyticsOrderState);
        }
        toggleOrderPlacedConfirmationModal();
    };
    const toggleOrderPlacedConfirmationModal = ()=>{
        setShowOrderPlacedConfirmationModal(!showOrderPlacedConfirmationModal);
    };
    // Transcript generation functions
    const copyTranscript = ()=>{
        var transcript = "";
        Object.keys(groupedEvents).forEach((requestId, idx)=>{
            const events = groupedEvents[requestId];
            const requestRecEvents = events.filter((e)=>e.eventType === "RequestReceived");
            const contentHitEvents = events.filter((e)=>e.eventType === "ContentHit");
            const userMarkdown = generateUserMarkdown(requestRecEvents, contentHitEvents, idx === 0, true);
            const botMarkdown = generateBotMarkdown(events, true);
            if (userMarkdown === "Unknown" && botMarkdown === "Unknown") return;
            if (userMarkdown?.length && userMarkdown !== "Start Conversation") transcript += `User: ${userMarkdown}\n\n`;
            if (botMarkdown?.length) transcript += `Assistant: ${botMarkdown}\n\n`;
        });
        if (transcript?.length) copyText(transcript);
    };
    const renderRequestEventBubbles = (reqId, events, idx)=>{
        if (events?.length && events.every((e)=>e.eventType === "CallComplete")) return (0, _react.jsx)(HiddenDiv, {
            key: idx
        });
        // request recieved on left, assistant speach started and content hit on right
        const requestRecEvents = events.filter((e)=>e.eventType === "RequestReceived");
        const contentHitEvents = events.filter((e)=>e.eventType === "ContentHit");
        const userMarkdown = generateUserMarkdown(requestRecEvents, contentHitEvents, idx === 0);
        let botMarkdown = generateBotMarkdown(events);
        const userInvalid = !userMarkdown?.length || userMarkdown === "Unknown";
        const botInvalid = !botMarkdown?.length || botMarkdown === "Unknown";
        if (userInvalid && botInvalid) return (0, _react.jsx)((0, _reactDefault.default).Fragment, null);
        if (botMarkdown.includes("??")) botMarkdown = botMarkdown.replace("??", "");
        return (0, _react.jsx)(RequestDetails, {
            key: `${idx}-${reqId}`
        }, userInvalid ? (0, _react.jsx)((0, _reactDefault.default).Fragment, null) : (0, _react.jsx)((0, _reactDefault.default).Fragment, null, (0, _react.jsx)((0, _liveChatBubbleDefault.default), {
            simple: props.simple,
            markdown: userMarkdown,
            userBubbleStyle: props.userBubbleStyle,
            sender: "user",
            showCodeModal: ()=>props.setEventsToShow(events),
            createTestCase: ()=>handleCreateTestCase(events),
            forceMobile: props.mobileBubbles,
            title: `${contentHitEvents[0]?.response?.data?.title}(${idx})`
        })), botInvalid ? (0, _react.jsx)((0, _reactDefault.default).Fragment, null) : (0, _react.jsx)((0, _reactDefault.default).Fragment, null, (0, _react.jsx)((0, _liveChatBubbleDefault.default), {
            userBubbleStyle: props.userBubbleStyle,
            forceMobile: props.mobileBubbles,
            markdown: botMarkdown,
            sender: "bot",
            title: `${contentHitEvents[0]?.response?.data?.title}(${idx})`,
            simple: props.simple
        })));
    };
    const generateUserMarkdown = (requestEvents, contentHitEvents, first, simpleOverride = false)=>{
        if (props.simple || simpleOverride) {
            // get last events
            if (requestEvents?.length) {
                const lastRequest = requestEvents[requestEvents.length - 1];
                if (lastRequest.utterance?.length) return lastRequest.utterance;
            }
            if (contentHitEvents?.length) {
                const lastContentHit = contentHitEvents[contentHitEvents.length - 1];
                if (lastContentHit?.originalRequest?.nlp?.utterance?.length) return lastContentHit?.originalRequest?.nlp?.utterance;
                else if (lastContentHit && !first) return "Detailed analytics not available";
            }
            return first ? "Start Conversation" : "Unknown";
        }
        let md = "";
        for(let i = 0; i < requestEvents.length; i++){
            const event = requestEvents[i];
            let utterance = event.utterance;
            if (!utterance?.length) {
                // check if content hit array has same index
                const contentHitEvent = contentHitEvents[i];
                utterance = contentHitEvent?.originalRequest?.nlp?.utterance;
                if (!utterance && contentHitEvent && !first) utterance = "Detailed analytics not available";
            }
            md = `${md}${utterance ?? (first ? "Start Conversation" : "Unknown")}\n\n`;
        }
        return md;
    };
    const generateBotMarkdown = (responseEvents, simpleOverride = false)=>{
        const contentHits = responseEvents.filter((e)=>e.eventType === "ContentHit");
        if (!contentHits?.length && props.requireSpeech) return "Unknown"; // if we don't have a content hit then we won't have an assistant speech started for a full assistant response. 
        if (props.simple || simpleOverride) {
            // get speech started and ended events
            const assistantSpeechStarted = responseEvents.filter((e)=>e.eventType === "AssistantSpeechStarted");
            const assistantSpeechEnded = responseEvents.filter((e)=>e.eventType === "AssistantSpeechEnded");
            if (assistantSpeechStarted?.length) {
                const speechTexts = [];
                const validSpeechEvents = [];
                for (const startedEvent of assistantSpeechStarted){
                    // Find the corresponding ended event
                    const correspondingEndedEvent = assistantSpeechEnded.find((endedEvent)=>endedEvent.speechText === startedEvent.speechText && new Date(endedEvent.eventDate || endedEvent.timestamp).getTime() > new Date(startedEvent.eventDate || startedEvent.timestamp).getTime());
                    // Include speech text if:
                    // 1. No corresponding ended event found, OR
                    // 2. Corresponding ended event found but early property is not true
                    if (!correspondingEndedEvent || !correspondingEndedEvent.early) {
                        if (startedEvent?.speechText?.length) {
                            validSpeechEvents.push(startedEvent);
                            speechTexts.push(stripSsml(startedEvent.speechText));
                        }
                    }
                }
                // if we found no speech texts that qualify then add the last speechstarted event that we have
                if (speechTexts.length === 0 && assistantSpeechStarted.length > 0) {
                    const lastSpeechStarted = assistantSpeechStarted[assistantSpeechStarted.length - 1];
                    if (lastSpeechStarted?.speechText?.length) {
                        validSpeechEvents.push(lastSpeechStarted);
                        speechTexts.push(stripSsml(lastSpeechStarted.speechText));
                    }
                }
                if (speechTexts.length > 0) {
                    const noVoiceTagUsed = validSpeechEvents.some((e)=>!e.speechText?.includes("vfyvoice"));
                    // check if all speechTexts are teh same
                    const sameSpeechTexts = speechTexts.every((text)=>text === speechTexts[0]);
                    // Add timeline prefixes if there are multiple speech events
                    if (validSpeechEvents.length > 1 && noVoiceTagUsed) {
                        const firstEventTime = new Date(validSpeechEvents[0].eventDate || validSpeechEvents[0].timestamp).getTime();
                        const timedSpeechTexts = validSpeechEvents.map((event, index)=>{
                            if (index === 0) return `${stripSsml(event.speechText)}`;
                            else {
                                const currentEventTime = new Date(event.eventDate || event.timestamp).getTime();
                                const elapsedSeconds = ((currentEventTime - firstEventTime) / 1000).toFixed(1);
                                // elapsed seconds should be rounded to one decimal place if its .0 then just return seconds
                                if (elapsedSeconds.endsWith(".0")) return `${stripSsml(event.speechText)}`;
                                return `${stripSsml(event.speechText)}`;
                            }
                        });
                        return timedSpeechTexts.join("\n\n");
                    } else if (validSpeechEvents.length > 1 && !noVoiceTagUsed && sameSpeechTexts) return speechTexts[0];
                    else return speechTexts.join("\n\n");
                } else if (assistantSpeechStarted.length > 0) return "Detailed analytics not available";
            }
            if (contentHits?.length && !props.requireSpeech) {
                const lastContentHit = contentHits[contentHits.length - 1];
                if (lastContentHit?.response?.data?.content?.length) return stripSsml(lastContentHit?.response?.data?.content);
                else if (lastContentHit) return "Detailed analytics not available";
            }
            return "Unknown";
        }
        let md = "";
        if (contentHits?.length) md = `${md}#### Content Hits: ${contentHits.length}\n&nbsp;\n\n`;
        const anyAssistantSpeech = responseEvents.find((e)=>e.eventType === "AssistantSpeechStarted");
        for (const event of responseEvents){
            if (event.eventType == "AssistantSpeechEnded") {
                if (event.early) {
                    if (event.secondsSpoken) // round seconds spoken to one decimal
                    md = `${md}#### Assistant interrupted after ${event?.secondsSpoken?.toFixed(1) ?? "?"} seconds\n&nbsp;\n`;
                    else md = `${md}#### Assistant interrupted\n&nbsp;\n`;
                }
            } else if (event.eventType == "AssistantSpeechStarted") {
                // compare event date of events
                // count number of assistant speech paused after this speech started
                const assistantSpeechPaused = responseEvents.filter((e)=>e.eventType === "AssistantSpeechPaused" && e.timestamp > event.timestamp && !responseEvents.some((se)=>se.eventType === "AssistantSpeechStarted" && se.timestamp > event.timestamp && se.timestamp < e.timestamp));
                if (assistantSpeechPaused?.length) md = `${md}#### Assistant Speech (Paused ${assistantSpeechPaused.length} times)\n`;
                else md = `${md}#### Assistant Speech\n`;
                md = `${md}${stripSsml(event?.speechText ?? "unknown")}\n\n&nbsp;\n`;
            } else if (event.eventType == "ContentHit") {
                if (!anyAssistantSpeech) md = `${md}${stripSsml(event?.response?.data?.content ?? "unknown")}\n\n&nbsp;\n\n`;
            } else if (event.eventType == "OrderPlaced") md = `${md}#### Order placed with ${event?.totalItems ?? 0} \n&nbsp;\n\n`;
            else if (event.eventType == "Frustration") md = `${md}#### Frustration detected \n&nbsp;\n\n`;
            else if (event.eventType == "ItemAddedToOrder") md = `${md}#### Item(s) added to order \n&nbsp;\n\n`;
            else if (event.eventType == "CallTransferred") md = `${md}#### Call transferred \n&nbsp;\n\n`;
            else if (event.eventType == "ImmediateTransfer") md = `${md}#### Immediate Transfer \n&nbsp;\n\n`;
        }
        // more exact trim
        while(md.endsWith("\n") || md.endsWith("&nbsp;")){
            // if md ends with \n, remove it
            if (md.endsWith("\n")) md = md.slice(0, -1);
            // if md ends with &nbsp;, remove it
            if (md.endsWith("&nbsp;")) md = md.slice(0, -6);
        }
        return md;
    };
    const generateCallCompleteMarkdown = (event)=>{
        let callEnder = event.callEnder?.charAt(0).toUpperCase() + event.callEnder?.slice(1);
        // In spark, If duration is less than 20 seconds or callEnder is not available, just say call completed
        // or if callEnder is not available, just say call completed
        if (sparkContainer.inSpark && (event.duration < 20 || !callEnder) || !callEnder) return `Call Completed\n\nDuration: ${event.duration} seconds\n\n\n\n`;
        return `Call Ended By ${callEnder}\n\nDuration: ${event.duration} seconds\n\n\n\n`;
    };
    const callComplete = props.events.find((e)=>e.eventType === "CallComplete");
    const renderConversationCalls = ()=>{
        if (props.showConversationCalls === false) return null;
        if (conversationCallsLoading) return (0, _react.jsx)(ConversationCallsWrapper, null, (0, _react.jsx)(ConversationCallsHeader, null, "Calls in Conversation Thread"), (0, _react.jsx)(ConversationCallsList, null, (0, _react.jsx)(ConversationCallPill, {
            clickable: false,
            themes: [
                "secondary-small"
            ],
            text: "Loading...",
            onClick: null,
            type: "button"
        })));
        if (!conversationSessions?.length || conversationSessions.length <= 1) return null;
        const currentSessionId = props.sessionId || props.events.find((e)=>e.sessionId)?.sessionId;
        return (0, _react.jsx)(ConversationCallsWrapper, null, (0, _react.jsx)(ConversationCallsHeader, null, "Calls in Conversation Thread (", conversationSessions.length, ")"), conversationSwitchingSessionId ? (0, _react.jsx)(ConversationCallsLoader, null, (0, _react.jsx)((0, _loaderDefault.default), {
            static: true
        })) : null, (0, _react.jsx)(ConversationCallsList, null, conversationSessions.map((session, idx)=>{
            const isActive = session.sessionId === currentSessionId;
            const timeLabel = `Call #${idx + 1}`;
            return (0, _react.jsx)(ConversationCallPill, {
                key: session.sessionId,
                active: isActive,
                clickable: !!props.onSessionSelect,
                themes: [
                    "secondary-small"
                ],
                text: timeLabel,
                onClick: ()=>{
                    if (session.sessionId === currentSessionId) return;
                    setConversationSwitchingSessionId(session.sessionId);
                    props.onSessionSelect?.(session.sessionId);
                },
                type: "button"
            });
        })));
    };
    return (0, _react.jsx)("div", null, showEditTestCaseModal && (0, _react.jsx)((0, _editTestCaseDefault.default), {
        initialValue: testCaseToEdit,
        onSave: (tc)=>saveTestCase(tc),
        onClose: ()=>setShowEditTestCaseModal(false),
        isContentItemView: false
    }), (0, _react.jsx)(RelativeWrapper, {
        id: "session-review",
        key: props?.events[0]?.sessionId,
        style: {
            height: props.forcedHeight ? props.forcedHeight : props.manualHeight ? `${props.manualHeight}px` : "500px"
        },
        className: `${props.inModal ? " in-modal" : ""}`
    }, showOrderPlacedConfirmationModal && (0, _react.jsx)((0, _confirmationDialogDefault.default), {
        title: `Mark Order as Placed`,
        deleteText: "Yes, Mark Order as Placed",
        onClose: toggleOrderPlacedConfirmationModal,
        onConfirm: ()=>markAsOrderPlaced(),
        warning: true
    }, (0, _react.jsx)((0, _warningConfirmationDefault.default), {
        text: `Are you sure you want to mark this order as placed?`,
        useWarningColor: true
    })), (0, _react.jsx)(HistoryBody, {
        className: `chats-history-scrollable-body${props.hideBorder ? " hide-border" : ""}${props.inModal ? " in-modal" : ""}`,
        autoHide: true,
        autoHeight: true,
        superSimple: props.superSimple,
        autoHeightMin: props.forcedHeight ? props.forcedHeight : undefined,
        autoHeightMax: props.forcedHeight ? props.forcedHeight : `${isMobile ? `calc(100vh - 200px)` : props.inModal ? "calc(100vh - 280px)" : `calc(100vh - 250px)`}`
    }, (0, _react.jsx)(AllConversationsContainer, {
        className: `chats-conversations-container scrollable`
    }, renderConversationCalls(), (0, _react.jsx)(TopLevelDetailsWrapper, null, props.superSimple ? (0, _react.jsx)((0, _reactDefault.default).Fragment, null) : sparkContainer.inSpark ? // Spark: Inline layout (phone/tags and buttons on same row)
    (0, _react.jsx)(SparkInlineWrapper, null, props.showFrom && fromNumber?.length ? (0, _react.jsx)(SessionPhoneAndTagsWrapper, null, (0, _react.jsx)(PhoneNumberWrapper, null, formatPhoneNumber(fromNumber)), (0, _react.jsx)(StyledSessionTags, {
        tags: sessionTags,
        featureFlag: featureFlag
    })) : (0, _react.jsx)(SessionPhoneAndTagsWrapper, null, (0, _react.jsx)(StyledSessionTags, {
        tags: sessionTags,
        featureFlag: featureFlag
    })), (0, _react.jsx)(ButtonsWrapper, null, orderState && !sessionContainer.simpleView && (0, _react.jsx)((0, _tooltipWrapperDefault.default), {
        text: orderState === "orderPlaced" ? "This order has been marked as placed and cannot be updated." : "Click here to mark this order as placed.",
        place: "right"
    }, (0, _react.jsx)("div", null, (0, _react.jsx)(StyledButton, {
        loading: analyticsOrderStateContainer.isLoading || sessionContainer.loadingEvents,
        disabled: orderState === "orderPlaced" ? true : false,
        themes: [
            "secondary-small"
        ],
        text: orderState === "orderPlaced" ? "Order Placed" : "Order Not Placed",
        onClick: ()=>toggleOrderPlacedConfirmationModal(),
        type: "button",
        rightIcon: orderState === "orderPlaced" ? greenCheckIcon : redXIcon
    }))), (!props?.simple || sparkContainer.inSpark) && (0, _react.jsx)(StyledButton, {
        disabled: false,
        themes: [
            "secondary-small"
        ],
        text: sparkContainer.inSpark ? "All Events" : "All Events JSON",
        onClick: ()=>{
            props.setEventsToShow(props.events);
            if (props.resetCopyButtonText) props.resetCopyButtonText();
        },
        type: "button"
    }), recordingsAvailable && !props.superSimple ? (0, _react.jsx)(StyledButton, {
        disabled: false,
        themes: [
            "secondary-small"
        ],
        text: "Recording",
        onClick: ()=>{
            loadRecording(false);
            if (props?.resetCopyButtonText) props?.resetCopyButtonText();
        },
        type: "button"
    }) : (0, _react.jsx)((0, _reactDefault.default).Fragment, null), !props?.superSimple && (0, _react.jsx)(StyledButton, {
        disabled: false,
        themes: [
            "secondary-small"
        ],
        text: copyButtonText,
        onClick: ()=>{
            copyTranscript();
            setCopyButtonText("Copied!");
        },
        type: "button"
    }))) : sessionContainer.simpleView ? // Simple view: Stack tags vertically
    (0, _react.jsx)((0, _reactDefault.default).Fragment, null, props.showFrom && fromNumber?.length ? (0, _react.jsx)(SessionPhoneAndTagsWrapper, null, (0, _react.jsx)(PhoneNumberWrapper, null, formatPhoneNumber(fromNumber)), (0, _react.jsx)(StyledSessionTags, {
        tags: sessionTags,
        featureFlag: featureFlag
    })) : (0, _react.jsx)(SessionPhoneAndTagsWrapper, null, (0, _react.jsx)(StyledSessionTags, {
        tags: sessionTags,
        featureFlag: featureFlag
    })), (0, _react.jsx)(ButtonsWrapper, null, orderState && !sessionContainer.simpleView && (0, _react.jsx)((0, _tooltipWrapperDefault.default), {
        text: orderState === "orderPlaced" ? "This order has been marked as placed and cannot be updated." : "Click here to mark this order as placed.",
        place: "right"
    }, (0, _react.jsx)("div", null, (0, _react.jsx)(StyledButton, {
        loading: analyticsOrderStateContainer.isLoading || sessionContainer.loadingEvents,
        disabled: orderState === "orderPlaced" ? true : false,
        themes: [
            "secondary-small"
        ],
        text: orderState === "orderPlaced" ? "Order Placed" : "Order Not Placed",
        onClick: ()=>toggleOrderPlacedConfirmationModal(),
        type: "button",
        rightIcon: orderState === "orderPlaced" ? greenCheckIcon : redXIcon
    }))), (!props?.simple || sparkContainer.inSpark) && (0, _react.jsx)(StyledButton, {
        disabled: false,
        themes: [
            "secondary-small"
        ],
        text: sparkContainer.inSpark ? "All Events" : "All Events JSON",
        onClick: ()=>{
            props.setEventsToShow(props.events);
            if (props.resetCopyButtonText) props.resetCopyButtonText();
        },
        type: "button"
    }), recordingsAvailable && !props.superSimple ? (0, _react.jsx)(StyledButton, {
        disabled: false,
        themes: [
            "secondary-small"
        ],
        text: "Recording",
        onClick: ()=>{
            loadRecording(false);
            if (props?.resetCopyButtonText) props?.resetCopyButtonText();
        },
        type: "button"
    }) : (0, _react.jsx)((0, _reactDefault.default).Fragment, null), !props?.superSimple && (0, _react.jsx)(StyledButton, {
        disabled: false,
        themes: [
            "secondary-small"
        ],
        text: copyButtonText,
        onClick: ()=>{
            copyTranscript();
            setCopyButtonText("Copied!");
        },
        type: "button"
    }))) : // Non-simple view: Position tags to the right of phone number, above buttons
    (0, _react.jsx)((0, _reactDefault.default).Fragment, null, (0, _react.jsx)(PhoneAndTagsRow, null, props.showFrom && fromNumber?.length && (0, _react.jsx)(PhoneNumberWrapper, null, formatPhoneNumber(fromNumber)), (0, _react.jsx)(TagsWrapper, null, (0, _react.jsx)(StyledSessionTags, {
        tags: sessionTags,
        featureFlag: featureFlag
    }))), (0, _react.jsx)(ButtonsWrapper, null, orderState && !sessionContainer.simpleView && (0, _react.jsx)((0, _tooltipWrapperDefault.default), {
        text: orderState === "orderPlaced" ? "This order has been marked as placed and cannot be updated." : "Click here to mark this order as placed.",
        place: "right"
    }, (0, _react.jsx)("div", null, (0, _react.jsx)(StyledButton, {
        loading: analyticsOrderStateContainer.isLoading || sessionContainer.loadingEvents,
        disabled: orderState === "orderPlaced" ? true : false,
        themes: [
            "secondary-small"
        ],
        text: orderState === "orderPlaced" ? "Order Placed" : "Order Not Placed",
        onClick: ()=>toggleOrderPlacedConfirmationModal(),
        type: "button",
        rightIcon: orderState === "orderPlaced" ? greenCheckIcon : redXIcon
    }))), (!props?.simple || sparkContainer.inSpark) && (0, _react.jsx)(StyledButton, {
        disabled: false,
        themes: [
            "secondary-small"
        ],
        text: sparkContainer.inSpark ? "All Events" : "All Events JSON",
        onClick: ()=>{
            props.setEventsToShow(props.events);
            if (props.resetCopyButtonText) props.resetCopyButtonText();
        },
        type: "button"
    }), recordingsAvailable && !props.superSimple ? (0, _react.jsx)(StyledButton, {
        disabled: false,
        themes: [
            "secondary-small"
        ],
        text: "Recording",
        onClick: ()=>{
            loadRecording(false);
            if (props?.resetCopyButtonText) props?.resetCopyButtonText();
        },
        type: "button"
    }) : (0, _react.jsx)((0, _reactDefault.default).Fragment, null), !props?.superSimple && (0, _react.jsx)(StyledButton, {
        disabled: false,
        themes: [
            "secondary-small"
        ],
        text: copyButtonText,
        onClick: ()=>{
            copyTranscript();
            setCopyButtonText("Copied!");
        },
        type: "button"
    })))), Object.keys(groupedEvents).map((requestId, idx)=>{
        return renderRequestEventBubbles(requestId, groupedEvents[requestId], idx);
    }), callComplete && !props.superSimple && (0, _react.jsx)((0, _liveChatBubbleDefault.default), {
        userBubbleStyle: props.userBubbleStyle,
        markdown: generateCallCompleteMarkdown(callComplete),
        sender: "bot"
    })), props.inModal ? (0, _react.jsx)(AlwaysScrollToBottom, null) : (0, _react.jsx)((0, _reactDefault.default).Fragment, null)), (0, _react.jsx)((0, _pageErrorDefault.default), {
        errors: sessionContainer.error?.length ? [
            sessionContainer.error
        ] : null
    }), (0, _react.jsx)((0, _pageErrorDefault.default), {
        errors: analyticsOrderStateContainer.errors?.length ? analyticsOrderStateContainer.errors : null
    })));
};
exports.default = SessionReview;

},{"@emotion/styled/base":"lSuFu","@emotion/react":"djZKr","react":"6uln9","../../../components/structure/CustomScrollbars":"50vFq","../../../constants/colors":"1p3OR","./LiveChatBubble":"ekvF1","../../../components/general/Button":"6ymxN","../../../hooks/SessionAnalyticsContainer":"vk8Qc","../../../components/general/PageError":"ezFTm","../../../components/general/Loader":"bnV5T","../../../hooks/AnalyticsOrderStateContainer":"bf7Hw","../../../components/general/TooltipWrapper":"53pWd","../../../components/structure/ConfirmationDialog":"kx7yK","../../../components/general/WarningConfirmation":"9OccO","../../../constants/breakpoints":"2F01A","../../../hooks/UseIsMobile":"9Gz1L","../../../hooks/TestCaseContainer":"cLg3U","../../../components/forms/EditTestCase":"ePcs7","../../../hooks/SparkContainer":"jzXzx","../../../components/analytics/SessionTags":"ksD4K","../../../constants/featureFlagIds":"33vuW","67db686bb3ceec74":"1qcKY","fc6a7004cda60771":"l99Or","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"ekvF1":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _base = require("@emotion/styled/base");
var _baseDefault = parcelHelpers.interopDefault(_base);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _conversationMarkdown = require("./ConversationMarkdown");
var _conversationMarkdownDefault = parcelHelpers.interopDefault(_conversationMarkdown);
var _colors = require("../../../constants/colors");
var _button = require("../../../components/general/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _breakpoints = require("../../../constants/breakpoints");
var _useIsMobile = require("../../../hooks/UseIsMobile");
var _useIsMobileDefault = parcelHelpers.interopDefault(_useIsMobile);
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const deviceIcon = require("6159f5cf30c81ba4");
const userAvatar = require("73e845e630c6a716");
const LiveChatBubble = ({ markdown, sender, showCodeModal, createTestCase, simple, forceMobile, userBubbleStyle, title })=>{
    const isMobile = (0, _useIsMobileDefault.default)();
    if (sender === "user") return (0, _react.jsx)(ConversationContainer, null, (0, _react.jsx)(BotAvatar, {
        src: userAvatar
    }), (0, _react.jsx)(BotConversation, {
        mobile: forceMobile
    }, !simple && (0, _react.jsx)(TitleWrapper, null, (0, _react.jsx)(Title, null, title)), (0, _react.jsx)((0, _conversationMarkdownDefault.default), {
        className: "content-container",
        conversationText: markdown
    })), !simple && !forceMobile && !isMobile && (0, _react.jsx)(StyledButton, {
        disabled: false,
        themes: [
            "secondary-small"
        ],
        text: "Create Test Case",
        onClick: ()=>createTestCase(),
        type: "button"
    }), !simple && !forceMobile && !isMobile && (0, _react.jsx)(StyledButton, {
        disabled: false,
        themes: [
            "secondary-small"
        ],
        text: "Full Interaction JSON",
        onClick: ()=>showCodeModal(),
        type: "button"
    }));
    else return (0, _react.jsx)(ConversationContainer, null, (0, _react.jsx)(UserConversation, {
        className: `${userBubbleStyle ?? ""}`,
        mobile: forceMobile
    }, !simple && (0, _react.jsx)(TitleWrapper, null, (0, _react.jsx)(Title, null, title)), (0, _react.jsx)((0, _conversationMarkdownDefault.default), {
        className: "content-container",
        conversationText: markdown
    })), (0, _react.jsx)(UserAvatar, {
        src: deviceIcon
    }));
};
const ConversationContainer = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e19tngya7"
})({
    name: "19ua5gu",
    styles: "display:flex;align-items:start;>img{background:white;border-radius:50%;margin-top:30px;margin-right:12px;margin-left:12px;height:24px;width:24px;}"
});
const StyledButton = /*#__PURE__*/ (0, _baseDefault.default)((0, _buttonDefault.default), {
    target: "e19tngya6"
})({
    name: "g88fcj",
    styles: "top:32px;right:32px"
});
const TitleWrapper = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e19tngya5"
})({
    name: "1fo2l69",
    styles: "position:absolute;top:5px"
});
const Title = /*#__PURE__*/ (0, _baseDefault.default)("h6", {
    target: "e19tngya4"
})({
    name: "ot4ncn",
    styles: "font-size:10px"
});
const UserConversation = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e19tngya3"
})("margin:30px 0 0 300px;border:solid 1px ", (0, _colors.greeny_blue), ";box-shadow:0 1px 2px 0 ", (0, _colors.dark_grey_blue_20), ";background:white;border-radius:10px 0 10px 10px;padding:20px;display:flex;flex-direction:column;flex:1;justify-content:flex-end;position:relative;", (0, _breakpoints.breakpoint_small), "{margin:16px 0 0 0;}", (props)=>props.mobile ? "margin: 16px 0 0 0;" : "", ";");
const UserAvatar = /*#__PURE__*/ (0, _baseDefault.default)("img", {
    target: "e19tngya2"
})({
    name: "1s2o77u",
    styles: "background:white;height:24px;width:24px;margin:0 0 0 8px;border-radius:50px"
});
const BotAvatar = /*#__PURE__*/ (0, _baseDefault.default)("img", {
    target: "e19tngya1"
})({
    name: "9ow90b",
    styles: "background:white;height:24px;width:24px;border-radius:50%;margin:16px 8px 0 0"
});
const BotConversation = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e19tngya0"
})("margin:30px 200px 0 0;border:solid 1px ", (0, _colors.dark_sky_blue), ";box-shadow:0 1px 2px 0 ", (0, _colors.dark_grey_blue_20), ";background:white;border-radius:0 10px 10px 10px;padding:20px;display:flex;position:relative;flex-direction:row;flex:1;justify-content:flex-start;", (0, _breakpoints.breakpoint_small), "{margin:16px 16px 0 0;}", (props)=>props.mobile ? "margin: 16px 16px 0 0;" : "", ";");
exports.default = LiveChatBubble;

},{"@emotion/styled/base":"lSuFu","@emotion/react":"djZKr","react":"6uln9","./ConversationMarkdown":"c7849","../../../constants/colors":"1p3OR","../../../components/general/Button":"6ymxN","../../../constants/breakpoints":"2F01A","../../../hooks/UseIsMobile":"9Gz1L","6159f5cf30c81ba4":"2nj1V","73e845e630c6a716":"apu8T","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"c7849":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _base = require("@emotion/styled/base");
var _baseDefault = parcelHelpers.interopDefault(_base);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _reactMarkdown = require("react-markdown");
var _reactMarkdownDefault = parcelHelpers.interopDefault(_reactMarkdown);
var _colors = require("../../../constants/colors");
const ConversationMarkdown = (props)=>(0, _react.jsx)(StyledConversationMarkdown, null, (0, _react.jsx)((0, _reactMarkdownDefault.default), {
        className: props.className ?? "",
        linkTarget: "_blank"
    }, props.conversationText));
const StyledConversationMarkdown = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "est79ns0"
})("a:link{color:", (0, _colors.greeny_blue), ";}a:visited{color:", (0, _colors.dark_sky_blue), ";}a:hover{color:", (0, _colors.bluegreen), ";}a:active{color:", (0, _colors.customGreen), ";}ol{margin-bottom:6px;margin-top:6px;}ul{margin-bottom:6px;margin-top:6px;}p{margin-bottom:2px;margin-top:2px;}h1{margin-bottom:2px;margin-top:2px;color:", (0, _colors.dark_sky_blue), ";}h2{margin-bottom:2px;margin-top:2px;color:", (0, _colors.dark_sky_blue), ";}h3{margin-bottom:2px;margin-top:2px;color:", (0, _colors.dark_sky_blue), ";}h4{margin-bottom:2px;margin-top:2px;color:", (0, _colors.dark_sky_blue), ";}h5{margin-bottom:2px;margin-top:2px;color:", (0, _colors.dark_sky_blue), ";}h6{margin-bottom:2px;margin-top:2px;color:", (0, _colors.dark_sky_blue), ";}");
exports.default = ConversationMarkdown;

},{"@emotion/styled/base":"lSuFu","@emotion/react":"djZKr","react":"6uln9","react-markdown":"6G7AH","../../../constants/colors":"1p3OR","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"apu8T":[function(require,module,exports) {
module.exports = require("dc99af94e303b4cb").getBundleURL("kVLro") + require("fc50f09bb0a614a3").resolve("i9iR7");

},{"dc99af94e303b4cb":"c7Tr5","fc50f09bb0a614a3":"fyJL2"}],"vk8Qc":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _unstatedNext = require("unstated-next");
var _api = require("../api");
function useSessionAnalyticsContainer() {
    const [events, setEvents] = (0, _react.useState)({});
    const [sessions, setSessions] = (0, _react.useState)([]);
    const [sessionsForReview, setSessionsForReview] = (0, _react.useState)([]);
    const [loading, setLoading] = (0, _react.useState)(false);
    const [loadingEvents, setLoadingEvents] = (0, _react.useState)(false);
    const [error, setError] = (0, _react.useState)("");
    const [simpleView, setSimpleView] = (0, _react.useState)(false);
    const [allAppOrderPlaces, setAllAppOrderPlaces] = (0, _react.useState)([]);
    const [allAppTransfers, setAllAppTransfers] = (0, _react.useState)([]);
    (0, _react.useEffect)(()=>{
        // get simpleview boolean from application storage
        const simpleViewStr = localStorage.getItem("VOICIFY_SIMPLE_SESSION_ANALYTICS");
        if (simpleViewStr?.length) // parse the string to boolean
        setSimpleView(simpleViewStr === "true" ? true : false);
    }, []);
    const updateSimpleView = (simple)=>{
        setSimpleView(simple);
        localStorage.setItem("VOICIFY_SIMPLE_SESSION_ANALYTICS", simple ? "true" : "false");
    };
    (0, _react.useEffect)(()=>{
        setLoadingEvents(false);
    }, [
        events
    ]);
    const loadSessions = async (appId, filter)=>{
        try {
            setLoading(true);
            const tasks = [];
            const sessionFilters = breakUpFilters(filter);
            tasks.push(loadSessionsMultiFilter(appId, sessionFilters));
            tasks.push(_api.getCallStartedEventsByApplication(appId, filter));
            var results = await Promise.all(tasks);
            let sessionModels = [];
            let callStartedEvents = [];
            if (results[0].resultType === "Ok") sessionModels = results[0].data;
            else setError(results[0].errors.join(", "));
            if (results[1].resultType === "Ok") {
                if (results[1].data?.length) callStartedEvents = results[1].data;
            } else setError(results[1].errors.join(", "));
            const newSessions = [];
            for (const session of sessionModels ?? []){
                const callStarted = callStartedEvents.find((e)=>e.sessionId === session.sessionId);
                const phoneNumbers = [];
                if (callStarted?.from?.length) phoneNumbers.push(callStarted.from);
                if (callStarted?.to?.length) phoneNumbers.push(callStarted.to);
                if (callStarted?.phoneNumber?.length) phoneNumbers.push(callStarted.phoneNumber);
                newSessions.push({
                    sessionId: session.sessionId,
                    startDate: new Date(session.startDate),
                    phoneNumbers: phoneNumbers,
                    from: callStarted?.from
                });
            }
            // sort sessions by most recent start date first
            newSessions.sort((a, b)=>b.startDate.getTime() - a.startDate.getTime());
            setSessions(newSessions);
            setLoading(false);
        } catch (e) {
            console.log(e);
            setError(e.message);
        }
    };
    const loadSessionsMultiFilter = async (appId, filters)=>{
        try {
            const tasks = [];
            for (const filter of filters)tasks.push(_api.getSessionsByApplication(appId, filter));
            var results = await Promise.all(tasks);
            let sessionModels = [];
            for (const result of results)if (result.resultType === "Ok") sessionModels = sessionModels.concat(result.data);
            else setError(result.errors.join(", "));
            return {
                resultType: "Ok",
                data: sessionModels,
                errors: []
            };
        } catch (e) {
            console.log(e);
            setError(e.message);
        }
    };
    const breakUpFilters = (filter)=>{
        let sessionFilters = [
            filter
        ];
        if (filter.startDate && filter.endDate) {
            const diffDays = Math.ceil((new Date(filter.endDate).getTime() - new Date(filter.startDate).getTime()) / 86400000);
            if (diffDays > 7) {
                let done = false;
                sessionFilters = [];
                let startDate = new Date(filter.startDate);
                while(!done){
                    const endDate = new Date(startDate.getTime() + 604800000);
                    if (endDate > new Date(filter.endDate)) {
                        done = true;
                        sessionFilters.push({
                            startDate: startDate.toISOString(),
                            endDate: filter.endDate
                        });
                    } else {
                        sessionFilters.push({
                            startDate: startDate.toISOString(),
                            endDate: endDate.toISOString()
                        });
                        startDate = new Date(endDate.toISOString());
                    }
                }
            }
        }
        return sessionFilters;
    };
    const loadSessionsForReview = async (appId, minDuration = 20, daysBack = 2)=>{
        try {
            setLoading(true);
            const tasks = [];
            const filter = {
                startDate: new Date(new Date().setDate(new Date().getDate() - daysBack)).toISOString(),
                endDate: new Date(new Date().setDate(new Date().getDate() + 2)).toISOString()
            };
            // if filter. startDate and endDate are bigger than 30 days, load by week. 
            const sessionFilters = breakUpFilters(filter);
            tasks.push(loadSessionsMultiFilter(appId, sessionFilters));
            tasks.push(_api.getCallCompleteEventsByApplication(appId, filter));
            tasks.push(_api.getOrderPlacedEventsByApplication(appId, filter));
            tasks.push(_api.getCallTransferredEventsByApplication(appId, filter));
            var results = await Promise.all(tasks);
            let sessionModels = [];
            let callCompleteEvents = [];
            if (results[0].resultType !== "Ok") return "Invalid";
            if (results[0].resultType === "Ok") sessionModels = results[0].data;
            else setError(results[0].errors.join(", "));
            if (results[1].resultType === "Ok") {
                if (results[1].data?.length) callCompleteEvents = results[1].data;
            } else setError(results[1].errors.join(", "));
            if (results[2].resultType === "Ok") {
                if (results[2]?.data?.length) setAllAppOrderPlaces(results[2]?.data);
            }
            if (results[3].resultType === "Ok") {
                if (results[3]?.data?.length) setAllAppTransfers(results[3]?.data);
            }
            const newSessions = [];
            for (const session of sessionModels ?? []){
                const callComplete = callCompleteEvents.find((e)=>e.sessionId === session.sessionId);
                if (callComplete?.duration && callComplete?.duration > minDuration) {
                    const phoneNumbers = [];
                    if (callComplete?.from?.length) phoneNumbers.push(callComplete.from);
                    if (callComplete?.to?.length) phoneNumbers.push(callComplete.to);
                    if (callComplete?.phoneNumber?.length) phoneNumbers.push(callComplete.phoneNumber);
                    newSessions.push({
                        sessionId: session.sessionId,
                        startDate: new Date(session.startDate),
                        phoneNumbers: phoneNumbers,
                        duration: callComplete.duration,
                        from: callComplete?.from
                    });
                }
            }
            // sort sessions by most recent start date first
            newSessions.sort((a, b)=>b.startDate.getTime() - a.startDate.getTime());
            setSessionsForReview(newSessions);
            setLoading(false);
            return "Ok";
        } catch (e) {
            console.log(e);
            setError(e.message);
            return "Invalid";
        }
    };
    const loadLatestRecentContentHitsForSession = async (appId, sessionId)=>{
        try {
            const filter = {
                startDate: new Date(new Date().setDate(new Date().getDate() - 10)).toISOString(),
                endDate: new Date(new Date().setDate(new Date().getDate() + 5)).toISOString()
            };
            const contentHitsResponse = await _api.getContentHits(appId, filter, 0, 50, true, sessionId, "");
            if (contentHitsResponse.resultType === "Ok") return contentHitsResponse.data;
            return [];
        } catch  {
            return [];
        }
    };
    const loadRecentOrderPlacesForSession = (sessionId)=>{
        try {
            const orderPlaces = allAppOrderPlaces.filter((o)=>o.sessionId === sessionId);
            return [
                ...orderPlaces
            ];
        } catch  {
            return [];
        }
    };
    const loadRecentTransfersForSession = (sessionId)=>{
        try {
            const events = allAppTransfers.filter((o)=>o.sessionId === sessionId);
            return [
                ...events
            ];
        } catch  {
            return [];
        }
    };
    const loadEvents = async (appId, sessionId, silent)=>{
        if (!silent) setLoadingEvents(true);
        const eventsResponse = await _api.getAllEventsForSession(appId, sessionId);
        if (eventsResponse.resultType === "Ok") {
            eventsResponse.data.forEach((e)=>{
                if (e.eventDate) e.timestamp = new Date(e.eventDate).getTime();
            });
            setEvents({
                ...events,
                [sessionId]: eventsResponse.data
            });
            return eventsResponse.data;
        } else setError(eventsResponse.errors.join(", "));
    };
    const loadEventsForSession = async (appId, sessionId, forceEventLoad, silent)=>{
        try {
            setError("");
            if (forceEventLoad || !(sessionId in events)) {
                const loadEventsResponse = await loadEvents(appId, sessionId, silent);
                return loadEventsResponse;
            } else return events[sessionId];
        } catch (e) {
            setError(e.message);
        }
    };
    const getRecordingUrls = async (appId, sessionId, processed)=>{
        try {
            const recordingResponse = await _api.getCallRecording(appId, sessionId, processed);
            if (recordingResponse.resultType === "Ok") return recordingResponse.data.url;
            else setError(recordingResponse.errors.join(", "));
        } catch (e) {
            setError(e.message);
        }
    };
    const loadSessionsForOrgs = async (orgIds, filter, logCallback)=>{
        try {
            setLoading(true);
            setError("");
            const allSessionListModels = [];
            const loadErrors = [];
            const pageSize = 200;
            // Process each organization one at a time
            for(let i = 0; i < orgIds.length; i++){
                const orgId = orgIds[i];
                try {
                    logCallback?.(`Processing organization ${i + 1} of ${orgIds.length}...`);
                    // Helper function to load all sessions for this org with pagination
                    const loadAllSessionsForOrg = async ()=>{
                        let allSessions = [];
                        let skip = 0;
                        let hasMoreData = true;
                        let orgSessionCount = 0;
                        while(hasMoreData){
                            const result = await _api.getSessionsByOrganizationId(orgId, filter, skip, pageSize);
                            if (result.resultType === "Ok") {
                                allSessions = [
                                    ...allSessions,
                                    ...result.data
                                ];
                                orgSessionCount += result.data.length;
                                if (result.data.length < pageSize) hasMoreData = false;
                                else skip += pageSize;
                            } else {
                                const errorMsg = `Failed to load sessions for org ${orgId}: ${result?.errors?.[0] || "Unknown error"}`;
                                loadErrors.push(errorMsg);
                                logCallback?.(errorMsg);
                                hasMoreData = false;
                            }
                        }
                        logCallback?.(`Loaded ${orgSessionCount} sessions for organization ${i + 1}`);
                        return allSessions;
                    };
                    // Helper function to load all call complete events for this org with pagination
                    const loadAllCallCompleteEventsForOrg = async ()=>{
                        let allCallCompleteEvents = [];
                        let skip = 0;
                        let hasMoreData = true;
                        let orgCallCompleteCount = 0;
                        let callCompleteFilter = {
                            ...filter
                        };
                        let callCompletePageSize = 300;
                        // subtract half a day from start date to ensure we get all call complete events
                        // add 1 day to end date to ensure we get all call complete events
                        if (callCompleteFilter.startDate) {
                            const startDate = new Date(callCompleteFilter.startDate);
                            startDate.setHours(startDate.getHours() - 12);
                            callCompleteFilter.startDate = startDate.toISOString();
                        }
                        if (callCompleteFilter.endDate) {
                            const endDate = new Date(callCompleteFilter.endDate);
                            endDate.setDate(endDate.getDate() + 1);
                            callCompleteFilter.endDate = endDate.toISOString();
                        }
                        while(hasMoreData){
                            const paginatedFilter = {
                                ...callCompleteFilter,
                                skip,
                                take: callCompletePageSize
                            };
                            const result = await _api.getOrgCallCompleteEvents(orgId, paginatedFilter);
                            if (result.resultType === "Ok") {
                                allCallCompleteEvents = [
                                    ...allCallCompleteEvents,
                                    ...result.data
                                ];
                                orgCallCompleteCount = allCallCompleteEvents.length;
                                if (result.data.length === 0) hasMoreData = false;
                                else skip += callCompletePageSize;
                            } else {
                                const errorMsg = `Failed to load call complete events for org ${orgId}: ${result?.errors?.[0] || "Unknown error"}`;
                                loadErrors.push(errorMsg);
                                logCallback?.(errorMsg);
                                hasMoreData = false;
                            }
                        }
                        logCallback?.(`Loaded ${orgCallCompleteCount} call complete events for organization ${i + 1}`);
                        return allCallCompleteEvents;
                    };
                    // Load sessions and call complete events in parallel for this org
                    const [orgSessions, orgCallCompleteEvents] = await Promise.all([
                        loadAllSessionsForOrg(),
                        loadAllCallCompleteEventsForOrg()
                    ]);
                    // Process sessions for this org immediately
                    for (const session of orgSessions){
                        const callComplete = orgCallCompleteEvents.find((e)=>e.sessionId === session.sessionId);
                        const phoneNumbers = [];
                        let duration = undefined;
                        let from = undefined;
                        if (callComplete) {
                            duration = callComplete.duration;
                            from = callComplete.from;
                            if (callComplete.from?.length) phoneNumbers.push(callComplete.from);
                            if (callComplete.to?.length) phoneNumbers.push(callComplete.to);
                            if (callComplete.phoneNumber?.length) phoneNumbers.push(callComplete.phoneNumber);
                        }
                        allSessionListModels.push({
                            sessionId: session.sessionId,
                            startDate: new Date(session.startDate),
                            phoneNumbers: phoneNumbers,
                            duration: duration,
                            from: from
                        });
                    }
                } catch (error) {
                    const errorMsg = `Failed to process org ${orgId}: ${error.message || "Unknown error"}`;
                    loadErrors.push(errorMsg);
                    logCallback?.(errorMsg);
                }
            }
            if (loadErrors.length > 0) setError(loadErrors.join("; "));
            // Sort all sessions by most recent start date first
            allSessionListModels.sort((a, b)=>b.startDate.getTime() - a.startDate.getTime());
            setSessions(allSessionListModels);
            return allSessionListModels;
        } catch (e) {
            console.log(e);
            setError(e.message);
            return [];
        } finally{
            setLoading(false);
        }
    };
    return {
        loadSessions,
        loadSessionsForReview,
        loadEventsForSession,
        loadLatestRecentContentHitsForSession,
        loadRecentOrderPlacesForSession,
        loadRecentTransfersForSession,
        loadSessionsForOrgs,
        sessions,
        sessionsForReview,
        events,
        loading,
        loadingEvents,
        allAppTransfers,
        simpleView,
        updateSimpleView,
        getRecordingUrl: getRecordingUrls,
        error
    };
}
const SessionAnalyticsContainer = (0, _unstatedNext.createContainer)(useSessionAnalyticsContainer);
exports.default = SessionAnalyticsContainer;

},{"react":"6uln9","unstated-next":"61zE5","../api":"loxM6","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"bf7Hw":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _unstatedNext = require("unstated-next");
var _api = require("../api");
var _keys = require("../constants/Keys");
function useAnalyticsOrderStateContainer() {
    const [orderPlaced, setOrderPlaced] = (0, _react.useState)(false);
    const [isSuccessfulConversation, setIsSuccessfulConversation] = (0, _react.useState)(false);
    const [isLoading, setIsLoading] = (0, _react.useState)(false);
    const [errors, setErrors] = (0, _react.useState)([]);
    const getStoredAnalyticsOrderState = ()=>{
        let storedState = {};
        const storedAnalyticsOrderState = localStorage.getItem((0, _keys.ANALYTICS_ORDER_STATE));
        if (storedAnalyticsOrderState) storedState = JSON.parse(storedAnalyticsOrderState);
        return storedState;
    };
    const storeAnalyticsOrderState = (state)=>{
        const json = JSON.stringify(state);
        localStorage.setItem((0, _keys.ANALYTICS_ORDER_STATE), json);
    };
    const markOrderAsPlaced = async (applicationId, sessionId)=>{
        try {
            setIsLoading(true);
            const storedAnalyticsOrderState = getStoredAnalyticsOrderState();
            const result = await _api.markOrderAsPlaced(applicationId, sessionId, {});
            if (result.resultType == "Ok") {
                setOrderPlaced(true);
                storeAnalyticsOrderState({
                    ...storedAnalyticsOrderState,
                    [sessionId]: {
                        orderPlaced: true
                    }
                });
            } else if (result.errors != null && result.errors.length > 0) setErrors([
                ...result.errors
            ]);
            setIsLoading(false);
            return result;
        } catch (error) {
            setErrors([
                error
            ]);
            setIsLoading(false);
        }
    };
    const markOrderAsSuccessfulConversation = async (applicationId, sessionId)=>{
        try {
            setIsLoading(true);
            const storedAnalyticsOrderState = getStoredAnalyticsOrderState();
            const result = await _api.markOrderAsConversationalSuccess(applicationId, sessionId, {});
            if (result.resultType == "Ok") {
                setIsSuccessfulConversation(true);
                if (storedAnalyticsOrderState[sessionId]) storedAnalyticsOrderState[sessionId].successfulConversation = true;
                storeAnalyticsOrderState(storedAnalyticsOrderState);
            } else if (result.errors != null && result.errors.length > 0) setErrors([
                ...result.errors
            ]);
            setIsLoading(false);
            return result;
        } catch (error) {
            setErrors([
                error
            ]);
            setIsLoading(false);
        }
    };
    return {
        markOrderAsPlaced,
        orderPlaced,
        markOrderAsSuccessfulConversation,
        isSuccessfulConversation,
        getStoredAnalyticsOrderState,
        storeAnalyticsOrderState,
        isLoading,
        errors
    };
}
const AnalyticsOrderStateContainer = (0, _unstatedNext.createContainer)(useAnalyticsOrderStateContainer);
exports.default = AnalyticsOrderStateContainer;

},{"react":"6uln9","unstated-next":"61zE5","../api":"loxM6","../constants/Keys":"4iC9Z","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"ksD4K":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _base = require("@emotion/styled/base");
var _baseDefault = parcelHelpers.interopDefault(_base);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _tagPill = require("../general/TagPill");
var _tagPillDefault = parcelHelpers.interopDefault(_tagPill);
var _generativeCallReview = require("../../constants/analyticsConstants/generativeCallReview");
var _breakpoints = require("../../constants/breakpoints");
// Tags that should be grouped with counts when they appear multiple times
const GROUPABLE_TAGS = [
    "ACTION_COMPLETED",
    "APPOINTMENT_RESCHEDULED",
    "APPOINTMENT_CANCELLED",
    "CHECK_NEXT_APPOINTMENT_COMPLETE"
];
const groupTagsWithCounts = (tags)=>{
    const tagCounts = tags.reduce((acc, tag)=>{
        acc[tag] = (acc[tag] || 0) + 1;
        return acc;
    }, {});
    return Object.entries(tagCounts).map(([tag, count])=>({
            tag,
            count
        }));
};
const SessionTags = ({ tags, featureFlag, className, showVfyTags })=>{
    if (!tags || tags.length === 0) return null;
    const groupedTags = (0, _react1.useMemo)(()=>{
        let filteredTags = tags;
        if (!showVfyTags) filteredTags = filteredTags.filter((tag)=>!tag?.toLowerCase().startsWith("vfy_"));
        // Group tags and count occurrences
        const grouped = groupTagsWithCounts(filteredTags);
        // Sort the unique tags
        const uniqueTags = grouped.map((g)=>g.tag);
        const sortedUniqueTags = (0, _generativeCallReview.sortTagsByPriority)(uniqueTags, featureFlag);
        // Return grouped tags in sorted order
        return sortedUniqueTags.map((tag)=>{
            const found = grouped.find((g)=>g.tag === tag);
            return found || {
                tag,
                count: 1
            };
        });
    }, [
        tags,
        featureFlag,
        showVfyTags
    ]);
    return (0, _react.jsx)(TagsContainer, {
        className: className
    }, groupedTags.map(({ tag, count })=>(0, _react.jsx)((0, _tagPillDefault.default), {
            key: tag,
            tag: tag,
            featureFlag: featureFlag,
            count: GROUPABLE_TAGS.includes(tag) ? count : undefined
        })));
};
const TagsContainer = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1pby9hp0"
})("display:flex;flex-wrap:wrap;gap:4px;align-items:center;margin-left:8px;", (0, _breakpoints.breakpoint_small), "{margin-left:0;margin-top:4px;}");
exports.default = SessionTags;

},{"@emotion/styled/base":"lSuFu","@emotion/react":"djZKr","react":"6uln9","../general/TagPill":"kk8kj","../../constants/analyticsConstants/generativeCallReview":"5Shd2","../../constants/breakpoints":"2F01A","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"kk8kj":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _base = require("@emotion/styled/base");
var _baseDefault = parcelHelpers.interopDefault(_base);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _generativeCallReview = require("../../constants/analyticsConstants/generativeCallReview");
const SharedTagPill = ({ tag, featureFlag, className, count })=>{
    const colors = (0, _generativeCallReview.getTagColors)(tag);
    const displayName = (0, _generativeCallReview.getTagName)(tag, featureFlag) || tag;
    // Show count in parentheses if count is greater than 1
    const displayText = count && count > 1 ? `${displayName} (${count})` : displayName;
    return (0, _react.jsx)(StyledTagPill, {
        tagColors: colors,
        className: className
    }, displayText);
};
const StyledTagPill = /*#__PURE__*/ (0, _baseDefault.default)("span", {
    target: "e4kjmrb0"
})("display:inline-flex;align-items:center;background:", (props)=>props.tagColors?.background || "#eef6ff", ";color:", (props)=>props.tagColors?.color || "#1e3a8a", ";font-size:0.75rem;padding:0px 6px;border-radius:9999px;white-space:nowrap;height:18px;");
exports.default = SharedTagPill;

},{"@emotion/styled/base":"lSuFu","@emotion/react":"djZKr","react":"6uln9","../../constants/analyticsConstants/generativeCallReview":"5Shd2","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"5Shd2":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ALL_TAGS_AND_CATEGORIES", ()=>ALL_TAGS_AND_CATEGORIES);
parcelHelpers.export(exports, "TAGS", ()=>TAGS);
parcelHelpers.export(exports, "ALL_CATEGORIES", ()=>ALL_CATEGORIES);
parcelHelpers.export(exports, "HEALTHCARE_TAGS", ()=>HEALTHCARE_TAGS);
parcelHelpers.export(exports, "FOOD_ORDERING_TAGS", ()=>FOOD_ORDERING_TAGS);
parcelHelpers.export(exports, "POSITIVE_TAGS", ()=>POSITIVE_TAGS);
parcelHelpers.export(exports, "NEGATIVE_TAGS", ()=>NEGATIVE_TAGS);
parcelHelpers.export(exports, "NEUTRAL_TAGS", ()=>NEUTRAL_TAGS);
parcelHelpers.export(exports, "CAUTION_TAGS", ()=>CAUTION_TAGS);
parcelHelpers.export(exports, "ALL_TAGS", ()=>ALL_TAGS);
parcelHelpers.export(exports, "getCategoryName", ()=>getCategoryName);
parcelHelpers.export(exports, "getTagName", ()=>getTagName);
parcelHelpers.export(exports, "getTagPriority", ()=>getTagPriority);
parcelHelpers.export(exports, "sortTagsByPriority", ()=>sortTagsByPriority);
parcelHelpers.export(exports, "getTagColors", ()=>getTagColors);
parcelHelpers.export(exports, "getTagCombinationPriority", ()=>getTagCombinationPriority);
var _colors = require("../colors");
const ALL_TAGS_AND_CATEGORIES = [
    "ACTION_ATTEMPTED",
    "IMMEDIATE_TRANSFER",
    "OTHER",
    "NO_INTERACTION",
    "ACTION_COMPLETED",
    "TRANSFERRED",
    "UNSUPPORTED_CUSTOMER_REQUEST",
    "AI_ISSUE",
    "CUSTOMER_FRUSTRATION",
    "CUSTOMER_DELIGHT",
    "UPSELL_SUCCESSFUL",
    "UPSELL_ATTEMPTED",
    "APPOINTMENT_CANCELLED",
    "APPOINTMENT_RESCHEDULED",
    "VFY_PATIENT_HANGUP",
    "SPANISH",
    "UNSUPPORTED_APPOINTMENT_TYPE",
    "SCHEDULE_ATTEMPTED",
    "RESCHEDULE_ATTEMPTED",
    "CANCELLATION_ATTEMPTED",
    "CHECK_NEXT_APPOINTMENT",
    "TRANSFERRED_BUT_CONTAINED"
];
const TAGS = {
    ACTION_COMPLETED: "ACTION_COMPLETED",
    TRANSFERRED: "TRANSFERRED",
    UNSUPPORTED_CUSTOMER_REQUEST: "UNSUPPORTED_CUSTOMER_REQUEST",
    AI_ISSUE: "AI_ISSUE",
    CUSTOMER_FRUSTRATION: "CUSTOMER_FRUSTRATION",
    CUSTOMER_DELIGHT: "CUSTOMER_DELIGHT",
    UPSELL_SUCCESSFUL: "UPSELL_SUCCESSFUL",
    UPSELL_ATTEMPTED: "UPSELL_ATTEMPTED",
    APPOINTMENT_CANCELLED: "APPOINTMENT_CANCELLED",
    APPOINTMENT_RESCHEDULED: "APPOINTMENT_RESCHEDULED",
    VFY_PATIENT_HANGUP: "VFY_PATIENT_HANGUP",
    SPANISH: "SPANISH",
    UNSUPPORTED_APPOINTMENT_TYPE: "UNSUPPORTED_APPOINTMENT_TYPE",
    SCHEDULE_ATTEMPTED: "SCHEDULE_ATTEMPTED",
    RESCHEDULE_ATTEMPTED: "RESCHEDULE_ATTEMPTED",
    CANCELLATION_ATTEMPTED: "CANCELLATION_ATTEMPTED",
    CHECK_NEXT_APPOINTMENT: "CHECK_NEXT_APPOINTMENT",
    CHECK_NEXT_APPOINTMENT_COMPLETE: "CHECK_NEXT_APPOINTMENT_COMPLETE",
    NEW_PATIENT: "NEW_PATIENT",
    PAYMENT_LINK_REFUSED: "PAYMENT_LINK_REFUSED",
    OUT_OF_STOCK_ORDERED: "OUT_OF_STOCK_ORDERED",
    ABANDONED_ON_PRICE: "ABANDONED_ON_PRICE",
    ABANDONED_ON_NAME: "ABANDONED_ON_NAME",
    CALL_DURING_OFF_HOURS: "CALL_DURING_OFF_HOURS",
    OUTBOUND_LEFT_MESSAGE: "OUTBOUND_LEFT_MESSAGE",
    OUTBOUND_APPOINTMENT_CONFIRMED: "OUTBOUND_APPOINTMENT_CONFIRMED",
    OUTBOUND_APPOINTMENT_RESCHEDULED: "OUTBOUND_APPOINTMENT_RESCHEDULED",
    OUTBOUND_APPOINTMENT_CANCELLED: "OUTBOUND_APPOINTMENT_CANCELLED",
    OUTBOUND_CALL_TRANSFERRED: "OUTBOUND_CALL_TRANSFERRED",
    PICKUP_ORDER: "PICKUP_ORDER",
    DELIVERY_ORDER: "DELIVERY_ORDER",
    PAID_VIA_LINK: "PAID_VIA_LINK",
    PAID_VIA_CASH: "PAID_VIA_CASH",
    PAID_VIA_STORE: "PAID_VIA_STORE",
    VFY_POS_API_FAILURE: "VFY_POS_API_FAILURE",
    VFY_CALL_END_TRANSFER: "VFY_CALL_END_TRANSFER",
    TRANSFERRED_BUT_CONTAINED: "TRANSFERRED_BUT_CONTAINED"
};
const ALL_CATEGORIES = [
    "ACTION_ATTEMPTED",
    "QUESTION_ANSWERED",
    "OTHER",
    "IMMEDIATE_TRANSFER",
    "NO_INTERACTION"
];
const HEALTHCARE_TAGS = [
    "ACTION_COMPLETED",
    "AI_ISSUE",
    "TRANSFERRED",
    "UNSUPPORTED_CUSTOMER_REQUEST",
    "CUSTOMER_DELIGHT",
    "CUSTOMER_FRUSTRATION",
    "APPOINTMENT_RESCHEDULED",
    "APPOINTMENT_CANCELLED",
    "UNSUPPORTED_APPOINTMENT_TYPE",
    "SCHEDULE_ATTEMPTED",
    "RESCHEDULE_ATTEMPTED",
    "CANCELLATION_ATTEMPTED",
    "CHECK_NEXT_APPOINTMENT",
    "CHECK_NEXT_APPOINTMENT_COMPLETE",
    "NEW_PATIENT",
    "SPANISH",
    "CALL_DURING_OFF_HOURS",
    "OUTBOUND_LEFT_MESSAGE",
    "OUTBOUND_APPOINTMENT_CONFIRMED",
    "OUTBOUND_APPOINTMENT_RESCHEDULED",
    "OUTBOUND_APPOINTMENT_CANCELLED",
    "OUTBOUND_CALL_TRANSFERRED",
    "TRANSFERRED_BUT_CONTAINED"
];
const FOOD_ORDERING_TAGS = [
    "ACTION_COMPLETED",
    "AI_ISSUE",
    "TRANSFERRED",
    "UNSUPPORTED_CUSTOMER_REQUEST",
    "CUSTOMER_DELIGHT",
    "CUSTOMER_FRUSTRATION",
    "UPSELL_ATTEMPTED",
    "UPSELL_SUCCESSFUL",
    "SPANISH",
    "PAYMENT_LINK_REFUSED",
    "OUT_OF_STOCK_ORDERED",
    "ABANDONED_ON_PRICE",
    "ABANDONED_ON_NAME",
    "CALL_DURING_OFF_HOURS",
    "PICKUP_ORDER",
    "PAID_VIA_STORE",
    "PAID_VIA_LINK",
    "VFY_POS_API_FAILURE",
    "VFY_CALL_END_TRANSFER",
    "TRANSFERRED_BUT_CONTAINED"
];
const POSITIVE_TAGS = [
    TAGS.ACTION_COMPLETED,
    TAGS.CUSTOMER_DELIGHT,
    TAGS.UPSELL_SUCCESSFUL,
    TAGS.APPOINTMENT_RESCHEDULED,
    TAGS.APPOINTMENT_CANCELLED,
    TAGS.NEW_PATIENT,
    TAGS.CHECK_NEXT_APPOINTMENT_COMPLETE,
    TAGS.OUTBOUND_APPOINTMENT_CONFIRMED,
    TAGS.OUTBOUND_APPOINTMENT_RESCHEDULED,
    TAGS.TRANSFERRED_BUT_CONTAINED
];
const NEGATIVE_TAGS = [
    TAGS.AI_ISSUE,
    TAGS.CUSTOMER_FRUSTRATION
];
const NEUTRAL_TAGS = [
    TAGS.TRANSFERRED,
    TAGS.UPSELL_ATTEMPTED,
    TAGS.SPANISH,
    TAGS.UNSUPPORTED_APPOINTMENT_TYPE,
    TAGS.SCHEDULE_ATTEMPTED,
    TAGS.RESCHEDULE_ATTEMPTED,
    TAGS.CANCELLATION_ATTEMPTED,
    TAGS.CHECK_NEXT_APPOINTMENT,
    TAGS.OUTBOUND_APPOINTMENT_CANCELLED,
    TAGS.OUTBOUND_LEFT_MESSAGE,
    TAGS.OUTBOUND_CALL_TRANSFERRED
];
const CAUTION_TAGS = [
    TAGS.UNSUPPORTED_CUSTOMER_REQUEST,
    TAGS.PAYMENT_LINK_REFUSED,
    TAGS.OUT_OF_STOCK_ORDERED,
    TAGS.ABANDONED_ON_PRICE,
    TAGS.ABANDONED_ON_NAME
];
const ALL_TAGS = [
    ...POSITIVE_TAGS,
    ...NEUTRAL_TAGS,
    ...NEGATIVE_TAGS,
    ...CAUTION_TAGS
];
const getCategoryName = (category, featureFlag)=>{
    // CallCategories: "NO_INTERACTION" | "IMMEDIATE_TRANSFER" | "ACTION_ATTEMPTED" | "OTHER";
    if (!featureFlag) return category; // Fallback to the original category if featureFlag is not provided
    if (featureFlag === "FOOD_ORDERING") {
        if (category === "NO_INTERACTION") return "No Interaction";
        else if (category === "IMMEDIATE_TRANSFER") return "Immediate Transfer";
        else if (category === "QUESTION_ANSWERED") return "Question Answered";
        else if (category === "ACTION_ATTEMPTED") return "Order Attempts";
        else if (category === "OTHER") return "Miscellaneous";
        else return category; // Fallback to the original category if not matched
    } else if (featureFlag === "HEALTHCARE") {
        if (category === "NO_INTERACTION") return "No Interaction";
        else if (category === "IMMEDIATE_TRANSFER") return "Immediate Transfers";
        else if (category === "QUESTION_ANSWERED") return "Question Answered";
        else if (category === "ACTION_ATTEMPTED") return "Appointment Action Attempts";
        else if (category === "OTHER") return "Miscellaneous";
        else return category;
    } else return category; // Fallback to the original category if featureFlag doesn't match
};
const getTagName = (tag, featureFlag)=>{
    if (!featureFlag) return tag; // Fallback to the original tag if featureFlag is not provided
    if (featureFlag === "FOOD_ORDERING") switch(tag){
        case TAGS.ACTION_COMPLETED:
            return "Order Placed";
        case TAGS.TRANSFERRED:
            return "Transferred";
        case TAGS.UNSUPPORTED_CUSTOMER_REQUEST:
            return "Unsupported Customer Request";
        case TAGS.AI_ISSUE:
            return "AI Issue";
        case TAGS.CUSTOMER_FRUSTRATION:
            return "Customer Frustration";
        case TAGS.CUSTOMER_DELIGHT:
            return "Customer Delight";
        case TAGS.UPSELL_SUCCESSFUL:
            return "Upsell Successful";
        case TAGS.UPSELL_ATTEMPTED:
            return "Upsell Attempted";
        case TAGS.PAYMENT_LINK_REFUSED:
            return "Payment Link Refused";
        case TAGS.OUT_OF_STOCK_ORDERED:
            return "Out of Stock Item Ordered";
        case TAGS.SPANISH:
            return "Spanish";
        case TAGS.ABANDONED_ON_PRICE:
            return "Abandoned on Price";
        case TAGS.ABANDONED_ON_NAME:
            return "Abandoned on Name";
        case TAGS.CALL_DURING_OFF_HOURS:
            return "Call During Off Hours";
        case TAGS.PICKUP_ORDER:
            return "Pickup Order";
        case TAGS.DELIVERY_ORDER:
            return "Delivery Order";
        case TAGS.PAID_VIA_LINK:
            return "Payment Link";
        case TAGS.PAID_VIA_CASH:
            return "Cash Payment";
        case TAGS.PAID_VIA_STORE:
            return "Pay in Store";
        case TAGS.TRANSFERRED_BUT_CONTAINED:
            return "Contained Transfer";
        default:
            return tag;
    }
    else if (featureFlag === "HEALTHCARE") switch(tag){
        case TAGS.ACTION_COMPLETED:
            return "Appointment Scheduled";
        case TAGS.TRANSFERRED:
            return "Transferred";
        case TAGS.UNSUPPORTED_CUSTOMER_REQUEST:
            return "Unsupported Customer Request";
        case TAGS.AI_ISSUE:
            return "AI Issue";
        case TAGS.CUSTOMER_FRUSTRATION:
            return "Customer Frustration";
        case TAGS.CUSTOMER_DELIGHT:
            return "Customer Delight";
        case TAGS.UPSELL_SUCCESSFUL:
            return "Upsell Successful";
        case TAGS.UPSELL_ATTEMPTED:
            return "Upsell Attempted";
        case TAGS.APPOINTMENT_RESCHEDULED:
            return "Appointment Rescheduled";
        case TAGS.APPOINTMENT_CANCELLED:
            return "Appointment Cancelled";
        case TAGS.VFY_PATIENT_HANGUP:
            return "Patient Hangup";
        case TAGS.SPANISH:
            return "Spanish";
        case TAGS.UNSUPPORTED_APPOINTMENT_TYPE:
            return "Unsupported Appointment Type";
        case TAGS.SCHEDULE_ATTEMPTED:
            return "Schedule Attempted";
        case TAGS.RESCHEDULE_ATTEMPTED:
            return "Reschedule Attempted";
        case TAGS.CANCELLATION_ATTEMPTED:
            return "Cancellation Attempted";
        case TAGS.CHECK_NEXT_APPOINTMENT:
            return "Checked Next Appointment";
        case TAGS.NEW_PATIENT:
            return "New Patient";
        case TAGS.CHECK_NEXT_APPOINTMENT_COMPLETE:
            return "Check Next Appointment Successful";
        case TAGS.CALL_DURING_OFF_HOURS:
            return "Call During Off Hours";
        case TAGS.OUTBOUND_LEFT_MESSAGE:
            return "Left Outbound Message";
        case TAGS.OUTBOUND_APPOINTMENT_CONFIRMED:
            return "Outbound Appointment Confirmed";
        case TAGS.OUTBOUND_APPOINTMENT_RESCHEDULED:
            return "Outbound Appointment Rescheduled";
        case TAGS.OUTBOUND_APPOINTMENT_CANCELLED:
            return "Outbound Appointment Cancelled";
        case TAGS.OUTBOUND_CALL_TRANSFERRED:
            return "Outbound Call Transferred";
        case TAGS.TRANSFERRED_BUT_CONTAINED:
            return "Contained Transfer";
        default:
            return tag;
    }
    else return tag; // Fallback to the original tag if featureFlag doesn't match
};
const neutralTagColors = {
    background: (0, _colors.color_variants_ocean_light_1),
    color: (0, _colors.color_colors_ocean),
    border: (0, _colors.color_colors_ocean)
};
const positiveTagColors = {
    background: (0, _colors.highlight_green),
    color: (0, _colors.color_colors_growth),
    border: (0, _colors.color_colors_growth)
};
const negativeTagColors = {
    background: (0, _colors.color_variants_decline_light_1),
    color: (0, _colors.color_colors_decline),
    border: (0, _colors.color_colors_decline)
};
const cautionTagColors = {
    background: (0, _colors.color_variants_gold_light),
    color: (0, _colors.color_colors_gold),
    border: (0, _colors.color_colors_gold)
};
const getTagPriority = (tag)=>{
    let total = 0;
    // Returns priority: 1 = positive (highest), 2 = neutral, 3 = negative (lowest)
    if (POSITIVE_TAGS.includes(tag)) return 1; // positive tags
    else if (NEGATIVE_TAGS.includes(tag)) return 4; // negative tags
    else if (CAUTION_TAGS.includes(tag)) return 3; // caution tags
    else return 2; // neutral tags (TRANSFERRED, UNSUPPORTED_CUSTOMER_REQUEST, UPSELL_ATTEMPTED, etc.)
};
const sortTagsByPriority = (tags, featureFlag)=>{
    return [
        ...tags
    ].sort((a, b)=>{
        const priorityA = getTagPriority(a);
        const priorityB = getTagPriority(b);
        // If same priority, sort alphabetically by display name
        if (priorityA === priorityB) {
            const displayNameA = getTagName(a, featureFlag) || a;
            const displayNameB = getTagName(b, featureFlag) || b;
            return displayNameA.localeCompare(displayNameB);
        }
        return priorityA - priorityB;
    });
};
const getTagColors = (tag)=>{
    if (POSITIVE_TAGS.includes(tag)) return positiveTagColors;
    else if (CAUTION_TAGS.includes(tag)) return cautionTagColors;
    else if (NEGATIVE_TAGS.includes(tag)) return negativeTagColors;
    else return neutralTagColors; // Default for neutral tags and unknown tags
};
const getTagCombinationPriority = (tags)=>{
    let total = 0;
    if (!tags || tags.length === 0) return 100;
    for (const tag of tags || []){
        if (POSITIVE_TAGS.includes(tag)) total++; // positive tags
        if (NEGATIVE_TAGS.includes(tag)) total += 4;
        if (CAUTION_TAGS.includes(tag)) total += 3;
        total += 2;
    }
    return total;
};

},{"../colors":"1p3OR","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1qcKY":[function(require,module,exports) {
module.exports = require("90cd76b8f9d5030f").getBundleURL("kVLro") + require("3ca69234889e819c").resolve("lFY0Z");

},{"90cd76b8f9d5030f":"c7Tr5","3ca69234889e819c":"fyJL2"}],"l99Or":[function(require,module,exports) {
module.exports = require("21b4e268b3e50bd9").getBundleURL("kVLro") + require("5c8f1654f528106d").resolve("4eR7f");

},{"21b4e268b3e50bd9":"c7Tr5","5c8f1654f528106d":"fyJL2"}],"kbywW":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _base = require("@emotion/styled/base");
var _baseDefault = parcelHelpers.interopDefault(_base);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _colors = require("../../../constants/colors");
var _breakpoints = require("../../../constants/breakpoints");
var _button = require("../../../components/general/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _css = require("@emotion/css");
var _modalHeader = require("../../../components/general/ModalHeader");
var _modalHeaderDefault = parcelHelpers.interopDefault(_modalHeader);
var _footerBar = require("../../../components/structure/FooterBar");
var _footerBarDefault = parcelHelpers.interopDefault(_footerBar);
var _useWindowSize = require("../../../hooks/UseWindowSize");
var _useWindowSizeDefault = parcelHelpers.interopDefault(_useWindowSize);
var _modalLayout = require("../../../components/structure/ModalLayout");
var _modalLayoutDefault = parcelHelpers.interopDefault(_modalLayout);
var _jsoneditorReact = require("jsoneditor-react");
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const copyIcon = require("5ec8eb36138546a5");
const CodeOutputModal = (props)=>{
    const windowSize = (0, _useWindowSizeDefault.default)();
    const windowHeight = windowSize.windowSize.innerHeight * .9 - 300;
    const CustomEditorWrapper = /*#__PURE__*/ (0, _baseDefault.default)("div", {
        target: "e7qp9oz6"
    })("height:", windowHeight, ";");
    const copyText = (text)=>{
        navigator.clipboard.writeText(text);
    };
    const copyAndClose = (text)=>{
        copyText(text);
        props.closeModal();
    };
    const jsonEditorRef = (0, _react1.useRef)(null);
    (0, _react1.useEffect)(()=>{
        if (jsonEditorRef.current !== null) jsonEditorRef.current.set(props.data);
    }, [
        props.data
    ]);
    const setRef = (instance)=>{
        if (instance) jsonEditorRef.current = instance.jsonEditor;
        else jsonEditorRef.current = null;
    };
    return (0, _react.jsx)((0, _modalLayoutDefault.default), {
        className: CodeOutputModalStyle,
        isVisible: props.showCodeOutputModal
    }, (0, _react.jsx)((0, _modalHeaderDefault.default), {
        title: props.title,
        onClose: ()=>props.closeModal()
    }), (0, _react.jsx)(CodeDiv, null, (0, _react.jsx)(CustomEditorWrapper, null, (0, _react.jsx)(CustomEditor, null, (0, _react.jsx)((0, _jsoneditorReact.JsonEditor), {
        ref: setRef,
        value: props.data,
        enableTransform: false,
        enableSort: false,
        mode: "tree",
        allowedModes: [
            "tree",
            "code"
        ],
        sortObjectKeys: true
    })))), (0, _react.jsx)(CopyDiv, null, (0, _react.jsx)(CopySpan, {
        onClick: ()=>copyText(JSON.stringify(props.data, null, 2))
    }, "Copy", (0, _react.jsx)(CopyImg, {
        src: copyIcon
    }))), (0, _react.jsx)((0, _footerBarDefault.default), null, (0, _react.jsx)(CopyButton, {
        type: "button",
        themes: [
            "primary"
        ],
        text: "Copy & Close",
        onClick: ()=>copyAndClose(JSON.stringify(props.data, null, 2))
    }), (0, _react.jsx)((0, _buttonDefault.default), {
        type: "button",
        themes: [
            "secondary"
        ],
        text: "Cancel",
        onClick: ()=>props.closeModal()
    })));
};
exports.default = CodeOutputModal;
const CustomEditor = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e7qp9oz5"
})("font-family:Muli;*.jsoneditor-mode-tree{border:1px solid ", (0, _colors.color_shades_dark), ";font-family:Muli;}div.jsoneditor-menu{background-color:", (0, _colors.color_shades_darkest), ";border-bottom:none;}ul.jsoneditor-menu{background-color:white;}*.jsoneditor-navigation-bar{font-family:Muli;}.div.jsoneditor-field,div.jsoneditor-value,div.jsoneditor td,div.jsoneditor th,div.jsoneditor textarea,pre.jsoneditor-preview,.jsoneditor-schema-error,.jsoneditor-popover{font-family:Muli;}div.jsoneditor-tree div.jsoneditor-color{display:none;}");
const CopyButton = /*#__PURE__*/ (0, _baseDefault.default)((0, _buttonDefault.default), {
    target: "e7qp9oz4"
})({
    name: "1tx1l5v",
    styles: "margin-right:auto"
});
const CodeDiv = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e7qp9oz3"
})("border:1px solid ", (0, _colors.color_shades_dark), ";border-radius:8px;margin-right:24px;margin-bottom:32px;margin-left:24px;margin-top:32px;overflow:hidden;");
const CopySpan = /*#__PURE__*/ (0, _baseDefault.default)("span", {
    target: "e7qp9oz2"
})("margin-left:auto;color:", (0, _colors.text_blue), " cursor:pointer;margin-right:24px;");
const CopyImg = /*#__PURE__*/ (0, _baseDefault.default)("img", {
    target: "e7qp9oz1"
})({
    name: "u4qs01",
    styles: "margin-left:8px;height:20px;width:20px;cursor:pointer;vertical-align:middle"
});
const CopyDiv = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e7qp9oz0"
})({
    name: "151zhwt",
    styles: "margin-top:24px;display:flex"
});
const CodeOutputModalStyle = /*#__PURE__*/ (0, _css.css)("height:804px;min-height:804px;width:1152px;min-width:1152px;", (0, _breakpoints.breakpoint_small), "{height:90vh;min-height:90vh;width:95vw;min-width:95vw;max-width:95vw;}", "");

},{"@emotion/styled/base":"lSuFu","@emotion/react":"djZKr","react":"6uln9","../../../constants/colors":"1p3OR","../../../constants/breakpoints":"2F01A","../../../components/general/Button":"6ymxN","@emotion/css":"awUBr","../../../components/general/ModalHeader":"aUACx","../../../components/structure/FooterBar":"bibRL","../../../hooks/UseWindowSize":"43j9z","../../../components/structure/ModalLayout":"b1cO3","jsoneditor-react":"5EVpf","5ec8eb36138546a5":"6HqvT","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"fHvPO":[function(require,module,exports) {
module.exports = require("19b19cf33dd1f682").getBundleURL("kVLro") + require("7a9ab741fdda0866").resolve("1RSN6");

},{"19b19cf33dd1f682":"c7Tr5","7a9ab741fdda0866":"fyJL2"}],"41TbH":[function(require,module,exports) {
module.exports = require("b29d72a65e251e2e").getBundleURL("kVLro") + require("f350d59c2a4626a2").resolve("3CQDH");

},{"b29d72a65e251e2e":"c7Tr5","f350d59c2a4626a2":"fyJL2"}],"jSys4":[function(require,module,exports) {
module.exports = require("efc5f6a4249afb15").getBundleURL("kVLro") + require("43134157ae71aaa").resolve("9YB8n");

},{"efc5f6a4249afb15":"c7Tr5","43134157ae71aaa":"fyJL2"}],"faw9Z":[function(require,module,exports) {
module.exports = require("28563c77fa948dd3").getBundleURL("kVLro") + require("b71702a03c6517af").resolve("fEbHB");

},{"28563c77fa948dd3":"c7Tr5","b71702a03c6517af":"fyJL2"}],"gWS0M":[function(require,module,exports) {
module.exports = require("62deffcbdb639ce5").getBundleURL("kVLro") + require("13d8d64eba6f17f9").resolve("GnpAe");

},{"62deffcbdb639ce5":"c7Tr5","13d8d64eba6f17f9":"fyJL2"}],"5Agu1":[function(require,module,exports) {
module.exports = require("8c237a96e0f5fa74").getBundleURL("kVLro") + require("421c52d95189fa57").resolve("48g0J");

},{"8c237a96e0f5fa74":"c7Tr5","421c52d95189fa57":"fyJL2"}],"1d7sY":[function(require,module,exports) {
module.exports = require("2b6cadcbc16d1b60").getBundleURL("kVLro") + require("e0348c8c755cf637").resolve("5kqls");

},{"2b6cadcbc16d1b60":"c7Tr5","e0348c8c755cf637":"fyJL2"}],"hoUpc":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _unstated = require("unstated");
var _titleStateContainer = require("../../state/containers/TitleStateContainer");
var _titleStateContainerDefault = parcelHelpers.interopDefault(_titleStateContainer);
var _applicationContainer = require("../../state/containers/ApplicationContainer");
var _applicationContainerDefault = parcelHelpers.interopDefault(_applicationContainer);
var _organizationContainer = require("../../state/containers/OrganizationContainer");
var _organizationContainerDefault = parcelHelpers.interopDefault(_organizationContainer);
var _applicationDashboardContent = require("./components/ApplicationDashboardContent");
var _applicationDashboardContentDefault = parcelHelpers.interopDefault(_applicationDashboardContent);
var _featureContainer = require("../../state/containers/FeatureContainer");
var _featureContainerDefault = parcelHelpers.interopDefault(_featureContainer);
var _contentTreeStateContainer = require("../../state/containers/ContentTreeStateContainer");
var _contentTreeStateContainerDefault = parcelHelpers.interopDefault(_contentTreeStateContainer);
var _importExportContainer = require("../../state/containers/ImportExportContainer");
var _importExportContainerDefault = parcelHelpers.interopDefault(_importExportContainer);
var _templateConfigurationContainer = require("../../state/containers/TemplateConfigurationContainer");
var _templateConfigurationContainerDefault = parcelHelpers.interopDefault(_templateConfigurationContainer);
var _appliedApplicationTemplateContainer = require("../../state/containers/AppliedApplicationTemplateContainer");
var _appliedApplicationTemplateContainerDefault = parcelHelpers.interopDefault(_appliedApplicationTemplateContainer);
var _applicationAnalyticsFacetContainer = require("../../state/containers/ApplicationAnalyticsFacetContainer");
var _applicationAnalyticsFacetContainerDefault = parcelHelpers.interopDefault(_applicationAnalyticsFacetContainer);
var _webhookFolderContainer = require("../../state/containers/WebhookFolderContainer");
var _webhookFolderContainerDefault = parcelHelpers.interopDefault(_webhookFolderContainer);
var _webhookContainer = require("../../state/containers/WebhookContainer");
var _webhookContainerDefault = parcelHelpers.interopDefault(_webhookContainer);
var _integrationsListingsContainer = require("../../state/containers/IntegrationsListingsContainer");
var _integrationsListingsContainerDefault = parcelHelpers.interopDefault(_integrationsListingsContainer);
var _applicationEnvironmentsContainer = require("../../state/containers/ApplicationEnvironmentsContainer");
var _applicationEnvironmentsContainerDefault = parcelHelpers.interopDefault(_applicationEnvironmentsContainer);
var _applicationBackupVersionsContainer = require("../../state/containers/ApplicationBackupVersionsContainer");
var _applicationBackupVersionsContainerDefault = parcelHelpers.interopDefault(_applicationBackupVersionsContainer);
var _loaderWithHeader = require("../../components/general/LoaderWithHeader");
var _loaderWithHeaderDefault = parcelHelpers.interopDefault(_loaderWithHeader);
var _userContainer = require("../../state/containers/UserContainer");
var _userContainerDefault = parcelHelpers.interopDefault(_userContainer);
var _applicationMembersContainer = require("../../state/containers/ApplicationMembersContainer");
var _applicationMembersContainerDefault = parcelHelpers.interopDefault(_applicationMembersContainer);
var _memberContainer = require("../../state/containers/MemberContainer");
var _memberContainerDefault = parcelHelpers.interopDefault(_memberContainer);
var _currentApplicationContainer = require("../../hooks/CurrentApplicationContainer");
var _currentApplicationContainerDefault = parcelHelpers.interopDefault(_currentApplicationContainer);
const ApplicationDashboard = (props)=>{
    const { applicationId, applicationFeatureId, webhookFolderId, contentItemId, environmentId } = props.match.params;
    const webhookId = new URLSearchParams(props.location.search).get("webhookId");
    // Set current application ID in the container
    const currentAppContainer = (0, _currentApplicationContainerDefault.default).useContainer();
    (0, _react1.useEffect)(()=>{
        const appId = applicationId;
        if (appId) currentAppContainer.setApplicationId(appId);
    }, [
        applicationId
    ]);
    if (contentItemId) // if we're on a content item page lets show the header and a loader so loading directly there is smooth
    return (0, _react.jsx)((0, _loaderWithHeaderDefault.default), null);
    return (0, _react.jsx)((0, _unstated.Subscribe), {
        to: [
            (0, _titleStateContainerDefault.default),
            (0, _applicationContainerDefault.default),
            (0, _organizationContainerDefault.default),
            (0, _featureContainerDefault.default),
            (0, _contentTreeStateContainerDefault.default),
            (0, _importExportContainerDefault.default),
            (0, _templateConfigurationContainerDefault.default),
            (0, _appliedApplicationTemplateContainerDefault.default),
            (0, _applicationAnalyticsFacetContainerDefault.default),
            (0, _webhookContainerDefault.default),
            (0, _webhookFolderContainerDefault.default),
            (0, _integrationsListingsContainerDefault.default),
            (0, _applicationEnvironmentsContainerDefault.default),
            (0, _applicationBackupVersionsContainerDefault.default),
            (0, _userContainerDefault.default),
            (0, _applicationMembersContainerDefault.default),
            (0, _memberContainerDefault.default)
        ]
    }, (titleContainer, appContainer, orgContainer, featureContainer, treeContainer, importExportContainer, templateConfigurationContainer, appliedAppTemplateContainer, facetContainer, webhookContainer, webhookFolderContainer, integrationsContainer, environmentsContainer, backupsContainer, userContainer, appMembershipContainer, memberContainer)=>{
        return (0, _react.jsx)((0, _applicationDashboardContentDefault.default), {
            importExportContainer: importExportContainer,
            titleContainer: titleContainer,
            appContainer: appContainer,
            orgContainer: orgContainer,
            featureContainer: featureContainer,
            applicationId: applicationId ?? appContainer?.state?.currentApp?.id,
            environmentId: environmentId,
            history: props.history,
            key: applicationId ?? applicationFeatureId,
            treeContainer: treeContainer,
            templateConfigurationContainer: templateConfigurationContainer,
            appliedAppTemplateContainer: appliedAppTemplateContainer,
            facetContainer: facetContainer,
            currentFeatureId: applicationFeatureId,
            currentWebhookFolderId: webhookFolderId,
            currentWebhookId: webhookId,
            webhookContainer: webhookContainer,
            webhookFolderContainer: webhookFolderContainer,
            integrationsContainer: integrationsContainer,
            backupsContainer: backupsContainer,
            environmentsContainer: environmentsContainer,
            userContainer: userContainer,
            applicationMembersContainer: appMembershipContainer,
            orgMemberContainer: memberContainer
        });
    });
};
exports.default = ApplicationDashboard;

},{"@emotion/react":"djZKr","react":"6uln9","unstated":"grh7p","../../state/containers/TitleStateContainer":"2osOD","../../state/containers/ApplicationContainer":"cuqi2","../../state/containers/OrganizationContainer":"dlbaM","./components/ApplicationDashboardContent":"1fwEe","../../state/containers/FeatureContainer":"4ApGg","../../state/containers/ContentTreeStateContainer":"e0LlA","../../state/containers/ImportExportContainer":"lujXS","../../state/containers/TemplateConfigurationContainer":"aJrgZ","../../state/containers/AppliedApplicationTemplateContainer":"3XuX7","../../state/containers/ApplicationAnalyticsFacetContainer":"btY5V","../../state/containers/WebhookFolderContainer":"l24Qu","../../state/containers/WebhookContainer":"4VCcR","../../state/containers/IntegrationsListingsContainer":"4z81X","../../state/containers/ApplicationEnvironmentsContainer":"jCULY","../../state/containers/ApplicationBackupVersionsContainer":"6rA1P","../../components/general/LoaderWithHeader":"aUCTk","../../state/containers/UserContainer":"jDrDR","../../state/containers/ApplicationMembersContainer":"hsHim","../../state/containers/MemberContainer":"iYQOb","../../hooks/CurrentApplicationContainer":"4hT7h","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1fwEe":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _reactTabs = require("react-tabs");
var _fullPageTabbedPanel = require("../../../components/structure/Panels/FullPageTabbedPanel");
var _fullPageTabbedPanelDefault = parcelHelpers.interopDefault(_fullPageTabbedPanel);
var _logo = require("../../dashboardHeader/components/Logo");
var _logoDefault = parcelHelpers.interopDefault(_logo);
var _headerSeparator = require("../../../components/structure/Panels/HeaderSeparator");
var _headerSeparatorDefault = parcelHelpers.interopDefault(_headerSeparator);
var _applicationSelectorMenu = require("../../applicationSelectorMenu");
var _applicationSelectorMenuDefault = parcelHelpers.interopDefault(_applicationSelectorMenu);
var _dashboardHeader = require("../../dashboardHeader");
var _dashboardHeaderDefault = parcelHelpers.interopDefault(_dashboardHeader);
var _profileMenu = require("../../profileMenu");
var _profileMenuDefault = parcelHelpers.interopDefault(_profileMenu);
var _featureContentManager = require("../../featureContentManager");
var _featureContentManagerDefault = parcelHelpers.interopDefault(_featureContentManager);
var _scrollablePanelBody = require("../../../components/structure/ScrollablePanelBody");
var _scrollablePanelBodyDefault = parcelHelpers.interopDefault(_scrollablePanelBody);
var _applicationAnalytics = require("../../applicationAnalytics");
var _applicationAnalyticsDefault = parcelHelpers.interopDefault(_applicationAnalytics);
var _applicationMembers = require("../../applicationMembers");
var _applicationMembersDefault = parcelHelpers.interopDefault(_applicationMembers);
var _applicationSettings = require("../../applicationSettings");
var _applicationSettingsDefault = parcelHelpers.interopDefault(_applicationSettings);
var _simulator = require("../../simulator");
var _simulatorDefault = parcelHelpers.interopDefault(_simulator);
var _applicationAppliedTemplates = require("../../applicationAppliedTemplates");
var _applicationAppliedTemplatesDefault = parcelHelpers.interopDefault(_applicationAppliedTemplates);
var _webhookManager = require("../../webhookManager");
var _webhookManagerDefault = parcelHelpers.interopDefault(_webhookManager);
var _applicationModules = require("../../applicationModules");
var _applicationModulesDefault = parcelHelpers.interopDefault(_applicationModules);
var _loaderWithHeader = require("../../../components/general/LoaderWithHeader");
var _loaderWithHeaderDefault = parcelHelpers.interopDefault(_loaderWithHeader);
var _pageError = require("../../../components/general/PageError");
var _pageErrorDefault = parcelHelpers.interopDefault(_pageError);
var _nlpModelTrainingIndicator = require("./NlpModelTrainingIndicator");
var _nlpModelTrainingIndicatorDefault = parcelHelpers.interopDefault(_nlpModelTrainingIndicator);
const contentIcon = require("cbd0d1d57ddbac85");
const analyticsIcon = require("287929c06895dbb");
const participantsIcon = require("9f99b5346981196");
const webhooksIcon = require("6caa7e403577de15");
const settingsIcon = require("ba4ddd1d0dfb9837");
const simulatorIcon = require("efecad31318dc076");
const modulesIcon = require("7c29f2fd5728fbd4");
const analyticsTabName = "analytics";
const participantsTabName = "participants";
const settingsTabName = "appSettings";
const simulatorTabName = "simulator";
const webhooksTabName = "webhooks";
const modulesTabName = "modules";
const templatesSubTabName = "templates";
const ApplicationDashboardContent = (props)=>{
    const [loaded, setLoaded] = (0, _react1.useState)(false);
    const [isAppAdmin, setIsAppAdmin] = (0, _react1.useState)(false);
    (0, _react1.useEffect)(()=>{
        if (props.applicationMembersContainer.state.members == null || props.applicationMembersContainer.state.members.length == 0) props.applicationMembersContainer.getMembersForApp(props.applicationId);
    }, []);
    (0, _react1.useEffect)(()=>{
        const asyncLoad = async ()=>{
            let appId = props.applicationId;
            if (!appId) {
                const featureResult = await props.featureContainer.getApplicationFeature(props.currentFeatureId);
                appId = featureResult.data.applicationId;
            }
            const appResult = await props.appContainer.loadCurrentAppById(appId);
            props.titleContainer.setTitleView(appResult?.data?.name, [
                {
                    id: props.orgContainer.state.currentOrganization.id,
                    title: props.orgContainer.state.currentOrganization.name,
                    link: "/v"
                }
            ], appResult?.data);
            props.featureContainer.getFeaturesForApp(appId);
            props.webhookContainer.getWebhookAttachmentsForApplication(appId);
            props.featureContainer.getConversationCounts(appId);
            props.appliedAppTemplateContainer.loadAppliedTemplates(appId);
            props.environmentsContainer.loadEnvironments(appId);
            await setLoaded(true);
        };
        asyncLoad();
    }, [
        props.applicationId
    ]);
    (0, _react1.useEffect)(()=>{
        if (!props.applicationId || props.applicationMembersContainer.state.isLoading || props.userContainer.state?.currentUser?.id == null) return;
        else {
            props.orgMemberContainer.checkIsOrgAdmin(props.orgContainer.state.currentOrganization.id, props.userContainer.state.currentUser.id);
            const isAdmin = props.applicationMembersContainer.isUserAppAdmin(props.userContainer.state.currentUser.id, props.applicationId);
            setIsAppAdmin(isAdmin || props.orgMemberContainer.state.isOrgAdmin);
        }
    }, [
        props.userContainer.state.currentUser?.id,
        props.applicationId,
        props.applicationMembersContainer.state.members,
        props.orgMemberContainer.state.isOrgAdmin
    ]);
    const handleTabSelection = (index, last)=>{
        if (index == last) return;
        const urlStart = "/v/apps/" + props.applicationId;
        switch(index){
            case 0:
                props.history.push(urlStart);
                break;
            case 1:
                props.history.push(`${urlStart}/${analyticsTabName}`);
                break;
            case 2:
                props.history.push(`${urlStart}/${participantsTabName}`);
                break;
            case 3:
                props.history.push(`${urlStart}/${webhooksTabName}`);
                break;
            case 4:
                props.history.push(`${urlStart}/${modulesTabName}`);
                break;
            case 5:
                props.history.push(`${urlStart}/${simulatorTabName}`);
                break;
            case 6:
                props.history.push(`${urlStart}/${settingsTabName}`);
                break;
        }
    };
    const getSelectedIndex = ()=>{
        if (location.href.indexOf(analyticsTabName) > -1) return 1;
        if (location.href.indexOf(participantsTabName) > -1) return 2;
        if (location.href.indexOf(webhooksTabName) > -1) return 3;
        if (location.href.indexOf(modulesTabName) > -1) return 4;
        if (location.href.indexOf(simulatorTabName) > -1) return 5;
        if (location.href.indexOf(settingsTabName) > -1) return 6;
        return 0;
    };
    const app = props.appContainer.state.currentApp;
    if (!loaded) return (0, _react.jsx)((0, _loaderWithHeaderDefault.default), null);
    return (0, _react.jsx)((0, _fullPageTabbedPanelDefault.default), {
        key: app?.id ?? "app",
        tabs: [
            {
                title: "Content",
                icon: contentIcon,
                selectedIcon: contentIcon,
                className: "ac-app-content-tab"
            },
            {
                title: "Analytics",
                icon: analyticsIcon,
                selectedIcon: analyticsIcon,
                className: "ac-app-analytics-tab"
            },
            {
                title: "Participants",
                icon: participantsIcon,
                selectedIcon: participantsIcon,
                className: "ac-app-participants-tab"
            },
            {
                title: "Webhooks",
                icon: webhooksIcon,
                selectedIcon: webhooksIcon,
                className: "ac-app-webhooks-tab"
            },
            {
                title: "Modules",
                icon: modulesIcon,
                selectedIcon: modulesIcon,
                className: "ac-app-modules-tab ac-app-modules-tab"
            },
            {
                title: "Simulator",
                icon: simulatorIcon,
                selectedIcon: simulatorIcon,
                className: "ac-app-simulator-tab"
            },
            {
                title: "Settings",
                icon: settingsIcon,
                selectedIcon: settingsIcon,
                className: "ac-app-settings-tab"
            }
        ],
        onTabSelected: handleTabSelection.bind(undefined),
        selectedIndex: getSelectedIndex(),
        leftRender: ()=>(0, _react.jsx)((0, _reactDefault.default).Fragment, null, (0, _react.jsx)((0, _logoDefault.default), {
                isFull: true,
                isInverse: true
            }), (0, _react.jsx)((0, _applicationSelectorMenuDefault.default), {
                application: app,
                appContainer: props.appContainer,
                organizationId: props.orgContainer.state.currentOrganization?.id
            })),
        titleRender: ()=>(0, _react.jsx)((0, _dashboardHeaderDefault.default), null),
        rightRender: ()=>(0, _react.jsx)((0, _reactDefault.default).Fragment, null, (0, _react.jsx)((0, _headerSeparatorDefault.default), null), (0, _react.jsx)((0, _profileMenuDefault.default), null))
    }, (0, _react.jsx)((0, _reactTabs.TabPanel), null, location.href.indexOf(templatesSubTabName) > -1 ? (0, _react.jsx)((0, _applicationAppliedTemplatesDefault.default), {
        key: props.currentFeatureId,
        appContainer: props.appContainer,
        appliedAppTemplateContainer: props.appliedAppTemplateContainer,
        applicationId: props.applicationId,
        templateConfigurationContainer: props.templateConfigurationContainer,
        history: props.history,
        hasFullMenu: true
    }) : (0, _react.jsx)((0, _featureContentManagerDefault.default), {
        key: props.currentFeatureId,
        appContainer: props.appContainer,
        featureContainer: props.featureContainer,
        webhookContainer: props.webhookContainer,
        importExportContainer: props.importExportContainer,
        treeContainer: props.treeContainer,
        environmentsContainer: props.environmentsContainer,
        backupsContainer: props.backupsContainer,
        currentFeatureId: props.currentFeatureId ?? props.featureContainer.getRootFeature(props.applicationId)?.id,
        applicationId: props.applicationId,
        history: props.history,
        isAppAdmin: isAppAdmin,
        withNesting: false
    })), (0, _react.jsx)((0, _reactTabs.TabPanel), null, (0, _react.jsx)((0, _applicationAnalyticsDefault.default), {
        application: app,
        facetContainer: props.facetContainer,
        history: props.history
    })), (0, _react.jsx)((0, _reactTabs.TabPanel), null, (0, _react.jsx)((0, _scrollablePanelBodyDefault.default), null, (0, _react.jsx)((0, _applicationMembersDefault.default), {
        applicationId: props.applicationId,
        history: props.history
    }))), (0, _react.jsx)((0, _reactTabs.TabPanel), null, (0, _react.jsx)((0, _webhookManagerDefault.default), {
        key: props.currentWebhookFolderId,
        webhookContainer: props.webhookContainer,
        webhookFolderContainer: props.webhookFolderContainer,
        importExportContainer: props.importExportContainer,
        appContainer: props.appContainer,
        treeContainer: props.treeContainer,
        currentFolderId: props.currentWebhookFolderId,
        currentWebhookId: props.currentWebhookId,
        applicationId: props.applicationId,
        organizationId: props.orgContainer.state.currentOrganization?.id,
        history: props.history,
        withNesting: false
    })), (0, _react.jsx)((0, _reactTabs.TabPanel), null, (0, _react.jsx)((0, _applicationModulesDefault.default), {
        appContainer: props.appContainer,
        templateConfigurationContainer: props.templateConfigurationContainer,
        appliedAppTemplateContainer: props.appliedAppTemplateContainer,
        integrationsContainer: props.integrationsContainer,
        orgContainer: props.orgContainer,
        applicationId: props.applicationId,
        history: props.history
    })), (0, _react.jsx)((0, _reactTabs.TabPanel), null, (0, _react.jsx)((0, _simulatorDefault.default), {
        key: props.applicationId,
        applicationId: props.applicationId,
        history: props.history
    })), (0, _react.jsx)((0, _reactTabs.TabPanel), null, (0, _react.jsx)((0, _applicationSettingsDefault.default), {
        environmentId: props.environmentId,
        key: props.applicationId,
        applicationId: props.applicationId,
        history: props.history
    })), (0, _react.jsx)((0, _pageErrorDefault.default), {
        errors: [
            ...props.backupsContainer?.state?.errors ?? [],
            ...props.environmentsContainer?.state?.errors ?? [],
            ...props.featureContainer?.state?.errors ?? [],
            ...props.appContainer?.state?.errors ?? [],
            ...props.orgContainer?.state?.errors ?? [],
            ...props.webhookContainer?.state?.errors ?? [],
            ...props.appliedAppTemplateContainer?.state?.errors ?? []
        ],
        onClear: ()=>{
            props.backupsContainer.clearErrors();
            props.environmentsContainer.clearErrors();
            props.featureContainer.clearErrors();
            props.appContainer.clearErrors();
            props.orgContainer.clearErrors();
            props.webhookContainer.clearErrors();
            props.appliedAppTemplateContainer.clearErrors();
        }
    }), (0, _react.jsx)((0, _nlpModelTrainingIndicatorDefault.default), {
        application: props.appContainer.state.assistantApplication
    }));
};
exports.default = ApplicationDashboardContent;

},{"@emotion/react":"djZKr","react":"6uln9","react-tabs":"92Sgf","../../../components/structure/Panels/FullPageTabbedPanel":"72bEo","../../dashboardHeader/components/Logo":"8VQkf","../../../components/structure/Panels/HeaderSeparator":"c2pZO","../../applicationSelectorMenu":"bMOSh","../../dashboardHeader":"6RpIg","../../profileMenu":"irOVp","../../featureContentManager":"1nHBT","../../../components/structure/ScrollablePanelBody":"6LRg3","../../applicationAnalytics":"9kz2b","../../applicationMembers":"4qLCH","../../applicationSettings":"3j96I","../../simulator":"eKxIN","../../applicationAppliedTemplates":"kqidT","../../webhookManager":"hHRLs","../../applicationModules":"bvK1D","../../../components/general/LoaderWithHeader":"aUCTk","../../../components/general/PageError":"ezFTm","./NlpModelTrainingIndicator":"cTOlL","cbd0d1d57ddbac85":"30Bfz","287929c06895dbb":"7VuKq","9f99b5346981196":"1h75T","6caa7e403577de15":"gy99Q","ba4ddd1d0dfb9837":"5Agu1","efecad31318dc076":"lowHs","7c29f2fd5728fbd4":"ibi1X","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1nHBT":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _moment = require("moment");
var _momentDefault = parcelHelpers.interopDefault(_moment);
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _extensions = require("../../models/extensions");
var _featureToolbar = require("../featureContent/components/FeatureToolbar");
var _featureToolbarDefault = parcelHelpers.interopDefault(_featureToolbar);
var _panelContainer = require("../../components/structure/Panels/PanelContainer");
var _panelContainerDefault = parcelHelpers.interopDefault(_panelContainer);
var _applicationContentMenuPanel = require("../applicationContentMenuPanel");
var _applicationContentMenuPanelDefault = parcelHelpers.interopDefault(_applicationContentMenuPanel);
var _pageContainer = require("../../components/structure/PageContainer");
var _pageContainerDefault = parcelHelpers.interopDefault(_pageContainer);
var _selectionOptionsToolbar = require("../../components/general/SelectionOptionsToolbar");
var _selectionOptionsToolbarDefault = parcelHelpers.interopDefault(_selectionOptionsToolbar);
var _featureContent = require("../featureContent");
var _featureContentDefault = parcelHelpers.interopDefault(_featureContent);
var _contentExplorer = require("../contentExplorer");
var _contentExplorerDefault = parcelHelpers.interopDefault(_contentExplorer);
var _confirmationDialog = require("../../components/structure/ConfirmationDialog");
var _confirmationDialogDefault = parcelHelpers.interopDefault(_confirmationDialog);
var _deleteConfirmation = require("../featureContent/components/DeleteConfirmation");
var _deleteConfirmationDefault = parcelHelpers.interopDefault(_deleteConfirmation);
var _loader = require("../../components/general/Loader");
var _loaderDefault = parcelHelpers.interopDefault(_loader);
var _customScrollbars = require("../../components/structure/CustomScrollbars");
var _customScrollbarsDefault = parcelHelpers.interopDefault(_customScrollbars);
var _webhookInstanceManager = require("../webhookInstanceManager");
var _webhookInstanceManagerDefault = parcelHelpers.interopDefault(_webhookInstanceManager);
var _fullApplicationPublishModal = require("./components/FullApplicationPublishModal");
var _fullApplicationPublishModalDefault = parcelHelpers.interopDefault(_fullApplicationPublishModal);
var _partialPublishForm = require("../formScenes/PartialPublishForm");
var _partialPublishFormDefault = parcelHelpers.interopDefault(_partialPublishForm);
var _analyticsDateFormat = require("../../models/analytics/AnalyticsDateFormat");
var _importFileDialog = require("../../components/general/ImportFileDialog");
var _importFileDialogDefault = parcelHelpers.interopDefault(_importFileDialog);
const homeIcon = require("cedc64983500bd14");
const folderIcon = require("f3936d8fb9c8efd");
const FeatureContentManager = (props)=>{
    const [filters, setFilters] = (0, _react1.useState)({});
    const [loaded, setLoaded] = (0, _react1.useState)(false);
    const [selectedFeatureIds, setSelectedFeatureIds] = (0, _react1.useState)([]);
    const [selectedContentIds, setSelectedContentIds] = (0, _react1.useState)([]);
    const [isCopySelectorOpen, setIsCopySelectorOpen] = (0, _react1.useState)(false);
    const [isMoveSelectorOpen, setIsMoveSelectorOpen] = (0, _react1.useState)(false);
    const [isDeleteConfirmationOpen, setIsDeleteConfirmationOpen] = (0, _react1.useState)(false);
    const [isAddingNewFeature, setIsAddingNewFeature] = (0, _react1.useState)(false);
    const [isImporterOpen, setIsImporterOpen] = (0, _react1.useState)(false);
    const [isFilterExpanded, setIsFilterExpanded] = (0, _react1.useState)(false);
    const [isFullAppPublishOpen, setIsFullAppPublishOpen] = (0, _react1.useState)(false);
    const [publishingContentItems, setPublishingContentItems] = (0, _react1.useState)([]);
    const [isUnpublishing, setIsUnpublishing] = (0, _react1.useState)(false);
    const [publishingFolders, setPublishingFolders] = (0, _react1.useState)([]);
    const [editingFolderWithWebhooksId, setEditingFolderWithWebhooksId] = (0, _react1.useState)(null);
    const [editingContentItemWithWebhooks, setEditingContentItemWithWebhooks] = (0, _react1.useState)(null);
    (0, _react1.useEffect)(()=>{
        loadDetails();
    }, [
        props.currentFeatureId
    ]);
    (0, _react1.useEffect)(()=>{
        if (publishingContentItems.length == 0 && loaded) {
            const environment = props.environmentsContainer.findLiveEnvironment(props.applicationId);
            if (props.currentFeatureId && environment?.id) props.featureContainer.getApplicationFeatureContentPublishStatus(props.currentFeatureId, environment?.id);
        }
    }, [
        props.applicationId,
        props.currentFeatureId,
        props.environmentsContainer.state.environments,
        props.environmentsContainer.state.pollingIds,
        publishingContentItems,
        loaded
    ]);
    const loadDetails = async ()=>{
        if (props.currentFeatureId) {
            setLoaded(false);
            const promises = [];
            promises.push(props.featureContainer.getContentItemsForAppFeature(props.currentFeatureId));
            promises.push(loadEnvironments());
            await Promise.all(promises);
            props.treeContainer.addExpandedId(props.currentFeatureId);
            props.treeContainer.setSelectedId(props.currentFeatureId);
            setLoaded(true);
        }
    };
    const loadEnvironments = async ()=>{
        if (props.environmentsContainer.state.currentAppId != props.applicationId && props.applicationId) await props.environmentsContainer.loadEnvironments(props.applicationId);
    };
    const handleAddNewContent = (featureTypeId)=>{
        let url = (0, _extensions.getFeatureTypeCreateUrl)(featureTypeId, props.currentFeatureId);
        props.history.push(url);
    };
    const handleAddNewFeature = (text, applicationFeatureId)=>{
        props.featureContainer.addApplicationFeature(props.applicationId, text, applicationFeatureId).then((result)=>{
            if (result.resultType == "Ok") setIsAddingNewFeature(false);
        });
    };
    const getFilteredFeatures = (applicationFeatureId)=>{
        let features = props.featureContainer.getFeaturesForParent(applicationFeatureId);
        if (filters.textFilter) features = features.filter((af)=>(af.name ?? af.feature.name)?.toLowerCase().indexOf(filters.textFilter.toLowerCase()) > -1);
        return features;
    };
    const getFilteredContent = (applicationFeatureId)=>{
        let content = props.featureContainer.getContentByFeatureId(applicationFeatureId);
        if (filters.textFilter) content = content.filter((c)=>(c.title ?? "untitled")?.toLowerCase().indexOf(filters.textFilter.toLowerCase()) > -1);
        if (filters.featureTypeIdsFilter && filters.featureTypeIdsFilter.length > 0) content = content.filter((c)=>filters.featureTypeIdsFilter.some((id)=>id == c.featureTypeId));
        if (filters.languageIdsFilter) content = content.filter((c)=>filters.languageIdsFilter?.some((id)=>c.languages?.some((l)=>l.id == id)));
        if (filters.daysFilter) content = content.filter((c)=>(0, _momentDefault.default)().diff((0, _momentDefault.default)(c.modifiedDate), "days") <= filters.daysFilter);
        if (filters.propertiesFilter) {
            const { hasImage, hasAudio, hasVideo, isPublished, isDraft, isUpdated, isIncomplete, isSyncedAndPublished, isSyncedDraft, isSyncedAndUpdated } = filters.propertiesFilter;
            if (hasImage) content = content.filter((c)=>c.hasForegroundImage || c.hasBackgroundImage);
            if (hasAudio) content = content.filter((c)=>c.hasAudio);
            if (hasVideo) content = content.filter((c)=>c.hasVideo);
            // these need to be grouped
            content = content.filter((c)=>{
                if (!isPublished && !isDraft && !isUpdated && !isIncomplete && !isSyncedAndPublished && !isSyncedDraft && !isSyncedAndUpdated) return true;
                const lastPublish = props.featureContainer.state.featureContentPublishStatus.find((ps)=>ps.contentItemId === c.id);
                const modifiedDate = (0, _momentDefault.default)(c.modifiedDate, (0, _analyticsDateFormat.DATE_FORMAT));
                const latestPublish = lastPublish?.publishes?.length ? lastPublish.publishes[0] : null;
                let publishDate;
                if (latestPublish?.applicationEnvironmentPublish?.createdDate) publishDate = (0, _momentDefault.default)(latestPublish.applicationEnvironmentPublish.createdDate, (0, _analyticsDateFormat.DATE_FORMAT));
                if (isPublished) return publishDate && publishDate.isAfter(modifiedDate);
                if (isDraft) return !publishDate || latestPublish.publishEventType == "Unpublish";
                if (isUpdated) return publishDate && publishDate.isBefore(modifiedDate);
                if (isIncomplete) return !c.isComplete;
                if (isSyncedAndPublished) return publishDate && publishDate.isAfter(modifiedDate) && c.shouldNotSync && c.createdFromId;
                if (isSyncedDraft) return (!publishDate || latestPublish.publishEventType == "Unpublish") && c.shouldNotSync && c.createdFromId;
                if (isSyncedAndUpdated) return publishDate && publishDate.isBefore(modifiedDate) && c.shouldNotSync && c.createdFromId;
            });
        }
        return content;
    };
    const getBreadCrumbItems = ()=>{
        let ancestors = props.featureContainer.getAllAncestors(props.currentFeatureId);
        let crumbs = ancestors?.reverse()?.map((af)=>({
                id: af?.id,
                title: af?.name ?? af.feature?.name ?? af?.feature?.featureType?.name ?? "Untitled",
                link: `/v/apps/${props.applicationId}/content/${af.id}`
            }));
        return crumbs;
    };
    const handleContentItemSelectionChange = (contentItem, isSelected)=>{
        const selectedIds = [
            ...selectedContentIds
        ];
        if (isSelected) selectedIds.push(contentItem?.id);
        else selectedIds.splice(selectedIds.indexOf(contentItem.id), 1);
        setSelectedContentIds(selectedIds);
    };
    const handleFeatureSelectionChange = (applicationFeature, isSelected)=>{
        const selectedIds = [
            ...selectedFeatureIds
        ];
        if (isSelected) selectedIds.push(applicationFeature?.id);
        else selectedIds.splice(selectedIds.indexOf(applicationFeature.id), 1);
        setSelectedFeatureIds(selectedIds);
    };
    const handleSelectAll = ()=>{
        setSelectedFeatureIds(getFilteredFeatures(props.currentFeatureId)?.map((af)=>af.id) ?? []);
        setSelectedContentIds(getFilteredContent(props.currentFeatureId)?.map((c)=>c.id) ?? []);
    };
    const handleClearSelections = ()=>{
        setSelectedFeatureIds([]);
        setSelectedContentIds([]);
    };
    const handleExport = ()=>{
        const content = props.featureContainer.getContentByFeatureId(props.currentFeatureId ?? props.featureContainer.state.currentTopicFeatureId);
        const request = {
            applicationId: props.applicationId,
            applicationFeatures: selectedFeatureIds?.map((id)=>({
                    id
                })) ?? [],
            content: content?.filter((c)=>selectedContentIds.some((id)=>id == c.id))?.map((c)=>({
                    id: c.id,
                    featureTypeId: c.featureTypeId
                }))
        };
        props.importExportContainer.exportContentToFile(request, props.appContainer.state?.currentApp);
    };
    const handleCloseWebhookManager = ()=>{
        setEditingContentItemWithWebhooks(null);
        setEditingFolderWithWebhooksId(null);
    };
    const handleImportComplete = async (file)=>{
        const importResult = await props.importExportContainer.importFileToAppFeature(props.currentFeatureId, file);
        if (importResult.resultType == "Ok") {
            const promise = props.featureContainer.refreshForAppFeature(props.applicationId, props.currentFeatureId);
            promise.then((results)=>{
                if (results[0].resultType == "Ok" && results[1].resultType == "Ok") {
                    handleCloseModals();
                    props.featureContainer.getConversationCounts(props.applicationId);
                }
            });
        }
    };
    const handleMoveToSelected = async (_, featureIds)=>{
        if (featureIds.length > 0) {
            const content = props.featureContainer.getContentByFeatureId(props.currentFeatureId ?? props.featureContainer.state.currentTopicFeatureId);
            let result = await props.featureContainer.bulkMoveToAppFeature(featureIds[0], {
                applicationId: props.applicationId,
                applicationFeatures: selectedFeatureIds?.map((id)=>({
                        id
                    })) ?? [],
                content: content?.filter((c)=>selectedContentIds.some((id)=>id == c.id))?.map((c)=>({
                        id: c.id,
                        featureTypeId: c.featureTypeId
                    }))
            });
            if (result.resultType == "Ok") {
                handleCloseModals();
                props.history.push((0, _extensions.getFeatureContentUrl)(props.applicationId, featureIds[0]));
            }
        } else handleCloseModals();
    };
    const handleCopyToSelected = async (_, featureIds)=>{
        if (featureIds.length > 0) {
            const content = props.featureContainer.getContentByFeatureId(props.currentFeatureId ?? props.featureContainer.state.currentTopicFeatureId);
            const result = await props.featureContainer.bulkCopyToAppFeature(featureIds[0], {
                applicationId: props.applicationId,
                applicationFeatures: selectedFeatureIds?.map((id)=>({
                        id
                    })) ?? [],
                content: content?.filter((c)=>selectedContentIds.some((id)=>id == c.id))?.map((c)=>({
                        id: c.id,
                        featureTypeId: c.featureTypeId
                    }))
            });
            if (result.resultType == "Ok") {
                handleCloseModals();
                props.history.push((0, _extensions.getFeatureContentUrl)(props.applicationId, featureIds[0]));
            }
        } else handleCloseModals();
    };
    const handleDeleteConfirm = async ()=>{
        const content = props.featureContainer.getContentByFeatureId(props.currentFeatureId ?? props.featureContainer.state.currentTopicFeatureId);
        const result = await props.featureContainer.bulkDeleteContent(props.currentFeatureId, {
            applicationId: props.applicationId,
            applicationFeatures: selectedFeatureIds?.map((id)=>({
                    id
                })) ?? [],
            content: content?.filter((c)=>selectedContentIds.some((id)=>id == c.id))?.map((c)=>({
                    id: c.id,
                    featureTypeId: c.featureTypeId
                }))
        });
        if (result.resultType == "Ok") {
            handleCloseModals();
            handleClearSelections();
        }
    };
    const handleCloseModals = ()=>{
        setIsMoveSelectorOpen(false);
        setIsDeleteConfirmationOpen(false);
        setIsCopySelectorOpen(false);
        setIsImporterOpen(false);
        setPublishingContentItems([]);
        setPublishingFolders([]);
    };
    const finishManageWebhooks = ()=>{
        props.webhookContainer.getWebhookAttachmentsForApplication(props.applicationId);
        props.featureContainer.refreshForAppFeature(props.applicationId, props.currentFeatureId, true);
    };
    const handlePartialPublish = ()=>{
        // Publish selected content items, clear IsUnpublishing flag
        setIsUnpublishing(false);
        if (selectedContentIds.length > 0) {
            let content = props.featureContainer.getContentByFeatureId(props.currentFeatureId);
            content = content.filter((c)=>selectedContentIds.includes(c.id));
            if (content.length > 0) {
                const publishingContent = content.map((c)=>{
                    return {
                        contentId: c.id,
                        featureTypeId: c.featureTypeId
                    };
                });
                setPublishingContentItems(publishingContent);
            }
        }
        setPublishingFolders(selectedFeatureIds);
    };
    const feature = props.featureContainer.findFeatureById(props.currentFeatureId ?? props.featureContainer.state.currentTopicFeatureId);
    const application = props.appContainer.state.currentApp;
    const childContent = getFilteredContent(feature?.id);
    const childFeatures = getFilteredFeatures(feature?.id);
    const nonFilteredContent = props.featureContainer.getContentByFeatureId(feature?.id);
    const isContentFiltered = nonFilteredContent?.length > childContent?.length;
    if (!application) return (0, _react.jsx)((0, _loaderDefault.default), null);
    let selectionState = "none";
    if (childContent.length == selectedContentIds.length && childFeatures.length == selectedFeatureIds.length && (selectedContentIds.length > 0 || selectedFeatureIds.length > 0)) selectionState = "all";
    else if (selectedContentIds.length > 0 || selectedFeatureIds.length > 0) selectionState = "partial";
    return (0, _react.jsx)((0, _panelContainerDefault.default), null, (0, _react.jsx)((0, _applicationContentMenuPanelDefault.default), {
        history: props.history,
        application: application
    }), (0, _react.jsx)((0, _pageContainerDefault.default), {
        fill: true
    }, selectedContentIds.length > 0 || selectedFeatureIds.length > 0 ? (0, _react.jsx)((0, _selectionOptionsToolbarDefault.default), {
        applicationFeatureId: feature?.id,
        application: application,
        partialPublishDisabled: props.appContainer.state.assistantApplication == null,
        selectedContentIds: selectedContentIds,
        selectedFeaturesIds: selectedFeatureIds,
        icon: feature?.parentId ? folderIcon : homeIcon,
        groupSelectionState: selectionState,
        onClear: handleClearSelections.bind(undefined),
        onExport: handleExport.bind(undefined),
        isExporting: props.importExportContainer.state.isLoading,
        isMoving: props.featureContainer.state.isMoving,
        isCopying: props.featureContainer.state.isCopying,
        isDeleting: props.featureContainer.state.isDeleting,
        isPublishing: props.environmentsContainer.state.isLoading || props.backupsContainer.state.isCreating || props.backupsContainer.state.isLoading,
        onMove: ()=>setIsMoveSelectorOpen(true),
        onCopy: ()=>setIsCopySelectorOpen(true),
        onPublish: ()=>handlePartialPublish(),
        onUnselectAll: handleClearSelections.bind(undefined),
        onSelectAll: handleSelectAll.bind(undefined),
        isAppAdmin: props.isAppAdmin,
        onDelete: ()=>setIsDeleteConfirmationOpen(true),
        history: props.history
    }) : (0, _react.jsx)((0, _featureToolbarDefault.default), {
        applicationFeatureId: feature?.id,
        application: application,
        icon: feature?.parentId ? folderIcon : homeIcon,
        filters: filters,
        onAddNewFeature: ()=>setIsAddingNewFeature(true),
        onImport: ()=>setIsImporterOpen(true),
        onAddNewContent: handleAddNewContent.bind(undefined),
        onSelectAll: handleSelectAll.bind(undefined),
        onFullPublish: ()=>setIsFullAppPublishOpen(!isFullAppPublishOpen),
        featureContainer: props.featureContainer,
        groupSelectionState: selectionState,
        onToggleFilters: ()=>setIsFilterExpanded(!isFilterExpanded),
        isFilterExpanded: isFilterExpanded,
        onBreadCrumbItemClick: null,
        breadCrumbs: getBreadCrumbItems(),
        allowImport: true,
        isAppAdmin: props.isAppAdmin,
        history: props.history
    }), (0, _react.jsx)((0, _customScrollbarsDefault.default), {
        autoHide: true
    }, (0, _react.jsx)((0, _featureContentDefault.default), {
        feature: feature,
        showContentItemStatus: true,
        handlePublish: async (ci)=>{
            await setIsUnpublishing(false);
            await setPublishingContentItems([
                {
                    contentId: ci.id,
                    featureTypeId: ci.featureTypeId
                }
            ]);
        },
        handleUnpublish: async (ci)=>{
            await setIsUnpublishing(true);
            await setPublishingContentItems([
                {
                    contentId: ci.id,
                    featureTypeId: ci.featureTypeId
                }
            ]);
        },
        contentPublishStatus: props.featureContainer.state.featureContentPublishStatus,
        contentPublishStatusLoaded: props.featureContainer.state.loadedPublishHistoryFeatureId == props.currentFeatureId,
        featureContainer: props.featureContainer,
        webhookContainer: props.webhookContainer,
        childFeatures: childFeatures,
        contentItems: childContent,
        handleAddNewFeature: handleAddNewFeature.bind(undefined),
        withNesting: props.withNesting,
        applicationId: props.applicationId,
        selectedContentItemIds: selectedContentIds,
        selectedFeatureIds: selectedFeatureIds,
        onContentItemSelectionChange: handleContentItemSelectionChange.bind(undefined),
        onFeatureSelectionChange: handleFeatureSelectionChange.bind(undefined),
        onManageWebhooksForAppFeature: (appFeatureId)=>setEditingFolderWithWebhooksId(appFeatureId),
        onManageWebhooksForContentItem: (contentItemId)=>setEditingContentItemWithWebhooks(contentItemId),
        onFilterChange: (filters)=>setFilters(filters),
        application: application,
        filters: filters,
        isAddingNewFeature: isAddingNewFeature,
        isFilterExpanded: isFilterExpanded,
        navigatingContentItems: true,
        onStubAdded: ()=>{},
        droppableId: "features_main",
        selectableContentItems: true,
        selectableFeatures: true,
        statusDropDownDisabled: props.appContainer.state.assistantApplication == null,
        showContentItems: true,
        isContentFiltered: isContentFiltered
    })), isCopySelectorOpen && (0, _react.jsx)((0, _contentExplorerDefault.default), {
        applicationId: props.applicationId,
        exploreType: "feature-select",
        onClose: handleCloseModals.bind(undefined),
        title: "Select a folder to copy to",
        disabledFeatureIds: selectedFeatureIds,
        onSelect: handleCopyToSelected.bind(undefined),
        isLoading: props.featureContainer.state.isLoadingBulkOperation
    }), isMoveSelectorOpen && (0, _react.jsx)((0, _contentExplorerDefault.default), {
        applicationId: props.applicationId,
        exploreType: "feature-select",
        onClose: handleCloseModals.bind(undefined),
        title: "Select a folder to move to",
        disabledFeatureIds: selectedFeatureIds,
        onSelect: handleMoveToSelected.bind(undefined),
        isLoading: props.featureContainer.state.isLoadingBulkOperation
    }), isImporterOpen && (0, _react.jsx)((0, _importFileDialogDefault.default), {
        completeImport: handleImportComplete.bind(undefined),
        onClose: handleCloseModals.bind(undefined),
        title: "Import content into folder",
        acceptFileTypes: ".zip, .vfy",
        acceptFileTypesDisplayText: "Supports .zip, .vfy",
        isLoading: props.importExportContainer.state.isLoading,
        errors: props.importExportContainer.state.errors
    }), isDeleteConfirmationOpen && (0, _react.jsx)((0, _confirmationDialogDefault.default), {
        title: "Delete",
        deleteText: "Yes, Delete",
        isLoading: props.featureContainer.state.isLoadingBulkOperation,
        onClose: handleCloseModals.bind(undefined),
        onConfirm: handleDeleteConfirm.bind(undefined)
    }, (0, _react.jsx)((0, _deleteConfirmationDefault.default), {
        applicationFeatureCount: selectedFeatureIds.length,
        contentItemCount: selectedContentIds.length
    })), isFullAppPublishOpen && (0, _react.jsx)((0, _fullApplicationPublishModalDefault.default), {
        applicationId: props.applicationId,
        primaryEnvironmentId: props.environmentsContainer.findPrimaryEnvironment(props.applicationId)?.id,
        onClose: ()=>setIsFullAppPublishOpen(!isFullAppPublishOpen),
        environmentsContainer: props.environmentsContainer,
        backupsContainer: props.backupsContainer
    }), (publishingContentItems.length > 0 || publishingFolders.length > 0) && (0, _react.jsx)((0, _partialPublishFormDefault.default), {
        contentItems: publishingContentItems,
        applicationFeatureIds: publishingFolders,
        applicationId: props.applicationId,
        applicationFeatureId: props.currentFeatureId,
        history: props.history,
        onClose: ()=>handleCloseModals(),
        isUnpublishing: isUnpublishing
    }), (0, _react.jsx)((0, _webhookInstanceManagerDefault.default), {
        show: editingFolderWithWebhooksId != null || editingContentItemWithWebhooks != null,
        featureTypeId: editingContentItemWithWebhooks?.featureTypeId,
        existingWebhookChainingType: editingContentItemWithWebhooks?.webhookChainingType,
        webhookContainerId: editingFolderWithWebhooksId ?? editingContentItemWithWebhooks?.id,
        applicationId: props.applicationId,
        webhookInstanceScope: editingFolderWithWebhooksId != null ? "ApplicationFeature" : "Content",
        onClose: handleCloseWebhookManager.bind(undefined),
        onFinish: finishManageWebhooks.bind(undefined)
    })));
};
exports.default = FeatureContentManager;

},{"@emotion/react":"djZKr","moment":"2meyw","react":"6uln9","../../models/extensions":"7h01B","../featureContent/components/FeatureToolbar":"avRgQ","../../components/structure/Panels/PanelContainer":"9R2lE","../applicationContentMenuPanel":"12n7P","../../components/structure/PageContainer":"hc1r8","../../components/general/SelectionOptionsToolbar":"avfr2","../featureContent":"cSo8d","../contentExplorer":"k2ko3","../../components/structure/ConfirmationDialog":"kx7yK","../featureContent/components/DeleteConfirmation":"9xK2d","../../components/general/Loader":"bnV5T","../../components/structure/CustomScrollbars":"50vFq","../webhookInstanceManager":"1EIek","./components/FullApplicationPublishModal":"1BKac","../formScenes/PartialPublishForm":"bSD86","../../models/analytics/AnalyticsDateFormat":"ia5MW","../../components/general/ImportFileDialog":"7LQaS","cedc64983500bd14":"keV1x","f3936d8fb9c8efd":"jrk16","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"12n7P":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _menuStateContainer = require("../../state/containers/MenuStateContainer");
var _menuStateContainerDefault = parcelHelpers.interopDefault(_menuStateContainer);
var _applicationContainer = require("../../state/containers/ApplicationContainer");
var _applicationContainerDefault = parcelHelpers.interopDefault(_applicationContainer);
var _organizationContainer = require("../../state/containers/OrganizationContainer");
var _organizationContainerDefault = parcelHelpers.interopDefault(_organizationContainer);
var _featureContainer = require("../../state/containers/FeatureContainer");
var _featureContainerDefault = parcelHelpers.interopDefault(_featureContainer);
var _applicationMenu = require("./components/ApplicationMenu");
var _applicationMenuDefault = parcelHelpers.interopDefault(_applicationMenu);
var _unstated = require("unstated");
var _contentTreeStateContainer = require("../../state/containers/ContentTreeStateContainer");
var _contentTreeStateContainerDefault = parcelHelpers.interopDefault(_contentTreeStateContainer);
var _applicationBackupVersionsContainer = require("../../state/containers/ApplicationBackupVersionsContainer");
var _applicationBackupVersionsContainerDefault = parcelHelpers.interopDefault(_applicationBackupVersionsContainer);
class ApplicationContentMenuPanel extends (0, _reactDefault.default).Component {
    render() {
        return (0, _react.jsx)((0, _unstated.Subscribe), {
            to: [
                (0, _menuStateContainerDefault.default),
                (0, _applicationContainerDefault.default),
                (0, _organizationContainerDefault.default),
                (0, _featureContainerDefault.default),
                (0, _contentTreeStateContainerDefault.default),
                (0, _applicationBackupVersionsContainerDefault.default)
            ]
        }, (menuContainer, appContainer, orgContainer, featureContainer, treeContainer, backupsContainer)=>{
            return (0, _react.jsx)((0, _applicationMenuDefault.default), {
                appContainer: appContainer,
                menuContainer: menuContainer,
                orgContainer: orgContainer,
                featureContainer: featureContainer,
                application: this.props.application,
                history: this.props.history,
                treeContainer: treeContainer,
                backupsContainer: backupsContainer
            });
        });
    }
}
exports.default = ApplicationContentMenuPanel;

},{"@emotion/react":"djZKr","react":"6uln9","../../state/containers/MenuStateContainer":"kdPjq","../../state/containers/ApplicationContainer":"cuqi2","../../state/containers/OrganizationContainer":"dlbaM","../../state/containers/FeatureContainer":"4ApGg","./components/ApplicationMenu":"2HC9R","unstated":"grh7p","../../state/containers/ContentTreeStateContainer":"e0LlA","../../state/containers/ApplicationBackupVersionsContainer":"6rA1P","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"kdPjq":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _defineProperty = require("@babel/runtime/helpers/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _unstated = require("unstated");
var _api = require("../../api");
class MenuStateContainer extends (0, _unstated.Container) {
    constructor(...args){
        super(...args);
        (0, _definePropertyDefault.default)(this, "state", {
            isDrawerOpen: localStorage.getItem("menu") != "false",
            isLoading: false,
            applications: []
        });
    }
    loadApplicationsAndFeatures(organizationId) {
        this.setLoading(true);
        _api.getApplicationsWithFeaturesForOrg(organizationId).then((result)=>{
            if (result.resultType == "Ok") this.setState({
                ...this.state,
                applications: result.data
            });
            else this.setLoading(false);
        });
    }
    toggleDrawer() {
        var isDrawerOpen = this.state.isDrawerOpen;
        localStorage.setItem("menu", (!isDrawerOpen).toString());
        this.setState({
            ...this.state,
            isDrawerOpen: !isDrawerOpen
        });
    }
    setLoading(isLoading) {
        this.setState({
            ...this.state,
            isLoading
        });
    }
}
exports.default = MenuStateContainer;

},{"@babel/runtime/helpers/defineProperty":"9sJxO","unstated":"grh7p","../../api":"loxM6","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2HC9R":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _collapsingPanel = require("../../../components/structure/Panels/CollapsingPanel");
var _collapsingPanelDefault = parcelHelpers.interopDefault(_collapsingPanel);
var _applicationContentMenu = require("./ApplicationContentMenu");
var _applicationContentMenuDefault = parcelHelpers.interopDefault(_applicationContentMenu);
var _collapsedApplicationContentMenu = require("./CollapsedApplicationContentMenu");
var _collapsedApplicationContentMenuDefault = parcelHelpers.interopDefault(_collapsedApplicationContentMenu);
var _colors = require("../../../constants/colors");
var _breakpoints = require("../../../constants/breakpoints");
const ApplicationMenu = (props)=>{
    const onToggleCollapse = (e)=>{
        e.stopPropagation();
        props.menuContainer.toggleDrawer();
    };
    return (0, _react.jsx)("div", {
        className: `${containerStyle} ${props.menuContainer.state.isDrawerOpen ? " expanded" : " collapsed"} ac-content-left-menu`
    }, (0, _react.jsx)("div", {
        className: "fixed-wrapper"
    }, (0, _react.jsx)((0, _collapsingPanelDefault.default), {
        isCollapsed: !props.menuContainer.state.isDrawerOpen,
        collapsedView: (0, _react.jsx)((0, _collapsedApplicationContentMenuDefault.default), {
            history: props.history,
            application: props.application,
            appContainer: props.appContainer,
            featureContainer: props.featureContainer,
            treeContainer: props.treeContainer,
            backupsContainer: props.backupsContainer,
            onExpand: onToggleCollapse.bind(undefined)
        }),
        expandedView: (0, _react.jsx)((0, _applicationContentMenuDefault.default), {
            history: props.history,
            application: props.application,
            appContainer: props.appContainer,
            featureContainer: props.featureContainer,
            treeContainer: props.treeContainer,
            backupsContainer: props.backupsContainer,
            onCollapse: onToggleCollapse
        })
    })));
};
const containerStyle = /*#__PURE__*/ (0, _css.css)("z-index:2;bottom:0;position:relative;&.collapsed{width:80px;.fixed-wrapper{width:80px;}}&.expanded{width:288px;.fixed-wrapper{width:288px;}}.fixed-wrapper{position:fixed;top:80px;bottom:0;height:calc(100vh - 80px);background:white;border-right:1px solid ", (0, _colors.color_shades_dark), ";box-sizing:border-box;}", (0, _breakpoints.breakpoint_small), "{display:none;}", "");
exports.default = ApplicationMenu;

},{"@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","../../../components/structure/Panels/CollapsingPanel":"jVPoD","./ApplicationContentMenu":"4BhDj","./CollapsedApplicationContentMenu":"9Pn3n","../../../constants/colors":"1p3OR","../../../constants/breakpoints":"2F01A","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4BhDj":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _menuCollapseToggle = require("../../../components/structure/MenuCollapseToggle");
var _menuCollapseToggleDefault = parcelHelpers.interopDefault(_menuCollapseToggle);
var _applicationContentMenuContent = require("./ApplicationContentMenuContent");
var _applicationContentMenuContentDefault = parcelHelpers.interopDefault(_applicationContentMenuContent);
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const ApplicationContentMenu = (props)=>{
    return (0, _react.jsx)("div", {
        className: containerStyle
    }, (0, _react.jsx)((0, _menuCollapseToggleDefault.default), {
        isMinified: false,
        onToggle: props.onCollapse
    }), (0, _react.jsx)((0, _applicationContentMenuContentDefault.default), {
        backupsContainer: props.backupsContainer,
        appContainer: props.appContainer,
        application: props.application,
        featureContainer: props.featureContainer,
        treeContainer: props.treeContainer,
        history: props.history
    }));
};
const containerStyle = /*#__PURE__*/ (0, _css.css)({
    name: "g52d35",
    styles: ".panel-header{max-width:288px;}.header-container{position:relative;width:288px;display:flex;align-items:center;}"
});
exports.default = ApplicationContentMenu;

},{"@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","../../../components/structure/MenuCollapseToggle":"d7R0v","./ApplicationContentMenuContent":"brJAy","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"brJAy":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _applicationContentTree = require("./ApplicationContentTree");
var _applicationContentTreeDefault = parcelHelpers.interopDefault(_applicationContentTree);
var _applicationVariablesList = require("./ApplicationVariablesList");
var _applicationVariablesListDefault = parcelHelpers.interopDefault(_applicationVariablesList);
var _tabContainerPanel = require("../../../components/structure/Panels/TabContainerPanel");
var _tabContainerPanelDefault = parcelHelpers.interopDefault(_tabContainerPanel);
var _reactTabs = require("react-tabs");
var _applicationVariablesContainer = require("../../../hooks/ApplicationVariablesContainer");
var _applicationVariablesContainerDefault = parcelHelpers.interopDefault(_applicationVariablesContainer);
const contentTreeIcon = require("6c09e4b79ebd17df");
const contentTreeBlueIcon = require("a2ec61f4fff93243");
const constantsIcon = require("d994168654932f7a");
const constantsBlueIcon = require("613def475877c3b");
const ApplicationContentMenuContent = (props)=>{
    const [selectedTabIndex, setSelectedTabIndex] = (0, _react1.useState)(0);
    const handleTabChange = (index)=>{
        setSelectedTabIndex(index);
    };
    return (0, _react.jsx)((0, _applicationVariablesContainerDefault.default).Provider, null, (0, _react.jsx)((0, _tabContainerPanelDefault.default), {
        tabs: [
            {
                title: "Explorer",
                icon: contentTreeIcon,
                selectedIcon: contentTreeBlueIcon
            },
            {
                title: "Constants",
                icon: constantsIcon,
                selectedIcon: constantsBlueIcon
            }
        ],
        onTabSelected: handleTabChange,
        selectedIndex: selectedTabIndex
    }, (0, _react.jsx)((0, _reactTabs.TabPanel), null, (0, _react.jsx)("div", {
        className: "expanded-content-tree-container"
    }, (0, _react.jsx)((0, _applicationContentTreeDefault.default), {
        history: props.history,
        key: props.application?.id,
        application: props.application,
        appContainer: props.appContainer,
        featureContainer: props.featureContainer,
        backupsContainer: props.backupsContainer,
        treeContainer: props.treeContainer
    }))), (0, _react.jsx)((0, _reactTabs.TabPanel), null, (0, _react.jsx)("div", {
        className: "expanded-content-tree-container"
    }, (0, _react.jsx)((0, _applicationVariablesListDefault.default), {
        application: props.application
    })))));
};
exports.default = ApplicationContentMenuContent;

},{"@emotion/react":"djZKr","react":"6uln9","./ApplicationContentTree":"bn3fl","./ApplicationVariablesList":"cbp2C","../../../components/structure/Panels/TabContainerPanel":"iDHIJ","react-tabs":"92Sgf","../../../hooks/ApplicationVariablesContainer":"65mmm","6c09e4b79ebd17df":"f0x3E","a2ec61f4fff93243":"c2pA9","d994168654932f7a":"amyk0","613def475877c3b":"adACm","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"cbp2C":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _base = require("@emotion/styled/base");
var _baseDefault = parcelHelpers.interopDefault(_base);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _applicationVariablesContainer = require("../../../hooks/ApplicationVariablesContainer");
var _applicationVariablesContainerDefault = parcelHelpers.interopDefault(_applicationVariablesContainer);
var _button = require("../../../components/general/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _searchField = require("../../../components/forms/SearchField");
var _searchFieldDefault = parcelHelpers.interopDefault(_searchField);
var _customScrollbars = require("../../../components/structure/CustomScrollbars");
var _customScrollbarsDefault = parcelHelpers.interopDefault(_customScrollbars);
var _colors = require("../../../constants/colors");
var _applicationVariableEditModal = require("./ApplicationVariableEditModal");
var _applicationVariableEditModalDefault = parcelHelpers.interopDefault(_applicationVariableEditModal);
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const addIcon = require("7149090354f79db4");
const Header = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "epsfafo2"
})({
    name: "1uutyey",
    styles: "display:flex;justify-content:space-between;align-items:center;margin-bottom:8px;padding-bottom:4px"
});
const Title = /*#__PURE__*/ (0, _baseDefault.default)("span", {
    target: "epsfafo1"
})("margin:0;font-size:14px;font-weight:600;color:", (0, _colors.color_shades_darkest), ";line-height:1;");
const AddButton = /*#__PURE__*/ (0, _baseDefault.default)((0, _buttonDefault.default), {
    target: "epsfafo0"
})({
    name: "qklzi8",
    styles: "height:24px;width:24px;min-height:24px;min-width:24px;margin-top:4px;margin-bottom:4px"
});
const ApplicationVariablesList = (props)=>{
    const variablesContainer = (0, _applicationVariablesContainerDefault.default).useContainer();
    const [isEditModalOpen, setIsEditModalOpen] = (0, _react1.useState)(false);
    const [selectedVariable, setSelectedVariable] = (0, _react1.useState)(null);
    const [searchTerm, setSearchTerm] = (0, _react1.useState)("");
    (0, _react1.useEffect)(()=>{
        if (props.application?.id) variablesContainer.loadApplicationVariablesByApplicationId(props.application.id);
    }, [
        props.application?.id
    ]);
    const handleCreateVariable = ()=>{
        setSelectedVariable({
            name: "",
            value: "",
            applicationId: props.application.id
        });
        setIsEditModalOpen(true);
    };
    const handleEditVariable = (variable)=>{
        setSelectedVariable(variable);
        setIsEditModalOpen(true);
    };
    const handleCloseModal = ()=>{
        setIsEditModalOpen(false);
        setSelectedVariable(null);
    };
    const handleSaveVariable = async (variable)=>{
        if (variable.id) await variablesContainer.updateApplicationVariable(variable.id, variable);
        else await variablesContainer.createApplicationVariable(variable);
        handleCloseModal();
    };
    const handleDeleteVariable = async (variable)=>{
        if (variable.id && window.confirm(`Are you sure you want to delete the constant "${variable.name}"?`)) {
            await variablesContainer.deleteApplicationVariable(variable.id);
            handleCloseModal();
        }
    };
    const handleSearchChange = (e)=>{
        setSearchTerm(e.target.value);
    };
    const handleClearSearch = ()=>{
        setSearchTerm("");
    };
    const filteredVariables = variablesContainer.applicationVariables.filter((variable)=>variable.name.toLowerCase().includes(searchTerm.toLowerCase()));
    return (0, _react.jsx)("div", {
        className: containerStyle
    }, (0, _react.jsx)(Header, null, (0, _react.jsx)(Title, null, "Application Constants"), (0, _react.jsx)(AddButton, {
        themes: [
            "icon"
        ],
        icon: addIcon,
        onClick: handleCreateVariable
    })), (0, _react.jsx)((0, _searchFieldDefault.default), {
        placeholder: "Search constants by name...",
        value: searchTerm,
        onChange: handleSearchChange,
        handleClear: handleClearSearch,
        className: "search-field-compact",
        boxType: "square"
    }), (0, _react.jsx)("div", {
        className: "variables-list"
    }, (0, _react.jsx)((0, _customScrollbarsDefault.default), {
        autoHide: true
    }, (0, _react.jsx)("div", {
        className: "scrollable-content"
    }, filteredVariables.length === 0 ? (0, _react.jsx)("div", {
        className: "empty-state"
    }, searchTerm ? (0, _react.jsx)("p", null, 'No constants found matching "', searchTerm, '". Try a different search term.') : (0, _react.jsx)("p", null, "No constants found. Click the + button to create your first constant.")) : filteredVariables.map((variable)=>(0, _react.jsx)("div", {
            key: variable.id,
            className: "variable-item",
            onClick: ()=>handleEditVariable(variable)
        }, (0, _react.jsx)("div", {
            className: "variable-name"
        }, variable.name), (0, _react.jsx)("div", {
            className: "variable-value"
        }, variable.value)))))), isEditModalOpen && selectedVariable && (0, _react.jsx)((0, _applicationVariableEditModalDefault.default), {
        variable: selectedVariable,
        isVisible: isEditModalOpen,
        onClose: handleCloseModal,
        onSave: handleSaveVariable,
        onDelete: handleDeleteVariable
    }));
};
const containerStyle = /*#__PURE__*/ (0, _css.css)("padding:12px 16px 16px 16px;height:100%;display:flex;flex-direction:column;.search-field-compact{margin-bottom:8px!important;flex:none!important;>div:first-child{display:none!important;}>div:last-child>div{margin-top:0!important;}}.variables-list{flex:1;overflow:hidden;}.scrollable-content{padding-bottom:48px;}.empty-state{display:flex;align-items:center;justify-content:center;height:100px;color:", (0, _colors.color_shades_darker), ";font-style:italic;text-align:center;}.variable-item{padding:12px;border:1px solid ", (0, _colors.color_shades_dark), ";border-radius:8px;margin-bottom:8px;cursor:pointer;transition:all 0.2s ease;&:hover{border-color:", (0, _colors.color_colors_ocean), ";background-color:rgba(46, 125, 206, 0.05);}.variable-name{font-weight:600;font-size:14px;color:", (0, _colors.color_shades_darkest), ";margin-bottom:4px;}.variable-value{font-size:12px;color:", (0, _colors.color_shades_darker), ";word-break:break-all;overflow:hidden;text-overflow:ellipsis;display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;}}", "");
exports.default = ApplicationVariablesList;

},{"@emotion/styled/base":"lSuFu","@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","../../../hooks/ApplicationVariablesContainer":"65mmm","../../../components/general/Button":"6ymxN","../../../components/forms/SearchField":"aU10T","../../../components/structure/CustomScrollbars":"50vFq","../../../constants/colors":"1p3OR","./ApplicationVariableEditModal":"iikOM","7149090354f79db4":"6cI2N","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"iikOM":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _modalLayout = require("../../../components/structure/ModalLayout");
var _modalLayoutDefault = parcelHelpers.interopDefault(_modalLayout);
var _footerBar = require("../../../components/structure/FooterBar");
var _footerBarDefault = parcelHelpers.interopDefault(_footerBar);
var _textField = require("../../../components/forms/TextField");
var _textFieldDefault = parcelHelpers.interopDefault(_textField);
var _textAreaField = require("../../../components/forms/TextAreaField");
var _textAreaFieldDefault = parcelHelpers.interopDefault(_textAreaField);
var _button = require("../../../components/general/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _colors = require("../../../constants/colors");
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const closeIcon = require("c8b330f638e76467");
const deleteIcon = require("1bdd56f73f5e9e10");
const ApplicationVariableEditModal = (props)=>{
    const [name, setName] = (0, _react1.useState)(props.variable.name || "");
    const [value, setValue] = (0, _react1.useState)(props.variable.value || "");
    const [nameError, setNameError] = (0, _react1.useState)("");
    const [valueError, setValueError] = (0, _react1.useState)("");
    (0, _react1.useEffect)(()=>{
        setName(props.variable.name || "");
        setValue(props.variable.value || "");
        setNameError("");
        setValueError("");
    }, [
        props.variable
    ]);
    const validateForm = ()=>{
        let isValid = true;
        if (!name.trim()) {
            setNameError("Constant name is required");
            isValid = false;
        } else setNameError("");
        if (!value.trim()) {
            setValueError("Constant value is required");
            isValid = false;
        } else setValueError("");
        return isValid;
    };
    const handleSave = ()=>{
        if (validateForm()) {
            const updatedVariable = {
                ...props.variable,
                name: name.trim(),
                value: value.trim()
            };
            props.onSave(updatedVariable);
        }
    };
    const handleDelete = ()=>{
        props.onDelete(props.variable);
    };
    const isNewVariable = !props.variable.id;
    return (0, _react.jsx)((0, _modalLayoutDefault.default), {
        className: modalStyle,
        isVisible: props.isVisible,
        onClose: props.onClose,
        zIndex: 1010
    }, (0, _react.jsx)("div", {
        className: containerStyle
    }, (0, _react.jsx)("div", {
        className: "header-wrapper"
    }, (0, _react.jsx)("h2", null, isNewVariable ? "Create Constant" : "Edit Constant"), (0, _react.jsx)((0, _buttonDefault.default), {
        className: "close-icon",
        themes: [
            "end-tight",
            "icon"
        ],
        icon: closeIcon,
        type: "button",
        onClick: props.onClose
    })), !isNewVariable && (0, _react.jsx)("div", {
        onClick: handleDelete,
        className: "delete-confirmation"
    }, (0, _react.jsx)("div", null, "Delete Constant"), (0, _react.jsx)("img", {
        src: deleteIcon,
        alt: "Delete"
    })), (0, _react.jsx)("div", {
        className: "form-container"
    }, (0, _react.jsx)((0, _textFieldDefault.default), {
        name: "name",
        value: name,
        placeholder: "Enter constant name",
        label: "Constant Name",
        onChange: (e)=>setName(e.target.value),
        useForm: false
    }), nameError && (0, _react.jsx)("div", {
        className: "error-message"
    }, nameError), (0, _react.jsx)((0, _textAreaFieldDefault.default), {
        name: "value",
        value: value,
        placeholder: "Enter constant value",
        label: "Constant Value",
        onChange: (e)=>setValue(e.target.value),
        minRows: 8,
        maxRows: 25,
        useForm: false,
        showResponseVariableTest: true
    }), valueError && (0, _react.jsx)("div", {
        className: "error-message"
    }, valueError)), (0, _react.jsx)((0, _footerBarDefault.default), null, (0, _react.jsx)((0, _buttonDefault.default), {
        themes: [
            "primary",
            "wide"
        ],
        onClick: handleSave,
        text: isNewVariable ? "Create" : "Save",
        type: "button"
    }), (0, _react.jsx)((0, _buttonDefault.default), {
        themes: [
            "white",
            "end"
        ],
        onClick: props.onClose,
        text: "Cancel",
        type: "button"
    }))));
};
const modalStyle = /*#__PURE__*/ (0, _css.css)({
    name: "oi79z1",
    styles: "width:66vw;height:auto;max-height:80vh;min-height:850px;display:flex;flex-direction:column"
});
const containerStyle = /*#__PURE__*/ (0, _css.css)("display:flex;flex-direction:column;height:100%;max-height:80vh;overflow:hidden;.header-wrapper{display:flex;justify-content:space-between;align-items:center;padding:24px 32px 16px 32px;border-bottom:solid 1px ", (0, _colors.color_shades_dark), ";flex-shrink:0;h2{margin:0;font-size:24px;font-weight:600;color:", (0, _colors.color_shades_darkest), ";}.close-icon{cursor:pointer;}}.delete-confirmation{color:", (0, _colors.color_colors_ocean), ";position:absolute;right:32px;top:120px;cursor:pointer;display:flex;align-items:center;z-index:1;div{font-style:normal;font-weight:normal;font-size:14px;line-height:20px;margin-right:8px;}img{width:16px;height:16px;}&:hover{opacity:0.7;}}.form-container{padding:32px;padding-bottom:16px;flex:1;overflow-y:auto;min-height:0;.error-message{color:#e74c3c;font-size:12px;margin-top:4px;margin-bottom:16px;}}", "");
exports.default = ApplicationVariableEditModal;

},{"@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","../../../components/structure/ModalLayout":"b1cO3","../../../components/structure/FooterBar":"bibRL","../../../components/forms/TextField":"7a7bh","../../../components/forms/TextAreaField":"fE54C","../../../components/general/Button":"6ymxN","../../../constants/colors":"1p3OR","c8b330f638e76467":"93VwA","1bdd56f73f5e9e10":"f9rzT","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"f0x3E":[function(require,module,exports) {
module.exports = require("19fb39d05854aab9").getBundleURL("kVLro") + require("71b3534b2262537").resolve("g4HAv");

},{"19fb39d05854aab9":"c7Tr5","71b3534b2262537":"fyJL2"}],"c2pA9":[function(require,module,exports) {
module.exports = require("df8aac55ebcabab0").getBundleURL("kVLro") + require("e65ff500be4666f8").resolve("fAnXX");

},{"df8aac55ebcabab0":"c7Tr5","e65ff500be4666f8":"fyJL2"}],"9Pn3n":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _collapsedMenuPanel = require("../../../components/structure/CollapsedMenuPanel");
var _collapsedMenuPanelDefault = parcelHelpers.interopDefault(_collapsedMenuPanel);
var _applicationContentMenuContent = require("./ApplicationContentMenuContent");
var _applicationContentMenuContentDefault = parcelHelpers.interopDefault(_applicationContentMenuContent);
const CollapsedApplicationContentMenu = (props)=>{
    return (0, _react.jsx)((0, _collapsedMenuPanelDefault.default), {
        onExpand: props.onExpand,
        expandedViewRender: ()=>(0, _react.jsx)((0, _applicationContentMenuContentDefault.default), {
                backupsContainer: props.backupsContainer,
                appContainer: props.appContainer,
                application: props.application,
                featureContainer: props.featureContainer,
                treeContainer: props.treeContainer,
                history: props.history
            })
    });
};
exports.default = CollapsedApplicationContentMenu;

},{"@emotion/react":"djZKr","react":"6uln9","../../../components/structure/CollapsedMenuPanel":"1mVIj","./ApplicationContentMenuContent":"brJAy","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"avfr2":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _css = require("@emotion/css");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _checkIndicator = require("../forms/CheckIndicator");
var _checkIndicatorDefault = parcelHelpers.interopDefault(_checkIndicator);
var _button = require("./Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _colors = require("../../constants/colors");
var _conditionalTooltipWrapper = require("./ConditionalTooltipWrapper");
var _conditionalTooltipWrapperDefault = parcelHelpers.interopDefault(_conditionalTooltipWrapper);
const moveIcon = require("7c032ca8f012a283");
const copyIcon = require("a88c6ab53d96e3c3");
const deleteIcon = require("acebb5502afff864");
const exportIcon = require("37911f9e6230dc70");
const publishIcon = require("4793cb509445f98d");
class SelectionOptionsToolbar extends (0, _reactDefault.default).Component {
    constructor(props){
        super(props);
    }
    getSelectionLabel() {
        var label = "";
        if (this.props.selectedFeaturesIds.length > 0) label += `${this.props.selectedFeaturesIds.length} Folder${this.props.selectedFeaturesIds.length > 1 ? "s" : ""}`;
        if (this.props.selectedContentIds.length > 0) {
            if (this.props.selectedFeaturesIds.length > 0) label += ", ";
            label += `${this.props.selectedContentIds.length} ${this.props.isSelectingWebhooks == true ? "Webhook" : "Conversation"}${this.props.selectedContentIds.length > 1 ? "s" : ""}`;
        }
        return label;
    }
    render() {
        return (0, _react.jsx)("div", {
            className: containerStyle
        }, (0, _react.jsx)("div", {
            className: "tool-bar-container"
        }, (0, _react.jsx)("div", {
            className: "group-select-container"
        }, (0, _react.jsx)((0, _checkIndicatorDefault.default), {
            onClick: ()=>this.props.groupSelectionState == "all" ? this.props.onUnselectAll() : this.props.onSelectAll(),
            partial: this.props.groupSelectionState == "partial",
            checked: this.props.groupSelectionState == "all"
        }), (0, _react.jsx)("img", {
            src: this.props.icon
        })), (0, _react.jsx)("div", {
            className: "selection-details-container"
        }, (0, _react.jsx)("div", {
            className: "selection-header"
        }, (0, _react.jsx)("span", null, "Selected - "), (0, _react.jsx)("button", {
            type: "button",
            onClick: this.props.onClear
        }, "Unselect All")), (0, _react.jsx)("div", {
            className: "selection-description"
        }, (0, _react.jsx)("p", null, this.getSelectionLabel()))), (0, _react.jsx)("div", {
            className: "selection-operations-container"
        }, this.props.onPublish != null && (0, _react.jsx)((0, _conditionalTooltipWrapperDefault.default), {
            showTooltip: !this.props.isAppAdmin || this.props.partialPublishDisabled,
            place: "bottom",
            text: !this.props.isAppAdmin ? "Only App Admins can publish content" : "Please run a full publish of your <br /> app before starting any partial <br /> publishes to avoid errors"
        }, (0, _react.jsx)("div", null, (0, _react.jsx)((0, _buttonDefault.default), {
            disabled: this.props.partialPublishDisabled || !this.props.isAppAdmin,
            themes: [
                "secondary-small"
            ],
            className: "ac-publish-all",
            text: "Publish",
            onClick: this.props.onPublish,
            type: "button",
            rightIcon: publishIcon
        }))), (0, _react.jsx)((0, _buttonDefault.default), {
            disabled: this.props.isExporting,
            loading: this.props.isExporting,
            themes: [
                "white-small"
            ],
            text: "Export",
            onClick: this.props.onExport,
            icon: exportIcon
        }), (0, _react.jsx)((0, _buttonDefault.default), {
            disabled: this.props.isMoving,
            loading: this.props.isMoving,
            themes: [
                "white-small"
            ],
            text: "Move to...",
            onClick: this.props.onMove,
            icon: moveIcon
        }), (0, _react.jsx)((0, _buttonDefault.default), {
            disabled: this.props.isCopying,
            loading: this.props.isCopying,
            themes: [
                "white-small"
            ],
            text: "Copy to...",
            onClick: this.props.onCopy,
            icon: copyIcon
        }), (0, _react.jsx)((0, _buttonDefault.default), {
            disabled: this.props.isDeleting,
            loading: this.props.isDeleting,
            themes: [
                "white-small"
            ],
            text: "Delete",
            onClick: this.props.onDelete,
            icon: deleteIcon
        }))));
    }
}
const containerStyle = /*#__PURE__*/ (0, _css.css)("background:", (0, _colors.color_defaults_white), ";.tool-bar-container{display:flex;align-items:center;padding:0 24px;height:56px;border-bottom:1px solid ", (0, _colors.color_shades_dark), ";.group-select-container{display:flex;align-items:center;padding:0 12px 0 8px;margin-right:12px;border-right:1px solid ", (0, _colors.color_shades_dark), ";}.selection-details-container{.selection-header{display:flex;align-items:center;font-size:12px;line-height:16px;span{color:", (0, _colors.color_text_light), ";text-transform:uppercase;letter-spacing:0.1em;}button{color:", (0, _colors.color_text_link), ";border:none;background:none;cursor:pointer;}}.selection-description{font-weight:600;font-size:14px;line-height:20px;color:", (0, _colors.color_text_default), ";}}.selection-operations-container{display:flex;align-items:center;margin-right:0;margin-left:auto;}}", "");
exports.default = SelectionOptionsToolbar;

},{"@emotion/react":"djZKr","@emotion/css":"awUBr","react":"6uln9","../forms/CheckIndicator":"8zBm6","./Button":"6ymxN","../../constants/colors":"1p3OR","./ConditionalTooltipWrapper":"92m0T","7c032ca8f012a283":"95dRj","a88c6ab53d96e3c3":"1S0DP","acebb5502afff864":"bG6Op","37911f9e6230dc70":"l2zyx","4793cb509445f98d":"dL9sH","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"95dRj":[function(require,module,exports) {
module.exports = require("91512a1d86eae716").getBundleURL("kVLro") + require("70ec63e0f7ad6c60").resolve("b77NY");

},{"91512a1d86eae716":"c7Tr5","70ec63e0f7ad6c60":"fyJL2"}],"l2zyx":[function(require,module,exports) {
module.exports = require("2e5065535a2fd2e1").getBundleURL("kVLro") + require("7212f71bff3602c4").resolve("aAeGp");

},{"2e5065535a2fd2e1":"c7Tr5","7212f71bff3602c4":"fyJL2"}],"1BKac":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _base = require("@emotion/styled/base");
var _baseDefault = parcelHelpers.interopDefault(_base);
var _react = require("@emotion/react");
var _css = require("@emotion/css");
var _formik = require("formik");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _textField = require("../../../components/forms/TextField");
var _textFieldDefault = parcelHelpers.interopDefault(_textField);
var _button = require("../../../components/general/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _modalHeader = require("../../../components/general/ModalHeader");
var _modalHeaderDefault = parcelHelpers.interopDefault(_modalHeader);
var _pageError = require("../../../components/general/PageError");
var _pageErrorDefault = parcelHelpers.interopDefault(_pageError);
var _footerBar = require("../../../components/structure/FooterBar");
var _footerBarDefault = parcelHelpers.interopDefault(_footerBar);
var _smallModalLayout = require("../../../components/structure/SmallModalLayout");
var _smallModalLayoutDefault = parcelHelpers.interopDefault(_smallModalLayout);
var _colors = require("../../../constants/colors");
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const InnerForm = (props)=>{
    const handleKeyDown = (e)=>{
        e.stopPropagation();
        if (props.isSubmitting) return;
        if (e.key === "Enter") props.handleSubmit();
        if (e.key === "Escape") props.onClose();
    };
    return (0, _react.jsx)((0, _smallModalLayoutDefault.default), {
        isVisible: true,
        onClose: props.onClose,
        className: customModalInner
    }, (0, _react.jsx)(ModalForm, {
        tabIndex: 0,
        onKeyDown: handleKeyDown
    }, (0, _react.jsx)((0, _modalHeaderDefault.default), {
        title: "Full Publish",
        onClose: props.onClose
    }), (0, _react.jsx)("div", {
        className: "modal-body"
    }, (0, _react.jsx)(PublishConfirmationHeader, null, "Publish all Pending Updates?"), (0, _react.jsx)("p", null, "This will create a saved backup of all your content and push all changes to any channels where your app is currently deployed."), (0, _react.jsx)((0, _textFieldDefault.default), {
        autoFocus: true,
        name: "name",
        placeholder: "Enter name here",
        label: "Name",
        onBlur: props.handleBlur,
        onChange: props.handleChange,
        disabled: props.isSubmitting
    })), (0, _react.jsx)((0, _footerBarDefault.default), null, (0, _react.jsx)((0, _buttonDefault.default), {
        type: "button",
        themes: [
            "primary",
            "start"
        ],
        text: "Publish",
        onClick: ()=>props.handleSubmit(),
        disabled: props.isSubmitting,
        loading: props.isSubmitting
    }), (0, _react.jsx)((0, _buttonDefault.default), {
        type: "button",
        themes: [
            "secondary",
            "end"
        ],
        text: "Cancel",
        onClick: ()=>props.onClose(),
        disabled: props.isSubmitting,
        loading: props.isSubmitting
    })), (0, _react.jsx)((0, _pageErrorDefault.default), {
        errors: [
            ...props.backupsContainer?.state?.errors ?? [],
            ...props.environmentsContainer?.state?.errors ?? []
        ],
        onClear: ()=>{
            props.backupsContainer.clearErrors();
            props.environmentsContainer.clearErrors();
        }
    })));
};
const FullApplicationPublishModal = (0, _formik.withFormik)({
    mapPropsToValues: (props)=>({
            name: ""
        }),
    handleSubmit: async (values, { props, setSubmitting })=>{
        setSubmitting(true);
        const backupAndPublishResult = await props.environmentsContainer.queueFullBackupAndPublish(props.applicationId, props.primaryEnvironmentId, {
            name: values.name ?? "Published",
            description: ""
        });
        if (backupAndPublishResult?.resultType == "Ok") {
            await props.backupsContainer.addBackup(backupAndPublishResult.data.backup);
            await props.environmentsContainer.addPublish(backupAndPublishResult.data.publish);
            props.backupsContainer.waitForBackup(backupAndPublishResult.data.backup.id);
            props.environmentsContainer.waitForPublish(backupAndPublishResult.data.publish.id);
            setSubmitting(false);
            props.onClose();
            return;
        }
    }
})(InnerForm);
const PublishConfirmationHeader = /*#__PURE__*/ (0, _baseDefault.default)("h5", {
    target: "e7g42861"
})("font-family:Muli;font-style:normal;font-weight:normal;font-size:16px;line-height:24px;color:", (0, _colors.color_text_default), ";margin-top:24px;");
const customModalInner = /*#__PURE__*/ (0, _css.css)({
    name: "1mw49wb",
    styles: "height:416px;min-height:416px"
});
const ModalForm = /*#__PURE__*/ (0, _baseDefault.default)("form", {
    target: "e7g42860"
})({
    name: "daozzj",
    styles: "min-height:416px;height:416px;padding-bottom:64px;.modal-body{padding:0 32px;margin-bottom:180px;height:100%;flex:1;>h4{font-style:normal;font-weight:normal;font-size:18px;line-height:24px;}>p{font-style:normal;font-weight:normal;font-size:14px;line-height:20px;margin:0 0 24px 0;}}"
});
exports.default = FullApplicationPublishModal;

},{"@emotion/styled/base":"lSuFu","@emotion/react":"djZKr","@emotion/css":"awUBr","formik":"3YnOK","react":"6uln9","../../../components/forms/TextField":"7a7bh","../../../components/general/Button":"6ymxN","../../../components/general/ModalHeader":"aUACx","../../../components/general/PageError":"ezFTm","../../../components/structure/FooterBar":"bibRL","../../../components/structure/SmallModalLayout":"khwvt","../../../constants/colors":"1p3OR","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7LQaS":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _base = require("@emotion/styled/base");
var _baseDefault = parcelHelpers.interopDefault(_base);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _multiFileSelector = require("../forms/MultiFileSelector");
var _multiFileSelectorDefault = parcelHelpers.interopDefault(_multiFileSelector);
var _button = require("./Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _modalTitle = require("./ModalTitle");
var _modalTitleDefault = parcelHelpers.interopDefault(_modalTitle);
var _pageError = require("./PageError");
var _pageErrorDefault = parcelHelpers.interopDefault(_pageError);
var _footerBar = require("../structure/FooterBar");
var _footerBarDefault = parcelHelpers.interopDefault(_footerBar);
var _horizontalSeparator = require("../structure/HorizontalSeparator");
var _horizontalSeparatorDefault = parcelHelpers.interopDefault(_horizontalSeparator);
var _modalLayout = require("../structure/ModalLayout");
var _modalLayoutDefault = parcelHelpers.interopDefault(_modalLayout);
var _pageContainer = require("../structure/PageContainer");
var _pageContainerDefault = parcelHelpers.interopDefault(_pageContainer);
var _fullScreenLayout = require("../../scenes/fullScreenLayout");
var _fullScreenLayoutDefault = parcelHelpers.interopDefault(_fullScreenLayout);
var _colors = require("../../constants/colors");
var _stylesValues = require("../../constants/stylesValues");
var _breakpoints = require("../../constants/breakpoints");
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const closeIcon = require("c102b9a9622f35ea");
class ImportFileDialog extends (0, _reactDefault.default).Component {
    constructor(props){
        super(props);
        this.state = {
            file: null
        };
    }
    handleFilesSelected(files) {
        this.setState({
            ...this.state,
            file: files[0]
        });
    }
    handleSubmit(e) {
        e.preventDefault();
        if (this.state.file) this.props.completeImport(this.state.file);
    }
    render() {
        return (0, _react.jsx)(ImportFileDialogStyled, {
            isVisible: true,
            onClose: ()=>this.props.onClose()
        }, (0, _react.jsx)((0, _fullScreenLayoutDefault.default), null, (0, _react.jsx)((0, _pageContainerDefault.default), {
            fill: true
        }, (0, _react.jsx)(TitleWrapper, null, (0, _react.jsx)((0, _modalTitleDefault.default), null, this.props.title), (0, _react.jsx)(ButtonWrapper, null, (0, _react.jsx)((0, _buttonDefault.default), {
            themes: [
                "end-tight",
                "icon"
            ],
            icon: closeIcon,
            onClick: ()=>this.props.onClose()
        }))), (0, _react.jsx)((0, _horizontalSeparatorDefault.default), null), (0, _react.jsx)("form", {
            onSubmit: this.handleSubmit.bind(this)
        }, (0, _react.jsx)("div", {
            className: "fileSelector"
        }, (0, _react.jsx)((0, _multiFileSelectorDefault.default), {
            maxSizeOverrideMegabytes: this.props.maxSizeOverrideMegabytes,
            onSelected: this.handleFilesSelected.bind(this),
            accept: this.props.acceptFileTypes,
            uploadButtonText: "Select a local file",
            uploadLabel: "Drag a file here"
        }), (0, _react.jsx)("div", {
            className: "fileNameRow"
        }, (0, _react.jsx)("div", {
            className: "fileName"
        }, this.state.file?.name), (0, _react.jsx)("div", {
            className: "fileTypes"
        }, this.props.acceptFileTypesDisplayText))), (0, _react.jsx)(CustomFooter, {
            className: "import-footer"
        }, (0, _react.jsx)(SubmitButton, {
            className: "submitButton",
            type: "submit",
            themes: [
                "primary"
            ],
            text: "Import",
            disabled: this.props.isLoading || !this.state.file,
            loading: this.props.isLoading
        }), (0, _react.jsx)("div", {
            className: "selected-count"
        }), (0, _react.jsx)((0, _buttonDefault.default), {
            type: "button",
            themes: [
                "secondary"
            ],
            text: "Cancel",
            onClick: ()=>this.props.onClose(),
            disabled: this.props.isLoading,
            loading: this.props.isLoading
        }))), (0, _react.jsx)((0, _pageErrorDefault.default), {
            errors: this.props.errors
        }))));
    }
}
const ButtonWrapper = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1ky7v774"
})("border-left:", (0, _stylesValues.style_border_default), ";padding:0 0 0 32px;margin:8px 0;");
const TitleWrapper = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1ky7v773"
})({
    name: "dexxax",
    styles: "display:flex;flex-direction:row;align-items:center;padding:0 32px;justify-content:space-between"
});
const ImportFileDialogStyled = /*#__PURE__*/ (0, _baseDefault.default)((0, _modalLayoutDefault.default), {
    target: "e1ky7v772"
})("color:", (0, _colors.color_text_default), ";height:590px;width:750px;min-width:30%;min-height:30%;", (0, _breakpoints.breakpoint_small), "{height:calc(100vh - 100px);}.fileSelector{margin:32px;", (0, _breakpoints.breakpoint_small), "{margin:16px;}}.fileNameRow{margin:8px;margin-bottom:0px;display:flex;flex-direction:row;.fileTypes{font-style:italic;margin-left:auto;}.fileName{font-weight:bold;}}.selected-count{font-style:normal;font-weight:600;font-size:16px;line-height:24px;margin-right:auto;}");
const CustomFooter = /*#__PURE__*/ (0, _baseDefault.default)((0, _footerBarDefault.default), {
    target: "e1ky7v771"
})({
    name: "1q0eusf",
    styles: "z-index:auto"
});
const SubmitButton = /*#__PURE__*/ (0, _baseDefault.default)((0, _buttonDefault.default), {
    target: "e1ky7v770"
})({
    name: "1tx1l5v",
    styles: "margin-right:auto"
});
exports.default = ImportFileDialog;

},{"@emotion/styled/base":"lSuFu","@emotion/react":"djZKr","react":"6uln9","../forms/MultiFileSelector":"gLA6m","./Button":"6ymxN","./ModalTitle":"hIp2B","./PageError":"ezFTm","../structure/FooterBar":"bibRL","../structure/HorizontalSeparator":"Pw3HQ","../structure/ModalLayout":"b1cO3","../structure/PageContainer":"hc1r8","../../scenes/fullScreenLayout":"5mVdG","../../constants/colors":"1p3OR","../../constants/stylesValues":"dHVVv","../../constants/breakpoints":"2F01A","c102b9a9622f35ea":"93VwA","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"keV1x":[function(require,module,exports) {
module.exports = require("fd9a3ace95d6b5aa").getBundleURL("kVLro") + require("e4ab8147d915443c").resolve("F80ct");

},{"fd9a3ace95d6b5aa":"c7Tr5","e4ab8147d915443c":"fyJL2"}],"jrk16":[function(require,module,exports) {
module.exports = require("96c0b821e1574be0").getBundleURL("kVLro") + require("faed343cc2b9768a").resolve("jEqAq");

},{"96c0b821e1574be0":"c7Tr5","faed343cc2b9768a":"fyJL2"}],"9kz2b":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _base = require("@emotion/styled/base");
var _baseDefault = parcelHelpers.interopDefault(_base);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _unstated = require("unstated");
var _applicationStatisticsContainer = require("../../state/containers/ApplicationStatisticsContainer");
var _applicationStatisticsContainerDefault = parcelHelpers.interopDefault(_applicationStatisticsContainer);
var _tabContainerPanel = require("../../components/structure/Panels/TabContainerPanel");
var _tabContainerPanelDefault = parcelHelpers.interopDefault(_tabContainerPanel);
var _moment = require("moment");
var _momentDefault = parcelHelpers.interopDefault(_moment);
var _applicationMeasurementPage = require("./components/ApplicationMeasurementPage");
var _applicationMeasurementPageDefault = parcelHelpers.interopDefault(_applicationMeasurementPage);
var _applicationUserAnalyticsContainer = require("../../state/containers/ApplicationUserAnalyticsContainer");
var _applicationUserAnalyticsContainerDefault = parcelHelpers.interopDefault(_applicationUserAnalyticsContainer);
var _applicationInteractionAnalyticsContainer = require("../../state/containers/ApplicationInteractionAnalyticsContainer");
var _applicationInteractionAnalyticsContainerDefault = parcelHelpers.interopDefault(_applicationInteractionAnalyticsContainer);
var _css = require("@emotion/css");
var _dateRangeIntervalPicker = require("../../components/analytics/DateRangeIntervalPicker");
var _dateRangeIntervalPickerDefault = parcelHelpers.interopDefault(_dateRangeIntervalPicker);
var _timeIntervalSelectorHeader = require("../../components/analytics/TimeIntervalSelectorHeader");
var _timeIntervalSelectorHeaderDefault = parcelHelpers.interopDefault(_timeIntervalSelectorHeader);
var _colors = require("../../constants/colors");
var _scrollablePanelBody = require("../../components/structure/ScrollablePanelBody");
var _scrollablePanelBodyDefault = parcelHelpers.interopDefault(_scrollablePanelBody);
var _featureContainer = require("../../state/containers/FeatureContainer");
var _featureContainerDefault = parcelHelpers.interopDefault(_featureContainer);
var _applicationMissAnalyticsContainer = require("../../state/containers/ApplicationMissAnalyticsContainer");
var _applicationMissAnalyticsContainerDefault = parcelHelpers.interopDefault(_applicationMissAnalyticsContainer);
var _analyticsDateFormat = require("../../models/analytics/AnalyticsDateFormat");
var _filterToggleButton = require("../../components/analytics/filters/FilterToggleButton");
var _filterToggleButtonDefault = parcelHelpers.interopDefault(_filterToggleButton);
var _analyticsFilters = require("../../components/analytics/filters/AnalyticsFilters");
var _analyticsFiltersDefault = parcelHelpers.interopDefault(_analyticsFilters);
var _applicationTrackingContainer = require("../../state/containers/ApplicationTrackingContainer");
var _applicationTrackingContainerDefault = parcelHelpers.interopDefault(_applicationTrackingContainer);
var _queryString = require("query-string");
var _queryStringDefault = parcelHelpers.interopDefault(_queryString);
var _button = require("../../components/general/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _applicationEnvironmentsContainer = require("../../state/containers/ApplicationEnvironmentsContainer");
var _applicationEnvironmentsContainerDefault = parcelHelpers.interopDefault(_applicationEnvironmentsContainer);
var _applicationContainer = require("../../state/containers/ApplicationContainer");
var _applicationContainerDefault = parcelHelpers.interopDefault(_applicationContainer);
var _analyticsSettingsModal = require("../applicationAppliedTemplateManager/components/AnalyticsSettingsModal");
var _analyticsSettingsModalDefault = parcelHelpers.interopDefault(_analyticsSettingsModal);
var _ssmlContainer = require("../../state/containers/SsmlContainer");
var _ssmlContainerDefault = parcelHelpers.interopDefault(_ssmlContainer);
var _userApplicationPreferencesContainer = require("../../state/containers/UserApplicationPreferencesContainer");
var _userApplicationPreferencesContainerDefault = parcelHelpers.interopDefault(_userApplicationPreferencesContainer);
var _sparkContainer = require("../../hooks/SparkContainer");
var _sparkContainerDefault = parcelHelpers.interopDefault(_sparkContainer);
var _breakpoints = require("../../constants/breakpoints");
var _testCaseContainer = require("../../hooks/TestCaseContainer");
var _testCaseContainerDefault = parcelHelpers.interopDefault(_testCaseContainer);
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const settingsIcon = require("4dccfa2855112886");
const ApplicationAnalytics = (props)=>{
    const query = (0, _queryStringDefault.default).parse(window.location.search);
    const [interval, setInterval] = (0, _react1.useState)(query?.interval ?? "past month");
    const [startDate, setStartDate] = (0, _react1.useState)(query?.startDate ?? (0, _momentDefault.default)().startOf("day").subtract(28, "days").format((0, _analyticsDateFormat.DATE_FORMAT)));
    const [endDate, setEndDate] = (0, _react1.useState)(query?.endDate ?? (0, _momentDefault.default)().endOf("day").add(2, "days").format((0, _analyticsDateFormat.DATE_FORMAT)));
    const [isDatePickerExpanded, setIsDatePickerExpanded] = (0, _react1.useState)(false);
    const [isFilterExpanded, setIsFilterExpanded] = (0, _react1.useState)(false);
    const [filter, setFilter] = (0, _react1.useState)({});
    const [isSettingsOpen, setIsSettingsOpen] = (0, _react1.useState)(false);
    const sparkContainer = (0, _sparkContainerDefault.default).useContainer();
    const testCaseContainer = (0, _testCaseContainerDefault.default).useContainer();
    (0, _react1.useEffect)(()=>{
        testCaseContainer.setApplication(props.application);
    }, [
        props?.application?.id
    ]);
    (0, _react1.useEffect)(()=>{
        if (!props.application?.id?.length) return;
        props.facetContainer?.getDeviceTargets();
        props.facetContainer?.getAssistants(props.application?.id, startDate, endDate);
    }, [
        props.facetContainer,
        props.application,
        startDate,
        endDate
    ]);
    const handleTabSelection = (index, last)=>{
        if (index == last) return;
        const urlStart = `/v/apps/${props.application?.id}/analytics/`;
        if (index == 0) props.history.push(urlStart + window.location.search);
    };
    const getSelectedIndex = ()=>{
        return 0;
    };
    const handleDateRangeChange = (0, _react1.useCallback)((startDate, endDate, interval)=>{
        setStartDate(startDate);
        setEndDate(endDate);
        setInterval(interval);
        setIsDatePickerExpanded(false);
        setFilter({
            ...filter
        });
        props.facetContainer?.getAssistants(props.application?.id, startDate, endDate);
        props.history.push({
            search: `?startDate=${startDate}&endDate=${endDate}&interval=${interval}`
        });
    }, [
        props.facetContainer,
        props.history,
        props.application?.id
    ]);
    const toggleDatePicker = ()=>{
        setIsDatePickerExpanded(!isDatePickerExpanded);
    };
    const toggleFilter = ()=>{
        setIsFilterExpanded(!isFilterExpanded);
    };
    const toggleSettings = ()=>{
        setIsSettingsOpen(!isSettingsOpen);
    };
    const handleFilterChange = (filter)=>{
        setFilter({
            ...filter,
            assistants: filter.assistants ? [
                ...filter.assistants
            ] : [],
            interfaces: filter.interfaces ? [
                ...filter.interfaces
            ] : [],
            deviceTargetIds: filter.deviceTargetIds ? [
                ...filter.deviceTargetIds
            ] : [],
            languageIds: filter.languageIds ? [
                ...filter.languageIds
            ] : [],
            locales: filter.locales ? [
                ...filter.locales
            ] : []
        });
    };
    const getFilterCount = ()=>{
        let count = 0;
        if (filter?.assistants?.length > 0) count++;
        if (filter?.interfaces?.length > 0) count++;
        if (filter?.deviceTargetIds?.length > 0) count++;
        if (filter?.languageIds?.length > 0) count++;
        return count;
    };
    const currentFilter = props.facetContainer.convertFilter(startDate, endDate, filter, props.facetContainer.state.deviceTargets ?? []);
    const analyticsPanelBodyStyle = /*#__PURE__*/ (0, _css.css)({
        name: "yd065o",
        styles: "height:calc(100vh - 125px);.scrollable-panel>div{height:100%;}"
    });
    return (0, _react.jsx)((0, _unstated.Subscribe), {
        to: [
            (0, _applicationUserAnalyticsContainerDefault.default),
            (0, _applicationInteractionAnalyticsContainerDefault.default),
            (0, _applicationStatisticsContainerDefault.default),
            (0, _applicationMissAnalyticsContainerDefault.default),
            (0, _applicationTrackingContainerDefault.default),
            (0, _applicationContainerDefault.default),
            (0, _applicationEnvironmentsContainerDefault.default),
            (0, _featureContainerDefault.default),
            (0, _ssmlContainerDefault.default),
            (0, _userApplicationPreferencesContainerDefault.default)
        ]
    }, (userAnalyticsContainer, interactionAnalyticsContainer, statisticsContainer, missContainer, trackingContainer, applicationContainer, environmentContainer, featureContainer, ssmlContainer, userAppPrefContainer)=>{
        return (0, _react.jsx)((0, _reactDefault.default).Fragment, null, (0, _react.jsx)((0, _tabContainerPanelDefault.default), {
            className: containerStyle,
            tabs: [],
            selectedIndex: getSelectedIndex(),
            onTabSelected: handleTabSelection,
            additionalHeaderContent: ()=>(0, _react.jsx)("div", {
                    className: headerContainer
                }, (0, _react.jsx)((0, _timeIntervalSelectorHeaderDefault.default), {
                    startDate: startDate,
                    endDate: endDate,
                    isExpanded: isDatePickerExpanded,
                    onClick: toggleDatePicker
                }), !sparkContainer.inSpark && (0, _react.jsx)((0, _reactDefault.default).Fragment, null, (0, _react.jsx)((0, _filterToggleButtonDefault.default), {
                    filterCount: getFilterCount(),
                    isExpanded: isFilterExpanded,
                    onClick: toggleFilter
                }), (0, _react.jsx)((0, _buttonDefault.default), {
                    themes: [
                        "white-small"
                    ],
                    text: "Settings",
                    onClick: ()=>toggleSettings(),
                    rightComponent: ()=>(0, _react.jsx)(ButtonRightImage, null, (0, _react.jsx)("img", {
                            src: settingsIcon
                        }))
                })))
        }, (0, _react.jsx)((0, _scrollablePanelBodyDefault.default), {
            autoHeight: true,
            autoHeightMax: "calc(100vh - 125px)",
            className: analyticsPanelBodyStyle
        }, isFilterExpanded && (0, _react.jsx)((0, _analyticsFiltersDefault.default), {
            currentFilter: currentFilter,
            filterCount: getFilterCount(),
            onChange: handleFilterChange,
            languages: props.application?.languages ?? [],
            deviceTargets: props.facetContainer.state.deviceTargets ?? [],
            assistants: props.facetContainer.state.assistants ?? [],
            interfaces: props.facetContainer.state.interfaces ?? []
        }), isDatePickerExpanded && (0, _react.jsx)((0, _dateRangeIntervalPickerDefault.default), {
            startDate: startDate,
            endDate: endDate,
            interval: interval,
            onChange: handleDateRangeChange,
            onClose: ()=>setIsDatePickerExpanded(false)
        }), (0, _react.jsx)((0, _applicationMeasurementPageDefault.default), {
            application: props.application,
            ssmlContainer: ssmlContainer,
            userApplicationPreferencesContainer: userAppPrefContainer,
            interval: interval,
            userAnalyticsContainer: userAnalyticsContainer,
            interactionAnalyticsContainer: interactionAnalyticsContainer,
            missAnalyticsContainer: missContainer,
            statisticsContainer: statisticsContainer,
            featureContainer: featureContainer,
            envContainer: environmentContainer,
            applicationId: props.application?.id,
            filter: currentFilter,
            history: props.history,
            appsContainer: applicationContainer,
            trackingContainer: trackingContainer
        }))), isSettingsOpen && (0, _react.jsx)((0, _analyticsSettingsModalDefault.default), {
            applicationContainer: applicationContainer,
            envContainer: environmentContainer,
            appId: props.application.id,
            onClose: ()=>toggleSettings()
        }));
    });
};
const containerStyle = /*#__PURE__*/ (0, _css.css)(".panel-tab-list{flex:0;}", (0, _breakpoints.breakpoint_small), "{.panel-tab-list{display:none;}.time-label{display:none;}.time-selection{border-left:none;font-size:16px;}}", "");
const headerContainer = /*#__PURE__*/ (0, _css.css)("display:flex;justify-content:space-between;flex:1;height:100%;margin-right:32px;align-items:center;border-left:1px solid ", (0, _colors.color_shades_dark), ";", (0, _breakpoints.breakpoint_small), "{margin-left:0;margin-right:0;border-left:none;justify-content:center;gap:16px;flex-wrap:wrap;min-height:60px;overflow:hidden;}", "");
const ButtonRightImage = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e161r9ww0"
})({
    name: "a99ovq",
    styles: "margin-left:8px;width:20px;img{width:16px;height:16px;}"
});
exports.default = ApplicationAnalytics;

},{"@emotion/styled/base":"lSuFu","@emotion/react":"djZKr","react":"6uln9","unstated":"grh7p","../../state/containers/ApplicationStatisticsContainer":"8kWHE","../../components/structure/Panels/TabContainerPanel":"iDHIJ","moment":"2meyw","./components/ApplicationMeasurementPage":"ahatr","../../state/containers/ApplicationUserAnalyticsContainer":"g1mCv","../../state/containers/ApplicationInteractionAnalyticsContainer":"d0mPh","@emotion/css":"awUBr","../../components/analytics/DateRangeIntervalPicker":"2sClv","../../components/analytics/TimeIntervalSelectorHeader":"9ttp0","../../constants/colors":"1p3OR","../../components/structure/ScrollablePanelBody":"6LRg3","../../state/containers/FeatureContainer":"4ApGg","../../state/containers/ApplicationMissAnalyticsContainer":"gD5Gx","../../models/analytics/AnalyticsDateFormat":"ia5MW","../../components/analytics/filters/FilterToggleButton":"7cwN5","../../components/analytics/filters/AnalyticsFilters":"cKU0F","../../state/containers/ApplicationTrackingContainer":"4zokI","query-string":"klvAV","../../components/general/Button":"6ymxN","../../state/containers/ApplicationEnvironmentsContainer":"jCULY","../../state/containers/ApplicationContainer":"cuqi2","../applicationAppliedTemplateManager/components/AnalyticsSettingsModal":"1t7fR","../../state/containers/SsmlContainer":"bwJDI","../../state/containers/UserApplicationPreferencesContainer":"2fhAM","../../hooks/SparkContainer":"jzXzx","../../constants/breakpoints":"2F01A","../../hooks/TestCaseContainer":"cLg3U","4dccfa2855112886":"3rYoU","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8kWHE":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _defineProperty = require("@babel/runtime/helpers/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _api = require("../../api");
var _genericAnalyticsContainer = require("./GenericAnalyticsContainer");
var _genericAnalyticsContainerDefault = parcelHelpers.interopDefault(_genericAnalyticsContainer);
class ApplicationStatisticsContainer extends (0, _genericAnalyticsContainerDefault.default) {
    constructor(){
        super();
        (0, _definePropertyDefault.default)(this, "sparkDisplayOptions", [
            "Topic Hits",
            "Topic Misses",
            "AI Ordering",
            "AI Ordering Export"
        ]);
        (0, _definePropertyDefault.default)(this, "displayOptions", [
            "Content Hits",
            "Content Misses",
            "AI Ordering",
            "AI Ordering Export"
        ]);
        this.state = {
            appStats: [],
            appMissStats: [],
            appTopHits: [],
            appTopMisses: [],
            aggregatedFeatureTypeInteractions: [],
            previousAggregatedFeatureTypeInteractions: [],
            isLoading: false,
            isLoadingTotals: false,
            currentDisplayOption: this.displayOptions[0],
            sparkDisplayOption: this.sparkDisplayOptions[0],
            currentDeltaPeriod: "Previous Period",
            currentDeltaType: "Value",
            errors: []
        };
    }
    async loadContentHitsByFeatureTypeCounts(applicationId, filter) {
        this.setLoading(true);
        try {
            const result = await _api.getAggregatedInteractionsByFeatureType(applicationId, filter);
            if (result.resultType == "Ok") {
                this.setState({
                    ...this.state,
                    isLoading: false,
                    errors: [],
                    aggregatedFeatureTypeInteractions: result.data
                });
                return result.data;
            } else {
                this.setLoading(false);
                return result.errors;
            }
        } catch (error) {
            this.setLoading(false);
            return error;
        }
    }
    async loadPreviousContentHitsByFeatureTypeCounts(applicationId, filter) {
        this.setLoading(true);
        try {
            const result = await _api.getAggregatedInteractionsByFeatureType(applicationId, filter);
            if (result.resultType == "Ok") {
                this.setState({
                    ...this.state,
                    isLoading: false,
                    errors: [],
                    previousAggregatedFeatureTypeInteractions: result.data
                });
                return result.data;
            } else {
                this.setLoading(false);
                return result.errors;
            }
        } catch (error) {
            this.setLoading(false);
            return error;
        }
    }
    loadTopContentMissesForApp(applicationId, filter) {
        this.setLoading(true);
        const existingStats = this.state.appTopMisses.find((r)=>this.buildCacheKey(r.applicationId, r.filter) == this.buildCacheKey(applicationId, filter));
        if (existingStats !== undefined && existingStats !== null) {
            this.setLoading(false);
            return new Promise((resolve)=>resolve({
                    resultType: "Ok",
                    errors: null,
                    data: {
                        applicationId: existingStats.applicationId,
                        items: existingStats.items,
                        filter
                    }
                }));
        }
        const promise = _api.getApplicationTopContentMisses(applicationId, filter);
        promise.then((result)=>{
            if (result.resultType == "Ok") {
                var stats = this.state.appTopMisses;
                stats.push({
                    applicationId: applicationId,
                    items: result.data.items,
                    filter
                });
                this.setState({
                    ...this.state,
                    isLoading: false,
                    errors: [],
                    appTopMisses: stats
                });
            } else this.setLoading(false);
        }).catch(()=>{
            this.setLoading(false);
        });
        return promise;
    }
    loadTopContentHitsForApp(applicationId, filter) {
        this.setLoading(true);
        const existingStats = this.state.appTopHits.find((r)=>this.buildCacheKey(r.applicationId, r.filter) == this.buildCacheKey(applicationId, filter));
        if (existingStats !== undefined && existingStats !== null) {
            this.setLoading(false);
            return new Promise((resolve)=>resolve({
                    resultType: "Ok",
                    errors: null,
                    data: {
                        applicationId: existingStats.applicationId,
                        items: existingStats.items,
                        filter
                    }
                }));
        }
        const promise = _api.getApplicationTopContentHits(applicationId, filter);
        promise.then((result)=>{
            if (result.resultType == "Ok") {
                var stats = this.state.appTopHits;
                stats.push({
                    applicationId: applicationId,
                    items: result.data.items,
                    filter
                });
                this.setState({
                    ...this.state,
                    isLoading: false,
                    errors: [],
                    appTopHits: stats
                });
            } else this.setLoading(false);
        }).catch(()=>{
            this.setLoading(false);
        });
        return promise;
    }
    async loadStats(contextId, filter) {
        await this.setLoading(true);
        const previousPeriod = this.getPreviousDates(filter.startDate, filter.endDate);
        const existingStats = this.state.appStats?.find((r)=>this.buildCacheKey(r.id, r.filter) == this.buildCacheKey(contextId, filter));
        const existingPrevious = this.state.appStats?.find((r)=>this.buildCacheKey(r.id, r.filter) == this.buildCacheKey(contextId, {
                ...filter,
                startDate: previousPeriod.startDate,
                endDate: previousPeriod.endDate
            }));
        if (!existingPrevious) await this.reloadStats(contextId, {
            ...filter,
            startDate: previousPeriod.startDate,
            endDate: previousPeriod.endDate
        });
        if (existingStats) {
            this.setLoading(false);
            return new Promise((resolve)=>resolve({
                    resultType: "Ok",
                    errors: null,
                    data: existingStats.data
                }));
        }
        // load primary and previous period at the same time
        var primaryPromise = this.reloadStats(contextId, filter);
        return primaryPromise;
    }
    reloadStats(applicationId, filter) {
        this.setLoadingTotals(true);
        const existingStats = this.state.appStats.find((r)=>this.buildCacheKey(r.id, r.filter) == this.buildCacheKey(applicationId, filter));
        if (existingStats !== undefined && existingStats !== null) {
            this.setLoadingTotals(false);
            return new Promise((resolve)=>resolve({
                    resultType: "Ok",
                    errors: null,
                    data: existingStats.data
                }));
        }
        const promise = _api.getApplicationStats(applicationId, filter);
        promise.then((result)=>{
            if (result.resultType == "Ok") {
                var usage = this.state.appStats;
                usage.push({
                    id: applicationId,
                    filter,
                    data: result.data
                });
                this.setState({
                    ...this.state,
                    isLoadingTotals: false,
                    errors: [],
                    appStats: usage
                });
            } else this.setLoadingTotals(false);
        }).catch(()=>{
            this.setLoadingTotals(false);
        });
        return promise;
    }
    async loadMissStats(applicationId, filter) {
        await this.setLoading(true);
        const previousPeriod = this.getPreviousDates(filter.startDate, filter.endDate);
        const existingStats = this.state.appMissStats?.find((r)=>this.buildCacheKey(r.id, r.filter) == this.buildCacheKey(applicationId, filter));
        const existingPrevious = this.state.appMissStats?.find((r)=>this.buildCacheKey(r.id, r.filter) == this.buildCacheKey(applicationId, {
                ...filter,
                startDate: previousPeriod.startDate,
                endDate: previousPeriod.endDate
            }));
        if (!existingPrevious) await this.reloadMissStats(applicationId, {
            ...filter,
            startDate: previousPeriod.startDate,
            endDate: previousPeriod.endDate
        });
        if (existingStats) {
            this.setLoading(false);
            return new Promise((resolve)=>resolve({
                    resultType: "Ok",
                    errors: null,
                    data: existingStats.data
                }));
        }
        // load primary and previous period at the same time
        var primaryPromise = this.reloadMissStats(applicationId, filter);
        return primaryPromise;
    }
    async reloadMissStats(applicationId, filter) {
        this.setLoadingTotals(true);
        const existingStats = this.state.appMissStats.find((r)=>this.buildCacheKey(r.id, r.filter) == this.buildCacheKey(applicationId, filter));
        if (existingStats !== undefined && existingStats !== null) {
            this.setLoadingTotals(false);
            return new Promise((resolve)=>resolve({
                    resultType: "Ok",
                    errors: null,
                    data: existingStats.data
                }));
        }
        const promise = _api.getApplicationMissStats(applicationId, filter);
        promise.then((result)=>{
            if (result.resultType == "Ok") {
                var usage = this.state.appMissStats;
                usage.push({
                    id: applicationId,
                    filter,
                    data: result.data
                });
                this.setState({
                    ...this.state,
                    isLoadingTotals: false,
                    errors: [],
                    appMissStats: usage
                });
            } else this.setLoadingTotals(false);
        }).catch(()=>{
            this.setLoadingTotals(false);
        });
        return promise;
    }
    setLoadingTotals(isLoading) {
        this.setState({
            ...this.state,
            isLoadingTotals: isLoading
        });
    }
}
exports.default = ApplicationStatisticsContainer;

},{"@babel/runtime/helpers/defineProperty":"9sJxO","../../api":"loxM6","./GenericAnalyticsContainer":"3eKoF","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"ahatr":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _moment = require("moment");
var _momentDefault = parcelHelpers.interopDefault(_moment);
var _reactTabs = require("react-tabs");
var _tabbedLayout = require("../../../components/structure/TabbedLayout");
var _tabbedLayoutDefault = parcelHelpers.interopDefault(_tabbedLayout);
var _applicationUserCharts = require("./ApplicationUserCharts");
var _applicationUserChartsDefault = parcelHelpers.interopDefault(_applicationUserCharts);
var _applicationInteractionsCharts = require("./ApplicationInteractionsCharts");
var _applicationInteractionsChartsDefault = parcelHelpers.interopDefault(_applicationInteractionsCharts);
var _applicationStatistics = require("./ApplicationStatistics");
var _applicationStatisticsDefault = parcelHelpers.interopDefault(_applicationStatistics);
var _applicationMissCharts = require("./ApplicationMissCharts");
var _applicationMissChartsDefault = parcelHelpers.interopDefault(_applicationMissCharts);
var _analyticsDateFormat = require("../../../models/analytics/AnalyticsDateFormat");
var _sessionAnalyticsWrapper = require("./SessionAnalyticsWrapper");
var _sessionAnalyticsWrapperDefault = parcelHelpers.interopDefault(_sessionAnalyticsWrapper);
var _applicationLiveSessions = require("./ApplicationLiveSessions");
var _applicationLiveSessionsDefault = parcelHelpers.interopDefault(_applicationLiveSessions);
var _sparkContainer = require("../../../hooks/SparkContainer");
var _sparkContainerDefault = parcelHelpers.interopDefault(_sparkContainer);
var _loader = require("../../../components/general/Loader");
var _loaderDefault = parcelHelpers.interopDefault(_loader);
var _applicationTrackingPage = require("./ApplicationTrackingPage");
var _applicationTrackingPageDefault = parcelHelpers.interopDefault(_applicationTrackingPage);
var _featureFlagIds = require("../../../constants/featureFlagIds");
var _reviewUserManagement = require("./ReviewUserManagement");
var _reviewUserManagementDefault = parcelHelpers.interopDefault(_reviewUserManagement);
const ApplicationMeasurementPage = (props)=>{
    const sparkContainer = (0, _sparkContainerDefault.default).useContainer();
    const enableDetailedAnalytics = async ()=>{
        const envs = await props.envContainer.loadEnvironments(props.applicationId, true);
        if (envs.data) {
            if (!envs.data[0]?.detailedAnalyticsEnabled) await props.appsContainer.updateDetailedAnalytics(props.applicationId, true);
        }
    };
    (0, _react1.useEffect)(()=>{
        if (sparkContainer.inSpark) enableDetailedAnalytics();
    }, [
        props.applicationId
    ]);
    const handleTabSelection = (index, last)=>{
        if (index == last) return;
        const urlStart = `/v/apps/${props.applicationId}/analytics/`;
        if (sparkContainer.inSpark) {
            if (index == 0) props.history.push(urlStart + "topic-hits" + window.location.search);
            if (index == 1) props.history.push(urlStart + "sessions" + window.location.search);
            if (index == 2) props.history.push(urlStart + "topic-misses" + window.location.search);
            if (index == 3) props.history.push(urlStart + "track" + window.location.search);
            if (index == 4) props.history.push(urlStart + "review-link" + window.location.search);
        } else {
            if (index == 0) props.history.push(urlStart + "activity" + window.location.search);
            if (index == 1) props.history.push(urlStart + "users" + window.location.search);
            if (index == 2) props.history.push(urlStart + "sessions" + window.location.search);
            if (index == 3) props.history.push(urlStart + "misses" + window.location.search);
            if (index == 4) props.history.push(urlStart + "report" + window.location.search);
            if (index == 5) props.history.push(urlStart + "live");
            if (index == 6) props.history.push(urlStart + "track" + window.location.search);
        }
    };
    const sparkTabs = [
        "Overview",
        "Transcripts",
        "Topic Misses",
        "Track"
    ];
    if (props.application?.featureFlags?.some((f)=>f.id === (0, _featureFlagIds.FoodOrderingFeatureFlagId))) sparkTabs.push("Review Link");
    const getSelectedIndex = ()=>{
        if (sparkContainer.inSpark) {
            if (location.href.indexOf("topic-hits") > -1) return 0;
            if (location.href.indexOf("sessions") > -1) return 1;
            if (location.href.indexOf("topic-misses") > -1) return 2;
            if (location.href.indexOf("track") > -1) return 3;
            if (location.href.indexOf("review-link") > -1 && props.application?.featureFlags?.some((f)=>f.id === (0, _featureFlagIds.FoodOrderingFeatureFlagId))) return 4;
        } else {
            if (location.href.indexOf("users") > -1) return 1;
            if (location.href.indexOf("sessions") > -1) return 2;
            if (location.href.indexOf("misses") > -1) return 3;
            if (location.href.indexOf("report") > -1) return 4;
            if (location.href.indexOf("live") > -1) return 5;
            if (location.href.indexOf("track") > -1) return 6;
            return 0;
        }
    };
    const getInnerInterval = (startDate, endDate)=>{
        // rule of 3s.
        // if we are under 3 days, use hours **NOTE: now using days and hours if more then 1 day because Nivo groups the same x axis values together and renders them as 1
        // if we are under 3 months, use days
        // if we are under 3 years, use months
        // use years
        // get hours between dates
        const hoursBetween = (0, _momentDefault.default)(endDate, (0, _analyticsDateFormat.DATE_FORMAT)).diff((0, _momentDefault.default)(startDate, (0, _analyticsDateFormat.DATE_FORMAT)), "hours");
        if (hoursBetween <= 24) return "hour";
        if (hoursBetween <= 48) return "dayAndHour";
        if (hoursBetween <= 2160) return "day";
        if (hoursBetween <= 26280) return "month";
        return "year";
    };
    const innerInterval = getInnerInterval(props.filter.startDate, props.filter.endDate);
    const renderSparkTabs = ()=>{
        return (0, _react.jsx)((0, _reactDefault.default).Fragment, null, (0, _react.jsx)((0, _reactTabs.TabPanel), null, (0, _react.jsx)((0, _applicationStatisticsDefault.default), {
            showTopicHits: true,
            application: props.application,
            filter: props.filter,
            interval: props.interval,
            innerInterval: innerInterval,
            featureContainer: props.featureContainer,
            stateContainer: props.statisticsContainer,
            applicationId: props.applicationId,
            ssmlContainer: props.ssmlContainer,
            envContainer: props.envContainer,
            history: props.history,
            userApplicationPreferencesContainer: props.userApplicationPreferencesContainer,
            statisticsContainer: props.statisticsContainer
        })), (0, _react.jsx)((0, _reactTabs.TabPanel), null, (0, _react.jsx)((0, _sessionAnalyticsWrapperDefault.default), {
            filter: props.filter,
            interval: props.interval,
            innerInterval: innerInterval,
            ssmlContainer: props.ssmlContainer,
            envContainer: props.envContainer,
            history: props.history,
            userApplicationPreferencesContainer: props.userApplicationPreferencesContainer,
            applicationId: props.applicationId,
            application: props.application
        })), (0, _react.jsx)((0, _reactTabs.TabPanel), null, (0, _react.jsx)((0, _applicationStatisticsDefault.default), {
            showTopicMisses: true,
            application: props.application,
            filter: props.filter,
            interval: props.interval,
            innerInterval: innerInterval,
            featureContainer: props.featureContainer,
            stateContainer: props.statisticsContainer,
            applicationId: props.applicationId,
            ssmlContainer: props.ssmlContainer,
            envContainer: props.envContainer,
            history: props.history,
            userApplicationPreferencesContainer: props.userApplicationPreferencesContainer,
            statisticsContainer: props.statisticsContainer
        })), (0, _react.jsx)((0, _reactTabs.TabPanel), null, (0, _react.jsx)((0, _applicationTrackingPageDefault.default), {
            trackingContainer: props.trackingContainer,
            applicationId: props.application?.id,
            filter: props.filter,
            history: props.history,
            isSpark: sparkContainer.inSpark
        })), props.application?.featureFlags?.some((f)=>f.id === (0, _featureFlagIds.FoodOrderingFeatureFlagId)) ? (0, _react.jsx)((0, _reactTabs.TabPanel), null, (0, _react.jsx)((0, _reviewUserManagementDefault.default), {
            appId: props.application?.id
        })) : (0, _react.jsx)((0, _reactDefault.default).Fragment, null));
    };
    const renderVoicifyTabs = ()=>{
        return (0, _react.jsx)((0, _reactDefault.default).Fragment, null, (0, _react.jsx)((0, _reactTabs.TabPanel), null, (0, _react.jsx)((0, _applicationInteractionsChartsDefault.default), {
            filter: props.filter,
            interval: props.interval,
            innerInterval: innerInterval,
            stateContainer: props.interactionAnalyticsContainer,
            applicationId: props.applicationId
        })), (0, _react.jsx)((0, _reactTabs.TabPanel), null, (0, _react.jsx)((0, _applicationUserChartsDefault.default), {
            filter: props.filter,
            interval: props.interval,
            innerInterval: innerInterval,
            stateContainer: props.userAnalyticsContainer,
            applicationId: props.applicationId
        })), (0, _react.jsx)((0, _reactTabs.TabPanel), null, (0, _react.jsx)((0, _sessionAnalyticsWrapperDefault.default), {
            filter: props.filter,
            interval: props.interval,
            innerInterval: innerInterval,
            ssmlContainer: props.ssmlContainer,
            envContainer: props.envContainer,
            history: props.history,
            userApplicationPreferencesContainer: props.userApplicationPreferencesContainer,
            applicationId: props.applicationId,
            application: props.application
        })), (0, _react.jsx)((0, _reactTabs.TabPanel), null, (0, _react.jsx)((0, _applicationMissChartsDefault.default), {
            filter: props.filter,
            interval: props.interval,
            innerInterval: innerInterval,
            stateContainer: props.missAnalyticsContainer,
            applicationId: props.applicationId
        })), (0, _react.jsx)((0, _reactTabs.TabPanel), null, (0, _react.jsx)((0, _applicationStatisticsDefault.default), {
            application: props.application,
            filter: props.filter,
            interval: props.interval,
            innerInterval: innerInterval,
            featureContainer: props.featureContainer,
            stateContainer: props.statisticsContainer,
            applicationId: props.applicationId,
            ssmlContainer: props.ssmlContainer,
            envContainer: props.envContainer,
            history: props.history,
            userApplicationPreferencesContainer: props.userApplicationPreferencesContainer,
            statisticsContainer: props.statisticsContainer
        })), (0, _react.jsx)((0, _reactTabs.TabPanel), null, (0, _react.jsx)((0, _applicationLiveSessionsDefault.default), {
            history: props.history,
            applicationId: props.applicationId,
            application: props.application
        })), (0, _react.jsx)((0, _reactTabs.TabPanel), null, (0, _react.jsx)((0, _applicationTrackingPageDefault.default), {
            trackingContainer: props.trackingContainer,
            applicationId: props.application?.id,
            filter: props.filter,
            history: props.history,
            isSpark: sparkContainer.inSpark
        })));
    };
    if (!props.application?.id?.length || !props.applicationId?.length) return (0, _react.jsx)((0, _loaderDefault.default), null);
    return (0, _react.jsx)((0, _tabbedLayoutDefault.default), {
        tabs: sparkContainer.inSpark ? sparkTabs : [
            "Activity",
            "Users",
            "Sessions",
            "Misses",
            "Report",
            "Live",
            "Track"
        ],
        top: true,
        selectedIndex: getSelectedIndex(),
        onTabSelected: handleTabSelection
    }, sparkContainer.inSpark ? renderSparkTabs() : renderVoicifyTabs());
};
exports.default = ApplicationMeasurementPage;

},{"@emotion/react":"djZKr","react":"6uln9","moment":"2meyw","react-tabs":"92Sgf","../../../components/structure/TabbedLayout":"Hb6hy","./ApplicationUserCharts":"7quLA","./ApplicationInteractionsCharts":"bNDRQ","./ApplicationStatistics":"8iRAR","./ApplicationMissCharts":"eJbGz","../../../models/analytics/AnalyticsDateFormat":"ia5MW","./SessionAnalyticsWrapper":"lbSlB","./ApplicationLiveSessions":"lYgo6","../../../hooks/SparkContainer":"jzXzx","../../../components/general/Loader":"bnV5T","./ApplicationTrackingPage":"iuHaP","../../../constants/featureFlagIds":"33vuW","./ReviewUserManagement":"3D0cv","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7quLA":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _applicationAnalyticsCharts = require("./ApplicationAnalyticsCharts");
var _applicationAnalyticsChartsDefault = parcelHelpers.interopDefault(_applicationAnalyticsCharts);
const ApplicationUserCharts = (props)=>{
    (0, _react1.useEffect)(()=>{
        loadChartData();
    }, [
        props.interval,
        props.filter
    ]);
    const [loading, setLoading] = (0, _react1.useState)(false);
    const loadChartData = async ()=>{
        if (loading) return;
        await setLoading(true);
        props.stateContainer.loadPrimaryBreakdown({
            applicationId: props.applicationId
        }, props.filter, props.stateContainer.state.currentBreakdown);
        props.stateContainer.loadSecondaryBreakdown({
            applicationId: props.applicationId
        }, props.filter, props.stateContainer.state.currentBreakdown);
        await props.stateContainer.loadPrimaryHistogram({
            applicationId: props.applicationId
        }, props.innerInterval, props.filter);
        await props.stateContainer.loadSecondaryHistogram({
            applicationId: props.applicationId
        }, props.innerInterval, props.filter);
        await props.stateContainer.getAverages({
            applicationId: props.applicationId
        }, props.filter);
        await setLoading(false);
    };
    return (0, _react.jsx)((0, _applicationAnalyticsChartsDefault.default), {
        applicationId: props.applicationId,
        filter: props.filter,
        innerInterval: props.innerInterval,
        interval: props.interval,
        dataType: "Users",
        stateContainer: props.stateContainer,
        showPrimary: props.stateContainer.state.currentDisplayOption?.toLocaleLowerCase()?.indexOf("total") > -1,
        showSecondary: props.stateContainer.state.currentDisplayOption?.toLowerCase()?.indexOf("new") > -1,
        secondaryDataName: "New Users",
        primaryDataName: "Total Users"
    });
};
exports.default = ApplicationUserCharts;

},{"@emotion/react":"djZKr","react":"6uln9","./ApplicationAnalyticsCharts":"2fJkY","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2fJkY":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _defineProperty = require("@babel/runtime/helpers/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _moment = require("moment");
var _momentDefault = parcelHelpers.interopDefault(_moment);
var _colors = require("../../../constants/colors");
var _histogramChartCard = require("../../../components/charts/HistogramChartCard");
var _histogramChartCardDefault = parcelHelpers.interopDefault(_histogramChartCard);
var _analyticsSelectField = require("../../../components/analytics/AnalyticsSelectField");
var _analyticsSelectFieldDefault = parcelHelpers.interopDefault(_analyticsSelectField);
var _breakdownChartCard = require("../../../components/charts/BreakdownChartCard");
var _breakdownChartCardDefault = parcelHelpers.interopDefault(_breakdownChartCard);
var _averagesCard = require("../../../components/charts/AveragesCard");
var _averagesCardDefault = parcelHelpers.interopDefault(_averagesCard);
var _analyticsDateFormat = require("../../../models/analytics/AnalyticsDateFormat");
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
class ApplicationAnalyticsCharts extends (0, _reactDefault.default).Component {
    constructor(...args){
        super(...args);
        (0, _definePropertyDefault.default)(this, "today", (0, _momentDefault.default)());
    }
    componentDidMount() {
        this.props.stateContainer.loadFeatureTypes();
        this.props.stateContainer.loadDeviceTypes();
    }
    async handleBreakdownChange(option) {
        await this.props.stateContainer.handleBreakdownChange(option);
        await this.props.stateContainer.loadPrimaryBreakdown({
            applicationId: this.props.applicationId
        }, this.props.filter, option);
        await this.props.stateContainer.loadSecondaryBreakdown({
            applicationId: this.props.applicationId
        }, this.props.filter, option);
    }
    async handleDeltaPeriodChange(option) {
        await this.props.stateContainer.handleDeltaPeriodChange(option);
        await this.props.stateContainer.loadPrimaryHistogram({
            applicationId: this.props.applicationId
        }, this.props.innerInterval, this.props.filter);
        await this.props.stateContainer.loadSecondaryHistogram({
            applicationId: this.props.applicationId
        }, this.props.innerInterval, this.props.filter);
        await this.props.stateContainer.getAverages({
            applicationId: this.props.applicationId
        }, this.props.filter);
    }
    getInnerDateString(momentDate) {
        switch(this.props.innerInterval){
            case "year":
                return momentDate.format("YYYY");
            case "month":
                return momentDate.format("MMMM YYYY");
            case "day":
                return momentDate.format("MMMM DD, YYYY");
            case "dayAndHour":
                return momentDate.format("DD hh:mm a");
            //more then a day but less than 2 days, need to supply Day and Hour
            case "hour":
                return momentDate.format("hh:mm a");
        }
    }
    render() {
        const prevDates = this.props.stateContainer.getPreviousDates(this.props.filter.startDate, this.props.filter.endDate);
        const histogramData = this.props.stateContainer.state.primaryHistogramData?.find((h)=>this.props.stateContainer.buildHistogramKey(h) == this.props.stateContainer.buildCacheKey(this.props.applicationId, this.props.filter))?.data?.map((d)=>{
            const momentDate = (0, _momentDefault.default)(d.date);
            return {
                color: (0, _colors.ocean_blue),
                x: this.props.stateContainer.getHistogramDateLabel(this.props.innerInterval, momentDate),
                y: this.today.diff(momentDate) > 0 ? d.count : null,
                // null will add gaps - so we can null the values for future dates
                fullDate: this.getInnerDateString(momentDate)
            };
        });
        const secondaryHistogramData = this.props.stateContainer.state.secondaryHistogramData?.find((h)=>this.props.stateContainer.buildHistogramKey(h) == this.props.stateContainer.buildCacheKey(this.props.applicationId, this.props.filter))?.data?.map((d)=>{
            const momentDate = (0, _momentDefault.default)(d.date);
            return {
                color: (0, _colors.ocean_blue),
                x: this.props.stateContainer.getHistogramDateLabel(this.props.innerInterval, momentDate),
                y: this.today.diff(momentDate) > 0 ? d.count : null,
                // null will add gaps - so we can null the values for future dates
                fullDate: this.getInnerDateString(momentDate)
            };
        });
        const breakdownData = this.props.stateContainer.state.primaryBreakdownData?.find((h)=>this.props.stateContainer.buildBreakdownKey(h) == this.props.stateContainer.buildCacheKey(this.props.applicationId, this.props.filter, this.props.stateContainer.state.currentBreakdown))?.items ?? [];
        const secondaryBreakdownData = this.props.stateContainer.state.secondaryBreakdownData?.find((h)=>this.props.stateContainer.buildBreakdownKey(h) == this.props.stateContainer.buildCacheKey(this.props.applicationId, this.props.filter, this.props.stateContainer.state.currentBreakdown))?.items ?? [];
        const averagesData = this.props.stateContainer.state.averages?.find((h)=>this.props.stateContainer.buildAverageKey(h) == this.props.stateContainer.buildCacheKey(this.props.applicationId, this.props.filter))?.items ?? [];
        return (0, _react.jsx)("div", {
            className: wrapperStyle
        }, (0, _react.jsx)("div", {
            className: "options-row-container"
        }, (0, _react.jsx)((0, _analyticsSelectFieldDefault.default), {
            label: "Display:",
            className: "ac-analytics-display-field",
            options: this.props.stateContainer.displayOptions.map((s)=>({
                    label: s,
                    value: s
                })),
            value: this.props.stateContainer.state.currentDisplayOption,
            onChange: (e)=>this.props.stateContainer.handleDisplayOptionChange(e.value)
        }), (0, _react.jsx)("div", {
            className: "end-container"
        }, (0, _react.jsx)((0, _analyticsSelectFieldDefault.default), {
            className: "ac-analytics-compare-field",
            label: "Compare to:",
            options: [
                "Previous Period",
                "Same Time Last Year"
            ].map((s)=>({
                    label: s,
                    value: s
                })),
            value: this.props.stateContainer.state.currentDeltaPeriod,
            onChange: (e)=>this.handleDeltaPeriodChange(e.value)
        }), (0, _react.jsx)((0, _analyticsSelectFieldDefault.default), {
            label: "Change in:",
            options: [
                "Value",
                "Percentage",
                "Value & Percentage"
            ].map((s)=>({
                    label: s,
                    value: s
                })),
            value: this.props.stateContainer.state.currentDeltaType,
            onChange: (e)=>this.props.stateContainer.handleDeltaTypeChange(e.value)
        }))), (0, _react.jsx)("div", {
            className: "card-container"
        }, (0, _react.jsx)("div", {
            className: histogramContainer
        }, (0, _react.jsx)((0, _histogramChartCardDefault.default), {
            isLoading: this.props.stateContainer.state.isLoadingHistogram || !histogramData,
            data: histogramData,
            showSecondary: this.props.showSecondary,
            showPrimary: this.props.showPrimary,
            secondaryData: secondaryHistogramData,
            secondaryDataName: this.props.secondaryDataName,
            primaryDataName: this.props.primaryDataName,
            title: this.props.dataType
        })), (0, _react.jsx)("div", {
            className: breakdownContainer
        }, (0, _react.jsx)((0, _breakdownChartCardDefault.default), {
            options: this.props.stateContainer.breakdownOptions,
            selectedOption: this.props.stateContainer.state.currentBreakdown,
            onOptionChange: this.handleBreakdownChange.bind(this),
            secondaryDataLabel: this.props.secondaryDataName,
            primaryDataLabel: this.props.primaryDataName,
            items: breakdownData,
            secondaryItems: secondaryBreakdownData,
            showSecondary: this.props.showSecondary,
            showPrimary: this.props.showPrimary,
            isLoading: this.props.stateContainer.state.isLoadingBreakdown
        }))), (0, _react.jsx)("div", {
            className: averagesContainer
        }, (0, _react.jsx)((0, _averagesCardDefault.default), {
            isLoading: this.props.stateContainer.state.isLoadingHistogram || !histogramData,
            items: averagesData ?? [],
            comparedDateRangeLabel: `vs ${(0, _momentDefault.default)(prevDates.startDate, (0, _analyticsDateFormat.DATE_FORMAT)).format("MMM DD, YYYY")} - ${(0, _momentDefault.default)(prevDates.endDate, (0, _analyticsDateFormat.DATE_FORMAT)).format("MMM DD, YYYY")}`,
            showPercentage: this.props.stateContainer.state.currentDeltaType.toLocaleLowerCase().indexOf("percentage") > -1,
            showValue: this.props.stateContainer.state.currentDeltaType.toLocaleLowerCase().indexOf("value") > -1
        })));
    }
}
const wrapperStyle = /*#__PURE__*/ (0, _css.css)({
    name: "1f8klr2",
    styles: ".card-container{display:flex;}.options-row-container{display:flex;align-items:center;margin:32px;}.end-container{display:flex;align-items:center;margin-right:0;margin-left:auto;>div{margin-left:24px;}}"
});
const histogramContainer = /*#__PURE__*/ (0, _css.css)({
    name: "j411l2",
    styles: "flex:1;min-width:300px;margin:0 32px"
});
const breakdownContainer = /*#__PURE__*/ (0, _css.css)({
    name: "1qijuei",
    styles: "min-width:300px;margin-right:32px"
});
const averagesContainer = /*#__PURE__*/ (0, _css.css)({
    name: "18d63h3",
    styles: "margin:32px"
});
exports.default = ApplicationAnalyticsCharts;

},{"@babel/runtime/helpers/defineProperty":"9sJxO","@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","moment":"2meyw","../../../constants/colors":"1p3OR","../../../components/charts/HistogramChartCard":"cGWvK","../../../components/analytics/AnalyticsSelectField":"fCPWH","../../../components/charts/BreakdownChartCard":"dvaPH","../../../components/charts/AveragesCard":"1L0S8","../../../models/analytics/AnalyticsDateFormat":"ia5MW","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"bNDRQ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _applicationAnalyticsCharts = require("./ApplicationAnalyticsCharts");
var _applicationAnalyticsChartsDefault = parcelHelpers.interopDefault(_applicationAnalyticsCharts);
const ApplicationInteractionsCharts = (props)=>{
    (0, _react1.useEffect)(()=>{
        loadChartData();
    }, [
        props.interval,
        props.filter
    ]);
    const [loading, setLoading] = (0, _react1.useState)(false);
    const loadChartData = async ()=>{
        if (loading) return;
        await setLoading(true);
        props.stateContainer.loadPrimaryBreakdown({
            applicationId: props.applicationId
        }, props.filter, props.stateContainer.state.currentBreakdown);
        props.stateContainer.loadSecondaryBreakdown({
            applicationId: props.applicationId
        }, props.filter, props.stateContainer.state.currentBreakdown);
        await props.stateContainer.loadPrimaryHistogram({
            applicationId: props.applicationId
        }, props.innerInterval, props.filter);
        await props.stateContainer.loadSecondaryHistogram({
            applicationId: props.applicationId
        }, props.innerInterval, props.filter);
        await props.stateContainer.getAverages({
            applicationId: props.applicationId
        }, props.filter);
        await setLoading(false);
    };
    return (0, _react.jsx)((0, _applicationAnalyticsChartsDefault.default), {
        applicationId: props.applicationId,
        filter: props.filter,
        innerInterval: props.innerInterval,
        interval: props.interval,
        dataType: "Interactions",
        stateContainer: props.stateContainer,
        showSecondary: props.stateContainer.state.currentDisplayOption?.toLowerCase()?.indexOf("session") > -1,
        showPrimary: props.stateContainer.state.currentDisplayOption?.toLowerCase()?.indexOf("interactions") > -1,
        secondaryDataName: "Sessions",
        primaryDataName: "Interactions"
    });
};
exports.default = ApplicationInteractionsCharts;

},{"@emotion/react":"djZKr","react":"6uln9","./ApplicationAnalyticsCharts":"2fJkY","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8iRAR":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "filterChanged", ()=>filterChanged);
var _extends = require("@babel/runtime/helpers/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _applicationTopMissesTable = require("./ApplicationTopMissesTable");
var _applicationTopMissesTableDefault = parcelHelpers.interopDefault(_applicationTopMissesTable);
var _applicationTopHitsTable = require("./ApplicationTopHitsTable");
var _applicationTopHitsTableDefault = parcelHelpers.interopDefault(_applicationTopHitsTable);
var _analyticsSelectField = require("../../../components/analytics/AnalyticsSelectField");
var _analyticsSelectFieldDefault = parcelHelpers.interopDefault(_analyticsSelectField);
var _applicationOrderingExportWrapper = require("./ApplicationOrderingExportWrapper");
var _applicationOrderingExportWrapperDefault = parcelHelpers.interopDefault(_applicationOrderingExportWrapper);
var _applicationOrderingAnalyticsReport = require("./ApplicationOrderingAnalyticsReport");
var _applicationOrderingAnalyticsReportDefault = parcelHelpers.interopDefault(_applicationOrderingAnalyticsReport);
var _sparkContainer = require("../../../hooks/SparkContainer");
var _sparkContainerDefault = parcelHelpers.interopDefault(_sparkContainer);
var _featureTypeIds = require("../../../constants/featureTypeIds");
var _featureFlagIds = require("../../../constants/featureFlagIds");
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const filterChanged = (oldFilter, newFilter)=>{
    const deviceTargetDiff = oldFilter?.deviceTargetIds?.filter((d)=>!newFilter.deviceTargetIds?.includes(d));
    if (oldFilter?.startDate !== newFilter.startDate) return true;
    if (oldFilter?.endDate !== newFilter.endDate) return true;
    if (oldFilter?.languageIds !== newFilter.languageIds) return true;
    if (oldFilter?.locales !== newFilter.locales) return true;
    if (oldFilter?.assistants !== newFilter.assistants) return true;
    if (oldFilter?.deviceTargetIds?.length !== newFilter.deviceTargetIds?.length || deviceTargetDiff?.length) return true;
    return false;
};
const ApplicationStatistics = (props)=>{
    const [loading, setLoading] = (0, _react1.useState)({
        others: false,
        contentHits: false
    });
    const [interactionsCount, setInteractionsCount] = (0, _react1.useState)(0);
    const [filteredInteractionsCount, setFilteredInteractionsCount] = (0, _react1.useState)(0);
    const [aggregatedFeatureTypeInteractionsLoaded, setAggregatedFeatureTypeInteractionsLoaded] = (0, _react1.useState)(false);
    const [previousAggregatedFeatureTypeInteractionsLoaded, setPreviousAggregatedFeatureTypeInteractionsLoaded] = (0, _react1.useState)(false);
    const [previousInteractionsCount, setPreviousInteractionsCount] = (0, _react1.useState)(0);
    const prevFilter = (0, _react1.useRef)();
    const useGenerativeReview = props.application.featureFlags?.some((ff)=>ff.id && (0, _featureFlagIds.GENERATIVE_CALL_REVIEW_FEATURE_FLAG_IDS).includes(ff.id));
    const sparkContainer = (0, _sparkContainerDefault.default).useContainer();
    const previousDates = props.stateContainer.getPreviousDates(props.filter.startDate, props.filter.endDate);
    const loadPreviousContentHitsByFeatureTypeCounts = async ()=>{
        const filter = {
            ...props.filter,
            startDate: previousDates.startDate,
            endDate: previousDates.endDate
        };
        await props.statisticsContainer.loadPreviousContentHitsByFeatureTypeCounts(props.applicationId, filter);
    };
    const loadContentHitsByFeatureTypeCounts = async ()=>{
        await props.statisticsContainer.loadContentHitsByFeatureTypeCounts(props.applicationId, props.filter);
    };
    (0, _react1.useEffect)(()=>{
        if (props.statisticsContainer.state.aggregatedFeatureTypeInteractions) {
            setAggregatedFeatureTypeInteractionsLoaded(true);
            const aggregatedFeatureTypeInteractions = props.statisticsContainer.state.aggregatedFeatureTypeInteractions;
            let filteredInteractionCount = 0;
            let interactionCount = 0;
            const filteredAggregatedFeatureTypeInteractions = aggregatedFeatureTypeInteractions.filter((a)=>!(0, _featureTypeIds.SPARK_EXCLUDED_FEATURE_TYPE_IDS).includes(a.featureTypeId));
            for (const filteredAggregatedFeatureTypeInteraction of filteredAggregatedFeatureTypeInteractions)filteredInteractionCount = filteredInteractionCount + filteredAggregatedFeatureTypeInteraction.count;
            for (const aggregatedFeatureTypeInteraction of aggregatedFeatureTypeInteractions)interactionCount = interactionCount + aggregatedFeatureTypeInteraction.count;
            setFilteredInteractionsCount(filteredInteractionCount);
            setInteractionsCount(interactionCount);
        }
    }, [
        props.statisticsContainer.state.aggregatedFeatureTypeInteractions
    ]);
    (0, _react1.useEffect)(()=>{
        if (props.statisticsContainer.state.previousAggregatedFeatureTypeInteractions) {
            setPreviousAggregatedFeatureTypeInteractionsLoaded(true);
            const previousAggregatedFeatureTypeInteractions = props.statisticsContainer.state.previousAggregatedFeatureTypeInteractions;
            let interactionCount = 0;
            const filteredAggregatedFeatureTypeInteractions = previousAggregatedFeatureTypeInteractions.filter((a)=>!(0, _featureTypeIds.SPARK_EXCLUDED_FEATURE_TYPE_IDS).includes(a.featureTypeId));
            for (const aggregatedFeatureTypeInteraction of filteredAggregatedFeatureTypeInteractions)interactionCount = interactionCount + aggregatedFeatureTypeInteraction.count;
            setPreviousInteractionsCount(interactionCount);
        }
    }, [
        props.statisticsContainer.state.previousAggregatedFeatureTypeInteractions
    ]);
    (0, _react1.useEffect)(()=>{
        if (!props.applicationId?.length || !props.filter?.startDate || !props.filter?.endDate) return;
        if (!prevFilter.current || filterChanged(prevFilter.current, props.filter)) {
            prevFilter.current = props.filter;
            if (useGenerativeReview && sparkContainer.inSpark) {
                setLoading({
                    contentHits: false,
                    others: false
                });
                loadSparkGenerativeReviewStats();
                return;
            }
            loadContentHitsByFeatureTypeCounts();
            loadPreviousContentHitsByFeatureTypeCounts();
            loadChartData();
        }
    }, [
        props.interval,
        props.filter,
        props.applicationId
    ]);
    (0, _react1.useEffect)(()=>{
        if (props.envContainer.state.environments.some((e)=>e.applicationId === props.applicationId)) return;
        props.envContainer.loadEnvironments(props.applicationId);
    }, [
        props.applicationId
    ]);
    async function loadStats() {
        setLoading((state)=>({
                ...state,
                others: true
            }));
        const { applicationId, filter } = props;
        const promises = [];
        promises.push(props.stateContainer.loadTopContentMissesForApp(applicationId, filter));
        promises.push(props.stateContainer.loadMissStats(applicationId, filter));
        promises.push(props.stateContainer.loadStats(applicationId, filter));
        promises.push(props.featureContainer.getSystemFeatures());
        promises.push();
        await Promise.all(promises);
        setLoading((state)=>({
                ...state,
                others: false
            }));
    }
    async function loadSparkGenerativeReviewStats() {
        setLoading((state)=>({
                ...state,
                others: true
            }));
        const { applicationId, filter } = props;
        const promises = [];
        // don't need commented promises if we're using generative call review
        // promises.push(props.stateContainer.loadTopContentMissesForApp(applicationId, filter));
        // promises.push(props.stateContainer.loadMissStats(applicationId, filter));
        promises.push(props.stateContainer.loadStats(applicationId, filter));
        // promises.push(props.featureContainer.getSystemFeatures());
        await Promise.all(promises);
        setLoading((state)=>({
                ...state,
                others: false
            }));
    }
    async function loadContentHits() {
        setLoading((state)=>({
                ...state,
                contentHits: true
            }));
        await props.stateContainer.loadTopContentHitsForApp(props.applicationId, props.filter);
        setLoading((state)=>({
                ...state,
                contentHits: false
            }));
    }
    const loadChartData = async ()=>{
        if (loading.contentHits || loading.others) return;
        await Promise.all([
            loadStats(),
            loadContentHits()
        ]);
    };
    const handleDeltaPeriodChange = async (option)=>{
        const { applicationId, filter, stateContainer } = props;
        await stateContainer.handleDeltaPeriodChange(option);
        stateContainer.loadTopContentHitsForApp(applicationId, filter);
        stateContainer.loadTopContentMissesForApp(applicationId, filter);
        stateContainer.loadMissStats(applicationId, filter);
        stateContainer.loadStats(applicationId, filter);
    };
    const buildCacheKey = props.stateContainer.buildCacheKey;
    const nonFoodOrderingDisplayOptions = [
        ...props.stateContainer.displayOptions
    ].filter((d)=>!d.includes("AI Ordering"));
    const renderVoicifyContent = ()=>{
        switch(props.stateContainer.state.currentDisplayOption){
            case "Content Hits":
                return (0, _react.jsx)((0, _applicationTopHitsTableDefault.default), {
                    isLoading: loading,
                    data: props.stateContainer.state.appTopHits.find((a)=>buildCacheKey(a.applicationId, a.filter) === buildCacheKey(props.applicationId, props.filter)),
                    totals: props.stateContainer.state.appStats.find((a)=>buildCacheKey(a.id, a.filter) === buildCacheKey(props.applicationId, props.filter))?.data,
                    previousTotals: props.stateContainer.state.appStats.find((a)=>buildCacheKey(a.id, a.filter) === buildCacheKey(props.applicationId, {
                            ...props.filter,
                            startDate: previousDates.startDate,
                            endDate: previousDates.endDate
                        }))?.data,
                    featureContainer: props.featureContainer,
                    startDate: props.filter.startDate,
                    endDate: props.filter.endDate,
                    showPercentage: props.stateContainer.state.currentDeltaType.toLocaleLowerCase().indexOf("percentage") > -1,
                    showValue: props.stateContainer.state.currentDeltaType.toLocaleLowerCase().indexOf("value") > -1,
                    statisticsContainer: props.statisticsContainer,
                    aggregatedFeatureTypeInteractionsLoaded: aggregatedFeatureTypeInteractionsLoaded,
                    previousAggregatedFeatureTypeInteractionsLoaded: previousAggregatedFeatureTypeInteractionsLoaded,
                    filteredInteractionsCount: filteredInteractionsCount,
                    previousInteractionsCount: previousInteractionsCount,
                    previousDates: previousDates,
                    applicationId: props.applicationId,
                    application: props.application
                });
            case "Content Misses":
                return (0, _react.jsx)((0, _applicationTopMissesTableDefault.default), {
                    envContainer: props.envContainer,
                    isLoading: loading.others,
                    data: props.stateContainer.state.appTopMisses.find((a)=>buildCacheKey(a.applicationId, a.filter) === buildCacheKey(props.applicationId, props.filter)),
                    totals: props.stateContainer.state.appMissStats.find((a)=>buildCacheKey(a.id, a.filter) === buildCacheKey(props.applicationId, props.filter)),
                    previousTotals: props.stateContainer.state.appMissStats.find((a)=>buildCacheKey(a.id, a.filter) === buildCacheKey(props.applicationId, {
                            ...props.filter,
                            startDate: previousDates.startDate,
                            endDate: previousDates.endDate
                        })),
                    featureContainer: props.featureContainer,
                    startDate: props.filter.startDate,
                    endDate: props.filter.endDate,
                    filter: props.filter,
                    applicationId: props.applicationId,
                    showPercentage: props.stateContainer.state.currentDeltaType.toLocaleLowerCase().indexOf("percentage") > -1,
                    showValue: props.stateContainer.state.currentDeltaType.toLocaleLowerCase().indexOf("value") > -1,
                    statisticsContainer: props.statisticsContainer,
                    aggregatedFeatureTypeInteractionsLoaded: aggregatedFeatureTypeInteractionsLoaded,
                    interactionsCount: interactionsCount
                });
            case "AI Ordering":
                return (0, _react.jsx)((0, _applicationOrderingAnalyticsReportDefault.default), {
                    filter: props.filter,
                    applicationId: props.applicationId,
                    application: props.application
                });
            case "AI Ordering Export":
                return (0, _react.jsx)((0, _applicationOrderingExportWrapperDefault.default), (0, _extendsDefault.default)({}, props, {
                    filter: props.filter,
                    interval: props.interval,
                    innerInterval: props.innerInterval,
                    ssmlContainer: props.ssmlContainer,
                    envContainer: props.envContainer,
                    history: props.history,
                    userApplicationPreferencesContainer: props.userApplicationPreferencesContainer,
                    applicationId: props.applicationId
                }));
        }
    };
    const renderSparkContent = ()=>{
        if (props.showTopicHits) return (0, _react.jsx)((0, _applicationTopHitsTableDefault.default), {
            isLoading: loading,
            data: props.stateContainer.state.appTopHits.find((a)=>buildCacheKey(a.applicationId, a.filter) === buildCacheKey(props.applicationId, props.filter)),
            totals: props.stateContainer.state.appStats.find((a)=>buildCacheKey(a.id, a.filter) === buildCacheKey(props.applicationId, props.filter))?.data,
            previousTotals: props.stateContainer.state.appStats.find((a)=>buildCacheKey(a.id, a.filter) === buildCacheKey(props.applicationId, {
                    ...props.filter,
                    startDate: previousDates.startDate,
                    endDate: previousDates.endDate
                }))?.data,
            featureContainer: props.featureContainer,
            startDate: props.filter.startDate,
            endDate: props.filter.endDate,
            showPercentage: props.stateContainer.state.currentDeltaType.toLocaleLowerCase().indexOf("percentage") > -1,
            showValue: props.stateContainer.state.currentDeltaType.toLocaleLowerCase().indexOf("value") > -1,
            statisticsContainer: props.statisticsContainer,
            aggregatedFeatureTypeInteractionsLoaded: aggregatedFeatureTypeInteractionsLoaded,
            previousAggregatedFeatureTypeInteractionsLoaded: previousAggregatedFeatureTypeInteractionsLoaded,
            filteredInteractionsCount: filteredInteractionsCount,
            previousInteractionsCount: previousInteractionsCount,
            previousDates: previousDates,
            applicationId: props.applicationId,
            application: props.application
        });
        else return (0, _react.jsx)((0, _applicationTopMissesTableDefault.default), {
            envContainer: props.envContainer,
            isLoading: loading.others,
            data: props.stateContainer.state.appTopMisses.find((a)=>buildCacheKey(a.applicationId, a.filter) === buildCacheKey(props.applicationId, props.filter)),
            totals: props.stateContainer.state.appMissStats.find((a)=>buildCacheKey(a.id, a.filter) === buildCacheKey(props.applicationId, props.filter)),
            previousTotals: props.stateContainer.state.appMissStats.find((a)=>buildCacheKey(a.id, a.filter) === buildCacheKey(props.applicationId, {
                    ...props.filter,
                    startDate: previousDates.startDate,
                    endDate: previousDates.endDate
                })),
            featureContainer: props.featureContainer,
            startDate: props.filter.startDate,
            endDate: props.filter.endDate,
            filter: props.filter,
            applicationId: props.applicationId,
            showPercentage: props.stateContainer.state.currentDeltaType.toLocaleLowerCase().indexOf("percentage") > -1,
            showValue: props.stateContainer.state.currentDeltaType.toLocaleLowerCase().indexOf("value") > -1,
            statisticsContainer: props.statisticsContainer,
            aggregatedFeatureTypeInteractionsLoaded: aggregatedFeatureTypeInteractionsLoaded,
            interactionsCount: interactionsCount
        });
    };
    return (0, _react.jsx)("div", {
        className: wrapperStyle
    }, (0, _react.jsx)("div", {
        className: sparkContainer.inSpark ? "spark-wrapper" : "options-row-container"
    }, props.application?.featureFlags?.find((f)=>f.name === "Food Ordering") ? !sparkContainer.inSpark && (0, _react.jsx)((0, _analyticsSelectFieldDefault.default), {
        label: "Display:",
        options: props.stateContainer.displayOptions.map((s)=>({
                label: s,
                value: s
            })),
        value: props.stateContainer.state.currentDisplayOption,
        onChange: (e)=>props.stateContainer.handleDisplayOptionChange(e.value)
    }) : !sparkContainer.inSpark && (0, _react.jsx)((0, _analyticsSelectFieldDefault.default), {
        label: "Display:",
        options: nonFoodOrderingDisplayOptions.map((s)=>({
                label: s,
                value: s
            })),
        value: props.stateContainer.state.currentDisplayOption,
        onChange: (e)=>props.stateContainer.handleDisplayOptionChange(e.value)
    }), !sparkContainer.inSpark && props.stateContainer.state.currentDisplayOption === "Content Hits" && (0, _react.jsx)("div", {
        className: "end-container"
    }, (0, _react.jsx)((0, _analyticsSelectFieldDefault.default), {
        label: "Compare to:",
        options: [
            "Previous Period",
            "Same Time Last Year"
        ].map((s)=>({
                label: s,
                value: s
            })),
        value: props.stateContainer.state.currentDeltaPeriod,
        onChange: (e)=>handleDeltaPeriodChange(e.value)
    }), (0, _react.jsx)((0, _analyticsSelectFieldDefault.default), {
        label: "Change in:",
        options: [
            "Value",
            "Percentage",
            "Value & Percentage"
        ].map((s)=>({
                label: s,
                value: s
            })),
        value: props.stateContainer.state.currentDeltaType,
        onChange: (e)=>props.stateContainer.handleDeltaTypeChange(e.value)
    }))), sparkContainer.inSpark ? renderSparkContent() : renderVoicifyContent());
};
const wrapperStyle = /*#__PURE__*/ (0, _css.css)({
    name: "hc27h6",
    styles: ".card-container{display:flex;}.options-row-container{display:flex;align-items:center;margin:32px;}.spark-wrapper{display:flex;align-items:center;margin-top:16px;}.end-container{display:flex;align-items:center;margin-right:0;margin-left:auto;>div{margin-left:24px;}}"
});
exports.default = ApplicationStatistics;

},{"@babel/runtime/helpers/extends":"4iKIP","@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","./ApplicationTopMissesTable":"BhbOe","./ApplicationTopHitsTable":"cGpdB","../../../components/analytics/AnalyticsSelectField":"fCPWH","./ApplicationOrderingExportWrapper":"7ELyM","./ApplicationOrderingAnalyticsReport":"58rtH","../../../hooks/SparkContainer":"jzXzx","../../../constants/featureTypeIds":"hPLMP","../../../constants/featureFlagIds":"33vuW","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"BhbOe":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _base = require("@emotion/styled/base");
var _baseDefault = parcelHelpers.interopDefault(_base);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _tableCell = require("../../../components/general/TableCell");
var _tableCellDefault = parcelHelpers.interopDefault(_tableCell);
var _colors = require("../../../constants/colors");
var _reportTable = require("../../../components/analytics/ReportTable");
var _reportTableDefault = parcelHelpers.interopDefault(_reportTable);
var _reportTableHeader = require("../../../components/analytics/ReportTableHeader");
var _reportTableHeaderDefault = parcelHelpers.interopDefault(_reportTableHeader);
var _extensions = require("../../../models/extensions");
var _totalCard = require("../../../components/charts/TotalCard");
var _totalCardDefault = parcelHelpers.interopDefault(_totalCard);
var _sparkContainer = require("../../../hooks/SparkContainer");
var _sparkContainerDefault = parcelHelpers.interopDefault(_sparkContainer);
var _sessionAnalyticsContainerOld = require("../../../hooks/SessionAnalyticsContainerOld");
var _sessionAnalyticsContainerOldDefault = parcelHelpers.interopDefault(_sessionAnalyticsContainerOld);
var _featureTypeIds = require("../../../constants/featureTypeIds");
var _urls = require("../../../constants/Urls");
var _loader = require("../../../components/general/Loader");
var _loaderDefault = parcelHelpers.interopDefault(_loader);
var _applicationStatistics = require("./ApplicationStatistics");
var _secondaryLoader = require("../../../components/general/SecondaryLoader");
var _secondaryLoaderDefault = parcelHelpers.interopDefault(_secondaryLoader);
var _emptyView = require("../../applicationModules/components/EmptyView");
var _emptyViewDefault = parcelHelpers.interopDefault(_emptyView);
var _useIsMobile = require("../../../hooks/UseIsMobile");
var _useIsMobileDefault = parcelHelpers.interopDefault(_useIsMobile);
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const missIconBlue = require("a3a60c548ec20982");
const ApplicationTopMissesTable = (props)=>{
    const [missesLoaded, setMissesLoaded] = (0, _react1.useState)(false);
    const [misses, setMisses] = (0, _react1.useState)([]);
    const [missesWithCountsAndLinks, setMissesWithCountsAndLinks] = (0, _react1.useState)({});
    const prevFilter = (0, _react1.useRef)();
    const sparkContainer = (0, _sparkContainerDefault.default).useContainer();
    const sessionContainer = (0, _sessionAnalyticsContainerOldDefault.default).useContainer();
    const isMobile = (0, _useIsMobileDefault.default)();
    const percentMisses = props.interactionsCount > 0 ? Math.round(misses.length / props.interactionsCount * 100) : 0;
    const loadMoreMisses = async ()=>{
        await sessionContainer.loadMoreContentByFeatureType(props.applicationId, props.filter, (0, _featureTypeIds.FallbackFeatureTypeId));
    };
    (0, _react1.useEffect)(()=>{
        if (!props.applicationId?.length || !props.filter?.startDate || !props.filter?.endDate) return;
        if (!prevFilter.current || (0, _applicationStatistics.filterChanged)(prevFilter.current, props.filter)) loadMoreMisses();
        prevFilter.current = props.filter;
    }, [
        props.applicationId,
        props.filter
    ]);
    (0, _react1.useEffect)(()=>{
        if (sessionContainer.moreHitsByFeatureTypeToLoad || !sessionContainer.featureTypeContentHits) return;
        const fallbacks = sessionContainer.featureTypeContentHits;
        const uniqueFallbacks = [];
        for (const fallback of fallbacks){
            const fallbackEventDate = new Date(fallback.eventDate);
            if (!uniqueFallbacks.find((f)=>f.requestId === fallback.requestId)) uniqueFallbacks.push(fallback);
            else {
                const existingFallback = uniqueFallbacks.find((u)=>u.requestId === fallback.requestId);
                const existingFallbackEventDate = new Date(existingFallback.eventDate);
                if (existingFallback && fallbackEventDate > existingFallbackEventDate) {
                    const index = uniqueFallbacks.indexOf(existingFallback);
                    uniqueFallbacks[index] = fallback;
                }
            }
        }
        setMissesLoaded(true);
        setMisses(uniqueFallbacks);
        const uniqueTopics = [];
        const uniqueTopicsWithCount = {};
        for (const fallback of uniqueFallbacks){
            if (!fallback.originalRequest?.originalInput) continue;
            let baseUrl;
            sparkContainer.inSpark ? baseUrl = (0, _urls.getSparkBaseUrl)() : baseUrl = (0, _urls.getBaseUrl)();
            const sessionLink = `${baseUrl}/v/apps/${props.applicationId}/analytics/sessions?sessionId=${fallback.sessionId}&startDate=${props.startDate}&endDate=${props.endDate}`;
            if (uniqueTopics.includes(fallback.originalRequest.originalInput)) uniqueTopicsWithCount[fallback.originalRequest.originalInput] = {
                link: [
                    ...uniqueTopicsWithCount[fallback.originalRequest.originalInput].link,
                    sessionLink
                ],
                count: uniqueTopicsWithCount[fallback.originalRequest.originalInput].count + 1
            };
            else {
                uniqueTopics.push(fallback.originalRequest.originalInput);
                uniqueTopicsWithCount[fallback.originalRequest.originalInput] = {
                    link: [
                        sessionLink
                    ],
                    count: 1
                };
            }
        }
        setMissesWithCountsAndLinks(uniqueTopicsWithCount);
    }, [
        sessionContainer.featureTypeContentHits,
        sessionContainer.moreHitsByFeatureTypeToLoad
    ]);
    const getRowItems = ()=>{
        const items = [];
        const topics = Object.keys(missesWithCountsAndLinks);
        const countsAndLinks = Object.values(missesWithCountsAndLinks);
        topics.forEach((topic, index)=>{
            items.push({
                title: topic,
                link: countsAndLinks[index].link,
                count: countsAndLinks[index].count
            });
        });
        items.sort((a, b)=>{
            if (a.count === b.count) return a.title.localeCompare(b.title);
            return b.count - a.count;
        });
        return items;
    };
    const mobileColumns = [
        {
            id: "title",
            Header: (0, _react.jsx)((0, _reportTableHeaderDefault.default), {
                title: "What Callers Said",
                tooltip: "This could be a fragment of what the caller said if they paused in between words, and therefore may not be a miss. Review the linked transcripts to get the full context of the conversation."
            }),
            accessor: (item)=>item,
            Cell: (row)=>(0, _react.jsx)((0, _tableCellDefault.default), null, (0, _react.jsx)("img", {
                    className: "feature-type-icon",
                    src: (0, _extensions.getSmallFeatureTypeIcon)((0, _featureTypeIds.FallbackFeatureTypeId))
                }), (0, _react.jsx)("p", null, row.value.title ?? "Unknown")),
            style: {
                "whiteSpace": "unset"
            },
            minWidth: "50%"
        },
        {
            id: "link",
            Header: (0, _react.jsx)((0, _reportTableHeaderDefault.default), {
                title: "Convo Transcript"
            }),
            accessor: (item)=>item,
            Cell: (row)=>{
                const links = row.value.link || [];
                return (0, _react.jsx)(TranscriptCell, null, links.map((link, index)=>(0, _react.jsx)("div", {
                        key: index
                    }, (0, _react.jsx)(StyledLink, {
                        href: link,
                        target: "_blank",
                        key: `link.${index}`
                    }, links.length === 1 ? "Transcript" : `Transcript ${index + 1}`), "\xa0 \xa0")));
            },
            style: {
                "whiteSpace": "unset"
            },
            minWidth: "40%"
        }
    ];
    const columns = [
        {
            id: "title",
            Header: (0, _react.jsx)((0, _reportTableHeaderDefault.default), {
                title: "What Callers Said",
                tooltip: "This could be a fragment of what the caller said if they paused in between words, and therefore may not be a miss. Review the linked transcripts to get the full context of the conversation."
            }),
            accessor: (item)=>item,
            Cell: (row)=>(0, _react.jsx)((0, _tableCellDefault.default), null, (0, _react.jsx)("img", {
                    className: "feature-type-icon",
                    src: (0, _extensions.getSmallFeatureTypeIcon)((0, _featureTypeIds.FallbackFeatureTypeId))
                }), (0, _react.jsx)("p", null, row.value.title ?? "Unknown")),
            style: {
                "whiteSpace": "unset"
            },
            minWidth: "50%"
        },
        {
            id: "count",
            Header: (0, _react.jsx)((0, _reportTableHeaderDefault.default), {
                title: "# Times",
                tooltip: "If the total in this column doesn't match your miss count, it's because detailed analytics were disabled for a period of time."
            }),
            accessor: (item)=>item,
            Cell: (row)=>{
                return (0, _react.jsx)((0, _tableCellDefault.default), null, row.value.count);
            },
            minWidth: "10%"
        },
        {
            id: "link",
            Header: (0, _react.jsx)((0, _reportTableHeaderDefault.default), {
                title: "Full Conversation Transcript"
            }),
            accessor: (item)=>item,
            Cell: (row)=>{
                const links = row.value.link || [];
                return (0, _react.jsx)(TranscriptCell, null, links.map((link, index)=>(0, _react.jsx)("div", {
                        key: index
                    }, (0, _react.jsx)(StyledLink, {
                        href: link,
                        target: "_blank",
                        key: index
                    }, links.length === 1 ? "Transcript" : `Transcript ${index + 1}`), "\xa0 \xa0")));
            },
            style: {
                "whiteSpace": "unset"
            },
            minWidth: "40%"
        }
    ];
    return (0, _react.jsx)("div", {
        className: containerStyle
    }, props.isLoading || !sparkContainer.inSpark && !props.data || !props.aggregatedFeatureTypeInteractionsLoaded || !missesLoaded ? sparkContainer.inSpark ? (0, _react.jsx)("div", {
        className: "loader-container"
    }, (0, _react.jsx)((0, _loaderDefault.default), null)) : (0, _react.jsx)("div", {
        className: "loader-container"
    }, (0, _react.jsx)((0, _secondaryLoaderDefault.default), null)) : (0, _react.jsx)((0, _reactDefault.default).Fragment, null, (0, _react.jsx)("div", {
        className: "spark-summary-wrapper"
    }, (0, _react.jsx)(StyledTotalCard, {
        title: "Miss Count",
        value: misses.length,
        showValue: props.showValue,
        showPercentage: false,
        icon: missIconBlue
    }), (0, _react.jsx)(StyledTotalCard, {
        title: "Miss %",
        value: percentMisses,
        showValueAsPercent: true,
        showValue: props.showValue,
        showPercentage: false,
        icon: missIconBlue
    })), !props.envContainer.state.environments?.[0]?.detailedAnalyticsEnabled ? (0, _react.jsx)((0, _emptyViewDefault.default), {
        wrapperStyle: emptyViewWrapperStyle,
        noImage: true,
        title: "Miss Details Unavailable",
        description: "Go to Settings and enable detailed analytics to see additional insights."
    }) : (0, _react.jsx)((0, _reportTableDefault.default), {
        columns: isMobile ? mobileColumns : columns,
        data: getRowItems(),
        showPagination: false
    })));
};
const emptyViewWrapperStyle = /*#__PURE__*/ (0, _css.css)({
    name: "knjsbg",
    styles: "padding:32px"
});
const StyledLink = /*#__PURE__*/ (0, _baseDefault.default)("a", {
    target: "e1uf9k3w2"
})("color:", (0, _colors.color_text_link), ";");
const TranscriptCell = /*#__PURE__*/ (0, _baseDefault.default)((0, _tableCellDefault.default), {
    target: "e1uf9k3w1"
})({
    name: "piwbu2",
    styles: "display:flex;flex-wrap:wrap;line-height:3"
});
const StyledTotalCard = /*#__PURE__*/ (0, _baseDefault.default)((0, _totalCardDefault.default), {
    target: "e1uf9k3w0"
})({
    name: "au6jqs",
    styles: "padding:32px;height:auto"
});
const containerStyle = /*#__PURE__*/ (0, _css.css)(".feature-type-icon{margin-right:12px;width:24px;height:24px;}.loader-container{display:flex;flex:1;align-items:center;justify-content:center;height:100vh;width:100%;.spinner>div{background:", (0, _colors.color_colors_ocean), ";}}.spark-summary-wrapper{display:flex;flex:1;margin:0 16px;padding:16px 0;}.totals-container{display:flex;flex:1;margin:0 16px;padding-bottom:16px;}>h3{margin:16px 32px;}", "");
exports.default = ApplicationTopMissesTable;

},{"@emotion/styled/base":"lSuFu","@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","../../../components/general/TableCell":"2zNzE","../../../constants/colors":"1p3OR","../../../components/analytics/ReportTable":"4pPnp","../../../components/analytics/ReportTableHeader":"2Dfnn","../../../models/extensions":"7h01B","../../../components/charts/TotalCard":"gH7gf","../../../hooks/SparkContainer":"jzXzx","../../../hooks/SessionAnalyticsContainerOld":"3KBHi","../../../constants/featureTypeIds":"hPLMP","../../../constants/Urls":"iTopY","../../../components/general/Loader":"bnV5T","./ApplicationStatistics":"8iRAR","../../../components/general/SecondaryLoader":"7zJiF","../../applicationModules/components/EmptyView":"ffYYa","../../../hooks/UseIsMobile":"9Gz1L","a3a60c548ec20982":"mbuTU","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4pPnp":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _reactTable = require("react-table");
var _reactTableDefault = parcelHelpers.interopDefault(_reactTable);
var _colors = require("../../constants/colors");
var _numberIncrementSelector = require("../forms/NumberIncrementSelector");
var _numberIncrementSelectorDefault = parcelHelpers.interopDefault(_numberIncrementSelector);
var _roundedSelectField = require("../forms/RoundedSelectField");
var _roundedSelectFieldDefault = parcelHelpers.interopDefault(_roundedSelectField);
var _breakpoints = require("../../constants/breakpoints");
const ReportTable = (props)=>{
    const [pageSize, setPageSize] = (0, _react1.useState)(props.pageSize ? props.pageSize : localStorage.getItem("defaultPageSize") ? parseInt(localStorage.getItem("defaultPageSize")) : 20);
    const [pageNumber, setPageNumber] = (0, _react1.useState)(1);
    const pageSizes = [
        5,
        10,
        20,
        50,
        100
    ];
    const handlePage = (increment)=>{
        const currentDataSize = props.data?.slice((pageNumber - 1) * pageSize, pageNumber * pageSize)?.length ?? 0;
        let newPageNumber = pageNumber;
        if (increment && currentDataSize >= pageSize) newPageNumber++;
        else if (!increment && pageNumber > 1) newPageNumber--;
        setPageNumber(newPageNumber);
    };
    const handlePageSizeChange = (size)=>{
        setPageSize(size.value);
        setPageNumber(1);
    };
    return (0, _react.jsx)("div", {
        className: containerStyle
    }, (0, _react.jsx)("div", {
        className: "table-options-header"
    }, (0, _react.jsx)("div", {
        className: "table-pagination-options"
    }, (0, _react.jsx)("div", {
        className: "page-size-option"
    }, (0, _react.jsx)("p", null, "Rows per Page"), (0, _react.jsx)((0, _roundedSelectFieldDefault.default), {
        options: pageSizes.map((v)=>({
                label: v.toString(),
                value: v
            })),
        onChange: handlePageSizeChange.bind(undefined),
        value: pageSize.toString()
    })), (0, _react.jsx)((0, _numberIncrementSelectorDefault.default), {
        selectedNumber: pageNumber.toString(),
        updateValue: handlePage.bind(undefined),
        showNumber: true
    }))), (0, _react.jsx)((0, _reactTableDefault.default), {
        className: `${tableStyles} ${props.className}`,
        data: props.data?.slice((pageNumber - 1) * pageSize, pageNumber * pageSize),
        columns: props.columns,
        showPagination: false,
        onPageSizeChange: handlePageSizeChange.bind(undefined),
        showPaginationBottom: false,
        pageSize: pageSize,
        getTrProps: props.getTrProps,
        minRows: 1
    }));
};
const containerStyle = /*#__PURE__*/ (0, _css.css)("border-top:1px solid ", (0, _colors.color_shades_dark), ";background:white;margin-bottom:128px;.table-options-header{height:56px;margin:0 32px;display:flex;align-items:center;border-bottom:1px solid ", (0, _colors.color_shades_dark), ";.table-pagination-options{margin-right:0;margin-left:auto;display:flex;align-items:center;>*{margin-left:16px;}.page-size-option{display:flex;align-items:center;>p{font-size:14px;line-height:20px;margin-right:8px;}>.selector{.Select-control{width:80px;}.Select-value{margin-left:8px;}}}}}", (0, _breakpoints.breakpoint_small), "{display:flex;flex-direction:column;width:100%;.table-options-header{margin:0;width:100%;.table-pagination-options{width:100%;align-items:center;}}}", "");
const tableStyles = /*#__PURE__*/ (0, _css.css)("border:none;overflow:hidden;.rt-table{background:white;overflow:hidden;.rt-thead,.rt-thead -header{padding:0 32px;box-shadow:none;border-bottom:solid 1px ", (0, _colors.color_shades_dark), ";.rt-th{border:none;box-shadow:none;div{height:100%;}}}.rt-tbody{min-height:64px;.rt-tr-group{min-height:52px;border-bottom:solid 1px #cccccc;.rt-tr{background:transparent;padding:0 32px;border:none;overflow:visible;}}}div.rt-td{background:transparent;align-self:center;overflow:visible;}}", (0, _breakpoints.breakpoint_small), "{div{font-size:10px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;}.rt-table{.rt-thead,.rt-thead -header{padding:0 16px;}.rt-tbody{.rt-tr-group{.rt-tr{padding:0 16px;display:flex;}}}}}", "");
exports.default = ReportTable;

},{"@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","react-table":"e4yqY","../../constants/colors":"1p3OR","../forms/NumberIncrementSelector":"kU0zB","../forms/RoundedSelectField":"lAfbC","../../constants/breakpoints":"2F01A","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2Dfnn":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _base = require("@emotion/styled/base");
var _baseDefault = parcelHelpers.interopDefault(_base);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _colors = require("../../constants/colors");
var _tooltipWrapper = require("../general/TooltipWrapper");
var _tooltipWrapperDefault = parcelHelpers.interopDefault(_tooltipWrapper);
var _breakpoints = require("../../constants/breakpoints");
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const deltaDown = require("749e738223a17d26");
const deltaUp = require("1b0d4a253f7cd77a");
const ReportTableHeader = (props)=>(0, _react.jsx)("div", {
        className: containerStyle
    }, props.tooltip ? (0, _react.jsx)(StyledTooltipWrapper, {
        place: "topLeft",
        text: props.tooltip
    }, (0, _react.jsx)("p", {
        className: "item-label ac-analytics-table-header"
    }, props.title)) : (0, _react.jsx)("p", {
        className: "item-label ac-analytics-table-header"
    }, props.title), props.value && (0, _react.jsx)("div", {
        className: "item-values-container"
    }, (0, _react.jsx)("p", {
        className: "item-value"
    }, props.value), props.deltaValue != null && (0, _react.jsx)("img", {
        src: props.deltaValue > 0 ? deltaUp : deltaDown
    }), props.showValue && (0, _react.jsx)("p", {
        className: "item-delta"
    }, Math.abs(props.deltaValue)), props.showValue && props.showPercentage && (0, _react.jsx)("div", {
        className: "item-separator"
    }), props.showPercentage && (0, _react.jsx)("p", {
        className: "item-delta"
    }, Math.round(Math.abs(props.deltaPercentage)), "%")));
const StyledTooltipWrapper = /*#__PURE__*/ (0, _baseDefault.default)((0, _tooltipWrapperDefault.default), {
    target: "e17sb1hc0"
})({
    name: "1ww443i",
    styles: "max-width:200px"
});
const containerStyle = /*#__PURE__*/ (0, _css.css)("flex:1;text-align:left;padding:16px 0;.item-label{font-size:14px;line-height:16px;letter-spacing:0.1em;text-transform:uppercase;color:", (0, _colors.color_text_light), ";text-align:left;}.item-values-container{display:flex;align-items:center;img{margin-left:8px;margin-right:4px;}.item-value{font-size:18px;line-height:24px;}.item-delta{color:", (0, _colors.color_text_light), ";font-size:14px;line-height:20px;}.item-separator{height:16px;max-height:16px;width:1px;background :", (0, _colors.color_text_light), ";margin:0 8px;}}", (0, _breakpoints.breakpoint_small), "{padding:8px 0;.item-label{font-size:10px;line-height:16px;}}", "");
exports.default = ReportTableHeader;

},{"@emotion/styled/base":"lSuFu","@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","../../constants/colors":"1p3OR","../general/TooltipWrapper":"53pWd","../../constants/breakpoints":"2F01A","749e738223a17d26":"3WzsL","1b0d4a253f7cd77a":"lBKA8","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3KBHi":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _unstatedNext = require("unstated-next");
var _api = require("../api");
var _featureTypeIds = require("../constants/featureTypeIds");
function useSessionAnalyticsContainerOld() {
    const [contentHits, setContentHits] = (0, _react.useState)([]);
    const [featureTypeContentHits, setFeatureTypeContentHits] = (0, _react.useState)([]);
    const [sessions, setSessions] = (0, _react.useState)({});
    const [sessionsByFeatureType, setSessionsByFeatureType] = (0, _react.useState)({});
    const [moreToLoad, setMoreToLoad] = (0, _react.useState)(true);
    const [moreHitsByFeatureTypeToLoad, setMoreHitsByFeatureTypeToLoad] = (0, _react.useState)(true);
    const [applicationId, setAppId] = (0, _react.useState)("");
    const [startDate, setStartDate] = (0, _react.useState)("");
    const [endDate, setEndDate] = (0, _react.useState)("");
    const [loading, setLoading] = (0, _react.useState)(false);
    const [loadingSessionsByFeatureType, setLoadingSessionsByFeatureType] = (0, _react.useState)(false);
    const [skip, setSkip] = (0, _react.useState)(0);
    const [skipByType, setSkipByType] = (0, _react.useState)(0);
    const [sessionIds, setSessionIds] = (0, _react.useState)([]);
    const [sessionIdsByFeatureType, setSessionIdsByFeatureType] = (0, _react.useState)([]);
    const [error, setError] = (0, _react.useState)("");
    const setHits = (contentHitType)=>{
        let filtered = [];
        if (contentHitType === "allHits") filtered = contentHits.filter((e)=>e.response);
        else filtered = featureTypeContentHits.filter((e)=>e.response);
        // aggregate by session id
        const newSessions = {};
        for (const hit of filtered){
            if (!newSessions[hit.sessionId]) newSessions[hit.sessionId] = [];
            newSessions[hit.sessionId].push(hit);
        }
        // order sessions by eventDate
        const ordered = Object.keys(newSessions).sort((a, b)=>{
            return new Date(newSessions[b][0].eventDate).valueOf() - new Date(newSessions[a][0].eventDate).valueOf();
        }).reduce((obj, key)=>{
            obj[key] = newSessions[key];
            return obj;
        }, {});
        // order each session by eventDate
        for (const sessionId of Object.keys(ordered))ordered[sessionId] = ordered[sessionId].sort((a, b)=>{
            return new Date(a.eventDate).valueOf() - new Date(b.eventDate).valueOf();
        });
        if (contentHitType === "allHits") setSessions(ordered);
        else setSessionsByFeatureType(ordered);
    };
    (0, _react.useEffect)(()=>{
        setHits("allHits");
    }, [
        contentHits
    ]);
    (0, _react.useEffect)(()=>{
        setHits("hitsByFeatureType");
    }, [
        featureTypeContentHits
    ]);
    const isConflictingHit = (hit1, hit2)=>{
        // welcome messages had bug to have the same request ID as the first turn. lets fix that. 
        if (hit1.requestId === hit2.requestId) return true;
        else return false;
    };
    const loadMoreContentByFeatureType = async (appId, filter, featureTypeId = null)=>{
        try {
            let contentHitsToUse = featureTypeContentHits;
            let currentSkip = skipByType;
            if (applicationId !== appId || startDate !== filter.startDate || endDate !== filter.endDate) {
                setFeatureTypeContentHits([]);
                contentHitsToUse = [];
                setAppId(appId);
                setStartDate(filter.startDate);
                setEndDate(filter.endDate);
                setMoreHitsByFeatureTypeToLoad(true);
                setSessionIdsByFeatureType([]);
                setSkipByType(0);
                currentSkip = 0;
            }
            setLoadingSessionsByFeatureType(true);
            const newEvents = [];
            const maxEvents = 5000;
            let go = true;
            while(go){
                let events = await _api.getContentHits(appId, filter, currentSkip, 100, true, "", featureTypeId);
                currentSkip += 100;
                if (!events?.data?.length || events.data.length < 100) {
                    go = false;
                    setMoreHitsByFeatureTypeToLoad(false);
                }
                for (const event of events.data){
                    let existingHit = newEvents.find((e)=>isConflictingHit(e, event));
                    if (existingHit) {
                        // use hit with last created date
                        if (new Date(existingHit.eventDate).valueOf() > new Date(event.eventDate).valueOf()) continue;
                        else {
                            newEvents.splice(newEvents.indexOf(existingHit), 1);
                            newEvents.push(event);
                            continue;
                        }
                    }
                    existingHit = contentHitsToUse.find((e)=>isConflictingHit(e, event));
                    if (existingHit) {
                        // use hit with last created date
                        if (new Date(existingHit.eventDate).valueOf() > new Date(event.eventDate).valueOf()) continue;
                        else {
                            contentHitsToUse.splice(newEvents.indexOf(existingHit), 1);
                            newEvents.push(event);
                            continue;
                        }
                    }
                    newEvents.push(event);
                }
                if (newEvents.length >= maxEvents) go = false;
            }
            setSkipByType(currentSkip);
            setFeatureTypeContentHits([
                ...contentHitsToUse,
                ...newEvents
            ]);
            setLoadingSessionsByFeatureType(false);
            return [
                ...contentHitsToUse,
                ...newEvents
            ];
        } catch  {
            setError("There was an error loading the content hits");
        }
    };
    const loadMoreContentHits = async (appId, filter, sessionId = null)=>{
        try {
            let contentHitsToUse = contentHits;
            let currentSkip = skip;
            if (applicationId !== appId || startDate !== filter.startDate || endDate !== filter.endDate) {
                setContentHits([]);
                contentHitsToUse = [];
                setAppId(appId);
                setStartDate(filter.startDate);
                setEndDate(filter.endDate);
                setMoreToLoad(true);
                setSessionIds([]);
                setSkip(0);
                currentSkip = 0;
            }
            setLoading(true);
            const newEvents = [];
            const maxEvents = 100;
            let go = true;
            while(go){
                let events = await _api.getContentHits(appId, filter, currentSkip, 100, false);
                currentSkip += 50;
                if (!events?.data?.length || events.data.length < 100) {
                    go = false;
                    setMoreToLoad(false);
                }
                for (const event of events.data){
                    let existingHit = newEvents.find((e)=>isConflictingHit(e, event));
                    if (existingHit) {
                        // use hit with last created date
                        if (new Date(existingHit.eventDate).valueOf() > new Date(event.eventDate).valueOf()) continue;
                        else {
                            newEvents.splice(newEvents.indexOf(existingHit), 1);
                            newEvents.push(event);
                            continue;
                        }
                    }
                    existingHit = contentHitsToUse.find((e)=>isConflictingHit(e, event));
                    if (existingHit) {
                        // use hit with last created date
                        if (new Date(existingHit.eventDate).valueOf() > new Date(event.eventDate).valueOf()) continue;
                        else {
                            contentHitsToUse.splice(newEvents.indexOf(existingHit), 1);
                            newEvents.push(event);
                            continue;
                        }
                    }
                    newEvents.push(event);
                }
                if (newEvents.length >= maxEvents) go = false;
            }
            setSkip(currentSkip);
            if (sessionId?.length && !sessionIds.includes(sessionId)) {
                const sessionEvents = await _api.getContentHits(appId, filter, 0, 100, true, sessionId);
                for (const event of sessionEvents.data){
                    var existingHit = newEvents.find((e)=>isConflictingHit(e, event));
                    if (existingHit) {
                        // use hit with last created date
                        if (new Date(existingHit.eventDate).valueOf() > new Date(event.eventDate).valueOf()) continue;
                        else {
                            newEvents.splice(newEvents.indexOf(existingHit), 1);
                            newEvents.push(event);
                            continue;
                        }
                    }
                    existingHit = contentHitsToUse.find((e)=>isConflictingHit(e, event));
                    if (existingHit) {
                        // use hit with last created date
                        if (new Date(existingHit.eventDate).valueOf() > new Date(event.eventDate).valueOf()) continue;
                        else {
                            contentHitsToUse.splice(newEvents.indexOf(existingHit), 1);
                            newEvents.push(event);
                            continue;
                        }
                    }
                    newEvents.push(event);
                }
                setSessionIds([
                    ...sessionIds,
                    sessionId
                ]);
            }
            setContentHits([
                ...contentHitsToUse,
                ...newEvents
            ]);
            setLoading(false);
            return [
                ...contentHitsToUse,
                ...newEvents
            ];
        } catch  {
            setError("There was an error loading the content hits");
        }
    };
    const loadSession = async (appId, sessionId, filter)=>{
        try {
            if (sessionIds.includes(sessionId)) return;
            const allEvents = [];
            const newStartDate = new Date(filter.startDate);
            newStartDate.setDate(newStartDate.getDate() - 2);
            const newEndDate = new Date(filter.endDate);
            newEndDate.setDate(newEndDate.getDate() + 2);
            const newFilter = {
                ...filter,
                startDate: newStartDate.toISOString(),
                endDate: newEndDate.toISOString()
            };
            const sessionResult = await _api.getContentHits(appId, newFilter, 0, 50, true, sessionId);
            const newContentHits = [
                ...contentHits
            ];
            for (const event of sessionResult.data){
                var existingHit = newContentHits.find((e)=>isConflictingHit(e, event));
                if (existingHit) {
                    // use hit with last created date
                    if (new Date(existingHit.eventDate).valueOf() > new Date(event.eventDate).valueOf()) continue;
                    else newContentHits.splice(newContentHits.indexOf(existingHit), 1);
                }
                newContentHits.push(event);
            }
            setSessionIds([
                ...sessionIds,
                sessionId
            ]);
            setContentHits(newContentHits);
            return sessionResult;
        } catch  {
            setError("There was an error loading session");
        }
    };
    return {
        loadMoreContentHits,
        sessions,
        loadMoreContentByFeatureType,
        sessionsByFeatureType,
        loadingSessionsByFeatureType,
        loading,
        loadSession,
        moreToLoad,
        moreHitsByFeatureTypeToLoad,
        featureTypeContentHits
    };
}
const SessionAnalyticsContainerOld = (0, _unstatedNext.createContainer)(useSessionAnalyticsContainerOld);
exports.default = SessionAnalyticsContainerOld;

},{"react":"6uln9","unstated-next":"61zE5","../api":"loxM6","../constants/featureTypeIds":"hPLMP","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"mbuTU":[function(require,module,exports) {
module.exports = require("c24dc89a69a0c6e8").getBundleURL("kVLro") + require("78e1cdb4eaa0a71").resolve("aYzau");

},{"c24dc89a69a0c6e8":"c7Tr5","78e1cdb4eaa0a71":"fyJL2"}],"cGpdB":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _extends = require("@babel/runtime/helpers/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _base = require("@emotion/styled/base");
var _baseDefault = parcelHelpers.interopDefault(_base);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _tableCell = require("../../../components/general/TableCell");
var _tableCellDefault = parcelHelpers.interopDefault(_tableCell);
var _colors = require("../../../constants/colors");
var _moment = require("moment");
var _momentDefault = parcelHelpers.interopDefault(_moment);
var _reportTableHeader = require("../../../components/analytics/ReportTableHeader");
var _reportTableHeaderDefault = parcelHelpers.interopDefault(_reportTableHeader);
var _reportTable = require("../../../components/analytics/ReportTable");
var _reportTableDefault = parcelHelpers.interopDefault(_reportTable);
var _extensions = require("../../../models/extensions");
var _analyticsDateFormat = require("../../../models/analytics/AnalyticsDateFormat");
var _totalCard = require("../../../components/charts/TotalCard");
var _totalCardDefault = parcelHelpers.interopDefault(_totalCard);
var _featureTypeIds = require("../../../constants/featureTypeIds");
var _sparkContainer = require("../../../hooks/SparkContainer");
var _sparkContainerDefault = parcelHelpers.interopDefault(_sparkContainer);
var _sessionAnalyticsContainer = require("../../../hooks/SessionAnalyticsContainer");
var _sessionAnalyticsContainerDefault = parcelHelpers.interopDefault(_sessionAnalyticsContainer);
var _telephonyAnalyticsContainer = require("../../../hooks/TelephonyAnalyticsContainer");
var _telephonyAnalyticsContainerDefault = parcelHelpers.interopDefault(_telephonyAnalyticsContainer);
var _loader = require("../../../components/general/Loader");
var _loaderDefault = parcelHelpers.interopDefault(_loader);
var _generativeReportTable = require("../../../components/analytics/GenerativeReportTable");
var _generativeReportTableDefault = parcelHelpers.interopDefault(_generativeReportTable);
var _urls = require("../../../constants/Urls");
var _useIsMobile = require("../../../hooks/UseIsMobile");
var _useIsMobileDefault = parcelHelpers.interopDefault(_useIsMobile);
var _featureFlagIds = require("../../../constants/featureFlagIds");
var _generativeCallReview = require("../../../constants/analyticsConstants/generativeCallReview");
var _useProcessConversationalSuccessEvents = require("../../../hooks/UseProcessConversationalSuccessEvents");
var _graphFilterModal = require("../../../components/analytics/GraphFilterModal");
var _button = require("../../../components/general/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _smallModalLayout = require("../../../components/structure/SmallModalLayout");
var _smallModalLayoutDefault = parcelHelpers.interopDefault(_smallModalLayout);
var _modalHeader = require("../../../components/general/ModalHeader");
var _modalHeaderDefault = parcelHelpers.interopDefault(_modalHeader);
var _convSuccessHistogramContainer = require("../../../components/charts/ConvSuccessHistogramContainer");
var _convSuccessHistogramContainerDefault = parcelHelpers.interopDefault(_convSuccessHistogramContainer);
var _histogramChartCard = require("../../../components/charts/HistogramChartCard");
var _histogramChartCardDefault = parcelHelpers.interopDefault(_histogramChartCard);
var _engagementAnalyticsReporting = require("../../../api/controllers/engagementAnalyticsReporting");
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// Helper to format hours as "Xh Ym" for Staff/Labor Hours Saved display
// Matches format used in DentalSchedulingDashboard
const formatHoursSaved = (hours)=>{
    if (hours === undefined || hours === null) return "0h 0m";
    const wholeHours = Math.floor(hours);
    const minutes = Math.round((hours - wholeHours) * 60);
    if (wholeHours === 0) return `${minutes}m`;
    return `${wholeHours}h ${minutes}m`;
};
const phoneIconBlue = require("e349f22f29cc7073");
const averageIconBlue = require("ded04134fca6b0a2");
const questionIconBlue = require("25f48f082c693b2");
const laborHoursSavedIcon = require("6610327436cd4df9");
const uniqueCallersImage = require("c0f69e594e39fb16");
const callLengthImage = require("84ebaa4cd63f5928");
const orderPlacedIconBlue = require("6d74471367a0cdbf");
const appointmentUpdatesIcon = require("cd09bf28eea729fc");
const convertedCustomersIcon = require("13967107280c5ae1");
const upsellPercentageIcon = require("e95a4b034dbdd59d");
const repeatCustomersIcon = require("88a51cd1e258c1df");
const containedCallsIcon = require("ecca9bb22133cc59");
const ApplicationTopHitsTable = (props)=>{
    const sparkContainer = (0, _sparkContainerDefault.default).useContainer();
    const sessionContainer = (0, _sessionAnalyticsContainerDefault.default).useContainer();
    const telephonyAnalyticsContainer = (0, _telephonyAnalyticsContainerDefault.default).useContainer();
    const [isProcessingReviews, setIsProcessingReviews] = (0, _react1.useState)(false);
    const [uniqueEngagementCount, setUniqueEngagementCount] = (0, _react1.useState)(-1);
    const [convertedCustomers, setConvertedCustomers] = (0, _react1.useState)(-1);
    const [repeatCustomers, setRepeatCustomers] = (0, _react1.useState)(-1);
    const [upsellPercentage, setUpsellPercentage] = (0, _react1.useState)(-1);
    const [totalSold, setTotalSold] = (0, _react1.useState)(0);
    const [averageOrderLength, setAverageOrderLength] = (0, _react1.useState)(0);
    const [bookedAppointmentsEnglish, setBookedAppointmentsEnglish] = (0, _react1.useState)(0);
    const [bookedAppointmentsSpanish, setBookedAppointmentsSpanish] = (0, _react1.useState)(0);
    const [rescheduledAppointmentsEnglish, setRescheduledAppointmentsEnglish] = (0, _react1.useState)(0);
    const [rescheduledAppointmentsSpanish, setRescheduledAppointmentsSpanish] = (0, _react1.useState)(0);
    const [cancelledAppointmentsEnglish, setCancelledAppointmentsEnglish] = (0, _react1.useState)(0);
    const [cancelledAppointmentsSpanish, setCancelledAppointmentsSpanish] = (0, _react1.useState)(0);
    const [checkedEnglish, setCheckedEnglish] = (0, _react1.useState)(0);
    const [checkedSpanish, setCheckedSpanish] = (0, _react1.useState)(0);
    const [hoursSaved, setHoursSaved] = (0, _react1.useState)(0);
    const [loadingTopLevelMetrics, setLoadingTopLevelMetrics] = (0, _react1.useState)(false);
    const [appTopLevelMetrics, setAppTopLevelMetrics] = (0, _react1.useState)(null);
    const [displayGraphModal, setDisplayGraphModal] = (0, _react1.useState)(false);
    const [graphCategories, setGraphCategories] = (0, _react1.useState)([]);
    const [toggledGraphCategories, setToggledGraphCategories] = (0, _react1.useState)([]);
    const [graphTags, setGraphTags] = (0, _react1.useState)([]);
    const [toggledGraphTags, setToggledGraphTags] = (0, _react1.useState)([]);
    const [chart, setChart] = (0, _react1.useState)((0, _react.jsx)((0, _histogramChartCardDefault.default), {
        isLoading: true,
        title: null,
        data: null,
        showPrimary: true,
        showSecondary: false,
        secondaryData: null,
        primaryDataName: "Volume"
    }));
    const [showActionCompletedHistogram, setShowActionCompletedHistogram] = (0, _react1.useState)(false);
    const [actionCompletedHistogram, setActionCompletedHistogram] = (0, _react1.useState)((0, _react.jsx)((0, _histogramChartCardDefault.default), {
        isLoading: true,
        title: null,
        data: null,
        showPrimary: true,
        showSecondary: false,
        secondaryData: null,
        primaryDataName: "Volume"
    }));
    const isMobile = (0, _useIsMobileDefault.default)();
    const conversationalEvents = (0, _react1.useMemo)(()=>telephonyAnalyticsContainer.conversationalSuccessEvents || [], [
        telephonyAnalyticsContainer.conversationalSuccessEvents
    ]);
    const [containedCalls, setContainedCalls] = (0, _react1.useState)(0);
    const [containedCallsPercentage, setContainedCallPercentage] = (0, _react1.useState)(0.0);
    const assistantIndustry = props.application.featureFlags?.some((ff)=>ff.id && (0, _featureFlagIds.FoodOrderingFeatureFlagId).includes(ff.id)) ? "FOOD_ORDERING" : props.application.featureFlags?.some((ff)=>ff.id && (0, _featureFlagIds.HealthcareSchedulingFeatureFlagId).includes(ff.id)) ? "HEALTHCARE" : null;
    const hookOptions = (0, _react1.useMemo)(()=>({
            crossOrgMode: false,
            setConvertedCustomers,
            setRepeatCustomers,
            setUniqueEngagementCount,
            setUpsellPercentage,
            featureFlag: assistantIndustry
        }), [
        setConvertedCustomers,
        setRepeatCustomers,
        setUniqueEngagementCount,
        setUpsellPercentage,
        assistantIndustry
    ]);
    const processedConversationalSuccessEvents = (0, _useProcessConversationalSuccessEvents.useProcessConversationalSuccessEvents)(conversationalEvents, sessionContainer, [], // crossOrgSessionData - not used in this component
    hookOptions);
    const useGenerativeReview = props.application.featureFlags?.some((ff)=>ff.id && (0, _featureFlagIds.GENERATIVE_CALL_REVIEW_FEATURE_FLAG_IDS).includes(ff.id));
    const foodOrderingApp = props.application.featureFlags?.some((ff)=>ff.id && (0, _featureFlagIds.FoodOrderingFeatureFlagId).includes(ff.id));
    const healthcareApp = props.application.featureFlags?.some((ff)=>ff.id && (0, _featureFlagIds.HealthcareSchedulingFeatureFlagId).includes(ff.id));
    const [hasSpanishCalls, setHasSpanishCalls] = (0, _react1.useState)(false);
    // Load generative report data when in Spark mode
    (0, _react1.useEffect)(()=>{
        if (sparkContainer.inSpark && (props.startDate || props.endDate) && useGenerativeReview) {
            const filter = {
                startDate: props.startDate,
                endDate: props.endDate
            };
            sessionContainer.loadSessions(props.applicationId, filter);
            if (healthcareApp) {
                const minDurationSeconds = 10;
                const calculatedDaysBack = props.startDate && props.endDate ? (0, _momentDefault.default)(props.endDate, (0, _analyticsDateFormat.DATE_FORMAT)).diff((0, _momentDefault.default)(props.startDate, (0, _analyticsDateFormat.DATE_FORMAT)), "days") + 1 : null;
                sessionContainer.loadSessionsForReview(props.applicationId, minDurationSeconds, calculatedDaysBack);
            }
            if (healthcareApp || foodOrderingApp) telephonyAnalyticsContainer.loadConversationalSuccessEvents(props.applicationId, filter);
            if (foodOrderingApp && useGenerativeReview) {
                telephonyAnalyticsContainer.loadOrderPlacedEventsPaged(props.applicationId, filter);
                telephonyAnalyticsContainer.loadCallCompleteEventsPaged(props.applicationId, filter);
            }
        }
    }, [
        props.applicationId,
        props.startDate,
        props.endDate,
        sparkContainer.inSpark
    ]);
    (0, _react1.useEffect)(()=>{
        setHasSpanishCalls(processedConversationalSuccessEvents.filter((e)=>e.tags?.includes((0, _generativeCallReview.TAGS).SPANISH)).length > 0);
    }, [
        processedConversationalSuccessEvents
    ]);
    (0, _react1.useEffect)(()=>{
        if (healthcareApp && processedConversationalSuccessEvents) {
            const bookedEnglish = processedConversationalSuccessEvents.reduce((total, event)=>{
                if (event.tags?.includes((0, _generativeCallReview.TAGS).SPANISH) || !event.tags) return total;
                const tagCount = event.tags.filter((tag)=>tag === (0, _generativeCallReview.TAGS).ACTION_COMPLETED).length;
                return total + tagCount;
            }, 0);
            const bookedSpanish = processedConversationalSuccessEvents.reduce((total, event)=>{
                if (!event.tags?.includes((0, _generativeCallReview.TAGS).SPANISH) || !event.tags) return total;
                const tagCount = event.tags.filter((tag)=>tag === (0, _generativeCallReview.TAGS).ACTION_COMPLETED).length;
                return total + tagCount;
            }, 0);
            const rescheduledEnglish = processedConversationalSuccessEvents.reduce((total, event)=>{
                if (event.tags?.includes((0, _generativeCallReview.TAGS).SPANISH) || !event.tags) return total;
                const tagCount = event.tags.filter((tag)=>tag === (0, _generativeCallReview.TAGS).APPOINTMENT_RESCHEDULED).length;
                return total + tagCount;
            }, 0);
            const rescheduledSpanish = processedConversationalSuccessEvents.reduce((total, event)=>{
                if (!event.tags?.includes((0, _generativeCallReview.TAGS).SPANISH) || !event.tags) return total;
                const tagCount = event.tags.filter((tag)=>tag === (0, _generativeCallReview.TAGS).APPOINTMENT_RESCHEDULED).length;
                return total + tagCount;
            }, 0);
            const cancelledEnglish = processedConversationalSuccessEvents.reduce((total, event)=>{
                if (event.tags?.includes((0, _generativeCallReview.TAGS).SPANISH) || !event.tags) return total;
                const tagCount = event.tags.filter((tag)=>tag === (0, _generativeCallReview.TAGS).APPOINTMENT_CANCELLED).length;
                return total + tagCount;
            }, 0);
            const cancelledSpanish = processedConversationalSuccessEvents.reduce((total, event)=>{
                if (!event.tags?.includes((0, _generativeCallReview.TAGS).SPANISH) || !event.tags) return total;
                const tagCount = event.tags.filter((tag)=>tag === (0, _generativeCallReview.TAGS).APPOINTMENT_CANCELLED).length;
                return total + tagCount;
            }, 0);
            const checkedEnglish = processedConversationalSuccessEvents.reduce((total, event)=>{
                if (event.tags?.includes((0, _generativeCallReview.TAGS).SPANISH) || !event.tags) return total;
                const tagCount = event.tags.filter((tag)=>tag === (0, _generativeCallReview.TAGS).CHECK_NEXT_APPOINTMENT_COMPLETE).length;
                return total + tagCount;
            }, 0);
            const checkedSpanish = processedConversationalSuccessEvents.reduce((total, event)=>{
                if (!event.tags?.includes((0, _generativeCallReview.TAGS).SPANISH) || !event.tags) return total;
                const tagCount = event.tags.filter((tag)=>tag === (0, _generativeCallReview.TAGS).CHECK_NEXT_APPOINTMENT_COMPLETE).length;
                return total + tagCount;
            }, 0);
            setBookedAppointmentsEnglish(bookedEnglish);
            setBookedAppointmentsSpanish(bookedSpanish);
            setRescheduledAppointmentsEnglish(rescheduledEnglish);
            setRescheduledAppointmentsSpanish(rescheduledSpanish);
            setCancelledAppointmentsEnglish(cancelledEnglish);
            setCancelledAppointmentsSpanish(cancelledSpanish);
            setCheckedEnglish(checkedEnglish);
            setCheckedSpanish(checkedSpanish);
        }
    }, [
        processedConversationalSuccessEvents,
        healthcareApp,
        props.startDate,
        props.endDate
    ]);
    (0, _react1.useEffect)(()=>{
        if (healthcareApp && processedConversationalSuccessEvents) {
            // Contained calls from ACTION_ATTEMPTED category (managed appointments + unsupported transfers)
            const containedFromActionAttempted = processedConversationalSuccessEvents.filter((event)=>event.category == "ACTION_ATTEMPTED" && event.tags?.includes((0, _generativeCallReview.TAGS).TRANSFERRED) && (event.tags?.includes((0, _generativeCallReview.TAGS).SCHEDULE_ATTEMPTED) || event.tags?.includes((0, _generativeCallReview.TAGS).RESCHEDULE_ATTEMPTED) || event.tags?.includes((0, _generativeCallReview.TAGS).CANCELLATION_ATTEMPTED)) && (event.tags?.includes((0, _generativeCallReview.TAGS).UNSUPPORTED_APPOINTMENT_TYPE) || event.tags?.includes((0, _generativeCallReview.TAGS).UNSUPPORTED_CUSTOMER_REQUEST)) || event.tags?.includes((0, _generativeCallReview.TAGS).CHECK_NEXT_APPOINTMENT_COMPLETE) || event.tags?.includes((0, _generativeCallReview.TAGS).ACTION_COMPLETED) || event.tags?.includes((0, _generativeCallReview.TAGS).APPOINTMENT_RESCHEDULED) || event.tags?.includes((0, _generativeCallReview.TAGS).APPOINTMENT_CANCELLED))?.length ?? 0;
            // Contained calls from QUESTION_ANSWERED category - all are contained regardless of transfer
            const containedFromQuestionAnswered = processedConversationalSuccessEvents.filter((event)=>event.category === "QUESTION_ANSWERED")?.length ?? 0;
            const totalContained = containedFromActionAttempted + containedFromQuestionAnswered;
            setContainedCalls(totalContained);
            // Containable calls = ACTION_ATTEMPTED + QUESTION_ANSWERED
            const actionAttemptedTotal = processedConversationalSuccessEvents.filter((event)=>event.category === "ACTION_ATTEMPTED")?.length ?? 0;
            const questionAnsweredTotal = processedConversationalSuccessEvents.filter((event)=>event.category === "QUESTION_ANSWERED")?.length ?? 0;
            const containableTotal = actionAttemptedTotal + questionAnsweredTotal;
            if (containableTotal <= 0) setContainedCallPercentage("??");
            else {
                const percentage = Math.round(totalContained / containableTotal * 100);
                setContainedCallPercentage(percentage);
            }
        }
    }, [
        processedConversationalSuccessEvents,
        healthcareApp,
        props.startDate,
        props.endDate
    ]);
    // Load top level metrics from API for Staff/Labor Hours Saved calculation
    (0, _react1.useEffect)(()=>{
        if (sparkContainer.inSpark && (props.startDate || props.endDate) && useGenerativeReview && (healthcareApp || foodOrderingApp)) {
            const loadMetrics = async ()=>{
                setLoadingTopLevelMetrics(true);
                const filter = {
                    startDate: props.startDate,
                    endDate: props.endDate
                };
                const result = await (0, _engagementAnalyticsReporting.getTopLevelMetrics)(props.applicationId, filter);
                setLoadingTopLevelMetrics(false);
                if (result.resultType === "Ok") setAppTopLevelMetrics(result.data);
            };
            loadMetrics();
        }
    }, [
        props.applicationId,
        props.startDate,
        props.endDate,
        sparkContainer.inSpark,
        useGenerativeReview,
        healthcareApp,
        foodOrderingApp
    ]);
    // Calculate hours saved from API's laborMinutesSaved
    (0, _react1.useEffect)(()=>{
        if (appTopLevelMetrics?.laborMinutesSaved !== undefined && appTopLevelMetrics?.laborMinutesSaved !== null) {
            // Convert minutes to hours
            const hours = appTopLevelMetrics.laborMinutesSaved / 60;
            setHoursSaved(hours);
        }
    }, [
        appTopLevelMetrics
    ]);
    // Calculate total sold from order placed events (food ordering specific metrics)
    (0, _react1.useEffect)(()=>{
        if (foodOrderingApp && telephonyAnalyticsContainer.orderPlacedEvents?.length && telephonyAnalyticsContainer.callCompleteEvents?.length) {
            if (telephonyAnalyticsContainer.orderPlacedEvents) {
                const calculatedTotal = telephonyAnalyticsContainer.orderPlacedEvents.reduce((acc, event)=>acc + (event.total || 0), 0);
                setTotalSold(calculatedTotal);
            }
            // get all call complete events that have a sessionId in the orderPlacedEvents
            const orderPlacedCompleteEvents = telephonyAnalyticsContainer.callCompleteEvents.filter((event)=>telephonyAnalyticsContainer.orderPlacedEvents.some((orderEvent)=>orderEvent.sessionId === event.sessionId));
            // add up duration property for all seconds
            const totalDuration = orderPlacedCompleteEvents.reduce((acc, event)=>acc + (event.duration || 0), 0);
            const avgOrder = totalDuration / (orderPlacedCompleteEvents.length || 1);
            setAverageOrderLength(avgOrder);
        }
    }, [
        telephonyAnalyticsContainer.orderPlacedEvents,
        telephonyAnalyticsContainer.callCompleteEvents
    ]);
    (0, _react1.useEffect)(()=>{
        setChart((0, _react.jsx)((0, _histogramChartCardDefault.default), {
            isLoading: true,
            title: null,
            data: null,
            showPrimary: true,
            showSecondary: false,
            secondaryData: null,
            primaryDataName: "Volume"
        }));
        let cancelled = false;
        (async ()=>{
            const node = await renderGraph(graphCategories, graphTags, true);
            if (!cancelled) setChart(node);
        })();
        return ()=>{
            cancelled = true;
        };
    }, [
        graphCategories,
        graphTags,
        props.startDate,
        props.endDate
    ]);
    (0, _react1.useEffect)(()=>{
        (async ()=>{
            const actionCompletedNode = await renderGraph([
                "ACTION_ATTEMPTED"
            ], [
                "ACTION_COMPLETED"
            ], false);
            setActionCompletedHistogram(actionCompletedNode);
        })();
    }, [
        props.applicationId,
        props.startDate,
        props.endDate,
        sparkContainer.inSpark
    ]);
    const toggleGraphTag = (tag)=>{
        setToggledGraphTags((prev)=>prev.includes(tag) ? prev.filter((t)=>t !== tag) : [
                ...prev,
                tag
            ]);
    };
    const toggleGraphCategories = (cat)=>{
        setToggledGraphCategories((prev)=>prev.includes(cat) ? prev.filter((c)=>c !== cat) : [
                ...prev,
                cat
            ]);
    };
    const GraphFilterButton = ()=>{
        return (0, _react.jsx)(GraphButtonDiv, null, (0, _react.jsx)(GraphButton, {
            onClick: ()=>setDisplayGraphModal(true),
            themes: [
                "primary"
            ],
            text: "Customize"
        }));
    };
    const HistogramGraph = ({ includeButton, categories, tags, featureFlagId, applicationId, startDate, endDate, onOpenFilters })=>{
        const { title, mappedData, setParams } = (0, _convSuccessHistogramContainerDefault.default).useContainer();
        // Keep the container params in sync with the props passed to this component
        (0, _reactDefault.default).useEffect(()=>{
            setParams((p)=>({
                    ...p,
                    applicationId,
                    startDate,
                    endDate,
                    categories,
                    tags,
                    featureFlagId
                }));
        }, [
            applicationId,
            startDate,
            endDate,
            categories,
            tags,
            featureFlagId,
            setParams
        ]);
        return (0, _react.jsx)((0, _histogramChartCardDefault.default), {
            isLoading: false,
            title: title,
            data: mappedData,
            showPrimary: true,
            showSecondary: false,
            secondaryData: null,
            primaryDataName: "Volume",
            filterButton: includeButton ? GraphFilterButton() : undefined,
            titleMargin: {
                top: 16,
                right: 0,
                bottom: 0,
                left: 0
            },
            titlePadding: {
                top: 0,
                right: 0,
                bottom: 0,
                left: 26
            },
            graphPadding: 4,
            graphBottomPadding: 4,
            titleStyle: histogramTitleStyle
        });
    };
    const renderGraph = async (categories, tags, includeButton)=>{
        return (0, _react.jsx)((0, _convSuccessHistogramContainerDefault.default).Provider, {
            initialState: {
                applicationId: props.applicationId,
                startDate: props.startDate,
                // local naive is fine; container converts to UTC
                endDate: props.endDate,
                categories: categories,
                tags: tags,
                featureFlagId: assistantIndustry
            }
        }, (0, _react.jsx)(HistogramGraph, {
            includeButton: includeButton,
            categories: categories,
            tags: tags,
            featureFlagId: assistantIndustry,
            applicationId: props.applicationId,
            startDate: props.startDate,
            endDate: props.endDate,
            onOpenFilters: ()=>setDisplayGraphModal(true)
        }));
    };
    const sparkMobileColumns = [
        {
            id: "topicInquired",
            Header: (0, _react.jsx)((0, _reportTableHeaderDefault.default), {
                title: "Topic Inquired",
                showPercentage: false,
                showValue: false
            }),
            accessor: (item)=>item,
            Cell: (row)=>(0, _react.jsx)((0, _tableCellDefault.default), null, (0, _react.jsx)("img", {
                    className: "feature-type-icon",
                    src: (0, _extensions.getSmallFeatureTypeIcon)(row.value.featureTypeId == null || row.value.featureTypeId == "null" ? (0, _featureTypeIds.FallbackFeatureTypeId) : row.value.featureTypeId)
                }), (0, _react.jsx)("p", {
                    className: "ac-analytics-report-content-item"
                }, row.value.title ?? "Deleted Topic"))
        },
        {
            id: "transcripts",
            Header: (0, _react.jsx)((0, _reportTableHeaderDefault.default), {
                title: "# Transcripts",
                showValue: false,
                showPercentage: false
            }),
            accessor: (item)=>item,
            Cell: (row)=>{
                let baseUrl;
                sparkContainer.inSpark ? baseUrl = (0, _urls.getSparkBaseUrl)() : baseUrl = (0, _urls.getBaseUrl)();
                return (0, _react.jsx)((0, _tableCellDefault.default), null, (0, _react.jsx)("a", {
                    style: {
                        color: (0, _colors.color_text_link)
                    },
                    href: `${baseUrl}/v/apps/${props.applicationId}/analytics/sessions?contentId=${row.value.contentId}&startDate=${props.startDate}&endDate=${props.endDate}`,
                    target: "_blank"
                }, "Transcript", row.value.sessionCount > 1 ? "s" : "", " (", row.value.sessionCount, ")"));
            }
        }
    ];
    const sparkColumns = [
        {
            id: "topicInquired",
            Header: (0, _react.jsx)((0, _reportTableHeaderDefault.default), {
                title: "Topic Inquired",
                showPercentage: false,
                showValue: false
            }),
            accessor: (item)=>item,
            Cell: (row)=>(0, _react.jsx)((0, _tableCellDefault.default), null, (0, _react.jsx)("img", {
                    className: "feature-type-icon",
                    src: (0, _extensions.getSmallFeatureTypeIcon)(row.value.featureTypeId == null || row.value.featureTypeId == "null" ? (0, _featureTypeIds.FallbackFeatureTypeId) : row.value.featureTypeId)
                }), (0, _react.jsx)("p", {
                    className: "ac-analytics-report-content-item"
                }, row.value.title ?? "Deleted Topic"))
        },
        {
            id: "callerCount",
            Header: (0, _react.jsx)((0, _reportTableHeaderDefault.default), {
                title: "Unique Callers",
                showValue: false,
                showPercentage: false
            }),
            accessor: (item)=>item.userCount,
            Cell: (row)=>(0, _react.jsx)((0, _tableCellDefault.default), null, row.value)
        },
        {
            id: "transcripts",
            Header: (0, _react.jsx)((0, _reportTableHeaderDefault.default), {
                title: "# Transcripts",
                showValue: false,
                showPercentage: false
            }),
            accessor: (item)=>item,
            Cell: (row)=>{
                let baseUrl;
                sparkContainer.inSpark ? baseUrl = (0, _urls.getSparkBaseUrl)() : baseUrl = (0, _urls.getBaseUrl)();
                return (0, _react.jsx)((0, _tableCellDefault.default), null, (0, _react.jsx)(StyledLink, {
                    href: `${baseUrl}/v/apps/${props.applicationId}/analytics/sessions?contentId=${row.value.contentId}&startDate=${props.startDate}&endDate=${props.endDate}`,
                    target: "_blank"
                }, "Transcript", row.value.sessionCount > 1 ? "s" : "", " (", row.value.sessionCount, ")"));
            }
        }
    ];
    const deltaUsers = (props.totals?.totalUsers ?? 0) - (props.previousTotals?.totalUsers ?? 0);
    const deltaNewUsers = (props.totals?.totalNewUsers ?? 0) - (props.previousTotals?.totalNewUsers ?? 0);
    const deltaSessions = (props.totals?.totalSessions ?? 0) - (props.previousTotals?.totalSessions ?? 0);
    const deltaRequests = (props.filteredInteractionsCount ?? 0) - (props.previousTotals?.totalRequests ?? 0);
    const deltaInteractions = (props.filteredInteractionsCount ?? 0) - (props.previousInteractionsCount ?? 0);
    const deltaMinutes = (props.totals?.totalMinutes ?? 0) - (props.previousTotals?.totalMinutes ?? 0);
    const deltaNumberOfCaller = (props.totals?.totalUsers ?? 0) - (props.previousTotals?.totalUsers ?? 0);
    const timeframeLabel = `${(0, _momentDefault.default)(props.startDate, (0, _analyticsDateFormat.DATE_FORMAT)).format("MMM DD, YYYY")} - ${(0, _momentDefault.default)(props.endDate, (0, _analyticsDateFormat.DATE_FORMAT)).format("MMM DD, YYYY")}`;
    const filter = {
        startDate: props.startDate,
        endDate: props.endDate
    };
    const numberOfDays = (0, _momentDefault.default)(props.endDate, (0, _analyticsDateFormat.DATE_FORMAT)).diff((0, _momentDefault.default)(props.startDate, (0, _analyticsDateFormat.DATE_FORMAT)), "days") + 1;
    // Spark: average calls per day
    const previousNumberOfDays = (0, _momentDefault.default)(props.previousDates.endDate, (0, _analyticsDateFormat.DATE_FORMAT)).diff((0, _momentDefault.default)(props.previousDates.startDate, (0, _analyticsDateFormat.DATE_FORMAT)), "days") + 1;
    const averageCallsPerDay = Math.round((props.totals?.totalSessions ?? 0) / numberOfDays);
    const previousAverageCallsPerDay = Math.round((props.previousTotals?.totalSessions ?? 0) / previousNumberOfDays);
    const deltaAverageCallsPerDay = averageCallsPerDay - previousAverageCallsPerDay;
    // Spark: average call length
    const averageCallLength = (props.totals?.totalMinutes ?? 0) / (props.totals?.totalSessions ?? 0);
    const previousAverageCallLength = (props.previousTotals?.totalSessions ?? 0) / (props.previousTotals?.totalMinutes ?? 0);
    const deltaAverageCallLength = averageCallLength - previousAverageCallLength;
    // Spark: average topic inquiries per call
    const averageTopicInquiriesPerCall = (props.filteredInteractionsCount ?? 0) / (props.totals?.totalSessions ?? 1) || 0;
    const previousAverageTopicInquiriesPerCall = (props.previousTotals?.totalRequests ?? 0) / (props.previousTotals?.totalSessions ?? 1) || 0;
    const deltaAverageTopicInquiriesPerCall = (props.previousTotals?.totalSessions ?? 0) === 0 ? 0 : averageTopicInquiriesPerCall - previousAverageTopicInquiriesPerCall;
    const deltaAverageTopicInquiriesPerCallPercentage = previousAverageTopicInquiriesPerCall > 0 ? Math.round(deltaAverageTopicInquiriesPerCall / previousAverageTopicInquiriesPerCall * 100) : 0;
    const getExportableData = ()=>{
        const rows = [];
        rows.push([
            `"${timeframeLabel}"`,
            `Total Users: ${props.totals?.totalUsers ?? 0}`,
            `Total New Users: ${props.totals?.totalNewUsers ?? 0}`,
            `Total Sessions: ${props?.totals?.totalSessions ?? 0}`,
            `Total Interactions: ${props.totals?.totalSessions ?? 0}`
        ]);
        rows.push([]);
        rows.push([
            "Item name",
            "Users",
            "New Users",
            "Sessions",
            "Interactions"
        ]);
        props.data.items.forEach((item)=>{
            rows.push([
                item.title,
                item.userCount,
                item.newUserCount,
                item.sessionCount,
                item.count
            ]);
        });
        return rows;
    };
    const columns = [
        {
            id: "title",
            Header: (0, _react.jsx)((0, _reportTableHeaderDefault.default), {
                title: "Conversation Item",
                showPercentage: false,
                showValue: false
            }),
            accessor: (item)=>item,
            Cell: (row)=>(0, _react.jsx)((0, _tableCellDefault.default), null, (0, _react.jsx)("img", {
                    className: "feature-type-icon",
                    src: (0, _extensions.getSmallFeatureTypeIcon)(row.value.featureTypeId == null || row.value.featureTypeId == "null" ? (0, _featureTypeIds.FallbackFeatureTypeId) : row.value.featureTypeId)
                }), (0, _react.jsx)("a", {
                    className: "ac-analytics-report-content-item",
                    href: (0, _extensions.getEditUrl)(row.value.contentId, row.value.applicationFeatureId, row.value.featureTypeId == null || row.value.featureTypeId == "null" ? (0, _featureTypeIds.FallbackFeatureTypeId) : row.value.featureTypeId) + "analytics" + window.location.search,
                    target: "_blank"
                }, row.value.title ?? "No Title"))
        },
        {
            id: "userCount",
            Header: (0, _react.jsx)((0, _reportTableHeaderDefault.default), {
                title: "Users",
                showValue: false,
                showPercentage: false
            }),
            accessor: (item)=>item.userCount,
            Cell: (row)=>(0, _react.jsx)((0, _tableCellDefault.default), null, row.value)
        },
        {
            id: "newUserCount",
            Header: (0, _react.jsx)((0, _reportTableHeaderDefault.default), {
                title: "New Users",
                showValue: false,
                showPercentage: false
            }),
            accessor: (item)=>item.newUserCount,
            Cell: (row)=>(0, _react.jsx)((0, _tableCellDefault.default), null, row.value)
        },
        {
            id: "sessionCount",
            Header: (0, _react.jsx)((0, _reportTableHeaderDefault.default), {
                title: "Sessions",
                showValue: false,
                showPercentage: false
            }),
            accessor: (item)=>item.sessionCount,
            Cell: (row)=>(0, _react.jsx)((0, _tableCellDefault.default), null, row.value)
        },
        {
            id: "count",
            Header: (0, _react.jsx)((0, _reportTableHeaderDefault.default), {
                title: "Interactions",
                showValue: false,
                showPercentage: false
            }),
            accessor: (item)=>item.count,
            Cell: (row)=>(0, _react.jsx)((0, _tableCellDefault.default), null, row.value)
        }
    ];
    function everythingIsLoading() {
        if (sparkContainer.inSpark) {
            if (!useGenerativeReview) telephonyAnalyticsContainer.setLoading(false); // don't need this for loading indicator
            // In Spark mode, check for generative report loading as well
            return !Object.values(props.isLoading).includes(false) || sessionContainer.loading || telephonyAnalyticsContainer.loading || isProcessingReviews;
        }
        return !Object.values(props.isLoading).includes(false);
    }
    const items = props.data?.items?.filter((i)=>i.featureTypeId && !i.featureTypeId?.startsWith("response"));
    function renderTable() {
        if (props.isLoading.contentHits) return (0, _react.jsx)("div", {
            className: "loader-container"
        }, (0, _react.jsx)((0, _loaderDefault.default), null));
        if (sparkContainer.inSpark) {
            if (useGenerativeReview) return (0, _react.jsx)((0, _generativeReportTableDefault.default), {
                applicationId: props.applicationId,
                filter: filter,
                application: props.application,
                sessionContainer: sessionContainer,
                setUniqueEngagementCount: setUniqueEngagementCount,
                setConvertedCustomers: setConvertedCustomers,
                orderPlacedEvents: telephonyAnalyticsContainer.orderPlacedEvents,
                orderingAnalyticsContainer: telephonyAnalyticsContainer,
                onProcessingChange: setIsProcessingReviews,
                setUpsellPercentage: setUpsellPercentage,
                setRepeatCustomers: setRepeatCustomers
            });
            else {
                const sparkItems = props.data?.items?.filter((i)=>!(0, _featureTypeIds.SPARK_EXCLUDED_FEATURE_TYPE_IDS).includes(i.featureTypeId));
                return (0, _react.jsx)((0, _reportTableDefault.default), {
                    className: containerStyle,
                    columns: isMobile ? sparkMobileColumns : sparkColumns,
                    data: sparkItems,
                    showPagination: false,
                    getExportableData: getExportableData,
                    exportName: `${props.startDate}-${props.endDate}_ContentHits`
                });
            }
        }
        return (0, _react.jsx)((0, _reportTableDefault.default), {
            className: containerStyle,
            columns: columns,
            data: items,
            showPagination: false,
            getExportableData: getExportableData,
            exportName: `${props.startDate}-${props.endDate}_ContentHits`
        });
    }
    const formatNumber = (num)=>{
        if (num === undefined) return;
        return num.toLocaleString(undefined, {
            maximumFractionDigits: 2
        });
    };
    const formatSecondsToMinutes = (s)=>{
        if (s === undefined) return;
        // turn 123 seconds into 2 minutes and 3 seconds 61 into one minute and 1 second
        const minutes = Math.floor(s / 60);
        const seconds = Math.round(s % 60);
        if (minutes === 0) return `${seconds} seconds`;
        return `${minutes} minute${minutes > 1 ? "s" : ""} ${seconds} second${seconds > 1 ? "s" : ""}`;
    };
    const formatDollarsAndCents = (num)=>{
        return num.toLocaleString(undefined, {
            style: "currency",
            currency: "USD",
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        });
    };
    const formatSeconds = (seconds)=>{
        if (seconds === undefined) return;
        return Math.round(seconds);
    };
    const formatHoursAndMinutes = (hours)=>{
        // convert hour with decimal to minutes with colon
        if (hours === undefined) return;
        const wholeHours = Math.floor(hours);
        const minutes = Math.round((hours - wholeHours) * 60);
        if (wholeHours === 0) return `${minutes} minutes`;
        return `${wholeHours} hour${wholeHours > 1 ? "s" : ""} ${minutes} minute${minutes > 1 ? "s" : ""}`;
    };
    // Use the compact format for Staff/Labor Hours Saved tiles
    const formattedHoursSaved = formatHoursSaved(hoursSaved);
    const formatEngagementsWithCalls = (engagements)=>{
        if (engagements === undefined || engagements < 0) return "?";
        const totalCalls = props.totals?.totalSessions || 0;
        return `${engagements} in ${totalCalls} call${totalCalls !== 1 ? "s" : ""}`;
    };
    const getActionCompletedValue = ()=>{
        if (foodOrderingApp) return telephonyAnalyticsContainer.orderPlacedEvents?.length > -1 ? telephonyAnalyticsContainer.orderPlacedEvents?.length : "?";
        else if (healthcareApp) {
            const actionCompleted = bookedAppointmentsEnglish + bookedAppointmentsSpanish + rescheduledAppointmentsEnglish + rescheduledAppointmentsSpanish + cancelledAppointmentsEnglish + cancelledAppointmentsSpanish + checkedEnglish + checkedSpanish;
            return actionCompleted > -1 ? actionCompleted : "?";
        }
    };
    const getActionCompletedSubValues = (subValueNumber)=>{
        if (foodOrderingApp) {
            if (subValueNumber === 1) return (0, _react.jsx)((0, _reactDefault.default).Fragment, null, "Total sold: ", (0, _react.jsx)(BoldValueSpan, null, formatDollarsAndCents(totalSold)));
            else if (subValueNumber === 2) return (0, _react.jsx)((0, _reactDefault.default).Fragment, null, "Average ticket size: ", (0, _react.jsx)(BoldValueSpan, null, formatDollarsAndCents(totalSold / (telephonyAnalyticsContainer.orderPlacedEvents?.length > 0 ? telephonyAnalyticsContainer.orderPlacedEvents?.length : 1))));
            else if (subValueNumber === 3) return (0, _react.jsx)((0, _reactDefault.default).Fragment, null, "Average order length: ", averageOrderLength > 60 ? `${formatSecondsToMinutes(averageOrderLength)}` : `${formatNumber(formatSeconds(averageOrderLength))} seconds`);
        } else if (healthcareApp) {
            if (subValueNumber === 1) return (0, _react.jsx)((0, _reactDefault.default).Fragment, null, (0, _react.jsx)(BoldValueSpan, null, bookedAppointmentsEnglish > -1 ? bookedAppointmentsEnglish : "?"));
            else if (subValueNumber === 2) return (0, _react.jsx)((0, _reactDefault.default).Fragment, null, (0, _react.jsx)(BoldValueSpan, null, rescheduledAppointmentsEnglish > -1 ? rescheduledAppointmentsEnglish : "?"));
            else if (subValueNumber === 3) return (0, _react.jsx)((0, _reactDefault.default).Fragment, null, (0, _react.jsx)(BoldValueSpan, null, cancelledAppointmentsEnglish > -1 ? cancelledAppointmentsEnglish : "?"));
            else if (subValueNumber === 4) return (0, _react.jsx)((0, _reactDefault.default).Fragment, null, (0, _react.jsx)(BoldValueSpan, null, checkedEnglish > -1 ? checkedEnglish : "?"));
        }
        return null;
    };
    const getActionCompletedSubValuesSpanish = (subValueNumber)=>{
        if (foodOrderingApp) {
            if (subValueNumber === 1) return (0, _react.jsx)((0, _reactDefault.default).Fragment, null, "Total sold: ", (0, _react.jsx)(BoldValueSpan, null, formatDollarsAndCents(totalSold)));
            else if (subValueNumber === 2) return (0, _react.jsx)((0, _reactDefault.default).Fragment, null, "Average ticket size: ", (0, _react.jsx)(BoldValueSpan, null, formatDollarsAndCents(totalSold / (telephonyAnalyticsContainer.orderPlacedEvents?.length > 0 ? telephonyAnalyticsContainer.orderPlacedEvents?.length : 1))));
            else if (subValueNumber === 3) return (0, _react.jsx)((0, _reactDefault.default).Fragment, null, "Average order length: ", averageOrderLength > 60 ? `${formatSecondsToMinutes(averageOrderLength)}` : `${formatNumber(formatSeconds(averageOrderLength))} seconds`);
        } else if (healthcareApp) {
            if (subValueNumber === 1) return (0, _react.jsx)((0, _reactDefault.default).Fragment, null, (0, _react.jsx)(BoldValueSpan, null, bookedAppointmentsSpanish > -1 ? bookedAppointmentsSpanish : "?"));
            else if (subValueNumber === 2) return (0, _react.jsx)((0, _reactDefault.default).Fragment, null, (0, _react.jsx)(BoldValueSpan, null, rescheduledAppointmentsSpanish > -1 ? rescheduledAppointmentsSpanish : "?"));
            else if (subValueNumber === 3) return (0, _react.jsx)((0, _reactDefault.default).Fragment, null, (0, _react.jsx)(BoldValueSpan, null, cancelledAppointmentsSpanish > -1 ? cancelledAppointmentsSpanish : "?"));
            else if (subValueNumber === 4) return (0, _react.jsx)((0, _reactDefault.default).Fragment, null, (0, _react.jsx)(BoldValueSpan, null, checkedSpanish > -1 ? checkedSpanish : "?"));
        }
        return null;
    };
    const getTooltip = (title)=>{
        if (foodOrderingApp) switch(title){
            case "Engagements":
                return "Calls under 10 minutes apart from the same customer are grouped as one engagement.";
            case "Orders Placed":
                return "Total number of orders placed with the assistant during this timeframe.";
            case "Repeat Customers":
                return "Customers that placed multiple orders with the assistant during this timeframe.";
            case "Converted Customers":
                return "Customers that placed an order after earlier transferring to the store.";
            case "Upsell Percentage":
                return "Out of calls where we attempted an upsell, the percentage of those that were successful.";
            case "Labor Hours Saved":
                return "Amount of time the assistant spent taking placed orders.";
        }
        else if (healthcareApp) switch(title){
            case "Engagements":
                return "Calls under 10 minutes apart from the same customer are grouped as one engagement.";
            case "Appointment Updates":
                return "Total number of Appointment Updates with the assistant during this timeframe.";
            case "Repeat Customers":
                return "Patients that booked multiple appointments with the assistant during this timeframe.";
            case "Converted Customers":
                return "Patients that made an appointment update after earlier transferring to the office.";
            case "Labor Hours Saved":
            case "Staff Hours Saved":
                return "Amount of time the assistant spent scheduling appointments.";
            case "Average Call Length":
                return "";
            case "Call Containment":
                return "Calls that were either fielded successfully or transferred due to an unsupported request.";
        }
    };
    const getSubValue = (title)=>{
        if (foodOrderingApp) switch(title){
            case "Engagements":
                return "Calls under 10 minutes apart from the same customer are grouped as one engagement.";
            case "Repeat Customers":
                return "Customers that placed multiple orders with the assistant during this timeframe.";
            case "Converted Customers":
                return "Customers that initially requested staff but ultimately ordered with the assistant.";
            case "Upsell Percentage":
                return "of attempted upsells were successful!";
            case "Labor Hours Saved":
                return "Ordering time the assistant took off your team’s plate.";
        }
        else if (healthcareApp) switch(title){
            case "Engagements":
                return "Calls under 10 minutes apart from the same customer are grouped as one engagement.";
            // return `in ${props.totals?.totalSessions || 0} calls`;
            case "Repeat Customers":
                return "Patients that booked multiple appointments with the assistant during this timeframe.";
            case "Converted Customers":
                return "Patients that initially requested staff but ultimately booked with the assistant.";
            case "Labor Hours Saved":
            case "Staff Hours Saved":
                return "Time the assistant saved your receptionists.";
            case "Average Call Length":
                return "Average length of calls handled by the assistant.";
        }
    };
    const getIcon = (title)=>{
        if (foodOrderingApp) switch(title){
            case "Engagements":
                return phoneIconBlue;
            case "Orders Placed":
                return orderPlacedIconBlue;
            case "Repeat Customers":
                return repeatCustomersIcon;
            case "Converted Customers":
                return convertedCustomersIcon;
            case "Upsell Percentage":
                return upsellPercentageIcon;
            case "Labor Hours Saved":
                return laborHoursSavedIcon;
        }
        else if (healthcareApp) switch(title){
            case "Engagements":
                return phoneIconBlue;
            case "Appointment Updates":
                return appointmentUpdatesIcon;
            case "Appointments Managed":
                return null;
            case "Repeat Customers":
                return repeatCustomersIcon;
            case "Converted Customers":
                return convertedCustomersIcon;
            case "Labor Hours Saved":
            case "Staff Hours Saved":
                return laborHoursSavedIcon;
        }
    };
    const actionCompletedTitle = foodOrderingApp ? "Orders Placed" : "Appointments Managed";
    const hoursSavedTitle = healthcareApp ? "Staff Hours Saved" : "Labor Hours Saved";
    const renderGenerativeReviewCards = ()=>{
        return(// healthcareApp ? (
        (0, _react.jsx)(StyledTopMetricsContainer, null, (0, _react.jsx)(TopCardsContainer, null, (0, _react.jsx)(StyledTopCard, (0, _extendsDefault.default)({
            title: actionCompletedTitle,
            value: getActionCompletedValue(),
            deltaValue: null,
            deltaPercentage: null,
            showValue: false,
            showPercentage: false,
            hasSpanishCalls: hasSpanishCalls,
            isActionCompleteHealthCareCard: healthcareApp,
            subValue: getActionCompletedSubValues(1),
            subValue2: getActionCompletedSubValues(2),
            subValue3: getActionCompletedSubValues(3),
            subValue4: getActionCompletedSubValues(4)
        }, hasSpanishCalls && {
            subValueSpanish: getActionCompletedSubValuesSpanish(1),
            subValue2Spanish: getActionCompletedSubValuesSpanish(2),
            subValue3Spanish: getActionCompletedSubValuesSpanish(3),
            subValue4Spanish: getActionCompletedSubValuesSpanish(4)
        }, {
            icon: getIcon(actionCompletedTitle)
        })), foodOrderingApp && (0, _react.jsx)(StyledTopCard, {
            title: "Upsell Percentage",
            value: upsellPercentage > -1 ? `${Math.round(upsellPercentage * 10) / 10}%` : "?",
            deltaValue: null,
            deltaPercentage: null,
            showValue: false,
            tooltipMaxWidth: 200,
            subValue: getSubValue("Upsell Percentage"),
            tooltip: getTooltip("Upsell Percentage"),
            showPercentage: false,
            icon: getIcon("Upsell Percentage")
        }), (0, _react.jsx)(StyledTopCard, {
            title: "Average Call Length",
            value: formatHoursAndMinutes(averageCallLength / 60 || 0),
            showValue: props.showValue,
            showPercentage: props.showPercentage,
            subValue: getSubValue("Average Call Length"),
            tooltip: getTooltip("Average Call Length"),
            icon: callLengthImage
        }), healthcareApp && (0, _react.jsx)(StyledTopCard, {
            title: "Contained Conversations",
            value: `${containedCalls} (${containedCallsPercentage}%)`,
            showValue: props.showValue,
            showPercentage: props.showPercentage,
            subValue: getTooltip("Call Containment"),
            tooltip: "",
            icon: containedCallsIcon
        }), (0, _react.jsx)(StyledTopCard, {
            title: hoursSavedTitle,
            value: loadingTopLevelMetrics ? "..." : formattedHoursSaved,
            showValue: false,
            showPercentage: false,
            subValue: getSubValue(hoursSavedTitle),
            icon: getIcon(hoursSavedTitle),
            tooltipMaxWidth: 200,
            tooltip: getTooltip(hoursSavedTitle)
        }), (0, _react.jsx)(StyledTopCard, {
            title: "Engagements",
            value: formatEngagementsWithCalls(uniqueEngagementCount),
            deltaValue: null,
            deltaPercentage: null,
            showValue: false,
            showPercentage: false,
            icon: getIcon("Engagements"),
            tooltipMaxWidth: 200,
            tooltip: getTooltip("Engagements"),
            subValue: getSubValue("Engagements")
        })), (0, _react.jsx)(BottomSection, null, (0, _react.jsx)(LeftCardsContainer, null, (0, _react.jsx)(StyledLeftCard, {
            title: healthcareApp ? "Repeat Patients" : "Repeat Customers",
            tooltipMaxWidth: 200,
            tooltip: getTooltip("Repeat Customers"),
            subValue: getSubValue("Repeat Customers"),
            value: repeatCustomers > -1 ? repeatCustomers : "?",
            deltaValue: null,
            deltaPercentage: null,
            showValue: false,
            showPercentage: false,
            icon: getIcon("Repeat Customers")
        }), (0, _react.jsx)(StyledBottomLeftCard, {
            title: healthcareApp ? "Converted Patients" : "Converted Customers",
            tooltipMaxWidth: 200,
            tooltip: getTooltip("Converted Customers"),
            value: convertedCustomers > -1 ? convertedCustomers : "?",
            subValue: getSubValue("Converted Customers"),
            deltaValue: null,
            deltaPercentage: null,
            showValue: false,
            showPercentage: false,
            icon: getIcon("Converted Customers")
        })), (0, _react.jsx)(ChartContainer, null, (0, _react.jsx)(StyledGraphDiv, null, chart)))));
    };
    return (0, _react.jsx)("div", {
        className: wrapperStyle
    }, everythingIsLoading() || !sparkContainer.inSpark && !props.data ? (0, _react.jsx)("div", {
        className: "loader-container"
    }, (0, _react.jsx)((0, _loaderDefault.default), null)) : (0, _react.jsx)((0, _reactDefault.default).Fragment, null, !sparkContainer.inSpark && (0, _react.jsx)("h3", null, "App Summary"), (0, _react.jsx)(TotalsWrapper, null, sparkContainer.inSpark ? (foodOrderingApp || healthcareApp) && useGenerativeReview ? renderGenerativeReviewCards() : (0, _react.jsx)((0, _reactDefault.default).Fragment, null, (0, _react.jsx)(StyledTotalCard, {
        title: "Calls",
        value: props.totals?.totalSessions,
        deltaValue: deltaSessions,
        deltaPercentage: Math.round(deltaSessions / (props.previousTotals?.totalSessions > 0 ? props.previousTotals?.totalSessions : 1) * 100),
        showValue: props.showValue,
        showPercentage: props.showPercentage,
        icon: phoneIconBlue
    }), (0, _react.jsx)(StyledTotalCard, {
        title: "Average Call Length",
        value: formatNumber(averageCallLength || 0),
        deltaValue: parseFloat(formatNumber(deltaAverageCallLength || 0)),
        deltaPercentage: Math.round(deltaAverageCallLength / (previousAverageCallLength > 0 ? previousAverageCallLength : 1) * 100),
        showValue: props.showValue,
        showPercentage: props.showPercentage,
        icon: callLengthImage
    }), (0, _react.jsx)(StyledTotalCard, {
        title: "Hours Saved",
        value: Math.round((props.totals?.totalMinutes ?? 0) / 60 * 100) / 100,
        showValue: false,
        showPercentage: false,
        icon: laborHoursSavedIcon
    }), (0, _react.jsx)(StyledTotalCard, {
        title: "Unique Callers",
        value: props.totals?.totalUsers,
        deltaValue: Math.round(deltaNumberOfCaller),
        deltaPercentage: Math.round(deltaNumberOfCaller / (props.previousTotals?.totalUsers > 0 ? props.previousTotals?.totalUsers : 1) * 100),
        showValue: props.showValue,
        showPercentage: props.showPercentage,
        icon: uniqueCallersImage
    }), (0, _react.jsx)(StyledTotalCard, {
        title: "Average Calls per Day",
        value: averageCallsPerDay,
        deltaValue: deltaAverageCallsPerDay,
        deltaPercentage: Math.round(deltaAverageCallsPerDay / (previousAverageCallsPerDay > 0 ? previousAverageCallsPerDay : 1) * 100),
        showValue: props.showValue,
        showPercentage: props.showPercentage,
        icon: averageIconBlue,
        secondIcon: phoneIconBlue
    }), !useGenerativeReview ? (0, _react.jsx)(StyledTotalCard, {
        title: "Total Topic Inquiries",
        value: props.filteredInteractionsCount,
        deltaValue: deltaInteractions,
        deltaPercentage: Math.round(deltaInteractions / props.filteredInteractionsCount * 100),
        showValue: props.showValue,
        showPercentage: props.showPercentage,
        icon: questionIconBlue
    }) : (0, _react.jsx)((0, _reactDefault.default).Fragment, null), !useGenerativeReview ? (0, _react.jsx)(StyledTotalCard, {
        title: "Average Topic Inquiries per Call",
        value: Math.round(Number(averageTopicInquiriesPerCall.toFixed(2))),
        deltaValue: Math.round(Number(deltaAverageTopicInquiriesPerCall.toFixed(2))),
        deltaPercentage: deltaAverageTopicInquiriesPerCallPercentage,
        showValue: props.showValue,
        showPercentage: props.showPercentage,
        icon: averageIconBlue,
        secondIcon: questionIconBlue
    }) : (0, _react.jsx)((0, _reactDefault.default).Fragment, null)) : (0, _react.jsx)((0, _reactDefault.default).Fragment, null, (0, _react.jsx)((0, _totalCardDefault.default), {
        title: "Users",
        value: props.totals?.totalUsers,
        deltaValue: deltaUsers,
        deltaPercentage: Math.round(deltaUsers / (props.previousTotals?.totalUsers > 0 ? props.previousTotals?.totalUsers : 1) * 100),
        showValue: props.showValue,
        showPercentage: props.showPercentage
    }), (0, _react.jsx)((0, _totalCardDefault.default), {
        title: "New Users",
        value: props.totals?.totalNewUsers ?? 0,
        deltaValue: deltaNewUsers,
        deltaPercentage: Math.round(deltaNewUsers / (props.previousTotals?.totalNewUsers > 0 ? props.previousTotals?.totalNewUsers : 1) * 100),
        showValue: props.showValue,
        showPercentage: props.showPercentage
    }), (0, _react.jsx)((0, _totalCardDefault.default), {
        title: "Sessions",
        value: props.totals?.totalSessions,
        deltaValue: deltaSessions,
        deltaPercentage: Math.round(deltaSessions / (props.previousTotals?.totalSessions > 0 ? props.previousTotals?.totalSessions : 1) * 100),
        showValue: props.showValue,
        showPercentage: props.showPercentage
    }), (0, _react.jsx)((0, _totalCardDefault.default), {
        title: "Interactions",
        value: props.totals?.totalRequests,
        deltaValue: deltaRequests,
        deltaPercentage: Math.round(deltaRequests / (props.previousTotals?.totalRequests > 0 ? props.previousTotals?.totalRequests : 1) * 100),
        showValue: props.showValue,
        showPercentage: props.showPercentage
    }))), !sparkContainer.inSpark && (0, _react.jsx)("h3", {
        className: "ac-analytics-hits-table"
    }, "By Content"), renderTable(), displayGraphModal && (0, _react.jsx)((0, _graphFilterModal.GraphFilterModal), {
        isVisible: displayGraphModal,
        onClose: ()=>setDisplayGraphModal(false),
        categories: (0, _generativeCallReview.ALL_CATEGORIES),
        categoriesForDisplay: (0, _generativeCallReview.ALL_CATEGORIES).map((cat)=>(0, _generativeCallReview.getCategoryName)(cat, assistantIndustry)),
        tags: (0, _generativeCallReview.ALL_TAGS),
        tagsForDisplay: (0, _generativeCallReview.ALL_TAGS).map((tag)=>(0, _generativeCallReview.getTagName)(tag, assistantIndustry)),
        onToggleTag: (tag)=>toggleGraphTag(tag),
        onToggleCategory: (cat)=>toggleGraphCategories(cat),
        onApply: async ()=>{
            setGraphCategories([
                ...toggledGraphCategories
            ]);
            setGraphTags([
                ...toggledGraphTags
            ]);
        },
        assistantIndustry: assistantIndustry,
        currentToggledCategories: [
            ...toggledGraphCategories
        ],
        currentToggledTags: [
            ...toggledGraphTags
        ]
    }), showActionCompletedHistogram && (0, _react.jsx)((0, _smallModalLayoutDefault.default), {
        isVisible: showActionCompletedHistogram,
        onClose: ()=>setShowActionCompletedHistogram(false),
        className: modalContentStyle,
        innerClassName: modalInnerStyle
    }, (0, _react.jsx)((0, _modalHeaderDefault.default), {
        title: foodOrderingApp ? "Order Placed Volume" : healthcareApp ? "Appointment Booking Volume" : "Completed Action Volume",
        onClose: ()=>setShowActionCompletedHistogram(false)
    }), actionCompletedHistogram), ";"));
};
const StyledTotalCard = /*#__PURE__*/ (0, _baseDefault.default)((0, _totalCardDefault.default), {
    target: "e1ssdmzw14"
})({
    name: "hfam8v",
    styles: "padding:24px 32px;height:200px;width:100%;text-align:center;font-family:Muli;border:1px solid #CBCCD2;box-sizing:border-box;border-radius:8px;background:white;display:flex;flex-direction:column;justify-content:center;@media (max-width: 1200px){height:auto;min-height:150px;}"
});
const BoldValueSpan = /*#__PURE__*/ (0, _baseDefault.default)("span", {
    target: "e1ssdmzw13"
})("color:", (0, _colors.color_text_link), ";font-weight:bold;");
const wrapperStyle = /*#__PURE__*/ (0, _css.css)("margin:0;.loader-container{display:flex;flex:1;align-items:center;justify-content:center;width:100%;height:100vh;.spinner>div{background:", (0, _colors.color_colors_ocean), ";}}>h3{margin:16px 32px;}", "");
const TotalsWrapper = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1ssdmzw12"
})({
    name: "18obkmx",
    styles: "display:flex;justify-content:center;flex-wrap:wrap;margin:0 16px;padding-bottom:16px"
});
const containerStyle = /*#__PURE__*/ (0, _css.css)(".feature-type-icon{margin-right:12px;width:24px;height:24px;}a{color:", (0, _colors.color_text_default), ";&:hover{color:", (0, _colors.color_text_link), ";}}", "");
const GraphButtonDiv = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1ssdmzw11"
})({
    name: "1x662hg",
    styles: "justify-content:center;margin:0 align-items:center"
});
const StyledLink = /*#__PURE__*/ (0, _baseDefault.default)("a", {
    target: "e1ssdmzw10"
})("&&{color:", (0, _colors.color_text_link), ";}");
const GraphButton = /*#__PURE__*/ (0, _baseDefault.default)((0, _buttonDefault.default), {
    target: "e1ssdmzw9"
})({
    name: "3tav8f",
    styles: "font-size:11px;width:80px;height:23px;margin-bottom:0;margin-top:0"
});
// Styled components for the three-row grid layout
const StyledTopMetricsContainer = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1ssdmzw8"
})({
    name: "1cz73j6",
    styles: "--card-gap:24px;--responsive-gap-medium:16px;--responsive-gap-small:12px;--vertical-card-gap:16px;--graph-left-adjust:0px;--bottom-component-vertical-adjust:16px;--card-height:200px;display:flex;flex-direction:column;padding:var(--card-gap);width:100%;max-width:100vw;box-sizing:border-box;margin-bottom:40px;@media (max-width: 768px){padding:var(--responsive-gap-medium);gap:var(--responsive-gap-medium);}"
});
const BottomSection = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1ssdmzw7"
})({
    name: "19gwtns",
    styles: "display:grid;grid-template-columns:repeat(5, minmax(0, 1fr));grid-template-rows:var(--card-height) var(--card-height);gap:var(--card-gap);width:100%;@media (max-width: 1200px){grid-template-columns:1fr;grid-template-rows:auto;}"
});
const LeftCardsContainer = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1ssdmzw6"
})({
    name: "13i4qzg",
    styles: "grid-column:1/2;grid-row:1/3;display:grid;grid-template-rows:1fr 1fr;gap:var(--vertical-card-gap);position:relative;left:-16px;@media (max-width: 1200px){grid-column:1;grid-row:auto;grid-template-rows:auto;}"
});
const ChartContainer = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1ssdmzw5"
})({
    name: "6ifbvm",
    styles: "grid-column:2/6;grid-row:1/3;display:grid;>*{width:100%;height:100%;margin:0;}@media (max-width: 1200px){grid-column:1;grid-row:auto;min-height:auto;}"
});
const TopCardsContainer = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1ssdmzw4"
})({
    name: "10r8wo0",
    styles: "display:grid;grid-template-columns:repeat(5, 1fr);gap:var(--card-gap);width:100%;position:relative;left:-16px;@media (max-width: 1200px){grid-template-columns:repeat(2, 1fr);gap:var(--responsive-gap-medium);}@media (max-width: 768px){grid-template-columns:1fr;gap:var(--responsive-gap-small);}"
});
const histogramTitleStyle = /*#__PURE__*/ (0, _css.css)("font-size:14px;line-height:16px;letter-spacing:0.1em;text-transform:uppercase;color:", (0, _colors.color_text_light), ";margin:0;text-align:center;", "");
const StyledTopCard = /*#__PURE__*/ (0, _baseDefault.default)((0, _totalCardDefault.default), {
    target: "e1ssdmzw3"
})({
    name: "1q4739v",
    styles: "padding:24px;height:200px;width:100%;text-align:center;font-family:Muli;border:1px solid #CBCCD2;box-sizing:border-box;border-radius:8px;background:white;display:flex;flex-direction:column;justify-content:center;@media (max-width: 1200px){height:auto;min-height:150px;}"
});
const StyledLeftCard = /*#__PURE__*/ (0, _baseDefault.default)((0, _totalCardDefault.default), {
    target: "e1ssdmzw2"
})({
    name: "1n2emqd",
    styles: "padding:24px 32px;height:var(--card-height);width:100%;text-align:center;font-family:Muli;border:1px solid #CBCCD2;box-sizing:border-box;border-radius:8px;background:white;display:flex;flex-direction:column;justify-content:center;@media (max-width: 1200px){height:auto;min-height:200px;}"
});
const StyledBottomLeftCard = /*#__PURE__*/ (0, _baseDefault.default)((0, _totalCardDefault.default), {
    target: "e1ssdmzw1"
})({
    name: "rkkvxz",
    styles: "padding:24px 32px;height:var(--card-height);width:100%;text-align:center;font-family:Muli;border:1px solid #CBCCD2;box-sizing:border-box;border-radius:8px;background:white;display:flex;flex-direction:column;justify-content:center;position:relative;bottom:var(--bottom-component-vertical-adjust);@media (max-width: 1200px){height:auto;min-height:200px;}"
});
const StyledGraphDiv = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1ssdmzw0"
})({
    name: "kgbc25",
    styles: "width:100%;display:flex;flex-direction:column;margin:16px 0;position:relative;left:var(--graph-left-adjust);top:0px;>div{flex:1;margin:0;padding:0;box-sizing:border-box;height:432px;min-height:432px;max-height:432px;}"
});
const modalContentStyle = /*#__PURE__*/ (0, _css.css)({
    name: "piibti",
    styles: "width:100%;max-width:900px;max-height:80vh;@media (max-width: 768px){width:98%;max-width:100%;max-height:90vh;}"
});
const modalInnerStyle = /*#__PURE__*/ (0, _css.css)({
    name: "13ku56z",
    styles: "display:flex;flex-direction:column;height:100%"
});
exports.default = ApplicationTopHitsTable;

},{"@babel/runtime/helpers/extends":"4iKIP","@emotion/styled/base":"lSuFu","@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","../../../components/general/TableCell":"2zNzE","../../../constants/colors":"1p3OR","moment":"2meyw","../../../components/analytics/ReportTableHeader":"2Dfnn","../../../components/analytics/ReportTable":"4pPnp","../../../models/extensions":"7h01B","../../../models/analytics/AnalyticsDateFormat":"ia5MW","../../../components/charts/TotalCard":"gH7gf","../../../constants/featureTypeIds":"hPLMP","../../../hooks/SparkContainer":"jzXzx","../../../hooks/SessionAnalyticsContainer":"vk8Qc","../../../hooks/TelephonyAnalyticsContainer":"214YQ","../../../components/general/Loader":"bnV5T","../../../components/analytics/GenerativeReportTable":"eP5el","../../../constants/Urls":"iTopY","../../../hooks/UseIsMobile":"9Gz1L","../../../constants/featureFlagIds":"33vuW","../../../constants/analyticsConstants/generativeCallReview":"5Shd2","../../../hooks/UseProcessConversationalSuccessEvents":"5RAbR","../../../components/analytics/GraphFilterModal":"jEqDs","../../../components/general/Button":"6ymxN","../../../components/structure/SmallModalLayout":"khwvt","../../../components/general/ModalHeader":"aUACx","../../../components/charts/ConvSuccessHistogramContainer":"lDrBg","../../../components/charts/HistogramChartCard":"cGWvK","../../../api/controllers/engagementAnalyticsReporting":"7dGKa","e349f22f29cc7073":"iw6lu","ded04134fca6b0a2":"aBWWk","25f48f082c693b2":"h79CP","6610327436cd4df9":"koRig","c0f69e594e39fb16":"41hFy","84ebaa4cd63f5928":"aB2zi","6d74471367a0cdbf":"ffr48","cd09bf28eea729fc":"4FUwJ","13967107280c5ae1":"bI1PG","e95a4b034dbdd59d":"i8yay","88a51cd1e258c1df":"kMXMI","ecca9bb22133cc59":"jZBVd","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"214YQ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _unstatedNext = require("unstated-next");
var _react = require("react");
var _api = require("../api");
var _generativeCallReview = require("../constants/analyticsConstants/generativeCallReview");
// ========== TYPE DEFINITIONS ==========
/**
 * Per-app breakdown of appointments
 */ /**
 * Per-app breakdown of new patient bookings
 */ /**
 * Per-app breakdown of contained calls
 */ /**
 * Average call length broken down by appointment category
 */ /**
 * Call volume by app for a specific hour
 */ /**
 * Call volume aggregated by hour with per-app breakdown
 */ /**
 * Healthcare metrics for a single application
 * TODO: Consider adding API endpoint for app-level metrics
 */ /**
 * Healthcare metrics aggregated across multiple applications (organization-level)
 * TODO: Add API endpoint: GET /api/analytics/org/{orgId}/healthcare/metrics
 */ /**
 * Food ordering metrics for a single application
 * TODO: Consider adding API endpoint for app-level metrics
 */ /**
 * Food ordering metrics aggregated across multiple applications
 * TODO: Add API endpoint: GET /api/analytics/org/{orgId}/ordering/metrics
 */ /**
 * Labor savings calculation results
 */ function useTelephonyAnalyticsContainer() {
    const [loading, setLoading] = (0, _react.useState)(true);
    const [loadingSessionId, setLoadingSessionId] = (0, _react.useState)("");
    const [errors, setErrors] = (0, _react.useState)([]);
    const [itemAddedToOrderEvents, setItemAddedToOrderEvents] = (0, _react.useState)([]);
    const [callTransferredEvents, setCallTransferredEvents] = (0, _react.useState)([]);
    const [orderPlacedEvents, setOrderPlacedEvents] = (0, _react.useState)([]);
    const [unsuccessfulOrderSessionIds, setFailedOrderSessionIds] = (0, _react.useState)([]);
    const [ordersPlacedSessionIds, setOrdersPlacedSessionIds] = (0, _react.useState)([]);
    const [orderTransferredSessionIds, setOrderTransferredSessionIds] = (0, _react.useState)([]);
    const [noOrderSessionIds, setNoOrderSessionIds] = (0, _react.useState)([]);
    const [allEventsCache, setAllEventsCache] = (0, _react.useState)({});
    const [immediateTransferEvents, setImmediateTransferEvents] = (0, _react.useState)([]);
    const [conversationalSuccessEvents, setConversationalSuccessEvents] = (0, _react.useState)([]);
    const [callCompleteEvents, setCallCompleteEvents] = (0, _react.useState)([]);
    const [initialSessions, setInitialSessions] = (0, _react.useState)([]);
    const [sessions, setSessions] = (0, _react.useState)([]);
    const [orderAttempts, setOrderAttempts] = (0, _react.useState)(0);
    const [ordersPlaced, setOrdersPlaced] = (0, _react.useState)(0);
    const [transfers, setTransfers] = (0, _react.useState)(0);
    const [orderPlacedRate, setOrderPlacedRate] = (0, _react.useState)(0);
    const [orderTransferRate, setOrderTransferRate] = (0, _react.useState)(0);
    const [orderTransfers, setOrderTransfers] = (0, _react.useState)(null);
    const [transferRate, setTransferRate] = (0, _react.useState)(0);
    const [immediateTransfers, setImmediateTransfers] = (0, _react.useState)(0);
    const [immediateTransferRate, setImmediateTransferRate] = (0, _react.useState)(0);
    const [conversationalSuccessRate, setConversationalSuccessRate] = (0, _react.useState)(0);
    const [attemptedOrdersConversationalSuccessRate, setAttemptedOrdersConversationalSuccessRate] = (0, _react.useState)(0);
    const [attemptedOrderConversationalSuccess, setAttemptedOrderConversationalSuccess] = (0, _react.useState)(0);
    const [conversationalSuccess, setConversationalSuccess] = (0, _react.useState)(0);
    (0, _react.useEffect)(()=>{
        if (loading) return;
        let itemAddedToOrderSessionIds = getUniqueSessionIds(itemAddedToOrderEvents);
        itemAddedToOrderSessionIds = itemAddedToOrderSessionIds.filter((x)=>sessions.some((s)=>s.sessionId === x));
        const orderAttempts = itemAddedToOrderSessionIds.length;
        setOrderAttempts(orderAttempts);
        let placedSessionIds = getUniqueSessionIds(orderPlacedEvents);
        placedSessionIds = placedSessionIds.filter((x)=>sessions.some((s)=>s.sessionId === x));
        const ordersPlaced = placedSessionIds.length;
        setOrdersPlaced(ordersPlaced);
        setOrdersPlacedSessionIds(placedSessionIds);
        let failOrderSessionIds = itemAddedToOrderSessionIds.filter((x)=>!placedSessionIds.includes(x));
        setFailedOrderSessionIds(failOrderSessionIds);
        const noOrderSessions = sessions.filter((x)=>!itemAddedToOrderSessionIds.includes(x.sessionId));
        setNoOrderSessionIds(noOrderSessions.map((s)=>s.sessionId));
        const callTransferedSessionIds = getUniqueSessionIds(callTransferredEvents);
        setTransfers(callTransferedSessionIds.length);
        setTransferRate(callTransferedSessionIds.length / sessions.length);
        // union of call transferred and order attempted session ids
        const oTransferSessIds = callTransferedSessionIds.filter((x)=>itemAddedToOrderSessionIds.includes(x));
        setOrderTransferredSessionIds(oTransferSessIds);
        const immediateTransferSessionIds = getUniqueSessionIds(immediateTransferEvents);
        setImmediateTransferRate(immediateTransferSessionIds.length / sessions.length);
        setImmediateTransfers(immediateTransferSessionIds.length);
        // get call transfers that happened in a session where items were added to order
        if (!itemAddedToOrderSessionIds?.length) {
            setOrderPlacedRate(-1);
            setOrderTransferRate(-1);
            setOrderTransfers(-1);
        } else {
            setOrderPlacedRate(placedSessionIds.length / itemAddedToOrderSessionIds.length);
            const orderTransferedSessionIds = callTransferedSessionIds.filter((x)=>itemAddedToOrderSessionIds.includes(x));
            setOrderTransferRate(orderTransferedSessionIds.length / itemAddedToOrderSessionIds.length);
            setOrderTransfers(orderTransferedSessionIds?.length ?? 0);
            const conversationalSuccessSessionIds = new Set([
                ...conversationalSuccessEvents.map((x)=>x.sessionId)
            ]);
            let convSuccessSessionIds = [
                ...conversationalSuccessSessionIds
            ].filter((x)=>sessions.some((s)=>s.sessionId === x));
            const conversationalSuccessCount = convSuccessSessionIds.length;
            setConversationalSuccess(conversationalSuccessCount);
            const attemptedSuccessSessions = itemAddedToOrderSessionIds.filter((x)=>convSuccessSessionIds.includes(x));
            const attemptedConversationalSuccessRate = attemptedSuccessSessions.length / orderAttempts;
            setAttemptedOrdersConversationalSuccessRate(attemptedConversationalSuccessRate);
            setAttemptedOrderConversationalSuccess(attemptedSuccessSessions.length);
            const sessionsCount = sessions.length;
            const allConversationalSuccessRate = conversationalSuccessCount / sessionsCount;
            setConversationalSuccessRate(allConversationalSuccessRate);
        }
    }, [
        itemAddedToOrderEvents,
        orderPlacedEvents,
        callTransferredEvents,
        sessions,
        immediateTransferEvents,
        conversationalSuccessEvents,
        callCompleteEvents,
        loading
    ]);
    (0, _react.useEffect)(()=>{
        if (initialSessions.length && callCompleteEvents.length) {
            // we don't want sessions if they had no new tts generations and 3 or less cached ones and no transfers 
            // this means they probably didn't interact at all
            const newSessions = initialSessions.filter((s)=>{
                const completeEvent = callCompleteEvents.find((e)=>e.sessionId === s.sessionId);
                if (completeEvent && !completeEvent?.newTTSGenerations && completeEvent?.cachedTTSGenerations <= 3 || (completeEvent?.newTTSGenerations ?? 0 + (completeEvent?.cachedTTSGenerations ?? 0)) < 2) {
                    const callTransferredEvent = callTransferredEvents.find((e)=>e.sessionId === s.sessionId);
                    if (!callTransferredEvent) return false;
                }
                return true;
            });
            setSessions(newSessions);
            setLoading(false);
        }
    }, [
        initialSessions,
        callCompleteEvents,
        callTransferredEvents
    ]);
    /**
   * Calculate healthcare-specific metrics from conversational success events (App-level)
   * This provides both English and Spanish breakdowns for all appointment types
   * 
   * TODO: Replace with API endpoint when available:
   * GET /api/analytics/app/{appId}/healthcare/metrics?startDate={date}&endDate={date}
   */ const healthcareAppMetrics = (0, _react.useMemo)(()=>{
        if (!conversationalSuccessEvents || conversationalSuccessEvents.length === 0) return {
            scheduled: 0,
            scheduledEnglish: 0,
            scheduledSpanish: 0,
            rescheduled: 0,
            rescheduledEnglish: 0,
            rescheduledSpanish: 0,
            cancelled: 0,
            cancelledEnglish: 0,
            cancelledSpanish: 0,
            checkedNextAppt: 0,
            checkedNextApptEnglish: 0,
            checkedNextApptSpanish: 0,
            totalAppointmentActions: 0,
            containedCallsCount: 0,
            containedCallsPercentage: "??",
            hasSpanishCalls: false
        };
        // Count scheduled appointments (ACTION_COMPLETED but not rescheduled or cancelled)
        const scheduledEnglish = conversationalSuccessEvents.filter((event)=>event.sessionTags?.includes((0, _generativeCallReview.TAGS).ACTION_COMPLETED) && !event.sessionTags?.includes((0, _generativeCallReview.TAGS).APPOINTMENT_RESCHEDULED) && !event.sessionTags?.includes((0, _generativeCallReview.TAGS).APPOINTMENT_CANCELLED) && !event.sessionTags?.includes((0, _generativeCallReview.TAGS).SPANISH)).length;
        const scheduledSpanish = conversationalSuccessEvents.filter((event)=>event.sessionTags?.includes((0, _generativeCallReview.TAGS).ACTION_COMPLETED) && !event.sessionTags?.includes((0, _generativeCallReview.TAGS).APPOINTMENT_RESCHEDULED) && !event.sessionTags?.includes((0, _generativeCallReview.TAGS).APPOINTMENT_CANCELLED) && event.sessionTags?.includes((0, _generativeCallReview.TAGS).SPANISH)).length;
        // Count rescheduled appointments
        const rescheduledEnglish = conversationalSuccessEvents.filter((event)=>event.sessionTags?.includes((0, _generativeCallReview.TAGS).APPOINTMENT_RESCHEDULED) && !event.sessionTags?.includes((0, _generativeCallReview.TAGS).SPANISH)).length;
        const rescheduledSpanish = conversationalSuccessEvents.filter((event)=>event.sessionTags?.includes((0, _generativeCallReview.TAGS).APPOINTMENT_RESCHEDULED) && event.sessionTags?.includes((0, _generativeCallReview.TAGS).SPANISH)).length;
        // Count cancelled appointments
        const cancelledEnglish = conversationalSuccessEvents.filter((event)=>event.sessionTags?.includes((0, _generativeCallReview.TAGS).APPOINTMENT_CANCELLED) && !event.sessionTags?.includes((0, _generativeCallReview.TAGS).SPANISH)).length;
        const cancelledSpanish = conversationalSuccessEvents.filter((event)=>event.sessionTags?.includes((0, _generativeCallReview.TAGS).APPOINTMENT_CANCELLED) && event.sessionTags?.includes((0, _generativeCallReview.TAGS).SPANISH)).length;
        // Count checked next appointments
        const checkedNextApptEnglish = conversationalSuccessEvents.filter((event)=>event.sessionTags?.includes((0, _generativeCallReview.TAGS).CHECK_NEXT_APPOINTMENT_COMPLETE) && !event.sessionTags?.includes((0, _generativeCallReview.TAGS).SPANISH)).length;
        const checkedNextApptSpanish = conversationalSuccessEvents.filter((event)=>event.sessionTags?.includes((0, _generativeCallReview.TAGS).CHECK_NEXT_APPOINTMENT_COMPLETE) && event.sessionTags?.includes((0, _generativeCallReview.TAGS).SPANISH)).length;
        const scheduled = scheduledEnglish + scheduledSpanish;
        const rescheduled = rescheduledEnglish + rescheduledSpanish;
        const cancelled = cancelledEnglish + cancelledSpanish;
        const checkedNextAppt = checkedNextApptEnglish + checkedNextApptSpanish;
        const totalAppointmentActions = scheduled + rescheduled + cancelled + checkedNextAppt;
        // Calculate contained calls
        const successfulCalls = scheduled + rescheduled + cancelled;
        const remainingContainedCalls = conversationalSuccessEvents.filter((event)=>event.sessionTags?.includes((0, _generativeCallReview.TAGS).TRANSFERRED) && (event.sessionTags?.includes((0, _generativeCallReview.TAGS).SCHEDULE_ATTEMPTED) || event.sessionTags?.includes((0, _generativeCallReview.TAGS).RESCHEDULE_ATTEMPTED) || event.sessionTags?.includes((0, _generativeCallReview.TAGS).CANCELLATION_ATTEMPTED)) && (event.sessionTags?.includes((0, _generativeCallReview.TAGS).UNSUPPORTED_APPOINTMENT_TYPE) || event.sessionTags?.includes((0, _generativeCallReview.TAGS).UNSUPPORTED_CUSTOMER_REQUEST)) || event.sessionTags?.includes((0, _generativeCallReview.TAGS).CHECK_NEXT_APPOINTMENT_COMPLETE)).length;
        const containedCallsCount = successfulCalls + remainingContainedCalls;
        const attemptedTotal = conversationalSuccessEvents.filter((event)=>event.sessionCategory === "ACTION_ATTEMPTED").length;
        const containedCallsPercentage = attemptedTotal <= 0 ? "??" : Math.round(containedCallsCount / attemptedTotal * 100);
        const hasSpanishCalls = conversationalSuccessEvents.some((event)=>event.sessionTags?.includes((0, _generativeCallReview.TAGS).SPANISH));
        return {
            scheduled,
            scheduledEnglish,
            scheduledSpanish,
            rescheduled,
            rescheduledEnglish,
            rescheduledSpanish,
            cancelled,
            cancelledEnglish,
            cancelledSpanish,
            checkedNextAppt,
            checkedNextApptEnglish,
            checkedNextApptSpanish,
            totalAppointmentActions,
            containedCallsCount,
            containedCallsPercentage,
            hasSpanishCalls
        };
    }, [
        conversationalSuccessEvents
    ]);
    /**
   * Calculate organization-level healthcare metrics from conversational success events
   * Aggregates data across multiple healthcare applications
   * 
   * TODO: Replace with API endpoint when available:
   * GET /api/analytics/org/{orgId}/healthcare/metrics?startDate={date}&endDate={date}
   * 
   * @param aggregatedSessions - Sessions from all healthcare apps in the org
   * @param aggregatedCallCompleteEvents - Call complete events from all healthcare apps
   * @param healthcareApps - Array of healthcare application objects
   */ const calculateHealthcareOrgMetrics = (aggregatedSessions, aggregatedCallCompleteEvents, healthcareApps)=>{
        // Start with app-level metrics as base
        const baseMetrics = healthcareAppMetrics;
        if (!conversationalSuccessEvents || conversationalSuccessEvents.length === 0) return {
            ...baseMetrics,
            totalEngagements: aggregatedSessions?.length || 0,
            offHoursCalls: 0,
            transferCount: 0,
            faqCount: 0,
            averageCallLength: 0,
            averageContainedCallLength: 0,
            averageCallLengthByCategory: {
                scheduled: 0,
                rescheduled: 0,
                cancelled: 0,
                checkedNextAppt: 0
            },
            laborHoursSaved: 0,
            callVolumeByHour: [],
            appointmentsByApp: [],
            containedCallsByApp: [],
            newPatientBookings: 0,
            existingPatientBookings: 0,
            totalBookings: 0,
            newPatientBookingsByApp: []
        };
        // Count transfer and FAQ events
        let transferCount = 0;
        let faqCount = 0;
        conversationalSuccessEvents.forEach((event)=>{
            const tags = event.sessionTags || [];
            const category = event.sessionCategory;
            if (tags.includes((0, _generativeCallReview.TAGS).TRANSFERRED)) transferCount++;
            if (category === "QUESTION_ANSWERED") faqCount++;
        });
        const totalSessions = aggregatedSessions?.length || 1;
        const transferredSessionIds = new Set();
        conversationalSuccessEvents.forEach((event)=>{
            const tags = event.sessionTags || [];
            if (tags.includes((0, _generativeCallReview.TAGS).TRANSFERRED) && event.sessionId) transferredSessionIds.add(event.sessionId);
        });
        // Calculate average call lengths from call complete events
        let totalDuration = 0;
        let containedCallDuration = 0;
        let containedCallCount = 0;
        const callCompleteCount = aggregatedCallCompleteEvents?.length || 0;
        aggregatedCallCompleteEvents?.forEach((event)=>{
            const duration = event.callDuration || event.duration || 0;
            totalDuration += duration;
            const wasContained = !transferredSessionIds.has(event.sessionId);
            if (wasContained) {
                containedCallDuration += duration;
                containedCallCount++;
            }
        });
        const averageCallLength = callCompleteCount > 0 ? totalDuration / callCompleteCount / 60 // Convert to minutes
         : 0;
        const averageContainedCallLength = containedCallCount > 0 ? containedCallDuration / containedCallCount / 60 // Convert to minutes
         : 0;
        // Calculate average call length by category
        const sessionCategoryMap = new Map();
        conversationalSuccessEvents.forEach((event)=>{
            if (event.sessionId) {
                const tags = event.sessionTags || [];
                const categories = [];
                if (tags.includes((0, _generativeCallReview.TAGS).ACTION_COMPLETED) && !tags.includes((0, _generativeCallReview.TAGS).APPOINTMENT_RESCHEDULED) && !tags.includes((0, _generativeCallReview.TAGS).APPOINTMENT_CANCELLED)) categories.push("scheduled");
                if (tags.includes((0, _generativeCallReview.TAGS).APPOINTMENT_RESCHEDULED)) categories.push("rescheduled");
                if (tags.includes((0, _generativeCallReview.TAGS).APPOINTMENT_CANCELLED)) categories.push("cancelled");
                if (tags.includes((0, _generativeCallReview.TAGS).CHECK_NEXT_APPOINTMENT_COMPLETE)) categories.push("checkedNextAppt");
                if (categories.length > 0) sessionCategoryMap.set(event.sessionId, categories);
            }
        });
        const categoryDurations = {
            scheduled: {
                total: 0,
                count: 0
            },
            rescheduled: {
                total: 0,
                count: 0
            },
            cancelled: {
                total: 0,
                count: 0
            },
            checkedNextAppt: {
                total: 0,
                count: 0
            }
        };
        aggregatedCallCompleteEvents?.forEach((event)=>{
            const duration = event.callDuration || event.duration || 0;
            const categories = sessionCategoryMap.get(event.sessionId);
            if (categories) categories.forEach((category)=>{
                if (categoryDurations[category]) {
                    categoryDurations[category].total += duration;
                    categoryDurations[category].count++;
                }
            });
        });
        const averageCallLengthByCategory = {
            scheduled: categoryDurations.scheduled.count > 0 ? categoryDurations.scheduled.total / categoryDurations.scheduled.count / 60 : 0,
            rescheduled: categoryDurations.rescheduled.count > 0 ? categoryDurations.rescheduled.total / categoryDurations.rescheduled.count / 60 : 0,
            cancelled: categoryDurations.cancelled.count > 0 ? categoryDurations.cancelled.total / categoryDurations.cancelled.count / 60 : 0,
            checkedNextAppt: categoryDurations.checkedNextAppt.count > 0 ? categoryDurations.checkedNextAppt.total / categoryDurations.checkedNextAppt.count / 60 : 0
        };
        // Calculate labor hours saved
        const orgContainedCallsCount = totalSessions - transferredSessionIds.size;
        const laborHoursSaved = orgContainedCallsCount > 0 && averageContainedCallLength > 0 ? orgContainedCallsCount * averageContainedCallLength / 60 // Convert minutes to hours
         : 0;
        // Calculate call volume by hour with app breakdown
        const hourData = {};
        // Initialize all hours from 8 AM to 5 PM
        for(let hour = 8; hour <= 17; hour++){
            const period = hour >= 12 ? "PM" : "AM";
            const displayHour = hour > 12 ? hour - 12 : hour;
            const label = `${displayHour} ${period}`;
            hourData[label] = {
                total: 0,
                byApp: {}
            };
        }
        // Count sessions by hour across all apps
        aggregatedSessions?.forEach((session)=>{
            const startDate = new Date(session.startDate || session.date);
            const hour = startDate.getHours();
            if (hour >= 8 && hour <= 17) {
                const period = hour >= 12 ? "PM" : "AM";
                const displayHour = hour > 12 ? hour - 12 : hour;
                const label = `${displayHour} ${period}`;
                hourData[label].total++;
                const appId = session.applicationId;
                if (appId) {
                    const app = healthcareApps?.find((a)=>a.id === appId);
                    const appName = app?.name || "Unknown";
                    if (!hourData[label].byApp[appId]) hourData[label].byApp[appId] = {
                        appName,
                        count: 0
                    };
                    hourData[label].byApp[appId].count++;
                }
            }
        });
        const callVolumeByHour = Object.entries(hourData).map(([hour, data])=>({
                hour,
                calls: data.total,
                apps: Object.values(data.byApp).sort((a, b)=>b.count - a.count)
            }));
        // Calculate appointments by app
        const appointmentsByApp = [];
        if (healthcareApps && healthcareApps.length > 0) healthcareApps.forEach((app)=>{
            const appEvents = conversationalSuccessEvents.filter((event)=>event.applicationId === app.id);
            let appScheduled = 0;
            let appRescheduled = 0;
            let appCancelled = 0;
            let appCheckedNextAppt = 0;
            appEvents.forEach((event)=>{
                const tags = event.sessionTags || [];
                if (tags.includes((0, _generativeCallReview.TAGS).ACTION_COMPLETED) && !tags.includes((0, _generativeCallReview.TAGS).APPOINTMENT_RESCHEDULED) && !tags.includes((0, _generativeCallReview.TAGS).APPOINTMENT_CANCELLED)) appScheduled++;
                if (tags.includes((0, _generativeCallReview.TAGS).APPOINTMENT_RESCHEDULED)) appRescheduled++;
                if (tags.includes((0, _generativeCallReview.TAGS).APPOINTMENT_CANCELLED)) appCancelled++;
                if (tags.includes((0, _generativeCallReview.TAGS).CHECK_NEXT_APPOINTMENT_COMPLETE)) appCheckedNextAppt++;
            });
            if (appScheduled + appRescheduled + appCancelled + appCheckedNextAppt > 0) appointmentsByApp.push({
                appId: app.id,
                appName: app.name || "Unknown App",
                scheduled: appScheduled,
                rescheduled: appRescheduled,
                cancelled: appCancelled,
                checkedNextAppt: appCheckedNextAppt
            });
        });
        // Calculate contained calls breakdown by app
        const containedCallsByApp = [];
        if (healthcareApps && healthcareApps.length > 0) healthcareApps.forEach((app)=>{
            const appEvents = conversationalSuccessEvents.filter((event)=>event.applicationId === app.id);
            let appScheduled = 0;
            let appScheduledEnglish = 0;
            let appScheduledSpanish = 0;
            let appRescheduled = 0;
            let appRescheduledEnglish = 0;
            let appRescheduledSpanish = 0;
            let appCancelled = 0;
            let appCancelledEnglish = 0;
            let appCancelledSpanish = 0;
            let appCheckedNextAppt = 0;
            let appCheckedNextApptEnglish = 0;
            let appCheckedNextApptSpanish = 0;
            let appFaq = 0;
            let appFaqEnglish = 0;
            let appFaqSpanish = 0;
            let appTransfer = 0;
            let appTransferEnglish = 0;
            let appTransferSpanish = 0;
            appEvents.forEach((event)=>{
                const tags = event.sessionTags || [];
                const category = event.sessionCategory;
                const isSpanish = tags.includes((0, _generativeCallReview.TAGS).SPANISH);
                if (tags.includes((0, _generativeCallReview.TAGS).ACTION_COMPLETED) && !tags.includes((0, _generativeCallReview.TAGS).APPOINTMENT_RESCHEDULED) && !tags.includes((0, _generativeCallReview.TAGS).APPOINTMENT_CANCELLED)) {
                    appScheduled++;
                    if (isSpanish) appScheduledSpanish++;
                    else appScheduledEnglish++;
                }
                if (tags.includes((0, _generativeCallReview.TAGS).APPOINTMENT_RESCHEDULED)) {
                    appRescheduled++;
                    if (isSpanish) appRescheduledSpanish++;
                    else appRescheduledEnglish++;
                }
                if (tags.includes((0, _generativeCallReview.TAGS).APPOINTMENT_CANCELLED)) {
                    appCancelled++;
                    if (isSpanish) appCancelledSpanish++;
                    else appCancelledEnglish++;
                }
                if (tags.includes((0, _generativeCallReview.TAGS).CHECK_NEXT_APPOINTMENT_COMPLETE)) {
                    appCheckedNextAppt++;
                    if (isSpanish) appCheckedNextApptSpanish++;
                    else appCheckedNextApptEnglish++;
                }
                if (tags.includes((0, _generativeCallReview.TAGS).TRANSFERRED)) {
                    appTransfer++;
                    if (isSpanish) appTransferSpanish++;
                    else appTransferEnglish++;
                }
                if (category === "QUESTION_ANSWERED") {
                    appFaq++;
                    if (isSpanish) appFaqSpanish++;
                    else appFaqEnglish++;
                }
            });
            const totalActions = appScheduled + appRescheduled + appCancelled + appCheckedNextAppt + appFaq + appTransfer;
            if (totalActions > 0) containedCallsByApp.push({
                appId: app.id,
                appName: app.name || "Unknown App",
                scheduled: appScheduled,
                scheduledEnglish: appScheduledEnglish,
                scheduledSpanish: appScheduledSpanish,
                rescheduled: appRescheduled,
                rescheduledEnglish: appRescheduledEnglish,
                rescheduledSpanish: appRescheduledSpanish,
                cancelled: appCancelled,
                cancelledEnglish: appCancelledEnglish,
                cancelledSpanish: appCancelledSpanish,
                checkedNextAppt: appCheckedNextAppt,
                checkedNextApptEnglish: appCheckedNextApptEnglish,
                checkedNextApptSpanish: appCheckedNextApptSpanish,
                faq: appFaq,
                faqEnglish: appFaqEnglish,
                faqSpanish: appFaqSpanish,
                transfer: appTransfer,
                transferEnglish: appTransferEnglish,
                transferSpanish: appTransferSpanish
            });
        });
        // Calculate new patient bookings
        // TODO: Add API endpoint: GET /api/analytics/org/{orgId}/healthcare/new-patient-events?startDate={date}&endDate={date}
        // This endpoint should return conversational success events filtered by the "NEW_PATIENT" tag
        const newPatientBookings = conversationalSuccessEvents.filter((event)=>event.sessionTags?.includes((0, _generativeCallReview.TAGS).ACTION_COMPLETED) && !event.sessionTags?.includes((0, _generativeCallReview.TAGS).APPOINTMENT_RESCHEDULED) && !event.sessionTags?.includes((0, _generativeCallReview.TAGS).APPOINTMENT_CANCELLED) && event.sessionTags?.includes((0, _generativeCallReview.TAGS).NEW_PATIENT)).length;
        const existingPatientBookings = conversationalSuccessEvents.filter((event)=>event.sessionTags?.includes((0, _generativeCallReview.TAGS).ACTION_COMPLETED) && !event.sessionTags?.includes((0, _generativeCallReview.TAGS).APPOINTMENT_RESCHEDULED) && !event.sessionTags?.includes((0, _generativeCallReview.TAGS).APPOINTMENT_CANCELLED) && !event.sessionTags?.includes((0, _generativeCallReview.TAGS).NEW_PATIENT)).length;
        const totalBookings = newPatientBookings + existingPatientBookings;
        // Calculate off hours calls
        const offHoursCalls = conversationalSuccessEvents.filter((event)=>event.sessionTags?.includes((0, _generativeCallReview.TAGS).CALL_DURING_OFF_HOURS)).length;
        // Calculate new patient bookings by app
        const newPatientBookingsByApp = [];
        if (healthcareApps && healthcareApps.length > 0) healthcareApps.forEach((app)=>{
            const appEvents = conversationalSuccessEvents.filter((event)=>event.applicationId === app.id);
            const newPatient = appEvents.filter((event)=>event.sessionTags?.includes((0, _generativeCallReview.TAGS).ACTION_COMPLETED) && !event.sessionTags?.includes((0, _generativeCallReview.TAGS).APPOINTMENT_RESCHEDULED) && !event.sessionTags?.includes((0, _generativeCallReview.TAGS).APPOINTMENT_CANCELLED) && event.sessionTags?.includes((0, _generativeCallReview.TAGS).NEW_PATIENT)).length;
            const existingPatient = appEvents.filter((event)=>event.sessionTags?.includes((0, _generativeCallReview.TAGS).ACTION_COMPLETED) && !event.sessionTags?.includes((0, _generativeCallReview.TAGS).APPOINTMENT_RESCHEDULED) && !event.sessionTags?.includes((0, _generativeCallReview.TAGS).APPOINTMENT_CANCELLED) && !event.sessionTags?.includes((0, _generativeCallReview.TAGS).NEW_PATIENT)).length;
            if (newPatient > 0 || existingPatient > 0) newPatientBookingsByApp.push({
                appId: app.id,
                appName: app.name,
                newPatient,
                existingPatient
            });
        });
        return {
            ...baseMetrics,
            totalEngagements: totalSessions,
            offHoursCalls,
            transferCount,
            faqCount,
            averageCallLength,
            averageContainedCallLength,
            averageCallLengthByCategory,
            laborHoursSaved,
            callVolumeByHour,
            appointmentsByApp,
            containedCallsByApp,
            newPatientBookings,
            existingPatientBookings,
            totalBookings,
            newPatientBookingsByApp
        };
    };
    /**
   * Calculate food ordering metrics from order placed events and call complete events (App-level)
   * 
   * TODO: Replace with API endpoint when available:
   * GET /api/analytics/app/{appId}/ordering/metrics?startDate={date}&endDate={date}
   */ const foodOrderingAppMetrics = (0, _react.useMemo)(()=>{
        if (!orderPlacedEvents || orderPlacedEvents.length === 0 || !callCompleteEvents || callCompleteEvents.length === 0) return {
            totalSold: 0,
            averageOrderLength: 0,
            convertedCustomers: -1,
            repeatCustomers: -1,
            uniqueEngagementCount: -1,
            upsellPercentage: -1
        };
        // Calculate total sold
        const totalSold = orderPlacedEvents.reduce((acc, event)=>acc + (event.total || 0), 0);
        // Get all call complete events that have a sessionId in the orderPlacedEvents
        const orderPlacedCompleteEvents = callCompleteEvents.filter((event)=>orderPlacedEvents.some((orderEvent)=>orderEvent.sessionId === event.sessionId));
        // Calculate average order length
        const totalDuration = orderPlacedCompleteEvents.reduce((acc, event)=>acc + (event.duration || 0), 0);
        const averageOrderLength = totalDuration / (orderPlacedCompleteEvents.length || 1);
        return {
            totalSold,
            averageOrderLength,
            convertedCustomers: -1,
            // These are calculated in useProcessConversationalSuccessEvents hook
            repeatCustomers: -1,
            uniqueEngagementCount: -1,
            upsellPercentage: -1
        };
    }, [
        orderPlacedEvents,
        callCompleteEvents
    ]);
    /**
   * Calculate labor hours saved
   * For healthcare: based on ACTION_COMPLETED call durations
   * For food ordering: based on average order length * number of orders
   */ const calculateLaborSavings = (sessionsForReview, processedEvents, industryType)=>{
        if (industryType === "healthcare") {
            const actionCompletedEvents = processedEvents?.filter((event)=>event.tags?.includes((0, _generativeCallReview.TAGS).ACTION_COMPLETED));
            const totalDuration = actionCompletedEvents?.reduce((acc, event)=>{
                const idCandidates = [
                    event.sessionId
                ].concat(event?.mergedSessions?.map((ms)=>ms.sessionId) || []);
                const completedSessionId = idCandidates.find((id)=>{
                    const convEvent = conversationalSuccessEvents?.filter((e)=>e.sessionId === id);
                    if (convEvent[0]?.sessionTags?.includes((0, _generativeCallReview.TAGS).ACTION_COMPLETED)) return id;
                });
                if (completedSessionId !== null && completedSessionId !== undefined) {
                    const sessionForReview = sessionsForReview.find((s)=>s.sessionId === completedSessionId);
                    if (sessionForReview) return acc + (sessionForReview.duration || 0);
                }
                return acc;
            }, 0) || 0;
            return {
                hoursSaved: Math.round(totalDuration / 3600 * 100) / 100,
                totalDurationSeconds: totalDuration
            };
        } else {
            // Food ordering
            const avgOrder = foodOrderingAppMetrics.averageOrderLength;
            const secondsSaved = avgOrder * (orderPlacedEvents?.length || 0);
            return {
                hoursSaved: Math.round(secondsSaved / 3600 * 100) / 100,
                totalDurationSeconds: secondsSaved
            };
        }
    };
    const getUniqueSessionIds = (events)=>{
        const grouped = events.reduce((acc, item)=>{
            if (!acc[item.sessionId]) acc[item.sessionId] = [];
            acc[item.sessionId].push(item);
            return acc;
        }, {});
        return Object.keys(grouped);
    };
    const loadAllEventsForSession = async (sessionId, applicationId)=>{
        if (sessionId in allEventsCache) return allEventsCache[sessionId];
        else {
            setLoadingSessionId(sessionId);
            const allEvents = await _api.getAllEventsForSession(applicationId, sessionId);
            if (allEvents.resultType === "Ok") {
                allEvents.data.forEach((e)=>{
                    if (e.eventDate) e.timestamp = new Date(e.eventDate).getTime();
                });
                // sort by timestampt
                allEvents.data.sort((a, b)=>a.timestamp - b.timestamp);
                const newEventsCache = {
                    ...allEventsCache
                };
                newEventsCache[sessionId] = allEvents.data;
                setAllEventsCache(newEventsCache);
            }
            setLoadingSessionId("");
            return allEvents;
        }
    };
    const loadOrderingAnalytics = async (applicationId, filter)=>{
        setLoading(true);
        setInitialSessions([]);
        setItemAddedToOrderEvents([]);
        setOrderPlacedEvents([]);
        setCallTransferredEvents([]);
        setImmediateTransferEvents([]);
        setConversationalSuccessEvents([]);
        setCallCompleteEvents([]);
        const tasks = [];
        tasks.push(_api.getSessionsByApplication(applicationId, filter));
        tasks.push(_api.getItemAddedToOrderEventsByApplication(applicationId, filter));
        tasks.push(_api.getOrderPlacedEventsByApplication(applicationId, filter));
        tasks.push(_api.getCallTransferredEventsByApplication(applicationId, filter));
        tasks.push(_api.getImmediateTransferEventsByApplication(applicationId, filter));
        tasks.push(_api.getConversationalSuccessEventsByApplication(applicationId, filter));
        tasks.push(_api.getCallCompleteEventsByApplication(applicationId, filter));
        // wait for all tasks
        const results = await Promise.all(tasks);
        let errors = [];
        const errorResults = results.filter((x)=>x.resultType !== "Ok");
        if (errorResults.length) {
            errors = [
                ...errors,
                ...errorResults.map((x)=>x.errors[0])
            ];
            setErrors(errors);
            setLoading(false);
            return;
        }
        setInitialSessions(results[0].data);
        setItemAddedToOrderEvents(results[1].data);
        setOrderPlacedEvents(results[2].data);
        setCallTransferredEvents(results[3].data);
        setImmediateTransferEvents(results[4].data);
        setConversationalSuccessEvents(results[5].data);
        setCallCompleteEvents(results[6].data);
    };
    const loadOrderPlacedEventsPaged = async (applicationId, filter)=>{
        let skip = 0;
        let take = 500;
        let allEvents = [];
        let hasMore = true;
        while(hasMore){
            const result = await _api.getOrderPlacedEventsByApplication(applicationId, {
                ...filter,
                skip,
                take
            });
            if (result.resultType === "Ok") {
                allEvents = [
                    ...allEvents,
                    ...result.data
                ];
                hasMore = result.data.length === take;
                skip += take;
            } else return result;
        }
        setOrderPlacedEvents(allEvents);
        return {
            resultType: "Ok",
            data: allEvents,
            errors: null
        };
    };
    const loadCallCompleteEventsPaged = async (applicationId, filter)=>{
        let skip = 0;
        let take = 500;
        let allEvents = [];
        let hasMore = true;
        while(hasMore){
            const result = await _api.getCallCompleteEventsByApplication(applicationId, {
                ...filter,
                skip,
                take
            });
            if (result.resultType === "Ok") {
                allEvents = [
                    ...allEvents,
                    ...result.data
                ];
                hasMore = result.data.length === take;
                skip += take;
            } else return result;
        }
        setCallCompleteEvents(allEvents);
        return {
            resultType: "Ok",
            data: allEvents,
            errors: null
        };
    };
    const loadConversationalSuccessEventsPaged = async (applicationId, filter)=>{
        let skip = 0;
        let take = 500;
        let allEvents = [];
        let hasMore = true;
        while(hasMore){
            const result = await _api.getConversationalSuccessEventsByApplication(applicationId, {
                ...filter,
                skip,
                take
            });
            if (result.resultType === "Ok") {
                allEvents = [
                    ...allEvents,
                    ...result.data
                ];
                hasMore = result.data.length === take;
                skip += take;
            } else return result;
        }
        return {
            resultType: "Ok",
            data: allEvents,
            errors: null
        };
    };
    const loadConversationalSuccessEvents = async (applicationId, filter)=>{
        setLoading(true);
        setErrors([]);
        setConversationalSuccessEvents([]);
        const result = await loadConversationalSuccessEventsPaged(applicationId, filter);
        if (result.resultType === "Ok") setConversationalSuccessEvents(result.data);
        else setErrors((prev)=>[
                ...prev,
                result?.errors[0]
            ]);
        setLoading(false);
    };
    const loadConversationalSuccessEventsForOrgs = async (orgIds, filter, logCallback)=>{
        setLoading(true);
        setErrors([]);
        setConversationalSuccessEvents([]);
        let allEvents = [];
        const loadErrors = [];
        for(let i = 0; i < orgIds.length; i++){
            const orgId = orgIds[i];
            try {
                logCallback?.(`Loading success events for organization ${i + 1} of ${orgIds.length}...`);
                const result = await loadConversationalSuccessEventsPagedForOrg(orgId, filter);
                if (result.resultType === "Ok") {
                    allEvents = [
                        ...allEvents,
                        ...result.data
                    ];
                    logCallback?.(`Loaded ${result.data.length} success events for organization ${i + 1}`);
                } else {
                    const errorMsg = `Failed to load events for org ${orgId}: ${result?.errors?.[0] || "Unknown error"}`;
                    loadErrors.push(errorMsg);
                    logCallback?.(errorMsg);
                }
            } catch (error) {
                const errorMsg = `Failed to load events for org ${orgId}: ${error.message || "Unknown error"}`;
                loadErrors.push(errorMsg);
                logCallback?.(errorMsg);
            }
        }
        if (loadErrors.length > 0) setErrors(loadErrors);
        setConversationalSuccessEvents(allEvents);
        setLoading(false);
        // Return the loaded events
        return allEvents;
    };
    const loadConversationalSuccessEventsPagedForOrg = async (orgId, filter)=>{
        let skip = 0;
        let take = 200;
        let allEvents = [];
        let hasMore = true;
        while(hasMore){
            const result = await _api.getConversationalSuccessEvents(orgId, {
                ...filter,
                skip,
                take
            });
            if (result.resultType === "Ok") {
                allEvents = [
                    ...allEvents,
                    ...result.data
                ];
                hasMore = result.data.length === take;
                skip += take;
            } else return result;
        }
        return {
            resultType: "Ok",
            data: allEvents,
            errors: null
        };
    };
    return {
        loading,
        setLoading,
        errors,
        unsuccessfulOrderSessionIds,
        orderAttempts,
        ordersPlaced,
        sessions,
        orderPlacedRate,
        orderTransferRate,
        transferRate,
        transfers,
        orderTransfers,
        allEventsCache,
        noOrderSessionIds,
        immediateTransfers,
        immediateTransferRate,
        loadingSessionId,
        ordersPlacedSessionIds,
        orderPlacedEvents,
        orderTransferredSessionIds,
        conversationalSuccessRate,
        attemptedOrdersConversationalSuccessRate,
        loadOrderingAnalytics,
        loadAllEventsForSession,
        loadConversationalSuccessEvents,
        loadConversationalSuccessEventsForOrgs,
        loadOrderPlacedEventsPaged,
        loadCallCompleteEventsPaged,
        loadConversationalSuccessEventsPaged,
        callCompleteEvents,
        conversationalSuccessEvents,
        conversationalSuccess,
        attemptedOrderConversationalSuccess,
        // New calculated metrics - App level
        healthcareAppMetrics,
        foodOrderingAppMetrics,
        calculateLaborSavings,
        // Org level calculation functions
        calculateHealthcareOrgMetrics
    };
}
const TelephonyAnalyticsContainer = (0, _unstatedNext.createContainer)(useTelephonyAnalyticsContainer);
exports.default = TelephonyAnalyticsContainer;

},{"unstated-next":"61zE5","react":"6uln9","../api":"loxM6","../constants/analyticsConstants/generativeCallReview":"5Shd2","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"eP5el":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TagsWrap", ()=>TagsWrap);
var _base = require("@emotion/styled/base");
var _baseDefault = parcelHelpers.interopDefault(_base);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _reactRouterDom = require("react-router-dom");
var _contentCollapsingSection = require("../structure/ContentCollapsingSection");
var _contentCollapsingSectionDefault = parcelHelpers.interopDefault(_contentCollapsingSection);
var _customScrollbars = require("../structure/CustomScrollbars");
var _customScrollbarsDefault = parcelHelpers.interopDefault(_customScrollbars);
var _sessionAnalyticsContainer = require("../../hooks/SessionAnalyticsContainer");
var _sessionAnalyticsContainerDefault = parcelHelpers.interopDefault(_sessionAnalyticsContainer);
var _analyticsDateFormat = require("../../models/analytics/AnalyticsDateFormat");
var _moment = require("moment");
var _momentDefault = parcelHelpers.interopDefault(_moment);
var _useProcessConversationalSuccessEvents = require("../../hooks/UseProcessConversationalSuccessEvents");
var _tagFilterModal = require("./TagFilterModal");
var _searchField = require("../forms/SearchField");
var _searchFieldDefault = parcelHelpers.interopDefault(_searchField);
var _totalCard = require("../charts/TotalCard");
var _totalCardDefault = parcelHelpers.interopDefault(_totalCard);
var _lodash = require("lodash");
var _telephonyAnalyticsContainer = require("../../hooks/TelephonyAnalyticsContainer");
var _telephonyAnalyticsContainerDefault = parcelHelpers.interopDefault(_telephonyAnalyticsContainer);
var _api = require("../../api");
var _generativeCallReview = require("../../constants/analyticsConstants/generativeCallReview");
var _featureFlagIds = require("../../constants/featureFlagIds");
var _colors = require("../../constants/colors");
var _breakpoints = require("../../constants/breakpoints");
var _button = require("../general/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _tooltipWrapper = require("../general/TooltipWrapper");
var _tooltipWrapperDefault = parcelHelpers.interopDefault(_tooltipWrapper);
var _toggleIndicator = require("../general/ToggleIndicator");
var _toggleIndicatorDefault = parcelHelpers.interopDefault(_toggleIndicator);
var _sessionTags = require("./SessionTags");
var _sessionTagsDefault = parcelHelpers.interopDefault(_sessionTags);
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const outputIcon = require("42c6803afe20164c");
const assistantIssueIcon = require("50edd29fab35f5b");
const transferredIcon = require("85fcb9f775fcd9a8");
const orderPlacedIcon = require("bab853a0092b16ac");
const copyIcon = require("9d0d949b1a70269d");
const TAGS_WITH_SUMMARY_CARDS = []; // Can update this with tag names in the future if we want to show summary cards for specific tags
const SESSIONS_PER_PAGE = 50; // Number of sessions to show per page
const AUTO_REFRESH_INTERVAL_MINUTES = 5; // Auto-refresh interval in minutes for cross-org mode when end date is after now
const ALL_POSSIBLE_TAGS = [
    ...(0, _generativeCallReview.ALL_TAGS)
];
// Styled components defined outside the component to prevent recreation on every render
const StyledContentCollapsingSection = /*#__PURE__*/ (0, _baseDefault.default)((0, _contentCollapsingSectionDefault.default), {
    target: "e16vk8gr62"
})({
    name: "19g75hm",
    styles: "margin:0;.card-title-container h4 a{white-space:nowrap;overflow:hidden;text-overflow:ellipsis;display:inline-block;max-width:100%;vertical-align:middle;}"
});
const ScrollableSessionContainer = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e16vk8gr61"
})({
    name: "pw7jst",
    styles: "position:relative;width:100%"
});
const SessionList = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e16vk8gr60"
})({
    name: "15xu7xb",
    styles: "display:flex;flex-direction:column;gap:14px;padding:0 16px"
});
const NoDataMessage = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e16vk8gr59"
})({
    name: "l6fbdl",
    styles: "display:flex;align-items:center;justify-content:center;padding:32px 16px;color:#6b7280;font-style:italic;text-align:center;background:#f9fafb;border-radius:8px;margin:8px 0"
});
const NoTagsMessage = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e16vk8gr58"
})({
    name: "1h9plig",
    styles: "display:flex;align-items:center;justify-content:center;width:100%;padding:32px 16px;color:#6b7280;font-style:italic;text-align:center;background:#f9fafb;border-radius:8px;margin:16px 32px"
});
const SessionRow = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e16vk8gr57"
})("width:100%;display:flex;flex-direction:row;align-items:center;justify-content:space-between;min-height:40px;padding:8px 24px;margin:0;background:#f7f9fa;border:1px solid #d8d8d8;border-radius:", (props)=>props.isCollapsed ? "8px" : "8px 8px 0 0", ";overflow:hidden;white-space:nowrap;text-overflow:ellipsis;gap:16px;");
const SummaryDisplay = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e16vk8gr56"
})({
    name: "1t6ij0q",
    styles: "width:100%;box-sizing:border-box;display:block;padding:16px 24px;margin:0;background:#ffffff;border:1px solid #d8d8d8;border-top:none;border-radius:0 0 8px 8px;line-height:1.5;div{margin-bottom:4px;&:last-child{margin-bottom:0;}}"
});
const CollapsingSectionSubtitle = /*#__PURE__*/ (0, _baseDefault.default)("label", {
    target: "e16vk8gr55"
})("display:flex;flex-direction:row;align-items:center;gap:8px;flex-wrap:wrap;", (props)=>props.hasMatches === false ? `color: #9ca3af;` : "", ";");
const FilterResultsText = /*#__PURE__*/ (0, _baseDefault.default)("span", {
    target: "e16vk8gr54"
})("font-weight:normal;color:", (0, _colors.color_text_light), ";");
const FilterResultsContainer = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e16vk8gr53"
})({
    name: "5boble",
    styles: "display:flex;align-items:center;flex-wrap:wrap;gap:4px;font-size:14px"
});
const FilterTagsDisplay = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e16vk8gr52"
})({
    name: "m1fnek",
    styles: "display:inline-flex;flex-wrap:wrap;gap:4px;align-items:center"
});
const TitleStatsText = /*#__PURE__*/ (0, _baseDefault.default)("span", {
    target: "e16vk8gr51"
})("font-weight:normal;color:", (0, _colors.color_text_light), ";margin-left:8px;font-size:14px;");
const FilterTagPill = /*#__PURE__*/ (0, _baseDefault.default)("span", {
    target: "e16vk8gr50"
})("display:inline-flex;align-items:center;background:", (props)=>{
    if (props.isExcluded) // Keep original background color for excluded tags, but make it slightly muted
    return props.tagColors?.background || "#f3f4f6";
    return props.tagColors?.background || "#f3f4f6";
}, ";color:", (props)=>{
    if (props.isExcluded) // Keep original color but make it slightly darker/muted
    return props.tagColors?.color || "#6b7280";
    return props.tagColors?.color || "#6b7280";
}, ";border:", (props)=>props.isExcluded ? `1px solid ${props.tagColors?.border || "#d1d5db"}` : "none", ";font-size:0.75rem;padding:0px 6px;border-radius:9999px;white-space:nowrap;height:18px;font-style:normal;opacity:", (props)=>props.isExcluded ? "0.7" : "1", ";");
const NotPrefix = /*#__PURE__*/ (0, _baseDefault.default)("span", {
    target: "e16vk8gr49"
})("color:", (0, _colors.color_colors_decline), ";font-weight:600;margin-right:4px;");
const FilterNoResultsMessage = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e16vk8gr48"
})({
    name: "l0to5w",
    styles: "margin:32px 0;padding:16px 32px"
});
const GenerativeSessionReviewRow = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e16vk8gr47"
})("display:flex;align-items:center;justify-content:space-between;", (0, _breakpoints.breakpoint_small), "{flex-direction:column;align-items:stretch;gap:16px;}");
const CustomSearchWrapper = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e16vk8gr46"
})("margin-right:auto;", (0, _breakpoints.breakpoint_small), "{margin-right:0;width:100%;}");
const CustomSearch = /*#__PURE__*/ (0, _baseDefault.default)((0, _searchFieldDefault.default), {
    target: "e16vk8gr45"
})({
    name: "1djf4tj",
    styles: "margin:0;padding:0;div>.field-container{height:32px;box-shadow:none;border-radius:8px;margin:0;padding:0;}input::placeholder{font-size:0.75rem;}"
});
const SessionLink = /*#__PURE__*/ (0, _baseDefault.default)((0, _reactRouterDom.Link), {
    target: "e16vk8gr44"
})("all:unset;width:100%;cursor:pointer;display:block;&:hover ", SessionRow, ",&:focus ", SessionRow, "{background:#eaf3ff;}&:hover ", SummaryDisplay, ",&:focus ", SummaryDisplay, "{background:#f9fbff;}");
const CollapseButton = /*#__PURE__*/ (0, _baseDefault.default)("button", {
    target: "e16vk8gr43"
})({
    name: "g6cmma",
    styles: "background:none;border:none;padding:12px;cursor:pointer;color:#6b7280;font-size:0.75rem;display:flex;align-items:center;justify-content:center;min-width:32px;min-height:32px;border-radius:4px;&:hover{background-color:rgba(0, 0, 0, 0.05);}&:focus{outline:none;background-color:rgba(0, 0, 0, 0.1);}& .toggle-indicator{width:6px;height:6px;}"
});
const CollapsibleSessionCard = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e16vk8gr42"
})({
    name: "ytgpr9",
    styles: "width:100%;transition:opacity 0.2s ease"
});
const SessionLeftSide = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e16vk8gr41"
})({
    name: "1yydxi7",
    styles: "display:flex;align-items:center;gap:8px"
});
const TagsWrap = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e16vk8gr40"
})("display:flex;flex-wrap:wrap;gap:4px;align-items:center;", (0, _breakpoints.breakpoint_small), "{display:none;}", (0, _breakpoints.breakpoint_small_landscape), "{display:none;}");
const NoTagsPill = /*#__PURE__*/ (0, _baseDefault.default)("span", {
    target: "e16vk8gr39"
})({
    name: "1hgq1xq",
    styles: "display:inline-flex;align-items:center;background:#f3f4f6;color:#6b7280;font-size:0.75rem;padding:0px 6px;border-radius:9999px;white-space:nowrap;height:18px"
});
const StyledTotalCard = /*#__PURE__*/ (0, _baseDefault.default)((0, _totalCardDefault.default), {
    target: "e16vk8gr38"
})({
    name: "7ubfuv",
    styles: "padding:32px;text-align:center;height:auto;margin:0px 32px 32px 32px"
});
const CallBreakdownTitle = /*#__PURE__*/ (0, _baseDefault.default)("h3", {
    target: "e16vk8gr37"
})({
    name: "1myk5fr",
    styles: "font-size:1.125rem;font-weight:500;color:#374151;margin:0;padding:0"
});
const CallBreakdownTitleSection = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e16vk8gr36"
})("display:flex;align-items:center;gap:16px;", (0, _breakpoints.breakpoint_small), "{flex-direction:column;align-items:flex-start;gap:8px;}");
const LoadingLogBox = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e16vk8gr35"
})("background:#f8f9fa;border:1px solid #e5e7eb;border-radius:6px;padding:8px 12px;min-width:250px;max-width:400px;height:54px;font-size:0.75rem;color:#6b7280;overflow-y:auto;overflow-x:hidden;scrollbar-width:none;-ms-overflow-style:none;&::-webkit-scrollbar{display:none;}", (0, _breakpoints.breakpoint_small), "{min-width:auto;max-width:100%;width:100%;height:54px;}");
const LogEntry = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e16vk8gr34"
})({
    name: "1lxhupv",
    styles: "margin-bottom:2px;&:last-child{margin-bottom:0;}"
});
const CallBreakdownSectionWrapper = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e16vk8gr33"
})("width:100vw;margin:0 0 0 calc(-50vw + 50%);background:#ffffff;border-top:1px solid #e5e7eb;border-left:none;border-right:none;border-bottom:none;padding:32px 0 32px 0;", (0, _breakpoints.breakpoint_small), "{padding:16px 0 16px 0;}", (0, _breakpoints.breakpoint_small_landscape), "{padding:24px 0 24px 0;}");
const CallBreakdownHeader = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e16vk8gr32"
})("display:flex;justify-content:space-between;align-items:flex-start;width:100%;padding:0 32px;", (0, _breakpoints.breakpoint_small), "{flex-direction:column;align-items:stretch;gap:16px;padding:0 16px;}", (0, _breakpoints.breakpoint_small_landscape), "{padding:0 20px;}");
const CallBreakdownControls = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e16vk8gr31"
})("display:flex;align-items:center;gap:16px;", (0, _breakpoints.breakpoint_small), "{flex-direction:column;align-items:stretch;gap:8px;width:100%;}", (0, _breakpoints.breakpoint_small_landscape), "{flex-wrap:wrap;gap:8px;}");
const GenerativeReportContainer = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e16vk8gr30"
})({
    name: "1hq5uy7",
    styles: "padding-bottom:24px;overflow:visible;@media (max-width: 768px){padding-bottom:16px;}@media (min-width: 1200px){padding-bottom:32px;}"
});
const FullWidthSectionWrapper = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e16vk8gr29"
})({
    name: "1duqu3e",
    styles: "width:100vw;margin-left:calc(-50vw + 50%);.card-body{padding:0px;}"
});
const SessionTimestamp = /*#__PURE__*/ (0, _baseDefault.default)("span", {
    target: "e16vk8gr28"
})({
    name: "1nmxss3",
    styles: "font-size:0.875rem;color:#6b7280;font-weight:normal"
});
const PhoneNumberDisplay = /*#__PURE__*/ (0, _baseDefault.default)("span", {
    target: "e16vk8gr27"
})({
    name: "1xvnii3",
    styles: "font-size:0.75rem;color:#6b7280;font-weight:normal;margin-left:8px;font-family:monospace"
});
const SessionRightSide = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e16vk8gr26"
})({
    name: "1wcglds",
    styles: "display:flex;align-items:center;gap:16px"
});
const SessionControls = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e16vk8gr25"
})({
    name: "n63afj",
    styles: "display:flex;align-items:center;gap:4px;margin-bottom:2px"
});
const SessionIdDisplay = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e16vk8gr24"
})({
    name: "qiaz7u",
    styles: "font-size:0.75rem;color:#374151;display:flex;align-items:center;gap:4px;white-space:nowrap;margin-left:8px;margin-right:8px"
});
const CopiedIndicator = /*#__PURE__*/ (0, _baseDefault.default)("span", {
    target: "e16vk8gr23"
})({
    name: "247q4y",
    styles: "font-size:0.75rem;color:#10b981;font-weight:500"
});
const SmallSessionButton = /*#__PURE__*/ (0, _baseDefault.default)((0, _buttonDefault.default), {
    target: "e16vk8gr22"
})({
    name: "orkwxu",
    styles: "height:24px;padding:0 8px;font-size:0.75rem;font-weight:normal;margin:0;border-radius:12px;.secondary-loader{margin-top:-5px;}"
});
const SmallCopyButton = /*#__PURE__*/ (0, _baseDefault.default)((0, _buttonDefault.default), {
    target: "e16vk8gr21"
})({
    name: "1b949o5",
    styles: "height:24px;width:24px;padding:0;margin:0;min-width:24px;border:none;background:transparent;&:hover{background:transparent;}.secondary-loader{margin-top:-5px;}"
});
const ResetFiltersButton = /*#__PURE__*/ (0, _baseDefault.default)((0, _buttonDefault.default), {
    target: "e16vk8gr20"
})({
    name: "1x3kbdj",
    styles: "height:32px;padding:0 12px;font-size:0.875rem;font-weight:500;margin:0;border-radius:6px;display:flex;align-items:center;justify-content:center;&:disabled{opacity:0.5;cursor:not-allowed;}.secondary-loader{position:absolute;top:50%;left:50%;transform:translate(-50%, -50%);margin:0;.spinner{margin:0;height:20px;}}"
});
const FilterModalButton = /*#__PURE__*/ (0, _baseDefault.default)((0, _buttonDefault.default), {
    target: "e16vk8gr19"
})({
    name: "1d859pg",
    styles: "padding:8px 12px;font-size:0.85rem;min-height:auto;height:fit-content;margin:0;&:disabled{opacity:0.5;cursor:not-allowed;}"
});
const LoadEngagementsButton = /*#__PURE__*/ (0, _baseDefault.default)((0, _buttonDefault.default), {
    target: "e16vk8gr18"
})({
    name: "q77pbv",
    styles: "padding:8px 12px;font-size:0.85rem;min-height:auto;height:32px;margin:0;display:flex;align-items:center;justify-content:center;&:disabled{opacity:0.5;cursor:not-allowed;}"
});
const ExportCSVButton = /*#__PURE__*/ (0, _baseDefault.default)((0, _buttonDefault.default), {
    target: "e16vk8gr17"
})({
    name: "q77pbv",
    styles: "padding:8px 12px;font-size:0.85rem;min-height:auto;height:32px;margin:0;display:flex;align-items:center;justify-content:center;&:disabled{opacity:0.5;cursor:not-allowed;}"
});
const FilteredStatsDisplay = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e16vk8gr16"
})("display:flex;flex-direction:row;gap:8px;margin-right:8px;padding:8px 0;max-width:800px;min-height:34px;align-items:center;", (0, _breakpoints.breakpoint_small), "{flex-direction:column;align-items:flex-start;margin-right:0;padding:4px 0;gap:4px;width:100%;}", (0, _breakpoints.breakpoint_small_landscape), "{max-width:100%;margin-right:0;}");
const FilteredStatsText = /*#__PURE__*/ (0, _baseDefault.default)("span", {
    target: "e16vk8gr15"
})("color:", (0, _colors.color_text_light), ";font-weight:500;font-size:0.875rem;");
const FilteredStatsTextContainer = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e16vk8gr14"
})({
    name: "s5xdrg",
    styles: "display:flex;align-items:center"
});
const FilteredTagsContainer = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e16vk8gr13"
})("display:flex;gap:4px;align-items:center;max-width:600px;overflow:hidden;flex-shrink:0;", (0, _breakpoints.breakpoint_small), "{display:none;}", (0, _breakpoints.breakpoint_small_landscape), "{display:none;}");
const FilteredTagPill = /*#__PURE__*/ (0, _baseDefault.default)("span", {
    target: "e16vk8gr12"
})("display:inline-flex;align-items:center;background:", (props)=>{
    if (props.isExcluded) return props.tagColors?.background || "#f3f4f6";
    return props.tagColors?.background || "#f3f4f6";
}, ";color:", (props)=>{
    if (props.isExcluded) return props.tagColors?.color || "#6b7280";
    return props.tagColors?.color || "#6b7280";
}, ";border:", (props)=>props.isExcluded ? `1px solid ${props.tagColors?.border || "#d1d5db"}` : "none", ";font-size:0.75rem;padding:2px 6px;border-radius:9999px;white-space:nowrap;height:18px;font-style:normal;opacity:", (props)=>props.isExcluded ? "0.7" : "1", ";");
const FilteredSearchPill = /*#__PURE__*/ (0, _baseDefault.default)("span", {
    target: "e16vk8gr11"
})("display:inline-flex;align-items:center;background:", (0, _colors.color_shades_lighter), ";color:", (0, _colors.color_shades_darker), ";font-size:0.75rem;padding:2px 6px;border-radius:9999px;white-space:nowrap;height:18px;font-style:italic;");
const MoreFiltersIndicator = /*#__PURE__*/ (0, _baseDefault.default)("span", {
    target: "e16vk8gr10"
})("display:inline-flex;align-items:center;background:", (0, _colors.color_shades_light), ";color:", (0, _colors.color_shades_darker), ";font-size:0.75rem;padding:2px 6px;border-radius:9999px;white-space:nowrap;height:18px;font-weight:500;font-style:italic;cursor:pointer;");
const PaginationContainer = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e16vk8gr9"
})("display:flex;justify-content:space-between;align-items:center;padding:16px 24px 8px 24px;background:", (0, _colors.color_shades_lightest), ";", (0, _breakpoints.breakpoint_small), "{flex-direction:column;gap:12px;padding:12px 16px;}");
const EmptyPaginationContainer = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e16vk8gr8"
})("height:16px;background:", (0, _colors.color_shades_lightest), ";");
const PaginationInfo = /*#__PURE__*/ (0, _baseDefault.default)("span", {
    target: "e16vk8gr7"
})("font-size:0.875rem;color:", (0, _colors.color_text_light), ";font-weight:500;");
const PaginationControls = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e16vk8gr6"
})({
    name: "1yydxi7",
    styles: "display:flex;align-items:center;gap:8px"
});
const PaginationButton = /*#__PURE__*/ (0, _baseDefault.default)((0, _buttonDefault.default), {
    target: "e16vk8gr5"
})({
    name: "qrbvoc",
    styles: "min-width:80px;height:32px;font-size:0.875rem;padding:0 12px"
});
const PageNumbers = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e16vk8gr4"
})("display:flex;align-items:center;gap:4px;margin:0 8px;", (0, _breakpoints.breakpoint_small), "{margin:0 4px;}");
const PageNumber = /*#__PURE__*/ (0, _baseDefault.default)("button", {
    target: "e16vk8gr3"
})("display:flex;align-items:center;justify-content:center;width:32px;height:32px;border:1px solid ", (props)=>props.active ? (0, _colors.color_colors_ocean) : (0, _colors.color_shades_dark), ";background:", (props)=>props.active ? (0, _colors.color_colors_ocean) : (0, _colors.color_defaults_white), ";color:", (props)=>props.active ? (0, _colors.color_defaults_white) : (0, _colors.color_text_default), ";font-size:0.875rem;font-weight:", (props)=>props.active ? "600" : "400", ";border-radius:6px;cursor:pointer;transition:all 0.2s ease;&:hover{background:", (props)=>props.active ? (0, _colors.color_colors_ocean) : (0, _colors.color_shades_lighter), ";border-color:", (props)=>props.active ? (0, _colors.color_colors_ocean) : (0, _colors.color_shades_darker), ";}&:focus{outline:none;box-shadow:0 0 0 3px ", (0, _colors.color_variants_ocean_light_1), ";}");
const PageEllipsis = /*#__PURE__*/ (0, _baseDefault.default)("span", {
    target: "e16vk8gr2"
})("display:flex;align-items:center;justify-content:center;width:32px;height:32px;color:", (0, _colors.color_shades_darker), ";font-size:0.875rem;font-weight:500;");
const SummaryLine = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e16vk8gr1"
})({
    name: "1089mxj",
    styles: "white-space:pre-wrap"
});
const SessionIdList = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e16vk8gr0"
})({
    name: "1ufh210",
    styles: "display:flex;flex-direction:row;flex-wrap:wrap;gap:8px;margin:8px 0"
});
const GenerativeReportTable = (props)=>{
    const [sessionReviews, setSessionReviews] = (0, _react1.useState)([]);
    const [processingReviews, setProcessingReviews] = (0, _react1.useState)(false);
    const [selectedTags, setSelectedTags] = (0, _react1.useState)([]);
    const [excludedTags, setExcludedTags] = (0, _react1.useState)([]);
    const [searchFieldValue, setSearchFieldValue] = (0, _react1.useState)("");
    const [visibleSessionIds, setVisibleSessionIds] = (0, _react1.useState)([]);
    const [copiedSessionId, setCopiedSessionId] = (0, _react1.useState)(null);
    const [collapsedCards, setCollapsedCards] = (0, _react1.useState)([]);
    const [featureFlag, setFeatureFlag] = (0, _react1.useState)(undefined);
    const [crossOrgSessions, setCrossOrgSessions] = (0, _react1.useState)([]);
    const [loadingLog, setLoadingLog] = (0, _react1.useState)([]);
    const [debouncedSelectedTags, setDebouncedSelectedTags] = (0, _react1.useState)([]);
    const [debouncedExcludedTags, setDebouncedExcludedTags] = (0, _react1.useState)([]);
    const [debouncedSearchFieldValue, setDebouncedSearchFieldValue] = (0, _react1.useState)("");
    const [resettingFilters, setResettingFilters] = (0, _react1.useState)(false);
    const [hasInitiallyLoaded, setHasInitiallyLoaded] = (0, _react1.useState)(false);
    const [categoryCurrentPages, setCategoryCurrentPages] = (0, _react1.useState)({});
    const [isFilterModalOpen, setIsFilterModalOpen] = (0, _react1.useState)(false);
    const [isApplyingFilters, setIsApplyingFilters] = (0, _react1.useState)(false);
    const [hasLoadedCrossOrgData, setHasLoadedCrossOrgData] = (0, _react1.useState)(false);
    const [filterLogic, setFilterLogic] = (0, _react1.useState)("AND");
    const [lastLoadTime, setLastLoadTime] = (0, _react1.useState)(null);
    const loadingLogRef = (0, _react1.useRef)(null);
    const filterDebounceRef = (0, _react1.useRef)(null);
    const autoRefreshIntervalRef = (0, _react1.useRef)(null);
    const selectedTagsSet = (0, _react1.useMemo)(()=>new Set(selectedTags), [
        selectedTags
    ]);
    const excludedTagsSet = (0, _react1.useMemo)(()=>new Set(excludedTags), [
        excludedTags
    ]);
    const sessionContainer = props.sessionContainer || (0, _sessionAnalyticsContainerDefault.default).useContainer();
    const orderingAnalyticsContainer = props.orderingAnalyticsContainer || (0, _telephonyAnalyticsContainerDefault.default).useContainer();
    const memoizedFilter = (0, _react1.useMemo)(()=>props.filter, [
        JSON.stringify(props.filter)
    ]);
    // Helper function to get application name by ID
    const getAppNameById = (0, _react1.useCallback)((appId)=>{
        if (props.applications) {
            const app = props.applications.find((a)=>a.id === appId);
            return app?.name || appId;
        }
        return appId;
    }, [
        props.applications
    ]);
    const availableCategories = (0, _reactDefault.default).useMemo(()=>{
        const desiredOrder = [
            "ACTION_ATTEMPTED",
            "OTHER",
            "IMMEDIATE_TRANSFER",
            "NO_INTERACTION"
        ];
        const uniqueCategories = Array.from(new Set(sessionReviews.map((r)=>r.category)));
        return desiredOrder.filter((cat)=>uniqueCategories.includes(cat)).concat(uniqueCategories.filter((cat)=>!desiredOrder.includes(cat)));
    }, [
        sessionReviews
    ]);
    // Optimized: Combine tag computation and use Set for faster lookups
    const { availableTags, tagsForDisplay } = (0, _react1.useMemo)(()=>{
        const tagSet = new Set([
            ...ALL_POSSIBLE_TAGS
        ]);
        let hasSessionsWithoutTags = false;
        // Single pass through session reviews
        for (const review of sessionReviews){
            if (review.tags && review.tags.length > 0) for (const tag of review.tags)tagSet.add(tag);
            else hasSessionsWithoutTags = true;
        }
        const tags = Array.from(tagSet);
        let sortedTags = (0, _generativeCallReview.sortTagsByPriority)(tags, featureFlag);
        if (!props.crossOrgMode) sortedTags = sortedTags.filter((tag)=>!tag?.toLowerCase().startsWith("vfy_"));
        if (hasSessionsWithoutTags && !sortedTags.includes("NO_TAGS_AVAILABLE")) sortedTags.push("NO_TAGS_AVAILABLE");
        // Compute display names in the same memo
        const displayNames = sortedTags.map((tag)=>tag === "NO_TAGS_AVAILABLE" ? "Untagged" : (0, _generativeCallReview.getTagName)(tag, featureFlag) || tag);
        return {
            availableTags: sortedTags,
            tagsForDisplay: displayNames
        };
    }, [
        sessionReviews,
        featureFlag
    ]);
    const getFeatureFlag = ()=>{
        if (props.application?.featureFlags?.some((flag)=>flag.id === (0, _featureFlagIds.FoodOrderingFeatureFlagId))) return "FOOD_ORDERING";
        else if (props.application?.featureFlags?.some((flag)=>flag.id === (0, _featureFlagIds.HealthcareSchedulingFeatureFlagId))) return "HEALTHCARE";
        else return undefined;
    };
    (0, _react1.useEffect)(()=>{
        const flag = getFeatureFlag();
        setFeatureFlag(flag);
    }, [
        props.applicationId,
        props.application?.featureFlags
    ]);
    (0, _react1.useEffect)(()=>{
        if (!props.crossOrgMode && !props.currentOrgMode) getGenerativeSessionReviews();
    }, [
        props.applicationId,
        props.crossOrgMode,
        props.currentOrgMode,
        props.orgIds,
        props.appIds,
        memoizedFilter
    ]);
    // Reset cross-org/current-org data loaded state when filter changes
    (0, _react1.useEffect)(()=>{
        if (props.crossOrgMode || props.currentOrgMode) setHasLoadedCrossOrgData(false);
    }, [
        props.applicationId,
        props.crossOrgMode,
        props.currentOrgMode,
        props.orgIds,
        props.appIds,
        memoizedFilter
    ]);
    // Auto-refresh logic for cross-org mode or current org mode when end date is after now
    (0, _react1.useEffect)(()=>{
        // Clear any existing interval
        if (autoRefreshIntervalRef.current) {
            clearInterval(autoRefreshIntervalRef.current);
            autoRefreshIntervalRef.current = null;
        }
        // Only set up auto-refresh if:
        // 1. We're in cross-org mode or current org mode
        // 2. We've loaded data at least once
        // 3. The end date is after the current time
        const isMultiMode = props.crossOrgMode || props.currentOrgMode;
        if (isMultiMode && hasLoadedCrossOrgData && lastLoadTime) {
            const endDate = memoizedFilter.endDate ? (0, _momentDefault.default)(memoizedFilter.endDate) : null;
            const now = (0, _momentDefault.default)();
            if (endDate && endDate.isAfter(now)) // Set up interval to check for new sessions every 5 minutes
            autoRefreshIntervalRef.current = setInterval(()=>{
                loadNewSessions();
            }, AUTO_REFRESH_INTERVAL_MINUTES * 60000); // Convert minutes to milliseconds
        }
        // Cleanup on unmount or when dependencies change
        return ()=>{
            if (autoRefreshIntervalRef.current) {
                clearInterval(autoRefreshIntervalRef.current);
                autoRefreshIntervalRef.current = null;
            }
        };
    }, [
        props.crossOrgMode,
        props.currentOrgMode,
        hasLoadedCrossOrgData,
        lastLoadTime,
        memoizedFilter.endDate
    ]);
    (0, _react1.useEffect)(()=>{
        // Sync local processing state with container loading state only in single app mode
        // Only sync if we have initially loaded data (to prevent initial flash)
        const isMultiMode = props.crossOrgMode || props.currentOrgMode;
        if (!isMultiMode && hasInitiallyLoaded) setProcessingReviews(orderingAnalyticsContainer.loading || sessionContainer.loading);
    }, [
        orderingAnalyticsContainer.loading,
        sessionContainer.loading,
        props.crossOrgMode,
        props.currentOrgMode,
        hasInitiallyLoaded
    ]);
    (0, _react1.useEffect)(()=>{
        if (props.onProcessingChange) props.onProcessingChange(processingReviews);
    }, [
        processingReviews,
        props.onProcessingChange
    ]);
    // Auto-scroll loading log to bottom when new logs are added
    (0, _react1.useEffect)(()=>{
        if (loadingLogRef.current) loadingLogRef.current.scrollTop = loadingLogRef.current.scrollHeight;
    }, [
        loadingLog
    ]);
    // Memoize phone number lookup for better performance
    const sessionPhoneNumbers = (0, _react1.useMemo)(()=>{
        const phoneMap = new Map();
        const isMultiMode = props.crossOrgMode || props.currentOrgMode;
        const sessions = isMultiMode ? crossOrgSessions : sessionContainer.sessions;
        for (const session of sessions)if (session.sessionId && session?.from) phoneMap.set(session.sessionId, session?.from);
        return phoneMap;
    }, [
        props.crossOrgMode,
        props.currentOrgMode,
        crossOrgSessions,
        sessionContainer.sessions
    ]);
    // Debounce filter changes to improve performance with large datasets
    (0, _react1.useEffect)(()=>{
        // Clear existing debounce timer
        if (filterDebounceRef.current) clearTimeout(filterDebounceRef.current);
        // Reduced debounce delay for better responsiveness
        filterDebounceRef.current = setTimeout(()=>{
            setDebouncedSelectedTags(selectedTags);
            setDebouncedExcludedTags(excludedTags);
            setDebouncedSearchFieldValue(searchFieldValue);
        }, 500);
        // Cleanup function to clear timer on unmount or dependency change
        return ()=>{
            if (filterDebounceRef.current) clearTimeout(filterDebounceRef.current);
        };
    }, [
        selectedTags,
        excludedTags,
        searchFieldValue
    ]);
    // Initialize debounced values on first load
    (0, _react1.useEffect)(()=>{
        setDebouncedSelectedTags(selectedTags);
        setDebouncedExcludedTags(excludedTags);
        setDebouncedSearchFieldValue(searchFieldValue);
    }, [
        sessionReviews
    ]); // Only run when sessionReviews changes (initial load)
    // Reset pagination when filters change
    (0, _react1.useEffect)(()=>{
        setCategoryCurrentPages({});
    }, [
        debouncedSelectedTags,
        debouncedExcludedTags,
        debouncedSearchFieldValue
    ]);
    const stop = (e)=>e.stopPropagation();
    const toggleSessionIdVisibility = (sessionId, e)=>{
        e.preventDefault();
        e.stopPropagation();
        setVisibleSessionIds((prev)=>{
            if (prev.includes(sessionId)) return prev.filter((id)=>id !== sessionId);
            else return [
                ...prev,
                sessionId
            ];
        });
    };
    const copySessionId = (sessionId, e)=>{
        e.preventDefault();
        e.stopPropagation();
        navigator.clipboard.writeText(sessionId);
        setCopiedSessionId(sessionId);
        setTimeout(()=>{
            setCopiedSessionId(null);
        }, 2000);
    };
    const toggleCardCollapse = (sessionId, e)=>{
        e.preventDefault();
        e.stopPropagation();
        setCollapsedCards((prev)=>{
            if (prev.includes(sessionId)) return prev.filter((id)=>id !== sessionId);
            else return [
                ...prev,
                sessionId
            ];
        });
    };
    // Memoize session timestamps for better performance
    const sessionTimestamps = (0, _react1.useMemo)(()=>{
        const timestampMap = new Map();
        const isMultiMode = props.crossOrgMode || props.currentOrgMode;
        const sessions = isMultiMode ? crossOrgSessions : sessionContainer.sessions;
        for (const session of sessions)if (session?.sessionId && session?.startDate) timestampMap.set(session?.sessionId, (0, _momentDefault.default)(session?.startDate).format((0, _analyticsDateFormat.SESSION_DATE_FORMAT)));
        return timestampMap;
    }, [
        props.crossOrgMode,
        props.currentOrgMode,
        crossOrgSessions,
        sessionContainer.sessions
    ]);
    const getSessionTimeStamp = (0, _react1.useCallback)((review)=>{
        return sessionTimestamps.get(review.sessionId) || "N/A";
    }, [
        sessionTimestamps
    ]);
    const getSessionPhoneNumber = (0, _react1.useCallback)((review)=>{
        return sessionPhoneNumbers.get(review.sessionId);
    }, [
        sessionPhoneNumbers
    ]);
    const formatLastFourDigits = (phoneNumber)=>{
        if (!phoneNumber) return null;
        // Remove any non-digit characters from the input number
        const cleanedNumber = phoneNumber.replace(/\D/g, "");
        // Return last 4 digits if the number is long enough
        if (cleanedNumber.length >= 4) return cleanedNumber.substring(cleanedNumber.length - 4);
        return cleanedNumber;
    };
    const formatSummaryText = (text)=>{
        if (!text) return text;
        const trimmedText = text.trim();
        if (!trimmedText) return trimmedText;
        const lines = trimmedText.split("\n");
        const formattedLines = lines.map((line)=>{
            const trimmedLine = line.trim();
            if (trimmedLine.startsWith("- ")) // Replace "- " with bullet point and return as a list item
            return `• ${trimmedLine.substring(2)}`;
            if (trimmedLine.startsWith("* ")) // Replace "* " with bullet point and return as a list item
            return `• ${trimmedLine.substring(2)}`;
            return trimmedLine;
        });
        return formattedLines.join("\n").trim();
    };
    const getIconByTagLabel = (tag)=>{
        const mappedTagName = (0, _generativeCallReview.getTagName)(tag, featureFlag);
        switch(mappedTagName){
            case "Unsupported Request":
            case "AI Issue":
                return assistantIssueIcon;
            case "Transferred":
                return transferredIcon;
            case "Order Placed":
            case "Appointment Scheduled":
                return orderPlacedIcon;
            default:
                return null;
        }
    };
    const toggleTag = (0, _react1.useCallback)((tag, mode = "include")=>{
        if (mode === "include") {
            if (excludedTags.includes(tag)) {
                // If it's currently excluded and we're toggling to include, just remove from excluded
                setExcludedTags((prev)=>prev.filter((t)=>t !== tag));
                return;
            }
            setSelectedTags((prev)=>{
                if (prev.includes(tag)) return prev.filter((t)=>t !== tag);
                else return [
                    ...prev,
                    tag
                ];
            });
        } else {
            if (selectedTags.includes(tag)) // If it's currently included and we're toggling to exclude, remove from included first
            setSelectedTags((prev)=>prev.filter((t)=>t !== tag));
            setExcludedTags((prev)=>{
                if (prev.includes(tag)) return prev.filter((t)=>t !== tag);
                else return [
                    ...prev,
                    tag
                ];
            });
        }
    }, [
        selectedTags,
        excludedTags
    ]);
    const handleFilterModalOpen = (0, _react1.useCallback)(()=>{
        setIsFilterModalOpen(true);
    }, []);
    const handleFilterModalClose = (0, _react1.useCallback)(()=>{
        setIsFilterModalOpen(false);
        setIsApplyingFilters(false);
    }, []);
    const handleFilterModalApply = (0, _react1.useCallback)(()=>{
        setIsApplyingFilters(true);
        // The actual filtering logic is handled by the debounced effects
        // This just triggers the loading state and closes the modal
        setTimeout(()=>{
            setIsApplyingFilters(false);
        }, 500); // Brief delay to show loading state
    }, []);
    const [conversationalEvents, setConversationalEvents] = (0, _react1.useState)([]);
    const [crossOrgSessionsData, setCrossOrgSessionsDataState] = (0, _react1.useState)([]);
    const processedSessionReviews = (0, _useProcessConversationalSuccessEvents.useProcessConversationalSuccessEvents)(conversationalEvents, sessionContainer, crossOrgSessionsData, {
        crossOrgMode: props.crossOrgMode || props.currentOrgMode,
        setConvertedCustomers: props.setConvertedCustomers,
        setRepeatCustomers: props.setRepeatCustomers,
        setUniqueEngagementCount: props.setUniqueEngagementCount,
        setUpsellPercentage: props.setUpsellPercentage
    });
    // Update session reviews when processed reviews change
    (0, _react1.useEffect)(()=>{
        if (conversationalEvents.length > 0) setSessionReviews(processedSessionReviews);
    }, [
        processedSessionReviews,
        conversationalEvents.length
    ]);
    /**
   * Loads generative session reviews from conversational success events.
   * In cross-org mode, loads data from multiple organizations specified in orgIds prop.
   * In regular mode, uses the existing orderingAnalyticsContainer data.
   */ const getGenerativeSessionReviews = (0, _react1.useCallback)(async ()=>{
        setProcessingReviews(true);
        // Clear loading log only on initial load for cross-org mode or current org mode
        const isMultiMode = props.crossOrgMode || props.currentOrgMode;
        if (isMultiMode && loadingLog.length === 0) setLoadingLog([
            "Starting data load..."
        ]);
        else if (props.crossOrgMode && props.orgIds) setLoadingLog((prev)=>[
                ...prev,
                `Starting data load for ${props.orgIds.length} organizations...`
            ]);
        else if (props.currentOrgMode && props.appIds) setLoadingLog((prev)=>[
                ...prev,
                `Starting data load for ${props.appIds.length} applications...`
            ]);
        // Create a logging callback for the containers
        const addToLog = (message)=>{
            if (isMultiMode) setLoadingLog((prev)=>[
                    ...prev,
                    message
                ]);
        };
        try {
            let allConversationalSuccessEvents = [];
            let crossOrgSessionsData = [];
            if (props.crossOrgMode && props.orgIds && props.orgIds.length > 0) {
                // Cross-org mode: Use container function to load conversational success events from multiple organizations
                const crossOrgEvents = await orderingAnalyticsContainer.loadConversationalSuccessEventsForOrgs(props.orgIds, memoizedFilter, addToLog);
                allConversationalSuccessEvents = crossOrgEvents || [];
                setLoadingLog((prev)=>[
                        ...prev,
                        `Loaded ${allConversationalSuccessEvents.length} success events across all organizations`
                    ]);
                // Also load sessions for these organizations so we can get timestamps and phone numbers
                crossOrgSessionsData = await sessionContainer.loadSessionsForOrgs(props.orgIds, memoizedFilter, addToLog);
                setCrossOrgSessions(crossOrgSessionsData || []);
                setLoadingLog((prev)=>[
                        ...prev,
                        `Loaded ${(crossOrgSessionsData || []).length} sessions across all organizations`
                    ]);
            } else if (props.currentOrgMode && props.appIds && props.appIds.length > 0) {
                // Current org mode: Load data for each application individually
                setLoadingLog((prev)=>[
                        ...prev,
                        `Loading data for ${props.appIds.length} applications...`
                    ]);
                // Load conversational success events for each application
                for(let i = 0; i < props.appIds.length; i++){
                    const appId = props.appIds[i];
                    const appName = getAppNameById(appId);
                    addToLog(`Loading events for ${appName} (${i + 1} of ${props.appIds.length})...`);
                    try {
                        // Now use the paged version
                        const result = await orderingAnalyticsContainer.loadConversationalSuccessEventsPaged(appId, memoizedFilter);
                        if (result.resultType === "Ok") {
                            const eventCount = (result.data || []).length;
                            allConversationalSuccessEvents.push(...result.data || []);
                            addToLog(`✓ Loaded ${eventCount} events for ${appName} (Total so far: ${allConversationalSuccessEvents.length})`);
                            // Log unique session IDs for debugging
                            const uniqueSessionIds = new Set(result.data.map((e)=>e.sessionId));
                            addToLog(`  → ${uniqueSessionIds.size} unique session IDs in events`);
                        } else {
                            const errorMsg = result?.errors?.[0] || "Unknown error";
                            addToLog(`✗ Error loading events for ${appName}: ${errorMsg}`);
                        }
                    } catch (error) {
                        addToLog(`✗ Exception loading events for ${appName}: ${error.message || error}`);
                    }
                }
                setLoadingLog((prev)=>[
                        ...prev,
                        `Loaded ${allConversationalSuccessEvents.length} success events across all applications`
                    ]);
                // Load sessions for each application
                for(let i = 0; i < props.appIds.length; i++){
                    const appId = props.appIds[i];
                    const appName = getAppNameById(appId);
                    addToLog(`Loading sessions for ${appName} (${i + 1} of ${props.appIds.length})...`);
                    try {
                        const sessionsResult = await _api.getSessionsByApplication(appId, memoizedFilter);
                        const callStartedResult = await _api.getCallStartedEventsByApplication(appId, memoizedFilter);
                        if (sessionsResult.resultType === "Ok" && callStartedResult.resultType === "Ok") {
                            const sessionModels = sessionsResult.data || [];
                            const callStartedEvents = callStartedResult.data || [];
                            addToLog(`  → Received ${sessionModels.length} session records`);
                            addToLog(`  → Received ${callStartedEvents.length} call started events`);
                            // Convert to SessionListModel format
                            for (const session of sessionModels){
                                const callStarted = callStartedEvents.find((e)=>e.sessionId === session.sessionId);
                                const phoneNumbers = [];
                                if (callStarted?.from?.length) phoneNumbers.push(callStarted.from);
                                if (callStarted?.to?.length) phoneNumbers.push(callStarted.to);
                                if (callStarted?.phoneNumber?.length) phoneNumbers.push(callStarted.phoneNumber);
                                crossOrgSessionsData.push({
                                    sessionId: session.sessionId,
                                    startDate: new Date(session.startDate),
                                    phoneNumbers: phoneNumbers,
                                    from: callStarted?.from
                                });
                            }
                            addToLog(`✓ Loaded ${sessionModels.length} sessions for ${appName} (Total so far: ${crossOrgSessionsData.length})`);
                        } else {
                            const errorMsg = sessionsResult.resultType !== "Ok" ? `Sessions: ${sessionsResult?.errors?.[0] || "Unknown error"}` : `Call events: ${callStartedResult?.errors?.[0] || "Unknown error"}`;
                            addToLog(`✗ Error loading sessions for ${appName}: ${errorMsg}`);
                        }
                    } catch (error) {
                        addToLog(`✗ Exception loading sessions for ${appName}: ${error.message || error}`);
                    }
                }
                setCrossOrgSessions(crossOrgSessionsData || []);
                setLoadingLog((prev)=>[
                        ...prev,
                        `Loaded ${(crossOrgSessionsData || []).length} sessions across all applications`
                    ]);
            } else {
                // Single application mode: Use existing orderingAnalyticsContainer
                allConversationalSuccessEvents = orderingAnalyticsContainer.conversationalSuccessEvents || [];
                // Clear cross-org sessions when not in cross-org mode
                setCrossOrgSessions([]);
            }
            // Set the events data which will trigger the hook
            setConversationalEvents(allConversationalSuccessEvents);
            setCrossOrgSessionsDataState(crossOrgSessionsData);
            if (isMultiMode) setLoadingLog((prev)=>[
                    ...prev,
                    `Processed ${allConversationalSuccessEvents.length} events`
                ]);
        } catch (error) {
            console.error("Error loading generative session reviews:", error);
            setSessionReviews([]);
            setConversationalEvents([]);
            setCrossOrgSessionsDataState([]);
            setCrossOrgSessions([]);
            if (isMultiMode) setLoadingLog((prev)=>[
                    ...prev,
                    `Error loading data: ${error}`
                ]);
        } finally{
            // In cross-org mode or current org mode, we manage loading state locally
            // In regular mode, we still set to false since this function has completed
            // The useEffect will sync with container loading states if needed
            setProcessingReviews(false);
            setHasInitiallyLoaded(true); // Mark that we've completed our first load
            if (isMultiMode) setLoadingLog((prev)=>[
                    ...prev,
                    "Data loading completed"
                ]);
            // Track the load time for auto-refresh
            setLastLoadTime(new Date());
        }
    }, [
        props.crossOrgMode,
        props.currentOrgMode,
        props.orgIds,
        props.appIds,
        memoizedFilter,
        orderingAnalyticsContainer,
        sessionContainer,
        loadingLog.length
    ]);
    /**
   * Loads new sessions since the last load time.
   * Only used in cross-org mode or current org mode when end date is after the current time.
   */ const loadNewSessions = (0, _react1.useCallback)(async ()=>{
        const hasOrgIds = props.crossOrgMode && props.orgIds && props.orgIds.length > 0;
        const hasAppIds = props.currentOrgMode && props.appIds && props.appIds.length > 0;
        if (!hasOrgIds && !hasAppIds || !lastLoadTime) return;
        console.log("Checking for new sessions since:", lastLoadTime);
        const addToLog = (message)=>{
            setLoadingLog((prev)=>[
                    ...prev,
                    message
                ]);
        };
        try {
            // Create a modified filter using lastLoadTime as start date and keep same end date
            const modifiedFilter = {
                ...memoizedFilter,
                startDate: lastLoadTime.toISOString()
            };
            addToLog(`Checking for new sessions since ${(0, _momentDefault.default)(lastLoadTime).format((0, _analyticsDateFormat.SESSION_DATE_FORMAT))}...`);
            let newEvents = [];
            let newSessionsData = [];
            if (props.crossOrgMode && props.orgIds) {
                // Cross-org mode: Load new conversational success events for multiple organizations
                newEvents = await orderingAnalyticsContainer.loadConversationalSuccessEventsForOrgs(props.orgIds, modifiedFilter, addToLog) || [];
                if (newEvents.length > 0) {
                    addToLog(`Found ${newEvents.length} new success events`);
                    // Load new sessions for timestamps and phone numbers
                    newSessionsData = await sessionContainer.loadSessionsForOrgs(props.orgIds, modifiedFilter, addToLog) || [];
                }
            } else if (props.currentOrgMode && props.appIds) {
                // Current org mode: Load new events for each application
                for (const appId of props.appIds){
                    const eventsResult = await orderingAnalyticsContainer.loadConversationalSuccessEventsPaged(appId, modifiedFilter);
                    if (eventsResult.resultType === "Ok") newEvents.push(...eventsResult.data || []);
                    const sessionsResult = await _api.getSessionsByApplication(appId, modifiedFilter);
                    const callStartedResult = await _api.getCallStartedEventsByApplication(appId, modifiedFilter);
                    if (sessionsResult.resultType === "Ok" && callStartedResult.resultType === "Ok") {
                        const sessionModels = sessionsResult.data || [];
                        const callStartedEvents = callStartedResult.data || [];
                        // Convert to SessionListModel format
                        for (const session of sessionModels){
                            const callStarted = callStartedEvents.find((e)=>e.sessionId === session.sessionId);
                            const phoneNumbers = [];
                            if (callStarted?.from?.length) phoneNumbers.push(callStarted.from);
                            if (callStarted?.to?.length) phoneNumbers.push(callStarted.to);
                            if (callStarted?.phoneNumber?.length) phoneNumbers.push(callStarted.phoneNumber);
                            newSessionsData.push({
                                sessionId: session.sessionId,
                                startDate: new Date(session.startDate),
                                phoneNumbers: phoneNumbers,
                                from: callStarted?.from
                            });
                        }
                    }
                }
                if (newEvents.length > 0) addToLog(`Found ${newEvents.length} new success events across applications`);
            }
            if (newEvents.length > 0) {
                if (newSessionsData.length > 0) addToLog(`Found ${newSessionsData.length} new sessions`);
                // Merge with existing data
                setConversationalEvents((prev)=>[
                        ...prev,
                        ...newEvents
                    ]);
                setCrossOrgSessionsDataState((prev)=>[
                        ...prev,
                        ...newSessionsData
                    ]);
                setCrossOrgSessions((prev)=>[
                        ...prev,
                        ...newSessionsData
                    ]);
                addToLog("New sessions merged successfully");
                // Update last load time
                setLastLoadTime(new Date());
            } else addToLog("No new sessions found");
        } catch (error) {
            console.error("Error loading new sessions:", error);
            addToLog(`Error loading new sessions: ${error}`);
        }
    }, [
        props.crossOrgMode,
        props.currentOrgMode,
        props.orgIds,
        props.appIds,
        lastLoadTime,
        memoizedFilter,
        orderingAnalyticsContainer,
        sessionContainer
    ]);
    const handleLoadEngagements = (0, _react1.useCallback)(()=>{
        if (props.crossOrgMode || props.currentOrgMode) {
            setHasLoadedCrossOrgData(true);
            getGenerativeSessionReviews();
        }
    }, [
        props.crossOrgMode,
        props.currentOrgMode,
        getGenerativeSessionReviews
    ]);
    // Check if we can load engagements (have necessary data)
    const canLoadEngagements = (0, _react1.useMemo)(()=>{
        if (!props.crossOrgMode && !props.currentOrgMode) return false;
        if (processingReviews) return false;
        if (!memoizedFilter?.startDate || !memoizedFilter?.endDate) return false;
        if (props.crossOrgMode && (!props.orgIds || props.orgIds.length === 0)) return false;
        if (props.currentOrgMode && (!props.appIds || props.appIds.length === 0)) return false;
        return true;
    }, [
        props.crossOrgMode,
        props.currentOrgMode,
        props.orgIds,
        props.appIds,
        processingReviews,
        memoizedFilter
    ]);
    const getSessionStatistics = (sessionReviews)=>{
        const categoryCounts = new Map();
        const tagCounts = new Map();
        let total = 0;
        for (const review of sessionReviews){
            total += 1;
            categoryCounts.set(review.category, (categoryCounts.get(review.category) ?? 0) + 1);
            if (review.tags && review.tags.length > 0) for (const tag of review.tags)tagCounts.set(tag, (tagCounts.get(tag) ?? 0) + 1);
            else tagCounts.set("NO_TAGS_AVAILABLE", (tagCounts.get("NO_TAGS_AVAILABLE") ?? 0) + 1);
        }
        const categories = Array.from(categoryCounts.entries()).map(([key, count])=>({
                key,
                count,
                percentage: (count / total).toFixed(2)
            }));
        const tags = Array.from(tagCounts.entries()).map(([key, count])=>({
                key,
                count,
                percentage: (count / total).toFixed(2)
            }));
        return {
            categories,
            tags
        };
    };
    const sessionStatistics = (0, _reactDefault.default).useMemo(()=>getSessionStatistics(sessionReviews), [
        sessionReviews
    ]);
    // Optimized filtering with memoized phone numbers and early exits
    const getFilteredReviews = (0, _react1.useCallback)((reviews, category)=>{
        return reviews.filter((review)=>{
            if (category && review.category !== category) return false;
            // Search filter with optimized phone number lookup and application name
            if (debouncedSearchFieldValue?.length) {
                const phoneNumber = sessionPhoneNumbers.get(review.sessionId);
                const lastFourDigits = phoneNumber ? formatLastFourDigits(phoneNumber) : null;
                const appName = getAppNameById(review.applicationId);
                const searchLower = debouncedSearchFieldValue.toLowerCase();
                let matchesSearch = review.sessionId.includes(debouncedSearchFieldValue) || lastFourDigits && lastFourDigits.includes(debouncedSearchFieldValue) || appName && appName.toLowerCase().includes(searchLower);
                if (!matchesSearch) {
                    if (review?.mergedSessions?.some((s)=>s.sessionId.includes(debouncedSearchFieldValue))) matchesSearch = true;
                }
                if (!matchesSearch) return false;
            }
            // Tag filtering with early exits
            const hasIncludeFilters = debouncedSelectedTags.length > 0;
            const hasExcludeFilters = debouncedExcludedTags.length > 0;
            if (!hasIncludeFilters && !hasExcludeFilters) return true;
            const sessionHasTags = review.tags && review.tags.length > 0;
            if (filterLogic === "OR") {
                //Handle include filters first - early exit if we have any of them
                let includeTrue = false;
                let excludeTrue = false;
                if (hasIncludeFilters) {
                    if (sessionHasTags) {
                        // Use some() for early exit when included tag is found
                        const hasIncludeTag = debouncedSelectedTags.some((includeTag)=>review.tags.includes(includeTag));
                        includeTrue = hasIncludeTag;
                    } else // Session has no tags, check if "NO_TAGS_AVAILABLE" is included
                    includeTrue = debouncedSelectedTags.includes("NO_TAGS_AVAILABLE");
                }
                if (hasExcludeFilters) {
                    if (sessionHasTags) {
                        //If session has ALL excluded tags it should be added, otherwise it should be
                        const hasAllExcludeTags = debouncedExcludedTags.every((t)=>review.tags.includes(t));
                        excludeTrue = !hasAllExcludeTags;
                    } else //If the session has no tags return true if NO tags available is not excluded
                    excludeTrue = !debouncedExcludedTags.includes("NO_TAGS_AVAILABLE");
                }
                return includeTrue || excludeTrue;
            } else {
                // Handle exclude filters first - early exit if excluded
                if (hasExcludeFilters) {
                    if (sessionHasTags) {
                        // Use some() for early exit when excluded tag is found
                        const hasExcludedTag = debouncedExcludedTags.some((excludedTag)=>review.tags.includes(excludedTag));
                        if (hasExcludedTag) return false;
                    } else {
                        // Session has no tags, check if "NO_TAGS_AVAILABLE" is excluded
                        if (debouncedExcludedTags.includes("NO_TAGS_AVAILABLE")) return false;
                    }
                }
                // Handle include filters
                if (hasIncludeFilters) {
                    if (sessionHasTags) return debouncedSelectedTags.every((t)=>review.tags.includes(t));
                    else return debouncedSelectedTags.includes("NO_TAGS_AVAILABLE");
                }
                return true;
            }
        });
    }, [
        debouncedSelectedTags,
        debouncedExcludedTags,
        debouncedSearchFieldValue,
        sessionPhoneNumbers,
        getAppNameById
    ]);
    // Memoize filtered reviews to avoid redundant calculations
    const filteredReviewsCache = (0, _react1.useMemo)(()=>{
        const cache = new Map();
        // Cache filtered reviews for each category
        for (const category of availableCategories){
            const key = `${category}`;
            cache.set(key, getFilteredReviews(sessionReviews, category));
        }
        // Cache uncategorized reviews
        cache.set("uncategorized", getFilteredReviews(sessionReviews));
        return cache;
    }, [
        sessionReviews,
        availableCategories,
        getFilteredReviews
    ]);
    // Helper function to get cached filtered reviews
    const getCachedFilteredReviews = (0, _react1.useCallback)((category)=>{
        const key = category || "uncategorized";
        return filteredReviewsCache.get(key) || [];
    }, [
        filteredReviewsCache
    ]);
    const handleExportCSV = (0, _react1.useCallback)(()=>{
        // Get all filtered reviews
        const allFilteredReviews = getCachedFilteredReviews();
        if (allFilteredReviews.length === 0) {
            alert("No data to export");
            return;
        }
        // Helper function to escape CSV values and prevent Excel formula injection
        const escapeCsvValue = (value)=>{
            if (!value) return '""';
            // Remove leading/trailing whitespace
            let escaped = value.trim();
            // Replace double quotes with double-double quotes for CSV
            escaped = escaped.replace(/"/g, '""');
            // Replace newlines and carriage returns with spaces
            escaped = escaped.replace(/[\r\n]+/g, " ");
            // Prevent Excel formula injection by prefixing dangerous characters with a single quote
            // This makes Excel treat it as text rather than a formula
            if (escaped.match(/^[=+\-@\t\r]/)) escaped = "'" + escaped;
            return `"${escaped}"`;
        };
        // Prepare CSV headers
        const headers = [
            "Date Time",
            "Application Name",
            "Session ID",
            "Category",
            "Tags",
            "Number of Calls",
            "Summary",
            "Application ID"
        ];
        // Prepare CSV rows
        const rows = allFilteredReviews.map((review)=>{
            const appName = getAppNameById(review.applicationId || "");
            const tags = review.tags && review.tags.length > 0 ? review.tags.join("; ") : "";
            const numberOfCalls = review.mergedSessions ? review.mergedSessions.length : 1;
            const dateTime = review.date ? (0, _momentDefault.default)(review.date).format("YYYY-MM-DD HH:mm:ss") : getSessionTimeStamp(review);
            return [
                escapeCsvValue(dateTime),
                escapeCsvValue(appName),
                escapeCsvValue(review.sessionId || ""),
                escapeCsvValue(review.category || ""),
                escapeCsvValue(tags),
                escapeCsvValue(numberOfCalls.toString()),
                escapeCsvValue(review.summary || ""),
                escapeCsvValue(review.applicationId || "")
            ];
        });
        // Create CSV content
        const csvContent = [
            headers.join(","),
            ...rows.map((row)=>row.join(","))
        ].join("\n");
        // Create blob and download
        const blob = new Blob([
            csvContent
        ], {
            type: "text/csv;charset=utf-8;"
        });
        const link = document.createElement("a");
        const url = URL.createObjectURL(blob);
        const timestamp = (0, _momentDefault.default)().format("YYYY-MM-DD_HH-mm-ss");
        link.setAttribute("href", url);
        link.setAttribute("download", `engagements_export_${timestamp}.csv`);
        link.style.visibility = "hidden";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    }, [
        getCachedFilteredReviews,
        getAppNameById,
        getSessionTimeStamp
    ]);
    const getFilteredStatistics = (0, _react1.useCallback)(()=>{
        const hasActiveFilters = debouncedSelectedTags.length > 0 || debouncedExcludedTags.length > 0 || debouncedSearchFieldValue?.length > 0;
        if (!hasActiveFilters) return null;
        const totalFilteredReviews = getCachedFilteredReviews();
        const totalCount = sessionReviews.length;
        const filteredCount = totalFilteredReviews.length;
        const percentage = totalCount > 0 ? (filteredCount / totalCount * 100).toFixed(0) : "0";
        return {
            count: filteredCount,
            percentage: percentage,
            hasActiveFilters: hasActiveFilters
        };
    }, [
        sessionReviews,
        debouncedSelectedTags,
        debouncedExcludedTags,
        debouncedSearchFieldValue,
        getCachedFilteredReviews
    ]);
    const filteredStatistics = (0, _react1.useMemo)(()=>getFilteredStatistics(), [
        getFilteredStatistics
    ]);
    (0, _react1.useEffect)(()=>{
        if (props.onFilteredDataChange) {
            const allFilteredReviews = getCachedFilteredReviews();
            props.onFilteredDataChange(allFilteredReviews, debouncedSelectedTags, debouncedExcludedTags);
        }
    }, [
        getCachedFilteredReviews,
        props.onFilteredDataChange,
        debouncedSelectedTags,
        debouncedExcludedTags
    ]);
    const renderHiddenFiltersTooltip = (hiddenTags)=>{
        const hiddenFiltersText = hiddenTags.map(({ tag, mode })=>{
            if (mode === "search") return tag;
            const displayName = tag === "NO_TAGS_AVAILABLE" ? "Untagged" : (0, _generativeCallReview.getTagName)(tag, featureFlag);
            return mode === "exclude" ? `NOT ${displayName}` : displayName;
        }).join(", ");
        return `${hiddenFiltersText}`;
    };
    const renderFilterResults = (filteredReviews, categoryCount, categoryName)=>{
        // Use immediate values for instant UI feedback on filter presence
        const hasActiveFilters = selectedTags.length > 0 || excludedTags.length > 0 || searchFieldValue?.length > 0;
        if (!hasActiveFilters) return null;
        return (0, _react.jsx)(CollapsingSectionSubtitle, {
            hasMatches: filteredReviews.length > 0
        }, filteredReviews.length > 0 ? (0, _react.jsx)(FilterResultsContainer, null, (0, _react.jsx)(FilterResultsText, null, `${filteredReviews.length}`), (0, _react.jsx)(FilterTagsDisplay, null, selectedTags.filter((tag)=>{
            if (tag === "NO_TAGS_AVAILABLE") return filteredReviews.some((review)=>!review.tags || review.tags.length === 0);
            return filteredReviews.some((review)=>review.tags && review.tags.includes(tag));
        }).map((tag)=>renderFilterTagPill(tag, "include")), excludedTags.filter((tag)=>{
            // Show excluded tags that would have been present without the exclusion
            if (tag === "NO_TAGS_AVAILABLE") return sessionReviews.some((review)=>!review.tags || review.tags.length === 0);
            return sessionReviews.some((review)=>review.tags && review.tags.includes(tag));
        }).map((tag)=>renderFilterTagPill(tag, "exclude"))), (0, _react.jsx)(FilterResultsText, null, `${filteredReviews.length === 1 ? "engagement" : "engagements"}`, categoryCount > 0 ? ` (${(filteredReviews.length / categoryCount * 100).toFixed(0)}% of ${categoryName})` : "")) : (0, _react.jsx)(FilterResultsContainer, null, (0, _react.jsx)(FilterResultsText, null, selectedTags.length === 0 && excludedTags.length === 0 ? "No tags selected" : "No"), (selectedTags.length > 0 || excludedTags.length > 0) && (0, _react.jsx)((0, _reactDefault.default).Fragment, null, (0, _react.jsx)(FilterTagsDisplay, null, (0, _generativeCallReview.sortTagsByPriority)(selectedTags, featureFlag).map((tag)=>renderFilterTagPill(tag, "include")), (0, _generativeCallReview.sortTagsByPriority)(excludedTags, featureFlag).map((tag)=>renderFilterTagPill(tag, "exclude"))), (0, _react.jsx)(FilterResultsText, null, "engagements"))));
    };
    const renderFilterTagPill = (tag, mode = "include")=>{
        if (tag === "NO_TAGS_AVAILABLE") return (0, _react.jsx)(FilterTagPill, {
            key: tag,
            isExcluded: mode === "exclude"
        }, mode === "exclude" ? (0, _react.jsx)((0, _reactDefault.default).Fragment, null, (0, _react.jsx)(NotPrefix, null, "NOT "), "Untagged") : "Untagged");
        const colors = (0, _generativeCallReview.getTagColors)(tag);
        return (0, _react.jsx)(FilterTagPill, {
            key: tag,
            tagColors: colors,
            isExcluded: mode === "exclude"
        }, mode === "exclude" ? (0, _react.jsx)((0, _reactDefault.default).Fragment, null, (0, _react.jsx)(NotPrefix, null, "NOT "), (0, _generativeCallReview.getTagName)(tag, featureFlag)) : (0, _generativeCallReview.getTagName)(tag, featureFlag));
    };
    const renderSessionCard = (review, index, categoryPrefix)=>{
        const categoryPlaceholders = [
            "IMMEDIATE_TRANSFER",
            "NO_INTERACTION",
            "No summary"
        ];
        const hasSummary = review.summary && review.summary.trim() !== "" && !categoryPlaceholders.includes(review.summary.trim());
        const hasBeenToggled = collapsedCards.includes(review.sessionId);
        let isCollapsed;
        if (review.category === "NO_INTERACTION" && index === 0) isCollapsed = hasBeenToggled;
        else isCollapsed = !hasBeenToggled;
        const phoneNumber = getSessionPhoneNumber(review);
        const lastFourDigits = formatLastFourDigits(phoneNumber);
        const applicationIdForLink = review.applicationId || props.applicationId;
        // Find the most recent sessionId for this multi-call session (if applicable)
        let sessionIdForLink = review.sessionId;
        if (Array.isArray(review.mergedSessions) && review.mergedSessions.length > 1) {
            const latest = review.mergedSessions.reduce((latest, curr)=>{
                if (!curr.startDate) return latest;
                if (!latest.startDate) return curr;
                return new Date(curr.startDate).getTime() > new Date(latest.startDate).getTime() ? curr : latest;
            }, review.mergedSessions[0]);
            sessionIdForLink = latest.sessionId;
        }
        const getUserIdSearchFromReview = (review)=>{
            // if user id is all numbers return it
            if (/^\d+$/.test(review.userId)) {
                // get last 6 digits
                const lastSixDigits = review.userId.slice(-6);
                return `&initialSearch=${lastSixDigits}`;
            }
            return "";
        };
        return (0, _react.jsx)(CollapsibleSessionCard, {
            key: `${categoryPrefix}-${review.sessionId}-${index}`
        }, (0, _react.jsx)(SessionLink, {
            to: `/v/apps/${applicationIdForLink}/analytics/sessions?sessionId=${sessionIdForLink}${getUserIdSearchFromReview(review)}`,
            target: "_blank",
            rel: "noopener noreferrer"
        }, (0, _react.jsx)(SessionRow, {
            isCollapsed: isCollapsed
        }, (0, _react.jsx)(SessionLeftSide, null, (0, _react.jsx)(SessionTimestamp, null, getSessionTimeStamp(review)), lastFourDigits && (0, _react.jsx)(PhoneNumberDisplay, null, "•••", lastFourDigits)), (0, _react.jsx)(SessionRightSide, null, renderSessionControls(review), renderSessionTags(review), (0, _react.jsx)(CollapseButton, {
            onClick: (e)=>toggleCardCollapse(review.sessionId, e),
            isCollapsed: isCollapsed
        }, (0, _react.jsx)((0, _toggleIndicatorDefault.default), {
            direction: isCollapsed ? "up" : "down"
        })))), !isCollapsed && (0, _react.jsx)((0, _reactDefault.default).Fragment, null, hasSummary ? (()=>{
            const formattedText = formatSummaryText(review.summary);
            return (0, _react.jsx)(SummaryDisplay, null, formattedText.split("\n").map((line, index)=>(0, _react.jsx)(SummaryLine, {
                    key: index
                }, line || "\xa0")));
        })() : (()=>{
            // Use summary value as category if it's a category placeholder, otherwise use review.category
            const effectiveCategory = [
                "IMMEDIATE_TRANSFER",
                "NO_INTERACTION"
            ].includes(review.summary?.trim()) ? review.summary.trim() : review.category;
            if (effectiveCategory === "NO_INTERACTION") return (0, _react.jsx)(SummaryDisplay, null, "• ", featureFlag === "HEALTHCARE" ? "The patient didn't interact with the assistant." : "The customer didn't interact with the assistant.");
            else if (effectiveCategory === "IMMEDIATE_TRANSFER") return (0, _react.jsx)(SummaryDisplay, null, "• ", featureFlag === "HEALTHCARE" ? "The patient immediately asked to transfer." : "The customer immediately asked to transfer.");
            else return (0, _react.jsx)(SummaryDisplay, null, "Summary unavailable");
        })())));
    };
    const renderSessionControls = (review)=>{
        const isMulti = Array.isArray(review.mergedSessions) && review.mergedSessions.length > 1;
        return (0, _react.jsx)(SessionControls, null, (0, _react.jsx)(SmallSessionButton, {
            themes: [
                "white-small"
            ],
            text: isMulti ? visibleSessionIds.includes(review.sessionId) ? "Hide Session IDs" : "Show Session IDs" : visibleSessionIds.includes(review.sessionId) ? "Hide Session ID" : "Show Session ID",
            onClick: (e)=>toggleSessionIdVisibility(review.sessionId, e)
        }), visibleSessionIds.includes(review.sessionId) && (0, _react.jsx)((0, _reactDefault.default).Fragment, null, isMulti ? (0, _react.jsx)(SessionIdList, null, review.mergedSessions.map((s, idx)=>(0, _react.jsx)(SessionIdDisplay, {
                key: s.sessionId
            }, s.sessionId, copiedSessionId === s.sessionId && (0, _react.jsx)(CopiedIndicator, null, "Copied!"), (0, _react.jsx)(SmallCopyButton, {
                themes: [
                    "white-icon"
                ],
                icon: copyIcon,
                onClick: (e)=>copySessionId(s.sessionId, e)
            })))) : (0, _react.jsx)(SessionIdDisplay, null, review.sessionId, copiedSessionId === review.sessionId && (0, _react.jsx)(CopiedIndicator, null, "Copied!"), (0, _react.jsx)(SmallCopyButton, {
            themes: [
                "white-icon"
            ],
            icon: copyIcon,
            onClick: (e)=>copySessionId(review.sessionId, e)
        }))));
    };
    const renderSessionTags = (review)=>(0, _react.jsx)(TagsWrap, null, review.tags && review.tags.length > 0 ? (0, _react.jsx)((0, _sessionTagsDefault.default), {
            showVfyTags: props.crossOrgMode,
            tags: review.tags,
            featureFlag: featureFlag
        }) : (0, _react.jsx)(NoTagsPill, null, "Untagged"));
    const renderPaginationControls = (totalSessions, category, position = "bottom")=>{
        const totalPages = getTotalPages(totalSessions);
        const currentPage = getCurrentPageForCategory(category);
        if (totalPages <= 1) return (0, _react.jsx)(EmptyPaginationContainer, null);
        const showingFrom = (currentPage - 1) * SESSIONS_PER_PAGE + 1;
        const showingTo = Math.min(currentPage * SESSIONS_PER_PAGE, totalSessions);
        return (0, _react.jsx)(PaginationContainer, {
            isTop: position === "top"
        }, (0, _react.jsx)(PaginationInfo, null, "Showing ", showingFrom, "-", showingTo, " of ", totalSessions, " calls"), (0, _react.jsx)(PaginationControls, null, (0, _react.jsx)(PaginationButton, {
            themes: [
                "white-small"
            ],
            text: "Previous",
            disabled: currentPage === 1,
            onClick: ()=>setCurrentPageForCategory(category, currentPage - 1)
        }), (0, _react.jsx)(PageNumbers, null, (()=>{
            const pages = [];
            const maxPagesToShow = 5;
            let startPage = Math.max(1, currentPage - Math.floor(maxPagesToShow / 2));
            let endPage = Math.min(totalPages, startPage + maxPagesToShow - 1);
            // Adjust start page if we're near the end
            if (endPage - startPage + 1 < maxPagesToShow) startPage = Math.max(1, endPage - maxPagesToShow + 1);
            // Show first page and ellipsis if needed
            if (startPage > 1) {
                pages.push((0, _react.jsx)(PageNumber, {
                    key: 1,
                    active: false,
                    onClick: ()=>setCurrentPageForCategory(category, 1)
                }, "1"));
                if (startPage > 2) pages.push((0, _react.jsx)(PageEllipsis, {
                    key: "ellipsis-start"
                }, "..."));
            }
            // Show page numbers
            for(let i = startPage; i <= endPage; i++)pages.push((0, _react.jsx)(PageNumber, {
                key: i,
                active: i === currentPage,
                onClick: ()=>setCurrentPageForCategory(category, i)
            }, i));
            // Show ellipsis and last page if needed
            if (endPage < totalPages) {
                if (endPage < totalPages - 1) pages.push((0, _react.jsx)(PageEllipsis, {
                    key: "ellipsis-end"
                }, "..."));
                pages.push((0, _react.jsx)(PageNumber, {
                    key: totalPages,
                    active: false,
                    onClick: ()=>setCurrentPageForCategory(category, totalPages)
                }, totalPages));
            }
            return pages;
        })()), (0, _react.jsx)(PaginationButton, {
            themes: [
                "white-small"
            ],
            text: "Next",
            disabled: currentPage === totalPages,
            onClick: ()=>setCurrentPageForCategory(category, currentPage + 1)
        })));
    };
    const renderSessionList = (filteredReviews, categoryPrefix = "")=>{
        return (0, _react.jsx)(SessionList, null, filteredReviews.length === 0 ? (0, _react.jsx)(NoDataMessage, null, categoryPrefix === "uncategorized" ? "No calls found with the current filters." : categoryPrefix === "" ? "No call data is available for the selected time period. Try adjusting your date range or check back later." : "No calls found for this category with the current filters.") : filteredReviews.map((review, index)=>renderSessionCard(review, index, categoryPrefix)));
    };
    const renderSessionListSorted = (filteredReviews, categoryPrefix = "")=>{
        if (filteredReviews.length === 0) return (0, _react.jsx)(SessionList, null, (0, _react.jsx)(NoDataMessage, null, categoryPrefix === "uncategorized" ? "No calls found with the current filters." : categoryPrefix === "" ? "No call data is available for the selected time period. Try adjusting your date range or check back later." : "No calls found for this category with the current filters."));
        // Sort sessions by date (newest first)
        const sortedSessions = [
            ...filteredReviews
        ].sort((a, b)=>{
            // In cross-org mode, use crossOrgSessions; otherwise use sessionContainer.sessions
            const sessions = props.crossOrgMode ? crossOrgSessions : sessionContainer.sessions;
            const sessionA = sessions.find((s)=>s.sessionId === a.sessionId);
            const sessionB = sessions.find((s)=>s.sessionId === b.sessionId);
            const dateA = sessionA?.startDate ? new Date(sessionA.startDate) : new Date(0);
            const dateB = sessionB?.startDate ? new Date(sessionB.startDate) : new Date(0);
            // Sort by date descending (newest first)
            return dateB.getTime() - dateA.getTime();
        });
        // Get paginated sessions for this category
        const paginatedSessions = getPaginatedSessions(sortedSessions, categoryPrefix || "uncategorized");
        return (0, _react.jsx)((0, _reactDefault.default).Fragment, null, renderPaginationControls(sortedSessions.length, categoryPrefix || "uncategorized", "top"), (0, _react.jsx)(SessionList, null, paginatedSessions.map((review, index)=>renderSessionCard(review, index, categoryPrefix))), renderPaginationControls(sortedSessions.length, categoryPrefix || "uncategorized", "bottom"));
    };
    const renderCategory = (category)=>{
        const filteredReviews = getCachedFilteredReviews(category);
        const categoryStats = sessionStatistics.categories.find((c)=>c.key === category);
        if (!categoryStats) return null;
        const categoryPercent = parseFloat(categoryStats.percentage) * 100;
        const categoryCount = categoryStats.count;
        const hasActiveFilters = debouncedSelectedTags.length > 0 || debouncedExcludedTags.length > 0 || debouncedSearchFieldValue?.length > 0;
        const shouldAutoExpand = hasActiveFilters && filteredReviews.length > 0;
        const shouldForceClose = hasActiveFilters && filteredReviews.length === 0;
        return (0, _react.jsx)(StyledContentCollapsingSection, {
            key: category,
            index: 0,
            bottom: (0, _lodash.indexOf)(availableCategories, category) === availableCategories.length - 1,
            isCollapsedByDefault: true,
            forceOpen: shouldAutoExpand,
            forceClose: shouldForceClose,
            title: (0, _generativeCallReview.getCategoryName)(category, featureFlag),
            icon: outputIcon,
            id: `category-${category}`,
            titleLeftAdditionalComponent: (0, _react.jsx)(TitleStatsText, null, `${categoryCount} | ${categoryPercent.toFixed(0)}% of total`),
            titleRightRowComponent: renderFilterResults(filteredReviews, categoryCount, (0, _generativeCallReview.getCategoryName)(category, featureFlag))
        }, (0, _react.jsx)(ScrollableSessionContainer, null, (0, _react.jsx)((0, _customScrollbarsDefault.default), {
            autoHide: true,
            autoHeight: true,
            autoHeightMax: "calc(40vh)",
            autoHeightMin: "calc(40vh)",
            hideHorizontalScrollbar: true
        }, renderSessionListSorted(filteredReviews, category))));
    };
    const renderNoDataFallback = ()=>{
        if (sessionReviews.length === 0) return (0, _react.jsx)(StyledContentCollapsingSection, {
            key: "no-data",
            index: 0,
            bottom: true,
            isCollapsedByDefault: true,
            title: "No Call Data Available",
            icon: outputIcon,
            id: "category-no-data",
            titleRightRowComponent: (0, _react.jsx)(CollapsingSectionSubtitle, null, "0 total calls | 0%")
        }, (0, _react.jsx)(ScrollableSessionContainer, null, (0, _react.jsx)((0, _customScrollbarsDefault.default), {
            autoHide: true,
            autoHeight: true,
            autoHeightMax: "calc(100vh - 100px)",
            hideHorizontalScrollbar: true
        }, renderSessionList([], ""))));
        // Show uncategorized sessions
        const filteredUncategorizedReviews = getCachedFilteredReviews();
        const hasActiveFilters = debouncedSelectedTags.length > 0 || debouncedExcludedTags.length > 0 || debouncedSearchFieldValue?.length > 0;
        const shouldAutoExpand = hasActiveFilters && filteredUncategorizedReviews.length > 0;
        const shouldForceClose = hasActiveFilters && filteredUncategorizedReviews.length === 0;
        return (0, _react.jsx)(StyledContentCollapsingSection, {
            key: "uncategorized",
            index: 0,
            bottom: true,
            isCollapsedByDefault: true,
            forceOpen: shouldAutoExpand,
            forceClose: shouldForceClose,
            title: "Uncategorized Calls",
            icon: outputIcon,
            id: "category-uncategorized",
            titleLeftAdditionalComponent: (0, _react.jsx)(TitleStatsText, null, `${sessionReviews.length} ${sessionReviews.length === 1 ? "total" : "total"} | 100%`),
            titleRightRowComponent: renderFilterResults(filteredUncategorizedReviews, 0, null)
        }, (0, _react.jsx)(ScrollableSessionContainer, null, (0, _react.jsx)((0, _customScrollbarsDefault.default), {
            autoHide: true,
            autoHeight: true,
            autoHeightMax: "calc(100vh - 100px)",
            hideHorizontalScrollbar: true
        }, renderSessionListSorted(filteredUncategorizedReviews, "uncategorized"))));
    };
    const handleResetFilters = async ()=>{
        setResettingFilters(true);
        try {
            // Add a small delay to provide visual feedback
            await new Promise((resolve)=>setTimeout(resolve, 300));
            setSelectedTags([]);
            setExcludedTags([]);
            setSearchFieldValue("");
            // Reset pagination when filters are reset
            setCategoryCurrentPages({});
        } finally{
            setResettingFilters(false);
        }
    };
    const getCurrentPageForCategory = (category)=>{
        return categoryCurrentPages[category] || 1;
    };
    const setCurrentPageForCategory = (category, page)=>{
        setCategoryCurrentPages((prev)=>({
                ...prev,
                [category]: page
            }));
        // Scroll to top of category after page change
        setTimeout(()=>{
            const categoryElement = document.getElementById(`category-${category}`);
            if (categoryElement) categoryElement.scrollIntoView({
                behavior: "smooth",
                block: "start"
            });
        }, 100); // Small delay to ensure DOM has updated
    };
    const getPaginatedSessions = (sessions, category)=>{
        const currentPage = getCurrentPageForCategory(category);
        const startIndex = (currentPage - 1) * SESSIONS_PER_PAGE;
        const endIndex = startIndex + SESSIONS_PER_PAGE;
        return sessions.slice(startIndex, endIndex);
    };
    const getTotalPages = (totalSessions)=>{
        return Math.ceil(totalSessions / SESSIONS_PER_PAGE);
    };
    return (0, _react.jsx)(GenerativeReportContainer, null, (0, _react.jsx)(GenerativeSessionReviewRow, null, availableTags.length === 0 ? (0, _react.jsx)(NoTagsMessage, null, "No tag data available for the selected time period.") : availableTags.filter((tag)=>tag !== "NO_TAGS_AVAILABLE").filter((tag)=>TAGS_WITH_SUMMARY_CARDS.includes(tag)).map((tag)=>{
        const tagStats = sessionStatistics.tags.find((t)=>t.key === tag);
        if (!tagStats) return null;
        const tagPercentage = parseFloat(tagStats.percentage) * 100;
        const tagCount = tagStats.count;
        return (0, _react.jsx)(StyledTotalCard, {
            key: tag,
            title: (0, _generativeCallReview.getTagName)(tag, featureFlag),
            value: `${tagCount} | ${tagPercentage.toFixed(0)}%`,
            showValue: false,
            showPercentage: false,
            icon: getIconByTagLabel(tag),
            subValue: "of all calls"
        });
    })), (0, _react.jsx)(CallBreakdownSectionWrapper, null, (0, _react.jsx)(CallBreakdownHeader, null, (0, _react.jsx)(CallBreakdownTitleSection, null, (0, _react.jsx)(CallBreakdownTitle, null, `Engagement Breakdown`), (props.crossOrgMode || props.currentOrgMode) && (0, _react.jsx)(LoadEngagementsButton, {
        themes: [
            "primary",
            "start"
        ],
        text: "Load engagements",
        onClick: handleLoadEngagements,
        disabled: !canLoadEngagements,
        loading: processingReviews
    }), (props.crossOrgMode || props.currentOrgMode) && sessionReviews.length > 0 ? (0, _react.jsx)(ExportCSVButton, {
        themes: [
            "white-small"
        ],
        text: "Export to CSV",
        onClick: handleExportCSV,
        disabled: processingReviews || sessionReviews.length === 0
    }) : (0, _react.jsx)((0, _reactDefault.default).Fragment, null), (props.crossOrgMode || props.currentOrgMode) && hasLoadedCrossOrgData && loadingLog.length > 0 && (0, _react.jsx)(LoadingLogBox, {
        ref: loadingLogRef
    }, loadingLog.map((logEntry, index)=>(0, _react.jsx)(LogEntry, {
            key: index
        }, logEntry)))), (0, _react.jsx)(CallBreakdownControls, null, (selectedTags.length > 0 || excludedTags.length > 0 || searchFieldValue?.length > 0) && (filteredStatistics || searchFieldValue?.length > 0) && (0, _react.jsx)(FilteredStatsDisplay, null, (0, _react.jsx)(FilteredStatsTextContainer, null, (0, _react.jsx)(FilteredStatsText, null, filteredStatistics ? `${filteredStatistics.count} engagement${filteredStatistics.count > 1 ? "s" : ""} | ${filteredStatistics.percentage}% match filter${filteredStatistics.count > 1 ? "s" : ""}:` : "Filtering...")), (0, _react.jsx)(FilteredTagsContainer, null, (()=>{
        const allTags = [
            ...(0, _generativeCallReview.sortTagsByPriority)(selectedTags, featureFlag).map((tag)=>({
                    tag,
                    mode: "include"
                })),
            ...(0, _generativeCallReview.sortTagsByPriority)(excludedTags, featureFlag).map((tag)=>({
                    tag,
                    mode: "exclude"
                })),
            ...searchFieldValue ? [
                {
                    tag: `Search: "${searchFieldValue}"`,
                    mode: "search"
                }
            ] : []
        ];
        const maxVisibleTags = 4;
        const visibleTags = allTags.slice(0, maxVisibleTags);
        const hiddenTags = allTags.slice(maxVisibleTags);
        const hiddenCount = hiddenTags.length;
        return (0, _react.jsx)((0, _reactDefault.default).Fragment, null, visibleTags.map(({ tag, mode }, index)=>{
            if (mode === "search") return (0, _react.jsx)(FilteredSearchPill, {
                key: `search-${index}`
            }, tag);
            return (0, _react.jsx)(FilteredTagPill, {
                key: `${mode}-${tag}`,
                tagColors: tag === "NO_TAGS_AVAILABLE" ? undefined : (0, _generativeCallReview.getTagColors)(tag),
                isExcluded: mode === "exclude"
            }, mode === "exclude" && (0, _react.jsx)(NotPrefix, null, "NOT "), tag === "NO_TAGS_AVAILABLE" ? "Untagged" : (0, _generativeCallReview.getTagName)(tag, featureFlag));
        }), hiddenCount > 0 && (0, _react.jsx)((0, _tooltipWrapperDefault.default), {
            text: renderHiddenFiltersTooltip(hiddenTags),
            place: "top",
            mouseEnterDelay: 0.3
        }, (0, _react.jsx)(MoreFiltersIndicator, null, "+", hiddenCount, " more filter", hiddenCount > 1 ? "s" : "")));
    })())), (0, _react.jsx)(FilterModalButton, {
        themes: [
            "primary",
            "start"
        ],
        text: `Filter calls`,
        onClick: handleFilterModalOpen,
        disabled: processingReviews || props.crossOrgMode && !hasLoadedCrossOrgData
    }), (0, _react.jsx)(ResetFiltersButton, {
        themes: [
            "white-small"
        ],
        text: "Reset filters",
        onClick: handleResetFilters,
        loading: resettingFilters,
        disabled: selectedTags.length === 0 && excludedTags.length === 0 && !searchFieldValue
    }), (0, _react.jsx)(CustomSearchWrapper, {
        onClick: stop,
        onMouseDown: stop
    }, (0, _react.jsx)(CustomSearch, {
        id: "searchField",
        name: "searchField",
        placeholder: props.crossOrgMode || props.currentOrgMode ? "Search by ID, phone, or app name" : "Enter ID or last 4 of phone",
        value: searchFieldValue,
        onChange: (e)=>setSearchFieldValue(e.target.value),
        boxType: "square"
    }))))), availableCategories.length === 0 && !processingReviews && hasInitiallyLoaded ? (0, _react.jsx)(FullWidthSectionWrapper, null, renderNoDataFallback()) : (0, _react.jsx)((0, _reactDefault.default).Fragment, null, availableCategories.map((categoryKey)=>(0, _react.jsx)(FullWidthSectionWrapper, {
            key: categoryKey
        }, renderCategory(categoryKey))), (debouncedSelectedTags.length > 0 || debouncedExcludedTags.length > 0 || debouncedSearchFieldValue?.length > 0) && availableCategories.every((category)=>getCachedFilteredReviews(category).length === 0) && (0, _react.jsx)(FullWidthSectionWrapper, null, (0, _react.jsx)(FilterNoResultsMessage, null, (0, _react.jsx)(NoDataMessage, null, "No calls match the current filters. Try adjusting your tag selection or search criteria to see results.")))), (0, _react.jsx)((0, _tagFilterModal.TagFilterModal), {
        isVisible: isFilterModalOpen,
        onClose: handleFilterModalClose,
        tags: availableTags,
        tagsForDisplay: tagsForDisplay,
        isCrossOrgMode: props.crossOrgMode,
        selectedTags: selectedTagsSet,
        excludedTags: excludedTagsSet,
        onToggle: toggleTag,
        onApply: handleFilterModalApply,
        isLoading: isApplyingFilters,
        application: props.application,
        setFilterLogic: setFilterLogic
    }));
};
exports.default = GenerativeReportTable;

},{"@emotion/styled/base":"lSuFu","@emotion/react":"djZKr","react":"6uln9","react-router-dom":"5fzqq","../structure/ContentCollapsingSection":"1CUms","../structure/CustomScrollbars":"50vFq","../../hooks/SessionAnalyticsContainer":"vk8Qc","../../models/analytics/AnalyticsDateFormat":"ia5MW","moment":"2meyw","../../hooks/UseProcessConversationalSuccessEvents":"5RAbR","./TagFilterModal":"a6pQY","../forms/SearchField":"aU10T","../charts/TotalCard":"gH7gf","lodash":"3hMBK","../../hooks/TelephonyAnalyticsContainer":"214YQ","../../api":"loxM6","../../constants/analyticsConstants/generativeCallReview":"5Shd2","../../constants/featureFlagIds":"33vuW","../../constants/colors":"1p3OR","../../constants/breakpoints":"2F01A","../general/Button":"6ymxN","../general/TooltipWrapper":"53pWd","../general/ToggleIndicator":"4eej1","./SessionTags":"ksD4K","42c6803afe20164c":"2nj1V","50edd29fab35f5b":"jFRAy","85fcb9f775fcd9a8":"i2fS0","bab853a0092b16ac":"jSys4","9d0d949b1a70269d":"6HqvT","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"5RAbR":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useProcessConversationalSuccessEvents", ()=>useProcessConversationalSuccessEvents);
var _react = require("react");
var _moment = require("moment");
var _momentDefault = parcelHelpers.interopDefault(_moment);
const useProcessConversationalSuccessEvents = (events, sessionContainer, crossOrgSessionData = [], options = {})=>{
    const { crossOrgMode = false, setConvertedCustomers, setRepeatCustomers, setUniqueEngagementCount, setUpsellPercentage } = options;
    const processingResults = (0, _react.useMemo)(()=>{
        const generativeSessionReviews = [];
        let upsellsAttempts = 0;
        let upsellCompletes = 0;
        if (!events || events.length === 0) return {
            reviews: [],
            stats: {
                convertedCustomers: 0,
                repeatCustomers: 0,
                uniqueEngagementCount: 0,
                upsellPercentage: 0
            }
        };
        // Create a map to track the best event for each sessionId
        const sessionEventMap = new Map();
        for (const conversationalSuccessEvent of events){
            let session = sessionContainer.sessions.find((s)=>s.sessionId === conversationalSuccessEvent.sessionId);
            if (!session) {
                if (crossOrgMode) session = crossOrgSessionData.find((s)=>s.sessionId === conversationalSuccessEvent.sessionId);
                if (!session) continue;
            }
            if (!conversationalSuccessEvent?.sessionId) continue; // Skip events without sessionId
            const sessionId = conversationalSuccessEvent.sessionId;
            const existingEvent = sessionEventMap.get(sessionId);
            if (!existingEvent) // First event for this sessionId
            sessionEventMap.set(sessionId, conversationalSuccessEvent);
            else {
                // Choose the better event based on priority:
                // 1. Prefer events with sessionCategory over those without
                // 2. If both have or both lack sessionCategory, prefer the one with a valid request id (integer) that is highest
                // 3. If both have or both lack sessionCategory and no request ids have integers, prefer the most recent (latest eventDate)
                const currentHasCategory = !!conversationalSuccessEvent.sessionCategory;
                const existingHasCategory = !!existingEvent.sessionCategory;
                let shouldReplace = false;
                if (currentHasCategory && !existingHasCategory) // Current has category, existing doesn't - replace
                shouldReplace = true;
                else if (!currentHasCategory && existingHasCategory) // Current doesn't have category, existing does - keep existing
                shouldReplace = false;
                else {
                    // Both have category or both don't have category - use most recent
                    const currentRequestId = `${conversationalSuccessEvent.requestId}`;
                    const existingRequestId = `${existingEvent.requestId}`;
                    const currentIsInteger = /^\d+$/.test(currentRequestId);
                    const existingIsInteger = /^\d+$/.test(existingRequestId);
                    if (currentIsInteger && !existingIsInteger) shouldReplace = true;
                    else if (!currentIsInteger && existingIsInteger) shouldReplace = false;
                    else if (currentIsInteger && existingIsInteger) {
                        // Both are integers, compare them as numbers
                        const currentRequestIdNum = parseInt(currentRequestId, 10);
                        const existingRequestIdNum = parseInt(existingRequestId, 10);
                        shouldReplace = currentRequestIdNum > existingRequestIdNum;
                    } else {
                        const currentDate = new Date(conversationalSuccessEvent.eventDate || 0);
                        const existingDate = new Date(existingEvent.eventDate || 0);
                        shouldReplace = currentDate > existingDate;
                    }
                }
                if (shouldReplace) sessionEventMap.set(sessionId, conversationalSuccessEvent);
            }
        }
        // Convert the deduplicated events to SessionReviews, skipping those without categories
        for (const conversationalSuccessEvent of sessionEventMap.values()){
            if (!conversationalSuccessEvent?.sessionCategory) continue; // Skip events without sessionCategory
            let session = null;
            if (crossOrgMode) session = crossOrgSessionData.find((s)=>s.sessionId === conversationalSuccessEvent.sessionId);
            else session = sessionContainer.sessions.find((s)=>s.sessionId === conversationalSuccessEvent.sessionId);
            generativeSessionReviews.push({
                sessionId: conversationalSuccessEvent.sessionId,
                summary: conversationalSuccessEvent.sessionSummary ?? "No summary",
                tags: conversationalSuccessEvent.sessionTags,
                category: conversationalSuccessEvent.sessionCategory,
                applicationId: conversationalSuccessEvent.applicationId,
                date: new Date(session?.startDate ?? session?.date ?? 0),
                userId: session?.from
            });
        }
        const groupedByUserId = generativeSessionReviews.reduce((acc, review)=>{
            if (!acc[review.userId]) acc[review.userId] = [];
            acc[review.userId].push(review);
            return acc;
        }, {});
        let convertedCustomers = 0;
        let repeatCustomers = 0;
        // foreach group order by date ascending, if there's a transfer tag before a placed tag add to converted customers
        Object.values(groupedByUserId).forEach((reviews)=>{
            reviews.sort((a, b)=>a.date.getTime() - b.date.getTime());
            let hasTransfer = false;
            let hasConverted = false;
            let orderCount = 0;
            for (const review of reviews){
                if (review.tags && review.tags.includes("TRANSFERRED")) {
                    hasTransfer = true;
                    continue;
                }
                if (review.tags.includes("ACTION_COMPLETED")) {
                    orderCount++;
                    if (hasTransfer && !hasConverted) {
                        convertedCustomers++;
                        hasConverted = true;
                    }
                }
            }
            if (orderCount > 1) repeatCustomers++;
        });
        // Sort by date ascending to process in chronological order
        generativeSessionReviews.sort((a, b)=>a.date.getTime() - b.date.getTime());
        // Category priority for merging (higher number = higher priority)
        const categoryPriority = {
            "ACTION_ATTEMPTED": 5,
            "QUESTION_ANSWERED": 4,
            "OTHER": 3,
            "IMMEDIATE_TRANSFER": 2,
            "NO_INTERACTION": 1
        };
        // Combine sessions within 10 minutes that don't have ACTION_COMPLETED
        const combinedReviews = [];
        const processedIndices = new Set();
        for(let i = 0; i < generativeSessionReviews.length; i++){
            if (processedIndices.has(i)) continue;
            const currentReview = generativeSessionReviews[i];
            if (currentReview.tags?.includes("UPSELL_ATTEMPTED")) upsellsAttempts++;
            if (currentReview.tags?.includes("UPSELL_SUCCESSFUL")) upsellCompletes++;
            // Skip if this review already has ACTION_COMPLETED tag
            if (currentReview.tags && currentReview.tags.includes("ACTION_COMPLETED")) {
                combinedReviews.push(currentReview);
                processedIndices.add(i);
                continue;
            }
            // Find all reviews within 10 minutes after this one (rolling window)
            const relatedReviews = [
                currentReview
            ];
            const relatedIndices = [
                i
            ];
            let lastRelatedTime = currentReview.date.getTime(); // Track the time of the last related call
            for(let j = i + 1; j < generativeSessionReviews.length; j++){
                if (processedIndices.has(j)) continue;
                const laterReview = generativeSessionReviews[j];
                const timeDifference = laterReview.date.getTime() - lastRelatedTime; // Compare to last related call, not first
                const tenMinutesInMs = 600000; // 10 minutes in milliseconds
                // Only combine calls if they have the same user ID and are within 10 minutes of the last related call
                if (timeDifference <= tenMinutesInMs && laterReview.userId === currentReview.userId) {
                    relatedReviews.push(laterReview);
                    relatedIndices.push(j);
                    lastRelatedTime = laterReview.date.getTime(); // Reset the timer - use this call as the new reference point
                } else if (timeDifference > tenMinutesInMs) break;
            }
            // Mark all related indices as processed
            relatedIndices.forEach((index)=>processedIndices.add(index));
            if (relatedReviews.length === 1) // No related reviews, add as-is
            combinedReviews.push({
                ...currentReview,
                mergedSessions: [
                    {
                        sessionId: currentReview.sessionId,
                        startDate: currentReview.date ? currentReview.date.toISOString() : null
                    }
                ]
            });
            else {
                // Combine multiple related reviews
                // Determine the best category based on priority
                let bestCategory = relatedReviews[0].category;
                let highestPriority = categoryPriority[bestCategory] || 0;
                for (const review of relatedReviews){
                    const priority = categoryPriority[review.category] || 0;
                    if (priority > highestPriority) {
                        highestPriority = priority;
                        bestCategory = review.category;
                    } else if (bestCategory === "OTHER" && review.category === "IMMEDIATE_TRANSFER") // If we end with an IMMEDIATE_TRANSFER, it takes precedence over OTHER
                    bestCategory = review.category;
                }
                // Combine tags from all sessions in the merge
                // For groupable tags (ACTION_COMPLETED, etc.), preserve all occurrences since each
                // session's tags already have the correct counts from the backend
                // For other tags, deduplicate to avoid redundancy
                const GROUPABLE_TAGS = [
                    "ACTION_COMPLETED",
                    "APPOINTMENT_RESCHEDULED",
                    "APPOINTMENT_CANCELLED",
                    "CHECK_NEXT_APPOINTMENT_COMPLETE"
                ];
                const allTags = [];
                const seenNonGroupableTags = new Set();
                relatedReviews.forEach((review)=>{
                    if (review.tags) review.tags.forEach((tag)=>{
                        if (GROUPABLE_TAGS.includes(tag)) // Always add groupable tags - preserve all occurrences
                        // since each session's tags already have correct counts from backend
                        allTags.push(tag);
                        else if (!seenNonGroupableTags.has(tag)) {
                            // Dedupe non-groupable tags across sessions
                            seenNonGroupableTags.add(tag);
                            allTags.push(tag);
                        }
                    });
                });
                // Combine summaries with call numbers, using custom messages for certain categories
                // Helper to get the formatted start time for a review
                const getStartTime = (review)=>{
                    // Try to find the session for this review
                    let session = sessionContainer.sessions.find((s)=>s.sessionId === review.sessionId);
                    if (!session && crossOrgMode) session = crossOrgSessionData.find((s)=>s.sessionId === review.sessionId);
                    if (session && session?.startDate) // Use moment if available, else fallback to toLocaleTimeString
                    try {
                        return (0, _momentDefault.default)(session.startDate).format("h:mm a");
                    } catch  {
                        return new Date(session.startDate).toLocaleTimeString([], {
                            hour: "2-digit",
                            minute: "2-digit"
                        });
                    }
                    return "";
                };
                const combinedSummary = relatedReviews.map((review, index)=>{
                    let summary = review.summary && review.summary !== "No summary" ? review.summary : null;
                    if (!summary) {
                        if (review.category === "IMMEDIATE_TRANSFER") summary = "• Customer immediately requested to transfer.";
                        else if (review.category === "NO_INTERACTION") summary = "• Customer didn't interact with the assistant.";
                        else summary = "No summary available";
                    }
                    const startTime = getStartTime(review);
                    const callLabel = startTime ? `Call #${index + 1}  (${startTime})` : `Call #${index + 1}`;
                    return `${callLabel}\n${summary}`;
                }).join("\n\n").replace(/\n\s*\n/g, "\n"); // Remove empty lines
                // remove any tags that lowered start with "vfy_" from the combined tags
                let tags = [
                    ...allTags
                ];
                if (!crossOrgMode) tags = tags.filter((tag)=>!tag?.toLowerCase().startsWith("vfy_"));
                // Create combined review using the earliest session's data as base
                const combinedReview = {
                    sessionId: currentReview.sessionId,
                    // Use the first session ID
                    summary: combinedSummary,
                    tags: tags,
                    category: bestCategory,
                    applicationId: currentReview.applicationId,
                    date: currentReview.date,
                    // Use the earliest date
                    mergedSessions: relatedReviews.map((r)=>({
                            sessionId: r.sessionId,
                            startDate: r.date ? r.date.toISOString() : null
                        }))
                };
                combinedReviews.push(combinedReview);
            }
        }
        return {
            reviews: combinedReviews,
            stats: {
                convertedCustomers,
                repeatCustomers,
                uniqueEngagementCount: combinedReviews.length,
                upsellPercentage: upsellsAttempts > 0 ? upsellCompletes / upsellsAttempts * 100 : 0
            }
        };
    }, [
        events,
        sessionContainer.sessions,
        crossOrgSessionData,
        crossOrgMode
    ]);
    // Use useEffect to call state setters when results change
    (0, _react.useEffect)(()=>{
        setConvertedCustomers?.(processingResults.stats.convertedCustomers);
        setRepeatCustomers?.(processingResults.stats.repeatCustomers);
        setUniqueEngagementCount?.(processingResults.stats.uniqueEngagementCount);
        setUpsellPercentage?.(processingResults.stats.upsellPercentage);
    }, [
        processingResults.stats,
        setConvertedCustomers,
        setRepeatCustomers,
        setUniqueEngagementCount,
        setUpsellPercentage
    ]);
    return processingResults.reviews;
};

},{"react":"6uln9","moment":"2meyw","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"a6pQY":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TagFilterModal", ()=>TagFilterModal);
var _base = require("@emotion/styled/base");
var _baseDefault = parcelHelpers.interopDefault(_base);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _smallModalLayout = require("../structure/SmallModalLayout");
var _smallModalLayoutDefault = parcelHelpers.interopDefault(_smallModalLayout);
var _button = require("../general/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _stylesValues = require("../../constants/stylesValues");
var _featureFlagIds = require("../../constants/featureFlagIds");
var _colors = require("../../constants/colors");
var _modalHeader = require("../general/ModalHeader");
var _modalHeaderDefault = parcelHelpers.interopDefault(_modalHeader);
var _footerBar = require("../structure/FooterBar");
var _footerBarDefault = parcelHelpers.interopDefault(_footerBar);
var _switch = require("../forms/Switch");
var _switchDefault = parcelHelpers.interopDefault(_switch);
var _css = require("@emotion/css");
var _generativeCallReview = require("../../constants/analyticsConstants/generativeCallReview");
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const TAGS_TO_FILTER_OUT = [];
const TagFilterModal = /*#__PURE__*/ (0, _reactDefault.default).memo(({ isVisible, onClose, tags, tagsForDisplay: originalTagsForDisplay, selectedTags, excludedTags, onToggle, onApply, isLoading = false, isCrossOrgMode = false, application, setFilterLogic })=>{
    const [localSelectedTags, setLocalSelectedTags] = (0, _react1.useState)(new Set());
    const [localExcludedTags, setLocalExcludedTags] = (0, _react1.useState)(new Set());
    const [currentPage, setCurrentPage] = (0, _react1.useState)(1);
    const [isApplying, setIsApplying] = (0, _react1.useState)(false);
    const [includeMode, setIncludeMode] = (0, _react1.useState)("AND");
    const TAGS_PER_PAGE = 50; // Show 50 tags per page for better performance
    (0, _react1.useEffect)(()=>{
        if (isVisible) {
            setLocalSelectedTags(new Set(selectedTags));
            setLocalExcludedTags(new Set(excludedTags));
            setCurrentPage(1);
        }
    }, [
        isVisible,
        selectedTags,
        excludedTags
    ]);
    (0, _react1.useEffect)(()=>{
        setFilterLogic(includeMode);
    }, [
        includeMode
    ]);
    const handleIncludeToggle = (0, _react1.useCallback)((tag)=>{
        setLocalSelectedTags((prev)=>{
            const newSet = new Set(prev);
            if (newSet.has(tag)) newSet.delete(tag);
            else {
                newSet.add(tag);
                setLocalExcludedTags((prevExcluded)=>{
                    const newExcludedSet = new Set(prevExcluded);
                    newExcludedSet.delete(tag);
                    return newExcludedSet;
                });
            }
            return newSet;
        });
    }, []);
    const handleExcludeToggle = (0, _react1.useCallback)((tag)=>{
        setLocalExcludedTags((prev)=>{
            const newSet = new Set(prev);
            if (newSet.has(tag)) newSet.delete(tag);
            else {
                newSet.add(tag);
                setLocalSelectedTags((prevSelected)=>{
                    const newSelectedSet = new Set(prevSelected);
                    newSelectedSet.delete(tag);
                    return newSelectedSet;
                });
            }
            return newSet;
        });
    }, []);
    const filteredTagPairs = (0, _react1.useMemo)(()=>{
        let pairs = tags.map((tag, idx)=>({
                tag,
                tagDisplay: originalTagsForDisplay[idx]
            }));
        if (!isCrossOrgMode) {
            // Filter out Customer Delight tags
            pairs = pairs.filter(({ tagDisplay })=>!TAGS_TO_FILTER_OUT.includes(tagDisplay));
            // Filter based on application type
            if (application?.featureFlags?.some((flag)=>flag.id === (0, _featureFlagIds.FoodOrderingFeatureFlagId))) // For foodOrdering, exclude healthcare-only tags
            pairs = pairs.filter(({ tag })=>(0, _generativeCallReview.FOOD_ORDERING_TAGS).includes(tag));
            else if (application?.featureFlags?.some((flag)=>flag.id === (0, _featureFlagIds.HealthcareSchedulingFeatureFlagId))) // For healthcare, exclude foodOrdering-only tags
            pairs = pairs.filter(({ tag })=>(0, _generativeCallReview.HEALTHCARE_TAGS).includes(tag));
        }
        return pairs;
    }, [
        tags,
        originalTagsForDisplay,
        isCrossOrgMode,
        application?.featureFlags
    ]);
    const sortedTags = (0, _react1.useMemo)(()=>{
        const tagPairs = filteredTagPairs.map(({ tag, tagDisplay })=>({
                tag,
                tagDisplay,
                sortKey: (tagDisplay || tag).toLowerCase()
            }));
        return tagPairs.sort((a, b)=>a.sortKey.localeCompare(b.sortKey));
    }, [
        filteredTagPairs
    ]);
    const paginationInfo = (0, _react1.useMemo)(()=>{
        const totalPages = Math.ceil(sortedTags.length / TAGS_PER_PAGE);
        const startIndex = (currentPage - 1) * TAGS_PER_PAGE;
        const endIndex = Math.min(startIndex + TAGS_PER_PAGE, sortedTags.length);
        const currentPageTags = sortedTags.slice(startIndex, endIndex);
        return {
            totalPages,
            currentPageTags,
            totalItems: sortedTags.length,
            startIndex: startIndex + 1,
            endIndex
        };
    }, [
        sortedTags,
        currentPage
    ]);
    const handleApply = (0, _react1.useCallback)(async ()=>{
        setIsApplying(true);
        try {
            // Batch all changes to minimize re-renders
            const selectedChanges = [];
            const excludedChanges = [];
            for (const tag of localSelectedTags)if (!selectedTags.has(tag)) selectedChanges.push({
                tag,
                action: "add"
            });
            for (const tag of selectedTags)if (!localSelectedTags.has(tag)) selectedChanges.push({
                tag,
                action: "remove"
            });
            for (const tag of localExcludedTags)if (!excludedTags.has(tag)) excludedChanges.push({
                tag,
                action: "add"
            });
            for (const tag of excludedTags)if (!localExcludedTags.has(tag)) excludedChanges.push({
                tag,
                action: "remove"
            });
            // Apply all changes in batches to reduce re-renders
            selectedChanges.forEach(({ tag })=>onToggle(tag, "include"));
            excludedChanges.forEach(({ tag })=>onToggle(tag, "exclude"));
            await onApply(includeMode);
            onClose();
        } catch (error) {
            console.error("Error applying tag filters:", error);
        } finally{
            setIsApplying(false);
        }
    }, [
        localSelectedTags,
        localExcludedTags,
        selectedTags,
        excludedTags,
        onToggle,
        onApply,
        onClose,
        includeMode
    ]);
    const handleReset = (0, _react1.useCallback)(()=>{
        setLocalSelectedTags(new Set());
        setLocalExcludedTags(new Set());
    }, []);
    const hasChanges = (0, _react1.useMemo)(()=>{
        const selectedEqual = localSelectedTags.size === selectedTags.size && Array.from(localSelectedTags).every((tag)=>selectedTags.has(tag));
        const excludedEqual = localExcludedTags.size === excludedTags.size && Array.from(localExcludedTags).every((tag)=>excludedTags.has(tag));
        return !selectedEqual || !excludedEqual;
    }, [
        localSelectedTags,
        localExcludedTags,
        selectedTags,
        excludedTags
    ]);
    return (0, _react.jsx)((0, _smallModalLayoutDefault.default), {
        isVisible: isVisible,
        onClose: onClose,
        className: modalContentStyle,
        innerClassName: modalInnerStyle
    }, (0, _react.jsx)((0, _modalHeaderDefault.default), {
        title: "Filter Calls by Tags",
        onClose: onClose
    }), (0, _react.jsx)(ModalBody, null, isLoading || isApplying ? (0, _react.jsx)(LoadingContainer, null, (0, _react.jsx)(LoadingSpinner, null), (0, _react.jsx)(LoadingText, null, isApplying ? "Applying filters..." : "Loading tags...")) : (0, _react.jsx)(ScrollContainer, null, (0, _react.jsx)(FilterSections, null, (0, _react.jsx)(IncludeFilterSection, null, (0, _react.jsx)(SectionHeader, null, (0, _react.jsx)(SectionTitleRow, null, (0, _react.jsx)(SectionTitle, null, (0, _react.jsx)(IncludeIcon, null, "✓"), "Include Tags", (0, _react.jsx)(ModeSelector, null, (0, _react.jsx)(ModeLabel, null, "AND"), (0, _react.jsx)((0, _switchDefault.default), {
        checked: includeMode === "OR",
        onChange: (checked)=>setIncludeMode(checked ? "OR" : "AND"),
        disabled: isApplying
    }), (0, _react.jsx)(ModeLabel, null, "OR")))), (0, _react.jsx)(SectionSubtitle, null, includeMode === "AND" ? "Show calls that have ALL of these tags" : "Show calls that have ANY of these tags")), (0, _react.jsx)(TagsList, {
        position: "left"
    }, paginationInfo.currentPageTags.length === 0 ? (0, _react.jsx)(NoTagsMessage, null, "No tags available.") : paginationInfo.currentPageTags.map(({ tag, tagDisplay })=>{
        const isSelected = localSelectedTags.has(tag);
        const isDisabled = localExcludedTags.has(tag);
        return (0, _react.jsx)(TagCheckboxItem, {
            key: `include-${tag}`,
            onClick: ()=>!isDisabled && handleIncludeToggle(tag),
            disabled: isDisabled,
            selected: isSelected
        }, (0, _react.jsx)(Checkbox, {
            type: "checkbox",
            checked: isSelected,
            disabled: isDisabled,
            readOnly: true
        }), (0, _react.jsx)(TagText, {
            selected: isSelected,
            disabled: isDisabled
        }, tagDisplay));
    }))), (0, _react.jsx)(ExcludeFilterSection, null, (0, _react.jsx)(SectionHeader, null, (0, _react.jsx)(SectionTitle, null, (0, _react.jsx)(ExcludeIcon, null, "✗"), "Exclude Tags"), (0, _react.jsx)(SectionSubtitle, null, "Hide calls that have these tags")), (0, _react.jsx)(TagsList, {
        position: "right"
    }, paginationInfo.currentPageTags.length === 0 ? (0, _react.jsx)(NoTagsMessage, null, "No tags available.") : paginationInfo.currentPageTags.map(({ tag, tagDisplay })=>{
        const isSelected = localExcludedTags.has(tag);
        const isDisabled = localSelectedTags.has(tag);
        return (0, _react.jsx)(TagCheckboxItem, {
            key: `exclude-${tag}`,
            onClick: ()=>!isDisabled && handleExcludeToggle(tag),
            disabled: isDisabled,
            selected: isSelected
        }, (0, _react.jsx)(Checkbox, {
            type: "checkbox",
            checked: isSelected,
            disabled: isDisabled,
            readOnly: true
        }), (0, _react.jsx)(TagText, {
            selected: isSelected,
            disabled: isDisabled
        }, tagDisplay));
    })))), paginationInfo.totalItems > TAGS_PER_PAGE && (0, _react.jsx)(PaginationFooter, null, (0, _react.jsx)(PaginationControls, null, (0, _react.jsx)(PaginationButton, {
        onClick: ()=>setCurrentPage((p)=>Math.max(1, p - 1)),
        disabled: currentPage === 1
    }, "Previous"), (0, _react.jsx)(PageInfo, null, currentPage, " / ", paginationInfo.totalPages), (0, _react.jsx)(PaginationButton, {
        onClick: ()=>setCurrentPage((p)=>Math.min(paginationInfo.totalPages, p + 1)),
        disabled: currentPage === paginationInfo.totalPages
    }, "Next"))))), (0, _react.jsx)((0, _footerBarDefault.default), null, (0, _react.jsx)(ButtonsWrapper, null, (0, _react.jsx)(ResetButton, {
        themes: [
            "white-small"
        ],
        text: "Reset All",
        onClick: handleReset,
        disabled: localSelectedTags.size === 0 && localExcludedTags.size === 0 || isApplying
    }), (0, _react.jsx)(CancelAndApplyButtons, null, (0, _react.jsx)(CancelButton, {
        themes: [
            "white-small"
        ],
        text: "Cancel",
        onClick: onClose,
        disabled: isApplying
    }), (0, _react.jsx)(ApplyButton, {
        themes: [
            "primary"
        ],
        text: "Apply Filters",
        onClick: handleApply,
        disabled: !hasChanges || isApplying,
        loading: isApplying
    })))));
});
TagFilterModal.displayName = "TagFilterModal";
const ButtonsWrapper = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e16fptld29"
})({
    name: "1ks9uvr",
    styles: "display:flex;justify-content:space-between;align-items:center;width:100%"
});
const modalContentStyle = /*#__PURE__*/ (0, _css.css)({
    name: "ju2had",
    styles: "width:100%;max-width:900px;height:80vh;max-height:80vh;@media (max-width: 768px){width:98%;max-width:100%;height:90vh;max-height:90vh;}"
});
const CancelAndApplyButtons = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e16fptld28"
})("");
const modalInnerStyle = /*#__PURE__*/ (0, _css.css)({
    name: "13ku56z",
    styles: "display:flex;flex-direction:column;height:100%"
});
const ModalBody = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e16fptld27"
})({
    name: "1k64kkp",
    styles: "padding:24px;padding-right:24px;flex:1;overflow:hidden;display:flex;flex-direction:column;position:relative;min-height:0"
});
const ScrollContainer = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e16fptld26"
})({
    name: "1to15qa",
    styles: "flex:1;display:flex;flex-direction:column;position:relative;min-height:0;height:100%"
});
const FilterSections = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e16fptld25"
})({
    name: "11ngjng",
    styles: "display:flex;flex-direction:row;gap:12px;flex:1;margin-bottom:76px;min-height:0;height:100%;@media (max-width: 768px){flex-direction:column;}"
});
const IncludeFilterSection = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e16fptld24"
})({
    name: "1fo2npg",
    styles: "display:flex;flex-direction:column;flex:1;min-width:0;min-height:0;max-height:100%"
});
const ExcludeFilterSection = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e16fptld23"
})({
    name: "1fo2npg",
    styles: "display:flex;flex-direction:column;flex:1;min-width:0;min-height:0;max-height:100%"
});
const SectionHeader = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e16fptld22"
})({
    name: "13l5mxs",
    styles: "margin-bottom:12px;flex-shrink:0"
});
const SectionTitleRow = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e16fptld21"
})({
    name: "gurmh7",
    styles: "display:flex;align-items:center;margin-bottom:4px"
});
const ModeSelector = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e16fptld20"
})({
    name: "spmvtc",
    styles: "display:flex;align-items:center;gap:8px;margin-left:16px"
});
const ModeLabel = /*#__PURE__*/ (0, _baseDefault.default)("span", {
    target: "e16fptld19"
})("font-size:0.75rem;font-weight:500;color:", (0, _colors.color_text_default), ";min-width:24px;text-align:center;");
const SectionTitle = /*#__PURE__*/ (0, _baseDefault.default)("h3", {
    target: "e16fptld18"
})("display:flex;align-items:center;gap:8px;font-size:1rem;font-weight:600;color:", (0, _colors.color_text_default), ";margin:0 0 4px 0;");
const SectionSubtitle = /*#__PURE__*/ (0, _baseDefault.default)("p", {
    target: "e16fptld17"
})("font-size:0.75rem;color:", (0, _colors.color_text_light), ";margin:0;font-style:italic;");
const IncludeIcon = /*#__PURE__*/ (0, _baseDefault.default)("span", {
    target: "e16fptld16"
})("color:", (0, _colors.color_colors_growth), ";font-weight:bold;font-size:1rem;");
const ExcludeIcon = /*#__PURE__*/ (0, _baseDefault.default)("span", {
    target: "e16fptld15"
})("color:", (0, _colors.color_colors_decline), ";font-weight:bold;font-size:1rem;");
const TagCheckboxItem = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e16fptld14"
})("display:flex;align-items:center;gap:8px;padding:8px 12px;cursor:", (props)=>props.disabled ? "not-allowed" : "pointer", ";border-radius:6px;margin-bottom:2px;background:", (props)=>{
    if (props.disabled) return 0, _colors.color_shades_light;
    if (props.selected) return 0, _colors.color_shades_lighter;
    return "transparent";
}, ";border:1px solid transparent;opacity:", (props)=>props.disabled ? "0.5" : "1", ";&:hover{background:", (props)=>{
    if (props.disabled) return 0, _colors.color_shades_light;
    if (props.selected) return 0, _colors.color_shades_lighter;
    return 0, _colors.color_shades_lighter;
}, ";}&:last-child{margin-bottom:0;}");
const Checkbox = /*#__PURE__*/ (0, _baseDefault.default)("input", {
    target: "e16fptld13"
})("width:16px;height:16px;cursor:", (props)=>props.disabled ? "not-allowed" : "pointer", ";margin:0;flex-shrink:0;");
const LoadingContainer = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e16fptld12"
})({
    name: "8ilaqx",
    styles: "display:flex;flex-direction:column;align-items:center;justify-content:center;flex:1;gap:16px"
});
const LoadingSpinner = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e16fptld11"
})("width:40px;height:40px;border:3px solid ", (0, _colors.color_shades_light), ";border-top:3px solid ", (0, _colors.color_colors_growth), ";border-radius:50%;animation:spin 1s linear infinite;@keyframes spin{0%{transform:rotate(0deg);}100%{transform:rotate(360deg);}}");
const LoadingText = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e16fptld10"
})("font-size:0.875rem;color:", (0, _colors.color_text_light), ";");
const TagsList = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e16fptld9"
})("border:", (0, _stylesValues.style_border_default), ";border-radius:8px;padding:8px;background:", (0, _colors.color_defaults_white), ";min-height:200px;height:0;flex-grow:1;overflow-y:auto;overflow-x:hidden;&::-webkit-scrollbar{width:8px;}&::-webkit-scrollbar-track{background:", (0, _colors.color_shades_lighter), ";border-radius:4px;}&::-webkit-scrollbar-thumb{background:", (0, _colors.color_shades_darker), ";border-radius:4px;}&::-webkit-scrollbar-thumb:hover{background:#555;}@media (max-width: 768px){min-height:150px;}");
const NoTagsMessage = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e16fptld8"
})("text-align:center;padding:32px 16px;color:", (0, _colors.color_text_light), ";font-size:0.875rem;font-style:italic;");
const TagText = /*#__PURE__*/ (0, _baseDefault.default)("span", {
    target: "e16fptld7"
})("font-size:0.9rem;color:", (props)=>{
    if (props.disabled) return 0, _colors.color_text_light;
    if (props.selected) return 0, _colors.color_text_default;
    return 0, _colors.color_text_default;
}, ";font-weight:", (props)=>props.selected ? "500" : "normal", ";flex:1;");
const ResetButton = /*#__PURE__*/ (0, _baseDefault.default)((0, _buttonDefault.default), {
    target: "e16fptld6"
})({
    name: "1edorjh",
    styles: "min-width:80px"
});
const CancelButton = /*#__PURE__*/ (0, _baseDefault.default)((0, _buttonDefault.default), {
    target: "e16fptld5"
})({
    name: "1edorjh",
    styles: "min-width:80px"
});
const ApplyButton = /*#__PURE__*/ (0, _baseDefault.default)((0, _buttonDefault.default), {
    target: "e16fptld4"
})({
    name: "lq4swo",
    styles: "min-width:120px"
});
const PaginationFooter = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e16fptld3"
})("display:flex;justify-content:center;align-items:center;padding:8px 0;border-top:", (0, _stylesValues.style_border_default), ";margin-top:8px;flex-shrink:0;");
const PaginationControls = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e16fptld2"
})({
    name: "1yydxi7",
    styles: "display:flex;align-items:center;gap:8px"
});
const PaginationButton = /*#__PURE__*/ (0, _baseDefault.default)("button", {
    target: "e16fptld1"
})("padding:4px 8px;border:1px solid ", (0, _colors.color_shades_darker), ";background:", (0, _colors.color_defaults_white), ";color:", (0, _colors.color_text_default), ";font-size:0.75rem;border-radius:4px;cursor:pointer;transition:all 0.2s ease;&:hover:not(:disabled){background:", (0, _colors.color_shades_lighter), ";border-color:", (0, _colors.color_shades_darker), ";}&:disabled{opacity:0.5;cursor:not-allowed;background:", (0, _colors.color_shades_light), ";}");
const PageInfo = /*#__PURE__*/ (0, _baseDefault.default)("span", {
    target: "e16fptld0"
})("font-size:0.75rem;color:", (0, _colors.color_text_default), ";font-weight:500;margin:0 4px;");

},{"@emotion/styled/base":"lSuFu","@emotion/react":"djZKr","react":"6uln9","../structure/SmallModalLayout":"khwvt","../general/Button":"6ymxN","../../constants/stylesValues":"dHVVv","../../constants/featureFlagIds":"33vuW","../../constants/colors":"1p3OR","../general/ModalHeader":"aUACx","../structure/FooterBar":"bibRL","../forms/Switch":"8kkL9","@emotion/css":"awUBr","../../constants/analyticsConstants/generativeCallReview":"5Shd2","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jFRAy":[function(require,module,exports) {
module.exports = require("c7771c4c08b45f37").getBundleURL("kVLro") + require("8f246bec6b88aefb").resolve("bmLF9");

},{"c7771c4c08b45f37":"c7Tr5","8f246bec6b88aefb":"fyJL2"}],"i2fS0":[function(require,module,exports) {
module.exports = require("af7a6a4d61c96e85").getBundleURL("kVLro") + require("383422725b4ba395").resolve("7hkTt");

},{"af7a6a4d61c96e85":"c7Tr5","383422725b4ba395":"fyJL2"}],"jEqDs":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "GraphFilterModal", ()=>GraphFilterModal);
var _base = require("@emotion/styled/base");
var _baseDefault = parcelHelpers.interopDefault(_base);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _smallModalLayout = require("../structure/SmallModalLayout");
var _smallModalLayoutDefault = parcelHelpers.interopDefault(_smallModalLayout);
var _button = require("../general/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _customScrollbars = require("../structure/CustomScrollbars");
var _customScrollbarsDefault = parcelHelpers.interopDefault(_customScrollbars);
var _useWindowSize = require("../../hooks/UseWindowSize");
var _useWindowSizeDefault = parcelHelpers.interopDefault(_useWindowSize);
var _stylesValues = require("../../constants/stylesValues");
var _colors = require("../../constants/colors");
var _modalHeader = require("../general/ModalHeader");
var _modalHeaderDefault = parcelHelpers.interopDefault(_modalHeader);
var _footerBar = require("../structure/FooterBar");
var _footerBarDefault = parcelHelpers.interopDefault(_footerBar);
var _css = require("@emotion/css");
var _generativeCallReview = require("../../constants/analyticsConstants/generativeCallReview");
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const MODAL_SCROLLBAR_SUBTRACTION = 175;
const GraphFilterModal = /*#__PURE__*/ (0, _reactDefault.default).memo(({ isVisible, onClose, categoriesForDisplay, tagsForDisplay: originalTagsForDisplay, categories, tags, onToggleTag, onToggleCategory, onApply, isLoading = false, application, assistantIndustry, currentToggledCategories, currentToggledTags })=>{
    const TAGS_TO_FILTER_OUT = [];
    const [localSelectedTags, setLocalSelectedTags] = (0, _react1.useState)(new Set(currentToggledTags));
    const [localSelectedCategories, setLocalCategories] = (0, _react1.useState)(new Set(currentToggledCategories));
    const [currentPage, setCurrentPage] = (0, _react1.useState)(1);
    const [isApplying, setIsApplying] = (0, _react1.useState)(false);
    const windowSize = (0, _useWindowSizeDefault.default)();
    const TAGS_PER_PAGE = 50; // Show 50 tags per page for better performance
    const CATS_PER_PAGE = 50;
    (0, _react1.useEffect)(()=>{
        if (isVisible) {
            setLocalCategories(new Set(currentToggledCategories));
            setLocalSelectedTags(new Set(currentToggledTags));
            setCurrentPage(1);
        }
    }, [
        isVisible,
        tags,
        categories
    ]);
    const handleTagsToggle = (0, _react1.useCallback)((tag)=>{
        onToggleTag(tag);
        setLocalSelectedTags((prev)=>{
            const newSet = new Set(prev);
            if (newSet.has(tag)) newSet.delete(tag);
            else newSet.add(tag);
            return newSet;
        });
    }, []);
    const handleCategoriesToggle = (0, _react1.useCallback)((cat)=>{
        onToggleCategory(cat);
        setLocalCategories((prev)=>{
            const newSet = new Set(prev);
            if (newSet.has(cat)) newSet.delete(cat);
            else newSet.add(cat);
            return newSet;
        });
    }, []);
    const filteredTagPairs = (0, _react1.useMemo)(()=>{
        let pairs = tags.map((tag)=>({
                tag,
                tagDisplay: (0, _generativeCallReview.getTagName)(tag, assistantIndustry)
            }));
        pairs = pairs.filter(({ tagDisplay })=>!TAGS_TO_FILTER_OUT.includes(tagDisplay));
        // Filter based on application type
        if (assistantIndustry === "FOOD_ORDERING") // For foodOrdering, exclude healthcare-only tags
        pairs = pairs.filter(({ tag })=>(0, _generativeCallReview.FOOD_ORDERING_TAGS).includes(tag));
        else if (assistantIndustry === "HEALTHCARE") // For healthcare, exclude foodOrdering-only tags
        pairs = pairs.filter(({ tag })=>(0, _generativeCallReview.HEALTHCARE_TAGS).includes(tag));
        return pairs;
    }, [
        tags,
        assistantIndustry,
        application?.featureFlags
    ]);
    const filteredCategoryPairs = (0, _react1.useMemo)(()=>{
        let pairs = categories.map((cat)=>({
                cat,
                catDisplay: (0, _generativeCallReview.getCategoryName)(cat, assistantIndustry)
            }));
        return pairs;
    }, [
        categories,
        assistantIndustry,
        application?.featureFlags
    ]);
    const sortedTags = (0, _react1.useMemo)(()=>{
        const tagPairs = filteredTagPairs.map(({ tag, tagDisplay })=>({
                tag,
                tagDisplay,
                sortKey: (tagDisplay || tag).toLowerCase()
            }));
        return tagPairs.sort((a, b)=>a.sortKey.localeCompare(b.sortKey));
    }, [
        filteredTagPairs
    ]);
    const paginationTagInfo = (0, _react1.useMemo)(()=>{
        const totalPages = Math.ceil(sortedTags.length / TAGS_PER_PAGE);
        const startIndex = (currentPage - 1) * TAGS_PER_PAGE;
        const endIndex = Math.min(startIndex + TAGS_PER_PAGE, sortedTags.length);
        const currentPageTags = sortedTags.slice(startIndex, endIndex);
        return {
            totalPages,
            currentPageTags,
            totalItems: sortedTags.length,
            startIndex: startIndex + 1,
            endIndex
        };
    }, [
        sortedTags,
        currentPage
    ]);
    const sortedCategories = (0, _react1.useMemo)(()=>{
        const categoryPairs = filteredCategoryPairs.map(({ cat, catDisplay })=>({
                cat,
                catDisplay,
                sortKey: (catDisplay || cat).toLowerCase()
            }));
        return categoryPairs.sort((a, b)=>a.sortKey.localeCompare(b.sortKey));
    }, [
        filteredCategoryPairs
    ]);
    const paginationCatInfo = (0, _react1.useMemo)(()=>{
        const totalPages = Math.ceil(sortedCategories.length / CATS_PER_PAGE);
        const startIndex = (currentPage - 1) * CATS_PER_PAGE;
        const endIndex = Math.min(startIndex + CATS_PER_PAGE, sortedCategories.length);
        const currentPageTags = sortedCategories.slice(startIndex, endIndex);
        return {
            totalPages,
            currentPageTags,
            totalItems: sortedCategories.length,
            startIndex: startIndex + 1,
            endIndex
        };
    }, [
        sortedCategories,
        currentPage
    ]);
    const handleApply = (0, _react1.useCallback)(async ()=>{
        setIsApplying(true);
        try {
            await onApply();
            onClose();
        } catch (error) {
            console.error("Error applying tag filters:", error);
        } finally{
            setIsApplying(false);
        }
    }, [
        localSelectedTags,
        localSelectedCategories,
        tags,
        categories,
        onToggleTag,
        onToggleCategory,
        onApply,
        onClose
    ]);
    const handleReset = (0, _react1.useCallback)(()=>{
        for (const tag of localSelectedTags)onToggleTag(tag);
        for (const cat of localSelectedCategories)onToggleCategory(cat);
        setLocalSelectedTags(new Set());
        setLocalCategories(new Set());
    }, []);
    const hasChanges = (0, _react1.useMemo)(()=>{
        const selectedEqual = localSelectedTags.size === tags.length && Array.from(localSelectedTags).every((tag)=>tag in tags);
        const excludedEqual = localSelectedCategories.size === categories.length && Array.from(localSelectedCategories).every((cat)=>cat in categories);
        return !selectedEqual || !excludedEqual;
    }, [
        localSelectedTags,
        localSelectedCategories,
        tags,
        categories
    ]);
    return (0, _react.jsx)((0, _smallModalLayoutDefault.default), {
        isVisible: isVisible,
        onClose: onClose,
        className: modalContentStyle,
        innerClassName: modalInnerStyle
    }, (0, _react.jsx)((0, _modalHeaderDefault.default), {
        title: "Customize Graph Metrics",
        onClose: onClose
    }), (0, _react.jsx)(ModalBody, null, isLoading || isApplying ? (0, _react.jsx)(LoadingContainer, null, (0, _react.jsx)(LoadingSpinner, null), (0, _react.jsx)(LoadingText, null, isApplying ? "Applying filters..." : "Loading tags...")) : (0, _react.jsx)(ScrollContainer, null, (0, _react.jsx)((0, _customScrollbarsDefault.default), {
        autoHide: true,
        autoHeight: true,
        autoHeightMax: windowSize.windowSize.innerHeight * .6 - MODAL_SCROLLBAR_SUBTRACTION,
        style: {
            width: "100%"
        }
    }, (0, _react.jsx)(FilterSections, null, (0, _react.jsx)(ExcludeFilterSection, null, (0, _react.jsx)(SectionHeader, null, (0, _react.jsx)(SectionTitle, null, "Categories"), (0, _react.jsx)(SectionSubtitle, null, "Include these categories in the graph metrics")), (0, _react.jsx)(TagsList, {
        position: "right"
    }, paginationCatInfo.currentPageTags.length === 0 ? (0, _react.jsx)(NoTagsMessage, null, "No tags available.") : paginationCatInfo.currentPageTags.map(({ cat, catDisplay })=>{
        const isSelected = localSelectedCategories.has(cat);
        return (0, _react.jsx)(TagCheckboxItem, {
            key: `${cat}`,
            onClick: ()=>handleCategoriesToggle(cat),
            disabled: false,
            selected: isSelected
        }, (0, _react.jsx)(Checkbox, {
            type: "checkbox",
            checked: isSelected,
            disabled: false,
            readOnly: true
        }), (0, _react.jsx)(TagText, {
            selected: isSelected,
            disabled: false
        }, catDisplay));
    }))), (0, _react.jsx)(IncludeFilterSection, null, (0, _react.jsx)(SectionHeader, null, (0, _react.jsx)(SectionTitle, null, "Tags"), (0, _react.jsx)(SectionSubtitle, null, "Include these tags in the metrics graph")), (0, _react.jsx)(TagsList, {
        position: "left"
    }, paginationTagInfo.currentPageTags.length === 0 ? (0, _react.jsx)(NoTagsMessage, null, "No tags available.") : paginationTagInfo.currentPageTags.map(({ tag, tagDisplay })=>{
        const isSelected = localSelectedTags.has(tag);
        return (0, _react.jsx)(TagCheckboxItem, {
            key: `${tag}`,
            onClick: ()=>handleTagsToggle(tag),
            disabled: false,
            selected: isSelected
        }, (0, _react.jsx)(Checkbox, {
            type: "checkbox",
            checked: isSelected,
            disabled: false,
            readOnly: true
        }), (0, _react.jsx)(TagText, {
            selected: isSelected,
            disabled: false
        }, tagDisplay));
    })))), paginationTagInfo.totalItems > TAGS_PER_PAGE && (0, _react.jsx)(PaginationFooter, null, (0, _react.jsx)(PaginationControls, null, (0, _react.jsx)(PaginationButton, {
        onClick: ()=>setCurrentPage((p)=>Math.max(1, p - 1)),
        disabled: currentPage === 1
    }, "Previous"), (0, _react.jsx)(PageInfo, null, currentPage, " / ", paginationTagInfo.totalPages), (0, _react.jsx)(PaginationButton, {
        onClick: ()=>setCurrentPage((p)=>Math.min(paginationTagInfo.totalPages, p + 1)),
        disabled: currentPage === paginationTagInfo.totalPages
    }, "Next")))))), (0, _react.jsx)((0, _footerBarDefault.default), null, (0, _react.jsx)(ButtonsWrapper, null, (0, _react.jsx)(ResetButton, {
        themes: [
            "white-small"
        ],
        text: "Reset All",
        onClick: handleReset,
        disabled: localSelectedTags.size === 0 && localSelectedCategories.size === 0 || isApplying
    }), (0, _react.jsx)(CancelAndApplyButtons, null, (0, _react.jsx)(ApplyButton, {
        themes: [
            "primary"
        ],
        text: "Apply Filters",
        onClick: handleApply,
        disabled: !hasChanges || isApplying,
        loading: isApplying
    })))));
});
const ButtonsWrapper = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "eglxd3026"
})({
    name: "1ks9uvr",
    styles: "display:flex;justify-content:space-between;align-items:center;width:100%"
});
const modalContentStyle = /*#__PURE__*/ (0, _css.css)({
    name: "piibti",
    styles: "width:100%;max-width:900px;max-height:80vh;@media (max-width: 768px){width:98%;max-width:100%;max-height:90vh;}"
});
const CancelAndApplyButtons = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "eglxd3025"
})("");
const modalInnerStyle = /*#__PURE__*/ (0, _css.css)({
    name: "13ku56z",
    styles: "display:flex;flex-direction:column;height:100%"
});
const ModalBody = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "eglxd3024"
})({
    name: "i01psu",
    styles: "padding:4px 4px 24px 24px;padding-right:4px;flex:1;overflow:hidden;display:flex;flex-direction:column;position:relative"
});
const ScrollContainer = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "eglxd3023"
})("flex:1;display:flex;flex-direction:column;position:relative;margin-right:-20px;padding-right:24px;.scrollbar-track-y{right:-20px;left:auto;width:16px;background:transparent;z-index:1000;}.scrollbar-thumb-y{right:-18px;width:12px;background:", (0, _colors.color_shades_darker), ";border-radius:6px;}.scrollbar-container{margin-right:0;padding-right:0;}.simplebar-track.simplebar-vertical{right:-20px;width:16px;z-index:1000;}.simplebar-scrollbar:before{background:", (0, _colors.color_shades_darker), ";width:12px;right:2px;border-radius:6px;}.scrollbar-track-vertical{right:-20px;width:16px;background:transparent;}.scrollbar-thumb-vertical{background:", (0, _colors.color_shades_darker), ";border-radius:6px;width:12px;}");
const FilterSections = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "eglxd3022"
})({
    name: "khcl0v",
    styles: "display:flex;flex-direction:row;flex:1;@media (max-width: 768px){flex-direction:column;}"
});
const IncludeFilterSection = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "eglxd3021"
})({
    name: "s6cpzs",
    styles: "display:flex;flex-direction:column;flex:1;min-width:0"
});
const ExcludeFilterSection = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "eglxd3020"
})({
    name: "dsjvn5",
    styles: "display:flex;flex-direction:column;flex:1;min-width:0;margin-right:18px"
});
const SectionHeader = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "eglxd3019"
})({
    name: "13l5mxs",
    styles: "margin-bottom:12px;flex-shrink:0"
});
const SectionTitle = /*#__PURE__*/ (0, _baseDefault.default)("h3", {
    target: "eglxd3018"
})("display:flex;align-items:center;gap:8px;font-size:1rem;font-weight:600;color:", (0, _colors.color_text_default), ";margin:0 0 4px 0;");
const SectionSubtitle = /*#__PURE__*/ (0, _baseDefault.default)("p", {
    target: "eglxd3017"
})("font-size:0.75rem;color:", (0, _colors.color_text_light), ";margin:0;font-style:italic;");
const IncludeIcon = /*#__PURE__*/ (0, _baseDefault.default)("span", {
    target: "eglxd3016"
})("color:", (0, _colors.color_colors_growth), ";font-weight:bold;font-size:1rem;");
const ExcludeIcon = /*#__PURE__*/ (0, _baseDefault.default)("span", {
    target: "eglxd3015"
})("color:", (0, _colors.color_colors_decline), ";font-weight:bold;font-size:1rem;");
const TagCheckboxItem = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "eglxd3014"
})("display:flex;align-items:center;gap:8px;padding:8px 12px;cursor:", (props)=>props.disabled ? "not-allowed" : "pointer", ";border-radius:6px;margin-bottom:2px;background:", (props)=>{
    if (props.disabled) return 0, _colors.color_shades_light;
    if (props.selected) return 0, _colors.color_shades_lighter;
    return "transparent";
}, ";border:1px solid transparent;opacity:", (props)=>props.disabled ? "0.5" : "1", ";&:hover{background:", (props)=>{
    if (props.disabled) return 0, _colors.color_shades_light;
    if (props.selected) return 0, _colors.color_shades_lighter;
    return 0, _colors.color_shades_lighter;
}, ";}&:last-child{margin-bottom:0;}");
const Checkbox = /*#__PURE__*/ (0, _baseDefault.default)("input", {
    target: "eglxd3013"
})("width:16px;height:16px;cursor:", (props)=>props.disabled ? "not-allowed" : "pointer", ";margin:0;flex-shrink:0;");
const LoadingContainer = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "eglxd3012"
})({
    name: "8ilaqx",
    styles: "display:flex;flex-direction:column;align-items:center;justify-content:center;flex:1;gap:16px"
});
const LoadingSpinner = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "eglxd3011"
})("width:40px;height:40px;border:3px solid ", (0, _colors.color_shades_light), ";border-top:3px solid ", (0, _colors.color_colors_growth), ";border-radius:50%;animation:spin 1s linear infinite;@keyframes spin{0%{transform:rotate(0deg);}100%{transform:rotate(360deg);}}");
const LoadingText = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "eglxd3010"
})("font-size:0.875rem;color:", (0, _colors.color_text_light), ";");
const TagsList = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "eglxd309"
})("flex:1;border:", (0, _stylesValues.style_border_default), ";border-radius:8px;padding:8px;background:", (0, _colors.color_defaults_white), ";min-height:200px;margin-right:", (props)=>props.position === "left" ? "4px" : "0", ";margin-left:", (props)=>props.position === "right" ? "4px" : "0", ";@media (max-width: 768px){min-height:150px;}");
const NoTagsMessage = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "eglxd308"
})("text-align:center;padding:32px 16px;color:", (0, _colors.color_text_light), ";font-size:0.875rem;font-style:italic;");
const TagText = /*#__PURE__*/ (0, _baseDefault.default)("span", {
    target: "eglxd307"
})("font-size:0.9rem;color:", (props)=>{
    if (props.disabled) return 0, _colors.color_text_light;
    if (props.selected) return 0, _colors.color_text_default;
    return 0, _colors.color_text_default;
}, ";font-weight:", (props)=>props.selected ? "500" : "normal", ";flex:1;");
const ResetButton = /*#__PURE__*/ (0, _baseDefault.default)((0, _buttonDefault.default), {
    target: "eglxd306"
})({
    name: "1edorjh",
    styles: "min-width:80px"
});
const CancelButton = /*#__PURE__*/ (0, _baseDefault.default)((0, _buttonDefault.default), {
    target: "eglxd305"
})({
    name: "1edorjh",
    styles: "min-width:80px"
});
const ApplyButton = /*#__PURE__*/ (0, _baseDefault.default)((0, _buttonDefault.default), {
    target: "eglxd304"
})({
    name: "lq4swo",
    styles: "min-width:120px"
});
const PaginationFooter = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "eglxd303"
})("display:flex;justify-content:center;align-items:center;padding:8px 0;border-top:", (0, _stylesValues.style_border_default), ";margin-top:8px;flex-shrink:0;");
const PaginationControls = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "eglxd302"
})({
    name: "1yydxi7",
    styles: "display:flex;align-items:center;gap:8px"
});
const PaginationButton = /*#__PURE__*/ (0, _baseDefault.default)("button", {
    target: "eglxd301"
})("padding:4px 8px;border:1px solid ", (0, _colors.color_shades_darker), ";background:", (0, _colors.color_defaults_white), ";color:", (0, _colors.color_text_default), ";font-size:0.75rem;border-radius:4px;cursor:pointer;transition:all 0.2s ease;&:hover:not(:disabled){background:", (0, _colors.color_shades_lighter), ";border-color:", (0, _colors.color_shades_darker), ";}&:disabled{opacity:0.5;cursor:not-allowed;background:", (0, _colors.color_shades_light), ";}");
const PageInfo = /*#__PURE__*/ (0, _baseDefault.default)("span", {
    target: "eglxd300"
})("font-size:0.75rem;color:", (0, _colors.color_text_default), ";font-weight:500;margin:0 4px;");

},{"@emotion/styled/base":"lSuFu","@emotion/react":"djZKr","react":"6uln9","../structure/SmallModalLayout":"khwvt","../general/Button":"6ymxN","../structure/CustomScrollbars":"50vFq","../../hooks/UseWindowSize":"43j9z","../../constants/stylesValues":"dHVVv","../../constants/colors":"1p3OR","../general/ModalHeader":"aUACx","../structure/FooterBar":"bibRL","@emotion/css":"awUBr","../../constants/analyticsConstants/generativeCallReview":"5Shd2","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"lDrBg":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _unstatedNext = require("unstated-next");
var _useHistogram = require("../../hooks/useHistogram");
var _generativeCallReview = require("../../constants/analyticsConstants/generativeCallReview");
var _colors = require("../../constants/colors");
function useHistogramContainer(initialState = {}) {
    // --- Params state the app can update from outside (mirrors your "container" style)
    const [params, setParams] = (0, _react.useState)({
        applicationId: initialState.applicationId,
        applicationIds: initialState.applicationIds ?? [],
        startDate: initialState.startDate ?? "",
        endDate: initialState.endDate ?? "",
        categories: initialState.categories ?? [],
        tags: initialState.tags ?? [],
        featureFlagId: initialState.featureFlagId,
        title: initialState.title,
        titleStyles: initialState.titleStyles,
        subtitle: initialState.subtitle,
        scale: initialState.scale,
        selectedView: initialState.selectedView ?? "All Conversations"
    });
    // --- Helpers
    const splitDateString = (dateTime, isUtc)=>{
        const parts = isUtc ? dateTime.split("T") : dateTime.split(" ");
        const date = parts[0];
        const time = isUtc ? parts[1].split(":")[0] + ":" + parts[1].split(":")[1] : parts[1] + (parts.length > 2 ? parts[2] : "");
        const [y, m, d] = date.split("-");
        return [
            y,
            m,
            d,
            time
        ];
    };
    const MONTH_MAP = new Map([
        [
            1,
            "Jan."
        ],
        [
            2,
            "Feb."
        ],
        [
            3,
            "Mar."
        ],
        [
            4,
            "Apr."
        ],
        [
            5,
            "May."
        ],
        [
            6,
            "Jun."
        ],
        [
            7,
            "Jul."
        ],
        [
            8,
            "Aug."
        ],
        [
            9,
            "Sep."
        ],
        [
            10,
            "Oct."
        ],
        [
            11,
            "Nov."
        ],
        [
            12,
            "Dec."
        ]
    ]);
    // --- Derived inputs
    const sdSplit = (0, _react.useMemo)(()=>params.startDate ? splitDateString(params.startDate, false) : [
            "",
            "",
            "",
            ""
        ], [
        params.startDate
    ]);
    const edSplit = (0, _react.useMemo)(()=>params.endDate ? splitDateString(params.endDate, false) : [
            "",
            "",
            "",
            ""
        ], [
        params.endDate
    ]);
    const interval = (0, _react.useMemo)(()=>{
        const sameDay = sdSplit[0] && edSplit[0] && sdSplit[0] === edSplit[0] && sdSplit[1] === edSplit[1] && sdSplit[2] === edSplit[2];
        return sameDay ? 2 : 3;
    }, [
        sdSplit,
        edSplit
    ]);
    const toIsoString = (0, _react.useMemo)(()=>(dateTimeStr)=>{
            if (!dateTimeStr) return "";
            const [date, time, meridiem] = dateTimeStr.split(" ");
            let [hours, minutes] = time.split(":");
            // Convert to 24-hour format
            let hour = parseInt(hours);
            if (meridiem?.toLowerCase() === "pm" && hour !== 12) hour += 12;
            if (meridiem?.toLowerCase() === "am" && hour === 12) hour = 0;
            // Pad with leading zeros
            const formattedHour = hour.toString().padStart(2, "0");
            return `${date}T${formattedHour}:${minutes}:00`;
        }, []);
    const startDateForApi = (0, _react.useMemo)(()=>toIsoString(params.startDate), [
        params.startDate
    ]);
    const endDateForApi = (0, _react.useMemo)(()=>toIsoString(params.endDate), [
        params.endDate
    ]);
    // Check if we're using custom categories/tags (old implementation) or multi-view mode (new dropdown)
    const useCustomCategoriesAndTags = params.categories && params.categories.length > 0;
    // Define categories and tags for each view
    const viewConfig = (0, _react.useMemo)(()=>{
        const containableCategories = [
            "ACTION_ATTEMPTED",
            "OTHER"
        ];
        switch(params.selectedView){
            case "Containable Conversations":
                return {
                    datasets: [
                        {
                            name: "Containable Conversations",
                            categories: containableCategories,
                            tags: [],
                            color: (0, _colors.voicify_spark_dark)
                        },
                        {
                            name: "Contained Conversations",
                            categories: containableCategories,
                            tags: [
                                (0, _generativeCallReview.TAGS).ACTION_COMPLETED
                            ],
                            color: (0, _colors.ocean_blue)
                        }
                    ]
                };
            case "Spanish Calls":
                return {
                    datasets: [
                        {
                            name: "All Containable Conversations",
                            categories: containableCategories,
                            tags: [],
                            color: (0, _colors.voicify_spark_dark)
                        },
                        {
                            name: "Spanish Containable Conversations",
                            categories: containableCategories,
                            tags: [
                                (0, _generativeCallReview.TAGS).SPANISH
                            ],
                            color: (0, _colors.voicify_spark_medium)
                        },
                        {
                            name: "Spanish Contained Conversations",
                            categories: containableCategories,
                            tags: [
                                (0, _generativeCallReview.TAGS).ACTION_COMPLETED,
                                (0, _generativeCallReview.TAGS).SPANISH
                            ],
                            color: (0, _colors.ocean_blue)
                        }
                    ]
                };
            case "All Conversations":
                return {
                    datasets: [
                        {
                            name: "All Conversations",
                            categories: (0, _generativeCallReview.ALL_CATEGORIES),
                            tags: [],
                            color: (0, _colors.voicify_spark_dark)
                        },
                        {
                            name: "Containable Conversations",
                            categories: containableCategories,
                            tags: [],
                            color: (0, _colors.voicify_spark_medium)
                        },
                        {
                            name: "Contained Conversations",
                            categories: containableCategories,
                            tags: [
                                (0, _generativeCallReview.TAGS).ACTION_COMPLETED
                            ],
                            color: (0, _colors.ocean_blue)
                        }
                    ]
                };
            default:
                return {
                    datasets: [
                        {
                            name: "Containable Conversations",
                            categories: containableCategories,
                            tags: [],
                            color: (0, _colors.voicify_spark_dark)
                        },
                        {
                            name: "Contained Conversations",
                            categories: containableCategories,
                            tags: [
                                (0, _generativeCallReview.TAGS).ACTION_COMPLETED
                            ],
                            color: (0, _colors.voicify_spark_medium)
                        }
                    ]
                };
        }
    }, [
        params.selectedView
    ]);
    // Fetch data for the first dataset (primary)
    const { data: data1, loading: loading1, error: error1 } = (0, _useHistogram.useHistogramData)({
        applicationId: params.applicationId,
        applicationIds: params.applicationIds,
        startDate: startDateForApi,
        endDate: endDateForApi,
        categories: useCustomCategoriesAndTags ? params.categories : viewConfig.datasets[0]?.categories || [],
        tags: useCustomCategoriesAndTags ? params.tags : viewConfig.datasets[0]?.tags || [],
        interval
    });
    // Fetch data for the second dataset (only for multi-view mode)
    const { data: data2, loading: loading2, error: error2 } = (0, _useHistogram.useHistogramData)({
        applicationId: params.applicationId,
        applicationIds: params.applicationIds,
        startDate: startDateForApi,
        endDate: endDateForApi,
        categories: useCustomCategoriesAndTags ? [] : viewConfig.datasets[1]?.categories || [],
        tags: useCustomCategoriesAndTags ? [] : viewConfig.datasets[1]?.tags || [],
        interval
    });
    // Fetch data for the third dataset (only for Spanish Calls and All Conversations views in multi-view mode)
    const { data: data3, loading: loading3, error: error3 } = (0, _useHistogram.useHistogramData)({
        applicationId: params.applicationId,
        applicationIds: params.applicationIds,
        startDate: startDateForApi,
        endDate: endDateForApi,
        categories: useCustomCategoriesAndTags ? [] : viewConfig.datasets[2]?.categories || [],
        tags: useCustomCategoriesAndTags ? [] : viewConfig.datasets[2]?.tags || [],
        interval
    });
    const loading = loading1 || loading2 || loading3;
    const error = error1 || error2 || error3;
    const compareDates = (date1, date2)=>{
        if (!date1 || !date2) return 0;
        const time1 = new Date(date1).getTime();
        const time2 = new Date(date2).getTime();
        if (time1 > time2) return 1;
        if (time1 < time2) return -1;
        return 0;
    };
    // --- Derived presentation values
    const { title, subtitle, mappedDatasets } = (0, _react.useMemo)(()=>{
        const mapDay = (day, month)=>`${MONTH_MAP.get(Number(month))} ${day}`;
        const formattedStart = sdSplit[0] ? mapDay(sdSplit[2], sdSplit[1]) : "";
        const formattedEnd = edSplit[0] ? mapDay(edSplit[2], edSplit[1]) : "";
        // Use custom title if provided, otherwise use selectedView only if explicitly set, otherwise default
        const title = params.title ?? (params.selectedView && params.selectedView !== "Containable Conversations" ? params.selectedView : "CALL VOLUME");
        let subtitle = params.subtitle ?? (formattedStart && formattedEnd ? formattedStart === formattedEnd ? formattedStart : `${formattedStart}-${formattedEnd}` : "");
        const dateForAxis = (isoLocal)=>{
            const time = isoLocal;
            // Get actual JS Date
            const dateObj = new Date(time);
            // Day-of-week map → first letter
            const dayLetterMap = [
                "Sun",
                "Mon",
                "Tue",
                "Wed",
                "Thu",
                "Fri",
                "Sat"
            ];
            const dayLetter = dayLetterMap[dateObj.getDay()]; // 0 = Sunday
            const [, m, d, hhmm] = splitDateString(time, true);
            if (interval >= 3) // Example: 11/23 (M)
            return `${m}/${d} (${dayLetter})`;
            else {
                let hour = Number(hhmm.split(":")[0]);
                const minute = hhmm.split(":")[1];
                const ampm = hour >= 12 ? "PM" : "AM";
                hour = hour % 12 || 12;
                // Example: 3:45 PM (T)
                return `${hour}:${minute} ${ampm} (${dayLetter})`;
            }
        };
        const cleanAndMapData = (rawData)=>{
            let cleanData = [];
            if (rawData?.length > 0 && rawData !== undefined && rawData !== null) cleanData = rawData.map((datum)=>{
                //If the datum date is less than the startdate or greater than the endDate on the props and the count is 0, don't return it
                if ((compareDates(datum.date, startDateForApi) < 0 || compareDates(datum.date, endDateForApi) > 0) && datum.count === 0) return null;
                return datum;
            }).filter(Boolean);
            return (cleanData ?? []).map((d)=>({
                    x: dateForAxis(d.date),
                    y: d.count,
                    fullDate: d.date
                }));
        };
        const mappedDatasets = [];
        if (useCustomCategoriesAndTags) // Old implementation - single dataset with custom categories/tags
        mappedDatasets.push({
            id: "Volume",
            data: cleanAndMapData(data1),
            color: (0, _colors.ocean_blue)
        });
        else {
            // New implementation - multiple datasets based on viewConfig
            mappedDatasets.push({
                id: viewConfig.datasets[0]?.name || "Line 1",
                data: cleanAndMapData(data1),
                color: viewConfig.datasets[0]?.color || (0, _colors.ocean_blue)
            });
            if (viewConfig.datasets[1]) mappedDatasets.push({
                id: viewConfig.datasets[1].name,
                data: cleanAndMapData(data2),
                color: viewConfig.datasets[1].color
            });
            if (viewConfig.datasets[2] && data3) mappedDatasets.push({
                id: viewConfig.datasets[2].name,
                data: cleanAndMapData(data3),
                color: viewConfig.datasets[2].color
            });
        }
        return {
            title,
            subtitle,
            mappedDatasets
        };
    }, [
        data1,
        data2,
        data3,
        interval,
        sdSplit,
        edSplit,
        params.selectedView,
        viewConfig,
        startDateForApi,
        endDateForApi,
        useCustomCategoriesAndTags
    ]);
    // For backward compatibility, provide mappedData as the first dataset's data
    const mappedData = mappedDatasets[0]?.data || [];
    return {
        params,
        setParams,
        // (updater: (prev: HistogramParams) => HistogramParams) => void
        title,
        titleStyles: params.titleStyles,
        subtitle,
        mappedData,
        // Backward compatible - single line data
        mappedDatasets,
        // Multi-line data for new implementation
        selectedView: params.selectedView,
        setSelectedView: (view)=>setParams((prev)=>({
                    ...prev,
                    selectedView: view
                })),
        loading,
        error,
        scale: params.scale
    };
}
const HistogramContainer = (0, _unstatedNext.createContainer)(useHistogramContainer);
exports.default = HistogramContainer;

},{"react":"6uln9","unstated-next":"61zE5","../../hooks/useHistogram":"e9FmM","../../constants/analyticsConstants/generativeCallReview":"5Shd2","../../constants/colors":"1p3OR","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"e9FmM":[function(require,module,exports) {
// useHistogramData.ts
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useHistogramData", ()=>useHistogramData);
var _react = require("react");
var _conversationalSuccessHistogram = require("../api/controllers/conversationalSuccessHistogram");
function useHistogramData({ applicationId, applicationIds, startDate, endDate, categories, tags, interval }) {
    const [data, setData] = (0, _react.useState)(null);
    const [loading, setLoading] = (0, _react.useState)(true);
    const [error, setError] = (0, _react.useState)(null);
    const applicationIdsKey = (0, _react.useMemo)(()=>applicationIds?.join(",") ?? "", [
        applicationIds
    ]);
    const categoriesKey = (0, _react.useMemo)(()=>categories?.join(",") ?? "", [
        categories
    ]);
    const tagsKey = (0, _react.useMemo)(()=>tags?.join(",") ?? "", [
        tags
    ]);
    (0, _react.useEffect)(()=>{
        const fetchData = async ()=>{
            try {
                setLoading(true);
                // If multiple application IDs provided, fetch and aggregate
                if (applicationIds && applicationIds.length > 0) {
                    const promises = applicationIds.map((appId)=>(0, _conversationalSuccessHistogram.getConversationalSuccessHistogram)(appId, startDate, endDate, interval, categories, tags));
                    const results = await Promise.all(promises);
                    // Aggregate data from all apps
                    const aggregatedData = new Map();
                    results.forEach((result)=>{
                        if (result.data && Array.isArray(result.data)) result.data.forEach((datum)=>{
                            const key = datum.date || datum.key;
                            if (aggregatedData.has(key)) {
                                const existing = aggregatedData.get(key);
                                existing.count += datum.count || 0;
                            } else aggregatedData.set(key, {
                                date: datum.date,
                                count: datum.count || 0,
                                key: datum.key || datum.date
                            });
                        });
                    });
                    setData(Array.from(aggregatedData.values()).sort((a, b)=>new Date(a.date).getTime() - new Date(b.date).getTime()));
                } else if (applicationId) {
                    const result = await (0, _conversationalSuccessHistogram.getConversationalSuccessHistogram)(applicationId, startDate, endDate, interval, categories, tags);
                    setData(result.data);
                } else setData([]);
            } catch (err) {
                setError(err instanceof Error ? err : new Error("An error occurred"));
            } finally{
                setLoading(false);
            }
        };
        fetchData();
    }, [
        applicationId,
        applicationIdsKey,
        startDate,
        endDate,
        categoriesKey,
        tagsKey,
        interval
    ]);
    return {
        data,
        loading,
        error
    };
}

},{"react":"6uln9","../api/controllers/conversationalSuccessHistogram":"8blHt","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8blHt":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getConversationalSuccessHistogram", ()=>getConversationalSuccessHistogram);
var _urls = require("../../constants/Urls");
var _generic = require("./generic");
const getConversationalSuccessHistogram = (applicationId, startDate, endDate, interval, categories, tags)=>{
    let url = `/ApplicationAnalytics/conversationalSuccess/histogram/${applicationId}?interval=${interval}&startDate=${startDate}&endDate=${endDate}`;
    if (categories && categories.length > 0) categories.forEach((cat)=>url += `&categories=${cat}`);
    if (tags && tags.length > 0) tags.forEach((tag)=>url += `&tags=${tag}`);
    url += `&timezone=${Intl.DateTimeFormat().resolvedOptions().timeZone}`;
    return (0, _generic.sendGet)(url, (0, _urls.getAnalyticsApiUrl)());
};

},{"../../constants/Urls":"iTopY","./generic":"6oGDt","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"iw6lu":[function(require,module,exports) {
module.exports = require("fa36d2e4b5f8585").getBundleURL("kVLro") + require("16c3773f5ff34b56").resolve("fCjRa");

},{"fa36d2e4b5f8585":"c7Tr5","16c3773f5ff34b56":"fyJL2"}],"aBWWk":[function(require,module,exports) {
module.exports = require("6aa0b258692fef48").getBundleURL("kVLro") + require("7e8c6509b886d7cc").resolve("6TXCh");

},{"6aa0b258692fef48":"c7Tr5","7e8c6509b886d7cc":"fyJL2"}],"h79CP":[function(require,module,exports) {
module.exports = require("b3337f653300c508").getBundleURL("kVLro") + require("61738b0c731feb1f").resolve("6vPjM");

},{"b3337f653300c508":"c7Tr5","61738b0c731feb1f":"fyJL2"}],"koRig":[function(require,module,exports) {
module.exports = require("445e20ccd6f200ff").getBundleURL("kVLro") + require("761e1a721a5f6a88").resolve("5b284");

},{"445e20ccd6f200ff":"c7Tr5","761e1a721a5f6a88":"fyJL2"}],"41hFy":[function(require,module,exports) {
module.exports = require("2076f3d10a7add1e").getBundleURL("kVLro") + require("199db50fc3ab32a6").resolve("cmeJb");

},{"2076f3d10a7add1e":"c7Tr5","199db50fc3ab32a6":"fyJL2"}],"aB2zi":[function(require,module,exports) {
module.exports = require("f46129c4be278144").getBundleURL("kVLro") + require("13f0c5d35416262b").resolve("htUkz");

},{"f46129c4be278144":"c7Tr5","13f0c5d35416262b":"fyJL2"}],"ffr48":[function(require,module,exports) {
module.exports = require("2723942123fbb347").getBundleURL("kVLro") + require("ec583fa7c1499405").resolve("2BH3y");

},{"2723942123fbb347":"c7Tr5","ec583fa7c1499405":"fyJL2"}],"4FUwJ":[function(require,module,exports) {
module.exports = require("4ee00f52e2da3a8f").getBundleURL("kVLro") + require("358b3946b3d37675").resolve("e67lp");

},{"4ee00f52e2da3a8f":"c7Tr5","358b3946b3d37675":"fyJL2"}],"bI1PG":[function(require,module,exports) {
module.exports = require("1ac698d23b962746").getBundleURL("kVLro") + require("bcf1aa3748e3e913").resolve("36Yir");

},{"1ac698d23b962746":"c7Tr5","bcf1aa3748e3e913":"fyJL2"}],"i8yay":[function(require,module,exports) {
module.exports = require("a6223497cbc18f55").getBundleURL("kVLro") + require("c7f29e5d48c08a76").resolve("ecWIA");

},{"a6223497cbc18f55":"c7Tr5","c7f29e5d48c08a76":"fyJL2"}],"kMXMI":[function(require,module,exports) {
module.exports = require("7dc073c9e09c88eb").getBundleURL("kVLro") + require("e93bf47bc34b8203").resolve("7EHwI");

},{"7dc073c9e09c88eb":"c7Tr5","e93bf47bc34b8203":"fyJL2"}],"jZBVd":[function(require,module,exports) {
module.exports = require("73c445e30a983f32").getBundleURL("kVLro") + require("9a6b361bdf091a40").resolve("9pwVj");

},{"73c445e30a983f32":"c7Tr5","9a6b361bdf091a40":"fyJL2"}],"7ELyM":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _extends = require("@babel/runtime/helpers/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _unstated = require("unstated");
var _applicationOrderingExport = require("./ApplicationOrderingExport");
var _applicationOrderingExportDefault = parcelHelpers.interopDefault(_applicationOrderingExport);
var _applicationContainer = require("../../../state/containers/ApplicationContainer");
var _applicationContainerDefault = parcelHelpers.interopDefault(_applicationContainer);
const ApplicationOrderingExportWrapper = (props)=>(0, _react.jsx)((0, _unstated.Subscribe), {
        to: [
            (0, _applicationContainerDefault.default)
        ]
    }, (applicationContainer)=>{
        return (0, _react.jsx)((0, _applicationOrderingExportDefault.default), (0, _extendsDefault.default)({}, props, {
            applicationContainer: applicationContainer
        }));
    });
exports.default = ApplicationOrderingExportWrapper;

},{"@babel/runtime/helpers/extends":"4iKIP","@emotion/react":"djZKr","react":"6uln9","unstated":"grh7p","./ApplicationOrderingExport":"bDlBC","../../../state/containers/ApplicationContainer":"cuqi2","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"bDlBC":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _extends = require("@babel/runtime/helpers/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _applicationOrderingStatisticsForm = require("./ApplicationOrderingStatisticsForm");
var _applicationOrderingStatisticsFormDefault = parcelHelpers.interopDefault(_applicationOrderingStatisticsForm);
var _sessionAnalyticsContainerOld = require("../../../hooks/SessionAnalyticsContainerOld");
var _sessionAnalyticsContainerOldDefault = parcelHelpers.interopDefault(_sessionAnalyticsContainerOld);
const ApplicationOrderingExport = (props)=>{
    const [isLoadingApplicationOrderingStatistics, setIsLoadingApplicationOrderingStatistics] = (0, _react1.useState)(false);
    const sessionContainer = (0, _sessionAnalyticsContainerOldDefault.default).useContainer();
    const ORDER_INTENT_NAMES = [
        "NoSlotOrderIntent",
        "Order-Confirm",
        "Order-Enhanced",
        "Order-MenuItem",
        "SameMenuItem",
        "SplitMenuItem"
    ];
    const CORRECTION_INTENT_NAMES = [
        "OrderCorrectionSwap",
        "OrderCorrectionAdd",
        "OrderCorrectionAddAndRemove",
        "OrderCorrectionRemove"
    ];
    const ORDERING_INTENT_NAMES = ORDER_INTENT_NAMES.concat(CORRECTION_INTENT_NAMES);
    const TRANSFER_INTENT_NAMES = [
        "Transfer"
    ];
    const convertCallSummaryDataToCSVText = (rows)=>{
        if (!rows || rows?.length === 0) return "";
        const newLine = "\r\n";
        const columnSeparator = ",";
        const csvText = rows.map((row)=>row.join(columnSeparator)).join(newLine);
        return csvText;
    };
    const handleDownload = (fileName, contentDataInCSV)=>{
        const blob = new Blob([
            contentDataInCSV
        ], {
            type: "text/plain"
        });
        const url = URL.createObjectURL(blob);
        let link = document.createElement("a");
        link.setAttribute("href", url);
        link.setAttribute("download", `${fileName}.csv`);
        document.body.appendChild(link); // Required for FF
        link.click();
        link.remove();
    };
    const exportCallSummary = (callSummaryData)=>{
        const appName = props.applicationContainer.state.currentApp.name;
        let fileName = `${appName}_call_summary`;
        if (callSummaryData == null || callSummaryData?.length === 0) return;
        const valuesDataInCSV = convertCallSummaryDataToCSVText(callSummaryData);
        handleDownload(fileName, valuesDataInCSV);
    };
    const convertUtcToEst = (utcTimeString)=>{
        const utcTime = new Date(utcTimeString);
        const utcYear = utcTime.getUTCFullYear();
        const utcMonth = utcTime.getUTCMonth();
        const utcDay = utcTime.getUTCDate();
        const utcHours = utcTime.getUTCHours();
        const utcMinutes = utcTime.getUTCMinutes();
        const utcSeconds = utcTime.getUTCSeconds();
        const estTime = new Date(Date.UTC(utcYear, utcMonth, utcDay, utcHours, utcMinutes, utcSeconds));
        estTime.setHours(estTime.getHours() - 5);
        return estTime;
    };
    const areDatesWithin2Hours = (utcDate1String, utcDate2String)=>{
        const utcDate1 = new Date(utcDate1String);
        const utcDate2 = new Date(utcDate2String);
        if (isNaN(utcDate1.getTime()) || isNaN(utcDate2.getTime())) throw new Error("Invalid date format");
        const timeDifference = Math.abs(utcDate1.getTime() - utcDate2.getTime());
        const within2Hours = timeDifference <= 7200000;
        return within2Hours;
    };
    const populateOrderingStatistics = (sessions)=>{
        if (!sessions) return;
        const sortedSessions = [];
        Object.keys(sessions).forEach((sessionId)=>{
            const session = {
                events: [
                    ...sessions[sessionId]
                ],
                sessionId: sessionId,
                firstEventDate: null
            };
            const firstEvent = session.events[0];
            const firstEventDate = firstEvent.eventDate;
            const firstEventDateObject = new Date(firstEventDate);
            session.firstEventDate = firstEventDateObject;
            sortedSessions.push(session);
        });
        sortedSessions.sort((a, b)=>{
            const aDate = a.firstEventDate;
            const bDate = b.firstEventDate;
            return aDate - bDate;
        });
        const sessionsObject = {};
        sortedSessions.forEach((session)=>{
            sessionsObject[session.sessionId] = session.events;
        });
        const callSummaryData = [
            [
                "Date (UTC)",
                "Time (UTC)",
                "Date (EST)",
                "Time (EST)",
                "Caller Phone Number",
                "Attempt #",
                "Session Link",
                "Session ID",
                "Caller Action",
                "Order Attempted",
                "Transferred",
                "Order Placed",
                "Number of Turns",
                "Last Turn Item Count"
            ]
        ];
        Object.keys(sessionsObject).forEach((sessionId)=>{
            // each session is a line in the csv
            const session = [
                ...sessionsObject[sessionId]
            ];
            // adjust start date and end date by a day to account for time zone differences
            const dayBeforeStartDate = new Date(new Date(session[0].eventDate).getTime() - 86400000).toISOString().split("T")[0];
            const dayAfterEndDate = new Date(new Date(session[0].eventDate).getTime() + 86400000).toISOString().split("T")[0];
            const sessionLink = `https://app.voicify.com/v/apps/${props.applicationId}/analytics/sessions?sessionId=${sessionId}&startDate=${dayBeforeStartDate}&endDate=${dayAfterEndDate}`;
            const conversationTurnCount = session.length;
            const [UtcDate, utcUnformattedTime] = session[0].eventDate.split("T");
            const utcTimeFormatted = utcUnformattedTime.split(".")[0];
            const estTime = convertUtcToEst(session[0].eventDate);
            const estDate = estTime.toISOString().split("T")[0];
            const formattedEstTime = estTime.toISOString().split("T")[1].split(".")[0];
            const callerPhoneNumber = session[0]?.originalRequest?.sessionAttributes["callingNumber"];
            let orderPlaced = false;
            let callerAction = "";
            let transfer = false;
            let aIAnswering = false;
            let orderAttempted = "";
            Object.values(session).forEach((contentHit)=>{
                if (contentHit.originalRequest) {
                    if (contentHit.originalRequest.sessionFlags) {
                        const includesOrderPlacedFlag = contentHit.originalRequest.sessionFlags.includes("order-placed");
                        if (includesOrderPlacedFlag) orderPlaced = true;
                    }
                    const intentName = contentHit.originalRequest.nlp?.intent?.name;
                    if (intentName && callerAction === "") {
                        if (ORDERING_INTENT_NAMES.includes(intentName)) callerAction = "Order Attempt";
                        if (intentName.includes("Information-")) aIAnswering = true;
                    }
                    if (intentName && !transfer) {
                        if (TRANSFER_INTENT_NAMES.includes(intentName)) transfer = true;
                    }
                }
            });
            // get the last session content hit
            let lastTurnItemCount = 0;
            const lastContentHit = session[session.length - 1];
            const order = lastContentHit?.originalRequest?.sessionAttributes["order"];
            if (order) {
                const parsedOrder = JSON.parse(order);
                if (parsedOrder?.MenuItems?.length) for (const menuItem of parsedOrder.MenuItems)lastTurnItemCount += menuItem.Quantity ?? 1;
            }
            const incompleteItems = lastContentHit?.originalRequest?.sessionAttributes["orderIssues"];
            if (incompleteItems) {
                const parsedOrderIssues = JSON.parse(incompleteItems);
                if (parsedOrderIssues?.IncompleteMenuItems?.length) for (const incompleteMenuItem of parsedOrderIssues.IncompleteMenuItems)lastTurnItemCount += incompleteMenuItem.Quantity ?? 1;
            }
            if (callerAction === "") {
                if (transfer) callerAction = "Immediate Transfer";
                else if (aIAnswering) callerAction = "AI Answering Question";
                else callerAction = "Immediate Hangup / Dropped Call";
            }
            if (callerAction === "Order Attempt") orderAttempted = "Order Attempted";
            else orderAttempted = "Order Not Attempted";
            callSummaryData.push([
                UtcDate,
                utcTimeFormatted,
                estDate,
                formattedEstTime,
                callerPhoneNumber,
                "Only",
                sessionLink,
                sessionId,
                callerAction,
                orderAttempted,
                transfer ? "Transferred" : "Not Transferred",
                orderPlaced ? "Order Placed" : "Order Not Placed",
                conversationTurnCount.toString(),
                lastTurnItemCount
            ]);
        });
        let previousCallers = {};
        const identifyRepeatCallers = ()=>{
            const repeatCallIndexes = [];
            callSummaryData.forEach((row, index)=>{
                if (index === 0) return;
                const rowUtcDate = row[0];
                const rowUtcTime = row[1];
                const rowFormattedUtcTime = rowUtcTime.split(".")[0];
                const rowCallerPhoneNumber = row[4];
                if (previousCallers.hasOwnProperty(rowCallerPhoneNumber)) {
                    const within2Hours = areDatesWithin2Hours(previousCallers[rowCallerPhoneNumber][previousCallers[rowCallerPhoneNumber].length - 1], `${rowUtcDate}T${rowFormattedUtcTime}`);
                    if (within2Hours) {
                        previousCallers[rowCallerPhoneNumber] = [
                            ...previousCallers[rowCallerPhoneNumber],
                            `${rowUtcDate}T${rowFormattedUtcTime}`
                        ];
                        const callCount = previousCallers[rowCallerPhoneNumber].length;
                        if (callCount === 2) {
                            const repeatCallIndex = callSummaryData.findIndex((row)=>row[4] === rowCallerPhoneNumber);
                            callSummaryData[index][5] = "Repeat";
                            callSummaryData[repeatCallIndex][5] = "First";
                            // if the first call was an unsuccessful order attempt and the second call was a successful order attempt, update the first call to "Order Deferred"
                            if (callSummaryData[index][9] === "Order Attempted" && callSummaryData[index][11] === "Order Not Placed" && callSummaryData[repeatCallIndex][9] === "Order Attempted" && callSummaryData[repeatCallIndex][11] === "Order Placed") callSummaryData[repeatCallIndex][9] = "Order Deferred";
                        } else if (callCount > 2) {
                            //find the indexes of the repeat calls and push them into an array called repeatCallIndexes
                            callSummaryData.forEach((row, index)=>{
                                if (row[4] === rowCallerPhoneNumber) repeatCallIndexes.push(index);
                            });
                            callSummaryData[index][5] = "Repeat";
                            // if the first call was an unsuccessful order attempt and the last call was a successful order attempt, update all calls except for the last to "Order Deferred"
                            repeatCallIndexes.forEach((idx)=>{
                                if (idx !== repeatCallIndexes[repeatCallIndexes.length - 1]) {
                                    if (callSummaryData[idx][9] === "Order Attempted" && callSummaryData[idx][11] === "Order Not Placed" && callSummaryData[repeatCallIndexes[repeatCallIndexes.length - 1]][9] === "Order Attempted" && callSummaryData[repeatCallIndexes[repeatCallIndexes.length - 1]][11] === "Order Placed") callSummaryData[idx][9] = "Order Deferred";
                                }
                            });
                        }
                    } else previousCallers[rowCallerPhoneNumber] = [
                        `${rowUtcDate}T${rowFormattedUtcTime}`
                    ];
                } else previousCallers[rowCallerPhoneNumber] = [
                    `${rowUtcDate}T${rowFormattedUtcTime}`
                ];
            });
        };
        identifyRepeatCallers();
        exportCallSummary(callSummaryData);
    };
    const calculateFilteredSessions = (formValues)=>{
        let newFilteredSessions = {};
        for(const sessionId in sessionContainer.sessions){
            // check content item ids and phone numbers
            const sessionHits = sessionContainer.sessions[sessionId];
            if (sessionHits?.length) {
                const callingNumber = sessionHits[0]?.originalRequest?.sessionAttributes["callingNumber"];
                if (!callingNumber?.length) continue;
                else if (formValues.callerNumbersToIgnore.includes(callingNumber)) continue;
            }
            const calledNumbers = [
                sessionHits[0]?.originalRequest?.sessionAttributes["callednumber"],
                sessionHits[0]?.originalRequest?.sessionAttributes["calledNumber"]
            ];
            if (formValues.assistantNumbersToUse.some((c)=>calledNumbers.includes(c))) newFilteredSessions[sessionId] = sessionHits;
        }
        return newFilteredSessions;
    };
    const handleSubmitApplicationOrderingStatisticsForm = async (formValues)=>{
        setIsLoadingApplicationOrderingStatistics(true);
        // check to see if app preferences exist in local storage for the current app
        const localStorageOrderingStatisticsPreferences = JSON.parse(localStorage.getItem("orderingStatisticsPreferences"));
        const currentAppPreferencesIndex = localStorageOrderingStatisticsPreferences && localStorageOrderingStatisticsPreferences.findIndex((preference)=>preference.applicationId === props.applicationId);
        let newLocalStorageOrderingStatisticsPreferences = [];
        if (currentAppPreferencesIndex) {
            // app preferences found, update the existing preferences
            newLocalStorageOrderingStatisticsPreferences = [
                ...localStorageOrderingStatisticsPreferences
            ];
            newLocalStorageOrderingStatisticsPreferences[currentAppPreferencesIndex] = {
                "applicationId": props.applicationId,
                "callerNumbersToIgnore": formValues.callerNumbersToIgnore,
                "assistantNumbersToUse": formValues.assistantNumbersToUse
            };
        } else // app preferences not found, create new preferences
        newLocalStorageOrderingStatisticsPreferences[0] = {
            "applicationId": props.applicationId,
            "callerNumbersToIgnore": formValues.callerNumbersToIgnore,
            "assistantNumbersToUse": formValues.assistantNumbersToUse
        };
        localStorage.setItem("orderingStatisticsPreferences", JSON.stringify(newLocalStorageOrderingStatisticsPreferences));
        //recalculate the filtered sessions
        const newFilteredSessions = calculateFilteredSessions(formValues);
        populateOrderingStatistics(newFilteredSessions);
        setIsLoadingApplicationOrderingStatistics(false);
    };
    return (0, _react.jsx)((0, _applicationOrderingStatisticsFormDefault.default), (0, _extendsDefault.default)({}, props, {
        calculateFilteredSessions: calculateFilteredSessions,
        isLoadingApplicationOrderingStatistics: isLoadingApplicationOrderingStatistics,
        handleSubmitForm: handleSubmitApplicationOrderingStatisticsForm
    }));
};
exports.default = ApplicationOrderingExport;

},{"@babel/runtime/helpers/extends":"4iKIP","@emotion/react":"djZKr","react":"6uln9","./ApplicationOrderingStatisticsForm":"ccJH3","../../../hooks/SessionAnalyticsContainerOld":"3KBHi","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"ccJH3":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _yup = require("yup");
var _formik = require("formik");
var _applicationOrderingStatistics = require("./ApplicationOrderingStatistics");
var _applicationOrderingStatisticsDefault = parcelHelpers.interopDefault(_applicationOrderingStatistics);
const ApplicationOrderingStatisticsForm = (0, _formik.withFormik)({
    mapPropsToValues: (props)=>({
            callerNumbersToIgnore: [
                ""
            ],
            assistantNumbersToUse: [
                ""
            ]
        }),
    validationSchema: _yup.object().shape({}),
    handleSubmit: async (values, { props, setSubmitting })=>{
        setSubmitting(true);
        props.handleSubmitForm(values);
        setSubmitting(false);
    }
})((0, _applicationOrderingStatisticsDefault.default));
exports.default = ApplicationOrderingStatisticsForm;

},{"yup":"j2SJU","formik":"3YnOK","./ApplicationOrderingStatistics":"b5yJ2","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"b5yJ2":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _base = require("@emotion/styled/base");
var _baseDefault = parcelHelpers.interopDefault(_base);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _sessionAnalyticsContainerOld = require("../../../hooks/SessionAnalyticsContainerOld");
var _sessionAnalyticsContainerOldDefault = parcelHelpers.interopDefault(_sessionAnalyticsContainerOld);
var _loader = require("../../../components/general/Loader");
var _loaderDefault = parcelHelpers.interopDefault(_loader);
var _simulatorContainer = require("../../../hooks/SimulatorContainer");
var _simulatorContainerDefault = parcelHelpers.interopDefault(_simulatorContainer);
var _textField = require("../../../components/forms/TextField");
var _textFieldDefault = parcelHelpers.interopDefault(_textField);
var _formik = require("formik");
var _css = require("@emotion/css");
var _button = require("../../../components/general/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _colors = require("../../../constants/colors");
var _horizontalSeparator = require("../../../components/structure/HorizontalSeparator");
var _horizontalSeparatorDefault = parcelHelpers.interopDefault(_horizontalSeparator);
var _iconTooltip = require("../../../components/general/IconTooltip");
var _iconTooltipDefault = parcelHelpers.interopDefault(_iconTooltip);
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const deleteIcon = require("a6b4778caa99ba37");
const csvIcon = require("fc5f398a17d5af05");
const ApplicationOrderingStatistics = (props)=>{
    const [sessionsLoaded, setSessionsLoaded] = (0, _react1.useState)(false);
    const [startDate, setStartDate] = (0, _react1.useState)("");
    const [endDate, setEndDate] = (0, _react1.useState)("");
    const simulatorContainer = (0, _simulatorContainerDefault.default).useContainer();
    const sessionContainer = (0, _sessionAnalyticsContainerOldDefault.default).useContainer();
    (0, _react1.useEffect)(()=>{
        simulatorContainer.startNewSession();
        loadMore();
        getLocalStoragePhoneNumersToIgnoreAndUse();
    }, []);
    (0, _react1.useEffect)(()=>{
        if (!sessionsLoaded) return;
        props.calculateFilteredSessions(props.values);
    }, [
        sessionContainer.sessions
    ]);
    (0, _react1.useEffect)(()=>{
        if (startDate === "" && props.filter.startDate) {
            setStartDate(props.filter?.startDate);
            setEndDate(props.filter?.endDate);
            return;
        }
        if (props.filter?.startDate !== startDate || props.filter?.endDate !== endDate) {
            setStartDate(props.filter?.startDate);
            setEndDate(props.filter?.endDate);
            setSessionsLoaded(false);
            simulatorContainer.startNewSession();
            sessionContainer.loadMoreContentHits(props.applicationId, props.filter);
        }
    }, [
        props.filter
    ]);
    (0, _react1.useEffect)(()=>{
        if (sessionContainer.moreToLoad) loadMore();
        else setSessionsLoaded(true);
    }, [
        sessionContainer.sessions,
        sessionContainer.moreToLoad
    ]);
    const loadMore = async ()=>{
        await sessionContainer.loadMoreContentHits(props.applicationId, props.filter);
    };
    const getLocalStoragePhoneNumersToIgnoreAndUse = ()=>{
        const phoneNumbersInLocalStorage = JSON.parse(localStorage.getItem("orderingStatisticsPreferences"));
        let ignoredCallerNumbers = [
            ""
        ];
        let assistantNumbers = [
            ""
        ];
        if (phoneNumbersInLocalStorage) {
            const currentAppLocalStoragePreferences = phoneNumbersInLocalStorage.find((p)=>p.applicationId === props.applicationId);
            if (currentAppLocalStoragePreferences) {
                if (currentAppLocalStoragePreferences.callerNumbersToIgnore) ignoredCallerNumbers = currentAppLocalStoragePreferences.callerNumbersToIgnore;
                if (currentAppLocalStoragePreferences.assistantNumbersToUse) assistantNumbers = currentAppLocalStoragePreferences.assistantNumbersToUse;
            }
        }
        props.setFieldValue("callerNumbersToIgnore", ignoredCallerNumbers);
        props.setFieldValue("assistantNumbersToUse", assistantNumbers);
    };
    const handleChange = (e, fieldName)=>{
        return props.setFieldValue(fieldName, e.target.value);
    };
    if (props.isLoadingApplicationOrderingStatistics) return (0, _react.jsx)((0, _loaderDefault.default), null);
    return (0, _react.jsx)("form", {
        onSubmit: props.handleSubmit
    }, (0, _react.jsx)(Title, null, "AI Ordering Summary Report Filter"), (0, _react.jsx)(SectionWrapper, null, (0, _react.jsx)((0, _buttonDefault.default), {
        disabled: !sessionsLoaded,
        loading: !sessionsLoaded,
        type: "submit",
        themes: [
            "secondary-small",
            "end-tight"
        ],
        rightIcon: csvIcon,
        text: "Download"
    }), (0, _react.jsx)(FormFieldsWrapper, null, (0, _react.jsx)((0, _formik.FieldArray), {
        validateOnChange: false,
        name: "assistantNumbersToUse",
        render: (arrayHelpers)=>(0, _react.jsx)(FieldWrapper, null, (0, _react.jsx)(TextFieldWrapper, null, (0, _react.jsx)(SubtitleWrapper, null, (0, _react.jsx)(Subtitle, null, "Assistant Numbers to Use"), (0, _react.jsx)((0, _iconTooltipDefault.default), {
                place: "right",
                text: " Go to Settings > Deployment > Telephony to get your assistant's number.",
                className: iconTooltipStyle
            })), (0, _react.jsx)(CustomHorizonalSeparator, null), props.values.assistantNumbersToUse.map((phoneNumber, index)=>{
                return (0, _react.jsx)(TextFieldWithDeleteWrapper, {
                    key: `assistantNumbersToUse.${index}`
                }, (0, _react.jsx)((0, _textFieldDefault.default), {
                    name: `assistantNumbersToUse.${index}`,
                    disabled: false,
                    value: phoneNumber,
                    label: "Assistant Phone Number",
                    placeholder: "Type an assistant number to use here",
                    onChange: (e)=>handleChange(e, `assistantNumbersToUse.${index}`),
                    onBlur: props.handleBlur,
                    fieldContainerStyle: fieldContainerStyle,
                    className: textFieldContainerStyle
                }), (0, _react.jsx)(DeleteIcon, {
                    src: deleteIcon,
                    onClick: ()=>arrayHelpers.remove(index)
                }));
            }), (0, _react.jsx)(ButtonWrapper, null, (0, _react.jsx)((0, _buttonDefault.default), {
                themes: [
                    "flat"
                ],
                text: "+ Add Phone Number",
                type: "button",
                className: addPhoneNumber,
                onClick: ()=>{
                    arrayHelpers.push("");
                }
            }))))
    }), (0, _react.jsx)((0, _formik.FieldArray), {
        validateOnChange: false,
        name: "callerNumbersToIgnore",
        render: (arrayHelpers)=>(0, _react.jsx)(FieldWrapper, null, (0, _react.jsx)(TextFieldWrapper, null, (0, _react.jsx)(SubtitleWrapper, null, (0, _react.jsx)(Subtitle, null, "Caller Numbers to Ignore"), (0, _react.jsx)((0, _iconTooltipDefault.default), {
                place: "right",
                text: "i.e. Phone numbers used to test the assistant.",
                className: iconTooltipStyle
            })), (0, _react.jsx)(CustomHorizonalSeparator, null), props.values.callerNumbersToIgnore.map((phoneNumber, index)=>{
                return (0, _react.jsx)(TextFieldWithDeleteWrapper, {
                    key: `callerNumbersToIgnore.${index}`
                }, (0, _react.jsx)((0, _textFieldDefault.default), {
                    name: `callerNumbersToIgnore.${index}`,
                    disabled: false,
                    value: phoneNumber,
                    label: "Caller Phone Number",
                    placeholder: "Type a caller number to ignore here",
                    onChange: (e)=>handleChange(e, `callerNumbersToIgnore.${index}`),
                    onBlur: props.handleBlur,
                    fieldContainerStyle: fieldContainerStyle,
                    className: textFieldContainerStyle
                }), (0, _react.jsx)(DeleteIcon, {
                    src: deleteIcon,
                    onClick: ()=>arrayHelpers.remove(index)
                }));
            }), (0, _react.jsx)(ButtonWrapper, null, (0, _react.jsx)((0, _buttonDefault.default), {
                themes: [
                    "flat"
                ],
                text: "+ Add Phone Number",
                type: "button",
                className: addPhoneNumber,
                onClick: ()=>{
                    arrayHelpers.push("");
                }
            }))))
    }))));
};
const iconTooltipStyle = /*#__PURE__*/ (0, _css.css)({
    name: "15dzmna",
    styles: "margin-left:8px;margin-bottom:16px"
});
const SubtitleWrapper = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e15hjgwp10"
})({
    name: "fhxb3m",
    styles: "display:flex;flex-direction:row;align-items:center"
});
const CustomHorizonalSeparator = /*#__PURE__*/ (0, _baseDefault.default)((0, _horizontalSeparatorDefault.default), {
    target: "e15hjgwp9"
})({
    name: "fly8kv",
    styles: "flex-grow:initial"
});
const textFieldContainerStyle = /*#__PURE__*/ (0, _css.css)({
    name: "1ykowef",
    styles: "margin-bottom:0"
});
const addPhoneNumber = /*#__PURE__*/ (0, _css.css)("color:", (0, _colors.text_blue), " font-size:14px;box-shadow:none;margin:inherit;padding:inherit;", "");
const ButtonWrapper = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e15hjgwp8"
})({
    name: "1bn3vae",
    styles: "display:flex;justify-content:flex-end;margin-right:32px"
});
const TextFieldWithDeleteWrapper = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e15hjgwp7"
})({
    name: "4da87x",
    styles: "display:flex;flex-direction:row;align-items:center;margin-top:16px"
});
const SectionWrapper = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e15hjgwp6"
})({
    name: "1qnw08d",
    styles: "display:flex;flex-direction:column;border:1px solid #CBCCD2;box-sizing:border-box;border-radius:8px;padding:0 16px 32px 32px;background:white;margin:16px 32px 96px 32px;box-shadow:0px 2px 4px rgba(50, 70, 97, 0.1)"
});
const FormFieldsWrapper = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e15hjgwp5"
})({
    name: "ho1qnd",
    styles: "display:flex;flex-direction:row"
});
const Subtitle = /*#__PURE__*/ (0, _baseDefault.default)("h3", {
    target: "e15hjgwp4"
})({
    name: "18uqayh",
    styles: "margin-bottom:16px"
});
const Title = /*#__PURE__*/ (0, _baseDefault.default)("h2", {
    target: "e15hjgwp3"
})({
    name: "hhyoc3",
    styles: "margin-left:32px"
});
const TextFieldWrapper = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e15hjgwp2"
})({
    name: "1l29w7u",
    styles: "display:flex;flex:1;flex-direction:column;justify-content:left"
});
const FieldWrapper = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e15hjgwp1"
})({
    name: "1j0er5d",
    styles: "display:flex;flex:1;padding:0 32px"
});
const DeleteIcon = /*#__PURE__*/ (0, _baseDefault.default)("img", {
    target: "e15hjgwp0"
})({
    name: "42codv",
    styles: "cursor:pointer;margin:32px 12px 12px 12px"
});
const fieldContainerStyle = /*#__PURE__*/ (0, _css.css)({
    name: "128tros",
    styles: "height:48px"
});
exports.default = ApplicationOrderingStatistics;

},{"@emotion/styled/base":"lSuFu","@emotion/react":"djZKr","react":"6uln9","../../../hooks/SessionAnalyticsContainerOld":"3KBHi","../../../components/general/Loader":"bnV5T","../../../hooks/SimulatorContainer":"gOZ3V","../../../components/forms/TextField":"7a7bh","formik":"3YnOK","@emotion/css":"awUBr","../../../components/general/Button":"6ymxN","../../../constants/colors":"1p3OR","../../../components/structure/HorizontalSeparator":"Pw3HQ","../../../components/general/IconTooltip":"3FODC","a6b4778caa99ba37":"k8RZz","fc5f398a17d5af05":"c0FTd","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"gOZ3V":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _unstatedNext = require("unstated-next");
var _api = require("../api");
var _guids = require("../services/guids");
var _guidsDefault = parcelHelpers.interopDefault(_guids);
var _extensions = require("../models/extensions");
const TurnHistoryKey = "ConversationTurnHistoryState";
const CamelTurnHistoryKey = "conversationTurnHistoryState";
function useSimulatorContainer() {
    const [selectedLanguage, setSelectedLanguage] = (0, _react.useState)(null);
    const [requests, setRequests] = (0, _react.useState)([]);
    const [responses, setResponses] = (0, _react.useState)([]);
    const [fullResponses, setFullResponses] = (0, _react.useState)([]);
    const [contentItemsFromHistory, setContentItemsFromHistory] = (0, _react.useState)([]);
    const [sessionId, setSessionId] = (0, _react.useState)((0, _guidsDefault.default)());
    const [sessionAttributes, setSessionAttributes] = (0, _react.useState)({});
    const [isWaitingForResponse, setIsWaitingForResponse] = (0, _react.useState)(false);
    const [errors, setErrors] = (0, _react.useState)([]);
    const [deviceTarget, setDeviceTarget] = (0, _react.useState)(null);
    const [useDraftContent, setUseDraftContent] = (0, _react.useState)(false);
    const [contentItemCache, setContentItemCache] = (0, _react.useState)([]);
    const [inputText, setInputText] = (0, _react.useState)("");
    const [testCase, setTestCase] = (0, _react.useState)(null);
    const buildIntentRequest = (requestName, text, sessionId, locale, userId, requiresLanguageUnderstanding)=>{
        const intentRequest = {
            requestId: (0, _guidsDefault.default)(),
            user: {
                id: userId
            },
            device: getTestDevice(),
            context: {
                sessionId: sessionId,
                requestName: requestName,
                requestType: "IntentRequest",
                requiresLanguageUnderstanding: requiresLanguageUnderstanding,
                originalInput: text,
                noTracking: true,
                locale: locale,
                channel: "Voicify Simulator"
            }
        };
        if (testCase) {
            testCase.assertions = [];
            if (testCase.sessionState.sessionAttributes["conversationTurnHistoryState"]) {
                testCase.sessionState.sessionAttributes["ConversationTurnHistoryState"] = testCase.sessionState.sessionAttributes["conversationTurnHistoryState"];
                delete testCase.sessionState.sessionAttributes["conversationTurnHistoryState"];
            }
            intentRequest.testCase = testCase;
            setTestCase(null);
        }
        return intentRequest;
    };
    const buildLaunchRequest = (text, userId, sessionId, language)=>{
        return buildIntentRequest("VoicifyWelcome", text, sessionId, language.shortCode, userId, false);
    };
    const buildStandardRequest = (text, userId, sessionId, language)=>{
        return buildIntentRequest(null, text, sessionId, language.shortCode, userId, true);
    };
    const buildFallbackRequest = (userId, text, sessionId, language)=>{
        return buildIntentRequest("VoicifyFallback", text, sessionId, language.shortCode, userId, false);
    };
    const updateConversationHistory = async (session, responsesArg, contentContainers, request, lastItemOverride = null)=>{
        try {
            let turnHistory = null;
            let lastItem = null;
            if (lastItemOverride) lastItem = lastItemOverride;
            else if (session.sessionAttributes) {
                if (session.sessionAttributes[TurnHistoryKey]) {
                    turnHistory = session.sessionAttributes[TurnHistoryKey];
                    lastItem = turnHistory.TurnHistory[turnHistory.TurnHistory.length - 1];
                } else if (session.sessionAttributes[CamelTurnHistoryKey]) {
                    turnHistory = session.sessionAttributes[CamelTurnHistoryKey];
                    lastItem = turnHistory.TurnHistory[turnHistory.TurnHistory.length - 1];
                }
            }
            if (!session.sessionAttributes && contentItemsFromHistory?.length) // try to get old session
            session = {
                id: "",
                sessionAttributes: contentItemsFromHistory[contentItemsFromHistory.length - 1]?.sessionAttributes
            };
            // get id if its an environment id
            let contentId = lastItem?.ContentId;
            if (contentId?.length && contentId.length > 40) contentId = contentId.substring(0, 36);
            let contentItem = {
                title: "Unavailable",
                applicationFeatureId: "",
                applicationId: "",
                id: "",
                hasBeenDeleted: true,
                isDraft: useDraftContent
            };
            if (contentId && !contentItemCache.find((c)=>c.id == lastItem.ContentId)) {
                const result = await contentContainers[lastItem.FeatureTypeId].findFullById(contentId);
                if (result.resultType == "Ok") {
                    contentItem = result.data;
                    contentItem = {
                        ...contentItem,
                        id: lastItem.ContentId,
                        // remapping content id in case we're in an environment
                        contentId: contentId,
                        hasBeenDeleted: false,
                        isDraft: useDraftContent,
                        interactionType: (0, _extensions.getDefaultFeatureTypeName)(lastItem.FeatureTypeId),
                        sessionAttributes: session.sessionAttributes,
                        response: responsesArg[responsesArg.length - 1],
                        request: request
                    };
                } else contentItem = {
                    title: "Unavailable",
                    applicationFeatureId: "",
                    applicationId: "",
                    id: lastItem.ContentId,
                    contentId: contentId,
                    hasBeenDeleted: true,
                    isDraft: useDraftContent,
                    sessionAttributes: session?.sessionAttributes,
                    response: responsesArg[responsesArg.length - 1],
                    request: request
                };
            } else if (contentId && contentItemCache.find((c)=>c.id == lastItem.ContentId)) {
                const lastContentItem = contentItemCache.find((c)=>c.id == lastItem.ContentId);
                contentItem = {
                    ...lastContentItem,
                    id: lastItem.ContentId,
                    // remapping content id in case we're in an environment
                    contentId: contentId,
                    hasBeenDeleted: false,
                    isDraft: useDraftContent,
                    interactionType: (0, _extensions.getDefaultFeatureTypeName)(lastItem.FeatureTypeId),
                    sessionAttributes: session.sessionAttributes,
                    response: responsesArg[responsesArg.length - 1],
                    request: request
                };
            } else contentItem = {
                title: "Default fallback message",
                applicationFeatureId: "",
                applicationId: "",
                id: null,
                contentId: null,
                hasBeenDeleted: true,
                isDraft: useDraftContent,
                sessionAttributes: session?.sessionAttributes,
                response: responsesArg[responsesArg.length - 1],
                request: request
            };
            setSessionAttributes(session?.sessionAttributes ?? {});
            setResponses(responsesArg);
            setContentItemsFromHistory([
                ...contentItemsFromHistory,
                contentItem
            ]);
            const newCache = [
                ...contentItemCache,
                ...contentItemsFromHistory,
                contentItem
            ];
            setContentItemCache(newCache.filter((item, index)=>newCache.findIndex((i)=>i.contentId === item.contentId) === index));
            setIsWaitingForResponse(false);
        } catch (err) {
            setErrors([
                err
            ]);
            setIsWaitingForResponse(false);
        }
    };
    const runTestCase = async (application, testCase, userId)=>{
        try {
            const newSessionId = (0, _guidsDefault.default)();
            const newRequests = [];
            const newResponses = [];
            const newContentItems = [];
            // first we need to update the conversation history per the conversation session state in session attributes. 
            var turnHistoryState = testCase.sessionState.sessionAttributes["conversationTurnHistoryState"];
            for (const turn of turnHistoryState.TurnHistory){
                newRequests.push({
                    text: turn.UserInput
                });
                newResponses.push({
                    responseId: (0, _guidsDefault.default)(),
                    ssml: turn.AssistantResponse,
                    outputSpeech: turn.AssistantResponse,
                    displayText: turn.AssistantResponse,
                    displayTitle: turn.AssistantResponse,
                    endSession: false
                });
            }
            setSessionId(newSessionId);
            setRequests(newRequests);
            setResponses(newResponses);
            setContentItemsFromHistory(newContentItems);
            setTestCase(testCase);
            setInputText(testCase.text);
            setFullResponses([]);
        } catch (error) {
            setErrors([
                error
            ]);
            setIsWaitingForResponse(false);
        }
    };
    const createTestCaseFromHistory = (userId)=>{
        if (fullResponses.length > 1) {
            const secondToLastResponse = fullResponses[fullResponses.length - 2];
            const lastResponse = fullResponses[fullResponses.length - 1];
            const testCase = {};
            testCase.text = lastResponse?.nlp?.utterance;
            testCase.sessionState = {
                sessionAttributes: secondToLastResponse.sessionAttributes,
                sessionFlags: secondToLastResponse.sessionFlags,
                id: sessionId
            };
            testCase.userProfile = {
                userId: userId,
                userAttributes: secondToLastResponse.userAttributes,
                userFlags: secondToLastResponse.userFlags
            };
            testCase.name = `New Test Case`;
            if (testCase.sessionState.sessionAttributes["conversationTurnHistoryState"]) {
                testCase.sessionState.sessionAttributes["ConversationTurnHistoryState"] = testCase.sessionState.sessionAttributes["conversationTurnHistoryState"];
                delete testCase.sessionState.sessionAttributes["conversationTurnHistoryState"];
            }
            return testCase;
        }
        return null;
    };
    const sendAndHandleCustomAssistantRequest = async (applicationId, applicationSecret, sessionId, request, contentContainers)=>{
        try {
            const result = await _api.sendCustomAssistantRequest(applicationId, applicationSecret, request, useDraftContent, true, true, true);
            if (result.resultType == "Ok") {
                setFullResponses([
                    ...fullResponses,
                    result.data
                ]);
                const newResponses = [
                    ...responses,
                    result.data
                ];
                await updateConversationHistory({
                    id: sessionId,
                    sessionAttributes: result.data.sessionAttributes
                }, newResponses, contentContainers, request);
            } else {
                setErrors(result.errors);
                setIsWaitingForResponse(false);
            }
        } catch (error) {
            setErrors([
                error
            ]);
            setIsWaitingForResponse(false);
        }
    };
    const getTestDevice = ()=>{
        return {
            id: "voicify-simulator",
            name: "Voicify Simulator",
            supportsAudio: true,
            supportsBackgroundImage: true,
            supportsDisplayText: true,
            supportsForegroundImage: true,
            supportsSsml: true,
            supportsTextInput: true,
            supportsVideo: true,
            supportsVoiceInput: true
        };
    };
    const startNewSession = ()=>{
        setRequests([]);
        setResponses([]);
        setContentItemsFromHistory([]);
        setFullResponses([]);
        setSessionId((0, _guidsDefault.default)());
    };
    const addMessage = (text)=>{
        setIsWaitingForResponse(true);
        setRequests([
            ...requests,
            {
                text
            }
        ]);
    };
    const handleDeviceSelected = (deviceTarget)=>{
        startNewSession();
        setDeviceTarget(deviceTarget);
    };
    const handleLanguageSelected = async (language)=>{
        await setSelectedLanguage(language);
        startNewSession();
    };
    const setEnvironment = (env)=>{
        startNewSession();
        setUseDraftContent(env == "draft");
    };
    const getConversationHistory = ()=>{
        return sessionAttributes[TurnHistoryKey] ?? sessionAttributes[CamelTurnHistoryKey] ?? {};
    };
    const sendCustomAssistantRequest = async (application, text, userId, sessionId, language, contentContainers)=>{
        const cleanedText = text.trim().toLowerCase();
        const cleanedInvocationPhrase = application.invocationPhrase.trim().toLowerCase();
        let request;
        if (cleanedText == `open ${cleanedInvocationPhrase}` || cleanedText == `talk to ${cleanedInvocationPhrase}`) request = buildLaunchRequest(text, userId, sessionId, language);
        else if (cleanedText == "[unhandled response]") request = buildFallbackRequest(userId, text, sessionId, language);
        else request = buildStandardRequest(text, userId, sessionId, language);
        await sendAndHandleCustomAssistantRequest(application.id, application.secret, sessionId, request, contentContainers);
    };
    const clearErrors = ()=>{
        setErrors([]);
    };
    return {
        selectedLanguage,
        sessionId,
        requests,
        responses,
        contentItemsFromHistory,
        sessionAttributes,
        isWaitingForResponse,
        errors,
        deviceTarget,
        useDraftContent,
        inputText,
        fullResponses,
        startNewSession,
        addMessage,
        handleDeviceSelected,
        handleLanguageSelected,
        setEnvironment,
        getConversationHistory,
        sendCustomAssistantRequest,
        clearErrors,
        updateConversationHistory,
        runTestCase,
        setInputText,
        createTestCaseFromHistory
    };
}
const SimulatorContainer = (0, _unstatedNext.createContainer)(useSimulatorContainer);
exports.default = SimulatorContainer;

},{"react":"6uln9","unstated-next":"61zE5","../api":"loxM6","../services/guids":"jvaYQ","../models/extensions":"7h01B","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"k8RZz":[function(require,module,exports) {
module.exports = require("b99939ac737deda1").getBundleURL("kVLro") + require("17149401fa821fa8").resolve("dqMC4");

},{"b99939ac737deda1":"c7Tr5","17149401fa821fa8":"fyJL2"}],"c0FTd":[function(require,module,exports) {
module.exports = require("805c8815dd8da885").getBundleURL("kVLro") + require("f810c86349c40289").resolve("2I5cX");

},{"805c8815dd8da885":"c7Tr5","f810c86349c40289":"fyJL2"}],"58rtH":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _base = require("@emotion/styled/base");
var _baseDefault = parcelHelpers.interopDefault(_base);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _telephonyAnalyticsContainer = require("../../../hooks/TelephonyAnalyticsContainer");
var _telephonyAnalyticsContainerDefault = parcelHelpers.interopDefault(_telephonyAnalyticsContainer);
var _totalCard = require("../../../components/charts/TotalCard");
var _totalCardDefault = parcelHelpers.interopDefault(_totalCard);
var _loader = require("../../../components/general/Loader");
var _loaderDefault = parcelHelpers.interopDefault(_loader);
var _pageError = require("../../../components/general/PageError");
var _pageErrorDefault = parcelHelpers.interopDefault(_pageError);
var _modalLayout = require("../../../components/structure/ModalLayout");
var _modalLayoutDefault = parcelHelpers.interopDefault(_modalLayout);
var _modalHeader = require("../../../components/general/ModalHeader");
var _modalHeaderDefault = parcelHelpers.interopDefault(_modalHeader);
var _sessionReview = require("./SessionReview");
var _sessionReviewDefault = parcelHelpers.interopDefault(_sessionReview);
var _moment = require("moment");
var _momentDefault = parcelHelpers.interopDefault(_moment);
var _analyticsDateFormat = require("../../../models/analytics/AnalyticsDateFormat");
var _useWindowSize = require("../../../hooks/UseWindowSize");
var _useWindowSizeDefault = parcelHelpers.interopDefault(_useWindowSize);
var _codeOutputModal = require("../../simulator/components/CodeOutputModal");
var _codeOutputModalDefault = parcelHelpers.interopDefault(_codeOutputModal);
var _button = require("../../../components/general/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _reactRouterDom = require("react-router-dom");
var _footerBar = require("../../../components/structure/FooterBar");
var _footerBarDefault = parcelHelpers.interopDefault(_footerBar);
var _colors = require("../../../constants/colors");
var _collapsingPanel = require("../../../components/structure/Panels/CollapsingPanel");
var _collapsingPanelDefault = parcelHelpers.interopDefault(_collapsingPanel);
var _urls = require("../../../constants/Urls");
var _css = require("@emotion/css");
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const conversationalSuccessIcon = require("9f1637e346d65024");
const orderPlacedIcon = require("a302be94e0371827");
const ApplicationOrderingAnalyticsReport = (props)=>{
    const [eventsToReview, setEventsToReview] = (0, _react1.useState)([]);
    const [sessionIdToReview, setSessionIdToReview] = (0, _react1.useState)("");
    const [eventsToReviewInCode, setEventsToReviewInCode] = (0, _react1.useState)([]);
    const [expandFailedOrders, setExpandFailedOrders] = (0, _react1.useState)(true);
    const [expandNoOrders, setExpandNoOrders] = (0, _react1.useState)(false);
    const [expandPlacedOrders, setExpandPlacedOrder] = (0, _react1.useState)(false);
    const [expandOrderTransfers, setExpandOrderTransfers] = (0, _react1.useState)(false);
    const [copyButtonText, setCopyButtonText] = (0, _react1.useState)("Copy Session");
    const orderingContainer = (0, _telephonyAnalyticsContainerDefault.default).useContainer();
    const windowSize = (0, _useWindowSizeDefault.default)();
    (0, _react1.useEffect)(()=>{
        orderingContainer.loadOrderingAnalytics(props.applicationId, props.filter);
    }, [
        props.filter,
        props.applicationId
    ]);
    const convertEventsForCodeOutputModal = (events)=>{
        var returnObj = {};
        events?.forEach((e, idx)=>{
            returnObj[`${idx}-${e.eventType}`] = e;
        });
        // get last event that is request received
        const lastContentHit = events?.slice()?.reverse()?.find((e)=>e.eventType === "ContentHit");
        if (lastContentHit?.originalRequest?.sessionAttributes) returnObj[`${events.length}-LatestSessionAttributes`] = lastContentHit.originalRequest.sessionAttributes;
        return returnObj;
    };
    (0, _react1.useEffect)(()=>{
        let load = false;
        if (sessionIdToReview?.length) {
            if (eventsToReview?.length) {
                if (eventsToReview.some((e)=>e?.sessionId === sessionIdToReview)) load = false;
                else load = true;
            } else load = true;
        }
        if (load) {
            if (sessionIdToReview in orderingContainer.allEventsCache) setEventsToReview(orderingContainer.allEventsCache[sessionIdToReview]);
            else orderingContainer.loadAllEventsForSession(sessionIdToReview, props.applicationId);
        }
    }, [
        sessionIdToReview,
        eventsToReview,
        orderingContainer.allEventsCache
    ]);
    const CodeReviewModal = ()=>{
        return (0, _react.jsx)((0, _codeOutputModalDefault.default), {
            title: "JSON",
            closeModal: ()=>setEventsToReviewInCode(null),
            data: convertEventsForCodeOutputModal(eventsToReviewInCode),
            showCodeOutputModal: eventsToReviewInCode?.length > 0
        });
    };
    const clearSessionToReview = ()=>{
        setEventsToReview([]);
        setSessionIdToReview("");
    };
    const formatPercentage = (value)=>{
        if (value < 0) return "No orders";
        return `${(value * 100).toFixed(2)} %`;
    };
    const handleCopyButtonClick = (url)=>{
        navigator.clipboard.writeText(url);
        setCopyButtonText("Copied!");
    };
    const resetCopyButtonText = ()=>{
        setCopyButtonText("Copy Session");
    };
    const getStartandEndDate = (sessionId)=>{
        const session = orderingContainer.sessions?.find((s)=>s.sessionId === sessionId);
        if (session) {
            const weekBeforeStartDate = new Date(new Date(session?.startDate).getTime() - 604800000).toISOString().split("T")[0];
            const dayAfterStartDate = new Date(new Date(session?.startDate).getTime() + 86400000).toISOString().split("T")[0];
            return `&startDate=${weekBeforeStartDate}&endDate=${dayAfterStartDate}`;
        }
    };
    const CustomSessionReview = ()=>{
        if (!eventsToReview?.length || eventsToReviewInCode?.length) return (0, _react.jsx)((0, _reactDefault.default).Fragment, null);
        const e = eventsToReview?.length && eventsToReview[0] ? eventsToReview[0] : null;
        return (0, _react.jsx)("div", {
            onClick: (e)=>{
                e.stopPropagation();
            }
        }, (0, _react.jsx)((0, _modalLayoutDefault.default), {
            isVisible: true
        }, (0, _react.jsx)((0, _modalHeaderDefault.default), {
            title: (0, _momentDefault.default)(e?.eventDate).format((0, _analyticsDateFormat.SESSION_DATE_FORMAT)),
            onClose: ()=>{
                clearSessionToReview();
                resetCopyButtonText();
            }
        }), (0, _react.jsx)((0, _sessionReviewDefault.default), {
            inModal: true,
            manualHeight: windowSize.windowSize.innerHeight * .9 - 168,
            events: eventsToReview ?? [],
            applicationId: props.applicationId,
            setEventsToShow: setEventsToReviewInCode,
            resetCopyButtonText: resetCopyButtonText,
            sessionId: e?.sessionId,
            application: props.application
        }), (0, _react.jsx)((0, _footerBarDefault.default), null, (0, _react.jsx)((0, _reactRouterDom.Link), {
            to: `/v/apps/${e?.applicationId}/analytics/sessions?sessionId=${e.sessionId}`,
            target: "_blank",
            rel: "noopener noreferrer",
            onClick: (e)=>{
                e.stopPropagation();
                resetCopyButtonText();
            }
        }, (0, _react.jsx)((0, _buttonDefault.default), {
            disabled: false,
            themes: [
                "secondary"
            ],
            text: "Go To Session",
            onClick: null,
            type: "button"
        })), (0, _react.jsx)("div", null, (0, _react.jsx)((0, _buttonDefault.default), {
            disabled: false,
            themes: [
                "secondary"
            ],
            text: copyButtonText,
            onClick: ()=>handleCopyButtonClick(`${(0, _urls.getBaseUrl)()}/v/apps/${e?.applicationId}/analytics/sessions?sessionId=${e.sessionId}${getStartandEndDate(e.sessionId)}`),
            type: "button"
        })), (0, _react.jsx)(FooterButton, {
            type: "button",
            themes: [
                "secondary"
            ],
            text: "Close",
            onClick: (e)=>{
                clearSessionToReview();
                e.stopPropagation();
                resetCopyButtonText();
            }
        }))));
    };
    const renderCollapsableSessionReview = (idsToReview, title, expandBool, setBoolFunc)=>{
        return (0, _react.jsx)((0, _collapsingPanelDefault.default), {
            collapsedView: (0, _react.jsx)(ClickableHeader, {
                onClick: ()=>setBoolFunc(!expandBool)
            }, `${title} (${idsToReview.length})`),
            isCollapsed: !expandBool,
            expandedView: (0, _react.jsx)((0, _reactDefault.default).Fragment, null, (0, _react.jsx)(ClickableHeader, {
                onClick: ()=>{
                    setBoolFunc(!expandBool);
                }
            }, `${title} (${idsToReview.length})`), idsToReview.map((sessionId, idx)=>{
                return (0, _react.jsx)(SessionHeader, {
                    className: orderingContainer.loadingSessionId === sessionId ? "loading" : "",
                    key: sessionId,
                    onClick: ()=>{
                        if (!orderingContainer.loadingSessionId.length) setSessionIdToReview(sessionId);
                    }
                }, (0, _react.jsx)(SessionHeaderDate, null, (0, _momentDefault.default)(orderingContainer?.sessions?.find((s)=>s.sessionId === sessionId)?.startDate ?? new Date()).format((0, _analyticsDateFormat.SESSION_DATE_FORMAT))), (0, _react.jsx)(SessionLink, {
                    to: `/v/apps/${props.applicationId}/analytics/sessions?sessionId=${sessionId}`,
                    target: "_blank",
                    rel: "noopener noreferrer",
                    onClick: (e)=>{
                        e.stopPropagation();
                    }
                }, (0, _react.jsx)(SessionLinkButton, {
                    disabled: false,
                    themes: [
                        "secondary-small"
                    ],
                    text: "Full Session",
                    onClick: null,
                    type: "button"
                })));
            }))
        });
    };
    if (orderingContainer.loading) return (0, _react.jsx)((0, _loaderDefault.default), null);
    return (0, _react.jsx)((0, _reactDefault.default).Fragment, null, (0, _react.jsx)(Header, null, "App Summary"), (0, _react.jsx)(SummaryContainer, null, (0, _react.jsx)(StyledTotalCard, {
        title: "Conversational Success Rate",
        subtitle: "(All Conversations)",
        value: formatPercentage(orderingContainer.conversationalSuccessRate),
        subValue: `${orderingContainer.conversationalSuccess?.toString()} ${orderingContainer.conversationalSuccess === 1 ? " successful call" : " successful calls"}`,
        tooltip: "Calls marked as Conversational Success. This includes AI Answering queries, immediate hangups, and successful transfers.",
        highlight: true,
        className: highlightedTotalCardStyle,
        icon: conversationalSuccessIcon
    }), (0, _react.jsx)(StyledTotalCard, {
        title: "Conversational Success Rate",
        subtitle: "(Attempted Orders)",
        value: formatPercentage(orderingContainer.attemptedOrdersConversationalSuccessRate),
        subValue: `${orderingContainer.attemptedOrderConversationalSuccess?.toString()} ${orderingContainer.attemptedOrderConversationalSuccess === 1 ? " successful call" : " successful calls"}`,
        tooltip: "Orders Placed plus Unplaced Orders marked as Conversational Success divided by the number of Attempted Orders.",
        highlight: true,
        className: highlightedTotalCardStyle,
        icon: conversationalSuccessIcon
    }), (0, _react.jsx)(StyledTotalCard, {
        title: "Orders Placed Rate",
        subtitle: "(Attempted Orders)",
        value: formatPercentage(orderingContainer.orderPlacedRate),
        subValue: `${orderingContainer.ordersPlaced?.toString()} ${orderingContainer.ordersPlaced === 1 ? " order placed" : " orders placed"}`,
        tooltip: "Orders Placed divided by Order Attempts.",
        highlight: true,
        className: highlightedTotalCardStyle,
        icon: orderPlacedIcon
    })), (0, _react.jsx)(SummaryContainer, null, (0, _react.jsx)(StyledTotalCard, {
        title: "Calls",
        value: orderingContainer.sessions.length,
        tooltip: "The total number of tracked sessions against this assistant."
    }), (0, _react.jsx)(StyledTotalCard, {
        title: "Order Attempts",
        value: orderingContainer.orderAttempts,
        tooltip: "The total number of sessions where any items were added to the order."
    })), (0, _react.jsx)(SummaryContainer, null, (0, _react.jsx)(StyledTotalCard, {
        title: "Transfer Rate",
        value: formatPercentage(orderingContainer.transferRate),
        subValue: `${orderingContainer.transfers?.toString()} ${orderingContainer.transfers === 1 ? " transfer" : " transfers"}`,
        tooltip: "Transfers divided by Sessions."
    }), (0, _react.jsx)(StyledTotalCard, {
        title: "Immediate Transfer Rate",
        value: formatPercentage(orderingContainer.immediateTransferRate),
        subValue: `${orderingContainer.immediateTransfers?.toString()} ${orderingContainer.immediateTransfers === 1 ? " immediate transfer" : " immediate transfers"}`,
        tooltip: "Immediate Transfers divided by Sessions."
    }), (0, _react.jsx)(StyledTotalCard, {
        title: "Order Transfer Rate",
        value: formatPercentage(orderingContainer.orderTransferRate),
        subValue: `${orderingContainer.orderTransfers?.toString()} ${orderingContainer.orderTransfers === 1 ? " transfer" : " transfers"}`,
        tooltip: "Transfer rate during Order Attempts."
    })), orderingContainer.unsuccessfulOrderSessionIds.length === 0 ? (0, _react.jsx)(Header, null, "No failed orders") : null, orderingContainer.unsuccessfulOrderSessionIds.length ? renderCollapsableSessionReview(orderingContainer.unsuccessfulOrderSessionIds, "Failed order sessions", expandFailedOrders, setExpandFailedOrders) : null, orderingContainer.ordersPlacedSessionIds.length ? renderCollapsableSessionReview(orderingContainer.ordersPlacedSessionIds, "Order placed sessions", expandPlacedOrders, setExpandPlacedOrder) : null, orderingContainer.noOrderSessionIds.length ? renderCollapsableSessionReview(orderingContainer.noOrderSessionIds, "No order sessions", expandNoOrders, setExpandNoOrders) : null, orderingContainer.orderTransferredSessionIds.length ? renderCollapsableSessionReview(orderingContainer.orderTransferredSessionIds, "Order sessions with transfers", expandOrderTransfers, setExpandOrderTransfers) : null, (0, _react.jsx)(Spacer, null), (0, _react.jsx)((0, _pageErrorDefault.default), {
        errors: orderingContainer.errors
    }), (0, _react.jsx)(CodeReviewModal, null), (0, _react.jsx)(CustomSessionReview, null));
};
const highlightedTotalCardStyle = /*#__PURE__*/ (0, _css.css)("border:1px solid ", (0, _colors.color_colors_ocean), ";box-shadow:0px 4px 8px rgba(30, 126, 185, 0.2);", "");
const StyledTotalCard = /*#__PURE__*/ (0, _baseDefault.default)((0, _totalCardDefault.default), {
    target: "e1519xo110"
})({
    name: "5ddqek",
    styles: "padding:32px;height:auto;text-align:center;margin:16px 16px 0px 16px"
});
const Header = /*#__PURE__*/ (0, _baseDefault.default)("h3", {
    target: "e1519xo19"
})({
    name: "9nd8j7",
    styles: "margin:16px 32px;margin-top:24px;font-size:18px"
});
const ClickableHeader = /*#__PURE__*/ (0, _baseDefault.default)(Header, {
    target: "e1519xo18"
})({
    name: "e0dnmk",
    styles: "cursor:pointer"
});
const Spacer = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1519xo17"
})({
    name: "1hgqtge",
    styles: "height:100px"
});
const SummaryContainer = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1519xo16"
})({
    name: "14ujbtq",
    styles: "display:flex;flex:1;margin:0 16px;padding-bottom:16px"
});
const FooterButton = /*#__PURE__*/ (0, _baseDefault.default)((0, _buttonDefault.default), {
    target: "e1519xo15"
})({
    name: "1o3nkn",
    styles: "margin-left:auto"
});
const SessionHeader = /*#__PURE__*/ (0, _baseDefault.default)("h3", {
    target: "e1519xo14"
})("margin-top:24px;margin-bottom:16px;margin-left:24px;margin-right:24px;padding:16px 16px;border:1px solid ", (0, _colors.color_shades_dark), ";cursor:pointer;border-radius:12px 12px 12px 12px;display:flex;flex-direction:row;position:relative;&.loading{cursor:default;background-color:", (0, _colors.color_shades_light), ";}");
const SessionHeaderDate = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1519xo13"
})({
    name: "1j4ms98",
    styles: "margin-top:6px;margin-right:8px;font-weight:lighter;min-width:180px"
});
const SessionLinkButton = /*#__PURE__*/ (0, _baseDefault.default)((0, _buttonDefault.default), {
    target: "e1519xo12"
})({
    name: "ti75j2",
    styles: "margin:0"
});
const StyledLink = /*#__PURE__*/ (0, _baseDefault.default)((0, _reactRouterDom.Link), {
    target: "e1519xo11"
})({
    name: "92uyih",
    styles: "text-decoration:none;color:inherit;&:focus,&:hover,&:visited,&:link,&:active{text-decoration:none;color:inherit;}"
});
const SessionLink = /*#__PURE__*/ (0, _baseDefault.default)((0, _reactRouterDom.Link), {
    target: "e1519xo10"
})({
    name: "1o3nkn",
    styles: "margin-left:auto"
});
exports.default = ApplicationOrderingAnalyticsReport;

},{"@emotion/styled/base":"lSuFu","@emotion/react":"djZKr","react":"6uln9","../../../hooks/TelephonyAnalyticsContainer":"214YQ","../../../components/charts/TotalCard":"gH7gf","../../../components/general/Loader":"bnV5T","../../../components/general/PageError":"ezFTm","../../../components/structure/ModalLayout":"b1cO3","../../../components/general/ModalHeader":"aUACx","./SessionReview":"bA5x6","moment":"2meyw","../../../models/analytics/AnalyticsDateFormat":"ia5MW","../../../hooks/UseWindowSize":"43j9z","../../simulator/components/CodeOutputModal":"kbywW","../../../components/general/Button":"6ymxN","react-router-dom":"5fzqq","../../../components/structure/FooterBar":"bibRL","../../../constants/colors":"1p3OR","../../../components/structure/Panels/CollapsingPanel":"jVPoD","../../../constants/Urls":"iTopY","@emotion/css":"awUBr","9f1637e346d65024":"fHvPO","a302be94e0371827":"jSys4","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"eJbGz":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _applicationAnalyticsCharts = require("./ApplicationAnalyticsCharts");
var _applicationAnalyticsChartsDefault = parcelHelpers.interopDefault(_applicationAnalyticsCharts);
const ApplicationMissCharts = (props)=>{
    (0, _react1.useEffect)(()=>{
        loadChartData();
    }, [
        props.interval,
        props.filter
    ]);
    const [loading, setLoading] = (0, _react1.useState)(false);
    const loadChartData = async ()=>{
        if (loading) return;
        await setLoading(true);
        props.stateContainer.loadPrimaryBreakdown({
            applicationId: props.applicationId
        }, props.filter, props.stateContainer.state.currentBreakdown);
        props.stateContainer.loadSecondaryBreakdown({
            applicationId: props.applicationId
        }, props.filter, props.stateContainer.state.currentBreakdown);
        await props.stateContainer.loadPrimaryHistogram({
            applicationId: props.applicationId
        }, props.innerInterval, props.filter);
        await props.stateContainer.loadSecondaryHistogram({
            applicationId: props.applicationId
        }, props.innerInterval, props.filter);
        await props.stateContainer.getAverages({
            applicationId: props.applicationId
        }, props.filter);
        await setLoading(false);
    };
    return (0, _react.jsx)((0, _applicationAnalyticsChartsDefault.default), {
        applicationId: props.applicationId,
        filter: props.filter,
        innerInterval: props.innerInterval,
        interval: props.interval,
        dataType: "Misses",
        stateContainer: props.stateContainer,
        showSecondary: props.stateContainer.state.currentDisplayOption?.toLowerCase()?.indexOf("interactions") > -1,
        showPrimary: props.stateContainer.state.currentDisplayOption?.toLowerCase()?.indexOf("intents") > -1,
        secondaryDataName: "Missed Interactions",
        primaryDataName: "Missed Intents"
    });
};
exports.default = ApplicationMissCharts;

},{"@emotion/react":"djZKr","react":"6uln9","./ApplicationAnalyticsCharts":"2fJkY","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"lbSlB":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _extends = require("@babel/runtime/helpers/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _unstated = require("unstated");
var _exitMessageContainer = require("../../../state/containers/ExitMessageContainer");
var _exitMessageContainerDefault = parcelHelpers.interopDefault(_exitMessageContainer);
var _customRequestContainer = require("../../../state/containers/CustomRequestContainer");
var _customRequestContainerDefault = parcelHelpers.interopDefault(_customRequestContainer);
var _helpMessageContainer = require("../../../state/containers/HelpMessageContainer");
var _helpMessageContainerDefault = parcelHelpers.interopDefault(_helpMessageContainer);
var _fallbackMessageContainer = require("../../../state/containers/FallbackMessageContainer");
var _fallbackMessageContainerDefault = parcelHelpers.interopDefault(_fallbackMessageContainer);
var _welcomeMessageContainer = require("../../../state/containers/WelcomeMessageContainer");
var _welcomeMessageContainerDefault = parcelHelpers.interopDefault(_welcomeMessageContainer);
var _questionAnswerContainer = require("../../../state/containers/QuestionAnswerContainer");
var _questionAnswerContainerDefault = parcelHelpers.interopDefault(_questionAnswerContainer);
var _latestMessageContainer = require("../../../state/containers/LatestMessageContainer");
var _latestMessageContainerDefault = parcelHelpers.interopDefault(_latestMessageContainer);
var _simpleChoiceContainer = require("../../../state/containers/SimpleChoiceContainer");
var _simpleChoiceContainerDefault = parcelHelpers.interopDefault(_simpleChoiceContainer);
var _numberRangeContainer = require("../../../state/containers/NumberRangeContainer");
var _numberRangeContainerDefault = parcelHelpers.interopDefault(_numberRangeContainer);
var _featureTypeIds = require("../../../constants/featureTypeIds");
var _applicationSessionAnalytics = require("./ApplicationSessionAnalytics");
var _applicationSessionAnalyticsDefault = parcelHelpers.interopDefault(_applicationSessionAnalytics);
const SessionAnalyticsWrapper = (props)=>(0, _react.jsx)((0, _unstated.Subscribe), {
        to: [
            (0, _customRequestContainerDefault.default),
            (0, _exitMessageContainerDefault.default),
            (0, _fallbackMessageContainerDefault.default),
            (0, _helpMessageContainerDefault.default),
            (0, _latestMessageContainerDefault.default),
            (0, _simpleChoiceContainerDefault.default),
            (0, _numberRangeContainerDefault.default),
            (0, _questionAnswerContainerDefault.default),
            (0, _welcomeMessageContainerDefault.default)
        ]
    }, (customRequestContainer, exitContainer, fallbackContainer, helpContainer, latestMessageContainer, simpleChoiceContainer, numberRangeContainer, questionAnswerContainer, welcomeContainer)=>{
        const contentContainers = {};
        contentContainers[0, _featureTypeIds.CustomRequestsFeatureTypeId] = customRequestContainer;
        contentContainers[0, _featureTypeIds.ExitMessagesFeatureTypeId] = exitContainer;
        contentContainers[0, _featureTypeIds.FallbackFeatureTypeId] = fallbackContainer;
        contentContainers[0, _featureTypeIds.HelpMessagesFeatureTypeId] = helpContainer;
        contentContainers[0, _featureTypeIds.LatestMessagesFeatureTypeId] = latestMessageContainer;
        contentContainers[0, _featureTypeIds.SimpleChoiceFeatureTypeId] = simpleChoiceContainer;
        contentContainers[0, _featureTypeIds.NumberRangeFeatureTypeId] = numberRangeContainer;
        contentContainers[0, _featureTypeIds.QuestionAnswerFeatureTypeId] = questionAnswerContainer;
        contentContainers[0, _featureTypeIds.WelcomeMessagesFeatureTypeId] = welcomeContainer;
        return (0, _react.jsx)((0, _applicationSessionAnalyticsDefault.default), (0, _extendsDefault.default)({}, props, {
            contentContainers: contentContainers,
            application: props.application
        }));
    });
exports.default = SessionAnalyticsWrapper;

},{"@babel/runtime/helpers/extends":"4iKIP","@emotion/react":"djZKr","react":"6uln9","unstated":"grh7p","../../../state/containers/ExitMessageContainer":"lSKl8","../../../state/containers/CustomRequestContainer":"aVO05","../../../state/containers/HelpMessageContainer":"2oQaX","../../../state/containers/FallbackMessageContainer":"kKZMo","../../../state/containers/WelcomeMessageContainer":"j3orW","../../../state/containers/QuestionAnswerContainer":"hfasy","../../../state/containers/LatestMessageContainer":"1Hdqb","../../../state/containers/SimpleChoiceContainer":"hO0x5","../../../state/containers/NumberRangeContainer":"an6iC","../../../constants/featureTypeIds":"hPLMP","./ApplicationSessionAnalytics":"gayEU","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"gayEU":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _base = require("@emotion/styled/base");
var _baseDefault = parcelHelpers.interopDefault(_base);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _sessionAnalyticsContainer = require("../../../hooks/SessionAnalyticsContainer");
var _sessionAnalyticsContainerDefault = parcelHelpers.interopDefault(_sessionAnalyticsContainer);
var _customScrollbars = require("../../../components/structure/CustomScrollbars");
var _customScrollbarsDefault = parcelHelpers.interopDefault(_customScrollbars);
var _useWindowSize = require("../../../hooks/UseWindowSize");
var _useWindowSizeDefault = parcelHelpers.interopDefault(_useWindowSize);
var _loader = require("../../../components/general/Loader");
var _loaderDefault = parcelHelpers.interopDefault(_loader);
var _simulatorConversationHistoryItem = require("../../simulator/components/SimulatorConversationHistoryItem");
var _simulatorConversationHistoryItemDefault = parcelHelpers.interopDefault(_simulatorConversationHistoryItem);
var _simulatorContainer = require("../../../hooks/SimulatorContainer");
var _simulatorContainerDefault = parcelHelpers.interopDefault(_simulatorContainer);
var _moment = require("moment");
var _momentDefault = parcelHelpers.interopDefault(_moment);
var _colors = require("../../../constants/colors");
var _analyticsDateFormat = require("../../../models/analytics/AnalyticsDateFormat");
var _queryString = require("query-string");
var _queryStringDefault = parcelHelpers.interopDefault(_queryString);
var _searchField = require("../../../components/forms/SearchField");
var _searchFieldDefault = parcelHelpers.interopDefault(_searchField);
var _sessionReview = require("./SessionReview");
var _sessionReviewDefault = parcelHelpers.interopDefault(_sessionReview);
var _codeOutputModal = require("../../simulator/components/CodeOutputModal");
var _codeOutputModalDefault = parcelHelpers.interopDefault(_codeOutputModal);
var _sparkContainer = require("../../../hooks/SparkContainer");
var _sparkContainerDefault = parcelHelpers.interopDefault(_sparkContainer);
var _useIsMobile = require("../../../hooks/UseIsMobile");
var _useIsMobileDefault = parcelHelpers.interopDefault(_useIsMobile);
var _collapsingPanel = require("../../../components/structure/Panels/CollapsingPanel");
var _collapsingPanelDefault = parcelHelpers.interopDefault(_collapsingPanel);
var _collapsedMenuPanel = require("../../../components/structure/CollapsedMenuPanel");
var _collapsedMenuPanelDefault = parcelHelpers.interopDefault(_collapsedMenuPanel);
var _expandedMenuPanel = require("../../../components/structure/ExpandedMenuPanel");
var _expandedMenuPanelDefault = parcelHelpers.interopDefault(_expandedMenuPanel);
var _breakpoints = require("../../../constants/breakpoints");
var _contentContainer = require("../../../hooks/ContentContainer");
var _contentContainerDefault = parcelHelpers.interopDefault(_contentContainer);
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const ApplicationSessionAnalytics = (props)=>{
    const DEFAULT_VISIBLE_COUNT = 100;
    const SEARCH_MAX_VISIBLE_COUNT = 200;
    const SESSION_WINDOW_BEFORE = 50;
    const SESSION_WINDOW_AFTER = 50;
    const LOAD_MORE_COUNT = 50;
    const [selectedSession, setSelectedSession] = (0, _react1.useState)("");
    const [sessionToLoad, setSessionToLoad] = (0, _react1.useState)([]);
    const [allEvents, setAllEvents] = (0, _react1.useState)([]);
    const [contentHits, setContentHits] = (0, _react1.useState)([]);
    const [filteredSessions, setFilteredSessions] = (0, _react1.useState)([]);
    const [loaded, setLoaded] = (0, _react1.useState)(false);
    const [startDate, setStartDate] = (0, _react1.useState)("");
    const [eventsToShow, setEventsToShow] = (0, _react1.useState)(null);
    const [endDate, setEndDate] = (0, _react1.useState)("");
    const [detailedAnalyticsEnabled, setDetailedAnalyticsEnabled] = (0, _react1.useState)(true);
    const [searchFieldValue, setSearchFieldValue] = (0, _react1.useState)("");
    const [isLeftExpanded, setIsLeftExpanded] = (0, _react1.useState)(true);
    const [touchStartY, setTouchStartY] = (0, _react1.useState)(0);
    const [touchStartTime, setTouchStartTime] = (0, _react1.useState)(0);
    const [mobileViewMode, setMobileViewMode] = (0, _react1.useState)("session");
    const [visibleRange, setVisibleRange] = (0, _react1.useState)({
        start: 0,
        end: DEFAULT_VISIBLE_COUNT - 1
    });
    const simulatorContainer = (0, _simulatorContainerDefault.default).useContainer();
    const sessionContainer = (0, _sessionAnalyticsContainerDefault.default).useContainer();
    const sparkContainer = (0, _sparkContainerDefault.default).useContainer();
    const contentContainer = (0, _contentContainerDefault.default).useContainer();
    const windowSize = (0, _useWindowSizeDefault.default)();
    const isMobile = (0, _useIsMobileDefault.default)();
    const sessionPillRefs = (0, _react1.useRef)({});
    const sessionListScrollRef = (0, _react1.useRef)(null);
    const lastSearchActiveRef = (0, _react1.useRef)(false);
    // Track if the session change was triggered by user selection
    const userSelectedSessionRef = (0, _react1.useRef)(false);
    // Reset userSelectedSessionRef when navigating to this page (e.g., via React Router Link)
    (0, _react1.useEffect)(()=>{
        userSelectedSessionRef.current = false;
    }, [
        window.location.pathname
    ]);
    (0, _react1.useEffect)(()=>{
        const query = (0, _queryStringDefault.default).parse(window.location.search);
        const search = query?.initialSearch;
        if (search?.length) setSearchFieldValue(search);
        const sessionId = query?.sessionId;
        if (isMobile && sessionId?.length) setIsLeftExpanded(false);
    }, [
        window.location.search,
        isMobile
    ]);
    (0, _react1.useEffect)(()=>{
        if (isMobile && selectedSession?.length) setIsLeftExpanded(false);
    }, [
        isMobile,
        selectedSession
    ]);
    (0, _react1.useEffect)(()=>{
        const query = (0, _queryStringDefault.default).parse(window.location.search);
        const selectedId = query?.sessionId;
        // Only scroll if the session change was NOT triggered by user selection
        if (!userSelectedSessionRef.current && selectedId) {
            // Wait for the DOM to paint the session pill
            const timeout = setTimeout(()=>{
                const pill = sessionPillRefs.current[selectedId];
                if (pill) pill.scrollIntoView({
                    behavior: "auto",
                    block: "center",
                    inline: "center"
                });
                userSelectedSessionRef.current = false;
            }, 0);
            return ()=>clearTimeout(timeout);
        } else userSelectedSessionRef.current = false;
    }, [
        window.location.search,
        filteredSessions
    ]);
    (0, _react1.useEffect)(()=>{
        if (!filteredSessions.length) {
            setVisibleRange({
                start: 0,
                end: -1
            });
            return;
        }
        const searchActive = searchFieldValue?.length > 0;
        const selectedIndex = filteredSessions.findIndex((session)=>session.sessionId === selectedSession);
        const maxVisibleCount = searchActive ? SEARCH_MAX_VISIBLE_COUNT : Number.MAX_SAFE_INTEGER;
        const baseRange = (()=>{
            if (selectedIndex >= 0) {
                const start = Math.max(0, selectedIndex - SESSION_WINDOW_BEFORE);
                const end = Math.min(filteredSessions.length - 1, selectedIndex + SESSION_WINDOW_AFTER);
                return {
                    start,
                    end
                };
            }
            return {
                start: 0,
                end: Math.min(filteredSessions.length - 1, DEFAULT_VISIBLE_COUNT - 1)
            };
        })();
        const shouldReset = searchActive !== lastSearchActiveRef.current;
        lastSearchActiveRef.current = searchActive;
        setVisibleRange((prev)=>{
            if (shouldReset || prev.end < 0) return baseRange;
            if (selectedIndex >= 0 && (selectedIndex < prev.start || selectedIndex > prev.end)) return baseRange;
            const normalizedStart = Math.max(0, Math.min(prev.start, filteredSessions.length - 1));
            const normalizedEnd = Math.max(normalizedStart, Math.min(prev.end, filteredSessions.length - 1));
            const visibleCount = normalizedEnd - normalizedStart + 1;
            if (visibleCount > maxVisibleCount) {
                const adjustedEnd = Math.min(filteredSessions.length - 1, normalizedStart + maxVisibleCount - 1);
                return {
                    start: normalizedStart,
                    end: adjustedEnd
                };
            }
            return {
                start: normalizedStart,
                end: normalizedEnd
            };
        });
        if (shouldReset && sessionListScrollRef.current?.scrollTop) sessionListScrollRef.current.scrollTop(0);
    }, [
        filteredSessions,
        selectedSession,
        searchFieldValue
    ]);
    const visibleSessions = (0, _react1.useMemo)(()=>{
        if (!filteredSessions.length || visibleRange.end < visibleRange.start) return [];
        return filteredSessions.slice(visibleRange.start, visibleRange.end + 1);
    }, [
        filteredSessions,
        visibleRange
    ]);
    const handleSessionListScroll = (values)=>{
        if (!filteredSessions.length) return;
        const searchActive = searchFieldValue?.length > 0;
        const maxVisibleCount = searchActive ? SEARCH_MAX_VISIBLE_COUNT : Number.MAX_SAFE_INTEGER;
        const totalCount = filteredSessions.length;
        const visibleCount = visibleRange.end >= visibleRange.start ? visibleRange.end - visibleRange.start + 1 : 0;
        if (values.top > 0.85) {
            if (visibleCount >= maxVisibleCount) return;
            setVisibleRange((prev)=>{
                const newEnd = Math.min(totalCount - 1, prev.end + LOAD_MORE_COUNT, prev.start + maxVisibleCount - 1);
                if (newEnd === prev.end) return prev;
                return {
                    ...prev,
                    end: newEnd
                };
            });
        }
        if (values.top < 0.15 && selectedSession?.length) {
            if (visibleCount >= maxVisibleCount) return;
            setVisibleRange((prev)=>{
                const newStart = Math.max(0, prev.start - LOAD_MORE_COUNT);
                if (newStart === prev.start) return prev;
                return {
                    ...prev,
                    start: newStart
                };
            });
        }
    };
    (0, _react1.useEffect)(()=>{
        simulatorContainer.startNewSession();
        initialLoad();
    }, []);
    (0, _react1.useEffect)(()=>{
        if (selectedSession?.length && selectedSession in sessionContainer.events && (!allEvents.length || allEvents[0].sessionId !== selectedSession)) {
            const newEvents = sessionContainer.events[selectedSession];
            // sort by event date
            newEvents.sort((a, b)=>new Date(a.eventDate).getTime() - new Date(b.eventDate).getTime());
            setAllEvents(newEvents);
        }
    }, [
        sessionContainer.events,
        selectedSession
    ]);
    (0, _react1.useEffect)(()=>{
        const contentHits = allEvents?.filter((e)=>e.eventType === "ContentHit");
        // group by req id
        const grouped = contentHits.reduce((acc, hit)=>{
            if (!acc[hit.requestId]) acc[hit.requestId] = [];
            acc[hit.requestId].push(hit);
            return acc;
        }, {});
        // take last hit of each group
        const lastHits = Object.values(grouped).map((hits)=>hits[hits.length - 1]);
        if (lastHits.length) {
            setSessionToLoad(lastHits);
            setContentHits(lastHits);
        }
    }, [
        allEvents
    ]);
    (0, _react1.useEffect)(()=>{
        if (sessionToLoad.length) loadSessionTurn();
    }, [
        sessionToLoad
    ]);
    (0, _react1.useEffect)(()=>{
        let newFilteredSessions = sessionContainer.sessions;
        const query = (0, _queryStringDefault.default).parse(window.location.search);
        if (query?.contentId?.length) {
            contentContainer.getSession(props.applicationId, query.contentId, props.filter).then((sessionIds)=>{
                if (sessionIds) setFilteredSessions(sessionContainer.sessions.filter((s)=>sessionIds.includes(s.sessionId)));
            });
            return;
        }
        if (searchFieldValue?.length) {
            newFilteredSessions = [];
            for (const session of sessionContainer.sessions){
                if (session.sessionId.includes(searchFieldValue)) newFilteredSessions.push(session);
                else if (session?.phoneNumbers?.some((p)=>p.includes(searchFieldValue))) newFilteredSessions.push(session);
            }
        }
        setFilteredSessions(newFilteredSessions);
    }, [
        sessionContainer.sessions,
        searchFieldValue
    ]);
    (0, _react1.useEffect)(()=>{
        if (props.envContainer.state.currentAppId === props.applicationId && props.envContainer.state.environments?.length) setDetailedAnalyticsEnabled(props.envContainer.state.environments?.[0]?.detailedAnalyticsEnabled ?? false);
    }, [
        props.envContainer.state.environments
    ]);
    (0, _react1.useEffect)(()=>{
        if (startDate === "" && props.filter.startDate) {
            setStartDate(props.filter?.startDate);
            setEndDate(props.filter?.endDate);
            return;
        }
        if (props.filter?.startDate !== startDate || props.filter?.endDate !== endDate) {
            setStartDate(props.filter?.startDate);
            setEndDate(props.filter?.endDate);
            simulatorContainer.startNewSession();
            sessionContainer.loadSessions(props.applicationId, props.filter);
        }
    }, [
        props.filter
    ]);
    (0, _react1.useEffect)(()=>{
        const query = (0, _queryStringDefault.default).parse(window.location.search);
        if (query?.sessionId?.length) {
            if (selectedSession === query.sessionId) return;
            if (sessionContainer.sessions.some((s)=>s.sessionId === query.sessionId)) setSelectedSession(query.sessionId);
        }
    }, [
        window.location.search,
        sessionContainer.sessions
    ]);
    (0, _react1.useEffect)(()=>{
        if (selectedSession.length == 0) return;
        sessionContainer.loadEventsForSession(props.applicationId, selectedSession);
        setLoaded(true);
    }, [
        selectedSession
    ]);
    const convertEventsForCodeOutputModal = (events)=>{
        var returnObj = {};
        events?.forEach((e, idx)=>{
            returnObj[`${idx}-${e.eventType}`] = e;
        });
        // get last event that is request received
        const lastContentHit = events?.slice()?.reverse()?.find((e)=>e.eventType === "ContentHit");
        if (lastContentHit?.originalRequest?.sessionAttributes) returnObj[`${events.length}-LatestSessionAttributes`] = lastContentHit.originalRequest.sessionAttributes;
        return returnObj;
    };
    const memoizedModal = (0, _react1.useMemo)(()=>(0, _react.jsx)((0, _codeOutputModalDefault.default), {
            title: "JSON",
            closeModal: ()=>setEventsToShow(null),
            data: convertEventsForCodeOutputModal(eventsToShow),
            showCodeOutputModal: eventsToShow
        }), [
        eventsToShow
    ]);
    const loadSessionTurn = async ()=>{
        const hit = sessionToLoad[0];
        const newResponses = [];
        newResponses.push(mapContentHitToResponse(hit));
        // we're adding the hit to the simulator container so that we can use the simulator to render the conversation
        await simulatorContainer.updateConversationHistory({
            id: hit.sessionId,
            sessionAttributes: {
                ...hit.originalRequest?.sessionAttributes ?? {},
                ...hit.response?.additionalSessionAttributes ?? {}
            }
        }, newResponses, props.contentContainers, mapContentHitToRequest(hit), mapContentHitToConversationTurn(hit));
        setSessionToLoad(sessionToLoad.slice(1));
    };
    const mapContentHitToResponse = (hit)=>{
        let resposneContent = hit.response?.data?.content;
        if (hit?.response?.followUp?.content?.length) resposneContent = `${resposneContent} ${hit?.response?.followUp?.content}`;
        if (hit) return {
            responseId: hit.response?.data?.responseId,
            ssml: resposneContent,
            outputSpeech: resposneContent,
            displayText: resposneContent,
            displayTitle: resposneContent,
            endSession: false,
            hints: hit.response?.followUp?.followupHints ?? [],
            sessionAttributes: hit.originalRequest?.sessionAttributes ?? {},
            nlp: hit.originalRequest?.nlp,
            responseIdentifier: hit?.response?.data?.name?.length ? hit.response.data.name : hit.response?.data?.responseId?.length ? hit.response?.data?.responseId : null
        };
    };
    const mapContentHitToRequest = (hit)=>{
        let responseContent = hit.response?.data?.content;
        if (hit?.response?.followUp?.content?.length) responseContent = `${responseContent} ${hit?.response?.followUp?.content}`;
        if (hit) return hit?.originalRequest?.nativeRequest;
        else return {
            requestId: hit.requestId,
            context: {
                sessionId: hit.sessionId,
                noTracking: false,
                requestType: hit.originalRequest?.requestType,
                originalInput: hit.originalRequest?.originalInput,
                channel: hit.originalRequest?.channel ?? "",
                requiresLanguageUnderstanding: hit.originalRequest?.nativeRequest?.requiresLanguageUnderstanding ?? true,
                locale: hit.originalRequest?.locale
            },
            device: null,
            user: null
        };
    };
    const initialLoad = async ()=>{
        const envsResult = await props.envContainer.loadEnvironments(props.applicationId);
        if (envsResult.resultType !== "Ok") {
            setDetailedAnalyticsEnabled(false);
            setLoaded(true);
            return;
        }
        const enabled = envsResult.data[0]?.detailedAnalyticsEnabled ?? false;
        setDetailedAnalyticsEnabled(enabled);
        if (!enabled) {
            setLoaded(true);
            return;
        }
        const query = (0, _queryStringDefault.default).parse(window.location.search);
        sessionContainer.loadSessions(props.applicationId, props.filter);
        setLoaded(true);
    };
    const mapContentHitToConversationTurn = (hit)=>{
        return {
            ContentId: hit?.response?.contentItem?.contentItemId,
            FeatureTypeId: hit?.featureTypeId,
            ApplicationId: props.applicationId,
            FollowUpId: hit?.response?.followUp?.id,
            HelpMessageId: "",
            FallbackMessageId: "",
            ChildTurns: [],
            IsLimitedToChildren: hit?.response?.followUp?.isLimitedToChildren,
            RequestDate: new Date(hit?.eventDate)
        };
    };
    const updateFilterToBeginningAndEndOfDay = (filter)=>{
        const newStartDate = new Date(filter.startDate);
        newStartDate.setUTCHours(0, 0, 0, 0);
        const newEndDate = new Date(filter.endDate);
        newEndDate.setUTCHours(23, 59, 59, 999);
        return {
            ...filter,
            startDate: newStartDate.toISOString(),
            endDate: newEndDate.toISOString()
        };
    };
    const handleToggleExpandLeft = (e, expanded)=>{
        setIsLeftExpanded(expanded);
        localStorage.setItem("contentMenu", expanded?.toString());
        e?.stopPropagation();
    };
    const formatPhoneNumber = (phoneNumber)=>{
        // Remove any non-digit characters from the input number
        const cleanedNumber = phoneNumber?.replace(/\D/g, "");
        const formattedNumber = `${cleanedNumber?.substring(7)}`;
        return formattedNumber;
    };
    const renderViewerWrapper = ()=>{
        const renderSessionView = ()=>sessionContainer.loadingEvents ? (0, _react.jsx)((0, _loaderDefault.default), null) : allEvents?.length ? (0, _react.jsx)(SessionReviewContainer, null, (0, _react.jsx)((0, _sessionReviewDefault.default), {
                showFrom: true,
                manualHeight: windowSize.windowSize.innerHeight - (isMobile ? 300 : 250),
                events: allEvents,
                applicationId: props.applicationId,
                hideBorder: true,
                simple: sessionContainer.simpleView || sparkContainer.inSpark,
                setEventsToShow: setEventsToShow,
                resetCopyButtonText: ()=>null,
                application: props.application,
                mobileBubbles: isMobile,
                onSessionSelect: (sessionId)=>{
                    if (window.location.search?.includes(sessionId)) return;
                    const session = filteredSessions.find((s)=>s.sessionId === sessionId);
                    if (session) {
                        handleSessionSelection(session, {
                            stopPropagation: ()=>null
                        });
                        return;
                    }
                    const newFilter = updateFilterToBeginningAndEndOfDay(props.filter);
                    props.history.push({
                        search: `?sessionId=${sessionId}&startDate=${newFilter.startDate}&endDate=${newFilter.endDate}&interval=${props.interval}`
                    });
                }
            })) : (0, _react.jsx)((0, _reactDefault.default).Fragment, null, (0, _react.jsx)(EmptyConversationText, null, (0, _react.jsx)("h4", null, "Select a session"), (0, _react.jsx)("p", null, "to view the conversation")), (0, _react.jsx)((0, _loaderDefault.default), {
                static: true
            }));
        const renderHistoryView = ()=>(0, _react.jsx)(HistoryViewContainer, null, (0, _react.jsx)((0, _customScrollbarsDefault.default), {
                autoHide: true,
                autoHeight: true,
                autoHeightMin: windowSize.windowSize.innerHeight - (isMobile ? 300 : 250),
                autoHeightMax: windowSize.windowSize.innerHeight - (isMobile ? 300 : 250)
            }, simulatorContainer.contentItemsFromHistory?.length ? (0, _react.jsx)(HistoryHeader, null, "CONVERSATION HISTORY") : null, (0, _react.jsx)(HistoryList, null, simulatorContainer.contentItemsFromHistory.map((c, idx)=>(0, _react.jsx)((0, _simulatorConversationHistoryItemDefault.default), {
                    key: idx,
                    turn: mapContentHitToConversationTurn(contentHits[idx]),
                    content: c,
                    simple: sessionContainer.simpleView,
                    index: idx
                })))));
        return (0, _react.jsx)(ViewerWrapper, {
            isMobile: isMobile
        }, isMobile && allEvents?.length > 0 && (0, _react.jsx)(MobileViewToggle, null, (0, _react.jsx)(ToggleButton, {
            active: mobileViewMode === "session",
            onClick: ()=>setMobileViewMode("session")
        }, "Session Review"), (0, _react.jsx)(ToggleButton, {
            active: mobileViewMode === "history",
            onClick: ()=>setMobileViewMode("history")
        }, "Conversation History")), isMobile ? mobileViewMode === "session" ? renderSessionView() : renderHistoryView() : renderSessionView());
    };
    const renderSessionList = ()=>{
        return (0, _react.jsx)(SessionListWrapper, null, (0, _react.jsx)((0, _customScrollbarsDefault.default), {
            autoHide: true,
            autoHeight: true,
            autoHeightMin: windowSize.windowSize.innerHeight - 200,
            autoHeightMax: windowSize.windowSize.innerHeight - 200,
            onScrollFrame: handleSessionListScroll,
            ref: sessionListScrollRef
        }, (0, _react.jsx)(SessionList, null, (0, _react.jsx)(SessionsHeader, null, sparkContainer.inSpark ? (0, _react.jsx)(LeftHeader, null, `${filteredSessions.length} CALLS`) : (0, _react.jsx)(LeftHeader, null, `${filteredSessions.length} SESSIONS`)), (0, _react.jsx)(StyledSearchField, {
            id: "searchField",
            name: "searchField",
            placeholder: "Session or Content Item ID",
            value: searchFieldValue,
            disabled: !loaded,
            onChange: (e)=>setSearchFieldValue(e.target.value),
            boxType: "square"
        }), visibleSessions.map((session, idx)=>{
            return (0, _react.jsx)(SessionPill, {
                ref: (el)=>{
                    sessionPillRefs.current[session.sessionId] = el;
                },
                className: `${window.location.search?.includes(session.sessionId) ? "selected" : ""} ${idx === Object.keys(visibleSessions).length - 1 ? "last" : ""}`,
                key: session.sessionId,
                onClick: isMobile ? undefined : (e)=>handleSessionSelection(session, e),
                onTouchStart: isMobile ? handleTouchStart : undefined,
                onTouchEnd: isMobile ? (e)=>handleTouchEnd(session, e) : undefined
            }, (0, _momentDefault.default)(session.startDate).format((0, _analyticsDateFormat.SESSION_DATE_FORMAT)), session?.from?.length ? (0, _react.jsx)(SessionPillFrom, null, formatPhoneNumber(session.from)) : null);
        }))));
    };
    const renderMenu = ()=>{
        return renderSessionList();
    };
    const renderCollapsingPanel = ()=>{
        return (0, _react.jsx)((0, _collapsingPanelDefault.default), {
            isCollapsed: !isLeftExpanded,
            collapsedView: (0, _react.jsx)((0, _collapsedMenuPanelDefault.default), {
                onExpand: (e)=>handleToggleExpandLeft(e, true),
                expandedViewRender: renderMenu,
                minimizedDrawer: isMobile
            }),
            expandedView: (0, _react.jsx)((0, _expandedMenuPanelDefault.default), {
                onCollapse: (e)=>handleToggleExpandLeft(e, false),
                expandedViewRender: renderMenu,
                minimizedDrawer: isMobile
            })
        });
    };
    const renderMobileView = ()=>{
        return (0, _react.jsx)(SectionWrapper, null, renderCollapsingPanel(), renderViewerWrapper(), memoizedModal);
    };
    const renderDesktopView = ()=>{
        return !isMobile && (0, _react.jsx)(SectionWrapper, null, renderSessionList(), renderViewerWrapper(), (0, _react.jsx)(HistoryListWrapper, null, (0, _react.jsx)((0, _customScrollbarsDefault.default), {
            autoHide: true,
            autoHeight: true,
            autoHeightMin: windowSize.windowSize.innerHeight - 200,
            autoHeightMax: windowSize.windowSize.innerHeight - 200
        }, simulatorContainer.contentItemsFromHistory?.length ? (0, _react.jsx)(HistoryHeader, null, "CONVERSATION HISTORY") : null, (0, _react.jsx)(HistoryList, null, simulatorContainer.contentItemsFromHistory.map((c, idx)=>(0, _react.jsx)((0, _simulatorConversationHistoryItemDefault.default), {
                key: idx,
                turn: mapContentHitToConversationTurn(contentHits[idx]),
                content: c,
                simple: sessionContainer.simpleView,
                index: idx
            }))))), memoizedModal);
    };
    const handleTouchStart = (e)=>{
        setTouchStartY(e.touches[0].clientY);
        setTouchStartTime(Date.now());
    };
    const handleTouchEnd = (session, e)=>{
        const touchEndY = e.changedTouches[0].clientY;
        const touchEndTime = Date.now();
        const deltaY = Math.abs(touchEndY - touchStartY);
        const deltaTime = touchEndTime - touchStartTime;
        // if the duratin of the touch was short, it was a tap(click), if not it was a scroll
        const isClick = deltaTime < 300 && deltaY < 10;
        if (isClick) handleSessionSelection(session, e);
    };
    const handleSessionSelection = (session, e)=>{
        if (window.location.search?.includes(session.sessionId)) return;
        // Mark that this session change is user-initiated
        userSelectedSessionRef.current = true;
        const selectedIndex = filteredSessions.findIndex((s)=>s.sessionId === session.sessionId);
        if (selectedIndex >= 0) {
            const start = Math.max(0, selectedIndex - SESSION_WINDOW_BEFORE);
            const end = Math.min(filteredSessions.length - 1, selectedIndex + SESSION_WINDOW_AFTER);
            setVisibleRange({
                start,
                end
            });
        }
        simulatorContainer.startNewSession();
        const newFilter = updateFilterToBeginningAndEndOfDay(props.filter);
        props.history.push({
            search: `?sessionId=${session.sessionId}&startDate=${newFilter.startDate}&endDate=${newFilter.endDate}&interval=${props.interval}`
        });
        if (isMobile) handleToggleExpandLeft(e, false);
    };
    return (0, _react.jsx)((0, _reactDefault.default).Fragment, null, !loaded || sessionContainer.loading || contentContainer.isLoading ? (0, _react.jsx)(LoaderWrapper, null, (0, _react.jsx)((0, _loaderDefault.default), null)) : !detailedAnalyticsEnabled ? (0, _react.jsx)((0, _reactDefault.default).Fragment, null, (0, _react.jsx)(EmptyConversationText, null, (0, _react.jsx)("h4", null, "Enable detailed analytics"), (0, _react.jsx)("p", null, "to view sessions")), (0, _react.jsx)((0, _loaderDefault.default), {
        static: true
    })) : isMobile ? renderMobileView() : renderDesktopView());
};
const LoaderWrapper = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e7qbowj17"
})("position:fixed;top:0;left:0;width:100vw;height:100vh;display:flex;align-items:center;justify-content:center;z-index:1000;.loader-container{display:flex;align-items:center;justify-content:center;.spinner>div{background:", (0, _colors.color_colors_ocean), ";}}");
const SessionReviewContainer = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e7qbowj16"
})({
    name: "1xelnrc",
    styles: "width:100%;min-width:0"
});
const SessionList = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e7qbowj15"
})({
    name: "6av4zr",
    styles: "font-family:Muli;font-style:normal;font-weight:normal"
});
const SectionWrapper = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e7qbowj14"
})({
    name: "36bnqj",
    styles: "display:flex;flex:1"
});
const HistoryListWrapper = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e7qbowj13"
})({
    name: "12hxb7m",
    styles: "height:100%;width:60%;max-width:432px;min-width:300px"
});
const HistoryList = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e7qbowj12"
})({
    name: "10rtstj",
    styles: "padding:16px"
});
const SessionListWrapper = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e7qbowj11"
})({
    name: "w216zb",
    styles: "max-width:432px;min-width:300px"
});
const SessionPill = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e7qbowj10"
})("height:56px;border:1px solid ", (0, _colors.color_shades_dark), ";border-radius:8px;background:white;margin:0 24px 24px 24px;padding:16px;position:relative;cursor:pointer;&.selected{background:", (0, _colors.color_shades_lighter), ";}&.last{margin-bottom:32px;}");
const SessionPillFrom = /*#__PURE__*/ (0, _baseDefault.default)("p", {
    target: "e7qbowj9"
})("bottom:4px;left:16px;position:absolute;color:", (0, _colors.color_text_light), ";font-size:12px;");
const StyledSearchField = /*#__PURE__*/ (0, _baseDefault.default)((0, _searchFieldDefault.default), {
    target: "e7qbowj8"
})({
    name: "l7wsnw",
    styles: "margin:0 24px 24px 24px"
});
const ViewerWrapper = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e7qbowj7"
})("height:calc(100vh - 200px);background:", (0, _colors.color_shades_lighter), ";width:75%;flex:1;min-width:0;", (0, _breakpoints.breakpoint_small), "{width:100%;height:calc(100vh - 175px);}", (props)=>props.isMobile ? `
        width: 100%;
        height: calc(100vh - 175px);
    ` : "", ";");
const SessionsHeader = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e7qbowj6"
})({
    name: "sgv9kj",
    styles: "margin:24px 24px 16px 24px;display:flex;flex-direction:row"
});
const LeftHeader = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e7qbowj5"
})({
    name: "1tx1l5v",
    styles: "margin-right:auto"
});
const HistoryHeader = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e7qbowj4"
})({
    name: "1qfj671",
    styles: "margin:24px 0px 0px 24px"
});
const EmptyConversationText = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e7qbowj3"
})("color:", (0, _colors.color_shades_darkest), ";position:absolute;top:50%;left:50%;margin:60px 0 0 -95px;display:flex;flex-direction:column;align-items:center;justify-content:center;");
const HistoryViewContainer = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e7qbowj2"
})({
    name: "1sc6paq",
    styles: "padding:16px;height:100%"
});
const MobileViewToggle = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e7qbowj1"
})("display:flex;background:white;border-bottom:1px solid ", (0, _colors.color_shades_dark), ";padding:8px 16px;");
const ToggleButton = /*#__PURE__*/ (0, _baseDefault.default)("button", {
    target: "e7qbowj0"
})("flex:1;padding:8px 16px;margin:0 4px;border:1px solid ", (0, _colors.color_shades_dark), ";border-radius:4px;background:", ({ active })=>active ? (0, _colors.color_shades_lighter) : "white", ";color:", ({ active })=>active ? (0, _colors.color_shades_darkest) : (0, _colors.color_text_light), ";font-size:14px;font-weight:", ({ active })=>active ? "bold" : "normal", ";cursor:pointer;transition:all 0.2s ease;&:hover{background:", (0, _colors.color_shades_lighter), ";}");
exports.default = ApplicationSessionAnalytics;

},{"@emotion/styled/base":"lSuFu","@emotion/react":"djZKr","react":"6uln9","../../../hooks/SessionAnalyticsContainer":"vk8Qc","../../../components/structure/CustomScrollbars":"50vFq","../../../hooks/UseWindowSize":"43j9z","../../../components/general/Loader":"bnV5T","../../simulator/components/SimulatorConversationHistoryItem":"kbMTK","../../../hooks/SimulatorContainer":"gOZ3V","moment":"2meyw","../../../constants/colors":"1p3OR","../../../models/analytics/AnalyticsDateFormat":"ia5MW","query-string":"klvAV","../../../components/forms/SearchField":"aU10T","./SessionReview":"bA5x6","../../simulator/components/CodeOutputModal":"kbywW","../../../hooks/SparkContainer":"jzXzx","../../../hooks/UseIsMobile":"9Gz1L","../../../components/structure/Panels/CollapsingPanel":"jVPoD","../../../components/structure/CollapsedMenuPanel":"1mVIj","../../../components/structure/ExpandedMenuPanel":"30h7k","../../../constants/breakpoints":"2F01A","../../../hooks/ContentContainer":"guIYn","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"kbMTK":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _base = require("@emotion/styled/base");
var _baseDefault = parcelHelpers.interopDefault(_base);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _colors = require("../../../constants/colors");
var _extensions = require("../../../models/extensions");
var _tooltipWrapper = require("../../../components/general/TooltipWrapper");
var _tooltipWrapperDefault = parcelHelpers.interopDefault(_tooltipWrapper);
var _horizontalSeparator = require("../../../components/structure/HorizontalSeparator");
var _horizontalSeparatorDefault = parcelHelpers.interopDefault(_horizontalSeparator);
var _customScrollbars = require("../../../components/structure/CustomScrollbars");
var _customScrollbarsDefault = parcelHelpers.interopDefault(_customScrollbars);
var _codeOutputModal = require("./CodeOutputModal");
var _codeOutputModalDefault = parcelHelpers.interopDefault(_codeOutputModal);
var _css = require("@emotion/css");
var _verticalSeparator = require("../../../components/structure/VerticalSeparator");
var _verticalSeparatorDefault = parcelHelpers.interopDefault(_verticalSeparator);
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const expandIcon = require("f50d5459394ff0e");
const expandGrey = require("e0361b736a43ba05");
const closed = require("6365e275a6546377");
const open = require("f0e54047dad9bc4d");
const investigateIcon = require("141957e08a1e2f24");
const selectedInvestigateIcon = require("9fd6562dd6bba14f");
const codeIcon = require("a49cf2018c41caa3");
const codeIconSearch = require("8b0b57397c469d0f");
const copyIcon = require("86b5dd600a8eeb98");
const codeExpandIcon = require("1ef86fef841db65e");
const SimulatorConversationHistoryItem = ({ turn, content, index, simple })=>{
    const [expanded, setExpanded] = (0, _react1.useState)(false);
    const [investigate, setInvestigate] = (0, _react1.useState)(true);
    const [showCodeModal, setShowCodeModal] = (0, _react1.useState)(false);
    const [modalTitle, setModalTitle] = (0, _react1.useState)("");
    const [modalContent, setModalContent] = (0, _react1.useState)();
    if (!content) return null;
    const showModal = (title, content)=>{
        setShowCodeModal(true);
        setModalTitle(title);
        setModalContent(content);
    };
    const copyText = (text)=>{
        navigator.clipboard.writeText(text);
    };
    return (0, _react.jsx)("div", {
        className: expanded ? ExpandedDiv : ClosedDiv
    }, (0, _react.jsx)("div", {
        className: containerStyle,
        onClick: ()=>setExpanded(!expanded)
    }, (0, _react.jsx)("div", {
        className: "left"
    }, (0, _react.jsx)(OpenCloseIcon, {
        src: expanded ? open : closed
    }), turn ? (0, _react.jsx)(FeatureTypeIcon, {
        src: (0, _extensions.getFeatureTypeIcon)(turn?.FeatureTypeId)
    }) : (0, _react.jsx)(EmptyIconSpace, null), (0, _react.jsx)("p", null, content?.title, simple == false ? `(${index})` : ""), content.hasBeenDeleted || !turn ? (0, _react.jsx)((0, _tooltipWrapperDefault.default), {
        place: "left",
        text: !turn ? "Voicify returned default fallback" : "This item is no longer available"
    }, (0, _react.jsx)(DisabledLinkOut, null, (0, _react.jsx)("img", {
        src: expandGrey
    }))) : (0, _react.jsx)((0, _tooltipWrapperDefault.default), {
        place: "left",
        text: content.isDraft ? "Open content item" : "Open draft version of this content item"
    }, (0, _react.jsx)(LinkOut, {
        href: (0, _extensions.getEditUrl)(content.contentId, content.applicationFeatureId, turn?.FeatureTypeId),
        target: "__blank"
    }, (0, _react.jsx)("img", {
        src: expandIcon
    }))))), expanded && (0, _react.jsx)((0, _reactDefault.default).Fragment, null, (0, _react.jsx)(CardHorizontalSeparator, null, (0, _react.jsx)((0, _horizontalSeparatorDefault.default), null)), (0, _react.jsx)(ExpandedContentDiv, null, (0, _react.jsx)(ContentDiv, null, (0, _react.jsx)(LabelText, null, " We think you said: "), (0, _react.jsx)(ContentText, null, `"${content?.response?.nlp?.utterance ?? content.request?.context?.originalInput}"`), (0, _react.jsx)((0, _horizontalSeparatorDefault.default), null), (0, _react.jsx)(InvestigateCodeDiv, null, (0, _react.jsx)(LeftCodeInvestigateDiv, {
        className: investigate ? SelectedDataDiv : NonSelectedDataDiv,
        onClick: ()=>setInvestigate(true)
    }, (0, _react.jsx)(InvestigateText, {
        className: investigate ? InvestigateTextSelected : null
    }, (0, _react.jsx)(CodeInvestigateIcon, {
        src: investigate ? selectedInvestigateIcon : investigateIcon
    }), "Investigate")), (0, _react.jsx)(CustomVerticalSeparator, {
        fit: true
    }), (0, _react.jsx)(CodeInvestigateDiv, {
        className: !investigate ? SelectedDataDiv : NonSelectedDataDiv,
        onClick: ()=>setInvestigate(false)
    }, (0, _react.jsx)(InvestigateText, {
        className: !investigate ? InvestigateTextSelected : null
    }, (0, _react.jsx)(CodeInvestigateIcon, {
        src: investigate ? codeIcon : codeIconSearch
    }), "Code Output"))), (0, _react.jsx)((0, _horizontalSeparatorDefault.default), null), (0, _react.jsx)("br", null), investigate ? (0, _react.jsx)((0, _reactDefault.default).Fragment, null, content.response?.nlp?.intent != null && (0, _react.jsx)((0, _reactDefault.default).Fragment, null, (0, _react.jsx)(LabelText, null, "Intent"), (0, _react.jsx)(ContentText, null, content.response?.nlp?.intent?.name)), content.interactionType != null && (0, _react.jsx)((0, _reactDefault.default).Fragment, null, (0, _react.jsx)(LabelText, null, "Interaction Type"), (0, _react.jsx)(ContentText, null, content.interactionType)), content.response?.responseIdentifier?.length && (0, _react.jsx)((0, _reactDefault.default).Fragment, null, (0, _react.jsx)(LabelText, null, "Response Used"), (0, _react.jsx)(ContentText, null, content.response?.responseIdentifier)), content.response?.nlp?.extractedEntities != null && content.response?.nlp?.extractedEntities.length > 0 && (0, _react.jsx)((0, _reactDefault.default).Fragment, null, (0, _react.jsx)(LabelText, null, "Entities"), (0, _react.jsx)((0, _customScrollbarsDefault.default), {
        autoHide: true,
        autoHeight: true,
        autoHeightMax: 100
    }, content.response?.nlp?.extractedEntities?.map((entity, index)=>(0, _react.jsx)(SlotEntityDiv, {
            key: "EKey " + index
        }, `${entity.name} -\u00A0`, " ", (0, _react.jsx)(KVPValue, null, entity.value ?? entity.utteranceText))))), !!content.response?.nlp?.slotDetails?.length && (0, _react.jsx)((0, _reactDefault.default).Fragment, null, (0, _react.jsx)("br", null), (0, _react.jsx)(LabelText, null, "Slots"), (0, _react.jsx)((0, _customScrollbarsDefault.default), {
        autoHide: true,
        autoHeight: true,
        autoHeightMax: 100
    }, content.response?.nlp?.slotDetails?.map((slotDetail, index)=>(0, _react.jsx)(SlotEntityDiv, {
            key: "SKey " + index
        }, `${slotDetail.slotName} -\u00A0`, " ", (0, _react.jsx)(KVPValue, null, slotDetail.value ?? slotDetail.utteranceText)))))) : (0, _react.jsx)((0, _reactDefault.default).Fragment, null, (0, _react.jsx)(CodeOutputContainerDiv, null, (0, _react.jsx)(CodeOutputDiv, null, "REQUEST", (0, _react.jsx)(ImgSpan, null, (0, _react.jsx)(CodeOutputImg, {
        src: copyIcon,
        onClick: ()=>copyText(JSON.stringify(content.request, null, 2))
    }), (0, _react.jsx)(CodeOutputImg, {
        src: codeExpandIcon,
        onClick: ()=>showModal("Request", content.request)
    })))), (0, _react.jsx)("br", null), (0, _react.jsx)(CodeDiv, null, (0, _react.jsx)((0, _customScrollbarsDefault.default), {
        autoHide: true,
        autoHeight: true,
        autoHeightMax: 140
    }, (0, _react.jsx)("pre", null, JSON.stringify(content.request, null, 2)))), (0, _react.jsx)("br", null), (0, _react.jsx)(CodeOutputContainerDiv, null, (0, _react.jsx)(CodeOutputDiv, null, "RESPONSE", (0, _react.jsx)(ImgSpan, null, (0, _react.jsx)(CodeOutputImg, {
        src: copyIcon,
        onClick: ()=>copyText(JSON.stringify(content.response, null, 2))
    }), (0, _react.jsx)(CodeOutputImg, {
        src: codeExpandIcon,
        onClick: ()=>showModal("Response", content.response)
    })))), (0, _react.jsx)("br", null), (0, _react.jsx)(CodeDiv, null, (0, _react.jsx)((0, _customScrollbarsDefault.default), {
        autoHide: true,
        autoHeight: true,
        autoHeightMax: 140
    }, (0, _react.jsx)("pre", null, JSON.stringify(content.response, null, 2)))))))), (0, _react.jsx)((0, _codeOutputModalDefault.default), {
        data: modalContent,
        title: modalTitle,
        closeModal: ()=>setShowCodeModal(false),
        showCodeOutputModal: showCodeModal
    }));
};
const KVPValue = /*#__PURE__*/ (0, _baseDefault.default)("p", {
    target: "ew8ihpq22"
})({
    name: "1jwcxx3",
    styles: "font-style:italic"
});
const EmptyIconSpace = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "ew8ihpq21"
})({
    name: "7qtfmv",
    styles: "width:8px"
});
const DisabledLinkOut = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "ew8ihpq20"
})({
    name: "1i6zi2n",
    styles: "img{width:32px;height:32px;}margin-right:16px;margin-left:auto;cursor:default"
});
const CodeDiv = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "ew8ihpq19"
})("max-height:140px;border:1px solid ", (0, _colors.color_shades_dark), ";border-radius:8px;overflow:hidden;");
const CodeOutputContainerDiv = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "ew8ihpq18"
})({
    name: "12dgzor",
    styles: "display:grid;grid-template-columns:auto"
});
const CodeOutputDiv = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "ew8ihpq17"
})({
    name: "1yubawu",
    styles: "grid-row:1/1;display:flex"
});
const CodeOutputImg = /*#__PURE__*/ (0, _baseDefault.default)("img", {
    target: "ew8ihpq16"
})({
    name: "u4qs01",
    styles: "margin-left:8px;height:20px;width:20px;cursor:pointer;vertical-align:middle"
});
const ImgSpan = /*#__PURE__*/ (0, _baseDefault.default)("span", {
    target: "ew8ihpq15"
})({
    name: "68ospr",
    styles: "margin-left:auto;align-items:center;cursor:pointer"
});
const OpenCloseIcon = /*#__PURE__*/ (0, _baseDefault.default)("img", {
    target: "ew8ihpq14"
})({
    name: "k9edgc",
    styles: "width:8px;height:8px;margin-left:8px"
});
const FeatureTypeIcon = /*#__PURE__*/ (0, _baseDefault.default)("img", {
    target: "ew8ihpq13"
})({
    name: "1a4nk1r",
    styles: "height:32px;width:32px;margin-left:16px;margin-right:12px"
});
const LinkOut = /*#__PURE__*/ (0, _baseDefault.default)("a", {
    target: "ew8ihpq12"
})({
    name: "kd5rnk",
    styles: "img{width:32px;height:32px;}margin-right:16px;margin-left:auto;cursor:pointer"
});
const ExpandedDiv = /*#__PURE__*/ (0, _css.css)("width:100%;max-height:656px;border:1px solid ", (0, _colors.color_shades_dark), ";border-radius:8px;background:white;margin-bottom:24px;", "");
const ClosedDiv = /*#__PURE__*/ (0, _css.css)("width:100%;height:56px;border:1px solid ", (0, _colors.color_shades_dark), ";border-radius:8px;background:white;margin-bottom:24px;", "");
const ExpandedContentDiv = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "ew8ihpq11"
})("border:1px solid ", (0, _colors.color_shades_dark), ";border-radius:8px;margin:24px;max-height:552px;");
const ContentDiv = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "ew8ihpq10"
})({
    name: "1u0qmvp",
    styles: "margin:16px"
});
const LabelText = /*#__PURE__*/ (0, _baseDefault.default)("p", {
    target: "ew8ihpq9"
})("font-size:14px;font-weight:400;color:", (0, _colors.color_shades_darker), ";");
const ContentText = /*#__PURE__*/ (0, _baseDefault.default)("p", {
    target: "ew8ihpq8"
})({
    name: "13rx3h2",
    styles: "margin-top:8px;margin-bottom:16px;text-overflow:ellipsis;white-space:nowrap;word-wrap:break-word;overflow:hidden"
});
const SelectedDataDiv = /*#__PURE__*/ (0, _css.css)("border:1px solid ", (0, _colors.color_colors_light_ocean), ";border-radius:8px;background-color:", (0, _colors.color_colors_light_ocean), ";display:flex;cursor:pointer;padding-bottom:2px;", "");
const NonSelectedDataDiv = /*#__PURE__*/ (0, _css.css)({
    name: "x1cs6j",
    styles: "display:flex;cursor:pointer;padding-bottom:2px"
});
const CodeInvestigateDiv = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "ew8ihpq7"
})({
    name: "151d73d",
    styles: "width:50%;margin:8px 4px 8px 8px"
});
const LeftCodeInvestigateDiv = /*#__PURE__*/ (0, _baseDefault.default)(CodeInvestigateDiv, {
    target: "ew8ihpq6"
})({
    name: "1kv40bl",
    styles: "margin:8px 8px 8px 4px"
});
const CustomVerticalSeparator = /*#__PURE__*/ (0, _baseDefault.default)((0, _verticalSeparatorDefault.default), {
    target: "ew8ihpq5"
})({
    name: "q2udce",
    styles: "margin:8px 0px"
});
const InvestigateCodeDiv = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "ew8ihpq4"
})({
    name: "7whenc",
    styles: "display:flex;width:100%"
});
const SlotEntityDiv = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "ew8ihpq3"
})({
    name: "1eijbgb",
    styles: "text-overflow:ellipsis;white-space:nowrap;word-wrap:break-word;overflow:hidden;width:100%;display:flex;flex-direction:row"
});
const InvestigateText = /*#__PURE__*/ (0, _baseDefault.default)("p", {
    target: "ew8ihpq2"
})({
    name: "19tn07a",
    styles: "vertical-align:middle;padding:0px 8px;margin-left:auto;margin-right:auto;margin-top:4px"
});
const InvestigateTextSelected = /*#__PURE__*/ (0, _css.css)("color:", (0, _colors.text_blue), " padding:0px 8px;margin-left:auto;margin-right:auto;vertical-align:middle;margin-top:4px;", "");
const CodeInvestigateIcon = /*#__PURE__*/ (0, _baseDefault.default)("img", {
    target: "ew8ihpq1"
})({
    name: "10zraha",
    styles: "margin-right:8px;vertical-align:middle"
});
const CardHorizontalSeparator = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "ew8ihpq0"
})({
    name: "129gzip",
    styles: "margin-right:24px;margin-left:24px"
});
const containerStyle = /*#__PURE__*/ (0, _css.css)({
    name: "1f6biyf",
    styles: "display:flex;flex-direction:row;align-items:center;height:56px;cursor:pointer;.left{display:flex;width:100%;align-items:center;justify-content:flex-start;p{text-overflow:ellipsis;white-space:nowrap;word-wrap:break-word;overflow:hidden;}}"
});
exports.default = SimulatorConversationHistoryItem;

},{"@emotion/styled/base":"lSuFu","@emotion/react":"djZKr","react":"6uln9","../../../constants/colors":"1p3OR","../../../models/extensions":"7h01B","../../../components/general/TooltipWrapper":"53pWd","../../../components/structure/HorizontalSeparator":"Pw3HQ","../../../components/structure/CustomScrollbars":"50vFq","./CodeOutputModal":"kbywW","@emotion/css":"awUBr","../../../components/structure/VerticalSeparator":"aNNRC","f50d5459394ff0e":"5ttMr","e0361b736a43ba05":"hHecg","6365e275a6546377":"k0hMs","f0e54047dad9bc4d":"5DAAi","141957e08a1e2f24":"57xXb","9fd6562dd6bba14f":"bT0hH","a49cf2018c41caa3":"5k4DO","8b0b57397c469d0f":"hfk0E","86b5dd600a8eeb98":"6HqvT","1ef86fef841db65e":"8Q10p","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hHecg":[function(require,module,exports) {
module.exports = require("2b46479ed3339d95").getBundleURL("kVLro") + require("1365d9cb95dda734").resolve("3yGXq");

},{"2b46479ed3339d95":"c7Tr5","1365d9cb95dda734":"fyJL2"}],"k0hMs":[function(require,module,exports) {
module.exports = require("160175c83b44284c").getBundleURL("kVLro") + require("17b4fc09d6c5413e").resolve("iJtv0");

},{"160175c83b44284c":"c7Tr5","17b4fc09d6c5413e":"fyJL2"}],"5DAAi":[function(require,module,exports) {
module.exports = require("f933ed1e3b501cf2").getBundleURL("kVLro") + require("a920c2b2db4c51c6").resolve("7QA1h");

},{"f933ed1e3b501cf2":"c7Tr5","a920c2b2db4c51c6":"fyJL2"}],"57xXb":[function(require,module,exports) {
module.exports = require("ff4efecc06a136fc").getBundleURL("kVLro") + require("68c199544924e3fa").resolve("kQrvy");

},{"ff4efecc06a136fc":"c7Tr5","68c199544924e3fa":"fyJL2"}],"bT0hH":[function(require,module,exports) {
module.exports = require("97d693147c4e0810").getBundleURL("kVLro") + require("e1b51da6ce225334").resolve("ip7Ae");

},{"97d693147c4e0810":"c7Tr5","e1b51da6ce225334":"fyJL2"}],"5k4DO":[function(require,module,exports) {
module.exports = require("5feca47788fd5fea").getBundleURL("kVLro") + require("76711c3ead1aa2c9").resolve("gXjsv");

},{"5feca47788fd5fea":"c7Tr5","76711c3ead1aa2c9":"fyJL2"}],"hfk0E":[function(require,module,exports) {
module.exports = require("73a0116804f36fa9").getBundleURL("kVLro") + require("af828ce9b90e899a").resolve("jGzwz");

},{"73a0116804f36fa9":"c7Tr5","af828ce9b90e899a":"fyJL2"}],"8Q10p":[function(require,module,exports) {
module.exports = require("7fd7df545f481204").getBundleURL("kVLro") + require("dcea37ef78d4af2a").resolve("cvAXC");

},{"7fd7df545f481204":"c7Tr5","dcea37ef78d4af2a":"fyJL2"}],"guIYn":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _api = require("../api");
var _unstatedNext = require("unstated-next");
function useContentContainer() {
    const [errors, setErrors] = (0, _react.useState)([]);
    const [isLoading, setIsLoading] = (0, _react.useState)(false);
    const getSession = async (applicationId, contentId, filter)=>{
        try {
            setIsLoading(true);
            const result = await _api.getContentItemSessionIds(applicationId, contentId, filter);
            if (result.resultType == "Ok") {
                setIsLoading(false);
                return result.data.sessionIds;
            } else if (result.errors != null && result.errors.length > 0) setErrors([
                ...result.errors
            ]);
            setIsLoading(false);
            return null;
        } catch (error) {
            setIsLoading(false);
            setErrors([
                error
            ]);
            return null;
        }
    };
    return {
        isLoading,
        getSession,
        errors
    };
}
const ContentContainer = (0, _unstatedNext.createContainer)(useContentContainer);
exports.default = ContentContainer;

},{"react":"6uln9","../api":"loxM6","unstated-next":"61zE5","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"lYgo6":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _base = require("@emotion/styled/base");
var _baseDefault = parcelHelpers.interopDefault(_base);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _analyticsEventStreamContainer = require("../../../hooks/AnalyticsEventStreamContainer");
var _analyticsEventStreamContainerDefault = parcelHelpers.interopDefault(_analyticsEventStreamContainer);
var _colors = require("../../../constants/colors");
var _codeOutputModal = require("../../simulator/components/CodeOutputModal");
var _codeOutputModalDefault = parcelHelpers.interopDefault(_codeOutputModal);
var _button = require("../../../components/general/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _analyticsDateFormat = require("../../../models/analytics/AnalyticsDateFormat");
var _moment = require("moment");
var _momentDefault = parcelHelpers.interopDefault(_moment);
var _reactRouterDom = require("react-router-dom");
var _loader = require("../../../components/general/Loader");
var _loaderDefault = parcelHelpers.interopDefault(_loader);
var _sessionReview = require("./SessionReview");
var _sessionReviewDefault = parcelHelpers.interopDefault(_sessionReview);
var _modalLayout = require("../../../components/structure/ModalLayout");
var _modalLayoutDefault = parcelHelpers.interopDefault(_modalLayout);
var _modalHeader = require("../../../components/general/ModalHeader");
var _modalHeaderDefault = parcelHelpers.interopDefault(_modalHeader);
var _footerBar = require("../../../components/structure/FooterBar");
var _footerBarDefault = parcelHelpers.interopDefault(_footerBar);
var _useWindowSize = require("../../../hooks/UseWindowSize");
var _useWindowSizeDefault = parcelHelpers.interopDefault(_useWindowSize);
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const ApplicationLiveSessions = (props)=>{
    const [sessions, setSessions] = (0, _react1.useState)([]);
    const sessionContainer = (0, _analyticsEventStreamContainerDefault.default).useContainer();
    const [expandedSessionIds, setExpandedSessionIds] = (0, _react1.useState)([]);
    const [sessionEventsToReview, setSessionEventsToReview] = (0, _react1.useState)([]);
    const [eventsToShow, setEventsToShow] = (0, _react1.useState)(null);
    const [multiApp, setMultiApp] = (0, _react1.useState)(false);
    const [liveCalls, setLiveCalls] = (0, _react1.useState)([]);
    const sessionsRef = (0, _react1.useRef)([]);
    const windowSize = (0, _useWindowSizeDefault.default)();
    (0, _react1.useEffect)(()=>{
        if (expandedSessionIds.length) {
            const newExpandedSession = sessions.find((s)=>s.sessionId === expandedSessionIds[0]);
            setSessionEventsToReview([
                ...newExpandedSession.events
            ]);
        } else setSessionEventsToReview([]);
    }, [
        expandedSessionIds
    ]);
    (0, _react1.useEffect)(()=>{
        if (expandedSessionIds?.length) {
            const newExpandedSession = sessions.find((s)=>s.sessionId === expandedSessionIds[0]);
            if (newExpandedSession?.events.length !== sessionEventsToReview?.length) setSessionEventsToReview([
                ...newExpandedSession.events
            ]);
        }
    }, [
        sessions
    ]);
    (0, _react1.useEffect)(()=>{
        let ma = false;
        if (sessions?.length) {
            const firstAppId = sessions[0].events[0].applicationId;
            if (firstAppId?.length) ma = sessions.some((s)=>s.events[0]?.applicationId?.length && s.events[0].applicationId !== firstAppId);
        }
        setMultiApp(ma);
    }, [
        sessions
    ]);
    (0, _react1.useEffect)(()=>{
        let newLiveCalls = sessions.filter((s)=>s.live);
        setLiveCalls(newLiveCalls);
    }, [
        sessionContainer.liveSessions
    ]);
    (0, _react1.useEffect)(()=>{
        sessionContainer.connect(props.applicationId);
    }, []);
    const convertEventsForCodeOutputModal = (events)=>{
        var returnObj = {};
        events?.forEach((e, idx)=>{
            returnObj[`${idx}-${e.eventType}`] = e;
        });
        // get last event that is request received
        const lastContentHit = events?.slice()?.reverse()?.find((e)=>e.eventType === "ContentHit");
        if (lastContentHit?.originalRequest?.sessionAttributes) returnObj[`${events.length}-LatestSessionAttributes`] = lastContentHit.originalRequest.sessionAttributes;
        return returnObj;
    };
    const memoizedModal = (0, _react1.useMemo)(()=>(0, _react.jsx)((0, _codeOutputModalDefault.default), {
            title: "JSON",
            closeModal: ()=>setEventsToShow(null),
            data: convertEventsForCodeOutputModal(eventsToShow),
            showCodeOutputModal: eventsToShow
        }), [
        eventsToShow
    ]);
    const CustomSessionReview = ()=>{
        if (!sessionEventsToReview?.length || eventsToShow?.length) return (0, _react.jsx)((0, _reactDefault.default).Fragment, null);
        const e = sessionEventsToReview?.length && sessionEventsToReview[0] ? sessionEventsToReview[0] : null;
        return (0, _react.jsx)("div", {
            onClick: (e)=>{
                e.stopPropagation();
            }
        }, (0, _react.jsx)((0, _modalLayoutDefault.default), {
            isVisible: true
        }, (0, _react.jsx)((0, _modalHeaderDefault.default), {
            title: (0, _momentDefault.default)(e?.eventDate).format((0, _analyticsDateFormat.SESSION_DATE_FORMAT)),
            onClose: ()=>setExpandedSessionIds([])
        }), (0, _react.jsx)((0, _sessionReviewDefault.default), {
            inModal: true,
            manualHeight: windowSize.windowSize.innerHeight * .9 - 168,
            events: sessionEventsToReview ?? [],
            applicationId: props.applicationId,
            setEventsToShow: setEventsToShow,
            application: props.application,
            showConversationCalls: false
        }), (0, _react.jsx)((0, _footerBarDefault.default), null, (0, _react.jsx)((0, _reactRouterDom.Link), {
            to: `/v/apps/${e?.applicationId}/analytics/sessions?sessionId=${expandedSessionIds[0]}`,
            target: "_blank",
            rel: "noopener noreferrer",
            onClick: (e)=>{
                e.stopPropagation();
            }
        }, (0, _react.jsx)((0, _buttonDefault.default), {
            disabled: false,
            themes: [
                "secondary"
            ],
            text: "Go To Session",
            onClick: null,
            type: "button"
        })), (0, _react.jsx)(FooterButton, {
            type: "button",
            themes: [
                "secondary"
            ],
            text: "Close",
            onClick: (e)=>{
                setExpandedSessionIds([]);
                e.stopPropagation();
            }
        }))));
    };
    const memoizedCustomSessionReview = (0, _react1.useMemo)(()=>(0, _react.jsx)(CustomSessionReview, null), [
        sessionEventsToReview,
        eventsToShow
    ]);
    const toggleOnlySession = (sessionId)=>{
        const isExpanded = expandedSessionIds.includes(sessionId);
        if (isExpanded) setExpandedSessionIds(expandedSessionIds.filter((s)=>s !== sessionId));
        else {
            const idx = sessions.findIndex((s)=>s.sessionId === sessionId);
            sessionsRef.current[idx].scrollIntoView({
                behavior: "instant",
                block: "end"
            });
            setExpandedSessionIds([
                sessionId
            ]);
        }
    };
    (0, _react1.useEffect)(()=>{
        if (props.applicationId in sessionContainer.liveSessions) {
            let newSessions = sessionContainer.liveSessions[props.applicationId];
            // sort by date ascending
            newSessions.sort((a, b)=>{
                // compare Date objects on eventDate property
                return new Date(b.eventDate).getTime() - new Date(a.eventDate).getTime();
            });
            newSessions = newSessions.filter((s)=>s.platform !== "session-review");
            setSessions(newSessions);
        }
    }, [
        sessionContainer.liveSessions
    ]);
    const stripSsml = (ssml)=>{
        return ssml.replace(/<[^>]*>/g, "");
    };
    const renderExpandedSession = (session, index)=>{
        return (0, _react.jsx)(Session, {
            key: index,
            ref: (el)=>sessionsRef.current[index] = el
        }, renderSessionHeader(session, false));
    };
    const renderSessionHeader = (session, small)=>{
        let requestEvents = session.events.filter((e)=>e.eventType === "RequestReceived");
        let responseEvents = [];
        if (session.platform?.toLowerCase() === "telephony") responseEvents = session.events.filter((e)=>e.eventType === "AssistantSpeechStarted" || e.eventType === "AssistantSpeechPaused" || e.eventType === "AssistantSpeechEnded");
        else responseEvents = session.events.filter((e)=>e.eventType === "AssistantSpeechStarted" || e.eventType === "AssistantSpeechPaused" || e.eventType === "AssistantSpeechEnded" || e.eventType === "ContentHit");
        // get last by eventDate
        let lastRequest = "";
        let lastResponse = "";
        let lastRequestId = "";
        if (requestEvents?.length) {
            const lastEvent = requestEvents[requestEvents.length - 1];
            if (lastEvent) {
                lastRequest = stripSsml(lastEvent?.utterance ?? "");
                lastRequestId = lastEvent?.requestId ?? "";
            }
        }
        if (responseEvents?.length) {
            const lastEvent = responseEvents[responseEvents.length - 1];
            if (lastEvent.requestId !== lastRequestId) lastResponse = "";
            else if (lastEvent) {
                if (lastEvent?.speechText?.length) lastResponse = stripSsml(lastEvent?.speechText);
                else if (lastEvent?.response?.data?.content?.length) lastResponse = `${stripSsml(lastEvent?.response?.data?.content)}`;
            }
        }
        if (small) return (0, _react.jsx)(SmallSessionHeader, {
            key: session.sessionId,
            className: session.live ? "live" : "",
            onClick: ()=>toggleOnlySession(session.sessionId)
        }, multiApp ? (0, _react.jsx)(SessionHeaderAppName, null, sessionContainer.getAppName(session.events[0].applicationId)) : null, (0, _react.jsx)(SessionHeaderDate, {
            className: "small"
        }, (0, _momentDefault.default)(session.events[0].eventDate).format((0, _analyticsDateFormat.SESSION_DATE_FORMAT))), lastResponse?.length || lastRequest?.length ? (0, _react.jsx)(SmallConvPreview, null, (0, _react.jsx)(SessionHeaderLastRequest, {
            className: "small"
        }, "User: ", lastRequest), (0, _react.jsx)(SessionHeaderLastResponse, {
            className: "small"
        }, "Assistant: ", lastResponse)) : null);
        return (0, _react.jsx)(SessionHeader, {
            className: session.live ? "live" : "",
            onClick: ()=>toggleOnlySession(session.sessionId)
        }, multiApp ? (0, _react.jsx)(SessionHeaderAppName, null, sessionContainer.getAppName(session.events[0].applicationId)) : null, (0, _react.jsx)(SessionHeaderName, null, session.events[0].platform ?? session.events[0].assistant), (0, _react.jsx)(SessionHeaderDate, null, (0, _momentDefault.default)(session.events[0].eventDate).format((0, _analyticsDateFormat.SESSION_DATE_FORMAT))), lastResponse?.length || lastRequest?.length ? (0, _react.jsx)(ConvPreview, null, (0, _react.jsx)(SessionHeaderLastRequest, null, "User: ", lastRequest), (0, _react.jsx)(SessionHeaderLastResponse, null, "Assistant: ", lastResponse)) : null, (0, _react.jsx)(SessionLink, {
            to: `/v/apps/${session.events[0].applicationId}/analytics/sessions?sessionId=${session.sessionId}`,
            target: "_blank",
            rel: "noopener noreferrer",
            onClick: (e)=>{
                e.stopPropagation();
            }
        }, (0, _react.jsx)(SessionLinkButton, {
            disabled: false,
            themes: [
                "secondary-small"
            ],
            text: "Full Session",
            onClick: null,
            type: "button"
        })));
    };
    const renderCollapsedSession = (session, index)=>{
        return (0, _react.jsx)(Session, {
            ref: (el)=>sessionsRef.current[index] = el,
            key: index
        }, renderSessionHeader(session, false));
    };
    if (!sessions?.length) return (0, _react.jsx)((0, _loaderDefault.default), null);
    return (0, _react.jsx)(AllSessionContainer, null, (0, _react.jsx)(LiveCallsContainer, null, liveCalls.length === 0 ? (0, _react.jsx)(CallCount, {
        className: "invisible"
    }, "No live calls") : (0, _react.jsx)(CallCount, {
        className: "live"
    }, "Live calls: ", liveCalls.length), liveCalls.map((session, index)=>{
        return renderSessionHeader(session, true);
    })), (0, _react.jsx)(AllSessions, null, sessions.map((session, index)=>{
        // collapsable sessions
        if (expandedSessionIds.includes(session.sessionId)) return renderExpandedSession(session, index);
        else return renderCollapsedSession(session, index);
    }), memoizedModal, memoizedCustomSessionReview));
};
const Session = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1w0xm9q16"
})({
    name: "17xq7oo",
    styles: "width:95%;margin-right:64px;margin-left:32px"
});
const AllSessionContainer = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1w0xm9q15"
})({
    name: "ulhs4j",
    styles: "margin-bottom:100px;position:relative;display:flex;flex-direction:row"
});
const AllSessions = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1w0xm9q14"
})({
    name: "cqx30m",
    styles: "width:75%"
});
const LiveCallsContainer = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1w0xm9q13"
})({
    name: "1jlgboo",
    styles: "display:flex;flex-direction:column;width:25%;margin-left:32px;margin-top:24px"
});
const SessionHeader = /*#__PURE__*/ (0, _baseDefault.default)("h3", {
    target: "e1w0xm9q12"
})("margin-top:24px;margin-bottom:16px;padding:16px 16px;border:1px solid ", (0, _colors.color_shades_dark), ";cursor:pointer;border-radius:12px 12px 12px 12px;display:flex;flex-direction:row;position:relative;&.live{border:1px solid ", (0, _colors.bluegreen), ";}");
const CallCount = /*#__PURE__*/ (0, _baseDefault.default)("h3", {
    target: "e1w0xm9q11"
})("padding:16px 16px;border:1px solid ", (0, _colors.color_shades_dark), ";cursor:pointer;border-radius:12px 12px 12px 12px;display:flex;flex-direction:row;position:relative;&.live{border:1px solid ", (0, _colors.bluegreen), ";}");
const SmallSessionHeader = /*#__PURE__*/ (0, _baseDefault.default)("h3", {
    target: "e1w0xm9q10"
})("margin-top:24px;margin-bottom:16px;padding:16px 16px;border:1px solid ", (0, _colors.color_shades_dark), ";cursor:pointer;border-radius:12px 12px 12px 12px;display:flex;flex-direction:column;position:relative;&.live{border:1px solid ", (0, _colors.bluegreen), ";}&.invisible{visibility:hidden;}");
const FooterButton = /*#__PURE__*/ (0, _baseDefault.default)((0, _buttonDefault.default), {
    target: "e1w0xm9q9"
})({
    name: "1o3nkn",
    styles: "margin-left:auto"
});
const SessionLinkButton = /*#__PURE__*/ (0, _baseDefault.default)((0, _buttonDefault.default), {
    target: "e1w0xm9q8"
})({
    name: "ti75j2",
    styles: "margin:0"
});
const SessionLink = /*#__PURE__*/ (0, _baseDefault.default)((0, _reactRouterDom.Link), {
    target: "e1w0xm9q7"
})({
    name: "1o3nkn",
    styles: "margin-left:auto"
});
const SessionHeaderName = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1w0xm9q6"
})({
    name: "1k9a154",
    styles: "margin-top:6px;margin-right:8px;min-width:120px;font-weight:bolder"
});
const SessionHeaderLastResponse = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1w0xm9q5"
})({
    name: "1knns1q",
    styles: "margin-top:8px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;margin-left:32px;font-weight:lighter;font-size:12px;&.small{margin-left:4px;}font-weight:bold"
});
const SessionHeaderLastRequest = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1w0xm9q4"
})({
    name: "11548zv",
    styles: "margin-top:0px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;margin-left:32px;font-weight:lighter;font-size:12px;&.small{margin-left:4px;margin-top:8px;}"
});
const ConvPreview = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1w0xm9q3"
})({
    name: "53xy4m",
    styles: "width:30%;display:flex;flex-direction:column"
});
const SmallConvPreview = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1w0xm9q2"
})({
    name: "z4gbbw",
    styles: "width:100%;display:flex;flex-direction:column"
});
const SessionHeaderDate = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1w0xm9q1"
})({
    name: "1se9gmg",
    styles: "margin-top:6px;margin-right:8px;font-weight:lighter;min-width:180px;&.small{margin-top:0px;}"
});
const SessionHeaderAppName = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1w0xm9q0"
})({
    name: "1rb39l9",
    styles: "position:absolute;top:-16px;left:0px;font-weight:lighter;font-size:12px"
});
exports.default = ApplicationLiveSessions;

},{"@emotion/styled/base":"lSuFu","@emotion/react":"djZKr","react":"6uln9","../../../hooks/AnalyticsEventStreamContainer":"6VBs6","../../../constants/colors":"1p3OR","../../simulator/components/CodeOutputModal":"kbywW","../../../components/general/Button":"6ymxN","../../../models/analytics/AnalyticsDateFormat":"ia5MW","moment":"2meyw","react-router-dom":"5fzqq","../../../components/general/Loader":"bnV5T","./SessionReview":"bA5x6","../../../components/structure/ModalLayout":"b1cO3","../../../components/general/ModalHeader":"aUACx","../../../components/structure/FooterBar":"bibRL","../../../hooks/UseWindowSize":"43j9z","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6VBs6":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _unstatedNext = require("unstated-next");
var _generic = require("../api/controllers/generic");
var _api = require("../api");
function useAnalyticsEventStreamContainer() {
    const [sockets, setSockets] = (0, _react.useState)([]);
    const [liveSessions, setLiveSessions] = (0, _react.useState)({});
    const [messages, setMessages] = (0, _react.useState)([]);
    const [appIdToClose, setAppIdToClose] = (0, _react.useState)("");
    const [pollingFlag, setPollingFlag] = (0, _react.useState)(0);
    const [applications, setApplications] = (0, _react.useState)([]);
    const pollRef = (0, _react.useRef)(null);
    (0, _react.useEffect)(()=>{
        const tenMS = 10000;
        pollRef.current = setInterval(()=>{
            // random number 1-maxint
            setPollingFlag(Math.floor(Math.random() * Number.MAX_SAFE_INTEGER));
        }, tenMS);
        return ()=>{
            if (pollRef.current) clearInterval(pollRef.current);
        };
    }, []);
    (0, _react.useEffect)(()=>{
        poll();
    }, [
        pollingFlag
    ]);
    const loadNewApp = async (appId)=>{
        const appResult = await _api.findApplication(appId);
        if (appResult.resultType === "Ok") setApplications([
            ...applications,
            appResult.data
        ]);
        else setApplications([
            ...applications,
            {
                id: appId,
                name: appId
            }
        ]);
    };
    const getAppName = (appId)=>{
        const app = applications.find((a)=>a.id === appId);
        if (!app) loadNewApp(appId);
        return app?.name ?? appId;
    };
    const poll = async ()=>{
        // while socket is open
        for (const { socket } of sockets){
            // if socket is open
            if (socket.readyState !== 1) continue;
            await socket.send("ka");
        }
    };
    (0, _react.useEffect)(()=>{
        if (messages.length) {
            for (const message of messages)handleMessage(message.appId, message.message);
            setMessages([]);
        }
    }, [
        messages
    ]);
    (0, _react.useEffect)(()=>{
        if (appIdToClose?.length) {
            const newSockets = sockets.filter((s)=>s.appId !== appIdToClose);
            setSockets(newSockets);
        }
    }, [
        appIdToClose
    ]);
    const handleMessage = (appId, message)=>{
        if (!message?.data?.length) return;
        const event = JSON.parse(message.data);
        if (!event?.sessionId?.length) return;
        let sessions = [];
        if (appId in liveSessions) sessions = liveSessions[appId];
        let session = sessions.find((s)=>s.sessionId === event.sessionId) ?? {
            sessionId: event.sessionId,
            events: []
        };
        event.timestamp = new Date(event.timestamp).getTime();
        session.events.push(event);
        // sort events by eventDate
        session.events.sort((a, b)=>a.timestamp - b.timestamp);
        const newSessions = {
            ...liveSessions
        };
        // remove old session with that id
        sessions = sessions.filter((s)=>s.sessionId !== event.sessionId);
        sessions.push(session);
        sessions.sort((a, b)=>a.events[0].timestamp - b.events[0].timestamp);
        sessions.forEach((s)=>{
            const callComplete = s.events.find((e)=>e.eventType === "CallComplete");
            const callStarted = s.events.find((e)=>e.eventType === "CallStarted");
            if (callStarted && !callComplete) s.live = true;
            else s.live = false;
            s.eventDate = callStarted?.eventDate?.length ? new Date(callStarted?.eventDate) : new Date(s.events[0].eventDate);
            s.platform = session.events[0].platform ?? session.events[0].assistant;
        });
        newSessions[appId] = sessions;
        setLiveSessions(newSessions);
    };
    const connect = async (appId)=>{
        if (sockets.some((s)=>s.appId === appId)) return;
        const socket = await (0, _generic.connectWebsocket)(`/EventWebSocket/application/${appId}`);
        socket.onmessage = (m)=>setMessages([
                ...messages,
                {
                    appId,
                    message: m
                }
            ]);
        socket.onclose = ()=>setAppIdToClose(appId);
        socket.onerror = ()=>setAppIdToClose(appId);
        let appName = appId;
        const appResult = await _api.findApplication(appId);
        if (appResult.resultType === "Ok") appName = appResult?.data?.name ?? appId;
        const newSockets = [
            ...sockets
        ];
        newSockets.push({
            socket: socket,
            appId: appId
        });
        while(newSockets.length > 4){
            var socketToDrop = newSockets.shift();
            socketToDrop.socket.close();
        }
        setSockets(newSockets);
    };
    return {
        connect,
        liveSessions,
        getAppName
    };
}
const AnalyticsEventStreamContainer = (0, _unstatedNext.createContainer)(useAnalyticsEventStreamContainer);
exports.default = AnalyticsEventStreamContainer;

},{"react":"6uln9","unstated-next":"61zE5","../api/controllers/generic":"6oGDt","../api":"loxM6","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"iuHaP":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _secondaryLoader = require("../../../components/general/SecondaryLoader");
var _secondaryLoaderDefault = parcelHelpers.interopDefault(_secondaryLoader);
var _css = require("@emotion/css");
var _contentNode = require("../../../components/analytics/tracking/ContentNode");
var _contentNodeDefault = parcelHelpers.interopDefault(_contentNode);
var _sessionStartNode = require("../../../components/analytics/tracking/SessionStartNode");
var _sessionStartNodeDefault = parcelHelpers.interopDefault(_sessionStartNode);
var _sessionEndNode = require("../../../components/analytics/tracking/SessionEndNode");
var _sessionEndNodeDefault = parcelHelpers.interopDefault(_sessionEndNode);
var _colors = require("../../../constants/colors");
var _stylesValues = require("../../../constants/stylesValues");
var _customScrollbars = require("../../../components/structure/CustomScrollbars");
var _customScrollbarsDefault = parcelHelpers.interopDefault(_customScrollbars);
var _downTreePaths = require("../../../components/analytics/tracking/DownTreePaths");
var _downTreePathsDefault = parcelHelpers.interopDefault(_downTreePaths);
var _treeRowPager = require("../../../components/analytics/TreeRowPager");
var _treeRowPagerDefault = parcelHelpers.interopDefault(_treeRowPager);
var _lodash = require("lodash");
var _lodashDefault = parcelHelpers.interopDefault(_lodash);
var _conversationScript = require("../../conversationScript");
var _conversationScriptDefault = parcelHelpers.interopDefault(_conversationScript);
var _analyticsEmptyView = require("../../../components/analytics/AnalyticsEmptyView");
var _analyticsEmptyViewDefault = parcelHelpers.interopDefault(_analyticsEmptyView);
class ApplicationTrackingPage extends (0, _reactDefault.default).Component {
    constructor(props){
        super(props);
        this.state = {
            selectedNodes: [],
            positionOffsets: []
        };
    }
    componentDidMount() {
        this.reloadData();
    }
    componentDidUpdate(previousProps) {
        if (JSON.stringify(previousProps.filter) != JSON.stringify(this.props.filter)) this.reloadData();
    }
    async reloadData() {
        const result = await this.props.trackingContainer.loadTree(this.props.applicationId, this.props.filter);
        if (result?.resultType == "Ok") await this.props.trackingContainer.loadChildNodeDetails(this.props.applicationId, this.props.filter, result.data);
        const tree = this.props.trackingContainer.findTree(this.props.applicationId, this.props.filter);
        if (tree?.data?.childNodes?.length > 3) {
            // check to see if we should set an offset
            // if we have 4 or more, then set the default to far left
            let levelOffset = this.state.positionOffsets.find((l)=>l.level == 0);
            const index = this.state.positionOffsets.indexOf(levelOffset);
            if (levelOffset) {
                levelOffset.offset = -(tree.data.childNodes.length / 2) + 2;
                this.state.positionOffsets[index] = levelOffset;
            } else {
                levelOffset = {
                    level: 0,
                    offset: -(tree.data.childNodes.length / 2) + 2
                };
                this.state.positionOffsets.push(levelOffset);
            }
        }
        this.setState({
            ...this.state,
            selectedNodes: [],
            positionOffsets: this.state.positionOffsets
        });
    }
    handleContentNodeClick(node, level) {
        let { selectedNodes, positionOffsets } = this.state;
        if (selectedNodes[level]?.contentId == node.contentId) selectedNodes = selectedNodes.slice(0, level);
        else {
            selectedNodes = selectedNodes.slice(0, level);
            selectedNodes[level] = node;
            if (node.childNodes?.length > 3) {
                // check to see if we should set an offset
                // if we have 4 or more, then set the default to far left
                let levelOffset = positionOffsets.find((l)=>l.level == level + 1);
                const index = positionOffsets.indexOf(levelOffset);
                if (levelOffset) {
                    levelOffset.offset = -(node.childNodes.length / 2) + 2;
                    positionOffsets[index] = levelOffset;
                } else {
                    levelOffset = {
                        level: level + 1,
                        offset: -(node.childNodes.length / 2) + 2
                    };
                    positionOffsets.push(levelOffset);
                }
            }
        }
        this.setState({
            ...this.state,
            selectedNodes,
            positionOffsets
        });
        this.props.trackingContainer.loadChildNodeDetails(this.props.applicationId, this.props.filter, node);
    }
    handleEndNodeClick(level, node) {
        var selectedNodes = this.state.selectedNodes;
        if (selectedNodes[level]?.conversationTrackingNodeType == "SessionEnd") selectedNodes = selectedNodes.slice(0, level);
        else selectedNodes[level] = node;
        this.setState({
            ...this.state,
            selectedNodes
        });
    }
    handleStartNodeClick() {
        this.setState({
            ...this.state,
            selectedNodes: []
        });
    }
    handlePage(level, increment, nodeLength) {
        const positionOffsets = this.state.positionOffsets;
        let levelOffset = positionOffsets.find((l)=>l.level == level);
        const index = positionOffsets.indexOf(levelOffset);
        if (!levelOffset) levelOffset = {
            level,
            offset: 0
        };
        else {
            // limit it so the last node ends in the middle
            if (increment && levelOffset.offset > nodeLength / 2 - 1) return;
            if (!increment && levelOffset.offset < -(nodeLength / 2 - 1)) return;
        }
        if (increment) levelOffset.offset++;
        else levelOffset.offset--;
        if (index > -1) positionOffsets[index] = levelOffset;
        else positionOffsets.push(levelOffset);
        this.setState({
            ...this.state,
            positionOffsets
        });
    }
    renderRow(nodes, conversationItems, level, prevIndex, prevLength) {
        if (!nodes || nodes.length == 0) return null;
        const selectedNodes = this.state.selectedNodes;
        const selectedNode = nodes.find((n)=>n.conversationTrackingNodeType == "Content" && selectedNodes[level]?.contentId == n.contentId || n.conversationTrackingNodeType == "SessionEnd" && selectedNodes[level]?.conversationTrackingNodeType == "SessionEnd");
        const totalSessions = nodes.map((n)=>n.sessionIds?.length ?? 0).reduce((a, b)=>a + b);
        const nodeOffset = this.state.positionOffsets.find((o)=>o.level == level)?.offset ?? 0;
        const prevNodeOffset = this.state.positionOffsets.find((o)=>o.level == level - 1)?.offset ?? 0;
        const treeRowOffset = /*#__PURE__*/ (0, _css.css)("margin-right:", nodeOffset * 288, "px;", "");
        return (0, _react.jsx)((0, _reactDefault.default).Fragment, null, (0, _react.jsx)((0, _downTreePathsDefault.default), {
            prevIndex: prevIndex,
            prevLength: prevLength,
            activeIndex: nodes.indexOf(selectedNode),
            nodes: nodes,
            nodeOffset: nodeOffset,
            prevNodeOffset: prevNodeOffset
        }), (0, _react.jsx)("div", {
            className: "row-separator"
        }, (0, _react.jsx)("div", {
            className: "row-separator-body"
        })), (0, _react.jsx)("div", {
            className: "pager"
        }, (0, _react.jsx)("div", {
            className: "pager-body"
        }, (0, _react.jsx)((0, _treeRowPagerDefault.default), {
            onRight: ()=>this.handlePage(level, true, nodes.length),
            onLeft: ()=>this.handlePage(level, false, nodes.length),
            canMoveLeft: nodeOffset > -(nodes.length / 2 - 1),
            canMoveRight: nodeOffset <= nodes.length / 2 - 1
        }), (0, _react.jsx)("p", {
            className: "pager-label"
        }, selectedNode ? `${nodes.indexOf(selectedNode) + 1} of ` : "-- of ", " ", nodes.length.toString(), " items"))), (0, _react.jsx)("div", {
            className: `tree-row ${treeRowOffset}`
        }, nodes?.map((n, i)=>{
            if (n.conversationTrackingNodeType == "Content") {
                const contentNode = n;
                const selected = selectedNodes[level]?.contentId == contentNode.contentId;
                return (0, _react.jsx)((0, _contentNodeDefault.default), {
                    id: contentNode.contentId + level,
                    key: i,
                    nodeData: contentNode,
                    percentage: n.sessionIds.length / totalSessions,
                    number: n.sessionIds.length,
                    conversationItem: conversationItems.find((c)=>c.id == contentNode.contentId),
                    selected: selected,
                    childSelected: selectedNodes[level + 1] != null,
                    active: selected || selectedNodes[level] == null,
                    isLoadingDetails: this.props.trackingContainer.state.isLoadingDetails,
                    onClick: ()=>this.handleContentNodeClick(contentNode, level)
                });
            }
            if (n.conversationTrackingNodeType == "SessionEnd") return (0, _react.jsx)((0, _sessionEndNodeDefault.default), {
                key: i,
                number: n.sessionIds.length,
                selected: selectedNodes[level]?.conversationTrackingNodeType == "SessionEnd",
                percentage: n.sessionIds.length / totalSessions,
                active: selectedNodes[level]?.conversationTrackingNodeType == "SessionEnd" || selectedNodes[level] == null,
                onClick: ()=>this.handleEndNodeClick(level, n)
            });
        })), selectedNode != null && selectedNode.conversationTrackingNodeType == "Content" && this.renderRow((0, _lodashDefault.default).sortBy(selectedNode.childNodes, (n)=>n.sessionIds?.length ?? 0).reverse(), conversationItems, level + 1, nodes.indexOf(selectedNode), nodes.length));
    }
    render() {
        const { trackingContainer } = this.props;
        const tree = trackingContainer.findTree(this.props.applicationId, this.props.filter);
        if (trackingContainer.state.isLoading || !tree) return (0, _react.jsx)("div", {
            className: loaderContainer
        }, (0, _react.jsx)((0, _secondaryLoaderDefault.default), null));
        return (0, _react.jsx)("div", {
            className: wrapperStyle
        }, (0, _react.jsx)((0, _customScrollbarsDefault.default), null, tree.data?.childNodes?.length > 0 ? (0, _react.jsx)("div", {
            className: "tree-container"
        }, (0, _react.jsx)("div", {
            className: "tree-row"
        }, (0, _react.jsx)((0, _sessionStartNodeDefault.default), {
            selected: this.state.selectedNodes.length > 0,
            onClick: this.handleStartNodeClick.bind(this),
            active: true
        })), this.renderRow((0, _lodashDefault.default).sortBy(tree.data.childNodes, (n)=>n.sessionIds?.length ?? 0).reverse(), tree.conversationItems, 0, 0, 1)) : (0, _react.jsx)((0, _analyticsEmptyViewDefault.default), null)), !this.props.isSpark ? (0, _react.jsx)("div", {
            className: "conversation-preview-container"
        }, (0, _react.jsx)((0, _customScrollbarsDefault.default), null, (0, _react.jsx)((0, _conversationScriptDefault.default), {
            nodes: this.state.selectedNodes ?? [],
            applicationId: this.props.applicationId,
            hasStart: true
        }))) : "");
    }
}
const loaderContainer = /*#__PURE__*/ (0, _css.css)("display:flex;flex:1;align-items:center;justify-content:center;width:100%;margin:64px 0;.spinner>div{background:", (0, _colors.color_colors_ocean), ";}", "");
const wrapperStyle = /*#__PURE__*/ (0, _css.css)("display:flex;height:100%;background:white;.tree-container{display:flex;flex-direction:column;align-items:center;padding:64px 0;overflow-x:hidden;margin-bottom:64px;}.tree-row{display:flex;align-items:center;justify-content:center;}.row-separator{position:relative;width:100%;.row-separator-body{height:1px;bottom:80px;left:0;right:0;position:absolute;border-top:", (0, _stylesValues.style_border_default), ";}}.pager{position:relative;width:100%;z-index:6;.pager-body{bottom:52px;right:32;position:absolute;display:flex;flex-direction:column;align-items:flex-end;.pager-label{color:", (0, _colors.color_text_light), ";font-size:10px;line-height:16px;text-align:right;background:white;}}}.conversation-preview-container{background:", (0, _colors.color_shades_lighter), ";min-width:576px;height:100%;border-left:", (0, _stylesValues.style_border_default), ";}", "");
exports.default = ApplicationTrackingPage;

},{"@emotion/react":"djZKr","react":"6uln9","../../../components/general/SecondaryLoader":"7zJiF","@emotion/css":"awUBr","../../../components/analytics/tracking/ContentNode":"1GmZZ","../../../components/analytics/tracking/SessionStartNode":"5EUlV","../../../components/analytics/tracking/SessionEndNode":"8f380","../../../constants/colors":"1p3OR","../../../constants/stylesValues":"dHVVv","../../../components/structure/CustomScrollbars":"50vFq","../../../components/analytics/tracking/DownTreePaths":"3kOiR","../../../components/analytics/TreeRowPager":"8fXD2","lodash":"3hMBK","../../conversationScript":"2y8Bz","../../../components/analytics/AnalyticsEmptyView":"fSMut","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3D0cv":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _base = require("@emotion/styled/base");
var _baseDefault = parcelHelpers.interopDefault(_base);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _colors = require("../../../constants/colors");
var _reviewUserContainer = require("../../../hooks/ReviewUserContainer");
var _reviewUserContainerDefault = parcelHelpers.interopDefault(_reviewUserContainer);
var _textField = require("../../../components/forms/TextField");
var _textFieldDefault = parcelHelpers.interopDefault(_textField);
var _button = require("../../../components/general/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _pageError = require("../../../components/general/PageError");
var _pageErrorDefault = parcelHelpers.interopDefault(_pageError);
var _urls = require("../../../constants/Urls");
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const ReviewUserManagement = (props)=>{
    const reviewUserContainer = (0, _reviewUserContainerDefault.default).useContainer();
    const [password, setPassword] = (0, _reactDefault.default).useState("");
    (0, _react1.useEffect)(()=>{
        reviewUserContainer.loadApp(props.appId);
    }, []);
    const buildLink = ()=>{
        const userKey = reviewUserContainer.member?.email.split("@")[0];
        const link = `${(0, _urls.getSparkBaseUrl)()}/review/${props.appId}?key=${userKey}`;
        return link;
    };
    return (0, _react.jsx)(CenterTopDiv, null, (0, _react.jsx)(ContentContainer, null, (0, _react.jsx)((0, _textFieldDefault.default), {
        disabled: reviewUserContainer.loading,
        useForm: false,
        value: password,
        onChange: (e)=>setPassword(e.target.value),
        label: "Password. This password will be used to access newly created links. Once you navigate away, you will not be able to see this password again.",
        placeholder: "Enter a password for the new link here. If you create a new link, the old one will stop working."
    }), reviewUserContainer.member?.email ? buildLink() : "No link yet", (0, _react.jsx)(ButtonRow, null, (0, _react.jsx)((0, _buttonDefault.default), {
        disabled: !reviewUserContainer.member?.email?.length,
        loading: reviewUserContainer.loading,
        text: "Copy existing link",
        onClick: async ()=>{
            const link = buildLink();
            await navigator.clipboard.writeText(link);
        },
        themes: [
            "primary"
        ]
    }), (0, _react.jsx)((0, _buttonDefault.default), {
        loading: reviewUserContainer.loading,
        text: "Create new link with password",
        onClick: async ()=>{
            await reviewUserContainer.createNewReviewUser(props.appId, password);
            await reviewUserContainer.loadApp(props.appId);
            setPassword("");
        },
        themes: [
            "primary"
        ]
    })), (0, _react.jsx)(Label, null, (0, _react.jsx)("a", {
        href: "https://www.loom.com/share/cbec1503d3f542d39198519ca8417eec?sid=42a2385b-a355-4bb9-bc40-d45abbdc37bb",
        target: "_blank"
    }, "Click here to learn more about this feature.")), (0, _react.jsx)(StyledPageError, {
        errors: reviewUserContainer?.error?.length ? [
            reviewUserContainer.error
        ] : [],
        onClear: ()=>reviewUserContainer.setError("")
    })));
};
const Label = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e18spbzr4"
})("font-weight:400;font-size:20px;color:", (0, _colors.color_text_default), ";margin-left:16px;margin-bottom:8px;a{color:", (0, _colors.color_text_link), ";}");
const ButtonRow = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e18spbzr3"
})({
    name: "ho1qnd",
    styles: "display:flex;flex-direction:row"
});
const ContentContainer = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e18spbzr2"
})({
    name: "121z217",
    styles: "width:40%"
});
const CenterTopDiv = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e18spbzr1"
})({
    name: "9fr6b9",
    styles: "display:flex;flex-direction:row;justify-content:center;width:100%;margin-top:32px"
});
const StyledPageError = /*#__PURE__*/ (0, _baseDefault.default)((0, _pageErrorDefault.default), {
    target: "e18spbzr0"
})({
    name: "1pkyfyy",
    styles: "bottom:100px"
});
exports.default = ReviewUserManagement;

},{"@emotion/styled/base":"lSuFu","@emotion/react":"djZKr","react":"6uln9","../../../constants/colors":"1p3OR","../../../hooks/ReviewUserContainer":"hbyu4","../../../components/forms/TextField":"7a7bh","../../../components/general/Button":"6ymxN","../../../components/general/PageError":"ezFTm","../../../constants/Urls":"iTopY","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hbyu4":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _unstatedNext = require("unstated-next");
var _api = require("../api");
function useReviewUserContainer() {
    const [error, setError] = (0, _react.useState)("");
    const [loading, setLoading] = (0, _react.useState)(false);
    const [member, setMember] = (0, _react.useState)({});
    const loadApp = async (appId)=>{
        setLoading(true);
        const result = await _api.getApplicationMembers(appId);
        if (result.resultType !== "Ok") {
            setError(result.errors[0]);
            setLoading(false);
            return;
        } else {
            var reviewUser = result.data.find((m)=>m.organizationMember.email.endsWith("@review-user.com"));
            if (reviewUser?.organizationMember?.email?.length) setMember(reviewUser.organizationMember);
            setLoading(false);
        }
    };
    const createNewReviewUser = async (appId, password)=>{
        setLoading(true);
        const result = await _api.refreshReviewUser({
            applicationId: appId,
            password: password
        });
        if (result.resultType !== "Ok") {
            setError(result.errors[0]);
            setLoading(false);
            return;
        }
        setLoading(false);
    };
    return {
        error,
        setError,
        loading,
        setLoading,
        member,
        loadApp,
        createNewReviewUser
    };
}
const ReviewUserContainer = (0, _unstatedNext.createContainer)(useReviewUserContainer);
exports.default = ReviewUserContainer;

},{"react":"6uln9","unstated-next":"61zE5","../api":"loxM6","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"g1mCv":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _defineProperty = require("@babel/runtime/helpers/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _api = require("../../api");
var _genericMeasurementsContainer = require("./GenericMeasurementsContainer");
var _genericMeasurementsContainerDefault = parcelHelpers.interopDefault(_genericMeasurementsContainer);
class ApplicationUserAnalyticsContainer extends (0, _genericMeasurementsContainerDefault.default) {
    constructor(){
        super();
        (0, _definePropertyDefault.default)(this, "breakdownOptions", [
            "By Platform",
            "By Interface",
            "By Device Type",
            "By Language",
            "By Interaction Type"
        ]);
        (0, _definePropertyDefault.default)(this, "displayOptions", [
            "Total Users",
            "New Users",
            "Total Users & New Users"
        ]);
        (0, _definePropertyDefault.default)(this, "getContextId", (scope)=>scope.applicationId);
        (0, _definePropertyDefault.default)(this, "getPrimaryHistogramPromise", (scope, interval, filter)=>_api.getUserHistogramForApplication(scope.applicationId, interval, filter));
        (0, _definePropertyDefault.default)(this, "getSecondaryHistogramPromise", (scope, interval, filter)=>_api.getNewUserHistogramForApplication(scope.applicationId, interval, filter));
        (0, _definePropertyDefault.default)(this, "getAverages", async (scope, filter)=>{
            const output = [];
            const previousDates = this.getPreviousDates(filter.startDate, filter.endDate);
            var usersHistogram = this.state.primaryHistogramData?.find((h)=>this.buildHistogramKey(h) == this.buildCacheKey(scope.applicationId, filter));
            var secondaryHistogram = this.state.secondaryHistogramData?.find((h)=>this.buildHistogramKey(h) == this.buildCacheKey(scope.applicationId, filter));
            var previousUsersHistogram = this.state.primaryHistogramData?.find((h)=>this.buildHistogramKey(h) == this.buildCacheKey(scope.applicationId, {
                    ...filter,
                    startDate: previousDates.startDate,
                    endDate: previousDates.endDate
                }));
            var previousSecondaryHistogram = this.state.secondaryHistogramData?.find((h)=>this.buildHistogramKey(h) == this.buildCacheKey(scope.applicationId, {
                    ...filter,
                    startDate: previousDates.startDate,
                    endDate: previousDates.endDate
                }));
            var numberOfDays = this.getDaysBetween(filter.startDate, filter.endDate);
            var numberOfOcurredDays = this.getDaysBetween(filter.startDate, filter.endDate, true);
            if (usersHistogram?.data && previousUsersHistogram != null) {
                const total = usersHistogram.data?.map((h)=>h.count)?.reduce((a, b)=>a + b);
                const prevTotal = previousUsersHistogram?.data?.map((h)=>h.count)?.reduce((a, b)=>a + b);
                const value = (total ?? 0) / (numberOfOcurredDays ?? 1);
                const prevValue = (prevTotal ?? 0) / (numberOfDays ?? 1);
                const deltaValue = (value ?? 0) - (prevValue ?? 0);
                output.push({
                    title: "users per day",
                    value: value !== Math.round(value) ? value.toFixed(2) : value,
                    deltaPercentage: deltaValue / (value > 0 ? value : 1) * 100,
                    deltaValue: deltaValue !== Math.round(deltaValue) ? deltaValue.toFixed(2) : deltaValue
                });
            }
            if (secondaryHistogram?.data && previousSecondaryHistogram != null) {
                const total = secondaryHistogram.data?.length > 0 ? secondaryHistogram.data.map((h)=>h.count)?.reduce((a, b)=>a + b) : 0;
                const prevTotal = previousSecondaryHistogram?.data?.length > 0 ? previousSecondaryHistogram?.data?.map((h)=>h.count)?.reduce((a, b)=>a + b) : 0;
                const value = (total ?? 0) / (numberOfOcurredDays ?? 1);
                const prevValue = (prevTotal ?? 0) / (numberOfDays ?? 1);
                const deltaValue = (value ?? 0) - (prevValue ?? 0);
                output.push({
                    title: "new users per day",
                    value: value !== Math.round(value) ? value.toFixed(2) : value,
                    deltaPercentage: deltaValue / (value > 0 ? value : 1) * 100,
                    deltaValue: deltaValue !== Math.round(deltaValue) ? deltaValue.toFixed(2) : deltaValue
                });
            }
            const averages = this.state.averages ?? [];
            averages.push({
                id: scope.applicationId,
                filter: {
                    ...filter
                },
                items: output
            });
            this.setState({
                ...this.state,
                averages
            });
            return {
                resultType: "Ok",
                errors: [],
                data: output
            };
        });
        (0, _definePropertyDefault.default)(this, "getPrimaryBreakdownPromise", async (scope, filter, breakdownType)=>{
            const breakdownData = {
                resultType: "Ok",
                data: [],
                errors: []
            };
            var aggregateData;
            switch(breakdownType){
                case "By Platform":
                    aggregateData = await _api.getUserAggregateByAssistant(scope.applicationId, filter);
                    if (aggregateData.resultType != "Ok") return aggregateData;
                    breakdownData.data = aggregateData.data.map((a, i, agg)=>({
                            label: a.key,
                            iconRender: ()=>this.getPlatformImage(a.key),
                            count: a.count,
                            percentage: this.getPercentage(a.count, agg)
                        }));
                    break;
                case "By Interface":
                    aggregateData = await _api.getUserAggregateByInterfaceType(scope.applicationId, filter);
                    if (aggregateData.resultType != "Ok") return aggregateData;
                    breakdownData.data = aggregateData.data.map((a, i, agg)=>({
                            label: a.key,
                            iconRender: ()=>this.getDeviceCapabilityImage(a.key),
                            count: a.count,
                            percentage: this.getPercentage(a.count, agg)
                        }));
                    break;
                case "By Device Type":
                    aggregateData = await _api.getUserAggregateByDeviceTarget(scope.applicationId, filter);
                    if (aggregateData.resultType != "Ok") return aggregateData;
                    breakdownData.data = aggregateData.data.map((a, i, agg)=>({
                            label: this.findDeviceType(a.key)?.displayName ?? "Unknown",
                            iconRender: ()=>this.getDeviceTypeImage(a.key),
                            count: a.count,
                            percentage: this.getPercentage(a.count, agg)
                        }));
                    break;
                case "By Language":
                    aggregateData = await _api.getUserAggregateByLanguage(scope.applicationId, filter);
                    if (aggregateData.resultType != "Ok") return aggregateData;
                    breakdownData.data = aggregateData.data.map((a, i, agg)=>({
                            label: this.getLanguageTitle(a.key),
                            iconRender: ()=>this.getLanguageImage(a.key),
                            count: a.count,
                            percentage: this.getPercentage(a.count, agg)
                        }));
                    break;
                case "By Interaction Type":
                    aggregateData = await _api.getUserAggregateByFeatureType(scope.applicationId, filter);
                    if (aggregateData.resultType != "Ok") return aggregateData;
                    breakdownData.data = aggregateData.data.map((a, i, agg)=>({
                            label: this.findFeatureType(a.key)?.name ?? "Unknown",
                            iconRender: ()=>this.getFeatureTypeImage(a.key),
                            count: a.count,
                            percentage: this.getPercentage(a.count, agg)
                        }));
                    break;
            }
            return breakdownData;
        });
        (0, _definePropertyDefault.default)(this, "getSecondaryBreakdownPromise", async (scope, filter, breakdownType)=>{
            const breakdownData = {
                resultType: "Ok",
                data: [],
                errors: []
            };
            var aggregateData;
            switch(breakdownType){
                case "By Platform":
                    aggregateData = await _api.getNewUserAggregateByAssistant(scope.applicationId, filter);
                    if (aggregateData.resultType != "Ok") return aggregateData;
                    breakdownData.data = aggregateData.data.map((a, i, agg)=>({
                            label: a.key,
                            iconRender: ()=>this.getPlatformImage(a.key),
                            count: a.count,
                            percentage: this.getPercentage(a.count, agg)
                        }));
                    break;
                case "By Interface":
                    aggregateData = await _api.getNewUserAggregateByInterfaceType(scope.applicationId, filter);
                    if (aggregateData.resultType != "Ok") return aggregateData;
                    breakdownData.data = aggregateData.data.map((a, i, agg)=>({
                            label: a.key,
                            iconRender: ()=>this.getDeviceCapabilityImage(a.key),
                            count: a.count,
                            percentage: this.getPercentage(a.count, agg)
                        }));
                    break;
                case "By Device Type":
                    aggregateData = await _api.getNewUserAggregateByDeviceTarget(scope.applicationId, filter);
                    if (aggregateData.resultType != "Ok") return aggregateData;
                    breakdownData.data = aggregateData.data.map((a, i, agg)=>({
                            label: this.findDeviceType(a.key)?.displayName ?? "Unknown",
                            iconRender: ()=>this.getDeviceTypeImage(a.key),
                            count: a.count,
                            percentage: this.getPercentage(a.count, agg)
                        }));
                    break;
                case "By Language":
                    aggregateData = await _api.getNewUserAggregateByLanguage(scope.applicationId, filter);
                    if (aggregateData.resultType != "Ok") return aggregateData;
                    breakdownData.data = aggregateData.data.map((a, i, agg)=>({
                            label: a.key,
                            iconRender: ()=>this.getLanguageImage(a.key),
                            count: a.count,
                            percentage: this.getPercentage(a.count, agg)
                        }));
                    break;
                case "By Interaction Type":
                    aggregateData = await _api.getNewUserAggregateByFeatureType(scope.applicationId, filter);
                    if (aggregateData.resultType != "Ok") return aggregateData;
                    breakdownData.data = aggregateData.data.map((a, i, agg)=>({
                            label: this.findFeatureType(a.key)?.name ?? "Unknown",
                            iconRender: ()=>this.getFeatureTypeImage(a.key),
                            count: a.count,
                            percentage: this.getPercentage(a.count, agg)
                        }));
                    break;
            }
            return breakdownData;
        });
        this.state = {
            isLoadingHistogram: false,
            isLoadingBreakdown: false,
            currentBreakdown: this.breakdownOptions[0],
            currentDisplayOption: this.displayOptions[0],
            currentDeltaPeriod: "Previous Period",
            currentDeltaType: "Value"
        };
    }
}
exports.default = ApplicationUserAnalyticsContainer;

},{"@babel/runtime/helpers/defineProperty":"9sJxO","../../api":"loxM6","./GenericMeasurementsContainer":"gjwAK","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"d0mPh":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _defineProperty = require("@babel/runtime/helpers/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _api = require("../../api");
var _genericMeasurementsContainer = require("./GenericMeasurementsContainer");
var _genericMeasurementsContainerDefault = parcelHelpers.interopDefault(_genericMeasurementsContainer);
class ApplicationInteractionAnalyticsContainer extends (0, _genericMeasurementsContainerDefault.default) {
    constructor(){
        super();
        (0, _definePropertyDefault.default)(this, "breakdownOptions", [
            "By Platform",
            "By Interface",
            "By Device Type",
            "By Language",
            "By Interaction Type"
        ]);
        (0, _definePropertyDefault.default)(this, "displayOptions", [
            "Interactions",
            "Sessions",
            "Interactions & Sessions"
        ]);
        (0, _definePropertyDefault.default)(this, "getContextId", (scope)=>scope.applicationId);
        (0, _definePropertyDefault.default)(this, "getPrimaryHistogramPromise", (scope, interval, filter)=>_api.getUsageHistogramForApplication(scope.applicationId, interval, filter));
        (0, _definePropertyDefault.default)(this, "getSecondaryHistogramPromise", (scope, interval, filter)=>_api.getSessionHistogramForApplication(scope.applicationId, interval, filter));
        (0, _definePropertyDefault.default)(this, "getAverages", async (scope, filter)=>{
            const output = [];
            const previousDates = this.getPreviousDates(filter.startDate, filter.endDate);
            var primaryHistogram = this.state.primaryHistogramData?.find((h)=>this.buildHistogramKey(h) == this.buildCacheKey(scope.applicationId, filter));
            var secondaryHistogram = this.state.secondaryHistogramData?.find((h)=>this.buildHistogramKey(h) == this.buildCacheKey(scope.applicationId, filter));
            var previousPrimaryHistogram = this.state.primaryHistogramData?.find((h)=>this.buildHistogramKey(h) == this.buildCacheKey(scope.applicationId, {
                    ...filter,
                    startDate: previousDates.startDate,
                    endDate: previousDates.endDate
                }));
            var previousSecondaryHistogram = this.state.secondaryHistogramData?.find((h)=>this.buildHistogramKey(h) == this.buildCacheKey(scope.applicationId, {
                    ...filter,
                    startDate: previousDates.startDate,
                    endDate: previousDates.endDate
                }));
            var numberOfDays = this.getDaysBetween(filter.startDate, filter.endDate);
            var numberOfOcurredDays = this.getDaysBetween(filter.startDate, filter.endDate, true);
            if (primaryHistogram != null && previousPrimaryHistogram != null) {
                const total = primaryHistogram?.data?.map((h)=>h.count)?.reduce((a, b)=>a + b);
                const prevTotal = previousPrimaryHistogram?.data?.map((h)=>h.count)?.reduce((a, b)=>a + b);
                const value = (total ?? 0) / (numberOfOcurredDays ?? 1);
                const prevValue = (prevTotal ?? 0) / (numberOfDays ?? 1);
                const deltaValue = (value ?? 0) - (prevValue ?? 0);
                output.push({
                    title: "interactions per day",
                    value: value !== Math.round(value) ? value.toFixed(2) : value,
                    deltaPercentage: deltaValue / (value > 0 ? value : 1) * 100,
                    deltaValue: deltaValue !== Math.round(deltaValue) ? deltaValue.toFixed(2) : deltaValue
                });
            }
            if (secondaryHistogram != null && previousSecondaryHistogram != null) {
                const total = secondaryHistogram.data?.map((h)=>h.count)?.reduce((a, b)=>a + b);
                const prevTotal = previousSecondaryHistogram?.data?.map((h)=>h.count)?.reduce((a, b)=>a + b);
                const value = (total ?? 0) / (numberOfOcurredDays ?? 1);
                const prevValue = (prevTotal ?? 0) / (numberOfDays ?? 1);
                const deltaValue = (value ?? 0) - (prevValue ?? 0);
                output.push({
                    title: "sessions per day",
                    value: value !== Math.round(value) ? value.toFixed(2) : value,
                    deltaPercentage: deltaValue / (value > 0 ? value : 1) * 100,
                    deltaValue: deltaValue !== Math.round(deltaValue) ? deltaValue.toFixed(2) : deltaValue
                });
            }
            if (primaryHistogram != null && previousPrimaryHistogram != null && secondaryHistogram != null && previousSecondaryHistogram != null) {
                var interactions = primaryHistogram.data?.map((h)=>h.count)?.reduce((a, b)=>a + b);
                var sessions = secondaryHistogram.data?.map((h)=>h.count)?.reduce((a, b)=>a + b);
                var prevInteractions = previousPrimaryHistogram?.data?.map((h)=>h.count)?.reduce((a, b)=>a + b);
                var prevSessions = previousSecondaryHistogram?.data?.map((h)=>h.count)?.reduce((a, b)=>a + b);
                const value = (interactions ?? 0) / (sessions > 0 ? sessions : 1);
                const prevValue = (prevInteractions ?? 0) / (prevSessions > 0 ? prevSessions : 1);
                const deltaValue = (value ?? 0) - (prevValue ?? 0);
                output.push({
                    title: "interactions per session",
                    value: value !== Math.round(value) ? value.toFixed(2) : value,
                    deltaPercentage: deltaValue / (value > 0 ? value : 1) * 100,
                    deltaValue: deltaValue !== Math.round(deltaValue) ? deltaValue.toFixed(2) : deltaValue
                });
            }
            const averages = [];
            if (primaryHistogram != null && previousPrimaryHistogram != null && secondaryHistogram != null && previousSecondaryHistogram != null) {
                averages.push({
                    id: scope.applicationId,
                    filter,
                    items: output
                });
                this.setState({
                    ...this.state,
                    averages
                });
            }
            return {
                resultType: "Ok",
                errors: [],
                data: output
            };
        });
        (0, _definePropertyDefault.default)(this, "getPrimaryBreakdownPromise", async (scope, filter, breakdownType)=>{
            const breakdownData = {
                resultType: "Ok",
                data: [],
                errors: []
            };
            var aggregateData;
            switch(breakdownType){
                case "By Platform":
                    aggregateData = await _api.getInteractionAggregateByAssistant(scope.applicationId, filter);
                    if (aggregateData.resultType != "Ok") return aggregateData;
                    breakdownData.data = aggregateData.data.map((a, i, agg)=>({
                            label: a.key,
                            iconRender: ()=>this.getPlatformImage(a.key),
                            count: a.count,
                            percentage: this.getPercentage(a.count, agg)
                        }));
                    break;
                case "By Interface":
                    aggregateData = await _api.getInteractionAggregateByInterfaceType(scope.applicationId, filter);
                    if (aggregateData.resultType != "Ok") return aggregateData;
                    breakdownData.data = aggregateData.data.map((a, i, agg)=>({
                            label: a.key,
                            iconRender: ()=>this.getDeviceCapabilityImage(a.key),
                            count: a.count,
                            percentage: this.getPercentage(a.count, agg)
                        }));
                    break;
                case "By Device Type":
                    aggregateData = await _api.getInteractionAggregateByDeviceTarget(scope.applicationId, filter);
                    if (aggregateData.resultType != "Ok") return aggregateData;
                    breakdownData.data = aggregateData.data.map((a, i, agg)=>({
                            label: this.findDeviceType(a.key)?.displayName ?? "Unknown",
                            iconRender: ()=>this.getDeviceTypeImage(a.key),
                            count: a.count,
                            percentage: this.getPercentage(a.count, agg)
                        }));
                    break;
                case "By Language":
                    aggregateData = await _api.getInteractionAggregateByLanguage(scope.applicationId, filter);
                    if (aggregateData.resultType != "Ok") return aggregateData;
                    breakdownData.data = aggregateData.data.map((a, i, agg)=>({
                            label: this.getLanguageTitle(a.key),
                            iconRender: ()=>this.getLanguageImage(a.key),
                            count: a.count,
                            percentage: this.getPercentage(a.count, agg)
                        }));
                    break;
                case "By Interaction Type":
                    aggregateData = await _api.getInteractionAggregateByFeatureType(scope.applicationId, filter);
                    if (aggregateData.resultType != "Ok") return aggregateData;
                    breakdownData.data = aggregateData.data.map((a, i, agg)=>({
                            label: this.findFeatureType(a.key)?.name ?? "Unknown",
                            iconRender: ()=>this.getFeatureTypeImage(a.key),
                            count: a.count,
                            percentage: this.getPercentage(a.count, agg)
                        }));
                    break;
            }
            return breakdownData;
        });
        (0, _definePropertyDefault.default)(this, "getSecondaryBreakdownPromise", async (scope, filter, breakdownType)=>{
            const breakdownData = {
                resultType: "Ok",
                data: [],
                errors: []
            };
            var aggregateData;
            switch(breakdownType){
                case "By Platform":
                    aggregateData = await _api.getSessionAggregateByAssistant(scope.applicationId, filter);
                    if (aggregateData.resultType != "Ok") return aggregateData;
                    breakdownData.data = aggregateData.data.map((a, i, agg)=>({
                            label: a.key,
                            iconRender: ()=>this.getPlatformImage(a.key),
                            count: a.count,
                            percentage: this.getPercentage(a.count, agg)
                        }));
                    break;
                case "By Interface":
                    aggregateData = await _api.getSessionAggregateByInterfaceType(scope.applicationId, filter);
                    if (aggregateData.resultType != "Ok") return aggregateData;
                    breakdownData.data = aggregateData.data.map((a, i, agg)=>({
                            label: a.key,
                            iconRender: ()=>this.getDeviceCapabilityImage(a.key),
                            count: a.count,
                            percentage: this.getPercentage(a.count, agg)
                        }));
                    break;
                case "By Device Type":
                    aggregateData = await _api.getSessionAggregateByDeviceTarget(scope.applicationId, filter);
                    if (aggregateData.resultType != "Ok") return aggregateData;
                    breakdownData.data = aggregateData.data.map((a, i, agg)=>({
                            label: this.findDeviceType(a.key)?.displayName ?? "Unknown",
                            iconRender: ()=>this.getDeviceTypeImage(a.key),
                            count: a.count,
                            percentage: this.getPercentage(a.count, agg)
                        }));
                    break;
                case "By Language":
                    aggregateData = await _api.getSessionAggregateByLanguage(scope.applicationId, filter);
                    if (aggregateData.resultType != "Ok") return aggregateData;
                    breakdownData.data = aggregateData.data.map((a, i, agg)=>({
                            label: a.key,
                            iconRender: ()=>this.getLanguageImage(a.key),
                            count: a.count,
                            percentage: this.getPercentage(a.count, agg)
                        }));
                    break;
                case "By Interaction Type":
                    aggregateData = await _api.getSessionAggregateByFeatureType(scope.applicationId, filter);
                    if (aggregateData.resultType != "Ok") return aggregateData;
                    breakdownData.data = aggregateData.data.map((a, i, agg)=>({
                            label: this.findFeatureType(a.key)?.name ?? "Unknown",
                            iconRender: ()=>this.getFeatureTypeImage(a.key),
                            count: a.count,
                            percentage: this.getPercentage(a.count, agg)
                        }));
                    break;
            }
            return breakdownData;
        });
        this.state = {
            isLoadingHistogram: false,
            isLoadingBreakdown: false,
            currentBreakdown: this.breakdownOptions[0],
            currentDisplayOption: this.displayOptions[0],
            currentDeltaPeriod: "Previous Period",
            currentDeltaType: "Value"
        };
    }
}
exports.default = ApplicationInteractionAnalyticsContainer;

},{"@babel/runtime/helpers/defineProperty":"9sJxO","../../api":"loxM6","./GenericMeasurementsContainer":"gjwAK","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"gD5Gx":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _defineProperty = require("@babel/runtime/helpers/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _api = require("../../api");
var _genericMeasurementsContainer = require("./GenericMeasurementsContainer");
var _genericMeasurementsContainerDefault = parcelHelpers.interopDefault(_genericMeasurementsContainer);
class ApplicationMissAnalyticsContainer extends (0, _genericMeasurementsContainerDefault.default) {
    constructor(){
        super();
        (0, _definePropertyDefault.default)(this, "breakdownOptions", [
            "By Platform",
            "By Interface",
            "By Device Type",
            "By Language"
        ]);
        (0, _definePropertyDefault.default)(this, "displayOptions", [
            "Missed Intents",
            "Missed Interactions"
        ]);
        (0, _definePropertyDefault.default)(this, "getContextId", (scope)=>scope.applicationId);
        (0, _definePropertyDefault.default)(this, "getPrimaryHistogramPromise", (scope, interval, filter)=>_api.getFeatureMissHistogramForApplication(scope.applicationId, interval, filter));
        (0, _definePropertyDefault.default)(this, "getSecondaryHistogramPromise", (scope, interval, filter)=>_api.getContentMissHistogramForApplication(scope.applicationId, interval, filter));
        (0, _definePropertyDefault.default)(this, "getAverages", async (scope, filter)=>{
            const output = [];
            const previousDates = this.getPreviousDates(filter.startDate, filter.endDate);
            var primaryHistogram = this.state.primaryHistogramData?.find((h)=>this.buildHistogramKey(h) == this.buildCacheKey(scope.applicationId, filter));
            var secondaryHistogram = this.state.secondaryHistogramData?.find((h)=>this.buildHistogramKey(h) == this.buildCacheKey(scope.applicationId, filter));
            var previousPrimaryHistogram = this.state.primaryHistogramData?.find((h)=>this.buildHistogramKey(h) == this.buildCacheKey(scope.applicationId, {
                    ...filter,
                    startDate: previousDates.startDate,
                    endDate: previousDates.endDate
                }));
            var previousSecondaryHistogram = this.state.secondaryHistogramData?.find((h)=>this.buildHistogramKey(h) == this.buildCacheKey(scope.applicationId, {
                    ...filter,
                    startDate: previousDates.startDate,
                    endDate: previousDates.endDate
                }));
            var numberOfDays = this.getDaysBetween(filter.startDate, filter.endDate);
            var numberOfOcurredDays = this.getDaysBetween(filter.startDate, filter.endDate, true);
            if (primaryHistogram != null && previousPrimaryHistogram != null) {
                const total = primaryHistogram?.data?.map((h)=>h.count)?.reduce((a, b)=>a + b);
                const prevTotal = previousPrimaryHistogram?.data?.map((h)=>h.count)?.reduce((a, b)=>a + b);
                const value = (total ?? 0) / (numberOfOcurredDays ?? 1);
                const prevValue = (prevTotal ?? 0) / (numberOfDays ?? 1);
                const deltaValue = (value ?? 0) - (prevValue ?? 0);
                output.push({
                    title: "missed intents per day",
                    value: value !== Math.round(value) ? value.toFixed(2) : value,
                    deltaPercentage: deltaValue / (value > 0 ? value : 1) * 100,
                    deltaValue: deltaValue !== Math.round(deltaValue) ? deltaValue.toFixed(2) : deltaValue
                });
            }
            if (secondaryHistogram != null && previousSecondaryHistogram != null) {
                const total = secondaryHistogram.data?.map((h)=>h.count)?.reduce((a, b)=>a + b);
                const prevTotal = previousSecondaryHistogram?.data?.map((h)=>h.count)?.reduce((a, b)=>a + b);
                const value = (total ?? 0) / (numberOfOcurredDays ?? 1);
                const prevValue = (prevTotal ?? 0) / (numberOfDays ?? 1);
                const deltaValue = (value ?? 0) - (prevValue ?? 0);
                output.push({
                    title: "missed interactions per day",
                    value: value !== Math.round(value) ? value.toFixed(2) : value,
                    deltaPercentage: deltaValue / (value > 0 ? value : 1) * 100,
                    deltaValue: deltaValue !== Math.round(deltaValue) ? deltaValue.toFixed(2) : deltaValue
                });
            }
            const averages = [];
            averages.push({
                id: scope.applicationId,
                filter,
                items: output
            });
            this.setState({
                ...this.state,
                averages
            });
            return {
                resultType: "Ok",
                errors: [],
                data: output
            };
        });
        (0, _definePropertyDefault.default)(this, "getPrimaryBreakdownPromise", async (scope, filter, breakdownType)=>{
            const breakdownData = {
                resultType: "Ok",
                data: [],
                errors: []
            };
            var aggregateData;
            switch(breakdownType){
                case "By Platform":
                    aggregateData = await _api.getFeatureMissAggregateByAssistant(scope.applicationId, filter);
                    if (aggregateData.resultType != "Ok") return aggregateData;
                    breakdownData.data = aggregateData.data.map((a, i, agg)=>({
                            label: a.key,
                            iconRender: ()=>this.getPlatformImage(a.key),
                            count: a.count,
                            percentage: this.getPercentage(a.count, agg)
                        }));
                    break;
                case "By Interface":
                    aggregateData = await _api.getFeatureMissAggregateByInterfaceType(scope.applicationId, filter);
                    if (aggregateData.resultType != "Ok") return aggregateData;
                    breakdownData.data = aggregateData.data.map((a, i, agg)=>({
                            label: a.key,
                            iconRender: ()=>this.getDeviceCapabilityImage(a.key),
                            count: a.count,
                            percentage: this.getPercentage(a.count, agg)
                        }));
                    break;
                case "By Device Type":
                    aggregateData = await _api.getFeatureMissAggregateByDeviceTarget(scope.applicationId, filter);
                    if (aggregateData.resultType != "Ok") return aggregateData;
                    breakdownData.data = aggregateData.data.map((a, i, agg)=>({
                            label: this.findDeviceType(a.key)?.displayName ?? "Unknown",
                            iconRender: ()=>this.getDeviceTypeImage(a.key),
                            count: a.count,
                            percentage: this.getPercentage(a.count, agg)
                        }));
                    break;
                case "By Language":
                    aggregateData = await _api.getFeatureMissAggregateByLanguage(scope.applicationId, filter);
                    if (aggregateData.resultType != "Ok") return aggregateData;
                    breakdownData.data = aggregateData.data.map((a, i, agg)=>({
                            label: this.getLanguageTitle(a.key),
                            iconRender: ()=>this.getLanguageImage(a.key),
                            count: a.count,
                            percentage: this.getPercentage(a.count, agg)
                        }));
                    break;
            }
            return breakdownData;
        });
        (0, _definePropertyDefault.default)(this, "getSecondaryBreakdownPromise", async (scope, filter, breakdownType)=>{
            const breakdownData = {
                resultType: "Ok",
                data: [],
                errors: []
            };
            var aggregateData;
            switch(breakdownType){
                case "By Platform":
                    aggregateData = await _api.getContentMissAggregateByAssistant(scope.applicationId, filter);
                    if (aggregateData.resultType != "Ok") return aggregateData;
                    breakdownData.data = aggregateData.data.map((a, i, agg)=>({
                            label: a.key,
                            iconRender: ()=>this.getPlatformImage(a.key),
                            count: a.count,
                            percentage: this.getPercentage(a.count, agg)
                        }));
                    break;
                case "By Interface":
                    aggregateData = await _api.getContentMissAggregateByInterfaceType(scope.applicationId, filter);
                    if (aggregateData.resultType != "Ok") return aggregateData;
                    breakdownData.data = aggregateData.data.map((a, i, agg)=>({
                            label: a.key,
                            iconRender: ()=>this.getDeviceCapabilityImage(a.key),
                            count: a.count,
                            percentage: this.getPercentage(a.count, agg)
                        }));
                    break;
                case "By Device Type":
                    aggregateData = await _api.getContentMissAggregateByDeviceTarget(scope.applicationId, filter);
                    if (aggregateData.resultType != "Ok") return aggregateData;
                    breakdownData.data = aggregateData.data.map((a, i, agg)=>({
                            label: this.findDeviceType(a.key)?.displayName ?? "Unknown",
                            iconRender: ()=>this.getDeviceTypeImage(a.key),
                            count: a.count,
                            percentage: this.getPercentage(a.count, agg)
                        }));
                    break;
                case "By Language":
                    aggregateData = await _api.getContentMissAggregateByLanguage(scope.applicationId, filter);
                    if (aggregateData.resultType != "Ok") return aggregateData;
                    breakdownData.data = aggregateData.data.map((a, i, agg)=>({
                            label: a.key,
                            iconRender: ()=>this.getLanguageImage(a.key),
                            count: a.count,
                            percentage: this.getPercentage(a.count, agg)
                        }));
                    break;
            }
            return breakdownData;
        });
        this.state = {
            isLoadingHistogram: false,
            isLoadingBreakdown: false,
            currentBreakdown: this.breakdownOptions[0],
            currentDisplayOption: this.displayOptions[0],
            currentDeltaPeriod: "Previous Period",
            currentDeltaType: "Value"
        };
    }
}
exports.default = ApplicationMissAnalyticsContainer;

},{"@babel/runtime/helpers/defineProperty":"9sJxO","../../api":"loxM6","./GenericMeasurementsContainer":"gjwAK","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4zokI":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _defineProperty = require("@babel/runtime/helpers/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _api = require("../../api");
var _genericAnalyticsContainer = require("./GenericAnalyticsContainer");
var _genericAnalyticsContainerDefault = parcelHelpers.interopDefault(_genericAnalyticsContainer);
var _featureTypeIds = require("../../constants/featureTypeIds");
class ApplicationTrackingContainer extends (0, _genericAnalyticsContainerDefault.default) {
    constructor(){
        super();
        (0, _definePropertyDefault.default)(this, "displayOptions", []);
        this.state = {
            isLoading: false,
            isLoadingDetails: false,
            errors: [],
            trees: []
        };
    }
    async loadTree(applicationId, filter) {
        await this.setLoading(true);
        try {
            const result = await _api.getApplicationConversationTracking(applicationId, filter);
            const trees = this.state.trees;
            if (result?.resultType == "Ok") trees.push({
                id: applicationId,
                filter: filter,
                data: result.data,
                conversationItems: []
            });
            await this.setState({
                ...this.state,
                isLoading: false,
                trees,
                errors: []
            });
            return result;
        } catch  {
            await this.setLoading(false);
        }
    }
    async loadChildNodeDetails(applicationId, filter, node) {
        await this.setLoadingDetails(true);
        try {
            if (node.childNodes.length < 1) return null;
            const result = await _api.bulkLoadDetails({
                applicationId: applicationId,
                content: node.childNodes.filter((c)=>c.conversationTrackingNodeType == "Content")?.map((c)=>({
                        id: c.contentId,
                        featureTypeId: c.featureTypeId ?? (0, _featureTypeIds.FallbackFeatureTypeId)
                    }))
            });
            if (result?.resultType == "Ok") {
                const trees = this.state.trees;
                const tree = this.findTree(applicationId, filter);
                const index = trees.indexOf(tree);
                if (!tree) return null;
                const conversationItems = tree.conversationItems ?? [];
                result?.data?.forEach((c)=>{
                    if (!conversationItems.some((ci)=>c.id == ci.id)) conversationItems.push(c);
                });
                tree.conversationItems = conversationItems;
                trees[index] = tree;
                await this.setState({
                    ...this.state,
                    isLoadingDetails: false,
                    trees,
                    errors: []
                });
                // if we have any that were not found, try them in fallback
                const missedNodes = node.childNodes?.filter((c)=>c.conversationTrackingNodeType == "Content" && !result.data?.some((r)=>r.id == c?.contentId));
                if (missedNodes?.length > 0) {
                    const result = await _api.bulkLoadDetails({
                        applicationId: applicationId,
                        content: missedNodes?.map((c)=>({
                                id: c.contentId,
                                featureTypeId: (0, _featureTypeIds.FallbackFeatureTypeId)
                            }))
                    });
                    if (result?.resultType == "Ok") {
                        const trees = this.state.trees;
                        const tree = this.findTree(applicationId, filter);
                        const index = trees.indexOf(tree);
                        if (!tree) return null;
                        const conversationItems = tree.conversationItems ?? [];
                        result?.data?.forEach((c)=>{
                            if (!conversationItems.some((ci)=>c.id == ci.id)) conversationItems.push(c);
                        });
                        tree.conversationItems = conversationItems;
                        trees[index] = tree;
                        await this.setState({
                            ...this.state,
                            isLoadingDetails: false,
                            trees,
                            errors: []
                        });
                    }
                }
            }
            return result;
        } catch  {
            await this.setLoadingDetails(false);
        }
    }
    setLoadingDetails(isLoadingDetails) {
        this.setState({
            ...this.state,
            isLoadingDetails
        });
    }
    findTree(applicationId, filter) {
        return this.state.trees.find((h)=>this.buildCacheKey(h.id, h.filter) == this.buildCacheKey(applicationId, filter));
    }
}
exports.default = ApplicationTrackingContainer;

},{"@babel/runtime/helpers/defineProperty":"9sJxO","../../api":"loxM6","./GenericAnalyticsContainer":"3eKoF","../../constants/featureTypeIds":"hPLMP","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1t7fR":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _base = require("@emotion/styled/base");
var _baseDefault = parcelHelpers.interopDefault(_base);
var _react = require("@emotion/react");
var _css = require("@emotion/css");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _modalLayout = require("../../../components/structure/ModalLayout");
var _modalLayoutDefault = parcelHelpers.interopDefault(_modalLayout);
var _modalHeader = require("../../../components/general/ModalHeader");
var _modalHeaderDefault = parcelHelpers.interopDefault(_modalHeader);
var _footerBar = require("../../../components/structure/FooterBar");
var _footerBarDefault = parcelHelpers.interopDefault(_footerBar);
var _button = require("../../../components/general/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _checkboxField = require("../../../components/forms/CheckboxField");
var _checkboxFieldDefault = parcelHelpers.interopDefault(_checkboxField);
var _sessionAnalyticsContainer = require("../../../hooks/SessionAnalyticsContainer");
var _sessionAnalyticsContainerDefault = parcelHelpers.interopDefault(_sessionAnalyticsContainer);
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const AnalyticsSettingsModal = (props)=>{
    const [loaded, setLoaded] = (0, _react1.useState)(false);
    const [loading, setLoading] = (0, _react1.useState)(false);
    const [detailedAnalyticsEnabled, setDetailedAnalyticsEnabled] = (0, _react1.useState)(false);
    const [initialState, setInitialState] = (0, _react1.useState)(false);
    const sessionContainer = (0, _sessionAnalyticsContainerDefault.default).useContainer();
    const load = async ()=>{
        const envs = await props.envContainer.loadEnvironments(props.appId, true);
        if (envs.data?.length) {
            if (envs.data[0]?.detailedAnalyticsEnabled) {
                setDetailedAnalyticsEnabled(true);
                setInitialState(true);
            }
        }
        setLoaded(true);
    };
    (0, _react1.useEffect)(()=>{
        load();
    }, []);
    const handleToggle = ()=>{
        setDetailedAnalyticsEnabled(!detailedAnalyticsEnabled);
    };
    const handleSave = async ()=>{
        setLoading(true);
        if (detailedAnalyticsEnabled && !initialState) {
            await props.applicationContainer.updateDetailedAnalytics(props.appId, true);
            await props.envContainer.loadEnvironments(props.appId, true);
        } else if (!detailedAnalyticsEnabled && initialState) {
            await props.applicationContainer.updateDetailedAnalytics(props.appId, false);
            await props.envContainer.loadEnvironments(props.appId, true);
        }
        props.onClose();
    };
    return (0, _react.jsx)((0, _modalLayoutDefault.default), {
        className: modalStyle,
        isVisible: true,
        onClose: props.onClose
    }, (0, _react.jsx)((0, _modalHeaderDefault.default), {
        title: "Analytics Settings",
        onClose: props.onClose
    }), (0, _react.jsx)(ContentContainer, null, (0, _react.jsx)("h4", null, "Privacy Notice"), (0, _react.jsx)(ContentParagraph, null, "By enabling detailed analytics, you will gain access to the transcripts of entire user conversations, ", (0, _react.jsx)("b", null, "including potentially sensitive information shared during those interactions.")), (0, _react.jsx)(ContentParagraph, null, "Here are a few key points to consider before proceeding:"), (0, _react.jsx)(ContentParagraph, null, "User Privacy: Enabling detailed analytics means that you will have access to full transcripts of user conversations. Ensure any sensitive data is marked as such using Voicify's Secure Conversations feature so it is not tracked."), (0, _react.jsx)(ContentParagraph, null, "By enabling detailed analytics, you acknowledge that you have read and understood the implications outlined above, and you accept responsibility for ensuring compliance with relevant privacy laws and regulations. If you have any questions or concerns, please reach out to Voicify's support team before proceeding."), (0, _react.jsx)((0, _checkboxFieldDefault.default), {
        id: "detailedAnalyticsEnabled",
        onChange: ()=>handleToggle(),
        label: "Detailed Analytics Enabled",
        checked: detailedAnalyticsEnabled,
        disabled: !loaded
    }), detailedAnalyticsEnabled && (0, _react.jsx)(DetailedSimpleCheckbox, {
        id: "simpleView",
        label: "Simple Transcript View",
        checked: sessionContainer.simpleView,
        disabled: !loaded,
        onChange: ()=>sessionContainer.updateSimpleView(!sessionContainer.simpleView)
    })), (0, _react.jsx)((0, _footerBarDefault.default), null, (0, _react.jsx)((0, _buttonDefault.default), {
        type: "button",
        themes: [
            "primary",
            "start"
        ],
        text: "Save",
        onClick: ()=>handleSave(),
        disabled: !loaded || loading,
        loading: !loaded || loading
    }), (0, _react.jsx)((0, _buttonDefault.default), {
        type: "button",
        themes: [
            "secondary",
            "end"
        ],
        text: "Cancel",
        onClick: ()=>props.onClose(),
        disabled: !loaded,
        loading: !loaded
    })));
};
const modalStyle = /*#__PURE__*/ (0, _css.css)({
    name: "1t90d7",
    styles: "width:20vw;height:10vh"
});
const DetailedSimpleCheckbox = /*#__PURE__*/ (0, _baseDefault.default)((0, _checkboxFieldDefault.default), {
    target: "e1btmbfg2"
})({
    name: "3hgi0y",
    styles: "margin-top:32px"
});
const ContentContainer = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1btmbfg1"
})({
    name: "1d0mum3",
    styles: "margin:32px;padding:32px;display:flex flex-direction:column flex-wrap:wrap"
});
const ContentParagraph = /*#__PURE__*/ (0, _baseDefault.default)("p", {
    target: "e1btmbfg0"
})({
    name: "1k6141t",
    styles: "margin:16px 0"
});
exports.default = AnalyticsSettingsModal;

},{"@emotion/styled/base":"lSuFu","@emotion/react":"djZKr","@emotion/css":"awUBr","react":"6uln9","../../../components/structure/ModalLayout":"b1cO3","../../../components/general/ModalHeader":"aUACx","../../../components/structure/FooterBar":"bibRL","../../../components/general/Button":"6ymxN","../../../components/forms/CheckboxField":"3S5Oy","../../../hooks/SessionAnalyticsContainer":"vk8Qc","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"bwJDI":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _defineProperty = require("@babel/runtime/helpers/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _unstated = require("unstated");
var _api = require("../../api");
class SsmlContainer extends (0, _unstated.Container) {
    constructor(...args){
        super(...args);
        // default state
        (0, _definePropertyDefault.default)(this, "state", {
            ssmlCacheItems: [],
            isUploading: false,
            isLoading: false,
            errors: [],
            applicationId: ""
        });
    }
    getCachedSsmlSpeech(ssml, assistant, locale) {
        const existingItem = this.state.ssmlCacheItems.find((c)=>c.ssml == ssml && c.assistant == assistant && c.locale == locale);
        if (!existingItem) return null;
        return existingItem.outputAudioFiles;
    }
    getSpeechOutput(ssml, assistant, locale) {
        const existingItem = this.state.ssmlCacheItems.find((c)=>c.ssml == ssml && c.assistant == assistant && c.locale == locale);
        if (existingItem) return new Promise((resolve)=>resolve({
                resultType: "Ok",
                data: existingItem.outputAudioFiles,
                errors: null
            }));
        this.setLoading(true);
        const request = {
            ssml: ssml,
            locale: locale
        };
        var promise = _api.ssmlToSpeech(request, assistant);
        promise.then((result)=>{
            if (result.resultType == "Ok") {
                const cache = this.state.ssmlCacheItems;
                cache.push({
                    assistant: assistant,
                    ssml: ssml,
                    outputAudioFiles: result.data,
                    locale: locale
                });
                this.setState({
                    ...this.state,
                    errors: [],
                    isLoading: false,
                    ssmlCacheItems: cache
                });
            } else this.setState({
                ...this.state,
                errors: result.errors,
                isLoading: false
            });
        }).catch((error)=>{
            this.setState({
                ...this.state,
                errors: [
                    error
                ],
                isLoading: false
            });
        });
        return promise;
    }
    clearErrors() {
        this.setState({
            ...this.state,
            errors: []
        });
    }
    setLoading(isLoading) {
        this.setState({
            ...this.state,
            isLoading: isLoading
        });
    }
}
exports.default = SsmlContainer;

},{"@babel/runtime/helpers/defineProperty":"9sJxO","unstated":"grh7p","../../api":"loxM6","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2fhAM":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _defineProperty = require("@babel/runtime/helpers/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _unstated = require("unstated");
var _api = require("../../api");
class UserApplicationPreferencesContainer extends (0, _unstated.Container) {
    constructor(...args){
        super(...args);
        // default state
        (0, _definePropertyDefault.default)(this, "state", {
            currentUserApplicationPreferences: {
                id: null,
                userId: null,
                applicationId: null,
                simulatorPinnedMessages: []
            },
            isLoading: true,
            errors: []
        });
    }
    setLoading(isLoading) {
        this.setState({
            ...this.setState,
            isLoading: isLoading
        });
    }
    addSimulatorPinnedMessage(applicationId, message) {
        this.setLoading(true);
        const request = {
            applicationId: applicationId,
            message: message
        };
        var promise = _api.addSimulatorPinnedMessage(request);
        promise.then((result)=>{
            if (result.resultType == "Ok") {
                const pinnedMessages = this.state.currentUserApplicationPreferences.simulatorPinnedMessages;
                if (!pinnedMessages.some((p)=>p.message == message)) pinnedMessages.push(result.data);
                this.setState({
                    ...this.state,
                    currentUserApplicationPreferences: {
                        ...this.state.currentUserApplicationPreferences,
                        simulatorPinnedMessages: pinnedMessages
                    },
                    isLoading: false,
                    errors: []
                });
            } else this.setState({
                ...this.state,
                errors: result.errors,
                isLoading: false
            });
        }).catch((error)=>{
            this.setState({
                ...this.state,
                errors: [
                    error
                ],
                isLoading: false
            });
        });
        return promise;
    }
    deleteSimulatorPinnedMessage(applicationId, pinnedMessageId) {
        this.setLoading(true);
        var promise = _api.deleteSimulatorPinnedMessage(applicationId, pinnedMessageId);
        promise.then((result)=>{
            if (result.resultType == "Ok") {
                const pinnedMessages = [
                    ...this.state.currentUserApplicationPreferences.simulatorPinnedMessages
                ];
                const message = pinnedMessages.find((p)=>p.id == pinnedMessageId);
                const index = pinnedMessages.indexOf(message);
                pinnedMessages.splice(index, 1);
                this.setState({
                    ...this.state,
                    currentUserApplicationPreferences: {
                        ...this.state.currentUserApplicationPreferences,
                        simulatorPinnedMessages: pinnedMessages
                    },
                    isLoading: false,
                    errors: []
                });
            } else this.setState({
                ...this.state,
                errors: result.errors,
                isLoading: false
            });
        }).catch((error)=>{
            this.setState({
                ...this.state,
                errors: [
                    error
                ],
                isLoading: false
            });
        });
        return promise;
    }
    loadUserApplicationPreferences(applicationId) {
        this.setLoading(true);
        var promise = _api.getUserApplicationPreferences(applicationId);
        promise.then((result)=>{
            if (result.resultType == "Ok") this.setState({
                ...this.state,
                currentUserApplicationPreferences: result.data,
                isLoading: false,
                errors: []
            });
            else this.setState({
                ...this.state,
                errors: result.errors,
                isLoading: false
            });
        }).catch((error)=>{
            this.setState({
                ...this.state,
                errors: [
                    error
                ],
                isLoading: false
            });
        });
        return promise;
    }
    clearErrors() {
        this.setState({
            ...this.state,
            errors: []
        });
    }
}
exports.default = UserApplicationPreferencesContainer;

},{"@babel/runtime/helpers/defineProperty":"9sJxO","unstated":"grh7p","../../api":"loxM6","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3rYoU":[function(require,module,exports) {
module.exports = require("b0040f836748bd2d").getBundleURL("kVLro") + require("9d1a82778f018828").resolve("bWAqp");

},{"b0040f836748bd2d":"c7Tr5","9d1a82778f018828":"fyJL2"}],"4qLCH":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _unstated = require("unstated");
var _memberContainer = require("../../state/containers/MemberContainer");
var _memberContainerDefault = parcelHelpers.interopDefault(_memberContainer);
var _applicationMemberListView = require("./components/ApplicationMemberListView");
var _applicationMemberListViewDefault = parcelHelpers.interopDefault(_applicationMemberListView);
var _organizationContainer = require("../../state/containers/OrganizationContainer");
var _organizationContainerDefault = parcelHelpers.interopDefault(_organizationContainer);
var _pageContainer = require("../../components/structure/PageContainer");
var _pageContainerDefault = parcelHelpers.interopDefault(_pageContainer);
var _applicationContainer = require("../../state/containers/ApplicationContainer");
var _applicationContainerDefault = parcelHelpers.interopDefault(_applicationContainer);
var _userContainer = require("../../state/containers/UserContainer");
var _userContainerDefault = parcelHelpers.interopDefault(_userContainer);
var _applicationMembersContainer = require("../../state/containers/ApplicationMembersContainer");
var _applicationMembersContainerDefault = parcelHelpers.interopDefault(_applicationMembersContainer);
class ApplicationMembers extends (0, _reactDefault.default).Component {
    render() {
        return (0, _react.jsx)((0, _unstated.Subscribe), {
            to: [
                (0, _memberContainerDefault.default),
                (0, _organizationContainerDefault.default),
                (0, _applicationContainerDefault.default),
                (0, _userContainerDefault.default),
                (0, _applicationMembersContainerDefault.default)
            ]
        }, (memberContainer, orgContainer, appContainer, userContainer, appMembersContainer)=>{
            return (0, _react.jsx)((0, _pageContainerDefault.default), null, (0, _react.jsx)((0, _applicationMemberListViewDefault.default), {
                history: this.props.history,
                memberContainer: memberContainer,
                organizationId: orgContainer.state.currentOrganization.id,
                applicationId: this.props.applicationId,
                appContainer: appContainer,
                userContainer: userContainer,
                applicationMembersContainer: appMembersContainer,
                organizationContainer: orgContainer
            }));
        });
    }
}
exports.default = ApplicationMembers;

},{"@emotion/react":"djZKr","react":"6uln9","unstated":"grh7p","../../state/containers/MemberContainer":"iYQOb","./components/ApplicationMemberListView":"gHZpn","../../state/containers/OrganizationContainer":"dlbaM","../../components/structure/PageContainer":"hc1r8","../../state/containers/ApplicationContainer":"cuqi2","../../state/containers/UserContainer":"jDrDR","../../state/containers/ApplicationMembersContainer":"hsHim","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"gHZpn":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _loader = require("../../../components/general/Loader");
var _loaderDefault = parcelHelpers.interopDefault(_loader);
var _tableHeader = require("../../../components/general/TableHeader");
var _tableHeaderDefault = parcelHelpers.interopDefault(_tableHeader);
var _tableCell = require("../../../components/general/TableCell");
var _tableCellDefault = parcelHelpers.interopDefault(_tableCell);
var _sortedTable = require("../../../components/structure/SortedTable");
var _sortedTableDefault = parcelHelpers.interopDefault(_sortedTable);
var _roleToggle = require("../../../components/general/RoleToggle");
var _roleToggleDefault = parcelHelpers.interopDefault(_roleToggle);
var _button = require("../../../components/general/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _userAvatar = require("../../../components/general/UserAvatar");
var _userAvatarDefault = parcelHelpers.interopDefault(_userAvatar);
var _pageError = require("../../../components/general/PageError");
var _pageErrorDefault = parcelHelpers.interopDefault(_pageError);
var _rcTooltip = require("rc-tooltip");
var _rcTooltipDefault = parcelHelpers.interopDefault(_rcTooltip);
var _confirmationDialog = require("../../../components/structure/ConfirmationDialog");
var _confirmationDialogDefault = parcelHelpers.interopDefault(_confirmationDialog);
var _removeConfirmation = require("../../../components/general/RemoveConfirmation");
var _removeConfirmationDefault = parcelHelpers.interopDefault(_removeConfirmation);
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const deleteIcon = require("8c3580bbac792e52");
const deleteIconHover = require("4c40b7692b91ab5c");
const deleteIconInactive = require("cf8e721c01b707d5");
class ApplicationMemberListView extends (0, _reactDefault.default).Component {
    constructor(props){
        super(props);
        this.state = {
            isRemoveConfirmationVisible: false,
            selectedMember: null
        };
    }
    componentWillMount() {
        this.props.memberContainer.getMembers(this.props.organizationId);
        this.props.applicationMembersContainer.getMembersForApp(this.props.applicationId);
        this.props.organizationContainer.getSystemRoles();
        if (this.props.userContainer.state.currentUser == null) this.props.userContainer.getUser();
    }
    handleChangeRole(memberId, roleDisplayName) {
        var role;
        if (roleDisplayName == "Administrator") role = this.props.organizationContainer.state.systemRoles.find((r)=>r.isAdmin);
        else role = this.props.organizationContainer.state.systemRoles.find((r)=>!r.isAdmin && r.canEdit);
        this.props.memberContainer.updateMemberRole(memberId, role.id);
    }
    handleChangeAppRole(memberId, roleDisplayName) {
        const role = this.props.organizationContainer.state.systemRoles.find((r)=>r.name == roleDisplayName);
        this.props.applicationMembersContainer.updateAppMemberRole(memberId, role.id);
    }
    handleInviteNew() {
        this.props.history.push(`/v/apps/${this.props.applicationId}/members/add`);
    }
    getAdminRoleName() {
        const role = this.props.organizationContainer.state.systemRoles.find((r)=>r.isAdmin);
        if (role != undefined) return role.name;
        return "Administrator";
    }
    getEditorRoleName() {
        const role = this.props.organizationContainer.state.systemRoles.find((r)=>!r.isAdmin && r.canEdit);
        if (role != undefined) return role.name;
        return "Contributor";
    }
    getViewerRoleName() {
        const role = this.props.organizationContainer.state.systemRoles.find((r)=>!r.isAdmin && !r.canEdit);
        if (role != undefined) return role.name;
        return "Viewer";
    }
    handleShowRemove(member) {
        this.setState({
            ...this.state,
            isRemoveConfirmationVisible: true,
            selectedMember: member
        });
    }
    handleHideRemove() {
        this.setState({
            ...this.state,
            isRemoveConfirmationVisible: false
        });
    }
    render() {
        const { isLoadingMembers } = this.props.applicationMembersContainer.state;
        if (isLoadingMembers || this.props.organizationContainer.state.isLoadingRoles || this.props.userContainer.state.currentUser == null) return (0, _react.jsx)((0, _loaderDefault.default), null);
        const members = this.props.applicationMembersContainer.state.members.filter((m)=>m.applicationId == this.props.applicationId);
        const userId = this.props.userContainer.state.currentUser.id;
        const isAdmin = true;
        const columns = [
            {
                id: "member",
                Header: (0, _react.jsx)((0, _tableHeaderDefault.default), {
                    text: "MEMBER"
                }),
                accessor: (m)=>m,
                Cell: (row)=>(0, _react.jsx)((0, _tableCellDefault.default), null, (0, _react.jsx)((0, _userAvatarDefault.default), {
                        className: avatarStyle,
                        noBackground: true,
                        lastName: row.value.organizationMember.lastName,
                        firstName: row.value.organizationMember.firstName,
                        src: row.value.organizationMember.imageUrl,
                        size: 32
                    }), (0, _react.jsx)("span", null, `${row.value.organizationMember.firstName} ${row.value.organizationMember.lastName}`))
            },
            {
                id: "email",
                Header: (0, _react.jsx)((0, _tableHeaderDefault.default), {
                    text: "EMAIL"
                }),
                accessor: (m)=>m,
                Cell: (row)=>(0, _react.jsx)((0, _tableCellDefault.default), null, row.value.organizationMember.email)
            },
            {
                id: "role",
                Header: (0, _react.jsx)((0, _tableHeaderDefault.default), {
                    text: "ORGANIZATION ROLE"
                }),
                accessor: (m)=>m,
                Cell: (row)=>(0, _react.jsx)((0, _tableCellDefault.default), null, isAdmin && row.value.organizationMember.userId != userId ? (0, _react.jsx)((0, _roleToggleDefault.default), {
                        currentRole: row.value.organizationMember.isAdmin ? "Administrator" : "Contributor",
                        roles: [
                            "Administrator",
                            "Contributor"
                        ],
                        onChange: (roleName)=>this.handleChangeRole(row.value.organizationMember.id, roleName)
                    }) : (0, _react.jsx)("span", null, row.value.organizationMember.isAdmin ? "Administrator" : "Contributor"))
            },
            {
                id: "appMemberRole",
                Header: (0, _react.jsx)((0, _tableHeaderDefault.default), {
                    text: "APPLICATION ROLE"
                }),
                accessor: (m)=>m,
                Cell: (row)=>(0, _react.jsx)((0, _tableCellDefault.default), null, isAdmin && row.value.organizationMember.userId != userId ? (0, _react.jsx)((0, _roleToggleDefault.default), {
                        currentRole: row.value.isAdmin ? this.getAdminRoleName() : row.value.canEdit ? this.getEditorRoleName() : this.getViewerRoleName(),
                        roles: this.props.organizationContainer.state.systemRoles.map((r)=>r.name),
                        onChange: (roleName)=>this.handleChangeAppRole(row.value.id, roleName)
                    }) : (0, _react.jsx)("span", null, row.value.isAdmin ? this.getAdminRoleName() : row.value.canEdit ? this.getEditorRoleName() : this.getViewerRoleName()))
            },
            {
                id: "removeMemberships",
                Header: (0, _react.jsx)((0, _tableHeaderDefault.default), {
                    text: ""
                }),
                accessor: (m)=>m,
                width: 50,
                Cell: (row)=>(0, _react.jsx)((0, _tableCellDefault.default), null, (0, _react.jsx)("div", {
                        className: deleteContainer
                    }, (0, _react.jsx)((0, _rcTooltipDefault.default), {
                        mouseEnterDelay: .5,
                        overlayClassName: tooltipContentStyle,
                        trigger: [
                            "hover"
                        ],
                        placement: "top",
                        overlay: isAdmin ? this.props.userContainer.state.currentUser.id == row.value.organizationMember.userId ? (0, _react.jsx)("div", {
                            className: tooltipText
                        }, "Cannot remove", (0, _react.jsx)("br", null), "own account") : (0, _react.jsx)("span", null, "Remove") : (0, _react.jsx)("div", {
                            className: tooltipText
                        }, "Requires admin", (0, _react.jsx)("br", null), "permissions")
                    }, (0, _react.jsx)("button", {
                        onClick: ()=>isAdmin && this.props.userContainer.state.currentUser.id != row.value.organizationMember.userId && this.handleShowRemove(row.value)
                    }, isAdmin && this.props.userContainer.state.currentUser.id != row.value.organizationMember.userId ? (0, _react.jsx)("div", null, (0, _react.jsx)("img", {
                        src: deleteIcon,
                        className: "static-icon"
                    }), (0, _react.jsx)("img", {
                        src: deleteIconHover,
                        className: "active-icon"
                    })) : (0, _react.jsx)("img", {
                        src: deleteIconInactive
                    })))))
            }
        ];
        return (0, _react.jsx)("div", null, (0, _react.jsx)((0, _buttonDefault.default), {
            text: "Invite New",
            themes: [
                "primary",
                "end-tight"
            ],
            onClick: this.handleInviteNew.bind(this),
            disabled: !isAdmin
        }), (0, _react.jsx)((0, _sortedTableDefault.default), {
            columns: columns,
            data: members
        }), (0, _react.jsx)((0, _pageErrorDefault.default), {
            errors: this.props.applicationMembersContainer.state.errors
        }), this.state.isRemoveConfirmationVisible ? (0, _react.jsx)((0, _confirmationDialogDefault.default), {
            title: "Remove",
            deleteText: "Yes, Remove",
            isLoading: this.props.applicationMembersContainer.state.isLoading,
            onClose: this.handleHideRemove.bind(this),
            onConfirm: ()=>{
                this.props.applicationMembersContainer.removeMemberFromApp(this.state.selectedMember?.id);
                this.handleHideRemove();
            }
        }, (0, _react.jsx)((0, _removeConfirmationDefault.default), {
            removalTarget: this.props.appContainer.state.currentApp?.name,
            memberName: this.state.selectedMember?.organizationMember?.firstName + " " + this.state.selectedMember?.organizationMember?.lastName
        })) : null);
    }
}
const avatarStyle = /*#__PURE__*/ (0, _css.css)({
    name: "o7nnmj",
    styles: "margin-right:16px"
});
const deleteContainer = /*#__PURE__*/ (0, _css.css)({
    name: "1uh7c32",
    styles: "display:flex;align-items:center;justify-content:center;background:white;button{border:none;box-shadow:none;background:none;color:transparent;padding:0;cursor:pointer;&:hover{.active-icon{display:block;}.static-icon{display:none;}}.active-icon{display:none;}img{height:24px;width:24px;margin:2px;}}"
});
const tooltipText = /*#__PURE__*/ (0, _css.css)({
    name: "1azakc",
    styles: "text-align:center"
});
const tooltipContentStyle = /*#__PURE__*/ (0, _css.css)({
    name: "11143my",
    styles: ".rc-tooltip-inner{font-family:Muli;font-size:14px;font-weight:normal;font-style:normal;letter-spacing:0.6px;z-index:120;color:white;background-color:#304562;box-shadow:-1px 4px 10px 0 rgba(48, 69, 98, 0.1);padding:8px;min-height:0;}"
});
exports.default = ApplicationMemberListView;

},{"@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","../../../components/general/Loader":"bnV5T","../../../components/general/TableHeader":"9EPgz","../../../components/general/TableCell":"2zNzE","../../../components/structure/SortedTable":"2MhF3","../../../components/general/RoleToggle":"aas3J","../../../components/general/Button":"6ymxN","../../../components/general/UserAvatar":"avuDP","../../../components/general/PageError":"ezFTm","rc-tooltip":"fhD1R","../../../components/structure/ConfirmationDialog":"kx7yK","../../../components/general/RemoveConfirmation":"elIoY","8c3580bbac792e52":"kG0i0","4c40b7692b91ab5c":"8Dvha","cf8e721c01b707d5":"fI7en","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"aas3J":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _reactSelect = require("react-select");
var _reactSelectDefault = parcelHelpers.interopDefault(_reactSelect);
var _colors = require("../../constants/colors");
var _fieldError = require("../forms/FieldError");
var _fieldErrorDefault = parcelHelpers.interopDefault(_fieldError);
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const checkIcon = require("15389f4c4cd8b422");
const inactiveIcon = require("37d722c8fc65e209");
class RoleToggle extends (0, _reactDefault.default).Component {
    componentWillMount() {
        this.setState({
            ...this.state,
            currentRole: this.props.currentRole
        });
    }
    handleChange(value) {
        this.setState({
            ...this.state,
            currentRole: value.value
        });
        if (this.props.onChange) this.props.onChange(value.value);
    }
    render() {
        return (0, _react.jsx)("div", {
            className: containerStyle
        }, this.props.label !== undefined ? (0, _react.jsx)("label", null, this.props.label) : null, (0, _react.jsx)((0, _reactSelectDefault.default), {
            name: this.props.name ? this.props.name : "role",
            placeholder: "Role",
            value: this.state.currentRole,
            onChange: this.handleChange.bind(this),
            options: this.props.roles.map((r)=>({
                    value: r,
                    label: r
                })),
            className: `${selectStyle} ${this.props.positionTop ? topSelectStyle : ""}`,
            searchable: false,
            clearable: false
        }), this.props.includeError ? (0, _react.jsx)((0, _fieldErrorDefault.default), {
            name: this.props.name ? this.props.name : "role"
        }) : null);
    }
}
const topSelectStyle = /*#__PURE__*/ (0, _css.css)({
    name: "x2g0uy",
    styles: "&.is-open{.Select-control{border-radius:16px;}}.Select-menu-outer{position:absolute;top:-100px;border-top-right-radius:16px;border-top-left-radius:16px;}.Select-option:first-child{border-top-right-radius:16px;border-top-left-radius:16px;}"
});
const selectStyle = /*#__PURE__*/ (0, _css.css)("font-family:Muli sans-serif;font-weight:normal;font-style:normal;font-stretch:normal;line-height:normal;letter-spacing:normal;text-align:left;width:160px;margin-right:32px;margin-left:auto;.Select-control{border-radius:16px;min-height:32px;box-shadow:-1px 4px 10px 0 ", (0, _colors.dark_grey_blue_10), ";}.Select-placeholder,.Select-value{padding:0 26px 0 8px;font-family:Muli;font-size:14px;display:flex;align-items:center;}.Select-value-label{margin-left:16px;}.Select-menu-outer{border-bottom-right-radius:16px;border-bottom-left-radius:16px;overflow-y:auto;z-index:999;}.Select-option,Select-noresults{height:32px;padding:0 26px 0 8px;font-family:Muli;font-size:14px;display:flex;align-items:center;}.Select-option:last-child{border-bottom-right-radius:16px;border-bottom-left-radius:16px;}", "");
const containerStyle = /*#__PURE__*/ (0, _css.css)("display:flex;align-items:center;>*+*{margin-left:16px;}label{margin:0 24px;font-family:Muli;font-size:14px;font-weight:normal;font-style:normal;font-stretch:normal;line-height:normal;letter-spacing:normal;text-align:right;color:", (0, _colors.dark_grey_blue), ";}", "");
exports.default = RoleToggle;

},{"@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","react-select":"1numo","../../constants/colors":"1p3OR","../forms/FieldError":"fDxhz","15389f4c4cd8b422":"gbGNg","37d722c8fc65e209":"6VsT8","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"gbGNg":[function(require,module,exports) {
module.exports = require("68815861544c8426").getBundleURL("kVLro") + require("a365d372581021dd").resolve("2eAzg");

},{"68815861544c8426":"c7Tr5","a365d372581021dd":"fyJL2"}],"6VsT8":[function(require,module,exports) {
module.exports = require("20a8c239b553a3b2").getBundleURL("kVLro") + require("dc07b9d6127c60b7").resolve("4fIzK");

},{"20a8c239b553a3b2":"c7Tr5","dc07b9d6127c60b7":"fyJL2"}],"kG0i0":[function(require,module,exports) {
module.exports = require("4865707414cfaf1").getBundleURL("kVLro") + require("19801ac3811f5077").resolve("ns1rB");

},{"4865707414cfaf1":"c7Tr5","19801ac3811f5077":"fyJL2"}],"8Dvha":[function(require,module,exports) {
module.exports = require("7cdc415d941134bb").getBundleURL("kVLro") + require("c3377eef9e324996").resolve("eOMrL");

},{"7cdc415d941134bb":"c7Tr5","c3377eef9e324996":"fyJL2"}],"fI7en":[function(require,module,exports) {
module.exports = require("721a0753320f16ef").getBundleURL("kVLro") + require("6c54b454d2a5c4").resolve("iyW7J");

},{"721a0753320f16ef":"c7Tr5","6c54b454d2a5c4":"fyJL2"}],"hsHim":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _defineProperty = require("@babel/runtime/helpers/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _unstated = require("unstated");
var _api = require("../../api");
class ApplicationMembersContainer extends (0, _unstated.Container) {
    constructor(...args){
        super(...args);
        // default state
        (0, _definePropertyDefault.default)(this, "state", {
            isLoadingMembers: false,
            isLoading: false,
            members: [],
            errors: []
        });
    }
    getMembersForApp(applicationId) {
        this.setLoading(true);
        const promise = _api.getApplicationMembers(applicationId);
        promise.then((result)=>{
            if (result.resultType == "Ok") {
                const members = this.state.members.filter((m)=>m.applicationId !== applicationId);
                members.push(...result.data);
                this.setState({
                    ...this.state,
                    errors: [],
                    isLoadingMembers: false,
                    members: members
                });
            } else this.setState({
                ...this.state,
                isLoadingMembers: false,
                errors: result.errors
            });
        }).catch((error)=>{
            this.setState({
                ...this.state,
                isLoadingMembers: false,
                errors: [
                    error
                ]
            });
        });
        return promise;
    }
    isUserAppAdmin(userId, appId) {
        const members = this.state.members.filter((m)=>m.applicationId == appId);
        var isAdmin = false;
        const member = members.find((m)=>m.organizationMember.userId == userId && m.applicationId == appId);
        if (member) isAdmin = member.isAdmin || member.organizationMember.isAdmin;
        else {
            const organizationMember = this.state.members.find((m)=>m.userId == userId);
            if (organizationMember) isAdmin = organizationMember.isAdmin;
        }
        return isAdmin;
    }
    addMembers(applicationId, model) {
        this.setState({
            ...this.state,
            isLoading: true
        });
        const promise = _api.addApplicationMember(applicationId, model);
        promise.then((result)=>{
            if (result.resultType == "Ok") this.setState({
                ...this.state,
                isLoading: false,
                errors: []
            });
            else this.setState({
                ...this.state,
                isLoading: false,
                errors: result.errors
            });
        }).catch((error)=>{
            this.setState({
                ...this.state,
                isLoading: false,
                errors: [
                    error
                ]
            });
        });
        return promise;
    }
    updateAppMemberRole(applicationMemberId, roleId) {
        const promise = _api.updateApplicationMemberRole(applicationMemberId, roleId);
        promise.then((result)=>{
            if (result.resultType != "Ok") this.setState({
                ...this.state,
                errors: result.errors
            });
        }).catch((error)=>{
            this.setState({
                ...this.state,
                errors: [
                    error
                ]
            });
        });
        return promise;
    }
    removeMemberFromApp(applicationMemberId) {
        this.setState({
            ...this.state,
            isLoading: true
        });
        var promise = _api.removeApplicationMember(applicationMemberId);
        promise.then((result)=>{
            if (result.resultType == "Ok") this.setState({
                ...this.state,
                isLoading: false,
                members: this.state.members.filter((m)=>m.id != applicationMemberId)
            });
            else this.setState({
                ...this.state,
                isLoading: false,
                errors: result.errors
            });
        }).catch((error)=>{
            this.setState({
                ...this.state,
                isLoading: false,
                errors: [
                    error
                ]
            });
        });
    }
    setLoading(isLoading) {
        this.setState({
            ...this.state,
            isLoadingMembers: isLoading
        });
    }
}
exports.default = ApplicationMembersContainer;

},{"@babel/runtime/helpers/defineProperty":"9sJxO","unstated":"grh7p","../../api":"loxM6","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3j96I":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _extends = require("@babel/runtime/helpers/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _unstated = require("unstated");
var _organizationContainer = require("../../state/containers/OrganizationContainer");
var _organizationContainerDefault = parcelHelpers.interopDefault(_organizationContainer);
var _applicationContainer = require("../../state/containers/ApplicationContainer");
var _applicationContainerDefault = parcelHelpers.interopDefault(_applicationContainer);
var _applicationSettingsTab = require("./components/ApplicationSettingsTab");
var _applicationSettingsTabDefault = parcelHelpers.interopDefault(_applicationSettingsTab);
var _memberContainer = require("../../state/containers/MemberContainer");
var _memberContainerDefault = parcelHelpers.interopDefault(_memberContainer);
var _applicationMembersContainer = require("../../state/containers/ApplicationMembersContainer");
var _applicationMembersContainerDefault = parcelHelpers.interopDefault(_applicationMembersContainer);
var _userContainer = require("../../state/containers/UserContainer");
var _userContainerDefault = parcelHelpers.interopDefault(_userContainer);
var _applicationEnvironmentsContainer = require("../../state/containers/ApplicationEnvironmentsContainer");
var _applicationEnvironmentsContainerDefault = parcelHelpers.interopDefault(_applicationEnvironmentsContainer);
var _mediaContainer = require("../../state/containers/MediaContainer");
var _mediaContainerDefault = parcelHelpers.interopDefault(_mediaContainer);
function ApplicationSettings(props) {
    return (0, _react.jsx)((0, _unstated.Subscribe), {
        to: [
            (0, _mediaContainerDefault.default),
            (0, _organizationContainerDefault.default),
            (0, _applicationContainerDefault.default),
            (0, _memberContainerDefault.default),
            (0, _applicationMembersContainerDefault.default),
            (0, _userContainerDefault.default),
            (0, _applicationEnvironmentsContainerDefault.default)
        ]
    }, (mediaContainer, orgContainer, appContainer, memberContainer, applicationMembersContainer, userContainer, environmentsContainer)=>{
        return (0, _react.jsx)((0, _applicationSettingsTabDefault.default), (0, _extendsDefault.default)({
            mediaContainer: mediaContainer,
            orgContainer: orgContainer,
            appContainer: appContainer,
            memberContainer: memberContainer,
            applicationMembersContainer: applicationMembersContainer,
            userContainer: userContainer,
            environmentsContainer: environmentsContainer
        }, props));
    });
}
exports.default = ApplicationSettings;

},{"@babel/runtime/helpers/extends":"4iKIP","@emotion/react":"djZKr","react":"6uln9","unstated":"grh7p","../../state/containers/OrganizationContainer":"dlbaM","../../state/containers/ApplicationContainer":"cuqi2","./components/ApplicationSettingsTab":"eqlN0","../../state/containers/MemberContainer":"iYQOb","../../state/containers/ApplicationMembersContainer":"hsHim","../../state/containers/UserContainer":"jDrDR","../../state/containers/ApplicationEnvironmentsContainer":"jCULY","../../state/containers/MediaContainer":"ch6Xu","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"eqlN0":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _extends = require("@babel/runtime/helpers/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _base = require("@emotion/styled/base");
var _baseDefault = parcelHelpers.interopDefault(_base);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _applicationInfoSettings = require("./ApplicationInfoSettings");
var _applicationInfoSettingsDefault = parcelHelpers.interopDefault(_applicationInfoSettings);
var _interactionModel = require("../../interactionModel");
var _interactionModelDefault = parcelHelpers.interopDefault(_interactionModel);
var _reactTabs = require("react-tabs");
var _tabPanelBody = require("../../../components/structure/TabPanelBody");
var _tabPanelBodyDefault = parcelHelpers.interopDefault(_tabPanelBody);
var _colors = require("../../../constants/colors");
var _languageSettings = require("./languages/LanguageSettings");
var _languageSettingsDefault = parcelHelpers.interopDefault(_languageSettings);
var _tabContainerPanel = require("../../../components/structure/Panels/TabContainerPanel");
var _tabContainerPanelDefault = parcelHelpers.interopDefault(_tabContainerPanel);
var _deploymentsTab = require("./DeploymentsTab");
var _deploymentsTabDefault = parcelHelpers.interopDefault(_deploymentsTab);
var _customScrollbars = require("../../../components/structure/CustomScrollbars");
var _customScrollbarsDefault = parcelHelpers.interopDefault(_customScrollbars);
var _loader = require("../../../components/general/Loader");
var _loaderDefault = parcelHelpers.interopDefault(_loader);
var _dropDownSelectField = require("../../../components/forms/DropDownSelectField");
var _dropDownSelectFieldDefault = parcelHelpers.interopDefault(_dropDownSelectField);
var _interactionModelSettingsHeader = require("./InteractionModelSettingsHeader");
var _interactionModelSettingsHeaderDefault = parcelHelpers.interopDefault(_interactionModelSettingsHeader);
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const interactionModelIcon = require("927752b250aaef41");
const interactionModelBlueIcon = require("2bbfb2fe1187d6df");
const rocketIcon = require("cb406d621f7b9512");
const rocketBlueIcon = require("134f62688991b99a");
const appInfoIcon = require("22f95642ccb92d8a");
const appInfoBlueIcon = require("72a7ce2bc99e99");
const liveAppIcon = require("358c11cbd77e17bc");
const testAppIcon = require("f73d6debe2440f2c");
//We are leaving interactionmodel here such that the old route still works.
//Moving forward we will be using nlp
const interactionModelTabName = "interactionmodel";
const nlpModelTabName = "nlp";
const deploymentTabName = "deployments";
const appInfo = "appInfo";
const ApplicationSettingsTab = (props)=>{
    // Deafult environment is used in App Info tab, Live(Production) for most but Draft for AL
    const [defaultEnvironmentOption, setDefaultEnvironmentOption] = (0, _react1.useState)(null);
    // If App has both Live(Production) and Draft environments then we show a selection drop down in Deployment Tab
    const [selectedEnvironmentOption, setSelectedEnvironmentOption] = (0, _react1.useState)(null);
    const [showEnvironmentOptions, setShowEnvironmentOptions] = (0, _react1.useState)(false);
    (0, _react1.useEffect)(()=>{
        getDefaultEnvironment();
    }, [
        props.applicationId
    ]);
    const getDefaultEnvironment = async ()=>{
        const envsResult = await props.environmentsContainer.loadEnvironments(props.applicationId);
        const appEnvs = envsResult.data;
        let selectedEnv = null;
        if (props.environmentId) selectedEnv = appEnvs?.find((e)=>e.id == props.environmentId);
        const liveEnv = props.environmentsContainer.findLiveEnvironment(props.applicationId);
        const draftEnv = props.environmentsContainer.findDraftEnvironment(props.applicationId);
        // if we have a environment id from the url lets use that
        if (selectedEnv) {
            if (selectedEnv.isDraft) {
                setSelectedEnvironmentOption("draft");
                setDefaultEnvironmentOption("draft");
            } else {
                setSelectedEnvironmentOption("live");
                setDefaultEnvironmentOption("live");
            }
        } else if (liveEnv) {
            setSelectedEnvironmentOption("live");
            setDefaultEnvironmentOption("live");
            if (getSelectedIndex() == 2) props.history.push(`/v/apps/${props.applicationId}/appSettings/${deploymentTabName}/${liveEnv.id}`);
        } else if (appEnvs?.length === 1 && draftEnv) {
            setSelectedEnvironmentOption("draft");
            setDefaultEnvironmentOption("draft");
            if (getSelectedIndex() == 2) props.history.push(`/v/apps/${props.applicationId}/appSettings/${deploymentTabName}/${draftEnv.id}`);
        }
        if (liveEnv && draftEnv) setShowEnvironmentOptions(true);
    };
    function handleTabSelection(index, last) {
        if (index == last) return;
        const urlStart = `/v/apps/${props.applicationId}/appSettings/`;
        if (index === 0) props.history.push(urlStart + nlpModelTabName);
        if (index === 1) props.history.push(urlStart + appInfo);
        if (index === 2) props.history.push(urlStart + deploymentTabName);
    }
    function getSelectedIndex() {
        if (location.href.indexOf(appInfo) > -1) return 1;
        if (location.href.indexOf(deploymentTabName) > -1) return 2;
        return 0;
    }
    function handleSelectedEnvironmentOptionChange(option) {
        setSelectedEnvironmentOption(option);
        const env = props.environmentsContainer.findEnvironmentByOption(props.applicationId, option);
        if (env) props.history.push(`/v/apps/${props.applicationId}/appSettings/${deploymentTabName}/${env.id}`);
    }
    const renderEnvironmentSelection = ()=>{
        return (0, _react.jsx)(SelectionContainer, null, (0, _react.jsx)((0, _dropDownSelectFieldDefault.default), {
            className: customSelect,
            key: "environment-selector",
            onChange: (e)=>handleSelectedEnvironmentOptionChange(e.value),
            value: selectedEnvironmentOption,
            clearable: false,
            searchable: false,
            valueRenderer: formatValueLabel,
            optionImageStyle: optionImageStyle,
            options: [
                {
                    value: "live",
                    label: "Live App",
                    image: liveAppIcon
                },
                {
                    value: "draft",
                    label: "Test App",
                    image: testAppIcon
                }
            ]
        }));
    };
    function renderHeaderContent() {
        const index = getSelectedIndex();
        if (index == 2) return (0, _react.jsx)(AdditionalHeader, null, showEnvironmentOptions ? renderEnvironmentSelection() : null, (0, _react.jsx)("span", {
            className: "header-title"
        }, "Deployment Platform"));
        if (index == 1) return (0, _react.jsx)(AdditionalHeader, null, (0, _react.jsx)("span", {
            className: "header-title"
        }, "Application Identity"));
        else return (0, _react.jsx)((0, _interactionModelSettingsHeaderDefault.default), {
            applicationId: props.applicationId,
            history: props.history,
            appContainer: props.appContainer
        });
    }
    const formatValueLabel = ({ label, image })=>(0, _react.jsx)(CustomSelectChosenOption, null, (0, _react.jsx)("img", {
            className: optionImageStyle,
            src: image
        }), (0, _react.jsx)("p", null, label));
    if (!props.appContainer.state.currentApp) return (0, _react.jsx)((0, _loaderDefault.default), null);
    return (0, _react.jsx)((0, _tabContainerPanelDefault.default), {
        tabs: [
            {
                title: "NLP Model",
                icon: interactionModelIcon,
                selectedIcon: interactionModelBlueIcon
            },
            {
                title: "App Info",
                icon: appInfoIcon,
                selectedIcon: appInfoBlueIcon
            },
            {
                title: "Deployment",
                icon: rocketIcon,
                selectedIcon: rocketBlueIcon,
                className: "ac-deploy-tab"
            }
        ],
        onTabSelected: (index, last)=>handleTabSelection(index, last),
        selectedIndex: getSelectedIndex(),
        additionalHeaderContent: renderHeaderContent
    }, (0, _react.jsx)((0, _reactTabs.TabPanel), null, (0, _react.jsx)((0, _tabPanelBodyDefault.default), {
        className: langaugeTabStyle
    }, (0, _react.jsx)((0, _languageSettingsDefault.default), {
        appContainer: props.appContainer,
        applicationId: props.applicationId,
        clearSelection: false
    }), (0, _react.jsx)((0, _interactionModelDefault.default), {
        appContainer: props.appContainer,
        applicationId: props.applicationId,
        allAppLanguages: props.appContainer.state.currentApp.languages
    }))), (0, _react.jsx)((0, _reactTabs.TabPanel), null, (0, _react.jsx)((0, _tabPanelBodyDefault.default), {
        className: langaugeTabStyle
    }, (0, _react.jsx)((0, _customScrollbarsDefault.default), {
        autoHeight: true,
        autoHeightMax: "calc(100vh - 140px)"
    }, (0, _react.jsx)((0, _languageSettingsDefault.default), {
        appContainer: props.appContainer,
        applicationId: props.applicationId,
        clearSelection: true
    }), (0, _react.jsx)((0, _applicationInfoSettingsDefault.default), {
        appContainer: props.appContainer,
        applicationId: props.applicationId,
        environmentOption: defaultEnvironmentOption,
        environmentsContainer: props.environmentsContainer
    })))), (0, _react.jsx)((0, _reactTabs.TabPanel), null, (0, _react.jsx)((0, _deploymentsTabDefault.default), (0, _extendsDefault.default)({}, props, {
        mediaContainer: props.mediaContainer,
        environmentOption: selectedEnvironmentOption,
        environmentsContainer: props.environmentsContainer
    }))));
};
const langaugeTabStyle = /*#__PURE__*/ (0, _css.css)({
    name: "1hcx8jb",
    styles: "padding:0"
});
const AdditionalHeader = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e145orsr2"
})("display:flex;flex-direction:row;margin-right:100vw;padding-left:32px;margin-left:7px;white-space:nowrap;border-left:1px solid ", (0, _colors.color_shades_dark), ";height:100%;padding-top:0;.header-title{padding:16px 16px 0 0;}");
const SelectionContainer = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e145orsr1"
})({
    name: "gnkjpz",
    styles: "padding:10px 16px 10px 0"
});
const optionImageStyle = /*#__PURE__*/ (0, _css.css)({
    name: "t35ebv",
    styles: "height:8px;width:8px;margin:auto 0px"
});
const customSelect = /*#__PURE__*/ (0, _css.css)({
    name: "gn754n",
    styles: "height:28px;width:140px"
});
const CustomSelectChosenOption = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e145orsr0"
})("display:flex;flex-direction:row;padding-left:6px;p{color:", (0, _colors.color_shades_darkest), ";margin-left:10px;}");
exports.default = ApplicationSettingsTab;

},{"@babel/runtime/helpers/extends":"4iKIP","@emotion/styled/base":"lSuFu","@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","./ApplicationInfoSettings":"19M9B","../../interactionModel":"bawjn","react-tabs":"92Sgf","../../../components/structure/TabPanelBody":"ePx7g","../../../constants/colors":"1p3OR","./languages/LanguageSettings":"gRrQW","../../../components/structure/Panels/TabContainerPanel":"iDHIJ","./DeploymentsTab":"ifLqC","../../../components/structure/CustomScrollbars":"50vFq","../../../components/general/Loader":"bnV5T","../../../components/forms/DropDownSelectField":"kFCJA","./InteractionModelSettingsHeader":"duQQT","927752b250aaef41":"jBhmL","2bbfb2fe1187d6df":"lxrDl","cb406d621f7b9512":"7eCA0","134f62688991b99a":"cysx1","22f95642ccb92d8a":"5dRXN","72a7ce2bc99e99":"7CibP","358c11cbd77e17bc":"8OyYY","f73d6debe2440f2c":"5B14D","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"19M9B":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _updateApplicationForm = require("./UpdateApplicationForm");
var _updateApplicationFormDefault = parcelHelpers.interopDefault(_updateApplicationForm);
var _pageContainer = require("../../../components/structure/PageContainer");
var _pageContainerDefault = parcelHelpers.interopDefault(_pageContainer);
var _languageContainer = require("../../../hooks/LanguageContainer");
var _languageContainerDefault = parcelHelpers.interopDefault(_languageContainer);
const ApplicationInfoSettings = (props)=>{
    const [environment, setEnvironment] = (0, _react1.useState)(null);
    const languagesContainer = (0, _languageContainerDefault.default).useContainer();
    (0, _react1.useEffect)(()=>{
        getEnvironmentByOption();
    }, [
        props.applicationId,
        props.environmentOption
    ]);
    const getEnvironmentByOption = async ()=>{
        await props.environmentsContainer.loadEnvironments(props.applicationId);
        if (!props.environmentOption) return;
        // If app has Live env then environmentOption: "live" passed from ApplicationSettingsTab 
        // All new apps get both envs and all migrated ones do as well.
        // If some strange app only has one env and it is a Draft env then "draft" option passed in
        const selectedEnvironment = props.environmentsContainer.findEnvironmentByOption(props.applicationId, props.environmentOption);
        setEnvironment(selectedEnvironment);
        return selectedEnvironment;
    };
    return (0, _react.jsx)((0, _pageContainerDefault.default), null, (0, _react.jsx)((0, _updateApplicationFormDefault.default), {
        languageIds: languagesContainer.currentSelectedLanguages.map((c)=>c.id),
        appContainer: props.appContainer,
        app: props.appContainer.state.currentApp,
        key: languagesContainer.currentSelectedLanguages.map((c)=>c.id).join("|"),
        environmentOption: props.environmentOption,
        environment: environment,
        environmentsContainer: props.environmentsContainer
    }));
};
exports.default = ApplicationInfoSettings;

},{"@emotion/react":"djZKr","react":"6uln9","./UpdateApplicationForm":"2pKgr","../../../components/structure/PageContainer":"hc1r8","../../../hooks/LanguageContainer":"lchkU","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2pKgr":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _formik = require("formik");
var _yup = require("yup");
var _applicationInformationForm = require("../../formScenes/ApplicationInformationForm");
var _applicationInformationFormDefault = parcelHelpers.interopDefault(_applicationInformationForm);
var _applications = require("../../../api/controllers/applications");
const UpdateApplicationForm = (0, _formik.withFormik)({
    mapPropsToValues: (props)=>{
        const firstAppInfo = props.app?.applicationInformationItems?.find((a)=>a.languageId === props.languageIds[0]);
        if (!props.languageIds || props.languageIds.length < 1 || !firstAppInfo) {
            const formValuesFromProps = {
                name: props.app.name ? props.app.name : "",
                invocationPhrase: props.app.invocationPhrase ? props.app.invocationPhrase : "",
                shortDescription: props.app.shortDescription ? props.app.shortDescription : "",
                description: props.app.description ? props.app.description : "",
                keywords: props.app.keywords ? props.app.keywords : "",
                timeZone: props.app.timeZone ? props.app.timeZone : "",
                posConfig: null,
                imageItemId: props.app.imageItemId,
                imageFile: null,
                selectedFlagIds: props.app.featureFlags ? props.app.featureFlags?.map((f)=>f.id) : [],
                featureFlags: props.app.featureFlags ? props.app.featureFlags : [],
                posLocationId: props.app.posLocationId ? props.app.posLocationId : "",
                posName: props.app.posName ? props.app.posName : "",
                manageMenuApplicationId: props.app.manageMenuApplicationId ? props.app.manageMenuApplicationId : "",
                outboundCallIntegrationName: props.app.outboundCallIntegrationName ? props.app.outboundCallIntegrationName : "",
                outboundCallLocationId: props.app.outboundCallLocationId ? props.app.outboundCallLocationId : "",
                isLive: props.app.isLive ?? false
            };
            return formValuesFromProps;
        } else {
            const formValuesFromFirstApp = {
                name: firstAppInfo.name ? firstAppInfo.name : "",
                invocationPhrase: firstAppInfo.invocationPhrase ? firstAppInfo.invocationPhrase : "",
                shortDescription: firstAppInfo.shortDescription ? firstAppInfo.shortDescription : "",
                description: firstAppInfo.description ? firstAppInfo.description : "",
                keywords: firstAppInfo.keywords ? firstAppInfo.keywords : "",
                timeZone: firstAppInfo.timeZone ? firstAppInfo.timeZone : "",
                posConfig: null,
                imageItemId: props.app.imageItemId,
                imageFile: null,
                selectedFlagIds: firstAppInfo.featureFlags ? firstAppInfo.featureFlags?.map((f)=>f.id) : [],
                featureFlags: firstAppInfo.featureFlags ? firstAppInfo.featureFlags : [],
                posLocationId: props.app.posLocationId ? props.app.posLocationId : "",
                posName: props.app.posName ? props.app.posName : "",
                manageMenuApplicationId: props.app.manageMenuApplicationId ? props.app.manageMenuApplicationId : "",
                outboundCallIntegrationName: props.app.outboundCallIntegrationName ? props.app.outboundCallIntegrationName : "",
                outboundCallLocationId: props.app.outboundCallLocationId ? props.app.outboundCallLocationId : "",
                isLive: props.app.isLive ?? false
            };
            return formValuesFromFirstApp;
        }
    },
    validationSchema: _yup.object().shape({
        name: _yup.string().max(50).required("You must enter a name for your application"),
        shortDescription: _yup.string().max(160),
        description: _yup.string().max(4000),
        invocationPhrase: _yup.string().required("You must enter an invocation name for your application").matches(/^([^0-9\!\&\*\(\)\{\}\%\$\#\@\!\?\;\:\-\_\+\=\/\<\>\~]*)$/, "Invocation name cannot contain digits or special characters"),
        outboundCallLocationId: _yup.string().nullable() // Allow empty string
    }),
    handleSubmit: async (values, { props, setStatus })=>{
        var featureFlags = props.appContainer.state.featureFlags;
        const newFlags = featureFlags.filter((f)=>values.selectedFlagIds.includes(f.id));
        const updateApplicationRequest = {
            imageItemId: values.imageItemId,
            name: props.app.name,
            invocationPhrase: props.app.invocationPhrase,
            shortDescription: props.app.shortDescription,
            description: props.app.description,
            keywords: props.app.keywords,
            timeZone: values.timeZone,
            applicationInformationItems: props.app.applicationInformationItems ? props.app.applicationInformationItems : [],
            featureFlags: newFlags,
            manageMenuApplicationId: values.manageMenuApplicationId,
            posName: values.posName,
            posLocationId: values.posLocationId,
            OutboundCallIntegrationName: values.outboundCallIntegrationName,
            OutboundCallLocationId: values.outboundCallLocationId,
            isLive: values.isLive
        };
        const updateEnvironmentRequest = {
            imageItemId: values.imageItemId,
            name: props.environment?.name,
            applicationName: props.app.name,
            invocationPhrase: props.app.invocationPhrase,
            shortDescription: props.app.shortDescription,
            description: props.app.description,
            keywords: props.app.keywords,
            timeZone: values.timeZone,
            applicationInformationItems: props.app.applicationInformationItems ? props.app.applicationInformationItems : [],
            featureFlags: newFlags,
            manageMenuApplicationId: values.manageMenuApplicationId,
            posName: values.posName,
            posLocationId: values.posLocationId
        };
        if (!props.languageIds || props.languageIds.length < 1) {
            // Update No Language values
            updateApplicationRequest.name = values.name;
            updateApplicationRequest.invocationPhrase = values.invocationPhrase;
            updateApplicationRequest.shortDescription = values.shortDescription;
            updateApplicationRequest.description = values.description;
            updateApplicationRequest.keywords = values.keywords;
            updateApplicationRequest.featureFlags = newFlags;
            updateEnvironmentRequest.applicationName = values.name;
            updateEnvironmentRequest.invocationPhrase = values.invocationPhrase;
            updateEnvironmentRequest.shortDescription = values.shortDescription;
            updateEnvironmentRequest.description = values.description;
            updateEnvironmentRequest.keywords = values.keywords;
        } else // for each language we are updating, add it if new, or update the existing
        props.languageIds.forEach((languageId)=>{
            if (updateApplicationRequest.applicationInformationItems.some((a)=>a.languageId === languageId)) {
                const existingItem = updateApplicationRequest.applicationInformationItems.find((a)=>a.languageId === languageId);
                existingItem.name = values.name;
                existingItem.invocationPhrase = values.invocationPhrase;
                existingItem.shortDescription = values.shortDescription;
                existingItem.description = values.description;
                existingItem.keywords = values.keywords;
                existingItem.timeZone = values.timeZone;
                existingItem.environmentId = props.environment.id;
                existingItem.featureFlags = newFlags;
                existingItem.manageMenuApplicationId = values.manageMenuApplicationId;
                existingItem.posName = values.posName;
                existingItem.posLocationId = values.posLocationId;
            } else {
                const newItem = {
                    languageId: languageId,
                    name: values.name,
                    invocationPhrase: values.invocationPhrase,
                    shortDescription: values.shortDescription,
                    description: values.description,
                    keywords: values.keywords,
                    timeZone: values.timeZone,
                    environmentId: props.environment.id,
                    featureFlags: newFlags,
                    manageMenuApplicationId: values.manageMenuApplicationId,
                    posName: values.posName,
                    posLocationId: values.posLocationId
                };
                updateApplicationRequest.applicationInformationItems.push(newItem);
            }
            if (updateEnvironmentRequest.applicationInformationItems.some((a)=>a.languageId === languageId)) {
                const existingItem = updateEnvironmentRequest.applicationInformationItems.find((a)=>a.languageId === languageId);
                existingItem.name = values.name;
                existingItem.invocationPhrase = values.invocationPhrase;
                existingItem.shortDescription = values.shortDescription;
                existingItem.description = values.description;
                existingItem.keywords = values.keywords;
                existingItem.timeZone = values.timeZone;
                existingItem.environmentId = props.environment?.id;
                existingItem.featureFlags = newFlags;
                existingItem.manageMenuApplicationId = values.manageMenuApplicationId;
                existingItem.posName = values.posName;
                existingItem.posLocationId = values.posLocationId;
            } else {
                const newItem = {
                    languageId: languageId,
                    name: values.name,
                    invocationPhrase: values.invocationPhrase,
                    shortDescription: values.shortDescription,
                    description: values.description,
                    keywords: values.keywords,
                    timeZone: values.timeZone,
                    environmentId: props.environment?.id,
                    featureFlags: newFlags,
                    manageMenuApplicationId: values.manageMenuApplicationId,
                    posName: values.posName,
                    posLocationId: values.posLocationId
                };
                updateEnvironmentRequest.applicationInformationItems.push(newItem);
            }
        });
        // Update Application Settings
        await props.appContainer.updateApplication(props.app.id, updateApplicationRequest).then(async (result)=>{
            if (values.imageFile) await props.appContainer.updateApplicationImage(props.app.id, values.imageFile).then((imgResult)=>{
                // Get application's new imageItemId and assign it to Live environment
                updateEnvironmentRequest.imageItemId = imgResult?.data?.id;
            });
            //update the pos config
            if (values.posConfig && values.posConfig.length > 0) await _applications.updatePOSConfig(props.app.id, values.posConfig);
            let message = "";
            if (result.resultType === "Ok") message = "Application updated successfully";
            else message = "There was an error updating the application";
            setTimeout(()=>{
                setStatus({
                    message
                });
            }, 5000);
        });
        // Update Live Environment Settings
        if (props.environmentOption === "live" && props.environment) props.environmentsContainer.updateEnvironmentSettings(props.app.id, props.environment.id, updateEnvironmentRequest);
    }
})((0, _applicationInformationFormDefault.default));
exports.default = UpdateApplicationForm;

},{"formik":"3YnOK","yup":"j2SJU","../../formScenes/ApplicationInformationForm":"f4xmb","../../../api/controllers/applications":"1me18","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"f4xmb":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _base = require("@emotion/styled/base");
var _baseDefault = parcelHelpers.interopDefault(_base);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _button = require("../../components/general/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _horizontalContainer = require("../../components/structure/HorizontalContainer");
var _horizontalContainerDefault = parcelHelpers.interopDefault(_horizontalContainer);
var _imageUploadContainer = require("../../components/structure/ImageUploadContainer");
var _imageUploadContainerDefault = parcelHelpers.interopDefault(_imageUploadContainer);
var _avatarFileUploadField = require("../../components/forms/AvatarFileUploadField");
var _avatarFileUploadFieldDefault = parcelHelpers.interopDefault(_avatarFileUploadField);
var _formFieldsContainer = require("../../components/structure/FormFieldsContainer");
var _formFieldsContainerDefault = parcelHelpers.interopDefault(_formFieldsContainer);
var _textField = require("../../components/forms/TextField");
var _textFieldDefault = parcelHelpers.interopDefault(_textField);
var _textAreaField = require("../../components/forms/TextAreaField");
var _textAreaFieldDefault = parcelHelpers.interopDefault(_textAreaField);
var _modalTitle = require("../../components/general/ModalTitle");
var _modalTitleDefault = parcelHelpers.interopDefault(_modalTitle);
var _checkboxField = require("../../components/forms/CheckboxField");
var _checkboxFieldDefault = parcelHelpers.interopDefault(_checkboxField);
var _switch = require("../../components/forms/Switch");
var _switchDefault = parcelHelpers.interopDefault(_switch);
var _contentCollapsingSection = require("../../components/structure/ContentCollapsingSection");
var _contentCollapsingSectionDefault = parcelHelpers.interopDefault(_contentCollapsingSection);
var _styledDropdown = require("../applicationSettings/components/customAssistantConfigurations/StyledDropdown");
var _styledDropdownDefault = parcelHelpers.interopDefault(_styledDropdown);
var _colors = require("../../constants/colors");
var _posNames = require("../../constants/posNames");
var _momentTimezone = require("moment-timezone");
var _momentTimezoneDefault = parcelHelpers.interopDefault(_momentTimezone);
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const advancedSettingsIcon = require("df4c66c7bbc41a63");
const importIcon = require("127f0c8af4c7f317");
const posNameOptions = [
    {
        label: "Custom",
        value: "Custom"
    },
    {
        label: "Speedline",
        value: (0, _posNames.SPEEDLINE)
    },
    {
        label: "Olo",
        value: (0, _posNames.OLO)
    },
    {
        label: "Adora",
        value: (0, _posNames.ADORA)
    },
    {
        label: "Toast",
        value: (0, _posNames.TOAST)
    },
    {
        label: "Paytronix",
        value: (0, _posNames.PAYTRONIX)
    }
];
const OutboundCallIntegrationOptions = [
    {
        label: "Denticon",
        value: "Denticon"
    },
    {
        label: "Dentrix Ascend",
        value: "DentrixAscend"
    },
    {
        label: "Epic",
        value: "Epic"
    },
    {
        label: "Salesforce",
        value: "Salesforce"
    }
];
const ApplicationInformationForm = (props)=>{
    const [imageUrl, setImageUrl] = (0, _react1.useState)(props.app.imageUrl);
    const [isPosConfigLoading, setIsPosConfigLoading] = (0, _react1.useState)(false);
    (0, _react1.useEffect)(()=>{
        props.appContainer.loadFeatureFlags();
        // set default pos name value if one isn't saved yet
        if (!props.app.posName) props.setFieldValue("posName", "SPEEDLINE");
        if (props.appContainer.state.posConfig) props.setFieldValue("posConfig", props.appContainer.state.posConfig);
    }, []);
    const isLoading = props.appContainer.state.isCreatingApplication;
    const allFeatureFlags = props.appContainer.state.featureFlags;
    const handleLoadPosConfig = async ()=>{
        if (!props.app.id) return;
        setIsPosConfigLoading(true);
        await props.appContainer.loadPOSConfig(props.app.id);
        props.setFieldValue("posConfig", props.appContainer.state.posConfig);
        setIsPosConfigLoading(false);
    };
    const handleFeatureFlagsChange = (flag)=>{
        // manage check box
        const flagsCopy = [
            ...props.values.selectedFlagIds
        ];
        if (flagsCopy.includes(flag.id)) flagsCopy.splice(flagsCopy.indexOf(flag.id), 1);
        else flagsCopy.push(flag.id);
        props.setFieldValue("selectedFlagIds", flagsCopy);
    };
    const handlePOSNameChange = (optionValue, value)=>{
        props.setFieldValue(optionValue, value);
    };
    const handleOutboundCallIntegrationNameChange = (optionValue, value)=>{
        props.setFieldValue(optionValue, value);
    };
    const handleFoodOrderingGenerativeAIModelChange = (optionValue, value)=>{
        const featureFlag = props.values.featureFlags?.find((f)=>f.name === optionValue);
        // featureFlag.GenerativeAIModel = value as string;
        props.setFieldValue("featureFlags", [
            ...props.values.featureFlags
        ]);
    };
    const usingCustomPOS = props.values.posName === "Custom" || !posNameOptions.some((o)=>o.value === props.values.posName);
    const renderFeatureFlags = ()=>{
        return allFeatureFlags.map((flag, index)=>{
            return (0, _react.jsx)((0, _reactDefault.default).Fragment, null, (0, _react.jsx)((0, _checkboxFieldDefault.default), {
                key: `KEY ${index}`,
                name: flag.name,
                label: flag.name,
                labelStyle: checkboxLabelStyle,
                disabled: isLoading,
                checked: props.values.selectedFlagIds.includes(flag.id),
                onChange: ()=>handleFeatureFlagsChange(flag),
                className: checkboxField
            }), flag.name == "Food Ordering" && props.values.selectedFlagIds.includes(flag.id) && (0, _react.jsx)(AdvancedSettingsFieldsWrapper, null, (0, _react.jsx)((0, _textFieldDefault.default), {
                name: "posLocationId",
                disabled: isLoading,
                value: props.values.posLocationId,
                label: "Location ID",
                placeholder: "The location ID in the POS",
                onChange: props.handleChange,
                onBlur: props.handleBlur
            }), (0, _react.jsx)(CustomDropdown, {
                label: "POS Name",
                disabled: isLoading,
                handleOnChange: handlePOSNameChange,
                fieldName: "posName",
                options: posNameOptions,
                size: "medium",
                searchable: true,
                value: usingCustomPOS ? "Custom" : props.values.posName
            }), usingCustomPOS && (0, _react.jsx)((0, _textFieldDefault.default), {
                name: "posName",
                disabled: isLoading,
                value: props.values.posName,
                label: "Custom POS Name",
                placeholder: "The name of the POS",
                onChange: props.handleChange,
                onBlur: props.handleBlur
            }), (0, _react.jsx)((0, _textFieldDefault.default), {
                name: "manageMenuApplicationId",
                disabled: isLoading,
                value: props.values.manageMenuApplicationId,
                label: "Manage Menu Application ID",
                placeholder: "The Id of the Voicify application that manages the menu",
                onChange: props.handleChange,
                onBlur: props.handleBlur
            })), flag.name == "Outbound Calling" && props.values.selectedFlagIds.includes(flag.id) && (0, _react.jsx)(AdvancedSettingsFieldsWrapper, null, (0, _react.jsx)((0, _textFieldDefault.default), {
                name: "outboundCallLocationId",
                disabled: isLoading,
                value: props.values.outboundCallLocationId,
                label: "Location ID",
                placeholder: "The location ID or office ID",
                onChange: props.handleChange,
                onBlur: props.handleBlur
            }), (0, _react.jsx)(CustomDropdown, {
                label: "Integration",
                disabled: isLoading,
                handleOnChange: handleOutboundCallIntegrationNameChange,
                fieldName: "outboundCallIntegrationName",
                options: OutboundCallIntegrationOptions,
                size: "medium",
                searchable: true,
                value: props.values.outboundCallIntegrationName
            })));
        });
    };
    const readDataUrl = ()=>{
        const reader = new FileReader();
        reader.onloadend = (e)=>{
            setImageUrl(reader.result.toString());
        };
    };
    const handleImageSelected = (file)=>{
        readDataUrl();
        props.setFieldValue("imageFile", file);
    };
    return (0, _react.jsx)("form", {
        onSubmit: props.handleSubmit
    }, (0, _react.jsx)((0, _modalTitleDefault.default), null, "App Info"), (0, _react.jsx)((0, _horizontalContainerDefault.default), null, (0, _react.jsx)((0, _formFieldsContainerDefault.default), {
        className: borderedFields
    }, (0, _react.jsx)(NormalSettingsWrapper, null, (0, _react.jsx)("p", {
        className: "detail-label"
    }, "Here you can manage the public-facing aspects of your application."), (0, _react.jsx)("p", {
        className: "detail-label"
    }, "Application Name is how you identify your app. Invocation Name is the phrase people will use to call up your application on their device"), (0, _react.jsx)((0, _textFieldDefault.default), {
        name: "name",
        disabled: isLoading,
        required: true,
        value: props.values.name,
        label: "Application Name:",
        placeholder: "Give your application a name",
        onChange: props.handleChange,
        onBlur: props.handleBlur
    }), (0, _react.jsx)((0, _textFieldDefault.default), {
        name: "invocationPhrase",
        disabled: isLoading,
        tooltip: "Invocation Name is the phrase people will use to call up your application on their device",
        required: true,
        value: props.values.invocationPhrase,
        label: "Invocation Name:",
        placeholder: "The name used to start your app",
        onChange: props.handleChange,
        onBlur: props.handleBlur
    }), (0, _react.jsx)((0, _textFieldDefault.default), {
        name: "shortDescription",
        disabled: isLoading,
        value: props.values.shortDescription,
        label: "Short Description:",
        placeholder: "Just something brief",
        onChange: props.handleChange,
        onBlur: props.handleBlur
    }), (0, _react.jsx)((0, _textAreaFieldDefault.default), {
        name: "description",
        disabled: isLoading,
        value: props.values.description,
        label: "Detailed Description:",
        placeholder: "Now with more detail",
        onChange: props.handleChange,
        onBlur: props.handleBlur
    }), (0, _react.jsx)((0, _textFieldDefault.default), {
        name: "keywords",
        disabled: isLoading,
        value: props.values.keywords,
        label: "Keywords:",
        placeholder: "These can help with finding your app/skill",
        onChange: props.handleChange,
        onBlur: props.handleBlur
    }), (0, _react.jsx)(CustomDropdown, {
        label: "Time Zone",
        disabled: isLoading,
        handleOnChange: props.setFieldValue,
        fieldName: "timeZone",
        options: (0, _momentTimezoneDefault.default).tz.names().map((timezone)=>({
                value: timezone,
                label: timezone
            })),
        size: "medium",
        searchable: true,
        value: props.values.timeZone
    }), (0, _react.jsx)(PosConfigContainer, null, (0, _react.jsx)("label", {
        className: "pos-config-label"
    }, "POS Configuration:"), (0, _react.jsx)((0, _buttonDefault.default), {
        type: "button",
        themes: [
            "secondary-small"
        ],
        icon: importIcon,
        text: isPosConfigLoading ? "Loading..." : "Load POS Config",
        disabled: isLoading || isPosConfigLoading,
        loading: isPosConfigLoading,
        onClick: handleLoadPosConfig,
        className: "pos-config-button"
    }), props.values.posConfig != null && (0, _react.jsx)((0, _reactDefault.default).Fragment, null, props.values.posName === (0, _posNames.SPEEDLINE) && (0, _react.jsx)(PosConfigNote, null, "Note: The config does not show the world pay credentials"), (0, _react.jsx)((0, _textAreaFieldDefault.default), {
        name: "posConfig",
        disabled: isLoading,
        value: props.values.posConfig,
        label: "",
        placeholder: "Enter POS configuration (JSON format)",
        className: "field_value",
        onChange: props.handleChange
    })))), (0, _react.jsx)((0, _contentCollapsingSectionDefault.default), {
        title: "Advanced Options",
        icon: advancedSettingsIcon,
        isCollapsedByDefault: true,
        className: collapsedSection,
        bottom: true
    }, renderFeatureFlags(), (0, _react.jsx)((0, _switchDefault.default), {
        checked: props.values.isLive ?? false,
        onChange: (enabled)=>props.setFieldValue("isLive", enabled),
        label: "Go Live"
    })), (0, _react.jsx)("div", {
        className: saveButtonWrapperStyle
    }, (0, _react.jsx)((0, _buttonDefault.default), {
        loading: isLoading,
        disabled: isLoading,
        themes: [
            "primary"
        ],
        text: "Save",
        type: "submit"
    }), props?.status?.message && (0, _react.jsx)(StatusMessage, null, props.status.message))), (0, _react.jsx)((0, _imageUploadContainerDefault.default), null, (0, _react.jsx)("label", null, "App Avatar"), (0, _react.jsx)((0, _avatarFileUploadFieldDefault.default), {
        imageUrl: imageUrl,
        accept: ".png",
        onChange: handleImageSelected.bind(undefined)
    }))));
};
const CustomDropdown = /*#__PURE__*/ (0, _baseDefault.default)((0, _styledDropdownDefault.default), {
    target: "e1o3hhsn5"
})({
    name: "18rrv6e",
    styles: "margin:8px 0 26px 0"
});
const PosConfigContainer = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1o3hhsn4"
})(".pos-config-label{margin-bottom:12px;display:block;font-size:14px;font-weight:500;color:", (0, _colors.color_text_default), ";}.pos-config-button{margin:0 0 16px 0!important;.left-img{width:16px;height:16px;margin-right:8px;}&:hover{transform:translateY(-1px);transition:transform 0.2s ease;}&:active{transform:translateY(0);}}");
const PosConfigNote = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1o3hhsn3"
})({
    name: "1tmanfc",
    styles: "margin-top:8px;font-size:14px;color:#666"
});
const StatusMessage = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1o3hhsn2"
})("width:30%;margin:auto;margin-top:20px;padding:10px;border-radius:4px;background-color:", (0, _colors.light_black), ";color:", (0, _colors.color_text_default), ";font-size:14px;text-align:center;");
const checkboxField = /*#__PURE__*/ (0, _css.css)({
    name: "1urdq9i",
    styles: "padding:0 24px"
});
const checkboxLabelStyle = /*#__PURE__*/ (0, _css.css)({
    name: "11g4mt0",
    styles: "font-size:16px"
});
const NormalSettingsWrapper = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1o3hhsn1"
})({
    name: "qj4bon",
    styles: "padding-right:64px;.field_value{width:100%;margin-top:14px;label{margin-left:6px;}textarea{overflow-y:auto;}&[name=\"posConfig\"] textarea{font-family:'Courier New',monospace;font-size:12px;min-height:150px;white-space:pre-wrap;word-wrap:break-word;overflow-wrap:break-word;line-height:1.4;}}"
});
const AdvancedSettingsFieldsWrapper = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1o3hhsn0"
})({
    name: "z3sfcj",
    styles: "padding-right:34px;margin:auto;margin-left:60px"
});
const collapsedSection = /*#__PURE__*/ (0, _css.css)({
    name: "xiywgd",
    styles: "margin-left:-50px;*.card-title-container{padding:24px 24px 24px 40px;}"
});
const borderedFields = /*#__PURE__*/ (0, _css.css)({
    name: "2hcm3",
    styles: "border-right:1px solid #c7cfd2;margin-top:0;.detail-label{font-family:Muli;font-size:12px;font-weight:normal;font-stretch:normal;font-style:normal;line-height:normal;letter-spacing:0.5px;color:#8e97a1;margin-bottom:16px;}"
});
const saveButtonWrapperStyle = /*#__PURE__*/ (0, _css.css)({
    name: "zjik7",
    styles: "display:flex"
});
exports.default = ApplicationInformationForm;

},{"@emotion/styled/base":"lSuFu","@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","../../components/general/Button":"6ymxN","../../components/structure/HorizontalContainer":"eJPfh","../../components/structure/ImageUploadContainer":"jmeXJ","../../components/forms/AvatarFileUploadField":"fAjrB","../../components/structure/FormFieldsContainer":"h3hzh","../../components/forms/TextField":"7a7bh","../../components/forms/TextAreaField":"fE54C","../../components/general/ModalTitle":"hIp2B","../../components/forms/CheckboxField":"3S5Oy","../../components/forms/Switch":"8kkL9","../../components/structure/ContentCollapsingSection":"1CUms","../applicationSettings/components/customAssistantConfigurations/StyledDropdown":"hjrMo","../../constants/colors":"1p3OR","../../constants/posNames":"hqmAX","moment-timezone":"2wlXV","df4c66c7bbc41a63":"1PtXC","127f0c8af4c7f317":"2vkHX","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jmeXJ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _colors = require("../../constants/colors");
const containerStyle = /*#__PURE__*/ (0, _css.css)("width:500px;display:flex;flex-direction:column;align-items:center;label{font-family:Muli;font-size:18px;font-weight:normal;font-style:normal;font-stretch:normal;line-height:normal;letter-spacing:normal;text-align:center;color:", (0, _colors.dark_grey_blue), ";}", "");
const ImageUploadContainer = (props)=>(0, _react.jsx)("div", {
        className: `${containerStyle} ${props.className ?? ""}`
    }, props.children);
exports.default = ImageUploadContainer;

},{"@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","../../constants/colors":"1p3OR","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"fAjrB":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _base = require("@emotion/styled/base");
var _baseDefault = parcelHelpers.interopDefault(_base);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _reactDropzone = require("react-dropzone");
var _reactDropzoneDefault = parcelHelpers.interopDefault(_reactDropzone);
var _button = require("../general/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _colors = require("../../constants/colors");
var _uploadFileSize = require("../../constants/UploadFileSize");
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const newImageIcon = require("d5a0002b106efe87");
const AvatarFileUploadField = (props)=>{
    const [imageUrl, setImageUrl] = (0, _react1.useState)(props.imageUrl);
    let dropZone;
    const readDataUrl = (file)=>{
        const reader = new FileReader();
        reader.onloadend = (e)=>{
            setImageUrl(reader.result.toString());
        };
        reader.readAsDataURL(file);
    };
    const handleFilePicked = (files)=>{
        if (files.length > 0) {
            const fileType = (0, _uploadFileSize.getFileTypeFromFileName)(files[0].name);
            if (fileType === "ImageFile" && files[0].size > (0, _uploadFileSize.MaxImageBytesSize)) {
                const imageSizeAllowed = Math.round((0, _uploadFileSize.MaxImageBytesSize) * (0, _uploadFileSize.BytesToMegabytesMultiplier));
                alert(`[${files[0].name}] image is too large. Please select a smaller image file. The max file size allowed is ${imageSizeAllowed}MB`);
                return;
            }
            readDataUrl(files[0]);
            props.onChange(files[0]);
        } else setImageUrl(undefined);
    };
    return (0, _react.jsx)("div", {
        className: props.containerStyle ? props.containerStyle : containerStyle
    }, (0, _react.jsx)(Label, null, props.label ? props.label : null), (0, _react.jsx)((0, _reactDropzoneDefault.default), {
        className: "dropZone",
        ref: (node)=>{
            dropZone = node;
        },
        onDrop: handleFilePicked.bind(undefined),
        accept: props.accept,
        multiple: false
    }, (0, _react.jsx)("div", {
        className: props.previewStyle ? props.previewStyle : previewStyle
    }, (0, _react.jsx)("img", {
        className: props.imageStyle ? imageUrl == null ? props.defaultImageStyle : props.imageStyle : imageUrl == null ? defaultImageStyle : imageStyle,
        src: imageUrl ?? newImageIcon
    })), (0, _react.jsx)("div", null, (0, _react.jsx)((0, _buttonDefault.default), {
        rightIcon: props.addIcon,
        className: `${props.buttonStyle} ${buttonStyle}`,
        themes: [
            "small-flat"
        ],
        text: props.addImageText ? props.addImageText : `Add an Image`,
        type: "button"
    }))));
};
const Label = /*#__PURE__*/ (0, _baseDefault.default)("p", {
    target: "e1vpsd710"
})("font-weight:400;font-size:14px;color:", (0, _colors.color_text_default), ";margin-left:16px;margin-bottom:8px;");
const buttonStyle = /*#__PURE__*/ (0, _css.css)({
    name: "1e182it",
    styles: "span{line-height:20px;font-size:14px;}"
});
const imageStyle = /*#__PURE__*/ (0, _css.css)({
    name: "17de294",
    styles: "width:165px;height:165px;left:0px;top:0px;position:absolute"
});
const defaultImageStyle = /*#__PURE__*/ (0, _css.css)({
    name: "f67qa6",
    styles: "width:75px;height:75px;left:50px;top:40px;position:absolute"
});
const previewStyle = /*#__PURE__*/ (0, _css.css)("width:165px;height:165px;padding:30px;background-color:#ffffff;border:solid 2px #c7cfd2;border-radius:50%;overflow:hidden;position:relative;box-shadow:0px 4px 10px ", (0, _colors.color_variants_shadow_10), ";", "");
const containerStyle = /*#__PURE__*/ (0, _css.css)({
    name: "13ozy8w",
    styles: "display:flex;flex-direction:column;.dropZone{display:flex;flex-direction:column;align-items:center;height:auto;width:auto;border-radius:20;border:none;justify-content:center;cursor:pointer;margin:32px 0;margin-bottom:0px;}"
});
exports.default = AvatarFileUploadField;

},{"@emotion/styled/base":"lSuFu","@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","react-dropzone":"46RRi","../general/Button":"6ymxN","../../constants/colors":"1p3OR","../../constants/UploadFileSize":"5inYb","d5a0002b106efe87":"8gixT","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8gixT":[function(require,module,exports) {
module.exports = require("bc21e721104e1a12").getBundleURL("kVLro") + require("a6942050e51d24f").resolve("6tbNi");

},{"bc21e721104e1a12":"c7Tr5","a6942050e51d24f":"fyJL2"}],"hqmAX":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "OLO", ()=>OLO);
parcelHelpers.export(exports, "SPEEDLINE", ()=>SPEEDLINE);
parcelHelpers.export(exports, "ADORA", ()=>ADORA);
parcelHelpers.export(exports, "TOAST", ()=>TOAST);
parcelHelpers.export(exports, "PAYTRONIX", ()=>PAYTRONIX);
const OLO = "OLO";
const SPEEDLINE = "SPEEDLINE";
const ADORA = "ADORA";
const TOAST = "TOAST";
const PAYTRONIX = "PAYTRONIX";

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2wlXV":[function(require,module,exports) {
var moment = module.exports = require("a3307e19e25878f5");
moment.tz.load(require("26482b68cc607116"));

},{"a3307e19e25878f5":"cmpb8","26482b68cc607116":"aqvBE"}],"cmpb8":[function(require,module,exports) {
//! moment-timezone.js
//! version : 0.6.0
//! Copyright (c) JS Foundation and other contributors
//! license : MIT
//! github.com/moment/moment-timezone
(function(root, factory) {
    "use strict";
    /*global define*/ if (0, module.exports) module.exports = factory(require("782152beb30574e4")); // Node
    else if (typeof define === "function" && define.amd) define([
        "moment"
    ], factory); // AMD
    else factory(root.moment); // Browser
})(this, function(moment) {
    "use strict";
    // Resolves es6 module loading issue
    if (moment.version === undefined && moment.default) moment = moment.default;
    // Do not load moment-timezone a second time.
    // if (moment.tz !== undefined) {
    // 	logError('Moment Timezone ' + moment.tz.version + ' was already loaded ' + (moment.tz.dataVersion ? 'with data from ' : 'without any data') + moment.tz.dataVersion);
    // 	return moment;
    // }
    var VERSION = "0.6.0", zones = {}, links = {}, countries = {}, names = {}, guesses = {}, cachedGuess;
    if (!moment || typeof moment.version !== "string") logError("Moment Timezone requires Moment.js. See https://momentjs.com/timezone/docs/#/use-it/browser/");
    var momentVersion = moment.version.split("."), major = +momentVersion[0], minor = +momentVersion[1];
    // Moment.js version check
    if (major < 2 || major === 2 && minor < 6) logError("Moment Timezone requires Moment.js >= 2.6.0. You are using Moment.js " + moment.version + ". See momentjs.com");
    /************************************
		Unpacking
	************************************/ function charCodeToInt(charCode) {
        if (charCode > 96) return charCode - 87;
        else if (charCode > 64) return charCode - 29;
        return charCode - 48;
    }
    function unpackBase60(string) {
        var i = 0, parts = string.split("."), whole = parts[0], fractional = parts[1] || "", multiplier = 1, num, out = 0, sign = 1;
        // handle negative numbers
        if (string.charCodeAt(0) === 45) {
            i = 1;
            sign = -1;
        }
        // handle digits before the decimal
        for(i; i < whole.length; i++){
            num = charCodeToInt(whole.charCodeAt(i));
            out = 60 * out + num;
        }
        // handle digits after the decimal
        for(i = 0; i < fractional.length; i++){
            multiplier = multiplier / 60;
            num = charCodeToInt(fractional.charCodeAt(i));
            out += num * multiplier;
        }
        return out * sign;
    }
    function arrayToInt(array) {
        for(var i = 0; i < array.length; i++)array[i] = unpackBase60(array[i]);
    }
    function intToUntil(array, length) {
        for(var i = 0; i < length; i++)array[i] = Math.round((array[i - 1] || 0) + array[i] * 60000); // minutes to milliseconds
        array[length - 1] = Infinity;
    }
    function mapIndices(source, indices) {
        var out = [], i;
        for(i = 0; i < indices.length; i++)out[i] = source[indices[i]];
        return out;
    }
    function unpack(string) {
        var data = string.split("|"), offsets = data[2].split(" "), indices = data[3].split(""), untils = data[4].split(" ");
        arrayToInt(offsets);
        arrayToInt(indices);
        arrayToInt(untils);
        intToUntil(untils, indices.length);
        return {
            name: data[0],
            abbrs: mapIndices(data[1].split(" "), indices),
            offsets: mapIndices(offsets, indices),
            untils: untils,
            population: data[5] | 0
        };
    }
    /************************************
		Zone object
	************************************/ function Zone(packedString) {
        if (packedString) this._set(unpack(packedString));
    }
    function closest(num, arr) {
        var len = arr.length;
        if (num < arr[0]) return 0;
        else if (len > 1 && arr[len - 1] === Infinity && num >= arr[len - 2]) return len - 1;
        else if (num >= arr[len - 1]) return -1;
        var mid;
        var lo = 0;
        var hi = len - 1;
        while(hi - lo > 1){
            mid = Math.floor((lo + hi) / 2);
            if (arr[mid] <= num) lo = mid;
            else hi = mid;
        }
        return hi;
    }
    Zone.prototype = {
        _set: function(unpacked) {
            this.name = unpacked.name;
            this.abbrs = unpacked.abbrs;
            this.untils = unpacked.untils;
            this.offsets = unpacked.offsets;
            this.population = unpacked.population;
        },
        _index: function(timestamp) {
            var target = +timestamp, untils = this.untils, i;
            i = closest(target, untils);
            if (i >= 0) return i;
        },
        countries: function() {
            var zone_name = this.name;
            return Object.keys(countries).filter(function(country_code) {
                return countries[country_code].zones.indexOf(zone_name) !== -1;
            });
        },
        parse: function(timestamp) {
            var target = +timestamp, offsets = this.offsets, untils = this.untils, max = untils.length - 1, offset, offsetNext, offsetPrev, i;
            for(i = 0; i < max; i++){
                offset = offsets[i];
                offsetNext = offsets[i + 1];
                offsetPrev = offsets[i ? i - 1 : i];
                if (offset < offsetNext && tz.moveAmbiguousForward) offset = offsetNext;
                else if (offset > offsetPrev && tz.moveInvalidForward) offset = offsetPrev;
                if (target < untils[i] - offset * 60000) return offsets[i];
            }
            return offsets[max];
        },
        abbr: function(mom) {
            return this.abbrs[this._index(mom)];
        },
        offset: function(mom) {
            logError("zone.offset has been deprecated in favor of zone.utcOffset");
            return this.offsets[this._index(mom)];
        },
        utcOffset: function(mom) {
            return this.offsets[this._index(mom)];
        }
    };
    /************************************
		Country object
	************************************/ function Country(country_name, zone_names) {
        this.name = country_name;
        this.zones = zone_names;
    }
    /************************************
		Current Timezone
	************************************/ function OffsetAt(at) {
        var timeString = at.toTimeString();
        var abbr = timeString.match(/\([a-z ]+\)/i);
        if (abbr && abbr[0]) {
            // 17:56:31 GMT-0600 (CST)
            // 17:56:31 GMT-0600 (Central Standard Time)
            abbr = abbr[0].match(/[A-Z]/g);
            abbr = abbr ? abbr.join("") : undefined;
        } else {
            // 17:56:31 CST
            // 17:56:31 GMT+0800 (台北標準時間)
            abbr = timeString.match(/[A-Z]{3,5}/g);
            abbr = abbr ? abbr[0] : undefined;
        }
        if (abbr === "GMT") abbr = undefined;
        this.at = +at;
        this.abbr = abbr;
        this.offset = at.getTimezoneOffset();
    }
    function ZoneScore(zone) {
        this.zone = zone;
        this.offsetScore = 0;
        this.abbrScore = 0;
    }
    ZoneScore.prototype.scoreOffsetAt = function(offsetAt) {
        this.offsetScore += Math.abs(this.zone.utcOffset(offsetAt.at) - offsetAt.offset);
        if (this.zone.abbr(offsetAt.at).replace(/[^A-Z]/g, "") !== offsetAt.abbr) this.abbrScore++;
    };
    function findChange(low, high) {
        var mid, diff;
        while(diff = ((high.at - low.at) / 12e4 | 0) * 6e4){
            mid = new OffsetAt(new Date(low.at + diff));
            if (mid.offset === low.offset) low = mid;
            else high = mid;
        }
        return low;
    }
    function userOffsets() {
        var startYear = new Date().getFullYear() - 2, last = new OffsetAt(new Date(startYear, 0, 1)), lastOffset = last.offset, offsets = [
            last
        ], change, next, nextOffset, i;
        for(i = 1; i < 48; i++){
            nextOffset = new Date(startYear, i, 1).getTimezoneOffset();
            if (nextOffset !== lastOffset) {
                // Create OffsetAt here to avoid unnecessary abbr parsing before checking offsets
                next = new OffsetAt(new Date(startYear, i, 1));
                change = findChange(last, next);
                offsets.push(change);
                offsets.push(new OffsetAt(new Date(change.at + 6e4)));
                last = next;
                lastOffset = nextOffset;
            }
        }
        for(i = 0; i < 4; i++){
            offsets.push(new OffsetAt(new Date(startYear + i, 0, 1)));
            offsets.push(new OffsetAt(new Date(startYear + i, 6, 1)));
        }
        return offsets;
    }
    function sortZoneScores(a, b) {
        if (a.offsetScore !== b.offsetScore) return a.offsetScore - b.offsetScore;
        if (a.abbrScore !== b.abbrScore) return a.abbrScore - b.abbrScore;
        if (a.zone.population !== b.zone.population) return b.zone.population - a.zone.population;
        return b.zone.name.localeCompare(a.zone.name);
    }
    function addToGuesses(name, offsets) {
        var i, offset;
        arrayToInt(offsets);
        for(i = 0; i < offsets.length; i++){
            offset = offsets[i];
            guesses[offset] = guesses[offset] || {};
            guesses[offset][name] = true;
        }
    }
    function guessesForUserOffsets(offsets) {
        var offsetsLength = offsets.length, filteredGuesses = {}, out = [], checkedOffsets = {}, i, j, offset, guessesOffset;
        for(i = 0; i < offsetsLength; i++){
            offset = offsets[i].offset;
            if (checkedOffsets.hasOwnProperty(offset)) continue;
            guessesOffset = guesses[offset] || {};
            for(j in guessesOffset)if (guessesOffset.hasOwnProperty(j)) filteredGuesses[j] = true;
            checkedOffsets[offset] = true;
        }
        for(i in filteredGuesses)if (filteredGuesses.hasOwnProperty(i)) out.push(names[i]);
        return out;
    }
    function rebuildGuess() {
        // use Intl API when available and returning valid time zone
        try {
            var intlName = Intl.DateTimeFormat().resolvedOptions().timeZone;
            if (intlName && intlName.length > 3) {
                var name = names[normalizeName(intlName)];
                if (name) return name;
                logError("Moment Timezone found " + intlName + " from the Intl api, but did not have that data loaded.");
            }
        } catch (e) {
        // Intl unavailable, fall back to manual guessing.
        }
        var offsets = userOffsets(), offsetsLength = offsets.length, guesses = guessesForUserOffsets(offsets), zoneScores = [], zoneScore, i, j;
        for(i = 0; i < guesses.length; i++){
            zoneScore = new ZoneScore(getZone(guesses[i]), offsetsLength);
            for(j = 0; j < offsetsLength; j++)zoneScore.scoreOffsetAt(offsets[j]);
            zoneScores.push(zoneScore);
        }
        zoneScores.sort(sortZoneScores);
        return zoneScores.length > 0 ? zoneScores[0].zone.name : undefined;
    }
    function guess(ignoreCache) {
        if (!cachedGuess || ignoreCache) cachedGuess = rebuildGuess();
        return cachedGuess;
    }
    /************************************
		Global Methods
	************************************/ function normalizeName(name) {
        return (name || "").toLowerCase().replace(/\//g, "_");
    }
    function addZone(packed) {
        var i, name, split, normalized;
        if (typeof packed === "string") packed = [
            packed
        ];
        for(i = 0; i < packed.length; i++){
            split = packed[i].split("|");
            name = split[0];
            normalized = normalizeName(name);
            zones[normalized] = packed[i];
            names[normalized] = name;
            addToGuesses(normalized, split[2].split(" "));
        }
    }
    function getZone(name, caller) {
        name = normalizeName(name);
        var zone = zones[name];
        var link;
        if (zone instanceof Zone) return zone;
        if (typeof zone === "string") {
            zone = new Zone(zone);
            zones[name] = zone;
            return zone;
        }
        // Pass getZone to prevent recursion more than 1 level deep
        if (links[name] && caller !== getZone && (link = getZone(links[name], getZone))) {
            zone = zones[name] = new Zone();
            zone._set(link);
            zone.name = names[name];
            return zone;
        }
        return null;
    }
    function getNames() {
        var i, out = [];
        for(i in names)if (names.hasOwnProperty(i) && (zones[i] || zones[links[i]]) && names[i]) out.push(names[i]);
        return out.sort();
    }
    function getCountryNames() {
        return Object.keys(countries);
    }
    function addLink(aliases) {
        var i, alias, normal0, normal1;
        if (typeof aliases === "string") aliases = [
            aliases
        ];
        for(i = 0; i < aliases.length; i++){
            alias = aliases[i].split("|");
            normal0 = normalizeName(alias[0]);
            normal1 = normalizeName(alias[1]);
            links[normal0] = normal1;
            names[normal0] = alias[0];
            links[normal1] = normal0;
            names[normal1] = alias[1];
        }
    }
    function addCountries(data) {
        var i, country_code, country_zones, split;
        if (!data || !data.length) return;
        for(i = 0; i < data.length; i++){
            split = data[i].split("|");
            country_code = split[0].toUpperCase();
            country_zones = split[1].split(" ");
            countries[country_code] = new Country(country_code, country_zones);
        }
    }
    function getCountry(name) {
        name = name.toUpperCase();
        return countries[name] || null;
    }
    function zonesForCountry(country, with_offset) {
        country = getCountry(country);
        if (!country) return null;
        var zones = country.zones.sort();
        if (with_offset) return zones.map(function(zone_name) {
            var zone = getZone(zone_name);
            return {
                name: zone_name,
                offset: zone.utcOffset(new Date())
            };
        });
        return zones;
    }
    function loadData(data) {
        addZone(data.zones);
        addLink(data.links);
        addCountries(data.countries);
        tz.dataVersion = data.version;
    }
    function zoneExists(name) {
        if (!zoneExists.didShowError) {
            zoneExists.didShowError = true;
            logError("moment.tz.zoneExists('" + name + "') has been deprecated in favor of !moment.tz.zone('" + name + "')");
        }
        return !!getZone(name);
    }
    function needsOffset(m) {
        var isUnixTimestamp = m._f === "X" || m._f === "x";
        return !!(m._a && m._tzm === undefined && !isUnixTimestamp);
    }
    function logError(message) {
        if (typeof console !== "undefined" && typeof console.error === "function") console.error(message);
    }
    /************************************
		moment.tz namespace
	************************************/ function tz(input) {
        var args = Array.prototype.slice.call(arguments, 0, -1), name = arguments[arguments.length - 1], out = moment.utc.apply(null, args), zone;
        if (!moment.isMoment(input) && needsOffset(out) && (zone = getZone(name))) out.add(zone.parse(out), "minutes");
        out.tz(name);
        return out;
    }
    tz.version = VERSION;
    tz.dataVersion = "";
    tz._zones = zones;
    tz._links = links;
    tz._names = names;
    tz._countries = countries;
    tz.add = addZone;
    tz.link = addLink;
    tz.load = loadData;
    tz.zone = getZone;
    tz.zoneExists = zoneExists; // deprecated in 0.1.0
    tz.guess = guess;
    tz.names = getNames;
    tz.Zone = Zone;
    tz.unpack = unpack;
    tz.unpackBase60 = unpackBase60;
    tz.needsOffset = needsOffset;
    tz.moveInvalidForward = true;
    tz.moveAmbiguousForward = false;
    tz.countries = getCountryNames;
    tz.zonesForCountry = zonesForCountry;
    /************************************
		Interface with Moment.js
	************************************/ var fn = moment.fn;
    moment.tz = tz;
    moment.defaultZone = null;
    moment.updateOffset = function(mom, keepTime) {
        var zone = moment.defaultZone, offset;
        if (mom._z === undefined) {
            if (zone && needsOffset(mom) && !mom._isUTC && mom.isValid()) {
                mom._d = moment.utc(mom._a)._d;
                mom.utc().add(zone.parse(mom), "minutes");
            }
            mom._z = zone;
        }
        if (mom._z) {
            offset = mom._z.utcOffset(mom);
            if (Math.abs(offset) < 16) offset = offset / 60;
            if (mom.utcOffset !== undefined) {
                var z = mom._z;
                mom.utcOffset(-offset, keepTime);
                mom._z = z;
            } else mom.zone(offset, keepTime);
        }
    };
    fn.tz = function(name, keepTime) {
        if (name) {
            if (typeof name !== "string") throw new Error("Time zone name must be a string, got " + name + " [" + typeof name + "]");
            this._z = getZone(name);
            if (this._z) moment.updateOffset(this, keepTime);
            else logError("Moment Timezone has no data for " + name + ". See http://momentjs.com/timezone/docs/#/data-loading/.");
            return this;
        }
        if (this._z) return this._z.name;
    };
    function abbrWrap(old) {
        return function() {
            if (this._z) return this._z.abbr(this);
            return old.call(this);
        };
    }
    function resetZoneWrap(old) {
        return function() {
            this._z = null;
            return old.apply(this, arguments);
        };
    }
    function resetZoneWrap2(old) {
        return function() {
            if (arguments.length > 0) this._z = null;
            return old.apply(this, arguments);
        };
    }
    fn.zoneName = abbrWrap(fn.zoneName);
    fn.zoneAbbr = abbrWrap(fn.zoneAbbr);
    fn.utc = resetZoneWrap(fn.utc);
    fn.local = resetZoneWrap(fn.local);
    fn.utcOffset = resetZoneWrap2(fn.utcOffset);
    moment.tz.setDefault = function(name) {
        if (major < 2 || major === 2 && minor < 9) logError("Moment Timezone setDefault() requires Moment.js >= 2.9.0. You are using Moment.js " + moment.version + ".");
        moment.defaultZone = name ? getZone(name) : null;
        return moment;
    };
    // Cloning a moment should include the _z property.
    var momentProperties = moment.momentProperties;
    if (Object.prototype.toString.call(momentProperties) === "[object Array]") {
        // moment 2.8.1+
        momentProperties.push("_z");
        momentProperties.push("_a");
    } else if (momentProperties) // moment 2.7.0
    momentProperties._z = null;
    // INJECT DATA
    return moment;
});

},{"782152beb30574e4":"2meyw"}],"aqvBE":[function(require,module,exports) {
module.exports = JSON.parse('{"version":"2025b","zones":["Africa/Abidjan|LMT GMT|g.8 0|01|-2ldXH.Q|48e5","Africa/Nairobi|LMT +0230 EAT +0245|-2r.g -2u -30 -2J|012132|-2ua2r.g N6nV.g 3Fbu h1cu dzbJ|47e5","Africa/Algiers|LMT PMT WET WEST CET CEST|-c.c -9.l 0 -10 -10 -20|01232323232323232454542423234542324|-3bQ0c.c MDA2.P cNb9.l HA0 19A0 1iM0 11c0 1oo0 Wo0 1rc0 QM0 1EM0 UM0 DA0 Imo0 rd0 De0 9Xz0 1fb0 1ap0 16K0 2yo0 mEp0 hwL0 jxA0 11A0 dDd0 17b0 11B0 1cN0 2Dy0 1cN0 1fB0 1cL0|26e5","Africa/Lagos|LMT GMT +0030 WAT|-d.z 0 -u -10|01023|-2B40d.z 7iod.z dnXK.p dLzH.z|17e6","Africa/Bissau|LMT -01 GMT|12.k 10 0|012|-2ldX0 2xoo0|39e4","Africa/Maputo|LMT CAT|-2a.i -20|01|-2sw2a.i|26e5","Africa/Cairo|LMT EET EEST|-25.9 -20 -30|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2MBC5.9 1AQM5.9 vb0 1ip0 11z0 1iN0 1nz0 12p0 1pz0 10N0 1pz0 16p0 1jz0 s3d0 Vz0 1oN0 11b0 1oO0 10N0 1pz0 10N0 1pb0 10N0 1pb0 10N0 1pb0 10N0 1pz0 10N0 1pb0 10N0 1pb0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1WL0 rd0 1Rz0 wp0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1qL0 Xd0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1ny0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 WL0 1qN0 Rb0 1wp0 On0 1zd0 Lz0 1EN0 Fb0 c10 8n0 8Nd0 gL0 e10 mn0 kSp0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0|15e6","Africa/Casablanca|LMT +00 +01|u.k 0 -10|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-2gMnt.E 130Lt.E rb0 Dd0 dVb0 b6p0 TX0 EoB0 LL0 gnd0 rz0 43d0 AL0 1Nd0 XX0 1Cp0 pz0 dEp0 4mn0 SyN0 AL0 1Nd0 wn0 1FB0 Db0 1zd0 Lz0 1Nf0 wM0 co0 go0 1o00 s00 dA0 vc0 11A0 A00 e00 y00 11A0 uM0 e00 Dc0 11A0 s00 e00 IM0 WM0 mo0 gM0 LA0 WM0 jA0 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0|32e5","Africa/Ceuta|LMT WET WEST CET CEST|l.g 0 -10 -10 -20|0121212121212121212121343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-2M0M0 GdX0 11z0 drd0 18p0 3HX0 17d0 1fz0 1a10 1io0 1a00 1y7o0 LL0 gnd0 rz0 43d0 AL0 1Nd0 XX0 1Cp0 pz0 dEp0 4VB0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|85e3","Africa/El_Aaiun|LMT -01 +00 +01|Q.M 10 0 -10|012323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-1rDz7.c 1GVA7.c 6L0 AL0 1Nd0 XX0 1Cp0 pz0 1cBB0 AL0 1Nd0 wn0 1FB0 Db0 1zd0 Lz0 1Nf0 wM0 co0 go0 1o00 s00 dA0 vc0 11A0 A00 e00 y00 11A0 uM0 e00 Dc0 11A0 s00 e00 IM0 WM0 mo0 gM0 LA0 WM0 jA0 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0|20e4","Africa/Johannesburg|LMT SAST SAST SAST|-1Q -1u -20 -30|0123232|-39EpQ qTcm 1Ajdu 1cL0 1cN0 1cL0|84e5","Africa/Juba|LMT CAT CAST EAT|-26.s -20 -30 -30|012121212121212121212121212121212131|-1yW26.s 1zK06.s 16L0 1iN0 17b0 1jd0 17b0 1ip0 17z0 1i10 17X0 1hB0 18n0 1hd0 19b0 1gp0 19z0 1iN0 17b0 1ip0 17z0 1i10 18n0 1hd0 18L0 1gN0 19b0 1gp0 19z0 1iN0 17z0 1i10 17X0 yGd0 PeX0|","Africa/Khartoum|LMT CAT CAST EAT|-2a.8 -20 -30 -30|012121212121212121212121212121212131|-1yW2a.8 1zK0a.8 16L0 1iN0 17b0 1jd0 17b0 1ip0 17z0 1i10 17X0 1hB0 18n0 1hd0 19b0 1gp0 19z0 1iN0 17b0 1ip0 17z0 1i10 18n0 1hd0 18L0 1gN0 19b0 1gp0 19z0 1iN0 17z0 1i10 17X0 yGd0 HjL0|51e5","Africa/Monrovia|LMT MMT MMT GMT|H.8 H.8 I.u 0|0123|-3ygng.Q 1usM0 28G01.m|11e5","Africa/Ndjamena|LMT WAT WAST|-10.c -10 -20|0121|-2le10.c 2J3c0.c Wn0|13e5","Africa/Sao_Tome|LMT LMT GMT WAT|-q.U A.J 0 -10|01232|-3tooq.U 18aoq.U 4i6N0 2q00|","Africa/Tripoli|LMT CET CEST EET|-Q.I -10 -20 -20|012121213121212121212121213123123|-21JcQ.I 1hnBQ.I vx0 4iP0 xx0 4eN0 Bb0 7ip0 U0n0 A10 1db0 1cN0 1db0 1dd0 1db0 1eN0 1bb0 1e10 1cL0 1c10 1db0 1dd0 1db0 1cN0 1db0 1q10 fAn0 1ep0 1db0 AKq0 TA0 1o00|11e5","Africa/Tunis|LMT PMT CET CEST|-E.I -9.l -10 -20|01232323232323232323232323232323232|-3zO0E.I 1cBAv.n 18pa9.l 1qM0 DA0 3Tc0 11B0 1ze0 WM0 7z0 3d0 14L0 1cN0 1f90 1ar0 16J0 1gXB0 WM0 1rA0 11c0 nwo0 Ko0 1cM0 1cM0 1rA0 10M0 zuM0 10N0 1aN0 1qM0 WM0 1qM0 11A0 1o00|20e5","Africa/Windhoek|LMT +0130 SAST SAST CAT WAT|-18.o -1u -20 -30 -20 -10|012324545454545454545454545454545454545454545454545454|-39Ep8.o qTbC.o 1Ajdu 1cL0 1SqL0 9Io0 16P0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0|32e4","America/Adak|LMT LMT NST NWT NPT BST BDT AHST HST HDT|-cd.m bK.C b0 a0 a0 b0 a0 a0 a0 90|01234256565656565656565656565656565678989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898|-48Pzs.L 1jVzf.p 1EX1d.m 8wW0 iB0 Qlb0 52O0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cm0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|326","America/Anchorage|LMT LMT AST AWT APT AHST AHDT YST AKST AKDT|-e0.o 9X.A a0 90 90 a0 90 90 90 80|01234256565656565656565656565656565678989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898|-48Pzs.L 1jVxs.n 1EX20.o 8wX0 iA0 Qlb0 52O0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cm0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|30e4","America/Puerto_Rico|LMT AST AWT APT|4o.p 40 30 30|01231|-2Qi7z.z 1IUbz.z 7XT0 iu0|24e5","America/Araguaina|LMT -03 -02|3c.M 30 20|0121212121212121212121212121212121212121212121212121|-2glwL.c HdKL.c 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 dMN0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 ny10 Lz0|14e4","America/Argentina/Buenos_Aires|LMT CMT -04 -03 -02|3R.M 4g.M 40 30 20|012323232323232323232323232323232323232323234343434343434343|-331U6.c 125cn pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wp0 Rb0 1wp0 TX0 A4p0 uL0 1qN0 WL0|","America/Argentina/Catamarca|LMT CMT -04 -03 -02|4n.8 4g.M 40 30 20|012323232323232323232323232323232323232323234343434243432343|-331TA.Q 125bR.E pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 rlB0 7B0 8zb0 uL0|","America/Argentina/Cordoba|LMT CMT -04 -03 -02|4g.M 4g.M 40 30 20|012323232323232323232323232323232323232323234343434243434343|-331TH.c 125c0 pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 A4p0 uL0 1qN0 WL0|","America/Argentina/Jujuy|LMT CMT -04 -03 -02|4l.c 4g.M 40 30 20|0123232323232323232323232323232323232323232343434232434343|-331TC.M 125bT.A pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1ze0 TX0 1ld0 WK0 1wp0 TX0 A4p0 uL0|","America/Argentina/La_Rioja|LMT CMT -04 -03 -02|4r.o 4g.M 40 30 20|0123232323232323232323232323232323232323232343434342343432343|-331Tw.A 125bN.o pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Qn0 qO0 16n0 Rb0 1wp0 TX0 rlB0 7B0 8zb0 uL0|","America/Argentina/Mendoza|LMT CMT -04 -03 -02|4z.g 4g.M 40 30 20|012323232323232323232323232323232323232323234343423232432343|-331To.I 125bF.w pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1u20 SL0 1vd0 Tb0 1wp0 TW0 ri10 Op0 7TX0 uL0|","America/Argentina/Rio_Gallegos|LMT CMT -04 -03 -02|4A.Q 4g.M 40 30 20|012323232323232323232323232323232323232323234343434343432343|-331Tn.8 125bD.U pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wp0 Rb0 1wp0 TX0 rlB0 7B0 8zb0 uL0|","America/Argentina/Salta|LMT CMT -04 -03 -02|4l.E 4g.M 40 30 20|0123232323232323232323232323232323232323232343434342434343|-331TC.k 125bT.8 pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 A4p0 uL0|","America/Argentina/San_Juan|LMT CMT -04 -03 -02|4y.4 4g.M 40 30 20|0123232323232323232323232323232323232323232343434342343432343|-331Tp.U 125bG.I pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Qn0 qO0 16n0 Rb0 1wp0 TX0 rld0 m10 8lb0 uL0|","America/Argentina/San_Luis|LMT CMT -04 -03 -02|4p.o 4g.M 40 30 20|0123232323232323232323232323232323232323232343434232323432323|-331Ty.A 125bP.o pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 XX0 1q20 SL0 AN0 vDb0 m10 8lb0 8L0 jd0 1qN0 WL0 1qN0|","America/Argentina/Tucuman|LMT CMT -04 -03 -02|4k.Q 4g.M 40 30 20|01232323232323232323232323232323232323232323434343424343234343|-331TD.8 125bT.U pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 rlB0 4N0 8BX0 uL0 1qN0 WL0|","America/Argentina/Ushuaia|LMT CMT -04 -03 -02|4x.c 4g.M 40 30 20|012323232323232323232323232323232323232323234343434343432343|-331Tq.M 125bH.A pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wp0 Rb0 1wp0 TX0 rkN0 8p0 8zb0 uL0|","America/Asuncion|LMT AMT -04 -03|3O.E 3O.E 40 30|01232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-3eLw9.k 1FGo0 1DKM9.k 3CL0 3Dd0 10L0 1pB0 10n0 1pB0 10n0 1pB0 1cL0 1dd0 1db0 1dd0 1cL0 1dd0 1cL0 1dd0 1cL0 1dd0 1db0 1dd0 1cL0 1dd0 1cL0 1dd0 1cL0 1dd0 1db0 1dd0 1cL0 1lB0 14n0 1dd0 1cL0 1fd0 WL0 1rd0 1aL0 1dB0 Xz0 1qp0 Xb0 1qN0 10L0 1rB0 TX0 1tB0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 WN0 1qL0 11B0 1nX0 1ip0 WL0 1qN0 WL0 1qN0 WL0 1tB0 TX0 1tB0 TX0 1tB0 19X0 1a10 1fz0 1a10 1fz0 1cN0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0|28e5","America/Panama|LMT CMT EST|5i.8 5j.A 50|012|-3eLuF.Q Iy01.s|15e5","America/Bahia_Banderas|LMT MST CST MDT CDT|71 70 60 60 50|01213121313131313131313131313131313142424242424242424242424242|-1UQF0 deo0 8lz0 16p0 11z0 1dd0 otX0 2bmP0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nW0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0|84e3","America/Bahia|LMT -03 -02|2y.4 30 20|01212121212121212121212121212121212121212121212121212121212121|-2glxp.U HdLp.U 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 l5B0 Rb0|27e5","America/Barbados|LMT AST ADT -0330|3W.t 40 30 3u|0121213121212121|-2m4k1.v 1eAN1.v RB0 1Bz0 Op0 1rb0 11d0 1jJc0 IL0 1ip0 17b0 1ip0 17b0 1ld0 13b0|28e4","America/Belem|LMT -03 -02|3d.U 30 20|012121212121212121212121212121|-2glwK.4 HdKK.4 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0|20e5","America/Belize|LMT CST -0530 CWT CPT CDT|5Q.M 60 5u 50 50 50|012121212121212121212121212121212121212121212121213412121212121212121212121212121212121212121215151|-2kBu7.c fPA7.c Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu Rcu 7Bt0 Ni0 4nd0 Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu e9Au qn0 lxB0 mn0|57e3","America/Boa_Vista|LMT -04 -03|42.E 40 30|0121212121212121212121212121212121|-2glvV.k HdKV.k 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 smp0 WL0 1tB0 2L0|62e2","America/Bogota|LMT BMT -05 -04|4U.g 4U.g 50 40|01232|-3sTv3.I 1eIo0 38yo3.I 1PX0|90e5","America/Boise|LMT PST PDT MST MWT MPT MDT|7I.N 80 70 70 60 60 60|01212134536363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363|-3tFE0 1nEe0 1nX0 11B0 1nX0 8C10 JCL0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 Dd0 1Kn0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|21e4","America/Cambridge_Bay|-00 MST MWT MPT MDT CST CDT EST|0 70 60 60 60 60 50 50|012314141414141414141414141414141414141414141414141414141414567541414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141|-21Jc0 RO90 8x20 ix0 14HB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11A0 1nX0 2K0 WQ0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|15e2","America/Campo_Grande|LMT -04 -03|3C.s 40 30|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2glwl.w HdLl.w 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 1C10 Lz0 1Ip0 HX0 1zd0 On0 1HB0 IL0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1zd0 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1HB0 FX0|77e4","America/Cancun|LMT CST EST CDT EDT|5L.4 60 50 50 40|01213132431313131313131313131313131313131312|-1UQG0 2q3C0 2tx0 wgP0 1lb0 14p0 1lb0 14o0 Lz0 xB0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 Dd0|63e4","America/Caracas|LMT CMT -0430 -04|4r.I 4r.E 4u 40|012323|-3eLvw.g ROnX.U 28KM2.k 1IwOu kqo0|29e5","America/Cayenne|LMT -04 -03|3t.k 40 30|012|-2mrwu.E 2gWou.E|58e3","America/Chicago|LMT CST CDT EST CWT CPT|5O.A 60 50 50 50 50|012121212121212121212121212121212121213121212121214512121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-3tFG0 1nEe0 1nX0 11B0 1nX0 1wp0 TX0 WN0 1qL0 1cN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 11B0 1Hz0 14p0 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 RB0 8x30 iw0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|92e5","America/Chihuahua|LMT MST CST MDT CDT|74.k 70 60 60 50|0121312424231313131313131313131313131313131313131313131313132|-1UQF0 deo0 8lz0 16p0 11z0 1dd0 2zQN0 1lb0 14p0 1lb0 14q0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0|81e4","America/Ciudad_Juarez|LMT MST CST MDT CDT|75.U 70 60 60 50|01213124242313131313131313131313131313131313131313131313131321313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131|-1UQF0 deo0 8lz0 16p0 11z0 1dd0 2zQN0 1lb0 14p0 1lb0 14q0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 U10 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1wn0 cm0 EP0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/Costa_Rica|LMT SJMT CST CDT|5A.d 5A.d 60 50|01232323232|-3eLun.L 1fyo0 2lu0n.L Db0 1Kp0 Db0 pRB0 15b0 1kp0 mL0|12e5","America/Coyhaique|LMT SMT -05 -04 -03|4M.g 4G.J 50 40 30|012131323232323232323434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434|-3eLvb.I MJbS.t fJAh.f 5knG.J 1Vzh.f jRAG.J 1pbh.f 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 nHX0 op0 blz0 ko0 Qeo0 WL0 1zd0 On0 1ip0 11z0 1o10 11z0 1qN0 WL0 1ld0 14n0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1zb0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 11B0 1qL0 11B0|","America/Phoenix|LMT MST MDT MWT|7s.i 70 60 60|012121313121|-3tFF0 1nEe0 1nX0 11B0 1nX0 SgN0 4Al1 Ap0 1db0 SWqX 1cL0|42e5","America/Cuiaba|LMT -04 -03|3I.k 40 30|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2glwf.E HdLf.E 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 4a10 HX0 1zd0 On0 1HB0 IL0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1zd0 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1HB0 FX0|54e4","America/Danmarkshavn|LMT -03 -02 GMT|1e.E 30 20 0|01212121212121212121212121212121213|-2a5WJ.k 2z5fJ.k 19U0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 DC0|8","America/Dawson_Creek|LMT PST PDT PWT PPT MST|80.U 80 70 70 70 70|01213412121212121212121212121212121212121212121212121212125|-3tofX.4 1nspX.4 1in0 UGp0 8x10 iy0 3NB0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 ML0|12e3","America/Dawson|LMT YST YDT YWT YPT YDDT PST PDT MST|9h.E 90 80 80 80 70 80 70 70|0121213415167676767676767676767676767676767676767676767676767676767676767676767676767676767678|-2MSeG.k GWpG.k 1in0 1o10 13V0 Ser0 8x00 iz0 LCL0 1fA0 jrA0 fNd0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1z90|13e2","America/Denver|LMT MST MDT MWT MPT|6X.U 70 60 60 60|012121212134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-3tFF0 1nEe0 1nX0 11B0 1nX0 11B0 1qL0 WN0 mn0 Ord0 8x20 ix0 LCN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|26e5","America/Detroit|LMT CST EST EWT EPT EDT|5w.b 60 50 40 40 40|0123425252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252|-2Cgir.N peqr.N 156L0 8x40 iv0 6fd0 11z0 JxX1 SMX 1cN0 1cL0 aW10 1cL0 s10 1Vz0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|37e5","America/Edmonton|LMT MST MDT MWT MPT|7x.Q 70 60 60 60|0121212121212134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2yd4q.8 shdq.8 1in0 17d0 hz0 2dB0 1fz0 1a10 11z0 1qN0 WL0 1qN0 11z0 IGN0 8x20 ix0 3NB0 11z0 XQp0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|10e5","America/Eirunepe|LMT -05 -04|4D.s 50 40|0121212121212121212121212121212121|-2glvk.w HdLk.w 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 dPB0 On0 yTd0 d5X0|31e3","America/El_Salvador|LMT CST CDT|5U.M 60 50|012121|-1XiG3.c 2Fvc3.c WL0 1qN0 WL0|11e5","America/Tijuana|LMT MST PST PDT PWT PPT|7M.4 70 80 70 70 70|012123245232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-1UQF0 4Q00 8mp0 8lz0 SN0 1cL0 pHB0 83r0 AU0 5MN0 1Rz0 38N0 Wn0 1qP0 11z0 1o10 11z0 3NA0 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 BUp0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 U10 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|20e5","America/Fort_Nelson|LMT PST PDT PWT PPT MST|8a.L 80 70 70 70 70|012134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121215|-3tofN.d 1nspN.d 1in0 UGp0 8x10 iy0 3NB0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0|39e2","America/Fort_Wayne|LMT CST CDT CWT CPT EST EDT|5I.C 60 50 50 50 50 40|0121212134121212121212121212151565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-3tFG0 1nEe0 1nX0 11B0 1nX0 QI10 Db0 RB0 8x30 iw0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 5Tz0 1o10 qLb0 1cL0 1cN0 1cL0 1qhd0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/Fortaleza|LMT -03 -02|2y 30 20|0121212121212121212121212121212121212121|-2glxq HdLq 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 nsp0 WL0 1tB0 5z0 2mN0 On0|34e5","America/Glace_Bay|LMT AST ADT AWT APT|3X.M 40 30 30 30|012134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2IsI0.c CwO0.c 1in0 UGp0 8x50 iu0 iq10 11z0 Jg10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|19e3","America/Godthab|LMT -03 -02 -01|3q.U 30 20 10|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212123232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-2a5Ux.4 2z5dx.4 19U0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 2so0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|17e3","America/Goose_Bay|LMT NST NDT NST NDT NWT NPT AST ADT ADDT|41.E 3u.Q 2u.Q 3u 2u 2u 2u 40 30 20|0121343434343434356343434343434343434343434343434343434343437878787878787878787878787878787878787878787879787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787|-3tojW.k 1nspt.c 1in0 DXb0 2HbX.8 WL0 1qN0 WL0 1qN0 WL0 1tB0 TX0 1tB0 WL0 1qN0 WL0 1qN0 7UHu itu 1tB0 WL0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1tB0 WL0 1ld0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 S10 g0u 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14n1 1lb0 14p0 1nW0 11C0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zcX Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|76e2","America/Grand_Turk|LMT KMT EST EDT AST|4I.w 57.a 50 40 40|01232323232323232323232323232323232323232323232323232323232323232323232323243232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-3eLvf.s RK0m.C 2HHBQ.O 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 7jA0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|37e2","America/Guatemala|LMT CST CDT|62.4 60 50|0121212121|-24KhV.U 2efXV.U An0 mtd0 Nz0 ifB0 17b0 zDB0 11z0|13e5","America/Guayaquil|LMT QMT -05 -04|5j.k 5e 50 40|01232|-3eLuE.E 1DNzS.E 2uILK rz0|27e5","America/Guyana|LMT -04 -0345 -03|3Q.D 40 3J 30|01231|-2mf87.l 8Hc7.l 2r7bJ Ey0f|80e4","America/Halifax|LMT AST ADT AWT APT|4e.o 40 30 30 30|0121212121212121212121212121212121212121212121212134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2IsHJ.A xzzJ.A 1db0 3I30 1in0 3HX0 IL0 1E10 ML0 1yN0 Pb0 1Bd0 Mn0 1Bd0 Rz0 1w10 Xb0 1w10 LX0 1w10 Xb0 1w10 Lz0 1C10 Jz0 1E10 OL0 1yN0 Un0 1qp0 Xb0 1qp0 11X0 1w10 Lz0 1HB0 LX0 1C10 FX0 1w10 Xb0 1qp0 Xb0 1BB0 LX0 1td0 Xb0 1qp0 Xb0 Rf0 8x50 iu0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 3Qp0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 3Qp0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 6i10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|39e4","America/Havana|LMT HMT CST CDT|5t.s 5t.A 50 40|0123232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-3eLuu.w 1qx00.8 72zu.o ML0 sld0 An0 1Nd0 Db0 1Nd0 An0 6Ep0 An0 1Nd0 An0 JDd0 Mn0 1Ap0 On0 1fd0 11X0 1qN0 WL0 1wp0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 14n0 1ld0 14L0 1kN0 15b0 1kp0 1cL0 1cN0 1fz0 1a10 1fz0 1fB0 11z0 14p0 1nX0 11B0 1nX0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 14n0 1ld0 14n0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 1a10 1in0 1a10 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 17c0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 11A0 6i00 Rc0 1wo0 U00 1tA0 Rc0 1wo0 U00 1wo0 U00 1zc0 U00 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0|21e5","America/Hermosillo|LMT MST CST MDT|7n.Q 70 60 60|01213121313131|-1UQF0 deo0 8lz0 16p0 11z0 1dd0 otX0 2bmP0 1lb0 14p0 1lb0 14p0 1lb0|64e4","America/Indiana/Knox|LMT CST CDT CWT CPT EST|5K.u 60 50 50 50 50|01212134121212121212121212121212121212151212121212121212121212121212121212121212121212121252121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-3tFG0 1nEe0 1nX0 11B0 1nX0 SgN0 8x30 iw0 3NB0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 11z0 1o10 11z0 1o10 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 3Cn0 8wp0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 z8o0 1o00 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/Indiana/Marengo|LMT CST CDT CWT CPT EST EDT|5J.n 60 50 50 50 50 40|01212134121212121212121215656565656525656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-3tFG0 1nEe0 1nX0 11B0 1nX0 SgN0 8x30 iw0 dyN0 11z0 6fd0 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 jrz0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1VA0 LA0 1BX0 1e6p0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/Indiana/Petersburg|LMT CST CDT CWT CPT EST EDT|5N.7 60 50 50 50 50 40|012121341212121212121212121215121212121212121212121252125656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-3tFG0 1nEe0 1nX0 11B0 1nX0 SgN0 8x30 iw0 njX0 WN0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 3Fb0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 19co0 1o00 Rd0 1zb0 Oo0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/Indiana/Tell_City|LMT CST CDT CWT CPT EST EDT|5L.3 60 50 50 50 50 40|012121341212121212121212121512165652121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-3tFG0 1nEe0 1nX0 11B0 1nX0 SgN0 8x30 iw0 njX0 WN0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 8wn0 1cN0 1cL0 1cN0 1cK0 1cN0 1cL0 1qhd0 1o00 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/Indiana/Vevay|LMT CST CDT CWT CPT EST EDT|5E.g 60 50 50 50 50 40|0121213415656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-3tFG0 1nEe0 1nX0 11B0 1nX0 SgN0 8x30 iw0 kPB0 Awn0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1lnd0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/Indiana/Vincennes|LMT CST CDT CWT CPT EST EDT|5O.7 60 50 50 50 50 40|012121341212121212121212121212121565652125656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-3tFG0 1nEe0 1nX0 11B0 1nX0 SgN0 8x30 iw0 1o10 11z0 g0p0 11z0 1o10 11z0 1qL0 WN0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 caL0 1cL0 1cN0 1cL0 1qhd0 1o00 Rd0 1zb0 Oo0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/Indiana/Winamac|LMT CST CDT CWT CPT EST EDT|5K.p 60 50 50 50 50 40|012121341212121212121212121212121212121565652165656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-3tFG0 1nEe0 1nX0 11B0 1nX0 SgN0 8x30 iw0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 jrz0 1cL0 1cN0 1cL0 1qhd0 1o00 Rd0 1za0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/Inuvik|-00 PST PDT MDT MST|0 80 70 60 70|01212121212121213434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434|-FnA0 L3K0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cK0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|35e2","America/Iqaluit|-00 EWT EPT EST EDT CST CDT|0 40 40 50 40 60 50|0123434343434343434343434343434343434343434343434343434343456343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-16K00 7nX0 iv0 14HB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11C0 1nX0 11A0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|67e2","America/Jamaica|LMT KMT EST EDT|57.a 57.a 50 40|01232323232323232323232|-3eLuQ.O RK00 2uM1Q.O 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0|94e4","America/Juneau|LMT LMT PST PWT PPT PDT YDT YST AKST AKDT|-f2.j 8V.F 80 70 70 70 80 90 90 80|0123425252525252525252525252625252578989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898|-48Pzs.L 1jVwq.s 1EX12.j 8x10 iy0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cM0 1cM0 1cL0 1cN0 1fz0 1a10 1fz0 co0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|33e3","America/Kentucky/Louisville|LMT CST CDT CWT CPT EST EDT|5H.2 60 50 50 50 50 40|01212121213412121212121212121212121212565656565656525656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-3tFG0 1nEe0 1nX0 11B0 1nX0 3Fd0 Nb0 LPd0 11z0 RB0 8x30 iw0 1nX1 e0X 9vd0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 xz0 gso0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1VA0 LA0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/Kentucky/Monticello|LMT CST CDT CWT CPT EST EDT|5D.o 60 50 50 50 50 40|01212134121212121212121212121212121212121212121212121212121212121212121212565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-3tFG0 1nEe0 1nX0 11B0 1nX0 SgN0 8x30 iw0 SWp0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11A0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/La_Paz|LMT CMT BST -04|4w.A 4w.A 3w.A 40|0123|-3eLvr.o 1FIo0 13b0|19e5","America/Lima|LMT LMT -05 -04|58.c 58.A 50 40|01232323232323232|-3eLuP.M JcM0.o 1bDzP.o zX0 1aN0 1cL0 1cN0 1cL0 1PrB0 zX0 1O10 zX0 6Gp0 zX0 98p0 zX0|11e6","America/Los_Angeles|LMT PST PDT PWT PPT|7Q.W 80 70 70 70|0121213412121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-3tFE0 1nEe0 1nX0 11B0 1nX0 SgN0 8x10 iy0 5Wp1 1VaX 3dA0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1fA0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|15e6","America/Maceio|LMT -03 -02|2m.Q 30 20|012121212121212121212121212121212121212121|-2glxB.8 HdLB.8 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 dMN0 Lz0 8Q10 WL0 1tB0 5z0 2mN0 On0|93e4","America/Managua|LMT MMT CST EST CDT|5J.8 5J.c 60 50 50|01232424232324242|-3eLue.Q 1Mhc0.4 1yAMe.M 4mn0 9Up0 Dz0 1K10 Dz0 s3F0 1KH0 DB0 9In0 k8p0 19X0 1o30 11y0|22e5","America/Manaus|LMT -04 -03|40.4 40 30|01212121212121212121212121212121|-2glvX.U HdKX.U 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 dPB0 On0|19e5","America/Martinique|LMT FFMT AST ADT|44.k 44.k 40 30|01232|-3eLvT.E PTA0 2LPbT.E 19X0|39e4","America/Matamoros|LMT CST CDT|6u 60 50|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1UQG0 2FjC0 1nX0 i6p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 U10 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|45e4","America/Mazatlan|LMT MST CST MDT|75.E 70 60 60|01213121313131313131313131313131313131313131313131313131313131|-1UQF0 deo0 8lz0 16p0 11z0 1dd0 otX0 2bmP0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0|44e4","America/Menominee|LMT CST CDT CWT CPT EST|5O.r 60 50 50 50 50|012121341212152121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-3pdG9.x 1jce9.x 1nX0 11B0 1nX0 SgN0 8x30 iw0 1o10 11z0 LCN0 1fz0 6410 9Jb0 1cM0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|85e2","America/Merida|LMT CST EST CDT|5W.s 60 50 50|0121313131313131313131313131313131313131313131313131313131|-1UQG0 2q3C0 24n0 wG10 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0|11e5","America/Metlakatla|LMT LMT PST PWT PPT PDT AKST AKDT|-fd.G 8K.i 80 70 70 70 90 80|0123425252525252525252525252525252526767672676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-48Pzs.L 1jVwf.5 1EX1d.G 8x10 iy0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1hU10 Rd0 1zb0 Op0 1zb0 Op0 1zb0 uM0 jB0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|14e2","America/Mexico_City|LMT MST CST MDT CDT CWT|6A.A 70 60 60 50 50|012131242425242424242424242424242424242424242424242424242424242424242|-1UQF0 deo0 8lz0 16p0 11z0 1dd0 gEn0 TX0 3xd0 Jb0 6zB0 SL0 e5d0 17b0 1Pff0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0|20e6","America/Miquelon|LMT AST -03 -02|3I.E 40 30 20|012323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-2mxUf.k 2LHcf.k gQ10 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|61e2","America/Moncton|LMT EST AST ADT AWT APT|4j.8 50 40 30 30 30|0123232323232323232323245232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-3txvE.Q J4ME.Q CwN0 1in0 zAo0 An0 1Nd0 An0 1Nd0 An0 1Nd0 An0 1Nd0 An0 1Nd0 An0 1K10 Lz0 1zB0 NX0 1u10 Wn0 S20 8x50 iu0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 3Cp0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14n1 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 ReX 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|64e3","America/Monterrey|LMT MST CST MDT CDT|6F.g 70 60 60 50|012131242424242424242424242424242424242424242424242424242424242|-1UQG0 dep0 8lz0 16p0 11z0 1dd0 2gmp0 1nX0 i6p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0|41e5","America/Montevideo|LMT MMT -04 -03 -0330 -0230 -02 -0130|3I.P 3I.P 40 30 3u 2u 20 1u|012343434343434343434343435353636353636375363636363636363636363636363636363636363636363|-2tRUf.9 sVc0 8jcf.9 1db0 1dcu 1cLu 1dcu 1cLu ircu 11zu 1o0u 11zu 1o0u 11zu 1o0u 11zu 1qMu WLu 1qMu WLu 1fAu 1cLu 1o0u 11zu NAu 3jXu zXu Dq0u 19Xu pcu jz0 cm10 19X0 6tB0 1fbu 3o0u jX0 4vB0 xz0 3Cp0 mmu 1a10 IMu Db0 4c10 uL0 1Nd0 An0 1SN0 uL0 mp0 28L0 iPB0 un0 1SN0 xz0 1zd0 Lz0 1zd0 Rb0 1zd0 On0 1wp0 Rb0 s8p0 1fB0 1ip0 11z0 1ld0 14n0 1o10 11z0 1o10 11z0 1o10 14n0 1ld0 14n0 1ld0 14n0 1o10 11z0 1o10 11z0 1o10 11z0|17e5","America/Toronto|LMT EST EDT EWT EPT|5h.w 50 40 40 40|012121212121212121212121212121212121212121212123412121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-32B6G.s UFdG.s 1in0 11Wu 1nzu 1fD0 WJ0 1wr0 Nb0 1Ap0 On0 1zd0 On0 1wp0 TX0 1tB0 TX0 1tB0 TX0 1tB0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 4kM0 8x40 iv0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1qL0 11B0 1nX0 11B0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|65e5","America/New_York|LMT EST EDT EWT EPT|4U.2 50 40 40 40|012121212121212121212121212121212121212121212121213412121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-3tFH0 1nEe0 1nX0 11B0 1nX0 11B0 1qL0 1a10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 RB0 8x40 iv0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|21e6","America/Nome|LMT LMT NST NWT NPT BST BDT YST AKST AKDT|-cW.m b1.C b0 a0 a0 b0 a0 90 90 80|01234256565656565656565656565656565678989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898|-48Pzs.L 1jVyu.p 1EX1W.m 8wW0 iB0 Qlb0 52O0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cl0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|38e2","America/Noronha|LMT -02 -01|29.E 20 10|0121212121212121212121212121212121212121|-2glxO.k HdKO.k 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 nsp0 WL0 1tB0 2L0 2pB0 On0|30e2","America/North_Dakota/Beulah|LMT MST MDT MWT MPT CST CDT|6L.7 70 60 60 60 60 50|0121213412121212121212121212121212121212121212121212121212121212121212121212121212121212121212125656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-3tFF0 1nEe0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Oo0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/North_Dakota/Center|LMT MST MDT MWT MPT CST CDT|6J.c 70 60 60 60 60 50|0121213412121212121212121212121212121212121212121212121212125656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-3tFF0 1nEe0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14o0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/North_Dakota/New_Salem|LMT MST MDT MWT MPT CST CDT|6J.D 70 60 60 60 60 50|0121213412121212121212121212121212121212121212121212121212121212121212121212121212565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-3tFF0 1nEe0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14o0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/Ojinaga|LMT MST CST MDT CDT|6V.E 70 60 60 50|0121312424231313131313131313131313131313131313131313131313132424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242|-1UQF0 deo0 8lz0 16p0 11z0 1dd0 2zQN0 1lb0 14p0 1lb0 14q0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 U10 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1wn0 Rc0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|23e3","America/Paramaribo|LMT PMT PMT -0330 -03|3E.E 3E.Q 3E.A 3u 30|01234|-2nDUj.k Wqo0.c qanX.I 1yVXN.o|24e4","America/Port-au-Prince|LMT PPMT EST EDT|4N.k 4N 50 40|012323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-3eLva.E 15RLX.E 2FnMb 19X0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14q0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 i6n0 1nX0 11B0 1nX0 d430 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 3iN0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|23e5","America/Rio_Branco|LMT -05 -04|4v.c 50 40|01212121212121212121212121212121|-2glvs.M HdLs.M 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 NBd0 d5X0|31e4","America/Porto_Velho|LMT -04 -03|4f.A 40 30|012121212121212121212121212121|-2glvI.o HdKI.o 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0|37e4","America/Punta_Arenas|LMT SMT -05 -04 -03|4H.E 4G.J 50 40 30|01213132323232323232343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434|-3eLvg.k MJbX.5 fJAh.f 5knG.J 1Vzh.f jRAG.J 1pbh.f 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 nHX0 op0 blz0 ko0 Qeo0 WL0 1zd0 On0 1ip0 11z0 1o10 11z0 1qN0 WL0 1ld0 14n0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0|","America/Winnipeg|LMT CST CDT CWT CPT|6s.A 60 50 50 50|0121212134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-3kLtv.o 1a3bv.o WL0 3ND0 1in0 Jap0 Rb0 aCN0 8x30 iw0 1tB0 11z0 1ip0 11z0 1o10 11z0 1o10 11z0 1rd0 10L0 1op0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 1cL0 1cN0 11z0 6i10 WL0 6i10 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|66e4","America/Rankin_Inlet|-00 CST CDT EST|0 60 50 50|01212121212121212121212121212121212121212121212121212121212321212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-vDc0 Bjk0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|26e2","America/Recife|LMT -03 -02|2j.A 30 20|0121212121212121212121212121212121212121|-2glxE.o HdLE.o 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 nsp0 WL0 1tB0 2L0 2pB0 On0|33e5","America/Regina|LMT MST MDT MWT MPT CST|6W.A 70 60 60 60 60|012121212121212121212121341212121212121212121212121215|-2AD51.o uHe1.o 1in0 s2L0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 66N0 1cL0 1cN0 19X0 1fB0 1cL0 1fB0 1cL0 1cN0 1cL0 M30 8x20 ix0 1ip0 1cL0 1ip0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 3NB0 1cL0 1cN0|19e4","America/Resolute|-00 CST CDT EST|0 60 50 50|01212121212121212121212121212121212121212121212121212121212321212121212321212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-SnA0 103I0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|229","America/Santarem|LMT -04 -03|3C.M 40 30|0121212121212121212121212121212|-2glwl.c HdLl.c 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 NBd0|21e4","America/Santiago|LMT SMT -05 -04 -03|4G.J 4G.J 50 40 30|0121313232323232323432343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434|-3eLvh.f MJc0 fJAh.f 5knG.J 1Vzh.f jRAG.J 1pbh.f 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 nHX0 op0 9Bz0 hX0 1q10 ko0 Qeo0 WL0 1zd0 On0 1ip0 11z0 1o10 11z0 1qN0 WL0 1ld0 14n0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1zb0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0|62e5","America/Santo_Domingo|LMT SDMT EST EDT -0430 AST|4D.A 4E 50 40 4u 40|012324242424242525|-3eLvk.o 1Jic0.o 1lJMk Mn0 6sp0 Lbu 1Cou yLu 1RAu wLu 1QMu xzu 1Q0u xXu 1PAu 13jB0 e00|29e5","America/Sao_Paulo|LMT -03 -02|36.s 30 20|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2glwR.w HdKR.w 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 pTd0 PX0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 1C10 Lz0 1Ip0 HX0 1zd0 On0 1HB0 IL0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1zd0 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1HB0 FX0|20e6","America/Scoresbysund|LMT -02 -01 +00|1r.Q 20 10 0|012132323232323232323232323232323232323232323232323232323232323232323232323232323232323232121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2a5Ww.8 2z5ew.8 1a00 1cK0 1cL0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 2pA0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|452","America/Sitka|LMT LMT PST PWT PPT PDT YST AKST AKDT|-eW.L 91.d 80 70 70 70 90 90 80|0123425252525252525252525252525252567878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787|-48Pzs.L 1jVwu 1EX0W.L 8x10 iy0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 co0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|90e2","America/St_Johns|LMT NST NDT NST NDT NWT NPT NDDT|3u.Q 3u.Q 2u.Q 3u 2u 2u 2u 1u|012121212121212121212121212121212121213434343434343435634343434343434343434343434343434343434343434343434343434343434343434343434343434343437343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-3tokt.8 1l020 14L0 1nB0 1in0 1gm0 Dz0 1JB0 1cL0 1cN0 1cL0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 1cL0 1cN0 1cL0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 1cL0 1fB0 19X0 1fB0 19X0 10O0 eKX.8 19X0 1iq0 WL0 1qN0 WL0 1qN0 WL0 1tB0 TX0 1tB0 WL0 1qN0 WL0 1qN0 7UHu itu 1tB0 WL0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1tB0 WL0 1ld0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14n1 1lb0 14p0 1nW0 11C0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zcX Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|11e4","America/Swift_Current|LMT MST MDT MWT MPT CST|7b.k 70 60 60 60 60|012134121212121212121215|-2AD4M.E uHdM.E 1in0 UGp0 8x20 ix0 1o10 17b0 1ip0 11z0 1o10 11z0 1o10 11z0 isN0 1cL0 3Cp0 1cL0 1cN0 11z0 1qN0 WL0 pMp0|16e3","America/Tegucigalpa|LMT CST CDT|5M.Q 60 50|01212121|-1WGGb.8 2ETcb.8 WL0 1qN0 WL0 GRd0 AL0|11e5","America/Thule|LMT AST ADT|4z.8 40 30|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2a5To.Q 31NBo.Q 1cL0 1cN0 1cL0 1fB0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|656","America/Vancouver|LMT PST PDT PWT PPT|8c.s 80 70 70 70|01213412121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-3tofL.w 1nspL.w 1in0 UGp0 8x10 iy0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|23e5","America/Whitehorse|LMT YST YDT YWT YPT YDDT PST PDT MST|90.c 90 80 80 80 70 80 70 70|0121213415167676767676767676767676767676767676767676767676767676767676767676767676767676767678|-2MSeX.M GWpX.M 1in0 1o10 13V0 Ser0 8x00 iz0 LCL0 1fA0 LA0 ytd0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1z90|23e3","America/Yakutat|LMT LMT YST YWT YPT YDT AKST AKDT|-eF.5 9i.T 90 80 80 80 90 80|0123425252525252525252525252525252526767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-48Pzs.L 1jVwL.G 1EX1F.5 8x00 iz0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cn0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|642","Antarctica/Casey|-00 +08 +11|0 -80 -b0|012121212121212121|-2q00 1DjS0 T90 40P0 KL0 blz0 3m10 1o30 14k0 1kr0 12l0 1o01 14kX 1lf1 14kX 1lf1 13bX|10","Antarctica/Davis|-00 +07 +05|0 -70 -50|01012121|-vyo0 iXt0 alj0 1D7v0 VB0 3Wn0 KN0|70","Pacific/Port_Moresby|LMT PMMT +10|-9M.E -9M.w -a0|012|-3D8VM.E AvA0.8|25e4","Antarctica/Macquarie|-00 AEST AEDT|0 -a0 -b0|0121012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-2OPc0 Fb40 1a00 4SK0 1ayy0 Lvs0 1cM0 1o00 Rc0 1wo0 Rc0 1wo0 U00 1wo0 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1qM0 WM0 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1wo0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 11A0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 11A0 1o00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1cM0 1cM0 3Co0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0|1","Antarctica/Mawson|-00 +06 +05|0 -60 -50|012|-CEo0 2fyk0|60","Pacific/Auckland|LMT NZMT NZST NZST NZDT|-bD.4 -bu -cu -c0 -d0|012131313131313131313131313134343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434|-46jLD.4 2nEO9.4 Lz0 1tB0 11zu 1o0u 11zu 1o0u 11zu 1o0u 14nu 1lcu 14nu 1lcu 1lbu 11Au 1nXu 11Au 1nXu 11Au 1nXu 11Au 1nXu 11Au 1qLu WMu 1qLu 11Au 1n1bu IM0 1C00 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1qM0 14o0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1io0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00|14e5","Antarctica/Palmer|-00 -03 -04 -02|0 30 40 20|0121212121213121212121212121212121212121212121212121212121212121212121212121212121|-cao0 nD0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 jsN0 14N0 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0|40","Antarctica/Rothera|-00 -03|0 30|01|gOo0|130","Asia/Riyadh|LMT +03|-36.Q -30|01|-TvD6.Q|57e5","Antarctica/Troll|-00 +00 +02|0 0 -20|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|1puo0 hd0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|40","Antarctica/Vostok|-00 +07 +05|0 -70 -50|01012|-tjA0 1rWh0 1Nj0 1aTv0|25","Europe/Berlin|LMT CET CEST CEMT|-R.s -10 -20 -30|012121212121212321212321212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-36RcR.s UbWR.s 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 kL0 Nc0 m10 WM0 1ao0 1cp0 dX0 jz0 Dd0 1io0 17c0 1fA0 1a00 1ehA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|41e5","Asia/Almaty|LMT +05 +06 +07|-57.M -50 -60 -70|0123232323232323232323212323232323232323232323232321|-1Pc57.M eUo7.M 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 L4m0|15e5","Asia/Amman|LMT EET EEST +03|-2n.I -20 -30 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212123|-1yW2n.I 1HiMn.I KL0 1oN0 11b0 1oN0 11b0 1pd0 1dz0 1cp0 11b0 1op0 11b0 fO10 1db0 1e10 1cL0 1cN0 1cL0 1cN0 1fz0 1pd0 10n0 1ld0 14n0 1hB0 15b0 1ip0 19X0 1cN0 1cL0 1cN0 17b0 1ld0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1So0 y00 1fc0 1dc0 1co0 1dc0 1cM0 1cM0 1cM0 1o00 11A0 1lc0 17c0 1cM0 1cM0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 4bX0 Dd0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 LA0 1C00|25e5","Asia/Anadyr|LMT +12 +13 +14 +11|-bN.U -c0 -d0 -e0 -b0|01232121212121212121214121212121212121212121212121212121212141|-1PcbN.U eUnN.U 23CL0 1db0 2q10 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|13e3","Asia/Aqtau|LMT +04 +05 +06|-3l.4 -40 -50 -60|012323232323232323232123232312121212121212121212|-1Pc3l.4 eUnl.4 24PX0 2pX0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0|15e4","Asia/Aqtobe|LMT +04 +05 +06|-3M.E -40 -50 -60|0123232323232323232321232323232323232323232323232|-1Pc3M.E eUnM.E 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0|27e4","Asia/Ashgabat|LMT +04 +05 +06|-3R.w -40 -50 -60|0123232323232323232323212|-1Pc3R.w eUnR.w 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0|41e4","Asia/Atyrau|LMT +03 +05 +06 +04|-3r.I -30 -50 -60 -40|01232323232323232323242323232323232324242424242|-1Pc3r.I eUor.I 24PW0 2pX0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 2sp0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0|","Asia/Baghdad|LMT BMT +03 +04|-2V.E -2V.A -30 -40|0123232323232323232323232323232323232323232323232323232|-3eLCV.E 18ao0.4 2ACnV.A 11b0 1cp0 1dz0 1dd0 1db0 1cN0 1cp0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1de0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0|66e5","Asia/Qatar|LMT +04 +03|-3q.8 -40 -30|012|-21Jfq.8 27BXq.8|96e4","Asia/Baku|LMT +03 +04 +05|-3j.o -30 -40 -50|01232323232323232323232123232323232323232323232323232323232323232|-1Pc3j.o 1jUoj.o WCL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 1cM0 9Je0 1o00 11z0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|27e5","Asia/Bangkok|LMT BMT +07|-6G.4 -6G.4 -70|012|-3D8SG.4 1C000|15e6","Asia/Barnaul|LMT +06 +07 +08|-5z -60 -70 -80|0123232323232323232323212323232321212121212121212121212121212121212|-21S5z pCnz 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 p90 LE0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0|","Asia/Beirut|LMT EET EEST|-2m -20 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-3D8Om 1BWom 1on0 1410 1db0 19B0 1in0 1ip0 WL0 1lQp0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 11b0 q6N0 En0 1oN0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 11b0 1op0 11b0 dA10 17b0 1iN0 17b0 1iN0 17b0 1iN0 17b0 1vB0 SL0 1mp0 13z0 1iN0 17b0 1iN0 17b0 1jd0 12n0 1a10 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0|22e5","Asia/Bishkek|LMT +05 +06 +07|-4W.o -50 -60 -70|012323232323232323232321212121212121212121212121212|-1Pc4W.o eUnW.o 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2e00 1tX0 17b0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1cPu 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0|87e4","Asia/Brunei|LMT +0730 +08 +0820 +09|-7l.k -7u -80 -8k -90|0123232323232323242|-1KITl.k gDbP.k 6ynu AnE 1O0k AnE 1NAk AnE 1NAk AnE 1NAk AnE 1O0k AnE 1NAk AnE pAk 8Fz0|42e4","Asia/Kolkata|LMT HMT MMT IST +0630|-5R.s -5R.k -5l.a -5u -6u|01234343|-4Fg5R.s BKo0.8 1rDcw.a 1r2LP.a 1un0 HB0 7zX0|15e6","Asia/Chita|LMT +08 +09 +10|-7x.Q -80 -90 -a0|012323232323232323232321232323232323232323232323232323232323232312|-21Q7x.Q pAnx.Q 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3re0|33e4","Asia/Ulaanbaatar|LMT +07 +08 +09|-77.w -70 -80 -90|012323232323232323232323232323232323232323232323232|-2APH7.w 2Uko7.w cKn0 1db0 1dd0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 6hD0 11z0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 kEp0 1cJ0 1cP0 1cJ0|12e5","Asia/Shanghai|LMT CST CDT|-85.H -80 -90|012121212121212121212121212121|-2M0U5.H Iuo5.H 18n0 OjB0 Rz0 11d0 1wL0 A10 8HX0 1G10 Tz0 1ip0 1jX0 1cN0 11b0 1oN0 aL0 1tU30 Rb0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0|23e6","Asia/Colombo|LMT MMT +0530 +06 +0630|-5j.o -5j.w -5u -60 -6u|012342432|-3D8Rj.o 13inX.Q 1rFbN.w 1zzu 7Apu 23dz0 11zu n3cu|22e5","Asia/Dhaka|LMT HMT +0630 +0530 +06 +07|-61.E -5R.k -6u -5u -60 -70|01232454|-3eLG1.E 26008.k 1unn.k HB0 m6n0 2kxbu 1i00|16e6","Asia/Damascus|LMT EET EEST +03|-2p.c -20 -30 -30|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212123|-21Jep.c Hep.c 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1xRB0 11X0 1oN0 10L0 1pB0 11b0 1oN0 10L0 1mp0 13X0 1oN0 11b0 1pd0 11b0 1oN0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 Nb0 1AN0 Nb0 bcp0 19X0 1gp0 19X0 3ld0 1xX0 Vd0 1Bz0 Sp0 1vX0 10p0 1dz0 1cN0 1cL0 1db0 1db0 1g10 1an0 1ap0 1db0 1fd0 1db0 1cN0 1db0 1dd0 1db0 1cp0 1dz0 1c10 1dX0 1cN0 1db0 1dd0 1db0 1cN0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1db0 1cN0 1db0 1cN0 19z0 1fB0 1qL0 11B0 1on0 Wp0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0|26e5","Asia/Dili|LMT +08 +09|-8m.k -80 -90|01212|-2le80 1dnX0 1nfA0 Xld0|19e4","Asia/Dubai|LMT +04|-3F.c -40|01|-21JfF.c|39e5","Asia/Dushanbe|LMT +05 +06 +07|-4z.c -50 -60 -70|012323232323232323232321|-1Pc4z.c eUnz.c 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2hB0|76e4","Asia/Famagusta|LMT EET EEST +03|-2f.M -20 -30 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212312121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1Vc2f.M 2a3cf.M 1cL0 1qp0 Xz0 19B0 19X0 1fB0 1db0 1cp0 1cL0 1fB0 19X0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1o30 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 15U0 2Ks0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|","Asia/Gaza|LMT EET EEST IST IDT|-2h.Q -20 -30 -20 -30|0121212121212121212121212121212121234343434343434343434343434343431212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2MBCh.Q 1Azeh.Q MM0 iM0 4JA0 10o0 1pA0 10M0 1pA0 16o0 1jA0 16o0 1jA0 pBa0 Vz0 1oN0 11b0 1oO0 10N0 1pz0 10N0 1pb0 10N0 1pb0 10N0 1pb0 10N0 1pz0 10N0 1pb0 10N0 1pb0 11d0 1oL0 dW0 hfB0 Db0 1fB0 Rb0 bXB0 gM0 8Q00 IM0 1wo0 TX0 1HB0 IL0 1s10 10n0 1o10 WL0 1zd0 On0 1ld0 11z0 1o10 14n0 1o10 14n0 1nd0 12n0 1nd0 Xz0 1q10 12n0 M10 C00 17c0 1io0 17c0 1io0 17c0 1o00 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 17c0 1io0 18N0 1bz0 19z0 1gp0 1610 1iL0 11z0 1o10 14o0 1lA1 SKX 1xd1 MKX 1AN0 1a00 1fA0 1cL0 1cN0 1nX0 1210 1nA0 1210 1qL0 WN0 1qL0 WN0 1qL0 11c0 1on0 11B0 1o00 11A0 1qo0 XA0 1qp0 1cN0 1cL0 1a10 1fz0 17d0 1in0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1lb0 14p0 1in0 17d0 1cL0 1cN0 19X0 1fB0 14n0 jB0 2L0 11B0 WL0 gN0 8n0 11B0 TX0 gN0 bb0 11B0 On0 jB0 dX0 11B0 Lz0 gN0 mn0 WN0 IL0 gN0 pb0 WN0 Db0 jB0 rX0 11B0 xz0 gN0 xz0 11B0 rX0 jB0 An0 11B0 pb0 gN0 IL0 WN0 mn0 gN0 Lz0 WN0 gL0 jB0 On0 11B0 bb0 gN0 TX0 11B0 5z0 jB0 WL0 11B0 2L0 jB0 11z0 1ip0 19X0 1cN0 1cL0 17d0 1in0 14p0 1lb0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1nX0 14p0 1in0 17d0 1fz0 1a10 19X0 1fB0 17b0 gN0 2L0 WN0 14n0 gN0 5z0 WN0 WL0 jB0 8n0 11B0 Rb0 gN0 dX0 11B0 Lz0 jB0 gL0 11B0 IL0 jB0 mn0 WN0 FX0 gN0 rX0 WN0 An0 jB0 uL0 11B0 uL0 gN0 An0 11B0 rX0 gN0 Db0 11B0 mn0 jB0 FX0 11B0 jz0 gN0 On0 WN0 dX0 jB0 Rb0 WN0 bb0 jB0 TX0 11B0 5z0 gN0 11z0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0|18e5","Asia/Hebron|LMT EET EEST IST IDT|-2k.n -20 -30 -20 -30|012121212121212121212121212121212123434343434343434343434343434343121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2MBCk.n 1Azek.n MM0 iM0 4JA0 10o0 1pA0 10M0 1pA0 16o0 1jA0 16o0 1jA0 pBa0 Vz0 1oN0 11b0 1oO0 10N0 1pz0 10N0 1pb0 10N0 1pb0 10N0 1pb0 10N0 1pz0 10N0 1pb0 10N0 1pb0 11d0 1oL0 dW0 hfB0 Db0 1fB0 Rb0 bXB0 gM0 8Q00 IM0 1wo0 TX0 1HB0 IL0 1s10 10n0 1o10 WL0 1zd0 On0 1ld0 11z0 1o10 14n0 1o10 14n0 1nd0 12n0 1nd0 Xz0 1q10 12n0 M10 C00 17c0 1io0 17c0 1io0 17c0 1o00 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 17c0 1io0 18N0 1bz0 19z0 1gp0 1610 1iL0 12L0 1mN0 14o0 1lc0 Tb0 1xd1 MKX bB0 cn0 1cN0 1a00 1fA0 1cL0 1cN0 1nX0 1210 1nA0 1210 1qL0 WN0 1qL0 WN0 1qL0 11c0 1on0 11B0 1o00 11A0 1qo0 XA0 1qp0 1cN0 1cL0 1a10 1fz0 17d0 1in0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1lb0 14p0 1in0 17d0 1cL0 1cN0 19X0 1fB0 14n0 jB0 2L0 11B0 WL0 gN0 8n0 11B0 TX0 gN0 bb0 11B0 On0 jB0 dX0 11B0 Lz0 gN0 mn0 WN0 IL0 gN0 pb0 WN0 Db0 jB0 rX0 11B0 xz0 gN0 xz0 11B0 rX0 jB0 An0 11B0 pb0 gN0 IL0 WN0 mn0 gN0 Lz0 WN0 gL0 jB0 On0 11B0 bb0 gN0 TX0 11B0 5z0 jB0 WL0 11B0 2L0 jB0 11z0 1ip0 19X0 1cN0 1cL0 17d0 1in0 14p0 1lb0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1nX0 14p0 1in0 17d0 1fz0 1a10 19X0 1fB0 17b0 gN0 2L0 WN0 14n0 gN0 5z0 WN0 WL0 jB0 8n0 11B0 Rb0 gN0 dX0 11B0 Lz0 jB0 gL0 11B0 IL0 jB0 mn0 WN0 FX0 gN0 rX0 WN0 An0 jB0 uL0 11B0 uL0 gN0 An0 11B0 rX0 gN0 Db0 11B0 mn0 jB0 FX0 11B0 jz0 gN0 On0 WN0 dX0 jB0 Rb0 WN0 bb0 jB0 TX0 11B0 5z0 gN0 11z0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0|25e4","Asia/Ho_Chi_Minh|LMT PLMT +07 +08 +09|-76.u -76.u -70 -80 -90|0123423232|-2yC76.u bK00 1h7b6.u 5lz0 18o0 3Oq0 k5c0 aVX0 BAM0|90e5","Asia/Hong_Kong|LMT HKT HKST HKWT JST|-7A.G -80 -90 -8u -90|0123412121212121212121212121212121212121212121212121212121212121212121|-2CFH0 1taO0 Hc0 xUu 9tBu 11z0 1tDu Rc0 1wo0 11A0 1cM0 11A0 1o00 11A0 1o00 11A0 1o00 14o0 1o00 11A0 1nX0 U10 1tz0 U10 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 U10 1tz0 U10 1wn0 Rd0 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 17d0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 s10 1Vz0 1cN0 1cL0 1cN0 1cL0 6fd0 14n0|73e5","Asia/Hovd|LMT +06 +07 +08|-66.A -60 -70 -80|012323232323232323232323232323232323232323232323232|-2APG6.A 2Uko6.A cKn0 1db0 1dd0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 6hD0 11z0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 kEp0 1cJ0 1cP0 1cJ0|81e3","Asia/Irkutsk|LMT IMT +07 +08 +09|-6V.5 -6V.5 -70 -80 -90|012343434343434343434343234343434343434343434343434343434343434343|-3D8SV.5 1Bxc0 pjXV.5 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|60e4","Europe/Istanbul|LMT IMT EET EEST +03 +04|-1T.Q -1U.U -20 -30 -30 -40|01232323232323232323232323232323232323232323232345423232323232323232323232323232323232323232323232323232323232323234|-3D8NT.Q 1ePXW.U dzzU.U 11b0 8tB0 1on0 1410 1db0 19B0 1in0 3Rd0 Un0 1oN0 11b0 zSN0 CL0 mp0 1Vz0 1gN0 8yn0 1yp0 ML0 1kp0 17b0 1ip0 17b0 1fB0 19X0 1ip0 19X0 1ip0 17b0 qdB0 38L0 1jd0 Tz0 l6O0 11A0 WN0 1qL0 TB0 1tX0 U10 1tz0 11B0 1in0 17d0 z90 cne0 pb0 2Cp0 1800 14o0 1dc0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1a00 1fA0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WO0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 Xc0 1qo0 WM0 1qM0 11A0 1o00 1200 1nA0 11A0 1tA0 U00 15w0|13e6","Asia/Jakarta|LMT BMT +0720 +0730 +09 +08 WIB|-77.c -77.c -7k -7u -90 -80 -70|012343536|-49jH7.c 2hiLL.c luM0 mPzO 8vWu 6kpu 4PXu xhcu|31e6","Asia/Jayapura|LMT +09 +0930 WIT|-9m.M -90 -9u -90|0123|-1uu9m.M sMMm.M L4nu|26e4","Asia/Jerusalem|LMT JMT IST IDT IDDT|-2k.S -2k.E -20 -30 -40|012323232323232432323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-3D8Ok.S 1wvA0.e SyOk.E MM0 iM0 4JA0 10o0 1pA0 10M0 1pA0 16o0 1jA0 16o0 1jA0 3LA0 Eo0 oo0 1co0 1dA0 16o0 10M0 1jc0 1tA0 14o0 1cM0 1a00 11A0 1Nc0 Ao0 1Nc0 Ao0 1Ko0 LA0 1o00 WM0 EQK0 Db0 1fB0 Rb0 bXB0 gM0 8Q00 IM0 1wo0 TX0 1HB0 IL0 1s10 10n0 1o10 WL0 1zd0 On0 1ld0 11z0 1o10 14n0 1o10 14n0 1nd0 12n0 1nd0 Xz0 1q10 12n0 1hB0 1dX0 1ep0 1aL0 1eN0 17X0 1nf0 11z0 1tB0 19W0 1e10 17b0 1ep0 1gL0 18N0 1fz0 1eN0 17b0 1gq0 1gn0 19d0 1dz0 1c10 17X0 1hB0 1gn0 19d0 1dz0 1c10 17X0 1kp0 1dz0 1c10 1aL0 1eN0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0|81e4","Asia/Kabul|LMT +04 +0430|-4A.M -40 -4u|012|-3eLEA.M 2dTcA.M|46e5","Asia/Kamchatka|LMT +11 +12 +13|-ay.A -b0 -c0 -d0|012323232323232323232321232323232323232323232323232323232323212|-1SLKy.A ivXy.A 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|18e4","Asia/Karachi|LMT +0530 +0630 +05 PKT PKST|-4s.c -5u -6u -50 -50 -60|012134545454|-2xoss.c 1qOKW.c 7zX0 eup0 LqMu 1fy00 1cL0 dK10 11b0 1610 1jX0|24e6","Asia/Urumqi|LMT +06|-5O.k -60|01|-1GgtO.k|32e5","Asia/Kathmandu|LMT +0530 +0545|-5F.g -5u -5J|012|-21JhF.g 2EGMb.g|12e5","Asia/Khandyga|LMT +08 +09 +10 +11|-92.d -80 -90 -a0 -b0|0123232323232323232323212323232323232323232323232343434343434343432|-21Q92.d pAp2.d 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 qK0 yN0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 17V0 7zD0|66e2","Asia/Krasnoyarsk|LMT +06 +07 +08|-6b.q -60 -70 -80|01232323232323232323232123232323232323232323232323232323232323232|-21Hib.q prAb.q 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|10e5","Asia/Kuala_Lumpur|LMT SMT +07 +0720 +0730 +09 +08|-6T.p -6T.p -70 -7k -7u -90 -80|01234546|-2M0ST.p aIM0 17anT.p l5XE 17bO 8Fyu 1so10|71e5","Asia/Macau|LMT CST +09 +10 CDT|-7y.a -80 -90 -a0 -90|012323214141414141414141414141414141414141414141414141414141414141414141|-2CFHy.a 1uqKy.a PX0 1kn0 15B0 11b0 4Qq0 1oM0 11c0 1ko0 1u00 11A0 1cM0 11c0 1o00 11A0 1o00 11A0 1oo0 1400 1o00 11A0 1o00 U00 1tA0 U00 1wo0 Rc0 1wru U10 1tz0 U10 1tz0 U10 1tz0 U10 1wn0 Rd0 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 17d0 1cK0 1cO0 1cK0 1cO0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 s10 1Vz0 1cN0 1cL0 1cN0 1cL0 6fd0 14n0|57e4","Asia/Magadan|LMT +10 +11 +12|-a3.c -a0 -b0 -c0|012323232323232323232321232323232323232323232323232323232323232312|-1Pca3.c eUo3.c 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3Cq0|95e3","Asia/Makassar|LMT MMT +08 +09 WITA|-7V.A -7V.A -80 -90 -80|01234|-21JjV.A vfc0 myLV.A 8ML0|15e5","Asia/Manila|LMT LMT PST PDT JST|fU.8 -83.Q -80 -90 -90|012323432323232|-54m83.Q 2d8A3.Q 1urM0 un0 bW10 nb0 7qo0 1MM0 klB0 lz0 TwN0 1bb0 uNB0 rz0|24e6","Asia/Nicosia|LMT EET EEST|-2d.s -20 -30|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1Vc2d.s 2a3cd.s 1cL0 1qp0 Xz0 19B0 19X0 1fB0 1db0 1cp0 1cL0 1fB0 19X0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1o30 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|32e4","Asia/Novokuznetsk|LMT +06 +07 +08|-5M.M -60 -70 -80|012323232323232323232321232323232323232323232323232323232323212|-1PctM.M eULM.M 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|55e4","Asia/Novosibirsk|LMT +06 +07 +08|-5v.E -60 -70 -80|0123232323232323232323212323212121212121212121212121212121212121212|-21Qnv.E pAFv.E 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 ml0 Os0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 4eN0|15e5","Asia/Omsk|LMT +05 +06 +07|-4R.u -50 -60 -70|01232323232323232323232123232323232323232323232323232323232323232|-224sR.u pMLR.u 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|12e5","Asia/Oral|LMT +03 +05 +06 +04|-3p.o -30 -50 -60 -40|01232323232323232424242424242424242424242424242|-1Pc3p.o eUop.o 23CK0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 1cM0 1cM0 IM0 1EM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0|27e4","Asia/Pontianak|LMT PMT +0730 +09 +08 WITA WIB|-7h.k -7h.k -7u -90 -80 -80 -70|012324256|-2ua7h.k XE00 munL.k 8Rau 6kpu 4PXu xhcu Wqnu|23e4","Asia/Pyongyang|LMT KST JST KST|-8n -8u -90 -90|012313|-2um8n 97XR 1lTzu 2Onc0 6BA0|29e5","Asia/Qostanay|LMT +04 +05 +06|-4e.s -40 -50 -60|0123232323232323232321232323232323232323232323232|-1Pc4e.s eUoe.s 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 Mv90|","Asia/Qyzylorda|LMT +04 +05 +06|-4l.Q -40 -50 -60|01232323232323232323232323232323232323232323232|-1Pc4l.Q eUol.Q 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 3ao0 1EM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 zQl0|73e4","Asia/Rangoon|LMT RMT +0630 +09|-6o.L -6o.L -6u -90|01232|-3D8So.L 1BnA0 SmnS.L 7j9u|48e5","Asia/Sakhalin|LMT +09 +11 +12 +10|-9u.M -90 -b0 -c0 -a0|01232323232323232323232423232323232424242424242424242424242424242|-2AGVu.M 1BoMu.M 1qFa0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 2pB0 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0|58e4","Asia/Samarkand|LMT +04 +05 +06|-4r.R -40 -50 -60|01232323232323232323232|-1Pc4r.R eUor.R 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0|36e4","Asia/Seoul|LMT KST JST KST KDT KDT|-8r.Q -8u -90 -90 -a0 -9u|012343434343151515151515134343|-2um8r.Q 97XV.Q 1m1zu 6CM0 Fz0 1kN0 14n0 1kN0 14L0 1zd0 On0 69B0 2I0u OL0 1FB0 Rb0 1qN0 TX0 1tB0 TX0 1tB0 TX0 1tB0 TX0 2ap0 12FBu 11A0 1o00 11A0|23e6","Asia/Srednekolymsk|LMT +10 +11 +12|-ae.Q -a0 -b0 -c0|01232323232323232323232123232323232323232323232323232323232323232|-1Pcae.Q eUoe.Q 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|35e2","Asia/Taipei|LMT CST JST CDT|-86 -80 -90 -90|012131313131313131313131313131313131313131|-30bk6 1FDc6 joM0 1yo0 Tz0 1ip0 1jX0 1cN0 11b0 1oN0 11b0 1oN0 11b0 1oN0 11b0 10N0 1BX0 10p0 1pz0 10p0 1pz0 10p0 1db0 1dd0 1db0 1cN0 1db0 1cN0 1db0 1cN0 1db0 1BB0 ML0 1Bd0 ML0 uq10 1db0 1cN0 1db0 97B0 AL0|74e5","Asia/Tashkent|LMT +05 +06 +07|-4B.b -50 -60 -70|012323232323232323232321|-1Pc4B.b eUnB.b 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0|23e5","Asia/Tbilisi|LMT TBMT +03 +04 +05|-2X.b -2X.b -30 -40 -50|01234343434343434343434323232343434343434343434323|-3D8OX.b 1LUM0 1jUnX.b WCL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 1cK0 1cL0 1cN0 1cL0 1cN0 2pz0 1cL0 1fB0 3Nz0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 An0 Os0 WM0|11e5","Asia/Tehran|LMT TMT +0330 +0430 +04 +05|-3p.I -3p.I -3u -4u -40 -50|012345423232323232323232323232323232323232323232323232323232323232323232|-2btDp.I Llc0 1FHaT.I 1pc0 120u Rc0 Dc0 1iMu JX0 1dB0 1en0 pNB0 UL0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 64p0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0|14e6","Asia/Thimphu|LMT +0530 +06|-5W.A -5u -60|012|-Su5W.A 1BGMs.A|79e3","Asia/Tokyo|LMT JST JDT|-9i.X -90 -a0|0121212121|-3jE90 2qSo0 Rc0 1lc0 14o0 1zc0 Oo0 1zc0 Oo0|38e6","Asia/Tomsk|LMT +06 +07 +08|-5D.P -60 -70 -80|0123232323232323232323212323232323232323232323212121212121212121212|-21NhD.P pxzD.P 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 co0 1bB0 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3Qp0|10e5","Asia/Ust-Nera|LMT +08 +09 +12 +11 +10|-9w.S -80 -90 -c0 -b0 -a0|012343434343434343434345434343434343434343434343434343434343434345|-21Q9w.S pApw.S 23CL0 1d90 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 17V0 7zD0|65e2","Asia/Vladivostok|LMT +09 +10 +11|-8L.v -90 -a0 -b0|01232323232323232323232123232323232323232323232323232323232323232|-1SJIL.v itXL.v 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|60e4","Asia/Yakutsk|LMT +08 +09 +10|-8C.W -80 -90 -a0|01232323232323232323232123232323232323232323232323232323232323232|-21Q8C.W pAoC.W 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|28e4","Asia/Yekaterinburg|LMT PMT +04 +05 +06|-42.x -3J.5 -40 -50 -60|012343434343434343434343234343434343434343434343434343434343434343|-2ag42.x 7mQh.s qBvJ.5 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|14e5","Asia/Yerevan|LMT +03 +04 +05|-2W -30 -40 -50|0123232323232323232323212121212323232323232323232323232323232|-1Pc2W 1jUnW WCL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 4RX0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0|13e5","Atlantic/Azores|LMT HMT -02 -01 +00 WET WEST|1G.E 1S.w 20 10 0 0 -10|012323232323232323232323232323232323232323232343234323432343232323232323232323232323232323232323232323434343434343434343434356434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-3tomh.k 18aoh.k aPX0 Sp0 M00 1vb0 SN0 1vb0 SN0 1vb0 Td0 1vb0 SN0 1vb0 6600 18o0 3I00 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 3I00 17c0 1cM0 1cM0 3Fc0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 1uo0 1c00 1dc0 1400 gL0 IM0 s10 U00 dX0 Rc0 pd0 Rc0 gL0 Oo0 pd0 Rc0 gL0 Oo0 pd0 14o0 1cM0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 CT90 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 Ap0 An0 wo0 Eo0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|25e4","Atlantic/Bermuda|LMT BMT BST AST ADT|4j.i 4j.i 3j.i 40 30|0121213434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-3eLvE.G 16mo0 1bb0 1i10 11X0 ru30 thbE.G 1PX0 11B0 1tz0 Rd0 1zb0 Op0 1zb0 3I10 Lz0 1EN0 FX0 1HB0 FX0 1Kp0 Db0 1Kp0 Db0 1Kp0 FX0 93d0 11z0 GAp0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|65e3","Atlantic/Canary|LMT -01 WET WEST|11.A 10 0 -10|01232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-1UtaW.o XPAW.o 1lAK0 1a10 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|54e4","Atlantic/Cape_Verde|LMT -02 -01|1y.4 20 10|01212|-2ldW0 1eEo0 7zX0 1djf0|50e4","Atlantic/Faroe|LMT WET WEST|r.4 0 -10|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2uSnw.U 2Wgow.U 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|49e3","Atlantic/Madeira|LMT FMT -01 +00 +01 WET WEST|17.A 17.A 10 0 -10 0 -10|01232323232323232323232323232323232323232323234323432343234323232323232323232323232323232323232323232356565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-3tomQ.o 18anQ.o aPX0 Sp0 M00 1vb0 SN0 1vb0 SN0 1vb0 Td0 1vb0 SN0 1vb0 6600 18o0 3I00 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 3I00 17c0 1cM0 1cM0 3Fc0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 1uo0 1c00 1dc0 1400 gL0 IM0 s10 U00 dX0 Rc0 pd0 Rc0 gL0 Oo0 pd0 Rc0 gL0 Oo0 pd0 14o0 1cM0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 BJ90 1a00 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cN0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|27e4","Atlantic/South_Georgia|LMT -02|2q.8 20|01|-3eLxx.Q|30","Atlantic/Stanley|LMT SMT -04 -03 -02|3P.o 3P.o 40 30 20|0123232323232323434323232323232323232323232323232323232323232323232323|-3eLw8.A S200 12bA8.A 19X0 1fB0 19X0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 Cn0 1Cc10 WL0 1qL0 U10 1tz0 2mN0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1tz0 U10 1tz0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1tz0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qN0 U10 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 U10 1tz0 U10 1tz0 U10 1wn0 U10 1tz0 U10 1tz0 U10|21e2","Australia/Sydney|LMT AEST AEDT|-a4.Q -a0 -b0|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-32oW4.Q RlC4.Q xc0 10jc0 yM0 1cM0 1cM0 1fA0 1a00 17c00 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 14o0 1o00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1tA0 WM0 1tA0 U00 1tA0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 11A0 1o00 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0|40e5","Australia/Adelaide|LMT ACST ACST ACDT|-9e.k -90 -9u -au|012323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-32oVe.k ak0e.k H1Bu xc0 10jc0 yM0 1cM0 1cM0 1fA0 1a00 17c00 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 Oo0 1zc0 WM0 1qM0 Rc0 1zc0 U00 1tA0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0|11e5","Australia/Brisbane|LMT AEST AEDT|-ac.8 -a0 -b0|012121212121212121|-32Bmc.8 Ry2c.8 xc0 10jc0 yM0 1cM0 1cM0 1fA0 1a00 17c00 LA0 H1A0 Oo0 1zc0 Oo0 1zc0 Oo0|20e5","Australia/Broken_Hill|LMT AEST ACST ACST ACDT|-9p.M -a0 -90 -9u -au|0123434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434|-32oVp.M 3Lzp.M 6wp0 H1Bu xc0 10jc0 yM0 1cM0 1cM0 1fA0 1a00 17c00 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 14o0 1o00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1tA0 WM0 1tA0 U00 1tA0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0|18e3","Australia/Hobart|LMT AEST AEDT|-9N.g -a0 -b0|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-3109N.g Pk1N.g 1a00 1qM0 Oo0 1zc0 Oo0 TAo0 yM0 1cM0 1cM0 1fA0 1a00 VfA0 1cM0 1o00 Rc0 1wo0 Rc0 1wo0 U00 1wo0 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1qM0 WM0 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1wo0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 11A0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 11A0 1o00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0|21e4","Australia/Darwin|LMT ACST ACST ACDT|-8H.k -90 -9u -au|01232323232|-32oUH.k ajXH.k H1Bu xc0 10jc0 yM0 1cM0 1cM0 1fA0 1a00|12e4","Australia/Eucla|LMT +0845 +0945|-8z.s -8J -9J|01212121212121212121|-30nIz.s PkpO.s xc0 10jc0 yM0 1cM0 1cM0 1gSo0 Oo0 l5A0 Oo0 iJA0 G00 zU00 IM0 1qM0 11A0 1o00 11A0|368","Australia/Lord_Howe|LMT AEST +1030 +1130 +11|-aA.k -a0 -au -bu -b0|01232323232424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424|-32oWA.k 3tzAA.k 1zdu Rb0 1zd0 On0 1zd0 On0 1zd0 On0 1zd0 TXu 1qMu WLu 1tAu WLu 1tAu TXu 1tAu Onu 1zcu Onu 1zcu Onu 1zcu Rbu 1zcu Onu 1zcu Onu 1zcu 11zu 1o0u 11zu 1o0u 11zu 1o0u 11zu 1qMu WLu 11Au 1nXu 1qMu 11zu 1o0u 11zu 1o0u 11zu 1qMu WLu 1qMu 11zu 1o0u WLu 1qMu 14nu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu|347","Australia/Lindeman|LMT AEST AEDT|-9T.U -a0 -b0|0121212121212121212121|-32BlT.U Ry1T.U xc0 10jc0 yM0 1cM0 1cM0 1fA0 1a00 17c00 LA0 H1A0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0|10","Australia/Melbourne|LMT AEST AEDT|-9D.Q -a0 -b0|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-32oVD.Q RlBD.Q xc0 10jc0 yM0 1cM0 1cM0 1fA0 1a00 17c00 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1qM0 11A0 1tA0 U00 1tA0 U00 1tA0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 11A0 1o00 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0|39e5","Australia/Perth|LMT AWST AWDT|-7H.o -80 -90|01212121212121212121|-30nHH.o PkpH.o xc0 10jc0 yM0 1cM0 1cM0 1gSo0 Oo0 l5A0 Oo0 iJA0 G00 zU00 IM0 1qM0 11A0 1o00 11A0|18e5","Europe/Brussels|LMT BMT WET CET CEST WEST|-h.u -h.u 0 -10 -20 -10|012343434325252525252525252525252525252525252525252525434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-3D8Mh.u u1Ah.u SO00 3zX0 11c0 1iO0 11A0 1o00 11A0 my0 Ic0 1qM0 Rc0 1EM0 UM0 1u00 10o0 1io0 1io0 17c0 1a00 1fA0 1cM0 1cM0 1io0 17c0 1fA0 1a00 1io0 1a30 1io0 17c0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 y00 5Wn0 WM0 1fA0 1cM0 16M0 1iM0 16M0 1C00 Uo0 1eeo0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|21e5","Pacific/Easter|LMT EMT -07 -06 -05|7h.s 7h.s 70 60 50|0123232323232323232323232323234343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434|-3eLsG.w 1HRc0 1s4IG.w WL0 1zd0 On0 1ip0 11z0 1o10 11z0 1qN0 WL0 1ld0 14n0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 2pA0 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1zb0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0|30e2","Europe/Athens|LMT AMT EET EEST CEST CET|-1y.Q -1y.Q -20 -30 -20 -10|0123234545232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-30SNy.Q OMM1 CNbx.Q mn0 kU10 9b0 3Es0 Xa0 1fb0 1dd0 k3X0 Nz0 SCp0 1vc0 SO0 1cM0 1a00 1ao0 1fc0 1a10 1fG0 1cg0 1dX0 1bX0 1cQ0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|35e5","Europe/Dublin|LMT DMT IST GMT BST IST|p.l p.l -y.D 0 -10 -10|012343434343435353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353|-3BHby.D 1ra20 Rc0 1fzy.D 14M0 1fc0 1g00 1co0 1dc0 1co0 1oo0 1400 1dc0 19A0 1io0 1io0 WM0 1o00 14o0 1o00 17c0 1io0 17c0 1fA0 1a00 1lc0 17c0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1cM0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1io0 1qM0 Dc0 g600 14o0 1wo0 17c0 1io0 11A0 1o00 17c0 1fA0 1a00 1fA0 1cM0 1fA0 1a00 17c0 1fA0 1a00 1io0 17c0 1lc0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1a00 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1tA0 IM0 90o0 U00 1tA0 U00 1tA0 U00 1tA0 U00 1tA0 WM0 1qM0 WM0 1qM0 WM0 1tA0 U00 1tA0 U00 1tA0 11z0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 14o0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|12e5","Etc/GMT-0|GMT|0|0||","Etc/GMT-1|+01|-10|0||","Etc/GMT-10|+10|-a0|0||","Etc/GMT-11|+11|-b0|0||","Etc/GMT-12|+12|-c0|0||","Etc/GMT-13|+13|-d0|0||","Etc/GMT-14|+14|-e0|0||","Etc/GMT-2|+02|-20|0||","Etc/GMT-3|+03|-30|0||","Etc/GMT-4|+04|-40|0||","Etc/GMT-5|+05|-50|0||","Etc/GMT-6|+06|-60|0||","Etc/GMT-7|+07|-70|0||","Etc/GMT-8|+08|-80|0||","Etc/GMT-9|+09|-90|0||","Etc/GMT+1|-01|10|0||","Etc/GMT+10|-10|a0|0||","Etc/GMT+11|-11|b0|0||","Etc/GMT+12|-12|c0|0||","Etc/GMT+2|-02|20|0||","Etc/GMT+3|-03|30|0||","Etc/GMT+4|-04|40|0||","Etc/GMT+5|-05|50|0||","Etc/GMT+6|-06|60|0||","Etc/GMT+7|-07|70|0||","Etc/GMT+8|-08|80|0||","Etc/GMT+9|-09|90|0||","Etc/UTC|UTC|0|0||","Europe/Andorra|LMT WET CET CEST|-6.4 0 -10 -20|0123232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-2M0M6.4 1Pnc6.4 1xIN0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|79e3","Europe/Astrakhan|LMT +03 +04 +05|-3c.c -30 -40 -50|012323232323232323212121212121212121212121212121212121212121212|-1Pcrc.c eUMc.c 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 1cM0 3Co0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0|10e5","Europe/London|LMT GMT BST BDST|1.f 0 -10 -20|01212121212121212121212121212121212121212121212121232323232321212321212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-4VgnW.J 2KHdW.J Rc0 1fA0 14M0 1fc0 1g00 1co0 1dc0 1co0 1oo0 1400 1dc0 19A0 1io0 1io0 WM0 1o00 14o0 1o00 17c0 1io0 17c0 1fA0 1a00 1lc0 17c0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1cM0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1io0 1qM0 Dc0 2Rz0 Dc0 1zc0 Oo0 1zc0 Rc0 1wo0 17c0 1iM0 FA0 xB0 1fA0 1a00 14o0 bb0 LA0 xB0 Rc0 1wo0 11A0 1o00 17c0 1fA0 1a00 1fA0 1cM0 1fA0 1a00 17c0 1fA0 1a00 1io0 17c0 1lc0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1a00 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1tA0 IM0 90o0 U00 1tA0 U00 1tA0 U00 1tA0 U00 1tA0 WM0 1qM0 WM0 1qM0 WM0 1tA0 U00 1tA0 U00 1tA0 11z0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 14o0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|10e6","Europe/Belgrade|LMT CET CEST|-1m -10 -20|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-3topm 2juLm 3IP0 WM0 1fA0 1cM0 1cM0 1rc0 Qo0 1vmo0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|12e5","Europe/Prague|LMT PMT CET CEST GMT|-V.I -V.I -10 -20 0|0123232323232323232423232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-4QbAV.I 1FDc0 XPaV.I 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 1cM0 1qM0 11c0 mp0 xA0 mn0 17c0 1io0 17c0 1fc0 1ao0 1bNc0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|13e5","Europe/Bucharest|LMT BMT EET EEST|-1I.o -1I.o -20 -30|01232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-3awpI.o 1AU00 20LI.o RA0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1Axc0 On0 1fA0 1a10 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cK0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cL0 1cN0 1cL0 1fB0 1nX0 11E0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|19e5","Europe/Budapest|LMT CET CEST|-1g.k -10 -20|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-3cK1g.k 124Lg.k 11d0 1iO0 11A0 1o00 11A0 1oo0 11c0 1lc0 17c0 O1V0 3Nf0 WM0 1fA0 1cM0 1cM0 1oJ0 1dd0 1020 1fX0 1cp0 1cM0 1cM0 1cM0 1fA0 1a00 bhy0 Rb0 1wr0 Rc0 1C00 LA0 1C00 LA0 SNW0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cO0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|17e5","Europe/Zurich|LMT BMT CET CEST|-y.8 -t.K -10 -20|0123232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-4HyMy.8 1Dw04.m 1SfAt.K 11A0 1o00 11A0 1xG10 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|38e4","Europe/Chisinau|LMT CMT BMT EET EEST CEST CET MSK MSD|-1T.k -1T -1I.o -20 -30 -20 -10 -30 -40|0123434343434343434345656578787878787878787878434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-3D8NT.k 1wNA0.k wGMa.A 20LI.o RA0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 27A0 2en0 39g0 WM0 1fA0 1cM0 V90 1t7z0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 gL0 WO0 1cM0 1cM0 1cK0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1nX0 11D0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|67e4","Europe/Gibraltar|LMT GMT BST BDST CET CEST|l.o 0 -10 -20 -10 -20|0121212121212121212121212121212121212121212121212123232323232121232121212121212121212145454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-3BHbC.A 1ra1C.A Rc0 1fA0 14M0 1fc0 1g00 1co0 1dc0 1co0 1oo0 1400 1dc0 19A0 1io0 1io0 WM0 1o00 14o0 1o00 17c0 1io0 17c0 1fA0 1a00 1lc0 17c0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1cM0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1io0 1qM0 Dc0 2Rz0 Dc0 1zc0 Oo0 1zc0 Rc0 1wo0 17c0 1iM0 FA0 xB0 1fA0 1a00 14o0 bb0 LA0 xB0 Rc0 1wo0 11A0 1o00 17c0 1fA0 1a00 1fA0 1cM0 1fA0 1a00 17c0 1fA0 1a00 1io0 17c0 1lc0 17c0 1fA0 10Jz0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|30e3","Europe/Helsinki|LMT HMT EET EEST|-1D.N -1D.N -20 -30|01232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-3H0ND.N 1Iu00 OULD.N 1dA0 1xGq0 1cM0 1cM0 1cM0 1cN0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|12e5","Europe/Kaliningrad|LMT CET CEST EET EEST MSK MSD +03|-1m -10 -20 -20 -30 -30 -40 -30|012121212121212343565656565656565654343434343434343434343434343434343434343434373|-36Rdm UbXm 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 390 7A0 1en0 12N0 1pbb0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|44e4","Europe/Kiev|LMT KMT EET MSK CEST CET MSD EEST|-22.4 -22.4 -20 -30 -20 -10 -40 -30|01234545363636363636363636367272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272|-3D8O2.4 1LUM0 eUo2.4 rnz0 2Hg0 WM0 1fA0 da0 1v4m0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 Db0 3220 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o10 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|34e5","Europe/Kirov|LMT +03 +04 +05 MSD MSK MSK|-3i.M -30 -40 -50 -40 -30 -40|0123232323232323232454524545454545454545454545454545454545454565|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 2pz0 1cN0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|48e4","Europe/Lisbon|LMT WET WEST WEMT CET CEST|A.J 0 -10 -20 -10 -20|012121212121212121212121212121212121212121212321232123212321212121212121212121212121212121212121212124121212121212121212121212121212124545454212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2le00 aPX0 Sp0 M00 1vb0 SN0 1vb0 SN0 1vb0 Td0 1vb0 SN0 1vb0 6600 18o0 3I00 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 3I00 17c0 1cM0 1cM0 3Fc0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 1uo0 1c00 1dc0 1400 gL0 IM0 s10 U00 dX0 Rc0 pd0 Rc0 gL0 Oo0 pd0 Rc0 gL0 Oo0 pd0 14o0 1cM0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 oiK0 1cM0 1cM0 1fB0 1cM0 1cM0 1cM0 1fA0 1a00 1cL0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cN0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|27e5","Europe/Madrid|LMT WET WEST WEMT CET CEST|e.I 0 -10 -20 -10 -20|0121212121212121212321454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-2M0M0 G5z0 19B0 1cL0 1dd0 b1z0 18p0 3HX0 17d0 1fz0 1a10 1io0 1a00 1in0 17d0 iIn0 Hd0 1cL0 bb0 1200 2s20 14n0 5aL0 Mp0 1vz0 17d0 1in0 17d0 1in0 17d0 1in0 17d0 6hX0 11B0 XHX0 1a10 1fz0 1a10 19X0 1cN0 1fz0 1a10 1fC0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|62e5","Europe/Malta|LMT CET CEST|-W.4 -10 -20|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-35rcW.4 SXzW.4 Lz0 1cN0 1db0 1410 1on0 Wp0 1qL0 17d0 1cL0 M3B0 5M20 WM0 1fA0 1co0 17c0 1iM0 16m0 1de0 1lc0 14m0 1lc0 WO0 1qM0 GTW0 On0 1C10 LA0 1C00 LA0 1EM0 LA0 1C00 LA0 1zc0 Oo0 1C00 Oo0 1co0 1cM0 1lA0 Xc0 1qq0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1iN0 19z0 1fB0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|42e4","Europe/Minsk|LMT MMT EET MSK CEST CET MSD EEST +03|-1O.g -1O -20 -30 -20 -10 -40 -30 -30|012345454363636363636363636372727272727272727272727272727272727272728|-3D8NO.g 1LUM0.g eUnO qNX0 3gQ0 WM0 1fA0 1cM0 Al0 1tsn0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 3Fc0 1cN0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0|19e5","Europe/Paris|LMT PMT WET WEST CEST CET WEMT|-9.l -9.l 0 -10 -20 -10 -20|01232323232323232323232323232323232323232323232323234545463654545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545|-3bQ09.l MDA0 cNb9.l HA0 19A0 1iM0 11c0 1oo0 Wo0 1rc0 QM0 1EM0 UM0 1u00 10o0 1io0 1wo0 Rc0 1a00 1fA0 1cM0 1cM0 1io0 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Df0 Ik0 5M30 WM0 1fA0 1cM0 Vx0 hB0 1aq0 16M0 1ekn0 1cL0 1fC0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|11e6","Europe/Moscow|LMT MMT MMT MST MDST MSD MSK +05 EET EEST MSK|-2u.h -2u.h -2v.j -3v.j -4v.j -40 -30 -50 -20 -30 -40|01232434565756865656565656565656565698656565656565656565656565656565656565656a6|-3D8Ou.h 1sQM0 2pyW.W 1bA0 11X0 GN0 1Hb0 c4v.j ik0 3DA0 dz0 15A0 c10 2q10 iM10 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cN0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|16e6","Europe/Riga|LMT RMT LST EET MSK CEST CET MSD EEST|-1A.y -1A.y -2A.y -20 -30 -20 -10 -40 -30|0121213456565647474747474747474838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383|-3D8NA.y 1xde0 11A0 1iM0 ko0 gWm0 yDXA.y 2bX0 3fE0 WM0 1fA0 1cM0 1cM0 4m0 1sLy0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cN0 1o00 11A0 1o00 11A0 1qM0 3oo0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|64e4","Europe/Rome|LMT RMT CET CEST|-N.U -N.U -10 -20|012323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-4aU0N.U 15snN.U T000 Lz0 1cN0 1db0 1410 1on0 Wp0 1qL0 17d0 1cL0 M3B0 5M20 WM0 1fA0 1cM0 16M0 1iM0 16m0 1de0 1lc0 14m0 1lc0 WO0 1qM0 GTW0 On0 1C10 LA0 1C00 LA0 1EM0 LA0 1C00 LA0 1zc0 Oo0 1C00 Oo0 1C00 LA0 1zc0 Oo0 1C00 LA0 1C00 LA0 1zc0 Oo0 1C00 Oo0 1zc0 Oo0 1fC0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|39e5","Europe/Samara|LMT +03 +04 +05|-3k.k -30 -40 -50|0123232323232323232121232323232323232323232323232323232323212|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 2y10 14m0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|12e5","Europe/Saratov|LMT +03 +04 +05|-34.i -30 -40 -50|012323232323232321212121212121212121212121212121212121212121212|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1cM0 1cM0 1fA0 1cM0 3Co0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 5810|","Europe/Simferopol|LMT SMT EET MSK CEST CET MSD EEST MSK|-2g.o -2g -20 -30 -20 -10 -40 -30 -40|0123454543636363636363636363272727636363727272727272727272727272727272727283|-3D8Og.o 1LUM0.o eUog rEn0 2qs0 WM0 1fA0 1cM0 3V0 1u0L0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1Q00 4eN0 1cM0 1cM0 1cM0 1cM0 dV0 WO0 1cM0 1cM0 1fy0 1o30 11B0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11z0 1nW0|33e4","Europe/Sofia|LMT IMT EET CET CEST EEST|-1x.g -1U.U -20 -10 -20 -30|0123434325252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252|-3D8Nx.g AiLA.k 1UFeU.U WM0 1fA0 1cM0 1cM0 1cN0 1mKH0 1dd0 1fb0 1ap0 1fb0 1a20 1fy0 1a30 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cK0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1nX0 11E0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|12e5","Europe/Tallinn|LMT TMT CET CEST EET MSK MSD EEST|-1D -1D -10 -20 -20 -30 -40 -30|0123214532323565656565656565657474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474|-3D8ND 1wI00 teD 11A0 1Ta0 4rXl KSLD 2FX0 2Jg0 WM0 1fA0 1cM0 18J0 1sTX0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o10 11A0 1qM0 5QM0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|41e4","Europe/Tirane|LMT CET CEST|-1j.k -10 -20|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2glBj.k 14pcj.k 5LC0 WM0 4M0 1fCK0 10n0 1op0 11z0 1pd0 11z0 1qN0 WL0 1qp0 Xb0 1qp0 Xb0 1qp0 11z0 1lB0 11z0 1qN0 11z0 1iN0 16n0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|42e4","Europe/Ulyanovsk|LMT +03 +04 +05 +02|-3d.A -30 -40 -50 -20|01232323232323232321214121212121212121212121212121212121212121212|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0|13e5","Europe/Vienna|LMT CET CEST|-15.l -10 -20|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-36Rd5.l UbX5.l 11d0 1iO0 11A0 1o00 11A0 3KM0 14o0 LA00 6i00 WM0 1fA0 1cM0 1cM0 1cM0 400 2qM0 1ao0 1co0 1cM0 1io0 17c0 1gHa0 19X0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|18e5","Europe/Vilnius|LMT WMT KMT CET EET MSK CEST MSD EEST|-1F.g -1o -1z.A -10 -20 -30 -20 -40 -30|0123435636365757575757575757584848484848484848463648484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484|-3D8NF.g 1u5Ah.g 6ILM.o 1Ooz.A zz0 Mfd0 29W0 3is0 WM0 1fA0 1cM0 LV0 1tgL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11B0 1o00 11A0 1qM0 8io0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|54e4","Europe/Volgograd|LMT +03 +04 +05 MSD MSK MSK|-2V.E -30 -40 -50 -40 -30 -40|012323232323232324545452454545454545454545454545454545454545456525|-21IqV.E psLV.E 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1cM0 1cM0 1fA0 1cM0 2pz0 1cN0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 9Jd0 5gn0|10e5","Europe/Warsaw|LMT WMT CET CEST EET EEST|-1o -1o -10 -20 -20 -30|0123232345423232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-3D8No 1qDA0 1LXo 11d0 1iO0 11A0 1o00 11A0 1on0 11A0 6zy0 HWP0 5IM0 WM0 1fA0 1cM0 1dz0 1mL0 1en0 15B0 1aq0 1nA0 11A0 1io0 17c0 1fA0 1a00 iDX0 LA0 1cM0 1cM0 1C00 Oo0 1cM0 1cM0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1C00 LA0 uso0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|17e5","Pacific/Honolulu|LMT HST HDT HWT HPT HST|av.q au 9u 9u 9u a0|01213415|-3061s.y 1uMdW.y 8x0 lef0 8wWu iAu 46p0|37e4","Indian/Chagos|LMT +05 +06|-4N.E -50 -60|012|-2xosN.E 3AGLN.E|30e2","Indian/Maldives|LMT MMT +05|-4S -4S -50|012|-3D8QS 3eLA0|35e4","Indian/Mauritius|LMT +04 +05|-3O -40 -50|012121|-2xorO 34unO 14L0 12kr0 11z0|15e4","Pacific/Kwajalein|LMT +11 +10 +09 -12 +12|-b9.k -b0 -a0 -90 c0 -c0|0123145|-2M0X9.k 1rDA9.k akp0 6Up0 12ry0 Wan0|14e3","Pacific/Chatham|LMT +1215 +1245 +1345|-cd.M -cf -cJ -dJ|0123232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-46jMd.M 37RbW.M 1adef IM0 1C00 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1qM0 14o0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1io0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00|600","Pacific/Apia|LMT LMT -1130 -11 -10 +14 +13|-cx.4 bq.U bu b0 a0 -e0 -d0|012343456565656565656565656|-38Fox.4 J1A0 1yW03.4 2rRbu 1ff0 1a00 CI0 AQ0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0|37e3","Pacific/Bougainville|LMT PMMT +10 +09 +11|-am.g -9M.w -a0 -90 -b0|012324|-3D8Wm.g AvAx.I 1TCLM.w 7CN0 2MQp0|18e4","Pacific/Efate|LMT +11 +12|-bd.g -b0 -c0|012121212121212121212121|-2l9nd.g 2uNXd.g Dc0 n610 1cL0 1cN0 1cL0 1fB0 19X0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 Lz0 1Nd0 An0|66e3","Pacific/Enderbury|-00 -12 -11 +13|0 c0 b0 -d0|0123|-1iIo0 1GsA0 B7X0|1","Pacific/Fakaofo|LMT -11 +13|bo.U b0 -d0|012|-2M0Az.4 4ufXz.4|483","Pacific/Fiji|LMT +12 +13|-bT.I -c0 -d0|012121212121212121212121212121|-2bUzT.I 3m8NT.I LA0 1EM0 IM0 nJc0 LA0 1o00 Rc0 1wo0 Ao0 1Nc0 Ao0 1Q00 xz0 1SN0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 20o0 pc0 2hc0 bc0|88e4","Pacific/Tarawa|LMT +12|-bw.4 -c0|01|-2M0Xw.4|29e3","Pacific/Galapagos|LMT -05 -06|5W.o 50 60|01212|-1yVS1.A 2dTz1.A gNd0 rz0|25e3","Pacific/Gambier|LMT -09|8X.M 90|01|-2jof0.c|125","Pacific/Guadalcanal|LMT +11|-aD.M -b0|01|-2joyD.M|11e4","Pacific/Guam|LMT LMT GST +09 GDT ChST|el -9D -a0 -90 -b0 -a0|0123242424242424242425|-54m9D 2glc0 1DFbD 6pB0 AhB0 3QL0 g2p0 3p91 WOX rX0 1zd0 Rb0 1wp0 Rb0 5xd0 rX0 5sN0 zb1 1C0X On0 ULb0|17e4","Pacific/Kiritimati|LMT -1040 -10 +14|at.k aE a0 -e0|0123|-2M0Bu.E 3bIMa.E B7Xk|51e2","Pacific/Kosrae|LMT LMT +11 +09 +10 +12|d8.4 -aP.U -b0 -90 -a0 -c0|0123243252|-54maP.U 2glc0 xsnP.U axC0 HBy0 akp0 axd0 WOK0 1bdz0|66e2","Pacific/Marquesas|LMT -0930|9i 9u|01|-2joeG|86e2","Pacific/Pago_Pago|LMT LMT SST|-cB.c bm.M b0|012|-38FoB.c J1A0|37e2","Pacific/Nauru|LMT +1130 +09 +12|-b7.E -bu -90 -c0|01213|-1Xdn7.E QCnB.E 7mqu 1lnbu|10e3","Pacific/Niue|LMT -1120 -11|bj.E bk b0|012|-FScE.k suo0.k|12e2","Pacific/Norfolk|LMT +1112 +1130 +1230 +11 +12|-bb.Q -bc -bu -cu -b0 -c0|0123245454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545|-2M0Xb.Q 21ILX.Q W01G Oo0 1COo0 9Jcu 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0|25e4","Pacific/Noumea|LMT +11 +12|-b5.M -b0 -c0|01212121|-2l9n5.M 2EqM5.M xX0 1PB0 yn0 HeP0 Ao0|98e3","Pacific/Palau|LMT LMT +09|f2.4 -8V.U -90|012|-54m8V.U 2glc0|21e3","Pacific/Pitcairn|LMT -0830 -08|8E.k 8u 80|012|-2M0Dj.E 3UVXN.E|56","Pacific/Rarotonga|LMT LMT -1030 -0930 -10|-dk.U aD.4 au 9u a0|01234343434343434343434343434|-2Otpk.U 28zc0 13tbO.U IL0 1zcu Onu 1zcu Onu 1zcu Rbu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Rbu 1zcu Onu 1zcu Onu 1zcu Onu|13e3","Pacific/Tahiti|LMT -10|9W.g a0|01|-2joe1.I|18e4","Pacific/Tongatapu|LMT +1220 +13 +14|-cj.c -ck -d0 -e0|01232323232|-XbMj.c BgLX.c 1yndk 15A0 1wo0 xz0 1Q10 xz0 zWN0 s00|75e3"],"links":["Africa/Abidjan|Africa/Accra","Africa/Abidjan|Africa/Bamako","Africa/Abidjan|Africa/Banjul","Africa/Abidjan|Africa/Conakry","Africa/Abidjan|Africa/Dakar","Africa/Abidjan|Africa/Freetown","Africa/Abidjan|Africa/Lome","Africa/Abidjan|Africa/Nouakchott","Africa/Abidjan|Africa/Ouagadougou","Africa/Abidjan|Africa/Timbuktu","Africa/Abidjan|Atlantic/Reykjavik","Africa/Abidjan|Atlantic/St_Helena","Africa/Abidjan|Iceland","Africa/Cairo|Egypt","Africa/Johannesburg|Africa/Maseru","Africa/Johannesburg|Africa/Mbabane","Africa/Lagos|Africa/Bangui","Africa/Lagos|Africa/Brazzaville","Africa/Lagos|Africa/Douala","Africa/Lagos|Africa/Kinshasa","Africa/Lagos|Africa/Libreville","Africa/Lagos|Africa/Luanda","Africa/Lagos|Africa/Malabo","Africa/Lagos|Africa/Niamey","Africa/Lagos|Africa/Porto-Novo","Africa/Maputo|Africa/Blantyre","Africa/Maputo|Africa/Bujumbura","Africa/Maputo|Africa/Gaborone","Africa/Maputo|Africa/Harare","Africa/Maputo|Africa/Kigali","Africa/Maputo|Africa/Lubumbashi","Africa/Maputo|Africa/Lusaka","Africa/Nairobi|Africa/Addis_Ababa","Africa/Nairobi|Africa/Asmara","Africa/Nairobi|Africa/Asmera","Africa/Nairobi|Africa/Dar_es_Salaam","Africa/Nairobi|Africa/Djibouti","Africa/Nairobi|Africa/Kampala","Africa/Nairobi|Africa/Mogadishu","Africa/Nairobi|Indian/Antananarivo","Africa/Nairobi|Indian/Comoro","Africa/Nairobi|Indian/Mayotte","Africa/Tripoli|Libya","America/Adak|America/Atka","America/Adak|US/Aleutian","America/Anchorage|US/Alaska","America/Argentina/Buenos_Aires|America/Buenos_Aires","America/Argentina/Catamarca|America/Argentina/ComodRivadavia","America/Argentina/Catamarca|America/Catamarca","America/Argentina/Cordoba|America/Cordoba","America/Argentina/Cordoba|America/Rosario","America/Argentina/Jujuy|America/Jujuy","America/Argentina/Mendoza|America/Mendoza","America/Chicago|CST6CDT","America/Chicago|US/Central","America/Denver|America/Shiprock","America/Denver|MST7MDT","America/Denver|Navajo","America/Denver|US/Mountain","America/Detroit|US/Michigan","America/Edmonton|America/Yellowknife","America/Edmonton|Canada/Mountain","America/Fort_Wayne|America/Indiana/Indianapolis","America/Fort_Wayne|America/Indianapolis","America/Fort_Wayne|US/East-Indiana","America/Godthab|America/Nuuk","America/Halifax|Canada/Atlantic","America/Havana|Cuba","America/Indiana/Knox|America/Knox_IN","America/Indiana/Knox|US/Indiana-Starke","America/Iqaluit|America/Pangnirtung","America/Jamaica|Jamaica","America/Kentucky/Louisville|America/Louisville","America/Los_Angeles|PST8PDT","America/Los_Angeles|US/Pacific","America/Manaus|Brazil/West","America/Mazatlan|Mexico/BajaSur","America/Mexico_City|Mexico/General","America/New_York|EST5EDT","America/New_York|US/Eastern","America/Noronha|Brazil/DeNoronha","America/Panama|America/Atikokan","America/Panama|America/Cayman","America/Panama|America/Coral_Harbour","America/Panama|EST","America/Phoenix|America/Creston","America/Phoenix|MST","America/Phoenix|US/Arizona","America/Puerto_Rico|America/Anguilla","America/Puerto_Rico|America/Antigua","America/Puerto_Rico|America/Aruba","America/Puerto_Rico|America/Blanc-Sablon","America/Puerto_Rico|America/Curacao","America/Puerto_Rico|America/Dominica","America/Puerto_Rico|America/Grenada","America/Puerto_Rico|America/Guadeloupe","America/Puerto_Rico|America/Kralendijk","America/Puerto_Rico|America/Lower_Princes","America/Puerto_Rico|America/Marigot","America/Puerto_Rico|America/Montserrat","America/Puerto_Rico|America/Port_of_Spain","America/Puerto_Rico|America/St_Barthelemy","America/Puerto_Rico|America/St_Kitts","America/Puerto_Rico|America/St_Lucia","America/Puerto_Rico|America/St_Thomas","America/Puerto_Rico|America/St_Vincent","America/Puerto_Rico|America/Tortola","America/Puerto_Rico|America/Virgin","America/Regina|Canada/Saskatchewan","America/Rio_Branco|America/Porto_Acre","America/Rio_Branco|Brazil/Acre","America/Santiago|Chile/Continental","America/Sao_Paulo|Brazil/East","America/St_Johns|Canada/Newfoundland","America/Tijuana|America/Ensenada","America/Tijuana|America/Santa_Isabel","America/Tijuana|Mexico/BajaNorte","America/Toronto|America/Montreal","America/Toronto|America/Nassau","America/Toronto|America/Nipigon","America/Toronto|America/Thunder_Bay","America/Toronto|Canada/Eastern","America/Vancouver|Canada/Pacific","America/Whitehorse|Canada/Yukon","America/Winnipeg|America/Rainy_River","America/Winnipeg|Canada/Central","Asia/Ashgabat|Asia/Ashkhabad","Asia/Bangkok|Asia/Phnom_Penh","Asia/Bangkok|Asia/Vientiane","Asia/Bangkok|Indian/Christmas","Asia/Brunei|Asia/Kuching","Asia/Dhaka|Asia/Dacca","Asia/Dubai|Asia/Muscat","Asia/Dubai|Indian/Mahe","Asia/Dubai|Indian/Reunion","Asia/Ho_Chi_Minh|Asia/Saigon","Asia/Hong_Kong|Hongkong","Asia/Jerusalem|Asia/Tel_Aviv","Asia/Jerusalem|Israel","Asia/Kathmandu|Asia/Katmandu","Asia/Kolkata|Asia/Calcutta","Asia/Kuala_Lumpur|Asia/Singapore","Asia/Kuala_Lumpur|Singapore","Asia/Macau|Asia/Macao","Asia/Makassar|Asia/Ujung_Pandang","Asia/Nicosia|Europe/Nicosia","Asia/Qatar|Asia/Bahrain","Asia/Rangoon|Asia/Yangon","Asia/Rangoon|Indian/Cocos","Asia/Riyadh|Antarctica/Syowa","Asia/Riyadh|Asia/Aden","Asia/Riyadh|Asia/Kuwait","Asia/Seoul|ROK","Asia/Shanghai|Asia/Chongqing","Asia/Shanghai|Asia/Chungking","Asia/Shanghai|Asia/Harbin","Asia/Shanghai|PRC","Asia/Taipei|ROC","Asia/Tehran|Iran","Asia/Thimphu|Asia/Thimbu","Asia/Tokyo|Japan","Asia/Ulaanbaatar|Asia/Choibalsan","Asia/Ulaanbaatar|Asia/Ulan_Bator","Asia/Urumqi|Asia/Kashgar","Atlantic/Faroe|Atlantic/Faeroe","Australia/Adelaide|Australia/South","Australia/Brisbane|Australia/Queensland","Australia/Broken_Hill|Australia/Yancowinna","Australia/Darwin|Australia/North","Australia/Hobart|Australia/Currie","Australia/Hobart|Australia/Tasmania","Australia/Lord_Howe|Australia/LHI","Australia/Melbourne|Australia/Victoria","Australia/Perth|Australia/West","Australia/Sydney|Australia/ACT","Australia/Sydney|Australia/Canberra","Australia/Sydney|Australia/NSW","Etc/GMT-0|Etc/GMT","Etc/GMT-0|Etc/GMT+0","Etc/GMT-0|Etc/GMT0","Etc/GMT-0|Etc/Greenwich","Etc/GMT-0|GMT","Etc/GMT-0|GMT+0","Etc/GMT-0|GMT-0","Etc/GMT-0|GMT0","Etc/GMT-0|Greenwich","Etc/UTC|Etc/UCT","Etc/UTC|Etc/Universal","Etc/UTC|Etc/Zulu","Etc/UTC|UCT","Etc/UTC|UTC","Etc/UTC|Universal","Etc/UTC|Zulu","Europe/Athens|EET","Europe/Belgrade|Europe/Ljubljana","Europe/Belgrade|Europe/Podgorica","Europe/Belgrade|Europe/Sarajevo","Europe/Belgrade|Europe/Skopje","Europe/Belgrade|Europe/Zagreb","Europe/Berlin|Arctic/Longyearbyen","Europe/Berlin|Atlantic/Jan_Mayen","Europe/Berlin|Europe/Copenhagen","Europe/Berlin|Europe/Oslo","Europe/Berlin|Europe/Stockholm","Europe/Brussels|CET","Europe/Brussels|Europe/Amsterdam","Europe/Brussels|Europe/Luxembourg","Europe/Brussels|MET","Europe/Chisinau|Europe/Tiraspol","Europe/Dublin|Eire","Europe/Helsinki|Europe/Mariehamn","Europe/Istanbul|Asia/Istanbul","Europe/Istanbul|Turkey","Europe/Kiev|Europe/Kyiv","Europe/Kiev|Europe/Uzhgorod","Europe/Kiev|Europe/Zaporozhye","Europe/Lisbon|Portugal","Europe/Lisbon|WET","Europe/London|Europe/Belfast","Europe/London|Europe/Guernsey","Europe/London|Europe/Isle_of_Man","Europe/London|Europe/Jersey","Europe/London|GB","Europe/London|GB-Eire","Europe/Moscow|W-SU","Europe/Paris|Europe/Monaco","Europe/Prague|Europe/Bratislava","Europe/Rome|Europe/San_Marino","Europe/Rome|Europe/Vatican","Europe/Warsaw|Poland","Europe/Zurich|Europe/Busingen","Europe/Zurich|Europe/Vaduz","Indian/Maldives|Indian/Kerguelen","Pacific/Auckland|Antarctica/McMurdo","Pacific/Auckland|Antarctica/South_Pole","Pacific/Auckland|NZ","Pacific/Chatham|NZ-CHAT","Pacific/Easter|Chile/EasterIsland","Pacific/Enderbury|Pacific/Kanton","Pacific/Guadalcanal|Pacific/Pohnpei","Pacific/Guadalcanal|Pacific/Ponape","Pacific/Guam|Pacific/Saipan","Pacific/Honolulu|HST","Pacific/Honolulu|Pacific/Johnston","Pacific/Honolulu|US/Hawaii","Pacific/Kwajalein|Kwajalein","Pacific/Pago_Pago|Pacific/Midway","Pacific/Pago_Pago|Pacific/Samoa","Pacific/Pago_Pago|US/Samoa","Pacific/Port_Moresby|Antarctica/DumontDUrville","Pacific/Port_Moresby|Pacific/Chuuk","Pacific/Port_Moresby|Pacific/Truk","Pacific/Port_Moresby|Pacific/Yap","Pacific/Tarawa|Pacific/Funafuti","Pacific/Tarawa|Pacific/Majuro","Pacific/Tarawa|Pacific/Wake","Pacific/Tarawa|Pacific/Wallis"],"countries":["AD|Europe/Andorra","AE|Asia/Dubai","AF|Asia/Kabul","AG|America/Puerto_Rico America/Antigua","AI|America/Puerto_Rico America/Anguilla","AL|Europe/Tirane","AM|Asia/Yerevan","AO|Africa/Lagos Africa/Luanda","AQ|Antarctica/Casey Antarctica/Davis Antarctica/Mawson Antarctica/Palmer Antarctica/Rothera Antarctica/Troll Antarctica/Vostok Pacific/Auckland Pacific/Port_Moresby Asia/Riyadh Asia/Singapore Antarctica/McMurdo Antarctica/DumontDUrville Antarctica/Syowa","AR|America/Argentina/Buenos_Aires America/Argentina/Cordoba America/Argentina/Salta America/Argentina/Jujuy America/Argentina/Tucuman America/Argentina/Catamarca America/Argentina/La_Rioja America/Argentina/San_Juan America/Argentina/Mendoza America/Argentina/San_Luis America/Argentina/Rio_Gallegos America/Argentina/Ushuaia","AS|Pacific/Pago_Pago","AT|Europe/Vienna","AU|Australia/Lord_Howe Antarctica/Macquarie Australia/Hobart Australia/Melbourne Australia/Sydney Australia/Broken_Hill Australia/Brisbane Australia/Lindeman Australia/Adelaide Australia/Darwin Australia/Perth Australia/Eucla Asia/Tokyo","AW|America/Puerto_Rico America/Aruba","AX|Europe/Helsinki Europe/Mariehamn","AZ|Asia/Baku","BA|Europe/Belgrade Europe/Sarajevo","BB|America/Barbados","BD|Asia/Dhaka","BE|Europe/Brussels","BF|Africa/Abidjan Africa/Ouagadougou","BG|Europe/Sofia","BH|Asia/Qatar Asia/Bahrain","BI|Africa/Maputo Africa/Bujumbura","BJ|Africa/Lagos Africa/Porto-Novo","BL|America/Puerto_Rico America/St_Barthelemy","BM|Atlantic/Bermuda","BN|Asia/Kuching Asia/Brunei","BO|America/La_Paz","BQ|America/Puerto_Rico America/Kralendijk","BR|America/Noronha America/Belem America/Fortaleza America/Recife America/Araguaina America/Maceio America/Bahia America/Sao_Paulo America/Campo_Grande America/Cuiaba America/Santarem America/Porto_Velho America/Boa_Vista America/Manaus America/Eirunepe America/Rio_Branco","BS|America/Toronto America/Nassau","BT|Asia/Thimphu","BW|Africa/Maputo Africa/Gaborone","BY|Europe/Minsk","BZ|America/Belize","CA|America/St_Johns America/Halifax America/Glace_Bay America/Moncton America/Goose_Bay America/Toronto America/Iqaluit America/Winnipeg America/Resolute America/Rankin_Inlet America/Regina America/Swift_Current America/Edmonton America/Cambridge_Bay America/Inuvik America/Dawson_Creek America/Fort_Nelson America/Whitehorse America/Dawson America/Vancouver America/Panama America/Puerto_Rico America/Phoenix America/Blanc-Sablon America/Atikokan America/Creston","CC|Asia/Yangon Indian/Cocos","CD|Africa/Maputo Africa/Lagos Africa/Kinshasa Africa/Lubumbashi","CF|Africa/Lagos Africa/Bangui","CG|Africa/Lagos Africa/Brazzaville","CH|Europe/Zurich","CI|Africa/Abidjan","CK|Pacific/Rarotonga","CL|America/Santiago America/Coyhaique America/Punta_Arenas Pacific/Easter","CM|Africa/Lagos Africa/Douala","CN|Asia/Shanghai Asia/Urumqi","CO|America/Bogota","CR|America/Costa_Rica","CU|America/Havana","CV|Atlantic/Cape_Verde","CW|America/Puerto_Rico America/Curacao","CX|Asia/Bangkok Indian/Christmas","CY|Asia/Nicosia Asia/Famagusta","CZ|Europe/Prague","DE|Europe/Zurich Europe/Berlin Europe/Busingen","DJ|Africa/Nairobi Africa/Djibouti","DK|Europe/Berlin Europe/Copenhagen","DM|America/Puerto_Rico America/Dominica","DO|America/Santo_Domingo","DZ|Africa/Algiers","EC|America/Guayaquil Pacific/Galapagos","EE|Europe/Tallinn","EG|Africa/Cairo","EH|Africa/El_Aaiun","ER|Africa/Nairobi Africa/Asmara","ES|Europe/Madrid Africa/Ceuta Atlantic/Canary","ET|Africa/Nairobi Africa/Addis_Ababa","FI|Europe/Helsinki","FJ|Pacific/Fiji","FK|Atlantic/Stanley","FM|Pacific/Kosrae Pacific/Port_Moresby Pacific/Guadalcanal Pacific/Chuuk Pacific/Pohnpei","FO|Atlantic/Faroe","FR|Europe/Paris","GA|Africa/Lagos Africa/Libreville","GB|Europe/London","GD|America/Puerto_Rico America/Grenada","GE|Asia/Tbilisi","GF|America/Cayenne","GG|Europe/London Europe/Guernsey","GH|Africa/Abidjan Africa/Accra","GI|Europe/Gibraltar","GL|America/Nuuk America/Danmarkshavn America/Scoresbysund America/Thule","GM|Africa/Abidjan Africa/Banjul","GN|Africa/Abidjan Africa/Conakry","GP|America/Puerto_Rico America/Guadeloupe","GQ|Africa/Lagos Africa/Malabo","GR|Europe/Athens","GS|Atlantic/South_Georgia","GT|America/Guatemala","GU|Pacific/Guam","GW|Africa/Bissau","GY|America/Guyana","HK|Asia/Hong_Kong","HN|America/Tegucigalpa","HR|Europe/Belgrade Europe/Zagreb","HT|America/Port-au-Prince","HU|Europe/Budapest","ID|Asia/Jakarta Asia/Pontianak Asia/Makassar Asia/Jayapura","IE|Europe/Dublin","IL|Asia/Jerusalem","IM|Europe/London Europe/Isle_of_Man","IN|Asia/Kolkata","IO|Indian/Chagos","IQ|Asia/Baghdad","IR|Asia/Tehran","IS|Africa/Abidjan Atlantic/Reykjavik","IT|Europe/Rome","JE|Europe/London Europe/Jersey","JM|America/Jamaica","JO|Asia/Amman","JP|Asia/Tokyo","KE|Africa/Nairobi","KG|Asia/Bishkek","KH|Asia/Bangkok Asia/Phnom_Penh","KI|Pacific/Tarawa Pacific/Kanton Pacific/Kiritimati","KM|Africa/Nairobi Indian/Comoro","KN|America/Puerto_Rico America/St_Kitts","KP|Asia/Pyongyang","KR|Asia/Seoul","KW|Asia/Riyadh Asia/Kuwait","KY|America/Panama America/Cayman","KZ|Asia/Almaty Asia/Qyzylorda Asia/Qostanay Asia/Aqtobe Asia/Aqtau Asia/Atyrau Asia/Oral","LA|Asia/Bangkok Asia/Vientiane","LB|Asia/Beirut","LC|America/Puerto_Rico America/St_Lucia","LI|Europe/Zurich Europe/Vaduz","LK|Asia/Colombo","LR|Africa/Monrovia","LS|Africa/Johannesburg Africa/Maseru","LT|Europe/Vilnius","LU|Europe/Brussels Europe/Luxembourg","LV|Europe/Riga","LY|Africa/Tripoli","MA|Africa/Casablanca","MC|Europe/Paris Europe/Monaco","MD|Europe/Chisinau","ME|Europe/Belgrade Europe/Podgorica","MF|America/Puerto_Rico America/Marigot","MG|Africa/Nairobi Indian/Antananarivo","MH|Pacific/Tarawa Pacific/Kwajalein Pacific/Majuro","MK|Europe/Belgrade Europe/Skopje","ML|Africa/Abidjan Africa/Bamako","MM|Asia/Yangon","MN|Asia/Ulaanbaatar Asia/Hovd","MO|Asia/Macau","MP|Pacific/Guam Pacific/Saipan","MQ|America/Martinique","MR|Africa/Abidjan Africa/Nouakchott","MS|America/Puerto_Rico America/Montserrat","MT|Europe/Malta","MU|Indian/Mauritius","MV|Indian/Maldives","MW|Africa/Maputo Africa/Blantyre","MX|America/Mexico_City America/Cancun America/Merida America/Monterrey America/Matamoros America/Chihuahua America/Ciudad_Juarez America/Ojinaga America/Mazatlan America/Bahia_Banderas America/Hermosillo America/Tijuana","MY|Asia/Kuching Asia/Singapore Asia/Kuala_Lumpur","MZ|Africa/Maputo","NA|Africa/Windhoek","NC|Pacific/Noumea","NE|Africa/Lagos Africa/Niamey","NF|Pacific/Norfolk","NG|Africa/Lagos","NI|America/Managua","NL|Europe/Brussels Europe/Amsterdam","NO|Europe/Berlin Europe/Oslo","NP|Asia/Kathmandu","NR|Pacific/Nauru","NU|Pacific/Niue","NZ|Pacific/Auckland Pacific/Chatham","OM|Asia/Dubai Asia/Muscat","PA|America/Panama","PE|America/Lima","PF|Pacific/Tahiti Pacific/Marquesas Pacific/Gambier","PG|Pacific/Port_Moresby Pacific/Bougainville","PH|Asia/Manila","PK|Asia/Karachi","PL|Europe/Warsaw","PM|America/Miquelon","PN|Pacific/Pitcairn","PR|America/Puerto_Rico","PS|Asia/Gaza Asia/Hebron","PT|Europe/Lisbon Atlantic/Madeira Atlantic/Azores","PW|Pacific/Palau","PY|America/Asuncion","QA|Asia/Qatar","RE|Asia/Dubai Indian/Reunion","RO|Europe/Bucharest","RS|Europe/Belgrade","RU|Europe/Kaliningrad Europe/Moscow Europe/Simferopol Europe/Kirov Europe/Volgograd Europe/Astrakhan Europe/Saratov Europe/Ulyanovsk Europe/Samara Asia/Yekaterinburg Asia/Omsk Asia/Novosibirsk Asia/Barnaul Asia/Tomsk Asia/Novokuznetsk Asia/Krasnoyarsk Asia/Irkutsk Asia/Chita Asia/Yakutsk Asia/Khandyga Asia/Vladivostok Asia/Ust-Nera Asia/Magadan Asia/Sakhalin Asia/Srednekolymsk Asia/Kamchatka Asia/Anadyr","RW|Africa/Maputo Africa/Kigali","SA|Asia/Riyadh","SB|Pacific/Guadalcanal","SC|Asia/Dubai Indian/Mahe","SD|Africa/Khartoum","SE|Europe/Berlin Europe/Stockholm","SG|Asia/Singapore","SH|Africa/Abidjan Atlantic/St_Helena","SI|Europe/Belgrade Europe/Ljubljana","SJ|Europe/Berlin Arctic/Longyearbyen","SK|Europe/Prague Europe/Bratislava","SL|Africa/Abidjan Africa/Freetown","SM|Europe/Rome Europe/San_Marino","SN|Africa/Abidjan Africa/Dakar","SO|Africa/Nairobi Africa/Mogadishu","SR|America/Paramaribo","SS|Africa/Juba","ST|Africa/Sao_Tome","SV|America/El_Salvador","SX|America/Puerto_Rico America/Lower_Princes","SY|Asia/Damascus","SZ|Africa/Johannesburg Africa/Mbabane","TC|America/Grand_Turk","TD|Africa/Ndjamena","TF|Asia/Dubai Indian/Maldives Indian/Kerguelen","TG|Africa/Abidjan Africa/Lome","TH|Asia/Bangkok","TJ|Asia/Dushanbe","TK|Pacific/Fakaofo","TL|Asia/Dili","TM|Asia/Ashgabat","TN|Africa/Tunis","TO|Pacific/Tongatapu","TR|Europe/Istanbul","TT|America/Puerto_Rico America/Port_of_Spain","TV|Pacific/Tarawa Pacific/Funafuti","TW|Asia/Taipei","TZ|Africa/Nairobi Africa/Dar_es_Salaam","UA|Europe/Simferopol Europe/Kyiv","UG|Africa/Nairobi Africa/Kampala","UM|Pacific/Pago_Pago Pacific/Tarawa Pacific/Midway Pacific/Wake","US|America/New_York America/Detroit America/Kentucky/Louisville America/Kentucky/Monticello America/Indiana/Indianapolis America/Indiana/Vincennes America/Indiana/Winamac America/Indiana/Marengo America/Indiana/Petersburg America/Indiana/Vevay America/Chicago America/Indiana/Tell_City America/Indiana/Knox America/Menominee America/North_Dakota/Center America/North_Dakota/New_Salem America/North_Dakota/Beulah America/Denver America/Boise America/Phoenix America/Los_Angeles America/Anchorage America/Juneau America/Sitka America/Metlakatla America/Yakutat America/Nome America/Adak Pacific/Honolulu","UY|America/Montevideo","UZ|Asia/Samarkand Asia/Tashkent","VA|Europe/Rome Europe/Vatican","VC|America/Puerto_Rico America/St_Vincent","VE|America/Caracas","VG|America/Puerto_Rico America/Tortola","VI|America/Puerto_Rico America/St_Thomas","VN|Asia/Bangkok Asia/Ho_Chi_Minh","VU|Pacific/Efate","WF|Pacific/Tarawa Pacific/Wallis","WS|Pacific/Apia","YE|Asia/Riyadh Asia/Aden","YT|Africa/Nairobi Indian/Mayotte","ZA|Africa/Johannesburg","ZM|Africa/Maputo Africa/Lusaka","ZW|Africa/Maputo Africa/Harare"]}');

},{}],"1PtXC":[function(require,module,exports) {
module.exports = require("cb0cae8298266caf").getBundleURL("kVLro") + require("92479db39618501a").resolve("d8jQ8");

},{"cb0cae8298266caf":"c7Tr5","92479db39618501a":"fyJL2"}],"2vkHX":[function(require,module,exports) {
module.exports = require("eac7567f6a411c32").getBundleURL("kVLro") + require("287c3a30ae66d0e2").resolve("d7T5P");

},{"eac7567f6a411c32":"c7Tr5","287c3a30ae66d0e2":"fyJL2"}],"bawjn":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _languageContainer = require("../../hooks/LanguageContainer");
var _languageContainerDefault = parcelHelpers.interopDefault(_languageContainer);
var _interactionModelForm = require("./components/InteractionModelForm");
var _interactionModelFormDefault = parcelHelpers.interopDefault(_interactionModelForm);
var _pageError = require("../../components/general/PageError");
var _pageErrorDefault = parcelHelpers.interopDefault(_pageError);
var _applicationNlpEntityContainer = require("../../hooks/ApplicationNlpEntityContainer");
var _applicationNlpEntityContainerDefault = parcelHelpers.interopDefault(_applicationNlpEntityContainer);
var _interactionModelContainer = require("../../hooks/InteractionModelContainer");
var _interactionModelContainerDefault = parcelHelpers.interopDefault(_interactionModelContainer);
var _nlpModelTrainingContainer = require("../../hooks/NlpModelTrainingContainer");
var _nlpModelTrainingContainerDefault = parcelHelpers.interopDefault(_nlpModelTrainingContainer);
const InteractionModel = ({ applicationId, allAppLanguages, appContainer })=>{
    const languagesContainer = (0, _languageContainerDefault.default).useContainer();
    const applicationNlpEntityContainer = (0, _applicationNlpEntityContainerDefault.default).useContainer();
    const interactionModelContainer = (0, _interactionModelContainerDefault.default).useContainer();
    const nlpTrainingContainer = (0, _nlpModelTrainingContainerDefault.default).useContainer();
    const languages = languagesContainer.currentSelectedLanguages;
    (0, _react1.useEffect)(function loadApplicationNlpEntitiesAsync() {
        loadApplicationNLP();
    }, [
        applicationId,
        languages
    ]);
    const loadApplicationNLP = async ()=>{
        await applicationNlpEntityContainer.getApplicationNlpEntities(applicationId, languages);
        await interactionModelContainer.loadInteractionModels(applicationId, languages);
        await applicationNlpEntityContainer.loadPrebuiltNlpEntities(applicationId, languages);
    };
    const submitInteractionModelForm = async (updates, entities)=>{
        // submit entities first
        let shouldPoll = false;
        if (entities.length) {
            shouldPoll = true;
            for (const entity of entities){
                const request = {
                    name: entity?.name,
                    values: entity?.values,
                    locales: entity?.locales,
                    isEditable: entity?.isEditable,
                    isCopyable: entity?.isCopyable,
                    threshold: entity?.threshold
                };
                if (entity?.isDeleted) {
                    const deletedEntityResult = await applicationNlpEntityContainer.deleteApplicationNlpEntity(applicationId, entity.id);
                    if (deletedEntityResult?.resultType === "Ok") await applicationNlpEntityContainer.loadAllApplicationNlpEntities(applicationId);
                } else if (entity?.isAdded) {
                    const addedEntityResult = await applicationNlpEntityContainer.addApplicationNlpEntity(applicationId, entity);
                    if (addedEntityResult?.resultType === "Ok") await applicationNlpEntityContainer.loadAllApplicationNlpEntities(applicationId);
                } else if (entity?.isModified) {
                    const modifiedEntityResult = await applicationNlpEntityContainer.updateApplicationNlpEntity(applicationId, entity.id, request);
                    if (modifiedEntityResult?.resultType === "Ok") await applicationNlpEntityContainer.loadAllApplicationNlpEntities(applicationId);
                }
            }
        }
        // submit interaction model
        if (updates.length) {
            shouldPoll = true;
            const interactionModelResult = await interactionModelContainer.updateInteractionModel(applicationId, updates[0].locale, updates[0]);
            if (interactionModelResult?.resultType === "Ok") await interactionModelContainer.loadInteractionModels(applicationId, languages);
        }
        if (shouldPoll) {
            await nlpTrainingContainer.queueTraining(applicationId);
            nlpTrainingContainer.startPollingForTraining();
        }
    };
    return (0, _react.jsx)((0, _reactDefault.default).Fragment, null, (0, _react.jsx)((0, _interactionModelFormDefault.default), {
        appContainer: appContainer,
        languages: languages,
        allAppLanguages: allAppLanguages,
        applicationId: applicationId,
        applicationNlpEntities: applicationNlpEntityContainer?.applicationNlpEntities,
        prebuiltNlpEntities: applicationNlpEntityContainer?.prebuiltNlpEntities,
        interactionModels: interactionModelContainer?.interactionModels,
        onSubmit: submitInteractionModelForm
    }), (0, _react.jsx)((0, _pageErrorDefault.default), {
        errors: [
            ...applicationNlpEntityContainer?.errors ?? [],
            ...interactionModelContainer?.errors ?? []
        ],
        onClear: ()=>{
            applicationNlpEntityContainer.clearErrors();
            interactionModelContainer.clearErrors();
        }
    }));
};
exports.default = InteractionModel;

},{"@emotion/react":"djZKr","react":"6uln9","../../hooks/LanguageContainer":"lchkU","./components/InteractionModelForm":"9RN9X","../../components/general/PageError":"ezFTm","../../hooks/ApplicationNlpEntityContainer":"6IUi8","../../hooks/InteractionModelContainer":"5cw5C","../../hooks/NlpModelTrainingContainer":"fdXHQ","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9RN9X":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "maxNlpEntityNameSize", ()=>maxNlpEntityNameSize);
parcelHelpers.export(exports, "sortEditableInteractionModel", ()=>sortEditableInteractionModel);
parcelHelpers.export(exports, "findIntentsByName", ()=>findIntentsByName);
parcelHelpers.export(exports, "buildEditableInteractionModel", ()=>buildEditableInteractionModel);
parcelHelpers.export(exports, "addEditableIntentToUpdate", ()=>addEditableIntentToUpdate);
parcelHelpers.export(exports, "convertToInteractionModelLocaleUpdate", ()=>convertToInteractionModelLocaleUpdate);
parcelHelpers.export(exports, "isEmptyInteractionModelUpdate", ()=>isEmptyInteractionModelUpdate);
parcelHelpers.export(exports, "convertValuesToCSVText", ()=>convertValuesToCSVText);
parcelHelpers.export(exports, "convertCSVtextToValues", ()=>convertCSVtextToValues);
parcelHelpers.export(exports, "extractSlots", ()=>extractSlots);
var _formik = require("formik");
var _lodash = require("lodash");
var _lodashDefault = parcelHelpers.interopDefault(_lodash);
var _interactionModelEditorWrapper = require("./InteractionModelEditorWrapper");
var _interactionModelEditorWrapperDefault = parcelHelpers.interopDefault(_interactionModelEditorWrapper);
var _yup = require("yup");
var _phraseSlot = require("../../../models/interactionModel/PhraseSlot");
var _phraseSlotDefault = parcelHelpers.interopDefault(_phraseSlot);
var _applicationNlpEntityContainer = require("../../../hooks/ApplicationNlpEntityContainer");
var _papaparse = require("papaparse");
var _papaparseDefault = parcelHelpers.interopDefault(_papaparse);
const maxNlpEntityNameSize = 50;
// Wrap our form with the withFormik HoC
const InteractionModelForm = (0, _formik.withFormik)({
    displayName: "InteractionModelForm",
    validateOnChange: true,
    validateOnBlur: true,
    validateOnMount: true,
    isInitialValid: false,
    enableReinitialize: true,
    validationSchema: _yup.object().shape({
        nlpEntities: _yup.array().of(_yup.object().shape({
            isDeleted: _yup.boolean(),
            name: _yup.string().when("isDeleted", {
                is: false,
                then: _yup.string().max(maxNlpEntityNameSize, `Validation: NLP entity name must not exceed ${maxNlpEntityNameSize} characters `).required("Validation: NLP Entity Name is required ")
            }),
            type: _yup.string().required("Validation: NLP Entity Type is required ")
        }))
    }),
    // Transform outer props into form values
    mapPropsToValues: (props)=>{
        const formEntities = props.applicationNlpEntities.map((e)=>{
            let formEntity = {
                ...e
            };
            return formEntity;
        });
        const formInteractionModel = buildEditableInteractionModel(props.interactionModels, props.languages);
        var im = props.interactionModels.find((i)=>i.locale === props.languages[0]?.shortCode);
        const values = {
            nlpEntities: formEntities,
            interactionModel: formInteractionModel,
            enableEnhancedIntentMatching: false,
            disableEnhancedIntentMatching: false,
            useEnhancedIntentMatching: im?.useEnhancedIntentMatching,
            enhancedIntentMatchingPrompt: im?.enhancedIntentMatchingPrompt
        };
        return values;
    },
    // Add a custom validation function (this can be async)
    validate: (values, props)=>{
        let errors = {};
        const intentsFieldsErrors = validateIntentsFormFields(values);
        if (intentsFieldsErrors && Object.keys(intentsFieldsErrors).length > 0) errors = intentsFieldsErrors;
        const entitiesFieldsErrors = validateNlpEntitiesFormFields(values);
        if (entitiesFieldsErrors && Object.keys(entitiesFieldsErrors).length > 0) errors = {
            ...errors,
            ...entitiesFieldsErrors
        };
        // Returned errors object must be empty for validation to succeed
        return errors;
    },
    /** Form submit handler https://formik.org/docs/guides/form-submission */ handleSubmit: async (values, { props, setSubmitting })=>{
        let updates = [];
        for(let i = 0; i < props.languages.length; ++i){
            const language = props.languages[i];
            const update = convertToInteractionModelLocaleUpdate(values, language);
            if (update) updates.push(update);
        }
        const modifiedEntities = values.nlpEntities?.filter((e)=>e.isModified || e.isDeleted || e.isAdded);
        await props.onSubmit(updates, modifiedEntities);
        setSubmitting(false);
    }
})((0, _interactionModelEditorWrapperDefault.default));
const validateIntentsFormFields = (values)=>{
    let errors = {};
    let intentsErrorsObject = {};
    const entities = values?.nlpEntities?.filter((e)=>!e.isDeleted);
    const mergedInteractionModel = {
        ...values?.interactionModel
    };
    const intentNameKeys = Object.keys(mergedInteractionModel);
    for(let intentIdx = 0; intentIdx < intentNameKeys?.length; intentIdx++){
        const intentKey = intentNameKeys[intentIdx];
        const intent = mergedInteractionModel[intentKey];
        // No need to validate deleted intent
        if (intent.isDeleted) continue;
        const intentName = intent.displayName;
        // We do not really "edit" slots or utterances when creating IM Update - we delete old one and add a new 
        // Get all utterances
        const intentUtterances = intent.utterances;
        // Get non deleted slots
        const intentSlots = intent.slots?.filter((s)=>!s.isDeleted);
        // Get required slots
        const requiredSlots = intentSlots?.filter((s)=>s.required);
        const intentUsedSlotNames = [];
        let utterancesErrorsArray = [];
        let slotsErrorsArray = [];
        const utteranceGroups = [];
        // We display one utterance per multiple languages
        intentUtterances?.forEach((utterance)=>{
            const phrase = utterance.phrase;
            const existingGroup = utteranceGroups.find((u)=>u.phrase == phrase);
            if (existingGroup) existingGroup.languages.push(utterance.language);
            else utteranceGroups.push({
                ...utterance,
                languages: [
                    utterance.language
                ]
            });
        });
        for(let utteranceIdx = 0; utteranceIdx < utteranceGroups?.length; utteranceIdx++){
            const utterance = utteranceGroups[utteranceIdx];
            // In order to keep the correct index for field errors we need to use utteranceGroups
            utterancesErrorsArray.push(null);
            const phrase = utterance?.phrase;
            // No need to validate Deleted utterance, but we need to keep it in array for correct field errors index position
            if (utterance.changeType === "Removed") continue;
            const utteranceSlots = extractSlots(phrase);
            const utteranceSlotNames = utteranceSlots?.map((s)=>s.getSlotName());
            // Find a list of all slot names used in non deleted utterances for further slot validations
            if (utteranceSlotNames?.length > 0) intentUsedSlotNames.push(...utteranceSlotNames);
            if (!phrase || phrase.length < 1) utterancesErrorsArray[utteranceIdx] = {
                phrase: `Phrase is required `
            };
            // Check if utterance is missing a required non deleted slot
            const missingSlots = (0, _lodashDefault.default).difference(requiredSlots?.map((s)=>s.name), utteranceSlotNames);
            if (missingSlots?.length > 0) utterancesErrorsArray[utteranceIdx] = {
                phrase: `Missing required slot(s) `
            };
            // Check if utterance has non existing slot
            const nonExistentSlots = (0, _lodashDefault.default).difference(utteranceSlotNames, intentSlots?.map((s)=>s.name));
            if (nonExistentSlots?.length > 0) utterancesErrorsArray[utteranceIdx] = {
                phrase: `Unknown slot(s) `
            };
            if (intent.isCustom) {
                // Check if custom intent's utterance's slots have valid NLP Entity?
                const slots = intentSlots?.filter((s)=>utteranceSlotNames?.includes(s.name));
                slots?.forEach((s)=>{
                    const valid = validateSlotNlpEntityName(s, entities);
                    if (!valid) utterancesErrorsArray[utteranceIdx] = {
                        phrase: `Invalid slot(s) `
                    };
                    else {
                        // What about slot's entities existing in intent locales?
                        const localeEntities = getNlpEntitiesInLocales(entities, intent.locales?.map((l)=>l.shortCode));
                        const slotEntityFoundInAllLocales = validateSlotNlpEntityName(s, localeEntities);
                        if (!slotEntityFoundInAllLocales) utterancesErrorsArray[utteranceIdx] = {
                            phrase: `Invalid slot(s) entity `
                        };
                    }
                });
            }
        }
        for(let slotIdx = 0; slotIdx < intentSlots?.length; slotIdx++){
            const slot = intentSlots[slotIdx];
            // For intent slots validation we do not need to keep exact fields index
            // This validation for displaying an error on IM intent item component
            // The actual slots form fields validation is happening in SlotsEditorForm
            if (intent.isCustom) {
                const entityName = slot.entityName;
                const slotEntityFound = validateSlotNlpEntityName(slot, entities);
                // Check if custom intent's non deleted slot that is used in any utterance is missing a valid NLP entity
                if (!slotEntityFound && intentUsedSlotNames.includes(slot.name)) {
                    const nlpEntityError = `Slot "${slot.name}" in intent "${intentName}" is used in some utterance(s) but it's entity "${entityName}" is invalid `;
                    slotsErrorsArray[slotIdx] = {
                        entityName: nlpEntityError
                    };
                }
                if (slotEntityFound) {
                    // What about slot's entities existing in intent locales?
                    const localeEntities = getNlpEntitiesInLocales(entities, intent.locales?.map((l)=>l.shortCode));
                    const slotEntityFoundInAllLocales = validateSlotNlpEntityName(slot, localeEntities);
                    if (!slotEntityFoundInAllLocales && intentUsedSlotNames.includes(slot.name)) {
                        const nlpEntityError = `Slot "${slot.name}" in intent "${intentKey}" is used in some utterance(s) but it's entity "${entityName}" does not have some of intent language(s) selected `;
                        slotsErrorsArray[slotIdx] = {
                            entityName: nlpEntityError
                        };
                    }
                }
            }
            const slotNameMatch = intentSlots?.filter((s, idx)=>idx != slotIdx && !s.isDeleted && s.name.trim().toLowerCase() == slot.name?.trim().toLowerCase());
            if (slotNameMatch?.length > 0) {
                const slotNameError = `Duplicate slot name "${slot.name}" found in "${intentName}" intent `;
                if (slotsErrorsArray[slotIdx]) slotsErrorsArray[slotIdx] = {
                    ...slotsErrorsArray[slotIdx],
                    name: slotNameError
                };
                else slotsErrorsArray[slotIdx] = {
                    name: slotNameError
                };
            }
        }
        if (utterancesErrorsArray?.length > 0 && utterancesErrorsArray?.some((e)=>!!e)) {
            const utterancesErrorsObject = {
                utterances: utterancesErrorsArray
            };
            if (intentsErrorsObject[intentKey]) intentsErrorsObject[intentKey] = {
                ...intentsErrorsObject[intentKey],
                ...utterancesErrorsObject
            };
            else intentsErrorsObject[intentKey] = utterancesErrorsObject;
        }
        if (slotsErrorsArray?.length > 0 && slotsErrorsArray?.some((e)=>!!e)) {
            const slotsErrorsObject = {
                slots: slotsErrorsArray
            };
            if (intentsErrorsObject[intentKey]) intentsErrorsObject[intentKey] = {
                ...intentsErrorsObject[intentKey],
                ...slotsErrorsObject
            };
            else intentsErrorsObject[intentKey] = slotsErrorsObject;
        }
    }
    if (intentsErrorsObject && Object.keys(intentsErrorsObject).length > 0) errors = {
        interactionModel: intentsErrorsObject
    };
    // Returned errors object must be empty for validation to succeed
    return errors;
};
const getNlpEntitiesInLocales = (nlpEntities, locales)=>{
    // Filter for selected locales 
    const formEntities = nlpEntities?.filter((nlpEntity)=>locales.every((shortCode)=>nlpEntity.locales.includes(shortCode)));
    return formEntities;
};
const validateSlotNlpEntityName = (slot, entities)=>{
    const entityName = slot?.entityName;
    const found = entities?.find((e)=>e.name == entityName);
    return !!found;
};
const validateNlpEntityRegexPattern = (value)=>{
    if (!value || value.trim() == "") return "Regex Pattern is required";
    try {
        // this is the same code that the nlp api uses to generate RegEx's from a string
        // lets try it here and if it fails then we know it's not going to work
        // when training or being used in the nlp api. 
        let regexString = value.slice();
        let flag = "";
        let index = value.lastIndexOf("/");
        if (index !== -1) {
            flag = regexString.slice(index + 1);
            regexString = regexString.slice(1, index);
        }
        const regex = new RegExp(regexString, flag);
    } catch (e) {
        return `Invalid regular expression: ${value}`;
    }
    return null;
};
const validateNlpEntitiesFormFields = (values)=>{
    // Validate that List type NLP Entity's Values array is not null, empty list is allowed, and that value's names are unique
    let errors = {};
    let entitiesErrorsArray = [];
    for(let entityIdx = 0; entityIdx < values?.nlpEntities?.length; entityIdx++){
        const entity = values?.nlpEntities[entityIdx];
        let nlpValuesErrorsArray = [];
        // Initialize null error for correct Form values array index
        entitiesErrorsArray.push(null); // need to keep exact index to match between errors and entity form fields
        // No need to validate deleted entity
        if (entity.isDeleted) continue;
        const duplicateEntityNames = values?.nlpEntities?.filter((e, idx)=>idx != entityIdx && !e.isDeleted && e.name.trim().toLowerCase() == entity.name.trim().toLowerCase());
        if (duplicateEntityNames?.length > 0) {
            const error = `Duplicate NLP entity name: "${entity.name}" `;
            // Form's field's "name" error will show up in FieldError
            entitiesErrorsArray[entityIdx] = {
                name: error
            };
            errors = {
                nlpEntities: entitiesErrorsArray
            };
        }
        // Large entities values validation can significabtly slow down performance, so only validating non Large entity values
        if (entity.isLarge || !entity.isModified) continue;
        // Newly added entity does not have isLarge populated in time after importing large volume of values, so need to recheck
        if (entity.values?.length > (0, _applicationNlpEntityContainer.LARGE_ENTITY_VALUES_COUNT)) continue;
        if (entity.type === "List") {
            // Check for duplicate value names
            const nlpValues = entity.values;
            for(let valueIdx = 0; valueIdx < nlpValues?.length; valueIdx++){
                const nlpValue = nlpValues[valueIdx];
                nlpValuesErrorsArray.push(null);
                if (!nlpValue?.name) {
                    const error = `Entity value name is required `;
                    // Form's field's "name" error will show up in FieldError
                    nlpValuesErrorsArray[valueIdx] = {
                        name: error
                    };
                }
            }
        } else if (entity.type === "Regex") {
            // Validate value pattern regular expression
            const nlpValues = entity.values;
            for(let valueIdx = 0; valueIdx < nlpValues?.length; valueIdx++){
                const nlpValue = nlpValues[valueIdx];
                nlpValuesErrorsArray.push(null);
                const error = validateNlpEntityRegexPattern(nlpValue?.pattern);
                if (error) nlpValuesErrorsArray[valueIdx] = {
                    pattern: error
                };
            }
        }
        if (nlpValuesErrorsArray?.length > 0 && nlpValuesErrorsArray?.some((e)=>!!e)) {
            const valuesErrorsObject = {
                values: nlpValuesErrorsArray
            };
            if (entitiesErrorsArray[entityIdx]) entitiesErrorsArray[entityIdx] = {
                ...entitiesErrorsArray[entityIdx],
                ...valuesErrorsObject
            };
            else entitiesErrorsArray[entityIdx] = valuesErrorsObject;
        }
    }
    if (entitiesErrorsArray?.length > 0 && entitiesErrorsArray?.some((e)=>!!e)) errors = {
        nlpEntities: entitiesErrorsArray
    };
    // Returned errors object must be empty for validation to succeed
    return errors;
};
const sortEditableInteractionModel = (mergedInteractionModel)=>{
    let editableIntents = Object.keys(mergedInteractionModel).map((intentKey)=>mergedInteractionModel[intentKey]);
    const editableInteractionModel = sortEditableIntents(editableIntents);
    return editableInteractionModel;
};
const findIntentsByName = (mergedInteractionModel, name)=>{
    let editableIntents = Object.keys(mergedInteractionModel).map((intentKey)=>mergedInteractionModel[intentKey]);
    const intents = editableIntents?.filter((i)=>i.displayName == name);
    return intents;
};
const createEditableIntent = (intent, interactionModel, language)=>{
    const disabledIntents = interactionModel.disabledIntents ?? [];
    const utterances = intent.utterances?.map((u)=>{
        return {
            phrase: u,
            changeType: "Original",
            language
        };
    });
    const editableSlots = intent.slots?.map((slot)=>{
        return {
            ...slot,
            isAdded: false,
            isDeleted: false,
            isModified: false,
            isOriginal: true,
            originalName: slot.name
        };
    });
    const key = intent.displayName + "|" + language?.shortCode;
    const intentToEdit = {
        ...intent,
        key: key,
        originalDisplayName: intent.displayName,
        displayName: intent.displayName,
        disabledForFeatureFlagIds: intent.disabledForFeatureFlagIds,
        utterances: utterances,
        slots: editableSlots,
        isDisabled: disabledIntents.find((di)=>di.displayName === intent.displayName) != null,
        updatedDisabledState: false,
        isCustom: intent.isCustom,
        modifiedDate: intent.modifiedDate,
        locales: [
            {
                shortCode: language?.shortCode,
                intentId: intent.id
            }
        ],
        isDeleted: false,
        isAdded: false,
        isModified: false,
        name: intent.name,
        requiresExactUtteranceMatch: intent.requiresExactUtteranceMatch
    };
    return intentToEdit;
};
const sortEditableIntents = (editableIntents)=>{
    // Custom Intents first, hacky sort, was not able to sort by two fields, isCustom first name second :()
    let editableIntentsOrdered = (0, _lodashDefault.default).orderBy(editableIntents ?? [], (r)=>(r.isCustom ? "AAA" : "ZZZ") + r.displayName, "asc");
    const editableInteractionModel = {};
    editableIntentsOrdered.forEach((intent)=>{
        editableInteractionModel[intent.key] = intent;
    });
    return editableInteractionModel;
};
const createEditableLocaleInteractionModel = (interactionModel, language)=>{
    const editableIntents = interactionModel.intents.filter((intent)=>intent.isUserEditable !== false) // null is assumed true - needs explicit false
    .map((intent)=>createEditableIntent(intent, interactionModel, language));
    const editableInteractionModel = sortEditableIntents(editableIntents);
    return editableInteractionModel;
};
const checkSlotsTheSame = (intent1, intent2)=>{
    const intent1Slots = intent1?.slots?.map((s)=>{
        const slot = {
            name: s.name,
            required: s.required,
            entityId: s.entityId ?? "",
            entityName: s.entityName ?? ""
        };
        return slot;
    });
    const intent2Slots = intent2?.slots ?? [];
    const same = intent1Slots?.length == intent2Slots?.length && intent2Slots?.every((s)=>{
        return intent1Slots?.find((original)=>original.name == s.name && original.required == s.required && original.entityId == s.entityId && original.entityName == s.entityName);
    });
    return same;
};
const buildEditableInteractionModel = (interactionModels, languages)=>{
    let mergedModel;
    for(let i = 0; i < interactionModels.length; i++){
        const localeInteractionModel = interactionModels[i];
        const language = languages?.find((l)=>l?.shortCode == localeInteractionModel.locale);
        if (language == null) continue;
        if (!mergedModel) // Create editable interaction model to display in UI, first language in a loop
        // Intent in different locales can have different set of slots and utterances
        mergedModel = createEditableLocaleInteractionModel(localeInteractionModel, language);
        else // start adding language/locale utterances to existing editable intents and add/merge new intents that not yet in model
        mergedModel = mergeLocaleIntents(mergedModel, localeInteractionModel, language);
    }
    return mergedModel;
};
const mergeLocaleIntents = (firstLocaleModel, localeInteractionModel, language)=>{
    if (localeInteractionModel == null || localeInteractionModel?.intents?.length == 0 || language == null) return firstLocaleModel;
    // start adding language/locale utterances to existing editable intents and add/merge new intents that not yet in model
    let mergedModel = {
        ...firstLocaleModel
    };
    localeInteractionModel.intents.forEach((intent)=>{
        let intentWasMerged = false;
        const sameNameIntents = findIntentsByName(mergedModel, intent.displayName);
        for(let i = 0; i < sameNameIntents?.length; i++){
            // Intent with that display name already exists
            let mergedIntent = sameNameIntents[i];
            const sameSlots = checkSlotsTheSame(mergedIntent, intent);
            if (!mergedIntent.isCustom || sameSlots) {
                // Add locale's specific utterances to existing intent
                mergedIntent.utterances.push(...intent.utterances.map((u)=>({
                        phrase: u,
                        changeType: "Original",
                        language
                    })));
                // Keep track in wich locales this intent exists
                mergedIntent.locales.push({
                    shortCode: language?.shortCode,
                    intentId: intent.id
                });
                // Change the key, append locale
                const intentNewKey = mergedIntent.key + "|" + language?.shortCode;
                delete mergedModel[mergedIntent.key];
                mergedIntent.key = intentNewKey;
                mergedModel[intentNewKey] = mergedIntent;
                intentWasMerged = true;
            }
        }
        // If locale's Custom intent not found in merged model or slots deviate create a new one
        if (!intentWasMerged && intent.isUserEditable && intent.isCustom) {
            const newCustomIntent = createEditableIntent(intent, localeInteractionModel, language);
            mergedModel[newCustomIntent.key] = newCustomIntent;
        }
    });
    //Resort model by Intents Modified Date to correctly display newly added intents in UI
    mergedModel = sortEditableInteractionModel(mergedModel);
    return mergedModel;
};
const addEditableIntentToUpdate = (update, intentUpdate, intent, language)=>{
    // Set Enable/Disable an intent update properties
    const intentId = intent.locales.find((l)=>l.shortCode === language.shortCode)?.intentId;
    if (intent.updatedDisabledState && intent.isDisabled) update.disableIntents.push({
        intentName: intent.originalDisplayName,
        intentId: intentId
    });
    else if (intent.updatedDisabledState && !intent.isDisabled) update.enableIntents.push({
        intentName: intent.originalDisplayName,
        intentId: intentId
    });
    let addedUtterances = [];
    let removedUtterances = [];
    // Get merged intent's modified Utterances in specific locale
    intent.utterances?.filter((u)=>u.changeType != "Original" && u.language.id == language.id)?.map((u)=>{
        if (u.changeType == "Added") addedUtterances.push(u.phrase);
        else if (u.changeType == "Removed") removedUtterances.push(u.phrase);
    });
    let addedSlots = [];
    let removedSlots = [];
    // Get merged added and removed intent's slots
    intent.slots?.map((slot)=>{
        if (!slot.isOriginal && slot.isAdded && !slot.isDeleted) // Brand new slot added
        addedSlots.push(slot);
        else if (slot.isOriginal && slot.isDeleted) // Existing slot was deleted, could have been renamed as well, use original name
        removedSlots.push(slot.originalName);
        else if (slot.isOriginal && slot.isModified) {
            // Remove and readd
            removedSlots.push(slot.originalName);
            addedSlots.push(slot);
        }
    });
    //Check if merged intent exists in this locale Interaction Model and do updates
    if (intentExistsInLocaleInteractionModel(intent, language)) {
        if (intent.isDeleted && !intent.isAdded) // Set existing intent for removal from Interaction Model locale
        update.removeCustomIntents.push({
            intentName: intent.originalDisplayName,
            intentId: intentId
        });
        else if (intent.isAdded && !intent.isDeleted) {
            //If it is a brand new Custom intent then add it to update
            const newIntent = {
                ...intent,
                id: intent.displayName,
                displayName: intent.displayName,
                isUserEditable: true,
                isCustom: intent.isCustom,
                slots: intent.slots,
                utterances: addedUtterances,
                requiresExactUtteranceMatch: intent.requiresExactUtteranceMatch
            };
            update.addCustomIntents.push(newIntent);
        } else {
            // If an existing intent was modified then record it's update properties
            if (addedUtterances.length > 0) intentUpdate.addedUtterances = addedUtterances;
            if (removedUtterances.length > 0) intentUpdate.removedUtterances = removedUtterances;
            if (addedSlots.length > 0) intentUpdate.addedSlots = addedSlots;
            if (removedSlots.length > 0) intentUpdate.removedSlots = removedSlots;
            if (!!intent.originalDisplayName && intent.originalDisplayName != intent.displayName) intentUpdate.updatedDisplayName = intent.displayName;
            intentUpdate.requiresExactUtteranceMatch = intent.requiresExactUtteranceMatch;
            const updateExistingIntent = intentUpdate.addedUtterances.length > 0 || intentUpdate.removedUtterances.length > 0 || intentUpdate.addedSlots.length > 0 || intentUpdate.removedSlots.length > 0 || !!intentUpdate.updatedDisplayName || intent.didUpdateRequiresExactMatch || intent.isModified;
            intentUpdate.disabledForFeatureFlagIds = intent.disabledForFeatureFlagIds;
            if (updateExistingIntent) // Update existing intent properties
            update.intents[intent.isCustom ? intentId : intent.originalDisplayName] = intentUpdate;
        }
    } else // Merged intent does not exist in specific locale
    if (!intent.isDeleted && (addedUtterances.length > 0 || intent.isAdded)) {
        // 1. addedUtterances.length > 0 If we assigned any utterances to this locale we need to add new intent to Interaction Model locale
        // 2. isAdded - brand new intent, might have no utterances yet
        const newIntent = {
            ...intent,
            id: intent.displayName,
            displayName: intent.displayName,
            isUserEditable: true,
            isCustom: intent.isCustom,
            slots: intent.slots,
            utterances: addedUtterances,
            requiresExactUtteranceMatch: intent.requiresExactUtteranceMatch
        };
        update.addCustomIntents.push(newIntent);
    }
    return update;
};
const convertToInteractionModelLocaleUpdate = (values, language)=>{
    let update = {
        intents: {},
        locale: language?.shortCode,
        disableIntents: [],
        enableIntents: [],
        removeCustomIntents: [],
        addCustomIntents: []
    };
    var mergedInteractionModel = values.interactionModel;
    Object.keys(mergedInteractionModel)?.map((displayName)=>{
        let mergedIntent = mergedInteractionModel[displayName];
        let intentUpdate = {
            addedUtterances: [],
            removedUtterances: [],
            addedSlots: [],
            removedSlots: [],
            updatedDisplayName: "",
            requiresExactUtteranceMatch: false
        };
        if (mergedIntent.isModified) {
            intentUpdate.allowEnhancedIntentMatching = mergedIntent.allowEnhancedIntentMatching;
            intentUpdate.enhancedMatchingDescription = mergedIntent.enhancedMatchingDescription;
            intentUpdate.alwaysIncludeInPrompt = mergedIntent.alwaysIncludeInPrompt;
        }
        update = addEditableIntentToUpdate(update, intentUpdate, mergedIntent, language);
    });
    let enableEnhancedIntentMatching = undefined;
    let updatedPrompt = undefined;
    if (values.disableEnhancedIntentMatching) enableEnhancedIntentMatching = false;
    else if (values.enableEnhancedIntentMatching) enableEnhancedIntentMatching = true;
    if (values.updatedEnhancedIntentMatchingPrompt?.length) updatedPrompt = values.updatedEnhancedIntentMatchingPrompt;
    update.updatedEnhancedIntentMatchingPrompt = updatedPrompt;
    update.enableEnhancedIntentMatching = enableEnhancedIntentMatching;
    //No updates
    if (isEmptyInteractionModelUpdate(update)) return null;
    return update;
};
const isEmptyInteractionModelUpdate = (update)=>{
    return Object.keys(update.intents).length == 0 && update.disableIntents.length == 0 && update.enableIntents.length == 0 && update.removeCustomIntents.length == 0 && update.addCustomIntents.length == 0 && (update.enableEnhancedIntentMatching === undefined || update.enableEnhancedIntentMatching === null) && !update?.updatedEnhancedIntentMatchingPrompt?.length;
};
const intentExistsInLocaleInteractionModel = (intent, language)=>{
    const localeMatch = intent.locales.filter((l)=>l.shortCode == language?.shortCode);
    return localeMatch?.length > 0;
};
const convertValuesToCSVText = (values)=>{
    if (!values || values?.length == 0) return "";
    const newLine = "\r\n";
    let textBoxValues = "";
    const arrayOfLines = values.map((v)=>convertValueToCSVLine(v));
    textBoxValues = arrayOfLines.join(newLine);
    return textBoxValues;
};
const convertCSVtextToValues = (textBoxValues)=>{
    const parsed = CSVtoArray(textBoxValues);
    const values = parsed?.filter((p)=>{
        if (!p?.length || !p[0]) // ignore empty values and values without names
        return false;
        return true;
    })?.map((p)=>{
        let value = {};
        // First element of the array is value name
        value.name = p[0];
        // The rest of array elements are synonyms with the last potentially being metadata
        if (p.length > 1) {
            if (p[p.length - 1].startsWith("metadata:")) {
                value.metadata = JSON.parse(p[p.length - 1].replace("metadata:", ""));
                value.synonyms = [
                    ...p.slice(1, p.length - 1)
                ];
            } else value.synonyms = [
                ...p.slice(1, p.length)
            ];
        }
        return value;
    });
    return values;
};
const convertValueToCSVLine = (entityValue)=>{
    if (entityValue == null || !entityValue.name) return "";
    const comma = ",";
    const valueName = checkAndWrapForCSV(entityValue.name);
    const synonyms = entityValue.synonyms?.map((s)=>checkAndWrapForCSV(s))?.join(comma);
    let line = valueName;
    if (synonyms?.length > 0) line = `${valueName}${comma}${synonyms}`;
    if (Object.keys(entityValue.metadata ?? {}).length) {
        let metadataString = JSON.stringify(entityValue.metadata);
        const searchRegExp = /"/g;
        const replaceWith = '""';
        metadataString = metadataString.replace(searchRegExp, replaceWith);
        line = `${line}${comma}"metadata:${metadataString}"`;
    }
    return line;
};
const checkAndWrapForCSV = (inputText)=>{
    if (inputText == null) return "";
    let outputText = inputText.trim();
    if (outputText == "") return "";
    const comma = ",";
    const doubleQ = '"';
    if (outputText.includes(comma)) {
        // Wrap in quotes if it is not already
        if (!outputText.startsWith(doubleQ)) outputText = `${doubleQ}${outputText}`;
        if (!outputText.endsWith(doubleQ)) outputText = `${outputText}${doubleQ}`;
    }
    return outputText;
};
//using PapaParse https://github.com/mholt/PapaParse
function CSVtoArray(text) {
    var parseResult = (0, _papaparseDefault.default).parse(text);
    return parseResult.data;
}
const extractSlots = (phrase)=>{
    const regex = /{[^}]*}/g;
    const slotsExtracted = [];
    let match;
    while((match = regex.exec(phrase)) !== null){
        // This is necessary to avoid infinite loops with zero-width matches
        if (match.index === regex.lastIndex) regex.lastIndex++;
        match.forEach((match)=>{
            slotsExtracted.push(new (0, _phraseSlotDefault.default)(match.trim()));
        });
    }
    return slotsExtracted;
};
exports.default = InteractionModelForm;

},{"formik":"3YnOK","lodash":"3hMBK","./InteractionModelEditorWrapper":"72hfU","yup":"j2SJU","../../../models/interactionModel/PhraseSlot":"eqzd3","../../../hooks/ApplicationNlpEntityContainer":"6IUi8","papaparse":"58ztL","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"72hfU":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _extends = require("@babel/runtime/helpers/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _applicationIntentsEditor = require("./ApplicationIntentsEditor");
var _applicationIntentsEditorDefault = parcelHelpers.interopDefault(_applicationIntentsEditor);
var _applicationNlpEntitiesEditor = require("./ApplicationNlpEntitiesEditor");
var _applicationNlpEntitiesEditorDefault = parcelHelpers.interopDefault(_applicationNlpEntitiesEditor);
var _interactionModelContainer = require("../../../hooks/InteractionModelContainer");
var _interactionModelContainerDefault = parcelHelpers.interopDefault(_interactionModelContainer);
var _applicationNlpEntityContainer = require("../../../hooks/ApplicationNlpEntityContainer");
var _applicationNlpEntityContainerDefault = parcelHelpers.interopDefault(_applicationNlpEntityContainer);
var _interactionModelUiStateContainer = require("../../../hooks/InteractionModelUiStateContainer");
var _interactionModelUiStateContainerDefault = parcelHelpers.interopDefault(_interactionModelUiStateContainer);
var _pageError = require("../../../components/general/PageError");
var _pageErrorDefault = parcelHelpers.interopDefault(_pageError);
var _nlpSaveChangesModal = require("./NlpSaveChangesModal");
var _nlpSaveChangesModalDefault = parcelHelpers.interopDefault(_nlpSaveChangesModal);
var _customScrollbars = require("../../../components/structure/CustomScrollbars");
var _customScrollbarsDefault = parcelHelpers.interopDefault(_customScrollbars);
var _useWindowSize = require("../../../hooks/UseWindowSize");
var _useWindowSizeDefault = parcelHelpers.interopDefault(_useWindowSize);
var _voicifyMenuItemsEditor = require("./VoicifyMenuItemsEditor");
var _voicifyMenuItemsEditorDefault = parcelHelpers.interopDefault(_voicifyMenuItemsEditor);
var _applicationNlpMenuContainer = require("../../../hooks/ApplicationNlpMenuContainer");
var _applicationNlpMenuContainerDefault = parcelHelpers.interopDefault(_applicationNlpMenuContainer);
var _voicifyGroupsEditor = require("./VoicifyGroupsEditor");
var _voicifyGroupsEditorDefault = parcelHelpers.interopDefault(_voicifyGroupsEditor);
var _applicationNlpGenAIContainer = require("../../../hooks/ApplicationNlpGenAIContainer");
var _applicationNlpGenAIContainerDefault = parcelHelpers.interopDefault(_applicationNlpGenAIContainer);
var _featureSettings = require("./FeatureSettings");
var _featureSettingsDefault = parcelHelpers.interopDefault(_featureSettings);
const InteractionModelEditorWrapper = (props)=>{
    const [showSaveChangesModal, setShowSaveChangesModal] = (0, _react1.useState)(false);
    const [reformattedMenuItems, setReformattedMenuItems] = (0, _react1.useState)([]);
    const [selectedGroup, setSelectedGroup] = (0, _react1.useState)(null);
    const [selectedMenuItem, setSelectedMenuItem] = (0, _react1.useState)();
    //option groups
    const [areOptionGroups, setAreOptionGroups] = (0, _react1.useState)(false);
    const [latestChangedOptionGroup, setLatestChangedOptionGroup] = (0, _react1.useState)(null);
    const [latestOptionGroupToReplace, setLatestOptionGroupToReplace] = (0, _react1.useState)(null);
    //size groups
    const [areSizeGroups, setAreSizeGroups] = (0, _react1.useState)(false);
    const [latestChangedSizeGroup, setLatestChangedSizeGroup] = (0, _react1.useState)(null);
    const [latestSizeGroupToReplace, setLatestSizeGroupToReplace] = (0, _react1.useState)(null);
    const interactionModelContainer = (0, _interactionModelContainerDefault.default).useContainer();
    const uiStateContainer = (0, _interactionModelUiStateContainerDefault.default).useContainer();
    const applicationNlpEntityContainer = (0, _applicationNlpEntityContainerDefault.default).useContainer();
    const applicationNlpMenuContainer = (0, _applicationNlpMenuContainerDefault.default).useContainer();
    const applicationNlpGenAIContainer = (0, _applicationNlpGenAIContainerDefault.default).useContainer();
    const windowSize = (0, _useWindowSizeDefault.default)();
    const appName = props.appContainer?.state?.currentApp?.name;
    (0, _react1.useEffect)(()=>{
        applicationNlpMenuContainer.loadAllMenuItems(props.applicationId);
    }, []);
    (0, _react1.useEffect)(()=>{
        const formattedMenuItems = applicationNlpMenuContainer.menuItems.map((menuItem)=>{
            return {
                menuItem: menuItem
            };
        });
        setReformattedMenuItems(formattedMenuItems);
        interactionModelContainer.loadGroups(formattedMenuItems, uiStateContainer.menuEditorView);
        const thereAreOptionGroups = formattedMenuItems?.some((menuItem)=>{
            return menuItem?.menuItem?.optionGroups?.length > 0;
        });
        const thereAreSizeGroups = formattedMenuItems?.some((menuItem)=>{
            return menuItem?.menuItem?.sizeGroups?.length > 0;
        });
        setAreOptionGroups(thereAreOptionGroups);
        setAreSizeGroups(thereAreSizeGroups);
    }, [
        applicationNlpMenuContainer.menuItems
    ]);
    (0, _react1.useEffect)(()=>{
        if (latestChangedOptionGroup) performGroupChange(latestChangedOptionGroup, latestOptionGroupToReplace);
        else interactionModelContainer.loadGroups(reformattedMenuItems, uiStateContainer.menuEditorView);
        if (latestChangedSizeGroup) performGroupChange(latestChangedSizeGroup, latestSizeGroupToReplace);
        else interactionModelContainer.loadGroups(reformattedMenuItems, uiStateContainer.menuEditorView);
    }, [
        uiStateContainer.menuEditorView
    ]);
    (0, _react1.useEffect)(()=>{
        uiStateContainer.setIsFormDirty(props.dirty);
    }, [
        props.dirty
    ]);
    (0, _react1.useEffect)(()=>{
        if (location.pathname.includes("/nlp/entities")) uiStateContainer.setNluTab("Entities");
        else if (location.pathname.includes("/nlp/intents")) uiStateContainer.setNluTab("Intents");
        else if (location.pathname.includes("/nlp/menu")) uiStateContainer.setNluTab("Menu");
        else if (location.pathname.includes("/nlp/featureSettings")) uiStateContainer.setNluTab("Feature Settings");
    }, [
        location.pathname
    ]);
    (0, _react1.useEffect)(()=>{
        uiStateContainer.setErrors(props.errors);
    }, [
        props.errors
    ]);
    (0, _react1.useEffect)(()=>{
        if (uiStateContainer.triggerSaveChanges && props.values.interactionModel && !(interactionModelContainer.isLoading || applicationNlpEntityContainer.isLoading)) {
            if (latestChangedOptionGroup) performGroupChange(latestChangedOptionGroup, latestOptionGroupToReplace);
            if (latestChangedSizeGroup) performGroupChange(latestChangedSizeGroup, latestSizeGroupToReplace);
            setShowSaveChangesModal(true);
            uiStateContainer.setTriggerSaveChanges(false);
        }
    }, [
        uiStateContainer.triggerSaveChanges
    ]);
    const getAllOptionGroups = (item)=>{
        const optionGroupsList = [
            ...item.optionGroups ?? []
        ];
        for (const optionGroup of item.optionGroups){
            for (const option of optionGroup?.options)if (option?.optionGroups?.length > 0) optionGroupsList.push(...getAllOptionGroups(option));
        }
        if ("sizeGroups" in item) for (const sizeGroup of item.sizeGroups){
            for (const size of sizeGroup?.sizes)if (size?.optionGroups?.length > 0) optionGroupsList.push(...getAllOptionGroups(size));
        }
        return optionGroupsList;
    };
    const sortOptionsOrSizes = (sizesOrOptions)=>{
        sizesOrOptions?.sort((a, b)=>{
            if (!a || !a.name) return -1;
            if (!b || !b.name) return 1;
            const key1 = optionKey(a);
            const key2 = optionKey(b);
            const nameA = key1.toLowerCase();
            const nameB = key2.toLowerCase();
            if (nameA < nameB) return -1;
            if (nameA > nameB) return 1;
            return 0;
        });
    };
    const findGroupsToUpdate = (groups, itemToReplace, allToUpdate)=>{
        if (groups) for (const group of groups){
            if ("editId" in group && (itemToReplace ? itemToReplace.editId : selectedGroup.editId) === group.editId) allToUpdate.push(group);
            if ("options" in group && group.options) for (const option of group.options)findGroupsToUpdate(option.optionGroups || [], itemToReplace, allToUpdate);
        }
    };
    const performGroupChange = (changedGroup, groupToReplace)=>{
        const editedMenuItemsCopy = JSON.parse(JSON.stringify(interactionModelContainer.editedMenuItems));
        let matchingMenuItemIds;
        if ("options" in changedGroup) matchingMenuItemIds = interactionModelContainer.optionGroupMatches.find((match)=>match[groupToReplace ? groupToReplace.editId : selectedGroup.editId]);
        else if ("sizes" in changedGroup) matchingMenuItemIds = interactionModelContainer.sizeGroupMatches.find((match)=>match[groupToReplace ? groupToReplace.editId : selectedGroup.editId]);
        if (matchingMenuItemIds) {
            for (const menuItemId of matchingMenuItemIds[groupToReplace ? groupToReplace.editId : selectedGroup.editId]){
                // for each menu item that has the selected group:
                const menuItemToUpdate = editedMenuItemsCopy.find((menuItem)=>menuItem.menuItem.id === menuItemId);
                if (menuItemToUpdate) {
                    let groupsToUpdate = [];
                    if (uiStateContainer.menuEditorView === "Option Groups" && menuItemToUpdate.menuItem.optionGroups.length) {
                        if (groupToReplace) findGroupsToUpdate(menuItemToUpdate.menuItem.optionGroups, groupToReplace, groupsToUpdate);
                        else {
                            const allOptionGroups = [];
                            for (const sizeGroups of menuItemToUpdate?.menuItem?.sizeGroups){
                                for (const sizeGroupSize of sizeGroups?.sizes)if (sizeGroupSize?.optionGroups?.length) allOptionGroups.push(...sizeGroupSize?.optionGroups);
                            }
                            menuItemToUpdate.menuItem.optionGroups.push(...allOptionGroups);
                            findGroupsToUpdate(menuItemToUpdate.menuItem.optionGroups, null, groupsToUpdate);
                        }
                    }
                    // for optionGroups within size
                    if (uiStateContainer.menuEditorView === "Option Groups" && !menuItemToUpdate.menuItem.optionGroups.length) for (const sizeGroups of menuItemToUpdate.menuItem.sizeGroups){
                        for (const sizeGroupSize of sizeGroups.sizes)if (groupToReplace) findGroupsToUpdate(sizeGroupSize.optionGroups, groupToReplace, groupsToUpdate);
                        else findGroupsToUpdate(sizeGroupSize.optionGroups, null, groupsToUpdate);
                    }
                    if (uiStateContainer.menuEditorView === "Size Groups") {
                        if (groupToReplace) findGroupsToUpdate(menuItemToUpdate.menuItem.sizeGroups, groupToReplace, groupsToUpdate);
                        else findGroupsToUpdate(menuItemToUpdate.menuItem.sizeGroups, null, groupsToUpdate);
                    }
                    if (groupsToUpdate?.length) {
                        for (const groupToUpdate of groupsToUpdate)if (groupToUpdate) {
                            menuItemToUpdate.isModified = true;
                            // update options or sizes
                            const excludeProperties = [
                                "editId",
                                "referenceId",
                                "id",
                                "parentId",
                                "options",
                                "sizes"
                            ];
                            Object.keys(changedGroup).forEach((property)=>{
                                if (!excludeProperties.includes(property)) groupToUpdate[property] = changedGroup[property];
                                // remove properties that are not in changedGroup
                                Object.keys(groupToUpdate).forEach((prop)=>{
                                    if (!Object.keys(changedGroup).includes(prop)) delete groupToUpdate[prop];
                                });
                            });
                            const optionsOrSizesToRemove = [];
                            let groupToUpdateOptionsOrSizes = [];
                            let changedGroupOptionsOrSizes = [];
                            if ("options" in groupToUpdate && "options" in changedGroup) {
                                groupToUpdateOptionsOrSizes = groupToUpdate.options;
                                changedGroupOptionsOrSizes = changedGroup.options;
                            } else if ("sizes" in groupToUpdate && "sizes" in changedGroup) {
                                groupToUpdateOptionsOrSizes = groupToUpdate.sizes;
                                changedGroupOptionsOrSizes = changedGroup.sizes;
                            }
                            // if groupToUpdate has options or sizes that are not in changedGroup, remove them
                            groupToUpdateOptionsOrSizes.forEach((optionOrSizeToUpdate)=>{
                                if (!changedGroupOptionsOrSizes.find((changedOptionOrSize)=>groupToReplace ? optionKey(changedOptionOrSize) === optionKey(optionOrSizeToUpdate) : changedOptionOrSize.editId === optionOrSizeToUpdate.editId)) optionsOrSizesToRemove.push(optionOrSizeToUpdate);
                            });
                            optionsOrSizesToRemove.forEach((optionOrSizeToRemove)=>{
                                let optionOrSizeToRemoveIndex;
                                if ("options" in groupToUpdate) {
                                    optionOrSizeToRemoveIndex = groupToUpdate.options.findIndex((option)=>optionKey(option) === optionKey(optionOrSizeToRemove));
                                    groupToUpdate.options.splice(optionOrSizeToRemoveIndex, 1);
                                } else if ("sizes" in groupToUpdate) {
                                    optionOrSizeToRemoveIndex = groupToUpdate.sizes.findIndex((size)=>optionKey(size) === optionKey(optionOrSizeToRemove));
                                    groupToUpdate.sizes.splice(optionOrSizeToRemoveIndex, 1);
                                }
                            });
                            changedGroupOptionsOrSizes.forEach((changedOptionOrSize)=>{
                                let groupToUpateOptionOrSize;
                                if ("options" in groupToUpdate) groupToUpateOptionOrSize = groupToUpdate.options.find((option)=>{
                                    return groupToReplace ? optionKey(option) === optionKey(changedOptionOrSize) : option.editId === changedOptionOrSize.editId;
                                });
                                else if ("sizes" in groupToUpdate) groupToUpateOptionOrSize = groupToUpdate.sizes.find((size)=>{
                                    return groupToReplace ? optionKey(size) === optionKey(changedOptionOrSize) : size.editId === changedOptionOrSize.editId;
                                });
                                if (groupToUpateOptionOrSize) {
                                    const excludeProperties = [
                                        "editId",
                                        "referenceId",
                                        "id",
                                        "parentId",
                                        "options",
                                        "optionGroups"
                                    ];
                                    Object.keys(groupToUpateOptionOrSize).forEach((key)=>{
                                        if (!excludeProperties.includes(key)) {
                                            if (key in changedOptionOrSize) groupToUpateOptionOrSize[key] = changedOptionOrSize[key];
                                            else delete groupToUpateOptionOrSize[key];
                                        }
                                        //if changedOptionOrSize has a property that groupToUpdateOptionOrSize does not, add it
                                        Object.keys(changedOptionOrSize).forEach((key)=>{
                                            if (!(key in groupToUpateOptionOrSize)) groupToUpateOptionOrSize[key] = changedOptionOrSize[key];
                                        });
                                    });
                                } else {
                                    if ("options" in groupToUpdate) groupToUpdate.options.push(changedOptionOrSize);
                                    else if ("sizes" in groupToUpdate) groupToUpdate.sizes.push(changedOptionOrSize);
                                }
                            });
                            // update groups
                            groupToUpdate.editId = changedGroup.editId;
                            if ("options" in groupToUpdate) sortOptionsOrSizes(groupToUpdate.options);
                            else if ("sizes" in groupToUpdate) sortOptionsOrSizes(groupToUpdate.sizes);
                        }
                    }
                }
            }
            setReformattedMenuItems(editedMenuItemsCopy);
            interactionModelContainer.setEditedMenuItems(editedMenuItemsCopy);
            setLatestChangedOptionGroup(null);
            setLatestChangedSizeGroup(null);
            setLatestOptionGroupToReplace(null);
            setLatestSizeGroupToReplace(null);
        }
    };
    const optionKey = (option)=>{
        return `${option?.name ?? "unknown-name"}-${option.modifier ?? "unknown-modifier"}`;
    };
    const submitChanges = async ()=>{
        // submit interaction model form
        props.submitForm();
        // submit menu item updates
        if (reformattedMenuItems.length > 0) {
            let reload = false;
            for (const menuItem of reformattedMenuItems){
                if (selectedGroup) setSelectedGroup(null);
                if (selectedMenuItem) setSelectedMenuItem(null);
                if (menuItem?.isDeleted) {
                    reload = true;
                    await applicationNlpMenuContainer.deleteVoicifyMenuItem(props.applicationId, menuItem.menuItem.id);
                } else if (menuItem?.isAdded) {
                    reload = true;
                    await applicationNlpMenuContainer.addVoicifyMenuItem(props.applicationId, menuItem.menuItem);
                } else if (menuItem?.isModified) {
                    reload = true;
                    await applicationNlpMenuContainer.updateVoicifyMenuItem(props.applicationId, menuItem.menuItem);
                }
            }
            if (reload) {
                setReformattedMenuItems([]);
                await applicationNlpMenuContainer.loadAllMenuItems(props.applicationId);
            }
        }
    };
    const closeSaveChangesModal = ()=>{
        setShowSaveChangesModal(false);
    };
    const handleSaveGenerativeAIAssistantPrompt = async (generativeAIAssistantPrompt, featureFlag)=>{
        await applicationNlpGenAIContainer.saveGenerativeAIAssistantPrompt(props.applicationId, generativeAIAssistantPrompt, featureFlag);
        props.appContainer.setState((prevState)=>({
                currentApp: {
                    ...prevState.currentApp,
                    generativeAIAssistantPrompt: generativeAIAssistantPrompt
                }
            }));
    };
    const handleSaveFeatureFlagSettings = async (model)=>{
        await props.appContainer.updateFeatureFlagSettings(props.applicationId, model);
    };
    return (0, _react.jsx)((0, _reactDefault.default).Fragment, null, uiStateContainer.nluTab === "Intents" && (0, _react.jsx)((0, _customScrollbarsDefault.default), {
        autoHide: true,
        autoHeight: true,
        autoHeightMax: windowSize.windowSize.innerHeight - 210
    }, (0, _react.jsx)((0, _applicationIntentsEditorDefault.default), (0, _extendsDefault.default)({}, props, {
        applicationId: props.applicationId,
        key: props.languages.map((l)=>l.id).join("|"),
        languages: props.languages,
        interactionModel: props.values.interactionModel,
        isLoading: interactionModelContainer.isLoading || applicationNlpEntityContainer.isLoading
    }))), uiStateContainer.nluTab === "Entities" && (0, _react.jsx)((0, _applicationNlpEntitiesEditorDefault.default), (0, _extendsDefault.default)({}, props, {
        nlpEntities: props.values.nlpEntities,
        applicationId: props.applicationId,
        key: props.languages.map((l)=>l.id).join("|"),
        languages: props.languages,
        allAppLanguages: props.allAppLanguages,
        isLoading: interactionModelContainer.isLoading || applicationNlpEntityContainer.isLoading
    })), uiStateContainer.menuEditorView === "Menu Items" && uiStateContainer.nluTab === "Menu" && (0, _react.jsx)((0, _voicifyMenuItemsEditorDefault.default), (0, _extendsDefault.default)({}, props, {
        updatedMenuItems: reformattedMenuItems,
        setUpdatedMenuItems: setReformattedMenuItems,
        applicationId: props.applicationId,
        isLoading: applicationNlpMenuContainer.isLoading,
        selectedMenuItem: selectedMenuItem,
        setSelectedMenuItem: setSelectedMenuItem,
        menuItems: applicationNlpMenuContainer.menuItems,
        appName: appName
    })), uiStateContainer.nluTab === "Feature Settings" && (0, _react.jsx)((0, _featureSettingsDefault.default), (0, _extendsDefault.default)({}, props, {
        handleSave: handleSaveFeatureFlagSettings,
        isLoading: props.appContainer.state.isUpdatingFeatureFlagSettings
    })), uiStateContainer.menuEditorView === "Option Groups" && uiStateContainer.nluTab === "Menu" && (0, _react.jsx)((0, _voicifyGroupsEditorDefault.default), (0, _extendsDefault.default)({}, props, {
        performGroupChange: performGroupChange,
        setSelectedGroup: setSelectedGroup,
        groupsList: interactionModelContainer.optionGroupsList,
        setGroupsList: interactionModelContainer.setOptionGroupsList,
        setLatestChangedGroup: setLatestChangedOptionGroup,
        latestChangedGroup: latestChangedOptionGroup,
        latestGroupToReplace: latestOptionGroupToReplace,
        setLatestGroupToReplace: setLatestOptionGroupToReplace,
        matches: interactionModelContainer.optionGroupMatches,
        selectedGroup: selectedGroup,
        areGroups: areOptionGroups,
        groupType: "optionGroup",
        editableMenuItems: interactionModelContainer.editedMenuItems,
        setEditableMenuItems: interactionModelContainer.setEditedMenuItems,
        originalMenuItems: reformattedMenuItems,
        setOriginalMenuItems: setReformattedMenuItems,
        menuItems: applicationNlpMenuContainer.menuItems,
        applicationId: props.applicationId,
        isLoading: applicationNlpMenuContainer.isLoading
    })), uiStateContainer.menuEditorView === "Size Groups" && uiStateContainer.nluTab === "Menu" && (0, _react.jsx)((0, _voicifyGroupsEditorDefault.default), (0, _extendsDefault.default)({}, props, {
        performGroupChange: performGroupChange,
        setSelectedGroup: setSelectedGroup,
        groupsList: interactionModelContainer.sizeGroupsList,
        setGroupsList: interactionModelContainer.setSizeGroupsList,
        setLatestChangedGroup: setLatestChangedSizeGroup,
        latestChangedGroup: latestChangedSizeGroup,
        latestGroupToReplace: latestSizeGroupToReplace,
        setLatestGroupToReplace: setLatestSizeGroupToReplace,
        matches: interactionModelContainer.sizeGroupMatches,
        selectedGroup: selectedGroup,
        areGroups: areSizeGroups,
        groupType: "sizeGroup",
        editableMenuItems: interactionModelContainer.editedMenuItems,
        setEditableMenuItems: interactionModelContainer.setEditedMenuItems,
        originalMenuItems: reformattedMenuItems,
        setOriginalMenuItems: setReformattedMenuItems,
        menuItems: applicationNlpMenuContainer.menuItems,
        applicationId: props.applicationId,
        isLoading: applicationNlpMenuContainer.isLoading
    })), (0, _react.jsx)((0, _pageErrorDefault.default), {
        errors: [
            ...interactionModelContainer?.errors ?? [],
            ...applicationNlpEntityContainer?.errors ?? [],
            ...applicationNlpGenAIContainer?.errors ?? []
        ],
        onClear: ()=>{
            interactionModelContainer.clearErrors();
            applicationNlpEntityContainer.clearErrors();
        }
    }), (0, _react.jsx)((0, _nlpSaveChangesModalDefault.default), {
        showSaveChangesModal: showSaveChangesModal,
        closeModal: closeSaveChangesModal,
        values: props.values,
        submitChanges: submitChanges,
        languages: props.languages,
        isLoading: interactionModelContainer.isLoading || applicationNlpEntityContainer.isLoading,
        errors: props.errors,
        updatedMenuItems: reformattedMenuItems
    }));
};
exports.default = InteractionModelEditorWrapper;

},{"@babel/runtime/helpers/extends":"4iKIP","@emotion/react":"djZKr","react":"6uln9","./ApplicationIntentsEditor":"aUOIi","./ApplicationNlpEntitiesEditor":"aUL2g","../../../hooks/InteractionModelContainer":"5cw5C","../../../hooks/ApplicationNlpEntityContainer":"6IUi8","../../../hooks/InteractionModelUiStateContainer":"2A95n","../../../components/general/PageError":"ezFTm","./NlpSaveChangesModal":"iySc5","../../../components/structure/CustomScrollbars":"50vFq","../../../hooks/UseWindowSize":"43j9z","./VoicifyMenuItemsEditor":"fHke7","../../../hooks/ApplicationNlpMenuContainer":"jposS","./VoicifyGroupsEditor":"7PsFm","../../../hooks/ApplicationNlpGenAIContainer":"fxZ8I","./FeatureSettings":"kQddt","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"aUOIi":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _extends = require("@babel/runtime/helpers/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _base = require("@emotion/styled/base");
var _baseDefault = parcelHelpers.interopDefault(_base);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _colors = require("../../../constants/colors");
var _intentItem = require("./IntentItem");
var _intentItemDefault = parcelHelpers.interopDefault(_intentItem);
var _interactionModelForm = require("./InteractionModelForm");
var _modalTitle = require("../../../components/general/ModalTitle");
var _modalTitleDefault = parcelHelpers.interopDefault(_modalTitle);
var _button = require("../../../components/general/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _confirmationDialog = require("../../../components/structure/ConfirmationDialog");
var _confirmationDialogDefault = parcelHelpers.interopDefault(_confirmationDialog);
var _warningConfirmation = require("../../../components/general/WarningConfirmation");
var _warningConfirmationDefault = parcelHelpers.interopDefault(_warningConfirmation);
var _addNewIntentModal = require("./AddNewIntentModal");
var _addNewIntentModalDefault = parcelHelpers.interopDefault(_addNewIntentModal);
var _loader = require("../../../../shared/components/general/Loader");
var _loaderDefault = parcelHelpers.interopDefault(_loader);
var _manageIntentPromptModal = require("./ManageIntentPromptModal");
var _manageIntentPromptModalDefault = parcelHelpers.interopDefault(_manageIntentPromptModal);
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const deleteIcon = require("fa72b8b82823f5de");
const ApplicationIntentsEditor = (props)=>{
    const [activeIntentKey, setActiveIntentKey] = (0, _react1.useState)("");
    const [isAddNewIntentModalOpen, setIsAddNewIntentModalOpen] = (0, _react1.useState)(false);
    const [isIntentMatchingPromptModalOpen, setIsIntentMatchingPromptModalOpen] = (0, _react1.useState)(false);
    const [isVerifySaveModalOpen, setIsVerifySaveModalOpen] = (0, _react1.useState)(false);
    const [isDeleteAllIntentsModalOpen, setIsDeleteAllIntentsModalOpen] = (0, _react1.useState)(false);
    const toggleActivationByKey = (intentKey)=>{
        let newIntentKey = "";
        if (intentKey != activeIntentKey) newIntentKey = intentKey;
        setActiveIntentKey(newIntentKey);
    };
    const updateIntent = (intentName, updatedIntent)=>{
        if (updatedIntent.displayName == null || !updatedIntent.displayName.trim()) return "Invalid intent name";
        let mergedInteractionModel = {
            ...props.interactionModel
        };
        let intent = mergedInteractionModel[updatedIntent.key];
        if (!intent) return `Unable to find "${updatedIntent.key}" intent `;
        const originalDisplayName = intent.originalDisplayName;
        const keys = Object.keys(mergedInteractionModel);
        //Check for duplicate intent display name
        const intentNameMatch = keys.filter((intentKey)=>{
            const i = mergedInteractionModel[intentKey];
            return i.displayName?.toLowerCase().trim() === updatedIntent.displayName?.toLowerCase().trim() && i.originalDisplayName?.toLowerCase().trim() !== originalDisplayName?.toLowerCase().trim();
        });
        if (intentNameMatch?.length > 0) return `Unable to change intent name to "${updatedIntent.displayName}". Intent with that name already exists. `;
        const today = new Date();
        // For front end purpose only, backend will override it
        updatedIntent.modifiedDate = today.toUTCString();
        updatedIntent.isModified = true;
        delete mergedInteractionModel[updatedIntent.key];
        mergedInteractionModel[updatedIntent.key] = updatedIntent;
        mergedInteractionModel = (0, _interactionModelForm.sortEditableInteractionModel)(mergedInteractionModel);
        props.setFieldValue("interactionModel", mergedInteractionModel);
        // No error
        return null;
    };
    const renderIntentMenuItem = (intentToRender, idx)=>{
        const isActive = intentToRender.key === activeIntentKey;
        const sameNameIntents = (0, _interactionModelForm.findIntentsByName)(props.interactionModel, intentToRender.displayName);
        const showIntentLanguages = sameNameIntents?.length > 1;
        return (0, _react.jsx)((0, _intentItemDefault.default), (0, _extendsDefault.default)({}, props, {
            enhancedIntentMatchingEnabled: props.values.enableEnhancedIntentMatching ? true : props.values.disableEnhancedIntentMatching ? false : props.values.useEnhancedIntentMatching,
            displayType: "List",
            nlpEntities: props.values.nlpEntities,
            isLoading: props.isLoading,
            updateIntent: updateIntent,
            toggleActivationByKey: toggleActivationByKey,
            applicationId: props.applicationId,
            languages: props.languages,
            intent: intentToRender,
            idx: idx,
            isActive: isActive,
            key: idx,
            displayLanguages: showIntentLanguages
        }));
    };
    const addNewCustomIntent = (newDisplayName)=>{
        let mergedInteractionModel = {
            ...props.values.interactionModel
        };
        const today = new Date();
        // For front end purpose only, backend will override it
        const modifiedDate = today.toUTCString();
        let intentNewKey = newDisplayName;
        props.languages?.forEach((l)=>{
            intentNewKey = intentNewKey + "|" + l.shortCode;
        });
        const newIntent = {
            key: intentNewKey,
            originalDisplayName: newDisplayName,
            displayName: newDisplayName,
            disabledForFeatureFlagIds: [],
            utterances: [],
            slots: [],
            isDisabled: false,
            updatedDisabledState: false,
            isCustom: true,
            modifiedDate: modifiedDate,
            locales: props.languages.map((l)=>({
                    shortCode: l.shortCode,
                    intentId: newDisplayName
                })),
            isDeleted: false,
            isAdded: true,
            isModified: true,
            requiresExactUtteranceMatch: false
        };
        mergedInteractionModel[intentNewKey] = newIntent;
        mergedInteractionModel = (0, _interactionModelForm.sortEditableInteractionModel)(mergedInteractionModel);
        props.setFieldValue("interactionModel", mergedInteractionModel);
    };
    const addCustomIntent = (newIntentName)=>{
        addNewCustomIntent(newIntentName);
        // Close Modal and scroll to newly added intent
        setIsAddNewIntentModalOpen(false);
        setActiveIntentKey(newIntentName);
    };
    const savePromptUpdate = (enabled, prompt)=>{
        if (enabled != props.values.useEnhancedIntentMatching) {
            if (enabled) {
                props.setFieldValue("enableEnhancedIntentMatching", true);
                props.setFieldValue("disableEnhancedIntentMatching", false);
            } else {
                props.setFieldValue("enableEnhancedIntentMatching", false);
                props.setFieldValue("disableEnhancedIntentMatching", true);
            }
        } else {
            props.setFieldValue("enableEnhancedIntentMatching", false);
            props.setFieldValue("disableEnhancedIntentMatching", false);
        }
        if (prompt != props.values.enhancedIntentMatchingPrompt) props.setFieldValue("updatedEnhancedIntentMatchingPrompt", prompt);
        else props.setFieldValue("updatedEnhancedIntentMatchingPrompt", null);
        setIsIntentMatchingPromptModalOpen(false);
    };
    let intentNames = [];
    if (props.interactionModel) intentNames = Object.keys(props.interactionModel);
    if (props.isLoading) return (0, _react.jsx)(LoaderContainer, null, (0, _react.jsx)((0, _loaderDefault.default), null));
    return (0, _react.jsx)("div", {
        className: containerStyle
    }, (0, _react.jsx)("div", {
        className: headerContainer
    }, (0, _react.jsx)((0, _modalTitleDefault.default), null, "Manage your Intents and Utterances"), (0, _react.jsx)("p", {
        className: "detail-label"
    }, "Here you can manage your base interaction model for all your deployed channels and add new phrases when necessary.")), intentNames.length > 0 ? (0, _react.jsx)("div", {
        className: updatePanel
    }, (0, _react.jsx)((0, _buttonDefault.default), {
        themes: [
            "primary-small"
        ],
        onClick: ()=>setIsAddNewIntentModalOpen(!isAddNewIntentModalOpen),
        loading: props.isLoading,
        disabled: props.isLoading,
        text: "Add Intent"
    }), (0, _react.jsx)((0, _buttonDefault.default), {
        themes: [
            "primary-small"
        ],
        onClick: ()=>setIsIntentMatchingPromptModalOpen(!isIntentMatchingPromptModalOpen),
        loading: props.isLoading,
        disabled: props.isLoading,
        text: "Manage LLM Intent Matching"
    }), (0, _react.jsx)(DeleteAllIntentsWrapper, null, (0, _react.jsx)(DeleteAllButton, {
        themes: [
            "secondary-small"
        ],
        onClick: ()=>setIsDeleteAllIntentsModalOpen(!isDeleteAllIntentsModalOpen),
        loading: props.isLoading,
        disabled: props.isLoading,
        text: "Remove All Custom Intents",
        icon: deleteIcon
    }))) : (0, _react.jsx)("div", {
        className: headerContainer
    }, (0, _react.jsx)("p", {
        className: "detail-label"
    }, "Select a language to edit the interaction model for.")), props.isLoading || !props.interactionModel ? (0, _react.jsx)((0, _reactDefault.default).Fragment, null) : intentNames.map((name, idx)=>{
        return renderIntentMenuItem(props.interactionModel[name], idx);
    }), isAddNewIntentModalOpen && (0, _react.jsx)((0, _addNewIntentModalDefault.default), {
        interactionModel: props.interactionModel,
        handleSubmit: addCustomIntent,
        handleClose: ()=>setIsAddNewIntentModalOpen(false),
        languages: props.languages,
        isLoading: props.isLoading
    }), isIntentMatchingPromptModalOpen && (0, _react.jsx)((0, _manageIntentPromptModalDefault.default), {
        prompt: props.values.updatedEnhancedIntentMatchingPrompt ?? props.values.enhancedIntentMatchingPrompt,
        enabled: props.values.enableEnhancedIntentMatching ? true : props.values.disableEnhancedIntentMatching ? false : props.values.useEnhancedIntentMatching,
        handleSubmit: savePromptUpdate,
        handleClose: ()=>setIsIntentMatchingPromptModalOpen(false),
        languages: props.languages,
        isLoading: props.isLoading
    }), isDeleteAllIntentsModalOpen && (0, _react.jsx)((0, _confirmationDialogDefault.default), {
        title: `Delete All Intents`,
        deleteText: "Delete",
        warning: true,
        isLoading: props.isLoading,
        onClose: ()=>setIsDeleteAllIntentsModalOpen(false),
        onConfirm: ()=>{
            // Mark all custom intents as deleted instead of immediately removing them
            let mergedInteractionModel = {
                ...props.interactionModel
            };
            Object.keys(mergedInteractionModel).forEach((intentKey)=>{
                const intent = mergedInteractionModel[intentKey];
                // Only mark custom intents as deleted (same logic as remove intent button)
                if (intent.isCustom) {
                    intent.isDeleted = true;
                    intent.isModified = true;
                }
            });
            props.setFieldValue("interactionModel", mergedInteractionModel);
            setIsDeleteAllIntentsModalOpen(false);
        }
    }, (0, _react.jsx)((0, _warningConfirmationDefault.default), {
        text: `This will mark all custom intents for deletion. You will need to save changes to permanently remove them.`
    })), isVerifySaveModalOpen && (0, _react.jsx)((0, _confirmationDialogDefault.default), {
        title: `Save Interaction Model Changes`,
        deleteText: "Save",
        warning: true,
        isLoading: props.isLoading,
        onClose: ()=>setIsVerifySaveModalOpen(false),
        onConfirm: ()=>props.submitForm()
    }, (0, _react.jsx)((0, _warningConfirmationDefault.default), {
        text: `Any Custom Intents and NLP Entities set for deletion will be permanentely removed from Interaction Model.`
    })));
};
exports.default = ApplicationIntentsEditor;
const DeleteAllButton = /*#__PURE__*/ (0, _baseDefault.default)((0, _buttonDefault.default), {
    target: "e1r77czx2"
})({
    name: "1vhddwx",
    styles: "img{width:14px!important;height:14px!important;}"
});
const DeleteAllIntentsWrapper = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1r77czx1"
})({
    name: "mzdyw5",
    styles: "display:flex;justify-content:flex-end;flex:1;margin-right:18px"
});
const containerStyle = /*#__PURE__*/ (0, _css.css)({
    name: "pit38s",
    styles: "height:auto"
});
const updatePanel = /*#__PURE__*/ (0, _css.css)("display:flex;flex-direction:row;align-items:center;justify-content:flex-start;padding:5px;padding-left:32px;.success-label{font-size:16px;font-weight:600;color:", (0, _colors.green_1), ";}", "");
const headerContainer = /*#__PURE__*/ (0, _css.css)({
    name: "185uk78",
    styles: "margin:0 50px 16px 50px"
});
const LoaderContainer = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1r77czx0"
})({
    name: "13udsys",
    styles: "height:100%"
});

},{"@babel/runtime/helpers/extends":"4iKIP","@emotion/styled/base":"lSuFu","@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","../../../constants/colors":"1p3OR","./IntentItem":"l8wuQ","./InteractionModelForm":"9RN9X","../../../components/general/ModalTitle":"hIp2B","../../../components/general/Button":"6ymxN","../../../components/structure/ConfirmationDialog":"kx7yK","../../../components/general/WarningConfirmation":"9OccO","./AddNewIntentModal":"gval1","../../../../shared/components/general/Loader":"bnV5T","./ManageIntentPromptModal":"48qeH","fa72b8b82823f5de":"7eyKJ","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"l8wuQ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _base = require("@emotion/styled/base");
var _baseDefault = parcelHelpers.interopDefault(_base);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _toggleIndicator = require("../../../components/general/ToggleIndicator");
var _toggleIndicatorDefault = parcelHelpers.interopDefault(_toggleIndicator);
var _css = require("@emotion/css");
var _button = require("../../../components/general/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _colors = require("../../../constants/colors");
var _languageCollectionAvatar = require("../../../components/general/LanguageCollectionAvatar");
var _languageCollectionAvatarDefault = parcelHelpers.interopDefault(_languageCollectionAvatar);
var _switch = require("../../../components/forms/Switch");
var _switchDefault = parcelHelpers.interopDefault(_switch);
var _lodash = require("lodash");
var _lodashDefault = parcelHelpers.interopDefault(_lodash);
var _modalLayout = require("../../../components/structure/ModalLayout");
var _modalLayoutDefault = parcelHelpers.interopDefault(_modalLayout);
var _pageContainer = require("../../../components/structure/PageContainer");
var _pageContainerDefault = parcelHelpers.interopDefault(_pageContainer);
var _horizontalContainer = require("../../../components/structure/HorizontalContainer");
var _horizontalContainerDefault = parcelHelpers.interopDefault(_horizontalContainer);
var _modalTitle = require("../../../components/general/ModalTitle");
var _modalTitleDefault = parcelHelpers.interopDefault(_modalTitle);
var _horizontalSeparator = require("../../../components/structure/HorizontalSeparator");
var _horizontalSeparatorDefault = parcelHelpers.interopDefault(_horizontalSeparator);
var _customScrollbars = require("../../../components/structure/CustomScrollbars");
var _customScrollbarsDefault = parcelHelpers.interopDefault(_customScrollbars);
var _footerBar = require("../../../components/structure/FooterBar");
var _footerBarDefault = parcelHelpers.interopDefault(_footerBar);
var _pageError = require("../../../components/general/PageError");
var _pageErrorDefault = parcelHelpers.interopDefault(_pageError);
var _useWindowSize = require("../../../hooks/UseWindowSize");
var _useWindowSizeDefault = parcelHelpers.interopDefault(_useWindowSize);
var _formik = require("formik");
var _errorLabel = require("../../../components/general/ErrorLabel");
var _errorLabelDefault = parcelHelpers.interopDefault(_errorLabel);
var _fieldError = require("../../../components/forms/FieldError");
var _fieldErrorDefault = parcelHelpers.interopDefault(_fieldError);
var _interactionModelForm = require("./InteractionModelForm");
var _nlpContainer = require("../../../hooks/NlpContainer");
var _nlpContainerDefault = parcelHelpers.interopDefault(_nlpContainer);
var _nlpModelTrainingContainer = require("../../../hooks/NlpModelTrainingContainer");
var _nlpModelTrainingContainerDefault = parcelHelpers.interopDefault(_nlpModelTrainingContainer);
var _interactionModelInput = require("./interactionModelInput");
var _interactionModelInputDefault = parcelHelpers.interopDefault(_interactionModelInput);
var _tooltipWrapper = require("../../../components/general/TooltipWrapper");
var _tooltipWrapperDefault = parcelHelpers.interopDefault(_tooltipWrapper);
var _disableForFeatureFlagOptions = require("../../contentPage/components/DisableForFeatureFlagOptions");
var _disableForFeatureFlagOptionsDefault = parcelHelpers.interopDefault(_disableForFeatureFlagOptions);
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const deleteIcon = require("cd23b7fb1db4c27d");
const pencilGrey = require("9c3c0bcdd7d3b6dd");
const quoteIcon = require("b40019f7d1d9fbd1");
const addIcon = require("27cb060f8100aad9");
const greenCircleCheck = require("7450f739748b9ccf");
const redNoCircle = require("204ab4769b05b1eb");
const yellowInfoCircle = require("7f065a80d7b204e");
const yellowUpdate = require("b12551d0dc4e84a9");
const closeIcon = require("e9aee97f8b33f4d6");
const alertIcon = require("95e8603b627d8ed0");
const enhancedIcon = require("ee5136db07e59045");
const IntentItem = (props)=>{
    const [editingPhrase, setEditingPhrase] = (0, _react1.useState)("");
    const [editingIntentName, setEditingIntentName] = (0, _react1.useState)("");
    const [editingIntentDescription, setEditingIntentDescription] = (0, _react1.useState)("");
    const [utterancesError, setUtterancesError] = (0, _react1.useState)([]);
    const [intentError, setIntentError] = (0, _react1.useState)([]);
    const [validationError, setValidationError] = (0, _react1.useState)([]);
    const [editingFeatureFlags, setEditingFeatureFlags] = (0, _react1.useState)(false);
    const [assistantApplication, setAssistantApplication] = (0, _react1.useState)(null);
    const windowSize = (0, _useWindowSizeDefault.default)();
    const nlpContainer = (0, _nlpContainerDefault.default).useContainer();
    const modelTrainingContainer = (0, _nlpModelTrainingContainerDefault.default).useContainer();
    const utteranceTextInput = /*#__PURE__*/ (0, _reactDefault.default).createRef();
    const intentNameTextInput = /*#__PURE__*/ (0, _reactDefault.default).createRef();
    const intentDescriptionTextInput = /*#__PURE__*/ (0, _reactDefault.default).createRef();
    const hasUnsavedChanges = props.intent.isDeleted || props.intent.isAdded || props.intent.isModified || props.intent.updatedDisabledState;
    const isActive = props.isActive;
    const isCustom = props.intent.isCustom;
    const isDeleted = props.intent.isDeleted;
    const intentName = props.intent.displayName;
    const intentKey = props.intent.key;
    const intentField = `interactionModel.${intentKey}`;
    const displayNameField = `interactionModel.${intentKey}.displayName`;
    const slotsField = `interactionModel.${intentKey}.slots`;
    const utterancesField = `interactionModel.${intentKey}.utterances`;
    const hasErrors = (0, _formik.getIn)(props.errors, intentField);
    const displayNameFieldError = (0, _formik.getIn)(props.errors, displayNameField);
    const hasSlotsErrors = (0, _formik.getIn)(props.errors, slotsField);
    const intentLanguages = props.languages?.filter((l)=>props.intent.locales?.some((locale)=>locale.shortCode == l.shortCode));
    (0, _react1.useEffect)(function refreshDisplayIntentErrors() {
        setValidationError([]);
        setUtterancesError([]);
        if (hasErrors) {
            const intentFormErrors = displayNameFieldError ? [
                displayNameFieldError
            ] : [];
            const slotsFormErrors = hasSlotsErrors?.map((error)=>{
                let rtn = [];
                if (error?.name) rtn.push(error?.name);
                if (error?.entityName) rtn.push(error?.entityName);
                return rtn;
            });
            if (intentFormErrors) setIntentError(intentFormErrors);
            if (slotsFormErrors) setValidationError(slotsFormErrors);
        }
    }, [
        hasErrors,
        isActive
    ]);
    (0, _react1.useEffect)(()=>{
        intentNameTextInput.current?.focus();
    }, [
        editingIntentName
    ]);
    (0, _react1.useEffect)(()=>{
        intentDescriptionTextInput.current?.focus();
    }, [
        editingIntentDescription
    ]);
    const detectSlots = async (input)=>{
        if (!props.intent?.slots?.length) return input;
        let assistantApp = modelTrainingContainer.currentApp;
        if (assistantApp?.id != props.applicationId) {
            var appResult = await modelTrainingContainer.loadAssistantApplication(props.applicationId);
            assistantApp = appResult.data;
        }
        const appId = assistantApp?.id;
        const appSecret = assistantApp?.secret;
        const env = assistantApp?.environments?.find((e)=>e.name == "Production");
        const modelId = env?.languages?.[0].nlpModelId;
        if (!appId?.length || !appSecret?.length || !env?.id?.length || !modelId?.length) return input;
        const nlpResult = await nlpContainer.runNlp(appId, appSecret, env.id, input, modelId);
        if (nlpResult.resultType !== "Ok") return input;
        const entities = nlpResult.data.extractedEntities;
        const entitiesUsed = [];
        const entitiesToUse = [];
        (props.intent?.slots ?? []).forEach((slot)=>{
            const toAdd = entities?.filter((e)=>e.name === slot.entityName || e.entityId === slot.entityId) ?? [];
            toAdd.forEach((ta)=>{
                if (!entitiesUsed?.includes(ta)) {
                    entitiesUsed.push(ta);
                    entitiesToUse.push({
                        ...ta,
                        slotName: slot.name
                    });
                }
            });
        });
        // sort entitiesTouse by start property ascending
        entitiesToUse.sort((a, b)=>a.start - b.start);
        const nonNested = [];
        for(let i = 0; i < entitiesToUse.length; i += 1){
            if (entitiesToUse.some((ie, idx)=>idx !== i && (ie.start <= entitiesToUse[i].start && ie.end > entitiesToUse[i].end || ie.start < entitiesToUse[i].start && ie.end >= entitiesToUse[i].end))) ;
            else nonNested.push(entitiesToUse[i]);
        }
        let index = 0;
        let result = "";
        for(let i = 0; i < nonNested.length; i += 1){
            const entity = nonNested[i];
            const left = input.slice(index, entity.start);
            index = entity.end + 1;
            result += left;
            result += `{${entity.slotName}}`;
        }
        const right = input.slice(nonNested[nonNested.length - 1]?.end + 1);
        result += right;
        return result;
    };
    const handleIntentItemToggleActivation = ()=>{
        props.toggleActivationByKey(intentKey);
    };
    const toggleIsDeleted = ()=>{
        let editable = {
            ...props.intent
        };
        editable.isDeleted = !editable.isDeleted;
        const error = props.updateIntent(intentName, editable);
        if (error) setIntentError([
            error
        ]);
        else props.toggleActivationByKey(intentKey);
    };
    const toggleRequiresExactUtteranceMatch = ()=>{
        let editable = {
            ...props.intent
        };
        editable.didUpdateRequiresExactMatch = true;
        editable.requiresExactUtteranceMatch = !editable.requiresExactUtteranceMatch;
        const error = props.updateIntent(intentName, editable);
        if (error) setIntentError([
            error
        ]);
    };
    const toggleAllowEnhanced = ()=>{
        let editable = {
            ...props.intent
        };
        editable.allowEnhancedIntentMatching = !editable.allowEnhancedIntentMatching;
        editable.isModified = true;
        const error = props.updateIntent(intentName, editable);
        if (error) setIntentError([
            error
        ]);
    };
    const toggleAlwaysInclude = ()=>{
        let editable = {
            ...props.intent
        };
        editable.alwaysIncludeInPrompt = !editable.alwaysIncludeInPrompt;
        editable.isModified = true;
        const error = props.updateIntent(intentName, editable);
        if (error) setIntentError([
            error
        ]);
    };
    const toggleIsDisabled = ()=>{
        let editable = {
            ...props.intent
        };
        editable.isDisabled = !editable.isDisabled;
        editable.updatedDisabledState = true;
        const error = props.updateIntent(intentName, editable);
        if (error) setIntentError([
            error
        ]);
        else props.toggleActivationByKey(intentKey);
    };
    const changeName = (newName)=>{
        let editable = {
            ...props.intent
        };
        editable.displayName = newName;
        const error = props.updateIntent(intentName, editable);
        if (error) setIntentError([
            error
        ]);
    };
    const changeDescription = (newDescription)=>{
        let editable = {
            ...props.intent
        };
        editable.enhancedMatchingDescription = newDescription;
        const error = props.updateIntent(intentName, editable);
        if (error) setIntentError([
            error
        ]);
    };
    const setEditingIntentDescriptionState = (editing)=>{
        if (!editing) {
            const updatedDescription = intentDescriptionTextInput.current.value;
            if (props.intent.enhancedMatchingDescription != updatedDescription) changeDescription(updatedDescription);
            setEditingIntentDescription(null);
        } else setEditingIntentDescription(intentName);
    };
    const handleEditingIntentDescriptionKeyUp = (e)=>{
        e.stopPropagation();
        if (e.key === "Enter") setEditingIntentDescriptionState(false);
        else if (e.key === "Escape") setEditingIntentDescription(null);
    };
    const setEditingIntentNameState = (editing)=>{
        if (!editing) {
            const editedName = intentNameTextInput.current.value;
            if (intentName != editedName) changeName(editedName);
            setEditingIntentName(null);
        } else setEditingIntentName(intentName);
    };
    const handleEditingIntentNameKeyUp = (e)=>{
        e.stopPropagation();
        if (e.key === "Enter") setEditingIntentNameState(false);
        else if (e.key === "Escape") setEditingIntentName(null);
    };
    const handleEditingUtteranceKeyUp = (e, utterance)=>{
        e.stopPropagation();
        if (e.key === "Enter") setEditingUtteranceState(false, utterance);
        else if (e.key === "Escape") setEditingPhrase(null);
    };
    const utteranceExists = (phrase, lang)=>{
        const utteranceMatch = props.intent.utterances.filter((u)=>u.changeType != "Removed" && u.phrase.toLowerCase().trim() === phrase.toLowerCase().trim() && u.language.id == lang.id);
        return utteranceMatch?.length > 0;
    };
    const addUtterance = (phrase, languages)=>{
        const intent = {
            ...props.intent
        };
        languages.forEach((lang)=>{
            // If utterance already exists - do nothing, if it does not exist - add it
            if (!utteranceExists(phrase, lang)) intent.utterances.unshift({
                phrase: phrase,
                changeType: "Added",
                language: lang
            });
        });
        const error = props.updateIntent(intentName, intent);
        if (error) setIntentError([
            error
        ]);
    };
    const handleAddUtteranceToAllLanguages = (utterance)=>{
        const languagesToAdd = intentLanguages.filter((l)=>!utterance.languages.some((ul)=>ul.id == l.id));
        addUtterance(utterance.phrase, languagesToAdd);
    };
    const removeUtterance = (intent, phrase, language)=>{
        if (utteranceExists(phrase, language)) {
            const utterance = intent.utterances.filter((u)=>u.phrase === phrase && u.language.id == language.id)[0];
            if (utterance.changeType == "Added") {
                var idx = intent.utterances.indexOf(utterance);
                intent.utterances.splice(idx, 1);
            } else utterance.changeType = "Removed";
        }
        return;
    };
    const removeUtteranceFromAllLanguages = (utterance)=>{
        const intent = {
            ...props.intent
        };
        intentLanguages.forEach((lang)=>{
            removeUtterance(intent, utterance, lang);
        });
        const error = props.updateIntent(intentName, intent);
        if (error) setIntentError([
            error
        ]);
    };
    const updateSlots = (updatedSlots)=>{
        // Interaction Model Update is going to remove old slots and add new slots
        const intentToUpdate = {
            ...props.intent
        };
        let intentUtterances = [
            ...intentToUpdate.utterances
        ];
        intentToUpdate.slots = updatedSlots;
        // If existing slot name was updated then we need to replace old slot with changed slot in utterances that use it
        updatedSlots.filter((slot)=>!slot.isDeleted && slot.name != slot.originalName)?.forEach((modifiedSlot)=>{
            const slotOriginalName = modifiedSlot.originalName;
            const slotNewName = modifiedSlot.name;
            intentUtterances?.forEach((utterance)=>{
                const utteranceSlots = (0, _interactionModelForm.extractSlots)(utterance.phrase);
                const extractedPhraseSlots = utteranceSlots?.map((s)=>s.getSlotName());
                extractedPhraseSlots?.forEach((slotName)=>{
                    if (slotName == slotOriginalName) {
                        // Slot was used in utterance
                        const oldSlot = `{${slotOriginalName}}`;
                        const newSlot = `{${slotNewName}}`;
                        const newPhrase = utterance.phrase.replace(oldSlot, newSlot);
                        intentLanguages.forEach((lang)=>{
                            updateUtterance(intentToUpdate, utterance.phrase, newPhrase, lang);
                        });
                    }
                });
            });
        });
        // Remove utterances that use deleted slots
        if (updatedSlots?.some((s)=>s.isDeleted)) {
            intentUtterances = [
                ...intentToUpdate.utterances
            ];
            const utterancesToRemove = [];
            updatedSlots.filter((slot)=>slot.isDeleted)?.forEach((deletedSlot)=>{
                const deletedSlotName = deletedSlot.originalName ? deletedSlot.originalName : deletedSlot.name;
                intentUtterances?.forEach((utterance)=>{
                    const utteranceSlots = (0, _interactionModelForm.extractSlots)(utterance.phrase);
                    const extractedPhraseSlots = utteranceSlots?.map((s)=>s.getSlotName());
                    extractedPhraseSlots?.forEach((slotName)=>{
                        if (slotName == deletedSlotName) utterancesToRemove.push(utterance);
                    });
                });
            });
            utterancesToRemove?.forEach((utterance)=>{
                intentLanguages.forEach((lang)=>{
                    removeUtterance(intentToUpdate, utterance.phrase, lang);
                });
            });
        }
        // Filter out newly added and then deleted slots
        const modifiedSlots = updatedSlots.filter((slot)=>!(slot.isAdded && slot.isDeleted));
        intentToUpdate.slots = modifiedSlots;
        const error = props.updateIntent(intentName, intentToUpdate);
        if (error) setIntentError([
            error
        ]);
    };
    const validateUtterance = (phrase)=>{
        const intent = props.intent;
        const errors = [];
        const nonDeletedSlots = intent.slots ? intent.slots.filter((s)=>!s.isDeleted) : [];
        const requiredSlots = nonDeletedSlots ? nonDeletedSlots.filter((s)=>s.required).map((s)=>s.name) : [];
        const availableSlots = nonDeletedSlots ? nonDeletedSlots.map((s)=>s.name) : [];
        const extractedPhraseSlots = (0, _interactionModelForm.extractSlots)(phrase).map((s)=>s.getSlotName());
        const existingUtterance = intent.utterances?.find((u)=>u.phrase === phrase);
        if (existingUtterance) {
            errors.push(`That utterance already exists for this intent.`);
            return errors;
        }
        if (!phrase || phrase.length < 1) errors.push(`Phrase cannot be empty`);
        const missingSlots = (0, _lodashDefault.default).difference(requiredSlots, extractedPhraseSlots);
        if (missingSlots && missingSlots.length > 0) missingSlots.forEach((s)=>{
            errors.push(`Slot {${s}} is required`);
        });
        const nonExistentSlots = (0, _lodashDefault.default).difference(extractedPhraseSlots, availableSlots);
        if (nonExistentSlots && nonExistentSlots.length > 0) nonExistentSlots.forEach((s)=>{
            errors.push(`{${s}} is not a valid slot for "${intent.displayName}" intent `);
        });
        return errors;
    };
    const updateUtterance = (intent, oldPhrase, newPhrase, language)=>{
        const idx = intent.utterances.map((u)=>u.phrase).indexOf(oldPhrase);
        const utterance = intent.utterances[idx];
        if (utterance.changeType == "Original") {
            intent.utterances[idx].changeType = "Removed";
            intent.utterances.splice(idx, 0, {
                phrase: newPhrase,
                changeType: "Added",
                language
            });
        } else if (utterance.changeType == "Added") intent.utterances[idx].phrase = newPhrase;
    //else:  Do not care about Removed
    };
    const editUtterance = (intent, oldPhrase, newPhrase, language)=>{
        if (utteranceExists(oldPhrase, language) && !utteranceExists(newPhrase, language)) {
            const errors = validateUtterance(newPhrase);
            if (errors.length > 0) {
                setUtterancesError([
                    ...utterancesError ?? [],
                    ...errors ?? []
                ]);
                utteranceTextInput.current?.focus();
                return;
            }
            updateUtterance(intent, oldPhrase, newPhrase, language);
            return;
        } else {
            setUtterancesError([
                ...utterancesError ?? [],
                "Validation error: Phrase already exists"
            ]);
            return;
        }
    };
    const setEditingUtteranceState = (editing, utterance)=>{
        if (!editing) {
            if (utterance != utteranceTextInput.current.value) {
                const intent = {
                    ...props.intent
                };
                intentLanguages.forEach((lang)=>{
                    editUtterance(intent, utterance, utteranceTextInput.current.value, lang);
                    setEditingPhrase(null);
                    setUtterancesError([]);
                });
                const error = props.updateIntent(intentName, intent);
                if (error) setIntentError([
                    error
                ]);
            } else {
                setUtterancesError([]);
                setEditingPhrase(null);
            }
        } else {
            setUtterancesError([]);
            setEditingPhrase(utterance);
        }
    };
    const renderItemHeaderToggle = (direction)=>{
        const nonRemovedUtterances = props.intent.utterances.filter((u)=>u.changeType != "Removed");
        const uniqueUtterances = [
            ...new Set(nonRemovedUtterances.map((u)=>u.phrase))
        ];
        return (0, _react.jsx)("div", {
            className: itemBody,
            key: `menuItem-${props.idx}`,
            onClick: (e)=>handleIntentItemToggleActivation()
        }, (0, _react.jsx)((0, _toggleIndicatorDefault.default), {
            className: "toggle-indicator",
            direction: direction
        }), renderListIntentDisplayName(), (0, _react.jsx)("div", {
            className: "counter-container"
        }, hasErrors && (0, _react.jsx)((0, _errorLabelDefault.default), {
            image: alertIcon,
            text: "Errors Present"
        }), props.displayLanguages && (0, _react.jsx)("div", {
            className: "enabled-container"
        }, (0, _react.jsx)((0, _languageCollectionAvatarDefault.default), {
            languages: intentLanguages,
            limit: 3
        })), hasUnsavedChanges && (0, _react.jsx)("div", {
            className: "enabled-container"
        }, (0, _react.jsx)("p", null, isDeleted ? "Deleted" : "Modified"), (0, _react.jsx)("img", {
            src: isDeleted ? redNoCircle : yellowUpdate
        })), (0, _react.jsx)("p", null, "Phrases:"), (0, _react.jsx)("div", {
            className: "count" + (nonRemovedUtterances.length == 0 ? " empty" : "")
        }, (0, _react.jsx)("span", null, uniqueUtterances.length))), (0, _react.jsx)("div", {
            className: "enabled-container"
        }, (0, _react.jsx)("p", null, props.intent.isDisabled ? "Disabled" : "Enabled"), (0, _react.jsx)("img", {
            src: props.intent.isDisabled ? redNoCircle : greenCircleCheck
        })));
    };
    const renderActiveIntentEditingContent = ()=>{
        return (0, _react.jsx)((0, _reactDefault.default).Fragment, null, (0, _react.jsx)("div", {
            className: editingContainer
        }, (0, _react.jsx)("div", {
            className: "enabled-switch-container"
        }, (0, _react.jsx)(EnhancedIntentSettingsRow, null, (0, _react.jsx)(MatchingEnabledSwitch, {
            className: "enabled-switch",
            onChange: ()=>toggleAllowEnhanced(),
            disabled: !props.enhancedIntentMatchingEnabled,
            checked: props.intent.allowEnhancedIntentMatching,
            leftOption: !props.enhancedIntentMatchingEnabled ? "LLM intent matching disabled for model" : "LLM Matching"
        }), props.intent.allowEnhancedIntentMatching && props.enhancedIntentMatchingEnabled && (0, _react.jsx)((0, _reactDefault.default).Fragment, null, (0, _react.jsx)(AlwaysIncludeSwitch, {
            className: "enabled-switch",
            onChange: ()=>toggleAlwaysInclude(),
            checked: props.intent.alwaysIncludeInPrompt,
            leftOption: "Always include in prompt"
        }), editingIntentDescription === intentName ? (0, _react.jsx)(DescriptionInput, {
            type: "text",
            defaultValue: props.intent.enhancedMatchingDescription,
            placeholder: "When the user ...",
            ref: intentDescriptionTextInput,
            onClick: (e)=>e.stopPropagation(),
            onBlur: ()=>setEditingIntentDescriptionState(false),
            onKeyUp: (e)=>handleEditingIntentDescriptionKeyUp(e)
        }) : (0, _react.jsx)(DescriptionRow, null, (0, _react.jsx)(EditDescriptionButton, {
            themes: [
                "white-small",
                "end-tight"
            ],
            text: "Edit Description",
            icon: pencilGrey,
            type: "button",
            onClick: ()=>setEditingIntentDescriptionState(true)
        }), (0, _react.jsx)((0, _tooltipWrapperDefault.default), {
            text: props.intent.enhancedMatchingDescription?.length ? props.intent.enhancedMatchingDescription : "No description set",
            place: "top",
            maxWidth: 300
        }, (0, _react.jsx)(DescriptionPreview, null, props.intent.enhancedMatchingDescription?.length ? props.intent.enhancedMatchingDescription : "No description set"))))), (0, _react.jsx)(SecondaryButtonRow, null, (0, _react.jsx)(DisabledForFeaturesButton, {
            themes: [
                "white-small",
                "end-tight"
            ],
            onClick: ()=>{
                setEditingFeatureFlags(!editingFeatureFlags);
            },
            text: `Disabled for ${props.intent.disabledForFeatureFlagIds?.length ?? 0} Features`,
            icon: pencilGrey
        }), isCustom && (0, _react.jsx)((0, _reactDefault.default).Fragment, null, (0, _react.jsx)(EditNameButton, {
            themes: [
                "white-small",
                "end-tight"
            ],
            text: "Edit Name",
            icon: pencilGrey,
            type: "button",
            onClick: ()=>setEditingIntentNameState(true)
        }), !isDeleted && props.displayType === "List" && (0, _react.jsx)(RemoveIntentButton, {
            themes: [
                "white-small"
            ],
            text: "Remove Intent",
            type: "button",
            icon: deleteIcon,
            onClick: ()=>toggleIsDeleted()
        })), props.displayType === "List" ? (0, _react.jsx)((0, _reactDefault.default).Fragment, null, (0, _react.jsx)(RequiresExactMatchSwitch, {
            className: "enabled-switch",
            onChange: ()=>toggleRequiresExactUtteranceMatch(),
            checked: props.intent.requiresExactUtteranceMatch,
            leftOption: "Requires Exact Match"
        }), props.intent.disabledForFeatureFlagIds?.length ? (0, _react.jsx)((0, _reactDefault.default).Fragment, null) : (0, _react.jsx)((0, _switchDefault.default), {
            className: "enabled-switch",
            key: intentKey,
            onChange: ()=>toggleIsDisabled(),
            checked: !props.intent.isDisabled,
            leftOption: props.intent.isDisabled ? "Disabled" : "Enabled"
        })) : (0, _react.jsx)(Filler, null))), props.intent.isDisabled && (0, _react.jsx)("div", {
            className: disabledWarningStyle
        }, (0, _react.jsx)("img", {
            src: yellowInfoCircle
        }), (0, _react.jsx)("p", null, "This intent is currently disabled. Any changes you make to it will not be reflected in your app’s interaction model")), editingFeatureFlags && (0, _react.jsx)(DisableForFlagsContainer, null, (0, _react.jsx)((0, _disableForFeatureFlagOptionsDefault.default), {
            titleOverride: "Disable this intent if feature flags are present",
            descriptionOverride: "If a checked feature flag is present in this application, this intent will be disabled.",
            appContainer: props.appContainer,
            onChange: (value)=>{
                const intent = {
                    ...props.intent
                };
                intent.disabledForFeatureFlagIds = value;
                const error = props.updateIntent(intentName, intent);
                if (error) setIntentError([
                    error
                ]);
            },
            selectedFeatureFlags: props.intent.disabledForFeatureFlagIds
        })), (0, _react.jsx)((0, _interactionModelInputDefault.default), {
            nlpEntities: props.nlpEntities,
            validateUtterance: validateUtterance,
            extractSlots: (0, _interactionModelForm.extractSlots),
            addUtterance: addUtterance,
            updateSlots: updateSlots,
            setError: setUtterancesError,
            isLoading: props.isLoading || nlpContainer.loading,
            intent: props.intent,
            detectSlots: (text)=>detectSlots(text),
            intentName: intentName,
            applicationId: props.applicationId,
            languages: intentLanguages
        }), renderUtterancesContainer(), (0, _react.jsx)((0, _pageErrorDefault.default), {
            className: pageErrorStyle,
            errors: [
                ...intentError ?? [],
                ...utterancesError ?? [],
                ...validationError ?? []
            ],
            onClear: ()=>{
                setIntentError([]);
                setUtterancesError([]);
                setValidationError([]);
            }
        })));
    };
    const renderIntentName = ()=>{
        return (0, _react.jsx)(IntentNameRow, null, (0, _react.jsx)("div", null, intentName), props.intent.allowEnhancedIntentMatching ? (0, _react.jsx)((0, _tooltipWrapperDefault.default), {
            place: "right",
            text: "LLM Intent Matching Enabled"
        }, (0, _react.jsx)("img", {
            src: enhancedIcon
        })) : null);
    };
    const renderListIntentDisplayName = ()=>{
        if (isActive) return (0, _react.jsx)((0, _reactDefault.default).Fragment, null, editingIntentName != intentName ? renderIntentName() : (0, _react.jsx)(NameInput, {
            type: "text",
            defaultValue: intentName,
            ref: intentNameTextInput,
            onClick: (e)=>e.stopPropagation(),
            onBlur: ()=>setEditingIntentNameState(false),
            onKeyUp: (e)=>handleEditingIntentNameKeyUp(e)
        }));
        else return renderIntentName();
    };
    const renderModalIntentDisplayName = ()=>{
        return editingIntentName != intentName ? (0, _react.jsx)((0, _modalTitleDefault.default), {
            padded: true
        }, intentName) : (0, _react.jsx)(ModalNameInput, {
            type: "text",
            defaultValue: intentName,
            ref: intentNameTextInput,
            onClick: (e)=>e.stopPropagation(),
            onBlur: ()=>setEditingIntentNameState(false),
            onKeyUp: (e)=>handleEditingIntentNameKeyUp(e)
        });
    };
    const renderUtteranceItem = (utterance, utteranceIdx)=>{
        if (utterance.changeType != "Removed") {
            const phrase = utterance?.phrase;
            return (0, _react.jsx)("div", {
                key: utteranceIdx,
                className: utteranceItem
            }, editingPhrase != phrase ? (0, _react.jsx)("div", null, (0, _react.jsx)("img", {
                className: "quote-icon",
                src: quoteIcon
            }), phrase, (0, _react.jsx)("img", {
                className: "edit-icons edit",
                src: pencilGrey,
                onClick: (e)=>{
                    e.stopPropagation();
                    setEditingUtteranceState(true, phrase);
                }
            })) : (0, _react.jsx)(NameInput, {
                type: "text",
                defaultValue: phrase,
                ref: utteranceTextInput,
                autoFocus: true,
                onBlur: ()=>setEditingUtteranceState(false, phrase),
                onKeyUp: (e)=>handleEditingUtteranceKeyUp(e, phrase)
            }), (0, _react.jsx)("div", {
                className: "end-container"
            }, (0, _react.jsx)("div", {
                className: "utterance-field-error"
            }, (0, _react.jsx)((0, _fieldErrorDefault.default), {
                name: `${utterancesField}.${utteranceIdx}.phrase`,
                ignoreTouched: true
            })), utterance.languages.length < intentLanguages.length ? (0, _react.jsx)((0, _reactDefault.default).Fragment, null, (0, _react.jsx)((0, _buttonDefault.default), {
                themes: [
                    "hollow",
                    "flat"
                ],
                icon: addIcon,
                onClick: ()=>handleAddUtteranceToAllLanguages(utterance),
                text: "Apply to all"
            }), (0, _react.jsx)("div", {
                className: "unselected-flags"
            }, (0, _react.jsx)((0, _languageCollectionAvatarDefault.default), {
                languages: intentLanguages.filter((l)=>!utterance.languages.some((ul)=>ul.id == l.id)),
                limit: 3
            }))) : null, (0, _react.jsx)((0, _languageCollectionAvatarDefault.default), {
                languages: utterance.languages,
                limit: 3
            }), (0, _react.jsx)("img", {
                src: deleteIcon,
                className: "edit-icons delete",
                onClick: ()=>removeUtteranceFromAllLanguages(phrase)
            })));
        }
    };
    const renderUtterancesContainer = ()=>{
        const utteranceGroups = [];
        props.intent.utterances.forEach((utterance)=>{
            const phrase = utterance.phrase;
            const existingGroup = utteranceGroups.find((u)=>u.phrase == phrase);
            if (existingGroup) existingGroup.languages.push(utterance.language);
            else utteranceGroups.push({
                ...utterance,
                languages: [
                    utterance.language
                ]
            });
        });
        return (0, _react.jsx)("div", {
            className: utteranceContainer
        }, utteranceGroups.map((u, idx)=>{
            return renderUtteranceItem(u, idx);
        }));
    };
    const renderIntentListItem = ()=>{
        if (isActive) return (0, _react.jsx)("div", {
            className: activeItemContainer,
            key: `active-${props.idx}`
        }, renderItemHeaderToggle("down"), renderActiveIntentEditingContent());
        else return renderItemHeaderToggle("right");
    };
    const renderIntentModalItem = ()=>{
        return (0, _react.jsx)((0, _modalLayoutDefault.default), {
            allowOverflow: true,
            isVisible: true,
            onClose: ()=>props.handleClose()
        }, (0, _react.jsx)((0, _pageContainerDefault.default), {
            fill: true,
            withFooter: true
        }, (0, _react.jsx)((0, _horizontalContainerDefault.default), null, renderModalIntentDisplayName(), (0, _react.jsx)((0, _buttonDefault.default), {
            themes: [
                "end-tight",
                "icon"
            ],
            icon: closeIcon,
            onClick: ()=>props.handleClose()
        })), (0, _react.jsx)((0, _horizontalSeparatorDefault.default), null), (0, _react.jsx)((0, _customScrollbarsDefault.default), {
            autoHide: true,
            autoHeight: true,
            autoHeightMax: windowSize.windowSize.innerHeight * .9 - 188
        }, renderActiveIntentEditingContent()), (0, _react.jsx)(CustomFooter, {
            usedInModal: true
        }, (0, _react.jsx)(SubmitButton, {
            type: "button",
            themes: [
                "primary"
            ],
            text: "Save",
            onClick: ()=>props.handleSubmit(),
            disabled: props.isLoading,
            loading: props.isLoading
        }), (0, _react.jsx)((0, _buttonDefault.default), {
            type: "button",
            themes: [
                "secondary"
            ],
            text: "Cancel",
            onClick: ()=>props.handleClose(),
            disabled: props.isLoading,
            loading: props.isLoading
        }))));
    };
    return props.displayType === "List" ? renderIntentListItem() : renderIntentModalItem();
};
exports.default = IntentItem;
const DisabledForFeaturesButton = /*#__PURE__*/ (0, _baseDefault.default)((0, _buttonDefault.default), {
    target: "e1vh2q5119"
})({
    name: "3mmiur",
    styles: "margin:0 8px;height:24px;padding:0 12px;font-size:12px;font-weight:500;.left-img,.right-img{height:14px;width:14px;margin-right:6px;margin-left:0;}"
});
const CustomFooter = /*#__PURE__*/ (0, _baseDefault.default)((0, _footerBarDefault.default), {
    target: "e1vh2q5118"
})({
    name: "1q0eusf",
    styles: "z-index:auto"
});
const SubmitButton = /*#__PURE__*/ (0, _baseDefault.default)((0, _buttonDefault.default), {
    target: "e1vh2q5117"
})({
    name: "1tx1l5v",
    styles: "margin-right:auto"
});
const activeItemContainer = /*#__PURE__*/ (0, _css.css)({
    name: "bjn8wh",
    styles: "position:relative"
});
const DisableForFlagsContainer = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1vh2q5116"
})({
    name: "85u338",
    styles: "margin:24px"
});
const itemBody = /*#__PURE__*/ (0, _css.css)("display:flex;flex-direction:row;align-items:center;height:75px;border:solid 1px ", (0, _colors.color_shades_dark), ";font-size:18px;color:", (0, _colors.color_text_default), ";position:relative;cursor:pointer;input{background-color:white;width:97%;border-radius:5px;border:solid 1px #cccccc;padding:12px;height:40px;margin-top:8px;margin-right:36px;font-size:18px;color:", (0, _colors.color_text_default), ";}.toggle-indicator{margin:16px;}.enabled-container{display:flex;align-items:center;margin-right:16px;margin-left:16px;p{font-size:14px;color:", (0, _colors.color_text_default), ";margin-right:12px;}img{height:24px;width:24px;}}.counter-container{display:flex;align-items:center;margin-right:16px;margin-left:auto;p{font-size:14px;color:", (0, _colors.color_text_default), ";margin-right:12px;}.count{width:30px;max-height:22px;border-radius:11px;border:solid 1px #8e97a1;background:#8e97a1;color:white;display:flex;align-items:center;justify-content:center!important;span{font-size:14px;text-align:center;}&.empty{background:white;color:", (0, _colors.color_text_default), ";}}}", "");
const pageErrorStyle = /*#__PURE__*/ (0, _css.css)({
    name: "q5ufan",
    styles: "top:92;bottom:inherit"
});
const editingContainer = /*#__PURE__*/ (0, _css.css)("background-color:", (0, _colors.color_shades_lighter), ";border:solid 1px ", (0, _colors.color_shades_dark), ";width:100%;position:relative;.enabled-switch-container{display:flex;flex-direction:column;gap:16px;padding:16px 24px;}.enabled-switch{margin:0;.primary-label{font-family:Muli;font-style:normal;font-weight:normal;font-size:14px;line-height:20px;color:", (0, _colors.color_text_default), ";}}", "");
const disabledWarningStyle = /*#__PURE__*/ (0, _css.css)("border-radius:5px;margin:30px;padding:24px;background:", (0, _colors.color_variants_gold_light), ";border:1px solid ", (0, _colors.color_colors_gold), ";display:flex;flex-direction:row;img{margin-right:16px;}", "");
const utteranceContainer = /*#__PURE__*/ (0, _css.css)("border:solid 1px ", (0, _colors.color_shades_dark), ";margin:30px;margin-top:0px;border-top:0px;border-radius:5px;position:relative;z-index:1;", "");
const Filler = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1vh2q5115"
})({
    name: "109aiko",
    styles: "width:32px;height:24px;margin:0"
});
const MatchingEnabledSwitch = /*#__PURE__*/ (0, _baseDefault.default)((0, _switchDefault.default), {
    target: "e1vh2q5114"
})({
    name: "1g5k56e",
    styles: "margin:0;min-width:160px"
});
const AlwaysIncludeSwitch = /*#__PURE__*/ (0, _baseDefault.default)((0, _switchDefault.default), {
    target: "e1vh2q5113"
})({
    name: "s5jr51",
    styles: "margin:0;min-width:224px"
});
const DescriptionInput = /*#__PURE__*/ (0, _baseDefault.default)("input", {
    target: "e1vh2q5112"
})("height:42px;border-radius:8px;border:solid 1px #cccccc;background:white;padding:0 16px;flex:1;margin-right:16px;font-family:Muli;font-size:14px;font-weight:normal;font-stretch:normal;font-style:normal;line-height:normal;letter-spacing:normal;color:", (0, _colors.color_text_default), ";margin-top:10px;");
const NameInput = /*#__PURE__*/ (0, _baseDefault.default)("input", {
    target: "e1vh2q5111"
})("height:42px;border-radius:5px;border:solid 1px #cccccc;background:white;padding:0 16px;flex:1;margin-right:48px;font-family:Muli;font-size:14px;font-weight:normal;font-stretch:normal;font-style:normal;line-height:normal;letter-spacing:normal;color:", (0, _colors.color_text_default), ";");
const ModalNameInput = /*#__PURE__*/ (0, _baseDefault.default)(NameInput, {
    target: "e1vh2q5110"
})({
    name: "12hu7w4",
    styles: "margin:16px 32px 16px 32px"
});
const EnhancedIntentSettingsRow = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1vh2q519"
})({
    name: "qq53ia",
    styles: "display:flex;flex-direction:row;align-items:center;flex-wrap:wrap;gap:8px;width:100%;overflow:hidden"
});
const SecondaryButtonRow = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1vh2q518"
})({
    name: "1eatpkt",
    styles: "display:flex;flex-direction:row;align-items:center;flex-wrap:wrap;gap:8px;width:100%;overflow:hidden;justify-content:flex-end"
});
const EditDescriptionButton = /*#__PURE__*/ (0, _baseDefault.default)((0, _buttonDefault.default), {
    target: "e1vh2q517"
})({
    name: "3mmiur",
    styles: "margin:0 8px;height:24px;padding:0 12px;font-size:12px;font-weight:500;.left-img,.right-img{height:14px;width:14px;margin-right:6px;margin-left:0;}"
});
const EditNameButton = /*#__PURE__*/ (0, _baseDefault.default)((0, _buttonDefault.default), {
    target: "e1vh2q516"
})({
    name: "11yiqd1",
    styles: "margin:0;height:24px;padding:0 12px;font-size:12px;font-weight:500;.left-img,.right-img{height:14px;width:14px;margin-right:6px;margin-left:0;}"
});
const RemoveIntentButton = /*#__PURE__*/ (0, _baseDefault.default)((0, _buttonDefault.default), {
    target: "e1vh2q515"
})({
    name: "3mmiur",
    styles: "margin:0 8px;height:24px;padding:0 12px;font-size:12px;font-weight:500;.left-img,.right-img{height:14px;width:14px;margin-right:6px;margin-left:0;}"
});
const DescriptionPreview = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1vh2q514"
})("flex:1;padding:0 8px;margin:0;color:", (0, _colors.color_shades_darkest_transparent), ";font-size:12px;font-style:italic;line-height:24px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;");
const DescriptionRow = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1vh2q513"
})({
    name: "v5pbp8",
    styles: "display:flex;flex-direction:row;align-items:center;flex:1;max-width:400px;margin:0"
});
const DescriptionPreviewRow = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1vh2q512"
})({
    name: "1vncc1c",
    styles: "display:flex;flex-direction:row;width:100%"
});
const utteranceItem = /*#__PURE__*/ (0, _css.css)("display:flex;flex-direction:row;align-items:center;height:75px;border-top:solid 1px ", (0, _colors.color_shades_dark), ";background-color:white;padding-left:16px;padding-right:16px;justify-content:space-between;.utterance-field-error{margin:0 16px 0 0;}.edit-icons{margin-left:12px;cursor:pointer;&.edit{height:16px;}}.quote-icon{margin-right:12px;height:12px;}.end-container{display:flex;align-items:center;margin-left:auto;margin-right:0;button{.left-img{margin-right:12px;}}.unselected-flags{padding:0 24px;margin-right:24px;border-right:1px solid #cccccc;.inner-flag{img{filter:grayscale(100%);}}}}", "");
const RequiresExactMatchSwitch = /*#__PURE__*/ (0, _baseDefault.default)((0, _switchDefault.default), {
    target: "e1vh2q511"
})({
    name: "13mu2qc",
    styles: "margin:0;min-width:210px"
});
const IntentNameRow = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1vh2q510"
})({
    name: "1j6pbk9",
    styles: "display:flex;flex-direction:row;div{margin-right:8px;}"
});

},{"@emotion/styled/base":"lSuFu","@emotion/react":"djZKr","react":"6uln9","../../../components/general/ToggleIndicator":"4eej1","@emotion/css":"awUBr","../../../components/general/Button":"6ymxN","../../../constants/colors":"1p3OR","../../../components/general/LanguageCollectionAvatar":"crbMk","../../../components/forms/Switch":"8kkL9","lodash":"3hMBK","../../../components/structure/ModalLayout":"b1cO3","../../../components/structure/PageContainer":"hc1r8","../../../components/structure/HorizontalContainer":"eJPfh","../../../components/general/ModalTitle":"hIp2B","../../../components/structure/HorizontalSeparator":"Pw3HQ","../../../components/structure/CustomScrollbars":"50vFq","../../../components/structure/FooterBar":"bibRL","../../../components/general/PageError":"ezFTm","../../../hooks/UseWindowSize":"43j9z","formik":"3YnOK","../../../components/general/ErrorLabel":"k9Ob0","../../../components/forms/FieldError":"fDxhz","./InteractionModelForm":"9RN9X","../../../hooks/NlpContainer":"eDZih","../../../hooks/NlpModelTrainingContainer":"fdXHQ","./interactionModelInput":"ilaog","../../../components/general/TooltipWrapper":"53pWd","../../contentPage/components/DisableForFeatureFlagOptions":"67JXM","cd23b7fb1db4c27d":"7eyKJ","9c3c0bcdd7d3b6dd":"15I2s","b40019f7d1d9fbd1":"2wWYJ","27cb060f8100aad9":"kxmNT","7450f739748b9ccf":"hst2e","204ab4769b05b1eb":"37PeV","7f065a80d7b204e":"k0Bys","b12551d0dc4e84a9":"8yrG0","e9aee97f8b33f4d6":"93VwA","95e8603b627d8ed0":"cRA6k","ee5136db07e59045":"5TB7H","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"k9Ob0":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _css = require("@emotion/css");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _colors = require("../../constants/colors");
const ErrorLabel = (props)=>{
    return (0, _react.jsx)("div", {
        className: `${errorLabelWrapper} ${props.className ?? ""}`
    }, (0, _react.jsx)("img", {
        src: props.image
    }), (0, _react.jsx)("div", {
        className: "error-text"
    }, props.text));
};
const errorLabelWrapper = /*#__PURE__*/ (0, _css.css)("color:", (0, _colors.color_colors_decline), ";font-weight:400;border-radius:4px;border:1px solid ", (0, _colors.color_colors_decline), ";width:auto;height:26px;margin:16px;padding:8px;font-size:14px;line-height:20px;display:flex;align-items:center;flex-direction:row;img{margin-right:8px;height:20px;width:auto;}.error-text{color:", (0, _colors.color_colors_decline), ";margin-right:0px;padding:0px;}", "");
exports.default = ErrorLabel;

},{"@emotion/react":"djZKr","@emotion/css":"awUBr","react":"6uln9","../../constants/colors":"1p3OR","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"eDZih":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _unstatedNext = require("unstated-next");
var _api = require("../api");
var _invalidResult = require("../models/result/InvalidResult");
var _invalidResultDefault = parcelHelpers.interopDefault(_invalidResult);
function useNlpContainer() {
    const [error, setError] = (0, _react.useState)("");
    const [loading, setLoading] = (0, _react.useState)(false);
    const runNlp = async (appId, appSecret, environmentId, text, modelId)=>{
        setLoading(true);
        var sessionTokenResult = await getSessionToken(appId, appSecret, environmentId, "cms-slot-filling");
        if (sessionTokenResult.resultType !== "Ok") {
            setLoading(false);
            return new (0, _invalidResultDefault.default)(sessionTokenResult.errors?.[0]);
        }
        setLoading(false);
        return await _api.processNlp(text, modelId, sessionTokenResult.data);
    };
    const getSessionToken = async (appId, appSecret, environmentId, sessionId)=>{
        const result = await _api.generateSessionToken(appId, appSecret, environmentId, sessionId);
        if (result.resultType === "Ok") return {
            data: result.data.token,
            resultType: "Ok",
            errors: null
        };
        else {
            setError(result.errors?.[0]);
            return new (0, _invalidResultDefault.default)(result.errors?.[0]);
        }
    };
    return {
        runNlp,
        loading,
        setLoading
    };
}
const NlpContainer = (0, _unstatedNext.createContainer)(useNlpContainer);
exports.default = NlpContainer;

},{"react":"6uln9","unstated-next":"61zE5","../api":"loxM6","../models/result/InvalidResult":"hpD5G","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"fdXHQ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _unstatedNext = require("unstated-next");
var _keys = require("../constants/Keys");
var _api = require("../api");
var _moment = require("moment");
var _momentDefault = parcelHelpers.interopDefault(_moment);
const TRAINING_TIMEOUT_MINUTES = 20;
function useNlpModelTrainingContainer() {
    const [indicator, setIndicator] = (0, _react.useState)(null);
    const [currentApp, setCurrentApp] = (0, _react.useState)(null);
    const [isPolling, setIsPolling] = (0, _react.useState)(false);
    const [pollingTrigger, setPollingTrigger] = (0, _react.useState)(0);
    (0, _react.useEffect)(()=>{
        if (isPolling) pollForNlpModelTrain();
    }, [
        isPolling,
        pollingTrigger
    ]);
    (0, _react.useEffect)(()=>{
        if (!currentApp?.id) setIsPolling(false);
    }, [
        currentApp
    ]);
    const pollForNlpModelTrain = async ()=>{
        // wait 4 seconds first.
        var appResult = await loadAssistantApplication(currentApp?.id);
        if (appResult.resultType != "Ok") setErrorIndicator();
        const app = appResult.data;
        let storedState = getStoredState();
        let currentAppState = storedState.find((s)=>s.applicationId == app.id);
        if (!currentAppState) setIsPolling(false);
        else {
            const idx = storedState.indexOf(currentAppState);
            storedState.splice(idx, 1);
        }
        const newAppNlpModelId = getNlpModelId(app);
        if (newAppNlpModelId && currentAppState.latestNlpModelId !== newAppNlpModelId) {
            setSuccessIndicator();
            setIsPolling(false);
            currentAppState.isCurrentlyTraining = false;
        } else if ((0, _momentDefault.default)().diff(currentAppState.lastTrainingStart, "minutes") > TRAINING_TIMEOUT_MINUTES // timed out
         || currentAppState.latestNlpModelId && !newAppNlpModelId // removed nlp
        ) {
            setErrorIndicator();
            setIsPolling(false);
            currentAppState.isCurrentlyTraining = false;
        } else {
            await new Promise((r)=>setTimeout(r, 4000));
            setPollingTrigger(pollingTrigger + 1);
        }
        storedState.push(currentAppState);
        storeState(storedState);
        setCurrentApp(app);
    };
    const setNewApplication = async (app)=>{
        if (app?.id && app?.id !== currentApp?.id) {
            setCurrentApp(app);
            let storedState = getStoredState();
            let currentAppState = storedState.find((s)=>s.applicationId == app.id);
            if (currentAppState) {
                const idx = storedState.indexOf(currentAppState);
                storedState.splice(idx, 1);
            } else currentAppState = {
                applicationId: app.id,
                isCurrentlyTraining: false,
                latestNlpModelId: getNlpModelId(app)
            };
            if (currentAppState.isCurrentlyTraining) {
                if (currentAppState.latestNlpModelId !== getNlpModelId(app)) {
                    currentAppState.isCurrentlyTraining = false;
                    setSuccessIndicator();
                    setIsPolling(false);
                } else if ((0, _momentDefault.default)().diff(currentAppState.lastTrainingStart, "minutes") > TRAINING_TIMEOUT_MINUTES) {
                    setErrorIndicator();
                    currentAppState.isCurrentlyTraining = false;
                    setIsPolling(false);
                } else {
                    setIsPolling(true);
                    setBuildingIndicator();
                    storedState.push(currentAppState);
                    storeState(storedState);
                    await new Promise((r)=>setTimeout(r, 4000));
                    setPollingTrigger(pollingTrigger + 1);
                }
            } else {
                setIsPolling(false);
                clear();
            }
            if (!storedState.some((s)=>s.applicationId === currentAppState.applicationId)) {
                storedState.push(currentAppState);
                storeState(storedState);
            }
        }
    };
    const startPollingForTraining = async ()=>{
        let storedState = getStoredState();
        let currentAppState = storedState.find((s)=>s.applicationId == currentApp.id);
        if (currentAppState) {
            const idx = storedState.indexOf(currentAppState);
            storedState.splice(idx, 1);
        }
        currentAppState = {
            applicationId: currentApp.id,
            isCurrentlyTraining: true,
            latestNlpModelId: getNlpModelId(currentApp),
            lastTrainingStart: (0, _momentDefault.default)()
        };
        storedState.push(currentAppState);
        setBuildingIndicator();
        await new Promise((r)=>setTimeout(r, 4000));
        setIsPolling(true);
        setPollingTrigger(pollingTrigger + 1);
        storeState(storedState);
    };
    const setBuildingIndicator = ()=>{
        setIndicator({
            type: "building",
            message: "Your NLP Model is currently building"
        });
    };
    const queueTraining = async (appId)=>{
        await _api.queueDeployments(appId);
    };
    const setErrorIndicator = ()=>{
        setIndicator({
            type: "error",
            message: "Your NLP Model failed to build"
        });
    };
    const setSuccessIndicator = ()=>{
        setIndicator({
            type: "success",
            message: "Your NLP Model has been built successfully"
        });
    };
    // we use the most recent default lang production environment nlp model id
    const getNlpModelId = (app)=>{
        const env = app.environments?.find((e)=>e.name === "Production");
        var lang = env?.languages?.find((l)=>l.languageId === app.defaultLanguageId);
        if (lang) return lang.nlpModelId;
        return env?.nlpModelId;
    };
    const getStoredState = ()=>{
        let storedState = [];
        const storedTrainingState = localStorage.getItem((0, _keys.VOICIFY_NLP_MODEL_TRAINING_STATE));
        if (storedTrainingState) storedState = JSON.parse(storedTrainingState);
        return storedState;
    };
    const storeState = (state)=>{
        const json = JSON.stringify(state);
        localStorage.setItem((0, _keys.VOICIFY_NLP_MODEL_TRAINING_STATE), json);
    };
    const loadAssistantApplication = async (applicationId)=>{
        try {
            var result = await _api.getAssistantApplication(applicationId);
            setCurrentApp(result.data);
            return result;
        } catch (e) {
            console.log(e);
        }
    };
    const clear = ()=>{
        setIndicator(null);
    };
    return {
        indicator,
        currentApp,
        clear,
        setNewApplication,
        startPollingForTraining,
        loadAssistantApplication,
        queueTraining
    };
}
const NlpModelTrainingContainer = (0, _unstatedNext.createContainer)(useNlpModelTrainingContainer);
exports.default = NlpModelTrainingContainer;

},{"react":"6uln9","unstated-next":"61zE5","../constants/Keys":"4iC9Z","../api":"loxM6","moment":"2meyw","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"ilaog":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _defineProperty = require("@babel/runtime/helpers/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _button = require("../../../components/general/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _css = require("@emotion/css");
var _lodash = require("lodash");
var _lodashDefault = parcelHelpers.interopDefault(_lodash);
var _toggleIndicator = require("../../../components/general/ToggleIndicator");
var _toggleIndicatorDefault = parcelHelpers.interopDefault(_toggleIndicator);
var _colors = require("../../../constants/colors");
var _slotsEditorModal = require("./SlotsEditorModal");
var _slotsEditorModalDefault = parcelHelpers.interopDefault(_slotsEditorModal);
var _slotSelector = require("./slotSelector");
var _slotSelectorDefault = parcelHelpers.interopDefault(_slotSelector);
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
class InteractionModelInput extends (0, _reactDefault.default).Component {
    constructor(...args){
        super(...args);
        (0, _definePropertyDefault.default)(this, "textInput", /*#__PURE__*/ (0, _reactDefault.default).createRef());
    }
    componentWillMount() {
        this.setState({
            validationErrors: [],
            slotsStyled: [],
            insertingSlot: false,
            isSlotsEditorModalOpen: false
        });
    }
    componentDidMount() {
        this.textInput?.current?.focus();
    }
    handleAddUtterance() {
        let text = this.textInput.current.innerText.replace(/\u200b/g, "");
        // replace any extra spaces with a single space
        text = text.replace(/\s\s+/g, " ");
        const validationErrors = this.props.validateUtterance(text);
        if (validationErrors.length > 0) this.detectSlots(true);
        else {
            this.props.addUtterance(text, this.props.languages);
            this.textInput.current.innerHTML = "";
            this.props.setError([]);
            this.setState({
                ...this.state,
                slotsStyled: [],
                insertingSlot: false
            });
        }
    }
    preventLineBreak(e) {
        if (e.which && e.which == 13 || e.keyCode && e.keyCode == 13) e.preventDefault();
    }
    handleInputChange(e) {
        var divElement = e.target;
        this.handleSlotChanged(divElement, e.keyCode == 8);
        if (e.key === "Enter") this.handleEnter();
    }
    async detectSlots(reValidate = false) {
        this.textInput.current.innerText = this.textInput.current.innerText.replace(/\s\s+/g, " ");
        const result = await this.props.detectSlots(this.textInput.current.innerText);
        if (result?.length) this.textInput.current.innerText = result;
        if (reValidate) {
            const validationErrors = this.props.validateUtterance(result);
            if (validationErrors?.length) this.props.setError(validationErrors);
        }
        return result;
    }
    async handleEnter() {
        const currentText = `${this.textInput.current.innerText}`;
        // drop multiple spaces to one space
        let text = this.textInput.current.innerText.replace(/\s\s+/g, " ");
        const result = await this.props.detectSlots(text);
        if (result?.length && currentText !== result) this.textInput.current.innerText = result;
        else this.handleAddUtterance();
    }
    handleSlotChanged(e, backspacing = false, splitChildAtIndex) {
        var slotsExtracted = this.props.extractSlots(e.innerText);
        var slots = slotsExtracted.map((s)=>s.fullText);
        var newSlot = (0, _lodashDefault.default).difference(slots, this.state.slotsStyled);
        var deletedSlot = (0, _lodashDefault.default).difference(this.state.slotsStyled, slots);
        var openBracketCount = this.textInput.current.textContent.match(/\{/g) ? this.textInput.current.textContent.match(/\{/g).length : 0;
        var closedBracketCount = this.textInput.current.textContent.match(/\}/g) ? this.textInput.current.textContent.match(/\}/g).length : 0;
        var inequalBracketCount = openBracketCount != closedBracketCount;
        if (!inequalBracketCount && (newSlot.length > 0 || deletedSlot.length > 0)) {
            var html = e.innerText;
            slots.map((s)=>{
                html = html.replace(`${s}`, `<span contenteditable=false style="background-color:${(0, _colors.color_shades_lighter)}">${s}</span>`);
            });
            e.innerHTML = html;
            var childNodes = Array.from(this.textInput.current.childNodes);
            var sel = document.getSelection();
            if (splitChildAtIndex >= 0 && childNodes.length >= splitChildAtIndex + 2) {
                var targetNode = childNodes[splitChildAtIndex + 2];
                if (targetNode.nodeType != 3) sel.collapse(this.textInput.current, splitChildAtIndex + 2);
                else sel.collapse(targetNode, 0);
            } else if (backspacing) {
                var priorChildIndex;
                var priorChildText;
                if (deletedSlot.length > 0) this.state.previousChildren.forEach((n, i)=>{
                    if (n == deletedSlot[0]) {
                        priorChildIndex = i - 1;
                        priorChildText = this.state.previousChildren[priorChildIndex];
                        if (priorChildIndex == -1) sel.collapse(this.textInput.current, 0);
                        else if (i == this.state.previousChildren.length - 1) {
                            if (priorChildText.indexOf("{") >= 0) sel.collapse(this.textInput.current, childNodes.length);
                            else {
                                var targetNode = childNodes[priorChildIndex];
                                sel.collapse(targetNode, priorChildText.length);
                            }
                        } else if (priorChildText.indexOf("{") >= 0) {
                            var targetNode = childNodes[priorChildIndex + 1];
                            targetNode.textContent.indexOf("{") >= 0 ? sel.collapse(this.textInput.current, priorChildIndex + 1) : sel.collapse(targetNode, 0);
                        } else {
                            var targetNode = childNodes[priorChildIndex];
                            sel.collapse(targetNode, priorChildText.length);
                        }
                    }
                });
            } else {
                var nextChildIndex;
                var nextChildText; //Refactor to accept isBlockNode() function that checks text node vs styled node
                if (newSlot.length >= 1) childNodes.forEach((n, i)=>{
                    if (n.textContent == newSlot[newSlot.length - 1]) {
                        nextChildIndex = i + 1;
                        if (nextChildIndex >= childNodes.length) sel.collapse(this.textInput.current, childNodes.length);
                        else {
                            nextChildText = childNodes[i + 1].textContent;
                            if (nextChildText.indexOf("{") >= 0) sel.collapse(this.textInput.current, i + 1);
                            else sel.collapse(childNodes[i + 1], 0);
                        }
                    }
                });
                else if (deletedSlot.length >= 1) this.state.previousChildren.forEach((n, i)=>{
                    if (n == deletedSlot[deletedSlot.length - 1]) {
                        nextChildIndex = i;
                        if (i == childNodes.length) {
                            var targetNode = childNodes[i - 1];
                            if (targetNode == null || targetNode.textContent.indexOf("{") >= 0) sel.collapse(this.textInput.current, childNodes.length);
                            else sel.collapse(targetNode, this.state.previousChildren[i - 1].length);
                        } else {
                            nextChildText = childNodes[i].textContent;
                            if (nextChildText.indexOf("{") >= 0) {
                                var targetNode = childNodes[i - 1];
                                targetNode ? sel.collapse(targetNode, this.state.previousChildren[i - 1].length) : sel.collapse(this.textInput.current, i);
                            } else sel.collapse(childNodes[i], 0);
                        }
                    }
                });
            }
            this.setState({
                ...this.state,
                slotsStyled: slots,
                previousChildren: Array.from(childNodes).map((n)=>n.textContent)
            });
        } else this.setState({
            ...this.state,
            previousChildren: Array.from(this.textInput.current.childNodes).map((n)=>n.textContent)
        });
    }
    toggleInsertSlot() {
        this.setState({
            ...this.state,
            insertingSlot: !this.state.insertingSlot
        });
    }
    toggleSlotsEditorModal() {
        this.setState({
            ...this.state,
            isSlotsEditorModalOpen: !this.state.isSlotsEditorModalOpen
        });
    }
    addSlot(slot) {
        const childNodes = this.textInput.current.childNodes;
        let indexOfCaret = 0;
        let foundSameNode = false;
        let splitChildAtIndex;
        const isTextNode = this.state.selectionNode.nodeType == 3;
        childNodes.forEach((node, key)=>{
            if (!foundSameNode) {
                let isSameNode = isTextNode ? this.state.selectionNode.isSameNode(node) : key == this.state.anchorOffset;
                if (isSameNode) {
                    if (isTextNode) indexOfCaret += this.state.anchorOffset;
                    foundSameNode = true;
                    if (key != childNodes.length - 1) {
                        if (isTextNode) splitChildAtIndex = key;
                        else splitChildAtIndex = key - 1;
                    }
                } else indexOfCaret += node.textContent.length;
            }
        });
        var start = this.textInput.current.innerText.slice(0, indexOfCaret);
        var end = this.textInput.current.innerText.slice(indexOfCaret);
        this.textInput.current.innerText = `${start}{${slot.name}}${end}`;
        this.handleSlotChanged(this.textInput.current, false, splitChildAtIndex);
    }
    storeCursorPosition() {
        var sel = window.getSelection();
        this.setState({
            ...this.state,
            selectionNode: sel.anchorNode,
            anchorOffset: sel.anchorOffset
        });
    }
    handleIntentSlotsEdits(formData) {
        const updatedSlots = formData.intent.slots;
        this.props.updateSlots(updatedSlots);
        this.toggleSlotsEditorModal();
    }
    render() {
        const intent = this.props.intent;
        const availableSlots = intent?.slots?.filter((s)=>!s.isDeleted);
        return (0, _react.jsx)("div", {
            className: interactionModelInput
        }, (0, _react.jsx)("div", {
            className: inputArea
        }, (0, _react.jsx)("div", {
            className: labels
        }, (0, _react.jsx)("div", null, "Add a new phrase"), (0, _react.jsx)("div", {
            className: "slots-actions-container"
        }, (!intent?.name || !intent.name.hasOwnProperty("voicify") || intent.name["voicify"] !== "GeneralQuestion" && intent.name["voicify"] !== "WhatsNew") && (0, _react.jsx)("div", {
            className: "slot-menu-label right-border",
            onClick: this.toggleSlotsEditorModal.bind(this)
        }, "Manage Slots"), (0, _react.jsx)("div", {
            className: "slot-menu-label",
            onClick: this.toggleInsertSlot.bind(this)
        }, "Insert a Slot"), (0, _react.jsx)((0, _toggleIndicatorDefault.default), {
            className: "toggle-indicator",
            direction: this.state.insertingSlot ? "up" : "down"
        })), (0, _react.jsx)((0, _slotSelectorDefault.default), {
            addSlot: this.addSlot.bind(this),
            availableSlots: availableSlots,
            usedSlots: this.state.slotsStyled,
            hidden: !this.state.insertingSlot
        })), (0, _react.jsx)("div", {
            contentEditable: true,
            onBlur: this.storeCursorPosition.bind(this),
            className: input,
            ref: this.textInput,
            onKeyPress: this.preventLineBreak.bind(this),
            onKeyUp: this.handleInputChange.bind(this)
        })), (0, _react.jsx)((0, _buttonDefault.default), {
            className: "add-phrase-button",
            themes: [
                "primary-small"
            ],
            type: "button",
            loading: this.props.isLoading,
            onClick: this.detectSlots.bind(this),
            text: "Detect Slots"
        }), (0, _react.jsx)((0, _buttonDefault.default), {
            className: "add-phrase-button",
            themes: [
                "primary-small"
            ],
            type: "button",
            loading: this.props.isLoading,
            onClick: this.handleAddUtterance.bind(this),
            text: "Add Phrase"
        }), this.state.isSlotsEditorModalOpen && (0, _react.jsx)((0, _slotsEditorModalDefault.default), {
            languages: this.props.languages,
            isLoading: this.props.isLoading,
            applicationId: this.props.applicationId,
            handleClose: this.toggleSlotsEditorModal.bind(this),
            handleIntentSlotsEdits: this.handleIntentSlotsEdits.bind(this),
            intent: intent,
            nlpEntities: this.props.nlpEntities
        }));
    }
}
exports.default = InteractionModelInput;
const interactionModelInput = /*#__PURE__*/ (0, _css.css)("height:100px;padding:30px;padding-bottom:40px;background-color:white;font-size:14px;color:", (0, _colors.color_text_default), ";border:solid 1px ", (0, _colors.color_shades_dark), ";border-top-left-radius:5px;border-top-right-radius:5px;border-bottom:0px;margin:30px;margin-top:0px;margin-bottom:0px;display:flex;flex-direction:row;align-items:center;position:relative;z-index:2;.add-phrase-button{margin-top:40px;}.slots-actions-container{display:flex;align-items:center;.slot-menu-label{font-family:Muli;font-size:14px;font-weight:normal;font-stretch:normal;font-style:normal;line-height:normal;letter-spacing:normal;color:", (0, _colors.ocean_blue), ";cursor:pointer;margin-right:4px;}.right-border{padding-right:4px;border-right:1px solid gray;}.toggle-indicator{border-left:solid 1px ", (0, _colors.ocean_blue), ";border-top:solid 1px ", (0, _colors.ocean_blue), ";}}", "");
const inputArea = /*#__PURE__*/ (0, _css.css)({
    name: "e3ziuo",
    styles: "display:flex;flex-direction:column;flex:1 500px;flex-basis:500px;>input{border-radius:5px;height:45px;}"
});
const labels = /*#__PURE__*/ (0, _css.css)({
    name: "1b5kkxk",
    styles: "display:flex;flex-direction:row;justify-content:space-between;position:relative;z-index:1;margin-bottom:6px"
});
const input = /*#__PURE__*/ (0, _css.css)({
    name: "196id07",
    styles: "background-color:white;width:97%;border-radius:5px;border:solid 1px #cccccc;padding:12px;height:40px;margin-top:8px"
});

},{"@babel/runtime/helpers/defineProperty":"9sJxO","@emotion/react":"djZKr","react":"6uln9","../../../components/general/Button":"6ymxN","@emotion/css":"awUBr","lodash":"3hMBK","../../../components/general/ToggleIndicator":"4eej1","../../../constants/colors":"1p3OR","./SlotsEditorModal":"buz6P","./slotSelector":"7E3J3","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"buz6P":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _modalLayout = require("../../../components/structure/ModalLayout");
var _modalLayoutDefault = parcelHelpers.interopDefault(_modalLayout);
var _slotsEditorForm = require("./SlotsEditorForm");
var _slotsEditorFormDefault = parcelHelpers.interopDefault(_slotsEditorForm);
const SlotsEditorModal = (props)=>{
    return (0, _react.jsx)((0, _modalLayoutDefault.default), {
        zIndex: 1010,
        isVisible: true,
        onClose: ()=>props.handleClose()
    }, (0, _react.jsx)((0, _slotsEditorFormDefault.default), {
        isLoading: props.isLoading,
        applicationId: props.applicationId,
        languages: props.languages,
        nlpEntities: props.nlpEntities,
        intent: props.intent,
        onSubmit: props.handleIntentSlotsEdits,
        handleCloseModal: props.handleClose,
        initialValues: {
            nlpEntities: props.nlpEntities,
            intent: props.intent
        }
    }));
};
exports.default = SlotsEditorModal;

},{"@emotion/react":"djZKr","react":"6uln9","../../../components/structure/ModalLayout":"b1cO3","./SlotsEditorForm":"31ZIV","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"31ZIV":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _formik = require("formik");
var _yup = require("yup");
var _slotsEditor = require("./SlotsEditor");
var _slotsEditorDefault = parcelHelpers.interopDefault(_slotsEditor);
var _lodash = require("lodash");
var _lodashDefault = parcelHelpers.interopDefault(_lodash);
const maxSlotNameSize = 50;
// Wrap our form with the withFormik HoC
const SlotsEditorForm = (0, _formik.withFormik)({
    displayName: "SlotsEditorForm",
    validateOnChange: true,
    validateOnBlur: true,
    validateOnMount: true,
    isInitialValid: false,
    enableReinitialize: true,
    validationSchema: _yup.object().shape({
        intent: _yup.object().shape({
            slots: _yup.array().of(_yup.object().shape({
                isDeleted: _yup.boolean(),
                name: _yup.string().when("isDeleted", {
                    is: false,
                    then: _yup.string().required("Validation: Slot name is required").max(maxSlotNameSize, `Validation: Slot name must not exceed ${maxSlotNameSize} characters`)
                }),
                entityName: _yup.string().when("isDeleted", {
                    is: false,
                    then: _yup.string().required("Validation: Slot NLP entity selection is required")
                })
            }))
        })
    }),
    // Transform outer props into form values
    mapPropsToValues: (props)=>{
        // Filter for selected locales 
        const formEntities = mapNlpEntities(props.nlpEntities, props.languages);
        // Order slots by name
        const slotsOrdered = (0, _lodashDefault.default).orderBy(props.intent?.slots ?? [], (s)=>s.name, "asc");
        const formIntent = {
            ...props.intent,
            slots: slotsOrdered
        };
        const values = {
            nlpEntities: formEntities,
            intent: formIntent
        };
        return values;
    },
    // Add a custom validation function (this can be async)
    validate: (values, props)=>{
        const errors = validateSlotsFormFields(values);
        // Returned errors object must be empty for validation to succeed
        return errors;
    },
    /** Form submit handler https://formik.org/docs/guides/form-submission */ handleSubmit: async (values, { props, setSubmitting })=>{
        await props.onSubmit(values);
        setSubmitting(false);
    }
})((0, _slotsEditorDefault.default));
const mapNlpEntities = (nlpEntities, languages)=>{
    // Filter for selected locales 
    const formEntities = nlpEntities?.filter((nlpEntity)=>{
        return languages?.map((lang)=>lang.shortCode)?.some((locale)=>nlpEntity.locales?.includes(locale));
    })?.map((e)=>{
        // We do not need to carry NLP Entity values for either slot validation or management display to pick an entity
        const formEntity = {
            ...e,
            values: []
        };
        return formEntity;
    });
    return formEntities;
};
const validateSlotsFormFields = (values)=>{
    let errors = {};
    let slotsErrorsArray = [];
    const entities = values.nlpEntities?.filter((e)=>!e.isDeleted);
    for(let slotIdx = 0; slotIdx < values.intent?.slots?.length; slotIdx++){
        const editableSlot = values.intent?.slots[slotIdx];
        // Initialize null error for correct Form values array index
        slotsErrorsArray.push(null); // must be == slotIdx
        if (editableSlot.isDeleted) continue;
        // Check if non deleted slot has issue
        const entityName = editableSlot.entityName;
        const found = entities?.find((e)=>e.name == entityName);
        // Display error indicator on intent and slot items if slot is using deleted NLP Entity
        if (entityName && !found) {
            const nlpEntityError = `NLP entity "${entityName}" not found or not applicable to selected language(s) `;
            // Form's field's "entityName" error will show up in FieldError
            slotsErrorsArray[slotIdx] = {
                entityName: nlpEntityError
            };
            errors = {
                intent: {
                    slots: slotsErrorsArray
                }
            };
        }
        // What about slot's entities existing in intent locales?
        const localeEntities = getNlpEntitiesInLocales(entities, values.intent?.locales?.map((l)=>l.shortCode));
        const slotEntityFoundInAllLocales = localeEntities?.find((e)=>e.name == entityName);
        if (entityName && !slotEntityFoundInAllLocales) {
            const nlpEntityError = `NLP entity "${entityName}" does not have intent language(s) selected `;
            // Form's field's "entityName" error will show up in FieldError
            slotsErrorsArray[slotIdx] = {
                entityName: nlpEntityError
            };
            errors = {
                intent: {
                    slots: slotsErrorsArray
                }
            };
        }
        if (values.intent?.slots?.filter((slot, idx)=>idx != slotIdx && !slot.isDeleted && slot.name.trim().toLowerCase() == editableSlot.name?.trim().toLowerCase())?.length > 0) {
            const slotNameError = `Duplicate slot name "${editableSlot.name}" `;
            // Form's field's "name" error will show up in FieldError
            if (slotsErrorsArray[slotIdx]) slotsErrorsArray[slotIdx] = {
                ...slotsErrorsArray[slotIdx],
                name: slotNameError
            };
            else slotsErrorsArray[slotIdx] = {
                name: slotNameError
            };
            errors = {
                intent: {
                    slots: slotsErrorsArray
                }
            };
        }
    }
    return errors;
};
const getNlpEntitiesInLocales = (nlpEntities, locales)=>{
    // Filter for selected locales 
    const formEntities = nlpEntities?.filter((nlpEntity)=>locales.every((shortCode)=>nlpEntity.locales.includes(shortCode)));
    return formEntities;
};
exports.default = SlotsEditorForm;

},{"formik":"3YnOK","yup":"j2SJU","./SlotsEditor":"84ufV","lodash":"3hMBK","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"84ufV":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "INTENT_FORM_PREFIX", ()=>INTENT_FORM_PREFIX);
parcelHelpers.export(exports, "maxSlotNameDisplaySize", ()=>maxSlotNameDisplaySize);
var _extends = require("@babel/runtime/helpers/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _base = require("@emotion/styled/base");
var _baseDefault = parcelHelpers.interopDefault(_base);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _slotCard = require("./SlotCard");
var _slotCardDefault = parcelHelpers.interopDefault(_slotCard);
var _colors = require("../../../constants/colors");
var _css = require("@emotion/css");
var _loader = require("../../../components/general/Loader");
var _loaderDefault = parcelHelpers.interopDefault(_loader);
var _button = require("../../../components/general/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _horizontalSeparator = require("../../../components/structure/HorizontalSeparator");
var _horizontalSeparatorDefault = parcelHelpers.interopDefault(_horizontalSeparator);
var _formik = require("formik");
var _slotItem = require("./SlotItem");
var _slotItemDefault = parcelHelpers.interopDefault(_slotItem);
var _pageError = require("../../../components/general/PageError");
var _pageErrorDefault = parcelHelpers.interopDefault(_pageError);
var _footerBar = require("../../../components/structure/FooterBar");
var _footerBarDefault = parcelHelpers.interopDefault(_footerBar);
var _customScrollbars = require("../../../components/structure/CustomScrollbars");
var _customScrollbarsDefault = parcelHelpers.interopDefault(_customScrollbars);
var _useWindowSize = require("../../../hooks/UseWindowSize");
var _useWindowSizeDefault = parcelHelpers.interopDefault(_useWindowSize);
var _modalHeader = require("../../../components/general/ModalHeader");
var _modalHeaderDefault = parcelHelpers.interopDefault(_modalHeader);
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const INTENT_FORM_PREFIX = "intent";
const maxSlotNameDisplaySize = 25;
const SlotsEditor = (props)=>{
    const windowSize = (0, _useWindowSizeDefault.default)();
    const { isValid, dirty } = props;
    const [activeItemIndex, setActiveItemIndex] = (0, _react1.useState)(-1);
    const [errorMessages, setErrorMessages] = (0, _react1.useState)([]);
    const [slotGroups, setSlotGroups] = (0, _react1.useState)([]);
    const intent = props.values.intent;
    const intentName = props.intent?.displayName;
    const enableSave = dirty && isValid;
    (0, _react1.useEffect)(function activateFirstNonDeletedItem() {
        if (intent?.slots?.length > 0) {
            //sort slots by disallowed slots first, required second, required slot groups third, then alphabetically
            intent?.slots?.sort((a, b)=>{
                if (a.disallowed && !b.disallowed) return -1;
                if (!a.disallowed && b.disallowed) return 1;
                if (a.required && !b.required) return -1;
                if (!a.required && b.required) return 1;
                if (a.requiredSlotGroupIds?.length && !b.requiredSlotGroupIds?.length) return -1;
                if (!a.requiredSlotGroupIds?.length && b.requiredSlotGroupIds?.length) return 1;
                if (a.requiredSlotGroupIds?.length || b.requiredSlotGroupIds?.length) return a.requiredSlotGroupIds[0].localeCompare(b.requiredSlotGroupIds[0]);
                else return a.name.localeCompare(b.name);
            });
            const index = intent?.slots?.findIndex((s)=>!s.isDeleted);
            if (index >= 0) toggleItemActivationByIndex(index);
        }
    }, []);
    (0, _react1.useEffect)(()=>{
        const newSlotGroups = [];
        if (intent?.slots?.length > 0) {
            intent?.slots?.forEach((slot)=>{
                slot?.requiredSlotGroupIds?.forEach((groupId)=>{
                    if (groupId?.length && !newSlotGroups.includes(groupId)) newSlotGroups.push(groupId);
                });
            });
            // order new slot groups alphabetically 
            newSlotGroups.sort((a, b)=>a.localeCompare(b));
            setSlotGroups(newSlotGroups);
        } else setSlotGroups([]);
    }, [
        intent,
        intent?.slots
    ]);
    const toggleItemActivationByIndex = (index)=>{
        setActiveItemIndex(index);
    };
    const onSubmitIntentSlotsUpdate = ()=>{
        props.validateForm();
        props.submitForm();
    };
    const addSlot = ()=>{
        let newEditableSlot = {
            name: "New",
            required: false,
            isOriginal: false,
            isAdded: true,
            isDeleted: false,
            isModified: true,
            originalName: "",
            entityName: ""
        };
        const idx = intent?.slots?.length ?? 0;
        const fieldName = `${INTENT_FORM_PREFIX}.slots.${idx}`;
        props.setFieldValue(fieldName, newEditableSlot);
        toggleItemActivationByIndex(idx);
    };
    const slot = intent?.slots?.[activeItemIndex];
    const renderSlotMenuItem = (slot, index, arrayHelpers)=>{
        const isActive = index === activeItemIndex;
        // Do not display deleted slots
        return !slot.isDeleted && (0, _react.jsx)((0, _slotItemDefault.default), (0, _extendsDefault.default)({}, props, {
            toggleItemActivationByIndex: toggleItemActivationByIndex,
            applicationId: props.applicationId,
            nlpEntities: props.values.nlpEntities,
            intent: intent,
            slot: slot,
            isActive: isActive,
            key: index,
            formPrefix: INTENT_FORM_PREFIX,
            formIndex: index
        }));
    };
    const renderSlotItemsList = ()=>{
        if (!intent.slots?.length) return (0, _react.jsx)(LeftEmptyView, null, "Add a slot to extract entities for this intent");
        return (0, _react.jsx)((0, _customScrollbarsDefault.default), {
            autoHide: true,
            autoHeight: true,
            autoHeightMax: windowSize.windowSize.innerHeight * .9 - 250
        }, (0, _react.jsx)(SlotItemsListWrapper, null, // Newly added slots on the top
        //Sort slots by required slot group
        intent?.slots?.some((v)=>v.isAdded) && (0, _react.jsx)((0, _formik.FieldArray), {
            validateOnChange: true,
            name: `${INTENT_FORM_PREFIX}.slots`,
            render: (arrayHelpers)=>intent.slots?.map((slot, index)=>{
                    if (!slot.isAdded) return null;
                    return renderSlotMenuItem(slot, index, arrayHelpers);
                })
        }), (0, _react.jsx)((0, _formik.FieldArray), {
            validateOnChange: true,
            name: `${INTENT_FORM_PREFIX}.slots`,
            render: (arrayHelpers)=>intent.slots?.map((slot, index)=>{
                    if (slot.isAdded) return null;
                    return renderSlotMenuItem(slot, index, arrayHelpers);
                })
        })));
    };
    return (0, _react.jsx)(SlotsEditorWrapper, null, (0, _react.jsx)((0, _modalHeaderDefault.default), {
        title: `Slots for ${intentName}`,
        onClose: ()=>props.handleCloseModal(),
        className: modalHeaderStyle
    }), (0, _react.jsx)((0, _horizontalSeparatorDefault.default), null), props.isLoading ? (0, _react.jsx)((0, _loaderDefault.default), {
        className: customLoaderStyle
    }) : (0, _react.jsx)((0, _reactDefault.default).Fragment, null, (0, _react.jsx)(ModalContentWrapper, null, (0, _react.jsx)(SlotListWrapper, null, (0, _react.jsx)(SlotListHeader, null, (0, _react.jsx)("div", null, "Slots"), (0, _react.jsx)((0, _buttonDefault.default), {
        themes: [
            "primary-small",
            "start"
        ],
        disabled: props.isLoading,
        loading: props.isLoading,
        onClick: addSlot,
        text: "Add a Slot"
    })), (0, _react.jsx)((0, _horizontalSeparatorDefault.default), null), renderSlotItemsList()), (0, _react.jsx)(SlotEditWrapper, null, slot && !slot?.isDeleted ? (0, _react.jsx)((0, _slotCardDefault.default), (0, _extendsDefault.default)({}, props, {
        applicationId: props.applicationId,
        nlpEntities: props.values.nlpEntities,
        intent: intent,
        slot: slot,
        key: activeItemIndex,
        allSlotGroups: slotGroups,
        formPrefix: INTENT_FORM_PREFIX,
        formIndex: activeItemIndex
    })) : (0, _react.jsx)(EmptyView, null, "Select a Slot to see more details and manage values")))), (0, _react.jsx)((0, _pageErrorDefault.default), {
        errors: [
            ...errorMessages ?? []
        ],
        onClear: ()=>{
            setErrorMessages([]);
        }
    }), (0, _react.jsx)(CustomFooter, {
        usedInModal: true
    }, (0, _react.jsx)(SubmitButton, {
        type: "button",
        themes: [
            "primary"
        ],
        text: "Apply Changes",
        onClick: ()=>onSubmitIntentSlotsUpdate(),
        disabled: props.isLoading || !enableSave,
        loading: props.isLoading
    }), (0, _react.jsx)((0, _buttonDefault.default), {
        type: "button",
        themes: [
            "secondary"
        ],
        text: "Cancel",
        onClick: ()=>props.handleCloseModal(),
        disabled: props.isLoading,
        loading: props.isLoading
    })));
};
exports.default = SlotsEditor;
const SlotItemsListWrapper = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "eyznx729"
})({
    name: "1jl8o5k",
    styles: "margin:32px 32px 0 32px"
});
const ModalContentWrapper = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "eyznx728"
})({
    name: "bwwyqj",
    styles: "display:flex;width:100%;height:calc(100vh - 160px)"
});
const modalHeaderStyle = /*#__PURE__*/ (0, _css.css)({
    name: "pvlw48",
    styles: "width:100%;border-bottom:none"
});
const SlotsEditorWrapper = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "eyznx727"
})({
    name: "1fttcpj",
    styles: "display:flex;flex-direction:column"
});
const SlotListWrapper = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "eyznx726"
})({
    name: "82a6rk",
    styles: "flex:1"
});
const SlotListHeader = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "eyznx725"
})({
    name: "kipgul",
    styles: "button{margin:0 16px 16px 0;}display:flex;justify-content:space-between;margin:16px 32px 0 32px"
});
const SlotEditWrapper = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "eyznx724"
})("flex:1;border-left:1px solid ", (0, _colors.color_shades_dark), ";");
const customLoaderStyle = /*#__PURE__*/ (0, _css.css)({
    name: "1pp2wda",
    styles: "position:relative;top:auto;margin-top:30px;margin-bottom:30px"
});
const CustomFooter = /*#__PURE__*/ (0, _baseDefault.default)((0, _footerBarDefault.default), {
    target: "eyznx723"
})({
    name: "1q0eusf",
    styles: "z-index:auto"
});
const SubmitButton = /*#__PURE__*/ (0, _baseDefault.default)((0, _buttonDefault.default), {
    target: "eyznx722"
})({
    name: "1tx1l5v",
    styles: "margin-right:auto"
});
const EmptyView = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "eyznx721"
})("background:white;border:1px solid ", (0, _colors.color_shades_dark), ";border-radius:8px;color:", (0, _colors.color_shades_dark), ";padding:24px;margin:32px;");
const LeftEmptyView = /*#__PURE__*/ (0, _baseDefault.default)(EmptyView, {
    target: "eyznx720"
})({
    name: "18d63h3",
    styles: "margin:32px"
});

},{"@babel/runtime/helpers/extends":"4iKIP","@emotion/styled/base":"lSuFu","@emotion/react":"djZKr","react":"6uln9","./SlotCard":"enORJ","../../../constants/colors":"1p3OR","@emotion/css":"awUBr","../../../components/general/Loader":"bnV5T","../../../components/general/Button":"6ymxN","../../../components/structure/HorizontalSeparator":"Pw3HQ","formik":"3YnOK","./SlotItem":"224im","../../../components/general/PageError":"ezFTm","../../../components/structure/FooterBar":"bibRL","../../../components/structure/CustomScrollbars":"50vFq","../../../hooks/UseWindowSize":"43j9z","../../../components/general/ModalHeader":"aUACx","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"enORJ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _base = require("@emotion/styled/base");
var _baseDefault = parcelHelpers.interopDefault(_base);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _button = require("../../../components/general/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _horizontalSeparator = require("../../../components/structure/HorizontalSeparator");
var _horizontalSeparatorDefault = parcelHelpers.interopDefault(_horizontalSeparator);
var _dirtyFormPrompt = require("../../formScenes/components/DirtyFormPrompt");
var _textField = require("../../../components/forms/TextField");
var _textFieldDefault = parcelHelpers.interopDefault(_textField);
var _css = require("@emotion/css");
var _switch = require("../../../components/forms/Switch");
var _switchDefault = parcelHelpers.interopDefault(_switch);
var _nlpEntitySelector = require("./NlpEntitySelector");
var _nlpEntitySelectorDefault = parcelHelpers.interopDefault(_nlpEntitySelector);
var _slotsEditor = require("./SlotsEditor");
var _colors = require("../../../constants/colors");
var _styledDropdown = require("../../applicationSettings/components/customAssistantConfigurations/StyledDropdown");
var _styledDropdownDefault = parcelHelpers.interopDefault(_styledDropdown);
var _customScrollbars = require("../../../components/structure/CustomScrollbars");
var _customScrollbarsDefault = parcelHelpers.interopDefault(_customScrollbars);
var _useWindowSize = require("../../../hooks/UseWindowSize");
var _useWindowSizeDefault = parcelHelpers.interopDefault(_useWindowSize);
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const deleteAvatar = require("cee348c65b260dc9");
const requiredSlotIcon = require("50aa71a4eb524512");
const requiredGroupIcon = require("e585dcd19dc1cacc");
const disallowedSlotIcon = require("a8a09ffcaf2155c5");
const SlotCard = (props)=>{
    const windowSize = (0, _useWindowSizeDefault.default)();
    const slotName = props.slot?.name;
    const slotDisplayName = "{ } " + (slotName?.trim().length > (0, _slotsEditor.maxSlotNameDisplaySize) ? slotName.trim().substring(0, (0, _slotsEditor.maxSlotNameDisplaySize)) + "..." : slotName);
    const cardPrefix = `${props.formPrefix}.slots.${props.formIndex}`;
    const nameField = `${cardPrefix}.name`;
    const requiredField = `${cardPrefix}.required`;
    const disallowedField = `${cardPrefix}.disallowed`;
    const requiredSlotGroupField = `${cardPrefix}.requiredSlotGroupIds`;
    const isModifiedField = `${cardPrefix}.isModified`;
    const nlpEntityNameField = `${cardPrefix}.entityName`;
    const selectedEntityName = props.slot?.entityName;
    const selectedEntityId = props.slot?.entityId;
    const entityNamesArray = props.nlpEntities?.map((e)=>e.name);
    const slotRequired = props.slot?.required;
    const slotDisallowed = props.slot?.disallowed;
    const slotHasRequiredSlotGroups = props.slot?.requiredSlotGroupIds?.length > 0;
    const selectedEntity = props.nlpEntities?.find((e)=>selectedEntityId ? e.id == selectedEntityId : e.name == selectedEntityName);
    const handleFieldChange = (fieldName, value)=>{
        props.setFieldValue(fieldName, value);
        props.setFieldValue(isModifiedField, true);
    };
    const handleAddRequiredSlotGroup = ()=>{
        const newGroups = [
            ...props.slot.requiredSlotGroupIds || []
        ];
        if (props.allSlotGroups?.length) newGroups.push(props.allSlotGroups[0]);
        else newGroups.push("Group 1");
        handleFieldChange(requiredSlotGroupField, newGroups);
    //scroll to the bottom of the container
    };
    const getNextGroupName = ()=>{
        let i = 1;
        while(props.allSlotGroups?.includes(`Group ${i}`))i++;
        return `Group ${i}`;
    };
    const handleAddGroupOption = (groupIndex)=>{
        const newGroups = [
            ...props.slot.requiredSlotGroupIds || []
        ];
        let newGroupName = getNextGroupName();
        newGroups[groupIndex] = newGroupName;
        handleFieldChange(requiredSlotGroupField, newGroups);
    };
    const deleteGroupId = (groupIndex)=>{
        const newGroups = [
            ...props.slot.requiredSlotGroupIds || []
        ];
        newGroups.splice(groupIndex, 1);
        handleFieldChange(requiredSlotGroupField, newGroups);
    };
    const handleEntitySelectorClick = (values)=>{
        if (values?.length) {
            const selectedOption = values[0];
            if (selectedOption === "__custom") ;
            else if (selectedOption === "__preBuilt") ;
            else if (entityNamesArray.includes(selectedOption)) {
                if (selectedOption === selectedEntityName) return;
                const optionEntity = props.nlpEntities?.find((e)=>e.name == selectedOption);
                if (optionEntity == null) return;
                handleFieldChange(nlpEntityNameField, optionEntity?.name);
            }
        }
    };
    const handleRequiredSlotGroupClick = (value, groupIndex)=>{
        if (value === "New Group") handleAddGroupOption(groupIndex);
        else {
            const newGroups = [
                ...props.slot.requiredSlotGroupIds || []
            ];
            newGroups[groupIndex] = value;
            handleFieldChange(requiredSlotGroupField, newGroups);
        }
    };
    const handleSlotNameKeyUp = (event)=>{
        event.stopPropagation();
        if (event.key === "Escape") ;
        else if (event.key === "Enter") props.validateForm();
    };
    return (0, _react.jsx)(SlotCardWrapper, null, (0, _react.jsx)(CardHeader, null, (0, _react.jsx)("div", null, "Properties for:"), (0, _react.jsx)(CustomButton, {
        themes: [
            "black-small"
        ],
        text: slotDisplayName,
        type: "button"
    })), (0, _react.jsx)((0, _dirtyFormPrompt.DirtyFormPrompt), {
        allowPrompt: props.status?.submitting != true
    }), (0, _react.jsx)((0, _horizontalSeparatorDefault.default), null), (0, _react.jsx)((0, _customScrollbarsDefault.default), {
        autoHide: true,
        autoHeight: true,
        autoHeightMax: windowSize.windowSize.innerHeight * .9 - 250
    }, (0, _react.jsx)(CardContentWrapper, null, (0, _react.jsx)(SectionHeaderWrapper, null, (0, _react.jsx)(SectionHeaderText, null, "DETAILS"), (0, _react.jsx)((0, _horizontalSeparatorDefault.default), null)), (0, _react.jsx)((0, _textFieldDefault.default), {
        className: textFieldStyle,
        useForm: true,
        name: nameField,
        disabled: false,
        required: true,
        placeholder: "Slot Name",
        value: props.slot?.name,
        label: "Name",
        onChange: (e)=>handleFieldChange(nameField, e?.target?.value),
        onBlur: props.handleBlur,
        autoFocus: true,
        onKeyPress: handleSlotNameKeyUp
    }), (0, _react.jsx)((0, _nlpEntitySelectorDefault.default), {
        fieldName: nlpEntityNameField,
        label: "Entity",
        selectedDisplayText: selectedEntityName || "Select an entity",
        handleChange: handleEntitySelectorClick,
        selected: selectedEntity,
        nlpEntities: props.nlpEntities,
        className: nlpEntitySelectorStyle
    }), (0, _react.jsx)("div", null, (0, _react.jsx)(SectionHeaderWrapper, null, (0, _react.jsx)(SectionHeaderText, null, "PERMISSION"), (0, _react.jsx)((0, _horizontalSeparatorDefault.default), null)), (0, _react.jsx)((0, _switchDefault.default), {
        icon: disallowedSlotIcon,
        disabled: slotRequired,
        name: disallowedField,
        detail: "If checked, this intent will not be hit if this slot is extracted.",
        checked: props.slot?.disallowed,
        onChange: (checked)=>handleFieldChange(disallowedField, checked),
        label: props.slot?.disallowed ? "Disallowed" : "Disallow",
        className: switchStyle
    })), (0, _react.jsx)(SectionHeaderWrapper, null, (0, _react.jsx)(SectionHeaderText, null, "REQUIREMENTS"), (0, _react.jsx)((0, _horizontalSeparatorDefault.default), null)), (0, _react.jsx)("div", null, (0, _react.jsx)((0, _switchDefault.default), {
        icon: requiredSlotIcon,
        disabled: slotDisallowed,
        detail: "If checked, this slot will be required in all of this intent's utterances.",
        className: switchStyle,
        name: requiredField,
        checked: props.slot?.required,
        onChange: (checked)=>handleFieldChange(requiredField, checked),
        label: props.slot?.required ? "Is Required" : "Make Required"
    })), !slotRequired && !slotDisallowed && slotHasRequiredSlotGroups && props.slot.requiredSlotGroupIds.map((groupId, index)=>{
        const availableOptions = props.allSlotGroups.map((groupId)=>{
            return {
                label: groupId,
                value: groupId
            };
        });
        availableOptions.push({
            value: "New Group",
            label: "New Group"
        });
        return (0, _react.jsx)((0, _reactDefault.default).Fragment, null, (0, _react.jsx)(LabelWrapper, null, (0, _react.jsx)(Label, null, "Required Slot Group"), (0, _react.jsx)(LabelIcon, {
            src: requiredGroupIcon
        })), (0, _react.jsx)(GroupDropdownContainer, null, (0, _react.jsx)(LabelAndDropdownContainer, null, (0, _react.jsx)(CustomDropdown, {
            handleOnChange: (fieldName, value)=>handleRequiredSlotGroupClick(value, index),
            fieldName: `requiredSlotGroup-${index}`,
            options: availableOptions,
            size: "medium",
            searchable: true,
            value: props.slot.requiredSlotGroupIds[index]
        })), (0, _react.jsx)(DeleteButton, {
            src: deleteAvatar,
            onClick: ()=>deleteGroupId(index)
        })));
    }), !slotRequired && !slotDisallowed && (0, _react.jsx)((0, _reactDefault.default).Fragment, null, (0, _react.jsx)(AddAnIntentText, {
        onClick: handleAddRequiredSlotGroup
    }, "+ Add to a required slot group")))));
};
exports.default = SlotCard;
const SectionHeaderWrapper = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "ess9uud14"
})({
    name: "n3vj0b",
    styles: "display:flex;align-items:center;margin:32px 0 24px 0"
});
const SectionHeaderText = /*#__PURE__*/ (0, _baseDefault.default)("h2", {
    target: "ess9uud13"
})("margin-right:8px;font-size:16px;color:", (0, _colors.color_shades_darkest), ";text-transform:uppercase;font-weight:400;white-space:nowrap;");
const CardContentWrapper = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "ess9uud12"
})({
    name: "12hu7w4",
    styles: "margin:16px 32px 16px 32px"
});
const nlpEntitySelectorStyle = /*#__PURE__*/ (0, _css.css)({
    name: "1wz5dts",
    styles: "min-width:inherit;.field-wrapper{label{font-family:Muli;font-size:14px;}}"
});
const CustomButton = /*#__PURE__*/ (0, _baseDefault.default)((0, _buttonDefault.default), {
    target: "ess9uud11"
})({
    name: "1q4vxyr",
    styles: "margin-left:8px"
});
const textFieldStyle = /*#__PURE__*/ (0, _css.css)({
    name: "14303nh",
    styles: "margin:16px 0;.field-container{height:44px;}"
});
const switchStyle = /*#__PURE__*/ (0, _css.css)({
    name: "1ezqht9",
    styles: "margin-top:16px;padding:0"
});
const GroupDropdownContainer = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "ess9uud10"
})({
    name: "15ucr6y",
    styles: "display:flex;flex-direction:row;width:100%;align-items:center;justify-content:center"
});
const LabelAndDropdownContainer = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "ess9uud9"
})({
    name: "1d3w5wq",
    styles: "width:100%"
});
const DeleteButton = /*#__PURE__*/ (0, _baseDefault.default)("img", {
    target: "ess9uud8"
})({
    name: "1lt3ojz",
    styles: "cursor:pointer;margin-left:16px;flex:0"
});
const SlotCardWrapper = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "ess9uud7"
})("");
const CardHeader = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "ess9uud6"
})({
    name: "1k91l61",
    styles: "display:flex;align-items:center;margin:0 32px"
});
const ClickableText = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "ess9uud5"
})("color:", (0, _colors.color_colors_ocean), ";font-size:12px;cursor:pointer;");
const AddAnIntentText = /*#__PURE__*/ (0, _baseDefault.default)(ClickableText, {
    target: "ess9uud4"
})({
    name: "1dlj1g1",
    styles: "font-size:14px;height:48px;margin-top:24px"
});
const CustomDropdown = /*#__PURE__*/ (0, _baseDefault.default)((0, _styledDropdownDefault.default), {
    target: "ess9uud3"
})({
    name: "1soh0gv",
    styles: "margin-top:4px"
});
const LabelWrapper = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "ess9uud2"
})({
    name: "1q9uhor",
    styles: "display:flex;flex-direction:row;margin:32px 0 8px 0;align-items:center"
});
const Label = /*#__PURE__*/ (0, _baseDefault.default)("p", {
    target: "ess9uud1"
})("font-weight:400;font-size:14px;color:", (0, _colors.color_shades_darkest), ";margin:0 0 4px 4px;");
const LabelIcon = /*#__PURE__*/ (0, _baseDefault.default)("img", {
    target: "ess9uud0"
})({
    name: "158icaa",
    styles: "margin-left:4px"
});

},{"@emotion/styled/base":"lSuFu","@emotion/react":"djZKr","react":"6uln9","../../../components/general/Button":"6ymxN","../../../components/structure/HorizontalSeparator":"Pw3HQ","../../formScenes/components/DirtyFormPrompt":"i9WDI","../../../components/forms/TextField":"7a7bh","@emotion/css":"awUBr","../../../components/forms/Switch":"8kkL9","./NlpEntitySelector":"2cpLN","./SlotsEditor":"84ufV","../../../constants/colors":"1p3OR","../../applicationSettings/components/customAssistantConfigurations/StyledDropdown":"hjrMo","../../../components/structure/CustomScrollbars":"50vFq","../../../hooks/UseWindowSize":"43j9z","cee348c65b260dc9":"k8RZz","50aa71a4eb524512":"30GaK","e585dcd19dc1cacc":"8M1Gg","a8a09ffcaf2155c5":"1P0SP","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2cpLN":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _base = require("@emotion/styled/base");
var _baseDefault = parcelHelpers.interopDefault(_base);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _groupedMultiSelector = require("../../../components/forms/GroupedMultiSelector");
var _groupedMultiSelectorDefault = parcelHelpers.interopDefault(_groupedMultiSelector);
var _colors = require("../../../constants/colors");
var _fieldError = require("../../../components/forms/FieldError");
var _fieldErrorDefault = parcelHelpers.interopDefault(_fieldError);
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const addIcon = require("e8f8de6c2a3c2e19");
const NlpEntitySelector = (props)=>{
    const selectedDisplayName = props.selected?.name;
    const getGroups = ()=>{
        const groups = [];
        const customGroup = {
            key: "__custom",
            label: "Custom",
            subItems: [],
            hideRadio: true
        };
        const preBuiltGroup = {
            key: "__preBuilt",
            label: "Pre-built",
            subItems: [],
            hideRadio: true
        };
        props.nlpEntities?.forEach((entity)=>{
            const deleted = entity.isDeleted ? "Deleted - " : "";
            const label = `${deleted} ${entity.name} (Type: ${entity.type})`;
            const optionItem = {
                label: label,
                value: entity.name,
                isSelected: entity.name == selectedDisplayName,
                data: entity,
                groupKey: "",
                hideCheckbox: true
            };
            if (entity.prebuiltEntityId) {
                optionItem.groupKey = "preBuilt";
                preBuiltGroup.subItems.push(optionItem);
            } else {
                optionItem.groupKey = "custom";
                customGroup.subItems.push(optionItem);
            }
        });
        if (customGroup.subItems.length) groups.push(customGroup);
        if (preBuiltGroup.subItems.length) groups.push(preBuiltGroup);
        return groups;
    };
    return (0, _react.jsx)((0, _reactDefault.default).Fragment, null, (0, _react.jsx)(NlpEntitySelectorStyled, {
        className: props.className,
        groupToggle: groupToggleStyle,
        label: props.label,
        groups: getGroups(),
        onChange: (values)=>props.handleChange(values),
        selectedValues: [
            selectedDisplayName
        ],
        withGroupSelection: false,
        treatGroupAsValue: false,
        subItemCheckType: "radio",
        restrictGroups: true,
        position: props.position ?? "bottom",
        emptyText: "Select",
        disabled: props.disabled,
        innerSelectionRender: ()=>(0, _react.jsx)("div", null, props.selectedDisplayText)
    }), (0, _react.jsx)((0, _fieldErrorDefault.default), {
        name: props.fieldName,
        ignoreTouched: true
    }));
};
const groupToggleStyle = /*#__PURE__*/ (0, _css.css)({
    name: "14vfbk2",
    styles: "margin-left:auto;margin-right:0;height:8px;width:8px"
});
const NlpEntitySelectorStyled = /*#__PURE__*/ (0, _baseDefault.default)((0, _groupedMultiSelectorDefault.default), {
    target: "e14u7an0"
})("margin-left:auto;margin-top:16px;margin-right:0;&.bordered{border-right:1px solid #ccc;}&.disabled{.field .selection{background:", (0, _colors.color_shades_light), ";cursor:not-allowed;}}.sub-item{height:44px;}.item-group{height:44px;}.field{.selection{border-radius:8px;.empty-text{text-align:right;margin-left:auto;margin-right:12px;width:100%;}}}.inner-wrapper{max-height:300px!important;}.field-wrapper{display:block;.selection-section{border-radius:8px;margin-top:8;}label{text-align:left;margin:0 16px;}}");
exports.default = NlpEntitySelector;

},{"@emotion/styled/base":"lSuFu","@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","../../../components/forms/GroupedMultiSelector":"51iZT","../../../constants/colors":"1p3OR","../../../components/forms/FieldError":"fDxhz","e8f8de6c2a3c2e19":"6cI2N","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"30GaK":[function(require,module,exports) {
module.exports = require("39ffa49143bc0ff6").getBundleURL("kVLro") + require("100f1a9f753890be").resolve("k7bE7");

},{"39ffa49143bc0ff6":"c7Tr5","100f1a9f753890be":"fyJL2"}],"8M1Gg":[function(require,module,exports) {
module.exports = require("be6ea78fc7929337").getBundleURL("kVLro") + require("dade6b6bd7afe74a").resolve("j49Jl");

},{"be6ea78fc7929337":"c7Tr5","dade6b6bd7afe74a":"fyJL2"}],"1P0SP":[function(require,module,exports) {
module.exports = require("eb1d6dd581ddecfb").getBundleURL("kVLro") + require("cc73180307e142b0").resolve("98QPl");

},{"eb1d6dd581ddecfb":"c7Tr5","cc73180307e142b0":"fyJL2"}],"224im":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _base = require("@emotion/styled/base");
var _baseDefault = parcelHelpers.interopDefault(_base);
var _react = require("@emotion/react");
var _css = require("@emotion/css");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _button = require("../../../components/general/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _warningConfirmation = require("../../../components/general/WarningConfirmation");
var _warningConfirmationDefault = parcelHelpers.interopDefault(_warningConfirmation);
var _confirmationDialog = require("../../../components/structure/ConfirmationDialog");
var _confirmationDialogDefault = parcelHelpers.interopDefault(_confirmationDialog);
var _colors = require("../../../constants/colors");
var _slotsEditor = require("./SlotsEditor");
var _errorLabel = require("../../../components/general/ErrorLabel");
var _errorLabelDefault = parcelHelpers.interopDefault(_errorLabel);
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const deleteIcon = require("9cea360dcc59035a");
const addIcon = require("29b91d6b5d912343");
const redNoCircle = require("6afb0114d1b1e70b");
const yellowUpdate = require("7a33a8dc7caae86a");
const alertIcon = require("1a38ac536d465267");
const requiredSlotIcon = require("9cd842556959e413");
const requiredGroupIcon = require("8063c59d60cc00b3");
const disallowedSlotIcon = require("c62bad13d7535996");
const SlotItem = (props)=>{
    const [isConfirmDeleteModalOpen, setIsConfirmDeleteModalOpen] = (0, _react1.useState)(false);
    const isActive = props.isActive;
    const slotName = props.slot?.name;
    const slotDisplayName = "{ } " + (slotName?.trim().length > (0, _slotsEditor.maxSlotNameDisplaySize) ? slotName.trim().substring(0, (0, _slotsEditor.maxSlotNameDisplaySize)) + "..." : slotName);
    const isDeleted = props.slot?.isDeleted;
    const isModified = props.slot?.isModified;
    const cardPrefix = `${props.formPrefix}.slots.${props.formIndex}`;
    const isModifiedField = `${cardPrefix}.isModified`;
    const isDeletedField = `${cardPrefix}.isDeleted`;
    const hasUnsavedChanges = props.slot?.isDeleted || props.slot?.isAdded || props.slot?.isModified;
    const disableFields = isDeleted || props.isSubmitting || props.isValidating;
    const hasErrors = props.errors?.[props.formPrefix]?.["slots"]?.[props.formIndex];
    const handleItemToggleActivation = ()=>{
        props.toggleItemActivationByIndex(props.formIndex);
    };
    const toggleConfirmDeleteModal = ()=>{
        setIsConfirmDeleteModalOpen(!isConfirmDeleteModalOpen);
    };
    const onConfirmDelete = ()=>{
        props.setFieldValue(isDeletedField, true);
        props.setFieldValue(isModifiedField, true);
        // Reset any validation errors on deleted item, otherwise the submit will not work
        props.validateForm();
        toggleConfirmDeleteModal();
    };
    const renderItemName = ()=>{
        return (0, _react.jsx)("div", {
            className: itemTitle,
            key: slotName
        }, (0, _react.jsx)((0, _buttonDefault.default), {
            themes: [
                "black-small"
            ],
            text: slotDisplayName,
            type: "button"
        }));
    };
    const getSlotDetailsIcon = ()=>{
        switch(true){
            case props.slot?.disallowed:
                return (0, _react.jsx)((0, _buttonDefault.default), {
                    themes: [
                        "icon",
                        "end-tight"
                    ],
                    icon: disallowedSlotIcon
                });
            case props.slot?.required:
                return (0, _react.jsx)((0, _buttonDefault.default), {
                    themes: [
                        "icon",
                        "end-tight"
                    ],
                    icon: requiredSlotIcon
                });
            case props.slot?.requiredSlotGroupIds?.length > 0:
                return (0, _react.jsx)(RequiredSlotGroupWrapper, null, (0, _react.jsx)(SlotGroupText, null, props.slot.requiredSlotGroupIds[0]), (0, _react.jsx)((0, _buttonDefault.default), {
                    themes: [
                        "icon",
                        "end-tight"
                    ],
                    icon: requiredGroupIcon
                }));
        }
    };
    const renderItemActions = ()=>{
        return (0, _react.jsx)("div", {
            className: itemActions
        }, getSlotDetailsIcon(), hasErrors && (0, _react.jsx)((0, _errorLabelDefault.default), {
            image: alertIcon,
            text: "Errors Present"
        }), hasUnsavedChanges && (0, _react.jsx)((0, _buttonDefault.default), {
            themes: [
                "icon",
                "end-tight"
            ],
            icon: isDeleted ? redNoCircle : isModified ? yellowUpdate : addIcon
        }), !disableFields && (0, _react.jsx)((0, _buttonDefault.default), {
            themes: [
                "icon",
                "end-tight"
            ],
            icon: deleteIcon,
            type: "button",
            disabled: disableFields,
            onClick: toggleConfirmDeleteModal
        }));
    };
    const renderSlotDisplayItem = ()=>{
        return (0, _react.jsx)("div", {
            className: `${itemContainer} ${isActive ? "active" : ""}`
        }, (0, _react.jsx)("div", {
            className: `${itemHeader} ${isActive ? "active" : ""}`,
            key: `menuItem-${slotName}`,
            onClick: ()=>handleItemToggleActivation()
        }, renderItemName(), renderItemActions()), isConfirmDeleteModalOpen && (0, _react.jsx)((0, _confirmationDialogDefault.default), {
            title: `Confirm Delete`,
            deleteText: "Yes, Delete",
            isLoading: false,
            onClose: toggleConfirmDeleteModal,
            onConfirm: onConfirmDelete
        }, (0, _react.jsx)((0, _warningConfirmationDefault.default), {
            text: `Are you sure you want to delete the slot "${slotName}"? 
                        When you choose "Apply Changes" all utterances that are using this slot will become invalid.`
        })));
    };
    return renderSlotDisplayItem();
};
exports.default = SlotItem;
const SlotGroupText = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1b25cge1"
})("color:", (0, _colors.color_colors_decline), ";font-size:8px;");
const RequiredSlotGroupWrapper = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1b25cge0"
})({
    name: "1wnowod",
    styles: "display:flex;align-items:center;justify-content:center"
});
const itemContainer = /*#__PURE__*/ (0, _css.css)("border:1px solid ", (0, _colors.color_shades_dark), ";border-radius:8px;margin:8px 0 8px 0;padding:0 16px 0 16px;&.active{border:1px solid ", (0, _colors.color_colors_ocean), ";box-shadow:0px 0px 4px 4px ", (0, _colors.color_variants_ocean_light_2), ";min-height:56px;height:auto;}", "");
const itemHeader = /*#__PURE__*/ (0, _css.css)({
    name: "d1w3fo",
    styles: "height:56px;display:flex;justify-content:space-between;cursor:pointer"
});
const itemTitle = /*#__PURE__*/ (0, _css.css)("display:flex;flex-direction:row;align-items:center;font-size:18px;color:", (0, _colors.color_text_default), ";position:relative;", "");
const itemActions = /*#__PURE__*/ (0, _css.css)({
    name: "zjik7",
    styles: "display:flex"
});

},{"@emotion/styled/base":"lSuFu","@emotion/react":"djZKr","@emotion/css":"awUBr","react":"6uln9","../../../components/general/Button":"6ymxN","../../../components/general/WarningConfirmation":"9OccO","../../../components/structure/ConfirmationDialog":"kx7yK","../../../constants/colors":"1p3OR","./SlotsEditor":"84ufV","../../../components/general/ErrorLabel":"k9Ob0","9cea360dcc59035a":"7eyKJ","29b91d6b5d912343":"kxmNT","6afb0114d1b1e70b":"37PeV","7a33a8dc7caae86a":"8yrG0","1a38ac536d465267":"cRA6k","9cd842556959e413":"30GaK","8063c59d60cc00b3":"8M1Gg","c62bad13d7535996":"1P0SP","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"kxmNT":[function(require,module,exports) {
module.exports = require("d8541a04ddb2932e").getBundleURL("kVLro") + require("dc6d7bfe40d6076b").resolve("206U8");

},{"d8541a04ddb2932e":"c7Tr5","dc6d7bfe40d6076b":"fyJL2"}],"37PeV":[function(require,module,exports) {
module.exports = require("3b2adcc27d73e39").getBundleURL("kVLro") + require("de4058b09fb25d22").resolve("afqZk");

},{"3b2adcc27d73e39":"c7Tr5","de4058b09fb25d22":"fyJL2"}],"7E3J3":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _base = require("@emotion/styled/base");
var _baseDefault = parcelHelpers.interopDefault(_base);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _colors = require("../../../constants/colors");
var _conditionalTooltipWrapper = require("../../../components/general/ConditionalTooltipWrapper");
var _conditionalTooltipWrapperDefault = parcelHelpers.interopDefault(_conditionalTooltipWrapper);
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
class SlotSelector extends (0, _reactDefault.default).Component {
    renderSlotItem(slot, idx, first, last) {
        return (0, _react.jsx)("div", {
            key: idx,
            onClick: this.props.addSlot.bind(this, slot),
            className: "availableSlot"
        }, (0, _react.jsx)((0, _conditionalTooltipWrapperDefault.default), {
            showTooltip: slot.required,
            text: "This slot is required in all utterances for this intent"
        }, (0, _react.jsx)(SlotRow, {
            className: `${first ? "first" : ""} ${last ? "last" : ""}`
        }, (0, _react.jsx)(SlotName, null, "{ } ", slot.name), slot.required ? (0, _react.jsx)(RequiredIndicator, null, "*") : (0, _react.jsx)((0, _reactDefault.default).Fragment, null))));
    }
    render() {
        if (this.props.hidden) return null;
        return (0, _react.jsx)("div", {
            className: slotSelectorContainer
        }, this.props.availableSlots ? this.props.availableSlots.map((s, idx)=>this.renderSlotItem(s, idx, idx === 0, idx === this.props.availableSlots.length - 1)) : (0, _react.jsx)("i", null, "No slots available"));
    }
}
exports.default = SlotSelector;
const SlotName = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1bw0rwn2"
})({
    name: "qamjgr",
    styles: "margin-right:4px"
});
const SlotRow = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1bw0rwn1"
})("display:flex;flex-direction:row;border-bottom:solid 1px ", (0, _colors.color_shades_dark), ";padding:8px 8px 8px 8px;&.first{}&.last{border-bottom:none;}");
const RequiredIndicator = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1bw0rwn0"
})("color:", (0, _colors.color_colors_decline), ";margin-right:4px;margin-left:auto;");
const slotSelectorContainer = /*#__PURE__*/ (0, _css.css)("position:absolute;background-color:white;border-style:solid;border-width:1px;border-color:", (0, _colors.color_shades_dark), ";right:0px;top:30px;min-width:100px;z-index:3;.availableSlot{cursor:pointer;}.availableSlot:hover{color:", (0, _colors.color_colors_ocean), ";}", "");

},{"@emotion/styled/base":"lSuFu","@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","../../../constants/colors":"1p3OR","../../../components/general/ConditionalTooltipWrapper":"92m0T","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"15I2s":[function(require,module,exports) {
module.exports = require("3299e04a4276e9c5").getBundleURL("kVLro") + require("cefb139b3a97651a").resolve("bq6an");

},{"3299e04a4276e9c5":"c7Tr5","cefb139b3a97651a":"fyJL2"}],"2wWYJ":[function(require,module,exports) {
module.exports = require("7e5d26088af99136").getBundleURL("kVLro") + require("e4b08a0c03de8740").resolve("jxtLW");

},{"7e5d26088af99136":"c7Tr5","e4b08a0c03de8740":"fyJL2"}],"hst2e":[function(require,module,exports) {
module.exports = require("304dd469e22e76cd").getBundleURL("kVLro") + require("db7674d2e00bfeaa").resolve("iC7pW");

},{"304dd469e22e76cd":"c7Tr5","db7674d2e00bfeaa":"fyJL2"}],"5TB7H":[function(require,module,exports) {
module.exports = require("7682a56460f07f8").getBundleURL("kVLro") + require("5331913c8dc67e44").resolve("6GwIN");

},{"7682a56460f07f8":"c7Tr5","5331913c8dc67e44":"fyJL2"}],"gval1":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _base = require("@emotion/styled/base");
var _baseDefault = parcelHelpers.interopDefault(_base);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _textField = require("../../../components/forms/TextField");
var _textFieldDefault = parcelHelpers.interopDefault(_textField);
var _button = require("../../../components/general/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _modalTitle = require("../../../components/general/ModalTitle");
var _modalTitleDefault = parcelHelpers.interopDefault(_modalTitle);
var _pageError = require("../../../components/general/PageError");
var _pageErrorDefault = parcelHelpers.interopDefault(_pageError);
var _footerBar = require("../../../components/structure/FooterBar");
var _footerBarDefault = parcelHelpers.interopDefault(_footerBar);
var _horizontalContainer = require("../../../components/structure/HorizontalContainer");
var _horizontalContainerDefault = parcelHelpers.interopDefault(_horizontalContainer);
var _horizontalSeparator = require("../../../components/structure/HorizontalSeparator");
var _horizontalSeparatorDefault = parcelHelpers.interopDefault(_horizontalSeparator);
var _modalLayout = require("../../../components/structure/ModalLayout");
var _modalLayoutDefault = parcelHelpers.interopDefault(_modalLayout);
var _pageContainer = require("../../../components/structure/PageContainer");
var _pageContainerDefault = parcelHelpers.interopDefault(_pageContainer);
var _colors = require("../../../constants/colors");
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const closeIcon = require("bfefcaba3c385217");
const AddNewIntentModal = (props)=>{
    const [newIntentName, setNewIntentName] = (0, _react1.useState)("");
    const [isAddDisabled, setIsAddDisabled] = (0, _react1.useState)(true);
    const [errorMessages, setErrorMessages] = (0, _react1.useState)([]);
    const handleKeyUp = (e)=>{
        e.stopPropagation();
        if (props.isLoading || isAddDisabled) return;
        if (e.key === "Enter") props.handleSubmit(newIntentName);
    };
    const handleChange = (value)=>{
        setIsAddDisabled(true);
        setErrorMessages([]);
        setNewIntentName(value);
        //Validate that intent display name is unique
        const iMatch = Object.keys(props.interactionModel)?.filter((key)=>props.interactionModel[key]?.displayName.toLowerCase().trim() === value.toLowerCase().trim());
        if (iMatch?.length > 0) {
            setErrorMessages([
                `Intent with name "${value}" already exists`
            ]);
            return;
        }
        if (value?.trim().length == 0) {
            setIsAddDisabled(true);
            setErrorMessages([
                `Please add intent name`
            ]);
            return;
        }
        setIsAddDisabled(false);
    };
    return (0, _react.jsx)(NewIntentModal, {
        isVisible: true,
        onClose: ()=>props.handleClose()
    }, (0, _react.jsx)((0, _pageContainerDefault.default), {
        fill: true,
        withFooter: true
    }, (0, _react.jsx)((0, _horizontalContainerDefault.default), null, (0, _react.jsx)((0, _modalTitleDefault.default), {
        padded: true
    }, "New Intent"), (0, _react.jsx)((0, _buttonDefault.default), {
        themes: [
            "end-tight",
            "icon"
        ],
        icon: closeIcon,
        onClick: ()=>props.handleClose()
    })), (0, _react.jsx)((0, _horizontalSeparatorDefault.default), null), (0, _react.jsx)((0, _horizontalContainerDefault.default), null, (0, _react.jsx)("div", {
        className: "main-body",
        onKeyUp: (e)=>handleKeyUp(e)
    }, (0, _react.jsx)((0, _textFieldDefault.default), {
        autoFocus: true,
        useForm: false,
        required: true,
        name: `displayName`,
        value: newIntentName,
        disabled: props.isLoading,
        placeholder: "Name your intent",
        label: `Name`,
        onChange: (e)=>handleChange(e.target.value),
        onBlur: ()=>{}
    })), (0, _react.jsx)((0, _pageErrorDefault.default), {
        errors: [
            ...errorMessages ?? []
        ],
        onClear: ()=>{
            setErrorMessages([]);
        }
    })), (0, _react.jsx)(CustomFooter, null, (0, _react.jsx)(SubmitButton, {
        type: "button",
        themes: [
            "primary"
        ],
        text: "Add",
        onClick: ()=>props.handleSubmit(newIntentName),
        disabled: props.isLoading || newIntentName.length == 0 || isAddDisabled,
        loading: props.isLoading
    }), (0, _react.jsx)((0, _buttonDefault.default), {
        type: "button",
        themes: [
            "secondary"
        ],
        text: "Cancel",
        onClick: ()=>props.handleClose(),
        disabled: props.isLoading,
        loading: props.isLoading
    }))));
};
exports.default = AddNewIntentModal;
const NewIntentModal = /*#__PURE__*/ (0, _baseDefault.default)((0, _modalLayoutDefault.default), {
    target: "e1jsh25t2"
})("color:", (0, _colors.color_text_default), ";width:40%;height:30%;min-height:500px;min-width:600px;.main-body{width:100%;padding:32px;}");
const CustomFooter = /*#__PURE__*/ (0, _baseDefault.default)((0, _footerBarDefault.default), {
    target: "e1jsh25t1"
})({
    name: "1q0eusf",
    styles: "z-index:auto"
});
const SubmitButton = /*#__PURE__*/ (0, _baseDefault.default)((0, _buttonDefault.default), {
    target: "e1jsh25t0"
})({
    name: "1tx1l5v",
    styles: "margin-right:auto"
});

},{"@emotion/styled/base":"lSuFu","@emotion/react":"djZKr","react":"6uln9","../../../components/forms/TextField":"7a7bh","../../../components/general/Button":"6ymxN","../../../components/general/ModalTitle":"hIp2B","../../../components/general/PageError":"ezFTm","../../../components/structure/FooterBar":"bibRL","../../../components/structure/HorizontalContainer":"eJPfh","../../../components/structure/HorizontalSeparator":"Pw3HQ","../../../components/structure/ModalLayout":"b1cO3","../../../components/structure/PageContainer":"hc1r8","../../../constants/colors":"1p3OR","bfefcaba3c385217":"93VwA","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"48qeH":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "enabledOptions", ()=>enabledOptions);
var _base = require("@emotion/styled/base");
var _baseDefault = parcelHelpers.interopDefault(_base);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _button = require("../../../components/general/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _modalTitle = require("../../../components/general/ModalTitle");
var _modalTitleDefault = parcelHelpers.interopDefault(_modalTitle);
var _pageError = require("../../../components/general/PageError");
var _pageErrorDefault = parcelHelpers.interopDefault(_pageError);
var _footerBar = require("../../../components/structure/FooterBar");
var _footerBarDefault = parcelHelpers.interopDefault(_footerBar);
var _horizontalContainer = require("../../../components/structure/HorizontalContainer");
var _horizontalContainerDefault = parcelHelpers.interopDefault(_horizontalContainer);
var _horizontalSeparator = require("../../../components/structure/HorizontalSeparator");
var _horizontalSeparatorDefault = parcelHelpers.interopDefault(_horizontalSeparator);
var _modalLayout = require("../../../components/structure/ModalLayout");
var _modalLayoutDefault = parcelHelpers.interopDefault(_modalLayout);
var _pageContainer = require("../../../components/structure/PageContainer");
var _pageContainerDefault = parcelHelpers.interopDefault(_pageContainer);
var _colors = require("../../../constants/colors");
var _textAreaField = require("../../../components/forms/TextAreaField");
var _textAreaFieldDefault = parcelHelpers.interopDefault(_textAreaField);
var _radioGroup = require("../../../components/forms/RadioGroup");
var _radioGroupDefault = parcelHelpers.interopDefault(_radioGroup);
var _stylesValues = require("../../../constants/stylesValues");
var _css = require("@emotion/css");
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const closeIcon = require("e3c259fbb85ee882");
const enabledOptions = [
    {
        label: "LLM Intent Matching Enabled",
        value: true
    },
    {
        label: "LLM Intent Matching Disabled",
        value: false
    }
];
const ManageIntentPromptModal = (props)=>{
    const [prompt, setPrompt] = (0, _react1.useState)(props.prompt);
    const [enabled, setEnabled] = (0, _react1.useState)(props.enabled);
    const [errorMessages, setErrorMessages] = (0, _react1.useState)([]);
    const handlePromptChange = (value)=>{
        setErrorMessages([]);
        setPrompt(value);
    };
    return (0, _react.jsx)(NewIntentModal, {
        isVisible: true,
        onClose: ()=>props.handleClose()
    }, (0, _react.jsx)((0, _pageContainerDefault.default), {
        fill: true,
        withFooter: true
    }, (0, _react.jsx)((0, _horizontalContainerDefault.default), null, (0, _react.jsx)((0, _modalTitleDefault.default), {
        padded: true
    }, "Manage Intent Matching Prompt"), (0, _react.jsx)((0, _buttonDefault.default), {
        themes: [
            "end-tight",
            "icon"
        ],
        icon: closeIcon,
        onClick: ()=>props.handleClose()
    })), (0, _react.jsx)((0, _horizontalSeparatorDefault.default), null), (0, _react.jsx)((0, _horizontalContainerDefault.default), null, (0, _react.jsx)("div", {
        className: "main-body"
    }, (0, _react.jsx)(CustomRadioGroup, {
        checkContainerStyle: checkContainerStyle,
        selectedOptionStyle: selectedOptionStyle,
        onChange: (e)=>setEnabled(e.value),
        value: enabled,
        options: enabledOptions
    }), enabled && (0, _react.jsx)((0, _reactDefault.default).Fragment, null, (0, _react.jsx)("p", null, "The variable {INTENTS} will be replaced by a new line separated list of relevant intents in this format: d: description. a:INTENT_NAME"), (0, _react.jsx)("p", null, "The variable {LAST_ASSISTANT_SPEECH} will be replaced by the last thing the assistant said. You can optionally include it if you want to prompt with more context."), (0, _react.jsx)(CustomTextArea, {
        required: true,
        name: `prompt`,
        value: prompt,
        maxRows: 20,
        disabled: props.isLoading || !enabled,
        placeholder: "Edit intent matching prompt here",
        onChange: (e)=>handlePromptChange(e.target.value),
        onBlur: ()=>{}
    }))), (0, _react.jsx)((0, _pageErrorDefault.default), {
        errors: [
            ...errorMessages ?? []
        ],
        onClear: ()=>{
            setErrorMessages([]);
        }
    })), (0, _react.jsx)(CustomFooter, null, (0, _react.jsx)(SubmitButton, {
        type: "button",
        themes: [
            "primary"
        ],
        text: "Save",
        onClick: ()=>props.handleSubmit(enabled, prompt),
        disabled: props.isLoading || prompt.length == 0,
        loading: props.isLoading
    }), (0, _react.jsx)((0, _buttonDefault.default), {
        type: "button",
        themes: [
            "secondary"
        ],
        text: "Cancel",
        onClick: ()=>props.handleClose(),
        disabled: props.isLoading,
        loading: props.isLoading
    }))));
};
exports.default = ManageIntentPromptModal;
const CustomTextArea = /*#__PURE__*/ (0, _baseDefault.default)((0, _textAreaFieldDefault.default), {
    target: "ezu7mj74"
})({
    name: "1h51pyi",
    styles: "margin-top:-16px"
});
const NewIntentModal = /*#__PURE__*/ (0, _baseDefault.default)((0, _modalLayoutDefault.default), {
    target: "ezu7mj73"
})("color:", (0, _colors.color_text_default), ";width:70%;height:70%;min-height:750px;min-width:600px;.main-body{width:100%;padding:32px;padding-top:8px;}");
const CustomFooter = /*#__PURE__*/ (0, _baseDefault.default)((0, _footerBarDefault.default), {
    target: "ezu7mj72"
})({
    name: "1q0eusf",
    styles: "z-index:auto"
});
const SubmitButton = /*#__PURE__*/ (0, _baseDefault.default)((0, _buttonDefault.default), {
    target: "ezu7mj71"
})({
    name: "1tx1l5v",
    styles: "margin-right:auto"
});
const CustomRadioGroup = /*#__PURE__*/ (0, _baseDefault.default)((0, _radioGroupDefault.default), {
    target: "ezu7mj70"
})({
    name: "g40tsu",
    styles: "margin:0 0 26px 0"
});
const checkContainerStyle = /*#__PURE__*/ (0, _css.css)("width:20px;height:20px;border-radius:50%;background-color:#ffffff;border:", (0, _stylesValues.style_border_default), ";display:flex;align-items:center;justify-content:center;", "");
const selectedOptionStyle = /*#__PURE__*/ (0, _css.css)("width:10px;height:10px;border-radius:50%;background-image:", (0, _colors.color_gradients_green_shift), ";", "");

},{"@emotion/styled/base":"lSuFu","@emotion/react":"djZKr","react":"6uln9","../../../components/general/Button":"6ymxN","../../../components/general/ModalTitle":"hIp2B","../../../components/general/PageError":"ezFTm","../../../components/structure/FooterBar":"bibRL","../../../components/structure/HorizontalContainer":"eJPfh","../../../components/structure/HorizontalSeparator":"Pw3HQ","../../../components/structure/ModalLayout":"b1cO3","../../../components/structure/PageContainer":"hc1r8","../../../constants/colors":"1p3OR","../../../components/forms/TextAreaField":"fE54C","../../../components/forms/RadioGroup":"eiGrn","../../../constants/stylesValues":"dHVVv","@emotion/css":"awUBr","e3c259fbb85ee882":"93VwA","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"aUL2g":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "NLP_FORM_PREFIX", ()=>NLP_FORM_PREFIX);
var _extends = require("@babel/runtime/helpers/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _base = require("@emotion/styled/base");
var _baseDefault = parcelHelpers.interopDefault(_base);
var _react = require("@emotion/react");
var _css = require("@emotion/css");
var _formik = require("formik");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _button = require("../../../components/general/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _pageError = require("../../../components/general/PageError");
var _pageErrorDefault = parcelHelpers.interopDefault(_pageError);
var _customScrollbars = require("../../../components/structure/CustomScrollbars");
var _customScrollbarsDefault = parcelHelpers.interopDefault(_customScrollbars);
var _horizontalSeparator = require("../../../components/structure/HorizontalSeparator");
var _horizontalSeparatorDefault = parcelHelpers.interopDefault(_horizontalSeparator);
var _colors = require("../../../constants/colors");
var _applicationNlpEntityContainer = require("../../../hooks/ApplicationNlpEntityContainer");
var _useWindowSize = require("../../../hooks/UseWindowSize");
var _useWindowSizeDefault = parcelHelpers.interopDefault(_useWindowSize);
var _addNewNlpEntityModal = require("./AddNewNlpEntityModal");
var _addNewNlpEntityModalDefault = parcelHelpers.interopDefault(_addNewNlpEntityModal);
var _applicationNlpEntityCard = require("./ApplicationNlpEntityCard");
var _applicationNlpEntityCardDefault = parcelHelpers.interopDefault(_applicationNlpEntityCard);
var _applicationNlpEntityItem = require("./ApplicationNlpEntityItem");
var _applicationNlpEntityItemDefault = parcelHelpers.interopDefault(_applicationNlpEntityItem);
var _emptyView = require("../../featureContent/components/EmptyView");
var _emptyViewDefault = parcelHelpers.interopDefault(_emptyView);
var _searchField = require("../../../components/forms/SearchField");
var _searchFieldDefault = parcelHelpers.interopDefault(_searchField);
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const NLP_FORM_PREFIX = "nlpEntities";
const ApplicationNlpEntitiesEditor = (props)=>{
    const [activeItemIndex, setActiveItemIndex] = (0, _react1.useState)(-1);
    const [isAddNewNlpEntityModalOpen, setIsAddNewNlpEntityModalOpen] = (0, _react1.useState)(false);
    const [errorMessages, setErrorMessages] = (0, _react1.useState)([]);
    const windowSize = (0, _useWindowSizeDefault.default)();
    const [searchTerm, setSearchTerm] = (0, _react1.useState)("");
    const handleSearchChange = (e)=>{
        setSearchTerm(e.target.value);
    };
    const toggleItemActivationByIndex = (index)=>{
        setActiveItemIndex(index);
    };
    const toggleAddNewNlpEntityModal = ()=>{
        setIsAddNewNlpEntityModalOpen(!isAddNewNlpEntityModalOpen);
    };
    const copyNlpEntity = (copyFrom)=>{
        // For front end purpose only, backend will override it
        const today = new Date().toUTCString();
        const newNlpEntity = {
            ...copyFrom,
            id: "",
            applicationId: props.applicationId,
            name: "Copy - " + copyFrom.name,
            modifiedDate: today,
            isAdded: true,
            isModified: true,
            isDeleted: false
        };
        return newNlpEntity;
    };
    const handleCopyNlpEntityByIndex = (index, arrayHelpers)=>{
        const copyFrom = props.nlpEntities[index];
        if (copyFrom) {
            const newNlpEntity = copyNlpEntity(copyFrom);
            arrayHelpers.push(newNlpEntity);
            toggleItemActivationByIndex(props.nlpEntities.length);
        }
    };
    const getPrebuiltNlpEntityById = (entityId)=>{
        const filtered = props.prebuiltNlpEntities?.filter((e)=>e.id === entityId);
        if (filtered?.length == 1) return filtered[0];
        return null;
    };
    const copyNlpEntityFromPrebuilt = (prebuiltEntityId)=>{
        const prebuiltNlpEntity = getPrebuiltNlpEntityById(prebuiltEntityId);
        if (!prebuiltNlpEntity) {
            setErrorMessages([
                "Unable to find Prebuilt NLP Entity to copy from"
            ]);
            return null;
        }
        // If Prebuilt entity is not Copyable and we already have it - do not add it again
        // validation to not be able to add non-copyable prebuilt entiteis multiple times
        if (!prebuiltNlpEntity.isCopyable) {
            const found = props.nlpEntities?.find((e)=>e.prebuiltEntityId && e.prebuiltEntityId == prebuiltNlpEntity.id);
            if (found) {
                setErrorMessages([
                    `Unable to add ${found.type} Prebuilt NLP Entity "${found?.name}", it was already added to your application. `
                ]);
                return null;
            }
        }
        // For front end purpose only, backend will override it
        const today = new Date().toUTCString();
        const values = prebuiltNlpEntity.values ? [
            ...prebuiltNlpEntity?.values
        ] : [];
        const numberOfvalues = prebuiltNlpEntity.values?.length || 0;
        const isLarge = numberOfvalues > (0, _applicationNlpEntityContainer.LARGE_ENTITY_VALUES_COUNT);
        const newNlpEntity = {
            ...prebuiltNlpEntity,
            id: "",
            applicationId: props.applicationId,
            values,
            modifiedDate: today,
            isAdded: true,
            isModified: true,
            isDeleted: false,
            isLarge,
            prebuiltEntityId: prebuiltNlpEntity.id
        };
        return newNlpEntity;
    };
    const addApplicationNlpEntity = (source, key)=>{
        // Close modal 
        setIsAddNewNlpEntityModalOpen(false);
        if (!source || !key) return;
        const defaultLocales = props.languages?.map((l)=>l.shortCode);
        // For front end purpose only, backend will override it
        const today = new Date().toUTCString();
        let customEntityType = "List";
        // Nlp Entity Type is required and is not user editable
        // For new Custom Nlp we have two choices either List or Regex
        if (source === "Custom" && key === "Regex") customEntityType = "Regex";
        // Default new Entity to Custom selection
        let newNlpEntity = {
            id: "",
            applicationId: props.applicationId,
            type: customEntityType,
            name: "New " + source + " " + key,
            values: [],
            locales: defaultLocales,
            modifiedDate: today,
            isAdded: true,
            isModified: true,
            isDeleted: false,
            isEditable: true,
            isCopyable: true,
            isEnabled: true,
            isLarge: false
        };
        if (source === "Prebuilt") {
            // Override new Entity with Prebuilt selection key=entityId
            newNlpEntity = copyNlpEntityFromPrebuilt(key);
            if (newNlpEntity == null) return;
        }
        const idx = props.nlpEntities?.length ?? 0;
        const fieldName = `${NLP_FORM_PREFIX}.${idx}`;
        props.setFieldValue(fieldName, newNlpEntity);
        toggleItemActivationByIndex(idx);
    };
    const renderActiveNlpEntityEdit = ()=>{
        const nlpEntity = props.nlpEntities[activeItemIndex];
        return (0, _react.jsx)("div", {
            className: editActiveItem
        }, nlpEntity ? (0, _react.jsx)((0, _applicationNlpEntityCardDefault.default), (0, _extendsDefault.default)({}, props, {
            setErrors: props.setErrors,
            languages: props.allAppLanguages,
            nlpEntities: props.nlpEntities,
            nlpEntity: nlpEntity,
            formPrefix: NLP_FORM_PREFIX,
            formIndex: activeItemIndex
        })) : (0, _react.jsx)(EmptyViewText, null, "Select an entity to see more details and manage values"));
    };
    const renderNlpEntity = (nlpEntity, index, arrayHelpers)=>{
        const isActive = index === activeItemIndex;
        const isInLanguages = props.languages?.map((lang)=>lang.shortCode)?.some((locale)=>nlpEntity.locales?.includes(locale));
        //Only render entities in selected languages
        return isInLanguages && (0, _react.jsx)((0, _applicationNlpEntityItemDefault.default), (0, _extendsDefault.default)({}, props, {
            toggleItemActivationByIndex: toggleItemActivationByIndex,
            handleCopyNlpEntity: (idx)=>handleCopyNlpEntityByIndex(idx, arrayHelpers),
            applicationId: props.applicationId,
            languages: props.languages,
            nlpEntity: nlpEntity,
            isActive: isActive,
            key: index,
            formPrefix: NLP_FORM_PREFIX,
            formIndex: index
        }));
    };
    const renderNlpEntityItemsList = ()=>{
        if (!props.nlpEntities?.length && !props.isLoading) return (0, _react.jsx)(EmptyViewPadding, null, (0, _react.jsx)((0, _emptyViewDefault.default), {
            subtext: "Try adding a new Entity"
        }));
        return (0, _react.jsx)((0, _reactDefault.default).Fragment, null, (0, _react.jsx)((0, _searchFieldDefault.default), {
            id: "searchField1",
            name: "searchField",
            placeholder: "Find this",
            value: searchTerm,
            onChange: handleSearchChange,
            boxType: "square",
            className: searchPadding
        }), // Newly added entities on the top
        props.nlpEntities?.some((v)=>v.isAdded) && (0, _react.jsx)((0, _formik.FieldArray), {
            validateOnChange: true,
            name: NLP_FORM_PREFIX,
            render: (arrayHelpers)=>props.nlpEntities?.filter((entity)=>entity?.name?.toLowerCase().includes(searchTerm.toLowerCase()))?.map((entity, index)=>{
                    if (!entity.isAdded) return null;
                    return renderNlpEntity(entity, index, arrayHelpers);
                })
        }), (0, _react.jsx)((0, _formik.FieldArray), {
            validateOnChange: true,
            name: NLP_FORM_PREFIX,
            render: (arrayHelpers)=>props.nlpEntities?.filter((entity)=>entity?.name?.toLowerCase().includes(searchTerm.toLowerCase()))?.map((entity, index)=>{
                    if (entity.isAdded) return null;
                    return renderNlpEntity(entity, props.nlpEntities.indexOf(entity), arrayHelpers);
                })
        }));
    };
    const renderNlpEntitiesItemsPanel = ()=>{
        return (0, _react.jsx)("div", {
            className: menuItemsContainer
        }, (0, _react.jsx)("div", {
            className: menuItemsContainerHeader
        }, (0, _react.jsx)("div", null, "NLP Entities "), (0, _react.jsx)((0, _buttonDefault.default), {
            themes: [
                "primary-small",
                "start"
            ],
            disabled: props.isLoading,
            loading: props.isLoading,
            onClick: toggleAddNewNlpEntityModal,
            text: "Add an entity"
        })), (0, _react.jsx)((0, _horizontalSeparatorDefault.default), null), props.nlpEntities && renderNlpEntityItemsList());
    };
    return (0, _react.jsx)("div", {
        className: containerStyle
    }, (0, _react.jsx)("div", {
        className: twoSectionsContainer
    }, (0, _react.jsx)((0, _customScrollbarsDefault.default), {
        autoHide: true,
        autoHeight: true,
        autoHeightMin: windowSize.windowSize.innerHeight - 210,
        autoHeightMax: windowSize.windowSize.innerHeight - 210
    }, renderNlpEntitiesItemsPanel()), (0, _react.jsx)(BorderLeftCustomScrollbars, {
        autoHide: true,
        autoHeight: true,
        autoHeightMin: windowSize.windowSize.innerHeight - 210,
        autoHeightMax: windowSize.windowSize.innerHeight - 210
    }, renderActiveNlpEntityEdit())), isAddNewNlpEntityModalOpen && (0, _react.jsx)((0, _addNewNlpEntityModalDefault.default), {
        handleSubmit: addApplicationNlpEntity,
        handleClose: toggleAddNewNlpEntityModal,
        isLoading: props.isLoading
    }), (0, _react.jsx)((0, _pageErrorDefault.default), {
        errors: [
            ...errorMessages ?? []
        ],
        onClear: ()=>{
            setErrorMessages([]);
        }
    }));
};
exports.default = ApplicationNlpEntitiesEditor;
const BorderLeftCustomScrollbars = /*#__PURE__*/ (0, _baseDefault.default)((0, _customScrollbarsDefault.default), {
    target: "et7c93z2"
})("border-left:1px solid ", (0, _colors.color_shades_dark), ";");
const containerStyle = /*#__PURE__*/ (0, _css.css)({
    name: "pit38s",
    styles: "height:auto"
});
const twoSectionsContainer = /*#__PURE__*/ (0, _css.css)({
    name: "j9lc9v",
    styles: "height:100%;display:flex"
});
const menuItemsContainer = /*#__PURE__*/ (0, _css.css)({
    name: "g4pc86",
    styles: "position:relative;height:auto;padding:0 32px 16px 32px"
});
const menuItemsContainerHeader = /*#__PURE__*/ (0, _css.css)({
    name: "1066lcq",
    styles: "display:flex;justify-content:space-between;align-items:center"
});
const editActiveItem = /*#__PURE__*/ (0, _css.css)({
    name: "1ank6rl",
    styles: "position:relative;height:auto;padding:16px 32px 16px 32px;overflow:hidden"
});
const customLoaderStyle = /*#__PURE__*/ (0, _css.css)({
    name: "1pp2wda",
    styles: "position:relative;top:auto;margin-top:30px;margin-bottom:30px"
});
const EmptyViewText = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "et7c93z1"
})("background:white;border:1px solid ", (0, _colors.color_shades_dark), ";border-radius:8px;color:", (0, _colors.color_shades_dark), ";padding:24px;");
const EmptyViewPadding = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "et7c93z0"
})({
    name: "yehwrb",
    styles: "margin-top:24px;width:100%"
});
const searchPadding = /*#__PURE__*/ (0, _css.css)({
    name: "1nuhno9",
    styles: "padding-top:8px"
});

},{"@babel/runtime/helpers/extends":"4iKIP","@emotion/styled/base":"lSuFu","@emotion/react":"djZKr","@emotion/css":"awUBr","formik":"3YnOK","react":"6uln9","../../../components/general/Button":"6ymxN","../../../components/general/PageError":"ezFTm","../../../components/structure/CustomScrollbars":"50vFq","../../../components/structure/HorizontalSeparator":"Pw3HQ","../../../constants/colors":"1p3OR","../../../hooks/ApplicationNlpEntityContainer":"6IUi8","../../../hooks/UseWindowSize":"43j9z","./AddNewNlpEntityModal":"3f3Mh","./ApplicationNlpEntityCard":"kkteV","./ApplicationNlpEntityItem":"cOmz5","../../featureContent/components/EmptyView":"j6GxB","../../../components/forms/SearchField":"aU10T","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6IUi8":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LARGE_ENTITY_VALUES_COUNT", ()=>LARGE_ENTITY_VALUES_COUNT);
var _react = require("react");
var _unstatedNext = require("unstated-next");
var _api = require("../api");
var _lodash = require("lodash");
var _lodashDefault = parcelHelpers.interopDefault(_lodash);
const LARGE_ENTITY_VALUES_COUNT = 1500;
function useApplicationNlpEntityContainer() {
    const [isLoading, setIsLoading] = (0, _react.useState)(false);
    const [errors, setErrors] = (0, _react.useState)([]);
    const [currentApplicationId, setCurrentApplicationId] = (0, _react.useState)(null);
    const [selectedLanguages, setSelectedLanguages] = (0, _react.useState)([]);
    const [applicationNlpEntities, setApplicationNlpEntities] = (0, _react.useState)([]);
    const [prebuiltNlpEntities, setPrebuiltNlpEntities] = (0, _react.useState)([]);
    const getApplicationNlpEntities = async (applicationId, languages)=>{
        try {
            setSelectedLanguages(languages);
            if (applicationId == currentApplicationId && applicationNlpEntities?.length > 0) return;
            await loadAllApplicationNlpEntities(applicationId);
            setIsLoading(false);
        } catch (err) {
            setIsLoading(false);
            setErrors([
                err.toString()
            ]);
        }
    };
    const loadAllApplicationNlpEntities = async (applicationId)=>{
        try {
            setIsLoading(true);
            setApplicationNlpEntities([]);
            setErrors([]);
            const result = await _api.getApplicationNlpEntities(applicationId);
            if (result?.resultType == "Ok") {
                const allEntities = result.data;
                let editable = allEntities?.map((entity)=>{
                    const numberOfvalues = entity?.values?.length || 0;
                    const isLarge = numberOfvalues > LARGE_ENTITY_VALUES_COUNT;
                    const editableEntity = {
                        ...entity,
                        isModified: false,
                        isAdded: false,
                        isDeleted: false,
                        isLarge
                    };
                    return editableEntity;
                });
                editable = (0, _lodashDefault.default).orderBy(editable ?? [], (e)=>e.name, [
                    "asc"
                ]);
                await setApplicationNlpEntities(editable);
                await setCurrentApplicationId(applicationId);
            } else await setErrors([
                ...errors,
                ...result.errors,
                "Unable to load application NLP entities"
            ]);
            await setIsLoading(false);
        } catch (err) {
            await setIsLoading(false);
            await setErrors([
                err.toString()
            ]);
        }
    };
    const loadPrebuiltNlpEntities = async (applicationId, languages)=>{
        try {
            setIsLoading(true);
            setSelectedLanguages(languages);
            setPrebuiltNlpEntities([]);
            setErrors([]);
            let merged = [];
            for (const lang of languages){
                const locale = lang.shortCode;
                const result = await _api.getApplicationPrebuiltNlpEntitiesInLocale(applicationId, locale);
                if (result?.resultType == "Ok") {
                    const prebuiltLocaleEntities = result.data;
                    if (merged.length == 0) merged = prebuiltLocaleEntities;
                    else {
                        const mergedEntitiesIds = merged.map((e)=>e.id);
                        const localeEntitiesIds = prebuiltLocaleEntities?.map((e)=>e.id);
                        const hasAll = localeEntitiesIds?.every((val)=>mergedEntitiesIds?.includes(val));
                        if (!hasAll) prebuiltLocaleEntities?.forEach((e)=>{
                            if (!mergedEntitiesIds?.includes(e.id)) merged.push(e);
                        });
                    }
                    merged = (0, _lodashDefault.default).orderBy(merged ?? [], (e)=>e.name, [
                        "asc"
                    ]);
                    setPrebuiltNlpEntities(merged);
                    setCurrentApplicationId(applicationId);
                } else await setErrors([
                    ...errors,
                    ...result.errors,
                    `Unable to load Prebuilt NLP entities in locale "${locale}" `
                ]);
            }
            await setIsLoading(false);
        } catch (err) {
            await setIsLoading(false);
            await setErrors([
                err.toString()
            ]);
        }
    };
    const updateApplicationNlpEntity = async (applicationId, nlpEntityId, request)=>{
        try {
            setIsLoading(true);
            const result = await _api.updateApplicationNlpEntity(applicationId, nlpEntityId, request);
            if (result?.resultType === "Ok") {
                setIsLoading(false);
                return result;
            } else await setErrors([
                ...errors,
                ...result.errors,
                "Unable to Update Entity"
            ]);
            setIsLoading(false);
        } catch (e) {
            setErrors([
                e?.toString(),
                "Unable to Update Entity"
            ]);
            setIsLoading(false);
        }
    };
    const addApplicationNlpEntity = async (applicationId, request)=>{
        try {
            setIsLoading(true);
            const result = await _api.addApplicationNlpEntity(applicationId, request);
            if (result?.resultType === "Ok") {
                setIsLoading(false);
                return result;
            } else await setErrors([
                ...errors,
                ...result.errors,
                "Unable to Add Entity"
            ]);
            setIsLoading(false);
        } catch (e) {
            setErrors([
                e?.toString(),
                "Unable to Add Entity"
            ]);
            setIsLoading(false);
        }
    };
    const deleteApplicationNlpEntity = async (applicationId, nlpEntityId)=>{
        try {
            setIsLoading(true);
            const result = await _api.deleteApplicationNlpEntity(applicationId, nlpEntityId);
            if (result?.resultType === "Ok") {
                setIsLoading(false);
                return result;
            } else await setErrors([
                ...errors,
                ...result.errors,
                "Unable to Delete Entity"
            ]);
            setIsLoading(false);
        } catch (e) {
            setErrors([
                e?.toString(),
                "Unable to Delete Entity"
            ]);
            setIsLoading(false);
        }
    };
    const clearErrors = ()=>{
        setErrors([]);
    };
    return {
        getApplicationNlpEntities,
        loadAllApplicationNlpEntities,
        loadPrebuiltNlpEntities,
        isLoading,
        currentApplicationId,
        languages: selectedLanguages,
        applicationNlpEntities,
        prebuiltNlpEntities,
        errors,
        clearErrors,
        updateApplicationNlpEntity,
        addApplicationNlpEntity,
        deleteApplicationNlpEntity
    };
}
const ApplicationNlpEntityContainer = (0, _unstatedNext.createContainer)(useApplicationNlpEntityContainer);
exports.default = ApplicationNlpEntityContainer;

},{"react":"6uln9","unstated-next":"61zE5","../api":"loxM6","lodash":"3hMBK","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3f3Mh":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _base = require("@emotion/styled/base");
var _baseDefault = parcelHelpers.interopDefault(_base);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _radioGroup = require("../../../components/forms/RadioGroup");
var _radioGroupDefault = parcelHelpers.interopDefault(_radioGroup);
var _selectField = require("../../../components/forms/SelectField");
var _selectFieldDefault = parcelHelpers.interopDefault(_selectField);
var _button = require("../../../components/general/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _loader = require("../../../components/general/Loader");
var _loaderDefault = parcelHelpers.interopDefault(_loader);
var _modalTitle = require("../../../components/general/ModalTitle");
var _modalTitleDefault = parcelHelpers.interopDefault(_modalTitle);
var _pageError = require("../../../components/general/PageError");
var _pageErrorDefault = parcelHelpers.interopDefault(_pageError);
var _footerBar = require("../../../components/structure/FooterBar");
var _footerBarDefault = parcelHelpers.interopDefault(_footerBar);
var _horizontalContainer = require("../../../components/structure/HorizontalContainer");
var _horizontalContainerDefault = parcelHelpers.interopDefault(_horizontalContainer);
var _horizontalSeparator = require("../../../components/structure/HorizontalSeparator");
var _horizontalSeparatorDefault = parcelHelpers.interopDefault(_horizontalSeparator);
var _modalLayout = require("../../../components/structure/ModalLayout");
var _modalLayoutDefault = parcelHelpers.interopDefault(_modalLayout);
var _pageContainer = require("../../../components/structure/PageContainer");
var _pageContainerDefault = parcelHelpers.interopDefault(_pageContainer);
var _colors = require("../../../constants/colors");
var _applicationNlpEntityContainer = require("../../../hooks/ApplicationNlpEntityContainer");
var _applicationNlpEntityContainerDefault = parcelHelpers.interopDefault(_applicationNlpEntityContainer);
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const closeIcon = require("3f26c8fe1b737ec8");
const AddNewNlpEntityModal = (props)=>{
    const applicationNlpEntityContainer = (0, _applicationNlpEntityContainerDefault.default).useContainer();
    const [isAddDisabled, setIsAddDisabled] = (0, _react1.useState)(true);
    const [errorMessages, setErrorMessages] = (0, _react1.useState)([]);
    const [nlpEntityOption, setNlpEntityOption] = (0, _react1.useState)("Custom");
    const [typeOptionValue, setTypeOptionValue] = (0, _react1.useState)(null);
    const [prebuiltOptionValue, setPrebuiltOptionValue] = (0, _react1.useState)(null);
    const types = [
        "List",
        "Regex"
    ]; // We do not allow user to create "Native" entity
    const typeOptions = types.map((t)=>({
            value: t,
            label: t
        }));
    const prebuiltEntitiesOptions = applicationNlpEntityContainer?.prebuiltNlpEntities?.map((e)=>({
            value: e.id,
            label: e.name + " (" + e.type + ")"
        }));
    const handleKeyUp = (e)=>{
        e.stopPropagation();
        if (props.isLoading || isAddDisabled) return;
        if (e.key === "Enter") handleAddNewNlpEntity();
    };
    const handleOptionChange = (option)=>{
        setIsAddDisabled(true);
        setNlpEntityOption(option.value);
        setTypeOptionValue(null);
        setPrebuiltOptionValue(null);
    };
    const handleCustomSelectionChange = (e)=>{
        setTypeOptionValue(e.value);
        setIsAddDisabled(false);
    };
    const handlePrebuiltSelectionChange = (e)=>{
        setPrebuiltOptionValue(e.value);
        setIsAddDisabled(false);
    };
    const handleAddNewNlpEntity = ()=>{
        props.handleSubmit(nlpEntityOption, prebuiltOptionValue || typeOptionValue);
    };
    return (0, _react.jsx)(NewNlpEntityModal, {
        isVisible: true,
        onClose: ()=>props.handleClose()
    }, (0, _react.jsx)((0, _pageContainerDefault.default), {
        fill: true,
        withFooter: true
    }, (0, _react.jsx)((0, _horizontalContainerDefault.default), null, (0, _react.jsx)((0, _modalTitleDefault.default), {
        padded: true
    }, "New NLP Entity"), (0, _react.jsx)((0, _buttonDefault.default), {
        themes: [
            "end-tight",
            "icon"
        ],
        icon: closeIcon,
        onClick: ()=>props.handleClose()
    })), (0, _react.jsx)((0, _horizontalSeparatorDefault.default), null), (0, _react.jsx)((0, _horizontalContainerDefault.default), null, (0, _react.jsx)("div", {
        className: "main-body",
        onKeyUp: (e)=>handleKeyUp(e)
    }, (0, _react.jsx)((0, _radioGroupDefault.default), {
        onChange: handleOptionChange,
        value: nlpEntityOption,
        disabled: props.isLoading,
        options: [
            {
                value: "Custom",
                label: "Custom Entity"
            }
        ]
    }), typeOptionValue === "List" && (0, _react.jsx)(TypeDescription, null, 'List entities represent lists of values each with optional synonyms. For example: an entity that represents toppings might have a value "Pepperoni" with a synonym of "roni".'), typeOptionValue === "Regex" && (0, _react.jsx)(TypeDescription, null, "Regex entities represent regular expressions that represent different patterns of potential user inputs. For example:", (0, _react.jsx)("br", null), "^[0-9]", 5, "(?:-[0-9]", 4, ")?$", (0, _react.jsx)("br", null), "represents any 5 or 9 digit zip code."), (0, _react.jsx)((0, _selectFieldDefault.default), {
        options: typeOptions,
        value: typeOptionValue,
        disabled: props.isLoading || nlpEntityOption === "Prebuilt",
        placeholder: "Select...",
        onBlur: ()=>{},
        onChange: handleCustomSelectionChange,
        useFormTheme: true,
        label: "Type",
        name: "customNlpEntityType"
    }), (0, _react.jsx)((0, _radioGroupDefault.default), {
        onChange: handleOptionChange,
        value: nlpEntityOption,
        disabled: props.isLoading,
        options: [
            {
                value: "Prebuilt",
                label: "Pre-built Entity"
            }
        ]
    }), (0, _react.jsx)((0, _selectFieldDefault.default), {
        options: prebuiltEntitiesOptions,
        value: prebuiltOptionValue,
        disabled: props.isLoading || nlpEntityOption === "Custom",
        placeholder: "Select...",
        onBlur: ()=>{},
        onChange: handlePrebuiltSelectionChange,
        useFormTheme: true,
        label: "Select One",
        name: "prebuiltNlpEntities"
    }), props.isLoading && (0, _react.jsx)((0, _loaderDefault.default), null)), (0, _react.jsx)((0, _pageErrorDefault.default), {
        errors: [
            ...errorMessages ?? []
        ],
        onClear: ()=>{
            setErrorMessages([]);
        }
    })), (0, _react.jsx)(CustomFooter, {
        className: "add-new-footer"
    }, (0, _react.jsx)(SubmitButton, {
        type: "button",
        themes: [
            "primary"
        ],
        text: "Create",
        onClick: handleAddNewNlpEntity,
        disabled: props.isLoading || isAddDisabled,
        loading: props.isLoading
    }), (0, _react.jsx)("div", {
        className: "selected-count"
    }), (0, _react.jsx)((0, _buttonDefault.default), {
        type: "button",
        themes: [
            "secondary"
        ],
        text: "Cancel",
        onClick: ()=>props.handleClose(),
        disabled: props.isLoading,
        loading: props.isLoading
    }))));
};
exports.default = AddNewNlpEntityModal;
const NewNlpEntityModal = /*#__PURE__*/ (0, _baseDefault.default)((0, _modalLayoutDefault.default), {
    target: "e16ec8ib3"
})("color:", (0, _colors.color_text_default), ";width:40%;height:30%;min-height:730px;min-width:700px;.main-body{width:100%;padding:32px;}");
const CustomFooter = /*#__PURE__*/ (0, _baseDefault.default)((0, _footerBarDefault.default), {
    target: "e16ec8ib2"
})({
    name: "1q0eusf",
    styles: "z-index:auto"
});
const SubmitButton = /*#__PURE__*/ (0, _baseDefault.default)((0, _buttonDefault.default), {
    target: "e16ec8ib1"
})({
    name: "1tx1l5v",
    styles: "margin-right:auto"
});
const TypeDescription = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e16ec8ib0"
})({
    name: "cezfk",
    styles: "margin:0px 16px 16px 16px"
});

},{"@emotion/styled/base":"lSuFu","@emotion/react":"djZKr","react":"6uln9","../../../components/forms/RadioGroup":"eiGrn","../../../components/forms/SelectField":"405B3","../../../components/general/Button":"6ymxN","../../../components/general/Loader":"bnV5T","../../../components/general/ModalTitle":"hIp2B","../../../components/general/PageError":"ezFTm","../../../components/structure/FooterBar":"bibRL","../../../components/structure/HorizontalContainer":"eJPfh","../../../components/structure/HorizontalSeparator":"Pw3HQ","../../../components/structure/ModalLayout":"b1cO3","../../../components/structure/PageContainer":"hc1r8","../../../constants/colors":"1p3OR","../../../hooks/ApplicationNlpEntityContainer":"6IUi8","3f26c8fe1b737ec8":"93VwA","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"kkteV":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _extends = require("@babel/runtime/helpers/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _base = require("@emotion/styled/base");
var _baseDefault = parcelHelpers.interopDefault(_base);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _dirtyFormPrompt = require("../../formScenes/components/DirtyFormPrompt");
var _contentLanguageMultiSelector = require("../../../components/forms/ContentLanguageMultiSelector");
var _contentLanguageMultiSelectorDefault = parcelHelpers.interopDefault(_contentLanguageMultiSelector);
var _textField = require("../../../components/forms/TextField");
var _textFieldDefault = parcelHelpers.interopDefault(_textField);
var _button = require("../../../components/general/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _horizontalSeparator = require("../../../components/structure/HorizontalSeparator");
var _horizontalSeparatorDefault = parcelHelpers.interopDefault(_horizontalSeparator);
var _css = require("@emotion/css");
var _numberIncrementSelector = require("../../../components/forms/NumberIncrementSelector");
var _numberIncrementSelectorDefault = parcelHelpers.interopDefault(_numberIncrementSelector);
var _searchField = require("../../../components/forms/SearchField");
var _searchFieldDefault = parcelHelpers.interopDefault(_searchField);
var _roundedSelectionRow = require("../../../components/general/RoundedSelectionRow");
var _roundedSelectionRowDefault = parcelHelpers.interopDefault(_roundedSelectionRow);
var _nlpEntityValuesListDisplay = require("./NlpEntityValuesListDisplay");
var _nlpEntityValuesListDisplayDefault = parcelHelpers.interopDefault(_nlpEntityValuesListDisplay);
var _nlpEntityValuesTextBoxDisplay = require("./NlpEntityValuesTextBoxDisplay");
var _nlpEntityValuesTextBoxDisplayDefault = parcelHelpers.interopDefault(_nlpEntityValuesTextBoxDisplay);
var _applicationNlpEntityContainer = require("../../../hooks/ApplicationNlpEntityContainer");
var _importFileDialog = require("../../../components/general/ImportFileDialog");
var _importFileDialogDefault = parcelHelpers.interopDefault(_importFileDialog);
var _confirmationDialog = require("../../../components/structure/ConfirmationDialog");
var _confirmationDialogDefault = parcelHelpers.interopDefault(_confirmationDialog);
var _warningConfirmation = require("../../../components/general/WarningConfirmation");
var _warningConfirmationDefault = parcelHelpers.interopDefault(_warningConfirmation);
var _colors = require("../../../constants/colors");
var _sharedStyledComponents = require("./SharedStyledComponents");
var _interactionModelForm = require("./InteractionModelForm");
var _textOverflowMenu = require("../../../components/general/overflowMenu/TextOverflowMenu");
var _textOverflowMenuDefault = parcelHelpers.interopDefault(_textOverflowMenu);
var _formFieldsContainer = require("../../../components/structure/FormFieldsContainer");
var _formFieldsContainerDefault = parcelHelpers.interopDefault(_formFieldsContainer);
var _horizontalOptionsSelector = require("../../../components/forms/HorizontalOptionsSelector");
var _horizontalOptionsSelectorDefault = parcelHelpers.interopDefault(_horizontalOptionsSelector);
var _stylesValues = require("../../../constants/stylesValues");
var _countButton = require("../../contentPage/components/CountButton");
var _contentCard = require("../../../components/structure/ContentCard");
var _contentCardDefault = parcelHelpers.interopDefault(_contentCard);
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const closeIcon = require("300924717f7d2130");
const tableViewIconLight = require("e0fb27f6e79f920");
const tableViewIconSelected = require("b327cf4edb68396c");
const tableTextboxIcon = require("e28d03f327c9d5da");
const tableTextboxIconSelected = require("f0cde3cd0230ab6");
const importIcon = require("14c66fb8555f5ce4");
const exportIcon = require("1d615fbd19c22e1c");
const questionIcon = require("166b0a3a18c6b5b");
const selectedQuestionIcon = require("135919f5fb9b35a");
const searchQuestionIcon = require("853facfc7061ab08");
const nonEditableIcon = require("96a90cb766437b19");
const sensitiveEntity = require("acc39a324ab3dd70");
const noTrackingEntity = require("e2f3cbf1c51332f9");
const confidenceScoreIcon = require("1b90fb59eece2a0d");
const blueConfidenceScoreIcon = require("969eafb21bcaf05c");
const numberOfValuesPerPage = 10;
const ENTITY_SENSITIVITY_NONE = "None";
const ENTITY_SENSITIVITY_SENSITIVE = "Sensitive";
const ENTITY_SENSITIVITY_NOTRACKING = "No Tracking";
const ApplicationNlpEntityCard = (props)=>{
    const [activeItemIndex, setActiveItemIndex] = (0, _react1.useState)(-1);
    const [valuesFormDisplayInfo, setValuesFormDisplayInfo] = (0, _react1.useState)([]);
    const [filteredNumberOfValues, setFilteredNumberOfValues] = (0, _react1.useState)(0);
    const [valuesPageNumber, setValuesPageNumber] = (0, _react1.useState)(1);
    const [valuesSearchTerm, setValuesSearchTerm] = (0, _react1.useState)("");
    const [triggerNlpValuesSearch, setTriggerNlpValuesSearch] = (0, _react1.useState)("");
    const [viewDisplayType, setViewDisplayType] = (0, _react1.useState)("ListDisplay");
    const [isImportFileDialogModalOpen, setIsImportFileDialogModalOpen] = (0, _react1.useState)(false);
    const [isImporting, setIsImporting] = (0, _react1.useState)(false);
    const [fileImportErrors, setFileImportErrors] = (0, _react1.useState)([]);
    const [importedValues, setImportedValues] = (0, _react1.useState)([]);
    const [isConfirmImportValuesModalOpen, setIsConfirmImportValuesModalOpen] = (0, _react1.useState)(false);
    const [showSearch, setShowSearch] = (0, _react1.useState)(false);
    const [showConfidenceScore, setShowConfidenceScore] = (0, _react1.useState)(false);
    const cardPrefix = `${props.formPrefix}.${props.formIndex}`;
    const nameField = `${cardPrefix}.name`;
    const thresholdField = `${cardPrefix}.threshold`;
    const valuesField = `${cardPrefix}.values`;
    const isLargeEntityField = `${cardPrefix}.isLarge`;
    const isModifiedField = `${cardPrefix}.isModified`;
    const localesField = `${cardPrefix}.locales`;
    const sensitivityField = `${cardPrefix}.dataSensitivity`;
    const disableFields = !props.nlpEntity.isEditable || props.nlpEntity.isDeleted; //|| props.isSubmitting || props.isValidating 
    const selectedLanguageIds = props.nlpEntity.locales?.map((locale)=>props.languages?.find((lang)=>lang.shortCode == locale)?.id);
    const nlpEntityValues = props.nlpEntity.values;
    const valuesButtonText = nlpEntityValues ? nlpEntityValues.length.toLocaleString() : " None ";
    const isLastPage = numberOfValuesPerPage * valuesPageNumber >= filteredNumberOfValues;
    const largeEntityInfoText = "Large Entity";
    const viewDisplayValuesoptions = [
        {
            icon: tableViewIconLight,
            selectedIcon: tableViewIconSelected,
            name: "List"
        },
        {
            icon: tableTextboxIcon,
            selectedIcon: tableTextboxIconSelected,
            name: "Textbox"
        }
    ];
    (0, _react1.useEffect)(function resetNlpValuesDisplayOnEntitySelect() {
        clearSearchTerm();
        setViewDisplayType("ListDisplay");
        setValuesFormDisplayInfo([]);
        setImportedValues([]);
        recalculateValuesToRender();
    }, [
        props.formIndex
    ]);
    (0, _react1.useEffect)(function resetNlpValuesDisplayOnSearchAddDeleteTypeChange() {
        recalculateValuesToRender();
    }, [
        triggerNlpValuesSearch,
        nlpEntityValues,
        viewDisplayType
    ]);
    const recalculateValuesToRender = ()=>{
        setValuesFormDisplayInfo([]);
        // Do not display values for Large Entities
        if (props.nlpEntity.isLarge) return;
        const hasNewlyAdded = nlpEntityValues?.some((v)=>v.isAdded);
        let filtered = [];
        nlpEntityValues?.map((value, index)=>{
            const info = {
                nlpEntityValue: value,
                // For values ArrayHelper to be able to delete a value need original form index
                originalArrayIndex: index,
                displayIndex: index // Will be set after sorting to new disply index if we have search 
            };
            if (valuesSearchTerm) {
                if (value?.name && value.name?.toLowerCase().includes(valuesSearchTerm?.toLowerCase()) || value?.pattern && value.pattern?.toLowerCase().includes(valuesSearchTerm?.toLowerCase())) {
                    if (value.isAdded) // Newly added values on top
                    filtered.unshift(info);
                    else filtered.push(info);
                }
            } else if (value.isAdded) // Newly added values on top
            filtered.unshift(info);
            else filtered.push(info);
        });
        if (valuesSearchTerm || hasNewlyAdded) filtered = filtered?.map((f, idx)=>{
            const d = {
                ...f,
                displayIndex: idx
            };
            return d;
        });
        setValuesFormDisplayInfo(filtered);
        setFilteredNumberOfValues(filtered?.length ?? 0);
    };
    const toggleConfidenceScore = ()=>{
        setShowConfidenceScore(!showConfidenceScore);
    };
    const confidenceScoreOptions = [
        {
            name: "Very Fuzzy",
            value: .6
        },
        {
            name: "",
            value: .7
        },
        {
            name: "Fuzzy",
            value: .8
        },
        {
            name: "",
            value: .9
        },
        {
            name: "Exact",
            value: 1
        }
    ];
    const decrementPage = ()=>{
        if (valuesPageNumber <= 1) return;
        setValuesPageNumber(valuesPageNumber - 1);
    };
    const incrementPage = ()=>{
        if (isLastPage) return;
        setValuesPageNumber(valuesPageNumber + 1);
    };
    const clearSearchTerm = ()=>{
        // Clear search
        setValuesSearchTerm("");
        setTriggerNlpValuesSearch("");
        setValuesPageNumber(1);
    };
    const handleSearch = (searchEvent)=>{
        setValuesSearchTerm(searchEvent.target.value);
    };
    const handleSearchKeyDown = (event)=>{
        if (event.key === "Escape") // Clear search
        clearSearchTerm();
        else if (event.key === "Enter") {
            setTriggerNlpValuesSearch(valuesSearchTerm);
            setValuesPageNumber(1);
        }
    };
    const toggleItemActivationByIndex = (index)=>{
        setActiveItemIndex(index);
    };
    const addNewNlpValue = ()=>{
        // Clear search
        clearSearchTerm();
        const newIdx = nlpEntityValues?.length || 0;
        const nlpEntityValue = {
            isAdded: true
        };
        props.setFieldValue(`${valuesField}.${newIdx}`, nlpEntityValue);
        props.setFieldValue(isModifiedField, true);
        setActiveItemIndex(newIdx);
        setValuesPageNumber(1);
    };
    const toggleViewDisplayType = ()=>{
        // TextBoxDisplay is Only applicable to List NLP Entity Type 
        setShowSearch(false);
        if (props.nlpEntity.type !== "List") return;
        if (viewDisplayType === "ListDisplay") {
            clearSearchTerm();
            setViewDisplayType("TextBoxDisplay");
        } else setViewDisplayType("ListDisplay");
        setValuesPageNumber(1);
    };
    const handleNlpEntityNameKeyUp = (event)=>{
        if (disableFields) return;
        if (event.key === "Escape") ;
        else if (event.key === "Enter") props.validateForm();
    };
    const handleDataSensitivityFieldChange = (sensitivity)=>{
        props.setFieldValue(sensitivityField, sensitivity === "No Tracking" ? "NoTracking" : sensitivity);
        props.setFieldValue(isModifiedField, true);
    };
    const handleNlpEntityNameChange = (fieldName, event)=>{
        props.setFieldValue(isModifiedField, true);
        props.handleChange(event);
    };
    const handleLanguagesChange = (langs)=>{
        const selectedLocales = langs?.map((lang)=>lang.shortCode);
        props.setFieldValue(localesField, selectedLocales);
        props.setFieldValue(isModifiedField, true);
    };
    const toggleConfirmImportValuesModal = ()=>{
        setIsConfirmImportValuesModalOpen(!isConfirmImportValuesModalOpen);
    };
    const toggleImportFileDialogModal = ()=>{
        setIsImportFileDialogModalOpen(!isImportFileDialogModalOpen);
    };
    const overwriteNlpValuesFromImport = ()=>{
        if (importedValues?.length > (0, _applicationNlpEntityContainer.LARGE_ENTITY_VALUES_COUNT)) props.setFieldValue(isLargeEntityField, true);
        else props.setFieldValue(isLargeEntityField, false);
        props.setFieldValue(valuesField, importedValues);
        props.setFieldValue(isModifiedField, true);
        setIsImporting(false);
        setImportedValues([]);
        toggleConfirmImportValuesModal();
    };
    const importNlpValues = (file)=>{
        setFileImportErrors([]);
        if (!file) {
            setFileImportErrors([
                "Please select a file"
            ]);
            return;
        }
        const reader = new FileReader();
        reader.onloadend = (e)=>{
            const textBoxValues = reader.result.toString();
            if (textBoxValues) {
                const imported = (0, _interactionModelForm.convertCSVtextToValues)(textBoxValues);
                setImportedValues(imported);
                setIsImportFileDialogModalOpen(false);
                toggleConfirmImportValuesModal();
            }
        };
        reader.readAsText(file);
    };
    const exportNlpValues = ()=>{
        let fileName = props.nlpEntity?.name || "NlpEntity";
        let valuesData = nlpEntityValues;
        if (valuesData == null || valuesData?.length === 0) return;
        fileName = fileName + "_" + valuesData?.length.toString() + "_NlpValues";
        const valuesDataInCSV = (0, _interactionModelForm.convertValuesToCSVText)(valuesData);
        handleDownload(fileName, valuesDataInCSV);
    };
    const handleDownload = (fileName, contentDataInCSV)=>{
        const blob = new Blob([
            contentDataInCSV
        ], {
            type: "text/plain"
        });
        const url = URL.createObjectURL(blob);
        let link = document.createElement("a");
        link.setAttribute("href", url);
        link.setAttribute("download", `${fileName}.csv`);
        document.body.appendChild(link); // Required for FF
        link.click();
        link.remove();
    };
    const renderNlpValuesNavigation = ()=>{
        return (0, _react.jsx)((0, _reactDefault.default).Fragment, null, (0, _react.jsx)("div", {
            className: valuesNavigationContainer
        }, (0, _react.jsx)("div", {
            className: valuesViewDisplayType
        }, (0, _react.jsx)("div", {
            className: `label row`
        }, "View"), (0, _react.jsx)((0, _roundedSelectionRowDefault.default), {
            key: "list-valyes-display-type-selector",
            options: viewDisplayValuesoptions,
            className: roundedSelectStyle,
            optionClassName: roundedOptionStyle,
            onClick: toggleViewDisplayType,
            selectedFilter: viewDisplayType === "ListDisplay" ? 0 : 1
        })), (0, _react.jsx)("div", null, (0, _react.jsx)((0, _numberIncrementSelectorDefault.default), {
            useShadow: true,
            selectedNumber: `${valuesPageNumber}`,
            updateValue: (b)=>b ? incrementPage() : decrementPage(),
            label: "Page",
            showNumber: true
        }))));
    };
    const renderNlpValuesActions = ()=>{
        return (0, _react.jsx)((0, _reactDefault.default).Fragment, null, (0, _react.jsx)("div", {
            className: valuesActionsContainer
        }, (0, _react.jsx)(AddAndSearchDiv, null, !props.nlpEntity.isLarge && (0, _react.jsx)(AddAValueButton, {
            themes: [
                "primary-small",
                "end-tight"
            ],
            onClick: (e)=>addNewNlpValue(),
            disabled: disableFields || props.nlpEntity.isLarge || viewDisplayType === "TextBoxDisplay",
            text: "Add a Value"
        }), props.nlpEntity.type === "List" && !props.nlpEntity.isLarge && (0, _react.jsx)((0, _buttonDefault.default), {
            className: showSearch ? SelectedQuestionButton : QuestionButton,
            themes: [
                "small-circle"
            ],
            onClick: ()=>setShowSearch(true),
            icon: showSearch ? selectedQuestionIcon : questionIcon
        })), props.nlpEntity.type === "List" && !props.nlpEntity.isLarge && (0, _react.jsx)(Spacer, null), props.nlpEntity.type === "List" && (0, _react.jsx)(ImportExport, null, (0, _react.jsx)(ImportExportDiv, {
            onClick: toggleImportFileDialogModal
        }, (0, _react.jsx)(ImportExportSpan, null, "Import"), (0, _react.jsx)(ImportExportImg, {
            src: importIcon
        })), (0, _react.jsx)(ImportExportDiv, {
            onClick: (e)=>exportNlpValues()
        }, (0, _react.jsx)(ImportExportSpan, null, "Export"), (0, _react.jsx)(ImportExportImg, {
            src: exportIcon
        })))), showSearch && (0, _react.jsx)((0, _reactDefault.default).Fragment, null, (0, _react.jsx)((0, _horizontalSeparatorDefault.default), null), showSearch && (0, _react.jsx)("div", {
            className: triangleStyle
        }), (0, _react.jsx)((0, _searchFieldDefault.default), {
            id: "searchField1",
            name: "searchField",
            placeholder: "Find this",
            value: valuesSearchTerm,
            disabled: props.nlpEntity.isLarge || viewDisplayType === "TextBoxDisplay",
            onChange: handleSearch,
            onKeyDown: handleSearchKeyDown,
            boxType: "square",
            className: searchPadding
        })), triggerNlpValuesSearch && (0, _react.jsx)((0, _reactDefault.default).Fragment, null, (0, _react.jsx)("div", null, " Matching Results: "), valuesFormDisplayInfo?.length === 0 && (0, _react.jsx)(SearchResultDiv, {
            key: "no-results"
        }, (0, _react.jsx)(NoResultsDiv, null, (0, _react.jsx)(NoResultsImg, {
            src: searchQuestionIcon
        }), (0, _react.jsx)("p", null, "No results found"), (0, _react.jsx)(ClearButton, {
            themes: [
                "white-small"
            ],
            onClick: (e)=>clearSearchTerm(),
            text: "Clear Search Terms",
            rightIcon: closeIcon
        })))));
    };
    const renderNlpValuesListDisplay = ()=>{
        return (0, _react.jsx)((0, _nlpEntityValuesListDisplayDefault.default), (0, _extendsDefault.default)({}, props, {
            activeItemIndex: activeItemIndex,
            toggleItemActivationByIndex: toggleItemActivationByIndex,
            valuesFormDisplayInfo: valuesFormDisplayInfo,
            numberOfValuesPerPage: numberOfValuesPerPage,
            valuesPageNumber: valuesPageNumber,
            languages: props.languages,
            nlpEntities: props.nlpEntities,
            nlpEntity: props.nlpEntity,
            formPrefix: props.formPrefix,
            formIndex: props.formIndex
        }));
    };
    const renderNlpEntityValuesTextBoxDisplay = ()=>{
        return (0, _react.jsx)((0, _nlpEntityValuesTextBoxDisplayDefault.default), (0, _extendsDefault.default)({}, props, {
            setErrors: props.setErrors,
            languages: props.languages,
            nlpEntities: props.nlpEntities,
            nlpEntity: props.nlpEntity,
            formPrefix: props.formPrefix,
            formIndex: props.formIndex
        }));
    };
    const renderNlpValuesItems = ()=>{
        return (0, _react.jsx)("div", {
            className: menuItemsContainer
        }, (0, _react.jsx)((0, _horizontalSeparatorDefault.default), null), props.nlpEntity.isEditable && (0, _react.jsx)((0, _reactDefault.default).Fragment, null, (0, _react.jsx)(ValuesHeading, null, (0, _react.jsx)("div", null, "Values", (0, _react.jsx)((0, _sharedStyledComponents.SmallTagWithMargin), null, valuesButtonText), props.nlpEntity.isLarge && (0, _react.jsx)((0, _sharedStyledComponents.SmallTagWithMargin), null, largeEntityInfoText)), props.nlpEntity.type === "List" && (0, _react.jsx)("div", {
            className: menuWrapperStyle
        }, (0, _react.jsx)(CustomCountButton, {
            isActive: showConfidenceScore,
            onClick: toggleConfidenceScore,
            activeIcon: blueConfidenceScoreIcon,
            inactiveIcon: confidenceScoreIcon,
            showCount: false,
            text: "Confidence Score"
        }))), showConfidenceScore && (0, _react.jsx)((0, _contentCardDefault.default), {
            title: "Confidence Score",
            icon: confidenceScoreIcon,
            className: contentCardStyle
        }, (0, _react.jsx)((0, _formFieldsContainerDefault.default), null, (0, _react.jsx)(Description, null, "Designate a score between 0 and 1 to indicate the desired level of precision for extracting this entity, where 1 represents exact matching and no fuzziness. Be mindful that any value other than 1 will have performance impacts, especially for large entities."), (0, _react.jsx)((0, _horizontalOptionsSelectorDefault.default), {
            name: thresholdField,
            options: confidenceScoreOptions,
            value: props.nlpEntity.threshold ?? 1,
            isCustom: false,
            onChange: (value)=>{
                props.setFieldValue(isModifiedField, true);
                props.setFieldValue(thresholdField, value);
            }
        })))), !props.nlpEntity.isEditable ? (0, _react.jsx)(NonEditableEntityDescription, null, (0, _react.jsx)("img", {
            src: nonEditableIcon
        }), "This entity is a pre-configured type and cannot be edited") : (0, _react.jsx)((0, _reactDefault.default).Fragment, null, !props.nlpEntity.isLarge && props.nlpEntity.type === "List" && renderNlpValuesNavigation(), renderNlpValuesActions(), props.nlpEntity.isLarge ? (0, _react.jsx)(NonEditableEntityDescription, null, (0, _react.jsx)("img", {
            src: nonEditableIcon
        }), (0, _react.jsx)("span", null, "The number of values for this entity exceeds the threshold for display ", (0, _react.jsx)("br", null), "To view/edit, please ", (0, _react.jsx)(ClickableText, {
            onClick: (e)=>exportNlpValues()
        }, "export"), " your values and ", (0, _react.jsx)(ClickableText, {
            onClick: toggleImportFileDialogModal
        }, "re-import"), " them.")) : (0, _react.jsx)((0, _reactDefault.default).Fragment, null, viewDisplayType === "ListDisplay" && renderNlpValuesListDisplay(), viewDisplayType === "TextBoxDisplay" && renderNlpEntityValuesTextBoxDisplay())));
    };
    return (0, _react.jsx)(CardContainer, null, (0, _react.jsx)(EntityHeader, null, (0, _react.jsx)("div", null, "Properties for:", (0, _react.jsx)((0, _sharedStyledComponents.SmallTag), null, props.nlpEntity.name)), (0, _react.jsx)(EntitySensitivityDropdown, {
        clickableText: props.nlpEntity.dataSensitivity === "NoTracking" ? "No Tracking" : props.nlpEntity.dataSensitivity ?? "None",
        menuClassName: dataSensitivityMenuStyle,
        label: "Data Security: ",
        onOptionSelected: (option)=>handleDataSensitivityFieldChange(option),
        options: [
            {
                label: ENTITY_SENSITIVITY_NONE,
                tooltip: "Entity does not represent sensitive data"
            },
            {
                label: ENTITY_SENSITIVITY_NOTRACKING,
                icon: noTrackingEntity,
                hoverIcon: noTrackingEntity,
                tooltip: "Entity information will not be tracked in this application's analytics"
            },
            {
                label: ENTITY_SENSITIVITY_SENSITIVE,
                icon: sensitiveEntity,
                hoverIcon: sensitiveEntity,
                tooltip: "Entity not tracked in analytics and will be encrypted for webhooks"
            }
        ]
    })), (0, _react.jsx)((0, _dirtyFormPrompt.DirtyFormPrompt), {
        promptOverride: (location)=>{
            if (location?.hash || location?.pathname?.includes("/nlp/")) return true;
            return "You have unsaved changes. Are you sure you want to leave?";
        },
        allowPrompt: props.status?.submitting != true
    }), (0, _react.jsx)((0, _horizontalSeparatorDefault.default), null), (0, _react.jsx)("fieldset", null, (0, _react.jsx)((0, _textFieldDefault.default), {
        name: nameField,
        className: textFieldStyle,
        disabled: disableFields,
        required: true,
        placeholder: "NLP Entity Name",
        value: props.nlpEntity.name,
        label: "Name",
        onChange: (e)=>handleNlpEntityNameChange(nameField, e),
        onBlur: props.handleBlur,
        autoFocus: true,
        onKeyPress: handleNlpEntityNameKeyUp
    }), (0, _react.jsx)((0, _contentLanguageMultiSelectorDefault.default), {
        disabled: disableFields,
        id: "contentLanguage",
        label: "Apply to Region",
        languages: props.languages,
        selectedLanguageIds: selectedLanguageIds,
        onChange: handleLanguagesChange
    }), renderNlpValuesItems()), isImportFileDialogModalOpen && (0, _react.jsx)((0, _importFileDialogDefault.default), {
        onClose: toggleImportFileDialogModal,
        completeImport: importNlpValues,
        title: "Select NLP Values file to import",
        acceptFileTypes: ".csv, .txt",
        acceptFileTypesDisplayText: "Supports .csv, .txt",
        isLoading: isImporting,
        errors: fileImportErrors
    }), isConfirmImportValuesModalOpen && (0, _react.jsx)((0, _confirmationDialogDefault.default), {
        title: `Confirm Overwrite`,
        deleteText: "Yes, Overwrite",
        isLoading: isImporting,
        onClose: toggleConfirmImportValuesModal,
        onConfirm: ()=>{
            setIsImporting(true);
            overwriteNlpValuesFromImport();
        }
    }, (0, _react.jsx)((0, _warningConfirmationDefault.default), {
        text: `Importing these values will replace any existing values for this entity. To preserve the existing values, export them and combine everything into a single file to be imported.`
    })));
};
exports.default = ApplicationNlpEntityCard;
const contentCardStyle = /*#__PURE__*/ (0, _css.css)({
    name: "yz1nei",
    styles: "margin-top:16px"
});
const CustomCountButton = /*#__PURE__*/ (0, _baseDefault.default)((0, _countButton.CountButton), {
    target: "e1a49s9v18"
})({
    name: "1wcfv52",
    styles: "margin-right:0"
});
const menuWrapperStyle = /*#__PURE__*/ (0, _css.css)("display:flex;align-items:center;justify-content:flex-end;.validation-button{height:32px;padding:0 24px;background:", (0, _colors.color_gradients_silver_shift), ";border:", (0, _stylesValues.style_border_default), ";box-shadow:none;border-radius:16px;box-sizing:border-box;color:", (0, _colors.color_text_default), ";font-size:14px;line-height:20px;cursor:pointer;display:flex;align-items:center;font-family:'Muli';}.toggled{background:", (0, _colors.color_variants_ocean_light_opaque), ";border:1px solid ", (0, _colors.color_colors_ocean), ";color:", (0, _colors.color_colors_ocean), ";}", "");
const ValuesHeading = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1a49s9v17"
})({
    name: "1eoy87d",
    styles: "display:flex;justify-content:space-between"
});
const textFieldStyle = /*#__PURE__*/ (0, _css.css)({
    name: "yz1nei",
    styles: "margin-top:16px"
});
const Description = /*#__PURE__*/ (0, _baseDefault.default)("p", {
    target: "e1a49s9v16"
})({
    name: "1s22u92",
    styles: "margin-bottom:32px"
});
const CardContainer = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1a49s9v15"
})({
    name: "pinkt9",
    styles: ".field-wrapper{label{font-size:14px;line-height:20px;font-weight:400;}}.field-container{height:44px;}label{font-size:14px;line-height:20px;font-weight:400;}"
});
const triangleStyle = /*#__PURE__*/ (0, _css.css)({
    name: "1ime291",
    styles: "transform:rotate(45deg);width:12px;height:12px;margin-top:-7px;margin-bottom:-6px;border-top:solid 1px #cccccc;border-left:solid 1px #cccccc;background:white;margin-left:160px;margin-right:auto"
});
const EntityHeader = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1a49s9v14"
})({
    name: "13ks4oq",
    styles: "button{margin:0 0 16px 8px;}margin:0;display:flex;justify-content:space-between"
});
const EntitySensitivityDropdown = /*#__PURE__*/ (0, _baseDefault.default)((0, _textOverflowMenuDefault.default), {
    target: "e1a49s9v13"
})({
    name: "hkh81z",
    styles: "margin-top:8px"
});
const menuItemsContainer = /*#__PURE__*/ (0, _css.css)({
    name: "9nji6z",
    styles: "position:relative;height:auto;padding-top:16px"
});
const valuesNavigationContainer = /*#__PURE__*/ (0, _css.css)({
    name: "12yxpji",
    styles: "display:flex;justify-content:space-between;align-items:center;.label{font-size:12px;font-weight:400;text-align:left;padding:0 0 4px 16px;}"
});
const valuesViewDisplayType = /*#__PURE__*/ (0, _css.css)({
    name: "degjtc",
    styles: "text-align:center;min-width:224px"
});
const dataSensitivityMenuStyle = /*#__PURE__*/ (0, _css.css)({
    name: "146rubr",
    styles: "margin-left:unset;right:-20px"
});
const roundedSelectStyle = /*#__PURE__*/ (0, _css.css)({
    name: "s0vnfv",
    styles: "height:32px"
});
const roundedOptionStyle = /*#__PURE__*/ (0, _css.css)({
    name: "zwe5g6",
    styles: "height:34px"
});
const valuesActionsContainer = /*#__PURE__*/ (0, _css.css)({
    name: "1wwdce3",
    styles: "display:flex;flex-direction:row;padding-top:16px;align-items:center;justify-content:space-between"
});
const searchPadding = /*#__PURE__*/ (0, _css.css)({
    name: "1nuhno9",
    styles: "padding-top:8px"
});
const ImportExportSpan = /*#__PURE__*/ (0, _baseDefault.default)("span", {
    target: "e1a49s9v12"
})("color:", (0, _colors.color_text_link), ";");
const ImportExportDiv = /*#__PURE__*/ (0, _baseDefault.default)("span", {
    target: "e1a49s9v11"
})({
    name: "1n2qanb",
    styles: "padding-left:24px"
});
const ImportExport = /*#__PURE__*/ (0, _baseDefault.default)("span", {
    target: "e1a49s9v10"
})({
    name: "68ospr",
    styles: "margin-left:auto;align-items:center;cursor:pointer"
});
const AddAndSearchDiv = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1a49s9v9"
})({
    name: "lmvtfu",
    styles: "text-align:left;min-width:224px"
});
const SearchResultDiv = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1a49s9v8"
})({
    name: "1nuhno9",
    styles: "padding-top:8px"
});
const ImportExportImg = /*#__PURE__*/ (0, _baseDefault.default)("img", {
    target: "e1a49s9v7"
})({
    name: "1istfun",
    styles: "height:20px;width:20px;margin-left:8px;vertical-align:middle"
});
const AddAValueButton = /*#__PURE__*/ (0, _baseDefault.default)((0, _buttonDefault.default), {
    target: "e1a49s9v6"
})({
    name: "1ecd97i",
    styles: "margin-right:auto;margin-top:0px"
});
const QuestionButton = /*#__PURE__*/ (0, _css.css)({
    name: "13g2ub9",
    styles: "padding-left:8px;margin-left:16px;height:32px;width:32px;vertical-align:middle"
});
const SelectedQuestionButton = /*#__PURE__*/ (0, _css.css)("padding-left:8px;margin-left:16px;height:32px;width:32px;vertical-align:middle;background-color:", (0, _colors.color_variants_ocean_light_opaque), ";border-color:", (0, _colors.color_colors_ocean), ";", "");
const ClearButton = /*#__PURE__*/ (0, _baseDefault.default)((0, _buttonDefault.default), {
    target: "e1a49s9v5"
})({
    name: "97w96s",
    styles: "height:32px;img{width:14px;height:14px;cursor:pointer;}margin-left:auto"
});
const NoResultsDiv = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1a49s9v4"
})("width:100%;display:flex;background:white;border-radius:8px;border:solid 1px ", (0, _colors.color_shades_dark), ";height:48px;vertical-align:middle;align-items:center;");
const NoResultsImg = /*#__PURE__*/ (0, _baseDefault.default)("img", {
    target: "e1a49s9v3"
})({
    name: "npea74",
    styles: "height:25px;width:25px;margin-right:16px;margin-left:16px"
});
const NonEditableEntityDescription = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1a49s9v2"
})("background:white;border:1px solid ", (0, _colors.color_shades_dark), ";border-radius:8px;color:", (0, _colors.color_shades_darkest), ";padding:24px;font-weight:400;font-size:18px;max-height:144px;width:auto;display:flex;flex-direction:column;text-align:center;font-style:italic;margin-top:16px;img{margin-left:auto;margin-right:auto;margin-bottom:8px;}");
const ClickableText = /*#__PURE__*/ (0, _baseDefault.default)("span", {
    target: "e1a49s9v1"
})("color:", (0, _colors.color_colors_ocean), ";cursor:pointer;");
const Spacer = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1a49s9v0"
})({
    name: "6jwybp",
    styles: "height:16px"
});

},{"@babel/runtime/helpers/extends":"4iKIP","@emotion/styled/base":"lSuFu","@emotion/react":"djZKr","react":"6uln9","../../formScenes/components/DirtyFormPrompt":"i9WDI","../../../components/forms/ContentLanguageMultiSelector":"4SbwP","../../../components/forms/TextField":"7a7bh","../../../components/general/Button":"6ymxN","../../../components/structure/HorizontalSeparator":"Pw3HQ","@emotion/css":"awUBr","../../../components/forms/NumberIncrementSelector":"kU0zB","../../../components/forms/SearchField":"aU10T","../../../components/general/RoundedSelectionRow":"dUH5O","./NlpEntityValuesListDisplay":"cscGX","./NlpEntityValuesTextBoxDisplay":"fwWjm","../../../hooks/ApplicationNlpEntityContainer":"6IUi8","../../../components/general/ImportFileDialog":"7LQaS","../../../components/structure/ConfirmationDialog":"kx7yK","../../../components/general/WarningConfirmation":"9OccO","../../../constants/colors":"1p3OR","./SharedStyledComponents":"g3EMz","./InteractionModelForm":"9RN9X","../../../components/general/overflowMenu/TextOverflowMenu":"iiFcw","../../../components/structure/FormFieldsContainer":"h3hzh","../../../components/forms/HorizontalOptionsSelector":"6A3ab","../../../constants/stylesValues":"dHVVv","../../contentPage/components/CountButton":"dGBKj","../../../components/structure/ContentCard":"hJsdJ","300924717f7d2130":"93VwA","e0fb27f6e79f920":"2Wrg7","b327cf4edb68396c":"JdePy","e28d03f327c9d5da":"48meH","f0cde3cd0230ab6":"dTLvY","14c66fb8555f5ce4":"jlgVO","1d615fbd19c22e1c":"kdXIL","166b0a3a18c6b5b":"4XE64","135919f5fb9b35a":"3HdTe","853facfc7061ab08":"fjmlt","96a90cb766437b19":"RPqVb","acc39a324ab3dd70":"lyz7r","e2f3cbf1c51332f9":"fXyPs","1b90fb59eece2a0d":"elYBX","969eafb21bcaf05c":"8UZxi","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"cscGX":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _extends = require("@babel/runtime/helpers/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _formik = require("formik");
var _nlpEntityValueItem = require("./NlpEntityValueItem");
var _nlpEntityValueItemDefault = parcelHelpers.interopDefault(_nlpEntityValueItem);
const NlpEntityValuesListDisplay = (props)=>{
    const cardPrefix = `${props.formPrefix}.${props.formIndex}`;
    const valuesField = `${cardPrefix}.values`;
    const isModifiedField = `${cardPrefix}.isModified`;
    (0, _react1.useEffect)(function resetActiveItemIndexOnEntitySelection() {
        props.toggleItemActivationByIndex(-1);
    }, [
        props.formIndex
    ]);
    const deleteNlpValueByIndex = (index, arrayHelpers)=>{
        props.toggleItemActivationByIndex(-1);
        arrayHelpers.remove(index);
        props.setFieldValue(isModifiedField, true);
    };
    const renderNlpEntityMenuItem = (nlpEntityValueToRender, index, arrayHelpers)=>{
        const isActive = index === props.activeItemIndex;
        return (0, _react.jsx)((0, _nlpEntityValueItemDefault.default), (0, _extendsDefault.default)({}, props, {
            toggleItemActivationByIndex: props.toggleItemActivationByIndex,
            deleteNlpValueByIndex: (idx)=>deleteNlpValueByIndex(idx, arrayHelpers),
            languages: props.languages,
            nlpEntity: props.nlpEntity,
            isActive: isActive,
            key: index,
            formPrefix: props.formPrefix,
            formIndex: props.formIndex,
            nlpValue: nlpEntityValueToRender,
            nlpValueIndex: index
        }));
    };
    const renderNlpValuesList = ()=>{
        return (0, _react.jsx)((0, _reactDefault.default).Fragment, null, props.valuesFormDisplayInfo ? (0, _react.jsx)((0, _formik.FieldArray), {
            validateOnChange: true,
            name: valuesField,
            render: (arrayHelpers)=>props.valuesFormDisplayInfo?.map((item, index)=>{
                    // Pagination - only display items that are in the range 
                    if (item.displayIndex >= props.numberOfValuesPerPage * (props.valuesPageNumber - 1) && item.displayIndex < props.numberOfValuesPerPage * props.valuesPageNumber) return renderNlpEntityMenuItem(item.nlpEntityValue, item.originalArrayIndex, arrayHelpers);
                    return null;
                })
        }) : null);
    };
    return renderNlpValuesList();
};
exports.default = NlpEntityValuesListDisplay;

},{"@babel/runtime/helpers/extends":"4iKIP","@emotion/react":"djZKr","react":"6uln9","formik":"3YnOK","./NlpEntityValueItem":"fGnrq","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"fGnrq":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _extends = require("@babel/runtime/helpers/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _base = require("@emotion/styled/base");
var _baseDefault = parcelHelpers.interopDefault(_base);
var _react = require("@emotion/react");
var _css = require("@emotion/css");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _button = require("../../../components/general/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _errorLabel = require("../../../components/general/ErrorLabel");
var _errorLabelDefault = parcelHelpers.interopDefault(_errorLabel);
var _tooltipWrapper = require("../../../components/general/TooltipWrapper");
var _tooltipWrapperDefault = parcelHelpers.interopDefault(_tooltipWrapper);
var _colors = require("../../../constants/colors");
var _countButton = require("../../contentPage/components/CountButton");
var _entityMetadataModal = require("./EntityMetadataModal");
var _entityMetadataModalDefault = parcelHelpers.interopDefault(_entityMetadataModal);
var _interactionModelForm = require("./InteractionModelForm");
var _nlpEntityValueCard = require("./NlpEntityValueCard");
var _nlpEntityValueCardDefault = parcelHelpers.interopDefault(_nlpEntityValueCard);
var _sharedStyledComponents = require("./SharedStyledComponents");
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const deleteIcon = require("611b478f83e1ae3a");
const alertIcon = require("50e1138a12adf771");
const metadataIcon = require("b0baa88f33ae135f");
const NlpEntityValueItem = (props)=>{
    const [showMetadataModal, setShowMetadataModal] = (0, _react1.useState)(false);
    const isActive = props.isActive;
    const nlpEntityValue = props.nlpValue;
    const nlpEntityValueName = nlpEntityValue?.name;
    const nlpEntityValueSynonyms = nlpEntityValue?.synonyms;
    const nlpEntityValueTitle = nlpEntityValueName ? nlpEntityValueName?.trim().length > (0, _interactionModelForm.maxNlpEntityNameSize) ? nlpEntityValueName.trim().substring(0, (0, _interactionModelForm.maxNlpEntityNameSize)) + "..." : nlpEntityValueName : props.nlpEntity.type === "Regex" ? `Pattern ${props.nlpValueIndex + 1}` : `New ${props.nlpEntity.type} Value`;
    const disableFields = !props.nlpEntity.isEditable || props.nlpEntity.isDeleted; //|| props.isSubmitting || props.isValidating 
    const hasErrors = props.errors?.[props.formPrefix]?.[props.formIndex]?.["values"]?.[props.nlpValueIndex];
    const handleItemToggleActivation = (index)=>{
        if (isActive) //Close
        props.toggleItemActivationByIndex(-1);
        else //Open
        props.toggleItemActivationByIndex(index);
    };
    const handleKeyUp = (event)=>{
        if (disableFields) return;
        if (event.key === "Escape") handleItemToggleActivation(-1);
    };
    const handleDeleteItem = (event)=>{
        event.stopPropagation();
        props.deleteNlpValueByIndex(props.nlpValueIndex);
    };
    const handleShowMetadataModal = (event)=>{
        event.stopPropagation();
        setShowMetadataModal(true);
    };
    const renderItemName = ()=>{
        return (0, _react.jsx)("div", {
            className: itemTitle,
            key: props.nlpValueIndex
        }, (0, _react.jsx)((0, _sharedStyledComponents.SmallTagWithMargin), null, nlpEntityValueTitle), nlpEntityValueSynonyms?.length > 0 && (0, _react.jsx)((0, _sharedStyledComponents.SmallTagWithMargin), null, "+" + nlpEntityValueSynonyms?.length.toString()));
    };
    const renderItemActions = ()=>{
        return (0, _react.jsx)("div", {
            className: itemActions
        }, hasErrors && (0, _react.jsx)((0, _errorLabelDefault.default), {
            image: alertIcon,
            text: "Errors Present"
        }), !disableFields && (0, _react.jsx)(MetadataButton, null, (0, _react.jsx)((0, _countButton.CountButton), {
            isActive: false,
            onClick: (event)=>handleShowMetadataModal(event),
            activeIcon: metadataIcon,
            inactiveIcon: metadataIcon,
            showCount: true,
            count: Object.keys(nlpEntityValue.metadata ?? {}).length,
            text: "Metadata"
        })), !disableFields && (0, _react.jsx)((0, _tooltipWrapperDefault.default), {
            text: "Delete"
        }, (0, _react.jsx)("div", null, (0, _react.jsx)((0, _buttonDefault.default), {
            themes: [
                "icon",
                "end-tight"
            ],
            icon: deleteIcon,
            type: "button",
            disabled: disableFields,
            onClick: (event)=>handleDeleteItem(event)
        }))));
    };
    const renderNlpEntityDisplayItem = ()=>{
        return (0, _react.jsx)("div", {
            className: `${itemContainer} ${isActive ? "active" : ""}`,
            onKeyUp: handleKeyUp
        }, (0, _react.jsx)("div", {
            className: `${itemHeader} ${isActive ? "active" : ""}`,
            key: `menuItem-${props.nlpValueIndex}`,
            onClick: ()=>handleItemToggleActivation(props.nlpValueIndex)
        }, renderItemName(), renderItemActions()), isActive && (0, _react.jsx)((0, _nlpEntityValueCardDefault.default), (0, _extendsDefault.default)({}, props, {
            languages: props.languages,
            nlpEntity: props.nlpEntity,
            key: props.nlpValueIndex,
            formPrefix: props.formPrefix,
            formIndex: props.formIndex,
            nlpValue: props.nlpValue,
            nlpValueIndex: props.nlpValueIndex
        })), showMetadataModal && (0, _react.jsx)((0, _entityMetadataModalDefault.default), {
            metadata: props.nlpValue.metadata,
            handleUpdate: (metadata)=>{
                if (metadata !== props.nlpValue.metadata) {
                    props.setFieldValue(`${props.formPrefix}.${props.formIndex}.isModified`, true);
                    props.setFieldValue(`${props.formPrefix}.${props.formIndex}.values.${props.nlpValueIndex}.metadata`, metadata);
                }
            },
            handleClose: ()=>{
                setShowMetadataModal(false);
            }
        }));
    };
    return renderNlpEntityDisplayItem();
};
exports.default = NlpEntityValueItem;
const itemContainer = /*#__PURE__*/ (0, _css.css)("border:1px solid ", (0, _colors.color_shades_dark), ";border-radius:8px;margin:8px 0 8px 0;padding:0 16px 0 16px;&.active{border:1px solid ", (0, _colors.color_colors_ocean), ";box-shadow:0px 0px 4px 4px ", (0, _colors.color_variants_ocean_light_2), ";min-height:56px;height:auto;}", "");
const itemHeader = /*#__PURE__*/ (0, _css.css)({
    name: "d1w3fo",
    styles: "height:56px;display:flex;justify-content:space-between;cursor:pointer"
});
const itemTitle = /*#__PURE__*/ (0, _css.css)("display:flex;flex-direction:row;align-items:center;font-size:18px;color:", (0, _colors.color_text_default), ";position:relative;", "");
const itemActions = /*#__PURE__*/ (0, _css.css)({
    name: "zjik7",
    styles: "display:flex"
});
const MetadataButton = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "eukra6d0"
})({
    name: "95ls12",
    styles: "margin-right:8px;margin-top:12px"
});

},{"@babel/runtime/helpers/extends":"4iKIP","@emotion/styled/base":"lSuFu","@emotion/react":"djZKr","@emotion/css":"awUBr","react":"6uln9","../../../components/general/Button":"6ymxN","../../../components/general/ErrorLabel":"k9Ob0","../../../components/general/TooltipWrapper":"53pWd","../../../constants/colors":"1p3OR","../../contentPage/components/CountButton":"dGBKj","./EntityMetadataModal":"3Q6tZ","./InteractionModelForm":"9RN9X","./NlpEntityValueCard":"3OBWp","./SharedStyledComponents":"g3EMz","611b478f83e1ae3a":"7eyKJ","50e1138a12adf771":"cRA6k","b0baa88f33ae135f":"2nTcT","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3Q6tZ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _base = require("@emotion/styled/base");
var _baseDefault = parcelHelpers.interopDefault(_base);
var _react = require("@emotion/react");
var _css = require("@emotion/css");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _textField = require("../../../components/forms/TextField");
var _textFieldDefault = parcelHelpers.interopDefault(_textField);
var _button = require("../../../components/general/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _modalHeader = require("../../../components/general/ModalHeader");
var _modalHeaderDefault = parcelHelpers.interopDefault(_modalHeader);
var _customScrollbars = require("../../../components/structure/CustomScrollbars");
var _customScrollbarsDefault = parcelHelpers.interopDefault(_customScrollbars);
var _footerBar = require("../../../components/structure/FooterBar");
var _footerBarDefault = parcelHelpers.interopDefault(_footerBar);
var _modalLayout = require("../../../components/structure/ModalLayout");
var _modalLayoutDefault = parcelHelpers.interopDefault(_modalLayout);
var _colors = require("../../../constants/colors");
var _useWindowSize = require("../../../hooks/UseWindowSize");
var _useWindowSizeDefault = parcelHelpers.interopDefault(_useWindowSize);
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const deleteIcon = require("3598a3ae5e8a4164");
const EntityMetadataModal = (props)=>{
    const [metadata, setMetadata] = (0, _react1.useState)([]);
    const windowSize = (0, _useWindowSizeDefault.default)();
    (0, _react1.useEffect)(()=>{
        let meta = [];
        for(let key in props.metadata)meta.push({
            key,
            value: convertValueToString(props.metadata[key])
        });
        setMetadata(meta);
    }, []);
    const mapMetadata = ()=>{
        let meta = {};
        for (let kv of metadata)if (isJsonString(kv.value)) meta[kv.key] = JSON.parse(kv.value);
        else meta[kv.key] = kv.value;
        return meta;
    };
    const updateKey = (idx, e)=>{
        let newMetadata = [
            ...metadata
        ];
        newMetadata[idx].key = e.target.value;
        setMetadata(newMetadata);
    };
    const updateValue = (idx, e)=>{
        let newMetadata = [
            ...metadata
        ];
        newMetadata[idx].value = e.target.value;
        setMetadata(newMetadata);
    };
    const removeMetadata = (idx)=>{
        let newMetadata = [
            ...metadata
        ];
        newMetadata.splice(idx, 1);
        setMetadata(newMetadata);
    };
    const convertValueToString = (val)=>{
        if (typeof val === "string") return val;
        else return JSON.stringify(val);
    };
    const isJsonString = (str)=>{
        try {
            JSON.parse(str);
        } catch (e) {
            return false;
        }
        return true;
    };
    return (0, _react.jsx)(MetadataModal, {
        isVisible: true
    }, (0, _react.jsx)((0, _modalHeaderDefault.default), {
        title: "Entity Metadata",
        onClose: ()=>props.handleClose()
    }), (0, _react.jsx)(MetadataHolder, null, (0, _react.jsx)((0, _customScrollbarsDefault.default), {
        autoHide: true,
        autoHeight: true,
        autoHeightMin: windowSize.windowSize.innerHeight * .6 - 184,
        autoHeightMax: windowSize.windowSize.innerHeight * .6 - 184
    }, (0, _react.jsx)((0, _buttonDefault.default), {
        themes: [
            "flat"
        ],
        text: "+ Add Metadata",
        type: "button",
        className: addProperty,
        onClick: ()=>{
            setMetadata([
                ...metadata,
                {
                    key: "",
                    value: ""
                }
            ]);
        }
    }), (0, _react.jsx)((0, _reactDefault.default).Fragment, null, !!metadata.length ? metadata.map((m, idx)=>{
        return (0, _react.jsx)(FieldContainer, {
            key: idx
        }, (0, _react.jsx)((0, _textFieldDefault.default), {
            label: "Key",
            onChange: (e)=>updateKey(idx, e),
            value: m.key,
            type: "text",
            useForm: false,
            className: leftField
        }), (0, _react.jsx)((0, _textFieldDefault.default), {
            label: "Value",
            onChange: (e)=>updateValue(idx, e),
            value: convertValueToString(m.value),
            type: "text",
            useForm: false,
            className: rightField
        }), (0, _react.jsx)(RemoveIcon, {
            themes: [
                "icon",
                "end-tight"
            ],
            icon: deleteIcon,
            type: "button",
            onClick: ()=>removeMetadata(idx)
        }));
    }) : null))), (0, _react.jsx)((0, _footerBarDefault.default), null, (0, _react.jsx)(UpdateButton, {
        type: "button",
        themes: [
            "primary"
        ],
        text: "Update",
        onClick: ()=>{
            props.handleUpdate(mapMetadata());
            props.handleClose();
        }
    }), (0, _react.jsx)((0, _buttonDefault.default), {
        type: "button",
        themes: [
            "secondary"
        ],
        text: "Cancel",
        onClick: ()=>props.handleClose()
    })));
};
const MetadataHolder = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1cixj2x4"
})({
    name: "1b2w9pa",
    styles: "margin:0px 32px 32px 32px"
});
const MetadataModal = /*#__PURE__*/ (0, _baseDefault.default)((0, _modalLayoutDefault.default), {
    target: "e1cixj2x3"
})("color:", (0, _colors.color_text_default), ";width:40%;height:60%;min-height:60%;min-width:40%;");
const UpdateButton = /*#__PURE__*/ (0, _baseDefault.default)((0, _buttonDefault.default), {
    target: "e1cixj2x2"
})({
    name: "1tx1l5v",
    styles: "margin-right:auto"
});
const addProperty = /*#__PURE__*/ (0, _css.css)("color:", (0, _colors.text_blue), " margin-bottom:16px;box-shadow:none;margin-left:0px;border:0;padding-left:0px;", "");
const leftField = /*#__PURE__*/ (0, _css.css)({
    name: "o7nnmj",
    styles: "margin-right:16px"
});
const rightField = /*#__PURE__*/ (0, _css.css)({
    name: "eahhht",
    styles: "margin-left:16px;margin-right:16px"
});
const FieldContainer = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1cixj2x1"
})({
    name: "ho1qnd",
    styles: "display:flex;flex-direction:row"
});
const RemoveIcon = /*#__PURE__*/ (0, _baseDefault.default)((0, _buttonDefault.default), {
    target: "e1cixj2x0"
})({
    name: "1da0jw",
    styles: "margin-top:37px;margin-left:8px"
});
exports.default = EntityMetadataModal;

},{"@emotion/styled/base":"lSuFu","@emotion/react":"djZKr","@emotion/css":"awUBr","react":"6uln9","../../../components/forms/TextField":"7a7bh","../../../components/general/Button":"6ymxN","../../../components/general/ModalHeader":"aUACx","../../../components/structure/CustomScrollbars":"50vFq","../../../components/structure/FooterBar":"bibRL","../../../components/structure/ModalLayout":"b1cO3","../../../constants/colors":"1p3OR","../../../hooks/UseWindowSize":"43j9z","3598a3ae5e8a4164":"7eyKJ","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3OBWp":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _base = require("@emotion/styled/base");
var _baseDefault = parcelHelpers.interopDefault(_base);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _textField = require("../../../components/forms/TextField");
var _textFieldDefault = parcelHelpers.interopDefault(_textField);
var _horizontalSeparator = require("../../../components/structure/HorizontalSeparator");
var _horizontalSeparatorDefault = parcelHelpers.interopDefault(_horizontalSeparator);
var _synonymsEditor = require("./SynonymsEditor");
var _synonymsEditorDefault = parcelHelpers.interopDefault(_synonymsEditor);
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const closeIcon = require("dc85c6d406ffb53");
const addIcon = require("bc83a8014e268df8");
const NlpEntityValueCard = (props)=>{
    const nlpEntityValue = props.nlpValue;
    const nlpEntityValueName = props.nlpValue?.name;
    const nlpEntityValueSynonyms = props.nlpValue?.synonyms;
    const disableFields = !props.nlpEntity.isEditable || props.nlpEntity.isDeleted; //|| props.isSubmitting || props.isValidating
    const isModifiedField = `${props.formPrefix}.${props.formIndex}.isModified`;
    const cardPrefix = `${props.formPrefix}.${props.formIndex}.values.${props.nlpValueIndex}`;
    const nameFieldName = `${cardPrefix}.name`;
    const patternFieldName = `${cardPrefix}.pattern`;
    const synonymsFieldName = `${cardPrefix}.synonyms`;
    (0, _react1.useEffect)(function resetNlpValueSynonymOnEntitySelect() {}, [
        props.formIndex
    ]);
    const handleDeleteSynonym = (index, arrayHelpers)=>{
        arrayHelpers.remove(index);
        props.setFieldValue(isModifiedField, true);
    };
    const handleAddSynonym = (synonym)=>{
        const error = validateNlpValueSynonym(synonym);
        if (error) return;
        const index = props.nlpValue?.synonyms?.length ?? 0;
        props.setFieldValue(`${synonymsFieldName}.${index}`, synonym);
        props.setFieldValue(isModifiedField, true);
    };
    const validateNlpValueSynonym = (value)=>{
        let error;
        if (!value || value.trim() == "") error = "List Value Synonym cannot be empty";
        return error;
    };
    const handleChange = (fieldName, event)=>{
        props.setFieldValue(isModifiedField, true);
        props.handleChange(event);
    };
    const renderListTypeEdits = ()=>{
        return (0, _react.jsx)((0, _reactDefault.default).Fragment, null, (0, _react.jsx)((0, _textFieldDefault.default), {
            name: nameFieldName,
            disabled: disableFields,
            required: true,
            placeholder: "Name",
            defaultValue: nlpEntityValueName,
            label: "Name",
            onChange: (e)=>handleChange(nameFieldName, e),
            onBlur: props.handleBlur,
            autoFocus: true,
            key: props.nlpValueIndex
        }), (0, _react.jsx)(SynonymsHeader, null, " SYNONYMS "), (0, _react.jsx)((0, _synonymsEditorDefault.default), {
            synonyms: nlpEntityValueSynonyms,
            synonymsFieldName: synonymsFieldName,
            disableFields: disableFields,
            handleDelete: handleDeleteSynonym,
            handleAddSynonym: handleAddSynonym,
            handleBlur: props.handleBlur,
            autofocusNewSynonym: !nlpEntityValue.isAdded
        }));
    };
    const renderRegexTypeEdits = ()=>{
        return (0, _react.jsx)((0, _reactDefault.default).Fragment, null, (0, _react.jsx)("div", {
            key: `${cardPrefix}.regex`
        }, (0, _react.jsx)((0, _textFieldDefault.default), {
            name: patternFieldName,
            disabled: disableFields,
            required: true,
            placeholder: "NLP Entity Regex Pattern",
            defaultValue: nlpEntityValue.pattern,
            label: "Regex",
            onChange: (e)=>handleChange(patternFieldName, e),
            onBlur: props.handleBlur,
            autoFocus: true
        })));
    };
    const renderNativeTypeEdits = ()=>{
        return (0, _react.jsx)((0, _reactDefault.default).Fragment, null);
    };
    return (0, _react.jsx)(CardContainer, null, (0, _react.jsx)((0, _horizontalSeparatorDefault.default), null), (0, _react.jsx)("fieldset", null, props.nlpEntity.type === "Regex" && renderRegexTypeEdits(), props.nlpEntity.type === "Native" && renderNativeTypeEdits(), props.nlpEntity.type === "List" && renderListTypeEdits()));
};
exports.default = NlpEntityValueCard;
const CardContainer = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1nq28f71"
})({
    name: "xywffh",
    styles: "padding:0 16px 0 16px;.field-wrapper{label{font-size:14px;line-height:20px;font-weight:400;}}.field-container{height:44px;}label{font-size:14px;line-height:20px;font-weight:400;}.new-field-container{display:flex;}"
});
const SynonymsHeader = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1nq28f70"
})({
    name: "5bhc30",
    styles: "margin-bottom:8px"
});

},{"@emotion/styled/base":"lSuFu","@emotion/react":"djZKr","react":"6uln9","../../../components/forms/TextField":"7a7bh","../../../components/structure/HorizontalSeparator":"Pw3HQ","./SynonymsEditor":"8oyHd","dc85c6d406ffb53":"93VwA","bc83a8014e268df8":"6cI2N","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8oyHd":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _base = require("@emotion/styled/base");
var _baseDefault = parcelHelpers.interopDefault(_base);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _textField = require("../../../components/forms/TextField");
var _textFieldDefault = parcelHelpers.interopDefault(_textField);
var _button = require("../../../components/general/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _colors = require("../../../constants/colors");
var _formik = require("formik");
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const closeIcon = require("c67e28b99c2dca9f");
const addIcon = require("bf21fffef25e4255");
const SynonymsEditor = (props)=>{
    const [newSynonymValue, setNewSynonymValue] = (0, _react1.useState)("");
    const handleNewSynonymKeyUp = (event)=>{
        if (props.disableFields) return;
        if (event.key === "Escape") // Clear new synonym
        setNewSynonymValue("");
        else if (event.key === "Enter") {
            // Add new synonym
            props.handleAddSynonym(newSynonymValue);
            setNewSynonymValue("");
        }
        event.stopPropagation();
    };
    const handleAddNewSynonymChange = (event)=>{
        const synonym = event.target.value;
        setNewSynonymValue(synonym);
    };
    return (0, _react.jsx)(CardContainer, {
        className: props.className ?? ""
    }, (0, _react.jsx)("fieldset", null, props.synonyms && (0, _react.jsx)(SynonymsHolder, null, (0, _react.jsx)((0, _formik.FieldArray), {
        validateOnChange: false,
        name: props.synonymsFieldName,
        render: (arrayHelpers)=>props.synonyms?.map((synonym, synIndex)=>(0, _react.jsx)(SynonymChip, {
                    key: `display-${props.synonymsFieldName}.${synIndex}`
                }, (0, _react.jsx)("span", null, synonym), props.disableFields ? null : (0, _react.jsx)("img", {
                    onClick: ()=>props.handleDelete(synIndex, arrayHelpers),
                    src: closeIcon
                })))
    })), !props.disableFields && (0, _react.jsx)((0, _reactDefault.default).Fragment, null, (0, _react.jsx)("div", {
        className: "new-field-container",
        key: `${props.synonymsFieldName}.addNewContainer`,
        onKeyUp: handleNewSynonymKeyUp
    }, (0, _react.jsx)((0, _textFieldDefault.default), {
        disabled: props.disableFields,
        placeholder: props.placeholder ? props.placeholder : "Add a synonym",
        value: newSynonymValue,
        onChange: handleAddNewSynonymChange,
        onBlur: props.handleBlur,
        useForm: false,
        autoFocus: props.autofocusNewSynonym
    }), (0, _react.jsx)(AddSynonymButton, {
        type: "button",
        themes: [
            "icon",
            "end-tight"
        ],
        icon: addIcon,
        disabled: !newSynonymValue || props.disableFields,
        onClick: ()=>{
            props.handleAddSynonym(newSynonymValue);
            setNewSynonymValue("");
        }
    })))));
};
exports.default = SynonymsEditor;
const SynonymChip = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "er7e0c33"
})("height:42px;padding:0 8px 0 16px;margin:0 8px 8px 0;display:flex;flex-direction:row;background:", (0, _colors.color_shades_light), ";border-radius:32px;line-height:40px;img{width:14px;height:14px;cursor:pointer;margin:14px 4px 0px 8px;}");
const SynonymsHolder = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "er7e0c32"
})({
    name: "jovua5",
    styles: "display:flex;flex-direction:row;flex-wrap:wrap"
});
const CardContainer = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "er7e0c31"
})({
    name: "1o3lb2u",
    styles: ".field-wrapper{label{font-size:14px;line-height:20px;font-weight:400;}}.field-container{height:44px;}label{font-size:14px;line-height:20px;font-weight:400;}.new-field-container{display:flex;}"
});
const AddSynonymButton = /*#__PURE__*/ (0, _baseDefault.default)((0, _buttonDefault.default), {
    target: "er7e0c30"
})({
    name: "vu0p6t",
    styles: "margin-left:16px;padding-top:2px"
});

},{"@emotion/styled/base":"lSuFu","@emotion/react":"djZKr","react":"6uln9","../../../components/forms/TextField":"7a7bh","../../../components/general/Button":"6ymxN","../../../constants/colors":"1p3OR","formik":"3YnOK","c67e28b99c2dca9f":"93VwA","bf21fffef25e4255":"6cI2N","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"g3EMz":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SmallTag", ()=>SmallTag);
parcelHelpers.export(exports, "SmallTagWithMargin", ()=>SmallTagWithMargin);
var _base = require("@emotion/styled/base");
var _baseDefault = parcelHelpers.interopDefault(_base);
var _colors = require("../../../constants/colors");
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const SmallTag = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1tk8vk21"
})("position:relative;white-space:nowrap;margin:0px 16px 16px 16px;font-family:Muli;font-style:normal;font-stretch:normal;letter-spacing:0.4px;text-align:center;padding:6px 24px 0px 24px;font-size:14px;font-weight:600;background:", (0, _colors.color_gradients_silver_shift), ";color:", (0, _colors.color_text_default), ";border:solid 1px ", (0, _colors.color_shades_dark), ";border-radius:16px;height:32px;display:inline-block;");
const SmallTagWithMargin = /*#__PURE__*/ (0, _baseDefault.default)(SmallTag, {
    target: "e1tk8vk20"
})({
    name: "yz1nei",
    styles: "margin-top:16px"
});

},{"@emotion/styled/base":"lSuFu","../../../constants/colors":"1p3OR","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2nTcT":[function(require,module,exports) {
module.exports = require("95a665e50ee55bd").getBundleURL("kVLro") + require("43e3a59a94e55d1e").resolve("gCEg1");

},{"95a665e50ee55bd":"c7Tr5","43e3a59a94e55d1e":"fyJL2"}],"fwWjm":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _textAreaField = require("../../../components/forms/TextAreaField");
var _textAreaFieldDefault = parcelHelpers.interopDefault(_textAreaField);
var _interactionModelForm = require("./InteractionModelForm");
var _lodash = require("lodash");
var _lodashDefault = parcelHelpers.interopDefault(_lodash);
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const closeIcon = require("b5b362452a037de2");
const NlpEntityValuesTextBoxDisplay = (props)=>{
    const [textBoxValues, setTextBoxValues] = (0, _react1.useState)("");
    const cardPrefix = `${props.formPrefix}.${props.formIndex}`;
    const valuesField = `${cardPrefix}.values`;
    const isModifiedField = `${cardPrefix}.isModified`;
    const disableFields = !props.nlpEntity?.isEditable || props.nlpEntity?.isDeleted; //|| props.isSubmitting || props.isValidating 
    const nlpEntityValues = props.nlpEntity?.values;
    (0, _react1.useEffect)(function resetTextBoxDisplay() {
        const ordered = (0, _lodashDefault.default).sortBy(nlpEntityValues ?? [], (v)=>v?.isAdded);
        const convertedToText = (0, _interactionModelForm.convertValuesToCSVText)(ordered);
        setTextBoxValues(convertedToText);
    }, []);
    const handleChange = (event)=>{
        props.setFieldValue(isModifiedField, true);
        setTextBoxValues(event.target.value);
        props.handleChange(event);
    };
    const handleBlur = (event)=>{
        const newParsedValues = (0, _interactionModelForm.convertCSVtextToValues)(textBoxValues);
        props.setFieldValue(valuesField, newParsedValues);
        props.handleBlur(event);
    };
    const renderNlpValuesTextBox = ()=>{
        return (0, _react.jsx)("div", {
            className: inputContainer
        }, (0, _react.jsx)((0, _textAreaFieldDefault.default), {
            name: "textBoxValues",
            value: textBoxValues,
            disabled: disableFields,
            placeholder: "Comma separated name and synonyms Values",
            onChange: (e)=>handleChange(e),
            onBlur: (e)=>handleBlur(e)
        }));
    };
    return renderNlpValuesTextBox();
};
exports.default = NlpEntityValuesTextBoxDisplay;
const inputContainer = /*#__PURE__*/ (0, _css.css)({
    name: "lt8g8y",
    styles: "&.title{margin-top:16px;}width:100%;.field-container{height:45px;}label{font-size:12px;}textarea{height:344px!important;margin-right:3px;resize:none;margin-bottom:3px;margin-top:3px;overflow-x:auto;white-space:nowrap;}"
});

},{"@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","../../../components/forms/TextAreaField":"fE54C","./InteractionModelForm":"9RN9X","lodash":"3hMBK","b5b362452a037de2":"igsne","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2Wrg7":[function(require,module,exports) {
module.exports = require("3ff9413e861d4743").getBundleURL("kVLro") + require("cdabc843a22e0d8e").resolve("ccwOm");

},{"3ff9413e861d4743":"c7Tr5","cdabc843a22e0d8e":"fyJL2"}],"JdePy":[function(require,module,exports) {
module.exports = require("7b31f7f901e2b2f1").getBundleURL("kVLro") + require("eb40f01591ee38be").resolve("9xmVA");

},{"7b31f7f901e2b2f1":"c7Tr5","eb40f01591ee38be":"fyJL2"}],"48meH":[function(require,module,exports) {
module.exports = require("9ffb8b439a8a210e").getBundleURL("kVLro") + require("4e6a2a285e883fc2").resolve("8aYgc");

},{"9ffb8b439a8a210e":"c7Tr5","4e6a2a285e883fc2":"fyJL2"}],"dTLvY":[function(require,module,exports) {
module.exports = require("2157bd7c98aba5c5").getBundleURL("kVLro") + require("eccad4f4a000ab77").resolve("8J3xM");

},{"2157bd7c98aba5c5":"c7Tr5","eccad4f4a000ab77":"fyJL2"}],"kdXIL":[function(require,module,exports) {
module.exports = require("65e1f4842ff3a0c2").getBundleURL("kVLro") + require("b808c7b3e73f8ebd").resolve("30UFS");

},{"65e1f4842ff3a0c2":"c7Tr5","b808c7b3e73f8ebd":"fyJL2"}],"4XE64":[function(require,module,exports) {
module.exports = require("b467927f5a91ba55").getBundleURL("kVLro") + require("4734f6f540e05d12").resolve("aqoEx");

},{"b467927f5a91ba55":"c7Tr5","4734f6f540e05d12":"fyJL2"}],"3HdTe":[function(require,module,exports) {
module.exports = require("eb8d565a1af6a15c").getBundleURL("kVLro") + require("4562a752b78f10ea").resolve("9uHXJ");

},{"eb8d565a1af6a15c":"c7Tr5","4562a752b78f10ea":"fyJL2"}],"fjmlt":[function(require,module,exports) {
module.exports = require("63425fd3d7e9d3bd").getBundleURL("kVLro") + require("65ce03db0c3e14d0").resolve("lKbnF");

},{"63425fd3d7e9d3bd":"c7Tr5","65ce03db0c3e14d0":"fyJL2"}],"RPqVb":[function(require,module,exports) {
module.exports = require("d13460e6cb255078").getBundleURL("kVLro") + require("d72eda762470750").resolve("wND4V");

},{"d13460e6cb255078":"c7Tr5","d72eda762470750":"fyJL2"}],"fXyPs":[function(require,module,exports) {
module.exports = require("7c31573c79bbea78").getBundleURL("kVLro") + require("14d6ce5597d2563a").resolve("iH8w7");

},{"7c31573c79bbea78":"c7Tr5","14d6ce5597d2563a":"fyJL2"}],"elYBX":[function(require,module,exports) {
module.exports = require("79f06cf0072ff854").getBundleURL("kVLro") + require("d70ddb076d793ddb").resolve("2NfTl");

},{"79f06cf0072ff854":"c7Tr5","d70ddb076d793ddb":"fyJL2"}],"8UZxi":[function(require,module,exports) {
module.exports = require("17acc99daff5c751").getBundleURL("kVLro") + require("1e011aa8d6b2b496").resolve("bBA5W");

},{"17acc99daff5c751":"c7Tr5","1e011aa8d6b2b496":"fyJL2"}],"cOmz5":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _base = require("@emotion/styled/base");
var _baseDefault = parcelHelpers.interopDefault(_base);
var _react = require("@emotion/react");
var _css = require("@emotion/css");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _button = require("../../../components/general/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _errorLabel = require("../../../components/general/ErrorLabel");
var _errorLabelDefault = parcelHelpers.interopDefault(_errorLabel);
var _warningConfirmation = require("../../../components/general/WarningConfirmation");
var _warningConfirmationDefault = parcelHelpers.interopDefault(_warningConfirmation);
var _confirmationDialog = require("../../../components/structure/ConfirmationDialog");
var _confirmationDialogDefault = parcelHelpers.interopDefault(_confirmationDialog);
var _colors = require("../../../constants/colors");
var _interactionModelForm = require("./InteractionModelForm");
var _tooltipWrapper = require("../../../components/general/TooltipWrapper");
var _tooltipWrapperDefault = parcelHelpers.interopDefault(_tooltipWrapper);
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const deleteIcon = require("677420c8e10638fd");
const addIcon = require("6eb74735ff213d9a");
const redNoCircle = require("c36ec89273919b8");
const yellowUpdate = require("db8680fb4600186");
const duplicateIcon = require("10c72d8b818b78de");
const alertIcon = require("d418a61a04452a2b");
const sensitiveEntity = require("f0176371cab10b56");
const noTrackingEntity = require("3a699f0ac3b09813");
const ApplicationNlpEntityItem = (props)=>{
    const [isConfirmDeleteModalOpen, setIsConfirmDeleteModalOpen] = (0, _react1.useState)(false);
    const isActive = props.isActive;
    const nlpEntityName = props.nlpEntity.name?.trim().length > (0, _interactionModelForm.maxNlpEntityNameSize) ? props.nlpEntity.name.trim().substring(0, (0, _interactionModelForm.maxNlpEntityNameSize)) + "..." : props.nlpEntity.name;
    const hasUnsavedChanges = props.nlpEntity.isDeleted || props.nlpEntity.isAdded || props.nlpEntity.isModified;
    const isDeleted = props.nlpEntity.isDeleted;
    const isModified = props.nlpEntity.isModified;
    const isCopyable = props.nlpEntity.isCopyable;
    const cardPrefix = `${props.formPrefix}.${props.formIndex}`;
    const isModifiedField = `${cardPrefix}.isModified`;
    const isDeletedField = `${cardPrefix}.isDeleted`;
    const hasErrors = props.errors?.[props.formPrefix]?.[props.formIndex];
    const handleItemToggleActivation = (index)=>{
        props.toggleItemActivationByIndex(index);
    };
    const toggleConfirmDeleteModal = ()=>{
        setIsConfirmDeleteModalOpen(!isConfirmDeleteModalOpen);
    };
    const onConfirmDelete = ()=>{
        props.setFieldValue(isDeletedField, !isDeleted);
        props.setFieldValue(isModifiedField, true);
        toggleConfirmDeleteModal();
    };
    const handleCopyNlpEntity = (event)=>{
        event.stopPropagation();
        props.handleCopyNlpEntity(props.formIndex);
    };
    const renderNlpEntityName = ()=>{
        return (0, _react.jsx)("div", {
            className: itemBody,
            key: props.formIndex
        }, (0, _react.jsx)((0, _buttonDefault.default), {
            themes: [
                "white-small"
            ],
            text: nlpEntityName,
            type: "button"
        }), props.nlpEntity.dataSensitivity === "Sensitive" && (0, _react.jsx)((0, _tooltipWrapperDefault.default), {
            place: "right",
            text: "Entity not tracked in analytics and will be encrypted for webhooks"
        }, (0, _react.jsx)(SensitivityIcon, {
            src: sensitiveEntity
        })), props.nlpEntity.dataSensitivity === "NoTracking" && (0, _react.jsx)((0, _tooltipWrapperDefault.default), {
            place: "right",
            text: "Entity information will not be tracked in this application's analytics"
        }, (0, _react.jsx)(SensitivityIcon, {
            src: noTrackingEntity
        })));
    };
    const renderItemActions = ()=>{
        return (0, _react.jsx)("div", {
            className: itemActions
        }, hasErrors && (0, _react.jsx)((0, _errorLabelDefault.default), {
            image: alertIcon,
            text: "Errors Present"
        }), hasUnsavedChanges && (0, _react.jsx)((0, _buttonDefault.default), {
            themes: [
                "icon",
                "end-tight"
            ],
            icon: isDeleted ? redNoCircle : isModified ? yellowUpdate : addIcon
        }), !isDeleted && isCopyable && (0, _react.jsx)((0, _buttonDefault.default), {
            themes: [
                "icon",
                "end-tight"
            ],
            icon: duplicateIcon,
            type: "button",
            onClick: (event)=>handleCopyNlpEntity(event)
        }), !isDeleted && (0, _react.jsx)((0, _buttonDefault.default), {
            themes: [
                "icon",
                "end-tight"
            ],
            icon: deleteIcon,
            type: "button",
            onClick: toggleConfirmDeleteModal
        }));
    };
    const renderNlpEntityDisplayItem = ()=>{
        return (0, _react.jsx)((0, _reactDefault.default).Fragment, null, (0, _react.jsx)("div", {
            className: `${itemContainer} ${isActive ? "active" : ""}`,
            key: `menuItem-${props.formIndex}`,
            onClick: ()=>handleItemToggleActivation(props.formIndex)
        }, renderNlpEntityName(), renderItemActions()), isConfirmDeleteModalOpen && (0, _react.jsx)((0, _confirmationDialogDefault.default), {
            title: `Confirm Delete`,
            deleteText: "Yes, Delete",
            isLoading: false,
            onClose: toggleConfirmDeleteModal,
            onConfirm: onConfirmDelete
        }, (0, _react.jsx)((0, _warningConfirmationDefault.default), {
            text: `Are you sure you want to delete the entity "${nlpEntityName}"? 
                        All slots that are using this entity will become invalid.`
        })));
    };
    return renderNlpEntityDisplayItem();
};
exports.default = ApplicationNlpEntityItem;
const itemContainer = /*#__PURE__*/ (0, _css.css)("border:1px solid ", (0, _colors.color_shades_dark), ";border-radius:8px;margin:8px 0 8px 0;height:56px;display:flex;justify-content:space-between;cursor:pointer;&.active{border:1px solid ", (0, _colors.color_colors_ocean), ";box-shadow:0px 0px 4px 4px ", (0, _colors.color_variants_ocean_light_2), ";}", "");
const itemBody = /*#__PURE__*/ (0, _css.css)("display:flex;flex-direction:row;align-items:center;color:", (0, _colors.color_text_default), ";font-size:18px;position:relative;", "");
const itemActions = /*#__PURE__*/ (0, _css.css)({
    name: "zjik7",
    styles: "display:flex"
});
const SensitivityIcon = /*#__PURE__*/ (0, _baseDefault.default)("img", {
    target: "e11vsvjy0"
})("");

},{"@emotion/styled/base":"lSuFu","@emotion/react":"djZKr","@emotion/css":"awUBr","react":"6uln9","../../../components/general/Button":"6ymxN","../../../components/general/ErrorLabel":"k9Ob0","../../../components/general/WarningConfirmation":"9OccO","../../../components/structure/ConfirmationDialog":"kx7yK","../../../constants/colors":"1p3OR","./InteractionModelForm":"9RN9X","../../../components/general/TooltipWrapper":"53pWd","677420c8e10638fd":"7eyKJ","6eb74735ff213d9a":"kxmNT","c36ec89273919b8":"37PeV","db8680fb4600186":"8yrG0","10c72d8b818b78de":"8rvGy","d418a61a04452a2b":"cRA6k","f0176371cab10b56":"lyz7r","3a699f0ac3b09813":"fXyPs","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2A95n":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _unstatedNext = require("unstated-next");
function useInteractionModelUiStateContainer() {
    const [nluTab, setNluTab] = (0, _react.useState)("Entities");
    const [menuEditorView, setMenuEditorView] = (0, _react.useState)("Menu Items");
    const [triggerSaveChanges, setTriggerSaveChanges] = (0, _react.useState)(false);
    const [isFormDirty, setIsFormDirty] = (0, _react.useState)(false);
    const [errors, setErrors] = (0, _react.useState)({});
    return {
        nluTab,
        triggerSaveChanges,
        isFormDirty,
        setNluTab,
        setTriggerSaveChanges,
        setIsFormDirty,
        errors,
        setErrors,
        menuEditorView,
        setMenuEditorView
    };
}
const InteractionModelUiStateContainer = (0, _unstatedNext.createContainer)(useInteractionModelUiStateContainer);
exports.default = InteractionModelUiStateContainer;

},{"react":"6uln9","unstated-next":"61zE5","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"iySc5":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _base = require("@emotion/styled/base");
var _baseDefault = parcelHelpers.interopDefault(_base);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _colors = require("../../../constants/colors");
var _languages = require("../../../models/extensions/languages");
var _button = require("../../../components/general/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _css = require("@emotion/css");
var _modalHeader = require("../../../components/general/ModalHeader");
var _modalHeaderDefault = parcelHelpers.interopDefault(_modalHeader);
var _footerBar = require("../../../components/structure/FooterBar");
var _footerBarDefault = parcelHelpers.interopDefault(_footerBar);
var _smallModalLayout = require("../../../components/structure/SmallModalLayout");
var _smallModalLayoutDefault = parcelHelpers.interopDefault(_smallModalLayout);
var _customScrollbars = require("../../../components/structure/CustomScrollbars");
var _customScrollbarsDefault = parcelHelpers.interopDefault(_customScrollbars);
var _useWindowSize = require("../../../hooks/UseWindowSize");
var _useWindowSizeDefault = parcelHelpers.interopDefault(_useWindowSize);
var _conditionalTooltipWrapper = require("../../../components/general/ConditionalTooltipWrapper");
var _conditionalTooltipWrapperDefault = parcelHelpers.interopDefault(_conditionalTooltipWrapper);
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const alertIcon = require("7abc6f4a83d669f7");
const entityIcon = require("3f5cdd8fadb5eac3");
const intentIcon = require("dbff231ce68aee6a");
const slotIcon = require("37647e57b7ee9a92");
const utteranceIcon = require("425badb800554d73");
const menuItemIcon = require("79109dc645bca41d");
const NlpSaveChangesModal = (props)=>{
    const windowSize = (0, _useWindowSizeDefault.default)();
    const [changedNlpData, setChangedNlpData] = (0, _react1.useState)([]);
    (0, _react1.useEffect)(()=>{
        if (!props.isLoading) setChangedNlpData(getChangedData());
    }, [
        props.values,
        props.showSaveChangesModal
    ]);
    const saveChangesAndClose = ()=>{
        props.submitChanges();
        props.closeModal();
    };
    const getChangedData = ()=>{
        if (props.values == null) return [];
        let changedData = getChangedInteractionModelData(props.values.interactionModel, props.values);
        const entityData = getChangedEntityData(props.values.nlpEntities);
        if (entityData?.length > 0) changedData = changedData.concat(entityData);
        return changedData;
    };
    const determineIcon = (changeType)=>{
        if (changeType == "Entity") return entityIcon;
        else if (changeType == "Slot") return slotIcon;
        else if (changeType == "Intent") return intentIcon;
        else if (changeType == "Utterance") return utteranceIcon;
        return intentIcon;
    };
    const modifyDisplayStringBasedOnType = (changeType, text)=>{
        if (changeType == "Utterance") return '"' + text + '"';
        else if (changeType == "Slot") return "{" + text + "}";
        else if (changeType == "Entity") return "<" + text + ">";
        else if (changeType == "Intent") return text;
        else if (changeType === "EnhancedIntentMatching") return text;
    };
    const changedMenuItems = props.updatedMenuItems?.filter((menuItem)=>{
        return menuItem.isAdded || menuItem.isDeleted || menuItem.isModified;
    });
    const getChangedEntityData = (nlpEntities)=>{
        let changedData = [];
        for(let counter = 0; counter < nlpEntities.length; counter++){
            const nlpEntity = nlpEntities[counter];
            if (nlpEntity.isAdded && nlpEntity.isDeleted) ;
            else if (nlpEntity.isDeleted) changedData.push({
                changeType: "Entity",
                state: "Removed",
                text: nlpEntity.name
            });
            else if (nlpEntity.isAdded) changedData.push({
                changeType: "Entity",
                state: "Added",
                text: nlpEntity.name
            });
            else if (nlpEntity.isModified) changedData.push({
                changeType: "Entity",
                state: "Modified",
                text: nlpEntity.name
            });
        }
        return changedData;
    };
    const getChangedInteractionModelData = (interactionModel, values)=>{
        let changedData = [];
        if (props.values.disableEnhancedIntentMatching) changedData.push({
            changeType: "EnhancedIntentMatching",
            state: "Removed",
            text: "Disabled"
        });
        else if (props.values.enableEnhancedIntentMatching) changedData.push({
            changeType: "EnhancedIntentMatching",
            state: "Added",
            text: "Enabled"
        });
        if (props.values.updatedEnhancedIntentMatchingPrompt?.length) changedData.push({
            changeType: "EnhancedIntentMatching",
            state: "Modified",
            text: "Updated Prompt"
        });
        for(let key in interactionModel){
            const intent = interactionModel[key];
            const utterances = intent.utterances;
            const slots = intent.slots;
            if (intent.isAdded && intent.isDeleted) ;
            else if (intent.isDeleted) changedData.push({
                changeType: "Intent",
                state: "Removed",
                text: intent.displayName
            });
            else if (intent.isAdded) changedData.push({
                changeType: "Intent",
                state: "Added",
                text: intent.displayName
            });
            else if (intent.isModified) changedData.push({
                changeType: "Intent",
                state: "Modified",
                text: intent.displayName
            });
            if (slots?.length > 0) for(let counter = 0; counter < slots.length; counter++){
                if (slots[counter].isModified) {
                    const slotObj = {
                        changeType: "Slot",
                        state: "Modified",
                        text: slots[counter].name
                    };
                    changedData.push(slotObj);
                } else if (slots[counter].isDeleted) {
                    const slotObj = {
                        changeType: "Slot",
                        state: "Removed",
                        text: slots[counter].name
                    };
                    changedData.push(slotObj);
                } else if (slots[counter].isAdded) {
                    const slotObj = {
                        changeType: "Slot",
                        state: "Added",
                        text: slots[counter].name
                    };
                    changedData.push(slotObj);
                }
            }
            if (utterances?.length > 0) for(let counter = 0; counter < utterances.length; counter++){
                if (utterances[counter].changeType == "Removed") {
                    const removedObj = {
                        changeType: "Utterance",
                        state: "Removed",
                        text: utterances[counter].phrase
                    };
                    changedData.push(removedObj);
                } else if (utterances[counter].changeType == "Added") {
                    const removedObj = {
                        changeType: "Utterance",
                        state: "Added",
                        text: utterances[counter].phrase
                    };
                    changedData.push(removedObj);
                }
            }
        }
        return changedData;
    };
    const renderMenuItemChange = (menuItem, index)=>{
        if (menuItem.isAdded) return (0, _react.jsx)(ChangedItemWrapper, {
            key: "Key " + index
        }, (0, _react.jsx)("div", {
            className: addedOrModifiedItem
        }, "Added "), (0, _react.jsx)(ChangedMenuItemText, null, (0, _react.jsx)(Icon, {
            src: menuItemIcon
        }), "Menu item: ", menuItem.menuItem.originalName ? menuItem.menuItem.originalName : menuItem.menuItem.colloquialName ? menuItem.menuItem.colloquialName : `unnamed item`));
        else if (menuItem.isModified) return (0, _react.jsx)(ChangedItemWrapper, {
            key: "Key " + index
        }, (0, _react.jsx)("div", {
            className: addedOrModifiedItem
        }, "Modified "), (0, _react.jsx)(ChangedMenuItemText, null, (0, _react.jsx)(Icon, {
            src: menuItemIcon
        }), "Menu item: ", menuItem.menuItem.originalName ? menuItem.menuItem.originalName : menuItem.menuItem.colloquialName ? menuItem.menuItem.colloquialName : `unnamed item`));
        else if (menuItem.isDeleted) return (0, _react.jsx)(ChangedItemWrapper, {
            key: "Key " + index
        }, (0, _react.jsx)("div", {
            className: removedItem
        }, "Removed "), (0, _react.jsx)(ChangedMenuItemText, null, (0, _react.jsx)(Icon, {
            src: menuItemIcon
        }), "Menu item: ", menuItem.menuItem.originalName ? menuItem.menuItem.originalName : menuItem.menuItem.colloquialName ? menuItem.menuItem.colloquialName : `unnamed item`));
    };
    const renderExplanationText = ()=>{
        if (changedNlpData?.length > 0 && changedMenuItems?.length > 0) return (0, _react.jsx)(ExplanationText, null, "This will update your menu and interaction model and apply those changes to both the test and live environments.");
        else if (changedNlpData?.length > 0 && changedMenuItems?.length == 0) return (0, _react.jsx)(ExplanationText, null, "This will update your interaction model and apply those changes to both the test and live environments.");
        else if (changedNlpData?.length == 0 && changedMenuItems?.length > 0) return (0, _react.jsx)(ExplanationText, null, "This will update your menu with the below changes.");
        else if (changedNlpData?.length == 0 && changedMenuItems?.length == 0) return (0, _react.jsx)(ExplanationText, null, "There are no pending menu or interaction model changes to save.");
    };
    let tooltip = "";
    if (!props.isLoading) {
        if (!!Object.keys(props.errors)?.length) tooltip = "You have errors in your NLP model";
        else if (changedNlpData?.length == 0) tooltip = "You don't have any changes to save";
    }
    return (0, _react.jsx)((0, _smallModalLayoutDefault.default), {
        className: saveChangesModal,
        isVisible: props.showSaveChangesModal
    }, (0, _react.jsx)((0, _modalHeaderDefault.default), {
        title: "Save Changes",
        onClose: ()=>props.closeModal()
    }), !!Object.keys(props.errors)?.length && !props.isLoading && (0, _react.jsx)(ErrorStyle, null, (0, _react.jsx)(AlertIcon, {
        src: alertIcon
    }), "You have errors in your NLP model"), (0, _react.jsx)(SaveChangesWrapper, null, changedNlpData?.length > 0 || changedMenuItems?.length > 0 && (0, _react.jsx)(Title, null, "Save all Pending Changes?"), renderExplanationText(), changedNlpData?.length > 0 || changedMenuItems?.length > 0 && (0, _react.jsx)(ChangedText, null, "Here's what has changed:"), (0, _react.jsx)(ChangeSummary, null, (0, _react.jsx)((0, _customScrollbarsDefault.default), {
        autoHide: true,
        autoHeight: true,
        autoHeightMin: windowSize.windowSize.innerHeight * .6 - 175,
        autoHeightMax: windowSize.windowSize.innerHeight * .6 - 175
    }, changedNlpData?.length > 0 && props.languages.map((lang, index)=>(0, _react.jsx)(ChangedItemWrapper, {
            key: "Key " + index
        }, (0, _react.jsx)(Icon, {
            src: (0, _languages.getFlagIconForLanguage)(lang)
        }), (0, _react.jsx)("p", null, (0, _languages.getLanguageNameForLanguage)(lang) + " - " + (0, _languages.getRegionyNameForLanguage)(lang)))), (0, _react.jsx)("div", null, changedNlpData?.map((data, index)=>(0, _react.jsx)(ChangedItemWrapper, {
            key: "Key " + index
        }, (0, _react.jsx)("p", {
            className: data.state == "Removed" ? removedItem : addedOrModifiedItem
        }, data.state), (0, _react.jsx)(ChangedMenuItemText, null, (0, _react.jsx)(Icon, {
            src: determineIcon(data.changeType)
        }), data.changeType + ": " + modifyDisplayStringBasedOnType(data.changeType, data.text))))), changedMenuItems.length > 0 && (0, _react.jsx)(ChangedMenuItemsWrapper, null, changedMenuItems?.map((menuItem, index)=>{
        return renderMenuItemChange(menuItem, index);
    }))))), (0, _react.jsx)((0, _footerBarDefault.default), null, (0, _react.jsx)((0, _conditionalTooltipWrapperDefault.default), {
        place: "top",
        showTooltip: !!tooltip,
        text: tooltip
    }, (0, _react.jsx)(SaveButtonWrapper, null, (0, _react.jsx)((0, _buttonDefault.default), {
        type: "button",
        themes: [
            "primary"
        ],
        text: "Save",
        loading: props.isLoading,
        disabled: props.isLoading || changedNlpData?.length == 0 && changedMenuItems?.length == 0 || !!Object.keys(props.errors)?.length,
        onClick: ()=>saveChangesAndClose()
    }))), (0, _react.jsx)((0, _buttonDefault.default), {
        type: "button",
        themes: [
            "secondary"
        ],
        text: "Cancel",
        loading: props.isLoading,
        onClick: ()=>props.closeModal()
    })));
};
exports.default = NlpSaveChangesModal;
const ChangeSummary = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1rfng9w11"
})({
    name: "acf2e7",
    styles: "padding:16px 0"
});
const Title = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1rfng9w10"
})({
    name: "18uqayh",
    styles: "margin-bottom:16px"
});
const SaveChangesWrapper = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1rfng9w9"
})({
    name: "knjsbg",
    styles: "padding:32px"
});
const ChangedMenuItemsWrapper = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1rfng9w8"
})({
    name: "1fttcpj",
    styles: "display:flex;flex-direction:column"
});
const ChangedMenuItemText = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1rfng9w7"
})({
    name: "1butnzk",
    styles: "font-style:italic;display:flex;align-items:center;justify-content:flex-start"
});
const SaveButtonWrapper = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1rfng9w6"
})({
    name: "1tx1l5v",
    styles: "margin-right:auto"
});
const saveChangesModal = /*#__PURE__*/ (0, _css.css)({
    name: "gl079z",
    styles: "height:80%;width:30%;min-width:450px"
});
const ExplanationText = /*#__PURE__*/ (0, _baseDefault.default)("p", {
    target: "e1rfng9w5"
})({
    name: "1rgcpx4",
    styles: "font-size:14px;margin-bottom:16px"
});
const ChangedText = /*#__PURE__*/ (0, _baseDefault.default)("p", {
    target: "e1rfng9w4"
})({
    name: "157k2o",
    styles: "margin-top:32px;margin-bottom:0;font-weight:bold"
});
const ChangedItemWrapper = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1rfng9w3"
})({
    name: "9nm4gv",
    styles: "padding-top:16px;display:flex;align-items:center;&:first-of-type{padding-top:0;}"
});
const addedOrModifiedItem = /*#__PURE__*/ (0, _css.css)("color:", (0, _colors.color_text_light), ";font-style:italic;", "");
const removedItem = /*#__PURE__*/ (0, _css.css)("color:", (0, _colors.faded_red), ";font-style:italic;", "");
const Icon = /*#__PURE__*/ (0, _baseDefault.default)("img", {
    target: "e1rfng9w2"
})({
    name: "1lwdwsh",
    styles: "padding:0 8px;width:32px"
});
const ErrorStyle = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1rfng9w1"
})('display:flex;align-items:center;justify-content:flex-start;font-family:Muli,"sans-serif";font-weight:normal;color:', (0, _colors.color_shades_darkest), ";background-color:", (0, _colors.color_variants_decline_light_1), ";border:1px solid ", (0, _colors.color_colors_decline), ";border-radius:8px;flex-grow:1;padding:8px 16px;margin:8px 0;font-size:14px;margin:16px 32px 0px 32px;");
const AlertIcon = /*#__PURE__*/ (0, _baseDefault.default)("img", {
    target: "e1rfng9w0"
})({
    name: "1oaeivz",
    styles: "margin-right:8px"
});

},{"@emotion/styled/base":"lSuFu","@emotion/react":"djZKr","react":"6uln9","../../../constants/colors":"1p3OR","../../../models/extensions/languages":"8E5Oo","../../../components/general/Button":"6ymxN","@emotion/css":"awUBr","../../../components/general/ModalHeader":"aUACx","../../../components/structure/FooterBar":"bibRL","../../../components/structure/SmallModalLayout":"khwvt","../../../components/structure/CustomScrollbars":"50vFq","../../../hooks/UseWindowSize":"43j9z","../../../components/general/ConditionalTooltipWrapper":"92m0T","7abc6f4a83d669f7":"cRA6k","3f5cdd8fadb5eac3":"8TxfO","dbff231ce68aee6a":"kZQQy","37647e57b7ee9a92":"4aKUh","425badb800554d73":"1c2WR","79109dc645bca41d":"16bHy","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8TxfO":[function(require,module,exports) {
module.exports = require("c1745eb50d535004").getBundleURL("kVLro") + require("aeca87cb5a56ce").resolve("d10Um");

},{"c1745eb50d535004":"c7Tr5","aeca87cb5a56ce":"fyJL2"}],"kZQQy":[function(require,module,exports) {
module.exports = require("18a6d824eddb30b1").getBundleURL("kVLro") + require("3f279f2a9bc119bf").resolve("23DA4");

},{"18a6d824eddb30b1":"c7Tr5","3f279f2a9bc119bf":"fyJL2"}],"4aKUh":[function(require,module,exports) {
module.exports = require("52be189b097b0c5a").getBundleURL("kVLro") + require("90072efe8e9b5dc").resolve("gMSfB");

},{"52be189b097b0c5a":"c7Tr5","90072efe8e9b5dc":"fyJL2"}],"1c2WR":[function(require,module,exports) {
module.exports = require("debf9800f5cc38b3").getBundleURL("kVLro") + require("b25a3d213c669421").resolve("icaPs");

},{"debf9800f5cc38b3":"c7Tr5","b25a3d213c669421":"fyJL2"}],"16bHy":[function(require,module,exports) {
module.exports = require("fcc5e2cac1666191").getBundleURL("kVLro") + require("d59c2dd25cbeedaf").resolve("dO6Uk");

},{"fcc5e2cac1666191":"c7Tr5","d59c2dd25cbeedaf":"fyJL2"}],"fHke7":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _base = require("@emotion/styled/base");
var _baseDefault = parcelHelpers.interopDefault(_base);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _loader = require("../../../components/general/Loader");
var _loaderDefault = parcelHelpers.interopDefault(_loader);
var _customScrollbars = require("../../../components/structure/CustomScrollbars");
var _customScrollbarsDefault = parcelHelpers.interopDefault(_customScrollbars);
var _horizontalSeparator = require("../../../components/structure/HorizontalSeparator");
var _horizontalSeparatorDefault = parcelHelpers.interopDefault(_horizontalSeparator);
var _colors = require("../../../constants/colors");
var _useWindowSize = require("../../../hooks/UseWindowSize");
var _useWindowSizeDefault = parcelHelpers.interopDefault(_useWindowSize);
var _emptyView = require("../../featureContent/components/EmptyView");
var _emptyViewDefault = parcelHelpers.interopDefault(_emptyView);
var _voicifyMenuItems = require("./VoicifyMenuItems");
var _voicifyMenuItemsDefault = parcelHelpers.interopDefault(_voicifyMenuItems);
var _voicifyMenuEditor = require("./VoicifyMenuEditor");
var _voicifyMenuEditorDefault = parcelHelpers.interopDefault(_voicifyMenuEditor);
var _uuid = require("uuid");
var _voicifyMenuHeader = require("./VoicifyMenuHeader");
var _voicifyMenuHeaderDefault = parcelHelpers.interopDefault(_voicifyMenuHeader);
var _importFileDialog = require("../../../components/general/ImportFileDialog");
var _importFileDialogDefault = parcelHelpers.interopDefault(_importFileDialog);
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const VoicifyMenuItemsEditor = (props)=>{
    const [activeItemIndex, setActiveItemIndex] = (0, _react1.useState)(-1);
    const [importFileModalOpen, setImportFileModalOpen] = (0, _react1.useState)(false);
    const windowSize = (0, _useWindowSizeDefault.default)();
    (0, _react1.useEffect)(()=>{
        if (!props.updatedMenuItems?.length) props.setSelectedMenuItem(null);
    }, [
        props.updatedMenuItems
    ]);
    const formatFileName = ()=>{
        const words = props.appName ? props.appName.toLowerCase().split(/\s+/) : [];
        const date = new Date();
        const formattedDate = `${date.getMonth() + 1}-${date.getDate()}-${date.getFullYear()}`;
        const formattedTime = `${date.getHours()}:${date.getMinutes()}`;
        words.push(formattedDate);
        words.push(formattedTime);
        const formattedName = words.join("-");
        return formattedName;
    };
    const toggleItemActivation = (editedMenuItem, index)=>{
        setActiveItemIndex(index);
        const newSelectedMenuItem = props.updatedMenuItems.filter((menuItem)=>{
            return menuItem.menuItem.id === editedMenuItem.menuItem.id && menuItem.menuItem.comboId === editedMenuItem.menuItem.comboId;
        });
        props.setSelectedMenuItem(newSelectedMenuItem[0]);
    };
    const processMenuImport = (file)=>{
        const reader = new FileReader();
        reader.readAsText(file);
        reader.onload = async (e)=>{
            const result = e.target.result;
            const importedMenuItems = JSON.parse(result);
            const editedMenuItems = importedMenuItems.map((importedMenuItem)=>{
                const isAMatch = props.updatedMenuItems.some((existingMenuItem)=>existingMenuItem.menuItem.id === importedMenuItem.id);
                if (isAMatch) return {
                    menuItem: {
                        ...importedMenuItem,
                        applicationId: props.applicationId
                    },
                    isModified: true
                };
                else return {
                    menuItem: {
                        ...importedMenuItem,
                        applicationId: props.applicationId
                    },
                    isAdded: true
                };
            });
            const updatedMenuItems = props.updatedMenuItems.map((existingMenuItem, index)=>{
                const isAMatch = editedMenuItems.some((editedMenuItem)=>editedMenuItem.menuItem.id === existingMenuItem.menuItem.id);
                if (!isAMatch) return {
                    menuItem: {
                        ...existingMenuItem.menuItem,
                        applicationId: props.applicationId
                    },
                    isDeleted: true
                };
                else {
                    existingMenuItem.menuItem.applicationId = props.applicationId;
                    return existingMenuItem;
                }
            }).concat(editedMenuItems.filter((editedMenuItem)=>!props.updatedMenuItems.some((existingMenuItem)=>existingMenuItem.menuItem.id === editedMenuItem.menuItem.id)));
            props.setUpdatedMenuItems(updatedMenuItems);
        };
        setImportFileModalOpen(false);
    };
    const handleImportMenuClick = ()=>{
        setImportFileModalOpen(true);
    };
    const handleExportMenuClick = ()=>{
        const menuStr = JSON.stringify(props.menuItems);
        const blob = new Blob([
            menuStr
        ], {
            type: "text/plain"
        });
        const url = URL.createObjectURL(blob);
        let link = document.createElement("a");
        link.setAttribute("href", url);
        link.setAttribute("download", `${formatFileName()}.json`);
        document.body.appendChild(link);
        link.click();
        link.remove();
    };
    const handleAddItemClick = (isCopy, menuItem, index)=>{
        const copiedOptionGroups = menuItem?.optionGroups?.map((optionGroup)=>{
            return {
                ...optionGroup
            };
        });
        const copiedSizeGroups = menuItem?.sizeGroups?.map((sizeGroup)=>{
            return {
                ...sizeGroup
            };
        });
        // if menu item is passed in, it is a copy of an existing menu item
        const newMenuItem = {
            menuItem: {
                applicationId: props.applicationId,
                id: (0, _uuid.v4)(),
                comboId: menuItem?.comboId ?? "",
                comboOnly: menuItem?.comboOnly ?? false,
                originalName: isCopy ? "Copy - " + menuItem?.originalName : "New Menu Item",
                colloquialName: menuItem?.colloquialName ?? "",
                optionGroups: isCopy ? copiedOptionGroups : [
                    {
                        referenceId: "",
                        name: "",
                        colloquialName: "",
                        numberOfRequiredOptions: null,
                        maxSelections: null,
                        limiter: "",
                        promptOverride: "",
                        initialPromptOverride: "",
                        numberedInitialPromptOverride: "",
                        automaticallyAddDefault: false,
                        isRequired: false,
                        options: [
                            {
                                id: "",
                                name: "",
                                colloquialName: "",
                                modifier: "",
                                default: false,
                                isPrimaryOption: false,
                                ignoreForReadout: false,
                                attributes: {}
                            }
                        ]
                    }
                ],
                sizeGroups: isCopy ? copiedSizeGroups : [
                    {
                        numberOfRequiredSizes: null,
                        promptOverride: "",
                        initialPromptOverride: "",
                        numberedInitialPromptOverride: "",
                        sizes: [
                            {
                                id: "",
                                name: "",
                                colloquialName: "",
                                default: false,
                                ignoreForReadout: false,
                                attributes: {},
                                optionGroups: [
                                    {
                                        referenceId: "",
                                        name: "",
                                        colloquialName: "",
                                        numberOfRequiredOptions: null,
                                        maxSelections: null,
                                        limiter: "",
                                        promptOverride: "",
                                        initialPromptOverride: "",
                                        numberedInitialPromptOverride: "",
                                        automaticallyAddDefault: false,
                                        isRequired: false,
                                        options: [
                                            {
                                                id: "",
                                                name: "",
                                                colloquialName: "",
                                                modifier: "",
                                                default: false,
                                                isPrimaryOption: false,
                                                ignoreForReadout: false,
                                                attributes: {}
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ],
                attributes: {
                    description: menuItem?.attributes?.description ?? "",
                    calories: menuItem?.attributes?.calories ?? "",
                    servingSize: menuItem?.attributes?.servingSize ?? "",
                    ingredients: menuItem?.attributes?.ingredients ?? "",
                    allergenInfo: menuItem?.attributes?.allergenInfo ?? "",
                    data: menuItem?.attributes?.data ?? {}
                }
            },
            isAdded: true
        };
        const copyOfUpdatedMenuItems = [
            ...props.updatedMenuItems
        ];
        if (isCopy) copyOfUpdatedMenuItems.splice(index, 0, newMenuItem);
        else copyOfUpdatedMenuItems.unshift(newMenuItem);
        props.setUpdatedMenuItems(copyOfUpdatedMenuItems);
        props.setSelectedMenuItem(newMenuItem);
        setActiveItemIndex(index ?? 0);
    };
    const handleMenuItemChange = (value)=>{
        const copyOfUpdatedMenuItems = [
            ...props.updatedMenuItems
        ];
        const updatedMenuItemIndex = copyOfUpdatedMenuItems.findIndex((menuItem)=>{
            return menuItem.menuItem.id === props.selectedMenuItem.menuItem.id;
        });
        if (copyOfUpdatedMenuItems[updatedMenuItemIndex].isAdded) copyOfUpdatedMenuItems[updatedMenuItemIndex] = {
            menuItem: {
                ...value
            },
            isAdded: true
        };
        else copyOfUpdatedMenuItems[updatedMenuItemIndex] = {
            menuItem: {
                ...value
            },
            isModified: true
        };
        props.setUpdatedMenuItems(copyOfUpdatedMenuItems);
    };
    return (0, _react.jsx)((0, _reactDefault.default).Fragment, null, props.isLoading ? (0, _react.jsx)(CustomLoader, null) : (0, _react.jsx)(MenuWrapper, null, importFileModalOpen && (0, _react.jsx)((0, _importFileDialogDefault.default), {
        completeImport: processMenuImport,
        onClose: ()=>setImportFileModalOpen(false),
        title: "Import your menu",
        acceptFileTypes: ".json",
        acceptFileTypesDisplayText: "Supports .json",
        isLoading: props.isLoading,
        errors: [],
        maxSizeOverrideMegabytes: 100
    }), (0, _react.jsx)((0, _customScrollbarsDefault.default), {
        autoHide: true,
        autoHeight: true,
        autoHeightMin: windowSize.windowSize.innerHeight - 210,
        autoHeightMax: windowSize.windowSize.innerHeight - 210
    }, (0, _react.jsx)(Panel, null, (0, _react.jsx)((0, _voicifyMenuHeaderDefault.default), {
        showAddItemButton: true,
        isLoading: props.isLoading,
        handleAddItemClick: handleAddItemClick,
        handleExportMenuClick: handleExportMenuClick,
        handleImportMenuClick: handleImportMenuClick
    }), !props.updatedMenuItems?.length && !props.isLoading && (0, _react.jsx)(EmptyViewPadding, null, (0, _react.jsx)((0, _emptyViewDefault.default), {
        subtext: "Try adding a new menu item"
    })), props.updatedMenuItems && (0, _react.jsx)((0, _voicifyMenuItemsDefault.default), {
        handleAddItemClick: handleAddItemClick,
        activeItemIndex: activeItemIndex,
        setActiveItemIndex: setActiveItemIndex,
        setSelectedMenuItem: props.setSelectedMenuItem,
        selectedMenuItem: props.selectedMenuItem,
        toggleItemActivation: toggleItemActivation,
        applicationId: props.applicationId,
        updatedMenuItems: props.updatedMenuItems,
        setUpdatedMenuItems: props.setUpdatedMenuItems,
        dirty: props.dirty,
        isValid: props.isValid,
        isLoading: props.isLoading
    }))), (0, _react.jsx)(BorderLeftCustomScrollbars, {
        autoHide: true,
        autoHeight: true,
        autoHeightMin: windowSize.windowSize.innerHeight - 210,
        autoHeightMax: windowSize.windowSize.innerHeight - 210
    }, (0, _react.jsx)(Panel, null, (0, _react.jsx)(MenuItemEditorHeader, null, "Edit Menu Item"), (0, _react.jsx)((0, _horizontalSeparatorDefault.default), null), (0, _react.jsx)(MenuItemEditorWrapper, null, props.updatedMenuItems && props.selectedMenuItem ? (0, _react.jsx)((0, _voicifyMenuEditorDefault.default), {
        menuItem: props.selectedMenuItem?.menuItem,
        handleChange: handleMenuItemChange
    }) : (0, _react.jsx)(EmptyViewText, null, "Select a menu item to see more details and manage values"))))));
};
exports.default = VoicifyMenuItemsEditor;
const MenuWrapper = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e18uufx58"
})({
    name: "j9lc9v",
    styles: "height:100%;display:flex"
});
const Panel = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e18uufx57"
})({
    name: "18zee9v",
    styles: "padding:16px 32px 16px 32px"
});
const BorderLeftCustomScrollbars = /*#__PURE__*/ (0, _baseDefault.default)((0, _customScrollbarsDefault.default), {
    target: "e18uufx56"
})("border-left:1px solid ", (0, _colors.color_shades_dark), ";");
const MenuItemEditorWrapper = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e18uufx55"
})({
    name: "yz1nei",
    styles: "margin-top:16px"
});
const MenuItemEditorHeader = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e18uufx54"
})({
    name: "fxjk4o",
    styles: "display:flex;align-items:center;height:64px"
});
const EmptyViewText = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e18uufx53"
})("background:white;border:1px solid ", (0, _colors.color_shades_dark), ";border-radius:8px;color:", (0, _colors.color_shades_dark), ";padding:24px;margin-top:24px;");
const EmptyViewPadding = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e18uufx52"
})({
    name: "yehwrb",
    styles: "margin-top:24px;width:100%"
});
const CustomLoader = /*#__PURE__*/ (0, _baseDefault.default)((0, _loaderDefault.default), {
    target: "e18uufx51"
})({
    name: "1085zez",
    styles: "position:fixed;top:50%;left:50%;transform:translate(-50%, -50%)"
});
const LabelWrapper = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e18uufx50"
})({
    name: "ho1qnd",
    styles: "display:flex;flex-direction:row"
});

},{"@emotion/styled/base":"lSuFu","@emotion/react":"djZKr","react":"6uln9","../../../components/general/Loader":"bnV5T","../../../components/structure/CustomScrollbars":"50vFq","../../../components/structure/HorizontalSeparator":"Pw3HQ","../../../constants/colors":"1p3OR","../../../hooks/UseWindowSize":"43j9z","../../featureContent/components/EmptyView":"j6GxB","./VoicifyMenuItems":"7Jl5q","./VoicifyMenuEditor":"ftqoA","uuid":"klst7","./VoicifyMenuHeader":"iQPQ0","../../../components/general/ImportFileDialog":"7LQaS","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7Jl5q":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _base = require("@emotion/styled/base");
var _baseDefault = parcelHelpers.interopDefault(_base);
var _react = require("@emotion/react");
var _css = require("@emotion/css");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _button = require("../../../components/general/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _colors = require("../../../constants/colors");
var _confirmationDialog = require("../../../components/structure/ConfirmationDialog");
var _confirmationDialogDefault = parcelHelpers.interopDefault(_confirmationDialog);
var _warningConfirmation = require("../../../components/general/WarningConfirmation");
var _warningConfirmationDefault = parcelHelpers.interopDefault(_warningConfirmation);
var _searchField = require("../../../components/forms/SearchField");
var _searchFieldDefault = parcelHelpers.interopDefault(_searchField);
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const deleteIcon = require("8b11876082f689b7");
const duplicateIcon = require("b4ad78ba52ca706a");
const addIcon = require("a27ba876de19d8ba");
const redNoCircle = require("7a1d5d0f7ea8e37c");
const yellowUpdate = require("52ed69eb680461e4");
const VoicifyMenuItems = (props)=>{
    const [isConfirmDeleteModalOpen, setIsConfirmDeleteModalOpen] = (0, _react1.useState)(false);
    const [searchTerm, setSearchTerm] = (0, _react1.useState)("");
    const handleSearchChange = (e)=>{
        setSearchTerm(e.target.value);
    };
    const toggleConfirmDeleteModal = ()=>{
        setIsConfirmDeleteModalOpen(!isConfirmDeleteModalOpen);
    };
    const selectMenuItemAndOpenModal = (menuItem, index)=>{
        props.toggleItemActivation(menuItem, index);
        toggleConfirmDeleteModal();
    };
    const onConfirmDelete = (clickedMenuItem)=>{
        const copyOfUpdatedMenuItems = [
            ...props.updatedMenuItems
        ];
        const updatedMenuItemIndex = copyOfUpdatedMenuItems.findIndex((menuItem)=>{
            return menuItem.menuItem.id === clickedMenuItem.menuItem.id && menuItem.menuItem.comboId === clickedMenuItem.menuItem.comboId;
        });
        copyOfUpdatedMenuItems[updatedMenuItemIndex] = {
            ...clickedMenuItem,
            isDeleted: true
        };
        // update local menu item state to show deleted menu item
        props.setUpdatedMenuItems(copyOfUpdatedMenuItems);
        // close modal and rerender menu item state
        toggleConfirmDeleteModal();
    };
    const handleCopyMenuItem = (e, menuItem)=>{
        e.stopPropagation();
        const menuItemCopy = {
            ...menuItem
        };
        const updatedMenuItemIndex = props.updatedMenuItems.findIndex((updatedMenuItem)=>{
            return updatedMenuItem.menuItem.id === menuItemCopy.menuItem.id && updatedMenuItem.menuItem.comboId === menuItemCopy.menuItem.comboId;
        });
        props.handleAddItemClick(true, menuItemCopy.menuItem, updatedMenuItemIndex);
    };
    return (0, _react.jsx)((0, _reactDefault.default).Fragment, null, isConfirmDeleteModalOpen && (0, _react.jsx)((0, _confirmationDialogDefault.default), {
        title: `Confirm Delete`,
        deleteText: "Yes, Delete",
        isLoading: false,
        onClose: toggleConfirmDeleteModal,
        onConfirm: ()=>onConfirmDelete(props.selectedMenuItem)
    }, (0, _react.jsx)((0, _warningConfirmationDefault.default), {
        text: `Are you sure you want to delete menu item "${props.selectedMenuItem.menuItem.originalName}"?`
    })), props.updatedMenuItems?.length > 0 && (0, _react.jsx)((0, _reactDefault.default).Fragment, null, (0, _react.jsx)((0, _searchFieldDefault.default), {
        id: "searchField1",
        name: "searchField",
        placeholder: "Find a menu item",
        value: searchTerm,
        onChange: handleSearchChange,
        boxType: "square",
        className: searchPadding
    }), props.updatedMenuItems.filter((menuItem)=>menuItem?.menuItem?.originalName?.toLowerCase().includes(searchTerm.toLowerCase()))?.map((menuItem, index)=>{
        return (0, _react.jsx)(MenuItemWrapper, {
            className: index === props.activeItemIndex ? "active" : "",
            key: `${menuItem.menuItem.originalName} - ${index}`,
            onClick: ()=>{
                props.toggleItemActivation(menuItem, index);
            }
        }, (0, _react.jsx)((0, _buttonDefault.default), {
            themes: [
                "white-small"
            ],
            text: menuItem.menuItem.originalName,
            type: "button"
        }), (0, _react.jsx)(MenuItemActionButtons, null, (menuItem.isAdded || menuItem.isDeleted || menuItem.isModified) && (0, _react.jsx)((0, _buttonDefault.default), {
            themes: [
                "icon",
                "end-tight"
            ],
            icon: menuItem.isDeleted ? redNoCircle : menuItem.isModified ? yellowUpdate : addIcon
        }), (0, _react.jsx)((0, _buttonDefault.default), {
            themes: [
                "icon",
                "end-tight"
            ],
            icon: duplicateIcon,
            type: "button",
            onClick: (e)=>handleCopyMenuItem(e, menuItem)
        }), (0, _react.jsx)((0, _buttonDefault.default), {
            themes: [
                "icon",
                "end-tight"
            ],
            icon: deleteIcon,
            type: "button",
            onClick: ()=>selectMenuItemAndOpenModal(menuItem, index)
        })));
    })));
};
exports.default = VoicifyMenuItems;
const MenuItemActionButtons = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "ei92v0i1"
})({
    name: "zjik7",
    styles: "display:flex"
});
const MenuItemWrapper = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "ei92v0i0"
})("border:1px solid ", (0, _colors.color_shades_dark), ";border-radius:8px;margin:8px 0 8px 0;height:56px;display:flex;justify-content:space-between;align-items:center;cursor:pointer;&.active{border:1px solid ", (0, _colors.color_colors_ocean), ";box-shadow:0px 0px 4px 4px ", (0, _colors.color_variants_ocean_light_2), ";}");
const searchPadding = /*#__PURE__*/ (0, _css.css)({
    name: "de9hf",
    styles: "padding-top:16px"
});

},{"@emotion/styled/base":"lSuFu","@emotion/react":"djZKr","@emotion/css":"awUBr","react":"6uln9","../../../components/general/Button":"6ymxN","../../../constants/colors":"1p3OR","../../../components/structure/ConfirmationDialog":"kx7yK","../../../components/general/WarningConfirmation":"9OccO","../../../components/forms/SearchField":"aU10T","8b11876082f689b7":"7eyKJ","b4ad78ba52ca706a":"8rvGy","a27ba876de19d8ba":"kxmNT","7a1d5d0f7ea8e37c":"37PeV","52ed69eb680461e4":"8yrG0","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"ftqoA":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _base = require("@emotion/styled/base");
var _baseDefault = parcelHelpers.interopDefault(_base);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _jsoneditorReact = require("jsoneditor-react");
var _editorMinCss = require("jsoneditor-react/es/editor.min.css");
var _colors = require("../../../constants/colors");
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const VoicifyMenuEditor = (props)=>{
    const jsonEditorRef = (0, _react1.useRef)(null);
    (0, _react1.useEffect)(()=>{
        if (jsonEditorRef.current !== null) jsonEditorRef.current.set(props.menuItem ? props.menuItem : props.group);
    }, [
        props.menuItem,
        props.group
    ]);
    const setRef = (instance)=>{
        if (instance) jsonEditorRef.current = instance.jsonEditor;
        else jsonEditorRef.current = null;
    };
    return (0, _react.jsx)(MenuItemEditorWrapper, null, (0, _react.jsx)(CustomEditor, null, (0, _react.jsx)((0, _jsoneditorReact.JsonEditor), {
        ref: setRef,
        value: props.menuItem ? props.menuItem : props.group,
        onChange: (value)=>props.handleChange(value),
        enableTransform: false,
        enableSort: false,
        mode: "tree",
        allowedModes: [
            "tree",
            "code"
        ],
        sortObjectKeys: true
    })));
};
exports.default = VoicifyMenuEditor;
const MenuItemEditorWrapper = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e53bge41"
})({
    name: "pinkt9",
    styles: ".field-wrapper{label{font-size:14px;line-height:20px;font-weight:400;}}.field-container{height:44px;}label{font-size:14px;line-height:20px;font-weight:400;}"
});
const CustomEditor = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e53bge40"
})("font-family:Muli;*.jsoneditor-mode-tree{border:1px solid ", (0, _colors.color_shades_dark), ";font-family:Muli;}div.jsoneditor-menu{background-color:", (0, _colors.color_shades_darkest), ";border-bottom:none;}ul.jsoneditor-menu{background-color:white;}*.jsoneditor-navigation-bar{font-family:Muli;}.div.jsoneditor-field,div.jsoneditor-value,div.jsoneditor td,div.jsoneditor th,div.jsoneditor textarea,pre.jsoneditor-preview,.jsoneditor-schema-error,.jsoneditor-popover{font-family:Muli;}div.jsoneditor-tree div.jsoneditor-color{display:none;}");

},{"@emotion/styled/base":"lSuFu","@emotion/react":"djZKr","react":"6uln9","jsoneditor-react":"5EVpf","jsoneditor-react/es/editor.min.css":"k1OaE","../../../constants/colors":"1p3OR","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"k1OaE":[function() {},{}],"iQPQ0":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "VoicifyMenuHeader", ()=>VoicifyMenuHeader);
var _base = require("@emotion/styled/base");
var _baseDefault = parcelHelpers.interopDefault(_base);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _roundedSelectionRow = require("../../../components/general/RoundedSelectionRow");
var _roundedSelectionRowDefault = parcelHelpers.interopDefault(_roundedSelectionRow);
var _button = require("../../../components/general/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _horizontalSeparator = require("../../../components/structure/HorizontalSeparator");
var _horizontalSeparatorDefault = parcelHelpers.interopDefault(_horizontalSeparator);
var _interactionModelUiStateContainer = require("../../../hooks/InteractionModelUiStateContainer");
var _interactionModelUiStateContainerDefault = parcelHelpers.interopDefault(_interactionModelUiStateContainer);
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const exportIcon = require("4d03f3528280eeb0");
const importIcon = require("1d4179a8e136048");
const VoicifyMenuHeader = (props)=>{
    const uiStateContainer = (0, _interactionModelUiStateContainerDefault.default).useContainer();
    const options = [
        {
            name: "Menu Items"
        },
        {
            name: "Option Groups"
        },
        {
            name: "Size Groups"
        }
    ];
    const selectOption = (index)=>{
        switch(index){
            case 0:
                uiStateContainer.setMenuEditorView("Menu Items");
                break;
            case 1:
                uiStateContainer.setMenuEditorView("Option Groups");
                break;
            case 2:
                uiStateContainer.setMenuEditorView("Size Groups");
                break;
            default:
                break;
        }
    };
    const selectedFilter = (options)=>{
        switch(options){
            case "Menu Items":
                return 0;
            case "Option Groups":
                return 1;
            case "Size Groups":
                return 2;
            default:
                return 0;
        }
    };
    return (0, _react.jsx)((0, _reactDefault.default).Fragment, null, (0, _react.jsx)(MenuHeaderWrapper, null, (0, _react.jsx)(MenuHeaderTopRow, null, (0, _react.jsx)(StyledRoundedSelectionRow, {
        options: options,
        className: roundedSelectStyle,
        optionClassName: roundedOptionStyle,
        optionTextClassName: optionTextStyle,
        onClick: (index)=>selectOption(index),
        selectedFilter: selectedFilter(uiStateContainer.menuEditorView)
    }), (0, _react.jsx)(ButtonWrapper, null, props.showAddItemButton && (0, _react.jsx)((0, _reactDefault.default).Fragment, null, (0, _react.jsx)((0, _buttonDefault.default), {
        themes: [
            "primary-small",
            "start"
        ],
        disabled: props.isLoading,
        loading: props.isLoading,
        onClick: ()=>props.handleAddItemClick(),
        className: addItemButton,
        text: "Add an item"
    })))), props.showAddItemButton && (0, _react.jsx)(MenuHeaderBottomRow, null, (0, _react.jsx)((0, _buttonDefault.default), {
        disabled: props.isLoading,
        loading: props.isLoading,
        type: "submit",
        themes: [
            "secondary-small",
            "end-tight"
        ],
        rightIcon: importIcon,
        className: importButton,
        onClick: ()=>props.handleImportMenuClick(),
        text: "Import Full Menu"
    }), (0, _react.jsx)((0, _buttonDefault.default), {
        disabled: props.isLoading,
        loading: props.isLoading,
        type: "submit",
        themes: [
            "secondary-small",
            "end-tight"
        ],
        rightIcon: exportIcon,
        onClick: ()=>props.handleExportMenuClick(),
        className: exportButton,
        text: "Export Full Menu"
    }))), (0, _react.jsx)((0, _horizontalSeparatorDefault.default), null));
};
const addItemButton = /*#__PURE__*/ (0, _css.css)({
    name: "1gzdbic",
    styles: "margin-right:0;margin-top:4px"
});
const MenuHeaderTopRow = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1xqbkzk4"
})({
    name: "1f1m9i6",
    styles: "display:flex;justify-content:space-between;align-items:flex-start"
});
const MenuHeaderBottomRow = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1xqbkzk3"
})({
    name: "1duj7gx",
    styles: "align-self:flex-end"
});
const exportButton = /*#__PURE__*/ (0, _css.css)({
    name: "r25eut",
    styles: "margin:auto auto 16px auto"
});
const importButton = /*#__PURE__*/ (0, _css.css)({
    name: "1hfsadt",
    styles: "margin:auto 8px auto auto"
});
const ButtonWrapper = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1xqbkzk2"
})({
    name: "pezd64",
    styles: "flex:1;display:flex;justify-content:flex-end"
});
const StyledRoundedSelectionRow = /*#__PURE__*/ (0, _baseDefault.default)((0, _roundedSelectionRowDefault.default), {
    target: "e1xqbkzk1"
})({
    name: "19u4ht3",
    styles: "flex:1;margin-bottom:16px"
});
const MenuHeaderWrapper = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1xqbkzk0"
})({
    name: "1wyph20",
    styles: "flex-direction:column;display:flex"
});
const roundedSelectStyle = /*#__PURE__*/ (0, _css.css)({
    name: "s0vnfv",
    styles: "height:32px"
});
const roundedOptionStyle = /*#__PURE__*/ (0, _css.css)({
    name: "v5zuxa",
    styles: "height:35px"
});
const optionTextStyle = /*#__PURE__*/ (0, _css.css)({
    name: "11rcwxl",
    styles: "margin-bottom:4px"
});
exports.default = VoicifyMenuHeader;

},{"@emotion/styled/base":"lSuFu","@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","../../../components/general/RoundedSelectionRow":"dUH5O","../../../components/general/Button":"6ymxN","../../../components/structure/HorizontalSeparator":"Pw3HQ","../../../hooks/InteractionModelUiStateContainer":"2A95n","4d03f3528280eeb0":"1wVxx","1d4179a8e136048":"d7E9Z","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1wVxx":[function(require,module,exports) {
module.exports = require("2afbe6277789e3e6").getBundleURL("kVLro") + require("41d725396cd0da0").resolve("krPb3");

},{"2afbe6277789e3e6":"c7Tr5","41d725396cd0da0":"fyJL2"}],"d7E9Z":[function(require,module,exports) {
module.exports = require("b6a291ffd3bcaaed").getBundleURL("kVLro") + require("c34e6e016caf5f97").resolve("lUheG");

},{"b6a291ffd3bcaaed":"c7Tr5","c34e6e016caf5f97":"fyJL2"}],"7PsFm":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _base = require("@emotion/styled/base");
var _baseDefault = parcelHelpers.interopDefault(_base);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _loader = require("../../../components/general/Loader");
var _loaderDefault = parcelHelpers.interopDefault(_loader);
var _customScrollbars = require("../../../components/structure/CustomScrollbars");
var _customScrollbarsDefault = parcelHelpers.interopDefault(_customScrollbars);
var _horizontalSeparator = require("../../../components/structure/HorizontalSeparator");
var _horizontalSeparatorDefault = parcelHelpers.interopDefault(_horizontalSeparator);
var _colors = require("../../../constants/colors");
var _useWindowSize = require("../../../hooks/UseWindowSize");
var _useWindowSizeDefault = parcelHelpers.interopDefault(_useWindowSize);
var _emptyView = require("../../featureContent/components/EmptyView");
var _emptyViewDefault = parcelHelpers.interopDefault(_emptyView);
var _voicifyGroups = require("./VoicifyGroups");
var _voicifyGroupsDefault = parcelHelpers.interopDefault(_voicifyGroups);
var _voicifyMenuHeader = require("./VoicifyMenuHeader");
var _voicifyMenuHeaderDefault = parcelHelpers.interopDefault(_voicifyMenuHeader);
var _voicifyMenuEditor = require("./VoicifyMenuEditor");
var _voicifyMenuEditorDefault = parcelHelpers.interopDefault(_voicifyMenuEditor);
var _tooltipWrapper = require("../../../components/general/TooltipWrapper");
var _tooltipWrapperDefault = parcelHelpers.interopDefault(_tooltipWrapper);
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const VoicifyGroupsEditor = (props)=>{
    const [activeItemId, setActiveItemId] = (0, _react1.useState)();
    const [groupCopy, setGroupCopy] = (0, _react1.useState)(null);
    const [showPasteIcon, setShowPasteIcon] = (0, _react1.useState)(false);
    const windowSize = (0, _useWindowSizeDefault.default)();
    const areOptionGroups = props.groupType === "optionGroup";
    (0, _react1.useEffect)(()=>{
        return ()=>{
            if (props.latestChangedGroup) props.performGroupChange(props.latestChangedGroup, props.latestGroupToReplace);
        };
    }, []);
    const handleCopyGroup = (e, group)=>{
        e.stopPropagation();
        toggleItemActivation(group);
        setGroupCopy(group);
        setShowPasteIcon(true);
    };
    const handleGroupPaste = (e, groupToReplace)=>{
        e.stopPropagation();
        toggleItemActivation(groupToReplace);
        if ("optionGroup" in groupCopy) handleGroupChange(groupCopy.optionGroup, groupToReplace);
        else if ("sizeGroup" in groupCopy) handleGroupChange(groupCopy.sizeGroup, groupToReplace);
    };
    const toggleItemActivation = (clickedGroup)=>{
        if (props.latestChangedGroup) props.performGroupChange(props.latestChangedGroup, props.latestGroupToReplace);
        setActiveItemId(clickedGroup?.editId);
        props.setSelectedGroup(clickedGroup);
    };
    const handleGroupChange = (changedGroup, groupToReplace)=>{
        const groupListItemIndex = props.groupsList.findIndex((group)=>group.editId === (groupToReplace?.editId ?? props.selectedGroup?.editId));
        const groupListItem = props.groupsList[groupListItemIndex];
        let updatedGroupListItem = {
            ...groupListItem,
            isModified: true
        };
        let newArray = [
            ...props.groupsList
        ];
        if ("options" in changedGroup) updatedGroupListItem.optionGroup = changedGroup;
        else if ("sizes" in changedGroup) updatedGroupListItem.sizeGroup = changedGroup;
        newArray[groupListItemIndex] = updatedGroupListItem;
        props.setGroupsList(newArray);
        props.setLatestChangedGroup(changedGroup);
        props.setLatestGroupToReplace(groupToReplace);
    };
    const getMenuItemsWithGroup = (group)=>{
        const matchingMenuItems = props.matches.find((match)=>match[group.editId]);
        if (!matchingMenuItems) return [];
        let matchingMenuItemNames = matchingMenuItems[group.editId]?.map((id)=>{
            const matchingMenuItem = props.originalMenuItems?.find((menuItem)=>menuItem.menuItem.id === id);
            return matchingMenuItem?.menuItem.originalName ?? null;
        });
        matchingMenuItemNames = [
            ...new Set(matchingMenuItemNames)
        ];
        let allMatchingMenuItemNames = matchingMenuItemNames.join(", ");
        if (matchingMenuItemNames?.length >= 3) {
            const [firstMenuItem, secondMenuItem, thirdMenuItem, ...rest] = matchingMenuItemNames;
            //account for long menu item names by restricting character count to 72
            const totalCharacterLength = firstMenuItem.length + secondMenuItem.length + thirdMenuItem.length;
            if (totalCharacterLength <= 72) return [
                `${firstMenuItem}, ${secondMenuItem}, ${thirdMenuItem}${rest.length > 0 ? "..." : ""}`,
                allMatchingMenuItemNames
            ];
            else return [
                `${firstMenuItem}${rest.length > 0 ? "..." : ""}`,
                allMatchingMenuItemNames
            ];
        } else if (matchingMenuItems[group.editId]?.length === 2) {
            const [firstMenuItem, secondMenuItem, ...rest] = matchingMenuItemNames;
            return [
                `${firstMenuItem}, ${secondMenuItem}${rest.length > 0 ? "..." : ""}`,
                allMatchingMenuItemNames
            ];
        }
        return [
            allMatchingMenuItemNames ?? null
        ];
    };
    return (0, _react.jsx)((0, _reactDefault.default).Fragment, null, props.isLoading ? (0, _react.jsx)(CustomLoader, null) : (0, _react.jsx)(GroupsWrapper, null, (0, _react.jsx)((0, _customScrollbarsDefault.default), {
        autoHide: true,
        autoHeight: true,
        autoHeightMin: windowSize.windowSize.innerHeight - 210,
        autoHeightMax: windowSize.windowSize.innerHeight - 210
    }, (0, _react.jsx)(Panel, null, (0, _react.jsx)((0, _voicifyMenuHeaderDefault.default), {
        isLoading: props.isLoading
    }), !props.areGroups && !props.isLoading && (0, _react.jsx)(EmptyViewPadding, null, (0, _react.jsx)((0, _emptyViewDefault.default), {
        subtext: `There are currently no menu items with ${areOptionGroups ? "option groups." : "size groups."}`
    })), props.areGroups && !props.isLoading && (0, _react.jsx)((0, _voicifyGroupsDefault.default), {
        getMenuItemsWithGroup: getMenuItemsWithGroup,
        activeItemId: activeItemId,
        toggleItemActivation: toggleItemActivation,
        groups: props.groupsList,
        handleCopyGroup: handleCopyGroup,
        handleGroupPaste: handleGroupPaste,
        groupCopy: groupCopy,
        showPasteIcon: showPasteIcon,
        groupType: areOptionGroups ? "optionGroup" : "sizeGroup"
    }))), (0, _react.jsx)(BorderLeftCustomScrollbars, {
        autoHide: true,
        autoHeight: true,
        autoHeightMin: windowSize.windowSize.innerHeight - 210,
        autoHeightMax: windowSize.windowSize.innerHeight - 210
    }, (0, _react.jsx)(Panel, null, props.selectedGroup && activeItemId != null ? (0, _react.jsx)(GroupEditorHeader, null, "Edit ", areOptionGroups ? "Option" : "Size", " Groups for:", getMenuItemsWithGroup(props.selectedGroup)?.length > 1 ? (0, _react.jsx)((0, _tooltipWrapperDefault.default), {
        text: getMenuItemsWithGroup(props.selectedGroup)[1]
    }, (0, _react.jsx)(ItemsWrapper, null, getMenuItemsWithGroup(props.selectedGroup)[0])) : (0, _react.jsx)(ItemsWrapper, null, getMenuItemsWithGroup(props.selectedGroup)[0])) : (0, _react.jsx)(GroupEditorHeader, null, "Edit ", areOptionGroups ? "Option" : "Size", " Group"), (0, _react.jsx)((0, _horizontalSeparatorDefault.default), null), (0, _react.jsx)(GroupEditorWrapper, null, props.areGroups && props.selectedGroup != null ? (0, _react.jsx)((0, _voicifyMenuEditorDefault.default), {
        group: areOptionGroups ? props.selectedGroup.optionGroup : props.selectedGroup.sizeGroup,
        handleChange: handleGroupChange
    }) : (0, _react.jsx)(EmptyViewText, null, "Select ", areOptionGroups ? "an option" : "a size", " group to see more details and manage values"))))));
};
exports.default = VoicifyGroupsEditor;
const ItemsWrapper = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1glsjhy8"
})({
    name: "1qcrfxt",
    styles: "font-size:12px;margin-left:8px"
});
const GroupsWrapper = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1glsjhy7"
})({
    name: "j9lc9v",
    styles: "height:100%;display:flex"
});
const Panel = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1glsjhy6"
})({
    name: "18zee9v",
    styles: "padding:16px 32px 16px 32px"
});
const BorderLeftCustomScrollbars = /*#__PURE__*/ (0, _baseDefault.default)((0, _customScrollbarsDefault.default), {
    target: "e1glsjhy5"
})("border-left:1px solid ", (0, _colors.color_shades_dark), ";");
const GroupEditorWrapper = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1glsjhy4"
})("");
const GroupEditorHeader = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1glsjhy3"
})({
    name: "fxjk4o",
    styles: "display:flex;align-items:center;height:64px"
});
const EmptyViewText = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1glsjhy2"
})("background:white;border:1px solid ", (0, _colors.color_shades_dark), ";border-radius:8px;color:", (0, _colors.color_shades_dark), ";padding:24px;margin-top:24px;");
const EmptyViewPadding = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1glsjhy1"
})({
    name: "yehwrb",
    styles: "margin-top:24px;width:100%"
});
const CustomLoader = /*#__PURE__*/ (0, _baseDefault.default)((0, _loaderDefault.default), {
    target: "e1glsjhy0"
})({
    name: "1pp2wda",
    styles: "position:relative;top:auto;margin-top:30px;margin-bottom:30px"
});

},{"@emotion/styled/base":"lSuFu","@emotion/react":"djZKr","react":"6uln9","../../../components/general/Loader":"bnV5T","../../../components/structure/CustomScrollbars":"50vFq","../../../components/structure/HorizontalSeparator":"Pw3HQ","../../../constants/colors":"1p3OR","../../../hooks/UseWindowSize":"43j9z","../../featureContent/components/EmptyView":"j6GxB","./VoicifyGroups":"2Ydz1","./VoicifyMenuHeader":"iQPQ0","./VoicifyMenuEditor":"ftqoA","../../../components/general/TooltipWrapper":"53pWd","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2Ydz1":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _base = require("@emotion/styled/base");
var _baseDefault = parcelHelpers.interopDefault(_base);
var _react = require("@emotion/react");
var _css = require("@emotion/css");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _button = require("../../../components/general/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _colors = require("../../../constants/colors");
var _searchField = require("../../../components/forms/SearchField");
var _searchFieldDefault = parcelHelpers.interopDefault(_searchField);
var _tooltipWrapper = require("../../../components/general/TooltipWrapper");
var _tooltipWrapperDefault = parcelHelpers.interopDefault(_tooltipWrapper);
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const yellowUpdate = require("6a27b4e2eb860ed5");
const duplicateIcon = require("b291e0cf1d2a98e5");
const pasteIcon = require("cfd9325a4ee187e8");
const VoicifyGroups = (props)=>{
    const [searchTerm, setSearchTerm] = (0, _react1.useState)("");
    const handleSearchChange = (e)=>{
        setSearchTerm(e.target.value);
    };
    let filteredGroups = [];
    if (props.groupType === "optionGroup") filteredGroups = props.groups?.filter((group)=>group.optionGroup.name?.toLowerCase().includes(searchTerm.toLowerCase()));
    else filteredGroups = props.groups?.filter((group)=>{
        const menuItems = props.getMenuItemsWithGroup(group);
        return menuItems?.some((item)=>item.toLowerCase().includes(searchTerm.toLowerCase()));
    });
    return (0, _react.jsx)((0, _reactDefault.default).Fragment, null, props.groups?.length > 0 && (0, _react.jsx)((0, _reactDefault.default).Fragment, null, (0, _react.jsx)((0, _searchFieldDefault.default), {
        name: "searchField",
        placeholder: props.groupType === "optionGroup" ? "Find an option group" : "Find a size group",
        value: searchTerm,
        onChange: handleSearchChange,
        boxType: "square",
        className: searchPadding
    }), filteredGroups.map((group)=>{
        return (0, _react.jsx)(OptionGroupWrapper, {
            className: group.editId === props.activeItemId ? "active" : "",
            key: group.editId,
            onClick: ()=>{
                props.toggleItemActivation(group);
            }
        }, (0, _react.jsx)((0, _tooltipWrapperDefault.default), {
            text: props.getMenuItemsWithGroup(group)?.length > 1 ? props.getMenuItemsWithGroup(group)[1] : props.getMenuItemsWithGroup(group)[0],
            place: "right",
            className: tooltipStyle
        }, (0, _react.jsx)(ListItemLeftWrapper, null, (0, _react.jsx)((0, _buttonDefault.default), {
            themes: [
                "white-small"
            ],
            text: props.groupType === "optionGroup" ? group.optionGroup.name : props.getMenuItemsWithGroup(group)[0],
            type: "button"
        }), (0, _react.jsx)(MenuItemsWrapper, null, props.groupType === "optionGroup" ? props.getMenuItemsWithGroup(group)[0] : ""))), (0, _react.jsx)(MenuItemActionButtons, null, group.isModified && (0, _react.jsx)((0, _buttonDefault.default), {
            themes: [
                "icon",
                "end-tight"
            ],
            icon: group.isModified && yellowUpdate
        }), props.showPasteIcon && (0, _react.jsx)((0, _buttonDefault.default), {
            themes: [
                "icon",
                "end-tight"
            ],
            icon: pasteIcon,
            type: "button",
            onClick: (e)=>props.handleGroupPaste(e, group)
        }), (0, _react.jsx)((0, _buttonDefault.default), {
            themes: [
                "icon",
                "end-tight"
            ],
            icon: duplicateIcon,
            type: "button",
            onClick: (e)=>props.handleCopyGroup(e, group)
        })));
    })));
};
exports.default = VoicifyGroups;
const tooltipStyle = /*#__PURE__*/ (0, _css.css)({
    name: "1muemwe",
    styles: "width:30%"
});
const ListItemLeftWrapper = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e10rt73h3"
})({
    name: "s5xdrg",
    styles: "display:flex;align-items:center"
});
const MenuItemActionButtons = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e10rt73h2"
})({
    name: "zjik7",
    styles: "display:flex"
});
const MenuItemsWrapper = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e10rt73h1"
})({
    name: "19ednsi",
    styles: "font-size:8px;margin-left:8px"
});
const OptionGroupWrapper = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e10rt73h0"
})("border:1px solid ", (0, _colors.color_shades_dark), ";border-radius:8px;margin:8px 0 8px 0;height:56px;display:flex;justify-content:space-between;align-items:center;cursor:pointer;&.active{border:1px solid ", (0, _colors.color_colors_ocean), ";box-shadow:0px 0px 4px 4px ", (0, _colors.color_variants_ocean_light_2), ";}");
const searchPadding = /*#__PURE__*/ (0, _css.css)({
    name: "de9hf",
    styles: "padding-top:16px"
});

},{"@emotion/styled/base":"lSuFu","@emotion/react":"djZKr","@emotion/css":"awUBr","react":"6uln9","../../../components/general/Button":"6ymxN","../../../constants/colors":"1p3OR","../../../components/forms/SearchField":"aU10T","../../../components/general/TooltipWrapper":"53pWd","6a27b4e2eb860ed5":"8yrG0","b291e0cf1d2a98e5":"8rvGy","cfd9325a4ee187e8":"7Jgt9","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7Jgt9":[function(require,module,exports) {
module.exports = require("a2e071bd3e23236d").getBundleURL("kVLro") + require("c9e7afae4ef2b0df").resolve("cGbj7");

},{"a2e071bd3e23236d":"c7Tr5","c9e7afae4ef2b0df":"fyJL2"}],"fxZ8I":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _api = require("../api");
var _unstatedNext = require("unstated-next");
function useApplicationNlpGenAIContainer() {
    const [isLoading, setIsLoading] = (0, _react.useState)(false);
    const [errors, setErrors] = (0, _react.useState)([]);
    const [isSavedSuccessfully, setIsSavedSuccessfully] = (0, _react.useState)(false);
    const saveGenerativeAIAssistantPrompt = async (applicationId, generativeAIAssistantPrompt, featureFlag)=>{
        try {
            if (!generativeAIAssistantPrompt) {
                setErrors([
                    "Prompt cannot be empty"
                ]);
                return;
            }
            setIsLoading(true);
            const result = await _api.updateGenerativeAIAssistantPrompt(applicationId, generativeAIAssistantPrompt, featureFlag);
            if (result.resultType != "Ok" && result.errors != null && result.errors.length > 0) {
                setErrors(result.errors);
                setIsSavedSuccessfully(false);
            } else if (result.resultType != "Ok") {
                setErrors([
                    "An error occurred while saving the prompt"
                ]);
                setIsSavedSuccessfully(false);
            }
            setIsSavedSuccessfully(result.resultType == "Ok");
            setIsLoading(false);
            return result;
        } catch (error) {
            setErrors([
                error
            ]);
            setIsLoading(false);
            setIsSavedSuccessfully(false);
        }
    };
    return {
        isLoading,
        errors,
        saveGenerativeAIAssistantPrompt,
        isSavedSuccessfully
    };
}
const ApplicationNlpGenAIContainer = (0, _unstatedNext.createContainer)(useApplicationNlpGenAIContainer);
exports.default = ApplicationNlpGenAIContainer;

},{"react":"6uln9","../api":"loxM6","unstated-next":"61zE5","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"kQddt":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _extends = require("@babel/runtime/helpers/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _base = require("@emotion/styled/base");
var _baseDefault = parcelHelpers.interopDefault(_base);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _reactHookForm = require("react-hook-form");
var _textAreaField = require("../../../components/forms/TextAreaField");
var _textAreaFieldDefault = parcelHelpers.interopDefault(_textAreaField);
var _button = require("../../../components/general/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _colors = require("../../../constants/colors");
var _customScrollbars = require("../../../components/structure/CustomScrollbars");
var _customScrollbarsDefault = parcelHelpers.interopDefault(_customScrollbars);
var _styledDropdown = require("../../applicationSettings/components/customAssistantConfigurations/StyledDropdown");
var _styledDropdownDefault = parcelHelpers.interopDefault(_styledDropdown);
var _useWindowSize = require("../../../hooks/UseWindowSize");
var _useWindowSizeDefault = parcelHelpers.interopDefault(_useWindowSize);
var _featureFlagSettingIds = require("../../../constants/featureFlagSettingIds");
var _genAiModels = require("../../../constants/genAiModels");
var _contentCollapsingSection = require("../../../components/structure/ContentCollapsingSection");
var _contentCollapsingSectionDefault = parcelHelpers.interopDefault(_contentCollapsingSection);
var _iconTooltip = require("../../../components/general/IconTooltip");
var _iconTooltipDefault = parcelHelpers.interopDefault(_iconTooltip);
var _css = require("@emotion/css");
var _checkboxField = require("../../../components/forms/CheckboxField");
var _checkboxFieldDefault = parcelHelpers.interopDefault(_checkboxField);
var _formFieldsContainer = require("../../../components/structure/FormFieldsContainer");
var _formFieldsContainerDefault = parcelHelpers.interopDefault(_formFieldsContainer);
var _horizontalOptionsSelector = require("../../../components/forms/HorizontalOptionsSelector");
var _horizontalOptionsSelectorDefault = parcelHelpers.interopDefault(_horizontalOptionsSelector);
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const FeatureSettings = (props)=>{
    const resolver = async (values)=>{
        const errors = {};
        return {
            values: values,
            errors
        };
    };
    const [featureFlagSettings, setFeatureFlagSettings] = (0, _react1.useState)([]);
    const { control, handleSubmit, formState: { errors }, setValue, getValues } = (0, _reactHookForm.useForm)({
        resolver,
        mode: "onChange",
        defaultValues: {
            systemPrompt: "",
            featureFlagId: ""
        }
    });
    const options = [
        {
            name: "Most Deterministic",
            value: 0
        },
        {
            name: "Very Conservative",
            value: 0.2
        },
        {
            name: "Slightly Creative",
            value: 0.4
        },
        {
            name: "Balanced",
            value: 0.6
        },
        {
            name: "Very Creative",
            value: 0.8
        },
        {
            name: "Most Random",
            value: 1
        }
    ];
    const windowSize = (0, _useWindowSizeDefault.default)();
    (0, _react1.useEffect)(()=>{
        props.appContainer.loadFeatureFlags().then(()=>{
            const featureFlags = props.appContainer?.state?.currentApp.featureFlags;
            if (featureFlags?.length > 0) {
                let defaultFlag = featureFlags.find((f)=>f.name == "Generative Assistant Ordering");
                if (!defaultFlag) defaultFlag = featureFlags[0];
                setValue("featureFlagId", defaultFlag.id, {
                    shouldValidate: true,
                    shouldDirty: true
                });
            }
        });
    }, []);
    (0, _react1.useEffect)(()=>{
        const selectedFlag = props?.appContainer?.state?.featureFlags?.find((f)=>f.id === getValues().featureFlagId);
        if (selectedFlag?.featureFlagSettings) {
            const applicationFeatureFlag = props.appContainer?.state?.currentApp.featureFlags?.find((f)=>f.id === getValues().featureFlagId);
            for (const featureFlagSetting of selectedFlag?.featureFlagSettings)featureFlagSetting.value = applicationFeatureFlag.featureFlagSettings?.find((fs)=>fs.id === featureFlagSetting.id)?.value;
            setFeatureFlagSettings([
                ...selectedFlag.featureFlagSettings
            ]);
        }
    }, [
        getValues().featureFlagId,
        props?.appContainer?.state?.featureFlags
    ]);
    const handleFeatureFlagChange = (value)=>{
        const featureFlags = props.appContainer?.state?.currentApp.featureFlags;
        const selectedFlag = featureFlags?.find((f)=>f.id === value);
        if (selectedFlag) setValue("featureFlagId", selectedFlag.id, {
            shouldValidate: true,
            shouldDirty: true
        });
    };
    const onSubmit = (data)=>{
        props.handleSave({
            featureFlagId: data.featureFlagId,
            featureFlagSettings: featureFlagSettings
        });
    };
    const renderTitleRightComponent = (tooltip)=>{
        if (tooltip) return (0, _react.jsx)((0, _iconTooltipDefault.default), {
            text: tooltip,
            place: "top"
        });
        return null;
    };
    return (0, _react.jsx)((0, _reactDefault.default).Fragment, null, (0, _react.jsx)(Container, null, (0, _react.jsx)("form", {
        onSubmit: handleSubmit(onSubmit)
    }, (0, _react.jsx)(TopContainer, null, (0, _react.jsx)(DropdownWrapper, null, (0, _react.jsx)((0, _reactHookForm.Controller), {
        name: "featureFlagId",
        control: control,
        render: ({ field })=>(0, _react.jsx)(CustomDropdown, (0, _extendsDefault.default)({}, field, {
                handleOnChange: (optionValue, value)=>{
                    field.onChange(value);
                    handleFeatureFlagChange(value);
                },
                options: props.appContainer?.state?.currentApp.featureFlags ? props.appContainer?.state?.currentApp.featureFlags.map((f)=>({
                        label: f.name,
                        value: f.id
                    })) : [],
                size: "medium",
                label: "Feature Flag",
                className: "custom_drop_down"
            }))
    })), (0, _react.jsx)(ButtonWrapper, null, (0, _react.jsx)(SaveButton, {
        type: "submit",
        disabled: props.isLoading,
        themes: [
            "primary"
        ],
        text: "Save",
        loading: props.isLoading
    }))), (0, _react.jsx)((0, _customScrollbarsDefault.default), {
        autoHide: true,
        autoHeight: true,
        autoHeightMax: "calc(100vh - 390px)"
    }, (0, _react.jsx)(SettingOptionsWrapper, null, featureFlagSettings?.sort((a, b)=>a.renderOrder - b.renderOrder)?.map((flagSetting, index)=>{
        var defaultValue = "";
        if (flagSetting.id === (0, _featureFlagSettingIds.FoodOrderingGenAIModelSettingId)) defaultValue = (0, _genAiModels.GenAIModels)[0].value;
        if (flagSetting.id === (0, _featureFlagSettingIds.FoodOrderingGenAIModelSettingId)) return (0, _react.jsx)(CustomDropdown, {
            key: flagSetting.id,
            handleOnChange: (optionValue, value)=>{
                const newSettings = [
                    ...featureFlagSettings
                ];
                newSettings[index] = {
                    ...newSettings[index],
                    value: value
                };
                setFeatureFlagSettings(newSettings);
            },
            fieldName: "value",
            label: flagSetting.name,
            options: (0, _genAiModels.GenAIModels),
            size: "medium",
            value: flagSetting.value?.length > 0 ? flagSetting.value : defaultValue,
            tooltip: flagSetting.description
        });
        if (flagSetting.type === "checkbox") return (0, _react.jsx)((0, _checkboxFieldDefault.default), {
            key: `KEY ${index}`,
            name: flagSetting.name,
            label: flagSetting.name,
            labelStyle: checkboxLabelStyle,
            disabled: props.isLoading,
            checked: flagSetting.value == "true",
            tooltip: flagSetting.description,
            tooltipPosition: "right",
            tooltipStyle: tooltipStyle,
            onChange: (e)=>{
                console.log(e);
                const newSettings = [
                    ...featureFlagSettings
                ];
                newSettings[index] = {
                    ...newSettings[index],
                    value: flagSetting.value == "true" ? "false" : "true"
                };
                setFeatureFlagSettings(newSettings);
            },
            className: checkboxField
        });
        if (flagSetting.type == "horizontal-options-selector") return (0, _react.jsx)((0, _formFieldsContainerDefault.default), null, (0, _react.jsx)(Name, null, flagSetting.name), (0, _react.jsx)((0, _horizontalOptionsSelectorDefault.default), {
            name: "temperature",
            options: options,
            value: parseFloat(flagSetting?.value ?? "0"),
            isCustom: false,
            onChange: (e)=>{
                const newSettings = [
                    ...featureFlagSettings
                ];
                newSettings[index] = {
                    ...newSettings[index],
                    value: e?.toString() ?? "0"
                };
                setFeatureFlagSettings(newSettings);
            }
        }));
        return (0, _react.jsx)(CollapsingSection, {
            title: flagSetting.name,
            id: "input",
            bottom: true,
            titleRightRowComponent: renderTitleRightComponent(flagSetting.description)
        }, (0, _react.jsx)((0, _textAreaFieldDefault.default), {
            key: flagSetting.id,
            id: flagSetting.id,
            value: flagSetting.value?.length > 0 ? flagSetting.value : defaultValue,
            placeholder: `${flagSetting.name}`,
            className: "field_value",
            showResponseVariableTest: true,
            onChange: (e)=>{
                const newSettings = [
                    ...featureFlagSettings
                ];
                newSettings[index] = {
                    ...newSettings[index],
                    value: e.target.value
                };
                setFeatureFlagSettings(newSettings);
            }
        }));
    }), !featureFlagSettings || featureFlagSettings?.length == 0 ? (0, _react.jsx)(EmptyStateMessage, null, "No settings are available for this feature flag") : (0, _react.jsx)((0, _reactDefault.default).Fragment, null))))));
};
const Container = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "expa37y10"
})("display:flex;flex-direction:column;gap:0px;padding:24px;margin:20px 40px;height:calc(100vh - 250px);background:", (0, _colors.color_defaults_white), ";border-radius:12px;box-shadow:0 4px 24px rgba(0, 0, 0, 0.06);transition:all 0.2s ease-in-out;.field_value{width:100%;margin-top:14px;label{margin-left:6px;}textarea{overflow-y:auto;}}.custom_drop_down{width:300px;margin:0;}");
const CollapsingSection = /*#__PURE__*/ (0, _baseDefault.default)((0, _contentCollapsingSectionDefault.default), {
    target: "expa37y9"
})({
    name: "3hgi0y",
    styles: "margin-top:32px"
});
const checkboxLabelStyle = /*#__PURE__*/ (0, _css.css)({
    name: "jarvx4",
    styles: "font-size:16px;margin-bottom:0px"
});
const checkboxField = /*#__PURE__*/ (0, _css.css)({
    name: "3hgi0y",
    styles: "margin-top:32px"
});
const TopContainer = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "expa37y8"
})("display:flex;justify-content:space-between;margin-bottom:24px;position:sticky;top:24px;background:", (0, _colors.color_defaults_white), ";z-index:1;padding-bottom:16px;border-bottom:1px solid #e0e0e0;");
const DropdownWrapper = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "expa37y7"
})({
    name: "82a6rk",
    styles: "flex:1"
});
const ButtonWrapper = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "expa37y6"
})({
    name: "6x4enz",
    styles: "display:flex;align-items:flex-end;margin-left:16px"
});
const CustomDropdown = /*#__PURE__*/ (0, _baseDefault.default)((0, _styledDropdownDefault.default), {
    target: "expa37y5"
})("");
const SettingOptionsWrapper = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "expa37y4"
})({
    name: "19s5ni1",
    styles: "padding:20px;margin-top:8px"
});
const SaveButton = /*#__PURE__*/ (0, _baseDefault.default)((0, _buttonDefault.default), {
    target: "expa37y3"
})("background-color:", (0, _colors.color_colors_ocean), ";height:40px;font-size:14px;font-weight:500;border-radius:8px;");
const ErrorMessageWrapper = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "expa37y2"
})("color:", (0, _colors.dark_red), ";font-size:14px;margin-top:4px;margin-left:6px;");
const EmptyStateMessage = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "expa37y1"
})("display:flex;align-items:center;justify-content:center;padding:32px;background-color:", (0, _colors.color_defaults_white), ";border-radius:8px;border:1px dashed #e0e0e0;color:#666;font-size:15px;font-weight:500;text-align:center;margin:16px 0;");
const tooltipStyle = /*#__PURE__*/ (0, _css.css)("width:20px;height:20px;margin-top:2px;margin-left:8px;border:solid 1px ", (0, _colors.text_blue), ";span{color:", (0, _colors.text_blue), ";}", "");
const tooltipContentStyle = /*#__PURE__*/ (0, _css.css)(".rc-tooltip-inner{font-family:Muli;font-size:14px;font-weight:normal;font-style:normal;letter-spacing:0.6px;z-index:120;color:", (0, _colors.color_shades_darker), ";background-color:white;border:1px solid ", (0, _colors.color_shades_dark), ";padding:8px;min-height:0;box-shadow:-1px 4px 10px 0 rgba(48, 69, 98, 0.1);}", "");
const Name = /*#__PURE__*/ (0, _baseDefault.default)("p", {
    target: "expa37y0"
})({
    name: "1q3jx6s",
    styles: "font-size:16px;margin-bottom:16px;margin-top:16px"
});
exports.default = FeatureSettings;

},{"@babel/runtime/helpers/extends":"4iKIP","@emotion/styled/base":"lSuFu","@emotion/react":"djZKr","react":"6uln9","react-hook-form":"3vT5K","../../../components/forms/TextAreaField":"fE54C","../../../components/general/Button":"6ymxN","../../../constants/colors":"1p3OR","../../../components/structure/CustomScrollbars":"50vFq","../../applicationSettings/components/customAssistantConfigurations/StyledDropdown":"hjrMo","../../../hooks/UseWindowSize":"43j9z","../../../constants/featureFlagSettingIds":"7LcoK","../../../constants/genAiModels":"7j9RQ","../../../components/structure/ContentCollapsingSection":"1CUms","../../../components/general/IconTooltip":"3FODC","@emotion/css":"awUBr","../../../components/forms/CheckboxField":"3S5Oy","../../../components/structure/FormFieldsContainer":"h3hzh","../../../components/forms/HorizontalOptionsSelector":"6A3ab","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3vT5K":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Controller", ()=>Controller);
parcelHelpers.export(exports, "Form", ()=>Form);
parcelHelpers.export(exports, "FormProvider", ()=>FormProvider);
parcelHelpers.export(exports, "appendErrors", ()=>appendErrors);
parcelHelpers.export(exports, "get", ()=>get);
parcelHelpers.export(exports, "set", ()=>set);
parcelHelpers.export(exports, "useController", ()=>useController);
parcelHelpers.export(exports, "useFieldArray", ()=>useFieldArray);
parcelHelpers.export(exports, "useForm", ()=>useForm);
parcelHelpers.export(exports, "useFormContext", ()=>useFormContext);
parcelHelpers.export(exports, "useFormState", ()=>useFormState);
parcelHelpers.export(exports, "useWatch", ()=>useWatch);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var isCheckBoxInput = (element)=>element.type === "checkbox";
var isDateObject = (value1)=>value1 instanceof Date;
var isNullOrUndefined = (value1)=>value1 == null;
const isObjectType = (value1)=>typeof value1 === "object";
var isObject = (value1)=>!isNullOrUndefined(value1) && !Array.isArray(value1) && isObjectType(value1) && !isDateObject(value1);
var getEventValue = (event)=>isObject(event) && event.target ? isCheckBoxInput(event.target) ? event.target.checked : event.target.value : event;
var getNodeParentName = (name)=>name.substring(0, name.search(/\.\d+(\.|$)/)) || name;
var isNameInFieldArray = (names, name)=>names.has(getNodeParentName(name));
var isPlainObject = (tempObject)=>{
    const prototypeCopy = tempObject.constructor && tempObject.constructor.prototype;
    return isObject(prototypeCopy) && prototypeCopy.hasOwnProperty("isPrototypeOf");
};
var isWeb = typeof window !== "undefined" && typeof window.HTMLElement !== "undefined" && typeof document !== "undefined";
function cloneObject(data) {
    let copy;
    const isArray = Array.isArray(data);
    if (data instanceof Date) copy = new Date(data);
    else if (data instanceof Set) copy = new Set(data);
    else if (!(isWeb && (data instanceof Blob || data instanceof FileList)) && (isArray || isObject(data))) {
        copy = isArray ? [] : {};
        if (!isArray && !isPlainObject(data)) copy = data;
        else {
            for(const key in data)if (data.hasOwnProperty(key)) copy[key] = cloneObject(data[key]);
        }
    } else return data;
    return copy;
}
var compact = (value1)=>Array.isArray(value1) ? value1.filter(Boolean) : [];
var isUndefined = (val)=>val === undefined;
var get = (object, path, defaultValue)=>{
    if (!path || !isObject(object)) return defaultValue;
    const result = compact(path.split(/[,[\].]+?/)).reduce((result, key)=>isNullOrUndefined(result) ? result : result[key], object);
    return isUndefined(result) || result === object ? isUndefined(object[path]) ? defaultValue : object[path] : result;
};
var isBoolean = (value1)=>typeof value1 === "boolean";
var isKey = (value1)=>/^\w*$/.test(value1);
var stringToPath = (input)=>compact(input.replace(/["|']|\]/g, "").split(/\.|\[/));
var set = (object, path, value1)=>{
    let index = -1;
    const tempPath = isKey(path) ? [
        path
    ] : stringToPath(path);
    const length = tempPath.length;
    const lastIndex = length - 1;
    while(++index < length){
        const key = tempPath[index];
        let newValue = value1;
        if (index !== lastIndex) {
            const objValue = object[key];
            newValue = isObject(objValue) || Array.isArray(objValue) ? objValue : !isNaN(+tempPath[index + 1]) ? [] : {};
        }
        if (key === "__proto__") return;
        object[key] = newValue;
        object = object[key];
    }
    return object;
};
const EVENTS = {
    BLUR: "blur",
    FOCUS_OUT: "focusout",
    CHANGE: "change"
};
const VALIDATION_MODE = {
    onBlur: "onBlur",
    onChange: "onChange",
    onSubmit: "onSubmit",
    onTouched: "onTouched",
    all: "all"
};
const INPUT_VALIDATION_RULES = {
    max: "max",
    min: "min",
    maxLength: "maxLength",
    minLength: "minLength",
    pattern: "pattern",
    required: "required",
    validate: "validate"
};
const HookFormContext = (0, _reactDefault.default).createContext(null);
/**
 * This custom hook allows you to access the form context. useFormContext is intended to be used in deeply nested structures, where it would become inconvenient to pass the context as a prop. To be used with {@link FormProvider}.
 *
 * @remarks
 * [API](https://react-hook-form.com/docs/useformcontext) • [Demo](https://codesandbox.io/s/react-hook-form-v7-form-context-ytudi)
 *
 * @returns return all useForm methods
 *
 * @example
 * ```tsx
 * function App() {
 *   const methods = useForm();
 *   const onSubmit = data => console.log(data);
 *
 *   return (
 *     <FormProvider {...methods} >
 *       <form onSubmit={methods.handleSubmit(onSubmit)}>
 *         <NestedInput />
 *         <input type="submit" />
 *       </form>
 *     </FormProvider>
 *   );
 * }
 *
 *  function NestedInput() {
 *   const { register } = useFormContext(); // retrieve all hook methods
 *   return <input {...register("test")} />;
 * }
 * ```
 */ const useFormContext = ()=>(0, _reactDefault.default).useContext(HookFormContext);
/**
 * A provider component that propagates the `useForm` methods to all children components via [React Context](https://reactjs.org/docs/context.html) API. To be used with {@link useFormContext}.
 *
 * @remarks
 * [API](https://react-hook-form.com/docs/useformcontext) • [Demo](https://codesandbox.io/s/react-hook-form-v7-form-context-ytudi)
 *
 * @param props - all useForm methods
 *
 * @example
 * ```tsx
 * function App() {
 *   const methods = useForm();
 *   const onSubmit = data => console.log(data);
 *
 *   return (
 *     <FormProvider {...methods} >
 *       <form onSubmit={methods.handleSubmit(onSubmit)}>
 *         <NestedInput />
 *         <input type="submit" />
 *       </form>
 *     </FormProvider>
 *   );
 * }
 *
 *  function NestedInput() {
 *   const { register } = useFormContext(); // retrieve all hook methods
 *   return <input {...register("test")} />;
 * }
 * ```
 */ const FormProvider = (props)=>{
    const { children, ...data } = props;
    return (0, _reactDefault.default).createElement(HookFormContext.Provider, {
        value: data
    }, children);
};
var getProxyFormState = (formState, control, localProxyFormState, isRoot = true)=>{
    const result = {
        defaultValues: control._defaultValues
    };
    for(const key in formState)Object.defineProperty(result, key, {
        get: ()=>{
            const _key = key;
            if (control._proxyFormState[_key] !== VALIDATION_MODE.all) control._proxyFormState[_key] = !isRoot || VALIDATION_MODE.all;
            localProxyFormState && (localProxyFormState[_key] = true);
            return formState[_key];
        }
    });
    return result;
};
var isEmptyObject = (value1)=>isObject(value1) && !Object.keys(value1).length;
var shouldRenderFormState = (formStateData, _proxyFormState, updateFormState, isRoot)=>{
    updateFormState(formStateData);
    const { name, ...formState } = formStateData;
    return isEmptyObject(formState) || Object.keys(formState).length >= Object.keys(_proxyFormState).length || Object.keys(formState).find((key)=>_proxyFormState[key] === (!isRoot || VALIDATION_MODE.all));
};
var convertToArrayPayload = (value1)=>Array.isArray(value1) ? value1 : [
        value1
    ];
var shouldSubscribeByName = (name, signalName, exact)=>!name || !signalName || name === signalName || convertToArrayPayload(name).some((currentName)=>currentName && (exact ? currentName === signalName : currentName.startsWith(signalName) || signalName.startsWith(currentName)));
function useSubscribe(props) {
    const _props = (0, _reactDefault.default).useRef(props);
    _props.current = props;
    (0, _reactDefault.default).useEffect(()=>{
        const subscription = !props.disabled && _props.current.subject && _props.current.subject.subscribe({
            next: _props.current.next
        });
        return ()=>{
            subscription && subscription.unsubscribe();
        };
    }, [
        props.disabled
    ]);
}
/**
 * This custom hook allows you to subscribe to each form state, and isolate the re-render at the custom hook level. It has its scope in terms of form state subscription, so it would not affect other useFormState and useForm. Using this hook can reduce the re-render impact on large and complex form application.
 *
 * @remarks
 * [API](https://react-hook-form.com/docs/useformstate) • [Demo](https://codesandbox.io/s/useformstate-75xly)
 *
 * @param props - include options on specify fields to subscribe. {@link UseFormStateReturn}
 *
 * @example
 * ```tsx
 * function App() {
 *   const { register, handleSubmit, control } = useForm({
 *     defaultValues: {
 *     firstName: "firstName"
 *   }});
 *   const { dirtyFields } = useFormState({
 *     control
 *   });
 *   const onSubmit = (data) => console.log(data);
 *
 *   return (
 *     <form onSubmit={handleSubmit(onSubmit)}>
 *       <input {...register("firstName")} placeholder="First Name" />
 *       {dirtyFields.firstName && <p>Field is dirty.</p>}
 *       <input type="submit" />
 *     </form>
 *   );
 * }
 * ```
 */ function useFormState(props) {
    const methods = useFormContext();
    const { control = methods.control, disabled, name, exact } = props || {};
    const [formState, updateFormState] = (0, _reactDefault.default).useState(control._formState);
    const _mounted = (0, _reactDefault.default).useRef(true);
    const _localProxyFormState = (0, _reactDefault.default).useRef({
        isDirty: false,
        isLoading: false,
        dirtyFields: false,
        touchedFields: false,
        validatingFields: false,
        isValidating: false,
        isValid: false,
        errors: false
    });
    const _name = (0, _reactDefault.default).useRef(name);
    _name.current = name;
    useSubscribe({
        disabled,
        next: (value1)=>_mounted.current && shouldSubscribeByName(_name.current, value1.name, exact) && shouldRenderFormState(value1, _localProxyFormState.current, control._updateFormState) && updateFormState({
                ...control._formState,
                ...value1
            }),
        subject: control._subjects.state
    });
    (0, _reactDefault.default).useEffect(()=>{
        _mounted.current = true;
        _localProxyFormState.current.isValid && control._updateValid(true);
        return ()=>{
            _mounted.current = false;
        };
    }, [
        control
    ]);
    return getProxyFormState(formState, control, _localProxyFormState.current, false);
}
var isString = (value1)=>typeof value1 === "string";
var generateWatchOutput = (names, _names, formValues, isGlobal, defaultValue)=>{
    if (isString(names)) {
        isGlobal && _names.watch.add(names);
        return get(formValues, names, defaultValue);
    }
    if (Array.isArray(names)) return names.map((fieldName)=>(isGlobal && _names.watch.add(fieldName), get(formValues, fieldName)));
    isGlobal && (_names.watchAll = true);
    return formValues;
};
/**
 * Custom hook to subscribe to field change and isolate re-rendering at the component level.
 *
 * @remarks
 *
 * [API](https://react-hook-form.com/docs/usewatch) • [Demo](https://codesandbox.io/s/react-hook-form-v7-ts-usewatch-h9i5e)
 *
 * @example
 * ```tsx
 * const { control } = useForm();
 * const values = useWatch({
 *   name: "fieldName"
 *   control,
 * })
 * ```
 */ function useWatch(props) {
    const methods = useFormContext();
    const { control = methods.control, name, defaultValue, disabled, exact } = props || {};
    const _name = (0, _reactDefault.default).useRef(name);
    _name.current = name;
    useSubscribe({
        disabled,
        subject: control._subjects.values,
        next: (formState)=>{
            if (shouldSubscribeByName(_name.current, formState.name, exact)) updateValue(cloneObject(generateWatchOutput(_name.current, control._names, formState.values || control._formValues, false, defaultValue)));
        }
    });
    const [value1, updateValue] = (0, _reactDefault.default).useState(control._getWatch(name, defaultValue));
    (0, _reactDefault.default).useEffect(()=>control._removeUnmounted());
    return value1;
}
/**
 * Custom hook to work with controlled component, this function provide you with both form and field level state. Re-render is isolated at the hook level.
 *
 * @remarks
 * [API](https://react-hook-form.com/docs/usecontroller) • [Demo](https://codesandbox.io/s/usecontroller-0o8px)
 *
 * @param props - the path name to the form field value, and validation rules.
 *
 * @returns field properties, field and form state. {@link UseControllerReturn}
 *
 * @example
 * ```tsx
 * function Input(props) {
 *   const { field, fieldState, formState } = useController(props);
 *   return (
 *     <div>
 *       <input {...field} placeholder={props.name} />
 *       <p>{fieldState.isTouched && "Touched"}</p>
 *       <p>{formState.isSubmitted ? "submitted" : ""}</p>
 *     </div>
 *   );
 * }
 * ```
 */ function useController(props) {
    const methods = useFormContext();
    const { name, disabled, control = methods.control, shouldUnregister } = props;
    const isArrayField = isNameInFieldArray(control._names.array, name);
    const value1 = useWatch({
        control,
        name,
        defaultValue: get(control._formValues, name, get(control._defaultValues, name, props.defaultValue)),
        exact: true
    });
    const formState = useFormState({
        control,
        name,
        exact: true
    });
    const _registerProps = (0, _reactDefault.default).useRef(control.register(name, {
        ...props.rules,
        value: value1,
        ...isBoolean(props.disabled) ? {
            disabled: props.disabled
        } : {}
    }));
    (0, _reactDefault.default).useEffect(()=>{
        const _shouldUnregisterField = control._options.shouldUnregister || shouldUnregister;
        const updateMounted = (name, value1)=>{
            const field = get(control._fields, name);
            if (field && field._f) field._f.mount = value1;
        };
        updateMounted(name, true);
        if (_shouldUnregisterField) {
            const value1 = cloneObject(get(control._options.defaultValues, name));
            set(control._defaultValues, name, value1);
            if (isUndefined(get(control._formValues, name))) set(control._formValues, name, value1);
        }
        return ()=>{
            (isArrayField ? _shouldUnregisterField && !control._state.action : _shouldUnregisterField) ? control.unregister(name) : updateMounted(name, false);
        };
    }, [
        name,
        control,
        isArrayField,
        shouldUnregister
    ]);
    (0, _reactDefault.default).useEffect(()=>{
        if (get(control._fields, name)) control._updateDisabledField({
            disabled,
            fields: control._fields,
            name,
            value: get(control._fields, name)._f.value
        });
    }, [
        disabled,
        name,
        control
    ]);
    return {
        field: {
            name,
            value: value1,
            ...isBoolean(disabled) || formState.disabled ? {
                disabled: formState.disabled || disabled
            } : {},
            onChange: (0, _reactDefault.default).useCallback((event)=>_registerProps.current.onChange({
                    target: {
                        value: getEventValue(event),
                        name: name
                    },
                    type: EVENTS.CHANGE
                }), [
                name
            ]),
            onBlur: (0, _reactDefault.default).useCallback(()=>_registerProps.current.onBlur({
                    target: {
                        value: get(control._formValues, name),
                        name: name
                    },
                    type: EVENTS.BLUR
                }), [
                name,
                control
            ]),
            ref: (0, _reactDefault.default).useCallback((elm)=>{
                const field = get(control._fields, name);
                if (field && elm) field._f.ref = {
                    focus: ()=>elm.focus(),
                    select: ()=>elm.select(),
                    setCustomValidity: (message)=>elm.setCustomValidity(message),
                    reportValidity: ()=>elm.reportValidity()
                };
            }, [
                control._fields,
                name
            ])
        },
        formState,
        fieldState: Object.defineProperties({}, {
            invalid: {
                enumerable: true,
                get: ()=>!!get(formState.errors, name)
            },
            isDirty: {
                enumerable: true,
                get: ()=>!!get(formState.dirtyFields, name)
            },
            isTouched: {
                enumerable: true,
                get: ()=>!!get(formState.touchedFields, name)
            },
            isValidating: {
                enumerable: true,
                get: ()=>!!get(formState.validatingFields, name)
            },
            error: {
                enumerable: true,
                get: ()=>get(formState.errors, name)
            }
        })
    };
}
/**
 * Component based on `useController` hook to work with controlled component.
 *
 * @remarks
 * [API](https://react-hook-form.com/docs/usecontroller/controller) • [Demo](https://codesandbox.io/s/react-hook-form-v6-controller-ts-jwyzw) • [Video](https://www.youtube.com/watch?v=N2UNk_UCVyA)
 *
 * @param props - the path name to the form field value, and validation rules.
 *
 * @returns provide field handler functions, field and form state.
 *
 * @example
 * ```tsx
 * function App() {
 *   const { control } = useForm<FormValues>({
 *     defaultValues: {
 *       test: ""
 *     }
 *   });
 *
 *   return (
 *     <form>
 *       <Controller
 *         control={control}
 *         name="test"
 *         render={({ field: { onChange, onBlur, value, ref }, formState, fieldState }) => (
 *           <>
 *             <input
 *               onChange={onChange} // send value to hook form
 *               onBlur={onBlur} // notify when input is touched
 *               value={value} // return updated value
 *               ref={ref} // set ref for focus management
 *             />
 *             <p>{formState.isSubmitted ? "submitted" : ""}</p>
 *             <p>{fieldState.isTouched ? "touched" : ""}</p>
 *           </>
 *         )}
 *       />
 *     </form>
 *   );
 * }
 * ```
 */ const Controller = (props)=>props.render(useController(props));
const flatten = (obj)=>{
    const output = {};
    for (const key of Object.keys(obj))if (isObjectType(obj[key])) {
        const nested = flatten(obj[key]);
        for (const nestedKey of Object.keys(nested))output[`${key}.${nestedKey}`] = nested[nestedKey];
    } else output[key] = obj[key];
    return output;
};
const POST_REQUEST = "post";
/**
 * Form component to manage submission.
 *
 * @param props - to setup submission detail. {@link FormProps}
 *
 * @returns form component or headless render prop.
 *
 * @example
 * ```tsx
 * function App() {
 *   const { control, formState: { errors } } = useForm();
 *
 *   return (
 *     <Form action="/api" control={control}>
 *       <input {...register("name")} />
 *       <p>{errors?.root?.server && 'Server error'}</p>
 *       <button>Submit</button>
 *     </Form>
 *   );
 * }
 * ```
 */ function Form(props) {
    const methods = useFormContext();
    const [mounted, setMounted] = (0, _reactDefault.default).useState(false);
    const { control = methods.control, onSubmit, children, action, method = POST_REQUEST, headers, encType, onError, render, onSuccess, validateStatus, ...rest } = props;
    const submit = async (event)=>{
        let hasError = false;
        let type = "";
        await control.handleSubmit(async (data)=>{
            const formData = new FormData();
            let formDataJson = "";
            try {
                formDataJson = JSON.stringify(data);
            } catch (_a) {}
            const flattenFormValues = flatten(control._formValues);
            for(const key in flattenFormValues)formData.append(key, flattenFormValues[key]);
            if (onSubmit) await onSubmit({
                data,
                event,
                method,
                formData,
                formDataJson
            });
            if (action) try {
                const shouldStringifySubmissionData = [
                    headers && headers["Content-Type"],
                    encType
                ].some((value1)=>value1 && value1.includes("json"));
                const response = await fetch(action, {
                    method,
                    headers: {
                        ...headers,
                        ...encType ? {
                            "Content-Type": encType
                        } : {}
                    },
                    body: shouldStringifySubmissionData ? formDataJson : formData
                });
                if (response && (validateStatus ? !validateStatus(response.status) : response.status < 200 || response.status >= 300)) {
                    hasError = true;
                    onError && onError({
                        response
                    });
                    type = String(response.status);
                } else onSuccess && onSuccess({
                    response
                });
            } catch (error) {
                hasError = true;
                onError && onError({
                    error
                });
            }
        })(event);
        if (hasError && props.control) {
            props.control._subjects.state.next({
                isSubmitSuccessful: false
            });
            props.control.setError("root.server", {
                type
            });
        }
    };
    (0, _reactDefault.default).useEffect(()=>{
        setMounted(true);
    }, []);
    return render ? (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, render({
        submit
    })) : (0, _reactDefault.default).createElement("form", {
        noValidate: mounted,
        action: action,
        method: method,
        encType: encType,
        onSubmit: submit,
        ...rest
    }, children);
}
var appendErrors = (name, validateAllFieldCriteria, errors, type, message)=>validateAllFieldCriteria ? {
        ...errors[name],
        types: {
            ...errors[name] && errors[name].types ? errors[name].types : {},
            [type]: message || true
        }
    } : {};
var generateId = ()=>{
    const d = typeof performance === "undefined" ? Date.now() : performance.now() * 1000;
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (c)=>{
        const r = (Math.random() * 16 + d) % 16 | 0;
        return (c == "x" ? r : r & 0x3 | 0x8).toString(16);
    });
};
var getFocusFieldName = (name, index, options = {})=>options.shouldFocus || isUndefined(options.shouldFocus) ? options.focusName || `${name}.${isUndefined(options.focusIndex) ? index : options.focusIndex}.` : "";
var getValidationModes = (mode)=>({
        isOnSubmit: !mode || mode === VALIDATION_MODE.onSubmit,
        isOnBlur: mode === VALIDATION_MODE.onBlur,
        isOnChange: mode === VALIDATION_MODE.onChange,
        isOnAll: mode === VALIDATION_MODE.all,
        isOnTouch: mode === VALIDATION_MODE.onTouched
    });
var isWatched = (name, _names, isBlurEvent)=>!isBlurEvent && (_names.watchAll || _names.watch.has(name) || [
        ..._names.watch
    ].some((watchName)=>name.startsWith(watchName) && /^\.\w+/.test(name.slice(watchName.length))));
const iterateFieldsByAction = (fields, action, fieldsNames, abortEarly)=>{
    for (const key of fieldsNames || Object.keys(fields)){
        const field = get(fields, key);
        if (field) {
            const { _f, ...currentField } = field;
            if (_f) {
                if (_f.refs && _f.refs[0] && action(_f.refs[0], key) && !abortEarly) return true;
                else if (_f.ref && action(_f.ref, _f.name) && !abortEarly) return true;
                else {
                    if (iterateFieldsByAction(currentField, action)) break;
                }
            } else if (isObject(currentField)) {
                if (iterateFieldsByAction(currentField, action)) break;
            }
        }
    }
    return;
};
var updateFieldArrayRootError = (errors, error, name)=>{
    const fieldArrayErrors = convertToArrayPayload(get(errors, name));
    set(fieldArrayErrors, "root", error[name]);
    set(errors, name, fieldArrayErrors);
    return errors;
};
var isFileInput = (element)=>element.type === "file";
var isFunction = (value1)=>typeof value1 === "function";
var isHTMLElement = (value1)=>{
    if (!isWeb) return false;
    const owner = value1 ? value1.ownerDocument : 0;
    return value1 instanceof (owner && owner.defaultView ? owner.defaultView.HTMLElement : HTMLElement);
};
var isMessage = (value1)=>isString(value1);
var isRadioInput = (element)=>element.type === "radio";
var isRegex = (value1)=>value1 instanceof RegExp;
const defaultResult = {
    value: false,
    isValid: false
};
const validResult = {
    value: true,
    isValid: true
};
var getCheckboxValue = (options)=>{
    if (Array.isArray(options)) {
        if (options.length > 1) {
            const values = options.filter((option)=>option && option.checked && !option.disabled).map((option)=>option.value);
            return {
                value: values,
                isValid: !!values.length
            };
        }
        return options[0].checked && !options[0].disabled ? options[0].attributes && !isUndefined(options[0].attributes.value) ? isUndefined(options[0].value) || options[0].value === "" ? validResult : {
            value: options[0].value,
            isValid: true
        } : validResult : defaultResult;
    }
    return defaultResult;
};
const defaultReturn = {
    isValid: false,
    value: null
};
var getRadioValue = (options)=>Array.isArray(options) ? options.reduce((previous, option)=>option && option.checked && !option.disabled ? {
            isValid: true,
            value: option.value
        } : previous, defaultReturn) : defaultReturn;
function getValidateError(result, ref, type = "validate") {
    if (isMessage(result) || Array.isArray(result) && result.every(isMessage) || isBoolean(result) && !result) return {
        type,
        message: isMessage(result) ? result : "",
        ref
    };
}
var getValueAndMessage = (validationData)=>isObject(validationData) && !isRegex(validationData) ? validationData : {
        value: validationData,
        message: ""
    };
var validateField = async (field, formValues, validateAllFieldCriteria, shouldUseNativeValidation, isFieldArray)=>{
    const { ref, refs, required, maxLength, minLength, min, max, pattern, validate, name, valueAsNumber, mount, disabled } = field._f;
    const inputValue = get(formValues, name);
    if (!mount || disabled) return {};
    const inputRef = refs ? refs[0] : ref;
    const setCustomValidity = (message)=>{
        if (shouldUseNativeValidation && inputRef.reportValidity) {
            inputRef.setCustomValidity(isBoolean(message) ? "" : message || "");
            inputRef.reportValidity();
        }
    };
    const error = {};
    const isRadio = isRadioInput(ref);
    const isCheckBox = isCheckBoxInput(ref);
    const isRadioOrCheckbox = isRadio || isCheckBox;
    const isEmpty = (valueAsNumber || isFileInput(ref)) && isUndefined(ref.value) && isUndefined(inputValue) || isHTMLElement(ref) && ref.value === "" || inputValue === "" || Array.isArray(inputValue) && !inputValue.length;
    const appendErrorsCurry = appendErrors.bind(null, name, validateAllFieldCriteria, error);
    const getMinMaxMessage = (exceedMax, maxLengthMessage, minLengthMessage, maxType = INPUT_VALIDATION_RULES.maxLength, minType = INPUT_VALIDATION_RULES.minLength)=>{
        const message = exceedMax ? maxLengthMessage : minLengthMessage;
        error[name] = {
            type: exceedMax ? maxType : minType,
            message,
            ref,
            ...appendErrorsCurry(exceedMax ? maxType : minType, message)
        };
    };
    if (isFieldArray ? !Array.isArray(inputValue) || !inputValue.length : required && (!isRadioOrCheckbox && (isEmpty || isNullOrUndefined(inputValue)) || isBoolean(inputValue) && !inputValue || isCheckBox && !getCheckboxValue(refs).isValid || isRadio && !getRadioValue(refs).isValid)) {
        const { value: value1, message } = isMessage(required) ? {
            value: !!required,
            message: required
        } : getValueAndMessage(required);
        if (value1) {
            error[name] = {
                type: INPUT_VALIDATION_RULES.required,
                message,
                ref: inputRef,
                ...appendErrorsCurry(INPUT_VALIDATION_RULES.required, message)
            };
            if (!validateAllFieldCriteria) {
                setCustomValidity(message);
                return error;
            }
        }
    }
    if (!isEmpty && (!isNullOrUndefined(min) || !isNullOrUndefined(max))) {
        let exceedMax;
        let exceedMin;
        const maxOutput = getValueAndMessage(max);
        const minOutput = getValueAndMessage(min);
        if (!isNullOrUndefined(inputValue) && !isNaN(inputValue)) {
            const valueNumber = ref.valueAsNumber || (inputValue ? +inputValue : inputValue);
            if (!isNullOrUndefined(maxOutput.value)) exceedMax = valueNumber > maxOutput.value;
            if (!isNullOrUndefined(minOutput.value)) exceedMin = valueNumber < minOutput.value;
        } else {
            const valueDate = ref.valueAsDate || new Date(inputValue);
            const convertTimeToDate = (time)=>new Date(new Date().toDateString() + " " + time);
            const isTime = ref.type == "time";
            const isWeek = ref.type == "week";
            if (isString(maxOutput.value) && inputValue) exceedMax = isTime ? convertTimeToDate(inputValue) > convertTimeToDate(maxOutput.value) : isWeek ? inputValue > maxOutput.value : valueDate > new Date(maxOutput.value);
            if (isString(minOutput.value) && inputValue) exceedMin = isTime ? convertTimeToDate(inputValue) < convertTimeToDate(minOutput.value) : isWeek ? inputValue < minOutput.value : valueDate < new Date(minOutput.value);
        }
        if (exceedMax || exceedMin) {
            getMinMaxMessage(!!exceedMax, maxOutput.message, minOutput.message, INPUT_VALIDATION_RULES.max, INPUT_VALIDATION_RULES.min);
            if (!validateAllFieldCriteria) {
                setCustomValidity(error[name].message);
                return error;
            }
        }
    }
    if ((maxLength || minLength) && !isEmpty && (isString(inputValue) || isFieldArray && Array.isArray(inputValue))) {
        const maxLengthOutput = getValueAndMessage(maxLength);
        const minLengthOutput = getValueAndMessage(minLength);
        const exceedMax = !isNullOrUndefined(maxLengthOutput.value) && inputValue.length > +maxLengthOutput.value;
        const exceedMin = !isNullOrUndefined(minLengthOutput.value) && inputValue.length < +minLengthOutput.value;
        if (exceedMax || exceedMin) {
            getMinMaxMessage(exceedMax, maxLengthOutput.message, minLengthOutput.message);
            if (!validateAllFieldCriteria) {
                setCustomValidity(error[name].message);
                return error;
            }
        }
    }
    if (pattern && !isEmpty && isString(inputValue)) {
        const { value: patternValue, message } = getValueAndMessage(pattern);
        if (isRegex(patternValue) && !inputValue.match(patternValue)) {
            error[name] = {
                type: INPUT_VALIDATION_RULES.pattern,
                message,
                ref,
                ...appendErrorsCurry(INPUT_VALIDATION_RULES.pattern, message)
            };
            if (!validateAllFieldCriteria) {
                setCustomValidity(message);
                return error;
            }
        }
    }
    if (validate) {
        if (isFunction(validate)) {
            const result = await validate(inputValue, formValues);
            const validateError = getValidateError(result, inputRef);
            if (validateError) {
                error[name] = {
                    ...validateError,
                    ...appendErrorsCurry(INPUT_VALIDATION_RULES.validate, validateError.message)
                };
                if (!validateAllFieldCriteria) {
                    setCustomValidity(validateError.message);
                    return error;
                }
            }
        } else if (isObject(validate)) {
            let validationResult = {};
            for(const key in validate){
                if (!isEmptyObject(validationResult) && !validateAllFieldCriteria) break;
                const validateError = getValidateError(await validate[key](inputValue, formValues), inputRef, key);
                if (validateError) {
                    validationResult = {
                        ...validateError,
                        ...appendErrorsCurry(key, validateError.message)
                    };
                    setCustomValidity(validateError.message);
                    if (validateAllFieldCriteria) error[name] = validationResult;
                }
            }
            if (!isEmptyObject(validationResult)) {
                error[name] = {
                    ref: inputRef,
                    ...validationResult
                };
                if (!validateAllFieldCriteria) return error;
            }
        }
    }
    setCustomValidity(true);
    return error;
};
var appendAt = (data, value1)=>[
        ...data,
        ...convertToArrayPayload(value1)
    ];
var fillEmptyArray = (value1)=>Array.isArray(value1) ? value1.map(()=>undefined) : undefined;
function insert(data, index, value1) {
    return [
        ...data.slice(0, index),
        ...convertToArrayPayload(value1),
        ...data.slice(index)
    ];
}
var moveArrayAt = (data, from, to)=>{
    if (!Array.isArray(data)) return [];
    if (isUndefined(data[to])) data[to] = undefined;
    data.splice(to, 0, data.splice(from, 1)[0]);
    return data;
};
var prependAt = (data, value1)=>[
        ...convertToArrayPayload(value1),
        ...convertToArrayPayload(data)
    ];
function removeAtIndexes(data, indexes) {
    let i = 0;
    const temp = [
        ...data
    ];
    for (const index of indexes){
        temp.splice(index - i, 1);
        i++;
    }
    return compact(temp).length ? temp : [];
}
var removeArrayAt = (data, index)=>isUndefined(index) ? [] : removeAtIndexes(data, convertToArrayPayload(index).sort((a, b)=>a - b));
var swapArrayAt = (data, indexA, indexB)=>{
    [data[indexA], data[indexB]] = [
        data[indexB],
        data[indexA]
    ];
};
function baseGet(object, updatePath) {
    const length = updatePath.slice(0, -1).length;
    let index = 0;
    while(index < length)object = isUndefined(object) ? index++ : object[updatePath[index++]];
    return object;
}
function isEmptyArray(obj) {
    for(const key in obj){
        if (obj.hasOwnProperty(key) && !isUndefined(obj[key])) return false;
    }
    return true;
}
function unset(object, path) {
    const paths = Array.isArray(path) ? path : isKey(path) ? [
        path
    ] : stringToPath(path);
    const childObject = paths.length === 1 ? object : baseGet(object, paths);
    const index = paths.length - 1;
    const key = paths[index];
    if (childObject) delete childObject[key];
    if (index !== 0 && (isObject(childObject) && isEmptyObject(childObject) || Array.isArray(childObject) && isEmptyArray(childObject))) unset(object, paths.slice(0, -1));
    return object;
}
var updateAt = (fieldValues, index, value1)=>{
    fieldValues[index] = value1;
    return fieldValues;
};
/**
 * A custom hook that exposes convenient methods to perform operations with a list of dynamic inputs that need to be appended, updated, removed etc. • [Demo](https://codesandbox.io/s/react-hook-form-usefieldarray-ssugn) • [Video](https://youtu.be/4MrbfGSFY2A)
 *
 * @remarks
 * [API](https://react-hook-form.com/docs/usefieldarray) • [Demo](https://codesandbox.io/s/react-hook-form-usefieldarray-ssugn)
 *
 * @param props - useFieldArray props
 *
 * @returns methods - functions to manipulate with the Field Arrays (dynamic inputs) {@link UseFieldArrayReturn}
 *
 * @example
 * ```tsx
 * function App() {
 *   const { register, control, handleSubmit, reset, trigger, setError } = useForm({
 *     defaultValues: {
 *       test: []
 *     }
 *   });
 *   const { fields, append } = useFieldArray({
 *     control,
 *     name: "test"
 *   });
 *
 *   return (
 *     <form onSubmit={handleSubmit(data => console.log(data))}>
 *       {fields.map((item, index) => (
 *          <input key={item.id} {...register(`test.${index}.firstName`)}  />
 *       ))}
 *       <button type="button" onClick={() => append({ firstName: "bill" })}>
 *         append
 *       </button>
 *       <input type="submit" />
 *     </form>
 *   );
 * }
 * ```
 */ function useFieldArray(props) {
    const methods = useFormContext();
    const { control = methods.control, name, keyName = "id", shouldUnregister } = props;
    const [fields, setFields] = (0, _reactDefault.default).useState(control._getFieldArray(name));
    const ids = (0, _reactDefault.default).useRef(control._getFieldArray(name).map(generateId));
    const _fieldIds = (0, _reactDefault.default).useRef(fields);
    const _name = (0, _reactDefault.default).useRef(name);
    const _actioned = (0, _reactDefault.default).useRef(false);
    _name.current = name;
    _fieldIds.current = fields;
    control._names.array.add(name);
    props.rules && control.register(name, props.rules);
    useSubscribe({
        next: ({ values, name: fieldArrayName })=>{
            if (fieldArrayName === _name.current || !fieldArrayName) {
                const fieldValues = get(values, _name.current);
                if (Array.isArray(fieldValues)) {
                    setFields(fieldValues);
                    ids.current = fieldValues.map(generateId);
                }
            }
        },
        subject: control._subjects.array
    });
    const updateValues = (0, _reactDefault.default).useCallback((updatedFieldArrayValues)=>{
        _actioned.current = true;
        control._updateFieldArray(name, updatedFieldArrayValues);
    }, [
        control,
        name
    ]);
    const append = (value1, options)=>{
        const appendValue = convertToArrayPayload(cloneObject(value1));
        const updatedFieldArrayValues = appendAt(control._getFieldArray(name), appendValue);
        control._names.focus = getFocusFieldName(name, updatedFieldArrayValues.length - 1, options);
        ids.current = appendAt(ids.current, appendValue.map(generateId));
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        control._updateFieldArray(name, updatedFieldArrayValues, appendAt, {
            argA: fillEmptyArray(value1)
        });
    };
    const prepend = (value1, options)=>{
        const prependValue = convertToArrayPayload(cloneObject(value1));
        const updatedFieldArrayValues = prependAt(control._getFieldArray(name), prependValue);
        control._names.focus = getFocusFieldName(name, 0, options);
        ids.current = prependAt(ids.current, prependValue.map(generateId));
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        control._updateFieldArray(name, updatedFieldArrayValues, prependAt, {
            argA: fillEmptyArray(value1)
        });
    };
    const remove = (index)=>{
        const updatedFieldArrayValues = removeArrayAt(control._getFieldArray(name), index);
        ids.current = removeArrayAt(ids.current, index);
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        control._updateFieldArray(name, updatedFieldArrayValues, removeArrayAt, {
            argA: index
        });
    };
    const insert$1 = (index, value1, options)=>{
        const insertValue = convertToArrayPayload(cloneObject(value1));
        const updatedFieldArrayValues = insert(control._getFieldArray(name), index, insertValue);
        control._names.focus = getFocusFieldName(name, index, options);
        ids.current = insert(ids.current, index, insertValue.map(generateId));
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        control._updateFieldArray(name, updatedFieldArrayValues, insert, {
            argA: index,
            argB: fillEmptyArray(value1)
        });
    };
    const swap = (indexA, indexB)=>{
        const updatedFieldArrayValues = control._getFieldArray(name);
        swapArrayAt(updatedFieldArrayValues, indexA, indexB);
        swapArrayAt(ids.current, indexA, indexB);
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        control._updateFieldArray(name, updatedFieldArrayValues, swapArrayAt, {
            argA: indexA,
            argB: indexB
        }, false);
    };
    const move = (from, to)=>{
        const updatedFieldArrayValues = control._getFieldArray(name);
        moveArrayAt(updatedFieldArrayValues, from, to);
        moveArrayAt(ids.current, from, to);
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        control._updateFieldArray(name, updatedFieldArrayValues, moveArrayAt, {
            argA: from,
            argB: to
        }, false);
    };
    const update = (index, value1)=>{
        const updateValue = cloneObject(value1);
        const updatedFieldArrayValues = updateAt(control._getFieldArray(name), index, updateValue);
        ids.current = [
            ...updatedFieldArrayValues
        ].map((item, i)=>!item || i === index ? generateId() : ids.current[i]);
        updateValues(updatedFieldArrayValues);
        setFields([
            ...updatedFieldArrayValues
        ]);
        control._updateFieldArray(name, updatedFieldArrayValues, updateAt, {
            argA: index,
            argB: updateValue
        }, true, false);
    };
    const replace = (value1)=>{
        const updatedFieldArrayValues = convertToArrayPayload(cloneObject(value1));
        ids.current = updatedFieldArrayValues.map(generateId);
        updateValues([
            ...updatedFieldArrayValues
        ]);
        setFields([
            ...updatedFieldArrayValues
        ]);
        control._updateFieldArray(name, [
            ...updatedFieldArrayValues
        ], (data)=>data, {}, true, false);
    };
    (0, _reactDefault.default).useEffect(()=>{
        control._state.action = false;
        isWatched(name, control._names) && control._subjects.state.next({
            ...control._formState
        });
        if (_actioned.current && (!getValidationModes(control._options.mode).isOnSubmit || control._formState.isSubmitted)) {
            if (control._options.resolver) control._executeSchema([
                name
            ]).then((result)=>{
                const error = get(result.errors, name);
                const existingError = get(control._formState.errors, name);
                if (existingError ? !error && existingError.type || error && (existingError.type !== error.type || existingError.message !== error.message) : error && error.type) {
                    error ? set(control._formState.errors, name, error) : unset(control._formState.errors, name);
                    control._subjects.state.next({
                        errors: control._formState.errors
                    });
                }
            });
            else {
                const field = get(control._fields, name);
                if (field && field._f && !(getValidationModes(control._options.reValidateMode).isOnSubmit && getValidationModes(control._options.mode).isOnSubmit)) validateField(field, control._formValues, control._options.criteriaMode === VALIDATION_MODE.all, control._options.shouldUseNativeValidation, true).then((error)=>!isEmptyObject(error) && control._subjects.state.next({
                        errors: updateFieldArrayRootError(control._formState.errors, error, name)
                    }));
            }
        }
        control._subjects.values.next({
            name,
            values: {
                ...control._formValues
            }
        });
        control._names.focus && iterateFieldsByAction(control._fields, (ref, key)=>{
            if (control._names.focus && key.startsWith(control._names.focus) && ref.focus) {
                ref.focus();
                return 1;
            }
            return;
        });
        control._names.focus = "";
        control._updateValid();
        _actioned.current = false;
    }, [
        fields,
        name,
        control
    ]);
    (0, _reactDefault.default).useEffect(()=>{
        !get(control._formValues, name) && control._updateFieldArray(name);
        return ()=>{
            (control._options.shouldUnregister || shouldUnregister) && control.unregister(name);
        };
    }, [
        name,
        control,
        keyName,
        shouldUnregister
    ]);
    return {
        swap: (0, _reactDefault.default).useCallback(swap, [
            updateValues,
            name,
            control
        ]),
        move: (0, _reactDefault.default).useCallback(move, [
            updateValues,
            name,
            control
        ]),
        prepend: (0, _reactDefault.default).useCallback(prepend, [
            updateValues,
            name,
            control
        ]),
        append: (0, _reactDefault.default).useCallback(append, [
            updateValues,
            name,
            control
        ]),
        remove: (0, _reactDefault.default).useCallback(remove, [
            updateValues,
            name,
            control
        ]),
        insert: (0, _reactDefault.default).useCallback(insert$1, [
            updateValues,
            name,
            control
        ]),
        update: (0, _reactDefault.default).useCallback(update, [
            updateValues,
            name,
            control
        ]),
        replace: (0, _reactDefault.default).useCallback(replace, [
            updateValues,
            name,
            control
        ]),
        fields: (0, _reactDefault.default).useMemo(()=>fields.map((field, index)=>({
                    ...field,
                    [keyName]: ids.current[index] || generateId()
                })), [
            fields,
            keyName
        ])
    };
}
var createSubject = ()=>{
    let _observers = [];
    const next = (value1)=>{
        for (const observer of _observers)observer.next && observer.next(value1);
    };
    const subscribe = (observer)=>{
        _observers.push(observer);
        return {
            unsubscribe: ()=>{
                _observers = _observers.filter((o)=>o !== observer);
            }
        };
    };
    const unsubscribe = ()=>{
        _observers = [];
    };
    return {
        get observers () {
            return _observers;
        },
        next,
        subscribe,
        unsubscribe
    };
};
var isPrimitive = (value1)=>isNullOrUndefined(value1) || !isObjectType(value1);
function deepEqual(object1, object2) {
    if (isPrimitive(object1) || isPrimitive(object2)) return object1 === object2;
    if (isDateObject(object1) && isDateObject(object2)) return object1.getTime() === object2.getTime();
    const keys1 = Object.keys(object1);
    const keys2 = Object.keys(object2);
    if (keys1.length !== keys2.length) return false;
    for (const key of keys1){
        const val1 = object1[key];
        if (!keys2.includes(key)) return false;
        if (key !== "ref") {
            const val2 = object2[key];
            if (isDateObject(val1) && isDateObject(val2) || isObject(val1) && isObject(val2) || Array.isArray(val1) && Array.isArray(val2) ? !deepEqual(val1, val2) : val1 !== val2) return false;
        }
    }
    return true;
}
var isMultipleSelect = (element)=>element.type === `select-multiple`;
var isRadioOrCheckbox = (ref)=>isRadioInput(ref) || isCheckBoxInput(ref);
var live = (ref)=>isHTMLElement(ref) && ref.isConnected;
var objectHasFunction = (data)=>{
    for(const key in data){
        if (isFunction(data[key])) return true;
    }
    return false;
};
function markFieldsDirty(data, fields = {}) {
    const isParentNodeArray = Array.isArray(data);
    if (isObject(data) || isParentNodeArray) for(const key in data){
        if (Array.isArray(data[key]) || isObject(data[key]) && !objectHasFunction(data[key])) {
            fields[key] = Array.isArray(data[key]) ? [] : {};
            markFieldsDirty(data[key], fields[key]);
        } else if (!isNullOrUndefined(data[key])) fields[key] = true;
    }
    return fields;
}
function getDirtyFieldsFromDefaultValues(data, formValues, dirtyFieldsFromValues) {
    const isParentNodeArray = Array.isArray(data);
    if (isObject(data) || isParentNodeArray) {
        for(const key in data)if (Array.isArray(data[key]) || isObject(data[key]) && !objectHasFunction(data[key])) {
            if (isUndefined(formValues) || isPrimitive(dirtyFieldsFromValues[key])) dirtyFieldsFromValues[key] = Array.isArray(data[key]) ? markFieldsDirty(data[key], []) : {
                ...markFieldsDirty(data[key])
            };
            else getDirtyFieldsFromDefaultValues(data[key], isNullOrUndefined(formValues) ? {} : formValues[key], dirtyFieldsFromValues[key]);
        } else dirtyFieldsFromValues[key] = !deepEqual(data[key], formValues[key]);
    }
    return dirtyFieldsFromValues;
}
var getDirtyFields = (defaultValues, formValues)=>getDirtyFieldsFromDefaultValues(defaultValues, formValues, markFieldsDirty(formValues));
var getFieldValueAs = (value1, { valueAsNumber, valueAsDate, setValueAs })=>isUndefined(value1) ? value1 : valueAsNumber ? value1 === "" ? NaN : value1 ? +value1 : value1 : valueAsDate && isString(value1) ? new Date(value1) : setValueAs ? setValueAs(value1) : value1;
function getFieldValue(_f) {
    const ref = _f.ref;
    if (_f.refs ? _f.refs.every((ref)=>ref.disabled) : ref.disabled) return;
    if (isFileInput(ref)) return ref.files;
    if (isRadioInput(ref)) return getRadioValue(_f.refs).value;
    if (isMultipleSelect(ref)) return [
        ...ref.selectedOptions
    ].map(({ value: value1 })=>value1);
    if (isCheckBoxInput(ref)) return getCheckboxValue(_f.refs).value;
    return getFieldValueAs(isUndefined(ref.value) ? _f.ref.value : ref.value, _f);
}
var getResolverOptions = (fieldsNames, _fields, criteriaMode, shouldUseNativeValidation)=>{
    const fields = {};
    for (const name of fieldsNames){
        const field = get(_fields, name);
        field && set(fields, name, field._f);
    }
    return {
        criteriaMode,
        names: [
            ...fieldsNames
        ],
        fields,
        shouldUseNativeValidation
    };
};
var getRuleValue = (rule)=>isUndefined(rule) ? rule : isRegex(rule) ? rule.source : isObject(rule) ? isRegex(rule.value) ? rule.value.source : rule.value : rule;
const ASYNC_FUNCTION = "AsyncFunction";
var hasPromiseValidation = (fieldReference)=>(!fieldReference || !fieldReference.validate) && !!(isFunction(fieldReference.validate) && fieldReference.validate.constructor.name === ASYNC_FUNCTION || isObject(fieldReference.validate) && Object.values(fieldReference.validate).find((validateFunction)=>validateFunction.constructor.name === ASYNC_FUNCTION));
var hasValidation = (options)=>options.mount && (options.required || options.min || options.max || options.maxLength || options.minLength || options.pattern || options.validate);
function schemaErrorLookup(errors, _fields, name) {
    const error = get(errors, name);
    if (error || isKey(name)) return {
        error,
        name
    };
    const names = name.split(".");
    while(names.length){
        const fieldName = names.join(".");
        const field = get(_fields, fieldName);
        const foundError = get(errors, fieldName);
        if (field && !Array.isArray(field) && name !== fieldName) return {
            name
        };
        if (foundError && foundError.type) return {
            name: fieldName,
            error: foundError
        };
        names.pop();
    }
    return {
        name
    };
}
var skipValidation = (isBlurEvent, isTouched, isSubmitted, reValidateMode, mode)=>{
    if (mode.isOnAll) return false;
    else if (!isSubmitted && mode.isOnTouch) return !(isTouched || isBlurEvent);
    else if (isSubmitted ? reValidateMode.isOnBlur : mode.isOnBlur) return !isBlurEvent;
    else if (isSubmitted ? reValidateMode.isOnChange : mode.isOnChange) return isBlurEvent;
    return true;
};
var unsetEmptyArray = (ref, name)=>!compact(get(ref, name)).length && unset(ref, name);
const defaultOptions = {
    mode: VALIDATION_MODE.onSubmit,
    reValidateMode: VALIDATION_MODE.onChange,
    shouldFocusError: true
};
function createFormControl(props = {}) {
    let _options = {
        ...defaultOptions,
        ...props
    };
    let _formState = {
        submitCount: 0,
        isDirty: false,
        isLoading: isFunction(_options.defaultValues),
        isValidating: false,
        isSubmitted: false,
        isSubmitting: false,
        isSubmitSuccessful: false,
        isValid: false,
        touchedFields: {},
        dirtyFields: {},
        validatingFields: {},
        errors: _options.errors || {},
        disabled: _options.disabled || false
    };
    let _fields = {};
    let _defaultValues = isObject(_options.defaultValues) || isObject(_options.values) ? cloneObject(_options.defaultValues || _options.values) || {} : {};
    let _formValues = _options.shouldUnregister ? {} : cloneObject(_defaultValues);
    let _state = {
        action: false,
        mount: false,
        watch: false
    };
    let _names = {
        mount: new Set(),
        unMount: new Set(),
        array: new Set(),
        watch: new Set()
    };
    let delayErrorCallback;
    let timer = 0;
    const _proxyFormState = {
        isDirty: false,
        dirtyFields: false,
        validatingFields: false,
        touchedFields: false,
        isValidating: false,
        isValid: false,
        errors: false
    };
    const _subjects = {
        values: createSubject(),
        array: createSubject(),
        state: createSubject()
    };
    const validationModeBeforeSubmit = getValidationModes(_options.mode);
    const validationModeAfterSubmit = getValidationModes(_options.reValidateMode);
    const shouldDisplayAllAssociatedErrors = _options.criteriaMode === VALIDATION_MODE.all;
    const debounce = (callback)=>(wait)=>{
            clearTimeout(timer);
            timer = setTimeout(callback, wait);
        };
    const _updateValid = async (shouldUpdateValid)=>{
        if (!_options.disabled && (_proxyFormState.isValid || shouldUpdateValid)) {
            const isValid = _options.resolver ? isEmptyObject((await _executeSchema()).errors) : await executeBuiltInValidation(_fields, true);
            if (isValid !== _formState.isValid) _subjects.state.next({
                isValid
            });
        }
    };
    const _updateIsValidating = (names, isValidating)=>{
        if (!_options.disabled && (_proxyFormState.isValidating || _proxyFormState.validatingFields)) {
            (names || Array.from(_names.mount)).forEach((name)=>{
                if (name) isValidating ? set(_formState.validatingFields, name, isValidating) : unset(_formState.validatingFields, name);
            });
            _subjects.state.next({
                validatingFields: _formState.validatingFields,
                isValidating: !isEmptyObject(_formState.validatingFields)
            });
        }
    };
    const _updateFieldArray = (name, values = [], method, args, shouldSetValues = true, shouldUpdateFieldsAndState = true)=>{
        if (args && method && !_options.disabled) {
            _state.action = true;
            if (shouldUpdateFieldsAndState && Array.isArray(get(_fields, name))) {
                const fieldValues = method(get(_fields, name), args.argA, args.argB);
                shouldSetValues && set(_fields, name, fieldValues);
            }
            if (shouldUpdateFieldsAndState && Array.isArray(get(_formState.errors, name))) {
                const errors = method(get(_formState.errors, name), args.argA, args.argB);
                shouldSetValues && set(_formState.errors, name, errors);
                unsetEmptyArray(_formState.errors, name);
            }
            if (_proxyFormState.touchedFields && shouldUpdateFieldsAndState && Array.isArray(get(_formState.touchedFields, name))) {
                const touchedFields = method(get(_formState.touchedFields, name), args.argA, args.argB);
                shouldSetValues && set(_formState.touchedFields, name, touchedFields);
            }
            if (_proxyFormState.dirtyFields) _formState.dirtyFields = getDirtyFields(_defaultValues, _formValues);
            _subjects.state.next({
                name,
                isDirty: _getDirty(name, values),
                dirtyFields: _formState.dirtyFields,
                errors: _formState.errors,
                isValid: _formState.isValid
            });
        } else set(_formValues, name, values);
    };
    const updateErrors = (name, error)=>{
        set(_formState.errors, name, error);
        _subjects.state.next({
            errors: _formState.errors
        });
    };
    const _setErrors = (errors)=>{
        _formState.errors = errors;
        _subjects.state.next({
            errors: _formState.errors,
            isValid: false
        });
    };
    const updateValidAndValue = (name, shouldSkipSetValueAs, value1, ref)=>{
        const field = get(_fields, name);
        if (field) {
            const defaultValue = get(_formValues, name, isUndefined(value1) ? get(_defaultValues, name) : value1);
            isUndefined(defaultValue) || ref && ref.defaultChecked || shouldSkipSetValueAs ? set(_formValues, name, shouldSkipSetValueAs ? defaultValue : getFieldValue(field._f)) : setFieldValue(name, defaultValue);
            _state.mount && _updateValid();
        }
    };
    const updateTouchAndDirty = (name, fieldValue, isBlurEvent, shouldDirty, shouldRender)=>{
        let shouldUpdateField = false;
        let isPreviousDirty = false;
        const output = {
            name
        };
        if (!_options.disabled) {
            const disabledField = !!(get(_fields, name) && get(_fields, name)._f && get(_fields, name)._f.disabled);
            if (!isBlurEvent || shouldDirty) {
                if (_proxyFormState.isDirty) {
                    isPreviousDirty = _formState.isDirty;
                    _formState.isDirty = output.isDirty = _getDirty();
                    shouldUpdateField = isPreviousDirty !== output.isDirty;
                }
                const isCurrentFieldPristine = disabledField || deepEqual(get(_defaultValues, name), fieldValue);
                isPreviousDirty = !!(!disabledField && get(_formState.dirtyFields, name));
                isCurrentFieldPristine || disabledField ? unset(_formState.dirtyFields, name) : set(_formState.dirtyFields, name, true);
                output.dirtyFields = _formState.dirtyFields;
                shouldUpdateField = shouldUpdateField || _proxyFormState.dirtyFields && isPreviousDirty !== !isCurrentFieldPristine;
            }
            if (isBlurEvent) {
                const isPreviousFieldTouched = get(_formState.touchedFields, name);
                if (!isPreviousFieldTouched) {
                    set(_formState.touchedFields, name, isBlurEvent);
                    output.touchedFields = _formState.touchedFields;
                    shouldUpdateField = shouldUpdateField || _proxyFormState.touchedFields && isPreviousFieldTouched !== isBlurEvent;
                }
            }
            shouldUpdateField && shouldRender && _subjects.state.next(output);
        }
        return shouldUpdateField ? output : {};
    };
    const shouldRenderByError = (name, isValid, error, fieldState)=>{
        const previousFieldError = get(_formState.errors, name);
        const shouldUpdateValid = _proxyFormState.isValid && isBoolean(isValid) && _formState.isValid !== isValid;
        if (props.delayError && error) {
            delayErrorCallback = debounce(()=>updateErrors(name, error));
            delayErrorCallback(props.delayError);
        } else {
            clearTimeout(timer);
            delayErrorCallback = null;
            error ? set(_formState.errors, name, error) : unset(_formState.errors, name);
        }
        if ((error ? !deepEqual(previousFieldError, error) : previousFieldError) || !isEmptyObject(fieldState) || shouldUpdateValid) {
            const updatedFormState = {
                ...fieldState,
                ...shouldUpdateValid && isBoolean(isValid) ? {
                    isValid
                } : {},
                errors: _formState.errors,
                name
            };
            _formState = {
                ..._formState,
                ...updatedFormState
            };
            _subjects.state.next(updatedFormState);
        }
    };
    const _executeSchema = async (name)=>{
        _updateIsValidating(name, true);
        const result = await _options.resolver(_formValues, _options.context, getResolverOptions(name || _names.mount, _fields, _options.criteriaMode, _options.shouldUseNativeValidation));
        _updateIsValidating(name);
        return result;
    };
    const executeSchemaAndUpdateState = async (names)=>{
        const { errors } = await _executeSchema(names);
        if (names) for (const name of names){
            const error = get(errors, name);
            error ? set(_formState.errors, name, error) : unset(_formState.errors, name);
        }
        else _formState.errors = errors;
        return errors;
    };
    const executeBuiltInValidation = async (fields, shouldOnlyCheckValid, context = {
        valid: true
    })=>{
        for(const name in fields){
            const field = fields[name];
            if (field) {
                const { _f, ...fieldValue } = field;
                if (_f) {
                    const isFieldArrayRoot = _names.array.has(_f.name);
                    const isPromiseFunction = field._f && hasPromiseValidation(field._f);
                    if (isPromiseFunction && _proxyFormState.validatingFields) _updateIsValidating([
                        name
                    ], true);
                    const fieldError = await validateField(field, _formValues, shouldDisplayAllAssociatedErrors, _options.shouldUseNativeValidation && !shouldOnlyCheckValid, isFieldArrayRoot);
                    if (isPromiseFunction && _proxyFormState.validatingFields) _updateIsValidating([
                        name
                    ]);
                    if (fieldError[_f.name]) {
                        context.valid = false;
                        if (shouldOnlyCheckValid) break;
                    }
                    !shouldOnlyCheckValid && (get(fieldError, _f.name) ? isFieldArrayRoot ? updateFieldArrayRootError(_formState.errors, fieldError, _f.name) : set(_formState.errors, _f.name, fieldError[_f.name]) : unset(_formState.errors, _f.name));
                }
                !isEmptyObject(fieldValue) && await executeBuiltInValidation(fieldValue, shouldOnlyCheckValid, context);
            }
        }
        return context.valid;
    };
    const _removeUnmounted = ()=>{
        for (const name of _names.unMount){
            const field = get(_fields, name);
            field && (field._f.refs ? field._f.refs.every((ref)=>!live(ref)) : !live(field._f.ref)) && unregister(name);
        }
        _names.unMount = new Set();
    };
    const _getDirty = (name, data)=>!_options.disabled && (name && data && set(_formValues, name, data), !deepEqual(getValues(), _defaultValues));
    const _getWatch = (names, defaultValue, isGlobal)=>generateWatchOutput(names, _names, {
            ..._state.mount ? _formValues : isUndefined(defaultValue) ? _defaultValues : isString(names) ? {
                [names]: defaultValue
            } : defaultValue
        }, isGlobal, defaultValue);
    const _getFieldArray = (name)=>compact(get(_state.mount ? _formValues : _defaultValues, name, props.shouldUnregister ? get(_defaultValues, name, []) : []));
    const setFieldValue = (name, value1, options = {})=>{
        const field = get(_fields, name);
        let fieldValue = value1;
        if (field) {
            const fieldReference = field._f;
            if (fieldReference) {
                !fieldReference.disabled && set(_formValues, name, getFieldValueAs(value1, fieldReference));
                fieldValue = isHTMLElement(fieldReference.ref) && isNullOrUndefined(value1) ? "" : value1;
                if (isMultipleSelect(fieldReference.ref)) [
                    ...fieldReference.ref.options
                ].forEach((optionRef)=>optionRef.selected = fieldValue.includes(optionRef.value));
                else if (fieldReference.refs) {
                    if (isCheckBoxInput(fieldReference.ref)) fieldReference.refs.length > 1 ? fieldReference.refs.forEach((checkboxRef)=>(!checkboxRef.defaultChecked || !checkboxRef.disabled) && (checkboxRef.checked = Array.isArray(fieldValue) ? !!fieldValue.find((data)=>data === checkboxRef.value) : fieldValue === checkboxRef.value)) : fieldReference.refs[0] && (fieldReference.refs[0].checked = !!fieldValue);
                    else fieldReference.refs.forEach((radioRef)=>radioRef.checked = radioRef.value === fieldValue);
                } else if (isFileInput(fieldReference.ref)) fieldReference.ref.value = "";
                else {
                    fieldReference.ref.value = fieldValue;
                    if (!fieldReference.ref.type) _subjects.values.next({
                        name,
                        values: {
                            ..._formValues
                        }
                    });
                }
            }
        }
        (options.shouldDirty || options.shouldTouch) && updateTouchAndDirty(name, fieldValue, options.shouldTouch, options.shouldDirty, true);
        options.shouldValidate && trigger(name);
    };
    const setValues = (name, value1, options)=>{
        for(const fieldKey in value1){
            const fieldValue = value1[fieldKey];
            const fieldName = `${name}.${fieldKey}`;
            const field = get(_fields, fieldName);
            (_names.array.has(name) || isObject(fieldValue) || field && !field._f) && !isDateObject(fieldValue) ? setValues(fieldName, fieldValue, options) : setFieldValue(fieldName, fieldValue, options);
        }
    };
    const setValue = (name, value1, options = {})=>{
        const field = get(_fields, name);
        const isFieldArray = _names.array.has(name);
        const cloneValue = cloneObject(value1);
        set(_formValues, name, cloneValue);
        if (isFieldArray) {
            _subjects.array.next({
                name,
                values: {
                    ..._formValues
                }
            });
            if ((_proxyFormState.isDirty || _proxyFormState.dirtyFields) && options.shouldDirty) _subjects.state.next({
                name,
                dirtyFields: getDirtyFields(_defaultValues, _formValues),
                isDirty: _getDirty(name, cloneValue)
            });
        } else field && !field._f && !isNullOrUndefined(cloneValue) ? setValues(name, cloneValue, options) : setFieldValue(name, cloneValue, options);
        isWatched(name, _names) && _subjects.state.next({
            ..._formState
        });
        _subjects.values.next({
            name: _state.mount ? name : undefined,
            values: {
                ..._formValues
            }
        });
    };
    const onChange = async (event)=>{
        _state.mount = true;
        const target = event.target;
        let name = target.name;
        let isFieldValueUpdated = true;
        const field = get(_fields, name);
        const getCurrentFieldValue = ()=>target.type ? getFieldValue(field._f) : getEventValue(event);
        const _updateIsFieldValueUpdated = (fieldValue)=>{
            isFieldValueUpdated = Number.isNaN(fieldValue) || isDateObject(fieldValue) && isNaN(fieldValue.getTime()) || deepEqual(fieldValue, get(_formValues, name, fieldValue));
        };
        if (field) {
            let error;
            let isValid;
            const fieldValue = getCurrentFieldValue();
            const isBlurEvent = event.type === EVENTS.BLUR || event.type === EVENTS.FOCUS_OUT;
            const shouldSkipValidation = !hasValidation(field._f) && !_options.resolver && !get(_formState.errors, name) && !field._f.deps || skipValidation(isBlurEvent, get(_formState.touchedFields, name), _formState.isSubmitted, validationModeAfterSubmit, validationModeBeforeSubmit);
            const watched = isWatched(name, _names, isBlurEvent);
            set(_formValues, name, fieldValue);
            if (isBlurEvent) {
                field._f.onBlur && field._f.onBlur(event);
                delayErrorCallback && delayErrorCallback(0);
            } else if (field._f.onChange) field._f.onChange(event);
            const fieldState = updateTouchAndDirty(name, fieldValue, isBlurEvent, false);
            const shouldRender = !isEmptyObject(fieldState) || watched;
            !isBlurEvent && _subjects.values.next({
                name,
                type: event.type,
                values: {
                    ..._formValues
                }
            });
            if (shouldSkipValidation) {
                if (_proxyFormState.isValid) {
                    if (props.mode === "onBlur") {
                        if (isBlurEvent) _updateValid();
                    } else _updateValid();
                }
                return shouldRender && _subjects.state.next({
                    name,
                    ...watched ? {} : fieldState
                });
            }
            !isBlurEvent && watched && _subjects.state.next({
                ..._formState
            });
            if (_options.resolver) {
                const { errors } = await _executeSchema([
                    name
                ]);
                _updateIsFieldValueUpdated(fieldValue);
                if (isFieldValueUpdated) {
                    const previousErrorLookupResult = schemaErrorLookup(_formState.errors, _fields, name);
                    const errorLookupResult = schemaErrorLookup(errors, _fields, previousErrorLookupResult.name || name);
                    error = errorLookupResult.error;
                    name = errorLookupResult.name;
                    isValid = isEmptyObject(errors);
                }
            } else {
                _updateIsValidating([
                    name
                ], true);
                error = (await validateField(field, _formValues, shouldDisplayAllAssociatedErrors, _options.shouldUseNativeValidation))[name];
                _updateIsValidating([
                    name
                ]);
                _updateIsFieldValueUpdated(fieldValue);
                if (isFieldValueUpdated) {
                    if (error) isValid = false;
                    else if (_proxyFormState.isValid) isValid = await executeBuiltInValidation(_fields, true);
                }
            }
            if (isFieldValueUpdated) {
                field._f.deps && trigger(field._f.deps);
                shouldRenderByError(name, isValid, error, fieldState);
            }
        }
    };
    const _focusInput = (ref, key)=>{
        if (get(_formState.errors, key) && ref.focus) {
            ref.focus();
            return 1;
        }
        return;
    };
    const trigger = async (name, options = {})=>{
        let isValid;
        let validationResult;
        const fieldNames = convertToArrayPayload(name);
        if (_options.resolver) {
            const errors = await executeSchemaAndUpdateState(isUndefined(name) ? name : fieldNames);
            isValid = isEmptyObject(errors);
            validationResult = name ? !fieldNames.some((name)=>get(errors, name)) : isValid;
        } else if (name) {
            validationResult = (await Promise.all(fieldNames.map(async (fieldName)=>{
                const field = get(_fields, fieldName);
                return await executeBuiltInValidation(field && field._f ? {
                    [fieldName]: field
                } : field);
            }))).every(Boolean);
            !(!validationResult && !_formState.isValid) && _updateValid();
        } else validationResult = isValid = await executeBuiltInValidation(_fields);
        _subjects.state.next({
            ...!isString(name) || _proxyFormState.isValid && isValid !== _formState.isValid ? {} : {
                name
            },
            ..._options.resolver || !name ? {
                isValid
            } : {},
            errors: _formState.errors
        });
        options.shouldFocus && !validationResult && iterateFieldsByAction(_fields, _focusInput, name ? fieldNames : _names.mount);
        return validationResult;
    };
    const getValues = (fieldNames)=>{
        const values = {
            ..._state.mount ? _formValues : _defaultValues
        };
        return isUndefined(fieldNames) ? values : isString(fieldNames) ? get(values, fieldNames) : fieldNames.map((name)=>get(values, name));
    };
    const getFieldState = (name, formState)=>({
            invalid: !!get((formState || _formState).errors, name),
            isDirty: !!get((formState || _formState).dirtyFields, name),
            error: get((formState || _formState).errors, name),
            isValidating: !!get(_formState.validatingFields, name),
            isTouched: !!get((formState || _formState).touchedFields, name)
        });
    const clearErrors = (name)=>{
        name && convertToArrayPayload(name).forEach((inputName)=>unset(_formState.errors, inputName));
        _subjects.state.next({
            errors: name ? _formState.errors : {}
        });
    };
    const setError = (name, error, options)=>{
        const ref = (get(_fields, name, {
            _f: {}
        })._f || {}).ref;
        const currentError = get(_formState.errors, name) || {};
        // Don't override existing error messages elsewhere in the object tree.
        const { ref: currentRef, message, type, ...restOfErrorTree } = currentError;
        set(_formState.errors, name, {
            ...restOfErrorTree,
            ...error,
            ref
        });
        _subjects.state.next({
            name,
            errors: _formState.errors,
            isValid: false
        });
        options && options.shouldFocus && ref && ref.focus && ref.focus();
    };
    const watch = (name, defaultValue)=>isFunction(name) ? _subjects.values.subscribe({
            next: (payload)=>name(_getWatch(undefined, defaultValue), payload)
        }) : _getWatch(name, defaultValue, true);
    const unregister = (name, options = {})=>{
        for (const fieldName of name ? convertToArrayPayload(name) : _names.mount){
            _names.mount.delete(fieldName);
            _names.array.delete(fieldName);
            if (!options.keepValue) {
                unset(_fields, fieldName);
                unset(_formValues, fieldName);
            }
            !options.keepError && unset(_formState.errors, fieldName);
            !options.keepDirty && unset(_formState.dirtyFields, fieldName);
            !options.keepTouched && unset(_formState.touchedFields, fieldName);
            !options.keepIsValidating && unset(_formState.validatingFields, fieldName);
            !_options.shouldUnregister && !options.keepDefaultValue && unset(_defaultValues, fieldName);
        }
        _subjects.values.next({
            values: {
                ..._formValues
            }
        });
        _subjects.state.next({
            ..._formState,
            ...!options.keepDirty ? {} : {
                isDirty: _getDirty()
            }
        });
        !options.keepIsValid && _updateValid();
    };
    const _updateDisabledField = ({ disabled, name, field, fields, value: value1 })=>{
        if (isBoolean(disabled) && _state.mount || !!disabled) {
            const inputValue = disabled ? undefined : isUndefined(value1) ? getFieldValue(field ? field._f : get(fields, name)._f) : value1;
            set(_formValues, name, inputValue);
            updateTouchAndDirty(name, inputValue, false, false, true);
        }
    };
    const register = (name, options = {})=>{
        let field = get(_fields, name);
        const disabledIsDefined = isBoolean(options.disabled) || isBoolean(_options.disabled);
        set(_fields, name, {
            ...field || {},
            _f: {
                ...field && field._f ? field._f : {
                    ref: {
                        name
                    }
                },
                name,
                mount: true,
                ...options
            }
        });
        _names.mount.add(name);
        if (field) _updateDisabledField({
            field,
            disabled: isBoolean(options.disabled) ? options.disabled : _options.disabled,
            name,
            value: options.value
        });
        else updateValidAndValue(name, true, options.value);
        return {
            ...disabledIsDefined ? {
                disabled: options.disabled || _options.disabled
            } : {},
            ..._options.progressive ? {
                required: !!options.required,
                min: getRuleValue(options.min),
                max: getRuleValue(options.max),
                minLength: getRuleValue(options.minLength),
                maxLength: getRuleValue(options.maxLength),
                pattern: getRuleValue(options.pattern)
            } : {},
            name,
            onChange,
            onBlur: onChange,
            ref: (ref)=>{
                if (ref) {
                    register(name, options);
                    field = get(_fields, name);
                    const fieldRef = isUndefined(ref.value) ? ref.querySelectorAll ? ref.querySelectorAll("input,select,textarea")[0] || ref : ref : ref;
                    const radioOrCheckbox = isRadioOrCheckbox(fieldRef);
                    const refs = field._f.refs || [];
                    if (radioOrCheckbox ? refs.find((option)=>option === fieldRef) : fieldRef === field._f.ref) return;
                    set(_fields, name, {
                        _f: {
                            ...field._f,
                            ...radioOrCheckbox ? {
                                refs: [
                                    ...refs.filter(live),
                                    fieldRef,
                                    ...Array.isArray(get(_defaultValues, name)) ? [
                                        {}
                                    ] : []
                                ],
                                ref: {
                                    type: fieldRef.type,
                                    name
                                }
                            } : {
                                ref: fieldRef
                            }
                        }
                    });
                    updateValidAndValue(name, false, undefined, fieldRef);
                } else {
                    field = get(_fields, name, {});
                    if (field._f) field._f.mount = false;
                    (_options.shouldUnregister || options.shouldUnregister) && !(isNameInFieldArray(_names.array, name) && _state.action) && _names.unMount.add(name);
                }
            }
        };
    };
    const _focusError = ()=>_options.shouldFocusError && iterateFieldsByAction(_fields, _focusInput, _names.mount);
    const _disableForm = (disabled)=>{
        if (isBoolean(disabled)) {
            _subjects.state.next({
                disabled
            });
            iterateFieldsByAction(_fields, (ref, name)=>{
                const currentField = get(_fields, name);
                if (currentField) {
                    ref.disabled = currentField._f.disabled || disabled;
                    if (Array.isArray(currentField._f.refs)) currentField._f.refs.forEach((inputRef)=>{
                        inputRef.disabled = currentField._f.disabled || disabled;
                    });
                }
            }, 0, false);
        }
    };
    const handleSubmit = (onValid, onInvalid)=>async (e)=>{
            let onValidError = undefined;
            if (e) {
                e.preventDefault && e.preventDefault();
                e.persist && e.persist();
            }
            if (_options.disabled) {
                if (onInvalid) await onInvalid({
                    ..._formState.errors
                }, e);
                return;
            }
            let fieldValues = cloneObject(_formValues);
            _subjects.state.next({
                isSubmitting: true
            });
            if (_options.resolver) {
                const { errors, values } = await _executeSchema();
                _formState.errors = errors;
                fieldValues = values;
            } else await executeBuiltInValidation(_fields);
            unset(_formState.errors, "root");
            if (isEmptyObject(_formState.errors)) {
                _subjects.state.next({
                    errors: {}
                });
                try {
                    await onValid(fieldValues, e);
                } catch (error) {
                    onValidError = error;
                }
            } else {
                if (onInvalid) await onInvalid({
                    ..._formState.errors
                }, e);
                _focusError();
                setTimeout(_focusError);
            }
            _subjects.state.next({
                isSubmitted: true,
                isSubmitting: false,
                isSubmitSuccessful: isEmptyObject(_formState.errors) && !onValidError,
                submitCount: _formState.submitCount + 1,
                errors: _formState.errors
            });
            if (onValidError) throw onValidError;
        };
    const resetField = (name, options = {})=>{
        if (get(_fields, name)) {
            if (isUndefined(options.defaultValue)) setValue(name, cloneObject(get(_defaultValues, name)));
            else {
                setValue(name, options.defaultValue);
                set(_defaultValues, name, cloneObject(options.defaultValue));
            }
            if (!options.keepTouched) unset(_formState.touchedFields, name);
            if (!options.keepDirty) {
                unset(_formState.dirtyFields, name);
                _formState.isDirty = options.defaultValue ? _getDirty(name, cloneObject(get(_defaultValues, name))) : _getDirty();
            }
            if (!options.keepError) {
                unset(_formState.errors, name);
                _proxyFormState.isValid && _updateValid();
            }
            _subjects.state.next({
                ..._formState
            });
        }
    };
    const _reset = (formValues, keepStateOptions = {})=>{
        const updatedValues = formValues ? cloneObject(formValues) : _defaultValues;
        const cloneUpdatedValues = cloneObject(updatedValues);
        const isEmptyResetValues = isEmptyObject(formValues);
        const values = isEmptyResetValues ? _defaultValues : cloneUpdatedValues;
        if (!keepStateOptions.keepDefaultValues) _defaultValues = updatedValues;
        if (!keepStateOptions.keepValues) {
            if (keepStateOptions.keepDirtyValues) {
                const fieldsToCheck = new Set([
                    ..._names.mount,
                    ...Object.keys(getDirtyFields(_defaultValues, _formValues))
                ]);
                for (const fieldName of Array.from(fieldsToCheck))get(_formState.dirtyFields, fieldName) ? set(values, fieldName, get(_formValues, fieldName)) : setValue(fieldName, get(values, fieldName));
            } else {
                if (isWeb && isUndefined(formValues)) for (const name of _names.mount){
                    const field = get(_fields, name);
                    if (field && field._f) {
                        const fieldReference = Array.isArray(field._f.refs) ? field._f.refs[0] : field._f.ref;
                        if (isHTMLElement(fieldReference)) {
                            const form = fieldReference.closest("form");
                            if (form) {
                                form.reset();
                                break;
                            }
                        }
                    }
                }
                _fields = {};
            }
            _formValues = props.shouldUnregister ? keepStateOptions.keepDefaultValues ? cloneObject(_defaultValues) : {} : cloneObject(values);
            _subjects.array.next({
                values: {
                    ...values
                }
            });
            _subjects.values.next({
                values: {
                    ...values
                }
            });
        }
        _names = {
            mount: keepStateOptions.keepDirtyValues ? _names.mount : new Set(),
            unMount: new Set(),
            array: new Set(),
            watch: new Set(),
            watchAll: false,
            focus: ""
        };
        _state.mount = !_proxyFormState.isValid || !!keepStateOptions.keepIsValid || !!keepStateOptions.keepDirtyValues;
        _state.watch = !!props.shouldUnregister;
        _subjects.state.next({
            submitCount: keepStateOptions.keepSubmitCount ? _formState.submitCount : 0,
            isDirty: isEmptyResetValues ? false : keepStateOptions.keepDirty ? _formState.isDirty : !!(keepStateOptions.keepDefaultValues && !deepEqual(formValues, _defaultValues)),
            isSubmitted: keepStateOptions.keepIsSubmitted ? _formState.isSubmitted : false,
            dirtyFields: isEmptyResetValues ? {} : keepStateOptions.keepDirtyValues ? keepStateOptions.keepDefaultValues && _formValues ? getDirtyFields(_defaultValues, _formValues) : _formState.dirtyFields : keepStateOptions.keepDefaultValues && formValues ? getDirtyFields(_defaultValues, formValues) : keepStateOptions.keepDirty ? _formState.dirtyFields : {},
            touchedFields: keepStateOptions.keepTouched ? _formState.touchedFields : {},
            errors: keepStateOptions.keepErrors ? _formState.errors : {},
            isSubmitSuccessful: keepStateOptions.keepIsSubmitSuccessful ? _formState.isSubmitSuccessful : false,
            isSubmitting: false
        });
    };
    const reset = (formValues, keepStateOptions)=>_reset(isFunction(formValues) ? formValues(_formValues) : formValues, keepStateOptions);
    const setFocus = (name, options = {})=>{
        const field = get(_fields, name);
        const fieldReference = field && field._f;
        if (fieldReference) {
            const fieldRef = fieldReference.refs ? fieldReference.refs[0] : fieldReference.ref;
            if (fieldRef.focus) {
                fieldRef.focus();
                options.shouldSelect && isFunction(fieldRef.select) && fieldRef.select();
            }
        }
    };
    const _updateFormState = (updatedFormState)=>{
        _formState = {
            ..._formState,
            ...updatedFormState
        };
    };
    const _resetDefaultValues = ()=>isFunction(_options.defaultValues) && _options.defaultValues().then((values)=>{
            reset(values, _options.resetOptions);
            _subjects.state.next({
                isLoading: false
            });
        });
    return {
        control: {
            register,
            unregister,
            getFieldState,
            handleSubmit,
            setError,
            _executeSchema,
            _getWatch,
            _getDirty,
            _updateValid,
            _removeUnmounted,
            _updateFieldArray,
            _updateDisabledField,
            _getFieldArray,
            _reset,
            _resetDefaultValues,
            _updateFormState,
            _disableForm,
            _subjects,
            _proxyFormState,
            _setErrors,
            get _fields () {
                return _fields;
            },
            get _formValues () {
                return _formValues;
            },
            get _state () {
                return _state;
            },
            set _state (value){
                _state = value;
            },
            get _defaultValues () {
                return _defaultValues;
            },
            get _names () {
                return _names;
            },
            set _names (value){
                _names = value;
            },
            get _formState () {
                return _formState;
            },
            set _formState (value){
                _formState = value;
            },
            get _options () {
                return _options;
            },
            set _options (value){
                _options = {
                    ..._options,
                    ...value
                };
            }
        },
        trigger,
        register,
        handleSubmit,
        watch,
        setValue,
        getValues,
        reset,
        resetField,
        clearErrors,
        unregister,
        setError,
        setFocus,
        getFieldState
    };
}
/**
 * Custom hook to manage the entire form.
 *
 * @remarks
 * [API](https://react-hook-form.com/docs/useform) • [Demo](https://codesandbox.io/s/react-hook-form-get-started-ts-5ksmm) • [Video](https://www.youtube.com/watch?v=RkXv4AXXC_4)
 *
 * @param props - form configuration and validation parameters.
 *
 * @returns methods - individual functions to manage the form state. {@link UseFormReturn}
 *
 * @example
 * ```tsx
 * function App() {
 *   const { register, handleSubmit, watch, formState: { errors } } = useForm();
 *   const onSubmit = data => console.log(data);
 *
 *   console.log(watch("example"));
 *
 *   return (
 *     <form onSubmit={handleSubmit(onSubmit)}>
 *       <input defaultValue="test" {...register("example")} />
 *       <input {...register("exampleRequired", { required: true })} />
 *       {errors.exampleRequired && <span>This field is required</span>}
 *       <button>Submit</button>
 *     </form>
 *   );
 * }
 * ```
 */ function useForm(props = {}) {
    const _formControl = (0, _reactDefault.default).useRef();
    const _values = (0, _reactDefault.default).useRef();
    const [formState, updateFormState] = (0, _reactDefault.default).useState({
        isDirty: false,
        isValidating: false,
        isLoading: isFunction(props.defaultValues),
        isSubmitted: false,
        isSubmitting: false,
        isSubmitSuccessful: false,
        isValid: false,
        submitCount: 0,
        dirtyFields: {},
        touchedFields: {},
        validatingFields: {},
        errors: props.errors || {},
        disabled: props.disabled || false,
        defaultValues: isFunction(props.defaultValues) ? undefined : props.defaultValues
    });
    if (!_formControl.current) _formControl.current = {
        ...createFormControl(props),
        formState
    };
    const control = _formControl.current.control;
    control._options = props;
    useSubscribe({
        subject: control._subjects.state,
        next: (value1)=>{
            if (shouldRenderFormState(value1, control._proxyFormState, control._updateFormState, true)) updateFormState({
                ...control._formState
            });
        }
    });
    (0, _reactDefault.default).useEffect(()=>control._disableForm(props.disabled), [
        control,
        props.disabled
    ]);
    (0, _reactDefault.default).useEffect(()=>{
        if (control._proxyFormState.isDirty) {
            const isDirty = control._getDirty();
            if (isDirty !== formState.isDirty) control._subjects.state.next({
                isDirty
            });
        }
    }, [
        control,
        formState.isDirty
    ]);
    (0, _reactDefault.default).useEffect(()=>{
        if (props.values && !deepEqual(props.values, _values.current)) {
            control._reset(props.values, control._options.resetOptions);
            _values.current = props.values;
            updateFormState((state)=>({
                    ...state
                }));
        } else control._resetDefaultValues();
    }, [
        props.values,
        control
    ]);
    (0, _reactDefault.default).useEffect(()=>{
        if (props.errors) control._setErrors(props.errors);
    }, [
        props.errors,
        control
    ]);
    (0, _reactDefault.default).useEffect(()=>{
        if (!control._state.mount) {
            control._updateValid();
            control._state.mount = true;
        }
        if (control._state.watch) {
            control._state.watch = false;
            control._subjects.state.next({
                ...control._formState
            });
        }
        control._removeUnmounted();
    });
    (0, _reactDefault.default).useEffect(()=>{
        props.shouldUnregister && control._subjects.values.next({
            values: control._getWatch()
        });
    }, [
        props.shouldUnregister,
        control
    ]);
    _formControl.current.formState = getProxyFormState(formState, control);
    return _formControl.current;
}

},{"react":"6uln9","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7LcoK":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "FoodOrderingGenAIModelSettingId", ()=>FoodOrderingGenAIModelSettingId);
parcelHelpers.export(exports, "FoodOrderingGenAIPromptOverrideSettingId", ()=>FoodOrderingGenAIPromptOverrideSettingId);
const FoodOrderingGenAIModelSettingId = "61cc990e-f123-45c7-b953-58a1fce8f752";
const FoodOrderingGenAIPromptOverrideSettingId = "56ef3cd9-07b7-43d9-b185-5bfb5affd092";

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"eqzd3":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
class PhraseSlot {
    constructor(text){
        this.fullText = text;
    }
    getSlotName() {
        if (!this.fullText || this.fullText == "") return null;
        return this.fullText.replace("{", "").replace("}", "").split("|")[0].trim();
    }
    getSlotExample() {
        if (!this.fullText || this.fullText == "") return null;
        return this.fullText.replace("{", "").replace("}", "").split("|")[1].trim();
    }
}
exports.default = PhraseSlot;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"58ztL":[function(require,module,exports) {
/* @license
Papa Parse
v5.4.1
https://github.com/mholt/PapaParse
License: MIT
*/ !function(e, t) {
    "function" == typeof define && define.amd ? define([], t) : module.exports = t();
}(this, function s() {
    "use strict";
    var f = "undefined" != typeof self ? self : "undefined" != typeof window ? window : void 0 !== f ? f : {};
    var n = !f.document && !!f.postMessage, o = f.IS_PAPA_WORKER || !1, a = {}, u = 0, b = {
        parse: function(e, t) {
            var r = (t = t || {}).dynamicTyping || !1;
            J(r) && (t.dynamicTypingFunction = r, r = {});
            if (t.dynamicTyping = r, t.transform = !!J(t.transform) && t.transform, t.worker && b.WORKERS_SUPPORTED) {
                var i = function() {
                    if (!b.WORKERS_SUPPORTED) return !1;
                    var e = (r = f.URL || f.webkitURL || null, i = s.toString(), b.BLOB_URL || (b.BLOB_URL = r.createObjectURL(new Blob([
                        "var global = (function() { if (typeof self !== 'undefined') { return self; } if (typeof window !== 'undefined') { return window; } if (typeof global !== 'undefined') { return global; } return {}; })(); global.IS_PAPA_WORKER=true; ",
                        "(",
                        i,
                        ")();"
                    ], {
                        type: "text/javascript"
                    })))), t = new f.Worker(e);
                    var r, i;
                    return t.onmessage = _, t.id = u++, a[t.id] = t;
                }();
                return i.userStep = t.step, i.userChunk = t.chunk, i.userComplete = t.complete, i.userError = t.error, t.step = J(t.step), t.chunk = J(t.chunk), t.complete = J(t.complete), t.error = J(t.error), delete t.worker, void i.postMessage({
                    input: e,
                    config: t,
                    workerId: i.id
                });
            }
            var n = null;
            b.NODE_STREAM_INPUT, "string" == typeof e ? (e = function(e) {
                if (65279 === e.charCodeAt(0)) return e.slice(1);
                return e;
            }(e), n = t.download ? new l(t) : new p(t)) : !0 === e.readable && J(e.read) && J(e.on) ? n = new g(t) : (f.File && e instanceof File || e instanceof Object) && (n = new c(t));
            return n.stream(e);
        },
        unparse: function(e, t) {
            var n = !1, _ = !0, m = ",", y = "\r\n", s = '"', a = s + s, r = !1, i = null, o = !1;
            !function() {
                if ("object" != typeof t) return;
                "string" != typeof t.delimiter || b.BAD_DELIMITERS.filter(function(e) {
                    return -1 !== t.delimiter.indexOf(e);
                }).length || (m = t.delimiter);
                ("boolean" == typeof t.quotes || "function" == typeof t.quotes || Array.isArray(t.quotes)) && (n = t.quotes);
                "boolean" != typeof t.skipEmptyLines && "string" != typeof t.skipEmptyLines || (r = t.skipEmptyLines);
                "string" == typeof t.newline && (y = t.newline);
                "string" == typeof t.quoteChar && (s = t.quoteChar);
                "boolean" == typeof t.header && (_ = t.header);
                if (Array.isArray(t.columns)) {
                    if (0 === t.columns.length) throw new Error("Option columns is empty");
                    i = t.columns;
                }
                void 0 !== t.escapeChar && (a = t.escapeChar + s);
                ("boolean" == typeof t.escapeFormulae || t.escapeFormulae instanceof RegExp) && (o = t.escapeFormulae instanceof RegExp ? t.escapeFormulae : /^[=+\-@\t\r].*$/);
            }();
            var u = new RegExp(Q(s), "g");
            "string" == typeof e && (e = JSON.parse(e));
            if (Array.isArray(e)) {
                if (!e.length || Array.isArray(e[0])) return h(null, e, r);
                if ("object" == typeof e[0]) return h(i || Object.keys(e[0]), e, r);
            } else if ("object" == typeof e) return "string" == typeof e.data && (e.data = JSON.parse(e.data)), Array.isArray(e.data) && (e.fields || (e.fields = e.meta && e.meta.fields || i), e.fields || (e.fields = Array.isArray(e.data[0]) ? e.fields : "object" == typeof e.data[0] ? Object.keys(e.data[0]) : []), Array.isArray(e.data[0]) || "object" == typeof e.data[0] || (e.data = [
                e.data
            ])), h(e.fields || [], e.data || [], r);
            throw new Error("Unable to serialize unrecognized input");
            function h(e, t, r) {
                var i = "";
                "string" == typeof e && (e = JSON.parse(e)), "string" == typeof t && (t = JSON.parse(t));
                var n = Array.isArray(e) && 0 < e.length, s = !Array.isArray(t[0]);
                if (n && _) {
                    for(var a = 0; a < e.length; a++)0 < a && (i += m), i += v(e[a], a);
                    0 < t.length && (i += y);
                }
                for(var o = 0; o < t.length; o++){
                    var u = n ? e.length : t[o].length, h = !1, f = n ? 0 === Object.keys(t[o]).length : 0 === t[o].length;
                    if (r && !n && (h = "greedy" === r ? "" === t[o].join("").trim() : 1 === t[o].length && 0 === t[o][0].length), "greedy" === r && n) {
                        for(var d = [], l = 0; l < u; l++){
                            var c = s ? e[l] : l;
                            d.push(t[o][c]);
                        }
                        h = "" === d.join("").trim();
                    }
                    if (!h) {
                        for(var p = 0; p < u; p++){
                            0 < p && !f && (i += m);
                            var g = n && s ? e[p] : p;
                            i += v(t[o][g], p);
                        }
                        o < t.length - 1 && (!r || 0 < u && !f) && (i += y);
                    }
                }
                return i;
            }
            function v(e, t) {
                if (null == e) return "";
                if (e.constructor === Date) return JSON.stringify(e).slice(1, 25);
                var r = !1;
                o && "string" == typeof e && o.test(e) && (e = "'" + e, r = !0);
                var i = e.toString().replace(u, a);
                return (r = r || !0 === n || "function" == typeof n && n(e, t) || Array.isArray(n) && n[t] || function(e, t) {
                    for(var r = 0; r < t.length; r++)if (-1 < e.indexOf(t[r])) return !0;
                    return !1;
                }(i, b.BAD_DELIMITERS) || -1 < i.indexOf(m) || " " === i.charAt(0) || " " === i.charAt(i.length - 1)) ? s + i + s : i;
            }
        }
    };
    if (b.RECORD_SEP = String.fromCharCode(30), b.UNIT_SEP = String.fromCharCode(31), b.BYTE_ORDER_MARK = "\uFEFF", b.BAD_DELIMITERS = [
        "\r",
        "\n",
        '"',
        b.BYTE_ORDER_MARK
    ], b.WORKERS_SUPPORTED = !n && !!f.Worker, b.NODE_STREAM_INPUT = 1, b.LocalChunkSize = 10485760, b.RemoteChunkSize = 5242880, b.DefaultDelimiter = ",", b.Parser = E, b.ParserHandle = r, b.NetworkStreamer = l, b.FileStreamer = c, b.StringStreamer = p, b.ReadableStreamStreamer = g, f.jQuery) {
        var d = f.jQuery;
        d.fn.parse = function(o) {
            var r = o.config || {}, u = [];
            return this.each(function(e) {
                if (!("INPUT" === d(this).prop("tagName").toUpperCase() && "file" === d(this).attr("type").toLowerCase() && f.FileReader) || !this.files || 0 === this.files.length) return !0;
                for(var t = 0; t < this.files.length; t++)u.push({
                    file: this.files[t],
                    inputElem: this,
                    instanceConfig: d.extend({}, r)
                });
            }), e(), this;
            function e() {
                if (0 !== u.length) {
                    var e, t, r, i, n = u[0];
                    if (J(o.before)) {
                        var s = o.before(n.file, n.inputElem);
                        if ("object" == typeof s) {
                            if ("abort" === s.action) return e = "AbortError", t = n.file, r = n.inputElem, i = s.reason, void (J(o.error) && o.error({
                                name: e
                            }, t, r, i));
                            if ("skip" === s.action) return void h();
                            "object" == typeof s.config && (n.instanceConfig = d.extend(n.instanceConfig, s.config));
                        } else if ("skip" === s) return void h();
                    }
                    var a = n.instanceConfig.complete;
                    n.instanceConfig.complete = function(e) {
                        J(a) && a(e, n.file, n.inputElem), h();
                    }, b.parse(n.file, n.instanceConfig);
                } else J(o.complete) && o.complete();
            }
            function h() {
                u.splice(0, 1), e();
            }
        };
    }
    function h(e) {
        this._handle = null, this._finished = !1, this._completed = !1, this._halted = !1, this._input = null, this._baseIndex = 0, this._partialLine = "", this._rowCount = 0, this._start = 0, this._nextChunk = null, this.isFirstChunk = !0, this._completeResults = {
            data: [],
            errors: [],
            meta: {}
        }, (function(e) {
            var t = w(e);
            t.chunkSize = parseInt(t.chunkSize), e.step || e.chunk || (t.chunkSize = null);
            this._handle = new r(t), (this._handle.streamer = this)._config = t;
        }).call(this, e), this.parseChunk = function(e, t) {
            if (this.isFirstChunk && J(this._config.beforeFirstChunk)) {
                var r = this._config.beforeFirstChunk(e);
                void 0 !== r && (e = r);
            }
            this.isFirstChunk = !1, this._halted = !1;
            var i = this._partialLine + e;
            this._partialLine = "";
            var n = this._handle.parse(i, this._baseIndex, !this._finished);
            if (!this._handle.paused() && !this._handle.aborted()) {
                var s = n.meta.cursor;
                this._finished || (this._partialLine = i.substring(s - this._baseIndex), this._baseIndex = s), n && n.data && (this._rowCount += n.data.length);
                var a = this._finished || this._config.preview && this._rowCount >= this._config.preview;
                if (o) f.postMessage({
                    results: n,
                    workerId: b.WORKER_ID,
                    finished: a
                });
                else if (J(this._config.chunk) && !t) {
                    if (this._config.chunk(n, this._handle), this._handle.paused() || this._handle.aborted()) return void (this._halted = !0);
                    n = void 0, this._completeResults = void 0;
                }
                return this._config.step || this._config.chunk || (this._completeResults.data = this._completeResults.data.concat(n.data), this._completeResults.errors = this._completeResults.errors.concat(n.errors), this._completeResults.meta = n.meta), this._completed || !a || !J(this._config.complete) || n && n.meta.aborted || (this._config.complete(this._completeResults, this._input), this._completed = !0), a || n && n.meta.paused || this._nextChunk(), n;
            }
            this._halted = !0;
        }, this._sendError = function(e) {
            J(this._config.error) ? this._config.error(e) : o && this._config.error && f.postMessage({
                workerId: b.WORKER_ID,
                error: e,
                finished: !1
            });
        };
    }
    function l(e) {
        var i;
        (e = e || {}).chunkSize || (e.chunkSize = b.RemoteChunkSize), h.call(this, e), this._nextChunk = n ? function() {
            this._readChunk(), this._chunkLoaded();
        } : function() {
            this._readChunk();
        }, this.stream = function(e) {
            this._input = e, this._nextChunk();
        }, this._readChunk = function() {
            if (this._finished) this._chunkLoaded();
            else {
                if (i = new XMLHttpRequest, this._config.withCredentials && (i.withCredentials = this._config.withCredentials), n || (i.onload = v(this._chunkLoaded, this), i.onerror = v(this._chunkError, this)), i.open(this._config.downloadRequestBody ? "POST" : "GET", this._input, !n), this._config.downloadRequestHeaders) {
                    var e = this._config.downloadRequestHeaders;
                    for(var t in e)i.setRequestHeader(t, e[t]);
                }
                if (this._config.chunkSize) {
                    var r = this._start + this._config.chunkSize - 1;
                    i.setRequestHeader("Range", "bytes=" + this._start + "-" + r);
                }
                try {
                    i.send(this._config.downloadRequestBody);
                } catch (e) {
                    this._chunkError(e.message);
                }
                n && 0 === i.status && this._chunkError();
            }
        }, this._chunkLoaded = function() {
            4 === i.readyState && (i.status < 200 || 400 <= i.status ? this._chunkError() : (this._start += this._config.chunkSize ? this._config.chunkSize : i.responseText.length, this._finished = !this._config.chunkSize || this._start >= function(e) {
                var t = e.getResponseHeader("Content-Range");
                if (null === t) return -1;
                return parseInt(t.substring(t.lastIndexOf("/") + 1));
            }(i), this.parseChunk(i.responseText)));
        }, this._chunkError = function(e) {
            var t = i.statusText || e;
            this._sendError(new Error(t));
        };
    }
    function c(e) {
        var i, n;
        (e = e || {}).chunkSize || (e.chunkSize = b.LocalChunkSize), h.call(this, e);
        var s = "undefined" != typeof FileReader;
        this.stream = function(e) {
            this._input = e, n = e.slice || e.webkitSlice || e.mozSlice, s ? ((i = new FileReader).onload = v(this._chunkLoaded, this), i.onerror = v(this._chunkError, this)) : i = new FileReaderSync, this._nextChunk();
        }, this._nextChunk = function() {
            this._finished || this._config.preview && !(this._rowCount < this._config.preview) || this._readChunk();
        }, this._readChunk = function() {
            var e = this._input;
            if (this._config.chunkSize) {
                var t = Math.min(this._start + this._config.chunkSize, this._input.size);
                e = n.call(e, this._start, t);
            }
            var r = i.readAsText(e, this._config.encoding);
            s || this._chunkLoaded({
                target: {
                    result: r
                }
            });
        }, this._chunkLoaded = function(e) {
            this._start += this._config.chunkSize, this._finished = !this._config.chunkSize || this._start >= this._input.size, this.parseChunk(e.target.result);
        }, this._chunkError = function() {
            this._sendError(i.error);
        };
    }
    function p(e) {
        var r;
        h.call(this, e = e || {}), this.stream = function(e) {
            return r = e, this._nextChunk();
        }, this._nextChunk = function() {
            if (!this._finished) {
                var e, t = this._config.chunkSize;
                return t ? (e = r.substring(0, t), r = r.substring(t)) : (e = r, r = ""), this._finished = !r, this.parseChunk(e);
            }
        };
    }
    function g(e) {
        h.call(this, e = e || {});
        var t = [], r = !0, i = !1;
        this.pause = function() {
            h.prototype.pause.apply(this, arguments), this._input.pause();
        }, this.resume = function() {
            h.prototype.resume.apply(this, arguments), this._input.resume();
        }, this.stream = function(e) {
            this._input = e, this._input.on("data", this._streamData), this._input.on("end", this._streamEnd), this._input.on("error", this._streamError);
        }, this._checkIsFinished = function() {
            i && 1 === t.length && (this._finished = !0);
        }, this._nextChunk = function() {
            this._checkIsFinished(), t.length ? this.parseChunk(t.shift()) : r = !0;
        }, this._streamData = v(function(e) {
            try {
                t.push("string" == typeof e ? e : e.toString(this._config.encoding)), r && (r = !1, this._checkIsFinished(), this.parseChunk(t.shift()));
            } catch (e) {
                this._streamError(e);
            }
        }, this), this._streamError = v(function(e) {
            this._streamCleanUp(), this._sendError(e);
        }, this), this._streamEnd = v(function() {
            this._streamCleanUp(), i = !0, this._streamData("");
        }, this), this._streamCleanUp = v(function() {
            this._input.removeListener("data", this._streamData), this._input.removeListener("end", this._streamEnd), this._input.removeListener("error", this._streamError);
        }, this);
    }
    function r(m) {
        var a, o, u, i = Math.pow(2, 53), n = -i, s = /^\s*-?(\d+\.?|\.\d+|\d+\.\d+)([eE][-+]?\d+)?\s*$/, h = /^((\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d\.\d+([+-][0-2]\d:[0-5]\d|Z))|(\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d([+-][0-2]\d:[0-5]\d|Z))|(\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d([+-][0-2]\d:[0-5]\d|Z)))$/, t = this, r = 0, f = 0, d = !1, e = !1, l = [], c = {
            data: [],
            errors: [],
            meta: {}
        };
        if (J(m.step)) {
            var p = m.step;
            m.step = function(e) {
                if (c = e, _()) g();
                else {
                    if (g(), 0 === c.data.length) return;
                    r += e.data.length, m.preview && r > m.preview ? o.abort() : (c.data = c.data[0], p(c, t));
                }
            };
        }
        function y(e) {
            return "greedy" === m.skipEmptyLines ? "" === e.join("").trim() : 1 === e.length && 0 === e[0].length;
        }
        function g() {
            return c && u && (k("Delimiter", "UndetectableDelimiter", "Unable to auto-detect delimiting character; defaulted to '" + b.DefaultDelimiter + "'"), u = !1), m.skipEmptyLines && (c.data = c.data.filter(function(e) {
                return !y(e);
            })), _() && function() {
                if (!c) return;
                function e(e, t) {
                    J(m.transformHeader) && (e = m.transformHeader(e, t)), l.push(e);
                }
                if (Array.isArray(c.data[0])) {
                    for(var t = 0; _() && t < c.data.length; t++)c.data[t].forEach(e);
                    c.data.splice(0, 1);
                } else c.data.forEach(e);
            }(), function() {
                if (!c || !m.header && !m.dynamicTyping && !m.transform) return c;
                function e(e, t) {
                    var r, i = m.header ? {} : [];
                    for(r = 0; r < e.length; r++){
                        var n = r, s = e[r];
                        m.header && (n = r >= l.length ? "__parsed_extra" : l[r]), m.transform && (s = m.transform(s, n)), s = v(n, s), "__parsed_extra" === n ? (i[n] = i[n] || [], i[n].push(s)) : i[n] = s;
                    }
                    return m.header && (r > l.length ? k("FieldMismatch", "TooManyFields", "Too many fields: expected " + l.length + " fields but parsed " + r, f + t) : r < l.length && k("FieldMismatch", "TooFewFields", "Too few fields: expected " + l.length + " fields but parsed " + r, f + t)), i;
                }
                var t = 1;
                !c.data.length || Array.isArray(c.data[0]) ? (c.data = c.data.map(e), t = c.data.length) : c.data = e(c.data, 0);
                m.header && c.meta && (c.meta.fields = l);
                return f += t, c;
            }();
        }
        function _() {
            return m.header && 0 === l.length;
        }
        function v(e, t) {
            var r;
            return r = e, m.dynamicTypingFunction && void 0 === m.dynamicTyping[r] && (m.dynamicTyping[r] = m.dynamicTypingFunction(r)), !0 === (m.dynamicTyping[r] || m.dynamicTyping) ? "true" === t || "TRUE" === t || "false" !== t && "FALSE" !== t && (function(e) {
                if (s.test(e)) {
                    var t = parseFloat(e);
                    if (n < t && t < i) return !0;
                }
                return !1;
            }(t) ? parseFloat(t) : h.test(t) ? new Date(t) : "" === t ? null : t) : t;
        }
        function k(e, t, r, i) {
            var n = {
                type: e,
                code: t,
                message: r
            };
            void 0 !== i && (n.row = i), c.errors.push(n);
        }
        this.parse = function(e, t, r) {
            var i = m.quoteChar || '"';
            if (m.newline || (m.newline = function(e, t) {
                e = e.substring(0, 1048576);
                var r = new RegExp(Q(t) + "([^]*?)" + Q(t), "gm"), i = (e = e.replace(r, "")).split("\r"), n = e.split("\n"), s = 1 < n.length && n[0].length < i[0].length;
                if (1 === i.length || s) return "\n";
                for(var a = 0, o = 0; o < i.length; o++)"\n" === i[o][0] && a++;
                return a >= i.length / 2 ? "\r\n" : "\r";
            }(e, i)), u = !1, m.delimiter) J(m.delimiter) && (m.delimiter = m.delimiter(e), c.meta.delimiter = m.delimiter);
            else {
                var n = function(e, t, r, i, n) {
                    var s, a, o, u;
                    n = n || [
                        ",",
                        "	",
                        "|",
                        ";",
                        b.RECORD_SEP,
                        b.UNIT_SEP
                    ];
                    for(var h = 0; h < n.length; h++){
                        var f = n[h], d = 0, l = 0, c = 0;
                        o = void 0;
                        for(var p = new E({
                            comments: i,
                            delimiter: f,
                            newline: t,
                            preview: 10
                        }).parse(e), g = 0; g < p.data.length; g++)if (r && y(p.data[g])) c++;
                        else {
                            var _ = p.data[g].length;
                            l += _, void 0 !== o ? 0 < _ && (d += Math.abs(_ - o), o = _) : o = _;
                        }
                        0 < p.data.length && (l /= p.data.length - c), (void 0 === a || d <= a) && (void 0 === u || u < l) && 1.99 < l && (a = d, s = f, u = l);
                    }
                    return {
                        successful: !!(m.delimiter = s),
                        bestDelimiter: s
                    };
                }(e, m.newline, m.skipEmptyLines, m.comments, m.delimitersToGuess);
                n.successful ? m.delimiter = n.bestDelimiter : (u = !0, m.delimiter = b.DefaultDelimiter), c.meta.delimiter = m.delimiter;
            }
            var s = w(m);
            return m.preview && m.header && s.preview++, a = e, o = new E(s), c = o.parse(a, t, r), g(), d ? {
                meta: {
                    paused: !0
                }
            } : c || {
                meta: {
                    paused: !1
                }
            };
        }, this.paused = function() {
            return d;
        }, this.pause = function() {
            d = !0, o.abort(), a = J(m.chunk) ? "" : a.substring(o.getCharIndex());
        }, this.resume = function() {
            t.streamer._halted ? (d = !1, t.streamer.parseChunk(a, !0)) : setTimeout(t.resume, 3);
        }, this.aborted = function() {
            return e;
        }, this.abort = function() {
            e = !0, o.abort(), c.meta.aborted = !0, J(m.complete) && m.complete(c), a = "";
        };
    }
    function Q(e) {
        return e.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
    }
    function E(j) {
        var z, M = (j = j || {}).delimiter, P = j.newline, U = j.comments, q = j.step, N = j.preview, B = j.fastMode, K = z = void 0 === j.quoteChar || null === j.quoteChar ? '"' : j.quoteChar;
        if (void 0 !== j.escapeChar && (K = j.escapeChar), ("string" != typeof M || -1 < b.BAD_DELIMITERS.indexOf(M)) && (M = ","), U === M) throw new Error("Comment character same as delimiter");
        !0 === U ? U = "#" : ("string" != typeof U || -1 < b.BAD_DELIMITERS.indexOf(U)) && (U = !1), "\n" !== P && "\r" !== P && "\r\n" !== P && (P = "\n");
        var W = 0, H = !1;
        this.parse = function(i, t, r) {
            if ("string" != typeof i) throw new Error("Input must be a string");
            var n = i.length, e = M.length, s = P.length, a = U.length, o = J(q), u = [], h = [], f = [], d = W = 0;
            if (!i) return L();
            if (j.header && !t) {
                var l = i.split(P)[0].split(M), c = [], p = {}, g = !1;
                for(var _ in l){
                    var m = l[_];
                    J(j.transformHeader) && (m = j.transformHeader(m, _));
                    var y = m, v = p[m] || 0;
                    for(0 < v && (g = !0, y = m + "_" + v), p[m] = v + 1; c.includes(y);)y = y + "_" + v;
                    c.push(y);
                }
                if (g) {
                    var k = i.split(P);
                    k[0] = c.join(M), i = k.join(P);
                }
            }
            if (B || !1 !== B && -1 === i.indexOf(z)) {
                for(var b = i.split(P), E = 0; E < b.length; E++){
                    if (f = b[E], W += f.length, E !== b.length - 1) W += P.length;
                    else if (r) return L();
                    if (!U || f.substring(0, a) !== U) {
                        if (o) {
                            if (u = [], I(f.split(M)), F(), H) return L();
                        } else I(f.split(M));
                        if (N && N <= E) return u = u.slice(0, N), L(!0);
                    }
                }
                return L();
            }
            for(var w = i.indexOf(M, W), R = i.indexOf(P, W), C = new RegExp(Q(K) + Q(z), "g"), S = i.indexOf(z, W);;)if (i[W] !== z) {
                if (U && 0 === f.length && i.substring(W, W + a) === U) {
                    if (-1 === R) return L();
                    W = R + s, R = i.indexOf(P, W), w = i.indexOf(M, W);
                } else if (-1 !== w && (w < R || -1 === R)) f.push(i.substring(W, w)), W = w + e, w = i.indexOf(M, W);
                else {
                    if (-1 === R) break;
                    if (f.push(i.substring(W, R)), D(R + s), o && (F(), H)) return L();
                    if (N && u.length >= N) return L(!0);
                }
            } else for(S = W, W++;;){
                if (-1 === (S = i.indexOf(z, S + 1))) return r || h.push({
                    type: "Quotes",
                    code: "MissingQuotes",
                    message: "Quoted field unterminated",
                    row: u.length,
                    index: W
                }), T();
                if (S === n - 1) return T(i.substring(W, S).replace(C, z));
                if (z !== K || i[S + 1] !== K) {
                    if (z === K || 0 === S || i[S - 1] !== K) {
                        -1 !== w && w < S + 1 && (w = i.indexOf(M, S + 1)), -1 !== R && R < S + 1 && (R = i.indexOf(P, S + 1));
                        var O = A(-1 === R ? w : Math.min(w, R));
                        if (i.substr(S + 1 + O, e) === M) {
                            f.push(i.substring(W, S).replace(C, z)), i[W = S + 1 + O + e] !== z && (S = i.indexOf(z, W)), w = i.indexOf(M, W), R = i.indexOf(P, W);
                            break;
                        }
                        var x = A(R);
                        if (i.substring(S + 1 + x, S + 1 + x + s) === P) {
                            if (f.push(i.substring(W, S).replace(C, z)), D(S + 1 + x + s), w = i.indexOf(M, W), S = i.indexOf(z, W), o && (F(), H)) return L();
                            if (N && u.length >= N) return L(!0);
                            break;
                        }
                        h.push({
                            type: "Quotes",
                            code: "InvalidQuotes",
                            message: "Trailing quote on quoted field is malformed",
                            row: u.length,
                            index: W
                        }), S++;
                    }
                } else S++;
            }
            return T();
            function I(e) {
                u.push(e), d = W;
            }
            function A(e) {
                var t = 0;
                if (-1 !== e) {
                    var r = i.substring(S + 1, e);
                    r && "" === r.trim() && (t = r.length);
                }
                return t;
            }
            function T(e) {
                return r || (void 0 === e && (e = i.substring(W)), f.push(e), W = n, I(f), o && F()), L();
            }
            function D(e) {
                W = e, I(f), f = [], R = i.indexOf(P, W);
            }
            function L(e) {
                return {
                    data: u,
                    errors: h,
                    meta: {
                        delimiter: M,
                        linebreak: P,
                        aborted: H,
                        truncated: !!e,
                        cursor: d + (t || 0)
                    }
                };
            }
            function F() {
                q(L()), u = [], h = [];
            }
        }, this.abort = function() {
            H = !0;
        }, this.getCharIndex = function() {
            return W;
        };
    }
    function _(e) {
        var t = e.data, r = a[t.workerId], i = !1;
        if (t.error) r.userError(t.error, t.file);
        else if (t.results && t.results.data) {
            var n = {
                abort: function() {
                    i = !0, m(t.workerId, {
                        data: [],
                        errors: [],
                        meta: {
                            aborted: !0
                        }
                    });
                },
                pause: y,
                resume: y
            };
            if (J(r.userStep)) {
                for(var s = 0; s < t.results.data.length && (r.userStep({
                    data: t.results.data[s],
                    errors: t.results.errors,
                    meta: t.results.meta
                }, n), !i); s++);
                delete t.results;
            } else J(r.userChunk) && (r.userChunk(t.results, n, t.file), delete t.results);
        }
        t.finished && !i && m(t.workerId, t.results);
    }
    function m(e, t) {
        var r = a[e];
        J(r.userComplete) && r.userComplete(t), r.terminate(), delete a[e];
    }
    function y() {
        throw new Error("Not implemented.");
    }
    function w(e) {
        if ("object" != typeof e || null === e) return e;
        var t = Array.isArray(e) ? [] : {};
        for(var r in e)t[r] = w(e[r]);
        return t;
    }
    function v(e, t) {
        return function() {
            e.apply(t, arguments);
        };
    }
    function J(e) {
        return "function" == typeof e;
    }
    return o && (f.onmessage = function(e) {
        var t = e.data;
        void 0 === b.WORKER_ID && t && (b.WORKER_ID = t.workerId);
        if ("string" == typeof t.input) f.postMessage({
            workerId: b.WORKER_ID,
            results: b.parse(t.input, t.config),
            finished: !0
        });
        else if (f.File && t.input instanceof File || t.input instanceof Object) {
            var r = b.parse(t.input, t.config);
            r && f.postMessage({
                workerId: b.WORKER_ID,
                results: r,
                finished: !0
            });
        }
    }), (l.prototype = Object.create(h.prototype)).constructor = l, (c.prototype = Object.create(h.prototype)).constructor = c, (p.prototype = Object.create(p.prototype)).constructor = p, (g.prototype = Object.create(h.prototype)).constructor = g, b;
});

},{}],"gRrQW":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _base = require("@emotion/styled/base");
var _baseDefault = parcelHelpers.interopDefault(_base);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _colors = require("../../../../constants/colors");
var _languageMultiSelector = require("./LanguageMultiSelector");
var _languageMultiSelectorDefault = parcelHelpers.interopDefault(_languageMultiSelector);
var _languageCard = require("./LanguageCard");
var _languageCardDefault = parcelHelpers.interopDefault(_languageCard);
var _horizontalSeparator = require("../../../../components/structure/HorizontalSeparator");
var _horizontalSeparatorDefault = parcelHelpers.interopDefault(_horizontalSeparator);
var _lodash = require("lodash");
var _lodashDefault = parcelHelpers.interopDefault(_lodash);
var _button = require("../../../../components/general/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _contentLanguageMultiSelector = require("../../../../components/forms/ContentLanguageMultiSelector");
var _contentLanguageMultiSelectorDefault = parcelHelpers.interopDefault(_contentLanguageMultiSelector);
var _toggleIndicator = require("../../../../components/general/ToggleIndicator");
var _toggleIndicatorDefault = parcelHelpers.interopDefault(_toggleIndicator);
var _languageContainer = require("../../../../hooks/LanguageContainer");
var _languageContainerDefault = parcelHelpers.interopDefault(_languageContainer);
var _interactionModelUiStateContainer = require("../../../../hooks/InteractionModelUiStateContainer");
var _interactionModelUiStateContainerDefault = parcelHelpers.interopDefault(_interactionModelUiStateContainer);
var _languageWarning = require("./LanguageWarning");
var _languageWarningDefault = parcelHelpers.interopDefault(_languageWarning);
var _customScrollbars = require("../../../../components/structure/CustomScrollbars");
var _customScrollbarsDefault = parcelHelpers.interopDefault(_customScrollbars);
var _confirmationDialog = require("../../../../components/structure/ConfirmationDialog");
var _confirmationDialogDefault = parcelHelpers.interopDefault(_confirmationDialog);
const LanguageSettings = (props)=>{
    const [isExpanded, setIsExpanded] = (0, _react1.useState)(false);
    const [showSyncConfirmation, setShowSyncConfirmation] = (0, _react1.useState)(false);
    const languagesContainer = (0, _languageContainerDefault.default).useContainer();
    const InteractionModelStateContainer = (0, _interactionModelUiStateContainerDefault.default).useContainer();
    (0, _react1.useEffect)(()=>{
        const app = props.appContainer.state.currentApp;
        const getLanguages = async ()=>{
            await languagesContainer.loadLanguages();
        };
        if (languagesContainer.languages.length < 1) getLanguages();
        const defaultLanguage = languagesContainer.languages.find((l)=>l.id == app.defaultLanguageId);
        const languages = defaultLanguage == null || props.clearSelection ? [] : [
            defaultLanguage
        ];
        languagesContainer.updateSelectedLanguages(languages);
    }, [
        props.appContainer.state.currentApp.defaultLanguageId
    ]);
    const toggleExpand = ()=>{
        setIsExpanded(!isExpanded);
    };
    const getAppLanguages = ()=>{
        const appLanguages = props.appContainer.state.currentApp.languages;
        return appLanguages;
    };
    const handleSelectedLanguages = (languageIds)=>{
        const appLanguages = getAppLanguages();
        const selectedLanguages = appLanguages.filter((al)=>languageIds.some((l)=>l == al.id));
        languagesContainer.updateSelectedLanguages(selectedLanguages);
    };
    const handleLanguageUpdate = (language, isSelected)=>{
        const appLanguages = getAppLanguages();
        if (isSelected) appLanguages.push(language);
        else (0, _lodashDefault.default).remove(appLanguages, (l)=>l.id == language.id);
        props.appContainer.updateApplicationLanguages(props.applicationId, appLanguages);
    };
    const handleDefaultLanguageChange = (languages)=>{
        if (languages && languages[0]) props.appContainer.updateApplicationDefaultLanguage(props.applicationId, languages[0].id);
        else props.appContainer.updateApplicationDefaultLanguage(props.applicationId, "");
    };
    function toggleShowSyncModal() {
        setShowSyncConfirmation(!showSyncConfirmation);
    }
    function handleEntitiesAndIntentsSync(languageIds, sourceLanguageId) {
        props.appContainer.syncNLPAndInteractionModel(props.applicationId, languageIds, sourceLanguageId);
    }
    const app = props.appContainer.state.currentApp;
    const appLanguages = getAppLanguages();
    const allLangs = (0, _lodashDefault.default).sortBy(languagesContainer.languages, (lang)=>lang.languageGroupCode != "en", (lang)=>lang.languageGroupCode, (lang)=>lang.supportedPlatforms == "*", (lang)=>lang.supportedPlatforms.length);
    var defaultLanguage = appLanguages.find((appLanguage)=>appLanguage.id === app.defaultLanguageId);
    const languagesToBeSynced = languagesContainer.currentSelectedLanguages.filter((l)=>l.id !== app.defaultLanguageId);
    const showSyncButton = languagesToBeSynced.length > 0;
    return (0, _react.jsx)(LanguageContainerDiv, null, (0, _react.jsx)("div", {
        className: "top-banner"
    }, (0, _react.jsx)("div", {
        className: "language-dropdown"
    }, (0, _react.jsx)((0, _languageMultiSelectorDefault.default), {
        languages: appLanguages,
        selectedLanguageIds: languagesContainer.currentSelectedLanguages.map((l)=>l.id),
        onChange: handleSelectedLanguages,
        warningRender: (0, _react.jsx)((0, _languageWarningDefault.default), {
            isDirty: InteractionModelStateContainer.isFormDirty,
            key: "language-warning"
        })
    })), (0, _react.jsx)((0, _buttonDefault.default), {
        themes: [
            "white",
            "end-tight"
        ],
        additionalClasses: "language-button",
        type: "button",
        text: "Language Settings",
        onClick: toggleExpand.bind(undefined),
        rightComponent: ()=>(0, _react.jsx)((0, _toggleIndicatorDefault.default), {
                direction: isExpanded ? "up" : "down"
            })
    })), isExpanded ? (0, _react.jsx)((0, _customScrollbarsDefault.default), null, showSyncButton && (0, _react.jsx)((0, _buttonDefault.default), {
        themes: [
            "primary-small",
            "end-tight"
        ],
        type: "button",
        additionalClasses: "language-button",
        text: `Sync ${languagesToBeSynced.map((l)=>l.shortCode).join(",")} with the default language: ${defaultLanguage.shortCode}`,
        onClick: toggleShowSyncModal,
        disabled: props.appContainer.state.isSyncingNLPAndInteractionModel,
        loading: props.appContainer.state.isSyncingNLPAndInteractionModel
    }), (0, _react.jsx)("div", {
        className: "language-settings"
    }, (0, _react.jsx)((0, _horizontalSeparatorDefault.default), null), (0, _react.jsx)("div", {
        className: "language-settings-header"
    }, (0, _react.jsx)("p", {
        className: "language-label"
    }, "Select the languages and regions you’d like to support."), (0, _react.jsx)((0, _contentLanguageMultiSelectorDefault.default), {
        isCollapsed: true,
        label: "Default:",
        languages: appLanguages,
        selectedLanguageIds: app.defaultLanguageId ? [
            app.defaultLanguageId
        ] : [],
        onChange: handleDefaultLanguageChange.bind(undefined)
    })), (0, _react.jsx)("div", {
        className: "language-container"
    }, allLangs.map((l)=>(0, _react.jsx)((0, _languageCardDefault.default), {
            key: l.id,
            language: l,
            onChange: handleLanguageUpdate.bind(undefined),
            isSelected: appLanguages.some((al)=>al.id == l.id)
        }))))) : null, showSyncConfirmation && (0, _react.jsx)((0, _confirmationDialogDefault.default), {
        title: "Sync NLP entities and intents",
        deleteText: "Yes, Close",
        warning: true,
        onClose: toggleShowSyncModal,
        onConfirm: ()=>{
            handleEntitiesAndIntentsSync(languagesToBeSynced.map((l)=>l.id), defaultLanguage.id);
            toggleShowSyncModal();
        }
    }, (0, _react.jsx)("div", {
        style: {
            padding: "30px"
        }
    }, (0, _react.jsx)("p", null, "This will copy and replace all entities and intents from ", defaultLanguage.shortCode, " to ", languagesToBeSynced.map((l)=>l.shortCode).join(","), "."), (0, _react.jsx)("p", null, "Are you sure you would like to proceed?"))));
};
const LanguageContainerDiv = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "es9lapi0"
})("background:", (0, _colors.shade_2_lighter), ";padding:12px 50px;border-bottom:solid 1px #c7cfd2;.sub-item{img{border-radius:50%;border:1px solid ", (0, _colors.cool_grey), ";}}.top-banner{display:flex;.language-dropdown{flex:1;margin-right:32px;}.language-button{margin-top:0;margin-bottom:0;font-family:Muli;font-size:14px;font-weight:600;font-stretch:normal;font-style:normal;line-height:normal;letter-spacing:0.31px;color:#2c3d52;height:45px;.toggle-indicator{margin-left:20px;margin-right:-20px;}}}.language-settings{margin-top:20px;.language-label{font-family:Muli;font-size:14px;font-weight:normal;font-stretch:normal;font-style:normal;line-height:normal;letter-spacing:normal;color:#2c3d52;margin:16px;}.language-container{display:flex;flex-wrap:wrap;}.language-settings-header{display:flex;align-items:center;.language-grouped-selector{margin-right:0;margin-left:auto;flex:0;}}}");
exports.default = LanguageSettings;

},{"@emotion/styled/base":"lSuFu","@emotion/react":"djZKr","react":"6uln9","../../../../constants/colors":"1p3OR","./LanguageMultiSelector":"kZWfm","./LanguageCard":"ktMpi","../../../../components/structure/HorizontalSeparator":"Pw3HQ","lodash":"3hMBK","../../../../components/general/Button":"6ymxN","../../../../components/forms/ContentLanguageMultiSelector":"4SbwP","../../../../components/general/ToggleIndicator":"4eej1","../../../../hooks/LanguageContainer":"lchkU","../../../../hooks/InteractionModelUiStateContainer":"2A95n","./LanguageWarning":"36r8s","../../../../components/structure/CustomScrollbars":"50vFq","../../../../components/structure/ConfirmationDialog":"kx7yK","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"kZWfm":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _languageCollectionAvatar = require("../../../../components/general/LanguageCollectionAvatar");
var _languageCollectionAvatarDefault = parcelHelpers.interopDefault(_languageCollectionAvatar);
var _languages = require("../../../../models/extensions/languages");
var _lodash = require("lodash");
var _lodashDefault = parcelHelpers.interopDefault(_lodash);
var _groupedMultiSelector = require("../../../../components/forms/GroupedMultiSelector");
var _groupedMultiSelectorDefault = parcelHelpers.interopDefault(_groupedMultiSelector);
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
class LanguageMultiSelector extends (0, _reactDefault.default).Component {
    constructor(props){
        super(props);
        this.state = {
            isExpanded: false
        };
    }
    handleChange(selectedIds) {
        this.props.onChange(selectedIds);
    }
    getLanguageGroups() {
        let dict = (0, _lodashDefault.default).groupBy(this.props.languages, (l)=>l.languageGroupCode);
        let groups = Object.keys(dict).map((key)=>({
                key: key,
                label: `${key.toUpperCase()} - ${(0, _languages.getLanguageName)(key)}`,
                subItems: dict[key].map((lang)=>({
                        data: lang,
                        value: lang.id,
                        icon: (0, _languages.getFlagIconForLanguage)(lang),
                        label: (0, _languages.getRegionyNameForLanguage)(lang),
                        groupKey: key,
                        isSelected: this.props.selectedLanguageIds.some((id)=>id == lang.id)
                    }))
            }));
        groups = (0, _lodashDefault.default).sortBy(groups, (group)=>group.key);
        if (this.props.warningRender) groups.unshift({
            key: "warning",
            label: `warning`,
            customRender: this.props.warningRender,
            subItems: []
        });
        return groups;
    }
    render() {
        const selectedLangs = this.props.languages.filter((l)=>this.props.selectedLanguageIds.some((id)=>id == l.id));
        return (0, _react.jsx)((0, _groupedMultiSelectorDefault.default), {
            label: this.props.label ?? "Languages:",
            groupToggle: groupToggleStyle,
            groups: this.getLanguageGroups(),
            onChange: this.handleChange.bind(this),
            selectedValues: this.props.selectedLanguageIds,
            withGroupSelection: true,
            restrictGroups: true,
            className: this.props.className,
            subItemCheckType: "check",
            position: "bottom",
            emptyText: "You must add at least one language to your application first.",
            innerSelectionRender: ()=>(0, _react.jsx)((0, _reactDefault.default).Fragment, null, (0, _react.jsx)((0, _languageCollectionAvatarDefault.default), {
                    languages: selectedLangs,
                    limit: 3
                }), (0, _react.jsx)("p", {
                    className: labelStyle
                }, selectedLangs.length > 0 ? selectedLangs.map((l)=>`${(0, _languages.getLanguageNameForLanguage)(l)} (${(0, _languages.getRegionyNameForLanguage)(l)})`).join(", ") : "Select a language"))
        });
    }
}
const groupToggleStyle = /*#__PURE__*/ (0, _css.css)({
    name: "173f3i6",
    styles: "margin-left:auto;margin-right:8px"
});
const labelStyle = /*#__PURE__*/ (0, _css.css)({
    name: "1qu8ll8",
    styles: "padding:0 8px"
});
exports.default = LanguageMultiSelector;

},{"@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","../../../../components/general/LanguageCollectionAvatar":"crbMk","../../../../models/extensions/languages":"8E5Oo","lodash":"3hMBK","../../../../components/forms/GroupedMultiSelector":"51iZT","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"ktMpi":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _checkIndicator = require("../../../../components/forms/CheckIndicator");
var _checkIndicatorDefault = parcelHelpers.interopDefault(_checkIndicator);
var _languages = require("../../../../models/extensions/languages");
var _colors = require("../../../../constants/colors");
const alexaIcon = require("8b3e484093883bef");
const cortanaIcon = require("7a0d5d590723cc9a");
const googleIcon = require("7593cf9dc0b07fe7");
const renderPlatformIcons = (platforms)=>{
    const icons = [];
    if (platforms == "*" || platforms.toLowerCase().indexOf("alexa") > -1) icons.push((0, _react.jsx)("img", {
        key: "alexa",
        src: alexaIcon
    }));
    if (platforms == "*" || platforms.toLowerCase().indexOf("googleassistant") > -1) icons.push((0, _react.jsx)("img", {
        key: "google",
        src: googleIcon
    }));
    if (platforms == "*" || platforms.toLowerCase().indexOf("cortana") > -1) icons.push((0, _react.jsx)("img", {
        key: "cortana",
        src: cortanaIcon
    }));
    return (0, _react.jsx)((0, _reactDefault.default).Fragment, null, icons);
};
const LanguageCard = (props)=>(0, _react.jsx)("div", {
        className: containerStyle,
        onClick: ()=>props.onChange(props.language, !props.isSelected)
    }, (0, _react.jsx)("div", {
        className: "inner-container"
    }, (0, _react.jsx)((0, _checkIndicatorDefault.default), {
        checked: props.isSelected
    }), (0, _react.jsx)("img", {
        className: "flag-icon",
        src: (0, _languages.getFlagIconForLanguage)(props.language)
    }), (0, _react.jsx)("p", {
        className: "language"
    }, `${(0, _languages.getLanguageNameForLanguage)(props.language)} (${(0, _languages.getRegionyNameForLanguage)(props.language)})`), (0, _react.jsx)("div", {
        className: "platform-support"
    }, renderPlatformIcons(props.language.supportedPlatforms))), (0, _react.jsx)("p", {
        className: "support-label"
    }, "SUPPORT:"));
const containerStyle = /*#__PURE__*/ (0, _css.css)("height:77px;border-radius:5px;box-shadow:0 2px 4px 0 rgba(48, 69, 98, 0.1);border:1px solid ", (0, _colors.silver_four), ";background:white;display:flex;justify-content:center;align-items:stretch;position:relative;padding:0 16px;margin:16px;width:calc(50% - 66px);cursor:pointer;.support-label{top:8px;right:16px;position:absolute;font-family:Muli;font-size:10px;font-weight:normal;font-stretch:normal;font-style:normal;line-height:normal;letter-spacing:normal;color:#8e97a1;}>.inner-container{display:flex;align-items:center;flex:1;.flag-icon{border:1px solid ", (0, _colors.cool_grey), ";border-radius:50%;}>.language{font-family:Muli;font-size:14px;font-weight:normal;font-stretch:normal;font-style:normal;line-height:normal;letter-spacing:normal;color:#304562;margin:0 16px;}>.platform-support{margin-right:0;margin-left:auto;border-left:1px solid ", (0, _colors.silver_four), ";display:flex;align-items:center;padding-left:8px;img{margin:0 4px;}}}", "");
exports.default = LanguageCard;

},{"@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","../../../../components/forms/CheckIndicator":"8zBm6","../../../../models/extensions/languages":"8E5Oo","../../../../constants/colors":"1p3OR","8b3e484093883bef":"3QQDI","7a0d5d590723cc9a":"lQLLX","7593cf9dc0b07fe7":"2bSwL","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3QQDI":[function(require,module,exports) {
module.exports = require("ba486a2c65bade33").getBundleURL("kVLro") + require("64ae1021c840c394").resolve("ed7oi");

},{"ba486a2c65bade33":"c7Tr5","64ae1021c840c394":"fyJL2"}],"lQLLX":[function(require,module,exports) {
module.exports = require("17304586e3c1a47f").getBundleURL("kVLro") + require("897eb023facbedde").resolve("59bFc");

},{"17304586e3c1a47f":"c7Tr5","897eb023facbedde":"fyJL2"}],"2bSwL":[function(require,module,exports) {
module.exports = require("3e093fb68458d161").getBundleURL("kVLro") + require("31007e8d9186bd93").resolve("oD39z");

},{"3e093fb68458d161":"c7Tr5","31007e8d9186bd93":"fyJL2"}],"36r8s":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _base = require("@emotion/styled/base");
var _baseDefault = parcelHelpers.interopDefault(_base);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _button = require("../../../../components/general/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _interactionModelUiStateContainer = require("../../../../hooks/InteractionModelUiStateContainer");
var _interactionModelUiStateContainerDefault = parcelHelpers.interopDefault(_interactionModelUiStateContainer);
var _colors = require("../../../../constants/colors");
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const warningIcon = require("7386b6fc3a363fd1");
const closeIcon = require("631c1791892b65c8");
const LanguageWarning = (props)=>{
    const [showWarning, setShowWarning] = (0, _react1.useState)(true);
    const InteractionModelStateContainer = (0, _interactionModelUiStateContainerDefault.default).useContainer();
    return (0, _react.jsx)((0, _reactDefault.default).Fragment, null, showWarning && props.isDirty ? (0, _react.jsx)(WarningDiv, null, (0, _react.jsx)(WarningIconImg, {
        src: warningIcon
    }), (0, _react.jsx)("p", null, "You have unsaved changes that may be lost if you change what langauge or region is displayed - "), (0, _react.jsx)(WarningSaveNow, {
        onClick: ()=>InteractionModelStateContainer.setTriggerSaveChanges(true)
    }, "Save Now"), (0, _react.jsx)((0, _buttonDefault.default), {
        themes: [
            "end-tight",
            "icon"
        ],
        icon: closeIcon,
        onClick: ()=>setShowWarning(false)
    })) : (0, _react.jsx)((0, _reactDefault.default).Fragment, null));
};
exports.default = LanguageWarning;
const WarningDiv = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "ek7bmap2"
})("cursor:pointer;display:flex;align-items:center;height:64px;padding:0 16px;border:1px solid ", (0, _colors.color_variants_gold_dark), ";background:", (0, _colors.color_variants_gold_light), ";border-radius:8px 8px 0px 0px;");
const WarningIconImg = /*#__PURE__*/ (0, _baseDefault.default)("img", {
    target: "ek7bmap1"
})({
    name: "13vjjlj",
    styles: "padding-right:8px"
});
const WarningSaveNow = /*#__PURE__*/ (0, _baseDefault.default)("span", {
    target: "ek7bmap0"
})("padding-left:4px;color:", (0, _colors.text_blue), ";");

},{"@emotion/styled/base":"lSuFu","@emotion/react":"djZKr","react":"6uln9","../../../../components/general/Button":"6ymxN","../../../../hooks/InteractionModelUiStateContainer":"2A95n","../../../../constants/colors":"1p3OR","7386b6fc3a363fd1":"TCjHN","631c1791892b65c8":"93VwA","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"TCjHN":[function(require,module,exports) {
module.exports = require("fa85df7da8d3db67").getBundleURL("kVLro") + require("1ff62ffa0196e56c").resolve("gWU2j");

},{"fa85df7da8d3db67":"c7Tr5","1ff62ffa0196e56c":"fyJL2"}],"ifLqC":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _base = require("@emotion/styled/base");
var _baseDefault = parcelHelpers.interopDefault(_base);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _moment = require("moment");
var _momentDefault = parcelHelpers.interopDefault(_moment);
var _colors = require("../../../constants/colors");
var _deploymentStatus = require("./DeploymentStatus");
var _deploymentStatusDefault = parcelHelpers.interopDefault(_deploymentStatus);
var _amazonDeploymentCard = require("./AmazonDeploymentCard");
var _amazonDeploymentCardDefault = parcelHelpers.interopDefault(_amazonDeploymentCard);
var _customScrollbars = require("../../../components/structure/CustomScrollbars");
var _customScrollbarsDefault = parcelHelpers.interopDefault(_customScrollbars);
var _dialogflowDeploymentCard = require("./DialogflowDeploymentCard");
var _dialogflowDeploymentCardDefault = parcelHelpers.interopDefault(_dialogflowDeploymentCard);
var _microsoftDeploymentCard = require("./MicrosoftDeploymentCard");
var _microsoftDeploymentCardDefault = parcelHelpers.interopDefault(_microsoftDeploymentCard);
var _lodash = require("lodash");
var _lodashDefault = parcelHelpers.interopDefault(_lodash);
var _loader = require("../../../components/general/Loader");
var _loaderDefault = parcelHelpers.interopDefault(_loader);
var _pageError = require("../../../components/general/PageError");
var _pageErrorDefault = parcelHelpers.interopDefault(_pageError);
var _dialogflowDeploymentContainer = require("../../../hooks/DialogflowDeploymentContainer");
var _dialogflowDeploymentContainerDefault = parcelHelpers.interopDefault(_dialogflowDeploymentContainer);
var _amazonDeploymentContainer = require("../../../hooks/AmazonDeploymentContainer");
var _amazonDeploymentContainerDefault = parcelHelpers.interopDefault(_amazonDeploymentContainer);
var _microsoftDeploymentContainer = require("../../../hooks/MicrosoftDeploymentContainer");
var _microsoftDeploymentContainerDefault = parcelHelpers.interopDefault(_microsoftDeploymentContainer);
var _customAssistantDeploymentCard = require("./customAssistantConfigurations/CustomAssistantDeploymentCard");
var _customAssistantDeploymentCardDefault = parcelHelpers.interopDefault(_customAssistantDeploymentCard);
var _deploymentsContainer = require("../../../hooks/DeploymentsContainer");
var _deploymentsContainerDefault = parcelHelpers.interopDefault(_deploymentsContainer);
var _telephonyDeploymentCard = require("./telephonyDeployments/TelephonyDeploymentCard");
var _telephonyDeploymentCardDefault = parcelHelpers.interopDefault(_telephonyDeploymentCard);
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const alexaIcon = require("db54fb0fa5e35e72");
const dialogflowIcon = require("da651a37f7154c28");
const botServiceIcon = require("279d033600502cf0");
const customChatIcon = require("3a6030db298587bc");
const telephonyIcon = require("75b890c2b3471ba4");
const bigLock = require("dfe23ebf1508d43a");
const smallLock = require("da0a463e3f3526f2");
// linked Application status icons
const waitingIcon = require("afc2bdd345d3fd11");
const failedIcon = require("af4d41a13c78187b");
const pendingReviewIcon = require("66eb451836e4f753");
const unknownReviewIcon = require("51303e3b35cc79ac");
const liveReviewIcon = require("8ff218a5ebabab03");
const livePendingReviewIcon = require("9311f8fd3071fd81");
const liveFailedReviewIcon = require("16bfd82f70ff16");
const readyIcon = require("405d130e36440d54");
const linkedIcon = require("f2ddfa08353d3d70");
const DeploymentsTab = (props)=>{
    const dialogflowDeploymentContainer = (0, _dialogflowDeploymentContainerDefault.default).useContainer();
    const amazonDeploymentContainer = (0, _amazonDeploymentContainerDefault.default).useContainer();
    const microsoftDeploymentContainer = (0, _microsoftDeploymentContainerDefault.default).useContainer();
    const deploymentsContainer = (0, _deploymentsContainerDefault.default).useContainer();
    const [environment, setEnvironment] = (0, _react1.useState)(null);
    const [endpoints, setEndpoints] = (0, _react1.useState)({});
    const [alexaLaunchMessage, setAlexaLaunchMessage] = (0, _react1.useState)("");
    const [loadingAlexaDeployment, setLoadingAlexaDeployment] = (0, _react1.useState)(false);
    const [alexaApplicationStatus, setAlexaApplicationStatus] = (0, _react1.useState)("UNKNOWN");
    const [relevantSkillCertification, setRelevantSkillCertification] = (0, _react1.useState)({});
    const [dialogflowApplicationStatus, setDialogflowApplicationStatus] = (0, _react1.useState)("UNKNOWN");
    const [loadingDialogflowDeployment, setLoadingDialogflowDeployment] = (0, _react1.useState)(false);
    const [dialogflowLaunchMessage, setDialogflowLaunchMessage] = (0, _react1.useState)("");
    const [botServiceApplicationStatus, setBotServiceApplicationStatus] = (0, _react1.useState)("UNKNOWN");
    // Load current user permissions
    (0, _react1.useEffect)(()=>{
        props.memberContainer.getMembers(props.orgContainer.state.currentOrganization.id);
        props.applicationMembersContainer.getMembersForApp(props.applicationId);
        props.orgContainer.getSystemRoles();
        if (props.userContainer.state.currentUser == null) props.userContainer.getUser();
    }, [
        props.applicationId
    ]);
    (0, _react1.useEffect)(()=>{
        if (props.applicationId && environment?.id) deploymentsContainer.waitForEnvironmentDeployment(props.applicationId, environment.id, true, true, true);
    }, [
        props.applicationId,
        environment
    ]);
    (0, _react1.useEffect)(()=>{
        loadEnvironmentDeployments();
    }, [
        props.applicationId,
        props.environmentOption
    ]);
    (0, _react1.useEffect)(()=>{
        loadAlexaDeploymentStatus();
    }, [
        amazonDeploymentContainer.currentSkillCertifications,
        amazonDeploymentContainer.availableSkills,
        amazonDeploymentContainer.linkedProjectId,
        deploymentsContainer?.status,
        amazonDeploymentContainer.status
    ]);
    (0, _react1.useEffect)(()=>{
        loadoadDialogflowDeploymentStatus();
    }, [
        dialogflowDeploymentContainer.linkedProjectId,
        deploymentsContainer?.status,
        dialogflowDeploymentContainer.status
    ]);
    (0, _react1.useEffect)(()=>{
        if (microsoftDeploymentContainer?.currentStep > 3) setBotServiceApplicationStatus("LINKED");
        else setBotServiceApplicationStatus("UNKNOWN");
    }, [
        microsoftDeploymentContainer.currentStep,
        props.environmentOption
    ]);
    const loadEnvironmentDeployments = async ()=>{
        // Get application environment based on selected environment option: Live or Draft
        const selectedEnvironment = await getEnvironmentByOption();
        // Clear old environment polling so we do not get stale statuses while waiting for interaction model to load selected environment
        await deploymentsContainer.setPollingEnvironment(props.applicationId, selectedEnvironment?.id);
        // Load application end points, check if selected environment option is Draft
        await loadEndpointsByOption();
    };
    const getEnvironmentByOption = async ()=>{
        await props.environmentsContainer.loadEnvironments(props.applicationId);
        if (!props.environmentOption) return;
        const selectedEnvironment = props.environmentsContainer.findEnvironmentByOption(props.applicationId, props.environmentOption);
        setEnvironment(selectedEnvironment);
        return selectedEnvironment;
    };
    const loadEndpointsByOption = async ()=>{
        let applicationEndpoints;
        // load application endpoints
        if (props.appContainer.state.applicationEndpoints && props.appContainer.state.applicationEndpoints.find((a)=>a.applicationId == props.applicationId)) // Not reference but a copy
        applicationEndpoints = {
            ...props.appContainer.state.applicationEndpoints.find((a)=>a.applicationId == props.applicationId)
        };
        else {
            const endpointsResult = await props.appContainer.getEndpoints(props.applicationId);
            applicationEndpoints = endpointsResult.data;
        }
        if (props.environmentOption === "draft") {
            //Append &useDraftContent=true to all Application's Fulfillment Endpoints for Draft environment
            const append = "&useDraftContent=true";
            applicationEndpoints.alexaEndpoint = applicationEndpoints.alexaEndpoint + append;
            applicationEndpoints.alexaProxyEndpoint = applicationEndpoints.alexaProxyEndpoint + append;
            applicationEndpoints.dialogFlowEndpoint = applicationEndpoints.dialogFlowEndpoint + append;
            applicationEndpoints.botServiceEndpoint = applicationEndpoints.botServiceEndpoint + append;
            applicationEndpoints.customAssistantEndpoint = applicationEndpoints.customAssistantEndpoint + append;
        }
        setEndpoints(applicationEndpoints);
    };
    const loadAlexaDeploymentStatus = async ()=>{
        if (amazonDeploymentContainer.status != "launch" && amazonDeploymentContainer.currentEnvironmentId == environment?.id) {
            setAlexaApplicationStatus("UNKNOWN");
            return;
        }
        const status = deploymentsContainer?.status;
        const hasQueuedDeployments = status?.queuedForDeploymentToPlatforms?.some((q)=>q.platform == "alexa");
        let deploymentResults = status?.latestDeploymentResults?.filter((r)=>r.platform == "alexa");
        deploymentResults = (0, _lodashDefault.default).orderBy(deploymentResults ?? [], (r)=>new Date(r.modifiedDate), [
            "desc"
        ]);
        const deploymentResult = deploymentResults?.length > 0 ? deploymentResults[0] : null;
        if (hasQueuedDeployments) {
            // if we're currently deploying this set waiting icon and show information about that deployment
            setLoadingAlexaDeployment(true);
            setAlexaApplicationStatus("WAITING");
            if (status?.queuedForDeploymentToPlatforms.some((q)=>q.platform == "alexa" && q.packageId)) setAlexaLaunchMessage("Skill created, importing skill package to Alexa");
            else setAlexaLaunchMessage("Your Voicify application is syncing with your Alexa skill");
        } else if (deploymentResult && deploymentResult.error) {
            // if there was an issue with a deployment we need to show the error.
            setAlexaLaunchMessage(deploymentResult.error);
            setAlexaApplicationStatus("DEPLOYMENT_ISSUE");
        } else if (loadingAlexaDeployment) {
            // if we were loading now we're done. Lets load info and clear the launch message.
            setAlexaLaunchMessage("");
            setLoadingAlexaDeployment(false);
            setAlexaApplicationStatus("READY");
            await amazonDeploymentContainer.loadEnvironmentDeploymentInformation(props.applicationId, environment?.id, props.orgContainer.state.currentOrganization.id);
        } else {
            // there's no current deployment or error lets check our current publication status
            let certifications = amazonDeploymentContainer.currentSkillCertifications;
            let skills = amazonDeploymentContainer.availableSkills;
            if (certifications.length > 0 && skills.length > 0) {
                // each version of a skill will show up as a different skill
                const currentSkills = skills.filter((s)=>s.skillId == amazonDeploymentContainer.linkedProjectId);
                if (currentSkills != null && currentSkills.length > 0) {
                    certifications.sort((a, b)=>(0, _momentDefault.default)(b.skillSubmissionTimestamp, "YYYY-MM-DDThh:mm").diff((0, _momentDefault.default)(a.skillSubmissionTimestamp, "YYYY-MM-DDThh:mm")));
                    const currentCertification = certifications[0];
                    const isLive = currentSkills.some((s)=>s.publicationStatus == "PUBLISHED");
                    setRelevantSkillCertification(currentCertification);
                    if (isLive) switch(currentCertification.status){
                        case "CANCELLED":
                            setAlexaApplicationStatus("LIVE");
                            break;
                        case "IN_PROGRESS":
                            setAlexaApplicationStatus("LIVE_PENDING_REVIEW");
                            break;
                        case "FAILED":
                            setAlexaApplicationStatus("LIVE_FAILED_REVIEW");
                            break;
                        case "SUCCEEDED":
                            setAlexaApplicationStatus("LIVE");
                            break;
                    }
                    else switch(currentCertification.status){
                        case "CANCELLED":
                            setAlexaApplicationStatus("READY");
                            break;
                        case "IN_PROGRESS":
                            setAlexaApplicationStatus("PENDING_REVIEW");
                            break;
                        case "FAILED":
                            setAlexaApplicationStatus("FAILED_REVIEW");
                            break;
                        case "SUCCEEDED":
                            setAlexaApplicationStatus("READY");
                            break;
                    }
                }
            } else if (amazonDeploymentContainer.linkedProjectId) setAlexaApplicationStatus("READY");
            else setAlexaApplicationStatus("UNKNOWN");
        }
    };
    const loadoadDialogflowDeploymentStatus = async ()=>{
        const status = deploymentsContainer?.status;
        const hasQueuedDeployments = status?.queuedForDeploymentToPlatforms?.some((q)=>q.platform == "dialogflow");
        let deploymentResults = status?.latestDeploymentResults?.filter((r)=>r.platform == "dialogflow");
        deploymentResults = (0, _lodashDefault.default).orderBy(deploymentResults ?? [], (r)=>new Date(r.modifiedDate), [
            "desc"
        ]);
        const deploymentResult = deploymentResults?.length > 0 ? deploymentResults[0] : null;
        if (hasQueuedDeployments) {
            setLoadingDialogflowDeployment(true);
            setDialogflowApplicationStatus("WAITING");
            setDialogflowLaunchMessage(null);
        } else if (deploymentResult && deploymentResult.error) {
            // if there was an issue with a deployment we need to show the error.
            setDialogflowLaunchMessage(deploymentResult.error);
            setDialogflowApplicationStatus("DEPLOYMENT_ISSUE");
            setLoadingDialogflowDeployment(false);
        } else {
            // we're not loading a deployment right now
            if (loadingDialogflowDeployment) {
                // if we were then load.
                setLoadingDialogflowDeployment(false);
                await dialogflowDeploymentContainer.loadEnvironmentDeploymentInformation(props.applicationId, environment?.id, props.orgContainer.state.currentOrganization.id);
            }
            if (dialogflowDeploymentContainer.linkedProjectId) {
                if (dialogflowDeploymentContainer.status == "finished") setDialogflowApplicationStatus("LINKED");
            } else setDialogflowApplicationStatus("UNKNOWN");
            setDialogflowLaunchMessage(null);
        }
    };
    const getApplicationStatusIcon = (status)=>{
        switch(status){
            case "WAITING":
                return waitingIcon;
            case "FAILED_REVIEW":
                return failedIcon;
            case "PENDING_REVIEW":
                return pendingReviewIcon;
            case "LIVE":
                return liveReviewIcon;
            case "LIVE_PENDING_REVIEW":
                return livePendingReviewIcon;
            case "LIVE_FAILED_REVIEW":
                return liveFailedReviewIcon;
            case "READY":
                return readyIcon;
            case "LINKED":
                return linkedIcon;
            case "DEPLOYMENT_ISSUE":
                return failedIcon;
            default:
                return unknownReviewIcon;
        }
    };
    const isCurrentUserAdmin = ()=>{
        const members = props.applicationMembersContainer.state.members.filter((m)=>m.applicationId == props.applicationId);
        const userId = props.userContainer.state.currentUser.id;
        var isAdmin = false;
        const member = members.find((m)=>m.organizationMember.userId == userId && m.applicationId == props.applicationId);
        if (member !== undefined) isAdmin = member.isAdmin || member.organizationMember.isAdmin;
        else {
            const organizationMember = props.memberContainer.state.members.find((m)=>m.userId == userId);
            if (organizationMember) isAdmin = organizationMember.isAdmin;
        }
        return isAdmin;
    };
    if (props.applicationMembersContainer.state.isLoadingMembers || props.userContainer.state.currentUser == null || props.environmentsContainer.state.isLoading || // wait for environment to get set
    environment == null) return (0, _react.jsx)(CenterDiv, null, (0, _react.jsx)((0, _loaderDefault.default), null));
    else if (!isCurrentUserAdmin()) return (0, _react.jsx)(StripedBackground, null, (0, _react.jsx)("img", {
        className: "big-lock",
        src: bigLock
    }), (0, _react.jsx)(PermissionMessage, null, (0, _react.jsx)("img", {
        src: smallLock
    }), (0, _react.jsx)("p", null, "You don't have permission to view this page")));
    else return (0, _react.jsx)(DeploymentsBody, {
        className: darkTabStyle
    }, (0, _react.jsx)(StatusPanel, null, (0, _react.jsx)((0, _deploymentStatusDefault.default), {
        href: "#custom-assistant-card",
        platform: "Custom Assistant",
        platformIcon: customChatIcon
    }), (0, _react.jsx)((0, _deploymentStatusDefault.default), {
        href: "#telephony-card",
        platform: "Telephony",
        platformIcon: telephonyIcon
    }), (0, _react.jsx)((0, _deploymentStatusDefault.default), {
        href: "#alexa-card",
        platform: "Amazon Alexa",
        platformIcon: alexaIcon,
        statusIcon: getApplicationStatusIcon(alexaApplicationStatus)
    }), (0, _react.jsx)((0, _deploymentStatusDefault.default), {
        href: "#dialogflow-card",
        platform: "Dialogflow",
        platformIcon: dialogflowIcon,
        statusIcon: getApplicationStatusIcon(dialogflowApplicationStatus)
    }), (0, _react.jsx)((0, _deploymentStatusDefault.default), {
        href: "#bot-service-card",
        platform: "Azure Bot Service",
        platformIcon: botServiceIcon,
        statusIcon: getApplicationStatusIcon(botServiceApplicationStatus)
    })), (0, _react.jsx)(DeploymentsPageContainer, null, (0, _react.jsx)((0, _customScrollbarsDefault.default), null, (0, _react.jsx)((0, _customAssistantDeploymentCardDefault.default), {
        endpoints: endpoints,
        appContainer: props.appContainer,
        applicationId: props.applicationId,
        environmentId: environment?.id,
        mediaContainer: props.mediaContainer
    }), (0, _react.jsx)((0, _telephonyDeploymentCardDefault.default), {
        applicationId: props.applicationId,
        environmentId: environment?.id,
        appContainer: props.appContainer
    }), (0, _react.jsx)((0, _amazonDeploymentCardDefault.default), {
        appContainer: props.appContainer,
        applicationId: props.applicationId,
        endpoints: endpoints,
        organizationId: props.orgContainer.state.currentOrganization.id,
        applicationStatus: alexaApplicationStatus,
        applicationStatusIcon: getApplicationStatusIcon(alexaApplicationStatus),
        certificationSummary: relevantSkillCertification,
        launchMessage: alexaLaunchMessage,
        environmentId: environment?.id
    }), (0, _react.jsx)((0, _dialogflowDeploymentCardDefault.default), {
        applicationStatusIcon: getApplicationStatusIcon(dialogflowApplicationStatus),
        endpoints: endpoints,
        organizationId: props.orgContainer.state.currentOrganization.id,
        applicationId: props.applicationId,
        applicationStatus: dialogflowApplicationStatus,
        launchMessage: dialogflowLaunchMessage,
        environmentId: environment?.id
    }), (0, _react.jsx)((0, _microsoftDeploymentCardDefault.default), {
        organizationId: props.orgContainer.state.currentOrganization.id,
        applicationId: props.applicationId,
        applicationStatusIcon: getApplicationStatusIcon(botServiceApplicationStatus),
        endpoints: endpoints,
        environmentId: environment?.id
    }))), (0, _react.jsx)((0, _pageErrorDefault.default), {
        errors: [
            ...props.appContainer?.state?.errors ?? [],
            ...deploymentsContainer?.errors ?? []
        ],
        onClear: ()=>{
            props.appContainer?.clearErrors();
            deploymentsContainer?.clearErrors();
        }
    }));
};
const StripedBackground = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e15d6v825"
})("height:100%;width:100%;display:flex;align-items:center;justify-content:center;background:repeating-linear-gradient(\n    -45deg,\n    ", (0, _colors.color_shades_lighter), " -11px,\n    ", (0, _colors.color_shades_lighter), " 28px,\n    ", (0, _colors.color_defaults_white), " 10px,\n    ", (0, _colors.color_defaults_white), " 56px\n  );img{&.big-lock{margin-bottom:110px;}}");
const CenterDiv = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e15d6v824"
})({
    name: "16k86jb",
    styles: "height:100%;width:100%;display:flex;align-items:center;justify-content:center"
});
const PermissionMessage = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e15d6v823"
})("position:fixed;bottom:0;left:0;right:0;height:56px;background-color:", (0, _colors.color_shades_darker), ";padding-left:24px;display:flex;align-items:center;p{font-size:14px;margin-left:12px;color:", (0, _colors.color_defaults_white), ";}");
const darkTabStyle = /*#__PURE__*/ (0, _css.css)("background:", (0, _colors.shade_2_lighter), ";display:flex;flex-direction:row;", "");
const StatusPanel = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e15d6v822"
})("width:288px;background:white;border-right:1px solid ", (0, _colors.color_shades_dark), ";");
const DeploymentsBody = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e15d6v821"
})({
    name: "1d3w5wq",
    styles: "width:100%"
});
const DeploymentsPageContainer = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e15d6v820"
})({
    name: "1qdywoz",
    styles: "padding:0px;flex:1;height:calc(100vh - 136px)"
});
exports.default = DeploymentsTab;

},{"@emotion/styled/base":"lSuFu","@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","moment":"2meyw","../../../constants/colors":"1p3OR","./DeploymentStatus":"gqlKy","./AmazonDeploymentCard":"D0hyq","../../../components/structure/CustomScrollbars":"50vFq","./DialogflowDeploymentCard":"dGxYk","./MicrosoftDeploymentCard":"ledij","lodash":"3hMBK","../../../components/general/Loader":"bnV5T","../../../components/general/PageError":"ezFTm","../../../hooks/DialogflowDeploymentContainer":"aCLZk","../../../hooks/AmazonDeploymentContainer":"bZJPl","../../../hooks/MicrosoftDeploymentContainer":"aIoVz","./customAssistantConfigurations/CustomAssistantDeploymentCard":"7hu17","../../../hooks/DeploymentsContainer":"54k9j","./telephonyDeployments/TelephonyDeploymentCard":"cEsfB","db54fb0fa5e35e72":"3QQDI","da651a37f7154c28":"gPHJM","279d033600502cf0":"g0Elm","3a6030db298587bc":"a0DXf","75b890c2b3471ba4":"fitEs","dfe23ebf1508d43a":"02NtP","da0a463e3f3526f2":"hS08u","afc2bdd345d3fd11":"lhK3e","af4d41a13c78187b":"5riL7","66eb451836e4f753":"1IRBB","51303e3b35cc79ac":"bFn5N","8ff218a5ebabab03":"5JN9L","9311f8fd3071fd81":"5D0ds","16bfd82f70ff16":"bHRRK","405d130e36440d54":"knnkL","f2ddfa08353d3d70":"932G9","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"gqlKy":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _base = require("@emotion/styled/base");
var _baseDefault = parcelHelpers.interopDefault(_base);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _colors = require("../../../constants/colors");
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
function DeploymentStatus(props) {
    return (0, _react.jsx)(StyleContainer, {
        href: props.href
    }, (0, _react.jsx)(PlatformIcon, {
        src: props.platformIcon
    }), (0, _react.jsx)(PlatformText, null, props.platform), (0, _react.jsx)(PlatformStatus, {
        src: props.statusIcon
    }));
}
const StyleContainer = /*#__PURE__*/ (0, _baseDefault.default)("a", {
    target: "e1r2rab43"
})("color:", (0, _colors.color_text_default), ";display:flex;margin:24px 24px 0px 24px;");
const PlatformIcon = /*#__PURE__*/ (0, _baseDefault.default)("img", {
    target: "e1r2rab42"
})({
    name: "trk3cg",
    styles: "margin-right:12px;width:24px"
});
const PlatformText = /*#__PURE__*/ (0, _baseDefault.default)("p", {
    target: "e1r2rab41"
})({
    name: "1hm0csn",
    styles: "font-size:14px;font-weight:400;line-height:20px;letter-spacing:0em;text-align:left"
});
const PlatformStatus = /*#__PURE__*/ (0, _baseDefault.default)("img", {
    target: "e1r2rab40"
})({
    name: "1o3nkn",
    styles: "margin-left:auto"
});
exports.default = DeploymentStatus;

},{"@emotion/styled/base":"lSuFu","@emotion/react":"djZKr","react":"6uln9","../../../constants/colors":"1p3OR","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"D0hyq":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _base = require("@emotion/styled/base");
var _baseDefault = parcelHelpers.interopDefault(_base);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _radioGroup = require("../../../components/forms/RadioGroup");
var _radioGroupDefault = parcelHelpers.interopDefault(_radioGroup);
var _button = require("../../../components/general/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _pageError = require("../../../components/general/PageError");
var _pageErrorDefault = parcelHelpers.interopDefault(_pageError);
var _deploymentWorkflowStep = require("./DeploymentWorkflowStep");
var _deploymentWorkflowStepDefault = parcelHelpers.interopDefault(_deploymentWorkflowStep);
var _loader = require("../../../components/general/Loader");
var _loaderDefault = parcelHelpers.interopDefault(_loader);
var _modalLayout = require("../../../components/structure/ModalLayout");
var _modalLayoutDefault = parcelHelpers.interopDefault(_modalLayout);
var _pageContainer = require("../../../components/structure/PageContainer");
var _pageContainerDefault = parcelHelpers.interopDefault(_pageContainer);
var _horizontalContainer = require("../../../components/structure/HorizontalContainer");
var _horizontalContainerDefault = parcelHelpers.interopDefault(_horizontalContainer);
var _modalTitle = require("../../../components/general/ModalTitle");
var _modalTitleDefault = parcelHelpers.interopDefault(_modalTitle);
var _horizontalSeparator = require("../../../components/structure/HorizontalSeparator");
var _horizontalSeparatorDefault = parcelHelpers.interopDefault(_horizontalSeparator);
var _footerBar = require("../../../components/structure/FooterBar");
var _footerBarDefault = parcelHelpers.interopDefault(_footerBar);
var _selectField = require("../../../components/forms/SelectField");
var _selectFieldDefault = parcelHelpers.interopDefault(_selectField);
var _css = require("@emotion/css");
var _textField = require("../../../components/forms/TextField");
var _textFieldDefault = parcelHelpers.interopDefault(_textField);
var _sharedStyledComponents = require("./SharedStyledComponents");
var _amazonDeploymentContainer = require("../../../hooks/AmazonDeploymentContainer");
var _amazonDeploymentContainerDefault = parcelHelpers.interopDefault(_amazonDeploymentContainer);
var _deploymentsContainer = require("../../../hooks/DeploymentsContainer");
var _deploymentsContainerDefault = parcelHelpers.interopDefault(_deploymentsContainer);
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const amazonLogo = require("3802672f6d299ec4");
const amazonButton = require("d51bc6ae95ce7212");
const linkOutIcon = require("232362a6ac5e2837");
const closeIcon = require("ce1005ae23462965");
const endpointButtonIconActive = require("27b0b2c8d5981d1f");
const endpointButtonIconInactive = require("eec5d858b860f2d6");
const AmazonDeploymentCard = (props)=>{
    const amazonContainer = (0, _amazonDeploymentContainerDefault.default).useContainer();
    const deploymentsContainer = (0, _deploymentsContainerDefault.default).useContainer();
    const [loaded, setLoaded] = (0, _react1.useState)(false);
    const [showEndpoints, setShowEndpoints] = (0, _react1.useState)(false);
    const [primaryButtonLoading, setPrimaryButtonLoading] = (0, _react1.useState)(false);
    const [currentVendorId, setCurrentVendorId] = (0, _react1.useState)(null);
    const [vendorLoading, setVendorLoading] = (0, _react1.useState)(false);
    const [showVendorModal, setShowVendorModal] = (0, _react1.useState)(false);
    const [workflowStep, setWorkflowStep] = (0, _react1.useState)(1);
    (0, _react1.useEffect)(()=>{
        const loadAsync = async ()=>{
            setLoaded(false);
            // load Amazon deployment stuff per environment
            await amazonContainer.loadEnvironmentDeploymentInformation(props.applicationId, props.environmentId, props.organizationId);
            setLoaded(true);
        };
        loadAsync();
        const cleanUp = ()=>{
            amazonContainer.reset();
        };
        // When exactly does React clean up an effect? 
        // React performs the cleanup when the component unmounts.  
        // However, effects run for every render and not just once. 
        // This is why React also cleans up effects from the previous render before running the effects next time. 
        return cleanUp;
    }, [
        props.applicationId,
        props.environmentId,
        props.organizationId
    ]);
    (0, _react1.useEffect)(()=>{
        switch(amazonContainer.status){
            case "linkingAccount":
                setWorkflowStep(1);
                break;
            case "selectingVendor":
                setWorkflowStep(1);
                break;
            case "linkingSkill":
                setWorkflowStep(2);
                break;
            case "launch":
                setWorkflowStep(3);
                break;
        }
    }, [
        amazonContainer.status
    ]);
    (0, _react1.useEffect)(()=>{
        if (amazonContainer.vendors?.length != 0) {
            if (amazonContainer.status == "selectingVendor") {
                if (amazonContainer.vendors?.length == 1) {
                    const vendorId = amazonContainer.vendors[0].id;
                    linkVendor(vendorId);
                } else setShowVendorModal(true);
            }
        }
    }, [
        amazonContainer.status
    ]);
    const handleDisconnectSkill = async ()=>{
        await setLoaded(false);
        await amazonContainer.unlinkEnvironmentSkill(props.applicationId, props.environmentId);
        await amazonContainer.setLinkingStatus("linkingSkill");
        await amazonContainer.setAccountNewOrExisting("new");
        await deploymentsContainer.loadInteractionModelEnvironmentStatus(props.applicationId, props.environmentId);
        await deploymentsContainer.stopWaitingForAlexaDeployment();
        await setLoaded(true);
    };
    const handleDisconnectAccount = async ()=>{
        await setLoaded(false);
        await amazonContainer.unlinkEnvironmentUserAccount(props.applicationId, props.environmentId);
        await amazonContainer.unlinkEnvironmentVendor(props.applicationId, props.environmentId);
        await amazonContainer.setVendorId(null);
        await setCurrentVendorId(null);
        await amazonContainer.setLinkingStatus("linkingAccount");
        await amazonContainer.getEnvironmentDeploymentStatus(props.applicationId, props.environmentId);
        await deploymentsContainer.loadInteractionModelEnvironmentStatus(props.applicationId, props.environmentId);
        await deploymentsContainer.stopWaitingForAlexaDeployment();
        await setLoaded(true);
    };
    const handleChangeVendor = async ()=>{
        await setCurrentVendorId(null);
        await amazonContainer.setLinkingStatus("selectingVendor");
        await setShowVendorModal(true);
    };
    const handleSelectionChange = (option)=>{
        amazonContainer.setAccountNewOrExisting(option.value);
    };
    const handleAccountSelectionChange = (newValue)=>{
        if (!newValue) return;
        amazonContainer.setAccountNewOrExisting("existing").then(()=>amazonContainer.setAccountToLink(newValue.value, newValue.label));
    };
    const isMainButtonDisabled = ()=>{
        if (workflowStep == 1 && !amazonContainer.tokenId) return true;
        if (amazonContainer.status == "selectingVendor") return true;
        if (workflowStep == 2 && amazonContainer.createNew == "existing" && !amazonContainer.linkedProjectId) return true;
        return false;
    };
    const renderMainButton = ()=>{
        if (workflowStep == 1) {
            if (amazonContainer.accountSelection == "new") return (0, _react.jsx)((0, _sharedStyledComponents.LoginImage), {
                className: "ac-amazon-login-button",
                src: amazonButton,
                onClick: linkNewAccount
            });
        } else if (workflowStep == 3) return (0, _react.jsx)("a", {
            href: "https://developer.amazon.com/alexa/console/ask?#",
            target: "_blank"
        }, (0, _react.jsx)((0, _sharedStyledComponents.MainButton), {
            className: "ac-amazon-developer-console",
            loading: primaryButtonLoading,
            disabled: primaryButtonLoading,
            themes: [
                "primary",
                "wide"
            ],
            text: "Developer Console",
            type: "button",
            rightIcon: linkOutIcon,
            onClick: handleMainButton
        }));
        return (0, _react.jsx)((0, _sharedStyledComponents.MainButton), {
            className: "ac-amazon-link-button",
            loading: primaryButtonLoading,
            disabled: primaryButtonLoading || isMainButtonDisabled(),
            themes: [
                "primary",
                "wide"
            ],
            text: "Link",
            type: "button",
            onClick: handleMainButton
        });
    };
    const handleMainButton = async ()=>{
        setPrimaryButtonLoading(true);
        switch(amazonContainer.status){
            case "linkingAccount":
                await handleAccountLink();
                break;
            case "linkingSkill":
                await handleSkillLink();
                break;
        }
        setPrimaryButtonLoading(false);
    };
    const handleAccountLink = async ()=>{
        switch(amazonContainer.accountSelection){
            case "new":
                await linkNewAccount();
                break;
            case "existing":
                await linkExistingAccount();
                break;
        }
    };
    const linkExistingAccount = async ()=>{
        if (!amazonContainer.tokenId) return;
        //Clear skill linkedProjectId
        await amazonContainer.setDeployToApp("");
        const linkTokenResult = await amazonContainer.linkTokenToEnvironment(props.applicationId, props.environmentId, amazonContainer.tokenId);
        if (linkTokenResult && linkTokenResult.data) {
            const vendorsResult = await amazonContainer.getEnvironmentVendors(props.applicationId, props.environmentId);
            //Auto select a vendor if there is only one
            if (vendorsResult && vendorsResult.data) await amazonContainer.setLinkingStatus("selectingVendor");
        }
    };
    const linkVendor = async (vendorId)=>{
        await setVendorLoading(true);
        await amazonContainer.linkEnvironmentVendor(props.applicationId, props.environmentId, vendorId);
        await amazonContainer.setLinkingStatus("linkingSkill");
        await amazonContainer.getSkills(amazonContainer.vendorId, amazonContainer.tokenId);
        await setVendorLoading(false);
        setShowVendorModal(false);
    };
    const handleSkillLink = async ()=>{
        if (!amazonContainer.linkedProjectId && amazonContainer.createNew !== "new") return;
        await amazonContainer.setLinkingStatus("launch");
        if (amazonContainer.createNew == "new") await amazonContainer.createAndDeployEnvironmentNewSkill(props.applicationId, props.environmentId);
        else await amazonContainer.linkEnvironment(props.applicationId, props.environmentId, amazonContainer.linkedProjectId);
        await deploymentsContainer.waitForEnvironmentDeployment(props.applicationId, props.environmentId, true, false, false);
    };
    const handleDeployToAppSelectionChange = async (option)=>{
        //Set selected skill linkedProjectId
        await option && amazonContainer.setDeployToApp(option.value);
    };
    const handleDeployToAppTextFieldChange = async (fieldValue)=>{
        //Set specified skill linkedProjectId
        await fieldValue && amazonContainer.setDeployToApp(fieldValue);
    };
    const handleCreateNewSkillSelectionChange = async (newValue)=>{
        if (!newValue) return;
        //Clear skill linkedProjectId first
        await amazonContainer.setDeployToApp("");
        await amazonContainer.setCreateNewSkill(newValue.value);
    };
    const linkNewAccount = async ()=>{
        //openAuthWindow
        const request = {
            applicationId: props.applicationId,
            environmentId: props.environmentId
        };
        const urlResult = await amazonContainer.getAuthUrl(request);
        if (urlResult) window.open(urlResult.data, "_self");
    };
    const handleVendorSelectionChange = async (newValue)=>{
        if (!newValue?.value) return;
        await amazonContainer.setVendorId(newValue.value);
    };
    const handleSelectVendor = async ()=>{
        const vendorId = amazonContainer.vendorId ?? amazonContainer?.vendors[0]?.id;
        await amazonContainer.unlinkEnvironmentVendor(props.applicationId, props.environmentId);
        await linkVendor(vendorId);
        await setCurrentVendorId(vendorId);
        await amazonContainer.setLinkingStatus("linkingSkill");
    };
    const handleCloseVendorModal = async ()=>{
        if (currentVendorId) await amazonContainer.setVendorId(currentVendorId);
        await setShowVendorModal(false);
    };
    const vendorName = amazonContainer.vendors?.length ? amazonContainer.vendors.filter((a)=>a.id == amazonContainer.vendorId).map((v)=>v.name)[0] : null;
    const appName = amazonContainer.availableApps?.length ? amazonContainer.availableApps.filter((a)=>a.id == amazonContainer.linkedProjectId).map((a)=>a.name)[0] : null;
    let appNameOrPlaceholderText = appName;
    if (!appNameOrPlaceholderText) {
        if (amazonContainer.linkedProjectId) appNameOrPlaceholderText = amazonContainer.linkedProjectId;
        else if (amazonContainer.loadingAvailableApps) appNameOrPlaceholderText = "Loading ...";
        else appNameOrPlaceholderText = "[deleted]";
    }
    const renderStep1 = ()=>{
        if (amazonContainer.status == "linkingAccount") return (0, _react.jsx)((0, _sharedStyledComponents.DeploymentStep), null, (0, _react.jsx)((0, _sharedStyledComponents.StepHeader), null, (0, _react.jsx)((0, _sharedStyledComponents.StepNumber), {
            className: "ac-amazon-step-1"
        }, "1"), (0, _react.jsx)("div", null, "Connect Account")), (0, _react.jsx)((0, _radioGroupDefault.default), {
            options: [
                {
                    value: "new",
                    label: "Connect a new account"
                },
                {
                    value: "existing",
                    label: "Connect an existing account"
                }
            ],
            onChange: handleSelectionChange,
            value: amazonContainer.accountSelection || (amazonContainer.userName ? "existing" : "new")
        }), (0, _react.jsx)((0, _sharedStyledComponents.DeploymentSelector), {
            useFormTheme: true,
            useForm: false,
            options: amazonContainer.availableCredentials.map((c)=>({
                    label: c.userName,
                    value: c.id
                })),
            disabled: amazonContainer.accountSelection === "new",
            value: amazonContainer.tokenId,
            onBlur: ()=>{},
            onChange: handleAccountSelectionChange,
            label: "Account",
            name: "existingDeploymentAccount"
        }));
        else if (amazonContainer.status == "selectingVendor") return (0, _react.jsx)((0, _sharedStyledComponents.LinkedAccount), null, (0, _react.jsx)((0, _sharedStyledComponents.StepHeader), null, (0, _react.jsx)((0, _sharedStyledComponents.StepNumber), null, "1"), (0, _react.jsx)("div", null, "Connect Account")), (0, _react.jsx)((0, _sharedStyledComponents.LabelAndButtonRow), null, (0, _react.jsx)((0, _sharedStyledComponents.LabeledText), null, (0, _react.jsx)("span", null, "Account"), (0, _react.jsx)("p", null, amazonContainer.userName)), (0, _react.jsx)((0, _sharedStyledComponents.Filler), null), (0, _react.jsx)((0, _sharedStyledComponents.AlternateButton), {
            themes: [
                "secondary-small"
            ],
            text: "Disconnect",
            onClick: handleDisconnectAccount
        })), (0, _react.jsx)((0, _sharedStyledComponents.LabelAndButtonRow), null, (0, _react.jsx)((0, _sharedStyledComponents.LabeledText), null, (0, _react.jsx)("span", null, "Vendor"), (0, _react.jsx)("p", null, currentVendorId ? amazonContainer.vendors.filter((a)=>a.id == currentVendorId).map((v)=>v.name)[0] : "Select a vendor")), (0, _react.jsx)((0, _sharedStyledComponents.Filler), null), amazonContainer.vendors.length > 1 && (0, _react.jsx)((0, _sharedStyledComponents.AlternateButton), {
            themes: [
                "secondary-small"
            ],
            text: "Change",
            onClick: handleChangeVendor
        })));
        else return (0, _react.jsx)((0, _sharedStyledComponents.LinkedAccount), null, (0, _react.jsx)((0, _sharedStyledComponents.StepHeader), null, (0, _react.jsx)((0, _sharedStyledComponents.StepNumber), null, "1"), (0, _react.jsx)("div", null, "Connect Account")), (0, _react.jsx)((0, _sharedStyledComponents.LabelAndButtonRow), null, (0, _react.jsx)((0, _sharedStyledComponents.LabeledText), null, (0, _react.jsx)("span", null, "Account"), (0, _react.jsx)("p", null, amazonContainer.userName)), (0, _react.jsx)((0, _sharedStyledComponents.Filler), null), (0, _react.jsx)((0, _sharedStyledComponents.AlternateButton), {
            themes: [
                "secondary-small"
            ],
            text: "Disconnect",
            onClick: handleDisconnectAccount
        })), (0, _react.jsx)((0, _sharedStyledComponents.LabelAndButtonRow), null, (0, _react.jsx)((0, _sharedStyledComponents.LabeledText), null, (0, _react.jsx)("span", null, "Vendor"), (0, _react.jsx)("p", null, vendorName)), (0, _react.jsx)((0, _sharedStyledComponents.Filler), null), amazonContainer.vendors.length > 1 && (0, _react.jsx)((0, _sharedStyledComponents.AlternateButton), {
            themes: [
                "secondary-small"
            ],
            text: "Change",
            onClick: handleChangeVendor
        })));
    };
    const renderStep2 = ()=>{
        if (amazonContainer.status == "linkingSkill") return (0, _react.jsx)((0, _sharedStyledComponents.DeploymentStep), null, (0, _react.jsx)((0, _sharedStyledComponents.StepHeader), null, (0, _react.jsx)((0, _sharedStyledComponents.StepNumber), {
            className: "ac-amazon-step-2"
        }, "2"), (0, _react.jsx)("div", null, "Link Skill")), (0, _react.jsx)((0, _radioGroupDefault.default), {
            options: [
                {
                    value: "new",
                    label: "Create a new skill"
                },
                {
                    value: "existing",
                    label: "Connect to an existing skill"
                }
            ],
            onChange: handleCreateNewSkillSelectionChange.bind(undefined),
            value: amazonContainer.createNew || "new"
        }), // we stop loading if we get 100 alexa skills to avoid throttling.
        // If they have less than 100 we let them choose otherwise we ask for a pasted skill ID.
        amazonContainer.availableApps && amazonContainer.availableApps.length < 100 ? (0, _react.jsx)((0, _sharedStyledComponents.DeploymentSelector), {
            useFormTheme: true,
            useForm: false,
            options: amazonContainer.availableApps.map((a)=>({
                    value: a.id,
                    label: a.name
                })),
            disabled: amazonContainer.createNew == "new",
            value: amazonContainer.linkedProjectId,
            onBlur: ()=>{},
            onChange: handleDeployToAppSelectionChange.bind(undefined),
            name: "deployToApp",
            label: "Skill"
        }) : (0, _react.jsx)((0, _textFieldDefault.default), {
            useForm: false,
            label: "Skill ID",
            disabled: amazonContainer.createNew == "new",
            placeholder: "Paste your skill ID here",
            value: amazonContainer.linkedProjectId,
            onChange: (e)=>handleDeployToAppTextFieldChange(e.target.value)
        }));
        else return (0, _react.jsx)((0, _sharedStyledComponents.DeploymentStep), null, (0, _react.jsx)((0, _sharedStyledComponents.StepHeader), null, (0, _react.jsx)((0, _sharedStyledComponents.StepNumber), null, "2"), (0, _react.jsx)("div", null, "Link Skill")), (0, _react.jsx)((0, _sharedStyledComponents.LabelAndButtonRow), null, (0, _react.jsx)((0, _sharedStyledComponents.LabeledText), null, (0, _react.jsx)("span", null, "Skill"), (0, _react.jsx)("p", null, appNameOrPlaceholderText)), (0, _react.jsx)((0, _sharedStyledComponents.Filler), null), (0, _react.jsx)((0, _sharedStyledComponents.AlternateButton), {
            themes: [
                "secondary-small"
            ],
            text: "Disconnect",
            onClick: handleDisconnectSkill
        })));
    };
    const copyText = (text)=>{
        navigator.clipboard.writeText(text);
    };
    const getApplicationStatusText = ()=>{
        switch(props.applicationStatus){
            case "WAITING":
                return "Please wait...";
            case "FAILED_REVIEW":
                return "Failed skill review";
            case "DEPLOYMENT_ISSUE":
                return "There was an problem deploying your application to Alexa";
            case "PENDING_REVIEW":
                return "Pending skill review and approval";
            case "LIVE":
                return "Live";
            case "LIVE_PENDING_REVIEW":
                return "Skill update pending review";
            case "LIVE_FAILED_REVIEW":
                return "Skill update failed review";
            case "READY":
                return "Ready";
            default:
                return "Unknown";
        }
    };
    const getAdditionalStatusText = ()=>{
        switch(props.applicationStatus){
            case "WAITING":
                return "Your Voicify application is syncing with your Alexa skill";
            case "FAILED_REVIEW":
                return "Your skill failed review. Check your email for certification feedback from the Alexa team. ";
            case "PENDING_REVIEW":
                return "Your skill has been submitted to Amazon for review. Once this process is completed, your skill will either appear in the skill store or you’ll be notified about issues that need to be resolved.";
            case "LIVE":
                return "";
            case "LIVE_PENDING_REVIEW":
                return "Your skill is live but the updated version is under review.";
            case "LIVE_FAILED_REVIEW":
                return "Your skill is live but the updated version failed review review. Check your email for certification feedback from the Alexa team.";
            case "READY":
                return "Everything seems good to go! Submit your skill for review in the Alexa Console and, if it’s approved, it will be published to this channel.";
            default:
                return "";
        }
    };
    const renderStep3 = ()=>{
        const additionalStatusText = getAdditionalStatusText();
        return (0, _react.jsx)((0, _sharedStyledComponents.DeploymentStep), null, (0, _react.jsx)((0, _sharedStyledComponents.StepHeader), null, (0, _react.jsx)((0, _sharedStyledComponents.StepNumber), null, "3"), (0, _react.jsx)("div", null, "Launch")), (0, _react.jsx)((0, _sharedStyledComponents.LabelAndButtonRow), null, (0, _react.jsx)((0, _sharedStyledComponents.LabeledText), null, (0, _react.jsx)("span", null, "Application Status"), (0, _react.jsx)((0, _sharedStyledComponents.PublishStatusRow), null, (0, _react.jsx)("a", {
            href: "https://developer.amazon.com/alexa/console/ask?#",
            target: "_blank"
        }, (0, _react.jsx)("img", {
            className: "ac-amazon-status",
            src: props.applicationStatusIcon
        })), (0, _react.jsx)("p", null, getApplicationStatusText()))), (0, _react.jsx)((0, _sharedStyledComponents.Filler), null), (0, _react.jsx)((0, _sharedStyledComponents.StyledLink), {
            target: "_blank",
            href: "https://support.voicify.com/knowledge/getting-started-with-voicify-part-4-deploying-to-alexa-and-google"
        }, "View our launch docs")), (props.launchMessage || additionalStatusText) && (0, _react.jsx)((0, _sharedStyledComponents.LabeledText), null, (0, _react.jsx)("p", null, props.launchMessage ?? additionalStatusText)));
    };
    return (0, _react.jsx)((0, _sharedStyledComponents.CardContainer), null, (0, _react.jsx)((0, _sharedStyledComponents.DeploymentsCard), {
        id: "alexa-card"
    }, (0, _react.jsx)((0, _sharedStyledComponents.LogoEndpointsHeader), null, (0, _react.jsx)((0, _sharedStyledComponents.Logo), {
        src: amazonLogo
    }), (0, _react.jsx)((0, _buttonDefault.default), {
        themes: [
            "secondary-small"
        ],
        disabled: props.endpoints?.alexaEndpoint == null,
        text: showEndpoints ? "Hide Endpoints" : "Show Endpoints",
        onClick: ()=>setShowEndpoints(!showEndpoints),
        type: "button",
        rightIcon: showEndpoints ? endpointButtonIconActive : endpointButtonIconInactive,
        className: showEndpoints ? `button-active` : null
    })), showEndpoints && (0, _react.jsx)((0, _reactDefault.default).Fragment, null, (0, _react.jsx)((0, _sharedStyledComponents.TopTriangleStyle), null), (0, _react.jsx)((0, _sharedStyledComponents.Endpoints), null, (0, _react.jsx)((0, _sharedStyledComponents.EndpointsHeader), null, "Fulfillment Endpoints"), (0, _react.jsx)((0, _horizontalContainerDefault.default), null, (0, _react.jsx)((0, _textFieldDefault.default), {
        useForm: false,
        value: props.endpoints?.alexaEndpoint,
        onChange: null,
        readOnly: true,
        label: "Direct Fulfillment"
    }), (0, _react.jsx)((0, _sharedStyledComponents.CopyButton), {
        themes: [
            "secondary"
        ],
        text: "Copy",
        type: "button",
        onClick: ()=>copyText(props.endpoints?.alexaEndpoint)
    })), (0, _react.jsx)((0, _horizontalContainerDefault.default), null, (0, _react.jsx)((0, _textFieldDefault.default), {
        useForm: false,
        value: props.endpoints?.alexaProxyEndpoint,
        onChange: null,
        readOnly: true,
        label: "Custom Fulfillment"
    }), (0, _react.jsx)((0, _sharedStyledComponents.CopyButton), {
        themes: [
            "secondary"
        ],
        text: "Copy",
        type: "button",
        onClick: ()=>copyText(props.endpoints?.alexaProxyEndpoint)
    })))), (0, _react.jsx)((0, _sharedStyledComponents.HelperText), null, (0, _react.jsx)("p", null, "Let’s get you ready to deploy to Alexa! ", (0, _react.jsx)("br", null), " ", (0, _react.jsx)("br", null)), (0, _react.jsx)("p", null, "This process will get your account on Voicify synced with your Amazon Developer account and apply your settings to a specific Skill. "), (0, _react.jsx)((0, _sharedStyledComponents.StyledLink), {
        target: "_blank",
        href: "https://support.voicify.com/en/knowledge/alexa-deployment"
    }, "Read More ")), (0, _react.jsx)((0, _sharedStyledComponents.WorkflowStepContainer), null, (0, _react.jsx)((0, _deploymentWorkflowStepDefault.default), {
        name: "Connect Account",
        currentStep: workflowStep,
        step: 1
    }), (0, _react.jsx)((0, _deploymentWorkflowStepDefault.default), {
        name: "Link Skill",
        currentStep: workflowStep,
        step: 2
    }), (0, _react.jsx)((0, _deploymentWorkflowStepDefault.default), {
        name: "Launch",
        currentStep: workflowStep,
        step: 3
    }), (0, _react.jsx)((0, _deploymentWorkflowStepDefault.default), {
        last: true,
        icon: props.applicationStatusIcon,
        currentStep: workflowStep,
        step: 4,
        href: "https://developer.amazon.com/alexa/console/ask?#"
    })), !loaded && (0, _react.jsx)((0, _loaderDefault.default), {
        className: customLoaderStyle
    }), loaded && (0, _react.jsx)((0, _reactDefault.default).Fragment, null, workflowStep >= 1 && renderStep1(), workflowStep >= 2 && renderStep2(), workflowStep >= 3 && renderStep3(), renderMainButton())), (0, _react.jsx)((0, _pageErrorDefault.default), {
        errors: amazonContainer.errors,
        onClear: amazonContainer.clearErrors
    }), (0, _react.jsx)(VendorModal, {
        isVisible: showVendorModal
    }, (0, _react.jsx)((0, _horizontalContainerDefault.default), null, (0, _react.jsx)((0, _modalTitleDefault.default), {
        padded: true
    }, "Choose Vendor"), (0, _react.jsx)((0, _buttonDefault.default), {
        themes: [
            "end-tight",
            "icon"
        ],
        icon: closeIcon,
        onClick: handleCloseVendorModal
    })), (0, _react.jsx)((0, _horizontalSeparatorDefault.default), null), (0, _react.jsx)((0, _pageContainerDefault.default), null, (0, _react.jsx)(VendorSelector, {
        options: amazonContainer.vendors.map((a)=>({
                value: a.id,
                label: a.name
            })),
        value: amazonContainer.vendorId ?? amazonContainer?.vendors[0]?.id,
        onBlur: ()=>{},
        clearable: false,
        onChange: handleVendorSelectionChange,
        label: "Vendor",
        useFormTheme: true,
        useForm: false,
        name: "vendorId"
    })), (0, _react.jsx)((0, _footerBarDefault.default), null, (0, _react.jsx)((0, _sharedStyledComponents.MainButton), {
        loading: vendorLoading,
        disabled: vendorLoading,
        themes: [
            "primary"
        ],
        text: "Select",
        type: "button",
        onClick: handleSelectVendor
    }))));
};
const VendorModal = /*#__PURE__*/ (0, _baseDefault.default)((0, _modalLayoutDefault.default), {
    target: "e1v3epfw1"
})({
    name: "1tkga6d",
    styles: "width:40%;height:30%;min-height:500px;min-width:600px"
});
const VendorSelector = /*#__PURE__*/ (0, _baseDefault.default)((0, _selectFieldDefault.default), {
    target: "e1v3epfw0"
})({
    name: "18d63h3",
    styles: "margin:32px"
});
const customLoaderStyle = /*#__PURE__*/ (0, _css.css)({
    name: "1pp2wda",
    styles: "position:relative;top:auto;margin-top:30px;margin-bottom:30px"
});
exports.default = AmazonDeploymentCard;

},{"@emotion/styled/base":"lSuFu","@emotion/react":"djZKr","react":"6uln9","../../../components/forms/RadioGroup":"eiGrn","../../../components/general/Button":"6ymxN","../../../components/general/PageError":"ezFTm","./DeploymentWorkflowStep":"lgTpr","../../../components/general/Loader":"bnV5T","../../../components/structure/ModalLayout":"b1cO3","../../../components/structure/PageContainer":"hc1r8","../../../components/structure/HorizontalContainer":"eJPfh","../../../components/general/ModalTitle":"hIp2B","../../../components/structure/HorizontalSeparator":"Pw3HQ","../../../components/structure/FooterBar":"bibRL","../../../components/forms/SelectField":"405B3","@emotion/css":"awUBr","../../../components/forms/TextField":"7a7bh","./SharedStyledComponents":"9COIL","../../../hooks/AmazonDeploymentContainer":"bZJPl","../../../hooks/DeploymentsContainer":"54k9j","3802672f6d299ec4":"bGsP0","d51bc6ae95ce7212":"bI1tn","232362a6ac5e2837":"bDy63","ce1005ae23462965":"93VwA","27b0b2c8d5981d1f":"fyNwe","eec5d858b860f2d6":"9ewOE","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"lgTpr":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _base = require("@emotion/styled/base");
var _baseDefault = parcelHelpers.interopDefault(_base);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _colors = require("../../../constants/colors");
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const oneDark = require("f2f9b9769a19830e");
const oneBlue = require("13a34ea3f86bccbf");
const oneGrey = require("f18c0f00d5d33999");
const twoDark = require("8caca651144a2561");
const twoBlue = require("37b9e93b57417de2");
const twoGrey = require("f5942a1aed43f576");
const threeDark = require("6a58745b3dde64d9");
const threeBlue = require("3eb630bba420f21b");
const threeGrey = require("13116f69a134fc2c");
function DeploymentWorkflowStep(props) {
    const [phase, setPhase] = (0, _react1.useState)("current");
    (0, _react1.useEffect)(()=>{
        setPhase(props.currentStep > props.step ? "done" : props.currentStep < props.step ? "todo" : "current");
    }, [
        props.currentStep,
        props.step
    ]);
    return (0, _react.jsx)(StyledTab, {
        key: props.step,
        className: `${props.last ? "last" : ""} ${props.className ? props.className : ""}`
    }, props.last ? props.href ? (0, _react.jsx)("a", {
        href: props.href,
        target: "_blank"
    }, (0, _react.jsx)(StatusImg, {
        src: props.icon
    })) : (0, _react.jsx)(StatusImg, {
        src: props.icon
    }) : (0, _react.jsx)(NumberedTab, {
        className: `numbered-tab-${phase == "done" ? "dark" : phase == "current" ? "blue" : "grey"}`
    }, (0, _react.jsx)("p", {
        className: `step-number ${phase == "done" ? "dark" : phase == "current" ? "blue" : "grey"}`
    }, props.step), (0, _react.jsx)("p", {
        className: `step-name`
    }, props.name), (0, _react.jsx)(SpacerLine, {
        className: `spacer-${phase == "done" ? "dark" : phase == "current" ? "blue" : "grey"}`
    })));
}
const StyledTab = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1ll6b993"
})({
    name: "p214ny",
    styles: "width:35%;&.last{width:auto;}"
});
const StatusImg = /*#__PURE__*/ (0, _baseDefault.default)("img", {
    target: "e1ll6b992"
})({
    name: "1soh0gv",
    styles: "margin-top:4px"
});
const NumberedTab = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1ll6b991"
})("display:flex;width:100%;white-space:nowrap;height:32px;p{font-size:14px;&.step-name{margin-top:6px;}&.step-number{width:24px;height:24px;border:1px solid;border-radius:16px;text-align:center;margin-right:8px;margin-top:4px;line-height:20px;&.dark{border:1px solid ", (0, _colors.color_shades_darkest), ";}&.blue{border:1px solid ", (0, _colors.color_colors_ocean), ";}&.grey{border:1px solid ", (0, _colors.color_shades_dark), ";}}}img{margin-right:8px;margin-top:-1px;}&.numbered-tab-dark{color:", (0, _colors.color_shades_darkest), ";}&.numbered-tab-blue{color:", (0, _colors.color_colors_ocean), ";}&.numbered-tab-grey{color:", (0, _colors.color_shades_darker), ";}");
const SpacerLine = /*#__PURE__*/ (0, _baseDefault.default)("span", {
    target: "e1ll6b990"
})("flex-grow:1;margin:0px 8px 15px 8px;&.spacer-dark{border-bottom:1px solid ", (0, _colors.color_shades_darkest), ";}&.spacer-blue{border-bottom:1px dashed ", (0, _colors.color_colors_ocean), ";}&.spacer-grey{border-bottom:1px dashed ", (0, _colors.color_shades_dark), ";}");
exports.default = DeploymentWorkflowStep;

},{"@emotion/styled/base":"lSuFu","@emotion/react":"djZKr","react":"6uln9","../../../constants/colors":"1p3OR","f2f9b9769a19830e":"jTfwa","13a34ea3f86bccbf":"cB2xm","f18c0f00d5d33999":"82dLQ","8caca651144a2561":"ba193","37b9e93b57417de2":"caAhW","f5942a1aed43f576":"1AftK","6a58745b3dde64d9":"fBqHj","3eb630bba420f21b":"1Jqlm","13116f69a134fc2c":"5wFLv","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jTfwa":[function(require,module,exports) {
module.exports = require("aeb2c4e507a3a39b").getBundleURL("kVLro") + require("cbf709b3d2e126d5").resolve("1cDo9");

},{"aeb2c4e507a3a39b":"c7Tr5","cbf709b3d2e126d5":"fyJL2"}],"cB2xm":[function(require,module,exports) {
module.exports = require("a2ee5e9cdbe912b2").getBundleURL("kVLro") + require("2afc3c56e54fb1c6").resolve("1V3e4");

},{"a2ee5e9cdbe912b2":"c7Tr5","2afc3c56e54fb1c6":"fyJL2"}],"82dLQ":[function(require,module,exports) {
module.exports = require("80208540f5cb0678").getBundleURL("kVLro") + require("268df505fe8acefa").resolve("gPfcN");

},{"80208540f5cb0678":"c7Tr5","268df505fe8acefa":"fyJL2"}],"ba193":[function(require,module,exports) {
module.exports = require("32a2da10f2165bb0").getBundleURL("kVLro") + require("43bbe10110ad2441").resolve("aGkgd");

},{"32a2da10f2165bb0":"c7Tr5","43bbe10110ad2441":"fyJL2"}],"caAhW":[function(require,module,exports) {
module.exports = require("67e012f30b8744a").getBundleURL("kVLro") + require("fc6d15e8903fd0ab").resolve("aBaVh");

},{"67e012f30b8744a":"c7Tr5","fc6d15e8903fd0ab":"fyJL2"}],"1AftK":[function(require,module,exports) {
module.exports = require("d159e3a40d91bfb0").getBundleURL("kVLro") + require("261149bcc94834fa").resolve("38swC");

},{"d159e3a40d91bfb0":"c7Tr5","261149bcc94834fa":"fyJL2"}],"fBqHj":[function(require,module,exports) {
module.exports = require("47396c8532d19347").getBundleURL("kVLro") + require("9e9d11f31b3ce928").resolve("7AzSa");

},{"47396c8532d19347":"c7Tr5","9e9d11f31b3ce928":"fyJL2"}],"1Jqlm":[function(require,module,exports) {
module.exports = require("180f065d7af02762").getBundleURL("kVLro") + require("afdfe20d736c2dd8").resolve("3itXp");

},{"180f065d7af02762":"c7Tr5","afdfe20d736c2dd8":"fyJL2"}],"5wFLv":[function(require,module,exports) {
module.exports = require("84c8be814daeab1b").getBundleURL("kVLro") + require("18011339adfb6ce1").resolve("1QjRG");

},{"84c8be814daeab1b":"c7Tr5","18011339adfb6ce1":"fyJL2"}],"9COIL":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MainButton", ()=>MainButton);
parcelHelpers.export(exports, "AlternateButton", ()=>AlternateButton);
parcelHelpers.export(exports, "PublishedStatusRow", ()=>PublishedStatusRow);
parcelHelpers.export(exports, "LabeledText", ()=>LabeledText);
parcelHelpers.export(exports, "DeploymentSelector", ()=>DeploymentSelector);
parcelHelpers.export(exports, "DeploymentStep", ()=>DeploymentStep);
parcelHelpers.export(exports, "DeploymentStepNoBorder", ()=>DeploymentStepNoBorder);
parcelHelpers.export(exports, "LinkedAccount", ()=>LinkedAccount);
parcelHelpers.export(exports, "StepHeader", ()=>StepHeader);
parcelHelpers.export(exports, "DeploymentsCard", ()=>DeploymentsCard);
parcelHelpers.export(exports, "LabelAndButtonRow", ()=>LabelAndButtonRow);
parcelHelpers.export(exports, "PublishStatusRow", ()=>PublishStatusRow);
parcelHelpers.export(exports, "WorkflowStepContainer", ()=>WorkflowStepContainer);
parcelHelpers.export(exports, "StyledLink", ()=>StyledLink);
parcelHelpers.export(exports, "CardContainer", ()=>CardContainer);
parcelHelpers.export(exports, "HelperText", ()=>HelperText);
parcelHelpers.export(exports, "StepHelperText", ()=>StepHelperText);
parcelHelpers.export(exports, "StepFormContainer", ()=>StepFormContainer);
parcelHelpers.export(exports, "StepTitle", ()=>StepTitle);
parcelHelpers.export(exports, "BorderSeparator", ()=>BorderSeparator);
parcelHelpers.export(exports, "LogoEndpointsHeader", ()=>LogoEndpointsHeader);
parcelHelpers.export(exports, "Endpoints", ()=>Endpoints);
parcelHelpers.export(exports, "LoginImage", ()=>LoginImage);
parcelHelpers.export(exports, "Filler", ()=>Filler);
parcelHelpers.export(exports, "CopyButton", ()=>CopyButton);
parcelHelpers.export(exports, "EndpointsHeader", ()=>EndpointsHeader);
parcelHelpers.export(exports, "StepNumber", ()=>StepNumber);
parcelHelpers.export(exports, "TopTriangleStyle", ()=>TopTriangleStyle);
parcelHelpers.export(exports, "Logo", ()=>Logo);
var _base = require("@emotion/styled/base");
var _baseDefault = parcelHelpers.interopDefault(_base);
var _selectField = require("../../../components/forms/SelectField");
var _selectFieldDefault = parcelHelpers.interopDefault(_selectField);
var _button = require("../../../components/general/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _colors = require("../../../constants/colors");
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const MainButton = /*#__PURE__*/ (0, _baseDefault.default)((0, _buttonDefault.default), {
    target: "edamyxe28"
})({
    name: "1ohnzoo",
    styles: "padding:12px 32px;margin:24px 32px;display:flex"
});
const AlternateButton = /*#__PURE__*/ (0, _baseDefault.default)((0, _buttonDefault.default), {
    target: "edamyxe27"
})({
    name: "cfjpzu",
    styles: "margin:0px"
});
const PublishedStatusRow = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "edamyxe26"
})({
    name: "zjik7",
    styles: "display:flex"
});
const LabeledText = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "edamyxe25"
})("span{text-transform:uppercase;color:", (0, _colors.color_shades_darker), ";font-size:12px;font-weight:400;line-height:16px;letter-spacing:0.1em;text-align:left;}p{color:", (0, _colors.color_shades_darkest), ";font-size:14px;font-weight:400;line-height:20px;letter-spacing:0em;text-align:left;}");
const DeploymentSelector = /*#__PURE__*/ (0, _baseDefault.default)((0, _selectFieldDefault.default), {
    target: "edamyxe24"
})({
    name: "1jhfjg7",
    styles: "width:60%;margin-left:32px"
});
const DeploymentStep = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "edamyxe23"
})("padding:24px 0px;margin:0px 32px;border-bottom:1px solid ", (0, _colors.color_shades_dark), ";");
const DeploymentStepNoBorder = /*#__PURE__*/ (0, _baseDefault.default)(DeploymentStep, {
    target: "edamyxe22"
})({
    name: "ves2bp",
    styles: "padding:24px 0px;margin:0px 32px;border-bottom:none"
});
const LinkedAccount = /*#__PURE__*/ (0, _baseDefault.default)(DeploymentStep, {
    target: "edamyxe21"
})({
    name: "rekijd",
    styles: "padding:16px 0px"
});
const StepHeader = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "edamyxe20"
})("display:flex;color:", (0, _colors.color_shades_darkest), ";img{margin-right:16px;}");
const DeploymentsCard = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "edamyxe19"
})("border-radius:10px;background-color:white;border:solid 1px ", (0, _colors.silver_two), ";margin-bottom:32px;flex-grow:0;font-family:Muli;font-weight:normal;font-style:normal;font-stretch:normal;line-height:normal;letter-spacing:normal;color:", (0, _colors.dark_grey_blue), ";min-height:400px;");
const LabelAndButtonRow = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "edamyxe18"
})({
    name: "xsakr8",
    styles: "display:flex;padding-top:16px"
});
const PublishStatusRow = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "edamyxe17"
})({
    name: "10cxffu",
    styles: "display:flex;padding-top:8px;img{margin:-3px 8px 8px 0px;}"
});
const WorkflowStepContainer = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "edamyxe16"
})("position:relative;display:flex;flex:1;margin:32px 32px 0px 32px;padding-bottom:64px;height:32px;border-bottom:1px solid ", (0, _colors.color_shades_dark), ";");
const StyledLink = /*#__PURE__*/ (0, _baseDefault.default)("a", {
    target: "edamyxe15"
})("color:", (0, _colors.color_colors_ocean), ";");
const CardContainer = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "edamyxe14"
})({
    name: "1a1txao",
    styles: "position:relative;margin:32px"
});
const HelperText = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "edamyxe13"
})({
    name: "1bi0nq3",
    styles: "padding:24px 32px 8px 32px"
});
const StepHelperText = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "edamyxe12"
})({
    name: "egnyfe",
    styles: "padding:28px 8px 0px 0px;font-size:14px"
});
const StepFormContainer = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "edamyxe11"
})({
    name: "1myirx6",
    styles: "margin:24px 0px"
});
const StepTitle = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "edamyxe10"
})({
    name: "1prltaw",
    styles: "margin-bottom:4px;font-size:16px"
});
const BorderSeparator = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "edamyxe9"
})("padding:0px;margin:0px;border-bottom:1px solid ", (0, _colors.color_shades_dark), ";");
const LogoEndpointsHeader = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "edamyxe8"
})("display:flex;flex-direction:row;padding:32px 32px 0px 32px;button{top:11px;&.button-active{color:", (0, _colors.color_colors_ocean), ";background:", (0, _colors.color_variants_ocean_light_opaque), ";border:1px solid ", (0, _colors.color_colors_ocean), ";box-sizing:border-box;border-radius:16px;}}");
const Endpoints = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "edamyxe7"
})("border-top:1px solid ", (0, _colors.color_shades_dark), ";border-bottom:1px solid ", (0, _colors.color_shades_dark), ";background-color:", (0, _colors.color_shades_lighter), ";padding:32px 32px;");
const LoginImage = /*#__PURE__*/ (0, _baseDefault.default)("img", {
    target: "edamyxe6"
})({
    name: "1ka1u3l",
    styles: "width:185px;height:40px;cursor:pointer;margin:24px 32px"
});
const Filler = /*#__PURE__*/ (0, _baseDefault.default)("span", {
    target: "edamyxe5"
})({
    name: "1ff36h2",
    styles: "flex-grow:1"
});
const CopyButton = /*#__PURE__*/ (0, _baseDefault.default)((0, _buttonDefault.default), {
    target: "edamyxe4"
})({
    name: "3hgi0y",
    styles: "margin-top:32px"
});
const EndpointsHeader = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "edamyxe3"
})({
    name: "1fgdcyd",
    styles: "margin-bottom:24px"
});
const StepNumber = /*#__PURE__*/ (0, _baseDefault.default)("p", {
    target: "edamyxe2"
})("font-size:14px;width:24px;height:24px;border:1px solid ", (0, _colors.color_shades_darker), ";border-radius:16px;text-align:center;margin-right:16px;line-height:20px;");
const TopTriangleStyle = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "edamyxe1"
})({
    name: "12r9jq1",
    styles: "transform:rotate(45deg);width:12px;height:12px;margin-top:-6px;margin-bottom:-6px;border-top:solid 1px #CBCCD2;border-left:solid 1px #CBCCD2;background:#F4F4F6;float:right;margin-right:132px"
});
const Logo = /*#__PURE__*/ (0, _baseDefault.default)("img", {
    target: "edamyxe0"
})({
    name: "12jy8r8",
    styles: "width:300px;height:auto;margin-right:auto"
});

},{"@emotion/styled/base":"lSuFu","../../../components/forms/SelectField":"405B3","../../../components/general/Button":"6ymxN","../../../constants/colors":"1p3OR","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"bZJPl":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _unstatedNext = require("unstated-next");
var _api = require("../api");
function useAmazonDeploymentContainer() {
    const [isLoading, setIsLoading] = (0, _react.useState)(false);
    const [errors, setErrors] = (0, _react.useState)([]);
    const [accountSelection, setAccountSelection] = (0, _react.useState)("new");
    const [availableApps, setAvailableApps] = (0, _react.useState)([]);
    const [availableCredentials, setAvailableCredentials] = (0, _react.useState)([]);
    const [tokenId, setTokenId] = (0, _react.useState)(null);
    const [linkedProjectId, setLinkedProjectId] = (0, _react.useState)(null);
    const [userName, setUserName] = (0, _react.useState)(null);
    const [createNew, setCreateNew] = (0, _react.useState)("new");
    const [loadingAvailableApps, setLoadingAvailableApps] = (0, _react.useState)(false);
    const [status, setStatus] = (0, _react.useState)("linkingAccount");
    const [vendorId, setVendorId] = (0, _react.useState)(null);
    const [vendors, setVendors] = (0, _react.useState)([]);
    const [loadingVendors, setLoadingVendors] = (0, _react.useState)(false);
    const [currentSkillCertifications, setCurrentSkillCertifications] = (0, _react.useState)([]);
    const [availableSkills, setAvailableSkills] = (0, _react.useState)([]);
    const [currentApplicationId, setCurrentApplicationId] = (0, _react.useState)(null);
    const [currentEnvironmentId, setCurrentEnvironmentId] = (0, _react.useState)(null);
    const reset = ()=>{
        setStatus("linkingAccount");
        setAccountSelection("new");
        setCreateNew("new");
        setLoadingAvailableApps(false);
        setAvailableApps([]);
        setAvailableCredentials([]);
        setTokenId(null);
        setLinkedProjectId(null);
        setUserName(null);
        setErrors([]);
        setVendorId(null);
        setVendors([]);
        setLoadingVendors(false);
        setCurrentSkillCertifications([]);
        setAvailableSkills([]);
        setCurrentApplicationId(null);
        setCurrentEnvironmentId(null);
    };
    const setDeployToApp = async (linkedProjectId)=>{
        await setLinkedProjectId(linkedProjectId);
    };
    const setLinkingStatus = async (status)=>{
        await setStatus(status);
    };
    const setAccountToLink = async (tokenId, userName)=>{
        await setTokenId(tokenId);
        await setUserName(userName);
    };
    const getAvailableCredentials = async (organizationId)=>{
        try {
            const result = await _api.getAvailableAmazonCredentials(organizationId);
            if (result.resultType == "Ok") await setAvailableCredentials(result.data.map((t)=>({
                    id: t.id,
                    userName: t.userName
                })));
            else await setErrors(result.errors);
            return result;
        } catch (err) {
            setErrors([
                err.toString()
            ]);
        }
    };
    const setAccountNewOrExisting = async (accountSelection)=>{
        if (accountSelection == "new") await setTokenId(null);
        await setAccountSelection(accountSelection);
    };
    const setCreateNewSkill = async (createNew)=>{
        await setCreateNew(createNew);
    };
    const getSkills = async (vendorId, tokenId)=>{
        await setLoadingAvailableApps(true);
        return await _api.listSkills(vendorId, tokenId).then(async (result)=>{
            if (result.resultType == "Ok") {
                const skills = result.data;
                await setAvailableApps(skills.map((a)=>({
                        id: a.skillId,
                        name: a.nameByLocale["en-US"]
                    })));
                await setAvailableSkills(skills);
                await setLoadingAvailableApps(false);
            } else {
                setErrors(result.errors);
                setLoadingAvailableApps(false);
            }
            return result;
        }).catch((err)=>{
            setErrors([
                err.toString()
            ]);
            setLoadingAvailableApps(false);
        });
    };
    const loadEnvironmentDeploymentInformation = async (applicationId, environmentId, organizationId)=>{
        try {
            if (currentApplicationId === applicationId && currentEnvironmentId === environmentId) return;
            await setIsLoading(true);
            await reset();
            const link = await getEnvironmentDeploymentStatus(applicationId, environmentId);
            if (link.linkedProjectId && link.userName) {
                await setLinkingStatus("launch");
                await setAccountNewOrExisting("existing");
                await setCreateNewSkill("existing");
                await loadEnvironmentSkillCertifications();
            } else if (link.vendorId && link.userName) {
                await setLinkingStatus("linkingSkill");
                await setAccountNewOrExisting("existing");
            } else if (link.userName) {
                await setLinkingStatus("selectingVendor");
                await setAccountNewOrExisting("existing");
            }
            await getAvailableCredentials(organizationId);
            if (link.tokenId) {
                // we need a valid tokenId in order to retrieve vendors
                const vendorsResult = await getEnvironmentVendors(applicationId, environmentId);
                let envVendorId = link.vendorId;
                if (!envVendorId) {
                    // We do not have a vendor selected 
                    if (vendorsResult && vendorsResult.resultType == "Ok" && vendorsResult.data && vendorsResult.data.vendors) // Link new vendor automatically if single one was found
                    // If multiple vendors found then user will have to manually select a vendor from drop down
                    {
                        if (vendorsResult.data.vendors.length == 1) {
                            envVendorId = vendorsResult.data.vendors[0].id;
                            await linkEnvironmentVendor(applicationId, environmentId, envVendorId);
                            await setVendorId(envVendorId);
                            await setStatus("linkingSkill");
                        }
                    } else await setErrors([
                        "Unable to find environment vendors"
                    ]);
                }
                if (envVendorId) // We have a vendor
                await getSkills(envVendorId, link.tokenId);
            }
            await setIsLoading(false);
        } catch (err) {
            setIsLoading(false);
            setErrors([
                err.toString()
            ]);
        }
    };
    const getEnvironmentDeploymentStatus = async (applicationId, environmentId)=>{
        try {
            await setCurrentApplicationId(applicationId);
            await setCurrentEnvironmentId(environmentId);
            // Need to clear ProjectId (AlexaSkillId), UserName, TokenId and VendorId before getEnvironmentDeploymentInfoForAmazon call
            await setLinkedProjectId(null);
            await setUserName(null);
            await setTokenId(null);
            await setVendorId(null);
            const result = await _api.getEnvironmentDeploymentInfoForAmazon(applicationId, environmentId);
            if (result.resultType == "Ok") {
                const status = result.data;
                await setLinkedProjectId(status.linkedProjectId);
                await setUserName(status.userName);
                await setTokenId(status.tokenId);
                await setVendorId(status.vendorId);
                await setErrors([]);
                return status;
            } else await setErrors(result.errors);
        } catch (err) {
            setErrors([
                err.toString()
            ]);
        }
    };
    const linkEnvironment = async (applicationId, environmentId, skillId)=>{
        try {
            const response = await _api.linkEnvironmentToAlexaSkill(applicationId, environmentId, skillId);
            if (response.resultType != "Ok") await setErrors(response.errors);
            else await setLinkedProjectId(skillId);
        } catch (err) {
            setErrors([
                err.toString()
            ]);
        }
    };
    const createAndDeployEnvironmentNewSkill = async (applicationId, environmentId)=>{
        try {
            await setStatus("launch");
            await setLoadingAvailableApps(true);
            const response = await _api.createAndDeployEnvironmentNewAlexaSkill(applicationId, environmentId);
            if (response.resultType == "Ok") {
                const skills = availableApps;
                skills.push(response.data);
                await setAvailableApps(skills);
                await setLinkedProjectId(response.data.id);
                await setCreateNew("existing");
                await setLoadingAvailableApps(false);
            } else {
                await setLoadingAvailableApps(false);
                await setStatus("linkingSkill");
                await setErrors(response.errors);
            }
            return response;
        } catch (err) {
            setLoadingAvailableApps(false);
            setErrors([
                err.toString()
            ]);
        }
    };
    const linkTokenToEnvironment = async (applicationId, environmentId, tokenId)=>{
        try {
            const res = await _api.linkAmazonTokenToEnvironment(applicationId, environmentId, tokenId);
            if (res.resultType != "Ok") setErrors(res.errors);
            return res;
        } catch (err) {
            setErrors([
                err.toString()
            ]);
        }
    };
    const loadEnvironmentSkillCertifications = async ()=>{
        try {
            if (linkedProjectId == null || currentApplicationId == null) return;
            var result = await _api.getAlexaSkillCertifications(currentApplicationId, currentEnvironmentId, linkedProjectId);
            if (result.resultType == "Ok") {
                await setCurrentSkillCertifications(result.data ?? []);
                return result.data;
            } else {
                await setCurrentSkillCertifications(result.data ?? []);
                await setErrors(result.errors);
            }
        } catch (err) {
            setErrors([
                err.toString()
            ]);
        }
    };
    const getAuthUrl = async (request)=>{
        try {
            const res = await _api.getAmazonAuthUrl(request);
            if (res.resultType != "Ok") setErrors(res.errors);
            return res;
        } catch (err) {
            setErrors([
                err.toString()
            ]);
        }
    };
    const getEnvironmentVendors = async (applicationId, environmentId)=>{
        await setLoadingVendors(true);
        await setCurrentApplicationId(applicationId);
        await setCurrentEnvironmentId(environmentId);
        const result = await _api.getEnvironmentAlexaVendors(applicationId, environmentId);
        if (result.resultType == "Ok") {
            await setVendors(result.data.vendors);
            await setLoadingVendors(false);
        } else {
            await setErrors(result.errors);
            await setLoadingVendors(false);
        }
        return result;
    };
    const linkEnvironmentVendor = (applicationId, environmentId, vendorId)=>{
        return _api.linkEnvironmentAlexaVendor(applicationId, environmentId, vendorId).then(async (res)=>{
            if (res.resultType == "Ok") {
                setVendorId(vendorId);
                setStatus("linkingSkill");
                setLinkedProjectId(null);
            } else setErrors(res.errors);
            return res;
        }).catch((err)=>{
            setErrors([
                err.toString()
            ]);
        });
    };
    const unlinkEnvironmentSkill = async (applicationId, environmentId)=>{
        try {
            await setLinkedProjectId(null);
            await setStatus("linkingSkill");
            const res = await _api.unlinkAlexaSkillFromEnvironment(applicationId, environmentId);
            if (res.resultType != "Ok") setErrors(res.errors);
            return res;
        } catch (err) {
            setErrors([
                err.toString()
            ]);
        }
    };
    const unlinkEnvironmentUserAccount = async (applicationId, environmentId)=>{
        try {
            const res = await _api.removeAmazonAuthTokenFromEnvironment(applicationId, environmentId);
            if (res.resultType != "Ok") setErrors(res.errors);
            return res;
        } catch (err) {
            setErrors([
                err.toString()
            ]);
        }
    };
    const unlinkEnvironmentVendor = async (applicationId, environmentId)=>{
        return _api.removeAlexaVendorFromEnvironment(applicationId, environmentId).then((res)=>{
            if (res.resultType != "Ok") setErrors(res.errors);
        }).catch((err)=>{
            setErrors([
                err.toString()
            ]);
        });
    };
    const clearErrors = async ()=>{
        await setErrors([]);
    };
    return {
        reset,
        setDeployToApp,
        setLinkingStatus,
        setAccountToLink,
        setAccountNewOrExisting,
        getAvailableCredentials,
        loadEnvironmentDeploymentInformation,
        getEnvironmentDeploymentStatus,
        createAndDeployEnvironmentNewSkill,
        setCreateNewSkill,
        getAuthUrl,
        getSkills,
        getEnvironmentVendors,
        linkEnvironment,
        linkEnvironmentVendor,
        linkTokenToEnvironment,
        unlinkEnvironmentSkill,
        unlinkEnvironmentUserAccount,
        unlinkEnvironmentVendor,
        setVendorId,
        currentEnvironmentId,
        status,
        createNew,
        accountSelection,
        availableSkills,
        currentSkillCertifications,
        linkedProjectId,
        tokenId,
        userName,
        vendors,
        vendorId,
        availableCredentials,
        availableApps,
        loadingAvailableApps,
        isLoading,
        errors,
        clearErrors
    };
}
const AmazonDeploymentContainer = (0, _unstatedNext.createContainer)(useAmazonDeploymentContainer);
exports.default = AmazonDeploymentContainer;

},{"react":"6uln9","unstated-next":"61zE5","../api":"loxM6","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"54k9j":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _unstatedNext = require("unstated-next");
var _api = require("../api");
function useDeploymentsContainer() {
    const [isLoading, setIsLoading] = (0, _react.useState)(false);
    const [errors, setErrors] = (0, _react.useState)([]);
    const [status, setStatus] = (0, _react.useState)(null);
    const [waitingForAlexa, setWaitingForAlexa] = (0, _react.useState)(false);
    const [waitingForDialogflow, setWaitingForDialogflow] = (0, _react.useState)(false);
    const [pollingForDeploymentStatus, setPollingForDeploymentStatus] = (0, _react.useState)(false);
    const [pollingApplicationId, setPollingApplicationId] = (0, _react.useState)("");
    const [pollingEnvironmentId, setPollingEnvironmentId] = (0, _react.useState)("");
    const [currentApplicationId, setCurrentApplicationId] = (0, _react.useState)("");
    const [pollingTrigger, setPollingTrigger] = (0, _react.useState)(0);
    const waitForEnvironmentDeployment = async (applicationId, environmentId, alexa, dialogflow, googleActions)=>{
        await setPollingEnvironment(applicationId, environmentId);
        setWaitingForDialogflow(dialogflow);
        setWaitingForAlexa(alexa);
        if (alexa || dialogflow || googleActions) pollForEnvironmentDeploymentStatus();
    };
    const stopWaitingForDialogflowDeployment = async ()=>{
        setWaitingForDialogflow(false);
    };
    const stopWaitingForAlexaDeployment = async ()=>{
        setWaitingForAlexa(false);
    };
    (0, _react.useEffect)(()=>{
        setPollingForDeploymentStatus(waitingForAlexa || waitingForDialogflow);
    }, [
        waitingForDialogflow,
        waitingForAlexa
    ]);
    const setPollingEnvironment = async (applicationId, environmentId)=>{
        if (pollingApplicationId != applicationId || pollingEnvironmentId != environmentId) {
            setCurrentApplicationId(applicationId);
            setPollingApplicationId(applicationId);
            setPollingEnvironmentId(environmentId);
            setPollingForDeploymentStatus(false);
            setWaitingForAlexa(false);
            setWaitingForDialogflow(false);
        }
    };
    const isPlatformDeploymentComplete = (platform, status)=>{
        let isDeploymentComplete = false;
        const hasQueuedDeployments = status?.queuedForDeploymentToPlatforms?.some((q)=>q.platform == platform);
        if (!hasQueuedDeployments) {
            // If there are no more environment platform queued deployments - lets check what was latest deployment status
            const deploymentResult = status?.latestDeploymentResults?.find((r)=>r.platform == platform);
            if (!deploymentResult || deploymentResult?.error || deploymentResult?.success || deploymentResult.status === "SUCCEEDED") isDeploymentComplete = true;
        }
        return isDeploymentComplete;
    };
    (0, _react.useEffect)(()=>{
        if (pollingForDeploymentStatus) poll();
    }, [
        pollingTrigger
    ]);
    const poll = async ()=>{
        try {
            const interactionModelStatusResult = await _api.getInteractionModelStatusPerEnvironment(pollingApplicationId, pollingEnvironmentId);
            if (interactionModelStatusResult.resultType == "Ok") {
                const newStatus = interactionModelStatusResult.data;
                setStatus(newStatus);
                let shouldContinueAlexa = waitingForAlexa;
                let shouldContinueDialogflow = waitingForDialogflow;
                // if we're polling for a platform then check if that one finished
                if (waitingForAlexa && isPlatformDeploymentComplete("alexa", newStatus)) {
                    setWaitingForAlexa(false);
                    shouldContinueAlexa = false;
                }
                if (waitingForDialogflow && isPlatformDeploymentComplete("dialogflow", newStatus)) {
                    setWaitingForDialogflow(false);
                    shouldContinueDialogflow = false;
                }
                setPollingForDeploymentStatus(shouldContinueAlexa || shouldContinueDialogflow);
                if (shouldContinueAlexa || shouldContinueDialogflow) {
                    await new Promise((r)=>setTimeout(r, 2000));
                    setPollingTrigger(pollingTrigger + 1);
                }
            } else {
                setErrors(interactionModelStatusResult.errors);
                setWaitingForAlexa(false);
                setWaitingForDialogflow(false);
                setPollingForDeploymentStatus(false);
            }
        } catch (err) {
            setErrors(err);
            setWaitingForAlexa(false);
            setWaitingForDialogflow(false);
            setPollingForDeploymentStatus(false);
        }
    };
    const pollForEnvironmentDeploymentStatus = async ()=>{
        try {
            // if we're already waiting then get out of it
            if (pollingForDeploymentStatus) return;
            setPollingForDeploymentStatus(true);
            setPollingTrigger(pollingTrigger + 1);
        } catch (err) {
            setErrors(err);
            setWaitingForAlexa(false);
            setWaitingForDialogflow(false);
            setPollingForDeploymentStatus(false);
        }
    };
    const loadInteractionModelEnvironmentStatus = async (applicationId, environmentId)=>{
        try {
            const interactionModelStatusResult = await _api.getInteractionModelStatusPerEnvironment(applicationId, environmentId);
            if (interactionModelStatusResult.resultType == "Ok") setStatus(interactionModelStatusResult.data);
            else setErrors(interactionModelStatusResult.errors);
            return interactionModelStatusResult;
        } catch (err) {
            setErrors(err.toString());
        }
    };
    const clearErrors = ()=>{
        setErrors([]);
    };
    return {
        errors,
        isLoading,
        currentApplicationId,
        status,
        setErrors,
        clearErrors,
        waitForEnvironmentDeployment,
        stopWaitingForAlexaDeployment,
        stopWaitingForDialogflowDeployment,
        loadInteractionModelEnvironmentStatus,
        pollForEnvironmentDeploymentStatus,
        setPollingEnvironment
    };
}
const InteractionModelContainer = (0, _unstatedNext.createContainer)(useDeploymentsContainer);
exports.default = InteractionModelContainer;

},{"react":"6uln9","unstated-next":"61zE5","../api":"loxM6","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"bGsP0":[function(require,module,exports) {
module.exports = require("7a3a5a61a4961e30").getBundleURL("kVLro") + require("f386ce092a7ea1ed").resolve("kZsMo");

},{"7a3a5a61a4961e30":"c7Tr5","f386ce092a7ea1ed":"fyJL2"}],"bDy63":[function(require,module,exports) {
module.exports = require("359d75851e3d0c22").getBundleURL("kVLro") + require("564f867907328702").resolve("9bLWh");

},{"359d75851e3d0c22":"c7Tr5","564f867907328702":"fyJL2"}],"fyNwe":[function(require,module,exports) {
module.exports = require("85c71551243e1498").getBundleURL("kVLro") + require("b86f95fe97538025").resolve("fjxnw");

},{"85c71551243e1498":"c7Tr5","b86f95fe97538025":"fyJL2"}],"9ewOE":[function(require,module,exports) {
module.exports = require("923ce242edd3581b").getBundleURL("kVLro") + require("f840ec595970b130").resolve("2E8Yv");

},{"923ce242edd3581b":"c7Tr5","f840ec595970b130":"fyJL2"}],"dGxYk":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _base = require("@emotion/styled/base");
var _baseDefault = parcelHelpers.interopDefault(_base);
var _react = require("@emotion/react");
var _css = require("@emotion/css");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _radioGroup = require("../../../components/forms/RadioGroup");
var _radioGroupDefault = parcelHelpers.interopDefault(_radioGroup);
var _button = require("../../../components/general/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _colors = require("../../../constants/colors");
var _pageError = require("../../../components/general/PageError");
var _pageErrorDefault = parcelHelpers.interopDefault(_pageError);
var _sharedStyledComponents = require("./SharedStyledComponents");
var _horizontalContainer = require("../../../components/structure/HorizontalContainer");
var _horizontalContainerDefault = parcelHelpers.interopDefault(_horizontalContainer);
var _textField = require("../../../components/forms/TextField");
var _textFieldDefault = parcelHelpers.interopDefault(_textField);
var _deploymentWorkflowStep = require("./DeploymentWorkflowStep");
var _deploymentWorkflowStepDefault = parcelHelpers.interopDefault(_deploymentWorkflowStep);
var _loader = require("../../../components/general/Loader");
var _loaderDefault = parcelHelpers.interopDefault(_loader);
var _dialogflowDeploymentContainer = require("../../../hooks/DialogflowDeploymentContainer");
var _dialogflowDeploymentContainerDefault = parcelHelpers.interopDefault(_dialogflowDeploymentContainer);
var _deploymentsContainer = require("../../../hooks/DeploymentsContainer");
var _deploymentsContainerDefault = parcelHelpers.interopDefault(_deploymentsContainer);
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const dialogflowLogo = require("93f3692668dcb723");
const googleButton = require("6d5d797d4264b");
const linkOutWhiteIcon = require("23db173b2a54afc");
const linkOutIcon = require("26cc14e861ce7b9e");
const plusDarkIcon = require("26e3912cc3aac2dc");
const endpointButtonIconActive = require("63d279fe31c68e09");
const endpointButtonIconInactive = require("709bf33eb09ca0cc");
const DialogflowDeploymentCard = (props)=>{
    const deploymentContainer = (0, _dialogflowDeploymentContainerDefault.default).useContainer();
    const deploymentsContainer = (0, _deploymentsContainerDefault.default).useContainer();
    const [showEndpoints, setShowEndpoints] = (0, _react1.useState)(false);
    const [loaded, setLoaded] = (0, _react1.useState)(false);
    const [primaryButtonLoading, setPrimaryButtonLoading] = (0, _react1.useState)(false);
    const [workflowStep, setWorkflowStep] = (0, _react1.useState)(1);
    (0, _react1.useEffect)(()=>{
        const loadAsync = async ()=>{
            setLoaded(false);
            // load Dialogflow deployment stuff per environment
            await deploymentContainer.loadEnvironmentDeploymentInformation(props.applicationId, props.environmentId, props.organizationId);
            setLoaded(true);
        };
        loadAsync();
        const cleanUp = ()=>{
            deploymentContainer.reset();
        };
        return cleanUp;
    }, [
        props.applicationId,
        props.environmentId,
        props.organizationId
    ]);
    (0, _react1.useEffect)(()=>{
        switch(deploymentContainer.status){
            case "initial":
                setWorkflowStep(1);
                break;
            case "linkingApp":
                setWorkflowStep(2);
                break;
            case "finished":
                setWorkflowStep(3);
                break;
        }
    }, [
        deploymentContainer.status
    ]);
    const handleSelectionChange = (option)=>{
        deploymentContainer.setSelection(option.value);
    };
    const handleDeployToAppSelectionChange = (option)=>{
        option && deploymentContainer.setDeployToApp(option.value);
    };
    const handleLinkButton = async ()=>{
        await setPrimaryButtonLoading(true);
        switch(deploymentContainer.status){
            case "initial":
                await handleAccountLink();
                break;
            case "linkingApp":
                await handleAppLink();
                break;
        }
        await setPrimaryButtonLoading(false);
    };
    const handleAccountLink = async ()=>{
        switch(deploymentContainer.accountSelection){
            case "new":
                await linkNewAccount();
                break;
            case "existing":
                await linkExistingAccount();
                break;
        }
    };
    const handleAppLink = async ()=>{
        if (!deploymentContainer.linkedProjectId) return;
        await setPrimaryButtonLoading(true);
        await deploymentContainer.linkEnvironment(props.applicationId, props.environmentId, deploymentContainer.linkedProjectId);
        await deploymentsContainer.waitForEnvironmentDeployment(props.applicationId, props.environmentId, false, true, false);
        await setPrimaryButtonLoading(false);
    };
    const handleAccountSelectionChange = async (newValue)=>{
        if (!newValue) return;
        await deploymentContainer.setSelection("existing");
        await deploymentContainer.setAccountToLink(newValue.value, newValue.label);
    };
    const linkNewAccount = async ()=>{
        //openAuthWindow
        const request = {
            applicationId: props.applicationId,
            environmentId: props.environmentId
        };
        const urlResult = await deploymentContainer.getAuthUrl(request);
        if (urlResult) window.open(urlResult.data, "_self");
    };
    const linkExistingAccount = async ()=>{
        if (!deploymentContainer.tokenId) return;
        await setPrimaryButtonLoading(true);
        // Clear linkedProjectId
        await deploymentContainer.setDeployToApp("");
        const linkTokenResult = await deploymentContainer.linkTokenToEnvironment(props.applicationId, props.environmentId, deploymentContainer.tokenId);
        if (linkTokenResult && linkTokenResult.data) {
            await deploymentContainer.getAgents(deploymentContainer.tokenId);
            await deploymentContainer.setLinkingStatus("linkingApp");
        }
        await setPrimaryButtonLoading(false);
    };
    const handleUnlinkApp = async ()=>{
        await setLoaded(false);
        await deploymentContainer.unlinkEnvironmentAgent(props.applicationId, props.environmentId);
        await deploymentContainer.setLinkingStatus("linkingApp");
        await setLoaded(true);
    };
    const handleDisconnectAccount = async ()=>{
        await setLoaded(false);
        await deploymentContainer.unlinkEnvironmentUserAccount(props.applicationId, props.environmentId);
        await deploymentContainer.setLinkingStatus("initial");
        await setLoaded(true);
    };
    const copyText = (text)=>{
        navigator.clipboard.writeText(text);
    };
    var appName = deploymentContainer.availableApps.length ? deploymentContainer.availableApps.filter((a)=>a.id == deploymentContainer.linkedProjectId).map((a)=>a.name)[0] : null;
    var appNameOrPlaceholderText = appName && appName.length ? appName : deploymentContainer.loadingAvailableApps ? "Loading..." : "[deleted]";
    const renderStep1 = ()=>{
        if (deploymentContainer.status == "initial") return (0, _react.jsx)((0, _sharedStyledComponents.DeploymentStep), null, (0, _react.jsx)((0, _sharedStyledComponents.StepHeader), null, (0, _react.jsx)((0, _sharedStyledComponents.StepNumber), null, "1"), (0, _react.jsx)("div", null, "Connect Account")), (0, _react.jsx)((0, _radioGroupDefault.default), {
            options: [
                {
                    value: "new",
                    label: "Connect a new account"
                },
                {
                    value: "existing",
                    label: "Connect an existing account"
                }
            ],
            onChange: handleSelectionChange,
            value: deploymentContainer.accountSelection || (deploymentContainer.userName ? "existing" : "new")
        }), (0, _react.jsx)((0, _sharedStyledComponents.DeploymentSelector), {
            useFormTheme: true,
            useForm: false,
            options: deploymentContainer.availableCredentials.map((c)=>({
                    label: c.userName,
                    value: c.id
                })),
            disabled: deploymentContainer.accountSelection === "new",
            value: deploymentContainer.tokenId,
            onBlur: ()=>{},
            onChange: handleAccountSelectionChange.bind(undefined),
            label: "Account",
            name: "existingDeploymentAccount"
        }));
        else return (0, _react.jsx)((0, _sharedStyledComponents.LinkedAccount), null, (0, _react.jsx)((0, _sharedStyledComponents.StepHeader), null, (0, _react.jsx)((0, _sharedStyledComponents.StepNumber), null, "1"), (0, _react.jsx)("div", null, "Connect Account")), (0, _react.jsx)((0, _sharedStyledComponents.LabelAndButtonRow), null, (0, _react.jsx)((0, _sharedStyledComponents.LabeledText), null, (0, _react.jsx)("span", null, "Account"), (0, _react.jsx)("p", null, deploymentContainer.userName)), (0, _react.jsx)((0, _sharedStyledComponents.Filler), null), (0, _react.jsx)((0, _sharedStyledComponents.AlternateButton), {
            themes: [
                "secondary-small"
            ],
            text: "Disconnect",
            onClick: handleDisconnectAccount
        })));
    };
    const renderStep2 = ()=>{
        if (deploymentContainer.status == "linkingApp") return (0, _react.jsx)((0, _sharedStyledComponents.DeploymentStep), null, (0, _react.jsx)((0, _sharedStyledComponents.StepHeader), null, (0, _react.jsx)((0, _sharedStyledComponents.StepNumber), null, "2"), (0, _react.jsx)("div", null, "Link Agent")), (0, _react.jsx)(AdditionalStepSection, null, (0, _react.jsx)("img", {
            src: plusDarkIcon,
            alt: "plus icon"
        }), (0, _react.jsx)("p", null, "To create a new agent, visit the ", (0, _react.jsx)("a", {
            target: "_blank",
            href: "https://console.dialogflow.com"
        }, "Dialogflow console ", (0, _react.jsx)("img", {
            src: linkOutIcon
        })))), (0, _react.jsx)(StepSectionLabel, null, "Connect an existing agent"), (0, _react.jsx)((0, _sharedStyledComponents.DeploymentSelector), {
            useFormTheme: true,
            useForm: false,
            options: deploymentContainer.availableApps.map((a)=>({
                    value: a.id,
                    label: a.name
                })),
            value: deploymentContainer.linkedProjectId,
            onBlur: ()=>{},
            onChange: handleDeployToAppSelectionChange.bind(undefined),
            name: "deployToApp",
            label: "Agent"
        }));
        else return (0, _react.jsx)((0, _sharedStyledComponents.DeploymentStep), null, (0, _react.jsx)((0, _sharedStyledComponents.StepHeader), null, (0, _react.jsx)((0, _sharedStyledComponents.StepNumber), null, "2"), (0, _react.jsx)("div", null, "Link Agent")), (0, _react.jsx)((0, _sharedStyledComponents.LabelAndButtonRow), null, (0, _react.jsx)((0, _sharedStyledComponents.LabeledText), null, (0, _react.jsx)("span", null, "Agent"), (0, _react.jsx)("p", null, appNameOrPlaceholderText)), (0, _react.jsx)((0, _sharedStyledComponents.Filler), null), (0, _react.jsx)((0, _sharedStyledComponents.AlternateButton), {
            themes: [
                "secondary-small"
            ],
            text: "Disconnect",
            onClick: handleUnlinkApp
        })));
    };
    const getApplicationStatusText = ()=>{
        switch(props.applicationStatus){
            case "WAITING":
                return "Please wait...";
            case "LINKED":
                return "Agent linked";
            case "DEPLOYMENT_ISSUE":
                return "Deployment issues";
            case "UNKNOWN":
            default:
                return "Unknown";
        }
    };
    const getAdditionalStatusText = ()=>{
        switch(props.applicationStatus){
            case "WAITING":
                return "Your Voicify application is syncing with your Dialogflow agent";
            case "LINKED":
                return "Your Voicify application is synced with your dialogflow agent. Go to the dialogflow console to deploy it.";
            case "UNKNOWN":
                return "";
            default:
                return "";
        }
    };
    const renderStep3 = ()=>{
        const additionalStatusText = getAdditionalStatusText();
        return (0, _react.jsx)((0, _sharedStyledComponents.DeploymentStep), null, (0, _react.jsx)((0, _sharedStyledComponents.StepHeader), null, (0, _react.jsx)((0, _sharedStyledComponents.StepNumber), null, "3"), (0, _react.jsx)("div", null, "Launch")), (0, _react.jsx)((0, _sharedStyledComponents.LabelAndButtonRow), null, (0, _react.jsx)((0, _sharedStyledComponents.LabeledText), null, (0, _react.jsx)("span", null, "Application Status"), (0, _react.jsx)((0, _sharedStyledComponents.PublishStatusRow), null, (0, _react.jsx)("a", {
            href: "https://console.dialogflow.com/",
            target: "_blank"
        }, (0, _react.jsx)("img", {
            src: props.applicationStatusIcon
        })), (0, _react.jsx)("p", null, getApplicationStatusText()))), (0, _react.jsx)((0, _sharedStyledComponents.Filler), null), (0, _react.jsx)((0, _sharedStyledComponents.StyledLink), {
            target: "_blank",
            href: "https://support.voicify.com/knowledge/getting-started-with-voicify-part-4-deploying-to-alexa-and-google"
        }, "View our launch docs")), (props.launchMessage || additionalStatusText) && (0, _react.jsx)((0, _sharedStyledComponents.LabeledText), null, (0, _react.jsx)("p", null, props.launchMessage ?? additionalStatusText)));
    };
    const isMainButtonDisabled = ()=>{
        if (workflowStep == 1 && !deploymentContainer.tokenId) return true;
        if (workflowStep == 2 && !deploymentContainer.linkedProjectId) return true;
        return false;
    };
    const renderMainButton = ()=>{
        if (deploymentContainer.status == "finished") return (0, _react.jsx)("a", {
            href: "https://console.dialogflow.com/",
            target: "_blank"
        }, (0, _react.jsx)((0, _sharedStyledComponents.MainButton), {
            themes: [
                "primary",
                "wide"
            ],
            text: "Developer Console",
            loading: primaryButtonLoading,
            disabled: primaryButtonLoading,
            type: "button",
            rightIcon: linkOutWhiteIcon,
            onClick: null
        }));
        if (deploymentContainer.accountSelection != "new") return (0, _react.jsx)((0, _sharedStyledComponents.MainButton), {
            themes: [
                "primary",
                "wide"
            ],
            text: "Link",
            type: "button",
            loading: primaryButtonLoading,
            disabled: primaryButtonLoading || isMainButtonDisabled(),
            onClick: handleLinkButton.bind(undefined)
        });
        else return (0, _react.jsx)((0, _sharedStyledComponents.LoginImage), {
            src: googleButton,
            onClick: linkNewAccount
        });
    };
    return (0, _react.jsx)((0, _sharedStyledComponents.CardContainer), null, (0, _react.jsx)((0, _sharedStyledComponents.DeploymentsCard), {
        id: "dialogflow-card"
    }, (0, _react.jsx)((0, _sharedStyledComponents.LogoEndpointsHeader), null, (0, _react.jsx)((0, _sharedStyledComponents.Logo), {
        src: dialogflowLogo
    }), (0, _react.jsx)((0, _sharedStyledComponents.Filler), null), (0, _react.jsx)((0, _buttonDefault.default), {
        themes: [
            "secondary-small"
        ],
        disabled: props.endpoints?.dialogFlowEndpoint == null,
        text: showEndpoints ? "Hide Endpoints" : "Show Endpoints",
        onClick: ()=>setShowEndpoints(!showEndpoints),
        type: "button",
        rightIcon: showEndpoints ? endpointButtonIconActive : endpointButtonIconInactive,
        className: showEndpoints ? `button-active` : null
    })), showEndpoints && (0, _react.jsx)((0, _reactDefault.default).Fragment, null, (0, _react.jsx)((0, _sharedStyledComponents.TopTriangleStyle), null), (0, _react.jsx)((0, _sharedStyledComponents.Endpoints), null, (0, _react.jsx)((0, _sharedStyledComponents.EndpointsHeader), null, "Fulfillment Endpoints"), (0, _react.jsx)((0, _horizontalContainerDefault.default), null, (0, _react.jsx)((0, _textFieldDefault.default), {
        useForm: false,
        value: props.endpoints?.dialogFlowEndpoint,
        onChange: null,
        readOnly: true,
        label: "Direct Fulfillment"
    }), (0, _react.jsx)((0, _sharedStyledComponents.CopyButton), {
        themes: [
            "secondary"
        ],
        text: "Copy",
        type: "button",
        onClick: ()=>copyText(props.endpoints?.dialogFlowEndpoint)
    })))), (0, _react.jsx)((0, _sharedStyledComponents.HelperText), null, (0, _react.jsx)("p", null, "Let’s get you ready to deploy to Dialogflow! ", (0, _react.jsx)("br", null), " ", (0, _react.jsx)("br", null)), (0, _react.jsx)("p", null, "This process will get your account on Voicify synced with your Google account and deploy your app to a specific Dialogflow agent. "), (0, _react.jsx)((0, _sharedStyledComponents.StyledLink), {
        target: "_blank",
        href: "https://support.voicify.com/en/knowledge/dialogflow-deployment"
    }, "Read More ")), (0, _react.jsx)((0, _sharedStyledComponents.WorkflowStepContainer), null, (0, _react.jsx)((0, _deploymentWorkflowStepDefault.default), {
        name: "Connect Account",
        currentStep: workflowStep,
        step: 1
    }), (0, _react.jsx)((0, _deploymentWorkflowStepDefault.default), {
        name: "Link Agent",
        currentStep: workflowStep,
        step: 2
    }), (0, _react.jsx)((0, _deploymentWorkflowStepDefault.default), {
        name: "Launch",
        currentStep: workflowStep,
        step: 3
    }), (0, _react.jsx)((0, _deploymentWorkflowStepDefault.default), {
        last: true,
        icon: props.applicationStatusIcon,
        currentStep: workflowStep,
        step: 4,
        href: "https://console.dialogflow.com/"
    })), !loaded && (0, _react.jsx)((0, _loaderDefault.default), {
        className: customLoaderStyle
    }), loaded && (0, _react.jsx)((0, _reactDefault.default).Fragment, null, workflowStep >= 1 && renderStep1(), workflowStep >= 2 && renderStep2(), workflowStep >= 3 && renderStep3(), renderMainButton())), (0, _react.jsx)((0, _pageErrorDefault.default), {
        errors: deploymentContainer.errors,
        onClear: deploymentContainer.clearErrors
    }));
};
const customLoaderStyle = /*#__PURE__*/ (0, _css.css)({
    name: "1pp2wda",
    styles: "position:relative;top:auto;margin-top:30px;margin-bottom:30px"
});
const AdditionalStepSection = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "enzgmcq1"
})("display:flex;align-items:center;margin:24px 0;>img{margin-right:12px;}a{color:", (0, _colors.color_text_link), ";}");
const StepSectionLabel = /*#__PURE__*/ (0, _baseDefault.default)("p", {
    target: "enzgmcq0"
})({
    name: "zvw9v1",
    styles: "margin:8px 0 16px 0"
});
exports.default = DialogflowDeploymentCard;

},{"@emotion/styled/base":"lSuFu","@emotion/react":"djZKr","@emotion/css":"awUBr","react":"6uln9","../../../components/forms/RadioGroup":"eiGrn","../../../components/general/Button":"6ymxN","../../../constants/colors":"1p3OR","../../../components/general/PageError":"ezFTm","./SharedStyledComponents":"9COIL","../../../components/structure/HorizontalContainer":"eJPfh","../../../components/forms/TextField":"7a7bh","./DeploymentWorkflowStep":"lgTpr","../../../components/general/Loader":"bnV5T","../../../hooks/DialogflowDeploymentContainer":"aCLZk","../../../hooks/DeploymentsContainer":"54k9j","93f3692668dcb723":"dlZOG","6d5d797d4264b":"kz8Cp","23db173b2a54afc":"bDy63","26cc14e861ce7b9e":"9mnp5","26e3912cc3aac2dc":"cTohd","63d279fe31c68e09":"fyNwe","709bf33eb09ca0cc":"9ewOE","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"aCLZk":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _unstatedNext = require("unstated-next");
var _api = require("../api");
function useDialogflowDeploymentContainer() {
    const [isLoading, setIsLoading] = (0, _react.useState)(false);
    const [errors, setErrors] = (0, _react.useState)([]);
    const [accountSelection, setAccountSelection] = (0, _react.useState)("new");
    const [availableApps, setAvailableApps] = (0, _react.useState)([]);
    const [availableCredentials, setAvailableCredentials] = (0, _react.useState)([]);
    const [tokenId, setTokenId] = (0, _react.useState)(null);
    const [linkedProjectId, setLinkedProjectId] = (0, _react.useState)(null);
    const [userName, setUserName] = (0, _react.useState)(null);
    const [loadingAvailableApps, setLoadingAvailableApps] = (0, _react.useState)(false);
    const [status, setStatus] = (0, _react.useState)("initial");
    const [currentApplicationId, setCurrentApplicationId] = (0, _react.useState)(null);
    const [currentEnvironmentId, setCurrentEnvironmentId] = (0, _react.useState)(null);
    const reset = ()=>{
        setStatus("initial");
        setAccountSelection("new");
        setLoadingAvailableApps(false);
        setAvailableApps([]);
        setAvailableCredentials([]);
        setTokenId(null);
        setLinkedProjectId(null);
        setUserName(null);
        setErrors([]);
        setCurrentApplicationId(null);
        setCurrentEnvironmentId(null);
    };
    const setSelection = async (selection)=>{
        if (selection === "new") await setTokenId(null);
        await setAccountSelection(selection);
    };
    const setDeployToApp = (linkedProjectId)=>{
        setLinkedProjectId(linkedProjectId);
    };
    const setLinkingStatus = async (status)=>{
        await setStatus(status);
    };
    const setAccountToLink = (tokenId, userName)=>{
        setTokenId(tokenId);
        setUserName(userName);
    };
    const getAuthUrl = (request)=>{
        return _api.getDialogflowAuthUrl(request).catch((err)=>{
            setErrors([
                err.toString()
            ]);
        });
    };
    const getAgents = (tokenId)=>{
        setLoadingAvailableApps(true);
        return _api.listDialogflowAgents(tokenId).then((result)=>{
            if (result.resultType == "Ok") {
                setLoadingAvailableApps(false);
                setAvailableApps(result.data.map((a)=>({
                        id: a.parent,
                        name: a.displayName
                    })));
            } else {
                setLoadingAvailableApps(false);
                setErrors(result.errors);
            }
            return result;
        }).catch((err)=>{
            setLoadingAvailableApps(false);
            setErrors([
                err.toString()
            ]);
        });
    };
    const getAvailableCredentials = (organizationId)=>{
        return _api.getAvailableDialogflowCredentials(organizationId).then((result)=>{
            if (result.resultType == "Ok") setAvailableCredentials(result.data.map((t)=>({
                    id: t.id,
                    userName: t.userName
                })));
            else setErrors(result.errors);
            return result;
        }).catch((err)=>{
            setErrors([
                err.toString()
            ]);
        });
    };
    const loadEnvironmentDeploymentInformation = async (applicationId, environmentId, organizationId)=>{
        try {
            if (currentApplicationId === applicationId && currentEnvironmentId === environmentId) return;
            await setIsLoading(true);
            const link = await getEnvironmentDeploymentStatus(applicationId, environmentId);
            if (link.linkedProjectId && link.userName) {
                await setLinkingStatus("finished");
                await setSelection("existing");
            } else if (link.userName) {
                await setLinkingStatus("linkingApp");
                await setSelection("existing");
            }
            await getAvailableCredentials(organizationId);
            if (link.tokenId) await getAgents(link.tokenId);
            await setIsLoading(false);
        } catch (err) {
            setIsLoading(false);
            setErrors([
                err.toString()
            ]);
        }
    };
    const getEnvironmentDeploymentStatus = async (applicationId, environmentId)=>{
        try {
            await setCurrentApplicationId(applicationId);
            await setCurrentEnvironmentId(environmentId);
            // Need to clear ProjectId (DialogflowAgentId), UserName and TokenId before getEnvironmentDeploymentInfoForDialogflow call
            await setLinkedProjectId(null);
            await setUserName(null);
            await setTokenId(null);
            const result = await _api.getEnvironmentDeploymentInfoForDialogflow(applicationId, environmentId);
            if (result.resultType === "Ok") {
                const status = result.data;
                await setLinkedProjectId(status.linkedProjectId);
                await setUserName(status.userName);
                await setTokenId(status.tokenId);
                await setErrors([]);
                return status;
            } else await setErrors(result.errors);
        } catch (err) {
            setErrors([
                err.toString()
            ]);
        }
    };
    const linkEnvironment = async (applicationId, environmentId, projectId)=>{
        try {
            const response = await _api.linkEnvironmentToDialogflowAgent(applicationId, environmentId, projectId);
            if (response.resultType != "Ok") await setErrors(response.errors);
            else {
                await setLinkingStatus("finished");
                await setLinkedProjectId(projectId);
            }
        } catch (err) {
            setErrors([
                err.toString()
            ]);
        }
    };
    const linkTokenToEnvironment = async (applicationId, environmentId, tokenId)=>{
        return _api.linkDialogflowTokenToEnvironment(applicationId, environmentId, tokenId).then((result)=>{
            if (result.resultType != "Ok") setErrors(result.errors);
            return result;
        }).catch((err)=>{
            setErrors([
                err.toString()
            ]);
        });
    };
    const unlinkEnvironmentAgent = async (applicationId, environmentId)=>{
        setStatus("linkingApp");
        setLinkedProjectId(null);
        return _api.unlinkDialogflowAgentFromEnvironment(applicationId, environmentId).then((result)=>{
            if (result.resultType != "Ok") setErrors(result.errors);
        }).catch((err)=>{
            setErrors([
                err.toString()
            ]);
        });
    };
    const unlinkEnvironmentUserAccount = async (applicationId, environmentId)=>{
        if (linkedProjectId != null) unlinkEnvironmentAgent(applicationId, environmentId);
        return _api.removeDialogflowAuthTokenFromEnvironment(applicationId, environmentId).then((result)=>{
            if (result.resultType != "Ok") setErrors(result.errors);
        }).catch((err)=>{
            setErrors([
                err.toString()
            ]);
        });
    };
    const clearErrors = ()=>{
        setErrors([]);
    };
    return {
        reset,
        setSelection,
        setDeployToApp,
        setLinkingStatus,
        setAccountToLink,
        getAuthUrl,
        getAgents,
        getAvailableCredentials,
        loadEnvironmentDeploymentInformation,
        getEnvironmentDeploymentStatus,
        linkEnvironment,
        linkTokenToEnvironment,
        unlinkEnvironmentAgent,
        unlinkEnvironmentUserAccount,
        currentEnvironmentId,
        status,
        accountSelection,
        linkedProjectId,
        tokenId,
        userName,
        availableCredentials,
        availableApps,
        loadingAvailableApps,
        isLoading,
        errors,
        clearErrors
    };
}
const DialogflowDeploymentContainer = (0, _unstatedNext.createContainer)(useDialogflowDeploymentContainer);
exports.default = DialogflowDeploymentContainer;

},{"react":"6uln9","unstated-next":"61zE5","../api":"loxM6","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"dlZOG":[function(require,module,exports) {
module.exports = require("e853ee22bf075327").getBundleURL("kVLro") + require("2ce535168fd33bc2").resolve("1q2e4");

},{"e853ee22bf075327":"c7Tr5","2ce535168fd33bc2":"fyJL2"}],"cTohd":[function(require,module,exports) {
module.exports = require("8e06bc9f97c5edff").getBundleURL("kVLro") + require("242dcdb721ef4ad1").resolve("iDO29");

},{"8e06bc9f97c5edff":"c7Tr5","242dcdb721ef4ad1":"fyJL2"}],"ledij":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _radioGroup = require("../../../components/forms/RadioGroup");
var _radioGroupDefault = parcelHelpers.interopDefault(_radioGroup);
var _button = require("../../../components/general/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _pageError = require("../../../components/general/PageError");
var _pageErrorDefault = parcelHelpers.interopDefault(_pageError);
var _textField = require("../../../components/forms/TextField");
var _textFieldDefault = parcelHelpers.interopDefault(_textField);
var _secondaryLoader = require("../../../components/general/SecondaryLoader");
var _secondaryLoaderDefault = parcelHelpers.interopDefault(_secondaryLoader);
var _sharedStyledComponents = require("./SharedStyledComponents");
var _horizontalContainer = require("../../../components/structure/HorizontalContainer");
var _horizontalContainerDefault = parcelHelpers.interopDefault(_horizontalContainer);
var _deploymentWorkflowStep = require("./DeploymentWorkflowStep");
var _deploymentWorkflowStepDefault = parcelHelpers.interopDefault(_deploymentWorkflowStep);
var _microsoftDeploymentContainer = require("../../../hooks/MicrosoftDeploymentContainer");
var _microsoftDeploymentContainerDefault = parcelHelpers.interopDefault(_microsoftDeploymentContainer);
const microsoftLogo = require("97fde38065de5b34");
const linkOutIcon = require("9d1eda7f85792ef3");
const linkOutWhiteIcon = require("c56144e97733596e");
const endpointButtonIconActive = require("305e5d4c5b65c16b");
const endpointButtonIconInactive = require("41b07d6c78ada95d");
const MicrosoftDeploymentCard = (props)=>{
    const deploymentContainer = (0, _microsoftDeploymentContainerDefault.default).useContainer();
    const [showEndpoints, setShowEndpoints] = (0, _react1.useState)(false);
    const [workflowStep, setWorkflowStep] = (0, _react1.useState)(1);
    (0, _react1.useEffect)(()=>{
        deploymentContainer.getEnvironmentCurrentLink(props.applicationId, props.environmentId);
    }, [
        props.applicationId,
        props.environmentId
    ]);
    (0, _react1.useEffect)(()=>{
        switch(deploymentContainer.currentStep){
            case 1:
                setWorkflowStep(1);
                break;
            case 2:
                setWorkflowStep(2);
                break;
            case 3:
                setWorkflowStep(3);
                break;
            case 4:
            default:
                setWorkflowStep(4);
                break;
        }
    }, [
        deploymentContainer.currentStep
    ]);
    const copyText = (text)=>{
        navigator.clipboard.writeText(text);
    };
    const handleLinkOrCreateLuis = async ()=>{
        if (deploymentContainer.luisAppType === "new") await deploymentContainer.createAndDeployEnvironmentNewLuisApp(props.applicationId, props.environmentId);
        else await deploymentContainer.linkEnvironmentToLuisApp(props.applicationId, props.environmentId);
    };
    const handleCreateLiusResourses = async ()=>{
        await deploymentContainer.linkEnvironmentLuisResources(props.applicationId, props.environmentId);
    };
    const isMainButtonDisabled = (step)=>{
        if (deploymentContainer.isLinkingApp || deploymentContainer.isLoadingApps || deploymentContainer.isCreatingApp) return true;
        if (step === 1 && (!deploymentContainer.deploymentLink.botServiceName?.trim() || !deploymentContainer.deploymentLink.microsoftAppId?.trim() || !deploymentContainer.deploymentLink.microsoftAppPassword?.trim())) return true;
        if (step === 2 && (!deploymentContainer.deploymentLink.luisAuthoringKey?.trim() || !deploymentContainer.deploymentLink.luisPredictionKey?.trim() || !deploymentContainer.deploymentLink.luisPredictionRegion?.trim() || !deploymentContainer.deploymentLink.luisPredictionEndpoint?.trim())) return true;
        if (step === 3 && !deploymentContainer.deploymentLink.luisAppId && deploymentContainer.luisAppType === "existing") return true;
        return false;
    };
    const renderStep1 = ()=>{
        return (0, _react.jsx)((0, _reactDefault.default).Fragment, null, (0, _react.jsx)((0, _sharedStyledComponents.DeploymentStep), null, (0, _react.jsx)((0, _sharedStyledComponents.StepHeader), null, (0, _react.jsx)((0, _sharedStyledComponents.StepNumber), null, "1"), (0, _react.jsx)("div", null, "Registration")), (0, _react.jsx)((0, _sharedStyledComponents.EndpointsHeader), null, (0, _react.jsx)((0, _sharedStyledComponents.StepHelperText), null, "Copy your endpoint url")), (0, _react.jsx)((0, _horizontalContainerDefault.default), null, (0, _react.jsx)((0, _textFieldDefault.default), {
            useForm: false,
            value: props.endpoints?.botServiceEndpoint || "",
            onChange: null,
            readOnly: true,
            label: "Endpoint Url"
        }), (0, _react.jsx)((0, _sharedStyledComponents.CopyButton), {
            themes: [
                "secondary"
            ],
            text: "Copy",
            type: "button",
            onClick: ()=>copyText(props.endpoints?.botServiceEndpoint)
        })), (0, _react.jsx)((0, _sharedStyledComponents.BorderSeparator), null), (0, _react.jsx)((0, _sharedStyledComponents.StepHelperText), null, (0, _react.jsx)("p", null, "Register your account in the Azure Portal. View our documents for more information on what to do.", (0, _react.jsx)((0, _sharedStyledComponents.StyledLink), {
            target: "_blank",
            href: "https://support.voicify.com/en/knowledge/microsoft-deployment"
        }, " Read More "))), (0, _react.jsx)((0, _sharedStyledComponents.StepHelperText), null, (0, _react.jsx)((0, _sharedStyledComponents.StyledLink), {
            target: "_blank",
            href: "https://portal.azure.com/"
        }, " Open Developer Portal ", (0, _react.jsx)("img", {
            src: linkOutIcon
        }))), (0, _react.jsx)((0, _sharedStyledComponents.StepHelperText), null, (0, _react.jsx)("p", null, "Once you’ve registered your bot in the Azure Portal, copy these fields into Voicify:")), (0, _react.jsx)((0, _sharedStyledComponents.StepFormContainer), null, (0, _react.jsx)((0, _textFieldDefault.default), {
            required: true,
            useForm: false,
            name: "botname",
            label: "Bot Service Handle",
            placeholder: "Get this from your bot service in azure",
            value: deploymentContainer.deploymentLink.botServiceName,
            onChange: (e)=>deploymentContainer.setBotName(e.target.value),
            onBlur: ()=>{}
        }), (0, _react.jsx)((0, _textFieldDefault.default), {
            required: true,
            useForm: false,
            name: "msappid",
            label: "Microsoft App ID",
            placeholder: "Get this from your bot service in azure",
            value: deploymentContainer.deploymentLink.microsoftAppId,
            onChange: (e)=>deploymentContainer.setMsAppId(e.target.value),
            onBlur: ()=>{}
        }), (0, _react.jsx)((0, _textFieldDefault.default), {
            required: true,
            useForm: false,
            name: "msapppassword",
            label: "Microsoft App Secret Value",
            placeholder: "Get this from your bot service in azure",
            value: deploymentContainer.deploymentLink.microsoftAppPassword,
            onChange: (e)=>deploymentContainer.setMsAppPassword(e.target.value),
            onBlur: ()=>{}
        }))), (0, _react.jsx)((0, _sharedStyledComponents.MainButton), {
            themes: [
                "primary",
                "wide"
            ],
            text: "Link",
            type: "button",
            disabled: isMainButtonDisabled(workflowStep),
            onClick: ()=>deploymentContainer.linkEnvironmentToBot(props.applicationId, props.environmentId)
        }));
    };
    const renderStep1Complete = ()=>{
        return (0, _react.jsx)((0, _sharedStyledComponents.DeploymentStep), null, (0, _react.jsx)((0, _sharedStyledComponents.StepHeader), null, (0, _react.jsx)((0, _sharedStyledComponents.StepNumber), null, "1"), (0, _react.jsx)("div", null, "Registration")), (0, _react.jsx)((0, _sharedStyledComponents.LabelAndButtonRow), null, (0, _react.jsx)((0, _sharedStyledComponents.LabeledText), null, (0, _react.jsx)("span", null, "Bot Service Handle"), (0, _react.jsx)("p", null, deploymentContainer.deploymentLink.botServiceName)), (0, _react.jsx)((0, _sharedStyledComponents.Filler), null)), (0, _react.jsx)((0, _sharedStyledComponents.LabelAndButtonRow), null, (0, _react.jsx)((0, _sharedStyledComponents.LabeledText), null, (0, _react.jsx)("span", null, "Microsoft App ID"), (0, _react.jsx)("p", null, deploymentContainer.deploymentLink.microsoftAppId)), (0, _react.jsx)((0, _sharedStyledComponents.Filler), null)), (0, _react.jsx)((0, _sharedStyledComponents.LabelAndButtonRow), null, (0, _react.jsx)((0, _sharedStyledComponents.LabeledText), null, (0, _react.jsx)("span", null, "Microsoft App Secret Value"), (0, _react.jsx)("p", null, deploymentContainer.deploymentLink.microsoftAppPassword?.substr(0, 4) + "**************")), (0, _react.jsx)((0, _sharedStyledComponents.Filler), null), (0, _react.jsx)((0, _sharedStyledComponents.AlternateButton), {
            themes: [
                "secondary-small"
            ],
            text: "Disconnect",
            onClick: ()=>deploymentContainer.unlinkEnvironmentMicrosoftProject(props.applicationId, props.environmentId)
        })));
    };
    const renderStep2 = ()=>{
        return (0, _react.jsx)((0, _reactDefault.default).Fragment, null, (0, _react.jsx)((0, _sharedStyledComponents.DeploymentStep), null, (0, _react.jsx)((0, _sharedStyledComponents.StepHeader), null, (0, _react.jsx)((0, _sharedStyledComponents.StepNumber), null, "2"), (0, _react.jsx)("div", null, "Luis Resources Setup")), (0, _react.jsx)((0, _sharedStyledComponents.StepHelperText), null, (0, _react.jsx)("p", null, "To learn how to create your Microsoft Luis App and set up your Luis resources, see the Voicify knowledge base article.", (0, _react.jsx)((0, _sharedStyledComponents.StyledLink), {
            target: "_blank",
            href: "https://support.voicify.com/en/knowledge/how-do-i-get-luis-resource-information"
        }, " Read More "))), (0, _react.jsx)((0, _sharedStyledComponents.StepHelperText), null, (0, _react.jsx)((0, _sharedStyledComponents.StyledLink), {
            target: "_blank",
            href: "https://portal.azure.com/"
        }, " Open Developer Portal ", (0, _react.jsx)("img", {
            src: linkOutIcon
        }))), (0, _react.jsx)((0, _sharedStyledComponents.StepHelperText), null, (0, _react.jsx)("p", null, "Create a Microsoft Luis App and paste required info here:")), (0, _react.jsx)((0, _sharedStyledComponents.StepFormContainer), null, (0, _react.jsx)((0, _textFieldDefault.default), {
            required: true,
            useForm: false,
            name: "luiskey",
            label: "Azure Language Understanding / Luis Authoring Key",
            placeholder: "Get this from your Luis account settings",
            value: deploymentContainer.deploymentLink.luisAuthoringKey,
            onChange: (e)=>deploymentContainer.setAuthoringKey(e.target.value)
        }), (0, _react.jsx)((0, _textFieldDefault.default), {
            required: true,
            useForm: false,
            name: "luisPredictionKey",
            label: "Azure Language Understanding / Luis Prediction Key",
            placeholder: "Get this from your Luis account settings",
            value: deploymentContainer.deploymentLink.luisPredictionKey,
            onChange: (e)=>deploymentContainer.setPredictionKey(e.target.value)
        }), (0, _react.jsx)((0, _textFieldDefault.default), {
            required: true,
            useForm: false,
            name: "luisPredictionRegion",
            label: "Azure Language Understanding / Luis Prediction Region",
            placeholder: "Get this from your Luis account settings",
            value: deploymentContainer.deploymentLink.luisPredictionRegion,
            onChange: (e)=>deploymentContainer.setPredictionRegion(e.target.value)
        }), (0, _react.jsx)((0, _textFieldDefault.default), {
            required: true,
            useForm: false,
            name: "luisPredictionEndpoint",
            label: "Azure Language Understanding / Luis Prediction Endpoint",
            placeholder: "Get this from your Luis account settings",
            value: deploymentContainer.deploymentLink.luisPredictionEndpoint,
            onChange: (e)=>deploymentContainer.setPredictionEndpoint(e.target.value)
        }))), (0, _react.jsx)((0, _sharedStyledComponents.MainButton), {
            themes: [
                "primary",
                "wide"
            ],
            text: "Link",
            type: "button",
            disabled: isMainButtonDisabled(workflowStep),
            onClick: handleCreateLiusResourses
        }));
    };
    const renderStep2Complete = ()=>{
        return (0, _react.jsx)((0, _sharedStyledComponents.DeploymentStep), null, (0, _react.jsx)((0, _sharedStyledComponents.StepHeader), null, (0, _react.jsx)((0, _sharedStyledComponents.StepNumber), null, "2"), (0, _react.jsx)("div", null, "Luis Resources Setup")), (0, _react.jsx)((0, _sharedStyledComponents.LabelAndButtonRow), null, (0, _react.jsx)((0, _sharedStyledComponents.LabeledText), null, (0, _react.jsx)("span", null, "Azure Language Understanding / Luis Authoring Key"), (0, _react.jsx)("p", null, deploymentContainer.deploymentLink.luisAuthoringKey?.substr(0, 4) + "*****************************")), (0, _react.jsx)((0, _sharedStyledComponents.Filler), null)), (0, _react.jsx)((0, _sharedStyledComponents.LabelAndButtonRow), null, (0, _react.jsx)((0, _sharedStyledComponents.LabeledText), null, (0, _react.jsx)("span", null, "Azure Language Understanding / Luis Prediction Key"), (0, _react.jsx)("p", null, deploymentContainer.deploymentLink.luisPredictionKey?.substr(0, 4) + "*****************************")), (0, _react.jsx)((0, _sharedStyledComponents.Filler), null)), (0, _react.jsx)((0, _sharedStyledComponents.LabelAndButtonRow), null, (0, _react.jsx)((0, _sharedStyledComponents.LabeledText), null, (0, _react.jsx)("span", null, "Azure Language Understanding / Luis Prediction Region"), (0, _react.jsx)("p", null, deploymentContainer.deploymentLink.luisPredictionRegion)), (0, _react.jsx)((0, _sharedStyledComponents.Filler), null)), (0, _react.jsx)((0, _sharedStyledComponents.LabelAndButtonRow), null, (0, _react.jsx)((0, _sharedStyledComponents.LabeledText), null, (0, _react.jsx)("span", null, "Azure Language Understanding / Luis Prediction Endpoint"), (0, _react.jsx)("p", null, deploymentContainer.deploymentLink.luisPredictionEndpoint)), (0, _react.jsx)((0, _sharedStyledComponents.Filler), null), (0, _react.jsx)((0, _sharedStyledComponents.AlternateButton), {
            themes: [
                "secondary-small"
            ],
            text: "Disconnect",
            onClick: ()=>deploymentContainer.unlinkEnvironmentLuisApp(props.applicationId, props.environmentId)
        })));
    };
    const handleCreateNewSelectionChange = async (newValue)=>{
        if (!newValue) return;
        await deploymentContainer.setLuisAppSelection(newValue.value);
    };
    const handleAppSelectionChange = async (option)=>{
        const o = option.value;
        await deploymentContainer.setLuisAppId(o);
    };
    const renderStep3 = ()=>{
        // choose existing luis or create new
        return (0, _react.jsx)((0, _reactDefault.default).Fragment, null, (0, _react.jsx)((0, _sharedStyledComponents.DeploymentStep), null, (0, _react.jsx)((0, _sharedStyledComponents.StepHeader), null, (0, _react.jsx)((0, _sharedStyledComponents.StepNumber), null, "3"), (0, _react.jsx)("div", null, "Link Luis App")), (0, _react.jsx)((0, _sharedStyledComponents.StepHelperText), null, (0, _react.jsx)("p", null, "Link your Voicify app to a Luis application:")), (0, _react.jsx)((0, _radioGroupDefault.default), {
            options: [
                {
                    value: "new",
                    label: "Create a new app"
                },
                {
                    value: "existing",
                    label: "Connect to an existing app"
                }
            ],
            onChange: handleCreateNewSelectionChange,
            value: deploymentContainer.luisAppType || "new"
        }), (0, _react.jsx)((0, _sharedStyledComponents.DeploymentSelector), {
            useFormTheme: true,
            useForm: false,
            options: deploymentContainer.luisApps?.map((a)=>({
                    value: a.id,
                    label: a.name
                })),
            disabled: deploymentContainer.luisAppType === "new" || deploymentContainer.isLoadingApps || deploymentContainer.isCreatingApp,
            value: deploymentContainer.deploymentLink.luisAppId,
            onBlur: ()=>{},
            onChange: handleAppSelectionChange,
            name: "deployToApp",
            label: "Luis Application"
        })), (0, _react.jsx)((0, _sharedStyledComponents.MainButton), {
            themes: [
                "primary",
                "wide"
            ],
            text: deploymentContainer.luisAppType === "new" ? "Create" : "Link",
            type: "button",
            loading: deploymentContainer.isCreatingApp,
            disabled: isMainButtonDisabled(workflowStep),
            onClick: handleLinkOrCreateLuis
        }));
    };
    const renderStep3Complete = ()=>{
        const luisApp = deploymentContainer.luisApps.find((a)=>a.id == deploymentContainer.deploymentLink.luisAppId);
        return (0, _react.jsx)((0, _sharedStyledComponents.DeploymentStep), null, (0, _react.jsx)((0, _sharedStyledComponents.StepHeader), null, (0, _react.jsx)((0, _sharedStyledComponents.StepNumber), null, "3"), (0, _react.jsx)("div", null, "Link Luis App")), deploymentContainer.isLoadingApps ? (0, _react.jsx)((0, _secondaryLoaderDefault.default), null) : (0, _react.jsx)((0, _reactDefault.default).Fragment, null, (0, _react.jsx)((0, _sharedStyledComponents.LabelAndButtonRow), null, (0, _react.jsx)((0, _sharedStyledComponents.LabeledText), null, (0, _react.jsx)("span", null, "Luis App Name"), (0, _react.jsx)("p", null, deploymentContainer.luisAppName ? deploymentContainer.luisAppName : luisApp ? luisApp.name : "Unknown")), (0, _react.jsx)((0, _sharedStyledComponents.Filler), null)), (0, _react.jsx)((0, _sharedStyledComponents.LabelAndButtonRow), null, (0, _react.jsx)((0, _sharedStyledComponents.LabeledText), null, (0, _react.jsx)("span", null, "Luis App ID"), (0, _react.jsx)("p", null, deploymentContainer.deploymentLink.luisAppId)), (0, _react.jsx)((0, _sharedStyledComponents.Filler), null)), (0, _react.jsx)((0, _sharedStyledComponents.LabelAndButtonRow), null, (0, _react.jsx)((0, _sharedStyledComponents.LabeledText), null, (0, _react.jsx)("span", null, "Luis Region"), (0, _react.jsx)("p", null, deploymentContainer.deploymentLink.luisRegion)), (0, _react.jsx)((0, _sharedStyledComponents.Filler), null), (0, _react.jsx)((0, _sharedStyledComponents.AlternateButton), {
            themes: [
                "secondary-small"
            ],
            text: "Disconnect",
            onClick: ()=>deploymentContainer.unlinkEnvironmentLuisApp(props.applicationId, props.environmentId)
        }))));
    };
    const renderStep4Complete = ()=>{
        return (0, _react.jsx)((0, _reactDefault.default).Fragment, null, (0, _react.jsx)((0, _sharedStyledComponents.DeploymentStep), null, (0, _react.jsx)((0, _sharedStyledComponents.StepHeader), null, (0, _react.jsx)((0, _sharedStyledComponents.StepNumber), null, "4"), (0, _react.jsx)("div", null, "Launch")), (0, _react.jsx)((0, _sharedStyledComponents.LabelAndButtonRow), null, (0, _react.jsx)((0, _sharedStyledComponents.LabeledText), null, (0, _react.jsx)("span", null, "Application Status"), (0, _react.jsx)((0, _sharedStyledComponents.PublishStatusRow), null, (0, _react.jsx)("a", {
            href: "https://portal.azure.com/",
            target: "_blank"
        }, (0, _react.jsx)("img", {
            src: props.applicationStatusIcon
        })), (0, _react.jsx)("p", null, "Linked"))), (0, _react.jsx)((0, _sharedStyledComponents.Filler), null), (0, _react.jsx)((0, _sharedStyledComponents.StyledLink), {
            target: "_blank",
            href: "https://support.voicify.com/en/knowledge/microsoft-deployment"
        }, "View our launch docs")), (0, _react.jsx)((0, _sharedStyledComponents.StepHelperText), null, (0, _react.jsx)("p", null, "Your Voicify and Luis apps are linked."))), (0, _react.jsx)("a", {
            href: "https://portal.azure.com/",
            target: "_blank"
        }, (0, _react.jsx)((0, _sharedStyledComponents.MainButton), {
            themes: [
                "primary",
                "wide"
            ],
            text: "Developer Portal",
            type: "button",
            disabled: isMainButtonDisabled(workflowStep),
            rightIcon: linkOutWhiteIcon,
            onClick: null
        })));
    };
    const renderStepContent = ()=>{
        const currentStep = deploymentContainer.currentStep;
        return (0, _react.jsx)((0, _reactDefault.default).Fragment, null, currentStep == 1 ? renderStep1() : null, currentStep > 1 ? renderStep1Complete() : null, currentStep == 2 ? renderStep2() : null, currentStep > 2 ? renderStep2Complete() : null, currentStep == 3 ? renderStep3() : null, currentStep > 3 ? renderStep3Complete() : null, currentStep >= 4 ? renderStep4Complete() : null);
    };
    return (0, _react.jsx)((0, _sharedStyledComponents.CardContainer), null, (0, _react.jsx)((0, _sharedStyledComponents.DeploymentsCard), {
        id: "bot-service-card"
    }, (0, _react.jsx)((0, _sharedStyledComponents.LogoEndpointsHeader), null, (0, _react.jsx)((0, _sharedStyledComponents.Logo), {
        src: microsoftLogo
    }), (0, _react.jsx)((0, _buttonDefault.default), {
        themes: [
            "secondary-small"
        ],
        disabled: props.endpoints?.botServiceEndpoint == null,
        text: showEndpoints ? "Hide Endpoints" : "Show Endpoints",
        onClick: ()=>setShowEndpoints(!showEndpoints),
        type: "button",
        rightIcon: showEndpoints ? endpointButtonIconActive : endpointButtonIconInactive,
        className: showEndpoints ? `button-active` : null
    })), showEndpoints && (0, _react.jsx)((0, _reactDefault.default).Fragment, null, (0, _react.jsx)((0, _sharedStyledComponents.TopTriangleStyle), null), (0, _react.jsx)((0, _sharedStyledComponents.Endpoints), null, (0, _react.jsx)((0, _sharedStyledComponents.EndpointsHeader), null, "Fulfillment Endpoints"), (0, _react.jsx)((0, _horizontalContainerDefault.default), null, (0, _react.jsx)((0, _textFieldDefault.default), {
        useForm: false,
        value: props.endpoints?.botServiceEndpoint,
        onChange: null,
        readOnly: true,
        label: "Direct Fulfillment"
    }), (0, _react.jsx)((0, _sharedStyledComponents.CopyButton), {
        themes: [
            "secondary"
        ],
        text: "Copy",
        type: "button",
        onClick: ()=>copyText(props.endpoints?.botServiceEndpoint)
    })))), (0, _react.jsx)((0, _sharedStyledComponents.HelperText), null, (0, _react.jsx)("p", null, "Let’s get you ready to deploy to Azure Bot Service! ", (0, _react.jsx)("br", null), " ", (0, _react.jsx)("br", null), " "), (0, _react.jsx)("p", null, "This process will get your account on Voicify synced with your Microsoft account and deploy your app to a specific LUIS app. "), (0, _react.jsx)((0, _sharedStyledComponents.StyledLink), {
        target: "_blank",
        href: "https://support.voicify.com/en/knowledge/microsoft-deployment"
    }, " Read More ")), (0, _react.jsx)((0, _sharedStyledComponents.WorkflowStepContainer), null, (0, _react.jsx)((0, _deploymentWorkflowStepDefault.default), {
        name: "Registration",
        currentStep: workflowStep,
        step: 1
    }), (0, _react.jsx)((0, _deploymentWorkflowStepDefault.default), {
        name: "Luis Resources Setup",
        currentStep: workflowStep,
        step: 2
    }), (0, _react.jsx)((0, _deploymentWorkflowStepDefault.default), {
        name: "Link Luis App",
        currentStep: workflowStep,
        step: 3
    }), (0, _react.jsx)((0, _deploymentWorkflowStepDefault.default), {
        name: "Launch",
        currentStep: workflowStep,
        step: 4
    }), (0, _react.jsx)((0, _deploymentWorkflowStepDefault.default), {
        last: true,
        icon: props.applicationStatusIcon,
        currentStep: workflowStep,
        step: 5,
        href: "https://portal.azure.com/"
    })), deploymentContainer.isLoadingLink ? (0, _react.jsx)((0, _secondaryLoaderDefault.default), null) : renderStepContent()), (0, _react.jsx)((0, _pageErrorDefault.default), {
        errors: deploymentContainer.errors,
        onClear: deploymentContainer.clearErrors
    }));
};
exports.default = MicrosoftDeploymentCard;

},{"@emotion/react":"djZKr","react":"6uln9","../../../components/forms/RadioGroup":"eiGrn","../../../components/general/Button":"6ymxN","../../../components/general/PageError":"ezFTm","../../../components/forms/TextField":"7a7bh","../../../components/general/SecondaryLoader":"7zJiF","./SharedStyledComponents":"9COIL","../../../components/structure/HorizontalContainer":"eJPfh","./DeploymentWorkflowStep":"lgTpr","../../../hooks/MicrosoftDeploymentContainer":"aIoVz","97fde38065de5b34":"eqo0Q","9d1eda7f85792ef3":"9mnp5","c56144e97733596e":"bDy63","305e5d4c5b65c16b":"fyNwe","41b07d6c78ada95d":"9ewOE","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"aIoVz":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _unstatedNext = require("unstated-next");
var _api = require("../api");
function useMicrosoftDeploymentContainer() {
    const defaultLuisRegion = "westus";
    const emptyLink = {
        botServiceName: "",
        microsoftAppId: "",
        microsoftAppPassword: "",
        luisRegion: "",
        luisPredictionRegion: "",
        luisAuthoringKey: "",
        luisPredictionKey: "",
        luisPredictionEndpoint: "",
        luisAppId: ""
    };
    const [errors, setErrors] = (0, _react.useState)([]);
    const [isLoadingApps, setIsLoadingApps] = (0, _react.useState)(false);
    const [isLoadingLink, setIsLoadingLink] = (0, _react.useState)(false);
    const [isCreatingApp, setIsCreatingApp] = (0, _react.useState)(false);
    const [isLinkingApp, setIsLinkingApp] = (0, _react.useState)(false);
    const [luisApps, setLuisApps] = (0, _react.useState)([]);
    const [deploymentLink, setDeploymentLink] = (0, _react.useState)(emptyLink);
    const [currentStep, setCurrentStep] = (0, _react.useState)(1);
    const [luisAppType, setLuisAppType] = (0, _react.useState)("new");
    const [luisAppName, setLuisAppName] = (0, _react.useState)(null);
    const [currentApplicationId, setCurrentApplicationId] = (0, _react.useState)(null);
    const [currentEnvironmentId, setCurrentEnvironmentId] = (0, _react.useState)(null);
    const reset = ()=>{
        setIsLoadingApps(false);
        setIsLoadingLink(false);
        setIsCreatingApp(false);
        setIsLinkingApp(false);
        setLuisApps([]);
        setDeploymentLink(emptyLink);
        setCurrentStep(1);
        setLuisAppType("new");
        setLuisAppName(null);
        setErrors([]);
        setCurrentApplicationId(null);
        setCurrentEnvironmentId(null);
    };
    // determines the step in the process by what has been filled out so far
    const getCurrentStep = (link)=>{
        let step = 1;
        if (!link) return step;
        if (link.microsoftAppId && link.microsoftAppPassword) step++;
        else return step;
        if (link.luisAuthoringKey && link.luisPredictionKey && link.luisPredictionRegion) step++;
        else return step;
        if (link.luisAppId) step++;
        return step;
    };
    const getEnvironmentCurrentLink = async (applicationId, environmentId)=>{
        try {
            await setIsLoadingLink(true);
            await setCurrentApplicationId(applicationId);
            await setCurrentEnvironmentId(environmentId);
            const result = await _api.getEnvironmentDeploymentInfoForMicrosoft(applicationId, environmentId);
            if (result.resultType == "Ok") {
                const link = result.data;
                await setDeploymentLink(link);
                await setCurrentStep(getCurrentStep(link));
                await setIsLoadingLink(false);
                if (link.luisAuthoringKey) await getEnvironmentLuisApps(applicationId, environmentId);
            } else {
                await setIsLoadingLink(false);
                await setErrors(result.errors);
            }
            return result;
        } catch (err) {
            setErrors([
                err.toString()
            ]);
            setIsLoadingLink(false);
        }
    };
    const linkEnvironmentToBot = (applicationId, environmentId)=>{
        // extra validation
        if (!deploymentLink.botServiceName) {
            setErrors([
                "Bot service name is required"
            ]);
            return;
        }
        if (!deploymentLink.microsoftAppId) {
            setErrors([
                "Microsoft App ID is required"
            ]);
            return;
        }
        if (!deploymentLink.microsoftAppPassword) {
            setErrors([
                "Microsoft App Password is required"
            ]);
            return;
        }
        setIsLinkingApp(true);
        const promise = _api.linkBotServiceToEnvironment(applicationId, environmentId, deploymentLink.botServiceName, deploymentLink.microsoftAppId, deploymentLink.microsoftAppPassword);
        promise.then((result)=>{
            if (result.resultType == "Ok") {
                setIsLinkingApp(false);
                setCurrentStep(getCurrentStep(deploymentLink));
            } else {
                setIsLinkingApp(false);
                setErrors(result.errors);
            }
        }).catch((err)=>{
            setErrors([
                err.toString()
            ]);
            setIsLinkingApp(false);
        });
        return promise;
    };
    const linkEnvironmentToLuisApp = async (applicationId, environmentId)=>{
        // extra validation
        if (!deploymentLink.luisAppId) {
            setErrors([
                "You must select a Luis app to link to"
            ]);
            return;
        }
        if (!deploymentLink.luisRegion) await setDeploymentLink({
            ...deploymentLink,
            luisRegion: defaultLuisRegion
        });
        setIsLinkingApp(true);
        const promise = _api.linkLuisAppToEnvironment(applicationId, environmentId, deploymentLink.luisAppId, deploymentLink.luisRegion ? deploymentLink.luisRegion : defaultLuisRegion);
        promise.then((result)=>{
            if (result.resultType == "Ok") {
                setIsLinkingApp(false);
                setCurrentStep(getCurrentStep(deploymentLink));
            } else {
                setIsLinkingApp(false);
                setErrors(result.errors);
            }
        }).catch((err)=>{
            setErrors([
                err.toString()
            ]);
            setIsLinkingApp(false);
        });
        return promise;
    };
    const linkEnvironmentLuisResources = async (applicationId, environmentId)=>{
        // extra validation
        if (!deploymentLink.luisAuthoringKey) {
            setErrors([
                "The Luis authoring key is required"
            ]);
            return;
        }
        if (!deploymentLink.luisPredictionKey) {
            setErrors([
                "The Luis prediction key is required"
            ]);
            return;
        }
        if (!deploymentLink.luisPredictionRegion) {
            setErrors([
                "The Luis prediction region is required"
            ]);
            return;
        }
        if (!deploymentLink.luisPredictionEndpoint) {
            setErrors([
                "The Luis prediction endpoint is required"
            ]);
            return;
        }
        await setIsLinkingApp(true);
        const promise = _api.linkLuisKeyToEnvironment(applicationId, environmentId, deploymentLink.luisAuthoringKey);
        promise.then(async (result)=>{
            if (result.resultType == "Ok") {
                await setIsLinkingApp(false);
                await setCurrentStep(getCurrentStep(deploymentLink));
                await linkEnvironmentLuisPredictionResources(applicationId, environmentId);
                await getEnvironmentLuisApps(applicationId, environmentId);
            } else {
                await setIsLinkingApp(false);
                await setErrors(result.errors);
            }
        }).catch((err)=>{
            setErrors([
                err.toString()
            ]);
            setIsLinkingApp(false);
        });
        return promise;
    };
    const linkEnvironmentLuisPredictionResources = async (applicationId, environmentId)=>{
        // extra validation
        if (!deploymentLink.luisPredictionKey) {
            setErrors([
                "The Luis prediction key is required"
            ]);
            return;
        }
        await setIsLinkingApp(true);
        const promise = _api.linkLuisPredictionResourcesToEnvironment(applicationId, environmentId, deploymentLink.luisPredictionKey, deploymentLink.luisPredictionRegion, deploymentLink.luisPredictionEndpoint);
        promise.then(async (result)=>{
            if (result.resultType == "Ok") {
                await setIsLinkingApp(false);
                await setCurrentStep(getCurrentStep(deploymentLink));
                await getEnvironmentLuisApps(applicationId, environmentId);
            } else {
                await setIsLinkingApp(false);
                await setErrors(result.errors);
            }
        }).catch((err)=>{
            setErrors([
                err.toString()
            ]);
            setIsLinkingApp(false);
        });
        return promise;
    };
    const createAndDeployEnvironmentNewLuisApp = async (applicationId, environmentId)=>{
        setIsCreatingApp(true);
        const promise = _api.createAndDeployEnvironmentNewLuisApp(applicationId, environmentId, defaultLuisRegion);
        promise.then(async (result)=>{
            if (result.resultType == "Ok") {
                let link = {
                    ...deploymentLink
                };
                link.luisAppId = result.data.luisAppId;
                link.luisRegion = defaultLuisRegion;
                await setDeploymentLink(link);
                await setLuisAppName(result.data.name);
                await setCurrentStep(getCurrentStep(link));
                await setIsCreatingApp(false);
                await setErrors([]);
            } else {
                await setIsCreatingApp(false);
                await setErrors(result.errors);
            }
        }).catch((err)=>{
            setErrors([
                err.toString()
            ]);
            setIsCreatingApp(false);
        });
        return promise;
    };
    const getEnvironmentLuisApps = async (applicationId, environmentId)=>{
        try {
            await setIsLoadingApps(true);
            const result = await _api.listLuisAppsForEnvironment(applicationId, environmentId);
            if (result.resultType == "Ok") {
                await setLuisApps(result.data);
                await setIsLoadingApps(false);
                await setIsLoadingLink(false);
            } else {
                await setIsLoadingApps(false);
                await setIsLoadingLink(false);
                await setErrors(result.errors);
            }
            return result;
        } catch (err) {
            setErrors([
                err.toString()
            ]);
            setIsLoadingApps(false);
            setIsLoadingLink(false);
        }
    };
    const unlinkEnvironmentMicrosoftProject = async (applicationId, environmentId)=>{
        try {
            setIsLinkingApp(true);
            const result = await _api.unlinkBotServiceFromEnvironment(applicationId, environmentId);
            if (result.resultType == "Ok") {
                await setDeploymentLink(emptyLink);
                await setIsLinkingApp(false);
                await setCurrentStep(1);
            } else {
                await setIsLinkingApp(false);
                await setErrors(result.errors);
            }
        } catch (err) {
            setErrors([
                err.toString()
            ]);
            setIsLinkingApp(false);
        }
    };
    const unlinkEnvironmentLuisApp = async (applicationId, environmentId)=>{
        try {
            setIsLinkingApp(true);
            const result = await _api.unlinkLuisFromEnvironment(applicationId, environmentId);
            if (result.resultType == "Ok") {
                const link = {
                    ...deploymentLink
                };
                link.luisAppId = "";
                link.luisAuthoringKey = "";
                link.luisPredictionKey = "";
                link.luisPredictionRegion = "";
                link.luisPredictionEndpoint = "";
                await setDeploymentLink(link);
                await setIsLinkingApp(false);
                await setCurrentStep(2);
            } else {
                await setIsLinkingApp(false);
                await setErrors(result.errors);
            }
        } catch (err) {
            setErrors([
                err.toString()
            ]);
            setIsLinkingApp(false);
        }
    };
    // form methods
    const setAuthoringKey = (text)=>{
        const link = {
            ...deploymentLink
        };
        link.luisAuthoringKey = text;
        setDeploymentLink(link);
    };
    const setPredictionKey = (text)=>{
        const link = {
            ...deploymentLink
        };
        link.luisPredictionKey = text;
        setDeploymentLink(link);
    };
    const setPredictionRegion = (text)=>{
        const link = {
            ...deploymentLink
        };
        link.luisPredictionRegion = text;
        setDeploymentLink(link);
    };
    const setPredictionEndpoint = (text)=>{
        const link = {
            ...deploymentLink
        };
        link.luisPredictionEndpoint = text;
        setDeploymentLink(link);
    };
    const setMsAppId = (text)=>{
        const link = {
            ...deploymentLink
        };
        link.microsoftAppId = text;
        setDeploymentLink(link);
    };
    const setMsAppPassword = (text)=>{
        const link = {
            ...deploymentLink
        };
        link.microsoftAppPassword = text;
        setDeploymentLink(link);
    };
    const setBotName = (text)=>{
        const link = {
            ...deploymentLink
        };
        link.botServiceName = text;
        setDeploymentLink(link);
    };
    const setLuisAppSelection = async (selection)=>{
        const link = {
            ...deploymentLink
        };
        link.luisAppId = "";
        link.luisRegion = "";
        setDeploymentLink(link);
        await setLuisAppType(selection);
    };
    const setLuisAppId = async (id)=>{
        const link = {
            ...deploymentLink
        };
        link.luisAppId = id;
        // We want to use the luis apps PRODUCTION LuisAppEndpoint (totally different from our Production environment)
        // When we create a luis app and version of a luis app we can "publish" it to production, staging, or dev. 
        const endPointRegion = luisApps.find((a)=>a.id == id).endpoints?.PRODUCTION?.endpointRegion;
        if (endPointRegion) link.luisRegion = endPointRegion;
        await setDeploymentLink(link);
    };
    const clearErrors = async ()=>{
        await setErrors([]);
    };
    return {
        reset,
        getEnvironmentCurrentLink,
        createAndDeployEnvironmentNewLuisApp,
        linkEnvironmentToLuisApp,
        linkEnvironmentLuisResources,
        linkEnvironmentToBot,
        unlinkEnvironmentMicrosoftProject,
        unlinkEnvironmentLuisApp,
        setBotName,
        setMsAppId,
        setMsAppPassword,
        setAuthoringKey,
        setPredictionKey,
        setPredictionRegion,
        setPredictionEndpoint,
        setLuisAppSelection,
        setLuisAppId,
        currentEnvironmentId,
        isLoadingApps,
        isLoadingLink,
        isCreatingApp,
        isLinkingApp,
        luisApps,
        deploymentLink,
        currentStep,
        luisAppType,
        luisAppName,
        errors,
        clearErrors
    };
}
const MicrosoftDeploymentContainer = (0, _unstatedNext.createContainer)(useMicrosoftDeploymentContainer);
exports.default = MicrosoftDeploymentContainer;

},{"react":"6uln9","unstated-next":"61zE5","../api":"loxM6","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"eqo0Q":[function(require,module,exports) {
module.exports = require("36873a90c317eea4").getBundleURL("kVLro") + require("89ca659429d801c1").resolve("8c9zg");

},{"36873a90c317eea4":"c7Tr5","89ca659429d801c1":"fyJL2"}],"7hu17":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _base = require("@emotion/styled/base");
var _baseDefault = parcelHelpers.interopDefault(_base);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _settingsCard = require("../../../../components/structure/SettingsCard");
var _settingsCardDefault = parcelHelpers.interopDefault(_settingsCard);
var _sharedStyledComponents = require("../SharedStyledComponents");
var _horizontalContainer = require("../../../../components/structure/HorizontalContainer");
var _horizontalContainerDefault = parcelHelpers.interopDefault(_horizontalContainer);
var _textField = require("../../../../components/forms/TextField");
var _textFieldDefault = parcelHelpers.interopDefault(_textField);
var _stylesValues = require("../../../../constants/stylesValues");
var _button = require("../../../../components/general/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _colors = require("../../../../constants/colors");
var _css = require("@emotion/css");
var _customAssistantContainer = require("../../../../hooks/CustomAssistantContainer");
var _customAssistantContainerDefault = parcelHelpers.interopDefault(_customAssistantContainer);
var _customAssistantConfigurationsForm = require("./CustomAssistantConfigurationsForm");
var _customAssistantConfigurationsFormDefault = parcelHelpers.interopDefault(_customAssistantConfigurationsForm);
var _useCustomAssistantConfigurationSettings = require("../../hooks/useCustomAssistantConfigurationSettings");
var _useCustomAssistantConfigurationSettingsDefault = parcelHelpers.interopDefault(_useCustomAssistantConfigurationSettings);
var _loader = require("../../../../components/general/Loader");
var _loaderDefault = parcelHelpers.interopDefault(_loader);
var _urls = require("../../../../constants/Urls");
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const customAssistantLogo = require("11876d708af720a3");
const defaultAvatar = require("d6a8e40d07dcff1c");
const copyAvatar = require("226ebb884bcd87c");
const deleteAvatar = require("75b4d2d7d76239fd");
const editAvatar = require("f477d57b8077ed3c");
const coreDefaultSettings = require("f3236cde14e683dc");
const CustomAssistantDeploymentCard = (props)=>{
    const buildDefaultSettings = ()=>{
        coreDefaultSettings.serverRootUrl = (0, _urls.getAssistantPreviewApiUrl)();
        coreDefaultSettings.applicationId = props.appContainer.state.currentApp.id;
        coreDefaultSettings.applicationSecret = props.appContainer.state.currentApp.secret;
        coreDefaultSettings.name = props.appContainer.state.currentApp.name;
        coreDefaultSettings.locale = props.appContainer.state.currentApp.languages[0].shortCode;
        coreDefaultSettings.styles.header.assistantName = props.appContainer.state.currentApp.name;
        coreDefaultSettings.styles.header.assistantImage = props.appContainer.state.currentApp.imageUrl;
        coreDefaultSettings.styles.start.assistantImage = props.appContainer.state.currentApp.imageUrl;
        // javaScript
        coreDefaultSettings.platformConfigurations.javaScript.serverRootUrl = (0, _urls.getAssistantPreviewApiUrl)();
        coreDefaultSettings.platformConfigurations.javaScript.applicationId = props.appContainer.state.currentApp.id;
        coreDefaultSettings.platformConfigurations.javaScript.applicationSecret = props.appContainer.state.currentApp.secret;
        coreDefaultSettings.platformConfigurations.javaScript.name = props.appContainer.state.currentApp.name;
        coreDefaultSettings.platformConfigurations.javaScript.locale = props.appContainer.state.currentApp.languages[0].shortCode;
        coreDefaultSettings.platformConfigurations.javaScript.styles.header.assistantName = props.appContainer.state.currentApp.name;
        coreDefaultSettings.platformConfigurations.javaScript.styles.header.assistantImage = props.appContainer.state.currentApp.imageUrl;
        coreDefaultSettings.platformConfigurations.javaScript.styles.start.assistantImage = props.appContainer.state.currentApp.imageUrl;
        // swift
        coreDefaultSettings.platformConfigurations.swift.serverRootUrl = (0, _urls.getAssistantPreviewApiUrl)();
        coreDefaultSettings.platformConfigurations.swift.applicationId = props.appContainer.state.currentApp.id;
        coreDefaultSettings.platformConfigurations.swift.applicationSecret = props.appContainer.state.currentApp.secret;
        coreDefaultSettings.platformConfigurations.swift.name = props.appContainer.state.currentApp.name;
        coreDefaultSettings.platformConfigurations.swift.locale = props.appContainer.state.currentApp.languages[0].shortCode;
        coreDefaultSettings.platformConfigurations.swift.styles.header.assistantName = props.appContainer.state.currentApp.name;
        coreDefaultSettings.platformConfigurations.swift.styles.header.assistantImage = props.appContainer.state.currentApp.imageUrl;
        // kotlin
        coreDefaultSettings.platformConfigurations.kotlin.serverRootUrl = (0, _urls.getAssistantPreviewApiUrl)();
        coreDefaultSettings.platformConfigurations.kotlin.applicationId = props.appContainer.state.currentApp.id;
        coreDefaultSettings.platformConfigurations.kotlin.applicationSecret = props.appContainer.state.currentApp.secret;
        coreDefaultSettings.platformConfigurations.kotlin.name = props.appContainer.state.currentApp.name;
        coreDefaultSettings.platformConfigurations.kotlin.locale = props.appContainer.state.currentApp.languages[0].shortCode;
        coreDefaultSettings.platformConfigurations.kotlin.styles.header.assistantName = props.appContainer.state.currentApp.name;
        coreDefaultSettings.platformConfigurations.kotlin.styles.header.assistantImage = props.appContainer.state.currentApp.imageUrl;
        return coreDefaultSettings;
    };
    const [isCreateConfigurationsOpen, setIsCreateConfigurationsOpen] = (0, _react1.useState)(false);
    const [isEditConfigurationsOpen, setIsEditConfigurationsOpen] = (0, _react1.useState)(false);
    const [isLoading, setIsLoading] = (0, _react1.useState)(false);
    const [appId, setAppId] = (0, _react1.useState)("");
    const [appKey, setAppKey] = (0, _react1.useState)("");
    const [customAssistantConfigurations, setCustomAssistantConfigurations] = (0, _react1.useState)([]);
    const [configuration, setConfiguration] = (0, _react1.useState)(buildDefaultSettings());
    const [configId, setConfigId] = (0, _react1.useState)("");
    const [configName, setConfigName] = (0, _react1.useState)("");
    const [newConfigurationId, setNewConfigurationId] = (0, _react1.useState)("");
    const customAssistantContainer = (0, _customAssistantContainerDefault.default).useContainer();
    const customAssistantConfigurationsContainer = (0, _useCustomAssistantConfigurationSettingsDefault.default).useContainer();
    (0, _react1.useEffect)(()=>{
        loadCustomAssistantConfigurations();
        props.appContainer.getInitialState();
        setAppId(props.appContainer.state.currentApp.id);
        setAppKey(props.appContainer.state.currentApp.secret);
        setConfigName(props.appContainer.state.currentApp.name);
    }, []);
    (0, _react1.useEffect)(()=>{
        setCustomAssistantConfigurations(customAssistantContainer.customAssistantConfigurations);
    }, [
        customAssistantContainer.customAssistantConfigurations
    ]);
    const clearConfiguration = ()=>{
        setConfiguration({
            name: props.appContainer.state.currentApp.name,
            applicationId: props.appContainer.state.currentApp.id,
            applicationSecret: props.appContainer.state.currentApp.secret,
            platformConfigurations: {
                javaScript: {
                    name: props.appContainer.state.currentApp.name,
                    applicationId: props.appContainer.state.currentApp.id,
                    applicationSecret: props.appContainer.state.currentApp.secret
                },
                swift: {
                    name: props.appContainer.state.currentApp.name,
                    applicationId: props.appContainer.state.currentApp.id,
                    applicationSecret: props.appContainer.state.currentApp.secret
                },
                kotlin: {
                    name: props.appContainer.state.currentApp.name,
                    applicationId: props.appContainer.state.currentApp.id,
                    applicationSecret: props.appContainer.state.currentApp.secret
                }
            }
        });
        setConfigId("");
        setConfigName("");
        setNewConfigurationId("");
    };
    const restartAssistant = ()=>{
        if (window.voicifyAssistant) {
            window.voicifyAssistant.clearAllLocalStorage();
            window.voicifyAssistant = null;
        }
    };
    const loadCustomAssistantConfigurations = async ()=>{
        setIsLoading(true);
        await customAssistantContainer.getCustomAssistantConfigurations(props.applicationId);
        setCustomAssistantConfigurations(customAssistantContainer.customAssistantConfigurations);
        setIsLoading(false);
    };
    const copyText = (text)=>{
        navigator.clipboard.writeText(text);
    };
    const deleteCustomConfig = async (configId)=>{
        setIsLoading(true);
        await customAssistantContainer.deleteCustomAssistantConfiguration(configId);
        loadCustomAssistantConfigurations();
        setIsLoading(false);
    };
    const copyCustomConfig = async (configId)=>{
        setIsLoading(true);
        await customAssistantContainer.copyCustomAssistantConfiguration(configId);
        loadCustomAssistantConfigurations();
        setIsLoading(false);
    };
    const openFormAndCreateConfig = async (config)=>{
        setIsLoading(true);
        restartAssistant();
        setIsCreateConfigurationsOpen(true);
        const newConfig = await customAssistantContainer.createCustomAssistantConfiguration(config);
        setConfiguration(newConfig.data);
        setNewConfigurationId(newConfig.data.id);
        setIsLoading(false);
    };
    const editCustomConfigForm = (configId, configName, config)=>{
        setConfiguration(config);
        setConfigId(configId);
        setConfigName(configName);
        setIsEditConfigurationsOpen(true);
    };
    const closeCustomConfigForm = ()=>{
        restartAssistant();
        clearConfiguration();
        setIsCreateConfigurationsOpen(false);
        setIsEditConfigurationsOpen(false);
        loadCustomAssistantConfigurations();
    };
    const submitCustomAssistantConfiguration = async (config)=>{
        setIsLoading(true);
        await customAssistantContainer.updateCustomAssistantConfiguration(config);
        loadCustomAssistantConfigurations();
        setIsLoading(false);
    };
    return (0, _react.jsx)((0, _sharedStyledComponents.CardContainer), {
        id: "custom-assistant-card"
    }, (isCreateConfigurationsOpen || isEditConfigurationsOpen) && (0, _react.jsx)((0, _customAssistantConfigurationsFormDefault.default), {
        browserAssistantSettings: customAssistantConfigurationsContainer.browserAssistantSettings,
        kotlinAssistantSettings: customAssistantConfigurationsContainer.kotlinAssistantSettings,
        swiftAssistantSettings: customAssistantConfigurationsContainer.swiftAssistantSettings,
        closeCustomConfigForm: closeCustomConfigForm,
        appContainer: props.appContainer,
        applicationId: appId,
        appKey: appKey,
        handleSubmitForm: submitCustomAssistantConfiguration,
        appName: props.appContainer.state?.currentApp?.name ?? "",
        configName: configName,
        appAvatar: props.appContainer.state.currentApp.imageUrl,
        customAssistantConfigurations: customAssistantConfigurations,
        configuration: configuration,
        configId: isEditConfigurationsOpen ? configId : newConfigurationId,
        isCreateConfigurationsOpen: isCreateConfigurationsOpen,
        isEditConfigurationsOpen: isEditConfigurationsOpen,
        copyText: copyText,
        mediaContainer: props.mediaContainer,
        isLoading: isLoading
    }), (0, _react.jsx)((0, _settingsCardDefault.default), null, (0, _react.jsx)((0, _sharedStyledComponents.Logo), {
        src: customAssistantLogo
    }), (0, _react.jsx)(DescriptionWrapper, null, (0, _react.jsx)("p", null, "Let's get you ready to deploy to Custom Assistant!"), (0, _react.jsx)("br", null), (0, _react.jsx)("p", null, 'Select the "Add a Configuration" button below to create a low-code Custom Assisant that you can deploy on your website and in your Android and iOS mobile apps.'), (0, _react.jsx)("p", null, "As an alternative, you can create a completely customized assistant using our browser, React Native, Android or iOS SDKs."), (0, _react.jsx)((0, _sharedStyledComponents.StyledLink), {
        target: "_blank",
        href: "https://support.voicify.com/en/knowledge/how-do-i-deploy-my-voicify-app/assistant-to-my-website"
    }, " Read More ")), (0, _react.jsx)(EndpointContainer, null, (0, _react.jsx)((0, _sharedStyledComponents.EndpointsHeader), null, "Copy your endpoint url"), (0, _react.jsx)((0, _horizontalContainerDefault.default), null, (0, _react.jsx)((0, _textFieldDefault.default), {
        useForm: false,
        onChange: ()=>null,
        value: props.endpoints?.customAssistantEndpoint ?? "",
        label: "Endpoint URL",
        readOnly: true,
        className: endpointTextField
    }), (0, _react.jsx)((0, _sharedStyledComponents.CopyButton), {
        themes: [
            "secondary"
        ],
        text: "Copy",
        type: "button",
        onClick: ()=>copyText(props.endpoints?.customAssistantEndpoint)
    }))), (0, _react.jsx)(CustomConfigurationsTitle, null, "Custom Configurations"), (0, _react.jsx)(CustomConfigurationsListWrapper, null, isLoading ? (0, _react.jsx)((0, _loaderDefault.default), null) : customAssistantContainer.customAssistantConfigurations.length > 0 ? customAssistantContainer.customAssistantConfigurations.map((customAssistantConfig)=>{
        return (0, _react.jsx)(CustomConfigurationsListItem, {
            key: customAssistantConfig.id
        }, (0, _react.jsx)(CustomConfigurationsItemLeft, {
            onClick: ()=>editCustomConfigForm(customAssistantConfig.id, customAssistantConfig.name, customAssistantConfig)
        }, (0, _react.jsx)(Avatar, {
            src: customAssistantConfig.avatarUrl ? customAssistantConfig.avatarUrl : defaultAvatar
        }), customAssistantConfig.name ? customAssistantConfig.name : (0, _react.jsx)("p", null, "Custom Assistant")), (0, _react.jsx)(CustomConfigurationsItemRight, null, (0, _react.jsx)(ActionIcon, {
            src: editAvatar,
            onClick: ()=>editCustomConfigForm(customAssistantConfig.id, customAssistantConfig.name, customAssistantConfig)
        }), (0, _react.jsx)(ActionIcon, {
            src: copyAvatar,
            onClick: ()=>copyCustomConfig(customAssistantConfig.id)
        }), (0, _react.jsx)(ActionIcon, {
            src: deleteAvatar,
            onClick: ()=>deleteCustomConfig(customAssistantConfig.id)
        })));
    }) : (0, _react.jsx)("p", null, "There are no Custom Assistant configurations associated with this app.")), (0, _react.jsx)(ConfigurationsButtonWrapper, null, (0, _react.jsx)(ConfigurationsButton, {
        themes: [
            "primary",
            "wide"
        ],
        text: "Add a Configuration",
        type: "button",
        onClick: ()=>openFormAndCreateConfig(buildDefaultSettings())
    }))));
};
const endpointTextField = /*#__PURE__*/ (0, _css.css)({
    name: "w40aiy",
    styles: "margin-left:32px;margin-bottom:0"
});
const ActionIcon = /*#__PURE__*/ (0, _baseDefault.default)("img", {
    target: "eukx0of10"
})({
    name: "1nohwdk",
    styles: "cursor:pointer;margin:12px 24px 12px 12px"
});
const Avatar = /*#__PURE__*/ (0, _baseDefault.default)("img", {
    target: "eukx0of9"
})("height:36px;width:36px;margin:12px 12px 12px 24px;padding:2px;border:", (0, _stylesValues.style_border_default), ";border-radius:50%;");
const CustomConfigurationsTitle = /*#__PURE__*/ (0, _baseDefault.default)("h3", {
    target: "eukx0of8"
})("font-size:18px;color:", (0, _colors.color_shades_darkest), ";font-weight:400;margin-top:32px;");
const ConfigurationsButtonWrapper = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "eukx0of7"
})("");
const ConfigurationsButton = /*#__PURE__*/ (0, _baseDefault.default)((0, _buttonDefault.default), {
    target: "eukx0of6"
})({
    name: "2r7frt",
    styles: "padding:6px 24px;margin:24px 0;display:flex;align-items:center;flex:4"
});
const DescriptionWrapper = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "eukx0of5"
})("padding:32px 0;border-bottom:", (0, _stylesValues.style_border_default), ";");
const EndpointContainer = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "eukx0of4"
})("padding:32px 0;border-bottom:", (0, _stylesValues.style_border_dotted), ";");
const CustomConfigurationsListWrapper = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "eukx0of3"
})({
    name: "1bktge1",
    styles: "padding-top:32px;display:flex;flex-direction:column"
});
const CustomConfigurationsListItem = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "eukx0of2"
})("display:flex;align-items:center;justify-content:space-between;border:", (0, _stylesValues.style_border_default), ";border-top:none;border-radius:8px;height:56px;&:first-of-type{border-top:", (0, _stylesValues.style_border_default), ";}");
const CustomConfigurationsItemLeft = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "eukx0of1"
})({
    name: "1tqlm1e",
    styles: "cursor:pointer;display:flex;align-items:center;justify-content:flex-start"
});
const CustomConfigurationsItemRight = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "eukx0of0"
})({
    name: "19mh0x6",
    styles: "display:flex;align-items:center;justify-content:flex-end"
});
exports.default = CustomAssistantDeploymentCard;

},{"@emotion/styled/base":"lSuFu","@emotion/react":"djZKr","react":"6uln9","../../../../components/structure/SettingsCard":"liIw4","../SharedStyledComponents":"9COIL","../../../../components/structure/HorizontalContainer":"eJPfh","../../../../components/forms/TextField":"7a7bh","../../../../constants/stylesValues":"dHVVv","../../../../components/general/Button":"6ymxN","../../../../constants/colors":"1p3OR","@emotion/css":"awUBr","../../../../hooks/CustomAssistantContainer":"1Z9b9","./CustomAssistantConfigurationsForm":"ccX5P","../../hooks/useCustomAssistantConfigurationSettings":"jrJ7j","../../../../components/general/Loader":"bnV5T","../../../../constants/Urls":"iTopY","11876d708af720a3":"bpfKj","d6a8e40d07dcff1c":"iS74T","226ebb884bcd87c":"avCoE","75b4d2d7d76239fd":"k8RZz","f477d57b8077ed3c":"1u9JO","f3236cde14e683dc":"fvG38","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1Z9b9":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _unstatedNext = require("unstated-next");
var _api = require("../api");
function useCustomAssistantContainer() {
    const [customAssistantConfigurations, setCustomAssistantConfigurations] = (0, _react.useState)([]);
    const [customAssistantConfiguration, setCustomAssistantConfiguration] = (0, _react.useState)();
    const [configurationImage, setConfigurationImage] = (0, _react.useState)("");
    const [isLoading, setIsLoading] = (0, _react.useState)(false);
    const [errors, setErrors] = (0, _react.useState)([]);
    const getCustomAssistantConfigurations = async (currentAppId)=>{
        try {
            setIsLoading(true);
            const result = await _api.getCustomAssistantConfigurations(currentAppId);
            if (result.resultType == "Ok") setCustomAssistantConfigurations(result.data);
            else if (result.errors != null && result.errors.length > 0) setErrors([
                ...result.errors
            ]);
            setIsLoading(false);
            return result;
        } catch (error) {
            setErrors([
                error
            ]);
            setIsLoading(false);
        }
    };
    const getCustomAssistantConfiguration = async (configId)=>{
        try {
            setIsLoading(true);
            const result = await _api.getCustomAssistantConfiguration(configId);
            if (result.resultType == "Ok") setCustomAssistantConfiguration(result.data);
            else if (result.errors != null && result.errors.length > 0) setErrors([
                ...result.errors
            ]);
            setIsLoading(false);
            return result;
        } catch (error) {
            setErrors([
                error
            ]);
            setIsLoading(false);
        }
    };
    const createCustomAssistantConfiguration = async (config)=>{
        try {
            setIsLoading(true);
            const result = await _api.createCustomAssistantConfiguration(config);
            if (result.errors != null && result.errors.length > 0) setErrors([
                ...result.errors
            ]);
            setIsLoading(false);
            return result;
        } catch (error) {
            setErrors([
                error
            ]);
            setIsLoading(false);
        }
    };
    const updateCustomAssistantConfiguration = async (config)=>{
        try {
            setIsLoading(true);
            const result = await _api.updateCustomAssistantConfiguration(config);
            if (result.errors != null && result.errors.length > 0) setErrors([
                ...result.errors
            ]);
            setIsLoading(false);
            return result;
        } catch (error) {
            setErrors([
                error
            ]);
            setIsLoading(false);
        }
    };
    const deleteCustomAssistantConfiguration = async (configId)=>{
        try {
            setIsLoading(true);
            const result = await _api.deleteCustomAssistantConfiguration(configId);
            if (result.errors != null && result.errors.length > 0) setErrors([
                ...result.errors
            ]);
            setIsLoading(false);
            return result;
        } catch (error) {
            setErrors([
                error
            ]);
            setIsLoading(false);
        }
    };
    const copyCustomAssistantConfiguration = async (configId)=>{
        const oldConfig = await getCustomAssistantConfiguration(configId);
        const newConfig = await createCustomAssistantConfiguration(oldConfig.data);
        return newConfig;
    };
    const updateConfigurationImage = async (applicationId, imageFile)=>{
        try {
            setIsLoading(true);
            const result = await _api.uploadMediaItem(applicationId, "configurationAvatar", imageFile);
            if (result.resultType == "Ok") setConfigurationImage(result.data.url);
            else if (result.errors != null && result.errors.length > 0) setErrors([
                ...result.errors
            ]);
            setIsLoading(false);
            return result;
        } catch (error) {
            setErrors([
                error
            ]);
            setIsLoading(false);
        }
    };
    return {
        isLoading,
        errors,
        customAssistantConfigurations,
        customAssistantConfiguration,
        getCustomAssistantConfigurations,
        getCustomAssistantConfiguration,
        deleteCustomAssistantConfiguration,
        updateCustomAssistantConfiguration,
        createCustomAssistantConfiguration,
        copyCustomAssistantConfiguration,
        updateConfigurationImage,
        configurationImage
    };
}
const CustomAssistantContainer = (0, _unstatedNext.createContainer)(useCustomAssistantContainer);
exports.default = CustomAssistantContainer;

},{"react":"6uln9","unstated-next":"61zE5","../api":"loxM6","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"ccX5P":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _yup = require("yup");
var _formik = require("formik");
var _customAssistantConfigurations = require("./CustomAssistantConfigurations");
var _customAssistantConfigurationsDefault = parcelHelpers.interopDefault(_customAssistantConfigurations);
const CustomAssistantConfigurationsForm = (0, _formik.withFormik)({
    mapPropsToValues: (props)=>({
            // Assistant Settings
            serverRootUrl: props.configuration.serverRootUrl ?? "https://assistant.voicify.com",
            appId: props.configuration.applicationId ?? props.applicationId,
            appKey: props.configuration.appKey ?? props.appKey,
            channel: props.configuration.channel ?? props.appName,
            device: props.configuration.device ?? "Custom Assistant SDK",
            sessionTimeout: props.configuration.sessionTimeout ?? 3600000,
            locale: props.configuration.locale ?? props.appContainer.state.currentApp.languages[0].shortCode,
            defaultLanguageId: props.appContainer.state.currentApp.languages[0].id,
            name: props.configName,
            displayName: props.configuration.displayName,
            avatarUrl: props.configuration.avatarUrl,
            uiType: props.configuration.uiType ?? "minimal",
            showConversationHistory: props.configuration.showConversationHistory ?? true,
            autoRunConversation: props.configuration.autoRunConversation ?? true,
            initializeWithWelcomeMessage: props.configuration.initializeWithWelcomeMessage ?? true,
            useVoiceInput: props.configuration.useVoiceInput ?? true,
            useOutputSpeech: props.configuration.useOutputSpeech ?? true,
            textToSpeechProvider: props.configuration.textToSpeechProvider ?? "Google",
            textToSpeechVoice: props.configuration.textToSpeechVoice,
            useDraftContent: props.configuration.useDraftContent ?? false,
            activeInput: props.configuration.activeInput ?? "textbox",
            noTracking: props.configuration.noTracking ?? true,
            themeStyle: props.configuration.theme ? props.configuration.theme : props.theme ? props.theme : "lightStyle1",
            primaryColor: props.configuration.primaryColor && props.configuration.primaryColor,
            font: props.configuration.font && props.configuration.font,
            // Styles
            // Assistant Styles
            overallBackgroundColor: props.configuration.styles?.assistant?.backgroundColor,
            // Header Styles
            headerBackgroundColor: props.configuration.styles?.header?.backgroundColor,
            headerAssistantName: props.configuration.styles?.header?.assistantName,
            headerAssistantNameTextColor: props.configuration.styles?.header?.assistantNameTextColor,
            headerAssistantImage: props.configuration.styles?.header?.assistantImage,
            headerFontFamily: props.configuration.styles?.header?.fontFamily,
            headerCloseAssistantColor: props.configuration.styles?.header?.closeAssistantColor,
            headerMinimizeAssistantColor: props.configuration.styles?.header?.minimizeAssistantColor,
            headerMinimizeIcon: props.configuration.styles?.header?.minimizeIcon,
            headerCloseAssistantButtonImage: props.configuration.styles?.header?.closeAssistantButtonImage,
            // Body Styles
            bodyBackgroundColor: props.configuration.styles?.body?.backgroundColor,
            bodyMessageSentTextColor: props.configuration.styles?.body?.messageSentTextColor,
            bodyMessageSentBackgroundColor: props.configuration.styles?.body?.messageSentBackgroundColor,
            bodyMessageReceivedTextColor: props.configuration.styles?.body?.messageReceivedTextColor,
            bodyMessageReceivedBackgroundColor: props.configuration.styles?.body?.messageReceivedBackgroundColor,
            bodyMessageSentFontFamily: props.configuration.styles?.body?.messageSentFontFamily,
            bodyMessageReceivedFontFamily: props.configuration.styles?.body?.messageReceivedFontFamily,
            bodyHintsTextColor: props.configuration.styles?.body?.hintsTextColor,
            bodyHintsBackgroundColor: props.configuration.styles?.body?.hintsBackgroundColor,
            bodyHintsFontFamily: props.configuration.styles?.body?.hintsFontFamily,
            bodyAssistantImage: props.configuration.styles?.body?.assistantImage,
            // Toolbar Styles
            toolbarBackgroundColor: props.configuration.styles?.toolbar?.backgroundColor,
            toolbarSpeakActiveTitleColor: props.configuration.styles?.toolbar?.speakActiveTitleColor,
            toolbarSpeakInactiveTitleColor: props.configuration.styles?.toolbar?.speakInactiveTitleColor,
            toolbarTypeActiveTitleColor: props.configuration.styles?.toolbar?.typeActiveTitleColor,
            toolbarTypeInactiveTitleColor: props.configuration.styles?.toolbar?.typeInactiveTitleColor,
            toolbarPartialSpeechResultTextColor: props.configuration.styles?.toolbar?.partialSpeechResultTextColor,
            toolbarFullSpeechResultTextColor: props.configuration.styles?.toolbar?.fullSpeechResultTextColor,
            toolbarSpeechResultBoxBackgroundColor: props.configuration.styles?.toolbar?.speechResultBoxBackgroundColor,
            toolbarTextInputTextColor: props.configuration.styles?.toolbar?.textInputTextColor,
            toolbarHelpTextFontColor: props.configuration.styles?.toolbar?.helpTextFontColor,
            toolbarPartialSpeechResultFontFamily: props.configuration.styles?.toolbar?.partialSpeechResultFontFamily,
            toolbarAssistantStateFontFamily: props.configuration.styles?.toolbar?.assistantStateFontFamily,
            toolbarHelpTextFontFamily: props.configuration.styles?.toolbar?.helpTextFontFamily,
            toolbarSpeakFontFamily: props.configuration.styles?.toolbar?.speakFontFamily,
            toolbarTypeFontFamily: props.configuration.styles?.toolbar?.typeFontFamily,
            toolbarTextboxFontFamily: props.configuration.styles?.toolbar?.textboxFontFamily,
            toolbarEqualizerColor: props.configuration.styles?.toolbar?.equalizerColor,
            toolbarEqualizerColorOne: props.configuration.styles?.toolbar?.equalizerColorOne,
            toolbarEqualizerColorTwo: props.configuration.styles?.toolbar?.equalizerColorTwo,
            toolbarMuteFontColor: props.configuration.styles?.toolbar?.muteFontColor,
            toolbarMuteFontFamily: props.configuration.styles?.toolbar?.muteFontFamily,
            toolbarMicActiveColor: props.configuration.styles?.toolbar?.micActiveColor,
            toolbarMicActiveImage: props.configuration.styles?.toolbar?.micActiveImage ?? "https://voicify-prod-files.s3.amazonaws.com/sdk-images/micThreeActive.svg",
            toolbarSendActiveImage: props.configuration.styles?.toolbar?.sendActiveImage ?? "https://voicify-prod-files.s3.amazonaws.com/sdk-images/sendTwoActive.svg",
            toolbarSendActiveColor: props.configuration.styles?.toolbar?.sendActiveColor,
            toolbarSendInactiveColor: props.configuration.styles?.toolbar?.sendInactiveColor,
            toolbarMuteImage: props.configuration.styles?.toolbar?.muteImage,
            toolbarAssistantStateFontColor: props.configuration.styles?.toolbar?.assistantStateFontColor,
            toolbarAssistantStateTextColor: props.configuration.styles?.toolbar?.assistantStateTextColor,
            toolbarTextInputLineColor: props.configuration.styles?.toolbar?.textInputLineColor,
            toolbarTextInputActiveLineColor: props.configuration.styles?.toolbar?.textInputActiveLineColor,
            toolbarPlaceholder: props.configuration.styles?.toolbar?.placeholder,
            // Start Styles
            startAssistantImage: props.configuration.styles?.start?.assistantImage,
            startButtonFontFamily: props.configuration.styles?.start?.buttonFontFamily,
            startButtonText: props.configuration.styles?.start?.buttonText,
            startButtonFontSize: props.configuration.styles?.start?.buttonFontSize
        }),
    validationSchema: _yup.object().shape({
        name: _yup.string().max(50).required("You must enter a name"),
        primaryColor: _yup.string().matches(/^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{8})$/, "Enter a valid hex color code"),
        buttonFontSize: _yup.number().min(0, "Must be a number more than 0"),
        overallBackgroundColor: _yup.string().matches(/^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{8})$/, "Enter a valid hex color code"),
        headerBackgroundColor: _yup.string().matches(/^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{8})$/, "Enter a valid hex color code"),
        headerAssistantNameTextColor: _yup.string().matches(/^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{8})$/, "Enter a valid hex color code"),
        bodyBackgroundColor: _yup.string().matches(/^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{8})$/, "Enter a valid hex color code"),
        toolbarBackgroundColor: _yup.string().matches(/^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{8})$/, "Enter a valid hex color code"),
        toolbarFontColor: _yup.string().matches(/^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{8})$/, "Enter a valid hex color code")
    }),
    handleSubmit: async (values, { props, setSubmitting })=>{
        setSubmitting(true);
        const platformConfigurations = {
            javaScript: {
                ...props.browserAssistantSettings,
                applicationId: props.browserAssistantSettings?.appId,
                applicationSecret: props.browserAssistantSettings?.appKey,
                name: values.name,
                avatarUrl: values.avatarUrl,
                displayName: values.displayName,
                textToSpeechVoice: props.browserAssistantSettings?.textToSpeechVoice,
                theme: values.themeStyle,
                showConversationHistory: values.showConversationHistory,
                styles: {
                    assistant: {
                        ...props.browserAssistantSettings?.styles?.assistant
                    },
                    header: {
                        ...props.browserAssistantSettings?.styles?.header
                    },
                    body: {
                        ...props.browserAssistantSettings?.styles?.body
                    },
                    toolbar: {
                        ...props.browserAssistantSettings?.styles?.toolbar
                    },
                    start: {
                        ...props.browserAssistantSettings?.styles?.start
                    }
                }
            },
            kotlin: {
                ...props.kotlinAssistantSettings?.assistantSettings,
                applicationId: props.kotlinAssistantSettings?.assistantSettings?.appId,
                applicationSecret: props.kotlinAssistantSettings?.assistantSettings?.appKey,
                activeInput: props.kotlinAssistantSettings?.assistantSettings?.initializeWithText ? "textbox" : "none",
                name: values.name,
                styles: {
                    assistant: {
                        ...props.kotlinAssistantSettings?.assistantSettings
                    },
                    header: {
                        ...props.kotlinAssistantSettings?.headerProps
                    },
                    body: {
                        ...props.kotlinAssistantSettings?.bodyProps
                    },
                    toolbar: {
                        ...props.kotlinAssistantSettings?.toolbarProps
                    }
                }
            },
            swift: {
                ...props.swiftAssistantSettings?.assistantSettings,
                serverRootUrl: props.swiftAssistantSettings?.assistantSettings?.serverRootUrl,
                applicationId: props.swiftAssistantSettings?.assistantSettings?.appId,
                applicationSecret: props.swiftAssistantSettings?.assistantSettings?.appKey,
                activeInput: props.swiftAssistantSettings?.assistantSettings?.initializeWithText ? "textbox" : "none",
                name: values.name,
                styles: {
                    assistant: {
                        ...props.swiftAssistantSettings?.assistantSettings
                    },
                    header: {
                        ...props.swiftAssistantSettings?.headerProps
                    },
                    body: {
                        ...props.swiftAssistantSettings?.bodyProps
                    },
                    toolbar: {
                        ...props.swiftAssistantSettings?.toolbarProps
                    }
                }
            }
        };
        const customAssistantConfiguration = {
            id: props.configId,
            serverRootUrl: values.serverRootUrl,
            applicationId: values.appId,
            applicationSecret: values.appKey,
            locale: values.locale,
            channel: values.channel,
            device: values.device,
            autoRunConversation: values.autoRunConversation,
            initializeWithWelcomeMessage: values.initializeWithWelcomeMessage,
            textToSpeechProvider: values.textToSpeechProvider,
            useVoiceInput: values.useVoiceInput,
            useOutputSpeech: values.useOutputSpeech,
            useDraftContent: values.useDraftContent,
            noTracking: values.noTracking,
            sessionTimeout: values.sessionTimeout,
            uiType: values.uiType,
            activeInput: values.activeInput,
            name: values.name,
            avatarUrl: values.avatarUrl,
            displayName: values.displayName,
            textToSpeechVoice: values.textToSpeechVoice,
            theme: values.themeStyle,
            primaryColor: values.primaryColor,
            font: values.font,
            showConversationHistory: values.showConversationHistory,
            platformConfigurations: platformConfigurations,
            styles: {
                assistant: {
                    backgroundColor: values.overallBackgroundColor
                },
                header: {
                    fontFamily: values.headerFontFamily,
                    assistantNameTextColor: values.headerAssistantNameTextColor,
                    assistantImage: values.headerAssistantImage,
                    assistantName: values.headerAssistantName,
                    backgroundColor: values.headerBackgroundColor,
                    closeAssistantColor: values.headerCloseAssistantColor,
                    minimizeAssistantColor: values.headerMinimizeAssistantColor,
                    closeAssistantButtonImage: values.headerCloseAssistantButtonImage,
                    minimizeIcon: values.headerMinimizeIcon
                },
                body: {
                    assistantImage: values.bodyAssistantImage,
                    backgroundColor: values.bodyBackgroundColor,
                    borderBottomColor: values.overallBorderColor,
                    borderTopColor: values.overallBorderColor,
                    messageSentBackgroundColor: values.bodyMessageSentBackgroundColor,
                    messageSentFontFamily: values.bodyMessageSentFontFamily,
                    messageReceivedFontFamily: values.bodyMessageReceivedFontFamily,
                    hintsFontFamily: values.bodyHintsFontFamily,
                    messageSentTextColor: values.bodyMessageSentTextColor,
                    messageReceivedTextColor: values.bodyMessageReceivedTextColor,
                    messageReceivedBackgroundColor: values.bodyMessageReceivedBackgroundColor,
                    hintsTextColor: values.bodyHintsTextColor,
                    hintsBackgroundColor: values.bodyHintsBackgroundColor
                },
                toolbar: {
                    assistantStateTextColor: values.toolbarAssistantStateTextColor,
                    assistantStateFontFamily: values.toolbarAssistantStateFontFamily,
                    helpTextFontFamily: values.toolbarHelpTextFontFamily,
                    muteFontFamily: values.toolbarMuteFontFamily,
                    partialSpeechResultFontFamily: values.toolbarPartialSpeechResultFontFamily,
                    speakFontFamily: values.toolbarSpeakFontFamily,
                    typeFontFamily: values.toolbarTypeFontFamily,
                    textboxFontFamily: values.toolbarTextboxFontFamily,
                    speechResultBoxBackgroundColor: values.toolbarSpeechResultBoxBackgroundColor,
                    micActiveHighlightColor: values.toolbarMicActiveHighlightColor,
                    speakActiveTitleColor: values.toolbarSpeakActiveTitleColor,
                    typeActiveTitleColor: values.toolbarTypeActiveTitleColor,
                    backgroundColor: values.toolbarBackgroundColor,
                    micActiveImage: values.toolbarMicActiveImage,
                    micInactiveImage: values.toolbarMicActiveImage,
                    sendActiveImage: values.toolbarSendActiveImage,
                    sendInactiveImage: values.toolbarSendActiveImage,
                    assistantStateFontColor: values.toolbarAssistantStateFontColor,
                    helpTextFontColor: values.toolbarHelpTextFontColor,
                    speakInactiveTitleColor: values.toolbarSpeakInactiveTitleColor,
                    typeInactiveTitleColor: values.toolbarTypeInactiveTitleColor,
                    muteFontColor: values.toolbarMuteFontColor,
                    placeholder: values.toolbarPlaceholder,
                    textInputLineColor: values.toolbarTextInputLineColor,
                    textInputActiveLineColor: values.toolbarTextInputActiveLineColor,
                    equalizerColor: values.toolbarEqualizerColor,
                    equalizerColorOne: values.toolbarEqualizerColorOne,
                    equalizerColorTwo: values.toolbarEqualizerColorTwo,
                    partialSpeechResultTextColor: values.toolbarPartialSpeechResultTextColor,
                    fullSpeechResultTextColor: values.toolbarFullSpeechResultTextColor,
                    textInputTextColor: values.toolbarTextInputTextColor,
                    sendActiveColor: values.toolbarSendActiveColor,
                    sendInactiveColor: values.toolbarSendInactiveColor,
                    muteImage: values.toolbarMuteImage,
                    micActiveColor: values.toolbarMicActiveColor
                },
                start: {
                    assistantImage: values.startAssistantImage,
                    buttonBackgroundColor: values.startButtonBackgroundColor,
                    buttonText: values.startButtonText,
                    buttonFontFamily: values.startButtonFontFamily,
                    buttonFontSize: values.startButtonFontSize
                }
            }
        };
        props.handleSubmitForm(customAssistantConfiguration);
        setSubmitting(false);
        props.closeCustomConfigForm();
    }
})((0, _customAssistantConfigurationsDefault.default));
exports.default = CustomAssistantConfigurationsForm;

},{"yup":"j2SJU","formik":"3YnOK","./CustomAssistantConfigurations":"eGtPC","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"eGtPC":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _extends = require("@babel/runtime/helpers/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _base = require("@emotion/styled/base");
var _baseDefault = parcelHelpers.interopDefault(_base);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _uuid = require("uuid");
var _reactTabs = require("react-tabs");
var _button = require("../../../../components/general/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _modalHeader = require("../../../../components/general/ModalHeader");
var _modalHeaderDefault = parcelHelpers.interopDefault(_modalHeader);
var _footerBar = require("../../../../components/structure/FooterBar");
var _footerBarDefault = parcelHelpers.interopDefault(_footerBar);
var _modalLayout = require("../../../../components/structure/ModalLayout");
var _modalLayoutDefault = parcelHelpers.interopDefault(_modalLayout);
var _stylesValues = require("../../../../constants/stylesValues");
var _colors = require("../../../../constants/colors");
var _css = require("@emotion/css");
var _languageContainer = require("../../../../hooks/LanguageContainer");
var _languageContainerDefault = parcelHelpers.interopDefault(_languageContainer);
var _setupTabPanel = require("./SetupTabPanel");
var _setupTabPanelDefault = parcelHelpers.interopDefault(_setupTabPanel);
var _appearanceTabPanel = require("./AppearanceTabPanel");
var _appearanceTabPanelDefault = parcelHelpers.interopDefault(_appearanceTabPanel);
var _exportTabPanel = require("./ExportTabPanel");
var _exportTabPanelDefault = parcelHelpers.interopDefault(_exportTabPanel);
var _customAssistantConfigurationsStyleThemes = require("../../../../constants/customAssistantConfigurationStyles/customAssistantConfigurationsStyleThemes");
var _useWindowSize = require("../../../../hooks/UseWindowSize");
var _useWindowSizeDefault = parcelHelpers.interopDefault(_useWindowSize);
var _customScrollbars = require("../../../../components/structure/CustomScrollbars");
var _customScrollbarsDefault = parcelHelpers.interopDefault(_customScrollbars);
var _voicifyBrowserAssistantSdk = require("@voicify/voicify-browser-assistant-sdk");
var _customAssistantConfigurationsColors = require("../../../../constants/customAssistantConfigurationStyles/customAssistantConfigurationsColors");
var _useCustomAssistantConfigurationColors = require("../../hooks/useCustomAssistantConfigurationColors");
var _useCustomAssistantConfigurationColorsDefault = parcelHelpers.interopDefault(_useCustomAssistantConfigurationColors);
var _useCustomAssistantConfigurationSettings = require("../../hooks/useCustomAssistantConfigurationSettings");
var _useCustomAssistantConfigurationSettingsDefault = parcelHelpers.interopDefault(_useCustomAssistantConfigurationSettings);
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const appearanceIcon = require("c87c604ee1c1a954");
const exportIcon = require("fa39a1dfbcfbd938");
const previewIcon = require("8fbbe60c13fb2c93");
const setupIcon = require("fc19718c7cc1ab95");
const assistantPreviewBackground = require("99f50d053da613be");
const MODAL_SCROLLBAR_SUBTRACTION = 240;
const CustomAssistantConfigurations = (props)=>{
    const [voicifyAssistantId, setVoicifyAssistantId] = (0, _react1.useState)((0, _uuid.v4)());
    const [rerenderAssistant, setRerenderAssistant] = (0, _react1.useState)(false);
    const [updateAssistant, setUpdateAssistant] = (0, _react1.useState)(true);
    const languagesContainer = (0, _languageContainerDefault.default).useContainer();
    const windowSize = (0, _useWindowSizeDefault.default)();
    const previewParent = (0, _react1.useRef)(null);
    const applicationSettingsHook = (0, _useCustomAssistantConfigurationSettingsDefault.default).useContainer();
    const customAssistantColors = (0, _useCustomAssistantConfigurationColorsDefault.default)();
    const [codeExportLanguage, setCodeExportLanguage] = (0, _react1.useState)("JavaScript");
    const [exportType, setExportType] = (0, _react1.useState)("static");
    const customAssistantSDKVersion = "1.3.9";
    const hasPlatformConfigurations = props.configuration?.platformConfigurations;
    (0, _react1.useEffect)(()=>{
        if (applicationSettingsHook.browserAssistantSettings !== null && updateAssistant) (0, _voicifyBrowserAssistantSdk.initializeVoicifyAssistant)(applicationSettingsHook.browserAssistantSettings, voicifyAssistantId);
    }, [
        voicifyAssistantId,
        applicationSettingsHook.browserAssistantSettings,
        updateAssistant
    ]);
    (0, _react1.useEffect)(()=>{
        const getLanguages = async ()=>{
            await languagesContainer.loadLanguages();
        };
        if (languagesContainer.languages.length === 0) getLanguages();
        const configLanguage = languagesContainer.languages?.find((l)=>l.shortCode === props.configuration.locale);
        if (configLanguage) {
            const configLanguageId = configLanguage.id;
            if (configLanguageId) props.setFieldValue("defaultLanguageId", configLanguageId);
        }
        if (hasPlatformConfigurations) setExportType("dynamic");
    }, []);
    (0, _react1.useEffect)(()=>{
        if (!props.values.primaryColor) customAssistantColors.clearColorStates();
        if (props.values.primaryColor && customAssistantColors.isValidHexCode(props.values.primaryColor)) {
            customAssistantColors.createIconFilter(props.values.primaryColor);
            customAssistantColors.createGradient(props.values.primaryColor);
            customAssistantColors.createColorShade(props.values.primaryColor, 80);
            customAssistantColors.createHighlight(props.values.primaryColor, 0.2);
        } else if (!props.values.primaryColor || !customAssistantColors.isValidHexCode(props.values.primaryColor)) customAssistantColors.createIconFilter("");
    }, [
        props.values.primaryColor,
        customAssistantColors.colorShade,
        customAssistantColors.iconFilter,
        customAssistantColors.highlight
    ]);
    (0, _react1.useEffect)(()=>{
        remountAssistant();
    }, [
        props.values,
        rerenderAssistant,
        previewParent,
        customAssistantColors.gradient,
        customAssistantColors.colorShade,
        customAssistantColors.highlight,
        customAssistantColors.iconFilter
    ]);
    (0, _react1.useEffect)(()=>{
        applicationSettingsHook.updateAssistantSettings(props.values, customAssistantColors.gradient, props.applicationId, props.appKey, getBrowserTheme(), getMobileTheme(), customAssistantColors.iconFilter, props.appAvatar, props.appName, customAssistantColors.highlight);
    }, [
        props.values,
        customAssistantColors.gradient,
        props.applicationId,
        props.appKey,
        props.values.themeStyle,
        customAssistantColors.iconFilter,
        props.appAvatar,
        props.appName,
        customAssistantColors.highlight,
        updateAssistant
    ]);
    const remountAssistant = ()=>{
        if (!previewParent.current) return;
        const assistantElement = document.getElementById(voicifyAssistantId);
        if (assistantElement) assistantElement.remove();
        const id = (0, _uuid.v4)();
        const element = document.createElement("div");
        element.id = id;
        previewParent.current.appendChild(element);
        setVoicifyAssistantId(id);
        applicationSettingsHook.generateAssistantSettingsExport(customAssistantSDKVersion, codeExportLanguage, exportType, props.configId, props.applicationId, props.appKey);
    };
    const getBrowserTheme = ()=>{
        let theme;
        switch(props.values.themeStyle){
            case "lightStyle1":
                if (props.values.uiType === "minimal") theme = (0, _customAssistantConfigurationsStyleThemes.browserLightStyle1Minimal);
                else theme = (0, _customAssistantConfigurationsStyleThemes.browserLightStyle1);
                break;
            case "lightStyle2":
                if (props.values.uiType === "minimal") theme = (0, _customAssistantConfigurationsStyleThemes.browserLightStyle2Minimal);
                else theme = (0, _customAssistantConfigurationsStyleThemes.browserLightStyle2);
                break;
            case "darkStyle1":
                if (props.values.uiType === "minimal") theme = (0, _customAssistantConfigurationsStyleThemes.browserDarkStyle1Minimal);
                else theme = (0, _customAssistantConfigurationsStyleThemes.browserDarkStyle1);
                break;
            case "darkStyle2":
                if (props.values.uiType === "minimal") theme = (0, _customAssistantConfigurationsStyleThemes.browserDarkStyle2Minimal);
                else theme = (0, _customAssistantConfigurationsStyleThemes.browserDarkStyle2);
                break;
            default:
                if (props.values.uiType === "minimal") theme = (0, _customAssistantConfigurationsStyleThemes.browserDefaultStyleMinimal);
                else theme = (0, _customAssistantConfigurationsStyleThemes.browserDefaultStyle);
                break;
        }
        return theme;
    };
    const getMobileTheme = ()=>{
        let theme;
        switch(props.values.themeStyle){
            case "lightStyle1":
                if (props.values.uiType === "minimal") theme = (0, _customAssistantConfigurationsStyleThemes.mobileLightStyle1Minimal);
                else theme = (0, _customAssistantConfigurationsStyleThemes.mobileLightStyle1);
                break;
            case "lightStyle2":
                if (props.values.uiType === "minimal") theme = (0, _customAssistantConfigurationsStyleThemes.mobileLightStyle2Minimal);
                else theme = (0, _customAssistantConfigurationsStyleThemes.mobileLightStyle2);
                break;
            case "darkStyle1":
                if (props.values.uiType === "minimal") theme = (0, _customAssistantConfigurationsStyleThemes.mobileDarkStyle1Minimal);
                else theme = (0, _customAssistantConfigurationsStyleThemes.mobileDarkStyle1);
                break;
            case "darkStyle2":
                if (props.values.uiType === "minimal") theme = (0, _customAssistantConfigurationsStyleThemes.mobileDarkStyle2Minimal);
                else theme = (0, _customAssistantConfigurationsStyleThemes.mobileDarkStyle2);
                break;
            default:
                theme = (0, _customAssistantConfigurationsStyleThemes.mobileDefaultStyle);
                break;
        }
        return theme;
    };
    const handleOnChange = (optionValue, value)=>{
        props.setFieldValue(optionValue, value);
    };
    const handleCodeExportLanguageChange = (optionValue, value)=>{
        setCodeExportLanguage(value);
        applicationSettingsHook.generateAssistantSettingsExport(customAssistantSDKVersion, value, exportType, props.configId, props.applicationId, props.appKey);
    };
    const handleExportTypeChange = (optionValue, value)=>{
        setExportType(value);
        applicationSettingsHook.generateAssistantSettingsExport(customAssistantSDKVersion, codeExportLanguage, value, props.configId, props.applicationId, props.appKey);
    };
    return (0, _react.jsx)((0, _modalLayoutDefault.default), {
        isVisible: true
    }, (0, _react.jsx)((0, _modalHeaderDefault.default), {
        title: "Configure a Custom Deployment Channel",
        onClose: props.closeCustomConfigForm
    }), (0, _react.jsx)("form", {
        onSubmit: props.handleSubmit
    }, (0, _react.jsx)(ContentWrapper, null, (0, _react.jsx)((0, _reactTabs.Tabs), {
        className: tabWrapper
    }, (0, _react.jsx)((0, _reactTabs.TabList), {
        className: modalSubHeader
    }, (0, _react.jsx)((0, _reactTabs.Tab), {
        className: tabItem,
        disabledClassName: tabItemTitleDisabled,
        selectedClassName: tabItemTitleSelected
    }, (0, _react.jsx)("img", {
        className: tabItemIcon,
        src: setupIcon
    }), (0, _react.jsx)("p", null, "Setup")), (0, _react.jsx)((0, _reactTabs.Tab), {
        className: tabItem,
        disabledClassName: tabItemTitleDisabled,
        selectedClassName: tabItemTitleSelected
    }, (0, _react.jsx)("img", {
        className: tabItemIcon,
        src: appearanceIcon
    }), (0, _react.jsx)("p", null, "Appearance"))), (0, _react.jsx)((0, _reactTabs.TabPanel), {
        className: setupTabPanel
    }, (0, _react.jsx)((0, _customScrollbarsDefault.default), {
        autoHide: true,
        autoHeight: true,
        autoHeightMax: windowSize.windowSize.innerHeight * .9 - MODAL_SCROLLBAR_SUBTRACTION
    }, (0, _react.jsx)((0, _setupTabPanelDefault.default), (0, _extendsDefault.default)({}, props, {
        handleOnChange: handleOnChange
    })))), (0, _react.jsx)((0, _reactTabs.TabPanel), {
        className: appearanceTabPanel
    }, (0, _react.jsx)((0, _customScrollbarsDefault.default), {
        autoHide: true,
        autoHeight: true,
        autoHeightMax: windowSize.windowSize.innerHeight * .9 - MODAL_SCROLLBAR_SUBTRACTION
    }, (0, _react.jsx)((0, _appearanceTabPanelDefault.default), (0, _extendsDefault.default)({}, props, {
        handleOnChange: handleOnChange,
        codeExportLanguage: codeExportLanguage
    }))))), (0, _react.jsx)((0, _reactTabs.Tabs), {
        onSelect: (index)=>{
            if (index === 0) {
                setRerenderAssistant(!rerenderAssistant);
                setUpdateAssistant(true);
            } else {
                applicationSettingsHook.generateAssistantSettingsExport(customAssistantSDKVersion, codeExportLanguage, exportType, props.configId, props.applicationId, props.appKey);
                //dont update assistant preview while on export tab
                setUpdateAssistant(false);
            }
        },
        className: tabWrapper
    }, (0, _react.jsx)((0, _reactTabs.TabList), {
        className: modalSubHeader
    }, (0, _react.jsx)((0, _reactTabs.Tab), {
        className: tabItem,
        disabledClassName: tabItemTitleDisabled,
        selectedClassName: tabItemTitleSelected
    }, (0, _react.jsx)("img", {
        className: tabItemIcon,
        src: previewIcon
    }), (0, _react.jsx)("p", null, "Preview")), (0, _react.jsx)((0, _reactTabs.Tab), {
        className: tabItem,
        disabledClassName: tabItemTitleDisabled,
        selectedClassName: tabItemTitleSelected
    }, (0, _react.jsx)("img", {
        className: tabItemIcon,
        src: exportIcon
    }), (0, _react.jsx)("p", null, "Export"))), (0, _react.jsx)((0, _reactTabs.TabPanel), {
        className: previewTabPanel
    }, (0, _react.jsx)((0, _customScrollbarsDefault.default), {
        autoHide: true,
        autoHeight: true,
        autoHeightMax: windowSize.windowSize.innerHeight * .9 - MODAL_SCROLLBAR_SUBTRACTION
    }, (0, _react.jsx)(ConfigurationTabContent, null, (0, _react.jsx)(SubHeader, null, "Scaled Preview"), props.values.uiType === "minimal" ? (0, _react.jsx)(AssistantPreviewWrapperMinimal, null, (0, _react.jsx)(VoicifyAssistantRootMinimal, {
        ref: previewParent,
        id: "voicifyAssistantRoot"
    })) : (0, _react.jsx)(AssistantPreviewWrapper, null, (0, _react.jsx)(VoicifyAssistantRoot, {
        ref: previewParent,
        id: "voicifyAssistantRoot"
    }))))), (0, _react.jsx)((0, _reactTabs.TabPanel), {
        className: exportTabPanel
    }, (0, _react.jsx)((0, _customScrollbarsDefault.default), {
        autoHide: true,
        autoHeight: true,
        autoHeightMax: windowSize.windowSize.innerHeight * .9 - MODAL_SCROLLBAR_SUBTRACTION
    }, (0, _react.jsx)((0, _exportTabPanelDefault.default), {
        copyText: props.copyText,
        assistantSettingsExport: applicationSettingsHook.assistantSettingsExport,
        codeExportLanguage: codeExportLanguage,
        handleCodeExportLanguageChange: handleCodeExportLanguageChange,
        isLoading: applicationSettingsHook.loading || props.isLoading,
        exportType: exportType,
        handleExportTypeChange: handleExportTypeChange,
        hasPlatformConfigurations: hasPlatformConfigurations
    }))))), (0, _react.jsx)((0, _footerBarDefault.default), null, (0, _react.jsx)((0, _buttonDefault.default), {
        disabled: props.isSubmitting,
        loading: props.isSubmitting,
        type: "submit",
        themes: [
            "primary",
            "start"
        ],
        text: "Save & Close"
    }), (0, _react.jsx)((0, _buttonDefault.default), {
        disabled: props.isSubmitting,
        loading: props.isSubmitting,
        type: "button",
        themes: [
            "secondary",
            "end"
        ],
        text: "Cancel",
        onClick: props.closeCustomConfigForm
    }))));
};
const SubHeader = /*#__PURE__*/ (0, _baseDefault.default)("h2", {
    target: "e1p99n8b6"
})("font-size:18px;color:", (0, _colors.color_shades_darkest), ";font-weight:400;margin-bottom:16px;");
const VoicifyAssistantRoot = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1p99n8b5"
})({
    name: "em7azy",
    styles: "transform:scale(0.62)"
});
const VoicifyAssistantRootMinimal = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1p99n8b4"
})({
    name: "j43i4t",
    styles: "transform:scale(0.36)"
});
const AssistantPreviewWrapper = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1p99n8b3"
})("display:flex;justify-content:flex-end;align-items:flex-end;border-top:4px solid ", (0, _customAssistantConfigurationsColors.defaultLightGray), ";border-right:4px solid ", (0, _customAssistantConfigurationsColors.defaultLightGray), ";border-bottom:4px solid ", (0, _customAssistantConfigurationsColors.defaultLightGray), ";padding-top:16px;background:url(", assistantPreviewBackground, ");height:78%;");
const AssistantPreviewWrapperMinimal = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1p99n8b2"
})("display:flex;justify-content:flex-start;align-items:flex-end;border-top:4px solid ", (0, _customAssistantConfigurationsColors.defaultLightGray), ";border-right:4px solid ", (0, _customAssistantConfigurationsColors.defaultLightGray), ";border-bottom:4px solid ", (0, _customAssistantConfigurationsColors.defaultLightGray), ";padding-top:16px;background:url(", assistantPreviewBackground, ");height:78%;");
const ConfigurationTabContent = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1p99n8b1"
})({
    name: "okoa8h",
    styles: "padding:24px 24px 0 24px"
});
const exportTabPanel = /*#__PURE__*/ (0, _css.css)("border-left:", (0, _stylesValues.style_border_default), ";", "");
const previewTabPanel = /*#__PURE__*/ (0, _css.css)("border-left:", (0, _stylesValues.style_border_default), ";", "");
const appearanceTabPanel = /*#__PURE__*/ (0, _css.css)("border-left:", (0, _stylesValues.style_border_default), ";", "");
const setupTabPanel = /*#__PURE__*/ (0, _css.css)("border-left:", (0, _stylesValues.style_border_default), ";", "");
const ContentWrapper = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1p99n8b0"
})({
    name: "zjik7",
    styles: "display:flex"
});
const tabWrapper = /*#__PURE__*/ (0, _css.css)({
    name: "82a6rk",
    styles: "flex:1"
});
const modalSubHeader = /*#__PURE__*/ (0, _css.css)("display:flex;flex-direction:row;padding-left:24px;border-bottom:", (0, _stylesValues.style_border_default), ";border-left:", (0, _stylesValues.style_border_default), ";", "");
const tabItem = /*#__PURE__*/ (0, _css.css)({
    name: "pedvsz",
    styles: "font-size:10px;cursor:pointer;width:80px;height:56px;display:flex;flex-direction:column;align-items:center;justify-content:center"
});
const tabItemIcon = /*#__PURE__*/ (0, _css.css)({
    name: "1f7m605",
    styles: "padding-bottom:4px"
});
const tabItemTitleDisabled = /*#__PURE__*/ (0, _css.css)("color:", (0, _colors.color_shades_darkest), ";", "");
const tabItemTitleSelected = /*#__PURE__*/ (0, _css.css)("color:", (0, _colors.color_colors_ocean), ";background-color:", (0, _colors.color_variants_ocean_light_opaque), ";img{filter:invert(49%) sepia(18%) saturate(1878%) hue-rotate(159deg) brightness(85%) contrast(99%);}", "");
exports.default = CustomAssistantConfigurations;

},{"@babel/runtime/helpers/extends":"4iKIP","@emotion/styled/base":"lSuFu","@emotion/react":"djZKr","react":"6uln9","uuid":"klst7","react-tabs":"92Sgf","../../../../components/general/Button":"6ymxN","../../../../components/general/ModalHeader":"aUACx","../../../../components/structure/FooterBar":"bibRL","../../../../components/structure/ModalLayout":"b1cO3","../../../../constants/stylesValues":"dHVVv","../../../../constants/colors":"1p3OR","@emotion/css":"awUBr","../../../../hooks/LanguageContainer":"lchkU","./SetupTabPanel":"8kzgY","./AppearanceTabPanel":"2pAKq","./ExportTabPanel":"9bHqN","../../../../constants/customAssistantConfigurationStyles/customAssistantConfigurationsStyleThemes":"ik75v","../../../../hooks/UseWindowSize":"43j9z","../../../../components/structure/CustomScrollbars":"50vFq","@voicify/voicify-browser-assistant-sdk":"xTqnJ","../../../../constants/customAssistantConfigurationStyles/customAssistantConfigurationsColors":"jOo9r","../../hooks/useCustomAssistantConfigurationColors":"kTU5j","../../hooks/useCustomAssistantConfigurationSettings":"jrJ7j","c87c604ee1c1a954":"iUA5c","fa39a1dfbcfbd938":"1W8SX","8fbbe60c13fb2c93":"4l2Jt","fc19718c7cc1ab95":"9IMzT","99f50d053da613be":"18Wlu","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8kzgY":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _base = require("@emotion/styled/base");
var _baseDefault = parcelHelpers.interopDefault(_base);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _radioGroup = require("../../../../components/forms/RadioGroup");
var _radioGroupDefault = parcelHelpers.interopDefault(_radioGroup);
var _textField = require("../../../../components/forms/TextField");
var _textFieldDefault = parcelHelpers.interopDefault(_textField);
var _horizontalSeparator = require("../../../../components/structure/HorizontalSeparator");
var _horizontalSeparatorDefault = parcelHelpers.interopDefault(_horizontalSeparator);
var _avatarFileUploadField = require("../../../../components/forms/AvatarFileUploadField");
var _avatarFileUploadFieldDefault = parcelHelpers.interopDefault(_avatarFileUploadField);
var _styledDropdown = require("./StyledDropdown");
var _styledDropdownDefault = parcelHelpers.interopDefault(_styledDropdown);
var _customAssistantPreviewLayout = require("./CustomAssistantPreviewLayout");
var _customAssistantPreviewLayoutDefault = parcelHelpers.interopDefault(_customAssistantPreviewLayout);
var _colors = require("../../../../constants/colors");
var _stylesValues = require("../../../../constants/stylesValues");
var _customAssistantConfigurationFormOptions = require("../../../../models/customAssistant/CustomAssistantConfigurationFormOptions");
var _languageSingleSelector = require("../languages/LanguageSingleSelector");
var _languageSingleSelectorDefault = parcelHelpers.interopDefault(_languageSingleSelector);
var _languageContainer = require("../../../../hooks/LanguageContainer");
var _languageContainerDefault = parcelHelpers.interopDefault(_languageContainer);
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const addIcon = require("e22dcb5f3376ef9d");
const SetupTabPanel = (props)=>{
    const [imageUrl, setImageUrl] = (0, _react1.useState)(props.values.avatarUrl);
    const languagesContainer = (0, _languageContainerDefault.default).useContainer();
    const handleLanguageChange = (selectedLanguageIds)=>{
        props.setFieldValue("defaultLanguageId", selectedLanguageIds[0]);
        const selectedLanguage = languagesContainer.languages?.find((l)=>l.id === selectedLanguageIds[0]);
        const selectedLanguageShortCode = selectedLanguage.shortCode;
        if (selectedLanguageShortCode) props.setFieldValue("locale", selectedLanguageShortCode);
    };
    const handleImageSelected = (file)=>{
        readDataUrl(file);
        getConfigImageUrl(file);
    };
    const readDataUrl = (file)=>{
        const reader = new FileReader();
        reader.readAsDataURL(file);
    };
    const getConfigImageUrl = async (file)=>{
        const result = await props.mediaContainer.uploadMediaItem(props.applicationId, "customAssistantConfigurationImage", file, null, ()=>null);
        props.setFieldValue("avatarUrl", result.data.url);
        setImageUrl(result.data.url);
    };
    const handleLayoutOnChange = (optionValue, value)=>{
        props.setFieldValue(optionValue, value);
        if (value === "minimal") props.setFieldValue("autoRunConversation", true);
        else props.setFieldValue("autoRunConversation", false);
    };
    return (0, _react.jsx)(ConfigurationTabContent, null, (0, _react.jsx)(SubHeader, null, "Setup"), (0, _react.jsx)(Description, null, "Configure how your assistant will work"), (0, _react.jsx)(SectionHeaderWrapper, null, (0, _react.jsx)(SectionHeaderText, null, "Basics"), (0, _react.jsx)((0, _horizontalSeparatorDefault.default), null)), (0, _react.jsx)((0, _languageSingleSelectorDefault.default), {
        labelStyle: languageLabelStyle,
        groupToggle: groupToggleStyle,
        label: "Language / Region",
        className: languageSelectStyle,
        languages: languagesContainer.languages,
        selectedLanguageIds: [
            props.values.defaultLanguageId
        ],
        onChange: handleLanguageChange,
        optionStyle: languageSingleSelectorOptionStyle
    }), (0, _react.jsx)((0, _textFieldDefault.default), {
        name: "name",
        tooltip: "Name used internally",
        toolTipPosition: "right",
        disabled: false,
        value: props.values.name,
        label: "Configuration Name",
        placeholder: "Configuration Name",
        onChange: props.handleChange,
        onBlur: props.handleBlur,
        fieldContainerStyle: fieldContainerStyle
    }), props.values.uiType !== "minimal" && (0, _react.jsx)((0, _textFieldDefault.default), {
        name: "displayName",
        tooltip: "Name end-users see",
        toolTipPosition: "right",
        disabled: false,
        value: props.values.displayName,
        label: "Assistant Display Name",
        placeholder: "Display Name",
        onChange: props.handleChange,
        onBlur: props.handleBlur,
        fieldContainerStyle: fieldContainerStyle
    }), (0, _react.jsx)((0, _avatarFileUploadFieldDefault.default), {
        imageUrl: imageUrl,
        label: "Avatar",
        addImageText: "Add Image",
        addIcon: addIcon,
        containerStyle: avatarFileUploadContainerStyle,
        previewStyle: avatarFileUploadIconWrapper,
        defaultImageStyle: defaultFileUploadIconStyle,
        imageStyle: avatarFileUploadIconStyle,
        buttonStyle: avatarFileUploadButtonStyle,
        accept: ".png,.jpg,.jpeg",
        onChange: handleImageSelected
    }), (0, _react.jsx)((0, _horizontalSeparatorDefault.default), {
        className: horizontalSeparatorWrapper
    }), (0, _react.jsx)(SectionHeaderWrapper, null, (0, _react.jsx)(SectionHeaderText, null, "Layout"), (0, _react.jsx)((0, _horizontalSeparatorDefault.default), null)), (0, _react.jsx)(Label, null, "Layout"), (0, _react.jsx)((0, _styledDropdownDefault.default), {
        handleOnChange: handleLayoutOnChange,
        fieldName: "uiType",
        options: (0, _customAssistantConfigurationFormOptions.uITypeOptions),
        size: "medium",
        className: dropDownStyleMedium,
        value: props.values.uiType
    }), (0, _react.jsx)((0, _customAssistantPreviewLayoutDefault.default), props), (0, _react.jsx)(SectionHeaderWrapper, null, (0, _react.jsx)(SectionHeaderText, null, "Initialization Mode"), (0, _react.jsx)((0, _horizontalSeparatorDefault.default), null)), (0, _react.jsx)(Description, null, "How do you want the assistant to start up when the user activates it?"), (0, _react.jsx)(RadioGroupLabel, null, "Welcome Message"), (0, _react.jsx)((0, _radioGroupDefault.default), {
        checkContainerStyle: checkContainerStyle,
        selectedOptionStyle: selectedOptionStyle,
        onChange: (e)=>props.handleOnChange("initializeWithWelcomeMessage", e.value),
        value: props.values.initializeWithWelcomeMessage,
        options: (0, _customAssistantConfigurationFormOptions.initializeWithWelcomeMessageOptions)
    }), props.values.uiType !== "minimal" && // autoRunConversation defaults to true for the minimal UI type
    (0, _react.jsx)((0, _reactDefault.default).Fragment, null, (0, _react.jsx)(RadioGroupLabel, null, "Listening"), (0, _react.jsx)((0, _radioGroupDefault.default), {
        checkContainerStyle: checkContainerStyle,
        selectedOptionStyle: selectedOptionStyle,
        onChange: (e)=>props.handleOnChange("autoRunConversation", e.value),
        value: props.values.autoRunConversation,
        options: (0, _customAssistantConfigurationFormOptions.autoRunConversationOptions)
    })), props.values.uiType !== "minimal" && (0, _react.jsx)((0, _reactDefault.default).Fragment, null, (0, _react.jsx)(SectionHeaderWrapper, null, (0, _react.jsx)(SectionHeaderText, null, "Input Types"), (0, _react.jsx)((0, _horizontalSeparatorDefault.default), null)), (0, _react.jsx)((0, _radioGroupDefault.default), {
        checkContainerStyle: checkContainerStyle,
        selectedOptionStyle: selectedOptionStyle,
        onChange: (e)=>props.handleOnChange("useVoiceInput", e.value),
        value: props.values.useVoiceInput,
        options: (0, _customAssistantConfigurationFormOptions.useVoiceInputOptions)
    }), (0, _react.jsx)(Label, null, "Active Input at open"), (0, _react.jsx)((0, _styledDropdownDefault.default), {
        handleOnChange: props.handleOnChange,
        fieldName: "activeInput",
        options: (0, _customAssistantConfigurationFormOptions.activeInputOptions),
        size: "medium",
        className: dropDownStyleMedium,
        value: props.values.activeInput
    })), (0, _react.jsx)(SectionHeaderWrapper, null, (0, _react.jsx)(SectionHeaderText, null, "Output Types"), (0, _react.jsx)((0, _horizontalSeparatorDefault.default), null)), props.values.uiType !== "minimal" && (0, _react.jsx)((0, _radioGroupDefault.default), {
        checkContainerStyle: checkContainerStyle,
        selectedOptionStyle: selectedOptionStyle,
        onChange: (e)=>props.handleOnChange("useOutputSpeech", e.value),
        value: props.values.useOutputSpeech,
        options: (0, _customAssistantConfigurationFormOptions.useOutputSpeechOptions)
    }), (0, _react.jsx)(Label, null, "Text-to-Speech Provider"), (0, _react.jsx)((0, _styledDropdownDefault.default), {
        handleOnChange: props.handleOnChange,
        fieldName: "textToSpeechProvider",
        options: (0, _customAssistantConfigurationFormOptions.textToSpeechProviderOptions),
        size: "medium",
        className: dropDownStyleMedium,
        value: props.values.textToSpeechProvider
    }), props.values.textToSpeechProvider === "Google" && (0, _react.jsx)((0, _reactDefault.default).Fragment, null, (0, _react.jsx)(LabelWrapper, null, (0, _react.jsx)(Label, null, "Google Text-to-Speech Voice"), (0, _react.jsx)(LabelLink, {
        href: "https://cloud.google.com/text-to-speech/docs/voices",
        target: "_blank"
    }, "(more info)")), (0, _react.jsx)((0, _styledDropdownDefault.default), {
        handleOnChange: props.handleOnChange,
        fieldName: "textToSpeechVoice",
        options: (0, _customAssistantConfigurationFormOptions.googleVoiceOptions),
        size: "medium",
        className: dropDownStyleMedium,
        value: props.values.textToSpeechVoice
    })), props.values.textToSpeechProvider === "Polly" && (0, _react.jsx)((0, _reactDefault.default).Fragment, null, (0, _react.jsx)(LabelWrapper, null, (0, _react.jsx)(Label, null, "Polly Text-to-Speech Voice"), (0, _react.jsx)(LabelLink, {
        href: "https://docs.aws.amazon.com/polly/latest/dg/voicelist.html",
        target: "_blank"
    }, "(more info)")), (0, _react.jsx)((0, _styledDropdownDefault.default), {
        handleOnChange: props.handleOnChange,
        fieldName: "textToSpeechVoice",
        options: (0, _customAssistantConfigurationFormOptions.pollyVoiceOptions),
        size: "medium",
        className: dropDownStyleMedium,
        value: props.values.textToSpeechVoice
    })), props.values.uiType === "minimal" && (0, _react.jsx)((0, _reactDefault.default).Fragment, null, (0, _react.jsx)(RadioGroupLabel, null, "Show Conversation History"), (0, _react.jsx)((0, _radioGroupDefault.default), {
        checkContainerStyle: checkContainerStyle,
        selectedOptionStyle: selectedOptionStyle,
        onChange: (e)=>props.handleOnChange("showConversationHistory", e.value),
        value: props.values.showConversationHistory,
        options: (0, _customAssistantConfigurationFormOptions.showConversationHistoryOptions)
    })), (0, _react.jsx)(SectionHeaderWrapper, null, (0, _react.jsx)(SectionHeaderText, null, "Content"), (0, _react.jsx)((0, _horizontalSeparatorDefault.default), null)), (0, _react.jsx)((0, _radioGroupDefault.default), {
        checkContainerStyle: checkContainerStyle,
        selectedOptionStyle: selectedOptionStyle,
        onChange: (e)=>props.handleOnChange("useDraftContent", e.value),
        value: props.values.useDraftContent,
        options: (0, _customAssistantConfigurationFormOptions.useDraftContentOptions)
    }), (0, _react.jsx)(SectionHeaderWrapper, null, (0, _react.jsx)(SectionHeaderText, null, "Analytics"), (0, _react.jsx)((0, _horizontalSeparatorDefault.default), null)), (0, _react.jsx)((0, _radioGroupDefault.default), {
        checkContainerStyle: checkContainerStyle,
        selectedOptionStyle: selectedOptionStyle,
        onChange: (e)=>props.handleOnChange("noTracking", e.value),
        value: props.values.noTracking,
        options: (0, _customAssistantConfigurationFormOptions.noTrackingOptions)
    }));
};
const LabelWrapper = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e10hnt8c8"
})({
    name: "ho1qnd",
    styles: "display:flex;flex-direction:row"
});
const Label = /*#__PURE__*/ (0, _baseDefault.default)("p", {
    target: "e10hnt8c7"
})("font-weight:400;font-size:14px;color:", (0, _colors.color_shades_darkest), ";margin:16px 0 4px 16px;");
const LabelLink = /*#__PURE__*/ (0, _baseDefault.default)("a", {
    target: "e10hnt8c6"
})("font-weight:400;font-size:14px;margin:16px 0 4px 8px;color:", (0, _colors.color_text_link), ";");
const SubHeader = /*#__PURE__*/ (0, _baseDefault.default)("h2", {
    target: "e10hnt8c5"
})("font-size:18px;color:", (0, _colors.color_shades_darkest), ";font-weight:400;");
const languageSingleSelectorOptionStyle = /*#__PURE__*/ (0, _css.css)({
    name: "15qog9e",
    styles: "font-size:14px;&.item-group{height:48px;}&.sub-item{height:48px;p{font-size:14px;}}"
});
const languageLabelStyle = /*#__PURE__*/ (0, _css.css)({
    name: "ms1rrx",
    styles: "font-size:14px;padding:0 8px"
});
const fieldContainerStyle = /*#__PURE__*/ (0, _css.css)({
    name: "128tros",
    styles: "height:48px"
});
const Description = /*#__PURE__*/ (0, _baseDefault.default)("p", {
    target: "e10hnt8c4"
})("font-size:14px;color:", (0, _colors.color_shades_darker), ";margin:16px 0 32px 0;");
const RadioGroupLabel = /*#__PURE__*/ (0, _baseDefault.default)("p", {
    target: "e10hnt8c3"
})("font-weight:400;font-size:14px;color:", (0, _colors.color_shades_darkest), ";margin:32px 0 4px 0;");
const avatarFileUploadButtonStyle = /*#__PURE__*/ (0, _css.css)("font-weight:400;font-size:16px;color:", (0, _colors.color_colors_ocean), ";margin-right:0;", "");
const horizontalSeparatorWrapper = /*#__PURE__*/ (0, _css.css)({
    name: "17r46gx",
    styles: "z-index:-1;margin-top:-25px"
});
const avatarFileUploadContainerStyle = /*#__PURE__*/ (0, _css.css)({
    name: "1p4rrvx",
    styles: "flex-grow:1;display:flex;flex-direction:column;.dropZone{display:flex;flex-direction:row;justify-content:space-between;align-items:flex-end;}margin:32px 0 0 0"
});
const defaultFileUploadIconStyle = /*#__PURE__*/ (0, _css.css)({
    name: "zvd8x7",
    styles: "width:40px;height:40px;left:20px;top:20px;position:absolute"
});
const avatarFileUploadIconStyle = /*#__PURE__*/ (0, _css.css)({
    name: "1h7i3to",
    styles: "width:80px;height:80px;border-radius:50%;left:0;top:0;position:absolute"
});
const avatarFileUploadIconWrapper = /*#__PURE__*/ (0, _css.css)("width:80px;height:80px;padding:20px;background-color:#ffffff;border:", (0, _stylesValues.style_border_default), ";border-radius:50%;box-shadow:0px 4px 10px ", (0, _colors.color_variants_shadow_10), ";cursor:pointer;", "");
const checkContainerStyle = /*#__PURE__*/ (0, _css.css)("width:20px;height:20px;border-radius:50%;background-color:#ffffff;border:", (0, _stylesValues.style_border_default), ";display:flex;align-items:center;justify-content:center;", "");
const selectedOptionStyle = /*#__PURE__*/ (0, _css.css)("width:10px;height:10px;border-radius:50%;background-image:", (0, _colors.color_gradients_green_shift), ";", "");
const groupToggleStyle = /*#__PURE__*/ (0, _css.css)({
    name: "1o53n4x",
    styles: "margin-left:auto;margin-right:8px;height:8px;width:8px"
});
const languageSelectStyle = /*#__PURE__*/ (0, _css.css)("margin:64px 0 32px 0;.field .selection{height:48px;border-radius:5px;padding-left:24px;}.field-wrapper{label{position:absolute;left:14px;top:-27px;font-family:Muli;font-size:14px;font-weight:400;color:", (0, _colors.color_shades_darkest), ";}}", "");
const SectionHeaderText = /*#__PURE__*/ (0, _baseDefault.default)("h2", {
    target: "e10hnt8c2"
})("margin-right:8px;font-size:16px;color:", (0, _colors.color_shades_darkest), ";text-transform:uppercase;font-weight:400;white-space:nowrap;");
const ConfigurationTabContent = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e10hnt8c1"
})({
    name: "okoa8h",
    styles: "padding:24px 24px 0 24px"
});
const SectionHeaderWrapper = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e10hnt8c0"
})({
    name: "13a1wts",
    styles: "display:flex;align-items:center;margin:32px 0"
});
const dropDownStyleMedium = /*#__PURE__*/ (0, _css.css)({
    name: "1s22u92",
    styles: "margin-bottom:32px"
});
exports.default = SetupTabPanel;

},{"@emotion/styled/base":"lSuFu","@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","../../../../components/forms/RadioGroup":"eiGrn","../../../../components/forms/TextField":"7a7bh","../../../../components/structure/HorizontalSeparator":"Pw3HQ","../../../../components/forms/AvatarFileUploadField":"fAjrB","./StyledDropdown":"hjrMo","./CustomAssistantPreviewLayout":"1qpla","../../../../constants/colors":"1p3OR","../../../../constants/stylesValues":"dHVVv","../../../../models/customAssistant/CustomAssistantConfigurationFormOptions":"hNADH","../languages/LanguageSingleSelector":"eDudC","../../../../hooks/LanguageContainer":"lchkU","e22dcb5f3376ef9d":"9qrrO","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1qpla":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _base = require("@emotion/styled/base");
var _baseDefault = parcelHelpers.interopDefault(_base);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _textField = require("../../../../components/forms/TextField");
var _textFieldDefault = parcelHelpers.interopDefault(_textField);
var _colors = require("../../../../constants/colors");
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const slideFromRightDesktop = require("911ce376c105eda5");
const slideOutDesktop = require("1c3891f67930473a");
const slideOutMobile = require("5f78a827d2f575ba");
const overlayDesktop = require("51049c7d6b2c9acb");
const overlayMobile = require("9981ce8cbfad4269");
const minimalDesktop = require("d590130d277f1581");
const minimalMobile = require("9d652810b198c1df");
const CustomAssistantPreviewLayout = (props)=>{
    switch(props.values.uiType){
        case "minimal":
            return (0, _react.jsx)(LayoutPreviewWrapper, null, (0, _react.jsx)(LayoutPreview, null, (0, _react.jsx)(LayoutPreviewHeading, null, "Minimal for Large Screens"), (0, _react.jsx)(LayoutPreviewImage, {
                src: minimalDesktop
            }), (0, _react.jsx)(LayoutPreviewDescription, null, "Assistant will appear as a button in the bottom center of the page and will open vertically")), (0, _react.jsx)(LayoutPreview, null, (0, _react.jsx)(LayoutPreviewHeading, null, "Minimal for Small Screens"), (0, _react.jsx)(LayoutPreviewImage, {
                src: minimalMobile
            }), (0, _react.jsx)(LayoutPreviewDescription, null, "Assistant will appear as a button in the bottom center of the page and will open vertically")));
        case "bottomRightButton":
            return (0, _react.jsx)(LayoutPreviewWrapper, null, (0, _react.jsx)(LayoutPreview, null, (0, _react.jsx)(LayoutPreviewHeading, null, "Overylay for Large Screens"), (0, _react.jsx)(LayoutPreviewImage, {
                src: overlayDesktop
            }), (0, _react.jsx)(LayoutPreviewDescription, null, "Assistant will appear as a button in the bottom right corner of the page and will open vertically to cover the content")), (0, _react.jsx)(LayoutPreview, null, (0, _react.jsx)(LayoutPreviewHeading, null, "Overylay for Small Screens"), (0, _react.jsx)(LayoutPreviewImage, {
                src: overlayMobile
            }), (0, _react.jsx)(LayoutPreviewDescription, null, "Assistant will appear as a button in the bottom right corner of the page and will open vertically to cover the content")));
        case "slideFromBottom":
            return (0, _react.jsx)(LayoutPreviewWrapper, null, (0, _react.jsx)(LayoutPreview, null, (0, _react.jsx)(LayoutPreviewHeading, null, "Slide-out for Large Screens"), (0, _react.jsx)(LayoutPreviewImage, {
                src: slideOutDesktop
            }), (0, _react.jsx)(LayoutPreviewDescription, null, "Assistant will appear in a panel on the bottom right side of the screen and will open vertically to cover the content")), (0, _react.jsx)(LayoutPreview, null, (0, _react.jsx)(LayoutPreviewHeading, null, "Slide-out for Small Screens"), (0, _react.jsx)(LayoutPreviewImage, {
                src: slideOutMobile
            }), (0, _react.jsx)(LayoutPreviewDescription, null, "Assistant will appear in a panel on the bottom right side of the screen and will open vertically to cover the content")));
        case "slideFromRight":
            return (0, _react.jsx)((0, _reactDefault.default).Fragment, null, (0, _react.jsx)(LayoutPreviewWrapper, null, (0, _react.jsx)(LayoutPreview, null, (0, _react.jsx)(LayoutPreviewHeading, null, "Slide From Right for Large Screens"), (0, _react.jsx)(LayoutPreviewImage, {
                src: slideFromRightDesktop
            }), (0, _react.jsx)(LayoutPreviewDescription, null, "Assistant will appear as a verticle button on the right-hand side of the page and will open horizontally covering the content"))), (0, _react.jsx)(TextFieldWrapper, null, (0, _react.jsx)((0, _textFieldDefault.default), {
                name: "startButtonText",
                disabled: false,
                value: props.values.startButtonText,
                label: "Start Button Text",
                placeholder: "Start Button Text",
                onChange: props.handleChange,
                onBlur: props.handleBlur,
                fieldContainerStyle: fieldContainerStyle
            }), (0, _react.jsx)((0, _textFieldDefault.default), {
                name: "startButtonFontSize",
                disabled: false,
                value: props.values.startButtonFontSize,
                label: "Start Button Text Size",
                placeholder: "Start Button Text Size",
                onChange: props.handleChange,
                onBlur: props.handleBlur,
                fieldContainerStyle: fieldContainerStyle
            })));
        default:
            return (0, _react.jsx)(LayoutPreviewWrapper, null, (0, _react.jsx)(LayoutPreview, null, (0, _react.jsx)(LayoutPreviewHeading, null, "Minimal for Large Screens"), (0, _react.jsx)(LayoutPreviewImage, {
                src: minimalDesktop
            }), (0, _react.jsx)(LayoutPreviewDescription, null, "Assistant will appear as a button in the bottom right corner of the page and will open vertically to cover the content")), (0, _react.jsx)(LayoutPreview, null, (0, _react.jsx)(LayoutPreviewHeading, null, "Minimal for Small Screens"), (0, _react.jsx)(LayoutPreviewImage, {
                src: minimalMobile
            }), (0, _react.jsx)(LayoutPreviewDescription, null, "Assistant will appear as a button in the bottom right corner of the page and will open vertically to cover the content")));
    }
};
const TextFieldWrapper = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "ee5jqiu5"
})({
    name: "yz1nei",
    styles: "margin-top:16px"
});
const fieldContainerStyle = /*#__PURE__*/ (0, _css.css)({
    name: "128tros",
    styles: "height:48px"
});
const LayoutPreviewWrapper = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "ee5jqiu4"
})({
    name: "1yxf6qu",
    styles: "display:flex;flex-direction:column;justify-content:center;align-items:center"
});
const LayoutPreview = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "ee5jqiu3"
})({
    name: "k7jp6j",
    styles: "display:flex;flex-direction:column;justify-content:center;align-items:center;margin-top:32px"
});
const LayoutPreviewHeading = /*#__PURE__*/ (0, _baseDefault.default)("p", {
    target: "ee5jqiu2"
})("font-weight:400;font-size:18px;color:", (0, _colors.color_shades_darkest), ";text-align:center;");
const LayoutPreviewImage = /*#__PURE__*/ (0, _baseDefault.default)("img", {
    target: "ee5jqiu1"
})({
    name: "te1fbj",
    styles: "margin:8px 0"
});
const LayoutPreviewDescription = /*#__PURE__*/ (0, _baseDefault.default)("p", {
    target: "ee5jqiu0"
})("font-weight:400;font-size:14px;color:", (0, _colors.color_shades_darker), ";text-align:center;");
exports.default = CustomAssistantPreviewLayout;

},{"@emotion/styled/base":"lSuFu","@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","../../../../components/forms/TextField":"7a7bh","../../../../constants/colors":"1p3OR","911ce376c105eda5":"1LGgW","1c3891f67930473a":"6l1rO","5f78a827d2f575ba":"b2qU6","51049c7d6b2c9acb":"62d8Q","9981ce8cbfad4269":"kQZ6E","d590130d277f1581":"ioNyi","9d652810b198c1df":"gHETj","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1LGgW":[function(require,module,exports) {
module.exports = require("514f5509d16d4d3c").getBundleURL("kVLro") + require("b6fa2364eafd55de").resolve("a5PFz");

},{"514f5509d16d4d3c":"c7Tr5","b6fa2364eafd55de":"fyJL2"}],"6l1rO":[function(require,module,exports) {
module.exports = require("e0031d22642adaca").getBundleURL("kVLro") + require("3255d083d516295").resolve("4Uvjp");

},{"e0031d22642adaca":"c7Tr5","3255d083d516295":"fyJL2"}],"b2qU6":[function(require,module,exports) {
module.exports = require("bca673500e2733bb").getBundleURL("kVLro") + require("3260b0dba7206cc7").resolve("iqre9");

},{"bca673500e2733bb":"c7Tr5","3260b0dba7206cc7":"fyJL2"}],"62d8Q":[function(require,module,exports) {
module.exports = require("3749f743a2d11b8f").getBundleURL("kVLro") + require("3e36f1d1a50fdcb3").resolve("g0Aou");

},{"3749f743a2d11b8f":"c7Tr5","3e36f1d1a50fdcb3":"fyJL2"}],"kQZ6E":[function(require,module,exports) {
module.exports = require("d3c829757683ece2").getBundleURL("kVLro") + require("440eb8e761b74737").resolve("lwj9z");

},{"d3c829757683ece2":"c7Tr5","440eb8e761b74737":"fyJL2"}],"ioNyi":[function(require,module,exports) {
module.exports = require("74f2508ca2d85e6b").getBundleURL("kVLro") + require("eff09ac45488e893").resolve("kWwFZ");

},{"74f2508ca2d85e6b":"c7Tr5","eff09ac45488e893":"fyJL2"}],"gHETj":[function(require,module,exports) {
module.exports = require("b487d7a41f32cc99").getBundleURL("kVLro") + require("55bf67ea6b01a7f4").resolve("5vxUJ");

},{"b487d7a41f32cc99":"c7Tr5","55bf67ea6b01a7f4":"fyJL2"}],"hNADH":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "uITypeOptions", ()=>uITypeOptions);
parcelHelpers.export(exports, "activeInputOptions", ()=>activeInputOptions);
parcelHelpers.export(exports, "textToSpeechProviderOptions", ()=>textToSpeechProviderOptions);
parcelHelpers.export(exports, "googleVoiceOptions", ()=>googleVoiceOptions);
parcelHelpers.export(exports, "pollyVoiceOptions", ()=>pollyVoiceOptions);
parcelHelpers.export(exports, "autoRunConversationOptions", ()=>autoRunConversationOptions);
parcelHelpers.export(exports, "initializeWithWelcomeMessageOptions", ()=>initializeWithWelcomeMessageOptions);
parcelHelpers.export(exports, "useVoiceInputOptions", ()=>useVoiceInputOptions);
parcelHelpers.export(exports, "useOutputSpeechOptions", ()=>useOutputSpeechOptions);
parcelHelpers.export(exports, "useDraftContentOptions", ()=>useDraftContentOptions);
parcelHelpers.export(exports, "showConversationHistoryOptions", ()=>showConversationHistoryOptions);
parcelHelpers.export(exports, "noTrackingOptions", ()=>noTrackingOptions);
parcelHelpers.export(exports, "themeStyleOptions", ()=>themeStyleOptions);
parcelHelpers.export(exports, "overallBackgroundStyleOptions", ()=>overallBackgroundStyleOptions);
parcelHelpers.export(exports, "headerBackgroundStyleOptions", ()=>headerBackgroundStyleOptions);
parcelHelpers.export(exports, "closeAssistantButtonImageOptions", ()=>closeAssistantButtonImageOptions);
parcelHelpers.export(exports, "minimizeIconOptions", ()=>minimizeIconOptions);
parcelHelpers.export(exports, "micActiveImageOptions", ()=>micActiveImageOptions);
parcelHelpers.export(exports, "sendActiveImageOptions", ()=>sendActiveImageOptions);
const uITypeOptions = [
    {
        value: "minimal",
        label: "Minimal"
    },
    {
        value: "bottomRightButton",
        label: "Overlay"
    },
    {
        value: "slideFromBottom",
        label: "Slide-out"
    },
    {
        value: "slideFromRight",
        label: "Slide From Right"
    }
];
const activeInputOptions = [
    {
        value: "textbox",
        label: "Textbox"
    },
    {
        value: "none",
        label: "None"
    }
];
const textToSpeechProviderOptions = [
    {
        value: "Google",
        label: "Google"
    },
    {
        value: "Polly",
        label: "Polly"
    }
];
const googleVoiceOptions = [
    {
        value: "female|af-ZA-Standard-A",
        label: "female|af-ZA-Standard-A"
    },
    {
        value: "female|ar-XA-Standard-A",
        label: "female|ar-XA-Standard-A"
    },
    {
        value: "male|ar-XA-Standard-B",
        label: "male|ar-XA-Standard-B"
    },
    {
        value: "male|ar-XA-Standard-C",
        label: "male|ar-XA-Standard-C"
    },
    {
        value: "female|ar-XA-Standard-D",
        label: "female|ar-XA-Standard-D"
    },
    {
        value: "female|ar-XA-Wavenet-A",
        label: "female|ar-XA-Wavenet-A"
    },
    {
        value: "male|ar-XA-Wavenet-B",
        label: "male|ar-XA-Wavenet-B"
    },
    {
        value: "male|ar-XA-Wavenet-C",
        label: "male|ar-XA-Wavenet-C"
    },
    {
        value: "female|ar-XA-Wavenet-D",
        label: "female|ar-XA-Wavenet-D"
    },
    {
        value: "female|bn-IN-Standard-A",
        label: "female|bn-IN-Standard-A"
    },
    {
        value: "male|bn-IN-Standard-B",
        label: "male|bn-IN-Standard-B"
    },
    {
        value: "female|bn-IN-Wavenet-A",
        label: "female|bn-IN-Wavenet-A"
    },
    {
        value: "male|bn-IN-Wavenet-B",
        label: "male|bn-IN-Wavenet-B"
    },
    {
        value: "female|bg-bg-Standard-A",
        label: "female|bg-bg-Standard-A"
    },
    {
        value: "female|ca-es-Standard-A",
        label: "female|ca-es-Standard-A"
    },
    {
        value: "female|yue-HK-Standard-A",
        label: "female|yue-HK-Standard-A"
    },
    {
        value: "male|yue-HK-Standard-B",
        label: "male|yue-HK-Standard-B"
    },
    {
        value: "female|yue-HK-Standard-C",
        label: "female|yue-HK-Standard-C"
    },
    {
        value: "male|yue-HK-Standard-D",
        label: "male|yue-HK-Standard-D"
    },
    {
        value: "female|cs-CZ-Standard-A",
        label: "female|cs-CZ-Standard-A"
    },
    {
        value: "female|cs-CZ-Wavenet-A",
        label: "female|cs-CZ-Wavenet-A"
    },
    {
        value: "female|da-DK-Standard-A",
        label: "female|da-DK-Standard-A"
    },
    {
        value: "male|da-DK-Standard-C",
        label: "male|da-DK-Standard-C"
    },
    {
        value: "female|da-DK-Standard-D",
        label: "female|da-DK-Standard-D"
    },
    {
        value: "female|da-DK-Standard-E",
        label: "female|da-DK-Standard-E"
    },
    {
        value: "female|da-DK-Wavenet-A",
        label: "female|da-DK-Wavenet-A"
    },
    {
        value: "male|da-DK-Wavenet-C",
        label: "male|da-DK-Wavenet-C"
    },
    {
        value: "female|da-DK-Wavenet-D",
        label: "female|da-DK-Wavenet-D"
    },
    {
        value: "female|da-DK-Wavenet-E",
        label: "female|da-DK-Wavenet-E"
    },
    {
        value: "female|nl-BE-Standard-A",
        label: "female|nl-BE-Standard-A"
    },
    {
        value: "male|nl-BE-Standard-B",
        label: "male|nl-BE-Standard-B"
    },
    {
        value: "female|nl-BE-Wavenet-A",
        label: "female|nl-BE-Wavenet-A"
    },
    {
        value: "male|nl-BE-Wavenet-B",
        label: "male|nl-BE-Wavenet-B"
    },
    {
        value: "female|nl-NL-Standard-A",
        label: "female|nl-NL-Standard-A"
    },
    {
        value: "male|nl-NL-Standard-B",
        label: "male|nl-NL-Standard-B"
    },
    {
        value: "male|nl-NL-Standard-C",
        label: "male|nl-NL-Standard-C"
    },
    {
        value: "female|nl-NL-Standard-D",
        label: "female|nl-NL-Standard-D"
    },
    {
        value: "female|nl-NL-Standard-E",
        label: "female|nl-NL-Standard-E"
    },
    {
        value: "female|nl-NL-Wavenet-A",
        label: "female|nl-NL-Wavenet-A"
    },
    {
        value: "male|nl-NL-Wavenet-B",
        label: "male|nl-NL-Wavenet-B"
    },
    {
        value: "male|nl-NL-Wavenet-C",
        label: "male|nl-NL-Wavenet-C"
    },
    {
        value: "female|nl-NL-Wavenet-D",
        label: "female|nl-NL-Wavenet-D"
    },
    {
        value: "female|nl-NL-Wavenet-E",
        label: "female|nl-NL-Wavenet-E"
    },
    {
        value: "female|en-AU-Neural2-A",
        label: "female|en-AU-Neural2-A"
    },
    {
        value: "female|en-AU-Standard-A",
        label: "female|en-AU-Standard-A"
    },
    {
        value: "male|en-AU-Standard-B",
        label: "male|en-AU-Standard-B"
    },
    {
        value: "female|en-AU-Standard-C",
        label: "female|en-AU-Standard-C"
    },
    {
        value: "male|en-AU-Standard-D",
        label: "male|en-AU-Standard-D"
    },
    {
        value: "female|en-AU-Wavenet-A",
        label: "female|en-AU-Wavenet-A"
    },
    {
        value: "male|en-AU-Wavenet-B",
        label: "male|en-AU-Wavenet-B"
    },
    {
        value: "female|en-AU-Wavenet-C",
        label: "female|en-AU-Wavenet-C"
    },
    {
        value: "male|en-AU-Wavenet-D",
        label: "male|en-AU-Wavenet-D"
    },
    {
        value: "female|en-IN-Standard-A",
        label: "female|en-IN-Standard-A"
    },
    {
        value: "male|en-IN-Standard-B",
        label: "male|en-IN-Standard-B"
    },
    {
        value: "male|en-IN-Standard-C",
        label: "male|en-IN-Standard-C"
    },
    {
        value: "female|en-IN-Standard-D",
        label: "female|en-IN-Standard-D"
    },
    {
        value: "female|en-IN-Wavenet-A",
        label: "female|en-IN-Wavenet-A"
    },
    {
        value: "male|en-IN-Wavenet-B",
        label: "male|en-IN-Wavenet-B"
    },
    {
        value: "male|en-IN-Wavenet-C",
        label: "male|en-IN-Wavenet-C"
    },
    {
        value: "female|en-IN-Wavenet-D",
        label: "female|en-IN-Wavenet-D"
    },
    {
        value: "female|en-GB-Neural2-A",
        label: "female|en-GB-Neural2-A"
    },
    {
        value: "female|en-GB-Standard-A",
        label: "female|en-GB-Standard-A"
    },
    {
        value: "male|en-GB-Standard-B",
        label: "male|en-GB-Standard-B"
    },
    {
        value: "female|en-GB-Standard-C",
        label: "female|en-GB-Standard-C"
    },
    {
        value: "male|en-GB-Standard-D",
        label: "male|en-GB-Standard-D"
    },
    {
        value: "female|en-GB-Standard-F",
        label: "female|en-GB-Standard-F"
    },
    {
        value: "female|en-GB-Wavenet-A",
        label: "female|en-GB-Wavenet-A"
    },
    {
        value: "male|en-GB-Wavenet-B",
        label: "male|en-GB-Wavenet-B"
    },
    {
        value: "female|en-GB-Wavenet-C",
        label: "female|en-GB-Wavenet-C"
    },
    {
        value: "male|en-GB-Wavenet-D",
        label: "male|en-GB-Wavenet-D"
    },
    {
        value: "female|en-GB-Wavenet-F",
        label: "female|en-GB-Wavenet-F"
    },
    {
        value: "female|en-US-Neural2-A",
        label: "female|en-US-Neural2-A"
    },
    {
        value: "male|en-US-Standard-A",
        label: "male|en-US-Standard-A"
    },
    {
        value: "male|en-US-Standard-B",
        label: "male|en-US-Standard-B"
    },
    {
        value: "female|en-US-Standard-C",
        label: "female|en-US-Standard-C"
    },
    {
        value: "male|en-US-Standard-D",
        label: "male|en-US-Standard-D"
    },
    {
        value: "female|en-US-Standard-E",
        label: "female|en-US-Standard-E"
    },
    {
        value: "female|en-US-Standard-F",
        label: "female|en-US-Standard-F"
    },
    {
        value: "female|en-US-Standard-G",
        label: "female|en-US-Standard-G"
    },
    {
        value: "female|en-US-Standard-H",
        label: "female|en-US-Standard-H"
    },
    {
        value: "male|en-US-Standard-I",
        label: "male|en-US-Standard-I"
    },
    {
        value: "male|en-US-Standard-J",
        label: "male|en-US-Standard-J"
    },
    {
        value: "male|en-US-Wavenet-A",
        label: "male|en-US-Wavenet-A"
    },
    {
        value: "male|en-US-Wavenet-B",
        label: "male|en-US-Wavenet-B"
    },
    {
        value: "female|en-US-Wavenet-C",
        label: "female|en-US-Wavenet-C"
    },
    {
        value: "male|en-US-Wavenet-D",
        label: "male|en-US-Wavenet-D"
    },
    {
        value: "female|en-US-Wavenet-E",
        label: "female|en-US-Wavenet-E"
    },
    {
        value: "female|en-US-Wavenet-F",
        label: "female|en-US-Wavenet-F"
    },
    {
        value: "female|en-US-Wavenet-G",
        label: "female|en-US-Wavenet-G"
    },
    {
        value: "female|en-US-Wavenet-H",
        label: "female|en-US-Wavenet-H"
    },
    {
        value: "male|en-US-Wavenet-I",
        label: "male|en-US-Wavenet-I"
    },
    {
        value: "male|en-US-Wavenet-J",
        label: "male|en-US-Wavenet-J"
    },
    {
        value: "female|fil-PH-Standard-A",
        label: "female|fil-PH-Standard-A"
    },
    {
        value: "female|fil-PH-Standard-B",
        label: "female|fil-PH-Standard-B"
    },
    {
        value: "male|fil-PH-Standard-C",
        label: "male|fil-PH-Standard-C"
    },
    {
        value: "male|fil-PH-Standard-D",
        label: "male|fil-PH-Standard-D"
    },
    {
        value: "female|fil-PH-Wavenet-A",
        label: "female|fil-PH-Wavenet-A"
    },
    {
        value: "female|fil-PH-Wavenet-B",
        label: "female|fil-PH-Wavenet-B"
    },
    {
        value: "male|fil-PH-Wavenet-C",
        label: "male|fil-PH-Wavenet-C"
    },
    {
        value: "male|fil-PH-Wavenet-D",
        label: "male|fil-PH-Wavenet-D"
    },
    {
        value: "female|fi-FI-Standard-A",
        label: "female|fi-FI-Standard-A"
    },
    {
        value: "female|fi-FI-Wavenet-A",
        label: "female|fi-FI-Wavenet-A"
    },
    {
        value: "female|fr-CA-Standard-A",
        label: "female|fr-CA-Standard-A"
    },
    {
        value: "male|fr-CA-Standard-B",
        label: "male|fr-CA-Standard-B"
    },
    {
        value: "female|fr-CA-Standard-C",
        label: "female|fr-CA-Standard-C"
    },
    {
        value: "male|fr-CA-Standard-D",
        label: "male|fr-CA-Standard-D"
    },
    {
        value: "female|fr-CA-Wavenet-A",
        label: "female|fr-CA-Wavenet-A"
    },
    {
        value: "male|fr-CA-Wavenet-B",
        label: "male|fr-CA-Wavenet-B"
    },
    {
        value: "female|fr-CA-Wavenet-C",
        label: "female|fr-CA-Wavenet-C"
    },
    {
        value: "male|fr-CA-Wavenet-D",
        label: "male|fr-CA-Wavenet-D"
    },
    {
        value: "female|fr-FR-Standard-A",
        label: "female|fr-FR-Standard-A"
    },
    {
        value: "male|fr-FR-Standard-B",
        label: "male|fr-FR-Standard-B"
    },
    {
        value: "female|fr-FR-Standard-C",
        label: "female|fr-FR-Standard-C"
    },
    {
        value: "male|fr-FR-Standard-D",
        label: "male|fr-FR-Standard-D"
    },
    {
        value: "female|fr-FR-Standard-E",
        label: "female|fr-FR-Standard-E"
    },
    {
        value: "female|fr-FR-Wavenet-A",
        label: "female|fr-FR-Wavenet-A"
    },
    {
        value: "male|fr-FR-Wavenet-B",
        label: "male|fr-FR-Wavenet-B"
    },
    {
        value: "female|fr-FR-Wavenet-C",
        label: "female|fr-FR-Wavenet-C"
    },
    {
        value: "male|fr-FR-Wavenet-D",
        label: "male|fr-FR-Wavenet-D"
    },
    {
        value: "female|fr-FR-Wavenet-E",
        label: "female|fr-FR-Wavenet-E"
    },
    {
        value: "female|de-DE-Standard-A",
        label: "female|de-DE-Standard-A"
    },
    {
        value: "male|de-DE-Standard-B",
        label: "male|de-DE-Standard-B"
    },
    {
        value: "female|de-DE-Standard-C",
        label: "female|de-DE-Standard-C"
    },
    {
        value: "male|de-DE-Standard-D",
        label: "male|de-DE-Standard-D"
    },
    {
        value: "male|de-DE-Standard-E",
        label: "male|de-DE-Standard-E"
    },
    {
        value: "female|de-DE-Standard-F",
        label: "female|de-DE-Standard-F"
    },
    {
        value: "female|de-DE-Wavenet-A",
        label: "female|de-DE-Wavenet-A"
    },
    {
        value: "male|de-DE-Wavenet-B",
        label: "male|de-DE-Wavenet-B"
    },
    {
        value: "female|de-DE-Wavenet-C",
        label: "female|de-DE-Wavenet-C"
    },
    {
        value: "male|de-DE-Wavenet-D",
        label: "male|de-DE-Wavenet-D"
    },
    {
        value: "male|de-DE-Wavenet-E",
        label: "male|de-DE-Wavenet-E"
    },
    {
        value: "female|de-DE-Wavenet-F",
        label: "female|de-DE-Wavenet-F"
    },
    {
        value: "female|el-GR-Standard-A",
        label: "female|el-GR-Standard-A"
    },
    {
        value: "female|el-GR-Wavenet-A",
        label: "female|el-GR-Wavenet-A"
    },
    {
        value: "female|gu-IN-Standard-A",
        label: "female|gu-IN-Standard-A"
    },
    {
        value: "male|gu-IN-Standard-B",
        label: "male|gu-IN-Standard-B"
    },
    {
        value: "female|gu-IN-Wavenet-A",
        label: "female|gu-IN-Wavenet-A"
    },
    {
        value: "male|gu-IN-Wavenet-B",
        label: "male|gu-IN-Wavenet-B"
    },
    {
        value: "female|hi-IN-Standard-A",
        label: "female|hi-IN-Standard-A"
    },
    {
        value: "male|hi-IN-Standard-B",
        label: "male|hi-IN-Standard-B"
    },
    {
        value: "male|hi-IN-Standard-C",
        label: "male|hi-IN-Standard-C"
    },
    {
        value: "female|hi-IN-Standard-D",
        label: "female|hi-IN-Standard-D"
    },
    {
        value: "female|hi-IN-Wavenet-A",
        label: "female|hi-IN-Wavenet-A"
    },
    {
        value: "male|hi-IN-Wavenet-B",
        label: "male|hi-IN-Wavenet-B"
    },
    {
        value: "male|hi-IN-Wavenet-C",
        label: "male|hi-IN-Wavenet-C"
    },
    {
        value: "female|hi-IN-Wavenet-D",
        label: "female|hi-IN-Wavenet-D"
    },
    {
        value: "female|hu-HU-Standard-A",
        label: "female|hu-HU-Standard-A"
    },
    {
        value: "female|hu-HU-Wavenet-A",
        label: "female|hu-HU-Wavenet-A"
    },
    {
        value: "female|is-is-Standard-A",
        label: "female|is-is-Standard-A"
    },
    {
        value: "female|id-ID-Standard-A",
        label: "female|id-ID-Standard-A"
    },
    {
        value: "male|id-ID-Standard-B",
        label: "male|id-ID-Standard-B"
    },
    {
        value: "male|id-ID-Standard-C",
        label: "male|id-ID-Standard-C"
    },
    {
        value: "female|id-ID-Standard-D",
        label: "female|id-ID-Standard-D"
    },
    {
        value: "female|id-ID-Wavenet-A",
        label: "female|id-ID-Wavenet-A"
    },
    {
        value: "male|id-ID-Wavenet-B",
        label: "male|id-ID-Wavenet-B"
    },
    {
        value: "male|id-ID-Wavenet-C",
        label: "male|id-ID-Wavenet-C"
    },
    {
        value: "female|id-ID-Wavenet-D",
        label: "female|id-ID-Wavenet-D"
    },
    {
        value: "female|it-IT-Standard-A",
        label: "female|it-IT-Standard-A"
    },
    {
        value: "female|it-IT-Standard-B",
        label: "female|it-IT-Standard-B"
    },
    {
        value: "male|it-IT-Standard-C",
        label: "male|it-IT-Standard-C"
    },
    {
        value: "male|it-IT-Standard-D",
        label: "male|it-IT-Standard-D"
    },
    {
        value: "female|it-IT-Wavenet-A",
        label: "female|it-IT-Wavenet-A"
    },
    {
        value: "female|it-IT-Wavenet-B",
        label: "female|it-IT-Wavenet-B"
    },
    {
        value: "male|it-IT-Wavenet-C",
        label: "male|it-IT-Wavenet-C"
    },
    {
        value: "male|it-IT-Wavenet-D",
        label: "male|it-IT-Wavenet-D"
    },
    {
        value: "female|ja-JP-Standard-A",
        label: "female|ja-JP-Standard-A"
    },
    {
        value: "female|ja-JP-Standard-B",
        label: "female|ja-JP-Standard-B"
    },
    {
        value: "male|ja-JP-Standard-C",
        label: "male|ja-JP-Standard-C"
    },
    {
        value: "male|ja-JP-Standard-D",
        label: "male|ja-JP-Standard-D"
    },
    {
        value: "female|ja-JP-Wavenet-A",
        label: "female|ja-JP-Wavenet-A"
    },
    {
        value: "female|ja-JP-Wavenet-B",
        label: "female|ja-JP-Wavenet-B"
    },
    {
        value: "male|ja-JP-Wavenet-C",
        label: "male|ja-JP-Wavenet-C"
    },
    {
        value: "male|ja-JP-Wavenet-D",
        label: "male|ja-JP-Wavenet-D"
    },
    {
        value: "female|kn-IN-Standard-A",
        label: "female|kn-IN-Standard-A"
    },
    {
        value: "male|kn-IN-Standard-B",
        label: "male|kn-IN-Standard-B"
    },
    {
        value: "female|kn-IN-Wavenet-A",
        label: "female|kn-IN-Wavenet-A"
    },
    {
        value: "male|kn-IN-Wavenet-B",
        label: "male|kn-IN-Wavenet-B"
    },
    {
        value: "female|ko-KR-Standard-A",
        label: "female|ko-KR-Standard-A"
    },
    {
        value: "female|ko-KR-Standard-B",
        label: "female|ko-KR-Standard-B"
    },
    {
        value: "male|ko-KR-Standard-C",
        label: "male|ko-KR-Standard-C"
    },
    {
        value: "male|ko-KR-Standard-D",
        label: "male|ko-KR-Standard-D"
    },
    {
        value: "female|ko-KR-Wavenet-A",
        label: "female|ko-KR-Wavenet-A"
    },
    {
        value: "female|ko-KR-Wavenet-B",
        label: "female|ko-KR-Wavenet-B"
    },
    {
        value: "male|ko-KR-Wavenet-C",
        label: "male|ko-KR-Wavenet-C"
    },
    {
        value: "male|ko-KR-Wavenet-D",
        label: "male|ko-KR-Wavenet-D"
    },
    {
        value: "male|lv-lv-Standard-A",
        label: "male|lv-lv-Standard-A"
    },
    {
        value: "female|ms-MY-Standard-A",
        label: "female|ms-MY-Standard-A"
    },
    {
        value: "male|ms-MY-Standard-B",
        label: "male|ms-MY-Standard-B"
    },
    {
        value: "female|ms-MY-Standard-C",
        label: "female|ms-MY-Standard-C"
    },
    {
        value: "male|ms-MY-Standard-D",
        label: "male|ms-MY-Standard-D"
    },
    {
        value: "female|ms-MY-Wavenet-A",
        label: "female|ms-MY-Wavenet-A"
    },
    {
        value: "male|ms-MY-Wavenet-B",
        label: "male|ms-MY-Wavenet-B"
    },
    {
        value: "female|ms-MY-Wavenet-C",
        label: "female|ms-MY-Wavenet-C"
    },
    {
        value: "male|ms-MY-Wavenet-D",
        label: "male|ms-MY-Wavenet-D"
    },
    {
        value: "female|ml-IN-Standard-A",
        label: "female|ml-IN-Standard-A"
    },
    {
        value: "male|ml-IN-Standard-B",
        label: "male|ml-IN-Standard-B"
    },
    {
        value: "female|ml-IN-Wavenet-A",
        label: "female|ml-IN-Wavenet-A"
    },
    {
        value: "male|ml-IN-Wavenet-B",
        label: "male|ml-IN-Wavenet-B"
    },
    {
        value: "female|cmn-CN-Standard-A",
        label: "female|cmn-CN-Standard-A"
    },
    {
        value: "male|cmn-CN-Standard-B",
        label: "male|cmn-CN-Standard-B"
    },
    {
        value: "male|cmn-CN-Standard-C",
        label: "male|cmn-CN-Standard-C"
    },
    {
        value: "female|cmn-CN-Standard-D",
        label: "female|cmn-CN-Standard-D"
    },
    {
        value: "female|cmn-CN-Wavenet-A",
        label: "female|cmn-CN-Wavenet-A"
    },
    {
        value: "male|cmn-CN-Wavenet-B",
        label: "male|cmn-CN-Wavenet-B"
    },
    {
        value: "male|cmn-CN-Wavenet-C",
        label: "male|cmn-CN-Wavenet-C"
    },
    {
        value: "female|cmn-CN-Wavenet-D",
        label: "female|cmn-CN-Wavenet-D"
    },
    {
        value: "female|cmn-TW-Standard-A",
        label: "female|cmn-TW-Standard-A"
    },
    {
        value: "male|cmn-TW-Standard-B",
        label: "male|cmn-TW-Standard-B"
    },
    {
        value: "male|cmn-TW-Standard-C",
        label: "male|cmn-TW-Standard-C"
    },
    {
        value: "female|cmn-TW-Wavenet-A",
        label: "female|cmn-TW-Wavenet-A"
    },
    {
        value: "male|cmn-TW-Wavenet-B",
        label: "male|cmn-TW-Wavenet-B"
    },
    {
        value: "male|cmn-TW-Wavenet-C",
        label: "male|cmn-TW-Wavenet-C"
    },
    {
        value: "female|nb-NO-Standard-A",
        label: "female|nb-NO-Standard-A"
    },
    {
        value: "male|nb-NO-Standard-B",
        label: "male|nb-NO-Standard-B"
    },
    {
        value: "female|nb-NO-Standard-C",
        label: "female|nb-NO-Standard-C"
    },
    {
        value: "male|nb-NO-Standard-D",
        label: "male|nb-NO-Standard-D"
    },
    {
        value: "female|nb-NO-Wavenet-A",
        label: "female|nb-NO-Wavenet-A"
    },
    {
        value: "male|nb-NO-Wavenet-B",
        label: "male|nb-NO-Wavenet-B"
    },
    {
        value: "female|nb-NO-Wavenet-C",
        label: "female|nb-NO-Wavenet-C"
    },
    {
        value: "male|nb-NO-Wavenet-D",
        label: "male|nb-NO-Wavenet-D"
    },
    {
        value: "female|nb-no-Standard-E",
        label: "female|nb-no-Standard-E"
    },
    {
        value: "female|nb-no-Wavenet-E",
        label: "female|nb-no-Wavenet-E"
    },
    {
        value: "female|pl-PL-Standard-A",
        label: "female|pl-PL-Standard-A"
    },
    {
        value: "male|pl-PL-Standard-B",
        label: "male|pl-PL-Standard-B"
    },
    {
        value: "male|pl-PL-Standard-C",
        label: "male|pl-PL-Standard-C"
    },
    {
        value: "female|pl-PL-Standard-D",
        label: "female|pl-PL-Standard-D"
    },
    {
        value: "female|pl-PL-Standard-E",
        label: "female|pl-PL-Standard-E"
    },
    {
        value: "female|pl-PL-Wavenet-A",
        label: "female|pl-PL-Wavenet-A"
    },
    {
        value: "male|pl-PL-Wavenet-B",
        label: "male|pl-PL-Wavenet-B"
    },
    {
        value: "male|pl-PL-Wavenet-C",
        label: "male|pl-PL-Wavenet-C"
    },
    {
        value: "female|pl-PL-Wavenet-D",
        label: "female|pl-PL-Wavenet-D"
    },
    {
        value: "female|pl-PL-Wavenet-E",
        label: "female|pl-PL-Wavenet-E"
    },
    {
        value: "female|pt-BR-Standard-A",
        label: "female|pt-BR-Standard-A"
    },
    {
        value: "male|pt-BR-Standard-B",
        label: "male|pt-BR-Standard-B"
    },
    {
        value: "female|pt-BR-Wavenet-A",
        label: "female|pt-BR-Wavenet-A"
    },
    {
        value: "male|pt-BR-Wavenet-B",
        label: "male|pt-BR-Wavenet-B"
    },
    {
        value: "female|pt-PT-Standard-A",
        label: "female|pt-PT-Standard-A"
    },
    {
        value: "male|pt-PT-Standard-B",
        label: "male|pt-PT-Standard-B"
    },
    {
        value: "male|pt-PT-Standard-C",
        label: "male|pt-PT-Standard-C"
    },
    {
        value: "female|pt-PT-Standard-D",
        label: "female|pt-PT-Standard-D"
    },
    {
        value: "female|pt-PT-Wavenet-A",
        label: "female|pt-PT-Wavenet-A"
    },
    {
        value: "male|pt-PT-Wavenet-B",
        label: "male|pt-PT-Wavenet-B"
    },
    {
        value: "male|pt-PT-Wavenet-C",
        label: "male|pt-PT-Wavenet-C"
    },
    {
        value: "female|pt-PT-Wavenet-D",
        label: "female|pt-PT-Wavenet-D"
    },
    {
        value: "female|pa-IN-Standard-A",
        label: "female|pa-IN-Standard-A"
    },
    {
        value: "male|pa-IN-Standard-B",
        label: "male|pa-IN-Standard-B"
    },
    {
        value: "female|pa-IN-Standard-C",
        label: "female|pa-IN-Standard-C"
    },
    {
        value: "male|pa-IN-Standard-D",
        label: "male|pa-IN-Standard-D"
    },
    {
        value: "female|pa-IN-Wavenet-A",
        label: "female|pa-IN-Wavenet-A"
    },
    {
        value: "male|pa-IN-Wavenet-B",
        label: "male|pa-IN-Wavenet-B"
    },
    {
        value: "female|pa-IN-Wavenet-C",
        label: "female|pa-IN-Wavenet-C"
    },
    {
        value: "male|pa-IN-Wavenet-D",
        label: "male|pa-IN-Wavenet-D"
    },
    {
        value: "female|ro-RO-Standard-A",
        label: "female|ro-RO-Standard-A"
    },
    {
        value: "female|ro-RO-Wavenet-A",
        label: "female|ro-RO-Wavenet-A"
    },
    {
        value: "female|ru-RU-Standard-A",
        label: "female|ru-RU-Standard-A"
    },
    {
        value: "male|ru-RU-Standard-B",
        label: "male|ru-RU-Standard-B"
    },
    {
        value: "female|ru-RU-Standard-C",
        label: "female|ru-RU-Standard-C"
    },
    {
        value: "male|ru-RU-Standard-D",
        label: "male|ru-RU-Standard-D"
    },
    {
        value: "female|ru-RU-Standard-E",
        label: "female|ru-RU-Standard-E"
    },
    {
        value: "female|ru-RU-Wavenet-A",
        label: "female|ru-RU-Wavenet-A"
    },
    {
        value: "male|ru-RU-Wavenet-B",
        label: "male|ru-RU-Wavenet-B"
    },
    {
        value: "female|ru-RU-Wavenet-C",
        label: "female|ru-RU-Wavenet-C"
    },
    {
        value: "male|ru-RU-Wavenet-D",
        label: "male|ru-RU-Wavenet-D"
    },
    {
        value: "female|ru-RU-Wavenet-E",
        label: "female|ru-RU-Wavenet-E"
    },
    {
        value: "female|sr-rs-Standard-A",
        label: "female|sr-rs-Standard-A"
    },
    {
        value: "female|sk-SK-Standard-A",
        label: "female|sk-SK-Standard-A"
    },
    {
        value: "female|sk-SK-Wavenet-A",
        label: "female|sk-SK-Wavenet-A"
    },
    {
        value: "female|es-ES-Standard-A",
        label: "female|es-ES-Standard-A"
    },
    {
        value: "male|es-ES-Standard-B",
        label: "male|es-ES-Standard-B"
    },
    {
        value: "female|es-ES-Standard-C",
        label: "female|es-ES-Standard-C"
    },
    {
        value: "female|es-ES-Standard-D",
        label: "female|es-ES-Standard-D"
    },
    {
        value: "male|es-ES-Wavenet-B",
        label: "male|es-ES-Wavenet-B"
    },
    {
        value: "female|es-ES-Wavenet-C",
        label: "female|es-ES-Wavenet-C"
    },
    {
        value: "female|es-ES-Wavenet-D",
        label: "female|es-ES-Wavenet-D"
    },
    {
        value: "female|es-US-Neural2-A",
        label: "female|es-US-Neural2-A"
    },
    {
        value: "female|es-US-Standard-A",
        label: "female|es-US-Standard-A"
    },
    {
        value: "male|es-US-Standard-B",
        label: "male|es-US-Standard-B"
    },
    {
        value: "male|es-US-Standard-C",
        label: "male|es-US-Standard-C"
    },
    {
        value: "female|es-US-Wavenet-A",
        label: "female|es-US-Wavenet-A"
    },
    {
        value: "male|es-US-Wavenet-B",
        label: "male|es-US-Wavenet-B"
    },
    {
        value: "male|es-US-Wavenet-C",
        label: "male|es-US-Wavenet-C"
    },
    {
        value: "female|sv-SE-Standard-A",
        label: "female|sv-SE-Standard-A"
    },
    {
        value: "female|sv-SE-Standard-B",
        label: "female|sv-SE-Standard-B"
    },
    {
        value: "female|sv-SE-Standard-C",
        label: "female|sv-SE-Standard-C"
    },
    {
        value: "male|sv-SE-Standard-D",
        label: "male|sv-SE-Standard-D"
    },
    {
        value: "male|sv-SE-Standard-E",
        label: "male|sv-SE-Standard-E"
    },
    {
        value: "female|sv-SE-Wavenet-A",
        label: "female|sv-SE-Wavenet-A"
    },
    {
        value: "female|sv-SE-Wavenet-B",
        label: "female|sv-SE-Wavenet-B"
    },
    {
        value: "male|sv-SE-Wavenet-C",
        label: "male|sv-SE-Wavenet-C"
    },
    {
        value: "female|sv-SE-Wavenet-D",
        label: "female|sv-SE-Wavenet-D"
    },
    {
        value: "male|sv-SE-Wavenet-E",
        label: "male|sv-SE-Wavenet-E"
    },
    {
        value: "female|ta-IN-Standard-A",
        label: "female|ta-IN-Standard-A"
    },
    {
        value: "male|ta-IN-Standard-B",
        label: "male|ta-IN-Standard-B"
    },
    {
        value: "female|ta-IN-Wavenet-A",
        label: "female|ta-IN-Wavenet-A"
    },
    {
        value: "male|ta-IN-Wavenet-B",
        label: "male|ta-IN-Wavenet-B"
    },
    {
        value: "female|te-IN-Standard-A",
        label: "female|te-IN-Standard-A"
    },
    {
        value: "male|te-IN-Standard-B",
        label: "male|te-IN-Standard-B"
    },
    {
        value: "female|th-TH-Standard-A",
        label: "female|th-TH-Standard-A"
    },
    {
        value: "female|tr-TR-Standard-A",
        label: "female|tr-TR-Standard-A"
    },
    {
        value: "male|tr-TR-Standard-B",
        label: "male|tr-TR-Standard-B"
    },
    {
        value: "female|tr-TR-Standard-C",
        label: "female|tr-TR-Standard-C"
    },
    {
        value: "female|tr-TR-Standard-D",
        label: "female|tr-TR-Standard-D"
    },
    {
        value: "male|tr-TR-Standard-E",
        label: "male|tr-TR-Standard-E"
    },
    {
        value: "female|tr-TR-Wavenet-A",
        label: "female|tr-TR-Wavenet-A"
    },
    {
        value: "male|tr-TR-Wavenet-B",
        label: "male|tr-TR-Wavenet-B"
    },
    {
        value: "female|tr-TR-Wavenet-C",
        label: "female|tr-TR-Wavenet-C"
    },
    {
        value: "female|tr-TR-Wavenet-D",
        label: "female|tr-TR-Wavenet-D"
    },
    {
        value: "male|tr-TR-Wavenet-E",
        label: "male|tr-TR-Wavenet-E"
    },
    {
        value: "female|uk-UA-Standard-A",
        label: "female|uk-UA-Standard-A"
    },
    {
        value: "female|uk-UA-Wavenet-A",
        label: "female|uk-UA-Wavenet-A"
    },
    {
        value: "female|vi-VN-Standard-A",
        label: "female|vi-VN-Standard-A"
    },
    {
        value: "male|vi-VN-Standard-B",
        label: "male|vi-VN-Standard-B"
    },
    {
        value: "female|vi-VN-Standard-C",
        label: "female|vi-VN-Standard-C"
    },
    {
        value: "male|vi-VN-Standard-D",
        label: "male|vi-VN-Standard-D"
    },
    {
        value: "female|vi-VN-Wavenet-A",
        label: "female|vi-VN-Wavenet-A"
    },
    {
        value: "male|vi-VN-Wavenet-B",
        label: "male|vi-VN-Wavenet-B"
    },
    {
        value: "female|vi-VN-Wavenet-C",
        label: "female|vi-VN-Wavenet-C"
    },
    {
        value: "male|vi-VN-Wavenet-D",
        label: "male|vi-VN-Wavenet-D"
    }
];
const pollyVoiceOptions = [
    {
        value: "zeina",
        label: "Zeina"
    },
    {
        value: "arlet",
        label: "Arlet"
    },
    {
        value: "zhiyu",
        label: "Zhiyu"
    },
    {
        value: "naja",
        label: "Naja"
    },
    {
        value: "mads",
        label: "Mads"
    },
    {
        value: "lotte",
        label: "Lotte"
    },
    {
        value: "ruben",
        label: "Ruben"
    },
    {
        value: "nicole",
        label: "Nicole"
    },
    {
        value: "olivia",
        label: "Olivia"
    },
    {
        value: "russell",
        label: "Russell"
    },
    {
        value: "amy",
        label: "Amy"
    },
    {
        value: "emma",
        label: "Emma"
    },
    {
        value: "brian",
        label: "Brian"
    },
    {
        value: "arthur",
        label: "Arthur"
    },
    {
        value: "aditi",
        label: "Aditi"
    },
    {
        value: "raveena",
        label: "Raveena"
    },
    {
        value: "aria",
        label: "Aria"
    },
    {
        value: "ayanda",
        label: "Ayanda"
    },
    {
        value: "ivy",
        label: "Ivy"
    },
    {
        value: "joanna",
        label: "Joanna"
    },
    {
        value: "kendra",
        label: "Kendra"
    },
    {
        value: "kimberly",
        label: "Kimberly"
    },
    {
        value: "salli",
        label: "Salli"
    },
    {
        value: "joey",
        label: "Joey"
    },
    {
        value: "justin",
        label: "Justin"
    },
    {
        value: "kevin",
        label: "Kevin"
    },
    {
        value: "matthew",
        label: "Matthew"
    },
    {
        value: "geraint",
        label: "Geraint"
    },
    {
        value: "c\xe9line",
        label: "C\xe9line"
    },
    {
        value: "celine",
        label: "Celine"
    },
    {
        value: "l\xe9a",
        label: "L\xe9a"
    },
    {
        value: "mathieu",
        label: "Mathieu"
    },
    {
        value: "chantal",
        label: "Chantal"
    },
    {
        value: "gabrielle",
        label: "Gabrielle"
    },
    {
        value: "liam",
        label: "Liam"
    },
    {
        value: "marlene",
        label: "Marlene"
    },
    {
        value: "vicki",
        label: "Vicki"
    },
    {
        value: "hans",
        label: "Hans"
    },
    {
        value: "daniel",
        label: "Daniel"
    },
    {
        value: "hannah",
        label: "Hannah"
    },
    {
        value: "d\xf3ra",
        label: "D\xf3ra"
    },
    {
        value: "dora",
        label: "Dora"
    },
    {
        value: "karl",
        label: "Karl"
    },
    {
        value: "carla",
        label: "Carla"
    },
    {
        value: "bianca",
        label: "Bianca"
    },
    {
        value: "giorgio",
        label: "Giorgio"
    },
    {
        value: "mizuki",
        label: "Mizuki"
    },
    {
        value: "takumi",
        label: "Takumi"
    },
    {
        value: "seoyeon",
        label: "Seoyeon"
    },
    {
        value: "liv",
        label: "Liv"
    },
    {
        value: "ewa",
        label: "Ewa"
    },
    {
        value: "maja",
        label: "Maja"
    },
    {
        value: "jacek",
        label: "Jacek"
    },
    {
        value: "jan",
        label: "Jan"
    },
    {
        value: "camila",
        label: "Camila"
    },
    {
        value: "vit\xf3ria",
        label: "Vit\xf3ria"
    },
    {
        value: "vitoria",
        label: "Vitoria"
    },
    {
        value: "ricardo",
        label: "Ricardo"
    },
    {
        value: "in\xeas",
        label: "In\xeas"
    },
    {
        value: "ines",
        label: "Ines"
    },
    {
        value: "cristiano",
        label: "Cristiano"
    },
    {
        value: "carmen",
        label: "Carmen"
    },
    {
        value: "tatyana",
        label: "Tatyana"
    },
    {
        value: "maxim",
        label: "Maxim"
    },
    {
        value: "conchita",
        label: "Conchita"
    },
    {
        value: "lucia",
        label: "Lucia"
    },
    {
        value: "enrique",
        label: "Enrique"
    },
    {
        value: "mia",
        label: "Mia"
    },
    {
        value: "lupe",
        label: "Lupe"
    },
    {
        value: "pen\xe9lope",
        label: "Pen\xe9lope"
    },
    {
        value: "penelope",
        label: "Penelope"
    },
    {
        value: "miguel",
        label: "Miguel"
    },
    {
        value: "pedro",
        label: "Pedro"
    },
    {
        value: "astrid",
        label: "Astrid"
    },
    {
        value: "filiz",
        label: "Filiz"
    },
    {
        value: "gwyneth",
        label: "Gwyneth"
    }
];
const autoRunConversationOptions = [
    {
        label: "Start listening on mic click",
        value: false
    },
    {
        label: "Always listen",
        value: true
    }
];
const initializeWithWelcomeMessageOptions = [
    {
        label: "Initialize with welcome message",
        value: true
    },
    {
        label: "Initialize without welcome message",
        value: false
    }
];
const useVoiceInputOptions = [
    {
        label: "Both speech and typing",
        value: true
    },
    {
        label: "Typing only",
        value: false
    }
];
const useOutputSpeechOptions = [
    {
        label: "Readout of text & on-screen display",
        value: true
    },
    {
        label: "On-screen display only",
        value: false
    }
];
const useDraftContentOptions = [
    {
        label: "Use published content only",
        value: false
    },
    {
        label: "Use draft content",
        value: true
    }
];
const showConversationHistoryOptions = [
    {
        label: "Show conversation history",
        value: true
    },
    {
        label: "Don't show conversation history",
        value: false
    }
];
const noTrackingOptions = [
    {
        label: "Track assistant usage",
        value: true
    },
    {
        label: "Don't track assistant usage",
        value: false
    }
];
const themeStyleOptions = [
    {
        label: "Light Theme 1",
        value: "lightStyle1"
    },
    {
        label: "Light Theme 2",
        value: "lightStyle2"
    },
    {
        label: "Dark Theme 1",
        value: "darkStyle1"
    },
    {
        label: "Dark Theme 2",
        value: "darkStyle2"
    },
    {
        label: "Default Theme",
        value: "default"
    }
];
const overallBackgroundStyleOptions = [
    {
        label: "Solid color or gradient",
        value: "solid or gradient"
    },
    {
        label: "Transparent",
        value: "transparent"
    }
];
const headerBackgroundStyleOptions = [
    {
        label: "Solid color or gradient",
        value: "solid or gradient"
    },
    {
        label: "Transparent",
        value: "transparent"
    }
];
const closeAssistantButtonImageOptions = [
    {
        label: "Style 1",
        value: "https://voicify-prod-files.s3.amazonaws.com/sdk-images/close.svg"
    },
    {
        label: "Style 2",
        value: "https://voicify-prod-files.s3.amazonaws.com/sdk-images/closeTwo.svg"
    }
];
const minimizeIconOptions = [
    {
        label: "Style 1",
        value: "https://voicify-prod-files.s3.amazonaws.com/sdk-images/minimize.svg"
    },
    {
        label: "Style 2",
        value: "https://voicify-prod-files.s3.amazonaws.com/sdk-images/minimizeTwo.svg"
    }
];
const micActiveImageOptions = [
    {
        label: "Style 1",
        value: "https://voicify-prod-files.s3.amazonaws.com/sdk-images/micActive.svg"
    },
    {
        label: "Style 2",
        value: "https://voicify-prod-files.s3.amazonaws.com/sdk-images/micTwoActive.svg"
    },
    {
        label: "Style 3",
        value: "https://voicify-prod-files.s3.amazonaws.com/sdk-images/micThreeActive.svg"
    }
];
const sendActiveImageOptions = [
    {
        label: "Style 1",
        value: "https://voicify-prod-files.s3.amazonaws.com/sdk-images/sendActive.svg"
    },
    {
        label: "Style 2",
        value: "https://voicify-prod-files.s3.amazonaws.com/sdk-images/sendTwoActive.svg"
    },
    {
        label: "Style 3",
        value: "https://voicify-prod-files.s3.amazonaws.com/sdk-images/sendThreeActive.svg"
    }
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"eDudC":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _languageCollectionAvatar = require("../../../../components/general/LanguageCollectionAvatar");
var _languageCollectionAvatarDefault = parcelHelpers.interopDefault(_languageCollectionAvatar);
var _languages = require("../../../../models/extensions/languages");
var _lodash = require("lodash");
var _lodashDefault = parcelHelpers.interopDefault(_lodash);
var _groupedMultiSelector = require("../../../../components/forms/GroupedMultiSelector");
var _groupedMultiSelectorDefault = parcelHelpers.interopDefault(_groupedMultiSelector);
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
class LanguageSingleSelector extends (0, _reactDefault.default).Component {
    constructor(props){
        super(props);
        this.state = {
            isExpanded: false
        };
    }
    handleChange(selectedIds) {
        this.props.onChange(selectedIds);
    }
    getLanguageGroups() {
        var dict = (0, _lodashDefault.default).groupBy(this.props.languages, (l)=>l.languageGroupCode);
        var groups = Object.keys(dict).map((key)=>({
                key: key,
                label: `${key.toUpperCase()} - ${(0, _languages.getLanguageName)(key)}`,
                subItems: dict[key].map((lang)=>({
                        data: lang,
                        value: lang.id,
                        icon: (0, _languages.getFlagIconForLanguage)(lang),
                        label: (0, _languages.getRegionyNameForLanguage)(lang),
                        groupKey: key,
                        isSelected: this.props.selectedLanguageIds.some((id)=>id == lang.id)
                    }))
            }));
        groups = (0, _lodashDefault.default).sortBy(groups, (group)=>group.key);
        return groups;
    }
    render() {
        const selectedLangs = this.props.languages.filter((l)=>this.props.selectedLanguageIds.some((id)=>id == l.id));
        return (0, _react.jsx)((0, _groupedMultiSelectorDefault.default), {
            label: this.props.label ?? "Languages:",
            groupToggle: this.props.groupToggle ? this.props.groupToggle : groupToggleStyle,
            groups: this.getLanguageGroups(),
            onChange: this.handleChange.bind(this),
            selectedValues: this.props.selectedLanguageIds,
            withGroupSelection: false,
            restrictGroups: true,
            className: this.props.className,
            subItemCheckType: "radio",
            position: "bottom",
            emptyText: "You must add at least one language to your application first.",
            innerSelectionRender: ()=>(0, _react.jsx)((0, _reactDefault.default).Fragment, null, (0, _react.jsx)((0, _languageCollectionAvatarDefault.default), {
                    languages: selectedLangs,
                    limit: 3
                }), (0, _react.jsx)("p", {
                    className: this.props.labelStyle ? this.props.labelStyle : labelStyle
                }, selectedLangs.length > 0 ? selectedLangs.map((l)=>`${(0, _languages.getLanguageNameForLanguage)(l)} (${(0, _languages.getRegionyNameForLanguage)(l)})`).join(", ") : "Select a language"))
        });
    }
}
const groupToggleStyle = /*#__PURE__*/ (0, _css.css)({
    name: "173f3i6",
    styles: "margin-left:auto;margin-right:8px"
});
const labelStyle = /*#__PURE__*/ (0, _css.css)({
    name: "1qu8ll8",
    styles: "padding:0 8px"
});
exports.default = LanguageSingleSelector;

},{"@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","../../../../components/general/LanguageCollectionAvatar":"crbMk","../../../../models/extensions/languages":"8E5Oo","lodash":"3hMBK","../../../../components/forms/GroupedMultiSelector":"51iZT","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9qrrO":[function(require,module,exports) {
module.exports = require("b7439c0f916346f0").getBundleURL("kVLro") + require("2b91b0af45cdfa87").resolve("h57W2");

},{"b7439c0f916346f0":"c7Tr5","2b91b0af45cdfa87":"fyJL2"}],"2pAKq":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _base = require("@emotion/styled/base");
var _baseDefault = parcelHelpers.interopDefault(_base);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _textField = require("../../../../components/forms/TextField");
var _textFieldDefault = parcelHelpers.interopDefault(_textField);
var _horizontalSeparator = require("../../../../components/structure/HorizontalSeparator");
var _horizontalSeparatorDefault = parcelHelpers.interopDefault(_horizontalSeparator);
var _styledDropdown = require("./StyledDropdown");
var _styledDropdownDefault = parcelHelpers.interopDefault(_styledDropdown);
var _colors = require("../../../../constants/colors");
var _customAssistantConfigurationFormOptions = require("../../../../models/customAssistant/CustomAssistantConfigurationFormOptions");
var _iconTooltip = require("../../../../components/general/IconTooltip");
var _iconTooltipDefault = parcelHelpers.interopDefault(_iconTooltip);
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const AppearanceTabPanel = (props)=>{
    return (0, _react.jsx)(ConfigurationTabContent, null, (0, _react.jsx)(SubHeader, null, "Appearance"), (0, _react.jsx)(Description, null, "How your assistant will look to your users"), (0, _react.jsx)(SectionHeaderWrapper, null, (0, _react.jsx)(SectionHeaderText, null, "Theme"), (0, _react.jsx)((0, _horizontalSeparatorDefault.default), null)), (0, _react.jsx)(Description, null, "Use a pre-set theme to get a start on the style you want"), (0, _react.jsx)(Label, null, "Theme Style"), (0, _react.jsx)((0, _styledDropdownDefault.default), {
        value: props.values.themeStyle ?? "",
        handleOnChange: props.handleOnChange,
        fieldName: "themeStyle",
        options: (0, _customAssistantConfigurationFormOptions.themeStyleOptions),
        size: "medium",
        className: dropDownStyleMedium
    }), (0, _react.jsx)((0, _textFieldDefault.default), {
        name: "primaryColor",
        tooltip: "Must be a valid hex color code",
        toolTipPosition: "right",
        disabled: false,
        value: props.values.primaryColor ?? "",
        label: "Primary Color",
        placeholder: "Primary Color",
        onChange: props.handleChange,
        onBlur: props.handleBlur,
        fieldContainerStyle: fieldContainerStyle,
        className: textFieldStyle
    }), (0, _react.jsx)(SectionHeaderWrapper, null, (0, _react.jsx)(SectionHeaderText, null, "Text"), (0, _react.jsx)((0, _horizontalSeparatorDefault.default), null)), (0, _react.jsx)((0, _textFieldDefault.default), {
        name: "font",
        tooltip: "Ensure your website and/or mobile app has support for the font you choose",
        toolTipPosition: "right",
        disabled: false,
        value: props.values.font ?? "",
        label: "Font",
        placeholder: "Font",
        onChange: props.handleChange,
        onBlur: props.handleBlur,
        fieldContainerStyle: fieldContainerStyle,
        className: textFieldStyleTwo
    }), (0, _react.jsx)(SectionHeaderWrapper, null, (0, _react.jsx)(SectionHeaderText, null, "Overall Assistant"), (0, _react.jsx)((0, _horizontalSeparatorDefault.default), null)), (0, _react.jsx)(IndentedTextFieldWrapper, null, (0, _react.jsx)(IndentedTextFieldLabelWrapper, null, (0, _react.jsx)(IndentedTextFieldLabel, null, "Background Color"), (0, _react.jsx)((0, _iconTooltipDefault.default), {
        text: "Must be a valid hex color code",
        place: "right"
    })), (0, _react.jsx)((0, _textFieldDefault.default), {
        name: "overallBackgroundColor",
        disabled: false,
        value: props.values.overallBackgroundColor ?? "",
        placeholder: "Background Color",
        onChange: props.handleChange,
        onBlur: props.handleBlur,
        fieldContainerStyle: indentedTextFieldBoxStyle,
        className: indentedTextFieldStyle
    })), (0, _react.jsx)((0, _reactDefault.default).Fragment, null, (0, _react.jsx)(SectionHeaderWrapper, null, (0, _react.jsx)(SectionHeaderText, null, "Header"), (0, _react.jsx)((0, _horizontalSeparatorDefault.default), null)), props.values.uiType !== "minimal" && (0, _react.jsx)((0, _reactDefault.default).Fragment, null, (0, _react.jsx)(IndentedTextFieldWrapper, null, (0, _react.jsx)(IndentedTextFieldLabelWrapper, null, (0, _react.jsx)(IndentedTextFieldLabel, null, "Background Color"), (0, _react.jsx)((0, _iconTooltipDefault.default), {
        text: "Must be a valid hex color code",
        place: "right"
    })), (0, _react.jsx)((0, _textFieldDefault.default), {
        name: "headerBackgroundColor",
        disabled: false,
        value: props.values.headerBackgroundColor ?? "",
        placeholder: " Background Color",
        onChange: props.handleChange,
        onBlur: props.handleBlur,
        fieldContainerStyle: indentedTextFieldBoxStyle,
        className: indentedTextFieldStyle
    })), (0, _react.jsx)(IndentedTextFieldWrapper, null, (0, _react.jsx)(IndentedTextFieldLabelWrapper, null, (0, _react.jsx)(IndentedTextFieldLabel, null, "Font Color"), (0, _react.jsx)((0, _iconTooltipDefault.default), {
        text: "Must be a valid hex color code",
        place: "right"
    })), (0, _react.jsx)((0, _textFieldDefault.default), {
        name: "headerAssistantNameTextColor",
        disabled: false,
        value: props.values.headerAssistantNameTextColor ?? "",
        placeholder: " Font Color",
        onChange: props.handleChange,
        onBlur: props.handleBlur,
        fieldContainerStyle: indentedTextFieldBoxStyle,
        className: indentedTextFieldStyle
    }))), (0, _react.jsx)(Label, null, "Close Style"), (0, _react.jsx)((0, _styledDropdownDefault.default), {
        handleOnChange: props.handleOnChange,
        fieldName: "headerCloseAssistantButtonImage",
        options: (0, _customAssistantConfigurationFormOptions.closeAssistantButtonImageOptions),
        size: "medium",
        className: dropDownStyleMedium,
        value: props.values.headerCloseAssistantButtonImage ?? ""
    }), props.values.uiType !== "minimal" && (0, _react.jsx)((0, _reactDefault.default).Fragment, null, (0, _react.jsx)(Label, null, "Minimize Style"), (0, _react.jsx)((0, _styledDropdownDefault.default), {
        handleOnChange: props.handleOnChange,
        fieldName: "headerMinimizeIcon",
        options: (0, _customAssistantConfigurationFormOptions.minimizeIconOptions),
        size: "medium",
        className: dropDownStyleMedium,
        value: props.values.headerMinimizeIcon ?? ""
    })), (0, _react.jsx)(SectionHeaderWrapper, null, (0, _react.jsx)(SectionHeaderText, null, "Chat Section"), (0, _react.jsx)((0, _horizontalSeparatorDefault.default), null)), (0, _react.jsx)(IndentedTextFieldWrapper, null, (0, _react.jsx)(IndentedTextFieldLabelWrapper, null, (0, _react.jsx)(IndentedTextFieldLabel, null, "Chat Section Background Color"), (0, _react.jsx)((0, _iconTooltipDefault.default), {
        text: "Must be a valid hex color code",
        place: "right"
    })), (0, _react.jsx)((0, _textFieldDefault.default), {
        name: "bodyBackgroundColor",
        disabled: false,
        value: props.values.bodyBackgroundColor ?? "",
        placeholder: "Background Color",
        onChange: props.handleChange,
        onBlur: props.handleBlur,
        fieldContainerStyle: indentedTextFieldBoxStyle,
        className: indentedTextFieldStyle
    }))), (0, _react.jsx)(SectionHeaderWrapper, null, (0, _react.jsx)(SectionHeaderText, null, "Inputs"), (0, _react.jsx)((0, _horizontalSeparatorDefault.default), null)), props.values.uiType !== "minimal" && (0, _react.jsx)((0, _reactDefault.default).Fragment, null, (0, _react.jsx)(IndentedTextFieldWrapper, null, (0, _react.jsx)(IndentedTextFieldLabelWrapper, null, (0, _react.jsx)(IndentedTextFieldLabel, null, "Background Color"), (0, _react.jsx)((0, _iconTooltipDefault.default), {
        text: "Must be a valid hex color code",
        place: "right"
    })), (0, _react.jsx)((0, _textFieldDefault.default), {
        name: "toolbarBackgroundColor",
        disabled: false,
        value: props.values.toolbarBackgroundColor ?? "",
        placeholder: "Background Color",
        onChange: props.handleChange,
        onBlur: props.handleBlur,
        fieldContainerStyle: indentedTextFieldBoxStyle,
        className: indentedTextFieldStyle
    })), (0, _react.jsx)(IndentedTextFieldWrapper, null, (0, _react.jsx)(IndentedTextFieldLabelWrapper, null, (0, _react.jsx)(IndentedTextFieldLabel, null, "Font Color"), (0, _react.jsx)((0, _iconTooltipDefault.default), {
        text: "Must be a valid hex color code",
        place: "right"
    })), (0, _react.jsx)((0, _textFieldDefault.default), {
        name: "toolbarFontColor",
        disabled: false,
        value: props.values.toolbarFontColor ?? "",
        placeholder: "Font Color",
        onChange: props.handleChange,
        onBlur: props.handleBlur,
        fieldContainerStyle: indentedTextFieldBoxStyle,
        className: indentedTextFieldStyle
    }))), (0, _react.jsx)((0, _textFieldDefault.default), {
        name: "toolbarPlaceholder",
        disabled: false,
        value: props.values.toolbarPlaceholder ?? "",
        label: "Placeholder Text",
        placeholder: "Placeholder Text",
        onChange: props.handleChange,
        onBlur: props.handleBlur,
        fieldContainerStyle: fieldContainerStyle
    }), (0, _react.jsx)(Label, null, "Speak Style"), (0, _react.jsx)((0, _styledDropdownDefault.default), {
        handleOnChange: props.handleOnChange,
        fieldName: "toolbarMicActiveImage",
        options: (0, _customAssistantConfigurationFormOptions.micActiveImageOptions),
        size: "medium",
        className: dropDownStyleMedium,
        value: props.values.toolbarMicActiveImage ?? "https://voicify-prod-files.s3.amazonaws.com/sdk-images/micThreeActive.svg"
    }), (0, _react.jsx)(Label, null, "Send Style"), (0, _react.jsx)((0, _styledDropdownDefault.default), {
        handleOnChange: props.handleOnChange,
        fieldName: "toolbarSendActiveImage",
        options: (0, _customAssistantConfigurationFormOptions.sendActiveImageOptions),
        size: "medium",
        className: dropDownStyleMedium,
        value: props.values.toolbarSendActiveImage ?? "https://voicify-prod-files.s3.amazonaws.com/sdk-images/sendTwoActive.svg"
    }));
};
const IndentedTextFieldLabelWrapper = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "eg879io8"
})({
    name: "1a8c3p8",
    styles: "display:flex;align-items:center;justify-content:left;flex-grow:1"
});
const IndentedTextFieldWrapper = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "eg879io7"
})({
    name: "s5xdrg",
    styles: "display:flex;align-items:center"
});
const IndentedTextFieldLabel = /*#__PURE__*/ (0, _baseDefault.default)("p", {
    target: "eg879io6"
})("font-weight:400;font-size:14px;color:", (0, _colors.color_shades_darkest), ";margin-right:16px;");
const indentedTextFieldBoxStyle = /*#__PURE__*/ (0, _css.css)({
    name: "1a77ufd",
    styles: "height:48px;flex-grow:1"
});
const indentedTextFieldStyle = /*#__PURE__*/ (0, _css.css)({
    name: "kc65rb",
    styles: "margin-bottom:none"
});
const textFieldStyle = /*#__PURE__*/ (0, _css.css)({
    name: "1s22u92",
    styles: "margin-bottom:32px"
});
const textFieldStyleTwo = /*#__PURE__*/ (0, _css.css)({
    name: "bmyph7",
    styles: "margin-bottom:32px;margin-top:32px"
});
const SubHeader = /*#__PURE__*/ (0, _baseDefault.default)("h2", {
    target: "eg879io5"
})("font-size:18px;color:", (0, _colors.color_shades_darkest), ";font-weight:400;");
const fieldContainerStyle = /*#__PURE__*/ (0, _css.css)({
    name: "128tros",
    styles: "height:48px"
});
const Description = /*#__PURE__*/ (0, _baseDefault.default)("p", {
    target: "eg879io4"
})("font-size:14px;color:", (0, _colors.color_shades_darker), ";margin:16px 0 32px 0;");
const Label = /*#__PURE__*/ (0, _baseDefault.default)("p", {
    target: "eg879io3"
})("font-weight:400;font-size:14px;color:", (0, _colors.color_shades_darkest), ";margin:32px 0 4px 16px;");
const SectionHeaderText = /*#__PURE__*/ (0, _baseDefault.default)("h2", {
    target: "eg879io2"
})("margin-right:8px;font-size:16px;color:", (0, _colors.color_shades_darkest), ";text-transform:uppercase;font-weight:400;white-space:nowrap;");
const ConfigurationTabContent = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "eg879io1"
})({
    name: "okoa8h",
    styles: "padding:24px 24px 0 24px"
});
const SectionHeaderWrapper = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "eg879io0"
})({
    name: "13a1wts",
    styles: "display:flex;align-items:center;margin:32px 0"
});
const dropDownStyleMedium = /*#__PURE__*/ (0, _css.css)({
    name: "1s22u92",
    styles: "margin-bottom:32px"
});
exports.default = AppearanceTabPanel;

},{"@emotion/styled/base":"lSuFu","@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","../../../../components/forms/TextField":"7a7bh","../../../../components/structure/HorizontalSeparator":"Pw3HQ","./StyledDropdown":"hjrMo","../../../../constants/colors":"1p3OR","../../../../models/customAssistant/CustomAssistantConfigurationFormOptions":"hNADH","../../../../components/general/IconTooltip":"3FODC","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9bHqN":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _base = require("@emotion/styled/base");
var _baseDefault = parcelHelpers.interopDefault(_base);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _colors = require("../../../../constants/colors");
var _sharedStyledComponents = require("../SharedStyledComponents");
var _loader = require("../../../../components/general/Loader");
var _loaderDefault = parcelHelpers.interopDefault(_loader);
var _styledDropdown = require("./StyledDropdown");
var _styledDropdownDefault = parcelHelpers.interopDefault(_styledDropdown);
var _customAssistantCodeExportTypes = require("../../../../models/customAssistant/CustomAssistantCodeExportTypes");
var _codeExportDescription = require("./CodeExportDescription");
var _codeExportDescriptionDefault = parcelHelpers.interopDefault(_codeExportDescription);
var _codeBlock = require("./CodeBlock");
var _codeBlockDefault = parcelHelpers.interopDefault(_codeBlock);
var _customAssistantConfigurationGuide = require("../../../../constants/CustomAssistantConfigurationGuide");
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const ExportTabPanel = ({ copyText, assistantSettingsExport, codeExportLanguage, handleCodeExportLanguageChange, exportType, handleExportTypeChange, isLoading, hasPlatformConfigurations })=>{
    const renderDescription = ()=>{
        switch(codeExportLanguage){
            case "JavaScript":
                return (0, _react.jsx)((0, _codeExportDescriptionDefault.default), {
                    description: (0, _customAssistantConfigurationGuide.javascriptCodeExportDescription),
                    documentationInformation: (0, _customAssistantConfigurationGuide.javascriptDocumentationInformation),
                    documentationLink: (0, _customAssistantConfigurationGuide.javascriptDocumentationLink),
                    documentationLinkName: (0, _customAssistantConfigurationGuide.javascriptDocumentationLinkName),
                    exportType: exportType,
                    handleExportTypeChange: handleExportTypeChange,
                    hasPlatformConfigurations: hasPlatformConfigurations
                });
            case "Swift":
                return (0, _react.jsx)((0, _codeExportDescriptionDefault.default), {
                    description: (0, _customAssistantConfigurationGuide.swiftDescription),
                    installationTitle: (0, _customAssistantConfigurationGuide.swiftInstallationTitle),
                    installationCode: (0, _customAssistantConfigurationGuide.swiftInstallationInstructions),
                    documentationInformation: (0, _customAssistantConfigurationGuide.swiftDocumentationInformation),
                    documentationLink: (0, _customAssistantConfigurationGuide.swiftDocumentationLink),
                    documentationLinkName: (0, _customAssistantConfigurationGuide.swiftDocumentationLinkName),
                    permissionsTitle: (0, _customAssistantConfigurationGuide.swiftPermissionsTitle),
                    permissionsCode: (0, _customAssistantConfigurationGuide.swiftPermissionsCode),
                    exportType: exportType,
                    handleExportTypeChange: handleExportTypeChange,
                    hasPlatformConfigurations: hasPlatformConfigurations
                });
            case "Kotlin":
                return (0, _react.jsx)((0, _codeExportDescriptionDefault.default), {
                    description: (0, _customAssistantConfigurationGuide.kotlinDescription),
                    installationTitle: (0, _customAssistantConfigurationGuide.kotlinInstallationTitle),
                    installationCode: (0, _customAssistantConfigurationGuide.kotlinInstallationInstructions),
                    documentationInformation: (0, _customAssistantConfigurationGuide.kotlinDocumentationInformation),
                    documentationLink: (0, _customAssistantConfigurationGuide.kotlinDocumentationLink),
                    documentationLinkName: (0, _customAssistantConfigurationGuide.kotlinDocumentationLinkName),
                    permissionsTitle: (0, _customAssistantConfigurationGuide.kotlinPermissionsTitle),
                    permissionsCode: (0, _customAssistantConfigurationGuide.kotlinPermissionsCode),
                    exportType: exportType,
                    handleExportTypeChange: handleExportTypeChange,
                    hasPlatformConfigurations: hasPlatformConfigurations
                });
        }
    };
    return (0, _react.jsx)(ConfigurationTabContent, null, (0, _react.jsx)(HeaderWrapper, null, (0, _react.jsx)(SubHeader, null, "Export content"), (0, _react.jsx)((0, _styledDropdownDefault.default), {
        handleOnChange: handleCodeExportLanguageChange,
        options: (0, _customAssistantCodeExportTypes.codeExportLanguageOptions),
        size: "medium",
        value: codeExportLanguage
    })), renderDescription(), (0, _react.jsx)((0, _sharedStyledComponents.CopyButton), {
        className: copyButton,
        themes: [
            "secondary-small"
        ],
        text: "Copy Code Snippet",
        type: "button",
        onClick: ()=>copyText(assistantSettingsExport)
    }), isLoading ? (0, _react.jsx)((0, _loaderDefault.default), null) : (0, _react.jsx)((0, _codeBlockDefault.default), {
        code: assistantSettingsExport
    }));
};
const copyButton = /*#__PURE__*/ (0, _css.css)({
    name: "13v414j",
    styles: "margin-right:16px;margin-left:0"
});
const HeaderWrapper = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "ep661fv2"
})({
    name: "1f1m9i6",
    styles: "display:flex;justify-content:space-between;align-items:flex-start"
});
const SubHeader = /*#__PURE__*/ (0, _baseDefault.default)("h2", {
    target: "ep661fv1"
})("flex:1;font-size:18px;color:", (0, _colors.color_shades_darkest), ";font-weight:400;");
const ConfigurationTabContent = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "ep661fv0"
})({
    name: "okoa8h",
    styles: "padding:24px 24px 0 24px"
});
exports.default = ExportTabPanel;

},{"@emotion/styled/base":"lSuFu","@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","../../../../constants/colors":"1p3OR","../SharedStyledComponents":"9COIL","../../../../components/general/Loader":"bnV5T","./StyledDropdown":"hjrMo","../../../../models/customAssistant/CustomAssistantCodeExportTypes":"7cpTo","./CodeExportDescription":"gsoJ2","./CodeBlock":"5rhGn","../../../../constants/CustomAssistantConfigurationGuide":"27GJ1","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7cpTo":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "codeExportLanguageOptions", ()=>codeExportLanguageOptions);
parcelHelpers.export(exports, "getKotlinHexValue", ()=>getKotlinHexValue);
const codeExportLanguageOptions = [
    {
        label: "JavaScript",
        value: "JavaScript"
    },
    {
        label: "iOS: Swift",
        value: "Swift"
    },
    {
        label: "Android: Kotlin",
        value: "Kotlin"
    }
];
const getKotlinHexValue = (hex, isKotlin)=>{
    //check for gradient
    let colors = hex?.split(",");
    let gradient = "";
    if (colors?.length > 1) {
        colors.forEach((color, idx)=>{
            let updatedColor = getKotlinHexValue(color, true);
            if (idx == 0) gradient = gradient + `${updatedColor}`;
            else gradient = gradient + `,${updatedColor}`;
        });
        return gradient;
    }
    if (hex?.length == 9 && isKotlin) return `#${hex.substring(7, 9)}${hex.substring(1, 7)}`;
    return hex;
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"gsoJ2":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _base = require("@emotion/styled/base");
var _baseDefault = parcelHelpers.interopDefault(_base);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _colors = require("../../../../constants/colors");
var _codeBlock = require("./CodeBlock");
var _codeBlockDefault = parcelHelpers.interopDefault(_codeBlock);
var _customAssisantExportTypeDropdown = require("./CustomAssisantExportTypeDropdown");
var _customAssisantExportTypeDropdownDefault = parcelHelpers.interopDefault(_customAssisantExportTypeDropdown);
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const CodeExportDescrption = (props)=>{
    return (0, _react.jsx)(Container, null, props?.documentationInformation && props?.documentationLink && (0, _react.jsx)(DocumentationInformation, null, props.documentationInformation, " ", (0, _react.jsx)("a", {
        target: "_blank",
        href: props.documentationLink
    }, props?.documentationLinkName)), (0, _react.jsx)((0, _customAssisantExportTypeDropdownDefault.default), {
        exportType: props.exportType,
        handleExportTypeChange: props.handleExportTypeChange,
        hasPlatformConfigurations: props.hasPlatformConfigurations
    }), props?.installationTitle && (0, _react.jsx)(Description, null, props.installationTitle), props?.installationCode && (0, _react.jsx)((0, _codeBlockDefault.default), {
        code: props.installationCode
    }), props?.permissionsTitle && (0, _react.jsx)(Description, null, props.permissionsTitle), props?.permissionsCode && (0, _react.jsx)((0, _codeBlockDefault.default), {
        code: props.permissionsCode
    }), (0, _react.jsx)(Description, null, props.description));
};
const DocumentationInformation = /*#__PURE__*/ (0, _baseDefault.default)("p", {
    target: "e1rbtfh62"
})("font-size:14px;color:", (0, _colors.color_shades_darker), ";margin:32px 0;");
const Description = /*#__PURE__*/ (0, _baseDefault.default)("p", {
    target: "e1rbtfh61"
})("font-size:14px;color:", (0, _colors.color_shades_darker), ";margin:16px 0 0 0;");
const Container = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1rbtfh60"
})({
    name: "1fttcpj",
    styles: "display:flex;flex-direction:column"
});
exports.default = CodeExportDescrption;

},{"@emotion/styled/base":"lSuFu","@emotion/react":"djZKr","react":"6uln9","../../../../constants/colors":"1p3OR","./CodeBlock":"5rhGn","./CustomAssisantExportTypeDropdown":"NDX2S","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"5rhGn":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _css = require("@emotion/css");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const CodeBlock = (props)=>{
    return (0, _react.jsx)("pre", {
        className: preStyle
    }, (0, _react.jsx)("code", {
        className: codeStyle
    }, props.code));
};
const preStyle = /*#__PURE__*/ (0, _css.css)({
    name: "1tzjdot",
    styles: "margin:16px 0 32px 0;background:#eee;padding:1rem;overflow:auto;border-radius:3px;flex:1;display:flex;flex-wrap:wrap"
});
const codeStyle = /*#__PURE__*/ (0, _css.css)({
    name: "mbc6jt",
    styles: "text-align:left;white-space:pre-wrap;word-spacing:normal;word-break:normal;word-wrap:wrap;line-height:1.5"
});
exports.default = CodeBlock;

},{"@emotion/react":"djZKr","@emotion/css":"awUBr","react":"6uln9","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"NDX2S":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _base = require("@emotion/styled/base");
var _baseDefault = parcelHelpers.interopDefault(_base);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _toggleIndicator = require("../../../../components/general/ToggleIndicator");
var _toggleIndicatorDefault = parcelHelpers.interopDefault(_toggleIndicator);
var _colors = require("../../../../constants/colors");
var _dropDownSelectField = require("../../../../components/forms/DropDownSelectField");
var _dropDownSelectFieldDefault = parcelHelpers.interopDefault(_dropDownSelectField);
var _iconTooltip = require("../../../../components/general/IconTooltip");
var _iconTooltipDefault = parcelHelpers.interopDefault(_iconTooltip);
var _css = require("@emotion/css");
var _errorLabel = require("../../../../components/general/ErrorLabel");
var _errorLabelDefault = parcelHelpers.interopDefault(_errorLabel);
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const staticIcon = require("7508f7d0dfe83fb4");
const dynamicIcon = require("f774a8f24077f32b");
const staticIconSelected = require("a15ffbf265680907");
const dynamicIconSelected = require("9a2debe71f71de44");
const alertIcon = require("ce34c909acca8a60");
const options = [
    {
        value: "dynamic",
        label: "Dynamic",
        image: dynamicIcon,
        description: "Paste the snippet into your codebase once and your configuration will dynamically update as you publish changes in Voicify",
        selectedImage: dynamicIconSelected
    },
    {
        value: "static",
        label: "Static",
        image: staticIcon,
        description: "Paste the snippet into your codebase every time you update your configuration in Voicify",
        selectedImage: staticIconSelected
    }
];
const formatValueLabel = ({ label, image })=>(0, _react.jsx)(CustomSelectChosenOption, null, (0, _react.jsx)("img", {
        src: image
    }), (0, _react.jsx)("p", null, label));
const CustomAssistantExportTypeDropdown = (props)=>{
    return (0, _react.jsx)((0, _reactDefault.default).Fragment, null, (0, _react.jsx)(CustomAssistantExportTypeDropdownWrapper, null, props.hasPlatformConfigurations ? (0, _react.jsx)(IconTooltipWrapper, null, (0, _react.jsx)(DropdownTitle, {
        className: "user-entry"
    }, "Code Export Type"), (0, _react.jsx)((0, _iconTooltipDefault.default), {
        text: "- Static adds a layer of protection around updates </br> - Dynamic enables real-time updates",
        place: "right",
        className: iconTooltipStyle
    })) : (0, _react.jsx)(DropdownTitleWrapper, null, (0, _react.jsx)(IconTooltipWrapper, null, (0, _react.jsx)(DropdownTitle, {
        className: "user-entry"
    }, "Code Export Type"), (0, _react.jsx)((0, _iconTooltipDefault.default), {
        text: "- Static adds a layer of protection around updates </br> - Dynamic enables real-time updates",
        place: "right",
        className: iconTooltipStyle
    })), (0, _react.jsx)((0, _errorLabelDefault.default), {
        image: alertIcon,
        text: "Hit the 'Save & Close' button and reopen this configuration to access your dynamic code snippet.",
        className: errorLabelStyle
    })), (0, _react.jsx)(CustomDropDownSelect, {
        className: "ac-access",
        clearable: false,
        searchable: false,
        valueRenderer: formatValueLabel,
        disabled: props.hasPlatformConfigurations ? false : true,
        options: options,
        onChange: (e)=>{
            props.handleExportTypeChange(props.exportType, e.value);
        },
        value: props.exportType,
        key: "user-entry-selector",
        arrowRenderer: (p)=>(0, _react.jsx)(Arrow, {
                direction: p.isOpen ? "up" : "down"
            }),
        menuRenderer: (menuProps)=>{
            return (0, _react.jsx)(MenuOptionsWrapper, null, (0, _react.jsx)(Triangle, null), options.map((option, index)=>(0, _react.jsx)(SelectOption, {
                    key: index,
                    className: "user-entry-option",
                    onClick: ()=>menuProps.selectValue(option)
                }, (0, _react.jsx)(CustomSelectOptionLabel, null, option.image ? (0, _react.jsx)(ExportTypeIcon, {
                    src: menuProps.valueArray[0].value == option.value ? option.selectedImage : option.image
                }) : null, (0, _react.jsx)("div", null, (0, _react.jsx)("p", {
                    className: menuProps.valueArray[0].value == option.value ? "option-selected" : ""
                }, option.label), (0, _react.jsx)("p", {
                    className: menuProps.valueArray[0].value == option.value ? "option-description-selected" : "option-description"
                }, option.description))), index != menuProps.options.length - 1 && (0, _react.jsx)(Divider, null))));
        }
    })));
};
const errorLabelStyle = /*#__PURE__*/ (0, _css.css)({
    name: "pit38s",
    styles: "height:auto"
});
const DropdownTitleWrapper = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1rqe0ja12"
})({
    name: "1fttcpj",
    styles: "display:flex;flex-direction:column"
});
const iconTooltipStyle = /*#__PURE__*/ (0, _css.css)({
    name: "ny5p0o",
    styles: "margin-left:16px"
});
const IconTooltipWrapper = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1rqe0ja11"
})({
    name: "1dj8hm0",
    styles: "display:flex;align-items:center;margin-bottom:8px"
});
const DropdownTitle = /*#__PURE__*/ (0, _baseDefault.default)("p", {
    target: "e1rqe0ja10"
})("");
const Arrow = /*#__PURE__*/ (0, _baseDefault.default)((0, _toggleIndicatorDefault.default), {
    target: "e1rqe0ja9"
})({
    name: "11f9gim",
    styles: "height:8px;width:8px"
});
const ExportTypeIcon = /*#__PURE__*/ (0, _baseDefault.default)("img", {
    target: "e1rqe0ja8"
})({
    name: "bmozya",
    styles: "height:24px;width:24px;margin-top:4px"
});
const SelectOption = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1rqe0ja7"
})("&.user-entry-option:hover{background-color:", (0, _colors.color_variants_ocean_xlight), ";cursor:pointer;}");
const MenuOptionsWrapper = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1rqe0ja6"
})({
    name: "hkh81z",
    styles: "margin-top:8px"
});
const CustomSelectChosenOption = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1rqe0ja5"
})("display:flex;flex-direction:row;padding-left:6px;p{color:", (0, _colors.color_shades_darkest), ";margin-left:10px;}img{height:24px;width:24px;margin-top:4px;}");
const Divider = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1rqe0ja4"
})("display:block;height:1px;border:0;border-top:1px solid ", (0, _colors.color_shades_dark), ";padding:0;");
const CustomSelectOptionLabel = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1rqe0ja3"
})("display:flex;flex-direction:row;padding-left:15px;padding-right:15px;padding-top:12px;padding-bottom:12px;font-size:14px;div{line-height:normal;margin-left:10px;color:", (0, _colors.color_shades_darkest), ";}.option-selected{color:", (0, _colors.color_colors_ocean), ";font-size:14px;}.option-description{font-size:10px;color:", (0, _colors.color_shades_darker), ";margin-top:4px;}.option-description-selected{font-size:10px;color:", (0, _colors.color_colors_ocean), ";margin-top:4px;}");
const Triangle = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1rqe0ja2"
})("transform:rotate(45deg);width:12px;height:12px;border-top:solid 1px ", (0, _colors.color_shades_dark), ";border-left:solid 1px ", (0, _colors.color_shades_dark), ";background:white;margin-top:-7px;right:15px;position:absolute;");
const CustomAssistantExportTypeDropdownWrapper = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1rqe0ja1"
})("margin-bottom:16px;.user-entry{margin-left:16px;font-size:14px;color:", (0, _colors.color_shades_darkest), ";}");
const CustomDropDownSelect = /*#__PURE__*/ (0, _baseDefault.default)((0, _dropDownSelectFieldDefault.default), {
    target: "e1rqe0ja0"
})("margin-top:4px;.Select-multi-value-wrapper{height:48px;}.Select-menu-outer{border-top-color:", (0, _colors.color_shades_dark), ";}.Select-value{margin-top:8px;}.Select-control{border-radius:4px;font-size:14px;}&.is-open{.Select-control{border-bottom-right-radius:4px;border-bottom-left-radius:4px;border-color:", (0, _colors.color_shades_dark), ";}}");
exports.default = CustomAssistantExportTypeDropdown;

},{"@emotion/styled/base":"lSuFu","@emotion/react":"djZKr","react":"6uln9","../../../../components/general/ToggleIndicator":"4eej1","../../../../constants/colors":"1p3OR","../../../../components/forms/DropDownSelectField":"kFCJA","../../../../components/general/IconTooltip":"3FODC","@emotion/css":"awUBr","../../../../components/general/ErrorLabel":"k9Ob0","7508f7d0dfe83fb4":"14aht","f774a8f24077f32b":"4BC4u","a15ffbf265680907":"gLc0f","9a2debe71f71de44":"ddbWK","ce34c909acca8a60":"cRA6k","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"14aht":[function(require,module,exports) {
module.exports = require("d4f558a6240eea3b").getBundleURL("kVLro") + require("31befa8eb4369788").resolve("7q5gp");

},{"d4f558a6240eea3b":"c7Tr5","31befa8eb4369788":"fyJL2"}],"4BC4u":[function(require,module,exports) {
module.exports = require("8ab31c3afbc63562").getBundleURL("kVLro") + require("45fee5e005b17a35").resolve("a1p8i");

},{"8ab31c3afbc63562":"c7Tr5","45fee5e005b17a35":"fyJL2"}],"gLc0f":[function(require,module,exports) {
module.exports = require("c75fa5271641f9e6").getBundleURL("kVLro") + require("1389720af649c20d").resolve("99HjY");

},{"c75fa5271641f9e6":"c7Tr5","1389720af649c20d":"fyJL2"}],"ddbWK":[function(require,module,exports) {
module.exports = require("8df26339dfad4cee").getBundleURL("kVLro") + require("9eb1de120f9b55c6").resolve("cbX40");

},{"8df26339dfad4cee":"c7Tr5","9eb1de120f9b55c6":"fyJL2"}],"27GJ1":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "javascriptCodeExportDescription", ()=>javascriptCodeExportDescription);
parcelHelpers.export(exports, "javascriptDocumentationInformation", ()=>javascriptDocumentationInformation);
parcelHelpers.export(exports, "javascriptDocumentationLink", ()=>javascriptDocumentationLink);
parcelHelpers.export(exports, "javascriptDocumentationLinkName", ()=>javascriptDocumentationLinkName);
parcelHelpers.export(exports, "swiftInstallationInstructions", ()=>swiftInstallationInstructions);
parcelHelpers.export(exports, "swiftPermissionsCode", ()=>swiftPermissionsCode);
parcelHelpers.export(exports, "swiftInstallationTitle", ()=>swiftInstallationTitle);
parcelHelpers.export(exports, "swiftDocumentationInformation", ()=>swiftDocumentationInformation);
parcelHelpers.export(exports, "swiftDocumentationLink", ()=>swiftDocumentationLink);
parcelHelpers.export(exports, "swiftDocumentationLinkName", ()=>swiftDocumentationLinkName);
parcelHelpers.export(exports, "swiftPermissionsTitle", ()=>swiftPermissionsTitle);
parcelHelpers.export(exports, "swiftDescription", ()=>swiftDescription);
parcelHelpers.export(exports, "kotlinInstallationInstructions", ()=>kotlinInstallationInstructions);
parcelHelpers.export(exports, "kotlinPermissionsCode", ()=>kotlinPermissionsCode);
parcelHelpers.export(exports, "kotlinInstallationTitle", ()=>kotlinInstallationTitle);
parcelHelpers.export(exports, "kotlinDocumentationInformation", ()=>kotlinDocumentationInformation);
parcelHelpers.export(exports, "kotlinDocumentationLink", ()=>kotlinDocumentationLink);
parcelHelpers.export(exports, "kotlinDocumentationLinkName", ()=>kotlinDocumentationLinkName);
parcelHelpers.export(exports, "kotlinPermissionsTitle", ()=>kotlinPermissionsTitle);
parcelHelpers.export(exports, "kotlinDescription", ()=>kotlinDescription);
const javascriptCodeExportDescription = "Copy the below JavaScript code snippet and paste it into the head section of your HTML page.";
const javascriptDocumentationInformation = "To get more information about the SDK, including the current version number, please visit our";
const javascriptDocumentationLink = "https://support.voicify.com/en/knowledge/how-do-i-deploy-my-voicify-app/assistant-to-my-website";
const javascriptDocumentationLinkName = "Browser SDK documentation.";
const swiftInstallationInstructions = `source 'https://github.com/voicifydevs/voicify-ios-sdk-pod-specs.git' 

target 'MyApp' do 

use_frameworks! :linkage => :static 

    pod 'voicify-ios-sdk', '~> {version}' 
    
end.
`;
const swiftPermissionsCode = `Key: Privacy - Speech Recognition Usage Description
Value: Your Usage Description Goes Here

Key: Privacy - Microphone Usage Description
Value: Your Usage Description Goes Here
`;
const swiftInstallationTitle = "1. Install the SDK with CocoaPods by specifing it to a target in your Podfile:";
const swiftDocumentationInformation = "To get more information about the SDK, including the current version number, please visit our";
const swiftDocumentationLink = "https://support.voicify.com/en/knowledge/how-do-i-deploy-my-voicify-assistant-to-my-ios-mobile-app";
const swiftDocumentationLinkName = "iOS SDK documentation.";
const swiftPermissionsTitle = "2. Add permissions to your IOS target properties:";
const swiftDescription = "3. Copy the below Swift code snippet and paste it into your view.";
const kotlinInstallationInstructions = `dependencies {
    implementation 'com.github.voicifydevs:voicify-android-sdk:{version}'
}
`;
const kotlinPermissionsCode = `<uses-permission "android:name=android.permission.RECORD_AUDIO" />
<uses-permission "android:name=android.permission.INTERNET" />

<queries>
    intent>
        <action android:name="android.speech.RecognitionService" />
    </intent>
</queries>`;
const kotlinInstallationTitle = "1. Install the SDK with Jitpack by specifying the dependency in your app level build.gradle file:";
const kotlinDocumentationInformation = "To get more information about the SDK, including the current version number, please visit our";
const kotlinDocumentationLink = "https://support.voicify.com/en/knowledge/how-do-i-deploy-my-voicify-assistant-to-my-android-app";
const kotlinDocumentationLinkName = "Android SDK documentation.";
const kotlinPermissionsTitle = "2. Add permissions to your Android manifest:";
const kotlinDescription = "3. Copy the below Kotlin code snippet and paste it into your activity.";

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"ik75v":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "defaultFont", ()=>defaultFont);
parcelHelpers.export(exports, "browserLightStyle1", ()=>browserLightStyle1);
parcelHelpers.export(exports, "browserLightStyle1Minimal", ()=>browserLightStyle1Minimal);
parcelHelpers.export(exports, "mobileLightStyle1", ()=>mobileLightStyle1);
parcelHelpers.export(exports, "mobileLightStyle1Minimal", ()=>mobileLightStyle1Minimal);
parcelHelpers.export(exports, "browserLightStyle2", ()=>browserLightStyle2);
parcelHelpers.export(exports, "browserLightStyle2Minimal", ()=>browserLightStyle2Minimal);
parcelHelpers.export(exports, "mobileLightStyle2", ()=>mobileLightStyle2);
parcelHelpers.export(exports, "mobileLightStyle2Minimal", ()=>mobileLightStyle2Minimal);
parcelHelpers.export(exports, "browserDarkStyle1", ()=>browserDarkStyle1);
parcelHelpers.export(exports, "browserDarkStyle1Minimal", ()=>browserDarkStyle1Minimal);
parcelHelpers.export(exports, "mobileDarkStyle1", ()=>mobileDarkStyle1);
parcelHelpers.export(exports, "mobileDarkStyle1Minimal", ()=>mobileDarkStyle1Minimal);
parcelHelpers.export(exports, "browserDarkStyle2", ()=>browserDarkStyle2);
parcelHelpers.export(exports, "browserDarkStyle2Minimal", ()=>browserDarkStyle2Minimal);
parcelHelpers.export(exports, "mobileDarkStyle2", ()=>mobileDarkStyle2);
parcelHelpers.export(exports, "mobileDarkStyle2Minimal", ()=>mobileDarkStyle2Minimal);
parcelHelpers.export(exports, "browserDefaultStyle", ()=>browserDefaultStyle);
parcelHelpers.export(exports, "browserDefaultStyleMinimal", ()=>browserDefaultStyleMinimal);
parcelHelpers.export(exports, "mobileDefaultStyle", ()=>mobileDefaultStyle);
var _hexToCssFilter = require("hex-to-css-filter");
var _colors = require("../colors");
var _customAssistantConfigurationsColors = require("./customAssistantConfigurationsColors");
const defaultFont = "sans-serif";
const sharedLightStyle1Props = {
    assistantNameTextColor: (0, _colors.color_shades_darkest),
    messageSentBackgroundColor: (0, _customAssistantConfigurationsColors.defaultDarkGray),
    messageReceivedBackgroundColor: "#0000000d",
    messageReceivedTextColor: (0, _colors.color_shades_darkest),
    speechResultBoxBackgroundColor: (0, _customAssistantConfigurationsColors.defaultDarkGray),
    buttonBackgroundColor: (0, _customAssistantConfigurationsColors.defaultDarkGray),
    textInputLineColor: (0, _customAssistantConfigurationsColors.defaultLightGray),
    textInputActiveLineColor: (0, _customAssistantConfigurationsColors.defaultLightGray),
    textboxActiveHighlightColor: (0, _customAssistantConfigurationsColors.defaultGrayHighlight),
    font: defaultFont,
    header: {
        backgroundColor: (0, _colors.color_defaults_white)
    },
    body: {
        backgroundColor: (0, _colors.color_shades_lighter)
    },
    toolbar: {
        backgroundColor: (0, _colors.color_defaults_white)
    }
};
const sharedLightStyle1MinimalProps = {
    assistantNameTextColor: (0, _colors.color_shades_darkest),
    messageSentBackgroundColor: (0, _customAssistantConfigurationsColors.defaultDarkGray),
    messageReceivedBackgroundColor: "#0000000d",
    messageReceivedTextColor: (0, _colors.color_shades_darkest),
    speechResultBoxBackgroundColor: (0, _customAssistantConfigurationsColors.defaultDarkGray),
    buttonBackgroundColor: (0, _customAssistantConfigurationsColors.defaultDarkGray),
    textInputLineColor: (0, _customAssistantConfigurationsColors.defaultLightGray),
    textInputActiveLineColor: (0, _customAssistantConfigurationsColors.defaultLightGray),
    textboxActiveHighlightColor: (0, _customAssistantConfigurationsColors.defaultGrayHighlight),
    font: defaultFont,
    header: {
        backgroundColor: "transparent"
    },
    body: {
        backgroundColor: "transparent"
    },
    toolbar: {
        backgroundColor: "transparent"
    }
};
const sharedLightStyle2Props = {
    assistantNameTextColor: (0, _colors.color_shades_darkest),
    messageSentBackgroundColor: (0, _customAssistantConfigurationsColors.defaultBlue),
    messageReceivedBackgroundColor: "#0000000d",
    messageReceivedTextColor: (0, _colors.color_shades_darkest),
    speechResultBoxBackgroundColor: (0, _customAssistantConfigurationsColors.defaultBlue),
    speakActiveTitleColor: (0, _customAssistantConfigurationsColors.defaultBlue),
    typeActiveTitleColor: (0, _customAssistantConfigurationsColors.defaultBlue),
    textboxActiveHighlightColor: (0, _customAssistantConfigurationsColors.defaultBlueHighlight),
    font: defaultFont,
    header: {
        backgroundColor: (0, _colors.color_defaults_white)
    },
    body: {
        backgroundColor: (0, _colors.color_shades_lighter)
    },
    toolbar: {
        backgroundColor: (0, _colors.color_defaults_white)
    }
};
const sharedLightStyle2MinimalProps = {
    assistantNameTextColor: (0, _colors.color_shades_darkest),
    messageSentBackgroundColor: (0, _customAssistantConfigurationsColors.defaultBlue),
    messageReceivedBackgroundColor: "#0000000d",
    messageReceivedTextColor: (0, _colors.color_shades_darkest),
    speechResultBoxBackgroundColor: (0, _customAssistantConfigurationsColors.defaultBlue),
    speakActiveTitleColor: (0, _customAssistantConfigurationsColors.defaultBlue),
    typeActiveTitleColor: (0, _customAssistantConfigurationsColors.defaultBlue),
    textboxActiveHighlightColor: (0, _customAssistantConfigurationsColors.defaultBlueHighlight),
    font: defaultFont,
    header: {
        backgroundColor: "transparent"
    },
    body: {
        backgroundColor: "transparent"
    },
    toolbar: {
        backgroundColor: "transparent"
    }
};
const sharedDarkStyle1Props = {
    assistantNameTextColor: (0, _customAssistantConfigurationsColors.defaultWhite),
    messageReceivedTextColor: (0, _customAssistantConfigurationsColors.defaultWhite),
    messageSentTextColor: (0, _customAssistantConfigurationsColors.defaultDarkModeTextColor),
    messageSentBackgroundColor: (0, _customAssistantConfigurationsColors.defaultWhite),
    speechResultBoxBackgroundColor: (0, _customAssistantConfigurationsColors.defaultWhite),
    speakInactiveTitleColor: (0, _customAssistantConfigurationsColors.defaultWhite),
    speakActiveTitleColor: (0, _customAssistantConfigurationsColors.defaultWhite),
    typeInactiveTitleColor: (0, _customAssistantConfigurationsColors.defaultWhite),
    typeActiveTitleColor: (0, _customAssistantConfigurationsColors.defaultWhite),
    textInputTextColor: (0, _customAssistantConfigurationsColors.defaultWhite),
    helpTextFontColor: (0, _customAssistantConfigurationsColors.defaultWhite),
    muteFontColor: (0, _customAssistantConfigurationsColors.defaultWhite),
    assistantStateFontColor: (0, _customAssistantConfigurationsColors.defaultWhite),
    fullSpeechResultTextColor: (0, _customAssistantConfigurationsColors.defaultDarkModeTextColor),
    partialSpeechResultTextColor: (0, _customAssistantConfigurationsColors.defaultDarkModeTextColor),
    font: defaultFont,
    hintsTextColor: (0, _customAssistantConfigurationsColors.defaultWhite),
    hintsBackgroundColor: (0, _customAssistantConfigurationsColors.transparent),
    header: {
        backgroundColor: (0, _customAssistantConfigurationsColors.transparent)
    },
    body: {
        backgroundColor: (0, _customAssistantConfigurationsColors.transparent)
    },
    toolbar: {
        backgroundColor: (0, _customAssistantConfigurationsColors.transparent)
    }
};
const sharedDarkStyle1MinimalProps = {
    assistantNameTextColor: (0, _customAssistantConfigurationsColors.defaultWhite),
    messageReceivedTextColor: (0, _colors.color_shades_darkest),
    messageSentTextColor: (0, _customAssistantConfigurationsColors.defaultDarkModeTextColor),
    messageSentBackgroundColor: (0, _customAssistantConfigurationsColors.defaultWhite),
    speechResultBoxBackgroundColor: (0, _customAssistantConfigurationsColors.defaultWhite),
    speakInactiveTitleColor: (0, _customAssistantConfigurationsColors.defaultWhite),
    speakActiveTitleColor: (0, _customAssistantConfigurationsColors.defaultWhite),
    typeInactiveTitleColor: (0, _customAssistantConfigurationsColors.defaultWhite),
    typeActiveTitleColor: (0, _customAssistantConfigurationsColors.defaultWhite),
    textInputTextColor: (0, _customAssistantConfigurationsColors.defaultWhite),
    helpTextFontColor: (0, _customAssistantConfigurationsColors.defaultWhite),
    muteFontColor: (0, _customAssistantConfigurationsColors.defaultWhite),
    assistantStateFontColor: (0, _customAssistantConfigurationsColors.defaultWhite),
    fullSpeechResultTextColor: (0, _customAssistantConfigurationsColors.defaultDarkModeTextColor),
    partialSpeechResultTextColor: (0, _customAssistantConfigurationsColors.defaultDarkModeTextColor),
    font: defaultFont,
    hintsTextColor: (0, _customAssistantConfigurationsColors.defaultWhite),
    hintsBackgroundColor: (0, _customAssistantConfigurationsColors.transparent),
    header: {
        backgroundColor: (0, _customAssistantConfigurationsColors.transparent)
    },
    body: {
        backgroundColor: (0, _customAssistantConfigurationsColors.transparent)
    },
    toolbar: {
        backgroundColor: (0, _customAssistantConfigurationsColors.transparent)
    }
};
const sharedDarkStyle2Props = {
    assistantNameTextColor: (0, _customAssistantConfigurationsColors.defaultWhite),
    messageReceivedTextColor: (0, _customAssistantConfigurationsColors.defaultWhite),
    messageSentTextColor: (0, _customAssistantConfigurationsColors.defaultWhite),
    messageSentBackgroundColor: (0, _customAssistantConfigurationsColors.defaultBlue),
    speechResultBoxBackgroundColor: (0, _customAssistantConfigurationsColors.defaultBlue),
    fullSpeechResultTextColor: (0, _customAssistantConfigurationsColors.defaultWhite),
    partialSpeechResultTextColor: (0, _customAssistantConfigurationsColors.defaultWhite),
    speakInactiveTitleColor: (0, _customAssistantConfigurationsColors.defaultWhite),
    speakActiveTitleColor: (0, _customAssistantConfigurationsColors.defaultWhite),
    typeInactiveTitleColor: (0, _customAssistantConfigurationsColors.defaultWhite),
    typeActiveTitleColor: (0, _customAssistantConfigurationsColors.defaultWhite),
    textInputTextColor: (0, _customAssistantConfigurationsColors.defaultWhite),
    helpTextFontColor: (0, _customAssistantConfigurationsColors.defaultWhite),
    muteFontColor: (0, _customAssistantConfigurationsColors.defaultWhite),
    assistantStateFontColor: (0, _customAssistantConfigurationsColors.defaultWhite),
    font: defaultFont,
    hintsTextColor: (0, _customAssistantConfigurationsColors.defaultWhite),
    hintsBackgroundColor: (0, _customAssistantConfigurationsColors.transparent),
    header: {
        backgroundColor: (0, _customAssistantConfigurationsColors.transparent)
    },
    body: {
        backgroundColor: (0, _customAssistantConfigurationsColors.transparent)
    },
    toolbar: {
        backgroundColor: (0, _customAssistantConfigurationsColors.transparent)
    }
};
const sharedDarkStyle2MinimalProps = {
    assistantNameTextColor: (0, _customAssistantConfigurationsColors.defaultWhite),
    messageReceivedTextColor: (0, _colors.color_shades_darkest),
    messageSentTextColor: (0, _customAssistantConfigurationsColors.defaultWhite),
    messageSentBackgroundColor: (0, _customAssistantConfigurationsColors.defaultBlue),
    speechResultBoxBackgroundColor: (0, _customAssistantConfigurationsColors.defaultBlue),
    fullSpeechResultTextColor: (0, _customAssistantConfigurationsColors.defaultWhite),
    partialSpeechResultTextColor: (0, _customAssistantConfigurationsColors.defaultWhite),
    speakInactiveTitleColor: (0, _customAssistantConfigurationsColors.defaultWhite),
    speakActiveTitleColor: (0, _customAssistantConfigurationsColors.defaultWhite),
    typeInactiveTitleColor: (0, _customAssistantConfigurationsColors.defaultWhite),
    typeActiveTitleColor: (0, _customAssistantConfigurationsColors.defaultWhite),
    textInputTextColor: (0, _customAssistantConfigurationsColors.defaultWhite),
    helpTextFontColor: (0, _customAssistantConfigurationsColors.defaultWhite),
    muteFontColor: (0, _customAssistantConfigurationsColors.defaultWhite),
    assistantStateFontColor: (0, _customAssistantConfigurationsColors.defaultWhite),
    font: defaultFont,
    hintsTextColor: (0, _customAssistantConfigurationsColors.defaultWhite),
    hintsBackgroundColor: (0, _customAssistantConfigurationsColors.transparent),
    header: {
        backgroundColor: (0, _customAssistantConfigurationsColors.transparent)
    },
    body: {
        backgroundColor: (0, _customAssistantConfigurationsColors.transparent)
    },
    toolbar: {
        backgroundColor: (0, _customAssistantConfigurationsColors.transparent)
    }
};
const sharedDefaultStyleProps = {
    assistantNameTextColor: (0, _colors.color_shades_darkest),
    messageSentBackgroundColor: (0, _customAssistantConfigurationsColors.defaultDarkGray),
    messageReceivedBackgroundColor: "#0000000d",
    messageReceivedTextColor: (0, _colors.color_shades_darkest),
    speechResultBoxBackgroundColor: (0, _customAssistantConfigurationsColors.defaultDarkGray),
    buttonBackgroundColor: (0, _customAssistantConfigurationsColors.defaultDarkGray),
    textInputLineColor: (0, _customAssistantConfigurationsColors.defaultLightGray),
    textInputActiveLineColor: (0, _customAssistantConfigurationsColors.defaultLightGray),
    textboxActiveHighlightColor: (0, _customAssistantConfigurationsColors.defaultGrayHighlight),
    font: defaultFont,
    header: {
        backgroundColor: (0, _colors.color_defaults_white)
    },
    body: {
        backgroundColor: (0, _colors.color_shades_lighter)
    },
    toolbar: {
        backgroundColor: (0, _colors.color_defaults_white)
    }
};
const sharedDefaultStyleMinimalProps = {
    assistantNameTextColor: (0, _colors.color_shades_darkest),
    messageSentBackgroundColor: (0, _customAssistantConfigurationsColors.defaultDarkGray),
    messageReceivedBackgroundColor: "#0000000d",
    messageReceivedTextColor: (0, _colors.color_shades_darkest),
    speechResultBoxBackgroundColor: (0, _customAssistantConfigurationsColors.defaultDarkGray),
    buttonBackgroundColor: (0, _customAssistantConfigurationsColors.defaultDarkGray),
    textInputLineColor: (0, _customAssistantConfigurationsColors.defaultLightGray),
    textInputActiveLineColor: (0, _customAssistantConfigurationsColors.defaultLightGray),
    textboxActiveHighlightColor: (0, _customAssistantConfigurationsColors.defaultGrayHighlight),
    font: defaultFont,
    header: {
        backgroundColor: "transparent"
    },
    body: {
        backgroundColor: "transparent"
    },
    toolbar: {
        backgroundColor: "transparent"
    }
};
const browserLightStyle1 = {
    ...sharedLightStyle1Props,
    closeAssistantColor: (0, _hexToCssFilter.hexToCSSFilter)((0, _customAssistantConfigurationsColors.defaultLightGray)).filter,
    minimizeAssistantColor: (0, _hexToCssFilter.hexToCSSFilter)((0, _customAssistantConfigurationsColors.defaultLightGray)).filter,
    muteImageColor: (0, _hexToCssFilter.hexToCSSFilter)((0, _customAssistantConfigurationsColors.defaultLightGray)).filter,
    micActiveColor: (0, _hexToCssFilter.hexToCSSFilter)((0, _customAssistantConfigurationsColors.defaultDarkGray)).filter,
    sendActiveColor: (0, _hexToCssFilter.hexToCSSFilter)((0, _customAssistantConfigurationsColors.defaultDarkGray)).filter,
    sendInactiveColor: (0, _hexToCssFilter.hexToCSSFilter)((0, _customAssistantConfigurationsColors.defaultDarkGray)).filter,
    equalizerColor: `linear-gradient(180deg, ${(0, _customAssistantConfigurationsColors.defaultDarkGray)} 0%, ${(0, _customAssistantConfigurationsColors.defaultLightGray)} 100%)`
};
const browserLightStyle1Minimal = {
    ...sharedLightStyle1MinimalProps,
    closeAssistantColor: (0, _hexToCssFilter.hexToCSSFilter)((0, _customAssistantConfigurationsColors.defaultLightGray)).filter,
    minimizeAssistantColor: (0, _hexToCssFilter.hexToCSSFilter)((0, _customAssistantConfigurationsColors.defaultLightGray)).filter,
    muteImageColor: (0, _hexToCssFilter.hexToCSSFilter)((0, _customAssistantConfigurationsColors.defaultLightGray)).filter,
    micActiveColor: (0, _hexToCssFilter.hexToCSSFilter)((0, _customAssistantConfigurationsColors.defaultDarkGray)).filter,
    keyboardColor: (0, _hexToCssFilter.hexToCSSFilter)((0, _customAssistantConfigurationsColors.defaultDarkGray)).filter,
    sendActiveColor: (0, _hexToCssFilter.hexToCSSFilter)((0, _customAssistantConfigurationsColors.defaultDarkGray)).filter,
    sendInactiveColor: (0, _hexToCssFilter.hexToCSSFilter)((0, _customAssistantConfigurationsColors.defaultDarkGray)).filter,
    overallBackgroundColor: "#FFFFFFBF",
    partialSpeechResultTextColor: "#FFFFFF"
};
const mobileLightStyle1 = {
    ...sharedLightStyle1Props,
    closeAssistantColor: (0, _customAssistantConfigurationsColors.defaultLightGray),
    minimizeAssistantColor: (0, _customAssistantConfigurationsColors.defaultLightGray),
    muteImageColor: (0, _customAssistantConfigurationsColors.defaultLightGray),
    micActiveColor: (0, _customAssistantConfigurationsColors.defaultDarkGray),
    sendActiveColor: (0, _customAssistantConfigurationsColors.defaultDarkGray),
    sendInactiveColor: (0, _customAssistantConfigurationsColors.defaultDarkGray),
    equalizerColor: `${(0, _customAssistantConfigurationsColors.defaultDarkGray)},${(0, _customAssistantConfigurationsColors.defaultLightGray)}`
};
const mobileLightStyle1Minimal = {
    ...sharedLightStyle1MinimalProps,
    closeAssistantColor: (0, _customAssistantConfigurationsColors.defaultLightGray),
    minimizeAssistantColor: (0, _customAssistantConfigurationsColors.defaultLightGray),
    muteImageColor: (0, _customAssistantConfigurationsColors.defaultLightGray),
    micActiveColor: (0, _customAssistantConfigurationsColors.defaultDarkGray),
    keyboardColor: (0, _customAssistantConfigurationsColors.defaultDarkGray),
    sendActiveColor: (0, _customAssistantConfigurationsColors.defaultDarkGray),
    sendInactiveColor: (0, _customAssistantConfigurationsColors.defaultDarkGray),
    equalizerColor: `${(0, _customAssistantConfigurationsColors.defaultDarkGray)},${(0, _customAssistantConfigurationsColors.defaultLightGray)}`,
    overallBackgroundColor: "#FFFFFFBF"
};
const browserLightStyle2 = {
    ...sharedLightStyle2Props,
    closeAssistantColor: (0, _hexToCssFilter.hexToCSSFilter)((0, _customAssistantConfigurationsColors.defaultLightGray)).filter,
    minimizeAssistantColor: (0, _hexToCssFilter.hexToCSSFilter)((0, _customAssistantConfigurationsColors.defaultLightGray)).filter,
    muteImageColor: (0, _hexToCssFilter.hexToCSSFilter)((0, _customAssistantConfigurationsColors.defaultLightGray)).filter,
    micActiveColor: (0, _hexToCssFilter.hexToCSSFilter)((0, _customAssistantConfigurationsColors.defaultBlue)).filter,
    sendActiveColor: (0, _hexToCssFilter.hexToCSSFilter)((0, _customAssistantConfigurationsColors.defaultBlue)).filter,
    sendInactiveColor: (0, _hexToCssFilter.hexToCSSFilter)((0, _customAssistantConfigurationsColors.defaultBlue)).filter,
    equalizerColor: "linear-gradient(180deg, #83ACE4 0%, rgba(128, 199, 175, 0) 100%), #8AD1B8"
};
const browserLightStyle2Minimal = {
    ...sharedLightStyle2MinimalProps,
    closeAssistantColor: (0, _hexToCssFilter.hexToCSSFilter)((0, _customAssistantConfigurationsColors.defaultLightGray)).filter,
    minimizeAssistantColor: (0, _hexToCssFilter.hexToCSSFilter)((0, _customAssistantConfigurationsColors.defaultLightGray)).filter,
    muteImageColor: (0, _hexToCssFilter.hexToCSSFilter)((0, _customAssistantConfigurationsColors.defaultLightGray)).filter,
    micActiveColor: (0, _hexToCssFilter.hexToCSSFilter)((0, _customAssistantConfigurationsColors.defaultBlue)).filter,
    keyboardColor: (0, _hexToCssFilter.hexToCSSFilter)((0, _customAssistantConfigurationsColors.defaultBlue)).filter,
    sendActiveColor: (0, _hexToCssFilter.hexToCSSFilter)((0, _customAssistantConfigurationsColors.defaultBlue)).filter,
    sendInactiveColor: (0, _hexToCssFilter.hexToCSSFilter)((0, _customAssistantConfigurationsColors.defaultBlue)).filter,
    overallBackgroundColor: "#FFFFFFBF",
    partialSpeechResultTextColor: "#FFFFFF"
};
const mobileLightStyle2 = {
    ...sharedLightStyle2Props,
    closeAssistantColor: (0, _customAssistantConfigurationsColors.defaultLightGray),
    minimizeAssistantColor: (0, _customAssistantConfigurationsColors.defaultLightGray),
    muteImageColor: (0, _customAssistantConfigurationsColors.defaultLightGray),
    micActiveColor: (0, _customAssistantConfigurationsColors.defaultBlue),
    sendActiveColor: (0, _customAssistantConfigurationsColors.defaultBlue),
    sendInactiveColor: (0, _customAssistantConfigurationsColors.defaultBlue),
    equalizerColor: "#83ACE4,#80c7af00,#8AD1B8"
};
const mobileLightStyle2Minimal = {
    ...sharedLightStyle2MinimalProps,
    closeAssistantColor: (0, _customAssistantConfigurationsColors.defaultLightGray),
    minimizeAssistantColor: (0, _customAssistantConfigurationsColors.defaultLightGray),
    muteImageColor: (0, _customAssistantConfigurationsColors.defaultLightGray),
    micActiveColor: (0, _customAssistantConfigurationsColors.defaultBlue),
    keyboardColor: (0, _customAssistantConfigurationsColors.defaultBlue),
    sendActiveColor: (0, _customAssistantConfigurationsColors.defaultBlue),
    sendInactiveColor: (0, _customAssistantConfigurationsColors.defaultBlue),
    equalizerColor: "#83ACE4,#80c7af00,#8AD1B8",
    overallBackgroundColor: "#FFFFFFBF"
};
const browserDarkStyle1 = {
    ...sharedDarkStyle1Props,
    closeAssistantColor: (0, _hexToCssFilter.hexToCSSFilter)((0, _customAssistantConfigurationsColors.defaultWhite)).filter,
    minimizeAssistantColor: (0, _hexToCssFilter.hexToCSSFilter)((0, _customAssistantConfigurationsColors.defaultWhite)).filter,
    muteImageColor: (0, _hexToCssFilter.hexToCSSFilter)((0, _customAssistantConfigurationsColors.defaultWhite)).filter,
    micActiveColor: (0, _hexToCssFilter.hexToCSSFilter)((0, _customAssistantConfigurationsColors.defaultWhite)).filter,
    sendActiveColor: (0, _hexToCssFilter.hexToCSSFilter)((0, _customAssistantConfigurationsColors.defaultWhite)).filter,
    sendInactiveColor: (0, _hexToCssFilter.hexToCSSFilter)((0, _customAssistantConfigurationsColors.defaultWhite)).filter,
    overallBackgroundColor: "linear-gradient(180deg, #444A50 0%, #8F9CA7 100%)",
    equalizerColor: "linear-gradient(215.1deg, rgba(255, 255, 255, 0.7) 20.69%, rgba(255, 255, 255, 0.7) 95.73%)"
};
const browserDarkStyle1Minimal = {
    ...sharedDarkStyle1MinimalProps,
    closeAssistantColor: (0, _hexToCssFilter.hexToCSSFilter)((0, _customAssistantConfigurationsColors.defaultWhite)).filter,
    minimizeAssistantColor: (0, _hexToCssFilter.hexToCSSFilter)((0, _customAssistantConfigurationsColors.defaultWhite)).filter,
    muteImageColor: (0, _hexToCssFilter.hexToCSSFilter)((0, _customAssistantConfigurationsColors.defaultWhite)).filter,
    micActiveColor: (0, _hexToCssFilter.hexToCSSFilter)((0, _customAssistantConfigurationsColors.defaultWhite)).filter,
    keyboardColor: "brightness(0) invert(1);",
    sendActiveColor: (0, _hexToCssFilter.hexToCSSFilter)((0, _customAssistantConfigurationsColors.defaultDarkGray)).filter,
    sendInactiveColor: (0, _hexToCssFilter.hexToCSSFilter)((0, _customAssistantConfigurationsColors.defaultDarkGray)).filter,
    overallBackgroundColor: "#00000080"
};
const mobileDarkStyle1 = {
    ...sharedDarkStyle1Props,
    closeAssistantColor: (0, _customAssistantConfigurationsColors.defaultWhite),
    minimizeAssistantColor: (0, _customAssistantConfigurationsColors.defaultWhite),
    muteImageColor: (0, _customAssistantConfigurationsColors.defaultWhite),
    micActiveColor: (0, _customAssistantConfigurationsColors.defaultWhite),
    keyboardColor: (0, _customAssistantConfigurationsColors.defaultWhite),
    sendActiveColor: (0, _customAssistantConfigurationsColors.defaultWhite),
    sendInactiveColor: (0, _customAssistantConfigurationsColors.defaultWhite),
    overallBackgroundColor: "#444A50,#8F9CA7",
    equalizerColor: "#ffffffb3,#ffffffb3"
};
const mobileDarkStyle1Minimal = {
    ...sharedDarkStyle1MinimalProps,
    closeAssistantColor: (0, _customAssistantConfigurationsColors.defaultWhite),
    minimizeAssistantColor: (0, _customAssistantConfigurationsColors.defaultWhite),
    muteImageColor: (0, _customAssistantConfigurationsColors.defaultWhite),
    micActiveColor: (0, _customAssistantConfigurationsColors.defaultWhite),
    keyboardColor: (0, _customAssistantConfigurationsColors.defaultWhite),
    sendActiveColor: (0, _customAssistantConfigurationsColors.defaultDarkGray),
    sendInactiveColor: (0, _customAssistantConfigurationsColors.defaultDarkGray),
    overallBackgroundColor: "#444A50,#8F9CA7",
    equalizerColor: "#ffffffb3,#ffffffb3"
};
const browserDarkStyle2 = {
    ...sharedDarkStyle2Props,
    closeAssistantColor: (0, _hexToCssFilter.hexToCSSFilter)((0, _customAssistantConfigurationsColors.defaultWhite)).filter,
    minimizeAssistantColor: (0, _hexToCssFilter.hexToCSSFilter)((0, _customAssistantConfigurationsColors.defaultWhite)).filter,
    muteImageColor: (0, _hexToCssFilter.hexToCSSFilter)((0, _customAssistantConfigurationsColors.defaultWhite)).filter,
    micActiveColor: (0, _hexToCssFilter.hexToCSSFilter)((0, _customAssistantConfigurationsColors.defaultWhite)).filter,
    sendActiveColor: (0, _hexToCssFilter.hexToCSSFilter)((0, _customAssistantConfigurationsColors.defaultWhite)).filter,
    sendInactiveColor: (0, _hexToCssFilter.hexToCSSFilter)((0, _customAssistantConfigurationsColors.defaultWhite)).filter,
    overallBackgroundColor: "linear-gradient(180deg, #202C36 0%, #3E77A5 100%)",
    equalizerColor: "linear-gradient(215.1deg, rgba(255, 255, 255, 0.7) 20.69%, rgba(255, 255, 255, 0.7) 95.73%)"
};
const browserDarkStyle2Minimal = {
    ...sharedDarkStyle2MinimalProps,
    closeAssistantColor: (0, _hexToCssFilter.hexToCSSFilter)((0, _customAssistantConfigurationsColors.defaultWhite)).filter,
    minimizeAssistantColor: (0, _hexToCssFilter.hexToCSSFilter)((0, _customAssistantConfigurationsColors.defaultWhite)).filter,
    muteImageColor: (0, _hexToCssFilter.hexToCSSFilter)((0, _customAssistantConfigurationsColors.defaultWhite)).filter,
    micActiveColor: (0, _hexToCssFilter.hexToCSSFilter)((0, _customAssistantConfigurationsColors.defaultWhite)).filter,
    keyboardColor: "brightness(0) invert(1);",
    sendActiveColor: (0, _hexToCssFilter.hexToCSSFilter)((0, _customAssistantConfigurationsColors.defaultDarkGray)).filter,
    sendInactiveColor: (0, _hexToCssFilter.hexToCSSFilter)((0, _customAssistantConfigurationsColors.defaultDarkGray)).filter,
    overallBackgroundColor: "#00000080"
};
const mobileDarkStyle2 = {
    ...sharedDarkStyle2Props,
    closeAssistantColor: (0, _customAssistantConfigurationsColors.defaultWhite),
    minimizeAssistantColor: (0, _customAssistantConfigurationsColors.defaultWhite),
    muteImageColor: (0, _customAssistantConfigurationsColors.defaultWhite),
    micActiveColor: (0, _customAssistantConfigurationsColors.defaultWhite),
    keyboardColor: (0, _customAssistantConfigurationsColors.defaultWhite),
    sendActiveColor: (0, _customAssistantConfigurationsColors.defaultWhite),
    sendInactiveColor: (0, _customAssistantConfigurationsColors.defaultWhite),
    overallBackgroundColor: "#202C36,#3E77A5",
    equalizerColor: "#ffffffb3,#ffffffb3"
};
const mobileDarkStyle2Minimal = {
    ...sharedDarkStyle2MinimalProps,
    closeAssistantColor: (0, _customAssistantConfigurationsColors.defaultWhite),
    minimizeAssistantColor: (0, _customAssistantConfigurationsColors.defaultWhite),
    muteImageColor: (0, _customAssistantConfigurationsColors.defaultWhite),
    micActiveColor: (0, _customAssistantConfigurationsColors.defaultWhite),
    keyboardColor: (0, _customAssistantConfigurationsColors.defaultWhite),
    sendActiveColor: (0, _customAssistantConfigurationsColors.defaultDarkGray),
    sendInactiveColor: (0, _customAssistantConfigurationsColors.defaultDarkGray),
    overallBackgroundColor: "#202C36,#3E77A5",
    equalizerColor: "#ffffffb3,#ffffffb3"
};
const browserDefaultStyle = {
    ...sharedDefaultStyleProps,
    closeAssistantColor: (0, _hexToCssFilter.hexToCSSFilter)((0, _customAssistantConfigurationsColors.defaultLightGray)).filter,
    minimizeAssistantColor: (0, _hexToCssFilter.hexToCSSFilter)((0, _customAssistantConfigurationsColors.defaultLightGray)).filter,
    muteImageColor: (0, _hexToCssFilter.hexToCSSFilter)((0, _customAssistantConfigurationsColors.defaultLightGray)).filter,
    micActiveColor: (0, _hexToCssFilter.hexToCSSFilter)((0, _customAssistantConfigurationsColors.defaultDarkGray)).filter,
    sendActiveColor: (0, _hexToCssFilter.hexToCSSFilter)((0, _customAssistantConfigurationsColors.defaultDarkGray)).filter,
    sendInactiveColor: (0, _hexToCssFilter.hexToCSSFilter)((0, _customAssistantConfigurationsColors.defaultDarkGray)).filter,
    equalizerColor: `linear-gradient(180deg, ${(0, _customAssistantConfigurationsColors.defaultDarkGray)} 0%, ${(0, _customAssistantConfigurationsColors.defaultLightGray)} 100%)`
};
const browserDefaultStyleMinimal = {
    ...sharedDefaultStyleMinimalProps,
    closeAssistantColor: (0, _hexToCssFilter.hexToCSSFilter)((0, _customAssistantConfigurationsColors.defaultLightGray)).filter,
    minimizeAssistantColor: (0, _hexToCssFilter.hexToCSSFilter)((0, _customAssistantConfigurationsColors.defaultLightGray)).filter,
    muteImageColor: (0, _hexToCssFilter.hexToCSSFilter)((0, _customAssistantConfigurationsColors.defaultLightGray)).filter,
    micActiveColor: (0, _hexToCssFilter.hexToCSSFilter)((0, _customAssistantConfigurationsColors.defaultDarkGray)).filter,
    keyboardColor: (0, _hexToCssFilter.hexToCSSFilter)((0, _customAssistantConfigurationsColors.defaultDarkGray)).filter,
    sendActiveColor: (0, _hexToCssFilter.hexToCSSFilter)((0, _customAssistantConfigurationsColors.defaultDarkGray)).filter,
    sendInactiveColor: (0, _hexToCssFilter.hexToCSSFilter)((0, _customAssistantConfigurationsColors.defaultDarkGray)).filter,
    overallBackgroundColor: "#FFFFFFBF",
    partialSpeechResultTextColor: "#FFFFFF"
};
const mobileDefaultStyle = {
    ...sharedDefaultStyleProps,
    closeAssistantColor: (0, _customAssistantConfigurationsColors.defaultLightGray),
    minimizeAssistantColor: (0, _customAssistantConfigurationsColors.defaultLightGray),
    muteImageColor: (0, _customAssistantConfigurationsColors.defaultLightGray),
    micActiveColor: (0, _customAssistantConfigurationsColors.defaultDarkGray),
    keyboardColor: (0, _customAssistantConfigurationsColors.defaultDarkGray),
    sendActiveColor: (0, _customAssistantConfigurationsColors.defaultDarkGray),
    sendInactiveColor: (0, _customAssistantConfigurationsColors.defaultDarkGray),
    equalizerColor: `${(0, _customAssistantConfigurationsColors.defaultDarkGray)},${(0, _customAssistantConfigurationsColors.defaultLightGray)}`
};

},{"hex-to-css-filter":"aRUNx","../colors":"1p3OR","./customAssistantConfigurationsColors":"jOo9r","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"aRUNx":[function(require,module,exports) {
(function(global, factory) {
    factory(exports);
})(this, function(exports1) {
    "use strict";
    /*! *****************************************************************************
    Copyright (c) Microsoft Corporation.

    Permission to use, copy, modify, and/or distribute this software for any
    purpose with or without fee is hereby granted.

    THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
    REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
    AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
    INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
    LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
    OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
    PERFORMANCE OF THIS SOFTWARE.
    ***************************************************************************** */ function __read(o, n) {
        var m = typeof Symbol === "function" && o[Symbol.iterator];
        if (!m) return o;
        var i = m.call(o), r, ar = [], e;
        try {
            while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
        } catch (error) {
            e = {
                error: error
            };
        } finally{
            try {
                if (r && !r.done && (m = i["return"])) m.call(i);
            } finally{
                if (e) throw e.error;
            }
        }
        return ar;
    }
    var Color = /** @class */ function() {
        function Color(r, g, b) {
            this.r = 0;
            this.g = 0;
            this.b = 0;
            this.set(r, g, b);
        }
        Color.prototype.set = function(r, g, b) {
            this.r = this.clamp(r);
            this.g = this.clamp(g);
            this.b = this.clamp(b);
        };
        /**
         * Applying cals to get CSS filter for hue-rotate
         *
         * @param {number} [angle=0]
         * @memberof Color
         */ Color.prototype.hueRotate = function(angle) {
            if (angle === void 0) angle = 0;
            angle = angle / 180 * Math.PI;
            var sin = Math.sin(angle);
            var cos = Math.cos(angle);
            this.multiply([
                0.213 + cos * 0.787 - sin * 0.213,
                0.715 - cos * 0.715 - sin * 0.715,
                0.072 - cos * 0.072 + sin * 0.928,
                0.213 - cos * 0.213 + sin * 0.143,
                0.715 + cos * 0.285 + sin * 0.14,
                0.072 - cos * 0.072 - sin * 0.283,
                0.213 - cos * 0.213 - sin * 0.787,
                0.715 - cos * 0.715 + sin * 0.715,
                0.072 + cos * 0.928 + sin * 0.072
            ]);
        };
        /**
         * Applying cals to get CSS filter for grayscale
         *
         * @param {number} [value=1]
         * @memberof Color
         */ Color.prototype.grayscale = function(value) {
            if (value === void 0) value = 1;
            this.multiply([
                0.2126 + 0.7874 * (1 - value),
                0.7152 - 0.7152 * (1 - value),
                0.0722 - 0.0722 * (1 - value),
                0.2126 - 0.2126 * (1 - value),
                0.7152 + 0.2848 * (1 - value),
                0.0722 - 0.0722 * (1 - value),
                0.2126 - 0.2126 * (1 - value),
                0.7152 - 0.7152 * (1 - value),
                0.0722 + 0.9278 * (1 - value)
            ]);
        };
        /**
         * Applying cals to get CSS filter for sepia
         *
         * @param {number} [value=1]
         * @memberof Color
         */ Color.prototype.sepia = function(value) {
            if (value === void 0) value = 1;
            this.multiply([
                0.393 + 0.607 * (1 - value),
                0.769 - 0.769 * (1 - value),
                0.189 - 0.189 * (1 - value),
                0.349 - 0.349 * (1 - value),
                0.686 + 0.314 * (1 - value),
                0.168 - 0.168 * (1 - value),
                0.272 - 0.272 * (1 - value),
                0.534 - 0.534 * (1 - value),
                0.131 + 0.869 * (1 - value)
            ]);
        };
        /**
         * Applying cals to get CSS filter for saturate
         *
         * @param {number} [value=1]
         * @memberof Color
         */ Color.prototype.saturate = function(value) {
            if (value === void 0) value = 1;
            this.multiply([
                0.213 + 0.787 * value,
                0.715 - 0.715 * value,
                0.072 - 0.072 * value,
                0.213 - 0.213 * value,
                0.715 + 0.285 * value,
                0.072 - 0.072 * value,
                0.213 - 0.213 * value,
                0.715 - 0.715 * value,
                0.072 + 0.928 * value
            ]);
        };
        Color.prototype.multiply = function(matrix) {
            // These values are needed. It's correct because the returned values will change
            var newR = this.clamp(this.r * matrix[0] + this.g * matrix[1] + this.b * matrix[2]);
            var newG = this.clamp(this.r * matrix[3] + this.g * matrix[4] + this.b * matrix[5]);
            var newB = this.clamp(this.r * matrix[6] + this.g * matrix[7] + this.b * matrix[8]);
            this.r = newR;
            this.g = newG;
            this.b = newB;
        };
        /**
         * Applying cals to get CSS filter for brightness
         *
         * @param {number} [value=1]
         * @memberof Color
         */ Color.prototype.brightness = function(value) {
            if (value === void 0) value = 1;
            this.linear(value);
        };
        /**
         * Applying cals to get CSS filter for contrast
         *
         * @param {number} [value=1]
         * @memberof Color
         */ Color.prototype.contrast = function(value) {
            if (value === void 0) value = 1;
            this.linear(value, -(0.5 * value) + 0.5);
        };
        Color.prototype.linear = function(slope, intercept) {
            if (slope === void 0) slope = 1;
            if (intercept === void 0) intercept = 0;
            this.r = this.clamp(this.r * slope + intercept * 255);
            this.g = this.clamp(this.g * slope + intercept * 255);
            this.b = this.clamp(this.b * slope + intercept * 255);
        };
        /**
         * Applying cals to get CSS filter for invert
         *
         * @param {number} [value=1]
         * @memberof Color
         */ Color.prototype.invert = function(value) {
            if (value === void 0) value = 1;
            this.r = this.clamp((value + this.r / 255 * (1 - 2 * value)) * 255);
            this.g = this.clamp((value + this.g / 255 * (1 - 2 * value)) * 255);
            this.b = this.clamp((value + this.b / 255 * (1 - 2 * value)) * 255);
        };
        /**
         * transform RGB into HSL values
         *
         * @returns {HSLData}
         * @memberof Color
         */ Color.prototype.hsl = function() {
            var red = this.r / 255;
            var green = this.g / 255;
            var blue = this.b / 255;
            // find greatest and smallest channel values
            var max = Math.max(red, green, blue);
            var min = Math.min(red, green, blue);
            var hue = 0;
            var saturation = 0;
            var lightness = (max + min) / 2;
            // If min and max have the same values, it means
            // the given color is achromatic
            if (max === min) return {
                h: 0,
                s: 0,
                l: lightness * 100
            };
            // Adding delta value of greatest and smallest channel values
            var delta = max - min;
            saturation = lightness > 0.5 ? delta / (2 - max - min) : delta / (max + min);
            if (max === red) hue = (green - blue) / delta + (green < blue ? 6 : 0);
            else if (max === green) hue = (blue - red) / delta + 2;
            else if (max === blue) hue = (red - green) / delta + 4;
            hue /= 6;
            return {
                h: hue * 100,
                s: saturation * 100,
                l: lightness * 100
            };
        };
        /**
         * Normalize the value to follow the min and max for RGB colors
         * min: 0
         * max: 255
         *
         * @private
         * @param {number} value
         * @returns {number}
         * @memberof Color
         */ Color.prototype.clamp = function(value) {
            // Minimum RGB Value = 0;
            // Maximum RGB Value = 255;
            return Math.min(Math.max(value, 0), 255);
        };
        return Color;
    }();
    var Solver = /** @class */ function() {
        function Solver(target, options) {
            this.target = target;
            this.targetHSL = target.hsl();
            this.options = Object.assign({}, // Adding default values for options
            {
                acceptanceLossPercentage: 5,
                maxChecks: 15
            }, options);
            // All the calcs done by the library to generate
            // a CSS Filter are based on the color `#000`
            // in this case, `rgb(0, 0, 0)`
            // Please make sure the background of the element
            // is `#000` for better performance
            // and color similarity.
            this.reusedColor = new Color(0, 0, 0);
        }
        /**
         * Returns the solved values for the
         *
         * @returns {(SPSAPayload & { filter: string; })}
         * @memberof Solver
         */ Solver.prototype.solve = function() {
            var result = this.solveNarrow(this.solveWide());
            return {
                values: result.values,
                called: result.called,
                loss: result.loss,
                filter: this.css(result.values)
            };
        };
        /**
         * Solve wide values based on the wide values for RGB and HSL values
         *
         * @private
         * @returns {SPSAPayload}
         * @memberof Solver
         */ Solver.prototype.solveWide = function() {
            var A = 5;
            var c = 15;
            // Wide values for RGB and HSL values
            // the values in the order: [`r`, `g`, `b`, `h`, `s`, `l`]
            var a = [
                60,
                180,
                18000,
                600,
                1.2,
                1.2
            ];
            var best = {
                loss: Infinity
            };
            var counter = 0;
            while(best.loss > this.options.acceptanceLossPercentage){
                var initialFilterValues = [
                    50,
                    20,
                    3750,
                    50,
                    100,
                    100
                ];
                var result = this.spsa({
                    A: A,
                    a: a,
                    c: c,
                    values: initialFilterValues,
                    // for wide values we should use the double of tries in
                    // comparison of `solveNarrow()` method
                    maxTriesInLoop: 1000
                });
                if (result.loss < best.loss) best = result;
                counter += 1;
                if (counter >= this.options.maxChecks) break;
            }
            return Object.assign({}, best, {
                called: counter
            });
        };
        /**
         * Solve narrow values based on the wide values for the filter
         *
         * @private
         * @param {SPSAPayload} wide
         * @returns {SPSAPayload}
         * @memberof Solver
         */ Solver.prototype.solveNarrow = function(wide) {
            var A = wide.loss;
            var c = 2;
            var A1 = A + 1;
            // Narrow values for RGB and HSL values
            // the values in the order: [`r`, `g`, `b`, `h`, `s`, `l`]
            var a = [
                0.25 * A1,
                0.25 * A1,
                A1,
                0.25 * A1,
                0.2 * A1,
                0.2 * A1
            ];
            return this.spsa({
                A: A,
                a: a,
                c: c,
                values: wide.values,
                maxTriesInLoop: 500,
                called: wide.called
            });
        };
        /**
         * Returns final value based on the current filter order
         * to get the order, please check the returned value
         * in `css()` method
         *
         * @private
         * @param {number} value
         * @param {number} idx
         * @returns {number}
         * @memberof Solver
         */ Solver.prototype.fixValueByFilterIDX = function(value, idx) {
            var max = 100;
            // Fixing max, minimum and value by filter
            if (idx === 2 /* saturate */ ) max = 7500;
            else if (idx === 4 /* brightness */  || idx === 5 /* contrast */ ) max = 200;
            if (idx === 3 /* hue-rotate */ ) {
                if (value > max) value %= max;
                else if (value < 0) value = max + value % max;
            } else if (value < 0) value = 0;
            else if (value > max) value = max;
            return value;
        };
        Solver.prototype.spsa = function(_a) {
            var A = _a.A, a = _a.a, c = _a.c, values = _a.values, _b = _a.maxTriesInLoop, maxTriesInLoop = _b === void 0 ? 500 : _b, _c = _a.called, called = _c === void 0 ? 0 : _c;
            var alpha = 1;
            var gamma = 0.16666666666666666;
            var best = null;
            var bestLoss = Infinity;
            var deltas = new Array(6);
            var highArgs = new Array(6);
            var lowArgs = new Array(6);
            // Size of all CSS filters to be applied to get the correct color
            var filtersToBeAppliedSize = 6;
            for(var key = 0; key < maxTriesInLoop; key++){
                var ck = c / Math.pow(key + 1, gamma);
                for(var i = 0; i < filtersToBeAppliedSize; i++){
                    deltas[i] = Math.random() > 0.5 ? 1 : -1;
                    highArgs[i] = values[i] + ck * deltas[i];
                    lowArgs[i] = values[i] - ck * deltas[i];
                }
                var lossDiff = this.loss(highArgs) - this.loss(lowArgs);
                for(var i = 0; i < filtersToBeAppliedSize; i++){
                    var g = lossDiff / (2 * ck) * deltas[i];
                    var ak = a[i] / Math.pow(A + key + 1, alpha);
                    values[i] = this.fixValueByFilterIDX(values[i] - ak * g, i);
                }
                var loss = this.loss(values);
                if (loss < bestLoss) {
                    best = values.slice(0);
                    bestLoss = loss;
                }
            }
            return {
                values: best,
                loss: bestLoss,
                called: called
            };
        };
        /**
         * Checks how much is the loss for the filter in RGB and HSL colors
         *
         * @private
         * @param {SPSAPayload['values']} filters
         * @returns {number}
         * @memberof Solver
         */ Solver.prototype.loss = function(filters) {
            // Argument as an Array of percentages.
            var color = this.reusedColor;
            // Resetting the color to black in case
            // it was called more than once
            color.set(0, 0, 0);
            color.invert(filters[0] / 100);
            color.sepia(filters[1] / 100);
            color.saturate(filters[2] / 100);
            color.hueRotate(filters[3] * 3.6);
            color.brightness(filters[4] / 100);
            color.contrast(filters[5] / 100);
            var colorHSL = color.hsl();
            return Math.abs(color.r - this.target.r) + Math.abs(color.g - this.target.g) + Math.abs(color.b - this.target.b) + Math.abs(colorHSL.h - this.targetHSL.h) + Math.abs(colorHSL.s - this.targetHSL.s) + Math.abs(colorHSL.l - this.targetHSL.l);
        };
        /**
         * Returns the CSS filter list for the received HEX color
         *
         * @private
         * @param {number[]} filters
         * @returns {string}
         * @memberof Solver
         */ Solver.prototype.css = function(filters) {
            var formatCssFilterValueByMultiplier = function(idx, multiplier) {
                if (multiplier === void 0) multiplier = 1;
                return Math.round(filters[idx] * multiplier);
            };
            return [
                "invert(" + formatCssFilterValueByMultiplier(0) + "%)",
                "sepia(" + formatCssFilterValueByMultiplier(1) + "%)",
                "saturate(" + formatCssFilterValueByMultiplier(2) + "%)",
                "hue-rotate(" + formatCssFilterValueByMultiplier(3, 3.6) + "deg)",
                "brightness(" + formatCssFilterValueByMultiplier(4) + "%)",
                "contrast(" + formatCssFilterValueByMultiplier(5) + "%);"
            ].join(" ");
        };
        return Solver;
    }();
    /**
     * Transform a CSS Color from Hexadecimal to RGB color
     *
     * @param {string} hex hexadecimal color
     * @returns {([number, number, number] | [])} array with the RGB colors or empty array
     */ var hexToRgb = function(hex) {
        if (hex.length === 4) return [
            parseInt("0x" + hex[1] + hex[1]),
            parseInt("0x" + hex[2] + hex[2]),
            parseInt("0x" + hex[3] + hex[3])
        ];
        if (hex.length === 7) return [
            parseInt("0x" + hex[1] + hex[2]),
            parseInt("0x" + hex[3] + hex[4]),
            parseInt("0x" + hex[5] + hex[6])
        ];
        return [];
    };
    var isNumeric = function(n) {
        return !isNaN(parseFloat(n)) && isFinite(n);
    };
    // Memory cache for the computed results to avoid multiple
    // calculations for the same color
    var results = {};
    /**
     * A function that transforms a HEX color into CSS filters
     *
     * @param colorValue string hexadecimal color
     * @param opts HexToCssConfiguration function configuration
     *
     */ var hexToCSSFilter = function(colorValue, opts) {
        var _a;
        if (opts === void 0) opts = {};
        var red;
        var green;
        var blue;
        if (results[colorValue] && !opts.forceFilterRecalculation) return Object.assign({}, results[colorValue], {
            cache: true
        });
        var color;
        try {
            _a = __read(hexToRgb(colorValue), 3), red = _a[0], green = _a[1], blue = _a[2];
            if (!isNumeric(red) || !isNumeric(green) || !isNumeric(blue)) throw new Error("hextToRgb returned an invalid value for '" + colorValue + "'");
            color = new Color(Number(red), Number(green), Number(blue));
        } catch (error) {
            throw new Error("Color value should be in HEX format. " + error);
        }
        var solver = new Solver(color, Object.assign({}, // `HexToCssConfiguration` Defaults
        {
            acceptanceLossPercentage: 5,
            maxChecks: 30,
            forceFilterRecalculation: false
        }, opts));
        return results[colorValue] = Object.assign({}, solver.solve(), {
            hex: colorValue,
            rgb: [
                red,
                green,
                blue
            ],
            cache: false
        });
    };
    /**
     * A function that clears cached results
     *
     * @param  {string} key? HEX string value passed previously `#24639C`. If not passed, it clears all cached results
     * @returns void
     */ var clearCache = function(key) {
        if (!key) results = {};
        else if (results[key]) delete results[key];
    };
    exports1.clearCache = clearCache;
    exports1.hexToCSSFilter = hexToCSSFilter;
    Object.defineProperty(exports1, "__esModule", {
        value: true
    });
});

},{}],"jOo9r":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "defaultBlue", ()=>defaultBlue);
parcelHelpers.export(exports, "defaultLightGray", ()=>defaultLightGray);
parcelHelpers.export(exports, "defaultDarkGray", ()=>defaultDarkGray);
parcelHelpers.export(exports, "defaultWhite", ()=>defaultWhite);
parcelHelpers.export(exports, "defaultOffWhite", ()=>defaultOffWhite);
parcelHelpers.export(exports, "defaultLightModeTextColor", ()=>defaultLightModeTextColor);
parcelHelpers.export(exports, "defaultDarkModeTextColor", ()=>defaultDarkModeTextColor);
parcelHelpers.export(exports, "defaultBlueHighlight", ()=>defaultBlueHighlight);
parcelHelpers.export(exports, "defaultGrayHighlight", ()=>defaultGrayHighlight);
parcelHelpers.export(exports, "transparent", ()=>transparent);
const defaultBlue = "#3E77A5";
const defaultLightGray = "#AAAAAA";
const defaultDarkGray = "#808080";
const defaultWhite = "#FFFFFF";
const defaultOffWhite = "#FFFFFFB2";
const defaultLightModeTextColor = "#8F97A1";
const defaultDarkModeTextColor = "#444444";
const defaultBlueHighlight = "#3E77A533";
const defaultGrayHighlight = "#80808033";
const transparent = "#00000000";

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"xTqnJ":[function(require,module,exports) {
var __filename = "node_modules/@voicify/voicify-browser-assistant-sdk/dist/index.js";
var $g5Y9E$marked = require("45c266e59932e429");
var $g5Y9E$crossfetch = require("c158f5a4da895c0f");
function $parcel$exportWildcard(dest, source) {
    Object.keys(source).forEach(function(key) {
        if (key === "default" || key === "__esModule" || dest.hasOwnProperty(key)) return;
        Object.defineProperty(dest, key, {
            enumerable: true,
            get: function get() {
                return source[key];
            }
        });
    });
    return dest;
}
function $parcel$defineInteropFlag(a) {
    Object.defineProperty(a, "__esModule", {
        value: true,
        configurable: true
    });
}
function $parcel$export(e, n, v, s) {
    Object.defineProperty(e, n, {
        get: v,
        set: s,
        enumerable: true,
        configurable: true
    });
}
function $parcel$interopDefault(a) {
    return a && a.__esModule ? a.default : a;
}
var $e03ffcafbfaf1a3e$exports = {};
$parcel$defineInteropFlag($e03ffcafbfaf1a3e$exports);
$parcel$export($e03ffcafbfaf1a3e$exports, "initializeVoicifyAssistant", ()=>$e03ffcafbfaf1a3e$export$f7efacc29c799bcc);
$parcel$export($e03ffcafbfaf1a3e$exports, "default", ()=>$e03ffcafbfaf1a3e$export$2e2bcd8739ae039);
var $174052f0970457c1$exports = {};
$parcel$export($174052f0970457c1$exports, "VoicifyAssistant", ()=>$174052f0970457c1$export$148d4fde09622661);
const $4b41e9819bbe1164$export$da15dd5ffd04fde3 = "voicifyEffectData";
const $4b41e9819bbe1164$export$fd17f511ad191b43 = "voicifyChatState";
const $4b41e9819bbe1164$export$efb3c37238d257ff = "voicifyChatHistory";
const $4b41e9819bbe1164$export$4021711600a99bf = "voicifyUserState";
const $4b41e9819bbe1164$export$dcb09b12943efe58 = "voicifyAfterEffectData";
const $4b41e9819bbe1164$export$4f565a209e2bfbdd = "voicifyAfterResponseData";
const $0aad6105f1eb8dfb$export$9998e8b770869dd4 = (requestBody, url)=>{
    return $parcel$interopDefault($g5Y9E$crossfetch)(url, {
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify(requestBody)
    });
};
const $2b1094d8e20ed12f$export$ebe80008247bee1 = (baseUrl, ttsProvider)=>{
    return `${baseUrl}/api/Ssml/toSpeech/${ttsProvider}`;
};
const $2b1094d8e20ed12f$export$6d894658e584f2ac = (baseUrl, sessionId, appId, appKey)=>{
    return `${baseUrl}/api/UserProfile/session/${sessionId}?applicationId=${appId}&applicationSecret=${appKey}`;
};
const $2b1094d8e20ed12f$export$131dff79d1fdc31f = (baseUrl, userId, appId, appKey)=>{
    return `${baseUrl}/api/UserProfile/${userId}?applicationId=${appId}&applicationSecret=${appKey}`;
};
const $2b1094d8e20ed12f$export$30c8d1ab699d63a9 = (baseUrl, configurationId, appId, appKey)=>{
    return `${baseUrl}/api/CustomAssistantConfiguration/${configurationId}/JavaScript?applicationId=${appId}&applicationSecret=${appKey}`;
};
const $6a0390b72c02f22d$export$3f90b926bc531097 = (baseUrl, userId, appId, appKey)=>{
    return $parcel$interopDefault($g5Y9E$crossfetch)($2b1094d8e20ed12f$export$131dff79d1fdc31f(baseUrl, userId, appId, appKey), {
        method: "GET",
        headers: {
            "Content-Type": "application/json"
        }
    });
};
const $e00ce1711940a61c$export$9462a73d39ebf452 = ()=>{
    var str = localStorage.getItem($4b41e9819bbe1164$export$dcb09b12943efe58);
    if (str) {
        var arr = JSON.parse(str);
        return arr;
    }
    return [];
};
const $e00ce1711940a61c$export$5ec8f248f9c9fd1c = (contexts)=>{
    const effectData = JSON.stringify(contexts);
    localStorage.setItem($4b41e9819bbe1164$export$dcb09b12943efe58, effectData);
};
const $e00ce1711940a61c$export$bfad21fd753357d6 = (context)=>{
    const arr = $e00ce1711940a61c$export$9462a73d39ebf452();
    const newArr = [
        ...arr,
        context
    ];
    $e00ce1711940a61c$export$5ec8f248f9c9fd1c(newArr);
};
const $e00ce1711940a61c$export$5f760f179a06cf01 = ()=>{
    return localStorage.getItem($4b41e9819bbe1164$export$da15dd5ffd04fde3);
};
const $e00ce1711940a61c$export$885899f8df83f1ca = (data)=>{
    const effectData = JSON.stringify(data);
    localStorage.setItem($4b41e9819bbe1164$export$da15dd5ffd04fde3, effectData);
};
const $e00ce1711940a61c$export$b2206d889512385b = ()=>{
    var str = localStorage.getItem($4b41e9819bbe1164$export$4f565a209e2bfbdd);
    if (str) {
        var arr = JSON.parse(str);
        return arr;
    }
    return [];
};
const $e00ce1711940a61c$export$6bbd431d88a3a0e9 = (afterResponseEffects)=>{
    const effectData = JSON.stringify(afterResponseEffects);
    localStorage.setItem($4b41e9819bbe1164$export$4f565a209e2bfbdd, effectData);
};
const $e00ce1711940a61c$export$dff7126b12f11ee4 = (data, propertyName, defaultValue)=>{
    if (data.hasOwnProperty(propertyName)) return data[propertyName];
    else return defaultValue;
};
const $e00ce1711940a61c$export$9acb288046f38a2b = (effectName, inRequestContext, inData)=>{
    var afterResponseEffects = $e00ce1711940a61c$export$b2206d889512385b();
    afterResponseEffects.push({
        data: inData,
        effect: effectName,
        requestContext: inRequestContext
    });
    $e00ce1711940a61c$export$6bbd431d88a3a0e9(afterResponseEffects);
};
const $e00ce1711940a61c$export$4c8b7dade296602f = (elementId, elementName, querySelector)=>{
    let element = null;
    if (elementId) element = document.getElementById(elementId);
    if (elementName && !element) {
        const elements = document.getElementsByName(elementId);
        if (elements?.length) element = elements[0];
    }
    if (querySelector && !element) element = document.querySelector(querySelector);
    return element;
};
const $e00ce1711940a61c$export$e772c8ff12451969 = async (ms)=>{
    await new Promise((r)=>setTimeout(r, ms));
};
const $309b0adb7eb516b2$export$710d58bcf60f615f = async (data)=>{
    var newTab = $e00ce1711940a61c$export$dff7126b12f11ee4(data, "openInNewTab", true);
    var url = $e00ce1711940a61c$export$dff7126b12f11ee4(data, "url", null);
    var fireAfterMilliseconds = $e00ce1711940a61c$export$dff7126b12f11ee4(data, "fireAfterMilliseconds", 0);
    if (url) {
        await $e00ce1711940a61c$export$e772c8ff12451969(fireAfterMilliseconds);
        if (newTab) window.open(url, "_blank");
        else window.location.href = url;
    }
};
const $309b0adb7eb516b2$export$fbc0a89cf1af6995 = async (data, requestContext, afterResponseEffect = false)=>{
    var fireBefore = $e00ce1711940a61c$export$dff7126b12f11ee4(data, "fireBeforeTextToSpeech", true);
    var newTab = $e00ce1711940a61c$export$dff7126b12f11ee4(data, "openInNewTab", true);
    if (fireBefore && !afterResponseEffect && requestContext.textToSpeechEnabled) $e00ce1711940a61c$export$bfad21fd753357d6(requestContext);
    if (fireBefore || afterResponseEffect) {
        await $309b0adb7eb516b2$export$710d58bcf60f615f(data);
        return !newTab;
    } else {
        $e00ce1711940a61c$export$9acb288046f38a2b("navigateWeb", requestContext, data);
        return false;
    }
};
const $9387f0261fd2ee30$export$111589e92a18c93 = async (data, requestContext)=>{
    var fireAfterMilliseconds = $e00ce1711940a61c$export$dff7126b12f11ee4(data, "fireAfterMilliseconds", 0);
    const element = document.getElementById(requestContext.assistantElementRootId);
    if (element) {
        const button = element?.shadowRoot?.getElementById("voicify-assistant-close-button-id");
        if (button) {
            await $e00ce1711940a61c$export$e772c8ff12451969(fireAfterMilliseconds);
            button.click();
        }
    }
};
const $9387f0261fd2ee30$export$7cd9277037e9ef95 = async (data, requestContext, afterResponseEffect = false)=>{
    var fireBefore = $e00ce1711940a61c$export$dff7126b12f11ee4(data, "fireBeforeTextToSpeech", true);
    if (fireBefore || afterResponseEffect) {
        await $9387f0261fd2ee30$export$111589e92a18c93(data, requestContext);
        return true;
    } else {
        $e00ce1711940a61c$export$9acb288046f38a2b("closeAssistant", requestContext, data);
        return false;
    }
};
const $325491c6629bcd5d$export$b4fc115e82ae5b38 = async (data)=>{
    const fireAfterMilliseconds = $e00ce1711940a61c$export$dff7126b12f11ee4(data, "fireAfterMilliseconds", 0);
    const elementId = $e00ce1711940a61c$export$dff7126b12f11ee4(data, "elementId", null);
    const elementName = $e00ce1711940a61c$export$dff7126b12f11ee4(data, "elementName", null);
    const querySelector = $e00ce1711940a61c$export$dff7126b12f11ee4(data, "querySelector", null);
    if (elementId || elementName || querySelector) {
        const element = $e00ce1711940a61c$export$4c8b7dade296602f(elementId, elementName, querySelector);
        if (element) {
            await $e00ce1711940a61c$export$e772c8ff12451969(fireAfterMilliseconds);
            if (element) element.click();
        }
    }
};
const $325491c6629bcd5d$export$64f981a079c4d482 = async (data, requestContext, afterResponseEffect = false)=>{
    var fireBefore = $e00ce1711940a61c$export$dff7126b12f11ee4(data, "fireBeforeTextToSpeech", true);
    if (fireBefore || afterResponseEffect) {
        await $325491c6629bcd5d$export$b4fc115e82ae5b38(data);
        return true;
    } else {
        $e00ce1711940a61c$export$9acb288046f38a2b("clickTap", requestContext, data);
        return false;
    }
};
const $8d118bb9fff18fd0$export$8ed99a7f74175211 = async (data)=>{
    const fireAfterMilliseconds = $e00ce1711940a61c$export$dff7126b12f11ee4(data, "fireAfterMilliseconds", 0);
    const elementId = $e00ce1711940a61c$export$dff7126b12f11ee4(data, "elementId", null);
    const elementName = $e00ce1711940a61c$export$dff7126b12f11ee4(data, "elementName", null);
    const querySelector = $e00ce1711940a61c$export$dff7126b12f11ee4(data, "querySelector", null);
    if (elementId || elementName || querySelector) {
        const element = $e00ce1711940a61c$export$4c8b7dade296602f(elementId, elementName, querySelector);
        if (element) {
            await $e00ce1711940a61c$export$e772c8ff12451969(fireAfterMilliseconds);
            if (element) element.scrollIntoView();
        }
    }
};
const $8d118bb9fff18fd0$export$81e9c5ea40ccb9cc = async (data, requestContext, afterResponseEffect = false)=>{
    var fireBefore = $e00ce1711940a61c$export$dff7126b12f11ee4(data, "fireBeforeTextToSpeech", true);
    if (fireBefore || afterResponseEffect) {
        await $8d118bb9fff18fd0$export$8ed99a7f74175211(data);
        return false;
    } else {
        $e00ce1711940a61c$export$9acb288046f38a2b("scrollTo", requestContext, data);
        return false;
    }
};
class $174052f0970457c1$export$148d4fde09622661 {
    constructor(settings, ttsProvider, sttProvider, rootId = "voicifyAssistantRoot"){
        this.errorHandlers = [];
        this.effectHandlers = [];
        this.requestStartedHandlers = [];
        this.responseHandlers = [];
        this.audioHandlers = [];
        this.videoHandlers = [];
        this.speechToTextProvider = sttProvider;
        this.textToSpeechProvider = ttsProvider;
        this.settings = settings;
        this.shouldSendWelcome = settings.initializeWithWelcomeMessage;
        this.assistantElementRootId = rootId;
        this.effectHandlers = [
            {
                effect: "navigateWeb",
                callbacks: [
                    $309b0adb7eb516b2$export$fbc0a89cf1af6995
                ]
            },
            {
                effect: "clickTap",
                callbacks: [
                    $325491c6629bcd5d$export$64f981a079c4d482
                ]
            },
            {
                effect: "scrollTo",
                callbacks: [
                    $8d118bb9fff18fd0$export$81e9c5ea40ccb9cc
                ]
            },
            {
                effect: "closeAssistant",
                callbacks: [
                    $9387f0261fd2ee30$export$7cd9277037e9ef95
                ]
            }
        ];
        this.playAfterEffectResponses();
    }
    async playAfterEffectResponses() {
        const afterEffects = $e00ce1711940a61c$export$9462a73d39ebf452();
        $e00ce1711940a61c$export$5ec8f248f9c9fd1c([]);
        if (afterEffects?.length) for(let i = 0; i < afterEffects.length; ++i){
            const requestContext = afterEffects[i];
            await this.handleCustomAssistantResponse(requestContext.request, requestContext.response, false);
        }
    }
    isExistingSession() {
        const localStorage1 = this.getLocalStorageChatState();
        if (localStorage1) {
            const localStorageChatState = JSON.parse(localStorage1);
            const lastInteractionDate = new Date(localStorageChatState.lastInteractionDate);
            const sessionTime = new Date(Date.now() - this.settings.sessionTimeout);
            if (lastInteractionDate.getTime() >= sessionTime.getTime()) return true;
            else return false;
        } else return false;
    }
    initializeExistingSession(handleSpeechTimeout = ()=>{}) {
        const chatState = this.getLocalStorageChatState();
        if (chatState) {
            this.shouldSendWelcome = false;
            this.initializeAndStart(handleSpeechTimeout);
            const sessionId = JSON.parse(chatState).sessionId;
            this.sessionId = sessionId;
        }
        const userState = this.getLocalStorageUserState();
        if (userState) {
            const userId = JSON.parse(userState).userId;
            this.userId = userId;
        }
    }
    getLocalStorageEffectData() {
        return $e00ce1711940a61c$export$5f760f179a06cf01();
    }
    setLocalStorageEffectData(data) {
        return $e00ce1711940a61c$export$885899f8df83f1ca(data);
    }
    getLocalStorageAfterResponseData() {
        return $e00ce1711940a61c$export$b2206d889512385b();
    }
    setLocalStorageAfterResponseData(afterEffects) {
        $e00ce1711940a61c$export$6bbd431d88a3a0e9(afterEffects);
    }
    getLocalStorageChatState() {
        return localStorage.getItem($4b41e9819bbe1164$export$fd17f511ad191b43);
    }
    getLocalStorageUserState() {
        return localStorage.getItem($4b41e9819bbe1164$export$4021711600a99bf);
    }
    setLocalStorageChatState(chatStateItem) {
        const chatState = JSON.stringify(chatStateItem);
        localStorage.setItem($4b41e9819bbe1164$export$fd17f511ad191b43, chatState);
    }
    setLocalStorageUserState(userState) {
        const userStateStr = JSON.stringify(userState);
        localStorage.setItem($4b41e9819bbe1164$export$4021711600a99bf, userStateStr);
    }
    recordChatHistoryItem(chatHistoryItem) {
        let chatHistory = this.getChatHistoryItems();
        chatHistory.push(chatHistoryItem);
        localStorage.setItem($4b41e9819bbe1164$export$efb3c37238d257ff, JSON.stringify(chatHistory));
    }
    getChatHistoryItems() {
        const localStorageChatHistory = localStorage.getItem($4b41e9819bbe1164$export$efb3c37238d257ff);
        if (localStorageChatHistory) return JSON.parse(localStorageChatHistory);
        else return [];
    }
    clearChatHistory() {
        localStorage.removeItem($4b41e9819bbe1164$export$efb3c37238d257ff);
    }
    clearAllLocalStorage() {
        localStorage.removeItem($4b41e9819bbe1164$export$efb3c37238d257ff);
        localStorage.removeItem($4b41e9819bbe1164$export$fd17f511ad191b43);
        localStorage.removeItem($4b41e9819bbe1164$export$da15dd5ffd04fde3);
    }
    endSession() {
        localStorage.removeItem($4b41e9819bbe1164$export$efb3c37238d257ff);
        localStorage.removeItem($4b41e9819bbe1164$export$fd17f511ad191b43);
        localStorage.removeItem($4b41e9819bbe1164$export$da15dd5ffd04fde3);
        this.shouldSendWelcome = this.settings.initializeWithWelcomeMessage;
    }
    clearSpeechTimeout() {
        clearTimeout(this.timeout);
        this.timeout = undefined;
    }
    initializeAndStart(handleSpeechTimeout = ()=>{}) {
        this.speechToTextProvider?.clearHandlers();
        this.textToSpeechProvider?.clearHandlers();
        this.textToSpeechProvider?.initialize(this.settings.locale);
        this.speechToTextProvider?.initialize(this.settings.locale);
        this.speechToTextProvider?.addStartListener(()=>{
            this.clearSpeechTimeout();
            const stopListening = ()=>{
                this.speechToTextProvider?.stopListening();
                if (this.settings.uiType === "minimal") handleSpeechTimeout();
            };
            this.timeout = window?.setTimeout(stopListening, 5000);
        });
        this.speechToTextProvider?.addPartialListener((speech)=>{
            if (speech) {
                this.clearSpeechTimeout();
                const stopListening = ()=>{
                    this.speechToTextProvider?.stopListening();
                    if (this.settings.uiType === "minimal") handleSpeechTimeout();
                };
                this.timeout = window?.setTimeout(stopListening, 5000);
            }
        });
        this.speechToTextProvider?.addFinishListener((speech)=>{
            this.clearSpeechTimeout();
            this.speechToTextProvider?.stopListening();
            if (speech) {
                const result = this.makeTextRequest(speech);
                return result;
            }
            return "no input";
        });
        this.textToSpeechProvider?.addFinishListener(()=>{
            if (this.settings.autoRunConversation && this.settings.useVoiceInput && this.settings.uiType !== "minimal") this.speechToTextProvider?.startListening();
        });
        this.textToSpeechProvider?.addFinishListener(async ()=>{
            await this.fireAfterResponseEffects();
        });
    }
    startNewSession(sessionId, userId, sessionAttributes, userAttributes) {
        this.sessionId = sessionId ?? $174052f0970457c1$var$uuidv4();
        if (!userId) {
            const storedUserState = this.getLocalStorageUserState();
            if (storedUserState) {
                const userId = JSON.parse(storedUserState).userId;
                this.userId = userId;
            } else this.userId = $174052f0970457c1$var$uuidv4();
        } else this.userId = userId;
        const lastInteraction = new Date();
        let chatStateItem = {
            sessionId: this.sessionId,
            lastInteractionDate: lastInteraction.toString()
        };
        this.setLocalStorageChatState(chatStateItem);
        let userState = {
            userId: this.userId
        };
        this.setLocalStorageUserState(userState);
        this.sessionAttributes = sessionAttributes;
        this.userAttributes = userAttributes;
        this.currentSessionInfo = {};
        this.currentUserInfo = {};
        if (this.shouldSendWelcome) this.makeWelcomeRequest();
    }
    onEffect(effectName, callback, overrideExistingEffect = true) {
        const existingHandler = this.effectHandlers.find((e)=>e.effect === effectName);
        if (existingHandler) {
            const idx = this.effectHandlers.findIndex((e)=>e.effect === existingHandler.effect);
            if (overrideExistingEffect) this.effectHandlers[idx] = {
                effect: effectName,
                callbacks: [
                    callback
                ]
            };
            else this.effectHandlers[idx] = {
                effect: effectName,
                callbacks: [
                    ...this.effectHandlers[idx].callbacks,
                    callback
                ]
            };
        } else this.effectHandlers?.push({
            effect: effectName,
            callbacks: [
                callback
            ]
        });
    }
    onError(callback) {
        this.errorHandlers?.push(callback);
    }
    onRequestStarted(callback) {
        this.requestStartedHandlers?.push(callback);
    }
    onResponseReceived(callback) {
        this.responseHandlers?.push(callback);
    }
    onPlayVideo(callback) {
        this.videoHandlers?.push(callback);
    }
    onPlayAudio(callback) {
        this.audioHandlers?.push(callback);
    }
    makeTextRequest(text, requestAttributes) {
        const request = this.generateTextRequest(text, requestAttributes);
        this.recordChatHistoryItem({
            type: "user",
            content: {
                text: text
            }
        });
        return this.makeRequest(request);
    }
    makeWelcomeRequest(requestAttributes) {
        const request = this.generateWelcomeRequest(requestAttributes);
        return this.makeRequest(request);
    }
    addSessionAttribute(key, value) {
        if (!this.sessionAttributes) this.sessionAttributes = {};
        this.sessionAttributes[key] = value;
    }
    addUserAttribute(key, value) {
        if (!this.userAttributes) this.userAttributes = {};
        this.userAttributes[key] = value;
    }
    async fireAfterResponseEffects() {
        const afterResponseEffects = $e00ce1711940a61c$export$b2206d889512385b();
        const effectHandlers = this.effectHandlers;
        if (afterResponseEffects?.length) for(let i = 0; i < afterResponseEffects.length; ++i){
            const afterResponseEffect = afterResponseEffects[i];
            const handler = effectHandlers.find((e)=>e.effect == afterResponseEffect.effect);
            if (handler?.callbacks?.length) for(let j = 0; j < handler.callbacks.length; ++j){
                const callback = handler.callbacks[j];
                await callback(afterResponseEffect.data, afterResponseEffect.requestContext, true);
            }
        }
        $e00ce1711940a61c$export$6bbd431d88a3a0e9([]);
    }
    async fireEffects(request, response) {
        const effectHandlers = this.effectHandlers;
        // fire effects
        let effects = [];
        if (response.effects?.length) effects = response.effects;
        else {
            var sessionEffects = response.sessionAttributes?.["effects"] ?? [];
            if (sessionEffects?.length) effects = sessionEffects?.filter((e)=>e.requestId == request.requestId)?.map((e)=>{
                const em = {
                    name: e.effectName,
                    data: e.data
                };
                return em;
            });
        }
        var shouldContinueWithResponse = true;
        if (effects?.length) for(let i = 0; i < effects.length; ++i){
            const effect = effects[i];
            const handler = effectHandlers.find((e)=>e.effect == effect.name);
            if (handler?.callbacks?.length) for(let j = 0; j < handler.callbacks.length; ++j){
                const callback = handler.callbacks[j];
                const effectResult = await callback(effect.data, {
                    request: request,
                    response: response,
                    assistantElementRootId: this.assistantElementRootId,
                    textToSpeechEnabled: !!(this.settings.useOutputSpeech && this.textToSpeechProvider)
                }, false);
                if (effectResult) shouldContinueWithResponse = false;
            }
        }
        return shouldContinueWithResponse;
    }
    async handleCustomAssistantResponse(request, response, shouldFireEffects) {
        let shouldPlay = true;
        const textToSpeechEnabled = this.settings.useOutputSpeech && this.textToSpeechProvider;
        if (shouldFireEffects) shouldPlay = await this.fireEffects(request, response);
        if (!shouldPlay && textToSpeechEnabled) return;
        let chatHistoryItem = {
            type: "bot",
            content: {
                text: response.displayText
            }
        };
        if (response.hints) chatHistoryItem.content.hints = response.hints;
        if (response.foregroundImage?.url) chatHistoryItem.content.image = response.foregroundImage.url;
        if (response.videoFile?.url) chatHistoryItem.content.video = response.videoFile.url;
        if (response.audioFile?.url) chatHistoryItem.content.audio = response.audioFile.url;
        this.recordChatHistoryItem(chatHistoryItem);
        if (this.textToSpeechProvider && this.settings?.useOutputSpeech && response?.ssml && !response.audioFile) this.textToSpeechProvider?.speakSsml(response.ssml);
        if (response.sessionAttributes) this.currentSessionInfo = response.sessionAttributes;
        if (this.settings.loadUserProfile && this.userId) {
            const userRes = await $6a0390b72c02f22d$export$3f90b926bc531097(this.settings.serverRootUrl, this.userId, this.settings.appId, this.settings.appKey);
            if (userRes.status == 200) {
                const userData = await userRes?.json();
                if (userData) this.currentUserInfo = userData;
            }
        }
        this.responseHandlers?.forEach((handle)=>handle(response));
        if (response?.audioFile) this.audioHandlers?.forEach((handle)=>handle(response.audioFile));
        if (response?.videoFile) this.videoHandlers?.forEach((handle)=>handle(response.videoFile));
        if (this.settings.autoRunConversation && this.settings.useVoiceInput && !response.endSession && this.settings.uiType !== "minimal" && (!this.textToSpeechProvider || !this.settings.useOutputSpeech)) this.speechToTextProvider?.startListening();
        if (!textToSpeechEnabled) await this.fireAfterResponseEffects();
        return response;
    }
    async makeRequest(request) {
        try {
            this.textToSpeechProvider?.stop();
            this.requestStartedHandlers?.forEach((handle)=>handle(request));
            const createEndpoint = ()=>{
                let endpoint = `${this.settings.serverRootUrl}/api/customAssistant/handleRequest?applicationId=${this.settings.appId}&applicationSecret=${this.settings.appKey}`;
                if (this.settings.environmentId) endpoint = endpoint.concat(`&environmentId=${this.settings.environmentId}`);
                if (this.settings.noTracking) endpoint = endpoint.concat(`&noTracking=${this.settings.noTracking}`);
                if (this.settings.useDraftContent) endpoint = endpoint.concat(`&useDraftContent=${this.settings.useDraftContent}`);
                if (!this.settings.disableNlpInResponse) endpoint = endpoint.concat(`&includeNlp=true`);
                if (!this.settings.disableSessionInResponse) endpoint = endpoint.concat(`&includeSessionAttributes=true`);
                return endpoint;
            };
            const endpoint1 = createEndpoint();
            const result = await $0aad6105f1eb8dfb$export$9998e8b770869dd4(request, endpoint1);
            if (result.status == 200) {
                const response = await result.json();
                await this.handleCustomAssistantResponse(request, response, true);
            } else {
                const error = await result.text();
                this.errorHandlers?.forEach((handle)=>handle(error));
            }
            return null;
        } catch (e) {
            this.errorHandlers?.forEach((handle)=>handle(e.toString()));
            return null;
        }
    }
    generateTextRequest(text, requestAttributes) {
        return {
            requestId: $174052f0970457c1$var$uuidv4(),
            user: this.generateUser(),
            device: this.generateDevice(),
            context: {
                channel: this.settings.channel,
                locale: this.settings.locale,
                sessionId: this.sessionId,
                requestType: "IntentRequest",
                originalInput: text,
                requiresLanguageUnderstanding: true,
                additionalSessionAttributes: this.sessionAttributes,
                additionalRequestAttributes: requestAttributes
            }
        };
    }
    generateWelcomeRequest(requestAttributes) {
        return {
            requestId: $174052f0970457c1$var$uuidv4(),
            user: this.generateUser(),
            device: this.generateDevice(),
            context: {
                channel: this.settings.channel,
                locale: this.settings.locale,
                sessionId: this.sessionId,
                requestType: "IntentRequest",
                requestName: "VoicifyWelcome",
                originalInput: "[Automated]",
                requiresLanguageUnderstanding: false,
                additionalSessionAttributes: this.sessionAttributes,
                additionalRequestAttributes: requestAttributes
            }
        };
    }
    generateUser() {
        return {
            id: this.userId,
            name: this.userId,
            additionalUserAttributes: this.userAttributes
        };
    }
    generateDevice() {
        return {
            id: this.settings.device,
            name: this.settings.device,
            supportsVideo: true,
            supportsDisplayText: true,
            supportsTextInput: true,
            supportsSsml: this.settings.useOutputSpeech,
            supportsVoiceInput: this.settings.useVoiceInput
        };
    }
}
const $174052f0970457c1$var$uuidv4 = ()=>{
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function(c) {
        var r = Math.random() * 16 | 0, v = c === "x" ? r : r & 3 | 8;
        return v.toString(16);
    });
};
class $ec0952f503e2d812$export$a81102a23bf7a474 {
    constructor(locale){
        this.partialSpeechResultHandlers = [];
        this.speechResultsHandlers = [];
        this.speechErrorHandlers = [];
        this.speechStartHandlers = [];
        this.speechOnNoMatchHandlers = [];
        this.speechEndHandlers = [];
        this.recognition = undefined;
        this.locale = locale;
        if (this.recognition === undefined) {
            const SpeechRecognition = window?.SpeechRecognition || window?.webkitSpeechRecognition;
            this.recognition = SpeechRecognition ? new SpeechRecognition() : null;
        }
    }
    initialize() {
        const that = this;
        if (this.recognition) {
            this.recognition.lang = this.locale ?? "en-US";
            this.recognition.continuous = true;
            this.recognition.interimResults = true;
            this.recognition.onresult = (event)=>{
                let partialTranscript = "";
                let finalTranscript = "";
                for(let i = 0; i < event.results.length; i++)if (event?.results[i]?.isFinal) finalTranscript += event?.results[i][0]?.transcript;
                else partialTranscript += event?.results[i][0]?.transcript;
                that.speechResultsHandlers?.forEach((handle)=>event.results && finalTranscript && handle(finalTranscript));
                that.partialSpeechResultHandlers?.forEach((handle)=>event.results && handle(partialTranscript));
            };
            this.recognition.onerror = (event)=>{
                that.speechErrorHandlers?.forEach((handle)=>handle(event?.error));
            };
            this.recognition.onspeechend = (event)=>{
                that.speechEndHandlers?.forEach((handle)=>handle(event?.type));
            };
            this.recognition.onnomatch = (event)=>{
                that.speechOnNoMatchHandlers?.forEach((handle)=>handle(event?.error));
            };
        }
    }
    isSpeechRecognitionAvailable() {
        if (this.recognition === undefined) return false;
        else return true;
    }
    abortListening() {
        if (this.recognition) this.recognition.abort();
    }
    startListening() {
        if (this.recognition) {
            this.recognition.start();
            this.speechStartHandlers?.forEach((handle)=>handle());
        }
    }
    stopListening() {
        if (this.recognition) {
            this.recognition.stop();
            this.speechEndHandlers.forEach((handle)=>handle());
        }
    }
    addPartialListener(callback) {
        this.partialSpeechResultHandlers?.push(callback);
    }
    addNoMatchListener(callback) {
        this.speechOnNoMatchHandlers?.push(callback);
    }
    addFinishListener(callback) {
        this.speechResultsHandlers?.push(callback);
    }
    addErrorListener(callback) {
        this.speechErrorHandlers?.push(callback);
    }
    addStartListener(callback) {
        this.speechStartHandlers.push(callback);
    }
    addEndListener(callback) {
        this.speechEndHandlers?.push(callback);
    }
    clearHandlers() {
        this.partialSpeechResultHandlers = [];
        this.speechOnNoMatchHandlers = [];
        this.speechResultsHandlers = [];
        this.speechErrorHandlers = [];
        this.speechStartHandlers = [];
        this.speechEndHandlers = [];
    }
}
const $fa358ff2c6e79430$export$97723172f824839b = (requestBody, baseUrl, ttsProvider)=>{
    return $parcel$interopDefault($g5Y9E$crossfetch)($2b1094d8e20ed12f$export$ebe80008247bee1(baseUrl, ttsProvider), {
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify(requestBody)
    });
};
class $948554412ccc1cb4$export$5a827068c1cd9140 {
    constructor(settings){
        this.speechEndHandlers = [];
        this.settings = settings;
    }
    initialize(locale) {
        this.settings.locale = locale;
    }
    createLinkedList(src) {
        let top = {};
        for(let i = src.length - 1; i >= 0; i--)if (i == src.length - 1) top = {
            src: src[i].url,
            next: {}
        };
        else {
            let temp = {
                src: src[i].url,
                next: top
            };
            top = temp;
        }
        return top;
    }
    async playUrl(url) {
        let linkedLists = {};
        if (Array.isArray(url)) {
            linkedLists = this.createLinkedList(url);
            if (linkedLists.src) {
                const sound = new Audio(linkedLists.src);
                this.audioPlayer = sound;
            }
            let currentPlayer = linkedLists;
            if (this.audioPlayer) {
                await this.audioPlayer.play();
                this.audioPlayer.onended = async ()=>{
                    if (currentPlayer?.next?.src && this.audioPlayer) {
                        this.audioPlayer.src = currentPlayer.next?.src;
                        await this.audioPlayer?.play();
                        currentPlayer = currentPlayer.next;
                    } else this.speechEndHandlers?.forEach((handle)=>handle());
                };
            }
        } else if (url) {
            const sound = new Audio(url);
            this.audioPlayer = sound;
            this.audioPlayer.onended = ()=>{
                this.speechEndHandlers?.forEach((handle)=>handle());
            };
            await this.audioPlayer.play();
        }
    }
    async speakSsml(ssml) {
        const ssmlUrl = await this.ssmlToSpeech(ssml);
        if (ssmlUrl) this.playUrl(ssmlUrl);
    }
    stop() {
        if (this.audioPlayer) {
            this.audioPlayer.pause();
            this.audioPlayer.currentTime = 0;
        }
    }
    addFinishListener(callback) {
        this.speechEndHandlers?.push(callback);
    }
    clearHandlers() {
        this.speechEndHandlers = [];
    }
    async ssmlToSpeech(ssml) {
        try {
            const textToSpeechRequest = this.generateTTSRequest(ssml);
            const result = await $fa358ff2c6e79430$export$97723172f824839b(textToSpeechRequest, this.settings.serverRootUrl, this.settings.textToSpeechProvider);
            if (result.status == 200) {
                const response = await result.json();
                return response;
            } else return null;
        } catch (e) {
            return null;
        }
    }
    generateTTSRequest(ssml) {
        const request = {
            applicationId: this.settings.appId,
            applicationSecret: this.settings.appKey,
            ssmlRequest: {
                ssml: ssml,
                locale: this.settings.locale,
                voice: this.settings.textToSpeechVoice
            }
        };
        return request;
    }
}
const $c4cac35f50f462b8$export$cd1262eccf5f120f = (styleSettings)=>{
    const style = document.createElement("style");
    style.innerHTML = `
        #voicifyAssistantRoot {
            position: relative;
            z-index: ${styleSettings?.assistant?.zIndex ?? "1000"};
        }
    `;
    document.body.append(style);
};
const $c4cac35f50f462b8$export$31f077b88a3c784c = (shadowRoot, styleSettings, customStyles)=>{
    const style = document.createElement("style");
    style.innerHTML = `

        ::-webkit-scrollbar {
            width: 0px;
            height: 0px;
            background: transparent;
        }

        .voicify-assistant-container {
            background: transparent;
            display: flex;
            flex-direction: column;
            width: ${styleSettings?.assistant?.width ?? "398px"};
            position: fixed;
            bottom: 32px;
            right: 32px;
        }

        .voicify-assistant-minimal-ui-container {
            background: transparent;
            display: flex;
            flex-direction: column;
            flex: 1;
            min-width: 0;
        }

        .voicify-assistant-minimal-ui-container-left {
            background: transparent;
            flex: 1;
            min-width: 0;
        }

        .voicify-assistant-minimal-ui-container-right {
            background: transparent;
            flex: 1;
            min-width: 0;
        }

        .voicify-assistant-container-slide-left {
            background: transparent;
            display: flex;
            justify-content: flex-end;
            align-items: flex-end;
            position: fixed;
            bottom: 0;
            right: 0;
        }

        .voicify-assistant-container-slide-up {
            width: ${styleSettings?.assistant?.width ?? "398px"};
            position: fixed;
            bottom: 0;
            right: 0;
            background: ${styleSettings?.assistant?.backgroundColor ?? "transparent"};
            border-radius: ${styleSettings?.assistant?.borderRadius ?? "8px 8px 0 0"};
        }

        .voicify-assistant-container-minimal-show-history {
            background: transparent;
            display: flex;
            flex-direction: row;
            width: ${styleSettings?.assistant?.width ?? "100vw"};
            position: ${styleSettings?.assistant?.position ?? "fixed"};
            top: ${styleSettings?.assistant?.top ?? "initial"};
            bottom: ${styleSettings?.assistant?.bottom ?? "32px"};
            right: ${styleSettings?.assistant?.right ?? "initial"};
            left: ${styleSettings?.assistant?.left ?? "initial"};
        }

        .voicify-assistant-container-minimal {
            background: transparent;
            display: flex;
            flex-direction: row;
            width: ${styleSettings?.assistant?.width ?? "100vw"};
            position: ${styleSettings?.assistant?.position ?? "fixed"};
            top: ${styleSettings?.assistant?.top ?? "initial"};
            bottom: ${styleSettings?.assistant?.bottom ?? "32px"};
            right: ${styleSettings?.assistant?.right ?? "initial"};
            left: ${styleSettings?.assistant?.left ?? "initial"};
        }

        .voicify-assistant-chat-container {
            display: flex;
            flex-direction: column;
            width: ${styleSettings?.assistant?.width ?? "398px"};
            height: ${styleSettings?.assistant?.height ?? "75vh"};
            box-shadow: 0px 4px 20px rgba(0, 0, 0, .1);
            border-radius: ${styleSettings?.assistant?.borderRadius ?? "8px"};
            background: ${styleSettings?.assistant?.backgroundColor ?? "transparent"};
        }

        .voicify-assistant-chat-container-slide-up {
            display: flex;
            flex-direction: column;
            width: ${styleSettings?.assistant?.width ?? "398px"};
            height: ${styleSettings?.assistant?.height ?? "75vh"};
            box-shadow: 0px 4px 20px rgba(0, 0, 0, .1);
            background: transparent;
        }

        .voicify-assistant-chat-container-quick {
            display: flex;
            flex-direction: column;
            width: ${styleSettings?.assistant?.width ?? "398px"};
            box-shadow: 0px 4px 20px rgba(0, 0, 0, .1);
            border-radius: ${styleSettings?.assistant?.borderRadius ?? "8px"};
            background: ${styleSettings?.assistant?.backgroundColor ?? "transparent"};
        }

        .voicify-assistant-chat-container-minimal {
            display: flex;
            flex-direction: column;
            max-height: ${styleSettings?.assistant?.height ?? "25vh"};
            border-radius: ${styleSettings?.assistant?.borderRadius ?? "8px"};
            background: ${styleSettings?.assistant?.backgroundColor ?? "#FFFFFFBF"};
            min-width: 0;
        }

        .voicify-assistant-chat-container-minimal-show-history {
            display: flex;
            flex-direction: column;
            max-height: ${styleSettings?.assistant?.height ?? "25vh"};
            border-radius: ${styleSettings?.assistant?.borderRadius ?? "8px"};
            background: ${styleSettings?.assistant?.backgroundColor ?? "#FFFFFFBF"};
            min-width: 0;
        }

        .voicify-assistant-header {
            display: flex;
            justify-content: space-between;
            font-size: ${styleSettings?.header?.fontSize ?? "18px"};
            font-family: ${styleSettings?.header?.fontFamily ?? "Helvetica"};
            padding-left: ${styleSettings?.header?.paddingLeft ?? "16px"};
            padding-right: 0;
            padding-top: 0;
            padding-bottom: 0;
            color: ${styleSettings?.header?.assistantNameTextColor ?? "#324661"};
            background: ${styleSettings?.header?.backgroundColor ?? "white"};
            border: 1px solid #CBCCD2;
            font-weight: 600;
            border-bottom-style: solid;
            border-bottom-width: 1px;
            border-bottom-color: ${styleSettings?.body?.borderTopColor ?? "#CBCCD2"};
        }

        .voicify-assistant-header-minimal {
            border-radius: 8px 8px 0 0;
            border: none;
            background: transparent;
            padding: 16px 16px 0 0;
            justify-content: right;
        }

        .voicify-assistant-header-bottom-right-button {
            border-radius: 8px 8px 0 0;
        }

        .voicify-assistant-header-slide-left {
            border-radius: 8px 0 0 0;
        }

        .voicify-assistant-header-slide-up {
            border-radius: 8px 8px 0 0;
        }

        .voicify-assistant-header-left {
            display: flex;
            align-items: center;
        }

        .voicify-assistant-logo {
            background-color: ${styleSettings?.header?.assistantImageBackgroundColor ?? "none"};
            height: ${styleSettings?.header?.assistantImageHeight ?? "40px"};
            width: ${styleSettings?.header?.assistantImageWidth ?? "40px"};
            padding: ${styleSettings?.header?.assistantImagePadding ?? "none"};
            margin-right: 12px;
            border-radius: ${styleSettings?.header?.assistantImageBorderRadius ?? "50%"};
            border-color: ${styleSettings?.header?.assistantImageBorderColor ?? "none"};
            border-width: ${styleSettings?.header?.assistantImageBorderWidth ?? "none"};
            border-style: ${styleSettings?.header?.assistantImageBorderStyle ?? "none"};
        }

        .voicify-assistant-header-right {
            display: flex;
            align-items: center;
            margin-right: 16px;
        }

        .voicify-assistant-close-button {
            display: flex;
            justify-content: center;
            align-items: center;
            background: transparent;
            border-radius: ${styleSettings?.header?.closeAssistantButtonBorderRadius ?? "50%"};
            height: 24px;
            width: 24px;
            border: none;
            box-shadow: none;
            cursor: pointer;
        }

        .voicify-assistant-close-button-minimal {
            display: flex;
            justify-content: center;
            align-items: center;
            background: transparent;
            border-radius: ${styleSettings?.header?.closeAssistantButtonBorderRadius ?? "50%"};
            height: 24px;
            width: 24px;
            border: none;
            box-shadow: none;
            cursor: pointer;
            align-self: flex-end;
            margin: 16px 16px 0 0;
            position: absolute;
        }

        .voicify-assistant-minimize-button {
            width: ${styleSettings?.header?.minimizeButtonHeight ?? "24px"};
            height: ${styleSettings?.header?.minimizeButtonWidth ?? "24px"};
            display: flex;
            justify-content: center;
            align-items: center;
            background: transparent;
            border-radius: ${styleSettings?.header?.minimizeButtonBorderRadius ?? "none"};
            border: none;
            box-shadow: none;
            cursor: pointer;
            margin-right: 16px;
            filter: ${styleSettings?.header?.minimizeAssistantColor ?? "invert(63%) sepia(8%) saturate(377%) hue-rotate(173deg) brightness(93%) contrast(90%)"};
        }

        .voicify-assistant-close-icon {
            background-color: ${styleSettings?.header?.closeAssistantButtonBackgroundColor ?? "transparent"};
            border-radius: ${styleSettings?.header?.closeAssistantButtonBorderRadius ?? "50%"};
            border-color: ${styleSettings?.header?.closeAssistantButtonBorderColor ?? "none"};
            border-width: ${styleSettings?.header?.closeAssistantButtonBorderWidth ?? "none"};
            border-style: ${styleSettings?.header?.closeAssistantButtonBorderStyle ?? "none"};
            height: 24px;
            width: 24px;
            filter: ${styleSettings?.header?.closeAssistantColor ?? "invert(63%) sepia(8%) saturate(377%) hue-rotate(173deg) brightness(93%) contrast(90%)"};
        }

        .voicify-assistant-chat-history {
            display: block;
            flex-grow: 1;
            padding-left: ${styleSettings?.body?.paddingLeft ?? "24px"};
            padding-right: ${styleSettings?.body?.paddingRight ?? "24px"};
            padding-top: ${styleSettings?.body?.paddingTop ?? "24px"};
            padding-bottom: ${styleSettings?.body?.paddingBottom ?? "24px"};
            overflow-y: auto;
            display: flex;
            flex-direction: column;
            border-top-color: transparent;
            border-bottom-color: ${styleSettings?.body?.borderBottomColor ?? "#CBCCD2"};
            border-right-color: #CBCCD2; 
            border-left-color: #CBCCD2;
            border-width: 1px;
            border-style: solid; 
            background: ${styleSettings?.body?.backgroundColor ?? "#F4F4F6"};
        }

        .voicify-assistant-chat-history-hidden {
            display: none;
        }

        .voicify-assistant-chat-history-minimal {
            display: flex;
            flex-grow: 1;
            padding-left: ${styleSettings?.body?.paddingLeft ?? "74px"};
            padding-right: ${styleSettings?.body?.paddingRight ?? "48px"};
            padding-top: ${styleSettings?.body?.paddingTop ?? "0"};
            padding-bottom: ${styleSettings?.body?.paddingBottom ?? "0"};
            overflow-y: auto;
            flex-direction: column;
            border-top-color: transparent;
            border-top-right-radius: 8px;
            border-top-left-radius: 8px;
            background: ${styleSettings?.body?.backgroundColor ?? "transparent"};
            min-width: 0;
        }

        .voicify-assistant-chat-history-minimal-hidden {
            display: none;
        }

        .voicify-assistant-toolbar {
            background: ${styleSettings?.toolbar?.backgroundColor ?? "white"};
            border: 1px solid #CBCCD2;
            border-top: none;
        }

        .voicify-assistant-toolbar-bottom-right-button {
            border-radius: 0 0 8px 8px;
            border-top: none;
        }

        .voicify-assistant-toolbar-minimal {
            background: ${styleSettings?.toolbar?.backgroundColor ?? "transparent"};
            border: 1px solid #CBCCD2;
            border-radius: 8px;
            border-top: none;
            box-shadow: 0px 4px 20px rgba(0, 0, 0, .1);
            display: flex;
            min-width: 0;
        }

        .voicify-assistant-toolbar-minimal-speaking {
            background: ${styleSettings?.toolbar?.backgroundColor ?? "transparent"};
            border: 1px solid #CBCCD2;
            border-radius: 8px 8px 0 0;
            border-top: none;
            box-shadow: 0px 4px 20px rgba(0, 0, 0, .1);
            display: flex;
            min-width: 0;
        }

        .voicify-assistant-toolbar-minimal-show-history {
            background: ${styleSettings?.toolbar?.backgroundColor ?? "transparent"};
            border-bottom-right-radius: 8px;
            border-bottom-left-radius: 8px;
            border-top: none;
            display: flex;
            flex-direction: column;
            min-width: 0;
        }

        .voicify-assistant-toolbar-slide {
            border-radius: 0;
        }

        .voicify-assistant-toolbar-top-hidden {
            display: none;
        }

        .voicify-assistant-toolbar-bottom {
            display: flex;
            padding-left: ${styleSettings?.toolbar?.paddingLeft ?? "16px"};
            padding-right: ${styleSettings?.toolbar?.paddingRight ?? "16px"};
            padding-top: ${styleSettings?.toolbar?.paddingTop ?? "16px"};
            padding-bottom: ${styleSettings?.toolbar?.paddingBottom ?? "16px"};
        }

        .voicify-assistant-toolbar-bottom-minimal {
            display: flex;
            padding-left: ${styleSettings?.toolbar?.paddingLeft ?? "16px"};
            padding-right: ${styleSettings?.toolbar?.paddingRight ?? "48px"};
            padding-top: ${styleSettings?.toolbar?.paddingTop ?? "48px"};
            padding-bottom: ${styleSettings?.toolbar?.paddingBottom ?? "48px"};
            flex: 1;
            min-width: 0;
        }
        
        .voicify-assistant-toolbar-bottom-minimal-show-history {
            display: flex;
            padding-left: ${styleSettings?.toolbar?.paddingLeft ?? "16px"};
            padding-right: ${styleSettings?.toolbar?.paddingRight ?? "48px"};
            padding-top: ${styleSettings?.toolbar?.paddingTop ?? "0"};
            padding-bottom: ${styleSettings?.toolbar?.paddingBottom ?? "48px"};
            flex: 1;
            min-width: 0;
        }

        .voicify-assistant-toolbar-top {
            margin-top: auto;
            margin-bottom: 0;
            display: flex;
            flex-direction: column;
            background: ${styleSettings?.toolbar?.backgroundColor ?? "white"};
            border-bottom: none;
            padding-left: ${styleSettings?.toolbar?.paddingLeft ?? "16px"};
            padding-right: ${styleSettings?.toolbar?.paddingRight ?? "16px"};
            padding-top: ${styleSettings?.toolbar?.paddingTop ?? "16px"};
            padding-bottom: ${styleSettings?.toolbar?.paddingBottom ?? "0px"};
        }

        .voicify-assistant-toolbar-top-bottom-border {
            padding: 0 24px;
            margin-top: 8px;
            border-bottom: 1px dashed #CBCCD2;
        }

        .voicify-assistant-toolbar-help {
            font-family: ${styleSettings?.toolbar?.helpTextFontFamily ?? "Helvetica"};
            font-size: ${styleSettings?.toolbar?.helpTextFontSize ?? "14px"};
            font-style: italic;
            color: ${styleSettings?.toolbar?.helpTextFontColor ?? "#8F97A1"};
            margin-bottom: 16px;
        }

        .voicify-assistant-minimal-speaking-indicator {
            background: ${styleSettings?.toolbar?.equalizerColor ?? "radial-gradient(#182EE3 0%, #06BAC8 100%)"};
            border-bottom-right-radius: 8px;
            border-bottom-left-radius: 8px;
            width: 100%;
            height: 20px;
            animation-duration: 2s;
            animation-iteration-count: infinite;
            animation-name: minimal-equalizer-color;
        }

        @keyframes minimal-equalizer-color {
            0% {background: radial-gradient(${styleSettings?.toolbar?.equalizerColorOne ?? `#182EE3`} 0%, ${styleSettings?.toolbar?.equalizerColorTwo ?? `#06BAC8`} 100%)}
            10% {background: radial-gradient(${styleSettings?.toolbar?.equalizerColorOne ?? `#182EE3`} 0%, ${styleSettings?.toolbar?.equalizerColorTwo ?? `#06BAC8`} 90%)}
            20% {background: radial-gradient(${styleSettings?.toolbar?.equalizerColorOne ?? `#182EE3`} 0%, ${styleSettings?.toolbar?.equalizerColorTwo ?? `#06BAC8`} 80%)}
            30% {background: radial-gradient(${styleSettings?.toolbar?.equalizerColorOne ?? `#182EE3`} 0%, ${styleSettings?.toolbar?.equalizerColorTwo ?? `#06BAC8`} 70%)}
            40% {background: radial-gradient(${styleSettings?.toolbar?.equalizerColorOne ?? `#182EE3`} 0%, ${styleSettings?.toolbar?.equalizerColorTwo ?? `#06BAC8`} 60%)}
            50% {background: radial-gradient(${styleSettings?.toolbar?.equalizerColorOne ?? `#182EE3`} 0%, ${styleSettings?.toolbar?.equalizerColorTwo ?? `#06BAC8`} 50%)}
            60% {background: radial-gradient(${styleSettings?.toolbar?.equalizerColorOne ?? `#182EE3`} 0%, ${styleSettings?.toolbar?.equalizerColorTwo ?? `#06BAC8`} 60%)}
            70% {background: radial-gradient(${styleSettings?.toolbar?.equalizerColorOne ?? `#182EE3`} 0%, ${styleSettings?.toolbar?.equalizerColorTwo ?? `#06BAC8`} 70%)}
            80% {background: radial-gradient(${styleSettings?.toolbar?.equalizerColorOne ?? `#182EE3`} 0%, ${styleSettings?.toolbar?.equalizerColorTwo ?? `#06BAC8`} 80%)}
            90% {background: radial-gradient(${styleSettings?.toolbar?.equalizerColorOne ?? `#182EE3`} 0%, ${styleSettings?.toolbar?.equalizerColorTwo ?? `#06BAC8`} 90%)}
            100% {background: radial-gradient(${styleSettings?.toolbar?.equalizerColorOne ?? `#182EE3`} 0%, ${styleSettings?.toolbar?.equalizerColorTwo ?? `#06BAC8`} 100%)}
        }

        .voicify-assistant-bar {
            border-radius: ${styleSettings?.toolbar?.equalizerBarBorderRadius ?? "10px"};
            height: 10px;
            width: ${styleSettings?.toolbar?.equalizerBarWidth ?? "10px"};
            background: ${styleSettings?.toolbar?.equalizerColor ?? "linear-gradient(180deg, #83ACE4 0%, rgba(128, 199, 175, 0) 100%), #8AD1B8"};
            margin-right: ${styleSettings?.toolbar?.equalizerBarRightMargin ?? "2px"};
            animation-duration: 2s;
            animation-iteration-count: infinite;
        }

        .voicify-assistant-bar-1 {
            animation-name: one;
        }

        .voicify-assistant-bar-2 {
            animation-name: two;
        }

        .voicify-assistant-bar-3 {
            animation-name: three;
        }

        .voicify-assistant-bar-4 {
            animation-name: four;
        }

        .voicify-assistant-bar-5 {
            animation-name: five;
        }

        .voicify-assistant-bar-6 {
            animation-name: six;
        }

        .voicify-assistant-bar-7 {
            animation-name: seven;
        }

        .voicify-assistant-bar-8 {
            animation-name: eight;
        }

        .voicify-assistant-bar-9 {
            animation-name: nine;
        }

        .voicify-assistant-bar-10 {
            animation-name: ten;
        }

        .voicify-assistant-bar-11 {
            animation-name: eleven;
        }

        @keyframes one {
            0% {height: 10px}
            12.5% {height: 5.52px}
            25% {height: 10px}
            37.5% {height: 5.52px}
            50% {height: 10px}
            62.5% {height: 10px}
            75% {height: 16px}
            100% {height: 10px}
        }

        @keyframes two {
            0% {height: 10px}
            12.5% {height: 20.97px}
            25% {height: 38px}
            37.5% {height: 20.97px}
            50% {height: 10px}
            62.5% {height: 10px}
            75% {height: 16px}
            100% {height: 10px}
        }

        @keyframes three {
            0% {height: 10px}
            12.5% {height: 15.45px}
            25% {height: 28px}
            37.5% {height: 15.45px}
            50% {height: 10px}
            62.5% {height: 8.54px}
            75% {height: 14px}
            100% {height: 8.54px}
        }

        @keyframes four {
            0% {height: 10px}
            12.5% {height: 8.83px}
            25% {height: 16px}
            37.5% {height: 8.83px}
            50% {height: 10px}
            62.5% {height: 15.85px}
            75% {height: 26px}
            100% {height: 15.85px}
        }

        @keyframes five {
            0% {height: 10px}
            12.5% {height: 1.66px}
            25% {height: 3px}
            37.5% {height: 1.66px}
            50% {height: 10px}
            62.5% {height: 25px}
            75% {height: 41px}
            100% {height: 25px}
        }

        @keyframes six {
            0% {height: 10px}
            12.5% {height: 7.72px}
            25% {height: 14px}
            37.5% {height: 7.72px}
            50% {height: 10px}
            62.5% {height: 10px}
            75% {height: 16px}
            100% {height: 10px}
        }

        @keyframes seven {
            0% {height: 10px}
            12.5% {height: 32px}
            25% {height: 58px}
            37.5% {height: 32px}
            50% {height: 10px}
            62.5% {height: 12.2px}
            75% {height: 20px}
            100% {height: 12.2px}
        }

        @keyframes eight {
            0% {height: 10px}
            12.5% {height: 23.17px}
            25% {height: 42px}
            37.5% {height: 23.17px}
            50% {height: 10px}
            62.5% {height: 21.95px}
            75% {height: 36px}
            100% {height: 21.95px}
        }

        @keyframes nine {
            0% {height: 10px}
            12.5% {height: 25.38px}
            25% {height: 46px}
            37.5% {height: 25.38px}
            50% {height: 10px}
            62.5% {height: 15.85px}
            75% {height: 26px}
            100% {height: 15.85px}
        }

        @keyframes ten {
            0% {height: 10px}
            12.5% {height: 17.66px}
            25% {height: 32px}
            37.5% {height: 17.66px}
            50% {height: 10px}
            62.5% {height: 10.98px}
            75% {height: 18px}
            100% {height: 10.98px}
        }

        @keyframes eleven {
            0% {height: 10px}
            12.5% {height: 6.62px}
            25% {height: 12px}
            37.5% {height: 6.62px}
            50% {height: 10px}
            62.5% {height: 7.32px}
            75% {height: 12px}
            100% {height: 7.32px}
        }

        .voicify-assistant-toolbar-animation {
            display: flex;
            justify-content: center;
            align-items: center;
            min-height: 64px;
        }

        .voicify-assistant-toolbar-state {
            font-family: ${styleSettings?.toolbar?.assistantStateFontFamily ?? "Helvetica"};
            font-size: ${styleSettings?.toolbar?.assistantStateFontSize ?? "12px"};
            font-style: italic;
            color: ${styleSettings?.toolbar?.assistantStateFontColor ?? "#AAAAAA"};
        }

        .voicify-assistant-toolbar-transcription {
            display: flex;
            align-items: center;
            margin: 8px 0;
            padding: 4px 16px 4px 16px;
            border-radius: 8px;
            background-color: ${styleSettings?.toolbar?.speechResultBoxBackgroundColor ?? "rgba(0, 0, 0, 0.5)"};
            color: ${styleSettings?.toolbar?.partialSpeechResultTextColor ?? "white"};
            font-family: ${styleSettings?.toolbar?.partialSpeechResultFontFamily ?? "Helvetica"};
            font-size: ${styleSettings?.toolbar?.partialSpeechResultFontSize ?? "16px"};
            height: ${styleSettings?.toolbar?.speechResultBoxHeight ?? "16px"};
            white-space: nowrap;
            overflow: hidden;
        }

        .voicify-assistant-toolbar-transcription-minimal {
            display: flex;
            flex: 1;
            align-items: center;
            padding: 18.5px 16px;
            border-radius: 8px;
            background-color: ${styleSettings?.toolbar?.speechResultBoxBackgroundColor ?? "#FFFFFF"};
            color: ${styleSettings?.toolbar?.partialSpeechResultTextColor ?? "#324661"};
            font-family: ${styleSettings?.toolbar?.partialSpeechResultFontFamily ?? "Helvetica"};
            font-size: ${styleSettings?.toolbar?.partialSpeechResultFontSize ?? "16px"};
            height: ${styleSettings?.toolbar?.speechResultBoxHeight ?? "16px"};
            white-space: nowrap;
            overflow: hidden;
        }

        .voicify-assistant-toolbar-left {
            display: flex;
            flex-direction: column;
            align-items: center;
        }

        .voicify-assistant-toolbar-left-minimal {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
        }

        .voicify-assistant-toolbar-left-no-mic {
            width: 0;
            margin-left: 8px;
        }

        .voicify-assistant-toolbar-right {
            margin-left: 16px;
            margin-bottom: 8px;
            display: flex;
            flex-direction: column;
            flex-grow: 1;
        }

        .voicify-assistant-toolbar-right-minimal {
            margin-left: 16px;
            display: flex;
            flex: 1;
            min-width: 0;
        }

        .voicify-assistant-send-button {
            display: flex;
            justify-content: center;
            align-items: flex-end;
            outline: none;
            height: 36px;
            border: none;
            background: transparent;
            cursor: pointer;
        }

        .voicify-assistant-send-button-minimal {
            display: flex;
            justify-content: center;
            align-items: center;
            outline: none;
            height: 36px;
            border: none;
            background: transparent;
            cursor: pointer;
        }

        .voicify-assistant-send-icon {
            filter: ${styleSettings?.toolbar?.sendActiveColor ?? "invert(53%) sepia(5%) saturate(0%) hue-rotate(157deg) brightness(94%) contrast(81%)"};
            height: 24px;
            width: 24px;
        }

        .voicify-assistant-send-icon-minimal {
            filter: ${styleSettings?.toolbar?.sendActiveColor ?? "invert(53%) sepia(5%) saturate(0%) hue-rotate(157deg) brightness(94%) contrast(81%)"};
            height: 24px;
            width: 24px;
        }

        .voicify-assistant-send-icon-inactive {
            filter: ${styleSettings?.toolbar?.sendInactiveColor ?? "invert(60%) sepia(7%) saturate(431%) hue-rotate(173deg) brightness(99%) contrast(90%)"};
            height: 24px;
            width: 24px;
        }

        .voicify-assistant-send-icon-inactive-minimal {
            filter: ${styleSettings?.toolbar?.sendInactiveColor ?? "invert(53%) sepia(5%) saturate(0%) hue-rotate(157deg) brightness(94%) contrast(81%)"};
            height: 24px;
            width: 24px;
        }

        .voicify-assistant-toolbar-listening-row {
            display: flex;
            justify-content: space-between;
            align-items: center;
        }

        .voicify-assistant-toolbar-mute-container {
            display: flex;
            align-items: center;
            cursor: pointer;
        }

        .voicify-assistant-toolbar-mute-text {
            color: ${styleSettings?.toolbar?.muteFontColor ?? "#AAAAAA"};
            font-family: ${styleSettings?.toolbar?.muteFontFamily ?? "Helvetica"};
            font-size: ${styleSettings?.toolbar?.muteFontSize ?? "12px"};
            margin-right: 4px;
        }

        .voicify-assistant-toolbar-mute-icon {
            height: ${styleSettings?.toolbar?.muteImageHeight ?? "auto"};
            width: ${styleSettings?.toolbar?.muteImageWidth ?? "auto"};
            filter: ${styleSettings?.toolbar?.muteImageColor ?? "invert(100%) sepia(0%) saturate(7488%) hue-rotate(146deg) brightness(92%) contrast(110%)"};
        }

        .voicify-assistant-toolbar-speak-active {
            font-size: ${styleSettings?.toolbar?.speakFontSize ?? "12px"};
            font-family: ${styleSettings?.toolbar?.speakFontFamily ?? "Helvetica"};
            color: ${styleSettings?.toolbar?.speakActiveTitleColor ?? "#444444"};
            margin-bottom: 4px;
        }

        .voicify-assistant-toolbar-speak-inactive {
            font-size: ${styleSettings?.toolbar?.speakFontSize ?? "12px"};
            font-family: ${styleSettings?.toolbar?.speakFontFamily ?? "Helvetica"};
            color: ${styleSettings?.toolbar?.speakInactiveTitleColor ?? "#8F97A1"};
            margin-bottom: 4px;
        }

        .voicify-assistant-toolbar-type-active {
            font-size: ${styleSettings?.toolbar?.typeFontSize ?? "12px"};
            font-family: ${styleSettings?.toolbar?.typeFontFamily ?? "Helvetica"};
            color: ${styleSettings?.toolbar?.typeActiveTitleColor ?? "#444444"};
            margin-bottom: 4px;
        }

        .voicify-assistant-toolbar-type-inactive {
            font-size: ${styleSettings?.toolbar?.typeFontSize ?? "12px"};
            font-family: ${styleSettings?.toolbar?.typeFontFamily ?? "Helvetica"};
            color: ${styleSettings?.toolbar?.typeInactiveTitleColor ?? "#8F97A1"};
            margin-bottom: 4px;
        }

        .voicify-assistant-microphone {
            display: flex;
            justify-content: center;
            align-items: start;
            border-radius: ${styleSettings?.toolbar?.micBorderRadius ?? "50%"};
            height: ${styleSettings?.toolbar?.micButtonHeight ?? "40px"};
            width: ${styleSettings?.toolbar?.micButtonWidth ?? "40px"};
            border: none;
            box-shadow: none;
            cursor: pointer;
            background: transparent;
        }

        .voicify-assistant-microphone-minimal {
            display: flex;
            justify-content: center;
            align-items: center;
            border-radius: ${styleSettings?.toolbar?.micBorderRadius ?? "50%"};
            height: ${styleSettings?.toolbar?.micButtonHeight ?? "40px"};
            width: ${styleSettings?.toolbar?.micButtonWidth ?? "40px"};
            border: none;
            box-shadow: none;
            cursor: pointer;
            background: transparent;
        }

        .voicify-assistant-keyboard {
            display: flex;
            justify-content: center;
            align-items: center;
            filter: ${styleSettings?.toolbar?.keyboardColor ?? "invert(53%) sepia(5%) saturate(0%) hue-rotate(157deg) brightness(94%) contrast(81%)"};
            border: none;
            box-shadow: none;
            cursor: pointer;
            background: transparent;
        }

        .voicify-assistant-keyboard-inactive {
            display: flex;
            justify-content: center;
            align-items: center;
            filter: ${styleSettings?.toolbar?.keyboardColor ?? "invert(53%) sepia(5%) saturate(0%) hue-rotate(157deg) brightness(94%) contrast(81%)"};
            border: none;
            box-shadow: none;
            cursor: pointer;
            background: transparent;
        }

        .voicify-assistant-mic-active {
            display: flex;
            justify-content: center;
            align-items: center;
            border-radius: 50%;
            filter: ${styleSettings?.toolbar?.micActiveColor ?? "invert(53%) sepia(5%) saturate(0%) hue-rotate(157deg) brightness(94%) contrast(81%)"};
            height: ${styleSettings?.toolbar?.micActiveImageHeight ?? "48px"};
            width: ${styleSettings?.toolbar?.micActiveImageWidth ?? "48px"};
            padding: ${styleSettings?.toolbar?.activeMicImagePadding ?? "none"};
            border-width: ${styleSettings?.toolbar?.micImageBorderWidth ?? "none"};
            border-style: ${styleSettings?.toolbar?.micImageBorderStyle ?? "none"};
            border-color: ${styleSettings?.toolbar?.micImageBorderColor ?? "none"};
            box-shadow: none;
            cursor: pointer;
            background: ${styleSettings?.toolbar?.micActiveHighlightColor ?? "none"};
        }

        .voicify-assistant-mic-active-minimal {
            display: flex;
            justify-content: center;
            align-items: center;
            border-radius: 50%;
            filter: ${styleSettings?.toolbar?.micActiveColor ?? "invert(53%) sepia(5%) saturate(0%) hue-rotate(157deg) brightness(94%) contrast(81%)"};
            height: ${styleSettings?.toolbar?.micActiveImageHeight ?? "48px"};
            width: ${styleSettings?.toolbar?.micActiveImageWidth ?? "48px"};
            padding: ${styleSettings?.toolbar?.activeMicImagePadding ?? "none"};
            border-width: ${styleSettings?.toolbar?.micImageBorderWidth ?? "none"};
            border-style: ${styleSettings?.toolbar?.micImageBorderStyle ?? "none"};
            border-color: ${styleSettings?.toolbar?.micImageBorderColor ?? "none"};
            box-shadow: none;
            cursor: pointer;
            background: ${styleSettings?.toolbar?.micActiveHighlightColor ?? "none"};
        }

        .voicify-assistant-mic-inactive {
            display: flex;
            justify-content: center;
            align-items: center;
            border-radius: 50%;
            filter: ${styleSettings?.toolbar?.micActiveColor ?? "invert(60%) sepia(7%) saturate(431%) hue-rotate(173deg) brightness(99%) contrast(90%)"};
            height: ${styleSettings?.toolbar?.micImageHeight ?? "48px"};
            width: ${styleSettings?.toolbar?.micImageWidth ?? "48px"};
            padding: ${styleSettings?.toolbar?.micImagePadding ?? "none"};
            border-width: ${styleSettings?.toolbar?.micImageBorderWidth ?? "none"};
            border-style: ${styleSettings?.toolbar?.micImageBorderStyle ?? "none"};
            border-color: ${styleSettings?.toolbar?.micImageBorderColor ?? "none"};
            border: none;
            box-shadow: none;
            cursor: pointer;
            background: ${styleSettings?.toolbar?.micInactiveHighlightColor ?? "none"};
        }

        .voicify-assistant-mic-inactive-minimal {
            display: flex;
            justify-content: center;
            align-items: center;
            border-radius: 50%;
            filter: ${styleSettings?.toolbar?.micActiveColor ?? "invert(53%) sepia(5%) saturate(0%) hue-rotate(157deg) brightness(94%) contrast(81%)"};
            height: ${styleSettings?.toolbar?.micImageHeight ?? "48px"};
            width: ${styleSettings?.toolbar?.micImageWidth ?? "48px"};
            padding: ${styleSettings?.toolbar?.micImagePadding ?? "none"};
            border-width: ${styleSettings?.toolbar?.micImageBorderWidth ?? "none"};
            border-style: ${styleSettings?.toolbar?.micImageBorderStyle ?? "none"};
            border-color: ${styleSettings?.toolbar?.micImageBorderColor ?? "none"};
            border: none;
            box-shadow: none;
            cursor: pointer;
            background: ${styleSettings?.toolbar?.micInactiveHighlightColor ?? "none"};
        }

        .voicify-assistant-input-container-active {
            background: ${styleSettings?.toolbar?.textboxActiveHighlightColor ?? " rgba(167, 167, 167, 0.2)"};
            border-radius: 8px;
            padding: 8px;
            display: flex;
        }

        .voicify-assistant-input-container-active-minimal {
            background: ${styleSettings?.toolbar?.textboxActiveHighlightColor ?? "#FFFFFF"};
            border-radius: 8px;
            padding: 8px;
            display: flex;
            border: 1px solid ${styleSettings?.toolbar?.textboxBorderColor ?? "#D9D9D9"};
            flex: 1;
        }

        .voicify-assistant-input-container-inactive {
            background: ${styleSettings?.toolbar?.textboxInactiveHighlightColor ?? "transparent"};
            border-radius: 8px;
            padding: 8px;
            display: flex;
        }

        .voicify-assistant-input-container-inactive-minimal {
            background: ${styleSettings?.toolbar?.textboxInactiveHighlightColor ?? "#FFFFFF"};
            border-radius: 8px;
            padding: 8px;
            display: flex;
            border: 1px solid ${styleSettings?.toolbar?.textboxBorderColor ?? "#D9D9D9"};
            flex: 1;
        }

        .voicify-assistant-input-container-active input {
            font-size: ${styleSettings?.toolbar?.textboxFontSize ?? "16px"};
            font-family: ${styleSettings?.toolbar?.textboxFontFamily ?? "Helvetica"};
            color: ${styleSettings?.toolbar?.textInputTextColor ?? "#324661"};
        }

        .voicify-assistant-textbox {
            border: none;
            border-bottom: 1px solid ${styleSettings?.toolbar?.textInputLineColor ?? "#CCCCCC"};
            outline: none;
            background: transparent;
            flex-grow: 1;
            caret-color: ${styleSettings?.toolbar?.textInputCursorColor ?? "#A3A3A3"};
        }

        .voicify-assistant-textbox-minimal {
            border: none;
            outline: none;
            background: transparent;
            flex-grow: 1;
            caret-color: ${styleSettings?.toolbar?.textInputCursorColor ?? "#A3A3A3"};
            font-size: ${styleSettings?.toolbar?.textboxFontSize ?? "16px"};
        }

        .voicify-assistant-textbox-active {
            border: none;
            border-bottom: 1px solid ${styleSettings?.toolbar?.textInputActiveLineColor ?? "#CCCCCC"};
            outline: none;
            background: transparent;
            flex-grow: 1;
            caret-color: ${styleSettings?.toolbar?.textInputCursorColor ?? "#A3A3A3"};
        }

        .voicify-assistant-textbox-active-minimal {
            border: none;
            outline: none;
            background: transparent;
            flex-grow: 1;
            caret-color: ${styleSettings?.toolbar?.textInputCursorColor ?? "#A3A3A3"};
            font-size: ${styleSettings?.toolbar?.textboxFontSize ?? "16px"};
        }

        ::placeholder {
            color: ${styleSettings?.toolbar?.placeholderFontColor ?? "#8F97A1"};
            font-style: ${styleSettings?.toolbar?.placeholderFontStyle ?? "normal"};
            font-size: ${styleSettings?.toolbar?.placeholderFontSize ?? "16px"};
            font-family: ${styleSettings?.toolbar?.placeholderFontFamily ?? "Helvetica"};
        }

        .voicify-assistant-chat-user-item {
            line-height: 1.4;
            background: ${styleSettings?.body?.messageSentBackgroundColor ?? "rgba(0, 0, 0, 0.5)"};
            font-size: ${styleSettings?.body?.messageSentFontSize ?? "16px"};
            font-family: ${styleSettings?.body?.messageSentFontFamily ?? "Helvetica"};
            color: ${styleSettings?.body?.messageSentTextColor ?? "white"};
            max-width: 265px;
            width: fit-contents;
            padding: 4px 16px;
            align-self: flex-end;
            border-width: ${styleSettings?.body?.messageSentBorderWidth ?? "none"};
            border-style: ${styleSettings?.body?.messageSentBorderStyle ?? "none"};
            border-color: ${styleSettings?.body?.messageSentBorderColor ?? "none"};
            border-top-left-radius: ${styleSettings?.body?.messageSentBorderTopLeftRadius ?? "8px"};
            border-top-right-radius: ${styleSettings?.body?.messageSentBorderTopRightRadius ?? "0"};
            border-bottom-right-radius: ${styleSettings?.body?.messageSentBorderBottomRightRadius ?? "8px"};
            border-bottom-left-radius: ${styleSettings?.body?.messageSentBorderBottomLeftRadius ?? "8px"};
            display: inline-block;
            overflow-wrap: break-word;
        }

        .voicify-assistant-chat-user-item-minimal {
            max-width: 218px;
            line-height: 1.4;
            background: ${styleSettings?.body?.messageSentBackgroundColor ?? "rgba(0, 0, 0, 0.5)"};
            font-size: ${styleSettings?.body?.messageSentFontSize ?? "16px"};
            font-family: ${styleSettings?.body?.messageSentFontFamily ?? "Helvetica"};
            color: ${styleSettings?.body?.messageSentTextColor ?? "white"};
            padding: 4px 16px;
            align-self: flex-end;
            border-width: ${styleSettings?.body?.messageSentBorderWidth ?? "none"};
            border-style: ${styleSettings?.body?.messageSentBorderStyle ?? "none"};
            border-color: ${styleSettings?.body?.messageSentBorderColor ?? "none"};
            border-top-left-radius: ${styleSettings?.body?.messageSentBorderTopLeftRadius ?? "8px"};
            border-top-right-radius: ${styleSettings?.body?.messageSentBorderTopRightRadius ?? "0"};
            border-bottom-right-radius: ${styleSettings?.body?.messageSentBorderBottomRightRadius ?? "8px"};
            border-bottom-left-radius: ${styleSettings?.body?.messageSentBorderBottomLeftRadius ?? "8px"};
            overflow-wrap: break-word;
        }

        .voicify-assistant-chat-bot-container {
            display: flex;
            justify-self: start;
        }

        .voicify-assistant-chat-bot-container-left {
            display: flex;
            align-items: flex-start;
        }

        .voicify-assistant-chat-bot-container-right {
            display: flex;
            flex-direction: column;
        }

        .voicify-assistant-chat-bot-container-right-minimal {
            display: flex;
            flex-direction: column;
            flex: 1;
        }

        .voicify-assistant-chat-bot-avatar {
            border-color: ${styleSettings?.body?.assistantImageBorderColor ?? "none"};
            border-width: ${styleSettings?.body?.assistantImageBorderWidth ?? "none"};
            border-style: ${styleSettings?.body?.assistantImageBorderStyle ?? "none"};
            border-radius: ${styleSettings?.body?.assistantImageBorderRadius ?? "50%"};
            height: 32px;
            width: 32px;
            margin-right: 8px;
            padding:  ${styleSettings?.body?.assistantImagePadding ?? "none"};
        }

        .voicify-assistant-chat-bot-item {
            line-height: 1.4;
            background: ${styleSettings?.body?.messageReceivedBackgroundColor ?? "rgba(0, 0, 0, 0.1)"};
            font-size: ${styleSettings?.body?.messageReceivedFontSize ?? "16px"};
            font-family: ${styleSettings?.body?.messageReceivedFontFamily ?? "Helvetica"};
            color: ${styleSettings?.body?.messageReceivedTextColor ?? "#324661"};
            max-width: 265px;
            width: fit-contents;
            padding: 4px 16px;
            border-top-left-radius: ${styleSettings?.body?.messageReceivedBorderTopLeftRadius ?? "8px"};
            border-top-right-radius: ${styleSettings?.body?.messageReceivedBorderTopRightRadius ?? "0"};
            border-bottom-right-radius: ${styleSettings?.body?.messageReceivedBorderBottomRightRadius ?? "8px"};
            border-bottom-left-radius: ${styleSettings?.body?.messageReceivedBorderBottomLeftRadius ?? "8px"};
            border-radius: 0px 8px 8px 8px;
            border-width: ${styleSettings?.body?.messageReceivedBorderWidth ?? "1px"};
            border-style: ${styleSettings?.body?.messageReceivedBorderStyle ?? "solid"};
            border-color: ${styleSettings?.body?.messageReceivedBorderColor ?? "#CCCCCC"};
            border: 1px solid #CCCCCC;
            display: inline-block;
        }

        .voicify-assistant-chat-bot-item-minimal {
            display: flex;
            flex-direction: column;
            max-width: 218px;
            line-height: 1.4;
            background: ${styleSettings?.body?.messageReceivedBackgroundColor ?? "#FFFFFF"};
            font-size: ${styleSettings?.body?.messageReceivedFontSize ?? "16px"};
            font-family: ${styleSettings?.body?.messageReceivedFontFamily ?? "Helvetica"};
            color: ${styleSettings?.body?.messageReceivedTextColor ?? "#324661"};
            padding: 4px 16px;
            border-top-left-radius: ${styleSettings?.body?.messageReceivedBorderTopLeftRadius ?? "8px"};
            border-top-right-radius: ${styleSettings?.body?.messageReceivedBorderTopRightRadius ?? "0"};
            border-bottom-right-radius: ${styleSettings?.body?.messageReceivedBorderBottomRightRadius ?? "8px"};
            border-bottom-left-radius: ${styleSettings?.body?.messageReceivedBorderBottomLeftRadius ?? "8px"};
            border-radius: 0px 8px 8px 8px;
            border-width: ${styleSettings?.body?.messageReceivedBorderWidth ?? "none"};
            border-style: ${styleSettings?.body?.messageReceivedBorderStyle ?? "none"};
            border-color: ${styleSettings?.body?.messageReceivedBorderColor ?? "none"};
        }

        .voicify-assistant-chat-bot-item-minimal p  {
            margin: 0;
            overflow-wrap: break-word;
            flex: 1;
        }

        .voicify-assistant-chat-bot-item p  {
            margin: 0;
            overflow-wrap: break-word;
        }

        .voicify-assistant-hint-container {
            display: flex;
            flex-wrap: wrap;
        }

        .voicify-assistant-hint-button {
            border-width: ${styleSettings?.body?.hintsBorderWidth ?? "1px"};
            border-style: ${styleSettings?.body?.hintsBorderStyle ?? "solid"};
            border-color: ${styleSettings?.body?.hintsBorderColor ?? "#CBCCD2"};
            color: ${styleSettings?.body?.hintsTextColor ?? "#8F97A1"};
            margin-right: 8px;
            margin-bottom: 8px;
            line-height: 24px;
            font-size: ${styleSettings?.body?.hintsFontSize ?? "16px"};
            font-family: ${styleSettings?.body?.hintsFontFamily ?? "Helvetica"};
            background: ${styleSettings?.body?.hintsBackgroundColor ?? "white"};
            border-radius: ${styleSettings?.body?.hintsBorderRadius ?? "16px"};
            padding-top: ${styleSettings?.body?.hintsPaddingTop ?? "4px"};
            padding-bottom: ${styleSettings?.body?.hintsPaddingBottom ?? "4px"};
            padding-right: ${styleSettings?.body?.hintsPaddingRight ?? "16px"};
            padding-left: ${styleSettings?.body?.hintsPaddingLeft ?? "16px"};
            cursor: pointer;
        }

        .voicify-assistant-foreground-image {
            margin: 16px 0;
        }

        .voicify-assistant-audio-element {
            width: 100%;
            align-self: self-end;
        }

        .voicify-assistant-video-element {
            width: ${styleSettings?.body?.videoWidth ?? "100%"};
            height: ${styleSettings?.body?.videoHeight ?? "auto"};
            align-self: self-end;
        }

        .voicify-assistant-start-button {
            width: ${styleSettings?.start?.assistantImageButtonWidth ?? "50px"};
            height: ${styleSettings?.start?.assistantImageButtonHeight ?? "50px"};
            background: ${styleSettings?.start?.assistantImageBackgroundColor ?? "transparent"};
            border-width: ${styleSettings?.start?.assistantImageBorderWidth ?? "none"};
            border-style: ${styleSettings?.start?.assistantImageBorderStyle ?? "none"};
            border-color: ${styleSettings?.start?.assistantImageBorderColor ?? "none"};
            box-shadow: none;
            border-radius: ${styleSettings?.start?.assistantImageBorderRadius ?? "50%"}; 
            display: flex;
            align-items: center;
            justify-content: center;
            align-self: flex-end;
            margin: 16px 0 0 16px;
            cursor: pointer;
        }

        .voicify-assistant-start-button-minimal {
            width: ${styleSettings?.start?.assistantImageButtonWidth ?? "50px"};
            height: ${styleSettings?.start?.assistantImageButtonHeight ?? "50px"};
            background: ${styleSettings?.start?.assistantImageBackgroundColor ?? "transparent"};
            border-width: ${styleSettings?.start?.assistantImageBorderWidth ?? "none"};
            border-style: ${styleSettings?.start?.assistantImageBorderStyle ?? "none"};
            border-color: ${styleSettings?.start?.assistantImageBorderColor ?? "none"};
            box-shadow: none;
            border-radius: ${styleSettings?.start?.assistantImageBorderRadius ?? "50%"}; 
            display: flex;
            align-items: center;
            justify-content: center;
            align-self: center;
            margin: 16px 0 0 16px;
            cursor: pointer;
        }

        .voicify-assistant-start-button-slide-left {
            display: flex;
            align-items: center;
            justify-content: center;
            background: ${styleSettings?.start?.buttonBackgroundColor ?? "#3E77A5"};
            width: ${styleSettings?.start?.buttonWidth ?? "122px"};
            height: ${styleSettings?.start?.buttonHeight ?? "28px"};
            padding: ${styleSettings?.start?.buttonPadding ?? "4px 16px"};
            border-radius: ${styleSettings?.start?.buttonBorderRadius ?? "8px 8px 0px 0px"};
            transform: rotate(-90deg);
            cursor: pointer;
            border: ${styleSettings?.start?.buttonBorder ?? "none"};
            margin: ${styleSettings?.start?.buttonMargin ?? "0 -47px 122px 0"};
        }

        .voicify-assistant-start-button-slide-left-quick {
            display: flex;
            align-items: center;
            justify-content: center;
            background: ${styleSettings?.start?.buttonBackgroundColor ?? "#3E77A5"};
            width: ${styleSettings?.start?.buttonWidth ?? "122px"};
            height: ${styleSettings?.start?.buttonHeight ?? "28px"};
            padding: ${styleSettings?.start?.buttonPadding ?? "4px 16px"};
            border-radius: ${styleSettings?.start?.buttonBorderRadius ?? "8px 8px 0px 0px"};
            transform: rotate(-90deg);
            cursor: pointer;
            border: ${styleSettings?.start?.buttonBorder ?? "none"};
            margin: ${styleSettings?.start?.buttonMargin ?? "0 -47px 75px 0"};
        }

        .voicify-assistant-start-button-slide-up {
            width: ${styleSettings?.start?.buttonIconHeight ?? "24px"};
            height: ${styleSettings?.start?.buttonIconWidth ?? "24px"};
            display: flex;
            justify-content: center;
            align-items: center;
            background: transparent;
            border-radius: ${styleSettings?.start?.buttonBorderRadius ?? "50%"};
            border: none;
            box-shadow: none;
            cursor: pointer;
        }

        .voicify-assistant-start-icon-slide-up {
            width: ${styleSettings?.start?.slideFromBottomStartIconHeight ?? null};
            height: ${styleSettings?.start?.slideFromBottomStartIconWidth ?? null};
            margin-right: 16px;
            filter: ${styleSettings?.header?.minimizeAssistantColor ?? "invert(63%) sepia(8%) saturate(377%) hue-rotate(173deg) brightness(93%) contrast(90%)"};
        }

        .voicify-assistant-start-icon-slide-left {
            height: ${styleSettings?.start?.buttonIconHeight ?? "null"};
            width: ${styleSettings?.start?.buttonIconWidth ?? "null"};
            transform: rotate(90deg);
        }

        .voicify-assistant-start-icon-slide-left {
            margin-right: 4px;
        }

        .voicify-assistant-start-text-slide-left {
            font-family: ${styleSettings?.start?.buttonFontFamily ?? "Helvetica"};
            color: ${styleSettings?.start?.buttonFontColor ?? "#FFFFFF"};
            font-size: ${styleSettings?.start?.buttonFontSize ?? "14px"};
        }

        .voicify-assistant-start-icon {
            width: ${styleSettings?.start?.assistantImageWidth ?? "64px"};
            height: ${styleSettings?.start?.assistantImageHeight ?? "64px"};
            border-with: ${styleSettings?.start?.assistantImageBorderWidth ?? "none"};
            border-style: ${styleSettings?.start?.assistantImageBorderStyle ?? "none"};
            border-color: ${styleSettings?.start?.assistantImageBorderColor ?? "none"};
            height: auto;
            border-radius: ${styleSettings?.start?.assistantImageBorderRadius ?? "50%"};
        }
        
        ${customStyles ? customStyles : ""}

        @media (max-width: 767px) {
            .voicify-assistant-minimal-speaking-indicator {
                border-radius: 0;
            }
            .voicify-assistant-chat-container-minimal {
                border-radius: 0;
            }
            .voicify-assistant-chat-container-minimal-show-history {
                border-radius: 0;
            }
            .voicify-assistant-minimal-ui-container-left {
                flex: unset;
            }
            .voicify-assistant-minimal-ui-container-right {
                flex: unset;
            }
            .voicify-assistant-container-minimal-show-history {
                bottom: 16px;
            }
            .voicify-assistant-container-minimal {
                bottom: 16px;
            }
            .voicify-assistant-chat-history-minimal {
                border-radius: 0;
            }
            .voicify-assistant-toolbar-minimal-show-history {
                border-radius: 0;
            }
            .voicify-assistant-toolbar-minimal {
                border-radius: 0;
            }
            .voicify-assistant-container {
                bottom: 20px;
                right: 20px;
                display: flex;
                flex-grow: 1;
                max-width: 335px;
                position: fixed;
                margin: 20px 0 0 20px;
            }
            .voicify-assistant-chat-container {
                max-width: 335px;
            }
            .voicify-assistant-header {
                font-size: calc(${styleSettings?.header?.fontSize ?? "18px"} - 2px);
            }
            .voicify-assistant-header-minimal {
                border-radius: 0;
            }
            .voicify-assistant-container-slide-up {
                max-width: 335px;
            }
            .voicify-assistant-foreground-image {
                width: 75%;
                align-self: self-end;
            }
            .voicify-assistant-toolbar-bottom {
                padding-left: calc(${styleSettings?.toolbar?.paddingLeft ?? "16px"} - 8px);
                padding-right: calc(${styleSettings?.toolbar?.paddingRight ?? "16px"} - 8px);
                padding-top: calc(${styleSettings?.toolbar?.paddingTop ?? "16px"} - 8px);
                padding-bottom: calc(${styleSettings?.toolbar?.paddingBottom ?? "16px"} - 8px);
            }
            .voicify-assistant-toolbar-right {
                margin-left: 4px;
            }
            .voicify-assistant-logo {
                height: 36px;
                width: 36px;
                margin-right: 4px;
            }
            .voicify-assistant-microphone img {
                height: calc(${styleSettings?.toolbar?.micImageHeight ?? "48px"} - 12px);
                width: calc(${styleSettings?.toolbar?.micImageWidth ?? "48px"} - 12px);
            }
            .voicify-assistant-send-button {
                height: 24px;
            }
            .voicify-assistant-send-icon {
                height: 20px;
                width: 20px;
            }
            .voicify-assistant-textbox {
                width: 75px;
            }
        }

        @media (max-width: 360px) {
            .voicify-assistant-container {
                max-width: 240px;
            }
            .voicify-assistant-chat-container {
                max-width: 240px;
            }
            .voicify-assistant-container-slide-up {
                max-width: 240px;
            }
        }

    `;
    shadowRoot.append(style);
};
var $c4cac35f50f462b8$export$2e2bcd8739ae039 = $c4cac35f50f462b8$export$31f077b88a3c784c;
const $235c6899bda6e9e4$export$3de01744a82b21a4 = (serverRootUrl, configurationId, appId, appKey)=>{
    const endpoint = $2b1094d8e20ed12f$export$30c8d1ab699d63a9(serverRootUrl, configurationId, appId, appKey);
    return $parcel$interopDefault($g5Y9E$crossfetch)(endpoint, {
        method: "GET",
        headers: {
            "Content-Type": "application/json"
        }
    });
};
var $12f6f5131ef1d6e5$exports = {};
$12f6f5131ef1d6e5$exports = new URL(require("94e4ab7b8b3b7843")).toString();
var $b8df331e863bee3b$exports = {};
$b8df331e863bee3b$exports = new URL(require("e6e4efb568522e6c")).toString();
var $9767337aaf4ad16a$exports = {};
$9767337aaf4ad16a$exports = new URL(require("95e1032ca6d4ecf0")).toString();
var $ac7332a7c448758c$exports = {};
$ac7332a7c448758c$exports = new URL(require("175c5a52bcb3f53f")).toString();
var $8c63d1e07c11868d$exports = {};
$8c63d1e07c11868d$exports = new URL(require("9ba0f92d5f9c5815")).toString();
var $8aa9eb8bea72c70f$exports = {};
$8aa9eb8bea72c70f$exports = new URL(require("4adc080d90327b74")).toString();
var $c8ff5c492d91c2de$exports = {};
$c8ff5c492d91c2de$exports = new URL(require("484c8cb66ab1d3ab")).toString();
var $b969e6d37b28079d$exports = {};
$b969e6d37b28079d$exports = new URL(require("fcc33a652c256e66")).toString();
var $0da994af18b954dd$exports = {};
$0da994af18b954dd$exports = new URL(require("83141b9e5a199a30")).toString();
var $2414dd9c8473ff10$exports = {};
$2414dd9c8473ff10$exports = new URL(require("6170589963b3621b")).toString();
var $cea9f2a385e922e8$exports = {};
$cea9f2a385e922e8$exports = new URL(require("98a141a7709cef00")).toString();
const $e03ffcafbfaf1a3e$var$getCustomAssistantConfiguration = async (serverRootUrl, configurationId, appId, appKey)=>{
    try {
        const result = await $235c6899bda6e9e4$export$3de01744a82b21a4(serverRootUrl, configurationId, appId, appKey);
        let formattedResult = result.json();
        return formattedResult;
    } catch (e) {
        console.log(e);
        return e;
    }
};
const $e03ffcafbfaf1a3e$export$f7efacc29c799bcc = async (settings, rootId = "voicifyAssistantRoot")=>{
    if (settings.configurationId) {
        const dynamicSettings = await $e03ffcafbfaf1a3e$var$getCustomAssistantConfiguration(settings.serverRootUrl, settings.configurationId, settings.appId, settings.appKey);
        // Merge static settings object with dynamic settings coming from the API
        settings = {
            ...dynamicSettings,
            ...settings
        };
        // Ensure entire styles object isn't overridden by individually spreading each nested styles object
        if (settings.styles) {
            settings.styles.assistant = {
                ...dynamicSettings.styles?.assistant,
                ...settings.styles.assistant
            };
            settings.styles.header = {
                ...dynamicSettings.styles?.header,
                ...settings.styles.header
            };
            settings.styles.body = {
                ...dynamicSettings.styles?.body,
                ...settings.styles.body
            };
            settings.styles.toolbar = {
                ...dynamicSettings.styles?.toolbar,
                ...settings.styles.toolbar
            };
            settings.styles.start = {
                ...dynamicSettings.styles?.start,
                ...settings.styles.start
            };
        }
        settings.device = "Custom Assistant Browser SDK";
        settings.channel = settings.name ?? "My App";
    }
    const sttProvider = new $ec0952f503e2d812$export$a81102a23bf7a474(settings.locale);
    const ttsProvider = new $948554412ccc1cb4$export$5a827068c1cd9140(settings);
    window.voicifyAssistant = new $174052f0970457c1$export$148d4fde09622661(settings, ttsProvider, sttProvider, rootId);
    let assistantStatus = "initial";
    let micStatus = "off";
    let audioList = [];
    let videoList = [];
    let root = document.getElementById(rootId);
    const hasRoot = root != null;
    if (!root) {
        root = document.createElement("div");
        root.id = rootId;
        root.ariaRoleDescription = "complementary";
    }
    let shadowRoot = root.attachShadow({
        mode: "open"
    });
    let rootElement = document.createElement("div");
    shadowRoot.appendChild(rootElement);
    if (!hasRoot) document.body.appendChild(root);
    const uuidv4 = ()=>{
        return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function(c) {
            var r = Math.random() * 16 | 0, v = c === "x" ? r : r & 3 | 8;
            return v.toString(16);
        });
    };
    const scrollToBottomOfChat = ()=>{
        const chatDiv = shadowRoot.getElementById("voicify-assistant-chat-history");
        chatDiv?.scroll({
            top: chatDiv.scrollHeight,
            behavior: "smooth"
        });
    };
    function sanitize(str) {
        return str.replace(/&<"/g, function(m) {
            if (m === "&") return "&amp;";
            if (m === "<") return "&lt;";
            return "&quot;";
        });
    }
    const pauseAudio = ()=>{
        audioList.forEach((audioItem)=>{
            audioItem.pause();
        });
    };
    const pauseVideo = ()=>{
        videoList.forEach((videoItem)=>{
            videoItem.pause();
        });
    };
    const minimalUI = settings.uiType === "minimal";
    const assistantContainer = document.createElement("div");
    const header = document.createElement("div");
    const headerLeftContainer = document.createElement("div");
    const headerRightContainer = document.createElement("div");
    const minimizeButton = document.createElement("button");
    minimizeButton.type = "button";
    minimizeButton.className = "voicify-assistant-minimize-button";
    const minimizeIcon = document.createElement("img");
    minimizeButton.append(minimizeIcon);
    minimizeIcon.alt = "minimize";
    minimizeIcon.src = settings.styles?.header?.minimizeIcon ?? $2414dd9c8473ff10$exports;
    const closeButton = document.createElement("button");
    const closeIcon = document.createElement("img");
    closeIcon.alt = "close";
    closeIcon.src = settings.styles?.header?.closeAssistantButtonImage ?? $b8df331e863bee3b$exports;
    const headerText = document.createElement("p");
    if (settings.styles?.header?.assistantName) {
        headerText.innerText = settings.styles.header.assistantName;
        rootId = settings.styles.header.assistantName;
        root.ariaLabel = settings.styles.header.assistantName;
    }
    const logo = document.createElement("img");
    logo.alt = "assistant";
    logo.src = settings.styles?.header?.assistantImage ?? $12f6f5131ef1d6e5$exports;
    const chatHistory = document.createElement("div");
    const toolbar = document.createElement("div");
    const toolbarBottomRow = document.createElement("div");
    const minimalSpeakingIndicator = document.createElement("div");
    minimalSpeakingIndicator.className = "voicify-assistant-minimal-speaking-indicator";
    if (!minimalUI) toolbarBottomRow.className = "voicify-assistant-toolbar-bottom";
    else if (settings.showConversationHistory) toolbarBottomRow.className = "voicify-assistant-toolbar-bottom-minimal-show-history";
    else toolbarBottomRow.className = "voicify-assistant-toolbar-bottom-minimal";
    const toolbarLeftColumn = document.createElement("div");
    const toolbarRightColumn = document.createElement("div");
    const toolbarTopRow = document.createElement("div");
    const toolbarListeningRow = document.createElement("div");
    const toolbarTranscription = document.createElement("div");
    const toolbarTopRowBottomBorder = document.createElement("div");
    const toolbarHelp = document.createElement("div");
    toolbarHelp.innerText = settings.styles?.toolbar?.helpText ?? "How can I help?";
    const toolbarMuteContainer = document.createElement("div");
    const toolbarMuteText = document.createElement("div");
    toolbarMuteText.innerText = settings.styles?.toolbar?.muteText ?? "Stop Listening";
    const toolbarMuteIcon = document.createElement("img");
    toolbarMuteIcon.src = settings.styles?.toolbar?.muteImage ?? $cea9f2a385e922e8$exports;
    toolbarMuteIcon.alt = "mute";
    const toolbarAnimation = document.createElement("div");
    const toolbarState = document.createElement("div");
    toolbarState.innerText = settings.styles?.toolbar?.assistantStateText ?? "Listening...";
    const toolbarHeadingType = document.createElement("p");
    toolbarHeadingType.innerText = "TYPE";
    const textboxContainer = document.createElement("div");
    const textbox = document.createElement("input");
    textbox.placeholder = settings.styles?.toolbar?.placeholder ?? "Type something here";
    const send = document.createElement("button");
    send.type = "button";
    const sendIcon = document.createElement("img");
    sendIcon.alt = "send";
    sendIcon.src = settings.styles?.toolbar?.sendInactiveImage ?? $9767337aaf4ad16a$exports;
    const toolbarHeadingSpeak = document.createElement("p");
    toolbarHeadingSpeak.innerText = "SPEAK";
    const micIcon = document.createElement("img");
    if (!minimalUI) micIcon.className = "voicify-assistant-mic-inactive";
    else micIcon.className = "voicify-assistant-mic-inactive-minimal";
    const microphone = document.createElement("button");
    microphone.type = "button";
    micIcon.src = settings.styles?.toolbar?.micInactiveImage ?? $c8ff5c492d91c2de$exports;
    micIcon.alt = "record";
    const keyboardIcon = document.createElement("img");
    keyboardIcon.className = "voicify-assistant-keyboard-inactive";
    const keyboard = document.createElement("button");
    keyboard.type = "button";
    keyboardIcon.src = settings.styles?.toolbar?.keyboardInactiveImage ?? $8aa9eb8bea72c70f$exports;
    keyboardIcon.alt = "type";
    const startButton = document.createElement("button");
    const startIcon = document.createElement("img");
    startIcon.alt = "start";
    startButton.type = "button";
    const minimalUIContainer = document.createElement("div");
    const minimalUIContainerLeft = document.createElement("div");
    const minimalUIContainerRight = document.createElement("div");
    minimalUIContainer.className = "voicify-assistant-minimal-ui-container";
    minimalUIContainerLeft.className = "voicify-assistant-minimal-ui-container-left";
    minimalUIContainerRight.className = "voicify-assistant-minimal-ui-container-right";
    const buildUserMessage = (message)=>{
        const messageItem = document.createElement("p");
        if (!minimalUI) messageItem.className = "voicify-assistant-chat-user-item";
        else messageItem.className = "voicify-assistant-chat-user-item-minimal";
        messageItem.innerText = message;
        chatHistory.appendChild(messageItem);
        scrollToBottomOfChat();
    };
    const buildBotMessage = (message, hints, image, audio, video)=>{
        const messageItemContainer = document.createElement("div");
        messageItemContainer.className = "voicify-assistant-chat-bot-container";
        const messageItemLeftColumn = document.createElement("div");
        messageItemLeftColumn.className = "voicify-assistant-chat-bot-container-left";
        const messageItemRightColumn = document.createElement("div");
        if (!minimalUI) {
            messageItemRightColumn.className = "voicify-assistant-chat-bot-container-right";
            const botAvatar = document.createElement("img");
            botAvatar.alt = "assistant avatar";
            botAvatar.src = settings.styles?.body?.assistantImage ?? $12f6f5131ef1d6e5$exports;
            botAvatar.className = "voicify-assistant-chat-bot-avatar";
            messageItemLeftColumn.appendChild(botAvatar);
        } else messageItemRightColumn.className = "voicify-assistant-chat-bot-container-right-minimal";
        const messageItem = document.createElement("p");
        if (!minimalUI) messageItem.className = "voicify-assistant-chat-bot-item";
        else messageItem.className = "voicify-assistant-chat-bot-item-minimal";
        if (message) {
            if (ttsProvider) {
                pauseAudio();
                pauseVideo();
            }
            messageItem.innerHTML = $g5Y9E$marked.parse(message);
            // Resize markdown images using Marked.js package: https://github.com/markedjs/marked/issues/339
            const renderer = new $g5Y9E$marked.Renderer();
            renderer.image = function(src, title, alt) {
                // The below RegEx enables image resizing directly in markdown in the following format:
                // ![alt](https://markdown-img.jpg "=250x250")
                const exec = /=\s*(\d*)\s*x\s*(\d*)\s*$/.exec(title);
                let res = '<img src="' + sanitize(src) + '" alt="' + sanitize(alt);
                if (exec && exec[1]) res += '" height="' + exec[1];
                if (exec && exec[2]) res += '" width="' + exec[2];
                return res + '">';
            };
            $g5Y9E$marked.setOptions({
                renderer: renderer
            });
            const aTagList = messageItem.querySelectorAll("a");
            aTagList.forEach((aTag)=>{
                aTag.setAttribute("target", "_blank");
            });
            messageItemRightColumn.appendChild(messageItem);
        }
        const hintContainer = document.createElement("div");
        if (hints && !minimalUI) {
            hintContainer.className = "voicify-assistant-hint-container";
            hints?.map((hint)=>{
                const hintButton = document.createElement("button");
                hintButton.className = "voicify-assistant-hint-button";
                hintButton.innerText = hint;
                hintContainer.appendChild(hintButton);
                hintButton.onclick = ()=>{
                    window.voicifyAssistant.makeTextRequest(hintButton.innerText);
                };
            });
            messageItemRightColumn.appendChild(hintContainer);
        }
        if (!minimalUI) messageItemContainer.appendChild(messageItemLeftColumn);
        messageItemContainer.appendChild(messageItemRightColumn);
        chatHistory.appendChild(messageItemContainer);
        const foregroundImage = document.createElement("img");
        foregroundImage.alt = "assistant response";
        if (image && !minimalUI) {
            const handleForegroundImageError = ()=>{
                foregroundImage.src = $12f6f5131ef1d6e5$exports;
            };
            foregroundImage.className = "voicify-assistant-foreground-image";
            foregroundImage.src = image;
            foregroundImage.onerror = handleForegroundImageError;
            foregroundImage.onload = scrollToBottomOfChat;
            chatHistory.appendChild(foregroundImage);
        }
        if (audio) {
            const audioElement = document.createElement("audio");
            audioElement.controls = true;
            audioElement.src = audio;
            audioElement.autoplay = true;
            audioElement.className = "voicify-assistant-audio-element";
            audioElement.id = "voicify-assistant-audio-element-" + uuidv4();
            if (!audioList.includes(audioElement)) audioList.push(audioElement);
            messageItemContainer.appendChild(messageItemLeftColumn);
            messageItemRightColumn.appendChild(audioElement);
            messageItemContainer.appendChild(messageItemRightColumn);
            chatHistory.appendChild(messageItemContainer);
            audioElement.addEventListener("play", function(e) {
                pauseVideo();
                audioList.forEach((audioItem)=>{
                    if (audioItem && audioItem != e.target) audioItem.pause();
                });
            }, true);
        }
        if (video && !minimalUI) {
            const videoElement = document.createElement("video");
            videoElement.controls = true;
            videoElement.innerHTML = "Your browser does not support the video tag.";
            videoElement.src = video;
            videoElement.className = "voicify-assistant-video-element";
            videoElement.id = "voicify-assistant-video-element-" + uuidv4();
            if (!videoList.includes(videoElement)) videoList.push(videoElement);
            messageItemContainer.appendChild(messageItemLeftColumn);
            messageItemRightColumn.appendChild(videoElement);
            messageItemContainer.appendChild(messageItemRightColumn);
            chatHistory.appendChild(messageItemContainer);
            videoElement.addEventListener("play", function(e) {
                pauseAudio();
                videoList.forEach((videoItem)=>{
                    if (videoItem && videoItem != e.target) videoItem.pause();
                });
            }, true);
        }
        scrollToBottomOfChat();
    };
    const buildChatHistory = ()=>{
        const localStorageChatHistory = window.voicifyAssistant.getChatHistoryItems();
        if (localStorageChatHistory.length >= 1 && window.voicifyAssistant.isExistingSession()) localStorageChatHistory.forEach((chatItem)=>{
            if (chatItem.type === "user" && (chatItem.content != undefined || null)) buildUserMessage(chatItem.content.text);
            if (chatItem.type === "bot") buildBotMessage(chatItem.content.text, chatItem.content.hints, chatItem.content.image, chatItem.content.audio, chatItem.content.video);
        });
    };
    const styleChatContainer = ()=>{
        if (!minimalUI) {
            if (settings.initializeWithWelcomeMessage) {
                if (settings.uiType === "slideFromBottom") assistantContainer.className = "voicify-assistant-chat-container-slide-up";
                else assistantContainer.className = "voicify-assistant-chat-container";
            } else assistantContainer.className = "voicify-assistant-chat-container-quick";
        } else if (settings.showConversationHistory) assistantContainer.className = "voicify-assistant-chat-container-minimal-show-history";
        else assistantContainer.className = "voicify-assistant-chat-container-minimal";
    };
    const styleHeader = ()=>{
        closeButton.id = "voicify-assistant-close-button-id";
        closeButton.append(closeIcon);
        closeIcon.className = "voicify-assistant-close-icon";
        if (!minimalUI) {
            closeButton.className = "voicify-assistant-close-button";
            assistantContainer.appendChild(header);
            switch(settings.uiType){
                case "bottomRightButton":
                    header.className = "voicify-assistant-header voicify-assistant-header-bottom-right-button";
                    headerRightContainer.append(minimizeButton);
                    break;
                case "slideFromRight":
                    header.className = "voicify-assistant-header voicify-assistant-header-slide-left";
                    headerRightContainer.append(minimizeButton);
                    break;
                case "slideFromBottom":
                    header.className = "voicify-assistant-header voicify-assistant-header-slide-up";
                    headerRightContainer.append(startButton);
                    break;
                default:
                    header.className = "voicify-assistant-header voicify-assistant-header-bottom-right-button";
                    headerRightContainer.append(minimizeButton);
                    break;
            }
            headerLeftContainer.className = "voicify-assistant-header-left";
            header.append(headerLeftContainer);
            headerRightContainer.className = "voicify-assistant-header-right";
            header.append(headerRightContainer);
            headerRightContainer.append(closeButton);
            logo.className = "voicify-assistant-logo";
            headerLeftContainer.appendChild(logo);
            headerLeftContainer.appendChild(headerText);
        } else {
            closeButton.className = "voicify-assistant-close-button-minimal";
            assistantContainer.appendChild(closeButton);
        }
    };
    const styleChatHistory = ()=>{
        if (settings.showConversationHistory) {
            assistantContainer.appendChild(chatHistory);
            if (!minimalUI) {
                if (settings.initializeWithWelcomeMessage) chatHistory.className = "voicify-assistant-chat-history";
                else chatHistory.className = "voicify-assistant-chat-history-hidden";
            } else if (settings.initializeWithWelcomeMessage) chatHistory.className = "voicify-assistant-chat-history-minimal";
            else chatHistory.className = "voicify-assistant-chat-history-minimal-hidden";
            chatHistory.id = "voicify-assistant-chat-history";
        }
    };
    const showSpeakingIndicator = ()=>{
        micIcon.src = settings.styles?.toolbar?.micActiveImage ?? $8c63d1e07c11868d$exports;
        if (!minimalUI) micIcon.className = "voicify-assistant-mic-active";
        else micIcon.className = "voicify-assistant-mic-active-minimal";
        toolbarHeadingSpeak.className = "voicify-assistant-toolbar-speak-active";
        toolbarTopRow.className = "voicify-assistant-toolbar-top";
        if (minimalUI) {
            if (settings.showConversationHistory) toolbar.appendChild(minimalSpeakingIndicator);
            else {
                assistantContainer?.appendChild(minimalSpeakingIndicator);
                toolbar.className = "voicify-assistant-toolbar-minimal-speaking";
            }
        }
    };
    const hideSpeakingIndicator = ()=>{
        micIcon.src = settings.styles?.toolbar?.micInactiveImage ?? $c8ff5c492d91c2de$exports;
        if (!minimalUI) micIcon.className = "voicify-assistant-mic-inactive";
        else micIcon.className = "voicify-assistant-mic-inactive-minimal";
        toolbarHeadingSpeak.className = "voicify-assistant-toolbar-speak-inactive";
        if (minimalUI) {
            if (settings.showConversationHistory && minimalSpeakingIndicator.parentElement === toolbar) toolbar.removeChild(minimalSpeakingIndicator);
            else if (!settings.showConversationHistory && minimalSpeakingIndicator.parentElement === assistantContainer) {
                assistantContainer?.removeChild(minimalSpeakingIndicator);
                toolbar.className = "voicify-assistant-toolbar-minimal";
            }
        }
    };
    const scrollToEndOfPartial = ()=>{
        toolbarTranscription.scrollLeft = toolbarTranscription.scrollWidth;
    };
    const displayTranscription = (speech)=>{
        toolbarTranscription.innerText = speech;
        scrollToEndOfPartial();
    };
    const clearTranscription = ()=>{
        toolbarTranscription.innerText = "";
    };
    const toggleListening = ()=>{
        if (micStatus === "off") {
            micStatus = "on";
            showSpeakingIndicator();
            pauseAudio();
            if (ttsProvider) ttsProvider.stop();
            sttProvider?.startListening();
            sttProvider?.addPartialListener((partialSpeechResult)=>{
                displayTranscription(partialSpeechResult);
            });
            sttProvider?.addFinishListener(()=>{
                hideSpeakingIndicator();
                sttProvider?.stopListening();
            });
            sttProvider?.addEndListener(()=>{
                micStatus = "off";
                hideSpeakingIndicator();
                toolbarTopRow.className = "voicify-assistant-toolbar-top-hidden";
            });
            sttProvider?.addNoMatchListener(()=>{
                hideSpeakingIndicator();
                toolbarTopRow.className = "voicify-assistant-toolbar-top-hidden";
            });
        } else if (micStatus === "on") {
            micStatus = "off";
            sttProvider?.stopListening();
            sttProvider?.addEndListener(()=>{
                hideSpeakingIndicator();
                toolbarTopRow.className = "voicify-assistant-toolbar-top-hidden";
            });
        }
    };
    const styleToolbar = ()=>{
        assistantContainer.appendChild(toolbar);
        const numberOfBars = 11;
        for(let i = 1; i <= numberOfBars; i++){
            const bar = document.createElement("div");
            bar.className = `voicify-assistant-bar-${i} voicify-assistant-bar`;
            toolbarAnimation.appendChild(bar);
        }
        switch(settings.uiType){
            case "bottomRightButton":
                toolbar.className = "voicify-assistant-toolbar voicify-assistant-toolbar-bottom-right-button";
                break;
            case "slideFromRight":
                toolbar.className = "voicify-assistant-toolbar voicify-assistant-toolbar-slide";
                break;
            case "slideFromBottom":
                toolbar.className = "voicify-assistant-toolbar voicify-assistant-toolbar-slide";
                break;
            case "minimal":
                if (settings.showConversationHistory) toolbar.className = "voicify-assistant-toolbar-minimal-show-history";
                else toolbar.className = "voicify-assistant-toolbar-minimal";
                break;
            default:
                toolbar.className = "voicify-assistant-toolbar voicify-assistant-toolbar-bottom-right-button";
                break;
        }
        toolbarLeftColumn.className = "voicify-assistant-toolbar-left-no-mic";
        if (!minimalUI) toolbarRightColumn.className = "voicify-assistant-toolbar-right";
        else toolbarRightColumn.className = "voicify-assistant-toolbar-right-minimal";
        toolbarTopRow.className = "voicify-assistant-toolbar-top-hidden";
        toolbarTopRowBottomBorder.className = "voicify-assistant-toolbar-top-bottom-border";
        toolbarListeningRow.className = "voicify-assistant-toolbar-listening-row";
        toolbarState.className = "voicify-assistant-toolbar-state";
        toolbarMuteContainer.className = "voicify-assistant-toolbar-mute-container";
        toolbarMuteText.className = "voicify-assistant-toolbar-mute-text";
        toolbarMuteIcon.className = "voicify-assistant-toolbar-mute-icon";
        if (!minimalUI) toolbarTranscription.className = "voicify-assistant-toolbar-transcription";
        else toolbarTranscription.className = "voicify-assistant-toolbar-transcription-minimal";
        toolbarAnimation.className = "voicify-assistant-toolbar-animation";
        toolbarHelp.className = "voicify-assistant-toolbar-help";
        toolbarMuteContainer.appendChild(toolbarMuteText);
        toolbarMuteContainer.appendChild(toolbarMuteIcon);
        toolbarListeningRow.appendChild(toolbarState);
        toolbarListeningRow.appendChild(toolbarMuteContainer);
        if (!minimalUI) {
            toolbarTopRow.appendChild(toolbarHelp);
            toolbarTopRow.appendChild(toolbarAnimation);
            toolbarTopRow.appendChild(toolbarListeningRow);
            toolbarTopRow.appendChild(toolbarTranscription);
            toolbarTopRow.appendChild(toolbarTopRowBottomBorder);
        }
        toolbarHeadingType.className = "voicify-assistant-toolbar-type-inactive";
        if (!minimalUI) textbox.className = "voicify-assistant-textbox";
        else textbox.className = "voicify-assistant-textbox-minimal";
        textbox.onfocus = ()=>{
            sttProvider?.stopListening();
            if (!minimalUI) {
                textboxContainer.className = "voicify-assistant-input-container-active";
                sendIcon.className = "voicify-assistant-send-icon";
                micIcon.className = "voicify-assistant-mic-inactive";
                textbox.className = "voicify-assistant-textbox-active";
            } else {
                textboxContainer.className = "voicify-assistant-input-container-active-minimal";
                sendIcon.className = "voicify-assistant-send-icon-minimal";
                micIcon.className = "voicify-assistant-mic-inactive-minimal";
                textbox.className = "voicify-assistant-textbox-active-minimal";
            }
            micIcon.src = settings.styles?.toolbar?.micInactiveImage ?? $c8ff5c492d91c2de$exports;
            toolbarHeadingType.className = "voicify-assistant-toolbar-type-active";
            sendIcon.src = settings.styles?.toolbar?.sendActiveImage ?? $ac7332a7c448758c$exports;
            toolbarHeadingSpeak.className = "voicify-assistant-toolbar-speak-inactive";
            toolbarTopRow.className = "voicify-assistant-toolbar-top-hidden";
        };
        textbox.onblur = ()=>{
            micStatus = "off";
            if (!minimalUI) textboxContainer.className = "voicify-assistant-input-container-inactive";
            else textboxContainer.className = "voicify-assistant-input-container-inactive-minimal";
            if (!minimalUI) sendIcon.className = "voicify-assistant-send-icon-inactive";
            else sendIcon.className = "voicify-assistant-send-icon-inactive-minimal";
            toolbarHeadingType.className = "voicify-assistant-toolbar-type-inactive";
            sendIcon.src = settings.styles?.toolbar?.sendInactiveImage ?? $9767337aaf4ad16a$exports;
            if (!minimalUI) textbox.className = "voicify-assistant-textbox";
            else textbox.className = "voicify-assistant-textbox-minimal";
        };
        if (!minimalUI) textboxContainer.className = "voicify-assistant-input-container-inactive";
        else textboxContainer.className = "voicify-assistant-input-container-inactive-minimal";
        if (!minimalUI) send.className = "voicify-assistant-send-button";
        else send.className = "voicify-assistant-send-button-minimal";
        if (!minimalUI) sendIcon.className = "voicify-assistant-send-icon-inactive";
        else sendIcon.className = "voicify-assistant-send-icon-inactive-minimal";
        send.appendChild(sendIcon);
        textboxContainer.appendChild(textbox);
        textboxContainer.appendChild(send);
        if (!minimalUI) {
            toolbarRightColumn.appendChild(toolbarHeadingType);
            toolbarRightColumn.appendChild(textboxContainer);
        } else toolbarRightColumn.appendChild(toolbarTranscription);
        toolbarHeadingSpeak.className = "voicify-assistant-toolbar-speak-inactive";
        if (sttProvider?.isSpeechRecognitionAvailable() && settings.useVoiceInput) {
            if (!minimalUI) {
                toolbarLeftColumn.className = "voicify-assistant-toolbar-left";
                microphone.className = "voicify-assistant-microphone";
            } else {
                toolbarLeftColumn.className = "voicify-assistant-toolbar-left-minimal";
                microphone.className = "voicify-assistant-microphone-minimal";
            }
            microphone.appendChild(micIcon);
            microphone.onclick = ()=>{
                if (!minimalUI) toggleListening();
                if (minimalUI) {
                    pauseAudio();
                    toolbarLeftColumn.removeChild(microphone);
                    toolbarLeftColumn.appendChild(keyboard);
                    toolbarRightColumn.removeChild(textboxContainer);
                    toolbarRightColumn.appendChild(toolbarTranscription);
                }
                if (minimalUI && settings.autoRunConversation && settings.useOutputSpeech) {
                    ttsProvider.stop();
                    sttProvider.startListening();
                    sttProvider?.addPartialListener((partialSpeechResult)=>{
                        displayTranscription(partialSpeechResult);
                    });
                    sttProvider?.addStartListener(()=>{
                        showSpeakingIndicator();
                    });
                    sttProvider?.addFinishListener(()=>{
                        hideSpeakingIndicator();
                    });
                    ttsProvider.addFinishListener(()=>{
                        sttProvider.startListening();
                    });
                    sttProvider.addEndListener(()=>{
                        clearTranscription();
                    });
                }
            };
            keyboard.className = "voicify-assistant-keyboard";
            keyboard.appendChild(keyboardIcon);
            keyboard.onclick = ()=>{
                window.voicifyAssistant.clearSpeechTimeout();
                ttsProvider.clearHandlers();
                pauseAudio();
                sttProvider?.stopListening();
                sttProvider?.addEndListener(()=>{
                    hideSpeakingIndicator();
                });
                toolbarLeftColumn.removeChild(keyboard);
                toolbarLeftColumn.appendChild(microphone);
                toolbarRightColumn.removeChild(toolbarTranscription);
                toolbarRightColumn.appendChild(textboxContainer);
                if (settings.activeInput === "textbox") textbox.focus();
            };
            toolbarMuteContainer.onclick = ()=>{
                toggleListening();
            };
            if (minimalUI) {
                if (toolbarLeftColumn.hasChildNodes()) toolbarLeftColumn.replaceChildren(keyboard);
                else toolbarLeftColumn.appendChild(keyboard);
            } else if (toolbarLeftColumn.hasChildNodes()) toolbarLeftColumn.replaceChildren(toolbarHeadingSpeak, microphone);
            else {
                toolbarLeftColumn.appendChild(toolbarHeadingSpeak);
                toolbarLeftColumn.appendChild(microphone);
            }
        }
    };
    const styleBottomRightButtonStartButton = ()=>{
        startButton.className = "voicify-assistant-start-button";
        startIcon.src = settings.styles?.start?.assistantImage ?? $12f6f5131ef1d6e5$exports;
        startIcon.className = "voicify-assistant-start-icon";
        startButton.append(startIcon);
        if (rootElement) rootElement.appendChild(startButton);
    };
    const styleMinimalStartButton = ()=>{
        startButton.className = "voicify-assistant-start-button-minimal";
        startIcon.src = settings.styles?.start?.assistantImage ?? $12f6f5131ef1d6e5$exports;
        startIcon.className = "voicify-assistant-start-icon";
        startButton.append(startIcon);
        if (rootElement) {
            rootElement.appendChild(minimalUIContainerLeft);
            rootElement.appendChild(minimalUIContainer);
            rootElement.appendChild(minimalUIContainerRight);
            minimalUIContainer.appendChild(startButton);
        }
    };
    const styleSlideFromRightStartButton = ()=>{
        const startText = document.createElement("div");
        startText.innerText = settings.styles?.start?.buttonText ?? "Assistant";
        startText.className = "voicify-assistant-start-text-slide-left";
        const startButtonIcon = document.createElement("img");
        startButtonIcon.src = settings.styles?.start?.slideFromRightStartButtonIcon ?? $b969e6d37b28079d$exports;
        startButtonIcon.className = "voicify-assistant-start-icon-slide-left voicify-assistant-start-icon-slide-left";
        if (settings.initializeWithWelcomeMessage) startButton.className = "voicify-assistant-start-button-slide-left";
        else startButton.className = "voicify-assistant-start-button-slide-left-quick";
        startButton.append(startButtonIcon);
        startButton.append(startText);
        if (rootElement) rootElement.appendChild(startButton);
    };
    const styleSlideFromBottomStartButton = ()=>{
        startButton.className = "voicify-assistant-start-button-slide-up";
        startIcon.src = settings.styles?.start?.slideFromBottomStartIcon ?? $0da994af18b954dd$exports;
        startIcon.className = "voicify-assistant-start-icon-slide-up";
        startButton.append(startIcon);
        headerRightContainer.removeChild(closeButton);
        if (rootElement) rootElement.appendChild(header);
    };
    const createbottomRightButtonUi = ()=>{
        if (rootElement) rootElement.className += "voicify-assistant-container";
        styleChatContainer();
        styleHeader();
        styleChatHistory();
        styleToolbar();
        styleBottomRightButtonStartButton();
    };
    const createslideFromRightUi = ()=>{
        if (rootElement) rootElement.className += "voicify-assistant-container-slide-left";
        styleChatContainer();
        styleHeader();
        styleChatHistory();
        styleToolbar();
        styleSlideFromRightStartButton();
    };
    const createslideFromBottomUi = ()=>{
        if (rootElement) rootElement.className += "voicify-assistant-container-slide-up";
        styleChatContainer();
        styleHeader();
        styleChatHistory();
        styleToolbar();
        styleSlideFromBottomStartButton();
    };
    const createMinimalUi = ()=>{
        if (rootElement && settings.showConversationHistory) rootElement.className += "voicify-assistant-container-minimal-show-history";
        else rootElement.className += "voicify-assistant-container-minimal";
        styleChatContainer();
        styleHeader();
        styleChatHistory();
        styleToolbar();
        styleMinimalStartButton();
    };
    const setUIType = ()=>{
        switch(settings.uiType){
            case "bottomRightButton":
                createbottomRightButtonUi();
                break;
            case "slideFromRight":
                createslideFromRightUi();
                break;
            case "slideFromBottom":
                createslideFromBottomUi();
                break;
            case "minimal":
                createMinimalUi();
                break;
            default:
                createbottomRightButtonUi();
                break;
        }
    };
    textbox.onkeyup = (e)=>{
        if (e.key.toLowerCase() == "enter") send.click();
    };
    send.onclick = ()=>{
        window.voicifyAssistant.makeTextRequest(textbox.value);
        textbox.value = "";
    };
    startButton.onclick = ()=>{
        handleAssistantClick();
        if (settings.activeInput === "textbox") textbox.focus();
    };
    const endAssistant = ()=>{
        ttsProvider?.stop();
        window.voicifyAssistant.endSession();
        while(chatHistory.lastElementChild)chatHistory.removeChild(chatHistory.lastElementChild);
        if (settings.uiType === "slideFromBottom") {
            headerRightContainer.removeChild(closeButton);
            startIcon.src = settings.styles?.start?.slideFromBottomStartIcon ?? $0da994af18b954dd$exports;
        }
        if (minimalUI) {
            minimalUIContainer?.removeChild(assistantContainer);
            minimalUIContainer?.appendChild(startButton);
        } else rootElement?.removeChild(assistantContainer);
        assistantStatus = "initial";
    };
    closeButton.onclick = ()=>{
        if (settings.uiType === "minimal") {
            ttsProvider.stop();
            sttProvider.stopListening();
            ttsProvider.clearHandlers();
            minimizeAssistant();
        } else endAssistant();
    };
    minimizeButton.onclick = ()=>{
        minimizeAssistant();
    };
    const openAssistant = ()=>{
        assistantStatus = "open";
        switch(settings.uiType){
            case "bottomRightButton":
                rootElement?.appendChild(assistantContainer);
                rootElement?.appendChild(startButton);
                toolbarBottomRow.replaceChildren(toolbarLeftColumn, toolbarRightColumn);
                toolbar.appendChild(toolbarTopRow);
                toolbar.appendChild(toolbarBottomRow);
                break;
            case "slideFromRight":
                rootElement?.appendChild(startButton);
                rootElement?.appendChild(assistantContainer);
                toolbarBottomRow.replaceChildren(toolbarLeftColumn, toolbarRightColumn);
                toolbar.appendChild(toolbarTopRow);
                toolbar.appendChild(toolbarBottomRow);
                break;
            case "slideFromBottom":
                startIcon.src = settings.styles?.header?.minimizeIcon ?? $2414dd9c8473ff10$exports;
                headerRightContainer.appendChild(closeButton);
                rootElement?.appendChild(assistantContainer);
                toolbarBottomRow.replaceChildren(toolbarLeftColumn, toolbarRightColumn);
                toolbar.appendChild(toolbarTopRow);
                toolbar.appendChild(toolbarBottomRow);
                break;
            case "minimal":
                rootElement?.appendChild(minimalUIContainerLeft);
                rootElement?.appendChild(minimalUIContainer);
                rootElement?.appendChild(minimalUIContainerRight);
                minimalUIContainer?.removeChild(startButton);
                minimalUIContainer?.appendChild(assistantContainer);
                if (toolbarLeftColumn.contains(microphone)) {
                    toolbarLeftColumn.removeChild(microphone);
                    toolbarLeftColumn.appendChild(keyboard);
                }
                if (toolbarRightColumn.contains(textboxContainer)) {
                    toolbarRightColumn.removeChild(textboxContainer);
                    toolbarRightColumn.appendChild(toolbarTranscription);
                }
                toolbarBottomRow.replaceChildren(toolbarLeftColumn, toolbarRightColumn);
                toolbar.appendChild(toolbarBottomRow);
                break;
            default:
                rootElement?.appendChild(assistantContainer);
                rootElement?.appendChild(startButton);
                toolbarBottomRow.replaceChildren(toolbarLeftColumn, toolbarRightColumn);
                toolbar.appendChild(toolbarTopRow);
                toolbar.appendChild(toolbarBottomRow);
                break;
        }
    };
    const startAssistant = ()=>{
        assistantStatus = "open";
        switch(settings.uiType){
            case "bottomRightButton":
                rootElement?.removeChild(startButton);
                rootElement?.appendChild(assistantContainer);
                rootElement?.appendChild(startButton);
                toolbarBottomRow.replaceChildren(toolbarLeftColumn, toolbarRightColumn);
                toolbar.appendChild(toolbarTopRow);
                toolbar.appendChild(toolbarBottomRow);
                break;
            case "slideFromRight":
                rootElement?.removeChild(startButton);
                rootElement?.appendChild(startButton);
                rootElement?.appendChild(assistantContainer);
                toolbarBottomRow.replaceChildren(toolbarLeftColumn, toolbarRightColumn);
                toolbar.appendChild(toolbarTopRow);
                toolbar.appendChild(toolbarBottomRow);
                break;
            case "slideFromBottom":
                startIcon.src = settings.styles?.header?.minimizeIcon ?? $2414dd9c8473ff10$exports;
                headerRightContainer.appendChild(closeButton);
                rootElement?.appendChild(assistantContainer);
                toolbarBottomRow.replaceChildren(toolbarLeftColumn, toolbarRightColumn);
                toolbar.appendChild(toolbarTopRow);
                toolbar.appendChild(toolbarBottomRow);
                break;
            case "minimal":
                rootElement?.removeChild(minimalUIContainerLeft);
                rootElement?.removeChild(minimalUIContainer);
                rootElement?.removeChild(minimalUIContainerRight);
                rootElement?.appendChild(minimalUIContainerLeft);
                rootElement?.appendChild(minimalUIContainer);
                rootElement?.appendChild(minimalUIContainerRight);
                minimalUIContainer?.removeChild(startButton);
                minimalUIContainer?.appendChild(assistantContainer);
                if (toolbarLeftColumn.contains(microphone)) {
                    toolbarLeftColumn.removeChild(microphone);
                    toolbarLeftColumn.appendChild(keyboard);
                    toolbarRightColumn.removeChild(textboxContainer);
                    toolbarRightColumn.appendChild(toolbarTranscription);
                }
                toolbarBottomRow.replaceChildren(toolbarLeftColumn, toolbarRightColumn);
                toolbar.appendChild(toolbarBottomRow);
                break;
            default:
                rootElement?.removeChild(startButton);
                rootElement?.appendChild(assistantContainer);
                rootElement?.appendChild(startButton);
                toolbarBottomRow.replaceChildren(toolbarLeftColumn, toolbarRightColumn);
                toolbar.appendChild(toolbarTopRow);
                toolbar.appendChild(toolbarBottomRow);
                break;
        }
    };
    const minimizeAssistant = ()=>{
        window.voicifyAssistant.clearSpeechTimeout();
        if (ttsProvider) ttsProvider.stop();
        if (settings.uiType === "slideFromBottom") {
            headerRightContainer.removeChild(closeButton);
            startIcon.src = settings.styles?.start?.slideFromBottomStartIcon ?? $0da994af18b954dd$exports;
        }
        assistantStatus = "closed";
        if (!minimalUI) rootElement?.removeChild(assistantContainer);
        else {
            hideSpeakingIndicator();
            minimalUIContainer?.removeChild(assistantContainer);
            minimalUIContainer?.appendChild(startButton);
        }
    };
    const handleSpeechTimeout = ()=>{
        minimizeAssistant();
    };
    const handleAssistantClick = ()=>{
        switch(assistantStatus){
            case "initial":
                startAssistant();
                if (settings.initializeWithWelcomeMessage === false && !minimalUI) {
                    assistantContainer.className = "voicify-assistant-chat-container-quick";
                    chatHistory.className = "voicify-assistant-chat-history-hidden";
                }
                window.voicifyAssistant.startNewSession();
                window.voicifyAssistant.initializeAndStart(handleSpeechTimeout);
                if (settings.autoRunConversation && settings.useOutputSpeech) {
                    sttProvider?.addPartialListener((partialSpeechResult)=>{
                        displayTranscription(partialSpeechResult);
                    });
                    sttProvider?.addStartListener(()=>{
                        showSpeakingIndicator();
                    });
                    sttProvider?.addFinishListener(()=>{
                        hideSpeakingIndicator();
                    });
                    sttProvider.addEndListener(()=>{
                        clearTranscription();
                    });
                    if (minimalUI) ttsProvider.addFinishListener(()=>{
                        sttProvider.startListening();
                    });
                }
                scrollToBottomOfChat();
                break;
            case "existing":
                openAssistant();
                scrollToBottomOfChat();
                break;
            case "open":
                if (settings.initializeWithWelcomeMessage === false && !minimalUI) {
                    assistantContainer.className = "voicify-assistant-chat-container";
                    chatHistory.className = "voicify-assistant-chat-history";
                }
                if (minimalUI) {
                    assistantContainer.className = "voicify-assistant-chat-container-minimal";
                    chatHistory.className = "voicify-assistant-chat-history-minimal";
                }
                minimizeAssistant();
                scrollToBottomOfChat();
                break;
            case "closed":
                startAssistant();
                if (settings.autoRunConversation && settings.useOutputSpeech) {
                    sttProvider?.startListening();
                    sttProvider?.addPartialListener((partialSpeechResult)=>{
                        displayTranscription(partialSpeechResult);
                    });
                    sttProvider?.addStartListener(()=>{
                        showSpeakingIndicator();
                    });
                    sttProvider?.addFinishListener(()=>{
                        hideSpeakingIndicator();
                    });
                    sttProvider.addEndListener(()=>{
                        clearTranscription();
                    });
                    if (minimalUI) {
                        ttsProvider.stop();
                        ttsProvider.addFinishListener(()=>{
                            sttProvider.startListening();
                        });
                    }
                }
                scrollToBottomOfChat();
                break;
        }
    };
    const createAssistant = ()=>{
        setUIType();
        if (window.voicifyAssistant.isExistingSession()) {
            assistantStatus = "existing";
            handleAssistantClick();
            window.voicifyAssistant.initializeExistingSession(handleSpeechTimeout);
        }
        buildChatHistory();
        window.voicifyAssistant.onRequestStarted((request)=>{
            if (!request.context.requiresLanguageUnderstanding && request.context.requestName == "VoicifyWelcome") return;
            if (!minimalUI) {
                if (settings.uiType === "slideFromBottom") assistantContainer.className = "voicify-assistant-chat-container-slide-up";
                else assistantContainer.className = "voicify-assistant-chat-container";
                chatHistory.className = "voicify-assistant-chat-history";
            } else if (settings.showConversationHistory) {
                assistantContainer.className = "voicify-assistant-chat-container-minimal-show-history";
                chatHistory.className = "voicify-assistant-chat-history-minimal";
            } else {
                assistantContainer.className = "voicify-assistant-chat-container-minimal";
                chatHistory.className = "voicify-assistant-chat-history-minimal";
            }
            buildUserMessage(request.context.originalInput?.trim());
            toolbarTopRow.className = "voicify-assistant-toolbar-top-hidden";
        });
        window.voicifyAssistant.onResponseReceived((response)=>{
            buildBotMessage((response.displayText ?? response.outputSpeech ?? "")?.trim(), response.hints, response.foregroundImage?.url, response.audioFile?.url, response.videoFile?.url);
        });
        $c4cac35f50f462b8$export$cd1262eccf5f120f(settings.styles);
        if (settings.customStyles) $c4cac35f50f462b8$export$31f077b88a3c784c(shadowRoot, settings.styles, settings.customStyles);
        else $c4cac35f50f462b8$export$31f077b88a3c784c(shadowRoot, settings.styles);
        scrollToBottomOfChat();
    };
    createAssistant();
    if (settings.openByDefault) handleAssistantClick();
};
var $e03ffcafbfaf1a3e$export$2e2bcd8739ae039 = $e03ffcafbfaf1a3e$export$f7efacc29c799bcc;
var $829a079375498163$exports = {};
var $298422f58342477e$exports = {};
var $4a070af717a38982$exports = {};
if (window) window.initializeVoicifyAssistant = $e03ffcafbfaf1a3e$export$2e2bcd8739ae039;
$parcel$exportWildcard(module.exports, $e03ffcafbfaf1a3e$exports);
$parcel$exportWildcard(module.exports, $829a079375498163$exports);
$parcel$exportWildcard(module.exports, $174052f0970457c1$exports);
$parcel$exportWildcard(module.exports, $298422f58342477e$exports);
$parcel$exportWildcard(module.exports, $4a070af717a38982$exports);

},{"45c266e59932e429":"aMa9j","c158f5a4da895c0f":"4rJhH","94e4ab7b8b3b7843":"67y10","e6e4efb568522e6c":"i11ct","95e1032ca6d4ecf0":"7VvW4","175c5a52bcb3f53f":"lHACd","9ba0f92d5f9c5815":"d7Mkf","4adc080d90327b74":"7n30l","484c8cb66ab1d3ab":"ofNrF","fcc33a652c256e66":"dc93L","83141b9e5a199a30":"36PR5","6170589963b3621b":"i8tpc","98a141a7709cef00":"awzFF"}],"aMa9j":[function(require,module,exports) {
/**
 * marked v4.3.0 - a markdown parser
 * Copyright (c) 2011-2023, Christopher Jeffrey. (MIT Licensed)
 * https://github.com/markedjs/marked
 */ /**
 * DO NOT EDIT THIS FILE
 * The code in this file is generated from files in ./src/
 */ (function(global, factory) {
    factory(exports);
})(this, function(exports1) {
    "use strict";
    function _defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
        }
    }
    function _createClass(Constructor, protoProps, staticProps) {
        if (protoProps) _defineProperties(Constructor.prototype, protoProps);
        if (staticProps) _defineProperties(Constructor, staticProps);
        Object.defineProperty(Constructor, "prototype", {
            writable: false
        });
        return Constructor;
    }
    function _extends() {
        _extends = Object.assign ? Object.assign.bind() : function(target) {
            for(var i = 1; i < arguments.length; i++){
                var source = arguments[i];
                for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
            }
            return target;
        };
        return _extends.apply(this, arguments);
    }
    function _unsupportedIterableToArray(o, minLen) {
        if (!o) return;
        if (typeof o === "string") return _arrayLikeToArray(o, minLen);
        var n = Object.prototype.toString.call(o).slice(8, -1);
        if (n === "Object" && o.constructor) n = o.constructor.name;
        if (n === "Map" || n === "Set") return Array.from(o);
        if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
    }
    function _arrayLikeToArray(arr, len) {
        if (len == null || len > arr.length) len = arr.length;
        for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
        return arr2;
    }
    function _createForOfIteratorHelperLoose(o, allowArrayLike) {
        var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
        if (it) return (it = it.call(o)).next.bind(it);
        if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
            if (it) o = it;
            var i = 0;
            return function() {
                if (i >= o.length) return {
                    done: true
                };
                return {
                    done: false,
                    value: o[i++]
                };
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    function _toPrimitive(input, hint) {
        if (typeof input !== "object" || input === null) return input;
        var prim = input[Symbol.toPrimitive];
        if (prim !== undefined) {
            var res = prim.call(input, hint || "default");
            if (typeof res !== "object") return res;
            throw new TypeError("@@toPrimitive must return a primitive value.");
        }
        return (hint === "string" ? String : Number)(input);
    }
    function _toPropertyKey(arg) {
        var key = _toPrimitive(arg, "string");
        return typeof key === "symbol" ? key : String(key);
    }
    function getDefaults() {
        return {
            async: false,
            baseUrl: null,
            breaks: false,
            extensions: null,
            gfm: true,
            headerIds: true,
            headerPrefix: "",
            highlight: null,
            hooks: null,
            langPrefix: "language-",
            mangle: true,
            pedantic: false,
            renderer: null,
            sanitize: false,
            sanitizer: null,
            silent: false,
            smartypants: false,
            tokenizer: null,
            walkTokens: null,
            xhtml: false
        };
    }
    exports1.defaults = getDefaults();
    function changeDefaults(newDefaults) {
        exports1.defaults = newDefaults;
    }
    /**
   * Helpers
   */ var escapeTest = /[&<>"']/;
    var escapeReplace = new RegExp(escapeTest.source, "g");
    var escapeTestNoEncode = /[<>"']|&(?!(#\d{1,7}|#[Xx][a-fA-F0-9]{1,6}|\w+);)/;
    var escapeReplaceNoEncode = new RegExp(escapeTestNoEncode.source, "g");
    var escapeReplacements = {
        "&": "&amp;",
        "<": "&lt;",
        ">": "&gt;",
        '"': "&quot;",
        "'": "&#39;"
    };
    var getEscapeReplacement = function getEscapeReplacement(ch) {
        return escapeReplacements[ch];
    };
    function escape(html, encode) {
        if (encode) {
            if (escapeTest.test(html)) return html.replace(escapeReplace, getEscapeReplacement);
        } else {
            if (escapeTestNoEncode.test(html)) return html.replace(escapeReplaceNoEncode, getEscapeReplacement);
        }
        return html;
    }
    var unescapeTest = /&(#(?:\d+)|(?:#x[0-9A-Fa-f]+)|(?:\w+));?/ig;
    /**
   * @param {string} html
   */ function unescape(html) {
        // explicitly match decimal, hex, and named HTML entities
        return html.replace(unescapeTest, function(_, n) {
            n = n.toLowerCase();
            if (n === "colon") return ":";
            if (n.charAt(0) === "#") return n.charAt(1) === "x" ? String.fromCharCode(parseInt(n.substring(2), 16)) : String.fromCharCode(+n.substring(1));
            return "";
        });
    }
    var caret = /(^|[^\[])\^/g;
    /**
   * @param {string | RegExp} regex
   * @param {string} opt
   */ function edit(regex, opt) {
        regex = typeof regex === "string" ? regex : regex.source;
        opt = opt || "";
        var obj = {
            replace: function replace(name, val) {
                val = val.source || val;
                val = val.replace(caret, "$1");
                regex = regex.replace(name, val);
                return obj;
            },
            getRegex: function getRegex() {
                return new RegExp(regex, opt);
            }
        };
        return obj;
    }
    var nonWordAndColonTest = /[^\w:]/g;
    var originIndependentUrl = /^$|^[a-z][a-z0-9+.-]*:|^[?#]/i;
    /**
   * @param {boolean} sanitize
   * @param {string} base
   * @param {string} href
   */ function cleanUrl(sanitize, base, href) {
        if (sanitize) {
            var prot;
            try {
                prot = decodeURIComponent(unescape(href)).replace(nonWordAndColonTest, "").toLowerCase();
            } catch (e) {
                return null;
            }
            if (prot.indexOf("javascript:") === 0 || prot.indexOf("vbscript:") === 0 || prot.indexOf("data:") === 0) return null;
        }
        if (base && !originIndependentUrl.test(href)) href = resolveUrl(base, href);
        try {
            href = encodeURI(href).replace(/%25/g, "%");
        } catch (e) {
            return null;
        }
        return href;
    }
    var baseUrls = {};
    var justDomain = /^[^:]+:\/*[^/]*$/;
    var protocol = /^([^:]+:)[\s\S]*$/;
    var domain = /^([^:]+:\/*[^/]*)[\s\S]*$/;
    /**
   * @param {string} base
   * @param {string} href
   */ function resolveUrl(base, href) {
        if (!baseUrls[" " + base]) {
            // we can ignore everything in base after the last slash of its path component,
            // but we might need to add _that_
            // https://tools.ietf.org/html/rfc3986#section-3
            if (justDomain.test(base)) baseUrls[" " + base] = base + "/";
            else baseUrls[" " + base] = rtrim(base, "/", true);
        }
        base = baseUrls[" " + base];
        var relativeBase = base.indexOf(":") === -1;
        if (href.substring(0, 2) === "//") {
            if (relativeBase) return href;
            return base.replace(protocol, "$1") + href;
        } else if (href.charAt(0) === "/") {
            if (relativeBase) return href;
            return base.replace(domain, "$1") + href;
        } else return base + href;
    }
    var noopTest = {
        exec: function noopTest() {}
    };
    function splitCells(tableRow, count) {
        // ensure that every cell-delimiting pipe has a space
        // before it to distinguish it from an escaped pipe
        var row = tableRow.replace(/\|/g, function(match, offset, str) {
            var escaped = false, curr = offset;
            while(--curr >= 0 && str[curr] === "\\")escaped = !escaped;
            if (escaped) // odd number of slashes means | is escaped
            // so we leave it alone
            return "|";
            else // add space before unescaped |
            return " |";
        }), cells = row.split(/ \|/);
        var i = 0;
        // First/last cell in a row cannot be empty if it has no leading/trailing pipe
        if (!cells[0].trim()) cells.shift();
        if (cells.length > 0 && !cells[cells.length - 1].trim()) cells.pop();
        if (cells.length > count) cells.splice(count);
        else while(cells.length < count)cells.push("");
        for(; i < cells.length; i++)// leading or trailing whitespace is ignored per the gfm spec
        cells[i] = cells[i].trim().replace(/\\\|/g, "|");
        return cells;
    }
    /**
   * Remove trailing 'c's. Equivalent to str.replace(/c*$/, '').
   * /c*$/ is vulnerable to REDOS.
   *
   * @param {string} str
   * @param {string} c
   * @param {boolean} invert Remove suffix of non-c chars instead. Default falsey.
   */ function rtrim(str, c, invert) {
        var l = str.length;
        if (l === 0) return "";
        // Length of suffix matching the invert condition.
        var suffLen = 0;
        // Step left until we fail to match the invert condition.
        while(suffLen < l){
            var currChar = str.charAt(l - suffLen - 1);
            if (currChar === c && !invert) suffLen++;
            else if (currChar !== c && invert) suffLen++;
            else break;
        }
        return str.slice(0, l - suffLen);
    }
    function findClosingBracket(str, b) {
        if (str.indexOf(b[1]) === -1) return -1;
        var l = str.length;
        var level = 0, i = 0;
        for(; i < l; i++){
            if (str[i] === "\\") i++;
            else if (str[i] === b[0]) level++;
            else if (str[i] === b[1]) {
                level--;
                if (level < 0) return i;
            }
        }
        return -1;
    }
    function checkSanitizeDeprecation(opt) {
        if (opt && opt.sanitize && !opt.silent) console.warn("marked(): sanitize and sanitizer parameters are deprecated since version 0.7.0, should not be used and will be removed in the future. Read more here: https://marked.js.org/#/USING_ADVANCED.md#options");
    }
    // copied from https://stackoverflow.com/a/5450113/806777
    /**
   * @param {string} pattern
   * @param {number} count
   */ function repeatString(pattern, count) {
        if (count < 1) return "";
        var result = "";
        while(count > 1){
            if (count & 1) result += pattern;
            count >>= 1;
            pattern += pattern;
        }
        return result + pattern;
    }
    function outputLink(cap, link, raw, lexer) {
        var href = link.href;
        var title = link.title ? escape(link.title) : null;
        var text = cap[1].replace(/\\([\[\]])/g, "$1");
        if (cap[0].charAt(0) !== "!") {
            lexer.state.inLink = true;
            var token = {
                type: "link",
                raw: raw,
                href: href,
                title: title,
                text: text,
                tokens: lexer.inlineTokens(text)
            };
            lexer.state.inLink = false;
            return token;
        }
        return {
            type: "image",
            raw: raw,
            href: href,
            title: title,
            text: escape(text)
        };
    }
    function indentCodeCompensation(raw, text) {
        var matchIndentToCode = raw.match(/^(\s+)(?:```)/);
        if (matchIndentToCode === null) return text;
        var indentToCode = matchIndentToCode[1];
        return text.split("\n").map(function(node) {
            var matchIndentInNode = node.match(/^\s+/);
            if (matchIndentInNode === null) return node;
            var indentInNode = matchIndentInNode[0];
            if (indentInNode.length >= indentToCode.length) return node.slice(indentToCode.length);
            return node;
        }).join("\n");
    }
    /**
   * Tokenizer
   */ var Tokenizer = /*#__PURE__*/ function() {
        function Tokenizer(options) {
            this.options = options || exports1.defaults;
        }
        var _proto = Tokenizer.prototype;
        _proto.space = function space(src) {
            var cap = this.rules.block.newline.exec(src);
            if (cap && cap[0].length > 0) return {
                type: "space",
                raw: cap[0]
            };
        };
        _proto.code = function code(src) {
            var cap = this.rules.block.code.exec(src);
            if (cap) {
                var text = cap[0].replace(/^ {1,4}/gm, "");
                return {
                    type: "code",
                    raw: cap[0],
                    codeBlockStyle: "indented",
                    text: !this.options.pedantic ? rtrim(text, "\n") : text
                };
            }
        };
        _proto.fences = function fences(src) {
            var cap = this.rules.block.fences.exec(src);
            if (cap) {
                var raw = cap[0];
                var text = indentCodeCompensation(raw, cap[3] || "");
                return {
                    type: "code",
                    raw: raw,
                    lang: cap[2] ? cap[2].trim().replace(this.rules.inline._escapes, "$1") : cap[2],
                    text: text
                };
            }
        };
        _proto.heading = function heading(src) {
            var cap = this.rules.block.heading.exec(src);
            if (cap) {
                var text = cap[2].trim();
                // remove trailing #s
                if (/#$/.test(text)) {
                    var trimmed = rtrim(text, "#");
                    if (this.options.pedantic) text = trimmed.trim();
                    else if (!trimmed || / $/.test(trimmed)) // CommonMark requires space before trailing #s
                    text = trimmed.trim();
                }
                return {
                    type: "heading",
                    raw: cap[0],
                    depth: cap[1].length,
                    text: text,
                    tokens: this.lexer.inline(text)
                };
            }
        };
        _proto.hr = function hr(src) {
            var cap = this.rules.block.hr.exec(src);
            if (cap) return {
                type: "hr",
                raw: cap[0]
            };
        };
        _proto.blockquote = function blockquote(src) {
            var cap = this.rules.block.blockquote.exec(src);
            if (cap) {
                var text = cap[0].replace(/^ *>[ \t]?/gm, "");
                var top = this.lexer.state.top;
                this.lexer.state.top = true;
                var tokens = this.lexer.blockTokens(text);
                this.lexer.state.top = top;
                return {
                    type: "blockquote",
                    raw: cap[0],
                    tokens: tokens,
                    text: text
                };
            }
        };
        _proto.list = function list(src) {
            var cap = this.rules.block.list.exec(src);
            if (cap) {
                var raw, istask, ischecked, indent, i, blankLine, endsWithBlankLine, line, nextLine, rawLine, itemContents, endEarly;
                var bull = cap[1].trim();
                var isordered = bull.length > 1;
                var list = {
                    type: "list",
                    raw: "",
                    ordered: isordered,
                    start: isordered ? +bull.slice(0, -1) : "",
                    loose: false,
                    items: []
                };
                bull = isordered ? "\\d{1,9}\\" + bull.slice(-1) : "\\" + bull;
                if (this.options.pedantic) bull = isordered ? bull : "[*+-]";
                // Get next list item
                var itemRegex = new RegExp("^( {0,3}" + bull + ")((?:[	 ][^\\n]*)?(?:\\n|$))");
                // Check if current bullet point can start a new List Item
                while(src){
                    endEarly = false;
                    if (!(cap = itemRegex.exec(src))) break;
                    if (this.rules.block.hr.test(src)) break;
                    raw = cap[0];
                    src = src.substring(raw.length);
                    line = cap[2].split("\n", 1)[0].replace(/^\t+/, function(t) {
                        return " ".repeat(3 * t.length);
                    });
                    nextLine = src.split("\n", 1)[0];
                    if (this.options.pedantic) {
                        indent = 2;
                        itemContents = line.trimLeft();
                    } else {
                        indent = cap[2].search(/[^ ]/); // Find first non-space char
                        indent = indent > 4 ? 1 : indent; // Treat indented code blocks (> 4 spaces) as having only 1 indent
                        itemContents = line.slice(indent);
                        indent += cap[1].length;
                    }
                    blankLine = false;
                    if (!line && /^ *$/.test(nextLine)) {
                        // Items begin with at most one blank line
                        raw += nextLine + "\n";
                        src = src.substring(nextLine.length + 1);
                        endEarly = true;
                    }
                    if (!endEarly) {
                        var nextBulletRegex = new RegExp("^ {0," + Math.min(3, indent - 1) + "}(?:[*+-]|\\d{1,9}[.)])((?:[ 	][^\\n]*)?(?:\\n|$))");
                        var hrRegex = new RegExp("^ {0," + Math.min(3, indent - 1) + "}((?:- *){3,}|(?:_ *){3,}|(?:\\* *){3,})(?:\\n+|$)");
                        var fencesBeginRegex = new RegExp("^ {0," + Math.min(3, indent - 1) + "}(?:```|~~~)");
                        var headingBeginRegex = new RegExp("^ {0," + Math.min(3, indent - 1) + "}#");
                        // Check if following lines should be included in List Item
                        while(src){
                            rawLine = src.split("\n", 1)[0];
                            nextLine = rawLine;
                            // Re-align to follow commonmark nesting rules
                            if (this.options.pedantic) nextLine = nextLine.replace(/^ {1,4}(?=( {4})*[^ ])/g, "  ");
                            // End list item if found code fences
                            if (fencesBeginRegex.test(nextLine)) break;
                            // End list item if found start of new heading
                            if (headingBeginRegex.test(nextLine)) break;
                            // End list item if found start of new bullet
                            if (nextBulletRegex.test(nextLine)) break;
                            // Horizontal rule found
                            if (hrRegex.test(src)) break;
                            if (nextLine.search(/[^ ]/) >= indent || !nextLine.trim()) // Dedent if possible
                            itemContents += "\n" + nextLine.slice(indent);
                            else {
                                // not enough indentation
                                if (blankLine) break;
                                // paragraph continuation unless last line was a different block level element
                                if (line.search(/[^ ]/) >= 4) break;
                                if (fencesBeginRegex.test(line)) break;
                                if (headingBeginRegex.test(line)) break;
                                if (hrRegex.test(line)) break;
                                itemContents += "\n" + nextLine;
                            }
                            if (!blankLine && !nextLine.trim()) // Check if current line is blank
                            blankLine = true;
                            raw += rawLine + "\n";
                            src = src.substring(rawLine.length + 1);
                            line = nextLine.slice(indent);
                        }
                    }
                    if (!list.loose) {
                        // If the previous item ended with a blank line, the list is loose
                        if (endsWithBlankLine) list.loose = true;
                        else if (/\n *\n *$/.test(raw)) endsWithBlankLine = true;
                    }
                    // Check for task list items
                    if (this.options.gfm) {
                        istask = /^\[[ xX]\] /.exec(itemContents);
                        if (istask) {
                            ischecked = istask[0] !== "[ ] ";
                            itemContents = itemContents.replace(/^\[[ xX]\] +/, "");
                        }
                    }
                    list.items.push({
                        type: "list_item",
                        raw: raw,
                        task: !!istask,
                        checked: ischecked,
                        loose: false,
                        text: itemContents
                    });
                    list.raw += raw;
                }
                // Do not consume newlines at end of final item. Alternatively, make itemRegex *start* with any newlines to simplify/speed up endsWithBlankLine logic
                list.items[list.items.length - 1].raw = raw.trimRight();
                list.items[list.items.length - 1].text = itemContents.trimRight();
                list.raw = list.raw.trimRight();
                var l = list.items.length;
                // Item child tokens handled here at end because we needed to have the final item to trim it first
                for(i = 0; i < l; i++){
                    this.lexer.state.top = false;
                    list.items[i].tokens = this.lexer.blockTokens(list.items[i].text, []);
                    if (!list.loose) {
                        // Check if list should be loose
                        var spacers = list.items[i].tokens.filter(function(t) {
                            return t.type === "space";
                        });
                        var hasMultipleLineBreaks = spacers.length > 0 && spacers.some(function(t) {
                            return /\n.*\n/.test(t.raw);
                        });
                        list.loose = hasMultipleLineBreaks;
                    }
                }
                // Set all items to loose if list is loose
                if (list.loose) for(i = 0; i < l; i++)list.items[i].loose = true;
                return list;
            }
        };
        _proto.html = function html(src) {
            var cap = this.rules.block.html.exec(src);
            if (cap) {
                var token = {
                    type: "html",
                    raw: cap[0],
                    pre: !this.options.sanitizer && (cap[1] === "pre" || cap[1] === "script" || cap[1] === "style"),
                    text: cap[0]
                };
                if (this.options.sanitize) {
                    var text = this.options.sanitizer ? this.options.sanitizer(cap[0]) : escape(cap[0]);
                    token.type = "paragraph";
                    token.text = text;
                    token.tokens = this.lexer.inline(text);
                }
                return token;
            }
        };
        _proto.def = function def(src) {
            var cap = this.rules.block.def.exec(src);
            if (cap) {
                var tag = cap[1].toLowerCase().replace(/\s+/g, " ");
                var href = cap[2] ? cap[2].replace(/^<(.*)>$/, "$1").replace(this.rules.inline._escapes, "$1") : "";
                var title = cap[3] ? cap[3].substring(1, cap[3].length - 1).replace(this.rules.inline._escapes, "$1") : cap[3];
                return {
                    type: "def",
                    tag: tag,
                    raw: cap[0],
                    href: href,
                    title: title
                };
            }
        };
        _proto.table = function table(src) {
            var cap = this.rules.block.table.exec(src);
            if (cap) {
                var item = {
                    type: "table",
                    header: splitCells(cap[1]).map(function(c) {
                        return {
                            text: c
                        };
                    }),
                    align: cap[2].replace(/^ *|\| *$/g, "").split(/ *\| */),
                    rows: cap[3] && cap[3].trim() ? cap[3].replace(/\n[ \t]*$/, "").split("\n") : []
                };
                if (item.header.length === item.align.length) {
                    item.raw = cap[0];
                    var l = item.align.length;
                    var i, j, k, row;
                    for(i = 0; i < l; i++){
                        if (/^ *-+: *$/.test(item.align[i])) item.align[i] = "right";
                        else if (/^ *:-+: *$/.test(item.align[i])) item.align[i] = "center";
                        else if (/^ *:-+ *$/.test(item.align[i])) item.align[i] = "left";
                        else item.align[i] = null;
                    }
                    l = item.rows.length;
                    for(i = 0; i < l; i++)item.rows[i] = splitCells(item.rows[i], item.header.length).map(function(c) {
                        return {
                            text: c
                        };
                    });
                    // parse child tokens inside headers and cells
                    // header child tokens
                    l = item.header.length;
                    for(j = 0; j < l; j++)item.header[j].tokens = this.lexer.inline(item.header[j].text);
                    // cell child tokens
                    l = item.rows.length;
                    for(j = 0; j < l; j++){
                        row = item.rows[j];
                        for(k = 0; k < row.length; k++)row[k].tokens = this.lexer.inline(row[k].text);
                    }
                    return item;
                }
            }
        };
        _proto.lheading = function lheading(src) {
            var cap = this.rules.block.lheading.exec(src);
            if (cap) return {
                type: "heading",
                raw: cap[0],
                depth: cap[2].charAt(0) === "=" ? 1 : 2,
                text: cap[1],
                tokens: this.lexer.inline(cap[1])
            };
        };
        _proto.paragraph = function paragraph(src) {
            var cap = this.rules.block.paragraph.exec(src);
            if (cap) {
                var text = cap[1].charAt(cap[1].length - 1) === "\n" ? cap[1].slice(0, -1) : cap[1];
                return {
                    type: "paragraph",
                    raw: cap[0],
                    text: text,
                    tokens: this.lexer.inline(text)
                };
            }
        };
        _proto.text = function text(src) {
            var cap = this.rules.block.text.exec(src);
            if (cap) return {
                type: "text",
                raw: cap[0],
                text: cap[0],
                tokens: this.lexer.inline(cap[0])
            };
        };
        _proto.escape = function escape$1(src) {
            var cap = this.rules.inline.escape.exec(src);
            if (cap) return {
                type: "escape",
                raw: cap[0],
                text: escape(cap[1])
            };
        };
        _proto.tag = function tag(src) {
            var cap = this.rules.inline.tag.exec(src);
            if (cap) {
                if (!this.lexer.state.inLink && /^<a /i.test(cap[0])) this.lexer.state.inLink = true;
                else if (this.lexer.state.inLink && /^<\/a>/i.test(cap[0])) this.lexer.state.inLink = false;
                if (!this.lexer.state.inRawBlock && /^<(pre|code|kbd|script)(\s|>)/i.test(cap[0])) this.lexer.state.inRawBlock = true;
                else if (this.lexer.state.inRawBlock && /^<\/(pre|code|kbd|script)(\s|>)/i.test(cap[0])) this.lexer.state.inRawBlock = false;
                return {
                    type: this.options.sanitize ? "text" : "html",
                    raw: cap[0],
                    inLink: this.lexer.state.inLink,
                    inRawBlock: this.lexer.state.inRawBlock,
                    text: this.options.sanitize ? this.options.sanitizer ? this.options.sanitizer(cap[0]) : escape(cap[0]) : cap[0]
                };
            }
        };
        _proto.link = function link(src) {
            var cap = this.rules.inline.link.exec(src);
            if (cap) {
                var trimmedUrl = cap[2].trim();
                if (!this.options.pedantic && /^</.test(trimmedUrl)) {
                    // commonmark requires matching angle brackets
                    if (!/>$/.test(trimmedUrl)) return;
                    // ending angle bracket cannot be escaped
                    var rtrimSlash = rtrim(trimmedUrl.slice(0, -1), "\\");
                    if ((trimmedUrl.length - rtrimSlash.length) % 2 === 0) return;
                } else {
                    // find closing parenthesis
                    var lastParenIndex = findClosingBracket(cap[2], "()");
                    if (lastParenIndex > -1) {
                        var start = cap[0].indexOf("!") === 0 ? 5 : 4;
                        var linkLen = start + cap[1].length + lastParenIndex;
                        cap[2] = cap[2].substring(0, lastParenIndex);
                        cap[0] = cap[0].substring(0, linkLen).trim();
                        cap[3] = "";
                    }
                }
                var href = cap[2];
                var title = "";
                if (this.options.pedantic) {
                    // split pedantic href and title
                    var link = /^([^'"]*[^\s])\s+(['"])(.*)\2/.exec(href);
                    if (link) {
                        href = link[1];
                        title = link[3];
                    }
                } else title = cap[3] ? cap[3].slice(1, -1) : "";
                href = href.trim();
                if (/^</.test(href)) {
                    if (this.options.pedantic && !/>$/.test(trimmedUrl)) // pedantic allows starting angle bracket without ending angle bracket
                    href = href.slice(1);
                    else href = href.slice(1, -1);
                }
                return outputLink(cap, {
                    href: href ? href.replace(this.rules.inline._escapes, "$1") : href,
                    title: title ? title.replace(this.rules.inline._escapes, "$1") : title
                }, cap[0], this.lexer);
            }
        };
        _proto.reflink = function reflink(src, links) {
            var cap;
            if ((cap = this.rules.inline.reflink.exec(src)) || (cap = this.rules.inline.nolink.exec(src))) {
                var link = (cap[2] || cap[1]).replace(/\s+/g, " ");
                link = links[link.toLowerCase()];
                if (!link) {
                    var text = cap[0].charAt(0);
                    return {
                        type: "text",
                        raw: text,
                        text: text
                    };
                }
                return outputLink(cap, link, cap[0], this.lexer);
            }
        };
        _proto.emStrong = function emStrong(src, maskedSrc, prevChar) {
            if (prevChar === void 0) prevChar = "";
            var match = this.rules.inline.emStrong.lDelim.exec(src);
            if (!match) return;
            // _ can't be between two alphanumerics. \p{L}\p{N} includes non-english alphabet/numbers as well
            if (match[3] && prevChar.match(/(?:[0-9A-Za-z\xAA\xB2\xB3\xB5\xB9\xBA\xBC-\xBE\xC0-\xD6\xD8-\xF6\xF8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0370-\u0374\u0376\u0377\u037A-\u037D\u037F\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u052F\u0531-\u0556\u0559\u0560-\u0588\u05D0-\u05EA\u05EF-\u05F2\u0620-\u064A\u0660-\u0669\u066E\u066F\u0671-\u06D3\u06D5\u06E5\u06E6\u06EE-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07C0-\u07EA\u07F4\u07F5\u07FA\u0800-\u0815\u081A\u0824\u0828\u0840-\u0858\u0860-\u086A\u0870-\u0887\u0889-\u088E\u08A0-\u08C9\u0904-\u0939\u093D\u0950\u0958-\u0961\u0966-\u096F\u0971-\u0980\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09E6-\u09F1\u09F4-\u09F9\u09FC\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E\u0A66-\u0A6F\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0AE6-\u0AEF\u0AF9\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B66-\u0B6F\u0B71-\u0B77\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0BE6-\u0BF2\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D\u0C58-\u0C5A\u0C5D\u0C60\u0C61\u0C66-\u0C6F\u0C78-\u0C7E\u0C80\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDD\u0CDE\u0CE0\u0CE1\u0CE6-\u0CEF\u0CF1\u0CF2\u0D04-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D54-\u0D56\u0D58-\u0D61\u0D66-\u0D78\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0DE6-\u0DEF\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E46\u0E50-\u0E59\u0E81\u0E82\u0E84\u0E86-\u0E8A\u0E8C-\u0EA3\u0EA5\u0EA7-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6\u0ED0-\u0ED9\u0EDC-\u0EDF\u0F00\u0F20-\u0F33\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F-\u1049\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u1090-\u1099\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1369-\u137C\u1380-\u138F\u13A0-\u13F5\u13F8-\u13FD\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16EE-\u16F8\u1700-\u1711\u171F-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17D7\u17DC\u17E0-\u17E9\u17F0-\u17F9\u1810-\u1819\u1820-\u1878\u1880-\u1884\u1887-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191E\u1946-\u196D\u1970-\u1974\u1980-\u19AB\u19B0-\u19C9\u19D0-\u19DA\u1A00-\u1A16\u1A20-\u1A54\u1A80-\u1A89\u1A90-\u1A99\u1AA7\u1B05-\u1B33\u1B45-\u1B4C\u1B50-\u1B59\u1B83-\u1BA0\u1BAE-\u1BE5\u1C00-\u1C23\u1C40-\u1C49\u1C4D-\u1C7D\u1C80-\u1C88\u1C90-\u1CBA\u1CBD-\u1CBF\u1CE9-\u1CEC\u1CEE-\u1CF3\u1CF5\u1CF6\u1CFA\u1D00-\u1DBF\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2070\u2071\u2074-\u2079\u207F-\u2089\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u212F-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2150-\u2189\u2460-\u249B\u24EA-\u24FF\u2776-\u2793\u2C00-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3\u2CFD\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2E2F\u3005-\u3007\u3021-\u3029\u3031-\u3035\u3038-\u303C\u3041-\u3096\u309D-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312F\u3131-\u318E\u3192-\u3195\u31A0-\u31BF\u31F0-\u31FF\u3220-\u3229\u3248-\u324F\u3251-\u325F\u3280-\u3289\u32B1-\u32BF\u3400-\u4DBF\u4E00-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA62B\uA640-\uA66E\uA67F-\uA69D\uA6A0-\uA6EF\uA717-\uA71F\uA722-\uA788\uA78B-\uA7CA\uA7D0\uA7D1\uA7D3\uA7D5-\uA7D9\uA7F2-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA830-\uA835\uA840-\uA873\uA882-\uA8B3\uA8D0-\uA8D9\uA8F2-\uA8F7\uA8FB\uA8FD\uA8FE\uA900-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9CF-\uA9D9\uA9E0-\uA9E4\uA9E6-\uA9FE\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA50-\uAA59\uAA60-\uAA76\uAA7A\uAA7E-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEA\uAAF2-\uAAF4\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uAB30-\uAB5A\uAB5C-\uAB69\uAB70-\uABE2\uABF0-\uABF9\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF10-\uFF19\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC]|\uD800[\uDC00-\uDC0B\uDC0D-\uDC26\uDC28-\uDC3A\uDC3C\uDC3D\uDC3F-\uDC4D\uDC50-\uDC5D\uDC80-\uDCFA\uDD07-\uDD33\uDD40-\uDD78\uDD8A\uDD8B\uDE80-\uDE9C\uDEA0-\uDED0\uDEE1-\uDEFB\uDF00-\uDF23\uDF2D-\uDF4A\uDF50-\uDF75\uDF80-\uDF9D\uDFA0-\uDFC3\uDFC8-\uDFCF\uDFD1-\uDFD5]|\uD801[\uDC00-\uDC9D\uDCA0-\uDCA9\uDCB0-\uDCD3\uDCD8-\uDCFB\uDD00-\uDD27\uDD30-\uDD63\uDD70-\uDD7A\uDD7C-\uDD8A\uDD8C-\uDD92\uDD94\uDD95\uDD97-\uDDA1\uDDA3-\uDDB1\uDDB3-\uDDB9\uDDBB\uDDBC\uDE00-\uDF36\uDF40-\uDF55\uDF60-\uDF67\uDF80-\uDF85\uDF87-\uDFB0\uDFB2-\uDFBA]|\uD802[\uDC00-\uDC05\uDC08\uDC0A-\uDC35\uDC37\uDC38\uDC3C\uDC3F-\uDC55\uDC58-\uDC76\uDC79-\uDC9E\uDCA7-\uDCAF\uDCE0-\uDCF2\uDCF4\uDCF5\uDCFB-\uDD1B\uDD20-\uDD39\uDD80-\uDDB7\uDDBC-\uDDCF\uDDD2-\uDE00\uDE10-\uDE13\uDE15-\uDE17\uDE19-\uDE35\uDE40-\uDE48\uDE60-\uDE7E\uDE80-\uDE9F\uDEC0-\uDEC7\uDEC9-\uDEE4\uDEEB-\uDEEF\uDF00-\uDF35\uDF40-\uDF55\uDF58-\uDF72\uDF78-\uDF91\uDFA9-\uDFAF]|\uD803[\uDC00-\uDC48\uDC80-\uDCB2\uDCC0-\uDCF2\uDCFA-\uDD23\uDD30-\uDD39\uDE60-\uDE7E\uDE80-\uDEA9\uDEB0\uDEB1\uDF00-\uDF27\uDF30-\uDF45\uDF51-\uDF54\uDF70-\uDF81\uDFB0-\uDFCB\uDFE0-\uDFF6]|\uD804[\uDC03-\uDC37\uDC52-\uDC6F\uDC71\uDC72\uDC75\uDC83-\uDCAF\uDCD0-\uDCE8\uDCF0-\uDCF9\uDD03-\uDD26\uDD36-\uDD3F\uDD44\uDD47\uDD50-\uDD72\uDD76\uDD83-\uDDB2\uDDC1-\uDDC4\uDDD0-\uDDDA\uDDDC\uDDE1-\uDDF4\uDE00-\uDE11\uDE13-\uDE2B\uDE80-\uDE86\uDE88\uDE8A-\uDE8D\uDE8F-\uDE9D\uDE9F-\uDEA8\uDEB0-\uDEDE\uDEF0-\uDEF9\uDF05-\uDF0C\uDF0F\uDF10\uDF13-\uDF28\uDF2A-\uDF30\uDF32\uDF33\uDF35-\uDF39\uDF3D\uDF50\uDF5D-\uDF61]|\uD805[\uDC00-\uDC34\uDC47-\uDC4A\uDC50-\uDC59\uDC5F-\uDC61\uDC80-\uDCAF\uDCC4\uDCC5\uDCC7\uDCD0-\uDCD9\uDD80-\uDDAE\uDDD8-\uDDDB\uDE00-\uDE2F\uDE44\uDE50-\uDE59\uDE80-\uDEAA\uDEB8\uDEC0-\uDEC9\uDF00-\uDF1A\uDF30-\uDF3B\uDF40-\uDF46]|\uD806[\uDC00-\uDC2B\uDCA0-\uDCF2\uDCFF-\uDD06\uDD09\uDD0C-\uDD13\uDD15\uDD16\uDD18-\uDD2F\uDD3F\uDD41\uDD50-\uDD59\uDDA0-\uDDA7\uDDAA-\uDDD0\uDDE1\uDDE3\uDE00\uDE0B-\uDE32\uDE3A\uDE50\uDE5C-\uDE89\uDE9D\uDEB0-\uDEF8]|\uD807[\uDC00-\uDC08\uDC0A-\uDC2E\uDC40\uDC50-\uDC6C\uDC72-\uDC8F\uDD00-\uDD06\uDD08\uDD09\uDD0B-\uDD30\uDD46\uDD50-\uDD59\uDD60-\uDD65\uDD67\uDD68\uDD6A-\uDD89\uDD98\uDDA0-\uDDA9\uDEE0-\uDEF2\uDFB0\uDFC0-\uDFD4]|\uD808[\uDC00-\uDF99]|\uD809[\uDC00-\uDC6E\uDC80-\uDD43]|\uD80B[\uDF90-\uDFF0]|[\uD80C\uD81C-\uD820\uD822\uD840-\uD868\uD86A-\uD86C\uD86F-\uD872\uD874-\uD879\uD880-\uD883][\uDC00-\uDFFF]|\uD80D[\uDC00-\uDC2E]|\uD811[\uDC00-\uDE46]|\uD81A[\uDC00-\uDE38\uDE40-\uDE5E\uDE60-\uDE69\uDE70-\uDEBE\uDEC0-\uDEC9\uDED0-\uDEED\uDF00-\uDF2F\uDF40-\uDF43\uDF50-\uDF59\uDF5B-\uDF61\uDF63-\uDF77\uDF7D-\uDF8F]|\uD81B[\uDE40-\uDE96\uDF00-\uDF4A\uDF50\uDF93-\uDF9F\uDFE0\uDFE1\uDFE3]|\uD821[\uDC00-\uDFF7]|\uD823[\uDC00-\uDCD5\uDD00-\uDD08]|\uD82B[\uDFF0-\uDFF3\uDFF5-\uDFFB\uDFFD\uDFFE]|\uD82C[\uDC00-\uDD22\uDD50-\uDD52\uDD64-\uDD67\uDD70-\uDEFB]|\uD82F[\uDC00-\uDC6A\uDC70-\uDC7C\uDC80-\uDC88\uDC90-\uDC99]|\uD834[\uDEE0-\uDEF3\uDF60-\uDF78]|\uD835[\uDC00-\uDC54\uDC56-\uDC9C\uDC9E\uDC9F\uDCA2\uDCA5\uDCA6\uDCA9-\uDCAC\uDCAE-\uDCB9\uDCBB\uDCBD-\uDCC3\uDCC5-\uDD05\uDD07-\uDD0A\uDD0D-\uDD14\uDD16-\uDD1C\uDD1E-\uDD39\uDD3B-\uDD3E\uDD40-\uDD44\uDD46\uDD4A-\uDD50\uDD52-\uDEA5\uDEA8-\uDEC0\uDEC2-\uDEDA\uDEDC-\uDEFA\uDEFC-\uDF14\uDF16-\uDF34\uDF36-\uDF4E\uDF50-\uDF6E\uDF70-\uDF88\uDF8A-\uDFA8\uDFAA-\uDFC2\uDFC4-\uDFCB\uDFCE-\uDFFF]|\uD837[\uDF00-\uDF1E]|\uD838[\uDD00-\uDD2C\uDD37-\uDD3D\uDD40-\uDD49\uDD4E\uDE90-\uDEAD\uDEC0-\uDEEB\uDEF0-\uDEF9]|\uD839[\uDFE0-\uDFE6\uDFE8-\uDFEB\uDFED\uDFEE\uDFF0-\uDFFE]|\uD83A[\uDC00-\uDCC4\uDCC7-\uDCCF\uDD00-\uDD43\uDD4B\uDD50-\uDD59]|\uD83B[\uDC71-\uDCAB\uDCAD-\uDCAF\uDCB1-\uDCB4\uDD01-\uDD2D\uDD2F-\uDD3D\uDE00-\uDE03\uDE05-\uDE1F\uDE21\uDE22\uDE24\uDE27\uDE29-\uDE32\uDE34-\uDE37\uDE39\uDE3B\uDE42\uDE47\uDE49\uDE4B\uDE4D-\uDE4F\uDE51\uDE52\uDE54\uDE57\uDE59\uDE5B\uDE5D\uDE5F\uDE61\uDE62\uDE64\uDE67-\uDE6A\uDE6C-\uDE72\uDE74-\uDE77\uDE79-\uDE7C\uDE7E\uDE80-\uDE89\uDE8B-\uDE9B\uDEA1-\uDEA3\uDEA5-\uDEA9\uDEAB-\uDEBB]|\uD83C[\uDD00-\uDD0C]|\uD83E[\uDFF0-\uDFF9]|\uD869[\uDC00-\uDEDF\uDF00-\uDFFF]|\uD86D[\uDC00-\uDF38\uDF40-\uDFFF]|\uD86E[\uDC00-\uDC1D\uDC20-\uDFFF]|\uD873[\uDC00-\uDEA1\uDEB0-\uDFFF]|\uD87A[\uDC00-\uDFE0]|\uD87E[\uDC00-\uDE1D]|\uD884[\uDC00-\uDF4A])/)) return;
            var nextChar = match[1] || match[2] || "";
            if (!nextChar || nextChar && (prevChar === "" || this.rules.inline.punctuation.exec(prevChar))) {
                var lLength = match[0].length - 1;
                var rDelim, rLength, delimTotal = lLength, midDelimTotal = 0;
                var endReg = match[0][0] === "*" ? this.rules.inline.emStrong.rDelimAst : this.rules.inline.emStrong.rDelimUnd;
                endReg.lastIndex = 0;
                // Clip maskedSrc to same section of string as src (move to lexer?)
                maskedSrc = maskedSrc.slice(-1 * src.length + lLength);
                while((match = endReg.exec(maskedSrc)) != null){
                    rDelim = match[1] || match[2] || match[3] || match[4] || match[5] || match[6];
                    if (!rDelim) continue; // skip single * in __abc*abc__
                    rLength = rDelim.length;
                    if (match[3] || match[4]) {
                        // found another Left Delim
                        delimTotal += rLength;
                        continue;
                    } else if (match[5] || match[6]) // either Left or Right Delim
                    {
                        if (lLength % 3 && !((lLength + rLength) % 3)) {
                            midDelimTotal += rLength;
                            continue; // CommonMark Emphasis Rules 9-10
                        }
                    }
                    delimTotal -= rLength;
                    if (delimTotal > 0) continue; // Haven't found enough closing delimiters
                    // Remove extra characters. *a*** -> *a*
                    rLength = Math.min(rLength, rLength + delimTotal + midDelimTotal);
                    var raw = src.slice(0, lLength + match.index + (match[0].length - rDelim.length) + rLength);
                    // Create `em` if smallest delimiter has odd char count. *a***
                    if (Math.min(lLength, rLength) % 2) {
                        var _text = raw.slice(1, -1);
                        return {
                            type: "em",
                            raw: raw,
                            text: _text,
                            tokens: this.lexer.inlineTokens(_text)
                        };
                    }
                    // Create 'strong' if smallest delimiter has even char count. **a***
                    var text = raw.slice(2, -2);
                    return {
                        type: "strong",
                        raw: raw,
                        text: text,
                        tokens: this.lexer.inlineTokens(text)
                    };
                }
            }
        };
        _proto.codespan = function codespan(src) {
            var cap = this.rules.inline.code.exec(src);
            if (cap) {
                var text = cap[2].replace(/\n/g, " ");
                var hasNonSpaceChars = /[^ ]/.test(text);
                var hasSpaceCharsOnBothEnds = /^ /.test(text) && / $/.test(text);
                if (hasNonSpaceChars && hasSpaceCharsOnBothEnds) text = text.substring(1, text.length - 1);
                text = escape(text, true);
                return {
                    type: "codespan",
                    raw: cap[0],
                    text: text
                };
            }
        };
        _proto.br = function br(src) {
            var cap = this.rules.inline.br.exec(src);
            if (cap) return {
                type: "br",
                raw: cap[0]
            };
        };
        _proto.del = function del(src) {
            var cap = this.rules.inline.del.exec(src);
            if (cap) return {
                type: "del",
                raw: cap[0],
                text: cap[2],
                tokens: this.lexer.inlineTokens(cap[2])
            };
        };
        _proto.autolink = function autolink(src, mangle) {
            var cap = this.rules.inline.autolink.exec(src);
            if (cap) {
                var text, href;
                if (cap[2] === "@") {
                    text = escape(this.options.mangle ? mangle(cap[1]) : cap[1]);
                    href = "mailto:" + text;
                } else {
                    text = escape(cap[1]);
                    href = text;
                }
                return {
                    type: "link",
                    raw: cap[0],
                    text: text,
                    href: href,
                    tokens: [
                        {
                            type: "text",
                            raw: text,
                            text: text
                        }
                    ]
                };
            }
        };
        _proto.url = function url(src, mangle) {
            var cap;
            if (cap = this.rules.inline.url.exec(src)) {
                var text, href;
                if (cap[2] === "@") {
                    text = escape(this.options.mangle ? mangle(cap[0]) : cap[0]);
                    href = "mailto:" + text;
                } else {
                    // do extended autolink path validation
                    var prevCapZero;
                    do {
                        prevCapZero = cap[0];
                        cap[0] = this.rules.inline._backpedal.exec(cap[0])[0];
                    }while (prevCapZero !== cap[0]);
                    text = escape(cap[0]);
                    if (cap[1] === "www.") href = "http://" + cap[0];
                    else href = cap[0];
                }
                return {
                    type: "link",
                    raw: cap[0],
                    text: text,
                    href: href,
                    tokens: [
                        {
                            type: "text",
                            raw: text,
                            text: text
                        }
                    ]
                };
            }
        };
        _proto.inlineText = function inlineText(src, smartypants) {
            var cap = this.rules.inline.text.exec(src);
            if (cap) {
                var text;
                if (this.lexer.state.inRawBlock) text = this.options.sanitize ? this.options.sanitizer ? this.options.sanitizer(cap[0]) : escape(cap[0]) : cap[0];
                else text = escape(this.options.smartypants ? smartypants(cap[0]) : cap[0]);
                return {
                    type: "text",
                    raw: cap[0],
                    text: text
                };
            }
        };
        return Tokenizer;
    }();
    /**
   * Block-Level Grammar
   */ var block = {
        newline: /^(?: *(?:\n|$))+/,
        code: /^( {4}[^\n]+(?:\n(?: *(?:\n|$))*)?)+/,
        fences: /^ {0,3}(`{3,}(?=[^`\n]*(?:\n|$))|~{3,})([^\n]*)(?:\n|$)(?:|([\s\S]*?)(?:\n|$))(?: {0,3}\1[~`]* *(?=\n|$)|$)/,
        hr: /^ {0,3}((?:-[\t ]*){3,}|(?:_[ \t]*){3,}|(?:\*[ \t]*){3,})(?:\n+|$)/,
        heading: /^ {0,3}(#{1,6})(?=\s|$)(.*)(?:\n+|$)/,
        blockquote: /^( {0,3}> ?(paragraph|[^\n]*)(?:\n|$))+/,
        list: /^( {0,3}bull)([ \t][^\n]+?)?(?:\n|$)/,
        html: "^ {0,3}(?:<(script|pre|style|textarea)[\\s>][\\s\\S]*?(?:</\\1>[^\\n]*\\n+|$)|comment[^\\n]*(\\n+|$)|<\\?[\\s\\S]*?(?:\\?>\\n*|$)|<![A-Z][\\s\\S]*?(?:>\\n*|$)|<!\\[CDATA\\[[\\s\\S]*?(?:\\]\\]>\\n*|$)|</?(tag)(?: +|\\n|/?>)[\\s\\S]*?(?:(?:\\n *)+\\n|$)|<(?!script|pre|style|textarea)([a-z][\\w-]*)(?:attribute)*? */?>(?=[ \\t]*(?:\\n|$))[\\s\\S]*?(?:(?:\\n *)+\\n|$)|</(?!script|pre|style|textarea)[a-z][\\w-]*\\s*>(?=[ \\t]*(?:\\n|$))[\\s\\S]*?(?:(?:\\n *)+\\n|$))",
        def: /^ {0,3}\[(label)\]: *(?:\n *)?([^<\s][^\s]*|<.*?>)(?:(?: +(?:\n *)?| *\n *)(title))? *(?:\n+|$)/,
        table: noopTest,
        lheading: /^((?:.|\n(?!\n))+?)\n {0,3}(=+|-+) *(?:\n+|$)/,
        // regex template, placeholders will be replaced according to different paragraph
        // interruption rules of commonmark and the original markdown spec:
        _paragraph: /^([^\n]+(?:\n(?!hr|heading|lheading|blockquote|fences|list|html|table| +\n)[^\n]+)*)/,
        text: /^[^\n]+/
    };
    block._label = /(?!\s*\])(?:\\.|[^\[\]\\])+/;
    block._title = /(?:"(?:\\"?|[^"\\])*"|'[^'\n]*(?:\n[^'\n]+)*\n?'|\([^()]*\))/;
    block.def = edit(block.def).replace("label", block._label).replace("title", block._title).getRegex();
    block.bullet = /(?:[*+-]|\d{1,9}[.)])/;
    block.listItemStart = edit(/^( *)(bull) */).replace("bull", block.bullet).getRegex();
    block.list = edit(block.list).replace(/bull/g, block.bullet).replace("hr", "\\n+(?=\\1?(?:(?:- *){3,}|(?:_ *){3,}|(?:\\* *){3,})(?:\\n+|$))").replace("def", "\\n+(?=" + block.def.source + ")").getRegex();
    block._tag = "address|article|aside|base|basefont|blockquote|body|caption|center|col|colgroup|dd|details|dialog|dir|div|dl|dt|fieldset|figcaption|figure|footer|form|frame|frameset|h[1-6]|head|header|hr|html|iframe|legend|li|link|main|menu|menuitem|meta|nav|noframes|ol|optgroup|option|p|param|section|source|summary|table|tbody|td|tfoot|th|thead|title|tr|track|ul";
    block._comment = /<!--(?!-?>)[\s\S]*?(?:-->|$)/;
    block.html = edit(block.html, "i").replace("comment", block._comment).replace("tag", block._tag).replace("attribute", / +[a-zA-Z:_][\w.:-]*(?: *= *"[^"\n]*"| *= *'[^'\n]*'| *= *[^\s"'=<>`]+)?/).getRegex();
    block.paragraph = edit(block._paragraph).replace("hr", block.hr).replace("heading", " {0,3}#{1,6} ").replace("|lheading", "") // setex headings don't interrupt commonmark paragraphs
    .replace("|table", "").replace("blockquote", " {0,3}>").replace("fences", " {0,3}(?:`{3,}(?=[^`\\n]*\\n)|~{3,})[^\\n]*\\n").replace("list", " {0,3}(?:[*+-]|1[.)]) ") // only lists starting from 1 can interrupt
    .replace("html", "</?(?:tag)(?: +|\\n|/?>)|<(?:script|pre|style|textarea|!--)").replace("tag", block._tag) // pars can be interrupted by type (6) html blocks
    .getRegex();
    block.blockquote = edit(block.blockquote).replace("paragraph", block.paragraph).getRegex();
    /**
   * Normal Block Grammar
   */ block.normal = _extends({}, block);
    /**
   * GFM Block Grammar
   */ block.gfm = _extends({}, block.normal, {
        table: "^ *([^\\n ].*\\|.*)\\n {0,3}(?:\\| *)?(:?-+:? *(?:\\| *:?-+:? *)*)(?:\\| *)?(?:\\n((?:(?! *\\n|hr|heading|blockquote|code|fences|list|html).*(?:\\n|$))*)\\n*|$)" // Cells
    });
    block.gfm.table = edit(block.gfm.table).replace("hr", block.hr).replace("heading", " {0,3}#{1,6} ").replace("blockquote", " {0,3}>").replace("code", " {4}[^\\n]").replace("fences", " {0,3}(?:`{3,}(?=[^`\\n]*\\n)|~{3,})[^\\n]*\\n").replace("list", " {0,3}(?:[*+-]|1[.)]) ") // only lists starting from 1 can interrupt
    .replace("html", "</?(?:tag)(?: +|\\n|/?>)|<(?:script|pre|style|textarea|!--)").replace("tag", block._tag) // tables can be interrupted by type (6) html blocks
    .getRegex();
    block.gfm.paragraph = edit(block._paragraph).replace("hr", block.hr).replace("heading", " {0,3}#{1,6} ").replace("|lheading", "") // setex headings don't interrupt commonmark paragraphs
    .replace("table", block.gfm.table) // interrupt paragraphs with table
    .replace("blockquote", " {0,3}>").replace("fences", " {0,3}(?:`{3,}(?=[^`\\n]*\\n)|~{3,})[^\\n]*\\n").replace("list", " {0,3}(?:[*+-]|1[.)]) ") // only lists starting from 1 can interrupt
    .replace("html", "</?(?:tag)(?: +|\\n|/?>)|<(?:script|pre|style|textarea|!--)").replace("tag", block._tag) // pars can be interrupted by type (6) html blocks
    .getRegex();
    /**
   * Pedantic grammar (original John Gruber's loose markdown specification)
   */ block.pedantic = _extends({}, block.normal, {
        html: edit("^ *(?:comment *(?:\\n|\\s*$)|<(tag)[\\s\\S]+?</\\1> *(?:\\n{2,}|\\s*$)|<tag(?:\"[^\"]*\"|'[^']*'|\\s[^'\"/>\\s]*)*?/?> *(?:\\n{2,}|\\s*$))").replace("comment", block._comment).replace(/tag/g, "(?!(?:a|em|strong|small|s|cite|q|dfn|abbr|data|time|code|var|samp|kbd|sub|sup|i|b|u|mark|ruby|rt|rp|bdi|bdo|span|br|wbr|ins|del|img)\\b)\\w+(?!:|[^\\w\\s@]*@)\\b").getRegex(),
        def: /^ *\[([^\]]+)\]: *<?([^\s>]+)>?(?: +(["(][^\n]+[")]))? *(?:\n+|$)/,
        heading: /^(#{1,6})(.*)(?:\n+|$)/,
        fences: noopTest,
        // fences not supported
        lheading: /^(.+?)\n {0,3}(=+|-+) *(?:\n+|$)/,
        paragraph: edit(block.normal._paragraph).replace("hr", block.hr).replace("heading", " *#{1,6} *[^\n]").replace("lheading", block.lheading).replace("blockquote", " {0,3}>").replace("|fences", "").replace("|list", "").replace("|html", "").getRegex()
    });
    /**
   * Inline-Level Grammar
   */ var inline = {
        escape: /^\\([!"#$%&'()*+,\-./:;<=>?@\[\]\\^_`{|}~])/,
        autolink: /^<(scheme:[^\s\x00-\x1f<>]*|email)>/,
        url: noopTest,
        tag: "^comment|^</[a-zA-Z][\\w:-]*\\s*>|^<[a-zA-Z][\\w-]*(?:attribute)*?\\s*/?>|^<\\?[\\s\\S]*?\\?>|^<![a-zA-Z]+\\s[\\s\\S]*?>|^<!\\[CDATA\\[[\\s\\S]*?\\]\\]>",
        // CDATA section
        link: /^!?\[(label)\]\(\s*(href)(?:\s+(title))?\s*\)/,
        reflink: /^!?\[(label)\]\[(ref)\]/,
        nolink: /^!?\[(ref)\](?:\[\])?/,
        reflinkSearch: "reflink|nolink(?!\\()",
        emStrong: {
            lDelim: /^(?:\*+(?:([punct_])|[^\s*]))|^_+(?:([punct*])|([^\s_]))/,
            //        (1) and (2) can only be a Right Delimiter. (3) and (4) can only be Left.  (5) and (6) can be either Left or Right.
            //          () Skip orphan inside strong                                      () Consume to delim     (1) #***                (2) a***#, a***                             (3) #***a, ***a                 (4) ***#              (5) #***#                 (6) a***a
            rDelimAst: /^(?:[^_*\\]|\\.)*?\_\_(?:[^_*\\]|\\.)*?\*(?:[^_*\\]|\\.)*?(?=\_\_)|(?:[^*\\]|\\.)+(?=[^*])|[punct_](\*+)(?=[\s]|$)|(?:[^punct*_\s\\]|\\.)(\*+)(?=[punct_\s]|$)|[punct_\s](\*+)(?=[^punct*_\s])|[\s](\*+)(?=[punct_])|[punct_](\*+)(?=[punct_])|(?:[^punct*_\s\\]|\\.)(\*+)(?=[^punct*_\s])/,
            rDelimUnd: /^(?:[^_*\\]|\\.)*?\*\*(?:[^_*\\]|\\.)*?\_(?:[^_*\\]|\\.)*?(?=\*\*)|(?:[^_\\]|\\.)+(?=[^_])|[punct*](\_+)(?=[\s]|$)|(?:[^punct*_\s\\]|\\.)(\_+)(?=[punct*\s]|$)|[punct*\s](\_+)(?=[^punct*_\s])|[\s](\_+)(?=[punct*])|[punct*](\_+)(?=[punct*])/ // ^- Not allowed for _
        },
        code: /^(`+)([^`]|[^`][\s\S]*?[^`])\1(?!`)/,
        br: /^( {2,}|\\)\n(?!\s*$)/,
        del: noopTest,
        text: /^(`+|[^`])(?:(?= {2,}\n)|[\s\S]*?(?:(?=[\\<!\[`*_]|\b_|$)|[^ ](?= {2,}\n)))/,
        punctuation: /^([\spunctuation])/
    };
    // list of punctuation marks from CommonMark spec
    // without * and _ to handle the different emphasis markers * and _
    inline._punctuation = "!\"#$%&'()+\\-.,/:;<=>?@\\[\\]`^{|}~";
    inline.punctuation = edit(inline.punctuation).replace(/punctuation/g, inline._punctuation).getRegex();
    // sequences em should skip over [title](link), `code`, <html>
    inline.blockSkip = /\[[^\]]*?\]\([^\)]*?\)|`[^`]*?`|<[^>]*?>/g;
    // lookbehind is not available on Safari as of version 16
    // inline.escapedEmSt = /(?<=(?:^|[^\\)(?:\\[^])*)\\[*_]/g;
    inline.escapedEmSt = /(?:^|[^\\])(?:\\\\)*\\[*_]/g;
    inline._comment = edit(block._comment).replace("(?:-->|$)", "-->").getRegex();
    inline.emStrong.lDelim = edit(inline.emStrong.lDelim).replace(/punct/g, inline._punctuation).getRegex();
    inline.emStrong.rDelimAst = edit(inline.emStrong.rDelimAst, "g").replace(/punct/g, inline._punctuation).getRegex();
    inline.emStrong.rDelimUnd = edit(inline.emStrong.rDelimUnd, "g").replace(/punct/g, inline._punctuation).getRegex();
    inline._escapes = /\\([!"#$%&'()*+,\-./:;<=>?@\[\]\\^_`{|}~])/g;
    inline._scheme = /[a-zA-Z][a-zA-Z0-9+.-]{1,31}/;
    inline._email = /[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+(@)[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+(?![-_])/;
    inline.autolink = edit(inline.autolink).replace("scheme", inline._scheme).replace("email", inline._email).getRegex();
    inline._attribute = /\s+[a-zA-Z:_][\w.:-]*(?:\s*=\s*"[^"]*"|\s*=\s*'[^']*'|\s*=\s*[^\s"'=<>`]+)?/;
    inline.tag = edit(inline.tag).replace("comment", inline._comment).replace("attribute", inline._attribute).getRegex();
    inline._label = /(?:\[(?:\\.|[^\[\]\\])*\]|\\.|`[^`]*`|[^\[\]\\`])*?/;
    inline._href = /<(?:\\.|[^\n<>\\])+>|[^\s\x00-\x1f]*/;
    inline._title = /"(?:\\"?|[^"\\])*"|'(?:\\'?|[^'\\])*'|\((?:\\\)?|[^)\\])*\)/;
    inline.link = edit(inline.link).replace("label", inline._label).replace("href", inline._href).replace("title", inline._title).getRegex();
    inline.reflink = edit(inline.reflink).replace("label", inline._label).replace("ref", block._label).getRegex();
    inline.nolink = edit(inline.nolink).replace("ref", block._label).getRegex();
    inline.reflinkSearch = edit(inline.reflinkSearch, "g").replace("reflink", inline.reflink).replace("nolink", inline.nolink).getRegex();
    /**
   * Normal Inline Grammar
   */ inline.normal = _extends({}, inline);
    /**
   * Pedantic Inline Grammar
   */ inline.pedantic = _extends({}, inline.normal, {
        strong: {
            start: /^__|\*\*/,
            middle: /^__(?=\S)([\s\S]*?\S)__(?!_)|^\*\*(?=\S)([\s\S]*?\S)\*\*(?!\*)/,
            endAst: /\*\*(?!\*)/g,
            endUnd: /__(?!_)/g
        },
        em: {
            start: /^_|\*/,
            middle: /^()\*(?=\S)([\s\S]*?\S)\*(?!\*)|^_(?=\S)([\s\S]*?\S)_(?!_)/,
            endAst: /\*(?!\*)/g,
            endUnd: /_(?!_)/g
        },
        link: edit(/^!?\[(label)\]\((.*?)\)/).replace("label", inline._label).getRegex(),
        reflink: edit(/^!?\[(label)\]\s*\[([^\]]*)\]/).replace("label", inline._label).getRegex()
    });
    /**
   * GFM Inline Grammar
   */ inline.gfm = _extends({}, inline.normal, {
        escape: edit(inline.escape).replace("])", "~|])").getRegex(),
        _extended_email: /[A-Za-z0-9._+-]+(@)[a-zA-Z0-9-_]+(?:\.[a-zA-Z0-9-_]*[a-zA-Z0-9])+(?![-_])/,
        url: /^((?:ftp|https?):\/\/|www\.)(?:[a-zA-Z0-9\-]+\.?)+[^\s<]*|^email/,
        _backpedal: /(?:[^?!.,:;*_'"~()&]+|\([^)]*\)|&(?![a-zA-Z0-9]+;$)|[?!.,:;*_'"~)]+(?!$))+/,
        del: /^(~~?)(?=[^\s~])([\s\S]*?[^\s~])\1(?=[^~]|$)/,
        text: /^([`~]+|[^`~])(?:(?= {2,}\n)|(?=[a-zA-Z0-9.!#$%&'*+\/=?_`{\|}~-]+@)|[\s\S]*?(?:(?=[\\<!\[`*~_]|\b_|https?:\/\/|ftp:\/\/|www\.|$)|[^ ](?= {2,}\n)|[^a-zA-Z0-9.!#$%&'*+\/=?_`{\|}~-](?=[a-zA-Z0-9.!#$%&'*+\/=?_`{\|}~-]+@)))/
    });
    inline.gfm.url = edit(inline.gfm.url, "i").replace("email", inline.gfm._extended_email).getRegex();
    /**
   * GFM + Line Breaks Inline Grammar
   */ inline.breaks = _extends({}, inline.gfm, {
        br: edit(inline.br).replace("{2,}", "*").getRegex(),
        text: edit(inline.gfm.text).replace("\\b_", "\\b_| {2,}\\n").replace(/\{2,\}/g, "*").getRegex()
    });
    /**
   * smartypants text replacement
   * @param {string} text
   */ function smartypants(text) {
        return text// em-dashes
        .replace(/---/g, "—")// en-dashes
        .replace(/--/g, "–")// opening singles
        .replace(/(^|[-\u2014/(\[{"\s])'/g, "$1‘")// closing singles & apostrophes
        .replace(/'/g, "’")// opening doubles
        .replace(/(^|[-\u2014/(\[{\u2018\s])"/g, "$1“")// closing doubles
        .replace(/"/g, "”")// ellipses
        .replace(/\.{3}/g, "…");
    }
    /**
   * mangle email addresses
   * @param {string} text
   */ function mangle(text) {
        var out = "", i, ch;
        var l = text.length;
        for(i = 0; i < l; i++){
            ch = text.charCodeAt(i);
            if (Math.random() > 0.5) ch = "x" + ch.toString(16);
            out += "&#" + ch + ";";
        }
        return out;
    }
    /**
   * Block Lexer
   */ var Lexer = /*#__PURE__*/ function() {
        function Lexer(options) {
            this.tokens = [];
            this.tokens.links = Object.create(null);
            this.options = options || exports1.defaults;
            this.options.tokenizer = this.options.tokenizer || new Tokenizer();
            this.tokenizer = this.options.tokenizer;
            this.tokenizer.options = this.options;
            this.tokenizer.lexer = this;
            this.inlineQueue = [];
            this.state = {
                inLink: false,
                inRawBlock: false,
                top: true
            };
            var rules = {
                block: block.normal,
                inline: inline.normal
            };
            if (this.options.pedantic) {
                rules.block = block.pedantic;
                rules.inline = inline.pedantic;
            } else if (this.options.gfm) {
                rules.block = block.gfm;
                if (this.options.breaks) rules.inline = inline.breaks;
                else rules.inline = inline.gfm;
            }
            this.tokenizer.rules = rules;
        }
        /**
     * Expose Rules
     */ /**
     * Static Lex Method
     */ Lexer.lex = function lex(src, options) {
            var lexer = new Lexer(options);
            return lexer.lex(src);
        } /**
     * Static Lex Inline Method
     */ ;
        Lexer.lexInline = function lexInline(src, options) {
            var lexer = new Lexer(options);
            return lexer.inlineTokens(src);
        } /**
     * Preprocessing
     */ ;
        var _proto = Lexer.prototype;
        _proto.lex = function lex(src) {
            src = src.replace(/\r\n|\r/g, "\n");
            this.blockTokens(src, this.tokens);
            var next;
            while(next = this.inlineQueue.shift())this.inlineTokens(next.src, next.tokens);
            return this.tokens;
        } /**
     * Lexing
     */ ;
        _proto.blockTokens = function blockTokens(src, tokens) {
            var _this = this;
            if (tokens === void 0) tokens = [];
            if (this.options.pedantic) src = src.replace(/\t/g, "    ").replace(/^ +$/gm, "");
            else src = src.replace(/^( *)(\t+)/gm, function(_, leading, tabs) {
                return leading + "    ".repeat(tabs.length);
            });
            var token, lastToken, cutSrc, lastParagraphClipped;
            while(src){
                if (this.options.extensions && this.options.extensions.block && this.options.extensions.block.some(function(extTokenizer) {
                    if (token = extTokenizer.call({
                        lexer: _this
                    }, src, tokens)) {
                        src = src.substring(token.raw.length);
                        tokens.push(token);
                        return true;
                    }
                    return false;
                })) continue;
                // newline
                if (token = this.tokenizer.space(src)) {
                    src = src.substring(token.raw.length);
                    if (token.raw.length === 1 && tokens.length > 0) // if there's a single \n as a spacer, it's terminating the last line,
                    // so move it there so that we don't get unecessary paragraph tags
                    tokens[tokens.length - 1].raw += "\n";
                    else tokens.push(token);
                    continue;
                }
                // code
                if (token = this.tokenizer.code(src)) {
                    src = src.substring(token.raw.length);
                    lastToken = tokens[tokens.length - 1];
                    // An indented code block cannot interrupt a paragraph.
                    if (lastToken && (lastToken.type === "paragraph" || lastToken.type === "text")) {
                        lastToken.raw += "\n" + token.raw;
                        lastToken.text += "\n" + token.text;
                        this.inlineQueue[this.inlineQueue.length - 1].src = lastToken.text;
                    } else tokens.push(token);
                    continue;
                }
                // fences
                if (token = this.tokenizer.fences(src)) {
                    src = src.substring(token.raw.length);
                    tokens.push(token);
                    continue;
                }
                // heading
                if (token = this.tokenizer.heading(src)) {
                    src = src.substring(token.raw.length);
                    tokens.push(token);
                    continue;
                }
                // hr
                if (token = this.tokenizer.hr(src)) {
                    src = src.substring(token.raw.length);
                    tokens.push(token);
                    continue;
                }
                // blockquote
                if (token = this.tokenizer.blockquote(src)) {
                    src = src.substring(token.raw.length);
                    tokens.push(token);
                    continue;
                }
                // list
                if (token = this.tokenizer.list(src)) {
                    src = src.substring(token.raw.length);
                    tokens.push(token);
                    continue;
                }
                // html
                if (token = this.tokenizer.html(src)) {
                    src = src.substring(token.raw.length);
                    tokens.push(token);
                    continue;
                }
                // def
                if (token = this.tokenizer.def(src)) {
                    src = src.substring(token.raw.length);
                    lastToken = tokens[tokens.length - 1];
                    if (lastToken && (lastToken.type === "paragraph" || lastToken.type === "text")) {
                        lastToken.raw += "\n" + token.raw;
                        lastToken.text += "\n" + token.raw;
                        this.inlineQueue[this.inlineQueue.length - 1].src = lastToken.text;
                    } else if (!this.tokens.links[token.tag]) this.tokens.links[token.tag] = {
                        href: token.href,
                        title: token.title
                    };
                    continue;
                }
                // table (gfm)
                if (token = this.tokenizer.table(src)) {
                    src = src.substring(token.raw.length);
                    tokens.push(token);
                    continue;
                }
                // lheading
                if (token = this.tokenizer.lheading(src)) {
                    src = src.substring(token.raw.length);
                    tokens.push(token);
                    continue;
                }
                // top-level paragraph
                // prevent paragraph consuming extensions by clipping 'src' to extension start
                cutSrc = src;
                if (this.options.extensions && this.options.extensions.startBlock) (function() {
                    var startIndex = Infinity;
                    var tempSrc = src.slice(1);
                    var tempStart = void 0;
                    _this.options.extensions.startBlock.forEach(function(getStartIndex) {
                        tempStart = getStartIndex.call({
                            lexer: this
                        }, tempSrc);
                        if (typeof tempStart === "number" && tempStart >= 0) startIndex = Math.min(startIndex, tempStart);
                    });
                    if (startIndex < Infinity && startIndex >= 0) cutSrc = src.substring(0, startIndex + 1);
                })();
                if (this.state.top && (token = this.tokenizer.paragraph(cutSrc))) {
                    lastToken = tokens[tokens.length - 1];
                    if (lastParagraphClipped && lastToken.type === "paragraph") {
                        lastToken.raw += "\n" + token.raw;
                        lastToken.text += "\n" + token.text;
                        this.inlineQueue.pop();
                        this.inlineQueue[this.inlineQueue.length - 1].src = lastToken.text;
                    } else tokens.push(token);
                    lastParagraphClipped = cutSrc.length !== src.length;
                    src = src.substring(token.raw.length);
                    continue;
                }
                // text
                if (token = this.tokenizer.text(src)) {
                    src = src.substring(token.raw.length);
                    lastToken = tokens[tokens.length - 1];
                    if (lastToken && lastToken.type === "text") {
                        lastToken.raw += "\n" + token.raw;
                        lastToken.text += "\n" + token.text;
                        this.inlineQueue.pop();
                        this.inlineQueue[this.inlineQueue.length - 1].src = lastToken.text;
                    } else tokens.push(token);
                    continue;
                }
                if (src) {
                    var errMsg = "Infinite loop on byte: " + src.charCodeAt(0);
                    if (this.options.silent) {
                        console.error(errMsg);
                        break;
                    } else throw new Error(errMsg);
                }
            }
            this.state.top = true;
            return tokens;
        };
        _proto.inline = function inline(src, tokens) {
            if (tokens === void 0) tokens = [];
            this.inlineQueue.push({
                src: src,
                tokens: tokens
            });
            return tokens;
        } /**
     * Lexing/Compiling
     */ ;
        _proto.inlineTokens = function inlineTokens(src, tokens) {
            var _this2 = this;
            if (tokens === void 0) tokens = [];
            var token, lastToken, cutSrc;
            // String with links masked to avoid interference with em and strong
            var maskedSrc = src;
            var match;
            var keepPrevChar, prevChar;
            // Mask out reflinks
            if (this.tokens.links) {
                var links = Object.keys(this.tokens.links);
                if (links.length > 0) {
                    while((match = this.tokenizer.rules.inline.reflinkSearch.exec(maskedSrc)) != null)if (links.includes(match[0].slice(match[0].lastIndexOf("[") + 1, -1))) maskedSrc = maskedSrc.slice(0, match.index) + "[" + repeatString("a", match[0].length - 2) + "]" + maskedSrc.slice(this.tokenizer.rules.inline.reflinkSearch.lastIndex);
                }
            }
            // Mask out other blocks
            while((match = this.tokenizer.rules.inline.blockSkip.exec(maskedSrc)) != null)maskedSrc = maskedSrc.slice(0, match.index) + "[" + repeatString("a", match[0].length - 2) + "]" + maskedSrc.slice(this.tokenizer.rules.inline.blockSkip.lastIndex);
            // Mask out escaped em & strong delimiters
            while((match = this.tokenizer.rules.inline.escapedEmSt.exec(maskedSrc)) != null){
                maskedSrc = maskedSrc.slice(0, match.index + match[0].length - 2) + "++" + maskedSrc.slice(this.tokenizer.rules.inline.escapedEmSt.lastIndex);
                this.tokenizer.rules.inline.escapedEmSt.lastIndex--;
            }
            while(src){
                if (!keepPrevChar) prevChar = "";
                keepPrevChar = false;
                // extensions
                if (this.options.extensions && this.options.extensions.inline && this.options.extensions.inline.some(function(extTokenizer) {
                    if (token = extTokenizer.call({
                        lexer: _this2
                    }, src, tokens)) {
                        src = src.substring(token.raw.length);
                        tokens.push(token);
                        return true;
                    }
                    return false;
                })) continue;
                // escape
                if (token = this.tokenizer.escape(src)) {
                    src = src.substring(token.raw.length);
                    tokens.push(token);
                    continue;
                }
                // tag
                if (token = this.tokenizer.tag(src)) {
                    src = src.substring(token.raw.length);
                    lastToken = tokens[tokens.length - 1];
                    if (lastToken && token.type === "text" && lastToken.type === "text") {
                        lastToken.raw += token.raw;
                        lastToken.text += token.text;
                    } else tokens.push(token);
                    continue;
                }
                // link
                if (token = this.tokenizer.link(src)) {
                    src = src.substring(token.raw.length);
                    tokens.push(token);
                    continue;
                }
                // reflink, nolink
                if (token = this.tokenizer.reflink(src, this.tokens.links)) {
                    src = src.substring(token.raw.length);
                    lastToken = tokens[tokens.length - 1];
                    if (lastToken && token.type === "text" && lastToken.type === "text") {
                        lastToken.raw += token.raw;
                        lastToken.text += token.text;
                    } else tokens.push(token);
                    continue;
                }
                // em & strong
                if (token = this.tokenizer.emStrong(src, maskedSrc, prevChar)) {
                    src = src.substring(token.raw.length);
                    tokens.push(token);
                    continue;
                }
                // code
                if (token = this.tokenizer.codespan(src)) {
                    src = src.substring(token.raw.length);
                    tokens.push(token);
                    continue;
                }
                // br
                if (token = this.tokenizer.br(src)) {
                    src = src.substring(token.raw.length);
                    tokens.push(token);
                    continue;
                }
                // del (gfm)
                if (token = this.tokenizer.del(src)) {
                    src = src.substring(token.raw.length);
                    tokens.push(token);
                    continue;
                }
                // autolink
                if (token = this.tokenizer.autolink(src, mangle)) {
                    src = src.substring(token.raw.length);
                    tokens.push(token);
                    continue;
                }
                // url (gfm)
                if (!this.state.inLink && (token = this.tokenizer.url(src, mangle))) {
                    src = src.substring(token.raw.length);
                    tokens.push(token);
                    continue;
                }
                // text
                // prevent inlineText consuming extensions by clipping 'src' to extension start
                cutSrc = src;
                if (this.options.extensions && this.options.extensions.startInline) (function() {
                    var startIndex = Infinity;
                    var tempSrc = src.slice(1);
                    var tempStart = void 0;
                    _this2.options.extensions.startInline.forEach(function(getStartIndex) {
                        tempStart = getStartIndex.call({
                            lexer: this
                        }, tempSrc);
                        if (typeof tempStart === "number" && tempStart >= 0) startIndex = Math.min(startIndex, tempStart);
                    });
                    if (startIndex < Infinity && startIndex >= 0) cutSrc = src.substring(0, startIndex + 1);
                })();
                if (token = this.tokenizer.inlineText(cutSrc, smartypants)) {
                    src = src.substring(token.raw.length);
                    if (token.raw.slice(-1) !== "_") // Track prevChar before string of ____ started
                    prevChar = token.raw.slice(-1);
                    keepPrevChar = true;
                    lastToken = tokens[tokens.length - 1];
                    if (lastToken && lastToken.type === "text") {
                        lastToken.raw += token.raw;
                        lastToken.text += token.text;
                    } else tokens.push(token);
                    continue;
                }
                if (src) {
                    var errMsg = "Infinite loop on byte: " + src.charCodeAt(0);
                    if (this.options.silent) {
                        console.error(errMsg);
                        break;
                    } else throw new Error(errMsg);
                }
            }
            return tokens;
        };
        _createClass(Lexer, null, [
            {
                key: "rules",
                get: function get() {
                    return {
                        block: block,
                        inline: inline
                    };
                }
            }
        ]);
        return Lexer;
    }();
    /**
   * Renderer
   */ var Renderer = /*#__PURE__*/ function() {
        function Renderer(options) {
            this.options = options || exports1.defaults;
        }
        var _proto = Renderer.prototype;
        _proto.code = function code(_code, infostring, escaped) {
            var lang = (infostring || "").match(/\S*/)[0];
            if (this.options.highlight) {
                var out = this.options.highlight(_code, lang);
                if (out != null && out !== _code) {
                    escaped = true;
                    _code = out;
                }
            }
            _code = _code.replace(/\n$/, "") + "\n";
            if (!lang) return "<pre><code>" + (escaped ? _code : escape(_code, true)) + "</code></pre>\n";
            return '<pre><code class="' + this.options.langPrefix + escape(lang) + '">' + (escaped ? _code : escape(_code, true)) + "</code></pre>\n";
        } /**
     * @param {string} quote
     */ ;
        _proto.blockquote = function blockquote(quote) {
            return "<blockquote>\n" + quote + "</blockquote>\n";
        };
        _proto.html = function html(_html) {
            return _html;
        } /**
     * @param {string} text
     * @param {string} level
     * @param {string} raw
     * @param {any} slugger
     */ ;
        _proto.heading = function heading(text, level, raw, slugger) {
            if (this.options.headerIds) {
                var id = this.options.headerPrefix + slugger.slug(raw);
                return "<h" + level + ' id="' + id + '">' + text + "</h" + level + ">\n";
            }
            // ignore IDs
            return "<h" + level + ">" + text + "</h" + level + ">\n";
        };
        _proto.hr = function hr() {
            return this.options.xhtml ? "<hr/>\n" : "<hr>\n";
        };
        _proto.list = function list(body, ordered, start) {
            var type = ordered ? "ol" : "ul", startatt = ordered && start !== 1 ? ' start="' + start + '"' : "";
            return "<" + type + startatt + ">\n" + body + "</" + type + ">\n";
        } /**
     * @param {string} text
     */ ;
        _proto.listitem = function listitem(text) {
            return "<li>" + text + "</li>\n";
        };
        _proto.checkbox = function checkbox(checked) {
            return "<input " + (checked ? 'checked="" ' : "") + 'disabled="" type="checkbox"' + (this.options.xhtml ? " /" : "") + "> ";
        } /**
     * @param {string} text
     */ ;
        _proto.paragraph = function paragraph(text) {
            return "<p>" + text + "</p>\n";
        } /**
     * @param {string} header
     * @param {string} body
     */ ;
        _proto.table = function table(header, body) {
            if (body) body = "<tbody>" + body + "</tbody>";
            return "<table>\n<thead>\n" + header + "</thead>\n" + body + "</table>\n";
        } /**
     * @param {string} content
     */ ;
        _proto.tablerow = function tablerow(content) {
            return "<tr>\n" + content + "</tr>\n";
        };
        _proto.tablecell = function tablecell(content, flags) {
            var type = flags.header ? "th" : "td";
            var tag = flags.align ? "<" + type + ' align="' + flags.align + '">' : "<" + type + ">";
            return tag + content + ("</" + type + ">\n");
        } /**
     * span level renderer
     * @param {string} text
     */ ;
        _proto.strong = function strong(text) {
            return "<strong>" + text + "</strong>";
        } /**
     * @param {string} text
     */ ;
        _proto.em = function em(text) {
            return "<em>" + text + "</em>";
        } /**
     * @param {string} text
     */ ;
        _proto.codespan = function codespan(text) {
            return "<code>" + text + "</code>";
        };
        _proto.br = function br() {
            return this.options.xhtml ? "<br/>" : "<br>";
        } /**
     * @param {string} text
     */ ;
        _proto.del = function del(text) {
            return "<del>" + text + "</del>";
        } /**
     * @param {string} href
     * @param {string} title
     * @param {string} text
     */ ;
        _proto.link = function link(href, title, text) {
            href = cleanUrl(this.options.sanitize, this.options.baseUrl, href);
            if (href === null) return text;
            var out = '<a href="' + href + '"';
            if (title) out += ' title="' + title + '"';
            out += ">" + text + "</a>";
            return out;
        } /**
     * @param {string} href
     * @param {string} title
     * @param {string} text
     */ ;
        _proto.image = function image(href, title, text) {
            href = cleanUrl(this.options.sanitize, this.options.baseUrl, href);
            if (href === null) return text;
            var out = '<img src="' + href + '" alt="' + text + '"';
            if (title) out += ' title="' + title + '"';
            out += this.options.xhtml ? "/>" : ">";
            return out;
        };
        _proto.text = function text(_text) {
            return _text;
        };
        return Renderer;
    }();
    /**
   * TextRenderer
   * returns only the textual part of the token
   */ var TextRenderer = /*#__PURE__*/ function() {
        function TextRenderer() {}
        var _proto = TextRenderer.prototype;
        // no need for block level renderers
        _proto.strong = function strong(text) {
            return text;
        };
        _proto.em = function em(text) {
            return text;
        };
        _proto.codespan = function codespan(text) {
            return text;
        };
        _proto.del = function del(text) {
            return text;
        };
        _proto.html = function html(text) {
            return text;
        };
        _proto.text = function text(_text) {
            return _text;
        };
        _proto.link = function link(href, title, text) {
            return "" + text;
        };
        _proto.image = function image(href, title, text) {
            return "" + text;
        };
        _proto.br = function br() {
            return "";
        };
        return TextRenderer;
    }();
    /**
   * Slugger generates header id
   */ var Slugger = /*#__PURE__*/ function() {
        function Slugger() {
            this.seen = {};
        }
        /**
     * @param {string} value
     */ var _proto = Slugger.prototype;
        _proto.serialize = function serialize(value) {
            return value.toLowerCase().trim()// remove html tags
            .replace(/<[!\/a-z].*?>/ig, "")// remove unwanted chars
            .replace(/[\u2000-\u206F\u2E00-\u2E7F\\'!"#$%&()*+,./:;<=>?@[\]^`{|}~]/g, "").replace(/\s/g, "-");
        } /**
     * Finds the next safe (unique) slug to use
     * @param {string} originalSlug
     * @param {boolean} isDryRun
     */ ;
        _proto.getNextSafeSlug = function getNextSafeSlug(originalSlug, isDryRun) {
            var slug = originalSlug;
            var occurenceAccumulator = 0;
            if (this.seen.hasOwnProperty(slug)) {
                occurenceAccumulator = this.seen[originalSlug];
                do {
                    occurenceAccumulator++;
                    slug = originalSlug + "-" + occurenceAccumulator;
                }while (this.seen.hasOwnProperty(slug));
            }
            if (!isDryRun) {
                this.seen[originalSlug] = occurenceAccumulator;
                this.seen[slug] = 0;
            }
            return slug;
        } /**
     * Convert string to unique id
     * @param {object} [options]
     * @param {boolean} [options.dryrun] Generates the next unique slug without
     * updating the internal accumulator.
     */ ;
        _proto.slug = function slug(value, options) {
            if (options === void 0) options = {};
            var slug = this.serialize(value);
            return this.getNextSafeSlug(slug, options.dryrun);
        };
        return Slugger;
    }();
    /**
   * Parsing & Compiling
   */ var Parser = /*#__PURE__*/ function() {
        function Parser(options) {
            this.options = options || exports1.defaults;
            this.options.renderer = this.options.renderer || new Renderer();
            this.renderer = this.options.renderer;
            this.renderer.options = this.options;
            this.textRenderer = new TextRenderer();
            this.slugger = new Slugger();
        }
        /**
     * Static Parse Method
     */ Parser.parse = function parse(tokens, options) {
            var parser = new Parser(options);
            return parser.parse(tokens);
        } /**
     * Static Parse Inline Method
     */ ;
        Parser.parseInline = function parseInline(tokens, options) {
            var parser = new Parser(options);
            return parser.parseInline(tokens);
        } /**
     * Parse Loop
     */ ;
        var _proto = Parser.prototype;
        _proto.parse = function parse(tokens, top) {
            if (top === void 0) top = true;
            var out = "", i, j, k, l2, l3, row, cell, header, body, token, ordered, start, loose, itemBody, item, checked, task, checkbox, ret;
            var l = tokens.length;
            for(i = 0; i < l; i++){
                token = tokens[i];
                // Run any renderer extensions
                if (this.options.extensions && this.options.extensions.renderers && this.options.extensions.renderers[token.type]) {
                    ret = this.options.extensions.renderers[token.type].call({
                        parser: this
                    }, token);
                    if (ret !== false || ![
                        "space",
                        "hr",
                        "heading",
                        "code",
                        "table",
                        "blockquote",
                        "list",
                        "html",
                        "paragraph",
                        "text"
                    ].includes(token.type)) {
                        out += ret || "";
                        continue;
                    }
                }
                switch(token.type){
                    case "space":
                        continue;
                    case "hr":
                        out += this.renderer.hr();
                        continue;
                    case "heading":
                        out += this.renderer.heading(this.parseInline(token.tokens), token.depth, unescape(this.parseInline(token.tokens, this.textRenderer)), this.slugger);
                        continue;
                    case "code":
                        out += this.renderer.code(token.text, token.lang, token.escaped);
                        continue;
                    case "table":
                        header = "";
                        // header
                        cell = "";
                        l2 = token.header.length;
                        for(j = 0; j < l2; j++)cell += this.renderer.tablecell(this.parseInline(token.header[j].tokens), {
                            header: true,
                            align: token.align[j]
                        });
                        header += this.renderer.tablerow(cell);
                        body = "";
                        l2 = token.rows.length;
                        for(j = 0; j < l2; j++){
                            row = token.rows[j];
                            cell = "";
                            l3 = row.length;
                            for(k = 0; k < l3; k++)cell += this.renderer.tablecell(this.parseInline(row[k].tokens), {
                                header: false,
                                align: token.align[k]
                            });
                            body += this.renderer.tablerow(cell);
                        }
                        out += this.renderer.table(header, body);
                        continue;
                    case "blockquote":
                        body = this.parse(token.tokens);
                        out += this.renderer.blockquote(body);
                        continue;
                    case "list":
                        ordered = token.ordered;
                        start = token.start;
                        loose = token.loose;
                        l2 = token.items.length;
                        body = "";
                        for(j = 0; j < l2; j++){
                            item = token.items[j];
                            checked = item.checked;
                            task = item.task;
                            itemBody = "";
                            if (item.task) {
                                checkbox = this.renderer.checkbox(checked);
                                if (loose) {
                                    if (item.tokens.length > 0 && item.tokens[0].type === "paragraph") {
                                        item.tokens[0].text = checkbox + " " + item.tokens[0].text;
                                        if (item.tokens[0].tokens && item.tokens[0].tokens.length > 0 && item.tokens[0].tokens[0].type === "text") item.tokens[0].tokens[0].text = checkbox + " " + item.tokens[0].tokens[0].text;
                                    } else item.tokens.unshift({
                                        type: "text",
                                        text: checkbox
                                    });
                                } else itemBody += checkbox;
                            }
                            itemBody += this.parse(item.tokens, loose);
                            body += this.renderer.listitem(itemBody, task, checked);
                        }
                        out += this.renderer.list(body, ordered, start);
                        continue;
                    case "html":
                        // TODO parse inline content if parameter markdown=1
                        out += this.renderer.html(token.text);
                        continue;
                    case "paragraph":
                        out += this.renderer.paragraph(this.parseInline(token.tokens));
                        continue;
                    case "text":
                        body = token.tokens ? this.parseInline(token.tokens) : token.text;
                        while(i + 1 < l && tokens[i + 1].type === "text"){
                            token = tokens[++i];
                            body += "\n" + (token.tokens ? this.parseInline(token.tokens) : token.text);
                        }
                        out += top ? this.renderer.paragraph(body) : body;
                        continue;
                    default:
                        var errMsg = 'Token with "' + token.type + '" type was not found.';
                        if (this.options.silent) {
                            console.error(errMsg);
                            return;
                        } else throw new Error(errMsg);
                }
            }
            return out;
        } /**
     * Parse Inline Tokens
     */ ;
        _proto.parseInline = function parseInline(tokens, renderer) {
            renderer = renderer || this.renderer;
            var out = "", i, token, ret;
            var l = tokens.length;
            for(i = 0; i < l; i++){
                token = tokens[i];
                // Run any renderer extensions
                if (this.options.extensions && this.options.extensions.renderers && this.options.extensions.renderers[token.type]) {
                    ret = this.options.extensions.renderers[token.type].call({
                        parser: this
                    }, token);
                    if (ret !== false || ![
                        "escape",
                        "html",
                        "link",
                        "image",
                        "strong",
                        "em",
                        "codespan",
                        "br",
                        "del",
                        "text"
                    ].includes(token.type)) {
                        out += ret || "";
                        continue;
                    }
                }
                switch(token.type){
                    case "escape":
                        out += renderer.text(token.text);
                        break;
                    case "html":
                        out += renderer.html(token.text);
                        break;
                    case "link":
                        out += renderer.link(token.href, token.title, this.parseInline(token.tokens, renderer));
                        break;
                    case "image":
                        out += renderer.image(token.href, token.title, token.text);
                        break;
                    case "strong":
                        out += renderer.strong(this.parseInline(token.tokens, renderer));
                        break;
                    case "em":
                        out += renderer.em(this.parseInline(token.tokens, renderer));
                        break;
                    case "codespan":
                        out += renderer.codespan(token.text);
                        break;
                    case "br":
                        out += renderer.br();
                        break;
                    case "del":
                        out += renderer.del(this.parseInline(token.tokens, renderer));
                        break;
                    case "text":
                        out += renderer.text(token.text);
                        break;
                    default:
                        var errMsg = 'Token with "' + token.type + '" type was not found.';
                        if (this.options.silent) {
                            console.error(errMsg);
                            return;
                        } else throw new Error(errMsg);
                }
            }
            return out;
        };
        return Parser;
    }();
    var Hooks = /*#__PURE__*/ function() {
        function Hooks(options) {
            this.options = options || exports1.defaults;
        }
        var _proto = Hooks.prototype;
        /**
     * Process markdown before marked
     */ _proto.preprocess = function preprocess(markdown) {
            return markdown;
        } /**
     * Process HTML after marked is finished
     */ ;
        _proto.postprocess = function postprocess(html) {
            return html;
        };
        return Hooks;
    }();
    Hooks.passThroughHooks = new Set([
        "preprocess",
        "postprocess"
    ]);
    function onError(silent, async, callback) {
        return function(e) {
            e.message += "\nPlease report this to https://github.com/markedjs/marked.";
            if (silent) {
                var msg = "<p>An error occurred:</p><pre>" + escape(e.message + "", true) + "</pre>";
                if (async) return Promise.resolve(msg);
                if (callback) {
                    callback(null, msg);
                    return;
                }
                return msg;
            }
            if (async) return Promise.reject(e);
            if (callback) {
                callback(e);
                return;
            }
            throw e;
        };
    }
    function parseMarkdown(lexer, parser) {
        return function(src, opt, callback) {
            if (typeof opt === "function") {
                callback = opt;
                opt = null;
            }
            var origOpt = _extends({}, opt);
            opt = _extends({}, marked.defaults, origOpt);
            var throwError = onError(opt.silent, opt.async, callback);
            // throw error in case of non string input
            if (typeof src === "undefined" || src === null) return throwError(new Error("marked(): input parameter is undefined or null"));
            if (typeof src !== "string") return throwError(new Error("marked(): input parameter is of type " + Object.prototype.toString.call(src) + ", string expected"));
            checkSanitizeDeprecation(opt);
            if (opt.hooks) opt.hooks.options = opt;
            if (callback) {
                var highlight = opt.highlight;
                var tokens;
                try {
                    if (opt.hooks) src = opt.hooks.preprocess(src);
                    tokens = lexer(src, opt);
                } catch (e) {
                    return throwError(e);
                }
                var done = function done(err) {
                    var out;
                    if (!err) try {
                        if (opt.walkTokens) marked.walkTokens(tokens, opt.walkTokens);
                        out = parser(tokens, opt);
                        if (opt.hooks) out = opt.hooks.postprocess(out);
                    } catch (e) {
                        err = e;
                    }
                    opt.highlight = highlight;
                    return err ? throwError(err) : callback(null, out);
                };
                if (!highlight || highlight.length < 3) return done();
                delete opt.highlight;
                if (!tokens.length) return done();
                var pending = 0;
                marked.walkTokens(tokens, function(token) {
                    if (token.type === "code") {
                        pending++;
                        setTimeout(function() {
                            highlight(token.text, token.lang, function(err, code) {
                                if (err) return done(err);
                                if (code != null && code !== token.text) {
                                    token.text = code;
                                    token.escaped = true;
                                }
                                pending--;
                                if (pending === 0) done();
                            });
                        }, 0);
                    }
                });
                if (pending === 0) done();
                return;
            }
            if (opt.async) return Promise.resolve(opt.hooks ? opt.hooks.preprocess(src) : src).then(function(src) {
                return lexer(src, opt);
            }).then(function(tokens) {
                return opt.walkTokens ? Promise.all(marked.walkTokens(tokens, opt.walkTokens)).then(function() {
                    return tokens;
                }) : tokens;
            }).then(function(tokens) {
                return parser(tokens, opt);
            }).then(function(html) {
                return opt.hooks ? opt.hooks.postprocess(html) : html;
            })["catch"](throwError);
            try {
                if (opt.hooks) src = opt.hooks.preprocess(src);
                var _tokens = lexer(src, opt);
                if (opt.walkTokens) marked.walkTokens(_tokens, opt.walkTokens);
                var html = parser(_tokens, opt);
                if (opt.hooks) html = opt.hooks.postprocess(html);
                return html;
            } catch (e) {
                return throwError(e);
            }
        };
    }
    /**
   * Marked
   */ function marked(src, opt, callback) {
        return parseMarkdown(Lexer.lex, Parser.parse)(src, opt, callback);
    }
    /**
   * Options
   */ marked.options = marked.setOptions = function(opt) {
        marked.defaults = _extends({}, marked.defaults, opt);
        changeDefaults(marked.defaults);
        return marked;
    };
    marked.getDefaults = getDefaults;
    marked.defaults = exports1.defaults;
    /**
   * Use Extension
   */ marked.use = function() {
        var extensions = marked.defaults.extensions || {
            renderers: {},
            childTokens: {}
        };
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        args.forEach(function(pack) {
            // copy options to new object
            var opts = _extends({}, pack);
            // set async to true if it was set to true before
            opts.async = marked.defaults.async || opts.async || false;
            // ==-- Parse "addon" extensions --== //
            if (pack.extensions) {
                pack.extensions.forEach(function(ext) {
                    if (!ext.name) throw new Error("extension name required");
                    if (ext.renderer) {
                        // Renderer extensions
                        var prevRenderer = extensions.renderers[ext.name];
                        if (prevRenderer) // Replace extension with func to run new extension but fall back if false
                        extensions.renderers[ext.name] = function() {
                            for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
                            var ret = ext.renderer.apply(this, args);
                            if (ret === false) ret = prevRenderer.apply(this, args);
                            return ret;
                        };
                        else extensions.renderers[ext.name] = ext.renderer;
                    }
                    if (ext.tokenizer) {
                        // Tokenizer Extensions
                        if (!ext.level || ext.level !== "block" && ext.level !== "inline") throw new Error("extension level must be 'block' or 'inline'");
                        if (extensions[ext.level]) extensions[ext.level].unshift(ext.tokenizer);
                        else extensions[ext.level] = [
                            ext.tokenizer
                        ];
                        if (ext.start) {
                            // Function to check for start of token
                            if (ext.level === "block") {
                                if (extensions.startBlock) extensions.startBlock.push(ext.start);
                                else extensions.startBlock = [
                                    ext.start
                                ];
                            } else if (ext.level === "inline") {
                                if (extensions.startInline) extensions.startInline.push(ext.start);
                                else extensions.startInline = [
                                    ext.start
                                ];
                            }
                        }
                    }
                    if (ext.childTokens) // Child tokens to be visited by walkTokens
                    extensions.childTokens[ext.name] = ext.childTokens;
                });
                opts.extensions = extensions;
            }
            // ==-- Parse "overwrite" extensions --== //
            if (pack.renderer) (function() {
                var renderer = marked.defaults.renderer || new Renderer();
                var _loop = function _loop(prop) {
                    var prevRenderer = renderer[prop];
                    // Replace renderer with func to run extension, but fall back if false
                    renderer[prop] = function() {
                        for(var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++)args[_key3] = arguments[_key3];
                        var ret = pack.renderer[prop].apply(renderer, args);
                        if (ret === false) ret = prevRenderer.apply(renderer, args);
                        return ret;
                    };
                };
                for(var prop in pack.renderer)_loop(prop);
                opts.renderer = renderer;
            })();
            if (pack.tokenizer) (function() {
                var tokenizer = marked.defaults.tokenizer || new Tokenizer();
                var _loop2 = function _loop2(prop) {
                    var prevTokenizer = tokenizer[prop];
                    // Replace tokenizer with func to run extension, but fall back if false
                    tokenizer[prop] = function() {
                        for(var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++)args[_key4] = arguments[_key4];
                        var ret = pack.tokenizer[prop].apply(tokenizer, args);
                        if (ret === false) ret = prevTokenizer.apply(tokenizer, args);
                        return ret;
                    };
                };
                for(var prop in pack.tokenizer)_loop2(prop);
                opts.tokenizer = tokenizer;
            })();
            // ==-- Parse Hooks extensions --== //
            if (pack.hooks) (function() {
                var hooks = marked.defaults.hooks || new Hooks();
                var _loop3 = function _loop3(prop) {
                    var prevHook = hooks[prop];
                    if (Hooks.passThroughHooks.has(prop)) hooks[prop] = function(arg) {
                        if (marked.defaults.async) return Promise.resolve(pack.hooks[prop].call(hooks, arg)).then(function(ret) {
                            return prevHook.call(hooks, ret);
                        });
                        var ret = pack.hooks[prop].call(hooks, arg);
                        return prevHook.call(hooks, ret);
                    };
                    else hooks[prop] = function() {
                        for(var _len5 = arguments.length, args = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++)args[_key5] = arguments[_key5];
                        var ret = pack.hooks[prop].apply(hooks, args);
                        if (ret === false) ret = prevHook.apply(hooks, args);
                        return ret;
                    };
                };
                for(var prop in pack.hooks)_loop3(prop);
                opts.hooks = hooks;
            })();
            // ==-- Parse WalkTokens extensions --== //
            if (pack.walkTokens) {
                var _walkTokens = marked.defaults.walkTokens;
                opts.walkTokens = function(token) {
                    var values = [];
                    values.push(pack.walkTokens.call(this, token));
                    if (_walkTokens) values = values.concat(_walkTokens.call(this, token));
                    return values;
                };
            }
            marked.setOptions(opts);
        });
    };
    /**
   * Run callback for every token
   */ marked.walkTokens = function(tokens, callback) {
        var values = [];
        var _loop4 = function _loop4() {
            var token = _step.value;
            values = values.concat(callback.call(marked, token));
            switch(token.type){
                case "table":
                    for(var _iterator2 = _createForOfIteratorHelperLoose(token.header), _step2; !(_step2 = _iterator2()).done;){
                        var cell = _step2.value;
                        values = values.concat(marked.walkTokens(cell.tokens, callback));
                    }
                    for(var _iterator3 = _createForOfIteratorHelperLoose(token.rows), _step3; !(_step3 = _iterator3()).done;){
                        var row = _step3.value;
                        for(var _iterator4 = _createForOfIteratorHelperLoose(row), _step4; !(_step4 = _iterator4()).done;){
                            var _cell = _step4.value;
                            values = values.concat(marked.walkTokens(_cell.tokens, callback));
                        }
                    }
                    break;
                case "list":
                    values = values.concat(marked.walkTokens(token.items, callback));
                    break;
                default:
                    if (marked.defaults.extensions && marked.defaults.extensions.childTokens && marked.defaults.extensions.childTokens[token.type]) // Walk any extensions
                    marked.defaults.extensions.childTokens[token.type].forEach(function(childTokens) {
                        values = values.concat(marked.walkTokens(token[childTokens], callback));
                    });
                    else if (token.tokens) values = values.concat(marked.walkTokens(token.tokens, callback));
            }
        };
        for(var _iterator = _createForOfIteratorHelperLoose(tokens), _step; !(_step = _iterator()).done;)_loop4();
        return values;
    };
    /**
   * Parse Inline
   * @param {string} src
   */ marked.parseInline = parseMarkdown(Lexer.lexInline, Parser.parseInline);
    /**
   * Expose
   */ marked.Parser = Parser;
    marked.parser = Parser.parse;
    marked.Renderer = Renderer;
    marked.TextRenderer = TextRenderer;
    marked.Lexer = Lexer;
    marked.lexer = Lexer.lex;
    marked.Tokenizer = Tokenizer;
    marked.Slugger = Slugger;
    marked.Hooks = Hooks;
    marked.parse = marked;
    var options = marked.options;
    var setOptions = marked.setOptions;
    var use = marked.use;
    var walkTokens = marked.walkTokens;
    var parseInline = marked.parseInline;
    var parse = marked;
    var parser = Parser.parse;
    var lexer = Lexer.lex;
    exports1.Hooks = Hooks;
    exports1.Lexer = Lexer;
    exports1.Parser = Parser;
    exports1.Renderer = Renderer;
    exports1.Slugger = Slugger;
    exports1.TextRenderer = TextRenderer;
    exports1.Tokenizer = Tokenizer;
    exports1.getDefaults = getDefaults;
    exports1.lexer = lexer;
    exports1.marked = marked;
    exports1.options = options;
    exports1.parse = parse;
    exports1.parseInline = parseInline;
    exports1.parser = parser;
    exports1.setOptions = setOptions;
    exports1.use = use;
    exports1.walkTokens = walkTokens;
});

},{}],"4rJhH":[function(require,module,exports) {
var global = typeof self !== "undefined" ? self : this;
var __self__ = function() {
    function F() {
        this.fetch = false;
        this.DOMException = global.DOMException;
    }
    F.prototype = global;
    return new F();
}();
(function(self1) {
    var irrelevant = function(exports1) {
        var support = {
            searchParams: "URLSearchParams" in self1,
            iterable: "Symbol" in self1 && "iterator" in Symbol,
            blob: "FileReader" in self1 && "Blob" in self1 && function() {
                try {
                    new Blob();
                    return true;
                } catch (e) {
                    return false;
                }
            }(),
            formData: "FormData" in self1,
            arrayBuffer: "ArrayBuffer" in self1
        };
        function isDataView(obj) {
            return obj && DataView.prototype.isPrototypeOf(obj);
        }
        if (support.arrayBuffer) {
            var viewClasses = [
                "[object Int8Array]",
                "[object Uint8Array]",
                "[object Uint8ClampedArray]",
                "[object Int16Array]",
                "[object Uint16Array]",
                "[object Int32Array]",
                "[object Uint32Array]",
                "[object Float32Array]",
                "[object Float64Array]"
            ];
            var isArrayBufferView = ArrayBuffer.isView || function(obj) {
                return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1;
            };
        }
        function normalizeName(name) {
            if (typeof name !== "string") name = String(name);
            if (/[^a-z0-9\-#$%&'*+.^_`|~]/i.test(name)) throw new TypeError("Invalid character in header field name");
            return name.toLowerCase();
        }
        function normalizeValue(value) {
            if (typeof value !== "string") value = String(value);
            return value;
        }
        // Build a destructive iterator for the value list
        function iteratorFor(items) {
            var iterator = {
                next: function() {
                    var value = items.shift();
                    return {
                        done: value === undefined,
                        value: value
                    };
                }
            };
            if (support.iterable) iterator[Symbol.iterator] = function() {
                return iterator;
            };
            return iterator;
        }
        function Headers(headers) {
            this.map = {};
            if (headers instanceof Headers) headers.forEach(function(value, name) {
                this.append(name, value);
            }, this);
            else if (Array.isArray(headers)) headers.forEach(function(header) {
                this.append(header[0], header[1]);
            }, this);
            else if (headers) Object.getOwnPropertyNames(headers).forEach(function(name) {
                this.append(name, headers[name]);
            }, this);
        }
        Headers.prototype.append = function(name, value) {
            name = normalizeName(name);
            value = normalizeValue(value);
            var oldValue = this.map[name];
            this.map[name] = oldValue ? oldValue + ", " + value : value;
        };
        Headers.prototype["delete"] = function(name) {
            delete this.map[normalizeName(name)];
        };
        Headers.prototype.get = function(name) {
            name = normalizeName(name);
            return this.has(name) ? this.map[name] : null;
        };
        Headers.prototype.has = function(name) {
            return this.map.hasOwnProperty(normalizeName(name));
        };
        Headers.prototype.set = function(name, value) {
            this.map[normalizeName(name)] = normalizeValue(value);
        };
        Headers.prototype.forEach = function(callback, thisArg) {
            for(var name in this.map)if (this.map.hasOwnProperty(name)) callback.call(thisArg, this.map[name], name, this);
        };
        Headers.prototype.keys = function() {
            var items = [];
            this.forEach(function(value, name) {
                items.push(name);
            });
            return iteratorFor(items);
        };
        Headers.prototype.values = function() {
            var items = [];
            this.forEach(function(value) {
                items.push(value);
            });
            return iteratorFor(items);
        };
        Headers.prototype.entries = function() {
            var items = [];
            this.forEach(function(value, name) {
                items.push([
                    name,
                    value
                ]);
            });
            return iteratorFor(items);
        };
        if (support.iterable) Headers.prototype[Symbol.iterator] = Headers.prototype.entries;
        function consumed(body) {
            if (body.bodyUsed) return Promise.reject(new TypeError("Already read"));
            body.bodyUsed = true;
        }
        function fileReaderReady(reader) {
            return new Promise(function(resolve, reject) {
                reader.onload = function() {
                    resolve(reader.result);
                };
                reader.onerror = function() {
                    reject(reader.error);
                };
            });
        }
        function readBlobAsArrayBuffer(blob) {
            var reader = new FileReader();
            var promise = fileReaderReady(reader);
            reader.readAsArrayBuffer(blob);
            return promise;
        }
        function readBlobAsText(blob) {
            var reader = new FileReader();
            var promise = fileReaderReady(reader);
            reader.readAsText(blob);
            return promise;
        }
        function readArrayBufferAsText(buf) {
            var view = new Uint8Array(buf);
            var chars = new Array(view.length);
            for(var i = 0; i < view.length; i++)chars[i] = String.fromCharCode(view[i]);
            return chars.join("");
        }
        function bufferClone(buf) {
            if (buf.slice) return buf.slice(0);
            else {
                var view = new Uint8Array(buf.byteLength);
                view.set(new Uint8Array(buf));
                return view.buffer;
            }
        }
        function Body() {
            this.bodyUsed = false;
            this._initBody = function(body) {
                this._bodyInit = body;
                if (!body) this._bodyText = "";
                else if (typeof body === "string") this._bodyText = body;
                else if (support.blob && Blob.prototype.isPrototypeOf(body)) this._bodyBlob = body;
                else if (support.formData && FormData.prototype.isPrototypeOf(body)) this._bodyFormData = body;
                else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) this._bodyText = body.toString();
                else if (support.arrayBuffer && support.blob && isDataView(body)) {
                    this._bodyArrayBuffer = bufferClone(body.buffer);
                    // IE 10-11 can't handle a DataView body.
                    this._bodyInit = new Blob([
                        this._bodyArrayBuffer
                    ]);
                } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) this._bodyArrayBuffer = bufferClone(body);
                else this._bodyText = body = Object.prototype.toString.call(body);
                if (!this.headers.get("content-type")) {
                    if (typeof body === "string") this.headers.set("content-type", "text/plain;charset=UTF-8");
                    else if (this._bodyBlob && this._bodyBlob.type) this.headers.set("content-type", this._bodyBlob.type);
                    else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) this.headers.set("content-type", "application/x-www-form-urlencoded;charset=UTF-8");
                }
            };
            if (support.blob) {
                this.blob = function() {
                    var rejected = consumed(this);
                    if (rejected) return rejected;
                    if (this._bodyBlob) return Promise.resolve(this._bodyBlob);
                    else if (this._bodyArrayBuffer) return Promise.resolve(new Blob([
                        this._bodyArrayBuffer
                    ]));
                    else if (this._bodyFormData) throw new Error("could not read FormData body as blob");
                    else return Promise.resolve(new Blob([
                        this._bodyText
                    ]));
                };
                this.arrayBuffer = function() {
                    if (this._bodyArrayBuffer) return consumed(this) || Promise.resolve(this._bodyArrayBuffer);
                    else return this.blob().then(readBlobAsArrayBuffer);
                };
            }
            this.text = function() {
                var rejected = consumed(this);
                if (rejected) return rejected;
                if (this._bodyBlob) return readBlobAsText(this._bodyBlob);
                else if (this._bodyArrayBuffer) return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer));
                else if (this._bodyFormData) throw new Error("could not read FormData body as text");
                else return Promise.resolve(this._bodyText);
            };
            if (support.formData) this.formData = function() {
                return this.text().then(decode);
            };
            this.json = function() {
                return this.text().then(JSON.parse);
            };
            return this;
        }
        // HTTP methods whose capitalization should be normalized
        var methods = [
            "DELETE",
            "GET",
            "HEAD",
            "OPTIONS",
            "POST",
            "PUT"
        ];
        function normalizeMethod(method) {
            var upcased = method.toUpperCase();
            return methods.indexOf(upcased) > -1 ? upcased : method;
        }
        function Request(input, options) {
            options = options || {};
            var body = options.body;
            if (input instanceof Request) {
                if (input.bodyUsed) throw new TypeError("Already read");
                this.url = input.url;
                this.credentials = input.credentials;
                if (!options.headers) this.headers = new Headers(input.headers);
                this.method = input.method;
                this.mode = input.mode;
                this.signal = input.signal;
                if (!body && input._bodyInit != null) {
                    body = input._bodyInit;
                    input.bodyUsed = true;
                }
            } else this.url = String(input);
            this.credentials = options.credentials || this.credentials || "same-origin";
            if (options.headers || !this.headers) this.headers = new Headers(options.headers);
            this.method = normalizeMethod(options.method || this.method || "GET");
            this.mode = options.mode || this.mode || null;
            this.signal = options.signal || this.signal;
            this.referrer = null;
            if ((this.method === "GET" || this.method === "HEAD") && body) throw new TypeError("Body not allowed for GET or HEAD requests");
            this._initBody(body);
        }
        Request.prototype.clone = function() {
            return new Request(this, {
                body: this._bodyInit
            });
        };
        function decode(body) {
            var form = new FormData();
            body.trim().split("&").forEach(function(bytes) {
                if (bytes) {
                    var split = bytes.split("=");
                    var name = split.shift().replace(/\+/g, " ");
                    var value = split.join("=").replace(/\+/g, " ");
                    form.append(decodeURIComponent(name), decodeURIComponent(value));
                }
            });
            return form;
        }
        function parseHeaders(rawHeaders) {
            var headers = new Headers();
            // Replace instances of \r\n and \n followed by at least one space or horizontal tab with a space
            // https://tools.ietf.org/html/rfc7230#section-3.2
            var preProcessedHeaders = rawHeaders.replace(/\r?\n[\t ]+/g, " ");
            preProcessedHeaders.split(/\r?\n/).forEach(function(line) {
                var parts = line.split(":");
                var key = parts.shift().trim();
                if (key) {
                    var value = parts.join(":").trim();
                    headers.append(key, value);
                }
            });
            return headers;
        }
        Body.call(Request.prototype);
        function Response(bodyInit, options) {
            if (!options) options = {};
            this.type = "default";
            this.status = options.status === undefined ? 200 : options.status;
            this.ok = this.status >= 200 && this.status < 300;
            this.statusText = "statusText" in options ? options.statusText : "OK";
            this.headers = new Headers(options.headers);
            this.url = options.url || "";
            this._initBody(bodyInit);
        }
        Body.call(Response.prototype);
        Response.prototype.clone = function() {
            return new Response(this._bodyInit, {
                status: this.status,
                statusText: this.statusText,
                headers: new Headers(this.headers),
                url: this.url
            });
        };
        Response.error = function() {
            var response = new Response(null, {
                status: 0,
                statusText: ""
            });
            response.type = "error";
            return response;
        };
        var redirectStatuses = [
            301,
            302,
            303,
            307,
            308
        ];
        Response.redirect = function(url, status) {
            if (redirectStatuses.indexOf(status) === -1) throw new RangeError("Invalid status code");
            return new Response(null, {
                status: status,
                headers: {
                    location: url
                }
            });
        };
        exports1.DOMException = self1.DOMException;
        try {
            new exports1.DOMException();
        } catch (err) {
            exports1.DOMException = function(message, name) {
                this.message = message;
                this.name = name;
                var error = Error(message);
                this.stack = error.stack;
            };
            exports1.DOMException.prototype = Object.create(Error.prototype);
            exports1.DOMException.prototype.constructor = exports1.DOMException;
        }
        function fetch(input, init) {
            return new Promise(function(resolve, reject) {
                var request = new Request(input, init);
                if (request.signal && request.signal.aborted) return reject(new exports1.DOMException("Aborted", "AbortError"));
                var xhr = new XMLHttpRequest();
                function abortXhr() {
                    xhr.abort();
                }
                xhr.onload = function() {
                    var options = {
                        status: xhr.status,
                        statusText: xhr.statusText,
                        headers: parseHeaders(xhr.getAllResponseHeaders() || "")
                    };
                    options.url = "responseURL" in xhr ? xhr.responseURL : options.headers.get("X-Request-URL");
                    var body = "response" in xhr ? xhr.response : xhr.responseText;
                    resolve(new Response(body, options));
                };
                xhr.onerror = function() {
                    reject(new TypeError("Network request failed"));
                };
                xhr.ontimeout = function() {
                    reject(new TypeError("Network request failed"));
                };
                xhr.onabort = function() {
                    reject(new exports1.DOMException("Aborted", "AbortError"));
                };
                xhr.open(request.method, request.url, true);
                if (request.credentials === "include") xhr.withCredentials = true;
                else if (request.credentials === "omit") xhr.withCredentials = false;
                if ("responseType" in xhr && support.blob) xhr.responseType = "blob";
                request.headers.forEach(function(value, name) {
                    xhr.setRequestHeader(name, value);
                });
                if (request.signal) {
                    request.signal.addEventListener("abort", abortXhr);
                    xhr.onreadystatechange = function() {
                        // DONE (success or failure)
                        if (xhr.readyState === 4) request.signal.removeEventListener("abort", abortXhr);
                    };
                }
                xhr.send(typeof request._bodyInit === "undefined" ? null : request._bodyInit);
            });
        }
        fetch.polyfill = true;
        if (!self1.fetch) {
            self1.fetch = fetch;
            self1.Headers = Headers;
            self1.Request = Request;
            self1.Response = Response;
        }
        exports1.Headers = Headers;
        exports1.Request = Request;
        exports1.Response = Response;
        exports1.fetch = fetch;
        Object.defineProperty(exports1, "__esModule", {
            value: true
        });
        return exports1;
    }({});
})(__self__);
__self__.fetch.ponyfill = true;
// Remove "polyfill" property added by whatwg-fetch
delete __self__.fetch.polyfill;
// Choose between native implementation (global) or custom implementation (__self__)
// var ctx = global.fetch ? global : __self__;
var ctx = __self__; // this line disable service worker support temporarily
exports = ctx.fetch // To enable: import fetch from 'cross-fetch'
;
exports.default = ctx.fetch // For TypeScript consumers without esModuleInterop.
;
exports.fetch = ctx.fetch // To enable: import {fetch} from 'cross-fetch'
;
exports.Headers = ctx.Headers;
exports.Request = ctx.Request;
exports.Response = ctx.Response;
module.exports = exports;

},{}],"67y10":[function(require,module,exports) {
module.exports = require("25b0714c5d0ff71").getBundleURL("kVLro") + require("41ee74b2a823df5c").resolve("8suWi");

},{"25b0714c5d0ff71":"c7Tr5","41ee74b2a823df5c":"fyJL2"}],"i11ct":[function(require,module,exports) {
module.exports = require("b6fab8bd9b9cb83c").getBundleURL("kVLro") + require("1278f819b6833e8b").resolve("bjnWQ");

},{"b6fab8bd9b9cb83c":"c7Tr5","1278f819b6833e8b":"fyJL2"}],"7VvW4":[function(require,module,exports) {
module.exports = require("59bab5fb7c1fae48").getBundleURL("kVLro") + require("6231490feb0c6f1f").resolve("1K3ry");

},{"59bab5fb7c1fae48":"c7Tr5","6231490feb0c6f1f":"fyJL2"}],"lHACd":[function(require,module,exports) {
module.exports = require("3ddd493eb688f1eb").getBundleURL("kVLro") + require("fdc718eac21db403").resolve("XKiU5");

},{"3ddd493eb688f1eb":"c7Tr5","fdc718eac21db403":"fyJL2"}],"d7Mkf":[function(require,module,exports) {
module.exports = require("2a57a9a777993dc7").getBundleURL("kVLro") + require("53c0e112ad0a2888").resolve("jmbXZ");

},{"2a57a9a777993dc7":"c7Tr5","53c0e112ad0a2888":"fyJL2"}],"7n30l":[function(require,module,exports) {
module.exports = require("a2aefd709ded00ad").getBundleURL("kVLro") + require("3d299383c3b9be18").resolve("jv53H");

},{"a2aefd709ded00ad":"c7Tr5","3d299383c3b9be18":"fyJL2"}],"ofNrF":[function(require,module,exports) {
module.exports = require("4ce61424b9150f06").getBundleURL("kVLro") + require("1b6c8b9741351022").resolve("5D0ox");

},{"4ce61424b9150f06":"c7Tr5","1b6c8b9741351022":"fyJL2"}],"dc93L":[function(require,module,exports) {
module.exports = require("cda345f4de328aab").getBundleURL("kVLro") + require("2d0fb19976f53521").resolve("8IVkx");

},{"cda345f4de328aab":"c7Tr5","2d0fb19976f53521":"fyJL2"}],"36PR5":[function(require,module,exports) {
module.exports = require("bcf295133a34a15e").getBundleURL("kVLro") + require("133c00b995444b37").resolve("hnmUk");

},{"bcf295133a34a15e":"c7Tr5","133c00b995444b37":"fyJL2"}],"i8tpc":[function(require,module,exports) {
module.exports = require("975af8edabed9d6").getBundleURL("kVLro") + require("227d21e33649ea2b").resolve("8V36Z");

},{"975af8edabed9d6":"c7Tr5","227d21e33649ea2b":"fyJL2"}],"awzFF":[function(require,module,exports) {
module.exports = require("dfb73b0e5b11c974").getBundleURL("kVLro") + require("c02a4f3450d25ed0").resolve("jkXQc");

},{"dfb73b0e5b11c974":"c7Tr5","c02a4f3450d25ed0":"fyJL2"}],"kTU5j":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _hexToCssFilter = require("hex-to-css-filter");
var _react = require("react");
var _customAssistantCodeExportTypes = require("../../../models/customAssistant/CustomAssistantCodeExportTypes");
const GRADIENT_DIRECTION = "215.1deg";
const GRADIENT_COLOR_ONE_PERCENTAGE = "20.69%";
const GRADIENT_COLOR_TWO_PERCENTAGE = "95.73%";
function useCustomAssistantConfigurationColors() {
    const [iconFilter, setIconFilter] = (0, _react.useState)("");
    const [colorShade, setColorShade] = (0, _react.useState)("");
    const [highlight, setHighlight] = (0, _react.useState)("");
    const [gradient, setGradient] = (0, _react.useState)({
        javaScript: "",
        swift: "",
        kotlin: ""
    });
    const createGradient = (primaryColor)=>{
        let newGradient = {
            javaScript: "",
            swift: "",
            kotlin: ""
        };
        if (isValidHexCode(primaryColor) && colorShade) {
            newGradient.javaScript = `linear-gradient(${GRADIENT_DIRECTION}, ${colorShade} ${GRADIENT_COLOR_ONE_PERCENTAGE}, ${primaryColor} ${GRADIENT_COLOR_TWO_PERCENTAGE})`;
            newGradient.swift = `${colorShade},${primaryColor}`;
            newGradient.kotlin = `${(0, _customAssistantCodeExportTypes.getKotlinHexValue)(colorShade, true)},${(0, _customAssistantCodeExportTypes.getKotlinHexValue)(primaryColor, true)}`;
            setGradient(newGradient);
            return newGradient;
        }
    };
    const createIconFilter = (primaryColor)=>{
        if (isValidHexCode(primaryColor)) {
            const iconFilterColor = (0, _hexToCssFilter.hexToCSSFilter)(primaryColor);
            setIconFilter(iconFilterColor.filter);
        } else setIconFilter("");
    };
    const createHighlight = (hex, alpha)=>{
        let highlight = `${hex}${Math.floor(alpha * 255).toString(16).padStart(2, "")}`;
        setHighlight(highlight);
        return highlight;
    };
    const createColorShade = (colorCode, amount)=>{
        if (colorShade) setColorShade("");
        if (colorCode) {
            let usePound = false;
            if (colorCode[0] == "#") {
                colorCode = colorCode.slice(1);
                usePound = true;
            }
            const num = parseInt(colorCode, 16);
            let r = (num >> 16) + amount;
            if (r > 255) r = 255;
            else if (r < 0) r = 0;
            let b = (num >> 8 & 0x00FF) + amount;
            if (b > 255) b = 255;
            else if (b < 0) b = 0;
            let g = (num & 0x0000FF) + amount;
            if (g > 255) g = 255;
            else if (g < 0) g = 0;
            return setColorShade((usePound ? "#" : "") + (g | b << 8 | r << 16).toString(16));
        }
    };
    const isValidHexCode = (str)=>{
        if (str[0] != "#" || str.indexOf("#", 1) != -1) return false;
        if (!(str.length == 4 || str.length == 7)) return false;
        for(let i = 1; i < str.length; i++)if (!(str[i].charCodeAt(0) <= "0".charCodeAt(0) && str[i].charCodeAt(0) <= 9 || str[i].charCodeAt(0) >= "a".charCodeAt(0) && str[i].charCodeAt(0) <= "f".charCodeAt(0) || str[i].charCodeAt(0) >= "A".charCodeAt(0) || str[i].charCodeAt(0) <= "F".charCodeAt(0))) return false;
        return true;
    };
    const clearColorStates = ()=>{
        setGradient({
            javaScript: "",
            swift: "",
            kotlin: ""
        });
        setIconFilter("");
        setColorShade("");
        setHighlight("");
    };
    return {
        iconFilter,
        colorShade,
        highlight,
        gradient,
        useCustomAssistantConfigurationColors,
        createGradient,
        createIconFilter,
        createHighlight,
        createColorShade,
        clearColorStates,
        isValidHexCode
    };
}
exports.default = useCustomAssistantConfigurationColors;

},{"hex-to-css-filter":"aRUNx","react":"6uln9","../../../models/customAssistant/CustomAssistantCodeExportTypes":"7cpTo","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jrJ7j":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _urls = require("../../../constants/Urls");
var _customAssistantCodeExportTypes = require("../../../models/customAssistant/CustomAssistantCodeExportTypes");
var _customAssistantConfigurationsColors = require("../../../constants/customAssistantConfigurationStyles/customAssistantConfigurationsColors");
var _unstatedNext = require("unstated-next");
function useCustomAssistantConfigurationSettings() {
    const [browserAssistantSettings, setBrowserAssistantSettings] = (0, _react.useState)(null);
    const [swiftAssistantSettings, setSwiftAssistantSettings] = (0, _react.useState)(null);
    const [kotlinAssistantSettings, setKotlinAssistantSettings] = (0, _react.useState)(null);
    const [assistantSettingsExport, setAssistantSettingsExport] = (0, _react.useState)("");
    const [loading, setLoading] = (0, _react.useState)();
    const closeImages = {
        style1: {
            browser: "https://voicify-prod-files.s3.amazonaws.com/sdk-images/close.svg",
            mobile: "https://voicify-prod-files.s3.amazonaws.com/sdk-images/close.png"
        },
        style2: {
            browser: "https://voicify-prod-files.s3.amazonaws.com/sdk-images/closeTwo.svg",
            mobile: "https://voicify-prod-files.s3.amazonaws.com/sdk-images/close-2.png"
        }
    };
    const micImages = {
        style1: {
            browser: "https://voicify-prod-files.s3.amazonaws.com/sdk-images/micActive.svg",
            mobile: "https://voicify-prod-files.s3.amazonaws.com/sdk-images/mic-image.png"
        },
        style2: {
            browser: "https://voicify-prod-files.s3.amazonaws.com/sdk-images/micTwoActive.svg",
            mobile: "https://voicify-prod-files.s3.amazonaws.com/sdk-images/mic-image-2.png"
        },
        style3: {
            browser: "https://voicify-prod-files.s3.amazonaws.com/sdk-images/micThreeActive.svg",
            mobile: "https://voicify-prod-files.s3.amazonaws.com/sdk-images/mic-image-3.png"
        }
    };
    const sendImages = {
        style1: {
            browser: "https://voicify-prod-files.s3.amazonaws.com/sdk-images/sendActive.svg",
            mobile: "https://voicify-prod-files.s3.amazonaws.com/sdk-images/send-image.png"
        },
        style2: {
            browser: "https://voicify-prod-files.s3.amazonaws.com/sdk-images/sendTwoActive.svg",
            mobile: "https://voicify-prod-files.s3.amazonaws.com/sdk-images/send-image-2.png"
        },
        style3: {
            browser: "https://voicify-prod-files.s3.amazonaws.com/sdk-images/sendThreeActive.svg",
            mobile: "https://voicify-prod-files.s3.amazonaws.com/sdk-images/send-image-3.png"
        }
    };
    const sharedAssistantSettings = (values, applicationId, appKey)=>{
        return {
            serverRootUrl: (0, _urls.getAssistantPreviewApiUrl)(),
            appId: applicationId,
            appKey: appKey,
            locale: values.locale,
            channel: "My App",
            device: "My device",
            textToSpeechVoice: values.textToSpeechVoice ?? "",
            autoRunConversation: values.autoRunConversation,
            initializeWithWelcomeMessage: values.initializeWithWelcomeMessage,
            textToSpeechProvider: values.textToSpeechProvider,
            useVoiceInput: values.useVoiceInput,
            useOutputSpeech: values.useOutputSpeech,
            useDraftContent: values.useDraftContent,
            noTracking: values.noTracking
        };
    };
    const sharedHeaderProps = (values, theme, appAvatar, appName, isKotlin = false)=>{
        return {
            backgroundColor: values.headerBackgroundColor ? (0, _customAssistantCodeExportTypes.getKotlinHexValue)(values.headerBackgroundColor, isKotlin) : values.overallBackgroundColor ? (0, _customAssistantConfigurationsColors.transparent) : (0, _customAssistantCodeExportTypes.getKotlinHexValue)(theme.header.backgroundColor, isKotlin),
            assistantName: values.displayName ? values.displayName : appName,
            assistantNameTextColor: values.headerAssistantNameTextColor ? (0, _customAssistantCodeExportTypes.getKotlinHexValue)(values.headerAssistantNameTextColor, isKotlin) : (0, _customAssistantCodeExportTypes.getKotlinHexValue)(theme.assistantNameTextColor, isKotlin),
            assistantImage: values.avatarUrl ? values.avatarUrl : appAvatar,
            fontFamily: values.font ? values.font : theme.font ? theme.font : "sans-serif"
        };
    };
    const sharedBodyProps = (values, theme, appAvatar, isKotlin = false)=>{
        return {
            backgroundColor: values.bodyBackgroundColor ? (0, _customAssistantCodeExportTypes.getKotlinHexValue)(values.bodyBackgroundColor, isKotlin) : (0, _customAssistantCodeExportTypes.getKotlinHexValue)(values.overallBackgroundColor, isKotlin) ? (0, _customAssistantConfigurationsColors.transparent) : (0, _customAssistantCodeExportTypes.getKotlinHexValue)(theme.body.backgroundColor, isKotlin),
            messageSentTextColor: values.bodyMessageSentTextColor ? (0, _customAssistantCodeExportTypes.getKotlinHexValue)(values.bodyMessageSentTextColor, isKotlin) : theme.messageSentTextColor && (0, _customAssistantCodeExportTypes.getKotlinHexValue)(theme.messageSentTextColor, isKotlin),
            messageSentBackgroundColor: values.primaryColor ? (0, _customAssistantCodeExportTypes.getKotlinHexValue)(values.primaryColor, isKotlin) : values.bodyMessageSentBackgroundColor ? (0, _customAssistantCodeExportTypes.getKotlinHexValue)(values.bodyMessageSentBackgroundColor, isKotlin) : theme.messageSentBackgroundColor ? (0, _customAssistantCodeExportTypes.getKotlinHexValue)(theme.messageSentBackgroundColor, true) : null,
            messageReceivedTextColor: values.bodyMessageReceivedTextColor ? (0, _customAssistantCodeExportTypes.getKotlinHexValue)(values.bodyMessageReceivedTextColor, isKotlin) : theme.messageReceivedTextColor && (0, _customAssistantCodeExportTypes.getKotlinHexValue)(theme.messageReceivedTextColor, isKotlin),
            messageReceivedBackgroundColor: values.bodyMessageReceivedBackgroundColor ? (0, _customAssistantCodeExportTypes.getKotlinHexValue)(values.bodyMessageReceivedBackgroundColor, isKotlin) : theme.messageReceivedBackgroundColor ? (0, _customAssistantCodeExportTypes.getKotlinHexValue)(theme.messageReceivedBackgroundColor, isKotlin) : null,
            messageSentFontFamily: values.font ? values.font : theme.font ? theme.font : "sans-serif",
            messageReceivedFontFamily: values.font ? values.font : theme.font ? theme.font : "sans-serif",
            hintsTextColor: theme.hintsTextColor && (0, _customAssistantCodeExportTypes.getKotlinHexValue)(theme.hintsTextColor, isKotlin),
            hintsBackgroundColor: theme.hintsBackgroundColor && (0, _customAssistantCodeExportTypes.getKotlinHexValue)(theme.hintsBackgroundColor, isKotlin),
            hintsFontFamily: values.font ? values.font : theme.font ? theme.font : "sans-serif",
            assistantImage: values.avatarUrl ? values.avatarUrl : appAvatar,
            messageReceivedBorderColor: (0, _customAssistantCodeExportTypes.getKotlinHexValue)(values.overallBorderColor, isKotlin),
            messageSentBorderColor: (0, _customAssistantCodeExportTypes.getKotlinHexValue)(values.overallBorderColor, isKotlin),
            borderBottomColor: (0, _customAssistantCodeExportTypes.getKotlinHexValue)(values.overallBorderColor, isKotlin),
            borderTopColor: (0, _customAssistantCodeExportTypes.getKotlinHexValue)(values.overallBorderColor, isKotlin)
        };
    };
    const sharedToolbarProps = (values, theme, isKotlin = false)=>{
        return {
            backgroundColor: values.toolbarBackgroundColor ? (0, _customAssistantCodeExportTypes.getKotlinHexValue)(values.toolbarBackgroundColor, isKotlin) : values.overallBackgroundColor ? (0, _customAssistantConfigurationsColors.transparent) : (0, _customAssistantCodeExportTypes.getKotlinHexValue)(theme.toolbar.backgroundColor, isKotlin),
            speakActiveTitleColor: values.themeStyle === "darkStyle2" ? (0, _customAssistantCodeExportTypes.getKotlinHexValue)(theme.speakActiveTitleColor, isKotlin) : values.primaryColor ? (0, _customAssistantCodeExportTypes.getKotlinHexValue)(values.primaryColor, isKotlin) : (0, _customAssistantCodeExportTypes.getKotlinHexValue)(theme.speakActiveTitleColor, isKotlin),
            speakInactiveTitleColor: values.toolbarFontColor ? (0, _customAssistantCodeExportTypes.getKotlinHexValue)(values.toolbarFontColor, isKotlin) : (0, _customAssistantCodeExportTypes.getKotlinHexValue)(theme.speakInactiveTitleColor, isKotlin),
            typeActiveTitleColor: values.themeStyle === "darkStyle2" ? (0, _customAssistantCodeExportTypes.getKotlinHexValue)(theme.typeActiveTitleColor, isKotlin) : values.primaryColor ? (0, _customAssistantCodeExportTypes.getKotlinHexValue)(values.primaryColor, isKotlin) : (0, _customAssistantCodeExportTypes.getKotlinHexValue)(theme.typeActiveTitleColor, isKotlin),
            typeInactiveTitleColor: values.toolbarFontColor ? (0, _customAssistantCodeExportTypes.getKotlinHexValue)(values.toolbarFontColor, isKotlin) : (0, _customAssistantCodeExportTypes.getKotlinHexValue)(theme.typeInactiveTitleColor, isKotlin),
            partialSpeechResultTextColor: theme.partialSpeechResultTextColor && (0, _customAssistantCodeExportTypes.getKotlinHexValue)(theme.partialSpeechResultTextColor, isKotlin),
            fullSpeechResultTextColor: theme.fullSpeechResultTextColor && (0, _customAssistantCodeExportTypes.getKotlinHexValue)(theme.fullSpeechResultTextColor, isKotlin),
            speechResultBoxBackgroundColor: values.primaryColor ? (0, _customAssistantCodeExportTypes.getKotlinHexValue)(values.primaryColor, isKotlin) : (0, _customAssistantCodeExportTypes.getKotlinHexValue)(theme.speechResultBoxBackgroundColor, isKotlin),
            textInputTextColor: theme.textInputTextColor && (0, _customAssistantCodeExportTypes.getKotlinHexValue)(theme.textInputTextColor, isKotlin),
            helpTextFontColor: values.toolbarFontColor ? (0, _customAssistantCodeExportTypes.getKotlinHexValue)(values.toolbarFontColor, isKotlin) : (0, _customAssistantCodeExportTypes.getKotlinHexValue)(theme.helpTextFontColor, isKotlin),
            partialSpeechResultFontFamily: values.font ? values.font : theme.font ? theme.font : "sans-serif",
            assistantStateFontFamily: values.font ? values.font : theme.font ? theme.font : "sans-serif",
            helpTextFontFamily: values.font ? values.font : theme.font ? theme.font : "sans-serif",
            speakFontFamily: values.font ? values.font : theme.font ? theme.font : "sans-serif",
            typeFontFamily: values.font ? values.font : theme.font ? theme.font : "sans-serif",
            textboxFontFamily: values.font ? values.font : theme.font ? theme.font : "sans-serif",
            textInputActiveLineColor: (0, _customAssistantCodeExportTypes.getKotlinHexValue)(theme.textInputActiveLineColor, isKotlin),
            textInputLineColor: theme.textInputLineColor && (0, _customAssistantCodeExportTypes.getKotlinHexValue)(theme.textInputLineColor, isKotlin),
            placeholder: values.toolbarPlaceholder
        };
    };
    const updateAssistantSettings = (values, gradient, applicationId, appKey, browserTheme, mobileTheme, iconFilter, appAvatar, appName, highlight)=>{
        const isMinimalUI = values.uiType === "minimal";
        const isDarkStyle2 = values.themeStyle === "darkStyle2";
        const updatedBrowserAssistantSetting = {
            ...sharedAssistantSettings(values, applicationId, appKey),
            sessionTimeout: 3600000,
            environmentId: null,
            uiType: values.uiType,
            openByDefault: false,
            textToSpeechVoice: values.textToSpeechVoice,
            activeInput: values.activeInput,
            showConversationHistory: values.showConversationHistory,
            styles: {
                assistant: {
                    zIndex: "1",
                    backgroundColor: values.overallBackgroundColor ? values.overallBackgroundColor : isDarkStyle2 && values.primaryColor && isMinimalUI ? highlight : isDarkStyle2 && values.primaryColor ? gradient.swift : browserTheme.overallBackgroundColor
                },
                header: {
                    ...sharedHeaderProps(values, browserTheme, appAvatar, appName),
                    closeAssistantColor: isDarkStyle2 ? browserTheme.closeAssistantColor : iconFilter ? iconFilter : browserTheme.closeAssistantColor,
                    minimizeAssistantColor: isDarkStyle2 ? browserTheme.minimizeAssistantColor : iconFilter ? iconFilter : browserTheme.minimizeAssistantColor,
                    minimizeIcon: values.headerMinimizeIcon,
                    closeAssistantButtonImage: values.headerCloseAssistantButtonImage
                },
                body: {
                    ...sharedBodyProps(values, browserTheme, appAvatar)
                },
                toolbar: {
                    ...sharedToolbarProps(values, browserTheme),
                    textboxActiveHighlightColor: highlight ? highlight : browserTheme.textboxActiveHighlightColor,
                    equalizerColor: isDarkStyle2 ? browserTheme.equalizerColor : gradient.javaScript ? gradient.javaScript : browserTheme.equalizerColor && browserTheme.equalizerColor,
                    equalizerColorOne: values.primaryColor && values.primaryColor,
                    equalizerColorTwo: highlight && highlight,
                    muteImageColor: browserTheme.muteImageColor,
                    muteImage: "https://voicify-prod-files.s3.amazonaws.com/sdk-images/mute.svg",
                    muteFontColor: values.toolbarFontColor ? values.toolbarFontColor : browserTheme.muteFontColor,
                    muteFontFamily: values.font ? values.font : browserTheme.font ? browserTheme.font : "sans-serif",
                    micActiveColor: isDarkStyle2 ? browserTheme.micActiveColor : iconFilter ? iconFilter : browserTheme.micActiveColor,
                    keyboardColor: isDarkStyle2 ? browserTheme.keyboardColor : iconFilter ? iconFilter : browserTheme.keyboardColor,
                    sendActiveColor: isDarkStyle2 ? browserTheme.sendActiveColor : iconFilter ? iconFilter : browserTheme.sendActiveColor,
                    sendInactiveColor: isDarkStyle2 ? browserTheme.sendInactiveColor : iconFilter ? iconFilter : browserTheme.sendInactiveColor,
                    assistantStateFontColor: values.toolbarFontColor ? values.toolbarFontColor : browserTheme.assistantStateFontColor,
                    assistantStateTextColor: values.headerAssistantNameTextColor ? values.headerAssistantNameTextColor : browserTheme.assistantNameTextColor,
                    micActiveImage: values.toolbarMicActiveImage,
                    micInactiveImage: values.toolbarMicActiveImage,
                    sendActiveImage: values.toolbarSendActiveImage,
                    sendInactiveImage: values.toolbarSendActiveImage
                },
                start: {
                    assistantImage: values.avatarUrl ? values.avatarUrl : appAvatar,
                    buttonBackgroundColor: values.primaryColor ? values.primaryColor : browserTheme.buttonBackgroundColor,
                    buttonText: values.startButtonText,
                    buttonFontFamily: values.font ? values.font : browserTheme.font ? browserTheme.font : "sans-serif",
                    buttonFontSize: values.startButtonFontSize
                }
            }
        };
        const updatedSwiftAssistantSettings = {
            assistantSettings: {
                ...sharedAssistantSettings(values, applicationId, appKey),
                initializeWithText: values.activeInput === "textbox",
                backgroundColor: values.overallBackgroundColor ? values.overallBackgroundColor : isDarkStyle2 && values.primaryColor && isMinimalUI ? highlight : isDarkStyle2 && values.primaryColor ? gradient.swift : mobileTheme.overallBackgroundColor
            },
            headerProps: {
                ...sharedHeaderProps(values, mobileTheme, appAvatar, appName),
                closeAssistantColor: mobileTheme.closeAssistantColor,
                closeAssistantButtonImage: values.headerCloseAssistantButtonImage === closeImages.style1.browser ? closeImages.style1.mobile : closeImages.style2.mobile
            },
            bodyProps: {
                ...sharedBodyProps(values, mobileTheme, appAvatar)
            },
            toolbarProps: {
                ...sharedToolbarProps(values, mobileTheme),
                textboxActiveHighlightColor: mobileTheme.textboxActiveHighlightColor,
                equalizerColor: isDarkStyle2 ? mobileTheme.equalizerColor : gradient.swift ? gradient.swift : mobileTheme.equalizerColor && mobileTheme.equalizerColor,
                equalizerColorOne: values.primaryColor && values.primaryColor,
                equalizerColorTwo: highlight && highlight,
                micActiveColor: mobileTheme.micActiveColor,
                keyboardColor: mobileTheme.keyboardColor,
                sendActiveColor: mobileTheme.sendActiveColor,
                sendInactiveColor: mobileTheme.sendInactiveColor,
                assistantStateTextColor: values.toolbarFontColor ? values.toolbarFontColor : mobileTheme.assistantStateFontColor,
                micActiveImage: values.toolbarMicActiveImage === micImages.style1.browser ? micImages.style1.mobile : values.toolbarMicActiveImage === micImages.style2.browser ? micImages.style2.mobile : micImages.style3.mobile,
                micInactiveImage: values.toolbarMicActiveImage === micImages.style1.browser ? micImages.style1.mobile : values.toolbarMicActiveImage === micImages.style2.browser ? micImages.style2.mobile : micImages.style3.mobile,
                sendActiveImage: values.toolbarSendActiveImage === sendImages.style1.browser ? sendImages.style1.mobile : values.toolbarSendActiveImage === sendImages.style2.browser ? sendImages.style2.mobile : sendImages.style3.mobile,
                sendInactiveImage: values.toolbarSendActiveImage === sendImages.style1.browser ? sendImages.style1.mobile : values.toolbarSendActiveImage === sendImages.style2.browser ? sendImages.style2.mobile : sendImages.style3.mobile
            }
        };
        const updatedKotlinAssistantSettings = {
            assistantSettings: {
                ...sharedAssistantSettings(values, applicationId, appKey),
                initializeWithText: values.activeInput === "textbox",
                backgroundColor: values.overallBackgroundColor ? (0, _customAssistantCodeExportTypes.getKotlinHexValue)(values.overallBackgroundColor, true) : isDarkStyle2 && values.primaryColor && isMinimalUI ? highlight : isDarkStyle2 && values.primaryColor ? highlight : (0, _customAssistantCodeExportTypes.getKotlinHexValue)(mobileTheme.overallBackgroundColor, true)
            },
            headerProps: {
                ...sharedHeaderProps(values, mobileTheme, appAvatar, appName, true),
                closeAssistantColor: (0, _customAssistantCodeExportTypes.getKotlinHexValue)(mobileTheme.closeAssistantColor, true),
                closeAssistantButtonImage: values.headerCloseAssistantButtonImage === closeImages.style1.browser ? closeImages.style1.mobile : closeImages.style2.mobile
            },
            bodyProps: {
                ...sharedBodyProps(values, mobileTheme, appAvatar, true)
            },
            toolbarProps: {
                ...sharedToolbarProps(values, mobileTheme, true),
                textboxActiveHighlightColor: (0, _customAssistantCodeExportTypes.getKotlinHexValue)(mobileTheme.textboxActiveHighlightColor, true),
                equalizerColor: isDarkStyle2 ? (0, _customAssistantCodeExportTypes.getKotlinHexValue)(mobileTheme.equalizerColor, true) : gradient.kotlin ? gradient.kotlin : (0, _customAssistantCodeExportTypes.getKotlinHexValue)(mobileTheme.equalizerColor, true) && (0, _customAssistantCodeExportTypes.getKotlinHexValue)(mobileTheme.equalizerColor, true),
                equalizerColorOne: (0, _customAssistantCodeExportTypes.getKotlinHexValue)(values.primaryColor, true) && (0, _customAssistantCodeExportTypes.getKotlinHexValue)(values.primaryColor, true),
                equalizerColorTwo: (0, _customAssistantCodeExportTypes.getKotlinHexValue)(highlight, true) && (0, _customAssistantCodeExportTypes.getKotlinHexValue)(highlight, true),
                micActiveColor: (0, _customAssistantCodeExportTypes.getKotlinHexValue)(mobileTheme.micActiveColor, true),
                keyboardColor: (0, _customAssistantCodeExportTypes.getKotlinHexValue)(mobileTheme.keyboardColor, true),
                sendActiveColor: (0, _customAssistantCodeExportTypes.getKotlinHexValue)(mobileTheme.sendActiveColor, true),
                sendInactiveColor: (0, _customAssistantCodeExportTypes.getKotlinHexValue)(mobileTheme.sendInactiveColor, true),
                assistantStateTextColor: values.toolbarFontColor ? (0, _customAssistantCodeExportTypes.getKotlinHexValue)(values.toolbarFontColor, true) : (0, _customAssistantCodeExportTypes.getKotlinHexValue)(mobileTheme.assistantStateFontColor, true),
                micActiveImage: values.toolbarMicActiveImage === micImages.style1.browser ? micImages.style1.mobile : values.toolbarMicActiveImage === micImages.style2.browser ? micImages.style2.mobile : micImages.style3.mobile,
                micInactiveImage: values.toolbarMicActiveImage === micImages.style1.browser ? micImages.style1.mobile : values.toolbarMicActiveImage === micImages.style2.browser ? micImages.style2.mobile : micImages.style3.mobile,
                sendActiveImage: values.toolbarSendActiveImage === sendImages.style1.browser ? sendImages.style1.mobile : values.toolbarSendActiveImage === sendImages.style2.browser ? sendImages.style2.mobile : sendImages.style3.mobile,
                sendInactiveImage: values.toolbarSendActiveImage === sendImages.style1.browser ? sendImages.style1.mobile : values.toolbarSendActiveImage === sendImages.style2.browser ? sendImages.style2.mobile : sendImages.style3.mobile
            }
        };
        setBrowserAssistantSettings(updatedBrowserAssistantSetting);
        setSwiftAssistantSettings(updatedSwiftAssistantSettings);
        setKotlinAssistantSettings(updatedKotlinAssistantSettings);
    };
    const generateAssistantSettingsExport = (customAssistantSDKVersion, codeExportLanguage, exportType, configurationId, appId, appKey)=>{
        setLoading(true);
        const dynamicBrowserAssistantSetting = {
            configurationId: configurationId,
            serverRootUrl: (0, _urls.getAssistantPreviewApiUrl)(),
            appId: appId,
            appKey: appKey
        };
        let codeExport = "";
        const browserSettingsString = JSON.stringify(browserAssistantSettings, null, 2);
        const dynamicBrowserSettingsString = JSON.stringify(dynamicBrowserAssistantSetting, null, 2);
        if (exportType === "static") switch(codeExportLanguage){
            case "JavaScript":
                codeExport = `<script src='https://sdk.voicify.com/browser-sdk/${customAssistantSDKVersion}/voicifyAssistant.js'></script>\n` + "<script>\ndocument.addEventListener('DOMContentLoaded', (event) => {\nwindow.initializeVoicifyAssistant(" + browserSettingsString.replace(/"([^"]+)":/g, "$1:") + "\n)});</script>\n";
                break;
            case "Swift":
                let swiftAssistantSettingsJSON = mobileFormattedJSON(swiftAssistantSettings?.assistantSettings);
                let swiftHeaderJSON = mobileFormattedJSON(swiftAssistantSettings?.headerProps);
                let swiftBodyJSON = mobileFormattedJSON(swiftAssistantSettings?.bodyProps);
                let swiftToolbarJSON = mobileFormattedJSON(swiftAssistantSettings?.toolbarProps);
                codeExport = `AssistantDrawerUI(\n assistantSettings: AssistantSettingsProps(${swiftAssistantSettingsJSON.replace("null", "nil")}),\nheaderProps: HeaderProps( ${swiftHeaderJSON.replace("null", "nil")}),\nbodyProps: BodyProps( ${swiftBodyJSON.replace("null", "nil")}),\ntoolbarProps: ToolbarProps( ${swiftToolbarJSON.replace("null", "nil")} )\n)`;
                break;
            case "Kotlin":
                const kotlinAssistantSettingsJSON = mobileFormattedJSON(kotlinAssistantSettings?.assistantSettings);
                const kotlinHeaderJSON = mobileFormattedJSON(kotlinAssistantSettings?.headerProps);
                const kotlinBodyJSON = mobileFormattedJSON(kotlinAssistantSettings?.bodyProps);
                const kotlinToolbarJSON = mobileFormattedJSON(kotlinAssistantSettings?.toolbarProps);
                let formattedKotlinAssistantSettingsJSON = kotlinAssistantSettingsJSON.replace(/: \s*/g, " = ");
                let formattedKotlinHeaderJSON = kotlinHeaderJSON.replace(/: \s*/g, " = ");
                let formattedKotlinBodyJSON = kotlinBodyJSON.replace(/: \s*/g, " = ");
                let formattedKotlinToolbarJSON = kotlinToolbarJSON.replace(/: \s*/g, " = ");
                codeExport = `val voiceAssistant = AssistantDrawerUI.newInstance(\n AssistantSettingsProps(${formattedKotlinAssistantSettingsJSON.replace(`https\s=\s`, "https:")} ),\n HeaderProps( ${formattedKotlinHeaderJSON.replace(`https\s=\s`, "https:")}),\n BodyProps( ${formattedKotlinBodyJSON.replace(`https\s=\s`, "https:")}),\n ToolbarProps( ${formattedKotlinToolbarJSON.replace(`https\s=\s`, "https:")} )\n)`;
                break;
        }
        else switch(codeExportLanguage){
            case "JavaScript":
                codeExport = `<script src='https://sdk.voicify.com/browser-sdk/${customAssistantSDKVersion}/voicifyAssistant.js'></script>\n` + "<script>\ndocument.addEventListener('DOMContentLoaded', (event) => {\nwindow.initializeVoicifyAssistant(" + dynamicBrowserSettingsString.replace(/"([^"]+)":/g, "$1:") + "\n)});</script>\n";
                break;
            case "Swift":
                codeExport = `AssistantDrawerUI(\n  assistantSettings:\n   AssistantSettingsProps(\n    configurationId: "${configurationId}", \n    serverRootUrl: "${(0, _urls.getAssistantPreviewApiUrl)()}", \n    appId: "${appId}", \n    appKey: "${appKey}"\n   )\n)`;
                break;
            case "Kotlin":
                codeExport = `val voiceAssistant = AssistantDrawerUI.newInstance(\n  AssistantSettingsProps(\n   configurationId = "${configurationId}", \n   serverRootUrl = "${(0, _urls.getAssistantPreviewApiUrl)()}", \n   appId = "${appId}", \n   appKey = "${appKey}"\n  )\n)`;
                break;
        }
        setAssistantSettingsExport(codeExport);
        setLoading(false);
    };
    const mobileFormattedJSON = (json)=>{
        return JSON.stringify(json, null, 2)?.replace(/"([^"]+)":/g, "$1:")?.replace("{", "")?.replace("}", "");
    };
    return {
        updateAssistantSettings,
        browserAssistantSettings,
        kotlinAssistantSettings,
        swiftAssistantSettings,
        generateAssistantSettingsExport,
        assistantSettingsExport,
        loading
    };
}
const CustomAssistantConfigurationsContainer = (0, _unstatedNext.createContainer)(useCustomAssistantConfigurationSettings);
exports.default = CustomAssistantConfigurationsContainer;

},{"react":"6uln9","../../../constants/Urls":"iTopY","../../../models/customAssistant/CustomAssistantCodeExportTypes":"7cpTo","../../../constants/customAssistantConfigurationStyles/customAssistantConfigurationsColors":"jOo9r","unstated-next":"61zE5","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"iUA5c":[function(require,module,exports) {
module.exports = require("7ba24d5fd844e7c9").getBundleURL("kVLro") + require("c3a2395601e9d677").resolve("1s3Rv");

},{"7ba24d5fd844e7c9":"c7Tr5","c3a2395601e9d677":"fyJL2"}],"1W8SX":[function(require,module,exports) {
module.exports = require("d83018e46629a5d6").getBundleURL("kVLro") + require("31599d207b5cd6c7").resolve("eDVAx");

},{"d83018e46629a5d6":"c7Tr5","31599d207b5cd6c7":"fyJL2"}],"4l2Jt":[function(require,module,exports) {
module.exports = require("dbd21abc9d10015f").getBundleURL("kVLro") + require("6b31f26ec757e550").resolve("jIafG");

},{"dbd21abc9d10015f":"c7Tr5","6b31f26ec757e550":"fyJL2"}],"9IMzT":[function(require,module,exports) {
module.exports = require("40ee894a0693badb").getBundleURL("kVLro") + require("f7c046957e2d389c").resolve("4xEnS");

},{"40ee894a0693badb":"c7Tr5","f7c046957e2d389c":"fyJL2"}],"18Wlu":[function(require,module,exports) {
module.exports = require("1998482de022de3c").getBundleURL("kVLro") + require("fabd17e3fd38581b").resolve("4FLno");

},{"1998482de022de3c":"c7Tr5","fabd17e3fd38581b":"fyJL2"}],"bpfKj":[function(require,module,exports) {
module.exports = require("ac7d847fe1f8cb36").getBundleURL("kVLro") + require("999491e186df2914").resolve("9JZmF");

},{"ac7d847fe1f8cb36":"c7Tr5","999491e186df2914":"fyJL2"}],"iS74T":[function(require,module,exports) {
module.exports = require("43ea13a7c3ed371f").getBundleURL("kVLro") + require("94d277bcbc96546f").resolve("ell9p");

},{"43ea13a7c3ed371f":"c7Tr5","94d277bcbc96546f":"fyJL2"}],"avCoE":[function(require,module,exports) {
module.exports = require("964af3d36cf7e7dc").getBundleURL("kVLro") + require("4dbd7ab3c301be9").resolve("62pil");

},{"964af3d36cf7e7dc":"c7Tr5","4dbd7ab3c301be9":"fyJL2"}],"1u9JO":[function(require,module,exports) {
module.exports = require("32de532abfa553a1").getBundleURL("kVLro") + require("8859d3b7ec0857da").resolve("Rt6pV");

},{"32de532abfa553a1":"c7Tr5","8859d3b7ec0857da":"fyJL2"}],"fvG38":[function(require,module,exports) {
module.exports = JSON.parse('{"id":"","serverRootUrl":"","applicationId":"","applicationSecret":"","locale":"en-US","channel":"","device":"Custom Assistant SDK","autoRunConversation":false,"initializeWithWelcomeMessage":true,"textToSpeechProvider":"Google","useVoiceInput":true,"useOutputSpeech":true,"useDraftContent":false,"noTracking":true,"sessionTimeout":3600000,"uiType":"minimal","activeInput":"textbox","name":"","theme":"lightStyle1","showConversationHistory":"true","platformConfigurations":{"javaScript":{"serverRootUrl":"","appId":"","appKey":"","locale":"en-US","channel":"My App","device":"My device","autoRunConversation":true,"initializeWithWelcomeMessage":true,"textToSpeechProvider":"Google","useVoiceInput":true,"useOutputSpeech":true,"useDraftContent":false,"noTracking":true,"sessionTimeout":3600000,"environmentId":null,"uiType":"minimal","openByDefault":false,"activeInput":"textbox","showConversationHistory":"true","styles":{"assistant":{"zIndex":"1"},"header":{"backgroundColor":"#FFFFFF","assistantName":"Custom Assistant","assistantNameTextColor":"#324661","fontFamily":"sans-serif","closeAssistantColor":"invert(74%) sepia(3%) saturate(4%) hue-rotate(13deg) brightness(91%) contrast(90%);","minimizeAssistantColor":"invert(74%) sepia(3%) saturate(4%) hue-rotate(13deg) brightness(91%) contrast(90%);"},"body":{"backgroundColor":"#F4F4F6","messageSentBackgroundColor":"#808080","messageReceivedTextColor":"#324661","messageReceivedBackgroundColor":"#0000000d","messageSentFontFamily":"sans-serif","messageReceivedFontFamily":"sans-serif","hintsFontFamily":"sans-serif"},"toolbar":{"backgroundColor":"#FFFFFF","speechResultBoxBackgroundColor":"#808080","partialSpeechResultFontFamily":"sans-serif","assistantStateFontFamily":"sans-serif","helpTextFontFamily":"sans-serif","speakFontFamily":"sans-serif","typeFontFamily":"sans-serif","textboxFontFamily":"sans-serif","textInputActiveLineColor":"#AAAAAA","textInputLineColor":"#AAAAAA","textboxActiveHighlightColor":"#80808033","equalizerColor":"linear-gradient(180deg, #808080 0%, #AAAAAA 100%)","muteImageColor":"invert(74%) sepia(3%) saturate(4%) hue-rotate(13deg) brightness(91%) contrast(90%);","muteImage":"https://voicify-prod-files.s3.amazonaws.com/sdk-images/mute.svg","muteFontFamily":"sans-serif","micActiveColor":"invert(54%) sepia(0%) saturate(1%) hue-rotate(282deg) brightness(92%) contrast(86%);","sendActiveColor":"invert(54%) sepia(0%) saturate(1%) hue-rotate(282deg) brightness(92%) contrast(86%);","sendInactiveColor":"invert(54%) sepia(0%) saturate(1%) hue-rotate(282deg) brightness(92%) contrast(86%);","assistantStateTextColor":"#324661"},"start":{"assistantImage":"https://voicify-prod-files.s3.amazonaws.com/sdk-images/assistant.svg","buttonBackgroundColor":"#808080","buttonFontFamily":"sans-serif"}},"applicationId":"","applicationSecret":"","name":"","theme":"lightStyle1"},"kotlin":{"serverRootUrl":"","appId":"","appKey":"","locale":"en-US","channel":"My App","device":"My device","textToSpeechVoice":"","autoRunConversation":true,"initializeWithWelcomeMessage":true,"textToSpeechProvider":"Google","useVoiceInput":true,"useOutputSpeech":true,"useDraftContent":false,"noTracking":true,"initializeWithText":false,"applicationId":"","applicationSecret":"","activeInput":"textbox","name":"","showConversationHistory":"true","uiType":"minimal","styles":{"assistant":{"serverRootUrl":"","appId":"","appKey":"","locale":"en-US","channel":"My App","device":"My device","textToSpeechVoice":"","autoRunConversation":true,"initializeWithWelcomeMessage":true,"textToSpeechProvider":"Google","useVoiceInput":true,"useOutputSpeech":true,"useDraftContent":false,"noTracking":true,"initializeWithText":false},"header":{"backgroundColor":"#FFFFFF","assistantName":"Custom Assistant","assistantNameTextColor":"#324661","fontFamily":"sans-serif","closeAssistantColor":"#AAAAAA","closeAssistantButtonImage":"https://voicify-prod-files.s3.amazonaws.com/sdk-images/close-2.png"},"body":{"backgroundColor":"#F4F4F6","messageSentBackgroundColor":"#808080","messageReceivedTextColor":"#324661","messageReceivedBackgroundColor":"#0d000000","messageSentFontFamily":"sans-serif","messageReceivedFontFamily":"sans-serif","hintsFontFamily":"sans-serif"},"toolbar":{"backgroundColor":"#FFFFFF","speechResultBoxBackgroundColor":"#808080","partialSpeechResultFontFamily":"sans-serif","assistantStateFontFamily":"sans-serif","helpTextFontFamily":"sans-serif","speakFontFamily":"sans-serif","typeFontFamily":"sans-serif","textboxFontFamily":"sans-serif","textInputActiveLineColor":"#AAAAAA","textInputLineColor":"#AAAAAA","textboxActiveHighlightColor":"#33808080","equalizerColor":"#808080,#AAAAAA","micActiveColor":"#808080","sendActiveColor":"#808080","sendInactiveColor":"#808080","micActiveImage":"https://voicify-prod-files.s3.amazonaws.com/sdk-images/mic-image-3.png","micInactiveImage":"https://voicify-prod-files.s3.amazonaws.com/sdk-images/mic-image-3.png","sendActiveImage":"https://voicify-prod-files.s3.amazonaws.com/sdk-images/send-image-3.png","sendInactiveImage":"https://voicify-prod-files.s3.amazonaws.com/sdk-images/send-image-3.png"}}},"swift":{"serverRootUrl":"","appId":"","appKey":"","locale":"en-US","channel":"My App","device":"My device","textToSpeechVoice":"","autoRunConversation":true,"initializeWithWelcomeMessage":true,"textToSpeechProvider":"Google","useVoiceInput":true,"useOutputSpeech":true,"useDraftContent":false,"noTracking":true,"initializeWithText":false,"applicationId":"","applicationSecret":"","activeInput":"textbox","name":"","showConversationHistory":"true","uiType":"minimal","styles":{"assistant":{"serverRootUrl":"","appId":"","appKey":"","locale":"en-US","channel":"My App","device":"My device","textToSpeechVoice":"","autoRunConversation":true,"initializeWithWelcomeMessage":true,"textToSpeechProvider":"Google","useVoiceInput":true,"useOutputSpeech":true,"useDraftContent":false,"noTracking":true,"initializeWithText":false},"header":{"backgroundColor":"#FFFFFF","assistantName":"Custom Assistant","assistantNameTextColor":"#324661","fontFamily":"sans-serif","closeAssistantColor":"#AAAAAA","closeAssistantButtonImage":"https://voicify-prod-files.s3.amazonaws.com/sdk-images/close-2.png"},"body":{"backgroundColor":"#F4F4F6","messageSentBackgroundColor":"#808080","messageReceivedTextColor":"#324661","messageReceivedBackgroundColor":"#0000000d","messageSentFontFamily":"sans-serif","messageReceivedFontFamily":"sans-serif","hintsFontFamily":"sans-serif"},"toolbar":{"backgroundColor":"#FFFFFF","speechResultBoxBackgroundColor":"#808080","partialSpeechResultFontFamily":"sans-serif","assistantStateFontFamily":"sans-serif","helpTextFontFamily":"sans-serif","speakFontFamily":"sans-serif","typeFontFamily":"sans-serif","textboxFontFamily":"sans-serif","textInputActiveLineColor":"#AAAAAA","textInputLineColor":"#AAAAAA","textboxActiveHighlightColor":"#80808033","equalizerColor":"#808080,#AAAAAA","micActiveColor":"#808080","sendActiveColor":"#808080","sendInactiveColor":"#808080","micActiveImage":"https://voicify-prod-files.s3.amazonaws.com/sdk-images/mic-image-3.png","micInactiveImage":"https://voicify-prod-files.s3.amazonaws.com/sdk-images/mic-image-3.png","sendActiveImage":"https://voicify-prod-files.s3.amazonaws.com/sdk-images/send-image-3.png","sendInactiveImage":"https://voicify-prod-files.s3.amazonaws.com/sdk-images/send-image-3.png"}}}},"styles":{"assistant":{},"header":{},"body":{},"toolbar":{},"start":{}}}');

},{}],"cEsfB":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _base = require("@emotion/styled/base");
var _baseDefault = parcelHelpers.interopDefault(_base);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _settingsCard = require("../../../../components/structure/SettingsCard");
var _settingsCardDefault = parcelHelpers.interopDefault(_settingsCard);
var _sharedStyledComponents = require("../SharedStyledComponents");
var _stylesValues = require("../../../../constants/stylesValues");
var _button = require("../../../../components/general/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _colors = require("../../../../constants/colors");
var _loader = require("../../../../components/general/Loader");
var _loaderDefault = parcelHelpers.interopDefault(_loader);
var _telephonyDeploymentContainer = require("../../../../hooks/TelephonyDeploymentContainer");
var _telephonyDeploymentContainerDefault = parcelHelpers.interopDefault(_telephonyDeploymentContainer);
var _telephonyDeploymentForm = require("./TelephonyDeploymentForm");
var _telephonyDeploymentFormDefault = parcelHelpers.interopDefault(_telephonyDeploymentForm);
var _css = require("@emotion/css");
var _conditionalTooltipWrapper = require("../../../../components/general/ConditionalTooltipWrapper");
var _conditionalTooltipWrapperDefault = parcelHelpers.interopDefault(_conditionalTooltipWrapper);
var _pageError = require("../../../../components/general/PageError");
var _pageErrorDefault = parcelHelpers.interopDefault(_pageError);
var _confirmationDialog = require("../../../../components/structure/ConfirmationDialog");
var _confirmationDialogDefault = parcelHelpers.interopDefault(_confirmationDialog);
var _warningConfirmation = require("../../../../components/general/WarningConfirmation");
var _warningConfirmationDefault = parcelHelpers.interopDefault(_warningConfirmation);
var _applicationItem = require("../../../../../clients/spark/scenes/basicOrganizationApplications/components/ApplicationItem");
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const telephonyLogo = require("c7497a082153aeea");
const telephonyAvatar = require("53ab5e661d405fa1");
const deleteAvatar = require("138899d12193395b");
const editAvatar = require("af6ed259b230678b");
const TelephonyDeploymentCard = (props)=>{
    const [telephonyRequestFormIsOpen, setTelephonyRequestFormIsOpen] = (0, _react1.useState)(false);
    const [updateTelephonyRequestFormIsOpen, setUpdateTelephonyRequestFormIsOpen] = (0, _react1.useState)(false);
    const [selectedTelephonyDeployment, setSelectedTelephonyDeployment] = (0, _react1.useState)();
    const [isLoading, setIsLoading] = (0, _react1.useState)(false);
    const [isConfirmDeleteModalOpen, setIsConfirmDeleteModalOpen] = (0, _react1.useState)(false);
    const [selectedPhoneNumber, setSelectedPhoneNumber] = (0, _react1.useState)("");
    const [selectedPhoneNumberDeployments, setSelectedPhoneNumberDeployments] = (0, _react1.useState)(null);
    const telephonyDeploymentContainer = (0, _telephonyDeploymentContainerDefault.default).useContainer();
    (0, _react1.useEffect)(()=>{
        loadTelephonyDeployments();
    }, []);
    // we need to group the connections with the same number
    const groupDeploymentsByPhoneNumber = ()=>{
        const grouped = {};
        telephonyDeploymentContainer.telephonyDeployments?.forEach((deployment)=>{
            const phoneNumber = deployment.phoneNumber;
            if (!grouped[phoneNumber]) grouped[phoneNumber] = [];
            grouped[phoneNumber].push(deployment);
        });
        return grouped;
    };
    const getUniquePhoneNumbers = ()=>{
        const grouped = groupDeploymentsByPhoneNumber();
        return Object.keys(grouped).map((phoneNumber)=>({
                phoneNumber,
                deployment: grouped[phoneNumber][0],
                // Show the first deployment
                localeCount: grouped[phoneNumber].length
            }));
    };
    const getDeploymentsForPhoneNumber = (phoneNumber)=>{
        return telephonyDeploymentContainer.telephonyDeployments?.filter((deployment)=>deployment.phoneNumber === phoneNumber) || [];
    };
    const openTelephonyRequestForm = ()=>{
        setTelephonyRequestFormIsOpen(true);
    };
    const rewordedErrorMessage = ()=>{
        if (telephonyDeploymentContainer.errors[0] === "No numbers found") return [
            "There are no numbers available with the digits you requested. Please try again."
        ];
        else return telephonyDeploymentContainer.errors;
    };
    const openTelephonyUpdateForm = (telephonyDeployment)=>{
        setUpdateTelephonyRequestFormIsOpen(true);
        setSelectedTelephonyDeployment(telephonyDeployment);
    };
    const handlePhoneNumberClick = (phoneNumber, deployment)=>{
        const deployments = getDeploymentsForPhoneNumber(phoneNumber);
        setSelectedPhoneNumberDeployments(deployments);
        setSelectedTelephonyDeployment(deployment);
        setUpdateTelephonyRequestFormIsOpen(true);
    };
    const deletePhoneNumber = async (phoneNumber)=>{
        setIsLoading(true);
        await telephonyDeploymentContainer.deleteTelephonyDeployment(props.applicationId, phoneNumber);
        loadTelephonyDeployments();
        setIsConfirmDeleteModalOpen(false);
    };
    const toggleConfirmDeleteModal = ()=>{
        setIsConfirmDeleteModalOpen(!isConfirmDeleteModalOpen);
    };
    const closeDeleteModal = ()=>{
        toggleConfirmDeleteModal();
        setSelectedPhoneNumber("");
    };
    const selectPhoneNumberToDelete = (phoneNumber)=>{
        setSelectedPhoneNumber(phoneNumber);
        toggleConfirmDeleteModal();
    };
    const closeTelephonyRequestForm = ()=>{
        if (telephonyRequestFormIsOpen) setTelephonyRequestFormIsOpen(false);
        if (updateTelephonyRequestFormIsOpen) setUpdateTelephonyRequestFormIsOpen(false);
        setSelectedTelephonyDeployment(undefined);
        setSelectedPhoneNumberDeployments(null);
    };
    const loadTelephonyDeployments = async ()=>{
        setIsLoading(true);
        await telephonyDeploymentContainer.getTelephonyDeployments(props.applicationId);
        setIsLoading(false);
    };
    const submitTelephonyDeployment = async (request)=>{
        if (telephonyRequestFormIsOpen) await telephonyDeploymentContainer.createTelephonyDeployment(props.applicationId, request);
        if (updateTelephonyRequestFormIsOpen) await telephonyDeploymentContainer.updateTelephonyDeployment(props.applicationId, selectedTelephonyDeployment.phoneNumber, request);
        loadTelephonyDeployments();
    };
    const disable = isLoading || telephonyDeploymentContainer.isLoading || getUniquePhoneNumbers().length >= 4;
    return (0, _react.jsx)((0, _sharedStyledComponents.CardContainer), {
        id: "telephony-card"
    }, (telephonyRequestFormIsOpen || updateTelephonyRequestFormIsOpen) && (0, _react.jsx)((0, _telephonyDeploymentFormDefault.default), {
        closeTelephonyRequestForm: closeTelephonyRequestForm,
        submitTelephonyDeployment: submitTelephonyDeployment,
        environmentId: props.environmentId,
        selectedTelephonyDeployment: selectedTelephonyDeployment,
        selectedPhoneNumberDeployments: selectedPhoneNumberDeployments,
        appContainer: props.appContainer,
        onSelectDeployment: setSelectedTelephonyDeployment
    }), (0, _react.jsx)((0, _settingsCardDefault.default), null, (0, _react.jsx)((0, _sharedStyledComponents.Logo), {
        src: telephonyLogo
    }), (0, _react.jsx)(DescriptionWrapper, null, (0, _react.jsx)("p", null, "Let's deploy your assistant to a phone number!"), (0, _react.jsx)("br", null), (0, _react.jsx)("p", null, 'Select the "Add a Phone Number" button below to customize your settings.')), (0, _react.jsx)(CardTitle, null, "Phone Numbers"), (0, _react.jsx)(ListWrapper, null, telephonyDeploymentContainer.telephonyDeployments?.length > 0 ? getUniquePhoneNumbers().map(({ phoneNumber, deployment, localeCount })=>{
        return (0, _react.jsx)("div", {
            key: phoneNumber
        }, isConfirmDeleteModalOpen && (0, _react.jsx)((0, _confirmationDialogDefault.default), {
            isLoading: isLoading || telephonyDeploymentContainer.isLoading,
            title: `Confirm Delete`,
            deleteText: "Yes, Delete",
            onClose: closeDeleteModal,
            onConfirm: ()=>deletePhoneNumber(selectedPhoneNumber)
        }, (0, _react.jsx)((0, _warningConfirmationDefault.default), {
            text: `Are you sure you want to delete ${(0, _applicationItem.formatPhoneNumber)(selectedPhoneNumber)}? There's no guarantee you'll be able to request this specific number again.`
        })), isLoading || telephonyDeploymentContainer.isLoading ? (0, _react.jsx)((0, _loaderDefault.default), {
            className: loaderStyle
        }) : (0, _react.jsx)(ListItem, {
            key: deployment.id
        }, (0, _react.jsx)(ListItemLeft, {
            onClick: ()=>handlePhoneNumberClick(phoneNumber, deployment)
        }, (0, _react.jsx)(Avatar, {
            src: telephonyAvatar
        }), deployment?.name?.length ? (0, _react.jsx)((0, _reactDefault.default).Fragment, null, (0, _react.jsx)("p", null, deployment.name), (0, _react.jsx)(NameSpacer, null, ":")) : (0, _react.jsx)((0, _reactDefault.default).Fragment, null), deployment.phoneNumber?.length > 0 ? (0, _applicationItem.formatPhoneNumber)(deployment.phoneNumber, !!deployment.virtualNumber?.length) : (0, _react.jsx)("p", null, "Phone Number Unknown"), localeCount > 1 && (0, _react.jsx)(LocaleIndicator, null, "(", localeCount, " locales)")), (0, _react.jsx)(ListItemRight, null, (0, _react.jsx)(ActionIcon, {
            src: editAvatar,
            onClick: (e)=>{
                e.stopPropagation();
                handlePhoneNumberClick(phoneNumber, deployment);
            }
        }), (0, _react.jsx)(ActionIcon, {
            src: deleteAvatar,
            onClick: (e)=>{
                e.stopPropagation();
                selectPhoneNumberToDelete(deployment.phoneNumber);
            }
        }))));
    }) : (0, _react.jsx)("p", null, "Looks like you don't have any phone numbers set up for this assistant yet.")), (0, _react.jsx)((0, _conditionalTooltipWrapperDefault.default), {
        showTooltip: disable,
        place: "top",
        text: "You can have up to 4 phone numbers per assistant."
    }, (0, _react.jsx)("div", null, (0, _react.jsx)(CustomButton, {
        themes: [
            "primary",
            "wide"
        ],
        loading: isLoading || telephonyDeploymentContainer.isLoading,
        disabled: disable,
        text: "Add a Phone Number",
        type: "button",
        onClick: ()=>openTelephonyRequestForm()
    })))), telephonyDeploymentContainer.errors?.length > 0 && (0, _react.jsx)((0, _pageErrorDefault.default), {
        errors: rewordedErrorMessage(),
        onClear: ()=>{
            telephonyDeploymentContainer.clearErrors();
        }
    }));
};
const Empty = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "eifi8h511"
})({
    name: "1pzk433",
    styles: "width:100px"
});
const loaderStyle = /*#__PURE__*/ (0, _css.css)({
    name: "1kvmmhe",
    styles: "position:fixed;top:50%;left:60%"
});
const ActionIcon = /*#__PURE__*/ (0, _baseDefault.default)("img", {
    target: "eifi8h510"
})({
    name: "1nohwdk",
    styles: "cursor:pointer;margin:12px 24px 12px 12px"
});
const Avatar = /*#__PURE__*/ (0, _baseDefault.default)("img", {
    target: "eifi8h59"
})({
    name: "1ohidnd",
    styles: "margin:12px 12px 12px 24px;padding:2px;border-radius:50%"
});
const CardTitle = /*#__PURE__*/ (0, _baseDefault.default)("h3", {
    target: "eifi8h58"
})("font-size:18px;color:", (0, _colors.color_shades_darkest), ";font-weight:400;margin-top:32px;");
const CustomButton = /*#__PURE__*/ (0, _baseDefault.default)((0, _buttonDefault.default), {
    target: "eifi8h57"
})({
    name: "2r7frt",
    styles: "padding:6px 24px;margin:24px 0;display:flex;align-items:center;flex:4"
});
const DescriptionWrapper = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "eifi8h56"
})("padding:32px 0;border-bottom:", (0, _stylesValues.style_border_default), ";");
const ListWrapper = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "eifi8h55"
})({
    name: "jji7ym",
    styles: "padding-top:32px;display:flex;flex-direction:column;justify-content:center"
});
const ListItem = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "eifi8h54"
})("display:flex;align-items:center;justify-content:space-between;border:", (0, _stylesValues.style_border_default), ";border-top:none;border-radius:8px;height:56px;width:100%;&:first-of-type{border-top:", (0, _stylesValues.style_border_default), ";}");
const ListItemLeft = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "eifi8h53"
})({
    name: "1tqlm1e",
    styles: "cursor:pointer;display:flex;align-items:center;justify-content:flex-start"
});
const ListItemRight = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "eifi8h52"
})({
    name: "19mh0x6",
    styles: "display:flex;align-items:center;justify-content:flex-end"
});
const NameSpacer = /*#__PURE__*/ (0, _baseDefault.default)("p", {
    target: "eifi8h51"
})({
    name: "14ygysx",
    styles: "margin-left:0px;margin-right:8px"
});
const LocaleIndicator = /*#__PURE__*/ (0, _baseDefault.default)("span", {
    target: "eifi8h50"
})({
    name: "gti03w",
    styles: "margin-left:8px;font-size:12px;color:#666;font-style:italic"
});
exports.default = TelephonyDeploymentCard;

},{"@emotion/styled/base":"lSuFu","@emotion/react":"djZKr","react":"6uln9","../../../../components/structure/SettingsCard":"liIw4","../SharedStyledComponents":"9COIL","../../../../constants/stylesValues":"dHVVv","../../../../components/general/Button":"6ymxN","../../../../constants/colors":"1p3OR","../../../../components/general/Loader":"bnV5T","../../../../hooks/TelephonyDeploymentContainer":"2qU7b","./TelephonyDeploymentForm":"fxqOU","@emotion/css":"awUBr","../../../../components/general/ConditionalTooltipWrapper":"92m0T","../../../../components/general/PageError":"ezFTm","../../../../components/structure/ConfirmationDialog":"kx7yK","../../../../components/general/WarningConfirmation":"9OccO","../../../../../clients/spark/scenes/basicOrganizationApplications/components/ApplicationItem":"kQkdQ","c7497a082153aeea":"cC28N","53ab5e661d405fa1":"fitEs","138899d12193395b":"k8RZz","af6ed259b230678b":"1u9JO","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"fxqOU":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _yup = require("yup");
var _formik = require("formik");
var _telephonyDeployment = require("./TelephonyDeployment");
var _telephonyDeploymentDefault = parcelHelpers.interopDefault(_telephonyDeployment);
var _defaultTelephonyDeploymentSettings = require("../../../../constants/telephonyConstants.tsx/defaultTelephonyDeploymentSettings");
var _voices = require("../../../../constants/sparkConstants/voices");
const TelephonyDeploymentForm = (0, _formik.withFormik)({
    mapPropsToValues: (props)=>({
            noTracking: props.selectedTelephonyDeployment?.noTracking ?? (0, _defaultTelephonyDeploymentSettings.defaultTelephonyDeploymentSettings).noTracking,
            phoneNumberStartsWith: props.selectedTelephonyDeployment?.phoneNumber ? props.selectedTelephonyDeployment?.phoneNumber : (0, _defaultTelephonyDeploymentSettings.defaultTelephonyDeploymentSettings).phoneNumberStartsWith,
            locale: props.selectedTelephonyDeployment?.locale ? props.selectedTelephonyDeployment?.locale : props.appContainer?.state?.currentApp?.languages[0]?.shortCode ? props.appContainer?.state?.currentApp?.languages[0]?.shortCode : (0, _defaultTelephonyDeploymentSettings.defaultTelephonyDeploymentSettings).locale,
            asrEndpointing: props.selectedTelephonyDeployment?.asrEndpointing ?? (0, _defaultTelephonyDeploymentSettings.defaultTelephonyDeploymentSettings).asrEndpointing,
            asrProvider: props.selectedTelephonyDeployment?.asrProvider ?? (0, _defaultTelephonyDeploymentSettings.defaultTelephonyDeploymentSettings).asrProvider,
            asrModel: props.selectedTelephonyDeployment?.asrModel ?? (0, _defaultTelephonyDeploymentSettings.defaultTelephonyDeploymentSettings).asrModel,
            asrTier: props.selectedTelephonyDeployment?.asrTier ?? (0, _defaultTelephonyDeploymentSettings.defaultTelephonyDeploymentSettings).asrTier,
            performLanguageDetection: props.selectedTelephonyDeployment?.performLanguageDetection ?? (0, _defaultTelephonyDeploymentSettings.defaultTelephonyDeploymentSettings).performLanguageDetection,
            dtmfTurnsToListen: props.selectedTelephonyDeployment?.dtmfTurnsToListen ?? (0, _defaultTelephonyDeploymentSettings.defaultTelephonyDeploymentSettings).dtmfTurnsToListen,
            ttsPronunciationsMap: props.selectedTelephonyDeployment?.ttsPronunciationsMap ?? (0, _defaultTelephonyDeploymentSettings.defaultTelephonyDeploymentSettings).ttsPronunciationsMap,
            firstMessageDelayMS: props.selectedTelephonyDeployment?.firstMessageDelayMS ?? (0, _defaultTelephonyDeploymentSettings.defaultTelephonyDeploymentSettings).firstMessageDelayMS,
            mergeTurnsAfterPauses: props.selectedTelephonyDeployment?.mergeTurnsAfterPauses ?? (0, _defaultTelephonyDeploymentSettings.defaultTelephonyDeploymentSettings).mergeTurnsAfterPauses,
            mergeTurnTimeoutMS: props.selectedTelephonyDeployment?.mergeTurnTimeoutMS ?? (0, _defaultTelephonyDeploymentSettings.defaultTelephonyDeploymentSettings).mergeTurnTimeoutMS,
            disableBargeIn: props.selectedTelephonyDeployment?.disableBargeIn ?? (0, _defaultTelephonyDeploymentSettings.defaultTelephonyDeploymentSettings).disableBargeIn,
            repromptAttempts: props.selectedTelephonyDeployment?.repromptAttempts ?? (0, _defaultTelephonyDeploymentSettings.defaultTelephonyDeploymentSettings).repromptAttempts,
            repromptDelaySeconds: props.selectedTelephonyDeployment?.repromptDelaySeconds ?? (0, _defaultTelephonyDeploymentSettings.defaultTelephonyDeploymentSettings).repromptDelaySeconds,
            name: props.selectedTelephonyDeployment?.name ?? (0, _defaultTelephonyDeploymentSettings.defaultTelephonyDeploymentSettings).name,
            ttsOptions: props.selectedTelephonyDeployment?.ttsOptions != null && props.selectedTelephonyDeployment?.ttsOptions?.length > 0 ? props.selectedTelephonyDeployment?.ttsOptions : props.selectedTelephonyDeployment?.ttsProvider != null && props.selectedTelephonyDeployment?.ttsVoice != null ? [
                {
                    ttsProvider: props.selectedTelephonyDeployment?.ttsProvider,
                    ttsVoice: props.selectedTelephonyDeployment?.ttsVoice
                }
            ] : (0, _defaultTelephonyDeploymentSettings.defaultTelephonyDeploymentSettings).ttsOptions,
            proactiveResponseDelayMS: props.selectedTelephonyDeployment?.proactiveResponseDelayMS ?? (0, _defaultTelephonyDeploymentSettings.defaultTelephonyDeploymentSettings).proactiveResponseDelayMS,
            proactiveResponses: props.selectedTelephonyDeployment?.proactiveResponses ?? (0, _defaultTelephonyDeploymentSettings.defaultTelephonyDeploymentSettings).proactiveResponses,
            useProactiveResponses: props.selectedTelephonyDeployment?.useProactiveResponses ?? (0, _defaultTelephonyDeploymentSettings.defaultTelephonyDeploymentSettings).useProactiveResponses,
            maxProactiveResponseAttempts: props.selectedTelephonyDeployment?.maxProactiveResponseAttempts ?? (0, _defaultTelephonyDeploymentSettings.defaultTelephonyDeploymentSettings).maxProactiveResponseAttempts,
            followUpProactiveResponses: props.selectedTelephonyDeployment?.followUpProactiveResponses ?? (0, _defaultTelephonyDeploymentSettings.defaultTelephonyDeploymentSettings).followUpProactiveResponses,
            disableWelcomeMessageBargeIn: props.selectedTelephonyDeployment?.disableWelcomeMessageBargeIn ?? (0, _defaultTelephonyDeploymentSettings.defaultTelephonyDeploymentSettings).disableWelcomeMessageBargeIn,
            disableSpeechStarted: props.selectedTelephonyDeployment?.disableSpeechStarted ?? (0, _defaultTelephonyDeploymentSettings.defaultTelephonyDeploymentSettings).disableSpeechStarted,
            speechStartedUnconfirmedBargeInLimit: props.selectedTelephonyDeployment?.speechStartedUnconfirmedBargeInLimit ?? (0, _defaultTelephonyDeploymentSettings.defaultTelephonyDeploymentSettings).speechStartedUnconfirmedBargeInLimit,
            speechStartedPauseMS: props.selectedTelephonyDeployment?.speechStartedPauseMS ?? (0, _defaultTelephonyDeploymentSettings.defaultTelephonyDeploymentSettings).speechStartedPauseMS,
            speechStartedRequiredBufferCount: props.selectedTelephonyDeployment?.speechStartedRequiredBufferCount ?? (0, _defaultTelephonyDeploymentSettings.defaultTelephonyDeploymentSettings).speechStartedRequiredBufferCount,
            callRecordingEnabled: props.selectedTelephonyDeployment?.callRecordingEnabled ?? (0, _defaultTelephonyDeploymentSettings.defaultTelephonyDeploymentSettings).callRecordingEnabled,
            speechStartedLevel: props.selectedTelephonyDeployment?.speechStartedLevel ?? (0, _defaultTelephonyDeploymentSettings.defaultTelephonyDeploymentSettings).speechStartedLevel,
            attemptInitialTransfer: props.selectedTelephonyDeployment?.attemptInitialTransfer ?? (0, _defaultTelephonyDeploymentSettings.defaultTelephonyDeploymentSettings).attemptInitialTransfer,
            initialTransferTimeoutSeconds: props.selectedTelephonyDeployment?.initialTransferTimeoutSeconds ?? (0, _defaultTelephonyDeploymentSettings.defaultTelephonyDeploymentSettings).initialTransferTimeoutSeconds,
            initialTransferTarget: props.selectedTelephonyDeployment?.initialTransferTarget ?? (0, _defaultTelephonyDeploymentSettings.defaultTelephonyDeploymentSettings).initialTransferTarget,
            initialTransferWithCallingNumber: props.selectedTelephonyDeployment?.initialTransferWithCallingNumber ?? (0, _defaultTelephonyDeploymentSettings.defaultTelephonyDeploymentSettings).initialTransferWithCallingNumber,
            virtualNumber: props.selectedTelephonyDeployment?.virtualNumber ?? (0, _defaultTelephonyDeploymentSettings.defaultTelephonyDeploymentSettings).virtualNumber,
            useVirtualNumber: !!props.selectedTelephonyDeployment ? !!props.selectedTelephonyDeployment?.virtualNumber?.length : (0, _defaultTelephonyDeploymentSettings.defaultTelephonyDeploymentSettings).useVirtualNumber,
            shouldProcessAudio: props.selectedTelephonyDeployment?.shouldProcessAudio ?? (0, _defaultTelephonyDeploymentSettings.defaultTelephonyDeploymentSettings).shouldProcessAudio,
            country: props.selectedTelephonyDeployment?.phoneNumberCountryCode ?? (0, _defaultTelephonyDeploymentSettings.defaultTelephonyDeploymentSettings).country,
            followUpProactiveResponsesDelayMS: props.selectedTelephonyDeployment?.followUpProactiveResponsesDelayMS ?? (0, _defaultTelephonyDeploymentSettings.defaultTelephonyDeploymentSettings).followUpProactiveResponsesDelayMS,
            postProactiveResponsePauseDelayMS: props.selectedTelephonyDeployment?.postProactiveResponsePauseDelayMS ?? (0, _defaultTelephonyDeploymentSettings.defaultTelephonyDeploymentSettings).postProactiveResponsePauseDelayMS,
            disableSpamDetection: props.selectedTelephonyDeployment?.disableSpamDetection ?? (0, _defaultTelephonyDeploymentSettings.defaultTelephonyDeploymentSettings).disableSpamDetection,
            autoTransferPreviouslyTransferred: !!props.selectedTelephonyDeployment?.immediateTransferHourCutoff,
            immediateTransferHourCutoff: props.selectedTelephonyDeployment?.immediateTransferHourCutoff,
            aiReengageSecondsAfterImmediateTransfer: props.selectedTelephonyDeployment?.aiReengageSecondsAfterImmediateTransfer > 0 ? props.selectedTelephonyDeployment?.aiReengageSecondsAfterImmediateTransfer : -1,
            spamDetectionPromptOverride: props.selectedTelephonyDeployment?.spamDetectionPromptOverride ?? (0, _defaultTelephonyDeploymentSettings.defaultTelephonyDeploymentSettings).spamDetectionPromptOverride,
            spamDetectionTolerance: props.selectedTelephonyDeployment?.spamDetectionTolerance ?? (0, _defaultTelephonyDeploymentSettings.defaultTelephonyDeploymentSettings).spamDetectionTolerance,
            spamDetectionTemperature: props.selectedTelephonyDeployment?.spamDetectionTemperature ?? (0, _defaultTelephonyDeploymentSettings.defaultTelephonyDeploymentSettings).spamDetectionTemperature,
            spamDetectionGenAiProvider: props.selectedTelephonyDeployment?.spamDetectionGenAiProvider ?? (0, _defaultTelephonyDeploymentSettings.defaultTelephonyDeploymentSettings).spamDetectionGenAiProvider,
            tryWebsocketReconnectionOnWelcome: props.selectedTelephonyDeployment?.tryWebsocketReconnectionOnWelcome ?? (0, _defaultTelephonyDeploymentSettings.defaultTelephonyDeploymentSettings).tryWebsocketReconnectionOnWelcome,
            platform: props.selectedTelephonyDeployment?.platform ?? (0, _defaultTelephonyDeploymentSettings.defaultTelephonyDeploymentSettings).platform,
            useGenerativeProactiveResponse: props.selectedTelephonyDeployment?.useGenerativeProactiveResponse ?? (0, _defaultTelephonyDeploymentSettings.defaultTelephonyDeploymentSettings).useGenerativeProactiveResponse,
            generativeProactiveResponsePrompt: props.selectedTelephonyDeployment?.generativeProactiveResponsePrompt ?? (0, _defaultTelephonyDeploymentSettings.defaultTelephonyDeploymentSettings).generativeProactiveResponsePrompt,
            lastProactiveResponsesToDisallow: props.selectedTelephonyDeployment?.lastProactiveResponsesToDisallow ?? (0, _defaultTelephonyDeploymentSettings.defaultTelephonyDeploymentSettings).lastProactiveResponsesToDisallow,
            notificationEmails: props.selectedTelephonyDeployment?.notificationEmails ?? (0, _defaultTelephonyDeploymentSettings.defaultTelephonyDeploymentSettings).notificationEmails,
            immediateTransferCallerNumbers: props.selectedTelephonyDeployment?.immediateTransferCallerNumbers ?? (0, _defaultTelephonyDeploymentSettings.defaultTelephonyDeploymentSettings).immediateTransferCallerNumbers,
            outboundCallerIdNumber: props.selectedTelephonyDeployment?.outboundCallerIdNumber ?? (0, _defaultTelephonyDeploymentSettings.defaultTelephonyDeploymentSettings).outboundCallerIdNumber,
            useForOutboundCalling: props.selectedTelephonyDeployment?.useForOutboundCalling ?? (0, _defaultTelephonyDeploymentSettings.defaultTelephonyDeploymentSettings).useForOutboundCalling,
            disableAssistantSpeechCleaning: props.selectedTelephonyDeployment?.disableAssistantSpeechCleaning ?? (0, _defaultTelephonyDeploymentSettings.defaultTelephonyDeploymentSettings).disableAssistantSpeechCleaning,
            optInText: props.selectedTelephonyDeployment?.optInText ?? (0, _defaultTelephonyDeploymentSettings.defaultTelephonyDeploymentSettings).optInText
        }),
    validationSchema: _yup.object().shape({
        asrEndpointing: _yup.number().min(0, "Must be a number more than 0"),
        performLanguageDetection: _yup.boolean(),
        dtmfTurnsToListen: _yup.number().min(0, "Must be a number 0 or greater"),
        firstMessageDelayMS: _yup.number().min(0, "Must be a number more than 0"),
        mergeTurnTimeoutMS: _yup.number().min(0, "Must be a number more than 0"),
        repromptAttempts: _yup.number().min(0, "Must be a number more than 0"),
        repromptDelaySeconds: _yup.number().min(0, "Must be a number more than 0"),
        postProactiveResponsePauseDelayMS: _yup.number().min(0, "Must be a number more than 0"),
        notificationEmails: _yup.string(),
        immediateTransferCallerNumbers: _yup.string(),
        optInText: _yup.string().max(500, "Must be 500 characters or less")
    }),
    handleSubmit: async (values, { props, setSubmitting })=>{
        values.ttsOptions.map((option)=>{
            let voice = option.ttsVoice?.trim();
            if (!voice?.length) option.ttsVoice = option.ttsProvider?.toLowerCase() === "elevenlabs" ? (0, _voices.defaultVoice) : option.ttsProvider?.toLowerCase() === "rime" ? (0, _voices.defaultRimeVoice) : "";
        });
        const telephonyRequest = {
            ...props.selectedTelephonyDeployment,
            noTracking: values.noTracking,
            phoneNumberCountryCode: values.country,
            phoneNumberStartsWith: values.phoneNumberStartsWith,
            environmentId: props.environmentId,
            ttsOptions: values.ttsOptions,
            locale: values.locale,
            asrEndpointing: values.asrEndpointing,
            asrProvider: values.asrProvider,
            asrModel: values.asrModel,
            asrTier: values.asrTier,
            performLanguageDetection: values.performLanguageDetection,
            dtmfTurnsToListen: values.dtmfTurnsToListen,
            ttsPronunciationsMap: values.ttsPronunciationsMap,
            firstMessageDelayMS: values.firstMessageDelayMS,
            mergeTurnsAfterPauses: values.mergeTurnsAfterPauses,
            mergeTurnTimeoutMS: values.mergeTurnTimeoutMS,
            disableBargeIn: values.disableBargeIn,
            repromptAttempts: values.repromptAttempts,
            repromptDelaySeconds: values.repromptDelaySeconds,
            name: values.name,
            proactiveResponseDelayMS: values.proactiveResponseDelayMS,
            proactiveResponses: values.proactiveResponses,
            useProactiveResponses: values.useProactiveResponses,
            maxProactiveResponseAttempts: values.maxProactiveResponseAttempts,
            followUpProactiveResponses: values.followUpProactiveResponses,
            followUpProactiveResponsesDelayMS: values.followUpProactiveResponsesDelayMS,
            disableWelcomeMessageBargeIn: values.disableWelcomeMessageBargeIn,
            disableSpeechStarted: values.disableSpeechStarted,
            speechStartedUnconfirmedBargeInLimit: values.speechStartedUnconfirmedBargeInLimit,
            speechStartedPauseMS: values.speechStartedPauseMS,
            speechStartedRequiredBufferCount: values.speechStartedRequiredBufferCount,
            callRecordingEnabled: values.callRecordingEnabled,
            speechStartedLevel: values.speechStartedLevel,
            attemptInitialTransfer: values.attemptInitialTransfer,
            initialTransferTimeoutSeconds: values.initialTransferTimeoutSeconds,
            initialTransferTarget: values.initialTransferTarget,
            initialTransferWithCallingNumber: values.initialTransferWithCallingNumber,
            postProactiveResponsePauseDelayMS: values.postProactiveResponsePauseDelayMS,
            virtualNumber: values.virtualNumber,
            useVirtualNumber: values.useVirtualNumber,
            shouldProcessAudio: values.shouldProcessAudio,
            disableSpamDetection: values.disableSpamDetection,
            immediateTransferHourCutoff: values.autoTransferPreviouslyTransferred ? values.immediateTransferHourCutoff ?? (0, _defaultTelephonyDeploymentSettings.defaultTelephonyDeploymentSettings).immediateTransferHourCutoff : undefined,
            aiReengageSecondsAfterImmediateTransfer: values.aiReengageSecondsAfterImmediateTransfer,
            spamDetectionPromptOverride: values.spamDetectionPromptOverride,
            spamDetectionTolerance: values.spamDetectionTolerance,
            spamDetectionTemperature: values.spamDetectionTemperature,
            spamDetectionGenAiProvider: values.spamDetectionGenAiProvider,
            tryWebsocketReconnectionOnWelcome: values.tryWebsocketReconnectionOnWelcome,
            platform: values.platform,
            useGenerativeProactiveResponse: values.useGenerativeProactiveResponse,
            generativeProactiveResponsePrompt: values.generativeProactiveResponsePrompt,
            lastProactiveResponsesToDisallow: values.lastProactiveResponsesToDisallow,
            notificationEmails: values.notificationEmails,
            immediateTransferCallerNumbers: values.immediateTransferCallerNumbers,
            outboundCallerIdNumber: values.outboundCallerIdNumber,
            useForOutboundCalling: values.useForOutboundCalling,
            disableAssistantSpeechCleaning: values.disableAssistantSpeechCleaning,
            optInText: values.optInText
        };
        setSubmitting(true);
        props.submitTelephonyDeployment(telephonyRequest);
        setSubmitting(false);
        props.closeTelephonyRequestForm();
    }
})((0, _telephonyDeploymentDefault.default));
exports.default = TelephonyDeploymentForm;

},{"yup":"j2SJU","formik":"3YnOK","./TelephonyDeployment":"ckw1j","../../../../constants/telephonyConstants.tsx/defaultTelephonyDeploymentSettings":"bs6Uz","../../../../constants/sparkConstants/voices":"3U9Ff","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"ckw1j":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _base = require("@emotion/styled/base");
var _baseDefault = parcelHelpers.interopDefault(_base);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _button = require("../../../../components/general/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _modalHeader = require("../../../../components/general/ModalHeader");
var _modalHeaderDefault = parcelHelpers.interopDefault(_modalHeader);
var _footerBar = require("../../../../components/structure/FooterBar");
var _footerBarDefault = parcelHelpers.interopDefault(_footerBar);
var _modalLayout = require("../../../../components/structure/ModalLayout");
var _modalLayoutDefault = parcelHelpers.interopDefault(_modalLayout);
var _stylesValues = require("../../../../constants/stylesValues");
var _colors = require("../../../../constants/colors");
var _css = require("@emotion/css");
var _useWindowSize = require("../../../../hooks/UseWindowSize");
var _useWindowSizeDefault = parcelHelpers.interopDefault(_useWindowSize);
var _customScrollbars = require("../../../../components/structure/CustomScrollbars");
var _customScrollbarsDefault = parcelHelpers.interopDefault(_customScrollbars);
var _textField = require("../../../../components/forms/TextField");
var _textFieldDefault = parcelHelpers.interopDefault(_textField);
var _textAreaField = require("../../../../components/forms/TextAreaField");
var _textAreaFieldDefault = parcelHelpers.interopDefault(_textAreaField);
var _iconTooltip = require("../../../../components/general/IconTooltip");
var _iconTooltipDefault = parcelHelpers.interopDefault(_iconTooltip);
var _styledDropdown = require("../customAssistantConfigurations/StyledDropdown");
var _styledDropdownDefault = parcelHelpers.interopDefault(_styledDropdown);
var _radioGroup = require("../../../../components/forms/RadioGroup");
var _radioGroupDefault = parcelHelpers.interopDefault(_radioGroup);
var _telephonyDeploymentFormFieldOptions = require("./TelephonyDeploymentFormFieldOptions");
var _contentCollapsingSection = require("../../../../components/structure/ContentCollapsingSection");
var _contentCollapsingSectionDefault = parcelHelpers.interopDefault(_contentCollapsingSection);
var _applicationItem = require("../../../../../clients/spark/scenes/basicOrganizationApplications/components/ApplicationItem");
var _defaultTelephonyDeploymentSettings = require("../../../../constants/telephonyConstants.tsx/defaultTelephonyDeploymentSettings");
var _voices = require("../../../../constants/sparkConstants/voices");
var _voiceOptions = require("../../../../constants/sparkConstants/voiceOptions");
var _phonePlatforms = require("../../../../constants/phonePlatforms");
var _notificationEmailsManager = require("./NotificationEmailsManager");
var _notificationEmailsManagerDefault = parcelHelpers.interopDefault(_notificationEmailsManager);
var _immediateTransferCallerNumbersManager = require("./ImmediateTransferCallerNumbersManager");
var _immediateTransferCallerNumbersManagerDefault = parcelHelpers.interopDefault(_immediateTransferCallerNumbersManager);
var _telephonyDeploymentContainer = require("../../../../hooks/TelephonyDeploymentContainer");
var _telephonyDeploymentContainerDefault = parcelHelpers.interopDefault(_telephonyDeploymentContainer);
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const advancedSettingsIcon = require("92360c9725af8eb3");
const MODAL_SCROLLBAR_SUBTRACTION = 200;
const processAudioOptions = [
    {
        label: "Yes",
        value: true
    },
    {
        label: "No",
        value: false
    }
];
const countryOptions = [
    {
        label: "United States",
        value: "US"
    },
    {
        label: "Canada",
        value: "CA"
    }
];
const TelephonyDeployment = (props)=>{
    const windowSize = (0, _useWindowSizeDefault.default)();
    const telephonyDeploymentContainer = (0, _telephonyDeploymentContainerDefault.default).useContainer();
    // Initialize locale configurations with existing deployments if available
    const initializeLocaleConfigurations = ()=>{
        if (props.selectedPhoneNumberDeployments && props.selectedPhoneNumberDeployments.length > 1) {
            // Multiple existing deployments - initialize with all of them
            const configs = {};
            props.selectedPhoneNumberDeployments.forEach((deployment)=>{
                configs[deployment.locale] = {
                    noTracking: deployment.noTracking ?? (0, _defaultTelephonyDeploymentSettings.defaultTelephonyDeploymentSettings).noTracking,
                    phoneNumberStartsWith: deployment.phoneNumber || (0, _defaultTelephonyDeploymentSettings.defaultTelephonyDeploymentSettings).phoneNumberStartsWith,
                    locale: deployment.locale,
                    asrEndpointing: deployment.asrEndpointing ?? (0, _defaultTelephonyDeploymentSettings.defaultTelephonyDeploymentSettings).asrEndpointing,
                    asrProvider: deployment.asrProvider ?? (0, _defaultTelephonyDeploymentSettings.defaultTelephonyDeploymentSettings).asrProvider,
                    asrModel: deployment.asrModel ?? (0, _defaultTelephonyDeploymentSettings.defaultTelephonyDeploymentSettings).asrModel,
                    asrTier: deployment.asrTier ?? (0, _defaultTelephonyDeploymentSettings.defaultTelephonyDeploymentSettings).asrTier,
                    performLanguageDetection: deployment.performLanguageDetection ?? (0, _defaultTelephonyDeploymentSettings.defaultTelephonyDeploymentSettings).performLanguageDetection,
                    dtmfTurnsToListen: deployment.dtmfTurnsToListen ?? (0, _defaultTelephonyDeploymentSettings.defaultTelephonyDeploymentSettings).dtmfTurnsToListen,
                    ttsPronunciationsMap: deployment.ttsPronunciationsMap ?? (0, _defaultTelephonyDeploymentSettings.defaultTelephonyDeploymentSettings).ttsPronunciationsMap,
                    firstMessageDelayMS: deployment.firstMessageDelayMS ?? (0, _defaultTelephonyDeploymentSettings.defaultTelephonyDeploymentSettings).firstMessageDelayMS,
                    mergeTurnsAfterPauses: deployment.mergeTurnsAfterPauses ?? (0, _defaultTelephonyDeploymentSettings.defaultTelephonyDeploymentSettings).mergeTurnsAfterPauses,
                    mergeTurnTimeoutMS: deployment.mergeTurnTimeoutMS ?? (0, _defaultTelephonyDeploymentSettings.defaultTelephonyDeploymentSettings).mergeTurnTimeoutMS,
                    disableBargeIn: deployment.disableBargeIn ?? (0, _defaultTelephonyDeploymentSettings.defaultTelephonyDeploymentSettings).disableBargeIn,
                    repromptAttempts: deployment.repromptAttempts ?? (0, _defaultTelephonyDeploymentSettings.defaultTelephonyDeploymentSettings).repromptAttempts,
                    repromptDelaySeconds: deployment.repromptDelaySeconds ?? (0, _defaultTelephonyDeploymentSettings.defaultTelephonyDeploymentSettings).repromptDelaySeconds,
                    name: deployment.name ?? (0, _defaultTelephonyDeploymentSettings.defaultTelephonyDeploymentSettings).name,
                    ttsOptions: deployment.ttsOptions?.length > 0 ? deployment.ttsOptions : deployment.ttsProvider && deployment.ttsVoice ? [
                        {
                            ttsProvider: deployment.ttsProvider,
                            ttsVoice: deployment.ttsVoice
                        }
                    ] : (0, _defaultTelephonyDeploymentSettings.defaultTelephonyDeploymentSettings).ttsOptions,
                    proactiveResponseDelayMS: deployment.proactiveResponseDelayMS ?? (0, _defaultTelephonyDeploymentSettings.defaultTelephonyDeploymentSettings).proactiveResponseDelayMS,
                    proactiveResponses: deployment.proactiveResponses ?? (0, _defaultTelephonyDeploymentSettings.defaultTelephonyDeploymentSettings).proactiveResponses,
                    useProactiveResponses: deployment.useProactiveResponses ?? (0, _defaultTelephonyDeploymentSettings.defaultTelephonyDeploymentSettings).useProactiveResponses,
                    maxProactiveResponseAttempts: deployment.maxProactiveResponseAttempts ?? (0, _defaultTelephonyDeploymentSettings.defaultTelephonyDeploymentSettings).maxProactiveResponseAttempts,
                    followUpProactiveResponses: deployment.followUpProactiveResponses ?? (0, _defaultTelephonyDeploymentSettings.defaultTelephonyDeploymentSettings).followUpProactiveResponses,
                    disableWelcomeMessageBargeIn: deployment.disableWelcomeMessageBargeIn ?? (0, _defaultTelephonyDeploymentSettings.defaultTelephonyDeploymentSettings).disableWelcomeMessageBargeIn,
                    disableSpeechStarted: deployment.disableSpeechStarted ?? (0, _defaultTelephonyDeploymentSettings.defaultTelephonyDeploymentSettings).disableSpeechStarted,
                    speechStartedUnconfirmedBargeInLimit: deployment.speechStartedUnconfirmedBargeInLimit ?? (0, _defaultTelephonyDeploymentSettings.defaultTelephonyDeploymentSettings).speechStartedUnconfirmedBargeInLimit,
                    speechStartedPauseMS: deployment.speechStartedPauseMS ?? (0, _defaultTelephonyDeploymentSettings.defaultTelephonyDeploymentSettings).speechStartedPauseMS,
                    speechStartedRequiredBufferCount: deployment.speechStartedRequiredBufferCount ?? (0, _defaultTelephonyDeploymentSettings.defaultTelephonyDeploymentSettings).speechStartedRequiredBufferCount,
                    callRecordingEnabled: deployment.callRecordingEnabled ?? (0, _defaultTelephonyDeploymentSettings.defaultTelephonyDeploymentSettings).callRecordingEnabled,
                    speechStartedLevel: deployment.speechStartedLevel ?? (0, _defaultTelephonyDeploymentSettings.defaultTelephonyDeploymentSettings).speechStartedLevel,
                    attemptInitialTransfer: deployment.attemptInitialTransfer ?? (0, _defaultTelephonyDeploymentSettings.defaultTelephonyDeploymentSettings).attemptInitialTransfer,
                    initialTransferTimeoutSeconds: deployment.initialTransferTimeoutSeconds ?? (0, _defaultTelephonyDeploymentSettings.defaultTelephonyDeploymentSettings).initialTransferTimeoutSeconds,
                    initialTransferTarget: deployment.initialTransferTarget ?? (0, _defaultTelephonyDeploymentSettings.defaultTelephonyDeploymentSettings).initialTransferTarget,
                    initialTransferWithCallingNumber: deployment.initialTransferWithCallingNumber ?? (0, _defaultTelephonyDeploymentSettings.defaultTelephonyDeploymentSettings).initialTransferWithCallingNumber,
                    postProactiveResponsePauseDelayMS: deployment.postProactiveResponsePauseDelayMS ?? (0, _defaultTelephonyDeploymentSettings.defaultTelephonyDeploymentSettings).postProactiveResponsePauseDelayMS,
                    virtualNumber: deployment.virtualNumber ?? (0, _defaultTelephonyDeploymentSettings.defaultTelephonyDeploymentSettings).virtualNumber,
                    useVirtualNumber: deployment.virtualNumber?.length > 0,
                    shouldProcessAudio: deployment.shouldProcessAudio ?? (0, _defaultTelephonyDeploymentSettings.defaultTelephonyDeploymentSettings).shouldProcessAudio,
                    disableSpamDetection: deployment.disableSpamDetection ?? (0, _defaultTelephonyDeploymentSettings.defaultTelephonyDeploymentSettings).disableSpamDetection,
                    immediateTransferHourCutoff: deployment.immediateTransferHourCutoff ?? (0, _defaultTelephonyDeploymentSettings.defaultTelephonyDeploymentSettings).immediateTransferHourCutoff,
                    aiReengageSecondsAfterImmediateTransfer: deployment.aiReengageSecondsAfterImmediateTransfer ?? (0, _defaultTelephonyDeploymentSettings.defaultTelephonyDeploymentSettings).aiReengageSecondsAfterImmediateTransfer,
                    spamDetectionPromptOverride: deployment.spamDetectionPromptOverride ?? (0, _defaultTelephonyDeploymentSettings.defaultTelephonyDeploymentSettings).spamDetectionPromptOverride,
                    spamDetectionTolerance: deployment.spamDetectionTolerance ?? (0, _defaultTelephonyDeploymentSettings.defaultTelephonyDeploymentSettings).spamDetectionTolerance,
                    spamDetectionTemperature: deployment.spamDetectionTemperature ?? (0, _defaultTelephonyDeploymentSettings.defaultTelephonyDeploymentSettings).spamDetectionTemperature,
                    spamDetectionGenAiProvider: deployment.spamDetectionGenAiProvider ?? (0, _defaultTelephonyDeploymentSettings.defaultTelephonyDeploymentSettings).spamDetectionGenAiProvider,
                    tryWebsocketReconnectionOnWelcome: deployment.tryWebsocketReconnectionOnWelcome ?? (0, _defaultTelephonyDeploymentSettings.defaultTelephonyDeploymentSettings).tryWebsocketReconnectionOnWelcome,
                    platform: deployment.platform ?? (0, _phonePlatforms.PHONE_PLATFORMS).VONAGE,
                    useGenerativeProactiveResponse: deployment.useGenerativeProactiveResponse ?? (0, _defaultTelephonyDeploymentSettings.defaultTelephonyDeploymentSettings).useGenerativeProactiveResponse,
                    generativeProactiveResponsePrompt: deployment.generativeProactiveResponsePrompt ?? (0, _defaultTelephonyDeploymentSettings.defaultTelephonyDeploymentSettings).generativeProactiveResponsePrompt,
                    lastProactiveResponsesToDisallow: deployment.lastProactiveResponsesToDisallow ?? (0, _defaultTelephonyDeploymentSettings.defaultTelephonyDeploymentSettings).lastProactiveResponsesToDisallow,
                    notificationEmails: deployment.notificationEmails ?? (0, _defaultTelephonyDeploymentSettings.defaultTelephonyDeploymentSettings).notificationEmails,
                    immediateTransferCallerNumbers: deployment.immediateTransferCallerNumbers ?? (0, _defaultTelephonyDeploymentSettings.defaultTelephonyDeploymentSettings).immediateTransferCallerNumbers,
                    outboundCallerIdNumber: deployment.outboundCallerIdNumber ?? (0, _defaultTelephonyDeploymentSettings.defaultTelephonyDeploymentSettings).outboundCallerIdNumber,
                    useForOutboundCalling: deployment.useForOutboundCalling ?? (0, _defaultTelephonyDeploymentSettings.defaultTelephonyDeploymentSettings).useForOutboundCalling,
                    disableAssistantSpeechCleaning: deployment.disableAssistantSpeechCleaning ?? (0, _defaultTelephonyDeploymentSettings.defaultTelephonyDeploymentSettings).disableAssistantSpeechCleaning,
                    optInText: deployment.optInText ?? (0, _defaultTelephonyDeploymentSettings.defaultTelephonyDeploymentSettings).optInText
                };
            });
            return configs;
        } else // Single deployment or new deployment
        return {
            [props.values.locale]: {
                ...props.values
            }
        };
    };
    // State for managing multiple locale configurations
    const [localeConfigurations, setLocaleConfigurations] = (0, _react1.useState)(initializeLocaleConfigurations);
    const [activeLocale, setActiveLocale] = (0, _react1.useState)(props.values.locale);
    const [modifiedLocales, setModifiedLocales] = (0, _react1.useState)(new Set());
    const [switchingToLocale, setSwitchingToLocale] = (0, _react1.useState)(null);
    // Function to create new locale configuration
    const handleCreateNewLocaleConfiguration = (newLocale)=>{
        const currentConfig = localeConfigurations[activeLocale];
        const newConfig = {
            ...currentConfig,
            locale: newLocale,
            name: "",
            // Clear the name field as requested
            country: currentConfig.country || props.values.country // Copy the phone number country code
        };
        setLocaleConfigurations((prev)=>({
                ...prev,
                [newLocale]: newConfig
            }));
        setActiveLocale(newLocale);
        setModifiedLocales((prev)=>new Set(prev).add(newLocale));
        // Update form values to the new configuration
        Object.keys(newConfig).forEach((key)=>{
            props.setFieldValue(key, newConfig[key]);
        });
    };
    // Function to switch between locale tabs
    const handleLocaleTabChange = async (locale)=>{
        if (locale === activeLocale) return;
        setSwitchingToLocale(locale);
        // Save current form values to current locale
        setLocaleConfigurations((prev)=>({
                ...prev,
                [activeLocale]: {
                    ...props.values
                }
            }));
        await new Promise((resolve)=>setTimeout(resolve, 1));
        // Switch to new locale
        setActiveLocale(locale);
        let targetConfig = localeConfigurations[locale];
        // If we have multiple existing deployments, also update the selected deployment
        if (props.selectedPhoneNumberDeployments && props.selectedPhoneNumberDeployments.length > 1) {
            const correspondingDeployment = props.selectedPhoneNumberDeployments.find((d)=>d.locale === locale);
            if (correspondingDeployment) {
                if (props.onSelectDeployment) props.onSelectDeployment(correspondingDeployment);
                // If we don't have a config for this locale yet, create one from the deployment
                if (!targetConfig) {
                    targetConfig = {
                        noTracking: correspondingDeployment.noTracking ?? (0, _defaultTelephonyDeploymentSettings.defaultTelephonyDeploymentSettings).noTracking,
                        phoneNumberStartsWith: correspondingDeployment.phoneNumber || (0, _defaultTelephonyDeploymentSettings.defaultTelephonyDeploymentSettings).phoneNumberStartsWith,
                        locale: correspondingDeployment.locale,
                        asrEndpointing: correspondingDeployment.asrEndpointing ?? (0, _defaultTelephonyDeploymentSettings.defaultTelephonyDeploymentSettings).asrEndpointing,
                        asrProvider: correspondingDeployment.asrProvider ?? (0, _defaultTelephonyDeploymentSettings.defaultTelephonyDeploymentSettings).asrProvider,
                        asrModel: correspondingDeployment.asrModel ?? (0, _defaultTelephonyDeploymentSettings.defaultTelephonyDeploymentSettings).asrModel,
                        asrTier: correspondingDeployment.asrTier ?? (0, _defaultTelephonyDeploymentSettings.defaultTelephonyDeploymentSettings).asrTier,
                        performLanguageDetection: correspondingDeployment.performLanguageDetection ?? (0, _defaultTelephonyDeploymentSettings.defaultTelephonyDeploymentSettings).performLanguageDetection,
                        dtmfTurnsToListen: correspondingDeployment.dtmfTurnsToListen ?? (0, _defaultTelephonyDeploymentSettings.defaultTelephonyDeploymentSettings).dtmfTurnsToListen,
                        ttsPronunciationsMap: correspondingDeployment.ttsPronunciationsMap ?? (0, _defaultTelephonyDeploymentSettings.defaultTelephonyDeploymentSettings).ttsPronunciationsMap,
                        firstMessageDelayMS: correspondingDeployment.firstMessageDelayMS ?? (0, _defaultTelephonyDeploymentSettings.defaultTelephonyDeploymentSettings).firstMessageDelayMS,
                        mergeTurnsAfterPauses: correspondingDeployment.mergeTurnsAfterPauses ?? (0, _defaultTelephonyDeploymentSettings.defaultTelephonyDeploymentSettings).mergeTurnsAfterPauses,
                        mergeTurnTimeoutMS: correspondingDeployment.mergeTurnTimeoutMS ?? (0, _defaultTelephonyDeploymentSettings.defaultTelephonyDeploymentSettings).mergeTurnTimeoutMS,
                        disableBargeIn: correspondingDeployment.disableBargeIn ?? (0, _defaultTelephonyDeploymentSettings.defaultTelephonyDeploymentSettings).disableBargeIn,
                        repromptAttempts: correspondingDeployment.repromptAttempts ?? (0, _defaultTelephonyDeploymentSettings.defaultTelephonyDeploymentSettings).repromptAttempts,
                        repromptDelaySeconds: correspondingDeployment.repromptDelaySeconds ?? (0, _defaultTelephonyDeploymentSettings.defaultTelephonyDeploymentSettings).repromptDelaySeconds,
                        name: correspondingDeployment.name ?? (0, _defaultTelephonyDeploymentSettings.defaultTelephonyDeploymentSettings).name,
                        ttsOptions: correspondingDeployment.ttsOptions?.length > 0 ? correspondingDeployment.ttsOptions : correspondingDeployment.ttsProvider && correspondingDeployment.ttsVoice ? [
                            {
                                ttsProvider: correspondingDeployment.ttsProvider,
                                ttsVoice: correspondingDeployment.ttsVoice
                            }
                        ] : (0, _defaultTelephonyDeploymentSettings.defaultTelephonyDeploymentSettings).ttsOptions,
                        proactiveResponseDelayMS: correspondingDeployment.proactiveResponseDelayMS ?? (0, _defaultTelephonyDeploymentSettings.defaultTelephonyDeploymentSettings).proactiveResponseDelayMS,
                        proactiveResponses: correspondingDeployment.proactiveResponses ?? (0, _defaultTelephonyDeploymentSettings.defaultTelephonyDeploymentSettings).proactiveResponses,
                        useProactiveResponses: correspondingDeployment.useProactiveResponses ?? (0, _defaultTelephonyDeploymentSettings.defaultTelephonyDeploymentSettings).useProactiveResponses,
                        maxProactiveResponseAttempts: correspondingDeployment.maxProactiveResponseAttempts ?? (0, _defaultTelephonyDeploymentSettings.defaultTelephonyDeploymentSettings).maxProactiveResponseAttempts,
                        followUpProactiveResponses: correspondingDeployment.followUpProactiveResponses ?? (0, _defaultTelephonyDeploymentSettings.defaultTelephonyDeploymentSettings).followUpProactiveResponses,
                        disableWelcomeMessageBargeIn: correspondingDeployment.disableWelcomeMessageBargeIn ?? (0, _defaultTelephonyDeploymentSettings.defaultTelephonyDeploymentSettings).disableWelcomeMessageBargeIn,
                        disableSpeechStarted: correspondingDeployment.disableSpeechStarted ?? (0, _defaultTelephonyDeploymentSettings.defaultTelephonyDeploymentSettings).disableSpeechStarted,
                        speechStartedUnconfirmedBargeInLimit: correspondingDeployment.speechStartedUnconfirmedBargeInLimit ?? (0, _defaultTelephonyDeploymentSettings.defaultTelephonyDeploymentSettings).speechStartedUnconfirmedBargeInLimit,
                        speechStartedPauseMS: correspondingDeployment.speechStartedPauseMS ?? (0, _defaultTelephonyDeploymentSettings.defaultTelephonyDeploymentSettings).speechStartedPauseMS,
                        speechStartedRequiredBufferCount: correspondingDeployment.speechStartedRequiredBufferCount ?? (0, _defaultTelephonyDeploymentSettings.defaultTelephonyDeploymentSettings).speechStartedRequiredBufferCount,
                        callRecordingEnabled: correspondingDeployment.callRecordingEnabled ?? (0, _defaultTelephonyDeploymentSettings.defaultTelephonyDeploymentSettings).callRecordingEnabled,
                        speechStartedLevel: correspondingDeployment.speechStartedLevel ?? (0, _defaultTelephonyDeploymentSettings.defaultTelephonyDeploymentSettings).speechStartedLevel,
                        attemptInitialTransfer: correspondingDeployment.attemptInitialTransfer ?? (0, _defaultTelephonyDeploymentSettings.defaultTelephonyDeploymentSettings).attemptInitialTransfer,
                        initialTransferTimeoutSeconds: correspondingDeployment.initialTransferTimeoutSeconds ?? (0, _defaultTelephonyDeploymentSettings.defaultTelephonyDeploymentSettings).initialTransferTimeoutSeconds,
                        initialTransferTarget: correspondingDeployment.initialTransferTarget ?? (0, _defaultTelephonyDeploymentSettings.defaultTelephonyDeploymentSettings).initialTransferTarget,
                        initialTransferWithCallingNumber: correspondingDeployment.initialTransferWithCallingNumber ?? (0, _defaultTelephonyDeploymentSettings.defaultTelephonyDeploymentSettings).initialTransferWithCallingNumber,
                        postProactiveResponsePauseDelayMS: correspondingDeployment.postProactiveResponsePauseDelayMS ?? (0, _defaultTelephonyDeploymentSettings.defaultTelephonyDeploymentSettings).postProactiveResponsePauseDelayMS,
                        virtualNumber: correspondingDeployment.virtualNumber ?? (0, _defaultTelephonyDeploymentSettings.defaultTelephonyDeploymentSettings).virtualNumber,
                        useVirtualNumber: correspondingDeployment.virtualNumber?.length > 0,
                        shouldProcessAudio: correspondingDeployment.shouldProcessAudio ?? (0, _defaultTelephonyDeploymentSettings.defaultTelephonyDeploymentSettings).shouldProcessAudio,
                        disableSpamDetection: correspondingDeployment.disableSpamDetection ?? (0, _defaultTelephonyDeploymentSettings.defaultTelephonyDeploymentSettings).disableSpamDetection,
                        immediateTransferHourCutoff: correspondingDeployment.immediateTransferHourCutoff ?? (0, _defaultTelephonyDeploymentSettings.defaultTelephonyDeploymentSettings).immediateTransferHourCutoff,
                        aiReengageSecondsAfterImmediateTransfer: correspondingDeployment.aiReengageSecondsAfterImmediateTransfer ?? (0, _defaultTelephonyDeploymentSettings.defaultTelephonyDeploymentSettings).aiReengageSecondsAfterImmediateTransfer,
                        spamDetectionPromptOverride: correspondingDeployment.spamDetectionPromptOverride ?? (0, _defaultTelephonyDeploymentSettings.defaultTelephonyDeploymentSettings).spamDetectionPromptOverride,
                        spamDetectionTolerance: correspondingDeployment.spamDetectionTolerance ?? (0, _defaultTelephonyDeploymentSettings.defaultTelephonyDeploymentSettings).spamDetectionTolerance,
                        spamDetectionTemperature: correspondingDeployment.spamDetectionTemperature ?? (0, _defaultTelephonyDeploymentSettings.defaultTelephonyDeploymentSettings).spamDetectionTemperature,
                        spamDetectionGenAiProvider: correspondingDeployment.spamDetectionGenAiProvider ?? (0, _defaultTelephonyDeploymentSettings.defaultTelephonyDeploymentSettings).spamDetectionGenAiProvider,
                        tryWebsocketReconnectionOnWelcome: correspondingDeployment.tryWebsocketReconnectionOnWelcome ?? (0, _defaultTelephonyDeploymentSettings.defaultTelephonyDeploymentSettings).tryWebsocketReconnectionOnWelcome,
                        platform: correspondingDeployment.platform ?? (0, _phonePlatforms.PHONE_PLATFORMS).VONAGE,
                        useGenerativeProactiveResponse: correspondingDeployment.useGenerativeProactiveResponse ?? (0, _defaultTelephonyDeploymentSettings.defaultTelephonyDeploymentSettings).useGenerativeProactiveResponse,
                        generativeProactiveResponsePrompt: correspondingDeployment.generativeProactiveResponsePrompt ?? (0, _defaultTelephonyDeploymentSettings.defaultTelephonyDeploymentSettings).generativeProactiveResponsePrompt,
                        lastProactiveResponsesToDisallow: correspondingDeployment.lastProactiveResponsesToDisallow ?? (0, _defaultTelephonyDeploymentSettings.defaultTelephonyDeploymentSettings).lastProactiveResponsesToDisallow,
                        notificationEmails: correspondingDeployment.notificationEmails ?? (0, _defaultTelephonyDeploymentSettings.defaultTelephonyDeploymentSettings).notificationEmails,
                        immediateTransferCallerNumbers: correspondingDeployment.immediateTransferCallerNumbers ?? (0, _defaultTelephonyDeploymentSettings.defaultTelephonyDeploymentSettings).immediateTransferCallerNumbers,
                        outboundCallerIdNumber: correspondingDeployment.outboundCallerIdNumber ?? (0, _defaultTelephonyDeploymentSettings.defaultTelephonyDeploymentSettings).outboundCallerIdNumber,
                        useForOutboundCalling: correspondingDeployment.useForOutboundCalling ?? (0, _defaultTelephonyDeploymentSettings.defaultTelephonyDeploymentSettings).useForOutboundCalling,
                        disableAssistantSpeechCleaning: correspondingDeployment.disableAssistantSpeechCleaning ?? (0, _defaultTelephonyDeploymentSettings.defaultTelephonyDeploymentSettings).disableAssistantSpeechCleaning,
                        optInText: correspondingDeployment.optInText ?? (0, _defaultTelephonyDeploymentSettings.defaultTelephonyDeploymentSettings).optInText
                    };
                    setLocaleConfigurations((prev)=>({
                            ...prev,
                            [locale]: targetConfig
                        }));
                }
            }
        }
        // Update form values if we have a target config
        if (targetConfig) Object.keys(targetConfig).forEach((key)=>{
            props.setFieldValue(key, targetConfig[key]);
        });
        setSwitchingToLocale(null);
    };
    const handleOnChange = (optionValue, value)=>{
        props.setFieldValue(optionValue, value);
        setModifiedLocales((prev)=>new Set(prev).add(activeLocale));
        // Also update the current locale configuration
        setLocaleConfigurations((prev)=>({
                ...prev,
                [activeLocale]: {
                    ...prev[activeLocale],
                    [optionValue]: value
                }
            }));
    };
    const handleGenerativeProactiveResponseChange = (optionValue, value)=>{
        handleOnChange(optionValue, value);
        if (value) {
            handleOnChange("postProactiveResponsePauseDelayMS", "100");
            handleOnChange("proactiveResponseDelayMS", "900");
        }
    };
    const handleTtsOptionChange = (index, field, value)=>{
        if (field === "both") {
            const updated = [
                ...props.values.ttsOptions
            ];
            const values = value.split("split");
            updated[index] = {
                ...updated[index],
                ["ttsProvider"]: values[0]
            };
            updated[index] = {
                ...updated[index],
                ["ttsVoice"]: values[1]
            };
            props.setFieldValue("ttsOptions", updated);
            setModifiedLocales((prev)=>new Set(prev).add(activeLocale));
            // Update locale configuration
            setLocaleConfigurations((prev)=>({
                    ...prev,
                    [activeLocale]: {
                        ...prev[activeLocale],
                        ttsOptions: updated
                    }
                }));
        } else {
            const updated = [
                ...props.values.ttsOptions
            ];
            updated[index] = {
                ...updated[index],
                [field]: value
            };
            props.setFieldValue("ttsOptions", updated);
            setModifiedLocales((prev)=>new Set(prev).add(activeLocale));
            // Update locale configuration
            setLocaleConfigurations((prev)=>({
                    ...prev,
                    [activeLocale]: {
                        ...prev[activeLocale],
                        ttsOptions: updated
                    }
                }));
        }
    };
    const handleVoiceDropdownChange = (optionValue, value)=>{
        const option = (0, _voiceOptions.voiceOptions).find((fullOption)=>fullOption.value.toLowerCase() === value.toLowerCase());
        const currentLength = [
            ...props.values.ttsOptions
        ].length;
        const newTtsOptions = [
            ...props.values.ttsOptions,
            {}
        ];
        props.setFieldValue("ttsOptions", newTtsOptions);
        setModifiedLocales((prev)=>new Set(prev).add(activeLocale));
        // Update locale configuration first
        setLocaleConfigurations((prev)=>({
                ...prev,
                [activeLocale]: {
                    ...prev[activeLocale],
                    ttsOptions: newTtsOptions
                }
            }));
        handleTtsOptionChange(currentLength, "both", option.provider + "split" + option.voice);
    };
    const handleDropDownChange = (optionValue, value)=>{
        props.setFieldValue(optionValue, value);
        setModifiedLocales((prev)=>new Set(prev).add(activeLocale));
        // Update locale configuration
        setLocaleConfigurations((prev)=>({
                ...prev,
                [activeLocale]: {
                    ...prev[activeLocale],
                    [optionValue]: value
                }
            }));
    };
    const handleCountryChange = (optionValue, value)=>{
        props.setFieldValue("country", value);
        setModifiedLocales((prev)=>new Set(prev).add(activeLocale));
        // Update locale configuration
        setLocaleConfigurations((prev)=>({
                ...prev,
                [activeLocale]: {
                    ...prev[activeLocale],
                    country: value
                }
            }));
    };
    // Wrapper for props.handleChange to update locale configurations
    const handleFormChange = (e)=>{
        const { name, value, type } = e.target;
        const fieldValue = type === "checkbox" ? e.target.checked : value;
        props.handleChange(e);
        setModifiedLocales((prev)=>new Set(prev).add(activeLocale));
        // Update locale configuration
        setLocaleConfigurations((prev)=>({
                ...prev,
                [activeLocale]: {
                    ...prev[activeLocale],
                    [name]: fieldValue
                }
            }));
    };
    const handleNotificationEmailsChange = (emails)=>{
        props.setFieldValue("notificationEmails", emails);
        setModifiedLocales((prev)=>new Set(prev).add(activeLocale));
        // Update locale configuration
        setLocaleConfigurations((prev)=>({
                ...prev,
                [activeLocale]: {
                    ...prev[activeLocale],
                    ["notificationEmails"]: emails
                }
            }));
    };
    const handleImmediateTransferCallerNumbersChange = (numbers)=>{
        props.setFieldValue("immediateTransferCallerNumbers", numbers);
        setModifiedLocales((prev)=>new Set(prev).add(activeLocale));
        setLocaleConfigurations((prev)=>({
                ...prev,
                [activeLocale]: {
                    ...prev[activeLocale],
                    ["immediateTransferCallerNumbers"]: numbers
                }
            }));
    };
    // Handle submission of multiple locale configurations
    const handleMultiLocaleSubmit = async ()=>{
        const currentConfigurations = {
            ...localeConfigurations,
            [activeLocale]: {
                ...props.values
            }
        };
        const localesNeedingSubmission = new Set([
            ...modifiedLocales,
            activeLocale
        ]);
        const configurationsToSubmit = Object.entries(currentConfigurations).filter(([locale])=>localesNeedingSubmission.has(locale));
        props.setSubmitting(true);
        try {
            let hasNewLocaleDeployments = false;
            // Submit each modified locale configuration separately
            for (const [locale, config] of configurationsToSubmit){
                //if this is a new locale configuration for an existing number
                const isExistingNumber = !!props.selectedTelephonyDeployment?.phoneNumber;
                const isOriginalLocale = locale === props.selectedTelephonyDeployment?.locale;
                // Check if this locale already exists in the deployments for this number
                const isExistingLocale = props.selectedPhoneNumberDeployments && props.selectedPhoneNumberDeployments.some((deployment)=>deployment.locale === locale);
                const isNewLocaleForExistingNumber = isExistingNumber && !isOriginalLocale && !isExistingLocale;
                // Create TelephonyDeploymentRequest for this locale (similar to TelephonyDeploymentForm.tsx)
                const telephonyRequest = {
                    ...props.selectedTelephonyDeployment,
                    noTracking: config.noTracking,
                    phoneNumberCountryCode: isNewLocaleForExistingNumber ? props.selectedTelephonyDeployment?.phoneNumberCountryCode : config.country,
                    phoneNumberStartsWith: config.phoneNumberStartsWith,
                    environmentId: props.environmentId,
                    ttsOptions: config.ttsOptions,
                    locale: config.locale,
                    asrEndpointing: config.asrEndpointing,
                    asrProvider: config.asrProvider,
                    asrModel: config.asrModel,
                    asrTier: config.asrTier,
                    performLanguageDetection: config.performLanguageDetection,
                    dtmfTurnsToListen: config.dtmfTurnsToListen,
                    ttsPronunciationsMap: config.ttsPronunciationsMap,
                    firstMessageDelayMS: config.firstMessageDelayMS,
                    mergeTurnsAfterPauses: config.mergeTurnsAfterPauses,
                    mergeTurnTimeoutMS: config.mergeTurnTimeoutMS,
                    disableBargeIn: config.disableBargeIn,
                    repromptAttempts: config.repromptAttempts,
                    repromptDelaySeconds: config.repromptDelaySeconds,
                    name: config.name || "",
                    // Use the name as entered by the user
                    proactiveResponseDelayMS: config.proactiveResponseDelayMS,
                    proactiveResponses: config.proactiveResponses,
                    useProactiveResponses: config.useProactiveResponses,
                    maxProactiveResponseAttempts: config.maxProactiveResponseAttempts,
                    followUpProactiveResponses: config.followUpProactiveResponses,
                    followUpProactiveResponsesDelayMS: config.followUpProactiveResponsesDelayMS,
                    disableWelcomeMessageBargeIn: config.disableWelcomeMessageBargeIn,
                    disableSpeechStarted: config.disableSpeechStarted,
                    speechStartedUnconfirmedBargeInLimit: config.speechStartedUnconfirmedBargeInLimit,
                    speechStartedPauseMS: config.speechStartedPauseMS,
                    speechStartedRequiredBufferCount: config.speechStartedRequiredBufferCount,
                    callRecordingEnabled: config.callRecordingEnabled,
                    speechStartedLevel: config.speechStartedLevel,
                    attemptInitialTransfer: config.attemptInitialTransfer,
                    initialTransferTimeoutSeconds: config.initialTransferTimeoutSeconds,
                    initialTransferTarget: config.initialTransferTarget,
                    initialTransferWithCallingNumber: config.initialTransferWithCallingNumber,
                    postProactiveResponsePauseDelayMS: config.postProactiveResponsePauseDelayMS,
                    virtualNumber: config.virtualNumber,
                    useVirtualNumber: config.useVirtualNumber,
                    shouldProcessAudio: config.shouldProcessAudio,
                    disableSpamDetection: config.disableSpamDetection,
                    immediateTransferHourCutoff: config.autoTransferPreviouslyTransferred ? config.immediateTransferHourCutoff ?? 24 : undefined,
                    aiReengageSecondsAfterImmediateTransfer: config.aiReengageSecondsAfterImmediateTransfer,
                    spamDetectionPromptOverride: config.spamDetectionPromptOverride,
                    spamDetectionTolerance: config.spamDetectionTolerance,
                    spamDetectionTemperature: config.spamDetectionTemperature,
                    spamDetectionGenAiProvider: config.spamDetectionGenAiProvider,
                    tryWebsocketReconnectionOnWelcome: config.tryWebsocketReconnectionOnWelcome,
                    platform: config.platform,
                    useGenerativeProactiveResponse: config.useGenerativeProactiveResponse,
                    generativeProactiveResponsePrompt: config.generativeProactiveResponsePrompt,
                    lastProactiveResponsesToDisallow: config.lastProactiveResponsesToDisallow,
                    notificationEmails: config.notificationEmails,
                    immediateTransferCallerNumbers: config.immediateTransferCallerNumbers,
                    outboundCallerIdNumber: config.outboundCallerIdNumber,
                    useForOutboundCalling: config.useForOutboundCalling,
                    disableAssistantSpeechCleaning: config.disableAssistantSpeechCleaning,
                    optInText: config.optInText
                };
                // Process TTS options similar to original form
                if (telephonyRequest.ttsOptions) telephonyRequest.ttsOptions.forEach((option)=>{
                    let voice = option.ttsVoice?.trim();
                    if (!voice?.length) option.ttsVoice = option.ttsProvider?.toLowerCase() === "elevenlabs" ? "defaultVoice" : option.ttsProvider?.toLowerCase() === "rime" ? "defaultRimeVoice" : "";
                });
                if (isNewLocaleForExistingNumber) {
                    // For existing numbers with NEW locale configurations, use add methods
                    const platform = config.platform || props.selectedTelephonyDeployment?.platform || (0, _phonePlatforms.PHONE_PLATFORMS).VONAGE;
                    if (platform === (0, _phonePlatforms.PHONE_PLATFORMS).VONAGE) await telephonyDeploymentContainer.createTelephonyDeployment(props.appContainer?.state?.currentApp?.id, telephonyRequest);
                    else if (platform === (0, _phonePlatforms.PHONE_PLATFORMS).TELNYX) await telephonyDeploymentContainer.createTelephonyDeployment(props.appContainer?.state?.currentApp?.id, telephonyRequest);
                    hasNewLocaleDeployments = true;
                } else //For new numbers or updating existing locale configurations, use existing logic
                await props.submitTelephonyDeployment(telephonyRequest, props.selectedTelephonyDeployment?.phoneNumber);
            }
            //If we created new locale deployments, get all the deployments to show all locales
            if (hasNewLocaleDeployments) await telephonyDeploymentContainer.getTelephonyDeployments(props.appContainer?.state?.currentApp?.id);
        } catch (error) {
            console.error("Error submitting locale configurations:", error);
        } finally{
            props.setSubmitting(false);
            props.closeTelephonyRequestForm();
        }
    };
    const getLocaleOptions = ()=>{
        const localeOptions = props.appContainer?.state?.currentApp?.languages.map((language)=>{
            return {
                label: language.shortCode,
                value: language.shortCode
            };
        });
        return localeOptions;
    };
    const handlePhoneNumberStartsWithBlur = ()=>{
        if (props.values.phoneNumberStartsWith[0] !== "1" && props.values.platform === (0, _phonePlatforms.PHONE_PLATFORMS).VONAGE) props.setFieldValue("phoneNumberStartsWith", 1 + props.values.phoneNumberStartsWith);
        props.handleBlur;
    };
    const handleCreateNewLocaleFromDropdown = (selectedLocale)=>{
        if (!localeConfigurations[selectedLocale]) handleCreateNewLocaleConfiguration(selectedLocale);
    };
    // Check if this feature should be available (existing number + multiple locales)
    const showCreateLocaleButton = !!props.selectedTelephonyDeployment?.phoneNumber && getLocaleOptions().length > 1;
    // Get available locales that don't have configurations yet
    const getAvailableLocalesForNewConfig = ()=>{
        const allLocales = getLocaleOptions();
        return allLocales.filter((locale)=>!localeConfigurations[locale.value]);
    };
    const getLocalesToShowAsTabs = ()=>{
        if (props.selectedPhoneNumberDeployments && props.selectedPhoneNumberDeployments.length > 1) return props.selectedPhoneNumberDeployments.map((d)=>d.locale);
        else return Object.keys(localeConfigurations);
    };
    const usingCustomVoice = props.values.ttsOptions[0].ttsProvider !== "Google" || props.values.ttsOptions[0].ttsVoice === "Custom" || !(0, _telephonyDeploymentFormFieldOptions.googleVoiceOptions).some((o)=>o.value === props.values.ttsOptions[0].ttsProvider);
    return (0, _react.jsx)((0, _modalLayoutDefault.default), {
        isVisible: true
    }, !props.selectedTelephonyDeployment?.phoneNumber ? (0, _react.jsx)((0, _modalHeaderDefault.default), {
        title: "Configure a Phone Number",
        onClose: ()=>props.closeTelephonyRequestForm(),
        rightText: props.values.platform || (0, _phonePlatforms.PHONE_PLATFORMS).VONAGE,
        rightTextClassName: platformTextStyle
    }) : (0, _react.jsx)(HeaderContainer, null, (0, _react.jsx)((0, _modalHeaderDefault.default), {
        title: `Configure ${(0, _applicationItem.formatPhoneNumber)(props.selectedTelephonyDeployment.phoneNumber, !!props.selectedTelephonyDeployment?.virtualNumber?.length)}`,
        onClose: ()=>props.closeTelephonyRequestForm(),
        rightText: props.selectedTelephonyDeployment.platform || props.values.platform || (0, _phonePlatforms.PHONE_PLATFORMS).VONAGE,
        rightTextClassName: platformTextStyle
    })), (Object.keys(localeConfigurations).length > 1 || props.selectedPhoneNumberDeployments && props.selectedPhoneNumberDeployments.length > 1) && (0, _react.jsx)(LocaleTabsContainer, null, getLocalesToShowAsTabs().map((locale)=>(0, _react.jsx)("div", {
            key: locale,
            style: {
                display: "flex",
                alignItems: "center"
            }
        }, (0, _react.jsx)(LocaleTab, {
            type: "button",
            isActive: activeLocale === locale,
            isLoading: switchingToLocale === locale,
            disabled: switchingToLocale !== null,
            onClick: ()=>handleLocaleTabChange(locale)
        }, switchingToLocale === locale ? "Loading..." : locale), getLocalesToShowAsTabs().length > 1 && !(props.selectedPhoneNumberDeployments && props.selectedPhoneNumberDeployments.some((d)=>d.locale === locale)) && (0, _react.jsx)(RemoveLocaleButton, {
            type: "button",
            onClick: ()=>{
                const newConfigurations = {
                    ...localeConfigurations
                };
                delete newConfigurations[locale];
                setLocaleConfigurations(newConfigurations);
                // Switch to the first available locale if current one is deleted
                if (activeLocale === locale) {
                    const remainingLocales = getLocalesToShowAsTabs().filter((l)=>l !== locale);
                    if (remainingLocales.length > 0) {
                        const newActiveLocale = remainingLocales[0];
                        setActiveLocale(newActiveLocale);
                        const targetConfig = localeConfigurations[newActiveLocale] || newConfigurations[newActiveLocale];
                        if (targetConfig) Object.keys(targetConfig).forEach((key)=>{
                            props.setFieldValue(key, targetConfig[key]);
                        });
                    }
                }
            },
            title: "Remove this locale configuration"
        }, "\xd7")))), (0, _react.jsx)("form", {
        onSubmit: (e)=>{
            // Save current form values to current locale before submission
            setLocaleConfigurations((prev)=>({
                    ...prev,
                    [activeLocale]: {
                        ...props.values
                    }
                }));
            // Use multi-locale submit if:
            // 1. There are multiple locale configurations, OR
            // 2. There are multiple existing deployments, OR  
            // 3. Multiple locales have been modified
            const shouldUseMultiLocaleSubmit = Object.keys(localeConfigurations).length > 1 || props.selectedPhoneNumberDeployments && props.selectedPhoneNumberDeployments.length > 1 || modifiedLocales.size > 1;
            if (shouldUseMultiLocaleSubmit) {
                e.preventDefault();
                handleMultiLocaleSubmit();
            } else props.handleSubmit(e);
        }
    }, (0, _react.jsx)((0, _customScrollbarsDefault.default), {
        autoHide: true,
        autoHeight: true,
        autoHeightMax: windowSize.windowSize.innerHeight * .9 - MODAL_SCROLLBAR_SUBTRACTION
    }, (0, _react.jsx)(ContentWrapper, null, (0, _react.jsx)(SectionCard, null, (0, _react.jsx)(SectionTitle, null, "Basic Configuration"), (0, _react.jsx)(NameTextField, {
        name: "name",
        value: props.values.name,
        label: "Name",
        placeholder: "Enter a name for this telephony deployment here",
        onChange: handleFormChange,
        fieldContainerStyle: fieldContainerStyle
    }), (0, _react.jsx)(RadioGroupLabel, null, "Track Analytics"), (0, _react.jsx)(CustomRadioGroup, {
        checkContainerStyle: checkContainerStyle,
        selectedOptionStyle: selectedOptionStyle,
        onChange: (e)=>handleOnChange("noTracking", e.value),
        value: props.values.noTracking,
        options: (0, _telephonyDeploymentFormFieldOptions.noTrackingOptions)
    }), (0, _react.jsx)(RecordCallsRadioGroupLabel, null, "Record Calls"), (0, _react.jsx)(CustomRadioGroup, {
        checkContainerStyle: checkContainerStyle,
        selectedOptionStyle: selectedOptionStyle,
        onChange: (e)=>handleOnChange("callRecordingEnabled", e.value),
        value: props.values.callRecordingEnabled,
        options: (0, _telephonyDeploymentFormFieldOptions.callRecordingOptions)
    }), (0, _react.jsx)(RecordCallsRadioGroupLabel, null, "Clean JSON and Markdown from Responses"), (0, _react.jsx)(CustomRadioGroup, {
        checkContainerStyle: checkContainerStyle,
        selectedOptionStyle: selectedOptionStyle,
        onChange: (e)=>handleOnChange("disableAssistantSpeechCleaning", e.value),
        value: props.values.disableAssistantSpeechCleaning,
        options: (0, _telephonyDeploymentFormFieldOptions.SpeechCleaningOptions)
    })), !props.selectedTelephonyDeployment?.phoneNumber && (0, _react.jsx)(SectionCard, null, (0, _react.jsx)(SectionTitle, null, "Phone Number Configuration"), (0, _react.jsx)(RadioGroupLabel, null, "Phone Number Type"), (0, _react.jsx)(CustomRadioGroup, {
        checkContainerStyle: checkContainerStyle,
        selectedOptionStyle: selectedOptionStyle,
        onChange: (e)=>handleOnChange("useVirtualNumber", e.value),
        value: props.values.useVirtualNumber,
        options: (0, _telephonyDeploymentFormFieldOptions.virtualNumberOptions)
    }), (0, _react.jsx)(RadioGroupLabel, null, "Phone Platform"), (0, _react.jsx)(CustomRadioGroup, {
        checkContainerStyle: checkContainerStyle,
        selectedOptionStyle: selectedOptionStyle,
        onChange: (e)=>handleOnChange("platform", e.value),
        value: props.values.platform ?? (0, _phonePlatforms.PHONE_PLATFORMS).VONAGE,
        options: [
            {
                label: "Vonage",
                value: (0, _phonePlatforms.PHONE_PLATFORMS).VONAGE
            },
            {
                label: "Telnyx",
                value: (0, _phonePlatforms.PHONE_PLATFORMS).TELNYX
            }
        ]
    }), !props.values.useVirtualNumber && (0, _react.jsx)((0, _reactDefault.default).Fragment, null, (0, _react.jsx)(Label, null, "Preferred Country Code and Area Code"), (0, _react.jsx)(PhoneNumberRow, null, (0, _react.jsx)(CountryDropdownWrapper, null, (0, _react.jsx)(CustomDropdown, {
        handleOnChange: handleCountryChange,
        fieldName: "country",
        options: countryOptions,
        size: "medium",
        value: props.values.country || "US"
    })), (0, _react.jsx)(PhoneNumberWrapper, null, (0, _react.jsx)(CustomTextField, {
        name: "phoneNumberStartsWith",
        value: props.values.phoneNumberStartsWith,
        placeholder: "Enter your preferred country code and area code here e.g. 1508",
        onChange: handleFormChange,
        onBlur: handlePhoneNumberStartsWithBlur,
        fieldContainerStyle: fieldContainerStyle
    })))), props.values.useVirtualNumber && (0, _react.jsx)(CustomTextField, {
        name: "virtualNumber",
        value: props.values.virtualNumber,
        label: !props.selectedTelephonyDeployment?.phoneNumber?.length ? "Enter virtual number (Leave blank to generate)" : "Enter updated virtual number",
        placeholder: "Enter your preferred unique 6-12 digit virtual number here",
        onChange: handleFormChange,
        fieldContainerStyle: fieldContainerStyle
    })), (0, _react.jsx)(SectionCard, null, (0, _react.jsx)(SectionTitle, null, "Voice & Language Settings"), (0, _react.jsx)(LabelWrapper, null, (0, _react.jsx)(Label, null, "Add Preloaded Voices")), (0, _react.jsx)(AddPreloadedVoicesDropdown, {
        handleOnChange: handleVoiceDropdownChange,
        fieldName: "ttsVoice",
        options: (0, _voiceOptions.voiceOptions),
        size: "medium",
        searchable: true,
        placeholder: "Select a voice to add",
        className: dropDownStyleMedium,
        value: usingCustomVoice ? "Custom" : props.values.ttsOptions[0][1]
    }), usingCustomVoice && (0, _react.jsx)((0, _reactDefault.default).Fragment, null, props.values.ttsOptions.map((option, index)=>(0, _react.jsx)(CustomVoiceRow, {
            key: index
        }, (0, _react.jsx)(CustomVoiceRowLeft, {
            name: `ttsOptions[${index}].ttsProvider`,
            value: option.ttsProvider,
            label: "TTS Provider",
            labelStyle: labelStyle,
            placeholder: "Enter your TTS provider here",
            onChange: (e)=>handleTtsOptionChange(index, "ttsProvider", e.target.value),
            fieldContainerStyle: fieldContainerStyle
        }), (0, _react.jsx)(CustomVoiceRowRight, {
            name: `ttsOptions[${index}].ttsVoice`,
            value: option.ttsVoice,
            label: "Voice",
            labelStyle: labelStyle,
            placeholder: option.ttsProvider?.toLowerCase() === "elevenlabs" ? (0, _voices.defaultVoice) : option.ttsProvider?.toLowerCase() === "rime" ? (0, _voices.defaultRimeVoice) : "",
            onChange: (e)=>handleTtsOptionChange(index, "ttsVoice", e.target.value),
            fieldContainerStyle: fieldContainerStyle
        }), props.values.ttsOptions.length > 1 && (0, _react.jsx)(RemoveButton, {
            type: "button",
            onClick: ()=>{
                const updatedOptions = props.values.ttsOptions.filter((_, i)=>i !== index);
                props.setFieldValue("ttsOptions", updatedOptions);
            },
            style: {
                marginLeft: "8px"
            }
        }, "-"))), (0, _react.jsx)(AddVoiceWrapper, null, (0, _react.jsx)(AddButton, {
        type: "button",
        onClick: ()=>{
            const newOption = {};
            props.setFieldValue("ttsOptions", [
                ...props.values.ttsOptions,
                newOption
            ]);
        }
    }, "+ Add Another Voice"))), (0, _react.jsx)(LabelWrapper, null, (0, _react.jsx)(Label, null, "Locale")), getLocaleOptions().length > 1 ? (0, _react.jsx)(CustomDropdown, {
        handleOnChange: handleOnChange,
        fieldName: "locale",
        options: getLocaleOptions(),
        size: "medium",
        className: dropDownStyleMedium,
        value: props.values.locale
    }) : (0, _react.jsx)(CustomDropdown, {
        handleOnChange: handleOnChange,
        fieldName: "locale",
        options: [
            {
                label: "en-US",
                value: "en-US"
            }
        ],
        size: "medium",
        className: dropDownStyleMedium,
        value: props.values.locale
    }), showCreateLocaleButton && getAvailableLocalesForNewConfig().length > 0 && (0, _react.jsx)((0, _reactDefault.default).Fragment, null, (0, _react.jsx)(LabelWrapper, null, (0, _react.jsx)(Label, null, "Locale Configuration")), (0, _react.jsx)(CustomDropdown, {
        handleOnChange: (fieldName, value)=>handleCreateNewLocaleFromDropdown(value),
        fieldName: "newLocale",
        options: getAvailableLocalesForNewConfig(),
        value: "",
        placeholder: "Select a locale to create configuration",
        size: "medium",
        className: dropDownStyleMedium
    }))), (0, _react.jsx)(SectionCard, null, (0, _react.jsx)(SectionTitle, null, "Timing & Delay Settings"), (0, _react.jsx)(CustomTextField, {
        name: "firstMessageDelayMS",
        disabled: false,
        tooltip: "Number in milliseconds before the first assistant message is played",
        tooltipStyle: tooltipStyle,
        toolTipPosition: "right",
        value: props.values.firstMessageDelayMS,
        label: "First Message Delay (Milliseconds)",
        placeholder: "Enter a number in miliseconds here",
        onChange: handleFormChange,
        onBlur: props.handleBlur,
        fieldContainerStyle: fieldContainerStyle
    }), (0, _react.jsx)(CustomTextField, {
        name: "asrEndpointing",
        tooltip: "Number in milliseconds between when the caller is done talking and Voicify starts processing input",
        tooltipStyle: tooltipStyle,
        toolTipPosition: "right",
        disabled: false,
        value: props.values.asrEndpointing,
        label: "ASR Endpointing (Milliseconds)",
        type: "number",
        placeholder: "Enter a number in miliseconds here",
        onChange: handleFormChange,
        onBlur: props.handleBlur,
        fieldContainerStyle: fieldContainerStyle
    })), (0, _react.jsx)(SectionCard, null, (0, _react.jsx)(SectionTitle, null, "Barge-In Settings"), (0, _react.jsx)(RadioGroupLabel, null, "Use Barge In"), (0, _react.jsx)(CustomRadioGroup, {
        checkContainerStyle: checkContainerStyle,
        selectedOptionStyle: selectedOptionStyle,
        onChange: (e)=>handleOnChange("disableBargeIn", e.value),
        value: props.values.disableBargeIn,
        options: (0, _telephonyDeploymentFormFieldOptions.disableBargeInOptions)
    }), !props.values.disableBargeIn && (0, _react.jsx)((0, _reactDefault.default).Fragment, null, (0, _react.jsx)(AllowWelcomeMessageBargeInLabel, null, "Allow Welcome Message Barge In"), (0, _react.jsx)(CustomRadioGroup, {
        checkContainerStyle: checkContainerStyle,
        selectedOptionStyle: selectedOptionStyle,
        onChange: (e)=>handleOnChange("disableWelcomeMessageBargeIn", e.value),
        value: props.values.disableWelcomeMessageBargeIn,
        options: (0, _telephonyDeploymentFormFieldOptions.disableWelcomeMessageBargeInOptions)
    }), (0, _react.jsx)(MergeTurnsAfterPausesLabel, null, "Merge Turns After Pauses"), (0, _react.jsx)(CustomRadioGroup, {
        checkContainerStyle: checkContainerStyle,
        selectedOptionStyle: selectedOptionStyle,
        onChange: (e)=>handleOnChange("mergeTurnsAfterPauses", e.value),
        value: props.values.mergeTurnsAfterPauses,
        options: (0, _telephonyDeploymentFormFieldOptions.mergeTurnsAfterPausesOptions)
    }), (0, _react.jsx)(MergeTurnTimeoutTextField, {
        tooltip: "The maximum duration of pause between caller utterances that qualifies them as a single utterance",
        tooltipStyle: tooltipStyle,
        toolTipPosition: "right",
        name: "mergeTurnTimeoutMS",
        type: "number",
        disabled: false,
        value: props.values.mergeTurnTimeoutMS,
        label: "Merge Turn Timeout (Milliseconds)",
        placeholder: "Enter a number in miliseconds here",
        onChange: handleFormChange,
        onBlur: props.handleBlur,
        fieldContainerStyle: fieldContainerStyle
    }), (0, _react.jsx)(RadioGroupLabel, null, "Use Speech Started Event"), (0, _react.jsx)(CustomRadioGroup, {
        checkContainerStyle: checkContainerStyle,
        selectedOptionStyle: selectedOptionStyle,
        onChange: (e)=>handleOnChange("disableSpeechStarted", e.value),
        value: props.values.disableSpeechStarted,
        options: (0, _telephonyDeploymentFormFieldOptions.disableSpeechStartedOptions)
    }), !props.values.disableSpeechStarted && (0, _react.jsx)((0, _reactDefault.default).Fragment, null, (0, _react.jsx)(SpeechStartedLevelTextField, {
        tooltip: "The confidence level at which the assistant will consider the user to be speaking. 0.0 is silence, 1.0 is full volume/confidence, 0.9 is the default.",
        tooltipStyle: tooltipStyle,
        toolTipPosition: "right",
        name: "speechStartedLevel",
        type: "number",
        disabled: false,
        value: props.values.speechStartedLevel,
        label: "Speech Started Level",
        placeholder: "Enter a number from 0.0 to 1 here",
        onChange: handleFormChange,
        onBlur: props.handleBlur,
        fieldContainerStyle: fieldContainerStyle
    }), (0, _react.jsx)(CustomTextField, {
        tooltip: "The time in milliseconds that the assistant will pause after a speech started event.",
        tooltipStyle: tooltipStyle,
        toolTipPosition: "right",
        name: "speechStartedPauseMS",
        type: "number",
        disabled: false,
        value: props.values.speechStartedPauseMS,
        label: "Speech Started Pause Milliseconds",
        placeholder: "Enter a number in MS here",
        onChange: handleFormChange,
        onBlur: props.handleBlur,
        fieldContainerStyle: fieldContainerStyle
    }), (0, _react.jsx)(CustomTextField, {
        tooltip: "The maximum number of uncomfirmed speech started events during an assistant utterance before speech started is turned off",
        tooltipStyle: tooltipStyle,
        toolTipPosition: "right",
        name: "speechStartedUnconfirmedBargeInLimit",
        type: "number",
        disabled: false,
        value: props.values.speechStartedUnconfirmedBargeInLimit,
        label: "Unconfirmed Speech Started Event Limit",
        placeholder: "Enter a number here",
        onChange: handleFormChange,
        onBlur: props.handleBlur,
        fieldContainerStyle: fieldContainerStyle
    }), (0, _react.jsx)(CustomTextField, {
        tooltip: 'The number of consecutive "speaking" audio buffers before speech started event is fired.',
        tooltipStyle: tooltipStyle,
        toolTipPosition: "right",
        name: "speechStartedRequiredBufferCount",
        type: "number",
        disabled: false,
        value: props.values.speechStartedRequiredBufferCount,
        label: "Speech Started Required Audio Buffer Count",
        placeholder: "Enter a number here",
        onChange: handleFormChange,
        onBlur: props.handleBlur,
        fieldContainerStyle: fieldContainerStyle
    })))), (0, _react.jsx)(SectionCard, null, (0, _react.jsx)(SectionTitle, null, "Proactive Response Settings"), (0, _react.jsx)(RadioGroupLabel, null, "Use Proactive Responses"), (0, _react.jsx)(CustomRadioGroup, {
        checkContainerStyle: checkContainerStyle,
        selectedOptionStyle: selectedOptionStyle,
        onChange: (e)=>handleOnChange("useProactiveResponses", e.value),
        value: props.values.useProactiveResponses,
        options: (0, _telephonyDeploymentFormFieldOptions.useProactiveOptions)
    }), props.values.useProactiveResponses && (0, _react.jsx)((0, _reactDefault.default).Fragment, null, (0, _react.jsx)(UseGenerativeProactiveResponsesLabel, null, "Use Generative Proactive Responses"), (0, _react.jsx)(CustomRadioGroup, {
        checkContainerStyle: checkContainerStyle,
        selectedOptionStyle: selectedOptionStyle,
        onChange: (e)=>handleGenerativeProactiveResponseChange("useGenerativeProactiveResponse", e.value),
        value: props.values.useGenerativeProactiveResponse,
        options: (0, _telephonyDeploymentFormFieldOptions.useGenerativeProactiveOptions)
    }), (0, _react.jsx)(ProactiveResponseDelayTextField, {
        name: "proactiveResponseDelayMS",
        disabled: false,
        tooltip: "How long an assistant is taking before it gives a proactive response",
        tooltipStyle: tooltipStyle,
        toolTipPosition: "right",
        type: "number",
        value: props.values.proactiveResponseDelayMS,
        label: "Proactive Response Delay (Milliseconds)",
        placeholder: "Enter a number in miliseconds here",
        onChange: handleFormChange,
        onBlur: props.handleBlur,
        fieldContainerStyle: fieldContainerStyle
    }), (0, _react.jsx)(CustomTextField, {
        name: "postProactiveResponsePauseDelayMS",
        disabled: false,
        tooltip: "How long an assistant pauses after giving a proactive response before giving the next response if ready.",
        tooltipStyle: tooltipStyle,
        toolTipPosition: "right",
        type: "number",
        value: props.values.postProactiveResponsePauseDelayMS,
        label: "Post Proactive Response Delay (Milliseconds)",
        placeholder: "Enter a number in miliseconds here",
        onChange: handleFormChange,
        onBlur: props.handleBlur,
        fieldContainerStyle: fieldContainerStyle
    }), (0, _react.jsx)(CustomTextField, {
        name: "proactiveResponses",
        tooltip: "Each time a proactive response is returned it will be randomly selected from this list.",
        tooltipStyle: tooltipStyle,
        toolTipPosition: "right",
        disabled: false,
        value: props.values.proactiveResponses,
        label: "Proactive responses",
        placeholder: 'Enter the proactive responses you want to use divided by a "|" here.',
        onChange: handleFormChange,
        onBlur: props.handleBlur,
        fieldContainerStyle: fieldContainerStyle
    }), (0, _react.jsx)(CustomTextField, {
        name: "maxProactiveResponseAttempts",
        tooltip: "Maximum number of times the assistant will give a proactive response for a single turn of the conversation.",
        tooltipStyle: tooltipStyle,
        toolTipPosition: "right",
        disabled: false,
        value: props.values.maxProactiveResponseAttempts,
        label: "Maximum Proactive Response Attempts",
        placeholder: "1",
        type: "number",
        validate: (value)=>{
            if (value < 1) return "Value must be 1 or greater";
        },
        onChange: (e)=>{
            const value = parseInt(e.target.value);
            if (!isNaN(value) && value >= 1) handleFormChange(e);
        },
        onBlur: props.handleBlur,
        fieldContainerStyle: fieldContainerStyle
    }), props.values.maxProactiveResponseAttempts > 1 && (0, _react.jsx)((0, _reactDefault.default).Fragment, null, (0, _react.jsx)(CustomTextField, {
        name: "followUpProactiveResponses",
        tooltip: "After the first proactive response, if the assistant is still waiting, it will use a follow-up response from this list.",
        tooltipStyle: tooltipStyle,
        toolTipPosition: "right",
        disabled: false,
        value: props.values.followUpProactiveResponses,
        label: "Follow-up Proactive Responses",
        placeholder: 'Enter the follow-up proactive responses divided by a "|" here.',
        onChange: handleFormChange,
        onBlur: props.handleBlur,
        fieldContainerStyle: fieldContainerStyle
    }), (0, _react.jsx)(CustomTextField, {
        name: "followUpProactiveResponsesDelayMS",
        tooltip: "Delay between the follow up proactive responses",
        tooltipStyle: tooltipStyle,
        toolTipPosition: "right",
        disabled: false,
        value: props.values.followUpProactiveResponsesDelayMS,
        label: "Follow-up Proactive Responses Delay (Milliseconds)",
        placeholder: "8000",
        onChange: handleFormChange,
        onBlur: props.handleBlur,
        fieldContainerStyle: fieldContainerStyle
    })), (0, _react.jsx)(ProactiveResponsePromptTextAreaField, {
        name: "generativeProactiveResponsePrompt",
        tooltip: "Prompting for the genai proactive responses",
        disabled: false,
        value: props.values.generativeProactiveResponsePrompt,
        label: "Proactive Response Prompt",
        placeholder: "Enter prompting to generate proactive responses (if left blank will use default from the backend)",
        onChange: handleFormChange,
        onBlur: props.handleBlur
    }), (0, _react.jsx)(CustomTextField, {
        name: "lastProactiveResponsesToDisallow",
        tooltip: "Maximum number turns before we allow a proactive response to be repeated.",
        tooltipStyle: tooltipStyle,
        toolTipPosition: "right",
        disabled: false,
        value: props.values.lastProactiveResponsesToDisallow,
        label: "Last Proactive Responses to Disallow",
        placeholder: "6",
        type: "number",
        onChange: (e)=>{
            const value = parseInt(e.target.value);
            if (!isNaN(value) && value >= 0) handleFormChange(e);
        },
        onBlur: props.handleBlur,
        fieldContainerStyle: fieldContainerStyle
    }))), (0, _react.jsx)(SectionCard, null, (0, _react.jsx)(SectionTitle, null, "Reprompt Settings"), (0, _react.jsx)(CustomTextField, {
        name: "repromptAttempts",
        tooltip: "Max number of times the assistant will reprompt before hanging up",
        tooltipStyle: tooltipStyle,
        toolTipPosition: "right",
        disabled: false,
        value: props.values.repromptAttempts,
        label: "Reprompt Attempts",
        placeholder: "Enter the max number of reprompts here",
        onChange: handleFormChange,
        onBlur: props.handleBlur,
        fieldContainerStyle: fieldContainerStyle
    }), (0, _react.jsx)(CustomTextField, {
        name: "repromptDelaySeconds",
        tooltip: "Number of seconds of caller silence before the assistant reprompts",
        tooltipStyle: tooltipStyle,
        toolTipPosition: "right",
        disabled: false,
        value: props.values.repromptDelaySeconds,
        label: "Reprompt Delay (Seconds)",
        placeholder: "Enter the number of seconds between reprompts here",
        onChange: handleFormChange,
        onBlur: props.handleBlur,
        fieldContainerStyle: fieldContainerStyle
    })), (0, _react.jsx)(SectionCard, null, (0, _react.jsx)(SectionTitle, null, "Spam Filter Settings"), (0, _react.jsx)(RadioGroupLabel, null, "Use Spam Filter"), (0, _react.jsx)(CustomRadioGroup, {
        checkContainerStyle: checkContainerStyle,
        selectedOptionStyle: selectedOptionStyle,
        onChange: (e)=>handleOnChange("disableSpamDetection", e.value),
        value: props.values.disableSpamDetection,
        options: (0, _telephonyDeploymentFormFieldOptions.disableSpamFilterOptions)
    }), !props.values.disableSpamDetection && (0, _react.jsx)("div", null, (0, _react.jsx)(CustomTextField, {
        name: "spamDetectionPromptOverride",
        type: "text",
        value: props.values.spamDetectionPromptOverride,
        label: "Spam Detection Prompt (there is a default, use this to overrride)",
        onChange: handleFormChange
    }), (0, _react.jsx)(CustomTextField, {
        name: "spamDetectionTolerance",
        tooltip: "Minimum predicted probability to flag a call as spam",
        tooltipStyle: tooltipStyle,
        toolTipPosition: "right",
        disabled: false,
        value: props.values.spamDetectionTolerance < 0 ? 0.999 : props.values.spamDetectionTolerance,
        label: "Spam Detection Tolerance",
        placeholder: "Enter a number between 0.981 to 1 (Anything below 0.981 runs a false positive risk. Leave blank for default 0.999)",
        onChange: handleFormChange,
        onBlur: props.handleBlur,
        fieldContainerStyle: fieldContainerStyle
    }), (0, _react.jsx)(CustomTextField, {
        name: "spamDetectionTemperature",
        toolTipPosition: "right",
        disabled: false,
        value: props.values.spamDetectionTemperature < 0 ? 0.1 : props.values.spamDetectionTemperature,
        label: "Spam Detection Temperature",
        placeholder: "Enter a number between 0 and 1 (Leave blank for default 0.1)",
        onChange: handleFormChange,
        onBlur: props.handleBlur,
        fieldContainerStyle: fieldContainerStyle
    }), (0, _react.jsx)(CustomTextField, {
        name: "spamDetectionGenAiProvider",
        type: "text",
        value: props.values.spamDetectionGenAiProvider,
        label: "Spam Detection GenAI model (defaults to 4o-mini)",
        onChange: handleFormChange
    }))), (0, _react.jsx)(SectionCard, null, (0, _react.jsx)(SectionTitle, null, "Transfer Settings"), (0, _react.jsx)(CustomTextField, {
        tooltip: "Default phone number to transfer to. 12223334444 format (11 digits with leading 1)",
        tooltipStyle: tooltipStyle,
        toolTipPosition: "right",
        name: "initialTransferTarget",
        disabled: false,
        value: props.values.initialTransferTarget,
        label: "Default Transfer Phone Number",
        placeholder: "Enter a phone number here in format 12223334444",
        onChange: handleFormChange,
        onBlur: props.handleBlur,
        fieldContainerStyle: fieldContainerStyle
    }), (0, _react.jsx)(AttemptInitialTransferRadioGroupLabel, null, "Attempt Initial Transfer with Assistant as Backup"), (0, _react.jsx)(CustomRadioGroup, {
        checkContainerStyle: checkContainerStyle,
        selectedOptionStyle: selectedOptionStyle,
        onChange: (e)=>handleOnChange("attemptInitialTransfer", e.value),
        value: props.values.attemptInitialTransfer,
        options: (0, _telephonyDeploymentFormFieldOptions.attemptInitialTransferOptions)
    }), props.values.attemptInitialTransfer && (0, _react.jsx)((0, _reactDefault.default).Fragment, null, (0, _react.jsx)(CustomTextField, {
        tooltip: "The time in seconds that the phone will ring at the store before the assistant answers",
        tooltipStyle: tooltipStyle,
        toolTipPosition: "right",
        name: "initialTransferTimeoutSeconds",
        type: "number",
        disabled: false,
        value: props.values.initialTransferTimeoutSeconds,
        label: "Initial transfer ring time",
        placeholder: "Enter a number in seconds here",
        onChange: handleFormChange,
        onBlur: props.handleBlur,
        fieldContainerStyle: fieldContainerStyle
    }), (0, _react.jsx)(RadioGroupLabel, null, "Perform Initial Transfer with Calling Number Instead of Called Number"), (0, _react.jsx)(CustomRadioGroup, {
        checkContainerStyle: checkContainerStyle,
        selectedOptionStyle: selectedOptionStyle,
        onChange: (e)=>handleOnChange("initialTransferWithCallingNumber", e.value),
        value: props.values.initialTransferWithCallingNumber,
        options: (0, _telephonyDeploymentFormFieldOptions.initialTransferWithCallingNumberOptions)
    })), (0, _react.jsx)(RadioGroupLabel, null, "Auto-Transfer Previously Immediately Transferred Users"), (0, _react.jsx)(CustomRadioGroup, {
        checkContainerStyle: checkContainerStyle,
        selectedOptionStyle: selectedOptionStyle,
        onChange: (e)=>{
            handleOnChange("autoTransferPreviouslyTransferred", e.value);
            if (e.value && (props.values.immediateTransferHourCutoff == null || props.values.immediateTransferHourCutoff === undefined)) handleOnChange("immediateTransferHourCutoff", (0, _defaultTelephonyDeploymentSettings.defaultTelephonyDeploymentSettings).immediateTransferHourCutoff);
        },
        value: props.values.autoTransferPreviouslyTransferred,
        options: (0, _telephonyDeploymentFormFieldOptions.autoTransferPreviouslyTransferredOptions)
    }), props.values.autoTransferPreviouslyTransferred && (0, _react.jsx)(CustomTextField, {
        tooltip: "If a user has been previously immediately transferred and calls back, this is the number of hours between the previous transfer and the current call that will be used to determine if the user should be automtically transferred again.",
        tooltipStyle: tooltipStyle,
        toolTipPosition: "right",
        name: "immediateTransferHourCutoff",
        type: "number",
        disabled: false,
        value: props.values.immediateTransferHourCutoff ?? (0, _defaultTelephonyDeploymentSettings.defaultTelephonyDeploymentSettings).immediateTransferHourCutoff,
        label: "Auto transfer previously immediately transferred users cutoff (hours)",
        placeholder: "Enter a number in hours here",
        onChange: handleFormChange,
        onBlur: props.handleBlur,
        fieldContainerStyle: fieldContainerStyle
    }), (0, _react.jsx)(CustomTextField, {
        tooltip: "Allow AI to talk to the customer again, if no one answered the phone after an immediate transfer",
        tooltipStyle: tooltipStyle,
        toolTipPosition: "right",
        name: "aiReengageSecondsAfterImmediateTransfer",
        disabled: false,
        type: "number",
        value: props.values.aiReengageSecondsAfterImmediateTransfer,
        label: "Reengage AI n Seconds After Immediate Transfer, If Target Unresponsive",
        placeholder: "Enter the threshold in seconds",
        onChange: handleFormChange,
        onBlur: props.handleBlur,
        fieldContainerStyle: fieldContainerStyle
    }), (0, _react.jsx)((0, _notificationEmailsManagerDefault.default), {
        value: props.values.notificationEmails,
        onChange: (value)=>handleNotificationEmailsChange(value),
        onBlur: ()=>props.handleBlur("notificationEmails"),
        fieldContainerStyle: fieldContainerStyle
    }), (0, _react.jsx)((0, _immediateTransferCallerNumbersManagerDefault.default), {
        value: props.values.immediateTransferCallerNumbers,
        onChange: (value)=>handleImmediateTransferCallerNumbersChange(value),
        onBlur: ()=>props.handleBlur("immediateTransferCallerNumbers")
    })), props.values.platform === (0, _phonePlatforms.PHONE_PLATFORMS).TELNYX && (0, _react.jsx)(SectionCard, null, (0, _react.jsx)(SectionTitle, null, "Outbound Calling"), (0, _react.jsx)(LabelWrapper, null, (0, _react.jsx)(RadioGroupLabel, null, "Use For Outbound Calling"), (0, _react.jsx)((0, _iconTooltipDefault.default), {
        text: 'If multiple phone numbers are configured for the application, the outbound calling assistant will use this phone number if set to "Yes"',
        place: "right",
        className: tooltipStyle
    })), (0, _react.jsx)(CustomRadioGroup, {
        checkContainerStyle: checkContainerStyle,
        selectedOptionStyle: selectedOptionStyle,
        onChange: (e)=>handleOnChange("useForOutboundCalling", e.value),
        value: props.values.useForOutboundCalling,
        options: (0, _telephonyDeploymentFormFieldOptions.useForOutboundCallingOptions)
    }), (0, _react.jsx)(CustomTextField, {
        tooltip: "The caller ID number that will be displayed to recipients when making outbound calls. Must be verified on Telnyx.",
        tooltipStyle: tooltipStyle,
        toolTipPosition: "right",
        name: "outboundCallerIdNumber",
        disabled: false,
        value: props.values.outboundCallerIdNumber,
        label: "Caller ID Number",
        placeholder: "Enter caller ID number (e.g., 12223334444)",
        onChange: handleFormChange,
        onBlur: props.handleBlur,
        fieldContainerStyle: fieldContainerStyle
    })), (0, _react.jsx)(SectionCard, null, (0, _react.jsx)(SectionTitle, null, "SMS"), (0, _react.jsx)(CustomTextField, {
        name: "optInText",
        disabled: false,
        value: props.values.optInText,
        label: "Opt In Text",
        placeholder: "Enter SMS opt-in text",
        onChange: handleFormChange,
        onBlur: props.handleBlur,
        fieldContainerStyle: fieldContainerStyle
    })), (0, _react.jsx)((0, _contentCollapsingSectionDefault.default), {
        title: "Advanced Settings",
        icon: advancedSettingsIcon,
        isCollapsedByDefault: true,
        className: collapsedSection
    }, (0, _react.jsx)(LabelWrapper, null, (0, _react.jsx)(Label, null, "ASR Provider")), (0, _react.jsx)(CustomDropdown, {
        handleOnChange: handleDropDownChange,
        fieldName: "asrProvider",
        options: (0, _defaultTelephonyDeploymentSettings.availableASRProviders).map((asr)=>({
                value: asr,
                label: asr
            })),
        size: "medium",
        className: dropDownStyleMedium,
        value: props.values.asrProvider
    }), (0, _react.jsx)(CustomTextField, {
        name: "asrModel",
        disabled: false,
        value: props.values.asrModel,
        label: "ASR Model",
        placeholder: "Type your preferred ASR model here",
        onChange: handleFormChange,
        onBlur: props.handleBlur,
        fieldContainerStyle: fieldContainerStyle
    }), (0, _react.jsx)(CustomTextField, {
        name: "asrTier",
        disabled: false,
        value: props.values.asrTier,
        label: "ASR Tier",
        placeholder: "Type your preferred ASR tier here",
        onChange: handleFormChange,
        onBlur: props.handleBlur,
        fieldContainerStyle: fieldContainerStyle
    }), (0, _react.jsx)(RadioGroupLabel, null, "Process Audio"), (0, _react.jsx)(CustomRadioGroup, {
        checkContainerStyle: checkContainerStyle,
        selectedOptionStyle: selectedOptionStyle,
        onChange: (e)=>handleOnChange("shouldProcessAudio", e.value),
        value: props.values.shouldProcessAudio,
        options: processAudioOptions
    }), (0, _react.jsx)(RadioGroupLabel, null, "On Welcome Reprompt Transfer or Recconnect"), (0, _react.jsx)(CustomRadioGroup, {
        checkContainerStyle: checkContainerStyle,
        selectedOptionStyle: selectedOptionStyle,
        onChange: (e)=>handleOnChange("tryWebsocketReconnectionOnWelcome", e.value),
        value: props.values.tryWebsocketReconnectionOnWelcome,
        options: (0, _telephonyDeploymentFormFieldOptions.tryWebsocketReconnectionOnWelcomeOptions)
    }), (0, _react.jsx)(CustomTextField, {
        name: "ttsPronunciationsMap",
        disabled: false,
        value: props.values.ttsPronunciationsMap,
        label: "TTS Pronunciations Map",
        placeholder: "example: {'pan': '{p11@n}'}, format: escaped json",
        onChange: handleFormChange,
        onBlur: props.handleBlur,
        fieldContainerStyle: fieldContainerStyle
    }), (0, _react.jsx)(CustomTextField, {
        name: "notificationEmails",
        disabled: false,
        value: props.values.notificationEmails,
        label: "Notification Emails",
        tooltip: "Comma separated email addresses that will receive notifications when someone calls this number - for monitoring.",
        tooltipStyle: tooltipStyle,
        toolTipPosition: "right",
        placeholder: "example: email1@voicify.com, email2@voicify.com",
        onChange: handleFormChange,
        onBlur: props.handleBlur,
        fieldContainerStyle: fieldContainerStyle
    }), (0, _react.jsx)(RadioGroupLabel, null, "Perform Language Detection"), (0, _react.jsx)(CustomRadioGroup, {
        checkContainerStyle: checkContainerStyle,
        selectedOptionStyle: selectedOptionStyle,
        onChange: (e)=>handleOnChange("performLanguageDetection", e.value),
        value: props.values.performLanguageDetection,
        options: [
            {
                label: "Yes",
                value: true
            },
            {
                label: "No",
                value: false
            }
        ]
    }), (0, _react.jsx)(CustomTextField, {
        name: "dtmfTurnsToListen",
        type: "number",
        tooltip: "Number of turns to listen for DTMF (dial tone) input. Set to 0 to disable.",
        tooltipStyle: tooltipStyle,
        toolTipPosition: "right",
        disabled: false,
        value: props.values.dtmfTurnsToListen,
        label: "DTMF Turns to Listen",
        placeholder: "Enter number of turns (0 to disable)",
        onChange: handleFormChange,
        onBlur: props.handleBlur,
        fieldContainerStyle: fieldContainerStyle
    })))), (0, _react.jsx)((0, _footerBarDefault.default), null, (0, _react.jsx)((0, _buttonDefault.default), {
        disabled: props.isSubmitting,
        loading: props.isSubmitting,
        type: "submit",
        themes: [
            "primary",
            "start"
        ],
        text: "Save & Close",
        onClick: (e)=>{
            // Debug form validation
            console.log("Form errors:", props.errors);
            console.log("Form values:", props.values);
            console.log("Form isValid:", props.isValid);
            // If there are errors, prevent default submission and show them
            if (!props.isValid) {
                e.preventDefault();
                console.error("Form has validation errors:", props.errors);
                return;
            }
        }
    }), (0, _react.jsx)((0, _buttonDefault.default), {
        disabled: props.isSubmitting,
        loading: props.isSubmitting,
        type: "button",
        themes: [
            "secondary",
            "end"
        ],
        text: "Cancel",
        onClick: ()=>props.closeTelephonyRequestForm()
    }))));
};
const customRadioGroupStyle = /*#__PURE__*/ (0, _css.css)({
    name: "1ykowef",
    styles: "margin-bottom:0"
});
const AddPreloadedVoicesDropdown = /*#__PURE__*/ (0, _baseDefault.default)((0, _styledDropdownDefault.default), {
    target: "e1ntwx1d32"
})({
    name: "gxr3sg",
    styles: "margin:0 0 32px 0"
});
const AddVoiceWrapper = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1ntwx1d31"
})({
    name: "19mh0x6",
    styles: "display:flex;align-items:center;justify-content:flex-end"
});
const RemoveButton = /*#__PURE__*/ (0, _baseDefault.default)("button", {
    target: "e1ntwx1d30"
})("background:none;border:none;color:", (0, _colors.color_text_link), ";font-size:24px;line-height:1;cursor:pointer;padding:0;margin-left:8px;&:hover{color:grey;}");
const AddButton = /*#__PURE__*/ (0, _baseDefault.default)("button", {
    target: "e1ntwx1d29"
})("background:none;border:none;color:", (0, _colors.color_text_link), ";font-size:14px;line-height:1;cursor:pointer;padding:0;margin:0 18px 24px 0;max-width:1000px;&:hover{color:darkgrey;}");
const collapsedSection = /*#__PURE__*/ (0, _css.css)({
    name: "2ju0hn",
    styles: "*.card-title-container{padding:24px 24px 24px 40px;h4{font-size:14px;}}"
});
const RadioGroupLabel = /*#__PURE__*/ (0, _baseDefault.default)("p", {
    target: "e1ntwx1d28"
})("font-weight:400;font-size:14px;color:", (0, _colors.color_shades_darkest), ";margin:0;");
const CustomRadioGroup = /*#__PURE__*/ (0, _baseDefault.default)((0, _radioGroupDefault.default), {
    target: "e1ntwx1d27"
})({
    name: "g40tsu",
    styles: "margin:0 0 26px 0"
});
const AttemptInitialTransferRadioGroupLabel = /*#__PURE__*/ (0, _baseDefault.default)(RadioGroupLabel, {
    target: "e1ntwx1d26"
})({
    name: "1d0nbku",
    styles: "margin-top:24px"
});
const RecordCallsRadioGroupLabel = /*#__PURE__*/ (0, _baseDefault.default)(RadioGroupLabel, {
    target: "e1ntwx1d25"
})({
    name: "1d0nbku",
    styles: "margin-top:24px"
});
const UseGenerativeProactiveResponsesLabel = /*#__PURE__*/ (0, _baseDefault.default)(RadioGroupLabel, {
    target: "e1ntwx1d24"
})({
    name: "1d0nbku",
    styles: "margin-top:24px"
});
const AllowWelcomeMessageBargeInLabel = /*#__PURE__*/ (0, _baseDefault.default)(RadioGroupLabel, {
    target: "e1ntwx1d23"
})({
    name: "1d0nbku",
    styles: "margin-top:24px"
});
const MergeTurnsAfterPausesLabel = /*#__PURE__*/ (0, _baseDefault.default)(RadioGroupLabel, {
    target: "e1ntwx1d22"
})({
    name: "1d0nbku",
    styles: "margin-top:24px"
});
const CustomDropdown = /*#__PURE__*/ (0, _baseDefault.default)((0, _styledDropdownDefault.default), {
    target: "e1ntwx1d21"
})({
    name: "m8031q",
    styles: "margin:0 0 24px 0"
});
const CustomTextField = /*#__PURE__*/ (0, _baseDefault.default)((0, _textFieldDefault.default), {
    target: "e1ntwx1d20"
})({
    name: "oulvf1",
    styles: "margin-bottom:0 0 26px 0;label{font-size:14px;}"
});
const ProactiveResponseDelayTextField = /*#__PURE__*/ (0, _baseDefault.default)(CustomTextField, {
    target: "e1ntwx1d19"
})({
    name: "1d0nbku",
    styles: "margin-top:24px"
});
const MergeTurnTimeoutTextField = /*#__PURE__*/ (0, _baseDefault.default)(CustomTextField, {
    target: "e1ntwx1d18"
})({
    name: "1d0nbku",
    styles: "margin-top:24px"
});
const SpeechStartedLevelTextField = /*#__PURE__*/ (0, _baseDefault.default)(CustomTextField, {
    target: "e1ntwx1d17"
})({
    name: "1d0nbku",
    styles: "margin-top:24px"
});
const NameTextField = /*#__PURE__*/ (0, _baseDefault.default)(CustomTextField, {
    target: "e1ntwx1d16"
})({
    name: "1fgdcyd",
    styles: "margin-bottom:24px"
});
const ProactiveResponsePromptTextAreaField = /*#__PURE__*/ (0, _baseDefault.default)((0, _textAreaFieldDefault.default), {
    target: "e1ntwx1d15"
})({
    name: "1d51iu7",
    styles: "margin:0 0 24px 0;label{font-size:14px;margin:0;font-weight:normal;}"
});
const LabelWrapper = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1ntwx1d14"
})({
    name: "ho1qnd",
    styles: "display:flex;flex-direction:row"
});
const Label = /*#__PURE__*/ (0, _baseDefault.default)("p", {
    target: "e1ntwx1d13"
})("font-weight:400;font-size:14px;color:", (0, _colors.color_shades_darkest), ";margin:0 0 8px 0px;");
const dropDownStyleMedium = /*#__PURE__*/ (0, _css.css)({
    name: "1s22u92",
    styles: "margin-bottom:32px"
});
const tooltipStyle = /*#__PURE__*/ (0, _css.css)({
    name: "1q4vxyr",
    styles: "margin-left:8px"
});
const labelStyle = /*#__PURE__*/ (0, _css.css)("font-weight:400;font-size:14px;color:", (0, _colors.color_shades_darkest), ";margin:0 0 4px 0px;", "");
const checkContainerStyle = /*#__PURE__*/ (0, _css.css)("width:20px;height:20px;border-radius:50%;background-color:#ffffff;border:", (0, _stylesValues.style_border_default), ";display:flex;align-items:center;justify-content:center;", "");
const selectedOptionStyle = /*#__PURE__*/ (0, _css.css)("width:10px;height:10px;border-radius:50%;background-image:", (0, _colors.color_gradients_green_shift), ";", "");
const fieldContainerStyle = /*#__PURE__*/ (0, _css.css)({
    name: "128tros",
    styles: "height:48px"
});
const ContentWrapper = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1ntwx1d12"
})({
    name: "rvgcwd",
    styles: "display:flex;flex-direction:column;margin:36px 36px 0 36px"
});
const CustomVoiceRow = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1ntwx1d11"
})({
    name: "jmw2ht",
    styles: "display:flex;flex-direction:row;height:85px;align-items:center;margin-top:14px"
});
const CustomVoiceRowLeft = /*#__PURE__*/ (0, _baseDefault.default)(CustomTextField, {
    target: "e1ntwx1d10"
})({
    name: "16mq4g3",
    styles: "margin-right:8px;label{margin-bottom:0px;}"
});
const CustomVoiceRowRight = /*#__PURE__*/ (0, _baseDefault.default)(CustomTextField, {
    target: "e1ntwx1d9"
})({
    name: "16dvlkr",
    styles: "margin-left:8px;label{margin-bottom:0px;}"
});
const PhoneNumberRow = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1ntwx1d8"
})({
    name: "qp2k0b",
    styles: "display:flex;align-items:flex-end;gap:8px"
});
const CountryDropdownWrapper = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1ntwx1d7"
})({
    name: "3mi6ey",
    styles: "flex:0 0 160px"
});
const PhoneNumberWrapper = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1ntwx1d6"
})({
    name: "82a6rk",
    styles: "flex:1"
});
const SectionCard = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1ntwx1d5"
})({
    name: "zql69n",
    styles: "margin-bottom:24px;padding:24px;border:1px solid #E5E5E5;border-radius:4px;background-color:#FFFFFF;box-shadow:0 2px 4px rgba(0, 0, 0, 0.05)"
});
const SectionTitle = /*#__PURE__*/ (0, _baseDefault.default)("h3", {
    target: "e1ntwx1d4"
})("font-size:16px;font-weight:600;color:", (0, _colors.color_shades_darkest), ";margin:0 0 24px 0;");
const platformTextStyle = /*#__PURE__*/ (0, _css.css)("display:flex;align-items:center;gap:8px;font-size:20px;color:", (0, _colors.color_shades_darkest), ";font-weight:500;margin-right:16px;img{width:24px;height:24px;}", "");
const HeaderContainer = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1ntwx1d3"
})({
    name: "bjn8wh",
    styles: "position:relative"
});
const LocaleTabsContainer = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1ntwx1d2"
})("display:flex;align-items:center;gap:8px;margin:16px 36px 0 36px;border-bottom:1px solid ", (0, _colors.color_shades_light), ";padding-bottom:8px;");
const LocaleTab = /*#__PURE__*/ (0, _baseDefault.default)("button", {
    target: "e1ntwx1d1"
})("padding:8px 16px;border:none;background:", (props)=>props.isActive ? (0, _colors.color_gradients_green_shift) : "transparent", ";color:", (props)=>props.isActive ? (0, _colors.color_defaults_white) : (0, _colors.color_shades_darkest), ";border-radius:4px;font-size:14px;font-weight:", (props)=>props.isActive ? "600" : "400", ";cursor:", (props)=>props.disabled ? "not-allowed" : "pointer", ";opacity:", (props)=>props.isLoading ? 0.7 : 1, ";transition:all 0.2s ease;&:hover{background:", (props)=>props.isActive ? (0, _colors.color_gradients_green_shift) : props.disabled ? "transparent" : (0, _colors.color_shades_lighter), ";}&:disabled{opacity:0.6;cursor:not-allowed;}");
const RemoveLocaleButton = /*#__PURE__*/ (0, _baseDefault.default)("button", {
    target: "e1ntwx1d0"
})("background:none;border:none;color:", (0, _colors.color_text_link), ";font-size:12px;margin-left:8px;cursor:pointer;&:hover{color:", (0, _colors.color_colors_decline), ";}");
exports.default = TelephonyDeployment;

},{"@emotion/styled/base":"lSuFu","@emotion/react":"djZKr","react":"6uln9","../../../../components/general/Button":"6ymxN","../../../../components/general/ModalHeader":"aUACx","../../../../components/structure/FooterBar":"bibRL","../../../../components/structure/ModalLayout":"b1cO3","../../../../constants/stylesValues":"dHVVv","../../../../constants/colors":"1p3OR","@emotion/css":"awUBr","../../../../hooks/UseWindowSize":"43j9z","../../../../components/structure/CustomScrollbars":"50vFq","../../../../components/forms/TextField":"7a7bh","../../../../components/forms/TextAreaField":"fE54C","../../../../components/general/IconTooltip":"3FODC","../customAssistantConfigurations/StyledDropdown":"hjrMo","../../../../components/forms/RadioGroup":"eiGrn","./TelephonyDeploymentFormFieldOptions":"1f0qg","../../../../components/structure/ContentCollapsingSection":"1CUms","../../../../../clients/spark/scenes/basicOrganizationApplications/components/ApplicationItem":"kQkdQ","../../../../constants/telephonyConstants.tsx/defaultTelephonyDeploymentSettings":"bs6Uz","../../../../constants/sparkConstants/voices":"3U9Ff","../../../../constants/sparkConstants/voiceOptions":"ghV4a","../../../../constants/phonePlatforms":"bZIQ4","./NotificationEmailsManager":"17yAi","./ImmediateTransferCallerNumbersManager":"lNgE9","../../../../hooks/TelephonyDeploymentContainer":"2qU7b","92360c9725af8eb3":"1PtXC","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1f0qg":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "noTrackingOptions", ()=>noTrackingOptions);
parcelHelpers.export(exports, "callRecordingOptions", ()=>callRecordingOptions);
parcelHelpers.export(exports, "SpeechCleaningOptions", ()=>SpeechCleaningOptions);
parcelHelpers.export(exports, "virtualNumberOptions", ()=>virtualNumberOptions);
parcelHelpers.export(exports, "disableBargeInOptions", ()=>disableBargeInOptions);
parcelHelpers.export(exports, "disableSpamFilterOptions", ()=>disableSpamFilterOptions);
parcelHelpers.export(exports, "disableSpeechStartedOptions", ()=>disableSpeechStartedOptions);
parcelHelpers.export(exports, "attemptInitialTransferOptions", ()=>attemptInitialTransferOptions);
parcelHelpers.export(exports, "autoTransferPreviouslyTransferredOptions", ()=>autoTransferPreviouslyTransferredOptions);
parcelHelpers.export(exports, "useForOutboundCallingOptions", ()=>useForOutboundCallingOptions);
parcelHelpers.export(exports, "generalYesNoOptions", ()=>generalYesNoOptions);
parcelHelpers.export(exports, "tryWebsocketReconnectionOnWelcomeOptions", ()=>tryWebsocketReconnectionOnWelcomeOptions);
parcelHelpers.export(exports, "initialTransferWithCallingNumberOptions", ()=>initialTransferWithCallingNumberOptions);
parcelHelpers.export(exports, "useProactiveOptions", ()=>useProactiveOptions);
parcelHelpers.export(exports, "useGenerativeProactiveOptions", ()=>useGenerativeProactiveOptions);
parcelHelpers.export(exports, "disableWelcomeMessageBargeInOptions", ()=>disableWelcomeMessageBargeInOptions);
parcelHelpers.export(exports, "mergeTurnsAfterPausesOptions", ()=>mergeTurnsAfterPausesOptions);
parcelHelpers.export(exports, "googleVoiceOptions", ()=>googleVoiceOptions);
const noTrackingOptions = [
    {
        label: "Track assistant usage",
        value: false
    },
    {
        label: "Don't track assistant usage",
        value: true
    }
];
const callRecordingOptions = [
    {
        label: "Call Recording Enabled",
        value: true
    },
    {
        label: "Call Recording Disabled",
        value: false
    }
];
const SpeechCleaningOptions = [
    {
        label: "Enable speech cleaning",
        value: false
    },
    {
        label: "Disable speech cleaning",
        value: true
    }
];
const virtualNumberOptions = [
    {
        label: "Use virtual number",
        value: true
    },
    {
        label: "Purchase real phone number",
        value: false
    }
];
const disableBargeInOptions = [
    {
        label: "Enable barge-in",
        value: false
    },
    {
        label: "Disable barge-in",
        value: true
    }
];
const disableSpamFilterOptions = [
    {
        label: "Enable spam filter",
        value: false
    },
    {
        label: "Disable spam filter",
        value: true
    }
];
const disableSpeechStartedOptions = [
    {
        label: "Enable speech started event",
        value: false
    },
    {
        label: "Disable speech started event",
        value: true
    }
];
const attemptInitialTransferOptions = [
    {
        label: "Do not try store first",
        value: false
    },
    {
        label: "Try store first",
        value: true
    }
];
const autoTransferPreviouslyTransferredOptions = [
    {
        label: "Yes",
        value: true
    },
    {
        label: "No",
        value: false
    }
];
const useForOutboundCallingOptions = [
    {
        label: "Yes",
        value: true
    },
    {
        label: "No",
        value: false
    }
];
const generalYesNoOptions = [
    {
        label: "Yes",
        value: true
    },
    {
        label: "No",
        value: false
    }
];
const tryWebsocketReconnectionOnWelcomeOptions = [
    {
        label: "Yes",
        value: true
    },
    {
        label: "No",
        value: false
    }
];
const initialTransferWithCallingNumberOptions = [
    {
        label: "Transfer with assistant number",
        value: false
    },
    {
        label: "Transfer with caller's number",
        value: true
    }
];
const useProactiveOptions = [
    {
        label: "Enable proactive responses",
        value: true
    },
    {
        label: "Disable proactive responses",
        value: false
    }
];
const useGenerativeProactiveOptions = [
    {
        label: "Enable generative proactive responses",
        value: true
    },
    {
        label: "Disable generative proactive responses",
        value: false
    }
];
const disableWelcomeMessageBargeInOptions = [
    {
        label: "Allow barge in during welcome message",
        value: false
    },
    {
        label: "Disallow barge in during welcome message",
        value: true
    }
];
const mergeTurnsAfterPausesOptions = [
    {
        label: "Merge turns after pauses",
        value: true
    },
    {
        label: "Don't merge turns after pauses",
        value: false
    }
];
const googleVoiceOptions = [
    {
        value: "Custom",
        label: "Custom"
    },
    {
        value: "af-ZA-Standard-A",
        label: "af-ZA-Standard-A"
    },
    {
        value: "ar-XA-Standard-A",
        label: "ar-XA-Standard-A"
    },
    {
        value: "ar-XA-Standard-B",
        label: "ar-XA-Standard-B"
    },
    {
        value: "ar-XA-Standard-C",
        label: "ar-XA-Standard-C"
    },
    {
        value: "ar-XA-Standard-D",
        label: "ar-XA-Standard-D"
    },
    {
        value: "ar-XA-Wavenet-A",
        label: "ar-XA-Wavenet-A"
    },
    {
        value: "ar-XA-Wavenet-B",
        label: "ar-XA-Wavenet-B"
    },
    {
        value: "ar-XA-Wavenet-C",
        label: "ar-XA-Wavenet-C"
    },
    {
        value: "ar-XA-Wavenet-D",
        label: "ar-XA-Wavenet-D"
    },
    {
        value: "bn-IN-Standard-A",
        label: "bn-IN-Standard-A"
    },
    {
        value: "bn-IN-Standard-B",
        label: "bn-IN-Standard-B"
    },
    {
        value: "bn-IN-Wavenet-A",
        label: "bn-IN-Wavenet-A"
    },
    {
        value: "bn-IN-Wavenet-B",
        label: "bn-IN-Wavenet-B"
    },
    {
        value: "bg-bg-Standard-A",
        label: "bg-bg-Standard-A"
    },
    {
        value: "ca-es-Standard-A",
        label: "ca-es-Standard-A"
    },
    {
        value: "yue-HK-Standard-A",
        label: "yue-HK-Standard-A"
    },
    {
        value: "yue-HK-Standard-B",
        label: "yue-HK-Standard-B"
    },
    {
        value: "yue-HK-Standard-C",
        label: "yue-HK-Standard-C"
    },
    {
        value: "yue-HK-Standard-D",
        label: "yue-HK-Standard-D"
    },
    {
        value: "cs-CZ-Standard-A",
        label: "cs-CZ-Standard-A"
    },
    {
        value: "cs-CZ-Wavenet-A",
        label: "cs-CZ-Wavenet-A"
    },
    {
        value: "da-DK-Standard-A",
        label: "da-DK-Standard-A"
    },
    {
        value: "da-DK-Standard-C",
        label: "da-DK-Standard-C"
    },
    {
        value: "da-DK-Standard-D",
        label: "da-DK-Standard-D"
    },
    {
        value: "da-DK-Standard-E",
        label: "da-DK-Standard-E"
    },
    {
        value: "da-DK-Wavenet-A",
        label: "da-DK-Wavenet-A"
    },
    {
        value: "da-DK-Wavenet-C",
        label: "da-DK-Wavenet-C"
    },
    {
        value: "da-DK-Wavenet-D",
        label: "da-DK-Wavenet-D"
    },
    {
        value: "da-DK-Wavenet-E",
        label: "da-DK-Wavenet-E"
    },
    {
        value: "nl-BE-Standard-A",
        label: "nl-BE-Standard-A"
    },
    {
        value: "nl-BE-Standard-B",
        label: "nl-BE-Standard-B"
    },
    {
        value: "nl-BE-Wavenet-A",
        label: "nl-BE-Wavenet-A"
    },
    {
        value: "nl-BE-Wavenet-B",
        label: "nl-BE-Wavenet-B"
    },
    {
        value: "nl-NL-Standard-A",
        label: "nl-NL-Standard-A"
    },
    {
        value: "nl-NL-Standard-B",
        label: "nl-NL-Standard-B"
    },
    {
        value: "nl-NL-Standard-C",
        label: "nl-NL-Standard-C"
    },
    {
        value: "nl-NL-Standard-D",
        label: "nl-NL-Standard-D"
    },
    {
        value: "nl-NL-Standard-E",
        label: "nl-NL-Standard-E"
    },
    {
        value: "nl-NL-Wavenet-A",
        label: "nl-NL-Wavenet-A"
    },
    {
        value: "nl-NL-Wavenet-B",
        label: "nl-NL-Wavenet-B"
    },
    {
        value: "nl-NL-Wavenet-C",
        label: "nl-NL-Wavenet-C"
    },
    {
        value: "nl-NL-Wavenet-D",
        label: "nl-NL-Wavenet-D"
    },
    {
        value: "nl-NL-Wavenet-E",
        label: "nl-NL-Wavenet-E"
    },
    {
        value: "en-AU-Neural2-A",
        label: "en-AU-Neural2-A"
    },
    {
        value: "en-AU-Standard-A",
        label: "en-AU-Standard-A"
    },
    {
        value: "en-AU-Standard-B",
        label: "en-AU-Standard-B"
    },
    {
        value: "en-AU-Standard-C",
        label: "en-AU-Standard-C"
    },
    {
        value: "en-AU-Standard-D",
        label: "en-AU-Standard-D"
    },
    {
        value: "en-AU-Wavenet-A",
        label: "en-AU-Wavenet-A"
    },
    {
        value: "en-AU-Wavenet-B",
        label: "en-AU-Wavenet-B"
    },
    {
        value: "en-AU-Wavenet-C",
        label: "en-AU-Wavenet-C"
    },
    {
        value: "en-AU-Wavenet-D",
        label: "en-AU-Wavenet-D"
    },
    {
        value: "en-IN-Standard-A",
        label: "en-IN-Standard-A"
    },
    {
        value: "en-IN-Standard-B",
        label: "en-IN-Standard-B"
    },
    {
        value: "en-IN-Standard-C",
        label: "en-IN-Standard-C"
    },
    {
        value: "en-IN-Standard-D",
        label: "en-IN-Standard-D"
    },
    {
        value: "en-IN-Wavenet-A",
        label: "en-IN-Wavenet-A"
    },
    {
        value: "en-IN-Wavenet-B",
        label: "en-IN-Wavenet-B"
    },
    {
        value: "en-IN-Wavenet-C",
        label: "en-IN-Wavenet-C"
    },
    {
        value: "en-IN-Wavenet-D",
        label: "en-IN-Wavenet-D"
    },
    {
        value: "en-GB-Neural2-A",
        label: "en-GB-Neural2-A"
    },
    {
        value: "en-GB-Standard-A",
        label: "en-GB-Standard-A"
    },
    {
        value: "en-GB-Standard-B",
        label: "en-GB-Standard-B"
    },
    {
        value: "en-GB-Standard-C",
        label: "en-GB-Standard-C"
    },
    {
        value: "en-GB-Standard-D",
        label: "en-GB-Standard-D"
    },
    {
        value: "en-GB-Standard-F",
        label: "en-GB-Standard-F"
    },
    {
        value: "en-GB-Wavenet-A",
        label: "en-GB-Wavenet-A"
    },
    {
        value: "en-GB-Wavenet-B",
        label: "en-GB-Wavenet-B"
    },
    {
        value: "en-GB-Wavenet-C",
        label: "en-GB-Wavenet-C"
    },
    {
        value: "en-GB-Wavenet-D",
        label: "en-GB-Wavenet-D"
    },
    {
        value: "en-GB-Wavenet-F",
        label: "en-GB-Wavenet-F"
    },
    {
        value: "en-US-Neural2-A",
        label: "en-US-Neural2-A"
    },
    {
        value: "en-US-Neural2-C",
        label: "en-US-Neural2-C"
    },
    {
        value: "en-US-Neural2-D",
        label: "en-US-Neural2-D"
    },
    {
        value: "en-US-Neural2-E",
        label: "en-US-Neural2-E"
    },
    {
        value: "en-US-Neural2-F",
        label: "en-US-Neural2-F"
    },
    {
        value: "en-US-Neural2-G",
        label: "en-US-Neural2-G"
    },
    {
        value: "en-US-Neural2-H",
        label: "en-US-Neural2-H"
    },
    {
        value: "en-US-Neural2-I",
        label: "en-US-Neural2-I"
    },
    {
        value: "en-US-Neural2-J",
        label: "en-US-Neural2-J"
    },
    {
        value: "en-US-Standard-A",
        label: "en-US-Standard-A"
    },
    {
        value: "en-US-Standard-B",
        label: "en-US-Standard-B"
    },
    {
        value: "en-US-Standard-C",
        label: "en-US-Standard-C"
    },
    {
        value: "en-US-Standard-D",
        label: "en-US-Standard-D"
    },
    {
        value: "en-US-Standard-E",
        label: "en-US-Standard-E"
    },
    {
        value: "en-US-Standard-F",
        label: "en-US-Standard-F"
    },
    {
        value: "en-US-Standard-G",
        label: "en-US-Standard-G"
    },
    {
        value: "en-US-Standard-H",
        label: "en-US-Standard-H"
    },
    {
        value: "en-US-Standard-I",
        label: "en-US-Standard-I"
    },
    {
        value: "en-US-Standard-J",
        label: "en-US-Standard-J"
    },
    {
        value: "en-US-Wavenet-A",
        label: "en-US-Wavenet-A"
    },
    {
        value: "en-US-Wavenet-B",
        label: "en-US-Wavenet-B"
    },
    {
        value: "en-US-Wavenet-C",
        label: "en-US-Wavenet-C"
    },
    {
        value: "en-US-Wavenet-D",
        label: "en-US-Wavenet-D"
    },
    {
        value: "en-US-Wavenet-E",
        label: "en-US-Wavenet-E"
    },
    {
        value: "en-US-Wavenet-F",
        label: "en-US-Wavenet-F"
    },
    {
        value: "en-US-Wavenet-G",
        label: "en-US-Wavenet-G"
    },
    {
        value: "en-US-Wavenet-H",
        label: "en-US-Wavenet-H"
    },
    {
        value: "en-US-Wavenet-I",
        label: "en-US-Wavenet-I"
    },
    {
        value: "en-US-Wavenet-J",
        label: "en-US-Wavenet-J"
    },
    {
        value: "fil-PH-Standard-A",
        label: "fil-PH-Standard-A"
    },
    {
        value: "fil-PH-Standard-B",
        label: "fil-PH-Standard-B"
    },
    {
        value: "fil-PH-Standard-C",
        label: "fil-PH-Standard-C"
    },
    {
        value: "fil-PH-Standard-D",
        label: "fil-PH-Standard-D"
    },
    {
        value: "fil-PH-Wavenet-A",
        label: "fil-PH-Wavenet-A"
    },
    {
        value: "fil-PH-Wavenet-B",
        label: "fil-PH-Wavenet-B"
    },
    {
        value: "fil-PH-Wavenet-C",
        label: "fil-PH-Wavenet-C"
    },
    {
        value: "fil-PH-Wavenet-D",
        label: "fil-PH-Wavenet-D"
    },
    {
        value: "fi-FI-Standard-A",
        label: "fi-FI-Standard-A"
    },
    {
        value: "fi-FI-Wavenet-A",
        label: "fi-FI-Wavenet-A"
    },
    {
        value: "fr-CA-Standard-A",
        label: "fr-CA-Standard-A"
    },
    {
        value: "fr-CA-Standard-B",
        label: "fr-CA-Standard-B"
    },
    {
        value: "fr-CA-Standard-C",
        label: "fr-CA-Standard-C"
    },
    {
        value: "fr-CA-Standard-D",
        label: "fr-CA-Standard-D"
    },
    {
        value: "fr-CA-Wavenet-A",
        label: "fr-CA-Wavenet-A"
    },
    {
        value: "fr-CA-Wavenet-B",
        label: "fr-CA-Wavenet-B"
    },
    {
        value: "fr-CA-Wavenet-C",
        label: "fr-CA-Wavenet-C"
    },
    {
        value: "fr-CA-Wavenet-D",
        label: "fr-CA-Wavenet-D"
    },
    {
        value: "fr-FR-Standard-A",
        label: "fr-FR-Standard-A"
    },
    {
        value: "fr-FR-Standard-B",
        label: "fr-FR-Standard-B"
    },
    {
        value: "fr-FR-Standard-C",
        label: "fr-FR-Standard-C"
    },
    {
        value: "fr-FR-Standard-D",
        label: "fr-FR-Standard-D"
    },
    {
        value: "fr-FR-Standard-E",
        label: "fr-FR-Standard-E"
    },
    {
        value: "fr-FR-Wavenet-A",
        label: "fr-FR-Wavenet-A"
    },
    {
        value: "fr-FR-Wavenet-B",
        label: "fr-FR-Wavenet-B"
    },
    {
        value: "fr-FR-Wavenet-C",
        label: "fr-FR-Wavenet-C"
    },
    {
        value: "fr-FR-Wavenet-D",
        label: "fr-FR-Wavenet-D"
    },
    {
        value: "fr-FR-Wavenet-E",
        label: "fr-FR-Wavenet-E"
    },
    {
        value: "de-DE-Standard-A",
        label: "de-DE-Standard-A"
    },
    {
        value: "de-DE-Standard-B",
        label: "de-DE-Standard-B"
    },
    {
        value: "de-DE-Standard-C",
        label: "de-DE-Standard-C"
    },
    {
        value: "de-DE-Standard-D",
        label: "de-DE-Standard-D"
    },
    {
        value: "de-DE-Standard-E",
        label: "de-DE-Standard-E"
    },
    {
        value: "de-DE-Standard-F",
        label: "de-DE-Standard-F"
    },
    {
        value: "de-DE-Wavenet-A",
        label: "de-DE-Wavenet-A"
    },
    {
        value: "de-DE-Wavenet-B",
        label: "de-DE-Wavenet-B"
    },
    {
        value: "de-DE-Wavenet-C",
        label: "de-DE-Wavenet-C"
    },
    {
        value: "de-DE-Wavenet-D",
        label: "de-DE-Wavenet-D"
    },
    {
        value: "de-DE-Wavenet-E",
        label: "de-DE-Wavenet-E"
    },
    {
        value: "de-DE-Wavenet-F",
        label: "de-DE-Wavenet-F"
    },
    {
        value: "el-GR-Standard-A",
        label: "el-GR-Standard-A"
    },
    {
        value: "el-GR-Wavenet-A",
        label: "el-GR-Wavenet-A"
    },
    {
        value: "gu-IN-Standard-A",
        label: "gu-IN-Standard-A"
    },
    {
        value: "gu-IN-Standard-B",
        label: "gu-IN-Standard-B"
    },
    {
        value: "gu-IN-Wavenet-A",
        label: "gu-IN-Wavenet-A"
    },
    {
        value: "gu-IN-Wavenet-B",
        label: "gu-IN-Wavenet-B"
    },
    {
        value: "hi-IN-Standard-A",
        label: "hi-IN-Standard-A"
    },
    {
        value: "hi-IN-Standard-B",
        label: "hi-IN-Standard-B"
    },
    {
        value: "hi-IN-Standard-C",
        label: "hi-IN-Standard-C"
    },
    {
        value: "hi-IN-Standard-D",
        label: "hi-IN-Standard-D"
    },
    {
        value: "hi-IN-Wavenet-A",
        label: "hi-IN-Wavenet-A"
    },
    {
        value: "hi-IN-Wavenet-B",
        label: "hi-IN-Wavenet-B"
    },
    {
        value: "hi-IN-Wavenet-C",
        label: "hi-IN-Wavenet-C"
    },
    {
        value: "hi-IN-Wavenet-D",
        label: "hi-IN-Wavenet-D"
    },
    {
        value: "hu-HU-Standard-A",
        label: "hu-HU-Standard-A"
    },
    {
        value: "hu-HU-Wavenet-A",
        label: "hu-HU-Wavenet-A"
    },
    {
        value: "is-is-Standard-A",
        label: "is-is-Standard-A"
    },
    {
        value: "id-ID-Standard-A",
        label: "id-ID-Standard-A"
    },
    {
        value: "id-ID-Standard-B",
        label: "id-ID-Standard-B"
    },
    {
        value: "id-ID-Standard-C",
        label: "id-ID-Standard-C"
    },
    {
        value: "id-ID-Standard-D",
        label: "id-ID-Standard-D"
    },
    {
        value: "id-ID-Wavenet-A",
        label: "id-ID-Wavenet-A"
    },
    {
        value: "id-ID-Wavenet-B",
        label: "id-ID-Wavenet-B"
    },
    {
        value: "id-ID-Wavenet-C",
        label: "id-ID-Wavenet-C"
    },
    {
        value: "id-ID-Wavenet-D",
        label: "id-ID-Wavenet-D"
    },
    {
        value: "it-IT-Standard-A",
        label: "it-IT-Standard-A"
    },
    {
        value: "it-IT-Standard-B",
        label: "it-IT-Standard-B"
    },
    {
        value: "it-IT-Standard-C",
        label: "it-IT-Standard-C"
    },
    {
        value: "it-IT-Standard-D",
        label: "it-IT-Standard-D"
    },
    {
        value: "it-IT-Wavenet-A",
        label: "it-IT-Wavenet-A"
    },
    {
        value: "it-IT-Wavenet-B",
        label: "it-IT-Wavenet-B"
    },
    {
        value: "it-IT-Wavenet-C",
        label: "it-IT-Wavenet-C"
    },
    {
        value: "it-IT-Wavenet-D",
        label: "it-IT-Wavenet-D"
    },
    {
        value: "ja-JP-Standard-A",
        label: "ja-JP-Standard-A"
    },
    {
        value: "ja-JP-Standard-B",
        label: "ja-JP-Standard-B"
    },
    {
        value: "ja-JP-Standard-C",
        label: "ja-JP-Standard-C"
    },
    {
        value: "ja-JP-Standard-D",
        label: "ja-JP-Standard-D"
    },
    {
        value: "ja-JP-Wavenet-A",
        label: "ja-JP-Wavenet-A"
    },
    {
        value: "ja-JP-Wavenet-B",
        label: "ja-JP-Wavenet-B"
    },
    {
        value: "ja-JP-Wavenet-C",
        label: "ja-JP-Wavenet-C"
    },
    {
        value: "ja-JP-Wavenet-D",
        label: "ja-JP-Wavenet-D"
    },
    {
        value: "kn-IN-Standard-A",
        label: "kn-IN-Standard-A"
    },
    {
        value: "kn-IN-Standard-B",
        label: "kn-IN-Standard-B"
    },
    {
        value: "kn-IN-Wavenet-A",
        label: "kn-IN-Wavenet-A"
    },
    {
        value: "kn-IN-Wavenet-B",
        label: "kn-IN-Wavenet-B"
    },
    {
        value: "ko-KR-Standard-A",
        label: "ko-KR-Standard-A"
    },
    {
        value: "ko-KR-Standard-B",
        label: "ko-KR-Standard-B"
    },
    {
        value: "ko-KR-Standard-C",
        label: "ko-KR-Standard-C"
    },
    {
        value: "ko-KR-Standard-D",
        label: "ko-KR-Standard-D"
    },
    {
        value: "ko-KR-Wavenet-A",
        label: "ko-KR-Wavenet-A"
    },
    {
        value: "ko-KR-Wavenet-B",
        label: "ko-KR-Wavenet-B"
    },
    {
        value: "ko-KR-Wavenet-C",
        label: "ko-KR-Wavenet-C"
    },
    {
        value: "ko-KR-Wavenet-D",
        label: "ko-KR-Wavenet-D"
    },
    {
        value: "lv-lv-Standard-A",
        label: "lv-lv-Standard-A"
    },
    {
        value: "ms-MY-Standard-A",
        label: "ms-MY-Standard-A"
    },
    {
        value: "ms-MY-Standard-B",
        label: "ms-MY-Standard-B"
    },
    {
        value: "ms-MY-Standard-C",
        label: "ms-MY-Standard-C"
    },
    {
        value: "ms-MY-Standard-D",
        label: "ms-MY-Standard-D"
    },
    {
        value: "ms-MY-Wavenet-A",
        label: "ms-MY-Wavenet-A"
    },
    {
        value: "ms-MY-Wavenet-B",
        label: "ms-MY-Wavenet-B"
    },
    {
        value: "ms-MY-Wavenet-C",
        label: "ms-MY-Wavenet-C"
    },
    {
        value: "ms-MY-Wavenet-D",
        label: "ms-MY-Wavenet-D"
    },
    {
        value: "ml-IN-Standard-A",
        label: "ml-IN-Standard-A"
    },
    {
        value: "ml-IN-Standard-B",
        label: "ml-IN-Standard-B"
    },
    {
        value: "ml-IN-Wavenet-A",
        label: "ml-IN-Wavenet-A"
    },
    {
        value: "ml-IN-Wavenet-B",
        label: "ml-IN-Wavenet-B"
    },
    {
        value: "cmn-CN-Standard-A",
        label: "cmn-CN-Standard-A"
    },
    {
        value: "cmn-CN-Standard-B",
        label: "cmn-CN-Standard-B"
    },
    {
        value: "cmn-CN-Standard-C",
        label: "cmn-CN-Standard-C"
    },
    {
        value: "cmn-CN-Standard-D",
        label: "cmn-CN-Standard-D"
    },
    {
        value: "cmn-CN-Wavenet-A",
        label: "cmn-CN-Wavenet-A"
    },
    {
        value: "cmn-CN-Wavenet-B",
        label: "cmn-CN-Wavenet-B"
    },
    {
        value: "cmn-CN-Wavenet-C",
        label: "cmn-CN-Wavenet-C"
    },
    {
        value: "cmn-CN-Wavenet-D",
        label: "cmn-CN-Wavenet-D"
    },
    {
        value: "cmn-TW-Standard-A",
        label: "cmn-TW-Standard-A"
    },
    {
        value: "cmn-TW-Standard-B",
        label: "cmn-TW-Standard-B"
    },
    {
        value: "cmn-TW-Standard-C",
        label: "cmn-TW-Standard-C"
    },
    {
        value: "cmn-TW-Wavenet-A",
        label: "cmn-TW-Wavenet-A"
    },
    {
        value: "cmn-TW-Wavenet-B",
        label: "cmn-TW-Wavenet-B"
    },
    {
        value: "cmn-TW-Wavenet-C",
        label: "cmn-TW-Wavenet-C"
    },
    {
        value: "nb-NO-Standard-A",
        label: "nb-NO-Standard-A"
    },
    {
        value: "nb-NO-Standard-B",
        label: "nb-NO-Standard-B"
    },
    {
        value: "nb-NO-Standard-C",
        label: "nb-NO-Standard-C"
    },
    {
        value: "nb-NO-Standard-D",
        label: "nb-NO-Standard-D"
    },
    {
        value: "nb-NO-Wavenet-A",
        label: "nb-NO-Wavenet-A"
    },
    {
        value: "nb-NO-Wavenet-B",
        label: "nb-NO-Wavenet-B"
    },
    {
        value: "nb-NO-Wavenet-C",
        label: "nb-NO-Wavenet-C"
    },
    {
        value: "nb-NO-Wavenet-D",
        label: "nb-NO-Wavenet-D"
    },
    {
        value: "nb-no-Standard-E",
        label: "nb-no-Standard-E"
    },
    {
        value: "nb-no-Wavenet-E",
        label: "nb-no-Wavenet-E"
    },
    {
        value: "pl-PL-Standard-A",
        label: "pl-PL-Standard-A"
    },
    {
        value: "pl-PL-Standard-B",
        label: "pl-PL-Standard-B"
    },
    {
        value: "pl-PL-Standard-C",
        label: "pl-PL-Standard-C"
    },
    {
        value: "pl-PL-Standard-D",
        label: "pl-PL-Standard-D"
    },
    {
        value: "pl-PL-Standard-E",
        label: "pl-PL-Standard-E"
    },
    {
        value: "pl-PL-Wavenet-A",
        label: "pl-PL-Wavenet-A"
    },
    {
        value: "pl-PL-Wavenet-B",
        label: "pl-PL-Wavenet-B"
    },
    {
        value: "pl-PL-Wavenet-C",
        label: "pl-PL-Wavenet-C"
    },
    {
        value: "pl-PL-Wavenet-D",
        label: "pl-PL-Wavenet-D"
    },
    {
        value: "pl-PL-Wavenet-E",
        label: "pl-PL-Wavenet-E"
    },
    {
        value: "pt-BR-Standard-A",
        label: "pt-BR-Standard-A"
    },
    {
        value: "pt-BR-Standard-B",
        label: "pt-BR-Standard-B"
    },
    {
        value: "pt-BR-Wavenet-A",
        label: "pt-BR-Wavenet-A"
    },
    {
        value: "pt-BR-Wavenet-B",
        label: "pt-BR-Wavenet-B"
    },
    {
        value: "pt-PT-Standard-A",
        label: "pt-PT-Standard-A"
    },
    {
        value: "pt-PT-Standard-B",
        label: "pt-PT-Standard-B"
    },
    {
        value: "pt-PT-Standard-C",
        label: "pt-PT-Standard-C"
    },
    {
        value: "pt-PT-Standard-D",
        label: "pt-PT-Standard-D"
    },
    {
        value: "pt-PT-Wavenet-A",
        label: "pt-PT-Wavenet-A"
    },
    {
        value: "pt-PT-Wavenet-B",
        label: "pt-PT-Wavenet-B"
    },
    {
        value: "pt-PT-Wavenet-C",
        label: "pt-PT-Wavenet-C"
    },
    {
        value: "pt-PT-Wavenet-D",
        label: "pt-PT-Wavenet-D"
    },
    {
        value: "pa-IN-Standard-A",
        label: "pa-IN-Standard-A"
    },
    {
        value: "pa-IN-Standard-B",
        label: "pa-IN-Standard-B"
    },
    {
        value: "pa-IN-Standard-C",
        label: "pa-IN-Standard-C"
    },
    {
        value: "pa-IN-Standard-D",
        label: "pa-IN-Standard-D"
    },
    {
        value: "pa-IN-Wavenet-A",
        label: "pa-IN-Wavenet-A"
    },
    {
        value: "pa-IN-Wavenet-B",
        label: "pa-IN-Wavenet-B"
    },
    {
        value: "pa-IN-Wavenet-C",
        label: "pa-IN-Wavenet-C"
    },
    {
        value: "pa-IN-Wavenet-D",
        label: "pa-IN-Wavenet-D"
    },
    {
        value: "ro-RO-Standard-A",
        label: "ro-RO-Standard-A"
    },
    {
        value: "ro-RO-Wavenet-A",
        label: "ro-RO-Wavenet-A"
    },
    {
        value: "ru-RU-Standard-A",
        label: "ru-RU-Standard-A"
    },
    {
        value: "ru-RU-Standard-B",
        label: "ru-RU-Standard-B"
    },
    {
        value: "ru-RU-Standard-C",
        label: "ru-RU-Standard-C"
    },
    {
        value: "ru-RU-Standard-D",
        label: "ru-RU-Standard-D"
    },
    {
        value: "ru-RU-Standard-E",
        label: "ru-RU-Standard-E"
    },
    {
        value: "ru-RU-Wavenet-A",
        label: "ru-RU-Wavenet-A"
    },
    {
        value: "ru-RU-Wavenet-B",
        label: "ru-RU-Wavenet-B"
    },
    {
        value: "ru-RU-Wavenet-C",
        label: "ru-RU-Wavenet-C"
    },
    {
        value: "ru-RU-Wavenet-D",
        label: "ru-RU-Wavenet-D"
    },
    {
        value: "ru-RU-Wavenet-E",
        label: "ru-RU-Wavenet-E"
    },
    {
        value: "sr-rs-Standard-A",
        label: "sr-rs-Standard-A"
    },
    {
        value: "sk-SK-Standard-A",
        label: "sk-SK-Standard-A"
    },
    {
        value: "sk-SK-Wavenet-A",
        label: "sk-SK-Wavenet-A"
    },
    {
        value: "es-ES-Standard-A",
        label: "es-ES-Standard-A"
    },
    {
        value: "es-ES-Standard-B",
        label: "es-ES-Standard-B"
    },
    {
        value: "es-ES-Standard-C",
        label: "es-ES-Standard-C"
    },
    {
        value: "es-ES-Standard-D",
        label: "es-ES-Standard-D"
    },
    {
        value: "es-ES-Wavenet-B",
        label: "es-ES-Wavenet-B"
    },
    {
        value: "es-ES-Wavenet-C",
        label: "es-ES-Wavenet-C"
    },
    {
        value: "es-ES-Wavenet-D",
        label: "es-ES-Wavenet-D"
    },
    {
        value: "es-US-Neural2-A",
        label: "es-US-Neural2-A"
    },
    {
        value: "es-US-Standard-A",
        label: "es-US-Standard-A"
    },
    {
        value: "es-US-Standard-B",
        label: "es-US-Standard-B"
    },
    {
        value: "es-US-Standard-C",
        label: "es-US-Standard-C"
    },
    {
        value: "es-US-Wavenet-A",
        label: "es-US-Wavenet-A"
    },
    {
        value: "es-US-Wavenet-B",
        label: "es-US-Wavenet-B"
    },
    {
        value: "es-US-Wavenet-C",
        label: "es-US-Wavenet-C"
    },
    {
        value: "sv-SE-Standard-A",
        label: "sv-SE-Standard-A"
    },
    {
        value: "sv-SE-Standard-B",
        label: "sv-SE-Standard-B"
    },
    {
        value: "sv-SE-Standard-C",
        label: "sv-SE-Standard-C"
    },
    {
        value: "sv-SE-Standard-D",
        label: "sv-SE-Standard-D"
    },
    {
        value: "sv-SE-Standard-E",
        label: "sv-SE-Standard-E"
    },
    {
        value: "sv-SE-Wavenet-A",
        label: "sv-SE-Wavenet-A"
    },
    {
        value: "sv-SE-Wavenet-B",
        label: "sv-SE-Wavenet-B"
    },
    {
        value: "sv-SE-Wavenet-C",
        label: "sv-SE-Wavenet-C"
    },
    {
        value: "sv-SE-Wavenet-D",
        label: "sv-SE-Wavenet-D"
    },
    {
        value: "sv-SE-Wavenet-E",
        label: "sv-SE-Wavenet-E"
    },
    {
        value: "ta-IN-Standard-A",
        label: "ta-IN-Standard-A"
    },
    {
        value: "ta-IN-Standard-B",
        label: "ta-IN-Standard-B"
    },
    {
        value: "ta-IN-Wavenet-A",
        label: "ta-IN-Wavenet-A"
    },
    {
        value: "ta-IN-Wavenet-B",
        label: "ta-IN-Wavenet-B"
    },
    {
        value: "te-IN-Standard-A",
        label: "te-IN-Standard-A"
    },
    {
        value: "te-IN-Standard-B",
        label: "te-IN-Standard-B"
    },
    {
        value: "th-TH-Standard-A",
        label: "th-TH-Standard-A"
    },
    {
        value: "tr-TR-Standard-A",
        label: "tr-TR-Standard-A"
    },
    {
        value: "tr-TR-Standard-B",
        label: "tr-TR-Standard-B"
    },
    {
        value: "tr-TR-Standard-C",
        label: "tr-TR-Standard-C"
    },
    {
        value: "tr-TR-Standard-D",
        label: "tr-TR-Standard-D"
    },
    {
        value: "tr-TR-Standard-E",
        label: "tr-TR-Standard-E"
    },
    {
        value: "tr-TR-Wavenet-A",
        label: "tr-TR-Wavenet-A"
    },
    {
        value: "tr-TR-Wavenet-B",
        label: "tr-TR-Wavenet-B"
    },
    {
        value: "tr-TR-Wavenet-C",
        label: "tr-TR-Wavenet-C"
    },
    {
        value: "tr-TR-Wavenet-D",
        label: "tr-TR-Wavenet-D"
    },
    {
        value: "tr-TR-Wavenet-E",
        label: "tr-TR-Wavenet-E"
    },
    {
        value: "uk-UA-Standard-A",
        label: "uk-UA-Standard-A"
    },
    {
        value: "uk-UA-Wavenet-A",
        label: "uk-UA-Wavenet-A"
    },
    {
        value: "vi-VN-Standard-A",
        label: "vi-VN-Standard-A"
    },
    {
        value: "vi-VN-Standard-B",
        label: "vi-VN-Standard-B"
    },
    {
        value: "vi-VN-Standard-C",
        label: "vi-VN-Standard-C"
    },
    {
        value: "vi-VN-Standard-D",
        label: "vi-VN-Standard-D"
    },
    {
        value: "vi-VN-Wavenet-A",
        label: "vi-VN-Wavenet-A"
    },
    {
        value: "vi-VN-Wavenet-B",
        label: "vi-VN-Wavenet-B"
    },
    {
        value: "vi-VN-Wavenet-C",
        label: "vi-VN-Wavenet-C"
    },
    {
        value: "vi-VN-Wavenet-D",
        label: "vi-VN-Wavenet-D"
    }
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"kQkdQ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "formatPhoneNumber", ()=>formatPhoneNumber);
var _base = require("@emotion/styled/base");
var _baseDefault = parcelHelpers.interopDefault(_base);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _reactRouterDom = require("react-router-dom");
var _css = require("@emotion/css");
var _stylesValues = require("../../../../../shared/constants/stylesValues");
var _breakpoints = require("../../../../../shared/constants/breakpoints");
var _conditionalTooltipWrapper = require("../../../../../shared/components/general/ConditionalTooltipWrapper");
var _conditionalTooltipWrapperDefault = parcelHelpers.interopDefault(_conditionalTooltipWrapper);
var _tooltipWrapper = require("../../../../../shared/components/general/TooltipWrapper");
var _tooltipWrapperDefault = parcelHelpers.interopDefault(_tooltipWrapper);
var _colors = require("../../../../../shared/constants/colors");
var _sparkDeploymentContainer = require("../../../../../shared/hooks/SparkDeploymentContainer");
var _sparkDeploymentContainerDefault = parcelHelpers.interopDefault(_sparkDeploymentContainer);
var _moduleConsts = require("../../../../../shared/constants/sparkConstants/moduleConsts");
var _moment = require("moment");
var _momentDefault = parcelHelpers.interopDefault(_moment);
var _analyticsDateFormat = require("../../../../../shared/models/analytics/AnalyticsDateFormat");
var _userAvatar = require("../../../../../shared/components/general/UserAvatar");
var _userAvatarDefault = parcelHelpers.interopDefault(_userAvatar);
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const assistantImage = require("5d662e0777530787");
const sharedImage = require("2f86df3eea49842a");
const formCompleteImage = require("260a307317cca677");
const formIncompleteImage = require("558df86503cf4f1a");
const editImage = require("2a33ea82e151a42e");
const analyticsIcon = require("32415d4ea1c8c44");
const copyIcon = require("c68b29704b55778d");
const formatPhoneNumber = (phoneNumber, virtual = false)=>{
    if (virtual) return `${phoneNumber} (Virtual)`;
    // Remove any non-digit characters from the input number
    const cleanedNumber = phoneNumber?.replace(/\D/g, "");
    const formattedNumber = `+${cleanedNumber?.substring(0, 1)} (${cleanedNumber?.substring(1, 4)}) ${cleanedNumber?.substring(4, 7)}-${cleanedNumber?.substring(7)}`;
    return formattedNumber;
};
const ApplicationItem = (props)=>{
    const trainingContainer = (0, _sparkDeploymentContainerDefault.default).useContainer();
    const [copiedPhoneNumber, setCopiedPhoneNumber] = (0, _react1.useState)(false);
    const copyTimeoutRef = (0, _react1.useRef)(null);
    (0, _react1.useEffect)(()=>{
        return ()=>{
            if (copyTimeoutRef.current !== null) clearTimeout(copyTimeoutRef.current);
        };
    }, []);
    const handleCopyPhoneNumber = (e)=>{
        e.preventDefault();
        e.stopPropagation();
        if (!navigator.clipboard?.writeText) return;
        const formattedPhoneNumber = props.app.virtualNumber ? props.app.virtualNumber : formatPhoneNumber(props.app.phoneNumber);
        if (formattedPhoneNumber) navigator.clipboard.writeText(formattedPhoneNumber).then(()=>{
            setCopiedPhoneNumber(true);
            if (copyTimeoutRef.current !== null) clearTimeout(copyTimeoutRef.current);
            copyTimeoutRef.current = setTimeout(()=>setCopiedPhoneNumber(false), 2000);
        });
    };
    const renderTrainingState = ()=>{
        if (props.applicationType === "common") return null;
        switch(trainingContainer.getAppDeploymentState(props.app?.id)){
            case "training":
                return (0, _react.jsx)(TrainingStatus, {
                    className: "publishing"
                }, "Publishing");
            case "trained":
                return (0, _react.jsx)((0, _reactDefault.default).Fragment, null, props.app.virtualNumber ? (0, _react.jsx)(PhoneNumberLink, {
                    to: `/v/apps/${props.app.id}`
                }, (0, _react.jsx)(PhoneNumber, null, `${props.app.virtualNumber} (Virtual)`)) : props.app.phoneNumber ? (0, _react.jsx)(PhoneNumberLink, {
                    to: `/v/apps/${props.app.id}`
                }, (0, _react.jsx)(PhoneNumber, null, formatPhoneNumber(props.app.phoneNumber))) : null);
            case "error":
                return (0, _react.jsx)((0, _tooltipWrapperDefault.default), {
                    text: "Try publishing again or contact support."
                }, (0, _react.jsx)(TrainingStatus, {
                    className: "error"
                }, "Publish Error"));
            default:
                return null;
        }
    };
    let analyticsQueryStr = "";
    if (window?.location?.href) {
        const url = new URL(window?.location?.href);
        if (url.search) {
            const params = new URLSearchParams(url?.search);
            const year = (0, _momentDefault.default)().year();
            const month = params.get("month");
            const startDate = (0, _momentDefault.default)(`${month} 1, ${year}`, "MMMM D, YYYY");
            const endDate = startDate.clone().endOf("month");
            analyticsQueryStr = `?startDate=${startDate.format((0, _analyticsDateFormat.DATE_FORMAT))}&endDate=${endDate.format((0, _analyticsDateFormat.DATE_FORMAT))}&interval=month`;
        }
    }
    const appName = props.applicationType === "common" ? props.app.name === (0, _moduleConsts.aiDentalSchedulingCommonAppName) ? (0, _moduleConsts.aiDentalSchedulingCommonAppName) : (0, _moduleConsts.aiAnsweringCommonAppName) : props.app.name;
    // Get the applied templates specific to this app
    const appAppliedTemplates = props.appliedAppTemplateContainer?.state?.perApplicationAppliedTemplates?.find((t)=>t.applicationId === props.app.id);
    const hasAppTemplates = appAppliedTemplates?.appliedTemplates?.length > 0;
    const isComplete = !props.app.hasIncompleteFormFields && hasAppTemplates;
    const isLive = props.app.isLive ?? false;
    const isSharedConfig = props.applicationType === "common";
    // Check if app is currently publishing
    const isPublishing = props.applicationType !== "common" && trainingContainer.getAppDeploymentState(props.app?.id) === "training";
    // Check if templates are still loading for this app
    const isLoadingStatus = props.isLoadingTemplates || props.appliedAppTemplateContainer?.state?.isLoading && !appAppliedTemplates;
    return (0, _react.jsx)((0, _reactDefault.default).Fragment, null, (0, _react.jsx)((0, _conditionalTooltipWrapperDefault.default), {
        showTooltip: isPublishing,
        text: "Hang tight! You'll be able to edit once published."
    }, (0, _react.jsx)(AppListItem, {
        app: props.app,
        isInSidePanel: props.isInSidePanel,
        isSharedConfig: isSharedConfig,
        isSelected: props.isSelected,
        isPublishing: isPublishing
    }, props.isFilterable && (0, _react.jsx)((0, _tooltipWrapperDefault.default), {
        text: props.isSelected ? "Uncheck to exclude from charts" : "Check to include in charts",
        replacementContentStyle: modernTooltipStyle,
        place: "right"
    }, (0, _react.jsx)(FilterCheckboxWrapper, {
        onClick: (e)=>{
            e.preventDefault();
            e.stopPropagation();
            props.onToggleFilter?.();
        }
    }, (0, _react.jsx)(FilterCheckbox, {
        type: "checkbox",
        checked: props.isSelected,
        onChange: ()=>props.onToggleFilter?.(),
        onClick: (e)=>e.stopPropagation(),
        "aria-label": "Toggle filter for application"
    }))), (0, _react.jsx)(StyledLink, {
        to: `/v/apps/${props.app.id}/analytics`
    }, (0, _react.jsx)(AppContentWrapper, null, (0, _react.jsx)((0, _userAvatarDefault.default), {
        firstName: appName?.split(" ")[0] || "A",
        lastName: appName?.split(" ")[1] || "P",
        size: 32,
        noBackground: false,
        noShadow: true
    }), (0, _react.jsx)(AppNameWrapper, null, (0, _react.jsx)(AssistantName, null, appName), (props.app.phoneNumber || props.app.virtualNumber) && (0, _react.jsx)(PhoneNumberRow, null, (0, _react.jsx)(PhoneNumberText, null, props.app.virtualNumber ? `${props.app.virtualNumber} (Virtual)` : formatPhoneNumber(props.app.phoneNumber)), (0, _react.jsx)((0, _tooltipWrapperDefault.default), {
        text: copiedPhoneNumber ? "Copied!" : "Copy phone number",
        replacementContentStyle: modernTooltipStyle,
        place: "top"
    }, (0, _react.jsx)(CopyButton, {
        onClick: handleCopyPhoneNumber,
        copied: copiedPhoneNumber
    }, (0, _react.jsx)(CopyIcon, {
        src: copyIcon
    }))))), isPublishing ? (0, _react.jsx)(PublishingPill, null, (0, _react.jsx)(PublishingSpinner, null), "Publishing") : isLoadingStatus ? (0, _react.jsx)(StatusPillLoader, null, (0, _react.jsx)(StatusPillLoaderDot, null), (0, _react.jsx)(StatusPillLoaderDot, null), (0, _react.jsx)(StatusPillLoaderDot, null)) : (0, _react.jsx)(StatusWrapper, null, (0, _react.jsx)((0, _tooltipWrapperDefault.default), {
        text: isComplete ? "Form complete" : "Form needs review",
        replacementContentStyle: modernTooltipStyle,
        place: "top"
    }, (0, _react.jsx)(FormStatusDot, {
        isComplete: isComplete
    })), !isSharedConfig && (0, _react.jsx)(LiveStatusPill, {
        isLive: isLive
    }, isLive ? "Live" : "Not Live")))))));
};
const modernTooltipStyle = /*#__PURE__*/ (0, _css.css)(".rc-tooltip-inner{font-family:Muli,-apple-system,BlinkMacSystemFont,'Segoe UI',sans-serif;font-size:10px;font-weight:500;letter-spacing:0.3px;line-height:1.4;z-index:120;color:white;background:linear-gradient(135deg, ", (0, _colors.voicify_spark_darker), " 0%, #1a4d6b 100%);box-shadow:0 4px 12px rgba(30, 126, 185, 0.25),0 2px 4px rgba(0, 0, 0, 0.1);border-radius:6px;padding:6px 10px;min-height:0;border:1px solid rgba(255, 255, 255, 0.1);}.rc-tooltip-arrow{display:none;}", "");
const AppContentWrapper = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1h646jv26"
})({
    name: "1iuuy60",
    styles: "display:flex;align-items:center;gap:8px;width:100%;min-width:0;overflow:hidden"
});
const AppNameWrapper = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1h646jv25"
})({
    name: "11trrc4",
    styles: "flex:1;min-width:0;overflow:hidden;display:flex;flex-direction:column;gap:2px"
});
const AssistantName = /*#__PURE__*/ (0, _baseDefault.default)("p", {
    target: "e1h646jv24"
})("white-space:nowrap;overflow:hidden;text-overflow:ellipsis;font-size:11px;font-weight:600;margin:0;color:", (0, _colors.color_shades_darkest), ";", (0, _breakpoints.breakpoint_macbook_small), "{font-size:10px;}", (0, _breakpoints.breakpoint_large), "{font-size:9px;}", (0, _breakpoints.breakpoint_small), "{font-size:10px;}");
const PhoneNumberText = /*#__PURE__*/ (0, _baseDefault.default)("p", {
    target: "e1h646jv23"
})("white-space:nowrap;overflow:hidden;text-overflow:ellipsis;font-size:9px;font-weight:500;margin:0;color:", (0, _colors.color_shades_darker), ";", (0, _breakpoints.breakpoint_macbook_small), "{font-size:8px;}", (0, _breakpoints.breakpoint_large), "{font-size:7px;}", (0, _breakpoints.breakpoint_small), "{font-size:8px;}");
const PhoneNumberRow = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1h646jv22"
})({
    name: "tqq1rc",
    styles: "display:flex;align-items:center;gap:4px;min-width:0"
});
const CopyButton = /*#__PURE__*/ (0, _baseDefault.default)("button", {
    target: "e1h646jv21"
})("display:flex;align-items:center;justify-content:center;background:", (props)=>props.copied ? "#E8F5E9" : "transparent", ";border:none;border-radius:4px;padding:2px;cursor:pointer;opacity:", (props)=>props.copied ? 1 : 0.6, ";transition:all 0.2s;flex-shrink:0;&:hover{opacity:1;background:", (0, _colors.color_shades_light), ";}");
const CopyIcon = /*#__PURE__*/ (0, _baseDefault.default)("img", {
    target: "e1h646jv20"
})({
    name: "1suksrg",
    styles: "width:12px;height:12px"
});
const StatusWrapper = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1h646jv19"
})({
    name: "1mveb9k",
    styles: "display:flex;align-items:center;gap:6px;flex-shrink:0"
});
const FormStatusDot = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1h646jv18"
})("width:6px;height:6px;border-radius:50%;background-color:", (props)=>props.isComplete ? (0, _colors.color_colors_growth) : "#E5B94C", ";opacity:", (props)=>props.isComplete ? 1 : 0.6, ";flex-shrink:0;cursor:help;transition:all 0.2s;&:hover{transform:scale(1.3);opacity:1;}");
const LiveStatusPill = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1h646jv17"
})("padding:4px 10px;border-radius:16px;font-size:10px;font-weight:600;white-space:nowrap;background-color:", (props)=>props.isLive ? "#E8F5E9" : (0, _colors.color_shades_light), ";color:", (props)=>props.isLive ? (0, _colors.color_colors_growth) : (0, _colors.color_shades_darker), ";border:1px solid ", (props)=>props.isLive ? "#A5D6A7" : (0, _colors.color_shades_light), ";transition:all 0.2s;flex-shrink:0;", (0, _breakpoints.breakpoint_macbook_small), "{font-size:9px;padding:3px 8px;}", (0, _breakpoints.breakpoint_large), "{font-size:8px;padding:2px 6px;}", (0, _breakpoints.breakpoint_small), "{font-size:9px;padding:3px 8px;}");
const StatusPillLoader = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1h646jv16"
})("display:flex;align-items:center;justify-content:center;gap:3px;padding:4px 14px;border-radius:16px;background-color:", (0, _colors.color_shades_light), ";border:1px solid ", (0, _colors.color_shades_light), ";flex-shrink:0;min-width:70px;", (0, _breakpoints.breakpoint_small), "{padding:3px 10px;min-width:60px;}");
const StatusPillLoaderDot = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1h646jv15"
})("width:4px;height:4px;border-radius:50%;background-color:", (0, _colors.color_shades_darker), ";animation:statusPulse 1.2s ease-in-out infinite;&:nth-of-type(2){animation-delay:0.2s;}&:nth-of-type(3){animation-delay:0.4s;}@keyframes statusPulse{0%,80%,100%{opacity:0.3;transform:scale(0.8);}40%{opacity:1;transform:scale(1);}}");
const PublishingPill = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1h646jv14"
})("display:flex;align-items:center;gap:6px;padding:4px 10px;border-radius:16px;font-size:10px;font-weight:600;white-space:nowrap;background-color:#E8F5E9;color:", (0, _colors.color_colors_growth), ";border:1px solid #A5D6A7;flex-shrink:0;", (0, _breakpoints.breakpoint_small), "{font-size:9px;padding:3px 8px;gap:4px;}");
const PublishingSpinner = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1h646jv13"
})("width:10px;height:10px;border:2px solid #A5D6A7;border-top-color:", (0, _colors.color_colors_growth), ";border-radius:50%;animation:publishingSpin 0.8s linear infinite;@keyframes publishingSpin{to{transform:rotate(360deg);}}", (0, _breakpoints.breakpoint_small), "{width:8px;height:8px;border-width:1.5px;}");
const StyledLink = /*#__PURE__*/ (0, _baseDefault.default)((0, _reactRouterDom.Link), {
    target: "e1h646jv12"
})({
    name: "1h3pj2f",
    styles: "text-decoration:none;color:inherit;flex:1;min-width:0;overflow:hidden"
});
const PhoneNumberLink = /*#__PURE__*/ (0, _baseDefault.default)((0, _reactRouterDom.Link), {
    target: "e1h646jv11"
})({
    name: "o171kl",
    styles: "text-decoration:none;color:inherit"
});
const TrainingStatus = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1h646jv10"
})("font-size:10px;font-weight:600;margin-right:12px;&.publishing{color:", (0, _colors.color_colors_growth), ";position:relative;}&.publishing:after{content:'';animation:dots 1.5s steps(1, end) infinite;position:absolute;margin-left:2px;}&.published{color:", (0, _colors.color_colors_growth), ";}&.error{color:", (0, _colors.color_colors_decline), ";}@keyframes dots{0%,20%{content:'.';}40%{content:'..';}60%,80%{content:'...';}100%{content:'';}}", (0, _breakpoints.breakpoint_small), "{display:none;}");
const FormIncompleteWrapper = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1h646jv9"
})({
    name: "s5xdrg",
    styles: "display:flex;align-items:center"
});
const FilterCheckboxWrapper = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1h646jv8"
})({
    name: "1wtti5p",
    styles: "display:flex;align-items:center;justify-content:center;padding:0 8px 0 4px;cursor:pointer;z-index:10;pointer-events:auto"
});
const FilterCheckbox = /*#__PURE__*/ (0, _baseDefault.default)("input", {
    target: "e1h646jv7"
})("width:16px;height:16px;cursor:pointer;appearance:none;border:2px solid ", (0, _colors.color_shades_light), ";border-radius:3px;transition:all 0.2s;background-color:", (0, _colors.color_defaults_white), ";position:relative;&:checked{background-color:", (0, _colors.voicify_spark_darker), ";border-color:", (0, _colors.voicify_spark_darker), ";}&:checked::after{content:'';position:absolute;left:50%;top:45%;width:3px;height:7px;border:solid white;border-width:0 2px 2px 0;transform:translate(-50%, -50%) rotate(45deg);}&:hover{transform:scale(1.1);border-color:", (0, _colors.voicify_spark_medium), ";}");
const AppListItem = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1h646jv6"
})("text-decoration:none;color:", (0, _colors.dark_grey_blue), ";background-color:", (props)=>props.isPublishing ? (0, _colors.color_shades_light) : props.isSharedConfig ? (0, _colors.voicify_spark_lightest) : (0, _colors.color_defaults_white), ";cursor:", (props)=>props.isPublishing ? "not-allowed" : "pointer", ";display:flex;align-items:center;width:100%;border:1px solid ", (props)=>props.isPublishing ? (0, _colors.color_shades_light) : props.isSharedConfig ? "rgba(27, 165, 220, 0.25)" : (0, _colors.color_shades_light), ";border-radius:12px;padding:12px;margin-bottom:12px;transition:all 0.3s ease;box-shadow:0 2px 4px rgba(50, 70, 97, 0.08);position:relative;overflow:hidden;opacity:", (props)=>props.isPublishing ? 0.7 : props.isSelected === false ? 0.4 : 1, ";pointer-events:", (props)=>props.isPublishing ? "none" : "auto", ";", (props)=>props.isSharedConfig && !props.isPublishing && `
        &:before {
            content: '';
            position: absolute;
            left: 0;
            top: 0;
            bottom: 0;
            width: 3px;
            background: linear-gradient(180deg, ${0, _colors.voicify_spark_medium} 0%, ${0, _colors.voicify_spark_darker} 100%);
        }
    `, " &:hover{transform:", (props)=>props.isPublishing ? "none" : "translateY(-2px)", ";box-shadow:", (props)=>props.isPublishing ? "0 2px 4px rgba(50, 70, 97, 0.08)" : "0 4px 12px rgba(30, 126, 185, 0.15)", ";border-color:", (props)=>props.isPublishing ? (0, _colors.color_shades_light) : props.isSharedConfig ? (0, _colors.voicify_spark_darker) : (0, _colors.voicify_spark_medium), ";opacity:", (props)=>props.isPublishing ? 0.7 : props.isSelected === false ? 0.6 : 1, ";}", (0, _breakpoints.breakpoint_small), "{padding:12px;margin-bottom:8px;}");
const DisabledAppListItem = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1h646jv5"
})("text-decoration:none;color:", (0, _colors.color_shades_darker), ";background-color:", (0, _colors.color_shades_light), ";cursor:not-allowed;display:flex;align-items:center;justify-content:space-between;border:", (0, _stylesValues.style_border_default), ";border-top:", (props)=>props.isInSidePanel ? (0, _stylesValues.style_border_default) : "none", ";border-radius:6px;height:44px;padding:0 12px;opacity:0.7;", (0, _breakpoints.breakpoint_small), "{font-size:12px;padding:0 8px;height:48px;}");
const AssistantIcon = /*#__PURE__*/ (0, _baseDefault.default)("img", {
    target: "e1h646jv4"
})("margin-right:", (props)=>props.src === sharedImage ? "10px" : "8px", ";width:", (props)=>props.src === sharedImage ? "18px" : "20px", ";height:", (props)=>props.src === sharedImage ? "18px" : "20px", ";", (0, _breakpoints.breakpoint_small), "{display:none;}");
const AppListItemSide = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1h646jv3"
})({
    name: "19mh0x6",
    styles: "display:flex;align-items:center;justify-content:flex-end"
});
const ActionIcon = /*#__PURE__*/ (0, _baseDefault.default)("img", {
    target: "e1h646jv2"
})("margin:0 0 0 8px;width:16px;height:16px;opacity:0.8;transition:opacity 0.2s;&:hover{opacity:1;}", (0, _breakpoints.breakpoint_small), "{margin:0 4px;height:16px;width:16px;}");
const IncompleteText = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1h646jv1"
})("font-size:9px;margin:0 4px 0 0;color:", (0, _colors.color_colors_decline), ";font-weight:600;", (0, _breakpoints.breakpoint_small), "{display:none;}");
const PhoneNumber = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1h646jv0"
})("margin-right:12px;font-size:11px;color:#6b7280;font-weight:500;", (0, _breakpoints.breakpoint_small), "{font-size:9px;}");
exports.default = ApplicationItem;

},{"@emotion/styled/base":"lSuFu","@emotion/react":"djZKr","react":"6uln9","react-router-dom":"5fzqq","@emotion/css":"awUBr","../../../../../shared/constants/stylesValues":"dHVVv","../../../../../shared/constants/breakpoints":"2F01A","../../../../../shared/components/general/ConditionalTooltipWrapper":"92m0T","../../../../../shared/components/general/TooltipWrapper":"53pWd","../../../../../shared/constants/colors":"1p3OR","../../../../../shared/hooks/SparkDeploymentContainer":"7t8XT","../../../../../shared/constants/sparkConstants/moduleConsts":"e2wLw","moment":"2meyw","../../../../../shared/models/analytics/AnalyticsDateFormat":"ia5MW","../../../../../shared/components/general/UserAvatar":"avuDP","5d662e0777530787":"1g51C","2f86df3eea49842a":"5tlsw","260a307317cca677":"6owvk","558df86503cf4f1a":"2B5Yl","2a33ea82e151a42e":"1u9JO","32415d4ea1c8c44":"ekINT","c68b29704b55778d":"1jL91","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7t8XT":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _unstatedNext = require("unstated-next");
var _keys = require("../constants/Keys");
var _api = require("../api");
function useSparkDeploymentContainer() {
    const [currentOrgId, setCurrentOrgId] = (0, _react.useState)("");
    const [deploymentState, setDeploymentState] = (0, _react.useState)(null);
    const [environments, setEnvironments] = (0, _react.useState)([]);
    const [pollingTrigger, setPollingTrigger] = (0, _react.useState)(false);
    const [polling, setPolling] = (0, _react.useState)(false);
    (0, _react.useEffect)(()=>{
        // Load state from localStorage but DON'T start polling automatically
        // Polling should only start when pollForApplication is explicitly called
        setDeploymentState(getStoredState());
    }, []);
    (0, _react.useEffect)(()=>{
        if (!polling) return;
        pollForUnfinishedDeployments();
    }, [
        pollingTrigger,
        polling
    ]);
    const getStoredState = ()=>{
        let storedState = {};
        const storedTrainingState = localStorage.getItem((0, _keys.VOICIFY_SPARK_DEPLOYMENT_STATE));
        if (storedTrainingState) storedState = JSON.parse(storedTrainingState);
        return storedState;
    };
    const storeState = (state)=>{
        const json = JSON.stringify(state);
        localStorage.setItem((0, _keys.VOICIFY_SPARK_DEPLOYMENT_STATE), json);
    };
    const pollForApplication = async (appId, orgId, appliedTemplateSyncId)=>{
        const newState = {
            ...deploymentState
        };
        // Only track apps that have an active sync
        if (!appliedTemplateSyncId) return;
        if (appId in newState) {
            // App already being tracked, update with new sync ID and reset to Queued
            newState[appId].appliedTemplateSyncId = appliedTemplateSyncId;
            newState[appId].syncStage = "Queued"; // New sync started
        } else // New app to track
        newState[appId] = {
            appliedTemplateSyncId: appliedTemplateSyncId,
            orgId: orgId,
            syncStage: "Queued"
        };
        setDeploymentState(newState);
        storeState(newState);
        // Start polling when explicitly requested
        if (!polling) {
            setPolling(true);
            setPollingTrigger(!pollingTrigger);
        }
    };
    const getAppDeploymentState = (appId, containerState)=>{
        // First check container state if provided (matches AppliedAppTemplateReviewForm getSubmissionState pattern)
        if (containerState) {
            if (containerState.isWaitingForTemplateSync) return "training";
            if (containerState.multipleTemplateSyncsStatus === "syncing") return "training";
            if (containerState.multipleTemplateSyncsStatus === "error") return "error";
            if (containerState.multipleTemplateSyncsStatus === "success") return "trained";
        }
        // Check deployment state tracking from polling
        if (!deploymentState || !(appId in deploymentState)) return "trained";
        const appState = deploymentState[appId];
        // If no sync ID is being tracked, return trained (no active sync)
        if (!appState.appliedTemplateSyncId) return "trained";
        // Check sync stage from polling (matches AppliedAppTemplateReviewForm pattern)
        if (appState.syncStage === "Processing" || appState.syncStage === "Queued") return "training";
        if (appState.syncStage === "Error") return "error";
        if (appState.syncStage === "Complete") return "trained";
        // Default to trained if no sync stage is set yet
        return "trained";
    };
    const getAppIdsToPoll = ()=>{
        if (!deploymentState) return [];
        const appIds = Object.keys(deploymentState);
        return appIds.filter((appId)=>{
            const st = getAppDeploymentState(appId);
            if (st === "training") return true;
            return false;
        });
    };
    const pollForUnfinishedDeployments = async ()=>{
        const newDeploymentState = {
            ...deploymentState
        };
        const appIds = getAppIdsToPoll();
        // If no apps are in training state, stop polling
        if (appIds.length === 0) {
            setPolling(false);
            return;
        }
        let env = null;
        const newEnvs = [
            ...environments
        ];
        for (const appId of appIds){
            const appliedTemplateSyncId = newDeploymentState[appId].appliedTemplateSyncId;
            // find env for that app
            env = newEnvs.find((e)=>e.applicationId === appId && !e.isDraft && !e.isCustom);
            if (!env) {
                const environmentResults = await _api.getApplicationEnvironments(appId);
                if (environmentResults.resultType == "Ok") {
                    newEnvs.push(...environmentResults.data);
                    env = environmentResults.data.find((e)=>e.applicationId === appId && !e.isDraft && !e.isCustom);
                }
            }
            if (!env) continue;
            if (appliedTemplateSyncId) {
                const result = await _api.getAppliedTemplateSync(appliedTemplateSyncId);
                if (result.resultType == "Ok") {
                    const sync = result.data;
                    // Store the sync stage to match AppliedAppTemplateReviewForm behavior
                    newDeploymentState[appId].syncStage = sync.stage;
                    // Clean up completed or errored syncs - clear the sync ID so they stop being tracked
                    if (sync.stage === "Complete" || sync.stage === "Error") newDeploymentState[appId].appliedTemplateSyncId = undefined;
                }
            } else {
                const publishesResult = await _api.getEnvironmentPublishes(env.id, 0, 50);
                if (publishesResult.resultType == "Ok") {
                    const publishes = publishesResult.data;
                    // get last publish that is complete
                    const lastPublish = publishes.find((p)=>p.stage === "Complete");
                    if (lastPublish) // Mark as complete
                    newDeploymentState[appId].syncStage = "Complete";
                }
            }
        }
        setDeploymentState(newDeploymentState);
        setEnvironments(newEnvs);
        storeState(newDeploymentState);
        // Continue polling only if there are still apps in training state
        await new Promise((r)=>setTimeout(r, 7500));
        setPollingTrigger(!pollingTrigger);
    };
    return {
        setCurrentOrgId,
        pollForApplication,
        getAppDeploymentState,
        deploymentState
    };
}
const SparkDeploymentContainer = (0, _unstatedNext.createContainer)(useSparkDeploymentContainer);
exports.default = SparkDeploymentContainer;

},{"react":"6uln9","unstated-next":"61zE5","../constants/Keys":"4iC9Z","../api":"loxM6","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1g51C":[function(require,module,exports) {
module.exports = require("924a128b706b456e").getBundleURL("kVLro") + require("ba7a6bac665e35f1").resolve("8elmQ");

},{"924a128b706b456e":"c7Tr5","ba7a6bac665e35f1":"fyJL2"}],"5tlsw":[function(require,module,exports) {
module.exports = require("8561fcb26c08b71e").getBundleURL("kVLro") + require("5b77c7fc2e450698").resolve("6JLVS");

},{"8561fcb26c08b71e":"c7Tr5","5b77c7fc2e450698":"fyJL2"}],"6owvk":[function(require,module,exports) {
module.exports = require("c9317fd126bd589d").getBundleURL("kVLro") + require("a2a18bc91e43f86f").resolve("17dg9");

},{"c9317fd126bd589d":"c7Tr5","a2a18bc91e43f86f":"fyJL2"}],"2B5Yl":[function(require,module,exports) {
module.exports = require("14bee3a9a4fff7b1").getBundleURL("kVLro") + require("b03255aed83dcd38").resolve("cLpOP");

},{"14bee3a9a4fff7b1":"c7Tr5","b03255aed83dcd38":"fyJL2"}],"ekINT":[function(require,module,exports) {
module.exports = require("c33d031e28c969d8").getBundleURL("kVLro") + require("69786b595eb28c61").resolve("dlcEQ");

},{"c33d031e28c969d8":"c7Tr5","69786b595eb28c61":"fyJL2"}],"bs6Uz":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "defaultTelephonyDeploymentSettings", ()=>defaultTelephonyDeploymentSettings);
parcelHelpers.export(exports, "availableASRProviders", ()=>availableASRProviders);
var _voices = require("../sparkConstants/voices");
const defaultTelephonyDeploymentSettings = {
    noTracking: false,
    phoneNumberStartsWith: "",
    ttsOptions: [
        {
            ttsProvider: "ElevenLabs",
            ttsVoice: (0, _voices.defaultVoice)
        }
    ],
    locale: "en-US",
    asrProvider: "Deepgram",
    asrEndpointing: 50,
    asrModel: "nova-2",
    asrTier: "",
    performLanguageDetection: false,
    dtmfTurnsToListen: 0,
    ttsPronunciationsMap: "",
    firstMessageDelayMS: 0,
    mergeTurnsAfterPauses: true,
    mergeTurnTimeoutMS: 2000,
    disableBargeIn: false,
    repromptAttempts: 2,
    repromptDelaySeconds: 8,
    name: "",
    proactiveResponseDelayMS: 1300,
    proactiveResponses: "One moment|Let's see|Just a moment|Hold on a sec|Hang on while I check on that|Give me a moment|Hang on while I look into that",
    useProactiveResponses: true,
    maxProactiveResponseAttempts: 1,
    followUpProactiveResponses: "I'm still checking on that|I'm continuing to look into this for you|I'm actively working on this and will update you soon|I'm still looking|I'm making progress on this and will keep you posted",
    disableWelcomeMessageBargeIn: true,
    disableSpeechStarted: false,
    speechStartedUnconfirmedBargeInLimit: 3,
    speechStartedPauseMS: 1000,
    speechStartedRequiredBufferCount: 5,
    callRecordingEnabled: false,
    speechStartedLevel: 0.90,
    attemptInitialTransfer: false,
    initialTransferTimeoutSeconds: 8,
    initialTransferTarget: "",
    initialTransferWithCallingNumber: false,
    virtualNumber: null,
    useVirtualNumber: false,
    shouldProcessAudio: true,
    country: "US",
    followUpProactiveResponsesDelayMS: 8000,
    postProactiveResponsePauseDelayMS: 200,
    disableSpamDetection: true,
    autoTransferPreviouslyTransferred: false,
    immediateTransferHourCutoff: 168,
    // one week
    aiReengageSecondsAfterImmediateTransfer: 12,
    spamDetectionPromptOverride: "",
    spamDetectionTolerance: 0.999,
    spamDetectionTemperature: 0.1,
    spamDetectionGenAiProvider: "",
    tryWebsocketReconnectionOnWelcome: false,
    platform: "Telnyx",
    useGenerativeProactiveResponse: true,
    generativeProactiveResponsePrompt: "",
    lastProactiveResponsesToDisallow: 6,
    notificationEmails: "",
    immediateTransferCallerNumbers: "",
    outboundCallerIdNumber: "",
    useForOutboundCalling: false,
    disableAssistantSpeechCleaning: false,
    optInText: ""
};
const availableASRProviders = [
    "Deepgram",
    "Azure"
];

},{"../sparkConstants/voices":"3U9Ff","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3U9Ff":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "defaultVoice", ()=>defaultVoice);
parcelHelpers.export(exports, "female1Voice", ()=>female1Voice);
parcelHelpers.export(exports, "female2Voice", ()=>female2Voice);
parcelHelpers.export(exports, "female3Voice", ()=>female3Voice);
parcelHelpers.export(exports, "female4Voice", ()=>female4Voice);
parcelHelpers.export(exports, "male1Voice", ()=>male1Voice);
parcelHelpers.export(exports, "male2Voice", ()=>male2Voice);
parcelHelpers.export(exports, "male3Voice", ()=>male3Voice);
parcelHelpers.export(exports, "male4Voice", ()=>male4Voice);
parcelHelpers.export(exports, "defaultRimeVoice", ()=>defaultRimeVoice);
const defaultVoice = "voice_id=tnSpp4vdxKPjI9w0GnoV|model_id=eleven_turbo_v2|stability=0.8|similarity_boost=0.8";
const female1Voice = "voice_id=t51fJYm2fmmjCQAzkR5M|model_id=eleven_turbo_v2|optimize_streaming_latency=2|stability=.40|similarity_boost=.75";
const female2Voice = "voice_id=kLVCa59XE4oxfhTnAvdc|model_id=eleven_turbo_v2|optimize_streaming_latency=2|stability=.50|similarity_boost=.75";
const female3Voice = "voice_id=P7x743VjyZEOihNNygQ9|model_id=eleven_turbo_v2|optimize_streaming_latency=2|stability=.50|similarity_boost=.25";
const female4Voice = "voice_id=sKt7Hq8ey0SpJckxX1by|model_id=eleven_turbo_v2|optimize_streaming_latency=2|stability=.50|similarity_boost=.75";
const male1Voice = "voice_id=Cqvi37TsYKey25WXyNgD|model_id=eleven_turbo_v2|optimize_streaming_latency=2|stability=.40|similarity_boost=1";
const male2Voice = "voice_id=tzRU80bFwNhvoFZKHqEK|model_id=eleven_turbo_v2|optimize_streaming_latency=2|stability=.50|similarity_boost=.50";
const male3Voice = "voice_id=11cp6Oc48SUayWKqAq3z|model_id=eleven_turbo_v2|optimize_streaming_latency=2|stability=.75|similarity_boost=0";
const male4Voice = "voice_id=zf6z4U9028YOsb3qu50O|model_id=eleven_turbo_v2|optimize_streaming_latency=2|stability=.50|similarity_boost=.75";
const defaultRimeVoice = "speaker=grove_rf|speedAlpha=.95";

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"ghV4a":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "voiceOptions", ()=>voiceOptions);
var _voiceRecordingUrls = require("./voiceRecordingUrls");
var _vickyPng = require("../../content/images/spark/Profile_Pics/Vicky.png");
var _vickyPngDefault = parcelHelpers.interopDefault(_vickyPng);
var _halleyPng = require("../../content/images/spark/Profile_Pics/Halley.png");
var _halleyPngDefault = parcelHelpers.interopDefault(_halleyPng);
var _mattPng = require("../../content/images/spark/Profile_Pics/Matt.png");
var _mattPngDefault = parcelHelpers.interopDefault(_mattPng);
var _mauricioPng = require("../../content/images/spark/Profile_Pics/Mauricio.png");
var _mauricioPngDefault = parcelHelpers.interopDefault(_mauricioPng);
var _markPng = require("../../content/images/spark/Profile_Pics/Mark.png");
var _markPngDefault = parcelHelpers.interopDefault(_markPng);
var _ameliaPng = require("../../content/images/spark/Profile_Pics/Amelia.png");
var _ameliaPngDefault = parcelHelpers.interopDefault(_ameliaPng);
var _michaelPng = require("../../content/images/spark/Profile_Pics/Michael.png");
var _michaelPngDefault = parcelHelpers.interopDefault(_michaelPng);
var _alexaPng = require("../../content/images/spark/Profile_Pics/Alexa.png");
var _alexaPngDefault = parcelHelpers.interopDefault(_alexaPng);
var _madeleinePng = require("../../content/images/spark/Profile_Pics/Madeleine.png");
var _madeleinePngDefault = parcelHelpers.interopDefault(_madeleinePng);
var _susanPng = require("../../content/images/spark/Profile_Pics/Susan.png");
var _susanPngDefault = parcelHelpers.interopDefault(_susanPng);
var _sophiePng = require("../../content/images/spark/Profile_Pics/Sophie.png");
var _sophiePngDefault = parcelHelpers.interopDefault(_sophiePng);
var _georgePng = require("../../content/images/spark/Profile_Pics/George.png");
var _georgePngDefault = parcelHelpers.interopDefault(_georgePng);
var _jasonPng = require("../../content/images/spark/Profile_Pics/Jason.png");
var _jasonPngDefault = parcelHelpers.interopDefault(_jasonPng);
var _alexPng = require("../../content/images/spark/Profile_Pics/Alex.png");
var _alexPngDefault = parcelHelpers.interopDefault(_alexPng);
var _amrutPng = require("../../content/images/spark/Profile_Pics/Amrut.png");
var _amrutPngDefault = parcelHelpers.interopDefault(_amrutPng);
var _virajPng = require("../../content/images/spark/Profile_Pics/Viraj.png");
var _virajPngDefault = parcelHelpers.interopDefault(_virajPng);
var _cassidyPng = require("../../content/images/spark/Profile_Pics/Cassidy.png");
var _cassidyPngDefault = parcelHelpers.interopDefault(_cassidyPng);
var _jhennyPng = require("../../content/images/spark/Profile_Pics/Jhenny.png");
var _jhennyPngDefault = parcelHelpers.interopDefault(_jhennyPng);
var _bethPng = require("../../content/images/spark/Profile_Pics/Beth.png");
var _bethPngDefault = parcelHelpers.interopDefault(_bethPng);
var _jessicaPng = require("../../content/images/spark/Profile_Pics/Jessica.png");
var _jessicaPngDefault = parcelHelpers.interopDefault(_jessicaPng);
var _petePng = require("../../content/images/spark/Profile_Pics/Pete.png");
var _petePngDefault = parcelHelpers.interopDefault(_petePng);
var _hopePng = require("../../content/images/spark/Profile_Pics/Hope.png");
var _hopePngDefault = parcelHelpers.interopDefault(_hopePng);
var _jessPng = require("../../content/images/spark/Profile_Pics/Jess.png");
var _jessPngDefault = parcelHelpers.interopDefault(_jessPng);
var _karenPng = require("../../content/images/spark/Profile_Pics/Karen.png");
var _karenPngDefault = parcelHelpers.interopDefault(_karenPng);
var _mariaPng = require("../../content/images/spark/Profile_Pics/Maria.png");
var _mariaPngDefault = parcelHelpers.interopDefault(_mariaPng);
const voiceOptions = [
    {
        value: "Vicky",
        label: "Vicky (ordering default)",
        icon: (0, _vickyPngDefault.default),
        description: "Upbeat and helpful female American accent",
        audioSrc: (0, _voiceRecordingUrls.vickyVoiceRecording),
        provider: "elevenlabs",
        voice: "voice_id=tnSpp4vdxKPjI9w0GnoV|model_id=eleven_turbo_v2|stability=0.8|similarity_boost=0.8"
    },
    {
        value: "Callie",
        label: "Callie (healthcare default)",
        icon: (0, _halleyPngDefault.default),
        description: "Young friendly female with American accent",
        audioSrc: (0, _voiceRecordingUrls.callieVoiceRecording),
        provider: "elevenlabs",
        voice: "voice_id=7YaUDeaStRuoYg3FKsmU|model_id=eleven_flash_v2_5|speed=1.10|stability=1|similarity_boost=.4"
    },
    {
        value: "Alexa",
        label: "Alexa",
        icon: (0, _alexaPngDefault.default),
        description: "Young female with American accent",
        audioSrc: (0, _voiceRecordingUrls.alexaVoiceRecording),
        provider: "elevenlabs",
        voice: "voice_id=t51fJYm2fmmjCQAzkR5M|model_id=eleven_turbo_v2|stability=0.8|similarity_boost=0.8"
    },
    {
        value: "Madeleine",
        label: "Madeleine",
        icon: (0, _madeleinePngDefault.default),
        description: "Middle-aged female with American accent",
        audioSrc: (0, _voiceRecordingUrls.madeleineVoiceRecording),
        provider: "elevenlabs",
        voice: "voice_id=kLVCa59XE4oxfhTnAvdc|model_id=eleven_turbo_v2|stability=0.8|similarity_boost=0.8"
    },
    {
        value: "Susan",
        label: "Susan",
        icon: (0, _susanPngDefault.default),
        description: "Middle-aged female with American accent",
        audioSrc: (0, _voiceRecordingUrls.susanVoiceRecording),
        provider: "elevenlabs",
        voice: "voice_id=P7x743VjyZEOihNNygQ9|model_id=eleven_turbo_v2|stability=0.8|similarity_boost=0.8"
    },
    {
        value: "Sophie",
        label: "Sophie",
        icon: (0, _sophiePngDefault.default),
        description: "Young female with American accent",
        audioSrc: (0, _voiceRecordingUrls.sophieVoiceRecording),
        provider: "elevenlabs",
        voice: "voice_id=sKt7Hq8ey0SpJckxX1by|model_id=eleven_turbo_v2|stability=0.8|similarity_boost=0.8"
    },
    {
        value: "George",
        label: "George",
        icon: (0, _georgePngDefault.default),
        description: "Middle-aged male with American accent",
        audioSrc: (0, _voiceRecordingUrls.georgeVoiceRecording),
        provider: "elevenlabs",
        voice: "voice_id=Cqvi37TsYKey25WXyNgD|model_id=eleven_turbo_v2|stability=0.8|similarity_boost=0.8"
    },
    {
        value: "Jason",
        label: "Jason",
        icon: (0, _jasonPngDefault.default),
        description: "Young male with American accent",
        audioSrc: (0, _voiceRecordingUrls.jasonVoiceRecording),
        provider: "elevenlabs",
        voice: "voice_id=tzRU80bFwNhvoFZKHqEK|model_id=eleven_turbo_v2|stability=0.8|similarity_boost=0.8"
    },
    {
        value: "Alex",
        label: "Alex",
        icon: (0, _alexPngDefault.default),
        description: "Young male with American accent",
        audioSrc: (0, _voiceRecordingUrls.alexVoiceRecording),
        provider: "elevenlabs",
        voice: "voice_id=zf6z4U9028YOsb3qu50O|model_id=eleven_turbo_v2|stability=0.8|similarity_boost=0.8"
    },
    {
        value: "Mauricio",
        label: "Mauricio",
        icon: (0, _mauricioPngDefault.default),
        description: "Smooth and clear young Latino voice",
        audioSrc: (0, _voiceRecordingUrls.mauricioVoiceRecording),
        provider: "elevenlabs",
        voice: "voice_id=94zOad0g7T7K4oa7zhDq|model_id=eleven_turbo_v2|stability=0.8|similarity_boost=0.8"
    },
    {
        value: "Mark",
        label: "Mark",
        icon: (0, _markPngDefault.default),
        description: "Natural and Professional American male voice",
        audioSrc: (0, _voiceRecordingUrls.markVoiceRecording),
        provider: "elevenlabs",
        voice: "voice_id=UgBBYS2sOqTuMpoF3BR0|model_id=eleven_turbo_v2|stability=0.8|similarity_boost=0.8"
    },
    {
        value: "Amelia",
        label: "Amelia",
        icon: (0, _ameliaPngDefault.default),
        description: "Concise and helpful young English female voice",
        audioSrc: (0, _voiceRecordingUrls.ameliaVoiceRecording),
        provider: "elevenlabs",
        voice: "voice_id=ZF6FPAbjXT4488VcRRnw|model_id=eleven_turbo_v2|stability=0.8|similarity_boost=0.8"
    },
    {
        value: "Amrut",
        label: "Amrut",
        icon: (0, _amrutPngDefault.default),
        description: "Clear and calming male Indian Voice",
        audioSrc: (0, _voiceRecordingUrls.amrutVoiceRecording),
        provider: "elevenlabs",
        voice: "voice_id=vO7hjeAjmsdlGgUdvPpe|model_id=eleven_turbo_v2|stability=0.8|similarity_boost=0.8"
    },
    {
        value: "Michael",
        label: "Michael",
        icon: (0, _michaelPngDefault.default),
        description: "Calm and clear male American english voice",
        audioSrc: (0, _voiceRecordingUrls.michaelVoiceRecording),
        provider: "elevenlabs",
        voice: "voice_id=ashjVK50jp28G73AUTnb|model_id=eleven_turbo_v2|stability=0.8|similarity_boost=0.8"
    },
    {
        value: "Viraj",
        label: "Viraj",
        icon: (0, _virajPngDefault.default),
        description: "Smooth and gentle male Indian voice",
        audioSrc: (0, _voiceRecordingUrls.virajVoiceRecording),
        provider: "elevenlabs",
        voice: "voice_id=1U02n4nD6AdIZ9CjF053|model_id=eleven_turbo_v2|stability=0.8|similarity_boost=0.8"
    },
    {
        value: "Halley",
        label: "Halley",
        icon: (0, _halleyPngDefault.default),
        description: "Fun and Bubbly young female American voice",
        audioSrc: (0, _voiceRecordingUrls.halleyVoiceRecording),
        provider: "elevenlabs",
        voice: "voice_id=eBvoGh8YGJn1xokno71w|model_id=eleven_turbo_v2|stability=0.8|similarity_boost=0.8"
    },
    {
        value: "Cassidy",
        label: "Cassidy",
        icon: (0, _cassidyPngDefault.default),
        description: "Direct and smooth female American Voice",
        audioSrc: (0, _voiceRecordingUrls.cassidyVoiceRecording),
        provider: "elevenlabs",
        voice: "voice_id=56AoDkrOh6qfVPDXZ7Pt|model_id=eleven_turbo_v2|stability=0.8|similarity_boost=0.8"
    },
    {
        value: "Jhenny",
        label: "Jhenny",
        icon: (0, _jhennyPngDefault.default),
        description: "Sharp and gentle female Latina voice",
        audioSrc: (0, _voiceRecordingUrls.jhennyVoiceRecording),
        provider: "elevenlabs",
        voice: "voice_id=FXGrCtY3PEyfqczBAlqm|model_id=eleven_turbo_v2|stability=0.8|similarity_boost=0.8"
    },
    {
        value: "Beth",
        label: "Beth",
        icon: (0, _bethPngDefault.default),
        description: "Soothing and professional older female English voice",
        audioSrc: (0, _voiceRecordingUrls.bethVoiceRecording),
        provider: "elevenlabs",
        voice: "voice_id=8N2ng9i2uiUWqstgmWlH|model_id=eleven_turbo_v2|stability=0.8|similarity_boost=0.8"
    },
    {
        value: "Jessica",
        label: "Jessica",
        icon: (0, _jessicaPngDefault.default),
        description: "Fun and gentle Californian female voice",
        audioSrc: (0, _voiceRecordingUrls.jessicaVoiceRecording),
        provider: "elevenlabs",
        voice: "voice_id=FZlijOvmHCYM8RpAxXLJ|model_id=eleven_turbo_v2|stability=0.8|similarity_boost=0.8"
    },
    {
        value: "Pete",
        label: "Pete",
        icon: (0, _petePngDefault.default),
        description: "Simple and Smooth middle-aged American male voice",
        audioSrc: (0, _voiceRecordingUrls.peteVoiceRecording),
        provider: "elevenlabs",
        voice: "voice_id=ChO6kqkVouUn0s7HMunx|model_id=eleven_turbo_v2|stability=0.8|similarity_boost=0.8"
    },
    {
        value: "Hope",
        label: "Hope",
        icon: (0, _hopePngDefault.default),
        description: "Conversational and kind young American female voice",
        audioSrc: (0, _voiceRecordingUrls.hopeVoiceRecording),
        provider: "elevenlabs",
        voice: "voice_id=OYTbf65OHHFELVut7v2H|model_id=eleven_turbo_v2|stability=0.8|similarity_boost=0.8"
    },
    {
        value: "Jess",
        label: "Jess",
        icon: (0, _jessPngDefault.default),
        description: "Clear and professional Australian female voice",
        audioSrc: (0, _voiceRecordingUrls.jessVoiceRecording),
        provider: "elevenlabs",
        voice: "voice_id=ys3XeJJA4ArWMhRpcX1D|model_id=eleven_turbo_v2|stability=0.8|similarity_boost=0.8"
    },
    {
        value: "Matt",
        label: "Matt",
        icon: (0, _mattPngDefault.default),
        description: "Professional and concise American male voice",
        audioSrc: (0, _voiceRecordingUrls.mattVoiceRecording),
        provider: "elevenlabs",
        voice: "voice_id=pwMBn0SsmN1220Aorv15|model_id=eleven_turbo_v2|stability=0.8|similarity_boost=0.8"
    },
    {
        value: "Karen",
        label: "Karen",
        icon: (0, _karenPngDefault.default),
        description: "Concise and helpful young American female voice",
        audioSrc: (0, _voiceRecordingUrls.karenVoiceRecording),
        provider: "elevenlabs",
        voice: "voice_id=LHgFk7RaIiyNE5I3pC1d|model_id=eleven_turbo_v2|stability=0.8|similarity_boost=0.8"
    },
    {
        value: "Maria",
        label: "Maria",
        icon: (0, _mariaPngDefault.default),
        description: "Professional Hispanic multilingual voice",
        audioSrc: (0, _voiceRecordingUrls.mariaVoiceRecording),
        provider: "elevenlabs",
        voice: "voice_id=3liN8q8YoeB9Hk6AboKe|model_id=eleven_multilingual_v2|stability=0.8|similarity_boost=0.8|speed=.97"
    }
];

},{"./voiceRecordingUrls":"cDgdl","../../content/images/spark/Profile_Pics/Vicky.png":"knj35","../../content/images/spark/Profile_Pics/Halley.png":"bxYpz","../../content/images/spark/Profile_Pics/Matt.png":"hhxEA","../../content/images/spark/Profile_Pics/Mauricio.png":"f7ODG","../../content/images/spark/Profile_Pics/Mark.png":"f8enf","../../content/images/spark/Profile_Pics/Amelia.png":"2NOXN","../../content/images/spark/Profile_Pics/Michael.png":"4mcWG","../../content/images/spark/Profile_Pics/Alexa.png":"hBL4r","../../content/images/spark/Profile_Pics/Madeleine.png":"cxp65","../../content/images/spark/Profile_Pics/Susan.png":"kDOxE","../../content/images/spark/Profile_Pics/Sophie.png":"laGcv","../../content/images/spark/Profile_Pics/George.png":"8tVtt","../../content/images/spark/Profile_Pics/Jason.png":"95GCs","../../content/images/spark/Profile_Pics/Alex.png":"isQY4","../../content/images/spark/Profile_Pics/Amrut.png":"lcNz7","../../content/images/spark/Profile_Pics/Viraj.png":"lky8c","../../content/images/spark/Profile_Pics/Cassidy.png":"jqhIE","../../content/images/spark/Profile_Pics/Jhenny.png":"2XN7N","../../content/images/spark/Profile_Pics/Beth.png":"eNUsH","../../content/images/spark/Profile_Pics/Jessica.png":"3Ijku","../../content/images/spark/Profile_Pics/Pete.png":"i5hyU","../../content/images/spark/Profile_Pics/Hope.png":"7Dwj2","../../content/images/spark/Profile_Pics/Jess.png":"guzv6","../../content/images/spark/Profile_Pics/Karen.png":"aEFAN","../../content/images/spark/Profile_Pics/Maria.png":"ITAHR","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"cDgdl":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "alexaVoiceRecording", ()=>alexaVoiceRecording);
parcelHelpers.export(exports, "madeleineVoiceRecording", ()=>madeleineVoiceRecording);
parcelHelpers.export(exports, "susanVoiceRecording", ()=>susanVoiceRecording);
parcelHelpers.export(exports, "sophieVoiceRecording", ()=>sophieVoiceRecording);
parcelHelpers.export(exports, "georgeVoiceRecording", ()=>georgeVoiceRecording);
parcelHelpers.export(exports, "jasonVoiceRecording", ()=>jasonVoiceRecording);
parcelHelpers.export(exports, "alexVoiceRecording", ()=>alexVoiceRecording);
parcelHelpers.export(exports, "callieVoiceRecording", ()=>callieVoiceRecording);
parcelHelpers.export(exports, "vickyVoiceRecording", ()=>vickyVoiceRecording);
parcelHelpers.export(exports, "mauricioVoiceRecording", ()=>mauricioVoiceRecording);
parcelHelpers.export(exports, "markVoiceRecording", ()=>markVoiceRecording);
parcelHelpers.export(exports, "ameliaVoiceRecording", ()=>ameliaVoiceRecording);
parcelHelpers.export(exports, "amrutVoiceRecording", ()=>amrutVoiceRecording);
parcelHelpers.export(exports, "michaelVoiceRecording", ()=>michaelVoiceRecording);
parcelHelpers.export(exports, "virajVoiceRecording", ()=>virajVoiceRecording);
parcelHelpers.export(exports, "halleyVoiceRecording", ()=>halleyVoiceRecording);
parcelHelpers.export(exports, "hopeVoiceRecording", ()=>hopeVoiceRecording);
parcelHelpers.export(exports, "peteVoiceRecording", ()=>peteVoiceRecording);
parcelHelpers.export(exports, "jhennyVoiceRecording", ()=>jhennyVoiceRecording);
parcelHelpers.export(exports, "mattVoiceRecording", ()=>mattVoiceRecording);
parcelHelpers.export(exports, "bethVoiceRecording", ()=>bethVoiceRecording);
parcelHelpers.export(exports, "jessVoiceRecording", ()=>jessVoiceRecording);
parcelHelpers.export(exports, "karenVoiceRecording", ()=>karenVoiceRecording);
parcelHelpers.export(exports, "jessicaVoiceRecording", ()=>jessicaVoiceRecording);
parcelHelpers.export(exports, "cassidyVoiceRecording", ()=>cassidyVoiceRecording);
parcelHelpers.export(exports, "mariaVoiceRecording", ()=>mariaVoiceRecording);
const alexaVoiceRecording = "https://voicify-prod-files.s3.amazonaws.com/spark-voices/female1.mp3";
const madeleineVoiceRecording = "https://voicify-prod-files.s3.amazonaws.com/spark-voices/female2.mp3";
const susanVoiceRecording = "https://voicify-prod-files.s3.amazonaws.com/spark-voices/female3.mp3";
const sophieVoiceRecording = "https://voicify-prod-files.s3.amazonaws.com/spark-voices/female4.mp3";
const georgeVoiceRecording = "https://voicify-prod-files.s3.amazonaws.com/spark-voices/male1.mp3";
const jasonVoiceRecording = "https://voicify-prod-files.s3.amazonaws.com/spark-voices/male2.mp3";
const alexVoiceRecording = "https://voicify-prod-files.s3.amazonaws.com/spark-voices/male4.mp3";
const callieVoiceRecording = "https://voicify-prod-files.s3.us-east-1.amazonaws.com/voices/Callie.mp3";
const vickyVoiceRecording = "https://voicify-prod-files.s3.us-east-1.amazonaws.com/voices/Vicky.mp3";
const mauricioVoiceRecording = "https://voicify-prod-files.s3.us-east-1.amazonaws.com/voices/Mauricio.mp3";
const markVoiceRecording = "https://voicify-prod-files.s3.us-east-1.amazonaws.com/voices/Mark.mp3";
const ameliaVoiceRecording = "https://voicify-prod-files.s3.us-east-1.amazonaws.com/voices/Amelia.mp3";
const amrutVoiceRecording = "https://voicify-prod-files.s3.us-east-1.amazonaws.com/voices/Amrut.mp3";
const michaelVoiceRecording = "https://voicify-prod-files.s3.us-east-1.amazonaws.com/voices/Michael.mp3";
const virajVoiceRecording = "https://voicify-prod-files.s3.us-east-1.amazonaws.com/voices/Viraj.mp3";
const halleyVoiceRecording = "https://voicify-prod-files.s3.us-east-1.amazonaws.com/voices/Halley.mp3";
const hopeVoiceRecording = "https://voicify-prod-files.s3.us-east-1.amazonaws.com/voices/Hope.mp3";
const peteVoiceRecording = "https://voicify-prod-files.s3.us-east-1.amazonaws.com/voices/Pete.mp3";
const jhennyVoiceRecording = "https://voicify-prod-files.s3.us-east-1.amazonaws.com/voices/Jhenny.mp3";
const mattVoiceRecording = "https://voicify-prod-files.s3.us-east-1.amazonaws.com/voices/Matt.mp3";
const bethVoiceRecording = "https://voicify-prod-files.s3.us-east-1.amazonaws.com/voices/Beth.mp3";
const jessVoiceRecording = "https://voicify-prod-files.s3.us-east-1.amazonaws.com/voices/Jess.mp3";
const karenVoiceRecording = "https://voicify-prod-files.s3.us-east-1.amazonaws.com/voices/Karen.mp3";
const jessicaVoiceRecording = "https://voicify-prod-files.s3.us-east-1.amazonaws.com/voices/Jessica.mp3";
const cassidyVoiceRecording = "https://voicify-prod-files.s3.us-east-1.amazonaws.com/voices/Cassidy.mp3";
const mariaVoiceRecording = "https://voicify-prod-files.s3.us-east-1.amazonaws.com/voices/Maria.mp3";

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"knj35":[function(require,module,exports) {
module.exports = require("dc2fc7634fd42bfd").getBundleURL("kVLro") + require("14f8dbd199d9df27").resolve("26SWo");

},{"dc2fc7634fd42bfd":"c7Tr5","14f8dbd199d9df27":"fyJL2"}],"bxYpz":[function(require,module,exports) {
module.exports = require("f82bab76a1ffc27c").getBundleURL("kVLro") + require("4326d9c50f9c0d48").resolve("jSlo6");

},{"f82bab76a1ffc27c":"c7Tr5","4326d9c50f9c0d48":"fyJL2"}],"hhxEA":[function(require,module,exports) {
module.exports = require("7f38f059b49c754b").getBundleURL("kVLro") + require("5c1f03574a8b7806").resolve("1gTO8");

},{"7f38f059b49c754b":"c7Tr5","5c1f03574a8b7806":"fyJL2"}],"f7ODG":[function(require,module,exports) {
module.exports = require("47e5f5b49dbd2ded").getBundleURL("kVLro") + require("480a00941a83bde3").resolve("j887h");

},{"47e5f5b49dbd2ded":"c7Tr5","480a00941a83bde3":"fyJL2"}],"f8enf":[function(require,module,exports) {
module.exports = require("261980508e0be400").getBundleURL("kVLro") + require("99dbb7a7d3686efe").resolve("uJSzq");

},{"261980508e0be400":"c7Tr5","99dbb7a7d3686efe":"fyJL2"}],"2NOXN":[function(require,module,exports) {
module.exports = require("667d14fdc852d3ec").getBundleURL("kVLro") + require("6c3dbefb761fc491").resolve("16psu");

},{"667d14fdc852d3ec":"c7Tr5","6c3dbefb761fc491":"fyJL2"}],"4mcWG":[function(require,module,exports) {
module.exports = require("d53e41717cf2725d").getBundleURL("kVLro") + require("43b0371a49a52004").resolve("htmdW");

},{"d53e41717cf2725d":"c7Tr5","43b0371a49a52004":"fyJL2"}],"hBL4r":[function(require,module,exports) {
module.exports = require("c1fc7e8d54ffae51").getBundleURL("kVLro") + require("7101fbcdfcd53455").resolve("3IEhB");

},{"c1fc7e8d54ffae51":"c7Tr5","7101fbcdfcd53455":"fyJL2"}],"cxp65":[function(require,module,exports) {
module.exports = require("63b4d7ea573acf16").getBundleURL("kVLro") + require("b469da6a9397fe91").resolve("jP9yV");

},{"63b4d7ea573acf16":"c7Tr5","b469da6a9397fe91":"fyJL2"}],"kDOxE":[function(require,module,exports) {
module.exports = require("66887a1c0c3272dd").getBundleURL("kVLro") + require("6aca06f54945717d").resolve("a3Id2");

},{"66887a1c0c3272dd":"c7Tr5","6aca06f54945717d":"fyJL2"}],"laGcv":[function(require,module,exports) {
module.exports = require("7736fa5bf5232cb5").getBundleURL("kVLro") + require("3ca81b1b1382d00c").resolve("6c6Lz");

},{"7736fa5bf5232cb5":"c7Tr5","3ca81b1b1382d00c":"fyJL2"}],"8tVtt":[function(require,module,exports) {
module.exports = require("fac27942994140e3").getBundleURL("kVLro") + require("5f44253d0c653ae9").resolve("kgOB3");

},{"fac27942994140e3":"c7Tr5","5f44253d0c653ae9":"fyJL2"}],"95GCs":[function(require,module,exports) {
module.exports = require("137d9e55c15a0387").getBundleURL("kVLro") + require("c6ccb74c3787d02").resolve("15upD");

},{"137d9e55c15a0387":"c7Tr5","c6ccb74c3787d02":"fyJL2"}],"isQY4":[function(require,module,exports) {
module.exports = require("2a80e204d6416df4").getBundleURL("kVLro") + require("c795dbc03398f1a8").resolve("7SbGi");

},{"2a80e204d6416df4":"c7Tr5","c795dbc03398f1a8":"fyJL2"}],"lcNz7":[function(require,module,exports) {
module.exports = require("1d597cd7e2217b17").getBundleURL("kVLro") + require("5fe6b0bc85f6a35b").resolve("fBvuS");

},{"1d597cd7e2217b17":"c7Tr5","5fe6b0bc85f6a35b":"fyJL2"}],"lky8c":[function(require,module,exports) {
module.exports = require("42d9ffe6636dae8b").getBundleURL("kVLro") + require("b895c962edf0b61d").resolve("ckGdK");

},{"42d9ffe6636dae8b":"c7Tr5","b895c962edf0b61d":"fyJL2"}],"jqhIE":[function(require,module,exports) {
module.exports = require("24472bb33fa3e10b").getBundleURL("kVLro") + require("bfa3bc989805a91c").resolve("eUK3z");

},{"24472bb33fa3e10b":"c7Tr5","bfa3bc989805a91c":"fyJL2"}],"2XN7N":[function(require,module,exports) {
module.exports = require("210baf48930d89e7").getBundleURL("kVLro") + require("9f170c6d1021ed46").resolve("fAvNa");

},{"210baf48930d89e7":"c7Tr5","9f170c6d1021ed46":"fyJL2"}],"eNUsH":[function(require,module,exports) {
module.exports = require("138263df6d39ddd3").getBundleURL("kVLro") + require("a092a7328d2db077").resolve("bWRDf");

},{"138263df6d39ddd3":"c7Tr5","a092a7328d2db077":"fyJL2"}],"3Ijku":[function(require,module,exports) {
module.exports = require("5100c97849f1b67b").getBundleURL("kVLro") + require("b370ae795a4ba6e3").resolve("5YKlB");

},{"5100c97849f1b67b":"c7Tr5","b370ae795a4ba6e3":"fyJL2"}],"i5hyU":[function(require,module,exports) {
module.exports = require("863c7a46d6664755").getBundleURL("kVLro") + require("669da6f23413e8c3").resolve("jMcpp");

},{"863c7a46d6664755":"c7Tr5","669da6f23413e8c3":"fyJL2"}],"7Dwj2":[function(require,module,exports) {
module.exports = require("c52d54dcc43f1fc").getBundleURL("kVLro") + require("60fe473e7da85516").resolve("bXxUe");

},{"c52d54dcc43f1fc":"c7Tr5","60fe473e7da85516":"fyJL2"}],"guzv6":[function(require,module,exports) {
module.exports = require("a20935697faf6a64").getBundleURL("kVLro") + require("7329b7aa23cb5ebc").resolve("3BMaq");

},{"a20935697faf6a64":"c7Tr5","7329b7aa23cb5ebc":"fyJL2"}],"aEFAN":[function(require,module,exports) {
module.exports = require("d5f6b17af7c896fe").getBundleURL("kVLro") + require("8c5a4f46f04561d2").resolve("lc7od");

},{"d5f6b17af7c896fe":"c7Tr5","8c5a4f46f04561d2":"fyJL2"}],"ITAHR":[function(require,module,exports) {
module.exports = require("6c0c1222e6bc7332").getBundleURL("kVLro") + require("c0bba6f9c19553ec").resolve("9BzAv");

},{"6c0c1222e6bc7332":"c7Tr5","c0bba6f9c19553ec":"fyJL2"}],"17yAi":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _base = require("@emotion/styled/base");
var _baseDefault = parcelHelpers.interopDefault(_base);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _textField = require("../../../../components/forms/TextField");
var _textFieldDefault = parcelHelpers.interopDefault(_textField);
var _colors = require("../../../../constants/colors");
var _generativeCallReview = require("../../../../constants/analyticsConstants/generativeCallReview");
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const NotificationEmailsManager = ({ value, onChange, onBlur, fieldContainerStyle })=>{
    const [emailConfigs, setEmailConfigs] = (0, _react1.useState)([]);
    const timeoutRef = (0, _react1.useRef)(null);
    const emailConfigsRef = (0, _react1.useRef)([]);
    // Update ref whenever emailConfigs changes
    (0, _react1.useEffect)(()=>{
        emailConfigsRef.current = emailConfigs;
    }, [
        emailConfigs
    ]);
    // Debounced update function to prevent excessive onChange calls
    const debouncedUpdateValue = (0, _react1.useCallback)(()=>{
        if (timeoutRef.current) clearTimeout(timeoutRef.current);
        timeoutRef.current = setTimeout(()=>{
            const configs = emailConfigsRef.current;
            const emailStrings = configs.map((config)=>{
                // Combine all tags and deduplicate
                const allTags = [];
                const seenTags = new Set();
                // Add required tags
                config.requiredTags.forEach((tag)=>{
                    if (!seenTags.has(tag) && !seenTags.has(`!${tag}`)) {
                        allTags.push(tag);
                        seenTags.add(tag);
                    }
                });
                // Add excluded tags with ! prefix
                config.excludedTags.forEach((tag)=>{
                    const excludedTag = `!${tag}`;
                    if (!seenTags.has(excludedTag) && !seenTags.has(tag)) {
                        allTags.push(excludedTag);
                        seenTags.add(excludedTag);
                    }
                });
                // Add custom tags (may already have ! prefix)
                config.customTags.forEach((tag)=>{
                    const normalizedTag = tag.startsWith("!") ? tag.substring(1) : tag;
                    if (!seenTags.has(tag) && !seenTags.has(normalizedTag) && (!tag.startsWith("!") || !seenTags.has(normalizedTag))) {
                        allTags.push(tag);
                        seenTags.add(tag);
                        if (tag.startsWith("!")) seenTags.add(normalizedTag);
                    }
                });
                if (allTags.length === 0) return config.email || ""; // Return empty string for new emails without address
                else return config.email ? `${config.email}(${allTags.join(",")})` : `(${allTags.join(",")})`;
            }).filter((emailString)=>emailString !== ""); // Only filter out completely empty strings
            console.log(emailStrings.join(","));
            onChange(emailStrings.join(","));
        }, 300); // 300ms debounce
    }, [
        onChange
    ]);
    // Cleanup timeout on unmount
    (0, _react1.useEffect)(()=>{
        return ()=>{
            if (timeoutRef.current) clearTimeout(timeoutRef.current);
        };
    }, []);
    // Parse the value string into email configurations
    (0, _react1.useEffect)(()=>{
        if (!value) {
            setEmailConfigs([]);
            return;
        }
        const configs = [];
        // More sophisticated parsing to handle email(tag1,tag2,tag3) format
        let currentIndex = 0;
        let emailIndex = 0;
        while(currentIndex < value.length){
            let nextComma = value.indexOf(",", currentIndex);
            let nextParen = value.indexOf("(", currentIndex);
            // If no more commas, take the rest of the string
            if (nextComma === -1) nextComma = value.length;
            let emailPart;
            if (nextParen !== -1 && nextParen < nextComma) {
                // This email has conditions - find the matching closing parenthesis
                let parenCount = 1;
                let searchIndex = nextParen + 1;
                while(parenCount > 0 && searchIndex < value.length){
                    if (value[searchIndex] === "(") parenCount++;
                    else if (value[searchIndex] === ")") parenCount--;
                    searchIndex++;
                }
                emailPart = value.substring(currentIndex, searchIndex).trim();
                currentIndex = searchIndex + 1; // Skip the comma after the closing paren
            } else {
                // Simple email without conditions
                emailPart = value.substring(currentIndex, nextComma).trim();
                currentIndex = nextComma + 1;
            }
            if (emailPart) {
                const parenIndex = emailPart.indexOf("(");
                if (parenIndex === -1) // Simple email without conditions
                configs.push({
                    id: `email-${emailIndex}`,
                    email: emailPart,
                    requiredTags: [],
                    excludedTags: [],
                    customTags: [],
                    customTagsInput: ""
                });
                else {
                    // Email with conditions
                    const email = emailPart.substring(0, parenIndex);
                    const conditionsPart = emailPart.substring(parenIndex + 1);
                    const endParen = conditionsPart.lastIndexOf(")");
                    const conditions = endParen !== -1 ? conditionsPart.substring(0, endParen) : conditionsPart;
                    const requiredTags = [];
                    const excludedTags = [];
                    const customTags = [];
                    conditions.split(",").forEach((condition)=>{
                        const trimmed = condition.trim();
                        if (trimmed.startsWith("!")) {
                            const tag = trimmed.substring(1);
                            if ((0, _generativeCallReview.ALL_TAGS_AND_CATEGORIES).includes(tag)) excludedTags.push(tag);
                            else customTags.push(trimmed); // Keep the ! for custom excluded tags
                        } else if ((0, _generativeCallReview.ALL_TAGS_AND_CATEGORIES).includes(trimmed)) requiredTags.push(trimmed);
                        else customTags.push(trimmed);
                    });
                    if (email) configs.push({
                        id: `email-${emailIndex}`,
                        email,
                        requiredTags,
                        excludedTags,
                        customTags,
                        customTagsInput: customTags.join(", ")
                    });
                }
                emailIndex++;
            }
        }
        setEmailConfigs(configs);
    }, [
        value
    ]);
    // Convert email configurations back to string format
    const updateValue = (0, _react1.useCallback)(()=>{
        debouncedUpdateValue();
    }, [
        debouncedUpdateValue
    ]);
    // Immediate update for critical operations (add/remove)
    const immediateUpdateValue = (0, _react1.useCallback)((configs)=>{
        if (timeoutRef.current) clearTimeout(timeoutRef.current);
        const emailStrings = configs.map((config)=>{
            // Combine all tags and deduplicate
            const allTags = [];
            const seenTags = new Set();
            // Add required tags
            config.requiredTags.forEach((tag)=>{
                if (!seenTags.has(tag) && !seenTags.has(`!${tag}`)) {
                    allTags.push(tag);
                    seenTags.add(tag);
                }
            });
            // Add excluded tags with ! prefix
            config.excludedTags.forEach((tag)=>{
                const excludedTag = `!${tag}`;
                if (!seenTags.has(excludedTag) && !seenTags.has(tag)) {
                    allTags.push(excludedTag);
                    seenTags.add(excludedTag);
                }
            });
            // Add custom tags (may already have ! prefix)
            config.customTags.forEach((tag)=>{
                const normalizedTag = tag.startsWith("!") ? tag.substring(1) : tag;
                if (!seenTags.has(tag) && !seenTags.has(normalizedTag) && (!tag.startsWith("!") || !seenTags.has(normalizedTag))) {
                    allTags.push(tag);
                    seenTags.add(tag);
                    if (tag.startsWith("!")) seenTags.add(normalizedTag);
                }
            });
            if (allTags.length === 0) return config.email || ""; // Return empty string for new emails without address
            else return config.email ? `${config.email}(${allTags.join(",")})` : `(${allTags.join(",")})`;
        }).filter((emailString)=>emailString !== ""); // Only filter out completely empty strings
        console.log(emailStrings.join(","));
        onChange(emailStrings.join(","));
    }, [
        onChange
    ]);
    const addEmailConfig = ()=>{
        const newConfig = {
            id: `email-${Date.now()}`,
            email: "",
            requiredTags: [],
            excludedTags: [],
            customTags: [],
            customTagsInput: ""
        };
        const updatedConfigs = [
            ...emailConfigs,
            newConfig
        ];
        setEmailConfigs(updatedConfigs);
    // Don't call immediateUpdateValue here since the email is empty
    // The onChange will be called when user actually enters an email
    };
    const removeEmailConfig = (id)=>{
        const updatedConfigs = emailConfigs.filter((config)=>config.id !== id);
        setEmailConfigs(updatedConfigs);
        immediateUpdateValue(updatedConfigs);
    };
    const updateEmailConfig = (id, updates)=>{
        setEmailConfigs((prevConfigs)=>prevConfigs.map((config)=>config.id === id ? {
                    ...config,
                    ...updates
                } : config));
    };
    const handleTagSelection = (configId, field, tagValue)=>{
        const config = emailConfigs.find((c)=>c.id === configId);
        if (!config) return;
        const currentTags = config[field];
        const isSelected = currentTags.includes(tagValue);
        const oppositeField = field === "requiredTags" ? "excludedTags" : "requiredTags";
        const oppositeTags = config[oppositeField];
        let updatedTags;
        let updatedOppositeTags = oppositeTags;
        if (isSelected) // Unselecting the tag
        updatedTags = currentTags.filter((tag)=>tag !== tagValue);
        else {
            // Selecting the tag - first remove it from the opposite list if it exists
            updatedOppositeTags = oppositeTags.filter((tag)=>tag !== tagValue);
            updatedTags = [
                ...currentTags,
                tagValue
            ];
        }
        // Update both fields to ensure the tag is only in one list
        updateEmailConfig(configId, {
            [field]: updatedTags,
            [oppositeField]: updatedOppositeTags
        });
        // Use debounced update for tag selections
        updateValue();
    };
    return (0, _react.jsx)(Container, null, (0, _react.jsx)(Label, null, "Notification Emails"), (0, _react.jsx)(Description, null, "Set up email addresses and rules for call notifications to this number. By default, notifications are sent to all listed emails. Use tags to control which emails receive specific notifications."), emailConfigs.map((config, index)=>(0, _react.jsx)(EmailConfigContainer, {
            key: config.id
        }, (0, _react.jsx)(EmailConfigHeader, null, (0, _react.jsx)(EmailConfigTitle, null, "Email Configuration ", index + 1), emailConfigs.length > 1 && (0, _react.jsx)(RemoveButton, {
            type: "button",
            onClick: ()=>removeEmailConfig(config.id)
        }, "Remove")), (0, _react.jsx)(EmailTextField, {
            name: `email-${config.id}`,
            value: config.email,
            label: "Email Address",
            placeholder: "example@voicify.com",
            onChange: (e)=>updateEmailConfig(config.id, {
                    email: e.target.value
                }),
            onBlur: ()=>{
                // Only trigger onChange when user finishes editing the email
                updateValue();
                onBlur();
            },
            fieldContainerStyle: fieldContainerStyle
        }), (0, _react.jsx)(TagSection, null, (0, _react.jsx)(TagSectionTitle, null, "Required Tags"), (0, _react.jsx)(Description, null, "Email sent when ALL of these are present:"), (0, _react.jsx)(TagGrid, null, (0, _generativeCallReview.ALL_TAGS_AND_CATEGORIES).map((tag)=>(0, _react.jsx)(TagCheckbox, {
                key: `required-${tag}`
            }, (0, _react.jsx)("input", {
                id: `required-${config.id}-${tag}`,
                type: "checkbox",
                checked: config.requiredTags.includes(tag),
                onChange: ()=>handleTagSelection(config.id, "requiredTags", tag)
            }), (0, _react.jsx)("label", {
                htmlFor: `required-${config.id}-${tag}`
            }, tag))))), (0, _react.jsx)(TagSection, null, (0, _react.jsx)(TagSectionTitle, null, "Excluded Tags"), (0, _react.jsx)(Description, null, "Email NOT sent when ANY of these are present:"), (0, _react.jsx)(TagGrid, null, (0, _generativeCallReview.ALL_TAGS_AND_CATEGORIES).map((tag)=>(0, _react.jsx)(TagCheckbox, {
                key: `excluded-${tag}`
            }, (0, _react.jsx)("input", {
                id: `excluded-${config.id}-${tag}`,
                type: "checkbox",
                checked: config.excludedTags.includes(tag),
                onChange: ()=>handleTagSelection(config.id, "excludedTags", tag)
            }), (0, _react.jsx)("label", {
                htmlFor: `excluded-${config.id}-${tag}`
            }, tag))))), (0, _react.jsx)(CustomTagTextField, {
            name: `custom-tag-${config.id}`,
            value: config.customTagsInput,
            label: "Custom Tags",
            placeholder: "Enter custom tags separated by commas (prefix with ! to exclude, e.g., CUSTOM_TAG1, !CUSTOM_TAG2)",
            onChange: (e)=>{
                // Just update the input string, don't process tags yet
                updateEmailConfig(config.id, {
                    customTagsInput: e.target.value
                });
            },
            onBlur: ()=>{
                // Process the tags when user finishes editing
                const customTagsString = config.customTagsInput;
                const customTags = customTagsString.split(",").map((tag)=>tag.trim()).filter((tag)=>tag.length > 0);
                const updatedConfigs = emailConfigs.map((c)=>c.id === config.id ? {
                        ...c,
                        customTags
                    } : c);
                setEmailConfigs(updatedConfigs);
                immediateUpdateValue(updatedConfigs); // Use immediate update for blur
                onBlur();
            },
            fieldContainerStyle: fieldContainerStyle
        }))), (0, _react.jsx)(AddButton, {
        type: "button",
        onClick: addEmailConfig
    }, "+ Add Email Configuration"));
};
const Container = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "eh8nd6l13"
})({
    name: "1wg6ny0",
    styles: "margin-bottom:26px"
});
const Label = /*#__PURE__*/ (0, _baseDefault.default)("p", {
    target: "eh8nd6l12"
})("font-weight:400;font-size:14px;color:", (0, _colors.color_shades_darkest), ";margin:0 0 8px 0;");
const Description = /*#__PURE__*/ (0, _baseDefault.default)("p", {
    target: "eh8nd6l11"
})("font-size:14px;color:", (0, _colors.color_shades_darker), ";margin:0 0 16px 0;");
const EmailConfigContainer = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "eh8nd6l10"
})({
    name: "q999zb",
    styles: "border:1px solid #e1e1e1;border-radius:4px;padding:16px;margin-bottom:16px;background-color:#fafafa"
});
const EmailConfigHeader = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "eh8nd6l9"
})({
    name: "2ptt9o",
    styles: "display:flex;justify-content:space-between;align-items:center;margin-bottom:16px"
});
const EmailConfigTitle = /*#__PURE__*/ (0, _baseDefault.default)("h4", {
    target: "eh8nd6l8"
})("font-size:14px;font-weight:500;color:", (0, _colors.color_shades_darkest), ";margin:0;");
const EmailTextField = /*#__PURE__*/ (0, _baseDefault.default)((0, _textFieldDefault.default), {
    target: "eh8nd6l7"
})({
    name: "j3ge5y",
    styles: "margin-bottom:16px;font-size:14px"
});
const CustomTagTextField = /*#__PURE__*/ (0, _baseDefault.default)((0, _textFieldDefault.default), {
    target: "eh8nd6l6"
})({
    name: "it1kpl",
    styles: "margin-bottom:0;font-size:14px"
});
const TagSection = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "eh8nd6l5"
})({
    name: "456bw7",
    styles: "margin:24px 0"
});
const TagSectionTitle = /*#__PURE__*/ (0, _baseDefault.default)("p", {
    target: "eh8nd6l4"
})("font-size:14px;font-weight:500;color:", (0, _colors.color_shades_darkest), ";margin:0 0 8px 0;");
const TagGrid = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "eh8nd6l3"
})({
    name: "cl7urv",
    styles: "display:flex;flex-wrap:wrap;gap:8px"
});
const TagCheckbox = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "eh8nd6l2"
})('display:flex;align-items:flex-start;gap:6px;flex-shrink:0;input[type="checkbox"]{margin:0;margin-top:2px;flex-shrink:0;}label{font-size:12px;color:', (0, _colors.color_shades_darkest), ";margin:0;cursor:pointer;white-space:nowrap;line-height:1.3;}");
const RemoveButton = /*#__PURE__*/ (0, _baseDefault.default)("button", {
    target: "eh8nd6l1"
})("background:none;border:none;color:", (0, _colors.color_text_link), ";font-size:14px;cursor:pointer;padding:4px 8px;&:hover{color:#999;}");
const AddButton = /*#__PURE__*/ (0, _baseDefault.default)("button", {
    target: "eh8nd6l0"
})("background:none;border:none;color:", (0, _colors.color_text_link), ";font-size:14px;cursor:pointer;padding:8px 0;&:hover{color:#999;}");
exports.default = NotificationEmailsManager;

},{"@emotion/styled/base":"lSuFu","@emotion/react":"djZKr","react":"6uln9","../../../../components/forms/TextField":"7a7bh","../../../../constants/colors":"1p3OR","../../../../constants/analyticsConstants/generativeCallReview":"5Shd2","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"lNgE9":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _textField = require("../../../../components/forms/TextField");
var _textFieldDefault = parcelHelpers.interopDefault(_textField);
const ImmediateTransferCallerNumbersManager = ({ value, onChange, onBlur, fieldContainerStyle })=>{
    const handleChange = (e)=>{
        onChange(e.target.value);
    };
    const handleBlur = (e)=>{
        const normalized = (e.currentTarget.value ?? "").split(",").map((n)=>n.trim()).filter((n)=>n.length > 0).join(", ");
        onChange(normalized);
        onBlur();
    };
    return (0, _react.jsx)((0, _textFieldDefault.default), {
        name: "immediateTransferCallerNumbers",
        label: "Immediate Transfer Caller Numbers",
        tooltip: 'Make sure to enter the transfer number above in "Default Transfer Phone Number" -- Enter the phone numbers that will be immediately transferred when they call. Separate multiple numbers with commas (e.g. 15551234567, 15559876543).',
        toolTipPosition: "right",
        value: value,
        onChange: handleChange,
        onBlur: handleBlur,
        placeholder: "e.g. 15551234567, 15559876543",
        fieldContainerStyle: fieldContainerStyle
    });
};
exports.default = ImmediateTransferCallerNumbersManager;

},{"@emotion/react":"djZKr","react":"6uln9","../../../../components/forms/TextField":"7a7bh","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"cC28N":[function(require,module,exports) {
module.exports = require("ece86475fbba554b").getBundleURL("kVLro") + require("dcd8221a253a0819").resolve("2geIv");

},{"ece86475fbba554b":"c7Tr5","dcd8221a253a0819":"fyJL2"}],"fitEs":[function(require,module,exports) {
module.exports = require("4124a8c122fc0ec3").getBundleURL("kVLro") + require("e7987c31f1446383").resolve("g63ev");

},{"4124a8c122fc0ec3":"c7Tr5","e7987c31f1446383":"fyJL2"}],"02NtP":[function(require,module,exports) {
module.exports = require("9d4fb37d7b4db6fe").getBundleURL("kVLro") + require("b68da057c11ce8e2").resolve("ZjJir");

},{"9d4fb37d7b4db6fe":"c7Tr5","b68da057c11ce8e2":"fyJL2"}],"hS08u":[function(require,module,exports) {
module.exports = require("8b01ff6ac00d0431").getBundleURL("kVLro") + require("5d15a81c4ea7d13").resolve("jbeLR");

},{"8b01ff6ac00d0431":"c7Tr5","5d15a81c4ea7d13":"fyJL2"}],"lhK3e":[function(require,module,exports) {
module.exports = require("e413ca50e065cedf").getBundleURL("kVLro") + require("b7ce7bfa91a73614").resolve("7igux");

},{"e413ca50e065cedf":"c7Tr5","b7ce7bfa91a73614":"fyJL2"}],"5riL7":[function(require,module,exports) {
module.exports = require("e750d61cdd63aa4d").getBundleURL("kVLro") + require("6d2856002ecb94f9").resolve("boylR");

},{"e750d61cdd63aa4d":"c7Tr5","6d2856002ecb94f9":"fyJL2"}],"1IRBB":[function(require,module,exports) {
module.exports = require("a1ae05908426b728").getBundleURL("kVLro") + require("b96e5c7394e225f6").resolve("bscAr");

},{"a1ae05908426b728":"c7Tr5","b96e5c7394e225f6":"fyJL2"}],"bFn5N":[function(require,module,exports) {
module.exports = require("d53908b6a2ff3510").getBundleURL("kVLro") + require("96d50a14d4e15eb3").resolve("csaym");

},{"d53908b6a2ff3510":"c7Tr5","96d50a14d4e15eb3":"fyJL2"}],"5JN9L":[function(require,module,exports) {
module.exports = require("75c8a38883bd8464").getBundleURL("kVLro") + require("9707f63db097246d").resolve("kXiR6");

},{"75c8a38883bd8464":"c7Tr5","9707f63db097246d":"fyJL2"}],"5D0ds":[function(require,module,exports) {
module.exports = require("b6d8e66ef2c0788d").getBundleURL("kVLro") + require("6240c89cb728f08e").resolve("2BIHN");

},{"b6d8e66ef2c0788d":"c7Tr5","6240c89cb728f08e":"fyJL2"}],"bHRRK":[function(require,module,exports) {
module.exports = require("316d442f3c84e1ed").getBundleURL("kVLro") + require("61cb800a004772c6").resolve("4FkBx");

},{"316d442f3c84e1ed":"c7Tr5","61cb800a004772c6":"fyJL2"}],"knnkL":[function(require,module,exports) {
module.exports = require("ae256b1557e7e279").getBundleURL("kVLro") + require("3444c92016d0e67c").resolve("3M2in");

},{"ae256b1557e7e279":"c7Tr5","3444c92016d0e67c":"fyJL2"}],"932G9":[function(require,module,exports) {
module.exports = require("1a3702ef4ec3e52d").getBundleURL("kVLro") + require("865c5094205a0911").resolve("4dQpL");

},{"1a3702ef4ec3e52d":"c7Tr5","865c5094205a0911":"fyJL2"}],"duQQT":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _base = require("@emotion/styled/base");
var _baseDefault = parcelHelpers.interopDefault(_base);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _colors = require("../../../constants/colors");
var _roundedSelectionRow = require("../../../components/general/RoundedSelectionRow");
var _roundedSelectionRowDefault = parcelHelpers.interopDefault(_roundedSelectionRow);
var _button = require("../../../components/general/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _css = require("@emotion/css");
var _interactionModelUiStateContainer = require("../../../hooks/InteractionModelUiStateContainer");
var _interactionModelUiStateContainerDefault = parcelHelpers.interopDefault(_interactionModelUiStateContainer);
var _featureFlagIds = require("../../../constants/featureFlagIds");
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const alertIcon = require("fdbb71b5ddf1e8d9");
const InteractionModelSettingsHeader = (props)=>{
    const uiStateContainer = (0, _interactionModelUiStateContainerDefault.default).useContainer();
    (0, _react1.useEffect)(()=>{
        uiStateContainer.setTriggerSaveChanges(false);
    }, []);
    const showMenuTab = props.appContainer?.state?.currentApp?.featureFlags?.some((flag)=>flag.id === (0, _featureFlagIds.FoodOrderingFeatureFlagId));
    const getOptions = ()=>{
        const option = [
            {
                name: "Entities"
            },
            {
                name: "Intents"
            }
        ];
        if (showMenuTab) option.push({
            name: "Menu"
        });
        if (props.appContainer?.state?.currentApp?.featureFlags?.length > 0) option.push({
            name: "Feature Settings"
        });
        return option;
    };
    if (!!Object.keys(uiStateContainer?.errors?.nlpEntities ?? {})?.length) {
        getOptions()[0].icon = alertIcon;
        getOptions()[0].selectedIcon = alertIcon;
    }
    if (!!Object.keys(uiStateContainer?.errors?.interactionModel ?? {})?.length) {
        getOptions()[1].icon = alertIcon;
        getOptions()[1].selectedIcon = alertIcon;
    }
    const selectedFilter = (tabs)=>{
        var options = getOptions();
        const tabPath = window.location.pathname.split("/").pop();
        if (tabPath === "featureSettings") {
            if (options.some((o)=>o.name == "Menu")) return 3;
            return 2;
        }
        switch(tabs){
            case "Entities":
                return 0;
            case "Intents":
                return 1;
            case "Menu":
                return 2;
            case "Feature Settings":
                return 3;
            default:
                return 0;
        }
    };
    var options = getOptions();
    return (0, _react.jsx)(InteractionModelAdditionalHeader, null, (0, _react.jsx)("span", {
        className: "header-title"
    }, "NLP Model"), (0, _react.jsx)(ToggleContainer, null, (0, _react.jsx)((0, _roundedSelectionRowDefault.default), {
        key: "nlu-sections-selector",
        options: options,
        className: roundedSelectStyle,
        optionClassName: roundedOptionStyle,
        optionTextClassName: optionTextStyle,
        onClick: (num)=>props.history.push(`/v/apps/${props.applicationId}/appSettings/nlp/${num === 1 ? "intents" : num === 2 ? options.some((o)=>o.name == "Menu") ? "menu" : "featureSettings" : num === 3 ? "featureSettings" : "entities"}`),
        selectedFilter: selectedFilter(uiStateContainer.nluTab)
    })), uiStateContainer.nluTab !== "Feature Settings" && (0, _react.jsx)(SaveChangesButton, {
        type: "button",
        themes: [
            "primary-small"
        ],
        text: "Save Changes",
        onClick: ()=>uiStateContainer.setTriggerSaveChanges(true)
    }));
};
exports.default = InteractionModelSettingsHeader;
const AdditionalHeader = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e2i1s0h3"
})("display:flex;flex-direction:row;margin-right:100vw;padding-left:32px;margin-left:7px;white-space:nowrap;border-left:1px solid ", (0, _colors.color_shades_dark), ";height:100%;padding-top:0;.header-title{padding:16px 16px 0 0;}");
const InteractionModelAdditionalHeader = /*#__PURE__*/ (0, _baseDefault.default)(AdditionalHeader, {
    target: "e2i1s0h2"
})({
    name: "wbf8tc",
    styles: "margin-right:0px;margin-left:7px;width:100%"
});
const ToggleContainer = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e2i1s0h1"
})({
    name: "9xv2r8",
    styles: "min-width:349px;padding:0 10px 10px 0;margin:8px auto 0 0"
});
const SaveChangesButton = /*#__PURE__*/ (0, _baseDefault.default)((0, _buttonDefault.default), {
    target: "e2i1s0h0"
})({
    name: "1blsetw",
    styles: "margin-top:12px;margin-right:32px"
});
const roundedSelectStyle = /*#__PURE__*/ (0, _css.css)({
    name: "s0vnfv",
    styles: "height:32px"
});
const optionTextStyle = /*#__PURE__*/ (0, _css.css)({
    name: "11rcwxl",
    styles: "margin-bottom:4px"
});
const roundedOptionStyle = /*#__PURE__*/ (0, _css.css)({
    name: "v5zuxa",
    styles: "height:35px"
});

},{"@emotion/styled/base":"lSuFu","@emotion/react":"djZKr","react":"6uln9","../../../constants/colors":"1p3OR","../../../components/general/RoundedSelectionRow":"dUH5O","../../../components/general/Button":"6ymxN","@emotion/css":"awUBr","../../../hooks/InteractionModelUiStateContainer":"2A95n","../../../constants/featureFlagIds":"33vuW","fdbb71b5ddf1e8d9":"cRA6k","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jBhmL":[function(require,module,exports) {
module.exports = require("de9b6647ca31172e").getBundleURL("kVLro") + require("5176464f1d173828").resolve("cMzqM");

},{"de9b6647ca31172e":"c7Tr5","5176464f1d173828":"fyJL2"}],"lxrDl":[function(require,module,exports) {
module.exports = require("93e2b3dabf8685c1").getBundleURL("kVLro") + require("d38c58bb97e87879").resolve("jOiAN");

},{"93e2b3dabf8685c1":"c7Tr5","d38c58bb97e87879":"fyJL2"}],"7eCA0":[function(require,module,exports) {
module.exports = require("e25654fd5f637e1f").getBundleURL("kVLro") + require("cb7eb49b27e0770b").resolve("1ak8I");

},{"e25654fd5f637e1f":"c7Tr5","cb7eb49b27e0770b":"fyJL2"}],"cysx1":[function(require,module,exports) {
module.exports = require("a408766404dca4ef").getBundleURL("kVLro") + require("f151904e809132c").resolve("52s3o");

},{"a408766404dca4ef":"c7Tr5","f151904e809132c":"fyJL2"}],"5dRXN":[function(require,module,exports) {
module.exports = require("d9dd2f1e80eb55dd").getBundleURL("kVLro") + require("23a91f7201e07e4e").resolve("a0akU");

},{"d9dd2f1e80eb55dd":"c7Tr5","23a91f7201e07e4e":"fyJL2"}],"7CibP":[function(require,module,exports) {
module.exports = require("f2f51e486fa97229").getBundleURL("kVLro") + require("65df925baab811ae").resolve("9KLRl");

},{"f2f51e486fa97229":"c7Tr5","65df925baab811ae":"fyJL2"}],"8OyYY":[function(require,module,exports) {
module.exports = require("b968e0f4f75d2f06").getBundleURL("kVLro") + require("1d72b3172a77351e").resolve("kMIEo");

},{"b968e0f4f75d2f06":"c7Tr5","1d72b3172a77351e":"fyJL2"}],"5B14D":[function(require,module,exports) {
module.exports = require("2c3fcb19cb8a82cc").getBundleURL("kVLro") + require("287993859810df76").resolve("lJjlm");

},{"2c3fcb19cb8a82cc":"c7Tr5","287993859810df76":"fyJL2"}],"eKxIN":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _unstated = require("unstated");
var _applicationContainer = require("../../state/containers/ApplicationContainer");
var _applicationContainerDefault = parcelHelpers.interopDefault(_applicationContainer);
var _userContainer = require("../../state/containers/UserContainer");
var _userContainerDefault = parcelHelpers.interopDefault(_userContainer);
var _mediaContainer = require("../../state/containers/MediaContainer");
var _mediaContainerDefault = parcelHelpers.interopDefault(_mediaContainer);
var _mediaResponseContainer = require("../../state/containers/MediaResponseContainer");
var _mediaResponseContainerDefault = parcelHelpers.interopDefault(_mediaResponseContainer);
var _ssmlContainer = require("../../state/containers/SsmlContainer");
var _ssmlContainerDefault = parcelHelpers.interopDefault(_ssmlContainer);
var _simulator = require("./components/Simulator");
var _simulatorDefault = parcelHelpers.interopDefault(_simulator);
var _exitMessageContainer = require("../../state/containers/ExitMessageContainer");
var _exitMessageContainerDefault = parcelHelpers.interopDefault(_exitMessageContainer);
var _customRequestContainer = require("../../state/containers/CustomRequestContainer");
var _customRequestContainerDefault = parcelHelpers.interopDefault(_customRequestContainer);
var _helpMessageContainer = require("../../state/containers/HelpMessageContainer");
var _helpMessageContainerDefault = parcelHelpers.interopDefault(_helpMessageContainer);
var _fallbackMessageContainer = require("../../state/containers/FallbackMessageContainer");
var _fallbackMessageContainerDefault = parcelHelpers.interopDefault(_fallbackMessageContainer);
var _welcomeMessageContainer = require("../../state/containers/WelcomeMessageContainer");
var _welcomeMessageContainerDefault = parcelHelpers.interopDefault(_welcomeMessageContainer);
var _questionAnswerContainer = require("../../state/containers/QuestionAnswerContainer");
var _questionAnswerContainerDefault = parcelHelpers.interopDefault(_questionAnswerContainer);
var _latestMessageContainer = require("../../state/containers/LatestMessageContainer");
var _latestMessageContainerDefault = parcelHelpers.interopDefault(_latestMessageContainer);
var _simpleChoiceContainer = require("../../state/containers/SimpleChoiceContainer");
var _simpleChoiceContainerDefault = parcelHelpers.interopDefault(_simpleChoiceContainer);
var _numberRangeContainer = require("../../state/containers/NumberRangeContainer");
var _numberRangeContainerDefault = parcelHelpers.interopDefault(_numberRangeContainer);
var _featureTypeIds = require("../../constants/featureTypeIds");
var _userApplicationPreferencesContainer = require("../../state/containers/UserApplicationPreferencesContainer");
var _userApplicationPreferencesContainerDefault = parcelHelpers.interopDefault(_userApplicationPreferencesContainer);
const ApplicationSimulator = ({ applicationId })=>(0, _react.jsx)((0, _unstated.Subscribe), {
        to: [
            (0, _applicationContainerDefault.default),
            (0, _userContainerDefault.default),
            (0, _userApplicationPreferencesContainerDefault.default),
            (0, _mediaContainerDefault.default),
            (0, _mediaResponseContainerDefault.default),
            (0, _ssmlContainerDefault.default),
            (0, _customRequestContainerDefault.default),
            (0, _exitMessageContainerDefault.default),
            (0, _fallbackMessageContainerDefault.default),
            (0, _helpMessageContainerDefault.default),
            (0, _latestMessageContainerDefault.default),
            (0, _simpleChoiceContainerDefault.default),
            (0, _numberRangeContainerDefault.default),
            (0, _questionAnswerContainerDefault.default),
            (0, _welcomeMessageContainerDefault.default)
        ]
    }, (appContainer, userContainer, userApplicationPreferencesContainer, mediaContainer, mediaResponseContainer, ssmlContainer, customRequestContainer, exitContainer, fallbackContainer, helpContainer, latestMessageContainer, simpleChoiceContainer, numberRangeContainer, questionAnswerContainer, welcomeContainer)=>{
        const contentContainers = {};
        contentContainers[0, _featureTypeIds.CustomRequestsFeatureTypeId] = customRequestContainer;
        contentContainers[0, _featureTypeIds.ExitMessagesFeatureTypeId] = exitContainer;
        contentContainers[0, _featureTypeIds.FallbackFeatureTypeId] = fallbackContainer;
        contentContainers[0, _featureTypeIds.HelpMessagesFeatureTypeId] = helpContainer;
        contentContainers[0, _featureTypeIds.LatestMessagesFeatureTypeId] = latestMessageContainer;
        contentContainers[0, _featureTypeIds.SimpleChoiceFeatureTypeId] = simpleChoiceContainer;
        contentContainers[0, _featureTypeIds.NumberRangeFeatureTypeId] = numberRangeContainer;
        contentContainers[0, _featureTypeIds.QuestionAnswerFeatureTypeId] = questionAnswerContainer;
        contentContainers[0, _featureTypeIds.WelcomeMessagesFeatureTypeId] = welcomeContainer;
        return (0, _react.jsx)((0, _simulatorDefault.default), {
            appContainer: appContainer,
            userContainer: userContainer,
            userApplicationPreferencesContainer: userApplicationPreferencesContainer,
            mediaContainer: mediaContainer,
            mediaResponseContainer: mediaResponseContainer,
            ssmlContainer: ssmlContainer,
            applicationId: applicationId,
            contentContainers: contentContainers
        });
    });
exports.default = ApplicationSimulator;

},{"@emotion/react":"djZKr","react":"6uln9","unstated":"grh7p","../../state/containers/ApplicationContainer":"cuqi2","../../state/containers/UserContainer":"jDrDR","../../state/containers/MediaContainer":"ch6Xu","../../state/containers/MediaResponseContainer":"1ccrV","../../state/containers/SsmlContainer":"bwJDI","./components/Simulator":"5kqIY","../../state/containers/ExitMessageContainer":"lSKl8","../../state/containers/CustomRequestContainer":"aVO05","../../state/containers/HelpMessageContainer":"2oQaX","../../state/containers/FallbackMessageContainer":"kKZMo","../../state/containers/WelcomeMessageContainer":"j3orW","../../state/containers/QuestionAnswerContainer":"hfasy","../../state/containers/LatestMessageContainer":"1Hdqb","../../state/containers/SimpleChoiceContainer":"hO0x5","../../state/containers/NumberRangeContainer":"an6iC","../../constants/featureTypeIds":"hPLMP","../../state/containers/UserApplicationPreferencesContainer":"2fhAM","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"5kqIY":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _simulatorInteraction = require("./SimulatorInteraction");
var _simulatorInteractionDefault = parcelHelpers.interopDefault(_simulatorInteraction);
var _simulatorInputPanel = require("./SimulatorInputPanel");
var _simulatorInputPanelDefault = parcelHelpers.interopDefault(_simulatorInputPanel);
var _loader = require("../../../components/general/Loader");
var _loaderDefault = parcelHelpers.interopDefault(_loader);
var _simulatorOutputPanel = require("./SimulatorOutputPanel");
var _simulatorOutputPanelDefault = parcelHelpers.interopDefault(_simulatorOutputPanel);
var _pageError = require("../../../components/general/PageError");
var _pageErrorDefault = parcelHelpers.interopDefault(_pageError);
var _panelContainer = require("../../../components/structure/Panels/PanelContainer");
var _panelContainerDefault = parcelHelpers.interopDefault(_panelContainer);
var _simulatorContainer = require("../../../hooks/SimulatorContainer");
var _simulatorContainerDefault = parcelHelpers.interopDefault(_simulatorContainer);
var _testCaseContainer = require("../../../hooks/TestCaseContainer");
var _testCaseContainerDefault = parcelHelpers.interopDefault(_testCaseContainer);
var _editTestCase = require("../../../components/forms/EditTestCase");
var _editTestCaseDefault = parcelHelpers.interopDefault(_editTestCase);
const Simulator = (props)=>{
    const messageBarInput = (0, _react1.useRef)(null);
    const [testCaseToCreate, setTestCaseToCreate] = (0, _react1.useState)(null);
    const application = props.appContainer.state.currentApp;
    const simulatorContainer = (0, _simulatorContainerDefault.default).useContainer();
    const testCaseContainer = (0, _testCaseContainerDefault.default).useContainer();
    (0, _react1.useEffect)(()=>{
        const selectedLanguage = application?.languages?.length > 0 ? application.languages.find((l)=>l.id == application.defaultLanguageId) ?? application?.languages[0] : null;
        simulatorContainer.handleLanguageSelected(selectedLanguage);
        const asyncLoad = async ()=>{
            await props.appContainer.loadCurrentAppById(props.applicationId);
            let devices = props.mediaResponseContainer.state.deviceTargets;
            if (!(devices?.length > 0)) {
                const result = await props.mediaResponseContainer.getDeviceTargets();
                devices = result.data;
            }
            const alexaSpeaker = devices.find((d)=>d.assistant == "Alexa" && d.supportsRichAudio && !d.supportsForegroundImages);
            simulatorContainer.handleDeviceSelected(alexaSpeaker);
        };
        asyncLoad();
    }, [
        props.applicationId
    ]);
    const handleSendMessage = async (text)=>{
        await sendMessage(text, application);
    };
    const simulateTestCase = async (testCase)=>{
        simulatorContainer.runTestCase(application, testCase, props.userContainer.state.currentUser.id);
    };
    const handleSendWelcome = async ()=>{
        const text = `Open ${application.invocationPhrase}`;
        await sendMessage(text, application);
    };
    const createTestCase = async ()=>{
        const tc = simulatorContainer.createTestCaseFromHistory(props.userContainer.state.currentUser.id);
        setTestCaseToCreate(tc);
    };
    const sendMessage = async (text, application)=>{
        simulatorContainer.addMessage(text);
        await simulatorContainer.sendCustomAssistantRequest(application, text, props.userContainer.state.currentUser.id, simulatorContainer.sessionId, simulatorContainer.selectedLanguage, props.contentContainers);
        messageBarInput?.current.focus();
    };
    if (!(props.mediaResponseContainer.state.deviceTargets?.length > 0)) return (0, _react.jsx)((0, _loaderDefault.default), null);
    return (0, _react.jsx)((0, _reactDefault.default).Fragment, null, (0, _react.jsx)((0, _panelContainerDefault.default), null, (0, _react.jsx)((0, _simulatorInputPanelDefault.default), {
        appContainer: props.appContainer,
        handleSendWelcome: handleSendWelcome,
        userApplicationPreferencesContainer: props.userApplicationPreferencesContainer,
        applicationId: application.id,
        languages: application.languages,
        requests: simulatorContainer.requests,
        selectedLanguage: simulatorContainer.selectedLanguage,
        handleSendMessage: handleSendMessage,
        handleLanguageSelected: (language)=>simulatorContainer.handleLanguageSelected(language),
        handleStartNewSession: simulatorContainer.startNewSession,
        simulateTestCase: simulateTestCase
    }), (0, _react.jsx)((0, _simulatorInteractionDefault.default), {
        applicationId: application.id,
        handleSendWelcome: handleSendWelcome,
        responseContainer: props.mediaResponseContainer,
        userApplicationPreferencesContainer: props.userApplicationPreferencesContainer,
        ssmlContainer: props.ssmlContainer,
        requests: simulatorContainer.requests,
        responses: simulatorContainer.responses,
        selectedLanguage: simulatorContainer.selectedLanguage,
        selectedDevice: simulatorContainer.deviceTarget,
        isWaitingForResponse: simulatorContainer.isWaitingForResponse,
        handleSendMessage: handleSendMessage,
        handleDeviceSelected: (dev)=>simulatorContainer.handleDeviceSelected(dev),
        simulatorMessageBarInputRef: messageBarInput,
        handleSetEnvironment: (env)=>simulatorContainer.setEnvironment(env),
        useDraftContent: simulatorContainer.useDraftContent,
        createTestCase: ()=>{
            createTestCase();
        }
    }), (0, _react.jsx)((0, _simulatorOutputPanelDefault.default), {
        conversationHistory: simulatorContainer.getConversationHistory(),
        contentItems: simulatorContainer.contentItemsFromHistory
    })), testCaseToCreate !== null ? (0, _react.jsx)((0, _editTestCaseDefault.default), {
        initialValue: testCaseToCreate,
        onSave: async (tc)=>{
            await testCaseContainer.createTestCase(props.applicationId, tc);
            await testCaseContainer.loadAppLevelTestCases(props.applicationId);
            setTestCaseToCreate(null);
        },
        onClose: ()=>setTestCaseToCreate(null),
        isContentItemView: false
    }) : (0, _react.jsx)((0, _reactDefault.default).Fragment, null), (0, _react.jsx)((0, _pageErrorDefault.default), {
        errors: [
            ...simulatorContainer.errors ?? [],
            ...props.appContainer?.state?.errors ?? [],
            ...props.userContainer?.state?.errors ?? [],
            ...props.userApplicationPreferencesContainer?.state?.errors ?? [],
            ...props.mediaContainer?.state?.errors ?? [],
            ...props.mediaResponseContainer?.state?.errors ?? [],
            ...props.ssmlContainer?.state?.errors ?? []
        ],
        onClear: ()=>{
            simulatorContainer.clearErrors();
            props.appContainer.clearErrors();
            props.userContainer.clearErrors();
            props.userApplicationPreferencesContainer.clearErrors();
            props.mediaContainer.clearErrors();
            props.mediaResponseContainer.clearErrors();
            props.ssmlContainer.clearErrors();
        }
    }));
};
exports.default = Simulator;

},{"@emotion/react":"djZKr","react":"6uln9","./SimulatorInteraction":"56u4e","./SimulatorInputPanel":"4hV53","../../../components/general/Loader":"bnV5T","./SimulatorOutputPanel":"a7vuP","../../../components/general/PageError":"ezFTm","../../../components/structure/Panels/PanelContainer":"9R2lE","../../../hooks/SimulatorContainer":"gOZ3V","../../../hooks/TestCaseContainer":"cLg3U","../../../components/forms/EditTestCase":"ePcs7","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"56u4e":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _base = require("@emotion/styled/base");
var _baseDefault = parcelHelpers.interopDefault(_base);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _simulatorMessageBar = require("./SimulatorMessageBar");
var _simulatorMessageBarDefault = parcelHelpers.interopDefault(_simulatorMessageBar);
var _deviceAndEnvironmentPicker = require("./DeviceAndEnvironmentPicker");
var _deviceAndEnvironmentPickerDefault = parcelHelpers.interopDefault(_deviceAndEnvironmentPicker);
var _simulatorConversationViewer = require("./SimulatorConversationViewer");
var _simulatorConversationViewerDefault = parcelHelpers.interopDefault(_simulatorConversationViewer);
var _colors = require("../../../constants/colors");
const SimulatorInteraction = (props)=>(0, _react.jsx)(SimulatorInteractionContainer, null, (0, _react.jsx)((0, _deviceAndEnvironmentPickerDefault.default), {
        availableDevices: props.responseContainer.state.deviceTargets,
        selectedTarget: props.selectedDevice,
        onSetEnvironment: props.handleSetEnvironment,
        useDraftContent: props.useDraftContent,
        onDeviceSelectionChange: props.handleDeviceSelected.bind(undefined)
    }), (0, _react.jsx)((0, _simulatorConversationViewerDefault.default), {
        applicationId: props.applicationId,
        ssmlContainer: props.ssmlContainer,
        selectedDevice: props.selectedDevice,
        selectedLanguage: props.selectedLanguage,
        userApplicationPreferencesContainer: props.userApplicationPreferencesContainer,
        requests: props.requests,
        responses: props.responses,
        handleSendMessage: props.handleSendMessage,
        createTestCase: props.createTestCase
    }), (0, _react.jsx)((0, _simulatorMessageBarDefault.default), {
        showSendWelcomeButton: props.requests.length == 0,
        simulatorMessageBarInputRef: props.simulatorMessageBarInputRef,
        onSubmit: props.handleSendMessage,
        handleSendWelcome: props.handleSendWelcome,
        selectedLanguage: props.selectedLanguage,
        isDisabled: props.isWaitingForResponse || !props.selectedLanguage
    }));
const SimulatorInteractionContainer = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1611sea0"
})("height:100%;display:flex;flex-direction:column;justify-content:space-between;flex:2;background:", (0, _colors.color_shades_lighter), ";border:1px solid ", (0, _colors.color_shades_dark), ";border-top:none;position:relative;>*{width:calc(100%-15px);}");
exports.default = SimulatorInteraction;

},{"@emotion/styled/base":"lSuFu","@emotion/react":"djZKr","react":"6uln9","./SimulatorMessageBar":"ez4fU","./DeviceAndEnvironmentPicker":"kq1X3","./SimulatorConversationViewer":"5AMPD","../../../constants/colors":"1p3OR","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"ez4fU":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _colors = require("../../../constants/colors");
var _button = require("../../../components/general/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _stylesValues = require("../../../constants/stylesValues");
var _simulatorContainer = require("../../../hooks/SimulatorContainer");
var _simulatorContainerDefault = parcelHelpers.interopDefault(_simulatorContainer);
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const welcomeIconBlack = require("34cda641c8a11251");
const sendIcon = require("c11fcc8a9a203fcc");
const micIcon = require("abf038bf959ee4ff");
const SimulatorMessageBar = (props)=>{
    const [text, setText] = (0, _react1.useState)("");
    const [isMicOpen, setIsMicOpen] = (0, _react1.useState)(false);
    const simulatorContainer = (0, _simulatorContainerDefault.default).useContainer();
    let recognition = null;
    if (window["SpeechRecognition"] || window["webkitSpeechRecognition"]) {
        const SpeechRecognition = window["SpeechRecognition"] || window["webkitSpeechRecognition"];
        recognition = new SpeechRecognition();
        recognition.lang = props.selectedLanguage?.shortCode ?? "en-US";
        // This runs when the speech recognition service starts
        recognition.onstart = function() {
            // start recognition
            setIsMicOpen(true);
        };
        recognition.onerror = ()=>{
            setIsMicOpen(false);
        };
        recognition.onspeechend = function() {
            // when user is done speaking
            recognition.stop();
            setIsMicOpen(false);
        };
        // This runs when the speech recognition service returns result
        recognition.onresult = function(event) {
            const transcript = event.results[0][0].transcript;
            setText(transcript);
            if (transcript?.length > 0) submit();
        };
    }
    (0, _react1.useEffect)(()=>{
        if (recognition && props.selectedLanguage?.shortCode != props.selectedLanguage?.shortCode) recognition.lang = props.selectedLanguage?.shortCode ?? "en-US";
    }, [
        props.selectedLanguage
    ]);
    (0, _react1.useEffect)(()=>{
        if (simulatorContainer.inputText?.length) {
            props.onSubmit(simulatorContainer.inputText, props.selectedLanguage);
            simulatorContainer.setInputText("");
        }
    }, [
        simulatorContainer.inputText
    ]);
    const handleStartListening = ()=>{
        recognition.start();
    };
    const handleSubmit = (e)=>{
        e.preventDefault();
        submit();
    };
    const submit = ()=>{
        if (text) {
            props.onSubmit(text, props.selectedLanguage);
            setText("");
        }
    };
    const handleTextChange = (e)=>{
        setText(e.target.value);
        simulatorContainer.setInputText("");
    };
    return (0, _react.jsx)("div", {
        className: containerStyle
    }, props.showSendWelcomeButton && (0, _react.jsx)((0, _buttonDefault.default), {
        className: welcomeButton,
        icon: welcomeIconBlack,
        themes: [
            "white-pill"
        ],
        disabled: !props.showSendWelcomeButton,
        text: "Welcome",
        onClick: ()=>props.handleSendWelcome()
    }), (0, _react.jsx)("form", {
        onSubmit: handleSubmit
    }, (0, _react.jsx)("div", {
        className: `message-bar-input ${props.isDisabled ? "disabled" : ""} ac-simulator-message-bar`
    }, recognition && (0, _react.jsx)("button", {
        type: "button",
        className: "mic-button",
        onClick: handleStartListening
    }, (0, _react.jsx)("img", {
        src: micIcon
    }), (0, _react.jsx)("p", null, isMicOpen ? "Listening" : "Click to Speak")), (0, _react.jsx)("input", {
        ref: props.simulatorMessageBarInputRef,
        disabled: props.isDisabled,
        name: "text",
        placeholder: "Type Something Here",
        type: "text",
        value: text,
        onChange: handleTextChange
    }), (0, _react.jsx)("button", {
        className: "submit-button",
        type: "submit"
    }, (0, _react.jsx)("img", {
        src: sendIcon
    })))));
};
const welcomeButton = /*#__PURE__*/ (0, _css.css)({
    name: "1nc8fsl",
    styles: "position:absolute;top:-56px;left:0px"
});
const containerStyle = /*#__PURE__*/ (0, _css.css)("background:", (0, _colors.color_shades_lighter), ";height:72px;padding:15px;border-top:0;position:relative;margin-bottom:16px;form{display:flex;align-items:center;height:100%;}.message-bar-input{flex:1;height:72px;border-radius:12px;border:1px solid ", (0, _colors.color_shades_dark), ";background:white;font-family:Muli;font-size:16px;font-weight:normal;font-stretch:normal;padding-left:16px;box-shadow:0px 4px 10px rgba(50, 70, 97, 0.1);display:flex;justify-content:space-between;align-items:center;input{width:100%;background:transparent;border:none;font-size:16px;color:", (0, _colors.color_text_default), ";::placeholder{font-weight:normal;font-style:italic;font-size:16px;letter-spacing:normal;color:", (0, _colors.color_text_light), ";}}.mic-button{padding:0;margin:0;background:none;border:none;border-right:", (0, _stylesValues.style_border_default), ";display:flex;flex-direction:column;align-items:center;justify-content:center;width:104px;height:100%;overflow:hidden;padding-right:16px;margin-right:16px;cursor:pointer;p{font-size:10px;line-height:16px;color:", (0, _colors.color_text_default), ";}}&.disabled{background:", (0, _colors.color_shades_light), ";color:", (0, _colors.color_text_light), ";}}.submit-button{border:none;background-color:transparent;background-repeat:no-repeat;margin-right:16px;width:24px;height:24px;padding:0;cursor:pointer;}", "");
exports.default = SimulatorMessageBar;

},{"@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","../../../constants/colors":"1p3OR","../../../components/general/Button":"6ymxN","../../../constants/stylesValues":"dHVVv","../../../hooks/SimulatorContainer":"gOZ3V","34cda641c8a11251":"lHDr5","c11fcc8a9a203fcc":"7RJIh","abf038bf959ee4ff":"1xJTF","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1xJTF":[function(require,module,exports) {
module.exports = require("49b5657d530e0140").getBundleURL("kVLro") + require("dd3e4ddfa59fcde1").resolve("duMN2");

},{"49b5657d530e0140":"c7Tr5","dd3e4ddfa59fcde1":"fyJL2"}],"kq1X3":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _base = require("@emotion/styled/base");
var _baseDefault = parcelHelpers.interopDefault(_base);
var _react = require("@emotion/react");
var _css = require("@emotion/css");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _verticalSeparator = require("../../../components/structure/VerticalSeparator");
var _verticalSeparatorDefault = parcelHelpers.interopDefault(_verticalSeparator);
var _colors = require("../../../constants/colors");
var _simulatorDeviceSelector = require("./SimulatorDeviceSelector");
var _simulatorDeviceSelectorDefault = parcelHelpers.interopDefault(_simulatorDeviceSelector);
var _dropDownSelectField = require("../../../components/forms/DropDownSelectField");
var _dropDownSelectFieldDefault = parcelHelpers.interopDefault(_dropDownSelectField);
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const liveAppIcon = require("5265a702bd5e6c01");
const testAppIcon = require("c35f287c63232e50");
const formatValueLabel = ({ label, image })=>(0, _react.jsx)(CustomSelectChosenOption, null, (0, _react.jsx)("img", {
        className: optionImageStyle,
        src: image
    }), (0, _react.jsx)("p", null, label));
const DeviceAndEnvironmentPicker = (props)=>{
    return (0, _react.jsx)(Container, null, (0, _react.jsx)(SelectionContainer, {
        className: "ac-simulator-device-type"
    }, (0, _react.jsx)((0, _dropDownSelectFieldDefault.default), {
        className: customSelect,
        key: "environment-selector",
        onChange: (e)=>props.onSetEnvironment(e.value),
        value: props.useDraftContent ? "draft" : "live",
        clearable: false,
        searchable: false,
        valueRenderer: formatValueLabel,
        optionImageStyle: optionImageStyle,
        options: [
            {
                value: "live",
                label: "Live App",
                image: liveAppIcon
            },
            {
                value: "draft",
                label: "Test App",
                image: testAppIcon
            }
        ]
    })), (0, _react.jsx)(Separator, null), (0, _react.jsx)((0, _simulatorDeviceSelectorDefault.default), {
        targets: props.availableDevices,
        isSmall: true,
        selectedTarget: props.selectedTarget,
        onSelectionChange: props.onDeviceSelectionChange
    }));
};
const optionImageStyle = /*#__PURE__*/ (0, _css.css)({
    name: "t35ebv",
    styles: "height:8px;width:8px;margin:auto 0px"
});
const customSelect = /*#__PURE__*/ (0, _css.css)({
    name: "uicm3s",
    styles: "height:28px;width:140px;margin-bottom:30px;margin-right:16px"
});
const SelectionContainer = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e158rfsz3"
})({
    name: "sr8ex0",
    styles: "display:flex;flex-direction:row;margin-left:32px;margin-top:20px"
});
const Separator = /*#__PURE__*/ (0, _baseDefault.default)((0, _verticalSeparatorDefault.default), {
    target: "e158rfsz2"
})({
    name: "s0vnfv",
    styles: "height:32px"
});
const Container = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e158rfsz1"
})("height:55px;display:flex;flex-direction:row;border-bottom:1px solid ", (0, _colors.color_shades_dark), ";justify-content:space-between;align-items:center;background:white;box-sizing:content-box;");
const CustomSelectChosenOption = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e158rfsz0"
})("display:flex;flex-direction:row;padding-left:6px;p{color:", (0, _colors.color_shades_darkest), ";margin-left:10px;}");
exports.default = DeviceAndEnvironmentPicker;

},{"@emotion/styled/base":"lSuFu","@emotion/react":"djZKr","@emotion/css":"awUBr","react":"6uln9","../../../components/structure/VerticalSeparator":"aNNRC","../../../constants/colors":"1p3OR","./SimulatorDeviceSelector":"eZHQC","../../../components/forms/DropDownSelectField":"kFCJA","5265a702bd5e6c01":"8OyYY","c35f287c63232e50":"5B14D","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"eZHQC":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _base = require("@emotion/styled/base");
var _baseDefault = parcelHelpers.interopDefault(_base);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _colors = require("../../../constants/colors");
var _toggleIndicator = require("../../../components/general/ToggleIndicator");
var _toggleIndicatorDefault = parcelHelpers.interopDefault(_toggleIndicator);
var _customScrollbars = require("../../../components/structure/CustomScrollbars");
var _customScrollbarsDefault = parcelHelpers.interopDefault(_customScrollbars);
var _lodash = require("lodash");
var _lodashDefault = parcelHelpers.interopDefault(_lodash);
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const speakerIcon = require("5c8cfe48ed97c647");
const screenIcon = require("360bcde579f89330");
const chatIcon = require("1a866b4e1b2f5ed4");
const SimulatorDeviceSelector = (props)=>{
    const [isCollapsed, setIsCollapsed] = (0, _react1.useState)(true);
    const [isScreenCollapsed, setIsScreenCollapsed] = (0, _react1.useState)(true);
    const [isChatCollapsed, setIsChatCollapsed] = (0, _react1.useState)(true);
    const [isSpeakerCollapsed, setIsSpeakerCollapsed] = (0, _react1.useState)(false);
    const clickingRef = (0, _react1.useRef)(null);
    (0, _react1.useEffect)(()=>{
        document.addEventListener("click", handleOutsideClick, false);
        return ()=>{
            document.removeEventListener("click", handleOutsideClick, false);
        };
    }, []);
    const handleSelectionChange = (target)=>{
        setIsCollapsed(!isCollapsed);
        props.onSelectionChange(target);
    };
    const renderDeviceHeader = (icon, name, select, top, bottom, isHeaderCollapsed)=>{
        return (0, _react.jsx)(DeviceOption, {
            className: getContainerClass(false, false, top, false, bottom),
            key: name,
            onClick: ()=>select()
        }, (0, _react.jsx)("div", {
            className: "template-icon"
        }, (0, _react.jsx)("img", {
            className: "header-image",
            src: icon
        })), (0, _react.jsx)("p", {
            className: "template-title"
        }, name), (0, _react.jsx)(DeviceHeaderToggleIndicator, {
            direction: isHeaderCollapsed ? "down" : "up"
        }));
    };
    const renderDeviceOption = (device, isSelected, top, bottom, flatBottom = false)=>{
        return (0, _react.jsx)(DeviceOption, {
            key: device.id,
            className: getContainerClass(true, isSelected, top, bottom, flatBottom),
            onClick: ()=>handleSelectionChange(device)
        }, (0, _react.jsx)("div", {
            className: "template-icon device"
        }, (0, _react.jsx)("img", {
            src: device.iconUrl
        })), (0, _react.jsx)("p", {
            className: "template-title"
        }, device.displayName));
    };
    const handleOutsideClick = (e)=>{
        if (clickingRef.current && !clickingRef.current.contains(e.target)) setIsCollapsed(true);
    };
    const getContainerClass = (isDevice, isSelected, top, bottom, flatBottom = false)=>{
        var className = "selectable";
        if (isSelected) className += " selected";
        if (top) className += " top";
        if (bottom) className += " bottom";
        if (isDevice) className += " device";
        if (flatBottom) className += " flat-bottom";
        return className;
    };
    return (0, _react.jsx)("div", {
        className: containerStyle + " small " + "ac-simulator-device-picker ac-content-preview-device-picker",
        ref: clickingRef
    }, props.isSmall ? null : (0, _react.jsx)("p", {
        className: "field-label"
    }, "Preview-Type:"), (0, _react.jsx)("div", {
        className: "selection-container"
    }, props.selectedTarget && (0, _react.jsx)(TargetDevice, {
        key: props.selectedTarget.id,
        onClick: ()=>setIsCollapsed(!isCollapsed)
    }, (0, _react.jsx)("img", {
        className: "device-target-icon",
        src: props.selectedTarget.iconUrl
    }), (0, _react.jsx)("p", {
        className: "device-target-title"
    }, props.selectedTarget.displayName)), (0, _react.jsx)("div", {
        className: "selection-toggle",
        onClick: ()=>setIsCollapsed(!isCollapsed)
    }, (0, _react.jsx)((0, _toggleIndicatorDefault.default), {
        className: TargetDeviceToggleIndicator,
        direction: isCollapsed ? "down" : "up"
    }))), !isCollapsed && (0, _react.jsx)(OptionsWrapper, {
        className: "selector-wrapper"
    }, (0, _react.jsx)(Triangle, null), (0, _react.jsx)((0, _customScrollbarsDefault.default), {
        autoHide: true,
        className: `inner-wrapper ${props.targets?.length === 1 ? " is-small" : ""}`
    }, renderDeviceHeader(screenIcon, "Screen", ()=>setIsScreenCollapsed(!isScreenCollapsed), true, false, isScreenCollapsed), !isScreenCollapsed && (0, _lodashDefault.default).orderBy(props.targets.filter((t)=>t.supportsForegroundImages), [
        (t)=>t.displayName.toLowerCase()
    ]).map((target, i)=>renderDeviceOption(target, target.id == props.selectedTarget.id, false, false)), renderDeviceHeader(speakerIcon, "Audio", ()=>setIsSpeakerCollapsed(!isSpeakerCollapsed), false, false, isSpeakerCollapsed), !isSpeakerCollapsed && (0, _lodashDefault.default).orderBy(props.targets.filter((t)=>!t.supportsForegroundImages && t.supportsRichAudio), [
        (t)=>t.displayName.toLowerCase()
    ]).map((target, i)=>renderDeviceOption(target, target.id == props.selectedTarget.id, false, false)), renderDeviceHeader(chatIcon, "Chat", ()=>setIsChatCollapsed(!isChatCollapsed), false, isChatCollapsed, isChatCollapsed), !isChatCollapsed && (0, _lodashDefault.default).orderBy(props.targets.filter((t)=>!t.supportsForegroundImages && !t.supportsRichAudio), [
        (t)=>t.displayName.toLowerCase()
    ]).map((target, i)=>renderDeviceOption(target, target.id == props.selectedTarget.id, false, false, !isChatCollapsed && isSpeakerCollapsed && isScreenCollapsed)))));
};
const TargetDevice = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1vnsm54"
})("background:white;display:flex;flex-direction:row;padding-left:16px;font-family:Muli;font-style:normal;font-stretch:normal;line-height:normal;letter-spacing:normal;cursor:pointer;flex:1;align-items:center;min-height:80px;.device-target-icon{margin-right:16px;}.device-target-title{font-size:18px;color:", (0, _colors.color_shades_darkest), ";margin-bottom:2px;}");
const TargetDeviceToggleIndicator = /*#__PURE__*/ (0, _css.css)({
    name: "9e7m57",
    styles: "width:8px;height:8px"
});
const DeviceHeaderToggleIndicator = /*#__PURE__*/ (0, _baseDefault.default)((0, _toggleIndicatorDefault.default), {
    target: "e1vnsm53"
})({
    name: "g3t98",
    styles: "margin-left:auto;margin-right:32px;width:8px;height:8px"
});
const Triangle = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1vnsm52"
})("transform:rotate(45deg);width:14px;height:14px;margin-top:-7px;margin-bottom:-7px;border-top:solid 1px ", (0, _colors.color_shades_dark), ";border-left:solid 1px ", (0, _colors.color_shades_dark), ";background:white;margin-right:30px;margin-left:auto;z-index:4;");
const DeviceOption = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1vnsm51"
})("background:white;display:flex;flex-direction:row;font-family:Muli;font-style:normal;font-stretch:normal;line-height:normal;letter-spacing:normal;cursor:pointer;flex:1;align-items:center;min-height:64px;.header-image{width:32px;}&.selectable{border:1px solid ", (0, _colors.color_shades_dark), ";border-bottom:0px;&:hover{background:", (0, _colors.color_variants_ocean_light_opaque), ";}&.top{border-radius:10px 10px 0 0;border-top:0px;}&.bottom{border-radius:0 0 10px 10px;}&.flat-bottom{border-bottom:1px solid ", (0, _colors.color_shades_dark), ";}}.template-icon{margin-right:12px;margin-left:24px;&.device{margin-left:48px;}}&.selected{background-color:rgba(0, 125, 187, 0.1);border:1px solid ", (0, _colors.ocean_blue), ";}&.device{border-left:3px solid ", (0, _colors.color_shades_dark), ";}.template-title{color:", (0, _colors.color_shades_darkest), ";font-size:18px;margin-bottom:2px;}");
const OptionsWrapper = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1vnsm50"
})("position:absolute;display:flex;flex-direction:column;background:white;box-shadow:0 4px 4px 0 ", (0, _colors.color_variants_shadow_10), ";border-radius:12px;z-index:3;flex:1;width:100%;left:0px;top:72px;.inner-wrapper{overflow:hidden;max-height:600px;border-radius:12px;border-top:solid 1px ", (0, _colors.color_shades_dark), ";border-bottom:solid 1px ", (0, _colors.color_shades_dark), ";}");
const containerStyle = /*#__PURE__*/ (0, _css.css)("width:100%;.selection-container{display:flex;flex-direction:row;align-items:stretch;border-top:solid 1px ", (0, _colors.color_shades_dark), ";cursor:pointer;background:white;overflow:hidden;.selection-toggle{display:flex;align-items:center;justify-content:center;width:75px;height:52px;}.selection-toggle.small{border:0;}}&.small{.selection-container{height:52px;width:100%;align-items:center;justify-content:space-between;border:0;.selection-toggle{border:0;}}.selector-wrapper{margin:0;.inner-wrapper{min-height:300px;&.is-small{min-height:82px;}}}}.field-label{font-size:14px;color:", (0, _colors.color_shades_dark), ";background:white;padding-left:32px;padding-top:16px;}", "");
exports.default = SimulatorDeviceSelector;

},{"@emotion/styled/base":"lSuFu","@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","../../../constants/colors":"1p3OR","../../../components/general/ToggleIndicator":"4eej1","../../../components/structure/CustomScrollbars":"50vFq","lodash":"3hMBK","5c8cfe48ed97c647":"9pEQA","360bcde579f89330":"9l70Q","1a866b4e1b2f5ed4":"3u7X8","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"5AMPD":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _base = require("@emotion/styled/base");
var _baseDefault = parcelHelpers.interopDefault(_base);
var _react = require("@emotion/react");
var _css = require("@emotion/css");
var _colors = require("../../../constants/colors");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _userVariationsBubble = require("../../../components/messagePreviews/UserVariationsBubble");
var _userVariationsBubbleDefault = parcelHelpers.interopDefault(_userVariationsBubble);
var _deviceScreenVariationsBubble = require("../../../components/messagePreviews/DeviceScreenVariationsBubble");
var _deviceScreenVariationsBubbleDefault = parcelHelpers.interopDefault(_deviceScreenVariationsBubble);
var _deviceAudioVariationsBubble = require("../../../components/messagePreviews/DeviceAudioVariationsBubble");
var _deviceAudioVariationsBubbleDefault = parcelHelpers.interopDefault(_deviceAudioVariationsBubble);
var _deviceChatVariationBubble = require("../../../components/messagePreviews/DeviceChatVariationBubble");
var _deviceChatVariationBubbleDefault = parcelHelpers.interopDefault(_deviceChatVariationBubble);
var _customScrollbars = require("../../../components/structure/CustomScrollbars");
var _customScrollbarsDefault = parcelHelpers.interopDefault(_customScrollbars);
var _deviceLoadingChatBubble = require("../../../components/messagePreviews/DeviceLoadingChatBubble");
var _deviceLoadingChatBubbleDefault = parcelHelpers.interopDefault(_deviceLoadingChatBubble);
var _unsupportedResponseBubble = require("../../../components/messagePreviews/UnsupportedResponseBubble");
var _unsupportedResponseBubbleDefault = parcelHelpers.interopDefault(_unsupportedResponseBubble);
var _tooltipWrapper = require("../../../components/general/TooltipWrapper");
var _tooltipWrapperDefault = parcelHelpers.interopDefault(_tooltipWrapper);
var _button = require("../../../components/general/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _simulatorContainer = require("../../../hooks/SimulatorContainer");
var _simulatorContainerDefault = parcelHelpers.interopDefault(_simulatorContainer);
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const addThumbtackIcon = require("eeae884198db0f92");
const redoIcon = require("344bffab3d8aa77f");
const deviceIcon = require("dbb691eb13fe4736");
const SimulatorConversationViewer = (props)=>{
    const scrollingRef = (0, _react1.useRef)(null);
    const [copyButtonText, setCopyButtonText] = (0, _reactDefault.default).useState("Copy Transcript");
    const simulatorContainer = (0, _simulatorContainerDefault.default).useContainer();
    (0, _react1.useEffect)(()=>{
        if (copyButtonText === "Copied!") setCopyButtonText("Copy Transcript");
    }, [
        props.responses,
        props.applicationId,
        props.requests
    ]);
    (0, _react1.useEffect)(()=>{
        scrollingRef.current?.scrollIntoView({
            block: "end"
        });
    });
    const renderConversationTurn = (message, interfaceType, index)=>{
        const deviceResponse = props.responses[index];
        const variation = {
            content: message.text,
            id: index.toString(),
            highlights: []
        };
        const mappedResponse = mapCustomAssistantResponseToMediaResponse(deviceResponse);
        return (0, _react.jsx)("div", {
            key: index,
            className: "conversation-turn"
        }, (0, _react.jsx)("div", {
            className: "user-variation"
        }, (0, _react.jsx)((0, _userVariationsBubbleDefault.default), {
            bubbleWidthPercentage: 60,
            className: "user-bubble",
            variations: [
                variation
            ]
        }), props.viewOnly ? null : (0, _react.jsx)("div", {
            className: "icons"
        }, (0, _react.jsx)((0, _tooltipWrapperDefault.default), {
            text: "Pin this message to use later"
        }, (0, _react.jsx)("img", {
            className: "pin",
            src: addThumbtackIcon,
            onClick: ()=>props.userApplicationPreferencesContainer.addSimulatorPinnedMessage(props.applicationId, message.text)
        })), (0, _react.jsx)((0, _tooltipWrapperDefault.default), {
            text: "Send this message again"
        }, (0, _react.jsx)("img", {
            className: "redo",
            src: redoIcon,
            onClick: ()=>props.handleSendMessage(message.text)
        })))), deviceResponse ? mappedResponse.isUnsupportedResponse ? (0, _react.jsx)((0, _unsupportedResponseBubbleDefault.default), null) : interfaceType == "chat" ? (0, _react.jsx)((0, _deviceChatVariationBubbleDefault.default), {
            deviceTargetId: props.selectedDevice.id,
            variations: [
                mappedResponse
            ]
        }) : interfaceType == "audio" ? (0, _react.jsx)((0, _deviceAudioVariationsBubbleDefault.default), {
            ssmlContainer: props.ssmlContainer,
            assistant: props.selectedDevice.assistant,
            deviceTargetId: props.selectedDevice.id,
            variations: [
                mappedResponse
            ],
            languages: [
                props.selectedLanguage
            ]
        }) : interfaceType == "screen" ? (0, _react.jsx)((0, _deviceScreenVariationsBubbleDefault.default), {
            ssmlContainer: props.ssmlContainer,
            deviceTarget: props.selectedDevice,
            variations: [
                mappedResponse
            ],
            languages: [
                props.selectedLanguage
            ]
        }) : null : (0, _react.jsx)((0, _deviceLoadingChatBubbleDefault.default), {
            icon: deviceIcon
        }));
    };
    const copyText = (text)=>{
        navigator.clipboard.writeText(text);
    };
    const copyTranscript = ()=>{
        var transcript = "";
        props.requests.forEach((r, i)=>{
            const deviceResponse = props.responses[i];
            if (r?.text?.length) transcript += `User: ${r.text}\n\n`;
            if (deviceResponse?.displayText?.length || deviceResponse?.ssml?.length) transcript += `Assistant: ${deviceResponse?.displayText ?? deviceResponse.ssml}\n\n`;
        });
        copyText(transcript);
    };
    const mapCustomAssistantResponseToMediaResponse = (deviceResponse)=>{
        if (!deviceResponse) return null;
        const isUnsupported = deviceResponse.ssml == null && deviceResponse.audioFile == null && deviceResponse.videoFile == null && deviceResponse.displayText == null && deviceResponse.displayTitle == null;
        return {
            audioItem: deviceResponse.audioFile,
            videoItem: deviceResponse.videoFile,
            foregroundImageItem: deviceResponse.foregroundImage,
            backgroundImageItem: deviceResponse.backgroundImage,
            deviceTarget: props.selectedDevice,
            id: deviceResponse.responseId,
            responseTemplateTypeId: deviceResponse.responseTemplate,
            applicationId: props.applicationId,
            displayText: deviceResponse.displayText ?? "",
            displayTitle: deviceResponse.displayTitle ?? "",
            content: deviceResponse.ssml,
            highlights: [],
            imageItem: deviceResponse.foregroundImage,
            isUnsupportedResponse: isUnsupported
        };
    };
    if (!props.selectedLanguage && !props.viewOnly) return (0, _react.jsx)("div", {
        className: containerStyle
    }, (0, _react.jsx)("div", {
        className: "no-lang"
    }, "You must add at least one language to your application first."));
    const hasMessages = props.requests?.length > 0;
    if ((!hasMessages || !props.selectedDevice) && !props.viewOnly) return (0, _react.jsx)("div", {
        className: containerStyle
    });
    const device = props.selectedDevice;
    const chat = !device.supportsSsml && device.supportsDisplayText;
    const audio = device.supportsSsml && !device.supportsDisplayText;
    const interfaceType = chat ? "chat" : audio ? "audio" : "screen";
    return (0, _react.jsx)("div", {
        className: containerStyle
    }, (0, _react.jsx)(CopyButton, {
        themes: [
            "secondary-small"
        ],
        text: copyButtonText,
        onClick: ()=>{
            copyTranscript();
            setCopyButtonText("Copied!");
        },
        type: "button"
    }), !props.viewOnly && simulatorContainer?.fullResponses?.length > 1 ? (0, _react.jsx)(CreateTestCaseButton, {
        themes: [
            "secondary-small"
        ],
        text: "Create Test Case",
        onClick: ()=>{
            props.createTestCase();
        },
        type: "button"
    }) : (0, _react.jsx)((0, _reactDefault.default).Fragment, null), props.viewOnly ? (0, _react.jsx)((0, _reactDefault.default).Fragment, null, props.requests.map((c, i)=>{
        return renderConversationTurn(c, interfaceType, i);
    }), (0, _react.jsx)("div", {
        className: "end-padding",
        key: "end",
        ref: scrollingRef
    })) : (0, _react.jsx)((0, _customScrollbarsDefault.default), null, props.requests.map((c, i)=>{
        return renderConversationTurn(c, interfaceType, i);
    }), (0, _react.jsx)("div", {
        className: "end-padding",
        key: "end",
        ref: scrollingRef
    })));
};
const CopyButton = /*#__PURE__*/ (0, _baseDefault.default)((0, _buttonDefault.default), {
    target: "exqws571"
})({
    name: "yhjy22",
    styles: "width:186px;position:absolute;top:24px;right:24px;min-width:auto;width:auto;z-index:100"
});
const CreateTestCaseButton = /*#__PURE__*/ (0, _baseDefault.default)((0, _buttonDefault.default), {
    target: "exqws570"
})({
    name: "orq1fd",
    styles: "width:186px;position:absolute;top:64px;right:24px;min-width:auto;width:auto;z-index:100"
});
const containerStyle = /*#__PURE__*/ (0, _css.css)("background:", (0, _colors.color_shades_lighter), ";overflow:auto;display:flex;flex-grow:1;flex-direction:row;flex-wrap:wrap;position:relative;max-width:100%;>*{min-width:100%;max-width:100%;}.no-lang{padding-left:20%;align-self:center;}.end-padding{padding-bottom:32px;}.conversation-turn{.user-variation{display:flex;flex-direction:row;position:relative;}.user-bubble{width:100%;}}.icons{img{position:absolute;cursor:pointer;&.pin{top:30px;left:calc(60% + 60px);}&.redo{top:62px;left:calc(60% + 60px);}}}", "");
exports.default = SimulatorConversationViewer;

},{"@emotion/styled/base":"lSuFu","@emotion/react":"djZKr","@emotion/css":"awUBr","../../../constants/colors":"1p3OR","react":"6uln9","../../../components/messagePreviews/UserVariationsBubble":"2ASHP","../../../components/messagePreviews/DeviceScreenVariationsBubble":"1Pwmt","../../../components/messagePreviews/DeviceAudioVariationsBubble":"jkh8P","../../../components/messagePreviews/DeviceChatVariationBubble":"aIuxi","../../../components/structure/CustomScrollbars":"50vFq","../../../components/messagePreviews/DeviceLoadingChatBubble":"gT9AU","../../../components/messagePreviews/UnsupportedResponseBubble":"hXxEZ","../../../components/general/TooltipWrapper":"53pWd","../../../components/general/Button":"6ymxN","../../../hooks/SimulatorContainer":"gOZ3V","eeae884198db0f92":"i4iw1","344bffab3d8aa77f":"aRE2s","dbb691eb13fe4736":"2nj1V","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1Pwmt":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _css = require("@emotion/css");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _colors = require("../../constants/colors");
var _pageError = require("../general/PageError");
var _pageErrorDefault = parcelHelpers.interopDefault(_pageError);
var _positionIndicator = require("../structure/ConversationFlow/PositionIndicator");
var _positionIndicatorDefault = parcelHelpers.interopDefault(_positionIndicator);
var _horizontalSeparator = require("../structure/HorizontalSeparator");
var _horizontalSeparatorDefault = parcelHelpers.interopDefault(_horizontalSeparator);
var _alexaAudioPlayerPreview = require("./AlexaRectangleScreens/AlexaAudioPlayerPreview");
var _alexaAudioPlayerPreviewDefault = parcelHelpers.interopDefault(_alexaAudioPlayerPreview);
var _alexaBodyTemplate1Preview = require("./AlexaRectangleScreens/AlexaBodyTemplate1Preview");
var _alexaBodyTemplate1PreviewDefault = parcelHelpers.interopDefault(_alexaBodyTemplate1Preview);
var _alexaBodyTemplate2Preview = require("./AlexaRectangleScreens/AlexaBodyTemplate2Preview");
var _alexaBodyTemplate2PreviewDefault = parcelHelpers.interopDefault(_alexaBodyTemplate2Preview);
var _alexaBodyTemplate3Preview = require("./AlexaRectangleScreens/AlexaBodyTemplate3Preview");
var _alexaBodyTemplate3PreviewDefault = parcelHelpers.interopDefault(_alexaBodyTemplate3Preview);
var _alexaBodyTemplate6Preview = require("./AlexaRectangleScreens/AlexaBodyTemplate6Preview");
var _alexaBodyTemplate6PreviewDefault = parcelHelpers.interopDefault(_alexaBodyTemplate6Preview);
var _alexaBodyTemplate7Preview = require("./AlexaRectangleScreens/AlexaBodyTemplate7Preview");
var _alexaBodyTemplate7PreviewDefault = parcelHelpers.interopDefault(_alexaBodyTemplate7Preview);
var _alexaListTemplate2Preview = require("./AlexaRectangleScreens/AlexaListTemplate2Preview");
var _alexaListTemplate2PreviewDefault = parcelHelpers.interopDefault(_alexaListTemplate2Preview);
var _alexaVideoPreview = require("./AlexaRectangleScreens/AlexaVideoPreview");
var _alexaVideoPreviewDefault = parcelHelpers.interopDefault(_alexaVideoPreview);
var _alexaSmallAudioPlayerPreview = require("./AlexaRoundScreens/AlexaSmallAudioPlayerPreview");
var _alexaSmallAudioPlayerPreviewDefault = parcelHelpers.interopDefault(_alexaSmallAudioPlayerPreview);
var _alexaSmallBodyTemplate1Preview = require("./AlexaRoundScreens/AlexaSmallBodyTemplate1Preview");
var _alexaSmallBodyTemplate1PreviewDefault = parcelHelpers.interopDefault(_alexaSmallBodyTemplate1Preview);
var _alexaSmallBodyTemplate2Preview = require("./AlexaRoundScreens/AlexaSmallBodyTemplate2Preview");
var _alexaSmallBodyTemplate2PreviewDefault = parcelHelpers.interopDefault(_alexaSmallBodyTemplate2Preview);
var _alexaSmallBodyTemplate3Preview = require("./AlexaRoundScreens/AlexaSmallBodyTemplate3Preview");
var _alexaSmallBodyTemplate3PreviewDefault = parcelHelpers.interopDefault(_alexaSmallBodyTemplate3Preview);
var _alexaSmallBodyTemplate6Preview = require("./AlexaRoundScreens/AlexaSmallBodyTemplate6Preview");
var _alexaSmallBodyTemplate6PreviewDefault = parcelHelpers.interopDefault(_alexaSmallBodyTemplate6Preview);
var _alexaSmallBodyTemplate7Preview = require("./AlexaRoundScreens/AlexaSmallBodyTemplate7Preview");
var _alexaSmallBodyTemplate7PreviewDefault = parcelHelpers.interopDefault(_alexaSmallBodyTemplate7Preview);
var _alexaSmallListTemplate2Preview = require("./AlexaRoundScreens/AlexaSmallListTemplate2Preview");
var _alexaSmallListTemplate2PreviewDefault = parcelHelpers.interopDefault(_alexaSmallListTemplate2Preview);
var _alexaSmallVideoPreview = require("./AlexaRoundScreens/AlexaSmallVideoPreview");
var _alexaSmallVideoPreviewDefault = parcelHelpers.interopDefault(_alexaSmallVideoPreview);
var _alexaShortAudioPlayerPreview = require("./AlexaShortRectangleScreens/AlexaShortAudioPlayerPreview");
var _alexaShortAudioPlayerPreviewDefault = parcelHelpers.interopDefault(_alexaShortAudioPlayerPreview);
var _alexaShortBodyTemplate1Preview = require("./AlexaShortRectangleScreens/AlexaShortBodyTemplate1Preview");
var _alexaShortBodyTemplate1PreviewDefault = parcelHelpers.interopDefault(_alexaShortBodyTemplate1Preview);
var _alexaShortBodyTemplate2Preview = require("./AlexaShortRectangleScreens/AlexaShortBodyTemplate2Preview");
var _alexaShortBodyTemplate2PreviewDefault = parcelHelpers.interopDefault(_alexaShortBodyTemplate2Preview);
var _alexaShortBodyTemplate3Preview = require("./AlexaShortRectangleScreens/AlexaShortBodyTemplate3Preview");
var _alexaShortBodyTemplate3PreviewDefault = parcelHelpers.interopDefault(_alexaShortBodyTemplate3Preview);
var _alexaShortBodyTemplate6Preview = require("./AlexaShortRectangleScreens/AlexaShortBodyTemplate6Preview");
var _alexaShortBodyTemplate6PreviewDefault = parcelHelpers.interopDefault(_alexaShortBodyTemplate6Preview);
var _alexaShortBodyTemplate7Preview = require("./AlexaShortRectangleScreens/AlexaShortBodyTemplate7Preview");
var _alexaShortBodyTemplate7PreviewDefault = parcelHelpers.interopDefault(_alexaShortBodyTemplate7Preview);
var _alexaShortListTemplate2Preview = require("./AlexaShortRectangleScreens/AlexaShortListTemplate2Preview");
var _alexaShortListTemplate2PreviewDefault = parcelHelpers.interopDefault(_alexaShortListTemplate2Preview);
var _alexaShortVideoPreview = require("./AlexaShortRectangleScreens/AlexaShortVideoPreview");
var _alexaShortVideoPreviewDefault = parcelHelpers.interopDefault(_alexaShortVideoPreview);
var _cortanaScreenListPreview = require("./CortanaScreens/CortanaScreenListPreview");
var _cortanaScreenListPreviewDefault = parcelHelpers.interopDefault(_cortanaScreenListPreview);
var _cortanaScreenMediaResponsePreview = require("./CortanaScreens/CortanaScreenMediaResponsePreview");
var _cortanaScreenMediaResponsePreviewDefault = parcelHelpers.interopDefault(_cortanaScreenMediaResponsePreview);
var _cortanaScreenSimpleCardPreview = require("./CortanaScreens/CortanaScreenSimpleCardPreview");
var _cortanaScreenSimpleCardPreviewDefault = parcelHelpers.interopDefault(_cortanaScreenSimpleCardPreview);
var _cortanaScreenStandardCardPreview = require("./CortanaScreens/CortanaScreenStandardCardPreview");
var _cortanaScreenStandardCardPreviewDefault = parcelHelpers.interopDefault(_cortanaScreenStandardCardPreview);
var _googleMobileListPreview = require("./GoogleMobileScreens/GoogleMobileListPreview");
var _googleMobileListPreviewDefault = parcelHelpers.interopDefault(_googleMobileListPreview);
var _googleMobileMediaResponsePreview = require("./GoogleMobileScreens/GoogleMobileMediaResponsePreview");
var _googleMobileMediaResponsePreviewDefault = parcelHelpers.interopDefault(_googleMobileMediaResponsePreview);
var _googleMobileSimpleCardPreview = require("./GoogleMobileScreens/GoogleMobileSimpleCardPreview");
var _googleMobileSimpleCardPreviewDefault = parcelHelpers.interopDefault(_googleMobileSimpleCardPreview);
var _googleMobileStandardCardPreview = require("./GoogleMobileScreens/GoogleMobileStandardCardPreview");
var _googleMobileStandardCardPreviewDefault = parcelHelpers.interopDefault(_googleMobileStandardCardPreview);
var _googleListPreview = require("./GoogleSmartScreens/GoogleListPreview");
var _googleListPreviewDefault = parcelHelpers.interopDefault(_googleListPreview);
var _googleMediaResponsePreview = require("./GoogleSmartScreens/GoogleMediaResponsePreview");
var _googleMediaResponsePreviewDefault = parcelHelpers.interopDefault(_googleMediaResponsePreview);
var _googleSimpleCardPreview = require("./GoogleSmartScreens/GoogleSimpleCardPreview");
var _googleSimpleCardPreviewDefault = parcelHelpers.interopDefault(_googleSimpleCardPreview);
var _googleStandardCardPreview = require("./GoogleSmartScreens/GoogleStandardCardPreview");
var _googleStandardCardPreviewDefault = parcelHelpers.interopDefault(_googleStandardCardPreview);
var _multiFileAudioPlayer = require("./MultiFileAudioPlayer");
var _multiFileAudioPlayerDefault = parcelHelpers.interopDefault(_multiFileAudioPlayer);
var _dompurify = require("dompurify");
var _dompurifyDefault = parcelHelpers.interopDefault(_dompurify);
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const deviceIcon = require("3cd2ada9a957a275");
const containerStyle = /*#__PURE__*/ (0, _css.css)({
    name: "84huzn",
    styles: "display:flex;align-items:start;>img{background:white;border-radius:50%;margin-top:30px;margin-right:12px;margin-left:12px;}"
});
const bubbleStyle = /*#__PURE__*/ (0, _css.css)("margin:30px 0 0 115px;border:solid 1px ", (0, _colors.dark_sky_blue), ";box-shadow:-1px 4px 10px 0 ", (0, _colors.dark_grey_blue_20), ";background:white;border-radius:10px 0 10px 10px;padding:24px;display:flex;flex-direction:column;flex:1;@media only screen and (min-width: 1240px){max-width:60%;margin-right:0;margin-left:auto;}.title{font-family:Muli;font-size:18px;font-weight:600;font-style:normal;font-stretch:normal;line-height:normal;letter-spacing:normal;color:", (0, _colors.dark_grey_blue), ";margin-bottom:24px;}.open-quote{margin-left:0;margin-right:auto;margin-bottom:16px;margin-top:16px;}.close-quote{margin-right:0;margin-left:auto;margin-bottom:16px;margin-top:0;}.placeholder{text-align:center;font-style:italic;color:", (0, _colors.cool_grey), ";}.carousel-container{display:flex;align-items:center;justify-content:center;flex-direction:column;margin-top:16px;span{margin-bottom:8px;font-size:10px;font-weight:normal;font-stretch:normal;line-height:normal;letter-spacing:0.4px;text-align:center;color:", (0, _colors.cool_grey), ";}}", "");
const inputStyle = /*#__PURE__*/ (0, _css.css)("font-family:Muli;font-size:14px;font-weight:normal;font-style:normal;font-stretch:normal;line-height:normal;letter-spacing:normal;color:", (0, _colors.dark_grey_blue), ";margin-top:12px;span{background:", (0, _colors.highlight_blue), ";}", "");
const unsupportedDevice = /*#__PURE__*/ (0, _css.css)({
    name: "10rtstj",
    styles: "padding:16px"
});
class DeviceScreenVariationsBubble extends (0, _reactDefault.default).Component {
    componentWillMount() {
        this.setState({
            position: 0,
            audioResponses: []
        });
    }
    getSsmlContent(conversationResponse) {
        var customResponse = conversationResponse.mediaResponseContainer ? conversationResponse.mediaResponseContainer.responses.find((r)=>r.deviceTargetId == this.props.deviceTarget.id && r.readoutOverride != null) : null;
        if (customResponse) return customResponse.readoutOverride;
        return conversationResponse.content;
    }
    buildLabel(item) {
        // strip tags from ssml first
        const ssml = this.getVariationSsml(item, false);
        const stripTagRegex = /<\/?[^>]+(>|$)/g;
        var displayText = ssml;
        displayText = displayText.replace(stripTagRegex, "");
        item.highlights.forEach((highlight)=>{
            displayText = displayText.replace(highlight.replace(stripTagRegex, ""), `<span>${highlight}</span>`);
        });
        return (0, _react.jsx)("p", {
            className: inputStyle,
            key: item.id,
            dangerouslySetInnerHTML: {
                __html: (0, _dompurifyDefault.default).sanitize(displayText)
            }
        });
    }
    getVariationSsml(item, includeFollowUp) {
        var ssml = item.content;
        var customResponse = item.mediaResponseContainer ? item.mediaResponseContainer.responses.find((r)=>r.deviceTargetId == this.props.deviceTarget.id && r.readoutOverride != null) : null;
        if (customResponse) ssml = customResponse.readoutOverride;
        if (includeFollowUp && this.props.followUp) ssml += `<break time=".5s"/> ${this.props.followUp.content}`;
        return ssml;
    }
    loadSsmlAudio(item) {
        const innerSsml = this.getVariationSsml(item, true);
        var ssml = innerSsml.startsWith("<speak>") ? innerSsml : `<speak>${innerSsml}</speak>`;
        var locale = this.props.languages == null || this.props.languages.length < 1 ? "" : this.props.languages[0].shortCode;
        if (this.state.audioResponses.some((a)=>a.ssml == ssml && a.assistant == this.props.deviceTarget.assistant)) return;
        var cachedAudio = this.props.ssmlContainer.getCachedSsmlSpeech(ssml, this.props.deviceTarget.assistant, locale);
        if (cachedAudio) {
            var responses = this.state.audioResponses;
            responses.push({
                ssml: ssml,
                assistant: this.props.deviceTarget.assistant,
                outputAudioFiles: cachedAudio,
                locale: locale
            });
            this.setState({
                ...this.state,
                audioResponses: responses
            });
        } else this.props.ssmlContainer.getSpeechOutput(ssml, this.props.deviceTarget.assistant, locale).then((result)=>{
            if (result.resultType == "Ok") {
                var responses = this.state.audioResponses;
                responses.push({
                    ssml: ssml,
                    assistant: this.props.deviceTarget.assistant,
                    outputAudioFiles: result.data,
                    locale: locale
                });
                this.setState({
                    ...this.state,
                    audioResponses: responses
                });
            }
        });
    }
    handlePositionChange(position) {
        this.setState({
            ...this.state,
            position
        });
    }
    getAudioSrc(variation) {
        // check for audio player
        var customResponse = variation.mediaResponseContainer ? variation.mediaResponseContainer.responses.find((r)=>r.deviceTargetId == this.props.deviceTarget.id) : null;
        if (customResponse != null && customResponse.audioItem) return [
            customResponse.audioItem.url
        ];
        else if (variation.audioItem) return [
            variation.audioItem.url
        ];
        var innerSsml = this.getVariationSsml(variation, true);
        var ssml = innerSsml.startsWith("<speak>") ? innerSsml : `<speak>${innerSsml}</speak>`;
        var audioSrc = this.state.audioResponses.find((a)=>a.ssml == ssml && a.assistant == this.props.deviceTarget.assistant);
        if (!audioSrc || !audioSrc.outputAudioFiles) return null;
        return audioSrc.outputAudioFiles.map((s)=>s.url);
    }
    stripTags(ssml) {
        const stripTagRegex = /<\/?[^>]+(>|$)/g;
        var displayText = ssml;
        displayText = displayText.replace(stripTagRegex, "");
        return displayText;
    }
    hasAudio() {
        const variation = this.props.variations[this.state.position];
        if (!variation) return false;
        const customResponse = variation.mediaResponseContainer ? variation.mediaResponseContainer.responses.find((r)=>r.deviceTargetId == this.props.deviceTarget.id && r.readoutOverride != null) : null;
        if (customResponse != null && customResponse.videoItem) return false;
        if (!customResponse && variation.videoItem && this.props.deviceTarget.assistant == "Alexa") return false;
        return true;
    }
    renderDisplayPreview() {
        if (this.props.variations.length == 0) return null;
        const response = this.props.variations[this.state.position];
        const mediaResponse = response.mediaResponseContainer ? response.mediaResponseContainer.responses.find((r)=>r.deviceTargetId == this.props.deviceTarget.id) : null;
        // temp: need to fill in the others with a switch
        if (this.props.deviceTarget.assistant == "Alexa" && !this.props.deviceTarget.displayName.includes("Small")) {
            if (mediaResponse) switch(mediaResponse.responseTemplateType.nativeName){
                case "BodyTemplate1":
                    return (0, _react.jsx)((0, _alexaBodyTemplate1PreviewDefault.default), {
                        followUp: this.props.followUp,
                        response: response,
                        mediaResponse: mediaResponse
                    });
                case "BodyTemplate2":
                    return (0, _react.jsx)((0, _alexaBodyTemplate2PreviewDefault.default), {
                        followUp: this.props.followUp,
                        response: response,
                        mediaResponse: mediaResponse
                    });
                case "BodyTemplate3":
                    return (0, _react.jsx)((0, _alexaBodyTemplate3PreviewDefault.default), {
                        followUp: this.props.followUp,
                        response: response,
                        mediaResponse: mediaResponse
                    });
                case "BodyTemplate6":
                    return (0, _react.jsx)((0, _alexaBodyTemplate6PreviewDefault.default), {
                        followUp: this.props.followUp,
                        response: response,
                        mediaResponse: mediaResponse
                    });
                case "BodyTemplate7":
                    return (0, _react.jsx)((0, _alexaBodyTemplate7PreviewDefault.default), {
                        followUp: this.props.followUp,
                        response: response,
                        mediaResponse: mediaResponse
                    });
                case "AudioPlayer":
                    return (0, _react.jsx)((0, _alexaAudioPlayerPreviewDefault.default), {
                        followUp: this.props.followUp,
                        response: response,
                        mediaResponse: mediaResponse
                    });
                case "Video":
                    return (0, _react.jsx)((0, _alexaVideoPreviewDefault.default), {
                        followUp: this.props.followUp,
                        response: response,
                        mediaResponse: mediaResponse
                    });
                case "ListTemplate2":
                    return (0, _react.jsx)((0, _alexaListTemplate2PreviewDefault.default), {
                        followUp: this.props.followUp,
                        response: response,
                        mediaResponse: mediaResponse
                    });
            }
            else {
                if (response.isList) return (0, _react.jsx)((0, _alexaListTemplate2PreviewDefault.default), {
                    followUp: this.props.followUp,
                    response: response,
                    mediaResponse: mediaResponse
                });
                else if (response.videoItem) return (0, _react.jsx)((0, _alexaVideoPreviewDefault.default), {
                    followUp: this.props.followUp,
                    response: response,
                    mediaResponse: mediaResponse
                });
                else if (response.audioItem) return (0, _react.jsx)((0, _alexaAudioPlayerPreviewDefault.default), {
                    followUp: this.props.followUp,
                    response: response,
                    mediaResponse: mediaResponse
                });
                else if (response.imageItem) return (0, _react.jsx)((0, _alexaBodyTemplate2PreviewDefault.default), {
                    followUp: this.props.followUp,
                    response: response,
                    mediaResponse: mediaResponse
                });
                else return (0, _react.jsx)((0, _alexaBodyTemplate1PreviewDefault.default), {
                    followUp: this.props.followUp,
                    response: response,
                    mediaResponse: mediaResponse
                });
            }
        } else if (this.props.deviceTarget.assistant == "Alexa" && this.props.deviceTarget.displayName.includes("Small") && this.props.deviceTarget.displayName.includes("Round")) {
            if (mediaResponse) switch(mediaResponse.responseTemplateType.nativeName){
                case "BodyTemplate1":
                    return (0, _react.jsx)((0, _alexaSmallBodyTemplate1PreviewDefault.default), {
                        followUp: this.props.followUp,
                        response: response,
                        mediaResponse: mediaResponse
                    });
                case "BodyTemplate2":
                    return (0, _react.jsx)((0, _alexaSmallBodyTemplate2PreviewDefault.default), {
                        followUp: this.props.followUp,
                        response: response,
                        mediaResponse: mediaResponse
                    });
                case "BodyTemplate3":
                    return (0, _react.jsx)((0, _alexaSmallBodyTemplate3PreviewDefault.default), {
                        followUp: this.props.followUp,
                        response: response,
                        mediaResponse: mediaResponse
                    });
                case "BodyTemplate6":
                    return (0, _react.jsx)((0, _alexaSmallBodyTemplate6PreviewDefault.default), {
                        followUp: this.props.followUp,
                        response: response,
                        mediaResponse: mediaResponse
                    });
                case "BodyTemplate7":
                    return (0, _react.jsx)((0, _alexaSmallBodyTemplate7PreviewDefault.default), {
                        followUp: this.props.followUp,
                        response: response,
                        mediaResponse: mediaResponse
                    });
                case "AudioPlayer":
                    return (0, _react.jsx)((0, _alexaSmallAudioPlayerPreviewDefault.default), {
                        followUp: this.props.followUp,
                        response: response,
                        mediaResponse: mediaResponse
                    });
                case "Video":
                    return (0, _react.jsx)((0, _alexaSmallVideoPreviewDefault.default), {
                        followUp: this.props.followUp,
                        response: response,
                        mediaResponse: mediaResponse
                    });
                case "ListTemplate2":
                    return (0, _react.jsx)((0, _alexaSmallListTemplate2PreviewDefault.default), {
                        followUp: this.props.followUp,
                        response: response,
                        mediaResponse: mediaResponse
                    });
            }
            else {
                if (response.isList) return (0, _react.jsx)((0, _alexaSmallListTemplate2PreviewDefault.default), {
                    followUp: this.props.followUp,
                    response: response,
                    mediaResponse: mediaResponse
                });
                else if (response.videoItem) return (0, _react.jsx)((0, _alexaSmallVideoPreviewDefault.default), {
                    followUp: this.props.followUp,
                    response: response,
                    mediaResponse: mediaResponse
                });
                else if (response.audioItem) return (0, _react.jsx)((0, _alexaSmallAudioPlayerPreviewDefault.default), {
                    followUp: this.props.followUp,
                    response: response,
                    mediaResponse: mediaResponse
                });
                else if (response.imageItem) return (0, _react.jsx)((0, _alexaSmallBodyTemplate2PreviewDefault.default), {
                    followUp: this.props.followUp,
                    response: response,
                    mediaResponse: mediaResponse
                });
                else return (0, _react.jsx)((0, _alexaSmallBodyTemplate1PreviewDefault.default), {
                    followUp: this.props.followUp,
                    response: response,
                    mediaResponse: mediaResponse
                });
            }
        }
        if (this.props.deviceTarget.assistant == "Alexa" && this.props.deviceTarget.displayName.includes("Small")) {
            if (mediaResponse) switch(mediaResponse.responseTemplateType.nativeName){
                case "BodyTemplate1":
                    return (0, _react.jsx)((0, _alexaShortBodyTemplate1PreviewDefault.default), {
                        followUp: this.props.followUp,
                        response: response,
                        mediaResponse: mediaResponse
                    });
                case "BodyTemplate2":
                    return (0, _react.jsx)((0, _alexaShortBodyTemplate2PreviewDefault.default), {
                        followUp: this.props.followUp,
                        response: response,
                        mediaResponse: mediaResponse
                    });
                case "BodyTemplate3":
                    return (0, _react.jsx)((0, _alexaShortBodyTemplate3PreviewDefault.default), {
                        followUp: this.props.followUp,
                        response: response,
                        mediaResponse: mediaResponse
                    });
                case "BodyTemplate6":
                    return (0, _react.jsx)((0, _alexaShortBodyTemplate6PreviewDefault.default), {
                        followUp: this.props.followUp,
                        response: response,
                        mediaResponse: mediaResponse
                    });
                case "BodyTemplate7":
                    return (0, _react.jsx)((0, _alexaShortBodyTemplate7PreviewDefault.default), {
                        followUp: this.props.followUp,
                        response: response,
                        mediaResponse: mediaResponse
                    });
                case "AudioPlayer":
                    return (0, _react.jsx)((0, _alexaShortAudioPlayerPreviewDefault.default), {
                        followUp: this.props.followUp,
                        response: response,
                        mediaResponse: mediaResponse
                    });
                case "Video":
                    return (0, _react.jsx)((0, _alexaShortVideoPreviewDefault.default), {
                        followUp: this.props.followUp,
                        response: response,
                        mediaResponse: mediaResponse
                    });
                case "ListTemplate2":
                    return (0, _react.jsx)((0, _alexaShortListTemplate2PreviewDefault.default), {
                        followUp: this.props.followUp,
                        response: response,
                        mediaResponse: mediaResponse
                    });
            }
            else {
                if (response.isList) return (0, _react.jsx)((0, _alexaShortListTemplate2PreviewDefault.default), {
                    followUp: this.props.followUp,
                    response: response,
                    mediaResponse: mediaResponse
                });
                else if (response.videoItem) return (0, _react.jsx)((0, _alexaShortVideoPreviewDefault.default), {
                    followUp: this.props.followUp,
                    response: response,
                    mediaResponse: mediaResponse
                });
                else if (response.audioItem) return (0, _react.jsx)((0, _alexaShortAudioPlayerPreviewDefault.default), {
                    followUp: this.props.followUp,
                    response: response,
                    mediaResponse: mediaResponse
                });
                else if (response.imageItem) return (0, _react.jsx)((0, _alexaShortBodyTemplate2PreviewDefault.default), {
                    followUp: this.props.followUp,
                    response: response,
                    mediaResponse: mediaResponse
                });
                else return (0, _react.jsx)((0, _alexaShortBodyTemplate1PreviewDefault.default), {
                    followUp: this.props.followUp,
                    response: response,
                    mediaResponse: mediaResponse
                });
            }
        } else if (this.props.deviceTarget.assistant == "GoogleAssistant") {
            if (this.props.deviceTarget.displayName.includes("Screen")) {
                if (mediaResponse) switch(mediaResponse.responseTemplateType.nativeName){
                    case "BodyTemplate1":
                    case "SimpleCard":
                        return (0, _react.jsx)((0, _googleSimpleCardPreviewDefault.default), {
                            followUp: this.props.followUp,
                            response: response,
                            mediaResponse: mediaResponse
                        });
                    case "BodyTemplate2":
                    case "StandardCard":
                        return (0, _react.jsx)((0, _googleStandardCardPreviewDefault.default), {
                            followUp: this.props.followUp,
                            response: response,
                            mediaResponse: mediaResponse
                        });
                    case "MediaResponse":
                        return (0, _react.jsx)((0, _googleMediaResponsePreviewDefault.default), {
                            followUp: this.props.followUp,
                            response: response,
                            mediaResponse: mediaResponse
                        });
                    case "List":
                        return (0, _react.jsx)((0, _googleListPreviewDefault.default), {
                            followUp: this.props.followUp,
                            response: response,
                            mediaResponse: mediaResponse
                        });
                }
                else {
                    if (response.isList) return (0, _react.jsx)((0, _googleListPreviewDefault.default), {
                        followUp: this.props.followUp,
                        response: response,
                        mediaResponse: mediaResponse
                    });
                    else if (response.audioItem) return (0, _react.jsx)((0, _googleMediaResponsePreviewDefault.default), {
                        followUp: this.props.followUp,
                        response: response,
                        mediaResponse: mediaResponse
                    });
                    else if (response.imageItem) return (0, _react.jsx)((0, _googleStandardCardPreviewDefault.default), {
                        followUp: this.props.followUp,
                        response: response,
                        mediaResponse: mediaResponse
                    });
                    else return (0, _react.jsx)((0, _googleSimpleCardPreviewDefault.default), {
                        followUp: this.props.followUp,
                        response: response,
                        mediaResponse: mediaResponse
                    });
                }
            } else if (this.props.deviceTarget.displayName.includes("Mobile")) {
                if (mediaResponse) switch(mediaResponse.responseTemplateType.nativeName){
                    case "BodyTemplate1":
                    case "SimpleCard":
                        return (0, _react.jsx)((0, _googleMobileSimpleCardPreviewDefault.default), {
                            followUp: this.props.followUp,
                            response: response,
                            mediaResponse: mediaResponse
                        });
                    case "BodyTemplate2":
                    case "StandardCard":
                        return (0, _react.jsx)((0, _googleMobileStandardCardPreviewDefault.default), {
                            followUp: this.props.followUp,
                            response: response,
                            mediaResponse: mediaResponse
                        });
                    case "MediaResponse":
                        return (0, _react.jsx)((0, _googleMobileMediaResponsePreviewDefault.default), {
                            followUp: this.props.followUp,
                            response: response,
                            mediaResponse: mediaResponse
                        });
                    case "List":
                        return (0, _react.jsx)((0, _googleMobileListPreviewDefault.default), {
                            followUp: this.props.followUp,
                            response: response,
                            mediaResponse: mediaResponse
                        });
                }
                else {
                    if (response.isList) return (0, _react.jsx)((0, _googleMobileListPreviewDefault.default), {
                        followUp: this.props.followUp,
                        response: response,
                        mediaResponse: mediaResponse
                    });
                    else if (response.audioItem) return (0, _react.jsx)((0, _googleMobileMediaResponsePreviewDefault.default), {
                        followUp: this.props.followUp,
                        response: response,
                        mediaResponse: mediaResponse
                    });
                    else if (response.imageItem) return (0, _react.jsx)((0, _googleMobileStandardCardPreviewDefault.default), {
                        followUp: this.props.followUp,
                        response: response,
                        mediaResponse: mediaResponse
                    });
                    else return (0, _react.jsx)((0, _googleMobileSimpleCardPreviewDefault.default), {
                        followUp: this.props.followUp,
                        response: response,
                        mediaResponse: mediaResponse
                    });
                }
            }
        } else if (this.props.deviceTarget.assistant == "Cortana") {
            if (mediaResponse) switch(mediaResponse.responseTemplateType.nativeName){
                case "BodyTemplate1":
                case "SimpleCard":
                case "Card":
                    return (0, _react.jsx)((0, _cortanaScreenSimpleCardPreviewDefault.default), {
                        followUp: this.props.followUp,
                        response: response,
                        mediaResponse: mediaResponse
                    });
                case "BodyTemplate2":
                case "StandardCard":
                case "Hero":
                    return (0, _react.jsx)((0, _cortanaScreenStandardCardPreviewDefault.default), {
                        followUp: this.props.followUp,
                        response: response,
                        mediaResponse: mediaResponse
                    });
                case "MediaResponse":
                case "AudioCard":
                    return (0, _react.jsx)((0, _cortanaScreenMediaResponsePreviewDefault.default), {
                        followUp: this.props.followUp,
                        response: response,
                        mediaResponse: mediaResponse
                    });
                case "List":
                    return (0, _react.jsx)((0, _cortanaScreenListPreviewDefault.default), {
                        followUp: this.props.followUp,
                        response: response,
                        mediaResponse: mediaResponse
                    });
            }
            else {
                if (response.isList) return (0, _react.jsx)((0, _cortanaScreenListPreviewDefault.default), {
                    followUp: this.props.followUp,
                    response: response,
                    mediaResponse: mediaResponse
                });
                else if (response.audioItem) return (0, _react.jsx)((0, _cortanaScreenMediaResponsePreviewDefault.default), {
                    followUp: this.props.followUp,
                    response: response,
                    mediaResponse: mediaResponse
                });
                else if (response.imageItem) return (0, _react.jsx)((0, _cortanaScreenStandardCardPreviewDefault.default), {
                    followUp: this.props.followUp,
                    response: response,
                    mediaResponse: mediaResponse
                });
                else return (0, _react.jsx)((0, _cortanaScreenSimpleCardPreviewDefault.default), {
                    followUp: this.props.followUp,
                    response: response,
                    mediaResponse: mediaResponse
                });
            }
        }
        return (0, _react.jsx)("p", {
            className: unsupportedDevice
        }, "Unsupported Device Preview");
    }
    render() {
        const { title, variations } = this.props;
        if (!variations) return null;
        return (0, _react.jsx)("div", {
            className: containerStyle
        }, (0, _react.jsx)("div", {
            className: `${bubbleStyle} ac-output-message-preview`
        }, title ? (0, _react.jsx)((0, _reactDefault.default).Fragment, null, (0, _react.jsx)("span", {
            className: "title"
        }, title), (0, _react.jsx)((0, _horizontalSeparatorDefault.default), null)) : null, this.renderDisplayPreview(), this.hasAudio() ? (0, _react.jsx)((0, _multiFileAudioPlayerDefault.default), {
            src: this.getAudioSrc(variations[this.state.position]),
            isLoading: this.props.ssmlContainer.state.isLoading,
            onLoad: ()=>this.loadSsmlAudio(variations[this.state.position])
        }) : null, variations.length > 1 ? (0, _react.jsx)((0, _reactDefault.default).Fragment, null, (0, _react.jsx)((0, _horizontalSeparatorDefault.default), null), (0, _react.jsx)("div", {
            className: "carousel-container"
        }, (0, _react.jsx)("span", null, `VARIATION: ${this.state.position + 1} of ${variations.length}`), (0, _react.jsx)((0, _positionIndicatorDefault.default), {
            count: variations.length,
            position: this.state.position,
            onChange: this.handlePositionChange.bind(this)
        }))) : null), (0, _react.jsx)("img", {
            src: deviceIcon
        }), (0, _react.jsx)((0, _pageErrorDefault.default), {
            errors: this.props.ssmlContainer.state.errors
        }));
    }
}
exports.default = DeviceScreenVariationsBubble;

},{"@emotion/react":"djZKr","@emotion/css":"awUBr","react":"6uln9","../../constants/colors":"1p3OR","../general/PageError":"ezFTm","../structure/ConversationFlow/PositionIndicator":"39CHS","../structure/HorizontalSeparator":"Pw3HQ","./AlexaRectangleScreens/AlexaAudioPlayerPreview":"dEBfz","./AlexaRectangleScreens/AlexaBodyTemplate1Preview":"7deZM","./AlexaRectangleScreens/AlexaBodyTemplate2Preview":"kEZAL","./AlexaRectangleScreens/AlexaBodyTemplate3Preview":"eEJmq","./AlexaRectangleScreens/AlexaBodyTemplate6Preview":"auAMH","./AlexaRectangleScreens/AlexaBodyTemplate7Preview":"bpSWm","./AlexaRectangleScreens/AlexaListTemplate2Preview":"jfUJO","./AlexaRectangleScreens/AlexaVideoPreview":"6dWjd","./AlexaRoundScreens/AlexaSmallAudioPlayerPreview":"bK9L3","./AlexaRoundScreens/AlexaSmallBodyTemplate1Preview":"6ljQA","./AlexaRoundScreens/AlexaSmallBodyTemplate2Preview":"aeZZs","./AlexaRoundScreens/AlexaSmallBodyTemplate3Preview":"UrwhQ","./AlexaRoundScreens/AlexaSmallBodyTemplate6Preview":"kBWXD","./AlexaRoundScreens/AlexaSmallBodyTemplate7Preview":"dgC50","./AlexaRoundScreens/AlexaSmallListTemplate2Preview":"fwgTS","./AlexaRoundScreens/AlexaSmallVideoPreview":"4BY4D","./AlexaShortRectangleScreens/AlexaShortAudioPlayerPreview":"eEDKA","./AlexaShortRectangleScreens/AlexaShortBodyTemplate1Preview":"jUmib","./AlexaShortRectangleScreens/AlexaShortBodyTemplate2Preview":"gHgQY","./AlexaShortRectangleScreens/AlexaShortBodyTemplate3Preview":"Mondn","./AlexaShortRectangleScreens/AlexaShortBodyTemplate6Preview":"lUgsT","./AlexaShortRectangleScreens/AlexaShortBodyTemplate7Preview":"4B6WV","./AlexaShortRectangleScreens/AlexaShortListTemplate2Preview":"g1oP9","./AlexaShortRectangleScreens/AlexaShortVideoPreview":"hnd8Y","./CortanaScreens/CortanaScreenListPreview":"lkhq8","./CortanaScreens/CortanaScreenMediaResponsePreview":"2kFWI","./CortanaScreens/CortanaScreenSimpleCardPreview":"gXVlX","./CortanaScreens/CortanaScreenStandardCardPreview":"1KEHx","./GoogleMobileScreens/GoogleMobileListPreview":"fYqxp","./GoogleMobileScreens/GoogleMobileMediaResponsePreview":"8M60m","./GoogleMobileScreens/GoogleMobileSimpleCardPreview":"aksG3","./GoogleMobileScreens/GoogleMobileStandardCardPreview":"cGAKr","./GoogleSmartScreens/GoogleListPreview":"lYE6m","./GoogleSmartScreens/GoogleMediaResponsePreview":"1uyer","./GoogleSmartScreens/GoogleSimpleCardPreview":"aAxY5","./GoogleSmartScreens/GoogleStandardCardPreview":"jLzoO","./MultiFileAudioPlayer":"6v3LY","dompurify":"5cPaM","3cd2ada9a957a275":"2nj1V","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"dEBfz":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _screenPreviewComponent = require("../ScreenPreviewComponent");
var _screenPreviewComponentDefault = parcelHelpers.interopDefault(_screenPreviewComponent);
var _alexaRectangleWrapper = require("./AlexaRectangleWrapper");
var _alexaRectangleWrapperDefault = parcelHelpers.interopDefault(_alexaRectangleWrapper);
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const screenStyle = /*#__PURE__*/ (0, _css.css)({
    name: "1a5pjha",
    styles: "color:white;.body-text,.title-text{font-family:'Roboto',sans-serif;font-size:80px;padding-top:80px;padding-left:160px;color:white;overflow-wrap:break-word;z-index:2;position:relative;}.body-text{overflow-y:hidden;flex:1;}.body-container{display:flex;z-index:2;align-items:center;height:90%;}.hint-text{font-family:'Noto Serif',serif;font-size:60px;color:white;font-style:italic;z-index:2;padding-left:160px;position:relative;}.foreground-image{width:400px;height:400px;z-index:2;height:auto;padding-right:160px;img{width:100%;height:auto;}}.background-image{width:1920px;height:1080px;position:absolute;z-index:1;}"
});
class AlexaAudioPlayerPreview extends (0, _screenPreviewComponentDefault.default) {
    getHintText() {
        if (this.state.hints && this.state.hints.length > 0) {
            const hint = this.state.hints[0];
            return `Try "Alexa, ${hint.content}"`;
        }
        return "";
    }
    render() {
        return (0, _react.jsx)((0, _alexaRectangleWrapperDefault.default), {
            className: screenStyle
        }, this.state.backgroundImageUrl ? (0, _react.jsx)("img", {
            className: "background-image",
            src: this.state.backgroundImageUrl
        }) : null, (0, _react.jsx)("div", {
            className: "body-container"
        }, (0, _react.jsx)("p", {
            className: "body-text"
        }, (0, _react.jsx)("span", null, this.state.displayTitle), (0, _react.jsx)("br", null), (0, _react.jsx)("span", null, this.state.displayText)), this.state.foregroundImageUrl ? (0, _react.jsx)("div", {
            className: "foreground-image"
        }, (0, _react.jsx)("img", {
            src: this.state.foregroundImageUrl
        })) : null), this.state.hints ? (0, _react.jsx)("p", {
            className: "hint-text"
        }, this.getHintText()) : null);
    }
}
exports.default = AlexaAudioPlayerPreview;

},{"@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","../ScreenPreviewComponent":"lBlZx","./AlexaRectangleWrapper":"3hWhN","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"lBlZx":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
class ScreenPreviewComponent extends (0, _reactDefault.default).Component {
    componentWillMount() {
        this.configureFields();
    }
    configureFields() {
        this.setState({
            ...this.state,
            displayText: this.getDisplayText(),
            displayTitle: this.getDisplayTitle(),
            foregroundImageUrl: this.getForegroundImageUrl(),
            backgroundImageUrl: this.getBackgroundImageUrl(),
            audioUrl: this.getAudioUrl(),
            videoUrl: this.getVideoUrl(),
            hints: this.getHints(),
            followUpText: this.getFollowUpText(),
            ssml: this.getSsmlDisplay()
        });
    }
    componentDidUpdate(prevProps) {
        if (prevProps != this.props) this.configureFields();
    }
    stripTags(ssml) {
        const stripTagRegex = /<\/?[^>]+(>|$)/g;
        var displayText = ssml;
        displayText = displayText.replace(stripTagRegex, "");
        return displayText;
    }
    getSsmlDisplay() {
        if (this.props.mediaResponse && this.props.mediaResponse.readoutOverride != null) return this.stripTags(this.props.mediaResponse.readoutOverride);
        if (this.props.response.content) return this.stripTags(this.props.response.content);
    }
    getDisplayText() {
        if (this.props.mediaResponse && this.props.mediaResponse.displayText != null) return this.props.mediaResponse.displayText.replace("\n", "<br/>");
        if (this.props.response.displayTextOverride) return this.props.response.displayTextOverride.replace("\n", "<br/>");
        if (this.props.response.content) return this.stripTags(this.props.response.content).replace("\r", "<br/>").replace("\n", "<br/>");
        return "";
    }
    getForegroundImageUrl() {
        if (this.props.mediaResponse && this.props.mediaResponse.foregroundImageItem != null) return this.props.mediaResponse.foregroundImageItem.url;
        if (this.props.response.imageItem) return this.props.response.imageItem.url;
        return null;
    }
    getDisplayTitle() {
        if (this.props.mediaResponse && this.props.mediaResponse.displayTitle != null) return this.props.mediaResponse.displayTitle;
        if (this.props.response.audioItem) return this.props.response.audioItem.name;
        if (this.props.response.displayTitleOverride) return this.props.response.displayTitleOverride;
        return null;
    }
    getBackgroundImageUrl() {
        if (this.props.mediaResponse && this.props.mediaResponse.backgroundImageItem) return this.props.mediaResponse.backgroundImageItem.url;
        if (this.props.response.backgroundImageItem) return this.props.response.backgroundImageItem.url;
        return null;
    }
    getVideoUrl() {
        if (this.props.mediaResponse && this.props.mediaResponse.videoItem) return this.props.mediaResponse.videoItem.url;
        if (this.props.response.videoItem) return this.props.response.videoItem.url;
        return null;
    }
    getAudioUrl() {
        if (this.props.mediaResponse && this.props.mediaResponse.audioItem) return this.props.mediaResponse.audioItem.url;
        if (this.props.response.audioItem) return this.props.response.audioItem.url;
        return null;
    }
    getHints() {
        if (!this.props.followUp) return null;
        return this.props.followUp.followUpHints;
    }
    getFollowUpText() {
        if (this.props.followUp && !this.props.response.displayTextOverride) return this.stripTags(this.props.followUp.content);
        return null;
    }
}
exports.default = ScreenPreviewComponent;

},{"react":"6uln9","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3hWhN":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "alexaBodyStyle", ()=>alexaBodyStyle);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _reactContainerDimensions = require("react-container-dimensions");
var _reactContainerDimensionsDefault = parcelHelpers.interopDefault(_reactContainerDimensions);
const alexaBackground = require("cfc7c536c410887c");
const alexaBodyStyle = /*#__PURE__*/ (0, _css.css)("position:relative;width:100%;padding-top:56.25%;margin:16px 0;.screen-wrapper{position:absolute;top:0;left:0;padding:8px;background:black;border-radius:5px;width:calc(100% - 16px);height:100%;}.screen{position:relative;left:50%;top:50%;transform:translate(-49%, -49%);transform-origin:center center;width:1920px;height:1080px;background:url('", alexaBackground, "');background-size:cover;background-repeat:no-repeat;background-position:center center;display:flex;flex-direction:column;.hint-container{margin-bottom:0;margin-top:bottom;}}", "");
const AlexaRectangleWrapper = (props)=>(0, _react.jsx)("div", {
        className: alexaBodyStyle
    }, (0, _react.jsx)("div", {
        className: "screen-wrapper"
    }, (0, _react.jsx)((0, _reactContainerDimensionsDefault.default), null, ({ width, height })=>(0, _react.jsx)("div", {
            className: `screen ${props.className}`,
            style: {
                transform: `translate(-50%, -50%) scale(${Math.min(width / 1920, height / 1080)})`
            }
        }, props.children))));
exports.default = AlexaRectangleWrapper;

},{"@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","react-container-dimensions":"lhO7N","cfc7c536c410887c":"9S2Lw","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"lhO7N":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var _createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
var _react = require("d243181371163d5c");
var _react2 = _interopRequireDefault(_react);
var _propTypes = require("cc95f0c45de01d01");
var _propTypes2 = _interopRequireDefault(_propTypes);
var _reactDom = require("7fae5cdb50fa1e9a");
var _reactDom2 = _interopRequireDefault(_reactDom);
var _elementResizeDetector = require("4fe1d4c8f5bfe412");
var _elementResizeDetector2 = _interopRequireDefault(_elementResizeDetector);
var _invariant = require("b04647b36bb7cdb0");
var _invariant2 = _interopRequireDefault(_invariant);
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var ContainerDimensions = function(_Component) {
    _inherits(ContainerDimensions, _Component);
    _createClass(ContainerDimensions, null, [
        {
            key: "getDomNodeDimensions",
            value: function getDomNodeDimensions(node) {
                var _node$getBoundingClie = node.getBoundingClientRect(), top = _node$getBoundingClie.top, right = _node$getBoundingClie.right, bottom = _node$getBoundingClie.bottom, left = _node$getBoundingClie.left, width = _node$getBoundingClie.width, height = _node$getBoundingClie.height;
                return {
                    top: top,
                    right: right,
                    bottom: bottom,
                    left: left,
                    width: width,
                    height: height
                };
            }
        }
    ]);
    function ContainerDimensions() {
        _classCallCheck(this, ContainerDimensions);
        var _this = _possibleConstructorReturn(this, (ContainerDimensions.__proto__ || Object.getPrototypeOf(ContainerDimensions)).call(this));
        _this.state = {
            initiated: false
        };
        _this.onResize = _this.onResize.bind(_this);
        return _this;
    }
    _createClass(ContainerDimensions, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this.parentNode = _reactDom2.default.findDOMNode(this).parentNode;
                this.elementResizeDetector = (0, _elementResizeDetector2.default)({
                    strategy: "scroll",
                    callOnAdd: false
                });
                this.elementResizeDetector.listenTo(this.parentNode, this.onResize);
                this.componentIsMounted = true;
                this.onResize();
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this.componentIsMounted = false;
                this.elementResizeDetector.uninstall(this.parentNode);
            }
        },
        {
            key: "onResize",
            value: function onResize() {
                var clientRect = ContainerDimensions.getDomNodeDimensions(this.parentNode);
                if (this.componentIsMounted) this.setState(_extends({
                    initiated: true
                }, clientRect));
            }
        },
        {
            key: "render",
            value: function render() {
                (0, _invariant2.default)(this.props.children, "Expected children to be one of function or React.Element");
                if (!this.state.initiated) return _react2.default.createElement("div", null);
                if (typeof this.props.children === "function") {
                    var renderedChildren = this.props.children(this.state);
                    return renderedChildren && _react.Children.only(renderedChildren);
                }
                return _react.Children.only(_react2.default.cloneElement(this.props.children, this.state));
            }
        }
    ]);
    return ContainerDimensions;
}(_react.Component);
ContainerDimensions.propTypes = {
    children: _propTypes2.default.oneOfType([
        _propTypes2.default.element,
        _propTypes2.default.func
    ]).isRequired
};
exports.default = ContainerDimensions;

},{"d243181371163d5c":"6uln9","cc95f0c45de01d01":"6FKs7","7fae5cdb50fa1e9a":"b8T3j","4fe1d4c8f5bfe412":"bVqi7","b04647b36bb7cdb0":"9pmgK"}],"bVqi7":[function(require,module,exports) {
"use strict";
var forEach = require("ea9e0e7d38eca8c3").forEach;
var elementUtilsMaker = require("a178c42848103051");
var listenerHandlerMaker = require("83a254b760ed59a7");
var idGeneratorMaker = require("ed83e19963098ab9");
var idHandlerMaker = require("de82803922f1924b");
var reporterMaker = require("61e10e5ef60df4dd");
var browserDetector = require("c7db79c83f4d637b");
var batchProcessorMaker = require("341d5c54934e6b8a");
var stateHandler = require("8542e4cab8762406");
//Detection strategies.
var objectStrategyMaker = require("2178db436e052fa4");
var scrollStrategyMaker = require("49f9f4550b30745d");
function isCollection(obj) {
    return Array.isArray(obj) || obj.length !== undefined;
}
function toArray(collection) {
    if (!Array.isArray(collection)) {
        var array = [];
        forEach(collection, function(obj) {
            array.push(obj);
        });
        return array;
    } else return collection;
}
function isElement(obj) {
    return obj && obj.nodeType === 1;
}
/**
 * @typedef idHandler
 * @type {object}
 * @property {function} get Gets the resize detector id of the element.
 * @property {function} set Generate and sets the resize detector id of the element.
 */ /**
 * @typedef Options
 * @type {object}
 * @property {boolean} callOnAdd    Determines if listeners should be called when they are getting added.
                                    Default is true. If true, the listener is guaranteed to be called when it has been added.
                                    If false, the listener will not be guarenteed to be called when it has been added (does not prevent it from being called).
 * @property {idHandler} idHandler  A custom id handler that is responsible for generating, setting and retrieving id's for elements.
                                    If not provided, a default id handler will be used.
 * @property {reporter} reporter    A custom reporter that handles reporting logs, warnings and errors.
                                    If not provided, a default id handler will be used.
                                    If set to false, then nothing will be reported.
 * @property {boolean} debug        If set to true, the the system will report debug messages as default for the listenTo method.
 */ /**
 * Creates an element resize detector instance.
 * @public
 * @param {Options?} options Optional global options object that will decide how this instance will work.
 */ module.exports = function(options) {
    options = options || {};
    //idHandler is currently not an option to the listenTo function, so it should not be added to globalOptions.
    var idHandler;
    if (options.idHandler) // To maintain compatability with idHandler.get(element, readonly), make sure to wrap the given idHandler
    // so that readonly flag always is true when it's used here. This may be removed next major version bump.
    idHandler = {
        get: function(element) {
            return options.idHandler.get(element, true);
        },
        set: options.idHandler.set
    };
    else {
        var idGenerator = idGeneratorMaker();
        var defaultIdHandler = idHandlerMaker({
            idGenerator: idGenerator,
            stateHandler: stateHandler
        });
        idHandler = defaultIdHandler;
    }
    //reporter is currently not an option to the listenTo function, so it should not be added to globalOptions.
    var reporter = options.reporter;
    if (!reporter) {
        //If options.reporter is false, then the reporter should be quiet.
        var quiet = reporter === false;
        reporter = reporterMaker(quiet);
    }
    //batchProcessor is currently not an option to the listenTo function, so it should not be added to globalOptions.
    var batchProcessor = getOption(options, "batchProcessor", batchProcessorMaker({
        reporter: reporter
    }));
    //Options to be used as default for the listenTo function.
    var globalOptions = {};
    globalOptions.callOnAdd = !!getOption(options, "callOnAdd", true);
    globalOptions.debug = !!getOption(options, "debug", false);
    var eventListenerHandler = listenerHandlerMaker(idHandler);
    var elementUtils = elementUtilsMaker({
        stateHandler: stateHandler
    });
    //The detection strategy to be used.
    var detectionStrategy;
    var desiredStrategy = getOption(options, "strategy", "object");
    var importantCssRules = getOption(options, "important", false);
    var strategyOptions = {
        reporter: reporter,
        batchProcessor: batchProcessor,
        stateHandler: stateHandler,
        idHandler: idHandler,
        important: importantCssRules
    };
    if (desiredStrategy === "scroll") {
        if (browserDetector.isLegacyOpera()) {
            reporter.warn("Scroll strategy is not supported on legacy Opera. Changing to object strategy.");
            desiredStrategy = "object";
        } else if (browserDetector.isIE(9)) {
            reporter.warn("Scroll strategy is not supported on IE9. Changing to object strategy.");
            desiredStrategy = "object";
        }
    }
    if (desiredStrategy === "scroll") detectionStrategy = scrollStrategyMaker(strategyOptions);
    else if (desiredStrategy === "object") detectionStrategy = objectStrategyMaker(strategyOptions);
    else throw new Error("Invalid strategy name: " + desiredStrategy);
    //Calls can be made to listenTo with elements that are still being installed.
    //Also, same elements can occur in the elements list in the listenTo function.
    //With this map, the ready callbacks can be synchronized between the calls
    //so that the ready callback can always be called when an element is ready - even if
    //it wasn't installed from the function itself.
    var onReadyCallbacks = {};
    /**
     * Makes the given elements resize-detectable and starts listening to resize events on the elements. Calls the event callback for each event for each element.
     * @public
     * @param {Options?} options Optional options object. These options will override the global options. Some options may not be overriden, such as idHandler.
     * @param {element[]|element} elements The given array of elements to detect resize events of. Single element is also valid.
     * @param {function} listener The callback to be executed for each resize event for each element.
     */ function listenTo(options, elements, listener) {
        function onResizeCallback(element) {
            var listeners = eventListenerHandler.get(element);
            forEach(listeners, function callListenerProxy(listener) {
                listener(element);
            });
        }
        function addListener(callOnAdd, element, listener) {
            eventListenerHandler.add(element, listener);
            if (callOnAdd) listener(element);
        }
        //Options object may be omitted.
        if (!listener) {
            listener = elements;
            elements = options;
            options = {};
        }
        if (!elements) throw new Error("At least one element required.");
        if (!listener) throw new Error("Listener required.");
        if (isElement(elements)) // A single element has been passed in.
        elements = [
            elements
        ];
        else if (isCollection(elements)) // Convert collection to array for plugins.
        // TODO: May want to check so that all the elements in the collection are valid elements.
        elements = toArray(elements);
        else return reporter.error("Invalid arguments. Must be a DOM element or a collection of DOM elements.");
        var elementsReady = 0;
        var callOnAdd = getOption(options, "callOnAdd", globalOptions.callOnAdd);
        var onReadyCallback = getOption(options, "onReady", function noop() {});
        var debug = getOption(options, "debug", globalOptions.debug);
        forEach(elements, function attachListenerToElement(element) {
            if (!stateHandler.getState(element)) {
                stateHandler.initState(element);
                idHandler.set(element);
            }
            var id = idHandler.get(element);
            debug && reporter.log("Attaching listener to element", id, element);
            if (!elementUtils.isDetectable(element)) {
                debug && reporter.log(id, "Not detectable.");
                if (elementUtils.isBusy(element)) {
                    debug && reporter.log(id, "System busy making it detectable");
                    //The element is being prepared to be detectable. Do not make it detectable.
                    //Just add the listener, because the element will soon be detectable.
                    addListener(callOnAdd, element, listener);
                    onReadyCallbacks[id] = onReadyCallbacks[id] || [];
                    onReadyCallbacks[id].push(function onReady() {
                        elementsReady++;
                        if (elementsReady === elements.length) onReadyCallback();
                    });
                    return;
                }
                debug && reporter.log(id, "Making detectable...");
                //The element is not prepared to be detectable, so do prepare it and add a listener to it.
                elementUtils.markBusy(element, true);
                return detectionStrategy.makeDetectable({
                    debug: debug,
                    important: importantCssRules
                }, element, function onElementDetectable(element) {
                    debug && reporter.log(id, "onElementDetectable");
                    if (stateHandler.getState(element)) {
                        elementUtils.markAsDetectable(element);
                        elementUtils.markBusy(element, false);
                        detectionStrategy.addListener(element, onResizeCallback);
                        addListener(callOnAdd, element, listener);
                        // Since the element size might have changed since the call to "listenTo", we need to check for this change,
                        // so that a resize event may be emitted.
                        // Having the startSize object is optional (since it does not make sense in some cases such as unrendered elements), so check for its existance before.
                        // Also, check the state existance before since the element may have been uninstalled in the installation process.
                        var state = stateHandler.getState(element);
                        if (state && state.startSize) {
                            var width = element.offsetWidth;
                            var height = element.offsetHeight;
                            if (state.startSize.width !== width || state.startSize.height !== height) onResizeCallback(element);
                        }
                        if (onReadyCallbacks[id]) forEach(onReadyCallbacks[id], function(callback) {
                            callback();
                        });
                    } else // The element has been unisntalled before being detectable.
                    debug && reporter.log(id, "Element uninstalled before being detectable.");
                    delete onReadyCallbacks[id];
                    elementsReady++;
                    if (elementsReady === elements.length) onReadyCallback();
                });
            }
            debug && reporter.log(id, "Already detecable, adding listener.");
            //The element has been prepared to be detectable and is ready to be listened to.
            addListener(callOnAdd, element, listener);
            elementsReady++;
        });
        if (elementsReady === elements.length) onReadyCallback();
    }
    function uninstall(elements) {
        if (!elements) return reporter.error("At least one element is required.");
        if (isElement(elements)) // A single element has been passed in.
        elements = [
            elements
        ];
        else if (isCollection(elements)) // Convert collection to array for plugins.
        // TODO: May want to check so that all the elements in the collection are valid elements.
        elements = toArray(elements);
        else return reporter.error("Invalid arguments. Must be a DOM element or a collection of DOM elements.");
        forEach(elements, function(element) {
            eventListenerHandler.removeAllListeners(element);
            detectionStrategy.uninstall(element);
            stateHandler.cleanState(element);
        });
    }
    function initDocument(targetDocument) {
        detectionStrategy.initDocument && detectionStrategy.initDocument(targetDocument);
    }
    return {
        listenTo: listenTo,
        removeListener: eventListenerHandler.removeListener,
        removeAllListeners: eventListenerHandler.removeAllListeners,
        uninstall: uninstall,
        initDocument: initDocument
    };
};
function getOption(options, name, defaultValue) {
    var value = options[name];
    if ((value === undefined || value === null) && defaultValue !== undefined) return defaultValue;
    return value;
}

},{"ea9e0e7d38eca8c3":"kVKr4","a178c42848103051":"7jI1D","83a254b760ed59a7":"eUSEn","ed83e19963098ab9":"jUA6U","de82803922f1924b":"5qjit","61e10e5ef60df4dd":"kGv1h","c7db79c83f4d637b":"kJePN","341d5c54934e6b8a":"T1A1m","8542e4cab8762406":"2OgyN","2178db436e052fa4":"9cn8Q","49f9f4550b30745d":"khwtV"}],"kVKr4":[function(require,module,exports) {
"use strict";
var utils = module.exports = {};
/**
 * Loops through the collection and calls the callback for each element. if the callback returns truthy, the loop is broken and returns the same value.
 * @public
 * @param {*} collection The collection to loop through. Needs to have a length property set and have indices set from 0 to length - 1.
 * @param {function} callback The callback to be called for each element. The element will be given as a parameter to the callback. If this callback returns truthy, the loop is broken and the same value is returned.
 * @returns {*} The value that a callback has returned (if truthy). Otherwise nothing.
 */ utils.forEach = function(collection, callback) {
    for(var i = 0; i < collection.length; i++){
        var result = callback(collection[i]);
        if (result) return result;
    }
};

},{}],"7jI1D":[function(require,module,exports) {
"use strict";
module.exports = function(options) {
    var getState = options.stateHandler.getState;
    /**
     * Tells if the element has been made detectable and ready to be listened for resize events.
     * @public
     * @param {element} The element to check.
     * @returns {boolean} True or false depending on if the element is detectable or not.
     */ function isDetectable(element) {
        var state = getState(element);
        return state && !!state.isDetectable;
    }
    /**
     * Marks the element that it has been made detectable and ready to be listened for resize events.
     * @public
     * @param {element} The element to mark.
     */ function markAsDetectable(element) {
        getState(element).isDetectable = true;
    }
    /**
     * Tells if the element is busy or not.
     * @public
     * @param {element} The element to check.
     * @returns {boolean} True or false depending on if the element is busy or not.
     */ function isBusy(element) {
        return !!getState(element).busy;
    }
    /**
     * Marks the object is busy and should not be made detectable.
     * @public
     * @param {element} element The element to mark.
     * @param {boolean} busy If the element is busy or not.
     */ function markBusy(element, busy) {
        getState(element).busy = !!busy;
    }
    return {
        isDetectable: isDetectable,
        markAsDetectable: markAsDetectable,
        isBusy: isBusy,
        markBusy: markBusy
    };
};

},{}],"eUSEn":[function(require,module,exports) {
"use strict";
module.exports = function(idHandler) {
    var eventListeners = {};
    /**
     * Gets all listeners for the given element.
     * @public
     * @param {element} element The element to get all listeners for.
     * @returns All listeners for the given element.
     */ function getListeners(element) {
        var id = idHandler.get(element);
        if (id === undefined) return [];
        return eventListeners[id] || [];
    }
    /**
     * Stores the given listener for the given element. Will not actually add the listener to the element.
     * @public
     * @param {element} element The element that should have the listener added.
     * @param {function} listener The callback that the element has added.
     */ function addListener(element, listener) {
        var id = idHandler.get(element);
        if (!eventListeners[id]) eventListeners[id] = [];
        eventListeners[id].push(listener);
    }
    function removeListener(element, listener) {
        var listeners = getListeners(element);
        for(var i = 0, len = listeners.length; i < len; ++i)if (listeners[i] === listener) {
            listeners.splice(i, 1);
            break;
        }
    }
    function removeAllListeners(element) {
        var listeners = getListeners(element);
        if (!listeners) return;
        listeners.length = 0;
    }
    return {
        get: getListeners,
        add: addListener,
        removeListener: removeListener,
        removeAllListeners: removeAllListeners
    };
};

},{}],"jUA6U":[function(require,module,exports) {
"use strict";
module.exports = function() {
    var idCount = 1;
    /**
     * Generates a new unique id in the context.
     * @public
     * @returns {number} A unique id in the context.
     */ function generate() {
        return idCount++;
    }
    return {
        generate: generate
    };
};

},{}],"5qjit":[function(require,module,exports) {
"use strict";
module.exports = function(options) {
    var idGenerator = options.idGenerator;
    var getState = options.stateHandler.getState;
    /**
     * Gets the resize detector id of the element.
     * @public
     * @param {element} element The target element to get the id of.
     * @returns {string|number|null} The id of the element. Null if it has no id.
     */ function getId(element) {
        var state = getState(element);
        if (state && state.id !== undefined) return state.id;
        return null;
    }
    /**
     * Sets the resize detector id of the element. Requires the element to have a resize detector state initialized.
     * @public
     * @param {element} element The target element to set the id of.
     * @returns {string|number|null} The id of the element.
     */ function setId(element) {
        var state = getState(element);
        if (!state) throw new Error("setId required the element to have a resize detection state.");
        var id = idGenerator.generate();
        state.id = id;
        return id;
    }
    return {
        get: getId,
        set: setId
    };
};

},{}],"kGv1h":[function(require,module,exports) {
"use strict";
/* global console: false */ /**
 * Reporter that handles the reporting of logs, warnings and errors.
 * @public
 * @param {boolean} quiet Tells if the reporter should be quiet or not.
 */ module.exports = function(quiet) {
    function noop() {
    //Does nothing.
    }
    var reporter = {
        log: noop,
        warn: noop,
        error: noop
    };
    if (!quiet && window.console) {
        var attachFunction = function(reporter, name) {
            //The proxy is needed to be able to call the method with the console context,
            //since we cannot use bind.
            reporter[name] = function reporterProxy() {
                var f = console[name];
                if (f.apply) f.apply(console, arguments);
                else for(var i = 0; i < arguments.length; i++)f(arguments[i]);
            };
        };
        attachFunction(reporter, "log");
        attachFunction(reporter, "warn");
        attachFunction(reporter, "error");
    }
    return reporter;
};

},{}],"kJePN":[function(require,module,exports) {
"use strict";
var detector = module.exports = {};
detector.isIE = function(version) {
    function isAnyIeVersion() {
        var agent = navigator.userAgent.toLowerCase();
        return agent.indexOf("msie") !== -1 || agent.indexOf("trident") !== -1 || agent.indexOf(" edge/") !== -1;
    }
    if (!isAnyIeVersion()) return false;
    if (!version) return true;
    //Shamelessly stolen from https://gist.github.com/padolsey/527683
    var ieVersion = function() {
        var undef, v = 3, div = document.createElement("div"), all = div.getElementsByTagName("i");
        do div.innerHTML = "<!--[if gt IE " + ++v + "]><i></i><![endif]-->";
        while (all[0]);
        return v > 4 ? v : undef;
    }();
    return version === ieVersion;
};
detector.isLegacyOpera = function() {
    return !!window.opera;
};

},{}],"T1A1m":[function(require,module,exports) {
"use strict";
var utils = require("1de1640da9096082");
module.exports = function batchProcessorMaker(options) {
    options = options || {};
    var reporter = options.reporter;
    var asyncProcess = utils.getOption(options, "async", true);
    var autoProcess = utils.getOption(options, "auto", true);
    if (autoProcess && !asyncProcess) {
        reporter && reporter.warn("Invalid options combination. auto=true and async=false is invalid. Setting async=true.");
        asyncProcess = true;
    }
    var batch = Batch();
    var asyncFrameHandler;
    var isProcessing = false;
    function addFunction(level, fn) {
        if (!isProcessing && autoProcess && asyncProcess && batch.size() === 0) // Since this is async, it is guaranteed to be executed after that the fn is added to the batch.
        // This needs to be done before, since we're checking the size of the batch to be 0.
        processBatchAsync();
        batch.add(level, fn);
    }
    function processBatch() {
        // Save the current batch, and create a new batch so that incoming functions are not added into the currently processing batch.
        // Continue processing until the top-level batch is empty (functions may be added to the new batch while processing, and so on).
        isProcessing = true;
        while(batch.size()){
            var processingBatch = batch;
            batch = Batch();
            processingBatch.process();
        }
        isProcessing = false;
    }
    function forceProcessBatch(localAsyncProcess) {
        if (isProcessing) return;
        if (localAsyncProcess === undefined) localAsyncProcess = asyncProcess;
        if (asyncFrameHandler) {
            cancelFrame(asyncFrameHandler);
            asyncFrameHandler = null;
        }
        if (localAsyncProcess) processBatchAsync();
        else processBatch();
    }
    function processBatchAsync() {
        asyncFrameHandler = requestFrame(processBatch);
    }
    function clearBatch() {
        batch = {};
        batchSize = 0;
        topLevel = 0;
        bottomLevel = 0;
    }
    function cancelFrame(listener) {
        // var cancel = window.cancelAnimationFrame || window.mozCancelAnimationFrame || window.webkitCancelAnimationFrame || window.clearTimeout;
        var cancel = clearTimeout;
        return cancel(listener);
    }
    function requestFrame(callback) {
        // var raf = window.requestAnimationFrame || window.mozRequestAnimationFrame || window.webkitRequestAnimationFrame || function(fn) { return window.setTimeout(fn, 20); };
        var raf = function(fn) {
            return setTimeout(fn, 0);
        };
        return raf(callback);
    }
    return {
        add: addFunction,
        force: forceProcessBatch
    };
};
function Batch() {
    var batch = {};
    var size = 0;
    var topLevel1 = 0;
    var bottomLevel1 = 0;
    function add(level, fn) {
        if (!fn) {
            fn = level;
            level = 0;
        }
        if (level > topLevel1) topLevel1 = level;
        else if (level < bottomLevel1) bottomLevel1 = level;
        if (!batch[level]) batch[level] = [];
        batch[level].push(fn);
        size++;
    }
    function process() {
        for(var level = bottomLevel1; level <= topLevel1; level++){
            var fns = batch[level];
            for(var i = 0; i < fns.length; i++){
                var fn = fns[i];
                fn();
            }
        }
    }
    function getSize() {
        return size;
    }
    return {
        add: add,
        process: process,
        size: getSize
    };
}

},{"1de1640da9096082":"42rIP"}],"42rIP":[function(require,module,exports) {
"use strict";
var utils = module.exports = {};
utils.getOption = getOption;
function getOption(options, name, defaultValue) {
    var value = options[name];
    if ((value === undefined || value === null) && defaultValue !== undefined) return defaultValue;
    return value;
}

},{}],"2OgyN":[function(require,module,exports) {
"use strict";
var prop = "_erd";
function initState(element) {
    element[prop] = {};
    return getState(element);
}
function getState(element) {
    return element[prop];
}
function cleanState(element) {
    delete element[prop];
}
module.exports = {
    initState: initState,
    getState: getState,
    cleanState: cleanState
};

},{}],"9cn8Q":[function(require,module,exports) {
/**
 * Resize detection strategy that injects objects to elements in order to detect resize events.
 * Heavily inspired by: http://www.backalleycoder.com/2013/03/18/cross-browser-event-based-element-resize-detection/
 */ "use strict";
var browserDetector = require("cd9ce4125a1c26c");
module.exports = function(options) {
    options = options || {};
    var reporter = options.reporter;
    var batchProcessor = options.batchProcessor;
    var getState = options.stateHandler.getState;
    if (!reporter) throw new Error("Missing required dependency: reporter.");
    /**
     * Adds a resize event listener to the element.
     * @public
     * @param {element} element The element that should have the listener added.
     * @param {function} listener The listener callback to be called for each resize event of the element. The element will be given as a parameter to the listener callback.
     */ function addListener(element, listener) {
        function listenerProxy() {
            listener(element);
        }
        if (browserDetector.isIE(8)) {
            //IE 8 does not support object, but supports the resize event directly on elements.
            getState(element).object = {
                proxy: listenerProxy
            };
            element.attachEvent("onresize", listenerProxy);
        } else {
            var object = getObject(element);
            if (!object) throw new Error("Element is not detectable by this strategy.");
            object.contentDocument.defaultView.addEventListener("resize", listenerProxy);
        }
    }
    function buildCssTextString(rules) {
        var seperator = options.important ? " !important; " : "; ";
        return (rules.join(seperator) + seperator).trim();
    }
    /**
     * Makes an element detectable and ready to be listened for resize events. Will call the callback when the element is ready to be listened for resize changes.
     * @private
     * @param {object} options Optional options object.
     * @param {element} element The element to make detectable
     * @param {function} callback The callback to be called when the element is ready to be listened for resize changes. Will be called with the element as first parameter.
     */ function makeDetectable(options, element, callback) {
        if (!callback) {
            callback = element;
            element = options;
            options = null;
        }
        options = options || {};
        var debug = options.debug;
        function injectObject(element, callback) {
            var OBJECT_STYLE = buildCssTextString([
                "display: block",
                "position: absolute",
                "top: 0",
                "left: 0",
                "width: 100%",
                "height: 100%",
                "border: none",
                "padding: 0",
                "margin: 0",
                "opacity: 0",
                "z-index: -1000",
                "pointer-events: none"
            ]);
            //The target element needs to be positioned (everything except static) so the absolute positioned object will be positioned relative to the target element.
            // Position altering may be performed directly or on object load, depending on if style resolution is possible directly or not.
            var positionCheckPerformed = false;
            // The element may not yet be attached to the DOM, and therefore the style object may be empty in some browsers.
            // Since the style object is a reference, it will be updated as soon as the element is attached to the DOM.
            var style = window.getComputedStyle(element);
            var width = element.offsetWidth;
            var height = element.offsetHeight;
            getState(element).startSize = {
                width: width,
                height: height
            };
            function mutateDom() {
                function alterPositionStyles() {
                    if (style.position === "static") {
                        element.style.setProperty("position", "relative", options.important ? "important" : "");
                        var removeRelativeStyles = function(reporter, element, style, property) {
                            function getNumericalValue(value) {
                                return value.replace(/[^-\d\.]/g, "");
                            }
                            var value = style[property];
                            if (value !== "auto" && getNumericalValue(value) !== "0") {
                                reporter.warn("An element that is positioned static has style." + property + "=" + value + " which is ignored due to the static positioning. The element will need to be positioned relative, so the style." + property + " will be set to 0. Element: ", element);
                                element.style.setProperty(property, "0", options.important ? "important" : "");
                            }
                        };
                        //Check so that there are no accidental styles that will make the element styled differently now that is is relative.
                        //If there are any, set them to 0 (this should be okay with the user since the style properties did nothing before [since the element was positioned static] anyway).
                        removeRelativeStyles(reporter, element, style, "top");
                        removeRelativeStyles(reporter, element, style, "right");
                        removeRelativeStyles(reporter, element, style, "bottom");
                        removeRelativeStyles(reporter, element, style, "left");
                    }
                }
                function onObjectLoad() {
                    // The object has been loaded, which means that the element now is guaranteed to be attached to the DOM.
                    if (!positionCheckPerformed) alterPositionStyles();
                    /*jshint validthis: true */ function getDocument(element, callback) {
                        //Opera 12 seem to call the object.onload before the actual document has been created.
                        //So if it is not present, poll it with an timeout until it is present.
                        //TODO: Could maybe be handled better with object.onreadystatechange or similar.
                        if (!element.contentDocument) {
                            var state = getState(element);
                            if (state.checkForObjectDocumentTimeoutId) window.clearTimeout(state.checkForObjectDocumentTimeoutId);
                            state.checkForObjectDocumentTimeoutId = setTimeout(function checkForObjectDocument() {
                                state.checkForObjectDocumentTimeoutId = 0;
                                getDocument(element, callback);
                            }, 100);
                            return;
                        }
                        callback(element.contentDocument);
                    }
                    //Mutating the object element here seems to fire another load event.
                    //Mutating the inner document of the object element is fine though.
                    var objectElement = this;
                    //Create the style element to be added to the object.
                    getDocument(objectElement, function onObjectDocumentReady(objectDocument) {
                        //Notify that the element is ready to be listened to.
                        callback(element);
                    });
                }
                // The element may be detached from the DOM, and some browsers does not support style resolving of detached elements.
                // The alterPositionStyles needs to be delayed until we know the element has been attached to the DOM (which we are sure of when the onObjectLoad has been fired), if style resolution is not possible.
                if (style.position !== "") {
                    alterPositionStyles(style);
                    positionCheckPerformed = true;
                }
                //Add an object element as a child to the target element that will be listened to for resize events.
                var object = document.createElement("object");
                object.style.cssText = OBJECT_STYLE;
                object.tabIndex = -1;
                object.type = "text/html";
                object.setAttribute("aria-hidden", "true");
                object.onload = onObjectLoad;
                //Safari: This must occur before adding the object to the DOM.
                //IE: Does not like that this happens before, even if it is also added after.
                if (!browserDetector.isIE()) object.data = "about:blank";
                if (!getState(element)) // The element has been uninstalled before the actual loading happened.
                return;
                element.appendChild(object);
                getState(element).object = object;
                //IE: This must occur after adding the object to the DOM.
                if (browserDetector.isIE()) object.data = "about:blank";
            }
            if (batchProcessor) batchProcessor.add(mutateDom);
            else mutateDom();
        }
        if (browserDetector.isIE(8)) //IE 8 does not support objects properly. Luckily they do support the resize event.
        //So do not inject the object and notify that the element is already ready to be listened to.
        //The event handler for the resize event is attached in the utils.addListener instead.
        callback(element);
        else injectObject(element, callback);
    }
    /**
     * Returns the child object of the target element.
     * @private
     * @param {element} element The target element.
     * @returns The object element of the target.
     */ function getObject(element) {
        return getState(element).object;
    }
    function uninstall(element) {
        if (!getState(element)) return;
        var object = getObject(element);
        if (!object) return;
        if (browserDetector.isIE(8)) element.detachEvent("onresize", object.proxy);
        else element.removeChild(object);
        if (getState(element).checkForObjectDocumentTimeoutId) window.clearTimeout(getState(element).checkForObjectDocumentTimeoutId);
        delete getState(element).object;
    }
    return {
        makeDetectable: makeDetectable,
        addListener: addListener,
        uninstall: uninstall
    };
};

},{"cd9ce4125a1c26c":"kJePN"}],"khwtV":[function(require,module,exports) {
/**
 * Resize detection strategy that injects divs to elements in order to detect resize events on scroll events.
 * Heavily inspired by: https://github.com/marcj/css-element-queries/blob/master/src/ResizeSensor.js
 */ "use strict";
var forEach = require("6db7aa4d80d49894").forEach;
module.exports = function(options) {
    options = options || {};
    var reporter = options.reporter;
    var batchProcessor = options.batchProcessor;
    var getState = options.stateHandler.getState;
    var hasState = options.stateHandler.hasState;
    var idHandler = options.idHandler;
    if (!batchProcessor) throw new Error("Missing required dependency: batchProcessor");
    if (!reporter) throw new Error("Missing required dependency: reporter.");
    //TODO: Could this perhaps be done at installation time?
    var scrollbarSizes = getScrollbarSizes();
    var styleId = "erd_scroll_detection_scrollbar_style";
    var detectionContainerClass = "erd_scroll_detection_container";
    function initDocument(targetDocument) {
        // Inject the scrollbar styling that prevents them from appearing sometimes in Chrome.
        // The injected container needs to have a class, so that it may be styled with CSS (pseudo elements).
        injectScrollStyle(targetDocument, styleId, detectionContainerClass);
    }
    initDocument(window.document);
    function buildCssTextString(rules) {
        var seperator = options.important ? " !important; " : "; ";
        return (rules.join(seperator) + seperator).trim();
    }
    function getScrollbarSizes() {
        var width = 500;
        var height = 500;
        var child = document.createElement("div");
        child.style.cssText = buildCssTextString([
            "position: absolute",
            "width: " + width * 2 + "px",
            "height: " + height * 2 + "px",
            "visibility: hidden",
            "margin: 0",
            "padding: 0"
        ]);
        var container = document.createElement("div");
        container.style.cssText = buildCssTextString([
            "position: absolute",
            "width: " + width + "px",
            "height: " + height + "px",
            "overflow: scroll",
            "visibility: none",
            "top: " + -width * 3 + "px",
            "left: " + -height * 3 + "px",
            "visibility: hidden",
            "margin: 0",
            "padding: 0"
        ]);
        container.appendChild(child);
        document.body.insertBefore(container, document.body.firstChild);
        var widthSize = width - container.clientWidth;
        var heightSize = height - container.clientHeight;
        document.body.removeChild(container);
        return {
            width: widthSize,
            height: heightSize
        };
    }
    function injectScrollStyle(targetDocument, styleId, containerClass) {
        function injectStyle(style, method) {
            method = method || function(element) {
                targetDocument.head.appendChild(element);
            };
            var styleElement = targetDocument.createElement("style");
            styleElement.innerHTML = style;
            styleElement.id = styleId;
            method(styleElement);
            return styleElement;
        }
        if (!targetDocument.getElementById(styleId)) {
            var containerAnimationClass = containerClass + "_animation";
            var containerAnimationActiveClass = containerClass + "_animation_active";
            var style = "/* Created by the element-resize-detector library. */\n";
            style += "." + containerClass + " > div::-webkit-scrollbar { " + buildCssTextString([
                "display: none"
            ]) + " }\n\n";
            style += "." + containerAnimationActiveClass + " { " + buildCssTextString([
                "-webkit-animation-duration: 0.1s",
                "animation-duration: 0.1s",
                "-webkit-animation-name: " + containerAnimationClass,
                "animation-name: " + containerAnimationClass
            ]) + " }\n";
            style += "@-webkit-keyframes " + containerAnimationClass + " { 0% { opacity: 1; } 50% { opacity: 0; } 100% { opacity: 1; } }\n";
            style += "@keyframes " + containerAnimationClass + " { 0% { opacity: 1; } 50% { opacity: 0; } 100% { opacity: 1; } }";
            injectStyle(style);
        }
    }
    function addAnimationClass(element) {
        element.className += " " + detectionContainerClass + "_animation_active";
    }
    function addEvent(el, name, cb) {
        if (el.addEventListener) el.addEventListener(name, cb);
        else if (el.attachEvent) el.attachEvent("on" + name, cb);
        else return reporter.error("[scroll] Don't know how to add event listeners.");
    }
    function removeEvent(el, name, cb) {
        if (el.removeEventListener) el.removeEventListener(name, cb);
        else if (el.detachEvent) el.detachEvent("on" + name, cb);
        else return reporter.error("[scroll] Don't know how to remove event listeners.");
    }
    function getExpandElement(element) {
        return getState(element).container.childNodes[0].childNodes[0].childNodes[0];
    }
    function getShrinkElement(element) {
        return getState(element).container.childNodes[0].childNodes[0].childNodes[1];
    }
    /**
     * Adds a resize event listener to the element.
     * @public
     * @param {element} element The element that should have the listener added.
     * @param {function} listener The listener callback to be called for each resize event of the element. The element will be given as a parameter to the listener callback.
     */ function addListener(element, listener) {
        var listeners = getState(element).listeners;
        if (!listeners.push) throw new Error("Cannot add listener to an element that is not detectable.");
        getState(element).listeners.push(listener);
    }
    /**
     * Makes an element detectable and ready to be listened for resize events. Will call the callback when the element is ready to be listened for resize changes.
     * @private
     * @param {object} options Optional options object.
     * @param {element} element The element to make detectable
     * @param {function} callback The callback to be called when the element is ready to be listened for resize changes. Will be called with the element as first parameter.
     */ function makeDetectable(options, element, callback) {
        if (!callback) {
            callback = element;
            element = options;
            options = null;
        }
        options = options || {};
        function debug() {
            if (options.debug) {
                var args = Array.prototype.slice.call(arguments);
                args.unshift(idHandler.get(element), "Scroll: ");
                if (reporter.log.apply) reporter.log.apply(null, args);
                else for(var i = 0; i < args.length; i++)reporter.log(args[i]);
            }
        }
        function isDetached(element) {
            function isInDocument(element) {
                var isInShadowRoot = element.getRootNode && element.getRootNode().contains(element);
                return element === element.ownerDocument.body || element.ownerDocument.body.contains(element) || isInShadowRoot;
            }
            if (!isInDocument(element)) return true;
            // FireFox returns null style in hidden iframes. See https://github.com/wnr/element-resize-detector/issues/68 and https://bugzilla.mozilla.org/show_bug.cgi?id=795520
            if (window.getComputedStyle(element) === null) return true;
            return false;
        }
        function isUnrendered(element) {
            // Check the absolute positioned container since the top level container is display: inline.
            var container = getState(element).container.childNodes[0];
            var style = window.getComputedStyle(container);
            return !style.width || style.width.indexOf("px") === -1; //Can only compute pixel value when rendered.
        }
        function getStyle() {
            // Some browsers only force layouts when actually reading the style properties of the style object, so make sure that they are all read here,
            // so that the user of the function can be sure that it will perform the layout here, instead of later (important for batching).
            var elementStyle = window.getComputedStyle(element);
            var style = {};
            style.position = elementStyle.position;
            style.width = element.offsetWidth;
            style.height = element.offsetHeight;
            style.top = elementStyle.top;
            style.right = elementStyle.right;
            style.bottom = elementStyle.bottom;
            style.left = elementStyle.left;
            style.widthCSS = elementStyle.width;
            style.heightCSS = elementStyle.height;
            return style;
        }
        function storeStartSize() {
            var style = getStyle();
            getState(element).startSize = {
                width: style.width,
                height: style.height
            };
            debug("Element start size", getState(element).startSize);
        }
        function initListeners() {
            getState(element).listeners = [];
        }
        function storeStyle() {
            debug("storeStyle invoked.");
            if (!getState(element)) {
                debug("Aborting because element has been uninstalled");
                return;
            }
            var style = getStyle();
            getState(element).style = style;
        }
        function storeCurrentSize(element, width, height) {
            getState(element).lastWidth = width;
            getState(element).lastHeight = height;
        }
        function getExpandChildElement(element) {
            return getExpandElement(element).childNodes[0];
        }
        function getWidthOffset() {
            return 2 * scrollbarSizes.width + 1;
        }
        function getHeightOffset() {
            return 2 * scrollbarSizes.height + 1;
        }
        function getExpandWidth(width) {
            return width + 10 + getWidthOffset();
        }
        function getExpandHeight(height) {
            return height + 10 + getHeightOffset();
        }
        function getShrinkWidth(width) {
            return width * 2 + getWidthOffset();
        }
        function getShrinkHeight(height) {
            return height * 2 + getHeightOffset();
        }
        function positionScrollbars(element, width, height) {
            var expand = getExpandElement(element);
            var shrink = getShrinkElement(element);
            var expandWidth = getExpandWidth(width);
            var expandHeight = getExpandHeight(height);
            var shrinkWidth = getShrinkWidth(width);
            var shrinkHeight = getShrinkHeight(height);
            expand.scrollLeft = expandWidth;
            expand.scrollTop = expandHeight;
            shrink.scrollLeft = shrinkWidth;
            shrink.scrollTop = shrinkHeight;
        }
        function injectContainerElement() {
            var container = getState(element).container;
            if (!container) {
                container = document.createElement("div");
                container.className = detectionContainerClass;
                container.style.cssText = buildCssTextString([
                    "visibility: hidden",
                    "display: inline",
                    "width: 0px",
                    "height: 0px",
                    "z-index: -1",
                    "overflow: hidden",
                    "margin: 0",
                    "padding: 0"
                ]);
                getState(element).container = container;
                addAnimationClass(container);
                element.appendChild(container);
                var onAnimationStart = function() {
                    getState(element).onRendered && getState(element).onRendered();
                };
                addEvent(container, "animationstart", onAnimationStart);
                // Store the event handler here so that they may be removed when uninstall is called.
                // See uninstall function for an explanation why it is needed.
                getState(element).onAnimationStart = onAnimationStart;
            }
            return container;
        }
        function injectScrollElements() {
            function alterPositionStyles() {
                var style = getState(element).style;
                if (style.position === "static") {
                    element.style.setProperty("position", "relative", options.important ? "important" : "");
                    var removeRelativeStyles = function(reporter, element, style, property) {
                        function getNumericalValue(value) {
                            return value.replace(/[^-\d\.]/g, "");
                        }
                        var value = style[property];
                        if (value !== "auto" && getNumericalValue(value) !== "0") {
                            reporter.warn("An element that is positioned static has style." + property + "=" + value + " which is ignored due to the static positioning. The element will need to be positioned relative, so the style." + property + " will be set to 0. Element: ", element);
                            element.style[property] = 0;
                        }
                    };
                    //Check so that there are no accidental styles that will make the element styled differently now that is is relative.
                    //If there are any, set them to 0 (this should be okay with the user since the style properties did nothing before [since the element was positioned static] anyway).
                    removeRelativeStyles(reporter, element, style, "top");
                    removeRelativeStyles(reporter, element, style, "right");
                    removeRelativeStyles(reporter, element, style, "bottom");
                    removeRelativeStyles(reporter, element, style, "left");
                }
            }
            function getLeftTopBottomRightCssText(left, top, bottom, right) {
                left = !left ? "0" : left + "px";
                top = !top ? "0" : top + "px";
                bottom = !bottom ? "0" : bottom + "px";
                right = !right ? "0" : right + "px";
                return [
                    "left: " + left,
                    "top: " + top,
                    "right: " + right,
                    "bottom: " + bottom
                ];
            }
            debug("Injecting elements");
            if (!getState(element)) {
                debug("Aborting because element has been uninstalled");
                return;
            }
            alterPositionStyles();
            var rootContainer = getState(element).container;
            if (!rootContainer) rootContainer = injectContainerElement();
            // Due to this WebKit bug https://bugs.webkit.org/show_bug.cgi?id=80808 (currently fixed in Blink, but still present in WebKit browsers such as Safari),
            // we need to inject two containers, one that is width/height 100% and another that is left/top -1px so that the final container always is 1x1 pixels bigger than
            // the targeted element.
            // When the bug is resolved, "containerContainer" may be removed.
            // The outer container can occasionally be less wide than the targeted when inside inline elements element in WebKit (see https://bugs.webkit.org/show_bug.cgi?id=152980).
            // This should be no problem since the inner container either way makes sure the injected scroll elements are at least 1x1 px.
            var scrollbarWidth = scrollbarSizes.width;
            var scrollbarHeight = scrollbarSizes.height;
            var containerContainerStyle = buildCssTextString([
                "position: absolute",
                "flex: none",
                "overflow: hidden",
                "z-index: -1",
                "visibility: hidden",
                "width: 100%",
                "height: 100%",
                "left: 0px",
                "top: 0px"
            ]);
            var containerStyle = buildCssTextString([
                "position: absolute",
                "flex: none",
                "overflow: hidden",
                "z-index: -1",
                "visibility: hidden"
            ].concat(getLeftTopBottomRightCssText(-(1 + scrollbarWidth), -(1 + scrollbarHeight), -scrollbarHeight, -scrollbarWidth)));
            var expandStyle = buildCssTextString([
                "position: absolute",
                "flex: none",
                "overflow: scroll",
                "z-index: -1",
                "visibility: hidden",
                "width: 100%",
                "height: 100%"
            ]);
            var shrinkStyle = buildCssTextString([
                "position: absolute",
                "flex: none",
                "overflow: scroll",
                "z-index: -1",
                "visibility: hidden",
                "width: 100%",
                "height: 100%"
            ]);
            var expandChildStyle = buildCssTextString([
                "position: absolute",
                "left: 0",
                "top: 0"
            ]);
            var shrinkChildStyle = buildCssTextString([
                "position: absolute",
                "width: 200%",
                "height: 200%"
            ]);
            var containerContainer = document.createElement("div");
            var container = document.createElement("div");
            var expand = document.createElement("div");
            var expandChild = document.createElement("div");
            var shrink = document.createElement("div");
            var shrinkChild = document.createElement("div");
            // Some browsers choke on the resize system being rtl, so force it to ltr. https://github.com/wnr/element-resize-detector/issues/56
            // However, dir should not be set on the top level container as it alters the dimensions of the target element in some browsers.
            containerContainer.dir = "ltr";
            containerContainer.style.cssText = containerContainerStyle;
            containerContainer.className = detectionContainerClass;
            container.className = detectionContainerClass;
            container.style.cssText = containerStyle;
            expand.style.cssText = expandStyle;
            expandChild.style.cssText = expandChildStyle;
            shrink.style.cssText = shrinkStyle;
            shrinkChild.style.cssText = shrinkChildStyle;
            expand.appendChild(expandChild);
            shrink.appendChild(shrinkChild);
            container.appendChild(expand);
            container.appendChild(shrink);
            containerContainer.appendChild(container);
            rootContainer.appendChild(containerContainer);
            function onExpandScroll() {
                var state = getState(element);
                if (state && state.onExpand) state.onExpand();
                else debug("Aborting expand scroll handler: element has been uninstalled");
            }
            function onShrinkScroll() {
                var state = getState(element);
                if (state && state.onShrink) state.onShrink();
                else debug("Aborting shrink scroll handler: element has been uninstalled");
            }
            addEvent(expand, "scroll", onExpandScroll);
            addEvent(shrink, "scroll", onShrinkScroll);
            // Store the event handlers here so that they may be removed when uninstall is called.
            // See uninstall function for an explanation why it is needed.
            getState(element).onExpandScroll = onExpandScroll;
            getState(element).onShrinkScroll = onShrinkScroll;
        }
        function registerListenersAndPositionElements() {
            function updateChildSizes(element, width, height) {
                var expandChild = getExpandChildElement(element);
                var expandWidth = getExpandWidth(width);
                var expandHeight = getExpandHeight(height);
                expandChild.style.setProperty("width", expandWidth + "px", options.important ? "important" : "");
                expandChild.style.setProperty("height", expandHeight + "px", options.important ? "important" : "");
            }
            function updateDetectorElements(done) {
                var width = element.offsetWidth;
                var height = element.offsetHeight;
                // Check whether the size has actually changed since last time the algorithm ran. If not, some steps may be skipped.
                var sizeChanged = width !== getState(element).lastWidth || height !== getState(element).lastHeight;
                debug("Storing current size", width, height);
                // Store the size of the element sync here, so that multiple scroll events may be ignored in the event listeners.
                // Otherwise the if-check in handleScroll is useless.
                storeCurrentSize(element, width, height);
                // Since we delay the processing of the batch, there is a risk that uninstall has been called before the batch gets to execute.
                // Since there is no way to cancel the fn executions, we need to add an uninstall guard to all fns of the batch.
                batchProcessor.add(0, function performUpdateChildSizes() {
                    if (!sizeChanged) return;
                    if (!getState(element)) {
                        debug("Aborting because element has been uninstalled");
                        return;
                    }
                    if (!areElementsInjected()) {
                        debug("Aborting because element container has not been initialized");
                        return;
                    }
                    if (options.debug) {
                        var w = element.offsetWidth;
                        var h = element.offsetHeight;
                        if (w !== width || h !== height) reporter.warn(idHandler.get(element), "Scroll: Size changed before updating detector elements.");
                    }
                    updateChildSizes(element, width, height);
                });
                batchProcessor.add(1, function updateScrollbars() {
                    // This function needs to be invoked event though the size is unchanged. The element could have been resized very quickly and then
                    // been restored to the original size, which will have changed the scrollbar positions.
                    if (!getState(element)) {
                        debug("Aborting because element has been uninstalled");
                        return;
                    }
                    if (!areElementsInjected()) {
                        debug("Aborting because element container has not been initialized");
                        return;
                    }
                    positionScrollbars(element, width, height);
                });
                if (sizeChanged && done) batchProcessor.add(2, function() {
                    if (!getState(element)) {
                        debug("Aborting because element has been uninstalled");
                        return;
                    }
                    if (!areElementsInjected()) {
                        debug("Aborting because element container has not been initialized");
                        return;
                    }
                    done();
                });
            }
            function areElementsInjected() {
                return !!getState(element).container;
            }
            function notifyListenersIfNeeded() {
                function isFirstNotify() {
                    return getState(element).lastNotifiedWidth === undefined;
                }
                debug("notifyListenersIfNeeded invoked");
                var state = getState(element);
                // Don't notify if the current size is the start size, and this is the first notification.
                if (isFirstNotify() && state.lastWidth === state.startSize.width && state.lastHeight === state.startSize.height) return debug("Not notifying: Size is the same as the start size, and there has been no notification yet.");
                // Don't notify if the size already has been notified.
                if (state.lastWidth === state.lastNotifiedWidth && state.lastHeight === state.lastNotifiedHeight) return debug("Not notifying: Size already notified");
                debug("Current size not notified, notifying...");
                state.lastNotifiedWidth = state.lastWidth;
                state.lastNotifiedHeight = state.lastHeight;
                forEach(getState(element).listeners, function(listener) {
                    listener(element);
                });
            }
            function handleRender() {
                debug("startanimation triggered.");
                if (isUnrendered(element)) {
                    debug("Ignoring since element is still unrendered...");
                    return;
                }
                debug("Element rendered.");
                var expand = getExpandElement(element);
                var shrink = getShrinkElement(element);
                if (expand.scrollLeft === 0 || expand.scrollTop === 0 || shrink.scrollLeft === 0 || shrink.scrollTop === 0) {
                    debug("Scrollbars out of sync. Updating detector elements...");
                    updateDetectorElements(notifyListenersIfNeeded);
                }
            }
            function handleScroll() {
                debug("Scroll detected.");
                if (isUnrendered(element)) {
                    // Element is still unrendered. Skip this scroll event.
                    debug("Scroll event fired while unrendered. Ignoring...");
                    return;
                }
                updateDetectorElements(notifyListenersIfNeeded);
            }
            debug("registerListenersAndPositionElements invoked.");
            if (!getState(element)) {
                debug("Aborting because element has been uninstalled");
                return;
            }
            getState(element).onRendered = handleRender;
            getState(element).onExpand = handleScroll;
            getState(element).onShrink = handleScroll;
            var style = getState(element).style;
            updateChildSizes(element, style.width, style.height);
        }
        function finalizeDomMutation() {
            debug("finalizeDomMutation invoked.");
            if (!getState(element)) {
                debug("Aborting because element has been uninstalled");
                return;
            }
            var style = getState(element).style;
            storeCurrentSize(element, style.width, style.height);
            positionScrollbars(element, style.width, style.height);
        }
        function ready() {
            callback(element);
        }
        function install() {
            debug("Installing...");
            initListeners();
            storeStartSize();
            batchProcessor.add(0, storeStyle);
            batchProcessor.add(1, injectScrollElements);
            batchProcessor.add(2, registerListenersAndPositionElements);
            batchProcessor.add(3, finalizeDomMutation);
            batchProcessor.add(4, ready);
        }
        debug("Making detectable...");
        if (isDetached(element)) {
            debug("Element is detached");
            injectContainerElement();
            debug("Waiting until element is attached...");
            getState(element).onRendered = function() {
                debug("Element is now attached");
                install();
            };
        } else install();
    }
    function uninstall(element) {
        var state = getState(element);
        if (!state) // Uninstall has been called on a non-erd element.
        return;
        // Uninstall may have been called in the following scenarios:
        // (1) Right between the sync code and async batch (here state.busy = true, but nothing have been registered or injected).
        // (2) In the ready callback of the last level of the batch by another element (here, state.busy = true, but all the stuff has been injected).
        // (3) After the installation process (here, state.busy = false and all the stuff has been injected).
        // So to be on the safe side, let's check for each thing before removing.
        // We need to remove the event listeners, because otherwise the event might fire on an uninstall element which results in an error when trying to get the state of the element.
        state.onExpandScroll && removeEvent(getExpandElement(element), "scroll", state.onExpandScroll);
        state.onShrinkScroll && removeEvent(getShrinkElement(element), "scroll", state.onShrinkScroll);
        state.onAnimationStart && removeEvent(state.container, "animationstart", state.onAnimationStart);
        state.container && element.removeChild(state.container);
    }
    return {
        makeDetectable: makeDetectable,
        addListener: addListener,
        uninstall: uninstall,
        initDocument: initDocument
    };
};

},{"6db7aa4d80d49894":"kVKr4"}],"9pmgK":[function(require,module,exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */ var invariant = function(condition, format, a, b, c, d, e, f) {
    if (!condition) {
        var error;
        if (format === undefined) error = new Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");
        else {
            var args = [
                a,
                b,
                c,
                d,
                e,
                f
            ];
            var argIndex = 0;
            error = new Error(format.replace(/%s/g, function() {
                return args[argIndex++];
            }));
            error.name = "Invariant Violation";
        }
        error.framesToPop = 1; // we don't care about invariant's own frame
        throw error;
    }
};
module.exports = invariant;

},{}],"9S2Lw":[function(require,module,exports) {
module.exports = require("1d56f1d08d44db42").getBundleURL("kVLro") + require("5d99215d9300d3cb").resolve("b80VU");

},{"1d56f1d08d44db42":"c7Tr5","5d99215d9300d3cb":"fyJL2"}],"7deZM":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _screenPreviewComponent = require("../ScreenPreviewComponent");
var _screenPreviewComponentDefault = parcelHelpers.interopDefault(_screenPreviewComponent);
var _alexaRectangleWrapper = require("./AlexaRectangleWrapper");
var _alexaRectangleWrapperDefault = parcelHelpers.interopDefault(_alexaRectangleWrapper);
var _dompurify = require("dompurify");
var _dompurifyDefault = parcelHelpers.interopDefault(_dompurify);
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const screenStyle = /*#__PURE__*/ (0, _css.css)({
    name: "3ag5c2",
    styles: "color:white;.body-text,.title-text{font-family:'Roboto',sans-serif;font-size:80px;padding-top:80px;padding-left:160px;padding-right:160px;color:white;overflow-wrap:break-word;z-index:2;position:relative;}.body-text{overflow-y:hidden;height:860px;flex:1;}.body-container{display:flex;z-index:2;position:relative;}.hint-text{font-family:'Noto Serif',serif;font-size:60px;color:white;font-style:italic;z-index:2;padding-left:160px;position:relative;}.background-image{width:1920px;height:1080px;position:absolute;z-index:1;}"
});
class AlexaBody1TemplatePreview extends (0, _screenPreviewComponentDefault.default) {
    getHintText() {
        if (this.state.hints && this.state.hints.length > 0) {
            const hint = this.state.hints[0];
            return `Try "Alexa, ${hint.content}"`;
        }
        return "";
    }
    render() {
        return (0, _react.jsx)((0, _alexaRectangleWrapperDefault.default), {
            className: screenStyle
        }, this.state.backgroundImageUrl ? (0, _react.jsx)("img", {
            className: "background-image",
            src: this.state.backgroundImageUrl
        }) : null, this.state.displayTitle ? (0, _react.jsx)("p", {
            className: "title-text"
        }, this.state.displayTitle) : null, (0, _react.jsx)("div", {
            className: "body-container"
        }, (0, _react.jsx)("p", {
            className: "body-text"
        }, (0, _react.jsx)("span", {
            dangerouslySetInnerHTML: {
                __html: (0, _dompurifyDefault.default).sanitize(this.state.displayText)
            }
        }), this.state.followUpText ? (0, _react.jsx)((0, _reactDefault.default).Fragment, null, (0, _react.jsx)("br", null), (0, _react.jsx)("br", null), (0, _react.jsx)("span", {
            className: "followup-text",
            dangerouslySetInnerHTML: {
                __html: (0, _dompurifyDefault.default).sanitize(this.state.followUpText)
            }
        })) : null)));
    }
}
exports.default = AlexaBody1TemplatePreview;

},{"@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","../ScreenPreviewComponent":"lBlZx","./AlexaRectangleWrapper":"3hWhN","dompurify":"5cPaM","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"kEZAL":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _screenPreviewComponent = require("../ScreenPreviewComponent");
var _screenPreviewComponentDefault = parcelHelpers.interopDefault(_screenPreviewComponent);
var _alexaRectangleWrapper = require("./AlexaRectangleWrapper");
var _alexaRectangleWrapperDefault = parcelHelpers.interopDefault(_alexaRectangleWrapper);
var _dompurify = require("dompurify");
var _dompurifyDefault = parcelHelpers.interopDefault(_dompurify);
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const screenStyle = /*#__PURE__*/ (0, _css.css)({
    name: "1nzca0v",
    styles: "color:white;overflow:hidden;.body-text,.title-text{font-family:'Roboto',sans-serif;font-size:80px;padding-top:80px;padding-left:160px;color:white;overflow-wrap:break-word;z-index:2;position:relative;}.body-text{overflow-y:hidden;height:860px;flex:1;}.body-container{display:flex;align-items:start;z-index:2;position:relative;}.hint-text{font-family:'Noto Serif',serif;font-size:60px;color:white;font-style:italic;z-index:2;padding-left:160px;position:relative;}.foreground-image{width:600px;z-index:2;height:auto;padding-right:160px;margin-top:80px;img{width:100%;height:auto;}}.background-image{width:1920px;height:1080px;position:absolute;z-index:1;}"
});
class AlexaBody2TemplatePreview extends (0, _screenPreviewComponentDefault.default) {
    getHintText() {
        if (this.state.hints && this.state.hints.length > 0) {
            const hint = this.state.hints[0];
            return `Try "Alexa, ${hint.content}"`;
        }
        return "";
    }
    render() {
        return (0, _react.jsx)((0, _alexaRectangleWrapperDefault.default), {
            className: screenStyle
        }, this.state.backgroundImageUrl ? (0, _react.jsx)("img", {
            className: "background-image",
            src: this.state.backgroundImageUrl
        }) : null, this.state.displayTitle ? (0, _react.jsx)("p", {
            className: "title-text"
        }, this.state.displayTitle) : null, (0, _react.jsx)("div", {
            className: "body-container"
        }, (0, _react.jsx)("p", {
            className: "body-text"
        }, (0, _react.jsx)("span", {
            dangerouslySetInnerHTML: {
                __html: (0, _dompurifyDefault.default).sanitize(this.state.displayText)
            }
        }), this.state.followUpText ? (0, _react.jsx)((0, _reactDefault.default).Fragment, null, (0, _react.jsx)("br", null), (0, _react.jsx)("br", null), (0, _react.jsx)("span", {
            className: "followup-text",
            dangerouslySetInnerHTML: {
                __html: (0, _dompurifyDefault.default).sanitize(this.state.followUpText)
            }
        })) : null), this.state.foregroundImageUrl ? (0, _react.jsx)("div", {
            className: "foreground-image"
        }, (0, _react.jsx)("img", {
            src: this.state.foregroundImageUrl
        })) : null), this.state.hints ? (0, _react.jsx)("p", {
            className: "hint-text"
        }, this.getHintText()) : null);
    }
}
exports.default = AlexaBody2TemplatePreview;

},{"@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","../ScreenPreviewComponent":"lBlZx","./AlexaRectangleWrapper":"3hWhN","dompurify":"5cPaM","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"eEJmq":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _screenPreviewComponent = require("../ScreenPreviewComponent");
var _screenPreviewComponentDefault = parcelHelpers.interopDefault(_screenPreviewComponent);
var _alexaRectangleWrapper = require("./AlexaRectangleWrapper");
var _alexaRectangleWrapperDefault = parcelHelpers.interopDefault(_alexaRectangleWrapper);
var _dompurify = require("dompurify");
var _dompurifyDefault = parcelHelpers.interopDefault(_dompurify);
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const screenStyle = /*#__PURE__*/ (0, _css.css)({
    name: "1i5vnrd",
    styles: "color:white;.body-text,.title-text{font-family:'Roboto',sans-serif;font-size:80px;padding-top:80px;padding-left:80px;padding-right:160px;color:white;overflow-wrap:break-word;z-index:2;position:relative;}.body-text{overflow-y:hidden;height:860px;flex:1;}.body-container{display:flex;z-index:2;position:relative;align-items:start;}.hint-text{font-family:'Noto Serif',serif;font-size:60px;color:white;font-style:italic;z-index:2;padding-left:160px;position:relative;}.foreground-image{width:600px;z-index:2;height:auto;padding-left:160px;padding-right:80px;margin-top:80px;img{width:100%;height:auto;}}.background-image{width:1920px;height:1080px;position:absolute;z-index:1;}"
});
class AlexaBody3TemplatePreview extends (0, _screenPreviewComponentDefault.default) {
    getHintText() {
        if (this.state.hints && this.state.hints.length > 0) {
            const hint = this.state.hints[0];
            return `Try "Alexa, ${hint.content}"`;
        }
        return "";
    }
    render() {
        return (0, _react.jsx)((0, _alexaRectangleWrapperDefault.default), {
            className: screenStyle
        }, this.state.backgroundImageUrl ? (0, _react.jsx)("img", {
            className: "background-image",
            src: this.state.backgroundImageUrl
        }) : null, this.state.displayTitle ? (0, _react.jsx)("p", {
            className: "title-text"
        }, this.state.displayTitle) : null, (0, _react.jsx)("div", {
            className: "body-container"
        }, this.state.foregroundImageUrl ? (0, _react.jsx)("div", {
            className: "foreground-image"
        }, (0, _react.jsx)("img", {
            src: this.state.foregroundImageUrl
        })) : null, (0, _react.jsx)("p", {
            className: "body-text"
        }, (0, _react.jsx)("span", {
            dangerouslySetInnerHTML: {
                __html: (0, _dompurifyDefault.default).sanitize(this.state.displayText)
            }
        }), this.state.followUpText ? (0, _react.jsx)((0, _reactDefault.default).Fragment, null, (0, _react.jsx)("br", null), (0, _react.jsx)("br", null), (0, _react.jsx)("span", {
            className: "followup-text",
            dangerouslySetInnerHTML: {
                __html: (0, _dompurifyDefault.default).sanitize(this.state.followUpText)
            }
        })) : null)), this.state.hints ? (0, _react.jsx)("p", {
            className: "hint-text"
        }, this.getHintText()) : null);
    }
}
exports.default = AlexaBody3TemplatePreview;

},{"@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","../ScreenPreviewComponent":"lBlZx","./AlexaRectangleWrapper":"3hWhN","dompurify":"5cPaM","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"auAMH":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _screenPreviewComponent = require("../ScreenPreviewComponent");
var _screenPreviewComponentDefault = parcelHelpers.interopDefault(_screenPreviewComponent);
var _alexaRectangleWrapper = require("./AlexaRectangleWrapper");
var _alexaRectangleWrapperDefault = parcelHelpers.interopDefault(_alexaRectangleWrapper);
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const screenStyle = /*#__PURE__*/ (0, _css.css)({
    name: "lqs15d",
    styles: "color:white;.body-text{font-family:'Roboto',sans-serif;font-size:100px;padding-left:160px;color:white;overflow-wrap:break-word;overflow-y:hidden;height:160px;padding-top:800px;flex:1;margin-bottom:0;margin-top:auto;z-index:2;position:relative;}.body-container{display:flex;z-index:2;position:relative;}.hint-text{font-family:'Noto Serif',serif;font-size:60px;color:white;font-style:italic;z-index:2;padding-left:160px;position:relative;}.foreground-image{width:600px;z-index:2;height:auto;padding-right:160px;img{width:100%;height:auto;}}.background-image{width:1920px;height:1080px;position:absolute;top:0;left:0;bottom:0;z-index:1;}"
});
class AlexaBody6TemplatePreview extends (0, _screenPreviewComponentDefault.default) {
    getHintText() {
        if (this.state.hints && this.state.hints.length > 0) {
            const hint = this.state.hints[0];
            return `Try "Alexa, ${hint.content}"`;
        }
        return "";
    }
    render() {
        return (0, _react.jsx)((0, _alexaRectangleWrapperDefault.default), {
            className: screenStyle
        }, this.state.backgroundImageUrl ? (0, _react.jsx)("img", {
            className: "background-image",
            src: this.state.backgroundImageUrl
        }) : null, (0, _react.jsx)("div", {
            className: "body-container"
        }, (0, _react.jsx)("p", {
            className: "body-text"
        }, (0, _react.jsx)("span", null, this.state.displayText))), this.state.hints ? (0, _react.jsx)("p", {
            className: "hint-text"
        }, this.getHintText()) : null);
    }
}
exports.default = AlexaBody6TemplatePreview;

},{"@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","../ScreenPreviewComponent":"lBlZx","./AlexaRectangleWrapper":"3hWhN","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"bpSWm":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _screenPreviewComponent = require("../ScreenPreviewComponent");
var _screenPreviewComponentDefault = parcelHelpers.interopDefault(_screenPreviewComponent);
var _alexaRectangleWrapper = require("./AlexaRectangleWrapper");
var _alexaRectangleWrapperDefault = parcelHelpers.interopDefault(_alexaRectangleWrapper);
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const screenStyle = /*#__PURE__*/ (0, _css.css)({
    name: "13z8wdh",
    styles: "color:white;.title-text{font-family:'Roboto',sans-serif;font-size:80px;padding-top:80px;padding-left:80px;padding-right:160px;color:white;overflow-wrap:break-word;z-index:2;position:relative;}.body-container{display:flex;z-index:2;align-items:center;justify-content:center;position:relative;}.hint-text{font-family:'Noto Serif',serif;font-size:60px;color:white;font-style:italic;z-index:2;padding-left:160px;position:relative;}.foreground-image{z-index:2;height:800px;width:auto;padding-left:80px;padding-right:80px;img{width:auto;height:100%;}}.background-image{width:1920px;height:1080px;position:absolute;z-index:1;}"
});
class AlexaBody7TemplatePreview extends (0, _screenPreviewComponentDefault.default) {
    getHintText() {
        if (this.state.hints && this.state.hints.length > 0) {
            const hint = this.state.hints[0];
            return `Try "Alexa, ${hint.content}"`;
        }
        return "";
    }
    render() {
        return (0, _react.jsx)((0, _alexaRectangleWrapperDefault.default), {
            className: screenStyle
        }, this.state.backgroundImageUrl ? (0, _react.jsx)("img", {
            className: "background-image",
            src: this.state.backgroundImageUrl
        }) : null, this.state.displayTitle ? (0, _react.jsx)("p", {
            className: "title-text"
        }, this.state.displayTitle) : null, (0, _react.jsx)("div", {
            className: "body-container"
        }, this.state.foregroundImageUrl ? (0, _react.jsx)("div", {
            className: "foreground-image"
        }, (0, _react.jsx)("img", {
            src: this.state.foregroundImageUrl
        })) : null), this.state.hints ? (0, _react.jsx)("p", {
            className: "hint-text"
        }, this.getHintText()) : null);
    }
}
exports.default = AlexaBody7TemplatePreview;

},{"@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","../ScreenPreviewComponent":"lBlZx","./AlexaRectangleWrapper":"3hWhN","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jfUJO":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _screenPreviewComponent = require("../ScreenPreviewComponent");
var _screenPreviewComponentDefault = parcelHelpers.interopDefault(_screenPreviewComponent);
var _alexaRectangleWrapper = require("./AlexaRectangleWrapper");
var _alexaRectangleWrapperDefault = parcelHelpers.interopDefault(_alexaRectangleWrapper);
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const screenStyle = /*#__PURE__*/ (0, _css.css)({
    name: "8lrj0q",
    styles: "color:white;.body-text,.title-text{font-family:'Roboto',sans-serif;font-size:80px;padding-top:80px;padding-left:160px;color:white;overflow-wrap:break-word;z-index:2;position:relative;}.body-text{overflow-y:hidden;text-align:center;font-size:40px;margin-top:30px;padding:0;}.body-container{display:flex;z-index:2;position:relative;align-items:baseline;margin-top:150px;justify-content:center;}.hint-text{font-family:'Noto Serif',serif;font-size:60px;color:white;font-style:italic;z-index:2;padding-left:160px;position:relative;margin-bottom:20px;margin-top:auto;}.foreground-image{width:400px;height:400px;z-index:2;img{height:100%;width:auto;}&.empty{background:#CCCCCC;}}.list-item{display:flex;flex-direction:column;align-items:center;margin-right:160px;max-width:440px;}.background-image{width:1920px;height:1080px;position:absolute;z-index:1;}"
});
class AlexaListTemplate2Preview extends (0, _screenPreviewComponentDefault.default) {
    getHintText() {
        if (this.state.hints && this.state.hints.length > 0) {
            const hint = this.state.hints[0];
            return `Try "Alexa, ${hint.content}"`;
        }
        return "";
    }
    renderAdditionalItems() {
        const items = [];
        for(var i = 0; i < this.props.response.additionalListItems; i++)items.push(i);
        return items.map((_, i)=>(0, _react.jsx)("div", {
                key: i,
                className: "list-item"
            }, (0, _react.jsx)("div", {
                className: "foreground-image empty"
            }), (0, _react.jsx)("p", {
                className: "body-text"
            }, (0, _react.jsx)("span", null, i + 2, ". Additional Item"))));
    }
    render() {
        return (0, _react.jsx)((0, _alexaRectangleWrapperDefault.default), {
            className: screenStyle
        }, this.state.backgroundImageUrl ? (0, _react.jsx)("img", {
            className: "background-image",
            src: this.state.backgroundImageUrl
        }) : null, this.state.displayTitle ? (0, _react.jsx)("p", {
            className: "title-text"
        }, this.state.displayTitle) : null, (0, _react.jsx)("div", {
            className: "body-container"
        }, (0, _react.jsx)("div", {
            className: "list-item"
        }, this.state.foregroundImageUrl ? (0, _react.jsx)("div", {
            className: "foreground-image"
        }, (0, _react.jsx)("img", {
            src: this.state.foregroundImageUrl
        })) : (0, _react.jsx)("div", {
            className: "foreground-image empty"
        }), (0, _react.jsx)("p", {
            className: "body-text"
        }, (0, _react.jsx)("span", null, "1. ", this.state.displayText))), this.props.response.additionalListItems ? this.renderAdditionalItems() : null), this.state.hints ? (0, _react.jsx)("p", {
            className: "hint-text"
        }, this.getHintText()) : null);
    }
}
exports.default = AlexaListTemplate2Preview;

},{"@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","../ScreenPreviewComponent":"lBlZx","./AlexaRectangleWrapper":"3hWhN","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6dWjd":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _screenPreviewComponent = require("../ScreenPreviewComponent");
var _screenPreviewComponentDefault = parcelHelpers.interopDefault(_screenPreviewComponent);
var _alexaRectangleWrapper = require("./AlexaRectangleWrapper");
var _alexaRectangleWrapperDefault = parcelHelpers.interopDefault(_alexaRectangleWrapper);
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const screenStyle = /*#__PURE__*/ (0, _css.css)({
    name: "1tfa7cg",
    styles: "video{width:1920px;height:1080px;}"
});
class AlexaVideoPreview extends (0, _screenPreviewComponentDefault.default) {
    render() {
        return (0, _react.jsx)((0, _alexaRectangleWrapperDefault.default), {
            className: screenStyle
        }, this.state.videoUrl ? (0, _react.jsx)("video", {
            controls: true
        }, (0, _react.jsx)("source", {
            src: this.state.videoUrl,
            type: "video/mp4"
        }), "Your browser does not support videos.") : null);
    }
}
exports.default = AlexaVideoPreview;

},{"@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","../ScreenPreviewComponent":"lBlZx","./AlexaRectangleWrapper":"3hWhN","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"bK9L3":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _screenPreviewComponent = require("../ScreenPreviewComponent");
var _screenPreviewComponentDefault = parcelHelpers.interopDefault(_screenPreviewComponent);
var _alexaSmallWrapper = require("./AlexaSmallWrapper");
var _alexaSmallWrapperDefault = parcelHelpers.interopDefault(_alexaSmallWrapper);
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const screenStyle = /*#__PURE__*/ (0, _css.css)({
    name: "tosu4r",
    styles: "align-items:center;justify-content:center"
});
class AlexaSmallAudioPlayerPreview extends (0, _screenPreviewComponentDefault.default) {
    render() {
        return (0, _react.jsx)((0, _alexaSmallWrapperDefault.default), {
            className: screenStyle
        }, this.state.foregroundImageUrl ? (0, _react.jsx)("img", {
            className: "background-image",
            src: this.state.foregroundImageUrl
        }) : null, this.state.foregroundImageUrl ? (0, _react.jsx)("div", {
            className: "background-cover"
        }) : null, (0, _react.jsx)("div", {
            className: "body-container"
        }, (0, _react.jsx)("p", {
            className: "body-text"
        }, (0, _react.jsx)("span", null, this.state.displayTitle), (0, _react.jsx)("br", null), (0, _react.jsx)("span", null, this.state.displayText))));
    }
}
exports.default = AlexaSmallAudioPlayerPreview;

},{"@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","../ScreenPreviewComponent":"lBlZx","./AlexaSmallWrapper":"aUlRI","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"aUlRI":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "alexaBodyStyle", ()=>alexaBodyStyle);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _reactContainerDimensions = require("react-container-dimensions");
var _reactContainerDimensionsDefault = parcelHelpers.interopDefault(_reactContainerDimensions);
const alexaBackground = require("764c4ad2686f8b06");
const alexaBodyStyle = /*#__PURE__*/ (0, _css.css)("position:relative;width:100%;padding-top:100%;margin:16px 0;border-radius:50%;.screen-wrapper{position:absolute;top:0;left:0;padding:8px;background:black;border-radius:50%;width:100%;height:100%;}.screen{position:relative;left:50%;top:50%;transform:translate(-49%, -49%);transform-origin:center center;width:1080px;height:1080px;background:url('", alexaBackground, "');background-size:cover;background-repeat:no-repeat;background-position:center center;border-radius:50%;overflow:hidden;color:white;display:flex;flex-direction:column;.body-text,.title-text{font-family:'Roboto',sans-serif;font-size:80px;padding-top:80px;padding-left:20px;padding-right:20px;color:white;overflow-wrap:break-word;z-index:2;position:relative;text-align:center;}.body-text{overflow-y:hidden;flex:1;}.background-cover{width:1080px;height:1080px;position:absolute;z-index:1;background-color:black;opacity:.7;}.body-container{display:flex;z-index:2;position:relative;}.background-image{width:1080px;height:1080px;position:absolute;z-index:0;}.foreground-image{width:600px;z-index:2;height:auto;img{width:100%;height:auto;}}}", "");
const AlexaSmallWrapper = (props)=>(0, _react.jsx)("div", {
        className: alexaBodyStyle
    }, (0, _react.jsx)("div", {
        className: "screen-wrapper"
    }, (0, _react.jsx)((0, _reactContainerDimensionsDefault.default), null, ({ width, height })=>(0, _react.jsx)("div", {
            className: `screen ${props.className}`,
            style: {
                transform: `translate(-50%, -50%) scale(${Math.min(width / 1080, height / 1080)})`
            }
        }, props.children))));
exports.default = AlexaSmallWrapper;

},{"@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","react-container-dimensions":"lhO7N","764c4ad2686f8b06":"9S2Lw","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6ljQA":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _screenPreviewComponent = require("../ScreenPreviewComponent");
var _screenPreviewComponentDefault = parcelHelpers.interopDefault(_screenPreviewComponent);
var _alexaSmallWrapper = require("./AlexaSmallWrapper");
var _alexaSmallWrapperDefault = parcelHelpers.interopDefault(_alexaSmallWrapper);
var _css = require("@emotion/css");
var _dompurify = require("dompurify");
var _dompurifyDefault = parcelHelpers.interopDefault(_dompurify);
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const screenStyle = /*#__PURE__*/ (0, _css.css)({
    name: "1mlur3v",
    styles: "color:white;.body-container{margin:180px 120px 0 120px;}"
});
class AlexaSmallBody1TemplatePreview extends (0, _screenPreviewComponentDefault.default) {
    render() {
        return (0, _react.jsx)((0, _alexaSmallWrapperDefault.default), {
            className: screenStyle
        }, this.state.backgroundImageUrl ? (0, _react.jsx)("img", {
            className: "background-image",
            src: this.state.backgroundImageUrl
        }) : null, this.state.backgroundImageUrl ? (0, _react.jsx)("div", {
            className: "background-cover"
        }) : null, this.state.displayTitle ? (0, _react.jsx)("p", {
            className: "title-text"
        }, this.state.displayTitle) : null, (0, _react.jsx)("div", {
            className: "body-container"
        }, (0, _react.jsx)("p", {
            className: "body-text"
        }, (0, _react.jsx)("span", {
            dangerouslySetInnerHTML: {
                __html: (0, _dompurifyDefault.default).sanitize(this.state.displayText)
            }
        }), this.state.followUpText ? (0, _react.jsx)((0, _reactDefault.default).Fragment, null, (0, _react.jsx)("br", null), (0, _react.jsx)("br", null), (0, _react.jsx)("span", {
            className: "followup-text",
            dangerouslySetInnerHTML: {
                __html: (0, _dompurifyDefault.default).sanitize(this.state.followUpText)
            }
        })) : null)));
    }
}
exports.default = AlexaSmallBody1TemplatePreview;

},{"@emotion/react":"djZKr","react":"6uln9","../ScreenPreviewComponent":"lBlZx","./AlexaSmallWrapper":"aUlRI","@emotion/css":"awUBr","dompurify":"5cPaM","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"aeZZs":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _screenPreviewComponent = require("../ScreenPreviewComponent");
var _screenPreviewComponentDefault = parcelHelpers.interopDefault(_screenPreviewComponent);
var _alexaSmallWrapper = require("./AlexaSmallWrapper");
var _alexaSmallWrapperDefault = parcelHelpers.interopDefault(_alexaSmallWrapper);
var _css = require("@emotion/css");
var _dompurify = require("dompurify");
var _dompurifyDefault = parcelHelpers.interopDefault(_dompurify);
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const screenStyle = /*#__PURE__*/ (0, _css.css)({
    name: "1mlur3v",
    styles: "color:white;.body-container{margin:180px 120px 0 120px;}"
});
class AlexaSmallBody2TemplatePreview extends (0, _screenPreviewComponentDefault.default) {
    render() {
        return (0, _react.jsx)((0, _alexaSmallWrapperDefault.default), {
            className: screenStyle
        }, this.state.foregroundImageUrl ? (0, _react.jsx)("img", {
            className: "background-image",
            src: this.state.foregroundImageUrl
        }) : null, this.state.foregroundImageUrl ? (0, _react.jsx)("div", {
            className: "background-cover"
        }) : null, this.state.displayTitle ? (0, _react.jsx)("p", {
            className: "title-text"
        }, this.state.displayTitle) : null, (0, _react.jsx)("div", {
            className: "body-container"
        }, (0, _react.jsx)("p", {
            className: "body-text"
        }, (0, _react.jsx)("span", {
            dangerouslySetInnerHTML: {
                __html: (0, _dompurifyDefault.default).sanitize(this.state.displayText)
            }
        }), this.state.followUpText ? (0, _react.jsx)((0, _reactDefault.default).Fragment, null, (0, _react.jsx)("br", null), (0, _react.jsx)("br", null), (0, _react.jsx)("span", {
            className: "followup-text",
            dangerouslySetInnerHTML: {
                __html: (0, _dompurifyDefault.default).sanitize(this.state.followUpText)
            }
        })) : null)));
    }
}
exports.default = AlexaSmallBody2TemplatePreview;

},{"@emotion/react":"djZKr","react":"6uln9","../ScreenPreviewComponent":"lBlZx","./AlexaSmallWrapper":"aUlRI","@emotion/css":"awUBr","dompurify":"5cPaM","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"UrwhQ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _screenPreviewComponent = require("../ScreenPreviewComponent");
var _screenPreviewComponentDefault = parcelHelpers.interopDefault(_screenPreviewComponent);
var _alexaSmallWrapper = require("./AlexaSmallWrapper");
var _alexaSmallWrapperDefault = parcelHelpers.interopDefault(_alexaSmallWrapper);
var _dompurify = require("dompurify");
var _dompurifyDefault = parcelHelpers.interopDefault(_dompurify);
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const screenStyle = /*#__PURE__*/ (0, _css.css)({
    name: "1mlur3v",
    styles: "color:white;.body-container{margin:180px 120px 0 120px;}"
});
class AlexaSmallBody3TemplatePreview extends (0, _screenPreviewComponentDefault.default) {
    render() {
        return (0, _react.jsx)((0, _alexaSmallWrapperDefault.default), {
            className: screenStyle
        }, this.state.foregroundImageUrl ? (0, _react.jsx)("img", {
            className: "background-image",
            src: this.state.foregroundImageUrl
        }) : null, this.state.foregroundImageUrl ? (0, _react.jsx)("div", {
            className: "background-cover"
        }) : null, this.state.displayTitle ? (0, _react.jsx)("p", {
            className: "title-text"
        }, this.state.displayTitle) : null, (0, _react.jsx)("div", {
            className: "body-container"
        }, (0, _react.jsx)("p", {
            className: "body-text"
        }, (0, _react.jsx)("span", {
            dangerouslySetInnerHTML: {
                __html: (0, _dompurifyDefault.default).sanitize(this.state.displayText)
            }
        }), this.state.followUpText ? (0, _react.jsx)((0, _reactDefault.default).Fragment, null, (0, _react.jsx)("br", null), (0, _react.jsx)("br", null), (0, _react.jsx)("span", {
            className: "followup-text",
            dangerouslySetInnerHTML: {
                __html: (0, _dompurifyDefault.default).sanitize(this.state.followUpText)
            }
        })) : null)));
    }
}
exports.default = AlexaSmallBody3TemplatePreview;

},{"@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","../ScreenPreviewComponent":"lBlZx","./AlexaSmallWrapper":"aUlRI","dompurify":"5cPaM","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"kBWXD":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _screenPreviewComponent = require("../ScreenPreviewComponent");
var _screenPreviewComponentDefault = parcelHelpers.interopDefault(_screenPreviewComponent);
var _alexaSmallWrapper = require("./AlexaSmallWrapper");
var _alexaSmallWrapperDefault = parcelHelpers.interopDefault(_alexaSmallWrapper);
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const screenStyle = /*#__PURE__*/ (0, _css.css)({
    name: "an59m5",
    styles: "color:white;.body-container{margin:auto 180px 180px 180px;}"
});
class AlexaSmallBody6TemplatePreview extends (0, _screenPreviewComponentDefault.default) {
    render() {
        return (0, _react.jsx)((0, _alexaSmallWrapperDefault.default), {
            className: screenStyle
        }, this.state.backgroundImageUrl ? (0, _react.jsx)("img", {
            className: "background-image",
            src: this.state.backgroundImageUrl
        }) : null, (0, _react.jsx)("div", {
            className: "body-container"
        }, (0, _react.jsx)("p", {
            className: "body-text"
        }, (0, _react.jsx)("span", null, this.state.displayText))));
    }
}
exports.default = AlexaSmallBody6TemplatePreview;

},{"@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","../ScreenPreviewComponent":"lBlZx","./AlexaSmallWrapper":"aUlRI","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"dgC50":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _screenPreviewComponent = require("../ScreenPreviewComponent");
var _screenPreviewComponentDefault = parcelHelpers.interopDefault(_screenPreviewComponent);
var _alexaSmallWrapper = require("./AlexaSmallWrapper");
var _alexaSmallWrapperDefault = parcelHelpers.interopDefault(_alexaSmallWrapper);
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const screenStyle = /*#__PURE__*/ (0, _css.css)({
    name: "1h3rtzg",
    styles: "align-items:center"
});
class AlexaSmallBody7TemplatePreview extends (0, _screenPreviewComponentDefault.default) {
    render() {
        return (0, _react.jsx)((0, _alexaSmallWrapperDefault.default), {
            className: screenStyle
        }, this.state.backgroundImageUrl ? (0, _react.jsx)("img", {
            className: "background-image",
            src: this.state.backgroundImageUrl
        }) : null, this.state.displayTitle ? (0, _react.jsx)("p", {
            className: "title-text"
        }, this.state.displayTitle) : null, (0, _react.jsx)("div", {
            className: "body-container"
        }, this.state.foregroundImageUrl ? (0, _react.jsx)("div", {
            className: "foreground-image"
        }, (0, _react.jsx)("img", {
            src: this.state.foregroundImageUrl
        })) : null));
    }
}
exports.default = AlexaSmallBody7TemplatePreview;

},{"@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","../ScreenPreviewComponent":"lBlZx","./AlexaSmallWrapper":"aUlRI","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"fwgTS":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _screenPreviewComponent = require("../ScreenPreviewComponent");
var _screenPreviewComponentDefault = parcelHelpers.interopDefault(_screenPreviewComponent);
var _alexaSmallWrapper = require("./AlexaSmallWrapper");
var _alexaSmallWrapperDefault = parcelHelpers.interopDefault(_alexaSmallWrapper);
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const screenStyle = /*#__PURE__*/ (0, _css.css)({
    name: "n5ofkf",
    styles: ".body-container{margin:auto 180px 180px 180px;}"
});
class AlexaSmallListTemplate2Preview extends (0, _screenPreviewComponentDefault.default) {
    render() {
        return (0, _react.jsx)((0, _alexaSmallWrapperDefault.default), {
            className: screenStyle
        }, this.state.foregroundImageUrl ? (0, _react.jsx)("img", {
            className: "background-image",
            src: this.state.foregroundImageUrl
        }) : null, this.state.foregroundImageUrl ? (0, _react.jsx)("div", {
            className: "background-cover"
        }) : null, (0, _react.jsx)("div", {
            className: "body-container"
        }, (0, _react.jsx)("p", {
            className: "body-text"
        }, (0, _react.jsx)("span", null, this.state.displayText))));
    }
}
exports.default = AlexaSmallListTemplate2Preview;

},{"@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","../ScreenPreviewComponent":"lBlZx","./AlexaSmallWrapper":"aUlRI","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4BY4D":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _screenPreviewComponent = require("../ScreenPreviewComponent");
var _screenPreviewComponentDefault = parcelHelpers.interopDefault(_screenPreviewComponent);
var _alexaSmallWrapper = require("./AlexaSmallWrapper");
var _alexaSmallWrapperDefault = parcelHelpers.interopDefault(_alexaSmallWrapper);
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const screenStyle = /*#__PURE__*/ (0, _css.css)({
    name: "1ujxsfa",
    styles: "align-items:center;justify-content:center;video{width:1080px;}"
});
class AlexaSmallVideoPreview extends (0, _screenPreviewComponentDefault.default) {
    render() {
        return (0, _react.jsx)((0, _alexaSmallWrapperDefault.default), {
            className: screenStyle
        }, this.state.videoUrl ? (0, _react.jsx)("video", {
            controls: true
        }, (0, _react.jsx)("source", {
            src: this.state.videoUrl,
            type: "video/mp4"
        }), "Your browser does not support videos.") : null);
    }
}
exports.default = AlexaSmallVideoPreview;

},{"@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","../ScreenPreviewComponent":"lBlZx","./AlexaSmallWrapper":"aUlRI","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"eEDKA":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _screenPreviewComponent = require("../ScreenPreviewComponent");
var _screenPreviewComponentDefault = parcelHelpers.interopDefault(_screenPreviewComponent);
var _alexaShortRectangleWrapper = require("./AlexaShortRectangleWrapper");
var _alexaShortRectangleWrapperDefault = parcelHelpers.interopDefault(_alexaShortRectangleWrapper);
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const screenStyle = /*#__PURE__*/ (0, _css.css)({
    name: "1p8qia8",
    styles: "color:white;.body-text,.title-text{font-family:'Roboto',sans-serif;font-size:80px;padding-top:80px;padding-left:160px;color:white;overflow-wrap:break-word;z-index:2;position:relative;}.body-text{overflow-y:hidden;flex:1;}.body-container{display:flex;z-index:2;align-items:center;height:90%;}.hint-text{font-family:'Noto Serif',serif;font-size:60px;color:white;font-style:italic;z-index:2;padding-left:160px;position:relative;}.foreground-image{width:400px;height:400px;z-index:2;height:auto;padding-right:160px;img{width:100%;height:auto;}}.background-image{width:1920px;height:960px;position:absolute;z-index:1;}"
});
class AlexaShortAudioPlayerPreview extends (0, _screenPreviewComponentDefault.default) {
    getHintText() {
        if (this.state.hints && this.state.hints.length > 0) {
            const hint = this.state.hints[0];
            return `Try "Alexa, ${hint.content}"`;
        }
        return "";
    }
    render() {
        return (0, _react.jsx)((0, _alexaShortRectangleWrapperDefault.default), {
            className: screenStyle
        }, this.state.backgroundImageUrl ? (0, _react.jsx)("img", {
            className: "background-image",
            src: this.state.backgroundImageUrl
        }) : null, (0, _react.jsx)("div", {
            className: "body-container"
        }, (0, _react.jsx)("p", {
            className: "body-text"
        }, (0, _react.jsx)("span", null, this.state.displayTitle), (0, _react.jsx)("br", null), (0, _react.jsx)("span", null, this.state.displayText)), this.state.foregroundImageUrl ? (0, _react.jsx)("div", {
            className: "foreground-image"
        }, (0, _react.jsx)("img", {
            src: this.state.foregroundImageUrl
        })) : null), this.state.hints ? (0, _react.jsx)("p", {
            className: "hint-text"
        }, this.getHintText()) : null);
    }
}
exports.default = AlexaShortAudioPlayerPreview;

},{"@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","../ScreenPreviewComponent":"lBlZx","./AlexaShortRectangleWrapper":"dDgJO","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"dDgJO":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "alexaBodyStyle", ()=>alexaBodyStyle);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _reactContainerDimensions = require("react-container-dimensions");
var _reactContainerDimensionsDefault = parcelHelpers.interopDefault(_reactContainerDimensions);
const alexaBackground = require("a950db4a0ad923aa");
const alexaBodyStyle = /*#__PURE__*/ (0, _css.css)("position:relative;width:100%;padding-top:50%;margin:16px 0;.screen-wrapper{position:absolute;top:0;left:0;padding:8px;background:black;border-radius:5px;width:calc(100% - 16px);height:100%;}.screen{position:relative;left:50%;top:50%;transform:translate(-49%, -49%);transform-origin:center center;width:1920px;height:960px;background:url('", alexaBackground, "');background-size:cover;background-repeat:no-repeat;background-position:center center;display:flex;flex-direction:column;.hint-container{margin-bottom:0;margin-top:bottom;}}", "");
const AlexaShortRectangleWrapper = (props)=>(0, _react.jsx)("div", {
        className: alexaBodyStyle
    }, (0, _react.jsx)("div", {
        className: "screen-wrapper"
    }, (0, _react.jsx)((0, _reactContainerDimensionsDefault.default), null, ({ width, height })=>(0, _react.jsx)("div", {
            className: `screen ${props.className}`,
            style: {
                transform: `translate(-50%, -50%) scale(${Math.min(width / 1920, height / 960)})`
            }
        }, props.children))));
exports.default = AlexaShortRectangleWrapper;

},{"@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","react-container-dimensions":"lhO7N","a950db4a0ad923aa":"9S2Lw","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jUmib":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _screenPreviewComponent = require("../ScreenPreviewComponent");
var _screenPreviewComponentDefault = parcelHelpers.interopDefault(_screenPreviewComponent);
var _alexaShortRectangleWrapper = require("./AlexaShortRectangleWrapper");
var _alexaShortRectangleWrapperDefault = parcelHelpers.interopDefault(_alexaShortRectangleWrapper);
var _dompurify = require("dompurify");
var _dompurifyDefault = parcelHelpers.interopDefault(_dompurify);
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const screenStyle = /*#__PURE__*/ (0, _css.css)({
    name: "186yziz",
    styles: "color:white;.body-text,.title-text{font-family:'Roboto',sans-serif;font-size:80px;padding-top:80px;padding-left:160px;padding-right:160px;color:white;overflow-wrap:break-word;z-index:2;position:relative;}.body-text{overflow-y:hidden;height:860px;flex:1;}.body-container{display:flex;z-index:2;position:relative;}.hint-text{font-family:'Noto Serif',serif;font-size:60px;color:white;font-style:italic;z-index:2;padding-left:160px;position:relative;}.background-image{width:1920px;height:960px;position:absolute;z-index:1;}"
});
class AlexaShortBody1TemplatePreview extends (0, _screenPreviewComponentDefault.default) {
    getHintText() {
        if (this.state.hints && this.state.hints.length > 0) {
            const hint = this.state.hints[0];
            return `Try "Alexa, ${hint.content}"`;
        }
        return "";
    }
    render() {
        return (0, _react.jsx)((0, _alexaShortRectangleWrapperDefault.default), {
            className: screenStyle
        }, this.state.backgroundImageUrl ? (0, _react.jsx)("img", {
            className: "background-image",
            src: this.state.backgroundImageUrl
        }) : null, this.state.displayTitle ? (0, _react.jsx)("p", {
            className: "title-text"
        }, this.state.displayTitle) : null, (0, _react.jsx)("div", {
            className: "body-container"
        }, (0, _react.jsx)("p", {
            className: "body-text"
        }, (0, _react.jsx)("span", {
            dangerouslySetInnerHTML: {
                __html: (0, _dompurifyDefault.default).sanitize(this.state.displayText)
            }
        }), this.state.followUpText ? (0, _react.jsx)((0, _reactDefault.default).Fragment, null, (0, _react.jsx)("br", null), (0, _react.jsx)("br", null), (0, _react.jsx)("span", {
            className: "followup-text",
            dangerouslySetInnerHTML: {
                __html: (0, _dompurifyDefault.default).sanitize(this.state.followUpText)
            }
        })) : null)), this.state.hints ? (0, _react.jsx)("p", {
            className: "hint-text"
        }, this.getHintText()) : null);
    }
}
exports.default = AlexaShortBody1TemplatePreview;

},{"@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","../ScreenPreviewComponent":"lBlZx","./AlexaShortRectangleWrapper":"dDgJO","dompurify":"5cPaM","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"gHgQY":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _screenPreviewComponent = require("../ScreenPreviewComponent");
var _screenPreviewComponentDefault = parcelHelpers.interopDefault(_screenPreviewComponent);
var _alexaShortRectangleWrapper = require("./AlexaShortRectangleWrapper");
var _alexaShortRectangleWrapperDefault = parcelHelpers.interopDefault(_alexaShortRectangleWrapper);
var _dompurify = require("dompurify");
var _dompurifyDefault = parcelHelpers.interopDefault(_dompurify);
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const screenStyle = /*#__PURE__*/ (0, _css.css)({
    name: "f4erh4",
    styles: "color:white;overflow:hidden;.body-text,.title-text{font-family:'Roboto',sans-serif;font-size:80px;padding-top:80px;padding-left:160px;color:white;overflow-wrap:break-word;z-index:2;position:relative;}.body-text{overflow-y:hidden;height:860px;flex:1;}.body-container{display:flex;align-items:start;z-index:2;position:relative;}.hint-text{font-family:'Noto Serif',serif;font-size:60px;color:white;font-style:italic;z-index:2;padding-left:160px;position:relative;}.foreground-image{width:600px;z-index:2;height:auto;padding-right:160px;margin-top:80px;img{width:100%;height:auto;}}.background-image{width:1920px;height:960px;position:absolute;z-index:1;}"
});
class AlexaShortBody2TemplatePreview extends (0, _screenPreviewComponentDefault.default) {
    getHintText() {
        if (this.state.hints && this.state.hints.length > 0) {
            const hint = this.state.hints[0];
            return `Try "Alexa, ${hint.content}"`;
        }
        return "";
    }
    render() {
        return (0, _react.jsx)((0, _alexaShortRectangleWrapperDefault.default), {
            className: screenStyle
        }, this.state.backgroundImageUrl ? (0, _react.jsx)("img", {
            className: "background-image",
            src: this.state.backgroundImageUrl
        }) : null, this.state.displayTitle ? (0, _react.jsx)("p", {
            className: "title-text"
        }, this.state.displayTitle) : null, (0, _react.jsx)("div", {
            className: "body-container"
        }, (0, _react.jsx)("p", {
            className: "body-text"
        }, (0, _react.jsx)("span", {
            dangerouslySetInnerHTML: {
                __html: (0, _dompurifyDefault.default).sanitize(this.state.displayText)
            }
        }), this.state.followUpText ? (0, _react.jsx)((0, _reactDefault.default).Fragment, null, (0, _react.jsx)("br", null), (0, _react.jsx)("br", null), (0, _react.jsx)("span", {
            className: "followup-text",
            dangerouslySetInnerHTML: {
                __html: (0, _dompurifyDefault.default).sanitize(this.state.followUpText)
            }
        })) : null), this.state.foregroundImageUrl ? (0, _react.jsx)("div", {
            className: "foreground-image"
        }, (0, _react.jsx)("img", {
            src: this.state.foregroundImageUrl
        })) : null), this.state.hints ? (0, _react.jsx)("p", {
            className: "hint-text"
        }, this.getHintText()) : null);
    }
}
exports.default = AlexaShortBody2TemplatePreview;

},{"@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","../ScreenPreviewComponent":"lBlZx","./AlexaShortRectangleWrapper":"dDgJO","dompurify":"5cPaM","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"Mondn":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _screenPreviewComponent = require("../ScreenPreviewComponent");
var _screenPreviewComponentDefault = parcelHelpers.interopDefault(_screenPreviewComponent);
var _alexaShortRectangleWrapper = require("./AlexaShortRectangleWrapper");
var _alexaShortRectangleWrapperDefault = parcelHelpers.interopDefault(_alexaShortRectangleWrapper);
var _dompurify = require("dompurify");
var _dompurifyDefault = parcelHelpers.interopDefault(_dompurify);
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const screenStyle = /*#__PURE__*/ (0, _css.css)({
    name: "drbx8",
    styles: "color:white;.body-text,.title-text{font-family:'Roboto',sans-serif;font-size:80px;padding-top:80px;padding-left:80px;padding-right:160px;color:white;overflow-wrap:break-word;z-index:2;position:relative;}.body-text{overflow-y:hidden;height:860px;flex:1;}.body-container{display:flex;z-index:2;position:relative;align-items:start;}.hint-text{font-family:'Noto Serif',serif;font-size:60px;color:white;font-style:italic;z-index:2;padding-left:160px;position:relative;}.foreground-image{width:600px;z-index:2;height:auto;padding-left:160px;padding-right:80px;margin-top:80px;img{width:100%;height:auto;}}.background-image{width:1920px;height:960px;position:absolute;z-index:1;}"
});
class AlexaShortBody3TemplatePreview extends (0, _screenPreviewComponentDefault.default) {
    getHintText() {
        if (this.state.hints && this.state.hints.length > 0) {
            const hint = this.state.hints[0];
            return `Try "Alexa, ${hint.content}"`;
        }
        return "";
    }
    render() {
        return (0, _react.jsx)((0, _alexaShortRectangleWrapperDefault.default), {
            className: screenStyle
        }, this.state.backgroundImageUrl ? (0, _react.jsx)("img", {
            className: "background-image",
            src: this.state.backgroundImageUrl
        }) : null, this.state.displayTitle ? (0, _react.jsx)("p", {
            className: "title-text"
        }, this.state.displayTitle) : null, (0, _react.jsx)("div", {
            className: "body-container"
        }, this.state.foregroundImageUrl ? (0, _react.jsx)("div", {
            className: "foreground-image"
        }, (0, _react.jsx)("img", {
            src: this.state.foregroundImageUrl
        })) : null, (0, _react.jsx)("p", {
            className: "body-text"
        }, (0, _react.jsx)("span", {
            dangerouslySetInnerHTML: {
                __html: (0, _dompurifyDefault.default).sanitize(this.state.displayText)
            }
        }), this.state.followUpText ? (0, _react.jsx)((0, _reactDefault.default).Fragment, null, (0, _react.jsx)("br", null), (0, _react.jsx)("br", null), (0, _react.jsx)("span", {
            className: "followup-text",
            dangerouslySetInnerHTML: {
                __html: (0, _dompurifyDefault.default).sanitize(this.state.followUpText)
            }
        })) : null)), this.state.hints ? (0, _react.jsx)("p", {
            className: "hint-text"
        }, this.getHintText()) : null);
    }
}
exports.default = AlexaShortBody3TemplatePreview;

},{"@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","../ScreenPreviewComponent":"lBlZx","./AlexaShortRectangleWrapper":"dDgJO","dompurify":"5cPaM","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"lUgsT":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _screenPreviewComponent = require("../ScreenPreviewComponent");
var _screenPreviewComponentDefault = parcelHelpers.interopDefault(_screenPreviewComponent);
var _alexaShortRectangleWrapper = require("./AlexaShortRectangleWrapper");
var _alexaShortRectangleWrapperDefault = parcelHelpers.interopDefault(_alexaShortRectangleWrapper);
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const screenStyle = /*#__PURE__*/ (0, _css.css)({
    name: "1xxrjx4",
    styles: "color:white;.body-text{font-family:'Roboto',sans-serif;font-size:100px;padding-left:160px;color:white;overflow-wrap:break-word;overflow-y:hidden;height:100px;padding-top:800px;flex:1;margin-bottom:0;margin-top:auto;z-index:2;position:relative;}.body-container{display:flex;z-index:2;position:relative;}.hint-text{font-family:'Noto Serif',serif;font-size:60px;color:white;font-style:italic;z-index:2;padding-left:160px;position:relative;}.foreground-image{width:600px;z-index:2;height:auto;padding-right:160px;img{width:100%;height:auto;}}.background-image{width:1920px;height:960px;position:absolute;top:0;left:0;bottom:0;z-index:1;}"
});
class AlexaShortBody6TemplatePreview extends (0, _screenPreviewComponentDefault.default) {
    getHintText() {
        if (this.state.hints && this.state.hints.length > 0) {
            const hint = this.state.hints[0];
            return `Try "Alexa, ${hint.content}"`;
        }
        return "";
    }
    render() {
        return (0, _react.jsx)((0, _alexaShortRectangleWrapperDefault.default), {
            className: screenStyle
        }, this.state.backgroundImageUrl ? (0, _react.jsx)("img", {
            className: "background-image",
            src: this.state.backgroundImageUrl
        }) : null, (0, _react.jsx)("div", {
            className: "body-container"
        }, (0, _react.jsx)("p", {
            className: "body-text"
        }, (0, _react.jsx)("span", null, this.state.displayText))), this.state.hints ? (0, _react.jsx)("p", {
            className: "hint-text"
        }, this.getHintText()) : null);
    }
}
exports.default = AlexaShortBody6TemplatePreview;

},{"@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","../ScreenPreviewComponent":"lBlZx","./AlexaShortRectangleWrapper":"dDgJO","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4B6WV":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _screenPreviewComponent = require("../ScreenPreviewComponent");
var _screenPreviewComponentDefault = parcelHelpers.interopDefault(_screenPreviewComponent);
var _alexaShortRectangleWrapper = require("./AlexaShortRectangleWrapper");
var _alexaShortRectangleWrapperDefault = parcelHelpers.interopDefault(_alexaShortRectangleWrapper);
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const screenStyle = /*#__PURE__*/ (0, _css.css)({
    name: "bquo5a",
    styles: "color:white;.title-text{font-family:'Roboto',sans-serif;font-size:80px;padding-top:80px;padding-left:80px;padding-right:160px;color:white;overflow-wrap:break-word;z-index:2;position:relative;}.body-container{display:flex;z-index:2;align-items:center;justify-content:center;position:relative;}.hint-text{font-family:'Noto Serif',serif;font-size:60px;color:white;font-style:italic;z-index:2;padding-left:160px;position:relative;}.foreground-image{z-index:2;height:800px;width:auto;padding-left:80px;padding-right:80px;img{width:auto;height:100%;}}.background-image{width:1920px;height:960px;position:absolute;z-index:1;}"
});
class AlexaShortBody7TemplatePreview extends (0, _screenPreviewComponentDefault.default) {
    getHintText() {
        if (this.state.hints && this.state.hints.length > 0) {
            const hint = this.state.hints[0];
            return `Try "Alexa, ${hint.content}"`;
        }
        return "";
    }
    render() {
        return (0, _react.jsx)((0, _alexaShortRectangleWrapperDefault.default), {
            className: screenStyle
        }, this.state.backgroundImageUrl ? (0, _react.jsx)("img", {
            className: "background-image",
            src: this.state.backgroundImageUrl
        }) : null, this.state.displayTitle ? (0, _react.jsx)("p", {
            className: "title-text"
        }, this.state.displayTitle) : null, (0, _react.jsx)("div", {
            className: "body-container"
        }, this.state.foregroundImageUrl ? (0, _react.jsx)("div", {
            className: "foreground-image"
        }, (0, _react.jsx)("img", {
            src: this.state.foregroundImageUrl
        })) : null), this.state.hints ? (0, _react.jsx)("p", {
            className: "hint-text"
        }, this.getHintText()) : null);
    }
}
exports.default = AlexaShortBody7TemplatePreview;

},{"@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","../ScreenPreviewComponent":"lBlZx","./AlexaShortRectangleWrapper":"dDgJO","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"g1oP9":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _screenPreviewComponent = require("../ScreenPreviewComponent");
var _screenPreviewComponentDefault = parcelHelpers.interopDefault(_screenPreviewComponent);
var _alexaShortRectangleWrapper = require("./AlexaShortRectangleWrapper");
var _alexaShortRectangleWrapperDefault = parcelHelpers.interopDefault(_alexaShortRectangleWrapper);
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const screenStyle = /*#__PURE__*/ (0, _css.css)({
    name: "1se2utr",
    styles: "color:white;.body-text,.title-text{font-family:'Roboto',sans-serif;font-size:80px;padding-top:80px;padding-left:160px;color:white;overflow-wrap:break-word;z-index:2;position:relative;}.body-text{overflow-y:hidden;text-align:center;font-size:40px;margin-top:30px;padding:0;}.body-container{display:flex;z-index:2;position:relative;align-items:baseline;margin-top:150px;justify-content:center;}.hint-text{font-family:'Noto Serif',serif;font-size:60px;color:white;font-style:italic;z-index:2;padding-left:160px;position:relative;margin-bottom:20px;margin-top:auto;}.foreground-image{width:400px;height:400px;z-index:2;img{height:100%;width:auto;}&.empty{background:#CCCCCC;}}.list-item{display:flex;flex-direction:column;align-items:center;margin-right:160px;max-width:440px;}.background-image{width:1920px;height:960px;position:absolute;z-index:1;}"
});
class AlexaShortListTemplate2Preview extends (0, _screenPreviewComponentDefault.default) {
    getHintText() {
        if (this.state.hints && this.state.hints.length > 0) {
            const hint = this.state.hints[0];
            return `Try "Alexa, ${hint.content}"`;
        }
        return "";
    }
    renderAdditionalItems() {
        const items = [];
        for(var i = 0; i < this.props.response.additionalListItems; i++)items.push(i);
        return items.map((_, i)=>(0, _react.jsx)("div", {
                key: i,
                className: "list-item"
            }, (0, _react.jsx)("div", {
                className: "foreground-image empty"
            }), (0, _react.jsx)("p", {
                className: "body-text"
            }, (0, _react.jsx)("span", null, i + 2, ". Additional Item"))));
    }
    render() {
        return (0, _react.jsx)((0, _alexaShortRectangleWrapperDefault.default), {
            className: screenStyle
        }, this.state.backgroundImageUrl ? (0, _react.jsx)("img", {
            className: "background-image",
            src: this.state.backgroundImageUrl
        }) : null, this.state.displayTitle ? (0, _react.jsx)("p", {
            className: "title-text"
        }, this.state.displayTitle) : null, (0, _react.jsx)("div", {
            className: "body-container"
        }, (0, _react.jsx)("div", {
            className: "list-item"
        }, this.state.foregroundImageUrl ? (0, _react.jsx)("div", {
            className: "foreground-image"
        }, (0, _react.jsx)("img", {
            src: this.state.foregroundImageUrl
        })) : (0, _react.jsx)("div", {
            className: "foreground-image empty"
        }), (0, _react.jsx)("p", {
            className: "body-text"
        }, (0, _react.jsx)("span", null, "1. ", this.state.displayText))), this.props.response.additionalListItems ? this.renderAdditionalItems() : null), this.state.hints ? (0, _react.jsx)("p", {
            className: "hint-text"
        }, this.getHintText()) : null);
    }
}
exports.default = AlexaShortListTemplate2Preview;

},{"@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","../ScreenPreviewComponent":"lBlZx","./AlexaShortRectangleWrapper":"dDgJO","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hnd8Y":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _screenPreviewComponent = require("../ScreenPreviewComponent");
var _screenPreviewComponentDefault = parcelHelpers.interopDefault(_screenPreviewComponent);
var _alexaShortRectangleWrapper = require("./AlexaShortRectangleWrapper");
var _alexaShortRectangleWrapperDefault = parcelHelpers.interopDefault(_alexaShortRectangleWrapper);
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const screenStyle = /*#__PURE__*/ (0, _css.css)({
    name: "1mqpmwz",
    styles: "video{width:1920px;height:960px;}"
});
class AlexaShortVideoPreview extends (0, _screenPreviewComponentDefault.default) {
    render() {
        return (0, _react.jsx)((0, _alexaShortRectangleWrapperDefault.default), {
            className: screenStyle
        }, this.state.videoUrl ? (0, _react.jsx)("video", {
            controls: true
        }, (0, _react.jsx)("source", {
            src: this.state.videoUrl,
            type: "video/mp4"
        }), "Your browser does not support videos.") : null);
    }
}
exports.default = AlexaShortVideoPreview;

},{"@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","../ScreenPreviewComponent":"lBlZx","./AlexaShortRectangleWrapper":"dDgJO","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"lkhq8":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _screenPreviewComponent = require("../ScreenPreviewComponent");
var _screenPreviewComponentDefault = parcelHelpers.interopDefault(_screenPreviewComponent);
var _cortanaScreenWrapper = require("./CortanaScreenWrapper");
var _cortanaScreenWrapperDefault = parcelHelpers.interopDefault(_cortanaScreenWrapper);
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const screenStyle = /*#__PURE__*/ (0, _css.css)({
    name: "sug51y",
    styles: ".list-container{display:flex;flex-direction:row;overflow-x:auto;}"
});
class CortanaScreenListPreview extends (0, _screenPreviewComponentDefault.default) {
    renderAdditionalItems() {
        const items = [];
        for(var i = 0; i < this.props.response.additionalListItems; i++)items.push(i);
        return items.map((_, i)=>(0, _react.jsx)("div", {
                key: i,
                className: "card"
            }, (0, _react.jsx)("div", {
                className: "foreground-image empty"
            }), (0, _react.jsx)("p", {
                className: "body-text"
            }, (0, _react.jsx)("span", null, i + 2, ". Additional Item"))));
    }
    render() {
        return (0, _react.jsx)((0, _cortanaScreenWrapperDefault.default), {
            className: screenStyle
        }, (0, _react.jsx)("div", {
            className: "body-container"
        }, this.state.displayTitle ? (0, _react.jsx)("p", {
            className: "title-text"
        }, this.state.displayTitle) : null, (0, _react.jsx)("div", {
            className: "list-container"
        }, (0, _react.jsx)("div", {
            className: "card"
        }, this.state.foregroundImageUrl ? (0, _react.jsx)("div", {
            className: "foreground-image"
        }, (0, _react.jsx)("img", {
            src: this.state.foregroundImageUrl
        })) : (0, _react.jsx)("div", {
            className: "foreground-image empty"
        }), (0, _react.jsx)("p", {
            className: "body-text"
        }, (0, _react.jsx)("span", null, "1. ", this.state.displayText))), this.props.response.additionalListItems ? this.renderAdditionalItems() : null)));
    }
}
exports.default = CortanaScreenListPreview;

},{"@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","../ScreenPreviewComponent":"lBlZx","./CortanaScreenWrapper":"czxdk","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"czxdk":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "cortanaBodyStyle", ()=>cortanaBodyStyle);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _reactContainerDimensions = require("react-container-dimensions");
var _reactContainerDimensionsDefault = parcelHelpers.interopDefault(_reactContainerDimensions);
var _colors = require("../../../constants/colors");
const cortanaBodyStyle = /*#__PURE__*/ (0, _css.css)("position:relative;width:100%;padding-top:133.33%;margin:16px 0;.screen-wrapper{position:absolute;top:0;left:0;padding:8px;background:gray;width:calc(100% - 16px);height:100%;}.screen{position:relative;left:50%;top:50%;transform:translate(-49%, -49%);transform-origin:center center;height:1440px;width:1080px;background:#111111;display:flex;flex-direction:column;.media-container{display:flex;flex-direction:column;align-items:center;justify-content:center;margin-top:42px;.scrub-bar{width:900px;margin:20px 160px;height:8px;background:", (0, _colors.silver_two), ";}.scrub-handle{width:32px;height:32px;border:solid 8px ", (0, _colors.silver_two), ";margin-top:-48px;margin-left:90px;background:white;margin-right:auto;border-radius:50%;}.time-container{display:flex;flex:1;font-size:60px;width:900px;font-weight:bold;.end{margin-left:auto;margin-right:0;}}.play-icon{height:80px;width:80px;filter:invert(1);}}.card{margin:40px;padding:32px;background:#252525;border:5px solid #aaaaaa;.body-text,.title-text{padding-top:12px;padding-left:12px;}}.body-text,.title-text{font-family:'Roboto',sans-serif;padding-top:80px;padding-left:80px;color:#FFFFFF;overflow-wrap:break-word;z-index:2;position:relative;}.detail-text{color:", (0, _colors.cool_grey), ";font-family:'Roboto',sans-serif;overflow-wrap:break-word;z-index:2;position:relative;padding-left:80px;font-size:42px;}.title-text{font-size:80px;}.foreground-image{z-index:2;height:auto;display:flex;width:900px;height:506px;justify-content:center;align-items:center;img{height:100%;width:auto;}}.body-text{overflow-y:hidden;flex:1;font-size:42px;}.body-container{z-index:2;position:relative;}}", "");
const CortanaScreenScreenWrapper = (props)=>(0, _react.jsx)("div", {
        className: cortanaBodyStyle
    }, (0, _react.jsx)("div", {
        className: "screen-wrapper"
    }, (0, _react.jsx)((0, _reactContainerDimensionsDefault.default), null, ({ width, height })=>(0, _react.jsx)("div", {
            className: `screen ${props.className}`,
            style: {
                transform: `translate(-50%, -50%) scale(${Math.min(width / 1080, height / 1440)})`
            }
        }, props.children))));
exports.default = CortanaScreenScreenWrapper;

},{"@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","react-container-dimensions":"lhO7N","../../../constants/colors":"1p3OR","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2kFWI":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _screenPreviewComponent = require("../ScreenPreviewComponent");
var _screenPreviewComponentDefault = parcelHelpers.interopDefault(_screenPreviewComponent);
var _cortanaScreenWrapper = require("./CortanaScreenWrapper");
var _cortanaScreenWrapperDefault = parcelHelpers.interopDefault(_cortanaScreenWrapper);
const playIcon = require("17ea4896371f7536");
class CortanaScreenMediaResponsePreview extends (0, _screenPreviewComponentDefault.default) {
    render() {
        return (0, _react.jsx)((0, _cortanaScreenWrapperDefault.default), {
            className: ""
        }, (0, _react.jsx)("div", {
            className: "body-container"
        }, (0, _react.jsx)("div", {
            className: "card"
        }, (0, _react.jsx)("p", {
            className: "body-text"
        }, (0, _react.jsx)("span", null, this.state.displayText), this.state.followUpText ? (0, _react.jsx)((0, _reactDefault.default).Fragment, null, (0, _react.jsx)("br", null), (0, _react.jsx)("br", null), (0, _react.jsx)("span", {
            className: "followup-text"
        }, this.state.followUpText)) : null), this.state.displayTitle ? (0, _react.jsx)("p", {
            className: "title-text"
        }, this.state.displayTitle) : null, (0, _react.jsx)("p", {
            className: "detail-text"
        }, (0, _react.jsx)("span", null, this.state.displayText)), this.state.foregroundImageUrl ? (0, _react.jsx)("div", {
            className: "foreground-image"
        }, (0, _react.jsx)("img", {
            src: this.state.foregroundImageUrl
        })) : null, (0, _react.jsx)("div", {
            className: "media-container"
        }, (0, _react.jsx)("div", {
            className: "scrub-bar"
        }), (0, _react.jsx)("div", {
            className: "scrub-handle"
        }), (0, _react.jsx)("div", {
            className: "time-container"
        }, (0, _react.jsx)("p", null, "--.--"), (0, _react.jsx)("p", {
            className: "end"
        }, "--.--")), (0, _react.jsx)("img", {
            className: "play-icon",
            src: playIcon
        })))));
    }
}
exports.default = CortanaScreenMediaResponsePreview;

},{"@emotion/react":"djZKr","react":"6uln9","../ScreenPreviewComponent":"lBlZx","./CortanaScreenWrapper":"czxdk","17ea4896371f7536":"jWPMt","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jWPMt":[function(require,module,exports) {
module.exports = require("afe6c5d65b937797").getBundleURL("kVLro") + require("2543e00628609413").resolve("c7wNV");

},{"afe6c5d65b937797":"c7Tr5","2543e00628609413":"fyJL2"}],"gXVlX":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _screenPreviewComponent = require("../ScreenPreviewComponent");
var _screenPreviewComponentDefault = parcelHelpers.interopDefault(_screenPreviewComponent);
var _cortanaScreenWrapper = require("./CortanaScreenWrapper");
var _cortanaScreenWrapperDefault = parcelHelpers.interopDefault(_cortanaScreenWrapper);
var _dompurify = require("dompurify");
var _dompurifyDefault = parcelHelpers.interopDefault(_dompurify);
class CortanaScreenSimpleCardPreview extends (0, _screenPreviewComponentDefault.default) {
    render() {
        return (0, _react.jsx)((0, _cortanaScreenWrapperDefault.default), {
            className: ""
        }, (0, _react.jsx)("div", {
            className: "body-container"
        }, this.state.displayTitle ? (0, _react.jsx)("p", {
            className: "title-text"
        }, this.state.displayTitle) : null, (0, _react.jsx)("p", {
            className: "body-text"
        }, (0, _react.jsx)("span", {
            dangerouslySetInnerHTML: {
                __html: (0, _dompurifyDefault.default).sanitize(this.state.displayText)
            }
        }), this.state.followUpText ? (0, _react.jsx)((0, _reactDefault.default).Fragment, null, (0, _react.jsx)("br", null), (0, _react.jsx)("br", null), (0, _react.jsx)("span", {
            className: "followup-text",
            dangerouslySetInnerHTML: {
                __html: (0, _dompurifyDefault.default).sanitize(this.state.followUpText)
            }
        })) : null)));
    }
}
exports.default = CortanaScreenSimpleCardPreview;

},{"@emotion/react":"djZKr","react":"6uln9","../ScreenPreviewComponent":"lBlZx","./CortanaScreenWrapper":"czxdk","dompurify":"5cPaM","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1KEHx":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _screenPreviewComponent = require("../ScreenPreviewComponent");
var _screenPreviewComponentDefault = parcelHelpers.interopDefault(_screenPreviewComponent);
var _cortanaScreenWrapper = require("./CortanaScreenWrapper");
var _cortanaScreenWrapperDefault = parcelHelpers.interopDefault(_cortanaScreenWrapper);
var _dompurify = require("dompurify");
var _dompurifyDefault = parcelHelpers.interopDefault(_dompurify);
class CortanaScreenStandardCardPreview extends (0, _screenPreviewComponentDefault.default) {
    render() {
        return (0, _react.jsx)((0, _cortanaScreenWrapperDefault.default), {
            className: ""
        }, (0, _react.jsx)("div", {
            className: "body-container"
        }, (0, _react.jsx)("div", {
            className: "card"
        }, this.state.displayTitle ? (0, _react.jsx)("p", {
            className: "title-text"
        }, this.state.displayTitle) : null, this.state.foregroundImageUrl ? (0, _react.jsx)("div", {
            className: "foreground-image"
        }, (0, _react.jsx)("img", {
            src: this.state.foregroundImageUrl
        })) : null, (0, _react.jsx)("p", {
            className: "body-text"
        }, (0, _react.jsx)("span", {
            dangerouslySetInnerHTML: {
                __html: (0, _dompurifyDefault.default).sanitize(this.state.displayText)
            }
        }), this.state.followUpText ? (0, _react.jsx)((0, _reactDefault.default).Fragment, null, (0, _react.jsx)("br", null), (0, _react.jsx)("br", null), (0, _react.jsx)("span", {
            className: "followup-text"
        }, this.state.followUpText)) : null))));
    }
}
exports.default = CortanaScreenStandardCardPreview;

},{"@emotion/react":"djZKr","react":"6uln9","../ScreenPreviewComponent":"lBlZx","./CortanaScreenWrapper":"czxdk","dompurify":"5cPaM","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"fYqxp":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _screenPreviewComponent = require("../ScreenPreviewComponent");
var _screenPreviewComponentDefault = parcelHelpers.interopDefault(_screenPreviewComponent);
var _googleMobileScreenWrapper = require("./GoogleMobileScreenWrapper");
var _googleMobileScreenWrapperDefault = parcelHelpers.interopDefault(_googleMobileScreenWrapper);
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const screenStyle = /*#__PURE__*/ (0, _css.css)({
    name: "j776ee",
    styles: ".list-item{border-bottom:1px solid gray;display:flex;align-items:center;height:300px;.foreground-image{height:260px;width:auto;margin-right:0;margin-left:auto;img{height:100%;width:auto;}}}"
});
class GoogleMobileListPreview extends (0, _screenPreviewComponentDefault.default) {
    renderAdditionalItems() {
        const items = [];
        for(var i = 0; i < this.props.response.additionalListItems; i++)items.push(i);
        return items.map((_, i)=>(0, _react.jsx)("div", {
                key: i,
                className: "list-item"
            }, (0, _react.jsx)("p", {
                className: "body-text"
            }, (0, _react.jsx)("span", null, i + 2, ". Additional Item")), (0, _react.jsx)("div", {
                className: "foreground-image empty"
            })));
    }
    render() {
        return (0, _react.jsx)((0, _googleMobileScreenWrapperDefault.default), {
            className: screenStyle
        }, (0, _react.jsx)("div", {
            className: "body-container"
        }, this.state.displayTitle ? (0, _react.jsx)("p", {
            className: "title-text"
        }, this.state.displayTitle) : null, (0, _react.jsx)("div", {
            className: "body-container"
        }, (0, _react.jsx)("div", {
            className: "list-item"
        }, (0, _react.jsx)("p", {
            className: "body-text"
        }, (0, _react.jsx)("span", null, "1. ", this.state.displayText)), this.state.foregroundImageUrl ? (0, _react.jsx)("div", {
            className: "foreground-image"
        }, (0, _react.jsx)("img", {
            src: this.state.foregroundImageUrl
        })) : (0, _react.jsx)("div", {
            className: "foreground-image empty"
        })), this.props.response.additionalListItems ? this.renderAdditionalItems() : null)), (0, _react.jsx)("div", {
            className: "chip-container"
        }, this.state.hints ? this.state.hints.filter((h)=>h.content.length <= 20).map((h, i)=>(0, _react.jsx)("span", {
                key: i,
                className: "hint-chip"
            }, h.content)) : null));
    }
}
exports.default = GoogleMobileListPreview;

},{"@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","../ScreenPreviewComponent":"lBlZx","./GoogleMobileScreenWrapper":"d95zj","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"d95zj":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "googleBodyStyle", ()=>googleBodyStyle);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _reactContainerDimensions = require("react-container-dimensions");
var _reactContainerDimensionsDefault = parcelHelpers.interopDefault(_reactContainerDimensions);
var _colors = require("../../../constants/colors");
const googleBodyStyle = /*#__PURE__*/ (0, _css.css)("position:relative;width:100%;padding-top:133.33%;margin:16px 0;.screen-wrapper{position:absolute;top:0;left:0;padding:8px;background:gray;border-radius:5px;width:calc(100% - 16px);height:100%;}.screen{position:relative;left:50%;top:50%;transform:translate(-49%, -49%);transform-origin:center center;height:1440px;width:1080px;background:white;display:flex;flex-direction:column;.media-container{display:flex;flex-direction:column;align-items:center;justify-content:center;margin-top:42px;.scrub-bar{width:900px;margin:20px 160px;height:8px;background:", (0, _colors.silver_two), ";}.scrub-handle{width:32px;height:32px;border:solid 8px ", (0, _colors.silver_two), ";margin-top:-48px;margin-left:90px;background:white;margin-right:auto;border-radius:50%;}.time-container{display:flex;flex:1;font-size:60px;width:900px;font-weight:bold;.end{margin-left:auto;margin-right:0;}}.play-icon{height:80px;width:80px;}}.hint-chip{border:1px solid gray;height:60px;border-radius:40px;margin-right:20px;font-family:'Roboto',sans-serif;font-size:48px;color:#111111;z-index:2;padding:18px 24px;}.body-text,.title-text{font-family:'Roboto',sans-serif;padding-top:80px;padding-left:80px;color:#111111;overflow-wrap:break-word;z-index:2;position:relative;}.detail-text{color:", (0, _colors.cool_grey), ";font-family:'Roboto',sans-serif;overflow-wrap:break-word;z-index:2;position:relative;padding-left:80px;font-size:42px;}.title-text{font-size:80px;}.foreground-image{z-index:2;height:auto;display:flex;width:900px;height:506px;justify-content:center;align-items:center;margin:40px 160px 40px 100px;img{height:100%;width:auto;}}.body-text{overflow-y:hidden;flex:1;font-size:42px;}.body-container{z-index:2;position:relative;}.chip-container{margin-left:60px;margin-bottom:120px;margin-top:auto;}}", "");
const GoogleMobileScreenWrapper = (props)=>(0, _react.jsx)("div", {
        className: googleBodyStyle
    }, (0, _react.jsx)("div", {
        className: "screen-wrapper"
    }, (0, _react.jsx)((0, _reactContainerDimensionsDefault.default), null, ({ width, height })=>(0, _react.jsx)("div", {
            className: `screen ${props.className}`,
            style: {
                transform: `translate(-50%, -50%) scale(${Math.min(width / 1080, height / 1440)})`
            }
        }, props.children))));
exports.default = GoogleMobileScreenWrapper;

},{"@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","react-container-dimensions":"lhO7N","../../../constants/colors":"1p3OR","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8M60m":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _screenPreviewComponent = require("../ScreenPreviewComponent");
var _screenPreviewComponentDefault = parcelHelpers.interopDefault(_screenPreviewComponent);
var _googleMobileScreenWrapper = require("./GoogleMobileScreenWrapper");
var _googleMobileScreenWrapperDefault = parcelHelpers.interopDefault(_googleMobileScreenWrapper);
const playIcon = require("9576718b6a48310f");
class GoogleMobileMediaResponsePreview extends (0, _screenPreviewComponentDefault.default) {
    render() {
        return (0, _react.jsx)((0, _googleMobileScreenWrapperDefault.default), {
            className: ""
        }, (0, _react.jsx)("div", {
            className: "body-container"
        }, (0, _react.jsx)("p", {
            className: "body-text"
        }, (0, _react.jsx)("span", null, this.state.displayText), this.state.followUpText ? (0, _react.jsx)((0, _reactDefault.default).Fragment, null, (0, _react.jsx)("br", null), (0, _react.jsx)("br", null), (0, _react.jsx)("span", {
            className: "followup-text"
        }, this.state.followUpText)) : null), this.state.displayTitle ? (0, _react.jsx)("p", {
            className: "title-text"
        }, this.state.displayTitle) : null, (0, _react.jsx)("p", {
            className: "detail-text"
        }, (0, _react.jsx)("span", null, this.state.displayText)), this.state.foregroundImageUrl ? (0, _react.jsx)("div", {
            className: "foreground-image"
        }, (0, _react.jsx)("img", {
            src: this.state.foregroundImageUrl
        })) : null), (0, _react.jsx)("div", {
            className: "media-container"
        }, (0, _react.jsx)("div", {
            className: "scrub-bar"
        }), (0, _react.jsx)("div", {
            className: "scrub-handle"
        }), (0, _react.jsx)("div", {
            className: "time-container"
        }, (0, _react.jsx)("p", null, "--.--"), (0, _react.jsx)("p", {
            className: "end"
        }, "--.--")), (0, _react.jsx)("img", {
            className: "play-icon",
            src: playIcon
        })), (0, _react.jsx)("div", {
            className: "chip-container"
        }, this.state.hints ? this.state.hints.filter((h)=>h.content.length <= 20).map((h, i)=>(0, _react.jsx)("span", {
                key: i,
                className: "hint-chip"
            }, h.content)) : null));
    }
}
exports.default = GoogleMobileMediaResponsePreview;

},{"@emotion/react":"djZKr","react":"6uln9","../ScreenPreviewComponent":"lBlZx","./GoogleMobileScreenWrapper":"d95zj","9576718b6a48310f":"jWPMt","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"aksG3":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _screenPreviewComponent = require("../ScreenPreviewComponent");
var _screenPreviewComponentDefault = parcelHelpers.interopDefault(_screenPreviewComponent);
var _googleMobileScreenWrapper = require("./GoogleMobileScreenWrapper");
var _googleMobileScreenWrapperDefault = parcelHelpers.interopDefault(_googleMobileScreenWrapper);
var _dompurify = require("dompurify");
var _dompurifyDefault = parcelHelpers.interopDefault(_dompurify);
class GoogleMobileSimpleCardPreview extends (0, _screenPreviewComponentDefault.default) {
    render() {
        return (0, _react.jsx)((0, _googleMobileScreenWrapperDefault.default), {
            className: ""
        }, (0, _react.jsx)("div", {
            className: "body-container"
        }, this.state.displayTitle ? (0, _react.jsx)("p", {
            className: "title-text"
        }, this.state.displayTitle) : null, (0, _react.jsx)("p", {
            className: "body-text"
        }, (0, _react.jsx)("span", {
            dangerouslySetInnerHTML: {
                __html: (0, _dompurifyDefault.default).sanitize(this.state.displayText)
            }
        }), this.state.followUpText ? (0, _react.jsx)((0, _reactDefault.default).Fragment, null, (0, _react.jsx)("br", null), (0, _react.jsx)("br", null), (0, _react.jsx)("span", {
            className: "followup-text",
            dangerouslySetInnerHTML: {
                __html: (0, _dompurifyDefault.default).sanitize(this.state.followUpText)
            }
        })) : null)), (0, _react.jsx)("div", {
            className: "chip-container"
        }, this.state.hints ? this.state.hints.filter((h)=>h.content.length <= 20).map((h, i)=>(0, _react.jsx)("span", {
                key: i,
                className: "hint-chip"
            }, h.content)) : null));
    }
}
exports.default = GoogleMobileSimpleCardPreview;

},{"@emotion/react":"djZKr","react":"6uln9","../ScreenPreviewComponent":"lBlZx","./GoogleMobileScreenWrapper":"d95zj","dompurify":"5cPaM","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"cGAKr":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _screenPreviewComponent = require("../ScreenPreviewComponent");
var _screenPreviewComponentDefault = parcelHelpers.interopDefault(_screenPreviewComponent);
var _googleMobileScreenWrapper = require("./GoogleMobileScreenWrapper");
var _googleMobileScreenWrapperDefault = parcelHelpers.interopDefault(_googleMobileScreenWrapper);
var _dompurify = require("dompurify");
var _dompurifyDefault = parcelHelpers.interopDefault(_dompurify);
class GoogleMobileStandardCardPreview extends (0, _screenPreviewComponentDefault.default) {
    render() {
        return (0, _react.jsx)((0, _googleMobileScreenWrapperDefault.default), {
            className: ""
        }, (0, _react.jsx)("div", {
            className: "body-container"
        }, (0, _react.jsx)("p", {
            className: "body-text"
        }, (0, _react.jsx)("span", null, this.state.ssml), this.state.followUpText ? (0, _react.jsx)((0, _reactDefault.default).Fragment, null, (0, _react.jsx)("br", null), (0, _react.jsx)("br", null), (0, _react.jsx)("span", {
            className: "followup-text"
        }, this.state.followUpText)) : null), this.state.displayTitle ? (0, _react.jsx)("p", {
            className: "title-text"
        }, this.state.displayTitle) : null, this.state.foregroundImageUrl ? (0, _react.jsx)("div", {
            className: "foreground-image"
        }, (0, _react.jsx)("img", {
            src: this.state.foregroundImageUrl
        })) : null, (0, _react.jsx)("p", {
            className: "body-text"
        }, (0, _react.jsx)("span", {
            dangerouslySetInnerHTML: {
                __html: (0, _dompurifyDefault.default).sanitize(this.state.displayText)
            }
        }), this.state.followUpText ? (0, _react.jsx)((0, _reactDefault.default).Fragment, null, (0, _react.jsx)("br", null), (0, _react.jsx)("br", null), (0, _react.jsx)("span", {
            className: "followup-text"
        }, this.state.followUpText)) : null)), (0, _react.jsx)("div", {
            className: "chip-container"
        }, this.state.hints ? this.state.hints.filter((h)=>h.content.length <= 20).map((h, i)=>(0, _react.jsx)("span", {
                key: i,
                className: "hint-chip"
            }, h.content)) : null));
    }
}
exports.default = GoogleMobileStandardCardPreview;

},{"@emotion/react":"djZKr","react":"6uln9","../ScreenPreviewComponent":"lBlZx","./GoogleMobileScreenWrapper":"d95zj","dompurify":"5cPaM","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"lYE6m":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _screenPreviewComponent = require("../ScreenPreviewComponent");
var _screenPreviewComponentDefault = parcelHelpers.interopDefault(_screenPreviewComponent);
var _googleScreenWrapper = require("./GoogleScreenWrapper");
var _googleScreenWrapperDefault = parcelHelpers.interopDefault(_googleScreenWrapper);
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const screenStyle = /*#__PURE__*/ (0, _css.css)({
    name: "icvpds",
    styles: "color:white;.body-text,.title-text{font-family:'Roboto',sans-serif;padding-top:80px;padding-left:80px;color:#111111;overflow-wrap:break-word;z-index:2;position:relative;}.title-text{font-size:80px;}.body-text{overflow-y:hidden;flex:1;font-size:42px;}.body-container{display:flex;z-index:2;flex-direction:column;position:relative;}.chip-container{margin-left:60px;margin-bottom:20px;}.list-item{border-bottom:1px solid gray;display:flex;align-items:center;height:300px;.foreground-image{height:260px;width:auto;margin-right:0;margin-left:auto;img{height:100%;width:auto;}}}.hint-chip{border:1px solid gray;height:80px;border-radius:80px;margin-right:40px;font-family:'Roboto',sans-serif;font-size:62px;color:#111111;z-index:2;padding:32px;}"
});
class GoogleListPreview extends (0, _screenPreviewComponentDefault.default) {
    renderAdditionalItems() {
        const items = [];
        for(var i = 0; i < this.props.response.additionalListItems; i++)items.push(i);
        return items.map((_, i)=>(0, _react.jsx)("div", {
                key: i,
                className: "list-item"
            }, (0, _react.jsx)("p", {
                className: "body-text"
            }, (0, _react.jsx)("span", null, i + 2, ". Additional Item")), (0, _react.jsx)("div", {
                className: "foreground-image empty"
            })));
    }
    render() {
        return (0, _react.jsx)((0, _googleScreenWrapperDefault.default), {
            className: screenStyle
        }, this.state.displayTitle ? (0, _react.jsx)("p", {
            className: "title-text"
        }, this.state.displayTitle) : null, (0, _react.jsx)("div", {
            className: "body-container"
        }, (0, _react.jsx)("div", {
            className: "list-item"
        }, (0, _react.jsx)("p", {
            className: "body-text"
        }, (0, _react.jsx)("span", null, "1. ", this.state.displayText)), this.state.foregroundImageUrl ? (0, _react.jsx)("div", {
            className: "foreground-image"
        }, (0, _react.jsx)("img", {
            src: this.state.foregroundImageUrl
        })) : (0, _react.jsx)("div", {
            className: "foreground-image empty"
        })), this.props.response.additionalListItems ? this.renderAdditionalItems() : null), (0, _react.jsx)("div", {
            className: "chip-container"
        }, this.state.hints ? this.state.hints.filter((h)=>h.content.length <= 20).map((h, i)=>(0, _react.jsx)("span", {
                key: i,
                className: "hint-chip"
            }, h.content)) : null));
    }
}
exports.default = GoogleListPreview;

},{"@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","../ScreenPreviewComponent":"lBlZx","./GoogleScreenWrapper":"96ryj","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"96ryj":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "googleBodyStyle", ()=>googleBodyStyle);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _reactContainerDimensions = require("react-container-dimensions");
var _reactContainerDimensionsDefault = parcelHelpers.interopDefault(_reactContainerDimensions);
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const googleBodyStyle = /*#__PURE__*/ (0, _css.css)({
    name: "1ktg2y8",
    styles: "position:relative;width:100%;padding-top:56.25%;margin:16px 0;.screen-wrapper{position:absolute;top:0;left:0;padding:8px;background:gray;border-radius:5px;width:calc(100% - 16px);height:100%;}.screen{position:relative;left:50%;top:50%;transform:translate(-49%, -49%);transform-origin:center center;width:1920px;height:1080px;background:white;}"
});
const GoogleScreenWrapper = (props)=>(0, _react.jsx)("div", {
        className: googleBodyStyle
    }, (0, _react.jsx)("div", {
        className: "screen-wrapper"
    }, (0, _react.jsx)((0, _reactContainerDimensionsDefault.default), null, ({ width, height })=>(0, _react.jsx)("div", {
            className: `screen ${props.className}`,
            style: {
                transform: `translate(-50%, -50%) scale(${Math.min(width / 1920, height / 1080)})`
            }
        }, props.children))));
exports.default = GoogleScreenWrapper;

},{"@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","react-container-dimensions":"lhO7N","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1uyer":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _screenPreviewComponent = require("../ScreenPreviewComponent");
var _screenPreviewComponentDefault = parcelHelpers.interopDefault(_screenPreviewComponent);
var _googleScreenWrapper = require("./GoogleScreenWrapper");
var _googleScreenWrapperDefault = parcelHelpers.interopDefault(_googleScreenWrapper);
var _colors = require("../../../constants/colors");
const playIcon = require("e2bd4c6512cdd83a");
const screenStyle = /*#__PURE__*/ (0, _css.css)("color:white;.body-text,.title-text{font-family:'Roboto',sans-serif;font-size:80px;padding-top:80px;padding-left:160px;color:#111111;overflow-wrap:break-word;z-index:2;position:relative;}.body-text{overflow-y:hidden;flex:1;}.detail-text{color:", (0, _colors.cool_grey), ";font-family:'Roboto',sans-serif;overflow-wrap:break-word;z-index:2;position:relative;padding-left:80px;font-size:42px;}.media-container{display:flex;flex-direction:column;align-items:center;justify-content:center;margin-top:42px;margin-bottom:32px;.scrub-bar{width:1820px;margin:20px 160px;height:8px;background:", (0, _colors.silver_two), ";}.scrub-handle{width:32px;height:32px;border:solid 8px ", (0, _colors.silver_two), ";margin-top:-48px;margin-left:90px;background:white;margin-right:auto;border-radius:50%;}.time-container{display:flex;flex:1;font-size:60px;width:1820px;font-weight:bold;.end{margin-left:auto;margin-right:0;}}.play-icon{height:80px;width:80px;}}.body-container{display:flex;z-index:2;align-items:center;height:68%;}.foreground-image{width:400px;height:400px;z-index:2;height:auto;padding-right:160px;img{width:100%;height:auto;}}.chip-container{margin-left:60px;margin-bottom:20px;}.hint-chip{border:1px solid gray;height:80px;border-radius:80px;margin-right:40px;font-family:'Roboto',sans-serif;font-size:62px;color:#111111;z-index:2;padding:32px;}", "");
class GoogleMediaResponsePreview extends (0, _screenPreviewComponentDefault.default) {
    render() {
        return (0, _react.jsx)((0, _googleScreenWrapperDefault.default), {
            className: screenStyle
        }, (0, _react.jsx)("div", {
            className: "body-container"
        }, (0, _react.jsx)("p", {
            className: "body-text"
        }, (0, _react.jsx)("span", null, this.state.displayTitle), (0, _react.jsx)("br", null), (0, _react.jsx)("span", null, this.state.displayText)), this.state.foregroundImageUrl ? (0, _react.jsx)("div", {
            className: "foreground-image"
        }, (0, _react.jsx)("img", {
            src: this.state.foregroundImageUrl
        })) : null), (0, _react.jsx)("div", {
            className: "media-container"
        }, (0, _react.jsx)("div", {
            className: "scrub-bar"
        }), (0, _react.jsx)("div", {
            className: "scrub-handle"
        }), (0, _react.jsx)("div", {
            className: "time-container"
        }, (0, _react.jsx)("p", null, "--.--"), (0, _react.jsx)("p", {
            className: "end"
        }, "--.--")), (0, _react.jsx)("img", {
            className: "play-icon",
            src: playIcon
        })), (0, _react.jsx)("div", {
            className: "chip-container"
        }, this.state.hints ? this.state.hints.filter((h)=>h.content.length <= 20).map((h, i)=>(0, _react.jsx)("span", {
                key: i,
                className: "hint-chip"
            }, h.content)) : null));
    }
}
exports.default = GoogleMediaResponsePreview;

},{"@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","../ScreenPreviewComponent":"lBlZx","./GoogleScreenWrapper":"96ryj","../../../constants/colors":"1p3OR","e2bd4c6512cdd83a":"jWPMt","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"aAxY5":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _screenPreviewComponent = require("../ScreenPreviewComponent");
var _screenPreviewComponentDefault = parcelHelpers.interopDefault(_screenPreviewComponent);
var _googleScreenWrapper = require("./GoogleScreenWrapper");
var _googleScreenWrapperDefault = parcelHelpers.interopDefault(_googleScreenWrapper);
var _dompurify = require("dompurify");
var _dompurifyDefault = parcelHelpers.interopDefault(_dompurify);
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const screenStyle = /*#__PURE__*/ (0, _css.css)({
    name: "l8qsnl",
    styles: "color:white;.body-text,.title-text{font-family:'Roboto',sans-serif;padding-top:80px;padding-left:80px;color:#111111;overflow-wrap:break-word;z-index:2;position:relative;}.title-text{font-size:80px;}.body-text{overflow-y:hidden;height:660px;flex:1;font-size:42px;}.body-container{display:flex;z-index:2;position:relative;}.chip-container{margin-left:60px;margin-bottom:20px;}.hint-chip{border:1px solid gray;height:80px;border-radius:80px;margin-right:40px;font-family:'Roboto',sans-serif;font-size:62px;color:#111111;z-index:2;padding:32px;}"
});
class GoogleSimpleCardPreview extends (0, _screenPreviewComponentDefault.default) {
    render() {
        return (0, _react.jsx)((0, _googleScreenWrapperDefault.default), {
            className: screenStyle
        }, this.state.displayTitle ? (0, _react.jsx)("p", {
            className: "title-text"
        }, this.state.displayTitle) : null, (0, _react.jsx)("div", {
            className: "body-container"
        }, (0, _react.jsx)("p", {
            className: "body-text"
        }, (0, _react.jsx)("span", {
            dangerouslySetInnerHTML: {
                __html: (0, _dompurifyDefault.default).sanitize(this.state.displayText)
            }
        }), this.state.followUpText ? (0, _react.jsx)((0, _reactDefault.default).Fragment, null, (0, _react.jsx)("br", null), (0, _react.jsx)("br", null), (0, _react.jsx)("span", {
            className: "followup-text",
            dangerouslySetInnerHTML: {
                __html: (0, _dompurifyDefault.default).sanitize(this.state.followUpText)
            }
        })) : null)), (0, _react.jsx)("div", {
            className: "chip-container"
        }, this.state.hints ? this.state.hints.filter((h)=>h.content.length <= 20).map((h, i)=>(0, _react.jsx)("span", {
                key: i,
                className: "hint-chip"
            }, h.content)) : null));
    }
}
exports.default = GoogleSimpleCardPreview;

},{"@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","../ScreenPreviewComponent":"lBlZx","./GoogleScreenWrapper":"96ryj","dompurify":"5cPaM","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jLzoO":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _screenPreviewComponent = require("../ScreenPreviewComponent");
var _screenPreviewComponentDefault = parcelHelpers.interopDefault(_screenPreviewComponent);
var _googleScreenWrapper = require("./GoogleScreenWrapper");
var _googleScreenWrapperDefault = parcelHelpers.interopDefault(_googleScreenWrapper);
var _dompurify = require("dompurify");
var _dompurifyDefault = parcelHelpers.interopDefault(_dompurify);
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const screenStyle = /*#__PURE__*/ (0, _css.css)({
    name: "5g5bin",
    styles: "color:white;.body-text,.title-text{font-family:'Roboto',sans-serif;padding-top:80px;padding-left:80px;color:#111111;overflow-wrap:break-word;z-index:2;position:relative;}.title-text{font-size:80px;}.foreground-image{width:400px;z-index:2;height:auto;padding-right:160px;margin-top:80px;img{width:100%;height:auto;}}.body-text{overflow-y:hidden;height:660px;flex:1;font-size:42px;}.body-container{display:flex;z-index:2;position:relative;align-items:start;}.chip-container{margin-left:60px;margin-bottom:20px;}.hint-chip{border:1px solid gray;height:80px;border-radius:80px;margin-right:40px;font-family:'Roboto',sans-serif;font-size:62px;color:#111111;z-index:2;padding:32px;}"
});
class GoogleStandardCardPreview extends (0, _screenPreviewComponentDefault.default) {
    render() {
        return (0, _react.jsx)((0, _googleScreenWrapperDefault.default), {
            className: screenStyle
        }, this.state.displayTitle ? (0, _react.jsx)("p", {
            className: "title-text"
        }, this.state.displayTitle) : null, (0, _react.jsx)("div", {
            className: "body-container"
        }, (0, _react.jsx)("p", {
            className: "body-text"
        }, (0, _react.jsx)("span", {
            dangerouslySetInnerHTML: {
                __html: (0, _dompurifyDefault.default).sanitize(this.state.displayText)
            }
        }), this.state.followUpText ? (0, _react.jsx)((0, _reactDefault.default).Fragment, null, (0, _react.jsx)("br", null), (0, _react.jsx)("br", null), (0, _react.jsx)("span", {
            className: "followup-text",
            dangerouslySetInnerHTML: {
                __html: (0, _dompurifyDefault.default).sanitize(this.state.followUpText)
            }
        })) : null), this.state.foregroundImageUrl ? (0, _react.jsx)("div", {
            className: "foreground-image"
        }, (0, _react.jsx)("img", {
            src: this.state.foregroundImageUrl
        })) : null), (0, _react.jsx)("div", {
            className: "chip-container"
        }, this.state.hints ? this.state.hints.filter((h)=>h.content.length <= 20).map((h, i)=>(0, _react.jsx)("span", {
                key: i,
                className: "hint-chip"
            }, h.content)) : null));
    }
}
exports.default = GoogleStandardCardPreview;

},{"@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","../ScreenPreviewComponent":"lBlZx","./GoogleScreenWrapper":"96ryj","dompurify":"5cPaM","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jkh8P":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _horizontalSeparator = require("../structure/HorizontalSeparator");
var _horizontalSeparatorDefault = parcelHelpers.interopDefault(_horizontalSeparator);
var _positionIndicator = require("../structure/ConversationFlow/PositionIndicator");
var _positionIndicatorDefault = parcelHelpers.interopDefault(_positionIndicator);
var _colors = require("../../constants/colors");
var _multiFileAudioPlayer = require("./MultiFileAudioPlayer");
var _multiFileAudioPlayerDefault = parcelHelpers.interopDefault(_multiFileAudioPlayer);
var _pageError = require("../general/PageError");
var _pageErrorDefault = parcelHelpers.interopDefault(_pageError);
var _audioPlayerFileIndicator = require("./AudioPlayerFileIndicator");
var _audioPlayerFileIndicatorDefault = parcelHelpers.interopDefault(_audioPlayerFileIndicator);
var _dompurify = require("dompurify");
var _dompurifyDefault = parcelHelpers.interopDefault(_dompurify);
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const openQuoteIcon = require("b814f7bde0c250a3");
const closeQuoteIcon = require("4470ecf57447569c");
const deviceIcon = require("137bde21ba6cd54a");
class DeviceAudioVariationsBubble extends (0, _reactDefault.default).Component {
    componentWillMount() {
        this.setState({
            position: 0,
            audioResponses: []
        });
    }
    getSsmlContent(conversationResponse) {
        var customResponse = conversationResponse.mediaResponseContainer ? conversationResponse.mediaResponseContainer.responses.find((r)=>r.deviceTargetId == this.props.deviceTargetId && r.readoutOverride != null) : null;
        if (customResponse) return customResponse.readoutOverride;
        return conversationResponse.content;
    }
    buildLabel(item) {
        // strip tags from ssml first
        const ssml = this.getVariationSsml(item, false);
        const stripTagRegex = /<\/?[^>]+(>|$)/g;
        var displayText = ssml ?? "";
        displayText = displayText.replace(stripTagRegex, "");
        item.highlights.forEach((highlight)=>{
            displayText = displayText.replace(highlight.replace(stripTagRegex, ""), `<span>${highlight}</span>`);
        });
        return (0, _react.jsx)("p", {
            className: inputStyle,
            key: item.id,
            dangerouslySetInnerHTML: {
                __html: (0, _dompurifyDefault.default).sanitize(displayText)
            }
        });
    }
    getVariationSsml(item, includeFollowUp) {
        var ssml = item.content;
        var customResponse = item.mediaResponseContainer ? item.mediaResponseContainer.responses.find((r)=>r.deviceTargetId == this.props.deviceTargetId && r.readoutOverride != null) : null;
        if (customResponse) ssml = customResponse.readoutOverride;
        if (includeFollowUp && this.props.followUp) ssml += `<break time=".5s"/> ${this.props.followUp.content}`;
        return ssml;
    }
    loadSsmlAudio(item) {
        const innerSsml = this.getVariationSsml(item, true);
        var ssml = innerSsml.startsWith("<speak>") ? innerSsml : `<speak>${innerSsml}</speak>`;
        var locale = this.props.languages == null || this.props.languages.length < 1 ? "" : this.props.languages[0].shortCode;
        if (this.state.audioResponses.some((a)=>a.ssml == ssml && a.assistant == this.props.assistant)) return;
        var cachedAudio = this.props.ssmlContainer.getCachedSsmlSpeech(ssml, this.props.assistant, locale);
        if (cachedAudio) {
            var responses = this.state.audioResponses;
            responses.push({
                ssml: ssml,
                assistant: this.props.assistant,
                outputAudioFiles: cachedAudio,
                locale: locale
            });
            this.setState({
                ...this.state,
                audioResponses: responses
            });
        } else this.props.ssmlContainer.getSpeechOutput(ssml, this.props.assistant, locale).then((result)=>{
            if (result.resultType == "Ok") {
                var responses = this.state.audioResponses;
                responses.push({
                    ssml: ssml,
                    assistant: this.props.assistant,
                    outputAudioFiles: result.data,
                    locale: locale
                });
                this.setState({
                    ...this.state,
                    audioResponses: responses
                });
            }
        });
    }
    handlePositionChange(position) {
        this.setState({
            ...this.state,
            position
        });
    }
    getAudioItem(variation) {
        var customResponse = variation.mediaResponseContainer ? variation.mediaResponseContainer.responses.find((r)=>r.deviceTargetId == this.props.deviceTargetId) : null;
        if (customResponse != null && customResponse.audioItem) return customResponse.audioItem;
        else if (variation.audioItem) return variation.audioItem;
        return null;
    }
    hasAudioPlayer(variation) {
        var item = this.getAudioItem(variation);
        if (item == null) return false;
        return true;
    }
    getAudioSrc(variation) {
        var customResponse = variation.mediaResponseContainer ? variation.mediaResponseContainer.responses.find((r)=>r.deviceTargetId == this.props.deviceTargetId) : null;
        if (customResponse != null && customResponse.audioItem) return [
            customResponse.audioItem.url
        ];
        else if (variation.audioItem) return [
            variation.audioItem.url
        ];
        var innerSsml = this.getVariationSsml(variation, true);
        var ssml = innerSsml.startsWith("<speak>") ? innerSsml : `<speak>${innerSsml}</speak>`;
        var audioSrc = this.state.audioResponses.find((a)=>a.ssml == ssml && a.assistant == this.props.assistant);
        if (!audioSrc || !audioSrc.outputAudioFiles) return null;
        return audioSrc.outputAudioFiles.map((s)=>s.url);
    }
    stripTags(ssml) {
        const stripTagRegex = /<\/?[^>]+(>|$)/g;
        var displayText = ssml;
        displayText = displayText.replace(stripTagRegex, "");
        return displayText;
    }
    render() {
        const { title, variations } = this.props;
        if (!variations) return null;
        const variation = variations[this.state.position];
        const hasAudioPlayer = this.hasAudioPlayer(variation);
        return (0, _react.jsx)("div", {
            className: containerStyle
        }, (0, _react.jsx)("div", {
            className: `${bubbleStyle} ac-output-message-preview`
        }, title && (0, _react.jsx)((0, _reactDefault.default).Fragment, null, (0, _react.jsx)("span", {
            className: "title"
        }, title), (0, _react.jsx)((0, _horizontalSeparatorDefault.default), null)), (0, _react.jsx)("div", {
            className: "open-quote-container"
        }, (0, _react.jsx)("img", {
            className: "open-quote",
            src: openQuoteIcon
        }), hasAudioPlayer ? (0, _react.jsx)("span", null, "(Overridden by Audio Response)") : null), (0, _react.jsx)("div", {
            className: `content-container ${hasAudioPlayer ? "removed" : ""}`
        }, variations.some((v)=>v.content != "") ? this.buildLabel(variation) : (0, _react.jsx)("p", {
            className: "placeholder"
        }, "Enter your response to see here"), this.props.followUp ? (0, _react.jsx)("div", {
            className: followUpContainer
        }, (0, _react.jsx)((0, _horizontalSeparatorDefault.default), null), (0, _react.jsx)("span", {
            className: followUpDetail
        }, "& Then…"), (0, _react.jsx)("p", {
            className: inputStyle
        }, (0, _react.jsx)("span", null, this.stripTags(this.props.followUp.content)))) : null), (0, _react.jsx)("img", {
            className: "close-quote",
            src: closeQuoteIcon
        }), hasAudioPlayer ? (0, _react.jsx)((0, _audioPlayerFileIndicatorDefault.default), {
            title: this.getAudioItem(variation).name
        }) : null, (0, _react.jsx)((0, _multiFileAudioPlayerDefault.default), {
            hasFile: hasAudioPlayer,
            src: this.getAudioSrc(variation),
            isLoading: this.props.ssmlContainer.state.isLoading,
            onLoad: ()=>this.loadSsmlAudio(variation)
        }), variations.length > 1 ? (0, _react.jsx)((0, _reactDefault.default).Fragment, null, (0, _react.jsx)((0, _horizontalSeparatorDefault.default), null), (0, _react.jsx)("div", {
            className: "carousel-container"
        }, (0, _react.jsx)("span", null, `VARIATION: ${this.state.position + 1} of ${variations.length}`), (0, _react.jsx)((0, _positionIndicatorDefault.default), {
            count: variations.length,
            position: this.state.position,
            onChange: this.handlePositionChange.bind(this)
        }))) : null), (0, _react.jsx)("img", {
            src: deviceIcon
        }), (0, _react.jsx)((0, _pageErrorDefault.default), {
            errors: this.props.ssmlContainer.state.errors
        }));
    }
}
const containerStyle = /*#__PURE__*/ (0, _css.css)({
    name: "84huzn",
    styles: "display:flex;align-items:start;>img{background:white;border-radius:50%;margin-top:30px;margin-right:12px;margin-left:12px;}"
});
const bubbleStyle = /*#__PURE__*/ (0, _css.css)("margin:30px 0 0 115px;border:solid 1px ", (0, _colors.dark_sky_blue), ";box-shadow:-1px 4px 10px 0 ", (0, _colors.dark_grey_blue_20), ";background:white;border-radius:10px 0 10px 10px;padding:24px;display:flex;flex-direction:column;flex:1;@media only screen and (min-width: 1240px){max-width:60%;margin-right:0;margin-left:auto;}.content-container{&.removed{text-decoration:line-through;}}.title{font-family:Muli;font-size:18px;font-weight:600;font-style:normal;font-stretch:normal;line-height:normal;letter-spacing:normal;color:", (0, _colors.dark_grey_blue), ";margin-bottom:24px;}.open-quote-container{display:flex;align-items:center;span{font-size:12px;color:", (0, _colors.cool_grey), ";letter-spacing:0.5px;margin-left:4px;}}.open-quote{margin-bottom:16px;margin-top:16px;}.close-quote{margin-right:0;margin-left:auto;margin-bottom:16px;margin-top:0;}.placeholder{text-align:center;font-style:italic;color:", (0, _colors.cool_grey), ";}.carousel-container{display:flex;align-items:center;justify-content:center;flex-direction:column;margin-top:16px;span{margin-bottom:8px;font-size:10px;font-weight:normal;font-stretch:normal;line-height:normal;letter-spacing:0.4px;text-align:center;color:", (0, _colors.cool_grey), ";}}", "");
const inputStyle = /*#__PURE__*/ (0, _css.css)("font-family:Muli;font-size:14px;font-weight:normal;font-style:normal;font-stretch:normal;line-height:normal;letter-spacing:normal;color:", (0, _colors.dark_grey_blue), ";margin-top:12px;span{background:", (0, _colors.highlight_blue), ";}", "");
const followUpDetail = /*#__PURE__*/ (0, _css.css)("background:white;margin-top:-9px;margin-left:8px;padding:0 4px;font-family:Muli;font-size:12px;font-weight:normal;font-style:normal;font-stretch:normal;line-height:normal;letter-spacing:0.5px;color:", (0, _colors.cool_grey), ";position:absolute;", "");
const followUpContainer = /*#__PURE__*/ (0, _css.css)({
    name: "n4zvey",
    styles: "position:relative;margin:48px 0 16px 0;p{margin-top:48px;}"
});
exports.default = DeviceAudioVariationsBubble;

},{"@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","../structure/HorizontalSeparator":"Pw3HQ","../structure/ConversationFlow/PositionIndicator":"39CHS","../../constants/colors":"1p3OR","./MultiFileAudioPlayer":"6v3LY","../general/PageError":"ezFTm","./AudioPlayerFileIndicator":"2qHo0","dompurify":"5cPaM","b814f7bde0c250a3":"fsPJR","4470ecf57447569c":"qzmjz","137bde21ba6cd54a":"2nj1V","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2qHo0":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _colors = require("../../constants/colors");
const audioIcon = require("ead338a9cbf3ba11");
const containerStyle = /*#__PURE__*/ (0, _css.css)("display:flex;align-items:center;border:1px solid ", (0, _colors.cool_grey), ";border-radius:5px 5px 0 0;height:50px;p{font-size:14px;color:", (0, _colors.dark_grey_blue), ";}>*{margin-left:22px;}", "");
const AudioPlayerFileIndicator = (props)=>(0, _react.jsx)("div", {
        className: containerStyle
    }, (0, _react.jsx)("img", {
        src: audioIcon
    }), (0, _react.jsx)("p", null, props.title));
exports.default = AudioPlayerFileIndicator;

},{"@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","../../constants/colors":"1p3OR","ead338a9cbf3ba11":"dZ4mZ","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hXxEZ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _colors = require("../../constants/colors");
var _tooltipWrapper = require("../general/TooltipWrapper");
var _tooltipWrapperDefault = parcelHelpers.interopDefault(_tooltipWrapper);
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const deviceIcon = require("3214dfc7469f789b");
const infoIcon = require("d22527ef291429ae");
const containerStyle = /*#__PURE__*/ (0, _css.css)({
    name: "84huzn",
    styles: "display:flex;align-items:start;>img{background:white;border-radius:50%;margin-top:30px;margin-right:12px;margin-left:12px;}"
});
const bubbleStyle = /*#__PURE__*/ (0, _css.css)("margin:30px 0 0 115px;border:solid 1px ", (0, _colors.pastel_red), ";box-shadow:-1px 4px 10px 0 ", (0, _colors.dark_grey_blue_20), ";background:white;border-radius:10px 0 10px 10px;padding:24px;display:flex;flex-direction:column;flex:1;@media only screen and (min-width: 1240px){max-width:20%;margin-right:0;margin-left:auto;}.placeholder{text-align:center;font-style:italic;color:", (0, _colors.cool_grey), ";}.content-container{margin:auto;display:flex;flex-direction:row;img{margin-left:8px;width:20px;height:20px;color:", (0, _colors.cool_grey), ";}}", "");
const UnsupportedResponseBubble = (props)=>(0, _react.jsx)("div", {
        className: containerStyle
    }, (0, _react.jsx)("div", {
        className: bubbleStyle
    }, (0, _react.jsx)("div", {
        className: "content-container"
    }, (0, _react.jsx)("p", {
        className: "placeholder"
    }, "Unsupported Response"), (0, _react.jsx)((0, _tooltipWrapperDefault.default), {
        text: "The simulator does not support responses intended for native platforms"
    }, (0, _react.jsx)("img", {
        src: infoIcon
    })))), (0, _react.jsx)("img", {
        src: deviceIcon
    }));
exports.default = UnsupportedResponseBubble;

},{"@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","../../constants/colors":"1p3OR","../general/TooltipWrapper":"53pWd","3214dfc7469f789b":"2nj1V","d22527ef291429ae":"3Pubw","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"i4iw1":[function(require,module,exports) {
module.exports = require("958a37f475917e7").getBundleURL("kVLro") + require("20831aa0a128abf0").resolve("dJho8");

},{"958a37f475917e7":"c7Tr5","20831aa0a128abf0":"fyJL2"}],"aRE2s":[function(require,module,exports) {
module.exports = require("7cccbba311d28603").getBundleURL("kVLro") + require("9c1f7f96c58122b3").resolve("anDtQ");

},{"7cccbba311d28603":"c7Tr5","9c1f7f96c58122b3":"fyJL2"}],"4hV53":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _tabContainerPanel = require("../../../components/structure/Panels/TabContainerPanel");
var _tabContainerPanelDefault = parcelHelpers.interopDefault(_tabContainerPanel);
var _reactTabs = require("react-tabs");
var _simulatorUserProfile = require("./SimulatorUserProfile");
var _simulatorUserProfileDefault = parcelHelpers.interopDefault(_simulatorUserProfile);
var _simulatorPinnedMessagesPanel = require("./SimulatorPinnedMessagesPanel");
var _simulatorPinnedMessagesPanelDefault = parcelHelpers.interopDefault(_simulatorPinnedMessagesPanel);
var _simulatorTestCasesPanel = require("./SimulatorTestCasesPanel");
var _simulatorTestCasesPanelDefault = parcelHelpers.interopDefault(_simulatorTestCasesPanel);
var _testCaseContainer = require("../../../hooks/TestCaseContainer");
var _testCaseContainerDefault = parcelHelpers.interopDefault(_testCaseContainer);
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const userIcon = require("d3ac147f7085eb13");
const userSelectedIcon = require("fed1b872c23e9e42");
const thumbtackIcon = require("b0b190b759017f9a");
const thumbtackSelectedIcon = require("fbc162eb1d7e2ae4");
const wrenchIcon = require("38ff4890392f9ec5");
const wrenchSelected = require("720311ea910d3cc");
const SimulatorInputPanel = (props)=>{
    const [selectedIndex, setSelectedIndex] = (0, _react1.useState)(0);
    const testCaseContainer = (0, _testCaseContainerDefault.default).useContainer();
    const updateSelectedIndex = (index)=>{
        setSelectedIndex(index);
    };
    (0, _react1.useEffect)(()=>{
        testCaseContainer.setApplication(props.appContainer?.state.currentApp);
    }, [
        props.appContainer?.state.currentApp?.id
    ]);
    return (0, _react.jsx)((0, _tabContainerPanelDefault.default), {
        selectedIndex: selectedIndex,
        onTabSelected: (index)=>{
            updateSelectedIndex(index);
        },
        className: containerStyle,
        tabs: [
            {
                title: "Tests",
                icon: thumbtackIcon,
                selectedIcon: thumbtackSelectedIcon,
                className: "ac-simulator-pinned-tab"
            },
            {
                title: "Tools",
                icon: wrenchIcon,
                selectedIcon: wrenchSelected,
                className: "ac-simulator-pinned-tab"
            },
            {
                title: "Language",
                icon: userIcon,
                selectedIcon: userSelectedIcon,
                className: "ac-simulator-user-tab"
            }
        ]
    }, (0, _react.jsx)((0, _reactTabs.TabPanel), null, (0, _react.jsx)((0, _simulatorTestCasesPanelDefault.default), {
        handleSendWelcome: props.handleSendWelcome,
        applicationId: props.applicationId,
        userApplicationPreferencesContainer: props.userApplicationPreferencesContainer,
        languages: props.languages,
        selectedLanguage: props.selectedLanguage,
        handleStartNewSession: props.handleStartNewSession,
        requests: props.requests,
        simulateTestCase: (tc)=>props.simulateTestCase(tc)
    })), (0, _react.jsx)((0, _reactTabs.TabPanel), null, (0, _react.jsx)((0, _simulatorPinnedMessagesPanelDefault.default), {
        handleSendWelcome: props.handleSendWelcome,
        applicationId: props.applicationId,
        userApplicationPreferencesContainer: props.userApplicationPreferencesContainer,
        languages: props.languages,
        selectedLanguage: props.selectedLanguage,
        handleSendMessage: (text)=>props.handleSendMessage(text),
        handleStartNewSession: props.handleStartNewSession,
        requests: props.requests
    })), (0, _react.jsx)((0, _reactTabs.TabPanel), null, (0, _react.jsx)((0, _simulatorUserProfileDefault.default), {
        appContainer: props.appContainer,
        applicationId: props.applicationId,
        languages: props.languages,
        selectedLanguage: props.selectedLanguage,
        handleLanguageSelected: (language)=>{
            props.handleLanguageSelected(language);
        }
    })));
};
const containerStyle = /*#__PURE__*/ (0, _css.css)({
    name: "odwkv8",
    styles: "width:432px;max-width:432px;flex:1"
});
exports.default = SimulatorInputPanel;

},{"@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","../../../components/structure/Panels/TabContainerPanel":"iDHIJ","react-tabs":"92Sgf","./SimulatorUserProfile":"8lyOZ","./SimulatorPinnedMessagesPanel":"4ftEP","./SimulatorTestCasesPanel":"4I2H7","../../../hooks/TestCaseContainer":"cLg3U","d3ac147f7085eb13":"ggifZ","fed1b872c23e9e42":"aVRuD","b0b190b759017f9a":"3hXyd","fbc162eb1d7e2ae4":"k74xV","38ff4890392f9ec5":"7K1Sf","720311ea910d3cc":"b8Mu1","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8lyOZ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _colors = require("../../../constants/colors");
var _simulatorLanguageSelector = require("./SimulatorLanguageSelector");
var _simulatorLanguageSelectorDefault = parcelHelpers.interopDefault(_simulatorLanguageSelector);
const flagIcon = require("9a3fcdf88cdefad4");
const SimulatorUserProfile = ({ languages, selectedLanguage, handleLanguageSelected })=>(0, _react.jsx)("div", {
        className: containerStyle
    }, (0, _react.jsx)("div", {
        className: "title-container"
    }, (0, _react.jsx)("div", {
        className: "title"
    }, "User Profile"), (0, _react.jsx)("div", {
        className: "subtitle"
    }, "Configure the settings of the end-user you’d like to speak as in the simulator")), (0, _react.jsx)("div", {
        className: "language-container"
    }, (0, _react.jsx)("div", {
        className: "title"
    }, (0, _react.jsx)("img", {
        src: flagIcon
    }), (0, _react.jsx)("span", null, "Language / Region")), (0, _react.jsx)((0, _simulatorLanguageSelectorDefault.default), {
        languages: languages,
        selectedLanguage: selectedLanguage,
        handleLanguageSelected: handleLanguageSelected
    })));
const containerStyle = /*#__PURE__*/ (0, _css.css)("padding:24px;padding-top:32px;max-width:432px;font-family:Muli;font-style:normal;font-weight:normal;.title-container{.title{font-size:18px;line-height:24px;padding-bottom:18px;color:", (0, _colors.color_text_default), ";}.subtitle{font-size:14px;line-height:20px;padding-bottom:12px;color:", (0, _colors.color_text_light), ";}}.language-container{border:1px solid ", (0, _colors.color_shades_dark), ";box-sizing:border-box;border-radius:8px;max-width:368px;height:128px;padding:24px;.title{display:flex;flex-direction:row;align-items:center;font-size:14px;line-height:20px;color:", (0, _colors.color_text_default), ";}}", "");
exports.default = SimulatorUserProfile;

},{"@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","../../../constants/colors":"1p3OR","./SimulatorLanguageSelector":"49Fz2","9a3fcdf88cdefad4":"cJMqX","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"49Fz2":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _css = require("@emotion/css");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _toggleIndicator = require("../../../components/general/ToggleIndicator");
var _toggleIndicatorDefault = parcelHelpers.interopDefault(_toggleIndicator);
var _languages = require("../../../models/extensions/languages");
var _colors = require("../../../constants/colors");
var _customScrollbars = require("../../../components/structure/CustomScrollbars");
var _customScrollbarsDefault = parcelHelpers.interopDefault(_customScrollbars);
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const SimulatorLanguageSelector = ({ handleLanguageSelected, languages, selectedLanguage })=>{
    const [isExpanded, setIsExpanded] = (0, _react1.useState)(false);
    const handleToggle = ()=>{
        setIsExpanded(!isExpanded);
    };
    const selectLanguage = (language)=>{
        handleLanguageSelected(language);
        handleToggle();
    };
    const renderEmpty = ()=>{
        return (0, _react.jsx)("div", {
            className: "selected-summary"
        }, (0, _react.jsx)("p", {
            className: "item-text"
        }, "Select a Language"), (0, _react.jsx)((0, _toggleIndicatorDefault.default), {
            direction: isExpanded ? "up" : "down"
        }));
    };
    const renderLanguageSummaryItem = (language)=>{
        return (0, _react.jsx)("div", {
            className: "selected-summary"
        }, (0, _react.jsx)("img", {
            src: (0, _languages.getFlagIconForLanguage)(language)
        }), (0, _react.jsx)("p", {
            className: "item-text"
        }, language?.shortCode), (0, _react.jsx)((0, _toggleIndicatorDefault.default), {
            direction: isExpanded ? "up" : "down"
        }));
    };
    const renderNoLanguages = ()=>{
        return (0, _react.jsx)("div", {
            className: containerStyle
        }, (0, _react.jsx)("div", null, (0, _react.jsx)("p", {
            className: "empty-value"
        }, "You must add at least one language to your application first.")));
    };
    const renderLanguageList = ()=>{
        return (0, _react.jsx)((0, _reactDefault.default).Fragment, null, languages.map((l, idx)=>{
            return (0, _react.jsx)("div", {
                key: l.id,
                className: `select-item ${idx === 0 ? " top" : ""}${selectedLanguage?.id === l.id ? "selected-language" : ""}`,
                onClick: ()=>{
                    selectLanguage(l);
                }
            }, (0, _react.jsx)("img", {
                src: (0, _languages.getFlagIconForLanguage)(l)
            }), (0, _react.jsx)("p", {
                className: "item-text"
            }, l.shortCode));
        }));
    };
    if (languages.length === 0) return renderNoLanguages();
    return (0, _react.jsx)("div", {
        className: containerStyle
    }, (0, _react.jsx)("div", {
        onClick: handleToggle,
        onBlur: handleToggle
    }, selectedLanguage ? renderLanguageSummaryItem(languages.find((l)=>l.id === selectedLanguage?.id)) : renderEmpty()), isExpanded && (0, _react.jsx)("div", {
        className: "expanded-view"
    }, (0, _react.jsx)("div", {
        className: triangleStyle
    }), (0, _react.jsx)("div", {
        className: "select-list"
    }, (0, _react.jsx)((0, _customScrollbarsDefault.default), {
        autoHeight: true,
        className: "scrollbar-holder",
        autoHide: true
    }, renderLanguageList()))));
};
const containerStyle = /*#__PURE__*/ (0, _css.css)("width:100%;.expanded-view{margin-top:10px;}.selected-summary{background:white;border:1px solid ", (0, _colors.color_shades_dark), ";box-sizing:border-box;border-radius:4px;height:48px;display:flex;align-items:center;padding:0 16px;cursor:pointer;}.scrollbar-holder{}.select-list{background:white;border:1px solid ", (0, _colors.color_shades_dark), ";border-radius:4px;max-height:350px;min-height:64px;overflow-y:auto;overflow-x:hidden;display:flex;flex-direction:row;align-items:flex-start;cursor:pointer;flex-wrap:wrap;}.select-item{min-width:calc(100%-16px);display:flex;flex-direction:row;align-items:center;padding-bottom:20px;padding-top:20px;padding-left:16px;border-top:1px solid ", (0, _colors.color_shades_dark), ";&:hover{background:", (0, _colors.color_shades_light), ";}&.selected-language{background:", (0, _colors.color_variants_ocean_light_opaque_2), ";}&.top{border-top:0px;}}.item-text{padding-left:8px;}.toggle-indicator{margin-right:0;margin-left:auto;}", "");
const triangleStyle = /*#__PURE__*/ (0, _css.css)({
    name: "n2w3ez",
    styles: "transform:rotate(45deg);width:12px;height:12px;margin-top:-7px;margin-bottom:-6px;border-top:solid 1px #cccccc;border-left:solid 1px #cccccc;background:white;margin-right:16px;margin-left:auto;z-index:2"
});
exports.default = SimulatorLanguageSelector;

},{"@emotion/react":"djZKr","@emotion/css":"awUBr","react":"6uln9","../../../components/general/ToggleIndicator":"4eej1","../../../models/extensions/languages":"8E5Oo","../../../constants/colors":"1p3OR","../../../components/structure/CustomScrollbars":"50vFq","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4ftEP":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _base = require("@emotion/styled/base");
var _baseDefault = parcelHelpers.interopDefault(_base);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _colors = require("../../../constants/colors");
var _button = require("../../../components/general/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _customScrollbars = require("../../../components/structure/CustomScrollbars");
var _customScrollbarsDefault = parcelHelpers.interopDefault(_customScrollbars);
var _useWindowSize = require("../../../hooks/UseWindowSize");
var _useWindowSizeDefault = parcelHelpers.interopDefault(_useWindowSize);
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const greenPowerIcon = require("6bd5954e67168aeb");
const removeThumbtackIcon = require("860df3755ff4dcb2");
const helpIconBlack = require("64336cb6e583904");
const fallbackIconBlack = require("487e47dc10f26f83");
const welcomeIconBlack = require("20055cecf1613105");
const exitIconBlack = require("10245df0001a789d");
const SimulatorPinnedMessagesPanel = (props)=>{
    const windowSize = (0, _useWindowSizeDefault.default)();
    (0, _react1.useEffect)(()=>{
        props.userApplicationPreferencesContainer.loadUserApplicationPreferences(props.applicationId);
    }, [
        props.applicationId
    ]);
    const pinnedMessages = props.userApplicationPreferencesContainer.state.currentUserApplicationPreferences?.simulatorPinnedMessages ?? [];
    return (0, _react.jsx)("div", {
        className: containerStyle
    }, (0, _react.jsx)(PinnedMessagesHeadingWrapper, null, (0, _react.jsx)("div", {
        className: "title-container"
    }, (0, _react.jsx)("div", {
        className: "title"
    }, "Pinned Messages")), (0, _react.jsx)("div", {
        className: defaultButtons
    }, (0, _react.jsx)((0, _buttonDefault.default), {
        icon: greenPowerIcon,
        themes: [
            "white-pill"
        ],
        className: greenText,
        text: "Restart session",
        onClick: ()=>props.handleStartNewSession()
    }), (0, _react.jsx)("div", {
        className: generalResponses
    }, (0, _react.jsx)((0, _buttonDefault.default), {
        icon: welcomeIconBlack,
        themes: [
            "white-pill"
        ],
        disabled: props.requests.length > 0,
        className: generalResponseButton,
        text: "Welcome",
        onClick: ()=>props.handleSendWelcome()
    }), (0, _react.jsx)((0, _buttonDefault.default), {
        icon: helpIconBlack,
        themes: [
            "white-pill"
        ],
        className: generalResponseButton,
        text: "Help",
        onClick: ()=>props.handleSendMessage("Help")
    }), (0, _react.jsx)((0, _buttonDefault.default), {
        icon: exitIconBlack,
        themes: [
            "white-pill"
        ],
        className: generalResponseButton,
        text: "Exit",
        onClick: ()=>props.handleSendMessage("Exit")
    }), (0, _react.jsx)((0, _buttonDefault.default), {
        icon: fallbackIconBlack,
        themes: [
            "white-pill"
        ],
        className: generalResponseButton,
        text: "System Fallback",
        onClick: ()=>props.handleSendMessage("[Unhandled Response]")
    })))), (0, _react.jsx)((0, _customScrollbarsDefault.default), {
        autoHide: true,
        autoHeight: true,
        autoHeightMax: windowSize.windowSize.innerHeight * .9 - 353
    }, (0, _react.jsx)(Phrases, null, pinnedMessages.map((pm, idx)=>(0, _react.jsx)(Phrase, {
            key: idx
        }, (0, _react.jsx)(PhraseChip, {
            onClick: ()=>props.handleSendMessage(pm.message)
        }, pm.message), (0, _react.jsx)("div", {
            className: "remove-thumbtack",
            onClick: ()=>props.userApplicationPreferencesContainer.deleteSimulatorPinnedMessage(props.applicationId, pm.id)
        }, (0, _react.jsx)("img", {
            src: removeThumbtackIcon
        })))))));
};
const PinnedMessagesHeadingWrapper = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "eyrszst3"
})({
    name: "1urdq9i",
    styles: "padding:0 24px"
});
const Phrases = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "eyrszst2"
})({
    name: "1urdq9i",
    styles: "padding:0 24px"
});
const greenText = /*#__PURE__*/ (0, _css.css)("color:", (0, _colors.color_colors_growth), ";margin-left:0px;", "");
const generalResponseButton = /*#__PURE__*/ (0, _css.css)({
    name: "1prk50",
    styles: "margin-right:8px;margin-left:0px;margin-top:0px"
});
const defaultButtons = /*#__PURE__*/ (0, _css.css)({
    name: "1gkzyv6",
    styles: "margin-top:-15px"
});
const generalResponses = /*#__PURE__*/ (0, _css.css)({
    name: "xj96an",
    styles: "display:flex;display:block"
});
const Phrase = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "eyrszst1"
})({
    name: "1qepch",
    styles: "display:flex;flex-direction:row;width:100%;margin:8 0;cursor:pointer;.remove-thumbtack{height:56px;width:24px;margin-left:8px;img{width:100%;margin-top:16px;}}&:first-of-type{margin-top:24px;}&:last-of-type{margin-bottom:24px;}"
});
const PhraseChip = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "eyrszst0"
})("background:white;border:1px solid ", (0, _colors.silver_four), ";border-radius:8px;width:100%;padding:16px 24px;font-size:14px;line-height:20px;font-weight:400;");
const defaultPinned = /*#__PURE__*/ (0, _css.css)({
    name: "27vn2j",
    styles: "display:flex;flex-direction:row;.defaults-expander{font-family:Muli;font-size:14px;font-weight:normal;font-style:normal;padding-right:5px;font-stretch:normal;line-height:1.43;letter-spacing:normal;cursor:pointer;text-align:left;flex-direction:row;display:flex;padding-bottom:15px;div{margin-right:10px;margin-top:6px;}}"
});
const fill = /*#__PURE__*/ (0, _css.css)("flex:1;&.line{margin-left:5px;border-bottom:solid 1px ", (0, _colors.color_shades_dark), ";margin-bottom:24px;}", "");
const containerStyle = /*#__PURE__*/ (0, _css.css)("padding-top:32px;max-width:432px;font-family:Muli;font-style:normal;font-weight:normal;.title-container{.title{font-size:18px;line-height:24px;padding-bottom:18px;color:", (0, _colors.color_text_default), ";}.subtitle{font-size:14px;line-height:20px;padding-bottom:12px;color:", (0, _colors.color_text_light), ";}}", "");
exports.default = SimulatorPinnedMessagesPanel;

},{"@emotion/styled/base":"lSuFu","@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","../../../constants/colors":"1p3OR","../../../components/general/Button":"6ymxN","../../../components/structure/CustomScrollbars":"50vFq","../../../hooks/UseWindowSize":"43j9z","6bd5954e67168aeb":"8RZxX","860df3755ff4dcb2":"7MgUx","64336cb6e583904":"cIZRM","487e47dc10f26f83":"eam4y","20055cecf1613105":"lHDr5","10245df0001a789d":"9OCAY","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7MgUx":[function(require,module,exports) {
module.exports = require("144a8c12f8d51b1a").getBundleURL("kVLro") + require("181638dbac1200de").resolve("kfzeh");

},{"144a8c12f8d51b1a":"c7Tr5","181638dbac1200de":"fyJL2"}],"4I2H7":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _base = require("@emotion/styled/base");
var _baseDefault = parcelHelpers.interopDefault(_base);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _colors = require("../../../constants/colors");
var _button = require("../../../components/general/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _customScrollbars = require("../../../components/structure/CustomScrollbars");
var _customScrollbarsDefault = parcelHelpers.interopDefault(_customScrollbars);
var _useWindowSize = require("../../../hooks/UseWindowSize");
var _useWindowSizeDefault = parcelHelpers.interopDefault(_useWindowSize);
var _testCaseContainer = require("../../../hooks/TestCaseContainer");
var _testCaseContainerDefault = parcelHelpers.interopDefault(_testCaseContainer);
var _editTestCase = require("../../../components/forms/EditTestCase");
var _editTestCaseDefault = parcelHelpers.interopDefault(_editTestCase);
var _secondaryLoader = require("../../../components/general/SecondaryLoader");
var _secondaryLoaderDefault = parcelHelpers.interopDefault(_secondaryLoader);
var _searchField = require("../../../components/forms/SearchField");
var _searchFieldDefault = parcelHelpers.interopDefault(_searchField);
var _checkboxField = require("../../../components/forms/CheckboxField");
var _checkboxFieldDefault = parcelHelpers.interopDefault(_checkboxField);
var _tooltipWrapper = require("../../../components/general/TooltipWrapper");
var _tooltipWrapperDefault = parcelHelpers.interopDefault(_tooltipWrapper);
var _deleteConfirmation = require("../../featureContent/components/DeleteConfirmation");
var _deleteConfirmationDefault = parcelHelpers.interopDefault(_deleteConfirmation);
var _confirmationDialog = require("../../../components/structure/ConfirmationDialog");
var _confirmationDialogDefault = parcelHelpers.interopDefault(_confirmationDialog);
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const removeIcon = require("8c6361aa85759150");
const copyIcon = require("9944d2b18ca67713");
const arrowRight = require("fdda2da9c9d3fb66");
const refresh = require("92f245649ce4a64b");
const greenPowerIcon = require("b1d0a74b6bd21962");
const SimulatorTestCasesPanel = (props)=>{
    const windowSize = (0, _useWindowSizeDefault.default)();
    const testCaseContainer = (0, _testCaseContainerDefault.default).useContainer();
    const [testCase, setTestCase] = (0, _react1.useState)(null);
    const [checkedCases, setCheckedCases] = (0, _react1.useState)([]);
    const [search, setSearch] = (0, _react1.useState)("");
    const [nameToDelete, setNameToDelete] = (0, _react1.useState)("");
    const [contentItemIdToDelete, setContentItemIdToDelete] = (0, _react1.useState)("");
    (0, _react1.useEffect)(()=>{
        if (props.contentItemId?.length > 0) testCaseContainer.loadAppLevelTestCase(props.applicationId, props.contentItemId);
        else testCaseContainer.loadAppLevelTestCases(props.applicationId);
    }, []);
    (0, _react1.useEffect)(()=>{
        const runTestCaseSimulation = async ()=>{
            if (sessionStorage.getItem("testCaseToSimulate") !== null) {
                const testCase = JSON.parse(sessionStorage.getItem("testCaseToSimulate"));
                await simulateCase(testCase.name, testCase?.contentItemId);
                sessionStorage.removeItem("testCaseToSimulate");
            }
        };
        runTestCaseSimulation();
    }, []);
    const confirmDelete = ()=>{
        if (nameToDelete) testCaseContainer.deleteAppLevelTestCase(props.applicationId, nameToDelete, contentItemIdToDelete).then(()=>{
            setNameToDelete("");
            testCaseContainer.loadAppLevelTestCases(props.applicationId);
        });
    };
    const getContentItemFromSessionAttributes = (testCase)=>{
        const turns = testCase?.sessionState?.sessionAttributes?.["conversationTurnHistoryState"]?.["TurnHistory"];
        const contentItemId = Array.isArray(turns) && turns.length > 0 ? turns[turns.length - 1]?.["ContentId"] : null;
        return contentItemId;
    };
    const closeDeleteConfirmation = ()=>{
        setNameToDelete("");
    };
    const simulateCase = async (name1, contentItemId)=>{
        const testCase = await testCaseContainer.loadAppLevelTestCase(props.applicationId, name1, contentItemId);
        if (testCase) props.simulateTestCase(testCase);
    };
    const editTestCase = async (name1, contentItemId)=>{
        const testCase = await testCaseContainer.loadAppLevelTestCase(props.applicationId, name1, contentItemId);
        if (testCase) setTestCase(testCase);
    };
    const getTestCaseColor = (name1)=>{
        const testCaseResults = testCaseContainer.testCaseResults;
        if (testCaseResults && testCaseResults[name1]) {
            if (Object.keys(testCaseResults[name1]).some((k)=>testCaseResults[name1][k]?.toLowerCase() !== "true")) return "red";
            return "green";
        } else return "";
    };
    const isLoadingCase = (name1)=>{
        if (testCaseContainer.runningTests?.length && testCaseContainer.runningTests.includes(name1)) {
            const testCaseResults = testCaseContainer.testCaseResults;
            if (testCaseResults && testCaseResults[name1]) return false;
            return true;
        } else return false;
    };
    const handleSearch = (searchEvent)=>{
        setSearch(searchEvent.target.value);
    };
    const updateAvailableTestCases = (newTestCase)=>{
        testCaseContainer.createTestCase(props.applicationId, newTestCase);
        if (!(newTestCase?.contentItemId?.length > 0)) {
            const newAvailableTestCases = {
                ...testCaseContainer.availableTestCases,
                applicationTestCases: [
                    ...testCaseContainer.availableTestCases?.applicationTestCases,
                    newTestCase.name
                ]
            };
            testCaseContainer.setAvailableTestCases(newAvailableTestCases);
        } else {
            const newAvailableTestCases = {
                ...testCaseContainer.availableTestCases,
                contentItemTestCases: {
                    ...testCaseContainer.availableTestCases.contentItemTestCases,
                    [newTestCase.contentItemId]: [
                        ...testCaseContainer.availableTestCases?.contentItemTestCases[newTestCase.contentItemId],
                        newTestCase.name
                    ]
                }
            };
            testCaseContainer.setAvailableTestCases(newAvailableTestCases);
        }
    };
    let testCases = testCaseContainer.gatherAllTestCases();
    let testCaseIds = testCaseContainer.getContentItemIdList(testCaseContainer?.availableTestCases?.applicationTestCases?.length ?? 0, testCaseContainer?.availableTestCases?.contentItemTestCases ?? {});
    if (search?.length) {
        testCases = [];
        testCaseIds = [];
        const allTestCases = testCaseContainer.gatherAllTestCases();
        const allTestCaseIds = testCaseContainer.getContentItemIdList(testCaseContainer.availableTestCases.applicationTestCases.length, testCaseContainer.availableTestCases.contentItemTestCases);
        for(var i = 0; i < allTestCases.length; i++){
            const c = allTestCases[i];
            if (c.toLowerCase().includes(search.toLowerCase())) {
                testCases.push(c);
                testCaseIds.push(allTestCaseIds[i]);
            }
        }
    }
    let combined = testCases.map((name1, i)=>({
            name: name1,
            id: testCaseIds[i]
        }));
    // alphabetically sort test casess
    combined = combined.sort((a, b)=>a.name.localeCompare(b.name));
    testCases = combined.map((c)=>c.name);
    testCaseIds = combined.map((c)=>c.id);
    return (0, _react.jsx)("div", {
        className: containerStyle
    }, (0, _react.jsx)(TestCaseHeadingWrapper, null, (0, _react.jsx)("div", {
        className: "title-container"
    }, (0, _react.jsx)("div", {
        className: "title"
    }, "Test Cases")), (0, _react.jsx)(RestartButton, {
        themes: [
            "white-pill"
        ],
        text: "Restart Session",
        onClick: ()=>props.handleStartNewSession()
    }), (0, _react.jsx)(StyledTopButton, {
        themes: [
            "white-pill"
        ],
        text: "Run All",
        onClick: ()=>testCaseContainer.runAppLevelTestCases()
    }), checkedCases?.length ? (0, _react.jsx)(StyledTopButton, {
        themes: [
            "white-pill"
        ],
        text: "Run Checked",
        onClick: ()=>testCaseContainer.runAppLevelTestCases(checkedCases)
    }) : (0, _react.jsx)((0, _reactDefault.default).Fragment, null), (0, _react.jsx)(SearchRow, null, (0, _react.jsx)(SearchCheckbox, {
        key: `check.${name}`,
        checked: testCases?.length && testCases.every((tc)=>checkedCases.includes(tc)),
        onClick: (e)=>{
            if (testCases?.length) {
                if (testCases.every((tc)=>checkedCases.includes(tc))) setCheckedCases([]);
                else setCheckedCases([
                    ...testCases
                ]);
            }
        },
        label: ""
    }), (0, _react.jsx)(CustomSearch, {
        id: "1",
        name: "searchField",
        placeholder: "Search for a test case",
        disabled: false,
        onChange: handleSearch
    }))), (0, _react.jsx)((0, _customScrollbarsDefault.default), {
        autoHide: true,
        autoHeight: true,
        autoHeightMax: windowSize.windowSize.innerHeight * .9 - 175
    }, (0, _react.jsx)(Phrases, null, testCases.map((name1, idx)=>(0, _react.jsx)(Phrase, {
            key: idx
        }, (0, _react.jsx)(StyledCheckbox, {
            key: `check.${name1}`,
            checked: checkedCases.includes(name1),
            onClick: (e)=>{
                if (checkedCases.includes(name1)) setCheckedCases(checkedCases.filter((c)=>c !== name1));
                else setCheckedCases([
                    ...checkedCases,
                    name1
                ]);
            },
            label: ""
        }), isLoadingCase(name1) ? (0, _react.jsx)(TestCaseChip, {
            className: getTestCaseColor(name1),
            onClick: ()=>editTestCase(name1, testCaseIds[idx])
        }, (0, _react.jsx)((0, _secondaryLoaderDefault.default), null)) : (0, _react.jsx)(TestCaseChip, {
            className: getTestCaseColor(name1),
            onClick: ()=>editTestCase(name1, testCaseIds[idx])
        }, name1), (0, _react.jsx)((0, _tooltipWrapperDefault.default), {
            place: "top",
            text: "Delete"
        }, (0, _react.jsx)("div", {
            className: "remove-thumbtack",
            onClick: ()=>{
                setNameToDelete(name1);
                setContentItemIdToDelete(testCaseIds[idx]);
            }
        }, (0, _react.jsx)("img", {
            src: removeIcon
        }))), (0, _react.jsx)((0, _tooltipWrapperDefault.default), {
            place: "top",
            text: "Copy"
        }, (0, _react.jsx)("div", {
            className: "remove-thumbtack",
            onClick: async ()=>{
                const testCase = await testCaseContainer.loadAppLevelTestCase(props.applicationId, name1, testCaseIds[idx]);
                if (testCase) testCase.name = testCase.name + "-copy";
                updateAvailableTestCases(testCase);
            }
        }, (0, _react.jsx)("img", {
            src: copyIcon
        }))), (0, _react.jsx)((0, _tooltipWrapperDefault.default), {
            place: "top",
            text: "Run"
        }, (0, _react.jsx)("div", {
            className: "remove-thumbtack",
            onClick: ()=>{
                testCaseContainer.runAppLevelTestCases([
                    name1
                ]);
            }
        }, (0, _react.jsx)("img", {
            src: refresh
        }))), (0, _react.jsx)((0, _tooltipWrapperDefault.default), {
            place: "top",
            text: "Try in simulator"
        }, (0, _react.jsx)("div", {
            className: "remove-thumbtack",
            onClick: async ()=>{
                await simulateCase(name1, testCaseIds[idx]);
            }
        }, (0, _react.jsx)("img", {
            src: arrowRight
        }))))))), testCase != null ? (0, _react.jsx)((0, _editTestCaseDefault.default), {
        initialValue: testCase,
        onSave: async (tc)=>{
            await testCaseContainer.deleteAppLevelTestCase(props.applicationId, testCase.name, testCase?.contentItemId);
            await testCaseContainer.createTestCase(props.applicationId, tc);
            testCaseContainer.loadAppLevelTestCases(props.applicationId);
            setTestCase(null);
        },
        onClose: ()=>setTestCase(null),
        isContentItemView: false
    }) : (0, _react.jsx)((0, _reactDefault.default).Fragment, null), nameToDelete?.length ? (0, _react.jsx)((0, _confirmationDialogDefault.default), {
        title: "Delete",
        deleteText: "Yes, Delete",
        isLoading: testCaseContainer.loading,
        onClose: ()=>closeDeleteConfirmation(),
        onConfirm: ()=>confirmDelete()
    }, (0, _react.jsx)((0, _deleteConfirmationDefault.default), {
        itemLabel: ` this test case? ${nameToDelete}`
    })) : (0, _react.jsx)((0, _reactDefault.default).Fragment, null));
};
const SearchRow = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1fgpe319"
})({
    name: "ho1qnd",
    styles: "display:flex;flex-direction:row"
});
const TestCaseHeadingWrapper = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1fgpe318"
})({
    name: "edg7se",
    styles: "padding:0 20px 0px 24px"
});
const Phrases = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1fgpe317"
})({
    name: "1xhbqog",
    styles: "padding:0 24px;padding-bottom:40px"
});
const Phrase = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1fgpe316"
})({
    name: "1ycoc4z",
    styles: "display:flex;flex-direction:row;align-items:center;width:100%;margin:8px 0;cursor:pointer;.remove-thumbtack{width:24px;margin-left:8px;img{width:100%;margin-top:10px;}}&:first-of-type{margin-top:16px;}&:last-of-type{margin-bottom:16px;}"
});
const CustomSearch = /*#__PURE__*/ (0, _baseDefault.default)((0, _searchFieldDefault.default), {
    target: "e1fgpe315"
})({
    name: "xkolyu",
    styles: "margin-bottom:0px;div>.field-container{height:32px;box-shadow:none;border-radius:8px;}"
});
const StyledTopButton = /*#__PURE__*/ (0, _baseDefault.default)((0, _buttonDefault.default), {
    target: "e1fgpe314"
})({
    name: "1j4g0ki",
    styles: "margin-top:0px;margin-bottom:8px;margin-right:8px;margin-left:0px"
});
const TestCaseChip = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1fgpe313"
})("&.red{background:", (0, _colors.pastel_red), ";}&.green{background:", (0, _colors.pastel_green), ";}overflow:hidden;background:white;border:1px solid ", (0, _colors.silver_four), ";border-radius:8px;width:100%;padding:6px 16px;font-size:14px;line-height:20px;font-weight:400;.spinner>div{background-color:", (0, _colors.color_colors_ocean), ";}.spinner{height:24px;margin-top:-3px;}");
const StyledCheckbox = /*#__PURE__*/ (0, _baseDefault.default)((0, _checkboxFieldDefault.default), {
    target: "e1fgpe312"
})({
    name: "1soh0gv",
    styles: "margin-top:4px"
});
const SearchCheckbox = /*#__PURE__*/ (0, _baseDefault.default)((0, _checkboxFieldDefault.default), {
    target: "e1fgpe311"
})({
    name: "xda5ep",
    styles: "margin-top:12px"
});
const containerStyle = /*#__PURE__*/ (0, _css.css)("padding-top:32px;max-width:432px;font-family:Muli;font-style:normal;font-weight:normal;.title-container{.title{font-size:18px;line-height:24px;padding-bottom:18px;color:", (0, _colors.color_text_default), ";}.subtitle{font-size:14px;line-height:20px;padding-bottom:12px;color:", (0, _colors.color_text_light), ";}}", "");
const RestartButton = /*#__PURE__*/ (0, _baseDefault.default)(StyledTopButton, {
    target: "e1fgpe310"
})("color:", (0, _colors.color_colors_growth), ";");
exports.default = SimulatorTestCasesPanel;

},{"@emotion/styled/base":"lSuFu","@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","../../../constants/colors":"1p3OR","../../../components/general/Button":"6ymxN","../../../components/structure/CustomScrollbars":"50vFq","../../../hooks/UseWindowSize":"43j9z","../../../hooks/TestCaseContainer":"cLg3U","../../../components/forms/EditTestCase":"ePcs7","../../../components/general/SecondaryLoader":"7zJiF","../../../components/forms/SearchField":"aU10T","../../../components/forms/CheckboxField":"3S5Oy","../../../components/general/TooltipWrapper":"53pWd","../../featureContent/components/DeleteConfirmation":"9xK2d","../../../components/structure/ConfirmationDialog":"kx7yK","8c6361aa85759150":"agq6G","9944d2b18ca67713":"1S0DP","fdda2da9c9d3fb66":"4D83Y","92f245649ce4a64b":"9akQy","b1d0a74b6bd21962":"8RZxX","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"ggifZ":[function(require,module,exports) {
module.exports = require("27892e293959572e").getBundleURL("kVLro") + require("f7876140d77d15e6").resolve("cud1U");

},{"27892e293959572e":"c7Tr5","f7876140d77d15e6":"fyJL2"}],"aVRuD":[function(require,module,exports) {
module.exports = require("fbc3366329f1433c").getBundleURL("kVLro") + require("ee2feaca6f55f6d2").resolve("3P8v4");

},{"fbc3366329f1433c":"c7Tr5","ee2feaca6f55f6d2":"fyJL2"}],"3hXyd":[function(require,module,exports) {
module.exports = require("cec8a23773a436cf").getBundleURL("kVLro") + require("356541e9155801a0").resolve("idboF");

},{"cec8a23773a436cf":"c7Tr5","356541e9155801a0":"fyJL2"}],"k74xV":[function(require,module,exports) {
module.exports = require("cd12ad5d16785648").getBundleURL("kVLro") + require("9c34b07c8d945826").resolve("jzOmp");

},{"cd12ad5d16785648":"c7Tr5","9c34b07c8d945826":"fyJL2"}],"7K1Sf":[function(require,module,exports) {
module.exports = require("aa8c1d96bfc64407").getBundleURL("kVLro") + require("79f46b6e951be9a9").resolve("c9PMx");

},{"aa8c1d96bfc64407":"c7Tr5","79f46b6e951be9a9":"fyJL2"}],"b8Mu1":[function(require,module,exports) {
module.exports = require("a481c7c004c816a3").getBundleURL("kVLro") + require("58282808e6e71984").resolve("8CddP");

},{"a481c7c004c816a3":"c7Tr5","58282808e6e71984":"fyJL2"}],"a7vuP":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _tabContainerPanel = require("../../../components/structure/Panels/TabContainerPanel");
var _tabContainerPanelDefault = parcelHelpers.interopDefault(_tabContainerPanel);
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _reactTabs = require("react-tabs");
var _css = require("@emotion/css");
var _simulatorConversationHistory = require("./SimulatorConversationHistory");
var _simulatorConversationHistoryDefault = parcelHelpers.interopDefault(_simulatorConversationHistory);
var _scrollablePanelBody = require("../../../components/structure/ScrollablePanelBody");
var _scrollablePanelBodyDefault = parcelHelpers.interopDefault(_scrollablePanelBody);
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const historyIcon = require("7d83b40f706b85a7");
const historyIconBlue = require("7cb3a13fc421aab4");
const SimulatorOutputPanel = ({ conversationHistory, contentItems, viewOnly })=>(0, _react.jsx)((0, _tabContainerPanelDefault.default), {
        tabs: [
            {
                title: "History",
                icon: historyIcon,
                selectedIcon: historyIconBlue,
                className: "ac-simulator-history"
            }
        ],
        className: containerStyle
    }, (0, _react.jsx)((0, _reactTabs.TabPanel), null, (0, _react.jsx)((0, _scrollablePanelBodyDefault.default), null, (0, _react.jsx)((0, _simulatorConversationHistoryDefault.default), {
        conversationHistory: conversationHistory,
        contentItems: contentItems
    }))));
const containerStyle = /*#__PURE__*/ (0, _css.css)({
    name: "1agss7c",
    styles: "width:432px;max-width:432px;height:100%;max-height:100%;overflow-y:hidden;flex:1"
});
exports.default = SimulatorOutputPanel;

},{"@emotion/react":"djZKr","../../../components/structure/Panels/TabContainerPanel":"iDHIJ","react":"6uln9","react-tabs":"92Sgf","@emotion/css":"awUBr","./SimulatorConversationHistory":"jXeso","../../../components/structure/ScrollablePanelBody":"6LRg3","7d83b40f706b85a7":"jDgmn","7cb3a13fc421aab4":"lfd3D","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jXeso":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _css = require("@emotion/css");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _simulatorConversationHistoryItem = require("./SimulatorConversationHistoryItem");
var _simulatorConversationHistoryItemDefault = parcelHelpers.interopDefault(_simulatorConversationHistoryItem);
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const SimulatorConversationHistory = (props)=>(0, _react.jsx)("div", {
        className: containerStyle
    }, props.contentItems?.map((c, i)=>{
        return (0, _react.jsx)((0, _simulatorConversationHistoryItemDefault.default), {
            key: i,
            turn: props.conversationHistory?.TurnHistory?.find((h)=>h.ContentId === c.id),
            content: c,
            index: i
        });
    }));
const containerStyle = /*#__PURE__*/ (0, _css.css)({
    name: "cbllux",
    styles: "display:flex;padding:24px;padding-bottom:56px;flex-direction:column"
});
exports.default = SimulatorConversationHistory;

},{"@emotion/react":"djZKr","@emotion/css":"awUBr","react":"6uln9","./SimulatorConversationHistoryItem":"kbMTK","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jDgmn":[function(require,module,exports) {
module.exports = require("4f596a74d095ef67").getBundleURL("kVLro") + require("92913ab4b5c6908").resolve("iMLnO");

},{"4f596a74d095ef67":"c7Tr5","92913ab4b5c6908":"fyJL2"}],"lfd3D":[function(require,module,exports) {
module.exports = require("91ef8adb393f3221").getBundleURL("kVLro") + require("466bdb7df13eab36").resolve("kgc0W");

},{"91ef8adb393f3221":"c7Tr5","466bdb7df13eab36":"fyJL2"}],"kqidT":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _panelContainer = require("../../components/structure/Panels/PanelContainer");
var _panelContainerDefault = parcelHelpers.interopDefault(_panelContainer);
var _tabContainerPanel = require("../../components/structure/Panels/TabContainerPanel");
var _tabContainerPanelDefault = parcelHelpers.interopDefault(_tabContainerPanel);
var _reactTabs = require("react-tabs");
var _scrollablePanelBody = require("../../components/structure/ScrollablePanelBody");
var _scrollablePanelBodyDefault = parcelHelpers.interopDefault(_scrollablePanelBody);
var _collapsingPanel = require("../../components/structure/Panels/CollapsingPanel");
var _collapsingPanelDefault = parcelHelpers.interopDefault(_collapsingPanel);
var _collapsedMenuPanel = require("../../components/structure/CollapsedMenuPanel");
var _collapsedMenuPanelDefault = parcelHelpers.interopDefault(_collapsedMenuPanel);
var _expandedMenuPanel = require("../../components/structure/ExpandedMenuPanel");
var _expandedMenuPanelDefault = parcelHelpers.interopDefault(_expandedMenuPanel);
var _colors = require("../../constants/colors");
var _appliedAppTemplateMenu = require("./components/AppliedAppTemplateMenu");
var _appliedAppTemplateMenuDefault = parcelHelpers.interopDefault(_appliedAppTemplateMenu);
var _templateListItem = require("./components/TemplateListItem");
var _templateListItemDefault = parcelHelpers.interopDefault(_templateListItem);
var _customScrollbars = require("../../components/structure/CustomScrollbars");
var _customScrollbarsDefault = parcelHelpers.interopDefault(_customScrollbars);
var _applicationContentMenuPanel = require("../applicationContentMenuPanel");
var _applicationContentMenuPanelDefault = parcelHelpers.interopDefault(_applicationContentMenuPanel);
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const templatesIcon = require("820fcd4e56d4c934");
const templatesBlueIcon = require("24af934c139c540d");
const completeIcon = require("2c101b521ac3c854");
const readyIcon = require("1d8ece6e57492bc0");
const incompleteIcon = require("8ad3421dc509cfa4");
const notEnabledIcon = require("a03a8972cd377512");
class ApplicationAppliedTemplates extends (0, _reactDefault.default).Component {
    constructor(props){
        super(props);
        this.state = {
            isLeftExpanded: localStorage.getItem("contentMenu") == "true",
            selectedMenuIndex: 0
        };
    }
    componentDidMount() {
        this.props.templateConfigurationContainer.getAvailableTemplates(this.props.appContainer.state.organizationId);
    }
    handleToggleExpandLeft(e, expanded) {
        this.setState({
            ...this.state,
            isLeftExpanded: expanded
        });
        localStorage.setItem("contentMenu", expanded?.toString());
        e?.stopPropagation();
    }
    setContentMenuIndex(index) {
        this.setState({
            ...this.state,
            selectedMenuIndex: index
        });
    }
    getStatusIcon(status) {
        if (status == "incomplete") return incompleteIcon;
        if (status == "complete") return readyIcon;
        return completeIcon;
    }
    getStatusLabel(status) {
        switch(status){
            case "synced":
                return "In Use";
            case "complete":
                return "Ready";
            case "incomplete":
                return "Incomplete";
        }
    }
    renderMenu() {
        return (0, _react.jsx)((0, _tabContainerPanelDefault.default), {
            tabs: [
                {
                    title: "Templates",
                    icon: templatesIcon,
                    selectedIcon: templatesBlueIcon
                }
            ],
            onTabSelected: (newIndex)=>{
                this.setContentMenuIndex(newIndex);
            },
            selectedIndex: this.state.selectedMenuIndex
        }, (0, _react.jsx)((0, _reactTabs.TabPanel), null, (0, _react.jsx)((0, _scrollablePanelBodyDefault.default), {
            className: panelBodyStyle
        }, (0, _react.jsx)((0, _appliedAppTemplateMenuDefault.default), {
            history: this.props.history,
            applicationId: this.props.applicationId,
            appContainer: this.props.appContainer,
            appliedAppTemplateContainer: this.props.appliedAppTemplateContainer
        }))));
    }
    render() {
        const appliedTemplates = this.props.appliedAppTemplateContainer.getLoadedTemplatesForApp(this.props.applicationId);
        const availableTemplateConfigurations = this.props.templateConfigurationContainer.state.availableTemplates?.filter((tc)=>!appliedTemplates?.some((a)=>a.templateForm?.templateConfigurationId == tc.id));
        return (0, _react.jsx)((0, _panelContainerDefault.default), {
            className: containerStyle
        }, this.props.hasFullMenu ? (0, _react.jsx)((0, _applicationContentMenuPanelDefault.default), {
            history: this.props.history,
            application: this.props.appContainer.state.currentApp
        }) : (0, _react.jsx)("div", {
            className: `${menuStyle} ${this.state.isLeftExpanded ? "expanded" : "collapsed"}`
        }, (0, _react.jsx)("div", {
            className: "fixed-wrapper"
        }, (0, _react.jsx)((0, _collapsingPanelDefault.default), {
            isCollapsed: !this.state.isLeftExpanded,
            collapsedView: (0, _react.jsx)((0, _collapsedMenuPanelDefault.default), {
                onExpand: (e)=>this.handleToggleExpandLeft(e, true),
                expandedViewRender: this.renderMenu.bind(this)
            }),
            expandedView: (0, _react.jsx)((0, _expandedMenuPanelDefault.default), {
                onCollapse: (e)=>this.handleToggleExpandLeft(e, false),
                expandedViewRender: this.renderMenu.bind(this)
            })
        }))), (0, _react.jsx)((0, _customScrollbarsDefault.default), null, (0, _react.jsx)("div", {
            className: `templates-list ${this.state.isLeftExpanded ? "expanded-view" : ""}`
        }, appliedTemplates.length > 0 && (0, _react.jsx)("h3", null, "Enabled Template"), appliedTemplates?.map((at, idx)=>(0, _react.jsx)((0, _templateListItemDefault.default), {
                key: idx,
                templateConfiguration: at.templateForm.templateConfiguration,
                applied: true,
                applicationId: this.props.applicationId,
                icon: this.getStatusIcon(this.props.appliedAppTemplateContainer.getCurrentStatus(at)),
                status: this.getStatusLabel(this.props.appliedAppTemplateContainer.getCurrentStatus(at)),
                appliedAppTemplate: at
            })), availableTemplateConfigurations.length > 0 && (0, _react.jsx)("h3", null, "All Available Templates"), availableTemplateConfigurations?.map((tc, idx)=>(0, _react.jsx)((0, _templateListItemDefault.default), {
                key: idx,
                templateConfiguration: tc,
                applied: false,
                icon: notEnabledIcon,
                status: "Not Enabled",
                applicationId: this.props.applicationId
            })))));
    }
}
const containerStyle = /*#__PURE__*/ (0, _css.css)("width:100%;background:", (0, _colors.color_variants_main_bg), ";.form-wrapper{flex:1;min-width:600px;}.empty-indicator{width:100%;height:100%;display:flex;align-items:center;justify-content:center;}.templates-list{padding:32px;h3{margin:32px;font-family:Muli;font-style:normal;font-weight:normal;font-size:18px;line-height:24px;color:", (0, _colors.color_shades_darkest), ";}}", "");
const panelBodyStyle = /*#__PURE__*/ (0, _css.css)({
    name: "zbunnm",
    styles: "padding-top:0;min-height:100%"
});
const menuStyle = /*#__PURE__*/ (0, _css.css)("z-index:2;bottom:0;position:relative;&.collapsed{width:80px;.fixed-wrapper{width:80px;}}&.expanded{width:288px;.fixed-wrapper{width:288px;}}.fixed-wrapper{position:fixed;bottom:0;height:calc(100vh - 80px);background:white;border-right:1px solid ", (0, _colors.color_shades_dark), ";box-sizing:border-box;}", "");
exports.default = ApplicationAppliedTemplates;

},{"@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","../../components/structure/Panels/PanelContainer":"9R2lE","../../components/structure/Panels/TabContainerPanel":"iDHIJ","react-tabs":"92Sgf","../../components/structure/ScrollablePanelBody":"6LRg3","../../components/structure/Panels/CollapsingPanel":"jVPoD","../../components/structure/CollapsedMenuPanel":"1mVIj","../../components/structure/ExpandedMenuPanel":"30h7k","../../constants/colors":"1p3OR","./components/AppliedAppTemplateMenu":"fbZUw","./components/TemplateListItem":"khR9z","../../components/structure/CustomScrollbars":"50vFq","../applicationContentMenuPanel":"12n7P","820fcd4e56d4c934":"HOrVq","24af934c139c540d":"jKOUt","2c101b521ac3c854":"7CQ2Y","1d8ece6e57492bc0":"cbVjq","8ad3421dc509cfa4":"4oiDX","a03a8972cd377512":"71Ovv","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"fbZUw":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _activeTemplateSelector = require("./ActiveTemplateSelector");
var _activeTemplateSelectorDefault = parcelHelpers.interopDefault(_activeTemplateSelector);
class AppliedAppTemplateMenu extends (0, _reactDefault.default).Component {
    render() {
        return (0, _react.jsx)("div", {
            className: containerStyle
        }, (0, _react.jsx)((0, _activeTemplateSelectorDefault.default), {
            appliedTemplates: this.props.appliedAppTemplateContainer.getLoadedTemplatesForApp(this.props.applicationId),
            activeAppliedTemplate: this.props.appliedAppTemplateContainer.state.appliedTemplates.find((at)=>at.id == this.props.currentAppliedTemplateId)
        }));
    }
}
const containerStyle = /*#__PURE__*/ (0, _css.css)("", "");
exports.default = AppliedAppTemplateMenu;

},{"@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","./ActiveTemplateSelector":"9uqv7","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9uqv7":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _colors = require("../../../constants/colors");
var _reactRouterDom = require("react-router-dom");
const templatesIcon = require("2ffa56c45eb3c84a");
class ActiveTemplateSelector extends (0, _reactDefault.default).Component {
    constructor(props){
        super(props);
        this.state = {
            isExpanded: false
        };
    }
    toggleExpand() {
        this.setState({
            ...this.state,
            isExpanded: !this.state.isExpanded
        });
    }
    render() {
        return (0, _react.jsx)("div", {
            className: containerStyle
        }, (0, _react.jsx)("p", {
            className: "selector-label"
        }, !this.props.appliedTemplates || this.props.appliedTemplates.length == 0 ? "No templates were used in this app" : "Enabled Templates"), this.props.appliedTemplates.map((t)=>(0, _react.jsx)((0, _reactRouterDom.Link), {
                key: t.id,
                className: `template-item ${t.id == this.props.activeAppliedTemplate?.id ? "active" : ""}`,
                to: `/v/apps/${t?.appliedApplicationId}/templates/${t?.id}`
            }, (0, _react.jsx)("img", {
                src: templatesIcon
            }), (0, _react.jsx)("p", null, t.templateForm.templateConfiguration.name))));
    }
}
const containerStyle = /*#__PURE__*/ (0, _css.css)(".selector-label{color:", (0, _colors.color_text_light), ";font-style:italic;font-weight:normal;font-size:14px;line-height:20px;margin:24px 24px 16px 24px;}.template-item{display:flex;align-items:center;height:32px;padding:0 24px;cursor:pointer;p{margin:0 8px;font-style:normal;font-weight:normal;font-size:14px;line-height:20px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;color:", (0, _colors.color_text_default), ";}img{width:16px;height:16px;}&.active{background:", (0, _colors.color_variants_ocean_light_1), ";}}", "");
exports.default = ActiveTemplateSelector;

},{"@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","../../../constants/colors":"1p3OR","react-router-dom":"5fzqq","2ffa56c45eb3c84a":"bOjIf","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"khR9z":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _reactRouterDom = require("react-router-dom");
var _colors = require("../../../constants/colors");
class TemplateListItem extends (0, _reactDefault.default).Component {
    render() {
        const props = {
            ...this.props
        };
        const link = props.applied ? `/v/apps/${this.props.applicationId}/templates/${props.appliedAppTemplate.id}` : `/v/apps/${props.applicationId}/templates/new/${props.templateConfiguration.id}`;
        return (0, _react.jsx)((0, _reactRouterDom.Link), {
            to: link,
            className: containerStyle
        }, (0, _react.jsx)("div", {
            className: "image-container"
        }, (0, _react.jsx)("img", {
            src: props.templateConfiguration.imageUrl
        })), (0, _react.jsx)("h3", null, props.templateConfiguration.name), (0, _react.jsx)("p", {
            className: `${props.applied ? "" : "italic"} right`
        }, props.status), (0, _react.jsx)("img", {
            className: "end-icon",
            src: props.icon
        }));
    }
}
const containerStyle = /*#__PURE__*/ (0, _css.css)("margin:16px 32px;border-radius:8px;background:white;border:1px solid ", (0, _colors.color_shades_dark), ";display:flex;flex-direction:row;align-items:center;.image-container{padding:8px;border-right:1px solid ", (0, _colors.color_shades_dark), ";width:160px;position:relative;height:88px;img{max-width:144;max-height:72px;margin:auto;position:absolute;top:50%;left:50%;transform:translate(-50%, -50%);}}p{color:", (0, _colors.color_shades_darker), ";font-family:Muli;font-style:normal;font-weight:normal;font-size:14px;line-height:20px;&.italic{font-style:italic;}&.right{margin-left:auto;margin-right:8px;}}.end-icon{margin-right:32px;width:24px;height:24px;}", "");
exports.default = TemplateListItem;

},{"@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","react-router-dom":"5fzqq","../../../constants/colors":"1p3OR","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"HOrVq":[function(require,module,exports) {
module.exports = require("78cf2091b3638349").getBundleURL("kVLro") + require("ab7dd15d2413598d").resolve("g3Fss");

},{"78cf2091b3638349":"c7Tr5","ab7dd15d2413598d":"fyJL2"}],"jKOUt":[function(require,module,exports) {
module.exports = require("7faf433144f938eb").getBundleURL("kVLro") + require("77093dab62544c1a").resolve("eOR26");

},{"7faf433144f938eb":"c7Tr5","77093dab62544c1a":"fyJL2"}],"7CQ2Y":[function(require,module,exports) {
module.exports = require("abc60de55dc07ef3").getBundleURL("kVLro") + require("89bf182c90cae90c").resolve("eUeJN");

},{"abc60de55dc07ef3":"c7Tr5","89bf182c90cae90c":"fyJL2"}],"cbVjq":[function(require,module,exports) {
module.exports = require("e6528beb1bd316cb").getBundleURL("kVLro") + require("ad705d513b9c18fe").resolve("VWeFp");

},{"e6528beb1bd316cb":"c7Tr5","ad705d513b9c18fe":"fyJL2"}],"4oiDX":[function(require,module,exports) {
module.exports = require("30e7e90c2cbe51c9").getBundleURL("kVLro") + require("7170bb7507438b12").resolve("214yc");

},{"30e7e90c2cbe51c9":"c7Tr5","7170bb7507438b12":"fyJL2"}],"71Ovv":[function(require,module,exports) {
module.exports = require("782e2d429ce71506").getBundleURL("kVLro") + require("ee3e294eca61733b").resolve("6kzFp");

},{"782e2d429ce71506":"c7Tr5","ee3e294eca61733b":"fyJL2"}],"hHRLs":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _panelContainer = require("../../components/structure/Panels/PanelContainer");
var _panelContainerDefault = parcelHelpers.interopDefault(_panelContainer);
var _pageContainer = require("../../components/structure/PageContainer");
var _pageContainerDefault = parcelHelpers.interopDefault(_pageContainer);
var _confirmationDialog = require("../../components/structure/ConfirmationDialog");
var _confirmationDialogDefault = parcelHelpers.interopDefault(_confirmationDialog);
var _loader = require("../../components/general/Loader");
var _loaderDefault = parcelHelpers.interopDefault(_loader);
var _customScrollbars = require("../../components/structure/CustomScrollbars");
var _customScrollbarsDefault = parcelHelpers.interopDefault(_customScrollbars);
var _selectionOptionsToolbar = require("../../components/general/SelectionOptionsToolbar");
var _selectionOptionsToolbarDefault = parcelHelpers.interopDefault(_selectionOptionsToolbar);
var _webhookToolbar = require("./components/WebhookToolbar");
var _webhookToolbarDefault = parcelHelpers.interopDefault(_webhookToolbar);
var _deleteConfirmation = require("../featureContent/components/DeleteConfirmation");
var _deleteConfirmationDefault = parcelHelpers.interopDefault(_deleteConfirmation);
var _webhooksSidePanel = require("./components/WebhooksSidePanel");
var _webhooksSidePanelDefault = parcelHelpers.interopDefault(_webhooksSidePanel);
var _webhookList = require("./components/WebhookList");
var _webhookListDefault = parcelHelpers.interopDefault(_webhookList);
var _webhookFolderSelector = require("./components/WebhookFolderSelector");
var _webhookFolderSelectorDefault = parcelHelpers.interopDefault(_webhookFolderSelector);
var _webhookForm = require("./components/WebhookForm");
var _webhookFormDefault = parcelHelpers.interopDefault(_webhookForm);
var _orphanedWebhooksHeader = require("./components/OrphanedWebhooksHeader");
var _orphanedWebhooksHeaderDefault = parcelHelpers.interopDefault(_orphanedWebhooksHeader);
var _orphanedWebhooksModal = require("./components/OrphanedWebhooksModal");
var _orphanedWebhooksModalDefault = parcelHelpers.interopDefault(_orphanedWebhooksModal);
var _importFileDialog = require("../../components/general/ImportFileDialog");
var _importFileDialogDefault = parcelHelpers.interopDefault(_importFileDialog);
const homeIcon = require("5a4f27ea309aaff0");
const folderIcon = require("bec44cf6624434c");
class WebhookManager extends (0, _reactDefault.default).Component {
    constructor(props){
        super(props);
        this.state = {
            filters: {},
            updatingWebhook: null,
            selectedWebhookIds: [],
            selectedFolderIds: [],
            isSelectorOpen: false,
            isDeleteConfirmationOpen: false,
            isAddingNewFolder: false,
            isImporterOpen: false,
            currentFolder: null,
            isSidePanelOpen: false,
            isWebhookUpdaterOpen: false,
            isWebhookCreatorOpen: false,
            selectionOperation: "move",
            loaded: false,
            orphanedWebhooks: [],
            isOrphanedWebhooksModalOpen: false
        };
    }
    async componentDidUpdate() {
        if (this.state.loaded) {
            let change = false;
            const newState = {
                ...this.state
            };
            if (this.props.currentFolderId != null && this.props.currentFolderId != (this.state.currentFolder?.id ?? null)) {
                const result = await this.props.webhookFolderContainer.getFolderView(this.props.applicationId, this.props.currentFolderId, this.props.webhookContainer.state.webhooks);
                newState.currentFolder = result.data;
                change = true;
            }
            if (this.props.currentWebhookId != null && ((this.props.currentWebhookId != this.state.updatingWebhook?.id) ?? "")) {
                var webhook = this.props.webhookContainer.state.webhooks.find((w)=>w.id == this.props.currentWebhookId);
                newState.updatingWebhook = webhook;
                newState.isWebhookUpdaterOpen = true;
                change = true;
            }
            if (change) this.setState(newState);
        }
    }
    componentDidMount() {
        this.props.webhookContainer.getWebhookTypes();
        const appId = this.props.applicationId;
        if (appId) this.reloadData(appId);
    }
    async reloadData(appId) {
        this.setState({
            ...this.state,
            loaded: false
        });
        var results = await Promise.all([
            this.props.webhookFolderContainer.loadWebhookFolders(appId),
            this.props.webhookContainer.getWebhooksForApplication(appId),
            this.props.webhookContainer.getWebhooksForOrganization(this.props.organizationId)
        ]);
        if (!results.some((r)=>r.resultType != "Ok")) {
            await this.loadCurrentFolder(appId, this.props.currentFolderId);
            this.props.webhookFolderContainer.buildTree(this.props.applicationId, this.props.webhookContainer.state.webhooks);
            let orphanedWebhooks = this.props.webhookContainer.state.organizationWebhooks ?? [];
            orphanedWebhooks = orphanedWebhooks.filter((w)=>!w?.applicationId);
            await this.setState({
                ...this.state,
                orphanedWebhooks: orphanedWebhooks,
                loaded: true
            });
        }
    }
    async loadCurrentFolder(appId, folderId) {
        const result = await this.props.webhookFolderContainer.getFolderView(appId, folderId, this.props.webhookContainer.state.webhooks);
        if (result.resultType == "Ok") this.setState({
            ...this.state,
            currentFolder: result.data
        });
    }
    handleStartAddNewFeature() {
        this.setState({
            ...this.state,
            isAddingNewFolder: true
        });
    }
    handleStartAddNewWebhook() {
        this.setState({
            ...this.state,
            isWebhookCreatorOpen: true,
            isWebhookUpdaterOpen: false,
            updatingWebhook: null
        });
    }
    handleStartUpdatingWebhook(webhook) {
        this.props.history.push(`/v/apps/${this.props.applicationId}/webhooks/${this.props.currentFolderId ?? ""}?webhookId=${webhook.id}`);
    }
    async handleUpdateWebhook(model) {
        model.applicationId = this.props.applicationId, await this.props.webhookContainer.updateFullWebhook(model);
        this.loadCurrentFolder(this.props.applicationId, this.props.currentFolderId);
        this.handleCloseModals();
    }
    async handleCreateWebhook(model) {
        model.applicationId = this.props.applicationId, await this.props.webhookContainer.createFullWebhook(model);
        this.loadCurrentFolder(this.props.applicationId, this.props.currentFolderId);
        this.handleCloseModals();
    }
    async handleRemoveSensitiveData(webhookId) {
        await this.props.webhookContainer.removeSensitiveDataKey(webhookId);
    }
    async handleGenerateSensitiveData(webhookId) {
        await this.props.webhookContainer.generateSensitiveDataKey(webhookId);
    }
    toggleSidePanel() {
        this.setState({
            ...this.state,
            isSidePanelOpen: !this.state.isSidePanelOpen
        });
    }
    toggleImporter() {
        this.setState({
            ...this.state,
            isImporterOpen: !this.state.isImporterOpen
        });
    }
    handleFilterChange(filters) {
        this.setState({
            ...this.state,
            filters
        });
    }
    getBreadCrumbItems() {
        var ancestors = this.props.webhookFolderContainer.getAllAncestors(this.props.currentFolderId);
        var crumbs = ancestors?.reverse()?.map((f)=>({
                id: f?.id,
                title: f?.name ?? "Untitled",
                link: `/v/apps/${this.props.applicationId}/webhooks/${f.id}`
            }));
        crumbs = [
            {
                id: "home",
                title: "Home",
                link: `/v/apps/${this.props.applicationId}/webhooks/`
            },
            ...crumbs
        ];
        return crumbs;
    }
    toggleOrphanedWebhooksModal() {
        this.setState({
            ...this.state,
            isOrphanedWebhooksModalOpen: !this.state.isOrphanedWebhooksModalOpen
        });
    }
    async handleAddAllWebhooksToApp(ids) {
        const promises = [];
        ids.forEach((id)=>{
            const webhook = this.state.orphanedWebhooks.find((w)=>w.id == id);
            if (webhook) {
                const updateRequest = {
                    title: webhook.title,
                    description: webhook.description,
                    webhookTypeId: webhook.webhookType.id,
                    url: webhook.url,
                    accessToken: webhook.accessToken,
                    isDisabled: webhook.isDisabled,
                    isPublic: webhook.isPublic,
                    applicationId: this.props.applicationId
                };
                promises.push(this.props.webhookContainer.updateWebhook(id, updateRequest));
            }
        });
        const results = await Promise.all(promises);
        if (!results.some((r)=>r.resultType != "Ok")) {
            await this.reloadData(this.props.applicationId);
            await this.setState({
                ...this.state,
                isOrphanedWebhooksModalOpen: false
            });
        }
    }
    handleWebhookSelectionChange(webhook, isSelected) {
        const selectedIds = this.state.selectedWebhookIds;
        if (isSelected) selectedIds.push(webhook?.id);
        else selectedIds.splice(selectedIds.indexOf(webhook.id), 1);
        this.setState({
            ...this.state,
            selectedWebhookIds: selectedIds
        });
    }
    onBreadcrumbClick(item) {
        this.props.history.push(item.link);
    }
    handleFolderSelectionChange(applicationFeature, isSelected) {
        const selectedIds = this.state.selectedFolderIds;
        if (isSelected) selectedIds.push(applicationFeature?.id);
        else selectedIds.splice(selectedIds.indexOf(applicationFeature.id), 1);
        this.setState({
            ...this.state,
            selectedFolderIds: selectedIds
        });
    }
    handleSelectAll() {
        this.setState({
            ...this.state,
            selectedWebhookIds: this.state.currentFolder.webhooks?.map((c)=>c.id) ?? [],
            selectedFolderIds: this.state.currentFolder.children?.map((c)=>c.id) ?? []
        });
    }
    handleClearSelections() {
        this.setState({
            ...this.state,
            selectedWebhookIds: [],
            selectedFolderIds: []
        });
    }
    handleCopy() {
        this.setState({
            ...this.state,
            selectionOperation: "copy",
            isSelectorOpen: true
        });
    }
    handleMove() {
        this.setState({
            ...this.state,
            selectionOperation: "move",
            isSelectorOpen: true
        });
    }
    handleExport() {
        this.props.importExportContainer.exportWebhooksToFile(this.buildBulkWebhookRequest(), this.props.appContainer.state.currentApp);
    }
    handleDelete() {
        this.setState({
            ...this.state,
            isDeleteConfirmationOpen: true
        });
    }
    handleDeleteWebhook(webhook) {
        this.setState({
            ...this.state,
            selectedFolderIds: [],
            selectedWebhookIds: [
                webhook.id
            ],
            isDeleteConfirmationOpen: true
        });
    }
    handleImportComplete(file) {
        const importPromise = this.props.importExportContainer.importFileToWebhookFolder(this.props.currentFolderId, this.props.applicationId, file);
        importPromise.then((importResult)=>{
            if (importResult.resultType == "Ok") {
                this.reloadData(this.props.applicationId);
                this.handleCloseModals();
            }
        });
    }
    handleSelectionComplete(folderIds) {
        if (folderIds.length == 1) {
            var result = null;
            if (this.state.selectionOperation == "copy") result = this.props.webhookFolderContainer.copyToFolder(folderIds[0], this.buildBulkWebhookRequest());
            else if (this.state.selectionOperation == "move") result = this.props.webhookFolderContainer.moveToFolder(folderIds[0], this.buildBulkWebhookRequest());
            result.then((result)=>{
                if (result.resultType == "Ok") {
                    this.props.webhookContainer.getWebhooksForApplication(this.props.applicationId);
                    if (folderIds[0] == this.props.currentFolderId) {
                        this.reloadData(this.props.applicationId);
                        this.handleCloseModals();
                        this.handleClearSelections();
                    } else {
                        this.handleCloseModals();
                        this.handleClearSelections();
                        this.props.history.push(`/v/apps/${this.props.applicationId}/webhooks/${folderIds[0]}`);
                    }
                }
            });
        } else this.handleCloseModals();
    }
    buildBulkWebhookRequest() {
        return {
            applicationId: this.props.applicationId,
            webhookFolderIds: this.state.selectedFolderIds,
            webhookIds: this.state.selectedWebhookIds
        };
    }
    handleDeleteConfirm() {
        this.props.webhookFolderContainer.bulkDelete(this.buildBulkWebhookRequest()).then((result)=>{
            if (result.resultType == "Ok") {
                this.reloadData(this.props.applicationId);
                this.handleCloseModals();
                this.handleClearSelections();
            }
        });
    }
    handleCloseModals() {
        this.props.history.push(`/v/apps/${this.props.applicationId}/webhooks/${this.props.currentFolderId ?? ""}`);
        this.setState({
            ...this.state,
            isDeleteConfirmationOpen: false,
            isSelectorOpen: false,
            isImporterOpen: false,
            isWebhookUpdaterOpen: false,
            isWebhookCreatorOpen: false,
            updatingWebhook: null
        });
    }
    async handleCreateNewFolder(text) {
        await this.props.webhookFolderContainer.createFolder(this.props.applicationId, text, this.props.currentFolderId);
        await this.loadCurrentFolder(this.props.applicationId, this.props.currentFolderId);
        this.setState({
            ...this.state,
            isAddingNewFolder: false
        });
    }
    render() {
        const currentFolder = this.state.currentFolder;
        if (!currentFolder) return (0, _react.jsx)((0, _loaderDefault.default), null);
        var selectionState = "none";
        if (currentFolder.webhooks?.length == this.state.selectedWebhookIds.length && currentFolder.children?.length == this.state.selectedFolderIds.length && (this.state.selectedWebhookIds.length > 0 || this.state.selectedFolderIds.length > 0)) selectionState = "all";
        else if (this.state.selectedWebhookIds.length > 0 || this.state.selectedFolderIds.length > 0) selectionState = "partial";
        const selectedFolderCount = this.state.selectedFolderIds.length;
        const selectedWebhookCount = this.state.selectedWebhookIds.length;
        var deleteConfirmation = `${selectedFolderCount} folder${selectedFolderCount == 1 ? "" : "s"} and ${selectedWebhookCount} webhook${selectedWebhookCount == 1 ? "" : "s"}? This will remove all deleted webhooks from your content as well.`;
        if (selectedWebhookCount == 1 && selectedFolderCount == 0) deleteConfirmation = `this webhook and all instances of it?`;
        return (0, _react.jsx)((0, _panelContainerDefault.default), null, (0, _react.jsx)((0, _webhooksSidePanelDefault.default), {
            history: this.props.history,
            isOpen: this.state.isSidePanelOpen,
            webhookFolderContainer: this.props.webhookFolderContainer,
            toggleView: this.toggleSidePanel.bind(this),
            applicationId: this.props.applicationId,
            webhookContainer: this.props.webhookContainer
        }), (0, _react.jsx)((0, _pageContainerDefault.default), {
            fill: true
        }, this.state.selectedWebhookIds.length > 0 || this.state.selectedFolderIds.length > 0 ? (0, _react.jsx)((0, _selectionOptionsToolbarDefault.default), {
            applicationFeatureId: currentFolder?.id,
            application: null,
            onPublish: null,
            isPublishing: false,
            selectedContentIds: this.state.selectedWebhookIds,
            selectedFeaturesIds: this.state.selectedFolderIds,
            icon: this.props.currentFolderId ? folderIcon : homeIcon,
            groupSelectionState: selectionState,
            onClear: this.handleClearSelections.bind(this),
            onExport: this.handleExport.bind(this),
            isExporting: this.props.importExportContainer.state.isLoading,
            isMoving: this.props.webhookFolderContainer.state.isLoading,
            isCopying: this.props.webhookFolderContainer.state.isLoading,
            isDeleting: this.props.webhookFolderContainer.state.isLoading,
            onMove: this.handleMove.bind(this),
            onCopy: this.handleCopy.bind(this),
            onUnselectAll: this.handleClearSelections.bind(this),
            onSelectAll: this.handleSelectAll.bind(this),
            onDelete: this.handleDelete.bind(this),
            history: this.props.history,
            isSelectingWebhooks: true
        }) : (0, _react.jsx)((0, _webhookToolbarDefault.default), {
            showNewWebhook: true,
            showImport: true,
            showNewFolder: true,
            icon: this.props.currentFolderId ? folderIcon : homeIcon,
            onImport: this.toggleImporter.bind(this),
            onAddNewWebhook: this.handleStartAddNewWebhook.bind(this),
            onAddNewFolder: this.handleStartAddNewFeature.bind(this),
            onSelectAll: this.handleSelectAll.bind(this),
            groupSelectionState: selectionState,
            onBreadCrumbItemClick: this.onBreadcrumbClick.bind(this),
            breadCrumbs: this.getBreadCrumbItems(),
            history: this.props.history
        }), this.state.orphanedWebhooks && this.state.orphanedWebhooks.length > 0 && (0, _react.jsx)((0, _orphanedWebhooksHeaderDefault.default), {
            showOrphanedWebhooks: this.toggleOrphanedWebhooksModal.bind(this),
            count: this.state.orphanedWebhooks.length
        }), (0, _react.jsx)((0, _customScrollbarsDefault.default), {
            autoHide: true
        }, (0, _react.jsx)((0, _webhookListDefault.default), {
            reloadData: this.reloadData.bind(this),
            webhookFolderContainer: this.props.webhookFolderContainer,
            currentFolderId: this.props.currentFolderId,
            folders: currentFolder.children,
            webhooks: currentFolder.webhooks,
            applicationId: this.props.applicationId,
            selectedWebhookIds: this.state.selectedWebhookIds,
            selectedFolderIds: this.state.selectedFolderIds,
            onFolderClick: null,
            onWebhookClick: this.handleStartUpdatingWebhook.bind(this),
            onWebhookSelectionChange: this.handleWebhookSelectionChange.bind(this),
            onFolderSelectionChange: this.handleFolderSelectionChange.bind(this),
            showContentItems: true,
            selectableContentItems: true,
            selectableFeatures: true,
            withNesting: false,
            showWebhookCount: true,
            isAddingNewFolder: this.state.isAddingNewFolder,
            droppableId: "webhooks_main",
            disabledFolderIds: [],
            handleCreateNewFolder: this.handleCreateNewFolder.bind(this)
        })), this.state.isSelectorOpen && (0, _react.jsx)((0, _webhookFolderSelectorDefault.default), {
            applicationId: this.props.applicationId,
            onClose: this.handleCloseModals.bind(this),
            title: "Select a folder",
            disabledFolderIds: this.state.selectionOperation == "copy" ? [] : this.state.selectedFolderIds,
            onFinish: this.handleSelectionComplete.bind(this),
            withNesting: true,
            appContainer: this.props.appContainer,
            webhookFolderContainer: this.props.webhookFolderContainer,
            initialFolderId: this.props.currentFolderId
        }), (this.state.isWebhookUpdaterOpen || this.state.isWebhookCreatorOpen) && (0, _react.jsx)((0, _webhookFormDefault.default), {
            currentFolderId: this.props.currentFolderId,
            onWebhookDelete: this.handleDeleteWebhook.bind(this),
            onClose: this.handleCloseModals.bind(this),
            editorType: this.state.isWebhookUpdaterOpen ? "update" : "create",
            webhookTypes: this.props.webhookContainer.state.webhookTypes,
            isLoading: this.props.webhookContainer.state.isLoading,
            finishCreate: this.handleCreateWebhook.bind(this),
            finishUpdate: this.handleUpdateWebhook.bind(this),
            webhookToUpdate: this.state.updatingWebhook,
            removeSensitiveDataKey: this.handleRemoveSensitiveData.bind(this),
            generateSensitiveDataKey: this.handleGenerateSensitiveData.bind(this),
            webhookSensitiveData: this.props.webhookContainer.state.webhookSensitiveData
        }), this.state.isOrphanedWebhooksModalOpen && (0, _react.jsx)((0, _orphanedWebhooksModalDefault.default), {
            webhooks: this.state.orphanedWebhooks,
            handleAddToApp: this.handleAddAllWebhooksToApp.bind(this),
            handleClose: this.toggleOrphanedWebhooksModal.bind(this),
            handleRemove: this.handleDeleteWebhook.bind(this),
            isLoading: this.props.webhookContainer.state.isLoading || this.props.webhookContainer.state.isUpdating
        }), this.state.isImporterOpen && (0, _react.jsx)((0, _importFileDialogDefault.default), {
            completeImport: this.handleImportComplete.bind(this),
            onClose: this.handleCloseModals.bind(this),
            title: "Import webhooks into folder",
            acceptFileTypes: ".zip, .vfy",
            acceptFileTypesDisplayText: "Supports .zip, .vfy",
            isLoading: this.props.importExportContainer.state.isLoading,
            errors: this.props.importExportContainer.state.errors
        }), this.state.isDeleteConfirmationOpen && (0, _react.jsx)((0, _confirmationDialogDefault.default), {
            title: "Delete",
            deleteText: "Yes, Delete",
            isLoading: this.props.webhookFolderContainer.state.isLoading,
            onClose: this.handleCloseModals.bind(this),
            onConfirm: this.handleDeleteConfirm.bind(this)
        }, (0, _react.jsx)((0, _deleteConfirmationDefault.default), {
            itemLabel: deleteConfirmation
        }))));
    }
}
exports.default = WebhookManager;

},{"@emotion/react":"djZKr","react":"6uln9","../../components/structure/Panels/PanelContainer":"9R2lE","../../components/structure/PageContainer":"hc1r8","../../components/structure/ConfirmationDialog":"kx7yK","../../components/general/Loader":"bnV5T","../../components/structure/CustomScrollbars":"50vFq","../../components/general/SelectionOptionsToolbar":"avfr2","./components/WebhookToolbar":"34NVS","../featureContent/components/DeleteConfirmation":"9xK2d","./components/WebhooksSidePanel":"jMIaX","./components/WebhookList":"hcs6V","./components/WebhookFolderSelector":"jPctm","./components/WebhookForm":"8qWA9","./components/OrphanedWebhooksHeader":"4nHH3","./components/OrphanedWebhooksModal":"boPHx","../../components/general/ImportFileDialog":"7LQaS","5a4f27ea309aaff0":"keV1x","bec44cf6624434c":"dHwU7","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"34NVS":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getFilterCount", ()=>getFilterCount);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _colors = require("../../../constants/colors");
var _button = require("../../../components/general/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _checkIndicator = require("../../../components/forms/CheckIndicator");
var _checkIndicatorDefault = parcelHelpers.interopDefault(_checkIndicator);
var _breadcrumb = require("../../../components/general/Breadcrumb");
var _breadcrumbDefault = parcelHelpers.interopDefault(_breadcrumb);
var _newFolderOrWebhookPicker = require("./NewFolderOrWebhookPicker");
var _newFolderOrWebhookPickerDefault = parcelHelpers.interopDefault(_newFolderOrWebhookPicker);
const addIcon = require("dc47c61c19f7f33");
class WebhookToolbar extends (0, _reactDefault.default).Component {
    constructor(props){
        super(props);
        this.state = {
            isAddNewExpanded: false
        };
    }
    handleToggleAddNew() {
        this.setState({
            ...this.state,
            isAddNewExpanded: !this.state.isAddNewExpanded
        });
    }
    handleNewSelected(option) {
        if (option == "folder") this.props.onAddNewFolder();
        if (option == "webhook") this.props.onAddNewWebhook();
        if (option == "import") this.props.onImport();
    }
    render() {
        return (0, _react.jsx)("div", {
            className: containerStyle
        }, (0, _react.jsx)("div", {
            className: "tool-bar-container"
        }, this.props.onSelectAll && (0, _react.jsx)("div", {
            className: "group-select-container"
        }, (0, _react.jsx)((0, _checkIndicatorDefault.default), {
            onClick: ()=>this.props.onSelectAll(),
            partial: this.props.groupSelectionState == "partial",
            checked: this.props.groupSelectionState == "all"
        }), (0, _react.jsx)("img", {
            src: this.props.icon
        })), (0, _react.jsx)((0, _breadcrumbDefault.default), {
            items: this.props.breadCrumbs,
            onItemClick: this.props.onBreadCrumbItemClick
        }), (this.props.showImport || this.props.showNewFolder || this.props.showNewWebhook) && (0, _react.jsx)("div", {
            className: "add-button"
        }, (0, _react.jsx)((0, _buttonDefault.default), {
            themes: [
                "primary-small"
            ],
            text: "Add New",
            onClick: this.handleToggleAddNew.bind(this),
            type: "button",
            rightIcon: addIcon
        }), this.state.isAddNewExpanded && (0, _react.jsx)((0, _newFolderOrWebhookPickerDefault.default), {
            position: "right",
            onClose: this.handleToggleAddNew.bind(this),
            onSelected: this.handleNewSelected.bind(this),
            showImport: this.props.showImport,
            showNewWebhook: this.props.showNewWebhook,
            showNewFolder: this.props.showNewFolder
        }))));
    }
}
const getFilterCount = (filters)=>{
    var count = 0;
    if (filters.textFilter && filters.textFilter.length > 0) count++;
    if (filters.daysFilter) count++;
    if (filters.featureTypeIdsFilter && filters.featureTypeIdsFilter.length > 0) count++;
    if (filters.languageIdsFilter && filters.languageIdsFilter.length > 0) count++;
    if (filters.propertiesFilter) {
        var hasPropertyFilters = Object.keys(filters.propertiesFilter).map((key)=>filters.propertiesFilter[key]).filter((val)=>val === true).length > 0;
        if (hasPropertyFilters) count++;
    }
    return count;
};
const containerStyle = /*#__PURE__*/ (0, _css.css)("background:", (0, _colors.color_defaults_white), ";.tool-bar-container{border-bottom:1px solid ", (0, _colors.color_shades_dark), ";display:flex;align-items:center;padding:0 24px;height:56px;}.group-select-container{display:flex;align-items:center;padding:0 12px 0 8px;margin-right:12px;border-right:1px solid ", (0, _colors.color_shades_dark), ";}button{margin:0;&.expanded{background:linear-gradient(0deg, rgba(30, 126, 185, 0.07), rgba(30, 126, 185, 0.07)),#FFFFFF;border:1px solid ", (0, _colors.color_text_link), ";color:", (0, _colors.color_text_link), ";}&.search-button{margin:0 16px;padding:0 16px;.right-img{margin:0;}}.filter-right{margin-left:8px;width:20px;img{width:16px;height:16px;}}.filter-count{border-radius:50%;color:white;display:flex;align-items:center;justify-content:center;background:", (0, _colors.color_text_link), ";width:20px;height:20px;span{font-style:normal;font-weight:600;font-size:10px;line-height:16px;}}}.filter-button{margin-right:24px;margin-left:auto;&.applied-filter button{border:1px solid ", (0, _colors.color_text_link), ";color:", (0, _colors.color_text_link), ";}}.add-button{margin-right:16px;margin-left:auto;position:relative;}", "");
exports.default = WebhookToolbar;

},{"@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","../../../constants/colors":"1p3OR","../../../components/general/Button":"6ymxN","../../../components/forms/CheckIndicator":"8zBm6","../../../components/general/Breadcrumb":"euZw9","./NewFolderOrWebhookPicker":"gxbvZ","dc47c61c19f7f33":"i0YpA","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"gxbvZ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _defineProperty = require("@babel/runtime/helpers/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _colors = require("../../../constants/colors");
var _customScrollbars = require("../../../components/structure/CustomScrollbars");
var _customScrollbarsDefault = parcelHelpers.interopDefault(_customScrollbars);
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const folderIcon = require("ff78cbb7b1b2a399");
const webhookIcon = require("fa4b97293f73ae15");
const importIcon = require("2e6f25cd8d3df288");
class NewFolderOrWebhookPicker extends (0, _reactDefault.default).Component {
    constructor(...args){
        super(...args);
        (0, _definePropertyDefault.default)(this, "documentCloser", this.handleDocumentClick.bind(this));
    }
    componentWillMount() {
        this.setState({
            isCollapsed: true
        });
        document.addEventListener("click", this.documentCloser, true);
    }
    componentWillUnmount() {
        document.removeEventListener("click", this.documentCloser, true);
    }
    handleDocumentClick(e) {
        if (e.target.closest(".selector-wrapper") || e.target.closest(".selection-container")) return;
        this.props.onClose();
    }
    handleNewWebhook() {
        this.props.onSelected("webhook");
    }
    handleNewFolder() {
        this.props.onSelected("folder");
    }
    handleImport() {
        this.props.onSelected("import");
    }
    render() {
        return (0, _react.jsx)("div", {
            className: containerStyle + " " + (this.props.position == "left" ? leftStyle : rightStyle)
        }, (0, _react.jsx)("div", {
            className: "selector-wrapper"
        }, (0, _react.jsx)("div", {
            className: triangleStyle
        }), (0, _react.jsx)((0, _customScrollbarsDefault.default), {
            autoHide: true,
            autoHeight: true,
            autoHeightMax: 600,
            className: "inner-wrapper"
        }, this.props.showNewFolder && (0, _react.jsx)("div", {
            className: listItemStyle,
            onClick: ()=>this.handleNewFolder()
        }, (0, _react.jsx)("img", {
            src: folderIcon
        }), (0, _react.jsx)("p", null, "New Folder")), this.props.showNewWebhook && (0, _react.jsx)("div", {
            className: listItemStyle,
            onClick: ()=>this.handleNewWebhook()
        }, (0, _react.jsx)("img", {
            src: webhookIcon
        }), (0, _react.jsx)("p", null, "New Webhook")), this.props.showImport && (0, _react.jsx)("div", {
            className: `import ${listItemStyle}`,
            onClick: ()=>this.handleImport()
        }, (0, _react.jsx)("img", {
            src: importIcon
        }), (0, _react.jsx)("p", null, "Import")))));
    }
}
const listItemStyle = /*#__PURE__*/ (0, _css.css)("display:flex;flex-direction:row;align-items:center;padding:16px;cursor:pointer;background:white;&.import{border-top:1px solid ", (0, _colors.color_shades_dark), ";}img{width:32px;height:32px;margin:0 16px;}p{color:", (0, _colors.dark_grey_blue), ";font-size:16px;}", "");
const containerStyle = /*#__PURE__*/ (0, _css.css)("position:absolute;.selector-wrapper{width:340px;display:flex;flex-direction:column;margin-left:0;margin-right:0;background:white;margin-bottom:120px;margin-top:-12px;box-shadow:0 4px 4px 0 ", (0, _colors.dark_grey_blue_10), ";border-radius:10px;z-index:100;flex:1;position:absolute;.inner-wrapper{overflow-y:auto;max-height:600px;border:1px solid #cccccc;border-radius:10px;}}.field-label{font-size:14px;color:", (0, _colors.cool_grey), ";background:white;padding-left:32px;padding-top:16px;}", "");
const triangleStyle = /*#__PURE__*/ (0, _css.css)({
    name: "1qgg4j9",
    styles: "z-index:1;transform:rotate(45deg);width:12px;height:12px;margin-top:-14px;margin-bottom:-6px;border-top:solid 1px #cccccc;border-left:solid 1px #cccccc;background:white;margin-right:16px;margin-left:auto"
});
const rightStyle = /*#__PURE__*/ (0, _css.css)({
    name: "18c671m",
    styles: "right:374px;top:82px"
});
const leftStyle = /*#__PURE__*/ (0, _css.css)("top:42px;left:32px;.", triangleStyle, "{margin-left:16px;margin-right:auto;}", "");
exports.default = NewFolderOrWebhookPicker;

},{"@babel/runtime/helpers/defineProperty":"9sJxO","@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","../../../constants/colors":"1p3OR","../../../components/structure/CustomScrollbars":"50vFq","ff78cbb7b1b2a399":"6KJ6c","fa4b97293f73ae15":"jtMBK","2e6f25cd8d3df288":"jlgVO","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6KJ6c":[function(require,module,exports) {
module.exports = require("3971e480696b8f12").getBundleURL("kVLro") + require("7a434241393a8ee5").resolve("3dudY");

},{"3971e480696b8f12":"c7Tr5","7a434241393a8ee5":"fyJL2"}],"jtMBK":[function(require,module,exports) {
module.exports = require("bb5f6f6135f73b78").getBundleURL("kVLro") + require("e01906bbf2d8f242").resolve("kNCUE");

},{"bb5f6f6135f73b78":"c7Tr5","e01906bbf2d8f242":"fyJL2"}],"jMIaX":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _collapsingPanel = require("../../../components/structure/Panels/CollapsingPanel");
var _collapsingPanelDefault = parcelHelpers.interopDefault(_collapsingPanel);
var _colors = require("../../../constants/colors");
var _expandedWebhookSidePanel = require("./ExpandedWebhookSidePanel");
var _expandedWebhookSidePanelDefault = parcelHelpers.interopDefault(_expandedWebhookSidePanel);
var _collapsedWebhookSidePanel = require("./CollapsedWebhookSidePanel");
var _collapsedWebhookSidePanelDefault = parcelHelpers.interopDefault(_collapsedWebhookSidePanel);
class WebhooksSidePanel extends (0, _reactDefault.default).Component {
    onToggleCollapse(e) {
        e.stopPropagation();
        this.props.toggleView();
    }
    render() {
        return (0, _react.jsx)("div", {
            className: containerStyle + (this.props.isOpen ? " expanded" : " collapsed")
        }, (0, _react.jsx)("div", {
            className: "fixed-wrapper"
        }, (0, _react.jsx)((0, _collapsingPanelDefault.default), {
            isCollapsed: !this.props.isOpen,
            collapsedView: (0, _react.jsx)((0, _collapsedWebhookSidePanelDefault.default), {
                history: this.props.history,
                webhookFolderContainer: this.props.webhookFolderContainer,
                onExpand: this.onToggleCollapse.bind(this),
                webhookContainer: this.props.webhookContainer,
                applicationId: this.props.applicationId
            }),
            expandedView: (0, _react.jsx)((0, _expandedWebhookSidePanelDefault.default), {
                history: this.props.history,
                webhookFolderContainer: this.props.webhookFolderContainer,
                onCollapse: this.onToggleCollapse.bind(this),
                webhookContainer: this.props.webhookContainer,
                showCollapseButton: true,
                applicationId: this.props.applicationId
            })
        })));
    }
}
const containerStyle = /*#__PURE__*/ (0, _css.css)("z-index:2;bottom:0;position:relative;&.collapsed{width:80px;.fixed-wrapper{width:80px;}}&.expanded{width:288px;.fixed-wrapper{width:288px;}}.fixed-wrapper{position:fixed;top:80px;bottom:0;height:calc(100vh - 80px);background:white;border-right:1px solid ", (0, _colors.color_shades_dark), ";box-sizing:border-box;}", "");
exports.default = WebhooksSidePanel;

},{"@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","../../../components/structure/Panels/CollapsingPanel":"jVPoD","../../../constants/colors":"1p3OR","./ExpandedWebhookSidePanel":"cv9af","./CollapsedWebhookSidePanel":"k0F73","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"cv9af":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _tabContainerPanel = require("../../../components/structure/Panels/TabContainerPanel");
var _tabContainerPanelDefault = parcelHelpers.interopDefault(_tabContainerPanel);
var _reactTabs = require("react-tabs");
var _customScrollbars = require("../../../components/structure/CustomScrollbars");
var _customScrollbarsDefault = parcelHelpers.interopDefault(_customScrollbars);
var _nestedTree = require("../../../components/structure/NestedTree/NestedTree");
var _nestedTreeDefault = parcelHelpers.interopDefault(_nestedTree);
var _colors = require("../../../constants/colors");
var _menuCollapseToggle = require("../../../components/structure/MenuCollapseToggle");
var _menuCollapseToggleDefault = parcelHelpers.interopDefault(_menuCollapseToggle);
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const contentTreeIcon = require("1437aae511c154b3");
const contentTreeBlueIcon = require("c7590a7906065657");
class ExpandedWebhookSidePanel extends (0, _reactDefault.default).Component {
    handleTreeItemClick(item) {
        if (item.type == "feature") {
            const expandedIds = this.props.webhookFolderContainer.state.expandedIds;
            if (expandedIds.some((id)=>id == item.id)) expandedIds.splice(expandedIds.indexOf(item.id), 1);
            else expandedIds.push(item.id);
            this.props.webhookFolderContainer.setExpandedIds(expandedIds);
            this.props.webhookFolderContainer.buildTree(this.props.applicationId, this.props.webhookContainer.state.webhooks);
        }
    }
    render() {
        return (0, _react.jsx)("div", {
            className: containerStyle
        }, this.props.showCollapseButton && (0, _react.jsx)((0, _menuCollapseToggleDefault.default), {
            isMinified: false,
            onToggle: this.props.onCollapse
        }), (0, _react.jsx)((0, _tabContainerPanelDefault.default), {
            tabs: [
                {
                    title: "Explorer",
                    icon: contentTreeIcon,
                    selectedIcon: contentTreeBlueIcon
                }
            ],
            selectedIndex: 0
        }, (0, _react.jsx)((0, _reactTabs.TabPanel), null, (0, _react.jsx)("div", {
            className: "expanded-content-tree-container"
        }, (0, _react.jsx)("div", {
            className: scrollContainer
        }, (0, _react.jsx)((0, _customScrollbarsDefault.default), {
            autoHide: true,
            className: "tree-scroll"
        }, (0, _react.jsx)("div", {
            className: "tree-container"
        }, (0, _react.jsx)((0, _nestedTreeDefault.default), {
            emptyText: "No Webhooks Found Here",
            isRootHidden: true,
            key: this.props.webhookFolderContainer.state.tree?.id ?? "r",
            root: this.props.webhookFolderContainer.state.tree,
            onItemClick: this.handleTreeItemClick.bind(this)
        }))))))));
    }
}
const containerStyle = /*#__PURE__*/ (0, _css.css)({
    name: "g52d35",
    styles: ".panel-header{max-width:288px;}.header-container{position:relative;width:288px;display:flex;align-items:center;}"
});
const scrollContainer = /*#__PURE__*/ (0, _css.css)("display:flex;flex-direction:column;height:100%;.selector-section-header{align-items:center;padding:0px 16px 0 24px;background:white;height:56px;min-height:56px;max-height:56px;border-bottom:1px solid ", (0, _colors.color_shades_dark), ";p{font-size:18px;line-height:24px;padding-top:16px;color:", (0, _colors.color_text_default), ";}}.tree-container{padding-bottom:16px;max-height:100%;flex:1;}", "");
exports.default = ExpandedWebhookSidePanel;

},{"@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","../../../components/structure/Panels/TabContainerPanel":"iDHIJ","react-tabs":"92Sgf","../../../components/structure/CustomScrollbars":"50vFq","../../../components/structure/NestedTree/NestedTree":"fhYq0","../../../constants/colors":"1p3OR","../../../components/structure/MenuCollapseToggle":"d7R0v","1437aae511c154b3":"f0x3E","c7590a7906065657":"c2pA9","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"k0F73":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _collapsedMenuPanel = require("../../../components/structure/CollapsedMenuPanel");
var _collapsedMenuPanelDefault = parcelHelpers.interopDefault(_collapsedMenuPanel);
var _expandedWebhookSidePanel = require("./ExpandedWebhookSidePanel");
var _expandedWebhookSidePanelDefault = parcelHelpers.interopDefault(_expandedWebhookSidePanel);
const CollapsedWebhookSidePanel = (props)=>{
    return (0, _react.jsx)((0, _collapsedMenuPanelDefault.default), {
        onExpand: props.onExpand,
        expandedViewRender: ()=>(0, _react.jsx)((0, _expandedWebhookSidePanelDefault.default), {
                onCollapse: props.onExpand,
                webhookFolderContainer: props.webhookFolderContainer,
                history: props.history,
                webhookContainer: props.webhookContainer,
                showCollapseButton: false,
                applicationId: props.applicationId
            })
    });
};
exports.default = CollapsedWebhookSidePanel;

},{"@emotion/react":"djZKr","react":"6uln9","../../../components/structure/CollapsedMenuPanel":"1mVIj","./ExpandedWebhookSidePanel":"cv9af","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hcs6V":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _extends = require("@babel/runtime/helpers/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _reactBeautifulDnd = require("react-beautiful-dnd");
var _lodash = require("lodash");
var _lodashDefault = parcelHelpers.interopDefault(_lodash);
var _webhookListItem = require("./WebhookListItem");
var _webhookListItemDefault = parcelHelpers.interopDefault(_webhookListItem);
var _colors = require("../../../constants/colors");
var _secondaryLoader = require("../../../components/general/SecondaryLoader");
var _secondaryLoaderDefault = parcelHelpers.interopDefault(_secondaryLoader);
var _webhookFolderItem = require("./WebhookFolderItem");
var _webhookFolderItemDefault = parcelHelpers.interopDefault(_webhookFolderItem);
var _newWebhookFolderItem = require("./NewWebhookFolderItem");
var _newWebhookFolderItemDefault = parcelHelpers.interopDefault(_newWebhookFolderItem);
var _emptyView = require("../../featureContent/components/EmptyView");
var _emptyViewDefault = parcelHelpers.interopDefault(_emptyView);
class WebhookList extends (0, _reactDefault.default).Component {
    handleDragEnd(result, provider) {
        // dropped outside the list
        if (!result.destination) return;
        const features = (0, _lodashDefault.default).orderBy(this.props.folders, (af)=>af.priority, "asc");
        const reorder = (list, startIndex, endIndex)=>{
            const result = Array.from(list);
            const [removed] = result.splice(startIndex, 1);
            result.splice(endIndex, 0, removed);
            return result;
        };
        this.props.webhookFolderContainer.setFolderOrder(this.props.applicationId, this.props.currentFolderId, reorder(features, result.source.index, result.destination.index).map((r)=>r.id));
    }
    render() {
        return (0, _react.jsx)("div", {
            className: containerStyle
        }, (0, _react.jsx)("div", {
            className: "child-container"
        }, this.props.withNesting && (0, _react.jsx)("div", {
            className: "spacer"
        }), (0, _react.jsx)("div", {
            className: "child-content-container"
        }, this.props.isAddingNewFolder && (0, _react.jsx)((0, _newWebhookFolderItemDefault.default), {
            isLoading: false,
            onFinish: (text)=>this.props.handleCreateNewFolder(text)
        }), this.props.webhookFolderContainer.state.isLoading && !this.props.webhookFolderContainer.state.loadingFolderIds.some((s)=>s === this.props.currentFolderId) ? (0, _react.jsx)((0, _secondaryLoaderDefault.default), {
            className: "feature-loader"
        }) : (0, _react.jsx)((0, _reactBeautifulDnd.DragDropContext), {
            onDragEnd: this.handleDragEnd.bind(this)
        }, (0, _react.jsx)((0, _reactBeautifulDnd.Droppable), {
            droppableId: this.props.droppableId,
            type: "WEBHOOKS_MAIN"
        }, (provided, snapshot)=>(0, _react.jsx)("div", (0, _extendsDefault.default)({}, provided.droppableProps, {
                ref: provided.innerRef
            }), (0, _lodashDefault.default).orderBy(this.props.folders, (f)=>f.priority, "asc")?.map((folder, i)=>(0, _react.jsx)((0, _reactBeautifulDnd.Draggable), {
                    draggableId: folder.id,
                    index: i,
                    key: folder.id
                }, (provided, snapshot)=>(0, _react.jsx)("div", (0, _extendsDefault.default)({
                        ref: provided.innerRef
                    }, provided.draggableProps, provided.dragHandleProps), (0, _react.jsx)((0, _webhookFolderItemDefault.default), {
                        reloadData: this.props.reloadData,
                        folder: folder,
                        webhookFolderContainer: this.props.webhookFolderContainer,
                        applicationId: this.props.applicationId,
                        onSelectionChange: this.props.onFolderSelectionChange,
                        isSelected: this.props.selectedFolderIds?.some((id)=>id == folder.id),
                        selectable: !this.props.disabledFolderIds.some((id)=>id == folder.id),
                        disabled: this.props.disabledFolderIds.some((id)=>id == folder.id),
                        onClick: this.props.onFolderClick,
                        isSingleSelect: this.props.isSingleSelect,
                        showWebhookCount: this.props.showWebhookCount,
                        index: i
                    })))), provided.placeholder))), this.props.webhookFolderContainer.state.loadingFolderIds.some((s)=>s === this.props.currentFolderId) ? (0, _react.jsx)("div", {
            className: "content-loader"
        }, (0, _react.jsx)((0, _secondaryLoaderDefault.default), null)) : (0, _react.jsx)("div", {
            className: `child-content-items-container ${this.props.folders == null || this.props.folders?.length === 0 ? "only-content" : ""}`
        }, this.props.showContentItems && (0, _lodashDefault.default).orderBy(this.props.webhooks, (webhook)=>webhook.createdDate, "asc")?.map((webhook)=>(0, _react.jsx)((0, _webhookListItemDefault.default), {
                selectable: this.props.selectableContentItems,
                onClick: this.props.onWebhookClick,
                key: webhook.id,
                webhook: webhook,
                isSelected: this.props.selectedWebhookIds?.some((id)=>id == webhook.id),
                onSelectionChange: this.props.onWebhookSelectionChange,
                disabled: false,
                isSingleSelect: this.props.isSingleSelect
            })), this.props.webhooks.length == 0 && this.props.folders.length == 0 && !this.props.webhookFolderContainer.state.isLoading && (0, _react.jsx)((0, _emptyViewDefault.default), null)))));
    }
}
const containerStyle = /*#__PURE__*/ (0, _css.css)("background:", (0, _colors.color_variants_main_bg), ";height:100%;.content-loader{margin:32px;margin-top:48px;.spinner>div{background:", (0, _colors.color_colors_growth), ";}}.feature-loader{margin-top:16px;}.child-container{display:flex;align-items:stretch;.spacer{width:32px;background:", (0, _colors.color_shades_light), ";border:1px solid ", (0, _colors.color_shades_dark), ";box-sizing:border-box;}.child-content-container{flex:1;padding:32px 0;.spinner>div{background:", (0, _colors.color_colors_growth), ";}}.child-content-items-container{padding:32px 0;margin-bottom:64px;&.only-content{padding:0px;}}}.triangle-down{width:0;height:0;border-left:3px solid transparent;border-right:3px solid transparent;border-top:3px solid ", (0, _colors.color_shades_darkest), ";}.triangle-right{width:0;height:0;border-top:3px solid transparent;border-bottom:3px solid transparent;border-left:3px solid ", (0, _colors.color_shades_darkest), ";}.triangle-container{width:3px;height:3px;margin-right:8px;}.check{margin-top:4px;}", "");
exports.default = WebhookList;

},{"@babel/runtime/helpers/extends":"4iKIP","@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","react-beautiful-dnd":"bkbSn","lodash":"3hMBK","./WebhookListItem":"an5B2","../../../constants/colors":"1p3OR","../../../components/general/SecondaryLoader":"7zJiF","./WebhookFolderItem":"2sbov","./NewWebhookFolderItem":"17CKJ","../../featureContent/components/EmptyView":"j6GxB","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"an5B2":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _checkIndicator = require("../../../components/forms/CheckIndicator");
var _checkIndicatorDefault = parcelHelpers.interopDefault(_checkIndicator);
var _colors = require("../../../constants/colors");
const webhookIcon = require("64fd60543147b277");
const deleteIcon = require("510aa3b8ed78187d");
class WebhookListItem extends (0, _reactDefault.default).Component {
    render() {
        const webhook = this.props.webhook;
        return (0, _react.jsx)("div", {
            className: `${containerStyle} ${this.props.disabled ? "disabled" : ""}`
        }, (0, _react.jsx)("div", {
            className: `content-item`
        }, (0, _react.jsx)((0, _checkIndicatorDefault.default), {
            checkType: this.props.isSingleSelect ? "radio" : "check",
            checked: this.props.isSelected,
            onClick: this.props.disabled || !this.props.selectable ? ()=>{} : ()=>this.props.onSelectionChange(webhook, !this.props.isSelected),
            disabled: this.props.disabled || !this.props.selectable
        }), (0, _react.jsx)("img", {
            className: "content-item-icon",
            src: webhookIcon
        }), (0, _react.jsx)("div", {
            onClick: ()=>this.props.onClick(this.props.webhook),
            key: webhook.id,
            className: "content-item-title-container"
        }, (0, _react.jsx)("p", {
            className: "section-title"
        }, "Webhook"), (0, _react.jsx)("p", {
            className: "section-detail"
        }, webhook.title ?? "Untitled")), this.props.onDelete && (0, _react.jsx)("img", {
            src: deleteIcon,
            className: "delete-button",
            onClick: ()=>this.props.onDelete()
        })));
    }
}
const containerStyle = /*#__PURE__*/ (0, _css.css)("&.disabled{.content-item{background:", (0, _colors.color_shades_lighter), ";cursor:not-allowed;}}height:80px;padding:0 16px;background:", (0, _colors.color_shades_light), ";box-sizing:border-box;border-bottom:1px solid ", (0, _colors.color_shades_dark), ";&:first-child{border-top:1px solid ", (0, _colors.color_shades_dark), ";}.content-item{background:", (0, _colors.color_defaults_white), ";box-sizing:border-box;border-radius:4px;border-left:1px solid ", (0, _colors.color_shades_dark), ";border-right:1px solid ", (0, _colors.color_shades_dark), ";display:flex;align-items:center;padding:0 16px;height:100%;}.content-item-icon{width:48px;height:48px;margin-right:16px;}.section-title{font-family:Muli;font-style:normal;font-weight:normal;font-size:12px;line-height:16px;color:", (0, _colors.color_shades_darker), ";}.section-detail{font-style:normal;font-weight:normal;font-size:14px;line-height:20px;color:", (0, _colors.color_shades_darkest), ";}.content-item-title-container{cursor:pointer;flex:1;p{white-space:nowrap;overflow:hidden;text-overflow:ellipsis;max-width:25vw;}}.content-details-container{display:flex;align-items:center;margin-right:0;margin-left:auto;justify-content:flex-start;flex:1;}.delete-button{cursor:pointer;margin-right:16px;}.content-modified-container,.content-hits-container,.content-media-container{padding:0 16px;}.content-hits-container{width:96px;}.content-modified-container{width:124px;}.content-item-status-container{margin-right:0;margin-left:0;width:124px;}.content-item-languages-container{margin-right:32px;margin-left:0;width:100px;>div{justify-content:flex-end;}}", "");
exports.default = WebhookListItem;

},{"@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","../../../components/forms/CheckIndicator":"8zBm6","../../../constants/colors":"1p3OR","64fd60543147b277":"jtMBK","510aa3b8ed78187d":"f9rzT","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2sbov":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _reactRouterDom = require("react-router-dom");
var _colors = require("../../../constants/colors");
var _largeOverflowMenu = require("../../../components/general/LargeOverflowMenu");
var _largeOverflowMenuDefault = parcelHelpers.interopDefault(_largeOverflowMenu);
var _checkIndicator = require("../../../components/forms/CheckIndicator");
var _checkIndicatorDefault = parcelHelpers.interopDefault(_checkIndicator);
var _confirmationDialog = require("../../../components/structure/ConfirmationDialog");
var _confirmationDialogDefault = parcelHelpers.interopDefault(_confirmationDialog);
var _deleteConfirmation = require("../../featureContent/components/DeleteConfirmation");
var _deleteConfirmationDefault = parcelHelpers.interopDefault(_deleteConfirmation);
const folderIcon = require("ec77d463df0e9eb0");
const deleteIcon = require("875485359de29f3e");
const deleteRedIcon = require("8ee5536c29db73d0");
const editIcon = require("62b4df57fb49c345");
const upIcon = require("e4c4ed8c0362805c");
const downIcon = require("f57f0ee478d0d25e");
class WebhookFolderItem extends (0, _reactDefault.default).Component {
    constructor(props){
        super(props);
        this.state = {
            isEditing: false,
            isDeleteConfirmationOpen: false,
            newName: this.props.folder?.name ?? this.props.folder?.name ?? "Untitled"
        };
    }
    handleFinishRename() {
        if (this.state.newName) {
            const folder = {
                ...this.props.folder
            };
            folder.name = this.state.newName;
            this.props.webhookFolderContainer.updateFolder(folder).then((result)=>{
                if (result.resultType == "Ok") this.setState({
                    ...this.state,
                    isEditing: false
                });
            });
        } else this.setState({
            ...this.state,
            isEditing: false
        });
    }
    handleNameChange(e) {
        this.setState({
            ...this.state,
            newName: e.target.value
        });
    }
    handleOptionSelected(optionName) {
        if (optionName == "Rename") this.setState({
            ...this.state,
            isEditing: true
        }, ()=>this.inputElement?.focus());
        if (optionName == "Move Up") this.props.webhookFolderContainer.moveFolderUp(this.props.folder?.id);
        if (optionName == "Move Down") this.props.webhookFolderContainer.moveFolderDown(this.props.folder?.id);
        if (optionName == "Delete") this.setState({
            ...this.state,
            isDeleteConfirmationOpen: true
        });
    }
    async handleDeleteConfirm() {
        const result = await this.props.webhookFolderContainer.deleteFolder(this.props.folder.id);
        if (result.resultType == "Ok") {
            this.setState({
                ...this.state,
                isDeleteConfirmationOpen: false
            });
            this.props.reloadData(this.props.applicationId);
        }
    }
    handleCloseModals() {
        this.setState({
            ...this.state,
            isDeleteConfirmationOpen: false
        });
    }
    handleEnterBlur(e) {
        if (e.charCode == 13) e.target.blur();
    }
    getOptions() {
        const options = [
            {
                label: "Rename",
                icon: editIcon,
                hoverIcon: editIcon
            },
            {
                label: "Delete",
                icon: deleteIcon,
                hoverIcon: deleteRedIcon,
                isDestructive: true
            }
        ];
        options.push({
            label: "Move Up",
            icon: upIcon,
            hoverIcon: upIcon
        });
        options.push({
            label: "Move Down",
            icon: downIcon,
            hoverIcon: downIcon
        });
        return options;
    }
    render() {
        return (0, _react.jsx)("div", {
            className: `${containerStyle} ${this.props.disabled ? "disabled" : ""} ${this.props.className ?? ""}`
        }, (0, _react.jsx)("div", {
            className: `feature-item ${this.props.index == 0 ? "top" : ""} ${this.props.selectable ? "" : "not-selectable"}`
        }, this.props.selectable && (0, _react.jsx)((0, _checkIndicatorDefault.default), {
            checkType: this.props.isSingleSelect ? "radio" : "check",
            checked: this.props.isSelected,
            onClick: this.props.disabled ? ()=>{} : ()=>this.props.onSelectionChange(this.props.folder, !this.props.isSelected),
            disabled: this.props.disabled
        }), this.state.isEditing ? (0, _react.jsx)("div", {
            className: "feature-link"
        }, (0, _react.jsx)("img", {
            className: "folder-icon",
            src: folderIcon
        }), (0, _react.jsx)("input", {
            className: "feature-title",
            placeholder: "New Folder",
            value: this.state.newName,
            ref: (r)=>this.inputElement = r,
            onChange: this.handleNameChange.bind(this),
            onBlur: this.handleFinishRename.bind(this),
            onKeyPress: (e)=>this.handleEnterBlur(e),
            onFocus: (e)=>e.target.select()
        })) : this.props.onClick ? (0, _react.jsx)("div", {
            className: "feature-link",
            onClick: this.props.disabled ? null : ()=>this.props.onClick(this.props.folder)
        }, (0, _react.jsx)("img", {
            className: "folder-icon",
            src: folderIcon
        }), (0, _react.jsx)("h4", {
            className: "feature-title"
        }, this.props.folder.name ?? "Untitled")) : (0, _react.jsx)((0, _reactRouterDom.Link), {
            className: "feature-link",
            to: `/v/apps/${this.props.applicationId}/webhooks/${this.props.folder.id}`
        }, (0, _react.jsx)("img", {
            className: "folder-icon",
            src: folderIcon
        }), (0, _react.jsx)("h4", {
            className: "feature-title"
        }, this.props.folder.name ?? "Untitled")), this.props.showWebhookCount && (0, _react.jsx)("div", {
            className: "webhook-count"
        }, (0, _react.jsx)("div", {
            className: "count"
        }, this.props.folder.totalWebhookCount), (0, _react.jsx)("div", {
            className: "descriptor"
        }, `WEBHOOK${this.props.folder.totalWebhookCount == 1 ? "" : "s"}`)), (0, _react.jsx)((0, _largeOverflowMenuDefault.default), {
            className: `overflow-menu-folder ${this.props.showWebhookCount ? "" : "margin-left"}`,
            isActive: false,
            onOptionSelected: this.handleOptionSelected.bind(this),
            options: this.getOptions()
        })), this.state.isDeleteConfirmationOpen && (0, _react.jsx)((0, _confirmationDialogDefault.default), {
            title: `Delete ${this.props.folder?.name ?? "Untitled"}`,
            deleteText: "Yes, Delete",
            isLoading: this.props.webhookFolderContainer.state.isLoading,
            onClose: this.handleCloseModals.bind(this),
            onConfirm: this.handleDeleteConfirm.bind(this)
        }, (0, _react.jsx)((0, _deleteConfirmationDefault.default), {
            applicationFeatureCount: 1
        })));
    }
}
const containerStyle = /*#__PURE__*/ (0, _css.css)(".webhook-count{padding-right:24px;border-right:solid 1px ", (0, _colors.color_shades_dark), ";margin-left:auto;text-align:right;font-style:normal;.count{font-weight:600;font-size:18px;line-height:24px;color:", (0, _colors.color_shades_darkest), ";}.descriptor{font-weight:normal;font-size:12px;line-height:16px;letter-spacing:0.1em;text-transform:uppercase;color:", (0, _colors.color_shades_darker), ";}}&.dragging{.feature-item{border:1px solid ", (0, _colors.color_shades_dark), ";}}&.disabled{.feature-item{background:", (0, _colors.color_shades_lighter), ";cursor:not-allowed;.feature-title{background:", (0, _colors.color_shades_lighter), ";}}}.overflow-menu-folder{margin-left:24px;margin-right:32px;&.margin-left{margin-left:auto;}}.feature-item{height:80px;background:#FFFFFF;border-bottom:1px solid ", (0, _colors.color_shades_dark), ";box-sizing:border-box;display:flex;align-items:center;padding:0 32px;&.top{border-top:1px solid ", (0, _colors.color_shades_dark), ";}&.not-selectable{padding-left:69px;}.feature-link{cursor:pointer;display:flex;align-items:center;color:", (0, _colors.color_shades_darkest), ";}.folder-icon{width:56px;height:56px;}.feature-title{background:white;margin-left:16px;margin-top:18px;font-family:Muli;font-style:normal;font-weight:600;font-size:18px;line-height:24px;padding-bottom:12px;border:none;color:", (0, _colors.color_text_default), ";white-space:nowrap;overflow:hidden;text-overflow:ellipsis;max-width:60vw;}.add-new-button-container{position:relative;}.count-container{text-align:right;margin-right:16px;margin-left:auto;border-right:1px solid ", (0, _colors.silver_four), ";padding:0 12px;h5{font-style:normal;font-weight:normal;font-size:18px;line-height:24px;}p{font-style:normal;font-weight:normal;font-size:12px;line-height:16px;color:", (0, _colors.color_shades_darker), ";}}.add-button{margin:0 24px;}}.child-container{display:flex;align-items:stretch;.spacer{width:32px;background:#E9EAEE;border:1px solid ", (0, _colors.color_shades_dark), ";box-sizing:border-box;}.child-content-container{flex:1;}.child-content-items-container{padding:32px;background:", (0, _colors.color_shades_lighter), ";}.content-item{height:64px;padding:0 16px;display:flex;align-items:center;background:#FFFFFF;border:1px solid ", (0, _colors.color_shades_dark), ";box-sizing:border-box;border-radius:4px;.content-item-icon{width:24px;height:24px;margin-right:16px;}.feature-type-title{font-family:Muli;font-style:normal;font-weight:normal;font-size:12px;line-height:16px;color:", (0, _colors.color_shades_darker), ";}.content-title{font-style:normal;font-weight:normal;font-size:14px;line-height:20px;color:", (0, _colors.color_shades_darkest), ";}}}.triangle-down{width:0;height:0;border-left:3px solid transparent;border-right:3px solid transparent;border-top:3px solid ", (0, _colors.color_shades_darkest), ";}.triangle-right{width:0;height:0;border-top:3px solid transparent;border-bottom:3px solid transparent;border-left:3px solid ", (0, _colors.color_shades_darkest), ";}.triangle-container{width:3px;height:3px;margin-right:8px;}.check{margin-top:4px;}", "");
exports.default = WebhookFolderItem;

},{"@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","react-router-dom":"5fzqq","../../../constants/colors":"1p3OR","../../../components/general/LargeOverflowMenu":"h9O0c","../../../components/forms/CheckIndicator":"8zBm6","../../../components/structure/ConfirmationDialog":"kx7yK","../../featureContent/components/DeleteConfirmation":"9xK2d","ec77d463df0e9eb0":"bY86c","875485359de29f3e":"jrTqc","8ee5536c29db73d0":"euMUu","62b4df57fb49c345":"1dzFf","e4c4ed8c0362805c":"3qx1D","f57f0ee478d0d25e":"iu0gE","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"bY86c":[function(require,module,exports) {
module.exports = require("885d45e5239a7b8c").getBundleURL("kVLro") + require("519bd45064749f10").resolve("6pbPW");

},{"885d45e5239a7b8c":"c7Tr5","519bd45064749f10":"fyJL2"}],"17CKJ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _colors = require("../../../constants/colors");
var _secondaryLoader = require("../../../components/general/SecondaryLoader");
var _secondaryLoaderDefault = parcelHelpers.interopDefault(_secondaryLoader);
const folderIcon = require("6e0762f3f09eaf4c");
class NewWebhookFolderItem extends (0, _reactDefault.default).Component {
    constructor(props){
        super(props);
        this.state = {
            text: "New Folder"
        };
    }
    componentDidMount() {
        this.inputElement?.focus();
    }
    handleBlur() {
        if (this.state.text) this.props.onFinish(this.state.text);
    }
    handleEnterBlur(e) {
        if (e.charCode == 13) e.target.blur();
    }
    handleChange(e) {
        this.setState({
            ...this.state,
            text: e.target.value
        });
    }
    render() {
        return (0, _react.jsx)("div", {
            className: containerStyle
        }, this.props.isLoading && (0, _react.jsx)((0, _secondaryLoaderDefault.default), null), (0, _react.jsx)("div", {
            className: "feature-link"
        }, (0, _react.jsx)("img", {
            className: "folder-icon",
            src: folderIcon
        }), (0, _react.jsx)("input", {
            className: "feature-title",
            placeholder: "New Folder",
            value: this.state.text,
            disabled: this.props.isLoading,
            ref: (r)=>this.inputElement = r,
            onChange: this.handleChange.bind(this),
            onBlur: this.handleBlur.bind(this),
            onFocus: (e)=>e.target.select(),
            onKeyPress: (e)=>this.handleEnterBlur(e)
        })));
    }
}
const containerStyle = /*#__PURE__*/ (0, _css.css)("height:80px;background:#FFFFFF;border:1px solid ", (0, _colors.color_shades_dark), ";box-sizing:border-box;display:flex;align-items:center;padding:0 32px;cursor:pointer;.feature-link{display:flex;align-items:center;color:", (0, _colors.color_shades_darkest), ";margin-left:36px;}.folder-icon{width:56px;height:56px;}.feature-title{background:white;margin-left:16px;margin-top:18px;font-family:Muli;font-style:normal;font-weight:600;font-size:18px;line-height:24px;padding-bottom:12px;border:none;color:", (0, _colors.color_text_default), ";}.spinner>div{background:", (0, _colors.color_text_link), ";}", "");
exports.default = NewWebhookFolderItem;

},{"@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","../../../constants/colors":"1p3OR","../../../components/general/SecondaryLoader":"7zJiF","6e0762f3f09eaf4c":"bY86c","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jPctm":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _footerBar = require("../../../components/structure/FooterBar");
var _footerBarDefault = parcelHelpers.interopDefault(_footerBar);
var _button = require("../../../components/general/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _css = require("@emotion/css");
var _customScrollbars = require("../../../components/structure/CustomScrollbars");
var _customScrollbarsDefault = parcelHelpers.interopDefault(_customScrollbars);
var _modalLayout = require("../../../components/structure/ModalLayout");
var _modalLayoutDefault = parcelHelpers.interopDefault(_modalLayout);
var _fullScreenLayout = require("../../fullScreenLayout");
var _fullScreenLayoutDefault = parcelHelpers.interopDefault(_fullScreenLayout);
var _pageContainer = require("../../../components/structure/PageContainer");
var _pageContainerDefault = parcelHelpers.interopDefault(_pageContainer);
var _horizontalContainer = require("../../../components/structure/HorizontalContainer");
var _horizontalContainerDefault = parcelHelpers.interopDefault(_horizontalContainer);
var _modalTitle = require("../../../components/general/ModalTitle");
var _modalTitleDefault = parcelHelpers.interopDefault(_modalTitle);
var _horizontalSeparator = require("../../../components/structure/HorizontalSeparator");
var _horizontalSeparatorDefault = parcelHelpers.interopDefault(_horizontalSeparator);
var _webhookToolbar = require("./WebhookToolbar");
var _webhookToolbarDefault = parcelHelpers.interopDefault(_webhookToolbar);
var _webhookList = require("./WebhookList");
var _webhookListDefault = parcelHelpers.interopDefault(_webhookList);
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const closeIcon = require("f053ca5e82515c95");
class WebhookFolderSelector extends (0, _reactDefault.default).Component {
    constructor(props){
        super(props);
        this.state = {
            currentFolderId: props.initialFolderId,
            isAddingNewFolder: false,
            selectedFolderIds: [],
            // default select the root when selecting a folder
            folderHistory: [],
            selectionText: ""
        };
    }
    componentDidMount() {
        this.setState({
            ...this.state,
            selectedFolderIds: [
                this.props.initialFolderId
            ]
        });
    }
    handleStartAddNewFolder() {
        this.setState({
            ...this.state,
            isAddingNewFolder: true
        });
    }
    handleAddNewFeature(text, parentFolderId) {
        this.props.webhookFolderContainer.createFolder(this.props.applicationId, text, parentFolderId).then((result)=>{
            if (result.resultType == "Ok") this.setState({
                ...this.state,
                isAddingNewFolder: false
            });
        });
    }
    getBreadCrumbItems() {
        var ancestors = this.props.webhookFolderContainer.getAllAncestors(this.state.currentFolderId);
        var crumbs = ancestors?.reverse()?.map((f)=>({
                id: f?.id,
                title: f?.name ?? "Untitled",
                link: `#`,
                highlighted: this.state.selectedFolderIds[0] == f?.id
            }));
        const isHomeHighlighted = this.state.selectedFolderIds[0] == null;
        crumbs = [
            {
                id: null,
                title: "Home",
                link: `#`,
                highlighted: isHomeHighlighted
            },
            ...crumbs
        ];
        return crumbs;
    }
    getFolders(parentFolderId) {
        return this.props.webhookFolderContainer.state.webhookFolders.filter((wf)=>wf.parentId == parentFolderId);
    }
    handleFolderSelectionChange(applicationFeature, isSelected) {
        var selectedIds = this.state.selectedFolderIds;
        if (isSelected) selectedIds = [
            applicationFeature?.id
        ];
        this.setState({
            ...this.state,
            selectedFolderIds: selectedIds
        });
    }
    handleClearSelections() {
        this.setState({
            ...this.state,
            selectedFolderIds: []
        });
    }
    handleFolderClick(folder) {
        const history = this.state.folderHistory;
        history.push(folder);
        this.setState({
            ...this.state,
            currentFolderId: folder?.id,
            folderHistory: history,
            selectedFolderIds: [
                folder.id
            ]
        });
    }
    handleFinishSelection() {
        this.props.onFinish(this.state.selectedFolderIds);
    }
    handleBreadcrumbClick(item) {
        this.setState({
            ...this.state,
            currentFolderId: item.id
        });
    }
    render() {
        const folder = this.props.webhookFolderContainer.findFolderById(this.state.currentFolderId);
        const application = this.props.appContainer.state.currentApp;
        return (0, _react.jsx)((0, _modalLayoutDefault.default), {
            isVisible: true,
            onClose: this.props.onClose
        }, (0, _react.jsx)((0, _fullScreenLayoutDefault.default), {
            className: containerStyle
        }, (0, _react.jsx)((0, _pageContainerDefault.default), {
            fill: true
        }, (0, _react.jsx)((0, _horizontalContainerDefault.default), {
            className: "header-wrapper"
        }, (0, _react.jsx)((0, _modalTitleDefault.default), null, this.props.title), (0, _react.jsx)((0, _buttonDefault.default), {
            className: "close-icon",
            themes: [
                "end-tight",
                "icon"
            ],
            icon: closeIcon,
            onClick: this.props.onClose
        })), (0, _react.jsx)((0, _horizontalSeparatorDefault.default), null), (0, _react.jsx)("div", {
            className: containerStyle
        }, (0, _react.jsx)((0, _webhookToolbarDefault.default), {
            showImport: false,
            showNewWebhook: false,
            onImport: null,
            showNewFolder: false,
            onAddNewWebhook: null,
            onAddNewFolder: this.handleStartAddNewFolder.bind(this),
            groupSelectionState: "none",
            onBreadCrumbItemClick: this.handleBreadcrumbClick.bind(this),
            breadCrumbs: this.getBreadCrumbItems(),
            history: null
        }), (0, _react.jsx)((0, _customScrollbarsDefault.default), {
            autoHide: true,
            className: "scrollable-container"
        }, (0, _react.jsx)((0, _webhookListDefault.default), {
            webhookFolderContainer: this.props.webhookFolderContainer,
            currentFolderId: this.state.currentFolderId,
            folders: this.getFolders(this.state.currentFolderId),
            onWebhookClick: null,
            webhooks: [],
            applicationId: this.props.applicationId,
            selectedWebhookIds: [],
            handleCreateNewFolder: null,
            disabledFolderIds: this.props.disabledFolderIds,
            selectedFolderIds: this.state.selectedFolderIds,
            onFolderClick: this.handleFolderClick.bind(this),
            onWebhookSelectionChange: null,
            onFolderSelectionChange: this.handleFolderSelectionChange.bind(this),
            showContentItems: false,
            selectableContentItems: false,
            selectableFeatures: true,
            isSingleSelect: true,
            showWebhookCount: false,
            withNesting: false,
            isAddingNewFolder: this.state.isAddingNewFolder,
            droppableId: "webhooks_modal"
        })), (0, _react.jsx)((0, _footerBarDefault.default), {
            small: true
        }, (0, _react.jsx)((0, _buttonDefault.default), {
            themes: [
                "primary"
            ],
            text: "Select",
            type: "button",
            loading: this.props.webhookFolderContainer.state.isLoading,
            disabled: this.props.webhookFolderContainer.state.isLoading || this.state.selectedFolderIds.length < 1,
            onClick: this.handleFinishSelection.bind(this)
        }))))));
    }
}
const containerStyle = /*#__PURE__*/ (0, _css.css)({
    name: "dy1jlk",
    styles: "height:100%;padding-bottom:80px;display:flex;flex-direction:column;h2{margin-left:32px;}.close-icon{margin-right:32px;margin-top:28px;}"
});
exports.default = WebhookFolderSelector;

},{"@emotion/react":"djZKr","react":"6uln9","../../../components/structure/FooterBar":"bibRL","../../../components/general/Button":"6ymxN","@emotion/css":"awUBr","../../../components/structure/CustomScrollbars":"50vFq","../../../components/structure/ModalLayout":"b1cO3","../../fullScreenLayout":"5mVdG","../../../components/structure/PageContainer":"hc1r8","../../../components/structure/HorizontalContainer":"eJPfh","../../../components/general/ModalTitle":"hIp2B","../../../components/structure/HorizontalSeparator":"Pw3HQ","./WebhookToolbar":"34NVS","./WebhookList":"hcs6V","f053ca5e82515c95":"93VwA","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8qWA9":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _base = require("@emotion/styled/base");
var _baseDefault = parcelHelpers.interopDefault(_base);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _formik = require("formik");
var _yup = require("yup");
var _modalLayout = require("../../../components/structure/ModalLayout");
var _modalLayoutDefault = parcelHelpers.interopDefault(_modalLayout);
var _fullScreenLayout = require("../../fullScreenLayout");
var _fullScreenLayoutDefault = parcelHelpers.interopDefault(_fullScreenLayout);
var _css = require("@emotion/css");
var _pageContainer = require("../../../components/structure/PageContainer");
var _pageContainerDefault = parcelHelpers.interopDefault(_pageContainer);
var _horizontalContainer = require("../../../components/structure/HorizontalContainer");
var _horizontalContainerDefault = parcelHelpers.interopDefault(_horizontalContainer);
var _modalTitle = require("../../../components/general/ModalTitle");
var _modalTitleDefault = parcelHelpers.interopDefault(_modalTitle);
var _button = require("../../../components/general/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _textField = require("../../../components/forms/TextField");
var _textFieldDefault = parcelHelpers.interopDefault(_textField);
var _colors = require("../../../constants/colors");
var _selectField = require("../../../components/forms/SelectField");
var _selectFieldDefault = parcelHelpers.interopDefault(_selectField);
var _footerBar = require("../../../components/structure/FooterBar");
var _footerBarDefault = parcelHelpers.interopDefault(_footerBar);
var _customScrollbars = require("../../../components/structure/CustomScrollbars");
var _customScrollbarsDefault = parcelHelpers.interopDefault(_customScrollbars);
var _switch = require("../../../components/forms/Switch");
var _switchDefault = parcelHelpers.interopDefault(_switch);
var _useWindowSize = require("../../../hooks/UseWindowSize");
var _useWindowSizeDefault = parcelHelpers.interopDefault(_useWindowSize);
var _textOverflowMenu = require("../../../components/general/overflowMenu/TextOverflowMenu");
var _textOverflowMenuDefault = parcelHelpers.interopDefault(_textOverflowMenu);
var _webhookSensitiveDataModal = require("./WebhookSensitiveDataModal");
var _webhookSensitiveDataModalDefault = parcelHelpers.interopDefault(_webhookSensitiveDataModal);
var _textAreaField = require("../../../components/forms/TextAreaField");
var _textAreaFieldDefault = parcelHelpers.interopDefault(_textAreaField);
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const closeIcon = require("a6cf1e6d2b9b5048");
const descriptionIcon = require("16a27c58229cdc14");
const typeIcon = require("8f02a49e62677dd8");
const linkIcon = require("fb849fe020658eb2");
const tokenIcon = require("96265d5453fff2bc");
const removeParameterIcon = require("69e33719c8aec6a");
const deleteIcon = require("c73e32159f2d361c");
const SENSITIVE_DATA_STATUS_DISABLE = "Disable";
const SENSITIVE_DATA_STATUS_UPDATE = "Regenerate Key";
const SENSITIVE_DATA_STATUS_GENERATE = "Generate New Key";
const WebhookFormComponent = (props)=>{
    const [isGenerateEncryptionKeyOpen, setIsGenerateEncryptionKeyOpen] = (0, _react1.useState)(false);
    const windowSize = (0, _useWindowSizeDefault.default)();
    const handleTypeChange = (value)=>{
        const finalValue = value === null ? null : value.value;
        props.setFieldValue("webhookTypeId", finalValue);
    };
    const handleTypeBlur = (blur)=>{
        props.setFieldTouched("webhookTypeId", blur);
    };
    const openGenerateEncryptionKey = (webhookId)=>{
        props.generateSensitiveDataKey(webhookId);
        setIsGenerateEncryptionKeyOpen(true);
    };
    const removeEncryptionKey = (webhookId)=>{
        props.removeSensitiveDataKey(webhookId);
    };
    const toggleWebhookSensitiveDataModal = ()=>{
        setIsGenerateEncryptionKeyOpen(!isGenerateEncryptionKeyOpen);
    };
    const handleClose = ()=>{
        toggleWebhookSensitiveDataModal();
    };
    return (0, _react.jsx)((0, _modalLayoutDefault.default), {
        className: modalStyle,
        isVisible: true,
        onClose: props.onClose,
        zIndex: 1010
    }, isGenerateEncryptionKeyOpen && (0, _react.jsx)((0, _webhookSensitiveDataModalDefault.default), {
        handleClose: handleClose,
        webhookToUpdate: props.webhookToUpdate,
        sensitiveData: props.webhookSensitiveData,
        isLoading: props.isLoading
    }), (0, _react.jsx)("form", {
        onSubmit: props.handleSubmit
    }, (0, _react.jsx)((0, _fullScreenLayoutDefault.default), {
        className: containerStyle
    }, (0, _react.jsx)((0, _pageContainerDefault.default), {
        fill: true
    }, (0, _react.jsx)((0, _horizontalContainerDefault.default), {
        className: "header-wrapper"
    }, (0, _react.jsx)((0, _modalTitleDefault.default), null, props.values.title ? props.values.title : props.editorType == "create" ? "Create Webhook" : "Update Webhook"), (0, _react.jsx)((0, _buttonDefault.default), {
        className: "close-icon",
        themes: [
            "end-tight",
            "icon"
        ],
        icon: closeIcon,
        type: "button",
        onClick: props.onClose
    })), (0, _react.jsx)((0, _customScrollbarsDefault.default), {
        autoHide: true,
        autoHeight: true,
        autoHeightMax: windowSize.windowSize.innerHeight * .9 - 188
    }, props.editorType == "update" && (0, _react.jsx)("div", {
        onClick: ()=>props.onWebhookDelete(props.webhookToUpdate),
        className: "delete-confirmation"
    }, (0, _react.jsx)("div", null, "Delete Webhooks & all Instances"), (0, _react.jsx)("img", {
        src: deleteIcon
    })), (0, _react.jsx)((0, _textFieldDefault.default), {
        className: "title-field",
        name: `title`,
        value: props.values.title,
        placeholder: "Enter webhook name",
        label: `Webhook Name`,
        onChange: props.handleChange,
        disabled: props.isLoading,
        onBlur: props.handleBlur
    }), props.editorType === "update" && (0, _react.jsx)(SensitiveDataContainer, null, (0, _react.jsx)((0, _textOverflowMenuDefault.default), {
        clickableText: props.values.hasSensitiveDataKey ? "Enabled" : "Disabled",
        menuClassName: dropdownMenuStyle,
        label: "Accepts Secure Data:",
        onOptionSelected: (option)=>{
            props.setFieldValue("hasSensitiveDataKey", option !== SENSITIVE_DATA_STATUS_DISABLE);
            option === SENSITIVE_DATA_STATUS_DISABLE ? removeEncryptionKey(props.webhookToUpdate.id) : openGenerateEncryptionKey(props.webhookToUpdate.id);
        },
        options: props.values.hasSensitiveDataKey ? [
            {
                label: SENSITIVE_DATA_STATUS_DISABLE
            },
            {
                label: SENSITIVE_DATA_STATUS_UPDATE
            }
        ] : [
            {
                label: SENSITIVE_DATA_STATUS_GENERATE
            }
        ]
    })), (0, _react.jsx)("div", {
        className: "main-form-container"
    }, (0, _react.jsx)((0, _horizontalContainerDefault.default), null, (0, _react.jsx)((0, _textFieldDefault.default), {
        labelIcon: descriptionIcon,
        className: "webhook-editor-text left",
        name: `description`,
        value: props.values.description,
        disabled: props.isLoading,
        placeholder: "Enter description",
        label: `Description`,
        onChange: props.handleChange,
        onBlur: props.handleBlur
    }), (0, _react.jsx)((0, _selectFieldDefault.default), {
        labelIcon: typeIcon,
        className: "webhook-editor-selector right",
        options: props.webhookTypes.map((o)=>({
                value: o.id,
                label: o.title
            })),
        value: props.values.webhookTypeId,
        onBlur: handleTypeBlur.bind(undefined),
        onChange: handleTypeChange.bind(undefined),
        disabled: props.isLoading,
        label: "Type",
        placeholder: "- None -",
        clearValueText: "- None -",
        clearable: true,
        name: "webhookTypeId"
    })), (0, _react.jsx)((0, _horizontalContainerDefault.default), null, (0, _react.jsx)((0, _textFieldDefault.default), {
        labelIcon: linkIcon,
        className: "webhook-editor-text left",
        name: `url`,
        value: props.values.url,
        disabled: props.isLoading,
        placeholder: "Enter webhook url",
        label: `URL`,
        onChange: props.handleChange,
        onBlur: props.handleBlur
    }), (0, _react.jsx)((0, _textFieldDefault.default), {
        labelIcon: tokenIcon,
        className: "webhook-editor-text right",
        name: `accessToken`,
        disabled: props.isLoading,
        value: props.values.accessToken,
        placeholder: "Enter token",
        label: `Token (Optional)`,
        onChange: props.handleChange,
        onBlur: props.handleBlur
    })), (0, _react.jsx)("div", {
        className: "sub-header"
    }, "Configuration Parameters"), (0, _react.jsx)("div", {
        className: "sub-header-description"
    }, "Configuration Parameters will be carried over to any instances of this webhook"), (0, _react.jsx)((0, _formik.FieldArray), {
        validateOnChange: false,
        name: "configurationParameters",
        render: (arrayHelpers)=>(0, _react.jsx)("div", null, props.values.configurationParameters.map((c, idx)=>{
                return (0, _react.jsx)("div", {
                    key: idx
                }, (0, _react.jsx)((0, _horizontalContainerDefault.default), {
                    className: "remove-parameter"
                }, (0, _react.jsx)("span", {
                    className: "left"
                }), (0, _react.jsx)("div", null, c.key ? c.key : "Configuration Parameter"), (0, _react.jsx)("span", {
                    className: "right"
                }), (0, _react.jsx)("img", {
                    src: removeParameterIcon,
                    onClick: ()=>{
                        arrayHelpers.remove(idx);
                    }
                })), (0, _react.jsx)((0, _horizontalContainerDefault.default), null, (0, _react.jsx)((0, _textFieldDefault.default), {
                    className: "webhook-editor-text left",
                    name: `configurationParameters.${idx}.key`,
                    value: c.key,
                    disabled: props.isLoading,
                    placeholder: "Enter configuration key",
                    label: `Key`,
                    onChange: props.handleChange,
                    onBlur: props.handleBlur
                }), (0, _react.jsx)((0, _textAreaFieldDefault.default), {
                    className: "webhook-editor-text right",
                    name: `configurationParameters.${idx}.value`,
                    disabled: props.isLoading,
                    value: c.value,
                    placeholder: "Enter configuration value",
                    label: `Value`,
                    showResponseVariableTest: true,
                    onChange: props.handleChange,
                    onBlur: props.handleBlur
                })));
            }), (0, _react.jsx)("div", {
                onClick: ()=>{
                    arrayHelpers.push({
                        value: "",
                        key: ""
                    });
                },
                className: `add-parameter-link ${props.values.configurationParameters.length > 0 ? "less-top-padding" : ""}`
            }, "+ Add a Configuration Parameter"))
    }), (0, _react.jsx)("div", {
        className: "sub-header"
    }, "Instance Parameters"), (0, _react.jsx)("div", {
        className: "sub-header-description"
    }, "Instance Parameters can be set up when a webhook is attached as an instance"), (0, _react.jsx)((0, _formik.FieldArray), {
        validateOnChange: false,
        name: "parameters",
        render: (arrayHelpers)=>(0, _react.jsx)("div", null, props.values.parameters.map((p, idx)=>{
                return (0, _react.jsx)("div", {
                    key: idx
                }, (0, _react.jsx)((0, _horizontalContainerDefault.default), {
                    className: "remove-parameter"
                }, (0, _react.jsx)("span", {
                    className: "left"
                }), (0, _react.jsx)("div", null, p.name ? p.name : "Instance Parameter"), (0, _react.jsx)("span", {
                    className: "right"
                }), (0, _react.jsx)("img", {
                    src: removeParameterIcon,
                    onClick: ()=>{
                        arrayHelpers.remove(idx);
                    }
                })), (0, _react.jsx)((0, _horizontalContainerDefault.default), null, (0, _react.jsx)((0, _textFieldDefault.default), {
                    className: "webhook-editor-text left",
                    name: `parameters.${idx}.name`,
                    value: p.name,
                    disabled: props.isLoading,
                    placeholder: "Enter a parameter key",
                    label: `Key`,
                    onChange: props.handleChange,
                    onBlur: props.handleBlur
                }), (0, _react.jsx)((0, _textFieldDefault.default), {
                    className: "webhook-editor-text right",
                    name: `parameters.${idx}.defaultValue`,
                    disabled: props.isLoading,
                    value: p.defaultValue,
                    placeholder: "Enter a default value",
                    label: `Default Value (Optional)`,
                    onChange: props.handleChange,
                    onBlur: props.handleBlur
                })), (0, _react.jsx)((0, _switchDefault.default), {
                    className: "switch-wrapper",
                    checked: p.isRequired,
                    onChange: (value)=>props.setFieldValue(`parameters.${idx}.isRequired`, value),
                    label: "Required Parameter",
                    disabled: props.isLoading
                }));
            }), (0, _react.jsx)("div", {
                onClick: ()=>{
                    arrayHelpers.push({
                        name: "",
                        defaultValue: "",
                        isRequired: false
                    });
                },
                className: `add-parameter-link less-bottom-padding ${props.values.parameters.length > 0 ? "less-top-padding" : ""}`
            }, "+ Add an Instance Parameter"))
    }))), (0, _react.jsx)((0, _footerBarDefault.default), null, (0, _react.jsx)((0, _buttonDefault.default), {
        className: "submit-button",
        loading: props.isLoading,
        disabled: props.isLoading,
        themes: [
            "primary",
            "wide"
        ],
        text: props.editorType == "create" ? "Create" : "Save",
        type: "submit"
    }), (0, _react.jsx)((0, _buttonDefault.default), {
        className: "cancel-button",
        loading: props.isLoading,
        disabled: props.isLoading,
        themes: [
            "white",
            "end"
        ],
        text: "Cancel",
        type: "button",
        onClick: props.onClose.bind(undefined)
    }))))));
};
const WebhookForm = (0, _formik.withFormik)({
    mapPropsToValues: (props)=>{
        if (props.editorType == "update") return {
            title: props.webhookToUpdate.title,
            description: props.webhookToUpdate.description,
            url: props.webhookToUpdate.url,
            webhookTypeId: props.webhookToUpdate.webhookType.id,
            accessToken: props.webhookToUpdate.accessToken,
            parameters: props.webhookToUpdate.parameters ?? [],
            configurationParameters: props.webhookToUpdate.configurationParameters ?? [],
            hasSensitiveDataKey: props.webhookToUpdate.hasSensitiveDataKey
        };
        else return {
            title: "",
            description: "",
            url: "",
            webhookTypeId: "",
            accessToken: "",
            parameters: [],
            configurationParameters: [],
            hasSensitiveDataKey: false
        };
    },
    validationSchema: _yup.object().shape({
        title: _yup.string().required("You must enter a title"),
        url: _yup.string().url().required("You must enter a webhook url"),
        webhookTypeId: _yup.string().required("You must choose a webhook type"),
        parameters: _yup.array().of(_yup.object().shape({
            name: _yup.string().required("You must enter an instance parameter key"),
            isRequired: _yup.boolean().required("You must specify if the parameter is required")
        })),
        configurationParameters: _yup.array().of(_yup.object().shape({
            key: _yup.string().required("You must enter a configuration parameter key"),
            value: _yup.string().required("You must enter a configuration parameter value")
        }))
    }),
    handleSubmit: (values, { props })=>{
        const model = {
            ...props.webhookToUpdate,
            webhookFolderId: props.currentFolderId,
            title: values.title,
            description: values.description,
            url: values.url,
            webhookType: props.webhookTypes.find((wt)=>wt.id == values.webhookTypeId),
            accessToken: values.accessToken,
            configurationParameters: values.configurationParameters,
            parameters: values.parameters
        };
        if (props.webhookToUpdate) props.finishUpdate(model);
        else props.finishCreate(model);
    }
})(WebhookFormComponent);
exports.default = WebhookForm;
const dropdownMenuStyle = /*#__PURE__*/ (0, _css.css)({
    name: "5q0cqp",
    styles: "margin-left:68px"
});
const SensitiveDataContainer = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "ei69hpd0"
})({
    name: "1wkdu0e",
    styles: "display:flex;justify-content:flex-end;margin-right:32px;margin-top:32px"
});
const modalStyle = /*#__PURE__*/ (0, _css.css)({
    name: "16l20fm",
    styles: "width:75vw;height:80vh"
});
const containerStyle = /*#__PURE__*/ (0, _css.css)(".delete-confirmation{color:", (0, _colors.color_colors_ocean), ";position:absolute;right:32px;top:16px;cursor:pointer;display:flex;div{font-style:normal;font-weight:normal;font-size:14px;line-height:20px;margin-right:16px;padding-top:2px;}}.header-wrapper{border-bottom:solid 1px ", (0, _colors.color_shades_dark), ";.close-icon{margin-right:32px;margin-top:28px;}h2{margin-left:32px;}}.switch-wrapper{margin-bottom:32px;}.title-field{margin:32px 32px 0px 32px;}.main-form-container{border:solid 1px ", (0, _colors.color_shades_dark), ";border-radius:6px;padding:32px;margin:8px 32px 32px 32px;}.sub-header{font-style:normal;font-weight:normal;font-size:14px;line-height:16px;letter-spacing:0.1em;text-transform:uppercase;color:", (0, _colors.color_shades_darkest), ";}.sub-header-description{margin-top:16px;font-style:normal;font-weight:normal;font-size:14px;line-height:20px;color:", (0, _colors.color_shades_darker), ";}.webhook-editor-text{margin-left:0px;&.left{margin-right:8px;}&.right{flex:1;margin-left:8px;}}.webhook-editor-selector{width:50%;margin-left:0px;&.left{padding-right:8px;}&.right{padding-left:8px;}.Select-control{border-radius:8px;height:60px;}.Select-input{margin:0px;}}.add-parameter-link{margin-top:16px;margin-bottom:32px;font-style:normal;font-weight:normal;font-size:14px;line-height:20px;color:", (0, _colors.color_colors_ocean), ";display:flex;flex-direction:row;cursor:pointer;&.less-top-padding{margin-top:0px;}&.less-bottom-padding{margin-bottom:0px;}}.remove-parameter{margin:16px 0px 16px 0px;display:flex;flex-direction:row;div{font-style:normal;font-weight:normal;font-size:16px;line-height:24px;color:", (0, _colors.color_shades_darkest), ";display:flex;flex-direction:row;}img{cursor:pointer;}span{border-bottom:solid 1px ", (0, _colors.color_shades_dark), ";margin-bottom:10px;&.left{width:10px;margin-right:8px;}&.right{margin-left:8px;flex-grow:1;margin-right:8px;}}}", "");

},{"@emotion/styled/base":"lSuFu","@emotion/react":"djZKr","react":"6uln9","formik":"3YnOK","yup":"j2SJU","../../../components/structure/ModalLayout":"b1cO3","../../fullScreenLayout":"5mVdG","@emotion/css":"awUBr","../../../components/structure/PageContainer":"hc1r8","../../../components/structure/HorizontalContainer":"eJPfh","../../../components/general/ModalTitle":"hIp2B","../../../components/general/Button":"6ymxN","../../../components/forms/TextField":"7a7bh","../../../constants/colors":"1p3OR","../../../components/forms/SelectField":"405B3","../../../components/structure/FooterBar":"bibRL","../../../components/structure/CustomScrollbars":"50vFq","../../../components/forms/Switch":"8kkL9","../../../hooks/UseWindowSize":"43j9z","../../../components/general/overflowMenu/TextOverflowMenu":"iiFcw","./WebhookSensitiveDataModal":"e4nk8","../../../components/forms/TextAreaField":"fE54C","a6cf1e6d2b9b5048":"93VwA","16a27c58229cdc14":"lg3om","8f02a49e62677dd8":"asKzP","fb849fe020658eb2":"guMp5","96265d5453fff2bc":"fPC8F","69e33719c8aec6a":"aDy6h","c73e32159f2d361c":"f9rzT","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"e4nk8":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _base = require("@emotion/styled/base");
var _baseDefault = parcelHelpers.interopDefault(_base);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _keyModalLayout = require("../../../components/structure/KeyModalLayout");
var _keyModalLayoutDefault = parcelHelpers.interopDefault(_keyModalLayout);
var _modalLayout = require("../../../components/structure/ModalLayout");
var _modalLayoutDefault = parcelHelpers.interopDefault(_modalLayout);
var _colors = require("../../../constants/colors");
const WebhookSensitiveDataModal = (props)=>{
    return (0, _react.jsx)(WebhookSensitiveDataModalStyled, {
        zIndex: 1010,
        isVisible: true,
        onClose: props.handleClose
    }, (0, _react.jsx)((0, _keyModalLayoutDefault.default), {
        modalTitle: "Sensitive Data Encryption Key",
        handleClose: props.handleClose,
        token: props.sensitiveData.key,
        isLoading: props.isLoading
    }));
};
const WebhookSensitiveDataModalStyled = /*#__PURE__*/ (0, _baseDefault.default)((0, _modalLayoutDefault.default), {
    target: "e15ba14p0"
})("color:", (0, _colors.color_text_default), ";.main-body{width:100%;}");
exports.default = WebhookSensitiveDataModal;

},{"@emotion/styled/base":"lSuFu","@emotion/react":"djZKr","react":"6uln9","../../../components/structure/KeyModalLayout":"QILh0","../../../components/structure/ModalLayout":"b1cO3","../../../constants/colors":"1p3OR","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"lg3om":[function(require,module,exports) {
module.exports = require("17318a8e89f87cba").getBundleURL("kVLro") + require("accf6e5c007f1ac7").resolve("dE2Fm");

},{"17318a8e89f87cba":"c7Tr5","accf6e5c007f1ac7":"fyJL2"}],"asKzP":[function(require,module,exports) {
module.exports = require("bf0e7da8c3e1148e").getBundleURL("kVLro") + require("5e217844a568e771").resolve("3EZN1");

},{"bf0e7da8c3e1148e":"c7Tr5","5e217844a568e771":"fyJL2"}],"guMp5":[function(require,module,exports) {
module.exports = require("cd5de5d2bf752ae1").getBundleURL("kVLro") + require("30b08dc74d84085b").resolve("6QapQ");

},{"cd5de5d2bf752ae1":"c7Tr5","30b08dc74d84085b":"fyJL2"}],"fPC8F":[function(require,module,exports) {
module.exports = require("9cc640e6e425166").getBundleURL("kVLro") + require("4238f74cad26748d").resolve("g5UeJ");

},{"9cc640e6e425166":"c7Tr5","4238f74cad26748d":"fyJL2"}],"4nHH3":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _css = require("@emotion/css");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _colors = require("../../../constants/colors");
const infoImage = require("badffe76baaa9663");
const OrphanedWebhooksHeader = (props)=>(0, _react.jsx)("div", {
        className: containerStyle
    }, (0, _react.jsx)("img", {
        src: infoImage
    }), (0, _react.jsx)("p", {
        className: "prompt"
    }, `You have ${props.count} orphaned webhooks. `), (0, _react.jsx)("span", null), (0, _react.jsx)("p", {
        className: "show-link",
        onClick: ()=>props.showOrphanedWebhooks()
    }, "View Them"));
const containerStyle = /*#__PURE__*/ (0, _css.css)("display:flex;border-bottom:1px solid ", (0, _colors.color_colors_gold), ";background:", (0, _colors.color_colors_gold_background), ";padding:18px 32px;font-style:normal;font-weight:normal;font-size:14px;line-height:20px;color:", (0, _colors.color_shades_darkest), ";.show-link{cursor:pointer;color:", (0, _colors.color_colors_ocean), ";padding-left:16px;border-left:1px solid ", (0, _colors.color_shades_dark), ";}img{margin-right:12px;}span{margin-left:auto;}", "");
exports.default = OrphanedWebhooksHeader;

},{"@emotion/react":"djZKr","@emotion/css":"awUBr","react":"6uln9","../../../constants/colors":"1p3OR","badffe76baaa9663":"k0Bys","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"boPHx":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _css = require("@emotion/css");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _button = require("../../../components/general/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _modalTitle = require("../../../components/general/ModalTitle");
var _modalTitleDefault = parcelHelpers.interopDefault(_modalTitle);
var _customScrollbars = require("../../../components/structure/CustomScrollbars");
var _customScrollbarsDefault = parcelHelpers.interopDefault(_customScrollbars);
var _footerBar = require("../../../components/structure/FooterBar");
var _footerBarDefault = parcelHelpers.interopDefault(_footerBar);
var _horizontalContainer = require("../../../components/structure/HorizontalContainer");
var _horizontalContainerDefault = parcelHelpers.interopDefault(_horizontalContainer);
var _horizontalSeparator = require("../../../components/structure/HorizontalSeparator");
var _horizontalSeparatorDefault = parcelHelpers.interopDefault(_horizontalSeparator);
var _modalLayout = require("../../../components/structure/ModalLayout");
var _modalLayoutDefault = parcelHelpers.interopDefault(_modalLayout);
var _pageContainer = require("../../../components/structure/PageContainer");
var _pageContainerDefault = parcelHelpers.interopDefault(_pageContainer);
var _colors = require("../../../constants/colors");
var _webhookListItem = require("./WebhookListItem");
var _webhookListItemDefault = parcelHelpers.interopDefault(_webhookListItem);
const closeIcon = require("ca7ddaeb27090046");
const OrphanedWebhooksModal = ({ webhooks, handleClose, handleAddToApp, handleRemove, isLoading })=>{
    const [selectedWebhookIds, setSelectedWebhookIds] = (0, _react1.useState)([]);
    const updateSelection = (webhook, isSelected)=>{
        if (!isSelected && selectedWebhookIds.some((id)=>id == webhook.id)) {
            const ids = selectedWebhookIds.filter((id)=>id != webhook.id);
            setSelectedWebhookIds(ids);
        } else if (isSelected && !selectedWebhookIds.some((id)=>id == webhook.id)) {
            let ids = [
                ...selectedWebhookIds
            ];
            ids.push(webhook.id);
            setSelectedWebhookIds(ids);
        }
    };
    return (0, _react.jsx)((0, _modalLayoutDefault.default), {
        className: containerStyle,
        isVisible: true,
        onClose: handleClose.bind(undefined)
    }, (0, _react.jsx)((0, _pageContainerDefault.default), {
        fill: true,
        withFooter: true
    }, (0, _react.jsx)((0, _horizontalContainerDefault.default), null, (0, _react.jsx)((0, _modalTitleDefault.default), {
        padded: true
    }, "Orphaned Webhooks"), (0, _react.jsx)((0, _buttonDefault.default), {
        themes: [
            "end-tight",
            "icon"
        ],
        icon: closeIcon,
        onClick: handleClose.bind(undefined)
    })), (0, _react.jsx)("div", {
        className: "orphaned-webhooks-description"
    }, (0, _react.jsx)("p", null, "These webhooks exist within your org but are not currently associated with any specific apps. Select which webhooks you’d like to move to your current app. "), (0, _react.jsx)("p", null, "Once they have been established within a particular app, webhooks can then be updated as needed.")), (0, _react.jsx)((0, _horizontalSeparatorDefault.default), null), (0, _react.jsx)((0, _customScrollbarsDefault.default), {
        autoHeight: true,
        autoHeightMin: 608,
        autoHeightMax: 608
    }, webhooks.map((webhook)=>(0, _react.jsx)((0, _webhookListItemDefault.default), {
            key: webhook.id,
            webhook: webhook,
            isSelected: selectedWebhookIds.some((id)=>id == webhook.id),
            selectable: true,
            disabled: false,
            onDelete: ()=>handleRemove(webhook),
            onClick: ()=>null,
            onSelectionChange: updateSelection.bind(undefined)
        }))), (0, _react.jsx)((0, _footerBarDefault.default), {
        className: "orphaned-webhooks-footer"
    }, (0, _react.jsx)((0, _buttonDefault.default), {
        type: "button",
        themes: [
            "primary"
        ],
        text: "Move to this app",
        onClick: ()=>handleAddToApp(selectedWebhookIds),
        disabled: isLoading || selectedWebhookIds.length == 0,
        loading: isLoading
    }), (0, _react.jsx)("div", {
        className: "selected-count"
    }, `${selectedWebhookIds.length} Selected`), (0, _react.jsx)((0, _buttonDefault.default), {
        type: "button",
        themes: [
            "secondary"
        ],
        text: "Cancel",
        onClick: handleClose.bind(undefined),
        disabled: isLoading,
        loading: isLoading
    }))));
};
const containerStyle = /*#__PURE__*/ (0, _css.css)("color:", (0, _colors.color_shades_darkest), ";height:900px;.orphaned-webhooks-description{padding:32px;border-top:1px solid ", (0, _colors.color_shades_dark), ";}.selected-count{font-style:normal;font-weight:600;font-size:16px;line-height:24px;margin-right:auto;}.orphaned-webhooks-footer{padding:32px 16px;}", "");
exports.default = OrphanedWebhooksModal;

},{"@emotion/react":"djZKr","@emotion/css":"awUBr","react":"6uln9","../../../components/general/Button":"6ymxN","../../../components/general/ModalTitle":"hIp2B","../../../components/structure/CustomScrollbars":"50vFq","../../../components/structure/FooterBar":"bibRL","../../../components/structure/HorizontalContainer":"eJPfh","../../../components/structure/HorizontalSeparator":"Pw3HQ","../../../components/structure/ModalLayout":"b1cO3","../../../components/structure/PageContainer":"hc1r8","../../../constants/colors":"1p3OR","./WebhookListItem":"an5B2","ca7ddaeb27090046":"93VwA","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"dHwU7":[function(require,module,exports) {
module.exports = require("4bcfb1c6c9be2d21").getBundleURL("kVLro") + require("3eed22514a4810a8").resolve("irHH7");

},{"4bcfb1c6c9be2d21":"c7Tr5","3eed22514a4810a8":"fyJL2"}],"bvK1D":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _tabContainerPanel = require("../../components/structure/Panels/TabContainerPanel");
var _tabContainerPanelDefault = parcelHelpers.interopDefault(_tabContainerPanel);
var _reactTabs = require("react-tabs");
var _colors = require("../../constants/colors");
var _ownedModules = require("./components/OwnedModules");
var _ownedModulesDefault = parcelHelpers.interopDefault(_ownedModules);
var _discoverModules = require("./components/DiscoverModules");
var _discoverModulesDefault = parcelHelpers.interopDefault(_discoverModules);
var _searchField = require("../../components/forms/SearchField");
var _searchFieldDefault = parcelHelpers.interopDefault(_searchField);
var _roundedTwoOptionButton = require("../../components/forms/RoundedTwoOptionButton");
var _roundedTwoOptionButtonDefault = parcelHelpers.interopDefault(_roundedTwoOptionButton);
var _horizontalContainer = require("../../components/structure/HorizontalContainer");
var _horizontalContainerDefault = parcelHelpers.interopDefault(_horizontalContainer);
var _stylesValues = require("../../constants/stylesValues");
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const ownedIcon = require("c178cb842f381854");
const ownedBlueIcon = require("64f7fd7b01042cf");
const discoverIcon = require("642c3499df174416");
const discoverBlueIcon = require("b5dcbb0faf9ec0fc");
const completeIcon = require("a6551934dafa986f");
const readyIcon = require("eb1274ca68d6dbf0");
const incompleteIcon = require("e9a7eadbcc393f26");
const WAIT_INTERVAL = 500;
const ENTER_KEY = 13;
const ApplicationModules = (props)=>{
    const appliedTemplates = props.appliedAppTemplateContainer.getLoadedTemplatesForApp(props.applicationId);
    const { availableTemplates, organizationTemplates, privateTemplates } = props.templateConfigurationContainer.state;
    const { integrationsListings } = props.integrationsContainer.state;
    let timer = null;
    (0, _react1.useEffect)(()=>{
        props.templateConfigurationContainer.getAvailableTemplates(props.orgContainer.state.currentOrganization?.id);
        props.templateConfigurationContainer.getOrganizationTemplates(props.orgContainer.state.currentOrganization?.id);
        props.templateConfigurationContainer.getPrivateTemplates(props.orgContainer.state.currentOrganization?.id);
        props.integrationsContainer.getListings(props.orgContainer.state.currentOrganization?.id);
        props.templateConfigurationContainer.loadCategories();
        props.templateConfigurationContainer.loadIndustries();
    }, []);
    const handleTabSelection = (index, last)=>{
        if (index == last) return;
        const urlStart = `/v/apps/${props.applicationId}/modules/`;
        if (index == 0) props.history.push(urlStart + window.location.search);
        if (index == 1) props.history.push(urlStart + "discover" + window.location.search);
    };
    const getSelectedIndex = ()=>{
        if (location.href.indexOf("discover") > -1) return 1;
        return 0;
    };
    const getStatusIcon = (status)=>{
        if (status == "incomplete") return incompleteIcon;
        if (status == "complete") return readyIcon;
        return completeIcon;
    };
    const getStatusLabel = (status)=>{
        switch(status){
            case "synced":
                return "In Use";
            case "complete":
                return "Ready";
            case "incomplete":
                return "Incomplete";
        }
    };
    const toggleView = ()=>{
        const newView = props.templateConfigurationContainer.state.defaultViewType == "card" ? "table" : "card";
        props.templateConfigurationContainer.setState({
            ...props.templateConfigurationContainer.state,
            defaultViewType: newView
        });
        localStorage.setItem("modulesViewType", newView);
    };
    const handleSearch = (searchEvent)=>{
        clearTimeout(timer);
        props.templateConfigurationContainer.setState({
            ...props.templateConfigurationContainer.state,
            searchFilter: searchEvent.target.value
        });
        timer = setTimeout(reloadTemplates, WAIT_INTERVAL);
    };
    const handleSearchKeyDown = (e)=>{
        if (e.keyCode === ENTER_KEY) reloadTemplates();
    };
    const reloadTemplates = ()=>{
        props.templateConfigurationContainer.changeTemplateFilter({
            ...props.templateConfigurationContainer.state,
            currentDiscoverPage: 1
        });
    };
    return (0, _react.jsx)((0, _tabContainerPanelDefault.default), {
        className: containerStyle,
        tabs: [
            {
                title: "Owned",
                icon: ownedIcon,
                className: "ac-frameworks-owned-tab ac-modules-owned-tab",
                selectedIcon: ownedBlueIcon
            },
            {
                title: "Discover",
                icon: discoverIcon,
                className: "ac-frameworks-discover-tab ac-modules-discover-tab",
                selectedIcon: discoverBlueIcon
            }
        ],
        selectedIndex: getSelectedIndex(),
        onTabSelected: handleTabSelection,
        additionalHeaderContent: ()=>(0, _react.jsx)((0, _horizontalContainerDefault.default), {
                className: searchAndModify
            }, (0, _react.jsx)((0, _searchFieldDefault.default), {
                id: "1",
                name: "searchField",
                placeholder: "Search",
                disabled: false,
                onChange: handleSearch,
                onKeyDown: handleSearchKeyDown,
                className: searchField
            }), (0, _react.jsx)("div", {
                className: "table-grid"
            }, (0, _react.jsx)((0, _roundedTwoOptionButtonDefault.default), {
                updateViewValue: toggleView,
                selectedOption: props.templateConfigurationContainer.state.defaultViewType == "table"
            }))),
        key: location.href
    }, (0, _react.jsx)((0, _reactTabs.TabPanel), null, (0, _react.jsx)((0, _ownedModulesDefault.default), {
        templateConfigurationContainer: props.templateConfigurationContainer,
        appliedTemplatesContainer: props.appliedAppTemplateContainer,
        applicationId: props.applicationId,
        appliedTemplates: appliedTemplates,
        organizationTemplates: organizationTemplates,
        privateTemplates: privateTemplates?.filter((t)=>t.organizationId != props.appContainer.state.organizationId)
    })), (0, _react.jsx)((0, _reactTabs.TabPanel), null, (0, _react.jsx)((0, _discoverModulesDefault.default), {
        templateConfigurationContainer: props.templateConfigurationContainer,
        appliedTemplatesContainer: props.appliedAppTemplateContainer,
        applicationId: props.applicationId,
        organizationId: props.appContainer.state.organizationId,
        appliedTemplates: appliedTemplates,
        availableTemplateConfigurations: availableTemplates,
        legacyIntegrations: integrationsListings
    })));
};
const containerStyle = /*#__PURE__*/ (0, _css.css)("width:100%;background:", (0, _colors.color_variants_main_bg), ";.panel-tab-list{flex:0;}", "");
const searchAndModify = /*#__PURE__*/ (0, _css.css)("margin:12px 0 12px 96px;padding:0 32px;border-left:", (0, _stylesValues.style_border_default), ";flex:1;div{box-shadow:none;}.number-container{box-shadow:none;}.field-container{height:32px;border-radius:16px;margin-top:0px;}.table-grid{margin-left:16px;}", "");
const searchField = /*#__PURE__*/ (0, _css.css)({
    name: "1tlmwo2",
    styles: "margin-bottom:0px"
});
exports.default = ApplicationModules;

},{"@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","../../components/structure/Panels/TabContainerPanel":"iDHIJ","react-tabs":"92Sgf","../../constants/colors":"1p3OR","./components/OwnedModules":"7lc1M","./components/DiscoverModules":"jyave","../../components/forms/SearchField":"aU10T","../../components/forms/RoundedTwoOptionButton":"7kmUj","../../components/structure/HorizontalContainer":"eJPfh","../../constants/stylesValues":"dHVVv","c178cb842f381854":"jZ7x0","64f7fd7b01042cf":"180gZ","642c3499df174416":"cOhL1","b5dcbb0faf9ec0fc":"ddjHw","a6551934dafa986f":"7CQ2Y","eb1274ca68d6dbf0":"cbVjq","e9a7eadbcc393f26":"4oiDX","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7lc1M":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _panelContainer = require("../../../components/structure/Panels/PanelContainer");
var _panelContainerDefault = parcelHelpers.interopDefault(_panelContainer);
var _staticMenuPanel = require("../../../components/structure/Panels/StaticMenuPanel");
var _staticMenuPanelDefault = parcelHelpers.interopDefault(_staticMenuPanel);
var _bodyPanel = require("../../../components/structure/Panels/BodyPanel");
var _bodyPanelDefault = parcelHelpers.interopDefault(_bodyPanel);
var _scrollablePanelBody = require("../../../components/structure/ScrollablePanelBody");
var _scrollablePanelBodyDefault = parcelHelpers.interopDefault(_scrollablePanelBody);
var _ownedModulesMenu = require("./OwnedModulesMenu");
var _ownedModulesMenuDefault = parcelHelpers.interopDefault(_ownedModulesMenu);
var _appliedTemplates = require("./AppliedTemplates");
var _appliedTemplatesDefault = parcelHelpers.interopDefault(_appliedTemplates);
var _ownedTemplates = require("./OwnedTemplates");
var _ownedTemplatesDefault = parcelHelpers.interopDefault(_ownedTemplates);
var _privateTemplates = require("./PrivateTemplates");
var _privateTemplatesDefault = parcelHelpers.interopDefault(_privateTemplates);
const OwnedModules = ({ templateConfigurationContainer, applicationId, organizationTemplates, privateTemplates, appliedTemplates })=>{
    const [templateType, setTemplateType] = (0, _react1.useState)(null);
    const [viewType, setViewType] = (0, _react1.useState)("Applied");
    return (0, _react.jsx)((0, _panelContainerDefault.default), null, (0, _react.jsx)((0, _staticMenuPanelDefault.default), null, (0, _react.jsx)((0, _ownedModulesMenuDefault.default), {
        onTypeChange: setTemplateType,
        onViewChange: setViewType,
        selectedView: viewType,
        selectedType: templateType,
        categories: templateConfigurationContainer.state.categories,
        industries: templateConfigurationContainer.state.industries
    })), (0, _react.jsx)((0, _bodyPanelDefault.default), null, (0, _react.jsx)((0, _scrollablePanelBodyDefault.default), null, viewType == "Applied" && (0, _react.jsx)((0, _appliedTemplatesDefault.default), {
        templateConfigurationContainer: templateConfigurationContainer,
        applicationId: applicationId,
        appliedTemplates: appliedTemplates
    }), viewType == "Owned" && (0, _react.jsx)((0, _ownedTemplatesDefault.default), {
        templateConfigurationContainer: templateConfigurationContainer,
        applicationId: applicationId,
        organizationTemplates: organizationTemplates
    }), viewType == "Access" && (0, _react.jsx)((0, _privateTemplatesDefault.default), {
        templateConfigurationContainer: templateConfigurationContainer,
        applicationId: applicationId,
        privateTemplates: privateTemplates
    }))));
};
exports.default = OwnedModules;

},{"@emotion/react":"djZKr","react":"6uln9","../../../components/structure/Panels/PanelContainer":"9R2lE","../../../components/structure/Panels/StaticMenuPanel":"dOVW0","../../../components/structure/Panels/BodyPanel":"dYF57","../../../components/structure/ScrollablePanelBody":"6LRg3","./OwnedModulesMenu":"5t8BS","./AppliedTemplates":"ehtzY","./OwnedTemplates":"5cHq5","./PrivateTemplates":"bEXMp","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"dOVW0":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _base = require("@emotion/styled/base");
var _baseDefault = parcelHelpers.interopDefault(_base);
var _stylesValues = require("../../../constants/stylesValues");
const StaticMenuPanel = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "ez0da710"
})(`
    width: 288px;
    max-width: 288px;
    border-right: ${(0, _stylesValues.style_border_default)};
    background: white;
`, "");
exports.default = StaticMenuPanel;

},{"@emotion/styled/base":"lSuFu","../../../constants/stylesValues":"dHVVv","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"dYF57":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _base = require("@emotion/styled/base");
var _baseDefault = parcelHelpers.interopDefault(_base);
const BodyPanel = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e14nrchh0"
})(`
    flex: 1;
`, "");
exports.default = BodyPanel;

},{"@emotion/styled/base":"lSuFu","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"5t8BS":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _base = require("@emotion/styled/base");
var _baseDefault = parcelHelpers.interopDefault(_base);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _stylesValues = require("../../../constants/stylesValues");
var _colors = require("../../../constants/colors");
const modulesIcon = require("9a94763ef466cf45");
const templatesIcon = require("71d7da57f9560610");
const integrationsIcon = require("d35b2a740e8ef54d");
const OwnedModulesMenu = ({ onTypeChange, onViewChange, selectedType, selectedView })=>{
    return (0, _react.jsx)(MenuBody, null, (0, _react.jsx)(ModuleTypeSection, null, (0, _react.jsx)(ModuleTypeHeader, null, "Type:"), (0, _react.jsx)("ul", null, (0, _react.jsx)(ModuleTypeItem, {
        className: !selectedType ? "selected" : "",
        onClick: ()=>onTypeChange(null)
    }, (0, _react.jsx)("img", {
        src: modulesIcon
    }), (0, _react.jsx)("p", null, "View All")), (0, _react.jsx)(ModuleTypeItem, {
        className: selectedType == "ContentTemplate" ? "selected" : "",
        onClick: ()=>onTypeChange("ContentTemplate")
    }, (0, _react.jsx)("img", {
        src: templatesIcon
    }), (0, _react.jsx)("p", null, "Templates")), (0, _react.jsx)(ModuleTypeItem, {
        className: selectedType == "Integration" ? "selected" : "",
        onClick: ()=>onTypeChange("Integration")
    }, (0, _react.jsx)("img", {
        src: integrationsIcon
    }), (0, _react.jsx)("p", null, "Integrations")))), (0, _react.jsx)(ModuleTypeSection, null, (0, _react.jsx)(ModuleTypeHeader, null, "View:"), (0, _react.jsx)("ul", null, (0, _react.jsx)(ModuleTypeItem, {
        className: selectedView == "Applied" || !selectedView ? "selected" : "",
        onClick: ()=>onViewChange("Applied")
    }, (0, _react.jsx)("p", null, "Applied Modules")), (0, _react.jsx)(ModuleTypeItem, {
        className: selectedView == "Owned" ? "selected" : "",
        onClick: ()=>onViewChange("Owned")
    }, (0, _react.jsx)("p", null, "Organization Modules")), (0, _react.jsx)(ModuleTypeItem, {
        className: selectedView == "Access" ? "selected" : "",
        onClick: ()=>onViewChange("Access")
    }, (0, _react.jsx)("p", null, "Private Modules")))));
};
const MenuBody = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e6v72113"
})(``, "");
const ModuleTypeSection = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e6v72112"
})(`
    border-bottom: ${(0, _stylesValues.style_border_default)};
    padding: 16px 8px;
`, "");
const ModuleTypeHeader = /*#__PURE__*/ (0, _baseDefault.default)("p", {
    target: "e6v72111"
})(`
    margin-left: 16px;
    margin-bottom: 8px;
    font-size: 16px;
    line-height: 24px;
`, "");
const ModuleTypeItem = /*#__PURE__*/ (0, _baseDefault.default)("li", {
    target: "e6v72110"
})(`
    padding-left: 16px;
    flex: 1;
    height: 32px;
    display: flex;
    align-items: center;
    font-size: 14px;
    line-height: 20px;
    cursor: pointer;
    img {
        margin-right: 12px;
        width: 20px;
    }
    &.selected {
        background: ${(0, _colors.color_variants_ocean_light_1)};
        border-radius: 4px;
        color: ${(0, _colors.color_text_link)};
    }
`, "");
exports.default = OwnedModulesMenu;

},{"@emotion/styled/base":"lSuFu","@emotion/react":"djZKr","react":"6uln9","../../../constants/stylesValues":"dHVVv","../../../constants/colors":"1p3OR","9a94763ef466cf45":"9vjp1","71d7da57f9560610":"7e2U1","d35b2a740e8ef54d":"bRn2E","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9vjp1":[function(require,module,exports) {
module.exports = require("5b4facbf65f7e309").getBundleURL("kVLro") + require("540ddb80cf4d71dc").resolve("jvbjc");

},{"5b4facbf65f7e309":"c7Tr5","540ddb80cf4d71dc":"fyJL2"}],"7e2U1":[function(require,module,exports) {
module.exports = require("5c91501d2c55b208").getBundleURL("kVLro") + require("ced827c0bf74fcd6").resolve("3g0DN");

},{"5c91501d2c55b208":"c7Tr5","ced827c0bf74fcd6":"fyJL2"}],"bRn2E":[function(require,module,exports) {
module.exports = require("1618b72e4d175d6f").getBundleURL("kVLro") + require("b67d0b7f2ca420b0").resolve("cxB5o");

},{"1618b72e4d175d6f":"c7Tr5","b67d0b7f2ca420b0":"fyJL2"}],"ehtzY":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _base = require("@emotion/styled/base");
var _baseDefault = parcelHelpers.interopDefault(_base);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _moduleListItem = require("./ModuleListItem");
var _moduleListItemDefault = parcelHelpers.interopDefault(_moduleListItem);
var _moduleCard = require("./ModuleCard");
var _moduleCardDefault = parcelHelpers.interopDefault(_moduleCard);
var _colors = require("../../../constants/colors");
var _emptyView = require("./EmptyView");
var _emptyViewDefault = parcelHelpers.interopDefault(_emptyView);
var _secondaryLoader = require("../../../components/general/SecondaryLoader");
var _secondaryLoaderDefault = parcelHelpers.interopDefault(_secondaryLoader);
const AppliedTemplates = ({ templateConfigurationContainer, applicationId, appliedTemplates })=>{
    return (0, _react.jsx)(InnerPageWrapper, null, (0, _react.jsx)(PageHeader, null, "Applied Modules"), appliedTemplates.length > 0 && (0, _react.jsx)(PageDetail, null, "These are the modules that have been applied to this app"), templateConfigurationContainer.state.isLoading && (0, _react.jsx)(LoaderWrapper, null, (0, _react.jsx)((0, _secondaryLoaderDefault.default), null)), templateConfigurationContainer.state.defaultViewType == "table" ? (0, _react.jsx)(ListWrapper, null, appliedTemplates?.map((t)=>(0, _react.jsx)("li", {
            key: t.id
        }, (0, _react.jsx)((0, _moduleListItemDefault.default), {
            templateConfiguration: t.templateForm.templateConfiguration,
            appliedTemplate: t,
            key: t.id,
            applicationId: applicationId
        })))) : (0, _react.jsx)(CardWrapper, null, appliedTemplates?.map((t)=>(0, _react.jsx)("li", {
            key: t.id
        }, (0, _react.jsx)((0, _moduleCardDefault.default), {
            templateConfiguration: t.templateForm.templateConfiguration,
            appliedTemplate: t,
            key: t.id,
            applicationId: applicationId
        })))), appliedTemplates?.length < 1 && !templateConfigurationContainer.state.isLoading && (0, _react.jsx)((0, _emptyViewDefault.default), {
        title: "It's quiet in here!",
        description: "No modules have been applied to this app yet."
    }));
};
const InnerPageWrapper = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "ewse03k5"
})(`
    padding-bottom: 128px;
`, "");
const CardWrapper = /*#__PURE__*/ (0, _baseDefault.default)("ul", {
    target: "ewse03k4"
})(`
    display: flex;
    flex-wrap: wrap;
    list-style-type: none;
`, "");
const ListWrapper = /*#__PURE__*/ (0, _baseDefault.default)("ul", {
    target: "ewse03k3"
})(`
    list-style-type: none;
`, "");
const LoaderWrapper = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "ewse03k2"
})(`
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 32px;
    .spinner > div {
        background-color: ${(0, _colors.color_colors_ocean)};
    }
`, "");
const PageHeader = /*#__PURE__*/ (0, _baseDefault.default)("h3", {
    target: "ewse03k1"
})(`
    font-size: 24px;
    font-weight: normal;
    line-height: 32px;
    margin: 32px 0 24px 32px;
`, "");
const PageDetail = /*#__PURE__*/ (0, _baseDefault.default)("p", {
    target: "ewse03k0"
})(`
    margin: auto 32px;
`, "");
exports.default = AppliedTemplates;

},{"@emotion/styled/base":"lSuFu","@emotion/react":"djZKr","react":"6uln9","./ModuleListItem":"eFNRM","./ModuleCard":"gK70m","../../../constants/colors":"1p3OR","./EmptyView":"ffYYa","../../../components/general/SecondaryLoader":"7zJiF","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"eFNRM":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _base = require("@emotion/styled/base");
var _baseDefault = parcelHelpers.interopDefault(_base);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _colors = require("../../../constants/colors");
var _stylesValues = require("../../../constants/stylesValues");
var _reactRouterDom = require("react-router-dom");
var _css = require("@emotion/css");
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const defaultImage = require("bc02ff4a27774a4f");
const templateIcon = require("1677f64653ef87d9");
const integrationIcon = require("cdb9738a2bdc7c95");
const readyIcon = require("8cc0352ea4f5a9f");
const notEnabledIcon = require("affad0fb0f2b2287");
const ModuleListItem = ({ templateConfiguration, appliedTemplate, applicationId })=>{
    return (0, _react.jsx)((0, _reactRouterDom.Link), {
        className: `${moduleLink} ac-framework-list-item ac-module-list-item`,
        to: appliedTemplate?.id ? `/v/apps/${applicationId}/modules/applied/${appliedTemplate.id}` : `/v/apps/${applicationId}/modules/${templateConfiguration?.id}/details`
    }, (0, _react.jsx)(CardBody, null, (0, _react.jsx)(CardHeader, null), (0, _react.jsx)(CardImageWrapper, null, (0, _react.jsx)("img", {
        src: templateConfiguration?.imageUrl ?? defaultImage
    })), (0, _react.jsx)(InnerCardBody, null, (0, _react.jsx)("p", {
        className: "template-title"
    }, appliedTemplate?.name?.length > 0 ? appliedTemplate.name : templateConfiguration?.name), (0, _react.jsx)("p", {
        className: "template-byline"
    }, (0, _react.jsx)("img", {
        src: templateConfiguration?.templateType == "Integration" ? integrationIcon : templateIcon
    }), (0, _react.jsx)("span", null, `${templateConfiguration?.templateType == "Integration" ? "Integration" : "Template"} - by ${templateConfiguration?.ownerName}`), (0, _react.jsx)("span", {
        className: "version-label"
    }, templateConfiguration?.currentVersion?.versionName ? `version: ${templateConfiguration.currentVersion.versionName}` : null)), (0, _react.jsx)(CardDescription, null, (0, _react.jsx)("p", {
        className: "template-description"
    }, templateConfiguration.shortDescription))), (0, _react.jsx)(CardEnd, null, (0, _react.jsx)("p", {
        className: "template-status"
    }, (0, _react.jsx)("span", null, appliedTemplate ? "Enabled" : "Not Enabled"), (0, _react.jsx)("img", {
        src: appliedTemplate ? readyIcon : notEnabledIcon
    })))));
};
const moduleLink = /*#__PURE__*/ (0, _css.css)({
    name: "4zleql",
    styles: "display:block"
});
const CardBody = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1lrhuxd5"
})(`
    border: ${(0, _stylesValues.style_border_default)};
    box-sizing: border-box;
    border-radius: 8px;
    background: white;
    width: calc(100% - 64px);
    height: 160px;
    position: relative;
    margin-left: 32px;
    margin-top: 32px;
    overflow: hidden;
    display: flex;
    align-items: center;
    cursor: pointer;
    color: ${(0, _colors.color_text_default)};
`, "");
const CardHeader = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1lrhuxd4"
})(`
    background: ${(0, _colors.color_shades_lighter)};
    width: 72px;
    height: 100%;
    border-right: ${(0, _stylesValues.style_border_default)};
`, "");
const CardDescription = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1lrhuxd3"
})(`
    height: 85px;
    overflow: hidden;
`, "");
const CardImageWrapper = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1lrhuxd2"
})(`
    position: absolute;
    width: 96px;
    height: 96px;
    margin-left: 24px;
    background: white;
    border: ${(0, _stylesValues.style_border_default)};
    border-radius: 8px;
    overflow: hidden;
    img {
        max-height: 100%;
        max-width: 100%;
    }
`, "");
const InnerCardBody = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1lrhuxd1"
})(`
    display: flex;
    flex-direction: column;
    margin-left: 80px;
    color: ${(0, _colors.color_text_default)};
    flex: 1;
    .template-title {
        margin-top: 16px;
        margin-bottom: 5px;
        font-style: normal;
        font-weight: normal;
        font-size: 24px;
        line-height: 32px;
    }
    .template-byline {
        display: flex;
        align-items: center;
        color: ${(0, _colors.color_text_light)};
        font-size: 14px;
        line-height: 20px;
        img {
            margin-right: 8px;
        }
        .version-label {
            padding-left: 8px;
        }
    }
    .template-description {
        margin-top: 24px;
    }
`, "");
const CardEnd = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1lrhuxd0"
})(`
    height: calc(100% - 48px);
    width: 200px;
    border-left: ${(0, _stylesValues.style_border_default)};
    margin: 24px;
    display: flex;
    flex-direction: column;
    align-items: center;
    .template-price {
        display: flex;
        align-items: center;
        margin-right: 0;
        margin-left: auto;
        margin-bottom: 0;
        margin-top: auto;
        .price-label {
            font-style: normal;
            font-weight: normal;
            font-size: 12px;
            line-height: 16px;
            color: ${(0, _colors.color_text_light)};
            display: block;
            margin-right: 8px;
        }
        .price-value {
            font-style: normal;
            font-weight: normal;
            font-size: 18px;
            line-height: 24px;
            display: block;
        }
    }
    .template-status {
        margin-right: 0;
        margin-left: auto;
        font-size: 14px;
        line-height: 20px;
        font-style: italic;
        color: ${(0, _colors.color_text_light)};
        display: flex;
        align-items: center;
        &.enabled {
            color: ${(0, _colors.color_colors_growth)};
        }
        img {
            width: 24px;
            margin-left: 8px;
        }
    }
`, "");
exports.default = ModuleListItem;

},{"@emotion/styled/base":"lSuFu","@emotion/react":"djZKr","react":"6uln9","../../../constants/colors":"1p3OR","../../../constants/stylesValues":"dHVVv","react-router-dom":"5fzqq","@emotion/css":"awUBr","bc02ff4a27774a4f":"e2QPt","1677f64653ef87d9":"liQyF","cdb9738a2bdc7c95":"k12bg","8cc0352ea4f5a9f":"cbVjq","affad0fb0f2b2287":"71Ovv","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"liQyF":[function(require,module,exports) {
module.exports = require("555f5c6662d0451b").getBundleURL("kVLro") + require("7184269483fbb80c").resolve("gWF4F");

},{"555f5c6662d0451b":"c7Tr5","7184269483fbb80c":"fyJL2"}],"k12bg":[function(require,module,exports) {
module.exports = require("d04cb0a1379152c6").getBundleURL("kVLro") + require("1e2fe038089ee132").resolve("jyWbU");

},{"d04cb0a1379152c6":"c7Tr5","1e2fe038089ee132":"fyJL2"}],"gK70m":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _base = require("@emotion/styled/base");
var _baseDefault = parcelHelpers.interopDefault(_base);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _colors = require("../../../constants/colors");
var _stylesValues = require("../../../constants/stylesValues");
var _reactRouterDom = require("react-router-dom");
var _css = require("@emotion/css");
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const defaultImage = require("5f5a4999f2b00e3");
const templateIcon = require("6824e2b1ac1f1aa");
const integrationIcon = require("42e25aa348083edc");
const readyIcon = require("ed4014fc2141d7d9");
const notEnabledIcon = require("45113179fe8e4a92");
const versionIcon = require("591fd1c291d3b3f1");
const timeIcon = require("6b26cc7641e02ec4");
const ModuleCard = ({ templateConfiguration, appliedTemplate, applicationId })=>{
    let isOutdated = true;
    if (templateConfiguration?.currentVersion?.id !== undefined && templateConfiguration?.currentVersion?.id === appliedTemplate?.appliedVersion?.id) isOutdated = false;
    return (0, _react.jsx)((0, _reactRouterDom.Link), {
        to: applicationId ? appliedTemplate?.id ? `/v/apps/${applicationId}/modules/applied/${appliedTemplate.id}` : `/v/apps/${applicationId}/modules/${templateConfiguration?.id}/details` : "#",
        className: `${moduleLink} modules-card ac-framework-list-item ac-module-list-item`
    }, (0, _react.jsx)(CardBody, null, (0, _react.jsx)(CardHeader, null), (0, _react.jsx)(CardImageWrapper, null, (0, _react.jsx)("img", {
        src: templateConfiguration?.imageUrl ?? defaultImage
    })), (0, _react.jsx)(InnerCardBody, null, (0, _react.jsx)("p", {
        className: "version-label"
    }, templateConfiguration?.currentVersion?.versionName ? `version: ${templateConfiguration.currentVersion.versionName}` : " "), (0, _react.jsx)("p", {
        className: "template-title"
    }, appliedTemplate?.name?.length > 0 ? appliedTemplate.name : templateConfiguration?.name), (0, _react.jsx)("p", {
        className: "template-byline"
    }, (0, _react.jsx)("img", {
        src: templateConfiguration?.templateType == "Integration" ? integrationIcon : templateIcon
    }), (0, _react.jsx)("span", null, `${templateConfiguration?.templateType == "Integration" ? "Integration" : "Template"} - by ${templateConfiguration?.ownerName}`)), (0, _react.jsx)("p", {
        className: "template-details"
    }, (0, _react.jsx)("img", {
        src: timeIcon
    }), (0, _react.jsx)("span", null, "Last Sync Date: ", appliedTemplate?.lastSyncedDate ? new Date(appliedTemplate?.lastSyncedDate).toDateString() : new Date().toDateString())), (0, _react.jsx)("p", {
        className: "template-details"
    }, (0, _react.jsx)("img", {
        src: versionIcon
    }), (0, _react.jsx)("span", null, "Applied Version: ", appliedTemplate?.appliedVersion?.versionName ?? "NA")), (0, _react.jsx)(CardDescription, null, (0, _react.jsx)("p", {
        className: "template-description"
    }, templateConfiguration.shortDescription))), (0, _react.jsx)(CardFooter, null, (0, _react.jsx)("p", {
        className: "template-status"
    }, (0, _react.jsx)("span", null, appliedTemplate ? "Enabled" : "Not Enabled"), (0, _react.jsx)("img", {
        src: appliedTemplate ? readyIcon : notEnabledIcon
    })))));
};
const moduleLink = /*#__PURE__*/ (0, _css.css)({
    name: "1r5gb7q",
    styles: "display:inline-block"
});
const CardBody = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "eqqpcpn5"
})(`
    border: ${(0, _stylesValues.style_border_default)};
    box-sizing: border-box;
    border-radius: 8px;
    background: white;
    width: 340px;
    height: 376px;
    position: relative;
    margin-left: 32px;
    margin-top: 32px;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    cursor: pointer;
    color: ${(0, _colors.color_text_default)};
`, "");
const CardHeader = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "eqqpcpn4"
})(`
    background: ${(0, _colors.color_shades_lighter)};
    height: 102px;
    border-bottom: ${(0, _stylesValues.style_border_default)};
`, "");
const CardDescription = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "eqqpcpn3"
})(`
    height: 72px;    
    overflow: hidden;
`, "");
const CardImageWrapper = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "eqqpcpn2"
})(`
    position: absolute;
    width: 96px;
    height: 96px;
    margin-left: 24px;
    margin-top: 24px;
    background: white;
    border: ${(0, _stylesValues.style_border_default)};
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
    img {
        max-height: 100%;
        max-width: 100%;
    }
`, "");
const InnerCardBody = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "eqqpcpn1"
})(`
    display: flex;
    flex-direction: column;
    margin: 24px;
    color: ${(0, _colors.color_text_default)};
    flex: 1;
    .version-label {
        margin-right: 0;
        margin-left: auto;
        text-align: right;        
        font-size: 14px;
        line-height: 20px;
        height: 20px;
    }
    .template-title {
       margin-top: 16px;
        margin-bottom: 5px;
        font-style: normal;
        font-weight: normal;
        font-size: 20px;
        line-height: 32px;
    }
    .template-byline {
        display: flex;
        align-items: center;
        color: ${(0, _colors.color_text_light)};
        font-size: 14px;
        line-height: 20px;
        img {
            margin-right: 8px;
        }
    }
    .template-details {
        display: flex;
        align-items: center;
        color: ${(0, _colors.color_text_light)};
        font-size: 14px;
        line-height: 20px;
        margin-top: 8px;
        img {
            margin-right: 8px;
        }
    }
    .template-description {
        margin-top: 8px;
    }
`, "");
const CardFooter = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "eqqpcpn0"
})(`
    height: 72px;
    border-top: ${(0, _stylesValues.style_border_default)};
    margin: 0 24px;
    display: flex;
    align-items: center;
    .template-price {
        .price-label {
            font-style: normal;
            font-weight: normal;
            font-size: 12px;
            line-height: 16px;
            color: ${(0, _colors.color_text_light)};
            display: block;
        }
        .price-value {
            font-style: normal;
            font-weight: normal;
            font-size: 18px;
            line-height: 24px;
            display: block;
        }
    }
    .template-status {
        margin-right: 0;
        margin-left: auto;
        font-size: 14px;
        line-height: 20px;
        font-style: italic;
        color: ${(0, _colors.color_text_light)};
        display: flex;
        align-items: center;
        &.enabled {
            color: ${(0, _colors.color_colors_growth)};
        }
        img {
            width: 24px;
            margin-left: 8px;
        }
    }
`, "");
exports.default = ModuleCard;

},{"@emotion/styled/base":"lSuFu","@emotion/react":"djZKr","react":"6uln9","../../../constants/colors":"1p3OR","../../../constants/stylesValues":"dHVVv","react-router-dom":"5fzqq","@emotion/css":"awUBr","5f5a4999f2b00e3":"e2QPt","6824e2b1ac1f1aa":"liQyF","42e25aa348083edc":"k12bg","ed4014fc2141d7d9":"cbVjq","45113179fe8e4a92":"71Ovv","591fd1c291d3b3f1":"9gflY","6b26cc7641e02ec4":"awsXh","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9gflY":[function(require,module,exports) {
module.exports = require("11c99c3fd46932fd").getBundleURL("kVLro") + require("407e41b0c2d29c37").resolve("9FUed");

},{"11c99c3fd46932fd":"c7Tr5","407e41b0c2d29c37":"fyJL2"}],"awsXh":[function(require,module,exports) {
module.exports = require("6d9ebf59abe123ca").getBundleURL("kVLro") + require("e2f4500caeb4e329").resolve("1Nwtn");

},{"6d9ebf59abe123ca":"c7Tr5","e2f4500caeb4e329":"fyJL2"}],"5cHq5":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _base = require("@emotion/styled/base");
var _baseDefault = parcelHelpers.interopDefault(_base);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _moduleCard = require("./ModuleCard");
var _moduleCardDefault = parcelHelpers.interopDefault(_moduleCard);
var _colors = require("../../../constants/colors");
var _emptyView = require("./EmptyView");
var _emptyViewDefault = parcelHelpers.interopDefault(_emptyView);
var _moduleListItem = require("./ModuleListItem");
var _moduleListItemDefault = parcelHelpers.interopDefault(_moduleListItem);
var _secondaryLoader = require("../../../components/general/SecondaryLoader");
var _secondaryLoaderDefault = parcelHelpers.interopDefault(_secondaryLoader);
const OwnedTemplates = ({ templateConfigurationContainer, applicationId, organizationTemplates })=>{
    return (0, _react.jsx)(InnerPageContainer, null, (0, _react.jsx)(PageHeader, null, "Organization Modules"), (0, _react.jsx)(PageDetail, null, "These are the modules owned by this organization"), templateConfigurationContainer.state.isLoading && (0, _react.jsx)(LoaderContainer, null, (0, _react.jsx)((0, _secondaryLoaderDefault.default), null)), templateConfigurationContainer.state.defaultViewType == "table" ? (0, _react.jsx)(ListContainer, null, organizationTemplates?.map((t)=>(0, _react.jsx)("li", {
            key: t.id
        }, (0, _react.jsx)((0, _moduleListItemDefault.default), {
            templateConfiguration: t,
            key: t.id,
            applicationId: applicationId
        })))) : (0, _react.jsx)(CardContainer, null, organizationTemplates?.map((t)=>(0, _react.jsx)("li", {
            key: t.id
        }, (0, _react.jsx)((0, _moduleCardDefault.default), {
            templateConfiguration: t,
            key: t.id,
            applicationId: applicationId
        })))), organizationTemplates?.length < 1 && !templateConfigurationContainer.state.isLoading && (0, _react.jsx)((0, _emptyViewDefault.default), {
        title: "It's quiet in here!",
        description: "This is where you'll see the modules you've created in this organization. Try creating a template app or integration module!",
        actionLink: `/v/modules`,
        actionText: "Build Modules"
    }));
};
const InnerPageContainer = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e5qm9le5"
})(`
    padding-bottom: 128px;
`, "");
const CardContainer = /*#__PURE__*/ (0, _baseDefault.default)("ul", {
    target: "e5qm9le4"
})(`
    display: flex;
    flex-wrap: wrap;
    list-style-type: none;
`, "");
const ListContainer = /*#__PURE__*/ (0, _baseDefault.default)("ul", {
    target: "e5qm9le3"
})(`
    list-style-type: none;
`, "");
const LoaderContainer = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e5qm9le2"
})(`
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 32px;
    .spinner > div {
        background-color: ${(0, _colors.color_colors_ocean)};
    }
`, "");
const PageHeader = /*#__PURE__*/ (0, _baseDefault.default)("h3", {
    target: "e5qm9le1"
})(`
    font-size: 24px;
    font-weight: normal;
    line-height: 32px;
    margin: 32px 0 24px 32px;
`, "");
const PageDetail = /*#__PURE__*/ (0, _baseDefault.default)("p", {
    target: "e5qm9le0"
})(`
    margin: auto 32px;
`, "");
exports.default = OwnedTemplates;

},{"@emotion/styled/base":"lSuFu","@emotion/react":"djZKr","react":"6uln9","./ModuleCard":"gK70m","../../../constants/colors":"1p3OR","./EmptyView":"ffYYa","./ModuleListItem":"eFNRM","../../../components/general/SecondaryLoader":"7zJiF","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"bEXMp":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _base = require("@emotion/styled/base");
var _baseDefault = parcelHelpers.interopDefault(_base);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _colors = require("../../../constants/colors");
var _moduleCard = require("./ModuleCard");
var _moduleCardDefault = parcelHelpers.interopDefault(_moduleCard);
var _moduleListItem = require("./ModuleListItem");
var _moduleListItemDefault = parcelHelpers.interopDefault(_moduleListItem);
var _secondaryLoader = require("../../../components/general/SecondaryLoader");
var _secondaryLoaderDefault = parcelHelpers.interopDefault(_secondaryLoader);
var _emptyView = require("./EmptyView");
var _emptyViewDefault = parcelHelpers.interopDefault(_emptyView);
const PrivateTemplates = ({ templateConfigurationContainer, applicationId, privateTemplates })=>{
    return (0, _react.jsx)(InnerPageContainer, null, (0, _react.jsx)(PageHeader, null, "Private Modules"), (0, _react.jsx)(PageDetail, null, "These are the private modules you've been given access to from other organizations"), templateConfigurationContainer.state.isLoading && (0, _react.jsx)(LoaderContainer, null, (0, _react.jsx)((0, _secondaryLoaderDefault.default), null)), templateConfigurationContainer.state.defaultViewType == "table" ? (0, _react.jsx)(ListContainer, null, privateTemplates?.map((t)=>(0, _react.jsx)("li", {
            key: t.id
        }, (0, _react.jsx)((0, _moduleListItemDefault.default), {
            templateConfiguration: t,
            key: t.id,
            applicationId: applicationId
        })))) : (0, _react.jsx)(CardContainer, null, privateTemplates?.map((t)=>(0, _react.jsx)("li", {
            key: t.id
        }, (0, _react.jsx)((0, _moduleCardDefault.default), {
            templateConfiguration: t,
            key: t.id,
            applicationId: applicationId
        })))), privateTemplates?.length < 1 && !templateConfigurationContainer.state.isLoading && (0, _react.jsx)((0, _emptyViewDefault.default), {
        title: "It's quiet in here!",
        description: "This is where you'll see the modules you've been given access to. Module builders can share their private modules with you and you can use them from here. Try exploring available modules to add!",
        actionLink: `/v/apps/${applicationId}/modules/discover`,
        actionText: "Explore Modules"
    }));
};
const InnerPageContainer = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e11tpmpj5"
})(`
    padding-bottom: 128px;
`, "");
const CardContainer = /*#__PURE__*/ (0, _baseDefault.default)("ul", {
    target: "e11tpmpj4"
})(`
    display: flex;
    flex-wrap: wrap;
    list-style-type: none;
`, "");
const ListContainer = /*#__PURE__*/ (0, _baseDefault.default)("ul", {
    target: "e11tpmpj3"
})(`
    list-style-type: none;
`, "");
const LoaderContainer = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e11tpmpj2"
})(`
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 32px;
    .spinner > div {
        background-color: ${(0, _colors.color_colors_ocean)};
    }
`, "");
const PageHeader = /*#__PURE__*/ (0, _baseDefault.default)("h3", {
    target: "e11tpmpj1"
})(`
    font-size: 24px;
    font-weight: normal;
    line-height: 32px;
    margin: 32px 0 24px 32px;
`, "");
const PageDetail = /*#__PURE__*/ (0, _baseDefault.default)("p", {
    target: "e11tpmpj0"
})(`
    margin: auto 32px;
`, "");
exports.default = PrivateTemplates;

},{"@emotion/styled/base":"lSuFu","@emotion/react":"djZKr","react":"6uln9","../../../constants/colors":"1p3OR","./ModuleCard":"gK70m","./ModuleListItem":"eFNRM","../../../components/general/SecondaryLoader":"7zJiF","./EmptyView":"ffYYa","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jyave":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _base = require("@emotion/styled/base");
var _baseDefault = parcelHelpers.interopDefault(_base);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _panelContainer = require("../../../components/structure/Panels/PanelContainer");
var _panelContainerDefault = parcelHelpers.interopDefault(_panelContainer);
var _staticMenuPanel = require("../../../components/structure/Panels/StaticMenuPanel");
var _staticMenuPanelDefault = parcelHelpers.interopDefault(_staticMenuPanel);
var _bodyPanel = require("../../../components/structure/Panels/BodyPanel");
var _bodyPanelDefault = parcelHelpers.interopDefault(_bodyPanel);
var _moduleCard = require("./ModuleCard");
var _moduleCardDefault = parcelHelpers.interopDefault(_moduleCard);
var _secondaryLoader = require("../../../components/general/SecondaryLoader");
var _secondaryLoaderDefault = parcelHelpers.interopDefault(_secondaryLoader);
var _discoverModulesMenu = require("./DiscoverModulesMenu");
var _discoverModulesMenuDefault = parcelHelpers.interopDefault(_discoverModulesMenu);
var _reactRouter = require("react-router");
var _horizontalContainer = require("../../../components/structure/HorizontalContainer");
var _horizontalContainerDefault = parcelHelpers.interopDefault(_horizontalContainer);
var _flatRoundedSelectField = require("../../../components/forms/FlatRoundedSelectField");
var _flatRoundedSelectFieldDefault = parcelHelpers.interopDefault(_flatRoundedSelectField);
var _numberIncrementSelector = require("../../../components/forms/NumberIncrementSelector");
var _numberIncrementSelectorDefault = parcelHelpers.interopDefault(_numberIncrementSelector);
var _colors = require("../../../constants/colors");
var _scrollablePanelBody = require("../../../components/structure/ScrollablePanelBody");
var _scrollablePanelBodyDefault = parcelHelpers.interopDefault(_scrollablePanelBody);
var _moduleListItem = require("./ModuleListItem");
var _moduleListItemDefault = parcelHelpers.interopDefault(_moduleListItem);
var _legacyIntegrationCard = require("./LegacyIntegrationCard");
var _legacyIntegrationCardDefault = parcelHelpers.interopDefault(_legacyIntegrationCard);
var _legacyIntegrationListItem = require("./LegacyIntegrationListItem");
var _legacyIntegrationListItemDefault = parcelHelpers.interopDefault(_legacyIntegrationListItem);
var _addLegacyIntegration = require("../../addLegacyIntegration");
var _addLegacyIntegrationDefault = parcelHelpers.interopDefault(_addLegacyIntegration);
var _toggleableSection = require("../../../components/structure/ToggleableSection");
var _toggleableSectionDefault = parcelHelpers.interopDefault(_toggleableSection);
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const DiscoverModules = ({ templateConfigurationContainer, appliedTemplatesContainer, applicationId, organizationId, availableTemplateConfigurations, appliedTemplates, legacyIntegrations })=>{
    const location = (0, _reactRouter.useLocation)();
    const history = (0, _reactRouter.useHistory)();
    const [legacyIntegration, setLegacyIntegration] = (0, _react1.useState)(null);
    const filterValues = new URLSearchParams(location.search);
    const handleTypeChange = (type)=>{
        if (!type) filterValues.delete("templateType");
        else filterValues.set("templateType", type);
        history.push(`${location.pathname}?${filterValues.toString()}`);
        templateConfigurationContainer.changeTemplateFilter({
            ...templateConfigurationContainer.state,
            templateTypeFilter: type,
            currentDiscoverPage: 1
        });
    };
    const handleCategoryChange = (categoryId)=>{
        if (!categoryId) filterValues.delete("category");
        else filterValues.set("category", categoryId);
        history.push(`${location.pathname}?${filterValues.toString()}`);
        templateConfigurationContainer.changeTemplateFilter({
            ...templateConfigurationContainer.state,
            categoryIdFilter: categoryId,
            currentDiscoverPage: 1
        });
    };
    const handleIndustryChange = (industryId)=>{
        if (!industryId) filterValues.delete("industry");
        else filterValues.set("industry", industryId);
        history.push(`${location.pathname}?${filterValues.toString()}`);
        templateConfigurationContainer.changeTemplateFilter({
            ...templateConfigurationContainer.state,
            industryIdFilter: industryId,
            currentDiscoverPage: 1
        });
    };
    const incrementPage = ()=>{
        if (templateConfigurationContainer.state.availableTemplates?.length == templateConfigurationContainer.state.defaultPageSize) // only increment if we have a full page right now
        templateConfigurationContainer.changeTemplateFilter({
            ...templateConfigurationContainer.state,
            currentDiscoverPage: templateConfigurationContainer.state.currentDiscoverPage + 1
        });
    };
    const decrementPage = ()=>{
        if (templateConfigurationContainer.state.currentDiscoverPage > 1) templateConfigurationContainer.changeTemplateFilter({
            ...templateConfigurationContainer.state,
            currentDiscoverPage: templateConfigurationContainer.state.currentDiscoverPage - 1
        });
    };
    const handleSortByChange = (e)=>{
        templateConfigurationContainer.changeTemplateFilter({
            ...templateConfigurationContainer.state,
            defaultSortBy: e.value,
            currentDiscoverPage: 1
        });
    };
    return (0, _react.jsx)((0, _panelContainerDefault.default), null, (0, _react.jsx)((0, _staticMenuPanelDefault.default), null, (0, _react.jsx)((0, _discoverModulesMenuDefault.default), {
        onCategoryChange: handleCategoryChange,
        onIndustryChange: handleIndustryChange,
        onTypeChange: handleTypeChange,
        selectedType: templateConfigurationContainer.state.templateTypeFilter,
        selectedCategoryId: templateConfigurationContainer.state.categoryIdFilter,
        selectedIndustryId: templateConfigurationContainer.state.industryIdFilter,
        categories: templateConfigurationContainer.state.categories,
        industries: templateConfigurationContainer.state.industries
    })), (0, _react.jsx)((0, _bodyPanelDefault.default), null, (0, _react.jsx)((0, _scrollablePanelBodyDefault.default), null, (0, _react.jsx)(InnerPageContainer, null, (0, _react.jsx)(PageHeader, null, "All Modules"), (0, _react.jsx)((0, _horizontalContainerDefault.default), null, (0, _react.jsx)((0, _flatRoundedSelectFieldDefault.default), {
        options: [
            {
                label: "Name - Alphabetical",
                value: "NameAscending"
            },
            {
                label: "Name - Reverse Alphabetical",
                value: "NameDescending"
            },
            {
                label: "Created Date - Oldest First",
                value: "CreatedDateAscending"
            },
            {
                label: "Created Date - Latest First",
                value: "CreatedDateDescending"
            }
        ],
        onChange: handleSortByChange,
        value: templateConfigurationContainer.state.defaultSortBy,
        label: "Arrange by",
        className: arrangeBy
    }), (0, _react.jsx)("div", {
        className: pageContainer
    }, (0, _react.jsx)("div", {
        className: leftSideLabel
    }, "Page"), (0, _react.jsx)((0, _numberIncrementSelectorDefault.default), {
        useShadow: false,
        selectedNumber: `${templateConfigurationContainer.state.currentDiscoverPage}`,
        updateValue: (b)=>b ? incrementPage() : decrementPage(),
        showNumber: true
    }))), templateConfigurationContainer.state.isLoading && (0, _react.jsx)(LoaderContainer, null, (0, _react.jsx)((0, _secondaryLoaderDefault.default), null)), templateConfigurationContainer.state.defaultViewType == "table" ? (0, _react.jsx)(ListContainer, null, availableTemplateConfigurations?.map((t)=>(0, _react.jsx)("li", {
            key: t.id
        }, (0, _react.jsx)((0, _moduleListItemDefault.default), {
            templateConfiguration: t,
            key: t.id,
            applicationId: applicationId
        })))) : (0, _react.jsx)(CardContainer, null, availableTemplateConfigurations?.map((t)=>(0, _react.jsx)("li", {
            key: t.id
        }, (0, _react.jsx)((0, _moduleCardDefault.default), {
            templateConfiguration: t,
            key: t.id,
            applicationId: applicationId
        })))), (0, _react.jsx)((0, _toggleableSectionDefault.default), {
        className: legacySection,
        hideTitle: "Legacy Integrations",
        showTitle: "Legacy Integrations",
        toggleType: "triangle",
        isCollapsed: true
    }, templateConfigurationContainer.state.defaultViewType == "table" ? (0, _react.jsx)(ListContainer, null, legacyIntegrations?.map((i)=>(0, _react.jsx)("li", {
            key: i.id
        }, (0, _react.jsx)((0, _legacyIntegrationListItemDefault.default), {
            integration: i,
            key: i.id,
            applicationId: applicationId,
            onSelect: (i)=>setLegacyIntegration(i)
        })))) : (0, _react.jsx)(CardContainer, null, legacyIntegrations?.map((i)=>(0, _react.jsx)("li", {
            key: i.id
        }, (0, _react.jsx)((0, _legacyIntegrationCardDefault.default), {
            integration: i,
            key: i.id,
            applicationId: applicationId,
            onSelect: (i)=>setLegacyIntegration(i)
        })))))))), legacyIntegration && (0, _react.jsx)((0, _addLegacyIntegrationDefault.default), {
        integration: legacyIntegration,
        organizationId: organizationId,
        onClose: ()=>setLegacyIntegration(null)
    }));
};
const InnerPageContainer = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1usg6fr4"
})(`
    padding-bottom: 128px;
`, "");
const CardContainer = /*#__PURE__*/ (0, _baseDefault.default)("ul", {
    target: "e1usg6fr3"
})(`
    display: flex;
    flex-wrap: wrap;
    list-style-type: none;
`, "");
const ListContainer = /*#__PURE__*/ (0, _baseDefault.default)("ul", {
    target: "e1usg6fr2"
})(`
    list-style-type: none;
`, "");
const pageContainer = /*#__PURE__*/ (0, _css.css)({
    name: "1a9xpvx",
    styles: "display:flex;flex-direction:row;margin:12px 32px 0px 0px"
});
const LoaderContainer = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1usg6fr1"
})(`
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 32px;
    .spinner > div {
        background-color: ${(0, _colors.color_colors_ocean)};
    }
`, "");
const legacySection = /*#__PURE__*/ (0, _css.css)(".title-section{margin-left:32px;span{color:", (0, _colors.color_text_default), ";font-size:18px;line-height:24px;}}", "");
const leftSideLabel = /*#__PURE__*/ (0, _css.css)("font-family:Muli;font-style:normal;font-weight:normal;font-size:12px;line-height:16px;color:", (0, _colors.color_text_default), ";margin-right:16px;margin-top:8px;", "");
const arrangeBy = /*#__PURE__*/ (0, _css.css)({
    name: "8gcf24",
    styles: "margin:12px auto 12px 32px;.Select{width:240px;}"
});
const PageHeader = /*#__PURE__*/ (0, _baseDefault.default)("h3", {
    target: "e1usg6fr0"
})(`
    font-size: 24px;
    font-weight: normal;
    line-height: 32px;
    margin: 32px 0 24px 32px;
`, "");
exports.default = DiscoverModules;

},{"@emotion/styled/base":"lSuFu","@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","../../../components/structure/Panels/PanelContainer":"9R2lE","../../../components/structure/Panels/StaticMenuPanel":"dOVW0","../../../components/structure/Panels/BodyPanel":"dYF57","./ModuleCard":"gK70m","../../../components/general/SecondaryLoader":"7zJiF","./DiscoverModulesMenu":"8WKLI","react-router":"i3TiW","../../../components/structure/HorizontalContainer":"eJPfh","../../../components/forms/FlatRoundedSelectField":"73UnY","../../../components/forms/NumberIncrementSelector":"kU0zB","../../../constants/colors":"1p3OR","../../../components/structure/ScrollablePanelBody":"6LRg3","./ModuleListItem":"eFNRM","./LegacyIntegrationCard":"2Jdtn","./LegacyIntegrationListItem":"5RLCF","../../addLegacyIntegration":"gTIEB","../../../components/structure/ToggleableSection":"f5pes","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8WKLI":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _base = require("@emotion/styled/base");
var _baseDefault = parcelHelpers.interopDefault(_base);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _moduleMenuGroup = require("./ModuleMenuGroup");
var _moduleMenuGroupDefault = parcelHelpers.interopDefault(_moduleMenuGroup);
var _stylesValues = require("../../../constants/stylesValues");
var _colors = require("../../../constants/colors");
const modulesIcon = require("a7e424380cc9790c");
const templatesIcon = require("c3248d6a54905caa");
const integrationsIcon = require("f905ec38678e2985");
const DiscoverModulesMenu = ({ categories, industries, onTypeChange, onCategoryChange, onIndustryChange, selectedType, selectedCategoryId, selectedIndustryId })=>{
    return (0, _react.jsx)(MenuBody, null, (0, _react.jsx)(ModuleTypeSection, null, (0, _react.jsx)(ModuleTypeHeader, null, "Type:"), (0, _react.jsx)("ul", null, (0, _react.jsx)(ModuleTypeItem, {
        className: !selectedType ? "selected" : "",
        onClick: ()=>onTypeChange(null)
    }, (0, _react.jsx)("img", {
        src: modulesIcon
    }), (0, _react.jsx)("p", null, "View All")), (0, _react.jsx)(ModuleTypeItem, {
        className: selectedType == "ContentTemplate" ? "selected" : "",
        onClick: ()=>onTypeChange("ContentTemplate")
    }, (0, _react.jsx)("img", {
        src: templatesIcon
    }), (0, _react.jsx)("p", null, "Templates")), (0, _react.jsx)(ModuleTypeItem, {
        className: selectedType == "Integration" ? "selected" : "",
        onClick: ()=>onTypeChange("Integration")
    }, (0, _react.jsx)("img", {
        src: integrationsIcon
    }), (0, _react.jsx)("p", null, "Integrations")))), (0, _react.jsx)((0, _moduleMenuGroupDefault.default), {
        title: "Category",
        allLabel: "- All Categories -",
        onItemSelect: onCategoryChange,
        selectedItemId: selectedCategoryId,
        items: categories?.map((c)=>({
                id: c.id,
                label: c.name
            }))
    }), (0, _react.jsx)((0, _moduleMenuGroupDefault.default), {
        title: "Industry",
        allLabel: "- All Industry -",
        onItemSelect: onIndustryChange,
        selectedItemId: selectedIndustryId,
        items: industries?.map((c)=>({
                id: c.id,
                label: c.name
            }))
    }));
};
const MenuBody = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1cr7zea3"
})(``, "");
const ModuleTypeSection = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1cr7zea2"
})(`
    border-bottom: ${(0, _stylesValues.style_border_default)};
    padding: 16px 8px;
`, "");
const ModuleTypeHeader = /*#__PURE__*/ (0, _baseDefault.default)("p", {
    target: "e1cr7zea1"
})(`
    margin-left: 16px;
    margin-bottom: 8px;
    font-size: 16px;
    line-height: 24px;
`, "");
const ModuleTypeItem = /*#__PURE__*/ (0, _baseDefault.default)("li", {
    target: "e1cr7zea0"
})(`
    padding-left: 16px;
    flex: 1;
    height: 32px;
    display: flex;
    align-items: center;
    font-size: 14px;
    line-height: 20px;
    cursor: pointer;
    img {
        margin-right: 12px;
        width: 20px;
    }
    &.selected {
        background: ${(0, _colors.color_variants_ocean_light_1)};
        border-radius: 4px;
        color: ${(0, _colors.color_text_link)};
    }
`, "");
exports.default = DiscoverModulesMenu;

},{"@emotion/styled/base":"lSuFu","@emotion/react":"djZKr","react":"6uln9","./ModuleMenuGroup":"5FTFo","../../../constants/stylesValues":"dHVVv","../../../constants/colors":"1p3OR","a7e424380cc9790c":"9vjp1","c3248d6a54905caa":"7e2U1","f905ec38678e2985":"bRn2E","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"5FTFo":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _base = require("@emotion/styled/base");
var _baseDefault = parcelHelpers.interopDefault(_base);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _toggleIndicator = require("../../../components/general/ToggleIndicator");
var _toggleIndicatorDefault = parcelHelpers.interopDefault(_toggleIndicator);
var _colors = require("../../../constants/colors");
const ModuleMenuGroup = ({ title, allLabel, selectedItemId, items, onItemSelect })=>{
    const [isCollapsed, setIsCollapsed] = (0, _react1.useState)(false);
    return (0, _react.jsx)(GroupContainer, null, (0, _react.jsx)(TitleContainer, {
        onClick: ()=>setIsCollapsed(!isCollapsed)
    }, (0, _react.jsx)((0, _toggleIndicatorDefault.default), {
        direction: isCollapsed ? "right" : "down",
        type: "triangle"
    }), (0, _react.jsx)("p", null, title)), !isCollapsed && (0, _react.jsx)("ul", null, (0, _react.jsx)(MenuItem, {
        className: `defualt ${!selectedItemId ? "selected" : ""}`,
        onClick: ()=>onItemSelect(null)
    }, (0, _react.jsx)("p", null, allLabel)), items?.map((i)=>(0, _react.jsx)(MenuItem, {
            key: i.id,
            className: i.id == selectedItemId ? "selected" : "",
            onClick: ()=>onItemSelect(i.id)
        }, (0, _react.jsx)("p", null, i.label)))));
};
const TitleContainer = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "enls122"
})(`
    cursor: pointer;
    display: flex;
    align-items: center;
    p {
        font-size: 16px;
        line-height: 24px;
        margin-left: 8px;
        margin-bottom: 4px;
    }
`, "");
const GroupContainer = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "enls121"
})(`
    margin: 12px 8px;
    width: calc(100% - 16px);
`, "");
const MenuItem = /*#__PURE__*/ (0, _baseDefault.default)("li", {
    target: "enls120"
})(`
    padding-left: 48px;
    flex: 1;
    height: 32px;
    display: flex;
    align-items: center;
    font-size: 14px;
    line-height: 20px;
    cursor: pointer;
    &.default {
        font-style: italic;
    }
    &.selected {
        background: ${(0, _colors.color_variants_ocean_light_1)};
        border-radius: 4px;
    }
`, "");
exports.default = ModuleMenuGroup;

},{"@emotion/styled/base":"lSuFu","@emotion/react":"djZKr","react":"6uln9","../../../components/general/ToggleIndicator":"4eej1","../../../constants/colors":"1p3OR","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2Jdtn":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _base = require("@emotion/styled/base");
var _baseDefault = parcelHelpers.interopDefault(_base);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _colors = require("../../../constants/colors");
var _stylesValues = require("../../../constants/stylesValues");
const defaultImage = require("342a490ad7685a0a");
const integrationIcon = require("c09cae8bcedcd611");
const notEnabledIcon = require("451716124dc645a8");
const sunsetIcon = require("bf45ece26fab734e");
const LegacyIntegrationCard = ({ integration, onSelect })=>{
    return (0, _react.jsx)(CardBody, {
        onClick: ()=>onSelect(integration)
    }, (0, _react.jsx)(CardHeader, null, (0, _react.jsx)(LegacyHeader, null, (0, _react.jsx)("p", null, "Legacy"), (0, _react.jsx)("img", {
        src: sunsetIcon
    }))), (0, _react.jsx)(CardImageWrapper, null, (0, _react.jsx)("img", {
        src: integration.iconUrl ?? defaultImage
    })), (0, _react.jsx)(InnerCardBody, null, (0, _react.jsx)("p", {
        className: "version-label"
    }, " "), (0, _react.jsx)("p", {
        className: "template-title"
    }, integration?.name), (0, _react.jsx)("p", {
        className: "template-byline"
    }, (0, _react.jsx)("img", {
        src: integrationIcon
    }), (0, _react.jsx)("span", null, `Legacy Integration - by ${integration.provider}`)), (0, _react.jsx)("p", {
        className: "template-description"
    }, integration.description)), (0, _react.jsx)(CardFooter, null, (0, _react.jsx)("p", {
        className: "template-status"
    }, (0, _react.jsx)("span", null, "Not Enabled"), (0, _react.jsx)("img", {
        src: notEnabledIcon
    }))));
};
const CardBody = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "eacwejq5"
})(`
    border: ${(0, _stylesValues.style_border_default)};
    box-sizing: border-box;
    border-radius: 8px;
    background: white;
    width: 340px;
    height: 376px;
    position: relative;
    margin-left: 32px;
    margin-top: 32px;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    cursor: pointer;
    color: ${(0, _colors.color_text_default)};
`, "");
const CardHeader = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "eacwejq4"
})(`
    background: ${(0, _colors.color_shades_lighter)};
    height: 72px;
    border-bottom: ${(0, _stylesValues.style_border_default)};
    display: flex;
`, "");
const LegacyHeader = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "eacwejq3"
})(`
    display: flex;
    align-items: center;
    margin-right: 24px;
    margin-left: auto;
    p {
        text-transform: uppercase;
        letter-spacing: 0.1em;
        font-size: 14px;
        line-height: 16px;
        margin-right: 8px;
    }
`, "");
const CardImageWrapper = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "eacwejq2"
})(`
    position: absolute;
    width: 96px;
    height: 96px;
    margin-left: 24px;
    margin-top: 24px;
    background: white;
    border: ${(0, _stylesValues.style_border_default)};
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
    img {
        max-height: 100%;
        max-width: 100%;
    }
`, "");
const InnerCardBody = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "eacwejq1"
})(`
    display: flex;
    flex-direction: column;
    margin: 24px;
    color: ${(0, _colors.color_text_default)};
    flex: 1;
    .version-label {
        margin-right: 0;
        margin-left: auto;
        text-align: right;        
        font-size: 14px;
        line-height: 20px;
        height: 20px;
    }
    .template-title {
        margin-top: 16px;
        margin-bottom: 5px;
        font-style: normal;
        font-weight: normal;
        font-size: 24px;
        line-height: 32px;
    }
    .template-byline {
        display: flex;
        align-items: center;
        color: ${(0, _colors.color_text_light)};
        font-size: 14px;
        line-height: 20px;
        img {
            margin-right: 8px;
        }
    }
    .template-description {
        margin-top: 24px;
    }
`, "");
const CardFooter = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "eacwejq0"
})(`
    height: 72px;
    border-top: ${(0, _stylesValues.style_border_default)};
    margin: 0 24px;
    display: flex;
    align-items: center;
    .template-price {
        .price-label {
            font-style: normal;
            font-weight: normal;
            font-size: 12px;
            line-height: 16px;
            color: ${(0, _colors.color_text_light)};
            display: block;
        }
        .price-value {
            font-style: normal;
            font-weight: normal;
            font-size: 18px;
            line-height: 24px;
            display: block;
        }
    }
    .template-status {
        margin-right: 0;
        margin-left: auto;
        font-size: 14px;
        line-height: 20px;
        font-style: italic;
        color: ${(0, _colors.color_text_light)};
        display: flex;
        align-items: center;
        &.enabled {
            color: ${(0, _colors.color_colors_growth)};
        }
        img {
            width: 24px;
            margin-left: 8px;
        }
    }
`, "");
exports.default = LegacyIntegrationCard;

},{"@emotion/styled/base":"lSuFu","@emotion/react":"djZKr","react":"6uln9","../../../constants/colors":"1p3OR","../../../constants/stylesValues":"dHVVv","342a490ad7685a0a":"e2QPt","c09cae8bcedcd611":"k12bg","451716124dc645a8":"71Ovv","bf45ece26fab734e":"bgy35","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"bgy35":[function(require,module,exports) {
module.exports = require("7431e660939e92cd").getBundleURL("kVLro") + require("6f09a5355b99170c").resolve("exJEb");

},{"7431e660939e92cd":"c7Tr5","6f09a5355b99170c":"fyJL2"}],"5RLCF":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _base = require("@emotion/styled/base");
var _baseDefault = parcelHelpers.interopDefault(_base);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _colors = require("../../../constants/colors");
var _stylesValues = require("../../../constants/stylesValues");
const defaultImage = require("312548105a728e55");
const integrationIcon = require("5bf9459e7d259862");
const notEnabledIcon = require("dd52d7f4af64c599");
const sunsetIcon = require("72315d5391f200e7");
const LegacyIntegrationListItem = ({ integration, onSelect })=>{
    return (0, _react.jsx)(CardBody, {
        onClick: ()=>onSelect(integration)
    }, (0, _react.jsx)(CardHeader, null), (0, _react.jsx)(CardImageWrapper, null, (0, _react.jsx)("img", {
        src: integration?.iconUrl ?? defaultImage
    })), (0, _react.jsx)(InnerCardBody, null, (0, _react.jsx)("p", {
        className: "template-title"
    }, integration?.name), (0, _react.jsx)("p", {
        className: "template-byline"
    }, (0, _react.jsx)("img", {
        src: integrationIcon
    }), (0, _react.jsx)("span", null, `Legacy Integration - by ${integration?.provider}`)), (0, _react.jsx)("p", {
        className: "template-description"
    }, integration?.description)), (0, _react.jsx)(LegacyHeader, null, (0, _react.jsx)("p", null, "Legacy"), (0, _react.jsx)("img", {
        src: sunsetIcon
    })), (0, _react.jsx)(CardEnd, null, (0, _react.jsx)("p", {
        className: "template-status"
    }, (0, _react.jsx)("span", null, "Not Enabled"), (0, _react.jsx)("img", {
        src: notEnabledIcon
    }))));
};
const CardEnd = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1542bk25"
})(`
    height: calc(100% - 48px);
    width: 200px;
    border-left: ${(0, _stylesValues.style_border_default)};
    margin: 24px;
    display: flex;
    flex-direction: column;
    align-items: center;
    .template-price {
        display: flex;
        align-items: center;
        margin-right: 0;
        margin-left: auto;
        margin-bottom: 0;
        margin-top: auto;
        .price-label {
            font-style: normal;
            font-weight: normal;
            font-size: 12px;
            line-height: 16px;
            color: ${(0, _colors.color_text_light)};
            display: block;
            margin-right: 8px;
        }
        .price-value {
            font-style: normal;
            font-weight: normal;
            font-size: 18px;
            line-height: 24px;
            display: block;
        }
    }
    .template-status {
        margin-right: 0;
        margin-left: auto;
        font-size: 14px;
        line-height: 20px;
        font-style: italic;
        color: ${(0, _colors.color_text_light)};
        display: flex;
        align-items: center;
        &.enabled {
            color: ${(0, _colors.color_colors_growth)};
        }
        img {
            width: 24px;
            margin-left: 8px;
        }
    }
`, "");
const LegacyHeader = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1542bk24"
})(`
    display: flex;
    align-items: center;
    margin-right: 0;
    margin-left: auto;
    margin-top: 32px;
    margin-bottom: auto;
    p {
        text-transform: uppercase;
        letter-spacing: 0.1em;
        font-size: 14px;
        line-height: 16px;
        margin-right: 8px;
    }
`, "");
const CardBody = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1542bk23"
})(`
    border: ${(0, _stylesValues.style_border_default)};
    box-sizing: border-box;
    border-radius: 8px;
    background: white;
    width: calc(100% - 64px);
    height: 160px;
    position: relative;
    margin-left: 32px;
    margin-top: 32px;
    overflow: hidden;
    display: flex;
    align-items: center;
    cursor: pointer;
    color: ${(0, _colors.color_text_default)};
`, "");
const CardHeader = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1542bk22"
})(`
    background: ${(0, _colors.color_shades_lighter)};
    width: 72px;
    height: 100%;
    border-right: ${(0, _stylesValues.style_border_default)};
`, "");
const CardImageWrapper = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1542bk21"
})(`
    position: absolute;
    width: 96px;
    height: 96px;
    margin-left: 24px;
    background: white;
    border: ${(0, _stylesValues.style_border_default)};
    border-radius: 8px;
    overflow: hidden;

    img {
        max-height: 100%;
        max-width: 100%;
    }
`, "");
const InnerCardBody = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1542bk20"
})(`
    display: flex;
    flex-direction: column;
    margin-left: 80px;
    color: ${(0, _colors.color_text_default)};
    flex: 1;
    .template-title {
        margin-top: 16px;
        margin-bottom: 5px;
        font-style: normal;
        font-weight: normal;
        font-size: 24px;
        line-height: 32px;
    }
    .template-byline {
        display: flex;
        align-items: center;
        color: ${(0, _colors.color_text_light)};
        font-size: 14px;
        line-height: 20px;
        img {
            margin-right: 8px;
        }
        .version-label {
            padding-left: 8px;
        }
    }
    .template-description {
        margin-top: 24px;
    }
`, "");
exports.default = LegacyIntegrationListItem;

},{"@emotion/styled/base":"lSuFu","@emotion/react":"djZKr","react":"6uln9","../../../constants/colors":"1p3OR","../../../constants/stylesValues":"dHVVv","312548105a728e55":"e2QPt","5bf9459e7d259862":"k12bg","dd52d7f4af64c599":"71Ovv","72315d5391f200e7":"bgy35","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"gTIEB":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _defineProperty = require("@babel/runtime/helpers/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _unstated = require("unstated");
var _organizationContainer = require("../../state/containers/OrganizationContainer");
var _organizationContainerDefault = parcelHelpers.interopDefault(_organizationContainer);
var _integrationsListingsContainer = require("../../state/containers/IntegrationsListingsContainer");
var _integrationsListingsContainerDefault = parcelHelpers.interopDefault(_integrationsListingsContainer);
var _modalLayout = require("../../components/structure/ModalLayout");
var _modalLayoutDefault = parcelHelpers.interopDefault(_modalLayout);
var _integrationSetup = require("./components/IntegrationSetup");
var _integrationSetupDefault = parcelHelpers.interopDefault(_integrationSetup);
var _webhookContainer = require("../../state/containers/WebhookContainer");
var _webhookContainerDefault = parcelHelpers.interopDefault(_webhookContainer);
class AddLegacyIntegration extends (0, _reactDefault.default).Component {
    constructor(...args){
        super(...args);
        (0, _definePropertyDefault.default)(this, "state", {
            selectedIntegration: null
        });
    }
    handleClose(hasChanges) {
        if (hasChanges == true) {
            var confirmClose = confirm("You have unsaved changes. Are you sure you want to close?");
            if (!confirmClose) return;
        }
        this.props.onClose();
    }
    render() {
        return (0, _react.jsx)((0, _modalLayoutDefault.default), {
            isVisible: true,
            onClose: this.handleClose.bind(this)
        }, (0, _react.jsx)((0, _unstated.Subscribe), {
            to: [
                (0, _organizationContainerDefault.default),
                (0, _integrationsListingsContainerDefault.default),
                (0, _webhookContainerDefault.default)
            ]
        }, (orgContainer, integrationContainer, webhookContainer)=>{
            return (0, _react.jsx)((0, _integrationSetupDefault.default), {
                organizationId: orgContainer.state.currentOrganization.id,
                integrationContainer: integrationContainer,
                webhookContainer: webhookContainer,
                handleClose: this.handleClose.bind(this),
                integration: this.props.integration
            });
        }));
    }
}
exports.default = AddLegacyIntegration;

},{"@babel/runtime/helpers/defineProperty":"9sJxO","@emotion/react":"djZKr","react":"6uln9","unstated":"grh7p","../../state/containers/OrganizationContainer":"dlbaM","../../state/containers/IntegrationsListingsContainer":"4z81X","../../components/structure/ModalLayout":"b1cO3","./components/IntegrationSetup":"bkFFp","../../state/containers/WebhookContainer":"4VCcR","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4z81X":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _defineProperty = require("@babel/runtime/helpers/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _unstated = require("unstated");
var _api = require("../../api");
var _lodash = require("lodash");
const customWebhook = {
    name: "Custom Webhook",
    id: "custom",
    description: "Create a custom integration from a webhook",
    provider: "Voicify",
    internalIntegration: true
};
const customIntegration = {
    name: "Add an Integration",
    id: "integration",
    description: "Add a custom integration listing",
    provider: "Custom",
    internalIntegration: true
};
class IntegrationsListingsContainer extends (0, _unstated.Container) {
    constructor(...args){
        super(...args);
        (0, _definePropertyDefault.default)(this, "state", {
            integrationsListings: []
        });
    }
    setLoading(isLoading) {
        return this.setState({
            ...this.state,
            isLoading: isLoading
        });
    }
    setSaving(isSaving) {
        return this.setState({
            ...this.state,
            isSaving: isSaving
        });
    }
    clearErrors() {
        this.setState({
            ...this.state,
            errors: null
        });
    }
    getListings(organizationId) {
        return this.setLoading(true).then(()=>{
            var promise = _api.getIntegrationsListings(organizationId).then((res)=>{
                if (res.resultType == "Ok") {
                    var listings = res.data;
                    var builtin = listings.filter((l)=>l.organizationId == null);
                    var custom = listings.filter((l)=>l.organizationId != null);
                    listings = builtin.concat(custom);
                    return this.setState({
                        ...this.state,
                        integrationsListings: listings,
                        isLoading: false
                    });
                } else return this.setState({
                    ...this.state,
                    errors: res.errors,
                    isLoading: false
                });
            }).catch((err)=>{
                return this.setState({
                    ...this.state,
                    errors: err,
                    isLoading: false
                });
            });
            return promise;
        });
    }
    isInternalIntegration(integration) {
        return integration.internalIntegration == true;
    }
    sendConfigurationInformation(organizationId, integration, parameters) {
        this.clearErrors();
        return this.setSaving(true).then(()=>{
            const setupRequest = {
                additionalProperties: parameters,
                apiUserId: this.state.integrationConfig.apiUserId
            };
            var promise = _api.sendIntegrationConfiguration(organizationId, integration.id, setupRequest).then((res)=>{
                if (res.resultType == "Ok") return this.setState({
                    ...this.state,
                    integrationConfig: {
                        additionalPropertiesConfiguration: {},
                        oAuthUrl: "",
                        setupSections: [],
                        apiUserId: ""
                    },
                    isSaving: false
                });
                else return this.setState({
                    ...this.state,
                    errors: res.errors,
                    integrationConfig: {
                        additionalPropertiesConfiguration: {},
                        oAuthUrl: "",
                        setupSections: [],
                        apiUserId: ""
                    },
                    isSaving: false
                });
            }).catch((err)=>{
                return this.setState({
                    ...this.state,
                    isSaving: false,
                    errors: err
                });
            });
            return promise;
        });
    }
    addCustomIntegrationListing(organizationId, request) {
        return this.setSaving(true).then(()=>{
            var promise = _api.addIntegrationListing(organizationId, request).then((res)=>{
                if (res.resultType != "Ok") return this.setState({
                    ...this.state,
                    errors: res.errors,
                    isSaving: false
                });
                else return this.setState({
                    ...this.state,
                    isSaving: false,
                    errors: null
                });
            }).catch((err)=>{
                return this.setState({
                    ...this.state,
                    errors: [
                        err
                    ],
                    isSaving: false
                });
            });
            return promise;
        });
    }
    removeIntegrationsListing(integrationsListingId) {
        return this.setSaving(true).then(()=>{
            var promise = _api.removeIntegrationListing(integrationsListingId).then((res)=>{
                if (res.resultType != "Ok") return this.setState({
                    ...this.state,
                    errors: res.errors,
                    isSaving: false
                });
                else {
                    _lodash.remove(this.state.integrationsListings, (i)=>i.id == integrationsListingId);
                    return this.setState({
                        ...this.state,
                        integrationsListings: this.state.integrationsListings,
                        isSaving: false,
                        errors: null
                    });
                }
            }).catch((err)=>{
                return this.setState({
                    ...this.state,
                    isSaving: false,
                    errors: [
                        err
                    ]
                });
            });
            return promise;
        });
    }
    setupExternalIntegration(organizationId, integration) {
        this.clearErrors();
        return this.setSaving(true).then(()=>{
            var promise = _api.getIntegrationSetup(organizationId, integration.id).then((res)=>{
                if (res.resultType != "Ok") this.setState({
                    ...this.state,
                    integrationConfig: null,
                    isSaving: false,
                    errors: res.errors
                });
                else this.setState({
                    ...this.state,
                    integrationConfig: res.data,
                    isSaving: false
                });
                return res;
            }).catch((err)=>{
                this.setState({
                    ...this.state,
                    isSaving: false,
                    errors: [
                        "There was an issue contacting the remote integration, please try again later"
                    ]
                });
                return err;
            });
            return promise;
        });
    }
}
exports.default = IntegrationsListingsContainer;

},{"@babel/runtime/helpers/defineProperty":"9sJxO","unstated":"grh7p","../../api":"loxM6","lodash":"3hMBK","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"bkFFp":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _defineProperty = require("@babel/runtime/helpers/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _react = require("@emotion/react");
var _fullScreenLayout = require("../../fullScreenLayout");
var _fullScreenLayoutDefault = parcelHelpers.interopDefault(_fullScreenLayout);
var _scrollView = require("../../../components/structure/ScrollView");
var _scrollViewDefault = parcelHelpers.interopDefault(_scrollView);
var _pageContainer = require("../../../components/structure/PageContainer");
var _pageContainerDefault = parcelHelpers.interopDefault(_pageContainer);
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _horizontalContainer = require("../../../components/structure/HorizontalContainer");
var _horizontalContainerDefault = parcelHelpers.interopDefault(_horizontalContainer);
var _button = require("../../../components/general/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _modalTitle = require("../../../components/general/ModalTitle");
var _modalTitleDefault = parcelHelpers.interopDefault(_modalTitle);
var _horizontalSeparator = require("../../../components/structure/HorizontalSeparator");
var _horizontalSeparatorDefault = parcelHelpers.interopDefault(_horizontalSeparator);
var _externalIntegrationForm = require("../../formScenes/ExternalIntegrationForm");
var _externalIntegrationFormDefault = parcelHelpers.interopDefault(_externalIntegrationForm);
const closeIcon = require("83c1058122f4df85");
class IntegrationSetup extends (0, _reactDefault.default).Component {
    constructor(...args){
        super(...args);
        (0, _definePropertyDefault.default)(this, "state", {
            integrationSelected: null
        });
    }
    componentDidMount() {
        const { integration } = this.props;
        if (!this.props.integrationContainer.isInternalIntegration(integration)) this.props.integrationContainer.setupExternalIntegration(this.props.organizationId, integration).then(()=>{
            if (!this.props.integrationContainer.state.errors || this.props.integrationContainer.state.errors.length == 0) {
                var oAuthUrl = this.props.integrationContainer.state.integrationConfig.oAuthUrl;
                if (oAuthUrl) window.open(oAuthUrl, "_self");
                else {
                    var additionalPropertiesConfiguration = this.props.integrationContainer.state.integrationConfig.additionalPropertiesConfiguration == null ? [] : this.props.integrationContainer.state.integrationConfig.additionalPropertiesConfiguration;
                    var setupSections = this.props.integrationContainer.state.integrationConfig.setupSections == null ? [] : this.props.integrationContainer.state.integrationConfig.setupSections;
                    if (additionalPropertiesConfiguration != null && Object.keys(additionalPropertiesConfiguration).length > 0 || setupSections != null && setupSections.length > 0) this.setState({
                        ...this.state,
                        integrationSelected: integration
                    });
                    else {
                        this.props.integrationContainer.sendConfigurationInformation(this.props.organizationId, integration, {});
                        this.props.webhookContainer.getWebhooksForOrganization(this.props.organizationId).then(()=>{
                            this.handleFinished();
                        });
                    }
                }
            }
        });
        else this.setState({
            ...this.state,
            integrationSelected: integration
        });
    }
    handleClose() {
        this.props.integrationContainer.clearErrors();
        this.props.handleClose(this.state.hasChanges);
    }
    handleFinished(hasChanges) {
        this.setState({
            integrationSelected: null
        });
        this.props.integrationContainer.clearErrors();
        this.props.handleClose(hasChanges || false);
    }
    handleChange() {
        this.setState({
            hasChanges: true
        });
    }
    render() {
        return (0, _react.jsx)((0, _fullScreenLayoutDefault.default), null, (0, _react.jsx)((0, _scrollViewDefault.default), null, (0, _react.jsx)((0, _pageContainerDefault.default), {
            fill: true,
            withFooter: true
        }, (0, _react.jsx)((0, _horizontalContainerDefault.default), null, (0, _react.jsx)((0, _modalTitleDefault.default), {
            padded: true
        }, "Add a New Integration:"), (0, _react.jsx)((0, _buttonDefault.default), {
            themes: [
                "end-tight",
                "icon"
            ],
            icon: closeIcon,
            onClick: this.handleClose.bind(this)
        })), (0, _react.jsx)((0, _horizontalSeparatorDefault.default), null), this.props.integrationContainer.state.integrationConfig && (0, _react.jsx)((0, _externalIntegrationFormDefault.default), {
            integrationContainer: this.props.integrationContainer,
            organizationId: this.props.organizationId,
            integration: this.state.integrationSelected,
            webhookContainer: this.props.webhookContainer,
            handleClose: this.handleFinished.bind(this),
            additionalPropertiesConfiguration: this.props.integrationContainer.state.integrationConfig.additionalPropertiesConfiguration,
            setupSections: this.props.integrationContainer.state.integrationConfig.setupSections
        }))));
    }
}
exports.default = IntegrationSetup;

},{"@babel/runtime/helpers/defineProperty":"9sJxO","@emotion/react":"djZKr","../../fullScreenLayout":"5mVdG","../../../components/structure/ScrollView":"53ath","../../../components/structure/PageContainer":"hc1r8","react":"6uln9","../../../components/structure/HorizontalContainer":"eJPfh","../../../components/general/Button":"6ymxN","../../../components/general/ModalTitle":"hIp2B","../../../components/structure/HorizontalSeparator":"Pw3HQ","../../formScenes/ExternalIntegrationForm":"iJBhz","83c1058122f4df85":"93VwA","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"iJBhz":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _reactMarkdown = require("react-markdown");
var _reactMarkdownDefault = parcelHelpers.interopDefault(_reactMarkdown);
var _pageContainer = require("../../components/structure/PageContainer");
var _pageContainerDefault = parcelHelpers.interopDefault(_pageContainer);
var _footerBar = require("../../components/structure/FooterBar");
var _footerBarDefault = parcelHelpers.interopDefault(_footerBar);
var _button = require("../../components/general/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _css = require("@emotion/css");
var _textField = require("../../components/forms/TextField");
var _textFieldDefault = parcelHelpers.interopDefault(_textField);
var _formik = require("formik");
var _pageError = require("../../components/general/PageError");
var _pageErrorDefault = parcelHelpers.interopDefault(_pageError);
var _colors = require("../../constants/colors");
var _textAreaField = require("../../components/forms/TextAreaField");
var _textAreaFieldDefault = parcelHelpers.interopDefault(_textAreaField);
var _checkboxField = require("../../components/forms/CheckboxField");
var _checkboxFieldDefault = parcelHelpers.interopDefault(_checkboxField);
var _switch = require("../../components/forms/Switch");
var _switchDefault = parcelHelpers.interopDefault(_switch);
var _selectField = require("../../components/forms/SelectField");
var _selectFieldDefault = parcelHelpers.interopDefault(_selectField);
var _loader = require("../../components/general/Loader");
var _loaderDefault = parcelHelpers.interopDefault(_loader);
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
class InnerForm extends (0, _reactDefault.default).Component {
    renderSetupProperty(property) {
        switch(property.field.fieldType){
            case "ShortTextField":
                return this.renderShortText(property);
            case "LongTextField":
                return this.renderLongText(property);
            case "SwitchField":
                return this.renderSwitch(property);
            case "SelectField":
                return this.renderSelect(property);
            case "CheckboxField":
                return this.renderCheckbox(property);
        }
    }
    renderCheckbox(property) {
        return (0, _react.jsx)("div", null, (0, _react.jsx)("div", {
            className: label
        }, property.label), (0, _react.jsx)((0, _checkboxFieldDefault.default), {
            key: property.id,
            name: `boolParameters.${property.id}`,
            checked: this.props.values.boolParameters[property.id],
            onChange: this.props.handleChange,
            required: property.required,
            className: checkboxField,
            tooltip: property.tooltip
        }));
    }
    renderSwitch(property) {
        return (0, _react.jsx)("div", null, (0, _react.jsx)("div", {
            className: label
        }, property.label), (0, _react.jsx)((0, _switchDefault.default), {
            key: property.id,
            name: `boolParameters.${property.id}`,
            onChange: this.handleSwitchChange.bind(this, `boolParameters.${property.id}`, property.id),
            checked: this.props.values.boolParameters[property.id],
            label: property.field.rightOption,
            leftOption: property.field.leftOption,
            tooltip: property.tooltip
        }));
    }
    renderShortText(property) {
        return (0, _react.jsx)((0, _textFieldDefault.default), {
            key: property.id,
            name: `stringParameters.${property.id}`,
            value: this.props.values.stringParameters[property.id],
            onChange: this.props.handleChange,
            required: property.required,
            tooltip: property.tooltip,
            label: property.label,
            placeholder: property.field.placeholder
        });
    }
    renderLongText(property) {
        return (0, _react.jsx)((0, _textAreaFieldDefault.default), {
            key: property.id,
            name: `stringParameters.${property.id}`,
            value: this.props.values.stringParameters[property.id],
            onChange: this.props.handleChange,
            required: property.required,
            tooltip: property.tooltip,
            label: property.label,
            placeholder: property.field.placeholder
        });
    }
    renderSelect(property) {
        return (0, _react.jsx)((0, _selectFieldDefault.default), {
            key: property.id,
            className: selectField,
            onChange: this.handleChange.bind(this, `stringParameters.${property.id}`),
            onBlur: ()=>{},
            name: `stringParameters.${property.id}`,
            value: this.props.values.stringParameters[property.id],
            label: property.label,
            placeholder: property.field.placeholder,
            options: property.field.options.map((o)=>({
                    value: o.value,
                    label: o.label
                }))
        });
    }
    renderSetupSection(section, idx) {
        const properties = section.properties == null ? [] : section.properties;
        return (0, _react.jsx)("div", {
            key: `section_${idx}`,
            className: setupSectionContainer
        }, (0, _react.jsx)((0, _reactMarkdownDefault.default), {
            className: "instructions",
            source: section.instructionsMarkdown,
            renderers: {
                link: this.linkRenderer
            }
        }), properties.map((p, subIdx)=>{
            return (0, _react.jsx)("div", {
                key: `setupSection_${subIdx}`,
                className: setupPropertyContainer
            }, this.renderSetupProperty(p));
        }));
    }
    linkRenderer(props) {
        return (0, _react.jsx)("a", {
            href: props.href,
            target: "_blank"
        }, props.children);
    }
    renderSetupSections() {
        return (0, _react.jsx)("div", {
            className: setupSectionsContainer
        }, this.props.setupSections.map((s, idx)=>{
            return this.renderSetupSection(s, idx);
        }));
    }
    handleChange(fieldName, value) {
        this.props.setFieldValue(fieldName, value.value);
    }
    handleSwitchChange(fieldName, id) {
        const newValue = !this.props.values.boolParameters[id];
        this.props.setFieldValue(fieldName, newValue);
    }
    render() {
        if (this.props.integrationContainer.state.isLoading) return (0, _react.jsx)((0, _loaderDefault.default), null);
        return (0, _react.jsx)((0, _pageContainerDefault.default), {
            fill: true
        }, (0, _react.jsx)("form", {
            onSubmit: this.props.handleSubmit
        }, (0, _react.jsx)((0, _pageContainerDefault.default), {
            fill: true
        }, this.props.setupSections != null ? this.renderSetupSections() : this.renderSimpleFields()), (0, _react.jsx)((0, _footerBarDefault.default), null, (0, _react.jsx)((0, _buttonDefault.default), {
            themes: [
                "primary",
                "wide"
            ],
            loading: this.props.integrationContainer.state.isSaving,
            text: "Create",
            type: "submit"
        }), (0, _react.jsx)((0, _buttonDefault.default), {
            themes: [
                "white",
                "end"
            ],
            loading: this.props.integrationContainer.state.isSaving,
            text: "Cancel",
            type: "button",
            onClick: this.props.handleClose.bind(this, true)
        }))), (0, _react.jsx)((0, _pageErrorDefault.default), {
            errors: this.props.integrationContainer.state.errors
        }));
    }
    renderSimpleField(nameLeft, nameRight, idx) {
        // todo: remove in next release, deprecated.
        var type = this.props.additionalPropertiesConfiguration[nameLeft];
        type;
        return (0, _react.jsx)("div", {
            key: `container${idx}`,
            className: formFieldsRow
        }, (0, _react.jsx)((0, _textFieldDefault.default), {
            key: `leftfield${idx}`,
            className: formFieldLeft,
            name: `stringParameters.${nameLeft}`,
            label: nameLeft,
            value: this.props.values.stringParameters[nameLeft],
            onChange: this.props.handleChange
        }), nameRight == null ? null : (0, _react.jsx)((0, _textFieldDefault.default), {
            className: formFieldRight,
            key: `rightfield${idx}`,
            name: `stringParameters.${nameRight}`,
            label: nameRight,
            value: this.props.values.stringParameters[nameRight],
            onChange: this.props.handleChange
        }));
    }
    renderSimpleFields() {
        // todo: remove in next release, deprecated.
        const keys = Object.keys(this.props.additionalPropertiesConfiguration ?? {});
        return (0, _react.jsx)("div", {
            className: dumbFormFieldsContainer
        }, keys.map((n, idx)=>{
            return idx % 2 === 0 || idx === 0 ? this.renderSimpleField(n, keys.length > idx + 1 ? keys[idx + 1] : null, idx) : null;
        }));
    }
}
const ExternalIntegrationForm = (0, _formik.withFormik)({
    mapPropsToValues: (props)=>{
        var stringParameters = {};
        var boolParameters = {};
        if (props.setupSections == null) Object.keys(props.additionalPropertiesConfiguration ?? {}).map((f)=>{
            stringParameters[f] = "";
        });
        else props.setupSections.map((s)=>{
            const properties = s.properties == null ? [] : s.properties;
            properties.map((p)=>{
                if (p.field.fieldType === "CheckboxField" || p.field.fieldType === "SwitchField") boolParameters[p.id] = true;
                else stringParameters[p.id] = "";
            });
        });
        return {
            stringParameters: stringParameters,
            boolParameters: boolParameters
        };
    },
    handleSubmit: (values, { props })=>{
        let paramsToSend = values.stringParameters;
        if (props.setupSections != null) for(let key in values.boolParameters)paramsToSend[key] = values.boolParameters[key] ? "true" : "false";
        props.integrationContainer.sendConfigurationInformation(props.organizationId, props.integration, paramsToSend).then(()=>{
            props.webhookContainer.getWebhooksForOrganization(props.organizationId).then(()=>{
                props.handleClose(false);
            });
        });
    }
})(InnerForm);
const setupSectionsContainer = /*#__PURE__*/ (0, _css.css)({
    name: "m3h5y5",
    styles: "padding-bottom:150px"
});
const selectField = /*#__PURE__*/ (0, _css.css)({
    name: "de9hf",
    styles: "padding-top:16px"
});
const checkboxField = /*#__PURE__*/ (0, _css.css)({
    name: "1lt7ksy",
    styles: "padding-left:16px;.tooltip{margin-top:3px;}"
});
const setupSectionContainer = /*#__PURE__*/ (0, _css.css)("padding-left:35px;padding-right:35px;margin-bottom:10px;padding-bottom:10px;border-bottom:1px solid ", (0, _colors.silver_four), ";.instructions{font-family:Muli;font-style:normal;font-stretch:normal;padding-bottom:20px;h1{margin-bottom:16px;margin-top:16px;font-size:24px;font-weight:bold;}h2{margin-bottom:16px;margin-top:16px;font-size:20px;font-weight:bold;}h3{margin-bottom:16px;margin-top:16px;font-size:18px;font-weight:bold;}h4{margin-bottom:16px;margin-top:16px;font-size:16px;font-weight:bold;}h5{margin-bottom:16px;margin-top:16px;font-size:14px;font-weight:bold italic;}h6{margin-bottom:16px;margin-top:16px;font-size:14px;font-weight:bold;}}", "");
const label = /*#__PURE__*/ (0, _css.css)({
    name: "1479jx0",
    styles: "font-family:Muli;font-size:14px;font-weight:600;font-style:normal;font-stretch:normal;letter-spacing:normal;text-align:left;margin:24px 16px 8px 16px"
});
const setupPropertyContainer = /*#__PURE__*/ (0, _css.css)("padding:10px 0px;border-top:1px solid ", (0, _colors.silver_four), ";", "");
const dumbFormFieldsContainer = /*#__PURE__*/ (0, _css.css)({
    name: "1o9kiwm",
    styles: "display:flex;flex-direction:column;margin:30px;width:90%;height:auto;font-size:20px"
});
const formFieldsRow = /*#__PURE__*/ (0, _css.css)({
    name: "1gdoo5k",
    styles: "display:flex;flex-direction:row;width:100%;height:auto;margin-left:15px;margin-right:15px"
});
const formFieldLeft = /*#__PURE__*/ (0, _css.css)({
    name: "r552lt",
    styles: "width:50%;margin-right:15px"
});
const formFieldRight = /*#__PURE__*/ (0, _css.css)({
    name: "1rfwjrw",
    styles: "width:50%;margin-left:15px"
});
exports.default = ExternalIntegrationForm;

},{"@emotion/react":"djZKr","react":"6uln9","react-markdown":"6G7AH","../../components/structure/PageContainer":"hc1r8","../../components/structure/FooterBar":"bibRL","../../components/general/Button":"6ymxN","@emotion/css":"awUBr","../../components/forms/TextField":"7a7bh","formik":"3YnOK","../../components/general/PageError":"ezFTm","../../constants/colors":"1p3OR","../../components/forms/TextAreaField":"fE54C","../../components/forms/CheckboxField":"3S5Oy","../../components/forms/Switch":"8kkL9","../../components/forms/SelectField":"405B3","../../components/general/Loader":"bnV5T","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jZ7x0":[function(require,module,exports) {
module.exports = require("c87cc11dc5286890").getBundleURL("kVLro") + require("d0cc96b6b6e41a58").resolve("7SoB4");

},{"c87cc11dc5286890":"c7Tr5","d0cc96b6b6e41a58":"fyJL2"}],"180gZ":[function(require,module,exports) {
module.exports = require("bf090f10df9de8eb").getBundleURL("kVLro") + require("8b02a15f82946c4f").resolve("e7yl6");

},{"bf090f10df9de8eb":"c7Tr5","8b02a15f82946c4f":"fyJL2"}],"cOhL1":[function(require,module,exports) {
module.exports = require("f10840b72e450ea3").getBundleURL("kVLro") + require("10206b3e28cb7139").resolve("bDEUt");

},{"f10840b72e450ea3":"c7Tr5","10206b3e28cb7139":"fyJL2"}],"ddjHw":[function(require,module,exports) {
module.exports = require("ec96a2e21dcd7b2f").getBundleURL("kVLro") + require("542814f76eec6bfd").resolve("2Z3YB");

},{"ec96a2e21dcd7b2f":"c7Tr5","542814f76eec6bfd":"fyJL2"}],"aUCTk":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _headerBar = require("../structure/HeaderBar");
var _headerBarDefault = parcelHelpers.interopDefault(_headerBar);
var _logo = require("../../scenes/dashboardHeader/components/Logo");
var _logoDefault = parcelHelpers.interopDefault(_logo);
var _loader = require("./Loader");
var _loaderDefault = parcelHelpers.interopDefault(_loader);
const LoaderWithHeader = (props)=>(0, _react.jsx)((0, _reactDefault.default).Fragment, null, (0, _react.jsx)((0, _headerBarDefault.default), null, (0, _react.jsx)((0, _logoDefault.default), {
        isFull: true,
        isInverse: true
    })), (0, _react.jsx)((0, _loaderDefault.default), null));
exports.default = LoaderWithHeader;

},{"@emotion/react":"djZKr","react":"6uln9","../structure/HeaderBar":"5ka3F","../../scenes/dashboardHeader/components/Logo":"8VQkf","./Loader":"bnV5T","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"cTOlL":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _base = require("@emotion/styled/base");
var _baseDefault = parcelHelpers.interopDefault(_base);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _colors = require("../../../constants/colors");
var _nlpModelTrainingContainer = require("../../../hooks/NlpModelTrainingContainer");
var _nlpModelTrainingContainerDefault = parcelHelpers.interopDefault(_nlpModelTrainingContainer);
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const closeIcon = require("e1b6a047de6b9ce6");
const redIcon = require("8dc20b704afe7153");
const greenIcon = require("7384379ca1c3cd5a");
const loadingGif = require("a7dbe843af377164");
const NlpModelTrainingIndicator = (props)=>{
    const indicatorHook = (0, _nlpModelTrainingContainerDefault.default).useContainer();
    (0, _react1.useEffect)(()=>{
        indicatorHook.setNewApplication(props.application);
    }, [
        props.application?.id
    ]);
    if (indicatorHook.indicator?.type === "success") return (0, _react.jsx)(IndicatorWrapper, {
        onClick: indicatorHook.clear
    }, (0, _react.jsx)(GreenIndicator, null, (0, _react.jsx)(TrainingIcon, {
        src: greenIcon
    }), (0, _react.jsx)(IndicatorText, null, indicatorHook.indicator.message), (0, _react.jsx)(CloseIcon, {
        src: closeIcon
    })));
    if (indicatorHook.indicator?.type === "building") return (0, _react.jsx)(IndicatorWrapper, {
        onClick: indicatorHook.clear
    }, (0, _react.jsx)(BlueIndicator, null, (0, _react.jsx)(TrainingGif, {
        src: loadingGif
    }), (0, _react.jsx)(IndicatorText, null, indicatorHook.indicator.message), (0, _react.jsx)(CloseIcon, {
        src: closeIcon
    })));
    if (indicatorHook.indicator?.type === "error") return (0, _react.jsx)(IndicatorWrapper, {
        onClick: indicatorHook.clear
    }, (0, _react.jsx)(RedIndicator, null, (0, _react.jsx)(TrainingIcon, {
        src: redIcon
    }), (0, _react.jsx)(IndicatorText, null, indicatorHook.indicator.message), (0, _react.jsx)(CloseIcon, {
        src: closeIcon
    })));
    return (0, _react.jsx)((0, _reactDefault.default).Fragment, null);
};
exports.default = NlpModelTrainingIndicator;
const IndicatorText = /*#__PURE__*/ (0, _baseDefault.default)("p", {
    target: "e2vp2t28"
})("font-weight:400;font-size:14px;line-height:20px;color:", (0, _colors.color_shades_darkest), ";margin:auto auto auto 16px;");
const TrainingIcon = /*#__PURE__*/ (0, _baseDefault.default)("img", {
    target: "e2vp2t27"
})({
    name: "c9zh5k",
    styles: "width:88px;height:80px;margin:auto 0px auto 16px"
});
const TrainingGif = /*#__PURE__*/ (0, _baseDefault.default)("img", {
    target: "e2vp2t26"
})({
    name: "r7fzpu",
    styles: "width:96px;height:92px;margin:auto 0px auto 16px"
});
const CloseIcon = /*#__PURE__*/ (0, _baseDefault.default)("img", {
    target: "e2vp2t25"
})({
    name: "18qer9d",
    styles: "margin:auto 32px auto auto;width:12px;height:12px"
});
const IndicatorWrapper = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e2vp2t24"
})("position:fixed;bottom:32px;right:32px;width:528px;height:104px;border-radius:8px;border:1px solid ", (0, _colors.color_shades_dark), ";box-shadow:0px 4px 20px ", (0, _colors.color_variants_shadow_10), ";z-index:1100;background:white;box-sizing:border-box;cursor:pointer;");
const Indicator = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e2vp2t23"
})({
    name: "1999fp6",
    styles: "display:flex;flex-direction:row;height:100%;border-radius:8px;width:100%"
});
const GreenIndicator = /*#__PURE__*/ (0, _baseDefault.default)(Indicator, {
    target: "e2vp2t22"
})("background:", (0, _colors.color_variants_green_2), ";");
const RedIndicator = /*#__PURE__*/ (0, _baseDefault.default)(Indicator, {
    target: "e2vp2t21"
})("background:", (0, _colors.color_variants_red_2), ";");
const BlueIndicator = /*#__PURE__*/ (0, _baseDefault.default)(Indicator, {
    target: "e2vp2t20"
})("background:", (0, _colors.color_variants_blue_2), ";");

},{"@emotion/styled/base":"lSuFu","@emotion/react":"djZKr","react":"6uln9","../../../constants/colors":"1p3OR","../../../hooks/NlpModelTrainingContainer":"fdXHQ","e1b6a047de6b9ce6":"93VwA","8dc20b704afe7153":"b4rNR","7384379ca1c3cd5a":"2jyYp","a7dbe843af377164":"kyWjm","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"b4rNR":[function(require,module,exports) {
module.exports = require("2e5236bdbb711065").getBundleURL("kVLro") + require("7c17cfd05382e817").resolve("a1Qej");

},{"2e5236bdbb711065":"c7Tr5","7c17cfd05382e817":"fyJL2"}],"2jyYp":[function(require,module,exports) {
module.exports = require("1c5f390205fb9b69").getBundleURL("kVLro") + require("4be7f56ce40a59f8").resolve("ijwCS");

},{"1c5f390205fb9b69":"c7Tr5","4be7f56ce40a59f8":"fyJL2"}],"kyWjm":[function(require,module,exports) {
module.exports = require("cc2ff9591f2911a1").getBundleURL("kVLro") + require("84530951653f659d").resolve("g79It");

},{"cc2ff9591f2911a1":"c7Tr5","84530951653f659d":"fyJL2"}],"30Bfz":[function(require,module,exports) {
module.exports = require("487934c8ed871a9c").getBundleURL("kVLro") + require("eb6fc5131d6fd643").resolve("dNpim");

},{"487934c8ed871a9c":"c7Tr5","eb6fc5131d6fd643":"fyJL2"}],"1h75T":[function(require,module,exports) {
module.exports = require("5847033e37d325f9").getBundleURL("kVLro") + require("566cd8c29d02e33a").resolve("aAzDL");

},{"5847033e37d325f9":"c7Tr5","566cd8c29d02e33a":"fyJL2"}],"gy99Q":[function(require,module,exports) {
module.exports = require("3272a5436609ffc4").getBundleURL("kVLro") + require("8a03f6c2e2be8024").resolve("gcJVF");

},{"3272a5436609ffc4":"c7Tr5","8a03f6c2e2be8024":"fyJL2"}],"lowHs":[function(require,module,exports) {
module.exports = require("c5a64c69161e6da4").getBundleURL("kVLro") + require("ae8117baf8003257").resolve("2T0HB");

},{"c5a64c69161e6da4":"c7Tr5","ae8117baf8003257":"fyJL2"}],"ibi1X":[function(require,module,exports) {
module.exports = require("4a0a2334dc766154").getBundleURL("kVLro") + require("4e84aa849e4b50c9").resolve("PnRPf");

},{"4a0a2334dc766154":"c7Tr5","4e84aa849e4b50c9":"fyJL2"}],"lujXS":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _defineProperty = require("@babel/runtime/helpers/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _unstated = require("unstated");
var _api = require("../../api");
class ImportExportContainer extends (0, _unstated.Container) {
    constructor(...args){
        super(...args);
        // default state
        (0, _definePropertyDefault.default)(this, "state", {
            errors: [],
            isLoading: false
        });
    }
    async exportContentToFile(contentRequest, currentApplication) {
        try {
            this.setLoading(true);
            var request = {
                applicationId: currentApplication.id,
                bulkContentRequest: contentRequest,
                archiveType: "BulkContent"
            };
            const archiveResult = await _api.queueArchive(request);
            let result = null;
            if (archiveResult.resultType == "Ok") await this.waitForExport(archiveResult.data.id);
            else this.setState({
                ...this.state,
                isLoading: false,
                errors: archiveResult.errors ?? result.errors
            });
        } catch (error) {
            return {
                resultType: "InternalError",
                data: null,
                errors: [
                    error
                ]
            };
        }
    }
    async exportWebhooksToFile(webhookRequest, currentApplication) {
        try {
            this.setLoading(true);
            var request = {
                applicationId: currentApplication.id,
                bulkWebhookRequest: webhookRequest,
                archiveType: "BulkWebhook"
            };
            const archiveResult = await _api.queueArchive(request);
            let result = null;
            if (archiveResult.resultType == "Ok") await this.waitForExport(archiveResult.data.id);
            else this.setState({
                ...this.state,
                isLoading: false,
                errors: archiveResult.errors ?? result.errors
            });
        } catch (error) {
            return {
                resultType: "InternalError",
                data: null,
                errors: [
                    error
                ]
            };
        }
    }
    async waitForExport(archiveId) {
        try {
            let checking = true;
            while(checking){
                const result = await _api.getArchive(archiveId);
                if (result.resultType == "Ok") {
                    const archive = result.data;
                    switch(archive.stage){
                        case "Processing":
                        case "Queued":
                            await new Promise((r)=>setTimeout(r, 1000)); // wait 1000 ms and then we can try again. 
                            break;
                        case "Complete":
                            if (archive.error) {
                                await this.setState({
                                    ...this.state,
                                    isLoading: false,
                                    errors: [
                                        archive.error
                                    ]
                                });
                                return {
                                    data: null,
                                    resultType: "Invalid",
                                    errors: [
                                        archive.error
                                    ]
                                };
                            } else {
                                await this.setState({
                                    ...this.state,
                                    isLoading: false,
                                    errors: []
                                });
                                window.open(archive.fileUrl, "_blank").focus();
                                return result;
                            }
                            break;
                        default:
                            await this.setState({
                                ...this.state,
                                isLoading: false,
                                errors: [
                                    "Unknown issue with archive"
                                ]
                            });
                            return {
                                data: null,
                                resultType: "Invalid",
                                errors: [
                                    "Unknown issue with archive"
                                ]
                            };
                    }
                } else this.setState({
                    ...this.state,
                    isLoading: false,
                    errors: result.errors
                });
            }
        } catch (e) {
            await this.setState({
                ...this.state,
                isLoading: false,
                errors: [
                    e?.toString()
                ]
            });
        }
    }
    importFileToAppFeature(applicationFeatureId, file) {
        if (!file) return;
        this.setLoading(true);
        const promise = _api.importToAppFeature(applicationFeatureId, file);
        promise.then((result)=>{
            if (result.resultType == "Ok") this.setState({
                ...this.state,
                isLoading: false
            });
            else this.setState({
                ...this.state,
                isLoading: false,
                errors: result.errors
            });
        }).catch((e)=>{
            this.setState({
                ...this.state,
                isLoading: false,
                errors: [
                    e.toString()
                ]
            });
        });
        return promise;
    }
    async importFileToWebhookFolder(targetFolderId, applicationId, file) {
        try {
            if (!file) return;
            if (!targetFolderId) targetFolderId = "";
            this.setLoading(true);
            const result = await _api.importToWebhookFolder(targetFolderId, applicationId, file);
            if (result.resultType == "Ok") this.setState({
                ...this.state,
                isLoading: false
            });
            else this.setState({
                ...this.state,
                isLoading: false,
                errors: result.errors
            });
            return result;
        } catch (error) {
            return {
                resultType: "InternalError",
                data: null,
                errors: [
                    error
                ]
            };
        }
    }
    saveBlob(blob, fileName) {
        var a = document.createElement("a");
        a.href = window.URL.createObjectURL(blob);
        a.download = fileName;
        a.dispatchEvent(new MouseEvent("click"));
    }
    setLoading(isLoading) {
        this.setState({
            ...this.state,
            isLoading: isLoading
        });
    }
}
exports.default = ImportExportContainer;

},{"@babel/runtime/helpers/defineProperty":"9sJxO","unstated":"grh7p","../../api":"loxM6","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"l24Qu":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _defineProperty = require("@babel/runtime/helpers/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _unstated = require("unstated");
var _lodash = require("lodash");
var _lodashDefault = parcelHelpers.interopDefault(_lodash);
var _api = require("../../api");
const folderIcon = require("a1c49fdaabd50610");
const webhookIcon = require("8cb3a93f3717c0f3");
class WebhookFolderContainer extends (0, _unstated.Container) {
    constructor(...args){
        super(...args);
        (0, _definePropertyDefault.default)(this, "state", {
            isLoading: false,
            webhookFolders: [],
            errors: [],
            currentApplicationId: null,
            loadingFolderIds: [],
            expandedIds: [],
            tree: {}
        });
    }
    async buildTree(appId, webhooks) {
        try {
            if (appId != this.state.currentApplicationId) await this.loadWebhookFolders(appId);
            const root = {
                id: appId,
                isHighlighted: false,
                isExpanded: true,
                isLoadingChildren: false,
                icon: folderIcon,
                expandedIcon: folderIcon,
                title: "root",
                canExpand: true,
                linkTo: ``,
                children: [
                    ...(this.state.webhookFolders?.filter((wf)=>wf.parentId == null)?.sort((a, b)=>a.priority > b.priority ? 1 : -1) ?? []).map((f)=>this.mapFolderToTreeItem(f, webhooks)),
                    ...(webhooks?.filter((w)=>w.webhookFolderId == null) ?? []).map((w)=>this.mapWebhookToTreeItem(w))
                ]
            };
            this.setState({
                ...this.state,
                tree: root
            });
            return {
                resultType: "Ok",
                data: root,
                errors: null
            };
        } catch (error) {
            return {
                resultType: "InternalError",
                data: null,
                errors: [
                    error
                ]
            };
        }
    }
    getAllAncestors(folderId) {
        const folder = this.findFolderById(folderId);
        if (!folder) return [];
        const output = [];
        output.push(folder);
        var parentId = folder.parentId;
        while(parentId){
            const parent = this.findFolderById(parentId);
            output.push(parent);
            parentId = parent?.parentId;
        }
        return output;
    }
    findFolderById(folderId) {
        return this.state.webhookFolders.find((f)=>f.id == folderId);
    }
    setExpandedIds(ids) {
        this.setState({
            ...this.state,
            expandedIds: ids
        });
    }
    mapFolderToTreeItem(folder, webhooks) {
        return {
            id: folder?.id,
            isHighlighted: false,
            isExpanded: this.state.expandedIds?.some((id)=>folder?.id == id),
            isLoadingChildren: this.state.loadingFolderIds?.some((id)=>folder?.id == id),
            icon: folderIcon,
            expandedIcon: folderIcon,
            title: folder?.name,
            canExpand: true,
            type: "feature",
            linkTo: ``,
            children: [
                ...(this.state.webhookFolders?.filter((wf)=>wf.parentId == folder.id)?.sort((a, b)=>a.priority > b.priority ? 1 : -1) ?? []).map((f)=>this.mapFolderToTreeItem(f, webhooks)),
                ...(webhooks?.filter((w)=>w.webhookFolderId == folder.id) ?? []).map((w)=>this.mapWebhookToTreeItem(w))
            ]
        };
    }
    mapWebhookToTreeItem(webhook) {
        return {
            id: webhook.id,
            isHighlighted: false,
            isExpanded: false,
            isLoadingChildren: false,
            icon: webhookIcon,
            title: webhook.title,
            canExpand: false,
            linkTo: ``,
            children: []
        };
    }
    moveFolderUp(applicationFeatureId) {
        const folder = this.findFolderById(applicationFeatureId);
        // sort locally
        var familyFeatures = (0, _lodashDefault.default).orderBy(this.state.webhookFolders.filter((af)=>af.parentId == folder.parentId && af.applicationId == folder.applicationId), (af)=>af.priority, "asc").map((af)=>af.id);
        var originalIndex = familyFeatures.indexOf(folder.id);
        if (originalIndex <= 0) return;
        familyFeatures = this.moveFolderInParent(familyFeatures, originalIndex, originalIndex - 1);
        this.setFolderOrder(folder.applicationId, folder.parentId, familyFeatures);
    }
    moveFolderDown(applicationFeatureId) {
        const feature = this.findFolderById(applicationFeatureId);
        // sort locally
        var familyFeatures = (0, _lodashDefault.default).orderBy(this.state.webhookFolders.filter((af)=>af.parentId == feature.parentId && af.applicationId == feature.applicationId), (af)=>af.priority, "asc").map((af)=>af.id);
        var originalIndex = familyFeatures.indexOf(feature.id);
        if (originalIndex >= familyFeatures.length) return;
        familyFeatures = this.moveFolderInParent(familyFeatures, originalIndex, originalIndex + 1);
        this.setFolderOrder(feature.applicationId, feature.parentId, familyFeatures);
    }
    moveFolderInParent(features, originalPosition, newPosition) {
        if (newPosition >= features.length) {
            var k = newPosition - features.length + 1;
            while(k--)features.push(undefined);
        }
        features.splice(newPosition, 0, features.splice(originalPosition, 1)[0]);
        return features;
    }
    setFolderOrder(applicationId, parentFolderId, sortedAppFeatureIds) {
        // set local state for perf, then call api
        const allfolders = this.state.webhookFolders;
        sortedAppFeatureIds.forEach((id, index)=>{
            const feature = allfolders.find((af)=>af.id == id);
            feature.priority = index;
        });
        this.setState({
            ...this.state,
            webhookFolders: allfolders
        });
        // sort in api
        _api.setWebhookFolderOrder(applicationId, parentFolderId, sortedAppFeatureIds).then((result)=>{
            if (result.resultType != "Ok") this.setState({
                ...this.state,
                errors: result.errors
            });
        }).catch((e)=>{
            this.setState({
                ...this.state,
                errors: [
                    e.toString()
                ]
            });
        });
    }
    async bulkDelete(request) {
        this.setState({
            ...this.state,
            isLoading: true
        });
        var result = await _api.bulkDeleteWebhooksAndFolders(request);
        if (result.resultType == "Ok") this.setLoading(false);
        else this.setState({
            ...this.state,
            isLoading: false,
            errors: [
                ...result.errors
            ]
        });
        return result;
    }
    async moveToFolder(targetFolderId, request) {
        if (!targetFolderId) targetFolderId = "";
        this.setState({
            ...this.state,
            isLoading: true
        });
        var result = await _api.moveWebhooksAndFoldersToFolder(targetFolderId, request);
        if (result.resultType == "Ok") this.setLoading(false);
        else this.setState({
            ...this.state,
            isLoading: false,
            errors: [
                ...result.errors
            ]
        });
        return result;
    }
    async copyToFolder(targetFolderId, request) {
        if (!targetFolderId) targetFolderId = "";
        this.setState({
            ...this.state,
            isLoading: true
        });
        var result = await _api.copyWebhooksAndFoldersToFolder(targetFolderId, request);
        if (result.resultType == "Ok") this.setLoading(false);
        else this.setState({
            ...this.state,
            isLoading: false,
            errors: [
                ...result.errors
            ]
        });
        return result;
    }
    async getFolderView(appId, folderId, webhooks) {
        try {
            if (appId != this.state.currentApplicationId) await this.loadWebhookFolders(appId);
            var folder = this.state.webhookFolders?.filter((wf)=>wf.id == folderId)[0] ?? {};
            folder.children = this.state.webhookFolders?.filter((wf)=>wf.parentId == folderId)?.sort((a, b)=>a.priority > b.priority ? 1 : -1) ?? [];
            folder.children.forEach((c)=>{
                c.totalWebhookCount = this.getWebhookCountInFolder(c, webhooks);
            });
            folder.webhooks = webhooks?.filter((w)=>w.webhookFolderId == folderId) ?? [];
            return {
                resultType: "Ok",
                data: folder,
                errors: null
            };
        } catch (error) {
            return {
                resultType: "InternalError",
                data: null,
                errors: [
                    error
                ]
            };
        }
    }
    getWebhookCountInFolder(folder, webhookPool) {
        var count = 0;
        var childWebhooks = webhookPool?.filter((w)=>w.webhookFolderId == folder.id) ?? [];
        count = count + childWebhooks.length;
        var childFolders = this.state.webhookFolders?.filter((wf)=>wf.parentId == folder.id) ?? [];
        childFolders.forEach((f)=>{
            count = count + this.getWebhookCountInFolder(f, webhookPool);
        });
        return count;
    }
    async deleteFolder(id) {
        try {
            this.setLoading(true);
            const result = await _api.deleteWebhookFolder(id);
            if (result.resultType == "Ok") {
                const idx = this.state.webhookFolders.findIndex((wf)=>wf.id == id);
                const newFolders = [
                    ...this.state.webhookFolders
                ];
                newFolders.splice(idx, 1);
                this.setState({
                    ...this.state,
                    isLoading: false,
                    webhookFolders: newFolders
                });
            } else this.setState({
                ...this.state,
                isLoading: true,
                errors: result.errors
            });
            return result;
        } catch (error) {
            return {
                resultType: "InternalError",
                data: null,
                errors: [
                    error
                ]
            };
        }
    }
    async updateFolder(model) {
        try {
            const result = await _api.updateWebhookFolder(model.id, model);
            if (result.resultType == "Ok") {
                const idx = this.state.webhookFolders.findIndex((wf)=>wf.id == model.id);
                const newFolders = [
                    ...this.state.webhookFolders
                ];
                newFolders[idx] = model;
                this.setState({
                    ...this.state,
                    isLoading: false,
                    webhookFolders: newFolders
                });
            } else this.setState({
                ...this.state,
                isLoading: true,
                errors: result.errors
            });
        } catch (error) {
            return {
                resultType: "InternalError",
                data: null,
                errors: [
                    error
                ]
            };
        }
    }
    async createFolder(appId, name, parentId) {
        try {
            if (appId != this.state.currentApplicationId) await this.loadWebhookFolders(appId);
            if (!parentId) parentId = null;
            var orderedWebhookFolders = this.state.webhookFolders?.filter((wf)=>wf.parentId == parentId)?.sort((a, b)=>a.priority > b.priority ? 1 : -1) ?? [];
            var lowestPriority = orderedWebhookFolders == null || orderedWebhookFolders?.length == 0 ? 1 : orderedWebhookFolders[0].priority;
            const model = {
                name: name,
                priority: lowestPriority - 1,
                applicationId: appId,
                parentId: parentId
            };
            const result = await _api.createWebhookFolder(model);
            if (result.resultType == "Ok") await this.setState({
                ...this.state,
                isLoading: false,
                webhookFolders: [
                    result.data,
                    ...this.state.webhookFolders
                ]
            });
            else await this.setState({
                ...this.state,
                isLoading: false,
                errors: result.errors
            });
            return result;
        } catch (error) {
            return {
                resultType: "InternalError",
                data: null,
                errors: [
                    error
                ]
            };
        }
    }
    async loadWebhookFolders(appId) {
        this.setLoading(true);
        try {
            const result = await _api.getWebhookFoldersForApplication(appId);
            if (result.resultType == "Ok") this.setState({
                ...this.state,
                isLoading: false,
                currentApplicationId: appId,
                webhookFolders: result.data ?? []
            });
            else this.setState({
                ...this.state,
                isLoading: true,
                errors: result.errors
            });
            return result;
        } catch  {
            this.setLoading(false);
        }
    }
    setLoading(isLoading) {
        this.setState({
            ...this.state,
            isLoading: isLoading
        });
    }
}
exports.default = WebhookFolderContainer;

},{"@babel/runtime/helpers/defineProperty":"9sJxO","unstated":"grh7p","lodash":"3hMBK","../../api":"loxM6","a1c49fdaabd50610":"dHwU7","8cb3a93f3717c0f3":"e6PIG","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"eIVVi":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _unstated = require("unstated");
var _welcomeMessageContainer = require("../../state/containers/WelcomeMessageContainer");
var _welcomeMessageContainerDefault = parcelHelpers.interopDefault(_welcomeMessageContainer);
var _welcomeMessageContentForm = require("./components/WelcomeMessageContentForm");
var _welcomeMessageContentFormDefault = parcelHelpers.interopDefault(_welcomeMessageContentForm);
var _applicationContainer = require("../../state/containers/ApplicationContainer");
var _applicationContainerDefault = parcelHelpers.interopDefault(_applicationContainer);
var _titleStateContainer = require("../../state/containers/TitleStateContainer");
var _titleStateContainerDefault = parcelHelpers.interopDefault(_titleStateContainer);
var _followUpContainer = require("../../state/containers/FollowUpContainer");
var _followUpContainerDefault = parcelHelpers.interopDefault(_followUpContainer);
var _repromptContainer = require("../../state/containers/RepromptContainer");
var _repromptContainerDefault = parcelHelpers.interopDefault(_repromptContainer);
var _mediaResponseContainer = require("../../state/containers/MediaResponseContainer");
var _mediaResponseContainerDefault = parcelHelpers.interopDefault(_mediaResponseContainer);
var _genericCreateContentItemPage = require("../formScenes/GenericCreateContentItemPage");
var _genericCreateContentItemPageDefault = parcelHelpers.interopDefault(_genericCreateContentItemPage);
var _featureContainer = require("../../state/containers/FeatureContainer");
var _featureContainerDefault = parcelHelpers.interopDefault(_featureContainer);
var _featureTypeIds = require("../../constants/featureTypeIds");
class CreateWelcomeMessage extends (0, _reactDefault.default).Component {
    render() {
        return (0, _react.jsx)((0, _unstated.Subscribe), {
            to: [
                (0, _welcomeMessageContainerDefault.default),
                (0, _applicationContainerDefault.default),
                (0, _titleStateContainerDefault.default),
                (0, _repromptContainerDefault.default),
                (0, _followUpContainerDefault.default),
                (0, _mediaResponseContainerDefault.default),
                (0, _featureContainerDefault.default)
            ]
        }, (welcomeContainer, appContainer, titleContainer, repromptContainer, followUpContainer, responseContainer, featureContainer)=>{
            return (0, _react.jsx)((0, _genericCreateContentItemPageDefault.default), {
                stateContainer: welcomeContainer,
                titleContainer: titleContainer,
                applicationContainer: appContainer,
                defaultTitle: "New Welcome Message",
                history: this.props.history,
                location: this.props.location,
                match: this.props.match,
                staticContext: this.props.staticContext,
                featureContainer: featureContainer,
                featureTypeId: (0, _featureTypeIds.WelcomeMessagesFeatureTypeId),
                formRender: (application, assistantApplication, onPublish, onSubmit, onAccessTypeChange)=>(0, _react.jsx)((0, _welcomeMessageContentFormDefault.default), {
                        location: this.props.location,
                        applicationFeatureId: this.props.match.params.applicationFeatureId,
                        stateContainer: welcomeContainer,
                        assistantApplication: assistantApplication,
                        appContainer: appContainer,
                        followUpContainer: followUpContainer,
                        repromptContainer: repromptContainer,
                        responseStateContainer: responseContainer,
                        featureContainer: featureContainer,
                        history: this.props.history,
                        onSubmit: onSubmit,
                        onAccessTypeChange: onAccessTypeChange,
                        onShowPublishModal: onPublish,
                        isSaving: welcomeContainer.state.isSaving,
                        application: application
                    })
            });
        });
    }
}
exports.default = CreateWelcomeMessage;

},{"@emotion/react":"djZKr","react":"6uln9","unstated":"grh7p","../../state/containers/WelcomeMessageContainer":"j3orW","./components/WelcomeMessageContentForm":"8Nk8K","../../state/containers/ApplicationContainer":"cuqi2","../../state/containers/TitleStateContainer":"2osOD","../../state/containers/FollowUpContainer":"rm9OA","../../state/containers/RepromptContainer":"5vKMV","../../state/containers/MediaResponseContainer":"1ccrV","../formScenes/GenericCreateContentItemPage":"dUUA3","../../state/containers/FeatureContainer":"4ApGg","../../constants/featureTypeIds":"hPLMP","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8Nk8K":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _formik = require("formik");
var _yup = require("yup");
var _welcomeMessageForm = require("../../formScenes/WelcomeMessageForm");
var _welcomeMessageFormDefault = parcelHelpers.interopDefault(_welcomeMessageForm);
const WelcomeMessageContentForm = (0, _formik.withFormik)({
    mapPropsToValues: (props)=>({
            responses: [
                {
                    content: ""
                }
            ],
            title: "Untitled Welcome Message",
            followUpSelection: "end",
            repromptSelection: "end",
            sensitiveConversationChange: "None",
            entryType: "open",
            isLive: true,
            requiresParent: false,
            languages: props.application?.languages.find((l)=>l.id == props.application?.defaultLanguageId) ? [
                props.application?.languages.find((l)=>l.id == props.application?.defaultLanguageId)
            ] : [],
            webhookChainingType: "NoChaining"
        }),
    validationSchema: _yup.object().shape({
        title: _yup.string().required("You must give this a title"),
        responses: _yup.array().of(_yup.object().shape({
            content: _yup.string().required("You must enter a response variation")
        })).required("You must enter at least 1 response variation").min(1, "You must enter at least 1 response variation")
    }),
    validateOnMount: true,
    handleSubmit: (values, { props, setStatus })=>{
        setStatus({
            submitting: true
        });
        return props.onSubmit(props.stateContainer.mapFormDataToModel({
            applicationFeatureId: props.applicationFeatureId,
            applicationId: props.application?.id,
            responses: []
        }, values));
    }
})((0, _welcomeMessageFormDefault.default));
exports.default = WelcomeMessageContentForm;

},{"formik":"3YnOK","yup":"j2SJU","../../formScenes/WelcomeMessageForm":"93rpb","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"93rpb":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _defineProperty = require("@babel/runtime/helpers/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _pageContainer = require("../../components/structure/PageContainer");
var _pageContainerDefault = parcelHelpers.interopDefault(_pageContainer);
var _titleTextField = require("../../components/forms/TitleTextField");
var _titleTextFieldDefault = parcelHelpers.interopDefault(_titleTextField);
var _followUpForm = require("../followUpForm");
var _followUpFormDefault = parcelHelpers.interopDefault(_followUpForm);
var _loader = require("../../components/general/Loader");
var _loaderDefault = parcelHelpers.interopDefault(_loader);
var _featureTypeIds = require("../../constants/featureTypeIds");
var _contentLanguageMultiSelector = require("../../components/forms/ContentLanguageMultiSelector");
var _contentLanguageMultiSelectorDefault = parcelHelpers.interopDefault(_contentLanguageMultiSelector);
var _contentPage = require("../contentPage");
var _contentPageDefault = parcelHelpers.interopDefault(_contentPage);
var _relatedContentMenu = require("../relatedContentMenu");
var _relatedContentMenuDefault = parcelHelpers.interopDefault(_relatedContentMenu);
var _scrollablePanelBody = require("../../components/structure/ScrollablePanelBody");
var _scrollablePanelBodyDefault = parcelHelpers.interopDefault(_scrollablePanelBody);
var _panelTitle = require("../contentPage/components/PanelTitle");
var _panelTitleDefault = parcelHelpers.interopDefault(_panelTitle);
var _contentCollapsingSection = require("../../components/structure/ContentCollapsingSection");
var _contentCollapsingSectionDefault = parcelHelpers.interopDefault(_contentCollapsingSection);
var _contentSectionTitle = require("../contentPage/components/ContentSectionTitle");
var _contentSectionTitleDefault = parcelHelpers.interopDefault(_contentSectionTitle);
var _extensions = require("../../models/extensions");
var _pageError = require("../../components/general/PageError");
var _pageErrorDefault = parcelHelpers.interopDefault(_pageError);
var _conversationItemActionButtonToolbar = require("./components/ConversationItemActionButtonToolbar");
var _conversationItemActionButtonToolbarDefault = parcelHelpers.interopDefault(_conversationItemActionButtonToolbar);
var _templateLockedBanner = require("../../components/general/TemplateLockedBanner");
var _templateLockedBannerDefault = parcelHelpers.interopDefault(_templateLockedBanner);
var _conversationItemFieldSet = require("../../components/forms/ConversationItemFieldSet");
var _conversationItemFieldSetDefault = parcelHelpers.interopDefault(_conversationItemFieldSet);
var _contentInfoOptions = require("../../components/structure/ContentInfoOptions");
var _contentInfoOptionsDefault = parcelHelpers.interopDefault(_contentInfoOptions);
var _responsesManager = require("../responsesManager");
var _responsesManagerDefault = parcelHelpers.interopDefault(_responsesManager);
var _dirtyFormPrompt = require("./components/DirtyFormPrompt");
var _sensitiveDataOptions = require("../contentPage/components/SensitiveDataOptions");
var _sensitiveDataOptionsDefault = parcelHelpers.interopDefault(_sensitiveDataOptions);
var _disableForFeatureFlagOptions = require("../contentPage/components/DisableForFeatureFlagOptions");
var _disableForFeatureFlagOptionsDefault = parcelHelpers.interopDefault(_disableForFeatureFlagOptions);
var _contentItemTestCaseViewer = require("./ContentItemTestCaseViewer");
var _contentItemTestCaseViewerDefault = parcelHelpers.interopDefault(_contentItemTestCaseViewer);
const contentInfoIcon = require("168c3cd204a5ec37");
const continueIcon = require("e47430235bb5bfae");
class WelcomeMessageForm extends (0, _followUpFormDefault.default) {
    constructor(...args){
        super(...args);
        (0, _definePropertyDefault.default)(this, "handleResponseIdFromSim", (id)=>{
            this.setState({
                simulatedResponseId: id
            });
        });
    }
    componentDidUpdate(prevProps, prevState) {
        super.componentDidUpdate(prevProps, prevState);
    }
    handleAsyncSubmit(onSuccess) {
        if (this.props.onSubmit && this.manualValidate()) return this.props.onSubmit(this.props.stateContainer.mapFormDataToModel(this.props.welcomeMessage, this.props.values), onSuccess);
    }
    handleDiscardChanges() {
        this.handleFinish();
    }
    handleDelete() {
        const confirmed = confirm("Are you sure you want to delete this?");
        if (confirmed) this.props.stateContainer.delete(this.props.welcomeMessage.id).then(()=>{
            this.handleFinish();
        });
    }
    handleCopy() {
        this.props.onSubmit(this.props.stateContainer.mapFormDataToModel(this.props.welcomeMessage, this.props.values), ()=>{
            this.props.stateContainer.copy(this.props.welcomeMessage.id).then((r2)=>{
                if (r2.resultType == "Ok") this.props.history.push(`/v/${r2.data.applicationFeatureId}/welcomemessages/${r2.data.id}`);
            });
        });
    }
    getMenuTreeRoots() {
        return [
            this.getContentInfoTreeItem(),
            ...this.getResponsesTreeItems(this.props.values.responses)
        ];
    }
    handleContentItemOptionSelected(option, event) {
        event.stopPropagation();
        if (option == "Manage Webhooks") this.showWebhookInstanceManager();
        else if (option == "Duplicate") this.handleCopy();
        else if (option == "Delete") this.handleDelete();
    }
    getContentItem() {
        return this.props.welcomeMessage;
    }
    handleResponsesChange(responseGroups) {
        this.props.setFieldValue("responses", this.getResponsesFromGroups(responseGroups));
    }
    render() {
        const props = {
            ...this.props
        };
        const isLoading = props.stateContainer.state.isSaving;
        const isDisabled = isLoading || this.props.isTemplateOwned;
        const responseGroups = this.getResponseGroups(this.props.values.responses);
        const { simulatedResponseId } = this.state;
        if (this.props.responseStateContainer.state.isLoading || !this.props.application) return (0, _react.jsx)((0, _loaderDefault.default), null);
        return (0, _react.jsx)((0, _reactDefault.default).Fragment, null, (0, _react.jsx)("form", {
            onSubmit: props.handleSubmit
        }, (0, _react.jsx)((0, _dirtyFormPrompt.DirtyFormPrompt), {
            allowPrompt: props.status?.submitting != true
        }), (0, _react.jsx)((0, _contentPageDefault.default), {
            relatedContentRender: ()=>(0, _react.jsx)((0, _relatedContentMenuDefault.default), {
                    parentContentId: this.props.previousContentId,
                    conversationItem: {
                        ...this.props.welcomeMessage,
                        featureTypeId: (0, _featureTypeIds.WelcomeMessagesFeatureTypeId)
                    },
                    history: this.props.history,
                    featureTypeId: (0, _featureTypeIds.WelcomeMessagesFeatureTypeId),
                    followUp: responseGroups?.[0]?.firstResponse?.followUp,
                    contentId: this.props.welcomeMessage?.id,
                    onClose: this.props.onToggleNavigation,
                    onSave: this.handleAsyncSubmit.bind(this)
                }),
            treeRender: this.renderTree.bind(this),
            formPanelRender: ()=>(0, _react.jsx)((0, _pageContainerDefault.default), {
                    fill: true
                }, (0, _react.jsx)((0, _conversationItemActionButtonToolbarDefault.default), {
                    errors: Object.values(props.errors),
                    validateForm: props.validateForm,
                    publishDisabled: this.props.assistantApplication == null,
                    saveDisabled: Object.keys(props.errors).length > 0,
                    contentItem: props.welcomeMessage,
                    isLoading: isLoading,
                    handleDiscardChanges: this.handleDiscardChanges.bind(this),
                    handlePublishing: this.handleSaveAndPublish.bind(this),
                    submitForm: props.submitForm
                }), props.welcomeMessage?.createdFromId && (0, _react.jsx)((0, _templateLockedBannerDefault.default), {
                    isLoading: props.stateContainer.state.isTogglingSync,
                    isLinked: props.isTemplateOwned,
                    onRelink: this.handleToggleRelinkModal.bind(this),
                    onUnlink: ()=>this.props.onToggleSync(this.props.welcomeMessage.id, true)
                }), (0, _react.jsx)((0, _conversationItemFieldSetDefault.default), {
                    disabled: isDisabled,
                    withBanner: props.welcomeMessage?.createdFromId != null
                }, (0, _react.jsx)((0, _scrollablePanelBodyDefault.default), {
                    className: "scrollable-body"
                }, (0, _react.jsx)((0, _panelTitleDefault.default), {
                    title: "Content Editing",
                    detail: "Here’s where you can fill in the info about this content and determine the course of the conversation by filling in the relevant details."
                }), (0, _react.jsx)((0, _contentCollapsingSectionDefault.default), {
                    title: "Content Info",
                    id: "contentInfo",
                    icon: contentInfoIcon,
                    titleRightRowComponent: (0, _react.jsx)((0, _contentInfoOptionsDefault.default), {
                        webhookCount: this.props.stateContainer.state.webhookUpdates?.webhookInstances?.length ?? this.props.stateContainer.state.attachedWebhooks?.length ?? 0,
                        options: this.getOptions(this.props.welcomeMessage != null),
                        optionSelected: this.handleContentItemOptionSelected.bind(this),
                        manageWebhooks: this.showWebhookInstanceManager.bind(this),
                        showSensitiveConversation: this.state.showSensitiveConversation,
                        toggleSensitiveConversation: ()=>{
                            this.toggleSensitiveConversation();
                        },
                        showDisabledForFeatures: this.state.showDisabledForFeatureFlags,
                        toggleDisabledForFeatures: ()=>{
                            this.toggleDisableForFeatureFlags();
                        },
                        flagsSelected: props.values.disabledForFeatureFlagIds?.length
                    })
                }, this.state.showSensitiveConversation && (0, _react.jsx)((0, _sensitiveDataOptionsDefault.default), {
                    selectedOption: props.values.sensitiveConversationChange ?? "None",
                    onChange: (value)=>{
                        props.setFieldValue("sensitiveConversationChange", value);
                    }
                }), this.state.showDisabledForFeatureFlags && (0, _react.jsx)((0, _disableForFeatureFlagOptionsDefault.default), {
                    appContainer: this.props.appContainer,
                    onChange: (value)=>{
                        props.setFieldValue("disabledForFeatureFlagIds", value);
                    },
                    selectedFeatureFlags: props.values.disabledForFeatureFlagIds
                }), (0, _react.jsx)((0, _contentSectionTitleDefault.default), {
                    title: "Welcome Message Conversation",
                    icon: (0, _extensions.getFeatureTypeIcon)((0, _featureTypeIds.WelcomeMessagesFeatureTypeId), true)
                }), (0, _react.jsx)((0, _titleTextFieldDefault.default), {
                    id: "contentTitle",
                    disabled: isDisabled,
                    name: "title",
                    placeholder: "For display only",
                    value: props.values.title,
                    label: "Title",
                    onChange: props.handleChange,
                    onBlur: props.handleBlur
                }), (0, _react.jsx)((0, _contentLanguageMultiSelectorDefault.default), {
                    id: "contentLanguage",
                    disabled: isDisabled,
                    label: "Language / Region",
                    languages: props.application?.languages,
                    selectedLanguageIds: props.values.languages.map((l)=>l.id),
                    onChange: this.handleLanguagesChange.bind(this)
                }), this.renderOptions(false, isDisabled, true)), (0, _react.jsx)((0, _responsesManagerDefault.default), {
                    applicationId: this.props.application?.id,
                    applicationFeatureId: this.props.applicationFeatureId,
                    languages: this.props.values.languages,
                    responseGroups: responseGroups,
                    getConditionsKey: (c)=>this.getConditionsKey(c),
                    isDisabled: isDisabled,
                    onChange: this.handleResponsesChange.bind(this),
                    showError: this.showError.bind(this),
                    onBlur: this.props.handleBlur,
                    emptyFollowUpOptionText: "Default - await further user input",
                    emptyFollowUpOptionIcon: continueIcon,
                    simulatedResponseId: simulatedResponseId,
                    responseIdToNamesRef: this.responseIdToNamesRef,
                    contentItemTitle: this.props.values.title
                }))), (0, _react.jsx)((0, _pageErrorDefault.default), {
                    errors: this.props?.stateContainer?.state?.errors ?? [],
                    onClear: this.handleClearError.bind(this)
                })),
            testCasesRender: ()=>(0, _react.jsx)((0, _contentItemTestCaseViewerDefault.default), {
                    application: this.props.application,
                    contentItemId: this.props.welcomeMessage?.id,
                    getResponseId: this.handleResponseIdFromSim,
                    responseIdToNamesRef: this.responseIdToNamesRef
                })
        })), this.renderRelinkSyncWarning(), this.renderWebhookInstanceManager(this.props.application?.id, this.props.welcomeMessage?.id, (0, _featureTypeIds.WelcomeMessagesFeatureTypeId), this.props.values.webhookChainingType));
    }
}
exports.default = WelcomeMessageForm;

},{"@babel/runtime/helpers/defineProperty":"9sJxO","@emotion/react":"djZKr","react":"6uln9","../../components/structure/PageContainer":"hc1r8","../../components/forms/TitleTextField":"6fj1a","../followUpForm":"5HXc2","../../components/general/Loader":"bnV5T","../../constants/featureTypeIds":"hPLMP","../../components/forms/ContentLanguageMultiSelector":"4SbwP","../contentPage":"6VyMV","../relatedContentMenu":"aWiMy","../../components/structure/ScrollablePanelBody":"6LRg3","../contentPage/components/PanelTitle":"anVUR","../../components/structure/ContentCollapsingSection":"1CUms","../contentPage/components/ContentSectionTitle":"5RGHr","../../models/extensions":"7h01B","../../components/general/PageError":"ezFTm","./components/ConversationItemActionButtonToolbar":"TGPQ9","../../components/general/TemplateLockedBanner":"gMkKq","../../components/forms/ConversationItemFieldSet":"8a3oA","../../components/structure/ContentInfoOptions":"6Ozsc","../responsesManager":"jtCYo","./components/DirtyFormPrompt":"i9WDI","../contentPage/components/SensitiveDataOptions":"oXWpd","../contentPage/components/DisableForFeatureFlagOptions":"67JXM","./ContentItemTestCaseViewer":"6EkXj","168c3cd204a5ec37":"fKr4T","e47430235bb5bfae":"d8BS5","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"kD2Qe":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _unstated = require("unstated");
var _welcomeMessageContainer = require("../../state/containers/WelcomeMessageContainer");
var _welcomeMessageContainerDefault = parcelHelpers.interopDefault(_welcomeMessageContainer);
var _editWelcomeMessageForm = require("./components/EditWelcomeMessageForm");
var _editWelcomeMessageFormDefault = parcelHelpers.interopDefault(_editWelcomeMessageForm);
var _applicationContainer = require("../../state/containers/ApplicationContainer");
var _applicationContainerDefault = parcelHelpers.interopDefault(_applicationContainer);
var _titleStateContainer = require("../../state/containers/TitleStateContainer");
var _titleStateContainerDefault = parcelHelpers.interopDefault(_titleStateContainer);
var _followUpContainer = require("../../state/containers/FollowUpContainer");
var _followUpContainerDefault = parcelHelpers.interopDefault(_followUpContainer);
var _repromptContainer = require("../../state/containers/RepromptContainer");
var _repromptContainerDefault = parcelHelpers.interopDefault(_repromptContainer);
var _mediaResponseContainer = require("../../state/containers/MediaResponseContainer");
var _mediaResponseContainerDefault = parcelHelpers.interopDefault(_mediaResponseContainer);
var _genericEditContentItemPage = require("../formScenes/GenericEditContentItemPage");
var _genericEditContentItemPageDefault = parcelHelpers.interopDefault(_genericEditContentItemPage);
var _featureContainer = require("../../state/containers/FeatureContainer");
var _featureContainerDefault = parcelHelpers.interopDefault(_featureContainer);
var _featureTypeIds = require("../../constants/featureTypeIds");
var _queryString = require("query-string");
var _queryStringDefault = parcelHelpers.interopDefault(_queryString);
var _applicationEnvironmentsContainer = require("../../state/containers/ApplicationEnvironmentsContainer");
var _applicationEnvironmentsContainerDefault = parcelHelpers.interopDefault(_applicationEnvironmentsContainer);
var _applicationBackupVersionsContainer = require("../../state/containers/ApplicationBackupVersionsContainer");
var _applicationBackupVersionsContainerDefault = parcelHelpers.interopDefault(_applicationBackupVersionsContainer);
class EditWelcomeMessage extends (0, _reactDefault.default).Component {
    render() {
        return (0, _react.jsx)((0, _unstated.Subscribe), {
            key: this.props.match.params.welcomeMessageId + this.props.match.params.applicationFeatureId,
            to: [
                (0, _welcomeMessageContainerDefault.default),
                (0, _applicationContainerDefault.default),
                (0, _titleStateContainerDefault.default),
                (0, _repromptContainerDefault.default),
                (0, _followUpContainerDefault.default),
                (0, _mediaResponseContainerDefault.default),
                (0, _featureContainerDefault.default),
                (0, _applicationEnvironmentsContainerDefault.default),
                (0, _applicationBackupVersionsContainerDefault.default)
            ]
        }, (welcomeContainer, applicationContainer, titleContainer, repromptContainer, followUpContainer, responseContainer, featureContainer, environmentsContainer, backupsContainer)=>{
            return (0, _react.jsx)((0, _genericEditContentItemPageDefault.default), {
                stateContainer: welcomeContainer,
                environmentsContainer: environmentsContainer,
                backupsContainer: backupsContainer,
                titleContainer: titleContainer,
                applicationContainer: applicationContainer,
                defaultTitle: "Edit Welcome Message",
                contentItemId: this.props.match.params.welcomeMessageId,
                history: this.props.history,
                location: this.props.location,
                match: this.props.match,
                staticContext: this.props.staticContext,
                featureContainer: featureContainer,
                featureTypeId: (0, _featureTypeIds.WelcomeMessagesFeatureTypeId),
                formRender: (contentItem, application, isTemplateOwned, assistantApplication, onShowPublishModal, onSubmit, toggleSync, onAccessTypeChange)=>(0, _react.jsx)((0, _editWelcomeMessageFormDefault.default), {
                        location: this.props.location,
                        application: application,
                        applicationFeatureId: this.props.match.params.applicationFeatureId,
                        welcomeMessage: contentItem,
                        stateContainer: welcomeContainer,
                        appContainer: applicationContainer,
                        followUpContainer: followUpContainer,
                        repromptContainer: repromptContainer,
                        responseStateContainer: responseContainer,
                        assistantApplication: assistantApplication,
                        onShowPublishModal: onShowPublishModal,
                        onSubmit: onSubmit,
                        onToggleSync: toggleSync,
                        onToggleNavigation: null,
                        onAccessTypeChange: onAccessTypeChange,
                        previousContentId: (0, _queryStringDefault.default)?.parse(this.props.location.search)?.previousContentId,
                        featureContainer: featureContainer,
                        history: this.props.history,
                        isSaving: welcomeContainer.state.isSaving,
                        isTemplateOwned: isTemplateOwned
                    })
            });
        });
    }
}
exports.default = EditWelcomeMessage;

},{"@emotion/react":"djZKr","react":"6uln9","unstated":"grh7p","../../state/containers/WelcomeMessageContainer":"j3orW","./components/EditWelcomeMessageForm":"2bZ4d","../../state/containers/ApplicationContainer":"cuqi2","../../state/containers/TitleStateContainer":"2osOD","../../state/containers/FollowUpContainer":"rm9OA","../../state/containers/RepromptContainer":"5vKMV","../../state/containers/MediaResponseContainer":"1ccrV","../formScenes/GenericEditContentItemPage":"6RzEJ","../../state/containers/FeatureContainer":"4ApGg","../../constants/featureTypeIds":"hPLMP","query-string":"klvAV","../../state/containers/ApplicationEnvironmentsContainer":"jCULY","../../state/containers/ApplicationBackupVersionsContainer":"6rA1P","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2bZ4d":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _formik = require("formik");
var _yup = require("yup");
var _welcomeMessageForm = require("../../formScenes/WelcomeMessageForm");
var _welcomeMessageFormDefault = parcelHelpers.interopDefault(_welcomeMessageForm);
const EditWelcomeMessageForm = (0, _formik.withFormik)({
    mapPropsToValues: (props)=>({
            title: props.welcomeMessage.title,
            responses: props.welcomeMessage.responses.length > 0 ? props.welcomeMessage.responses : [
                {
                    content: ""
                }
            ],
            languages: props.welcomeMessage.languages,
            isLive: props.welcomeMessage.isLive,
            webhookChainingType: props.welcomeMessage.webhookChainingType,
            showPublishModal: props?.location?.search?.includes("publishing=true") ?? false,
            sensitiveConversationChange: props.welcomeMessage.sensitiveConversationChange ?? "None",
            disabledForFeatureFlagIds: props.welcomeMessage?.disabledForFeatureFlagIds,
            requiresParent: false
        }),
    validationSchema: _yup.object().shape({
        title: _yup.string().required("You must enter a title"),
        responses: _yup.array().of(_yup.object().shape({
            content: _yup.string().required("You must enter an response variation")
        })).required("You must enter at least 1 response variation").min(1, "You must enter at least 1 response variation")
    }),
    validateOnMount: true,
    handleSubmit: (values, { props, setStatus })=>{
        setStatus({
            submitting: true
        });
        console.log(values);
        return props.onSubmit(props.stateContainer.mapFormDataToModel(props.welcomeMessage, values));
    }
})((0, _welcomeMessageFormDefault.default));
exports.default = EditWelcomeMessageForm;

},{"formik":"3YnOK","yup":"j2SJU","../../formScenes/WelcomeMessageForm":"93rpb","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8pmaC":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _unstated = require("unstated");
var _questionAnswerContainer = require("../../state/containers/QuestionAnswerContainer");
var _questionAnswerContainerDefault = parcelHelpers.interopDefault(_questionAnswerContainer);
var _questionAnswerContentForm = require("./components/QuestionAnswerContentForm");
var _questionAnswerContentFormDefault = parcelHelpers.interopDefault(_questionAnswerContentForm);
var _applicationContainer = require("../../state/containers/ApplicationContainer");
var _applicationContainerDefault = parcelHelpers.interopDefault(_applicationContainer);
var _titleStateContainer = require("../../state/containers/TitleStateContainer");
var _titleStateContainerDefault = parcelHelpers.interopDefault(_titleStateContainer);
var _repromptContainer = require("../../state/containers/RepromptContainer");
var _repromptContainerDefault = parcelHelpers.interopDefault(_repromptContainer);
var _followUpContainer = require("../../state/containers/FollowUpContainer");
var _followUpContainerDefault = parcelHelpers.interopDefault(_followUpContainer);
var _mediaResponseContainer = require("../../state/containers/MediaResponseContainer");
var _mediaResponseContainerDefault = parcelHelpers.interopDefault(_mediaResponseContainer);
var _navigationBarFormPage = require("../formScenes/NavigationBarFormPage");
var _navigationBarFormPageDefault = parcelHelpers.interopDefault(_navigationBarFormPage);
var _genericCreateContentItemPage = require("../formScenes/GenericCreateContentItemPage");
var _genericCreateContentItemPageDefault = parcelHelpers.interopDefault(_genericCreateContentItemPage);
var _featureContainer = require("../../state/containers/FeatureContainer");
var _featureContainerDefault = parcelHelpers.interopDefault(_featureContainer);
var _featureTypeIds = require("../../constants/featureTypeIds");
class CreateQuestionAnswer extends (0, _navigationBarFormPageDefault.default) {
    render() {
        return (0, _react.jsx)((0, _unstated.Subscribe), {
            to: [
                (0, _questionAnswerContainerDefault.default),
                (0, _applicationContainerDefault.default),
                (0, _titleStateContainerDefault.default),
                (0, _repromptContainerDefault.default),
                (0, _followUpContainerDefault.default),
                (0, _mediaResponseContainerDefault.default),
                (0, _featureContainerDefault.default)
            ]
        }, (faqContainer, appContainer, titleContainer, repromptContainer, followUpContainer, responseStateContainer, featureContainer)=>{
            return (0, _react.jsx)((0, _genericCreateContentItemPageDefault.default), {
                stateContainer: faqContainer,
                titleContainer: titleContainer,
                applicationContainer: appContainer,
                featureContainer: featureContainer,
                defaultTitle: "New Question Answer",
                history: this.props.history,
                location: this.props.location,
                match: this.props.match,
                staticContext: this.props.staticContext,
                featureTypeId: (0, _featureTypeIds.QuestionAnswerFeatureTypeId),
                formRender: (application, assistantApplication, onPublish, onSubmit, onAccessTypeChange)=>(0, _react.jsx)((0, _questionAnswerContentFormDefault.default), {
                        location: this.props.location,
                        applicationFeatureId: this.props.match.params.applicationFeatureId,
                        application: application,
                        stateContainer: faqContainer,
                        assistantApplication: assistantApplication,
                        appContainer: appContainer,
                        repromptContainer: repromptContainer,
                        followUpContainer: followUpContainer,
                        responseStateContainer: responseStateContainer,
                        featureContainer: featureContainer,
                        history: this.props.history,
                        isSaving: faqContainer.state.isSaving,
                        onSubmit: onSubmit,
                        onShowPublishModal: onPublish,
                        onAccessTypeChange: onAccessTypeChange,
                        isTemplateOwned: false,
                        onToggleSync: null
                    })
            });
        });
    }
}
exports.default = CreateQuestionAnswer;

},{"@emotion/react":"djZKr","react":"6uln9","unstated":"grh7p","../../state/containers/QuestionAnswerContainer":"hfasy","./components/QuestionAnswerContentForm":"e26Vc","../../state/containers/ApplicationContainer":"cuqi2","../../state/containers/TitleStateContainer":"2osOD","../../state/containers/RepromptContainer":"5vKMV","../../state/containers/FollowUpContainer":"rm9OA","../../state/containers/MediaResponseContainer":"1ccrV","../formScenes/NavigationBarFormPage":"4ZcAE","../formScenes/GenericCreateContentItemPage":"dUUA3","../../state/containers/FeatureContainer":"4ApGg","../../constants/featureTypeIds":"hPLMP","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"e26Vc":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _formik = require("formik");
var _yup = require("yup");
var _questionAnswerForm = require("../../formScenes/QuestionAnswerForm");
var _questionAnswerFormDefault = parcelHelpers.interopDefault(_questionAnswerForm);
const QuestionAnswerContentForm = (0, _formik.withFormik)({
    mapPropsToValues: (props)=>({
            title: "Untitled FAQ",
            questions: [
                {
                    content: ""
                }
            ],
            responses: [
                {
                    content: ""
                }
            ],
            isLive: true,
            sensitiveConversationChange: "None",
            followUpSelection: "end",
            repromptSelection: "end",
            entryType: "open",
            requiresParent: false,
            languages: props.application?.languages.find((l)=>l.id == props.application?.defaultLanguageId) ? [
                props.application?.languages.find((l)=>l.id == props.application?.defaultLanguageId)
            ] : [],
            webhookChainingType: "NoChaining",
            minimumConfidenceScore: null,
            requiredPhrases: []
        }),
    validationSchema: _yup.object().shape({
        title: _yup.string().required("You must enter a title"),
        questions: _yup.array().of(_yup.object().shape({
            content: _yup.string().required("You must enter a question variation")
        })).required("You must enter at least 1 question variation").min(1, "You must enter at least 1 question variation"),
        responses: _yup.array().of(_yup.object().shape({
            content: _yup.string().required("You must enter a response variation")
        })).required("You must enter at least 1 answer variation").min(1, "You must enter at least 1 answer variation"),
        minimumConfidenceScore: _yup.number().typeError("Please provide a number between 0 and 1.").min(0, "Please provide a number between 0 and 1.").max(1, "Please provide a number between 0 and 1.").nullable(true)
    }),
    validateOnMount: true,
    handleSubmit: (values, { props, setStatus, setFieldValue })=>{
        setStatus({
            submitting: true
        });
        return props.onSubmit(props.stateContainer.mapFormDataToModel({
            applicationFeatureId: props.applicationFeatureId,
            applicationId: props.application.id,
            questionSet: [],
            responses: []
        }, values));
    }
})((0, _questionAnswerFormDefault.default));
exports.default = QuestionAnswerContentForm;

},{"formik":"3YnOK","yup":"j2SJU","../../formScenes/QuestionAnswerForm":"kUhv3","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"kUhv3":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _defineProperty = require("@babel/runtime/helpers/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _base = require("@emotion/styled/base");
var _baseDefault = parcelHelpers.interopDefault(_base);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _formik = require("formik");
var _button = require("../../components/general/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _contentCard = require("../../components/structure/ContentCard");
var _contentCardDefault = parcelHelpers.interopDefault(_contentCard);
var _pageContainer = require("../../components/structure/PageContainer");
var _pageContainerDefault = parcelHelpers.interopDefault(_pageContainer);
var _formFieldsContainer = require("../../components/structure/FormFieldsContainer");
var _formFieldsContainerDefault = parcelHelpers.interopDefault(_formFieldsContainer);
var _titleTextField = require("../../components/forms/TitleTextField");
var _titleTextFieldDefault = parcelHelpers.interopDefault(_titleTextField);
var _followUpForm = require("../followUpForm");
var _followUpFormDefault = parcelHelpers.interopDefault(_followUpForm);
var _loader = require("../../components/general/Loader");
var _loaderDefault = parcelHelpers.interopDefault(_loader);
var _textField = require("../../components/forms/TextField");
var _textFieldDefault = parcelHelpers.interopDefault(_textField);
var _featureTypeIds = require("../../constants/featureTypeIds");
var _contentLanguageMultiSelector = require("../../components/forms/ContentLanguageMultiSelector");
var _contentLanguageMultiSelectorDefault = parcelHelpers.interopDefault(_contentLanguageMultiSelector);
var _contentPage = require("../contentPage");
var _contentPageDefault = parcelHelpers.interopDefault(_contentPage);
var _contentCollapsingSection = require("../../components/structure/ContentCollapsingSection");
var _contentCollapsingSectionDefault = parcelHelpers.interopDefault(_contentCollapsingSection);
var _contentSectionTitle = require("../contentPage/components/ContentSectionTitle");
var _contentSectionTitleDefault = parcelHelpers.interopDefault(_contentSectionTitle);
var _extensions = require("../../models/extensions");
var _relatedContentMenu = require("../relatedContentMenu");
var _relatedContentMenuDefault = parcelHelpers.interopDefault(_relatedContentMenu);
var _scrollablePanelBody = require("../../components/structure/ScrollablePanelBody");
var _scrollablePanelBodyDefault = parcelHelpers.interopDefault(_scrollablePanelBody);
var _panelTitle = require("../contentPage/components/PanelTitle");
var _panelTitleDefault = parcelHelpers.interopDefault(_panelTitle);
var _pageError = require("../../components/general/PageError");
var _pageErrorDefault = parcelHelpers.interopDefault(_pageError);
var _conversationItemActionButtonToolbar = require("./components/ConversationItemActionButtonToolbar");
var _conversationItemActionButtonToolbarDefault = parcelHelpers.interopDefault(_conversationItemActionButtonToolbar);
var _templateLockedBanner = require("../../components/general/TemplateLockedBanner");
var _templateLockedBannerDefault = parcelHelpers.interopDefault(_templateLockedBanner);
var _conversationItemFieldSet = require("../../components/forms/ConversationItemFieldSet");
var _conversationItemFieldSetDefault = parcelHelpers.interopDefault(_conversationItemFieldSet);
var _responsesManager = require("../responsesManager");
var _responsesManagerDefault = parcelHelpers.interopDefault(_responsesManager);
var _contentInfoOptions = require("../../components/structure/ContentInfoOptions");
var _contentInfoOptionsDefault = parcelHelpers.interopDefault(_contentInfoOptions);
var _baseConversationItemForm = require("./BaseConversationItemForm");
var _dirtyFormPrompt = require("./components/DirtyFormPrompt");
var _css = require("@emotion/css");
var _colors = require("../../constants/colors");
var _horizontalOptionsSelector = require("../../components/forms/HorizontalOptionsSelector");
var _horizontalOptionsSelectorDefault = parcelHelpers.interopDefault(_horizontalOptionsSelector);
var _stylesValues = require("../../constants/stylesValues");
var _horizontalSeparator = require("../../components/structure/HorizontalSeparator");
var _horizontalSeparatorDefault = parcelHelpers.interopDefault(_horizontalSeparator);
var _countButton = require("../contentPage/components/CountButton");
var _sensitiveDataOptions = require("../contentPage/components/SensitiveDataOptions");
var _sensitiveDataOptionsDefault = parcelHelpers.interopDefault(_sensitiveDataOptions);
var _textFieldSubtitle = require("../../components/forms/TextFieldSubtitle");
var _textFieldSubtitleDefault = parcelHelpers.interopDefault(_textFieldSubtitle);
var _disableForFeatureFlagOptions = require("../contentPage/components/DisableForFeatureFlagOptions");
var _disableForFeatureFlagOptionsDefault = parcelHelpers.interopDefault(_disableForFeatureFlagOptions);
var _contentItemTestCaseViewer = require("./ContentItemTestCaseViewer");
var _contentItemTestCaseViewerDefault = parcelHelpers.interopDefault(_contentItemTestCaseViewer);
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const userIcon = require("a3a9b08c999fc8ce");
const contentInfoIcon = require("7d63c228e0b57787");
const inputGroupIcon = require("38a4c2300cb5b928");
const keywordsIcon = require("c52c9abadac989da");
const inputIcon = require("89f3e27f515d9903");
const requiredStarIcon = require("4f4ec863ab609327");
const confidenceScoreIcon = require("f763383445bee072");
const validationIcon = require("29bfd9660bdf09df");
const blueValidationIcon = require("a5b57192feb21c72");
class QuestionAnswerForm extends (0, _followUpFormDefault.default) {
    componentDidUpdate(prevProps, prevState) {
        super.componentDidUpdate(prevProps, prevState);
    }
    constructor(props){
        super(props);
        (0, _definePropertyDefault.default)(this, "handleResponseIdFromSim", (id)=>{
            this.setState({
                simulatedResponseId: id
            });
        });
        (0, _definePropertyDefault.default)(this, "options", [
            {
                name: "None",
                value: 0
            },
            {
                name: "Weak",
                value: .2
            },
            {
                name: "Fair",
                value: .4
            },
            {
                name: "Good",
                value: .6
            },
            {
                name: "Strong",
                value: .8
            },
            {
                name: "Exact",
                value: 1
            }
        ]);
        this.state = {
            showValidation: false
        };
    }
    toggleValidation() {
        this.setState({
            ...this.state,
            showValidation: !this.state.showValidation,
            showSensitiveConversation: false
        });
    }
    handleDiscardChanges() {
        this.handleFinish();
    }
    handleDelete() {
        const confirmed = confirm("Are you sure you want to delete this?");
        if (confirmed) this.props.stateContainer.delete(this.props.questionAnswer.id).then((result)=>{
            this.handleFinish();
        });
    }
    handleCopy() {
        this.handleAsyncSubmit(()=>{
            this.props.stateContainer.copy(this.props.questionAnswer.id).then((r2)=>{
                if (r2.resultType == "Ok") this.props.history.push(`/v/${r2.data.applicationFeatureId}/faqs/${r2.data.id}`);
            });
        });
    }
    handleAsyncSubmit(onSuccess) {
        if (this.manualValidate()) return this.props.onSubmit(this.props.stateContainer.mapFormDataToModel(this.props.questionAnswer, this.props.values), onSuccess);
    }
    getMenuTreeRoots() {
        var roots = [
            this.getContentInfoTreeItem(),
            {
                id: "user-says",
                title: "User-Says",
                isExpanded: this.isItemExpanded("user-says"),
                canExpand: true,
                icon: userIcon,
                linkTo: "#userSays",
                children: [
                    {
                        id: "input-options",
                        title: "Input Options",
                        canExpand: true,
                        isExpanded: this.isItemExpanded("input-options"),
                        icon: inputGroupIcon,
                        linkTo: "#inputOptions",
                        children: this.props.values.questions?.map((q, i)=>({
                                id: `q${i}`,
                                title: `Input Option #${i + 1}`,
                                canExpand: false,
                                icon: inputIcon,
                                linkTo: `#q${i}`
                            }))
                    }
                ]
            },
            ...this.getResponsesTreeItems(this.props.values.responses)
        ];
        return roots;
    }
    getContentItem() {
        return this.props.questionAnswer;
    }
    handleContentItemOptionSelected(option, event) {
        event.stopPropagation();
        if (option == "Manage Webhooks") this.showWebhookInstanceManager();
        else if (option == "Duplicate") this.handleCopy();
        else if (option == "Delete") this.handleDelete();
    }
    handleResponsesChange(responseGroups) {
        this.props.setFieldValue("responses", this.getResponsesFromGroups(responseGroups));
    }
    render() {
        const props = {
            ...this.props
        };
        const isLoading = props.stateContainer.state.isSaving;
        const isDisabled = isLoading || this.props.isTemplateOwned;
        const responseGroups = this.getResponseGroups(this.props.values.responses);
        const { simulatedResponseId } = this.state;
        if (this.props.responseStateContainer.state.isLoading || !this.props.application) return (0, _react.jsx)((0, _loaderDefault.default), null);
        return (0, _react.jsx)((0, _reactDefault.default).Fragment, null, (0, _react.jsx)("form", {
            id: "my-form",
            onSubmit: props.handleSubmit
        }, (0, _react.jsx)((0, _dirtyFormPrompt.DirtyFormPrompt), {
            allowPrompt: props.status?.submitting != true
        }), (0, _react.jsx)((0, _contentPageDefault.default), {
            relatedContentRender: ()=>(0, _react.jsx)((0, _relatedContentMenuDefault.default), {
                    parentContentId: this.props.previousContentId,
                    conversationItem: {
                        ...this.props.questionAnswer,
                        featureTypeId: (0, _featureTypeIds.QuestionAnswerFeatureTypeId)
                    },
                    history: this.props.history,
                    featureTypeId: (0, _featureTypeIds.QuestionAnswerFeatureTypeId),
                    followUp: responseGroups?.[0]?.firstResponse?.followUp,
                    contentId: this.props.questionAnswer?.id,
                    onClose: this.props.onToggleNavigation,
                    onSave: this.handleAsyncSubmit.bind(this)
                }),
            treeRender: this.renderTree.bind(this),
            formPanelRender: ()=>(0, _react.jsx)((0, _pageContainerDefault.default), {
                    fill: true
                }, (0, _react.jsx)((0, _conversationItemActionButtonToolbarDefault.default), {
                    errors: Object.values(props.errors),
                    validateForm: props.validateForm,
                    publishDisabled: this.props.assistantApplication == null,
                    saveDisabled: Object.keys(props.errors).length > 0,
                    contentItem: props.questionAnswer,
                    isLoading: isLoading,
                    handleDiscardChanges: this.handleDiscardChanges.bind(this),
                    handlePublishing: this.handleSaveAndPublish.bind(this),
                    submitForm: props.submitForm
                }), props.questionAnswer?.createdFromId && (0, _react.jsx)((0, _templateLockedBannerDefault.default), {
                    isLoading: props.stateContainer.state.isTogglingSync,
                    isLinked: props.isTemplateOwned,
                    onRelink: this.handleToggleRelinkModal.bind(this),
                    onUnlink: ()=>this.props.onToggleSync(this.props.questionAnswer.id, true)
                }), (0, _react.jsx)((0, _conversationItemFieldSetDefault.default), {
                    disabled: isDisabled,
                    withBanner: props.questionAnswer?.createdFromId != null
                }, (0, _react.jsx)((0, _scrollablePanelBodyDefault.default), {
                    className: "scrollable-body"
                }, (0, _react.jsx)((0, _panelTitleDefault.default), {
                    title: "Content Editing",
                    detail: "Here’s where you can fill in the info about this content and determine the course of the conversation by filling in the relevant details."
                }), (0, _react.jsx)((0, _contentCollapsingSectionDefault.default), {
                    className: "ac-content-info",
                    title: "Content Info",
                    id: "contentInfo",
                    icon: contentInfoIcon,
                    titleRightRowComponent: (0, _react.jsx)((0, _contentInfoOptionsDefault.default), {
                        webhookCount: this.props.stateContainer.state.webhookUpdates?.webhookInstances?.length ?? this.props.stateContainer.state.attachedWebhooks?.length ?? 0,
                        options: this.getOptions(this.props.questionAnswer != null),
                        optionSelected: this.handleContentItemOptionSelected.bind(this),
                        manageWebhooks: this.showWebhookInstanceManager.bind(this),
                        showSensitiveConversation: this.state.showSensitiveConversation,
                        toggleSensitiveConversation: ()=>{
                            this.toggleSensitiveConversation();
                        },
                        showDisabledForFeatures: this.state.showDisabledForFeatureFlags,
                        toggleDisabledForFeatures: ()=>{
                            this.toggleDisableForFeatureFlags();
                        },
                        flagsSelected: props.values.disabledForFeatureFlagIds?.length
                    })
                }, this.state.showSensitiveConversation && (0, _react.jsx)((0, _sensitiveDataOptionsDefault.default), {
                    selectedOption: props.values.sensitiveConversationChange ?? "None",
                    onChange: (value)=>{
                        props.setFieldValue("sensitiveConversationChange", value);
                    }
                }), this.state.showDisabledForFeatureFlags && (0, _react.jsx)((0, _disableForFeatureFlagOptionsDefault.default), {
                    appContainer: this.props.appContainer,
                    onChange: (value)=>{
                        props.setFieldValue("disabledForFeatureFlagIds", value);
                    },
                    selectedFeatureFlags: props.values.disabledForFeatureFlagIds
                }), (0, _react.jsx)((0, _contentSectionTitleDefault.default), {
                    title: "Question Answer Conversation",
                    icon: (0, _extensions.getFeatureTypeIcon)((0, _featureTypeIds.QuestionAnswerFeatureTypeId), true)
                }), (0, _react.jsx)((0, _titleTextFieldDefault.default), {
                    id: "contentTitle",
                    disabled: isDisabled,
                    name: "title",
                    placeholder: "For display only",
                    value: props.values.title,
                    label: "Title",
                    onChange: props.handleChange,
                    onBlur: props.handleBlur
                }), (0, _react.jsx)((0, _contentLanguageMultiSelectorDefault.default), {
                    disabled: isDisabled,
                    id: "contentLanguage",
                    label: "Language / Region",
                    languages: props.application.languages,
                    selectedLanguageIds: props.values.languages.map((l)=>l.id),
                    onChange: this.handleLanguagesChange.bind(this)
                }), this.renderOptions(false, isDisabled)), (0, _react.jsx)((0, _contentCollapsingSectionDefault.default), {
                    title: "User Says",
                    icon: userIcon,
                    id: "userSays",
                    titleRightRowComponent: (0, _react.jsx)("div", {
                        className: menuWrapperStyle
                    }, (0, _react.jsx)((0, _countButton.CountButton), {
                        isActive: this.state.showValidation,
                        onClick: ()=>{
                            this.toggleValidation();
                        },
                        activeIcon: blueValidationIcon,
                        inactiveIcon: validationIcon,
                        showCount: false,
                        text: "Validation"
                    }))
                }, this.state.showValidation && (0, _react.jsx)((0, _baseConversationItemForm.HighlightSection), null, (0, _react.jsx)((0, _contentCardDefault.default), {
                    title: "Confidence Score",
                    icon: confidenceScoreIcon
                }, (0, _react.jsx)((0, _formFieldsContainerDefault.default), null, (0, _react.jsx)(Description, null, "You may provide a score between 0 and 1 to indicate how closely you’d like what a user says to match one of the input variations you provide. If this threshold is not met, the content will not be returned."), (0, _react.jsx)((0, _horizontalOptionsSelectorDefault.default), {
                    name: "minimumConfidenceScore",
                    options: this.options,
                    value: props.values.minimumConfidenceScore,
                    isCustom: false,
                    onChange: (value)=>{
                        props.setFieldValue("minimumConfidenceScore", value);
                    }
                }))), (0, _react.jsx)((0, _contentCardDefault.default), {
                    title: "Requires Specific Keywords",
                    icon: keywordsIcon,
                    id: "requiredPhrases"
                }, (0, _react.jsx)((0, _formFieldsContainerDefault.default), null, (0, _react.jsx)(Description, null, "Type in required keywords or short phrases below. If the user doesn’t say one of the options, they will not engage with this conversation item."), (0, _react.jsx)((0, _formik.FieldArray), {
                    validateOnChange: false,
                    name: "requiredPhrases",
                    render: (arrayHelpers)=>(0, _react.jsx)("div", null, props.values.requiredPhrases?.map((requiredPhrase, index)=>(0, _react.jsx)((0, _reactDefault.default).Fragment, null, (0, _react.jsx)("div", {
                                key: "requiredPhrases" + index
                            }, (0, _react.jsx)((0, _textFieldSubtitleDefault.default), {
                                titleText: `Keyword #${index + 1}`,
                                canDelete: true,
                                onDelete: ()=>arrayHelpers.remove(index),
                                canCopy: false
                            }), (0, _react.jsx)((0, _textFieldDefault.default), {
                                id: `requiredPhrases${index}`,
                                disabled: isDisabled,
                                name: `requiredPhrases.${index}`,
                                value: requiredPhrase,
                                placeholder: "Keyword or Short Phrase",
                                label: "User Must Say",
                                onChange: props.handleChange,
                                onBlur: props.handleBlur
                            })))), (0, _react.jsx)((0, _horizontalSeparatorDefault.default), null), (0, _react.jsx)((0, _buttonDefault.default), {
                            disabled: isDisabled,
                            themes: [
                                "secondary-medium"
                            ],
                            type: "button",
                            text: "Add a Keyword",
                            onClick: ()=>arrayHelpers.push("")
                        }))
                })))), (0, _react.jsx)((0, _contentCardDefault.default), {
                    title: "Input Options",
                    icon: inputGroupIcon,
                    id: "inputOptions",
                    className: "ac-faq-input-card",
                    rightRender: ()=>(0, _react.jsx)((0, _reactDefault.default).Fragment, null, (0, _react.jsx)(RequiredContainer, null, (0, _react.jsx)(RequiredText, null, "At least one required"), (0, _react.jsx)(RequiredAsterixIcon, {
                            src: requiredStarIcon
                        })))
                }, (0, _react.jsx)(ContentCardSubText, null, "Any of the inputs here could trigger this conversation item."), (0, _react.jsx)((0, _formFieldsContainerDefault.default), null, (0, _react.jsx)((0, _formik.FieldArray), {
                    validateOnChange: false,
                    name: "questions",
                    render: (arrayHelpers)=>(0, _react.jsx)("div", null, props.values.questions.map((question, index)=>(0, _react.jsx)((0, _reactDefault.default).Fragment, null, (0, _react.jsx)("div", {
                                key: "q" + index,
                                className: "aFc-faq-input-option"
                            }, (0, _react.jsx)((0, _textFieldSubtitleDefault.default), {
                                titleText: `Input Option #${index + 1}`,
                                canDelete: index > 0,
                                canCopy: true,
                                onDelete: ()=>arrayHelpers.remove(index),
                                onCopy: ()=>arrayHelpers.insert(index, {
                                        ...question,
                                        questionId: null
                                    })
                            }), (0, _react.jsx)((0, _textFieldDefault.default), {
                                id: `q${index}`,
                                disabled: isDisabled,
                                name: `questions.${index}.content`,
                                value: question.content,
                                placeholder: "A Phrase",
                                label: "User Says",
                                onChange: props.handleChange,
                                onBlur: props.handleBlur
                            })))), (0, _react.jsx)((0, _horizontalSeparatorDefault.default), null), (0, _react.jsx)((0, _buttonDefault.default), {
                            disabled: isDisabled,
                            themes: [
                                "secondary-medium"
                            ],
                            type: "button",
                            text: "Add a Variation",
                            onClick: ()=>arrayHelpers.push({
                                    content: ""
                                })
                        }))
                })))), (0, _react.jsx)((0, _responsesManagerDefault.default), {
                    applicationId: this.props.application.id,
                    applicationFeatureId: this.props.applicationFeatureId,
                    languages: this.props.values.languages,
                    responseGroups: responseGroups,
                    getConditionsKey: (c)=>this.getConditionsKey(c),
                    showError: this.showError.bind(this),
                    isDisabled: isDisabled,
                    onChange: this.handleResponsesChange.bind(this),
                    onBlur: this.props.handleBlur,
                    simulatedResponseId: simulatedResponseId,
                    responseIdToNamesRef: this.responseIdToNamesRef,
                    contentItemTitle: this.props.values.title
                }))), (0, _react.jsx)((0, _pageErrorDefault.default), {
                    errors: this.props?.stateContainer?.state?.errors ?? [],
                    onClear: this.handleClearError.bind(this)
                })),
            testCasesRender: ()=>(0, _react.jsx)((0, _contentItemTestCaseViewerDefault.default), {
                    application: this.props.application,
                    contentItemId: this.props.questionAnswer?.id,
                    getResponseId: this.handleResponseIdFromSim,
                    responseIdToNamesRef: this.responseIdToNamesRef
                })
        })), this.renderRelinkSyncWarning(), this.renderWebhookInstanceManager(this.props.application.id, this.props.questionAnswer?.id, (0, _featureTypeIds.QuestionAnswerFeatureTypeId), this.props.values.webhookChainingType));
    }
}
const ValidationImage = /*#__PURE__*/ (0, _baseDefault.default)("img", {
    target: "e17h6aee5"
})({
    name: "1q4vxyr",
    styles: "margin-left:8px"
});
const menuWrapperStyle = /*#__PURE__*/ (0, _css.css)("margin-right:8px;margin-left:auto;display:flex;align-items:center;.validation-button{height:32px;padding:0 24px;background:", (0, _colors.color_gradients_silver_shift), ";border:", (0, _stylesValues.style_border_default), ";box-shadow:none;border-radius:16px;box-sizing:border-box;color:", (0, _colors.color_text_default), ";margin-right:16px;font-size:14px;line-height:20px;cursor:pointer;display:flex;align-items:center;font-family:'Muli';}.toggled{background:", (0, _colors.color_variants_ocean_light_opaque), ";border:1px solid ", (0, _colors.color_colors_ocean), ";color:", (0, _colors.color_colors_ocean), ";}", "");
const expanded = /*#__PURE__*/ (0, _css.css)({
    name: "4zleql",
    styles: "display:block"
});
const collapsed = /*#__PURE__*/ (0, _css.css)({
    name: "eivff4",
    styles: "display:none"
});
const RequiredContainer = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e17h6aee4"
})({
    name: "pn8r9s",
    styles: "display:flex;align-items:center;line-height:16px"
});
const RequiredAsterixIcon = /*#__PURE__*/ (0, _baseDefault.default)("img", {
    target: "e17h6aee3"
})("color:", (0, _colors.color_colors_decline), ";width:10px;");
const RequiredText = /*#__PURE__*/ (0, _baseDefault.default)("p", {
    target: "e17h6aee2"
})("size:12px;margin-right:9px;color:", (0, _colors.color_shades_darkest), ";");
const ContentCardSubText = /*#__PURE__*/ (0, _baseDefault.default)("p", {
    target: "e17h6aee1"
})("margin-top:8px;size:12px;line-height:16px;color:", (0, _colors.color_shades_darker), ";");
const Description = /*#__PURE__*/ (0, _baseDefault.default)("p", {
    target: "e17h6aee0"
})({
    name: "1s22u92",
    styles: "margin-bottom:32px"
});
exports.default = QuestionAnswerForm;

},{"@babel/runtime/helpers/defineProperty":"9sJxO","@emotion/styled/base":"lSuFu","@emotion/react":"djZKr","react":"6uln9","formik":"3YnOK","../../components/general/Button":"6ymxN","../../components/structure/ContentCard":"hJsdJ","../../components/structure/PageContainer":"hc1r8","../../components/structure/FormFieldsContainer":"h3hzh","../../components/forms/TitleTextField":"6fj1a","../followUpForm":"5HXc2","../../components/general/Loader":"bnV5T","../../components/forms/TextField":"7a7bh","../../constants/featureTypeIds":"hPLMP","../../components/forms/ContentLanguageMultiSelector":"4SbwP","../contentPage":"6VyMV","../../components/structure/ContentCollapsingSection":"1CUms","../contentPage/components/ContentSectionTitle":"5RGHr","../../models/extensions":"7h01B","../relatedContentMenu":"aWiMy","../../components/structure/ScrollablePanelBody":"6LRg3","../contentPage/components/PanelTitle":"anVUR","../../components/general/PageError":"ezFTm","./components/ConversationItemActionButtonToolbar":"TGPQ9","../../components/general/TemplateLockedBanner":"gMkKq","../../components/forms/ConversationItemFieldSet":"8a3oA","../responsesManager":"jtCYo","../../components/structure/ContentInfoOptions":"6Ozsc","./BaseConversationItemForm":"akSVo","./components/DirtyFormPrompt":"i9WDI","@emotion/css":"awUBr","../../constants/colors":"1p3OR","../../components/forms/HorizontalOptionsSelector":"6A3ab","../../constants/stylesValues":"dHVVv","../../components/structure/HorizontalSeparator":"Pw3HQ","../contentPage/components/CountButton":"dGBKj","../contentPage/components/SensitiveDataOptions":"oXWpd","../../components/forms/TextFieldSubtitle":"lJGWV","../contentPage/components/DisableForFeatureFlagOptions":"67JXM","./ContentItemTestCaseViewer":"6EkXj","a3a9b08c999fc8ce":"5aXrZ","7d63c228e0b57787":"fKr4T","38a4c2300cb5b928":"a8FLc","c52c9abadac989da":"bvVJx","89f3e27f515d9903":"iZ56c","4f4ec863ab609327":"20G3l","f763383445bee072":"elYBX","29bfd9660bdf09df":"IUggC","a5b57192feb21c72":"inP2n","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"5aXrZ":[function(require,module,exports) {
module.exports = require("c93ce5e1c65a8207").getBundleURL("kVLro") + require("d53e3964fb6c7599").resolve("1gI3f");

},{"c93ce5e1c65a8207":"c7Tr5","d53e3964fb6c7599":"fyJL2"}],"bvVJx":[function(require,module,exports) {
module.exports = require("931c64e27b8dbed2").getBundleURL("kVLro") + require("296b8e4fb670e516").resolve("36ypo");

},{"931c64e27b8dbed2":"c7Tr5","296b8e4fb670e516":"fyJL2"}],"IUggC":[function(require,module,exports) {
module.exports = require("e21a2d3d69668fdf").getBundleURL("kVLro") + require("d4d6c4aa1792dcc6").resolve("1mmnT");

},{"e21a2d3d69668fdf":"c7Tr5","d4d6c4aa1792dcc6":"fyJL2"}],"inP2n":[function(require,module,exports) {
module.exports = require("b6eda49fa212757a").getBundleURL("kVLro") + require("424e0e815ee5c99").resolve("bxmZz");

},{"b6eda49fa212757a":"c7Tr5","424e0e815ee5c99":"fyJL2"}],"esFpB":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _unstated = require("unstated");
var _questionAnswerContainer = require("../../state/containers/QuestionAnswerContainer");
var _questionAnswerContainerDefault = parcelHelpers.interopDefault(_questionAnswerContainer);
var _editQuestionAnswerContentForm = require("./components/EditQuestionAnswerContentForm");
var _editQuestionAnswerContentFormDefault = parcelHelpers.interopDefault(_editQuestionAnswerContentForm);
var _featureContainer = require("../../state/containers/FeatureContainer");
var _featureContainerDefault = parcelHelpers.interopDefault(_featureContainer);
var _applicationContainer = require("../../state/containers/ApplicationContainer");
var _applicationContainerDefault = parcelHelpers.interopDefault(_applicationContainer);
var _titleStateContainer = require("../../state/containers/TitleStateContainer");
var _titleStateContainerDefault = parcelHelpers.interopDefault(_titleStateContainer);
var _followUpContainer = require("../../state/containers/FollowUpContainer");
var _followUpContainerDefault = parcelHelpers.interopDefault(_followUpContainer);
var _repromptContainer = require("../../state/containers/RepromptContainer");
var _repromptContainerDefault = parcelHelpers.interopDefault(_repromptContainer);
var _mediaResponseContainer = require("../../state/containers/MediaResponseContainer");
var _mediaResponseContainerDefault = parcelHelpers.interopDefault(_mediaResponseContainer);
var _featureTypeIds = require("../../constants/featureTypeIds");
var _genericEditContentItemPage = require("../formScenes/GenericEditContentItemPage");
var _genericEditContentItemPageDefault = parcelHelpers.interopDefault(_genericEditContentItemPage);
var _queryString = require("query-string");
var _queryStringDefault = parcelHelpers.interopDefault(_queryString);
var _applicationEnvironmentsContainer = require("../../state/containers/ApplicationEnvironmentsContainer");
var _applicationEnvironmentsContainerDefault = parcelHelpers.interopDefault(_applicationEnvironmentsContainer);
var _applicationBackupVersionsContainer = require("../../state/containers/ApplicationBackupVersionsContainer");
var _applicationBackupVersionsContainerDefault = parcelHelpers.interopDefault(_applicationBackupVersionsContainer);
class EditQuestionAnswer extends (0, _reactDefault.default).Component {
    render() {
        return (0, _react.jsx)((0, _unstated.Subscribe), {
            key: this.props.match.params.questionAnswerId + this.props.match.params.applicationFeatureId,
            to: [
                (0, _questionAnswerContainerDefault.default),
                (0, _applicationContainerDefault.default),
                (0, _titleStateContainerDefault.default),
                (0, _repromptContainerDefault.default),
                (0, _followUpContainerDefault.default),
                (0, _mediaResponseContainerDefault.default),
                (0, _featureContainerDefault.default),
                (0, _applicationEnvironmentsContainerDefault.default),
                (0, _applicationBackupVersionsContainerDefault.default)
            ]
        }, (faqContainer, applicationContainer, titleContainer, repromptContainer, followUpContainer, responseContainer, featureContainer, environmentsContainer, backupsContainer)=>(0, _react.jsx)((0, _genericEditContentItemPageDefault.default), {
                stateContainer: faqContainer,
                environmentsContainer: environmentsContainer,
                backupsContainer: backupsContainer,
                titleContainer: titleContainer,
                applicationContainer: applicationContainer,
                defaultTitle: "Edit Question Answer",
                contentItemId: this.props.match.params.questionAnswerId,
                history: this.props.history,
                location: this.props.location,
                match: this.props.match,
                staticContext: this.props.staticContext,
                featureContainer: featureContainer,
                featureTypeId: (0, _featureTypeIds.QuestionAnswerFeatureTypeId),
                formRender: (contentItem, application, isTemplateOwned, assistantApplication, onShowPublishModal, onSubmit, toggleSync, onAccessTypeChange)=>(0, _react.jsx)((0, _editQuestionAnswerContentFormDefault.default), {
                        location: this.props.location,
                        applicationFeatureId: this.props.match.params.applicationFeatureId,
                        application: application,
                        appContainer: applicationContainer,
                        stateContainer: faqContainer,
                        questionAnswer: contentItem,
                        followUpContainer: followUpContainer,
                        repromptContainer: repromptContainer,
                        responseStateContainer: responseContainer,
                        featureContainer: featureContainer,
                        assistantApplication: assistantApplication,
                        onShowPublishModal: onShowPublishModal,
                        onAccessTypeChange: onAccessTypeChange,
                        onSubmit: onSubmit,
                        onToggleSync: toggleSync,
                        previousContentId: (0, _queryStringDefault.default)?.parse(this.props.location.search)?.previousContentId,
                        history: this.props.history,
                        isSaving: faqContainer.state.isSaving,
                        isTemplateOwned: isTemplateOwned
                    })
            }));
    }
}
exports.default = EditQuestionAnswer;

},{"@emotion/react":"djZKr","react":"6uln9","unstated":"grh7p","../../state/containers/QuestionAnswerContainer":"hfasy","./components/EditQuestionAnswerContentForm":"lJIgh","../../state/containers/FeatureContainer":"4ApGg","../../state/containers/ApplicationContainer":"cuqi2","../../state/containers/TitleStateContainer":"2osOD","../../state/containers/FollowUpContainer":"rm9OA","../../state/containers/RepromptContainer":"5vKMV","../../state/containers/MediaResponseContainer":"1ccrV","../../constants/featureTypeIds":"hPLMP","../formScenes/GenericEditContentItemPage":"6RzEJ","query-string":"klvAV","../../state/containers/ApplicationEnvironmentsContainer":"jCULY","../../state/containers/ApplicationBackupVersionsContainer":"6rA1P","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"lJIgh":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _formik = require("formik");
var _yup = require("yup");
var _questionAnswerForm = require("../../formScenes/QuestionAnswerForm");
var _questionAnswerFormDefault = parcelHelpers.interopDefault(_questionAnswerForm);
var _lodash = require("lodash");
var _lodashDefault = parcelHelpers.interopDefault(_lodash);
const EditQuestionAnswerContentForm = (0, _formik.withFormik)({
    mapPropsToValues: (props)=>{
        const questions = props.questionAnswer.questionSet;
        let firstQuestion = {};
        if (questions && questions.length > 0) firstQuestion = questions[0];
        const values = {
            title: props.questionAnswer.title,
            isLive: props.questionAnswer.isLive,
            webhookChainingType: props.questionAnswer.webhookChainingType,
            questions: props.questionAnswer.questionSet.length > 0 ? props.questionAnswer.questionSet.map((q)=>({
                    questionId: q.id,
                    content: q.content
                })) : [
                {
                    content: ""
                }
            ],
            responses: props.questionAnswer.responses.length > 0 ? (0, _lodashDefault.default).cloneDeep(props.questionAnswer.responses) : [
                {
                    content: ""
                }
            ],
            requiresParent: props.questionAnswer.requiresParent,
            languages: props.questionAnswer.languages,
            minimumConfidenceScore: firstQuestion?.minimumConfidenceScore,
            requiredPhrases: firstQuestion?.requiredPhrases ?? [],
            sensitiveConversationChange: props.questionAnswer.sensitiveConversationChange ?? "None",
            disabledForFeatureFlagIds: props.questionAnswer?.disabledForFeatureFlagIds
        };
        return values;
    },
    validationSchema: _yup.object().shape({
        title: _yup.string().required("You must enter a title"),
        questions: _yup.array().of(_yup.object().shape({
            content: _yup.string().required("You must enter a question variation")
        })).required("You must enter at least 1 question variation").min(1, "You must enter at least 1 question variation"),
        responses: _yup.array().of(_yup.object().shape({
            content: _yup.string().required("You must enter an response variation")
        })).required("You must enter at least 1 response variation").min(1, "You must enter at least 1 response variation"),
        minimumConfidenceScore: _yup.number().typeError("Please provide a number between 0 and 1.").min(0, "Please provide a number between 0 and 1.").max(1, "Please provide a number between 0 and 1.")
    }),
    validateOnMount: true,
    handleSubmit: (values, { props, setStatus })=>{
        setStatus({
            submitting: true
        });
        return props.onSubmit(props.stateContainer.mapFormDataToModel(props.questionAnswer, values));
    }
})((0, _questionAnswerFormDefault.default));
exports.default = EditQuestionAnswerContentForm;

},{"formik":"3YnOK","yup":"j2SJU","../../formScenes/QuestionAnswerForm":"kUhv3","lodash":"3hMBK","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"cM4pL":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _unstated = require("unstated");
var _latestMessageContainer = require("../../state/containers/LatestMessageContainer");
var _latestMessageContainerDefault = parcelHelpers.interopDefault(_latestMessageContainer);
var _latestMessageContentForm = require("./components/LatestMessageContentForm");
var _latestMessageContentFormDefault = parcelHelpers.interopDefault(_latestMessageContentForm);
var _applicationContainer = require("../../state/containers/ApplicationContainer");
var _applicationContainerDefault = parcelHelpers.interopDefault(_applicationContainer);
var _titleStateContainer = require("../../state/containers/TitleStateContainer");
var _titleStateContainerDefault = parcelHelpers.interopDefault(_titleStateContainer);
var _repromptContainer = require("../../state/containers/RepromptContainer");
var _repromptContainerDefault = parcelHelpers.interopDefault(_repromptContainer);
var _followUpContainer = require("../../state/containers/FollowUpContainer");
var _followUpContainerDefault = parcelHelpers.interopDefault(_followUpContainer);
var _mediaResponseContainer = require("../../state/containers/MediaResponseContainer");
var _mediaResponseContainerDefault = parcelHelpers.interopDefault(_mediaResponseContainer);
var _navigationBarFormPage = require("../formScenes/NavigationBarFormPage");
var _navigationBarFormPageDefault = parcelHelpers.interopDefault(_navigationBarFormPage);
var _genericCreateContentItemPage = require("../formScenes/GenericCreateContentItemPage");
var _genericCreateContentItemPageDefault = parcelHelpers.interopDefault(_genericCreateContentItemPage);
var _featureContainer = require("../../state/containers/FeatureContainer");
var _featureContainerDefault = parcelHelpers.interopDefault(_featureContainer);
var _featureTypeIds = require("../../constants/featureTypeIds");
class CreateLatestMessage extends (0, _navigationBarFormPageDefault.default) {
    render() {
        return (0, _react.jsx)((0, _unstated.Subscribe), {
            to: [
                (0, _latestMessageContainerDefault.default),
                (0, _applicationContainerDefault.default),
                (0, _titleStateContainerDefault.default),
                (0, _repromptContainerDefault.default),
                (0, _followUpContainerDefault.default),
                (0, _mediaResponseContainerDefault.default),
                (0, _featureContainerDefault.default)
            ]
        }, (latestMessageContainer, appContainer, titleContainer, repromptContainer, followUpContainer, responseStateContainer, featureContainer)=>{
            return (0, _react.jsx)((0, _genericCreateContentItemPageDefault.default), {
                stateContainer: latestMessageContainer,
                titleContainer: titleContainer,
                applicationContainer: appContainer,
                defaultTitle: "New Latest Message",
                history: this.props.history,
                location: this.props.location,
                match: this.props.match,
                staticContext: this.props.staticContext,
                featureContainer: featureContainer,
                featureTypeId: (0, _featureTypeIds.LatestMessagesFeatureTypeId),
                formRender: (application, assistantApplication, onPublish, onSubmit, onAccessTypeChange)=>(0, _react.jsx)((0, _latestMessageContentFormDefault.default), {
                        location: this.props.location,
                        applicationFeatureId: this.props.match.params.applicationFeatureId,
                        application: application,
                        assistantApplication: assistantApplication,
                        stateContainer: latestMessageContainer,
                        appContainer: appContainer,
                        repromptContainer: repromptContainer,
                        followUpContainer: followUpContainer,
                        responseStateContainer: responseStateContainer,
                        featureContainer: featureContainer,
                        history: this.props.history,
                        isSaving: latestMessageContainer.state.isSaving,
                        onAccessTypeChange: onAccessTypeChange,
                        onShowPublishModal: onPublish,
                        onSubmit: onSubmit
                    })
            });
        });
    }
}
exports.default = CreateLatestMessage;

},{"@emotion/react":"djZKr","react":"6uln9","unstated":"grh7p","../../state/containers/LatestMessageContainer":"1Hdqb","./components/LatestMessageContentForm":"lvAyu","../../state/containers/ApplicationContainer":"cuqi2","../../state/containers/TitleStateContainer":"2osOD","../../state/containers/RepromptContainer":"5vKMV","../../state/containers/FollowUpContainer":"rm9OA","../../state/containers/MediaResponseContainer":"1ccrV","../formScenes/NavigationBarFormPage":"4ZcAE","../formScenes/GenericCreateContentItemPage":"dUUA3","../../state/containers/FeatureContainer":"4ApGg","../../constants/featureTypeIds":"hPLMP","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"lvAyu":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _formik = require("formik");
var _yup = require("yup");
var _moment = require("moment");
var _momentDefault = parcelHelpers.interopDefault(_moment);
var _latestMessageForm = require("../../formScenes/LatestMessageForm");
var _latestMessageFormDefault = parcelHelpers.interopDefault(_latestMessageForm);
const LatestMessageContentForm = (0, _formik.withFormik)({
    mapPropsToValues: (props)=>({
            title: "Untitled Latest Message",
            category: "",
            startDate: (0, _momentDefault.default)().format("YYYY-MM-DD"),
            endDate: (0, _momentDefault.default)().format("YYYY-MM-DD"),
            responses: [
                {
                    content: ""
                }
            ],
            followUpSelection: "end",
            repromptSelection: "end",
            entryType: "open",
            sensitiveConversationChange: "None",
            requiresParent: false,
            isLive: true,
            languages: props.application?.languages.find((l)=>l.id == props.application?.defaultLanguageId) ? [
                props.application?.languages.find((l)=>l.id == props.application?.defaultLanguageId)
            ] : [],
            webhookChainingType: "NoChaining"
        }),
    validationSchema: _yup.object().shape({
        title: _yup.string().required("You must enter a title"),
        responses: _yup.array().of(_yup.object().shape({
            content: _yup.string().required("You must enter a response variation")
        })).required("You must enter at least 1 response variation").min(1, "You must enter at least 1 response variation"),
        category: _yup.string().required("You must enter a category"),
        startDate: _yup.date().required("You must enter a start date"),
        endDate: _yup.date().required("You must enter an end date")
    }),
    validateOnMount: true,
    handleSubmit: (values, { props, setStatus, setFieldValue })=>{
        setStatus({
            submitting: true
        });
        return props.onSubmit(props.stateContainer.mapFormDataToModel({
            applicationFeatureId: props.applicationFeatureId,
            applicationId: props.application?.id,
            responses: []
        }, values));
    }
})((0, _latestMessageFormDefault.default));
exports.default = LatestMessageContentForm;

},{"formik":"3YnOK","yup":"j2SJU","moment":"2meyw","../../formScenes/LatestMessageForm":"bSC0E","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"bSC0E":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _defineProperty = require("@babel/runtime/helpers/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _textField = require("../../components/forms/TextField");
var _textFieldDefault = parcelHelpers.interopDefault(_textField);
var _contentCard = require("../../components/structure/ContentCard");
var _contentCardDefault = parcelHelpers.interopDefault(_contentCard);
var _pageContainer = require("../../components/structure/PageContainer");
var _pageContainerDefault = parcelHelpers.interopDefault(_pageContainer);
var _formFieldsContainer = require("../../components/structure/FormFieldsContainer");
var _formFieldsContainerDefault = parcelHelpers.interopDefault(_formFieldsContainer);
var _horizontalFormFieldsContainer = require("../../components/structure/HorizontalFormFieldsContainer");
var _horizontalFormFieldsContainerDefault = parcelHelpers.interopDefault(_horizontalFormFieldsContainer);
var _titleTextField = require("../../components/forms/TitleTextField");
var _titleTextFieldDefault = parcelHelpers.interopDefault(_titleTextField);
var _followUpForm = require("../followUpForm");
var _followUpFormDefault = parcelHelpers.interopDefault(_followUpForm);
var _loader = require("../../components/general/Loader");
var _loaderDefault = parcelHelpers.interopDefault(_loader);
var _featureTypeIds = require("../../constants/featureTypeIds");
var _contentLanguageMultiSelector = require("../../components/forms/ContentLanguageMultiSelector");
var _contentLanguageMultiSelectorDefault = parcelHelpers.interopDefault(_contentLanguageMultiSelector);
var _contentPage = require("../contentPage");
var _contentPageDefault = parcelHelpers.interopDefault(_contentPage);
var _relatedContentMenu = require("../relatedContentMenu");
var _relatedContentMenuDefault = parcelHelpers.interopDefault(_relatedContentMenu);
var _scrollablePanelBody = require("../../components/structure/ScrollablePanelBody");
var _scrollablePanelBodyDefault = parcelHelpers.interopDefault(_scrollablePanelBody);
var _panelTitle = require("../contentPage/components/PanelTitle");
var _panelTitleDefault = parcelHelpers.interopDefault(_panelTitle);
var _contentCollapsingSection = require("../../components/structure/ContentCollapsingSection");
var _contentCollapsingSectionDefault = parcelHelpers.interopDefault(_contentCollapsingSection);
var _contentSectionTitle = require("../contentPage/components/ContentSectionTitle");
var _contentSectionTitleDefault = parcelHelpers.interopDefault(_contentSectionTitle);
var _extensions = require("../../models/extensions");
var _pageError = require("../../components/general/PageError");
var _pageErrorDefault = parcelHelpers.interopDefault(_pageError);
var _conversationItemActionButtonToolbar = require("./components/ConversationItemActionButtonToolbar");
var _conversationItemActionButtonToolbarDefault = parcelHelpers.interopDefault(_conversationItemActionButtonToolbar);
var _templateLockedBanner = require("../../components/general/TemplateLockedBanner");
var _templateLockedBannerDefault = parcelHelpers.interopDefault(_templateLockedBanner);
var _conversationItemFieldSet = require("../../components/forms/ConversationItemFieldSet");
var _conversationItemFieldSetDefault = parcelHelpers.interopDefault(_conversationItemFieldSet);
var _contentInfoOptions = require("../../components/structure/ContentInfoOptions");
var _contentInfoOptionsDefault = parcelHelpers.interopDefault(_contentInfoOptions);
var _responsesManager = require("../responsesManager");
var _responsesManagerDefault = parcelHelpers.interopDefault(_responsesManager);
var _dirtyFormPrompt = require("./components/DirtyFormPrompt");
var _sensitiveDataOptions = require("../contentPage/components/SensitiveDataOptions");
var _sensitiveDataOptionsDefault = parcelHelpers.interopDefault(_sensitiveDataOptions);
var _disableForFeatureFlagOptions = require("../contentPage/components/DisableForFeatureFlagOptions");
var _disableForFeatureFlagOptionsDefault = parcelHelpers.interopDefault(_disableForFeatureFlagOptions);
var _contentItemTestCaseViewer = require("./ContentItemTestCaseViewer");
var _contentItemTestCaseViewerDefault = parcelHelpers.interopDefault(_contentItemTestCaseViewer);
const userIcon = require("4e763ebc39a5a636");
const contentInfoIcon = require("f60002c1512a52c5");
const inputGroupIcon = require("8410ddf894b12a9d");
const inputIcon = require("836500aa922a13d6");
class LatestMessageForm extends (0, _followUpFormDefault.default) {
    constructor(...args){
        super(...args);
        (0, _definePropertyDefault.default)(this, "handleResponseIdFromSim", (id)=>{
            this.setState({
                simulatedResponseId: id
            });
        });
    }
    componentDidUpdate(prevProps, prevState) {
        super.componentDidUpdate(prevProps, prevState);
    }
    handleAsyncSubmit(onSuccess) {
        if (this.manualValidate()) return this.props.onSubmit(this.props.stateContainer.mapFormDataToModel(this.props.latestMessage, this.props.values), onSuccess);
    }
    handleDiscardChanges() {
        this.handleFinish();
    }
    getPlaceholderCategoryName() {
        return this.props.values.category === "" ? "{Category}" : this.props.values.category;
    }
    handleDelete() {
        const confirmed = confirm("Are you sure you want to delete this?");
        if (confirmed) this.props.stateContainer.delete(this.props.latestMessage.id).then(()=>{
            this.handleFinish();
        });
    }
    handleCopy() {
        this.handleAsyncSubmit(()=>{
            this.props.stateContainer.copy(this.props.latestMessage.id).then((r2)=>{
                if (r2.resultType == "Ok") this.props.history.push(`/v/${r2.data.applicationFeatureId}/latestmessages/${r2.data.id}`);
            });
        });
    }
    getMenuTreeRoots() {
        var roots = [
            this.getContentInfoTreeItem(),
            {
                id: "user-says",
                title: "User-Says",
                isExpanded: this.isItemExpanded("user-says"),
                canExpand: true,
                icon: userIcon,
                linkTo: "#userSays",
                children: [
                    {
                        id: "phrases",
                        title: "Input Options",
                        canExpand: true,
                        isExpanded: this.isItemExpanded("phrases"),
                        icon: inputGroupIcon,
                        linkTo: "#phrases",
                        children: [
                            {
                                id: "category",
                                title: "Category",
                                canExpand: false,
                                icon: inputIcon,
                                linkTo: "#category"
                            },
                            {
                                id: "startEnd",
                                title: "Start/End Date",
                                canExpand: false,
                                icon: inputIcon,
                                linkTo: "#startEnd"
                            }
                        ]
                    }
                ]
            },
            ...this.getResponsesTreeItems(this.props.values.responses)
        ];
        return roots;
    }
    getContentItem() {
        return this.props.latestMessage;
    }
    handleContentItemOptionSelected(option, event) {
        event.stopPropagation();
        if (option == "Manage Webhooks") this.showWebhookInstanceManager();
        else if (option == "Duplicate") this.handleCopy();
        else if (option == "Delete") this.handleDelete();
    }
    handleResponsesChange(responseGroups) {
        this.props.setFieldValue("responses", this.getResponsesFromGroups(responseGroups));
    }
    render() {
        const props = {
            ...this.props
        };
        const isLoading = props.stateContainer.state.isSaving;
        const isDisabled = isLoading || this.props.isTemplateOwned;
        const responseGroups = this.getResponseGroups(this.props.values.responses);
        const { simulatedResponseId } = this.state;
        if (this.props.responseStateContainer.state.isLoading || !this.props.application) return (0, _react.jsx)((0, _loaderDefault.default), null);
        return (0, _react.jsx)((0, _reactDefault.default).Fragment, null, (0, _react.jsx)("form", {
            onSubmit: props.handleSubmit
        }, (0, _react.jsx)((0, _dirtyFormPrompt.DirtyFormPrompt), {
            allowPrompt: props.status?.submitting != true
        }), (0, _react.jsx)((0, _contentPageDefault.default), {
            relatedContentRender: ()=>(0, _react.jsx)((0, _relatedContentMenuDefault.default), {
                    parentContentId: this.props.previousContentId,
                    conversationItem: {
                        ...this.props.latestMessage,
                        featureTypeId: (0, _featureTypeIds.LatestMessagesFeatureTypeId)
                    },
                    history: this.props.history,
                    featureTypeId: (0, _featureTypeIds.LatestMessagesFeatureTypeId),
                    followUp: responseGroups?.[0]?.firstResponse?.followUp,
                    contentId: this.props.latestMessage?.id,
                    onClose: this.props.onToggleNavigation,
                    onSave: this.handleAsyncSubmit.bind(this)
                }),
            treeRender: this.renderTree.bind(this),
            formPanelRender: ()=>(0, _react.jsx)((0, _pageContainerDefault.default), {
                    fill: true
                }, (0, _react.jsx)((0, _conversationItemActionButtonToolbarDefault.default), {
                    errors: Object.values(props.errors),
                    validateForm: props.validateForm,
                    publishDisabled: this.props.assistantApplication == null,
                    saveDisabled: Object.keys(props.errors).length > 0,
                    contentItem: props.latestMessage,
                    isLoading: isLoading,
                    handleDiscardChanges: this.handleDiscardChanges.bind(this),
                    handlePublishing: this.handleSaveAndPublish.bind(this),
                    submitForm: props.submitForm
                }), props.latestMessage?.createdFromId && (0, _react.jsx)((0, _templateLockedBannerDefault.default), {
                    isLoading: props.stateContainer.state.isTogglingSync,
                    isLinked: props.isTemplateOwned,
                    onRelink: this.handleToggleRelinkModal.bind(this),
                    onUnlink: ()=>this.props.onToggleSync(this.props.latestMessage.id, true)
                }), (0, _react.jsx)((0, _conversationItemFieldSetDefault.default), {
                    disabled: isDisabled,
                    withBanner: props.latestMessage?.createdFromId != null
                }, (0, _react.jsx)((0, _scrollablePanelBodyDefault.default), {
                    className: "scrollable-body"
                }, (0, _react.jsx)((0, _panelTitleDefault.default), {
                    title: "Content Editing",
                    detail: "Here’s where you can fill in the info about this content and determine the course of the conversation by filling in the relevant details."
                }), (0, _react.jsx)((0, _contentCollapsingSectionDefault.default), {
                    title: "Content Info",
                    id: "contentInfo",
                    icon: contentInfoIcon,
                    titleRightRowComponent: (0, _react.jsx)((0, _contentInfoOptionsDefault.default), {
                        webhookCount: this.props.stateContainer.state.webhookUpdates?.webhookInstances?.length ?? this.props.stateContainer.state.attachedWebhooks?.length ?? 0,
                        options: this.getOptions(this.props.latestMessage != null),
                        optionSelected: this.handleContentItemOptionSelected.bind(this),
                        manageWebhooks: this.showWebhookInstanceManager.bind(this),
                        showSensitiveConversation: this.state.showSensitiveConversation,
                        toggleSensitiveConversation: ()=>{
                            this.toggleSensitiveConversation();
                        },
                        showDisabledForFeatures: this.state.showDisabledForFeatureFlags,
                        toggleDisabledForFeatures: ()=>{
                            this.toggleDisableForFeatureFlags();
                        },
                        flagsSelected: props.values.disabledForFeatureFlagIds?.length
                    })
                }, this.state.showSensitiveConversation && (0, _react.jsx)((0, _sensitiveDataOptionsDefault.default), {
                    selectedOption: props.values.sensitiveConversationChange ?? "None",
                    onChange: (value)=>{
                        props.setFieldValue("sensitiveConversationChange", value);
                    }
                }), this.state.showDisabledForFeatureFlags && (0, _react.jsx)((0, _disableForFeatureFlagOptionsDefault.default), {
                    appContainer: this.props.appContainer,
                    onChange: (value)=>{
                        props.setFieldValue("disabledForFeatureFlagIds", value);
                    },
                    selectedFeatureFlags: props.values.disabledForFeatureFlagIds
                }), (0, _react.jsx)((0, _contentSectionTitleDefault.default), {
                    title: "Latest Message Conversation",
                    icon: (0, _extensions.getFeatureTypeIcon)((0, _featureTypeIds.LatestMessagesFeatureTypeId), true)
                }), (0, _react.jsx)((0, _titleTextFieldDefault.default), {
                    id: "contentTitle",
                    disabled: isDisabled,
                    name: "title",
                    placeholder: "For display only",
                    value: props.values.title,
                    label: "Title",
                    onChange: props.handleChange,
                    onBlur: props.handleBlur
                }), (0, _react.jsx)((0, _contentLanguageMultiSelectorDefault.default), {
                    id: "contentLanguage",
                    disabled: isDisabled,
                    label: "Language / Region",
                    languages: props.application.languages,
                    selectedLanguageIds: props.values.languages.map((l)=>l.id),
                    onChange: this.handleLanguagesChange.bind(this)
                }), this.renderOptions(false, isDisabled)), (0, _react.jsx)((0, _contentCollapsingSectionDefault.default), {
                    title: "User Says",
                    icon: userIcon,
                    id: "userSays"
                }, (0, _react.jsx)((0, _contentCardDefault.default), {
                    title: "Phrases",
                    icon: inputGroupIcon,
                    id: "phrases"
                }, (0, _react.jsx)((0, _formFieldsContainerDefault.default), null, (0, _react.jsx)((0, _textFieldDefault.default), {
                    id: "category",
                    disabled: isDisabled,
                    required: true,
                    name: "category",
                    value: props.values.category,
                    label: "Category",
                    placeholder: "Enter the category this message belongs to",
                    onChange: props.handleChange,
                    onBlur: props.handleBlur
                }), (0, _react.jsx)((0, _horizontalFormFieldsContainerDefault.default), null, (0, _react.jsx)((0, _textFieldDefault.default), {
                    id: "startEnd",
                    disabled: isDisabled,
                    required: true,
                    name: "startDate",
                    type: "date",
                    value: props.values.startDate,
                    label: "Effective Start Date",
                    onChange: props.handleChange,
                    onBlur: props.handleBlur
                }), (0, _react.jsx)((0, _textFieldDefault.default), {
                    disabled: isDisabled,
                    required: true,
                    name: "endDate",
                    type: "date",
                    value: props.values.endDate,
                    label: "Effect End Date",
                    onChange: props.handleChange,
                    onBlur: props.handleBlur
                }))))), (0, _react.jsx)((0, _responsesManagerDefault.default), {
                    applicationId: this.props.application.id,
                    applicationFeatureId: this.props.applicationFeatureId,
                    languages: this.props.values.languages,
                    responseGroups: responseGroups,
                    getConditionsKey: (c)=>this.getConditionsKey(c),
                    showError: this.showError.bind(this),
                    isDisabled: isDisabled,
                    onChange: this.handleResponsesChange.bind(this),
                    onBlur: this.props.handleBlur,
                    simulatedResponseId: simulatedResponseId,
                    responseIdToNamesRef: this.responseIdToNamesRef,
                    contentItemTitle: this.props.values.title
                }))), (0, _react.jsx)((0, _pageErrorDefault.default), {
                    errors: this.props?.stateContainer?.state?.errors ?? [],
                    onClear: this.handleClearError.bind(this)
                })),
            testCasesRender: ()=>(0, _react.jsx)((0, _contentItemTestCaseViewerDefault.default), {
                    application: this.props.application,
                    contentItemId: this.props.latestMessage?.id,
                    getResponseId: this.handleResponseIdFromSim,
                    responseIdToNamesRef: this.responseIdToNamesRef
                })
        })), this.renderRelinkSyncWarning(), this.renderWebhookInstanceManager(this.props.application.id, this.props.latestMessage?.id, (0, _featureTypeIds.LatestMessagesFeatureTypeId), this.props.values?.webhookChainingType));
    }
}
exports.default = LatestMessageForm;

},{"@babel/runtime/helpers/defineProperty":"9sJxO","@emotion/react":"djZKr","react":"6uln9","../../components/forms/TextField":"7a7bh","../../components/structure/ContentCard":"hJsdJ","../../components/structure/PageContainer":"hc1r8","../../components/structure/FormFieldsContainer":"h3hzh","../../components/structure/HorizontalFormFieldsContainer":"d9pZV","../../components/forms/TitleTextField":"6fj1a","../followUpForm":"5HXc2","../../components/general/Loader":"bnV5T","../../constants/featureTypeIds":"hPLMP","../../components/forms/ContentLanguageMultiSelector":"4SbwP","../contentPage":"6VyMV","../relatedContentMenu":"aWiMy","../../components/structure/ScrollablePanelBody":"6LRg3","../contentPage/components/PanelTitle":"anVUR","../../components/structure/ContentCollapsingSection":"1CUms","../contentPage/components/ContentSectionTitle":"5RGHr","../../models/extensions":"7h01B","../../components/general/PageError":"ezFTm","./components/ConversationItemActionButtonToolbar":"TGPQ9","../../components/general/TemplateLockedBanner":"gMkKq","../../components/forms/ConversationItemFieldSet":"8a3oA","../../components/structure/ContentInfoOptions":"6Ozsc","../responsesManager":"jtCYo","./components/DirtyFormPrompt":"i9WDI","../contentPage/components/SensitiveDataOptions":"oXWpd","../contentPage/components/DisableForFeatureFlagOptions":"67JXM","./ContentItemTestCaseViewer":"6EkXj","4e763ebc39a5a636":"5aXrZ","f60002c1512a52c5":"fKr4T","8410ddf894b12a9d":"a8FLc","836500aa922a13d6":"iZ56c","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"d9pZV":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const containerStyle = /*#__PURE__*/ (0, _css.css)({
    name: "e0x6bq",
    styles: "display:flex;flex-direction:row;align-items:stretch;justify-content:space-between;>div{width:45%;flex:1;}>*+*{margin-left:18px;}"
});
const HorizontalFormFieldsContainer = (props)=>(0, _react.jsx)("div", {
        className: containerStyle
    }, props.children);
exports.default = HorizontalFormFieldsContainer;

},{"@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"13xUA":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _unstated = require("unstated");
var _featureContainer = require("../../state/containers/FeatureContainer");
var _featureContainerDefault = parcelHelpers.interopDefault(_featureContainer);
var _latestMessageContainer = require("../../state/containers/LatestMessageContainer");
var _latestMessageContainerDefault = parcelHelpers.interopDefault(_latestMessageContainer);
var _updateLatestMessageContentForm = require("./components/UpdateLatestMessageContentForm");
var _updateLatestMessageContentFormDefault = parcelHelpers.interopDefault(_updateLatestMessageContentForm);
var _applicationContainer = require("../../state/containers/ApplicationContainer");
var _applicationContainerDefault = parcelHelpers.interopDefault(_applicationContainer);
var _titleStateContainer = require("../../state/containers/TitleStateContainer");
var _titleStateContainerDefault = parcelHelpers.interopDefault(_titleStateContainer);
var _repromptContainer = require("../../state/containers/RepromptContainer");
var _repromptContainerDefault = parcelHelpers.interopDefault(_repromptContainer);
var _followUpContainer = require("../../state/containers/FollowUpContainer");
var _followUpContainerDefault = parcelHelpers.interopDefault(_followUpContainer);
var _mediaResponseContainer = require("../../state/containers/MediaResponseContainer");
var _mediaResponseContainerDefault = parcelHelpers.interopDefault(_mediaResponseContainer);
var _genericEditContentItemPage = require("../formScenes/GenericEditContentItemPage");
var _genericEditContentItemPageDefault = parcelHelpers.interopDefault(_genericEditContentItemPage);
var _featureTypeIds = require("../../constants/featureTypeIds");
var _queryString = require("query-string");
var _queryStringDefault = parcelHelpers.interopDefault(_queryString);
var _applicationEnvironmentsContainer = require("../../state/containers/ApplicationEnvironmentsContainer");
var _applicationEnvironmentsContainerDefault = parcelHelpers.interopDefault(_applicationEnvironmentsContainer);
var _applicationBackupVersionsContainer = require("../../state/containers/ApplicationBackupVersionsContainer");
var _applicationBackupVersionsContainerDefault = parcelHelpers.interopDefault(_applicationBackupVersionsContainer);
class EditLatestMessage extends (0, _reactDefault.default).Component {
    render() {
        return (0, _react.jsx)((0, _unstated.Subscribe), {
            key: this.props.match.params.latestMessageId + this.props.match.params.applicationFeatureId,
            to: [
                (0, _latestMessageContainerDefault.default),
                (0, _applicationContainerDefault.default),
                (0, _titleStateContainerDefault.default),
                (0, _repromptContainerDefault.default),
                (0, _followUpContainerDefault.default),
                (0, _mediaResponseContainerDefault.default),
                (0, _featureContainerDefault.default),
                (0, _applicationEnvironmentsContainerDefault.default),
                (0, _applicationBackupVersionsContainerDefault.default)
            ]
        }, (latestMessageContainer, appContainer, titleContainer, repromptContainer, followUpContainer, responseContainer, featureContainer, environmentsContainer, backupsContainer)=>{
            return (0, _react.jsx)((0, _genericEditContentItemPageDefault.default), {
                stateContainer: latestMessageContainer,
                environmentsContainer: environmentsContainer,
                backupsContainer: backupsContainer,
                titleContainer: titleContainer,
                applicationContainer: appContainer,
                defaultTitle: "Edit Latest Message",
                contentItemId: this.props.match.params.latestMessageId,
                history: this.props.history,
                location: this.props.location,
                match: this.props.match,
                staticContext: this.props.staticContext,
                featureContainer: featureContainer,
                featureTypeId: (0, _featureTypeIds.LatestMessagesFeatureTypeId),
                formRender: (contentItem, application, isTemplateOwned, assistantApplication, onShowPublishModal, onSubmit, toggleSync, onAccessTypeChange)=>(0, _react.jsx)((0, _updateLatestMessageContentFormDefault.default), {
                        location: this.props.location,
                        applicationFeatureId: this.props.match.params.applicationFeatureId,
                        application: application,
                        latestMessage: contentItem,
                        stateContainer: latestMessageContainer,
                        repromptContainer: repromptContainer,
                        followUpContainer: followUpContainer,
                        appContainer: appContainer,
                        responseStateContainer: responseContainer,
                        featureContainer: featureContainer,
                        assistantApplication: assistantApplication,
                        onShowPublishModal: onShowPublishModal,
                        onAccessTypeChange: onAccessTypeChange,
                        onSubmit: onSubmit,
                        onToggleSync: toggleSync,
                        previousContentId: (0, _queryStringDefault.default)?.parse(this.props.location.search)?.previousContentId,
                        history: this.props.history,
                        isSaving: latestMessageContainer.state.isSaving,
                        isTemplateOwned: isTemplateOwned
                    })
            });
        });
    }
}
exports.default = EditLatestMessage;

},{"@emotion/react":"djZKr","react":"6uln9","unstated":"grh7p","../../state/containers/FeatureContainer":"4ApGg","../../state/containers/LatestMessageContainer":"1Hdqb","./components/UpdateLatestMessageContentForm":"2x2y9","../../state/containers/ApplicationContainer":"cuqi2","../../state/containers/TitleStateContainer":"2osOD","../../state/containers/RepromptContainer":"5vKMV","../../state/containers/FollowUpContainer":"rm9OA","../../state/containers/MediaResponseContainer":"1ccrV","../formScenes/GenericEditContentItemPage":"6RzEJ","../../constants/featureTypeIds":"hPLMP","query-string":"klvAV","../../state/containers/ApplicationEnvironmentsContainer":"jCULY","../../state/containers/ApplicationBackupVersionsContainer":"6rA1P","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2x2y9":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _formik = require("formik");
var _yup = require("yup");
var _moment = require("moment");
var _momentDefault = parcelHelpers.interopDefault(_moment);
var _latestMessageForm = require("../../formScenes/LatestMessageForm");
var _latestMessageFormDefault = parcelHelpers.interopDefault(_latestMessageForm);
const UpdateLatestMessageContentForm = (0, _formik.withFormik)({
    mapPropsToValues: (props)=>{
        var values = {
            title: props.latestMessage.title,
            category: props.latestMessage.category,
            startDate: (0, _momentDefault.default)(props.latestMessage.startDate).format("YYYY-MM-DD"),
            endDate: (0, _momentDefault.default)(props.latestMessage.endDate).format("YYYY-MM-DD"),
            responses: props.latestMessage.responses.length > 0 ? props.latestMessage.responses : [
                {
                    content: ""
                }
            ],
            requiresParent: props.latestMessage.requiresParent,
            languages: props.latestMessage.languages,
            isLive: props.latestMessage.isLive,
            webhookChainingType: props.latestMessage.webhookChainingType,
            sensitiveConversationChange: props.latestMessage.sensitiveConversationChange ?? "None",
            disabledForFeatureFlagIds: props.latestMessage?.disabledForFeatureFlagIds
        };
        return values;
    },
    validationSchema: _yup.object().shape({
        title: _yup.string().required("You must enter a title"),
        responses: _yup.array().of(_yup.object().shape({
            content: _yup.string().required("You must enter a response variation")
        })).required("You must enter at least 1 response variation").min(1, "You must enter at least 1 response variation"),
        category: _yup.string().required("You must enter a category"),
        startDate: _yup.date().required("You must enter a start date"),
        endDate: _yup.date().required("You must enter an end date")
    }),
    validateOnMount: true,
    handleSubmit: (values, { props, setStatus })=>{
        setStatus({
            submitting: true
        });
        return props.onSubmit(props.stateContainer.mapFormDataToModel(props.latestMessage, values));
    }
})((0, _latestMessageFormDefault.default));
exports.default = UpdateLatestMessageContentForm;

},{"formik":"3YnOK","yup":"j2SJU","moment":"2meyw","../../formScenes/LatestMessageForm":"bSC0E","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"i62o6":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _unstated = require("unstated");
var _authContainer = require("../../state/containers/AuthContainer");
var _authContainerDefault = parcelHelpers.interopDefault(_authContainer);
var _reactRouter = require("react-router");
var _organizationContainer = require("../../state/containers/OrganizationContainer");
var _organizationContainerDefault = parcelHelpers.interopDefault(_organizationContainer);
class Logout extends (0, _reactDefault.default).Component {
    render() {
        return (0, _react.jsx)((0, _unstated.Subscribe), {
            to: [
                (0, _authContainerDefault.default),
                (0, _organizationContainerDefault.default)
            ]
        }, (authContainer, orgContainer)=>{
            authContainer.signOut();
            orgContainer.setCurrentOrgById(null);
            location.reload();
            return (0, _react.jsx)((0, _reactRouter.Redirect), {
                to: "/login"
            });
        });
    }
}
exports.default = Logout;

},{"@emotion/react":"djZKr","react":"6uln9","unstated":"grh7p","../../state/containers/AuthContainer":"cl1Qb","react-router":"i3TiW","../../state/containers/OrganizationContainer":"dlbaM","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hUj9o":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _unstated = require("unstated");
var _fullScreenLayout = require("../../../shared/scenes/fullScreenLayout");
var _fullScreenLayoutDefault = parcelHelpers.interopDefault(_fullScreenLayout);
var _applicationContainer = require("../../../shared/state/containers/ApplicationContainer");
var _applicationContainerDefault = parcelHelpers.interopDefault(_applicationContainer);
var _organizationContainer = require("../../../shared/state/containers/OrganizationContainer");
var _organizationContainerDefault = parcelHelpers.interopDefault(_organizationContainer);
var _horizontalContainer = require("../../../shared/components/structure/HorizontalContainer");
var _horizontalContainerDefault = parcelHelpers.interopDefault(_horizontalContainer);
var _modalTitle = require("../../../shared/components/general/ModalTitle");
var _modalTitleDefault = parcelHelpers.interopDefault(_modalTitle);
var _button = require("../../../shared/components/general/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _horizontalSeparator = require("../../../shared/components/structure/HorizontalSeparator");
var _horizontalSeparatorDefault = parcelHelpers.interopDefault(_horizontalSeparator);
var _pageError = require("../../../shared/components/general/PageError");
var _pageErrorDefault = parcelHelpers.interopDefault(_pageError);
var _createApplicationForm = require("./components/CreateApplicationForm");
var _createApplicationFormDefault = parcelHelpers.interopDefault(_createApplicationForm);
var _colors = require("../../../shared/constants/colors");
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const closeIcon = require("5309fe333b18ccda");
const CreateApplication = (props)=>{
    const handleClose = ()=>{
        props.history.push("/v");
    };
    const handleFinish = (applicationId)=>{
        props.history.push(`/v/apps/${applicationId}/modules/discover`);
        location.reload();
    };
    return (0, _react.jsx)((0, _fullScreenLayoutDefault.default), null, (0, _react.jsx)((0, _unstated.Subscribe), {
        to: [
            (0, _applicationContainerDefault.default),
            (0, _organizationContainerDefault.default)
        ]
    }, (appContainer, orgContainer)=>{
        return (0, _react.jsx)("div", {
            className: containerStyle
        }, (0, _react.jsx)((0, _horizontalContainerDefault.default), null, (0, _react.jsx)((0, _modalTitleDefault.default), {
            padded: true
        }, "Create a New App"), (0, _react.jsx)("div", {
            className: rightSide
        }, (0, _react.jsx)((0, _buttonDefault.default), {
            themes: [
                "end-tight",
                "icon"
            ],
            icon: closeIcon,
            onClick: handleClose.bind(undefined)
        }))), (0, _react.jsx)((0, _horizontalSeparatorDefault.default), null), (0, _react.jsx)((0, _createApplicationFormDefault.default), {
            organizationId: orgContainer.state.currentOrganization.id,
            appContainer: appContainer,
            onCancel: handleClose.bind(undefined),
            onCreate: handleFinish.bind(undefined)
        }), (0, _react.jsx)((0, _pageErrorDefault.default), {
            errors: appContainer.state.createErrors
        }));
    }));
};
const rightSide = /*#__PURE__*/ (0, _css.css)("margin:16px;margin-left:auto;padding:0px 16px;padding-right:0px;border-left:1px solid ", (0, _colors.silver_two), ";", "");
const containerStyle = /*#__PURE__*/ (0, _css.css)({
    name: "s1n8ed",
    styles: "height:100vh"
});
exports.default = CreateApplication;

},{"@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","unstated":"grh7p","../../../shared/scenes/fullScreenLayout":"5mVdG","../../../shared/state/containers/ApplicationContainer":"cuqi2","../../../shared/state/containers/OrganizationContainer":"dlbaM","../../../shared/components/structure/HorizontalContainer":"eJPfh","../../../shared/components/general/ModalTitle":"hIp2B","../../../shared/components/general/Button":"6ymxN","../../../shared/components/structure/HorizontalSeparator":"Pw3HQ","../../../shared/components/general/PageError":"ezFTm","./components/CreateApplicationForm":"4j0I5","../../../shared/constants/colors":"1p3OR","5309fe333b18ccda":"93VwA","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4j0I5":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _formik = require("formik");
var _yup = require("yup");
var _horizontalContainer = require("../../../../shared/components/structure/HorizontalContainer");
var _horizontalContainerDefault = parcelHelpers.interopDefault(_horizontalContainer);
var _formFieldsContainer = require("../../../../shared/components/structure/FormFieldsContainer");
var _formFieldsContainerDefault = parcelHelpers.interopDefault(_formFieldsContainer);
var _textField = require("../../../../shared/components/forms/TextField");
var _textFieldDefault = parcelHelpers.interopDefault(_textField);
var _pageContainer = require("../../../../shared/components/structure/PageContainer");
var _pageContainerDefault = parcelHelpers.interopDefault(_pageContainer);
var _imageUploadContainer = require("../../../../shared/components/structure/ImageUploadContainer");
var _imageUploadContainerDefault = parcelHelpers.interopDefault(_imageUploadContainer);
var _avatarFileUploadField = require("../../../../shared/components/forms/AvatarFileUploadField");
var _avatarFileUploadFieldDefault = parcelHelpers.interopDefault(_avatarFileUploadField);
var _button = require("../../../../shared/components/general/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _horizontalSeparator = require("../../../../shared/components/structure/HorizontalSeparator");
var _horizontalSeparatorDefault = parcelHelpers.interopDefault(_horizontalSeparator);
var _pageCard = require("../../../../shared/components/structure/PageCard");
var _pageCardDefault = parcelHelpers.interopDefault(_pageCard);
var _colors = require("../../../../shared/constants/colors");
var _customScrollbars = require("../../../../shared/components/structure/CustomScrollbars");
var _customScrollbarsDefault = parcelHelpers.interopDefault(_customScrollbars);
var _languageSingleSelector = require("../../../../shared/scenes/applicationSettings/components/languages/LanguageSingleSelector");
var _languageSingleSelectorDefault = parcelHelpers.interopDefault(_languageSingleSelector);
var _languageContainer = require("../../../hooks/LanguageContainer");
var _languageContainerDefault = parcelHelpers.interopDefault(_languageContainer);
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const InnerForm = (props)=>{
    const [imageUrl, setImageUrl] = (0, _react1.useState)("");
    const languagesContainer = (0, _languageContainerDefault.default).useContainer();
    (0, _react1.useEffect)(()=>{
        const getLanguages = async ()=>{
            await languagesContainer.loadLanguages();
        };
        if (languagesContainer.languages.length == 0) getLanguages();
        const enUs = languagesContainer.languages.find((l)=>l.shortCode == "en-US");
        props.setFieldValue("defaultLanguageId", enUs?.id);
    }, []);
    const handleImageSelected = (file)=>{
        readDataUrl(file);
        props.setFieldValue("imageFile", file);
    };
    const handleLanguageChange = (selectedLanguageIds)=>{
        props.setFieldValue("defaultLanguageId", selectedLanguageIds[0]);
    };
    const readDataUrl = (file)=>{
        const reader = new FileReader();
        reader.onloadend = ()=>{
            setImageUrl(reader.result.toString());
        };
        reader.readAsDataURL(file);
    };
    const isLoading = props.appContainer.state.isCreatingApplication || props.appContainer.state.isLoadingApps;
    return (0, _react.jsx)("form", {
        onSubmit: props.handleSubmit,
        className: formStyle
    }, (0, _react.jsx)((0, _horizontalContainerDefault.default), {
        className: whiteBackgroundStyle
    }, (0, _react.jsx)((0, _buttonDefault.default), {
        className: rightSide,
        themes: [
            "secondary-small"
        ],
        text: "Cancel",
        onClick: props.onCancel.bind(undefined),
        loading: props.appContainer.state.isCreatingApplication,
        disabled: props.appContainer.state.isCreatingApplication
    }), (0, _react.jsx)((0, _buttonDefault.default), {
        themes: [
            "primary-small"
        ],
        className: "ac-create-app-finish",
        text: "Create App",
        type: "submit",
        loading: props.appContainer.state.isCreatingApplication,
        disabled: props.appContainer.state.isCreatingApplication
    })), (0, _react.jsx)((0, _horizontalSeparatorDefault.default), null), (0, _react.jsx)((0, _pageContainerDefault.default), null, (0, _react.jsx)((0, _customScrollbarsDefault.default), {
        className: scrollBarsStyle
    }, (0, _react.jsx)("div", {
        className: formSpacingStyle
    }, (0, _react.jsx)("h3", null, "App Info"), (0, _react.jsx)("p", null, "Here you can configure the public-facing aspects of your application."), (0, _react.jsx)((0, _pageCardDefault.default), {
        className: formCardStyle
    }, (0, _react.jsx)("h4", null, "App Basics"), (0, _react.jsx)((0, _horizontalSeparatorDefault.default), null), (0, _react.jsx)((0, _formFieldsContainerDefault.default), {
        className: formFieldsContainerStyle
    }, (0, _react.jsx)((0, _languageSingleSelectorDefault.default), {
        label: "Language / Region",
        className: `${languageSelectStyle} ac-create-app-lang`,
        languages: languagesContainer.languages,
        selectedLanguageIds: [
            props.values.defaultLanguageId
        ],
        onChange: handleLanguageChange.bind(undefined)
    }), (0, _react.jsx)((0, _textFieldDefault.default), {
        name: "name",
        className: "ac-create-app-name",
        disabled: isLoading,
        required: true,
        value: props.values.name,
        label: "App Name",
        placeholder: "Give your application a name",
        onChange: props.handleChange,
        onBlur: props.handleBlur
    }), (0, _react.jsx)((0, _textFieldDefault.default), {
        name: "invocationName",
        className: "ac-create-app-invocation",
        disabled: isLoading,
        tooltip: "Invocation Name is the phrase people will use to call up your application on their device",
        required: true,
        value: props.values.invocationName,
        label: "Invocation Name",
        placeholder: "The name used to start your app",
        onChange: props.handleChange,
        onBlur: props.handleBlur
    }))), (0, _react.jsx)((0, _pageCardDefault.default), {
        className: `${formCardStyle} ${imageUploadStyle}`
    }, (0, _react.jsx)("h4", null, "App Avatar"), (0, _react.jsx)((0, _horizontalSeparatorDefault.default), null), (0, _react.jsx)((0, _imageUploadContainerDefault.default), {
        className: "previewContainer ac-create-app-image"
    }, (0, _react.jsx)((0, _avatarFileUploadFieldDefault.default), {
        accept: ".png,.jpg,.jpeg",
        onChange: handleImageSelected.bind(undefined)
    })), (0, _react.jsx)("h3", null, "This image will represent your app in Voicify"), (0, _react.jsx)("p", null, "Upload an image in .jpg or .png format")), (0, _react.jsx)("div", {
        className: createAppButtonContainerStyle
    }, (0, _react.jsx)((0, _buttonDefault.default), {
        text: "Create App",
        themes: [
            "primary"
        ],
        type: "submit",
        loading: props.appContainer.state.isCreatingApplication,
        disabled: props.appContainer.state.isCreatingApplication
    }))))));
};
const CreateApplicationForm = (0, _formik.withFormik)({
    mapPropsToValues: ()=>({
            name: "",
            invocationName: "",
            defaultLanguageId: "",
            imageFile: null
        }),
    validationSchema: _yup.object().shape({
        name: _yup.string().max(50).required("You must enter a name for your application"),
        invocationName: _yup.string().required("You must enter an invocation name for your application").matches(/^([^0-9\!\&\*\(\)\{\}\%\$\#\@\!\?\;\:\-\_\+\=\/\<\>\~]*)$/, "Invocation name cannot contain digits or special characters")
    }),
    handleSubmit: async (values, { props })=>{
        const appInfo = {
            name: values.name,
            invocationPhrase: values.invocationName,
            imageFile: values.imageFile,
            templates: [],
            defaultLanguageId: values.defaultLanguageId,
            withSamples: false
        };
        const result = await props.appContainer.createApplication(props.organizationId, appInfo);
        if (result.resultType == "Ok") props.onCreate(result.data.id);
    }
})(InnerForm);
const rightSide = /*#__PURE__*/ (0, _css.css)({
    name: "1o3nkn",
    styles: "margin-left:auto"
});
const createAppButtonContainerStyle = /*#__PURE__*/ (0, _css.css)({
    name: "299dh7",
    styles: "text-align:center;margin-top:24px"
});
const formSpacingStyle = /*#__PURE__*/ (0, _css.css)({
    name: "we7e32",
    styles: "width:50vw;padding-bottom:120px;margin-left:auto;margin-right:auto"
});
const imageUploadStyle = /*#__PURE__*/ (0, _css.css)("h3{margin-bottom:0px;margin-top:0px;margin-left:auto;margin-right:auto;font-size:14px;line-height:20px;text-align:center;}p{margin-bottom:0px;margin-top:0px;margin-left:auto;margin-right:auto;font-size:12px;line-height:16px;text-align:center;color:", (0, _colors.color_shades_darker), ";}.previewContainer{margin-left:auto;margin-right:auto;}", "");
const languageSelectStyle = /*#__PURE__*/ (0, _css.css)({
    name: "mqjryl",
    styles: "position:relative;margin-bottom:16px;.field .selection{height:60px;border-radius:5px;padding-left:24px;}.field-wrapper{label{position:absolute;left:14px;top:-27px;font-family:Muli;font-size:14px;font-weight:600;}}"
});
const formCardStyle = /*#__PURE__*/ (0, _css.css)({
    name: "1p0gll7",
    styles: "width:50vw;padding:32px;margin-top:24px"
});
const formStyle = /*#__PURE__*/ (0, _css.css)("background:", (0, _colors.color_variants_main_bg), ";height:calc(100% - 120px);", "");
const scrollBarsStyle = /*#__PURE__*/ (0, _css.css)({
    name: "brsscc",
    styles: "height:calc(100% - 152px)"
});
const formFieldsContainerStyle = /*#__PURE__*/ (0, _css.css)({
    name: "uk7huj",
    styles: "margin-top:56px"
});
const whiteBackgroundStyle = /*#__PURE__*/ (0, _css.css)({
    name: "pfjone",
    styles: "background:white"
});
exports.default = CreateApplicationForm;

},{"@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","formik":"3YnOK","yup":"j2SJU","../../../../shared/components/structure/HorizontalContainer":"eJPfh","../../../../shared/components/structure/FormFieldsContainer":"h3hzh","../../../../shared/components/forms/TextField":"7a7bh","../../../../shared/components/structure/PageContainer":"hc1r8","../../../../shared/components/structure/ImageUploadContainer":"jmeXJ","../../../../shared/components/forms/AvatarFileUploadField":"fAjrB","../../../../shared/components/general/Button":"6ymxN","../../../../shared/components/structure/HorizontalSeparator":"Pw3HQ","../../../../shared/components/structure/PageCard":"gU8yi","../../../../shared/constants/colors":"1p3OR","../../../../shared/components/structure/CustomScrollbars":"50vFq","../../../../shared/scenes/applicationSettings/components/languages/LanguageSingleSelector":"eDudC","../../../hooks/LanguageContainer":"lchkU","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"gU8yi":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _colors = require("../../constants/colors");
const cardStyle = /*#__PURE__*/ (0, _css.css)("background:white;box-shadow:0 2px 4px 0 ", (0, _colors.dark_grey_blue_10), ";border:solid 1px #cbd0d2;border-radius:8px;height:auto;", "");
const PageCard = (props)=>(0, _react.jsx)("div", {
        className: `${props.className ?? ""} ${cardStyle}`
    }, props.children);
exports.default = PageCard;

},{"@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","../../constants/colors":"1p3OR","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"e8QPP":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _base = require("@emotion/styled/base");
var _baseDefault = parcelHelpers.interopDefault(_base);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _unstated = require("unstated");
var _modalLayout = require("../../components/structure/ModalLayout");
var _modalLayoutDefault = parcelHelpers.interopDefault(_modalLayout);
var _fullScreenLayout = require("../fullScreenLayout");
var _fullScreenLayoutDefault = parcelHelpers.interopDefault(_fullScreenLayout);
var _scrollView = require("../../components/structure/ScrollView");
var _scrollViewDefault = parcelHelpers.interopDefault(_scrollView);
var _pageContainer = require("../../components/structure/PageContainer");
var _pageContainerDefault = parcelHelpers.interopDefault(_pageContainer);
var _horizontalContainer = require("../../components/structure/HorizontalContainer");
var _horizontalContainerDefault = parcelHelpers.interopDefault(_horizontalContainer);
var _horizontalSeparator = require("../../components/structure/HorizontalSeparator");
var _horizontalSeparatorDefault = parcelHelpers.interopDefault(_horizontalSeparator);
var _organizationContainer = require("../../state/containers/OrganizationContainer");
var _organizationContainerDefault = parcelHelpers.interopDefault(_organizationContainer);
var _pageError = require("../../components/general/PageError");
var _pageErrorDefault = parcelHelpers.interopDefault(_pageError);
var _memberContainer = require("../../state/containers/MemberContainer");
var _memberContainerDefault = parcelHelpers.interopDefault(_memberContainer);
var _organizationMemberInviteForm = require("./components/OrganizationMemberInviteForm");
var _organizationMemberInviteFormDefault = parcelHelpers.interopDefault(_organizationMemberInviteForm);
var _modalHeader = require("../../components/general/ModalHeader");
var _modalHeaderDefault = parcelHelpers.interopDefault(_modalHeader);
var _breakpoints = require("../../constants/breakpoints");
const closeIcon = require("2230f3936192ed21");
class OrganizationMemberInvite extends (0, _reactDefault.default).Component {
    componentWillMount() {
        this.setState({
            hasChanges: false
        });
    }
    handleClose() {
        if (this.state.hasChanges) {
            var confirmClose = confirm("You have unsaved changes. Are you sure you want to close?");
            if (!confirmClose) return;
        }
        this.props.history.goBack();
    }
    handleFinish() {
        this.props.history.goBack();
    }
    handleChange() {
        this.setState({
            hasChanges: true
        });
    }
    render() {
        return (0, _react.jsx)((0, _modalLayoutDefault.default), {
            isVisible: true,
            onClose: this.handleClose.bind(this)
        }, (0, _react.jsx)((0, _unstated.Subscribe), {
            to: [
                (0, _memberContainerDefault.default),
                (0, _organizationContainerDefault.default)
            ]
        }, (memberContainer, orgContainer)=>{
            return (0, _react.jsx)((0, _fullScreenLayoutDefault.default), null, (0, _react.jsx)((0, _scrollViewDefault.default), null, (0, _react.jsx)((0, _pageContainerDefault.default), {
                fill: true,
                withFooter: true
            }, (0, _react.jsx)((0, _horizontalContainerDefault.default), null, (0, _react.jsx)((0, _modalHeaderDefault.default), {
                title: "Add a New Member",
                onClose: this.handleClose.bind(this)
            })), (0, _react.jsx)((0, _horizontalSeparatorDefault.default), null), (0, _react.jsx)((0, _organizationMemberInviteFormDefault.default), {
                organizationContainer: orgContainer,
                memberContainer: memberContainer,
                onFinish: this.handleFinish.bind(this),
                onClose: this.handleClose.bind(this),
                onChange: this.handleChange.bind(this)
            }))), (0, _react.jsx)((0, _pageErrorDefault.default), {
                errors: memberContainer.state.errors
            }));
        }));
    }
}
const StyledModalHeader = /*#__PURE__*/ (0, _baseDefault.default)((0, _modalHeaderDefault.default), {
    target: "e1ool6d50"
})((0, _breakpoints.breakpoint_small), "{h2{}}");
exports.default = OrganizationMemberInvite;

},{"@emotion/styled/base":"lSuFu","@emotion/react":"djZKr","react":"6uln9","unstated":"grh7p","../../components/structure/ModalLayout":"b1cO3","../fullScreenLayout":"5mVdG","../../components/structure/ScrollView":"53ath","../../components/structure/PageContainer":"hc1r8","../../components/structure/HorizontalContainer":"eJPfh","../../components/structure/HorizontalSeparator":"Pw3HQ","../../state/containers/OrganizationContainer":"dlbaM","../../components/general/PageError":"ezFTm","../../state/containers/MemberContainer":"iYQOb","./components/OrganizationMemberInviteForm":"6Xjvq","../../components/general/ModalHeader":"aUACx","../../constants/breakpoints":"2F01A","2230f3936192ed21":"93VwA","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6Xjvq":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _base = require("@emotion/styled/base");
var _baseDefault = parcelHelpers.interopDefault(_base);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _formik = require("formik");
var _yup = require("yup");
var _pageContainer = require("../../../components/structure/PageContainer");
var _pageContainerDefault = parcelHelpers.interopDefault(_pageContainer);
var _formFieldsContainer = require("../../../components/structure/FormFieldsContainer");
var _formFieldsContainerDefault = parcelHelpers.interopDefault(_formFieldsContainer);
var _textField = require("../../../components/forms/TextField");
var _textFieldDefault = parcelHelpers.interopDefault(_textField);
var _footerBar = require("../../../components/structure/FooterBar");
var _footerBarDefault = parcelHelpers.interopDefault(_footerBar);
var _button = require("../../../components/general/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _selectField = require("../../../components/forms/SelectField");
var _selectFieldDefault = parcelHelpers.interopDefault(_selectField);
var _loader = require("../../../components/general/Loader");
var _loaderDefault = parcelHelpers.interopDefault(_loader);
var _horizontalSeparator = require("../../../components/structure/HorizontalSeparator");
var _horizontalSeparatorDefault = parcelHelpers.interopDefault(_horizontalSeparator);
var _checkboxField = require("../../../components/forms/CheckboxField");
var _checkboxFieldDefault = parcelHelpers.interopDefault(_checkboxField);
var _breakpoints = require("../../../constants/breakpoints");
class InnerForm extends (0, _reactDefault.default).Component {
    componentWillMount() {
        if (this.props.organizationContainer.state.systemRoles.length == 0) this.props.organizationContainer.getSystemRoles();
    }
    handleAdminToggle(e) {
        this.props.setFieldValue("isAdmin", e.target.checked);
    }
    handleAddToAppsToggle(e) {
        this.props.setFieldValue("isAddedToApplications", e.target.checked);
    }
    handleRoleChange(value) {
        const finalValue = value === null ? null : value.value;
        this.props.setFieldValue("applicationRoleId", finalValue);
        this.props.onChange();
    }
    handleRoleBlur(blur) {
        this.props.setFieldTouched("applicationRoleId", blur);
    }
    render() {
        const props = {
            ...this.props
        };
        const isLoading = props.memberContainer.state.isLoading;
        return (0, _react.jsx)((0, _pageContainerDefault.default), {
            fill: true
        }, (0, _react.jsx)("form", {
            onSubmit: props.handleSubmit
        }, (0, _react.jsx)((0, _pageContainerDefault.default), null, (0, _react.jsx)((0, _formFieldsContainerDefault.default), null, (0, _react.jsx)((0, _textFieldDefault.default), {
            name: "email",
            type: "email",
            className: "ac-invite-email",
            required: true,
            value: props.values.email,
            label: "Email Address",
            placeholder: "Where do you want to send the invitation?",
            onChange: props.handleChange,
            onBlur: props.handleBlur,
            disabled: isLoading
        }), (0, _react.jsx)((0, _checkboxFieldDefault.default), {
            name: "isAdmin",
            className: "ac-invite-admin",
            checked: props.values.isAdmin,
            label: "Set as Administrator",
            onChange: this.handleAdminToggle.bind(this),
            disabled: isLoading
        })), (0, _react.jsx)((0, _horizontalSeparatorDefault.default), null), (0, _react.jsx)((0, _formFieldsContainerDefault.default), null, (0, _react.jsx)((0, _checkboxFieldDefault.default), {
            name: "isAddedToApplications",
            className: "ac-invite-apps",
            checked: props.values.isAddedToApplications,
            label: "Add as participant to all Apps",
            onChange: this.handleAddToAppsToggle.bind(this),
            disabled: isLoading
        }), this.props.organizationContainer.state.isLoadingRoles ? (0, _react.jsx)((0, _loaderDefault.default), null) : (0, _react.jsx)((0, _selectFieldDefault.default), {
            value: props.values.applicationRoleId,
            name: "applicationRoleId",
            onChange: this.handleRoleChange.bind(this),
            onBlur: this.handleRoleBlur.bind(this),
            hidden: !props.values.isAddedToApplications,
            options: this.props.organizationContainer.state.systemRoles.map((r)=>({
                    label: r.name,
                    value: r.id
                })),
            label: "Role:",
            disabled: isLoading
        }))), (0, _react.jsx)((0, _footerBarDefault.default), null, (0, _react.jsx)(StyledButton, {
            loading: isLoading,
            disabled: isLoading,
            className: "ac-invite-send",
            themes: [
                "primary",
                "wide"
            ],
            text: "Send Invite",
            type: "submit"
        }), (0, _react.jsx)(StyledButton, {
            disabled: isLoading,
            themes: [
                "white",
                "end"
            ],
            text: "Cancel",
            type: "button",
            onClick: this.props.onClose
        }))));
    }
}
const OrganizationMemberInviteForm = (0, _formik.withFormik)({
    mapPropsToValues: (props)=>({
            email: "",
            isAdmin: false,
            isAddedToApplications: false,
            applicationRoleId: props.organizationContainer.state.systemRoles.length == 0 ? "" : props.organizationContainer.state.systemRoles[0].id
        }),
    validationSchema: _yup.object().shape({
        email: _yup.string().email("You must enter a valid email").required("You must enter an email to send the invitation to")
    }),
    handleSubmit: (values, { props })=>{
        props.memberContainer.inviteMember(props.organizationContainer.state.currentOrganization.id, {
            email: values.email,
            isAdmin: values.isAdmin,
            isAddedToApplications: values.isAddedToApplications,
            applicationRoleId: values.applicationRoleId
        }).then((result)=>{
            if (result.resultType == "Ok") props.onFinish();
        });
    }
})(InnerForm);
const StyledButton = /*#__PURE__*/ (0, _baseDefault.default)((0, _buttonDefault.default), {
    target: "ept7i6u0"
})((0, _breakpoints.breakpoint_small), "{width:100px;span{font-size:12px;}}");
exports.default = OrganizationMemberInviteForm;

},{"@emotion/styled/base":"lSuFu","@emotion/react":"djZKr","react":"6uln9","formik":"3YnOK","yup":"j2SJU","../../../components/structure/PageContainer":"hc1r8","../../../components/structure/FormFieldsContainer":"h3hzh","../../../components/forms/TextField":"7a7bh","../../../components/structure/FooterBar":"bibRL","../../../components/general/Button":"6ymxN","../../../components/forms/SelectField":"405B3","../../../components/general/Loader":"bnV5T","../../../components/structure/HorizontalSeparator":"Pw3HQ","../../../components/forms/CheckboxField":"3S5Oy","../../../constants/breakpoints":"2F01A","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"f6vgJ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _unstated = require("unstated");
var _modalLayout = require("../../components/structure/ModalLayout");
var _modalLayoutDefault = parcelHelpers.interopDefault(_modalLayout);
var _fullScreenLayout = require("../fullScreenLayout");
var _fullScreenLayoutDefault = parcelHelpers.interopDefault(_fullScreenLayout);
var _scrollView = require("../../components/structure/ScrollView");
var _scrollViewDefault = parcelHelpers.interopDefault(_scrollView);
var _pageContainer = require("../../components/structure/PageContainer");
var _pageContainerDefault = parcelHelpers.interopDefault(_pageContainer);
var _horizontalContainer = require("../../components/structure/HorizontalContainer");
var _horizontalContainerDefault = parcelHelpers.interopDefault(_horizontalContainer);
var _horizontalSeparator = require("../../components/structure/HorizontalSeparator");
var _horizontalSeparatorDefault = parcelHelpers.interopDefault(_horizontalSeparator);
var _organizationContainer = require("../../state/containers/OrganizationContainer");
var _organizationContainerDefault = parcelHelpers.interopDefault(_organizationContainer);
var _pageError = require("../../components/general/PageError");
var _pageErrorDefault = parcelHelpers.interopDefault(_pageError);
var _memberContainer = require("../../state/containers/MemberContainer");
var _memberContainerDefault = parcelHelpers.interopDefault(_memberContainer);
var _addApplicationMemberForm = require("./components/AddApplicationMemberForm");
var _addApplicationMemberFormDefault = parcelHelpers.interopDefault(_addApplicationMemberForm);
var _applicationMembersContainer = require("../../state/containers/ApplicationMembersContainer");
var _applicationMembersContainerDefault = parcelHelpers.interopDefault(_applicationMembersContainer);
var _modalHeader = require("../../components/general/ModalHeader");
var _modalHeaderDefault = parcelHelpers.interopDefault(_modalHeader);
var _currentApplicationContainer = require("../../hooks/CurrentApplicationContainer");
var _currentApplicationContainerDefault = parcelHelpers.interopDefault(_currentApplicationContainer);
const closeIcon = require("9d3da7d965cdb03b");
const AddApplicationMember = (props)=>{
    const [hasChanges, setHasChanges] = (0, _react1.useState)(false);
    // Set current application ID in the container
    const currentAppContainer = (0, _currentApplicationContainerDefault.default).useContainer();
    (0, _react1.useEffect)(()=>{
        if (props.match.params.applicationId) currentAppContainer.setApplicationId(props.match.params.applicationId);
    }, [
        props.match.params.applicationId,
        currentAppContainer
    ]);
    const handleClose = ()=>{
        if (hasChanges) {
            var confirmClose = confirm("You have unsaved changes. Are you sure you want to close?");
            if (!confirmClose) return;
        }
        props.history.goBack();
    };
    const handleFinish = ()=>{
        props.history.goBack();
    };
    const handleChange = ()=>{
        setHasChanges(true);
    };
    return (0, _react.jsx)((0, _modalLayoutDefault.default), {
        isVisible: true,
        onClose: handleClose,
        className: modalStyle
    }, (0, _react.jsx)((0, _unstated.Subscribe), {
        to: [
            (0, _memberContainerDefault.default),
            (0, _organizationContainerDefault.default),
            (0, _applicationMembersContainerDefault.default)
        ]
    }, (memberContainer, orgContainer, appMemberContainer)=>{
        return (0, _react.jsx)((0, _fullScreenLayoutDefault.default), null, (0, _react.jsx)((0, _scrollViewDefault.default), null, (0, _react.jsx)((0, _pageContainerDefault.default), {
            fill: true,
            withFooter: true
        }, (0, _react.jsx)((0, _horizontalContainerDefault.default), null, (0, _react.jsx)((0, _modalHeaderDefault.default), {
            title: "Add a New Member",
            onClose: handleClose
        })), (0, _react.jsx)((0, _horizontalSeparatorDefault.default), null), (0, _react.jsx)((0, _addApplicationMemberFormDefault.default), {
            applicationId: props.match.params.applicationId,
            appMemberContainer: appMemberContainer,
            organizationContainer: orgContainer,
            memberContainer: memberContainer,
            onFinish: handleFinish,
            onClose: handleClose,
            onChange: handleChange
        }))), (0, _react.jsx)((0, _pageErrorDefault.default), {
            errors: memberContainer.state.errors
        }));
    }));
};
const modalStyle = /*#__PURE__*/ (0, _css.css)("", "");
exports.default = AddApplicationMember;

},{"@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","unstated":"grh7p","../../components/structure/ModalLayout":"b1cO3","../fullScreenLayout":"5mVdG","../../components/structure/ScrollView":"53ath","../../components/structure/PageContainer":"hc1r8","../../components/structure/HorizontalContainer":"eJPfh","../../components/structure/HorizontalSeparator":"Pw3HQ","../../state/containers/OrganizationContainer":"dlbaM","../../components/general/PageError":"ezFTm","../../state/containers/MemberContainer":"iYQOb","./components/AddApplicationMemberForm":"34l5Q","../../state/containers/ApplicationMembersContainer":"hsHim","../../components/general/ModalHeader":"aUACx","../../hooks/CurrentApplicationContainer":"4hT7h","9d3da7d965cdb03b":"93VwA","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"34l5Q":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _formik = require("formik");
var _yup = require("yup");
var _pageContainer = require("../../../components/structure/PageContainer");
var _pageContainerDefault = parcelHelpers.interopDefault(_pageContainer);
var _formFieldsContainer = require("../../../components/structure/FormFieldsContainer");
var _formFieldsContainerDefault = parcelHelpers.interopDefault(_formFieldsContainer);
var _footerBar = require("../../../components/structure/FooterBar");
var _footerBarDefault = parcelHelpers.interopDefault(_footerBar);
var _button = require("../../../components/general/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _memberSelector = require("./MemberSelector");
var _memberSelectorDefault = parcelHelpers.interopDefault(_memberSelector);
var _roleToggle = require("../../../components/general/RoleToggle");
var _roleToggleDefault = parcelHelpers.interopDefault(_roleToggle);
var _pageError = require("../../../components/general/PageError");
var _pageErrorDefault = parcelHelpers.interopDefault(_pageError);
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
class InnerForm extends (0, _reactDefault.default).Component {
    componentWillMount() {
        if (this.props.organizationContainer.state.systemRoles.length == 0) this.props.organizationContainer.getSystemRoles();
        this.props.appMemberContainer.getMembersForApp(this.props.applicationId);
        this.props.memberContainer.getMembers(this.props.organizationContainer.state.currentOrganization.id).then((result)=>{
            if (result.resultType == "Ok") this.props.setFieldValue("members", result.data.filter((m)=>!this.props.appMemberContainer.state.members.some((am)=>am.organizationMember.id == m.id)).map((m)=>({
                    isSelected: false,
                    member: m
                })));
        });
    }
    handleRoleChange(roleName) {
        const role = this.props.organizationContainer.state.systemRoles.find((r)=>r.name == roleName);
        this.props.setFieldValue("applicationRoleId", role.id);
        this.props.onChange();
    }
    handleRoleBlur(blur) {
        this.props.setFieldTouched("applicationRoleId", blur);
    }
    handleMemberChange(members) {
        this.props.setFieldValue("members", members);
    }
    render() {
        const props = {
            ...this.props
        };
        const isLoading = props.appMemberContainer.state.isLoading;
        return (0, _react.jsx)((0, _pageContainerDefault.default), {
            fill: true
        }, (0, _react.jsx)("form", {
            className: formStyle,
            onSubmit: props.handleSubmit
        }, (0, _react.jsx)((0, _pageContainerDefault.default), null, (0, _react.jsx)("p", null, "Select existing members from your organization"), (0, _react.jsx)((0, _formFieldsContainerDefault.default), null, (0, _react.jsx)((0, _memberSelectorDefault.default), {
            members: props.values.members,
            onChange: this.handleMemberChange.bind(this)
        }))), (0, _react.jsx)((0, _footerBarDefault.default), null, (0, _react.jsx)((0, _roleToggleDefault.default), {
            positionTop: true,
            includeError: true,
            name: "applicationRoleId",
            label: "Role:",
            onChange: this.handleRoleChange.bind(this),
            currentRole: "",
            roles: props.organizationContainer.state.systemRoles.map((r)=>r.name)
        }), (0, _react.jsx)("div", {
            className: buttonContainer
        }, (0, _react.jsx)((0, _buttonDefault.default), {
            loading: isLoading,
            disabled: isLoading,
            themes: [
                "primary"
            ],
            text: "Send Invite",
            type: "submit"
        }), (0, _react.jsx)((0, _buttonDefault.default), {
            disabled: isLoading,
            themes: [
                "white"
            ],
            text: "Cancel",
            type: "button",
            onClick: this.props.onClose
        })))), (0, _react.jsx)((0, _pageErrorDefault.default), {
            errors: this.props.appMemberContainer.state.errors
        }));
    }
}
const AddApplicationMemberForm = (0, _formik.withFormik)({
    mapPropsToValues: ()=>({
            applicationRoleId: "",
            members: []
        }),
    validationSchema: _yup.object().shape({
        applicationRoleId: _yup.string().required("You must select a role for these members to have")
    }),
    handleSubmit: (values, { props })=>{
        props.appMemberContainer.addMembers(props.applicationId, {
            roleId: values.applicationRoleId,
            organizationMemberIds: values.members.filter((m)=>m.isSelected).map((m)=>m.member.id)
        }).then((result)=>{
            if (result.resultType == "Ok") {
                props.onFinish();
                props.appMemberContainer.getMembersForApp(props.applicationId);
            }
        });
    }
})(InnerForm);
const buttonContainer = /*#__PURE__*/ (0, _css.css)({
    name: "1g9jfmp",
    styles: "margin-right:50px;margin-left:auto;display:flex;>*+*{margin-left:16px;}"
});
const formStyle = /*#__PURE__*/ (0, _css.css)({
    name: "knjsbg",
    styles: "padding:32px"
});
exports.default = AddApplicationMemberForm;

},{"@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","formik":"3YnOK","yup":"j2SJU","../../../components/structure/PageContainer":"hc1r8","../../../components/structure/FormFieldsContainer":"h3hzh","../../../components/structure/FooterBar":"bibRL","../../../components/general/Button":"6ymxN","./MemberSelector":"csRKl","../../../components/general/RoleToggle":"aas3J","../../../components/general/PageError":"ezFTm","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"csRKl":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _memberCard = require("./MemberCard");
var _memberCardDefault = parcelHelpers.interopDefault(_memberCard);
class MemberSelector extends (0, _reactDefault.default).Component {
    componentWillMount() {
        this.setState({
            members: this.props.members
        });
    }
    componentDidUpdate(previousProps) {
        if (JSON.stringify(previousProps.members) != JSON.stringify(this.props.members)) this.setState({
            members: this.props.members
        });
    }
    handleSelectionChange(member, index) {
        const members = this.state.members;
        members[index] = {
            member: member.member,
            isSelected: !member.isSelected
        };
        this.setState({
            ...this.state,
            members: members
        });
        this.props.onChange(members);
    }
    render() {
        return (0, _react.jsx)("div", null, this.state.members.map((m, i)=>(0, _react.jsx)((0, _memberCardDefault.default), {
                key: m.member.id,
                id: m.member.id,
                firstName: m.member.firstName,
                lastName: m.member.lastName,
                email: m.member.email,
                selected: m.isSelected,
                imageUrl: m.member.imageUrl,
                onClick: this.handleSelectionChange.bind(this, m, i)
            })));
    }
}
exports.default = MemberSelector;

},{"@emotion/react":"djZKr","react":"6uln9","./MemberCard":"ki0nJ","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"ki0nJ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _colors = require("../../../constants/colors");
var _userAvatar = require("../../../components/general/UserAvatar");
var _userAvatarDefault = parcelHelpers.interopDefault(_userAvatar);
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const checkImage = require("e5a0a3610cd9546d");
const cardStyle = /*#__PURE__*/ (0, _css.css)("height:56px;border-radius:20px;box-shadow:0 2px 4px 0 ", (0, _colors.dark_grey_blue_10), ";background-color:#ffffff;border:solid 1px #c7cfd2;display:flex;flex-direction:row;padding:0 16px;margin-top:5px;align-items:center;cursor:pointer;max-width:400px;flex-wrap:wrap;p{display:block;font-family:Muli;font-size:14px;font-weight:normal;font-style:normal;font-stretch:normal;line-height:normal;letter-spacing:normal;color:", (0, _colors.dark_grey_blue), ";}", "");
const checkContainerStyle = /*#__PURE__*/ (0, _css.css)({
    name: "ks4z5i",
    styles: "margin-right:24px;width:20px;height:20px;border-radius:4px;background-color:#ffffff;border:solid 1px #cccccc;display:flex;align-items:center;justify-content:center;img{width:16px;height:12px;}"
});
const avatarStyle = /*#__PURE__*/ (0, _css.css)({
    name: "o7nnmj",
    styles: "margin-right:16px"
});
const MemberCard = (props)=>(0, _react.jsx)("div", {
        className: cardStyle,
        onClick: props.onClick
    }, (0, _react.jsx)("div", {
        className: checkContainerStyle
    }, props.selected ? (0, _react.jsx)("img", {
        src: checkImage
    }) : null), (0, _react.jsx)((0, _userAvatarDefault.default), {
        className: avatarStyle,
        src: props.imageUrl,
        firstName: props.firstName,
        lastName: props.lastName,
        size: 28
    }), (0, _react.jsx)("div", null, (0, _react.jsx)("p", null, `${props.firstName} ${props.lastName}`), (0, _react.jsx)("p", null, props.email)));
exports.default = MemberCard;

},{"@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","../../../constants/colors":"1p3OR","../../../components/general/UserAvatar":"avuDP","e5a0a3610cd9546d":"iqgKO","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"iqgKO":[function(require,module,exports) {
module.exports = require("d03a9cb6414bcb85").getBundleURL("kVLro") + require("b838b87cedef2dcb").resolve("k96Nc");

},{"d03a9cb6414bcb85":"c7Tr5","b838b87cedef2dcb":"fyJL2"}],"2uweN":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _unstated = require("unstated");
var _fallbackMessageContainer = require("../../state/containers/FallbackMessageContainer");
var _fallbackMessageContainerDefault = parcelHelpers.interopDefault(_fallbackMessageContainer);
var _editFallbackMessageForm = require("./components/EditFallbackMessageForm");
var _editFallbackMessageFormDefault = parcelHelpers.interopDefault(_editFallbackMessageForm);
var _applicationContainer = require("../../state/containers/ApplicationContainer");
var _applicationContainerDefault = parcelHelpers.interopDefault(_applicationContainer);
var _titleStateContainer = require("../../state/containers/TitleStateContainer");
var _titleStateContainerDefault = parcelHelpers.interopDefault(_titleStateContainer);
var _repromptContainer = require("../../state/containers/RepromptContainer");
var _repromptContainerDefault = parcelHelpers.interopDefault(_repromptContainer);
var _followUpContainer = require("../../state/containers/FollowUpContainer");
var _followUpContainerDefault = parcelHelpers.interopDefault(_followUpContainer);
var _mediaResponseContainer = require("../../state/containers/MediaResponseContainer");
var _mediaResponseContainerDefault = parcelHelpers.interopDefault(_mediaResponseContainer);
var _genericEditContentItemPage = require("../formScenes/GenericEditContentItemPage");
var _genericEditContentItemPageDefault = parcelHelpers.interopDefault(_genericEditContentItemPage);
var _featureContainer = require("../../state/containers/FeatureContainer");
var _featureContainerDefault = parcelHelpers.interopDefault(_featureContainer);
var _featureTypeIds = require("../../constants/featureTypeIds");
var _queryString = require("query-string");
var _queryStringDefault = parcelHelpers.interopDefault(_queryString);
var _applicationBackupVersionsContainer = require("../../state/containers/ApplicationBackupVersionsContainer");
var _applicationBackupVersionsContainerDefault = parcelHelpers.interopDefault(_applicationBackupVersionsContainer);
var _applicationEnvironmentsContainer = require("../../state/containers/ApplicationEnvironmentsContainer");
var _applicationEnvironmentsContainerDefault = parcelHelpers.interopDefault(_applicationEnvironmentsContainer);
class EditFallbackMessage extends (0, _reactDefault.default).Component {
    render() {
        return (0, _react.jsx)((0, _unstated.Subscribe), {
            key: this.props.match.params.fallbackMessageId + this.props.match.params.applicationFeatureId,
            to: [
                (0, _fallbackMessageContainerDefault.default),
                (0, _applicationContainerDefault.default),
                (0, _titleStateContainerDefault.default),
                (0, _repromptContainerDefault.default),
                (0, _followUpContainerDefault.default),
                (0, _mediaResponseContainerDefault.default),
                (0, _featureContainerDefault.default),
                (0, _applicationEnvironmentsContainerDefault.default),
                (0, _applicationBackupVersionsContainerDefault.default)
            ]
        }, (fallbackContainer, appContainer, titleContainer, repromptContainer, followUpContainer, responseContainer, featureContainer, environmentsContainer, backupsContainer)=>{
            return (0, _react.jsx)((0, _genericEditContentItemPageDefault.default), {
                stateContainer: fallbackContainer,
                environmentsContainer: environmentsContainer,
                backupsContainer: backupsContainer,
                titleContainer: titleContainer,
                applicationContainer: appContainer,
                defaultTitle: "Edit Fallback Message",
                contentItemId: this.props.match.params.fallbackMessageId,
                history: this.props.history,
                location: this.props.location,
                match: this.props.match,
                staticContext: this.props.staticContext,
                featureContainer: featureContainer,
                featureTypeId: (0, _featureTypeIds.FallbackFeatureTypeId),
                formRender: (contentItem, application, isTemplateOwned, assistantApplication, onShowPublishModal, onSubmit, toggleSync, onAccessTypeChange)=>(0, _react.jsx)((0, _editFallbackMessageFormDefault.default), {
                        location: this.props.location,
                        application: application,
                        applicationFeatureId: this.props.match.params.applicationFeatureId,
                        appContainer: appContainer,
                        followUpContainer: followUpContainer,
                        repromptContainer: repromptContainer,
                        fallbackMessage: contentItem,
                        stateContainer: fallbackContainer,
                        responseStateContainer: responseContainer,
                        featureContainer: featureContainer,
                        assistantApplication: assistantApplication,
                        onShowPublishModal: onShowPublishModal,
                        onAccessTypeChange: onAccessTypeChange,
                        onSubmit: onSubmit,
                        onToggleSync: toggleSync,
                        previousContentId: (0, _queryStringDefault.default)?.parse(this.props.location.search)?.previousContentId,
                        history: this.props.history,
                        isSaving: fallbackContainer.state.isSaving,
                        isTemplateOwned: isTemplateOwned
                    })
            });
        });
    }
}
exports.default = EditFallbackMessage;

},{"@emotion/react":"djZKr","react":"6uln9","unstated":"grh7p","../../state/containers/FallbackMessageContainer":"kKZMo","./components/EditFallbackMessageForm":"dgSsL","../../state/containers/ApplicationContainer":"cuqi2","../../state/containers/TitleStateContainer":"2osOD","../../state/containers/RepromptContainer":"5vKMV","../../state/containers/FollowUpContainer":"rm9OA","../../state/containers/MediaResponseContainer":"1ccrV","../formScenes/GenericEditContentItemPage":"6RzEJ","../../state/containers/FeatureContainer":"4ApGg","../../constants/featureTypeIds":"hPLMP","query-string":"klvAV","../../state/containers/ApplicationBackupVersionsContainer":"6rA1P","../../state/containers/ApplicationEnvironmentsContainer":"jCULY","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"dgSsL":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _formik = require("formik");
var _yup = require("yup");
var _fallbackMessageForm = require("../../formScenes/FallbackMessageForm");
var _fallbackMessageFormDefault = parcelHelpers.interopDefault(_fallbackMessageForm);
const EditFallbackMessageForm = (0, _formik.withFormik)({
    mapPropsToValues: (props)=>({
            title: props.fallbackMessage.title,
            categoryId: props.fallbackMessage.category ? props.fallbackMessage.category.id : "",
            responses: props.fallbackMessage.responses.length > 0 ? props.fallbackMessage.responses : [
                {
                    content: ""
                }
            ],
            requiresParent: props.fallbackMessage.requiresParent,
            languages: props.fallbackMessage.languages,
            isLive: props.fallbackMessage.isLive,
            webhookChainingType: props.fallbackMessage.webhookChainingType,
            sensitiveConversationChange: props.fallbackMessage.sensitiveConversationChange ?? "None",
            disabledForFeatureFlagIds: props.fallbackMessage?.disabledForFeatureFlagIds
        }),
    validationSchema: _yup.object().shape({
        title: _yup.string().required("You must enter a title"),
        categoryId: _yup.string().required("You must select a category"),
        responses: _yup.array().of(_yup.object().shape({
            content: _yup.string().required("You must enter an response variation")
        })).required("You must enter at least 1 response variation").min(1, "You must enter at least 1 response variation")
    }),
    validateOnMount: true,
    handleSubmit: (values, { props, setStatus })=>{
        setStatus({
            submitting: true
        });
        return props.onSubmit(props.stateContainer.mapFormDataToModel(props.fallbackMessage, values));
    }
})((0, _fallbackMessageFormDefault.default));
exports.default = EditFallbackMessageForm;

},{"formik":"3YnOK","yup":"j2SJU","../../formScenes/FallbackMessageForm":"4LY6G","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4LY6G":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _defineProperty = require("@babel/runtime/helpers/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _base = require("@emotion/styled/base");
var _baseDefault = parcelHelpers.interopDefault(_base);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _pageContainer = require("../../components/structure/PageContainer");
var _pageContainerDefault = parcelHelpers.interopDefault(_pageContainer);
var _titleTextField = require("../../components/forms/TitleTextField");
var _titleTextFieldDefault = parcelHelpers.interopDefault(_titleTextField);
var _followUpForm = require("../followUpForm");
var _followUpFormDefault = parcelHelpers.interopDefault(_followUpForm);
var _loader = require("../../components/general/Loader");
var _loaderDefault = parcelHelpers.interopDefault(_loader);
var _featureTypeIds = require("../../constants/featureTypeIds");
var _contentLanguageMultiSelector = require("../../components/forms/ContentLanguageMultiSelector");
var _contentLanguageMultiSelectorDefault = parcelHelpers.interopDefault(_contentLanguageMultiSelector);
var _contentPage = require("../contentPage");
var _contentPageDefault = parcelHelpers.interopDefault(_contentPage);
var _relatedContentMenu = require("../relatedContentMenu");
var _relatedContentMenuDefault = parcelHelpers.interopDefault(_relatedContentMenu);
var _scrollablePanelBody = require("../../components/structure/ScrollablePanelBody");
var _scrollablePanelBodyDefault = parcelHelpers.interopDefault(_scrollablePanelBody);
var _panelTitle = require("../contentPage/components/PanelTitle");
var _panelTitleDefault = parcelHelpers.interopDefault(_panelTitle);
var _contentCollapsingSection = require("../../components/structure/ContentCollapsingSection");
var _contentCollapsingSectionDefault = parcelHelpers.interopDefault(_contentCollapsingSection);
var _contentSectionTitle = require("../contentPage/components/ContentSectionTitle");
var _contentSectionTitleDefault = parcelHelpers.interopDefault(_contentSectionTitle);
var _extensions = require("../../models/extensions");
var _pageError = require("../../components/general/PageError");
var _pageErrorDefault = parcelHelpers.interopDefault(_pageError);
var _conversationItemActionButtonToolbar = require("./components/ConversationItemActionButtonToolbar");
var _conversationItemActionButtonToolbarDefault = parcelHelpers.interopDefault(_conversationItemActionButtonToolbar);
var _templateLockedBanner = require("../../components/general/TemplateLockedBanner");
var _templateLockedBannerDefault = parcelHelpers.interopDefault(_templateLockedBanner);
var _conversationItemFieldSet = require("../../components/forms/ConversationItemFieldSet");
var _conversationItemFieldSetDefault = parcelHelpers.interopDefault(_conversationItemFieldSet);
var _contentInfoOptions = require("../../components/structure/ContentInfoOptions");
var _contentInfoOptionsDefault = parcelHelpers.interopDefault(_contentInfoOptions);
var _responsesManager = require("../responsesManager");
var _responsesManagerDefault = parcelHelpers.interopDefault(_responsesManager);
var _secondaryLoader = require("../../components/general/SecondaryLoader");
var _secondaryLoaderDefault = parcelHelpers.interopDefault(_secondaryLoader);
var _selectField = require("../../components/forms/SelectField");
var _selectFieldDefault = parcelHelpers.interopDefault(_selectField);
var _dirtyFormPrompt = require("./components/DirtyFormPrompt");
var _sensitiveDataOptions = require("../contentPage/components/SensitiveDataOptions");
var _sensitiveDataOptionsDefault = parcelHelpers.interopDefault(_sensitiveDataOptions);
var _disableForFeatureFlagOptions = require("../contentPage/components/DisableForFeatureFlagOptions");
var _disableForFeatureFlagOptionsDefault = parcelHelpers.interopDefault(_disableForFeatureFlagOptions);
var _contentItemTestCaseViewer = require("./ContentItemTestCaseViewer");
var _contentItemTestCaseViewerDefault = parcelHelpers.interopDefault(_contentItemTestCaseViewer);
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const contentInfoIcon = require("f26dd962379d7504");
const continueIcon = require("e4b4099d5f085e23");
class FallbackMessageForm extends (0, _followUpFormDefault.default) {
    constructor(...args){
        super(...args);
        (0, _definePropertyDefault.default)(this, "handleResponseIdFromSim", (id)=>{
            this.setState({
                simulatedResponseId: id
            });
        });
    }
    componentDidUpdate(prevProps, prevState) {
        super.componentDidUpdate(prevProps, prevState);
    }
    componentDidMount() {
        this.props.stateContainer.getFallbackCategories();
    }
    handleAsyncSubmit(onSuccess) {
        if (this.manualValidate()) return this.props.onSubmit(this.props.stateContainer.mapFormDataToModel(this.props.fallbackMessage, this.props.values), onSuccess);
    }
    handleDiscardChanges() {
        this.handleFinish();
    }
    handleCopy() {
        this.handleAsyncSubmit(()=>{
            this.props.stateContainer.copy(this.props.fallbackMessage.id).then((r2)=>{
                if (r2.resultType == "Ok") this.props.history.push(`/v/${r2.data.applicationFeatureId}/fallbackmessages/${r2.data.id}`);
            });
        });
    }
    handleDelete() {
        const confirmed = confirm("Are you sure you want to delete this?");
        if (confirmed) this.props.stateContainer.delete(this.props.fallbackMessage.id).then(()=>{
            this.handleFinish();
        });
    }
    handleCategoryChange(value) {
        const finalValue = value === null ? null : value.value;
        this.props.setFieldValue("categoryId", finalValue);
    }
    handleCategoryBlur(blur) {
        this.props.setFieldTouched("categoryId", blur);
    }
    handleSsmlUpdate(ssml) {
        this.props.setFieldValue("content", ssml);
    }
    getMenuTreeRoots() {
        var roots = [
            this.getContentInfoTreeItem(),
            ...this.getResponsesTreeItems(this.props.values.responses)
        ];
        return roots;
    }
    handleContentItemOptionSelected(option, event) {
        event.stopPropagation();
        if (option == "Manage Webhooks") this.showWebhookInstanceManager();
        else if (option == "Duplicate") this.handleCopy();
        else if (option == "Delete") this.handleDelete();
    }
    getContentItem() {
        return this.props.fallbackMessage;
    }
    handleResponsesChange(responseGroups) {
        this.props.setFieldValue("responses", this.getResponsesFromGroups(responseGroups));
    }
    render() {
        const props = {
            ...this.props
        };
        const isLoading = props.stateContainer.state.isSaving;
        const isDisabled = isLoading || this.props.isTemplateOwned;
        const categories = props.stateContainer.state.categories;
        const responseGroups = this.getResponseGroups(this.props.values.responses);
        const { simulatedResponseId } = this.state;
        if (this.props.responseStateContainer.state.isLoading || !this.props.application) return (0, _react.jsx)((0, _loaderDefault.default), null);
        return (0, _react.jsx)((0, _reactDefault.default).Fragment, null, (0, _react.jsx)("form", {
            onSubmit: props.handleSubmit
        }, (0, _react.jsx)((0, _dirtyFormPrompt.DirtyFormPrompt), {
            allowPrompt: props.status?.submitting != true
        }), (0, _react.jsx)((0, _contentPageDefault.default), {
            relatedContentRender: ()=>(0, _react.jsx)((0, _relatedContentMenuDefault.default), {
                    parentContentId: this.props.previousContentId,
                    conversationItem: {
                        ...this.props.fallbackMessage,
                        featureTypeId: (0, _featureTypeIds.FallbackFeatureTypeId)
                    },
                    history: this.props.history,
                    featureTypeId: (0, _featureTypeIds.FallbackFeatureTypeId),
                    followUp: responseGroups?.[0]?.firstResponse?.followUp,
                    contentId: this.props.fallbackMessage?.id,
                    onClose: this.props.onToggleNavigation,
                    onSave: this.handleAsyncSubmit.bind(this)
                }),
            treeRender: this.renderTree.bind(this),
            formPanelRender: ()=>(0, _react.jsx)((0, _pageContainerDefault.default), {
                    fill: true
                }, (0, _react.jsx)((0, _conversationItemActionButtonToolbarDefault.default), {
                    errors: Object.values(props.errors),
                    validateForm: props.validateForm,
                    publishDisabled: this.props.assistantApplication == null,
                    saveDisabled: Object.keys(props.errors).length > 0,
                    contentItem: props.fallbackMessage,
                    isLoading: isLoading,
                    handleDiscardChanges: this.handleDiscardChanges.bind(this),
                    handlePublishing: this.handleSaveAndPublish.bind(this),
                    submitForm: props.submitForm
                }), props.fallbackMessage?.createdFromId && (0, _react.jsx)((0, _templateLockedBannerDefault.default), {
                    isLoading: props.stateContainer.state.isTogglingSync,
                    isLinked: props.isTemplateOwned,
                    onRelink: this.handleToggleRelinkModal.bind(this),
                    onUnlink: ()=>this.props.onToggleSync(this.props.fallbackMessage.id, true)
                }), (0, _react.jsx)((0, _conversationItemFieldSetDefault.default), {
                    disabled: isDisabled,
                    withBanner: props.fallbackMessage?.createdFromId != null
                }, (0, _react.jsx)((0, _scrollablePanelBodyDefault.default), {
                    className: "scrollable-body"
                }, (0, _react.jsx)((0, _panelTitleDefault.default), {
                    title: "Content Editing",
                    detail: "Here’s where you can fill in the info about this content and determine the course of the conversation by filling in the relevant details."
                }), (0, _react.jsx)((0, _contentCollapsingSectionDefault.default), {
                    title: "Content Info",
                    id: "contentInfo",
                    icon: contentInfoIcon,
                    titleRightRowComponent: (0, _react.jsx)((0, _contentInfoOptionsDefault.default), {
                        webhookCount: this.props.stateContainer.state.webhookUpdates?.webhookInstances?.length ?? this.props.stateContainer.state.attachedWebhooks?.length ?? 0,
                        options: this.getOptions(this.props.fallbackMessage != null),
                        optionSelected: this.handleContentItemOptionSelected.bind(this),
                        manageWebhooks: this.showWebhookInstanceManager.bind(this),
                        showSensitiveConversation: this.state.showSensitiveConversation,
                        toggleSensitiveConversation: ()=>{
                            this.toggleSensitiveConversation();
                        },
                        showDisabledForFeatures: this.state.showDisabledForFeatureFlags,
                        toggleDisabledForFeatures: ()=>{
                            this.toggleDisableForFeatureFlags();
                        },
                        flagsSelected: props.values.disabledForFeatureFlagIds?.length
                    })
                }, this.state.showSensitiveConversation && (0, _react.jsx)((0, _sensitiveDataOptionsDefault.default), {
                    selectedOption: props.values.sensitiveConversationChange ?? "None",
                    onChange: (value)=>{
                        props.setFieldValue("sensitiveConversationChange", value);
                    }
                }), this.state.showDisabledForFeatureFlags && (0, _react.jsx)((0, _disableForFeatureFlagOptionsDefault.default), {
                    appContainer: this.props.appContainer,
                    onChange: (value)=>{
                        props.setFieldValue("disabledForFeatureFlagIds", value);
                    },
                    selectedFeatureFlags: props.values.disabledForFeatureFlagIds
                }), (0, _react.jsx)((0, _contentSectionTitleDefault.default), {
                    title: "Fallback Message Conversation",
                    icon: (0, _extensions.getFeatureTypeIcon)((0, _featureTypeIds.FallbackFeatureTypeId), true)
                }), (0, _react.jsx)((0, _titleTextFieldDefault.default), {
                    id: "contentTitle",
                    disabled: isDisabled,
                    name: "title",
                    placeholder: "For display only",
                    value: props.values.title,
                    label: "Title",
                    onChange: props.handleChange,
                    onBlur: props.handleBlur
                }), (0, _react.jsx)((0, _contentLanguageMultiSelectorDefault.default), {
                    id: "contentLanguage",
                    disabled: isDisabled,
                    label: "Language / Region",
                    languages: props.application.languages,
                    selectedLanguageIds: props.values.languages.map((l)=>l.id),
                    onChange: this.handleLanguagesChange.bind(this)
                }), this.renderOptions(false, isDisabled), categories.length == 0 || props.stateContainer.state.isLoadingCategories ? (0, _react.jsx)((0, _secondaryLoaderDefault.default), null) : (0, _react.jsx)((0, _selectFieldDefault.default), {
                    name: "categoryId",
                    className: selectFieldStyle,
                    label: "Fallback Category",
                    onChange: this.handleCategoryChange.bind(this),
                    onBlur: this.handleCategoryBlur.bind(this),
                    value: props.values.categoryId,
                    disabled: isDisabled,
                    options: categories.map((o)=>({
                            value: o.id,
                            label: o.name
                        }))
                })), (0, _react.jsx)((0, _responsesManagerDefault.default), {
                    applicationId: this.props.application.id,
                    applicationFeatureId: this.props.applicationFeatureId,
                    languages: this.props.values.languages,
                    responseGroups: responseGroups,
                    getConditionsKey: (c)=>this.getConditionsKey(c),
                    showError: this.showError.bind(this),
                    isDisabled: isDisabled,
                    onChange: this.handleResponsesChange.bind(this),
                    onBlur: this.props.handleBlur,
                    emptyFollowUpOptionText: "Default - await further user input",
                    emptyFollowUpOptionIcon: continueIcon,
                    showEndSessionOption: true,
                    simulatedResponseId: simulatedResponseId,
                    responseIdToNamesRef: this.responseIdToNamesRef,
                    contentItemTitle: this.props.values.title
                }))), (0, _react.jsx)((0, _pageErrorDefault.default), {
                    errors: this.props?.stateContainer?.state?.errors ?? [],
                    onClear: this.handleClearError.bind(this)
                })),
            testCasesRender: ()=>(0, _react.jsx)((0, _contentItemTestCaseViewerDefault.default), {
                    application: this.props.application,
                    contentItemId: this.props.fallbackMessage?.id,
                    getResponseId: this.handleResponseIdFromSim,
                    responseIdToNamesRef: this.responseIdToNamesRef
                })
        })), this.renderRelinkSyncWarning(), this.renderWebhookInstanceManager(this.props.application.id, this.props.fallbackMessage?.id, (0, _featureTypeIds.FallbackFeatureTypeId), this.props.values.webhookChainingType));
    }
}
const selectFieldStyle = /*#__PURE__*/ (0, _css.css)({
    name: "1d0nbku",
    styles: "margin-top:24px"
});
const StyledContainer = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "efd5ues0"
})({
    name: "1n5m579",
    styles: "padding:16px;width:100%;display:block;justify-content:flex-start"
});
exports.default = FallbackMessageForm;

},{"@babel/runtime/helpers/defineProperty":"9sJxO","@emotion/styled/base":"lSuFu","@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","../../components/structure/PageContainer":"hc1r8","../../components/forms/TitleTextField":"6fj1a","../followUpForm":"5HXc2","../../components/general/Loader":"bnV5T","../../constants/featureTypeIds":"hPLMP","../../components/forms/ContentLanguageMultiSelector":"4SbwP","../contentPage":"6VyMV","../relatedContentMenu":"aWiMy","../../components/structure/ScrollablePanelBody":"6LRg3","../contentPage/components/PanelTitle":"anVUR","../../components/structure/ContentCollapsingSection":"1CUms","../contentPage/components/ContentSectionTitle":"5RGHr","../../models/extensions":"7h01B","../../components/general/PageError":"ezFTm","./components/ConversationItemActionButtonToolbar":"TGPQ9","../../components/general/TemplateLockedBanner":"gMkKq","../../components/forms/ConversationItemFieldSet":"8a3oA","../../components/structure/ContentInfoOptions":"6Ozsc","../responsesManager":"jtCYo","../../components/general/SecondaryLoader":"7zJiF","../../components/forms/SelectField":"405B3","./components/DirtyFormPrompt":"i9WDI","../contentPage/components/SensitiveDataOptions":"oXWpd","../contentPage/components/DisableForFeatureFlagOptions":"67JXM","./ContentItemTestCaseViewer":"6EkXj","f26dd962379d7504":"fKr4T","e4b4099d5f085e23":"d8BS5","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"lVVZ5":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _unstated = require("unstated");
var _fallbackMessageContainer = require("../../state/containers/FallbackMessageContainer");
var _fallbackMessageContainerDefault = parcelHelpers.interopDefault(_fallbackMessageContainer);
var _applicationContainer = require("../../state/containers/ApplicationContainer");
var _applicationContainerDefault = parcelHelpers.interopDefault(_applicationContainer);
var _titleStateContainer = require("../../state/containers/TitleStateContainer");
var _titleStateContainerDefault = parcelHelpers.interopDefault(_titleStateContainer);
var _createFallbackMessageForm = require("./components/CreateFallbackMessageForm");
var _createFallbackMessageFormDefault = parcelHelpers.interopDefault(_createFallbackMessageForm);
var _repromptContainer = require("../../state/containers/RepromptContainer");
var _repromptContainerDefault = parcelHelpers.interopDefault(_repromptContainer);
var _followUpContainer = require("../../state/containers/FollowUpContainer");
var _followUpContainerDefault = parcelHelpers.interopDefault(_followUpContainer);
var _mediaResponseContainer = require("../../state/containers/MediaResponseContainer");
var _mediaResponseContainerDefault = parcelHelpers.interopDefault(_mediaResponseContainer);
var _navigationBarFormPage = require("../formScenes/NavigationBarFormPage");
var _navigationBarFormPageDefault = parcelHelpers.interopDefault(_navigationBarFormPage);
var _genericCreateContentItemPage = require("../formScenes/GenericCreateContentItemPage");
var _genericCreateContentItemPageDefault = parcelHelpers.interopDefault(_genericCreateContentItemPage);
var _featureContainer = require("../../state/containers/FeatureContainer");
var _featureContainerDefault = parcelHelpers.interopDefault(_featureContainer);
var _featureTypeIds = require("../../constants/featureTypeIds");
class CreateFallbackMessage extends (0, _navigationBarFormPageDefault.default) {
    render() {
        return (0, _react.jsx)((0, _unstated.Subscribe), {
            to: [
                (0, _fallbackMessageContainerDefault.default),
                (0, _applicationContainerDefault.default),
                (0, _titleStateContainerDefault.default),
                (0, _repromptContainerDefault.default),
                (0, _followUpContainerDefault.default),
                (0, _mediaResponseContainerDefault.default),
                (0, _featureContainerDefault.default)
            ]
        }, (fallbackContainer, appContainer, titleContainer, repromptContainer, followUpContainer, responseContainer, featureContainer)=>{
            return (0, _react.jsx)((0, _genericCreateContentItemPageDefault.default), {
                stateContainer: fallbackContainer,
                titleContainer: titleContainer,
                applicationContainer: appContainer,
                defaultTitle: "New Fallback Message",
                history: this.props.history,
                location: this.props.location,
                match: this.props.match,
                staticContext: this.props.staticContext,
                featureContainer: featureContainer,
                featureTypeId: (0, _featureTypeIds.FallbackFeatureTypeId),
                formRender: (application, assistantApplication, onPublish, onSubmit, onAccessTypeChange)=>(0, _react.jsx)((0, _createFallbackMessageFormDefault.default), {
                        location: this.props.location,
                        application: application,
                        applicationFeatureId: this.props.match.params.applicationFeatureId,
                        stateContainer: fallbackContainer,
                        assistantApplication: assistantApplication,
                        appContainer: appContainer,
                        onShowPublishModal: onPublish,
                        followUpContainer: followUpContainer,
                        repromptContainer: repromptContainer,
                        responseStateContainer: responseContainer,
                        featureContainer: featureContainer,
                        isSaving: fallbackContainer.state.isSaving,
                        history: this.props.history,
                        onAccessTypeChange: onAccessTypeChange,
                        onSubmit: onSubmit,
                        onToggleNavigation: ()=>{}
                    })
            });
        });
    }
}
exports.default = CreateFallbackMessage;

},{"@emotion/react":"djZKr","react":"6uln9","unstated":"grh7p","../../state/containers/FallbackMessageContainer":"kKZMo","../../state/containers/ApplicationContainer":"cuqi2","../../state/containers/TitleStateContainer":"2osOD","./components/CreateFallbackMessageForm":"iw4Fv","../../state/containers/RepromptContainer":"5vKMV","../../state/containers/FollowUpContainer":"rm9OA","../../state/containers/MediaResponseContainer":"1ccrV","../formScenes/NavigationBarFormPage":"4ZcAE","../formScenes/GenericCreateContentItemPage":"dUUA3","../../state/containers/FeatureContainer":"4ApGg","../../constants/featureTypeIds":"hPLMP","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"iw4Fv":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _formik = require("formik");
var _yup = require("yup");
var _fallbackMessageForm = require("../../formScenes/FallbackMessageForm");
var _fallbackMessageFormDefault = parcelHelpers.interopDefault(_fallbackMessageForm);
// note: some info on handling two submit buttons: https://github.com/jaredpalmer/formik/issues/214
// save creates the item and save and publish saves it and toggles the is live call
const CreateFallbackMessageForm = (0, _formik.withFormik)({
    mapPropsToValues: (props)=>({
            responses: [
                {
                    content: ""
                }
            ],
            title: "Untitled Fallback Message",
            followUpSelection: "end",
            repromptSelection: "end",
            entryType: "open",
            sensitiveConversationChange: "None",
            requiresParent: false,
            isLive: true,
            languages: props.application?.languages.find((l)=>l.id == props.application?.defaultLanguageId) ? [
                props.application?.languages.find((l)=>l.id == props.application?.defaultLanguageId)
            ] : [],
            webhookChainingType: "NoChaining"
        }),
    validationSchema: _yup.object().shape({
        title: _yup.string().required("You must enter a title"),
        responses: _yup.array().of(_yup.object().shape({
            content: _yup.string().required("You must enter a response variation")
        })).required("You must enter at least 1 response variation").min(1, "You must enter at least 1 response variation"),
        categoryId: _yup.string().required("You must select a category")
    }),
    validateOnMount: true,
    handleSubmit: (values, { props, setStatus, setFieldValue })=>{
        setStatus({
            submitting: true
        });
        return props.onSubmit(props.stateContainer.mapFormDataToModel({
            applicationFeatureId: props.applicationFeatureId,
            applicationId: props.application?.id,
            responses: []
        }, values));
    }
})((0, _fallbackMessageFormDefault.default));
exports.default = CreateFallbackMessageForm;

},{"formik":"3YnOK","yup":"j2SJU","../../formScenes/FallbackMessageForm":"4LY6G","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7eaNQ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _unstated = require("unstated");
var _featureContainer = require("../../state/containers/FeatureContainer");
var _featureContainerDefault = parcelHelpers.interopDefault(_featureContainer);
var _numberRangeContainer = require("../../state/containers/NumberRangeContainer");
var _numberRangeContainerDefault = parcelHelpers.interopDefault(_numberRangeContainer);
var _applicationContainer = require("../../state/containers/ApplicationContainer");
var _applicationContainerDefault = parcelHelpers.interopDefault(_applicationContainer);
var _titleStateContainer = require("../../state/containers/TitleStateContainer");
var _titleStateContainerDefault = parcelHelpers.interopDefault(_titleStateContainer);
var _repromptContainer = require("../../state/containers/RepromptContainer");
var _repromptContainerDefault = parcelHelpers.interopDefault(_repromptContainer);
var _followUpContainer = require("../../state/containers/FollowUpContainer");
var _followUpContainerDefault = parcelHelpers.interopDefault(_followUpContainer);
var _createNumberRangeForm = require("./components/CreateNumberRangeForm");
var _createNumberRangeFormDefault = parcelHelpers.interopDefault(_createNumberRangeForm);
var _mediaResponseContainer = require("../../state/containers/MediaResponseContainer");
var _mediaResponseContainerDefault = parcelHelpers.interopDefault(_mediaResponseContainer);
var _navigationBarFormPage = require("../formScenes/NavigationBarFormPage");
var _navigationBarFormPageDefault = parcelHelpers.interopDefault(_navigationBarFormPage);
var _genericCreateContentItemPage = require("../formScenes/GenericCreateContentItemPage");
var _genericCreateContentItemPageDefault = parcelHelpers.interopDefault(_genericCreateContentItemPage);
var _featureTypeIds = require("../../constants/featureTypeIds");
const outputIcon = require("e83731d1364bd994");
class CreateNumberRange extends (0, _navigationBarFormPageDefault.default) {
    render() {
        return (0, _react.jsx)((0, _unstated.Subscribe), {
            to: [
                (0, _numberRangeContainerDefault.default),
                (0, _applicationContainerDefault.default),
                (0, _titleStateContainerDefault.default),
                (0, _repromptContainerDefault.default),
                (0, _followUpContainerDefault.default),
                (0, _mediaResponseContainerDefault.default),
                (0, _featureContainerDefault.default)
            ]
        }, (numberRangeContainer, appContainer, titleContainer, repromptContainer, followUpContainer, responseStateContainer, featureContainer)=>{
            return (0, _react.jsx)((0, _genericCreateContentItemPageDefault.default), {
                stateContainer: numberRangeContainer,
                titleContainer: titleContainer,
                applicationContainer: appContainer,
                defaultTitle: "New Number Range",
                history: this.props.history,
                location: this.props.location,
                match: this.props.match,
                staticContext: this.props.staticContext,
                featureContainer: featureContainer,
                featureTypeId: (0, _featureTypeIds.NumberRangeFeatureTypeId),
                formRender: (application, assistantApplication, onPublish, onSubmit, onAccessTypeChange)=>(0, _react.jsx)((0, _createNumberRangeFormDefault.default), {
                        location: this.props.location,
                        applicationFeatureId: this.props.match.params.applicationFeatureId,
                        application: application,
                        stateContainer: numberRangeContainer,
                        assistantApplication: assistantApplication,
                        appContainer: appContainer,
                        repromptContainer: repromptContainer,
                        followUpContainer: followUpContainer,
                        responseStateContainer: responseStateContainer,
                        featureContainer: featureContainer,
                        isSaving: numberRangeContainer.state.isSaving,
                        history: this.props.history,
                        onAccessTypeChange: onAccessTypeChange,
                        onShowPublishModal: onPublish,
                        onSubmit: onSubmit,
                        onToggleNavigation: ()=>{}
                    })
            });
        });
    }
}
exports.default = CreateNumberRange;

},{"@emotion/react":"djZKr","react":"6uln9","unstated":"grh7p","../../state/containers/FeatureContainer":"4ApGg","../../state/containers/NumberRangeContainer":"an6iC","../../state/containers/ApplicationContainer":"cuqi2","../../state/containers/TitleStateContainer":"2osOD","../../state/containers/RepromptContainer":"5vKMV","../../state/containers/FollowUpContainer":"rm9OA","./components/CreateNumberRangeForm":"4wdkR","../../state/containers/MediaResponseContainer":"1ccrV","../formScenes/NavigationBarFormPage":"4ZcAE","../formScenes/GenericCreateContentItemPage":"dUUA3","../../constants/featureTypeIds":"hPLMP","e83731d1364bd994":"2nj1V","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4wdkR":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _formik = require("formik");
var _yup = require("yup");
var _numberRangeForm = require("../../formScenes/NumberRangeForm");
var _numberRangeFormDefault = parcelHelpers.interopDefault(_numberRangeForm);
const CreateNumberRangeForm = (0, _formik.withFormik)({
    mapPropsToValues: (props)=>({
            title: "Untitled Number Range",
            category: "",
            minimumValue: null,
            maximumValue: null,
            responses: [
                {
                    content: ""
                }
            ],
            followUpSelection: "end",
            repromptSelection: "end",
            rangeType: "between",
            sensitiveConversationChange: "None",
            entryType: "targeted",
            requiresParent: true,
            isLive: true,
            languages: props.application?.languages.find((l)=>l.id == props.application?.defaultLanguageId) ? [
                props.application?.languages.find((l)=>l.id == props.application?.defaultLanguageId)
            ] : [],
            webhookChainingType: "NoChaining"
        }),
    validationSchema: _yup.object().shape({
        title: _yup.string().required("You must enter a title"),
        responses: _yup.array().of(_yup.object().shape({
            content: _yup.string().required("You must enter a response variation")
        })).required("You must enter at least 1 response variation").min(1, "You must enter at least 1 response variation")
    }),
    validateOnMount: true,
    handleSubmit: (values, { props, setStatus, setFieldValue })=>{
        setStatus({
            submitting: true
        });
        return props.onSubmit(props.stateContainer.mapFormDataToModel({
            applicationFeatureId: props.applicationFeatureId,
            applicationId: props.application?.id,
            responses: []
        }, values));
    }
})((0, _numberRangeFormDefault.default));
exports.default = CreateNumberRangeForm;

},{"formik":"3YnOK","yup":"j2SJU","../../formScenes/NumberRangeForm":"7hA5F","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7hA5F":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _defineProperty = require("@babel/runtime/helpers/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _contentCard = require("../../components/structure/ContentCard");
var _contentCardDefault = parcelHelpers.interopDefault(_contentCard);
var _detailLabel = require("../../components/general/DetailLabel");
var _detailLabelDefault = parcelHelpers.interopDefault(_detailLabel);
var _pageContainer = require("../../components/structure/PageContainer");
var _pageContainerDefault = parcelHelpers.interopDefault(_pageContainer);
var _formFieldsContainer = require("../../components/structure/FormFieldsContainer");
var _formFieldsContainerDefault = parcelHelpers.interopDefault(_formFieldsContainer);
var _horizontalContainer = require("../../components/structure/HorizontalContainer");
var _horizontalContainerDefault = parcelHelpers.interopDefault(_horizontalContainer);
var _titleTextField = require("../../components/forms/TitleTextField");
var _titleTextFieldDefault = parcelHelpers.interopDefault(_titleTextField);
var _selectField = require("../../components/forms/SelectField");
var _selectFieldDefault = parcelHelpers.interopDefault(_selectField);
var _followUpForm = require("../followUpForm");
var _followUpFormDefault = parcelHelpers.interopDefault(_followUpForm);
var _loader = require("../../components/general/Loader");
var _loaderDefault = parcelHelpers.interopDefault(_loader);
var _textField = require("../../components/forms/TextField");
var _textFieldDefault = parcelHelpers.interopDefault(_textField);
var _css = require("@emotion/css");
var _colors = require("../../constants/colors");
var _featureTypeIds = require("../../constants/featureTypeIds");
var _contentLanguageMultiSelector = require("../../components/forms/ContentLanguageMultiSelector");
var _contentLanguageMultiSelectorDefault = parcelHelpers.interopDefault(_contentLanguageMultiSelector);
var _contentPage = require("../contentPage");
var _contentPageDefault = parcelHelpers.interopDefault(_contentPage);
var _relatedContentMenu = require("../relatedContentMenu");
var _relatedContentMenuDefault = parcelHelpers.interopDefault(_relatedContentMenu);
var _scrollablePanelBody = require("../../components/structure/ScrollablePanelBody");
var _scrollablePanelBodyDefault = parcelHelpers.interopDefault(_scrollablePanelBody);
var _panelTitle = require("../contentPage/components/PanelTitle");
var _panelTitleDefault = parcelHelpers.interopDefault(_panelTitle);
var _contentCollapsingSection = require("../../components/structure/ContentCollapsingSection");
var _contentCollapsingSectionDefault = parcelHelpers.interopDefault(_contentCollapsingSection);
var _contentSectionTitle = require("../contentPage/components/ContentSectionTitle");
var _contentSectionTitleDefault = parcelHelpers.interopDefault(_contentSectionTitle);
var _extensions = require("../../models/extensions");
var _pageError = require("../../components/general/PageError");
var _pageErrorDefault = parcelHelpers.interopDefault(_pageError);
var _conversationItemActionButtonToolbar = require("./components/ConversationItemActionButtonToolbar");
var _conversationItemActionButtonToolbarDefault = parcelHelpers.interopDefault(_conversationItemActionButtonToolbar);
var _templateLockedBanner = require("../../components/general/TemplateLockedBanner");
var _templateLockedBannerDefault = parcelHelpers.interopDefault(_templateLockedBanner);
var _conversationItemFieldSet = require("../../components/forms/ConversationItemFieldSet");
var _conversationItemFieldSetDefault = parcelHelpers.interopDefault(_conversationItemFieldSet);
var _contentInfoOptions = require("../../components/structure/ContentInfoOptions");
var _contentInfoOptionsDefault = parcelHelpers.interopDefault(_contentInfoOptions);
var _responsesManager = require("../responsesManager");
var _responsesManagerDefault = parcelHelpers.interopDefault(_responsesManager);
var _dirtyFormPrompt = require("./components/DirtyFormPrompt");
var _sensitiveDataOptions = require("../contentPage/components/SensitiveDataOptions");
var _sensitiveDataOptionsDefault = parcelHelpers.interopDefault(_sensitiveDataOptions);
var _disableForFeatureFlagOptions = require("../contentPage/components/DisableForFeatureFlagOptions");
var _disableForFeatureFlagOptionsDefault = parcelHelpers.interopDefault(_disableForFeatureFlagOptions);
var _contentItemTestCaseViewer = require("./ContentItemTestCaseViewer");
var _contentItemTestCaseViewerDefault = parcelHelpers.interopDefault(_contentItemTestCaseViewer);
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const userIcon = require("cebe9fa6e1edfe57");
const contentInfoIcon = require("b35d13dc166ebf54");
const inputGroupIcon = require("248b54d89e7ba2b6");
const inputIcon = require("45d01daabf47d5b5");
const numberFieldStyle = /*#__PURE__*/ (0, _css.css)({
    name: "1ww443i",
    styles: "max-width:200px"
});
const horizontalFormStyle = /*#__PURE__*/ (0, _css.css)("align-items:center;p{margin:20px 12px 0 12px;color:", (0, _colors.cool_grey), ";}", "");
class NumberRangeForm extends (0, _followUpFormDefault.default) {
    constructor(...args){
        super(...args);
        (0, _definePropertyDefault.default)(this, "handleResponseIdFromSim", (id)=>{
            this.setState({
                simulatedResponseId: id
            });
        });
    }
    componentDidUpdate(prevProps, prevState) {
        super.componentDidUpdate(prevProps, prevState);
    }
    handleAsyncSubmit(onSuccess) {
        if (this.manualValidate()) return this.props.onSubmit(this.props.stateContainer.mapFormDataToModel(this.props.numberRange, this.props.values), onSuccess);
    }
    handleDiscardChanges() {
        this.handleFinish();
    }
    handleDelete() {
        const confirmed = confirm("Are you sure you want to delete this?");
        if (confirmed) this.props.stateContainer.delete(this.props.numberRange.id).then(()=>{
            this.handleFinish();
        });
    }
    handleCopy() {
        this.handleAsyncSubmit(()=>{
            this.props.stateContainer.copy(this.props.numberRange.id).then((r2)=>{
                if (r2.resultType == "Ok") this.props.history.push(`/v/${r2.data.applicationFeatureId}/numberranges/${r2.data.id}`);
            });
        });
    }
    handleTypeChange(value) {
        const finalValue = value === null ? null : value.value;
        this.props.setFieldValue("rangeType", finalValue);
        this.props.setFieldValue("maximumValue", "");
        this.props.setFieldValue("minimumValue", "");
    }
    handleTypeBlur(blur) {
        this.props.setFieldTouched("rangeType", blur);
    }
    handleEqualsChange(e) {
        this.props.setFieldValue("maximumValue", e.target.value);
        this.props.setFieldValue("minimumValue", e.target.value);
    }
    handleEqualsBlur(blur) {
        this.props.setFieldTouched("maximumValue", blur);
        this.props.setFieldTouched("minimumValue", blur);
    }
    getUserUtterances() {
        switch(this.props.values.rangeType){
            case "equal":
                return [
                    {
                        id: "equal",
                        content: this.getMinText(),
                        highlights: [
                            this.getMinText()
                        ]
                    }
                ];
            case "between":
                return [
                    {
                        id: "middle-random",
                        content: `[Value greater than ${this.getMinText()} but less than ${this.getMaxText()}]`,
                        highlights: [
                            this.getMinText(),
                            this.getMaxText()
                        ]
                    },
                    {
                        id: "lower",
                        content: this.getMinText(),
                        highlights: [
                            this.getMinText()
                        ]
                    },
                    {
                        id: "upper",
                        content: this.getMaxText(),
                        highlights: [
                            this.getMaxText()
                        ]
                    }
                ];
            case "greater-than":
                return [
                    {
                        id: "middle-random",
                        content: `[Value greater than ${this.getMinText()}]`,
                        highlights: [
                            this.getMinText()
                        ]
                    },
                    {
                        id: "lower",
                        content: "" + this.getMinText(),
                        highlights: [
                            this.getMinText()
                        ]
                    }
                ];
            case "less-than":
                return [
                    {
                        id: "middle-random",
                        content: `[Value less than ${this.getMaxText()}]`,
                        highlights: [
                            this.getMaxText()
                        ]
                    },
                    {
                        id: "upper",
                        content: "" + this.getMaxText(),
                        highlights: [
                            this.getMaxText()
                        ]
                    }
                ];
        }
        return [];
    }
    renderBetweenFields() {
        return (0, _react.jsx)((0, _horizontalContainerDefault.default), {
            className: horizontalFormStyle
        }, this.renderGreaterThanFields(), (0, _react.jsx)("p", null, "AND"), this.renderLessThanFields());
    }
    renderLessThanFields() {
        return (0, _react.jsx)((0, _textFieldDefault.default), {
            required: true,
            className: numberFieldStyle,
            name: "maximumValue",
            value: this.props.values.maximumValue,
            onChange: this.props.handleChange,
            onBlur: this.props.handleBlur,
            label: "Maximum value",
            placeholder: "max",
            type: "number"
        });
    }
    renderGreaterThanFields() {
        return (0, _react.jsx)((0, _textFieldDefault.default), {
            required: true,
            className: numberFieldStyle,
            name: "minimumValue",
            value: this.props.values.minimumValue,
            onChange: this.props.handleChange,
            onBlur: this.props.handleBlur,
            label: "Minimum value",
            placeholder: "min",
            type: "number"
        });
    }
    renderEqualsFields() {
        return (0, _react.jsx)((0, _textFieldDefault.default), {
            required: true,
            className: numberFieldStyle,
            value: this.props.values.minimumValue,
            name: "minimumValue",
            onChange: this.handleEqualsChange.bind(this),
            onBlur: this.handleEqualsBlur.bind(this),
            label: "Exact value",
            placeholder: "exact",
            type: "number"
        });
    }
    getMinText() {
        return this.props.values.minimumValue ? "" + this.props.values.minimumValue : "{minimum}";
    }
    getMaxText() {
        return this.props.values.maximumValue ? "" + this.props.values.maximumValue : "{maximum}";
    }
    getMenuTreeRoots() {
        var roots = [
            this.getContentInfoTreeItem(),
            {
                id: "user-says",
                title: "User-Says",
                isExpanded: this.isItemExpanded("user-says"),
                canExpand: true,
                icon: userIcon,
                linkTo: "#userSays",
                children: [
                    {
                        id: "numberOptions",
                        title: "Number Options",
                        canExpand: true,
                        isExpanded: this.isItemExpanded("numberOptions"),
                        icon: inputGroupIcon,
                        linkTo: "#numberOptions",
                        children: [
                            {
                                id: "numberRangeType",
                                title: "Type",
                                canExpand: false,
                                icon: inputIcon,
                                linkTo: "#numberRangeType"
                            },
                            {
                                id: "values",
                                title: "Values",
                                canExpand: false,
                                icon: inputIcon,
                                linkTo: "#values"
                            }
                        ]
                    }
                ]
            },
            ...this.getResponsesTreeItems(this.props.values.responses)
        ];
        return roots;
    }
    getContentItem() {
        return this.props.numberRange;
    }
    handleContentItemOptionSelected(option, event) {
        event.stopPropagation();
        if (option == "Manage Webhooks") this.showWebhookInstanceManager();
        else if (option == "Duplicate") this.handleCopy();
        else if (option == "Delete") this.handleDelete();
    }
    handleResponsesChange(responseGroups) {
        this.props.setFieldValue("responses", this.getResponsesFromGroups(responseGroups));
    }
    render() {
        const props = {
            ...this.props
        };
        const isLoading = props.stateContainer.state.isSaving;
        const isDisabled = isLoading || this.props.isTemplateOwned;
        const responseGroups = this.getResponseGroups(this.props.values.responses);
        const { simulatedResponseId } = this.state;
        if (this.props.responseStateContainer.state.isLoading || !this.props.application) return (0, _react.jsx)((0, _loaderDefault.default), null);
        return (0, _react.jsx)((0, _reactDefault.default).Fragment, null, (0, _react.jsx)("form", {
            onSubmit: props.handleSubmit
        }, (0, _react.jsx)((0, _dirtyFormPrompt.DirtyFormPrompt), {
            allowPrompt: props.status?.submitting != true
        }), (0, _react.jsx)((0, _contentPageDefault.default), {
            relatedContentRender: ()=>(0, _react.jsx)((0, _relatedContentMenuDefault.default), {
                    parentContentId: this.props.previousContentId,
                    conversationItem: {
                        ...this.props.numberRange,
                        featureTypeId: (0, _featureTypeIds.NumberRangeFeatureTypeId)
                    },
                    history: this.props.history,
                    featureTypeId: (0, _featureTypeIds.NumberRangeFeatureTypeId),
                    followUp: responseGroups?.[0]?.firstResponse?.followUp,
                    contentId: this.props.numberRange?.id,
                    onClose: this.props.onToggleNavigation,
                    onSave: this.handleAsyncSubmit.bind(this)
                }),
            treeRender: this.renderTree.bind(this),
            formPanelRender: ()=>(0, _react.jsx)((0, _pageContainerDefault.default), {
                    fill: true
                }, (0, _react.jsx)((0, _conversationItemActionButtonToolbarDefault.default), {
                    errors: Object.values(props.errors),
                    validateForm: props.validateForm,
                    publishDisabled: this.props.assistantApplication == null,
                    saveDisabled: Object.keys(props.errors).length > 0,
                    contentItem: props.numberRange,
                    isLoading: isLoading,
                    handleDiscardChanges: this.handleDiscardChanges.bind(this),
                    handlePublishing: this.handleSaveAndPublish.bind(this),
                    submitForm: props.submitForm
                }), props.numberRange?.createdFromId && (0, _react.jsx)((0, _templateLockedBannerDefault.default), {
                    isLoading: props.stateContainer.state.isTogglingSync,
                    isLinked: props.isTemplateOwned,
                    onRelink: this.handleToggleRelinkModal.bind(this),
                    onUnlink: ()=>this.props.onToggleSync(this.props.numberRange.id, true)
                }), (0, _react.jsx)((0, _conversationItemFieldSetDefault.default), {
                    disabled: isDisabled,
                    withBanner: props.numberRange?.createdFromId != null
                }, (0, _react.jsx)((0, _scrollablePanelBodyDefault.default), {
                    className: "scrollable-body"
                }, (0, _react.jsx)((0, _panelTitleDefault.default), {
                    title: "Content Editing",
                    detail: "Here’s where you can fill in the info about this content and determine the course of the conversation by filling in the relevant details."
                }), (0, _react.jsx)((0, _contentCollapsingSectionDefault.default), {
                    title: "Content Info",
                    id: "contentInfo",
                    icon: contentInfoIcon,
                    titleRightRowComponent: (0, _react.jsx)((0, _contentInfoOptionsDefault.default), {
                        webhookCount: this.props.stateContainer.state.webhookUpdates?.webhookInstances?.length ?? this.props.stateContainer.state.attachedWebhooks?.length ?? 0,
                        options: this.getOptions(this.props.numberRange != null),
                        optionSelected: this.handleContentItemOptionSelected.bind(this),
                        manageWebhooks: this.showWebhookInstanceManager.bind(this),
                        showSensitiveConversation: this.state.showSensitiveConversation,
                        toggleSensitiveConversation: ()=>{
                            this.toggleSensitiveConversation();
                        },
                        showDisabledForFeatures: this.state.showDisabledForFeatureFlags,
                        toggleDisabledForFeatures: ()=>{
                            this.toggleDisableForFeatureFlags();
                        },
                        flagsSelected: props.values.disabledForFeatureFlagIds?.length
                    })
                }, this.state.showSensitiveConversation && (0, _react.jsx)((0, _sensitiveDataOptionsDefault.default), {
                    selectedOption: props.values.sensitiveConversationChange ?? "None",
                    onChange: (value)=>{
                        props.setFieldValue("sensitiveConversationChange", value);
                    }
                }), this.state.showDisabledForFeatureFlags && (0, _react.jsx)((0, _disableForFeatureFlagOptionsDefault.default), {
                    appContainer: this.props.appContainer,
                    onChange: (value)=>{
                        props.setFieldValue("disabledForFeatureFlagIds", value);
                    },
                    selectedFeatureFlags: props.values.disabledForFeatureFlagIds
                }), (0, _react.jsx)((0, _contentSectionTitleDefault.default), {
                    title: "Number Range Conversation",
                    icon: (0, _extensions.getFeatureTypeIcon)((0, _featureTypeIds.NumberRangeFeatureTypeId), true)
                }), (0, _react.jsx)((0, _titleTextFieldDefault.default), {
                    id: "contentTitle",
                    disabled: isDisabled,
                    name: "title",
                    placeholder: "For display only",
                    value: props.values.title,
                    label: "Title",
                    onChange: props.handleChange,
                    onBlur: props.handleBlur
                }), (0, _react.jsx)((0, _contentLanguageMultiSelectorDefault.default), {
                    id: "contentLanguage",
                    disabled: isDisabled,
                    label: "Language / Region",
                    languages: props.application.languages,
                    selectedLanguageIds: props.values.languages.map((l)=>l.id),
                    onChange: this.handleLanguagesChange.bind(this)
                }), this.renderOptions(true, isDisabled)), (0, _react.jsx)((0, _contentCollapsingSectionDefault.default), {
                    title: "User Says",
                    icon: userIcon,
                    id: "userSays"
                }, (0, _react.jsx)((0, _contentCardDefault.default), {
                    title: "Number Options",
                    icon: inputGroupIcon,
                    id: "numberOptions"
                }, (0, _react.jsx)((0, _formFieldsContainerDefault.default), null, (0, _react.jsx)((0, _detailLabelDefault.default), {
                    text: "Select the type of number or range"
                }), (0, _react.jsx)((0, _selectFieldDefault.default), {
                    id: "numberRangeType",
                    name: "rangeType",
                    value: this.props.values.rangeType,
                    label: "Type",
                    disabled: isDisabled,
                    options: [
                        {
                            value: "equal",
                            label: "Equal to"
                        },
                        {
                            value: "between",
                            label: "Between"
                        },
                        {
                            value: "greater-than",
                            label: "Greater than or equal to"
                        },
                        {
                            value: "less-than",
                            label: "Less than or equal to"
                        }
                    ],
                    onChange: this.handleTypeChange.bind(this),
                    onBlur: this.handleTypeBlur.bind(this)
                }), (0, _react.jsx)("div", {
                    id: "values"
                }), this.props.values.rangeType == "equal" ? this.renderEqualsFields() : null, this.props.values.rangeType == "greater-than" ? this.renderGreaterThanFields() : null, this.props.values.rangeType == "less-than" ? this.renderLessThanFields() : null, this.props.values.rangeType == "between" ? this.renderBetweenFields() : null))), (0, _react.jsx)((0, _responsesManagerDefault.default), {
                    applicationId: this.props.application.id,
                    applicationFeatureId: this.props.applicationFeatureId,
                    languages: this.props.values.languages,
                    responseGroups: responseGroups,
                    getConditionsKey: (c)=>this.getConditionsKey(c),
                    showError: this.showError.bind(this),
                    isDisabled: isDisabled,
                    onChange: this.handleResponsesChange.bind(this),
                    onBlur: this.props.handleBlur,
                    simulatedResponseId: simulatedResponseId,
                    responseIdToNamesRef: this.responseIdToNamesRef,
                    contentItemTitle: this.props.values.title
                }))), (0, _react.jsx)((0, _pageErrorDefault.default), {
                    errors: this.props?.stateContainer?.state?.errors ?? [],
                    onClear: this.handleClearError.bind(this)
                })),
            testCasesRender: ()=>(0, _react.jsx)((0, _contentItemTestCaseViewerDefault.default), {
                    application: this.props.application,
                    contentItemId: this.props.numberRange?.id,
                    getResponseId: this.handleResponseIdFromSim,
                    responseIdToNamesRef: this.responseIdToNamesRef
                })
        })), this.renderRelinkSyncWarning(), this.renderWebhookInstanceManager(this.props.application.id, this.props.numberRange?.id, (0, _featureTypeIds.NumberRangeFeatureTypeId), this.props.values?.webhookChainingType));
    }
}
exports.default = NumberRangeForm;

},{"@babel/runtime/helpers/defineProperty":"9sJxO","@emotion/react":"djZKr","react":"6uln9","../../components/structure/ContentCard":"hJsdJ","../../components/general/DetailLabel":"j3EnX","../../components/structure/PageContainer":"hc1r8","../../components/structure/FormFieldsContainer":"h3hzh","../../components/structure/HorizontalContainer":"eJPfh","../../components/forms/TitleTextField":"6fj1a","../../components/forms/SelectField":"405B3","../followUpForm":"5HXc2","../../components/general/Loader":"bnV5T","../../components/forms/TextField":"7a7bh","@emotion/css":"awUBr","../../constants/colors":"1p3OR","../../constants/featureTypeIds":"hPLMP","../../components/forms/ContentLanguageMultiSelector":"4SbwP","../contentPage":"6VyMV","../relatedContentMenu":"aWiMy","../../components/structure/ScrollablePanelBody":"6LRg3","../contentPage/components/PanelTitle":"anVUR","../../components/structure/ContentCollapsingSection":"1CUms","../contentPage/components/ContentSectionTitle":"5RGHr","../../models/extensions":"7h01B","../../components/general/PageError":"ezFTm","./components/ConversationItemActionButtonToolbar":"TGPQ9","../../components/general/TemplateLockedBanner":"gMkKq","../../components/forms/ConversationItemFieldSet":"8a3oA","../../components/structure/ContentInfoOptions":"6Ozsc","../responsesManager":"jtCYo","./components/DirtyFormPrompt":"i9WDI","../contentPage/components/SensitiveDataOptions":"oXWpd","../contentPage/components/DisableForFeatureFlagOptions":"67JXM","./ContentItemTestCaseViewer":"6EkXj","cebe9fa6e1edfe57":"5aXrZ","b35d13dc166ebf54":"fKr4T","248b54d89e7ba2b6":"a8FLc","45d01daabf47d5b5":"iZ56c","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"awMS8":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _unstated = require("unstated");
var _featureContainer = require("../../state/containers/FeatureContainer");
var _featureContainerDefault = parcelHelpers.interopDefault(_featureContainer);
var _numberRangeContainer = require("../../state/containers/NumberRangeContainer");
var _numberRangeContainerDefault = parcelHelpers.interopDefault(_numberRangeContainer);
var _applicationContainer = require("../../state/containers/ApplicationContainer");
var _applicationContainerDefault = parcelHelpers.interopDefault(_applicationContainer);
var _titleStateContainer = require("../../state/containers/TitleStateContainer");
var _titleStateContainerDefault = parcelHelpers.interopDefault(_titleStateContainer);
var _repromptContainer = require("../../state/containers/RepromptContainer");
var _repromptContainerDefault = parcelHelpers.interopDefault(_repromptContainer);
var _followUpContainer = require("../../state/containers/FollowUpContainer");
var _followUpContainerDefault = parcelHelpers.interopDefault(_followUpContainer);
var _mediaResponseContainer = require("../../state/containers/MediaResponseContainer");
var _mediaResponseContainerDefault = parcelHelpers.interopDefault(_mediaResponseContainer);
var _editNumberRangeForm = require("./components/EditNumberRangeForm");
var _editNumberRangeFormDefault = parcelHelpers.interopDefault(_editNumberRangeForm);
var _genericEditContentItemPage = require("../formScenes/GenericEditContentItemPage");
var _genericEditContentItemPageDefault = parcelHelpers.interopDefault(_genericEditContentItemPage);
var _featureTypeIds = require("../../constants/featureTypeIds");
var _queryString = require("query-string");
var _queryStringDefault = parcelHelpers.interopDefault(_queryString);
var _applicationEnvironmentsContainer = require("../../state/containers/ApplicationEnvironmentsContainer");
var _applicationEnvironmentsContainerDefault = parcelHelpers.interopDefault(_applicationEnvironmentsContainer);
var _applicationBackupVersionsContainer = require("../../state/containers/ApplicationBackupVersionsContainer");
var _applicationBackupVersionsContainerDefault = parcelHelpers.interopDefault(_applicationBackupVersionsContainer);
class EditNumberRange extends (0, _reactDefault.default).Component {
    render() {
        return (0, _react.jsx)((0, _unstated.Subscribe), {
            key: this.props.match.params.numberRangeId + this.props.match.params.applicationFeatureId,
            to: [
                (0, _numberRangeContainerDefault.default),
                (0, _applicationContainerDefault.default),
                (0, _titleStateContainerDefault.default),
                (0, _repromptContainerDefault.default),
                (0, _followUpContainerDefault.default),
                (0, _mediaResponseContainerDefault.default),
                (0, _featureContainerDefault.default),
                (0, _applicationEnvironmentsContainerDefault.default),
                (0, _applicationBackupVersionsContainerDefault.default)
            ]
        }, (numberRangeContainer, appContainer, titleContainer, repromptContainer, followUpContainer, responseContainer, featureContainer, environmentsContainer, backupsContainer)=>{
            return (0, _react.jsx)((0, _genericEditContentItemPageDefault.default), {
                stateContainer: numberRangeContainer,
                environmentsContainer: environmentsContainer,
                backupsContainer: backupsContainer,
                titleContainer: titleContainer,
                applicationContainer: appContainer,
                defaultTitle: "Edit Number Range",
                contentItemId: this.props.match.params.numberRangeId,
                history: this.props.history,
                location: this.props.location,
                match: this.props.match,
                staticContext: this.props.staticContext,
                featureContainer: featureContainer,
                featureTypeId: (0, _featureTypeIds.NumberRangeFeatureTypeId),
                formRender: (contentItem, application, isTemplateOwned, assistantApplication, onShowPublishModal, onSubmit, toggleSync, onAccessTypeChange)=>(0, _react.jsx)((0, _editNumberRangeFormDefault.default), {
                        location: this.props.location,
                        applicationFeatureId: this.props.match.params.applicationFeatureId,
                        application: application,
                        numberRange: contentItem,
                        stateContainer: numberRangeContainer,
                        repromptContainer: repromptContainer,
                        followUpContainer: followUpContainer,
                        featureContainer: featureContainer,
                        appContainer: appContainer,
                        responseStateContainer: responseContainer,
                        assistantApplication: assistantApplication,
                        onShowPublishModal: onShowPublishModal,
                        onAccessTypeChange: onAccessTypeChange,
                        onSubmit: onSubmit,
                        onToggleSync: toggleSync,
                        previousContentId: (0, _queryStringDefault.default)?.parse(this.props.location.search)?.previousContentId,
                        history: this.props.history,
                        isSaving: numberRangeContainer.state.isSaving,
                        isTemplateOwned: isTemplateOwned
                    })
            });
        });
    }
}
exports.default = EditNumberRange;

},{"@emotion/react":"djZKr","react":"6uln9","unstated":"grh7p","../../state/containers/FeatureContainer":"4ApGg","../../state/containers/NumberRangeContainer":"an6iC","../../state/containers/ApplicationContainer":"cuqi2","../../state/containers/TitleStateContainer":"2osOD","../../state/containers/RepromptContainer":"5vKMV","../../state/containers/FollowUpContainer":"rm9OA","../../state/containers/MediaResponseContainer":"1ccrV","./components/EditNumberRangeForm":"4xYc5","../formScenes/GenericEditContentItemPage":"6RzEJ","../../constants/featureTypeIds":"hPLMP","query-string":"klvAV","../../state/containers/ApplicationEnvironmentsContainer":"jCULY","../../state/containers/ApplicationBackupVersionsContainer":"6rA1P","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4xYc5":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _formik = require("formik");
var _yup = require("yup");
var _numberRangeForm = require("../../formScenes/NumberRangeForm");
var _numberRangeFormDefault = parcelHelpers.interopDefault(_numberRangeForm);
const getRangeType = (min, max)=>{
    if (min != null && max != null && min == max) return "equal";
    else if (min != null && max != null) return "between";
    else if (min != null) return "greater-than";
    else if (max != null) return "less-than";
    return "equal";
};
const EditNumberRangeForm = (0, _formik.withFormik)({
    mapPropsToValues: (props)=>{
        var values = {
            title: props.numberRange.title,
            minimumValue: props.numberRange.minimumValue,
            maximumValue: props.numberRange.maximumValue,
            rangeType: getRangeType(props.numberRange.minimumValue, props.numberRange.maximumValue),
            responses: props.numberRange.responses.length > 0 ? props.numberRange.responses : [
                {
                    content: ""
                }
            ],
            requiresParent: true,
            languages: props.numberRange.languages,
            isLive: props.numberRange.isLive,
            webhookChainingType: props.numberRange.webhookChainingType,
            sensitiveConversationChange: props.numberRange.sensitiveConversationChange ?? "None",
            disabledForFeatureFlagIds: props.numberRange?.disabledForFeatureFlagIds
        };
        return values;
    },
    validationSchema: _yup.object().shape({
        title: _yup.string().required("You must enter a title"),
        responses: _yup.array().of(_yup.object().shape({
            content: _yup.string().required("You must enter a response variation")
        })).required("You must enter at least 1 response variation").min(1, "You must enter at least 1 response variation")
    }),
    validateOnMount: true,
    handleSubmit: (values, { props, setStatus })=>{
        setStatus({
            submitting: true
        });
        return props.onSubmit(props.stateContainer.mapFormDataToModel(props.numberRange, values));
    }
})((0, _numberRangeFormDefault.default));
exports.default = EditNumberRangeForm;

},{"formik":"3YnOK","yup":"j2SJU","../../formScenes/NumberRangeForm":"7hA5F","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"cbJPs":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _unstated = require("unstated");
var _featureContainer = require("../../state/containers/FeatureContainer");
var _featureContainerDefault = parcelHelpers.interopDefault(_featureContainer);
var _simpleChoiceContainer = require("../../state/containers/SimpleChoiceContainer");
var _simpleChoiceContainerDefault = parcelHelpers.interopDefault(_simpleChoiceContainer);
var _applicationContainer = require("../../state/containers/ApplicationContainer");
var _applicationContainerDefault = parcelHelpers.interopDefault(_applicationContainer);
var _titleStateContainer = require("../../state/containers/TitleStateContainer");
var _titleStateContainerDefault = parcelHelpers.interopDefault(_titleStateContainer);
var _repromptContainer = require("../../state/containers/RepromptContainer");
var _repromptContainerDefault = parcelHelpers.interopDefault(_repromptContainer);
var _followUpContainer = require("../../state/containers/FollowUpContainer");
var _followUpContainerDefault = parcelHelpers.interopDefault(_followUpContainer);
var _createSimpleChoiceForm = require("./components/CreateSimpleChoiceForm");
var _createSimpleChoiceFormDefault = parcelHelpers.interopDefault(_createSimpleChoiceForm);
var _mediaResponseContainer = require("../../state/containers/MediaResponseContainer");
var _mediaResponseContainerDefault = parcelHelpers.interopDefault(_mediaResponseContainer);
var _genericCreateContentItemPage = require("../formScenes/GenericCreateContentItemPage");
var _genericCreateContentItemPageDefault = parcelHelpers.interopDefault(_genericCreateContentItemPage);
var _featureTypeIds = require("../../constants/featureTypeIds");
class CreateSimpleChoice extends (0, _reactDefault.default).Component {
    render() {
        return (0, _react.jsx)((0, _unstated.Subscribe), {
            to: [
                (0, _simpleChoiceContainerDefault.default),
                (0, _applicationContainerDefault.default),
                (0, _titleStateContainerDefault.default),
                (0, _repromptContainerDefault.default),
                (0, _followUpContainerDefault.default),
                (0, _mediaResponseContainerDefault.default),
                (0, _featureContainerDefault.default)
            ]
        }, (simpleChoiceContainer, appContainer, titleContainer, repromptContainer, followUpContainer, responseStateContainer, featureContainer)=>{
            return (0, _react.jsx)((0, _genericCreateContentItemPageDefault.default), {
                stateContainer: simpleChoiceContainer,
                titleContainer: titleContainer,
                applicationContainer: appContainer,
                defaultTitle: "New Simple Choice",
                history: this.props.history,
                location: this.props.location,
                match: this.props.match,
                staticContext: this.props.staticContext,
                featureContainer: featureContainer,
                featureTypeId: (0, _featureTypeIds.SimpleChoiceFeatureTypeId),
                formRender: (application, assistantApplication, onPublish, onSubmit, onAccessTypeChange)=>(0, _react.jsx)((0, _createSimpleChoiceFormDefault.default), {
                        applicationFeatureId: this.props.match.params.applicationFeatureId,
                        application: application,
                        stateContainer: simpleChoiceContainer,
                        assistantApplication: assistantApplication,
                        appContainer: appContainer,
                        location: this.props.location,
                        repromptContainer: repromptContainer,
                        followUpContainer: followUpContainer,
                        responseStateContainer: responseStateContainer,
                        featureContainer: featureContainer,
                        isSaving: simpleChoiceContainer.state.isSaving,
                        history: this.props.history,
                        onAccessTypeChange: onAccessTypeChange,
                        onShowPublishModal: onPublish,
                        onSubmit: onSubmit,
                        onToggleNavigation: ()=>{}
                    })
            });
        });
    }
}
exports.default = CreateSimpleChoice;

},{"@emotion/react":"djZKr","react":"6uln9","unstated":"grh7p","../../state/containers/FeatureContainer":"4ApGg","../../state/containers/SimpleChoiceContainer":"hO0x5","../../state/containers/ApplicationContainer":"cuqi2","../../state/containers/TitleStateContainer":"2osOD","../../state/containers/RepromptContainer":"5vKMV","../../state/containers/FollowUpContainer":"rm9OA","./components/CreateSimpleChoiceForm":"5PhCZ","../../state/containers/MediaResponseContainer":"1ccrV","../formScenes/GenericCreateContentItemPage":"dUUA3","../../constants/featureTypeIds":"hPLMP","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"5PhCZ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _formik = require("formik");
var _yup = require("yup");
var _simpleChoiceForm = require("../../formScenes/SimpleChoiceForm");
var _simpleChoiceFormDefault = parcelHelpers.interopDefault(_simpleChoiceForm);
// note: some info on handling two submit buttons: https://github.com/jaredpalmer/formik/issues/214
// save creates the item and save and publish saves it and toggles the is live call
const CreateSimpleChoiceForm = (0, _formik.withFormik)({
    mapPropsToValues: (props)=>({
            title: "Untitled Yes/No",
            responses: [
                {
                    content: ""
                }
            ],
            followUpSelection: "end",
            repromptSelection: "end",
            choiceType: "Yes",
            entryType: "targeted",
            sensitiveConversationChange: "None",
            requiresParent: true,
            isLive: true,
            languages: props.application?.languages.find((l)=>l.id == props.application?.defaultLanguageId) ? [
                props.application?.languages.find((l)=>l.id == props.application?.defaultLanguageId)
            ] : [],
            webhookChainingType: "NoChaining"
        }),
    validationSchema: _yup.object().shape({
        title: _yup.string().required("You must enter a title"),
        responses: _yup.array().of(_yup.object().shape({
            content: _yup.string().required("You must enter a response variation")
        })).required("You must enter at least 1 response variation").min(1, "You must enter at least 1 response variation")
    }),
    validateOnMount: true,
    handleSubmit: (values, { props, setStatus })=>{
        setStatus({
            submitting: true
        });
        return props.onSubmit(props.stateContainer.mapFormDataToModel({
            applicationFeatureId: props.applicationFeatureId,
            applicationId: props.application?.id,
            responses: []
        }, values));
    }
})((0, _simpleChoiceFormDefault.default));
exports.default = CreateSimpleChoiceForm;

},{"formik":"3YnOK","yup":"j2SJU","../../formScenes/SimpleChoiceForm":"3TwBK","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3TwBK":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _defineProperty = require("@babel/runtime/helpers/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _contentCard = require("../../components/structure/ContentCard");
var _contentCardDefault = parcelHelpers.interopDefault(_contentCard);
var _detailLabel = require("../../components/general/DetailLabel");
var _detailLabelDefault = parcelHelpers.interopDefault(_detailLabel);
var _pageContainer = require("../../components/structure/PageContainer");
var _pageContainerDefault = parcelHelpers.interopDefault(_pageContainer);
var _formFieldsContainer = require("../../components/structure/FormFieldsContainer");
var _formFieldsContainerDefault = parcelHelpers.interopDefault(_formFieldsContainer);
var _titleTextField = require("../../components/forms/TitleTextField");
var _titleTextFieldDefault = parcelHelpers.interopDefault(_titleTextField);
var _followUpForm = require("../followUpForm");
var _followUpFormDefault = parcelHelpers.interopDefault(_followUpForm);
var _loader = require("../../components/general/Loader");
var _loaderDefault = parcelHelpers.interopDefault(_loader);
var _radioGroup = require("../../components/forms/RadioGroup");
var _radioGroupDefault = parcelHelpers.interopDefault(_radioGroup);
var _featureTypeIds = require("../../constants/featureTypeIds");
var _contentLanguageMultiSelector = require("../../components/forms/ContentLanguageMultiSelector");
var _contentLanguageMultiSelectorDefault = parcelHelpers.interopDefault(_contentLanguageMultiSelector);
var _contentPage = require("../contentPage");
var _contentPageDefault = parcelHelpers.interopDefault(_contentPage);
var _relatedContentMenu = require("../relatedContentMenu");
var _relatedContentMenuDefault = parcelHelpers.interopDefault(_relatedContentMenu);
var _scrollablePanelBody = require("../../components/structure/ScrollablePanelBody");
var _scrollablePanelBodyDefault = parcelHelpers.interopDefault(_scrollablePanelBody);
var _panelTitle = require("../contentPage/components/PanelTitle");
var _panelTitleDefault = parcelHelpers.interopDefault(_panelTitle);
var _contentCollapsingSection = require("../../components/structure/ContentCollapsingSection");
var _contentCollapsingSectionDefault = parcelHelpers.interopDefault(_contentCollapsingSection);
var _contentSectionTitle = require("../contentPage/components/ContentSectionTitle");
var _contentSectionTitleDefault = parcelHelpers.interopDefault(_contentSectionTitle);
var _extensions = require("../../models/extensions");
var _pageError = require("../../components/general/PageError");
var _pageErrorDefault = parcelHelpers.interopDefault(_pageError);
var _conversationItemActionButtonToolbar = require("./components/ConversationItemActionButtonToolbar");
var _conversationItemActionButtonToolbarDefault = parcelHelpers.interopDefault(_conversationItemActionButtonToolbar);
var _templateLockedBanner = require("../../components/general/TemplateLockedBanner");
var _templateLockedBannerDefault = parcelHelpers.interopDefault(_templateLockedBanner);
var _conversationItemFieldSet = require("../../components/forms/ConversationItemFieldSet");
var _conversationItemFieldSetDefault = parcelHelpers.interopDefault(_conversationItemFieldSet);
var _contentInfoOptions = require("../../components/structure/ContentInfoOptions");
var _contentInfoOptionsDefault = parcelHelpers.interopDefault(_contentInfoOptions);
var _responsesManager = require("../responsesManager");
var _responsesManagerDefault = parcelHelpers.interopDefault(_responsesManager);
var _dirtyFormPrompt = require("./components/DirtyFormPrompt");
var _sensitiveDataOptions = require("../contentPage/components/SensitiveDataOptions");
var _sensitiveDataOptionsDefault = parcelHelpers.interopDefault(_sensitiveDataOptions);
var _disableForFeatureFlagOptions = require("../contentPage/components/DisableForFeatureFlagOptions");
var _disableForFeatureFlagOptionsDefault = parcelHelpers.interopDefault(_disableForFeatureFlagOptions);
var _contentItemTestCaseViewer = require("./ContentItemTestCaseViewer");
var _contentItemTestCaseViewerDefault = parcelHelpers.interopDefault(_contentItemTestCaseViewer);
const userIcon = require("af0fc61d4b57b753");
const contentInfoIcon = require("5ff0b8146ecabc3a");
const inputGroupIcon = require("ed40ad2056e86951");
class SimpleChoiceForm extends (0, _followUpFormDefault.default) {
    constructor(...args){
        super(...args);
        (0, _definePropertyDefault.default)(this, "handleResponseIdFromSim", (id)=>{
            this.setState({
                simulatedResponseId: id
            });
        });
    }
    componentDidUpdate(prevProps, prevState) {
        super.componentDidUpdate(prevProps, prevState);
    }
    handleAsyncSubmit(onSuccess) {
        if (this.props.onSubmit && this.manualValidate()) return this.props.onSubmit(this.props.stateContainer.mapFormDataToModel(this.props.simpleChoice, this.props.values), onSuccess);
    }
    handleDiscardChanges() {
        this.handleFinish();
    }
    handleDelete() {
        const confirmed = confirm("Are you sure you want to delete this?");
        if (confirmed) this.props.stateContainer.delete(this.props.simpleChoice.id).then(()=>{
            this.handleFinish();
        });
    }
    handleCopy() {
        this.props.onSubmit(this.props.stateContainer.mapFormDataToModel(this.props.simpleChoice, this.props.values), ()=>{
            this.props.stateContainer.copy(this.props.simpleChoice.id).then((r2)=>{
                if (r2.resultType == "Ok") this.props.history.push(`/v/${r2.data.applicationFeatureId}/simplechoices/${r2.data.id}`);
            });
        });
    }
    getUserUtterances() {
        switch(this.props.values.choiceType){
            case "Yes":
                return [
                    {
                        id: "1",
                        content: "Yes",
                        highlights: []
                    },
                    {
                        id: "2",
                        content: "Yeah",
                        highlights: []
                    },
                    {
                        id: "3",
                        content: "Sure",
                        highlights: []
                    },
                    {
                        id: "4",
                        content: "Yes please",
                        highlights: []
                    },
                    {
                        id: "5",
                        content: "Uh huh",
                        highlights: []
                    }
                ];
            case "No":
                return [
                    {
                        id: "1",
                        content: "No",
                        highlights: []
                    },
                    {
                        id: "2",
                        content: "Nope",
                        highlights: []
                    },
                    {
                        id: "3",
                        content: "Nah",
                        highlights: []
                    },
                    {
                        id: "4",
                        content: "No thanks",
                        highlights: []
                    },
                    {
                        id: "5",
                        content: "Nuh uh",
                        highlights: []
                    }
                ];
        }
        return [];
    }
    handleOptionChange(option) {
        this.props.setFieldValue("choiceType", option.value);
    }
    getMenuTreeRoots() {
        var roots = [
            this.getContentInfoTreeItem(),
            {
                id: "user-says",
                title: "User-Says",
                isExpanded: this.isItemExpanded("user-says"),
                canExpand: true,
                icon: userIcon,
                linkTo: "#userSays",
                children: [
                    {
                        id: "phrases",
                        title: "Phrases",
                        canExpand: false,
                        icon: inputGroupIcon,
                        linkTo: "#Phrases"
                    }
                ]
            },
            ...this.getResponsesTreeItems(this.props.values.responses)
        ];
        return roots;
    }
    getContentItem() {
        return this.props.simpleChoice;
    }
    handleContentItemOptionSelected(option, event) {
        event.stopPropagation();
        if (option == "Manage Webhooks") this.showWebhookInstanceManager();
        else if (option == "Duplicate") this.handleCopy();
        else if (option == "Delete") this.handleDelete();
    }
    handleResponsesChange(responseGroups) {
        this.props.setFieldValue("responses", this.getResponsesFromGroups(responseGroups));
    }
    render() {
        const props = {
            ...this.props
        };
        const isLoading = props.stateContainer.state.isSaving;
        const isDisabled = isLoading || this.props.isTemplateOwned;
        const responseGroups = this.getResponseGroups(this.props.values.responses);
        const { simulatedResponseId } = this.state;
        if (this.props.responseStateContainer.state.isLoading || !this.props.application) return (0, _react.jsx)((0, _loaderDefault.default), null);
        return (0, _react.jsx)((0, _reactDefault.default).Fragment, null, (0, _react.jsx)("form", {
            onSubmit: props.handleSubmit
        }, (0, _react.jsx)((0, _dirtyFormPrompt.DirtyFormPrompt), {
            allowPrompt: props.status?.submitting != true
        }), (0, _react.jsx)((0, _contentPageDefault.default), {
            relatedContentRender: ()=>(0, _react.jsx)((0, _relatedContentMenuDefault.default), {
                    parentContentId: this.props.previousContentId,
                    conversationItem: {
                        ...this.props.simpleChoice,
                        featureTypeId: (0, _featureTypeIds.SimpleChoiceFeatureTypeId)
                    },
                    history: this.props.history,
                    featureTypeId: (0, _featureTypeIds.SimpleChoiceFeatureTypeId),
                    followUp: responseGroups?.[0]?.firstResponse?.followUp,
                    contentId: this.props.simpleChoice?.id,
                    onClose: this.props.onToggleNavigation,
                    onSave: this.handleAsyncSubmit.bind(this)
                }),
            treeRender: this.renderTree.bind(this),
            formPanelRender: ()=>(0, _react.jsx)((0, _pageContainerDefault.default), {
                    fill: true
                }, (0, _react.jsx)((0, _conversationItemActionButtonToolbarDefault.default), {
                    errors: Object.values(props.errors),
                    validateForm: props.validateForm,
                    publishDisabled: this.props.assistantApplication == null,
                    saveDisabled: Object.keys(props.errors).length > 0,
                    contentItem: props.simpleChoice,
                    isLoading: isLoading,
                    handleDiscardChanges: this.handleDiscardChanges.bind(this),
                    handlePublishing: this.handleSaveAndPublish.bind(this),
                    submitForm: props.submitForm
                }), props.simpleChoice?.createdFromId && (0, _react.jsx)((0, _templateLockedBannerDefault.default), {
                    isLoading: props.stateContainer.state.isTogglingSync,
                    isLinked: props.isTemplateOwned,
                    onRelink: this.handleToggleRelinkModal.bind(this),
                    onUnlink: ()=>this.props.onToggleSync(this.props.simpleChoice.id, true)
                }), (0, _react.jsx)((0, _conversationItemFieldSetDefault.default), {
                    disabled: isDisabled,
                    withBanner: props.simpleChoice?.createdFromId != null
                }, (0, _react.jsx)((0, _scrollablePanelBodyDefault.default), {
                    className: "scrollable-body"
                }, (0, _react.jsx)((0, _panelTitleDefault.default), {
                    title: "Content Editing",
                    detail: "Here’s where you can fill in the info about this content and determine the course of the conversation by filling in the relevant details."
                }), (0, _react.jsx)((0, _contentCollapsingSectionDefault.default), {
                    title: "Content Info",
                    id: "contentInfo",
                    icon: contentInfoIcon,
                    titleRightRowComponent: (0, _react.jsx)((0, _contentInfoOptionsDefault.default), {
                        webhookCount: this.props.stateContainer.state.webhookUpdates?.webhookInstances?.length ?? this.props.stateContainer.state.attachedWebhooks?.length ?? 0,
                        options: this.getOptions(this.props.simpleChoice != null),
                        optionSelected: this.handleContentItemOptionSelected.bind(this),
                        manageWebhooks: this.showWebhookInstanceManager.bind(this),
                        showSensitiveConversation: this.state.showSensitiveConversation,
                        toggleSensitiveConversation: ()=>{
                            this.toggleSensitiveConversation();
                        },
                        showDisabledForFeatures: this.state.showDisabledForFeatureFlags,
                        toggleDisabledForFeatures: ()=>{
                            this.toggleDisableForFeatureFlags();
                        },
                        flagsSelected: props.values.disabledForFeatureFlagIds?.length
                    })
                }, this.state.showSensitiveConversation && (0, _react.jsx)((0, _sensitiveDataOptionsDefault.default), {
                    selectedOption: props.values.sensitiveConversationChange ?? "None",
                    onChange: (value)=>{
                        props.setFieldValue("sensitiveConversationChange", value);
                    }
                }), this.state.showDisabledForFeatureFlags && (0, _react.jsx)((0, _disableForFeatureFlagOptionsDefault.default), {
                    appContainer: this.props.appContainer,
                    onChange: (value)=>{
                        props.setFieldValue("disabledForFeatureFlagIds", value);
                    },
                    selectedFeatureFlags: props.values.disabledForFeatureFlagIds
                }), (0, _react.jsx)((0, _contentSectionTitleDefault.default), {
                    title: "Simple Choice Conversation",
                    icon: (0, _extensions.getFeatureTypeIcon)((0, _featureTypeIds.SimpleChoiceFeatureTypeId), true)
                }), (0, _react.jsx)((0, _titleTextFieldDefault.default), {
                    id: "contentTitle",
                    disabled: isDisabled,
                    name: "title",
                    placeholder: "For display only",
                    value: props.values.title,
                    label: "Title",
                    onChange: props.handleChange,
                    onBlur: props.handleBlur
                }), (0, _react.jsx)((0, _contentLanguageMultiSelectorDefault.default), {
                    id: "contentLanguage",
                    disabled: isDisabled,
                    label: "Language / Region",
                    languages: props.application.languages,
                    selectedLanguageIds: props.values.languages.map((l)=>l.id),
                    onChange: this.handleLanguagesChange.bind(this)
                }), this.renderOptions(true, isDisabled)), (0, _react.jsx)((0, _contentCollapsingSectionDefault.default), {
                    title: "User Says",
                    icon: userIcon,
                    id: "userSays"
                }, (0, _react.jsx)((0, _contentCardDefault.default), {
                    title: "Phrases",
                    icon: inputGroupIcon,
                    id: "Phrases"
                }, (0, _react.jsx)((0, _formFieldsContainerDefault.default), null, (0, _react.jsx)((0, _detailLabelDefault.default), {
                    text: "Choose what type of response this belongs to"
                }), (0, _react.jsx)((0, _radioGroupDefault.default), {
                    onChange: this.handleOptionChange.bind(this),
                    value: this.props.values.choiceType,
                    disabled: isDisabled,
                    options: [
                        {
                            value: "Yes",
                            label: "Yes"
                        },
                        {
                            value: "No",
                            label: "No"
                        }
                    ]
                })))), (0, _react.jsx)((0, _responsesManagerDefault.default), {
                    applicationId: this.props.application.id,
                    applicationFeatureId: this.props.applicationFeatureId,
                    languages: this.props.values.languages,
                    responseGroups: responseGroups,
                    getConditionsKey: (c)=>this.getConditionsKey(c),
                    showError: this.showError.bind(this),
                    isDisabled: isDisabled,
                    onChange: this.handleResponsesChange.bind(this),
                    onBlur: this.props.handleBlur,
                    simulatedResponseId: simulatedResponseId,
                    responseIdToNamesRef: this.responseIdToNamesRef,
                    contentItemTitle: this.props.values.title
                }))), (0, _react.jsx)((0, _pageErrorDefault.default), {
                    errors: this.props?.stateContainer?.state?.errors ?? [],
                    onClear: this.handleClearError.bind(this)
                })),
            testCasesRender: ()=>(0, _react.jsx)((0, _contentItemTestCaseViewerDefault.default), {
                    application: this.props.application,
                    contentItemId: this.props.simpleChoice?.id,
                    getResponseId: this.handleResponseIdFromSim,
                    responseIdToNamesRef: this.responseIdToNamesRef
                })
        })), this.renderRelinkSyncWarning(), this.renderWebhookInstanceManager(this.props.application.id, this.props.simpleChoice?.id, (0, _featureTypeIds.SimpleChoiceFeatureTypeId), this.props.values.webhookChainingType));
    }
}
exports.default = SimpleChoiceForm;

},{"@babel/runtime/helpers/defineProperty":"9sJxO","@emotion/react":"djZKr","react":"6uln9","../../components/structure/ContentCard":"hJsdJ","../../components/general/DetailLabel":"j3EnX","../../components/structure/PageContainer":"hc1r8","../../components/structure/FormFieldsContainer":"h3hzh","../../components/forms/TitleTextField":"6fj1a","../followUpForm":"5HXc2","../../components/general/Loader":"bnV5T","../../components/forms/RadioGroup":"eiGrn","../../constants/featureTypeIds":"hPLMP","../../components/forms/ContentLanguageMultiSelector":"4SbwP","../contentPage":"6VyMV","../relatedContentMenu":"aWiMy","../../components/structure/ScrollablePanelBody":"6LRg3","../contentPage/components/PanelTitle":"anVUR","../../components/structure/ContentCollapsingSection":"1CUms","../contentPage/components/ContentSectionTitle":"5RGHr","../../models/extensions":"7h01B","../../components/general/PageError":"ezFTm","./components/ConversationItemActionButtonToolbar":"TGPQ9","../../components/general/TemplateLockedBanner":"gMkKq","../../components/forms/ConversationItemFieldSet":"8a3oA","../../components/structure/ContentInfoOptions":"6Ozsc","../responsesManager":"jtCYo","./components/DirtyFormPrompt":"i9WDI","../contentPage/components/SensitiveDataOptions":"oXWpd","../contentPage/components/DisableForFeatureFlagOptions":"67JXM","./ContentItemTestCaseViewer":"6EkXj","af0fc61d4b57b753":"5aXrZ","5ff0b8146ecabc3a":"fKr4T","ed40ad2056e86951":"a8FLc","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"kCKmE":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _unstated = require("unstated");
var _simpleChoiceContainer = require("../../state/containers/SimpleChoiceContainer");
var _simpleChoiceContainerDefault = parcelHelpers.interopDefault(_simpleChoiceContainer);
var _applicationContainer = require("../../state/containers/ApplicationContainer");
var _applicationContainerDefault = parcelHelpers.interopDefault(_applicationContainer);
var _titleStateContainer = require("../../state/containers/TitleStateContainer");
var _titleStateContainerDefault = parcelHelpers.interopDefault(_titleStateContainer);
var _repromptContainer = require("../../state/containers/RepromptContainer");
var _repromptContainerDefault = parcelHelpers.interopDefault(_repromptContainer);
var _followUpContainer = require("../../state/containers/FollowUpContainer");
var _followUpContainerDefault = parcelHelpers.interopDefault(_followUpContainer);
var _mediaResponseContainer = require("../../state/containers/MediaResponseContainer");
var _mediaResponseContainerDefault = parcelHelpers.interopDefault(_mediaResponseContainer);
var _editSimpleChoiceForm = require("./components/EditSimpleChoiceForm");
var _editSimpleChoiceFormDefault = parcelHelpers.interopDefault(_editSimpleChoiceForm);
var _genericEditContentItemPage = require("../formScenes/GenericEditContentItemPage");
var _genericEditContentItemPageDefault = parcelHelpers.interopDefault(_genericEditContentItemPage);
var _featureContainer = require("../../state/containers/FeatureContainer");
var _featureContainerDefault = parcelHelpers.interopDefault(_featureContainer);
var _featureTypeIds = require("../../constants/featureTypeIds");
var _queryString = require("query-string");
var _queryStringDefault = parcelHelpers.interopDefault(_queryString);
var _applicationEnvironmentsContainer = require("../../state/containers/ApplicationEnvironmentsContainer");
var _applicationEnvironmentsContainerDefault = parcelHelpers.interopDefault(_applicationEnvironmentsContainer);
var _applicationBackupVersionsContainer = require("../../state/containers/ApplicationBackupVersionsContainer");
var _applicationBackupVersionsContainerDefault = parcelHelpers.interopDefault(_applicationBackupVersionsContainer);
class EditSimpleChoices extends (0, _reactDefault.default).Component {
    render() {
        return (0, _react.jsx)((0, _unstated.Subscribe), {
            key: this.props.match.params.simpleChoiceId + this.props.match.params.applicationFeatureId,
            to: [
                (0, _simpleChoiceContainerDefault.default),
                (0, _applicationContainerDefault.default),
                (0, _titleStateContainerDefault.default),
                (0, _repromptContainerDefault.default),
                (0, _followUpContainerDefault.default),
                (0, _mediaResponseContainerDefault.default),
                (0, _featureContainerDefault.default),
                (0, _applicationEnvironmentsContainerDefault.default),
                (0, _applicationBackupVersionsContainerDefault.default)
            ]
        }, (simpleChoiceContainer, appContainer, titleContainer, repromptContainer, followUpContainer, responseContainer, featureContainer, environmentsContainer, backupsContainer)=>{
            return (0, _react.jsx)((0, _genericEditContentItemPageDefault.default), {
                stateContainer: simpleChoiceContainer,
                environmentsContainer: environmentsContainer,
                backupsContainer: backupsContainer,
                titleContainer: titleContainer,
                applicationContainer: appContainer,
                defaultTitle: "Edit Simple Choice",
                contentItemId: this.props.match.params.simpleChoiceId,
                history: this.props.history,
                location: this.props.location,
                match: this.props.match,
                staticContext: this.props.staticContext,
                featureContainer: featureContainer,
                featureTypeId: (0, _featureTypeIds.SimpleChoiceFeatureTypeId),
                formRender: (contentItem, application, isTemplateOwned, assistantApplication, onShowPublishModal, onSubmit, toggleSync, onAccessTypeChange)=>(0, _react.jsx)((0, _editSimpleChoiceFormDefault.default), {
                        location: this.props.location,
                        applicationFeatureId: this.props.match.params.applicationFeatureId,
                        application: application,
                        simpleChoice: contentItem,
                        stateContainer: simpleChoiceContainer,
                        repromptContainer: repromptContainer,
                        followUpContainer: followUpContainer,
                        appContainer: appContainer,
                        responseStateContainer: responseContainer,
                        featureContainer: featureContainer,
                        assistantApplication: assistantApplication,
                        onShowPublishModal: onShowPublishModal,
                        onAccessTypeChange: onAccessTypeChange,
                        onSubmit: onSubmit,
                        onToggleSync: toggleSync,
                        previousContentId: (0, _queryStringDefault.default)?.parse(this.props.location.search)?.previousContentId,
                        history: this.props.history,
                        isSaving: simpleChoiceContainer.state.isSaving,
                        isTemplateOwned: isTemplateOwned
                    })
            });
        });
    }
}
exports.default = EditSimpleChoices;

},{"@emotion/react":"djZKr","react":"6uln9","unstated":"grh7p","../../state/containers/SimpleChoiceContainer":"hO0x5","../../state/containers/ApplicationContainer":"cuqi2","../../state/containers/TitleStateContainer":"2osOD","../../state/containers/RepromptContainer":"5vKMV","../../state/containers/FollowUpContainer":"rm9OA","../../state/containers/MediaResponseContainer":"1ccrV","./components/EditSimpleChoiceForm":"gT8bm","../formScenes/GenericEditContentItemPage":"6RzEJ","../../state/containers/FeatureContainer":"4ApGg","../../constants/featureTypeIds":"hPLMP","query-string":"klvAV","../../state/containers/ApplicationEnvironmentsContainer":"jCULY","../../state/containers/ApplicationBackupVersionsContainer":"6rA1P","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"gT8bm":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _formik = require("formik");
var _yup = require("yup");
var _simpleChoiceForm = require("../../formScenes/SimpleChoiceForm");
var _simpleChoiceFormDefault = parcelHelpers.interopDefault(_simpleChoiceForm);
const EditSimpleChoiceForm = (0, _formik.withFormik)({
    mapPropsToValues: (props)=>{
        var values = {
            title: props.simpleChoice.title,
            choiceType: props.simpleChoice.choiceType,
            responses: props.simpleChoice.responses.length > 0 ? props.simpleChoice.responses : [
                {
                    content: ""
                }
            ],
            requiresParent: true,
            languages: props.simpleChoice.languages,
            isLive: props.simpleChoice.isLive,
            webhookChainingType: props.simpleChoice.webhookChainingType,
            sensitiveConversationChange: props.simpleChoice.sensitiveConversationChange ?? "None",
            disabledForFeatureFlagIds: props.simpleChoice?.disabledForFeatureFlagIds
        };
        return values;
    },
    validateOnMount: true,
    validationSchema: _yup.object().shape({
        title: _yup.string().required("You must enter a title"),
        responses: _yup.array().of(_yup.object().shape({
            content: _yup.string().required("You must enter a response variation")
        })).required("You must enter at least 1 response variation").min(1, "You must enter at least 1 response variation")
    }),
    handleSubmit: (values, { props, setStatus })=>{
        setStatus({
            submitting: true
        });
        return props.onSubmit(props.stateContainer.mapFormDataToModel(props.simpleChoice, values));
    }
})((0, _simpleChoiceFormDefault.default));
exports.default = EditSimpleChoiceForm;

},{"formik":"3YnOK","yup":"j2SJU","../../formScenes/SimpleChoiceForm":"3TwBK","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"knHb3":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _unstated = require("unstated");
var _customRequestContainer = require("../../state/containers/CustomRequestContainer");
var _customRequestContainerDefault = parcelHelpers.interopDefault(_customRequestContainer);
var _customRequestContentForm = require("./components/CustomRequestContentForm");
var _customRequestContentFormDefault = parcelHelpers.interopDefault(_customRequestContentForm);
var _applicationContainer = require("../../state/containers/ApplicationContainer");
var _applicationContainerDefault = parcelHelpers.interopDefault(_applicationContainer);
var _titleStateContainer = require("../../state/containers/TitleStateContainer");
var _titleStateContainerDefault = parcelHelpers.interopDefault(_titleStateContainer);
var _repromptContainer = require("../../state/containers/RepromptContainer");
var _repromptContainerDefault = parcelHelpers.interopDefault(_repromptContainer);
var _followUpContainer = require("../../state/containers/FollowUpContainer");
var _followUpContainerDefault = parcelHelpers.interopDefault(_followUpContainer);
var _mediaResponseContainer = require("../../state/containers/MediaResponseContainer");
var _mediaResponseContainerDefault = parcelHelpers.interopDefault(_mediaResponseContainer);
var _navigationBarFormPage = require("../formScenes/NavigationBarFormPage");
var _navigationBarFormPageDefault = parcelHelpers.interopDefault(_navigationBarFormPage);
var _genericCreateContentItemPage = require("../formScenes/GenericCreateContentItemPage");
var _genericCreateContentItemPageDefault = parcelHelpers.interopDefault(_genericCreateContentItemPage);
var _featureContainer = require("../../state/containers/FeatureContainer");
var _featureContainerDefault = parcelHelpers.interopDefault(_featureContainer);
var _featureTypeIds = require("../../constants/featureTypeIds");
class CreateCustomRequest extends (0, _navigationBarFormPageDefault.default) {
    render() {
        return (0, _react.jsx)((0, _unstated.Subscribe), {
            to: [
                (0, _customRequestContainerDefault.default),
                (0, _applicationContainerDefault.default),
                (0, _titleStateContainerDefault.default),
                (0, _repromptContainerDefault.default),
                (0, _followUpContainerDefault.default),
                (0, _mediaResponseContainerDefault.default),
                (0, _featureContainerDefault.default)
            ]
        }, (customRequestContainer, appContainer, titleContainer, repromptContainer, followUpContainer, responseStateContainer, featureContainer)=>{
            return (0, _react.jsx)((0, _genericCreateContentItemPageDefault.default), {
                stateContainer: customRequestContainer,
                titleContainer: titleContainer,
                applicationContainer: appContainer,
                defaultTitle: "New Custom Request",
                history: this.props.history,
                location: this.props.location,
                match: this.props.match,
                staticContext: this.props.staticContext,
                featureContainer: featureContainer,
                featureTypeId: (0, _featureTypeIds.CustomRequestsFeatureTypeId),
                formRender: (application, assistantApplication, onPublish, onSubmit, onAccessTypeChange)=>(0, _react.jsx)((0, _customRequestContentFormDefault.default), {
                        location: this.props.location,
                        applicationFeatureId: this.props.match.params.applicationFeatureId,
                        application: application,
                        stateContainer: customRequestContainer,
                        assistantApplication: assistantApplication,
                        appContainer: appContainer,
                        repromptContainer: repromptContainer,
                        followUpContainer: followUpContainer,
                        responseStateContainer: responseStateContainer,
                        history: this.props.history,
                        isSaving: customRequestContainer.state.isSaving,
                        onAccessTypeChange: onAccessTypeChange,
                        onShowPublishModal: onPublish,
                        featureContainer: featureContainer,
                        onSubmit: onSubmit,
                        isTemplateOwned: false,
                        onToggleSync: null
                    })
            });
        });
    }
}
exports.default = CreateCustomRequest;

},{"@emotion/react":"djZKr","react":"6uln9","unstated":"grh7p","../../state/containers/CustomRequestContainer":"aVO05","./components/CustomRequestContentForm":"4Udsy","../../state/containers/ApplicationContainer":"cuqi2","../../state/containers/TitleStateContainer":"2osOD","../../state/containers/RepromptContainer":"5vKMV","../../state/containers/FollowUpContainer":"rm9OA","../../state/containers/MediaResponseContainer":"1ccrV","../formScenes/NavigationBarFormPage":"4ZcAE","../formScenes/GenericCreateContentItemPage":"dUUA3","../../state/containers/FeatureContainer":"4ApGg","../../constants/featureTypeIds":"hPLMP","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4Udsy":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _formik = require("formik");
var _yup = require("yup");
var _customRequestForm = require("../../formScenes/CustomRequestForm");
var _customRequestFormDefault = parcelHelpers.interopDefault(_customRequestForm);
const CustomRequestContentForm = (0, _formik.withFormik)({
    mapPropsToValues: (props)=>({
            title: "Untitled Custom Request",
            requestTypes: "",
            requestNames: "",
            platformFilter: "",
            responses: [
                {
                    content: ""
                }
            ],
            followUpSelection: "end",
            repromptSelection: "end",
            entryType: "open",
            requiresParent: false,
            sensitiveConversationChange: "None",
            isLive: true,
            languages: props.application?.languages.find((l)=>l.id == props.application?.defaultLanguageId) ? [
                props.application?.languages.find((l)=>l.id == props.application?.defaultLanguageId)
            ] : [],
            webhookChainingType: "NoChaining",
            alwaysOpen: false
        }),
    validationSchema: _yup.object().shape({
        title: _yup.string().required("You must enter a title"),
        responses: _yup.array().of(_yup.object().shape({
            content: _yup.string().required("You must enter a response variation")
        })).required("You must enter at least 1 response variation").min(1, "You must enter at least 1 response variation"),
        requestTypes: _yup.string(),
        requestNames: _yup.string().when("requestTypes", {
            is: (val)=>{
                return !val;
            },
            then: _yup.string().required("You must enter at least one request name or request type"),
            otherwise: _yup.string()
        })
    }),
    validateOnMount: true,
    handleSubmit: (values, { props, setStatus, setFieldValue })=>{
        setStatus({
            submitting: true
        });
        return props.onSubmit(props.stateContainer.mapFormDataToModel({
            applicationFeatureId: props.applicationFeatureId,
            applicationId: props.application?.id,
            responses: []
        }, values));
    }
})((0, _customRequestFormDefault.default));
exports.default = CustomRequestContentForm;

},{"formik":"3YnOK","yup":"j2SJU","../../formScenes/CustomRequestForm":"a4b82","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"a4b82":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _defineProperty = require("@babel/runtime/helpers/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _contentLanguageMultiSelector = require("../../components/forms/ContentLanguageMultiSelector");
var _contentLanguageMultiSelectorDefault = parcelHelpers.interopDefault(_contentLanguageMultiSelector);
var _titleTextField = require("../../components/forms/TitleTextField");
var _titleTextFieldDefault = parcelHelpers.interopDefault(_titleTextField);
var _loader = require("../../components/general/Loader");
var _loaderDefault = parcelHelpers.interopDefault(_loader);
var _contentCollapsingSection = require("../../components/structure/ContentCollapsingSection");
var _contentCollapsingSectionDefault = parcelHelpers.interopDefault(_contentCollapsingSection);
var _pageContainer = require("../../components/structure/PageContainer");
var _pageContainerDefault = parcelHelpers.interopDefault(_pageContainer);
var _scrollablePanelBody = require("../../components/structure/ScrollablePanelBody");
var _scrollablePanelBodyDefault = parcelHelpers.interopDefault(_scrollablePanelBody);
var _featureTypeIds = require("../../constants/featureTypeIds");
var _extensions = require("../../models/extensions");
var _contentPage = require("../contentPage");
var _contentPageDefault = parcelHelpers.interopDefault(_contentPage);
var _contentSectionTitle = require("../contentPage/components/ContentSectionTitle");
var _contentSectionTitleDefault = parcelHelpers.interopDefault(_contentSectionTitle);
var _panelTitle = require("../contentPage/components/PanelTitle");
var _panelTitleDefault = parcelHelpers.interopDefault(_panelTitle);
var _followUpForm = require("../followUpForm");
var _followUpFormDefault = parcelHelpers.interopDefault(_followUpForm);
var _relatedContentMenu = require("../relatedContentMenu");
var _relatedContentMenuDefault = parcelHelpers.interopDefault(_relatedContentMenu);
var _pageError = require("../../components/general/PageError");
var _pageErrorDefault = parcelHelpers.interopDefault(_pageError);
var _conversationItemActionButtonToolbar = require("./components/ConversationItemActionButtonToolbar");
var _conversationItemActionButtonToolbarDefault = parcelHelpers.interopDefault(_conversationItemActionButtonToolbar);
var _templateLockedBanner = require("../../components/general/TemplateLockedBanner");
var _templateLockedBannerDefault = parcelHelpers.interopDefault(_templateLockedBanner);
var _conversationItemFieldSet = require("../../components/forms/ConversationItemFieldSet");
var _conversationItemFieldSetDefault = parcelHelpers.interopDefault(_conversationItemFieldSet);
var _contentInfoOptions = require("../../components/structure/ContentInfoOptions");
var _contentInfoOptionsDefault = parcelHelpers.interopDefault(_contentInfoOptions);
var _responsesManager = require("../responsesManager");
var _responsesManagerDefault = parcelHelpers.interopDefault(_responsesManager);
var _dirtyFormPrompt = require("./components/DirtyFormPrompt");
var _customRequestInputOptions = require("./components/CustomRequestInputOptions");
var _customRequestInputOptionsDefault = parcelHelpers.interopDefault(_customRequestInputOptions);
var _sensitiveDataOptions = require("../contentPage/components/SensitiveDataOptions");
var _sensitiveDataOptionsDefault = parcelHelpers.interopDefault(_sensitiveDataOptions);
var _disableForFeatureFlagOptions = require("../contentPage/components/DisableForFeatureFlagOptions");
var _disableForFeatureFlagOptionsDefault = parcelHelpers.interopDefault(_disableForFeatureFlagOptions);
var _contentItemTestCaseViewer = require("./ContentItemTestCaseViewer");
var _contentItemTestCaseViewerDefault = parcelHelpers.interopDefault(_contentItemTestCaseViewer);
const userIcon = require("95af8e77047f36f5");
const contentInfoIcon = require("c1b7b946e2311a06");
const inputGroupIcon = require("6983054d6472ce82");
const inputIcon = require("3af0e3ca0b82949a");
class CustomRequestForm extends (0, _followUpFormDefault.default) {
    constructor(...args){
        super(...args);
        (0, _definePropertyDefault.default)(this, "handleResponseIdFromSim", (id)=>{
            this.setState({
                simulatedResponseId: id
            });
        });
    }
    componentDidUpdate(prevProps, prevState) {
        super.componentDidUpdate(prevProps, prevState);
    }
    handleAsyncSubmit(onSuccess) {
        if (this.props.onSubmit && this.manualValidate()) return this.props.onSubmit(this.props.stateContainer.mapFormDataToModel(this.props.customRequest, this.props.values), onSuccess);
    }
    handleDiscardChanges() {
        this.handleFinish();
    }
    handleDelete() {
        const confirmed = confirm("Are you sure you want to delete this?");
        if (confirmed) this.props.stateContainer.delete(this.props.customRequest.id).then((result)=>{
            this.handleFinish();
        });
    }
    handleCopy() {
        this.handleAsyncSubmit(()=>{
            this.props.stateContainer.copy(this.props.customRequest.id).then((r2)=>{
                if (r2.resultType == "Ok") this.props.history.push(`/v/${r2.data.applicationFeatureId}/customrequests/${r2.data.id}`);
            });
        });
    }
    getMenuTreeRoots() {
        var roots = [
            this.getContentInfoTreeItem(),
            {
                id: "input-details",
                title: "Input Requirements",
                isExpanded: this.isItemExpanded("input-details"),
                canExpand: true,
                icon: userIcon,
                linkTo: "#input",
                children: [
                    {
                        id: "input-options",
                        title: "Intents and Events",
                        canExpand: true,
                        isExpanded: this.isItemExpanded("input-options"),
                        icon: inputGroupIcon,
                        linkTo: "#inputOptions",
                        children: [
                            {
                                id: "requestTypes",
                                title: "Request Types",
                                canExpand: false,
                                icon: inputIcon,
                                linkTo: "#requestTypes"
                            },
                            {
                                id: "requestNames",
                                title: "Request Names",
                                canExpand: false,
                                icon: inputIcon,
                                linkTo: "#requestNames"
                            },
                            {
                                id: "platforms",
                                title: "Platforms",
                                canExpand: false,
                                icon: inputIcon,
                                linkTo: "#platforms"
                            }
                        ]
                    }
                ]
            },
            ...this.getResponsesTreeItems(this.props.values.responses)
        ];
        return roots;
    }
    handleResponsesChange(responseGroups) {
        this.props.setFieldValue("responses", this.getResponsesFromGroups(responseGroups));
    }
    getContentItem() {
        return this.props.customRequest;
    }
    handleContentItemOptionSelected(option, event) {
        event.stopPropagation();
        if (option == "Manage Webhooks") this.showWebhookInstanceManager();
        else if (option == "Duplicate") this.handleCopy();
        else if (option == "Delete") this.handleDelete();
    }
    handleUpdateInputValues(requstNames, requestTypes, platformFilter) {
        this.props.setFieldValue("requestNames", requstNames);
        this.props.setFieldValue("requestTypes", requestTypes);
        this.props.setFieldValue("platformFilter", platformFilter);
    }
    render() {
        const props = {
            ...this.props
        };
        const isLoading = props.stateContainer.state.isSaving;
        const isDisabled = isLoading || this.props.isTemplateOwned;
        const responseGroups = this.getResponseGroups(this.props.values.responses);
        const { simulatedResponseId } = this.state;
        if (this.props.responseStateContainer.state.isLoading || !this.props.application) return (0, _react.jsx)((0, _loaderDefault.default), null);
        return (0, _react.jsx)((0, _reactDefault.default).Fragment, null, (0, _react.jsx)("form", {
            onSubmit: props.handleSubmit
        }, (0, _react.jsx)((0, _dirtyFormPrompt.DirtyFormPrompt), {
            allowPrompt: props.status?.submitting != true
        }), (0, _react.jsx)((0, _contentPageDefault.default), {
            relatedContentRender: ()=>(0, _react.jsx)((0, _relatedContentMenuDefault.default), {
                    parentContentId: this.props.previousContentId,
                    conversationItem: {
                        ...this.props.customRequest,
                        featureTypeId: (0, _featureTypeIds.CustomRequestsFeatureTypeId)
                    },
                    history: this.props.history,
                    featureTypeId: (0, _featureTypeIds.CustomRequestsFeatureTypeId),
                    followUp: responseGroups?.[0]?.firstResponse?.followUp,
                    contentId: this.props.customRequest?.id,
                    onClose: this.props.onToggleNavigation,
                    onSave: this.handleAsyncSubmit.bind(this)
                }),
            treeRender: this.renderTree.bind(this),
            formPanelRender: ()=>(0, _react.jsx)((0, _pageContainerDefault.default), {
                    fill: true
                }, (0, _react.jsx)((0, _conversationItemActionButtonToolbarDefault.default), {
                    errors: Object.values(props.errors),
                    validateForm: props.validateForm,
                    publishDisabled: this.props.assistantApplication == null,
                    saveDisabled: Object.keys(props.errors).length > 0,
                    contentItem: props.customRequest,
                    isLoading: isLoading,
                    handleDiscardChanges: this.handleDiscardChanges.bind(this),
                    handlePublishing: this.handleSaveAndPublish.bind(this),
                    submitForm: props.submitForm
                }), props.customRequest?.createdFromId && (0, _react.jsx)((0, _templateLockedBannerDefault.default), {
                    isLoading: props.stateContainer.state.isTogglingSync,
                    isLinked: props.isTemplateOwned,
                    onRelink: this.handleToggleRelinkModal.bind(this),
                    onUnlink: ()=>this.props.onToggleSync(this.props.customRequest.id, true)
                }), (0, _react.jsx)((0, _conversationItemFieldSetDefault.default), {
                    disabled: isDisabled,
                    withBanner: props.customRequest?.createdFromId != null
                }, (0, _react.jsx)((0, _scrollablePanelBodyDefault.default), {
                    className: "scrollable-body"
                }, (0, _react.jsx)((0, _panelTitleDefault.default), {
                    title: "Content Editing",
                    detail: "Here’s where you can fill in the info about this content and determine the course of the conversation by filling in the relevant details."
                }), (0, _react.jsx)((0, _contentCollapsingSectionDefault.default), {
                    title: "Content Info",
                    id: "contentInfo",
                    icon: contentInfoIcon,
                    titleRightRowComponent: (0, _react.jsx)((0, _contentInfoOptionsDefault.default), {
                        webhookCount: this.props.stateContainer.state.webhookUpdates?.webhookInstances?.length ?? this.props.stateContainer.state.attachedWebhooks?.length ?? 0,
                        options: this.getOptions(this.props.customRequest != null),
                        optionSelected: this.handleContentItemOptionSelected.bind(this),
                        manageWebhooks: this.showWebhookInstanceManager.bind(this),
                        showSensitiveConversation: this.state.showSensitiveConversation,
                        toggleSensitiveConversation: ()=>{
                            this.toggleSensitiveConversation();
                        },
                        showDisabledForFeatures: this.state.showDisabledForFeatureFlags,
                        toggleDisabledForFeatures: ()=>{
                            this.toggleDisableForFeatureFlags();
                        },
                        flagsSelected: props.values.disabledForFeatureFlagIds?.length
                    })
                }, this.state.showSensitiveConversation && (0, _react.jsx)((0, _sensitiveDataOptionsDefault.default), {
                    selectedOption: props.values.sensitiveConversationChange ?? "None",
                    onChange: (value)=>{
                        props.setFieldValue("sensitiveConversationChange", value);
                    }
                }), this.state.showDisabledForFeatureFlags && (0, _react.jsx)((0, _disableForFeatureFlagOptionsDefault.default), {
                    appContainer: this.props.appContainer,
                    onChange: (value)=>{
                        props.setFieldValue("disabledForFeatureFlagIds", value);
                    },
                    selectedFeatureFlags: props.values.disabledForFeatureFlagIds
                }), (0, _react.jsx)((0, _contentSectionTitleDefault.default), {
                    title: "Custom Request Conversation",
                    icon: (0, _extensions.getFeatureTypeIcon)((0, _featureTypeIds.CustomRequestsFeatureTypeId), true)
                }), (0, _react.jsx)((0, _titleTextFieldDefault.default), {
                    id: "contentTitle",
                    disabled: isDisabled,
                    name: "title",
                    placeholder: "For display only",
                    value: props.values.title,
                    label: "Title",
                    onChange: props.handleChange,
                    onBlur: props.handleBlur
                }), (0, _react.jsx)((0, _contentLanguageMultiSelectorDefault.default), {
                    disabled: isDisabled,
                    id: "contentLanguage",
                    label: "Language / Region",
                    languages: props.application.languages,
                    selectedLanguageIds: props.values.languages.map((l)=>l.id),
                    onChange: this.handleLanguagesChange.bind(this)
                }), this.renderOptions(false, isDisabled, false, true)), (0, _react.jsx)((0, _customRequestInputOptionsDefault.default), {
                    appContainer: this.props.appContainer,
                    isDisabled: isDisabled,
                    updateValues: this.handleUpdateInputValues.bind(this),
                    languages: this.props.values.languages,
                    requestNames: this.props.values.requestNames,
                    requestTypes: this.props.values.requestTypes,
                    platformFilter: this.props.values.platformFilter,
                    onBlur: this.props.handleBlur,
                    setFieldValue: this.props.setFieldValue,
                    onChange: this.props.handleChange,
                    application: this.props.application
                }), (0, _react.jsx)((0, _responsesManagerDefault.default), {
                    applicationId: this.props.application.id,
                    applicationFeatureId: this.props.applicationFeatureId,
                    languages: this.props.values.languages,
                    responseGroups: responseGroups,
                    getConditionsKey: (c)=>this.getConditionsKey(c),
                    showError: this.showError.bind(this),
                    isDisabled: isDisabled,
                    onChange: this.handleResponsesChange.bind(this),
                    onBlur: this.props.handleBlur,
                    simulatedResponseId: simulatedResponseId,
                    responseIdToNamesRef: this.responseIdToNamesRef,
                    contentItemTitle: this.props.values.title
                }))), (0, _react.jsx)((0, _pageErrorDefault.default), {
                    errors: this.props?.stateContainer?.state?.errors ?? [],
                    onClear: this.handleClearError.bind(this)
                })),
            testCasesRender: ()=>(0, _react.jsx)((0, _contentItemTestCaseViewerDefault.default), {
                    application: this.props.application,
                    contentItemId: this.props.customRequest?.id,
                    getResponseId: this.handleResponseIdFromSim,
                    responseIdToNamesRef: this.responseIdToNamesRef
                })
        })), this.renderRelinkSyncWarning(), this.renderWebhookInstanceManager(this.props.application.id, this.props.customRequest?.id, (0, _featureTypeIds.CustomRequestsFeatureTypeId), this.props.values?.webhookChainingType));
    }
}
exports.default = CustomRequestForm;

},{"@babel/runtime/helpers/defineProperty":"9sJxO","@emotion/react":"djZKr","react":"6uln9","../../components/forms/ContentLanguageMultiSelector":"4SbwP","../../components/forms/TitleTextField":"6fj1a","../../components/general/Loader":"bnV5T","../../components/structure/ContentCollapsingSection":"1CUms","../../components/structure/PageContainer":"hc1r8","../../components/structure/ScrollablePanelBody":"6LRg3","../../constants/featureTypeIds":"hPLMP","../../models/extensions":"7h01B","../contentPage":"6VyMV","../contentPage/components/ContentSectionTitle":"5RGHr","../contentPage/components/PanelTitle":"anVUR","../followUpForm":"5HXc2","../relatedContentMenu":"aWiMy","../../components/general/PageError":"ezFTm","./components/ConversationItemActionButtonToolbar":"TGPQ9","../../components/general/TemplateLockedBanner":"gMkKq","../../components/forms/ConversationItemFieldSet":"8a3oA","../../components/structure/ContentInfoOptions":"6Ozsc","../responsesManager":"jtCYo","./components/DirtyFormPrompt":"i9WDI","./components/CustomRequestInputOptions":"8AGsW","../contentPage/components/SensitiveDataOptions":"oXWpd","../contentPage/components/DisableForFeatureFlagOptions":"67JXM","./ContentItemTestCaseViewer":"6EkXj","95af8e77047f36f5":"fM7ms","c1b7b946e2311a06":"fKr4T","6983054d6472ce82":"a8FLc","3af0e3ca0b82949a":"iZ56c","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8AGsW":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _extends = require("@babel/runtime/helpers/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _base = require("@emotion/styled/base");
var _baseDefault = parcelHelpers.interopDefault(_base);
var _react = require("@emotion/react");
var _css = require("@emotion/css");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _fieldError = require("../../../components/forms/FieldError");
var _fieldErrorDefault = parcelHelpers.interopDefault(_fieldError);
var _intentSelector = require("./IntentSelector");
var _intentSelectorDefault = parcelHelpers.interopDefault(_intentSelector);
var _selectField = require("../../../components/forms/SelectField");
var _selectFieldDefault = parcelHelpers.interopDefault(_selectField);
var _textField = require("../../../components/forms/TextField");
var _textFieldDefault = parcelHelpers.interopDefault(_textField);
var _loader = require("../../../components/general/Loader");
var _loaderDefault = parcelHelpers.interopDefault(_loader);
var _textOverflowMenu = require("../../../components/general/overflowMenu/TextOverflowMenu");
var _textOverflowMenuDefault = parcelHelpers.interopDefault(_textOverflowMenu);
var _toggleIndicator = require("../../../components/general/ToggleIndicator");
var _toggleIndicatorDefault = parcelHelpers.interopDefault(_toggleIndicator);
var _contentCard = require("../../../components/structure/ContentCard");
var _contentCardDefault = parcelHelpers.interopDefault(_contentCard);
var _contentCollapsingSection = require("../../../components/structure/ContentCollapsingSection");
var _contentCollapsingSectionDefault = parcelHelpers.interopDefault(_contentCollapsingSection);
var _formFieldsContainer = require("../../../components/structure/FormFieldsContainer");
var _formFieldsContainerDefault = parcelHelpers.interopDefault(_formFieldsContainer);
var _colors = require("../../../constants/colors");
var _applicationNlpEntityContainer = require("../../../hooks/ApplicationNlpEntityContainer");
var _applicationNlpEntityContainerDefault = parcelHelpers.interopDefault(_applicationNlpEntityContainer);
var _interactionModelContainer = require("../../../hooks/InteractionModelContainer");
var _interactionModelContainerDefault = parcelHelpers.interopDefault(_interactionModelContainer);
var _intentItem = require("../../interactionModel/components/IntentItem");
var _intentItemDefault = parcelHelpers.interopDefault(_intentItem);
var _interactionModelForm = require("../../interactionModel/components/InteractionModelForm");
var _platforms = require("../../../constants/platforms");
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const userIcon = require("26f7544be1913523");
const inputGroupIcon = require("2990bda00f7b0ea4");
const deleteIcon = require("6216a8a085fc019b");
const CustomRequestInputOptions = (props)=>{
    const [showIntentEditor, setShowIntentEditor] = (0, _react1.useState)(false);
    const [interactionModel, setInteractionModel] = (0, _react1.useState)({});
    const [nlpEntities, setNlpEntities] = (0, _react1.useState)([]);
    const [isAddingIntent, setIsAddingIntent] = (0, _react1.useState)(false);
    const [showPlatforms, setShowPlatforms] = (0, _react1.useState)(false);
    const [loaded, setLoaded] = (0, _react1.useState)(false);
    const [initialNlpLoadComplete, setInitialNlpLoadComplete] = (0, _react1.useState)(false);
    const [editingIntentIndex, setEditingIntentIndex] = (0, _react1.useState)(null);
    const [selectedRequestTypeOption, setSelectedRequestTypeOption] = (0, _react1.useState)("Intent");
    // state that tracks requestNames
    const [selectedIntents, setSelectedIntents] = (0, _react1.useState)([]);
    // state that tracks platformFilter
    const [platforms, setPlatforms] = (0, _react1.useState)([]);
    const interactionModelContainer = (0, _interactionModelContainerDefault.default).useContainer();
    const nlpEntitiesContainer = (0, _applicationNlpEntityContainerDefault.default).useContainer();
    (0, _react1.useEffect)(()=>{
        load();
    }, []);
    const load = async ()=>{
        const promises = [];
        promises.push(nlpEntitiesContainer.getApplicationNlpEntities(props.application?.id, props.languages));
        promises.push(interactionModelContainer.loadInteractionModels(props.application?.id, props.languages));
        await Promise.all(promises);
        setInitialNlpLoadComplete(true);
    };
    (0, _react1.useEffect)(()=>{
        if (!loaded && initialNlpLoadComplete && !interactionModelContainer.isLoading && !nlpEntitiesContainer.isLoading && nlpEntitiesContainer.currentApplicationId === props.application?.id && interactionModelContainer.currentApplicationId === props.application?.id) {
            if (props.requestTypes) setSelectedRequestTypeOption("Custom");
            if (props.requestNames) mapRequestNamesToSelectedIntents(props.requestNames);
            if (props.platformFilter) {
                const platformArray = props.platformFilter.split(",") ?? [];
                const newPlatforms = [];
                for(let i = 0; i < platformArray.length; ++i){
                    const platform = platformArray[i];
                    if (platform === "GoogleAssistant" || platform === "Alexa") newPlatforms.push({
                        option: platform,
                        platform: platform
                    });
                    else newPlatforms.push({
                        option: "custom",
                        platform: platform
                    });
                }
                setPlatforms(newPlatforms);
            }
            setLoaded(true);
        }
    }, [
        interactionModel,
        nlpEntitiesContainer.currentApplicationId,
        interactionModelContainer.currentApplicationId,
        interactionModelContainer.isLoading,
        nlpEntitiesContainer.isLoading,
        initialNlpLoadComplete
    ]);
    const mapRequestNamesToSelectedIntents = (requestNames)=>{
        const newSelectedIntents = [];
        let requestNameArray = requestNames.split(",") ?? [];
        requestNameArray = requestNameArray.map((s)=>s.trim());
        const intents = Object.entries(interactionModel);
        for(let i = 0; i < requestNameArray.length; ++i){
            const requestName = requestNameArray[i];
            const idMatches = intents?.find((entry)=>entry[1].locales.some((l)=>l.intentId === requestName));
            const intentById = idMatches ? idMatches[1] : null;
            const nameMatches = intents?.find((entry)=>entry[1].name[0, _platforms.PLATFORM_VOICIFY] === requestName || entry[1].displayName === requestName);
            const intentByName = nameMatches ? nameMatches[1] : null;
            if (intentById && intentById.isCustom) {
                // For custom intents we capture intent id in requestNames
                const intentToMap = {
                    intent: intentById,
                    isUsingExternalIntent: false,
                    externalIntent: "",
                    ids: ""
                };
                newSelectedIntents.push(intentToMap);
            } else if (intentByName && !intentByName?.isCustom) {
                // For prebuilt intents we capture intent's name in requestNames
                const intentToMap = {
                    intent: intentByName,
                    isUsingExternalIntent: false,
                    externalIntent: "",
                    ids: ""
                };
                newSelectedIntents.push(intentToMap);
            } else {
                const intentToMap = {
                    intent: null,
                    isUsingExternalIntent: true,
                    externalIntent: requestName,
                    ids: ""
                };
                newSelectedIntents.push(intentToMap);
            }
        }
        if (!newSelectedIntents.length) newSelectedIntents.push({
            intent: null,
            isUsingExternalIntent: false,
            externalIntent: "",
            ids: ""
        });
        setSelectedIntents(newSelectedIntents);
    };
    const handleAddSelectedIntent = ()=>{
        setSelectedIntents([
            ...selectedIntents,
            {
                intent: null,
                isUsingExternalIntent: false,
                externalIntent: "",
                ids: ""
            }
        ]);
    };
    const mapPlatformFilter = (platformsToBeMapped)=>{
        let platformStrings = [];
        platformsToBeMapped.forEach((p)=>{
            if (p.platform?.length) platformStrings.push(p.platform);
        });
        if (platformStrings.length) return platformStrings.join(",");
        return null;
    };
    const mapRequestNames = (intentsToBeMapped)=>{
        const requestNames = [];
        intentsToBeMapped.forEach((i)=>{
            let requestName = "";
            if (i.isUsingExternalIntent) requestName = i.externalIntent;
            else if (i.intent?.isCustom) {
                // For custom intent we capture intent id in requestName
                const ids = i.intent.locales?.map((l)=>l.intentId);
                requestName = ids?.join(",");
            } else // For prebuilt intents we capture intent's name["voicify"] property in requestName
            requestName = i.intent?.name[0, _platforms.PLATFORM_VOICIFY] ?? i.intent?.displayName;
            if (requestName?.length) requestNames.push(requestName);
        });
        if (requestNames.length) return requestNames.join(",");
        return null;
    };
    (0, _react1.useEffect)(()=>{
        if (interactionModelContainer.interactionModels?.length && !loaded && interactionModelContainer.currentApplicationId === props.application?.id) {
            const model = (0, _interactionModelForm.buildEditableInteractionModel)(interactionModelContainer.interactionModels, props.languages);
            setInteractionModel(model);
        }
    }, [
        interactionModelContainer.interactionModels,
        interactionModelContainer.currentApplicationId
    ]);
    (0, _react1.useEffect)(()=>{
        if (nlpEntitiesContainer.applicationNlpEntities?.length) {
            const formEntities = nlpEntitiesContainer.applicationNlpEntities.map((e)=>{
                let formEntity = {
                    ...e
                };
                return formEntity;
            });
            setNlpEntities(formEntities);
        }
    }, [
        nlpEntitiesContainer.applicationNlpEntities
    ]);
    const handleAddIntent = (idx)=>{
        const newName = "New Intent";
        let intentNewKey = newName;
        props.languages?.forEach((l)=>{
            intentNewKey = intentNewKey + "|" + l.shortCode;
        });
        const newIntent = {
            intent: {
                key: intentNewKey,
                originalDisplayName: newName,
                displayName: newName,
                utterances: [],
                slots: [],
                isDisabled: false,
                updatedDisabledState: false,
                isCustom: true,
                locales: props.languages.map((l)=>({
                        shortCode: l.shortCode,
                        intentId: newName
                    })),
                isDeleted: false,
                isAdded: true,
                isModified: true,
                requiresExactUtteranceMatch: false,
                disabledForFeatureFlagIds: []
            },
            isUsingExternalIntent: false,
            externalIntent: "",
            ids: ""
        };
        setEditingIntentIndex(selectedIntents.length);
        setSelectedIntents([
            ...selectedIntents,
            newIntent
        ]);
        setShowIntentEditor(true);
        setIsAddingIntent(true);
    };
    const handleSelectExternalIntent = (idx)=>{
        const newSelectedIntents = [
            ...selectedIntents
        ];
        newSelectedIntents[idx].isUsingExternalIntent = true;
        newSelectedIntents[idx].externalIntent = "";
        setSelectedIntents(newSelectedIntents);
    };
    const handleIntentSelectorClick = (idx, values)=>{
        if (values?.length) {
            const selectedOption = values[0];
            if (selectedOption === "__newIntent") handleAddIntent(idx);
            else if (selectedOption === "__externalIntent") handleSelectExternalIntent(idx);
            else if (selectedOption === "__customIntents") ;
            else if (selectedOption === "__preBuiltIntents") ;
            else if (selectedOption in interactionModel) {
                setIsAddingIntent(false);
                const newSelectedIntents = [
                    ...selectedIntents
                ];
                newSelectedIntents[idx].isUsingExternalIntent = false;
                // Option value is intent.key
                newSelectedIntents[idx].intent = interactionModel[selectedOption];
                setSelectedIntents(newSelectedIntents);
                props.updateValues(mapRequestNames(newSelectedIntents), props.requestTypes, mapPlatformFilter(platforms));
            }
        }
    };
    const handleIntentModalUpdate = (displayName, intent)=>{
        let error = null;
        const newSelectedIntents = [
            ...selectedIntents
        ];
        newSelectedIntents[editingIntentIndex].intent = intent;
        newSelectedIntents[editingIntentIndex].isUsingExternalIntent = false;
        setSelectedIntents(newSelectedIntents);
        props.updateValues(mapRequestNames(newSelectedIntents), props.requestTypes, mapPlatformFilter(platforms));
        const newInteractionModel = {
            ...interactionModel
        };
        delete newInteractionModel[intent.key];
        newInteractionModel[intent.key] = intent;
        setInteractionModel(newInteractionModel);
        return error;
    };
    const handleIntentModalSubmit = async ()=>{
        const promises = [];
        for(let i = 0; i < props.languages?.length; i++){
            const language = props.languages[i];
            let update = {
                intents: {},
                locale: language?.shortCode,
                disableIntents: [],
                enableIntents: [],
                removeCustomIntents: [],
                addCustomIntents: []
            };
            let intentUpdate = {
                addedUtterances: [],
                removedUtterances: [],
                addedSlots: [],
                removedSlots: [],
                updatedDisplayName: ""
            };
            update = (0, _interactionModelForm.addEditableIntentToUpdate)(update, intentUpdate, selectedIntents[editingIntentIndex].intent, language);
            if (!(0, _interactionModelForm.isEmptyInteractionModelUpdate)(update)) promises.push(interactionModelContainer.updateInteractionModel(props.application?.id, language.shortCode, update));
        }
        if (promises.length) await Promise.all(promises);
        const result = await interactionModelContainer.loadInteractionModels(props.application?.id, props.languages);
        if (result.resultType == "Ok") {
            const model = (0, _interactionModelForm.buildEditableInteractionModel)(result.data, props.languages);
            setInteractionModel(model);
            const newSelectedIntent = Object.entries(model)?.find((entry)=>entry[1].key === selectedIntents[editingIntentIndex].intent?.key)[1];
            const newSelectedIntents = [
                ...selectedIntents
            ];
            newSelectedIntents[editingIntentIndex].intent = newSelectedIntent;
            newSelectedIntents[editingIntentIndex].isUsingExternalIntent = false;
            setSelectedIntents(newSelectedIntents);
            props.updateValues(mapRequestNames(newSelectedIntents), props.requestTypes, mapPlatformFilter(platforms));
            setIsAddingIntent(false);
            setShowIntentEditor(false);
        }
    };
    const handlePlatformSelectChange = (value, idx)=>{
        const newPlatforms = [
            ...platforms
        ];
        newPlatforms[idx].option = value;
        if (value !== "custom") newPlatforms[idx].platform = value;
        else newPlatforms[idx].platform = "";
        setPlatforms(newPlatforms);
        props.updateValues(mapRequestNames(selectedIntents), props.requestTypes, mapPlatformFilter(newPlatforms));
    };
    const handleCustomPlatformChange = (value, idx)=>{
        const newPlatforms = [
            ...platforms
        ];
        newPlatforms[idx].platform = value;
        setPlatforms(newPlatforms);
        props.updateValues(mapRequestNames(selectedIntents), props.requestTypes, mapPlatformFilter(newPlatforms));
    };
    const handleToggleShowPlatforms = ()=>{
        if (!showPlatforms && !platforms.length) setPlatforms([
            ...platforms,
            {
                option: "",
                platform: ""
            }
        ]);
        setShowPlatforms(!showPlatforms);
    };
    const handlePlatformDelete = (idx)=>{
        const newPlatforms = platforms.filter((p, i)=>i !== idx);
        setPlatforms(newPlatforms);
        props.updateValues(mapRequestNames(selectedIntents), props.requestTypes, mapPlatformFilter(newPlatforms));
    };
    const updateExternalIntent = (idx, newVal)=>{
        const newSelectedIntents = [
            ...selectedIntents
        ];
        newSelectedIntents[idx].externalIntent = newVal;
        setSelectedIntents(newSelectedIntents);
        props.updateValues(mapRequestNames(newSelectedIntents), props.requestTypes, mapPlatformFilter(platforms));
    };
    const handleIntentDelete = (idx)=>{
        const newSelectedIntents = selectedIntents.filter((x, i)=>idx !== i);
        setSelectedIntents(newSelectedIntents);
        props.updateValues(mapRequestNames(newSelectedIntents), props.requestTypes, mapPlatformFilter(platforms));
    };
    const handleRequestTypeSelectorChange = (option)=>{
        setSelectedRequestTypeOption(option);
        if (option === "Intent") {
            mapRequestNamesToSelectedIntents(props.requestNames);
            props.setFieldValue("requestTypes", "");
        }
    };
    const renderRequestTypeSelector = ()=>{
        return (0, _react.jsx)((0, _textOverflowMenuDefault.default), {
            clickableText: selectedRequestTypeOption,
            className: requestTypeStyle,
            menuClassName: requestTypeMenuStyle,
            toggleClassName: toggleIndicatorStyle,
            label: "Request Type: ",
            onOptionSelected: handleRequestTypeSelectorChange,
            options: [
                {
                    label: "Intent"
                },
                {
                    label: "Custom"
                }
            ]
        });
    };
    return (0, _react.jsx)((0, _reactDefault.default).Fragment, null, (0, _react.jsx)((0, _contentCollapsingSectionDefault.default), {
        titleRightRowComponent: renderRequestTypeSelector(),
        title: "Input Requirements",
        icon: userIcon,
        id: "input"
    }, (0, _react.jsx)((0, _contentCardDefault.default), {
        title: "Input Options",
        icon: inputGroupIcon,
        id: "inputOptions"
    }, !loaded ? (0, _react.jsx)(LoaderHolder, null, (0, _react.jsx)((0, _loaderDefault.default), null)) : (0, _react.jsx)((0, _reactDefault.default).Fragment, null, selectedRequestTypeOption === "Intent" ? (0, _react.jsx)((0, _reactDefault.default).Fragment, null, (0, _react.jsx)((0, _fieldErrorDefault.default), {
        name: "requestNames"
    }), selectedIntents.map((i, idx)=>(0, _react.jsx)(InputOptionFieldContainer, {
            key: idx
        }, (0, _react.jsx)(IntentActionRow, null, !i.isUsingExternalIntent && i.intent && (0, _react.jsx)(ClickableText, {
            onClick: ()=>{
                setShowIntentEditor(true);
                setEditingIntentIndex(idx);
            }
        }, "Manage this intent"), (0, _react.jsx)(IntentDeleteIcon, {
            onClick: ()=>handleIntentDelete(idx),
            src: deleteIcon
        })), (0, _react.jsx)((0, _intentSelectorDefault.default), {
            label: "Intent",
            selectedDisplayText: i.isUsingExternalIntent ? "External Intent" : i.intent?.displayName ? i.intent?.displayName : "Select an Intent",
            interactionModel: interactionModel,
            handleIntentChange: (x)=>handleIntentSelectorClick(idx, x),
            selectedIntent: i.intent
        }), i.isUsingExternalIntent && (0, _react.jsx)(IndentedTextFieldHolder, null, (0, _react.jsx)("div", {
            className: "vertical-line"
        }), (0, _react.jsx)("div", {
            className: "horizontal-line"
        }), (0, _react.jsx)((0, _textFieldDefault.default), {
            useForm: false,
            placeholder: "Enter comma separated intent names",
            value: i.externalIntent,
            label: "External Intent",
            onChange: (e)=>updateExternalIntent(idx, e.target.value)
        }))))) : (0, _react.jsx)((0, _formFieldsContainerDefault.default), null, (0, _react.jsx)((0, _textFieldDefault.default), {
        id: "requestTypes",
        disabled: props.isDisabled,
        name: "requestTypes",
        value: props.requestTypes,
        tooltip: "The native name of a request type such as IntentRequest or Connections.Response",
        toolTipPosition: "right",
        label: "Request Types",
        placeholder: "A comma separated list of native request types. Example: IntentRequest",
        onChange: props.onChange,
        onBlur: props.onBlur
    }), (0, _react.jsx)((0, _textFieldDefault.default), {
        id: "requestNames",
        disabled: props.isDisabled,
        name: "requestNames",
        value: props.requestNames,
        label: "Request Names",
        tooltip: "The native name of the request such as the Intent name or action name",
        toolTipPosition: "right",
        placeholder: "A comma separated list of native request names. Example: TelephoneIntent",
        onChange: props.onChange,
        onBlur: props.onBlur
    })), (0, _react.jsx)(PlatformRow, null, selectedRequestTypeOption === "Intent" ? (0, _react.jsx)(AddAnIntentText, {
        onClick: handleAddSelectedIntent
    }, "+ Add an Intent") : null, (0, _react.jsx)(PlatformChipWrapper, {
        onClick: handleToggleShowPlatforms
    }, (0, _react.jsx)(PlatformText, null, "Platform:"), platforms?.length ? (0, _react.jsx)(PlatformChip, null, platforms.length) : (0, _react.jsx)(PlatformAnyText, null, "Any"), (0, _react.jsx)(PlatformToggleIndicator, {
        direction: showPlatforms ? "up" : "down"
    }))), (0, _react.jsx)((0, _fieldErrorDefault.default), {
        name: "platformFilter"
    }), showPlatforms && (0, _react.jsx)(PlatformsList, null, platforms.length ? (0, _react.jsx)("p", null, "This input will be exclusive to the platforms listed below:") : (0, _react.jsx)((0, _reactDefault.default).Fragment, null), platforms.map((p, idx)=>(0, _react.jsx)(InputOptionFieldContainer, {
            key: idx
        }, (0, _react.jsx)(PlatformDeleteIcon, {
            onClick: ()=>handlePlatformDelete(idx),
            src: deleteIcon
        }), (0, _react.jsx)((0, _selectFieldDefault.default), {
            clearable: false,
            key: `platform-${idx}`,
            useForm: false,
            onChange: (e)=>{
                handlePlatformSelectChange(e.value, idx);
            },
            onBlur: ()=>{},
            value: p.option,
            label: "Platform",
            placeholder: "Select a platform",
            useFormTheme: true,
            options: [
                {
                    value: "Alexa",
                    label: "Alexa"
                },
                {
                    value: "GoogleAssistant",
                    label: "Google Assistant"
                },
                {
                    value: "custom",
                    label: "Custom"
                }
            ]
        }), p.option === "custom" && (0, _react.jsx)(CustomPlatformHolder, null, (0, _react.jsx)("div", {
            className: "vertical-line"
        }), (0, _react.jsx)("div", {
            className: "horizontal-line"
        }), (0, _react.jsx)((0, _textFieldDefault.default), {
            useForm: false,
            placeholder: "Enter a platform",
            value: p.platform,
            onBlur: ()=>{},
            label: "Platform Name",
            onChange: (e)=>handleCustomPlatformChange(e.target.value, idx)
        })))), (0, _react.jsx)(ClickableText, {
        onClick: ()=>setPlatforms([
                ...platforms,
                {
                    option: "",
                    platform: ""
                }
            ])
    }, "+ Add a Platform"))))), showIntentEditor && (0, _react.jsx)((0, _intentItemDefault.default), (0, _extendsDefault.default)({
        enhancedIntentMatchingEnabled: false
    }, props, {
        displayType: "Modal",
        nlpEntities: nlpEntities,
        intent: selectedIntents[editingIntentIndex].intent,
        isLoading: !loaded || interactionModelContainer.isLoading,
        updateIntent: handleIntentModalUpdate,
        toggleActivationByKey: ()=>{},
        applicationId: props.application?.id,
        languages: props.languages,
        idx: 0,
        isActive: true,
        key: 0,
        handleClose: ()=>setShowIntentEditor(false),
        handleSubmit: handleIntentModalSubmit
    })));
};
const requestTypeStyle = /*#__PURE__*/ (0, _css.css)({
    name: "1o3nkn",
    styles: "margin-left:auto"
});
const toggleIndicatorStyle = /*#__PURE__*/ (0, _css.css)({
    name: "1tnjm7g",
    styles: "margin-top:6px!important;margin-left:8px!important"
});
const requestTypeMenuStyle = /*#__PURE__*/ (0, _css.css)({
    name: "1j5hcas",
    styles: "margin-left:-6px"
});
const InputOptionFieldContainer = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e92w8nz15"
})({
    name: "bjn8wh",
    styles: "position:relative"
});
const PlatformDeleteIcon = /*#__PURE__*/ (0, _baseDefault.default)("img", {
    target: "e92w8nz14"
})({
    name: "1u6zhqq",
    styles: "position:absolute;cursor:pointer;right:16px;height:20px"
});
const IntentActionRow = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e92w8nz13"
})({
    name: "175dydh",
    styles: "position:absolute;display:flex;flex-direction:row;right:0px;z-index:1"
});
const IntentDeleteIcon = /*#__PURE__*/ (0, _baseDefault.default)("img", {
    target: "e92w8nz12"
})("cursor:pointer;height:20px;padding-left:8px;margin-left:8px;border-left:1px solid ", (0, _colors.color_shades_dark), ";");
const LoaderHolder = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e92w8nz11"
})({
    name: "epk9mb",
    styles: "width:100%;height:400px;position:relative"
});
const IndentedTextFieldHolder = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e92w8nz10"
})("display:flex;flex-direction:row;padding-top:8px;.vertical-line{height:67px;border-right:1px solid ", (0, _colors.color_shades_dark), ";margin-left:16px;margin-top:-9px;}.horizontal-line{border-bottom:1px solid ", (0, _colors.color_shades_dark), ";width:16px;margin-bottom:52px;}");
const CustomPlatformHolder = /*#__PURE__*/ (0, _baseDefault.default)(IndentedTextFieldHolder, {
    target: "e92w8nz9"
})({
    name: "18mjgh6",
    styles: "margin-top:-23px"
});
const ClickableText = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e92w8nz8"
})("color:", (0, _colors.color_colors_ocean), ";font-size:12px;cursor:pointer;");
const AddAnIntentText = /*#__PURE__*/ (0, _baseDefault.default)(ClickableText, {
    target: "e92w8nz7"
})({
    name: "mmdt3g",
    styles: "font-size:14px"
});
const PlatformRow = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e92w8nz6"
})({
    name: "1g7bw80",
    styles: "margin-top:16px;padding-bottom:24px;display:flex;flex-direction:row"
});
const PlatformText = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e92w8nz5"
})("color:", (0, _colors.color_shades_darker), ";");
const PlatformChip = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e92w8nz4"
})("min-width:24px;text-align:center;background:", (0, _colors.color_shades_darkest), ";color:white;margin-left:4px;border-radius:16px;font-size:12px;padding:2px 8px 0px 8px;line-height:16px;");
const PlatformChipWrapper = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e92w8nz3"
})({
    name: "7wclrp",
    styles: "display:flex;flex-direction:row;margin-left:auto;cursor:pointer"
});
const PlatformToggleIndicator = /*#__PURE__*/ (0, _baseDefault.default)((0, _toggleIndicatorDefault.default), {
    target: "e92w8nz2"
})({
    name: "15dqu5m",
    styles: "margin:8px 0 0 8px"
});
const PlatformsList = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e92w8nz1"
})("border-top:1px solid ", (0, _colors.color_shades_dark), ";border-bottom:1px solid ", (0, _colors.color_shades_dark), ";padding:16px 0 16px 0;p{margin-bottom:8px;}");
const PlatformAnyText = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e92w8nz0"
})("font-style:italic;color:", (0, _colors.color_shades_darkest), ";margin-left:4px;");
exports.default = CustomRequestInputOptions;

},{"@babel/runtime/helpers/extends":"4iKIP","@emotion/styled/base":"lSuFu","@emotion/react":"djZKr","@emotion/css":"awUBr","react":"6uln9","../../../components/forms/FieldError":"fDxhz","./IntentSelector":"gy5Tg","../../../components/forms/SelectField":"405B3","../../../components/forms/TextField":"7a7bh","../../../components/general/Loader":"bnV5T","../../../components/general/overflowMenu/TextOverflowMenu":"iiFcw","../../../components/general/ToggleIndicator":"4eej1","../../../components/structure/ContentCard":"hJsdJ","../../../components/structure/ContentCollapsingSection":"1CUms","../../../components/structure/FormFieldsContainer":"h3hzh","../../../constants/colors":"1p3OR","../../../hooks/ApplicationNlpEntityContainer":"6IUi8","../../../hooks/InteractionModelContainer":"5cw5C","../../interactionModel/components/IntentItem":"l8wuQ","../../interactionModel/components/InteractionModelForm":"9RN9X","../../../constants/platforms":"kY4Py","26f7544be1913523":"fM7ms","2990bda00f7b0ea4":"a8FLc","6216a8a085fc019b":"bG6Op","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"gy5Tg":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _groupedMultiSelector = require("../../../components/forms/GroupedMultiSelector");
var _groupedMultiSelectorDefault = parcelHelpers.interopDefault(_groupedMultiSelector);
var _colors = require("../../../constants/colors");
var _intents = require("../../../constants/Intents");
var _platforms = require("../../../constants/platforms");
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const addIcon = require("510370ac698d3b27");
const IntentSelector = (props)=>{
    const isIntentWithDifferentContentItem = (intent)=>{
        return (0, _intents.IntentsDisplayNamesWithContentItems).includes(intent.displayName) || intent?.name[0, _platforms.PLATFORM_VOICIFY] && (0, _intents.IntentVoicifyNamesWithContentItems).includes(intent?.name[0, _platforms.PLATFORM_VOICIFY]);
    };
    const getGroups = ()=>{
        const groups = [];
        groups.push({
            key: "__newIntent",
            label: "Add a new intent",
            subItems: [],
            image: addIcon
        });
        const customIntentGroup = {
            key: "__customIntents",
            label: "Custom Intent",
            subItems: [],
            hideRadio: true
        };
        const preBuiltIntentGroup = {
            key: "__preBuiltIntents",
            label: "Pre-built Intent",
            subItems: [],
            hideRadio: true
        };
        const intents = Object.entries(props.interactionModel);
        for (const [intentKey, intent] of intents){
            let label = intent.displayName;
            // Check if custom intent display name is unique, if not use the key as label
            const intentNameMatch = intents?.filter((entry)=>entry[1]?.displayName?.toLowerCase().trim() === intent.displayName?.toLowerCase().trim());
            if (intentNameMatch?.length > 1) label = intent.key?.replace(/\|/g, " ");
            const optionItem = {
                label: label,
                value: intent.key,
                isSelected: false,
                data: intent,
                groupKey: "",
                hideCheckbox: true
            };
            if (intent.isCustom) {
                optionItem.groupKey = "customIntents";
                customIntentGroup.subItems.push(optionItem);
            } else if (!isIntentWithDifferentContentItem(intent)) {
                optionItem.groupKey = "preBuiltIntents";
                preBuiltIntentGroup.subItems.push(optionItem);
            }
        }
        if (customIntentGroup.subItems.length) groups.push(customIntentGroup);
        if (preBuiltIntentGroup.subItems.length) groups.push(preBuiltIntentGroup);
        groups.push({
            key: "__externalIntent",
            label: "External Intent",
            subItems: []
        });
        return groups;
    };
    return (0, _react.jsx)("div", {
        id: props.id,
        className: `language-grouped-selector ${containerStyle} ${"full"} ${props.disabled ? "disabled" : ""}`
    }, (0, _react.jsx)((0, _groupedMultiSelectorDefault.default), {
        selectorWrapperClassName: selectorWrapperStyle,
        groupToggle: groupToggleStyle,
        label: props.label,
        groups: getGroups(),
        onChange: (values)=>props.handleIntentChange(values),
        selectedValues: [
            props.selectedIntent?.key
        ],
        withGroupSelection: false,
        treatGroupAsValue: true,
        subItemCheckType: "radio",
        restrictGroups: true,
        position: props.position ?? "bottom",
        emptyText: "Select an intent",
        disabled: props.disabled,
        innerSelectionRender: ()=>(0, _react.jsx)("div", null, props.selectedDisplayText)
    }));
};
const selectorWrapperStyle = /*#__PURE__*/ (0, _css.css)({
    name: "1dk0v5d",
    styles: "z-index:2"
});
const groupToggleStyle = /*#__PURE__*/ (0, _css.css)({
    name: "14vfbk2",
    styles: "margin-left:auto;margin-right:0;height:8px;width:8px"
});
const containerStyle = /*#__PURE__*/ (0, _css.css)("margin-left:auto;margin-top:16px;margin-right:0;flex:1;&.full{.field-wrapper{display:block;label{margin-left:16px;font-size:14px;color:", (0, _colors.color_shades_darkest), ";}.selection-section{margin-top:8px;}}}&.minified{.field{.selection{border:none;background:transparent;}}.field-wrapper{max-width:350px;margin-left:auto;}}&.bordered{border-right:1px solid #ccc;}&.disabled{.field .selection{background:", (0, _colors.color_shades_light), ";cursor:not-allowed;}}.field{.selection{border-radius:4px;.empty-text{text-align:right;margin-left:auto;margin-right:12px;width:100%;}}}.sub-item{img{border-radius:50%;border:1px solid ", (0, _colors.cool_grey), ";}}", "");
exports.default = IntentSelector;

},{"@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","../../../components/forms/GroupedMultiSelector":"51iZT","../../../constants/colors":"1p3OR","../../../constants/Intents":"kgrHM","../../../constants/platforms":"kY4Py","510370ac698d3b27":"6cI2N","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"kY4Py":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PLATFORM_ALEXA", ()=>PLATFORM_ALEXA);
parcelHelpers.export(exports, "PLATFORM_GOOGLE_ACTUIBS", ()=>PLATFORM_GOOGLE_ACTUIBS);
parcelHelpers.export(exports, "PLATFORM_DIALOGFLOW", ()=>PLATFORM_DIALOGFLOW);
parcelHelpers.export(exports, "PLATFORM_VOICIFY", ()=>PLATFORM_VOICIFY);
parcelHelpers.export(exports, "PLATFORM_LUIS", ()=>PLATFORM_LUIS);
const PLATFORM_ALEXA = "alexa";
const PLATFORM_GOOGLE_ACTUIBS = "googleActions";
const PLATFORM_DIALOGFLOW = "dialogflow";
const PLATFORM_VOICIFY = "voicify";
const PLATFORM_LUIS = "luis";

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"kLQP9":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _unstated = require("unstated");
var _featureContainer = require("../../state/containers/FeatureContainer");
var _featureContainerDefault = parcelHelpers.interopDefault(_featureContainer);
var _customRequestContainer = require("../../state/containers/CustomRequestContainer");
var _customRequestContainerDefault = parcelHelpers.interopDefault(_customRequestContainer);
var _updateCustomRequestContentForm = require("./components/UpdateCustomRequestContentForm");
var _updateCustomRequestContentFormDefault = parcelHelpers.interopDefault(_updateCustomRequestContentForm);
var _applicationContainer = require("../../state/containers/ApplicationContainer");
var _applicationContainerDefault = parcelHelpers.interopDefault(_applicationContainer);
var _titleStateContainer = require("../../state/containers/TitleStateContainer");
var _titleStateContainerDefault = parcelHelpers.interopDefault(_titleStateContainer);
var _repromptContainer = require("../../state/containers/RepromptContainer");
var _repromptContainerDefault = parcelHelpers.interopDefault(_repromptContainer);
var _followUpContainer = require("../../state/containers/FollowUpContainer");
var _followUpContainerDefault = parcelHelpers.interopDefault(_followUpContainer);
var _mediaResponseContainer = require("../../state/containers/MediaResponseContainer");
var _mediaResponseContainerDefault = parcelHelpers.interopDefault(_mediaResponseContainer);
var _genericEditContentItemPage = require("../formScenes/GenericEditContentItemPage");
var _genericEditContentItemPageDefault = parcelHelpers.interopDefault(_genericEditContentItemPage);
var _featureTypeIds = require("../../constants/featureTypeIds");
var _queryString = require("query-string");
var _queryStringDefault = parcelHelpers.interopDefault(_queryString);
var _applicationEnvironmentsContainer = require("../../state/containers/ApplicationEnvironmentsContainer");
var _applicationEnvironmentsContainerDefault = parcelHelpers.interopDefault(_applicationEnvironmentsContainer);
var _applicationBackupVersionsContainer = require("../../state/containers/ApplicationBackupVersionsContainer");
var _applicationBackupVersionsContainerDefault = parcelHelpers.interopDefault(_applicationBackupVersionsContainer);
class EditCustomRequest extends (0, _reactDefault.default).Component {
    render() {
        return (0, _react.jsx)((0, _unstated.Subscribe), {
            key: this.props.match.params.customRequestId + this.props.match.params.applicationFeatureId,
            to: [
                (0, _customRequestContainerDefault.default),
                (0, _applicationContainerDefault.default),
                (0, _titleStateContainerDefault.default),
                (0, _repromptContainerDefault.default),
                (0, _followUpContainerDefault.default),
                (0, _mediaResponseContainerDefault.default),
                (0, _featureContainerDefault.default),
                (0, _applicationEnvironmentsContainerDefault.default),
                (0, _applicationBackupVersionsContainerDefault.default)
            ]
        }, (customRequestContainer, appContainer, titleContainer, repromptContainer, followUpContainer, responseContainer, featureContainer, environmentsContainer, backupsContainer)=>{
            return (0, _react.jsx)((0, _genericEditContentItemPageDefault.default), {
                stateContainer: customRequestContainer,
                environmentsContainer: environmentsContainer,
                backupsContainer: backupsContainer,
                titleContainer: titleContainer,
                applicationContainer: appContainer,
                defaultTitle: "Edit Custom Request",
                contentItemId: this.props.match.params.customRequestId,
                history: this.props.history,
                location: this.props.location,
                match: this.props.match,
                staticContext: this.props.staticContext,
                featureContainer: featureContainer,
                featureTypeId: (0, _featureTypeIds.CustomRequestsFeatureTypeId),
                formRender: (contentItem, application, isTemplateOwned, assistantApplication, onShowPublishModal, onSubmit, toggleSync, onAccessTypeChange)=>(0, _react.jsx)((0, _updateCustomRequestContentFormDefault.default), {
                        location: this.props.location,
                        applicationFeatureId: this.props.match.params.applicationFeatureId,
                        application: application,
                        customRequest: contentItem,
                        stateContainer: customRequestContainer,
                        repromptContainer: repromptContainer,
                        followUpContainer: followUpContainer,
                        appContainer: appContainer,
                        responseStateContainer: responseContainer,
                        featureContainer: featureContainer,
                        assistantApplication: assistantApplication,
                        onShowPublishModal: onShowPublishModal,
                        onSubmit: onSubmit,
                        onToggleSync: toggleSync,
                        onAccessTypeChange: onAccessTypeChange,
                        previousContentId: (0, _queryStringDefault.default)?.parse(this.props.location.search)?.previousContentId,
                        history: this.props.history,
                        isSaving: customRequestContainer.state.isSaving,
                        isTemplateOwned: isTemplateOwned
                    })
            });
        });
    }
}
exports.default = EditCustomRequest;

},{"@emotion/react":"djZKr","react":"6uln9","unstated":"grh7p","../../state/containers/FeatureContainer":"4ApGg","../../state/containers/CustomRequestContainer":"aVO05","./components/UpdateCustomRequestContentForm":"5tUNS","../../state/containers/ApplicationContainer":"cuqi2","../../state/containers/TitleStateContainer":"2osOD","../../state/containers/RepromptContainer":"5vKMV","../../state/containers/FollowUpContainer":"rm9OA","../../state/containers/MediaResponseContainer":"1ccrV","../formScenes/GenericEditContentItemPage":"6RzEJ","../../constants/featureTypeIds":"hPLMP","query-string":"klvAV","../../state/containers/ApplicationEnvironmentsContainer":"jCULY","../../state/containers/ApplicationBackupVersionsContainer":"6rA1P","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"5tUNS":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _formik = require("formik");
var _yup = require("yup");
var _customRequestForm = require("../../formScenes/CustomRequestForm");
var _customRequestFormDefault = parcelHelpers.interopDefault(_customRequestForm);
const UpdateCustomRequestContentForm = (0, _formik.withFormik)({
    mapPropsToValues: (props)=>{
        var values = {
            title: props.customRequest.title,
            requestTypes: props.customRequest.requestTypes == null ? "" : props.customRequest.requestTypes,
            requestNames: props.customRequest.requestNames == null ? "" : props.customRequest.requestNames,
            platformFilter: props.customRequest.platformFilter == null ? "" : props.customRequest.platformFilter,
            responses: props.customRequest.responses.length > 0 ? props.customRequest.responses : [
                {
                    content: ""
                }
            ],
            requiresParent: props.customRequest.requiresParent,
            languages: props.customRequest.languages,
            isLive: props.customRequest.isLive,
            webhookChainingType: props.customRequest.webhookChainingType,
            sensitiveConversationChange: props.customRequest.sensitiveConversationChange ?? "None",
            disabledForFeatureFlagIds: props.customRequest?.disabledForFeatureFlagIds,
            alwaysOpen: props.customRequest.alwaysOpen ?? false
        };
        return values;
    },
    validationSchema: _yup.object().shape({
        title: _yup.string().required("You must enter a title"),
        responses: _yup.array().of(_yup.object().shape({
            content: _yup.string().required("You must enter a response variation")
        })).required("You must enter at least 1 response variation").min(1, "You must enter at least 1 response variation"),
        requestTypes: _yup.string(),
        requestNames: _yup.string().when("requestTypes", {
            is: (val)=>{
                return !val;
            },
            then: _yup.string().required("You must enter at least one request name or request type"),
            otherwise: _yup.string()
        })
    }),
    validateOnMount: true,
    handleSubmit: (values, { props, setStatus })=>{
        setStatus({
            submitting: true
        });
        return props.onSubmit(props.stateContainer.mapFormDataToModel(props.customRequest, values));
    }
})((0, _customRequestFormDefault.default));
exports.default = UpdateCustomRequestContentForm;

},{"formik":"3YnOK","yup":"j2SJU","../../formScenes/CustomRequestForm":"a4b82","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"c9NJd":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _logo = require("../../scenes/dashboardHeader/components/Logo");
var _logoDefault = parcelHelpers.interopDefault(_logo);
var _reactMarkdown = require("react-markdown");
var _reactMarkdownDefault = parcelHelpers.interopDefault(_reactMarkdown);
var _button = require("./Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _colors = require("../../constants/colors");
var _customScrollbars = require("../structure/CustomScrollbars");
var _customScrollbarsDefault = parcelHelpers.interopDefault(_customScrollbars);
var _notificationsContainer = require("../../hooks/NotificationsContainer");
var _notificationsContainerDefault = parcelHelpers.interopDefault(_notificationsContainer);
const linkRenderer = (props)=>{
    return (0, _react.jsx)("a", {
        href: props.href,
        target: "_blank"
    }, props.children);
};
const UrgentNotificationSplash = (props)=>{
    const notificationsHook = (0, _notificationsContainerDefault.default).useContainer();
    const notifications = notificationsHook.notifications;
    const notification = notifications.find((n)=>!n.isRead && n.priority === "Urgent");
    return notification != null && (0, _react.jsx)("div", {
        className: `${containerStyle} ${notification?.imageUrl == null ? "no-image" : ""}`
    }, (0, _react.jsx)((0, _customScrollbarsDefault.default), {
        autoHide: true
    }, (0, _react.jsx)((0, _logoDefault.default), {
        isFull: true,
        isInverse: true
    }), notification?.imageUrl != null && (0, _react.jsx)("div", {
        className: "image-container"
    }, (0, _react.jsx)("img", {
        src: notification.imageUrl
    })), (0, _react.jsx)("div", {
        className: `content ${markdownStyle}`
    }, (0, _react.jsx)((0, _reactMarkdownDefault.default), {
        source: notification?.markdown,
        renderers: {
            link: linkRenderer
        }
    }), (0, _react.jsx)("div", {
        className: "bottom-row"
    }, (0, _react.jsx)((0, _buttonDefault.default), {
        text: "Dismiss",
        themes: [
            "primary"
        ],
        disabled: notificationsHook.isLoading,
        loading: notificationsHook.isLoading,
        onClick: ()=>notificationsHook.markNotificationAsRead(notification.id)
    })))));
};
const containerStyle = /*#__PURE__*/ (0, _css.css)("position:fixed;width:100%;height:100%;top:0;left:0;z-index:5;&.no-image{padding-top:80px;}background-color:", (0, _colors.color_shades_darkest_transparent), ";.logo{position:fixed;left:24px;top:16px;}.image-container{text-align:center;width:100%;img{margin-left:auto;margin-right:auto;top:0px;}}.content{width:75%;height:auto;border-radius:16px;background:white;opacity:1;margin-left:auto;margin-right:auto;margin-bottom:56px;padding:56px;}.bottom-row{width:100%;padding-top:8px;margin-top:16px;border-top:1px solid ", (0, _colors.color_shades_dark), ";}", "");
const markdownStyle = /*#__PURE__*/ (0, _css.css)("font-family:Muli;font-style:normal;font-stretch:normal;font-size:18px;width:100%;line-height:20px;word-wrap:break-word;img{margin:32px;max-width:calc(100% - 64px);}p{font-size:18px;margin:12px 0;line-height:24px;}ul,ol{padding-left:24px;margin:12px 0;li{margin:4px;}}h1{margin-bottom:24px;margin-top:40px;font-size:28px;font-weight:bold;}h2{margin-bottom:24px;margin-top:40px;font-size:24px;font-weight:bold;}h3{margin-bottom:24px;margin-top:40px;font-size:22px;font-weight:bold;}h4{margin-bottom:16px;margin-top:24px;font-size:20px;font-weight:bold;}h5{margin-bottom:16px;margin-top:16px;font-size:18px;font-weight:bold italic;}h6{margin-bottom:16px;margin-top:16px;font-size:18px;font-weight:bold;}a{color:", (0, _colors.color_text_link), ";}", "");
exports.default = UrgentNotificationSplash;

},{"@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","../../scenes/dashboardHeader/components/Logo":"8VQkf","react-markdown":"6G7AH","./Button":"6ymxN","../../constants/colors":"1p3OR","../structure/CustomScrollbars":"50vFq","../../hooks/NotificationsContainer":"hNroK","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1pTCS":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _unstated = require("unstated");
var _templateConfigurationContainer = require("../../state/containers/TemplateConfigurationContainer");
var _templateConfigurationContainerDefault = parcelHelpers.interopDefault(_templateConfigurationContainer);
var _organizationContainer = require("../../state/containers/OrganizationContainer");
var _organizationContainerDefault = parcelHelpers.interopDefault(_organizationContainer);
var _applicationContainer = require("../../state/containers/ApplicationContainer");
var _applicationContainerDefault = parcelHelpers.interopDefault(_applicationContainer);
var _createTemplateConfigurationForm = require("./components/CreateTemplateConfigurationForm");
var _createTemplateConfigurationFormDefault = parcelHelpers.interopDefault(_createTemplateConfigurationForm);
const CreateTemplateConfiguration = (props)=>(0, _react.jsx)((0, _unstated.Subscribe), {
        to: [
            (0, _organizationContainerDefault.default),
            (0, _applicationContainerDefault.default),
            (0, _templateConfigurationContainerDefault.default)
        ]
    }, (orgContainer, appContainer, templatesContainer)=>(0, _react.jsx)((0, _createTemplateConfigurationFormDefault.default), {
            orgContainer: orgContainer,
            appContainer: appContainer,
            templatesContainer: templatesContainer,
            history: props.history
        }));
exports.default = CreateTemplateConfiguration;

},{"@emotion/react":"djZKr","react":"6uln9","unstated":"grh7p","../../state/containers/TemplateConfigurationContainer":"aJrgZ","../../state/containers/OrganizationContainer":"dlbaM","../../state/containers/ApplicationContainer":"cuqi2","./components/CreateTemplateConfigurationForm":"8LuB0","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8LuB0":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _formik = require("formik");
var _yup = require("yup");
var _smallModalLayout = require("../../../components/structure/SmallModalLayout");
var _smallModalLayoutDefault = parcelHelpers.interopDefault(_smallModalLayout);
var _footerBar = require("../../../components/structure/FooterBar");
var _footerBarDefault = parcelHelpers.interopDefault(_footerBar);
var _button = require("../../../components/general/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _modalHeader = require("../../../components/general/ModalHeader");
var _modalHeaderDefault = parcelHelpers.interopDefault(_modalHeader);
var _customScrollbars = require("../../../components/structure/CustomScrollbars");
var _customScrollbarsDefault = parcelHelpers.interopDefault(_customScrollbars);
var _appSelectField = require("../../../components/forms/AppSelectField");
var _appSelectFieldDefault = parcelHelpers.interopDefault(_appSelectField);
var _roundedSelectionRow = require("../../../components/general/RoundedSelectionRow");
var _roundedSelectionRowDefault = parcelHelpers.interopDefault(_roundedSelectionRow);
var _textField = require("../../../components/forms/TextField");
var _textFieldDefault = parcelHelpers.interopDefault(_textField);
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
class InnerForm extends (0, _reactDefault.default).Component {
    handleClose() {
        this.props.history.push("/v/modules");
    }
    handleAppChange(e) {
        this.props.setFieldValue("applicationId", e.value);
    }
    handleChangeSource(sourceType) {
        this.props.setFieldValue("sourceType", sourceType);
        this.props.setFieldValue("applicationId", "");
        this.props.setFieldValue("dynamicUrl", "");
    }
    render() {
        const props = {
            ...this.props
        };
        const isSaving = this.props.templatesContainer.state.isSaving || this.props.appContainer.state.isSaving;
        const { applicationId, dynamicUrl, sourceType } = this.props.values;
        return (0, _react.jsx)((0, _smallModalLayoutDefault.default), {
            isVisible: true,
            onClose: this.handleClose.bind(this)
        }, (0, _react.jsx)("form", {
            onSubmit: props.handleSubmit,
            className: containerStyle
        }, (0, _react.jsx)((0, _customScrollbarsDefault.default), {
            className: "modal-wrapper"
        }, (0, _react.jsx)((0, _modalHeaderDefault.default), {
            title: "Setup a new Module - Choose a Basis",
            onClose: this.handleClose.bind(this)
        }), (0, _react.jsx)("div", {
            className: "modal-body"
        }, (0, _react.jsx)("h4", null, "Select a basis for your module"), (0, _react.jsx)((0, _roundedSelectionRowDefault.default), {
            options: [
                {
                    name: "Template App"
                },
                {
                    name: "Dynamic Integration Endpoint"
                }
            ],
            onClick: (num)=>this.handleChangeSource(num == 1 ? "Dynamic" : "Application"),
            selectedFilter: sourceType == "Dynamic" ? 1 : 0
        }), sourceType == "Dynamic" ? (0, _react.jsx)((0, _reactDefault.default).Fragment, null, (0, _react.jsx)("p", null, "Enter your API endpoint that you want Voicify to send the completed form details to. Your endpoint will get information about the filled out forms from the user and can then use custom export models to sync with the app in Voicify."), (0, _react.jsx)((0, _textFieldDefault.default), {
            label: "Endpoint URL",
            value: dynamicUrl,
            name: "dynamicUrl",
            onChange: props.handleChange,
            onBlur: props.handleBlur,
            placeholder: "https://myintegration.voicify.com/api/myendpoint"
        }), (0, _react.jsx)("p", null, "This endpoint must accept HTTP POST requests over https.")) : (0, _react.jsx)((0, _reactDefault.default).Fragment, null, (0, _react.jsx)("p", null, "Select an existing app that will serve as a module for your template. The existing content, interaction model, and integrations will be copied over to any instances of the template."), (0, _react.jsx)((0, _appSelectFieldDefault.default), {
            name: "applicationId",
            label: "Template app",
            placeholder: "Select an app",
            value: applicationId,
            onBlur: props.handleBlur,
            onChange: this.handleAppChange.bind(this),
            appContainer: props.appContainer,
            organizationId: props.orgContainer.state.currentOrganization.id
        }), (0, _react.jsx)("p", null, "Dynamic assets such as variables can be included in your template and the values filled in will be inserted into the structure based on their placement within the source app.")))), (0, _react.jsx)((0, _footerBarDefault.default), null, (0, _react.jsx)((0, _buttonDefault.default), {
            type: "submit",
            themes: [
                "primary",
                "start"
            ],
            text: "Create",
            disabled: isSaving,
            loading: isSaving
        }), (0, _react.jsx)((0, _buttonDefault.default), {
            type: "button",
            themes: [
                "secondary",
                "end"
            ],
            text: "Cancel",
            onClick: this.handleClose.bind(this),
            disabled: isSaving,
            loading: isSaving
        }))));
    }
}
const containerStyle = /*#__PURE__*/ (0, _css.css)({
    name: "1ww43i1",
    styles: "min-height:580px;height:580px;padding-bottom:64px;.modal-wrapper{min-height:100%;}.modal-body{padding:32px;margin-bottom:180px;height:100%;flex:1;>h4{font-style:normal;font-weight:normal;font-size:18px;line-height:24px;}>p{font-style:normal;font-weight:normal;font-size:14px;line-height:20px;margin:32px 0;}}"
});
const CreateTemplateConfigurationForm = (0, _formik.withFormik)({
    mapPropsToValues: ()=>({
            applicationId: "",
            dynamicUrl: "",
            sourceType: "Application"
        }),
    validationSchema: _yup.object().shape({
        applicationId: _yup.string().when("sourceType", {
            is: (sourceType)=>sourceType == "Application",
            then: _yup.string().required("You must select an application to use as the template")
        }),
        dynamicUrl: _yup.string().when("sourceType", {
            is: (sourceType)=>sourceType == "Dynamic",
            then: _yup.string().url("You must enter a valid url").required("You must specify a dynamic integration endpoint url")
        })
    }),
    handleSubmit: (values, { props })=>{
        if (values.applicationId) props.appContainer.toggleTemplating(values.applicationId, true).then((toggleResult)=>{
            if (toggleResult.resultType == "Ok") props.templatesContainer.createEmptyTemplateConfiguration(props.orgContainer.state.currentOrganization?.id, values.applicationId, values.dynamicUrl).then((result)=>{
                if (result.resultType == "Ok") {
                    props.history.push(`/v/modules/edit/${result.data.id}`);
                    location.reload();
                }
            });
        });
        else props.templatesContainer.createEmptyTemplateConfiguration(props.orgContainer.state.currentOrganization?.id, values.applicationId, values.dynamicUrl).then((result)=>{
            if (result.resultType == "Ok") {
                props.history.push(`/v/modules/edit/${result.data.id}`);
                location.reload();
            }
        });
    }
})(InnerForm);
exports.default = CreateTemplateConfigurationForm;

},{"@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","formik":"3YnOK","yup":"j2SJU","../../../components/structure/SmallModalLayout":"khwvt","../../../components/structure/FooterBar":"bibRL","../../../components/general/Button":"6ymxN","../../../components/general/ModalHeader":"aUACx","../../../components/structure/CustomScrollbars":"50vFq","../../../components/forms/AppSelectField":"k5GZK","../../../components/general/RoundedSelectionRow":"dUH5O","../../../components/forms/TextField":"7a7bh","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"k5GZK":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _reactSelect = require("react-select");
var _reactSelectDefault = parcelHelpers.interopDefault(_reactSelect);
var _colors = require("../../constants/colors");
var _applicationAvatar = require("../general/ApplicationAvatar");
var _applicationAvatarDefault = parcelHelpers.interopDefault(_applicationAvatar);
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// component used in building forms with consistent components for look and function
class IconOptionComponent extends (0, _reactDefault.default).Component {
    handleMouseDown(event) {
        event.preventDefault();
        event.stopPropagation();
        this.props.onSelect(this.props.option, event);
    }
    handleMouseEnter(event) {
        this.props.onFocus(this.props.option, event);
    }
    handleMouseMove(event) {
        if (this.props.isFocused) return;
        this.props.onFocus(this.props.option, event);
    }
    render() {
        return (0, _react.jsx)("div", {
            className: this.props.className,
            onMouseDown: this.handleMouseDown.bind(this),
            onMouseEnter: this.handleMouseEnter.bind(this),
            onMouseMove: this.handleMouseMove.bind(this),
            title: this.props.option.label
        }, (0, _react.jsx)((0, _applicationAvatarDefault.default), {
            app: this.props.option.app,
            size: 32,
            className: "app-avatar"
        }), (0, _react.jsx)("span", {
            className: "Select-value-label"
        }, this.props.children));
    }
}
class IconValue extends (0, _reactDefault.default).Component {
    render() {
        return (0, _react.jsx)("div", {
            className: "Select-value",
            title: this.props.value.title
        }, (0, _react.jsx)((0, _applicationAvatarDefault.default), {
            app: this.props.value.app,
            size: 32,
            className: "app-avatar"
        }), (0, _react.jsx)("span", {
            className: "Select-value-label"
        }, this.props.children));
    }
}
const selectStyle = /*#__PURE__*/ (0, _css.css)({
    name: "47ati6",
    styles: "font-family:Muli sans-serif;font-weight:normal;font-style:normal;font-stretch:normal;line-height:normal;letter-spacing:normal;text-align:left;flex:1;margin-left:0;margin-right:0;width:100%;.Select-control{border-radius:12px;min-height:64px;}.Select-placeholder,.Select-value{padding:0 24px;padding-left:24px;font-family:Muli;font-size:14px;display:flex;align-items:center;.app-avatar{margin-left:14px;}}.Select-value-label{margin-left:16px;}.Select-menu-outer{border-bottom-right-radius:12px;border-bottom-left-radius:12px;overflow:hidden;}.Select-option,Select-noresults{height:64px;padding:0 24px;font-family:Muli;font-size:14px;display:flex;align-items:center;}.Select-option:last-child{border-bottom-right-radius:12px;border-bottom-left-radius:12px;}.Select-input{margin:16px;font-family:Muli,sans-serif;}"
});
const containerStyle = /*#__PURE__*/ (0, _css.css)("align-items:center;margin-left:auto;margin-right:0;flex:1;>*+*{margin-top:8px;}label{font-family:Muli;font-size:14px;font-weight:normal;font-style:normal;font-stretch:normal;line-height:normal;letter-spacing:normal;text-align:right;color:", (0, _colors.dark_grey_blue), ";margin-left:16px;}.detail-text{font-size:12px;font-weight:normal;font-style:normal;font-stretch:normal;line-height:normal;letter-spacing:0.7px;text-align:right;color:", (0, _colors.cool_grey), ";margin-right:8px;margin-left:auto;}.detail-icon{margin-right:32px;}", "");
const AppSelectField = (props)=>{
    const [apps, setApps] = (0, _react1.useState)([]);
    const [isLoading, setIsLoading] = (0, _react1.useState)(false);
    (0, _react1.useEffect)(()=>{
        const initialLoad = async ()=>{
            const appsResult = await props.appContainer.searchForApplications(props.organizationId, 1, 20, "CreatedDateDescending");
            setApps(appsResult.data.applications);
        };
        initialLoad();
    }, []);
    const handleChange = (value)=>{
        // this is going to call setFieldValue and manually update values.topcis
        props.onChange(value);
    };
    const handleInputChange = async (value)=>{
        if (value.length > 3 && !isLoading) {
            await setIsLoading(true);
            const appsResult = await props.appContainer.searchForOrgApplications(props.organizationId, 1, 20, "CreatedDateDescending", value);
            await setApps(appsResult.data.applications);
            await setIsLoading(false);
        }
    };
    const handleBlur = ()=>{
        // this is going to call setFieldTouched and manually update touched.topcis
        props.onBlur(true);
    };
    return (0, _react.jsx)("div", {
        className: containerStyle
    }, props.label !== undefined ? (0, _react.jsx)("label", null, props.label) : null, (0, _react.jsx)((0, _reactSelectDefault.default), {
        id: props.id,
        name: props.name,
        placeholder: props.placeholder,
        value: props.value,
        onChange: handleChange.bind(undefined),
        onBlur: handleBlur.bind(undefined),
        onInputChange: handleInputChange.bind(undefined),
        disabled: props.disabled,
        options: apps.map((a)=>({
                app: a,
                label: a.name,
                value: a.id
            })),
        valueComponent: IconValue,
        clearable: props.clearable,
        optionComponent: IconOptionComponent,
        className: selectStyle
    }));
};
exports.default = AppSelectField;

},{"@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","react-select":"1numo","../../constants/colors":"1p3OR","../general/ApplicationAvatar":"aA2GK","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2kSTD":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _unstated = require("unstated");
var _templateConfigurationContainer = require("../../state/containers/TemplateConfigurationContainer");
var _templateConfigurationContainerDefault = parcelHelpers.interopDefault(_templateConfigurationContainer);
var _organizationContainer = require("../../state/containers/OrganizationContainer");
var _organizationContainerDefault = parcelHelpers.interopDefault(_organizationContainer);
var _templateConfigurationForm = require("./components/TemplateConfigurationForm");
var _templateConfigurationFormDefault = parcelHelpers.interopDefault(_templateConfigurationForm);
var _mediaContainer = require("../../state/containers/MediaContainer");
var _mediaContainerDefault = parcelHelpers.interopDefault(_mediaContainer);
var _appliedApplicationTemplateContainer = require("../../state/containers/AppliedApplicationTemplateContainer");
var _appliedApplicationTemplateContainerDefault = parcelHelpers.interopDefault(_appliedApplicationTemplateContainer);
const EditTemplateConfiguration = (props)=>(0, _react.jsx)((0, _unstated.Subscribe), {
        to: [
            (0, _templateConfigurationContainerDefault.default),
            (0, _mediaContainerDefault.default),
            (0, _organizationContainerDefault.default),
            (0, _appliedApplicationTemplateContainerDefault.default)
        ]
    }, (templatesContainer, mediaContainer, orgContainer, appliedApplicationTemplateContainer)=>(0, _react.jsx)((0, _templateConfigurationFormDefault.default), {
            templateConfigContainer: templatesContainer,
            mediaContainer: mediaContainer,
            orgContainer: orgContainer,
            templateConfigurationId: props.match.params.templateConfigurationId,
            templateConfiguration: templatesContainer.state.organizationTemplates.find((t)=>t.id == props.match.params.templateConfigurationId),
            history: props.history,
            appliedApplicationTemplateContainer: appliedApplicationTemplateContainer
        }));
exports.default = EditTemplateConfiguration;

},{"@emotion/react":"djZKr","react":"6uln9","unstated":"grh7p","../../state/containers/TemplateConfigurationContainer":"aJrgZ","../../state/containers/OrganizationContainer":"dlbaM","./components/TemplateConfigurationForm":"6qB7g","../../state/containers/MediaContainer":"ch6Xu","../../state/containers/AppliedApplicationTemplateContainer":"3XuX7","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6qB7g":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _yup = require("yup");
var _reactTabs = require("react-tabs");
var _backButton = require("../../../components/general/BackButton");
var _backButtonDefault = parcelHelpers.interopDefault(_backButton);
var _headerTitleView = require("../../../components/structure/HeaderTitleView");
var _headerTitleViewDefault = parcelHelpers.interopDefault(_headerTitleView);
var _pageError = require("../../../components/general/PageError");
var _pageErrorDefault = parcelHelpers.interopDefault(_pageError);
var _fullPageTabbedPanel = require("../../../components/structure/Panels/FullPageTabbedPanel");
var _fullPageTabbedPanelDefault = parcelHelpers.interopDefault(_fullPageTabbedPanel);
var _formik = require("formik");
var _templateSetupEditor = require("./TemplateSetupEditor");
var _templateSetupEditorDefault = parcelHelpers.interopDefault(_templateSetupEditor);
var _templateConfigurationMenuSelector = require("./TemplateConfigurationMenuSelector");
var _templateConfigurationMenuSelectorDefault = parcelHelpers.interopDefault(_templateConfigurationMenuSelector);
var _templateDetailsEditor = require("./TemplateDetailsEditor");
var _templateDetailsEditorDefault = parcelHelpers.interopDefault(_templateDetailsEditor);
const builderIcon = require("391109f5ef924de8");
const setupIcon = require("168ed2a956451618");
const TemplateConfigurationContent = (props)=>{
    (0, _react1.useEffect)(()=>{
        const loadTemplateConfigurations = async ()=>{
            await props.templateConfigContainer.getOrganizationTemplates(props.orgContainer.state.currentOrganization.id);
        };
        if (props.templateConfiguration == null) loadTemplateConfigurations();
        props.templateConfigContainer.loadCategories();
        props.templateConfigContainer.loadIndustries();
        props.setFieldValue("templateConfiguration", props.templateConfiguration);
    }, [
        props.templateConfiguration
    ]);
    const handleClose = ()=>{
        props.history.push(`/v/templates`);
    };
    const getBreadCrumbItems = ()=>{
        var crumbs = [
            {
                id: "org",
                title: props.orgContainer.state.currentOrganization?.name,
                link: "/"
            }
        ];
        return crumbs;
    };
    const handleTemplateUpdate = (template)=>{
        props.setFieldValue("templateConfiguration", template);
    };
    const { isSaving } = props.templateConfigContainer.state;
    return (0, _react.jsx)("form", {
        onSubmit: props.handleSubmit
    }, (0, _react.jsx)((0, _fullPageTabbedPanelDefault.default), {
        tabs: [
            {
                title: "Setup",
                icon: setupIcon,
                selectedIcon: setupIcon
            },
            {
                title: "Form Creator",
                icon: builderIcon,
                selectedIcon: builderIcon
            }
        ],
        leftRender: ()=>(0, _react.jsx)((0, _reactDefault.default).Fragment, null, (0, _react.jsx)((0, _backButtonDefault.default), {
                onClick: handleClose.bind(undefined)
            }), (0, _react.jsx)((0, _templateConfigurationMenuSelectorDefault.default), {
                templateConfiguration: props.values.templateConfiguration,
                templateConfigContainer: props.templateConfigContainer,
                currentTemplateId: props.values.templateConfiguration?.id,
                history: props.history
            })),
        titleRender: ()=>(0, _react.jsx)((0, _headerTitleViewDefault.default), {
                text: props.templateConfiguration?.name,
                breadcrumb: getBreadCrumbItems()
            }),
        rightRender: ()=>null
    }, (0, _react.jsx)((0, _reactTabs.TabPanel), null, (0, _react.jsx)((0, _templateSetupEditorDefault.default), {
        history: props.history,
        onChange: handleTemplateUpdate.bind(undefined),
        isSaving: isSaving,
        templateConfigurationContainer: props.templateConfigContainer,
        templateConfiguration: props.values.templateConfiguration,
        mediaContainer: props.mediaContainer,
        organizationId: props.orgContainer.state.currentOrganization?.id
    })), (0, _react.jsx)((0, _reactTabs.TabPanel), null, (0, _react.jsx)((0, _templateDetailsEditorDefault.default), {
        history: props.history,
        onChange: handleTemplateUpdate.bind(undefined),
        isSaving: isSaving,
        templateConfigurationContainer: props.templateConfigContainer,
        templateConfiguration: props.values.templateConfiguration,
        mediaContainer: props.mediaContainer,
        organizationId: props.orgContainer.state.currentOrganization?.id
    }))), (0, _react.jsx)((0, _pageErrorDefault.default), {
        errors: props.templateConfigContainer.state.errors,
        onClear: ()=>props.templateConfigContainer.clearErrors()
    }));
};
const TemplateConfigurationForm = (0, _formik.withFormik)({
    mapPropsToValues: (props)=>({
            templateConfiguration: props.templateConfiguration
        }),
    validationSchema: _yup.object().shape({
        templateConfiguration: _yup.object().shape({
        }).required("You need to send a valid configuration")
    }),
    handleSubmit: async (values, { props })=>{
        if (!values.templateConfiguration.currentVersion) values.templateConfiguration.currentVersion = {
            versionName: "1.0"
        };
        await props.templateConfigContainer.updateTemplateConfiguration(values.templateConfiguration);
    }
})(TemplateConfigurationContent);
exports.default = TemplateConfigurationForm;

},{"@emotion/react":"djZKr","react":"6uln9","yup":"j2SJU","react-tabs":"92Sgf","../../../components/general/BackButton":"jZrQd","../../../components/structure/HeaderTitleView":"4unvp","../../../components/general/PageError":"ezFTm","../../../components/structure/Panels/FullPageTabbedPanel":"72bEo","formik":"3YnOK","./TemplateSetupEditor":"j5wxW","./TemplateConfigurationMenuSelector":"eDAQv","./TemplateDetailsEditor":"5UUN4","391109f5ef924de8":"92QFu","168ed2a956451618":"l7kbi","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"j5wxW":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _defineProperty = require("@babel/runtime/helpers/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _base = require("@emotion/styled/base");
var _baseDefault = parcelHelpers.interopDefault(_base);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _colors = require("../../../constants/colors");
var _applicationAvatar = require("../../../components/general/ApplicationAvatar");
var _applicationAvatarDefault = parcelHelpers.interopDefault(_applicationAvatar);
var _contentCard = require("../../../components/structure/ContentCard");
var _contentCardDefault = parcelHelpers.interopDefault(_contentCard);
var _textField = require("../../../components/forms/TextField");
var _textFieldDefault = parcelHelpers.interopDefault(_textField);
var _textAreaField = require("../../../components/forms/TextAreaField");
var _textAreaFieldDefault = parcelHelpers.interopDefault(_textAreaField);
var _formFieldsContainer = require("../../../components/structure/FormFieldsContainer");
var _formFieldsContainerDefault = parcelHelpers.interopDefault(_formFieldsContainer);
var _horizontalSeparator = require("../../../components/structure/HorizontalSeparator");
var _horizontalSeparatorDefault = parcelHelpers.interopDefault(_horizontalSeparator);
var _languages = require("../../../models/extensions/languages");
var _lodash = require("lodash");
var _lodashDefault = parcelHelpers.interopDefault(_lodash);
var _languageCollectionAvatar = require("../../../components/general/LanguageCollectionAvatar");
var _languageCollectionAvatarDefault = parcelHelpers.interopDefault(_languageCollectionAvatar);
var _addMarkdownButton = require("./AddMarkdownButton");
var _addMarkdownButtonDefault = parcelHelpers.interopDefault(_addMarkdownButton);
var _markdownEditorModal = require("./MarkdownEditorModal");
var _markdownEditorModalDefault = parcelHelpers.interopDefault(_markdownEditorModal);
var _reactDropzone = require("react-dropzone");
var _reactDropzoneDefault = parcelHelpers.interopDefault(_reactDropzone);
var _reactTabs = require("react-tabs");
var _button = require("../../../components/general/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _panelContainer = require("../../../components/structure/Panels/PanelContainer");
var _panelContainerDefault = parcelHelpers.interopDefault(_panelContainer);
var _panelHeaderContainer = require("../../../components/structure/Panels/PanelHeaderContainer");
var _panelHeaderContainerDefault = parcelHelpers.interopDefault(_panelHeaderContainer);
var _tabContainerPanel = require("../../../components/structure/Panels/TabContainerPanel");
var _tabContainerPanelDefault = parcelHelpers.interopDefault(_tabContainerPanel);
var _scrollablePanelBody = require("../../../components/structure/ScrollablePanelBody");
var _scrollablePanelBodyDefault = parcelHelpers.interopDefault(_scrollablePanelBody);
var _markdownPreview = require("./MarkdownPreview");
var _markdownPreviewDefault = parcelHelpers.interopDefault(_markdownPreview);
var _moduleCard = require("../../applicationModules/components/ModuleCard");
var _moduleCardDefault = parcelHelpers.interopDefault(_moduleCard);
var _reactRouterDom = require("react-router-dom");
var _loader = require("../../../components/general/Loader");
var _loaderDefault = parcelHelpers.interopDefault(_loader);
var _stylesValues = require("../../../constants/stylesValues");
var _radioGroup = require("../../../components/forms/RadioGroup");
var _radioGroupDefault = parcelHelpers.interopDefault(_radioGroup);
var _selectField = require("../../../components/forms/SelectField");
var _selectFieldDefault = parcelHelpers.interopDefault(_selectField);
var _templateTag = require("./TemplateTag");
var _templateTagDefault = parcelHelpers.interopDefault(_templateTag);
var _horizontalContainer = require("../../../components/structure/HorizontalContainer");
var _horizontalContainerDefault = parcelHelpers.interopDefault(_horizontalContainer);
var _confirmationDialog = require("../../../components/structure/ConfirmationDialog");
var _confirmationDialogDefault = parcelHelpers.interopDefault(_confirmationDialog);
var _deleteConfirmation = require("../../featureContent/components/DeleteConfirmation");
var _deleteConfirmationDefault = parcelHelpers.interopDefault(_deleteConfirmation);
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const linkIcon = require("afa81cd751f9f2c3");
const fieldPreviewIcon = require("b044413c3a0ab677");
const fieldPreviewIconBlue = require("d0067a05a87d0acd");
const helpIconBlue = require("7cce781ed52e5d3c");
const helpIcon = require("ccd3e429ebac0a04");
const addImageIcon = require("209246c38719db08");
const addCircle = require("4e904c4e91fbedc1");
const deleteIcon = require("adf0001c56331e2a");
class TemplateSetupEditor extends (0, _reactDefault.default).Component {
    constructor(props){
        super(props);
        (0, _definePropertyDefault.default)(this, "handleTitleChange", (e)=>{
            const template = this.props.templateConfiguration;
            template.name = e.target.value;
            this.props.onChange(template);
        });
        (0, _definePropertyDefault.default)(this, "handleFinalizeUrlChange", (e)=>{
            const template = this.props.templateConfiguration;
            template.finalizeFormUrl = e.target.value;
            this.props.onChange(template);
        });
        (0, _definePropertyDefault.default)(this, "handleDynamicUrlChange", (e)=>{
            const template = this.props.templateConfiguration;
            template.dynamicFormUrl = e.target.value;
            this.props.onChange(template);
        });
        (0, _definePropertyDefault.default)(this, "handleShortDescriptionChange", (e)=>{
            const template = this.props.templateConfiguration;
            template.shortDescription = e.target.value;
            this.props.onChange(template);
        });
        (0, _definePropertyDefault.default)(this, "handleMarkdownChange", (markdown)=>{
            const template = this.props.templateConfiguration;
            template.templateForm.instructionsMarkdown = markdown;
            this.props.onChange(template);
            this.setState({
                ...this.state,
                isMarkdownOpen: false
            });
        });
        (0, _definePropertyDefault.default)(this, "handleVersionNameChange", (e)=>{
            const template = this.props.templateConfiguration;
            if (!template.currentVersion) template.currentVersion = {
                versionName: e.target.value
            };
            else template.currentVersion.versionName = e.target.value;
            template.currentVersion.id = null;
            template.currentVersion.createdDate = null;
            this.props.onChange(template);
        });
        (0, _definePropertyDefault.default)(this, "handleReleaseNotesChange", (e)=>{
            const template = this.props.templateConfiguration;
            if (!template.currentVersion) template.currentVersion = {
                versionName: "1.0",
                releaseNotes: e.target.value
            };
            else template.currentVersion.releaseNotes = e.target.value;
            template.currentVersion.id = null;
            template.currentVersion.createdDate = null;
            this.props.onChange(template);
        });
        (0, _definePropertyDefault.default)(this, "handleTypeChange", (option)=>{
            const template = this.props.templateConfiguration;
            template.templateType = option.value;
            this.props.onChange(template);
        });
        (0, _definePropertyDefault.default)(this, "getLanguageGroups", ()=>{
            var dict = (0, _lodashDefault.default).groupBy(this.props.templateConfiguration?.templateApplication?.languages ?? [], (l)=>l.languageGroupCode);
            var groups = Object.keys(dict).map((key)=>({
                    key: key,
                    label: (0, _languages.getLanguageName)(key),
                    subItems: dict[key].map((lang)=>({
                            data: lang,
                            value: lang.id,
                            icon: (0, _languages.getFlagIconForLanguage)(lang),
                            label: `${(0, _languages.getLanguageName)(key)} - ${(0, _languages.getRegionyNameForLanguage)(lang)}`,
                            groupKey: key
                        }))
                }));
            groups = (0, _lodashDefault.default).sortBy(groups, (group)=>group.key);
            return groups;
        });
        this.state = {
            isMarkdownOpen: false,
            imageUrl: null,
            isDeleteConfirmationOpen: false
        };
    }
    componentDidMount() {
        // handle anchor link scrolling
        this.props.history?.listen((location)=>{
            const { hash } = location;
            if (hash !== "") // Push onto callback queue so it runs after the DOM is updated,
            // this is required when navigating from a different page so that
            // the element is rendered on the page before trying to getElementById.
            setTimeout(()=>{
                const id = hash.replace("#", "");
                const element = document.getElementById(id);
                if (element) {
                    const scrollable = element.closest(".scrollable-panel").children[0];
                    if (scrollable) scrollable.scrollTop = element.offsetTop - 30; // header offset values
                }
            }, 0);
        });
    }
    handleToggleMarkdown() {
        this.setState({
            ...this.state,
            isMarkdownOpen: !this.state.isMarkdownOpen
        });
    }
    handleToggleDeleteConfirmation() {
        this.setState({
            ...this.state,
            isDeleteConfirmationOpen: !this.state.isDeleteConfirmationOpen
        });
    }
    async handleDeleteConfirm() {
        await this.props.templateConfigurationContainer.disableTemplateConfiguration(this.props.templateConfiguration.id);
        await this.props.templateConfigurationContainer.getOrganizationTemplates(this.props.organizationId);
        this.props.history.push("/v/templates");
    }
    handleAddIndustry(industry) {
        const template = this.props.templateConfiguration;
        template.industries.push(industry);
        this.props.onChange(template);
    }
    handleAddCategory(category) {
        const template = this.props.templateConfiguration;
        template.categories.push(category);
        this.props.onChange(template);
    }
    handleRemoveIndustry(industry) {
        const template = this.props.templateConfiguration;
        (0, _lodashDefault.default).remove(template.industries, (i)=>i.id == industry.id);
        this.props.onChange(template);
    }
    handleRemoveCategory(category) {
        const template = this.props.templateConfiguration;
        (0, _lodashDefault.default).remove(template.categories, (i)=>i.id == category.id);
        this.props.onChange(template);
    }
    handleTagChange(e) {
        this.setState({
            ...this.state,
            currentTagId: e.value
        });
    }
    handleAddCurrentTag() {
        const id = this.state.currentTagId;
        if (!id) return;
        const category = this.props.templateConfigurationContainer.state.categories?.find((c)=>c.id == id);
        const industry = this.props.templateConfigurationContainer.state.industries?.find((i)=>i.id == id);
        if (category) this.handleAddCategory(category);
        else if (industry) this.handleAddIndustry(industry);
    }
    handleFilePicked(files) {
        if (files.length > 0) {
            const file = files[0];
            this.readDataUrl(file);
            this.props.mediaContainer.uploadOrganizationMedia(this.props.organizationId, file.name, file, "", ()=>{}).then((result)=>{
                if (result.resultType == "Ok") {
                    const template = this.props.templateConfiguration;
                    template.imageUrl = result.data;
                    this.props.onChange(template);
                }
            });
        } else this.setState({
            ...this.state,
            imageUrl: undefined
        });
    }
    readDataUrl(file) {
        const reader = new FileReader();
        reader.onloadend = (e)=>{
            this.setState({
                ...this.state,
                imageUrl: reader.result.toString()
            });
        };
        reader.readAsDataURL(file);
    }
    getAvailableTags() {
        const tags = this.props.templateConfigurationContainer.state.categories?.map((c)=>({
                ...c,
                type: "Category"
            }))?.concat(this.props.templateConfigurationContainer.state.industries?.map((i)=>({
                ...i,
                type: "Industry"
            })) ?? []);
        return tags?.filter((t)=>!this.props.templateConfiguration.categories?.some((c)=>c.id == t.id) && !this.props.templateConfiguration.industries?.some((i)=>i.id == t.id));
    }
    renderRadioOption(label, detail) {
        return (0, _react.jsx)(RadioOption, null, (0, _react.jsx)("p", {
            className: "radio-label"
        }, label), (0, _react.jsx)("p", {
            className: "radio-detail"
        }, detail));
    }
    render() {
        const props = this.props;
        if (!props.templateConfiguration) return (0, _react.jsx)((0, _loaderDefault.default), null);
        return (0, _react.jsx)((0, _panelContainerDefault.default), {
            className: containerStyle
        }, (0, _react.jsx)("div", {
            className: `${menuStyle} expanded`
        }, (0, _react.jsx)("div", {
            className: "fixed-wrapper"
        }, (0, _react.jsx)((0, _panelHeaderContainerDefault.default), {
            className: "template-section-menu-header"
        }, (0, _react.jsx)("h4", null, "Setup")), (0, _react.jsx)((0, _scrollablePanelBodyDefault.default), null, (0, _react.jsx)("ul", null, (0, _react.jsx)(ModuleMenuItem, null, (0, _react.jsx)((0, _reactRouterDom.Link), {
            to: "#basis"
        }, "Module Basis")), (0, _react.jsx)(ModuleMenuItem, null, (0, _react.jsx)((0, _reactRouterDom.Link), {
            to: "#info"
        }, "Basic Info")), (0, _react.jsx)(ModuleMenuItem, null, (0, _react.jsx)((0, _reactRouterDom.Link), {
            to: "#type"
        }, "Module Type")), (0, _react.jsx)(ModuleMenuItem, null, (0, _react.jsx)((0, _reactRouterDom.Link), {
            to: "#dynamicform"
        }, "Dynamic Form Endpoint")), (0, _react.jsx)(ModuleMenuItem, null, (0, _react.jsx)((0, _reactRouterDom.Link), {
            to: "#discoverability"
        }, "Discoverability")), (0, _react.jsx)(ModuleMenuItem, null, (0, _react.jsx)((0, _reactRouterDom.Link), {
            to: "#version"
        }, "Version Info")))))), (0, _react.jsx)((0, _panelContainerDefault.default), {
            className: formBodyStyle
        }, (0, _react.jsx)("div", {
            className: "form-wrapper"
        }, (0, _react.jsx)((0, _panelContainerDefault.default), null, (0, _react.jsx)("div", {
            className: middlePanelContainer
        }, (0, _react.jsx)((0, _panelHeaderContainerDefault.default), {
            className: "panel-header"
        }, (0, _react.jsx)((0, _buttonDefault.default), {
            type: "submit",
            themes: [
                "primary-small",
                "start"
            ],
            text: "Save",
            className: "save-button",
            disabled: props.isSaving,
            loading: props.isSaving
        })), " ", (0, _react.jsx)((0, _scrollablePanelBodyDefault.default), {
            className: panelBodyStyle
        }, (0, _react.jsx)("div", {
            className: mainBodyStyle
        }, (0, _react.jsx)((0, _horizontalContainerDefault.default), {
            className: "template-setup-section-header"
        }, (0, _react.jsx)("h4", null, "Setup"), (0, _react.jsx)("img", {
            src: deleteIcon,
            onClick: this.handleToggleDeleteConfirmation.bind(this)
        })), (0, _react.jsx)("p", {
            className: "section-description"
        }, "Here’s where you can set up your module and configure some of the settings that describe what it does."), (0, _react.jsx)((0, _addMarkdownButtonDefault.default), {
            onClick: this.handleToggleMarkdown.bind(this),
            hasValue: props.templateConfiguration?.templateForm?.instructionsMarkdown != null
        }), (0, _react.jsx)((0, _contentCardDefault.default), {
            title: "Module Source",
            id: "basis"
        }, props.templateConfiguration?.templateApplication ? (0, _react.jsx)((0, _reactDefault.default).Fragment, null, (0, _react.jsx)("div", {
            className: "app-container"
        }, (0, _react.jsx)((0, _applicationAvatarDefault.default), {
            app: props.templateConfiguration?.templateApplication,
            size: 32
        }), (0, _react.jsx)("h6", null, "⬥ ", props.templateConfiguration?.templateApplication?.name), (0, _react.jsx)("a", {
            href: `/v/apps/${props.templateConfiguration?.templateApplication?.id}`,
            target: "_blank"
        }, "Open ", (0, _react.jsx)("img", {
            src: linkIcon
        }))), (0, _react.jsx)((0, _horizontalSeparatorDefault.default), null), (0, _react.jsx)("div", {
            className: "languages-container"
        }, (0, _react.jsx)("h6", null, "Languages / Regions Supported"), this.getLanguageGroups()?.map((group)=>(0, _react.jsx)("div", {
                key: group.key
            }, (0, _react.jsx)("p", {
                className: "language-group-title"
            }, group.label), (0, _react.jsx)("ul", null, group.subItems?.map((lang)=>(0, _react.jsx)("li", {
                    key: lang.value
                }, (0, _react.jsx)((0, _languageCollectionAvatarDefault.default), {
                    languages: [
                        lang.data
                    ],
                    limit: 1
                }), (0, _react.jsx)("p", {
                    className: "local-title"
                }, lang.label)))))))) : (0, _react.jsx)("div", {
            className: "app-container"
        }, (0, _react.jsx)((0, _textFieldDefault.default), {
            name: "templateConfiguration.finalizeFormUrl",
            value: props.templateConfiguration.finalizeFormUrl ?? "",
            onChange: this.handleFinalizeUrlChange.bind(this),
            placeholder: "The URL of the final POST request",
            label: "Endpoint URL"
        }))), (0, _react.jsx)((0, _contentCardDefault.default), {
            title: "Module Info",
            id: "info"
        }, (0, _react.jsx)((0, _formFieldsContainerDefault.default), null, (0, _react.jsx)((0, _textFieldDefault.default), {
            label: "Module Name",
            placeholder: "Name your Module",
            name: "templateConfiguration.name",
            value: props.templateConfiguration?.name ?? "",
            required: true,
            onChange: this.handleTitleChange.bind(this)
        }), (0, _react.jsx)((0, _reactDropzoneDefault.default), {
            ref: (node)=>{
                this.dropZone = node;
            },
            onDrop: this.handleFilePicked.bind(this),
            accept: ".png,.jpg,.jpeg",
            multiple: false,
            style: dropzoneStyle
        }, (0, _react.jsx)("div", {
            className: "template-image-container"
        }, (0, _react.jsx)((0, _horizontalSeparatorDefault.default), null), (0, _react.jsx)("div", {
            className: "image-container"
        }, (0, _react.jsx)("img", {
            src: this.state.imageUrl ?? props.templateConfiguration?.imageUrl ?? addImageIcon,
            className: this.state.imageUrl ?? props.templateConfiguration?.imageUrl ? "" : "placeholder"
        })), (0, _react.jsx)("p", {
            className: "edit-option"
        }, (0, _react.jsx)("span", null, "Edit Image"), " ", (0, _react.jsx)("img", {
            src: addCircle
        })))), (0, _react.jsx)((0, _textAreaFieldDefault.default), {
            label: "Short Description",
            placeholder: "This is used in your listing",
            name: "templateConfiguration.shortDescription",
            value: props.templateConfiguration?.shortDescription ?? "",
            required: true,
            onChange: this.handleShortDescriptionChange.bind(this)
        }))), (0, _react.jsx)((0, _contentCardDefault.default), {
            title: "Module Type",
            id: "type"
        }, (0, _react.jsx)(DetailLabel, null, "What is the main focus of this module?"), (0, _react.jsx)((0, _radioGroupDefault.default), {
            value: props.templateConfiguration.templateType ?? "ContentTemplate",
            options: [
                {
                    value: "ContentTemplate",
                    detailOverride: ()=>this.renderRadioOption("Content Template", "This is a module that primarily focuses on generating and managing content within an app. It may optionally contain webhooks but they serve a supporting role to the content.")
                },
                {
                    value: "Integration",
                    detailOverride: ()=>this.renderRadioOption("Integration", "This is an integration that generates and manages webhooks to facilitate connections to other web-based services.")
                }
            ],
            onChange: this.handleTypeChange.bind(this)
        })), (0, _react.jsx)((0, _contentCardDefault.default), {
            title: "Dynamic Form Endpoint",
            id: "dynamicform"
        }, (0, _react.jsx)(DetailLabel, null, "If you are building a dynamic module form, supply the HTTP POST endpoint URL you want Voicify to send the data to."), (0, _react.jsx)((0, _textFieldDefault.default), {
            name: "templateConfiguration.dynamicFormUrl",
            value: props.templateConfiguration.dynamicFormUrl ?? "",
            onChange: this.handleDynamicUrlChange.bind(this),
            placeholder: "The URL of the intermediate POST requests",
            label: "Dynamic Form Endpoint URL"
        })), (0, _react.jsx)((0, _contentCardDefault.default), {
            title: "Discoverability",
            id: "discoverability"
        }, (0, _react.jsx)(DetailLabel, null, "Add industry and category tags that identify your module and help others find it "), (0, _react.jsx)(NewTagContainer, null, (0, _react.jsx)((0, _selectFieldDefault.default), {
            label: "Tags",
            name: "tags",
            onChange: this.handleTagChange.bind(this),
            value: this.state.currentTagId,
            placeholder: "- Type a tag to add -",
            options: this.getAvailableTags().map((t)=>({
                    label: `${t.type}: ${t.name}`,
                    value: t.id
                })),
            useFormTheme: true
        }), (0, _react.jsx)((0, _buttonDefault.default), {
            themes: [
                "primary"
            ],
            text: "Add Tag",
            onClick: ()=>this.handleAddCurrentTag(),
            disabled: this.state.currentTagId == null,
            type: "button"
        })), (0, _react.jsx)(TagContainer, null, props.templateConfiguration.categories?.map((c)=>(0, _react.jsx)((0, _templateTagDefault.default), {
                id: c.id,
                name: c.name,
                type: "Category",
                onRemove: ()=>this.handleRemoveCategory(c)
            })), props.templateConfiguration.industries?.map((c)=>(0, _react.jsx)((0, _templateTagDefault.default), {
                id: c.id,
                name: c.name,
                type: "Industry",
                onRemove: ()=>this.handleRemoveIndustry(c)
            })))), (0, _react.jsx)((0, _contentCardDefault.default), {
            title: "Version Info",
            id: "version"
        }, (0, _react.jsx)(DetailLabel, null, "Give your version name and latest update notes to help consumers of this module understand what they get."), (0, _react.jsx)((0, _formFieldsContainerDefault.default), null, (0, _react.jsx)((0, _textFieldDefault.default), {
            label: "Version Name",
            placeholder: "1.0",
            name: "templateConfiguration.currentVersion.versionName",
            value: props.templateConfiguration?.currentVersion?.versionName ?? "",
            required: true,
            onChange: this.handleVersionNameChange.bind(this)
        }), (0, _react.jsx)((0, _textAreaFieldDefault.default), {
            label: "Release Notes",
            placeholder: "Content updates",
            name: "templateConfiguration.currentVersion.releaseNotes",
            value: props.templateConfiguration?.currentVersion?.releaseNotes ?? "",
            onChange: this.handleReleaseNotesChange.bind(this)
        }))), this.state.isMarkdownOpen && (0, _react.jsx)((0, _markdownEditorModalDefault.default), {
            contextTitle: "Module Overview",
            markdown: props.templateConfiguration?.templateForm?.instructionsMarkdown ?? "",
            onSave: this.handleMarkdownChange.bind(this),
            onClose: this.handleToggleMarkdown.bind(this)
        })))), (0, _react.jsx)((0, _tabContainerPanelDefault.default), {
            tabs: [
                {
                    title: "Preview",
                    icon: fieldPreviewIcon,
                    selectedIcon: fieldPreviewIconBlue
                },
                {
                    title: "Helpful Info",
                    icon: helpIcon,
                    selectedIcon: helpIconBlue
                }
            ]
        }, (0, _react.jsx)((0, _reactTabs.TabPanel), null, (0, _react.jsx)((0, _scrollablePanelBodyDefault.default), {
            className: mainBodyStyle
        }, (0, _react.jsx)("h4", null, "Preview"), (0, _react.jsx)("p", {
            className: "section-description"
        }, "Here’s a preview of how your module will look in the listing"), this.props.templateConfiguration && (0, _react.jsx)((0, _moduleCardDefault.default), {
            applicationId: null,
            templateConfiguration: props.templateConfiguration
        }))), (0, _react.jsx)((0, _reactTabs.TabPanel), null, (0, _react.jsx)((0, _scrollablePanelBodyDefault.default), {
            className: mainBodyStyle
        }, (0, _react.jsx)((0, _markdownPreviewDefault.default), {
            instructionsMarkdown: props.templateConfiguration?.templateForm?.instructionsMarkdown ?? ""
        })))))), this.state.isDeleteConfirmationOpen && (0, _react.jsx)((0, _confirmationDialogDefault.default), {
            title: "Delete",
            deleteText: "Yes, Delete",
            isLoading: this.props.templateConfigurationContainer.state.isLoading,
            onClose: this.handleToggleDeleteConfirmation.bind(this),
            onConfirm: this.handleDeleteConfirm.bind(this)
        }, (0, _react.jsx)((0, _deleteConfirmationDefault.default), {
            itemLabel: " this module? Content generated with it will not be deleted though will become unable to be updated using it."
        }))));
    }
}
const NewTagContainer = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1eub92f4"
})(`
    display: flex;
    width: 100%;
    align-items: flex-end;
    >div {
        flex: 1;
        margin: 0;
    }
    button {
        margin: 0;
        margin-left: 16px;
        width: 128px;
    }
`, "");
const TagContainer = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1eub92f3"
})(`
    display: flex;
    flex-direction: column;
    align-items: start;
    margin: 24px 0;
    > * {
        margin-top: 8px;
    }
`, "");
const RadioOption = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1eub92f2"
})(`
    margin: 16px 0;
    .radio-label {
        font-size: 16px;
        line-height: 24px;
    }
    .radio-detail {
        margin-top: 8px;
        font-size: 14px;
        line-height: 20px;
    }
`, "");
const DetailLabel = /*#__PURE__*/ (0, _baseDefault.default)("p", {
    target: "e1eub92f1"
})(`
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 20px;
    color: ${(0, _colors.color_text_light)};
    margin: 24px 0;
`, "");
const middlePanelContainer = /*#__PURE__*/ (0, _css.css)("flex:1;border-right:1px solid ", (0, _colors.color_shades_dark), ";.panel-header{button{margin:0;}.save-button{margin-left:32px;}.next-button{margin-right:32px;}.prev-button{margin-right:16px;margin-left:auto;}}", "");
const containerStyle = /*#__PURE__*/ (0, _css.css)("background:", (0, _colors.color_variants_main_bg), ";.form-wrapper{flex:1;min-width:600px;}.empty-indicator{width:100%;height:100%;display:flex;align-items:center;justify-content:center;}.page-indicator-container{background:", (0, _colors.color_shades_lighter), ";border:1px solid ", (0, _colors.color_shades_dark), ";box-sizing:border-box;border-radius:4px;margin:0 32px;height:32px;display:flex;align-items:center;justify-content:center;padding:0 16px;}.template-section-menu-header{h4{font-family:Muli;font-style:normal;font-weight:normal;font-size:16px;line-height:24px;margin:0 32px;}button{margin-right:16px;margin-left:auto;}}.template-setup-section-header{display:flex;img{margin-left:auto;cursor:pointer;width:24px;height:24px;margin-top:4px;}h4{font-family:Muli;font-style:normal;font-weight:normal;font-size:24px;line-height:32px;}}.overview-empty-label{padding:32px;margin:32px;border:1px solid ", (0, _colors.color_shades_dark), ";border-radius:8px;text-align:center;font-style:italic;font-weight:normal;font-size:14px;line-height:20px;}.module-card{>div{margin-left:0;}}", "");
const formBodyStyle = /*#__PURE__*/ (0, _css.css)("border-right:1px solid ", (0, _colors.color_shades_dark), ";box-sizing:border-box;.scrollable-body{padding-bottom:56px;}", "");
const panelBodyStyle = /*#__PURE__*/ (0, _css.css)({
    name: "zbunnm",
    styles: "padding-top:0;min-height:100%"
});
const menuStyle = /*#__PURE__*/ (0, _css.css)("z-index:2;bottom:0;position:relative;ul{margin:16px;}&.collapsed{width:80px;.fixed-wrapper{width:80px;}}&.expanded{width:288px;.fixed-wrapper{width:288px;}}.fixed-wrapper{position:fixed;bottom:0;height:calc(100vh - 80px);background:white;border-right:1px solid ", (0, _colors.color_shades_dark), ";box-sizing:border-box;}", "");
const dropzoneStyle = {
    border: "none",
    display: "flex",
    flexDirection: "row",
    cursor: "pointer",
    color: (0, _colors.color_colors_ocean),
    margin: "32px -32px"
};
const ModuleMenuItem = /*#__PURE__*/ (0, _baseDefault.default)("li", {
    target: "e1eub92f0"
})(`
    padding-left: 16px;
    flex: 1;
    height: 32px;
    display: flex;
    align-items: center;
    font-size: 14px;
    line-height: 20px;
    cursor: pointer;
    a {
        color: ${(0, _colors.color_text_default)};
    }
    img {
        margin-right: 12px;
        width: 20px;
    }
    &.selected {
        background: ${(0, _colors.color_variants_ocean_light_1)};
        border-radius: 4px;
        color: ${(0, _colors.color_text_link)};
    }
`, "");
const mainBodyStyle = /*#__PURE__*/ (0, _css.css)("padding:24px 32px 64px 32px;h4{font-style:normal;font-weight:normal;font-size:18px;line-height:24px;color:", (0, _colors.color_text_default), ";}h5{font-style:normal;font-weight:normal;font-size:18px;line-height:24px;margin-top:32px;margin-bottom:24px;}.section-description{font-size:14px;line-height:20px;color:", (0, _colors.color_text_light), ";margin-top:16px;}.app-container{display:flex;align-items:center;padding:24px 0;h6{color:", (0, _colors.color_colors_royalty), ";font-style:normal;font-weight:normal;font-size:18px;line-height:24px;margin:0 12px;}a{display:flex;align-items:center;color:", (0, _colors.color_text_link), ";margin-right:0;margin-left:auto;img{margin-left:12px;}}}.template-image-container{width:100%;display:flex;align-items:center;position:relative;margin:32px 0;.image-container{position:absolute;width:80px;height:80px;background:white;border:", (0, _stylesValues.style_border_default), ";border-radius:8px;display:flex;align-items:center;justify-content:center;margin-left:32px;margin-bottom:16px;box-shadow:", (0, _stylesValues.style_shadow_default), ";img{max-height:100%;max-width:100%;&.placeholder{margin:16px;}}}.edit-option{display:flex;align-items:center;margin-right:0;margin-left:auto;color:", (0, _colors.color_text_link), ";margin-bottom:24px;position:absolute;right:32px;img{margin-left:8px;}}}.languages-container{margin:32px 0;h6{font-style:normal;font-weight:normal;font-size:16px;line-height:24px;margin-bottom:24px;}.language-group-title{font-style:normal;font-weight:600;font-size:14px;line-height:20px;}ul{list-style:none;margin:16px;li{display:flex;align-items:center;margin:0 16px;margin-bottom:8px;.local-title{margin:0 12px;font-style:normal;font-weight:normal;font-size:14px;line-height:20px;}}}}", "");
exports.default = TemplateSetupEditor;

},{"@babel/runtime/helpers/defineProperty":"9sJxO","@emotion/styled/base":"lSuFu","@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","../../../constants/colors":"1p3OR","../../../components/general/ApplicationAvatar":"aA2GK","../../../components/structure/ContentCard":"hJsdJ","../../../components/forms/TextField":"7a7bh","../../../components/forms/TextAreaField":"fE54C","../../../components/structure/FormFieldsContainer":"h3hzh","../../../components/structure/HorizontalSeparator":"Pw3HQ","../../../models/extensions/languages":"8E5Oo","lodash":"3hMBK","../../../components/general/LanguageCollectionAvatar":"crbMk","./AddMarkdownButton":"7gHKd","./MarkdownEditorModal":"1xj9r","react-dropzone":"46RRi","react-tabs":"92Sgf","../../../components/general/Button":"6ymxN","../../../components/structure/Panels/PanelContainer":"9R2lE","../../../components/structure/Panels/PanelHeaderContainer":"hUotd","../../../components/structure/Panels/TabContainerPanel":"iDHIJ","../../../components/structure/ScrollablePanelBody":"6LRg3","./MarkdownPreview":"6erDD","../../applicationModules/components/ModuleCard":"gK70m","react-router-dom":"5fzqq","../../../components/general/Loader":"bnV5T","../../../constants/stylesValues":"dHVVv","../../../components/forms/RadioGroup":"eiGrn","../../../components/forms/SelectField":"405B3","./TemplateTag":"3mzw3","../../../components/structure/HorizontalContainer":"eJPfh","../../../components/structure/ConfirmationDialog":"kx7yK","../../featureContent/components/DeleteConfirmation":"9xK2d","afa81cd751f9f2c3":"9mnp5","b044413c3a0ab677":"dF0fv","d0067a05a87d0acd":"7vpvL","7cce781ed52e5d3c":"lH5BG","ccd3e429ebac0a04":"ai6EJ","209246c38719db08":"lQDx7","4e904c4e91fbedc1":"cl9rg","adf0001c56331e2a":"bG6Op","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7gHKd":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _colors = require("../../../constants/colors");
const helpIcon = require("5a015e01b00e4d6c");
const includedIcon = require("ef7a20c3b661b8c8");
const AddMarkdownButton = (props)=>(0, _react.jsx)("button", {
        className: containerStyle,
        onClick: props.onClick,
        type: "button"
    }, (0, _react.jsx)("div", {
        className: "left-side"
    }, (0, _react.jsx)("img", {
        src: helpIcon
    }), (0, _react.jsx)("p", null, "Helpful Info "), props.hasValue && (0, _react.jsx)((0, _reactDefault.default).Fragment, null, (0, _react.jsx)("p", null, "\xa0- Included\xa0"), (0, _react.jsx)("img", {
        src: includedIcon
    }))), (0, _react.jsx)("p", {
        className: "right-side"
    }, props.hasValue ? "View/Edit" : "Add Info +"));
const containerStyle = /*#__PURE__*/ (0, _css.css)("height:48px;flex:1;width:100%;border:1px solid ", (0, _colors.color_colors_ocean), ";color:", (0, _colors.color_colors_ocean), ";background:none;border-radius:8px;cursor:pointer;display:flex;align-items:center;padding:0 24px;margin:24px 0;.left-side{display:flex;align-items:center;img{margin-right:8px;}}.right-side{margin-right:0;margin-left:auto;}", "");
exports.default = AddMarkdownButton;

},{"@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","../../../constants/colors":"1p3OR","5a015e01b00e4d6c":"hVXoR","ef7a20c3b661b8c8":"4JWF8","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hVXoR":[function(require,module,exports) {
module.exports = require("58fc9b8fc0fde539").getBundleURL("kVLro") + require("e8fe56c54772e1e0").resolve("iCjjG");

},{"58fc9b8fc0fde539":"c7Tr5","e8fe56c54772e1e0":"fyJL2"}],"4JWF8":[function(require,module,exports) {
module.exports = require("ca6b332b8f0232e").getBundleURL("kVLro") + require("407624a41da4d8e8").resolve("kHAjM");

},{"ca6b332b8f0232e":"c7Tr5","407624a41da4d8e8":"fyJL2"}],"1xj9r":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _modalLayout = require("../../../components/structure/ModalLayout");
var _modalLayoutDefault = parcelHelpers.interopDefault(_modalLayout);
var _modalHeader = require("../../../components/general/ModalHeader");
var _modalHeaderDefault = parcelHelpers.interopDefault(_modalHeader);
var _footerBar = require("../../../components/structure/FooterBar");
var _footerBarDefault = parcelHelpers.interopDefault(_footerBar);
var _button = require("../../../components/general/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _indexCss = require("react-markdown-editor-lite/lib/index.css");
var _reactMarkdownEditorLite = require("react-markdown-editor-lite");
var _reactMarkdownEditorLiteDefault = parcelHelpers.interopDefault(_reactMarkdownEditorLite);
var _markdownPreview = require("./MarkdownPreview");
var _markdownPreviewDefault = parcelHelpers.interopDefault(_markdownPreview);
var _panelContainer = require("../../../components/structure/Panels/PanelContainer");
var _panelContainerDefault = parcelHelpers.interopDefault(_panelContainer);
var _colors = require("../../../constants/colors");
var _customScrollbars = require("../../../components/structure/CustomScrollbars");
var _customScrollbarsDefault = parcelHelpers.interopDefault(_customScrollbars);
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const quoteIcon = require("61b926fecdd30241");
const codeIcon = require("9a57ca5995f70861");
const linkIcon = require("17d11f46f0905550");
const imageIcon = require("76893b72aae84d28");
const tableIcon = require("810bce30d904c579");
const listIcon = require("10c37ded565ce3a0");
const list2Icon = require("35c51b0a375b31d5");
const textIcon = require("e6653a97d2127f9e");
const boldIcon = require("2e440a859711ab8c");
const italicsIcon = require("c87fb4a55ba0b026");
const strikethroughIcon = require("621879d1ba6b4651");
class MarkdownEditorModal extends (0, _reactDefault.default).Component {
    constructor(props){
        super(props);
        this.state = {
            markdown: props.markdown
        };
    }
    componentDidUpdate(prevProps) {
        if (prevProps.markdown != this.props.markdown) this.setState({
            ...this.state,
            markdown: this.props.markdown
        });
    }
    handleChange(value) {
        this.setState({
            ...this.state,
            markdown: value.text
        });
    }
    render() {
        return (0, _react.jsx)((0, _modalLayoutDefault.default), {
            isVisible: true,
            onClose: this.props.onClose
        }, (0, _react.jsx)((0, _modalHeaderDefault.default), {
            title: "Helpful Information",
            onClose: this.props.onClose
        }), (0, _react.jsx)((0, _panelContainerDefault.default), {
            className: containerStyle
        }, (0, _react.jsx)("div", {
            className: `${sharedPanel} ${editorPanel}`
        }, (0, _react.jsx)("h3", null, this.props.contextTitle), (0, _react.jsx)("p", null, "Insert markdown here to better explain to users what will happen with the information they provide"), (0, _react.jsx)("div", {
            className: "editor-wrapper"
        }, (0, _react.jsx)((0, _reactMarkdownEditorLiteDefault.default), {
            value: this.state.markdown,
            style: {
                flex: 1,
                height: "100%"
            },
            config: {
                view: {
                    html: false,
                    menu: true,
                    md: true
                },
                canView: {
                    html: false
                }
            },
            renderHTML: (text)=>null,
            markdownClass: markdownContainer,
            onChange: this.handleChange.bind(this)
        }))), (0, _react.jsx)("div", {
            className: `${sharedPanel} ${previewPanel}`
        }, (0, _react.jsx)("h3", null, "Preview"), (0, _react.jsx)("p", null, "Here’s what will be displayed"), (0, _react.jsx)("div", {
            className: "editor-wrapper preview"
        }, (0, _react.jsx)((0, _customScrollbarsDefault.default), null, (0, _react.jsx)((0, _markdownPreviewDefault.default), {
            instructionsMarkdown: this.state.markdown
        }))))), (0, _react.jsx)((0, _footerBarDefault.default), null, (0, _react.jsx)((0, _buttonDefault.default), {
            themes: [
                "primary"
            ],
            text: "Save",
            type: "button",
            onClick: ()=>this.props.onSave(this.state.markdown)
        }), (0, _react.jsx)((0, _buttonDefault.default), {
            themes: [
                "secondary"
            ],
            text: "Clear All",
            type: "button",
            onClick: ()=>this.props.onSave("")
        }), (0, _react.jsx)((0, _buttonDefault.default), {
            themes: [
                "secondary",
                "end"
            ],
            text: "Cancel",
            type: "button",
            onClick: this.props.onClose
        })));
    }
}
const containerStyle = /*#__PURE__*/ (0, _css.css)({
    name: "p15py",
    styles: "margin-bottom:160px;padding-bottom:160px"
});
const sharedPanel = /*#__PURE__*/ (0, _css.css)("flex:1;padding:32px;display:flex;flex-direction:column;flex-shrink:0;width:50%;h3{font-style:normal;font-weight:normal;font-size:18px;line-height:24px;padding-bottom:16px;border-bottom:1px solid ", (0, _colors.color_shades_dark), ";}p{margin:16px 0;font-style:normal;font-weight:normal;font-size:14px;line-height:20px;}.editor-wrapper{border:1px solid ", (0, _colors.color_shades_dark), ";border-radius:8px;background:white;flex:1;overflow:hidden;.rc-md-navigation{height:52px;.button-wrap{.button{width:20px;height:20px;margin:8px;}}.drop-wrap{top:20px;}.button-type-header{i{::before{content:url(", textIcon, ");}}}.button-type-bold{i{::before{content:url(", boldIcon, ");}}}.button-type-italic{i{::before{content:url(", italicsIcon, ");}}}.button-type-underline{display:none;i{::before{content:url(", textIcon, ");}}}.button-type-strikethrough{i{::before{content:url(", strikethroughIcon, ");}}}.button-type-unordered{i{::before{content:url(", listIcon, ");}}}.button-type-ordered{i{::before{content:url(", list2Icon, ");}}}.button-type-quote{i{::before{content:url(", quoteIcon, ");}}}.button-type-hr{display:none;i{::before{content:url(", textIcon, ");}}}.button-type-inlinecode{display:none;i{::before{content:url(", textIcon, ");}}}.button-type-code{i{::before{content:url(", codeIcon, ");}}}.button-type-table{i{::before{content:url(", tableIcon, ");}}}.button-type-image{i{::before{content:url(", imageIcon, ");}}}.button-type-link{i{::before{content:url(", linkIcon, ");}}}.button-type-clear{display:none;i{::before{content:url(", textIcon, ");}}}.button-type-undo{display:none;i{::before{content:url(", textIcon, ");}}}.button-type-redo{display:none;i{::before{content:url(", textIcon, ");}}}}}.instructions{padding:32px;}", "");
const previewPanel = /*#__PURE__*/ (0, _css.css)("background:", (0, _colors.color_shades_lighter), ";border-left:1px solid ", (0, _colors.color_shades_dark), ";", "");
const editorPanel = /*#__PURE__*/ (0, _css.css)("background:", (0, _colors.page_primary_background), ";", "");
const markdownContainer = /*#__PURE__*/ (0, _css.css)("", "");
exports.default = MarkdownEditorModal;

},{"@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","../../../components/structure/ModalLayout":"b1cO3","../../../components/general/ModalHeader":"aUACx","../../../components/structure/FooterBar":"bibRL","../../../components/general/Button":"6ymxN","react-markdown-editor-lite/lib/index.css":"ziFXd","react-markdown-editor-lite":"hUwpQ","./MarkdownPreview":"6erDD","../../../components/structure/Panels/PanelContainer":"9R2lE","../../../constants/colors":"1p3OR","../../../components/structure/CustomScrollbars":"50vFq","61b926fecdd30241":"bI4XO","9a57ca5995f70861":"debi3","17d11f46f0905550":"hULAg","76893b72aae84d28":"9pjdp","810bce30d904c579":"569nE","10c37ded565ce3a0":"hWrKM","35c51b0a375b31d5":"g9lbq","e6653a97d2127f9e":"fhHWT","2e440a859711ab8c":"ax7CO","c87fb4a55ba0b026":"jM7uU","621879d1ba6b4651":"eXPtl","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"ziFXd":[function() {},{}],"hUwpQ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// 导出实用工具
parcelHelpers.export(exports, "getDecorated", ()=>(0, _decorateDefault.default)) // 导出内置插件
;
// 导出工具组件
parcelHelpers.export(exports, "DropList", ()=>(0, _indexDefault.default));
parcelHelpers.export(exports, "PluginComponent", ()=>(0, _plugin.PluginComponent));
parcelHelpers.export(exports, "Plugins", ()=>Plugins);
var _editor = require("./editor");
var _editorDefault = parcelHelpers.interopDefault(_editor);
var _autoResize = require("./plugins/autoResize");
var _autoResizeDefault = parcelHelpers.interopDefault(_autoResize);
var _codeBlock = require("./plugins/block/code-block");
var _codeBlockDefault = parcelHelpers.interopDefault(_codeBlock);
var _codeInline = require("./plugins/block/code-inline");
var _codeInlineDefault = parcelHelpers.interopDefault(_codeInline);
var _quote = require("./plugins/block/quote");
var _quoteDefault = parcelHelpers.interopDefault(_quote);
var _wrap = require("./plugins/block/wrap");
var _wrapDefault = parcelHelpers.interopDefault(_wrap);
var _clear = require("./plugins/clear");
var _clearDefault = parcelHelpers.interopDefault(_clear);
var _bold = require("./plugins/font/bold");
var _boldDefault = parcelHelpers.interopDefault(_bold);
var _italic = require("./plugins/font/italic");
var _italicDefault = parcelHelpers.interopDefault(_italic);
var _strikethrough = require("./plugins/font/strikethrough");
var _strikethroughDefault = parcelHelpers.interopDefault(_strikethrough);
var _underline = require("./plugins/font/underline");
var _underlineDefault = parcelHelpers.interopDefault(_underline);
var _fullScreen = require("./plugins/fullScreen");
var _fullScreenDefault = parcelHelpers.interopDefault(_fullScreen);
var _header = require("./plugins/header");
var _headerDefault = parcelHelpers.interopDefault(_header);
var _image = require("./plugins/Image");
var _imageDefault = parcelHelpers.interopDefault(_image);
var _link = require("./plugins/link");
var _linkDefault = parcelHelpers.interopDefault(_link);
var _ordered = require("./plugins/list/ordered");
var _orderedDefault = parcelHelpers.interopDefault(_ordered);
var _unordered = require("./plugins/list/unordered");
var _unorderedDefault = parcelHelpers.interopDefault(_unordered);
var _logger = require("./plugins/logger");
var _loggerDefault = parcelHelpers.interopDefault(_logger);
var _modeToggle = require("./plugins/modeToggle");
var _modeToggleDefault = parcelHelpers.interopDefault(_modeToggle);
var _table = require("./plugins/table");
var _tableDefault = parcelHelpers.interopDefault(_table);
var _tabInsert = require("./plugins/tabInsert");
var _tabInsertDefault = parcelHelpers.interopDefault(_tabInsert);
var _plugin = require("./plugins/Plugin");
var _index = require("./components/DropList/index"); // 注册默认插件
var _indexDefault = parcelHelpers.interopDefault(_index);
var _decorate = require("./utils/decorate");
var _decorateDefault = parcelHelpers.interopDefault(_decorate);
(0, _editorDefault.default).use((0, _headerDefault.default));
(0, _editorDefault.default).use((0, _boldDefault.default));
(0, _editorDefault.default).use((0, _italicDefault.default));
(0, _editorDefault.default).use((0, _underlineDefault.default));
(0, _editorDefault.default).use((0, _strikethroughDefault.default));
(0, _editorDefault.default).use((0, _unorderedDefault.default));
(0, _editorDefault.default).use((0, _orderedDefault.default));
(0, _editorDefault.default).use((0, _quoteDefault.default));
(0, _editorDefault.default).use((0, _wrapDefault.default));
(0, _editorDefault.default).use((0, _codeInlineDefault.default));
(0, _editorDefault.default).use((0, _codeBlockDefault.default));
(0, _editorDefault.default).use((0, _tableDefault.default));
(0, _editorDefault.default).use((0, _imageDefault.default));
(0, _editorDefault.default).use((0, _linkDefault.default));
(0, _editorDefault.default).use((0, _clearDefault.default));
(0, _editorDefault.default).use((0, _loggerDefault.default));
(0, _editorDefault.default).use((0, _modeToggleDefault.default));
(0, _editorDefault.default).use((0, _fullScreenDefault.default)); // 导出声明
var Plugins = {
    Header: (0, _headerDefault.default),
    FontBold: (0, _boldDefault.default),
    FontItalic: (0, _italicDefault.default),
    FontUnderline: (0, _underlineDefault.default),
    FontStrikethrough: (0, _strikethroughDefault.default),
    ListUnordered: (0, _unorderedDefault.default),
    ListOrdered: (0, _orderedDefault.default),
    BlockQuote: (0, _quoteDefault.default),
    BlockWrap: (0, _wrapDefault.default),
    BlockCodeInline: (0, _codeInlineDefault.default),
    BlockCodeBlock: (0, _codeBlockDefault.default),
    Table: (0, _tableDefault.default),
    Image: (0, _imageDefault.default),
    Link: (0, _linkDefault.default),
    Clear: (0, _clearDefault.default),
    Logger: (0, _loggerDefault.default),
    ModeToggle: (0, _modeToggleDefault.default),
    FullScreen: (0, _fullScreenDefault.default),
    AutoResize: (0, _autoResizeDefault.default),
    TabInsert: (0, _tabInsertDefault.default)
}; // 导出编辑器
exports.default = (0, _editorDefault.default);

},{"./editor":"dM3Kw","./plugins/autoResize":"a38J0","./plugins/block/code-block":"7z2GQ","./plugins/block/code-inline":"Hhbjh","./plugins/block/quote":"4ImJa","./plugins/block/wrap":"30ho2","./plugins/clear":"9LnVm","./plugins/font/bold":"bL5zM","./plugins/font/italic":"l94AL","./plugins/font/strikethrough":"a8naS","./plugins/font/underline":"7CSgF","./plugins/fullScreen":"44SSq","./plugins/header":"htJjW","./plugins/Image":"d8iaO","./plugins/link":"ixair","./plugins/list/ordered":"jnKYB","./plugins/list/unordered":"6413x","./plugins/logger":"1Z7Hb","./plugins/modeToggle":"iZzKX","./plugins/table":"9nOE0","./plugins/tabInsert":"ltHNI","./plugins/Plugin":"iqHiK","./components/DropList/index":"4RHe8","./utils/decorate":"g9qnH","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"dM3Kw":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _extends = require("@babel/runtime/helpers/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _assertThisInitialized = require("@babel/runtime/helpers/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inheritsLoose = require("@babel/runtime/helpers/inheritsLoose");
var _inheritsLooseDefault = parcelHelpers.interopDefault(_inheritsLoose);
var _react = require("react");
var _uuid = require("uuid");
var _icon = require("../components/Icon");
var _iconDefault = parcelHelpers.interopDefault(_icon);
var _navigationBar = require("../components/NavigationBar");
var _navigationBarDefault = parcelHelpers.interopDefault(_navigationBar);
var _toolBar = require("../components/ToolBar");
var _toolBarDefault = parcelHelpers.interopDefault(_toolBar);
var _i18N = require("../i18n");
var _i18NDefault = parcelHelpers.interopDefault(_i18N);
var _divider = require("../plugins/divider");
var _dividerDefault = parcelHelpers.interopDefault(_divider);
var _emitter = require("../share/emitter");
var _emitterDefault = parcelHelpers.interopDefault(_emitter);
var _var = require("../share/var");
var _decorate = require("../utils/decorate");
var _decorateDefault = parcelHelpers.interopDefault(_decorate);
var _mergeConfig = require("../utils/mergeConfig");
var _mergeConfigDefault = parcelHelpers.interopDefault(_mergeConfig);
var _tool = require("../utils/tool");
var _uploadPlaceholder = require("../utils/uploadPlaceholder");
var _uploadPlaceholderDefault = parcelHelpers.interopDefault(_uploadPlaceholder);
var _defaultConfig = require("./defaultConfig");
var _defaultConfigDefault = parcelHelpers.interopDefault(_defaultConfig);
var _preview = require("./preview");
function _createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
var Editor = /*#__PURE__*/ function(_React$Component) {
    (0, _inheritsLooseDefault.default)(Editor, _React$Component);
    /**
   * Register plugin
   * @param {any} comp Plugin component
   * @param {any} config Other configs
   */ Editor.use = function use(comp, config) {
        if (config === void 0) config = {};
        // Check for duplicate plugins
        for(var i = 0; i < Editor.plugins.length; i++)if (Editor.plugins[i].comp === comp) {
            Editor.plugins.splice(i, 1, {
                comp: comp,
                config: config
            });
            return;
        }
        Editor.plugins.push({
            comp: comp,
            config: config
        });
    } /**
   * Unregister plugin
   * @param {any} comp Plugin component
   */ ;
    Editor.unuse = function unuse(comp) {
        for(var i = 0; i < Editor.plugins.length; i++)if (Editor.plugins[i].comp === comp) {
            Editor.plugins.splice(i, 1);
            return;
        }
    } /**
   * Unregister all plugins
   * @param {any} comp Plugin component
   */ ;
    Editor.unuseAll = function unuseAll() {
        Editor.plugins = [];
    } /**
   * Locales
   */ ;
    function Editor(props) {
        var _this;
        _this = _React$Component.call(this, props) || this;
        _this.nodeMdText = /*#__PURE__*/ _react.createRef();
        _this.nodeMdPreview = /*#__PURE__*/ _react.createRef();
        _this.nodeMdPreviewWrapper = /*#__PURE__*/ _react.createRef();
        _this.hasContentChanged = true;
        _this.composing = false;
        _this.pluginApis = new Map();
        _this.scrollScale = 1;
        _this.isSyncingScroll = false;
        _this.shouldSyncScroll = "md";
        _this.keyboardListeners = [];
        _this.emitter = new (0, _emitterDefault.default)();
        _this.config = (0, _mergeConfigDefault.default)((0, _defaultConfigDefault.default), _this.props.config, _this.props);
        _this.state = {
            text: (_this.props.value || _this.props.defaultValue || "").replace(/↵/g, "\n"),
            html: "",
            view: _this.config.view || (0, _defaultConfigDefault.default).view,
            fullScreen: false,
            plugins: _this.getPlugins()
        };
        if (_this.config.canView && !_this.config.canView.menu) _this.state.view.menu = false;
        _this.nodeMdText = /*#__PURE__*/ _react.createRef();
        _this.nodeMdPreviewWrapper = /*#__PURE__*/ _react.createRef();
        _this.handleChange = _this.handleChange.bind((0, _assertThisInitializedDefault.default)(_this));
        _this.handlePaste = _this.handlePaste.bind((0, _assertThisInitializedDefault.default)(_this));
        _this.handleDrop = _this.handleDrop.bind((0, _assertThisInitializedDefault.default)(_this));
        _this.handleToggleMenu = _this.handleToggleMenu.bind((0, _assertThisInitializedDefault.default)(_this));
        _this.handleKeyDown = _this.handleKeyDown.bind((0, _assertThisInitializedDefault.default)(_this));
        _this.handleEditorKeyDown = _this.handleEditorKeyDown.bind((0, _assertThisInitializedDefault.default)(_this));
        _this.handleLocaleUpdate = _this.handleLocaleUpdate.bind((0, _assertThisInitializedDefault.default)(_this));
        _this.handleFocus = _this.handleFocus.bind((0, _assertThisInitializedDefault.default)(_this));
        _this.handleBlur = _this.handleBlur.bind((0, _assertThisInitializedDefault.default)(_this));
        _this.handleInputScroll = _this.handleSyncScroll.bind((0, _assertThisInitializedDefault.default)(_this), "md");
        _this.handlePreviewScroll = _this.handleSyncScroll.bind((0, _assertThisInitializedDefault.default)(_this), "html");
        return _this;
    }
    var _proto = Editor.prototype;
    _proto.componentDidMount = function componentDidMount() {
        var text = this.state.text;
        this.renderHTML(text);
        (0, _emitter.globalEmitter).on((0, _emitter.globalEmitter).EVENT_LANG_CHANGE, this.handleLocaleUpdate); // init i18n
        (0, _i18NDefault.default).setUp();
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        (0, _emitter.globalEmitter).off((0, _emitter.globalEmitter).EVENT_LANG_CHANGE, this.handleLocaleUpdate);
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        if (typeof this.props.value !== "undefined" && this.props.value !== this.state.text) {
            var value = this.props.value;
            if (typeof value !== "string") value = String(value).toString();
            value = value.replace(/↵/g, "\n");
            if (this.state.text !== value) {
                this.setState({
                    text: value
                });
                this.renderHTML(value);
            }
        }
        if (prevProps.plugins !== this.props.plugins) this.setState({
            plugins: this.getPlugins()
        });
    };
    _proto.isComposing = function isComposing() {
        return this.composing;
    };
    _proto.getPlugins = function getPlugins() {
        var _this2 = this;
        var plugins = [];
        if (this.props.plugins) {
            // If plugins option is configured, use only specified plugins
            var addToPlugins = function addToPlugins(name) {
                if (name === (0, _dividerDefault.default).pluginName) {
                    plugins.push({
                        comp: (0, _dividerDefault.default),
                        config: {}
                    });
                    return;
                }
                for(var _iterator = _createForOfIteratorHelperLoose(Editor.plugins), _step; !(_step = _iterator()).done;){
                    var it = _step.value;
                    if (it.comp.pluginName === name) {
                        plugins.push(it);
                        return;
                    }
                }
            };
            for(var _iterator2 = _createForOfIteratorHelperLoose(this.props.plugins), _step2; !(_step2 = _iterator2()).done;){
                var name = _step2.value;
                // Special handling of fonts to ensure backward compatibility
                if (name === "fonts") {
                    addToPlugins("font-bold");
                    addToPlugins("font-italic");
                    addToPlugins("font-underline");
                    addToPlugins("font-strikethrough");
                    addToPlugins("list-unordered");
                    addToPlugins("list-ordered");
                    addToPlugins("block-quote");
                    addToPlugins("block-wrap");
                    addToPlugins("block-code-inline");
                    addToPlugins("block-code-block");
                } else addToPlugins(name);
            }
        } else // Use all registered plugins
        plugins = [].concat(Editor.plugins);
        var result = {};
        plugins.forEach(function(it) {
            if (typeof result[it.comp.align] === "undefined") result[it.comp.align] = [];
            var key = it.comp.pluginName === "divider" ? (0, _uuid.v4)() : it.comp.pluginName;
            result[it.comp.align].push(/*#__PURE__*/ _react.createElement(it.comp, {
                editor: _this2,
                editorConfig: _this2.config,
                config: (0, _extendsDefault.default)({}, it.comp.defaultConfig || {}, it.config || {}),
                key: key
            }));
        });
        return result;
    } // sync left and right section's scroll
    ;
    _proto.handleSyncScroll = function handleSyncScroll(type, e) {
        var _this3 = this;
        // prevent loop
        if (type !== this.shouldSyncScroll) return;
         // trigger events
        if (this.props.onScroll) this.props.onScroll(e, type);
        this.emitter.emit(this.emitter.EVENT_SCROLL, e, type); // should sync scroll?
        var _this$config$syncScro = this.config.syncScrollMode, syncScrollMode = _this$config$syncScro === void 0 ? [] : _this$config$syncScro;
        if (!syncScrollMode.includes(type === "md" ? "rightFollowLeft" : "leftFollowRight")) return;
        if (this.hasContentChanged && this.nodeMdText.current && this.nodeMdPreviewWrapper.current) {
            // 计算出左右的比例
            this.scrollScale = this.nodeMdText.current.scrollHeight / this.nodeMdPreviewWrapper.current.scrollHeight;
            this.hasContentChanged = false;
        }
        if (!this.isSyncingScroll) {
            this.isSyncingScroll = true;
            requestAnimationFrame(function() {
                if (_this3.nodeMdText.current && _this3.nodeMdPreviewWrapper.current) {
                    if (type === "md") // left to right
                    _this3.nodeMdPreviewWrapper.current.scrollTop = _this3.nodeMdText.current.scrollTop / _this3.scrollScale;
                    else // right to left
                    _this3.nodeMdText.current.scrollTop = _this3.nodeMdPreviewWrapper.current.scrollTop * _this3.scrollScale;
                }
                _this3.isSyncingScroll = false;
            });
        }
    };
    _proto.renderHTML = function renderHTML(markdownText) {
        var _this4 = this;
        if (!this.props.renderHTML) {
            console.error("renderHTML props is required!");
            return Promise.resolve();
        }
        var res = this.props.renderHTML(markdownText);
        if ((0, _tool.isPromise)(res)) // @ts-ignore
        return res.then(function(r) {
            return _this4.setHtml(r);
        });
        if (typeof res === "function") return this.setHtml(res());
        return this.setHtml(res);
    };
    _proto.setHtml = function setHtml(html) {
        var _this5 = this;
        return new Promise(function(resolve) {
            _this5.setState({
                html: html
            }, resolve);
        });
    };
    _proto.handleToggleMenu = function handleToggleMenu() {
        this.setView({
            menu: !this.state.view.menu
        });
    };
    _proto.handleFocus = function handleFocus(e) {
        var onFocus = this.props.onFocus;
        if (onFocus) onFocus(e);
        this.emitter.emit(this.emitter.EVENT_FOCUS, e);
    };
    _proto.handleBlur = function handleBlur(e) {
        var onBlur = this.props.onBlur;
        if (onBlur) onBlur(e);
        this.emitter.emit(this.emitter.EVENT_BLUR, e);
    } /**
   * Text area change event
   * @param {React.ChangeEvent} e
   */ ;
    _proto.handleChange = function handleChange(e) {
        e.persist();
        var value = e.target.value; // 触发内部事件
        this.setText(value, e);
    } /**
   * Listen paste event to support paste images
   */ ;
    _proto.handlePaste = function handlePaste(e) {
        if (!this.config.allowPasteImage || !this.config.onImageUpload) return;
        var event = e.nativeEvent; // @ts-ignore
        var items = (event.clipboardData || window.clipboardData).items;
        if (items) {
            e.preventDefault();
            this.uploadWithDataTransfer(items);
        }
    } // Drag images to upload
    ;
    _proto.handleDrop = function handleDrop(e) {
        if (!this.config.onImageUpload) return;
        var event = e.nativeEvent;
        if (!event.dataTransfer) return;
        var items = event.dataTransfer.items;
        if (items) {
            e.preventDefault();
            this.uploadWithDataTransfer(items);
        }
    };
    _proto.handleEditorKeyDown = function handleEditorKeyDown(e) {
        var _this6 = this;
        var keyCode = e.keyCode, key = e.key, currentTarget = e.currentTarget;
        if ((keyCode === 13 || key === "Enter") && this.composing === false) {
            var _text = currentTarget.value;
            var curPos = currentTarget.selectionStart;
            var lineInfo = (0, _tool.getLineAndCol)(_text, curPos);
            var emptyCurrentLine = function emptyCurrentLine() {
                var newValue = currentTarget.value.substr(0, curPos - lineInfo.curLine.length) + currentTarget.value.substr(curPos);
                _this6.setText(newValue, undefined, {
                    start: curPos - lineInfo.curLine.length,
                    end: curPos - lineInfo.curLine.length
                });
                e.preventDefault();
            };
            var addSymbol = function addSymbol(symbol) {
                _this6.insertText("\n" + symbol, false, {
                    start: symbol.length + 1,
                    end: symbol.length + 1
                });
                e.preventDefault();
            }; // Enter key, check previous line
            var isSymbol = lineInfo.curLine.match(/^(\s*?)\* /);
            if (isSymbol) {
                if (/^(\s*?)\* $/.test(lineInfo.curLine)) {
                    emptyCurrentLine();
                    return;
                }
                addSymbol(isSymbol[0]);
                return;
            }
            var isOrderList = lineInfo.curLine.match(/^(\s*?)(\d+)\. /);
            if (isOrderList) {
                if (/^(\s*?)(\d+)\. $/.test(lineInfo.curLine)) {
                    emptyCurrentLine();
                    return;
                }
                var toInsert = "" + isOrderList[1] + (parseInt(isOrderList[2], 10) + 1) + ". ";
                addSymbol(toInsert);
                return;
            }
        } // 触发默认事件
        this.emitter.emit(this.emitter.EVENT_EDITOR_KEY_DOWN, e);
    } // Handle language change
    ;
    _proto.handleLocaleUpdate = function handleLocaleUpdate() {
        this.forceUpdate();
    } /**
   * Get elements
   */ ;
    _proto.getMdElement = function getMdElement() {
        return this.nodeMdText.current;
    };
    _proto.getHtmlElement = function getHtmlElement() {
        return this.nodeMdPreviewWrapper.current;
    } /**
   * Clear selected
   */ ;
    _proto.clearSelection = function clearSelection() {
        if (this.nodeMdText.current) this.nodeMdText.current.setSelectionRange(0, 0, "none");
    } /**
   * Get selected
   * @return {Selection}
   */ ;
    _proto.getSelection = function getSelection() {
        var source = this.nodeMdText.current;
        if (!source) return (0, _extendsDefault.default)({}, (0, _var.initialSelection));
        var start = source.selectionStart;
        var end = source.selectionEnd;
        var text = (source.value || "").slice(start, end);
        return {
            start: start,
            end: end,
            text: text
        };
    } /**
   * Set selected
   * @param {Selection} to
   */ ;
    _proto.setSelection = function setSelection(to) {
        if (this.nodeMdText.current) {
            this.nodeMdText.current.setSelectionRange(to.start, to.end, "forward");
            this.nodeMdText.current.focus();
        }
    } /**
   * Insert markdown text
   * @param type
   * @param option
   */ ;
    _proto.insertMarkdown = function insertMarkdown(type, option) {
        if (option === void 0) option = {};
        var curSelection = this.getSelection();
        var decorateOption = option ? (0, _extendsDefault.default)({}, option) : {};
        if (type === "image") decorateOption = (0, _extendsDefault.default)({}, decorateOption, {
            target: option.target || curSelection.text || "",
            imageUrl: option.imageUrl || this.config.imageUrl
        });
        if (type === "link") decorateOption = (0, _extendsDefault.default)({}, decorateOption, {
            linkUrl: this.config.linkUrl
        });
        if (type === "tab" && curSelection.start !== curSelection.end) {
            var curLineStart = this.getMdValue().slice(0, curSelection.start).lastIndexOf("\n") + 1;
            this.setSelection({
                start: curLineStart,
                end: curSelection.end
            });
        }
        var decorate = (0, _decorateDefault.default)(curSelection.text, type, decorateOption);
        var text = decorate.text;
        var selection = decorate.selection;
        if (decorate.newBlock) {
            var startLineInfo = (0, _tool.getLineAndCol)(this.getMdValue(), curSelection.start);
            var col = startLineInfo.col, curLine = startLineInfo.curLine;
            if (col > 0 && curLine.length > 0) {
                text = "\n" + text;
                if (selection) {
                    selection.start++;
                    selection.end++;
                }
            }
            var afterText = startLineInfo.afterText;
            if (curSelection.start !== curSelection.end) afterText = (0, _tool.getLineAndCol)(this.getMdValue(), curSelection.end).afterText;
            if (afterText.trim() !== "" && afterText.substr(0, 2) !== "\n\n") {
                if (afterText.substr(0, 1) !== "\n") text += "\n";
                text += "\n";
            }
        }
        this.insertText(text, true, selection);
    } /**
   * Insert a placeholder, and replace it when the Promise resolved
   * @param placeholder
   * @param wait
   */ ;
    _proto.insertPlaceholder = function insertPlaceholder(placeholder, wait) {
        var _this7 = this;
        this.insertText(placeholder, true);
        wait.then(function(str) {
            var text = _this7.getMdValue().replace(placeholder, str);
            _this7.setText(text);
        });
    } /**
   * Insert text
   * @param {string} value The text will be insert
   * @param {boolean} replaceSelected Replace selected text
   * @param {Selection} newSelection New selection
   */ ;
    _proto.insertText = function insertText(value, replaceSelected, newSelection) {
        if (value === void 0) value = "";
        if (replaceSelected === void 0) replaceSelected = false;
        var text = this.state.text;
        var selection = this.getSelection();
        var beforeContent = text.slice(0, selection.start);
        var afterContent = text.slice(replaceSelected ? selection.end : selection.start, text.length);
        this.setText(beforeContent + value + afterContent, undefined, newSelection ? {
            start: newSelection.start + beforeContent.length,
            end: newSelection.end + beforeContent.length
        } : {
            start: selection.start,
            end: selection.start
        });
    } /**
   * Set text, and trigger onChange event
   * @param {string} value
   * @param {any} event
   */ ;
    _proto.setText = function setText(value, event, newSelection) {
        var _this8 = this;
        if (value === void 0) value = "";
        var _this$config$onChange = this.config.onChangeTrigger, onChangeTrigger = _this$config$onChange === void 0 ? "both" : _this$config$onChange;
        var text = value.replace(/↵/g, "\n");
        if (this.state.text === value) return;
        this.setState({
            text: text
        });
        if (this.props.onChange && (onChangeTrigger === "both" || onChangeTrigger === "beforeRender")) this.props.onChange({
            text: text,
            html: this.getHtmlValue()
        }, event);
        this.emitter.emit(this.emitter.EVENT_CHANGE, value, event, typeof event === "undefined");
        if (newSelection) setTimeout(function() {
            return _this8.setSelection(newSelection);
        });
        if (!this.hasContentChanged) this.hasContentChanged = true;
        var rendering = this.renderHTML(text);
        if (onChangeTrigger === "both" || onChangeTrigger === "afterRender") rendering.then(function() {
            if (_this8.props.onChange) _this8.props.onChange({
                text: _this8.state.text,
                html: _this8.getHtmlValue()
            }, event);
        });
    } /**
   * Get text value
   * @return {string}
   */ ;
    _proto.getMdValue = function getMdValue() {
        return this.state.text;
    } /**
   * Get rendered html
   * @returns {string}
   */ ;
    _proto.getHtmlValue = function getHtmlValue() {
        if (typeof this.state.html === "string") return this.state.html;
        if (this.nodeMdPreview.current) return this.nodeMdPreview.current.getHtml();
        return "";
    } /**
   * Listen keyboard events
   */ ;
    /**
   * Listen keyboard events
   * @param {KeyboardEventListener} data
   */ _proto.onKeyboard = function onKeyboard(data) {
        var _this9 = this;
        if (Array.isArray(data)) {
            data.forEach(function(it) {
                return _this9.onKeyboard(it);
            });
            return;
        }
        if (!this.keyboardListeners.includes(data)) this.keyboardListeners.push(data);
    } /**
   * Un-listen keyboard events
   * @param {KeyboardEventListener} data
   */ ;
    _proto.offKeyboard = function offKeyboard(data) {
        var _this10 = this;
        if (Array.isArray(data)) {
            data.forEach(function(it) {
                return _this10.offKeyboard(it);
            });
            return;
        }
        var index = this.keyboardListeners.indexOf(data);
        if (index >= 0) this.keyboardListeners.splice(index, 1);
    };
    _proto.handleKeyDown = function handleKeyDown(e) {
        // 遍历监听数组，找找有没有被监听
        for(var _iterator3 = _createForOfIteratorHelperLoose(this.keyboardListeners), _step3; !(_step3 = _iterator3()).done;){
            var it = _step3.value;
            if ((0, _tool.isKeyMatch)(e, it)) {
                e.preventDefault();
                it.callback(e);
                return;
            }
        } // 如果没有，触发默认事件
        this.emitter.emit(this.emitter.EVENT_KEY_DOWN, e);
    };
    _proto.getEventType = function getEventType(event) {
        switch(event){
            case "change":
                return this.emitter.EVENT_CHANGE;
            case "fullscreen":
                return this.emitter.EVENT_FULL_SCREEN;
            case "viewchange":
                return this.emitter.EVENT_VIEW_CHANGE;
            case "keydown":
                return this.emitter.EVENT_KEY_DOWN;
            case "editor_keydown":
                return this.emitter.EVENT_EDITOR_KEY_DOWN;
            case "blur":
                return this.emitter.EVENT_BLUR;
            case "focus":
                return this.emitter.EVENT_FOCUS;
            case "scroll":
                return this.emitter.EVENT_SCROLL;
        }
    } /**
   * Listen events
   * @param {EditorEvent} event Event type
   * @param {any} cb Callback
   */ ;
    _proto.on = function on(event, cb) {
        var eventType = this.getEventType(event);
        if (eventType) this.emitter.on(eventType, cb);
    } /**
   * Un-listen events
   * @param {EditorEvent} event Event type
   * @param {any} cb Callback
   */ ;
    _proto.off = function off(event, cb) {
        var eventType = this.getEventType(event);
        if (eventType) this.emitter.off(eventType, cb);
    } /**
   * Set view property
   * Can show or hide: editor, preview, menu
   * @param {object} to
   */ ;
    _proto.setView = function setView(to) {
        var _this11 = this;
        var newView = (0, _extendsDefault.default)({}, this.state.view, to);
        this.setState({
            view: newView
        }, function() {
            _this11.emitter.emit(_this11.emitter.EVENT_VIEW_CHANGE, newView);
        });
    } /**
   * Get view property
   * @return {object}
   */ ;
    _proto.getView = function getView() {
        return (0, _extendsDefault.default)({}, this.state.view);
    } /**
   * Enter or exit full screen
   * @param {boolean} enable
   */ ;
    _proto.fullScreen = function fullScreen(enable) {
        var _this12 = this;
        if (this.state.fullScreen !== enable) this.setState({
            fullScreen: enable
        }, function() {
            _this12.emitter.emit(_this12.emitter.EVENT_FULL_SCREEN, enable);
        });
    } /**
   * Register a plugin API
   * @param {string} name API name
   * @param {any} cb callback
   */ ;
    _proto.registerPluginApi = function registerPluginApi(name, cb) {
        this.pluginApis.set(name, cb);
    };
    _proto.unregisterPluginApi = function unregisterPluginApi(name) {
        this.pluginApis.delete(name);
    } /**
   * Call a plugin API
   * @param {string} name API name
   * @param {any} others arguments
   * @returns {any}
   */ ;
    _proto.callPluginApi = function callPluginApi(name) {
        var handler = this.pluginApis.get(name);
        if (!handler) throw new Error("API " + name + " not found");
        for(var _len = arguments.length, others = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)others[_key - 1] = arguments[_key];
        return handler.apply(void 0, others);
    } /**
   * Is full screen
   * @return {boolean}
   */ ;
    _proto.isFullScreen = function isFullScreen() {
        return this.state.fullScreen;
    };
    _proto.uploadWithDataTransfer = function uploadWithDataTransfer(items) {
        var _this13 = this;
        var onImageUpload = this.config.onImageUpload;
        if (!onImageUpload) return;
        var queue = [];
        Array.prototype.forEach.call(items, function(it) {
            if (it.kind === "file" && it.type.includes("image")) {
                var file = it.getAsFile();
                if (file) {
                    var placeholder = (0, _uploadPlaceholderDefault.default)(file, onImageUpload);
                    queue.push(Promise.resolve(placeholder.placeholder));
                    placeholder.uploaded.then(function(str) {
                        var text = _this13.getMdValue().replace(placeholder.placeholder, str);
                        var offset = str.length - placeholder.placeholder.length; // 计算出替换后的光标位置
                        var selection = _this13.getSelection();
                        _this13.setText(text, undefined, {
                            start: selection.start + offset,
                            end: selection.start + offset
                        });
                    });
                }
            } else if (it.kind === "string" && it.type === "text/plain") queue.push(new Promise(function(resolve) {
                return it.getAsString(resolve);
            }));
        });
        Promise.all(queue).then(function(res) {
            var text = res.join("");
            var selection = _this13.getSelection();
            _this13.insertText(text, true, {
                start: selection.start === selection.end ? text.length : 0,
                end: text.length
            });
        });
    };
    _proto.render = function render() {
        var _this14 = this;
        var _this$state = this.state, view = _this$state.view, fullScreen = _this$state.fullScreen, text = _this$state.text, html = _this$state.html;
        var _this$props = this.props, id = _this$props.id, _this$props$className = _this$props.className, className = _this$props$className === void 0 ? "" : _this$props$className, style = _this$props.style, _this$props$name = _this$props.name, name = _this$props$name === void 0 ? "textarea" : _this$props$name, autoFocus = _this$props.autoFocus, placeholder = _this$props.placeholder, readOnly = _this$props.readOnly;
        var showHideMenu = this.config.canView && this.config.canView.hideMenu && !this.config.canView.menu;
        var getPluginAt = function getPluginAt(at) {
            return _this14.state.plugins[at] || [];
        };
        var isShowMenu = !!view.menu;
        var editorId = id ? id + "_md" : undefined;
        var previewerId = id ? id + "_html" : undefined;
        return /*#__PURE__*/ _react.createElement("div", {
            id: id,
            className: "rc-md-editor " + (fullScreen ? "full" : "") + " " + className,
            style: style,
            onKeyDown: this.handleKeyDown,
            onDrop: this.handleDrop
        }, /*#__PURE__*/ _react.createElement((0, _navigationBarDefault.default), {
            visible: isShowMenu,
            left: getPluginAt("left"),
            right: getPluginAt("right")
        }), /*#__PURE__*/ _react.createElement("div", {
            className: "editor-container"
        }, showHideMenu && /*#__PURE__*/ _react.createElement((0, _toolBarDefault.default), null, /*#__PURE__*/ _react.createElement("span", {
            className: "button button-type-menu",
            title: isShowMenu ? "hidden menu" : "show menu",
            onClick: this.handleToggleMenu
        }, /*#__PURE__*/ _react.createElement((0, _iconDefault.default), {
            type: "expand-" + (isShowMenu ? "less" : "more")
        }))), /*#__PURE__*/ _react.createElement("section", {
            className: "section sec-md " + (view.md ? "visible" : "in-visible")
        }, /*#__PURE__*/ _react.createElement("textarea", {
            id: editorId,
            ref: this.nodeMdText,
            name: name,
            autoFocus: autoFocus,
            placeholder: placeholder,
            readOnly: readOnly,
            value: text,
            className: "section-container input " + (this.config.markdownClass || ""),
            wrap: "hard",
            onChange: this.handleChange,
            onScroll: this.handleInputScroll,
            onMouseOver: function onMouseOver() {
                return _this14.shouldSyncScroll = "md";
            },
            onKeyDown: this.handleEditorKeyDown,
            onCompositionStart: function onCompositionStart() {
                return _this14.composing = true;
            },
            onCompositionEnd: function onCompositionEnd() {
                return _this14.composing = false;
            },
            onPaste: this.handlePaste,
            onFocus: this.handleFocus,
            onBlur: this.handleBlur
        })), /*#__PURE__*/ _react.createElement("section", {
            className: "section sec-html " + (view.html ? "visible" : "in-visible")
        }, /*#__PURE__*/ _react.createElement("div", {
            id: previewerId,
            className: "section-container html-wrap",
            ref: this.nodeMdPreviewWrapper,
            onMouseOver: function onMouseOver() {
                return _this14.shouldSyncScroll = "html";
            },
            onScroll: this.handlePreviewScroll
        }, /*#__PURE__*/ _react.createElement((0, _preview.HtmlRender), {
            html: html,
            className: this.config.htmlClass,
            ref: this.nodeMdPreview
        })))));
    };
    return Editor;
}(_react.Component);
Editor.plugins = [];
Editor.addLocale = (0, _i18NDefault.default).add.bind((0, _i18NDefault.default));
Editor.useLocale = (0, _i18NDefault.default).setCurrent.bind((0, _i18NDefault.default));
Editor.getLocale = (0, _i18NDefault.default).getCurrent.bind((0, _i18NDefault.default));
exports.default = Editor;

},{"@babel/runtime/helpers/extends":"4iKIP","@babel/runtime/helpers/assertThisInitialized":"dqevA","@babel/runtime/helpers/inheritsLoose":"j53wo","react":"6uln9","uuid":"klst7","../components/Icon":"40q2L","../components/NavigationBar":"k2xXz","../components/ToolBar":"4Knk7","../i18n":"2WwwD","../plugins/divider":"a7nDv","../share/emitter":"gZXz4","../share/var":"6seC2","../utils/decorate":"g9qnH","../utils/mergeConfig":"idutq","../utils/tool":"O3FOt","../utils/uploadPlaceholder":"5R07R","./defaultConfig":"6y6tr","./preview":"4JBTr","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"dqevA":[function(require,module,exports) {
function _assertThisInitialized(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
}
module.exports = _assertThisInitialized, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{}],"j53wo":[function(require,module,exports) {
var setPrototypeOf = require("56507d829b6b7d3d");
function _inheritsLoose(t, o) {
    t.prototype = Object.create(o.prototype), t.prototype.constructor = t, setPrototypeOf(t, o);
}
module.exports = _inheritsLoose, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{"56507d829b6b7d3d":"lL0sw"}],"lL0sw":[function(require,module,exports) {
function _setPrototypeOf(t, e) {
    return module.exports = _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, _setPrototypeOf(t, e);
}
module.exports = _setPrototypeOf, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{}],"40q2L":[function(require,module,exports) {
// Icon
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Icon);
var _react = require("react");
function Icon(props) {
    return /*#__PURE__*/ _react.createElement("i", {
        className: "rmel-iconfont rmel-icon-" + props.type
    });
}

},{"react":"6uln9","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"k2xXz":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>NavigationBar);
var _react = require("react");
function NavigationBar(props) {
    return /*#__PURE__*/ _react.createElement("div", {
        className: "rc-md-navigation " + (props.visible ? "visible" : "in-visible")
    }, /*#__PURE__*/ _react.createElement("div", {
        className: "navigation-nav left"
    }, /*#__PURE__*/ _react.createElement("div", {
        className: "button-wrap"
    }, props.left)), /*#__PURE__*/ _react.createElement("div", {
        className: "navigation-nav right"
    }, /*#__PURE__*/ _react.createElement("div", {
        className: "button-wrap"
    }, props.right)));
}

},{"react":"6uln9","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4Knk7":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>ToolBar);
var _react = require("react");
function ToolBar(props) {
    return /*#__PURE__*/ _react.createElement("div", {
        className: "tool-bar",
        style: props.style
    }, props.children);
}

},{"react":"6uln9","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2WwwD":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _emitter = require("../share/emitter");
var _enUS = require("./lang/en-US");
var _enUSDefault = parcelHelpers.interopDefault(_enUS);
var _zhCN = require("./lang/zh-CN");
var _zhCNDefault = parcelHelpers.interopDefault(_zhCN);
var I18n = /*#__PURE__*/ function() {
    function I18n() {
        this.langs = {
            enUS: (0, _enUSDefault.default),
            zhCN: (0, _zhCNDefault.default)
        };
        this.current = "enUS";
        this.setUp();
    }
    var _proto = I18n.prototype;
    _proto.setUp = function setUp() {
        if (typeof window === "undefined") // 不在浏览器环境中，取消检测
        return;
        var locale = "enUS"; // 检测语言
        if (navigator.language) {
            var it = navigator.language.split("-");
            locale = it[0];
            if (it.length !== 1) locale += it[it.length - 1].toUpperCase();
        } // IE10及更低版本使用browserLanguage
        // @ts-ignore
        if (navigator.browserLanguage) {
            // @ts-ignore
            var _it = navigator.browserLanguage.split("-");
            locale = _it[0];
            if (_it[1]) locale += _it[1].toUpperCase();
        }
        if (this.current !== locale && this.isAvailable(locale)) {
            this.current = locale;
            (0, _emitter.globalEmitter).emit((0, _emitter.globalEmitter).EVENT_LANG_CHANGE, this, locale, this.langs[locale]);
        }
    };
    _proto.isAvailable = function isAvailable(langName) {
        return typeof this.langs[langName] !== "undefined";
    };
    _proto.add = function add(langName, lang) {
        this.langs[langName] = lang;
    };
    _proto.setCurrent = function setCurrent(langName) {
        if (!this.isAvailable(langName)) throw new Error("Language " + langName + " is not exists");
        if (this.current !== langName) {
            this.current = langName;
            (0, _emitter.globalEmitter).emit((0, _emitter.globalEmitter).EVENT_LANG_CHANGE, this, langName, this.langs[langName]);
        }
    };
    _proto.get = function get(key, placeholders) {
        var str = this.langs[this.current][key] || "";
        if (placeholders) Object.keys(placeholders).forEach(function(k) {
            str = str.replace(new RegExp("\\{" + k + "\\}", "g"), placeholders[k]);
        });
        return str;
    };
    _proto.getCurrent = function getCurrent() {
        return this.current;
    };
    return I18n;
}();
var i18n = new I18n();
exports.default = i18n;

},{"../share/emitter":"gZXz4","./lang/en-US":"g065c","./lang/zh-CN":"59Eq2","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"gZXz4":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "globalEmitter", ()=>globalEmitter);
var _inheritsLoose = require("@babel/runtime/helpers/inheritsLoose");
var _inheritsLooseDefault = parcelHelpers.interopDefault(_inheritsLoose);
var _eventemitter3 = require("eventemitter3");
var Emitter = /*#__PURE__*/ function(_EventEmitter) {
    (0, _inheritsLooseDefault.default)(Emitter, _EventEmitter);
    function Emitter() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _EventEmitter.call.apply(_EventEmitter, [
            this
        ].concat(args)) || this;
        _this.EVENT_CHANGE = "a1";
        _this.EVENT_FULL_SCREEN = "a2";
        _this.EVENT_VIEW_CHANGE = "a3";
        _this.EVENT_KEY_DOWN = "a4";
        _this.EVENT_EDITOR_KEY_DOWN = "a5";
        _this.EVENT_FOCUS = "a5";
        _this.EVENT_BLUR = "a6";
        _this.EVENT_SCROLL = "a7";
        _this.EVENT_LANG_CHANGE = "b1";
        return _this;
    }
    return Emitter;
}((0, _eventemitter3.EventEmitter));
var globalEmitter = new Emitter();
exports.default = Emitter;

},{"@babel/runtime/helpers/inheritsLoose":"j53wo","eventemitter3":"6xgnM","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6xgnM":[function(require,module,exports) {
"use strict";
var has = Object.prototype.hasOwnProperty, prefix = "~";
/**
 * Constructor to create a storage for our `EE` objects.
 * An `Events` instance is a plain object whose properties are event names.
 *
 * @constructor
 * @private
 */ function Events() {}
//
// We try to not inherit from `Object.prototype`. In some engines creating an
// instance in this way is faster than calling `Object.create(null)` directly.
// If `Object.create(null)` is not supported we prefix the event names with a
// character to make sure that the built-in object properties are not
// overridden or used as an attack vector.
//
if (Object.create) {
    Events.prototype = Object.create(null);
    //
    // This hack is needed because the `__proto__` property is still inherited in
    // some old browsers like Android 4, iPhone 5.1, Opera 11 and Safari 5.
    //
    if (!new Events().__proto__) prefix = false;
}
/**
 * Representation of a single event listener.
 *
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} [once=false] Specify if the listener is a one-time listener.
 * @constructor
 * @private
 */ function EE(fn, context, once) {
    this.fn = fn;
    this.context = context;
    this.once = once || false;
}
/**
 * Add a listener for a given event.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} once Specify if the listener is a one-time listener.
 * @returns {EventEmitter}
 * @private
 */ function addListener(emitter, event, fn, context, once) {
    if (typeof fn !== "function") throw new TypeError("The listener must be a function");
    var listener = new EE(fn, context || emitter, once), evt = prefix ? prefix + event : event;
    if (!emitter._events[evt]) emitter._events[evt] = listener, emitter._eventsCount++;
    else if (!emitter._events[evt].fn) emitter._events[evt].push(listener);
    else emitter._events[evt] = [
        emitter._events[evt],
        listener
    ];
    return emitter;
}
/**
 * Clear event by name.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} evt The Event name.
 * @private
 */ function clearEvent(emitter, evt) {
    if (--emitter._eventsCount === 0) emitter._events = new Events();
    else delete emitter._events[evt];
}
/**
 * Minimal `EventEmitter` interface that is molded against the Node.js
 * `EventEmitter` interface.
 *
 * @constructor
 * @public
 */ function EventEmitter() {
    this._events = new Events();
    this._eventsCount = 0;
}
/**
 * Return an array listing the events for which the emitter has registered
 * listeners.
 *
 * @returns {Array}
 * @public
 */ EventEmitter.prototype.eventNames = function eventNames() {
    var names = [], events, name;
    if (this._eventsCount === 0) return names;
    for(name in events = this._events)if (has.call(events, name)) names.push(prefix ? name.slice(1) : name);
    if (Object.getOwnPropertySymbols) return names.concat(Object.getOwnPropertySymbols(events));
    return names;
};
/**
 * Return the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Array} The registered listeners.
 * @public
 */ EventEmitter.prototype.listeners = function listeners(event) {
    var evt = prefix ? prefix + event : event, handlers = this._events[evt];
    if (!handlers) return [];
    if (handlers.fn) return [
        handlers.fn
    ];
    for(var i = 0, l = handlers.length, ee = new Array(l); i < l; i++)ee[i] = handlers[i].fn;
    return ee;
};
/**
 * Return the number of listeners listening to a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Number} The number of listeners.
 * @public
 */ EventEmitter.prototype.listenerCount = function listenerCount(event) {
    var evt = prefix ? prefix + event : event, listeners = this._events[evt];
    if (!listeners) return 0;
    if (listeners.fn) return 1;
    return listeners.length;
};
/**
 * Calls each of the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Boolean} `true` if the event had listeners, else `false`.
 * @public
 */ EventEmitter.prototype.emit = function emit(event, a1, a2, a3, a4, a5) {
    var evt = prefix ? prefix + event : event;
    if (!this._events[evt]) return false;
    var listeners = this._events[evt], len = arguments.length, args, i;
    if (listeners.fn) {
        if (listeners.once) this.removeListener(event, listeners.fn, undefined, true);
        switch(len){
            case 1:
                return listeners.fn.call(listeners.context), true;
            case 2:
                return listeners.fn.call(listeners.context, a1), true;
            case 3:
                return listeners.fn.call(listeners.context, a1, a2), true;
            case 4:
                return listeners.fn.call(listeners.context, a1, a2, a3), true;
            case 5:
                return listeners.fn.call(listeners.context, a1, a2, a3, a4), true;
            case 6:
                return listeners.fn.call(listeners.context, a1, a2, a3, a4, a5), true;
        }
        for(i = 1, args = new Array(len - 1); i < len; i++)args[i - 1] = arguments[i];
        listeners.fn.apply(listeners.context, args);
    } else {
        var length = listeners.length, j;
        for(i = 0; i < length; i++){
            if (listeners[i].once) this.removeListener(event, listeners[i].fn, undefined, true);
            switch(len){
                case 1:
                    listeners[i].fn.call(listeners[i].context);
                    break;
                case 2:
                    listeners[i].fn.call(listeners[i].context, a1);
                    break;
                case 3:
                    listeners[i].fn.call(listeners[i].context, a1, a2);
                    break;
                case 4:
                    listeners[i].fn.call(listeners[i].context, a1, a2, a3);
                    break;
                default:
                    if (!args) for(j = 1, args = new Array(len - 1); j < len; j++)args[j - 1] = arguments[j];
                    listeners[i].fn.apply(listeners[i].context, args);
            }
        }
    }
    return true;
};
/**
 * Add a listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */ EventEmitter.prototype.on = function on(event, fn, context) {
    return addListener(this, event, fn, context, false);
};
/**
 * Add a one-time listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */ EventEmitter.prototype.once = function once(event, fn, context) {
    return addListener(this, event, fn, context, true);
};
/**
 * Remove the listeners of a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn Only remove the listeners that match this function.
 * @param {*} context Only remove the listeners that have this context.
 * @param {Boolean} once Only remove one-time listeners.
 * @returns {EventEmitter} `this`.
 * @public
 */ EventEmitter.prototype.removeListener = function removeListener(event, fn, context, once) {
    var evt = prefix ? prefix + event : event;
    if (!this._events[evt]) return this;
    if (!fn) {
        clearEvent(this, evt);
        return this;
    }
    var listeners = this._events[evt];
    if (listeners.fn) {
        if (listeners.fn === fn && (!once || listeners.once) && (!context || listeners.context === context)) clearEvent(this, evt);
    } else {
        for(var i = 0, events = [], length = listeners.length; i < length; i++)if (listeners[i].fn !== fn || once && !listeners[i].once || context && listeners[i].context !== context) events.push(listeners[i]);
        //
        // Reset the array, or remove it completely if we have no more listeners.
        //
        if (events.length) this._events[evt] = events.length === 1 ? events[0] : events;
        else clearEvent(this, evt);
    }
    return this;
};
/**
 * Remove all listeners, or those of the specified event.
 *
 * @param {(String|Symbol)} [event] The event name.
 * @returns {EventEmitter} `this`.
 * @public
 */ EventEmitter.prototype.removeAllListeners = function removeAllListeners(event) {
    var evt;
    if (event) {
        evt = prefix ? prefix + event : event;
        if (this._events[evt]) clearEvent(this, evt);
    } else {
        this._events = new Events();
        this._eventsCount = 0;
    }
    return this;
};
//
// Alias methods names because people roll like that.
//
EventEmitter.prototype.off = EventEmitter.prototype.removeListener;
EventEmitter.prototype.addListener = EventEmitter.prototype.on;
//
// Expose the prefix.
//
EventEmitter.prefixed = prefix;
//
// Allow `EventEmitter` to be imported as module namespace.
//
EventEmitter.EventEmitter = EventEmitter;
module.exports = EventEmitter;

},{}],"g065c":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = {
    clearTip: "Are you sure you want to clear all contents?",
    btnHeader: "Header",
    btnClear: "Clear",
    btnBold: "Bold",
    btnItalic: "Italic",
    btnUnderline: "Underline",
    btnStrikethrough: "Strikethrough",
    btnUnordered: "Unordered list",
    btnOrdered: "Ordered list",
    btnQuote: "Quote",
    btnLineBreak: "Line break",
    btnInlineCode: "Inline code",
    btnCode: "Code",
    btnTable: "Table",
    btnImage: "Image",
    btnLink: "Link",
    btnUndo: "Undo",
    btnRedo: "Redo",
    btnFullScreen: "Full screen",
    btnExitFullScreen: "Exit full screen",
    btnModeEditor: "Only display editor",
    btnModePreview: "Only display preview",
    btnModeAll: "Display both editor and preview",
    selectTabMap: "Actual input when typing a Tab key",
    tab: "Tab",
    spaces: "Spaces"
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"59Eq2":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = {
    clearTip: "您确定要清空所有内容吗？",
    btnHeader: "标题",
    btnClear: "清空",
    btnBold: "加粗",
    btnItalic: "斜体",
    btnUnderline: "下划线",
    btnStrikethrough: "删除线",
    btnUnordered: "无序列表",
    btnOrdered: "有序列表",
    btnQuote: "引用",
    btnLineBreak: "换行",
    btnInlineCode: "行内代码",
    btnCode: "代码块",
    btnTable: "表格",
    btnImage: "图片",
    btnLink: "链接",
    btnUndo: "撤销",
    btnRedo: "重做",
    btnFullScreen: "全屏",
    btnExitFullScreen: "退出全屏",
    btnModeEditor: "仅显示编辑器",
    btnModePreview: "仅显示预览",
    btnModeAll: "显示编辑器与预览",
    selectTabMap: "按下 Tab 键时实际的输入",
    tab: "制表符",
    spaces: "空格"
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"a7nDv":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Divider);
var _inheritsLoose = require("@babel/runtime/helpers/inheritsLoose");
var _inheritsLooseDefault = parcelHelpers.interopDefault(_inheritsLoose);
var _react = require("react");
var _plugin = require("../Plugin");
var Divider = /*#__PURE__*/ function(_PluginComponent) {
    (0, _inheritsLooseDefault.default)(Divider, _PluginComponent);
    function Divider() {
        return _PluginComponent.apply(this, arguments) || this;
    }
    var _proto = Divider.prototype;
    _proto.render = function render() {
        return /*#__PURE__*/ _react.createElement("span", {
            className: "rc-md-divider"
        });
    };
    return Divider;
}((0, _plugin.PluginComponent));
Divider.pluginName = "divider";

},{"@babel/runtime/helpers/inheritsLoose":"j53wo","react":"6uln9","../Plugin":"iqHiK","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"iqHiK":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PluginComponent", ()=>PluginComponent);
var _createClass = require("@babel/runtime/helpers/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _inheritsLoose = require("@babel/runtime/helpers/inheritsLoose");
var _inheritsLooseDefault = parcelHelpers.interopDefault(_inheritsLoose);
var _react = require("react");
var PluginComponent = /*#__PURE__*/ function(_React$Component) {
    (0, _inheritsLooseDefault.default)(PluginComponent, _React$Component);
    function PluginComponent() {
        return _React$Component.apply(this, arguments) || this;
    }
    var _proto = PluginComponent.prototype;
    _proto.getConfig = function getConfig(key, defaultValue) {
        return typeof this.props.config[key] !== "undefined" && this.props.config[key] !== null ? this.props.config[key] : defaultValue;
    };
    (0, _createClassDefault.default)(PluginComponent, [
        {
            key: "editor",
            get: function get() {
                return this.props.editor;
            }
        },
        {
            key: "editorConfig",
            get: function get() {
                return this.props.editorConfig;
            }
        }
    ]);
    return PluginComponent;
}(_react.Component);
PluginComponent.pluginName = "";
PluginComponent.align = "left";
PluginComponent.defaultConfig = {};

},{"@babel/runtime/helpers/createClass":"h0R9D","@babel/runtime/helpers/inheritsLoose":"j53wo","react":"6uln9","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"h0R9D":[function(require,module,exports) {
var toPropertyKey = require("b03a9e1e96a7e901");
function _defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, toPropertyKey(o.key), o);
    }
}
function _createClass(e, r, t) {
    return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}
module.exports = _createClass, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{"b03a9e1e96a7e901":"btEvn"}],"6seC2":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "initialSelection", ()=>initialSelection);
var initialSelection = {
    start: 0,
    end: 0,
    text: ""
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"g9qnH":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _tool = require("./tool");
// 最简单的Decorator，即在现有文字的基础上加上前缀、后缀即可
var SIMPLE_DECORATOR = {
    bold: [
        "**",
        "**"
    ],
    italic: [
        "*",
        "*"
    ],
    underline: [
        "++",
        "++"
    ],
    strikethrough: [
        "~~",
        "~~"
    ],
    quote: [
        "\n> ",
        "\n"
    ],
    inlinecode: [
        "`",
        "`"
    ],
    code: [
        "\n```\n",
        "\n```\n"
    ]
}; // 插入H1-H6
for(var i = 1; i <= 6; i++)SIMPLE_DECORATOR["h" + i] = [
    "\n" + (0, _tool.repeat)("#", i) + " ",
    "\n"
];
function decorateTableText(option) {
    var _option$row = option.row, row = _option$row === void 0 ? 2 : _option$row, _option$col = option.col, col = _option$col === void 0 ? 2 : _option$col;
    var rowHeader = [
        "|"
    ];
    var rowData = [
        "|"
    ];
    var rowDivision = [
        "|"
    ];
    var colStr = "";
    for(var _i = 1; _i <= col; _i++){
        rowHeader.push(" Head |");
        rowDivision.push(" --- |");
        rowData.push(" Data |");
    }
    for(var j = 1; j <= row; j++)colStr += "\n" + rowData.join("");
    return rowHeader.join("") + "\n" + rowDivision.join("") + colStr;
}
function decorateList(type, target) {
    var text = target;
    if (text.substr(0, 1) !== "\n") text = "\n" + text;
    if (type === "unordered") return text.length > 1 ? text.replace(/\n/g, "\n* ").trim() : "* ";
    else {
        var count = 1;
        if (text.length > 1) return text.replace(/\n/g, function() {
            return "\n" + count++ + ". ";
        }).trim();
        else return "1. ";
    }
}
function createTextDecorated(text, newBlock) {
    return {
        text: text,
        newBlock: newBlock,
        selection: {
            start: text.length,
            end: text.length
        }
    };
}
/**
 * 获取装饰后的Markdown文本
 * @param target 原文字
 * @param type 装饰类型
 * @param option 附加参数
 * @returns {Decorated}
 */ function getDecorated(target, type, option) {
    if (typeof SIMPLE_DECORATOR[type] !== "undefined") return {
        text: "" + SIMPLE_DECORATOR[type][0] + target + SIMPLE_DECORATOR[type][1],
        selection: {
            start: SIMPLE_DECORATOR[type][0].length,
            end: SIMPLE_DECORATOR[type][0].length + target.length
        }
    };
    switch(type){
        case "tab":
            var inputValue = option.tabMapValue === 1 ? "	" : " ".repeat(option.tabMapValue);
            var newSelectedText = inputValue + target.replace(/\n/g, "\n" + inputValue);
            var lineBreakCount = target.includes("\n") ? target.match(/\n/g).length : 0;
            return {
                text: newSelectedText,
                selection: {
                    start: option.tabMapValue,
                    end: option.tabMapValue * (lineBreakCount + 1) + target.length
                }
            };
        case "unordered":
            return createTextDecorated(decorateList("unordered", target), true);
        case "order":
            return createTextDecorated(decorateList("order", target), true);
        case "hr":
            return createTextDecorated("---", true);
        case "table":
            return {
                text: decorateTableText(option),
                newBlock: true
            };
        case "image":
            return {
                text: "![" + (target || option.target) + "](" + (option.imageUrl || "") + ")",
                selection: {
                    start: 2,
                    end: target.length + 2
                }
            };
        case "link":
            return {
                text: "[" + target + "](" + (option.linkUrl || "") + ")",
                selection: {
                    start: 1,
                    end: target.length + 1
                }
            };
    }
    return {
        text: target,
        selection: {
            start: 0,
            end: target.length
        }
    };
}
exports.default = getDecorated;

},{"./tool":"O3FOt","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"O3FOt":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "deepClone", ()=>deepClone);
parcelHelpers.export(exports, "isEmpty", ()=>isEmpty);
parcelHelpers.export(exports, "isPromise", ()=>isPromise);
parcelHelpers.export(exports, "repeat", ()=>repeat);
parcelHelpers.export(exports, "isKeyMatch", ()=>isKeyMatch);
parcelHelpers.export(exports, "getLineAndCol", ()=>getLineAndCol);
function _createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function deepClone(obj) {
    if (!obj || typeof obj !== "object") return obj;
    var objArray = Array.isArray(obj) ? [] : {};
    if (obj && typeof obj === "object") {
        for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) {
            // 如果obj的属性是对象，递归操作
            if (obj[key] && typeof obj[key] === "object") objArray[key] = deepClone(obj[key]);
            else objArray[key] = obj[key];
        }
    }
    return objArray;
}
function isEmpty(obj) {
    // 判断字符是否为空的方法
    return typeof obj === "undefined" || obj === null || obj === "";
}
function isPromise(obj) {
    return obj && (obj instanceof Promise || (typeof obj === "object" || typeof obj === "function") && typeof obj.then === "function");
}
function repeat(str, num) {
    var result = "";
    var n = num;
    while(n--)result += str;
    return result;
}
function isKeyMatch(event, cond) {
    var withKey = cond.withKey, keyCode = cond.keyCode, key = cond.key, aliasCommand = cond.aliasCommand;
    var e = {
        ctrlKey: event.ctrlKey,
        metaKey: event.metaKey,
        altKey: event.altKey,
        shiftKey: event.shiftKey,
        keyCode: event.keyCode,
        key: event.key
    };
    if (aliasCommand) e.ctrlKey = e.ctrlKey || e.metaKey;
    if (withKey && withKey.length > 0) for(var _iterator = _createForOfIteratorHelperLoose(withKey), _step; !(_step = _iterator()).done;){
        var it = _step.value;
        if (typeof e[it] !== "undefined" && !e[it]) return false;
    }
    else {
        if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return false;
    }
    if (e.key) return e.key === key;
    else return e.keyCode === keyCode;
}
function getLineAndCol(text, pos) {
    var lines = text.split("\n");
    var beforeLines = text.substr(0, pos).split("\n");
    var line = beforeLines.length;
    var col = beforeLines[beforeLines.length - 1].length;
    var curLine = lines[beforeLines.length - 1];
    var prevLine = beforeLines.length > 1 ? beforeLines[beforeLines.length - 2] : null;
    var nextLine = lines.length > beforeLines.length ? lines[beforeLines.length] : null;
    return {
        line: line,
        col: col,
        beforeText: text.substr(0, pos),
        afterText: text.substr(pos),
        curLine: curLine,
        prevLine: prevLine,
        nextLine: nextLine
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"idutq":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(defaultConfig) {
        var res = (0, _extendsDefault.default)({}, defaultConfig);
        for(var _len = arguments.length, configs = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)configs[_key - 1] = arguments[_key];
        configs.forEach(function(conf) {
            // only object
            if (typeof conf !== "object") return;
            res = mergeObject(res, conf);
        });
        return res;
    });
var _extends = require("@babel/runtime/helpers/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
function mergeObject(obj1, obj2) {
    var result = {};
    Object.keys(obj1).forEach(function(k) {
        if (typeof obj2[k] === "undefined") {
            result[k] = obj1[k];
            return;
        }
        if (typeof obj2[k] === "object") {
            if (Array.isArray(obj2[k])) result[k] = [].concat(obj2[k]);
            else result[k] = mergeObject(obj1[k], obj2[k]);
            return;
        }
        result[k] = obj2[k];
    });
    return result;
}

},{"@babel/runtime/helpers/extends":"4iKIP","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"5R07R":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _uuid = require("uuid");
var _decorate = require("./decorate");
var _decorateDefault = parcelHelpers.interopDefault(_decorate);
var _tool = require("./tool");
function getUploadPlaceholder(file, onImageUpload) {
    var placeholder = (0, _decorateDefault.default)("", "image", {
        target: "Uploading_" + (0, _uuid.v4)(),
        imageUrl: ""
    }).text;
    var uploaded = new Promise(function(resolve) {
        var isCallback = true;
        var handleUploaded = function handleUploaded(url) {
            if (isCallback) console.warn("Deprecated: onImageUpload should return a Promise, callback will be removed in future");
            resolve((0, _decorateDefault.default)("", "image", {
                target: file.name,
                imageUrl: url
            }).text);
        }; // 兼容回调和Promise
        var upload = onImageUpload(file, handleUploaded);
        if ((0, _tool.isPromise)(upload)) {
            isCallback = false;
            upload.then(handleUploaded);
        }
    });
    return {
        placeholder: placeholder,
        uploaded: uploaded
    };
}
exports.default = getUploadPlaceholder;

},{"uuid":"klst7","./decorate":"g9qnH","./tool":"O3FOt","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6y6tr":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var defaultConfig = {
    theme: "default",
    view: {
        menu: true,
        md: true,
        html: true
    },
    canView: {
        menu: true,
        md: true,
        html: true,
        both: true,
        fullScreen: true,
        hideMenu: true
    },
    htmlClass: "",
    markdownClass: "",
    syncScrollMode: [
        "rightFollowLeft",
        "leftFollowRight"
    ],
    imageUrl: "",
    imageAccept: "",
    linkUrl: "",
    loggerMaxSize: 100,
    loggerInterval: 600,
    table: {
        maxRow: 4,
        maxCol: 6
    },
    allowPasteImage: true,
    onImageUpload: undefined,
    onCustomImageUpload: undefined,
    shortcuts: true,
    onChangeTrigger: "both"
};
exports.default = defaultConfig;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4JBTr":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Preview", ()=>Preview);
parcelHelpers.export(exports, "HtmlRender", ()=>HtmlRender);
var _inheritsLoose = require("@babel/runtime/helpers/inheritsLoose");
var _inheritsLooseDefault = parcelHelpers.interopDefault(_inheritsLoose);
var _react = require("react");
var Preview = /*#__PURE__*/ function(_React$Component) {
    (0, _inheritsLooseDefault.default)(Preview, _React$Component);
    function Preview(props) {
        var _this;
        _this = _React$Component.call(this, props) || this;
        _this.el = /*#__PURE__*/ _react.createRef();
        return _this;
    }
    var _proto = Preview.prototype;
    _proto.getElement = function getElement() {
        return this.el.current;
    };
    _proto.getHeight = function getHeight() {
        return this.el.current ? this.el.current.offsetHeight : 0;
    };
    return Preview;
}(_react.Component);
var HtmlRender = /*#__PURE__*/ function(_Preview) {
    (0, _inheritsLooseDefault.default)(HtmlRender, _Preview);
    function HtmlRender() {
        return _Preview.apply(this, arguments) || this;
    }
    var _proto2 = HtmlRender.prototype;
    _proto2.getHtml = function getHtml() {
        if (typeof this.props.html === "string") return this.props.html;
        if (this.el.current) return this.el.current.innerHTML;
        return "";
    };
    _proto2.render = function render() {
        return typeof this.props.html === "string" ? /*#__PURE__*/ _react.createElement("div", {
            ref: this.el,
            dangerouslySetInnerHTML: {
                __html: this.props.html
            },
            className: this.props.className || "custom-html-style"
        }) : /*#__PURE__*/ _react.createElement("div", {
            ref: this.el,
            className: this.props.className || "custom-html-style"
        }, this.props.html);
    };
    return HtmlRender;
}(Preview);
exports.default = HtmlRender;

},{"@babel/runtime/helpers/inheritsLoose":"j53wo","react":"6uln9","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"a38J0":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>AutoResize);
var _assertThisInitialized = require("@babel/runtime/helpers/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inheritsLoose = require("@babel/runtime/helpers/inheritsLoose");
var _inheritsLooseDefault = parcelHelpers.interopDefault(_inheritsLoose);
var _react = require("react");
var _plugin = require("./Plugin");
var AutoResize = /*#__PURE__*/ function(_PluginComponent) {
    (0, _inheritsLooseDefault.default)(AutoResize, _PluginComponent);
    function AutoResize(props) {
        var _this;
        _this = _PluginComponent.call(this, props) || this;
        _this.timer = null;
        _this.useTimer = _this.getConfig("useTimer") || typeof requestAnimationFrame === "undefined";
        _this.handleChange = _this.handleChange.bind((0, _assertThisInitializedDefault.default)(_this));
        _this.doResize = _this.doResize.bind((0, _assertThisInitializedDefault.default)(_this));
        return _this;
    }
    var _proto = AutoResize.prototype;
    _proto.doResize = function doResize() {
        var _this2 = this;
        var resizeElement = function resizeElement(e) {
            e.style.height = "auto";
            var height = Math.min(Math.max(_this2.getConfig("min"), e.scrollHeight), _this2.getConfig("max"));
            e.style.height = height + "px";
            return height;
        };
        this.timer = null; // 如果渲染了编辑器，就以编辑器为准
        var view = this.editor.getView();
        var el = this.editor.getMdElement();
        var previewer = this.editor.getHtmlElement();
        if (el && view.md) {
            var height = resizeElement(el);
            if (previewer) previewer.style.height = height + "px";
            return;
        } // 否则，以预览区域为准
        if (previewer && view.html) resizeElement(previewer);
    };
    _proto.handleChange = function handleChange() {
        if (this.timer !== null) return;
        if (this.useTimer) {
            this.timer = window.setTimeout(this.doResize);
            return;
        }
        this.timer = requestAnimationFrame(this.doResize);
    };
    _proto.componentDidMount = function componentDidMount() {
        this.editor.on("change", this.handleChange);
        this.editor.on("viewchange", this.handleChange);
        this.handleChange();
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.editor.off("change", this.handleChange);
        this.editor.off("viewchange", this.handleChange);
        if (this.timer !== null && this.useTimer) {
            window.clearTimeout(this.timer);
            this.timer = null;
        }
    };
    _proto.render = function render() {
        return /*#__PURE__*/ _react.createElement("span", null);
    };
    return AutoResize;
}((0, _plugin.PluginComponent));
AutoResize.pluginName = "auto-resize";
AutoResize.align = "left";
AutoResize.defaultConfig = {
    min: 200,
    max: Infinity,
    useTimer: false
};

},{"@babel/runtime/helpers/assertThisInitialized":"dqevA","@babel/runtime/helpers/inheritsLoose":"j53wo","react":"6uln9","./Plugin":"iqHiK","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7z2GQ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>BlockCodeBlock);
var _inheritsLoose = require("@babel/runtime/helpers/inheritsLoose");
var _inheritsLooseDefault = parcelHelpers.interopDefault(_inheritsLoose);
var _react = require("react");
var _icon = require("../../components/Icon");
var _iconDefault = parcelHelpers.interopDefault(_icon);
var _i18N = require("../../i18n");
var _i18NDefault = parcelHelpers.interopDefault(_i18N);
var _plugin = require("../Plugin");
var BlockCodeBlock = /*#__PURE__*/ function(_PluginComponent) {
    (0, _inheritsLooseDefault.default)(BlockCodeBlock, _PluginComponent);
    function BlockCodeBlock() {
        return _PluginComponent.apply(this, arguments) || this;
    }
    var _proto = BlockCodeBlock.prototype;
    _proto.render = function render() {
        var _this = this;
        return /*#__PURE__*/ _react.createElement("span", {
            className: "button button-type-code-block",
            title: (0, _i18NDefault.default).get("btnCode"),
            onClick: function onClick() {
                return _this.editor.insertMarkdown("code");
            }
        }, /*#__PURE__*/ _react.createElement((0, _iconDefault.default), {
            type: "code-block"
        }));
    };
    return BlockCodeBlock;
}((0, _plugin.PluginComponent));
BlockCodeBlock.pluginName = "block-code-block";

},{"@babel/runtime/helpers/inheritsLoose":"j53wo","react":"6uln9","../../components/Icon":"40q2L","../../i18n":"2WwwD","../Plugin":"iqHiK","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"Hhbjh":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>BlockCodeInline);
var _inheritsLoose = require("@babel/runtime/helpers/inheritsLoose");
var _inheritsLooseDefault = parcelHelpers.interopDefault(_inheritsLoose);
var _react = require("react");
var _icon = require("../../components/Icon");
var _iconDefault = parcelHelpers.interopDefault(_icon);
var _i18N = require("../../i18n");
var _i18NDefault = parcelHelpers.interopDefault(_i18N);
var _plugin = require("../Plugin");
var BlockCodeInline = /*#__PURE__*/ function(_PluginComponent) {
    (0, _inheritsLooseDefault.default)(BlockCodeInline, _PluginComponent);
    function BlockCodeInline() {
        return _PluginComponent.apply(this, arguments) || this;
    }
    var _proto = BlockCodeInline.prototype;
    _proto.render = function render() {
        var _this = this;
        return /*#__PURE__*/ _react.createElement("span", {
            className: "button button-type-code-inline",
            title: (0, _i18NDefault.default).get("btnInlineCode"),
            onClick: function onClick() {
                return _this.editor.insertMarkdown("inlinecode");
            }
        }, /*#__PURE__*/ _react.createElement((0, _iconDefault.default), {
            type: "code"
        }));
    };
    return BlockCodeInline;
}((0, _plugin.PluginComponent));
BlockCodeInline.pluginName = "block-code-inline";

},{"@babel/runtime/helpers/inheritsLoose":"j53wo","react":"6uln9","../../components/Icon":"40q2L","../../i18n":"2WwwD","../Plugin":"iqHiK","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4ImJa":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>BlockQuote);
var _inheritsLoose = require("@babel/runtime/helpers/inheritsLoose");
var _inheritsLooseDefault = parcelHelpers.interopDefault(_inheritsLoose);
var _react = require("react");
var _icon = require("../../components/Icon");
var _iconDefault = parcelHelpers.interopDefault(_icon);
var _i18N = require("../../i18n");
var _i18NDefault = parcelHelpers.interopDefault(_i18N);
var _plugin = require("../Plugin");
var BlockQuote = /*#__PURE__*/ function(_PluginComponent) {
    (0, _inheritsLooseDefault.default)(BlockQuote, _PluginComponent);
    function BlockQuote() {
        return _PluginComponent.apply(this, arguments) || this;
    }
    var _proto = BlockQuote.prototype;
    _proto.render = function render() {
        var _this = this;
        return /*#__PURE__*/ _react.createElement("span", {
            className: "button button-type-quote",
            title: (0, _i18NDefault.default).get("btnQuote"),
            onClick: function onClick() {
                return _this.editor.insertMarkdown("quote");
            }
        }, /*#__PURE__*/ _react.createElement((0, _iconDefault.default), {
            type: "quote"
        }));
    };
    return BlockQuote;
}((0, _plugin.PluginComponent));
BlockQuote.pluginName = "block-quote";

},{"@babel/runtime/helpers/inheritsLoose":"j53wo","react":"6uln9","../../components/Icon":"40q2L","../../i18n":"2WwwD","../Plugin":"iqHiK","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"30ho2":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>BlockWrap);
var _inheritsLoose = require("@babel/runtime/helpers/inheritsLoose");
var _inheritsLooseDefault = parcelHelpers.interopDefault(_inheritsLoose);
var _react = require("react");
var _icon = require("../../components/Icon");
var _iconDefault = parcelHelpers.interopDefault(_icon);
var _i18N = require("../../i18n");
var _i18NDefault = parcelHelpers.interopDefault(_i18N);
var _plugin = require("../Plugin");
var BlockWrap = /*#__PURE__*/ function(_PluginComponent) {
    (0, _inheritsLooseDefault.default)(BlockWrap, _PluginComponent);
    function BlockWrap() {
        return _PluginComponent.apply(this, arguments) || this;
    }
    var _proto = BlockWrap.prototype;
    _proto.render = function render() {
        var _this = this;
        return /*#__PURE__*/ _react.createElement("span", {
            className: "button button-type-wrap",
            title: (0, _i18NDefault.default).get("btnLineBreak"),
            onClick: function onClick() {
                return _this.editor.insertMarkdown("hr");
            }
        }, /*#__PURE__*/ _react.createElement((0, _iconDefault.default), {
            type: "wrap"
        }));
    };
    return BlockWrap;
}((0, _plugin.PluginComponent));
BlockWrap.pluginName = "block-wrap";

},{"@babel/runtime/helpers/inheritsLoose":"j53wo","react":"6uln9","../../components/Icon":"40q2L","../../i18n":"2WwwD","../Plugin":"iqHiK","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9LnVm":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Clear);
var _assertThisInitialized = require("@babel/runtime/helpers/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inheritsLoose = require("@babel/runtime/helpers/inheritsLoose");
var _inheritsLooseDefault = parcelHelpers.interopDefault(_inheritsLoose);
var _react = require("react");
var _icon = require("../components/Icon");
var _iconDefault = parcelHelpers.interopDefault(_icon);
var _i18N = require("../i18n");
var _i18NDefault = parcelHelpers.interopDefault(_i18N);
var _plugin = require("./Plugin");
var Clear = /*#__PURE__*/ function(_PluginComponent) {
    (0, _inheritsLooseDefault.default)(Clear, _PluginComponent);
    function Clear(props) {
        var _this;
        _this = _PluginComponent.call(this, props) || this;
        _this.handleClick = _this.handleClick.bind((0, _assertThisInitializedDefault.default)(_this));
        return _this;
    }
    var _proto = Clear.prototype;
    _proto.handleClick = function handleClick() {
        if (this.editor.getMdValue() === "") return;
        if (window.confirm && typeof window.confirm === "function") {
            var result = window.confirm((0, _i18NDefault.default).get("clearTip"));
            if (result) this.editor.setText("");
        }
    };
    _proto.render = function render() {
        return /*#__PURE__*/ _react.createElement("span", {
            className: "button button-type-clear",
            title: (0, _i18NDefault.default).get("btnClear"),
            onClick: this.handleClick
        }, /*#__PURE__*/ _react.createElement((0, _iconDefault.default), {
            type: "delete"
        }));
    };
    return Clear;
}((0, _plugin.PluginComponent));
Clear.pluginName = "clear";

},{"@babel/runtime/helpers/assertThisInitialized":"dqevA","@babel/runtime/helpers/inheritsLoose":"j53wo","react":"6uln9","../components/Icon":"40q2L","../i18n":"2WwwD","./Plugin":"iqHiK","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"bL5zM":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>FontBold);
var _inheritsLoose = require("@babel/runtime/helpers/inheritsLoose");
var _inheritsLooseDefault = parcelHelpers.interopDefault(_inheritsLoose);
var _react = require("react");
var _icon = require("../../components/Icon");
var _iconDefault = parcelHelpers.interopDefault(_icon);
var _i18N = require("../../i18n");
var _i18NDefault = parcelHelpers.interopDefault(_i18N);
var _plugin = require("../Plugin");
var FontBold = /*#__PURE__*/ function(_PluginComponent) {
    (0, _inheritsLooseDefault.default)(FontBold, _PluginComponent);
    function FontBold(props) {
        var _this;
        _this = _PluginComponent.call(this, props) || this;
        _this.handleKeyboard = {
            key: "b",
            keyCode: 66,
            aliasCommand: true,
            withKey: [
                "ctrlKey"
            ],
            callback: function callback() {
                return _this.editor.insertMarkdown("bold");
            }
        };
        return _this;
    }
    var _proto = FontBold.prototype;
    _proto.componentDidMount = function componentDidMount() {
        if (this.editorConfig.shortcuts) this.editor.onKeyboard(this.handleKeyboard);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.editor.offKeyboard(this.handleKeyboard);
    };
    _proto.render = function render() {
        var _this2 = this;
        return /*#__PURE__*/ _react.createElement("span", {
            className: "button button-type-bold",
            title: (0, _i18NDefault.default).get("btnBold"),
            onClick: function onClick() {
                return _this2.editor.insertMarkdown("bold");
            }
        }, /*#__PURE__*/ _react.createElement((0, _iconDefault.default), {
            type: "bold"
        }));
    };
    return FontBold;
}((0, _plugin.PluginComponent));
FontBold.pluginName = "font-bold";

},{"@babel/runtime/helpers/inheritsLoose":"j53wo","react":"6uln9","../../components/Icon":"40q2L","../../i18n":"2WwwD","../Plugin":"iqHiK","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"l94AL":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>FontItalic);
var _inheritsLoose = require("@babel/runtime/helpers/inheritsLoose");
var _inheritsLooseDefault = parcelHelpers.interopDefault(_inheritsLoose);
var _react = require("react");
var _icon = require("../../components/Icon");
var _iconDefault = parcelHelpers.interopDefault(_icon);
var _i18N = require("../../i18n");
var _i18NDefault = parcelHelpers.interopDefault(_i18N);
var _plugin = require("../Plugin");
var FontItalic = /*#__PURE__*/ function(_PluginComponent) {
    (0, _inheritsLooseDefault.default)(FontItalic, _PluginComponent);
    function FontItalic(props) {
        var _this;
        _this = _PluginComponent.call(this, props) || this;
        _this.handleKeyboard = {
            key: "i",
            keyCode: 73,
            aliasCommand: true,
            withKey: [
                "ctrlKey"
            ],
            callback: function callback() {
                return _this.editor.insertMarkdown("italic");
            }
        };
        return _this;
    }
    var _proto = FontItalic.prototype;
    _proto.componentDidMount = function componentDidMount() {
        if (this.editorConfig.shortcuts) this.editor.onKeyboard(this.handleKeyboard);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.editor.offKeyboard(this.handleKeyboard);
    };
    _proto.render = function render() {
        var _this2 = this;
        return /*#__PURE__*/ _react.createElement("span", {
            className: "button button-type-italic",
            title: (0, _i18NDefault.default).get("btnItalic"),
            onClick: function onClick() {
                return _this2.editor.insertMarkdown("italic");
            }
        }, /*#__PURE__*/ _react.createElement((0, _iconDefault.default), {
            type: "italic"
        }));
    };
    return FontItalic;
}((0, _plugin.PluginComponent));
FontItalic.pluginName = "font-italic";

},{"@babel/runtime/helpers/inheritsLoose":"j53wo","react":"6uln9","../../components/Icon":"40q2L","../../i18n":"2WwwD","../Plugin":"iqHiK","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"a8naS":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>FontStrikethrough);
var _inheritsLoose = require("@babel/runtime/helpers/inheritsLoose");
var _inheritsLooseDefault = parcelHelpers.interopDefault(_inheritsLoose);
var _react = require("react");
var _icon = require("../../components/Icon");
var _iconDefault = parcelHelpers.interopDefault(_icon);
var _i18N = require("../../i18n");
var _i18NDefault = parcelHelpers.interopDefault(_i18N);
var _plugin = require("../Plugin");
var FontStrikethrough = /*#__PURE__*/ function(_PluginComponent) {
    (0, _inheritsLooseDefault.default)(FontStrikethrough, _PluginComponent);
    function FontStrikethrough(props) {
        var _this;
        _this = _PluginComponent.call(this, props) || this;
        _this.handleKeyboard = {
            key: "d",
            keyCode: 68,
            aliasCommand: true,
            withKey: [
                "ctrlKey"
            ],
            callback: function callback() {
                return _this.editor.insertMarkdown("strikethrough");
            }
        };
        return _this;
    }
    var _proto = FontStrikethrough.prototype;
    _proto.componentDidMount = function componentDidMount() {
        if (this.editorConfig.shortcuts) this.editor.onKeyboard(this.handleKeyboard);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.editor.offKeyboard(this.handleKeyboard);
    };
    _proto.render = function render() {
        var _this2 = this;
        return /*#__PURE__*/ _react.createElement("span", {
            className: "button button-type-strikethrough",
            title: (0, _i18NDefault.default).get("btnStrikethrough"),
            onClick: function onClick() {
                return _this2.editor.insertMarkdown("strikethrough");
            }
        }, /*#__PURE__*/ _react.createElement((0, _iconDefault.default), {
            type: "strikethrough"
        }));
    };
    return FontStrikethrough;
}((0, _plugin.PluginComponent));
FontStrikethrough.pluginName = "font-strikethrough";

},{"@babel/runtime/helpers/inheritsLoose":"j53wo","react":"6uln9","../../components/Icon":"40q2L","../../i18n":"2WwwD","../Plugin":"iqHiK","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7CSgF":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>FontUnderline);
var _inheritsLoose = require("@babel/runtime/helpers/inheritsLoose");
var _inheritsLooseDefault = parcelHelpers.interopDefault(_inheritsLoose);
var _react = require("react");
var _icon = require("../../components/Icon");
var _iconDefault = parcelHelpers.interopDefault(_icon);
var _i18N = require("../../i18n");
var _i18NDefault = parcelHelpers.interopDefault(_i18N);
var _plugin = require("../Plugin");
var FontUnderline = /*#__PURE__*/ function(_PluginComponent) {
    (0, _inheritsLooseDefault.default)(FontUnderline, _PluginComponent);
    function FontUnderline(props) {
        var _this;
        _this = _PluginComponent.call(this, props) || this;
        _this.handleKeyboard = {
            key: "u",
            keyCode: 85,
            withKey: [
                "ctrlKey"
            ],
            callback: function callback() {
                return _this.editor.insertMarkdown("underline");
            }
        };
        return _this;
    }
    var _proto = FontUnderline.prototype;
    _proto.componentDidMount = function componentDidMount() {
        if (this.editorConfig.shortcuts) this.editor.onKeyboard(this.handleKeyboard);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.editor.offKeyboard(this.handleKeyboard);
    };
    _proto.render = function render() {
        var _this2 = this;
        return /*#__PURE__*/ _react.createElement("span", {
            className: "button button-type-underline",
            title: (0, _i18NDefault.default).get("btnUnderline"),
            onClick: function onClick() {
                return _this2.editor.insertMarkdown("underline");
            }
        }, /*#__PURE__*/ _react.createElement((0, _iconDefault.default), {
            type: "underline"
        }));
    };
    return FontUnderline;
}((0, _plugin.PluginComponent));
FontUnderline.pluginName = "font-underline";

},{"@babel/runtime/helpers/inheritsLoose":"j53wo","react":"6uln9","../../components/Icon":"40q2L","../../i18n":"2WwwD","../Plugin":"iqHiK","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"44SSq":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>FullScreen);
var _assertThisInitialized = require("@babel/runtime/helpers/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inheritsLoose = require("@babel/runtime/helpers/inheritsLoose");
var _inheritsLooseDefault = parcelHelpers.interopDefault(_inheritsLoose);
var _react = require("react");
var _icon = require("../components/Icon");
var _iconDefault = parcelHelpers.interopDefault(_icon);
var _i18N = require("../i18n");
var _i18NDefault = parcelHelpers.interopDefault(_i18N);
var _plugin = require("./Plugin");
var FullScreen = /*#__PURE__*/ function(_PluginComponent) {
    (0, _inheritsLooseDefault.default)(FullScreen, _PluginComponent);
    function FullScreen(props) {
        var _this;
        _this = _PluginComponent.call(this, props) || this;
        _this.handleClick = _this.handleClick.bind((0, _assertThisInitializedDefault.default)(_this));
        _this.handleChange = _this.handleChange.bind((0, _assertThisInitializedDefault.default)(_this));
        _this.state = {
            enable: _this.editor.isFullScreen()
        };
        return _this;
    }
    var _proto = FullScreen.prototype;
    _proto.handleClick = function handleClick() {
        this.editor.fullScreen(!this.state.enable);
    };
    _proto.handleChange = function handleChange(enable) {
        this.setState({
            enable: enable
        });
    };
    _proto.componentDidMount = function componentDidMount() {
        this.editor.on("fullscreen", this.handleChange);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.editor.off("fullscreen", this.handleChange);
    };
    _proto.render = function render() {
        if (this.editorConfig.canView && this.editorConfig.canView.fullScreen) {
            var enable = this.state.enable;
            return /*#__PURE__*/ _react.createElement("span", {
                className: "button button-type-fullscreen",
                title: (0, _i18NDefault.default).get(enable ? "btnExitFullScreen" : "btnFullScreen"),
                onClick: this.handleClick
            }, /*#__PURE__*/ _react.createElement((0, _iconDefault.default), {
                type: enable ? "fullscreen-exit" : "fullscreen"
            }));
        }
        return null;
    };
    return FullScreen;
}((0, _plugin.PluginComponent));
FullScreen.pluginName = "full-screen";
FullScreen.align = "right";

},{"@babel/runtime/helpers/assertThisInitialized":"dqevA","@babel/runtime/helpers/inheritsLoose":"j53wo","react":"6uln9","../components/Icon":"40q2L","../i18n":"2WwwD","./Plugin":"iqHiK","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"htJjW":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Header);
var _assertThisInitialized = require("@babel/runtime/helpers/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inheritsLoose = require("@babel/runtime/helpers/inheritsLoose");
var _inheritsLooseDefault = parcelHelpers.interopDefault(_inheritsLoose);
var _react = require("react");
var _dropList = require("../../components/DropList");
var _dropListDefault = parcelHelpers.interopDefault(_dropList);
var _icon = require("../../components/Icon");
var _iconDefault = parcelHelpers.interopDefault(_icon);
var _i18N = require("../../i18n");
var _i18NDefault = parcelHelpers.interopDefault(_i18N);
var _plugin = require("../Plugin");
var _headerList = require("./HeaderList");
var _headerListDefault = parcelHelpers.interopDefault(_headerList);
var Header = /*#__PURE__*/ function(_PluginComponent) {
    (0, _inheritsLooseDefault.default)(Header, _PluginComponent);
    function Header(props) {
        var _this;
        _this = _PluginComponent.call(this, props) || this;
        _this.show = _this.show.bind((0, _assertThisInitializedDefault.default)(_this));
        _this.hide = _this.hide.bind((0, _assertThisInitializedDefault.default)(_this));
        _this.state = {
            show: false
        };
        return _this;
    }
    var _proto = Header.prototype;
    _proto.show = function show() {
        this.setState({
            show: true
        });
    };
    _proto.hide = function hide() {
        this.setState({
            show: false
        });
    };
    _proto.render = function render() {
        var _this2 = this;
        return /*#__PURE__*/ _react.createElement("span", {
            className: "button button-type-header",
            title: (0, _i18NDefault.default).get("btnHeader"),
            onMouseEnter: this.show,
            onMouseLeave: this.hide
        }, /*#__PURE__*/ _react.createElement((0, _iconDefault.default), {
            type: "font-size"
        }), /*#__PURE__*/ _react.createElement((0, _dropListDefault.default), {
            show: this.state.show,
            onClose: this.hide
        }, /*#__PURE__*/ _react.createElement((0, _headerListDefault.default), {
            onSelectHeader: function onSelectHeader(header) {
                return _this2.editor.insertMarkdown(header);
            }
        })));
    };
    return Header;
}((0, _plugin.PluginComponent));
Header.pluginName = "header";

},{"@babel/runtime/helpers/assertThisInitialized":"dqevA","@babel/runtime/helpers/inheritsLoose":"j53wo","react":"6uln9","../../components/DropList":"4RHe8","../../components/Icon":"40q2L","../../i18n":"2WwwD","../Plugin":"iqHiK","./HeaderList":"fsy5o","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4RHe8":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _assertThisInitialized = require("@babel/runtime/helpers/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inheritsLoose = require("@babel/runtime/helpers/inheritsLoose");
var _inheritsLooseDefault = parcelHelpers.interopDefault(_inheritsLoose);
var _react = require("react");
var DropList = /*#__PURE__*/ function(_React$Component) {
    (0, _inheritsLooseDefault.default)(DropList, _React$Component);
    function DropList(props) {
        var _this;
        _this = _React$Component.call(this, props) || this;
        _this.handleClose = _this.handleClose.bind((0, _assertThisInitializedDefault.default)(_this));
        return _this;
    }
    var _proto = DropList.prototype;
    _proto.handleClose = function handleClose(e) {
        e.stopPropagation();
        var onClose = this.props.onClose;
        if (typeof onClose === "function") onClose();
    };
    _proto.render = function render() {
        return /*#__PURE__*/ _react.createElement("div", {
            className: "drop-wrap " + (this.props.show ? "show" : "hidden"),
            onClick: this.handleClose
        }, this.props.children);
    };
    return DropList;
}(_react.Component);
exports.default = DropList;

},{"@babel/runtime/helpers/assertThisInitialized":"dqevA","@babel/runtime/helpers/inheritsLoose":"j53wo","react":"6uln9","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"fsy5o":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _inheritsLoose = require("@babel/runtime/helpers/inheritsLoose");
var _inheritsLooseDefault = parcelHelpers.interopDefault(_inheritsLoose);
// HeaderList
var _react = require("react");
var HeaderList = /*#__PURE__*/ function(_React$Component) {
    (0, _inheritsLooseDefault.default)(HeaderList, _React$Component);
    function HeaderList() {
        return _React$Component.apply(this, arguments) || this;
    }
    var _proto = HeaderList.prototype;
    _proto.handleHeader = function handleHeader(header) {
        var onSelectHeader = this.props.onSelectHeader;
        if (typeof onSelectHeader === "function") onSelectHeader(header);
    };
    _proto.render = function render() {
        return /*#__PURE__*/ _react.createElement("ul", {
            className: "header-list"
        }, /*#__PURE__*/ _react.createElement("li", {
            className: "list-item"
        }, /*#__PURE__*/ _react.createElement("h1", {
            onClick: this.handleHeader.bind(this, "h1")
        }, "H1")), /*#__PURE__*/ _react.createElement("li", {
            className: "list-item"
        }, /*#__PURE__*/ _react.createElement("h2", {
            onClick: this.handleHeader.bind(this, "h2")
        }, "H2")), /*#__PURE__*/ _react.createElement("li", {
            className: "list-item"
        }, /*#__PURE__*/ _react.createElement("h3", {
            onClick: this.handleHeader.bind(this, "h3")
        }, "H3")), /*#__PURE__*/ _react.createElement("li", {
            className: "list-item"
        }, /*#__PURE__*/ _react.createElement("h4", {
            onClick: this.handleHeader.bind(this, "h4")
        }, "H4")), /*#__PURE__*/ _react.createElement("li", {
            className: "list-item"
        }, /*#__PURE__*/ _react.createElement("h5", {
            onClick: this.handleHeader.bind(this, "h5")
        }, "H5")), /*#__PURE__*/ _react.createElement("li", {
            className: "list-item"
        }, /*#__PURE__*/ _react.createElement("h6", {
            onClick: this.handleHeader.bind(this, "h6")
        }, "H6")));
    };
    return HeaderList;
}(_react.Component);
exports.default = HeaderList;

},{"@babel/runtime/helpers/inheritsLoose":"j53wo","react":"6uln9","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"d8iaO":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Image);
var _assertThisInitialized = require("@babel/runtime/helpers/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inheritsLoose = require("@babel/runtime/helpers/inheritsLoose");
var _inheritsLooseDefault = parcelHelpers.interopDefault(_inheritsLoose);
var _react = require("react");
var _icon = require("../../components/Icon");
var _iconDefault = parcelHelpers.interopDefault(_icon);
var _i18N = require("../../i18n");
var _i18NDefault = parcelHelpers.interopDefault(_i18N);
var _plugin = require("../Plugin");
var _tool = require("../../utils/tool");
var _uploadPlaceholder = require("../../utils/uploadPlaceholder");
var _uploadPlaceholderDefault = parcelHelpers.interopDefault(_uploadPlaceholder);
var _inputFile = require("./inputFile");
var _inputFileDefault = parcelHelpers.interopDefault(_inputFile);
var Image = /*#__PURE__*/ function(_PluginComponent) {
    (0, _inheritsLooseDefault.default)(Image, _PluginComponent);
    function Image(props) {
        var _this;
        _this = _PluginComponent.call(this, props) || this;
        _this.inputFile = /*#__PURE__*/ _react.createRef();
        _this.onImageChanged = _this.onImageChanged.bind((0, _assertThisInitializedDefault.default)(_this));
        _this.handleCustomImageUpload = _this.handleCustomImageUpload.bind((0, _assertThisInitializedDefault.default)(_this));
        _this.handleImageUpload = _this.handleImageUpload.bind((0, _assertThisInitializedDefault.default)(_this));
        _this.state = {
            show: false
        };
        return _this;
    }
    var _proto = Image.prototype;
    _proto.handleImageUpload = function handleImageUpload() {
        var onImageUpload = this.editorConfig.onImageUpload;
        if (typeof onImageUpload === "function") {
            if (this.inputFile.current) this.inputFile.current.click();
        } else this.editor.insertMarkdown("image");
    };
    _proto.onImageChanged = function onImageChanged(file) {
        var onImageUpload = this.editorConfig.onImageUpload;
        if (onImageUpload) {
            var placeholder = (0, _uploadPlaceholderDefault.default)(file, onImageUpload);
            this.editor.insertPlaceholder(placeholder.placeholder, placeholder.uploaded);
        }
    };
    _proto.handleCustomImageUpload = function handleCustomImageUpload(e) {
        var _this2 = this;
        var onCustomImageUpload = this.editorConfig.onCustomImageUpload;
        if (onCustomImageUpload) {
            var res = onCustomImageUpload.call(this, e);
            if ((0, _tool.isPromise)(res)) res.then(function(result) {
                if (result && result.url) _this2.editor.insertMarkdown("image", {
                    target: result.text,
                    imageUrl: result.url
                });
            });
        }
    };
    _proto.render = function render() {
        var _this3 = this;
        var isCustom = !!this.editorConfig.onCustomImageUpload;
        return isCustom ? /*#__PURE__*/ _react.createElement("span", {
            className: "button button-type-image",
            title: (0, _i18NDefault.default).get("btnImage"),
            onClick: this.handleCustomImageUpload
        }, /*#__PURE__*/ _react.createElement((0, _iconDefault.default), {
            type: "image"
        })) : /*#__PURE__*/ _react.createElement("span", {
            className: "button button-type-image",
            title: (0, _i18NDefault.default).get("btnImage"),
            onClick: this.handleImageUpload,
            style: {
                position: "relative"
            }
        }, /*#__PURE__*/ _react.createElement((0, _iconDefault.default), {
            type: "image"
        }), /*#__PURE__*/ _react.createElement((0, _inputFileDefault.default), {
            accept: this.editorConfig.imageAccept || "",
            ref: this.inputFile,
            onChange: function onChange(e) {
                e.persist();
                if (e.target.files && e.target.files.length > 0) _this3.onImageChanged(e.target.files[0]);
            }
        }));
    };
    return Image;
}((0, _plugin.PluginComponent));
Image.pluginName = "image";

},{"@babel/runtime/helpers/assertThisInitialized":"dqevA","@babel/runtime/helpers/inheritsLoose":"j53wo","react":"6uln9","../../components/Icon":"40q2L","../../i18n":"2WwwD","../Plugin":"iqHiK","../../utils/tool":"O3FOt","../../utils/uploadPlaceholder":"5R07R","./inputFile":"b8IQX","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"b8IQX":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _inheritsLoose = require("@babel/runtime/helpers/inheritsLoose");
var _inheritsLooseDefault = parcelHelpers.interopDefault(_inheritsLoose);
// TableList
var _react = require("react");
var InputFile = /*#__PURE__*/ function(_React$Component) {
    (0, _inheritsLooseDefault.default)(InputFile, _React$Component);
    function InputFile(props) {
        var _this;
        _this = _React$Component.call(this, props) || this;
        _this.timerId = undefined;
        _this.locked = false;
        _this.input = /*#__PURE__*/ _react.createRef();
        return _this;
    }
    var _proto = InputFile.prototype;
    _proto.click = function click() {
        var _this2 = this;
        if (this.locked || !this.input.current) return;
        this.locked = true;
        this.input.current.value = "";
        this.input.current.click();
        if (this.timerId) window.clearTimeout(this.timerId);
        this.timerId = window.setTimeout(function() {
            _this2.locked = false;
            window.clearTimeout(_this2.timerId);
            _this2.timerId = undefined;
        }, 200);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        if (this.timerId) window.clearTimeout(this.timerId);
    };
    _proto.render = function render() {
        return /*#__PURE__*/ _react.createElement("input", {
            type: "file",
            ref: this.input,
            accept: this.props.accept,
            style: {
                position: "absolute",
                zIndex: -1,
                left: 0,
                top: 0,
                width: 0,
                height: 0,
                opacity: 0
            },
            onChange: this.props.onChange
        });
    };
    return InputFile;
}(_react.Component);
exports.default = InputFile;

},{"@babel/runtime/helpers/inheritsLoose":"j53wo","react":"6uln9","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"ixair":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Link);
var _inheritsLoose = require("@babel/runtime/helpers/inheritsLoose");
var _inheritsLooseDefault = parcelHelpers.interopDefault(_inheritsLoose);
var _react = require("react");
var _icon = require("../components/Icon");
var _iconDefault = parcelHelpers.interopDefault(_icon);
var _i18N = require("../i18n");
var _i18NDefault = parcelHelpers.interopDefault(_i18N);
var _plugin = require("./Plugin");
var Link = /*#__PURE__*/ function(_PluginComponent) {
    (0, _inheritsLooseDefault.default)(Link, _PluginComponent);
    function Link(props) {
        var _this;
        _this = _PluginComponent.call(this, props) || this;
        _this.handleKeyboard = {
            key: "k",
            keyCode: 75,
            aliasCommand: true,
            withKey: [
                "ctrlKey"
            ],
            callback: function callback() {
                return _this.editor.insertMarkdown("link");
            }
        };
        return _this;
    }
    var _proto = Link.prototype;
    _proto.componentDidMount = function componentDidMount() {
        if (this.editorConfig.shortcuts) this.editor.onKeyboard(this.handleKeyboard);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.editor.offKeyboard(this.handleKeyboard);
    };
    _proto.render = function render() {
        var _this2 = this;
        return /*#__PURE__*/ _react.createElement("span", {
            className: "button button-type-link",
            title: (0, _i18NDefault.default).get("btnLink"),
            onClick: function onClick() {
                return _this2.editor.insertMarkdown("link");
            }
        }, /*#__PURE__*/ _react.createElement((0, _iconDefault.default), {
            type: "link"
        }));
    };
    return Link;
}((0, _plugin.PluginComponent));
Link.pluginName = "link";

},{"@babel/runtime/helpers/inheritsLoose":"j53wo","react":"6uln9","../components/Icon":"40q2L","../i18n":"2WwwD","./Plugin":"iqHiK","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jnKYB":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>ListOrdered);
var _inheritsLoose = require("@babel/runtime/helpers/inheritsLoose");
var _inheritsLooseDefault = parcelHelpers.interopDefault(_inheritsLoose);
var _react = require("react");
var _icon = require("../../components/Icon");
var _iconDefault = parcelHelpers.interopDefault(_icon);
var _i18N = require("../../i18n");
var _i18NDefault = parcelHelpers.interopDefault(_i18N);
var _plugin = require("../Plugin");
var ListOrdered = /*#__PURE__*/ function(_PluginComponent) {
    (0, _inheritsLooseDefault.default)(ListOrdered, _PluginComponent);
    function ListOrdered(props) {
        var _this;
        _this = _PluginComponent.call(this, props) || this;
        _this.handleKeyboard = {
            key: "7",
            keyCode: 55,
            withKey: [
                "ctrlKey",
                "shiftKey"
            ],
            aliasCommand: true,
            callback: function callback() {
                return _this.editor.insertMarkdown("order");
            }
        };
        return _this;
    }
    var _proto = ListOrdered.prototype;
    _proto.componentDidMount = function componentDidMount() {
        if (this.editorConfig.shortcuts) this.editor.onKeyboard(this.handleKeyboard);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.editor.offKeyboard(this.handleKeyboard);
    };
    _proto.render = function render() {
        var _this2 = this;
        return /*#__PURE__*/ _react.createElement("span", {
            className: "button button-type-ordered",
            title: (0, _i18NDefault.default).get("btnOrdered"),
            onClick: function onClick() {
                return _this2.editor.insertMarkdown("order");
            }
        }, /*#__PURE__*/ _react.createElement((0, _iconDefault.default), {
            type: "list-ordered"
        }));
    };
    return ListOrdered;
}((0, _plugin.PluginComponent));
ListOrdered.pluginName = "list-ordered";

},{"@babel/runtime/helpers/inheritsLoose":"j53wo","react":"6uln9","../../components/Icon":"40q2L","../../i18n":"2WwwD","../Plugin":"iqHiK","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6413x":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>ListUnordered);
var _inheritsLoose = require("@babel/runtime/helpers/inheritsLoose");
var _inheritsLooseDefault = parcelHelpers.interopDefault(_inheritsLoose);
var _react = require("react");
var _icon = require("../../components/Icon");
var _iconDefault = parcelHelpers.interopDefault(_icon);
var _i18N = require("../../i18n");
var _i18NDefault = parcelHelpers.interopDefault(_i18N);
var _plugin = require("../Plugin");
var ListUnordered = /*#__PURE__*/ function(_PluginComponent) {
    (0, _inheritsLooseDefault.default)(ListUnordered, _PluginComponent);
    function ListUnordered(props) {
        var _this;
        _this = _PluginComponent.call(this, props) || this;
        _this.handleKeyboard = {
            key: "8",
            keyCode: 56,
            withKey: [
                "ctrlKey",
                "shiftKey"
            ],
            aliasCommand: true,
            callback: function callback() {
                return _this.editor.insertMarkdown("unordered");
            }
        };
        return _this;
    }
    var _proto = ListUnordered.prototype;
    _proto.componentDidMount = function componentDidMount() {
        if (this.editorConfig.shortcuts) this.editor.onKeyboard(this.handleKeyboard);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.editor.offKeyboard(this.handleKeyboard);
    };
    _proto.render = function render() {
        var _this2 = this;
        return /*#__PURE__*/ _react.createElement("span", {
            className: "button button-type-unordered",
            title: (0, _i18NDefault.default).get("btnUnordered"),
            onClick: function onClick() {
                return _this2.editor.insertMarkdown("unordered");
            }
        }, /*#__PURE__*/ _react.createElement((0, _iconDefault.default), {
            type: "list-unordered"
        }));
    };
    return ListUnordered;
}((0, _plugin.PluginComponent));
ListUnordered.pluginName = "list-unordered";

},{"@babel/runtime/helpers/inheritsLoose":"j53wo","react":"6uln9","../../components/Icon":"40q2L","../../i18n":"2WwwD","../Plugin":"iqHiK","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1Z7Hb":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Logger);
var _assertThisInitialized = require("@babel/runtime/helpers/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inheritsLoose = require("@babel/runtime/helpers/inheritsLoose");
var _inheritsLooseDefault = parcelHelpers.interopDefault(_inheritsLoose);
var _react = require("react");
var _icon = require("../../components/Icon");
var _iconDefault = parcelHelpers.interopDefault(_icon);
var _i18N = require("../../i18n");
var _i18NDefault = parcelHelpers.interopDefault(_i18N);
var _plugin = require("../Plugin");
var _logger = require("./logger");
var _loggerDefault = parcelHelpers.interopDefault(_logger);
var Logger = /*#__PURE__*/ function(_PluginComponent) {
    (0, _inheritsLooseDefault.default)(Logger, _PluginComponent);
    function Logger(props) {
        var _this;
        _this = _PluginComponent.call(this, props) || this;
        _this.handleKeyboards = [];
        _this.lastPop = null;
        _this.handleChange = _this.handleChange.bind((0, _assertThisInitializedDefault.default)(_this));
        _this.handleRedo = _this.handleRedo.bind((0, _assertThisInitializedDefault.default)(_this));
        _this.handleUndo = _this.handleUndo.bind((0, _assertThisInitializedDefault.default)(_this)); // Mac的Redo比较特殊，是Command+Shift+Z，优先处理
        _this.handleKeyboards = [
            {
                key: "y",
                keyCode: 89,
                withKey: [
                    "ctrlKey"
                ],
                callback: _this.handleRedo
            },
            {
                key: "z",
                keyCode: 90,
                withKey: [
                    "metaKey",
                    "shiftKey"
                ],
                callback: _this.handleRedo
            },
            {
                key: "z",
                keyCode: 90,
                aliasCommand: true,
                withKey: [
                    "ctrlKey"
                ],
                callback: _this.handleUndo
            }
        ];
        _this.logger = new (0, _loggerDefault.default)({
            maxSize: _this.editorConfig.loggerMaxSize
        }); // 注册API
        _this.editor.registerPluginApi("undo", _this.handleUndo);
        _this.editor.registerPluginApi("redo", _this.handleRedo);
        return _this;
    }
    var _proto = Logger.prototype;
    _proto.handleUndo = function handleUndo() {
        var last = this.logger.undo(this.editor.getMdValue());
        if (typeof last !== "undefined") {
            this.pause();
            this.lastPop = last;
            this.editor.setText(last);
            this.forceUpdate();
        }
    };
    _proto.handleRedo = function handleRedo() {
        var last = this.logger.redo();
        if (typeof last !== "undefined") {
            this.lastPop = last;
            this.editor.setText(last);
            this.forceUpdate();
        }
    };
    _proto.handleChange = function handleChange(value, e, isNotInput) {
        var _this2 = this;
        if (this.logger.getLast() === value || this.lastPop !== null && this.lastPop === value) return;
        this.logger.cleanRedo();
        if (isNotInput) {
            // from setText API call, not a input
            this.logger.push(value);
            this.lastPop = null;
            this.forceUpdate();
            return;
        }
        if (this.timerId) {
            window.clearTimeout(this.timerId);
            this.timerId = 0;
        }
        this.timerId = window.setTimeout(function() {
            if (_this2.logger.getLast() !== value) {
                _this2.logger.push(value);
                _this2.lastPop = null;
                _this2.forceUpdate();
            }
            window.clearTimeout(_this2.timerId);
            _this2.timerId = 0;
        }, this.editorConfig.loggerInterval);
    };
    _proto.componentDidMount = function componentDidMount() {
        var _this3 = this;
        // 监听变化事件
        this.editor.on("change", this.handleChange); // 监听键盘事件
        this.handleKeyboards.forEach(function(it) {
            return _this3.editor.onKeyboard(it);
        }); // 初始化时，把已有值填充进logger
        this.logger.initValue = this.editor.getMdValue();
        this.forceUpdate();
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        var _this4 = this;
        if (this.timerId) window.clearTimeout(this.timerId);
        this.editor.off("change", this.handleChange);
        this.editor.unregisterPluginApi("undo");
        this.editor.unregisterPluginApi("redo");
        this.handleKeyboards.forEach(function(it) {
            return _this4.editor.offKeyboard(it);
        });
    };
    _proto.pause = function pause() {
        if (this.timerId) {
            window.clearTimeout(this.timerId);
            this.timerId = undefined;
        }
    };
    _proto.render = function render() {
        var hasUndo = this.logger.getUndoCount() > 1 || this.logger.initValue !== this.editor.getMdValue();
        var hasRedo = this.logger.getRedoCount() > 0;
        return /*#__PURE__*/ _react.createElement(_react.Fragment, null, /*#__PURE__*/ _react.createElement("span", {
            className: "button button-type-undo " + (hasUndo ? "" : "disabled"),
            title: (0, _i18NDefault.default).get("btnUndo"),
            onClick: this.handleUndo
        }, /*#__PURE__*/ _react.createElement((0, _iconDefault.default), {
            type: "undo"
        })), /*#__PURE__*/ _react.createElement("span", {
            className: "button button-type-redo " + (hasRedo ? "" : "disabled"),
            title: (0, _i18NDefault.default).get("btnRedo"),
            onClick: this.handleRedo
        }, /*#__PURE__*/ _react.createElement((0, _iconDefault.default), {
            type: "redo"
        })));
    };
    return Logger;
}((0, _plugin.PluginComponent));
Logger.pluginName = "logger";

},{"@babel/runtime/helpers/assertThisInitialized":"dqevA","@babel/runtime/helpers/inheritsLoose":"j53wo","react":"6uln9","../../components/Icon":"40q2L","../../i18n":"2WwwD","../Plugin":"iqHiK","./logger":"5sX5P","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"5sX5P":[function(require,module,exports) {
/**
 * logger: undo redo
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var MAX_LOG_SIZE = 100;
var Logger = /*#__PURE__*/ function() {
    function Logger(props) {
        if (props === void 0) props = {};
        this.record = [];
        this.recycle = [];
        this.initValue = "";
        var _props = props, _props$maxSize = _props.maxSize, maxSize = _props$maxSize === void 0 ? MAX_LOG_SIZE : _props$maxSize;
        this.maxSize = maxSize;
    }
    var _proto = Logger.prototype;
    _proto.push = function push(val) {
        var result = this.record.push(val); // 如果超过了最长限制，把之前的清理掉，避免造成内存浪费
        while(this.record.length > this.maxSize)this.record.shift();
        return result;
    };
    _proto.get = function get() {
        return this.record;
    };
    _proto.getLast = function getLast() {
        var length = this.record.length;
        return this.record[length - 1];
    };
    _proto.undo = function undo(skipText) {
        var current = this.record.pop();
        if (typeof current === "undefined") return this.initValue;
         // 如果最上面的和现在的不一样，那就不需要再pop一次
        if (current !== skipText) {
            this.recycle.push(current);
            return current;
        } // 否则的话，最顶上的一个是当前状态，所以要pop两次才能得到之前的结果
        var last = this.record.pop();
        if (typeof last === "undefined") {
            // 已经没有更老的记录了，把初始值给出去吧
            this.recycle.push(current);
            return this.initValue;
        } // last 才是真正的上一步
        this.recycle.push(current);
        return last;
    };
    _proto.redo = function redo() {
        var history = this.recycle.pop();
        if (typeof history !== "undefined") {
            this.push(history);
            return history;
        }
        return undefined;
    };
    _proto.cleanRedo = function cleanRedo() {
        this.recycle = [];
    };
    _proto.getUndoCount = function getUndoCount() {
        return this.undo.length;
    };
    _proto.getRedoCount = function getRedoCount() {
        return this.recycle.length;
    };
    return Logger;
}();
exports.default = Logger;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"iZzKX":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _createClass = require("@babel/runtime/helpers/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _assertThisInitialized = require("@babel/runtime/helpers/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inheritsLoose = require("@babel/runtime/helpers/inheritsLoose");
var _inheritsLooseDefault = parcelHelpers.interopDefault(_inheritsLoose);
var _react = require("react");
var _icon = require("../components/Icon");
var _iconDefault = parcelHelpers.interopDefault(_icon);
var _i18N = require("../i18n");
var _i18NDefault = parcelHelpers.interopDefault(_i18N);
var _plugin = require("./Plugin");
var NEXT_ACTION;
(function(NEXT_ACTION) {
    NEXT_ACTION[NEXT_ACTION["SHOW_ALL"] = 0] = "SHOW_ALL";
    NEXT_ACTION[NEXT_ACTION["SHOW_MD"] = 1] = "SHOW_MD";
    NEXT_ACTION[NEXT_ACTION["SHOW_HTML"] = 2] = "SHOW_HTML";
})(NEXT_ACTION || (NEXT_ACTION = {}));
var ModeToggle = /*#__PURE__*/ function(_PluginComponent) {
    (0, _inheritsLooseDefault.default)(ModeToggle, _PluginComponent);
    function ModeToggle(props) {
        var _this;
        _this = _PluginComponent.call(this, props) || this;
        _this.handleClick = _this.handleClick.bind((0, _assertThisInitializedDefault.default)(_this));
        _this.handleChange = _this.handleChange.bind((0, _assertThisInitializedDefault.default)(_this));
        _this.state = {
            view: _this.editor.getView()
        };
        return _this;
    }
    var _proto = ModeToggle.prototype;
    _proto.handleClick = function handleClick() {
        switch(this.next){
            case NEXT_ACTION.SHOW_ALL:
                this.editor.setView({
                    html: true,
                    md: true
                });
                break;
            case NEXT_ACTION.SHOW_HTML:
                this.editor.setView({
                    html: true,
                    md: false
                });
                break;
            case NEXT_ACTION.SHOW_MD:
                this.editor.setView({
                    html: false,
                    md: true
                });
                break;
        }
    };
    _proto.handleChange = function handleChange(view) {
        this.setState({
            view: view
        });
    };
    _proto.componentDidMount = function componentDidMount() {
        this.editor.on("viewchange", this.handleChange);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.editor.off("viewchange", this.handleChange);
    };
    _proto.getDisplayInfo = function getDisplayInfo() {
        var next = this.next;
        switch(next){
            case NEXT_ACTION.SHOW_ALL:
                return {
                    icon: "view-split",
                    title: "All"
                };
            case NEXT_ACTION.SHOW_HTML:
                return {
                    icon: "visibility",
                    title: "Preview"
                };
            default:
                return {
                    icon: "keyboard",
                    title: "Editor"
                };
        }
    };
    _proto.render = function render() {
        if (this.isDisplay) {
            var display = this.getDisplayInfo();
            return /*#__PURE__*/ _react.createElement("span", {
                className: "button button-type-mode",
                title: (0, _i18NDefault.default).get("btnMode" + display.title),
                onClick: this.handleClick
            }, /*#__PURE__*/ _react.createElement((0, _iconDefault.default), {
                type: display.icon
            }));
        }
        return null;
    };
    (0, _createClassDefault.default)(ModeToggle, [
        {
            key: "isDisplay",
            get: function get() {
                var canView = this.editorConfig.canView;
                if (canView) // 至少有两种情况可以显示的时候，才会显示切换按钮
                return [
                    canView.html,
                    canView.md,
                    canView.both
                ].filter(function(it) {
                    return it;
                }).length >= 2;
                return false;
            }
        },
        {
            key: "next",
            get: function get() {
                var canView = this.editorConfig.canView;
                var view = this.state.view;
                var actions = [
                    NEXT_ACTION.SHOW_ALL,
                    NEXT_ACTION.SHOW_MD,
                    NEXT_ACTION.SHOW_HTML
                ];
                if (canView) {
                    if (!canView.both) actions.splice(actions.indexOf(NEXT_ACTION.SHOW_ALL), 1);
                    if (!canView.md) actions.splice(actions.indexOf(NEXT_ACTION.SHOW_MD), 1);
                    if (!canView.html) actions.splice(actions.indexOf(NEXT_ACTION.SHOW_HTML), 1);
                }
                var current = NEXT_ACTION.SHOW_MD;
                if (view.html) current = NEXT_ACTION.SHOW_HTML;
                if (view.html && view.md) current = NEXT_ACTION.SHOW_ALL;
                if (actions.length === 0) return current;
                if (actions.length === 1) return actions[0];
                var index = actions.indexOf(current);
                return index < actions.length - 1 ? actions[index + 1] : actions[0];
            }
        }
    ]);
    return ModeToggle;
}((0, _plugin.PluginComponent));
ModeToggle.pluginName = "mode-toggle";
ModeToggle.align = "right";
exports.default = ModeToggle;

},{"@babel/runtime/helpers/createClass":"h0R9D","@babel/runtime/helpers/assertThisInitialized":"dqevA","@babel/runtime/helpers/inheritsLoose":"j53wo","react":"6uln9","../components/Icon":"40q2L","../i18n":"2WwwD","./Plugin":"iqHiK","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9nOE0":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Table);
var _assertThisInitialized = require("@babel/runtime/helpers/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inheritsLoose = require("@babel/runtime/helpers/inheritsLoose");
var _inheritsLooseDefault = parcelHelpers.interopDefault(_inheritsLoose);
var _react = require("react");
var _dropList = require("../../components/DropList");
var _dropListDefault = parcelHelpers.interopDefault(_dropList);
var _icon = require("../../components/Icon");
var _iconDefault = parcelHelpers.interopDefault(_icon);
var _i18N = require("../../i18n");
var _i18NDefault = parcelHelpers.interopDefault(_i18N);
var _plugin = require("../Plugin");
var _table = require("./table");
var _tableDefault = parcelHelpers.interopDefault(_table);
var Table = /*#__PURE__*/ function(_PluginComponent) {
    (0, _inheritsLooseDefault.default)(Table, _PluginComponent);
    function Table(props) {
        var _this;
        _this = _PluginComponent.call(this, props) || this;
        _this.show = _this.show.bind((0, _assertThisInitializedDefault.default)(_this));
        _this.hide = _this.hide.bind((0, _assertThisInitializedDefault.default)(_this));
        _this.state = {
            show: false
        };
        return _this;
    }
    var _proto = Table.prototype;
    _proto.show = function show() {
        this.setState({
            show: true
        });
    };
    _proto.hide = function hide() {
        this.setState({
            show: false
        });
    };
    _proto.render = function render() {
        var _this2 = this;
        var config = this.editorConfig.table || this.props.config;
        return /*#__PURE__*/ _react.createElement("span", {
            className: "button button-type-table",
            title: (0, _i18NDefault.default).get("btnTable"),
            onMouseEnter: this.show,
            onMouseLeave: this.hide
        }, /*#__PURE__*/ _react.createElement((0, _iconDefault.default), {
            type: "grid"
        }), /*#__PURE__*/ _react.createElement((0, _dropListDefault.default), {
            show: this.state.show,
            onClose: this.hide
        }, /*#__PURE__*/ _react.createElement((0, _tableDefault.default), {
            visibility: this.state.show,
            maxRow: config.maxRow,
            maxCol: config.maxCol,
            onSetTable: function onSetTable(option) {
                return _this2.editor.insertMarkdown("table", option);
            }
        })));
    };
    return Table;
}((0, _plugin.PluginComponent));
Table.pluginName = "table";
Table.defaultConfig = {
    maxRow: 6,
    maxCol: 6
};

},{"@babel/runtime/helpers/assertThisInitialized":"dqevA","@babel/runtime/helpers/inheritsLoose":"j53wo","react":"6uln9","../../components/DropList":"4RHe8","../../components/Icon":"40q2L","../../i18n":"2WwwD","../Plugin":"iqHiK","./table":"cuycw","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"cuycw":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _inheritsLoose = require("@babel/runtime/helpers/inheritsLoose");
var _inheritsLooseDefault = parcelHelpers.interopDefault(_inheritsLoose);
var _react = require("react");
var TableList = /*#__PURE__*/ function(_React$Component) {
    (0, _inheritsLooseDefault.default)(TableList, _React$Component);
    function TableList(props) {
        var _this;
        _this = _React$Component.call(this, props) || this;
        _this.config = {
            padding: 3,
            width: 20,
            height: 20
        };
        var _props$maxRow = props.maxRow, maxRow = _props$maxRow === void 0 ? 5 : _props$maxRow, _props$maxCol = props.maxCol, maxCol = _props$maxCol === void 0 ? 6 : _props$maxCol;
        _this.state = {
            maxRow: maxRow,
            maxCol: maxCol,
            list: _this.formatTableModel(maxRow, maxCol)
        };
        return _this;
    }
    var _proto = TableList.prototype;
    _proto.formatTableModel = function formatTableModel(maxRow, maxCol) {
        if (maxRow === void 0) maxRow = 0;
        if (maxCol === void 0) maxCol = 0;
        var result = new Array(maxRow).fill(undefined);
        return result.map(function(_) {
            return new Array(maxCol).fill(0);
        });
    };
    _proto.calcWrapStyle = function calcWrapStyle() {
        var _this$state = this.state, maxRow = _this$state.maxRow, maxCol = _this$state.maxCol;
        var _this$config = this.config, width = _this$config.width, height = _this$config.height, padding = _this$config.padding;
        var wrapWidth = (width + padding) * maxCol - padding;
        var wrapHeight = (height + padding) * maxRow - padding;
        return {
            width: wrapWidth + "px",
            height: wrapHeight + "px"
        };
    };
    _proto.calcItemStyle = function calcItemStyle(row, col) {
        if (row === void 0) row = 0;
        if (col === void 0) col = 0;
        var _this$config2 = this.config, width = _this$config2.width, height = _this$config2.height, padding = _this$config2.padding;
        var top = (height + padding) * row;
        var left = (width + padding) * col;
        return {
            top: top + "px",
            left: left + "px"
        };
    };
    _proto.getList = function getList(i, j) {
        var list = this.state.list;
        return list.map(function(v, row) {
            return v.map(function(_, col) {
                return row <= i && col <= j ? 1 : 0;
            });
        });
    };
    _proto.handleHover = function handleHover(i, j) {
        this.setState({
            list: this.getList(i, j)
        });
    };
    _proto.handleSetTable = function handleSetTable(i, j) {
        var onSetTable = this.props.onSetTable;
        if (typeof onSetTable === "function") onSetTable({
            row: i + 1,
            col: j + 1
        });
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        if (this.props.visibility === false && prevProps.visibility !== this.props.visibility) this.setState({
            list: this.getList(-1, -1)
        });
    };
    _proto.render = function render() {
        var _this2 = this;
        return /*#__PURE__*/ _react.createElement("ul", {
            className: "table-list wrap",
            style: this.calcWrapStyle()
        }, this.state.list.map(function(row, i) {
            return row.map(function(col, j) {
                return /*#__PURE__*/ _react.createElement("li", {
                    className: "list-item " + (col === 1 ? "active" : ""),
                    key: i + "-" + j,
                    style: _this2.calcItemStyle(i, j),
                    onMouseOver: _this2.handleHover.bind(_this2, i, j),
                    onClick: _this2.handleSetTable.bind(_this2, i, j)
                });
            });
        }));
    };
    return TableList;
}(_react.Component);
exports.default = TableList;

},{"@babel/runtime/helpers/inheritsLoose":"j53wo","react":"6uln9","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"ltHNI":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>TabInsert);
var _assertThisInitialized = require("@babel/runtime/helpers/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inheritsLoose = require("@babel/runtime/helpers/inheritsLoose");
var _inheritsLooseDefault = parcelHelpers.interopDefault(_inheritsLoose);
/**
 * Since the Markdown Editor will lose input focus when user tpye a Tab key,
 * this is a built-in plugin to enable user to input Tab character.
 * see src/demo/index.tsx.
 */ var _react = require("react");
var _plugin = require("../Plugin");
var _dropList = require("../../components/DropList");
var _dropListDefault = parcelHelpers.interopDefault(_dropList);
var _i18N = require("../../i18n");
var _i18NDefault = parcelHelpers.interopDefault(_i18N);
var _tabMapList = require("./TabMapList");
var _tabMapListDefault = parcelHelpers.interopDefault(_tabMapList);
var _icon = require("../../components/Icon");
var _iconDefault = parcelHelpers.interopDefault(_icon);
/**
 * @field tabMapValue:  Number of spaces will be inputted. Especially, note that 1 means a '\t' instead of ' '.
 * @field show:         Whether to show TabMapList.
 */ var TabInsert = /*#__PURE__*/ function(_PluginComponent) {
    (0, _inheritsLooseDefault.default)(TabInsert, _PluginComponent);
    function TabInsert(props) {
        var _this;
        _this = _PluginComponent.call(this, props) || this;
        _this.show = _this.show.bind((0, _assertThisInitializedDefault.default)(_this));
        _this.hide = _this.hide.bind((0, _assertThisInitializedDefault.default)(_this));
        _this.handleChangeMapValue = _this.handleChangeMapValue.bind((0, _assertThisInitializedDefault.default)(_this));
        _this.state = {
            tabMapValue: _this.getConfig("tabMapValue"),
            show: false
        };
        _this.handleKeyboard = {
            key: "Tab",
            keyCode: 9,
            aliasCommand: true,
            withKey: [],
            callback: function callback() {
                return _this.editor.insertMarkdown("tab", {
                    tabMapValue: _this.state.tabMapValue
                });
            }
        };
        return _this;
    }
    var _proto = TabInsert.prototype;
    _proto.show = function show() {
        this.setState({
            show: true
        });
    };
    _proto.hide = function hide() {
        this.setState({
            show: false
        });
    };
    _proto.handleChangeMapValue = function handleChangeMapValue(mapValue) {
        this.setState({
            tabMapValue: mapValue
        });
    };
    _proto.componentDidMount = function componentDidMount() {
        if (this.editorConfig.shortcuts) this.editor.onKeyboard(this.handleKeyboard);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.editor.offKeyboard(this.handleKeyboard);
    };
    _proto.render = function render() {
        return /*#__PURE__*/ _react.createElement("span", {
            className: "button button-type-header",
            title: (0, _i18NDefault.default).get("selectTabMap"),
            onClick: this.show,
            onMouseLeave: this.hide
        }, /*#__PURE__*/ _react.createElement((0, _iconDefault.default), {
            type: "tab"
        }), /*#__PURE__*/ _react.createElement((0, _dropListDefault.default), {
            show: this.state.show,
            onClose: this.hide
        }, /*#__PURE__*/ _react.createElement((0, _tabMapListDefault.default), {
            value: this.state.tabMapValue,
            onSelectMapValue: this.handleChangeMapValue
        })));
    };
    return TabInsert;
}((0, _plugin.PluginComponent));
TabInsert.pluginName = "tab-insert";
TabInsert.defaultConfig = {
    tabMapValue: 1
};

},{"@babel/runtime/helpers/assertThisInitialized":"dqevA","@babel/runtime/helpers/inheritsLoose":"j53wo","react":"6uln9","../Plugin":"iqHiK","../../components/DropList":"4RHe8","../../i18n":"2WwwD","./TabMapList":"fzxhj","../../components/Icon":"40q2L","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"fzxhj":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _inheritsLoose = require("@babel/runtime/helpers/inheritsLoose");
var _inheritsLooseDefault = parcelHelpers.interopDefault(_inheritsLoose);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _react = require("react");
var _i18N = require("../../i18n");
var _i18NDefault = parcelHelpers.interopDefault(_i18N);
var TabMapList = /*#__PURE__*/ function(_React$Component) {
    (0, _inheritsLooseDefault.default)(TabMapList, _React$Component);
    function TabMapList() {
        return _React$Component.apply(this, arguments) || this;
    }
    var _proto = TabMapList.prototype;
    _proto.handleSelectMapValue = function handleSelectMapValue(mapValue) {
        var onSelectMapValue = this.props.onSelectMapValue;
        if (typeof onSelectMapValue === "function") onSelectMapValue(mapValue);
    };
    _proto.render = function render() {
        var _this = this;
        var value = this.props.value;
        return /*#__PURE__*/ _react.createElement("ul", {
            className: "tab-map-list"
        }, [
            1,
            2,
            4,
            8
        ].map(function(it) {
            return /*#__PURE__*/ _react.createElement("li", {
                key: it,
                className: (0, _classnamesDefault.default)("list-item", {
                    active: value === it
                })
            }, /*#__PURE__*/ _react.createElement("div", {
                onClick: _this.handleSelectMapValue.bind(_this, it)
            }, it === 1 ? (0, _i18NDefault.default).get("tab") : it + " " + (0, _i18NDefault.default).get("spaces")));
        }));
    };
    return TabMapList;
}(_react.Component);
exports.default = TabMapList;

},{"@babel/runtime/helpers/inheritsLoose":"j53wo","classnames":"hVGzI","react":"6uln9","../../i18n":"2WwwD","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6erDD":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _reactMarkdown = require("react-markdown");
var _reactMarkdownDefault = parcelHelpers.interopDefault(_reactMarkdown);
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const linkRenderer = (props)=>{
    return (0, _react.jsx)("a", {
        href: props.href,
        target: "_blank"
    }, props.children);
};
const MarkdownPreview = (props)=>(0, _react.jsx)("div", {
        className: containerStyle
    }, (0, _react.jsx)((0, _reactMarkdownDefault.default), {
        className: "instructions",
        source: props.instructionsMarkdown,
        renderers: {
            link: linkRenderer
        }
    }));
const containerStyle = /*#__PURE__*/ (0, _css.css)({
    name: "84kjh3",
    styles: "flex:1;.instructions{font-family:Muli;font-style:normal;font-stretch:normal;p{margin:16px 0px;}ol{margin-left:16px;}ul{margin-left:16px;}h1{margin-bottom:16px;margin-top:16px;font-size:24px;font-weight:bold;}h2{margin-bottom:16px;margin-top:16px;font-size:20px;font-weight:bold;}h3{margin-bottom:16px;margin-top:16px;font-size:18px;font-weight:bold;}h4{margin-bottom:16px;margin-top:16px;font-size:16px;font-weight:bold;}h5{margin-bottom:16px;margin-top:16px;font-size:14px;font-weight:bold italic;}h6{margin-bottom:16px;margin-top:16px;font-size:14px;font-weight:bold;}}"
});
exports.default = MarkdownPreview;

},{"@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","react-markdown":"6G7AH","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"bI4XO":[function(require,module,exports) {
module.exports = require("bb869768de803838").getBundleURL("kVLro") + require("85662874f49131c3").resolve("j81mH");

},{"bb869768de803838":"c7Tr5","85662874f49131c3":"fyJL2"}],"debi3":[function(require,module,exports) {
module.exports = require("5338b1556f6ccfa7").getBundleURL("kVLro") + require("80f9a62cb6294412").resolve("cCpMV");

},{"5338b1556f6ccfa7":"c7Tr5","80f9a62cb6294412":"fyJL2"}],"hULAg":[function(require,module,exports) {
module.exports = require("dc5a6e62d0561285").getBundleURL("kVLro") + require("a1fdbdde4998b9b3").resolve("80Xm7");

},{"dc5a6e62d0561285":"c7Tr5","a1fdbdde4998b9b3":"fyJL2"}],"9pjdp":[function(require,module,exports) {
module.exports = require("ca716b507d18371c").getBundleURL("kVLro") + require("93641d02f30c7a73").resolve("78sHI");

},{"ca716b507d18371c":"c7Tr5","93641d02f30c7a73":"fyJL2"}],"569nE":[function(require,module,exports) {
module.exports = require("ee08cec7d3e58a06").getBundleURL("kVLro") + require("aa365b202c312503").resolve("8tl39");

},{"ee08cec7d3e58a06":"c7Tr5","aa365b202c312503":"fyJL2"}],"hWrKM":[function(require,module,exports) {
module.exports = require("ff040a917b061ed2").getBundleURL("kVLro") + require("8d4b5ffa7c79afc0").resolve("NFPXT");

},{"ff040a917b061ed2":"c7Tr5","8d4b5ffa7c79afc0":"fyJL2"}],"g9lbq":[function(require,module,exports) {
module.exports = require("c4e7a168da366666").getBundleURL("kVLro") + require("c2089a33f7684928").resolve("fFMX8");

},{"c4e7a168da366666":"c7Tr5","c2089a33f7684928":"fyJL2"}],"fhHWT":[function(require,module,exports) {
module.exports = require("7d1636bd5674bf25").getBundleURL("kVLro") + require("d22a217d4227d5a1").resolve("hOYQR");

},{"7d1636bd5674bf25":"c7Tr5","d22a217d4227d5a1":"fyJL2"}],"ax7CO":[function(require,module,exports) {
module.exports = require("8fcc05738c7d6d2f").getBundleURL("kVLro") + require("db87abe44d9af23b").resolve("ex79k");

},{"8fcc05738c7d6d2f":"c7Tr5","db87abe44d9af23b":"fyJL2"}],"jM7uU":[function(require,module,exports) {
module.exports = require("a572b09202b9ebde").getBundleURL("kVLro") + require("923bda2899582984").resolve("blqmd");

},{"a572b09202b9ebde":"c7Tr5","923bda2899582984":"fyJL2"}],"eXPtl":[function(require,module,exports) {
module.exports = require("29527e5703ef2a18").getBundleURL("kVLro") + require("652f72081a8e6199").resolve("kBU6Y");

},{"29527e5703ef2a18":"c7Tr5","652f72081a8e6199":"fyJL2"}],"3mzw3":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _base = require("@emotion/styled/base");
var _baseDefault = parcelHelpers.interopDefault(_base);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _colors = require("../../../constants/colors");
const closeIcon = require("875322f937634897");
const TemplateTag = ({ id, name, type, onRemove })=>(0, _react.jsx)(TemplatePill, null, (0, _react.jsx)("p", null, type, ": ", name), (0, _react.jsx)("img", {
        src: closeIcon,
        onClick: ()=>onRemove()
    }));
const TemplatePill = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e82anma0"
})(`
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 2px 16px;
    background: ${(0, _colors.color_shades_lighter)};
    border-radius: 12px;
    p {
        font-size: 14px;
        line-height: 20px;
        margin-right: 8px;
    }
    img {
        width: 10px;
        height: 10px;
        cursor: pointer;
    }
`, "");
exports.default = TemplateTag;

},{"@emotion/styled/base":"lSuFu","@emotion/react":"djZKr","react":"6uln9","../../../constants/colors":"1p3OR","875322f937634897":"93VwA","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"dF0fv":[function(require,module,exports) {
module.exports = require("9629051a90709c6c").getBundleURL("kVLro") + require("2416c9ed1ede72df").resolve("aEg5Q");

},{"9629051a90709c6c":"c7Tr5","2416c9ed1ede72df":"fyJL2"}],"7vpvL":[function(require,module,exports) {
module.exports = require("49f07fc4c416b06b").getBundleURL("kVLro") + require("b7d09a67cb851092").resolve("k57Eu");

},{"49f07fc4c416b06b":"c7Tr5","b7d09a67cb851092":"fyJL2"}],"lH5BG":[function(require,module,exports) {
module.exports = require("6534071163e0be48").getBundleURL("kVLro") + require("575b1745491f6dcf").resolve("dqM9z");

},{"6534071163e0be48":"c7Tr5","575b1745491f6dcf":"fyJL2"}],"ai6EJ":[function(require,module,exports) {
module.exports = require("ea32373be5d8768b").getBundleURL("kVLro") + require("784f3c13b884e7db").resolve("37Wap");

},{"ea32373be5d8768b":"c7Tr5","784f3c13b884e7db":"fyJL2"}],"lQDx7":[function(require,module,exports) {
module.exports = require("8142921a5acf1d13").getBundleURL("kVLro") + require("ceaf9109da3bc538").resolve("dcXv4");

},{"8142921a5acf1d13":"c7Tr5","ceaf9109da3bc538":"fyJL2"}],"eDAQv":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _currentTemplateSelector = require("../../applicationTemplateMenuSelector/components/CurrentTemplateSelector");
var _currentTemplateSelectorDefault = parcelHelpers.interopDefault(_currentTemplateSelector);
var _slideInSlideOutComponent = require("../../../components/structure/SlideInSlideOutComponent");
var _slideInSlideOutComponentDefault = parcelHelpers.interopDefault(_slideInSlideOutComponent);
var _colors = require("../../../constants/colors");
var _templateConfigurationTemplateMenu = require("./TemplateConfigurationTemplateMenu");
var _templateConfigurationTemplateMenuDefault = parcelHelpers.interopDefault(_templateConfigurationTemplateMenu);
class TemplateConfigurationMenuSelector extends (0, _reactDefault.default).Component {
    constructor(props){
        super(props);
        this.state = {
            isExpanded: false
        };
    }
    toggle() {
        this.setState({
            ...this.state,
            isExpanded: !this.state.isExpanded
        });
    }
    render() {
        return (0, _react.jsx)("div", {
            className: `${containerStyle} ${this.state.isExpanded ? "expanded" : ""}`
        }, (0, _react.jsx)((0, _currentTemplateSelectorDefault.default), {
            onToggle: this.toggle.bind(this),
            isMinified: true,
            isOpen: this.state.isExpanded,
            templateConfiguration: this.props.templateConfiguration
        }), (0, _react.jsx)((0, _slideInSlideOutComponentDefault.default), {
            showChildren: this.state.isExpanded,
            styleName: "contentTreeDropdownSlide",
            direction: "down",
            slideType: "size"
        }, (0, _react.jsx)("div", {
            className: "fixed-tree-container"
        }, (0, _react.jsx)((0, _templateConfigurationTemplateMenuDefault.default), {
            currentTemplateConfigId: this.props.currentTemplateId,
            templateConfigContainer: this.props.templateConfigContainer
        }))));
    }
}
const containerStyle = /*#__PURE__*/ (0, _css.css)("height:80px;padding-top:16px;&.expanded{background:", (0, _colors.text_blue), ";}.fixed-tree-container{margin-top:80px;top:0;left:0;bottom:0;display:flex;flex-direction:column;position:fixed;max-height:calc(100% - 80px);width:288px;z-index:3;background:white;border-right:1px solid ", (0, _colors.color_shades_dark), ";}", "");
exports.default = TemplateConfigurationMenuSelector;

},{"@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","../../applicationTemplateMenuSelector/components/CurrentTemplateSelector":"eZYz3","../../../components/structure/SlideInSlideOutComponent":"bwTqS","../../../constants/colors":"1p3OR","./TemplateConfigurationTemplateMenu":"eRpuF","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"eZYz3":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _toggleIndicator = require("../../../components/general/ToggleIndicator");
var _toggleIndicatorDefault = parcelHelpers.interopDefault(_toggleIndicator);
var _colors = require("../../../constants/colors");
const moduleIcon = require("af1b65e242c08d4e");
const templateIcon = require("f9c6bd9a5c4be963");
const integrationIcon = require("27752be436c4fe17");
const CurrentTemplateSelector = ({ onToggle, isMinified, isOpen, templateConfiguration })=>{
    const getTypeIcon = ()=>{
        if (templateConfiguration?.templateType == "ContentTemplate") return templateIcon;
        if (templateConfiguration?.templateType == "Integration") return integrationIcon;
        return moduleIcon;
    };
    return (0, _react.jsx)("div", {
        className: `${containerStyle} ${isOpen ? "open" : ""} ${isMinified ? "minified" : ""}`,
        onClick: onToggle
    }, (0, _react.jsx)("div", {
        className: "template-icon"
    }, (0, _react.jsx)("img", {
        src: getTypeIcon()
    })), (0, _react.jsx)((0, _toggleIndicatorDefault.default), {
        direction: isOpen ? "up" : "down",
        className: "toggle-indicator"
    }));
};
const containerStyle = /*#__PURE__*/ (0, _css.css)("cursor:pointer;display:flex;align-items:center;max-width:100%;height:48px;padding:0 8px 0 16px;border-left:1px solid ", (0, _colors.color_shades_darker), ";border-right:1px solid ", (0, _colors.color_shades_darker), ";.template-icon{background:white;border:1px solid ", (0, _colors.color_shades_dark), ";box-sizing:border-box;border-radius:8px;padding:8px;width:48px;height:48px;transform:rotate(45deg);display:flex;align-items:center;justify-content:center;margin-right:4px;img{width:32px;height:32px;transform:rotate(-45deg);}}&.open{background:", (0, _colors.text_blue), ";border-left:1px solid transparent;border-right:1px solid transparent;}.toggle-indicator{border-color:white;margin-left:auto;margin-right:2px;margin-left:12px;}", "");
exports.default = CurrentTemplateSelector;

},{"@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","../../../components/general/ToggleIndicator":"4eej1","../../../constants/colors":"1p3OR","af1b65e242c08d4e":"9Q23q","f9c6bd9a5c4be963":"krour","27752be436c4fe17":"1FNB0","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"eRpuF":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _templateSelector = require("./TemplateSelector");
var _templateSelectorDefault = parcelHelpers.interopDefault(_templateSelector);
class TemplateConfigurationTemplateMenu extends (0, _reactDefault.default).Component {
    render() {
        return (0, _react.jsx)("div", {
            className: containerStyle
        }, (0, _react.jsx)((0, _templateSelectorDefault.default), {
            templates: this.props.templateConfigContainer.state.organizationTemplates,
            activeTemplate: this.props.templateConfigContainer.state.organizationTemplates.find((at)=>at.id == this.props.currentTemplateConfigId)
        }));
    }
}
const containerStyle = /*#__PURE__*/ (0, _css.css)("", "");
exports.default = TemplateConfigurationTemplateMenu;

},{"@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","./TemplateSelector":"bN1sp","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"bN1sp":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _colors = require("../../../constants/colors");
var _reactRouterDom = require("react-router-dom");
const templatesIcon = require("94e12cd535730088");
class TemplateSelector extends (0, _reactDefault.default).Component {
    constructor(props){
        super(props);
        this.state = {
            isExpanded: false
        };
    }
    toggleExpand() {
        this.setState({
            ...this.state,
            isExpanded: !this.state.isExpanded
        });
    }
    render() {
        return (0, _react.jsx)("div", {
            className: containerStyle
        }, (0, _react.jsx)("p", {
            className: "selector-label"
        }, !this.props.templates || this.props.templates.length == 0 ? "No templates created yet app" : "Templates"), this.props.templates.map((t)=>(0, _react.jsx)((0, _reactRouterDom.Link), {
                key: t.id,
                className: `template-item ${t.id == this.props.activeTemplate?.id ? "active" : ""}`,
                to: `/v/templates/edit/${t?.id}`
            }, (0, _react.jsx)("img", {
                src: templatesIcon
            }), (0, _react.jsx)("p", null, t.name))));
    }
}
const containerStyle = /*#__PURE__*/ (0, _css.css)(".selector-label{color:", (0, _colors.color_text_light), ";font-style:italic;font-weight:normal;font-size:14px;line-height:20px;margin:24px 24px 16px 24px;}.template-item{display:flex;align-items:center;height:32px;padding:0 24px;cursor:pointer;p{margin:0 8px;font-style:normal;font-weight:normal;font-size:14px;line-height:20px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;color:", (0, _colors.color_text_default), ";}img{width:16px;height:16px;}&.active{background:", (0, _colors.color_variants_ocean_light_1), ";}}", "");
exports.default = TemplateSelector;

},{"@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","../../../constants/colors":"1p3OR","react-router-dom":"5fzqq","94e12cd535730088":"bOjIf","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"5UUN4":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _base = require("@emotion/styled/base");
var _baseDefault = parcelHelpers.interopDefault(_base);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _tabContainerPanel = require("../../../components/structure/Panels/TabContainerPanel");
var _tabContainerPanelDefault = parcelHelpers.interopDefault(_tabContainerPanel);
var _reactTabs = require("react-tabs");
var _scrollablePanelBody = require("../../../components/structure/ScrollablePanelBody");
var _scrollablePanelBodyDefault = parcelHelpers.interopDefault(_scrollablePanelBody);
var _loader = require("../../../components/general/Loader");
var _loaderDefault = parcelHelpers.interopDefault(_loader);
var _panelContainer = require("../../../components/structure/Panels/PanelContainer");
var _panelContainerDefault = parcelHelpers.interopDefault(_panelContainer);
var _colors = require("../../../constants/colors");
var _panelHeaderContainer = require("../../../components/structure/Panels/PanelHeaderContainer");
var _panelHeaderContainerDefault = parcelHelpers.interopDefault(_panelHeaderContainer);
var _templateFieldSelector = require("./TemplateFieldSelector");
var _templateFieldSelectorDefault = parcelHelpers.interopDefault(_templateFieldSelector);
var _templateSectionSelector = require("./TemplateSectionSelector");
var _templateSectionSelectorDefault = parcelHelpers.interopDefault(_templateSectionSelector);
var _button = require("../../../components/general/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _templateOverviewEditor = require("./TemplateOverviewEditor");
var _templateOverviewEditorDefault = parcelHelpers.interopDefault(_templateOverviewEditor);
var _templateSectionEditor = require("./TemplateSectionEditor");
var _templateSectionEditorDefault = parcelHelpers.interopDefault(_templateSectionEditor);
var _guids = require("../../../services/guids");
var _guidsDefault = parcelHelpers.interopDefault(_guids);
var _lodash = require("lodash");
var _lodashDefault = parcelHelpers.interopDefault(_lodash);
var _markdownPreview = require("./MarkdownPreview");
var _markdownPreviewDefault = parcelHelpers.interopDefault(_markdownPreview);
var _appliedApplicationTemplateSectionForm = require("../../formScenes/AppliedApplicationTemplateSectionForm");
var _appliedApplicationTemplateSectionFormDefault = parcelHelpers.interopDefault(_appliedApplicationTemplateSectionForm);
var _templateOverviewCard = require("../../../components/templates/TemplateOverviewCard");
var _templateOverviewCardDefault = parcelHelpers.interopDefault(_templateOverviewCard);
var _simpleFileImportDialog = require("../../../components/general/SimpleFileImportDialog");
var _simpleFileImportDialogDefault = parcelHelpers.interopDefault(_simpleFileImportDialog);
var _confirmationDialog = require("../../../components/structure/ConfirmationDialog");
var _confirmationDialogDefault = parcelHelpers.interopDefault(_confirmationDialog);
var _warningConfirmation = require("../../../components/general/WarningConfirmation");
var _warningConfirmationDefault = parcelHelpers.interopDefault(_warningConfirmation);
var _pageError = require("../../../components/general/PageError");
var _pageErrorDefault = parcelHelpers.interopDefault(_pageError);
var _useCSVHandler = require("../../../hooks/UseCSVHandler");
var _useCSVHandlerDefault = parcelHelpers.interopDefault(_useCSVHandler);
var _useTemplateFormFieldsHandler = require("../../../hooks/UseTemplateFormFieldsHandler");
var _useTemplateFormFieldsHandlerDefault = parcelHelpers.interopDefault(_useTemplateFormFieldsHandler);
var _horizontalSeparator = require("../../../components/structure/HorizontalSeparator");
var _horizontalSeparatorDefault = parcelHelpers.interopDefault(_horizontalSeparator);
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const formFieldsIcon = require("30de7537281a724d");
const addIcon = require("257479b8881cab5d");
const fieldPreviewIcon = require("6363db5c17c2ad9");
const fieldPreviewIconBlue = require("982d800c67bf043c");
const helpIconBlue = require("95e7714bba92a86a");
const helpIcon = require("abb9f5b2d540298c");
const exportIcon = require("89f70cc9c06d2b08");
const importIcon = require("ea5df7f10a5d09e5");
const TemplateDetailsEditor = ({ templateConfiguration, templateConfigurationContainer, isSaving, onChange })=>{
    const [isFinishSelected, setIsFinishSelected] = (0, _react1.useState)(false);
    const [isStartSelected, setIsStartSelected] = (0, _react1.useState)(true);
    const [currentSection, setCurrentSection] = (0, _react1.useState)(null);
    const [isImportFileDialogModalOpen, setIsImportFileDialogModalOpen] = (0, _react1.useState)(false);
    const [pageErrors, setPageErrors] = (0, _react1.useState)([]);
    const [isConfirmImportModalOpen, setIsConfirmImportModalOpen] = (0, _react1.useState)(false);
    const [selectedImportFile, setSelectedImportFile] = (0, _react1.useState)(null);
    const { isLoadingImport, setIsLoadingImport } = (0, _useCSVHandlerDefault.default)();
    // New template-specific hook (only using export functionality)
    const { exportTemplateFormFields, importTemplateFormFields, importedData: importedSections, createTemplateSections, errors: templateErrors } = (0, _useTemplateFormFieldsHandlerDefault.default)();
    (0, _react1.useEffect)(()=>{
        if (importedSections && importedSections.length > 0) {
            const updatedTemplate = createTemplateSections(importedSections, templateConfiguration);
            onChange(updatedTemplate);
        }
    }, [
        importedSections
    ]);
    (0, _react1.useEffect)(()=>{
        if (templateErrors && templateErrors.length > 0) setPageErrors((prev)=>[
                ...prev,
                ...templateErrors
            ]);
    }, [
        templateErrors
    ]);
    const handleNextPage = ()=>{
        const sections = templateConfiguration?.templateForm?.templateFormSections;
        if (isStartSelected && sections && sections.length > 0) {
            setIsStartSelected(false);
            setCurrentSection(sections ? sections[0] : null);
        } else if (sections && sections.length > 0 && currentSection != sections[sections.length - 1]) {
            setIsStartSelected(false);
            setCurrentSection(sections[sections.indexOf(currentSection) + 1]);
        }
    };
    const handlePrevPage = ()=>{
        const sections = templateConfiguration?.templateForm?.templateFormSections;
        if (!isStartSelected && currentSection != sections[0]) {
            setIsStartSelected(false);
            setCurrentSection(sections[sections.indexOf(currentSection) - 1]);
        } else if (currentSection == sections[0]) {
            setIsStartSelected(true);
            setCurrentSection(null);
        }
    };
    const handleStartSelected = ()=>{
        setIsFinishSelected(false);
        setIsStartSelected(true);
        setCurrentSection(null);
    };
    const handleSectionSelected = (section)=>{
        setCurrentSection(section);
        setIsFinishSelected(false);
        setIsStartSelected(false);
    };
    const handleAddSection = ()=>{
        const templateConfig = templateConfiguration;
        if (!templateConfig.templateForm?.templateFormSections) templateConfig.templateForm.templateFormSections = [];
        templateConfig.templateForm.templateFormSections.push({
            id: (0, _guidsDefault.default)(),
            title: "New Page",
            instructionsMarkdown: "",
            templateFormFields: []
        });
        templateConfig.templateForm?.templateFormSections?.forEach((s, i)=>{
            s.priority = i;
        });
        handleTemplateUpdate(templateConfig);
        handleSectionSelected(templateConfig.templateForm.templateFormSections[templateConfig.templateForm.templateFormSections.length - 1]);
    };
    const handleTemplateUpdate = (template)=>{
        onChange(template);
    };
    const handleAddField = (fieldType)=>{
        const section = templateConfiguration.templateForm.templateFormSections.find((s)=>s == currentSection);
        if (section.templateFormFields == null) section.templateFormFields = [];
        section.templateFormFields.push({
            id: (0, _guidsDefault.default)(),
            associatedVariable: "",
            title: "",
            tip: "",
            placeholder: "",
            options: [],
            isRequired: false,
            templateFormSectionId: section.id,
            fieldType
        });
        section.templateFormFields.forEach((f, i)=>{
            f.priority = i;
        });
        handleTemplateUpdate(templateConfiguration);
    };
    const handleSortSections = (sections)=>{
        sections.forEach((s, i)=>{
            s.priority = i;
        });
        const templateConfig = templateConfiguration;
        templateConfig.templateForm.templateFormSections = sections;
        handleTemplateUpdate(templateConfig);
    };
    const handleDeleteSection = (section)=>{
        const templateConfig = templateConfiguration;
        (0, _lodashDefault.default).remove(templateConfig.templateForm.templateFormSections, (s)=>s.id == section.id);
        setIsStartSelected(true);
        setCurrentSection(null);
        handleTemplateUpdate(templateConfig);
    };
    const toggleImportFileDialogModal = ()=>{
        setIsImportFileDialogModalOpen(!isImportFileDialogModalOpen);
        if (isImportFileDialogModalOpen) setPageErrors([]);
    };
    const toggleConfirmImportModal = ()=>{
        setIsConfirmImportModalOpen(!isConfirmImportModalOpen);
        // Clear the selected file if the modal is being closed
        if (isConfirmImportModalOpen) setSelectedImportFile(null);
    };
    const importFormFields = (file)=>{
        setPageErrors([]);
        // Store the file for later processing
        setSelectedImportFile(file);
        toggleImportFileDialogModal();
        toggleConfirmImportModal();
    };
    const useImportedTemplateFormFields = async ()=>{
        if (!selectedImportFile) return;
        setIsLoadingImport(true);
        try {
            // Process the CSV file and import the data
            await importTemplateFormFields(selectedImportFile);
        // The useEffect will handle updating the template when importedSections changes
        } catch (error) {
            console.error("Error importing template form fields:", error);
        } finally{
            setIsLoadingImport(false);
            setSelectedImportFile(null);
            toggleConfirmImportModal();
        }
    };
    const renderMenu = ()=>{
        return (0, _react.jsx)("div", {
            className: "fixed-wrapper"
        }, (0, _react.jsx)((0, _panelHeaderContainerDefault.default), {
            className: "template-section-menu-header"
        }, (0, _react.jsx)("h4", null, "Sections"), (0, _react.jsx)((0, _buttonDefault.default), {
            type: "button",
            themes: [
                "end",
                "icon"
            ],
            icon: addIcon,
            onClick: handleAddSection
        })), (0, _react.jsx)((0, _scrollablePanelBodyDefault.default), {
            className: panelBodyStyle,
            autoHeight: true,
            autoHeightMax: "calc(100vh - 136px)"
        }, (0, _react.jsx)((0, _templateSectionSelectorDefault.default), {
            sections: templateConfiguration?.templateForm?.templateFormSections ?? [],
            activeSection: currentSection,
            isStartSelected: isStartSelected,
            onStartSelect: handleStartSelected,
            onChange: handleSectionSelected,
            onSort: handleSortSections
        }), (0, _react.jsx)((0, _horizontalSeparatorDefault.default), null), (0, _react.jsx)(FormPopulationButtonWrapper, null, (0, _react.jsx)(FormPopulationButton, {
            disabled: false,
            loading: false,
            type: "button",
            themes: [
                "secondary-small",
                "end-tight"
            ],
            rightIcon: exportIcon,
            onClick: ()=>{
                exportTemplateFormFields(templateConfiguration, templateConfiguration?.name);
            },
            text: "Export Form"
        }), (0, _react.jsx)(FormPopulationButton, {
            type: "button",
            themes: [
                "secondary-small",
                "end-tight"
            ],
            rightIcon: importIcon,
            onClick: ()=>{
                toggleImportFileDialogModal();
            },
            text: "Import Form"
        }))));
    };
    const getTabs = ()=>{
        // if we are on the start page, then don't add the fields tab
        const tabs = [
            {
                title: "Step Preview",
                icon: fieldPreviewIcon,
                selectedIcon: fieldPreviewIconBlue
            },
            {
                title: "Helpful Info",
                icon: helpIcon,
                selectedIcon: helpIconBlue
            }
        ];
        if (!isStartSelected && !isFinishSelected) tabs.unshift({
            title: "Form Fields",
            icon: formFieldsIcon,
            selectedIcon: formFieldsIcon
        });
        return tabs;
    };
    const { isLoading } = templateConfigurationContainer.state;
    if (isLoading) return (0, _react.jsx)((0, _loaderDefault.default), null);
    return (0, _react.jsx)((0, _panelContainerDefault.default), null, (0, _react.jsx)("div", {
        className: `${menuStyle} expanded`
    }, renderMenu()), (0, _react.jsx)("div", {
        className: middlePanelContainer
    }, (0, _react.jsx)((0, _panelHeaderContainerDefault.default), {
        className: "panel-header"
    }, (0, _react.jsx)((0, _buttonDefault.default), {
        type: "submit",
        themes: [
            "primary-small",
            "start"
        ],
        text: "Save",
        className: "save-button",
        disabled: isSaving,
        loading: isSaving
    }), (0, _react.jsx)((0, _buttonDefault.default), {
        type: "button",
        themes: [
            "secondary-small",
            "end"
        ],
        text: "Prev Step",
        className: "prev-button",
        disabled: isStartSelected,
        onClick: handlePrevPage
    }), (0, _react.jsx)((0, _buttonDefault.default), {
        type: "button",
        themes: [
            "secondary-small",
            "end"
        ],
        text: "Next Step",
        className: "next-button",
        onClick: handleNextPage
    })), (0, _react.jsx)((0, _scrollablePanelBodyDefault.default), null, isStartSelected ? (0, _react.jsx)((0, _templateOverviewEditorDefault.default), {
        onChange: onChange,
        templateConfiguration: templateConfiguration
    }) : (0, _react.jsx)((0, _templateSectionEditorDefault.default), {
        onChange: handleTemplateUpdate,
        section: currentSection,
        templateConfiguration: templateConfiguration,
        onDelete: handleDeleteSection
    }))), (0, _react.jsx)((0, _tabContainerPanelDefault.default), {
        tabs: getTabs()
    }, !isStartSelected && !isFinishSelected && (0, _react.jsx)((0, _reactTabs.TabPanel), null, (0, _react.jsx)((0, _scrollablePanelBodyDefault.default), null, (0, _react.jsx)((0, _templateFieldSelectorDefault.default), {
        templateConfiguration: templateConfiguration,
        section: currentSection,
        onFieldSelected: handleAddField
    }))), (0, _react.jsx)((0, _reactTabs.TabPanel), null, (0, _react.jsx)((0, _scrollablePanelBodyDefault.default), null, isStartSelected ? (0, _react.jsx)((0, _templateOverviewCardDefault.default), {
        templateConfiguration: templateConfiguration
    }) : (0, _react.jsx)((0, _appliedApplicationTemplateSectionFormDefault.default), {
        fieldsOnly: true,
        values: [],
        onFieldValueChange: ()=>{},
        section: currentSection,
        applicationId: null,
        preview: true
    }))), (0, _react.jsx)((0, _reactTabs.TabPanel), null, (0, _react.jsx)((0, _scrollablePanelBodyDefault.default), {
        className: mainBodyStyle
    }, (0, _react.jsx)((0, _markdownPreviewDefault.default), {
        instructionsMarkdown: isStartSelected ? templateConfiguration?.templateForm?.instructionsMarkdown ?? "" : currentSection?.instructionsMarkdown ?? ""
    })))), isConfirmImportModalOpen && (0, _react.jsx)((0, _confirmationDialogDefault.default), {
        title: "Confirm Form Import",
        deleteText: "Yes, Import",
        isLoading: isLoadingImport,
        onClose: toggleConfirmImportModal,
        onConfirm: useImportedTemplateFormFields,
        warning: true
    }, (0, _react.jsx)((0, _warningConfirmationDefault.default), {
        text: "By importing this form, you will completely replace the existing form with the imported data. This action cannot be undone.",
        useWarningColor: true
    })), isImportFileDialogModalOpen && (0, _react.jsx)((0, _simpleFileImportDialogDefault.default), {
        onClose: toggleImportFileDialogModal,
        completeImport: importFormFields,
        title: "Select a .csv File to Import",
        acceptFileTypes: ".csv",
        acceptFileTypesDisplayText: "Supports .csv",
        isLoading: false,
        errors: templateErrors
    }), (0, _react.jsx)((0, _pageErrorDefault.default), {
        errors: pageErrors,
        onClear: ()=>setPageErrors([])
    }));
};
exports.default = TemplateDetailsEditor;
const middlePanelContainer = /*#__PURE__*/ (0, _css.css)("flex:1;border-right:1px solid ", (0, _colors.color_shades_dark), ";.overview-empty-label{margin:32px;}.panel-header{button{margin:0;}.save-button{margin-left:32px;}.next-button{margin-right:32px;}.prev-button{margin-right:16px;margin-left:auto;}}", "");
const panelBodyStyle = /*#__PURE__*/ (0, _css.css)({
    name: "d871kr",
    styles: "padding-top:0;min-height:calc(100vh - 160px);height:auto;overflow-y:auto"
});
const mainBodyStyle = /*#__PURE__*/ (0, _css.css)({
    name: "1k5vgqb",
    styles: "padding:24px 32px 64px 32px"
});
const FormPopulationButton = /*#__PURE__*/ (0, _baseDefault.default)((0, _buttonDefault.default), {
    target: "ebfh3g51"
})({
    name: "lpq4s6",
    styles: "margin:0 0 16px 8px;font-size:14px;font-weight:400;.right-img{margin-left:8px;width:16px;}"
});
const FormPopulationButtonWrapper = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "ebfh3g50"
})({
    name: "4thpvz",
    styles: "display:flex;flex-direction:column;justify-content:start;align-items:start;margin-top:20px;margin-left:16px"
});
const menuStyle = /*#__PURE__*/ (0, _css.css)("z-index:2;bottom:0;position:relative;.template-section-menu-header{h4{font-family:Muli;font-style:normal;font-weight:normal;font-size:16px;line-height:24px;margin:0 32px;}button{margin-right:16px;margin-left:auto;}}&.collapsed{width:80px;.fixed-wrapper{width:80px;}}&.expanded{width:288px;.fixed-wrapper{width:288px;}}.fixed-wrapper{position:fixed;bottom:0;height:calc(100vh - 80px);background:white;border-right:1px solid ", (0, _colors.color_shades_dark), ";box-sizing:border-box;}", "");

},{"@emotion/styled/base":"lSuFu","@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","../../../components/structure/Panels/TabContainerPanel":"iDHIJ","react-tabs":"92Sgf","../../../components/structure/ScrollablePanelBody":"6LRg3","../../../components/general/Loader":"bnV5T","../../../components/structure/Panels/PanelContainer":"9R2lE","../../../constants/colors":"1p3OR","../../../components/structure/Panels/PanelHeaderContainer":"hUotd","./TemplateFieldSelector":"8UeYk","./TemplateSectionSelector":"4Zy8u","../../../components/general/Button":"6ymxN","./TemplateOverviewEditor":"8n3YY","./TemplateSectionEditor":"fqxg9","../../../services/guids":"jvaYQ","lodash":"3hMBK","./MarkdownPreview":"6erDD","../../formScenes/AppliedApplicationTemplateSectionForm":"fyhpO","../../../components/templates/TemplateOverviewCard":"jb5TR","../../../components/general/SimpleFileImportDialog":"jPTcP","../../../components/structure/ConfirmationDialog":"kx7yK","../../../components/general/WarningConfirmation":"9OccO","../../../components/general/PageError":"ezFTm","../../../hooks/UseCSVHandler":"jBTvX","../../../hooks/UseTemplateFormFieldsHandler":"xlsv2","../../../components/structure/HorizontalSeparator":"Pw3HQ","30de7537281a724d":"G6QZu","257479b8881cab5d":"6cI2N","6363db5c17c2ad9":"dF0fv","982d800c67bf043c":"7vpvL","95e7714bba92a86a":"lH5BG","abb9f5b2d540298c":"ai6EJ","89f70cc9c06d2b08":"1wVxx","ea5df7f10a5d09e5":"d7E9Z","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8UeYk":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _templateFieldOption = require("./TemplateFieldOption");
var _templateFieldOptionDefault = parcelHelpers.interopDefault(_templateFieldOption);
var _colors = require("../../../constants/colors");
const TemplateFieldSelector = (props)=>{
    return (0, _react.jsx)("div", {
        className: containerStyle
    }, (0, _react.jsx)("h3", null, "Form Fields"), (0, _react.jsx)("p", null, "Choose a form field to add to your module and configure them in the column to the left."), (0, _react.jsx)((0, _templateFieldOptionDefault.default), {
        fieldType: "ShortTextField",
        name: "Short Text Field",
        description: "Short text fields allow your users to input a short phrase to be inserted into your template.",
        onAdd: props.onFieldSelected
    }), (0, _react.jsx)((0, _templateFieldOptionDefault.default), {
        fieldType: "LongTextField",
        name: "Long Text Field",
        description: "Long text fields allow your users to input a a larger portion of text that could stretch across multiple lines.",
        onAdd: props.onFieldSelected
    }), (0, _react.jsx)((0, _templateFieldOptionDefault.default), {
        fieldType: "SSMLTextField",
        name: "SSML Field",
        description: "Allows users to enter ssml.",
        onAdd: props.onFieldSelected
    }), (0, _react.jsx)((0, _templateFieldOptionDefault.default), {
        fieldType: "NumberTextField",
        name: "Number Field",
        description: "Allows users to pick a number.",
        onAdd: props.onFieldSelected
    }), (0, _react.jsx)((0, _templateFieldOptionDefault.default), {
        fieldType: "DateTextField",
        name: "Date Field",
        description: "Allows users to pick a date.",
        onAdd: props.onFieldSelected
    }), (0, _react.jsx)((0, _templateFieldOptionDefault.default), {
        fieldType: "SelectField",
        name: "Dropdown",
        description: "Dropdowns are meant for when your users have a larger selection of options and can choose only one.",
        onAdd: props.onFieldSelected
    }), (0, _react.jsx)((0, _templateFieldOptionDefault.default), {
        fieldType: "RadioGroupField",
        name: "Radio Buttons",
        description: "Radio buttons are best suited for when your users have a small selection of options and can choose only one.",
        onAdd: props.onFieldSelected
    }), (0, _react.jsx)((0, _templateFieldOptionDefault.default), {
        fieldType: "CheckboxGroupField",
        name: "Checkboxes",
        description: "For when you'd like to present an array of options and allow for multiple values to be selectable.",
        onAdd: props.onFieldSelected
    }), (0, _react.jsx)((0, _templateFieldOptionDefault.default), {
        fieldType: "FileUploadField",
        name: "File",
        description: "Allow users to upload a file",
        onAdd: props.onFieldSelected
    }), (0, _react.jsx)((0, _templateFieldOptionDefault.default), {
        fieldType: "SingleDayTimeRangeField",
        name: "Single Day Hours",
        description: "Set operating hours for a single day with multiple time ranges.",
        onAdd: props.onFieldSelected
    }), (0, _react.jsx)((0, _templateFieldOptionDefault.default), {
        fieldType: "SpecialDateField",
        name: "Special Dates & Holidays",
        description: "Allow users to manage dates with custom hours or closed status for holidays and special events.",
        onAdd: props.onFieldSelected
    }));
};
const containerStyle = /*#__PURE__*/ (0, _css.css)("padding:32px;margin-bottom:32px;>h3{margin-bottom:16px;font-style:normal;font-weight:normal;font-size:24px;line-height:32px;}>p{color:", (0, _colors.color_text_light), ";font-style:normal;font-weight:normal;font-size:14px;line-height:20px;margin-bottom:8px;}", "");
exports.default = TemplateFieldSelector;

},{"@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","./TemplateFieldOption":"ls0uU","../../../constants/colors":"1p3OR","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"ls0uU":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _colors = require("../../../constants/colors");
var _button = require("../../../components/general/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _fieldTypeIcons = require("../../../models/extensions/fieldTypeIcons");
const addIcon = require("dbcdde4bd6a7587a");
const TemplateFieldOption = (props)=>(0, _react.jsx)("div", {
        className: containerStyle
    }, (0, _react.jsx)("div", {
        className: "card-header-section"
    }, (0, _react.jsx)("img", {
        src: (0, _fieldTypeIcons.getFieldTypeIcon)(props.fieldType)
    }), (0, _react.jsx)("p", null, props.name)), (0, _react.jsx)("div", {
        className: "card-body-section"
    }, (0, _react.jsx)("p", null, props.description), (0, _react.jsx)((0, _buttonDefault.default), {
        type: "button",
        themes: [
            "secondary-small"
        ],
        text: "Add to Template",
        icon: addIcon,
        onClick: ()=>props.onAdd(props.fieldType)
    })));
const containerStyle = /*#__PURE__*/ (0, _css.css)("margin:24px 0px;background:white;border:1px solid ", (0, _colors.color_shades_dark), ";border-radius:8px;.card-header-section{display:flex;align-items:center;padding:32px;border-bottom:1px solid ", (0, _colors.color_shades_dark), ";img{width:36px;height:auto;}p{margin-left:16px;font-style:normal;font-weight:normal;font-size:18px;line-height:24px;}}.card-body-section{padding:32px;p{margin-bottom:32px;font-style:normal;font-weight:normal;font-size:14px;line-height:20px;}button{margin:0;}}", "");
exports.default = TemplateFieldOption;

},{"@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","../../../constants/colors":"1p3OR","../../../components/general/Button":"6ymxN","../../../models/extensions/fieldTypeIcons":"j8H2u","dbcdde4bd6a7587a":"9IPFG","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"j8H2u":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getFieldTypeIcon", ()=>getFieldTypeIcon);
const shortTextIcon = require("3ec8f38f1671729b");
const numberTextIcon = require("7791544ad9a29a64");
const longTextIcon = require("14ca374b323fb977");
const ssmlIcon = require("4f934f783b1eb01b");
const selectIcon = require("bc8904c13741d52f");
const radioIcon = require("efa3632056cb4bd7");
const checkIcon = require("77c38823784d88fa");
const fileUploadIcon = require("3c0bc30a2bcaa145");
const timeRangeIcon = require("3ec8f38f1671729b"); // Using short text icon as placeholder
const specialDateIcon = require("3ec8f38f1671729b"); // Using short text icon as placeholder
const singleDayTimeRangeIcon = require("3ec8f38f1671729b"); // Using short text icon as placeholder
const getFieldTypeIcon = (fieldType)=>{
    switch(fieldType){
        case "ShortTextField":
            return shortTextIcon;
        case "NumberTextField":
            return numberTextIcon;
        case "DateTextField":
            return shortTextIcon;
        case "LongTextField":
            return longTextIcon;
        case "SSMLTextField":
            return ssmlIcon;
        case "RadioGroupField":
            return radioIcon;
        case "CheckboxGroupField":
            return checkIcon;
        case "SelectField":
            return selectIcon;
        case "FileUploadField":
            return fileUploadIcon;
        case "TimeRangeField":
            return timeRangeIcon;
        case "SpecialDateField":
            return specialDateIcon;
        case "SingleDayTimeRangeField":
            return singleDayTimeRangeIcon;
    }
    return null;
};

},{"3ec8f38f1671729b":"9Ow32","7791544ad9a29a64":"8B2Bd","14ca374b323fb977":"edqyZ","4f934f783b1eb01b":"6lpnV","bc8904c13741d52f":"lnTxW","efa3632056cb4bd7":"bOPrE","77c38823784d88fa":"25Gfu","3c0bc30a2bcaa145":"hH2Lp","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9Ow32":[function(require,module,exports) {
module.exports = require("97194110de2ebdac").getBundleURL("kVLro") + require("49abdcce5488a4a1").resolve("lHZcy");

},{"97194110de2ebdac":"c7Tr5","49abdcce5488a4a1":"fyJL2"}],"8B2Bd":[function(require,module,exports) {
module.exports = require("d6694e85d659a803").getBundleURL("kVLro") + require("f5432fcab051060a").resolve("9csSl");

},{"d6694e85d659a803":"c7Tr5","f5432fcab051060a":"fyJL2"}],"edqyZ":[function(require,module,exports) {
module.exports = require("79bbe53c0bb632e3").getBundleURL("kVLro") + require("328a3a634afcde0f").resolve("gIWKa");

},{"79bbe53c0bb632e3":"c7Tr5","328a3a634afcde0f":"fyJL2"}],"6lpnV":[function(require,module,exports) {
module.exports = require("852e21abcbe4d25f").getBundleURL("kVLro") + require("8287818de4df716d").resolve("cGLJK");

},{"852e21abcbe4d25f":"c7Tr5","8287818de4df716d":"fyJL2"}],"lnTxW":[function(require,module,exports) {
module.exports = require("f939b930946d4737").getBundleURL("kVLro") + require("a7e5d3db54789d1b").resolve("OhxvU");

},{"f939b930946d4737":"c7Tr5","a7e5d3db54789d1b":"fyJL2"}],"bOPrE":[function(require,module,exports) {
module.exports = require("48e8403639968f20").getBundleURL("kVLro") + require("2696be7efb259937").resolve("h4l1Q");

},{"48e8403639968f20":"c7Tr5","2696be7efb259937":"fyJL2"}],"25Gfu":[function(require,module,exports) {
module.exports = require("8e87c8e2aeb6b340").getBundleURL("kVLro") + require("45185d2d145c6012").resolve("isVLT");

},{"8e87c8e2aeb6b340":"c7Tr5","45185d2d145c6012":"fyJL2"}],"hH2Lp":[function(require,module,exports) {
module.exports = require("13fa5d4b5f6ceb13").getBundleURL("kVLro") + require("785571b450e9993f").resolve("1XPmI");

},{"13fa5d4b5f6ceb13":"c7Tr5","785571b450e9993f":"fyJL2"}],"9IPFG":[function(require,module,exports) {
module.exports = require("51c40309cd92a7b7").getBundleURL("kVLro") + require("8a60e3d2eb819591").resolve("fZCXp");

},{"51c40309cd92a7b7":"c7Tr5","8a60e3d2eb819591":"fyJL2"}],"4Zy8u":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _extends = require("@babel/runtime/helpers/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _colors = require("../../../constants/colors");
var _lodash = require("lodash");
var _lodashDefault = parcelHelpers.interopDefault(_lodash);
var _reactBeautifulDnd = require("react-beautiful-dnd");
var _extensions = require("../../../models/extensions");
const TemplateSectionSelector = (props)=>{
    const handleDragEnd = (result, provider)=>{
        // dropped outside the list
        if (!result.destination) return;
        const sections = (0, _lodashDefault.default).sortBy(props.sections ?? [], (s)=>s.priority);
        props.onSort((0, _extensions.reorder)(sections, result.source.index, result.destination.index));
    };
    return (0, _react.jsx)("div", {
        className: containerStyle
    }, (0, _react.jsx)("div", {
        className: `section-item ${props.isStartSelected ? "active" : ""}`,
        onClick: props.onStartSelect
    }, (0, _react.jsx)("p", null, "Overview")), (0, _react.jsx)((0, _reactBeautifulDnd.DragDropContext), {
        onDragEnd: handleDragEnd
    }, (0, _react.jsx)((0, _reactBeautifulDnd.Droppable), {
        droppableId: "sections",
        type: "TEMPLATE_SECTION"
    }, (provided, snapshot)=>(0, _react.jsx)("div", (0, _extendsDefault.default)({}, provided.droppableProps, {
            ref: provided.innerRef
        }), (0, _lodashDefault.default).sortBy(props.sections ?? [], (s)=>s.priority)?.map((s, i)=>(0, _react.jsx)((0, _reactBeautifulDnd.Draggable), {
                draggableId: s?.id,
                index: i,
                key: s.id
            }, (provided, snapshot)=>(0, _react.jsx)("div", (0, _extendsDefault.default)({
                    ref: provided.innerRef
                }, provided.draggableProps, provided.dragHandleProps, {
                    className: `section-item ${props.activeSection == s ? "active" : ""}`,
                    onClick: ()=>props.onChange(s)
                }), (0, _react.jsx)("p", null, s?.title)))), provided.placeholder))));
};
const containerStyle = /*#__PURE__*/ (0, _css.css)("padding:16px;.section-item{display:flex;align-items:center;border-radius:4px;height:48px;padding:0 16px;cursor:pointer;p{font-size:14px;line-height:20px;color:", (0, _colors.color_text_default), ";white-space:nowrap;overflow:hidden;text-overflow:ellipsis;}img{margin-right:0;margin-left:auto;width:24px;height:24px;}.selected-indicator{width:8px;height:8px;border-radius:50%;background:", (0, _colors.color_text_link), ";margin-right:8px;margin-left:auto;}&.active{background:", (0, _colors.color_variants_ocean_light_1), ";p{color:", (0, _colors.color_text_link), ";}}&.disabled{img{display:none;}p{color:", (0, _colors.color_text_light), ";}}}", "");
exports.default = TemplateSectionSelector;

},{"@babel/runtime/helpers/extends":"4iKIP","@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","../../../constants/colors":"1p3OR","lodash":"3hMBK","react-beautiful-dnd":"bkbSn","../../../models/extensions":"7h01B","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8n3YY":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _base = require("@emotion/styled/base");
var _baseDefault = parcelHelpers.interopDefault(_base);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _colors = require("../../../constants/colors");
var _contentCard = require("../../../components/structure/ContentCard");
var _contentCardDefault = parcelHelpers.interopDefault(_contentCard);
var _formFieldsContainer = require("../../../components/structure/FormFieldsContainer");
var _formFieldsContainerDefault = parcelHelpers.interopDefault(_formFieldsContainer);
var _textField = require("../../../components/forms/TextField");
var _textFieldDefault = parcelHelpers.interopDefault(_textField);
var _textAreaField = require("../../../components/forms/TextAreaField");
var _textAreaFieldDefault = parcelHelpers.interopDefault(_textAreaField);
var _detailLabel = require("../../../components/general/DetailLabel");
var _detailLabelDefault = parcelHelpers.interopDefault(_detailLabel);
const TemplateOverviewEditor = ({ templateConfiguration, onChange })=>{
    const handleOwnerChange = (e)=>{
        templateConfiguration.ownerName = e.target.value;
        onChange(templateConfiguration);
    };
    const handleDescriptionChange = (e)=>{
        templateConfiguration.description = e.target.value;
        onChange(templateConfiguration);
    };
    return (0, _react.jsx)(OverviewContainer, null, (0, _react.jsx)("h4", null, "Setup"), (0, _react.jsx)((0, _contentCardDefault.default), {
        title: "Identity"
    }, (0, _react.jsx)((0, _formFieldsContainerDefault.default), null, (0, _react.jsx)((0, _detailLabelDefault.default), null, "Add some more detail about this module."), (0, _react.jsx)((0, _textFieldDefault.default), {
        label: "Creator Name",
        placeholder: "The owner and creator of the template",
        name: "templateConfiguration.ownerName",
        value: templateConfiguration?.ownerName ?? "",
        required: true,
        onChange: handleOwnerChange
    }), (0, _react.jsx)((0, _textAreaFieldDefault.default), {
        label: "Detailed Description",
        placeholder: "This is used in your listing",
        name: "templateConfiguration.description",
        value: templateConfiguration?.description ?? "",
        required: true,
        onChange: handleDescriptionChange
    }))));
};
const OverviewContainer = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "ew5kul90"
})(`
padding: 24px 32px 64px 32px;
h4 {
    font-style: normal;
    font-weight: normal;
    font-size: 18px;
    line-height: 24px;
    color: ${(0, _colors.color_text_default)};
    margin-bottom: 24px;
}
`, "");
exports.default = TemplateOverviewEditor;

},{"@emotion/styled/base":"lSuFu","@emotion/react":"djZKr","react":"6uln9","../../../constants/colors":"1p3OR","../../../components/structure/ContentCard":"hJsdJ","../../../components/structure/FormFieldsContainer":"h3hzh","../../../components/forms/TextField":"7a7bh","../../../components/forms/TextAreaField":"fE54C","../../../components/general/DetailLabel":"j3EnX","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"fqxg9":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _extends = require("@babel/runtime/helpers/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _defineProperty = require("@babel/runtime/helpers/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _textField = require("../../../components/forms/TextField");
var _textFieldDefault = parcelHelpers.interopDefault(_textField);
var _horizontalSeparator = require("../../../components/structure/HorizontalSeparator");
var _horizontalSeparatorDefault = parcelHelpers.interopDefault(_horizontalSeparator);
var _colors = require("../../../constants/colors");
var _addMarkdownButton = require("./AddMarkdownButton");
var _addMarkdownButtonDefault = parcelHelpers.interopDefault(_addMarkdownButton);
var _textFieldEditor = require("./TextFieldEditor");
var _textFieldEditorDefault = parcelHelpers.interopDefault(_textFieldEditor);
var _markdownEditorModal = require("./MarkdownEditorModal");
var _markdownEditorModalDefault = parcelHelpers.interopDefault(_markdownEditorModal);
var _reactBeautifulDnd = require("react-beautiful-dnd");
var _lodash = require("lodash");
var _lodashDefault = parcelHelpers.interopDefault(_lodash);
var _largeOverflowMenu = require("../../../components/general/LargeOverflowMenu");
var _largeOverflowMenuDefault = parcelHelpers.interopDefault(_largeOverflowMenu);
var _button = require("../../../components/general/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _extensions = require("../../../models/extensions");
var _confirmationDialog = require("../../../components/structure/ConfirmationDialog");
var _confirmationDialogDefault = parcelHelpers.interopDefault(_confirmationDialog);
var _deleteConfirmation = require("../../featureContent/components/DeleteConfirmation");
var _deleteConfirmationDefault = parcelHelpers.interopDefault(_deleteConfirmation);
var _optionsFieldEditor = require("./OptionsFieldEditor");
var _optionsFieldEditorDefault = parcelHelpers.interopDefault(_optionsFieldEditor);
var _loader = require("../../../components/general/Loader");
var _loaderDefault = parcelHelpers.interopDefault(_loader);
var _fileUploadFieldEditor = require("./FileUploadFieldEditor");
var _fileUploadFieldEditorDefault = parcelHelpers.interopDefault(_fileUploadFieldEditor);
var _timeRangeFieldEditor = require("./TimeRangeFieldEditor");
var _timeRangeFieldEditorDefault = parcelHelpers.interopDefault(_timeRangeFieldEditor);
var _singleDayTimeRangeFieldEditor = require("./SingleDayTimeRangeFieldEditor");
var _singleDayTimeRangeFieldEditorDefault = parcelHelpers.interopDefault(_singleDayTimeRangeFieldEditor);
var _specialDateFieldEditor = require("./SpecialDateFieldEditor");
var _specialDateFieldEditorDefault = parcelHelpers.interopDefault(_specialDateFieldEditor);
const menuIcon = require("fc761482ce09ef79");
const editIcon = require("dbfd56f89a4b3d4c");
const deleteIcon = require("79c813102eea156e");
const upIcon = require("ca9e7ad8bd47e2ae");
const downIcon = require("c8db7167fa01d6c0");
class TemplateSectionEditor extends (0, _reactDefault.default).Component {
    constructor(props){
        super(props);
        (0, _definePropertyDefault.default)(this, "handleMarkdownChange", (markdown)=>{
            const template = this.props.templateConfiguration;
            const section = template?.templateForm?.templateFormSections?.find((s)=>s == this.props.section);
            section.instructionsMarkdown = markdown;
            this.props.onChange(template);
            this.setState({
                ...this.state,
                isMarkdownOpen: false
            });
        });
        (0, _definePropertyDefault.default)(this, "handleTitleChange", (e)=>{
            const template = this.props.templateConfiguration;
            const section = template?.templateForm?.templateFormSections?.find((s)=>s == this.props.section);
            section.title = e.target.value;
            this.props.onChange(template);
        });
        (0, _definePropertyDefault.default)(this, "handleFieldChange", (field)=>{
            const template = this.props.templateConfiguration;
            const section = this.props.section;
            if (!section) return;
            const fieldIndex = section?.templateFormFields?.findIndex((f)=>f.id == field.id);
            if (fieldIndex <= -1) return;
            section.templateFormFields[fieldIndex] = field;
            this.props.onChange(template);
        });
        (0, _definePropertyDefault.default)(this, "handleMoveFieldUp", (field)=>{
            const template = this.props.templateConfiguration;
            const section = template?.templateForm?.templateFormSections?.find((s)=>s == this.props.section);
            const fields = (0, _lodashDefault.default).sortBy(section?.templateFormFields ?? [], (s)=>s.priority);
            const index = fields.indexOf(field);
            if (index > 0) {
                var sortedFields = (0, _extensions.reorder)(fields, index, index - 1).map((f, i)=>({
                        ...f,
                        priority: i
                    }));
                section.templateFormFields = sortedFields;
                this.props.onChange(template);
            }
        });
        (0, _definePropertyDefault.default)(this, "handleMoveFieldDown", (field)=>{
            const template = this.props.templateConfiguration;
            const section = template?.templateForm?.templateFormSections?.find((s)=>s == this.props.section);
            const fields = (0, _lodashDefault.default).sortBy(section?.templateFormFields ?? [], (s)=>s.priority);
            const index = fields.indexOf(field);
            if (index < fields.length - 1) {
                var sortedFields = (0, _extensions.reorder)(fields, index, index + 1).map((f, i)=>({
                        ...f,
                        priority: i
                    }));
                section.templateFormFields = sortedFields;
                this.props.onChange(template);
            }
        });
        (0, _definePropertyDefault.default)(this, "handleMoveFieldToSection", (field, sectionId)=>{
            const template = this.props.templateConfiguration;
            const currentSection = template?.templateForm?.templateFormSections?.find((s)=>s == this.props.section);
            const newSection = template?.templateForm?.templateFormSections?.find((s)=>s.id == sectionId);
            if (!newSection) return;
            (0, _lodashDefault.default).remove(currentSection.templateFormFields, (f)=>f.id == field.id);
            newSection.templateFormFields.push(field);
            this.props.onChange(template);
        });
        (0, _definePropertyDefault.default)(this, "handleDragEnd", (result, provider)=>{
            // dropped outside the list
            if (!result.destination) return;
            const template = this.props.templateConfiguration;
            const section = template?.templateForm?.templateFormSections?.find((s)=>s == this.props.section);
            const fields = (0, _lodashDefault.default).sortBy(section?.templateFormFields ?? [], (s)=>s.priority);
            var sortedFields = (0, _extensions.reorder)(fields, result.source.index, result.destination.index).map((f, i)=>({
                    ...f,
                    priority: i
                }));
            section.templateFormFields = sortedFields;
            this.props.onChange(template);
        });
        (0, _definePropertyDefault.default)(this, "handleDeleteField", (field)=>{
            const template = this.props.templateConfiguration;
            const section = template?.templateForm?.templateFormSections?.find((s)=>s == this.props.section);
            const fields = (0, _lodashDefault.default).sortBy(section?.templateFormFields ?? [], (s)=>s.priority);
            (0, _lodashDefault.default).remove(fields, (f)=>f.id == field.id);
            section.templateFormFields = fields;
            this.props.onChange(template);
        });
        (0, _definePropertyDefault.default)(this, "renderField", (f, provided)=>{
            switch(f.fieldType){
                case "ShortTextField":
                case "NumberTextField":
                case "DateTextField":
                case "LongTextField":
                case "SSMLTextField":
                    return (0, _react.jsx)((0, _textFieldEditorDefault.default), {
                        key: f.id,
                        field: f,
                        sections: this.props.templateConfiguration?.templateForm?.templateFormSections ?? [],
                        onChange: this.handleFieldChange.bind(this),
                        onDelete: this.handleDeleteField.bind(this),
                        onMoveDown: this.handleMoveFieldDown.bind(this),
                        onMoveUp: this.handleMoveFieldUp.bind(this),
                        onMoveToSection: this.handleMoveFieldToSection.bind(this),
                        draggable: provided
                    });
                case "RadioGroupField":
                case "CheckboxGroupField":
                case "SelectField":
                    return (0, _react.jsx)((0, _optionsFieldEditorDefault.default), {
                        key: f.id,
                        field: f,
                        sections: this.props.templateConfiguration?.templateForm?.templateFormSections ?? [],
                        onChange: this.handleFieldChange.bind(this),
                        onDelete: this.handleDeleteField.bind(this),
                        onMoveDown: this.handleMoveFieldDown.bind(this),
                        onMoveUp: this.handleMoveFieldUp.bind(this),
                        onMoveToSection: this.handleMoveFieldToSection.bind(this),
                        draggable: provided
                    });
                case "FileUploadField":
                    return (0, _react.jsx)((0, _fileUploadFieldEditorDefault.default), {
                        key: f.id,
                        field: f,
                        sections: this.props.templateConfiguration?.templateForm?.templateFormSections ?? [],
                        onChange: this.handleFieldChange.bind(this),
                        onDelete: this.handleDeleteField.bind(this),
                        onMoveDown: this.handleMoveFieldDown.bind(this),
                        onMoveUp: this.handleMoveFieldUp.bind(this),
                        onMoveToSection: this.handleMoveFieldToSection.bind(this),
                        draggable: provided
                    });
                case "TimeRangeField":
                    return (0, _react.jsx)((0, _timeRangeFieldEditorDefault.default), {
                        key: f.id,
                        field: f,
                        sections: this.props.templateConfiguration?.templateForm?.templateFormSections ?? [],
                        onChange: this.handleFieldChange.bind(this),
                        onDelete: this.handleDeleteField.bind(this),
                        onMoveDown: this.handleMoveFieldDown.bind(this),
                        onMoveUp: this.handleMoveFieldUp.bind(this),
                        onMoveToSection: this.handleMoveFieldToSection.bind(this),
                        draggable: provided
                    });
                case "SingleDayTimeRangeField":
                    return (0, _react.jsx)((0, _singleDayTimeRangeFieldEditorDefault.default), {
                        key: f.id,
                        field: f,
                        sections: this.props.templateConfiguration?.templateForm?.templateFormSections ?? [],
                        onChange: this.handleFieldChange.bind(this),
                        onDelete: this.handleDeleteField.bind(this),
                        onMoveDown: this.handleMoveFieldDown.bind(this),
                        onMoveUp: this.handleMoveFieldUp.bind(this),
                        onMoveToSection: this.handleMoveFieldToSection.bind(this),
                        draggable: provided
                    });
                case "SpecialDateField":
                    return (0, _react.jsx)((0, _specialDateFieldEditorDefault.default), {
                        key: f.id,
                        field: f,
                        sections: this.props.templateConfiguration?.templateForm?.templateFormSections ?? [],
                        onChange: this.handleFieldChange.bind(this),
                        onDelete: this.handleDeleteField.bind(this),
                        onMoveDown: this.handleMoveFieldDown.bind(this),
                        onMoveUp: this.handleMoveFieldUp.bind(this),
                        onMoveToSection: this.handleMoveFieldToSection.bind(this),
                        draggable: provided
                    });
            }
            return null;
        });
        this.state = {
            isMarkdownOpen: false,
            isDeleteConfirmationOpen: false,
            isEditingTitle: false
        };
    }
    handleToggleMarkdown() {
        this.setState({
            ...this.state,
            isMarkdownOpen: !this.state.isMarkdownOpen
        });
    }
    handleToggleTitle() {
        this.setState({
            ...this.state,
            isEditingTitle: !this.state.isEditingTitle
        });
    }
    handleToggleDelete() {
        this.setState({
            ...this.state,
            isDeleteConfirmationOpen: !this.state.isDeleteConfirmationOpen
        });
    }
    handleDeleteConfirm() {
        this.props.onDelete(this.props.section);
        this.handleToggleDelete();
    }
    getOptions() {
        const options = [
            {
                label: "Delete",
                icon: deleteIcon,
                hoverIcon: deleteIcon,
                isDestructive: true
            },
            {
                label: "Move Up",
                icon: upIcon,
                hoverIcon: upIcon
            },
            {
                label: "Move Down",
                icon: downIcon,
                hoverIcon: downIcon
            }
        ];
        return options;
    }
    handleOptionSelected(optionName) {
        const template = this.props.templateConfiguration;
        var sections = template?.templateForm?.templateFormSections;
        const index = sections.indexOf(this.props.section);
        if (optionName == "Move Up") {
            if (index > 0) {
                sections = (0, _extensions.reorder)(sections, index, index - 1);
                sections.forEach((s, i)=>{
                    s.priority = i;
                });
                template.templateForm.templateFormSections = sections;
                this.props.onChange(template);
            }
        }
        if (optionName == "Move Down") {
            if (index < sections.length - 1) {
                sections = (0, _extensions.reorder)(sections, index, index + 1);
                sections.forEach((s, i)=>{
                    s.priority = i;
                });
                template.templateForm.templateFormSections = sections;
                this.props.onChange(template);
            }
        }
        if (optionName == "Delete") this.handleToggleDelete();
    }
    handleEnterBlur(e) {
        if (e.charCode == 13) e.target.blur();
    }
    render() {
        if (!this.props.section) return (0, _react.jsx)((0, _loaderDefault.default), null);
        return (0, _react.jsx)("div", {
            className: containerStyle
        }, (0, _react.jsx)("div", {
            className: "title-wrapper"
        }, this.state.isEditingTitle ? (0, _react.jsx)((0, _textFieldDefault.default), {
            name: "section.title",
            value: this.props.section.title,
            onChange: this.handleTitleChange.bind(this),
            placeholder: "Page Title",
            className: "section-title-field",
            onBlur: this.handleToggleTitle.bind(this),
            onKeyPress: this.handleEnterBlur.bind(this),
            autoFocus: true
        }) : (0, _react.jsx)("h4", null, this.props.section.title), !this.state.isEditingTitle && (0, _react.jsx)((0, _buttonDefault.default), {
            type: "button",
            themes: [
                "icon"
            ],
            className: "section-button",
            icon: editIcon,
            onClick: this.handleToggleTitle.bind(this)
        }), (0, _react.jsx)("div", {
            className: "section-button"
        }, (0, _react.jsx)((0, _largeOverflowMenuDefault.default), {
            isActive: false,
            onOptionSelected: this.handleOptionSelected.bind(this),
            options: this.getOptions(),
            icon: menuIcon
        }))), (0, _react.jsx)("p", {
            className: "detail-text"
        }, "Set up your module and configure the fields"), (0, _react.jsx)((0, _horizontalSeparatorDefault.default), null), (0, _react.jsx)((0, _addMarkdownButtonDefault.default), {
            onClick: this.handleToggleMarkdown.bind(this),
            hasValue: this.props.section?.instructionsMarkdown != null && this.props.section.instructionsMarkdown != ""
        }), !this.props.section.templateFormFields || this.props.section.templateFormFields.length == 0 ? (0, _react.jsx)("p", {
            className: "empty-label"
        }, "Select assets from the right to add to this page. You can configure them here once they’ve been added") : (0, _react.jsx)((0, _reactBeautifulDnd.DragDropContext), {
            onDragEnd: this.handleDragEnd.bind(this)
        }, (0, _react.jsx)((0, _reactBeautifulDnd.Droppable), {
            droppableId: "fields",
            type: "TEMPLATE_FIELD"
        }, (provided, snapshot)=>(0, _react.jsx)("div", (0, _extendsDefault.default)({}, provided.droppableProps, {
                ref: provided.innerRef
            }), this.props.section.templateFormFields?.map((f, i)=>(0, _react.jsx)((0, _reactBeautifulDnd.Draggable), {
                    draggableId: f?.id,
                    index: i,
                    key: f.id
                }, (provided, snapshot)=>(0, _react.jsx)("div", (0, _extendsDefault.default)({
                        ref: provided.innerRef
                    }, provided.draggableProps), this.renderField(f, provided)))), provided.placeholder))), this.state.isMarkdownOpen && (0, _react.jsx)((0, _markdownEditorModalDefault.default), {
            contextTitle: this.props.section.title ?? "Page",
            markdown: this.props.section.instructionsMarkdown ?? "",
            onSave: this.handleMarkdownChange.bind(this),
            onClose: this.handleToggleMarkdown.bind(this)
        }), this.state.isDeleteConfirmationOpen && (0, _react.jsx)((0, _confirmationDialogDefault.default), {
            title: `Delete ${this.props.section.title ?? "Page Instructions"}`,
            deleteText: "Yes, Delete",
            isLoading: false,
            onClose: this.handleToggleDelete.bind(this),
            onConfirm: this.handleDeleteConfirm.bind(this)
        }, (0, _react.jsx)((0, _deleteConfirmationDefault.default), {
            itemLabel: `${this.props.section.title}?`
        })));
    }
}
const containerStyle = /*#__PURE__*/ (0, _css.css)("padding:16px 32px;margin-bottom:64px;.title-wrapper{display:flex;align-items:center;h4{font-style:normal;font-weight:normal;font-size:18px;line-height:24px;color:", (0, _colors.color_text_default), ";flex:1;}.section-title-field{margin:0;}.section-button{margin-right:0;margin-left:16px;cursor:pointer;}}.detail-text{margin:16px 0 24px 0;font-style:normal;font-weight:normal;font-size:14px;line-height:20px;}.empty-label{text-align:center;border:1px solid ", (0, _colors.color_shades_dark), ";border-radius:8px;padding:32px;font-style:italic;font-weight:normal;font-size:14px;line-height:20px;margin:32px 0;}", "");
exports.default = TemplateSectionEditor;

},{"@babel/runtime/helpers/extends":"4iKIP","@babel/runtime/helpers/defineProperty":"9sJxO","@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","../../../components/forms/TextField":"7a7bh","../../../components/structure/HorizontalSeparator":"Pw3HQ","../../../constants/colors":"1p3OR","./AddMarkdownButton":"7gHKd","./TextFieldEditor":"dINhi","./MarkdownEditorModal":"1xj9r","react-beautiful-dnd":"bkbSn","lodash":"3hMBK","../../../components/general/LargeOverflowMenu":"h9O0c","../../../components/general/Button":"6ymxN","../../../models/extensions":"7h01B","../../../components/structure/ConfirmationDialog":"kx7yK","../../featureContent/components/DeleteConfirmation":"9xK2d","./OptionsFieldEditor":"fvvvP","../../../components/general/Loader":"bnV5T","./FileUploadFieldEditor":"hFeI0","./TimeRangeFieldEditor":"cw4qa","./SingleDayTimeRangeFieldEditor":"7W6Rv","./SpecialDateFieldEditor":"f2VvG","fc761482ce09ef79":"ch0E7","dbfd56f89a4b3d4c":"gYjWd","79c813102eea156e":"24JPN","ca9e7ad8bd47e2ae":"jk3D1","c8db7167fa01d6c0":"kBbXd","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"dINhi":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _extends = require("@babel/runtime/helpers/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _defineProperty = require("@babel/runtime/helpers/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _colors = require("../../../constants/colors");
var _toggleIndicator = require("../../../components/general/ToggleIndicator");
var _toggleIndicatorDefault = parcelHelpers.interopDefault(_toggleIndicator);
var _textField = require("../../../components/forms/TextField");
var _textFieldDefault = parcelHelpers.interopDefault(_textField);
var _horizontalSeparator = require("../../../components/structure/HorizontalSeparator");
var _horizontalSeparatorDefault = parcelHelpers.interopDefault(_horizontalSeparator);
var _switch = require("../../../components/forms/Switch");
var _switchDefault = parcelHelpers.interopDefault(_switch);
var _markdownEditorModal = require("./MarkdownEditorModal");
var _markdownEditorModalDefault = parcelHelpers.interopDefault(_markdownEditorModal);
var _largeOverflowMenu = require("../../../components/general/LargeOverflowMenu");
var _largeOverflowMenuDefault = parcelHelpers.interopDefault(_largeOverflowMenu);
var _confirmationDialog = require("../../../components/structure/ConfirmationDialog");
var _confirmationDialogDefault = parcelHelpers.interopDefault(_confirmationDialog);
var _deleteConfirmation = require("../../featureContent/components/DeleteConfirmation");
var _deleteConfirmationDefault = parcelHelpers.interopDefault(_deleteConfirmation);
var _fieldTypeIcons = require("../../../models/extensions/fieldTypeIcons");
var _textAreaField = require("../../../components/forms/TextAreaField");
var _textAreaFieldDefault = parcelHelpers.interopDefault(_textAreaField);
const menuIcon = require("bd6a6e1cd550670");
const deleteIcon = require("52bd50ec9a0869f");
const upIcon = require("2db528a5c221de55");
const downIcon = require("41ef03ed0a5bdabc");
const moveIcon = require("9d837bf8bd8d4da4");
class TextFieldEditor extends (0, _reactDefault.default).Component {
    constructor(props){
        super(props);
        (0, _definePropertyDefault.default)(this, "handleMarkdownChange", (markdown)=>{
            this.handleFieldChange("instructionsMarkdown", markdown);
            this.setState({
                ...this.state,
                isMarkdownOpen: false
            });
        });
        this.state = {
            isCollapsed: true,
            isMarkdownOpen: false,
            isDeleteConfirmationOpen: false
        };
    }
    handleToggleCollapse() {
        this.setState({
            ...this.state,
            isCollapsed: !this.state.isCollapsed
        });
    }
    handleToggleMarkdown() {
        this.setState({
            ...this.state,
            isMarkdownOpen: !this.state.isMarkdownOpen
        });
    }
    handleToggleDelete() {
        this.setState({
            ...this.state,
            isDeleteConfirmationOpen: !this.state.isDeleteConfirmationOpen
        });
    }
    handleFieldChange(fieldName, value) {
        const field = this.props.field;
        field[fieldName] = value;
        this.props.onChange(field);
    }
    getOptions() {
        const options = [
            {
                label: "Delete",
                icon: deleteIcon,
                hoverIcon: deleteIcon,
                isDestructive: true
            },
            {
                label: "Move Up",
                icon: upIcon,
                hoverIcon: upIcon
            },
            {
                label: "Move Down",
                icon: downIcon,
                hoverIcon: downIcon
            },
            {
                label: "Move to another page...",
                icon: moveIcon,
                hoverIcon: moveIcon,
                subOptions: this.props.sections.map((s)=>({
                        label: s.title
                    }))
            }
        ];
        return options;
    }
    handleOptionSelected(optionName) {
        if (optionName == "Move Up") this.props.onMoveUp(this.props.field);
        if (optionName == "Move Down") this.props.onMoveDown(this.props.field);
        if (optionName == "Delete") this.setState({
            ...this.state,
            isDeleteConfirmationOpen: true
        });
        // find section by name and pass it off
        const section = this.props.sections.find((s)=>s.title == optionName);
        if (section) this.props.onMoveToSection(this.props.field, section.id);
    }
    render() {
        const { field, draggable } = this.props;
        return (0, _react.jsx)("div", {
            className: containerStyle
        }, (0, _react.jsx)("div", (0, _extendsDefault.default)({
            className: "field-title-wrapper"
        }, draggable.dragHandleProps), (0, _react.jsx)((0, _toggleIndicatorDefault.default), {
            direction: this.state.isCollapsed ? "right" : "down",
            onClick: this.handleToggleCollapse.bind(this),
            type: "triangle",
            className: "toggle-indicator"
        }), (0, _react.jsx)("img", {
            src: (0, _fieldTypeIcons.getFieldTypeIcon)(field.fieldType),
            onClick: this.handleToggleCollapse.bind(this)
        }), (0, _react.jsx)("div", {
            className: "title-text-container",
            onClick: this.handleToggleCollapse.bind(this)
        }, (0, _react.jsx)("p", {
            className: "field-type-label"
        }, field.fieldType), (0, _react.jsx)("p", {
            className: "field-title"
        }, field.title)), (0, _react.jsx)("div", {
            className: "field-button"
        }, (0, _react.jsx)((0, _largeOverflowMenuDefault.default), {
            isActive: false,
            onOptionSelected: this.handleOptionSelected.bind(this),
            options: this.getOptions(),
            icon: menuIcon
        }))), !this.state.isCollapsed && (0, _react.jsx)("div", {
            className: "field-body-wrapper"
        }, (0, _react.jsx)((0, _textFieldDefault.default), {
            name: "field.associatedVariable",
            value: field.associatedVariable ?? "",
            placeholder: "{Variable}",
            label: "Associated Variable",
            onChange: (e)=>this.handleFieldChange("associatedVariable", e.target.value)
        }), (0, _react.jsx)((0, _horizontalSeparatorDefault.default), null), (0, _react.jsx)((0, _switchDefault.default), {
            className: "switch-container",
            checked: field.isRequired,
            onChange: (checked)=>this.handleFieldChange("isRequired", checked),
            label: "Required Field"
        }), (0, _react.jsx)((0, _textFieldDefault.default), {
            name: "field.title",
            value: field.title ?? "",
            placeholder: "Title your field",
            label: "Display Title",
            onChange: (e)=>this.handleFieldChange("title", e.target.value)
        }), (0, _react.jsx)((0, _textFieldDefault.default), {
            name: "field.label",
            value: field.label ?? "",
            placeholder: "Label for your text field",
            label: "Text Field Label",
            onChange: (e)=>this.handleFieldChange("label", e.target.value)
        }), (0, _react.jsx)((0, _textFieldDefault.default), {
            name: "field.description",
            value: field.tip ?? "",
            placeholder: "Describe your field",
            label: "Description of Field",
            onChange: (e)=>this.handleFieldChange("tip", e.target.value)
        }), (0, _react.jsx)((0, _textFieldDefault.default), {
            name: "field.placeholder",
            value: field.placeholder ?? "",
            placeholder: "Provide a placeholder",
            label: "Placeholder Content (Optional)",
            onChange: (e)=>this.handleFieldChange("placeholder", e.target.value)
        }), field.fieldType == "LongTextField" ? (0, _react.jsx)((0, _textAreaFieldDefault.default), {
            name: "field.defaultValue",
            value: field.defaultValue ?? "",
            placeholder: "Use this if you want to have the field auto-fill with a value",
            label: "Default Value (Optional)",
            onChange: (e)=>this.handleFieldChange("defaultValue", e.target.value)
        }) : (0, _react.jsx)((0, _textFieldDefault.default), {
            name: "field.defaultValue",
            value: field.defaultValue ?? "",
            placeholder: "Use this if you want to have the field auto-fill with a value",
            label: "Default Value (Optional)",
            onChange: (e)=>this.handleFieldChange("defaultValue", e.target.value)
        })), this.state.isMarkdownOpen && (0, _react.jsx)((0, _markdownEditorModalDefault.default), {
            contextTitle: field.title ?? "Field Instructions",
            markdown: this.props.field.instructionsMarkdown ?? "",
            onSave: this.handleMarkdownChange.bind(this),
            onClose: this.handleToggleMarkdown.bind(this)
        }), this.state.isDeleteConfirmationOpen && (0, _react.jsx)((0, _confirmationDialogDefault.default), {
            title: `Delete ${field?.title ?? "Field"}`,
            deleteText: "Yes, Delete",
            isLoading: false,
            onClose: this.handleToggleDelete.bind(this),
            onConfirm: ()=>this.props.onDelete(field)
        }, (0, _react.jsx)((0, _deleteConfirmationDefault.default), {
            itemLabel: `${field?.title ?? "Field"}?`
        })));
    }
}
const containerStyle = /*#__PURE__*/ (0, _css.css)("border:1px solid ", (0, _colors.color_shades_dark), ";background:white;border-radius:8px;margin-bottom:32px;.field-title-wrapper{display:flex;align-items:center;margin:16px 0;cursor:pointer;>.toggle-indicator{margin:16px;transform:scale(2);}>img{width:24px;height:auto;margin-right:12px;}.title-text-container{flex:1;}.field-type-label{font-style:normal;font-weight:normal;font-size:12px;line-height:16px;color:", (0, _colors.color_text_light), ";}.field-title{font-style:normal;font-weight:normal;font-size:18px;line-height:24px;}.field-button{margin-right:32px;margin-left:auto;}}.field-body-wrapper{margin:0 32px;padding:24px 0;border-top:1px solid ", (0, _colors.color_shades_dark), ";>.switch-container{margin:32px 0;}}", "");
exports.default = TextFieldEditor;

},{"@babel/runtime/helpers/extends":"4iKIP","@babel/runtime/helpers/defineProperty":"9sJxO","@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","../../../constants/colors":"1p3OR","../../../components/general/ToggleIndicator":"4eej1","../../../components/forms/TextField":"7a7bh","../../../components/structure/HorizontalSeparator":"Pw3HQ","../../../components/forms/Switch":"8kkL9","./MarkdownEditorModal":"1xj9r","../../../components/general/LargeOverflowMenu":"h9O0c","../../../components/structure/ConfirmationDialog":"kx7yK","../../featureContent/components/DeleteConfirmation":"9xK2d","../../../models/extensions/fieldTypeIcons":"j8H2u","../../../components/forms/TextAreaField":"fE54C","bd6a6e1cd550670":"ch0E7","52bd50ec9a0869f":"24JPN","2db528a5c221de55":"jk3D1","41ef03ed0a5bdabc":"kBbXd","9d837bf8bd8d4da4":"tAIjI","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"ch0E7":[function(require,module,exports) {
module.exports = require("3101234fdf51ff3").getBundleURL("kVLro") + require("5fa412a95c0b0aee").resolve("2RH79");

},{"3101234fdf51ff3":"c7Tr5","5fa412a95c0b0aee":"fyJL2"}],"tAIjI":[function(require,module,exports) {
module.exports = require("db7a598198b153d3").getBundleURL("kVLro") + require("b0b967a77ef0919c").resolve("2Oubs");

},{"db7a598198b153d3":"c7Tr5","b0b967a77ef0919c":"fyJL2"}],"fvvvP":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _extends = require("@babel/runtime/helpers/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _defineProperty = require("@babel/runtime/helpers/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _colors = require("../../../constants/colors");
var _toggleIndicator = require("../../../components/general/ToggleIndicator");
var _toggleIndicatorDefault = parcelHelpers.interopDefault(_toggleIndicator);
var _textField = require("../../../components/forms/TextField");
var _textFieldDefault = parcelHelpers.interopDefault(_textField);
var _horizontalSeparator = require("../../../components/structure/HorizontalSeparator");
var _horizontalSeparatorDefault = parcelHelpers.interopDefault(_horizontalSeparator);
var _switch = require("../../../components/forms/Switch");
var _switchDefault = parcelHelpers.interopDefault(_switch);
var _selectField = require("../../../components/forms/SelectField");
var _selectFieldDefault = parcelHelpers.interopDefault(_selectField);
var _markdownEditorModal = require("./MarkdownEditorModal");
var _markdownEditorModalDefault = parcelHelpers.interopDefault(_markdownEditorModal);
var _largeOverflowMenu = require("../../../components/general/LargeOverflowMenu");
var _largeOverflowMenuDefault = parcelHelpers.interopDefault(_largeOverflowMenu);
var _confirmationDialog = require("../../../components/structure/ConfirmationDialog");
var _confirmationDialogDefault = parcelHelpers.interopDefault(_confirmationDialog);
var _deleteConfirmation = require("../../featureContent/components/DeleteConfirmation");
var _deleteConfirmationDefault = parcelHelpers.interopDefault(_deleteConfirmation);
var _guids = require("../../../services/guids");
var _guidsDefault = parcelHelpers.interopDefault(_guids);
var _button = require("../../../components/general/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _fieldOptionEditor = require("./FieldOptionEditor");
var _fieldOptionEditorDefault = parcelHelpers.interopDefault(_fieldOptionEditor);
var _extensions = require("../../../models/extensions");
var _lodash = require("lodash");
var _lodashDefault = parcelHelpers.interopDefault(_lodash);
var _fieldTypeIcons = require("../../../models/extensions/fieldTypeIcons");
const menuIcon = require("4cd9684d77e170e1");
const deleteIcon = require("c77d3ffcc4507dca");
const upIcon = require("4854474ea6788d42");
const downIcon = require("5fcaa10924a911ea");
const moveIcon = require("6c1bcca0d65bd774");
class OptionsFieldEditor extends (0, _reactDefault.default).Component {
    constructor(props){
        super(props);
        (0, _definePropertyDefault.default)(this, "handleMarkdownChange", (markdown)=>{
            this.handleFieldChange("instructionsMarkdown", markdown);
            this.setState({
                ...this.state,
                isMarkdownOpen: false
            });
        });
        (0, _definePropertyDefault.default)(this, "handleMoveOptionUp", (option)=>{
            const field = this.props.field;
            const options = (0, _lodashDefault.default).sortBy(field?.options ?? [], (s)=>s.priority);
            const index = options.indexOf(option);
            if (index > 0) {
                var sortedOptions = (0, _extensions.reorder)(options, index, index - 1).map((f, i)=>({
                        ...f,
                        priority: i
                    }));
                field.options = sortedOptions;
                this.props.onChange(field);
            }
        });
        (0, _definePropertyDefault.default)(this, "handleMoveOptionDown", (option)=>{
            const field = this.props.field;
            const options = (0, _lodashDefault.default).sortBy(field?.options ?? [], (s)=>s.priority);
            const index = options.indexOf(option);
            if (index < options.length - 1) {
                var sortedOptions = (0, _extensions.reorder)(options, index, index + 1).map((f, i)=>({
                        ...f,
                        priority: i
                    }));
                field.options = sortedOptions;
                this.props.onChange(field);
            }
        });
        (0, _definePropertyDefault.default)(this, "handleDeleteOption", (option)=>{
            const field = this.props.field;
            const options = (0, _lodashDefault.default).sortBy(field?.options ?? [], (s)=>s.priority);
            (0, _lodashDefault.default).remove(options, (f)=>f.id == option.id);
            field.options = options;
            this.props.onChange(field);
        });
        (0, _definePropertyDefault.default)(this, "handleOptionChange", (option)=>{
            const field = this.props.field;
            const options = (0, _lodashDefault.default).sortBy(field?.options ?? [], (s)=>s.priority);
            const index = options.findIndex((o)=>o.id == option.id);
            options[index] = option;
            field.options = options;
            this.props.onChange(field);
        });
        this.state = {
            isCollapsed: true,
            isMarkdownOpen: false,
            isDeleteConfirmationOpen: false
        };
    }
    handleToggleCollapse() {
        this.setState({
            ...this.state,
            isCollapsed: !this.state.isCollapsed
        });
    }
    handleToggleMarkdown() {
        this.setState({
            ...this.state,
            isMarkdownOpen: !this.state.isMarkdownOpen
        });
    }
    handleToggleDelete() {
        this.setState({
            ...this.state,
            isDeleteConfirmationOpen: !this.state.isDeleteConfirmationOpen
        });
    }
    handleFieldChange(fieldName, value) {
        const field = this.props.field;
        field[fieldName] = value;
        this.props.onChange(field);
    }
    getDefaultValueOptions() {
        const { field } = this.props;
        const options = [
            {
                value: "",
                label: "No default value"
            }
        ];
        if (field?.options?.length > 0) field.options.forEach((option)=>{
            if (option.value) options.push({
                value: option.value,
                label: option.label || option.value
            });
        });
        return options;
    }
    getDefaultValuePlaceholder() {
        const { field } = this.props;
        if (field.fieldType === "CheckboxGroupField") return "Choose default options (pipe-separated for multiple: option1|option2)";
        else if (field.fieldType === "RadioGroupField" || field.fieldType === "SelectField") return "Choose a default option";
        return "Choose a default option";
    }
    getOptions() {
        const options = [
            {
                label: "Delete",
                icon: deleteIcon,
                hoverIcon: deleteIcon,
                isDestructive: true
            },
            {
                label: "Move Up",
                icon: upIcon,
                hoverIcon: upIcon
            },
            {
                label: "Move Down",
                icon: downIcon,
                hoverIcon: downIcon
            },
            {
                label: "Move to another page...",
                icon: moveIcon,
                hoverIcon: moveIcon,
                subOptions: this.props.sections.map((s)=>({
                        label: s.title
                    }))
            }
        ];
        return options;
    }
    handleOptionSelected(optionName) {
        if (optionName == "Move Up") this.props.onMoveUp(this.props.field);
        if (optionName == "Move Down") this.props.onMoveDown(this.props.field);
        if (optionName == "Delete") this.setState({
            ...this.state,
            isDeleteConfirmationOpen: true
        });
        // find section by name and pass it off
        const section = this.props.sections.find((s)=>s.title == optionName);
        if (section) this.props.onMoveToSection(this.props.field, section.id);
    }
    handleAddOption() {
        const field = this.props.field;
        if (!field.options) field.options = [];
        field.options.push({
            templateFormFieldId: field.id,
            id: (0, _guidsDefault.default)(),
            label: "",
            value: "",
            priority: 0
        });
        this.props.onChange(field);
    }
    render() {
        const { field, draggable } = this.props;
        return (0, _react.jsx)("div", {
            className: containerStyle
        }, (0, _react.jsx)("div", (0, _extendsDefault.default)({
            className: "field-title-wrapper"
        }, draggable.dragHandleProps), (0, _react.jsx)((0, _toggleIndicatorDefault.default), {
            direction: this.state.isCollapsed ? "right" : "down",
            onClick: this.handleToggleCollapse.bind(this),
            type: "triangle",
            className: "toggle-indicator"
        }), (0, _react.jsx)("img", {
            src: (0, _fieldTypeIcons.getFieldTypeIcon)(field.fieldType),
            onClick: this.handleToggleCollapse.bind(this)
        }), (0, _react.jsx)("div", {
            className: "title-text-container",
            onClick: this.handleToggleCollapse.bind(this)
        }, (0, _react.jsx)("p", {
            className: "field-type-label"
        }, field.fieldType), (0, _react.jsx)("p", {
            className: "field-title"
        }, field.title)), (0, _react.jsx)("div", {
            className: "field-button"
        }, (0, _react.jsx)((0, _largeOverflowMenuDefault.default), {
            isActive: false,
            onOptionSelected: this.handleOptionSelected.bind(this),
            options: this.getOptions(),
            icon: menuIcon
        }))), !this.state.isCollapsed && (0, _react.jsx)("div", {
            className: "field-body-wrapper"
        }, (0, _react.jsx)((0, _textFieldDefault.default), {
            name: "field.associatedVariable",
            value: field.associatedVariable ?? "",
            placeholder: "{Variable}",
            label: "Associated Variable",
            onChange: (e)=>this.handleFieldChange("associatedVariable", e.target.value)
        }), (0, _react.jsx)((0, _horizontalSeparatorDefault.default), null), (0, _react.jsx)((0, _switchDefault.default), {
            className: "switch-container",
            checked: field.isRequired,
            onChange: (checked)=>this.handleFieldChange("isRequired", checked),
            label: "Required Field"
        }), (0, _react.jsx)((0, _textFieldDefault.default), {
            name: "field.title",
            value: field.title ?? "",
            placeholder: "Title your field",
            label: "Display Title",
            onChange: (e)=>this.handleFieldChange("title", e.target.value)
        }), (0, _react.jsx)((0, _textFieldDefault.default), {
            name: "field.description",
            value: field.tip ?? "",
            placeholder: "Describe your field",
            label: "Description of Field",
            onChange: (e)=>this.handleFieldChange("tip", e.target.value)
        }), field.fieldType === "CheckboxGroupField" ? (0, _react.jsx)((0, _textFieldDefault.default), {
            name: "field.defaultValue",
            value: field.defaultValue ?? "",
            label: "Default Value (Optional - separate multiple with a '|')",
            placeholder: "Enter default values separated by pipes (e.g., option1|option2)",
            onChange: (e)=>this.handleFieldChange("defaultValue", e.target.value)
        }) : (0, _react.jsx)((0, _selectFieldDefault.default), {
            name: "field.defaultValue",
            value: field.defaultValue ?? "",
            label: "Default Value (Optional)",
            placeholder: this.getDefaultValuePlaceholder(),
            onChange: (e)=>this.handleFieldChange("defaultValue", e.value),
            options: this.getDefaultValueOptions(),
            clearable: false
        }), field?.options?.map((o, i)=>(0, _react.jsx)((0, _fieldOptionEditorDefault.default), {
                option: o,
                key: i,
                title: `Option ${i + 1}`,
                onMoveDown: this.handleMoveOptionDown.bind(this),
                onMoveUp: this.handleMoveOptionUp.bind(this),
                onChange: this.handleOptionChange.bind(this),
                onDelete: this.handleDeleteOption.bind(this)
            })), (0, _react.jsx)((0, _horizontalSeparatorDefault.default), null), (0, _react.jsx)((0, _buttonDefault.default), {
            type: "button",
            themes: [
                "secondary",
                "fill"
            ],
            className: "add-option-button",
            text: "Add an option",
            onClick: this.handleAddOption.bind(this)
        })), this.state.isMarkdownOpen && (0, _react.jsx)((0, _markdownEditorModalDefault.default), {
            contextTitle: field.title ?? "Field Instructions",
            markdown: this.props.field.instructionsMarkdown ?? "",
            onSave: this.handleMarkdownChange.bind(this),
            onClose: this.handleToggleMarkdown.bind(this)
        }), this.state.isDeleteConfirmationOpen && (0, _react.jsx)((0, _confirmationDialogDefault.default), {
            title: `Delete ${field?.title ?? "Field"}`,
            deleteText: "Yes, Delete",
            isLoading: false,
            onClose: this.handleToggleDelete.bind(this),
            onConfirm: ()=>this.props.onDelete(field)
        }, (0, _react.jsx)((0, _deleteConfirmationDefault.default), {
            itemLabel: field?.title ?? "Field?"
        })));
    }
}
const containerStyle = /*#__PURE__*/ (0, _css.css)("border:1px solid ", (0, _colors.color_shades_dark), ";background:white;border-radius:8px;margin-bottom:32px;.field-title-wrapper{display:flex;align-items:center;margin:16px 0;cursor:pointer;>.toggle-indicator{margin:16px;transform:scale(2);}>img{width:24px;height:auto;margin-right:12px;}.title-text-container{flex:1;}.field-type-label{font-style:normal;font-weight:normal;font-size:12px;line-height:16px;color:", (0, _colors.color_text_light), ";}.field-title{font-style:normal;font-weight:normal;font-size:18px;line-height:24px;}.field-button{margin-right:32px;margin-left:auto;}}.field-body-wrapper{margin:0 32px;padding:24px 0;border-top:1px solid ", (0, _colors.color_shades_dark), ";.add-option-button{margin:0;margin-top:24px;}>.switch-container{margin:32px 0;}}", "");
exports.default = OptionsFieldEditor;

},{"@babel/runtime/helpers/extends":"4iKIP","@babel/runtime/helpers/defineProperty":"9sJxO","@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","../../../constants/colors":"1p3OR","../../../components/general/ToggleIndicator":"4eej1","../../../components/forms/TextField":"7a7bh","../../../components/structure/HorizontalSeparator":"Pw3HQ","../../../components/forms/Switch":"8kkL9","../../../components/forms/SelectField":"405B3","./MarkdownEditorModal":"1xj9r","../../../components/general/LargeOverflowMenu":"h9O0c","../../../components/structure/ConfirmationDialog":"kx7yK","../../featureContent/components/DeleteConfirmation":"9xK2d","../../../services/guids":"jvaYQ","../../../components/general/Button":"6ymxN","./FieldOptionEditor":"Zdsi3","../../../models/extensions":"7h01B","lodash":"3hMBK","../../../models/extensions/fieldTypeIcons":"j8H2u","4cd9684d77e170e1":"ch0E7","c77d3ffcc4507dca":"24JPN","4854474ea6788d42":"jk3D1","5fcaa10924a911ea":"kBbXd","6c1bcca0d65bd774":"tAIjI","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"Zdsi3":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _colors = require("../../../constants/colors");
var _textField = require("../../../components/forms/TextField");
var _textFieldDefault = parcelHelpers.interopDefault(_textField);
var _confirmationDialog = require("../../../components/structure/ConfirmationDialog");
var _confirmationDialogDefault = parcelHelpers.interopDefault(_confirmationDialog);
var _deleteConfirmation = require("../../featureContent/components/DeleteConfirmation");
var _deleteConfirmationDefault = parcelHelpers.interopDefault(_deleteConfirmation);
var _button = require("../../../components/general/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
const deleteIcon = require("150d27a4d0bbdc7");
const upIcon = require("96a031d4c3833f50");
const downIcon = require("d6bc8c4d48df991b");
class FieldOptionEditor extends (0, _reactDefault.default).Component {
    constructor(props){
        super(props);
        this.state = {
            isDeleteConfirmationOpen: false
        };
    }
    handleToggleDelete() {
        this.setState({
            ...this.state,
            isDeleteConfirmationOpen: !this.state.isDeleteConfirmationOpen
        });
    }
    handleConfirmDelete() {
        this.props.onDelete(this.props.option);
        this.setState({
            ...this.state,
            isDeleteConfirmationOpen: false
        });
    }
    handleOptionChange(fieldName, value) {
        const option = this.props.option;
        option[fieldName] = value;
        this.props.onChange(option);
    }
    render() {
        const { option, title } = this.props;
        return (0, _react.jsx)("div", {
            className: containerStyle
        }, (0, _react.jsx)("div", {
            className: "option-title-container"
        }, (0, _react.jsx)("p", null, title), (0, _react.jsx)("div", {
            className: "option-title-buttons"
        }, (0, _react.jsx)((0, _buttonDefault.default), {
            type: "button",
            themes: [
                "icon"
            ],
            icon: downIcon,
            onClick: ()=>this.props.onMoveDown(option)
        }), (0, _react.jsx)((0, _buttonDefault.default), {
            type: "button",
            themes: [
                "icon"
            ],
            icon: upIcon,
            onClick: ()=>this.props.onMoveUp(option)
        }), (0, _react.jsx)((0, _buttonDefault.default), {
            type: "button",
            themes: [
                "icon"
            ],
            icon: deleteIcon,
            onClick: this.handleToggleDelete.bind(this)
        }))), (0, _react.jsx)((0, _textFieldDefault.default), {
            name: "option.label",
            value: option.label ?? "",
            placeholder: "Enter a value for display",
            label: "Option Label",
            onChange: (e)=>this.handleOptionChange("label", e.target.value)
        }), (0, _react.jsx)((0, _textFieldDefault.default), {
            name: "option.value",
            value: option.value ?? "",
            placeholder: "Enter a value for the variable",
            label: "Option value",
            onChange: (e)=>this.handleOptionChange("value", e.target.value)
        }), this.state.isDeleteConfirmationOpen && (0, _react.jsx)((0, _confirmationDialogDefault.default), {
            title: `Delete Option`,
            deleteText: "Yes, Delete",
            isLoading: false,
            onClose: this.handleToggleDelete.bind(this),
            onConfirm: this.handleConfirmDelete.bind(this)
        }, (0, _react.jsx)((0, _deleteConfirmationDefault.default), {
            itemLabel: option?.label ?? "Option?"
        })));
    }
}
const containerStyle = /*#__PURE__*/ (0, _css.css)("border-top:1px solid ", (0, _colors.color_shades_dark), ";padding-top:24px;margin-top:48px;.option-title-container{display:flex;align-items:center;margin-top:-36px;margin-bottom:24px;p{font-style:normal;font-weight:normal;font-size:16px;line-height:24px;background:white;margin-left:16px;padding:0 8px;}.option-title-buttons{margin-right:16px;margin-left:auto;display:flex;align-items:center;background:white;button{margin:0 4px;}}}", "");
exports.default = FieldOptionEditor;

},{"@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","../../../constants/colors":"1p3OR","../../../components/forms/TextField":"7a7bh","../../../components/structure/ConfirmationDialog":"kx7yK","../../featureContent/components/DeleteConfirmation":"9xK2d","../../../components/general/Button":"6ymxN","150d27a4d0bbdc7":"24JPN","96a031d4c3833f50":"h2b5G","d6bc8c4d48df991b":"76AQy","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"h2b5G":[function(require,module,exports) {
module.exports = require("bbdd943fab2d4cb6").getBundleURL("kVLro") + require("3c433a391395060d").resolve("3K2ho");

},{"bbdd943fab2d4cb6":"c7Tr5","3c433a391395060d":"fyJL2"}],"76AQy":[function(require,module,exports) {
module.exports = require("b8796b65564101c9").getBundleURL("kVLro") + require("221acdce83694c37").resolve("gBqEn");

},{"b8796b65564101c9":"c7Tr5","221acdce83694c37":"fyJL2"}],"hFeI0":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _extends = require("@babel/runtime/helpers/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _toggleIndicator = require("../../../components/general/ToggleIndicator");
var _toggleIndicatorDefault = parcelHelpers.interopDefault(_toggleIndicator);
var _largeOverflowMenu = require("../../../components/general/LargeOverflowMenu");
var _largeOverflowMenuDefault = parcelHelpers.interopDefault(_largeOverflowMenu);
var _textField = require("../../../components/forms/TextField");
var _textFieldDefault = parcelHelpers.interopDefault(_textField);
var _horizontalSeparator = require("../../../components/structure/HorizontalSeparator");
var _horizontalSeparatorDefault = parcelHelpers.interopDefault(_horizontalSeparator);
var _switch = require("../../../components/forms/Switch");
var _switchDefault = parcelHelpers.interopDefault(_switch);
var _confirmationDialog = require("../../../components/structure/ConfirmationDialog");
var _confirmationDialogDefault = parcelHelpers.interopDefault(_confirmationDialog);
var _deleteConfirmation = require("../../featureContent/components/DeleteConfirmation");
var _deleteConfirmationDefault = parcelHelpers.interopDefault(_deleteConfirmation);
var _colors = require("../../../constants/colors");
var _fieldTypeIcons = require("../../../models/extensions/fieldTypeIcons");
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const menuIcon = require("cc3732dd4bc432bd");
const deleteIcon = require("32c3b3211700488");
const upIcon = require("c7343d94fb7927f7");
const downIcon = require("49a1c3ead6e4188b");
const moveIcon = require("3b77ed2bb1b1f307");
const FieldUploadFieldEditor = (props)=>{
    const [isCollapsed, setCollapsed] = (0, _react1.useState)(true);
    const [isDeleteConfirmationOpen, setDeleteConfirmationOpen] = (0, _react1.useState)(false);
    function handleOptionSelected(optionName) {
        if (optionName == "Move Up") props.onMoveUp(props.field);
        if (optionName == "Move Down") props.onMoveDown(props.field);
        if (optionName == "Delete") setDeleteConfirmationOpen(true);
        // find section by name and pass it off
        const section = props.sections.find((s)=>s.title == optionName);
        if (section) props.onMoveToSection(props.field, section.id);
    }
    function getOptions() {
        const options = [
            {
                label: "Delete",
                icon: deleteIcon,
                hoverIcon: deleteIcon,
                isDestructive: true
            },
            {
                label: "Move Up",
                icon: upIcon,
                hoverIcon: upIcon
            },
            {
                label: "Move Down",
                icon: downIcon,
                hoverIcon: downIcon
            },
            {
                label: "Move to another page...",
                icon: moveIcon,
                hoverIcon: moveIcon,
                subOptions: props.sections.map((s)=>({
                        label: s.title
                    }))
            }
        ];
        return options;
    }
    function handleFieldChange(fieldName, value) {
        const field = props.field;
        field[fieldName] = value;
        props.onChange(field);
    }
    return (0, _react.jsx)("div", {
        className: `${containerStyle}`
    }, (0, _react.jsx)("div", (0, _extendsDefault.default)({
        className: "field-title-wrapper"
    }, props.draggable.dragHandleProps, {
        onClick: ()=>setCollapsed(!isCollapsed)
    }), (0, _react.jsx)((0, _toggleIndicatorDefault.default), {
        direction: isCollapsed ? "right" : "down",
        type: "triangle",
        className: "toggle-indicator"
    }), (0, _react.jsx)("img", {
        src: (0, _fieldTypeIcons.getFieldTypeIcon)(props.field.fieldType)
    }), (0, _react.jsx)("div", {
        className: "title-text-container"
    }, (0, _react.jsx)("p", {
        className: "field-type-label"
    }, props.field.fieldType), (0, _react.jsx)("p", {
        className: "field-title"
    }, props.field.title)), (0, _react.jsx)("div", {
        className: "field-button"
    }, (0, _react.jsx)((0, _largeOverflowMenuDefault.default), {
        isActive: false,
        onOptionSelected: handleOptionSelected.bind(undefined),
        options: getOptions(),
        icon: menuIcon
    }))), !isCollapsed && (0, _react.jsx)("div", {
        className: "field-body-wrapper"
    }, (0, _react.jsx)((0, _textFieldDefault.default), {
        name: "field.associatedVariable",
        value: props.field.associatedVariable ?? "",
        placeholder: "{Variable}",
        label: "Associated Variable",
        onChange: (e)=>handleFieldChange("associatedVariable", e.target.value)
    }), (0, _react.jsx)((0, _horizontalSeparatorDefault.default), null), (0, _react.jsx)("br", null), (0, _react.jsx)((0, _textFieldDefault.default), {
        name: "field.title",
        value: props.field.title ?? "",
        placeholder: "Upload your File",
        label: "Question / Display Title",
        onChange: (e)=>handleFieldChange("title", e.target.value)
    }), (0, _react.jsx)((0, _textFieldDefault.default), {
        name: "field.description",
        value: props.field.tip ?? "",
        placeholder: "Empty",
        label: "Description (Optional)",
        onChange: (e)=>handleFieldChange("tip", e.target.value)
    }), (0, _react.jsx)((0, _textFieldDefault.default), {
        name: "field.fileformats",
        value: props.field.fileFormats ?? "",
        placeholder: "Example .csv, .docx",
        label: "File Formats Supported - Comma Separated (Optional)",
        onChange: (e)=>handleFieldChange("fileFormats", e.target.value)
    }), (0, _react.jsx)((0, _textFieldDefault.default), {
        name: "field.filesuggestions",
        value: props.field.suggestions ?? "",
        placeholder: "Suggestions",
        label: "File Suggestions (Optional)",
        onChange: (e)=>handleFieldChange("suggestions", e.target.value)
    }), (0, _react.jsx)((0, _horizontalSeparatorDefault.default), null), (0, _react.jsx)("h1", {
        className: `${subHeader}`
    }, "Settings:"), (0, _react.jsx)((0, _switchDefault.default), {
        className: "switch-container",
        checked: props.field.isRequired,
        onChange: (checked)=>handleFieldChange("isRequired", checked),
        label: "Required Field"
    })), isDeleteConfirmationOpen && (0, _react.jsx)((0, _confirmationDialogDefault.default), {
        title: `Delete ${props.field?.title ?? "Field"}`,
        deleteText: "Yes, Delete",
        isLoading: false,
        onClose: ()=>setDeleteConfirmationOpen(false),
        onConfirm: ()=>props.onDelete(props.field)
    }, (0, _react.jsx)((0, _deleteConfirmationDefault.default), {
        itemLabel: `${props.field?.title ?? "Field"}?`
    })));
};
const containerStyle = /*#__PURE__*/ (0, _css.css)("border:1px solid ", (0, _colors.color_shades_dark), ";background:white;border-radius:8px;margin-bottom:32px;.field-title-wrapper{display:flex;align-items:center;margin:16px 0;cursor:pointer;>.toggle-indicator{margin:16px;transform:scale(2);}>img{width:24px;height:auto;margin-right:12px;}.title-text-container{flex:1;}.field-type-label{font-style:normal;font-weight:normal;font-size:12px;line-height:16px;color:", (0, _colors.color_text_light), ";}.field-title{font-style:normal;font-weight:normal;font-size:18px;line-height:24px;}.field-button{margin-right:32px;margin-left:auto;}}.field-body-wrapper{margin:0 32px;padding:24px 0;border-top:1px solid ", (0, _colors.color_shades_dark), ";>.switch-container{margin:32px 0;}}", "");
const subHeader = /*#__PURE__*/ (0, _css.css)({
    name: "1bkpu5b",
    styles: "margin-top:30px"
});
exports.default = FieldUploadFieldEditor;

},{"@babel/runtime/helpers/extends":"4iKIP","@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","../../../components/general/ToggleIndicator":"4eej1","../../../components/general/LargeOverflowMenu":"h9O0c","../../../components/forms/TextField":"7a7bh","../../../components/structure/HorizontalSeparator":"Pw3HQ","../../../components/forms/Switch":"8kkL9","../../../components/structure/ConfirmationDialog":"kx7yK","../../featureContent/components/DeleteConfirmation":"9xK2d","../../../constants/colors":"1p3OR","../../../models/extensions/fieldTypeIcons":"j8H2u","cc3732dd4bc432bd":"ch0E7","32c3b3211700488":"24JPN","c7343d94fb7927f7":"jk3D1","49a1c3ead6e4188b":"kBbXd","3b77ed2bb1b1f307":"tAIjI","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"cw4qa":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _extends = require("@babel/runtime/helpers/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _defineProperty = require("@babel/runtime/helpers/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _colors = require("../../../constants/colors");
var _toggleIndicator = require("../../../components/general/ToggleIndicator");
var _toggleIndicatorDefault = parcelHelpers.interopDefault(_toggleIndicator);
var _textField = require("../../../components/forms/TextField");
var _textFieldDefault = parcelHelpers.interopDefault(_textField);
var _horizontalSeparator = require("../../../components/structure/HorizontalSeparator");
var _horizontalSeparatorDefault = parcelHelpers.interopDefault(_horizontalSeparator);
var _switch = require("../../../components/forms/Switch");
var _switchDefault = parcelHelpers.interopDefault(_switch);
var _markdownEditorModal = require("./MarkdownEditorModal");
var _markdownEditorModalDefault = parcelHelpers.interopDefault(_markdownEditorModal);
var _largeOverflowMenu = require("../../../components/general/LargeOverflowMenu");
var _largeOverflowMenuDefault = parcelHelpers.interopDefault(_largeOverflowMenu);
var _confirmationDialog = require("../../../components/structure/ConfirmationDialog");
var _confirmationDialogDefault = parcelHelpers.interopDefault(_confirmationDialog);
var _deleteConfirmation = require("../../featureContent/components/DeleteConfirmation");
var _deleteConfirmationDefault = parcelHelpers.interopDefault(_deleteConfirmation);
var _fieldTypeIcons = require("../../../models/extensions/fieldTypeIcons");
const menuIcon = require("8b7e43514317d2a9");
const deleteIcon = require("959e0aa9a7157742");
const upIcon = require("1f00d35cebf95242");
const downIcon = require("7107ccbcb7e90b53");
const moveIcon = require("5d96e98bd49835b4");
class TimeRangeFieldEditor extends (0, _reactDefault.default).Component {
    constructor(props){
        super(props);
        (0, _definePropertyDefault.default)(this, "handleMarkdownChange", (markdown)=>{
            this.handleFieldChange("instructionsMarkdown", markdown);
            this.setState({
                ...this.state,
                isMarkdownOpen: false
            });
        });
        this.state = {
            isCollapsed: true,
            isMarkdownOpen: false,
            isDeleteConfirmationOpen: false
        };
    }
    handleToggleCollapse() {
        this.setState({
            ...this.state,
            isCollapsed: !this.state.isCollapsed
        });
    }
    handleToggleMarkdown() {
        this.setState({
            ...this.state,
            isMarkdownOpen: !this.state.isMarkdownOpen
        });
    }
    handleToggleDelete() {
        this.setState({
            ...this.state,
            isDeleteConfirmationOpen: !this.state.isDeleteConfirmationOpen
        });
    }
    handleFieldChange(fieldName, value) {
        const updatedField = {
            ...this.props.field,
            [fieldName]: value
        };
        this.props.onChange(updatedField);
    }
    getOptions() {
        const options = [
            {
                label: "Delete",
                icon: deleteIcon,
                hoverIcon: deleteIcon,
                isDestructive: true
            },
            {
                label: "Move Up",
                icon: upIcon,
                hoverIcon: upIcon
            },
            {
                label: "Move Down",
                icon: downIcon,
                hoverIcon: downIcon
            },
            {
                label: "Move to another page...",
                icon: moveIcon,
                hoverIcon: moveIcon,
                subOptions: this.props.sections.map((s)=>({
                        label: s.title
                    }))
            }
        ];
        return options;
    }
    handleOptionSelected(optionName) {
        if (optionName == "Move Up") this.props.onMoveUp(this.props.field);
        if (optionName == "Move Down") this.props.onMoveDown(this.props.field);
        if (optionName == "Delete") this.setState({
            ...this.state,
            isDeleteConfirmationOpen: true
        });
        // find section by name and pass it off
        const section = this.props.sections.find((s)=>s.title == optionName);
        if (section) this.props.onMoveToSection(this.props.field, section.id);
    }
    render() {
        const { field, draggable } = this.props;
        return (0, _react.jsx)("div", {
            className: containerStyle
        }, (0, _react.jsx)("div", (0, _extendsDefault.default)({
            className: "field-title-wrapper"
        }, draggable.dragHandleProps), (0, _react.jsx)((0, _toggleIndicatorDefault.default), {
            direction: this.state.isCollapsed ? "right" : "down",
            onClick: this.handleToggleCollapse.bind(this),
            type: "triangle",
            className: "toggle-indicator"
        }), (0, _react.jsx)("img", {
            src: (0, _fieldTypeIcons.getFieldTypeIcon)(field.fieldType),
            onClick: this.handleToggleCollapse.bind(this)
        }), (0, _react.jsx)("div", {
            className: "title-text-container",
            onClick: this.handleToggleCollapse.bind(this)
        }, (0, _react.jsx)("p", {
            className: "field-type-label"
        }, field.fieldType), (0, _react.jsx)("p", {
            className: "field-title"
        }, field.title)), (0, _react.jsx)("div", {
            className: "field-button"
        }, (0, _react.jsx)((0, _largeOverflowMenuDefault.default), {
            isActive: false,
            onOptionSelected: this.handleOptionSelected.bind(this),
            options: this.getOptions(),
            icon: menuIcon
        }))), !this.state.isCollapsed && (0, _react.jsx)("div", {
            className: "field-body-wrapper"
        }, (0, _react.jsx)((0, _textFieldDefault.default), {
            name: "field.associatedVariable",
            value: field.associatedVariable ?? "",
            placeholder: "{Variable}",
            label: "Associated Variable",
            onChange: (e)=>this.handleFieldChange("associatedVariable", e.target.value)
        }), (0, _react.jsx)((0, _horizontalSeparatorDefault.default), null), (0, _react.jsx)((0, _switchDefault.default), {
            className: "switch-container",
            checked: field.isRequired,
            onChange: (checked)=>this.handleFieldChange("isRequired", checked),
            label: "Required Field"
        }), (0, _react.jsx)((0, _textFieldDefault.default), {
            name: "field.title",
            value: field.title ?? "",
            placeholder: "Title your field",
            label: "Display Title",
            onChange: (e)=>this.handleFieldChange("title", e.target.value)
        }), (0, _react.jsx)((0, _textFieldDefault.default), {
            name: "field.label",
            value: field.label ?? "",
            placeholder: "Label for weekly hours",
            label: "Field Label",
            onChange: (e)=>this.handleFieldChange("label", e.target.value)
        }), (0, _react.jsx)((0, _textFieldDefault.default), {
            name: "field.description",
            value: field.tip ?? "",
            placeholder: "Describe your field (e.g., 'Set your business hours for each day')",
            label: "Description of Field",
            onChange: (e)=>this.handleFieldChange("tip", e.target.value)
        }), (0, _react.jsx)("div", {
            className: "info-section"
        }, (0, _react.jsx)("p", {
            className: "info-label"
        }, "Backend Format:"), (0, _react.jsx)("p", {
            className: "info-text"
        }, 'Data is sent as an array of 7 strings (Mon-Sun) with CLOSED hours (not open hours) in 24-hour format. Example: "17:00,09:00" means closed from 5pm-9am. Use pipe (|) for multiple closed periods: "00:00,09:00|17:00,23:59". Closed all day: "00:00,23:59".'))), this.state.isMarkdownOpen && (0, _react.jsx)((0, _markdownEditorModalDefault.default), {
            contextTitle: field.title ?? "Field Instructions",
            markdown: this.props.field.instructionsMarkdown ?? "",
            onSave: this.handleMarkdownChange.bind(this),
            onClose: this.handleToggleMarkdown.bind(this)
        }), this.state.isDeleteConfirmationOpen && (0, _react.jsx)((0, _confirmationDialogDefault.default), {
            title: `Delete ${field?.title ?? "Field"}`,
            deleteText: "Yes, Delete",
            isLoading: false,
            onClose: this.handleToggleDelete.bind(this),
            onConfirm: ()=>this.props.onDelete(this.props.field)
        }, (0, _react.jsx)((0, _deleteConfirmationDefault.default), {
            itemLabel: `${field?.title ?? "Field"}?`
        })));
    }
}
const containerStyle = /*#__PURE__*/ (0, _css.css)("border:1px solid ", (0, _colors.color_shades_dark), ";background:white;border-radius:8px;margin-bottom:32px;.field-title-wrapper{display:flex;align-items:center;margin:16px 0;cursor:pointer;>.toggle-indicator{margin:16px;transform:scale(2);}>img{width:24px;height:auto;margin-right:12px;}.title-text-container{flex:1;}.field-type-label{font-style:normal;font-weight:normal;font-size:12px;line-height:16px;color:", (0, _colors.color_text_light), ";}.field-title{font-style:normal;font-weight:normal;font-size:18px;line-height:24px;}.field-button{margin-right:32px;margin-left:auto;}}.field-body-wrapper{margin:0 32px;padding:24px 0;border-top:1px solid ", (0, _colors.color_shades_dark), ";>.switch-container{margin:32px 0;}.info-section{margin-top:24px;padding:16px;background:#f8f9fa;border-radius:4px;border-left:3px solid ", (0, _colors.color_shades_dark), ";.info-label{font-weight:600;font-size:12px;color:", (0, _colors.color_text_light), ";margin-bottom:8px;text-transform:uppercase;letter-spacing:0.5px;}.info-text{font-size:13px;line-height:1.5;color:", (0, _colors.color_text_light), ";margin:0;}}}", "");
exports.default = TimeRangeFieldEditor;

},{"@babel/runtime/helpers/extends":"4iKIP","@babel/runtime/helpers/defineProperty":"9sJxO","@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","../../../constants/colors":"1p3OR","../../../components/general/ToggleIndicator":"4eej1","../../../components/forms/TextField":"7a7bh","../../../components/structure/HorizontalSeparator":"Pw3HQ","../../../components/forms/Switch":"8kkL9","./MarkdownEditorModal":"1xj9r","../../../components/general/LargeOverflowMenu":"h9O0c","../../../components/structure/ConfirmationDialog":"kx7yK","../../featureContent/components/DeleteConfirmation":"9xK2d","../../../models/extensions/fieldTypeIcons":"j8H2u","8b7e43514317d2a9":"ch0E7","959e0aa9a7157742":"24JPN","1f00d35cebf95242":"jk3D1","7107ccbcb7e90b53":"kBbXd","5d96e98bd49835b4":"tAIjI","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7W6Rv":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _extends = require("@babel/runtime/helpers/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _defineProperty = require("@babel/runtime/helpers/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _textField = require("../../../components/forms/TextField");
var _textFieldDefault = parcelHelpers.interopDefault(_textField);
var _colors = require("../../../constants/colors");
var _toggleIndicator = require("../../../components/general/ToggleIndicator");
var _toggleIndicatorDefault = parcelHelpers.interopDefault(_toggleIndicator);
var _horizontalSeparator = require("../../../components/structure/HorizontalSeparator");
var _horizontalSeparatorDefault = parcelHelpers.interopDefault(_horizontalSeparator);
var _switch = require("../../../components/forms/Switch");
var _switchDefault = parcelHelpers.interopDefault(_switch);
var _markdownEditorModal = require("./MarkdownEditorModal");
var _markdownEditorModalDefault = parcelHelpers.interopDefault(_markdownEditorModal);
var _largeOverflowMenu = require("../../../components/general/LargeOverflowMenu");
var _largeOverflowMenuDefault = parcelHelpers.interopDefault(_largeOverflowMenu);
var _confirmationDialog = require("../../../components/structure/ConfirmationDialog");
var _confirmationDialogDefault = parcelHelpers.interopDefault(_confirmationDialog);
var _deleteConfirmation = require("../../featureContent/components/DeleteConfirmation");
var _deleteConfirmationDefault = parcelHelpers.interopDefault(_deleteConfirmation);
var _fieldTypeIcons = require("../../../models/extensions/fieldTypeIcons");
const menuIcon = require("845ef7c828c0fc1d");
const deleteIcon = require("f6a259fc3722dff3");
const upIcon = require("ff8737b486ed4571");
const downIcon = require("fada9c3ccd10bf34");
const moveIcon = require("6ad555a35ec46689");
class SingleDayTimeRangeFieldEditor extends (0, _reactDefault.default).Component {
    constructor(props){
        super(props);
        (0, _definePropertyDefault.default)(this, "handleMarkdownChange", (markdown)=>{
            this.handleFieldChange("instructionsMarkdown", markdown);
            this.setState({
                ...this.state,
                isMarkdownOpen: false
            });
        });
        this.state = {
            isCollapsed: true,
            isMarkdownOpen: false,
            isDeleteConfirmationOpen: false
        };
    }
    handleToggleCollapse() {
        this.setState({
            ...this.state,
            isCollapsed: !this.state.isCollapsed
        });
    }
    handleToggleMarkdown() {
        this.setState({
            ...this.state,
            isMarkdownOpen: !this.state.isMarkdownOpen
        });
    }
    handleToggleDelete() {
        this.setState({
            ...this.state,
            isDeleteConfirmationOpen: !this.state.isDeleteConfirmationOpen
        });
    }
    handleFieldChange(fieldName, value) {
        const updatedField = {
            ...this.props.field,
            [fieldName]: value
        };
        this.props.onChange(updatedField);
    }
    getOptions() {
        const options = [
            {
                label: "Delete",
                icon: deleteIcon,
                hoverIcon: deleteIcon,
                isDestructive: true
            },
            {
                label: "Move Up",
                icon: upIcon,
                hoverIcon: upIcon
            },
            {
                label: "Move Down",
                icon: downIcon,
                hoverIcon: downIcon
            },
            {
                label: "Move to another page...",
                icon: moveIcon,
                hoverIcon: moveIcon,
                subOptions: this.props.sections.map((s)=>({
                        label: s.title
                    }))
            }
        ];
        return options;
    }
    handleOptionSelected(optionName) {
        if (optionName == "Move Up") this.props.onMoveUp(this.props.field);
        if (optionName == "Move Down") this.props.onMoveDown(this.props.field);
        if (optionName == "Delete") this.setState({
            ...this.state,
            isDeleteConfirmationOpen: true
        });
        // find section by name and pass it off
        const section = this.props.sections.find((s)=>s.title == optionName);
        if (section) this.props.onMoveToSection(this.props.field, section.id);
    }
    render() {
        const { field, draggable } = this.props;
        return (0, _react.jsx)("div", {
            className: containerStyle
        }, (0, _react.jsx)("div", (0, _extendsDefault.default)({
            className: "field-title-wrapper"
        }, draggable.dragHandleProps), (0, _react.jsx)((0, _toggleIndicatorDefault.default), {
            direction: this.state.isCollapsed ? "right" : "down",
            onClick: this.handleToggleCollapse.bind(this),
            type: "triangle",
            className: "toggle-indicator"
        }), (0, _react.jsx)("img", {
            src: (0, _fieldTypeIcons.getFieldTypeIcon)(field.fieldType),
            onClick: this.handleToggleCollapse.bind(this)
        }), (0, _react.jsx)("div", {
            className: "title-text-container",
            onClick: this.handleToggleCollapse.bind(this)
        }, (0, _react.jsx)("p", {
            className: "field-type-label"
        }, field.fieldType), (0, _react.jsx)("p", {
            className: "field-title"
        }, field.title)), (0, _react.jsx)("div", {
            className: "field-button"
        }, (0, _react.jsx)((0, _largeOverflowMenuDefault.default), {
            isActive: false,
            onOptionSelected: this.handleOptionSelected.bind(this),
            options: this.getOptions(),
            icon: menuIcon
        }))), !this.state.isCollapsed && (0, _react.jsx)("div", {
            className: "field-body-wrapper"
        }, (0, _react.jsx)((0, _textFieldDefault.default), {
            name: "field.associatedVariable",
            value: field.associatedVariable ?? "",
            placeholder: "{Variable}",
            label: "Associated Variable",
            onChange: (e)=>this.handleFieldChange("associatedVariable", e.target.value)
        }), (0, _react.jsx)((0, _horizontalSeparatorDefault.default), null), (0, _react.jsx)((0, _switchDefault.default), {
            className: "switch-container",
            checked: field.isRequired,
            onChange: (checked)=>this.handleFieldChange("isRequired", checked),
            label: "Required Field"
        }), (0, _react.jsx)((0, _textFieldDefault.default), {
            name: "field.title",
            value: field.title ?? "",
            placeholder: "Title your field",
            label: "Display Title",
            onChange: (e)=>this.handleFieldChange("title", e.target.value)
        }), (0, _react.jsx)((0, _textFieldDefault.default), {
            name: "field.label",
            value: field.label ?? "",
            placeholder: "Label for single day hours",
            label: "Field Label",
            onChange: (e)=>this.handleFieldChange("label", e.target.value)
        }), (0, _react.jsx)((0, _textFieldDefault.default), {
            name: "field.description",
            value: field.tip ?? "",
            placeholder: "Describe your field (e.g., 'Set your Monday hours')",
            label: "Description of Field",
            onChange: (e)=>this.handleFieldChange("tip", e.target.value)
        }), (0, _react.jsx)("div", {
            className: "info-section"
        }, (0, _react.jsx)("p", {
            className: "info-label"
        }, "Backend Format:"), (0, _react.jsx)("p", {
            className: "info-text"
        }, 'Data is sent as OPEN hours in 24-hour format. Example: "09:00,17:00" means open from 9am-5pm. Use pipe (|) for multiple open periods: "09:00,12:00|13:00,17:00". Closed all day: empty string "".'))), this.state.isMarkdownOpen && (0, _react.jsx)((0, _markdownEditorModalDefault.default), {
            contextTitle: field.title ?? "Field Instructions",
            markdown: this.props.field.instructionsMarkdown ?? "",
            onSave: this.handleMarkdownChange.bind(this),
            onClose: this.handleToggleMarkdown.bind(this)
        }), this.state.isDeleteConfirmationOpen && (0, _react.jsx)((0, _confirmationDialogDefault.default), {
            title: `Delete ${field?.title ?? "Field"}`,
            deleteText: "Yes, Delete",
            isLoading: false,
            onClose: this.handleToggleDelete.bind(this),
            onConfirm: ()=>this.props.onDelete(this.props.field)
        }, (0, _react.jsx)((0, _deleteConfirmationDefault.default), {
            itemLabel: `${field?.title ?? "Field"}?`
        })));
    }
}
const containerStyle = /*#__PURE__*/ (0, _css.css)("border:1px solid ", (0, _colors.color_shades_dark), ";background:white;border-radius:8px;margin-bottom:32px;.field-title-wrapper{display:flex;align-items:center;margin:16px 0;cursor:pointer;>.toggle-indicator{margin:16px;transform:scale(2);}>img{width:24px;height:auto;margin-right:12px;}.title-text-container{flex:1;}.field-type-label{font-style:normal;font-weight:normal;font-size:12px;line-height:16px;color:", (0, _colors.color_text_light), ";}.field-title{font-style:normal;font-weight:normal;font-size:18px;line-height:24px;}.field-button{margin-right:32px;margin-left:auto;}}.field-body-wrapper{margin:0 32px;padding:24px 0;border-top:1px solid ", (0, _colors.color_shades_dark), ";>.switch-container{margin:32px 0;}.info-section{margin-top:24px;padding:16px;background:#f8f9fa;border-radius:4px;border-left:3px solid ", (0, _colors.color_shades_dark), ";.info-label{font-weight:600;font-size:12px;color:", (0, _colors.color_text_light), ";margin-bottom:8px;text-transform:uppercase;letter-spacing:0.5px;}.info-text{font-size:13px;line-height:1.5;color:", (0, _colors.color_text_light), ";margin:0;}}}", "");
exports.default = SingleDayTimeRangeFieldEditor;

},{"@babel/runtime/helpers/extends":"4iKIP","@babel/runtime/helpers/defineProperty":"9sJxO","@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","../../../components/forms/TextField":"7a7bh","../../../constants/colors":"1p3OR","../../../components/general/ToggleIndicator":"4eej1","../../../components/structure/HorizontalSeparator":"Pw3HQ","../../../components/forms/Switch":"8kkL9","./MarkdownEditorModal":"1xj9r","../../../components/general/LargeOverflowMenu":"h9O0c","../../../components/structure/ConfirmationDialog":"kx7yK","../../featureContent/components/DeleteConfirmation":"9xK2d","../../../models/extensions/fieldTypeIcons":"j8H2u","845ef7c828c0fc1d":"ch0E7","f6a259fc3722dff3":"24JPN","ff8737b486ed4571":"jk3D1","fada9c3ccd10bf34":"kBbXd","6ad555a35ec46689":"tAIjI","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"f2VvG":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _extends = require("@babel/runtime/helpers/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _defineProperty = require("@babel/runtime/helpers/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _colors = require("../../../constants/colors");
var _toggleIndicator = require("../../../components/general/ToggleIndicator");
var _toggleIndicatorDefault = parcelHelpers.interopDefault(_toggleIndicator);
var _textField = require("../../../components/forms/TextField");
var _textFieldDefault = parcelHelpers.interopDefault(_textField);
var _horizontalSeparator = require("../../../components/structure/HorizontalSeparator");
var _horizontalSeparatorDefault = parcelHelpers.interopDefault(_horizontalSeparator);
var _switch = require("../../../components/forms/Switch");
var _switchDefault = parcelHelpers.interopDefault(_switch);
var _markdownEditorModal = require("./MarkdownEditorModal");
var _markdownEditorModalDefault = parcelHelpers.interopDefault(_markdownEditorModal);
var _largeOverflowMenu = require("../../../components/general/LargeOverflowMenu");
var _largeOverflowMenuDefault = parcelHelpers.interopDefault(_largeOverflowMenu);
var _confirmationDialog = require("../../../components/structure/ConfirmationDialog");
var _confirmationDialogDefault = parcelHelpers.interopDefault(_confirmationDialog);
var _deleteConfirmation = require("../../featureContent/components/DeleteConfirmation");
var _deleteConfirmationDefault = parcelHelpers.interopDefault(_deleteConfirmation);
var _fieldTypeIcons = require("../../../models/extensions/fieldTypeIcons");
const menuIcon = require("404d913ff971d808");
const deleteIcon = require("6970a3bb322a6c5e");
const upIcon = require("c3d70250a9d3d4a7");
const downIcon = require("8bf42d10d8d63083");
const moveIcon = require("1e880c0d5fa4b11d");
class SpecialDateFieldEditor extends (0, _reactDefault.default).Component {
    constructor(props){
        super(props);
        (0, _definePropertyDefault.default)(this, "handleMarkdownChange", (markdown)=>{
            this.handleFieldChange("instructionsMarkdown", markdown);
            this.setState({
                ...this.state,
                isMarkdownOpen: false
            });
        });
        this.state = {
            isCollapsed: true,
            isMarkdownOpen: false,
            isDeleteConfirmationOpen: false
        };
    }
    handleToggleCollapse() {
        this.setState({
            ...this.state,
            isCollapsed: !this.state.isCollapsed
        });
    }
    handleToggleMarkdown() {
        this.setState({
            ...this.state,
            isMarkdownOpen: !this.state.isMarkdownOpen
        });
    }
    handleToggleDelete() {
        this.setState({
            ...this.state,
            isDeleteConfirmationOpen: !this.state.isDeleteConfirmationOpen
        });
    }
    handleFieldChange(fieldName, value) {
        const updatedField = {
            ...this.props.field,
            [fieldName]: value
        };
        this.props.onChange(updatedField);
    }
    getOptions() {
        const options = [
            {
                label: "Delete",
                icon: deleteIcon,
                hoverIcon: deleteIcon,
                isDestructive: true
            },
            {
                label: "Move Up",
                icon: upIcon,
                hoverIcon: upIcon
            },
            {
                label: "Move Down",
                icon: downIcon,
                hoverIcon: downIcon
            },
            {
                label: "Move to another page...",
                icon: moveIcon,
                hoverIcon: moveIcon,
                subOptions: this.props.sections.map((s)=>({
                        label: s.title
                    }))
            }
        ];
        return options;
    }
    handleOptionSelected(optionName) {
        if (optionName == "Move Up") this.props.onMoveUp(this.props.field);
        if (optionName == "Move Down") this.props.onMoveDown(this.props.field);
        if (optionName == "Delete") this.setState({
            ...this.state,
            isDeleteConfirmationOpen: true
        });
        // find section by name and pass it off
        const section = this.props.sections.find((s)=>s.title == optionName);
        if (section) this.props.onMoveToSection(this.props.field, section.id);
    }
    render() {
        const { field, draggable } = this.props;
        return (0, _react.jsx)("div", {
            className: containerStyle
        }, (0, _react.jsx)("div", (0, _extendsDefault.default)({
            className: "field-title-wrapper"
        }, draggable.dragHandleProps), (0, _react.jsx)((0, _toggleIndicatorDefault.default), {
            direction: this.state.isCollapsed ? "right" : "down",
            onClick: this.handleToggleCollapse.bind(this),
            type: "triangle",
            className: "toggle-indicator"
        }), (0, _react.jsx)("img", {
            src: (0, _fieldTypeIcons.getFieldTypeIcon)(field.fieldType),
            onClick: this.handleToggleCollapse.bind(this)
        }), (0, _react.jsx)("div", {
            className: "title-text-container",
            onClick: this.handleToggleCollapse.bind(this)
        }, (0, _react.jsx)("p", {
            className: "field-type-label"
        }, field.fieldType), (0, _react.jsx)("p", {
            className: "field-title"
        }, field.title)), (0, _react.jsx)("div", {
            className: "field-button"
        }, (0, _react.jsx)((0, _largeOverflowMenuDefault.default), {
            isActive: false,
            onOptionSelected: this.handleOptionSelected.bind(this),
            options: this.getOptions(),
            icon: menuIcon
        }))), !this.state.isCollapsed && (0, _react.jsx)("div", {
            className: "field-body-wrapper"
        }, (0, _react.jsx)((0, _textFieldDefault.default), {
            name: "field.associatedVariable",
            value: field.associatedVariable ?? "",
            placeholder: "{Variable}",
            label: "Associated Variable",
            onChange: (e)=>this.handleFieldChange("associatedVariable", e.target.value)
        }), (0, _react.jsx)((0, _horizontalSeparatorDefault.default), null), (0, _react.jsx)((0, _switchDefault.default), {
            className: "switch-container",
            checked: field.isRequired,
            onChange: (checked)=>this.handleFieldChange("isRequired", checked),
            label: "Required Field"
        }), (0, _react.jsx)((0, _textFieldDefault.default), {
            name: "field.title",
            value: field.title ?? "",
            placeholder: "Title your field",
            label: "Display Title",
            onChange: (e)=>this.handleFieldChange("title", e.target.value)
        }), (0, _react.jsx)((0, _textFieldDefault.default), {
            name: "field.label",
            value: field.label ?? "",
            placeholder: "Label for special dates",
            label: "Field Label",
            onChange: (e)=>this.handleFieldChange("label", e.target.value)
        }), (0, _react.jsx)((0, _textFieldDefault.default), {
            name: "field.description",
            value: field.tip ?? "",
            placeholder: "Describe your field (e.g., 'Add holidays and special dates with custom hours')",
            label: "Description of Field",
            onChange: (e)=>this.handleFieldChange("tip", e.target.value)
        }), (0, _react.jsx)("div", {
            className: "info-section"
        }, (0, _react.jsx)("p", {
            className: "info-label"
        }, "Backend Format:"), (0, _react.jsx)("p", {
            className: "info-text"
        }, 'Data is sent as CLOSED hours. Format: "01/02/2026,01/05/2026(13:00-16:30)" where dates are MM/DD/YYYY and times in parentheses are closed hours in 24-hour format. Use hyphens between start-end times and pipes (|) for multiple closed periods. Use "none" for no special dates.'))), this.state.isMarkdownOpen && (0, _react.jsx)((0, _markdownEditorModalDefault.default), {
            contextTitle: field.title ?? "Field Instructions",
            markdown: this.props.field.instructionsMarkdown ?? "",
            onSave: this.handleMarkdownChange.bind(this),
            onClose: this.handleToggleMarkdown.bind(this)
        }), this.state.isDeleteConfirmationOpen && (0, _react.jsx)((0, _confirmationDialogDefault.default), {
            title: `Delete ${field?.title ?? "Field"}`,
            deleteText: "Yes, Delete",
            isLoading: false,
            onClose: this.handleToggleDelete.bind(this),
            onConfirm: ()=>this.props.onDelete(this.props.field)
        }, (0, _react.jsx)((0, _deleteConfirmationDefault.default), {
            itemLabel: `${field?.title ?? "Field"}?`
        })));
    }
}
const containerStyle = /*#__PURE__*/ (0, _css.css)("border:1px solid ", (0, _colors.color_shades_dark), ";background:white;border-radius:8px;margin-bottom:32px;.field-title-wrapper{display:flex;align-items:center;margin:16px 0;cursor:pointer;>.toggle-indicator{margin:16px;transform:scale(2);}>img{width:24px;height:auto;margin-right:12px;}.title-text-container{flex:1;}.field-type-label{font-style:normal;font-weight:normal;font-size:12px;line-height:16px;color:", (0, _colors.color_text_light), ";}.field-title{font-style:normal;font-weight:normal;font-size:18px;line-height:24px;}.field-button{margin-right:32px;margin-left:auto;}}.field-body-wrapper{margin:0 32px;padding:24px 0;border-top:1px solid ", (0, _colors.color_shades_dark), ";>.switch-container{margin:32px 0;}.info-section{margin-top:24px;padding:16px;background:#f8f9fa;border-radius:4px;border-left:3px solid ", (0, _colors.color_shades_dark), ";.info-label{font-weight:600;font-size:12px;color:", (0, _colors.color_text_light), ";margin-bottom:8px;text-transform:uppercase;letter-spacing:0.5px;}.info-text{font-size:13px;line-height:1.5;color:", (0, _colors.color_text_light), ";margin:0;}}}", "");
exports.default = SpecialDateFieldEditor;

},{"@babel/runtime/helpers/extends":"4iKIP","@babel/runtime/helpers/defineProperty":"9sJxO","@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","../../../constants/colors":"1p3OR","../../../components/general/ToggleIndicator":"4eej1","../../../components/forms/TextField":"7a7bh","../../../components/structure/HorizontalSeparator":"Pw3HQ","../../../components/forms/Switch":"8kkL9","./MarkdownEditorModal":"1xj9r","../../../components/general/LargeOverflowMenu":"h9O0c","../../../components/structure/ConfirmationDialog":"kx7yK","../../featureContent/components/DeleteConfirmation":"9xK2d","../../../models/extensions/fieldTypeIcons":"j8H2u","404d913ff971d808":"ch0E7","6970a3bb322a6c5e":"24JPN","c3d70250a9d3d4a7":"jk3D1","8bf42d10d8d63083":"kBbXd","1e880c0d5fa4b11d":"tAIjI","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"gYjWd":[function(require,module,exports) {
module.exports = require("ba56fdf30b8609c1").getBundleURL("kVLro") + require("820358dfbfa935b3").resolve("hehlN");

},{"ba56fdf30b8609c1":"c7Tr5","820358dfbfa935b3":"fyJL2"}],"fyhpO":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _unstated = require("unstated");
var _colors = require("../../constants/colors");
var _checkboxField = require("../../components/forms/CheckboxField");
var _checkboxFieldDefault = parcelHelpers.interopDefault(_checkboxField);
var _textField = require("../../components/forms/TextField");
var _textFieldDefault = parcelHelpers.interopDefault(_textField);
var _textAreaField = require("../../components/forms/TextAreaField");
var _textAreaFieldDefault = parcelHelpers.interopDefault(_textAreaField);
var _selectField = require("../../components/forms/SelectField");
var _selectFieldDefault = parcelHelpers.interopDefault(_selectField);
var _switch = require("../../components/forms/Switch");
var _switchDefault = parcelHelpers.interopDefault(_switch);
var _formFieldCard = require("../../components/forms/FormFieldCard");
var _formFieldCardDefault = parcelHelpers.interopDefault(_formFieldCard);
var _panelContainer = require("../../components/structure/Panels/PanelContainer");
var _panelContainerDefault = parcelHelpers.interopDefault(_panelContainer);
var _templateInstructionsPanel = require("../applicationAppliedTemplateManager/components/TemplateInstructionsPanel");
var _templateInstructionsPanelDefault = parcelHelpers.interopDefault(_templateInstructionsPanel);
var _scrollablePanelBody = require("../../components/structure/ScrollablePanelBody");
var _scrollablePanelBodyDefault = parcelHelpers.interopDefault(_scrollablePanelBody);
var _radioGroup = require("../../components/forms/RadioGroup");
var _radioGroupDefault = parcelHelpers.interopDefault(_radioGroup);
var _checkboxGroup = require("../../components/forms/CheckboxGroup");
var _checkboxGroupDefault = parcelHelpers.interopDefault(_checkboxGroup);
var _ssmlField = require("../../components/forms/SsmlField/SsmlField");
var _ssmlFieldDefault = parcelHelpers.interopDefault(_ssmlField);
var _fileUploadField = require("../../components/forms/FileUploadField");
var _fileUploadFieldDefault = parcelHelpers.interopDefault(_fileUploadField);
var _mediaContainer = require("../../state/containers/MediaContainer");
var _mediaContainerDefault = parcelHelpers.interopDefault(_mediaContainer);
var _customScrollbars = require("../../components/structure/CustomScrollbars");
var _customScrollbarsDefault = parcelHelpers.interopDefault(_customScrollbars);
var _sparkContainer = require("../../hooks/SparkContainer");
var _sparkContainerDefault = parcelHelpers.interopDefault(_sparkContainer);
var _sectionUtils = require("../../utils/sectionUtils");
var _timeRangeField = require("../../components/forms/TimeRangeField");
var _timeRangeFieldDefault = parcelHelpers.interopDefault(_timeRangeField);
var _singleDayTimeRangeField = require("../../components/forms/SingleDayTimeRangeField");
var _singleDayTimeRangeFieldDefault = parcelHelpers.interopDefault(_singleDayTimeRangeField);
var _specialDateField = require("../../components/forms/SpecialDateField");
var _specialDateFieldDefault = parcelHelpers.interopDefault(_specialDateField);
var _fieldTypeUtils = require("../../utils/fieldTypeUtils");
var _applicationVariablesContainer = require("../../hooks/ApplicationVariablesContainer");
var _applicationVariablesContainerDefault = parcelHelpers.interopDefault(_applicationVariablesContainer);
var _saveFieldVariationModal = require("../../components/forms/SaveFieldVariationModal");
var _saveFieldVariationModalDefault = parcelHelpers.interopDefault(_saveFieldVariationModal);
var _viewFieldVariationsModal = require("../../components/forms/ViewFieldVariationsModal");
var _viewFieldVariationsModalDefault = parcelHelpers.interopDefault(_viewFieldVariationsModal);
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const AppliedApplicationTemplateSectionForm = (props)=>{
    const sparkContainer = (0, _sparkContainerDefault.default).useContainer();
    const variablesContainer = (0, _applicationVariablesContainerDefault.default).useContainer();
    const [saveVariationModalVisible, setSaveVariationModalVisible] = (0, _react1.useState)(false);
    const [viewVariationsModalVisible, setViewVariationsModalVisible] = (0, _react1.useState)(false);
    const [selectedField, setSelectedField] = (0, _react1.useState)(null);
    // Load application variables when component mounts or applicationId changes
    (0, _react1.useEffect)(()=>{
        if (props.applicationId) variablesContainer.loadApplicationVariablesByApplicationId(props.applicationId);
    }, [
        props.applicationId
    ]);
    const isRecentlyAddedModuleFormField = (field)=>{
        return props.recentlyAddedModuleFormFields?.some((f)=>f.id == field.id);
    };
    const getValue = (field)=>{
        const foundField = props.values?.find((v)=>field?.name && v?.dynamicFormFieldName == field?.name || field?.id && v?.templateFormFieldId == field?.id);
        return foundField?.value;
    };
    const getFieldName = (field)=>{
        return field.name ?? field.id;
    };
    const handleChange = (field, value)=>{
        props.onFieldValueChange(field, value.toString());
    };
    const handleReset = (field)=>{
        if (field.defaultValue !== undefined) props.onFieldValueChange(field, field.defaultValue);
    };
    // Get variations for a specific field
    const getFieldVariations = (field)=>{
        const prefix = `Form_Field_${field.title}_`;
        return variablesContainer.applicationVariables.filter((v)=>v.name.startsWith(prefix));
    };
    // Check if field has any saved variations
    const hasFieldVariations = (field)=>{
        return getFieldVariations(field).length > 0;
    };
    // Handle opening save variation modal
    const handleOpenSaveVariation = (field)=>{
        setSelectedField(field);
        setSaveVariationModalVisible(true);
    };
    // Handle opening view variations modal
    const handleOpenViewVariations = (field)=>{
        setSelectedField(field);
        setViewVariationsModalVisible(true);
    };
    // Handle selecting a variation to use
    const handleSelectVariation = (variation)=>{
        if (selectedField) props.onFieldValueChange(selectedField, variation.value);
        setViewVariationsModalVisible(false);
        setSelectedField(null);
    };
    const renderCheckbox = (field)=>{
        return (0, _react.jsx)("div", null, (0, _react.jsx)("div", {
            className: label
        }, field.label), (0, _react.jsx)((0, _checkboxFieldDefault.default), {
            key: field.id ?? field.name,
            name: `fields.${getFieldName(field)}`,
            checked: getValue(field) == "true",
            onChange: (e)=>handleChange(field, e.target.checked.toString()),
            className: checkboxField
        }));
    };
    const renderSwitch = (field)=>{
        return (0, _react.jsx)("div", null, (0, _react.jsx)("div", {
            className: label
        }, field.label), (0, _react.jsx)((0, _switchDefault.default), {
            className: switchContainer,
            key: field.id ?? field.name,
            name: `fields.${getFieldName(field)}`,
            onChange: (checked)=>handleChange(field, checked.toString()),
            checked: getValue(field) == "true",
            label: field.label
        }));
    };
    const renderShortText = (field, type)=>{
        if ((0, _fieldTypeUtils.isDeprecatedSingleDayTimeRangeField)(field, props.appContainer, props.appliedAppTemplate)) return (0, _react.jsx)((0, _singleDayTimeRangeFieldDefault.default), {
            key: field.id ?? field.name,
            name: `fields.${getFieldName(field)}`,
            label: field.label,
            value: getValue(field) ?? field.defaultValue,
            onChange: (value)=>handleChange(field, value),
            onBlur: ()=>{},
            onValidationChange: (hasErrors)=>{
                if (props.onFieldValidationChange) props.onFieldValidationChange(field.id ?? field.name, hasErrors);
            }
        });
        if ((0, _fieldTypeUtils.isDeprecatedSpecialDateField)(field, props.appContainer, props.appliedAppTemplate)) return (0, _react.jsx)((0, _specialDateFieldDefault.default), {
            key: field.id ?? field.name,
            name: `fields.${getFieldName(field)}`,
            label: field.label,
            value: getValue(field) ?? field.defaultValue,
            onChange: (value)=>handleChange(field, value),
            onBlur: ()=>{},
            onValidationChange: (hasErrors)=>{
                if (props.onFieldValidationChange) props.onFieldValidationChange(field.id ?? field.name, hasErrors);
            }
        });
        return (0, _react.jsx)((0, _textFieldDefault.default), {
            key: field.id ?? field.name,
            name: `fields.${getFieldName(field)}`,
            value: getValue(field) ?? field.defaultValue,
            defaultValue: field.defaultValue,
            type: type,
            onChange: (e)=>handleChange(field, e.target.value),
            onBlur: ()=>{},
            onReset: ()=>handleReset(field),
            label: field.label,
            placeholder: field.placeholder
        });
    };
    const renderLongText = (field)=>{
        return (0, _react.jsx)((0, _textAreaFieldDefault.default), {
            showResponseVariableTest: true,
            key: field.id ?? field.name,
            name: `fields.${getFieldName(field)}`,
            value: getValue(field) ?? field.defaultValue,
            defaultValue: field.defaultValue,
            onChange: (e)=>handleChange(field, e.target.value),
            onBlur: ()=>{},
            onReset: ()=>handleReset(field),
            label: field.label,
            placeholder: field.placeholder
        });
    };
    const renderSsmlField = (field)=>{
        return (0, _react.jsx)((0, _ssmlFieldDefault.default), {
            key: field.id ?? field.name,
            name: `fields.${getFieldName(field)}`,
            value: getValue(field) ?? field.defaultValue,
            onChange: (value)=>handleChange(field, value),
            onBlur: ()=>{},
            label: field.label,
            placeholder: field.placeholder,
            applicationId: props.applicationId
        });
    };
    const renderSelect = (field)=>{
        return (0, _react.jsx)((0, _selectFieldDefault.default), {
            key: field.id ?? field.name,
            className: selectField,
            onChange: (e)=>handleChange(field, e.value),
            onBlur: ()=>{},
            name: `fields.${getFieldName(field)}`,
            value: getValue(field),
            label: field.label,
            placeholder: field.placeholder,
            options: field.options.map((o)=>({
                    value: o.value,
                    label: o.label
                }))
        });
    };
    const renderCheckboxGroup = (field)=>{
        // note: checkboxes use pipe delimited values from the core value
        return (0, _react.jsx)((0, _checkboxGroupDefault.default), {
            key: field.id ?? field.name,
            onChange: (e, c)=>{
                var val = getValue(field);
                if (c) val += `|${e.value}`;
                else val = val.replace(e.value, "");
                handleChange(field, val);
            },
            values: getValue(field)?.split("|"),
            options: field.options.map((o)=>({
                    value: o.value,
                    label: o.label
                }))
        });
    };
    const renderRadioGroup = (field)=>{
        return (0, _react.jsx)((0, _radioGroupDefault.default), {
            key: field.id ?? field.name,
            onChange: (e)=>handleChange(field, e.value),
            value: getValue(field),
            options: field.options.map((o)=>({
                    value: o.value,
                    label: o.label
                }))
        });
    };
    const renderFileUpload = (field)=>{
        return (0, _react.jsx)((0, _unstated.Subscribe), {
            to: [
                (0, _mediaContainerDefault.default)
            ]
        }, (mediaContainer)=>(0, _react.jsx)((0, _fileUploadFieldDefault.default), {
                onChange: (e)=>handleChange(field, e.url),
                disabled: false,
                field: field,
                mediaContainer: mediaContainer,
                applicationId: props.applicationId,
                value: getValue(field),
                preview: props.preview
            }));
    };
    const renderTimeRange = (field)=>{
        return (0, _react.jsx)((0, _timeRangeFieldDefault.default), {
            key: field.id ?? field.name,
            name: `fields.${getFieldName(field)}`,
            label: field.label,
            value: getValue(field) ?? field.defaultValue,
            onChange: (value)=>handleChange(field, value),
            onBlur: ()=>{}
        });
    };
    const renderSingleDayTimeRange = (field)=>{
        return (0, _react.jsx)((0, _singleDayTimeRangeFieldDefault.default), {
            key: field.id ?? field.name,
            name: `fields.${getFieldName(field)}`,
            label: field.label,
            value: getValue(field) ?? field.defaultValue,
            onChange: (value)=>handleChange(field, value),
            onBlur: ()=>{},
            onValidationChange: (hasErrors)=>{
                if (props.onFieldValidationChange) props.onFieldValidationChange(field.id ?? field.name, hasErrors);
            }
        });
    };
    const renderSpecialDate = (field)=>{
        return (0, _react.jsx)((0, _specialDateFieldDefault.default), {
            key: field.id ?? field.name,
            name: `fields.${getFieldName(field)}`,
            label: field.label,
            value: getValue(field) ?? field.defaultValue,
            onChange: (value)=>handleChange(field, value),
            onBlur: ()=>{},
            onValidationChange: (hasErrors)=>{
                if (props.onFieldValidationChange) props.onFieldValidationChange(field.id ?? field.name, hasErrors);
            }
        });
    };
    // Check if field type supports variations (text-based fields only)
    const supportsVariations = (field)=>{
        const textBasedFieldTypes = [
            "ShortTextField",
            "NumberTextField",
            "DateTextField",
            "LongTextField",
            "SSMLField",
            "SSMLTextField"
        ];
        return textBasedFieldTypes.includes(field.fieldType);
    };
    const renderSetupProperty = (field)=>{
        switch(field.fieldType){
            case "ShortTextField":
                return renderShortText(field);
            case "NumberTextField":
                return renderShortText(field, "number");
            case "DateTextField":
                return renderShortText(field, "date");
            case "LongTextField":
                return renderLongText(field);
            case "SwitchField":
                return renderSwitch(field);
            case "SelectField":
                return renderSelect(field);
            case "CheckboxGroupField":
                return renderCheckboxGroup(field);
            case "RadioGroupField":
                return renderRadioGroup(field);
            case "CheckboxField":
                return renderCheckbox(field);
            case "FileUploadField":
                return renderFileUpload(field);
            case "TimeRangeField":
                return renderTimeRange(field);
            case "SingleDayTimeRangeField":
                return renderSingleDayTimeRange(field);
            case "SpecialDateField":
                return renderSpecialDate(field);
            case "SSMLField":
            case "SSMLTextField":
                return renderSsmlField(field);
        }
    };
    const renderFields = ()=>{
        // Use the consolidated helper function to get visible fields
        // Note: In non-Spark contexts, showAdminFields defaults to true
        const showAdmin = sparkContainer.inSpark ? props.showAdminFields ?? false : true;
        const fields = (0, _sectionUtils.getVisibleFields)(props.section, showAdmin, props.values);
        return (0, _react.jsx)("div", {
            className: setupSectionContainer
        }, (0, _react.jsx)("h3", null, props.section.title), fields.map((p, subIdx)=>{
            const fieldSupportsVariations = supportsVariations(p);
            return (0, _react.jsx)("div", {
                key: `setupSection_${subIdx}`,
                className: setupPropertyContainer
            }, (0, _react.jsx)((0, _formFieldCardDefault.default), {
                title: p.title,
                tip: p.tip,
                required: p.isRequired,
                isRecentlyAddedModuleFormField: isRecentlyAddedModuleFormField(p),
                hasVariations: fieldSupportsVariations ? hasFieldVariations(p) : false,
                onSaveVariation: fieldSupportsVariations ? ()=>handleOpenSaveVariation(p) : undefined,
                onViewVariations: fieldSupportsVariations ? ()=>handleOpenViewVariations(p) : undefined
            }, renderSetupProperty(p)));
        }));
    };
    return (0, _react.jsx)((0, _reactDefault.default).Fragment, null, props.fieldsOnly && renderFields(), (0, _react.jsx)((0, _panelContainerDefault.default), {
        className: panelContainerStyle
    }, (0, _react.jsx)((0, _customScrollbarsDefault.default), {
        autoHide: true,
        autoHeight: true,
        autoHeightMin: "calc(100vh - 136px)",
        autoHeightMax: "calc(100vh - 136px)"
    }, renderFields()), props.section.instructionsMarkdown && (0, _react.jsx)((0, _scrollablePanelBodyDefault.default), {
        className: previewStyle
    }, (0, _react.jsx)((0, _templateInstructionsPanelDefault.default), {
        title: "Preview",
        instructionsMarkdown: props.section.instructionsMarkdown
    }))), selectedField && (0, _react.jsx)((0, _reactDefault.default).Fragment, null, (0, _react.jsx)((0, _saveFieldVariationModalDefault.default), {
        isVisible: saveVariationModalVisible,
        fieldTitle: selectedField.title,
        fieldValue: getValue(selectedField) || "",
        onClose: ()=>{
            setSaveVariationModalVisible(false);
            setSelectedField(null);
        },
        applicationId: props.applicationId
    }), (0, _react.jsx)((0, _viewFieldVariationsModalDefault.default), {
        isVisible: viewVariationsModalVisible,
        fieldTitle: selectedField.title,
        variations: getFieldVariations(selectedField),
        onClose: ()=>{
            setViewVariationsModalVisible(false);
            setSelectedField(null);
        },
        onSelectVariation: handleSelectVariation
    })));
};
const panelContainerStyle = /*#__PURE__*/ (0, _css.css)("", "");
const previewStyle = /*#__PURE__*/ (0, _css.css)({
    name: "13udsys",
    styles: "height:100%"
});
const selectField = /*#__PURE__*/ (0, _css.css)({
    name: "de9hf",
    styles: "padding-top:16px"
});
const checkboxField = /*#__PURE__*/ (0, _css.css)({
    name: "1lt7ksy",
    styles: "padding-left:16px;.tooltip{margin-top:3px;}"
});
const setupSectionContainer = /*#__PURE__*/ (0, _css.css)({
    name: "1r82pz8",
    styles: "padding:32px;h3{margin-bottom:16px;font-style:normal;font-weight:normal;font-size:18px;line-height:24px;}"
});
const label = /*#__PURE__*/ (0, _css.css)({
    name: "18xvwxb",
    styles: "font-family:Muli;font-size:14px;font-weight:600;font-style:normal;font-stretch:normal;letter-spacing:normal;text-align:left;margin:8px 16px"
});
const switchContainer = /*#__PURE__*/ (0, _css.css)({
    name: "1s22u92",
    styles: "margin-bottom:32px"
});
const setupPropertyContainer = /*#__PURE__*/ (0, _css.css)("padding:16px 0px;position:relative;.field-triangle{position:absolute;width:24px;height:24px;background:", (0, _colors.color_shades_lighter), ";right:-44px;top:64px;transform:rotate(45deg);border-left:1px solid ", (0, _colors.color_shades_dark), ";border-bottom:1px solid ", (0, _colors.color_shades_dark), ";}", "");
exports.default = AppliedApplicationTemplateSectionForm;

},{"@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","unstated":"grh7p","../../constants/colors":"1p3OR","../../components/forms/CheckboxField":"3S5Oy","../../components/forms/TextField":"7a7bh","../../components/forms/TextAreaField":"fE54C","../../components/forms/SelectField":"405B3","../../components/forms/Switch":"8kkL9","../../components/forms/FormFieldCard":"bDrD9","../../components/structure/Panels/PanelContainer":"9R2lE","../applicationAppliedTemplateManager/components/TemplateInstructionsPanel":"ddl48","../../components/structure/ScrollablePanelBody":"6LRg3","../../components/forms/RadioGroup":"eiGrn","../../components/forms/CheckboxGroup":"2sSdD","../../components/forms/SsmlField/SsmlField":"cvL6K","../../components/forms/FileUploadField":"l7aUX","../../state/containers/MediaContainer":"ch6Xu","../../components/structure/CustomScrollbars":"50vFq","../../hooks/SparkContainer":"jzXzx","../../utils/sectionUtils":"1hn3I","../../components/forms/TimeRangeField":"7FNXe","../../components/forms/SingleDayTimeRangeField":"8CHRX","../../components/forms/SpecialDateField":"dZrB4","../../utils/fieldTypeUtils":"ckHtT","../../hooks/ApplicationVariablesContainer":"65mmm","../../components/forms/SaveFieldVariationModal":"l2LQ4","../../components/forms/ViewFieldVariationsModal":"kidfh","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"bDrD9":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _base = require("@emotion/styled/base");
var _baseDefault = parcelHelpers.interopDefault(_base);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _colors = require("../../constants/colors");
var _tooltipWrapper = require("../general/TooltipWrapper");
var _tooltipWrapperDefault = parcelHelpers.interopDefault(_tooltipWrapper);
var _button = require("../general/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const alertIcon = require("1a2a6a7260f5220e");
const FormFieldCard = (props)=>{
    return (0, _react.jsx)("div", {
        className: `${containerStyle} ${props.className}`
    }, (0, _react.jsx)("div", {
        className: "card-header-wrapper"
    }, (0, _react.jsx)("p", {
        className: "card-title"
    }, props.title), (0, _react.jsx)("div", {
        className: "header-actions"
    }, props.onSaveVariation && (0, _react.jsx)((0, _tooltipWrapperDefault.default), {
        text: "Save current value as a variation"
    }, (0, _react.jsx)(VariationButton, {
        themes: [
            "secondary-small"
        ],
        text: "Create Variation",
        type: "button",
        onClick: (e)=>{
            e.preventDefault();
            e.stopPropagation();
            props.onSaveVariation();
        }
    })), props.hasVariations && props.onViewVariations && (0, _react.jsx)((0, _tooltipWrapperDefault.default), {
        text: "View and select saved variations"
    }, (0, _react.jsx)(VariationButton, {
        themes: [
            "white-small"
        ],
        text: "View Variations",
        type: "button",
        onClick: (e)=>{
            e.preventDefault();
            e.stopPropagation();
            props.onViewVariations();
        }
    })), props.required && (0, _react.jsx)((0, _tooltipWrapperDefault.default), {
        text: "Required field"
    }, (0, _react.jsx)("p", {
        className: "required-indicator-label"
    }, (0, _react.jsx)("span", {
        className: "required-indicator"
    }, "*"))))), (0, _react.jsx)("div", {
        className: "card-body-wrapper"
    }, (0, _react.jsx)("p", {
        className: "card-tip"
    }, props.tip), props.children, props.isRecentlyAddedModuleFormField && (0, _react.jsx)(ErrorStyle, null, (0, _react.jsx)(AlertIconStyle, {
        src: alertIcon
    }), "Please review this recently added or updated form field. Edit the the value or to accept the default, simply select the 'Save & Next' button above.")));
};
const ErrorStyle = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1fx6hps2"
})('display:flex;align-items:center;justify-content:flex-start;font-family:Muli,"sans-serif";font-weight:normal;color:', (0, _colors.color_shades_darkest), ";background-color:", (0, _colors.color_colors_gold_background), ";border:1px solid ", (0, _colors.color_colors_gold), ";border-radius:8px;flex-grow:1;padding:8px 16px;margin:8px 0;font-size:14px;");
const AlertIconStyle = /*#__PURE__*/ (0, _baseDefault.default)("img", {
    target: "e1fx6hps1"
})({
    name: "1oaeivz",
    styles: "margin-right:8px"
});
const VariationButton = /*#__PURE__*/ (0, _baseDefault.default)((0, _buttonDefault.default), {
    target: "e1fx6hps0"
})({
    name: "nykhhs",
    styles: "margin-left:0px;font-size:12px;padding:4px 12px;height:auto;min-height:auto"
});
const containerStyle = /*#__PURE__*/ (0, _css.css)("background:white;border:1px solid ", (0, _colors.color_shades_dark), ";box-sizing:border-box;border-radius:8px;padding:32px;.card-header-wrapper{display:flex;align-items:center;justify-content:space-between;color:", (0, _colors.color_text_default), ";padding-bottom:16px;border-bottom:1px solid ", (0, _colors.color_shades_dark), ";.card-title{font-style:normal;font-weight:normal;font-size:18px;line-height:24px;flex:1;}.header-actions{display:flex;align-items:center;gap:8px;margin-left:16px;}.required-indicator-label{font-style:normal;font-weight:normal;font-size:12px;margin:0;.required-indicator{font-style:normal;font-weight:normal;font-size:24px;color:", (0, _colors.color_colors_decline), ";}}}.card-tip{margin:16px 0;color:", (0, _colors.color_text_light), ";font-style:normal;font-weight:normal;font-size:14px;line-height:20px;}", "");
exports.default = FormFieldCard;

},{"@emotion/styled/base":"lSuFu","@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","../../constants/colors":"1p3OR","../general/TooltipWrapper":"53pWd","../general/Button":"6ymxN","1a2a6a7260f5220e":"etYyQ","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"etYyQ":[function(require,module,exports) {
module.exports = require("98ac03ef0e9790f1").getBundleURL("kVLro") + require("b7f30adec48a60c0").resolve("aihcn");

},{"98ac03ef0e9790f1":"c7Tr5","b7f30adec48a60c0":"fyJL2"}],"ddl48":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _colors = require("../../../constants/colors");
var _reactMarkdown = require("react-markdown");
var _reactMarkdownDefault = parcelHelpers.interopDefault(_reactMarkdown);
const linkRenderer = (props)=>{
    return (0, _react.jsx)("a", {
        href: props.href,
        target: "_blank"
    }, props.children);
};
const TemplateInstructionsPanel = (props)=>(0, _react.jsx)("div", {
        className: containerStyle
    }, (0, _react.jsx)("h3", null, props.title), (0, _react.jsx)("div", {
        className: "instructions-wrapper"
    }, props.instructionsMarkdown ? (0, _react.jsx)((0, _reactMarkdownDefault.default), {
        className: "instructions",
        source: props.instructionsMarkdown,
        renderers: {
            link: linkRenderer
        }
    }) : (0, _react.jsx)("p", null, props.emptyText ?? "No preview available")));
const containerStyle = /*#__PURE__*/ (0, _css.css)("flex:1;background:", (0, _colors.color_shades_lighter), ";padding:32px 32px 164px 32px;border-left:1px solid ", (0, _colors.color_shades_dark), ";min-height:100%;h3{margin-bottom:32px;font-style:normal;font-weight:normal;font-size:18px;line-height:24px;}.instructions-wrapper{background:white;border:1px solid ", (0, _colors.color_shades_dark), ";border-radius:8px;padding:32px;margin-bottom:32px;}.instructions{font-family:Muli;font-style:normal;font-stretch:normal;ol{margin-left:16px;}ul{margin-left:16px;}p{margin:16px 0px;}h1{margin-bottom:16px;margin-top:16px;font-size:24px;font-weight:bold;}h2{margin-bottom:16px;margin-top:16px;font-size:20px;font-weight:bold;}h3{margin-bottom:16px;margin-top:16px;font-size:18px;font-weight:bold;}h4{margin-bottom:16px;margin-top:16px;font-size:16px;font-weight:bold;}h5{margin-bottom:16px;margin-top:16px;font-size:14px;font-weight:bold italic;}h6{margin-bottom:16px;margin-top:16px;font-size:14px;font-weight:bold;}}", "");
exports.default = TemplateInstructionsPanel;

},{"@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","../../../constants/colors":"1p3OR","react-markdown":"6G7AH","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2sSdD":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _colors = require("../../constants/colors");
var _checkIndicator = require("./CheckIndicator");
var _checkIndicatorDefault = parcelHelpers.interopDefault(_checkIndicator);
class CheckboxGroup extends (0, _reactDefault.default).Component {
    handleOptionSelected(option, checked) {
        if (this.props.onChange) this.props.onChange(option, checked);
    }
    render() {
        return (0, _react.jsx)("div", {
            className: containerStyle
        }, this.props.options.map((option, index)=>(0, _react.jsx)("div", {
                className: "check-option",
                key: index,
                onClick: this.handleOptionSelected.bind(this, option, !this.props.values?.some((v)=>v == option.value))
            }, (0, _react.jsx)((0, _checkIndicatorDefault.default), {
                checked: this.props.values?.some((v)=>v == option.value)
            }), option.icon ? (0, _react.jsx)("img", {
                className: "option-icon",
                src: option.icon
            }) : null, (0, _react.jsx)("span", null, option.label))));
    }
}
const containerStyle = /*#__PURE__*/ (0, _css.css)("margin:16px 0;>*{}.check-option{margin:8px 0;display:flex;flex-direction:row;align-items:center;cursor:pointer;span{font-family:Muli;font-size:14px;font-weight:normal;font-style:normal;font-stretch:normal;line-height:normal;letter-spacing:normal;color:", (0, _colors.dark_grey_blue), ";margin-left:8px;word-break:break-all;}}.option-icon{margin-left:16px;}", "");
exports.default = CheckboxGroup;

},{"@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","../../constants/colors":"1p3OR","./CheckIndicator":"8zBm6","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"l7aUX":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _base = require("@emotion/styled/base");
var _baseDefault = parcelHelpers.interopDefault(_base);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _reactDropzone = require("react-dropzone");
var _reactDropzoneDefault = parcelHelpers.interopDefault(_reactDropzone);
var _colors = require("../../constants/colors");
var _button = require("../../components/general/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _pageError = require("../general/PageError");
var _pageErrorDefault = parcelHelpers.interopDefault(_pageError);
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const cloudIcon = require("f602b4a23478fd7b");
const closeIcon = require("a4baa1de6c86f3a7");
const FieldUploadField = (props)=>{
    const [file, setFile] = (0, _react1.useState)(null);
    const [errors, setErrors] = (0, _react1.useState)(null);
    const clearFile = ()=>{
        setFile(null);
        props.onChange({
            url: null
        });
    };
    (0, _react1.useEffect)(()=>{
        if (props.value != null) //parses name from s3 file location url
        setFile(props.value.substring(props.value.lastIndexOf("/") + 1, props.value.length));
    }, []);
    async function handleFilePicked(files) {
        if (files.length > 0) {
            setFile(files[0].name);
            let result = await props.mediaContainer.uploadMediaItem(props.applicationId, files[0].name, files[0], "", ()=>{});
            if (!result.errors.length) {
                props.onChange(result.data);
                setErrors(null);
            } else setErrors(result.errors);
        }
    }
    return (0, _react.jsx)("div", {
        className: `${containerStyle} ${props.disabled ? "disabled" : ""}`
    }, (0, _react.jsx)(FileSizeInfoDiv, null, (0, _react.jsx)(SubLabel, null, "File under 10 MB")), (0, _react.jsx)("div", null, (0, _react.jsx)((0, _reactDropzoneDefault.default), {
        onDrop: handleFilePicked.bind(undefined),
        className: fieldContainer,
        accept: props.field?.fileFormats ? props.field.fileFormats : props.fileFormats,
        disabled: props.preview
    }, (0, _react.jsx)(ImgContainer, null, (0, _react.jsx)("img", {
        src: cloudIcon
    })), (0, _react.jsx)(TextContainer, null, (0, _react.jsx)("p", null, "Drag a file here")), (0, _react.jsx)(OrLabel, null, (0, _react.jsx)("p", null, "or")), (0, _react.jsx)(ButtonStyleContainer, null, (0, _react.jsx)((0, _buttonDefault.default), {
        className: buttonStyle,
        themes: [
            "primary-small",
            "start"
        ],
        text: "Select Local File",
        type: "button",
        disabled: props.preview
    })))), props.field?.fileFormats && (0, _react.jsx)(SubLabelContainer, null, (0, _react.jsx)(SubLabel, null, "File formats supported: ", props.field.fileFormats, " ")), props.fileFormats && (0, _react.jsx)(SubLabelContainer, null, (0, _react.jsx)(SubLabel, null, "File formats supported: ", props.fileFormats, " ")), props.field?.suggestions && (0, _react.jsx)(SubLabelContainer, null, (0, _react.jsx)(SubLabel, null, "Suggestions: ", props.field.suggestions)), file && (0, _react.jsx)(SubLabelContainer, null, (0, _react.jsx)("label", null, "Current file selected: ", file), (0, _react.jsx)(CloseIcon, {
        src: closeIcon,
        onClick: ()=>clearFile()
    })), (0, _react.jsx)((0, _pageErrorDefault.default), {
        errors: errors
    }));
};
const containerStyle = /*#__PURE__*/ (0, _css.css)({
    name: "11j4wuo",
    styles: "margin-bottom:24px;flex:1;&.tight{margin-bottom:16px;label{margin:8px 16px 0 16px;}}"
});
const CloseIcon = /*#__PURE__*/ (0, _baseDefault.default)("img", {
    target: "ezb3htx7"
})({
    name: "wl3sam",
    styles: "height:14px;width:14px;margin-left:16px;cursor:pointer;vertical-align:middle"
});
const FileSizeInfoDiv = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "ezb3htx6"
})({
    name: "8xhv84",
    styles: "width:100%;display:flex"
});
const ButtonStyleContainer = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "ezb3htx5"
})({
    name: "1v3vpfk",
    styles: "justify-content:center;display:flex;width:100%;grid-row:4/span 1"
});
const buttonStyle = /*#__PURE__*/ (0, _css.css)({
    name: "1bluln9",
    styles: "margin-right:auto;margin-left:auto"
});
const SubLabel = /*#__PURE__*/ (0, _baseDefault.default)("label", {
    target: "ezb3htx4"
})({
    name: "xnpvuf",
    styles: "font-size:12px;font-weight:100"
});
const OrLabel = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "ezb3htx3"
})({
    name: "y7ifss",
    styles: "font-size:12px;font-weight:100;justify-content:center;display:flex;width:100%;grid-row:3/span 1"
});
const SubLabelContainer = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "ezb3htx2"
})({
    name: "icns00",
    styles: "padding-top:10px"
});
const fieldContainer = /*#__PURE__*/ (0, _css.css)("display:flex;align-items:center;height:280px;width:100%;display:grid;grid-template-rows:160px 20px 20px 50px;border-radius:8px;border:dashed 4px ", (0, _colors.color_shades_dark), ";background:white;margin-top:10px;img{margin:16px;}&.disabled{background:", (0, _colors.pale_grey), ";input{background:", (0, _colors.pale_grey), ";}}", "");
const ImgContainer = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "ezb3htx1"
})({
    name: "1io5hd4",
    styles: "display:flex;width:100%;justify-content:center;align-items:center;grid-row:1/span 1"
});
const TextContainer = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "ezb3htx0"
})({
    name: "xxtjcx",
    styles: "display:flex;width:100%;justify-content:center;grid-row:2/span 1"
});
exports.default = FieldUploadField;

},{"@emotion/styled/base":"lSuFu","@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","react-dropzone":"46RRi","../../constants/colors":"1p3OR","../../components/general/Button":"6ymxN","../general/PageError":"ezFTm","f602b4a23478fd7b":"fc0I5","a4baa1de6c86f3a7":"93VwA","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1hn3I":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isAdminField", ()=>isAdminField);
parcelHelpers.export(exports, "fieldValueMatchesAssociatedVariable", ()=>fieldValueMatchesAssociatedVariable);
parcelHelpers.export(exports, "isFieldVisible", ()=>isFieldVisible);
parcelHelpers.export(exports, "getFieldValue", ()=>getFieldValue);
parcelHelpers.export(exports, "getVisibleFields", ()=>getVisibleFields);
parcelHelpers.export(exports, "sectionHasVisibleFields", ()=>sectionHasVisibleFields);
parcelHelpers.export(exports, "combineSections", ()=>combineSections);
parcelHelpers.export(exports, "getCompletionStatus", ()=>getCompletionStatus);
parcelHelpers.export(exports, "getNextSection", ()=>getNextSection);
parcelHelpers.export(exports, "getPreviousSection", ()=>getPreviousSection);
parcelHelpers.export(exports, "findActiveSectionIndex", ()=>findActiveSectionIndex);
parcelHelpers.export(exports, "getPageCount", ()=>getPageCount);
parcelHelpers.export(exports, "getCurrentPageNumber", ()=>getCurrentPageNumber);
parcelHelpers.export(exports, "getTemplateSectionsOnly", ()=>getTemplateSectionsOnly);
var _lodash = require("lodash");
const isAdminField = (field)=>{
    return field.title?.toLowerCase().startsWith("admin") ?? false;
};
const fieldValueMatchesAssociatedVariable = (field, fieldValue)=>{
    return !!(field.associatedVariable && field.associatedVariable === fieldValue);
};
const isFieldVisible = (field, fieldValue, showAdminFields = true)=>{
    // Hide admin fields if showAdminFields is false
    if (!showAdminFields && isAdminField(field)) return false;
    // Hide field if it has an associatedVariable and the value matches it
    if (fieldValueMatchesAssociatedVariable(field, fieldValue) && fieldValue !== field?.defaultValue) return false;
    return true;
};
const getFieldValue = (field, templateFormFieldValues)=>{
    return templateFormFieldValues?.find((v)=>field?.name && v?.dynamicFormFieldName === field?.name || field?.id && v?.templateFormFieldId === field?.id)?.value;
};
const getVisibleFields = (section, showAdminFields, templateFormFieldValues)=>{
    const fields = section?.templateFormFields ?? section?.dynamicFormFields ?? [];
    return fields.filter((field)=>{
        const fieldValue = getFieldValue(field, templateFormFieldValues);
        return isFieldVisible(field, fieldValue, showAdminFields);
    });
};
const sectionHasVisibleFields = (section, showAdminFields, templateFormFieldValues)=>{
    const visibleFields = getVisibleFields(section, showAdminFields, templateFormFieldValues);
    return visibleFields.length > 0;
};
const combineSections = (options)=>{
    const { sections, appendedSections, showAdminFields, importedFormFields, appliedAppTemplateContainer } = options;
    // Sort template sections by priority
    const sortedTemplateSections = _lodash.sortBy(sections ?? [], (s)=>s?.section?.priority);
    // Get template form field values for visibility checking
    const getTemplateFormFieldValues = (section)=>{
        if (!appliedAppTemplateContainer || !section.appliedTemplateId) return [];
        const appliedTemplate = appliedAppTemplateContainer.state.appliedTemplates?.find((at)=>at.id === section.appliedTemplateId);
        return appliedTemplate?.templateFormFieldValues ?? [];
    };
    // Filter out admin sections if needed and sections with no visible fields
    const filteredTemplateSections = sortedTemplateSections.filter((section)=>{
        // Filter admin sections
        if (!showAdminFields && section.section?.title?.toLowerCase().startsWith("admin")) return false;
        // Filter sections with no visible fields
        const templateFormFieldValues = getTemplateFormFieldValues(section);
        return sectionHasVisibleFields(section.section, showAdminFields, templateFormFieldValues);
    });
    const combined = [];
    // Add auto-generate section if it exists (always first)
    const autoGenerateSection = appendedSections?.find((section)=>section.name === "Auto-Generate Responses");
    if (autoGenerateSection) combined.push({
        ...autoGenerateSection,
        sectionType: "auto-generate",
        isComplete: autoGenerateSection.isComplete,
        isSelected: autoGenerateSection.isSelected
    });
    // Add filtered template sections
    filteredTemplateSections.forEach((section)=>{
        const isComplete = getCompletionStatus(section, importedFormFields, appliedAppTemplateContainer);
        combined.push({
            ...section,
            sectionType: "template",
            isComplete,
            priority: section.section?.priority
        });
    });
    // Add other appended sections (excluding auto-generate)
    const otherAppendedSections = appendedSections?.filter((section)=>section.name !== "Auto-Generate Responses");
    if (otherAppendedSections) otherAppendedSections.forEach((section)=>{
        combined.push({
            ...section,
            sectionType: "appended",
            isComplete: section.isComplete,
            isSelected: section.isSelected
        });
    });
    return combined;
};
const getCompletionStatus = (section, importedFormFields, appliedAppTemplateContainer)=>{
    if (!appliedAppTemplateContainer) return section.isComplete ?? false;
    // Always use the container's standard completion check for consistency
    const appliedTemplate = appliedAppTemplateContainer.state.appliedTemplates?.find((at)=>at.id === section.appliedTemplateId);
    if (!appliedTemplate) return section.isComplete ?? false;
    return appliedAppTemplateContainer.getIsSectionOfCurrentComplete(appliedTemplate, section.section);
};
const getNextSection = (allSections, currentIndex)=>{
    if (currentIndex === -1) // No current section, go to first section
    return allSections.length > 0 ? allSections[0] : "finish";
    else if (currentIndex >= allSections.length - 1) // Last section, go to finish
    return "finish";
    else // Navigate to next section
    return allSections[currentIndex + 1];
};
const getPreviousSection = (allSections, currentIndex, isFinishSelected)=>{
    if (currentIndex <= 0) // First section or no section, go to start
    return "start";
    else if (currentIndex === -1 && isFinishSelected) // Coming back from finish section
    return allSections.length > 0 ? allSections[allSections.length - 1] : "start";
    else // Navigate to previous section
    return allSections[currentIndex - 1];
};
const findActiveSectionIndex = (allSections, activeSection)=>{
    return allSections.findIndex((s)=>{
        if (s.sectionType === "template") {
            // Handle both direct section objects and currentSection objects with appliedTemplateId
            if (activeSection?.appliedTemplateId && activeSection?.section) // This is a currentSection object from ApplicationManagerContent
            // Match by appliedTemplateId AND section properties to ensure uniqueness
            return activeSection.appliedTemplateId === s.appliedTemplateId && (activeSection.section?.name && s?.section?.name === activeSection.section?.name || activeSection.section?.id && s.section?.id === activeSection.section?.id || activeSection.section?.title && s?.section?.title === activeSection.section?.title);
            else {
                // This is a direct section object - still check appliedTemplateId if available
                const activeSectionDetails = activeSection?.section ?? activeSection;
                const sameTemplate = !activeSection?.appliedTemplateId || activeSection.appliedTemplateId === s.appliedTemplateId;
                if (!sameTemplate) return false;
                return activeSectionDetails?.name && s?.section?.name === activeSectionDetails.name || activeSectionDetails?.id && s.section?.id === activeSectionDetails.id || activeSectionDetails?.title && s?.section?.title === activeSectionDetails.title;
            }
        } else // For appended sections, check if it's the same object or has matching properties
        return activeSection === s || activeSection?.name && s?.name === activeSection?.name || activeSection?.id && s?.id === activeSection?.id;
    });
};
const getPageCount = (allSections)=>{
    // Add 1 for the Review section
    return allSections.length + 1;
};
const getCurrentPageNumber = (allSections, currentIndex, isFinishSelected)=>{
    if (isFinishSelected) return getPageCount(allSections);
    return currentIndex + 1;
};
const getTemplateSectionsOnly = (allSections)=>{
    return allSections.filter((section)=>section.sectionType === "template").map((section)=>({
            appliedTemplateId: section.appliedTemplateId,
            section: section.section,
            isComplete: section.isComplete
        }));
};

},{"lodash":"3hMBK","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7FNXe":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _selectField = require("./SelectField");
var _selectFieldDefault = parcelHelpers.interopDefault(_selectField);
var _colors = require("../../constants/colors");
var _weeklyScheduleFormatters = require("../../utils/weeklyScheduleFormatters");
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const addIcon = require("e801e39903b625d0");
const deleteIcon = require("744d8a1fb7ab9a2f");
const DAYS_OF_WEEK = [
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
    "Sunday"
];
// Modern select styles
const modernSelectStyle = /*#__PURE__*/ (0, _css.css)("font-family:-apple-system,BlinkMacSystemFont,'Segoe UI',Roboto,sans-serif;width:100%;min-width:140px;margin-bottom:0;.css-og1717-labelcontainer{height:0;display:none;}.Select-control{border:1px solid ", (0, _colors.color_shades_dark), ";border-radius:6px;min-height:44px;background:white;transition:all 0.2s ease;&:hover{border-color:", (0, _colors.color_colors_ocean), ";}}&.is-focused:not(.is-open) .Select-control{border-color:", (0, _colors.color_colors_ocean), ";box-shadow:0 0 0 3px rgba(66, 153, 225, 0.1);}.Select-placeholder,.Select-value{padding:11px 14px;font-size:14px;line-height:1.4;display:flex;align-items:center;}.Select-value-label{color:", (0, _colors.color_text_light), ";}.Select-input{padding:11px 14px;height:44px;}.Select-input>input{padding:0;line-height:1.4;font-size:14px;color:", (0, _colors.color_text_light), ";}.Select-menu-outer{border:1px solid ", (0, _colors.color_shades_dark), ";border-radius:6px;box-shadow:0 4px 12px rgba(0, 0, 0, 0.1);margin-top:4px;z-index:1000;}.Select-menu{max-height:240px;border-radius:6px;}.Select-option{padding:10px 12px;font-size:14px;cursor:pointer;transition:background 0.15s ease;&.is-focused{background:#f0f4f8;color:", (0, _colors.color_text_light), ";}&.is-selected{background:", (0, _colors.color_colors_ocean), ";color:white;}}.Select-arrow-zone{padding-right:8px;}.Select-arrow{border-color:", (0, _colors.color_text_light), " transparent transparent;border-width:5px 4px 2.5px;}&.is-open .Select-arrow{border-color:transparent transparent ", (0, _colors.color_text_light), ";border-width:0 4px 5px;}", "");
const modernStatusSelectStyle = /*#__PURE__*/ (0, _css.css)("font-family:-apple-system,BlinkMacSystemFont,'Segoe UI',Roboto,sans-serif;margin-bottom:0;.css-og1717-labelcontainer{height:0;display:none;}.Select-control{border:1px solid ", (0, _colors.color_shades_dark), ";border-radius:6px;min-height:44px;background:white;transition:all 0.2s ease;&:hover{border-color:", (0, _colors.color_colors_ocean), ";}}&.is-focused:not(.is-open) .Select-control{border-color:", (0, _colors.color_colors_ocean), ";box-shadow:0 0 0 3px rgba(66, 153, 225, 0.1);}.Select-placeholder,.Select-value{padding:11px 12px;font-size:14px;line-height:1.4;display:flex;align-items:center;}.Select-value-label{color:", (0, _colors.color_text_light), ";}.Select-input{padding:11px 12px;height:44px;}.Select-input>input{padding:0 0 0 2px;line-height:1.4;font-size:14px;color:", (0, _colors.color_text_light), ";}.Select-menu-outer{border:1px solid ", (0, _colors.color_shades_dark), ";border-radius:6px;box-shadow:0 4px 12px rgba(0, 0, 0, 0.1);margin-top:4px;}.Select-menu{max-height:200px;border-radius:6px;}.Select-option{padding:8px 12px;font-size:14px;cursor:pointer;transition:background 0.15s ease;&.is-focused{background:#f0f4f8;color:", (0, _colors.color_text_light), ";}&.is-selected{background:", (0, _colors.color_colors_ocean), ";color:white;}}.Select-arrow-zone{padding-right:8px;}.Select-arrow{border-color:", (0, _colors.color_text_light), " transparent transparent;border-width:5px 4px 2.5px;}&.is-open .Select-arrow{border-color:transparent transparent ", (0, _colors.color_text_light), ";border-width:0 4px 5px;}", "");
const TimeRangeField = (props)=>{
    // Parse the value from backend format or JSON string
    const parseValue = (val)=>{
        if (!val) // Initialize with all days closed
        return DAYS_OF_WEEK.map((day)=>({
                day,
                isOpen: false,
                timeRanges: []
            }));
        try {
            const parsed = JSON.parse(val);
            // Check if it's backend format (array of 7 strings with OPEN hours)
            if (Array.isArray(parsed) && parsed.length === 7 && typeof parsed[0] === "string") return DAYS_OF_WEEK.map((day, index)=>{
                const dayString = parsed[index];
                // Check if closed all day (empty string or 'closed')
                if (!dayString || dayString === "closed") return {
                    day,
                    isOpen: false,
                    timeRanges: []
                };
                // Parse open periods from backend
                const openTimeRanges = [];
                const ranges = dayString.split("|");
                for (const range of ranges){
                    const [start, end] = range.split(",");
                    if (start && end) openTimeRanges.push({
                        id: `time_${Date.now()}_${openTimeRanges.length}`,
                        startTime: (0, _weeklyScheduleFormatters.convert24HourTo12Hour)(start.trim()),
                        endTime: (0, _weeklyScheduleFormatters.convert24HourTo12Hour)(end.trim())
                    });
                }
                return {
                    day,
                    isOpen: openTimeRanges.length > 0,
                    timeRanges: openTimeRanges
                };
            });
            // Otherwise, assume it's the frontend format (array of DaySchedule objects)
            return DAYS_OF_WEEK.map((day)=>{
                const existing = parsed.find((d)=>d.day === day);
                return existing || {
                    day,
                    isOpen: false,
                    timeRanges: []
                };
            });
        } catch  {
            return DAYS_OF_WEEK.map((day)=>({
                    day,
                    isOpen: false,
                    timeRanges: []
                }));
        }
    };
    const [schedule, setSchedule] = (0, _react1.useState)(parseValue(props.value));
    // Ref to prevent infinite loops from internal updates
    const internalUpdateRef = (0, _react1.useRef)(false);
    // Sync schedule with external prop changes
    (0, _react1.useEffect)(()=>{
        // Ignore updates originating from our own onChange
        if (internalUpdateRef.current) {
            internalUpdateRef.current = false;
            return;
        }
        const newSchedule = parseValue(props.value);
        setSchedule(newSchedule);
    }, [
        props.value
    ]);
    // Generate time options in 30-minute increments
    const generateTimeOptions = ()=>{
        const times = [];
        const periods = [
            "AM",
            "PM"
        ];
        for (const period of periods){
            for(let hour = 12; hour >= 1; hour--)for (const minute of [
                "00",
                "30"
            ]){
                const value = `${hour}:${minute} ${period}`;
                times.push({
                    value,
                    label: value
                });
            }
        }
        // Sort times properly
        return times.sort((a, b)=>{
            const parseTime = (timeStr)=>{
                const [time, period] = timeStr.split(" ");
                const [hour, minute] = time.split(":").map(Number);
                let hours24 = hour === 12 ? 0 : hour;
                if (period === "PM" && hour !== 12) hours24 += 12;
                if (period === "AM" && hour === 12) hours24 = 0;
                return hours24 * 60 + minute;
            };
            return parseTime(a.value) - parseTime(b.value);
        });
    };
    const timeOptions = generateTimeOptions();
    // Calculate closed hours from open hours
    const calculateClosedHours = (openTimeRanges)=>{
        if (openTimeRanges.length === 0) return "Closed All Day";
        const closedPeriods = [];
        const sortedRanges = [
            ...openTimeRanges
        ].sort((a, b)=>{
            const aStart = (0, _weeklyScheduleFormatters.convert12HourTo24Hour)(a.startTime);
            const bStart = (0, _weeklyScheduleFormatters.convert12HourTo24Hour)(b.startTime);
            return aStart.localeCompare(bStart);
        });
        // Check if closed from midnight to first opening
        const firstStart = (0, _weeklyScheduleFormatters.convert12HourTo24Hour)(sortedRanges[0].startTime);
        if (firstStart !== "00:00") closedPeriods.push(`${(0, _weeklyScheduleFormatters.convert24HourTo12Hour)("00:00")}-${(0, _weeklyScheduleFormatters.convert24HourTo12Hour)(firstStart)}`);
        // Check gaps between open periods
        for(let i = 0; i < sortedRanges.length - 1; i++){
            const currentEnd = (0, _weeklyScheduleFormatters.convert12HourTo24Hour)(sortedRanges[i].endTime);
            const nextStart = (0, _weeklyScheduleFormatters.convert12HourTo24Hour)(sortedRanges[i + 1].startTime);
            if (currentEnd !== nextStart) closedPeriods.push(`${(0, _weeklyScheduleFormatters.convert24HourTo12Hour)(currentEnd)}-${(0, _weeklyScheduleFormatters.convert24HourTo12Hour)(nextStart)}`);
        }
        // Check if closed from last closing to end of day
        const lastEnd = (0, _weeklyScheduleFormatters.convert12HourTo24Hour)(sortedRanges[sortedRanges.length - 1].endTime);
        // End of day is 23:59, but if they close at anything before that, show the closed period
        if (lastEnd < "23:59") closedPeriods.push(`${(0, _weeklyScheduleFormatters.convert24HourTo12Hour)(lastEnd)}-${(0, _weeklyScheduleFormatters.convert24HourTo12Hour)("23:59")}`);
        return closedPeriods.length > 0 ? `Closed: ${closedPeriods.join(", ")}` : "Open 24 Hours";
    };
    // Convert schedule to backend format: Array of 7 strings with OPEN hours
    const convertToBackendFormat = (schedule)=>{
        return DAYS_OF_WEEK.map((dayName)=>{
            const daySchedule = schedule.find((d)=>d.day === dayName);
            if (!daySchedule || !daySchedule.isOpen || daySchedule.timeRanges.length === 0) // Closed all day = empty string
            return "";
            // Sort time ranges by start time
            const sortedRanges = [
                ...daySchedule.timeRanges
            ].sort((a, b)=>{
                const aStart = (0, _weeklyScheduleFormatters.convert12HourTo24Hour)(a.startTime);
                const bStart = (0, _weeklyScheduleFormatters.convert12HourTo24Hour)(b.startTime);
                return aStart.localeCompare(bStart);
            });
            // Convert each open period to 24-hour format
            const openPeriods = sortedRanges.map((range)=>{
                const start = (0, _weeklyScheduleFormatters.convert12HourTo24Hour)(range.startTime);
                const end = (0, _weeklyScheduleFormatters.convert12HourTo24Hour)(range.endTime);
                return `${start},${end}`;
            });
            return openPeriods.join("|");
        });
    };
    const updateValue = (newSchedule)=>{
        setSchedule(newSchedule);
        if (props.onChange) {
            // Set ref before calling onChange to prevent useEffect from reacting
            internalUpdateRef.current = true;
            // Convert to backend format (array of 7 strings)
            const backendFormat = convertToBackendFormat(newSchedule);
            props.onChange(JSON.stringify(backendFormat));
        }
    };
    // Validate that open days have at least one time range
    const getValidationError = ()=>{
        for (const day of schedule){
            // Check if open day has time ranges
            if (day.isOpen && day.timeRanges.length === 0) return `${day.day}: Please add hours or mark as closed.`;
            // Check for overlapping time ranges
            if (day.isOpen && day.timeRanges.length > 1) {
                const sortedRanges = [
                    ...day.timeRanges
                ].sort((a, b)=>{
                    const aStart = (0, _weeklyScheduleFormatters.convert12HourTo24Hour)(a.startTime);
                    const bStart = (0, _weeklyScheduleFormatters.convert12HourTo24Hour)(b.startTime);
                    return aStart.localeCompare(bStart);
                });
                for(let i = 0; i < sortedRanges.length - 1; i++){
                    const currentEnd = (0, _weeklyScheduleFormatters.convert12HourTo24Hour)(sortedRanges[i].endTime);
                    const nextStart = (0, _weeklyScheduleFormatters.convert12HourTo24Hour)(sortedRanges[i + 1].startTime);
                    if (currentEnd > nextStart) return `${day.day}: Time ranges cannot overlap.`;
                }
            }
            // Check that end time is after start time
            for (const range of day.timeRanges){
                const start = (0, _weeklyScheduleFormatters.convert12HourTo24Hour)(range.startTime);
                const end = (0, _weeklyScheduleFormatters.convert12HourTo24Hour)(range.endTime);
                if (start >= end) return `${day.day}: End time must be after start time.`;
            }
        }
        return null;
    };
    const validationError = getValidationError();
    const handleToggleOpen = (day, isOpen)=>{
        updateValue(schedule.map((d)=>d.day === day ? {
                ...d,
                isOpen,
                timeRanges: isOpen && d.timeRanges.length === 0 ? [
                    {
                        id: `time_${Date.now()}_${Math.floor(Math.random() * 1e6)}`,
                        startTime: "9:00 AM",
                        endTime: "5:00 PM"
                    }
                ] : d.timeRanges
            } : d));
    };
    const handleAddTimeRange = (day)=>{
        const newTimeRange = {
            id: `time_${Date.now()}_${Math.floor(Math.random() * 1e6)}`,
            startTime: "9:00 AM",
            endTime: "5:00 PM"
        };
        updateValue(schedule.map((d)=>d.day === day ? {
                ...d,
                timeRanges: [
                    ...d.timeRanges,
                    newTimeRange
                ]
            } : d));
    };
    const handleRemoveTimeRange = (day, timeRangeId)=>{
        updateValue(schedule.map((d)=>d.day === day ? {
                ...d,
                timeRanges: d.timeRanges.filter((tr)=>tr.id !== timeRangeId)
            } : d));
    };
    const handleTimeRangeChange = (day, timeRangeId, field, value)=>{
        updateValue(schedule.map((d)=>d.day === day ? {
                ...d,
                timeRanges: d.timeRanges.map((tr)=>tr.id === timeRangeId ? {
                        ...tr,
                        [field]: value
                    } : tr)
            } : d));
    };
    return (0, _react.jsx)("div", {
        className: `${containerStyle} ${props.className || ""}`
    }, props.label && (0, _react.jsx)("label", {
        className: labelStyle
    }, props.label), validationError && (0, _react.jsx)("div", {
        className: errorStyle
    }, validationError), (0, _react.jsx)("div", {
        className: daysContainer
    }, schedule.map((daySchedule)=>(0, _react.jsx)("div", {
            key: daySchedule.day,
            className: dayCard
        }, (0, _react.jsx)("div", {
            className: dayHeader
        }, (0, _react.jsx)("span", {
            className: dayLabel
        }, daySchedule.day.toUpperCase()), (0, _react.jsx)("div", {
            className: statusSelectWrapper
        }, (0, _react.jsx)((0, _selectFieldDefault.default), {
            name: `${props.name}_${daySchedule.day}_status`,
            value: daySchedule.isOpen ? "Open" : "Closed",
            onChange: (selected)=>handleToggleOpen(daySchedule.day, selected?.value === "Open"),
            options: [
                {
                    value: "Open",
                    label: "Open"
                },
                {
                    value: "Closed",
                    label: "Closed"
                }
            ],
            disabled: props.disabled,
            clearable: false,
            useForm: false,
            customClassName: modernStatusSelectStyle,
            hideLabel: true
        }), daySchedule.isOpen && daySchedule.timeRanges.length > 0 && (0, _react.jsx)("div", {
            className: closedHoursInfo
        }, calculateClosedHours(daySchedule.timeRanges)))), daySchedule.isOpen && (0, _react.jsx)("div", {
            className: timeRangesContainer
        }, (0, _react.jsx)("div", {
            className: openHoursLabel
        }, "Open Hours:"), daySchedule.timeRanges.map((timeRange)=>(0, _react.jsx)("div", {
                key: timeRange.id,
                className: timeRangeRow
            }, (0, _react.jsx)("div", {
                className: timeRangeFields
            }, (0, _react.jsx)((0, _selectFieldDefault.default), {
                name: `${props.name}_${daySchedule.day}_start_${timeRange.id}`,
                placeholder: "Start time",
                value: timeRange.startTime,
                onChange: (selected)=>handleTimeRangeChange(daySchedule.day, timeRange.id, "startTime", selected?.value || ""),
                options: timeOptions,
                disabled: props.disabled,
                clearable: false,
                useForm: false,
                customClassName: modernSelectStyle,
                hideLabel: true
            }), (0, _react.jsx)("span", {
                className: timeSeparator
            }, "—"), (0, _react.jsx)((0, _selectFieldDefault.default), {
                name: `${props.name}_${daySchedule.day}_end_${timeRange.id}`,
                placeholder: "End time",
                value: timeRange.endTime,
                onChange: (selected)=>handleTimeRangeChange(daySchedule.day, timeRange.id, "endTime", selected?.value || ""),
                options: timeOptions,
                disabled: props.disabled,
                clearable: false,
                useForm: false,
                customClassName: modernSelectStyle,
                hideLabel: true
            })), (0, _react.jsx)("button", {
                type: "button",
                className: deleteButton,
                onClick: ()=>handleRemoveTimeRange(daySchedule.day, timeRange.id),
                disabled: props.disabled,
                title: "Remove time range"
            }, (0, _react.jsx)("img", {
                src: deleteIcon,
                alt: "Remove"
            })))), (0, _react.jsx)("button", {
            type: "button",
            className: addTimeRangeButton,
            onClick: ()=>handleAddTimeRange(daySchedule.day),
            disabled: props.disabled
        }, (0, _react.jsx)("img", {
            src: addIcon,
            alt: "Add"
        }), "Add time range"))))));
};
const containerStyle = /*#__PURE__*/ (0, _css.css)({
    name: "b6wrti",
    styles: "display:flex;flex-direction:column;width:100%"
});
const labelStyle = /*#__PURE__*/ (0, _css.css)("font-size:14px;font-weight:500;margin-bottom:12px;color:", (0, _colors.color_text_light), ";", "");
const errorStyle = /*#__PURE__*/ (0, _css.css)({
    name: "12abldf",
    styles: "font-size:14px;color:#d32f2f;margin-bottom:12px;padding:8px 12px;background-color:#ffebee;border-radius:4px;border-left:4px solid #d32f2f"
});
const daysContainer = /*#__PURE__*/ (0, _css.css)({
    name: "budh8k",
    styles: "display:flex;flex-direction:column;gap:16px"
});
const dayCard = /*#__PURE__*/ (0, _css.css)("border:1px solid ", (0, _colors.color_shades_dark), ";border-radius:8px;padding:32px;background:white;", "");
const dayHeader = /*#__PURE__*/ (0, _css.css)({
    name: "1ypil4x",
    styles: "display:flex;align-items:center;gap:12px;margin-bottom:0;padding-left:4px"
});
const dayLabel = /*#__PURE__*/ (0, _css.css)("font-size:14px;font-weight:600;min-width:100px;color:", (0, _colors.color_text_light), ";", "");
const statusSelectWrapper = /*#__PURE__*/ (0, _css.css)({
    name: "n0qfe1",
    styles: "min-width:140px;display:flex;flex-direction:column;gap:8px"
});
const closedHoursInfo = /*#__PURE__*/ (0, _css.css)("font-size:12px;color:", (0, _colors.color_text_light), ";padding:4px 8px;background:#f8f9fa;border-radius:4px;font-style:italic;", "");
const timeRangesContainer = /*#__PURE__*/ (0, _css.css)({
    name: "1kta5ku",
    styles: "display:flex;flex-direction:column;gap:12px;padding-left:116px;margin-top:12px"
});
const openHoursLabel = /*#__PURE__*/ (0, _css.css)("font-size:13px;font-weight:600;color:", (0, _colors.color_text_light), ";margin-bottom:0;text-transform:uppercase;letter-spacing:0.5px;", "");
const timeRangeRow = /*#__PURE__*/ (0, _css.css)({
    name: "uh5xjc",
    styles: "display:flex;align-items:center;gap:12px"
});
const timeRangeFields = /*#__PURE__*/ (0, _css.css)({
    name: "1h3m280",
    styles: "flex:1;display:flex;align-items:center;gap:12px"
});
const timeSeparator = /*#__PURE__*/ (0, _css.css)("font-size:16px;color:", (0, _colors.color_text_light), ";flex-shrink:0;", "");
const deleteButton = /*#__PURE__*/ (0, _css.css)({
    name: "kgv915",
    styles: "background:transparent;border:none;cursor:pointer;padding:8px;display:flex;align-items:center;justify-content:center;opacity:0.5;transition:opacity 0.2s;&:hover{opacity:1;}&:disabled{cursor:not-allowed;opacity:0.3;}img{width:18px;height:18px;}"
});
const addTimeRangeButton = /*#__PURE__*/ (0, _css.css)("background:transparent;border:1px dashed ", (0, _colors.color_shades_dark), ";border-radius:4px;padding:8px 12px;cursor:pointer;display:flex;align-items:center;justify-content:center;gap:8px;font-size:14px;color:", (0, _colors.color_colors_ocean), ";transition:all 0.2s;&:hover{background:#f9f9f9;border-color:", (0, _colors.color_colors_ocean), ";}&:disabled{cursor:not-allowed;opacity:0.5;}img{width:16px;height:16px;}", "");
exports.default = TimeRangeField;

},{"@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","./SelectField":"405B3","../../constants/colors":"1p3OR","../../utils/weeklyScheduleFormatters":"cN6JS","e801e39903b625d0":"cl9rg","744d8a1fb7ab9a2f":"7eyKJ","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"cN6JS":[function(require,module,exports) {
/**
 * Utility functions for converting weekly schedule between frontend and backend formats
 * 
 * Backend Format:
 * - Open/close times in 24-hour format
 * - Commas separate open/close pairs: "09:00,13:00"
 * - Pipe separates multiple periods: "09:00,13:00|14:00,18:00"
 * - Use "00:00,00:01" for fully closed days
 * 
 * Frontend Format:
 * - JSON array of DaySchedule objects with 12-hour time format
 */ /**
 * Convert 12-hour time to 24-hour format
 * Example: "1:00 PM" -> "13:00"
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "convert12HourTo24Hour", ()=>convert12HourTo24Hour);
parcelHelpers.export(exports, "convert24HourTo12Hour", ()=>convert24HourTo12Hour);
parcelHelpers.export(exports, "dayScheduleToBackendFormat", ()=>dayScheduleToBackendFormat);
parcelHelpers.export(exports, "backendFormatToDaySchedule", ()=>backendFormatToDaySchedule);
parcelHelpers.export(exports, "weeklyScheduleToBackend", ()=>weeklyScheduleToBackend);
parcelHelpers.export(exports, "backendToWeeklySchedule", ()=>backendToWeeklySchedule);
parcelHelpers.export(exports, "convertWeeklyScheduleToBackend", ()=>convertWeeklyScheduleToBackend);
parcelHelpers.export(exports, "convertWeeklyScheduleFromBackend", ()=>convertWeeklyScheduleFromBackend);
parcelHelpers.export(exports, "isValidDayFormat", ()=>isValidDayFormat);
const convert12HourTo24Hour = (time12)=>{
    const [time, period] = time12.trim().split(" ");
    const [hourStr, minute] = time.split(":");
    let hour = parseInt(hourStr, 10);
    if (period === "PM" && hour !== 12) hour += 12;
    else if (period === "AM" && hour === 12) hour = 0;
    return `${hour.toString().padStart(2, "0")}:${minute}`;
};
const convert24HourTo12Hour = (time24)=>{
    const [hourStr, minute] = time24.split(":");
    let hour = parseInt(hourStr, 10);
    const period = hour >= 12 ? "PM" : "AM";
    if (hour === 0) hour = 12;
    else if (hour > 12) hour -= 12;
    return `${hour}:${minute} ${period}`;
};
const dayScheduleToBackendFormat = (daySchedule)=>{
    // Closed day
    if (!daySchedule.isOpen || daySchedule.timeRanges.length === 0) return "00:00,00:01";
    // Convert each time range to 24-hour format and join with commas
    const periods = daySchedule.timeRanges.map((tr)=>{
        const start24 = convert12HourTo24Hour(tr.startTime);
        const end24 = convert12HourTo24Hour(tr.endTime);
        return `${start24},${end24}`;
    });
    // Join multiple periods with pipe
    return periods.join("|");
};
const backendFormatToDaySchedule = (day, backendStr)=>{
    // Check if closed
    if (backendStr === "00:00,00:01") return {
        day,
        isOpen: false,
        timeRanges: []
    };
    // Split by pipe for multiple periods
    const periods = backendStr.split("|");
    const timeRanges = periods.map((period, index)=>{
        const [start, end] = period.split(",");
        return {
            id: crypto.randomUUID(),
            startTime: convert24HourTo12Hour(start.trim()),
            endTime: convert24HourTo12Hour(end.trim())
        };
    });
    return {
        day,
        isOpen: true,
        timeRanges
    };
};
const weeklyScheduleToBackend = (schedule)=>{
    const DAYS_ORDER = [
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday",
        "Sunday"
    ];
    return DAYS_ORDER.map((day)=>{
        const daySchedule = schedule.find((d)=>d.day === day);
        if (!daySchedule) return "00:00,00:01"; // Default to closed if day not found
        return dayScheduleToBackendFormat(daySchedule);
    });
};
const backendToWeeklySchedule = (backendArray)=>{
    const DAYS_ORDER = [
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday",
        "Sunday"
    ];
    if (!backendArray || backendArray.length !== 7) // Return default closed schedule if invalid
    return DAYS_ORDER.map((day)=>({
            day,
            isOpen: false,
            timeRanges: []
        }));
    return DAYS_ORDER.map((day, index)=>{
        return backendFormatToDaySchedule(day, backendArray[index]);
    });
};
const convertWeeklyScheduleToBackend = (jsonStr)=>{
    try {
        const schedule = JSON.parse(jsonStr);
        return weeklyScheduleToBackend(schedule);
    } catch  {
        // Return default closed schedule if parsing fails
        return Array(7).fill("00:00,00:01");
    }
};
const convertWeeklyScheduleFromBackend = (backendArray)=>{
    const schedule = backendToWeeklySchedule(backendArray);
    return JSON.stringify(schedule);
};
const isValidDayFormat = (str)=>{
    if (!str) return false;
    // Check for closed format
    if (str === "00:00,00:01") return true;
    // Check for time periods format
    const periodPattern = /^\d{2}:\d{2},\d{2}:\d{2}$/;
    const periods = str.split("|");
    return periods.every((period)=>periodPattern.test(period.trim()));
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8CHRX":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _selectField = require("./SelectField");
var _selectFieldDefault = parcelHelpers.interopDefault(_selectField);
var _colors = require("../../constants/colors");
var _weeklyScheduleFormatters = require("../../utils/weeklyScheduleFormatters");
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const addIcon = require("58e1623492c179f4");
const deleteIcon = require("6dc4d52415e2384a");
// Modern select styles
const modernSelectStyle = /*#__PURE__*/ (0, _css.css)("font-family:-apple-system,BlinkMacSystemFont,'Segoe UI',Roboto,sans-serif;width:100%;min-width:140px;margin-bottom:0;.Select-control{border:1px solid ", (0, _colors.color_shades_dark), ";border-radius:6px;min-height:44px;background:white;transition:all 0.2s ease;&:hover{border-color:", (0, _colors.color_colors_ocean), ";}}&.is-focused:not(.is-open) .Select-control{border-color:", (0, _colors.color_colors_ocean), ";box-shadow:0 0 0 3px rgba(66, 153, 225, 0.1);}.Select-placeholder,.Select-value{padding:11px 14px;font-size:14px;line-height:1.4;display:flex;align-items:center;}.Select-value-label{color:", (0, _colors.color_text_light), ";}.Select-input{padding:11px 14px;height:44px;}.Select-input>input{padding:0;line-height:1.4;font-size:14px;color:", (0, _colors.color_text_light), ";}.Select-menu-outer{border:1px solid ", (0, _colors.color_shades_dark), ";border-radius:6px;box-shadow:0 4px 12px rgba(0, 0, 0, 0.1);margin-top:4px;z-index:1000;}.Select-menu{max-height:240px;border-radius:6px;}.Select-option{padding:10px 12px;font-size:14px;cursor:pointer;transition:background 0.15s ease;&.is-focused{background:#f0f4f8;color:", (0, _colors.color_text_light), ";}&.is-selected{background:", (0, _colors.color_colors_ocean), ";color:white;}}.Select-arrow-zone{padding-right:8px;}.Select-arrow{border-color:", (0, _colors.color_text_light), " transparent transparent;border-width:5px 4px 2.5px;}&.is-open .Select-arrow{border-color:transparent transparent ", (0, _colors.color_text_light), ";border-width:0 4px 5px;}", "");
const modernStatusSelectStyle = /*#__PURE__*/ (0, _css.css)(modernSelectStyle, ";", "");
const SingleDayTimeRangeField = (props)=>{
    // Parse backend format: Backend sends OPEN hours in 24-hour format
    const parseValue = (val)=>{
        if (!val || val === "" || val === "closed" || val === "00:00,00:01") // Closed all day
        return {
            isOpen: false,
            timeRanges: []
        };
        // Parse open periods from backend
        const openTimeRanges = [];
        const ranges = val.split("|");
        for (const range of ranges){
            const [start, end] = range.split(",");
            if (start && end) openTimeRanges.push({
                id: `time_${Date.now()}_${Math.floor(Math.random() * 1e6)}`,
                startTime: (0, _weeklyScheduleFormatters.convert24HourTo12Hour)(start.trim()),
                endTime: (0, _weeklyScheduleFormatters.convert24HourTo12Hour)(end.trim())
            });
        }
        return {
            isOpen: openTimeRanges.length > 0,
            timeRanges: openTimeRanges
        };
    };
    // Calculate closed hours from open hours
    const calculateClosedHours = (openTimeRanges)=>{
        if (openTimeRanges.length === 0) return "Closed All Day (12:00 AM-11:59 PM)";
        const closedPeriods = [];
        const sortedRanges = [
            ...openTimeRanges
        ].sort((a, b)=>{
            const aStart = (0, _weeklyScheduleFormatters.convert12HourTo24Hour)(a.startTime);
            const bStart = (0, _weeklyScheduleFormatters.convert12HourTo24Hour)(b.startTime);
            return aStart.localeCompare(bStart);
        });
        // Check if closed from midnight to first opening
        const firstStart = (0, _weeklyScheduleFormatters.convert12HourTo24Hour)(sortedRanges[0].startTime);
        if (firstStart !== "00:00") closedPeriods.push(`${(0, _weeklyScheduleFormatters.convert24HourTo12Hour)("00:00")}-${(0, _weeklyScheduleFormatters.convert24HourTo12Hour)(firstStart)}`);
        // Check gaps between open periods
        for(let i = 0; i < sortedRanges.length - 1; i++){
            const currentEnd = (0, _weeklyScheduleFormatters.convert12HourTo24Hour)(sortedRanges[i].endTime);
            const nextStart = (0, _weeklyScheduleFormatters.convert12HourTo24Hour)(sortedRanges[i + 1].startTime);
            if (currentEnd !== nextStart) closedPeriods.push(`${(0, _weeklyScheduleFormatters.convert24HourTo12Hour)(currentEnd)}-${(0, _weeklyScheduleFormatters.convert24HourTo12Hour)(nextStart)}`);
        }
        // Check if closed from last closing to end of day
        const lastEnd = (0, _weeklyScheduleFormatters.convert12HourTo24Hour)(sortedRanges[sortedRanges.length - 1].endTime);
        // End of day is 23:59, but if they close at anything before that, show the closed period
        if (lastEnd < "23:59") closedPeriods.push(`${(0, _weeklyScheduleFormatters.convert24HourTo12Hour)(lastEnd)}-${(0, _weeklyScheduleFormatters.convert24HourTo12Hour)("23:59")}`);
        return closedPeriods.length > 0 ? `Closed: ${closedPeriods.join(", ")}` : "Open 24 Hours";
    };
    // Convert to backend format (sends OPEN hours in 24-hour format)
    const convertToBackendFormat = (isOpen, timeRanges)=>{
        if (!isOpen || timeRanges.length === 0) // Closed all day = 00:00,00:01
        return "00:00,00:01";
        // Sort time ranges by start time
        const sortedRanges = [
            ...timeRanges
        ].sort((a, b)=>{
            const aStart = (0, _weeklyScheduleFormatters.convert12HourTo24Hour)(a.startTime);
            const bStart = (0, _weeklyScheduleFormatters.convert12HourTo24Hour)(b.startTime);
            return aStart.localeCompare(bStart);
        });
        // Convert each open period to 24-hour format
        const openPeriods = sortedRanges.map((range)=>{
            const start = (0, _weeklyScheduleFormatters.convert12HourTo24Hour)(range.startTime);
            const end = (0, _weeklyScheduleFormatters.convert12HourTo24Hour)(range.endTime);
            return `${start},${end}`;
        });
        return openPeriods.join("|");
    };
    const initialValue = parseValue(props.value);
    const [isOpen, setIsOpen] = (0, _react1.useState)(initialValue.isOpen);
    const [timeRanges, setTimeRanges] = (0, _react1.useState)(initialValue.timeRanges);
    // Ref to prevent infinite loops from internal updates
    const isUpdatingRef = (0, _react1.useRef)(false);
    // Ref to track previous validation state to avoid redundant callbacks
    const prevHasErrorsRef = (0, _react1.useRef)(undefined);
    // Sync state with external prop changes
    (0, _react1.useEffect)(()=>{
        // Ignore updates originating from our own onChange
        if (isUpdatingRef.current) {
            isUpdatingRef.current = false;
            return;
        }
        const parsed = parseValue(props.value);
        setIsOpen(parsed.isOpen);
        setTimeRanges(parsed.timeRanges);
    }, [
        props.value
    ]);
    // Generate time options in 1-minute increments
    const generateTimeOptions = ()=>{
        const times = [];
        const periods = [
            "AM",
            "PM"
        ];
        for (const period of periods){
            for(let hour = 12; hour >= 1; hour--)for(let minute = 0; minute < 60; minute++){
                const minuteStr = minute.toString().padStart(2, "0");
                const value = `${hour}:${minuteStr} ${period}`;
                times.push({
                    value,
                    label: value
                });
            }
        }
        return times.sort((a, b)=>{
            const parseTime = (timeStr)=>{
                const [time, period] = timeStr.split(" ");
                const [hour, minute] = time.split(":").map(Number);
                let hours24 = hour === 12 ? 0 : hour;
                if (period === "PM" && hour !== 12) hours24 += 12;
                if (period === "AM" && hour === 12) hours24 = 0;
                return hours24 * 60 + minute;
            };
            return parseTime(a.value) - parseTime(b.value);
        });
    };
    const timeOptions = generateTimeOptions();
    const updateValue = (newIsOpen, newTimeRanges)=>{
        setIsOpen(newIsOpen);
        setTimeRanges(newTimeRanges);
        if (props.onChange) {
            // Set ref before calling onChange to prevent useEffect from reacting
            isUpdatingRef.current = true;
            const backendFormat = convertToBackendFormat(newIsOpen, newTimeRanges);
            props.onChange(backendFormat);
        }
    };
    const handleToggleOpen = (newIsOpen)=>{
        if (newIsOpen && timeRanges.length === 0) {
            // Add default time range when opening
            const defaultRange = {
                id: `time_${Date.now()}_${Math.floor(Math.random() * 1e6)}`,
                startTime: "9:00 AM",
                endTime: "5:00 PM"
            };
            updateValue(true, [
                defaultRange
            ]);
        } else updateValue(newIsOpen, timeRanges);
    };
    const handleAddTimeRange = ()=>{
        const newTimeRange = {
            id: `time_${Date.now()}_${Math.floor(Math.random() * 1e6)}`,
            startTime: "9:00 AM",
            endTime: "5:00 PM"
        };
        updateValue(isOpen, [
            ...timeRanges,
            newTimeRange
        ]);
    };
    const handleRemoveTimeRange = (timeRangeId)=>{
        updateValue(isOpen, timeRanges.filter((tr)=>tr.id !== timeRangeId));
    };
    const handleTimeRangeChange = (timeRangeId, field, value)=>{
        updateValue(isOpen, timeRanges.map((tr)=>tr.id === timeRangeId ? {
                ...tr,
                [field]: value
            } : tr));
    };
    // Validation - returns a map of timeRangeId to error message
    const getValidationErrors = ()=>{
        const timeRangeErrors = new Map();
        let globalError = null;
        // Check that open status has at least one time range
        if (isOpen && timeRanges.length === 0) {
            globalError = "Please add hours or mark as closed.";
            return {
                globalError,
                timeRangeErrors
            };
        }
        // Check that end time is after start time for each range
        for (const range of timeRanges){
            const start = (0, _weeklyScheduleFormatters.convert12HourTo24Hour)(range.startTime);
            const end = (0, _weeklyScheduleFormatters.convert12HourTo24Hour)(range.endTime);
            if (start >= end) timeRangeErrors.set(range.id, "End time must be after start time.");
        }
        // Check for overlapping time ranges
        if (isOpen && timeRanges.length > 1 && timeRangeErrors.size === 0) {
            const sortedRanges = [
                ...timeRanges
            ].sort((a, b)=>{
                const aStart = (0, _weeklyScheduleFormatters.convert12HourTo24Hour)(a.startTime);
                const bStart = (0, _weeklyScheduleFormatters.convert12HourTo24Hour)(b.startTime);
                return aStart.localeCompare(bStart);
            });
            for(let i = 0; i < sortedRanges.length - 1; i++){
                const currentEnd = (0, _weeklyScheduleFormatters.convert12HourTo24Hour)(sortedRanges[i].endTime);
                const nextStart = (0, _weeklyScheduleFormatters.convert12HourTo24Hour)(sortedRanges[i + 1].startTime);
                if (currentEnd > nextStart) {
                    // Show overlap error once at the top instead of for each range
                    globalError = "Time ranges cannot overlap.";
                    break;
                }
            }
        }
        return {
            globalError,
            timeRangeErrors
        };
    };
    const { globalError, timeRangeErrors } = getValidationErrors();
    const validationError = props.error || globalError;
    const hasErrors = !!validationError || timeRangeErrors.size > 0;
    // Notify parent of validation state changes - only when state actually changes
    (0, _react1.useEffect)(()=>{
        // Only call if the validation state has actually changed
        if (prevHasErrorsRef.current !== hasErrors) {
            prevHasErrorsRef.current = hasErrors;
            if (props.onValidationChange) props.onValidationChange(hasErrors);
        }
    }, [
        hasErrors,
        props.onValidationChange
    ]);
    return (0, _react.jsx)("div", {
        className: `${containerStyle} ${props.className || ""}`
    }, props.label && (0, _react.jsx)("label", {
        className: labelStyle
    }, props.label), validationError && (0, _react.jsx)("div", {
        className: errorStyle
    }, validationError), (0, _react.jsx)("div", {
        className: dayCard
    }, (0, _react.jsx)("div", {
        className: dayHeader
    }, (0, _react.jsx)("div", {
        className: statusSelectWrapper
    }, (0, _react.jsx)((0, _selectFieldDefault.default), {
        name: `${props.name}_status`,
        value: isOpen ? "Open" : "Closed",
        onChange: (selected)=>handleToggleOpen(selected?.value === "Open"),
        options: [
            {
                value: "Open",
                label: "Open"
            },
            {
                value: "Closed",
                label: "Closed"
            }
        ],
        disabled: props.disabled,
        clearable: false,
        useForm: false,
        customClassName: modernStatusSelectStyle,
        hideLabel: true
    }), isOpen && timeRanges.length > 0 && (0, _react.jsx)("div", {
        className: closedHoursInfo
    }, calculateClosedHours(timeRanges)))), isOpen && (0, _react.jsx)("div", {
        className: timeRangesContainer
    }, (0, _react.jsx)("div", {
        className: openHoursLabel
    }, "Open Hours:"), timeRanges.map((timeRange, index)=>(0, _react.jsx)("div", {
            key: timeRange.id
        }, timeRangeErrors.has(timeRange.id) && (0, _react.jsx)("div", {
            className: timeRangeErrorStyle
        }, timeRangeErrors.get(timeRange.id)), (0, _react.jsx)("div", {
            className: timeRangeRow
        }, (0, _react.jsx)("div", {
            className: timeRangeFields
        }, (0, _react.jsx)((0, _selectFieldDefault.default), {
            name: `${props.name}_start_${timeRange.id}`,
            placeholder: "Start time",
            value: timeRange.startTime,
            onChange: (selected)=>handleTimeRangeChange(timeRange.id, "startTime", selected?.value || ""),
            options: timeOptions,
            disabled: props.disabled,
            clearable: false,
            useForm: false,
            customClassName: modernSelectStyle,
            hideLabel: true
        }), (0, _react.jsx)("span", {
            className: timeSeparator
        }, "—"), (0, _react.jsx)((0, _selectFieldDefault.default), {
            name: `${props.name}_end_${timeRange.id}`,
            placeholder: "End time",
            value: timeRange.endTime,
            onChange: (selected)=>handleTimeRangeChange(timeRange.id, "endTime", selected?.value || ""),
            options: timeOptions,
            disabled: props.disabled,
            clearable: false,
            useForm: false,
            customClassName: modernSelectStyle,
            hideLabel: true
        })), (0, _react.jsx)("button", {
            type: "button",
            className: deleteButton,
            onClick: ()=>handleRemoveTimeRange(timeRange.id),
            disabled: props.disabled,
            title: "Remove time range"
        }, (0, _react.jsx)("img", {
            src: deleteIcon,
            alt: "Remove"
        }))))), (0, _react.jsx)("button", {
        type: "button",
        className: addTimeRangeButton,
        onClick: handleAddTimeRange,
        disabled: props.disabled
    }, (0, _react.jsx)("img", {
        src: addIcon,
        alt: "Add"
    }), "Add time range"))));
};
const containerStyle = /*#__PURE__*/ (0, _css.css)({
    name: "b6wrti",
    styles: "display:flex;flex-direction:column;width:100%"
});
const labelStyle = /*#__PURE__*/ (0, _css.css)("font-size:14px;font-weight:500;margin-bottom:12px;color:", (0, _colors.color_shades_darker), ";", "");
const errorStyle = /*#__PURE__*/ (0, _css.css)({
    name: "12abldf",
    styles: "font-size:14px;color:#d32f2f;margin-bottom:12px;padding:8px 12px;background-color:#ffebee;border-radius:4px;border-left:4px solid #d32f2f"
});
const timeRangeErrorStyle = /*#__PURE__*/ (0, _css.css)({
    name: "te72im",
    styles: "font-size:13px;color:#d32f2f;margin-bottom:8px;padding:6px 10px;background-color:#ffebee;border-radius:4px;border-left:3px solid #d32f2f"
});
const dayCard = /*#__PURE__*/ (0, _css.css)("border:1px solid ", (0, _colors.color_shades_dark), ";border-radius:8px;padding:32px;background:white;", "");
const dayHeader = /*#__PURE__*/ (0, _css.css)({
    name: "1ypil4x",
    styles: "display:flex;align-items:center;gap:12px;margin-bottom:0;padding-left:4px"
});
const statusSelectWrapper = /*#__PURE__*/ (0, _css.css)({
    name: "n0qfe1",
    styles: "min-width:140px;display:flex;flex-direction:column;gap:8px"
});
const closedHoursInfo = /*#__PURE__*/ (0, _css.css)("font-size:12px;color:", (0, _colors.color_text_light), ";padding:4px 8px;background:#f8f9fa;border-radius:4px;font-style:italic;", "");
const timeRangesContainer = /*#__PURE__*/ (0, _css.css)({
    name: "8qf6y2",
    styles: "display:flex;flex-direction:column;gap:12px;margin-top:12px"
});
const openHoursLabel = /*#__PURE__*/ (0, _css.css)("font-size:13px;font-weight:600;color:", (0, _colors.color_text_light), ";margin-bottom:0;text-transform:uppercase;letter-spacing:0.5px;", "");
const timeRangeRow = /*#__PURE__*/ (0, _css.css)({
    name: "uh5xjc",
    styles: "display:flex;align-items:center;gap:12px"
});
const timeRangeFields = /*#__PURE__*/ (0, _css.css)({
    name: "1h3m280",
    styles: "flex:1;display:flex;align-items:center;gap:12px"
});
const timeSeparator = /*#__PURE__*/ (0, _css.css)("font-size:16px;color:", (0, _colors.color_text_light), ";flex-shrink:0;", "");
const deleteButton = /*#__PURE__*/ (0, _css.css)({
    name: "1aghwdm",
    styles: "background:transparent;border:none;cursor:pointer;padding:8px;display:flex;align-items:center;justify-content:center;opacity:0.6;transition:opacity 0.2s;&:hover{opacity:1;}&:disabled{cursor:not-allowed;opacity:0.3;}img{width:20px;height:20px;}"
});
const addTimeRangeButton = /*#__PURE__*/ (0, _css.css)("background:transparent;border:1px dashed ", (0, _colors.color_shades_dark), ";border-radius:4px;padding:8px 12px;cursor:pointer;display:flex;align-items:center;justify-content:center;gap:8px;font-size:14px;color:", (0, _colors.color_colors_ocean), ";transition:all 0.2s;&:hover{background:#f0f0f0;border-color:", (0, _colors.color_colors_ocean), ";}&:disabled{cursor:not-allowed;opacity:0.5;}img{width:16px;height:16px;}", "");
exports.default = SingleDayTimeRangeField;

},{"@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","./SelectField":"405B3","../../constants/colors":"1p3OR","../../utils/weeklyScheduleFormatters":"cN6JS","58e1623492c179f4":"cl9rg","6dc4d52415e2384a":"7eyKJ","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"dZrB4":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _selectField = require("./SelectField");
var _selectFieldDefault = parcelHelpers.interopDefault(_selectField);
var _textField = require("./TextField");
var _textFieldDefault = parcelHelpers.interopDefault(_textField);
var _colors = require("../../constants/colors");
var _weeklyScheduleFormatters = require("../../utils/weeklyScheduleFormatters");
var _scheduleFormatters = require("../../utils/scheduleFormatters");
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const addIcon = require("cf92a7bba3b1356a");
const deleteIcon = require("e52902c68ccf0187");
// Modern select styles
const modernSelectStyle = /*#__PURE__*/ (0, _css.css)("font-family:-apple-system,BlinkMacSystemFont,'Segoe UI',Roboto,sans-serif;width:100%;min-width:140px;.Select-control{border:1px solid ", (0, _colors.color_shades_dark), ";border-radius:6px;min-height:44px;background:white;transition:all 0.2s ease;&:hover{border-color:", (0, _colors.color_colors_ocean), ";}}&.is-focused:not(.is-open) .Select-control{border-color:", (0, _colors.color_colors_ocean), ";box-shadow:0 0 0 3px rgba(66, 153, 225, 0.1);}.Select-placeholder,.Select-value{padding:11px 14px;font-size:14px;line-height:1.4;display:flex;align-items:center;}.Select-value-label{color:", (0, _colors.color_text_light), ";}.Select-input{padding:11px 14px;height:44px;align-items:center;}.Select-input>input{padding:0 0 0 2px;line-height:1.4;font-size:14px;color:", (0, _colors.color_text_light), ";}.Select-menu-outer{border:1px solid ", (0, _colors.color_shades_dark), ";border-radius:6px;box-shadow:0 4px 12px rgba(0, 0, 0, 0.1);margin-top:4px;z-index:1000;}.Select-menu{max-height:240px;border-radius:6px;}.Select-option{padding:10px 12px;font-size:14px;cursor:pointer;transition:background 0.15s ease;&.is-focused{background:#f0f4f8;color:", (0, _colors.color_text_light), ";}&.is-selected{background:", (0, _colors.color_colors_ocean), ";color:white;}}.Select-arrow-zone{padding-right:8px;}.Select-arrow{border-color:", (0, _colors.color_text_light), " transparent transparent;border-width:5px 4px 2.5px;}&.is-open .Select-arrow{border-color:transparent transparent ", (0, _colors.color_text_light), ";border-width:0 4px 5px;}", "");
const SpecialDateField = (props)=>{
    // Parse the value from backend format: MM/DD/YYYY or MM/DD/YYYY(HH:MM-HH:MM|HH:MM-HH:MM) or 'none'
    const parseValue = (val)=>{
        if (!val || val === "none") return {
            dates: [],
            hasNoSpecialDates: val === "none"
        };
        // Try to parse as backend format first
        try {
            const dates = [];
            const dateEntries = val.split(",").filter((entry)=>entry.trim());
            let hasInvalidDate = false;
            for (const entry of dateEntries){
                const match = entry.match(/^([^(]+)\(([^)]+)\)$/);
                if (match) {
                    // Date with time ranges: MM/DD/YYYY(HH:MM-HH:MM)
                    // Backend stores CLOSED hours, we need to convert to OPEN hours for the UI
                    const dateStr = match[1].trim();
                    const timesStr = match[2].trim();
                    const formattedDate = (0, _scheduleFormatters.parseDateFromBackend)(dateStr);
                    // Check if date parsing failed
                    if (formattedDate === "none") {
                        hasInvalidDate = true;
                        continue;
                    }
                    // Parse closed periods from backend
                    const closedPeriods = [];
                    const timeRangePairs = timesStr.split("|");
                    for (const pair of timeRangePairs){
                        const [start, end] = pair.split("-");
                        if (start && end) closedPeriods.push({
                            start: start.trim(),
                            end: end.trim()
                        });
                    }
                    // Convert closed periods to open periods (inverse)
                    const openTimeRanges = [];
                    const sortedClosedPeriods = closedPeriods.sort((a, b)=>a.start.localeCompare(b.start));
                    // If first closed period doesn't start at 00:00, there's an open period before it
                    if (sortedClosedPeriods.length === 0) // No closed periods means open 24 hours
                    openTimeRanges.push({
                        id: `time_${crypto.randomUUID()}`,
                        startTime: "12:00 AM",
                        endTime: "11:59 PM"
                    });
                    else {
                        if (sortedClosedPeriods[0].start !== "00:00") openTimeRanges.push({
                            id: `time_${crypto.randomUUID()}`,
                            startTime: "12:00 AM",
                            endTime: (0, _weeklyScheduleFormatters.convert24HourTo12Hour)(sortedClosedPeriods[0].start)
                        });
                        // Open periods are between closed periods
                        for(let i = 0; i < sortedClosedPeriods.length - 1; i++){
                            const currentEnd = sortedClosedPeriods[i].end;
                            const nextStart = sortedClosedPeriods[i + 1].start;
                            if (currentEnd !== nextStart) openTimeRanges.push({
                                id: `time_${crypto.randomUUID()}`,
                                startTime: (0, _weeklyScheduleFormatters.convert24HourTo12Hour)(currentEnd),
                                endTime: (0, _weeklyScheduleFormatters.convert24HourTo12Hour)(nextStart)
                            });
                        }
                        // If last closed period doesn't end at 23:59, there's an open period after it
                        const lastPeriod = sortedClosedPeriods[sortedClosedPeriods.length - 1];
                        if (lastPeriod.end !== "23:59") openTimeRanges.push({
                            id: `time_${crypto.randomUUID()}`,
                            startTime: (0, _weeklyScheduleFormatters.convert24HourTo12Hour)(lastPeriod.end),
                            endTime: "11:59 PM"
                        });
                    }
                    dates.push({
                        id: `date_${crypto.randomUUID()}`,
                        date: formattedDate,
                        isClosedAllDay: false,
                        timeRanges: openTimeRanges
                    });
                } else {
                    // Date without parentheses: MM/DD/YYYY = closed all day
                    const dateStr = entry.trim();
                    const formattedDate = (0, _scheduleFormatters.parseDateFromBackend)(dateStr);
                    // Check if date parsing failed
                    if (formattedDate === "none") {
                        hasInvalidDate = true;
                        continue;
                    }
                    dates.push({
                        id: `date_${crypto.randomUUID()}`,
                        date: formattedDate,
                        isClosedAllDay: true,
                        timeRanges: []
                    });
                }
            }
            // If we encountered any invalid dates, treat as "no special dates"
            if (hasInvalidDate && dates.length === 0) return {
                dates: [],
                hasNoSpecialDates: true
            };
            if (dates.length > 0) return {
                dates,
                hasNoSpecialDates: false
            };
        } catch (e) {
            console.error("Error parsing backend format:", e);
        }
        // Fallback: try to parse as JSON (legacy format)
        try {
            const parsed = JSON.parse(val);
            if (Array.isArray(parsed) && parsed.length === 1 && parsed[0].date === "none") return {
                dates: [],
                hasNoSpecialDates: true
            };
            return {
                dates: parsed,
                hasNoSpecialDates: false
            };
        } catch  {
            return {
                dates: [],
                hasNoSpecialDates: false
            };
        }
    };
    const initialValue = parseValue(props.value);
    const [specialDates, setSpecialDates] = (0, _react1.useState)(initialValue.dates);
    const [hasNoSpecialDates, setHasNoSpecialDates] = (0, _react1.useState)(initialValue.hasNoSpecialDates);
    // Ref to prevent infinite loops from internal updates
    const isUpdatingRef = (0, _react1.useRef)(false);
    // Ref to track previous validation state to avoid redundant callbacks
    const prevHasErrorsRef = (0, _react1.useRef)(undefined);
    // Sync state with external prop changes
    (0, _react1.useEffect)(()=>{
        // Ignore updates originating from our own onChange
        if (isUpdatingRef.current) {
            isUpdatingRef.current = false;
            return;
        }
        const parsed = parseValue(props.value);
        setSpecialDates(parsed.dates);
        setHasNoSpecialDates(parsed.hasNoSpecialDates);
    }, [
        props.value
    ]);
    // Generate time options in 1-minute increments
    const generateTimeOptions = ()=>{
        const times = [];
        const periods = [
            "AM",
            "PM"
        ];
        for (const period of periods){
            for(let hour = 12; hour >= 1; hour--)for(let minute = 0; minute < 60; minute++){
                const minuteStr = minute.toString().padStart(2, "0");
                const value = `${hour}:${minuteStr} ${period}`;
                times.push({
                    value,
                    label: value
                });
            }
        }
        return times.sort((a, b)=>{
            const parseTime = (timeStr)=>{
                const [time, period] = timeStr.split(" ");
                const [hour, minute] = time.split(":").map(Number);
                let hours24 = hour === 12 ? 0 : hour;
                if (period === "PM" && hour !== 12) hours24 += 12;
                if (period === "AM" && hour === 12) hours24 = 0;
                return hours24 * 60 + minute;
            };
            return parseTime(a.value) - parseTime(b.value);
        });
    };
    const timeOptions = generateTimeOptions();
    // Calculate closed hours from open hours for display
    const calculateClosedHours = (openTimeRanges)=>{
        if (openTimeRanges.length === 0) return "Closed All Day";
        const closedPeriods = [];
        const sortedRanges = [
            ...openTimeRanges
        ].sort((a, b)=>{
            const aStart = (0, _weeklyScheduleFormatters.convert12HourTo24Hour)(a.startTime);
            const bStart = (0, _weeklyScheduleFormatters.convert12HourTo24Hour)(b.startTime);
            return aStart.localeCompare(bStart);
        });
        // Check if closed from midnight to first opening
        const firstStart = (0, _weeklyScheduleFormatters.convert12HourTo24Hour)(sortedRanges[0].startTime);
        if (firstStart !== "00:00") closedPeriods.push(`${(0, _weeklyScheduleFormatters.convert24HourTo12Hour)("00:00")}-${(0, _weeklyScheduleFormatters.convert24HourTo12Hour)(firstStart)}`);
        // Check gaps between open periods
        for(let i = 0; i < sortedRanges.length - 1; i++){
            const currentEnd = (0, _weeklyScheduleFormatters.convert12HourTo24Hour)(sortedRanges[i].endTime);
            const nextStart = (0, _weeklyScheduleFormatters.convert12HourTo24Hour)(sortedRanges[i + 1].startTime);
            if (currentEnd !== nextStart) closedPeriods.push(`${(0, _weeklyScheduleFormatters.convert24HourTo12Hour)(currentEnd)}-${(0, _weeklyScheduleFormatters.convert24HourTo12Hour)(nextStart)}`);
        }
        // Check if closed from last closing to end of day
        const lastEnd = (0, _weeklyScheduleFormatters.convert12HourTo24Hour)(sortedRanges[sortedRanges.length - 1].endTime);
        // End of day is 23:59, but if they close at anything before that, show the closed period
        if (lastEnd < "23:59") closedPeriods.push(`${(0, _weeklyScheduleFormatters.convert24HourTo12Hour)(lastEnd)}-${(0, _weeklyScheduleFormatters.convert24HourTo12Hour)("23:59")}`);
        return closedPeriods.length > 0 ? `Closed: ${closedPeriods.join(", ")}` : "Open 24 Hours";
    };
    // Convert special dates to backend format: MM/DD/YYYY or MM/DD/YYYY(HH:MM-HH:MM|HH:MM-HH:MM)
    // For custom hours, we save the CLOSED/DISABLED hours (inverse of open hours)
    const convertToBackendFormat = (dates)=>{
        return dates.map((specialDate)=>{
            const formattedDate = (0, _scheduleFormatters.formatDateForBackend)(specialDate.date);
            if (specialDate.isClosedAllDay) // Closed all day - just the date without time ranges
            return formattedDate;
            else if (specialDate.timeRanges.length > 0) {
                // Custom hours - calculate and save CLOSED hours (inverse of open hours)
                const closedPeriods = [];
                const sortedRanges = [
                    ...specialDate.timeRanges
                ].sort((a, b)=>{
                    const aStart = (0, _weeklyScheduleFormatters.convert12HourTo24Hour)(a.startTime);
                    const bStart = (0, _weeklyScheduleFormatters.convert12HourTo24Hour)(b.startTime);
                    return aStart.localeCompare(bStart);
                });
                // Check if closed from midnight to first opening
                const firstStart = (0, _weeklyScheduleFormatters.convert12HourTo24Hour)(sortedRanges[0].startTime);
                if (firstStart !== "00:00") closedPeriods.push(`00:00-${firstStart}`);
                // Check gaps between open periods (closed periods)
                for(let i = 0; i < sortedRanges.length - 1; i++){
                    const currentEnd = (0, _weeklyScheduleFormatters.convert12HourTo24Hour)(sortedRanges[i].endTime);
                    const nextStart = (0, _weeklyScheduleFormatters.convert12HourTo24Hour)(sortedRanges[i + 1].startTime);
                    if (currentEnd !== nextStart) closedPeriods.push(`${currentEnd}-${nextStart}`);
                }
                // Check if closed from last closing to end of day
                const lastEnd = (0, _weeklyScheduleFormatters.convert12HourTo24Hour)(sortedRanges[sortedRanges.length - 1].endTime);
                if (lastEnd !== "23:59") closedPeriods.push(`${lastEnd}-23:59`);
                // If there are closed periods, format them
                if (closedPeriods.length > 0) return `${formattedDate}(${closedPeriods.join("|")})`;
                else // Open 24 hours - no closed periods, treat as open all day (no special date)
                return "";
            } else // No time ranges but not closed all day - treat as closed
            return formattedDate;
        }).filter((entry)=>entry !== "").join(",");
    };
    const updateValue = (newDates, noSpecialDates = hasNoSpecialDates)=>{
        setSpecialDates(newDates);
        setHasNoSpecialDates(noSpecialDates);
        if (props.onChange) {
            // Set ref before calling onChange to prevent useEffect from reacting
            isUpdatingRef.current = true;
            if (noSpecialDates) // Send sentinel value
            props.onChange("none");
            else {
                // Convert to backend format
                const backendFormat = convertToBackendFormat(newDates);
                props.onChange(backendFormat);
            }
        }
    };
    const handleToggleNoSpecialDates = (checked)=>{
        if (checked) updateValue([], true);
        else updateValue(specialDates, false);
    };
    const handleAddDate = ()=>{
        const newDate = {
            id: `date_${crypto.randomUUID()}`,
            date: "",
            isClosedAllDay: true,
            timeRanges: []
        };
        updateValue([
            ...specialDates,
            newDate
        ], false);
    };
    // TODO: Add US Federal Holidays feature once backend API is released
    // This will allow users to select federal holidays for the next 10 years via checkboxes
    const handleRemoveDate = (dateId)=>{
        updateValue(specialDates.filter((d)=>d.id !== dateId));
    };
    const handleDateChange = (dateId, newDate)=>{
        updateValue(specialDates.map((d)=>d.id === dateId ? {
                ...d,
                date: newDate
            } : d));
    };
    const handleToggleClosedAllDay = (dateId, isClosed)=>{
        updateValue(specialDates.map((d)=>d.id === dateId ? {
                ...d,
                isClosedAllDay: isClosed,
                timeRanges: isClosed ? [] : d.timeRanges
            } : d));
    };
    const handleAddTimeRange = (dateId)=>{
        const newTimeRange = {
            id: `time_${crypto.randomUUID()}`,
            startTime: "9:00 AM",
            endTime: "5:00 PM"
        };
        updateValue(specialDates.map((d)=>d.id === dateId ? {
                ...d,
                timeRanges: [
                    ...d.timeRanges,
                    newTimeRange
                ]
            } : d));
    };
    const handleRemoveTimeRange = (dateId, timeRangeId)=>{
        updateValue(specialDates.map((d)=>d.id === dateId ? {
                ...d,
                timeRanges: d.timeRanges.filter((tr)=>tr.id !== timeRangeId)
            } : d));
    };
    const handleTimeRangeChange = (dateId, timeRangeId, field, value)=>{
        updateValue(specialDates.map((d)=>d.id === dateId ? {
                ...d,
                timeRanges: d.timeRanges.map((tr)=>tr.id === timeRangeId ? {
                        ...tr,
                        [field]: value
                    } : tr)
            } : d));
    };
    // Validation - returns a map of dateId to error message
    const getValidationErrors = ()=>{
        const errors = new Map();
        // Check for duplicate dates
        const seenDates = new Map();
        for (const date of specialDates)if (date.date) {
            if (seenDates.has(date.date)) {
                // Mark both the original and duplicate
                const originalId = seenDates.get(date.date);
                errors.set(originalId, "Duplicate dates are not allowed.");
                errors.set(date.id, "Duplicate dates are not allowed.");
            } else seenDates.set(date.date, date.id);
        }
        // Check for dates with custom hours but no time ranges
        for (const date of specialDates){
            if (!date.isClosedAllDay && date.timeRanges.length === 0) {
                errors.set(date.id, "Custom hours require at least one time range.");
                continue;
            }
            // Check for overlapping time ranges within a date
            if (!date.isClosedAllDay && date.timeRanges.length > 1) {
                const sortedRanges = [
                    ...date.timeRanges
                ].sort((a, b)=>{
                    const aStart = (0, _weeklyScheduleFormatters.convert12HourTo24Hour)(a.startTime);
                    const bStart = (0, _weeklyScheduleFormatters.convert12HourTo24Hour)(b.startTime);
                    return aStart.localeCompare(bStart);
                });
                for(let i = 0; i < sortedRanges.length - 1; i++){
                    const currentEnd = (0, _weeklyScheduleFormatters.convert12HourTo24Hour)(sortedRanges[i].endTime);
                    const nextStart = (0, _weeklyScheduleFormatters.convert12HourTo24Hour)(sortedRanges[i + 1].startTime);
                    if (currentEnd > nextStart) {
                        errors.set(date.id, "Time ranges cannot overlap.");
                        break;
                    }
                }
            }
            // Check that end time is after start time
            if (!errors.has(date.id)) for (const range of date.timeRanges){
                const start = (0, _weeklyScheduleFormatters.convert12HourTo24Hour)(range.startTime);
                const end = (0, _weeklyScheduleFormatters.convert12HourTo24Hour)(range.endTime);
                if (start >= end) {
                    errors.set(date.id, "End time must be after start time.");
                    break;
                }
            }
        }
        return errors;
    };
    const validationErrors = getValidationErrors();
    const hasErrors = validationErrors.size > 0;
    // Notify parent of validation state changes - only when state actually changes
    (0, _react1.useEffect)(()=>{
        // Only call if the validation state has actually changed
        if (prevHasErrorsRef.current !== hasErrors) {
            prevHasErrorsRef.current = hasErrors;
            if (props.onValidationChange) props.onValidationChange(hasErrors);
        }
    }, [
        hasErrors
    ]);
    return (0, _react.jsx)("div", {
        className: `${containerStyle} ${props.className || ""}`
    }, props.label && (0, _react.jsx)("label", {
        className: labelStyle
    }, props.label), (0, _react.jsx)("div", {
        className: noSpecialDatesContainer
    }, (0, _react.jsx)("label", {
        className: checkboxOption
    }, (0, _react.jsx)("input", {
        type: "checkbox",
        checked: hasNoSpecialDates,
        onChange: (e)=>handleToggleNoSpecialDates(e.target.checked),
        disabled: props.disabled
    }), (0, _react.jsx)("span", null, "We don't have any special closed dates"))), !hasNoSpecialDates && (0, _react.jsx)((0, _reactDefault.default).Fragment, null, (0, _react.jsx)("div", {
        className: datesContainer
    }, specialDates.map((specialDate, index)=>(0, _react.jsx)("div", {
            key: specialDate.id,
            className: dateCard
        }, validationErrors.has(specialDate.id) && (0, _react.jsx)("div", {
            className: dateErrorStyle
        }, validationErrors.get(specialDate.id)), (0, _react.jsx)("div", {
            className: dateHeader
        }, (0, _react.jsx)("span", {
            className: dateLabel
        }, "Date:"), (0, _react.jsx)("div", {
            className: dateInputWrapper
        }, (0, _react.jsx)((0, _textFieldDefault.default), {
            name: `${props.name}_date_${specialDate.id}`,
            type: "date",
            value: specialDate.date,
            onChange: (e)=>handleDateChange(specialDate.id, e.target.value),
            onBlur: props.onBlur,
            disabled: props.disabled
        })), (0, _react.jsx)("button", {
            type: "button",
            className: deleteButton,
            onClick: ()=>handleRemoveDate(specialDate.id),
            disabled: props.disabled
        }, (0, _react.jsx)("img", {
            src: deleteIcon,
            alt: "Remove"
        }))), (0, _react.jsx)("div", {
            className: optionsContainer
        }, (0, _react.jsx)("label", {
            className: radioOption
        }, (0, _react.jsx)("input", {
            type: "radio",
            name: `${props.name}_type_${specialDate.id}`,
            checked: specialDate.isClosedAllDay,
            onChange: ()=>handleToggleClosedAllDay(specialDate.id, true),
            disabled: props.disabled
        }), (0, _react.jsx)("span", null, "Closed all day")), (0, _react.jsx)("label", {
            className: radioOption
        }, (0, _react.jsx)("input", {
            type: "radio",
            name: `${props.name}_type_${specialDate.id}`,
            checked: !specialDate.isClosedAllDay,
            onChange: ()=>handleToggleClosedAllDay(specialDate.id, false),
            disabled: props.disabled
        }), (0, _react.jsx)("span", null, "Custom hours"))), !specialDate.isClosedAllDay && specialDate.timeRanges.length > 0 && (0, _react.jsx)("div", {
            className: closedHoursInfo
        }, calculateClosedHours(specialDate.timeRanges)), !specialDate.isClosedAllDay && (0, _react.jsx)("div", {
            className: timeRangesContainer
        }, (0, _react.jsx)("div", {
            className: openHoursLabel
        }, "Open Hours:"), specialDate.timeRanges.map((timeRange)=>(0, _react.jsx)("div", {
                key: timeRange.id,
                className: timeRangeRow
            }, (0, _react.jsx)("div", {
                className: timeRangeFields
            }, (0, _react.jsx)((0, _selectFieldDefault.default), {
                name: `${props.name}_start_${timeRange.id}`,
                placeholder: "Start time",
                value: timeRange.startTime,
                onChange: (selected)=>handleTimeRangeChange(specialDate.id, timeRange.id, "startTime", selected?.value || ""),
                options: timeOptions,
                disabled: props.disabled,
                clearable: false,
                useForm: false,
                customClassName: modernSelectStyle,
                hideLabel: true
            }), (0, _react.jsx)("span", {
                className: timeSeparator
            }, "—"), (0, _react.jsx)((0, _selectFieldDefault.default), {
                name: `${props.name}_end_${timeRange.id}`,
                placeholder: "End time",
                value: timeRange.endTime,
                onChange: (selected)=>handleTimeRangeChange(specialDate.id, timeRange.id, "endTime", selected?.value || ""),
                options: timeOptions,
                disabled: props.disabled,
                clearable: false,
                useForm: false,
                customClassName: modernSelectStyle,
                hideLabel: true
            })), (0, _react.jsx)("button", {
                type: "button",
                className: smallDeleteButton,
                onClick: ()=>handleRemoveTimeRange(specialDate.id, timeRange.id),
                disabled: props.disabled
            }, (0, _react.jsx)("img", {
                src: deleteIcon,
                alt: "Remove"
            })))), (0, _react.jsx)("button", {
            type: "button",
            className: addTimeRangeButton,
            onClick: ()=>handleAddTimeRange(specialDate.id),
            disabled: props.disabled
        }, (0, _react.jsx)("img", {
            src: addIcon,
            alt: "Add"
        }), "Add time range")))), (0, _react.jsx)("button", {
        type: "button",
        className: addDateButton,
        onClick: handleAddDate,
        disabled: props.disabled
    }, (0, _react.jsx)("img", {
        src: addIcon,
        alt: "Add"
    }), "Add special date"))));
};
const containerStyle = /*#__PURE__*/ (0, _css.css)({
    name: "b6wrti",
    styles: "display:flex;flex-direction:column;width:100%"
});
const labelStyle = /*#__PURE__*/ (0, _css.css)("font-size:14px;font-weight:500;margin-bottom:12px;color:", (0, _colors.color_text_light), ";", "");
const errorStyle = /*#__PURE__*/ (0, _css.css)({
    name: "12abldf",
    styles: "font-size:14px;color:#d32f2f;margin-bottom:12px;padding:8px 12px;background-color:#ffebee;border-radius:4px;border-left:4px solid #d32f2f"
});
const noSpecialDatesContainer = /*#__PURE__*/ (0, _css.css)({
    name: "18uqayh",
    styles: "margin-bottom:16px"
});
const checkboxOption = /*#__PURE__*/ (0, _css.css)("display:flex;align-items:center;gap:8px;font-size:14px;cursor:pointer;padding:12px;border:1px solid ", (0, _colors.color_shades_dark), ";border-radius:6px;background:white;transition:all 0.2s;&:hover{background:#f9f9f9;border-color:", (0, _colors.color_colors_ocean), ';}input[type="checkbox"]{cursor:pointer;width:18px;height:18px;}span{user-select:none;font-weight:500;}', "");
const federalHolidaysContainer = /*#__PURE__*/ (0, _css.css)("margin-bottom:16px;border:1px solid ", (0, _colors.color_shades_dark), ";border-radius:8px;padding:16px;background:white;", "");
const federalHolidaysHeader = /*#__PURE__*/ (0, _css.css)("font-size:14px;font-weight:600;margin-bottom:12px;color:", (0, _colors.color_text_light), ";", "");
const holidaysCheckboxGrid = /*#__PURE__*/ (0, _css.css)({
    name: "1465yk7",
    styles: "display:grid;grid-template-columns:repeat(auto-fill, minmax(220px, 1fr));gap:8px"
});
const holidayCheckboxOption = /*#__PURE__*/ (0, _css.css)({
    name: "1qus4oc",
    styles: 'display:flex;align-items:center;gap:8px;font-size:13px;cursor:pointer;padding:8px;border-radius:4px;transition:background 0.2s;&:hover{background:#f9f9f9;}input[type="checkbox"]{cursor:pointer;width:16px;height:16px;flex-shrink:0;}span{user-select:none;}'
});
const datesContainer = /*#__PURE__*/ (0, _css.css)({
    name: "budh8k",
    styles: "display:flex;flex-direction:column;gap:16px"
});
const dateCard = /*#__PURE__*/ (0, _css.css)("border:1px solid ", (0, _colors.color_shades_dark), ";border-radius:8px;padding:16px;background:white;", "");
const dateErrorStyle = /*#__PURE__*/ (0, _css.css)({
    name: "12abldf",
    styles: "font-size:14px;color:#d32f2f;margin-bottom:12px;padding:8px 12px;background-color:#ffebee;border-radius:4px;border-left:4px solid #d32f2f"
});
const dateHeader = /*#__PURE__*/ (0, _css.css)({
    name: "uh5xjc",
    styles: "display:flex;align-items:center;gap:12px"
});
const dateLabel = /*#__PURE__*/ (0, _css.css)({
    name: "ziw9xg",
    styles: "font-size:14px;font-weight:500;flex-shrink:0"
});
const dateInputWrapper = /*#__PURE__*/ (0, _css.css)({
    name: "fxp7t8",
    styles: "flex:1;min-width:0"
});
const deleteButton = /*#__PURE__*/ (0, _css.css)({
    name: "1aghwdm",
    styles: "background:transparent;border:none;cursor:pointer;padding:8px;display:flex;align-items:center;justify-content:center;opacity:0.6;transition:opacity 0.2s;&:hover{opacity:1;}&:disabled{cursor:not-allowed;opacity:0.3;}img{width:20px;height:20px;}"
});
const optionsContainer = /*#__PURE__*/ (0, _css.css)({
    name: "1izjgb",
    styles: "display:flex;flex-direction:column;gap:8px;margin-bottom:16px"
});
const radioOption = /*#__PURE__*/ (0, _css.css)({
    name: "7x6x6b",
    styles: 'display:flex;align-items:center;gap:8px;font-size:14px;cursor:pointer;input[type="radio"]{cursor:pointer;}span{user-select:none;}'
});
const closedHoursInfo = /*#__PURE__*/ (0, _css.css)("font-size:12px;color:", (0, _colors.color_text_light), ";padding:8px 12px;background:#f8f9fa;border-radius:4px;font-style:italic;margin-bottom:12px;", "");
const timeRangesContainer = /*#__PURE__*/ (0, _css.css)({
    name: "1n5c4dn",
    styles: "display:flex;flex-direction:column;gap:12px;padding:16px;background:#f9f9f9;border-radius:4px;border:1px solid #e8e8e8"
});
const openHoursLabel = /*#__PURE__*/ (0, _css.css)("font-size:13px;font-weight:600;color:", (0, _colors.color_text_light), ";margin-bottom:0;text-transform:uppercase;letter-spacing:0.5px;", "");
const timeRangeRow = /*#__PURE__*/ (0, _css.css)({
    name: "uh5xjc",
    styles: "display:flex;align-items:center;gap:12px"
});
const timeRangeFields = /*#__PURE__*/ (0, _css.css)({
    name: "1h3m280",
    styles: "flex:1;display:flex;align-items:center;gap:12px"
});
const timeSeparator = /*#__PURE__*/ (0, _css.css)("font-size:16px;color:", (0, _colors.color_text_light), ";flex-shrink:0;", "");
const smallDeleteButton = /*#__PURE__*/ (0, _css.css)({
    name: "1txgobc",
    styles: "background:transparent;border:none;cursor:pointer;padding:4px;display:flex;align-items:center;justify-content:center;opacity:0.5;transition:opacity 0.2s;&:hover{opacity:1;}&:disabled{cursor:not-allowed;opacity:0.3;}img{width:16px;height:16px;}"
});
const addTimeRangeButton = /*#__PURE__*/ (0, _css.css)("background:transparent;border:1px dashed ", (0, _colors.color_shades_dark), ";border-radius:4px;padding:8px 12px;cursor:pointer;display:flex;align-items:center;justify-content:center;gap:8px;font-size:14px;color:", (0, _colors.color_colors_ocean), ";transition:all 0.2s;&:hover{background:#f0f0f0;border-color:", (0, _colors.color_colors_ocean), ";}&:disabled{cursor:not-allowed;opacity:0.5;}img{width:16px;height:16px;}", "");
const addDateButton = /*#__PURE__*/ (0, _css.css)("background:white;border:2px dashed ", (0, _colors.color_shades_dark), ";border-radius:8px;padding:16px;cursor:pointer;display:flex;align-items:center;justify-content:center;gap:8px;font-size:14px;font-weight:500;color:", (0, _colors.color_colors_ocean), ";transition:all 0.2s;&:hover{background:#f9f9f9;border-color:", (0, _colors.color_colors_ocean), ";}&:disabled{cursor:not-allowed;opacity:0.5;}img{width:20px;height:20px;}", "");
exports.default = SpecialDateField;

},{"@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","./SelectField":"405B3","./TextField":"7a7bh","../../constants/colors":"1p3OR","../../utils/weeklyScheduleFormatters":"cN6JS","../../utils/scheduleFormatters":"iKWn3","cf92a7bba3b1356a":"cl9rg","e52902c68ccf0187":"7eyKJ","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"iKWn3":[function(require,module,exports) {
/**
 * Utility functions for converting between frontend schedule formats and backend DisabledDays format
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// Re-export types for convenience
// Re-export the time conversion functions for convenience
parcelHelpers.export(exports, "convert12HourTo24Hour", ()=>(0, _weeklyScheduleFormatters.convert12HourTo24Hour));
parcelHelpers.export(exports, "convert24HourTo12Hour", ()=>(0, _weeklyScheduleFormatters.convert24HourTo12Hour));
parcelHelpers.export(exports, "formatDateForBackend", ()=>formatDateForBackend);
parcelHelpers.export(exports, "parseDateFromBackend", ()=>parseDateFromBackend);
parcelHelpers.export(exports, "specialDateToDisabledDay", ()=>specialDateToDisabledDay);
parcelHelpers.export(exports, "disabledDayToSpecialDate", ()=>disabledDayToSpecialDate);
parcelHelpers.export(exports, "specialDatesToDisabledDays", ()=>specialDatesToDisabledDays);
parcelHelpers.export(exports, "disabledDaysToSpecialDates", ()=>disabledDaysToSpecialDates);
parcelHelpers.export(exports, "getDayOfWeek", ()=>getDayOfWeek);
parcelHelpers.export(exports, "isValidDisabledDayFormat", ()=>isValidDisabledDayFormat);
parcelHelpers.export(exports, "cleanDisabledDays", ()=>cleanDisabledDays);
var _weeklyScheduleFormatters = require("./weeklyScheduleFormatters");
const formatDateForBackend = (dateStr)=>{
    if (!dateStr) return "";
    // Parse the date string explicitly to avoid UTC timezone issues
    const [yearStr, monthStr, dayStr] = dateStr.split("-");
    const year = parseInt(yearStr, 10);
    const month = parseInt(monthStr, 10);
    const day = parseInt(dayStr, 10);
    return `${month}/${day}/${year}`;
};
const parseDateFromBackend = (backendDate)=>{
    if (!backendDate) return "";
    try {
        // Remove any time portion if present
        const datePart = backendDate.split("(")[0].trim();
        const parts = datePart.split("/");
        if (parts.length === 3) {
            let [month, day, year] = parts.map(Number);
            // Validate parsed numbers
            if (isNaN(month) || isNaN(day) || isNaN(year)) return "none";
            // Handle 2-digit year
            if (year < 100) year += year < 50 ? 2000 : 1900;
            // Validate date ranges
            if (month < 1 || month > 12 || day < 1 || day > 31 || year < 1900 || year > 2100) return "none";
            return `${year}-${month.toString().padStart(2, "0")}-${day.toString().padStart(2, "0")}`;
        } else if (parts.length === 2) {
            // M/D format - use current year
            const [month, day] = parts.map(Number);
            // Validate parsed numbers
            if (isNaN(month) || isNaN(day)) return "none";
            // Validate date ranges
            if (month < 1 || month > 12 || day < 1 || day > 31) return "none";
            const currentYear = new Date().getFullYear();
            return `${currentYear}-${month.toString().padStart(2, "0")}-${day.toString().padStart(2, "0")}`;
        }
        return "none";
    } catch (error) {
        return "none";
    }
};
const specialDateToDisabledDay = (specialDate)=>{
    const dateStr = formatDateForBackend(specialDate.date);
    if (!dateStr) return "";
    if (specialDate.isClosedAllDay || specialDate.timeRanges.length === 0) return dateStr;
    // Convert time ranges to 24-hour format
    const timeRangeStr = specialDate.timeRanges.map((tr)=>{
        const start = (0, _weeklyScheduleFormatters.convert12HourTo24Hour)(tr.startTime);
        const end = (0, _weeklyScheduleFormatters.convert12HourTo24Hour)(tr.endTime);
        return `${start}-${end}`;
    }).join("|");
    return `${dateStr}(${timeRangeStr})`;
};
const disabledDayToSpecialDate = (disabledDay)=>{
    if (!disabledDay) return null;
    const hasTime = disabledDay.includes("(");
    const datePart = hasTime ? disabledDay.split("(")[0] : disabledDay;
    const date = parseDateFromBackend(datePart);
    if (date === "none" || !date) return null;
    const specialDate = {
        id: `date_${Date.now()}_${Math.random()}`,
        date,
        isClosedAllDay: !hasTime,
        timeRanges: []
    };
    if (hasTime) {
        const timePart = disabledDay.split("(")[1].replace(")", "");
        // Support both pipe and comma delimiters
        const timeRanges = timePart.split(/[|,]/).map((range, index)=>{
            const [start, end] = range.split("-");
            return {
                id: `time_${Date.now()}_${index}`,
                startTime: (0, _weeklyScheduleFormatters.convert24HourTo12Hour)(start),
                endTime: (0, _weeklyScheduleFormatters.convert24HourTo12Hour)(end)
            };
        });
        specialDate.timeRanges = timeRanges;
    }
    return specialDate;
};
const specialDatesToDisabledDays = (specialDates)=>{
    return specialDates.filter((sd)=>sd.date) // Only include dates that have a valid date
    .map(specialDateToDisabledDay).filter(Boolean).join(",");
};
const disabledDaysToSpecialDates = (disabledDays)=>{
    if (!disabledDays) return [];
    return disabledDays.split(",").map((disabledDay)=>disabledDayToSpecialDate(disabledDay.trim())).filter(Boolean);
};
const getDayOfWeek = (dateStr)=>{
    const days = [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday"
    ];
    // Parse the date string explicitly to avoid timezone issues
    const [yearStr, monthStr, dayStr] = dateStr.split("-");
    const year = parseInt(yearStr, 10);
    const month = parseInt(monthStr, 10) - 1; // Month is 0-indexed
    const day = parseInt(dayStr, 10);
    // Create date in UTC to get the correct day of week
    const date = new Date(Date.UTC(year, month, day));
    return days[date.getUTCDay()];
};
const isValidDisabledDayFormat = (disabledDay)=>{
    if (!disabledDay) return false;
    // Check basic format: date or date(time-time|time-time) or date(time-time,time-time)
    const dateTimePattern = /^\d{1,2}\/\d{1,2}(\/\d{2,4})?(\(\d{2}:\d{2}-\d{2}:\d{2}([|,]\d{2}:\d{2}-\d{2}:\d{2})*\))?$/;
    return dateTimePattern.test(disabledDay);
};
const cleanDisabledDays = (disabledDays)=>{
    if (!disabledDays) return "";
    const validDays = disabledDays.split(",").map((d)=>d.trim()).filter(isValidDisabledDayFormat);
    return validDays.join(",");
};

},{"./weeklyScheduleFormatters":"cN6JS","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"ckHtT":[function(require,module,exports) {
/**
 * Utility functions for determining field types and deprecated field handling
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isFoodOrderingModuleWithFlag", ()=>isFoodOrderingModuleWithFlag);
parcelHelpers.export(exports, "isDeprecatedSingleDayTimeRangeField", ()=>isDeprecatedSingleDayTimeRangeField);
parcelHelpers.export(exports, "isDeprecatedSpecialDateField", ()=>isDeprecatedSpecialDateField);
var _featureFlagIds = require("../constants/featureFlagIds");
const SINGLE_DAY_TIME_RANGE_FIELD_ASSOCIATED_VARIABLES = [
    "{MONDAY}",
    "{TUESDAY}",
    "{WEDNESDAY}",
    "{THURSDAY}",
    "{FRIDAY}",
    "{SATURDAY}",
    "{SUNDAY}"
];
const SPECIAL_DATE_FIELD_ASSOCIATED_VARIABLE = "DISABLED_DAYS";
const isFoodOrderingModuleWithFlag = (appContainer, appliedAppTemplate)=>{
    const currentApp = appContainer?.state?.currentApp;
    // Check if app has the Food Ordering feature flag
    const hasFoodOrderingFlag = currentApp?.featureFlags?.some((flag)=>flag.id === (0, _featureFlagIds.FoodOrderingFeatureFlagId));
    if (!hasFoodOrderingFlag) return false;
    return true;
};
const isDeprecatedSingleDayTimeRangeField = (field, appContainer, appliedAppTemplate)=>{
    if (!SINGLE_DAY_TIME_RANGE_FIELD_ASSOCIATED_VARIABLES.includes(field.associatedVariable)) return false;
    return isFoodOrderingModuleWithFlag(appContainer, appliedAppTemplate);
};
const isDeprecatedSpecialDateField = (field, appContainer, appliedAppTemplate)=>{
    if (field.associatedVariable !== SPECIAL_DATE_FIELD_ASSOCIATED_VARIABLE) return false;
    return isFoodOrderingModuleWithFlag(appContainer, appliedAppTemplate);
};

},{"../constants/featureFlagIds":"33vuW","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"l2LQ4":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _modalLayout = require("../structure/ModalLayout");
var _modalLayoutDefault = parcelHelpers.interopDefault(_modalLayout);
var _footerBar = require("../structure/FooterBar");
var _footerBarDefault = parcelHelpers.interopDefault(_footerBar);
var _textField = require("./TextField");
var _textFieldDefault = parcelHelpers.interopDefault(_textField);
var _textAreaField = require("./TextAreaField");
var _textAreaFieldDefault = parcelHelpers.interopDefault(_textAreaField);
var _button = require("../general/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _colors = require("../../constants/colors");
var _applicationVariablesContainer = require("../../hooks/ApplicationVariablesContainer");
var _applicationVariablesContainerDefault = parcelHelpers.interopDefault(_applicationVariablesContainer);
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const closeIcon = require("49e95cf8de2596b3");
const SaveFieldVariationModal = (props)=>{
    const variablesContainer = (0, _applicationVariablesContainerDefault.default).useContainer();
    const [variationName, setVariationName] = (0, _react1.useState)("v1");
    const [variationValue, setVariationValue] = (0, _react1.useState)("");
    const [nameError, setNameError] = (0, _react1.useState)("");
    (0, _react1.useEffect)(()=>{
        setVariationName("v1");
        setVariationValue(props.fieldValue);
        setNameError("");
    }, [
        props.isVisible,
        props.fieldValue
    ]);
    const validateForm = ()=>{
        if (!variationName.trim()) {
            setNameError("Variation name is required");
            return false;
        }
        setNameError("");
        return true;
    };
    const handleSave = async ()=>{
        if (validateForm()) {
            const constantName = `Form_Field_${props.fieldTitle}_${variationName.trim()}`;
            const variable = {
                name: constantName,
                value: variationValue,
                applicationId: props.applicationId
            };
            const result = await variablesContainer.createApplicationVariable(variable);
            if (result?.resultType === "Ok") props.onClose();
        }
    };
    const fullConstantName = `Form_Field_${props.fieldTitle}_${variationName.trim()}`;
    return (0, _react.jsx)((0, _modalLayoutDefault.default), {
        className: modalStyle,
        isVisible: props.isVisible,
        onClose: props.onClose,
        zIndex: 1010
    }, (0, _react.jsx)("div", {
        className: containerStyle
    }, (0, _react.jsx)("div", {
        className: "header-wrapper"
    }, (0, _react.jsx)("h2", null, "Save Field Variation"), (0, _react.jsx)((0, _buttonDefault.default), {
        className: "close-icon",
        themes: [
            "end-tight",
            "icon"
        ],
        icon: closeIcon,
        type: "button",
        onClick: props.onClose
    })), (0, _react.jsx)("div", {
        className: "form-container"
    }, (0, _react.jsx)("div", {
        className: "info-section"
    }, (0, _react.jsx)("p", {
        className: "info-label"
    }, "Field:"), (0, _react.jsx)("p", {
        className: "info-value"
    }, props.fieldTitle)), (0, _react.jsx)((0, _textFieldDefault.default), {
        name: "variationName",
        value: variationName,
        placeholder: "Enter variation name (e.g., v1, v2, seasonal_2024)",
        label: "Variation Name",
        onChange: (e)=>setVariationName(e.target.value),
        useForm: false
    }), (0, _react.jsx)((0, _textAreaFieldDefault.default), {
        name: "variationValue",
        value: variationValue,
        placeholder: "Enter the value to save",
        label: "Value",
        labelClassName: labelNoIndentStyle,
        onChange: (e)=>setVariationValue(e.target.value),
        minRows: 4,
        maxRows: 15,
        useForm: false,
        showResponseVariableTest: true
    }), nameError && (0, _react.jsx)("div", {
        className: "error-message"
    }, nameError), (0, _react.jsx)("div", {
        className: "preview-section"
    }, (0, _react.jsx)("p", {
        className: "preview-label"
    }, "This will be saved as:"), (0, _react.jsx)("p", {
        className: "preview-value"
    }, fullConstantName))), (0, _react.jsx)((0, _footerBarDefault.default), null, (0, _react.jsx)((0, _buttonDefault.default), {
        themes: [
            "primary",
            "wide"
        ],
        onClick: handleSave,
        text: "Save Variation",
        type: "button"
    }), (0, _react.jsx)((0, _buttonDefault.default), {
        themes: [
            "white",
            "end"
        ],
        onClick: props.onClose,
        text: "Cancel",
        type: "button"
    }))));
};
const modalStyle = /*#__PURE__*/ (0, _css.css)({
    name: "1mu7coa",
    styles: "width:50vw;min-width:500px;max-width:700px;height:auto;max-height:80vh;display:flex;flex-direction:column;padding-bottom:100px"
});
const containerStyle = /*#__PURE__*/ (0, _css.css)("display:flex;flex-direction:column;height:100%;overflow:hidden;.header-wrapper{display:flex;justify-content:space-between;align-items:center;padding:24px 32px 16px 32px;border-bottom:solid 1px ", (0, _colors.color_shades_dark), ";flex-shrink:0;h2{margin:0;font-size:24px;font-weight:600;color:", (0, _colors.color_shades_darkest), ";}.close-icon{cursor:pointer;}}.form-container{padding:32px;padding-bottom:16px;flex:1;overflow-y:auto;min-height:0;.info-section{margin-bottom:24px;.info-label{font-size:12px;font-weight:600;color:", (0, _colors.color_shades_darkest), ";margin-bottom:8px;text-transform:uppercase;}.info-value{font-size:14px;color:", (0, _colors.color_shades_darkest), ";padding:12px;background-color:#f5f5f5;border-radius:4px;margin:0;&.truncated{overflow:hidden;text-overflow:ellipsis;white-space:nowrap;}}}.preview-section{margin-top:24px;padding:16px;background-color:#f0f8ff;border-radius:4px;border:1px solid #b3d9ff;.preview-label{font-size:12px;font-weight:600;color:", (0, _colors.color_shades_darkest), ";margin-bottom:8px;}.preview-value{font-size:14px;font-family:monospace;color:", (0, _colors.color_shades_darkest), ";word-break:break-all;margin:0;}}.error-message{color:#e74c3c;font-size:12px;margin-top:4px;margin-bottom:16px;}}", "");
const labelNoIndentStyle = /*#__PURE__*/ (0, _css.css)({
    name: "c7ipkq",
    styles: "margin-left:0!important"
});
exports.default = SaveFieldVariationModal;

},{"@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","../structure/ModalLayout":"b1cO3","../structure/FooterBar":"bibRL","./TextField":"7a7bh","./TextAreaField":"fE54C","../general/Button":"6ymxN","../../constants/colors":"1p3OR","../../hooks/ApplicationVariablesContainer":"65mmm","49e95cf8de2596b3":"93VwA","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"kidfh":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _modalLayout = require("../structure/ModalLayout");
var _modalLayoutDefault = parcelHelpers.interopDefault(_modalLayout);
var _footerBar = require("../structure/FooterBar");
var _footerBarDefault = parcelHelpers.interopDefault(_footerBar);
var _button = require("../general/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _customScrollbars = require("../structure/CustomScrollbars");
var _customScrollbarsDefault = parcelHelpers.interopDefault(_customScrollbars);
var _applicationVariablesContainer = require("../../hooks/ApplicationVariablesContainer");
var _applicationVariablesContainerDefault = parcelHelpers.interopDefault(_applicationVariablesContainer);
var _confirmationDialog = require("../structure/ConfirmationDialog");
var _confirmationDialogDefault = parcelHelpers.interopDefault(_confirmationDialog);
var _removeConfirmation = require("../general/RemoveConfirmation");
var _removeConfirmationDefault = parcelHelpers.interopDefault(_removeConfirmation);
var _colors = require("../../constants/colors");
var _pageError = require("../general/PageError");
var _pageErrorDefault = parcelHelpers.interopDefault(_pageError);
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const closeIcon = require("39232d21a6ba9c6c");
const deleteIcon = require("77bd57074caf6d8");
const ViewFieldVariationsModal = (props)=>{
    const variablesContainer = (0, _applicationVariablesContainerDefault.default).useContainer();
    const [selectedVariation, setSelectedVariation] = (0, _react1.useState)(null);
    const [isDeleteConfirmationOpen, setIsDeleteConfirmationOpen] = (0, _react1.useState)(false);
    const [variationToDelete, setVariationToDelete] = (0, _react1.useState)(null);
    const handleSelect = ()=>{
        if (selectedVariation) {
            props.onSelectVariation(selectedVariation);
            props.onClose();
        }
    };
    const handleDeleteVariation = (e, variation)=>{
        e.preventDefault();
        e.stopPropagation();
        setVariationToDelete(variation);
        setIsDeleteConfirmationOpen(true);
    };
    const confirmDelete = async ()=>{
        if (variationToDelete?.id) {
            const result = await variablesContainer.deleteApplicationVariable(variationToDelete.id);
            if (result?.resultType === "Ok") {
                if (selectedVariation?.id === variationToDelete.id) setSelectedVariation(null);
                setIsDeleteConfirmationOpen(false);
                setVariationToDelete(null);
            }
        }
    };
    const closeDeleteConfirmation = ()=>{
        setIsDeleteConfirmationOpen(false);
        setVariationToDelete(null);
    };
    const extractVariationName = (constantName)=>{
        const prefix = `Form_Field_${props.fieldTitle}_`;
        if (constantName.startsWith(prefix)) return constantName.substring(prefix.length);
        return constantName;
    };
    return (0, _react.jsx)((0, _reactDefault.default).Fragment, null, (0, _react.jsx)((0, _modalLayoutDefault.default), {
        className: modalStyle,
        isVisible: props.isVisible,
        onClose: props.onClose,
        zIndex: 900
    }, (0, _react.jsx)("div", {
        className: containerStyle
    }, (0, _react.jsx)("div", {
        className: "header-wrapper"
    }, (0, _react.jsx)("h2", null, "Saved Variations for ", props.fieldTitle), (0, _react.jsx)((0, _buttonDefault.default), {
        className: "close-icon",
        themes: [
            "end-tight",
            "icon"
        ],
        icon: closeIcon,
        type: "button",
        onClick: props.onClose
    })), (0, _react.jsx)("div", {
        className: "variations-container"
    }, (0, _react.jsx)((0, _customScrollbarsDefault.default), {
        autoHide: true
    }, (0, _react.jsx)("div", {
        className: "scrollable-content"
    }, props.variations.length === 0 ? (0, _react.jsx)("div", {
        className: "empty-state"
    }, (0, _react.jsx)("p", null, "No saved variations found for this field.")) : props.variations.map((variation)=>(0, _react.jsx)("div", {
            key: variation.id ?? variation.name,
            className: `variation-item ${selectedVariation?.id === variation.id ? "selected" : ""}`,
            onClick: ()=>setSelectedVariation(variation)
        }, (0, _react.jsx)("div", {
            className: "variation-header"
        }, (0, _react.jsx)("div", {
            className: "variation-name"
        }, extractVariationName(variation.name)), (0, _react.jsx)("div", {
            className: "variation-actions"
        }, (0, _react.jsx)("div", {
            className: "variation-full-name"
        }, variation.name), (0, _react.jsx)((0, _buttonDefault.default), {
            themes: [
                "icon"
            ],
            icon: deleteIcon,
            onClick: (e)=>handleDeleteVariation(e, variation),
            className: "delete-button",
            type: "button"
        }))), (0, _react.jsx)("div", {
            className: "variation-value"
        }, variation.value)))))), (0, _react.jsx)((0, _footerBarDefault.default), null, (0, _react.jsx)((0, _buttonDefault.default), {
        themes: [
            "primary",
            "wide"
        ],
        onClick: handleSelect,
        text: "Use Selected Variation",
        type: "button",
        disabled: !selectedVariation
    }), (0, _react.jsx)((0, _buttonDefault.default), {
        themes: [
            "white",
            "end"
        ],
        onClick: props.onClose,
        text: "Cancel",
        type: "button"
    })))), isDeleteConfirmationOpen && (0, _react.jsx)((0, _confirmationDialogDefault.default), {
        title: "Delete Variation",
        deleteText: "Delete",
        onClose: closeDeleteConfirmation,
        onConfirm: confirmDelete
    }, (0, _react.jsx)((0, _removeConfirmationDefault.default), {
        memberName: variationToDelete ? extractVariationName(variationToDelete.name) : "",
        removalTarget: "saved variations"
    })), (0, _react.jsx)((0, _pageErrorDefault.default), {
        errors: variablesContainer.errors,
        onClear: ()=>variablesContainer.setErrors([]),
        className: pageErrorStyle
    }));
};
const pageErrorStyle = /*#__PURE__*/ (0, _css.css)({
    name: "1x9h530",
    styles: "z-index:2000"
});
const modalStyle = /*#__PURE__*/ (0, _css.css)({
    name: "uec41c",
    styles: "width:60vw;min-width:600px;max-width:900px;height:70vh;max-height:70vh;display:flex;flex-direction:column"
});
const containerStyle = /*#__PURE__*/ (0, _css.css)("display:flex;flex-direction:column;height:100%;overflow:hidden;.header-wrapper{display:flex;justify-content:space-between;align-items:center;padding:24px 32px 16px 32px;border-bottom:solid 1px ", (0, _colors.color_shades_dark), ";flex-shrink:0;h2{margin:0;font-size:24px;font-weight:600;color:", (0, _colors.color_shades_darkest), ";}.close-icon{cursor:pointer;}}.variations-container{flex:1;overflow:hidden;padding:16px 32px;.scrollable-content{padding-bottom:16px;}.empty-state{display:flex;align-items:center;justify-content:center;height:200px;color:", (0, _colors.color_shades_darker), ";font-style:italic;text-align:center;}.variation-item{padding:16px;border:2px solid ", (0, _colors.color_shades_dark), ";border-radius:8px;margin-bottom:12px;cursor:pointer;transition:all 0.2s ease;background-color:white;&:hover{border-color:", (0, _colors.color_colors_ocean), ";}&.selected{border-color:", (0, _colors.color_colors_ocean), ";border-width:3px;background-color:", (0, _colors.color_colors_light_ocean), ";}.variation-header{display:flex;justify-content:space-between;align-items:baseline;margin-bottom:8px;gap:16px;.variation-name{font-weight:600;font-size:16px;color:", (0, _colors.color_shades_darkest), ";}.variation-full-name{font-size:11px;font-family:monospace;color:", (0, _colors.color_shades_darker), ";flex-shrink:0;}.variation-actions{display:flex;align-items:center;gap:12px;.delete-button{opacity:0.6;transition:opacity 0.2s ease;margin:0;&:hover{opacity:1;}img{width:16px;height:16px;}}}}.variation-value{font-size:14px;color:", (0, _colors.color_shades_darker), ";overflow:hidden;text-overflow:ellipsis;display:-webkit-box;-webkit-line-clamp:3;-webkit-box-orient:vertical;line-height:1.5;white-space:pre-wrap;word-break:break-word;}}}", "");
exports.default = ViewFieldVariationsModal;

},{"@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","../structure/ModalLayout":"b1cO3","../structure/FooterBar":"bibRL","../general/Button":"6ymxN","../structure/CustomScrollbars":"50vFq","../../hooks/ApplicationVariablesContainer":"65mmm","../structure/ConfirmationDialog":"kx7yK","../general/RemoveConfirmation":"elIoY","../../constants/colors":"1p3OR","../general/PageError":"ezFTm","39232d21a6ba9c6c":"93VwA","77bd57074caf6d8":"f9rzT","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jb5TR":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _base = require("@emotion/styled/base");
var _baseDefault = parcelHelpers.interopDefault(_base);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _stylesValues = require("../../constants/stylesValues");
var _languageCollectionAvatar = require("../general/LanguageCollectionAvatar");
var _languageCollectionAvatarDefault = parcelHelpers.interopDefault(_languageCollectionAvatar);
var _lodash = require("lodash");
var _lodashDefault = parcelHelpers.interopDefault(_lodash);
var _languages = require("../../models/extensions/languages");
const TemplateOverviewCard = ({ templateConfiguration })=>{
    var dict = (0, _lodashDefault.default).groupBy(templateConfiguration?.templateApplication?.languages ?? [], (l)=>l.languageGroupCode);
    var languageGroups = Object.keys(dict).map((key)=>({
            key: key,
            label: (0, _languages.getLanguageName)(key),
            subItems: dict[key].map((lang)=>({
                    data: lang,
                    value: lang.id,
                    icon: (0, _languages.getFlagIconForLanguage)(lang),
                    label: `${(0, _languages.getLanguageName)(key)} - ${(0, _languages.getRegionyNameForLanguage)(lang)}`,
                    groupKey: key
                }))
        }));
    languageGroups = (0, _lodashDefault.default).sortBy(languageGroups, (group)=>group.key);
    return (0, _react.jsx)(CardContainer, null, (0, _react.jsx)("h6", null, "Creator:"), (0, _react.jsx)("p", null, templateConfiguration?.ownerName), (0, _react.jsx)("h6", null, "Description"), (0, _react.jsx)("p", null, templateConfiguration?.description), (0, _react.jsx)("div", {
        className: "languages-container"
    }, (0, _react.jsx)("h6", null, "Languages / Regions Supported"), languageGroups?.map((group)=>(0, _react.jsx)("div", {
            key: group.key
        }, (0, _react.jsx)("p", {
            className: "language-group-title"
        }, group.label), (0, _react.jsx)("ul", null, group.subItems?.map((lang)=>(0, _react.jsx)("li", {
                key: lang.value
            }, (0, _react.jsx)((0, _languageCollectionAvatarDefault.default), {
                languages: [
                    lang.data
                ],
                limit: 1
            }), (0, _react.jsx)("p", {
                className: "local-title"
            }, lang.label))))))), (!languageGroups || languageGroups.length == 0) && (0, _react.jsx)("p", null, "Unknown"));
};
const CardContainer = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e12caum00"
})(`
    margin: 32px;
    padding: 24px 32px;
    background: white;
    border: ${(0, _stylesValues.style_border_default)};
    border-radius: 8px;

    h6 {
        font-style: normal;
        font-weight: normal;
        font-size: 16px;
        line-height: 24px;
    }
    >p {
        margin-bottom: 32px;
        margin-top: 16px;
        font-size: 14px;
        line-height: 20px;
    }
    .languages-container {
        margin: 32px 0;
        h6 {
            margin-bottom: 24px;
        }
        .language-group-title {
            font-style: normal;
            font-weight: 600;
            font-size: 14px;
            line-height: 20px;
        }
        ul {
            list-style: none;
            margin: 16px;
            li {
                display: flex;
                align-items: center;
                margin: 0 16px;
                .local-title {
                    margin: 0 12px;       
                    font-style: normal;
                    font-weight: normal;
                    font-size: 14px;
                    line-height: 20px;
                }
            }
        }
    }
`, "");
exports.default = TemplateOverviewCard;

},{"@emotion/styled/base":"lSuFu","@emotion/react":"djZKr","react":"6uln9","../../constants/stylesValues":"dHVVv","../general/LanguageCollectionAvatar":"crbMk","lodash":"3hMBK","../../models/extensions/languages":"8E5Oo","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jPTcP":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _base = require("@emotion/styled/base");
var _baseDefault = parcelHelpers.interopDefault(_base);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _multiFileSelector = require("../forms/MultiFileSelector");
var _multiFileSelectorDefault = parcelHelpers.interopDefault(_multiFileSelector);
var _button = require("./Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _modalTitle = require("./ModalTitle");
var _modalTitleDefault = parcelHelpers.interopDefault(_modalTitle);
var _footerBar = require("../structure/FooterBar");
var _footerBarDefault = parcelHelpers.interopDefault(_footerBar);
var _horizontalSeparator = require("../structure/HorizontalSeparator");
var _horizontalSeparatorDefault = parcelHelpers.interopDefault(_horizontalSeparator);
var _modalLayout = require("../structure/ModalLayout");
var _modalLayoutDefault = parcelHelpers.interopDefault(_modalLayout);
var _pageContainer = require("../structure/PageContainer");
var _pageContainerDefault = parcelHelpers.interopDefault(_pageContainer);
var _fullScreenLayout = require("../../scenes/fullScreenLayout");
var _fullScreenLayoutDefault = parcelHelpers.interopDefault(_fullScreenLayout);
var _colors = require("../../constants/colors");
var _stylesValues = require("../../constants/stylesValues");
var _breakpoints = require("../../constants/breakpoints");
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const closeIcon = require("edd2f76a947023ab");
const SimpleFileImportDialog = (props)=>{
    const [selectedFile, setSelectedFile] = (0, _react1.useState)(null);
    const handleFilesSelected = (files)=>{
        if (files.length > 0) setSelectedFile(files[0]);
    };
    const handleImportClick = ()=>{
        if (selectedFile) props.completeImport(selectedFile);
    };
    return (0, _react.jsx)(SimpleFileImportDialogStyled, {
        isVisible: true,
        onClose: props.onClose
    }, (0, _react.jsx)((0, _fullScreenLayoutDefault.default), null, (0, _react.jsx)((0, _pageContainerDefault.default), {
        fill: true
    }, (0, _react.jsx)(TitleWrapper, null, (0, _react.jsx)((0, _modalTitleDefault.default), null, props.title), (0, _react.jsx)(ButtonWrapper, null, (0, _react.jsx)((0, _buttonDefault.default), {
        themes: [
            "end-tight",
            "icon"
        ],
        icon: closeIcon,
        onClick: props.onClose
    }))), (0, _react.jsx)((0, _horizontalSeparatorDefault.default), null), (0, _react.jsx)("div", {
        className: "fileSelector"
    }, (0, _react.jsx)((0, _multiFileSelectorDefault.default), {
        maxSizeOverrideMegabytes: props.maxSizeOverrideMegabytes,
        onSelected: handleFilesSelected,
        accept: props.acceptFileTypes,
        uploadButtonText: "Select a local file",
        uploadLabel: "Drag a file here"
    }), (0, _react.jsx)("div", {
        className: "fileNameRow"
    }, (0, _react.jsx)("div", {
        className: "fileName"
    }, selectedFile?.name || ""), (0, _react.jsx)("div", {
        className: "fileTypes"
    }, props.acceptFileTypesDisplayText))), (0, _react.jsx)(CustomFooter, {
        className: "import-footer"
    }, (0, _react.jsx)((0, _buttonDefault.default), {
        className: "submitButton",
        type: "button",
        themes: [
            "primary"
        ],
        text: "Import",
        disabled: props.isLoading || !selectedFile,
        loading: props.isLoading,
        onClick: handleImportClick
    }), (0, _react.jsx)("div", {
        className: "selected-count"
    }), (0, _react.jsx)((0, _buttonDefault.default), {
        type: "button",
        themes: [
            "secondary"
        ],
        text: "Cancel",
        onClick: props.onClose,
        disabled: props.isLoading
    })))));
};
const ButtonWrapper = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e19s6n8n3"
})("border-left:", (0, _stylesValues.style_border_default), ";padding:0 0 0 32px;margin:8px 0;");
const TitleWrapper = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e19s6n8n2"
})({
    name: "dexxax",
    styles: "display:flex;flex-direction:row;align-items:center;padding:0 32px;justify-content:space-between"
});
const SimpleFileImportDialogStyled = /*#__PURE__*/ (0, _baseDefault.default)((0, _modalLayoutDefault.default), {
    target: "e19s6n8n1"
})("color:", (0, _colors.color_text_default), ";height:590px;width:750px;min-width:30%;min-height:30%;", (0, _breakpoints.breakpoint_small), "{height:calc(100vh - 100px);}.fileSelector{margin:32px;", (0, _breakpoints.breakpoint_small), "{margin:16px;}}.fileNameRow{margin:8px;margin-bottom:0px;display:flex;flex-direction:row;.fileTypes{font-style:italic;margin-left:auto;}.fileName{font-weight:bold;}}.selected-count{font-style:normal;font-weight:600;font-size:16px;line-height:24px;margin-right:auto;}");
const CustomFooter = /*#__PURE__*/ (0, _baseDefault.default)((0, _footerBarDefault.default), {
    target: "e19s6n8n0"
})({
    name: "1q0eusf",
    styles: "z-index:auto"
});
exports.default = SimpleFileImportDialog;

},{"@emotion/styled/base":"lSuFu","@emotion/react":"djZKr","react":"6uln9","../forms/MultiFileSelector":"gLA6m","./Button":"6ymxN","./ModalTitle":"hIp2B","../structure/FooterBar":"bibRL","../structure/HorizontalSeparator":"Pw3HQ","../structure/ModalLayout":"b1cO3","../structure/PageContainer":"hc1r8","../../scenes/fullScreenLayout":"5mVdG","../../constants/colors":"1p3OR","../../constants/stylesValues":"dHVVv","../../constants/breakpoints":"2F01A","edd2f76a947023ab":"93VwA","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jBTvX":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _papaparse = require("papaparse");
var _papaparseDefault = parcelHelpers.interopDefault(_papaparse);
const useCSVHandler = ()=>{
    const [importedData, setImportedData] = (0, _react.useState)([]);
    const [isLoadingImport, setIsLoadingImport] = (0, _react.useState)(false);
    const csvToArray = (text)=>{
        const parseResult = (0, _papaparseDefault.default).parse(text);
        // Normalize boolean values: remove tick prefix and handle any-case TRUE/FALSE
        return parseResult.data.map((row)=>row.map((cell)=>{
                if (typeof cell === "string") {
                    // Strip leading tick that Excel/export adds to force text treatment,
                    // then do a case-insensitive check so any casing variant round-trips correctly
                    const stripped = cell.startsWith("'") ? cell.slice(1) : cell;
                    const lower = stripped.toLowerCase();
                    if (lower === "true") return "true";
                    if (lower === "false") return "false";
                }
                return cell;
            }));
    };
    const importCSV = (file, processCSVData)=>{
        const reader = new FileReader();
        reader.onloadend = ()=>{
            const csvText = reader.result?.toString();
            if (csvText) {
                const csvArray = csvToArray(csvText);
                const importedFields = processCSVData(csvArray);
                setImportedData(importedFields);
            }
        };
        reader.readAsText(file);
    };
    const convertToCSVFriendly = (text)=>{
        if (text == null || text === undefined) return "";
        const textStr = String(text);
        if (!textStr.length) return "";
        // Check if text starts with characters that Excel interprets as formulas
        const startsWithFormulaChar = /^[=+\-@]/.test(textStr);
        // Check if value is a boolean string that Excel would auto-convert
        const isBooleanLike = /^(true|false)$/i.test(textStr);
        // For boolean-like values, prefix with tick to force Excel to treat as text
        if (isBooleanLike) return `"'${textStr}"`;
        // Check if we need to wrap in quotes (contains comma, quotes, newlines, or starts with formula characters)
        if (textStr.includes(",") || textStr.includes('"') || textStr.includes("\n") || textStr.includes("\r") || startsWithFormulaChar) {
            // For formula characters, prefix with single quote to prevent Excel interpretation
            const escapedText = startsWithFormulaChar ? `'${textStr}` : textStr;
            // Wrap the entire text in double quotes and escape any existing double quotes
            return `"${escapedText.replace(/"/g, '""').replace(/\r?\n/g, " ")}"`;
        }
        // If no special characters, return the text as-is
        return textStr;
    };
    const exportCSV = (data, headers, filename)=>{
        let csvContent = `${headers.map((header)=>convertToCSVFriendly(header)).join(",")}\n`;
        data.forEach((item)=>{
            if (item?.associatedVariable?.length && item?.associatedVariable === item?.value) return; // don't want shared topics fields that are marked as location specific in export
            else if (item?.associatedVariable?.length && item?.associatedVariable !== item?.value) delete item.associatedVariable;
            // Use headers to ensure column order matches
            const row = headers.map((header)=>{
                const value = item[header];
                return convertToCSVFriendly(value != null ? String(value) : "");
            }).join(",");
            csvContent += row + "\n";
        });
        // Add BOM to ensure correct encoding
        const bom = "\uFEFF";
        const blob = new Blob([
            bom + csvContent
        ], {
            type: "text/csv;charset=utf-8;"
        });
        const url = URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.setAttribute("href", url);
        link.setAttribute("download", `${filename}.csv`);
        document.body.appendChild(link);
        link.click();
        link.remove();
    };
    return {
        importedData,
        isLoadingImport,
        setIsLoadingImport,
        importCSV,
        exportCSV
    };
};
exports.default = useCSVHandler;

},{"react":"6uln9","papaparse":"58ztL","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"xlsv2":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _guids = require("../services/guids");
var _guidsDefault = parcelHelpers.interopDefault(_guids);
var _useCSVHandler = require("./UseCSVHandler");
var _useCSVHandlerDefault = parcelHelpers.interopDefault(_useCSVHandler);
const useTemplateFormFieldsHandler = ()=>{
    const [errors, setErrors] = (0, _react.useState)([]);
    const { importedData, importCSV } = (0, _useCSVHandlerDefault.default)();
    // Custom CSV export function for templates (without the filtering logic)
    const exportTemplateCSV = (data, headers, filename)=>{
        // Convert to CSV friendly format
        const convertToCSVFriendly = (text)=>{
            if (text == null || text === undefined) return "";
            const textStr = String(text);
            if (!textStr.length) return "";
            // Check if text starts with characters that Excel interprets as formulas
            const startsWithFormulaChar = /^[=+\-@]/.test(textStr);
            // Check if value is a boolean string that Excel would auto-convert
            const isBooleanLike = /^(true|false)$/i.test(textStr);
            // For boolean-like values, prefix with tick to force Excel to treat as text
            if (isBooleanLike) return `"'${textStr}"`;
            // Check if we need to wrap in quotes (contains comma, quotes, newlines, or starts with formula characters)
            if (textStr.includes(",") || textStr.includes('"') || textStr.includes("\n") || textStr.includes("\r") || startsWithFormulaChar) {
                // For formula characters, prefix with single quote to prevent Excel interpretation
                const escapedText = startsWithFormulaChar ? `'${textStr}` : textStr;
                // Wrap the entire text in double quotes and escape any existing double quotes
                return `"${escapedText.replace(/"/g, '""').replace(/\r?\n/g, " ")}"`;
            }
            // If no special characters, return the text as-is
            return textStr;
        };
        let csvContent = `${headers.map((header)=>convertToCSVFriendly(header)).join(",")}\n`;
        data.forEach((item)=>{
            // Use headers to ensure column order matches
            const row = headers.map((header)=>{
                const value = item[header];
                return convertToCSVFriendly(value != null ? String(value) : "");
            }).join(",");
            csvContent += row + "\n";
        });
        // Add BOM to ensure correct encoding
        const bom = "\uFEFF";
        const blob = new Blob([
            bom + csvContent
        ], {
            type: "text/csv;charset=utf-8;"
        });
        const url = URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.setAttribute("href", url);
        link.setAttribute("download", `${filename}.csv`);
        document.body.appendChild(link);
        link.click();
        link.remove();
    };
    const exportTemplateFormFields = (templateConfiguration, templateName)=>{
        try {
            setErrors([]); // Clear previous errors
            if (!templateConfiguration) {
                setErrors([
                    "No template configuration available for export. Please refresh the page to start over."
                ]);
                return;
            }
            const exportData = [];
            // Extract all form fields from all sections
            templateConfiguration?.templateForm?.templateFormSections?.forEach((section)=>{
                section.templateFormFields?.forEach((field)=>{
                    try {
                        exportData.push({
                            sectionId: null,
                            // Set to null so new IDs are generated on import
                            sectionTitle: section.title,
                            sectionPriority: section.priority,
                            fieldId: null,
                            // Set to null so new IDs are generated on import
                            fieldTitle: field.title,
                            fieldLabel: field.label || "",
                            // Add the label field for "Text Field Label"
                            fieldType: field.fieldType,
                            associatedVariable: field.associatedVariable,
                            placeholder: field.placeholder,
                            tip: field.tip,
                            defaultValue: field.defaultValue,
                            options: field.options ? JSON.stringify(field.options) : "",
                            isRequired: field.isRequired,
                            priority: field.priority
                        });
                    } catch (fieldError) {
                        setErrors((prev)=>[
                                ...prev,
                                `Error processing field "${field.title}": ${fieldError.message}`
                            ]);
                    }
                });
            });
            if (exportData.length === 0) {
                setErrors([
                    "No form fields to export. Please add some form fields to your template before exporting."
                ]);
                return;
            }
            const headers = [
                "sectionId",
                "sectionTitle",
                "sectionPriority",
                "fieldId",
                "fieldTitle",
                "fieldLabel",
                "fieldType",
                "associatedVariable",
                "placeholder",
                "tip",
                "defaultValue",
                "options",
                "isRequired",
                "priority"
            ];
            // Generate filename
            const name = templateName || "template";
            const date = new Date();
            const formattedDate = `${date.getMonth() + 1}-${date.getDate()}-${date.getFullYear()}`;
            const formattedTime = `${date.getHours()}-${date.getMinutes()}`;
            const filename = `${name.toLowerCase().replace(/\s+/g, "-")}-form-fields-${formattedDate}-${formattedTime}`;
            exportTemplateCSV(exportData, headers, filename);
        } catch (error) {
            setErrors([
                `Export failed: ${error.message}. Please try again or refresh the page to start over.`
            ]);
        }
    };
    const convertCSVToTemplateSections = (csvArray)=>{
        try {
            setErrors([]); // Clear previous errors
            if (!csvArray || csvArray.length === 0) {
                const error = "CSV file is empty or invalid. Please select a valid CSV file with template data, or refresh the page to start over.";
                setErrors([
                    error
                ]);
                return [];
            }
            if (csvArray.length < 2) {
                const error = "CSV file must contain headers and at least one data row. Please check your file format or refresh the page to start over.";
                setErrors([
                    error
                ]);
                return [];
            }
            const csvRows = csvArray.slice(1); // Skip header row
            const sectionsMap = new Map();
            let importErrors = [];
            // Validate headers
            const headers = csvArray[0];
            const expectedHeaders = [
                "sectionId",
                "sectionTitle",
                "sectionPriority",
                "fieldId",
                "fieldTitle",
                "fieldLabel",
                "fieldType",
                "associatedVariable",
                "placeholder",
                "tip",
                "defaultValue",
                "options",
                "isRequired",
                "priority"
            ];
            if (headers.length < expectedHeaders.length) {
                const missingHeaders = expectedHeaders.slice(headers.length);
                importErrors.push(`CSV file is missing required columns: ${missingHeaders.join(", ")}. Expected ${expectedHeaders.length} columns, found ${headers.length}. Please update your CSV file with all required columns or refresh the page to start over.`);
            }
            csvRows.forEach((row, rowIndex)=>{
                try {
                    // Skip empty rows
                    if (row.length === 0 || row.every((cell)=>!cell || cell.trim() === "")) return;
                    if (row.length < 14) {
                        const missingColumns = expectedHeaders.slice(row.length);
                        importErrors.push(`Row ${rowIndex + 2} is missing required columns: ${missingColumns.join(", ")}. Please complete all required field values before saving or refresh the page to start over.`);
                        return;
                    }
                    const [sectionId, sectionTitle, sectionPriority, fieldId, fieldTitle, fieldLabel, fieldType, associatedVariable, placeholder, tip, defaultValue, options, isRequired, priority] = row;
                    // Validate required fields
                    if (!sectionTitle || sectionTitle.trim() === "") {
                        importErrors.push(`Row ${rowIndex + 2}: Missing value for "sectionTitle" column. Please complete this required field before saving or refresh the page to start over.`);
                        return;
                    }
                    if (!fieldTitle || fieldTitle.trim() === "") {
                        importErrors.push(`Row ${rowIndex + 2}: Missing value for "fieldTitle" column. Please complete this required field before saving or refresh the page to start over.`);
                        return;
                    }
                    if (!fieldType || fieldType.trim() === "") {
                        importErrors.push(`Row ${rowIndex + 2}: Missing value for "fieldType" column. Please specify a valid field type (text, textarea, select, etc.) before saving or refresh the page to start over.`);
                        return;
                    }
                    // Group fields by section title
                    if (!sectionsMap.has(sectionTitle)) sectionsMap.set(sectionTitle, {
                        title: sectionTitle,
                        priority: parseInt(sectionPriority) || 0,
                        fields: []
                    });
                    const section = sectionsMap.get(sectionTitle);
                    try {
                        let parsedOptions = [];
                        if (options && options.trim() !== "") try {
                            parsedOptions = JSON.parse(options);
                            if (!Array.isArray(parsedOptions)) parsedOptions = [];
                        } catch (optionsError) {
                            importErrors.push(`Row ${rowIndex + 2}: Invalid JSON format in "options" column. Expected format: ["Option 1", "Option 2"]. Please fix this field before saving or refresh the page to start over.`);
                            parsedOptions = [];
                        }
                        section.fields.push({
                            title: fieldTitle,
                            label: fieldLabel,
                            fieldType: fieldType,
                            associatedVariable: associatedVariable || "",
                            placeholder: placeholder || "",
                            tip: tip || "",
                            defaultValue: defaultValue || "",
                            options: parsedOptions,
                            isRequired: isRequired === "true" || isRequired === "TRUE",
                            priority: parseInt(priority) || 0
                        });
                    } catch (fieldError) {
                        importErrors.push(`Row ${rowIndex + 2}: Error processing field "${fieldTitle || "unknown"}": ${fieldError.message}. Please check the field data or refresh the page to start over.`);
                    }
                } catch (rowError) {
                    importErrors.push(`Row ${rowIndex + 2}: Error processing data - please check that all required columns have valid values: ${rowError.message}. Complete all required fields before saving or refresh the page to start over.`);
                }
            });
            setErrors(importErrors);
            const sectionsArray = Array.from(sectionsMap.values());
            if (sectionsArray.length === 0 && importErrors.length === 0) {
                const error = "No valid sections found in CSV file. Please check your data format and ensure all required fields are completed, or refresh the page to start over.";
                setErrors([
                    error
                ]);
            }
            return sectionsArray;
        } catch (error) {
            setErrors([
                `Failed to process CSV file: ${error.message}. Please check your file format and try again, or refresh the page to start over.`
            ]);
            return [];
        }
    };
    const importTemplateFormFields = (file)=>{
        setErrors([]); // Clear previous errors
        try {
            importCSV(file, convertCSVToTemplateSections);
        } catch (error) {
            setErrors([
                `Failed to start import process: ${error.message}. Please try again or refresh the page to start over.`
            ]);
        }
    };
    const createTemplateSections = (importedSections, existingTemplate)=>{
        try {
            const templateConfig = {
                ...existingTemplate
            };
            if (!templateConfig.templateForm) templateConfig.templateForm = {
                templateFormSections: [],
                instructionsMarkdown: ""
            };
            // Clear existing sections - replace with imported ones
            templateConfig.templateForm.templateFormSections = [];
            let creationErrors = [];
            // Add imported sections and fields
            importedSections.forEach((importedSection, sectionIndex)=>{
                try {
                    if (!importedSection.title) {
                        creationErrors.push(`Section ${sectionIndex + 1}: Missing section title. Please ensure the "sectionTitle" column has a value for this section before saving.`);
                        return;
                    }
                    const newSection = {
                        id: (0, _guidsDefault.default)(),
                        title: importedSection.title,
                        priority: importedSection.priority || sectionIndex,
                        instructionsMarkdown: "",
                        templateFormFields: []
                    };
                    if (importedSection.fields && Array.isArray(importedSection.fields)) newSection.templateFormFields = importedSection.fields.map((field, index)=>{
                        try {
                            if (!field.title) {
                                creationErrors.push(`Field ${index + 1} in section "${importedSection.title}": Missing field title. Please ensure the "fieldTitle" column has a value before saving.`);
                                return null;
                            }
                            const newField = {
                                id: (0, _guidsDefault.default)(),
                                templateFormSectionId: newSection.id,
                                title: field.title,
                                label: field.label,
                                fieldType: field.fieldType || "text",
                                associatedVariable: field.associatedVariable || "",
                                placeholder: field.placeholder || "",
                                tip: field.tip || "",
                                defaultValue: field.defaultValue || "",
                                options: field.options || [],
                                isRequired: field.isRequired || false,
                                priority: field.priority || index
                            };
                            return newField;
                        } catch (fieldError) {
                            creationErrors.push(`Error creating field "${field.title || `#${index + 1}`}" in section "${importedSection.title}": ${fieldError.message}. Please check the field data before saving.`);
                            return null;
                        }
                    }).filter((field)=>field !== null);
                    templateConfig.templateForm.templateFormSections.push(newSection);
                } catch (sectionError) {
                    creationErrors.push(`Error processing section "${importedSection.title || `#${sectionIndex + 1}`}": ${sectionError.message}. Please check the section data before saving.`);
                }
            });
            // Re-sort all sections by priority
            templateConfig.templateForm.templateFormSections.sort((a, b)=>a.priority - b.priority);
            templateConfig.templateForm.templateFormSections.forEach((s, i)=>{
                s.priority = i;
            });
            if (creationErrors.length > 0) setErrors(creationErrors);
            return templateConfig;
        } catch (error) {
            setErrors([
                `Failed to create template sections: ${error.message}. Please check your data and try again, or refresh the page to start over.`
            ]);
            return existingTemplate;
        }
    };
    return {
        importedData,
        errors,
        exportTemplateFormFields,
        importTemplateFormFields,
        createTemplateSections,
        setErrors
    };
};
exports.default = useTemplateFormFieldsHandler;

},{"react":"6uln9","../services/guids":"jvaYQ","./UseCSVHandler":"jBTvX","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"G6QZu":[function(require,module,exports) {
module.exports = require("2a74f877e93b5569").getBundleURL("kVLro") + require("42a5cf8c7b70ac5").resolve("i1akX");

},{"2a74f877e93b5569":"c7Tr5","42a5cf8c7b70ac5":"fyJL2"}],"92QFu":[function(require,module,exports) {
module.exports = require("2c65b94cf3e741e8").getBundleURL("kVLro") + require("b8275d73ff396aa8").resolve("eiDVK");

},{"2c65b94cf3e741e8":"c7Tr5","b8275d73ff396aa8":"fyJL2"}],"l7kbi":[function(require,module,exports) {
module.exports = require("d7a13595f35d5b1c").getBundleURL("kVLro") + require("deeec8458915ee1f").resolve("01BRx");

},{"d7a13595f35d5b1c":"c7Tr5","deeec8458915ee1f":"fyJL2"}],"ckPOn":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _unstated = require("unstated");
var _appliedApplicationTemplateContainer = require("../../state/containers/AppliedApplicationTemplateContainer");
var _appliedApplicationTemplateContainerDefault = parcelHelpers.interopDefault(_appliedApplicationTemplateContainer);
var _applicationContainer = require("../../state/containers/ApplicationContainer");
var _applicationContainerDefault = parcelHelpers.interopDefault(_applicationContainer);
var _organizationContainer = require("../../state/containers/OrganizationContainer");
var _organizationContainerDefault = parcelHelpers.interopDefault(_organizationContainer);
var _templateConfigurationContainer = require("../../state/containers/TemplateConfigurationContainer");
var _templateConfigurationContainerDefault = parcelHelpers.interopDefault(_templateConfigurationContainer);
var _applicationEnvironmentsContainer = require("../../state/containers/ApplicationEnvironmentsContainer");
var _applicationEnvironmentsContainerDefault = parcelHelpers.interopDefault(_applicationEnvironmentsContainer);
var _appliedTemplateManagerContent = require("./components/AppliedTemplateManagerContent");
var _appliedTemplateManagerContentDefault = parcelHelpers.interopDefault(_appliedTemplateManagerContent);
var _currentApplicationContainer = require("../../hooks/CurrentApplicationContainer");
var _currentApplicationContainerDefault = parcelHelpers.interopDefault(_currentApplicationContainer);
const ApplicationAppliedTemplateManager = (props)=>{
    // Set current application ID in the container
    const currentAppContainer = (0, _currentApplicationContainerDefault.default).useContainer();
    (0, _react1.useEffect)(()=>{
        if (props.match.params.applicationId) currentAppContainer.setApplicationId(props.match.params.applicationId);
    }, [
        props.match.params.applicationId
    ]);
    return (0, _react.jsx)((0, _unstated.Subscribe), {
        to: [
            (0, _applicationContainerDefault.default),
            (0, _appliedApplicationTemplateContainerDefault.default),
            (0, _organizationContainerDefault.default),
            (0, _templateConfigurationContainerDefault.default),
            (0, _applicationEnvironmentsContainerDefault.default)
        ]
    }, (appContainer, appliedAppTemplateContainer, orgContainer, templateConfigContainer, applicationEnvironmentsContainer)=>(0, _react.jsx)((0, _appliedTemplateManagerContentDefault.default), {
            appContainer: appContainer,
            appliedAppTemplateContainer: appliedAppTemplateContainer,
            orgContainer: orgContainer,
            templateConfigContainer: templateConfigContainer,
            applicationId: props.match.params.applicationId,
            appliedAppTemplateId: props.match.params.appliedAppTemplateId,
            templateConfigurationId: props.match.params.templateConfigurationId,
            history: props.history,
            key: props.match.params.appliedAppTemplateId,
            applicationEnvironmentsContainer: applicationEnvironmentsContainer
        }));
};
exports.default = ApplicationAppliedTemplateManager;

},{"@emotion/react":"djZKr","react":"6uln9","unstated":"grh7p","../../state/containers/AppliedApplicationTemplateContainer":"3XuX7","../../state/containers/ApplicationContainer":"cuqi2","../../state/containers/OrganizationContainer":"dlbaM","../../state/containers/TemplateConfigurationContainer":"aJrgZ","../../state/containers/ApplicationEnvironmentsContainer":"jCULY","./components/AppliedTemplateManagerContent":"dVsUR","../../hooks/CurrentApplicationContainer":"4hT7h","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"dVsUR":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _scrollablePanelBody = require("../../../components/structure/ScrollablePanelBody");
var _scrollablePanelBodyDefault = parcelHelpers.interopDefault(_scrollablePanelBody);
var _loader = require("../../../components/general/Loader");
var _loaderDefault = parcelHelpers.interopDefault(_loader);
var _updateAppliedAppTemplateForm = require("./UpdateAppliedAppTemplateForm");
var _updateAppliedAppTemplateFormDefault = parcelHelpers.interopDefault(_updateAppliedAppTemplateForm);
var _sectionUtils = require("../../../utils/sectionUtils");
var _appliedAppTemplateDetailsForm = require("./AppliedAppTemplateDetailsForm");
var _appliedAppTemplateDetailsFormDefault = parcelHelpers.interopDefault(_appliedAppTemplateDetailsForm);
var _appliedAppTemplateReviewForm = require("./AppliedAppTemplateReviewForm");
var _appliedAppTemplateReviewFormDefault = parcelHelpers.interopDefault(_appliedAppTemplateReviewForm);
var _panelContainer = require("../../../components/structure/Panels/PanelContainer");
var _panelContainerDefault = parcelHelpers.interopDefault(_panelContainer);
var _collapsingPanel = require("../../../components/structure/Panels/CollapsingPanel");
var _collapsingPanelDefault = parcelHelpers.interopDefault(_collapsingPanel);
var _collapsedMenuPanel = require("../../../components/structure/CollapsedMenuPanel");
var _collapsedMenuPanelDefault = parcelHelpers.interopDefault(_collapsedMenuPanel);
var _expandedMenuPanel = require("../../../components/structure/ExpandedMenuPanel");
var _expandedMenuPanelDefault = parcelHelpers.interopDefault(_expandedMenuPanel);
var _appliedAppTemplateSectionMenu = require("./AppliedAppTemplateSectionMenu");
var _appliedAppTemplateSectionMenuDefault = parcelHelpers.interopDefault(_appliedAppTemplateSectionMenu);
var _colors = require("../../../constants/colors");
var _fullPagePanel = require("../../../components/structure/Panels/FullPagePanel");
var _fullPagePanelDefault = parcelHelpers.interopDefault(_fullPagePanel);
var _headerBar = require("../../../components/structure/HeaderBar");
var _headerBarDefault = parcelHelpers.interopDefault(_headerBar);
var _backButton = require("../../../components/general/BackButton");
var _backButtonDefault = parcelHelpers.interopDefault(_backButton);
var _applicationTemplateMenuSelector = require("../../applicationTemplateMenuSelector");
var _applicationTemplateMenuSelectorDefault = parcelHelpers.interopDefault(_applicationTemplateMenuSelector);
var _headerTitleView = require("../../../components/structure/HeaderTitleView");
var _headerTitleViewDefault = parcelHelpers.interopDefault(_headerTitleView);
var _panelHeaderContainer = require("../../../components/structure/Panels/PanelHeaderContainer");
var _panelHeaderContainerDefault = parcelHelpers.interopDefault(_panelHeaderContainer);
var _appliedTemplateStatusIndicator = require("./AppliedTemplateStatusIndicator");
var _appliedTemplateStatusIndicatorDefault = parcelHelpers.interopDefault(_appliedTemplateStatusIndicator);
var _pageError = require("../../../components/general/PageError");
var _pageErrorDefault = parcelHelpers.interopDefault(_pageError);
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const AppliedTemplateManagerContent = (props)=>{
    const [isLeftExpanded, setIsLeftExpanded] = (0, _react1.useState)(localStorage.getItem("contentMenu") == "true");
    const [isFinishSelected, setIsFinishSelected] = (0, _react1.useState)(false);
    const [isStartSelected, setIsStartSelected] = (0, _react1.useState)(true);
    const [currentSection, setCurrentSection] = (0, _react1.useState)(null);
    const [isNew, setIsNew] = (0, _react1.useState)(props.templateConfigurationId && !props.appliedAppTemplateId);
    const [areNoTemplateFormSections, setAreNoTemplateFormSections] = (0, _react1.useState)(false);
    const [fieldValidationErrors, setFieldValidationErrors] = (0, _react1.useState)({});
    const handleFieldValidationChange = (0, _react1.useCallback)((fieldId, hasErrors)=>{
        setFieldValidationErrors((prev)=>({
                ...prev,
                [fieldId]: hasErrors
            }));
    }, []);
    (0, _react1.useEffect)(()=>{
        props.appContainer.loadCurrentAppById(props.applicationId);
    }, []);
    const getCurrentAppliedTemplate = ()=>{
        return props.appliedAppTemplateContainer.state.appliedTemplates?.find((at)=>at.id == props.appliedAppTemplateId);
    };
    const getCurrentSectionIndex = ()=>{
        const appliedTemplateSections = getCurrentAppliedTemplate()?.templateForm?.templateFormSections ?? [];
        const section = appliedTemplateSections.find((s)=>currentSection?.id?.length && s.id == currentSection?.id || currentSection?.dynamicFormFields?.length && s.name === currentSection?.name);
        return appliedTemplateSections.indexOf(section);
    };
    const getCurrentTemplateConfig = ()=>{
        const templateConfig = props.appliedAppTemplateId ? getCurrentAppliedTemplate()?.templateForm?.templateConfiguration : props.templateConfigContainer.state.availableTemplates?.find((t)=>t.id == props.templateConfigurationId);
        return templateConfig;
    };
    const handleToggleExpandLeft = (e, expanded)=>{
        setIsLeftExpanded(expanded);
        localStorage.setItem("contentMenu", expanded?.toString());
        e?.stopPropagation();
    };
    const handleFinishSelected = ()=>{
        setIsFinishSelected(true);
        setIsStartSelected(false);
        setCurrentSection(null);
    };
    const handleStartSelected = ()=>{
        setIsFinishSelected(false);
        setIsStartSelected(true);
        setCurrentSection(null);
    };
    const handleSectionSelected = (section)=>{
        setCurrentSection(section);
        setIsFinishSelected(false);
        setIsStartSelected(false);
    };
    const handleNextSection = (latestFormValues)=>{
        const currentIndex = getCurrentSectionIndex();
        const sections = getCurrentAppliedTemplate()?.templateForm?.templateFormSections;
        props.appliedAppTemplateContainer.finishFormSection(getCurrentAppliedTemplate().id, {
            fieldValues: latestFormValues
        });
        if (sections.length > 0) {
            if (currentIndex == sections.length - 1) {
                setIsFinishSelected(true);
                setIsStartSelected(false);
                setCurrentSection(null);
            } else {
                setCurrentSection(sections[currentIndex + 1]);
                setIsFinishSelected(false);
                setIsStartSelected(false);
            }
        } else {
            setIsFinishSelected(true);
            setIsStartSelected(false);
            setCurrentSection(null);
            setAreNoTemplateFormSections(true);
        }
    };
    const handlePreviousSection = async ()=>{
        let currentDynamicSectionName;
        if (currentSection?.name) currentDynamicSectionName = currentSection.name;
        let currentIndex = getCurrentSectionIndex();
        if (areNoTemplateFormSections) {
            currentIndex = 0;
            setIsFinishSelected(false);
            setIsStartSelected(true);
            setCurrentSection(null);
            setAreNoTemplateFormSections(false);
            return;
        }
        if (currentIndex == 0) {
            setIsFinishSelected(false);
            setIsStartSelected(true);
            setCurrentSection(null);
            return;
        } else if (currentIndex === -1 && isFinishSelected) currentIndex = getCurrentAppliedTemplate()?.templateForm.templateFormSections.length;
        const prevSection = getCurrentAppliedTemplate()?.templateForm.templateFormSections[currentIndex - 1];
        if (prevSection) setCurrentSection(prevSection);
        else setCurrentSection(null);
        if (currentDynamicSectionName) await props.appliedAppTemplateContainer.removeDynamicFormSection(props.appliedAppTemplateId, currentDynamicSectionName);
        setAreNoTemplateFormSections(false);
    };
    const handleClose = ()=>{
        if (props.history.length > 1) props.history.goBack();
        else props.history.push(`/v/apps/${props.applicationId}/templates/`);
    };
    const getBreadCrumbItems = ()=>{
        const app = props.appContainer.state.currentApp;
        const crumbs = [
            {
                id: "org",
                title: props.orgContainer.state.currentOrganization?.name,
                link: "/"
            },
            {
                id: "app",
                title: app?.name,
                link: `/v/apps/${app?.id}`
            }
        ];
        return crumbs;
    };
    const handleInsertDynamicFormSection = async (dynamicSection)=>{
        const newSection = await props.appliedAppTemplateContainer.insertDynamicFormSection(getCurrentAppliedTemplate().id, dynamicSection, currentSection);
        setIsFinishSelected(false);
        setIsStartSelected(false);
        setCurrentSection(newSection);
    };
    const getPageCount = ()=>{
        return ((getCurrentAppliedTemplate()?.templateForm ?? getCurrentTemplateConfig()?.templateForm)?.templateFormSections?.length ?? 0) + 2;
    };
    const getCurrentTemplateForm = ()=>{
        return isNew ? getCurrentTemplateConfig()?.templateForm : getCurrentAppliedTemplate()?.templateForm;
    };
    // Use sectionUtils for section completion logic, matching ApplicationManagerContent
    const getSections = ()=>{
        const appliedTemplate = getCurrentAppliedTemplate();
        // Attach appliedTemplateId to each section for correct completion logic
        return getCurrentTemplateForm()?.templateFormSections?.map((s)=>({
                section: s,
                appliedTemplateId: appliedTemplate?.id,
                isComplete: (0, _sectionUtils.getCompletionStatus)({
                    section: s,
                    appliedTemplateId: appliedTemplate?.id
                }, undefined, props.appliedAppTemplateContainer),
                isDisabled: !props.appliedAppTemplateId
            }));
    };
    const getCurrentPageNumber = ()=>{
        if (isStartSelected) return 1;
        if (isFinishSelected) return getPageCount();
        return getCurrentSectionIndex() + 2;
    };
    const getDefaultTemplateValues = (appliedAppTemplate)=>{
        const templateValues = [];
        appliedAppTemplate?.templateForm?.templateFormSections?.forEach((formSection)=>{
            formSection?.templateFormFields?.forEach((formField)=>{
                if (formField?.defaultValue) {
                    const fieldValue = {
                        value: formField?.defaultValue,
                        fieldType: formField?.fieldType,
                        tip: formField?.tip,
                        title: formField?.title,
                        label: formField?.label,
                        defaultValue: formField?.defaultValue,
                        associatedVariable: formField?.associatedVariable,
                        placeholder: formField?.placeholder,
                        templateFormFieldId: formField?.id
                    };
                    templateValues.push(fieldValue);
                }
            });
        });
        return templateValues;
    };
    const renderMenu = ()=>{
        return (0, _react.jsx)((0, _reactDefault.default).Fragment, null, (0, _react.jsx)((0, _panelHeaderContainerDefault.default), null, (0, _react.jsx)("div", {
            className: "page-indicator-container"
        }, (0, _react.jsx)("p", null, "Step ", getCurrentPageNumber(), " of ", getPageCount()))), (0, _react.jsx)((0, _scrollablePanelBodyDefault.default), {
            className: panelBodyStyle
        }, (0, _react.jsx)((0, _appliedAppTemplateSectionMenuDefault.default), {
            history: props.history,
            applicationId: props.applicationId,
            appContainer: props.appContainer,
            appliedAppTemplateContainer: props.appliedAppTemplateContainer,
            activeSection: currentSection ? {
                section: currentSection,
                isComplete: props.appliedAppTemplateContainer.getIsSectionOfCurrentComplete(getCurrentAppliedTemplate(), currentSection)
            } : null,
            sections: getSections(),
            isFinishSelected: isFinishSelected,
            isStartSelected: isStartSelected,
            isNew: isNew,
            onFinishSelect: handleFinishSelected,
            onStartSelect: handleStartSelected,
            onSectionSelect: handleSectionSelected,
            templateConfigContainer: props.templateConfigContainer,
            orgContainer: props.orgContainer,
            appliedAppTemplateId: props.appliedAppTemplateId,
            fieldValidationErrors: fieldValidationErrors
        })));
    };
    const renderRightBody = ()=>{
        const { isLoading } = props.appliedAppTemplateContainer.state;
        const currentAppliedTemplate = getCurrentAppliedTemplate();
        const defaultValues = getDefaultTemplateValues(currentAppliedTemplate);
        if (currentAppliedTemplate != null && (currentAppliedTemplate?.templateFormFieldValues == null || currentAppliedTemplate?.templateFormFieldValues?.length === 0)) currentAppliedTemplate.templateFormFieldValues = defaultValues;
        if (isLoading) return (0, _react.jsx)((0, _loaderDefault.default), null);
        if (currentSection) return (0, _react.jsx)((0, _updateAppliedAppTemplateFormDefault.default), {
            history: props.history,
            applicationId: props.applicationId,
            appContainer: props.appContainer,
            appliedAppTemplateContainer: props.appliedAppTemplateContainer,
            appliedAppValues: currentAppliedTemplate?.templateFormFieldValues,
            appliedAppTemplate: currentAppliedTemplate,
            templateSection: currentSection,
            insertDynamicFormSection: handleInsertDynamicFormSection,
            onNext: handleNextSection,
            onPrevious: handlePreviousSection,
            onFieldValidationChange: handleFieldValidationChange
        });
        if (isStartSelected) return (0, _react.jsx)((0, _appliedAppTemplateDetailsFormDefault.default), {
            history: props.history,
            applicationId: props.applicationId,
            appContainer: props.appContainer,
            appliedAppTemplateContainer: props.appliedAppTemplateContainer,
            templateConfiguration: getCurrentTemplateConfig(),
            templateForm: getCurrentAppliedTemplate()?.templateForm,
            isNew: isNew,
            onNext: handleNextSection.bind(undefined),
            appliedAppTemplate: getCurrentAppliedTemplate()
        });
        if (isFinishSelected) return (0, _react.jsx)((0, _appliedAppTemplateReviewFormDefault.default), {
            history: props.history,
            applicationId: props.applicationId,
            appContainer: props.appContainer,
            appliedAppTemplate: currentAppliedTemplate,
            templateConfiguration: getCurrentTemplateConfig(),
            appliedAppTemplateContainer: props.appliedAppTemplateContainer,
            appliedAppValues: currentAppliedTemplate?.templateFormFieldValues ?? [],
            onPrevious: handlePreviousSection.bind(undefined),
            onSectionSelect: handleSectionSelected,
            appliedAppTemplateId: currentAppliedTemplate?.id,
            incompleteSections: props.appliedAppTemplateContainer.getIncompleteSections(getCurrentAppliedTemplate()),
            applicationEnvironmentsContainer: props.applicationEnvironmentsContainer,
            fieldValidationErrors: fieldValidationErrors
        });
        return null;
    };
    return (0, _react.jsx)((0, _fullPagePanelDefault.default), {
        className: containerStyle
    }, (0, _react.jsx)((0, _headerBarDefault.default), null, (0, _react.jsx)((0, _backButtonDefault.default), {
        onClick: handleClose.bind(undefined)
    }), (0, _react.jsx)((0, _applicationTemplateMenuSelectorDefault.default), {
        applicationId: props.applicationId,
        history: props.history,
        templateConfiguration: getCurrentTemplateConfig()
    }), (0, _react.jsx)((0, _headerTitleViewDefault.default), {
        text: getCurrentTemplateConfig()?.name,
        breadcrumb: getBreadCrumbItems(),
        app: props.appContainer.state.currentApp
    }), (0, _react.jsx)((0, _appliedTemplateStatusIndicatorDefault.default), {
        status: props.appliedAppTemplateContainer.getCurrentStatus(getCurrentAppliedTemplate())
    })), (0, _react.jsx)((0, _panelContainerDefault.default), {
        className: containerStyle
    }, (0, _react.jsx)("div", {
        className: `${menuStyle} ${isLeftExpanded ? "expanded" : "collapsed"}`
    }, (0, _react.jsx)("div", {
        className: "fixed-wrapper"
    }, (0, _react.jsx)((0, _collapsingPanelDefault.default), {
        isCollapsed: !isLeftExpanded,
        collapsedView: (0, _react.jsx)((0, _collapsedMenuPanelDefault.default), {
            onExpand: (e)=>handleToggleExpandLeft(e, true),
            expandedViewRender: renderMenu
        }),
        expandedView: (0, _react.jsx)((0, _expandedMenuPanelDefault.default), {
            onCollapse: (e)=>handleToggleExpandLeft(e, false),
            expandedViewRender: renderMenu
        })
    }))), (0, _react.jsx)((0, _panelContainerDefault.default), {
        className: formBodyStyle
    }, (0, _react.jsx)("div", {
        className: "form-wrapper"
    }, renderRightBody()))), (0, _react.jsx)((0, _pageErrorDefault.default), {
        errors: props.appliedAppTemplateContainer.state.errors,
        onClear: ()=>props.appliedAppTemplateContainer.clearErrors()
    }));
};
const containerStyle = /*#__PURE__*/ (0, _css.css)("background:", (0, _colors.color_variants_main_bg), ";.form-wrapper{flex:1;min-width:600px;}.empty-indicator{width:100%;height:100%;display:flex;align-items:center;justify-content:center;}.page-indicator-container{background:", (0, _colors.color_shades_lighter), ";border:1px solid ", (0, _colors.color_shades_dark), ";box-sizing:border-box;border-radius:4px;margin:0 32px;height:32px;display:flex;align-items:center;justify-content:center;padding:0 16px;}", "");
const formBodyStyle = /*#__PURE__*/ (0, _css.css)("border-right:1px solid ", (0, _colors.color_shades_dark), ";box-sizing:border-box;.scrollable-body{padding-bottom:56px;}", "");
const panelBodyStyle = /*#__PURE__*/ (0, _css.css)({
    name: "zbunnm",
    styles: "padding-top:0;min-height:100%"
});
const menuStyle = /*#__PURE__*/ (0, _css.css)("z-index:2;bottom:0;position:relative;&.collapsed{width:80px;.fixed-wrapper{width:80px;}}&.expanded{width:288px;.fixed-wrapper{width:288px;}}.fixed-wrapper{position:fixed;bottom:0;height:calc(100vh - 80px);background:white;border-right:1px solid ", (0, _colors.color_shades_dark), ";box-sizing:border-box;}", "");
exports.default = AppliedTemplateManagerContent;

},{"@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","../../../components/structure/ScrollablePanelBody":"6LRg3","../../../components/general/Loader":"bnV5T","./UpdateAppliedAppTemplateForm":"6WWnp","../../../utils/sectionUtils":"1hn3I","./AppliedAppTemplateDetailsForm":"3DNAN","./AppliedAppTemplateReviewForm":"hFrXj","../../../components/structure/Panels/PanelContainer":"9R2lE","../../../components/structure/Panels/CollapsingPanel":"jVPoD","../../../components/structure/CollapsedMenuPanel":"1mVIj","../../../components/structure/ExpandedMenuPanel":"30h7k","./AppliedAppTemplateSectionMenu":"f72qu","../../../constants/colors":"1p3OR","../../../components/structure/Panels/FullPagePanel":"aZqiJ","../../../components/structure/HeaderBar":"5ka3F","../../../components/general/BackButton":"jZrQd","../../applicationTemplateMenuSelector":"4OnfY","../../../components/structure/HeaderTitleView":"4unvp","../../../components/structure/Panels/PanelHeaderContainer":"hUotd","./AppliedTemplateStatusIndicator":"kN958","../../../components/general/PageError":"ezFTm","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6WWnp":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _base = require("@emotion/styled/base");
var _baseDefault = parcelHelpers.interopDefault(_base);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _yup = require("yup");
var _formik = require("formik");
var _loader = require("../../../components/general/Loader");
var _loaderDefault = parcelHelpers.interopDefault(_loader);
var _panelHeaderContainer = require("../../../components/structure/Panels/PanelHeaderContainer");
var _panelHeaderContainerDefault = parcelHelpers.interopDefault(_panelHeaderContainer);
var _button = require("../../../components/general/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _appliedApplicationTemplateSectionForm = require("../../formScenes/AppliedApplicationTemplateSectionForm");
var _appliedApplicationTemplateSectionFormDefault = parcelHelpers.interopDefault(_appliedApplicationTemplateSectionForm);
var _colors = require("../../../constants/colors");
var _templateSaveChangesModal = require("../../../components/templating/TemplateSaveChangesModal");
var _templateSaveChangesModalDefault = parcelHelpers.interopDefault(_templateSaveChangesModal);
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const InnerForm = (props)=>{
    const [recentlyAddedModuleFormFields, setRecentlyAddedModuleFormFields] = (0, _react1.useState)();
    const [showSaveChangesModal, setShowSaveChangesModal] = (0, _react1.useState)(false);
    const [fieldValidationErrors, setFieldValidationErrors] = (0, _react1.useState)({});
    const requiredFields = props.templateSection?.templateFormFields?.filter((f)=>f.isRequired) ?? [];
    const combinedRequiredFields = [
        ...requiredFields,
        ...props.templateSection?.dynamicFormFields?.filter((f)=>f.isRequired) ?? []
    ]; //add required dynamic form fields to required template form fields array
    const completeFields = combinedRequiredFields.filter((f)=>props.values.templateFormValues?.some((v)=>v.dynamicFormFieldName && v.dynamicFormFieldName == f.name && v.value || v.templateFormFieldId && v.templateFormFieldId == f.id && v.value));
    const hasValidationErrors = Object.values(fieldValidationErrors).some((hasError)=>hasError);
    const handleFieldValidationChange = (0, _react1.useCallback)((fieldId, hasErrors)=>{
        setFieldValidationErrors((prev)=>({
                ...prev,
                [fieldId]: hasErrors
            }));
        // Notify parent of validation state change (outside of state setter)
        if (props.onFieldValidationChange) props.onFieldValidationChange(fieldId, hasErrors);
    }, [
        props.onFieldValidationChange
    ]);
    (0, _react1.useEffect)(()=>{
        const recentlyAddedFields = props.templateSection?.templateFormFields?.filter((f)=>f.recentlyAdded) ?? [];
        for (const templateFormSection of props.appliedAppTemplate?.templateForm?.templateFormSections ?? [])for (const templateFormField of templateFormSection?.templateFormFields){
            if (!props.appliedAppTemplate?.templateFormFieldValues.find((templateFormFieldValue)=>templateFormFieldValue.title === templateFormField.title)) {
                if (templateFormField.defaultValue) recentlyAddedFields.push({
                    ...templateFormField,
                    recentlyAdded: true
                });
            }
        }
        setRecentlyAddedModuleFormFields(recentlyAddedFields);
    }, []);
    // Reset field validation errors when template section changes
    (0, _react1.useEffect)(()=>{
        setFieldValidationErrors({});
    }, [
        props.templateSection?.id ?? props.templateSection?.name
    ]);
    (0, _react1.useEffect)(()=>{
        const updatedFieldValues = [
            ...props.appliedAppValues
        ];
        for (const templateFormSection of props.appliedAppTemplate?.templateForm?.templateFormSections ?? []){
            for (const templateFormField of templateFormSection?.templateFormFields)if (!props.appliedAppTemplate?.templateFormFieldValues.find((templateFormFieldValue)=>templateFormFieldValue.title === templateFormField.title)) updatedFieldValues.push({
                value: templateFormField.defaultValue,
                fieldType: templateFormField.fieldType,
                tip: templateFormField.tip,
                title: templateFormField.title,
                label: templateFormField.label,
                defaultValue: templateFormField.defaultValue,
                associatedVariable: templateFormField.associatedVariable,
                placeholder: templateFormField.placeholder,
                templateFormFieldId: templateFormField.id
            });
        }
        props.setFieldValue("templateFormValues", updatedFieldValues);
    }, [
        props.appliedAppValues
    ]);
    const onDynamicFormValueChanged = (field, value)=>{
        const templateValues = props.values.templateFormValues ?? [];
        // if we have the value, update it
        const existingField = templateValues.find((v)=>field.name && v.dynamicFormFieldName == field.name || field.id && v.templateFormFieldId == field.id);
        if (existingField != null) {
            const index = templateValues.indexOf(existingField);
            existingField.value = value;
            templateValues[index] = existingField;
        } else {
            const fieldValue = {
                value: value,
                fieldType: field.fieldType,
                tip: field.tip,
                title: field.title,
                label: field.label,
                defaultValue: field.defaultValue,
                associatedVariable: field.associatedVariable,
                placeholder: field.placeholder
            };
            if (field.name) fieldValue.dynamicFormFieldName = field.name;
            else fieldValue.templateFormFieldId = field.id;
            templateValues.push(fieldValue);
        }
        props.setFieldValue("templateFormValues", templateValues);
    };
    const handleSaveForm = (e)=>{
        if (e) e.preventDefault();
        setShowSaveChangesModal(true);
    };
    const performSave = async ()=>{
        await props.appliedAppTemplateContainer.saveTemplateFields(props.applicationId, props.appliedAppTemplate.id, props.values.templateFormValues, {
            finalize: false,
            useModifiedFieldsOnly: true
        });
    };
    const closeSaveChangesModal = ()=>{
        setShowSaveChangesModal(false);
    };
    const handleNextSection = (e)=>{
        if (e) e.preventDefault();
        // Save and navigate to next section
        props.onNext(props.values.templateFormValues);
    };
    return (0, _react.jsx)((0, _reactDefault.default).Fragment, null, props.appliedAppTemplateContainer.state.isLoading ? (0, _react.jsx)((0, _loaderDefault.default), null) : (0, _react.jsx)("form", {
        className: containerStyle,
        onSubmit: handleNextSection
    }, (0, _react.jsx)((0, _panelHeaderContainerDefault.default), null, (0, _react.jsx)("p", {
        className: "progress-label"
    }, completeFields?.length ?? 0, " of ", requiredFields?.length ?? 0, " required fields on this page are complete"), (0, _react.jsx)("div", {
        className: buttonContainerStyle
    }, (0, _react.jsx)(PreviousButton, {
        disabled: props.appliedAppTemplateContainer.state.isSaving,
        themes: [
            "white-small"
        ],
        text: "Previous",
        type: "button",
        onClick: props.onPrevious
    }), (0, _react.jsx)(SaveButton, {
        loading: props.appliedAppTemplateContainer.state.isSaving,
        disabled: hasValidationErrors || props.appliedAppTemplateContainer.state.isSaving,
        themes: [
            "secondary-small"
        ],
        text: "Save",
        type: "button",
        onClick: handleSaveForm
    }), (0, _react.jsx)(NextButton, {
        disabled: hasValidationErrors || props.appliedAppTemplateContainer.state.isSaving || props.appliedAppTemplate?.templateForm?.templateConfiguration?.dynamicFormUrl != null && combinedRequiredFields.length != completeFields.length,
        loading: props.appliedAppTemplateContainer.state.isSaving,
        themes: [
            "primary-small"
        ],
        text: "Next",
        type: "button",
        onClick: handleNextSection
    }))), props.templateSection && (0, _react.jsx)((0, _appliedApplicationTemplateSectionFormDefault.default), {
        key: props.templateSection?.name ?? props.templateSection?.id,
        section: props.templateSection,
        values: props.values.templateFormValues,
        applicationId: props.applicationId,
        onFieldValueChange: onDynamicFormValueChanged,
        recentlyAddedModuleFormFields: recentlyAddedModuleFormFields,
        showAdminFields: props.showAdminFields,
        appContainer: props.appContainer,
        appliedAppTemplate: props.appliedAppTemplate,
        onFieldValidationChange: handleFieldValidationChange
    })), (0, _react.jsx)((0, _templateSaveChangesModalDefault.default), {
        showSaveChangesModal: showSaveChangesModal,
        closeModal: closeSaveChangesModal,
        changedFields: props.appliedAppTemplateContainer.getChangedFieldsForDisplay(props.appliedAppTemplate.id, props.values.templateFormValues),
        submitChanges: performSave,
        isLoading: props.appliedAppTemplateContainer.state.isSaving,
        hasErrors: false
    }));
};
const PreviousButton = /*#__PURE__*/ (0, _baseDefault.default)((0, _buttonDefault.default), {
    target: "e1d8qlgh2"
})("");
const NextButton = /*#__PURE__*/ (0, _baseDefault.default)((0, _buttonDefault.default), {
    target: "e1d8qlgh1"
})({
    name: "1gz4j9a",
    styles: "margin-left:0"
});
const SaveButton = /*#__PURE__*/ (0, _baseDefault.default)((0, _buttonDefault.default), {
    target: "e1d8qlgh0"
})("");
const containerStyle = /*#__PURE__*/ (0, _css.css)(".progress-label{color:", (0, _colors.color_text_light), ";font-style:normal;font-weight:normal;font-size:14px;line-height:20px;margin:0 32px;}", "");
const buttonContainerStyle = /*#__PURE__*/ (0, _css.css)({
    name: "cv8wgg",
    styles: "margin-right:16px;margin-left:auto;button{margin:0 16px 0 0;}"
});
const UpdateAppliedAppTemplateForm = (0, _formik.withFormik)({
    mapPropsToValues: (props)=>{
        const updatedFieldValues = [
            ...props.appliedAppTemplate?.templateFormFieldValues
        ];
        for (const templateFormSection of props.appliedAppTemplate?.templateForm?.templateFormSections ?? []){
            for (const templateFormField of templateFormSection?.templateFormFields)if (!props.appliedAppTemplate?.templateFormFieldValues.find((templateFormFieldValue)=>templateFormFieldValue.title === templateFormField.title)) updatedFieldValues.push({
                value: templateFormField.defaultValue,
                fieldType: templateFormField.fieldType,
                tip: templateFormField.tip,
                title: templateFormField.title,
                label: templateFormField.label,
                defaultValue: templateFormField.defaultValue,
                associatedVariable: templateFormField.associatedVariable,
                placeholder: templateFormField.placeholder,
                templateFormFieldId: templateFormField.id
            });
        }
        return {
            templateFormValues: updatedFieldValues
        };
    },
    validationSchema: _yup.object().shape({}),
    handleSubmit: async (values, { props })=>{
        // Navigate to next section with latest form values
        props.onNext(values.templateFormValues);
    }
})(InnerForm);
exports.default = UpdateAppliedAppTemplateForm;

},{"@emotion/styled/base":"lSuFu","@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","yup":"j2SJU","formik":"3YnOK","../../../components/general/Loader":"bnV5T","../../../components/structure/Panels/PanelHeaderContainer":"hUotd","../../../components/general/Button":"6ymxN","../../formScenes/AppliedApplicationTemplateSectionForm":"fyhpO","../../../constants/colors":"1p3OR","../../../components/templating/TemplateSaveChangesModal":"4QSXv","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4QSXv":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _base = require("@emotion/styled/base");
var _baseDefault = parcelHelpers.interopDefault(_base);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _colors = require("../../constants/colors");
var _button = require("../general/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _css = require("@emotion/css");
var _modalHeader = require("../general/ModalHeader");
var _modalHeaderDefault = parcelHelpers.interopDefault(_modalHeader);
var _footerBar = require("../structure/FooterBar");
var _footerBarDefault = parcelHelpers.interopDefault(_footerBar);
var _customScrollbars = require("../structure/CustomScrollbars");
var _customScrollbarsDefault = parcelHelpers.interopDefault(_customScrollbars);
var _useWindowSize = require("../../hooks/UseWindowSize");
var _useWindowSizeDefault = parcelHelpers.interopDefault(_useWindowSize);
var _conditionalTooltipWrapper = require("../general/ConditionalTooltipWrapper");
var _conditionalTooltipWrapperDefault = parcelHelpers.interopDefault(_conditionalTooltipWrapper);
var _smallModalLayout = require("../structure/SmallModalLayout");
var _smallModalLayoutDefault = parcelHelpers.interopDefault(_smallModalLayout);
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const alertIcon = require("fe42a9809fa90e6a");
const modifiedIcon = require("69a9d9442af9468e");
const addedIcon = require("800681e22f1911b9");
const removedIcon = require("b0aa98a5125d51c0");
const TemplateSaveChangesModal = (props)=>{
    const windowSize = (0, _useWindowSizeDefault.default)();
    const [changedFields, setChangedFields] = (0, _react1.useState)([]);
    (0, _react1.useEffect)(()=>{
        if (!props.isLoading && props.showSaveChangesModal) setChangedFields(props.changedFields || []);
    }, [
        props.changedFields,
        props.showSaveChangesModal,
        props.isLoading
    ]);
    const saveChangesAndClose = ()=>{
        props.submitChanges();
        props.closeModal();
    };
    const renderFieldChange = (change, index)=>{
        return (0, _react.jsx)(ChangedItemWrapper, {
            key: "change-" + index
        }, (0, _react.jsx)("div", {
            className: change.state === "Removed" ? removedItem : addedOrModifiedItem
        }, change.state), (0, _react.jsx)(ChangedFieldText, null, (0, _react.jsx)(IconAndFieldNameWrapper, null, (0, _react.jsx)(Icon, {
            src: change.state === "Modified" ? modifiedIcon : change.state === "Added" ? addedIcon : removedIcon
        }), (0, _react.jsx)(FieldName, null, change.fieldName)), change.state === "Modified" && (0, _react.jsx)(ValueChange, null, '"', change.oldValue, '" → "', change.newValue, '"'), change.state === "Added" && change.newValue && (0, _react.jsx)(ValueChange, null, 'Value: "', change.newValue, '"'), change.state === "Removed" && change.oldValue && (0, _react.jsx)(ValueChange, null, 'Was: "', change.oldValue, '"')));
    };
    const renderButtonText = ()=>{
        if (changedFields?.length > 0) return "Save";
        else return "Sync";
    };
    const renderExplanationText = ()=>{
        if (props.isFinishAction && changedFields?.length > 0) return (0, _react.jsx)(ExplanationText, null, "This will apply all updates to your live assistant. Once published, your assistant will begin using the new configuration.");
        else if (changedFields?.length > 0) return (0, _react.jsx)(ExplanationText, null, "This will save your progress in the form, but it won't update your assistant yet. To apply these changes to your live assistant, go to the Review section and click Finish.");
        else return (0, _react.jsx)(ExplanationText, null, "It looks like your form doesn't have any unsaved updates.", (0, _react.jsx)("br", null), (0, _react.jsx)("br", null), "Sync to update your assistant with the latest Voicify enhancements.");
    };
    let tooltip = "";
    if (!props.isLoading) {
        if (props.hasErrors) tooltip = "You have errors in your form";
        else if (changedFields?.length === 0) tooltip = "You don't have any changes to save";
    }
    const changesPresent = changedFields?.length > 0;
    return (0, _react.jsx)((0, _smallModalLayoutDefault.default), {
        className: saveChangesModal,
        isVisible: props.showSaveChangesModal
    }, (0, _react.jsx)((0, _modalHeaderDefault.default), {
        title: changesPresent ? "Save Changes" : "Sync Assistant",
        onClose: ()=>props.closeModal()
    }), props.hasErrors && !props.isLoading && (0, _react.jsx)(ErrorStyle, null, (0, _react.jsx)(AlertIcon, {
        src: alertIcon
    }), "You have errors in your template form"), (0, _react.jsx)(SaveChangesWrapper, null, changesPresent && (0, _react.jsx)(Title, null, "Save All Changes?"), renderExplanationText(), changesPresent && (0, _react.jsx)(ChangedText, null, "Here's what's changed:"), (0, _react.jsx)(ChangeSummary, null, (0, _react.jsx)((0, _customScrollbarsDefault.default), {
        autoHide: true,
        autoHeight: true,
        autoHeightMin: windowSize.windowSize.innerHeight * .6 - 190,
        autoHeightMax: windowSize.windowSize.innerHeight * .6 - 190
    }, (0, _react.jsx)("div", null, changedFields?.map((change, index)=>renderFieldChange(change, index)))))), (0, _react.jsx)((0, _footerBarDefault.default), null, (0, _react.jsx)((0, _conditionalTooltipWrapperDefault.default), {
        place: "top",
        showTooltip: !!tooltip,
        text: tooltip
    }, (0, _react.jsx)(SaveButtonWrapper, null, (0, _react.jsx)((0, _buttonDefault.default), {
        type: "button",
        themes: [
            "primary"
        ],
        text: renderButtonText(),
        loading: props.isLoading,
        disabled: props.isLoading || props.hasErrors,
        onClick: ()=>saveChangesAndClose()
    }))), (0, _react.jsx)((0, _buttonDefault.default), {
        type: "button",
        themes: [
            "secondary"
        ],
        text: "Cancel",
        disabled: props.isLoading,
        onClick: ()=>props.closeModal()
    })));
};
exports.default = TemplateSaveChangesModal;
const IconAndFieldNameWrapper = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e14l8hjh13"
})({
    name: "s5xdrg",
    styles: "display:flex;align-items:center"
});
const FieldName = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e14l8hjh12"
})("");
const ChangeSummary = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e14l8hjh11"
})({
    name: "acf2e7",
    styles: "padding:16px 0"
});
const Title = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e14l8hjh10"
})({
    name: "18uqayh",
    styles: "margin-bottom:16px"
});
const SaveChangesWrapper = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e14l8hjh9"
})({
    name: "knjsbg",
    styles: "padding:32px"
});
const ChangedFieldText = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e14l8hjh8"
})({
    name: "xsod9j",
    styles: "font-style:italic;display:flex;flex-direction:column"
});
const ValueChange = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e14l8hjh7"
})("font-size:12px;color:", (0, _colors.color_text_light), ";margin-top:4px;margin-left:24px;");
const SaveButtonWrapper = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e14l8hjh6"
})({
    name: "1tx1l5v",
    styles: "margin-right:auto"
});
const saveChangesModal = /*#__PURE__*/ (0, _css.css)({
    name: "gl079z",
    styles: "height:80%;width:30%;min-width:450px"
});
const ExplanationText = /*#__PURE__*/ (0, _baseDefault.default)("p", {
    target: "e14l8hjh5"
})({
    name: "1rgcpx4",
    styles: "font-size:14px;margin-bottom:16px"
});
const ChangedText = /*#__PURE__*/ (0, _baseDefault.default)("p", {
    target: "e14l8hjh4"
})({
    name: "157k2o",
    styles: "margin-top:32px;margin-bottom:0;font-weight:bold"
});
const ChangedItemWrapper = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e14l8hjh3"
})({
    name: "1tpzalm",
    styles: "padding-top:16px;display:flex;align-items:flex-start;&:first-of-type{padding-top:0;}"
});
const addedOrModifiedItem = /*#__PURE__*/ (0, _css.css)("color:", (0, _colors.color_text_light), ";font-style:italic;min-width:80px;", "");
const removedItem = /*#__PURE__*/ (0, _css.css)("color:", (0, _colors.faded_red), ";font-style:italic;min-width:80px;", "");
const Icon = /*#__PURE__*/ (0, _baseDefault.default)("img", {
    target: "e14l8hjh2"
})({
    name: "1lwdwsh",
    styles: "padding:0 8px;width:32px"
});
const ErrorStyle = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e14l8hjh1"
})('display:flex;align-items:center;justify-content:flex-start;font-family:Muli,"sans-serif";font-weight:normal;color:', (0, _colors.color_shades_darkest), ";background-color:", (0, _colors.color_variants_decline_light_1), ";border:1px solid ", (0, _colors.color_colors_decline), ";border-radius:8px;flex-grow:1;padding:8px 16px;margin:8px 0;font-size:14px;margin:16px 32px 0px 32px;");
const AlertIcon = /*#__PURE__*/ (0, _baseDefault.default)("img", {
    target: "e14l8hjh0"
})({
    name: "1oaeivz",
    styles: "margin-right:8px"
});

},{"@emotion/styled/base":"lSuFu","@emotion/react":"djZKr","react":"6uln9","../../constants/colors":"1p3OR","../general/Button":"6ymxN","@emotion/css":"awUBr","../general/ModalHeader":"aUACx","../structure/FooterBar":"bibRL","../structure/CustomScrollbars":"50vFq","../../hooks/UseWindowSize":"43j9z","../general/ConditionalTooltipWrapper":"92m0T","../structure/SmallModalLayout":"khwvt","fe42a9809fa90e6a":"cRA6k","69a9d9442af9468e":"8yrG0","800681e22f1911b9":"hst2e","b0aa98a5125d51c0":"37PeV","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3DNAN":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _yup = require("yup");
var _formik = require("formik");
var _loader = require("../../../components/general/Loader");
var _loaderDefault = parcelHelpers.interopDefault(_loader);
var _panelHeaderContainer = require("../../../components/structure/Panels/PanelHeaderContainer");
var _panelHeaderContainerDefault = parcelHelpers.interopDefault(_panelHeaderContainer);
var _button = require("../../../components/general/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _colors = require("../../../constants/colors");
var _panelContainer = require("../../../components/structure/Panels/PanelContainer");
var _panelContainerDefault = parcelHelpers.interopDefault(_panelContainer);
var _templateInstructionsPanel = require("./TemplateInstructionsPanel");
var _templateInstructionsPanelDefault = parcelHelpers.interopDefault(_templateInstructionsPanel);
var _scrollablePanelBody = require("../../../components/structure/ScrollablePanelBody");
var _scrollablePanelBodyDefault = parcelHelpers.interopDefault(_scrollablePanelBody);
var _confirmationDialog = require("../../../components/structure/ConfirmationDialog");
var _confirmationDialogDefault = parcelHelpers.interopDefault(_confirmationDialog);
var _appliedTemplateDeleteConfirmation = require("./AppliedTemplateDeleteConfirmation");
var _appliedTemplateDeleteConfirmationDefault = parcelHelpers.interopDefault(_appliedTemplateDeleteConfirmation);
var _textField = require("../../../components/forms/TextField");
var _textFieldDefault = parcelHelpers.interopDefault(_textField);
var _customScrollbars = require("../../../components/structure/CustomScrollbars");
var _customScrollbarsDefault = parcelHelpers.interopDefault(_customScrollbars);
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const deleteIcon = require("4f9086b31c3f6dbc");
const InnerForm = (props)=>{
    const [isDeleteConfirmationOpen, setIsDeleteConfirmationOpen] = (0, _react1.useState)(false);
    const handleDeleteConfirm = ()=>{
        props.appliedAppTemplateContainer.removeAppliedTemplate(props.applicationId, props.appliedAppTemplate?.id, (result)=>{
            setIsDeleteConfirmationOpen(false);
            props.history.push(`/v/apps/${props.applicationId}`);
        });
    };
    const handleCloseModals = ()=>{
        setIsDeleteConfirmationOpen(false);
    };
    const handleOpenDelete = ()=>{
        setIsDeleteConfirmationOpen(true);
    };
    const templateConfiguration = props.templateConfiguration;
    if (props.appliedAppTemplateContainer.state.isLoading) return (0, _react.jsx)((0, _loaderDefault.default), null);
    return (0, _react.jsx)((0, _reactDefault.default).Fragment, null, (0, _react.jsx)("form", {
        onSubmit: props.handleSubmit
    }, (0, _react.jsx)((0, _panelHeaderContainerDefault.default), null, (0, _react.jsx)("div", {
        className: buttonContainerStyle
    }, (0, _react.jsx)((0, _buttonDefault.default), {
        disabled: props.appliedAppTemplateContainer.state.isSaving,
        loading: props.appliedAppTemplateContainer.state.isSaving,
        themes: [
            "primary-small"
        ],
        text: props.isNew ? "Enable & Start" : "Next",
        type: "button",
        onClick: ()=>{
            props.submitForm();
        }
    }))), (0, _react.jsx)((0, _panelContainerDefault.default), null, (0, _react.jsx)((0, _customScrollbarsDefault.default), {
        className: previewStyle,
        autoHide: true,
        autoHeight: true,
        autoHeightMax: "calc(100vh - 136px)"
    }, (0, _react.jsx)("div", {
        className: containerStyle
    }, (0, _react.jsx)("div", {
        className: "section-header"
    }, (0, _react.jsx)("h4", null, "Overview"), props.appliedAppTemplate?.id && (0, _react.jsx)((0, _buttonDefault.default), {
        text: "Remove",
        rightIcon: deleteIcon,
        themes: [
            "flat",
            "end"
        ],
        type: "button",
        onClick: handleOpenDelete.bind(undefined)
    })), !props.isNew && (0, _react.jsx)("div", {
        className: "template-card name-card"
    }, (0, _react.jsx)("div", {
        className: "instance-name template-details"
    }, (0, _react.jsx)("h5", null, "Instance Name"), (0, _react.jsx)("p", null, "You can create an individual name for this instance of the module you’re using to help keep track of its purpose")), (0, _react.jsx)((0, _textFieldDefault.default), {
        name: "name",
        value: props.values.name,
        label: "Name",
        className: "name-field",
        placeholder: "My Module Instance",
        onChange: props.handleChange,
        onBlur: props.handleBlur,
        disabled: props.appliedAppTemplateContainer.state.isSaving
    })), (0, _react.jsx)("div", {
        className: "template-card"
    }, (0, _react.jsx)("div", {
        className: "image-wrapper"
    }, (0, _react.jsx)("img", {
        src: templateConfiguration?.imageUrl
    })), (0, _react.jsx)("div", {
        className: "template-details"
    }, (0, _react.jsx)("h5", null, templateConfiguration?.name), (0, _react.jsx)("h5", null, "Description"), (0, _react.jsx)("p", null, templateConfiguration?.description))))), (0, _react.jsx)((0, _scrollablePanelBodyDefault.default), {
        className: previewStyle
    }, (0, _react.jsx)((0, _templateInstructionsPanelDefault.default), {
        title: "Preview",
        instructionsMarkdown: templateConfiguration?.templateForm?.instructionsMarkdown ?? props.templateForm?.instructionsMarkdown ?? null
    })))), isDeleteConfirmationOpen && (0, _react.jsx)((0, _confirmationDialogDefault.default), {
        title: `Delete all template content?`,
        deleteText: "Remove & Delete",
        isLoading: props.appliedAppTemplateContainer.state.isSaving,
        onClose: handleCloseModals,
        onConfirm: handleDeleteConfirm
    }, (0, _react.jsx)((0, _appliedTemplateDeleteConfirmationDefault.default), null)));
};
const buttonContainerStyle = /*#__PURE__*/ (0, _css.css)({
    name: "cv8wgg",
    styles: "margin-right:16px;margin-left:auto;button{margin:0 16px 0 0;}"
});
const previewStyle = /*#__PURE__*/ (0, _css.css)({
    name: "p7es8o",
    styles: "height:calc(100% - 120px)"
});
const containerStyle = /*#__PURE__*/ (0, _css.css)("min-height:100%;flex:1;padding-bottom:64px;.section-header{display:flex;align-items:center;button{margin-right:0;margin-left:auto;}}h4{font-style:normal;font-weight:normal;font-size:18px;line-height:24px;color:", (0, _colors.color_text_default), ";margin:32px;}.template-card{flex:1;margin:0 32px;box-sizing:border-box;border-radius:8px;background:white;border:1px solid ", (0, _colors.color_shades_dark), ";overflow:hidden;&.name-card{margin-bottom:32px;}.image-wrapper{display:flex;align-items:center;justify-content:center;border-bottom:1px solid ", (0, _colors.color_shades_dark), ";padding:16px;img{height:240px;width:auto;}}.template-details{padding:0 32px 32px 32px;h5{font-style:normal;font-weight:normal;font-size:18px;line-height:24px;margin-top:32px;margin-bottom:16px;}p{font-style:normal;font-weight:normal;font-size:14px;line-height:20px;}}.instance-name{h5{border-bottom:1px solid ", (0, _colors.color_shades_dark), ";padding-bottom:16px;}}.name-field{margin:0px 32px 32px 32px;}}", "");
const AppliedAppTemplateDetailsForm = (0, _formik.withFormik)({
    mapPropsToValues: (props)=>{
        return {
            name: props.appliedAppTemplate?.name ?? ""
        };
    },
    validationSchema: _yup.object().shape({}),
    handleSubmit: (values, { props })=>{
        if (props.isNew) props.appliedAppTemplateContainer.addAppliedTemplateToApp(props.applicationId, props.templateConfiguration?.id).then((result)=>{
            if (result.resultType == "Ok") props.history.replace(`/v/apps/${props.applicationId}/templates/${result.data.id}`, "urlhistory");
        });
        else props.appliedAppTemplateContainer.updateAppliedTemplate(props.appliedAppTemplate?.id, {
            templateFormFieldValues: props.appliedAppTemplate?.templateFormFieldValues ?? [],
            name: values.name
        }).then((result)=>{
            if (result.resultType == "Ok") setTimeout(props.onNext, 1); // we want to elevate the transition to the main thread
        });
    }
})(InnerForm);
exports.default = AppliedAppTemplateDetailsForm;

},{"@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","yup":"j2SJU","formik":"3YnOK","../../../components/general/Loader":"bnV5T","../../../components/structure/Panels/PanelHeaderContainer":"hUotd","../../../components/general/Button":"6ymxN","../../../constants/colors":"1p3OR","../../../components/structure/Panels/PanelContainer":"9R2lE","./TemplateInstructionsPanel":"ddl48","../../../components/structure/ScrollablePanelBody":"6LRg3","../../../components/structure/ConfirmationDialog":"kx7yK","./AppliedTemplateDeleteConfirmation":"efgKi","../../../components/forms/TextField":"7a7bh","../../../components/structure/CustomScrollbars":"50vFq","4f9086b31c3f6dbc":"f9rzT","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"efgKi":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _colors = require("../../../constants/colors");
const bombIcon = require("6ea28b3abd5855e3");
const AppliedTemplateDeleteConfirmation = (props)=>(0, _react.jsx)("div", {
        className: containerStyle
    }, (0, _react.jsx)("img", {
        src: bombIcon
    }), (0, _react.jsx)("p", null, "Removing this template will delete all synced content"));
const containerStyle = /*#__PURE__*/ (0, _css.css)("display:flex;flex-direction:column;align-items:center;justify-content:center;margin:64px;img{width:82px;height:82px;margin-bottom:32px;}p{font-family:Muli;font-size:18px;font-weight:normal;font-style:normal;font-stretch:normal;line-height:normal;letter-spacing:0.5px;text-align:center;color:", (0, _colors.dark_grey_blue), ";}", "");
exports.default = AppliedTemplateDeleteConfirmation;

},{"@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","../../../constants/colors":"1p3OR","6ea28b3abd5855e3":"a89nH","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hFrXj":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _yup = require("yup");
var _formik = require("formik");
var _loader = require("../../../components/general/Loader");
var _loaderDefault = parcelHelpers.interopDefault(_loader);
var _panelHeaderContainer = require("../../../components/structure/Panels/PanelHeaderContainer");
var _panelHeaderContainerDefault = parcelHelpers.interopDefault(_panelHeaderContainer);
var _button = require("../../../components/general/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _customScrollbars = require("../../../components/structure/CustomScrollbars");
var _customScrollbarsDefault = parcelHelpers.interopDefault(_customScrollbars);
var _colors = require("../../../constants/colors");
var _templateReviewSection = require("./TemplateReviewSection");
var _templateReviewSectionDefault = parcelHelpers.interopDefault(_templateReviewSection);
var _panelContainer = require("../../../components/structure/Panels/PanelContainer");
var _panelContainerDefault = parcelHelpers.interopDefault(_panelContainer);
var _templateSaveChangesModal = require("../../../components/templating/TemplateSaveChangesModal");
var _templateSaveChangesModalDefault = parcelHelpers.interopDefault(_templateSaveChangesModal);
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const completeIcon = require("74143d240979afe4");
const incompleteIcon = require("b65da6617ec7213f");
const generateIcon = require("611c550a1f9ac0cc");
const processingIcon = require("226403c95691e2b7");
const successfulSyncIcon = require("6b58136a767596f1");
const errorIcon = require("3ca44aba89fb538c");
const InnerForm = (props)=>{
    const [isFormSubmitted, setIsFormSubmitted] = (0, _react1.useState)(false);
    const [showSaveChangesModal, setShowSaveChangesModal] = (0, _react1.useState)(false);
    const [modifiedFields, setModifiedFields] = (0, _react1.useState)([]);
    (0, _react1.useEffect)(()=>{
        props.applicationEnvironmentsContainer.loadEnvironments(props.applicationId);
    }, [
        props.applicationId
    ]);
    (0, _react1.useEffect)(()=>{
        props.setFieldValue("templateFormValues", props.appliedAppValues);
        if (isFormSubmitted) setIsFormSubmitted(false);
    }, [
        props.appliedAppValues
    ]);
    const handleFormSubmit = (e)=>{
        if (e) e.preventDefault();
        for (const [index, templateFormValue] of props.values.templateFormValues.entries())if (templateFormValue.value === "") {
            if (templateFormValue.defaultValue === "" || templateFormValue.defaultValue === null || templateFormValue.defaultValue === undefined) props.setFieldValue(`templateFormValues.${index}.value`, null);
            else props.setFieldValue(`templateFormValues.${index}.value`, templateFormValue.defaultValue);
        }
    // Don't call props.handleSubmit() here - let the modal handle it
    };
    const handleFinishAction = ()=>{
        // For the review form, always show the modal since this is the final confirmation
        setShowSaveChangesModal(true);
    };
    const performFinish = async (modifiedFieldsOnly)=>{
        // Process form values before submitting
        for (const [index, templateFormValue] of props.values.templateFormValues.entries())if (templateFormValue.value === "") {
            if (templateFormValue.defaultValue === "" || templateFormValue.defaultValue === null || templateFormValue.defaultValue === undefined) await props.setFieldValue(`templateFormValues.${index}.value`, null);
            else await props.setFieldValue(`templateFormValues.${index}.value`, templateFormValue.defaultValue);
        }
        // Store modified fields in form values for use in submission
        if (modifiedFieldsOnly && modifiedFieldsOnly.length > 0) await props.setFieldValue("modifiedFields", modifiedFieldsOnly);
        setIsFormSubmitted(true);
        props.handleSubmit();
    };
    const submitForm = ()=>{
        handleFinishAction();
    };
    const closeSaveChangesModal = ()=>{
        setShowSaveChangesModal(false);
    };
    const goBack = ()=>{
        props.history.goBack();
    };
    const incompleteSections = props.incompleteSections;
    const hasValidationErrors = props.fieldValidationErrors ? Object.values(props.fieldValidationErrors).some((hasError)=>hasError) : false;
    // Get sections with validation errors for user-friendly error messages
    const getSectionsWithValidationErrors = ()=>{
        if (!props.fieldValidationErrors || !props.appliedAppTemplate?.templateForm?.templateFormSections) return [];
        const sectionsWithErrors = [];
        const sections = props.appliedAppTemplate.templateForm.templateFormSections;
        for (const section of sections){
            const sectionFieldIds = section.templateFormFields?.map((f)=>f.id || f.name) || [];
            const hasErrorsInSection = sectionFieldIds.some((fieldId)=>props.fieldValidationErrors[fieldId] === true);
            if (hasErrorsInSection && section.title) sectionsWithErrors.push(section);
        }
        return sectionsWithErrors;
    };
    const sectionsWithValidationErrors = getSectionsWithValidationErrors();
    // Render clickable section links
    const renderSectionLinks = (sections, prefix)=>{
        return (0, _react.jsx)((0, _reactDefault.default).Fragment, null, prefix, " ", sections.map((section, index)=>(0, _react.jsx)((0, _reactDefault.default).Fragment, {
                key: section.id || section.name || index
            }, props.onSectionSelect ? (0, _react.jsx)("a", {
                href: "#",
                onClick: (e)=>{
                    e.preventDefault();
                    props.onSectionSelect(section);
                },
                className: "section-link"
            }, section.title || section.name) : (0, _react.jsx)("span", null, section.title || section.name), index < sections.length - 1 && ", ")));
    };
    let submissionState = "none";
    if (props.templateConfiguration?.isDisabled) submissionState = "templateConfigDisabled";
    else if (isFormSubmitted) {
        if (props.appliedAppTemplateContainer.state.isWaitingForTemplateSync || props.applicationEnvironmentsContainer.state.isCreating) submissionState = "waiting";
        else if (props.appliedAppTemplateContainer.state.templateSyncErrors && props.appliedAppTemplateContainer.state.templateSyncErrors.length > 0) submissionState = "error";
        else submissionState = "success";
    }
    return (0, _react.jsx)((0, _reactDefault.default).Fragment, null, props.appliedAppTemplateContainer.state.isLoading ? (0, _react.jsx)((0, _loaderDefault.default), null) : (0, _react.jsx)("form", {
        onSubmit: handleFormSubmit
    }, (0, _react.jsx)((0, _panelHeaderContainerDefault.default), null, (0, _react.jsx)("div", {
        className: buttonContainerStyle
    }, submissionState != "waiting" && (0, _react.jsx)((0, _buttonDefault.default), {
        disabled: props.appliedAppTemplateContainer.state.isSaving,
        themes: [
            "white-small"
        ],
        text: "Previous",
        type: "button",
        onClick: props.onPrevious
    }), submissionState != "success" ? (0, _react.jsx)((0, _buttonDefault.default), {
        disabled: hasValidationErrors || props.appliedAppTemplateContainer.state.isSaving || submissionState == "waiting" || incompleteSections.length > 0,
        loading: props.appliedAppTemplateContainer.state.isSaving || submissionState == "waiting",
        themes: [
            "primary-small"
        ],
        text: "Finish",
        type: "button",
        onClick: submitForm
    }) : (0, _react.jsx)((0, _buttonDefault.default), {
        disabled: hasValidationErrors || incompleteSections.length > 0 || props.appliedAppTemplateContainer.state.isSaving,
        loading: props.appliedAppTemplateContainer.state.isSaving,
        themes: [
            "primary-small"
        ],
        text: "Home",
        type: "button",
        onClick: goBack
    }))), (0, _react.jsx)((0, _panelContainerDefault.default), null, (0, _react.jsx)((0, _customScrollbarsDefault.default), null, (0, _react.jsx)("div", {
        className: containerStyle
    }, (0, _react.jsx)("h4", null, "Review"), submissionState == "success" && (0, _react.jsx)("div", {
        className: "successful-sync"
    }, (0, _react.jsx)("img", {
        src: successfulSyncIcon
    }), "Success! Your content has been generated."), submissionState == "none" && (0, _react.jsx)((0, _reactDefault.default).Fragment, null, (0, _react.jsx)((0, _templateReviewSectionDefault.default), {
        title: "Status Check",
        icon: incompleteSections.length > 0 || hasValidationErrors ? incompleteIcon : completeIcon,
        descriptionContent: hasValidationErrors && sectionsWithValidationErrors.length > 0 ? renderSectionLinks(sectionsWithValidationErrors, "We can't move forward yet—please go back and fix the highlighted issues in:") : hasValidationErrors ? "One or more fields aren't in the right format." : incompleteSections.length > 0 ? renderSectionLinks(incompleteSections, "You have incomplete sections:") : "It looks like you've filled in all the required fields."
    }), (0, _react.jsx)((0, _templateReviewSectionDefault.default), {
        title: "Generate Content",
        icon: generateIcon,
        description: hasValidationErrors ? "Check the sections listed above and correct any fields that aren't in the right format." : incompleteSections.length > 0 ? "You need to complete all sections before you can generate content." : 'When you click "Finish" your content will be generated based on the values you entered.'
    }), (0, _react.jsx)("div", {
        className: "button-container"
    }, (0, _react.jsx)((0, _buttonDefault.default), {
        disabled: hasValidationErrors || incompleteSections.length > 0 || props.appliedAppTemplateContainer.state.isSaving,
        loading: props.appliedAppTemplateContainer.state.isSaving,
        themes: [
            "primary"
        ],
        text: "Finish",
        type: "button",
        onClick: submitForm
    }))), submissionState == "success" && (0, _react.jsx)("div", {
        className: "button-container"
    }, (0, _react.jsx)((0, _buttonDefault.default), {
        disabled: incompleteSections.length > 0 || props.appliedAppTemplateContainer.state.isSaving,
        loading: props.appliedAppTemplateContainer.state.isSaving,
        themes: [
            "primary"
        ],
        text: "Home",
        type: "button",
        onClick: goBack
    })), submissionState == "waiting" && (0, _react.jsx)((0, _templateReviewSectionDefault.default), {
        title: "Processing...",
        icon: processingIcon,
        description: "We’re busy writing out your content. Please wait until this process is complete before you try to initiate another update."
    }), submissionState == "templateConfigDisabled" && (0, _react.jsx)((0, _templateReviewSectionDefault.default), {
        title: "Disabled",
        icon: errorIcon,
        description: "This module has been disabled and you are unable to use it further."
    }), submissionState == "error" && (0, _react.jsx)((0, _reactDefault.default).Fragment, null, (0, _react.jsx)((0, _templateReviewSectionDefault.default), {
        title: "Errors",
        icon: errorIcon,
        description: `There was a problem syncing your template.\n ${props.appliedAppTemplateContainer.state.templateSyncErrors.toString()}`
    }), (0, _react.jsx)("div", {
        className: "button-container"
    }, (0, _react.jsx)((0, _buttonDefault.default), {
        disabled: incompleteSections.length > 0 || props.appliedAppTemplateContainer.state.isSaving,
        loading: props.appliedAppTemplateContainer.state.isSaving,
        themes: [
            "primary"
        ],
        text: "Retry",
        type: "button",
        onClick: submitForm
    }))))))), (0, _react.jsx)((0, _templateSaveChangesModalDefault.default), {
        showSaveChangesModal: showSaveChangesModal,
        closeModal: closeSaveChangesModal,
        changedFields: props.appliedAppTemplateContainer.getChangedFieldsForDisplay(props.appliedAppTemplate?.id || "", props.values.templateFormValues || []),
        submitChanges: performFinish,
        isLoading: props.appliedAppTemplateContainer.state.isSaving,
        hasErrors: false,
        isFinishAction: true
    }));
};
const buttonContainerStyle = /*#__PURE__*/ (0, _css.css)({
    name: "cv8wgg",
    styles: "margin-right:16px;margin-left:auto;button{margin:0 16px 0 0;}"
});
const containerStyle = /*#__PURE__*/ (0, _css.css)("padding:32px;h4{font-style:normal;font-weight:normal;font-size:18px;line-height:24px;color:", (0, _colors.color_text_default), ";}.button-container{display:flex;flex-direction:column;align-items:center;justify-content:center;}.successful-sync{margin-top:16px;padding:16px;display:flex;background-color:", (0, _colors.color_colors_growth_background), ";border:solid 1px ", (0, _colors.color_colors_growth), ";border-radius:8px;img{margin-right:16px;}}.section-link{color:", (0, _colors.color_text_link), ";text-decoration:none;cursor:pointer;font-weight:600;transition:opacity 0.2s ease;&:hover{opacity:0.7;}}", "");
const AppliedAppTemplateReviewForm = (0, _formik.withFormik)({
    mapPropsToValues: (props)=>({
            templateFormValues: [
                ...props.appliedAppValues
            ],
            isSuccess: false,
            modifiedFields: []
        }),
    validationSchema: _yup.object().shape({}),
    handleSubmit: async (values, { props })=>{
        const currentAppliedTemplateId = props.appliedAppTemplateId;
        const modifiedFields = values.modifiedFields || [];
        // Use the unified saveTemplateFields method with finalize option
        await props.appliedAppTemplateContainer.saveTemplateFields(props.applicationId, currentAppliedTemplateId, values.templateFormValues, {
            finalize: true,
            useModifiedFieldsOnly: modifiedFields.length > 0
        });
    }
})(InnerForm);
exports.default = AppliedAppTemplateReviewForm;

},{"@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","yup":"j2SJU","formik":"3YnOK","../../../components/general/Loader":"bnV5T","../../../components/structure/Panels/PanelHeaderContainer":"hUotd","../../../components/general/Button":"6ymxN","../../../components/structure/CustomScrollbars":"50vFq","../../../constants/colors":"1p3OR","./TemplateReviewSection":"dWTNk","../../../components/structure/Panels/PanelContainer":"9R2lE","../../../components/templating/TemplateSaveChangesModal":"4QSXv","74143d240979afe4":"7aeiM","b65da6617ec7213f":"4oiDX","611c550a1f9ac0cc":"cbVjq","226403c95691e2b7":"6AZoR","6b58136a767596f1":"fmJrz","3ca44aba89fb538c":"cRA6k","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"dWTNk":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _colors = require("../../../constants/colors");
const TemplateReviewSection = (props)=>(0, _react.jsx)("div", {
        className: containerStyle
    }, (0, _react.jsx)("h5", null, props.title), props.icon && (0, _react.jsx)("img", {
        className: props.iconStyle ?? `section-icon`,
        src: props.icon
    }), props.loader && (0, _react.jsx)("div", {
        className: "section-loader"
    }, props.loader), props.descriptionContent ? (0, _react.jsx)("p", null, props.descriptionContent) : props.description && (0, _react.jsx)("p", null, props.description), props.children);
const containerStyle = /*#__PURE__*/ (0, _css.css)("border:1px solid ", (0, _colors.color_shades_dark), ";box-sizing:border-box;border-radius:8px;width:100%;display:flex;flex-direction:column;align-items:center;margin-top:40px;margin-bottom:16px;h5{margin-top:-14px;font-style:normal;font-weight:normal;font-size:18px;line-height:24px;text-align:center;background:", (0, _colors.page_primary_background), ";padding:0 8px;}.section-icon{width:auto;height:48px;margin-top:16px;}.section-loader{margin-top:16px;display:flex;justify-content:center;align-items:center;}p{margin:16px 32px 32px 32px;font-style:normal;font-weight:600;font-size:14px;line-height:20px;text-align:center;}", "");
exports.default = TemplateReviewSection;

},{"@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","../../../constants/colors":"1p3OR","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7aeiM":[function(require,module,exports) {
module.exports = require("e47023c24b257fa8").getBundleURL("kVLro") + require("2cfc15cecade664e").resolve("ba745");

},{"e47023c24b257fa8":"c7Tr5","2cfc15cecade664e":"fyJL2"}],"6AZoR":[function(require,module,exports) {
module.exports = require("4459b9360b31bb57").getBundleURL("kVLro") + require("92cf7ecea3225126").resolve("df09E");

},{"4459b9360b31bb57":"c7Tr5","92cf7ecea3225126":"fyJL2"}],"fmJrz":[function(require,module,exports) {
module.exports = require("3768125ea742dede").getBundleURL("kVLro") + require("e33243a7ad06336f").resolve("iT7DK");

},{"3768125ea742dede":"c7Tr5","e33243a7ad06336f":"fyJL2"}],"f72qu":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _appliedAppSectionSelector = require("./AppliedAppSectionSelector");
var _appliedAppSectionSelectorDefault = parcelHelpers.interopDefault(_appliedAppSectionSelector);
var _customScrollbars = require("../../../components/structure/CustomScrollbars");
var _customScrollbarsDefault = parcelHelpers.interopDefault(_customScrollbars);
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const AppliedAppTemplateSectionMenu = (props)=>{
    const handleActiveSectionChange = (status)=>{
        // Check if this is already a CombinedSection (from the new unified approach)
        if (status.sectionType) {
            // This is already a CombinedSection
            if (status.sectionType === "template") // Extract the section and appliedTemplateId for the legacy interface
            props.onSectionSelect(status.section, status.appliedTemplateId);
            else {
                // This is an appended section, convert to AppendedSection format
                const appendedSection = {
                    id: status.id || status.section?.id || status.name,
                    name: status.name || status.section?.name,
                    isComplete: status.isComplete,
                    isSelected: status.isSelected || false
                };
                props.onAppendedSectionSelect?.(appendedSection);
            }
            return;
        }
        // Legacy handling for backward compatibility
        if (!status.section && !status.sectionType) {
            // This is an appended section (auto-generate or other)
            const section = props.appendedSections?.find((section)=>{
                return section.id === status.id || section.name === status.name;
            });
            if (section) props.onAppendedSectionSelect?.(section);
        } else {
            // This is a template section
            const section = props.sections.find((section)=>{
                return section.section?.title === status.section?.title;
            });
            if (section) props.onSectionSelect(status.section, section.appliedTemplateId);
        }
    };
    const handleFinishSelected = ()=>{
        props.onFinishSelect();
    };
    const handleStartSelected = ()=>{
        if (props.hideStart) return;
        props.onStartSelect();
    };
    return (0, _react.jsx)("div", {
        className: containerStyle
    }, (0, _react.jsx)((0, _customScrollbarsDefault.default), {
        className: scrollContainer,
        autoHide: true,
        autoHeight: false,
        autoHeightMax: "calc(100vh - 136px)"
    }, (0, _react.jsx)((0, _appliedAppSectionSelectorDefault.default), {
        handleToggleExpandLeft: props.handleToggleExpandLeft,
        fileImportErrors: props.fileImportErrors,
        setFileImportErrors: props.setFileImportErrors,
        importedFormFields: props.importedFormFields,
        setImportedFormFields: props.setImportedFormFields,
        firstSectionName: props.firstSectionName,
        sections: props.sections,
        activeSection: props.activeSection,
        isStartSelected: props.isStartSelected && !props.activeSection,
        isFinishSelected: props.isFinishSelected && !props.activeSection,
        isNew: props.isNew,
        handleActiveSectionChange: handleActiveSectionChange,
        onStartSelect: handleStartSelected,
        onFinishSelect: handleFinishSelected,
        hideStart: props.hideStart,
        appendedSections: props.appendedSections,
        templateConfigContainer: props.templateConfigContainer,
        orgContainer: props.orgContainer,
        applicationId: props.applicationId,
        appliedAppTemplateContainer: props.appliedAppTemplateContainer,
        appContainer: props.appContainer,
        appliedAppTemplateId: props.appliedAppTemplateId,
        showAdminFields: props.showAdminFields,
        setShowAdminFields: props.setShowAdminFields,
        fieldValidationErrors: props.fieldValidationErrors
    })));
};
const containerStyle = /*#__PURE__*/ (0, _css.css)({
    name: "82a6rk",
    styles: "flex:1"
});
const scrollContainer = /*#__PURE__*/ (0, _css.css)({
    name: "82a6rk",
    styles: "flex:1"
});
exports.default = AppliedAppTemplateSectionMenu;

},{"@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","./AppliedAppSectionSelector":"4g0o2","../../../components/structure/CustomScrollbars":"50vFq","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4g0o2":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _base = require("@emotion/styled/base");
var _baseDefault = parcelHelpers.interopDefault(_base);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _colors = require("../../../constants/colors");
var _horizontalSeparator = require("../../../components/structure/HorizontalSeparator");
var _horizontalSeparatorDefault = parcelHelpers.interopDefault(_horizontalSeparator);
var _button = require("../../../components/general/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _switch = require("../../../components/forms/Switch");
var _switchDefault = parcelHelpers.interopDefault(_switch);
var _sparkContainer = require("../../../hooks/SparkContainer");
var _sparkContainerDefault = parcelHelpers.interopDefault(_sparkContainer);
var _sparkNewTopicForm = require("../../../../clients/spark/scenes/dashboard/SparkNewTopicForm");
var _sparkNewTopicFormDefault = parcelHelpers.interopDefault(_sparkNewTopicForm);
var _confirmationDialog = require("../../../components/structure/ConfirmationDialog");
var _confirmationDialogDefault = parcelHelpers.interopDefault(_confirmationDialog);
var _warningConfirmation = require("../../../components/general/WarningConfirmation");
var _warningConfirmationDefault = parcelHelpers.interopDefault(_warningConfirmation);
var _interactionModelContainer = require("../../../hooks/InteractionModelContainer");
var _interactionModelContainerDefault = parcelHelpers.interopDefault(_interactionModelContainer);
var _languageContainer = require("../../../hooks/LanguageContainer");
var _languageContainerDefault = parcelHelpers.interopDefault(_languageContainer);
var _pageError = require("../../../components/general/PageError");
var _pageErrorDefault = parcelHelpers.interopDefault(_pageError);
var _importFileDialog = require("../../../components/general/ImportFileDialog");
var _importFileDialogDefault = parcelHelpers.interopDefault(_importFileDialog);
var _css = require("@emotion/css");
var _formFieldImportHeadings = require("../../../constants/sparkConstants/formFieldImportHeadings");
var _useCSVHandler = require("../../../hooks/UseCSVHandler");
var _useCSVHandlerDefault = parcelHelpers.interopDefault(_useCSVHandler);
var _useIsMobile = require("../../../hooks/UseIsMobile");
var _useIsMobileDefault = parcelHelpers.interopDefault(_useIsMobile);
var _inviteSparkFormModal = require("./InviteSparkFormModal");
var _inviteSparkFormModalDefault = parcelHelpers.interopDefault(_inviteSparkFormModal);
var _memberContainer = require("../../../state/containers/MemberContainer");
var _memberContainerDefault = parcelHelpers.interopDefault(_memberContainer);
var _unstated = require("unstated");
var _customScrollbars = require("../../../components/structure/CustomScrollbars");
var _customScrollbarsDefault = parcelHelpers.interopDefault(_customScrollbars);
var _useWindowSize = require("../../../hooks/UseWindowSize");
var _useWindowSizeDefault = parcelHelpers.interopDefault(_useWindowSize);
var _mediaContainer = require("../../../state/containers/MediaContainer");
var _mediaContainerDefault = parcelHelpers.interopDefault(_mediaContainer);
var _autoGenerateFormFieldResponsesForm = require("../../../../clients/spark/scenes/dashboard/autoGenerateFormField/AutoGenerateFormFieldResponsesForm");
var _sectionUtils = require("../../../utils/sectionUtils");
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const completeIcon = require("a4431ba97d3e95b7");
const incompleteIcon = require("a996c7bfe301e90");
const addCircleIcon = require("dec510b2659a4f58");
const deleteIcon = require("31ec608ca76d6a01");
const exportIcon = require("617deb93e7ce4f9d");
const importIcon = require("e34eaa7394e32333");
const shareIcon = require("98ce30beced34845");
const autoGenerateIcon = require("489428f14231de10");
const AppliedAppSectionSelector = (props)=>{
    const [showNewTopicModal, setShowNewTopicModal] = (0, _react1.useState)(false);
    const [isDeleteConfirmationModalOpen, setIsDeleteConfirmationModalOpen] = (0, _react1.useState)(false);
    const [sectionToDelete, setSectionToDelete] = (0, _react1.useState)(null);
    const [allSections, setAllSections] = (0, _react1.useState)([]);
    const [interactionModels, setInteractionModels] = (0, _react1.useState)([]);
    const [languages, setLanguages] = (0, _react1.useState)([]);
    const [errors, setErrors] = (0, _react1.useState)([]);
    const [isDeletingSection, setIsDeletingSection] = (0, _react1.useState)(false);
    const [isImportFileDialogModalOpen, setIsImportFileDialogModalOpen] = (0, _react1.useState)(false);
    const [isConfirmImportModalOpen, setIsConfirmImportModalOpen] = (0, _react1.useState)(false);
    const [importedFields, setImportedFields] = (0, _react1.useState)([]);
    const [isShareFormOpen, setIsShareFormOpen] = (0, _react1.useState)(false);
    const [isAutoAnswerGenerateModalOpen, setIsAutoAnswerGenerateModalOpen] = (0, _react1.useState)(false);
    const [isLoading, setIsLoading] = (0, _react1.useState)(false);
    const [isUpdatingLiveStatus, setIsUpdatingLiveStatus] = (0, _react1.useState)(false);
    const prevShowAdminFieldsRef = (0, _react1.useRef)(undefined);
    const sparkContainer = (0, _sparkContainerDefault.default).useContainer();
    const interactionModelContainer = (0, _interactionModelContainerDefault.default).useContainer();
    const languagesContainer = (0, _languageContainerDefault.default).useContainer();
    const { importedData, isLoadingImport, importCSV, exportCSV, setIsLoadingImport } = (0, _useCSVHandlerDefault.default)();
    const prevSectionsLengthRef = (0, _react1.useRef)(undefined);
    const isMobile = (0, _useIsMobileDefault.default)();
    const windowSize = (0, _useWindowSizeDefault.default)();
    const sectionRef = (0, _react1.useRef)();
    const shouldScrollRef = (0, _react1.useRef)(false);
    (0, _react1.useEffect)(()=>{
        if (importedData?.length) setImportedFields(importedData);
    }, [
        importedData
    ]);
    (0, _react1.useEffect)(()=>{
        if (!languagesContainer.languages.length) languagesContainer.loadLanguages();
        if (!props.sections?.length) getCurrentAppliedTemplate();
    }, []);
    (0, _react1.useEffect)(()=>{
        // Check if the change in sections length is due to admin fields toggle
        const isAdminFieldsChange = prevShowAdminFieldsRef.current !== undefined && prevShowAdminFieldsRef.current !== props.showAdminFields;
        if (prevSectionsLengthRef.current !== undefined && props.sections.length > prevSectionsLengthRef.current && !isAdminFieldsChange) {
            // A new custom topic was added - we want to scroll to it
            shouldScrollRef.current = true;
            props.handleActiveSectionChange(props.sections[props.sections.length - 1]);
        }
        // Update the previous length and admin fields state
        prevSectionsLengthRef.current = props.sections?.length;
        prevShowAdminFieldsRef.current = props.showAdminFields;
    }, [
        props.sections?.length,
        props.showAdminFields
    ]);
    (0, _react1.useEffect)(()=>{
        const app = props.appContainer.state.currentApp;
        const defaultLanguage = languagesContainer.languages.find((l)=>l.id == app?.defaultLanguageId);
        if (defaultLanguage) {
            const languages = defaultLanguage == null ? [] : [
                defaultLanguage
            ];
            languagesContainer.updateSelectedLanguages(languages);
        }
    }, [
        languagesContainer.languages
    ]);
    (0, _react1.useEffect)(()=>{
        if (languagesContainer.currentSelectedLanguages.length > 0) setLanguages(languagesContainer.currentSelectedLanguages);
    }, [
        languagesContainer.currentSelectedLanguages
    ]);
    const loadInteractionModels = async ()=>{
        if (props.applicationId && languages.length) {
            const loadInteractionModelsResponse = await interactionModelContainer.loadInteractionModels(props.applicationId, languages);
            if (loadInteractionModelsResponse?.resultType === "Ok") setInteractionModels(loadInteractionModelsResponse.data);
        }
    };
    (0, _react1.useEffect)(()=>{
        loadInteractionModels();
    }, [
        languages,
        props.applicationId
    ]);
    (0, _react1.useEffect)(()=>{
        setInteractionModels(interactionModelContainer.interactionModels);
    }, [
        interactionModelContainer.interactionModels
    ]);
    (0, _react1.useEffect)(()=>{
        const combined = (0, _sectionUtils.combineSections)({
            sections: props.sections ?? [],
            appendedSections: props.appendedSections,
            showAdminFields: sparkContainer.inSpark ? props.showAdminFields ?? false : true,
            importedFormFields: props.importedFormFields,
            appliedAppTemplateContainer: props.appliedAppTemplateContainer
        });
        setAllSections(combined);
    }, [
        props.sections,
        props.appendedSections,
        props.showAdminFields,
        props.importedFormFields,
        props.appliedAppTemplateContainer.state.appliedTemplates
    ]);
    (0, _react1.useEffect)(()=>{
        if (shouldScrollRef.current && sectionRef?.current) {
            const current = sectionRef.current;
            current.scrollIntoView({
                behavior: "smooth",
                block: "nearest"
            });
            // Reset the scroll flag
            shouldScrollRef.current = false;
        }
    }, [
        props.activeSection
    ]);
    const getCurrentAppliedTemplate = async ()=>{
        const loadedTemplatesResult = await props.appliedAppTemplateContainer.loadAppliedTemplates(props.applicationId);
        const loadedTemplate = loadedTemplatesResult.data.find((at)=>at.id == props.appliedAppTemplateId);
    // The sections will be recombined through the useEffect that watches props.sections
    };
    const activeIndex = (0, _sectionUtils.findActiveSectionIndex)(allSections, props.activeSection);
    const handleDeleteSectionClick = (section)=>{
        setSectionToDelete(section);
        toggleDeleteConfirmationModal();
    };
    const toggleDeleteConfirmationModal = ()=>{
        setIsDeleteConfirmationModalOpen(!isDeleteConfirmationModalOpen);
    };
    const toggleNewTopicModal = ()=>{
        setShowNewTopicModal(!showNewTopicModal);
    };
    const deleteSection = async ()=>{
        if (sectionToDelete?.appliedTemplateId) {
            setIsDeletingSection(true);
            const appliedAppTemplateToDelete = props.appliedAppTemplateContainer.state.appliedTemplates.find((appliedAppTemplate)=>{
                return appliedAppTemplate.id === sectionToDelete.appliedTemplateId;
            });
            if (appliedAppTemplateToDelete) await props.appliedAppTemplateContainer.removeAppliedTemplate(props.applicationId, appliedAppTemplateToDelete.id, (result)=>{
                if (result.resultType === "Ok") {
                    if (interactionModels?.length) {
                        const interactionModel = interactionModels.find((interactionModel)=>interactionModel.locale === languages[0].shortCode);
                        const intentToDeleteId = interactionModel?.intents?.find((intent)=>intent.displayName === appliedAppTemplateToDelete.name)?.id;
                        const interactionModelUpdateRequest = {
                            intents: {},
                            disableIntents: [],
                            enableIntents: [],
                            locale: interactionModel.locale,
                            removeCustomIntents: [
                                {
                                    intentName: appliedAppTemplateToDelete.name,
                                    intentId: intentToDeleteId
                                }
                            ],
                            addCustomIntents: [],
                            updatedEnhancedIntentMatchingPrompt: interactionModel.enhancedIntentMatchingPrompt,
                            enableEnhancedIntentMatching: interactionModel.useEnhancedIntentMatching
                        };
                        interactionModelContainer.updateInteractionModel(props.applicationId, languages[0].shortCode, interactionModelUpdateRequest);
                    }
                    props.appliedAppTemplateContainer.loadAppliedTemplates(props.applicationId);
                    // If the deleted section was active, navigate to the first available section or finish
                    const activeSection = props.activeSection;
                    const isDeletedSectionActive = activeSection?.appliedTemplateId === sectionToDelete.appliedTemplateId && (activeSection?.section?.id === sectionToDelete.section?.id || activeSection?.section?.title === sectionToDelete.section?.title);
                    if (isDeletedSectionActive) {
                        // Navigate to the first section if available, otherwise go to finish
                        if (allSections.length > 1) {
                            // Find a section that's not the one being deleted
                            const nextSection = allSections.find((s)=>s.sectionType !== "template" || s.appliedTemplateId !== sectionToDelete.appliedTemplateId);
                            if (nextSection) props.handleActiveSectionChange(nextSection);
                            else props.onFinishSelect();
                        } else props.onFinishSelect();
                    }
                    toggleDeleteConfirmationModal();
                } else setErrors(result.errors);
            });
            setIsDeletingSection(false);
        }
    };
    const toggleImportFileDialogModal = ()=>{
        setIsImportFileDialogModalOpen(!isImportFileDialogModalOpen);
    };
    const toggleConfirmImportModal = ()=>{
        setIsConfirmImportModalOpen(!isConfirmImportModalOpen);
    };
    const convertCSVTextToTemplateFormFields = (csvArray)=>{
        const combinedFormFields = [];
        for (const appliedTemplate of props.appliedAppTemplateContainer.state?.appliedTemplates){
            const appliedApplicationTemplateId = appliedTemplate.id;
            for (const section of appliedTemplate.templateForm?.templateFormSections)for (const formField of section.templateFormFields){
                // Find the actual saved value for this field
                const savedFieldValue = appliedTemplate.templateFormFieldValues.find((value)=>value.templateFormFieldId === formField.id);
                const fieldValue = savedFieldValue ? savedFieldValue.value : formField.defaultValue || "";
                const updatedFormField = {
                    templateFormFieldId: formField.id,
                    value: fieldValue,
                    associatedVariable: formField.associatedVariable,
                    label: formField.label,
                    fieldType: formField.fieldType,
                    placeholder: formField.placeholder,
                    defaultValue: formField.defaultValue,
                    tip: formField.tip,
                    title: formField.title,
                    appliedApplicationTemplateId: appliedApplicationTemplateId
                };
                combinedFormFields.push(updatedFormField);
            }
        }
        const csvRows = csvArray.map((row)=>row.join(","));
        const headers = csvRows[0].split(",");
        const appliedAppTemplateIdHeadingIndex = headers.findIndex((header)=>header.toLowerCase() === (0, _formFieldImportHeadings.columnOneHeading).toLowerCase());
        const displayTitleHeadingIndex = headers.findIndex((header)=>header.toLowerCase() === (0, _formFieldImportHeadings.columnTwoHeading).toLowerCase());
        const assistantResponseHeadingIndex = headers.findIndex((header)=>header.toLowerCase() === (0, _formFieldImportHeadings.columnThreeHeading).toLowerCase());
        if (displayTitleHeadingIndex === -1 || assistantResponseHeadingIndex === -1) {
            props.setFileImportErrors([
                "The file you selected is not formatted correctly. Please ensure that the file contains the correct headers."
            ]);
            return [];
        }
        const importedTemplateFormFields = [];
        let fileImportErrorsList = [];
        for (const row of csvArray.slice(1)){
            let appliedAppTemplateId;
            if (appliedAppTemplateIdHeadingIndex !== -1) appliedAppTemplateId = row[appliedAppTemplateIdHeadingIndex];
            const displayTitle = row[displayTitleHeadingIndex];
            const assistantResponse = row[assistantResponseHeadingIndex];
            const currentFormFields = combinedFormFields.filter((formField)=>formField.title === displayTitle);
            let currentFormField;
            if (currentFormFields.length > 1) {
                if (appliedAppTemplateId) currentFormField = currentFormFields.find((formField)=>{
                    return formField.appliedApplicationTemplateId === appliedAppTemplateId;
                });
                else props.setFileImportErrors([
                    `Looks like there is more than one field with the title ${displayTitle}. Please include the module id in the file to specify which field to import.`
                ]);
            } else if (currentFormFields.length === 1) currentFormField = currentFormFields[0];
            if (currentFormField) {
                const importedFormField = {
                    ...currentFormField,
                    value: assistantResponse
                };
                importedTemplateFormFields.push(importedFormField);
            } else fileImportErrorsList.push(displayTitle);
        }
        for (const combinedFormField of combinedFormFields){
            const isImported = importedTemplateFormFields.some((importedFormField)=>importedFormField.title === combinedFormField.title && (importedFormField.appliedApplicationTemplateId ? importedFormField.appliedApplicationTemplateId === combinedFormField.appliedApplicationTemplateId : true));
            if (!isImported) importedTemplateFormFields.push(combinedFormField);
        }
        // ensure all file import errors have a length at all
        fileImportErrorsList = fileImportErrorsList.filter((error)=>error?.trim()?.length);
        if (fileImportErrorsList.length >= 1) {
            const fileImportErrorsString = [
                `We cannot import the following fields, as they're not in this form:`
            ];
            for (const [index, fileImportError] of fileImportErrorsList.entries()){
                if (index === 2) {
                    fileImportErrorsString[0] += ` ${fileImportError}, ...`;
                    break;
                } else if (index === fileImportErrorsList.length - 1) fileImportErrorsString[0] += ` ${fileImportError}.`;
                else fileImportErrorsString[0] += ` ${fileImportError},`;
            }
            props.setFileImportErrors(fileImportErrorsString);
        }
        return importedTemplateFormFields;
    };
    const importFormFields = (file)=>{
        importCSV(file, convertCSVTextToTemplateFormFields);
        toggleImportFileDialogModal();
        toggleConfirmImportModal();
    };
    const useImportedTemplateFormFieldValues = async ()=>{
        setIsLoadingImport(true);
        props.setImportedFormFields(importedFields);
        if (importedFields.length > 0) {
            const appliedTemplates = props.appliedAppTemplateContainer.state?.appliedTemplates;
            if (appliedTemplates) for (const appliedTemplate of appliedTemplates){
                const appliedTemplateImportedFormValues = importedFields.filter((importedField)=>{
                    return appliedTemplate.templateForm?.templateFormSections?.some((section)=>{
                        return section.templateFormFields.some((field)=>field.title === importedField.title && (importedField.appliedApplicationTemplateId ? importedField.appliedApplicationTemplateId === appliedTemplate.id : true));
                    });
                });
                const updatedAppliedTemplate = {
                    templateFormFieldValues: appliedTemplateImportedFormValues,
                    name: appliedTemplate.name
                };
                await props.appliedAppTemplateContainer.updateAppliedTemplate(appliedTemplate?.id, updatedAppliedTemplate);
            }
        }
        setIsLoadingImport(false);
        toggleConfirmImportModal();
    };
    const formatFileName = ()=>{
        const fileExportName = props.appContainer.state?.currentApp?.name ? props.appContainer.state.currentApp.name.toLowerCase().split(/\s+/) : [];
        const date = new Date();
        const formattedDate = `${date.getMonth() + 1}-${date.getDate()}-${date.getFullYear()}`;
        const formattedTime = `${date.getHours()}:${date.getMinutes()}`;
        fileExportName.push(formattedDate);
        fileExportName.push(formattedTime);
        const formattedFileExportName = fileExportName.join("-");
        return formattedFileExportName;
    };
    const exportFormFields = ()=>{
        const formFieldValues = [];
        for (const appliedTemplate of props.appliedAppTemplateContainer.state?.appliedTemplates){
            for (const section of appliedTemplate.templateForm?.templateFormSections)for (const formField of section.templateFormFields){
                const savedFieldValue = appliedTemplate.templateFormFieldValues.find((value)=>value.templateFormFieldId === formField.id);
                const fieldValue = savedFieldValue ? savedFieldValue.value : formField.defaultValue || "";
                formFieldValues.push({
                    [(0, _formFieldImportHeadings.columnOneHeading)]: appliedTemplate.id,
                    [(0, _formFieldImportHeadings.columnTwoHeading)]: formField.title,
                    [(0, _formFieldImportHeadings.columnThreeHeading)]: fieldValue,
                    associatedVariable: formField.associatedVariable
                });
            }
        }
        exportCSV(formFieldValues, [
            (0, _formFieldImportHeadings.columnOneHeading),
            (0, _formFieldImportHeadings.columnTwoHeading),
            (0, _formFieldImportHeadings.columnThreeHeading)
        ], formatFileName());
    };
    const handleActiveSectionChangeOnMobile = (e)=>{
        props.handleToggleExpandLeft(e, false);
    };
    const handleGoLiveToggle = async (enabled)=>{
        setIsUpdatingLiveStatus(true);
        try {
            const currentApp = props.appContainer.state.currentApp;
            if (!currentApp) return;
            await props.appContainer.updateApplication(props.applicationId, {
                ...currentApp,
                isLive: enabled
            });
        } finally{
            setIsUpdatingLiveStatus(false);
        }
    };
    const renderSectionItem = (section, idx)=>{
        const isActive = (()=>{
            if (section.sectionType === "template") {
                const activeSection = props.activeSection;
                if (activeSection?.appliedTemplateId && activeSection?.section) // Match by appliedTemplateId AND section properties to ensure uniqueness
                return activeSection.appliedTemplateId === section.appliedTemplateId && (activeSection.section?.name && section?.section?.name === activeSection.section?.name || activeSection.section?.id && section.section?.id === activeSection.section?.id || activeSection.section?.title && section?.section?.title === activeSection.section?.title);
                else {
                    // Fallback for cases without appliedTemplateId - still check appliedTemplateId if available
                    const activeSectionDetails = activeSection?.section ?? activeSection;
                    // Fallback for cases without appliedTemplateId on activeSection
                    // If both have appliedTemplateId, require both ID and property match
                    if (section.appliedTemplateId && activeSection?.appliedTemplateId) return activeSection.appliedTemplateId === section.appliedTemplateId && (activeSectionDetails?.name && section?.section?.name === activeSectionDetails.name || activeSectionDetails?.id && section.section?.id === activeSectionDetails.id || activeSectionDetails?.title && section?.section?.title === activeSectionDetails.title);
                    // Otherwise fall back to property-only matching
                    return activeSectionDetails?.name && section?.section?.name === activeSectionDetails.name || activeSectionDetails?.id && section.section?.id === activeSectionDetails.id || activeSectionDetails?.title && section?.section?.title === activeSectionDetails.title;
                }
            } else {
                const activeSection = props.activeSection;
                return activeSection === section || activeSection?.name && section?.name === activeSection?.name || activeSection?.id && section?.id === activeSection?.id;
            }
        })();
        const sectionTitle = section.sectionType === "template" ? section.section?.title : section.name;
        // Check if this specific section has validation errors
        // The fieldValidationErrors keys are field.id or field.name
        // We need to check if any errors belong to fields in this section
        const sectionFieldIds = section.sectionType === "template" ? section.section?.templateFormFields?.map((f)=>f.id || f.name) || [] : [];
        const hasValidationErrorsInThisSection = props.fieldValidationErrors && sectionFieldIds.length > 0 ? sectionFieldIds.some((fieldId)=>props.fieldValidationErrors[fieldId] === true) : false;
        const isComplete = section.isComplete && !hasValidationErrorsInThisSection;
        const isDisabled = section.sectionType === "template" ? section.isDisabled || props.isNew : false;
        const shouldShowDeleteButton = section.sectionType === "template" && section.section?.isCustom;
        return (0, _react.jsx)(SectionItem, {
            ref: isActive ? sectionRef : null,
            key: `${section.sectionType}-${idx}`,
            className: `${props.disabled && (idx > activeIndex && !props.isFinishSelected || props.isStartSelected) ? "disabled" : ""} ${!props.disabled && !isDisabled ? "clickable" : ""} ${isActive ? "active" : ""} ${isDisabled ? "disabled" : ""}`,
            onPointerDown: (e)=>{
                if (!isDisabled && !props.disabled) {
                    props.handleActiveSectionChange(section);
                    if (isMobile) handleActiveSectionChangeOnMobile(e);
                }
            },
            onClick: (e)=>{
                if (!isDisabled && !props.disabled) {
                    props.handleActiveSectionChange(section);
                    if (isMobile) handleActiveSectionChangeOnMobile(e);
                }
            }
        }, (0, _react.jsx)(SectionTitleWrapper, null, (0, _react.jsx)(SectionTitle, null, sectionTitle), shouldShowDeleteButton && (0, _react.jsx)(DeleteButton, {
            themes: [
                "icon-small"
            ],
            icon: deleteIcon,
            onClick: ()=>handleDeleteSectionClick(section)
        })), (0, _react.jsx)(CompleteIcon, {
            src: isComplete ? completeIcon : incompleteIcon
        }));
    };
    return (0, _react.jsx)(Wrapper, null, isDeleteConfirmationModalOpen && (0, _react.jsx)((0, _confirmationDialogDefault.default), {
        title: `Delete ${sectionToDelete.section.title ? sectionToDelete.section.title : "Section"}`,
        deleteText: "Yes, Delete",
        isLoading: isDeletingSection,
        onClose: ()=>toggleDeleteConfirmationModal(),
        onConfirm: ()=>deleteSection()
    }, (0, _react.jsx)((0, _warningConfirmationDefault.default), {
        text: `Are you sure you want to delete ${sectionToDelete.section.title ? sectionToDelete.section.title : "this section"}?`
    })), showNewTopicModal && sparkContainer.inSpark && (0, _react.jsx)((0, _sparkNewTopicFormDefault.default), {
        toggleNewTopicModal: toggleNewTopicModal,
        templateConfigContainer: props.templateConfigContainer,
        orgContainer: props.orgContainer,
        appliedAppTemplateContainer: props.appliedAppTemplateContainer,
        applicationId: props.applicationId,
        sections: props.sections
    }), !props.hideStart && (0, _react.jsx)((0, _reactDefault.default).Fragment, null, (0, _react.jsx)(SectionItem, {
        className: `overview-section ${props.isStartSelected ? "active" : ""}`,
        onPointerDown: (e)=>{
            if (!props.isNew || props.disabled) {
                props.onStartSelect();
                if (isMobile) handleActiveSectionChangeOnMobile(e);
            }
        }
    }, (0, _react.jsx)(SectionTitle, null, props.firstSectionName ? props.firstSectionName : `Overview`)), (0, _react.jsx)((0, _horizontalSeparatorDefault.default), null)), (0, _react.jsx)(TopicButtonWrapper, null, (0, _react.jsx)((0, _customScrollbarsDefault.default), {
        autoHeight: true,
        autoHeightMax: windowSize.windowSize.innerHeight * .45
    }, allSections.map((section, idx)=>renderSectionItem(section, idx)), (0, _react.jsx)(SectionItem, {
        className: `review-section ${props.isFinishSelected ? "active" : ""} ${props.isNew ? "disabled" : ""}`,
        onPointerDown: (e)=>{
            if (!(props.isNew || props.disabled)) props.onFinishSelect();
            if (isMobile) handleActiveSectionChangeOnMobile(e);
        }
    }, (0, _react.jsx)(SectionTitle, null, "Review"))), (0, _react.jsx)(ButtonsWrapper, null, (0, _react.jsx)((0, _horizontalSeparatorDefault.default), null), sparkContainer.inSpark && (0, _react.jsx)(FormPopulationButtonWrapper, null, (0, _react.jsx)(FormPopulationButton, {
        disabled: false,
        loading: false,
        type: "submit",
        themes: [
            "secondary-small",
            "end-tight"
        ],
        rightIcon: importIcon,
        onClick: ()=>toggleImportFileDialogModal(),
        text: "Import All Form Fields"
    }), (0, _react.jsx)(FormPopulationButton, {
        disabled: false,
        loading: false,
        type: "submit",
        themes: [
            "secondary-small",
            "end-tight"
        ],
        rightIcon: exportIcon,
        onClick: ()=>exportFormFields(),
        text: "Export All Form Fields"
    }), (0, _react.jsx)(GoLiveSwitch, {
        checked: props.appContainer.state.currentApp?.isLive ?? false,
        onChange: handleGoLiveToggle,
        label: "Go Live",
        loading: isUpdatingLiveStatus,
        disabled: isUpdatingLiveStatus
    }), props.showAdminFields !== undefined && props.setShowAdminFields && (0, _react.jsx)(AdminFieldsSwitch, {
        checked: props.showAdminFields,
        onChange: props.setShowAdminFields,
        label: "Show Admin Fields"
    })))), isShareFormOpen && (0, _react.jsx)((0, _unstated.Subscribe), {
        to: [
            (0, _memberContainerDefault.default)
        ]
    }, (memberContainer)=>{
        return (0, _react.jsx)((0, _inviteSparkFormModalDefault.default), {
            isShareFormOpen: isShareFormOpen,
            setIsShareFormOpen: setIsShareFormOpen,
            applicationId: props.applicationId,
            memberContainer: memberContainer
        });
    }), isImportFileDialogModalOpen && (0, _react.jsx)((0, _importFileDialogDefault.default), {
        onClose: toggleImportFileDialogModal,
        completeImport: importFormFields,
        title: "Select a .csv File to Import",
        acceptFileTypes: ".csv",
        acceptFileTypesDisplayText: "Supports .csv",
        isLoading: false,
        errors: []
    }), isConfirmImportModalOpen && (0, _react.jsx)((0, _confirmationDialogDefault.default), {
        title: `Confirm Form Fields Import`,
        deleteText: "Yes, Import",
        isLoading: isLoadingImport,
        onClose: toggleConfirmImportModal,
        onConfirm: useImportedTemplateFormFieldValues
    }, (0, _react.jsx)((0, _warningConfirmationDefault.default), {
        text: `By importing these form fields you will override any existing responses. To preserve existing responses, export them and combine everything into a single file to be imported.`,
        className: importWarningStyle
    })), isAutoAnswerGenerateModalOpen && (0, _react.jsx)((0, _unstated.Subscribe), {
        to: [
            (0, _mediaContainerDefault.default)
        ]
    }, (mediaContainer)=>{
        return (0, _react.jsx)((0, _autoGenerateFormFieldResponsesForm.AutoGenerateFormFieldResponsesFormModal), {
            applicationId: props.applicationId,
            mediaContainer: mediaContainer,
            appliedAppTemplateContainer: props.appliedAppTemplateContainer,
            onClose: ()=>setIsAutoAnswerGenerateModalOpen(false),
            isLoading: isLoading,
            setIsLoading: setIsLoading
        });
    }), (0, _react.jsx)((0, _pageErrorDefault.default), {
        errors: errors
    }));
};
const importWarningStyle = /*#__PURE__*/ (0, _css.css)({
    name: "3hgi0y",
    styles: "margin-top:32px"
});
const FormPopulationButton = /*#__PURE__*/ (0, _baseDefault.default)((0, _buttonDefault.default), {
    target: "e1y9cbw012"
})({
    name: "lpq4s6",
    styles: "margin:0 0 16px 8px;font-size:14px;font-weight:400;.right-img{margin-left:8px;width:16px;}"
});
const AdminFieldsSwitch = /*#__PURE__*/ (0, _baseDefault.default)((0, _switchDefault.default), {
    target: "e1y9cbw011"
})({
    name: "jmnvj1",
    styles: "margin:8px 0 16px 8px"
});
const GoLiveSwitch = /*#__PURE__*/ (0, _baseDefault.default)((0, _switchDefault.default), {
    target: "e1y9cbw010"
})({
    name: "jmnvj1",
    styles: "margin:8px 0 16px 8px"
});
const FormPopulationButtonWrapper = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1y9cbw09"
})({
    name: "36yuxy",
    styles: "display:flex;flex-direction:column;justify-content:start;align-items:start;margin-top:20px"
});
const CompleteIcon = /*#__PURE__*/ (0, _baseDefault.default)("img", {
    target: "e1y9cbw08"
})("");
const SectionTitle = /*#__PURE__*/ (0, _baseDefault.default)("p", {
    target: "e1y9cbw07"
})("");
const SectionTitleWrapper = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1y9cbw06"
})({
    name: "t2a431",
    styles: "display:flex;align-items:center;max-width:90%"
});
const DeleteButton = /*#__PURE__*/ (0, _baseDefault.default)((0, _buttonDefault.default), {
    target: "e1y9cbw05"
})({
    name: "1sk5kas",
    styles: "margin-left:0px;img{width:8px;height:8px;}"
});
const CustomButton = /*#__PURE__*/ (0, _baseDefault.default)((0, _buttonDefault.default), {
    target: "e1y9cbw04"
})({
    name: "5r8hnz",
    styles: "margin:0 0 0 16px;font-size:14px;font-weight:400;.right-img{margin-left:8px;}"
});
const SectionItem = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1y9cbw03"
})("display:flex;justify-content:space-between;align-items:center;border-radius:4px;height:48px;padding:0 16px;p{font-size:14px;line-height:20px;color:", (0, _colors.color_text_default), ";white-space:nowrap;overflow:hidden;text-overflow:ellipsis;}.selected-indicator{width:8px;height:8px;border-radius:50%;background:", (0, _colors.color_text_link), ";margin-right:8px;margin-left:auto;}&.active{background:", (0, _colors.color_variants_ocean_light_1), ";p{color:", (0, _colors.color_text_link), ";}}&.clickable{cursor:pointer;}&.disabled{img{display:none;}p{color:", (0, _colors.color_text_light), ";}}&.review-section{margin-bottom:8px;cursor:pointer;}");
const Wrapper = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1y9cbw02"
})({
    name: "10rtstj",
    styles: "padding:16px"
});
const TopicButtonWrapper = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1y9cbw01"
})({
    name: "1fttcpj",
    styles: "display:flex;flex-direction:column"
});
const ButtonsWrapper = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1y9cbw00"
})("background:", (0, _colors.color_defaults_white), ";position:sticky;bottom:0;");
exports.default = AppliedAppSectionSelector;

},{"@emotion/styled/base":"lSuFu","@emotion/react":"djZKr","react":"6uln9","../../../constants/colors":"1p3OR","../../../components/structure/HorizontalSeparator":"Pw3HQ","../../../components/general/Button":"6ymxN","../../../components/forms/Switch":"8kkL9","../../../hooks/SparkContainer":"jzXzx","../../../../clients/spark/scenes/dashboard/SparkNewTopicForm":"5jklN","../../../components/structure/ConfirmationDialog":"kx7yK","../../../components/general/WarningConfirmation":"9OccO","../../../hooks/InteractionModelContainer":"5cw5C","../../../hooks/LanguageContainer":"lchkU","../../../components/general/PageError":"ezFTm","../../../components/general/ImportFileDialog":"7LQaS","@emotion/css":"awUBr","../../../constants/sparkConstants/formFieldImportHeadings":"8pVbk","../../../hooks/UseCSVHandler":"jBTvX","../../../hooks/UseIsMobile":"9Gz1L","./InviteSparkFormModal":"d7wE0","../../../state/containers/MemberContainer":"iYQOb","unstated":"grh7p","../../../components/structure/CustomScrollbars":"50vFq","../../../hooks/UseWindowSize":"43j9z","../../../state/containers/MediaContainer":"ch6Xu","../../../../clients/spark/scenes/dashboard/autoGenerateFormField/AutoGenerateFormFieldResponsesForm":"bNIQ5","../../../utils/sectionUtils":"1hn3I","a4431ba97d3e95b7":"7CQ2Y","a996c7bfe301e90":"4oiDX","dec510b2659a4f58":"cl9rg","31ec608ca76d6a01":"6WgaZ","617deb93e7ce4f9d":"1wVxx","e34eaa7394e32333":"d7E9Z","98ce30beced34845":"Ik7fU","489428f14231de10":"hfaJb","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"5jklN":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _formik = require("formik");
var _yup = require("yup");
var _sparkNewTopic = require("./SparkNewTopic");
var _sparkNewTopicDefault = parcelHelpers.interopDefault(_sparkNewTopic);
var _customRequestModuleIds = require("../../../../shared/constants/sparkConstants/customRequestModuleIds");
const SparkNewTopicForm = (0, _formik.withFormik)({
    mapPropsToValues: (props)=>({
            topicName: "",
            topicResponseType: "respond"
        }),
    validationSchema: (props)=>{
        return _yup.object().shape({
            topicName: _yup.string().required("Please enter a topic name").test("is-unique", "Topic name must be unique", function(value) {
                if (!value) return true; // If there's no value, other validators will handle the required case
                const lowerCaseValue = value.toLowerCase();
                return !props.sections.some((section)=>{
                    return section.section.title.toLowerCase() === lowerCaseValue;
                });
            }),
            topicResponseType: _yup.string().required("Please select a response type")
        });
    },
    handleSubmit: async (values, { props })=>{
        const availableTemplates = await props.templateConfigContainer.getAvailableTemplates(props.orgContainer.state.currentOrganization.id);
        let matchingTemplate;
        const respondTemplateConfigId = (0, _customRequestModuleIds.getRespondTemplateConfigId)();
        const transferTemplateConfigId = (0, _customRequestModuleIds.getTransferTemplateConfigId)();
        const offerTextTemplateConfigId = (0, _customRequestModuleIds.getOfferTextTemplateConfigId)();
        switch(values.topicResponseType){
            case "respond":
                matchingTemplate = availableTemplates.data.find((template)=>template.id === respondTemplateConfigId);
                break;
            case "transfer":
                matchingTemplate = availableTemplates.data.find((template)=>template.id === transferTemplateConfigId);
                break;
            case "offerText":
                matchingTemplate = availableTemplates.data.find((template)=>template.id === offerTextTemplateConfigId);
                break;
        }
        if (matchingTemplate) {
            const appliedAppTemplateResponse = await props.appliedAppTemplateContainer.addAppliedTemplateToApp(props.applicationId, matchingTemplate.id);
            const nameTemplateFormSection = appliedAppTemplateResponse?.data?.templateForm?.templateFormSections?.find((section)=>section.title === "Details");
            const nameTemplateFormField = nameTemplateFormSection?.templateFormFields?.find((field)=>field.title === "Name");
            const formFieldValueToUpdate = appliedAppTemplateResponse?.data?.templateFormFieldValues?.find((field)=>field.label === "Name");
            const updatedAppliedAppTemplate = {
                templateFormFieldValues: [
                    ...appliedAppTemplateResponse?.data?.templateFormFieldValues,
                    {
                        ...formFieldValueToUpdate,
                        templateFormFieldId: nameTemplateFormField.id,
                        value: values.topicName
                    }
                ],
                name: values.topicName
            };
            await props.appliedAppTemplateContainer.updateAppliedTemplate(appliedAppTemplateResponse.data.id, updatedAppliedAppTemplate);
            await props.appliedAppTemplateContainer.loadAppliedTemplates(props.applicationId);
            props.toggleNewTopicModal();
        }
    }
})((0, _sparkNewTopicDefault.default));
exports.default = SparkNewTopicForm;

},{"formik":"3YnOK","yup":"j2SJU","./SparkNewTopic":"hfV5Y","../../../../shared/constants/sparkConstants/customRequestModuleIds":"kK2PT","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hfV5Y":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _base = require("@emotion/styled/base");
var _baseDefault = parcelHelpers.interopDefault(_base);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _colors = require("../../../../shared/constants/colors");
var _radioCardGroup = require("../../../../shared/components/forms/RadioCardGroup");
var _radioCardGroupDefault = parcelHelpers.interopDefault(_radioCardGroup);
var _css = require("@emotion/css");
var _textField = require("../../../../shared/components/forms/TextField");
var _textFieldDefault = parcelHelpers.interopDefault(_textField);
var _modalHeader = require("../../../../shared/components/general/ModalHeader");
var _modalHeaderDefault = parcelHelpers.interopDefault(_modalHeader);
var _footerBar = require("../../../../shared/components/structure/FooterBar");
var _footerBarDefault = parcelHelpers.interopDefault(_footerBar);
var _button = require("../../../../shared/components/general/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _modalLayout = require("../../../../shared/components/structure/ModalLayout");
var _modalLayoutDefault = parcelHelpers.interopDefault(_modalLayout);
var _customScrollbars = require("../../../../shared/components/structure/CustomScrollbars");
var _customScrollbarsDefault = parcelHelpers.interopDefault(_customScrollbars);
var _useWindowSize = require("../../../../shared/hooks/UseWindowSize");
var _useWindowSizeDefault = parcelHelpers.interopDefault(_useWindowSize);
var _breakpoints = require("../../../../shared/constants/breakpoints");
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const respondIcon = require("4e96925fa76b88af");
const textIcon = require("2a4c080d301b6093");
const transferIcon = require("c6ac0244d60b7c6e");
const SparkNewTopic = (props)=>{
    const MODAL_SCROLLBAR_SUBTRACTION = 200;
    const windowSize = (0, _useWindowSizeDefault.default)();
    (0, _react1.useEffect)(()=>{
        props.appliedAppTemplateContainer.loadAppliedTemplates(props.applicationId);
    }, [
        props.sections.length
    ]);
    const [topic, setTopic] = (0, _react1.useState)("your new topic");
    const topicResponseOptions = [
        {
            label: "Respond to the Topic",
            value: "respond",
            icon: respondIcon,
            description: 'For Example: "Yes, we are hiring. Email your resume to staff@restaurant.com. What else can I help you with?"',
            className: radioOptionCardStyle
        },
        {
            label: "Transfer the Call",
            value: "transfer",
            icon: transferIcon,
            description: 'For Example: "No problem! Transferring you to our catering department so you can learn more about our options."',
            className: radioOptionCardStyle
        },
        {
            label: "Offer a Text Message",
            value: "offerText",
            icon: textIcon,
            description: 'For Example: "I can send you a text message with our full menu. What phone number can I reach you at?"',
            className: radioOptionCardStyle
        }
    ];
    return (0, _react.jsx)((0, _modalLayoutDefault.default), {
        isVisible: true
    }, (0, _react.jsx)((0, _modalHeaderDefault.default), {
        title: "Add a New Topic",
        onClose: ()=>props.toggleNewTopicModal()
    }), (0, _react.jsx)("form", {
        onSubmit: props.handleSubmit
    }, (0, _react.jsx)((0, _customScrollbarsDefault.default), {
        autoHide: true,
        autoHeight: true,
        autoHeightMax: windowSize.windowSize.innerHeight * .9 - MODAL_SCROLLBAR_SUBTRACTION
    }, (0, _react.jsx)(ModalBody, null, (0, _react.jsx)(HeaderWrapper, null, (0, _react.jsx)(SubHeader, null, "Topic Name"), (0, _react.jsx)(Description, null, "Create a brief topic name, that will be used as the form section title.")), (0, _react.jsx)((0, _textFieldDefault.default), {
        name: "topicName",
        value: props.values.topicName,
        onChange: (e)=>{
            props.setFieldValue("topicName", e.target.value);
            setTopic(e.target.value);
        },
        placeholder: "Enter your new topic name here. e.g. Getting Started Information"
    }), (0, _react.jsx)(HeaderWrapper, null, (0, _react.jsx)(SubHeader, null, "Expected Response"), (0, _react.jsx)(Description, null, `If a customer inquires about ${topic}, the assistant should:`)), (0, _react.jsx)((0, _radioCardGroupDefault.default), {
        onChange: (e)=>props.setFieldValue("topicResponseType", e.value),
        value: props.values.topicResponseType,
        options: topicResponseOptions
    }))), (0, _react.jsx)((0, _footerBarDefault.default), {
        className: footerBarStyle
    }, (0, _react.jsx)(StyledCloseButton, {
        disabled: props.isSubmitting,
        loading: props.isSubmitting,
        type: "button",
        themes: [
            "secondary"
        ],
        text: "Close",
        onClick: ()=>props.toggleNewTopicModal()
    }), (0, _react.jsx)(StyledAddButton, {
        disabled: props.isSubmitting,
        loading: props.isSubmitting,
        type: "submit",
        themes: [
            "primary"
        ],
        text: "Add"
    }))));
};
const footerBarStyle = /*#__PURE__*/ (0, _css.css)({
    name: "1eoy87d",
    styles: "display:flex;justify-content:space-between"
});
const StyledAddButton = /*#__PURE__*/ (0, _baseDefault.default)((0, _buttonDefault.default), {
    target: "e1fdh5mm5"
})((0, _breakpoints.breakpoint_small), "{margin:0 8px 0 0;}");
const StyledCloseButton = /*#__PURE__*/ (0, _baseDefault.default)((0, _buttonDefault.default), {
    target: "e1fdh5mm4"
})((0, _breakpoints.breakpoint_small), "{margin:0 0 0 8px;}");
const HeaderWrapper = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1fdh5mm3"
})((0, _breakpoints.breakpoint_small), "{padding:0 8px;}");
const ModalBody = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1fdh5mm2"
})("padding:0 32px;", (0, _breakpoints.breakpoint_small), "{padding:0 16px;display:flex;flex-direction:column;justify-content:center;}");
const radioOptionCardStyle = /*#__PURE__*/ (0, _css.css)({
    name: "knjsbg",
    styles: "padding:32px"
});
const Description = /*#__PURE__*/ (0, _baseDefault.default)("p", {
    target: "e1fdh5mm1"
})("font-size:14px;color:", (0, _colors.color_shades_darker), ";margin:16px 0 16px 0;");
const SubHeader = /*#__PURE__*/ (0, _baseDefault.default)("h2", {
    target: "e1fdh5mm0"
})("margin-top:24px;font-size:18px;color:", (0, _colors.color_shades_darkest), ";font-weight:400;");
exports.default = SparkNewTopic;

},{"@emotion/styled/base":"lSuFu","@emotion/react":"djZKr","react":"6uln9","../../../../shared/constants/colors":"1p3OR","../../../../shared/components/forms/RadioCardGroup":"ZeFLy","@emotion/css":"awUBr","../../../../shared/components/forms/TextField":"7a7bh","../../../../shared/components/general/ModalHeader":"aUACx","../../../../shared/components/structure/FooterBar":"bibRL","../../../../shared/components/general/Button":"6ymxN","../../../../shared/components/structure/ModalLayout":"b1cO3","../../../../shared/components/structure/CustomScrollbars":"50vFq","../../../../shared/hooks/UseWindowSize":"43j9z","../../../../shared/constants/breakpoints":"2F01A","4e96925fa76b88af":"jgCE0","2a4c080d301b6093":"7sH7r","c6ac0244d60b7c6e":"4uPXJ","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jgCE0":[function(require,module,exports) {
module.exports = require("31c75d1929b14e95").getBundleURL("kVLro") + require("95686aea9672e169").resolve("8mi0t");

},{"31c75d1929b14e95":"c7Tr5","95686aea9672e169":"fyJL2"}],"7sH7r":[function(require,module,exports) {
module.exports = require("2d5e2ef0859fc538").getBundleURL("kVLro") + require("c6d85859cbf6ba7f").resolve("dhTzA");

},{"2d5e2ef0859fc538":"c7Tr5","c6d85859cbf6ba7f":"fyJL2"}],"4uPXJ":[function(require,module,exports) {
module.exports = require("114e44197539c495").getBundleURL("kVLro") + require("ebf5d2ec3b81df10").resolve("6Tt2S");

},{"114e44197539c495":"c7Tr5","ebf5d2ec3b81df10":"fyJL2"}],"kK2PT":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getRespondTemplateConfigId", ()=>getRespondTemplateConfigId);
parcelHelpers.export(exports, "getTransferTemplateConfigId", ()=>getTransferTemplateConfigId);
parcelHelpers.export(exports, "getOfferTextTemplateConfigId", ()=>getOfferTextTemplateConfigId);
const getRespondTemplateConfigId = ()=>{
    return "3103b6c3-cb34-465d-a8e2-d03ed229e0a2";
};
const getTransferTemplateConfigId = ()=>{
    return "a4bee9ad-f559-4330-8bce-7f1487b1748f";
};
const getOfferTextTemplateConfigId = ()=>{
    return "8366f581-0b5f-426e-8c8c-85cd7e9aa508";
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8pVbk":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "columnOneHeading", ()=>columnOneHeading);
parcelHelpers.export(exports, "columnTwoHeading", ()=>columnTwoHeading);
parcelHelpers.export(exports, "columnThreeHeading", ()=>columnThreeHeading);
const columnOneHeading = "applied app template id";
const columnTwoHeading = "display title";
const columnThreeHeading = "assistant response";

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"d7wE0":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _base = require("@emotion/styled/base");
var _baseDefault = parcelHelpers.interopDefault(_base);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _modalLayout = require("../../../components/structure/ModalLayout");
var _modalLayoutDefault = parcelHelpers.interopDefault(_modalLayout);
var _modalHeader = require("../../../components/general/ModalHeader");
var _modalHeaderDefault = parcelHelpers.interopDefault(_modalHeader);
var _customScrollbars = require("../../../components/structure/CustomScrollbars");
var _customScrollbarsDefault = parcelHelpers.interopDefault(_customScrollbars);
var _colors = require("../../../constants/colors");
var _textField = require("../../../components/forms/TextField");
var _textFieldDefault = parcelHelpers.interopDefault(_textField);
var _useWindowSize = require("../../../hooks/UseWindowSize");
var _useWindowSizeDefault = parcelHelpers.interopDefault(_useWindowSize);
var _footerBar = require("../../../components/structure/FooterBar");
var _footerBarDefault = parcelHelpers.interopDefault(_footerBar);
var _button = require("../../../components/general/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _formik = require("formik");
var _yup = require("yup");
var _css = require("@emotion/css");
var _organizationContainer = require("../../../state/containers/OrganizationContainer");
var _organizationContainerDefault = parcelHelpers.interopDefault(_organizationContainer);
var _warningLabel = require("../../../components/general/WarningLabel");
var _warningLabelDefault = parcelHelpers.interopDefault(_warningLabel);
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const infoCircle = require("ee91a63605963912");
const copyIcon = require("f91814c22fa23c1c");
const sendEmailIcon = require("a11591d9e6d4c9fc");
const generateIcon = require("15d26ca643c3c25e");
const InnerForm = (props)=>{
    const [isURLCopied, setIsURLCopied] = (0, _react1.useState)(false);
    const MODAL_SCROLLBAR_SUBTRACTION = 200;
    const windowSize = (0, _useWindowSizeDefault.default)();
    const isLoading = props.memberContainer.state.isLoading;
    const handleURLCopy = (text)=>{
        navigator.clipboard.writeText(text);
        setIsURLCopied(true);
        setTimeout(()=>{
            setIsURLCopied(false);
        }, 3000);
    };
    const handleCustomSubmit = (sendEmail)=>{
        if (sendEmail) props.setValues({
            ...props.values,
            sendEmail: true
        });
        else props.setValues({
            ...props.values,
            sendEmail: false
        });
        props.handleSubmit();
    };
    return (0, _react.jsx)((0, _modalLayoutDefault.default), {
        isVisible: true
    }, (0, _react.jsx)((0, _modalHeaderDefault.default), {
        title: "Invite Others to Your Organization",
        onClose: ()=>{
            props.setIsShareFormOpen(false);
        }
    }), (0, _react.jsx)("form", {
        onSubmit: (e)=>e.preventDefault()
    }, (0, _react.jsx)((0, _customScrollbarsDefault.default), {
        autoHide: true,
        autoHeight: true,
        autoHeightMax: windowSize.windowSize.innerHeight * .9 - MODAL_SCROLLBAR_SUBTRACTION
    }, (0, _react.jsx)(FormBodyWrapper, null, (0, _react.jsx)((0, _warningLabelDefault.default), {
        image: infoCircle,
        text: "Note: Inviting others gives them full access to all resources and data within the organization. Please invite trusted individuals only."
    }), (0, _react.jsx)("hr", null), (0, _react.jsx)(FieldsWrapper, null, (0, _react.jsx)((0, _textFieldDefault.default), {
        name: "email",
        label: "Email",
        type: "email",
        required: true,
        value: props.values.email,
        placeholder: "user@company.com",
        onChange: props.handleChange,
        onBlur: props.handleBlur,
        disabled: props.isSubmitting
    }), (0, _react.jsx)((0, _textFieldDefault.default), {
        name: "firstName",
        value: props.values.firstName,
        label: "First Name",
        required: true,
        placeholder: "What name do you go by?",
        onChange: props.handleChange,
        onBlur: props.handleBlur,
        disabled: props.isSubmitting
    }), (0, _react.jsx)((0, _textFieldDefault.default), {
        name: "lastName",
        value: props.values.lastName,
        label: "Last Name",
        placeholder: "Last name",
        required: true,
        onChange: props.handleChange,
        onBlur: props.handleBlur,
        disabled: props.isSubmitting
    })), props?.status?.error?.length > 1 && (0, _react.jsx)("h4", null, props.status.error), props?.status?.inviteURL && (0, _react.jsx)((0, _reactDefault.default).Fragment, null, (0, _react.jsx)("hr", null), (0, _react.jsx)(InviteURLWrapper, {
        onClick: ()=>handleURLCopy(props.status.inviteURL)
    }, (0, _react.jsx)((0, _textFieldDefault.default), {
        name: "inviteUrl",
        value: props.status.inviteURL,
        label: isURLCopied ? "Invite URL - COPIED" : "Invite URL",
        disabled: true,
        icon: copyIcon,
        fieldStyle: isURLCopied && InviteURLStyle
    }))))), (0, _react.jsx)((0, _footerBarDefault.default), {
        className: footerStyle
    }, (0, _react.jsx)("div", null, (0, _react.jsx)(StyledButton, {
        themes: [
            "primary",
            "start"
        ],
        text: "Generate Link",
        loading: isLoading,
        icon: generateIcon,
        onClick: ()=>handleCustomSubmit(false)
    }), (0, _react.jsx)(StyledButton, {
        themes: [
            "primary",
            "start"
        ],
        text: "Send Invite",
        loading: isLoading,
        icon: sendEmailIcon,
        onClick: ()=>handleCustomSubmit(true)
    })), (0, _react.jsx)(StyledButton, {
        themes: [
            "secondary"
        ],
        text: "Cancel",
        onClick: ()=>props.setIsShareFormOpen(false)
    }))));
};
const InviteSparkFormModal = (0, _formik.withFormik)({
    mapPropsToValues: (props)=>({
            email: "",
            firstName: "",
            lastName: "",
            sendEmail: false
        }),
    validationSchema: _yup.object().shape({
        firstName: _yup.string().required("You must enter your first name"),
        lastName: _yup.string().required("You must enter your last name"),
        email: _yup.string().email("Must be a valid email").required("You must enter your email")
    }),
    handleSubmit: async (values, { props, setStatus, setSubmitting })=>{
        const currentOrgId = JSON.parse(localStorage.getItem("CURRENT_ORG"))?.id;
        if (!currentOrgId) {
            setStatus({
                error: "Could not find organization. Please refresh."
            });
            return;
        }
        const organizationContainer = new (0, _organizationContainerDefault.default)();
        const systemRolesResults = await organizationContainer.getSystemRoles();
        if (systemRolesResults.resultType !== "Ok") {
            setStatus({
                error: systemRolesResults.errors[0]
            });
            return;
        }
        const request = {
            applicationId: props.applicationId,
            email: values.email,
            firstName: values.firstName,
            lastName: values.lastName,
            isAdmin: true,
            isAddedToApplications: true,
            applicationRoleId: systemRolesResults.data.find((role)=>role.name === "Admin").id,
            sendEmail: values.sendEmail
        };
        setSubmitting(true);
        const result = await props.memberContainer.inviteSparkForm(currentOrgId, request);
        setSubmitting(false);
        if (result.resultType !== "Ok") setStatus({
            error: result.errors[0]
        });
        else if (values.sendEmail) props.setIsShareFormOpen(false);
        else setStatus({
            inviteURL: result.data.inviteURL
        });
    }
})(InnerForm);
const StyledButton = /*#__PURE__*/ (0, _baseDefault.default)((0, _buttonDefault.default), {
    target: "eincd943"
})({
    name: "f939l8",
    styles: "margin:0px;margin-left:10px;@media(max-width: 900px){font-size:15px;padding:0px 10px 0px 10px;}@media(max-width: 500px){font-size:13px;padding:0px 10px 0px 10px;margin-top:10px;}"
});
const FormBodyWrapper = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "eincd942"
})({
    name: "r43ro",
    styles: "padding:20px 30px 0px 30px"
});
const FieldsWrapper = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "eincd941"
})({
    name: "1r0yqr6",
    styles: "margin-top:10px"
});
const footerStyle = /*#__PURE__*/ (0, _css.css)({
    name: "oxjs4y",
    styles: "display:flex;justify-content:space-between;padding-right:10px;@media(max-width: 500px){height:auto;padding:10px;}"
});
const InviteURLStyle = /*#__PURE__*/ (0, _css.css)("border:1px solid rgb(30,144,255);color:", (0, _colors.dark_grey_blue), ";font-family:Muli;text-align:left;width:100%;border-radius:5px;padding:12px 16px;font-size:14px;background:transparent;::placeholder{font-weight:normal;font-style:italic;letter-spacing:normal;color:", (0, _colors.color_shades_darker), ";}", "");
const InviteURLWrapper = /*#__PURE__*/ (0, _baseDefault.default)("span", {
    target: "eincd940"
})({
    name: "e0dnmk",
    styles: "cursor:pointer"
});
exports.default = InviteSparkFormModal;

},{"@emotion/styled/base":"lSuFu","@emotion/react":"djZKr","react":"6uln9","../../../components/structure/ModalLayout":"b1cO3","../../../components/general/ModalHeader":"aUACx","../../../components/structure/CustomScrollbars":"50vFq","../../../constants/colors":"1p3OR","../../../components/forms/TextField":"7a7bh","../../../hooks/UseWindowSize":"43j9z","../../../components/structure/FooterBar":"bibRL","../../../components/general/Button":"6ymxN","formik":"3YnOK","yup":"j2SJU","@emotion/css":"awUBr","../../../state/containers/OrganizationContainer":"dlbaM","../../../components/general/WarningLabel":"2Tr48","ee91a63605963912":"k0Bys","f91814c22fa23c1c":"1jL91","a11591d9e6d4c9fc":"iZpTh","15d26ca643c3c25e":"jrkQl","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"iZpTh":[function(require,module,exports) {
module.exports = require("627f974c8f646c24").getBundleURL("kVLro") + require("2852ea1f09503fbe").resolve("hdsNy");

},{"627f974c8f646c24":"c7Tr5","2852ea1f09503fbe":"fyJL2"}],"jrkQl":[function(require,module,exports) {
module.exports = require("45a2a2eccf26639e").getBundleURL("kVLro") + require("4c2b841636504789").resolve("ggx5x");

},{"45a2a2eccf26639e":"c7Tr5","4c2b841636504789":"fyJL2"}],"bNIQ5":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AutoGenerateFormFieldResponsesFormModal", ()=>AutoGenerateFormFieldResponsesFormModal);
parcelHelpers.export(exports, "AutoGenerateFormFieldResponsesForm", ()=>AutoGenerateFormFieldResponsesForm);
var _formik = require("formik");
var _yup = require("yup");
var _autoGenerateFormFieldResponses = require("./AutoGenerateFormFieldResponses");
var _autoGenerateFormFieldResponsesDefault = parcelHelpers.interopDefault(_autoGenerateFormFieldResponses);
var _autoGenerateFormFieldResponsesModal = require("./AutoGenerateFormFieldResponsesModal");
var _autoGenerateFormFieldResponsesModalDefault = parcelHelpers.interopDefault(_autoGenerateFormFieldResponsesModal);
async function handleSubmit(values, { props }) {
    if (values.autoGenerateFormFieldResponses) {
        if ("setIsLoading" in props) props.setIsLoading(true);
        const appliedTemplatesToUpdate = props.appliedAppTemplateContainer?.state?.appliedTemplates;
        const appliedTemplatesToUpdateIds = appliedTemplatesToUpdate.map((template)=>template.id);
        const autoGenerateAppliedAppValuesRequest = {
            appliedApplicationTemplateIds: appliedTemplatesToUpdateIds,
            fileUrl: values.fileUrl,
            webPageUrls: values.webPageUrls
        };
        await props.appliedAppTemplateContainer.autoGenerateAppliedApplicationTemplateFieldValues(props.applicationId, autoGenerateAppliedAppValuesRequest);
        if ("setIsLoading" in props) props.setIsLoading(false);
    }
    if ("onClose" in props) props.onClose();
    if ("handleNextSection" in props) props.handleNextSection();
}
const AutoGenerateFormFieldResponsesFormModal = (0, _formik.withFormik)({
    mapPropsToValues: (props)=>({
            autoGenerateFormFieldResponses: true,
            usefileUpload: false,
            fileUrl: "",
            webPageUrls: [
                ""
            ]
        }),
    validationSchema: _yup.object().shape({}),
    handleSubmit: handleSubmit
})((0, _autoGenerateFormFieldResponsesModalDefault.default));
const AutoGenerateFormFieldResponsesForm = (0, _formik.withFormik)({
    mapPropsToValues: (props)=>({
            autoGenerateFormFieldResponses: false,
            usefileUpload: false,
            fileUrl: "",
            webPageUrls: [
                ""
            ]
        }),
    validationSchema: _yup.object().shape({}),
    handleSubmit
})((0, _autoGenerateFormFieldResponsesDefault.default));

},{"formik":"3YnOK","yup":"j2SJU","./AutoGenerateFormFieldResponses":"g0dxR","./AutoGenerateFormFieldResponsesModal":"hnM6G","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"g0dxR":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _extends = require("@babel/runtime/helpers/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _base = require("@emotion/styled/base");
var _baseDefault = parcelHelpers.interopDefault(_base);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _panelContainer = require("../../../../../shared/components/structure/Panels/PanelContainer");
var _panelContainerDefault = parcelHelpers.interopDefault(_panelContainer);
var _scrollablePanelBody = require("../../../../../shared/components/structure/ScrollablePanelBody");
var _scrollablePanelBodyDefault = parcelHelpers.interopDefault(_scrollablePanelBody);
var _button = require("../../../../../shared/components/general/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _css = require("@emotion/css");
var _breakpoints = require("../../../../../shared/constants/breakpoints");
var _panelHeaderContainer = require("../../../../../shared/components/structure/Panels/PanelHeaderContainer");
var _panelHeaderContainerDefault = parcelHelpers.interopDefault(_panelHeaderContainer);
var _colors = require("../../../../../shared/constants/colors");
var _switch = require("../../../../../shared/components/forms/Switch");
var _switchDefault = parcelHelpers.interopDefault(_switch);
var _formFieldCard = require("../../../../../shared/components/forms/FormFieldCard");
var _formFieldCardDefault = parcelHelpers.interopDefault(_formFieldCard);
var _autoGenerateFormFieldInformationGathering = require("./AutoGenerateFormFieldInformationGathering");
var _autoGenerateFormFieldInformationGatheringDefault = parcelHelpers.interopDefault(_autoGenerateFormFieldInformationGathering);
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const instructionsIcon = require("f37179517e84b070");
const AutoGenerateFormFieldResponses = (props)=>{
    const updateAutoGenerateSectionStatus = (isComplete, isSelected)=>{
        const autoGenerateSectionIndex = props.appendedSections.findIndex((appendedSection)=>appendedSection.id === props.autoGenerateFormResponsesSection.id);
        const updatedAutoGenerateSection = {
            ...props.appendedSections[autoGenerateSectionIndex],
            isComplete,
            isSelected
        };
        const appendedSectionsWithUpdatedAutoGenerateSection = [
            ...props.appendedSections.slice(0, autoGenerateSectionIndex),
            updatedAutoGenerateSection,
            ...props.appendedSections.slice(autoGenerateSectionIndex + 1)
        ];
        props.setAppendedSections(appendedSectionsWithUpdatedAutoGenerateSection);
    };
    const handleAutoGenerateFormFieldResponsesSubmit = ()=>{
        props.handleRemoveSection(props.autoGenerateFormResponsesSection);
        props.removeSectionFromIncompleteSections(props.autoGenerateFormResponsesSection);
        props.handleSubmit();
    };
    const handleFileUrlFieldChange = (value)=>{
        props.setFieldValue("fileUrl", value);
        props.setFieldValue("webPageUrls", []);
    };
    const handleSkipAutoGenerateSection = ()=>{
        props.handleRemoveSection(props.autoGenerateFormResponsesSection);
        props.removeSectionFromIncompleteSections(props.autoGenerateFormResponsesSection);
    };
    return (0, _react.jsx)(AutoGenerateResponsesWrapper, null, (0, _react.jsx)((0, _panelHeaderContainerDefault.default), null, (0, _react.jsx)(InstructionsIcon, {
        src: instructionsIcon
    }), (0, _react.jsx)(InstructionsText, null, "Complete the fields below"), (0, _react.jsx)("div", {
        className: buttonContainerStyle
    }, (0, _react.jsx)((0, _buttonDefault.default), {
        disabled: false,
        loading: props.isLoading,
        themes: [
            "primary-small"
        ],
        text: "Save & Next",
        type: "button",
        onClick: ()=>handleAutoGenerateFormFieldResponsesSubmit()
    }))), (0, _react.jsx)(AutoGenerateResponsesFormWrapper, null, (0, _react.jsx)((0, _panelContainerDefault.default), {
        className: panelContainerStyle
    }, (0, _react.jsx)((0, _scrollablePanelBodyDefault.default), null, (0, _react.jsx)("form", {
        onSubmit: props.handleSubmit
    }, (0, _react.jsx)(FormFieldCardsWrapper, null, (0, _react.jsx)(Title, null, "Auto-Generate Responses"), (0, _react.jsx)(StyledFormFieldCard, {
        title: "Auto-Generate Responses",
        tip: "Enable this feature to automatically generate responses for your assistant.",
        className: formFieldCardStyle
    }, (0, _react.jsx)(CustomSwitch, {
        name: "autoGenerateFormFieldResponses",
        label: "Auto-generate responses for me",
        checked: props.values.autoGenerateFormFieldResponses,
        onChange: (checked)=>props.setFieldValue("autoGenerateFormFieldResponses", checked)
    })), props.values.autoGenerateFormFieldResponses === true && (0, _react.jsx)((0, _autoGenerateFormFieldInformationGatheringDefault.default), (0, _extendsDefault.default)({}, props, {
        handleFileUrlFieldChange: (url)=>handleFileUrlFieldChange(url),
        handleWebPageUrlChange: (e)=>{
            props.setFieldValue("fileUrl", null);
            props.handleChange(e);
        },
        setUseFileUpload: (value)=>props.setFieldValue("usefileUpload", value)
    }))), (0, _react.jsx)(ButtonWrapper, null, (0, _react.jsx)(StyledSaveAndNextButton, {
        disabled: false,
        loading: props.isLoading,
        themes: [
            "primary"
        ],
        text: "Save & Next",
        type: "button",
        onClick: ()=>handleAutoGenerateFormFieldResponsesSubmit()
    }), (0, _react.jsx)(StyledSkipButton, {
        disabled: false,
        loading: props.isLoading,
        themes: [
            "primary"
        ],
        text: "Skip",
        type: "button",
        onClick: ()=>handleSkipAutoGenerateSection()
    })))))));
};
const StyledFormFieldCard = /*#__PURE__*/ (0, _baseDefault.default)((0, _formFieldCardDefault.default), {
    target: "ek9wwr911"
})("");
const formFieldCardStyle = /*#__PURE__*/ (0, _css.css)({
    name: "zhi4ni",
    styles: "margin:32px 0"
});
const AutoGenerateResponsesWrapper = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "ek9wwr910"
})("");
const CustomSwitch = /*#__PURE__*/ (0, _baseDefault.default)((0, _switchDefault.default), {
    target: "ek9wwr99"
})({
    name: "456bw7",
    styles: "margin:24px 0"
});
const FormFieldCardWrapper = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "ek9wwr98"
})("padding:16px 0px;position:relative;.field-triangle{position:absolute;width:24px;height:24px;background:", (0, _colors.color_shades_lighter), ";right:-44px;top:64px;transform:rotate(45deg);border-left:1px solid ", (0, _colors.color_shades_dark), ";border-bottom:1px solid ", (0, _colors.color_shades_dark), ";}");
const FormFieldCardsWrapper = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "ek9wwr97"
})("padding:32px;h3{margin-bottom:16px;font-style:normal;font-weight:normal;font-size:18px;line-height:24px;}", (0, _breakpoints.breakpoint_small), "{padding:16px;h3{margin-bottom:0px;}}");
const InstructionsIcon = /*#__PURE__*/ (0, _baseDefault.default)("img", {
    target: "ek9wwr96"
})("width:24px;height:24px;margin:0 8px 0 32px;", (0, _breakpoints.breakpoint_small), "{display:none;}");
const InstructionsText = /*#__PURE__*/ (0, _baseDefault.default)("p", {
    target: "ek9wwr95"
})((0, _breakpoints.breakpoint_small), "{display:none;}");
const buttonContainerStyle = /*#__PURE__*/ (0, _css.css)("margin-right:16px;margin-left:auto;button{margin:0 16px 0 0;}", (0, _breakpoints.breakpoint_small), "{margin-right:0;}", "");
const AutoGenerateResponsesFormWrapper = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "ek9wwr94"
})("h3{margin-bottom:16px;font-style:normal;font-weight:normal;font-size:18px;line-height:24px;}", (0, _breakpoints.breakpoint_small), "{padding:16px;h3{margin-bottom:0px;}}");
const StyledSaveAndNextButton = /*#__PURE__*/ (0, _baseDefault.default)((0, _buttonDefault.default), {
    target: "ek9wwr93"
})("margin-top:0px;margin-right:32px;", (0, _breakpoints.breakpoint_small), "{margin-right:0;width:100px;font-size:12px;}");
const StyledSkipButton = /*#__PURE__*/ (0, _baseDefault.default)((0, _buttonDefault.default), {
    target: "ek9wwr92"
})("margin-top:0px;margin-right:32px;", (0, _breakpoints.breakpoint_small), "{margin-right:16px;width:100px;font-size:12px;}");
const panelContainerStyle = /*#__PURE__*/ (0, _css.css)({
    name: "zjik7",
    styles: "display:flex"
});
const ButtonWrapper = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "ek9wwr91"
})("display:flex;justify-content:space-between;margin:0 0 88px 18px;", (0, _breakpoints.breakpoint_small), "{justify-content:flex-end;}");
const Title = /*#__PURE__*/ (0, _baseDefault.default)("h3", {
    target: "ek9wwr90"
})({
    name: "e6krut",
    styles: "font-size:18px;font-weight:normal;margin-bottom:16px"
});
exports.default = AutoGenerateFormFieldResponses;

},{"@babel/runtime/helpers/extends":"4iKIP","@emotion/styled/base":"lSuFu","@emotion/react":"djZKr","react":"6uln9","../../../../../shared/components/structure/Panels/PanelContainer":"9R2lE","../../../../../shared/components/structure/ScrollablePanelBody":"6LRg3","../../../../../shared/components/general/Button":"6ymxN","@emotion/css":"awUBr","../../../../../shared/constants/breakpoints":"2F01A","../../../../../shared/components/structure/Panels/PanelHeaderContainer":"hUotd","../../../../../shared/constants/colors":"1p3OR","../../../../../shared/components/forms/Switch":"8kkL9","../../../../../shared/components/forms/FormFieldCard":"bDrD9","./AutoGenerateFormFieldInformationGathering":"lnIu7","f37179517e84b070":"3Pubw","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"lnIu7":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>AutoGenerateFormFieldInformationGathering);
var _base = require("@emotion/styled/base");
var _baseDefault = parcelHelpers.interopDefault(_base);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _fileUploadField = require("../../../../../shared/components/forms/FileUploadField");
var _fileUploadFieldDefault = parcelHelpers.interopDefault(_fileUploadField);
var _textField = require("../../../../../shared/components/forms/TextField");
var _textFieldDefault = parcelHelpers.interopDefault(_textField);
var _css = require("@emotion/css");
var _formFieldCard = require("../../../../../shared/components/forms/FormFieldCard");
var _formFieldCardDefault = parcelHelpers.interopDefault(_formFieldCard);
var _warningLabel = require("../../../../../shared/components/general/WarningLabel");
var _warningLabelDefault = parcelHelpers.interopDefault(_warningLabel);
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const infoCircle = require("edee6c068bf61a52");
function AutoGenerateFormFieldInformationGathering(props) {
    return (0, _react.jsx)("div", null, (0, _react.jsx)((0, _warningLabelDefault.default), {
        image: infoCircle,
        text: "Note: Automatically generating answers will overwrite any previously saved information in the fields."
    }), props.values.usefileUpload === true && (0, _react.jsx)(StyledFormFieldCard, {
        title: "Upload File",
        tip: "Upload a file with your restaurant's information. We'll use it to create responses to common customer questions.",
        className: formFieldCardStyle
    }, (0, _react.jsx)((0, _fileUploadFieldDefault.default), {
        onChange: (e)=>{
            props.handleFileUrlFieldChange(e.url);
        },
        disabled: false,
        fileFormats: ".pdf, .txt, .md",
        mediaContainer: props.mediaContainer,
        applicationId: props.applicationId,
        value: props.values.fileUrl,
        preview: false
    })), !props.values.usefileUpload === true && (0, _react.jsx)(StyledFormFieldCard, {
        title: "Use My Website",
        tip: "Enter your website URL. We'll use it to create responses to common customer questions.",
        className: formFieldCardStyle
    }, (0, _react.jsx)("div", null, props.values.webPageUrls?.map((webPageUrl, index)=>(0, _react.jsx)((0, _reactDefault.default).Fragment, null, (0, _react.jsx)("div", {
            key: "webPageUrl" + index
        }, (0, _react.jsx)((0, _textFieldDefault.default), {
            name: `webPageUrls.${index}`,
            id: `webPageUrls${index}`,
            value: webPageUrl,
            onChange: props.handleWebPageUrlChange,
            label: "Website URL",
            placeholder: "Enter your website URL here.",
            useForm: false
        })))))));
}
const StyledFormFieldCard = /*#__PURE__*/ (0, _baseDefault.default)((0, _formFieldCardDefault.default), {
    target: "e1i91hk90"
})("");
const formFieldCardStyle = /*#__PURE__*/ (0, _css.css)({
    name: "zhi4ni",
    styles: "margin:32px 0"
});

},{"@emotion/styled/base":"lSuFu","@emotion/react":"djZKr","react":"6uln9","../../../../../shared/components/forms/FileUploadField":"l7aUX","../../../../../shared/components/forms/TextField":"7a7bh","@emotion/css":"awUBr","../../../../../shared/components/forms/FormFieldCard":"bDrD9","../../../../../shared/components/general/WarningLabel":"2Tr48","edee6c068bf61a52":"k0Bys","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hnM6G":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _extends = require("@babel/runtime/helpers/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _base = require("@emotion/styled/base");
var _baseDefault = parcelHelpers.interopDefault(_base);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _footerBar = require("../../../../../shared/components/structure/FooterBar");
var _footerBarDefault = parcelHelpers.interopDefault(_footerBar);
var _modalLayout = require("../../../../../shared/components/structure/ModalLayout");
var _modalLayoutDefault = parcelHelpers.interopDefault(_modalLayout);
var _button = require("../../../../../shared/components/general/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _css = require("@emotion/css");
var _modalHeader = require("../../../../../shared/components/general/ModalHeader");
var _modalHeaderDefault = parcelHelpers.interopDefault(_modalHeader);
var _customScrollbars = require("../../../../../shared/components/structure/CustomScrollbars");
var _customScrollbarsDefault = parcelHelpers.interopDefault(_customScrollbars);
var _useWindowSize = require("../../../../../shared/hooks/UseWindowSize");
var _useWindowSizeDefault = parcelHelpers.interopDefault(_useWindowSize);
var _colors = require("../../../../../shared/constants/colors");
var _autoGenerateFormFieldInformationGathering = require("./AutoGenerateFormFieldInformationGathering");
var _autoGenerateFormFieldInformationGatheringDefault = parcelHelpers.interopDefault(_autoGenerateFormFieldInformationGathering);
var _breakpoints = require("../../../../../shared/constants/breakpoints");
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const AutoGenerateFormFieldResponsesModal = (props)=>{
    const containerRef = (0, _react1.useRef)(null);
    const MODAL_SCROLLBAR_SUBTRACTION = 250;
    const windowSize = (0, _useWindowSizeDefault.default)();
    (0, _react1.useEffect)(()=>{
        if (containerRef) containerRef.current.focus();
    }, []);
    (0, _react1.useEffect)(()=>{
        if (props.appliedAppTemplateContainer && props.appliedAppTemplateContainer.state.appliedTemplates.length > 0) {
            if (props.appliedAppTemplateContainer.state.appliedTemplates[0]?.generativeAiContexts?.length > 0) {
                const generativeAiContexts = props.appliedAppTemplateContainer.state.appliedTemplates[0].generativeAiContexts;
                const lastGenerativeAiContexts = generativeAiContexts[generativeAiContexts.length - 1];
                if (lastGenerativeAiContexts.fileUrl?.length > 0) {
                    props.setFieldValue("usefileUpload", true);
                    props.setFieldValue("fileUrl", lastGenerativeAiContexts.fileUrl);
                    props.setFieldValue("webPageUrls", []);
                } else if (lastGenerativeAiContexts.webPageUrls?.length > 0) {
                    const lastUrl = lastGenerativeAiContexts.webPageUrls[lastGenerativeAiContexts.webPageUrls.length - 1];
                    props.setFieldValue("webPageUrls", [
                        lastUrl
                    ]);
                    props.setFieldValue("fileUrl", null);
                }
            }
        }
    }, [
        props.appliedAppTemplateContainer.state.appliedTemplates
    ]);
    return (0, _react.jsx)("div", {
        ref: containerRef
    }, (0, _react.jsx)(AutoGenerateFormFieldResponsesModalStyled, {
        isVisible: true,
        onClose: props.onClose
    }, (0, _react.jsx)((0, _modalHeaderDefault.default), {
        title: "Auto generate answers",
        onClose: props.onClose
    }), (0, _react.jsx)("form", {
        onSubmit: (e)=>e.preventDefault()
    }, (0, _react.jsx)((0, _customScrollbarsDefault.default), {
        autoHide: true,
        autoHeight: true,
        autoHeightMax: windowSize.windowSize.innerHeight - MODAL_SCROLLBAR_SUBTRACTION
    }, (0, _react.jsx)(FormBodyWrapper, null, (0, _react.jsx)((0, _autoGenerateFormFieldInformationGatheringDefault.default), (0, _extendsDefault.default)({}, props, {
        handleFileUrlFieldChange: (url)=>{
            props.setFieldValue("fileUrl", url);
            props.setFieldValue("webPageUrls", []);
        },
        handleWebPageUrlChange: (e)=>{
            const url = e.target.value;
            props.setFieldValue("webPageUrls", [
                url
            ]);
            props.setFieldValue("fileUrl", null);
        },
        setUseFileUpload: (value)=>props.setFieldValue("usefileUpload", value)
    })))), (0, _react.jsx)((0, _footerBarDefault.default), {
        className: footerStyle
    }, (0, _react.jsx)("div", null, (0, _react.jsx)(StyledButton, {
        themes: [
            "primary",
            "start"
        ],
        text: "Submit",
        loading: props.isLoading,
        onClick: ()=>props.handleSubmit()
    })), (0, _react.jsx)(StyledButton, {
        themes: [
            "secondary"
        ],
        text: "Cancel",
        onClick: props.onClose
    })))));
};
exports.default = AutoGenerateFormFieldResponsesModal;
const AutoGenerateFormFieldResponsesModalStyled = /*#__PURE__*/ (0, _baseDefault.default)((0, _modalLayoutDefault.default), {
    target: "ethersn2"
})("color:", (0, _colors.color_text_default), ";height:850px;width:750px;min-width:30%;min-height:30%;", (0, _breakpoints.breakpoint_small), "{height:calc(100vh - 100px);}");
const StyledButton = /*#__PURE__*/ (0, _baseDefault.default)((0, _buttonDefault.default), {
    target: "ethersn1"
})({
    name: "f939l8",
    styles: "margin:0px;margin-left:10px;@media(max-width: 900px){font-size:15px;padding:0px 10px 0px 10px;}@media(max-width: 500px){font-size:13px;padding:0px 10px 0px 10px;margin-top:10px;}"
});
const FormBodyWrapper = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "ethersn0"
})({
    name: "r43ro",
    styles: "padding:20px 30px 0px 30px"
});
const footerStyle = /*#__PURE__*/ (0, _css.css)({
    name: "oxjs4y",
    styles: "display:flex;justify-content:space-between;padding-right:10px;@media(max-width: 500px){height:auto;padding:10px;}"
});

},{"@babel/runtime/helpers/extends":"4iKIP","@emotion/styled/base":"lSuFu","@emotion/react":"djZKr","react":"6uln9","../../../../../shared/components/structure/FooterBar":"bibRL","../../../../../shared/components/structure/ModalLayout":"b1cO3","../../../../../shared/components/general/Button":"6ymxN","@emotion/css":"awUBr","../../../../../shared/components/general/ModalHeader":"aUACx","../../../../../shared/components/structure/CustomScrollbars":"50vFq","../../../../../shared/hooks/UseWindowSize":"43j9z","../../../../../shared/constants/colors":"1p3OR","./AutoGenerateFormFieldInformationGathering":"lnIu7","../../../../../shared/constants/breakpoints":"2F01A","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6WgaZ":[function(require,module,exports) {
module.exports = require("c7812183e07d06a7").getBundleURL("kVLro") + require("88b25abf6349c552").resolve("aNXcl");

},{"c7812183e07d06a7":"c7Tr5","88b25abf6349c552":"fyJL2"}],"Ik7fU":[function(require,module,exports) {
module.exports = require("e549032d83e00b50").getBundleURL("kVLro") + require("d7bcae39e99f2700").resolve("678eT");

},{"e549032d83e00b50":"c7Tr5","d7bcae39e99f2700":"fyJL2"}],"hfaJb":[function(require,module,exports) {
module.exports = require("aaee6809d24ceaf2").getBundleURL("kVLro") + require("48cdfea95914e5fe").resolve("khhlK");

},{"aaee6809d24ceaf2":"c7Tr5","48cdfea95914e5fe":"fyJL2"}],"4OnfY":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _applicationContainer = require("../../state/containers/ApplicationContainer");
var _applicationContainerDefault = parcelHelpers.interopDefault(_applicationContainer);
var _currentTemplateSelector = require("./components/CurrentTemplateSelector");
var _currentTemplateSelectorDefault = parcelHelpers.interopDefault(_currentTemplateSelector);
var _unstated = require("unstated");
var _colors = require("../../constants/colors");
var _slideInSlideOutComponent = require("../../components/structure/SlideInSlideOutComponent");
var _slideInSlideOutComponentDefault = parcelHelpers.interopDefault(_slideInSlideOutComponent);
var _appliedAppTemplateMenu = require("../applicationAppliedTemplates/components/AppliedAppTemplateMenu");
var _appliedAppTemplateMenuDefault = parcelHelpers.interopDefault(_appliedAppTemplateMenu);
var _appliedApplicationTemplateContainer = require("../../state/containers/AppliedApplicationTemplateContainer");
var _appliedApplicationTemplateContainerDefault = parcelHelpers.interopDefault(_appliedApplicationTemplateContainer);
class ApplicationTemplateMenuSelector extends (0, _reactDefault.default).Component {
    constructor(props){
        super(props);
        this.state = {
            isExpanded: false
        };
    }
    toggle() {
        this.setState({
            ...this.state,
            isExpanded: !this.state.isExpanded
        });
    }
    render() {
        return (0, _react.jsx)((0, _unstated.Subscribe), {
            to: [
                (0, _applicationContainerDefault.default),
                (0, _appliedApplicationTemplateContainerDefault.default)
            ]
        }, (appContainer, appliedAppTemplateContainer)=>(0, _react.jsx)("div", {
                className: `${containerStyle} ${this.state.isExpanded ? "expanded" : ""}`
            }, (0, _react.jsx)((0, _currentTemplateSelectorDefault.default), {
                onToggle: this.toggle.bind(this),
                isMinified: true,
                isOpen: this.state.isExpanded,
                templateConfiguration: this.props.templateConfiguration
            }), (0, _react.jsx)((0, _slideInSlideOutComponentDefault.default), {
                showChildren: this.state.isExpanded,
                styleName: "contentTreeDropdownSlide",
                direction: "down",
                slideType: "size"
            }, (0, _react.jsx)("div", {
                className: "fixed-tree-container"
            }, (0, _react.jsx)((0, _appliedAppTemplateMenuDefault.default), {
                history: this.props.history,
                applicationId: this.props.applicationId,
                appContainer: appContainer,
                appliedAppTemplateContainer: appliedAppTemplateContainer
            })))));
    }
}
const containerStyle = /*#__PURE__*/ (0, _css.css)("height:80px;padding-top:16px;&.expanded{background:", (0, _colors.text_blue), ";}.fixed-tree-container{margin-top:80px;top:0;left:0;bottom:0;display:flex;flex-direction:column;position:fixed;max-height:calc(100% - 80px);width:288px;z-index:3;background:white;border-right:1px solid ", (0, _colors.color_shades_dark), ";}", "");
exports.default = ApplicationTemplateMenuSelector;

},{"@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","../../state/containers/ApplicationContainer":"cuqi2","./components/CurrentTemplateSelector":"eZYz3","unstated":"grh7p","../../constants/colors":"1p3OR","../../components/structure/SlideInSlideOutComponent":"bwTqS","../applicationAppliedTemplates/components/AppliedAppTemplateMenu":"fbZUw","../../state/containers/AppliedApplicationTemplateContainer":"3XuX7","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"kN958":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _colors = require("../../../constants/colors");
const incompleteIcon = require("e2c6e1d98fe1f249");
const readyIcon = require("290109388966f077");
const completeIcon = require("6ecffd18475bc172");
// note: we will likely need more status states in the future
const getStatusIcon = (status)=>{
    if (status == "incomplete" || status == "not-enabled") return incompleteIcon;
    if (status == "complete") return readyIcon;
    return completeIcon;
};
const getStatusLabel = (status)=>{
    switch(status){
        case "synced":
            return "In Use";
        case "complete":
            return "Ready";
        case "incomplete":
            return "Incomplete";
        case "not-enabled":
            return "Not Enabled";
    }
};
const AppliedTemplateStatusIndicator = (props)=>{
    return (0, _react.jsx)("div", {
        className: "status-indicator " + containerStyle
    }, (0, _react.jsx)("div", null, (0, _react.jsx)("p", {
        className: "label"
    }, "Template Status:"), (0, _react.jsx)("p", {
        className: "status"
    }, getStatusLabel(props.status))), (0, _react.jsx)("img", {
        src: getStatusIcon(props.status)
    }));
};
const containerStyle = /*#__PURE__*/ (0, _css.css)("display:flex;align-items:center;justify-content:flex-end;flex:1;margin-right:32px;img{margin-left:12px;border-right:1px solid ", (0, _colors.color_shades_dark), ";border-left:1px solid ", (0, _colors.color_shades_dark), ";padding:0 12px;height:24px;}.label{font-family:Muli;font-size:12px;font-weight:normal;font-style:normal;font-stretch:normal;line-height:normal;letter-spacing:normal;text-align:right;color:", (0, _colors.color_shades_light), ";cursor:pointer;text-align:right;}.status{font-family:Muli;font-size:14px;font-weight:normal;font-style:normal;font-stretch:normal;line-height:normal;letter-spacing:normal;text-align:right;color:white;cursor:pointer;}", "");
exports.default = AppliedTemplateStatusIndicator;

},{"@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","../../../constants/colors":"1p3OR","e2c6e1d98fe1f249":"kVdCE","290109388966f077":"hr0v4","6ecffd18475bc172":"4Vvcd","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"kVdCE":[function(require,module,exports) {
module.exports = require("b6c7be30b17484fe").getBundleURL("kVLro") + require("64c8f43afca3015a").resolve("32pqh");

},{"b6c7be30b17484fe":"c7Tr5","64c8f43afca3015a":"fyJL2"}],"hr0v4":[function(require,module,exports) {
module.exports = require("5ee6db1d8fb36cf").getBundleURL("kVLro") + require("236f9c7eb930cdbc").resolve("k7YXl");

},{"5ee6db1d8fb36cf":"c7Tr5","236f9c7eb930cdbc":"fyJL2"}],"4Vvcd":[function(require,module,exports) {
module.exports = require("52b380ccc5dfd2ac").getBundleURL("kVLro") + require("374a205bf4adb5b0").resolve("3SFzW");

},{"52b380ccc5dfd2ac":"c7Tr5","374a205bf4adb5b0":"fyJL2"}],"abrun":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _fullScreenLayout = require("../../scenes/fullScreenLayout");
var _fullScreenLayoutDefault = parcelHelpers.interopDefault(_fullScreenLayout);
var _button = require("./Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _modalTitle = require("./ModalTitle");
var _modalTitleDefault = parcelHelpers.interopDefault(_modalTitle);
var _pageContainer = require("../structure/PageContainer");
var _pageContainerDefault = parcelHelpers.interopDefault(_pageContainer);
var _footerBar = require("../structure/FooterBar");
var _footerBarDefault = parcelHelpers.interopDefault(_footerBar);
var _horizontalSeparator = require("../structure/HorizontalSeparator");
var _horizontalSeparatorDefault = parcelHelpers.interopDefault(_horizontalSeparator);
var _horizontalContainer = require("../structure/HorizontalContainer");
var _horizontalContainerDefault = parcelHelpers.interopDefault(_horizontalContainer);
var _colors = require("../../constants/colors");
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const expandIcon = require("ef484e6b4d168744");
class NewTermsModal extends (0, _reactDefault.default).Component {
    componentDidMount() {
        this.props.userContainer.getCurrentUserTermsAgreement();
    }
    openTermsInNewTab() {
        var win = window.open(this.props.userContainer.state.currentUserTermsAgreement.latestTerm.url, "_blank");
        win.focus();
    }
    acceptTerms() {
        this.props.userContainer.addUserTermAgreement(this.props.userContainer.state.currentUserTermsAgreement.latestTerm.id);
    }
    render() {
        const props = this.props;
        return this.props.userContainer.state.currentUserTermsAgreement.hasAgreedToLatest === false && (0, _react.jsx)("div", {
            className: containerStyle
        }, (0, _react.jsx)("div", {
            className: innerLayoutStyle
        }, (0, _react.jsx)("div", {
            className: innerWrapperStyle
        }, (0, _react.jsx)((0, _fullScreenLayoutDefault.default), null, (0, _react.jsx)((0, _pageContainerDefault.default), {
            fill: true
        }, (0, _react.jsx)((0, _horizontalContainerDefault.default), {
            className: "modal-title"
        }, (0, _react.jsx)((0, _modalTitleDefault.default), {
            padded: true
        }, "Terms & Conditions")), (0, _react.jsx)((0, _horizontalSeparatorDefault.default), null), (0, _react.jsx)("div", {
            className: "text one row"
        }, `We've updated our terms & conditions of use`), (0, _react.jsx)("div", {
            className: "text row"
        }, `In order to continue using the Voicify platform we require you to take a moment and review some changes we've made to our terms and conditions.`), (0, _react.jsx)("div", {
            className: `text row`
        }, `Please read them and accept by clicking the button below`), (0, _react.jsx)("a", {
            target: "_blank",
            href: props.userContainer.state.currentUserTermsAgreement.latestTerm.url,
            className: `link row`
        }, (0, _react.jsx)("span", {
            className: "titleText"
        }, `Terms & Conditions`), (0, _react.jsx)("img", {
            src: expandIcon
        })), (0, _react.jsx)((0, _footerBarDefault.default), null, (0, _react.jsx)((0, _buttonDefault.default), {
            onClick: this.acceptTerms.bind(this),
            className: `left`,
            loading: props.userContainer.state.isLoading,
            disabled: props.userContainer.state.isLoading,
            themes: [
                "primary"
            ],
            text: "Accept & Close",
            type: "button"
        }), (0, _react.jsx)((0, _buttonDefault.default), {
            onClick: this.openTermsInNewTab.bind(this),
            disabled: props.userContainer.state.isLoading,
            themes: [
                "white",
                "end"
            ],
            text: "Learn More",
            type: "button"
        })))))), (0, _react.jsx)("div", {
            className: layoutStyle
        }));
    }
}
const containerStyle = /*#__PURE__*/ (0, _css.css)(".text{color:", (0, _colors.color_shades_darkest), " font:Muli;font-family:Muli;font-size:14px;font-weight:normal;font-style:normal;font-stretch:normal;letter-spacing:normal;&.one{font-size:18px;padding-top:48px;}}.link{display:flex;flex-direction:row;color:", (0, _colors.text_blue), " font-size:18px;font:Muli;padding-bottom:48px;.titleText{padding-top:4px;}}.row{padding-left:48px;padding-right:48px;padding-bottom:25px;img{padding-left:5px;}}.modal-title{margin-left:46px;}button.left{margin-left:46px;}", "");
const layoutStyle = /*#__PURE__*/ (0, _css.css)({
    name: "or9pf8",
    styles: "overflow-x:visible;background:rgba(44,61,82, 0.7);padding:65px 115px;z-index:101;position:fixed;width:100%;height:100%;top:0;left:0"
});
const innerLayoutStyle = /*#__PURE__*/ (0, _css.css)({
    name: "vnxwbq",
    styles: "border-radius:20px;border:12px solid rgba(44,61,82, 0.8);display:block;width:800px;height:450px;max-height:calc(100vh - 210px);position:fixed;z-index:102;left:50%;top:50%;transform:translate(-50%, -50%);background:white;overflow:hidden"
});
const innerWrapperStyle = /*#__PURE__*/ (0, _css.css)({
    name: "1d508z5",
    styles: "border-radius:20px;button:disabled{background:linear-gradient(258deg, #c9c9c9, #a8a8a8 63%, #929292);cursor:not-allowed;}"
});
exports.default = NewTermsModal;

},{"@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","../../scenes/fullScreenLayout":"5mVdG","./Button":"6ymxN","./ModalTitle":"hIp2B","../structure/PageContainer":"hc1r8","../structure/FooterBar":"bibRL","../structure/HorizontalSeparator":"Pw3HQ","../structure/HorizontalContainer":"eJPfh","../../constants/colors":"1p3OR","ef484e6b4d168744":"5ttMr","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"dPp6x":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _defineProperty = require("@babel/runtime/helpers/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _unstated = require("unstated");
var _api = require("../../api");
var _billingConfig = require("../../models/revenue/BillingConfig");
var _moment = require("moment");
var _momentDefault = parcelHelpers.interopDefault(_moment);
const STORAGE_KEY = "VOICIFY_REVENUE_CONFIG";
const ENGAGEMENT_PAGE_SIZE = 5000;
const REVENUE_DEBUG = false;
class RevenueContainer extends (0, _unstated.Container) {
    constructor(){
        super();
        (0, _definePropertyDefault.default)(this, "state", {
            revenueConfig: {
                version: 1,
                organizations: []
            },
            selectedMonth: (0, _momentDefault.default)().subtract(1, "month").startOf("month").toDate(),
            isLoadingEngagements: false,
            isLoadingApplications: false,
            isSavingConfig: false,
            configSaveError: null,
            engagementsByOrg: {},
            applicationsByOrg: {},
            revenueByOrg: [],
            projectedRevenueByOrg: [],
            expandedOrgs: [],
            loadingOrgIds: [],
            errors: []
        });
        // ===================== ENGAGEMENT CACHE =====================
        // Cache keyed by "YYYY-MM" -> { orgId -> engagements[] }
        // Lives outside of state to avoid unnecessary re-renders on cache writes.
        (0, _definePropertyDefault.default)(this, "engagementCache", {});
        // ===================== WEB WORKER =====================
        // Revenue calculation worker — offloads CPU-intensive work from the UI thread.
        // Falls back to main-thread calculation if the worker cannot be created.
        (0, _definePropertyDefault.default)(this, "revenueWorker", null);
        (0, _definePropertyDefault.default)(this, "workerResolve", null);
        try {
            this.revenueWorker = new Worker(require("7224b633d2c16880"));
            this.revenueWorker.onmessage = (event)=>{
                if (event.data?.type === "calculateAll" && this.workerResolve) {
                    this.workerResolve(event.data.revenueByOrg);
                    this.workerResolve = null;
                }
            };
            this.revenueWorker.onerror = ()=>{
                // Worker failed — resolve with null so fallback kicks in
                if (this.workerResolve) {
                    this.workerResolve(null);
                    this.workerResolve = null;
                }
            };
        } catch  {
            // Worker creation failed (e.g., unsupported environment)
            this.revenueWorker = null;
        }
    }
    /**
   * Post a calculation job to the Web Worker and return a promise
   * that resolves with the result, or null if the worker is unavailable.
   */ calculateViaWorker(orgConfigs, engagementsByOrg, applicationsByOrg) {
        if (!this.revenueWorker) return Promise.resolve(null);
        return new Promise((resolve)=>{
            this.workerResolve = resolve;
            // Send only the fields the worker needs (slim payloads)
            const slimEngagements = {};
            for (const orgId of Object.keys(engagementsByOrg))slimEngagements[orgId] = engagementsByOrg[orgId].map((e)=>({
                    applicationId: e.applicationId,
                    preTransferDurationMinutes: e.preTransferDurationMinutes,
                    postTransferDurationMinutes: e.postTransferDurationMinutes,
                    sessionSummaries: e.sessionSummaries,
                    isContained: e.isContained,
                    isContainable: e.isContainable,
                    sessionTags: e.sessionTags
                }));
            const slimApps = {};
            for (const orgId of Object.keys(applicationsByOrg))slimApps[orgId] = applicationsByOrg[orgId].map((a)=>({
                    id: a.id,
                    name: a.name,
                    isLive: a.isLive
                }));
            this.revenueWorker.postMessage({
                type: "calculateAll",
                orgConfigs,
                engagementsByOrg: slimEngagements,
                applicationsByOrg: slimApps
            });
            // Safety timeout — if worker doesn't respond in 30s, fall back
            setTimeout(()=>{
                if (this.workerResolve === resolve) {
                    this.workerResolve = null;
                    resolve(null);
                }
            }, 30000);
        });
    }
    getMonthKey(date) {
        return (0, _momentDefault.default)(date || this.state.selectedMonth).format("YYYY-MM");
    }
    getCachedEngagements(monthKey, orgId) {
        return this.engagementCache[monthKey]?.[orgId] ?? null;
    }
    setCachedEngagements(monthKey, orgId, engagements) {
        if (!this.engagementCache[monthKey]) this.engagementCache[monthKey] = {};
        this.engagementCache[monthKey][orgId] = engagements;
    }
    clearEngagementCache() {
        this.engagementCache = {};
    }
    // ===================== CONFIG PERSISTENCE =====================
    async loadConfig() {
        // Try the API first
        try {
            const result = await _api.getRevenueConfig();
            if (result.resultType === "Unauthorized") {
                window.location.href = "https://voicify.com";
                return null;
            }
            if (result.resultType === "Ok" && result.data) {
                const migratedConfig = this.migrateConfig(result.data);
                this.setState({
                    ...this.state,
                    revenueConfig: migratedConfig
                });
                // Keep localStorage in sync as a local cache
                this.saveConfigToLocalStorage(migratedConfig);
                return migratedConfig;
            }
        } catch (e) {
            console.warn("Failed to load revenue config from API, falling back to localStorage:", e);
        }
        // Fall back to localStorage
        try {
            const stored = localStorage.getItem(STORAGE_KEY);
            if (stored) {
                const config = JSON.parse(stored);
                const migratedConfig = this.migrateConfig(config);
                this.setState({
                    ...this.state,
                    revenueConfig: migratedConfig
                });
                if (JSON.stringify(config) !== JSON.stringify(migratedConfig)) this.saveConfigToLocalStorage(migratedConfig);
                return migratedConfig;
            }
        } catch (e) {
            console.error("Failed to load revenue config from localStorage:", e);
        }
        return this.state.revenueConfig;
    }
    migrateConfig(config) {
        return {
            ...config,
            organizations: config.organizations.map((org)=>({
                    ...org,
                    forceIncludeApplicationIds: org.forceIncludeApplicationIds || [],
                    contractType: org.contractType || undefined,
                    contractStatus: org.contractStatus || undefined,
                    totalPossibleLocations: org.totalPossibleLocations || undefined
                }))
        };
    }
    saveConfigToLocalStorage(config) {
        try {
            localStorage.setItem(STORAGE_KEY, JSON.stringify(config));
        } catch (e) {
            console.error("Failed to save revenue config to localStorage:", e);
        }
    }
    // Local save (localStorage only) — used internally after each mutation
    saveConfig(config) {
        const configToSave = config || this.state.revenueConfig;
        this.saveConfigToLocalStorage(configToSave);
    }
    // Explicit save to API — called from the Save button
    async saveConfigToApi(config) {
        const configToSave = config || this.state.revenueConfig;
        this.setState({
            ...this.state,
            isSavingConfig: true,
            configSaveError: null
        });
        try {
            const result = await _api.putRevenueConfig(configToSave);
            if (result.resultType === "Unauthorized") {
                window.location.href = "https://voicify.com";
                return false;
            }
            if (result.resultType === "Ok") {
                this.saveConfigToLocalStorage(configToSave);
                this.setState({
                    ...this.state,
                    isSavingConfig: false,
                    configSaveError: null
                });
                return true;
            }
            const errorMsg = result.errors?.join(", ") || "Failed to save configuration";
            this.setState({
                ...this.state,
                isSavingConfig: false,
                configSaveError: errorMsg
            });
            return false;
        } catch (e) {
            const errorMsg = e?.message || "Failed to save configuration";
            this.setState({
                ...this.state,
                isSavingConfig: false,
                configSaveError: errorMsg
            });
            return false;
        }
    }
    // ===================== ORGANIZATION MANAGEMENT =====================
    addOrganization(orgId, orgName) {
        const existing = this.state.revenueConfig.organizations.find((o)=>o.organizationId === orgId);
        if (existing) return;
        const newOrgConfig = {
            organizationId: orgId,
            organizationName: orgName || orgId,
            defaultConfig: {
                ...(0, _billingConfig.DEFAULT_BILLING_CONFIG)
            },
            applicationOverrides: [],
            ignoredApplicationIds: [],
            forceIncludeApplicationIds: []
        };
        const updatedConfig = {
            ...this.state.revenueConfig,
            organizations: [
                ...this.state.revenueConfig.organizations,
                newOrgConfig
            ]
        };
        this.setState({
            ...this.state,
            revenueConfig: updatedConfig
        });
        this.saveConfig(updatedConfig);
    }
    removeOrganization(orgId) {
        const updatedConfig = {
            ...this.state.revenueConfig,
            organizations: this.state.revenueConfig.organizations.filter((o)=>o.organizationId !== orgId)
        };
        const { [orgId]: _removedEng, ...remainingEngagements } = this.state.engagementsByOrg;
        const { [orgId]: _removedApps, ...remainingApps } = this.state.applicationsByOrg;
        this.setState({
            ...this.state,
            revenueConfig: updatedConfig,
            engagementsByOrg: remainingEngagements,
            applicationsByOrg: remainingApps,
            revenueByOrg: this.state.revenueByOrg.filter((r)=>r.organizationId !== orgId)
        });
        this.saveConfig(updatedConfig);
    }
    updateOrgContractType(orgId, contractType) {
        const updatedOrgs = this.state.revenueConfig.organizations.map((o)=>o.organizationId === orgId ? {
                ...o,
                contractType
            } : o);
        const updatedConfig = {
            ...this.state.revenueConfig,
            organizations: updatedOrgs
        };
        this.setState({
            ...this.state,
            revenueConfig: updatedConfig
        });
        this.saveConfig(updatedConfig);
    }
    updateOrgContractStatus(orgId, contractStatus) {
        const updatedOrgs = this.state.revenueConfig.organizations.map((o)=>o.organizationId === orgId ? {
                ...o,
                contractStatus
            } : o);
        const updatedConfig = {
            ...this.state.revenueConfig,
            organizations: updatedOrgs
        };
        this.setState({
            ...this.state,
            revenueConfig: updatedConfig
        });
        this.saveConfig(updatedConfig);
    }
    updateOrgTotalPossibleLocations(orgId, totalPossibleLocations) {
        const updatedOrgs = this.state.revenueConfig.organizations.map((o)=>o.organizationId === orgId ? {
                ...o,
                totalPossibleLocations
            } : o);
        const updatedConfig = {
            ...this.state.revenueConfig,
            organizations: updatedOrgs
        };
        this.setState({
            ...this.state,
            revenueConfig: updatedConfig
        });
        this.saveConfig(updatedConfig);
    }
    updateOrgAvgRevenuePerLocation(orgId, avgRevenuePerLocation) {
        const updatedOrgs = this.state.revenueConfig.organizations.map((o)=>o.organizationId === orgId ? {
                ...o,
                avgRevenuePerLocation
            } : o);
        const updatedConfig = {
            ...this.state.revenueConfig,
            organizations: updatedOrgs
        };
        this.setState({
            ...this.state,
            revenueConfig: updatedConfig
        });
        this.saveConfig(updatedConfig);
        this.calculateProjectedRevenue();
    }
    // ===================== BILLING CONFIG =====================
    updateOrgDefaultConfig(orgId, config) {
        const updatedOrgs = this.state.revenueConfig.organizations.map((o)=>o.organizationId === orgId ? {
                ...o,
                defaultConfig: {
                    ...config
                }
            } : o);
        const updatedConfig = {
            ...this.state.revenueConfig,
            organizations: updatedOrgs
        };
        this.setState({
            ...this.state,
            revenueConfig: updatedConfig
        });
        this.saveConfig(updatedConfig);
    }
    addApplicationOverride(orgId, appId, config) {
        const updatedOrgs = this.state.revenueConfig.organizations.map((o)=>{
            if (o.organizationId !== orgId) return o;
            const existingOverride = o.applicationOverrides.find((ao)=>ao.applicationId === appId);
            if (existingOverride) return {
                ...o,
                applicationOverrides: o.applicationOverrides.map((ao)=>ao.applicationId === appId ? {
                        ...ao,
                        config: {
                            ...config
                        }
                    } : ao)
            };
            return {
                ...o,
                applicationOverrides: [
                    ...o.applicationOverrides,
                    {
                        applicationId: appId,
                        config: {
                            ...config
                        }
                    }
                ]
            };
        });
        const updatedConfig = {
            ...this.state.revenueConfig,
            organizations: updatedOrgs
        };
        this.setState({
            ...this.state,
            revenueConfig: updatedConfig
        });
        this.saveConfig(updatedConfig);
    }
    removeApplicationOverride(orgId, appId) {
        const updatedOrgs = this.state.revenueConfig.organizations.map((o)=>{
            if (o.organizationId !== orgId) return o;
            return {
                ...o,
                applicationOverrides: o.applicationOverrides.filter((ao)=>ao.applicationId !== appId)
            };
        });
        const updatedConfig = {
            ...this.state.revenueConfig,
            organizations: updatedOrgs
        };
        this.setState({
            ...this.state,
            revenueConfig: updatedConfig
        });
        this.saveConfig(updatedConfig);
    }
    copyBillingConfig(config, targetOrgId, targetAppId) {
        if (targetAppId) this.addApplicationOverride(targetOrgId, targetAppId, config);
        else this.updateOrgDefaultConfig(targetOrgId, config);
    }
    // ===================== EXPORT/IMPORT =====================
    exportOrgConfig(orgId) {
        const org = this.state.revenueConfig.organizations.find((o)=>o.organizationId === orgId);
        if (!org) throw new Error(`Organization ${orgId} not found`);
        return JSON.stringify(org, null, 2);
    }
    exportAppConfig(orgId, appId) {
        const org = this.state.revenueConfig.organizations.find((o)=>o.organizationId === orgId);
        if (!org) throw new Error(`Organization ${orgId} not found`);
        const override = org.applicationOverrides.find((ao)=>ao.applicationId === appId);
        if (!override) throw new Error(`Application override for ${appId} not found`);
        return JSON.stringify(override, null, 2);
    }
    importOrgConfig(jsonString) {
        try {
            const orgConfig = JSON.parse(jsonString);
            // Validate structure
            if (!orgConfig.organizationId || !orgConfig.defaultConfig) return {
                success: false,
                error: "Invalid organization config format"
            };
            // Check if org already exists
            const existingIndex = this.state.revenueConfig.organizations.findIndex((o)=>o.organizationId === orgConfig.organizationId);
            let updatedOrgs;
            if (existingIndex >= 0) // Replace existing org config
            updatedOrgs = this.state.revenueConfig.organizations.map((o, idx)=>idx === existingIndex ? {
                    ...orgConfig
                } : o);
            else // Add new org config
            updatedOrgs = [
                ...this.state.revenueConfig.organizations,
                {
                    ...orgConfig
                }
            ];
            const updatedConfig = {
                ...this.state.revenueConfig,
                organizations: updatedOrgs
            };
            this.setState({
                ...this.state,
                revenueConfig: updatedConfig
            });
            this.saveConfig(updatedConfig);
            return {
                success: true
            };
        } catch (e) {
            return {
                success: false,
                error: `Failed to parse JSON: ${e.message}`
            };
        }
    }
    importAppConfig(orgId, jsonString) {
        try {
            const appOverride = JSON.parse(jsonString);
            // Validate structure
            if (!appOverride.applicationId || !appOverride.config) return {
                success: false,
                error: "Invalid application config format"
            };
            // Check if org exists
            const orgExists = this.state.revenueConfig.organizations.some((o)=>o.organizationId === orgId);
            if (!orgExists) return {
                success: false,
                error: `Organization ${orgId} not found`
            };
            this.addApplicationOverride(orgId, appOverride.applicationId, appOverride.config);
            return {
                success: true
            };
        } catch (e) {
            return {
                success: false,
                error: `Failed to parse JSON: ${e.message}`
            };
        }
    }
    // ===================== IGNORED APPLICATIONS =====================
    toggleIgnoreApplication(orgId, appId) {
        const updatedOrgs = this.state.revenueConfig.organizations.map((o)=>{
            if (o.organizationId !== orgId) return o;
            const isIgnored = o.ignoredApplicationIds.includes(appId);
            return {
                ...o,
                ignoredApplicationIds: isIgnored ? o.ignoredApplicationIds.filter((id)=>id !== appId) : [
                    ...o.ignoredApplicationIds,
                    appId
                ]
            };
        });
        const updatedConfig = {
            ...this.state.revenueConfig,
            organizations: updatedOrgs
        };
        this.setState({
            ...this.state,
            revenueConfig: updatedConfig
        });
        this.saveConfig(updatedConfig);
        // Recalculate revenue immediately to update totals
        this.calculateAllRevenue();
    }
    // ===================== FORCE INCLUDE APPLICATIONS =====================
    addForceIncludeApplication(orgId, appId) {
        const updatedOrgs = this.state.revenueConfig.organizations.map((o)=>{
            if (o.organizationId !== orgId) return o;
            if (o.forceIncludeApplicationIds.includes(appId)) return o;
            return {
                ...o,
                forceIncludeApplicationIds: [
                    ...o.forceIncludeApplicationIds,
                    appId
                ]
            };
        });
        const updatedConfig = {
            ...this.state.revenueConfig,
            organizations: updatedOrgs
        };
        this.setState({
            ...this.state,
            revenueConfig: updatedConfig
        });
        this.saveConfig(updatedConfig);
    }
    removeForceIncludeApplication(orgId, appId) {
        const updatedOrgs = this.state.revenueConfig.organizations.map((o)=>{
            if (o.organizationId !== orgId) return o;
            return {
                ...o,
                forceIncludeApplicationIds: o.forceIncludeApplicationIds.filter((id)=>id !== appId)
            };
        });
        const updatedConfig = {
            ...this.state.revenueConfig,
            organizations: updatedOrgs
        };
        this.setState({
            ...this.state,
            revenueConfig: updatedConfig
        });
        this.saveConfig(updatedConfig);
    }
    // ===================== UI STATE =====================
    toggleOrgExpanded(orgId) {
        const isExpanded = this.state.expandedOrgs.includes(orgId);
        this.setState({
            ...this.state,
            expandedOrgs: isExpanded ? this.state.expandedOrgs.filter((id)=>id !== orgId) : [
                ...this.state.expandedOrgs,
                orgId
            ]
        });
    }
    setSelectedMonth(month) {
        this.setState({
            ...this.state,
            selectedMonth: month
        });
    }
    // ===================== DATA LOADING =====================
    async loadApplicationsForOrg(orgId) {
        // First try to get all apps using the standard endpoint
        const result = await _api.getApplicationsForOrg(orgId);
        if (result.resultType === "Ok" && result.data) return result.data;
        // Fallback: try paginated search if the standard endpoint fails
        const allApps = [];
        let skip = 0;
        const take = 100;
        let hasMore = true;
        while(hasMore){
            const searchResult = await _api.searchForApplications(orgId, skip, take, "name", "");
            if (searchResult.resultType === "Ok" && searchResult.data?.applications) {
                const page = searchResult.data.applications;
                for(let i = 0; i < page.length; i++)allApps.push(page[i]);
                hasMore = page.length === take;
                skip += take;
            } else hasMore = false;
        }
        return allApps;
    }
    async loadEngagementsForOrg(orgId, startDate, endDate, orgName) {
        const allEngagements = [];
        let skip = 0;
        let hasMore = true;
        while(hasMore){
            const filter = {
                startDate,
                endDate,
                skip,
                take: ENGAGEMENT_PAGE_SIZE
            };
            const result = await _api.getOrganizationEngagements(orgId, filter);
            if (result.resultType === "Ok") {
                const page = result.data;
                if (REVENUE_DEBUG) console.log(`[Load Engagements] Org ${orgId}, skip ${skip}: received ${page?.length || 0} engagements`);
                // Use push loop instead of spread to avoid O(n²) copying
                for(let i = 0; i < page.length; i++)allEngagements.push(page[i]);
                if (page.length < ENGAGEMENT_PAGE_SIZE) hasMore = false;
                else skip += ENGAGEMENT_PAGE_SIZE;
            } else {
                const orgDisplay = orgName ? `${orgName} (${orgId})` : orgId;
                this.setState((prevState)=>({
                        ...prevState,
                        errors: [
                            ...prevState.errors,
                            `Failed to load engagements for org ${orgDisplay}: ${result.errors?.[0] || "Unknown error"}`
                        ]
                    }));
                hasMore = false;
            }
        }
        return allEngagements;
    }
    async loadAllData(forceReload = false) {
        const orgs = this.state.revenueConfig.organizations;
        if (orgs.length === 0) return;
        const monthKey = this.getMonthKey();
        const startDate = (0, _momentDefault.default)(this.state.selectedMonth).startOf("month").format("YYYY-MM-DDTHH:mm:ss.SSSZ");
        const endDate = (0, _momentDefault.default)(this.state.selectedMonth).endOf("month").format("YYYY-MM-DDTHH:mm:ss.SSSZ");
        if (REVENUE_DEBUG) console.log(`[Load Data] Date range: ${startDate} to ${endDate}`);
        // Determine which orgs need fetching vs which have cached data
        const orgsToFetch = [];
        const cachedEngagementsByOrg = {};
        if (forceReload) {
            // Clear cache for this month if force reloading
            if (this.engagementCache[monthKey]) delete this.engagementCache[monthKey];
            orgsToFetch.push(...orgs);
        } else for (const org of orgs){
            const cached = this.getCachedEngagements(monthKey, org.organizationId);
            if (cached) cachedEngagementsByOrg[org.organizationId] = cached;
            else orgsToFetch.push(org);
        }
        this.setState((prevState)=>({
                ...prevState,
                isLoadingEngagements: true,
                isLoadingApplications: true,
                errors: [],
                loadingOrgIds: orgsToFetch.map((o)=>o.organizationId),
                // Immediately populate cached data so UI shows them
                engagementsByOrg: {
                    ...prevState.engagementsByOrg,
                    ...cachedEngagementsByOrg
                }
            }));
        const newEngagementsByOrg = {
            ...cachedEngagementsByOrg
        };
        const newApplicationsByOrg = {};
        // Load applications and engagements concurrently using a shared
        // concurrency-limited queue. Each slot picks up the next org as soon
        // as it finishes, so no slot sits idle.
        const CONCURRENCY = 5;
        // --- Applications queue (all orgs, lightweight) ---
        let appNextIndex = 0;
        const processApps = async ()=>{
            while(appNextIndex < orgs.length){
                const idx = appNextIndex++;
                const org = orgs[idx];
                const apps = await this.loadApplicationsForOrg(org.organizationId);
                newApplicationsByOrg[org.organizationId] = apps;
                this.setState((prevState)=>({
                        ...prevState,
                        applicationsByOrg: {
                            ...prevState.applicationsByOrg,
                            [org.organizationId]: apps
                        }
                    }));
            }
        };
        const appWorkers = [];
        for(let w = 0; w < Math.min(CONCURRENCY, orgs.length); w++)appWorkers.push(processApps());
        // --- Engagements queue (only uncached orgs) ---
        let engNextIndex = 0;
        const processEngagements = async ()=>{
            while(engNextIndex < orgsToFetch.length){
                const idx = engNextIndex++;
                const org = orgsToFetch[idx];
                const engagements = await this.loadEngagementsForOrg(org.organizationId, startDate, endDate, org.organizationName);
                // Store result and cache it
                newEngagementsByOrg[org.organizationId] = engagements;
                this.setCachedEngagements(monthKey, org.organizationId, engagements);
                if (REVENUE_DEBUG) console.log(`[Load Data] Loaded ${org.organizationId}: ${engagements.length} engagements`);
                // Update state immediately so user sees progress per-org
                this.setState((prevState)=>({
                        ...prevState,
                        engagementsByOrg: {
                            ...prevState.engagementsByOrg,
                            [org.organizationId]: engagements
                        },
                        loadingOrgIds: prevState.loadingOrgIds.filter((id)=>id !== org.organizationId)
                    }));
                // Progressive revenue calculation for this org immediately
                this.calculateRevenueForOrgs([
                    org.organizationId
                ], newEngagementsByOrg, newApplicationsByOrg);
            }
        };
        const engWorkers = [];
        if (orgsToFetch.length > 0) for(let w = 0; w < Math.min(CONCURRENCY, orgsToFetch.length); w++)engWorkers.push(processEngagements());
        // Wait for both queues to finish
        await Promise.all([
            ...appWorkers,
            ...engWorkers
        ]);
        // Calculate revenue for all orgs now that both apps and engagements are fully loaded.
        // Cached orgs were never calculated mid-flight; fetched orgs were calculated progressively
        // but may have had incomplete app metadata at that point — recalculate both.
        const allLoadedOrgIds = Array.from(new Set([
            ...Object.keys(cachedEngagementsByOrg),
            ...Object.keys(newEngagementsByOrg)
        ]));
        if (allLoadedOrgIds.length > 0) this.calculateRevenueForOrgs(allLoadedOrgIds, newEngagementsByOrg, newApplicationsByOrg);
        if (REVENUE_DEBUG) console.log(`[Load Data] Final newEngagementsByOrg:`, Object.keys(newEngagementsByOrg).map((k)=>`${k}: ${newEngagementsByOrg[k].length} engagements`));
        this.setState((prevState)=>({
                ...prevState,
                isLoadingEngagements: false,
                isLoadingApplications: false,
                engagementsByOrg: {
                    ...prevState.engagementsByOrg,
                    ...newEngagementsByOrg
                },
                applicationsByOrg: {
                    ...prevState.applicationsByOrg,
                    ...newApplicationsByOrg
                },
                loadingOrgIds: []
            }));
    }
    async loadDataForSingleOrg(orgId, forceReload = false) {
        const monthKey = this.getMonthKey();
        const startDate = (0, _momentDefault.default)(this.state.selectedMonth).startOf("month").format("YYYY-MM-DDTHH:mm:ss.SSSZ");
        const endDate = (0, _momentDefault.default)(this.state.selectedMonth).endOf("month").format("YYYY-MM-DDTHH:mm:ss.SSSZ");
        // Check cache first (unless force reloading)
        const cached = !forceReload ? this.getCachedEngagements(monthKey, orgId) : null;
        this.setState((prevState)=>({
                ...prevState,
                loadingOrgIds: [
                    ...prevState.loadingOrgIds,
                    orgId
                ],
                isLoadingEngagements: true
            }));
        // Always reload apps (lightweight), only reload engagements if not cached
        const orgConfig = this.state.revenueConfig.organizations.find((o)=>o.organizationId === orgId);
        const [apps, engagements] = await Promise.all([
            this.loadApplicationsForOrg(orgId),
            cached ? Promise.resolve(cached) : this.loadEngagementsForOrg(orgId, startDate, endDate, orgConfig?.organizationName)
        ]);
        // Cache the engagements if freshly fetched
        if (!cached) this.setCachedEngagements(monthKey, orgId, engagements);
        const newEngagementsByOrg = {
            ...this.state.engagementsByOrg,
            [orgId]: engagements
        };
        const newApplicationsByOrg = {
            ...this.state.applicationsByOrg,
            [orgId]: apps
        };
        this.setState((prevState)=>({
                ...prevState,
                isLoadingEngagements: false,
                engagementsByOrg: {
                    ...prevState.engagementsByOrg,
                    [orgId]: engagements
                },
                applicationsByOrg: {
                    ...prevState.applicationsByOrg,
                    [orgId]: apps
                },
                loadingOrgIds: prevState.loadingOrgIds.filter((id)=>id !== orgId)
            }));
        this.calculateAllRevenue(newEngagementsByOrg, newApplicationsByOrg);
    }
    // ===================== REVENUE CALCULATION =====================
    applyRounding(minutes, method) {
        if (!minutes || minutes <= 0) return 0;
        switch(method){
            case "up":
                return Math.ceil(minutes);
            case "down":
                return Math.floor(minutes);
            case "nearest":
                return Math.round(minutes);
            case "15sec":
                return Math.ceil(minutes * 4) / 4;
            case "30sec":
                return Math.ceil(minutes * 2) / 2;
            case "none":
                return minutes;
            default:
                return Math.ceil(minutes);
        }
    }
    getCallCount(sessionSummaries) {
        if (!sessionSummaries) return 1;
        // Fast path: count top-level keys by scanning for `":{` or `":` patterns
        // at brace depth 1, avoiding a full JSON.parse for each engagement.
        // The format is a JSON object like {"key1":{...},"key2":{...}}
        try {
            const str = sessionSummaries.trim();
            if (str.length < 2 || str[0] !== "{") return 1;
            let keyCount = 0;
            let depth = 0;
            let inString = false;
            let escape = false;
            for(let i = 0; i < str.length; i++){
                const ch = str[i];
                if (escape) {
                    escape = false;
                    continue;
                }
                if (ch === "\\" && inString) {
                    escape = true;
                    continue;
                }
                if (ch === '"') {
                    inString = !inString;
                    continue;
                }
                if (inString) continue;
                if (ch === "{") depth++;
                else if (ch === "}") depth--;
                else if (ch === ":" && depth === 1) keyCount++;
            }
            return keyCount > 0 ? keyCount : 1;
        } catch  {
            return 1;
        }
    }
    calculateApplicationRevenue(appId, appName, engagements, config) {
        const breakdown = {
            aiMinutes: {
                count: 0,
                revenue: 0
            },
            postTransferMinutes: {
                count: 0,
                revenue: 0
            },
            calls: {
                count: 0,
                revenue: 0
            },
            containedCalls: {
                count: 0,
                revenue: 0
            },
            nonContainableCalls: {
                count: 0,
                revenue: 0
            },
            ordersPlaced: {
                count: 0,
                revenue: 0
            },
            flatFee: config.flatMonthlyFee
        };
        for (const engagement of engagements){
            // AI minutes (preTransferDurationMinutes)
            const aiMin = this.applyRounding(engagement.preTransferDurationMinutes || 0, config.roundingMethod);
            breakdown.aiMinutes.count += aiMin;
            // Post transfer minutes (postTransferDurationMinutes)
            const ptMin = this.applyRounding(engagement.postTransferDurationMinutes || 0, config.roundingMethod);
            breakdown.postTransferMinutes.count += ptMin;
            // Calls
            const callCount = this.getCallCount(engagement.sessionSummaries);
            breakdown.calls.count += callCount;
            // Contained calls
            if (engagement.isContained) breakdown.containedCalls.count += 1;
            // Non-containable calls
            if (engagement.isContainable === false) breakdown.nonContainableCalls.count += 1;
            // Orders placed - check if ACTION_COMPLETED is in sessionTags array
            if (engagement.sessionTags?.includes("ACTION_COMPLETED")) breakdown.ordersPlaced.count += 1;
        }
        // Apply minutes included (across AI + post-transfer combined)
        const totalMinutes = breakdown.aiMinutes.count + breakdown.postTransferMinutes.count;
        const billableMinutes = Math.max(0, totalMinutes - config.minutesIncluded);
        if (totalMinutes > 0 && billableMinutes > 0) {
            const aiRatio = breakdown.aiMinutes.count / totalMinutes;
            const ptRatio = breakdown.postTransferMinutes.count / totalMinutes;
            breakdown.aiMinutes.revenue = billableMinutes * aiRatio * config.aiMinuteRate;
            breakdown.postTransferMinutes.revenue = billableMinutes * ptRatio * config.postTransferMinuteRate;
        }
        // Apply calls included
        const billableCalls = Math.max(0, breakdown.calls.count - config.callsIncluded);
        breakdown.calls.revenue = billableCalls * config.callRate;
        // Contained and non-containable are not subject to "included" amounts
        breakdown.containedCalls.revenue = breakdown.containedCalls.count * config.containedCallRate;
        breakdown.nonContainableCalls.revenue = breakdown.nonContainableCalls.count * config.nonContainableCallRate;
        breakdown.ordersPlaced.revenue = breakdown.ordersPlaced.count * config.orderPlacedRate;
        const totalRevenue = breakdown.aiMinutes.revenue + breakdown.postTransferMinutes.revenue + breakdown.calls.revenue + breakdown.containedCalls.revenue + breakdown.nonContainableCalls.revenue + breakdown.ordersPlaced.revenue + breakdown.flatFee;
        return {
            applicationId: appId,
            applicationName: appName,
            totalRevenue,
            breakdown,
            engagementCount: engagements.length
        };
    }
    /**
   * Calculate revenue for a specific subset of org IDs and merge results
   * into the existing revenueByOrg state. Used for progressive calculation
   * as data batches arrive, so the UI updates incrementally.
   */ calculateRevenueForOrgs(orgIds, engagementsByOrgData, applicationsByOrgData) {
        const newOrgRevenues = [];
        for (const orgId of orgIds){
            const orgConfig = this.state.revenueConfig.organizations.find((o)=>o.organizationId === orgId);
            if (!orgConfig) continue;
            const engagements = engagementsByOrgData[orgId] || [];
            const apps = applicationsByOrgData[orgId] || [];
            if (REVENUE_DEBUG) console.log(`[Progressive Calc] Org ${orgId}: ${engagements.length} engagements, ${apps.length} apps`);
            // Group engagements by applicationId
            const engagementsByApp = {};
            for (const eng of engagements){
                const appId = eng.applicationId;
                if (!appId) continue;
                if (!engagementsByApp[appId]) engagementsByApp[appId] = [];
                engagementsByApp[appId].push(eng);
            }
            const applicationRevenues = [];
            // Get all unique application IDs
            const allAppIds = new Set([
                ...Object.keys(engagementsByApp),
                ...apps.map((a)=>a.id).filter(Boolean),
                ...orgConfig.forceIncludeApplicationIds ?? []
            ]);
            for (const appId of allAppIds){
                if (orgConfig.ignoredApplicationIds.includes(appId)) continue;
                const appEngagements = engagementsByApp[appId] || [];
                const isForceIncluded = (orgConfig.forceIncludeApplicationIds ?? []).includes(appId);
                if (appEngagements.length === 0 && !isForceIncluded) continue;
                const appModel = apps.find((a)=>a.id === appId);
                // Skip non-live apps unless explicitly force-included
                if (appModel && appModel.isLive === false && !isForceIncluded) continue;
                const appName = appModel?.name || appId;
                const override = orgConfig.applicationOverrides.find((ao)=>ao.applicationId === appId);
                const config = override ? override.config : orgConfig.defaultConfig;
                const appRevenue = this.calculateApplicationRevenue(appId, appName, appEngagements, config);
                applicationRevenues.push(appRevenue);
            }
            applicationRevenues.sort((a, b)=>a.applicationName.toLowerCase().localeCompare(b.applicationName.toLowerCase()));
            const orgTotal = applicationRevenues.reduce((sum, ar)=>sum + ar.totalRevenue, 0);
            newOrgRevenues.push({
                organizationId: orgId,
                organizationName: orgConfig.organizationName || orgId,
                totalRevenue: orgTotal,
                applications: applicationRevenues
            });
        }
        // Merge: replace existing entries for these orgIds, keep others
        const orgIdSet = new Set(orgIds);
        this.setState((prevState)=>({
                ...prevState,
                revenueByOrg: [
                    ...prevState.revenueByOrg.filter((r)=>!orgIdSet.has(r.organizationId)),
                    ...newOrgRevenues
                ]
            }));
    }
    calculateAllRevenue(engagementsByOrgOverride, applicationsByOrgOverride) {
        const engagementsByOrgData = engagementsByOrgOverride || this.state.engagementsByOrg;
        const applicationsByOrgData = applicationsByOrgOverride || this.state.applicationsByOrg;
        // Try the Web Worker first for large datasets (off main thread)
        const totalEngagements = Object.values(engagementsByOrgData).reduce((sum, arr)=>sum + arr.length, 0);
        if (this.revenueWorker && totalEngagements > 5000) {
            if (REVENUE_DEBUG) console.log(`[Revenue Calc] Offloading ${totalEngagements} engagements to Web Worker`);
            this.calculateViaWorker(this.state.revenueConfig.organizations, engagementsByOrgData, applicationsByOrgData).then((workerResult)=>{
                if (workerResult) this.setState({
                    ...this.state,
                    revenueByOrg: workerResult,
                    isLoadingEngagements: false,
                    isLoadingApplications: false,
                    loadingOrgIds: []
                });
                else {
                    // Worker failed — fall back to main thread
                    if (REVENUE_DEBUG) console.log(`[Revenue Calc] Worker failed, falling back to main thread`);
                    this.calculateAllRevenueMainThread(engagementsByOrgData, applicationsByOrgData);
                }
            });
            return;
        }
        // Small dataset or no worker — calculate on main thread directly
        this.calculateAllRevenueMainThread(engagementsByOrgData, applicationsByOrgData);
    }
    /**
   * Main-thread revenue calculation — used as fallback when the Web Worker
   * is unavailable, or for small datasets where the overhead isn't worth it.
   */ calculateAllRevenueMainThread(engagementsByOrgData, applicationsByOrgData) {
        const revenueByOrg = [];
        for (const orgConfig of this.state.revenueConfig.organizations){
            const orgId = orgConfig.organizationId;
            const engagements = engagementsByOrgData[orgId] || [];
            const apps = applicationsByOrgData[orgId] || [];
            if (REVENUE_DEBUG) console.log(`[Revenue Calc] Org ${orgId}: ${engagements.length} engagements, ${apps.length} apps`);
            // Group engagements by applicationId
            const engagementsByApp = {};
            let skippedCount = 0;
            for (const eng of engagements){
                const appId = eng.applicationId;
                if (!appId) {
                    skippedCount++;
                    continue; // Skip engagements without applicationId
                }
                if (!engagementsByApp[appId]) engagementsByApp[appId] = [];
                engagementsByApp[appId].push(eng);
            }
            if (REVENUE_DEBUG && skippedCount > 0) console.log(`[Revenue Calc] Skipped ${skippedCount} engagements without applicationId`);
            if (REVENUE_DEBUG) console.log(`[Revenue Calc] Grouped into ${Object.keys(engagementsByApp).length} apps with engagements`);
            const applicationRevenues = [];
            // Get all unique application IDs from engagements and force-include list
            const allAppIds = new Set([
                ...Object.keys(engagementsByApp),
                ...apps.map((a)=>a.id).filter(Boolean),
                ...orgConfig.forceIncludeApplicationIds ?? []
            ]);
            if (REVENUE_DEBUG) console.log(`[Revenue Calc] Processing ${allAppIds.size} unique app IDs`);
            for (const appId of allAppIds){
                // Skip ignored applications
                if (orgConfig.ignoredApplicationIds.includes(appId)) continue;
                const appEngagements = engagementsByApp[appId] || [];
                const isForceIncluded = (orgConfig.forceIncludeApplicationIds ?? []).includes(appId);
                // Skip apps with 0 engagements unless they're force-included
                if (appEngagements.length === 0 && !isForceIncluded) continue;
                // Find application name
                const appModel = apps.find((a)=>a.id === appId);
                // Skip non-live apps unless explicitly force-included
                if (appModel && appModel.isLive === false && !isForceIncluded) continue;
                const appName = appModel?.name || appId;
                // Determine config: app override or org default
                const override = orgConfig.applicationOverrides.find((ao)=>ao.applicationId === appId);
                const config = override ? override.config : orgConfig.defaultConfig;
                const appRevenue = this.calculateApplicationRevenue(appId, appName, appEngagements, config);
                if (REVENUE_DEBUG) console.log(`[Revenue Calc] App ${appName}: ${appEngagements.length} engagements, $${appRevenue.totalRevenue.toFixed(2)} revenue${isForceIncluded ? " (force-included)" : ""}`);
                applicationRevenues.push(appRevenue);
            }
            // Sort by application name alphabetically
            applicationRevenues.sort((a, b)=>a.applicationName.toLowerCase().localeCompare(b.applicationName.toLowerCase()));
            const orgTotal = applicationRevenues.reduce((sum, ar)=>sum + ar.totalRevenue, 0);
            if (REVENUE_DEBUG) console.log(`[Revenue Calc] Org ${orgId} total: ${applicationRevenues.length} apps, $${orgTotal.toFixed(2)} revenue`);
            revenueByOrg.push({
                organizationId: orgId,
                organizationName: orgConfig.organizationName || orgId,
                totalRevenue: orgTotal,
                applications: applicationRevenues
            });
        }
        this.setState({
            ...this.state,
            revenueByOrg,
            isLoadingEngagements: false,
            isLoadingApplications: false,
            loadingOrgIds: []
        });
    }
    // ===================== PROJECTIONS =====================
    getCurrentLocationCount(orgId) {
        // Use tracked apps from revenue data (apps that appear in revenueByOrg)
        const orgRevenue = this.state.revenueByOrg.find((r)=>r.organizationId === orgId);
        if (orgRevenue && orgRevenue.applications.length > 0) return orgRevenue.applications.length;
        // Fallback: filter apps by non-ignored
        const orgConfig = this.state.revenueConfig.organizations.find((o)=>o.organizationId === orgId);
        const apps = this.state.applicationsByOrg[orgId] || [];
        if (orgConfig && apps.length > 0) return apps.filter((a)=>!orgConfig.ignoredApplicationIds.includes(a.id)).length;
        return 0;
    }
    getAverageRevenuePerLocation(orgId) {
        // Prefer the manually configured override if set
        const orgConfig = this.state.revenueConfig.organizations.find((o)=>o.organizationId === orgId);
        if (orgConfig?.avgRevenuePerLocation != null && orgConfig.avgRevenuePerLocation > 0) return orgConfig.avgRevenuePerLocation;
        // Fall back to computing from actual loaded revenue data
        const orgRevenue = this.state.revenueByOrg.find((r)=>r.organizationId === orgId);
        if (!orgRevenue || orgRevenue.applications.length === 0) return 0;
        return orgRevenue.totalRevenue / orgRevenue.applications.length;
    }
    getOrganizationProjection(orgId) {
        return this.state.revenueConfig.projections?.organizationProjections.find((op)=>op.organizationId === orgId);
    }
    /**
   * Initialize projections for multiple orgs in a single setState call.
   * Only initializes orgs that don't already have projections.
   * Calls calculateProjectedRevenue once after state settles.
   */ initializeAllMissingProjections(orgIds, monthCount = 12) {
        const startMonth = (0, _momentDefault.default)().add(1, "month").startOf("month");
        let projections = this.state.revenueConfig.projections || {
            version: 1,
            organizationProjections: []
        };
        let updatedOrgProjections = [
            ...projections.organizationProjections
        ];
        let changed = false;
        for (const orgId of orgIds){
            const existing = updatedOrgProjections.find((op)=>op.organizationId === orgId);
            if (existing && existing.monthlyProjections.length > 0) continue;
            const currentLocationCount = this.getCurrentLocationCount(orgId);
            const monthlyProjections = [];
            for(let i = 0; i < monthCount; i++)monthlyProjections.push({
                month: (0, _momentDefault.default)(startMonth).add(i, "months").format("YYYY-MM"),
                locationCount: currentLocationCount
            });
            // Remove any existing (empty) entry, then add new
            updatedOrgProjections = updatedOrgProjections.filter((op)=>op.organizationId !== orgId);
            updatedOrgProjections.push({
                organizationId: orgId,
                monthlyProjections
            });
            changed = true;
        }
        if (!changed) {
            // Nothing to initialize, just calculate
            this.calculateProjectedRevenue();
            return;
        }
        const updatedConfig = {
            ...this.state.revenueConfig,
            projections: {
                ...projections,
                organizationProjections: updatedOrgProjections
            }
        };
        this.setState({
            ...this.state,
            revenueConfig: updatedConfig
        }).then(()=>{
            this.calculateProjectedRevenue();
        });
        this.saveConfig(updatedConfig);
    }
    initializeDefaultProjections(orgId, monthCount = 12) {
        const currentLocationCount = this.getCurrentLocationCount(orgId);
        const startMonth = (0, _momentDefault.default)().add(1, "month").startOf("month");
        const monthlyProjections = [];
        for(let i = 0; i < monthCount; i++)monthlyProjections.push({
            month: (0, _momentDefault.default)(startMonth).add(i, "months").format("YYYY-MM"),
            locationCount: currentLocationCount
        });
        const projections = this.state.revenueConfig.projections || {
            version: 1,
            organizationProjections: []
        };
        // Remove any existing projection for this org, then add new
        const updatedOrgProjections = projections.organizationProjections.filter((op)=>op.organizationId !== orgId);
        updatedOrgProjections.push({
            organizationId: orgId,
            monthlyProjections
        });
        const updatedConfig = {
            ...this.state.revenueConfig,
            projections: {
                ...projections,
                organizationProjections: updatedOrgProjections
            }
        };
        this.setState({
            ...this.state,
            revenueConfig: updatedConfig
        }).then(()=>{
            this.calculateProjectedRevenue();
        });
        this.saveConfig(updatedConfig);
    }
    updateProjection(orgId, month, locationCount) {
        const projections = this.state.revenueConfig.projections || {
            version: 1,
            organizationProjections: []
        };
        const orgProjectionIndex = projections.organizationProjections.findIndex((op)=>op.organizationId === orgId);
        let updatedOrgProjections = [
            ...projections.organizationProjections
        ];
        if (orgProjectionIndex >= 0) {
            const orgProjection = updatedOrgProjections[orgProjectionIndex];
            const monthIndex = orgProjection.monthlyProjections.findIndex((mp)=>mp.month === month);
            let updatedMonthly = [
                ...orgProjection.monthlyProjections
            ];
            if (monthIndex >= 0) updatedMonthly[monthIndex] = {
                month,
                locationCount: Math.floor(locationCount)
            };
            else {
                updatedMonthly.push({
                    month,
                    locationCount: Math.floor(locationCount)
                });
                // Sort by month
                updatedMonthly.sort((a, b)=>a.month.localeCompare(b.month));
            }
            updatedOrgProjections[orgProjectionIndex] = {
                ...orgProjection,
                monthlyProjections: updatedMonthly
            };
        } else updatedOrgProjections.push({
            organizationId: orgId,
            monthlyProjections: [
                {
                    month,
                    locationCount: Math.floor(locationCount)
                }
            ]
        });
        const updatedConfig = {
            ...this.state.revenueConfig,
            projections: {
                ...projections,
                organizationProjections: updatedOrgProjections
            }
        };
        this.setState({
            ...this.state,
            revenueConfig: updatedConfig
        }).then(()=>{
            this.calculateProjectedRevenue();
        });
        this.saveConfig(updatedConfig);
    }
    addProjectionMonth(orgId) {
        const orgProjection = this.getOrganizationProjection(orgId);
        const currentLocationCount = this.getCurrentLocationCount(orgId);
        let nextMonth;
        if (orgProjection && orgProjection.monthlyProjections.length > 0) {
            const lastMonth = orgProjection.monthlyProjections[orgProjection.monthlyProjections.length - 1].month;
            nextMonth = (0, _momentDefault.default)(lastMonth, "YYYY-MM").add(1, "month").format("YYYY-MM");
        } else nextMonth = (0, _momentDefault.default)().add(1, "month").startOf("month").format("YYYY-MM");
        // updateProjection already chains calculateProjectedRevenue
        this.updateProjection(orgId, nextMonth, currentLocationCount);
    }
    removeProjectionMonth(orgId, month) {
        const projections = this.state.revenueConfig.projections;
        if (!projections) return;
        const updatedOrgProjections = projections.organizationProjections.map((op)=>{
            if (op.organizationId !== orgId) return op;
            return {
                ...op,
                monthlyProjections: op.monthlyProjections.filter((mp)=>mp.month !== month)
            };
        });
        const updatedConfig = {
            ...this.state.revenueConfig,
            projections: {
                ...projections,
                organizationProjections: updatedOrgProjections
            }
        };
        this.setState({
            ...this.state,
            revenueConfig: updatedConfig
        }).then(()=>{
            this.calculateProjectedRevenue();
        });
        this.saveConfig(updatedConfig);
    }
    clearProjections(orgId) {
        const projections = this.state.revenueConfig.projections;
        if (!projections) return;
        const updatedOrgProjections = projections.organizationProjections.filter((op)=>op.organizationId !== orgId);
        const updatedConfig = {
            ...this.state.revenueConfig,
            projections: {
                ...projections,
                organizationProjections: updatedOrgProjections
            }
        };
        this.setState({
            ...this.state,
            revenueConfig: updatedConfig
        }).then(()=>{
            this.calculateProjectedRevenue();
        });
        this.saveConfig(updatedConfig);
    }
    getAllProjectionMonths() {
        const projections = this.state.revenueConfig.projections;
        if (!projections) return [];
        const monthSet = new Set();
        for (const orgProjection of projections.organizationProjections)for (const mp of orgProjection.monthlyProjections)monthSet.add(mp.month);
        return Array.from(monthSet).sort();
    }
    calculateProjectedRevenue() {
        const projections = this.state.revenueConfig.projections;
        if (!projections) {
            this.setState({
                ...this.state,
                projectedRevenueByOrg: []
            });
            return;
        }
        const projectedRevenueByOrg = [];
        for (const orgConfig of this.state.revenueConfig.organizations){
            const orgId = orgConfig.organizationId;
            const orgProjection = projections.organizationProjections.find((op)=>op.organizationId === orgId);
            const currentLocationCount = this.getCurrentLocationCount(orgId);
            const averageRevenuePerLocation = this.getAverageRevenuePerLocation(orgId);
            const monthlyProjections = [];
            if (orgProjection) for (const mp of orgProjection.monthlyProjections)monthlyProjections.push({
                month: mp.month,
                locationCount: mp.locationCount,
                averageRevenuePerLocation,
                projectedRevenue: mp.locationCount * averageRevenuePerLocation
            });
            projectedRevenueByOrg.push({
                organizationId: orgId,
                organizationName: orgConfig.organizationName || orgId,
                currentLocationCount,
                averageRevenuePerLocation,
                monthlyProjections
            });
        }
        this.setState({
            ...this.state,
            projectedRevenueByOrg
        });
    }
}
exports.default = RevenueContainer;

},{"@babel/runtime/helpers/defineProperty":"9sJxO","unstated":"grh7p","../../api":"loxM6","../../models/revenue/BillingConfig":"9NytT","moment":"2meyw","7224b633d2c16880":"aGYW7","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9NytT":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CONTRACT_TYPES", ()=>CONTRACT_TYPES);
parcelHelpers.export(exports, "CONTRACT_TYPE_LABELS", ()=>CONTRACT_TYPE_LABELS);
parcelHelpers.export(exports, "CONTRACT_STATUSES", ()=>CONTRACT_STATUSES);
parcelHelpers.export(exports, "DEFAULT_BILLING_CONFIG", ()=>DEFAULT_BILLING_CONFIG);
parcelHelpers.export(exports, "BILLING_FIELD_DESCRIPTIONS", ()=>BILLING_FIELD_DESCRIPTIONS);
parcelHelpers.export(exports, "ROUNDING_METHOD_LABELS", ()=>ROUNDING_METHOD_LABELS);
const CONTRACT_TYPES = [
    "AI Ordering",
    "AI Answering",
    "Drive Thru",
    "Medical"
];
const CONTRACT_TYPE_LABELS = {
    "AI Ordering": "AI Ordering",
    "AI Answering": "AI Answering",
    "Drive Thru": "Drive Thru",
    "Medical": "Medical"
};
const CONTRACT_STATUSES = [
    "Won",
    "Prospect"
];
const DEFAULT_BILLING_CONFIG = {
    aiMinuteRate: 0,
    postTransferMinuteRate: 0,
    minutesIncluded: 0,
    callRate: 0,
    callsIncluded: 0,
    roundingMethod: "up",
    flatMonthlyFee: 0,
    containedCallRate: 0,
    nonContainableCallRate: 0,
    orderPlacedRate: 0
};
const BILLING_FIELD_DESCRIPTIONS = {
    aiMinuteRate: "Cost per AI minute. Calculated from preTransferDurationMinutes on each engagement - the time the AI spent handling the call before any transfer.",
    postTransferMinuteRate: "Cost per post-transfer minute. Calculated from postTransferDurationMinutes on each engagement - the time after a transfer occurred.",
    minutesIncluded: "Number of free minutes included per month before per-minute charges apply. Applies to the sum of AI minutes and post-transfer minutes.",
    callRate: "Cost per call. Call count is determined by the number of keys in the serialized sessionSummaries dictionary on each engagement.",
    callsIncluded: "Number of free calls included per month before per-call charges apply.",
    roundingMethod: "How to round minute durations. Options: Round Up (ceil to nearest minute), Round Down (floor), Round to Nearest, 15-second increments, 30-second increments, No Rounding (sum raw seconds, convert to minutes).",
    flatMonthlyFee: "Fixed monthly charge regardless of usage volume.",
    containedCallRate: "Cost per contained call. A call is contained when isContained = true on the engagement.",
    nonContainableCallRate: "Cost per non-containable call. A call is non-containable when isContainable = false on the engagement.",
    orderPlacedRate: "Cost per order placed. Counted when an engagement's sessionCategory = 'ACTION_COMPLETED'."
};
const ROUNDING_METHOD_LABELS = {
    "up": "Round Up (nearest minute)",
    "down": "Round Down (nearest minute)",
    "nearest": "Round to Nearest Minute",
    "15sec": "Round to 15-second increments",
    "30sec": "Round to 30-second increments",
    "none": "No Rounding (sum raw seconds)"
}; // ==================== PROJECTIONS ====================

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"aGYW7":[function(require,module,exports) {
let workerURL = require("eedd4c3ef4e4b82a");
let bundleURL = require("efb0cb3dceb0a65b");
let url = bundleURL.getBundleURL("kVLro") + require("1cf0dd4cc8c626f1").resolve("6Tr1s");
module.exports = workerURL(url, bundleURL.getOrigin(url), false);

},{"eedd4c3ef4e4b82a":"3OKNS","efb0cb3dceb0a65b":"c7Tr5","1cf0dd4cc8c626f1":"fyJL2"}],"3OKNS":[function(require,module,exports) {
"use strict";
module.exports = function(workerUrl, origin, isESM) {
    if (origin === self.location.origin) // If the worker bundle's url is on the same origin as the document,
    // use the worker bundle's own url.
    return workerUrl;
    else {
        // Otherwise, create a blob URL which loads the worker bundle with `importScripts`.
        var source = isESM ? "import " + JSON.stringify(workerUrl) + ";" : "importScripts(" + JSON.stringify(workerUrl) + ");";
        return URL.createObjectURL(new Blob([
            source
        ], {
            type: "application/javascript"
        }));
    }
};

},{}],"dISN2":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _base = require("@emotion/styled/base");
var _baseDefault = parcelHelpers.interopDefault(_base);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _reactRouterDom = require("react-router-dom");
var _reactTabs = require("react-tabs");
var _panelHeaderContainer = require("../../components/structure/Panels/PanelHeaderContainer");
var _panelHeaderContainerDefault = parcelHelpers.interopDefault(_panelHeaderContainer);
var _panelIconTab = require("../../components/structure/Panels/PanelIconTab");
var _panelIconTabDefault = parcelHelpers.interopDefault(_panelIconTab);
var _monthSelector = require("./components/MonthSelector");
var _monthSelectorDefault = parcelHelpers.interopDefault(_monthSelector);
var _organizationSelector = require("./components/OrganizationSelector");
var _organizationSelectorDefault = parcelHelpers.interopDefault(_organizationSelector);
var _organizationSection = require("./components/OrganizationSection");
var _organizationSectionDefault = parcelHelpers.interopDefault(_organizationSection);
var _projectionsTab = require("./components/ProjectionsTab");
var _projectionsTabDefault = parcelHelpers.interopDefault(_projectionsTab);
var _billingConfig = require("../../models/revenue/BillingConfig");
var _colors = require("../../constants/colors");
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const revenueDark = require("b070817e075ebb3c");
const revenueBlue = require("56ddb5a98e4ad28b");
const projectionsDark = require("665c329921eb3352");
const projectionsBlue = require("12e057fdae9d9935");
const Revenue = ({ userContainer, organizationContainer, revenueContainer, authContainer })=>{
    // Auth guard: must be logged in with @voicify.com email
    const currentUser = userContainer.state.currentUser;
    if (currentUser && currentUser.email) {
        const emailLower = currentUser.email.toLowerCase();
        if (!emailLower.endsWith("@voicify.com")) return (0, _react.jsx)((0, _reactRouterDom.Redirect), {
            to: "/v"
        });
    }
    const history = (0, _reactRouterDom.useHistory)();
    const routeLocation = (0, _reactRouterDom.useLocation)();
    const selectedTabIndex = routeLocation.pathname.indexOf("projections") > -1 ? 1 : 0;
    const handleTabSelection = (index, last)=>{
        if (index === last) return;
        if (index === 0) history.push("/v/revenue" + window.location.search);
        if (index === 1) history.push("/v/revenue/projections" + window.location.search);
    };
    const tabs = [
        {
            title: "Revenue",
            icon: revenueDark,
            selectedIcon: revenueBlue
        },
        {
            title: "Projections",
            icon: projectionsDark,
            selectedIcon: projectionsBlue
        }
    ];
    const [showSettings, setShowSettings] = (0, _react1.useState)(false);
    const [clipboardConfig, setClipboardConfig] = (0, _react1.useState)(null);
    // Load config from API (with localStorage fallback) on mount, refresh token to avoid 401s
    (0, _react1.useEffect)(()=>{
        const init = async ()=>{
            // Ensure we have a fresh access token before any API calls
            await authContainer.refreshToken();
            revenueContainer.loadConfig();
            organizationContainer.getOrganizations();
        };
        init();
    }, []);
    const handleAddOrg = (0, _react1.useCallback)((orgId, orgName)=>{
        revenueContainer.addOrganization(orgId, orgName);
    }, [
        revenueContainer
    ]);
    const handleRemoveOrg = (0, _react1.useCallback)((orgId)=>{
        revenueContainer.removeOrganization(orgId);
    }, [
        revenueContainer
    ]);
    const handleMonthChange = (0, _react1.useCallback)((month)=>{
        revenueContainer.setSelectedMonth(month);
    }, [
        revenueContainer
    ]);
    const handleLoadData = (0, _react1.useCallback)(async ()=>{
        // Refresh token before loading data to avoid 401 errors
        await authContainer.refreshToken();
        revenueContainer.loadAllData();
    }, [
        revenueContainer,
        authContainer
    ]);
    const handleForceReload = (0, _react1.useCallback)(async ()=>{
        await authContainer.refreshToken();
        revenueContainer.loadAllData(true);
    }, [
        revenueContainer,
        authContainer
    ]);
    const handleRecalculate = (0, _react1.useCallback)(()=>{
        revenueContainer.calculateAllRevenue();
    }, [
        revenueContainer
    ]);
    const handleSaveConfig = (0, _react1.useCallback)(async ()=>{
        await revenueContainer.saveConfigToApi();
    }, [
        revenueContainer
    ]);
    const handleCopyConfig = (0, _react1.useCallback)((config)=>{
        setClipboardConfig({
            ...config
        });
    }, []);
    const handleExportCompleteConfig = (0, _react1.useCallback)(()=>{
        try {
            const jsonString = JSON.stringify(revenueContainer.state.revenueConfig, null, 2);
            const blob = new Blob([
                jsonString
            ], {
                type: "application/json"
            });
            const url = URL.createObjectURL(blob);
            const a = document.createElement("a");
            a.href = url;
            a.download = `revenue-config-complete.json`;
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
            URL.revokeObjectURL(url);
        } catch (e) {
            alert(`Failed to export config: ${e.message}`);
        }
    }, [
        revenueContainer
    ]);
    const handleImportCompleteConfig = (0, _react1.useCallback)(()=>{
        const input = document.createElement("input");
        input.type = "file";
        input.accept = ".json";
        input.onchange = (e)=>{
            const file = e.target?.files?.[0];
            if (!file) return;
            const reader = new FileReader();
            reader.onload = (event)=>{
                try {
                    const jsonString = event.target?.result;
                    const config = JSON.parse(jsonString);
                    // Validate structure
                    if (!config.version || !config.organizations || !Array.isArray(config.organizations)) {
                        alert("Invalid configuration file format");
                        return;
                    }
                    // Confirm before replacing
                    if (!confirm(`This will replace your current configuration with ${config.organizations.length} organizations. Continue?`)) return;
                    // Update state and save
                    revenueContainer.setState({
                        ...revenueContainer.state,
                        revenueConfig: config
                    });
                    revenueContainer.saveConfig(config);
                    alert("Configuration imported successfully!");
                } catch (e) {
                    alert(`Failed to import config: ${e.message}`);
                }
            };
            reader.readAsText(file);
        };
        input.click();
    }, [
        revenueContainer
    ]);
    const isLoading = revenueContainer.state.isLoadingEngagements || revenueContainer.state.isLoadingApplications;
    const loadingStatus = (()=>{
        if (!isLoading) return "";
        const totalOrgs = revenueContainer.state.revenueConfig.organizations.length;
        const loadingIds = revenueContainer.state.loadingOrgIds;
        const doneCount = totalOrgs - loadingIds.length;
        if (revenueContainer.state.isLoadingApplications && revenueContainer.state.isLoadingEngagements) return `Loading conversations... ${doneCount}/${totalOrgs} orgs`;
        if (revenueContainer.state.isLoadingApplications) return `Loading applications... (${totalOrgs} orgs)`;
        if (revenueContainer.state.isLoadingEngagements) return `Loading conversations... ${doneCount}/${totalOrgs} orgs`;
        return "Loading...";
    })();
    const orgConfigs = revenueContainer.state.revenueConfig.organizations;
    const selectedOrgIds = orgConfigs.map((o)=>o.organizationId);
    const selectedOrgNames = {};
    orgConfigs.forEach((o)=>{
        selectedOrgNames[o.organizationId] = o.organizationName || o.organizationId;
    });
    const totalRevenue = revenueContainer.state.revenueByOrg.reduce((sum, org)=>sum + org.totalRevenue, 0);
    return (0, _react.jsx)(Container, null, (0, _react.jsx)((0, _reactTabs.Tabs), {
        selectedIndex: selectedTabIndex,
        onSelect: handleTabSelection
    }, (0, _react.jsx)((0, _panelHeaderContainerDefault.default), null, (0, _react.jsx)((0, _reactTabs.TabList), {
        className: "panel-tab-list"
    }, tabs.map((tab, index)=>(0, _panelIconTabDefault.default)({
            tab: tab,
            index: index,
            selectedIndex: selectedTabIndex
        }))), (0, _react.jsx)(TabRowActions, null, revenueContainer.state.configSaveError && (0, _react.jsx)(SaveErrorText, null, revenueContainer.state.configSaveError), (0, _react.jsx)(SaveConfigButton, {
        onClick: handleSaveConfig,
        disabled: revenueContainer.state.isSavingConfig
    }, revenueContainer.state.isSavingConfig ? "Saving..." : "Save"))), (0, _react.jsx)((0, _reactTabs.TabPanel), null, (0, _react.jsx)(TabContent, null, (0, _react.jsx)(Header, null, (0, _react.jsx)(HeaderLeft, null, (0, _react.jsx)("h1", null, "Revenue Calculator"), revenueContainer.state.revenueByOrg.length > 0 && (0, _react.jsx)(TotalRevenueBadge, null, "Total: ", formatCurrency(totalRevenue))), (0, _react.jsx)(HeaderActions, null, (0, _react.jsx)(SettingsButton, {
        onClick: ()=>setShowSettings(!showSettings)
    }, showSettings ? "Hide Settings" : "Settings"))), showSettings && (0, _react.jsx)(SettingsPanel, null, (0, _react.jsx)(ConfigExportImportBar, null, (0, _react.jsx)(ConfigExportImportButton, {
        onClick: handleExportCompleteConfig,
        title: "Export entire configuration (all organizations) to JSON file"
    }, "Export Complete Config"), (0, _react.jsx)(ConfigExportImportButton, {
        onClick: handleImportCompleteConfig,
        title: "Import entire configuration from JSON file"
    }, "Import Complete Config")), (0, _react.jsx)((0, _organizationSelectorDefault.default), {
        organizationContainer: organizationContainer,
        selectedOrgIds: selectedOrgIds,
        selectedOrgNames: selectedOrgNames,
        onAddOrg: handleAddOrg,
        onRemoveOrg: handleRemoveOrg
    })), (0, _react.jsx)(ControlsBar, null, (0, _react.jsx)(ControlsLeft, null, (0, _react.jsx)((0, _monthSelectorDefault.default), {
        selectedMonth: revenueContainer.state.selectedMonth,
        onMonthChange: handleMonthChange,
        disabled: isLoading
    })), (0, _react.jsx)(ControlsRight, null, loadingStatus && (0, _react.jsx)(LoadingStatus, null, loadingStatus), clipboardConfig && (0, _react.jsx)(ClipboardBadge, null, "Config copied to clipboard"), (0, _react.jsx)(RecalcButton, {
        onClick: handleRecalculate,
        disabled: isLoading || orgConfigs.length === 0
    }, "Recalculate"), (0, _react.jsx)(LoadDataButton, {
        onClick: handleLoadData,
        disabled: isLoading || orgConfigs.length === 0
    }, isLoading ? "Loading..." : "Load Data"), (0, _react.jsx)(ForceReloadButton, {
        onClick: handleForceReload,
        disabled: isLoading || orgConfigs.length === 0,
        title: "Bypass cache and reload all engagement data from the API"
    }, "Force Reload"))), revenueContainer.state.errors.length > 0 && (0, _react.jsx)(ErrorsPanel, null, revenueContainer.state.errors.map((err, i)=>(0, _react.jsx)(ErrorLine, {
            key: i
        }, err))), orgConfigs.length === 0 ? (0, _react.jsx)(EmptyState, null, (0, _react.jsx)(EmptyTitle, null, "No organizations configured"), (0, _react.jsx)(EmptyDescription, null, 'Click "Settings" above to add organizations you want to track revenue for. Use the Save button to persist your configuration.')) : (0, _react.jsx)(OrgSections, null, renderGroupedOrgs(orgConfigs, revenueContainer, clipboardConfig, handleCopyConfig)))), (0, _react.jsx)((0, _reactTabs.TabPanel), null, (0, _react.jsx)(TabContent, null, (0, _react.jsx)((0, _projectionsTabDefault.default), {
        revenueContainer: revenueContainer
    })))));
};
const sortOrgsByName = (orgs)=>orgs.slice().sort((a, b)=>{
        const nameA = (a.organizationName || a.organizationId).toLowerCase();
        const nameB = (b.organizationName || b.organizationId).toLowerCase();
        return nameA.localeCompare(nameB);
    });
const groupOrgsByContractType = (orgs)=>{
    const groups = [];
    // Groups in contract type order, then uncategorized at the end
    for (const ct of (0, _billingConfig.CONTRACT_TYPES)){
        const matching = orgs.filter((o)=>o.contractType === ct);
        if (matching.length > 0) groups.push({
            contractType: ct,
            orgs: sortOrgsByName(matching)
        });
    }
    const uncategorized = orgs.filter((o)=>!o.contractType);
    if (uncategorized.length > 0) groups.push({
        contractType: null,
        orgs: sortOrgsByName(uncategorized)
    });
    return groups;
};
const renderGroupedOrgs = (orgConfigs, revenueContainer, clipboardConfig, handleCopyConfig)=>{
    const groups = groupOrgsByContractType(orgConfigs);
    // If there's only one group (all same type or all uncategorized), skip the group header
    const showHeaders = groups.length > 1 || groups.length === 1 && groups[0].contractType !== null;
    return groups.map((group)=>{
        const groupKey = group.contractType || "__uncategorized__";
        const groupRevenue = group.orgs.reduce((sum, orgConfig)=>{
            const orgRev = revenueContainer.state.revenueByOrg.find((r)=>r.organizationId === orgConfig.organizationId);
            return sum + (orgRev?.totalRevenue || 0);
        }, 0);
        return (0, _react.jsx)(ContractTypeGroup, {
            key: groupKey
        }, showHeaders && (0, _react.jsx)(ContractTypeHeader, null, (0, _react.jsx)(ContractTypeLabel, null, group.contractType || "Uncategorized"), (0, _react.jsx)(ContractTypeCount, null, group.orgs.length, " org", group.orgs.length !== 1 ? "s" : ""), groupRevenue > 0 && (0, _react.jsx)(ContractTypeRevenue, null, formatCurrency(groupRevenue))), group.orgs.map((orgConfig)=>{
            const orgRevenue = revenueContainer.state.revenueByOrg.find((r)=>r.organizationId === orgConfig.organizationId);
            const orgIsLoading = revenueContainer.state.loadingOrgIds.includes(orgConfig.organizationId);
            const isExpanded = revenueContainer.state.expandedOrgs.includes(orgConfig.organizationId);
            return (0, _react.jsx)((0, _organizationSectionDefault.default), {
                key: orgConfig.organizationId,
                orgConfig: orgConfig,
                orgRevenue: orgRevenue,
                revenueContainer: revenueContainer,
                isExpanded: isExpanded,
                isLoading: orgIsLoading,
                onToggleExpand: ()=>revenueContainer.toggleOrgExpanded(orgConfig.organizationId),
                onRemove: ()=>revenueContainer.removeOrganization(orgConfig.organizationId),
                clipboardConfig: clipboardConfig,
                onCopyConfig: handleCopyConfig
            });
        }));
    });
};
const formatCurrency = (value)=>{
    return new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD",
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    }).format(value);
};
const Container = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "ei2t3xm31"
})({
    name: "167tzjt",
    styles: "height:100%;display:flex;flex-direction:column;overflow:hidden;font-family:Muli;.react-tabs{display:flex;flex-direction:column;flex:1;min-height:0;overflow:hidden;}.panel-tab-list{color:white;list-style-type:none;display:flex;align-items:center;margin-left:28px;}.react-tabs__tab-panel--selected{flex:1;overflow-y:auto;min-height:0;}"
});
const TabContent = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "ei2t3xm30"
})({
    name: "w4jzt0",
    styles: "padding:24px;max-width:1600px;margin:0 auto;width:100%;box-sizing:border-box"
});
const Header = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "ei2t3xm29"
})("display:flex;justify-content:space-between;align-items:center;margin-bottom:20px;h1{margin:0;color:", (0, _colors.color_text_default), ";font-size:24px;}");
const HeaderLeft = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "ei2t3xm28"
})({
    name: "1wcglds",
    styles: "display:flex;align-items:center;gap:16px"
});
const HeaderActions = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "ei2t3xm27"
})({
    name: "11jf4ye",
    styles: "display:flex;gap:8px"
});
const TotalRevenueBadge = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "ei2t3xm26"
})("font-size:18px;font-weight:700;color:", (0, _colors.color_colors_growth), ";background:rgba(88, 189, 153, 0.1);padding:6px 16px;border-radius:6px;");
const SettingsButton = /*#__PURE__*/ (0, _baseDefault.default)("button", {
    target: "ei2t3xm25"
})("background:", (0, _colors.color_colors_ocean), ";color:", (0, _colors.color_defaults_white), ";border:none;padding:8px 16px;border-radius:6px;cursor:pointer;font-size:14px;&:hover{opacity:0.9;}");
const SettingsPanel = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "ei2t3xm24"
})("background:", (0, _colors.color_shades_lightest), ";border:1px solid ", (0, _colors.color_shades_light), ";border-radius:8px;padding:20px;margin-bottom:20px;");
const ConfigExportImportBar = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "ei2t3xm23"
})("display:flex;gap:10px;margin-bottom:20px;padding-bottom:20px;border-bottom:1px solid ", (0, _colors.color_shades_light), ";");
const ConfigExportImportButton = /*#__PURE__*/ (0, _baseDefault.default)("button", {
    target: "ei2t3xm22"
})("background:", (0, _colors.color_colors_ocean), ";color:", (0, _colors.color_defaults_white), ";border:none;padding:8px 16px;border-radius:6px;cursor:pointer;font-size:13px;&:hover{opacity:0.9;}");
const ControlsBar = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "ei2t3xm21"
})({
    name: "5w22ir",
    styles: "display:flex;justify-content:space-between;align-items:flex-end;gap:16px;margin-bottom:20px;flex-wrap:wrap"
});
const ControlsLeft = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "ei2t3xm20"
})({
    name: "xub5b5",
    styles: "display:flex;gap:16px;align-items:flex-end"
});
const ControlsRight = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "ei2t3xm19"
})({
    name: "197tvr9",
    styles: "display:flex;gap:8px;align-items:center"
});
const ClipboardBadge = /*#__PURE__*/ (0, _baseDefault.default)("span", {
    target: "ei2t3xm18"
})("font-size:12px;color:", (0, _colors.color_colors_ocean), ";padding:4px 8px;background:rgba(30, 126, 185, 0.08);border-radius:3px;");
const LoadingStatus = /*#__PURE__*/ (0, _baseDefault.default)("span", {
    target: "ei2t3xm17"
})("font-size:12px;color:", (0, _colors.color_text_light), ";padding:4px 10px;background:", (0, _colors.color_shades_lightest), ";border:1px solid ", (0, _colors.color_shades_light), ";border-radius:4px;white-space:nowrap;");
const LoadDataButton = /*#__PURE__*/ (0, _baseDefault.default)("button", {
    target: "ei2t3xm16"
})("background:", (0, _colors.color_colors_growth), ";color:", (0, _colors.color_defaults_white), ";border:none;padding:8px 20px;border-radius:6px;cursor:pointer;font-size:14px;font-weight:500;&:hover:not(:disabled){opacity:0.9;}&:disabled{opacity:0.6;cursor:not-allowed;}");
const RecalcButton = /*#__PURE__*/ (0, _baseDefault.default)("button", {
    target: "ei2t3xm15"
})("background:", (0, _colors.color_colors_ocean), ";color:", (0, _colors.color_defaults_white), ";border:none;padding:8px 16px;border-radius:6px;cursor:pointer;font-size:14px;&:hover:not(:disabled){opacity:0.9;}&:disabled{opacity:0.6;cursor:not-allowed;}");
const ForceReloadButton = /*#__PURE__*/ (0, _baseDefault.default)("button", {
    target: "ei2t3xm14"
})("background:transparent;color:", (0, _colors.color_text_light), ";border:1px solid ", (0, _colors.color_shades_light), ";padding:8px 16px;border-radius:6px;cursor:pointer;font-size:13px;&:hover:not(:disabled){color:", (0, _colors.color_colors_decline), ";border-color:", (0, _colors.color_colors_decline), ";}&:disabled{opacity:0.6;cursor:not-allowed;}");
const ErrorsPanel = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "ei2t3xm13"
})("background:rgba(216, 65, 77, 0.08);border:1px solid ", (0, _colors.color_colors_decline), ";border-radius:6px;padding:12px 16px;margin-bottom:16px;");
const ErrorLine = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "ei2t3xm12"
})("font-size:13px;color:", (0, _colors.color_colors_decline), ";margin-bottom:4px;&:last-child{margin-bottom:0;}");
const EmptyState = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "ei2t3xm11"
})({
    name: "zx0ln1",
    styles: "text-align:center;padding:60px 24px"
});
const EmptyTitle = /*#__PURE__*/ (0, _baseDefault.default)("h2", {
    target: "ei2t3xm10"
})("color:", (0, _colors.color_text_default), ";margin:0 0 8px 0;");
const EmptyDescription = /*#__PURE__*/ (0, _baseDefault.default)("p", {
    target: "ei2t3xm9"
})("color:", (0, _colors.color_text_light), ";font-size:14px;max-width:400px;margin:0 auto;");
const OrgSections = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "ei2t3xm8"
})("");
const ContractTypeGroup = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "ei2t3xm7"
})({
    name: "5bhc30",
    styles: "margin-bottom:8px"
});
const ContractTypeHeader = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "ei2t3xm6"
})("display:flex;align-items:center;gap:12px;padding:10px 0 8px 0;margin-bottom:4px;border-bottom:2px solid ", (0, _colors.color_shades_light), ";");
const ContractTypeLabel = /*#__PURE__*/ (0, _baseDefault.default)("span", {
    target: "ei2t3xm5"
})("font-size:14px;font-weight:700;color:", (0, _colors.color_shades_darker), ";text-transform:uppercase;letter-spacing:0.5px;");
const ContractTypeCount = /*#__PURE__*/ (0, _baseDefault.default)("span", {
    target: "ei2t3xm4"
})("font-size:12px;color:", (0, _colors.color_text_light), ";");
const ContractTypeRevenue = /*#__PURE__*/ (0, _baseDefault.default)("span", {
    target: "ei2t3xm3"
})("font-size:13px;font-weight:600;color:", (0, _colors.color_colors_growth), ";margin-left:auto;");
const TabRowActions = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "ei2t3xm2"
})({
    name: "1hygxum",
    styles: "display:flex;align-items:center;gap:10px;margin-left:auto;padding-right:20px"
});
const SaveConfigButton = /*#__PURE__*/ (0, _baseDefault.default)("button", {
    target: "ei2t3xm1"
})("background:", (0, _colors.color_colors_growth), ";color:", (0, _colors.color_defaults_white), ";border:none;padding:6px 20px;border-radius:6px;cursor:pointer;font-size:14px;font-weight:500;&:hover:not(:disabled){opacity:0.9;}&:disabled{opacity:0.6;cursor:not-allowed;}");
const SaveErrorText = /*#__PURE__*/ (0, _baseDefault.default)("span", {
    target: "ei2t3xm0"
})("font-size:12px;color:", (0, _colors.color_colors_decline), ";");
exports.default = Revenue;

},{"@emotion/styled/base":"lSuFu","@emotion/react":"djZKr","react":"6uln9","react-router-dom":"5fzqq","react-tabs":"92Sgf","../../components/structure/Panels/PanelHeaderContainer":"hUotd","../../components/structure/Panels/PanelIconTab":"1Stt2","./components/MonthSelector":"hyEim","./components/OrganizationSelector":"72jBA","./components/OrganizationSection":"izvRg","./components/ProjectionsTab":"3ySUG","../../models/revenue/BillingConfig":"9NytT","../../constants/colors":"1p3OR","b070817e075ebb3c":"f63Qq","56ddb5a98e4ad28b":"dwJHc","665c329921eb3352":"8y8tE","12e057fdae9d9935":"dZZCl","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hyEim":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _base = require("@emotion/styled/base");
var _baseDefault = parcelHelpers.interopDefault(_base);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _moment = require("moment");
var _momentDefault = parcelHelpers.interopDefault(_moment);
var _colors = require("../../../constants/colors");
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const MonthSelector = ({ selectedMonth, onMonthChange, disabled })=>{
    // Generate current month + last 24 months (25 total)
    const months = [];
    for(let i = 0; i < 25; i++){
        const m = (0, _momentDefault.default)().subtract(i, "months").startOf("month");
        months.push({
            value: m.format("YYYY-MM"),
            label: m.format("MMMM YYYY"),
            date: m.toDate()
        });
    }
    const currentValue = (0, _momentDefault.default)(selectedMonth).format("YYYY-MM");
    return (0, _react.jsx)(Wrapper, null, (0, _react.jsx)(Label, null, "Billing Month"), (0, _react.jsx)(Select, {
        value: currentValue,
        onChange: (e)=>{
            const found = months.find((m)=>m.value === e.target.value);
            if (found) onMonthChange(found.date);
        },
        disabled: disabled
    }, months.map((m)=>(0, _react.jsx)("option", {
            key: m.value,
            value: m.value
        }, m.label))));
};
const Wrapper = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e7jpbe02"
})({
    name: "urqszi",
    styles: "display:flex;flex-direction:column;gap:4px"
});
const Label = /*#__PURE__*/ (0, _baseDefault.default)("label", {
    target: "e7jpbe01"
})("font-size:12px;font-weight:500;color:", (0, _colors.color_text_light), ";text-transform:uppercase;letter-spacing:0.05em;");
const Select = /*#__PURE__*/ (0, _baseDefault.default)("select", {
    target: "e7jpbe00"
})("padding:8px 12px;border:1px solid ", (0, _colors.color_shades_dark), ";border-radius:4px;font-size:14px;color:", (0, _colors.color_text_default), ";background:", (0, _colors.color_defaults_white), ";cursor:pointer;min-width:200px;&:focus{outline:none;border-color:", (0, _colors.color_colors_ocean), ";box-shadow:0 0 0 3px ", (0, _colors.color_variants_ocean_light_1), ";}&:disabled{opacity:0.6;cursor:not-allowed;}");
exports.default = MonthSelector;

},{"@emotion/styled/base":"lSuFu","@emotion/react":"djZKr","react":"6uln9","moment":"2meyw","../../../constants/colors":"1p3OR","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"72jBA":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _base = require("@emotion/styled/base");
var _baseDefault = parcelHelpers.interopDefault(_base);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _colors = require("../../../constants/colors");
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const OrganizationSelector = ({ organizationContainer, selectedOrgIds, selectedOrgNames, onAddOrg, onRemoveOrg })=>{
    const [searchTerm, setSearchTerm] = (0, _react1.useState)("");
    const availableOrgs = (0, _react1.useMemo)(()=>{
        const selectedSet = new Set(selectedOrgIds);
        return (organizationContainer.state.organizations || []).filter((org)=>org.id && org.name && !selectedSet.has(org.id)).filter((org)=>{
            if (!searchTerm.trim()) return true;
            return org.name.toLowerCase().includes(searchTerm.toLowerCase());
        }).sort((a, b)=>(a.name || "").localeCompare(b.name || ""));
    }, [
        organizationContainer.state.organizations,
        selectedOrgIds,
        searchTerm
    ]);
    return (0, _react.jsx)(Wrapper, null, (0, _react.jsx)(SectionTitle, null, "Organizations to Track"), (0, _react.jsx)(AddSection, null, (0, _react.jsx)(SearchInput, {
        type: "text",
        placeholder: "Search organizations...",
        value: searchTerm,
        onChange: (e)=>setSearchTerm(e.target.value)
    }), (0, _react.jsx)(OrgList, null, availableOrgs.map((org)=>(0, _react.jsx)(OrgOption, {
            key: org.id,
            onClick: ()=>{
                onAddOrg(org.id, org.name);
                setSearchTerm("");
            }
        }, (0, _react.jsx)(OrgOptionName, null, org.name), (0, _react.jsx)(AddIcon, null, "+"))), availableOrgs.length === 0 && searchTerm && (0, _react.jsx)(MoreText, null, "No matching organizations found."))), selectedOrgIds.length > 0 && (0, _react.jsx)(SelectedSection, null, (0, _react.jsx)(SelectedTitle, null, "Selected (", selectedOrgIds.length, ")"), selectedOrgIds.map((orgId)=>(0, _react.jsx)(SelectedOrg, {
            key: orgId
        }, (0, _react.jsx)(SelectedOrgName, null, selectedOrgNames[orgId] || orgId), (0, _react.jsx)(RemoveButton, {
            onClick: ()=>onRemoveOrg(orgId)
        }, "Remove")))));
};
const Wrapper = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1iao8v413"
})({
    name: "1fgdcyd",
    styles: "margin-bottom:24px"
});
const SectionTitle = /*#__PURE__*/ (0, _baseDefault.default)("h3", {
    target: "e1iao8v412"
})("margin:0 0 12px 0;color:", (0, _colors.color_text_default), ";font-size:16px;");
const AddSection = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1iao8v411"
})("background:", (0, _colors.color_defaults_white), ";border:1px solid ", (0, _colors.color_shades_dark), ";border-radius:6px;padding:12px;margin-bottom:12px;");
const SearchInput = /*#__PURE__*/ (0, _baseDefault.default)("input", {
    target: "e1iao8v410"
})("width:100%;padding:8px 12px;border:1px solid ", (0, _colors.color_shades_dark), ";border-radius:4px;font-size:14px;margin-bottom:8px;box-sizing:border-box;&:focus{outline:none;border-color:", (0, _colors.color_colors_ocean), ";box-shadow:0 0 0 3px ", (0, _colors.color_variants_ocean_light_1), ";}");
const OrgList = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1iao8v49"
})({
    name: "1u5dvgf",
    styles: "max-height:200px;overflow-y:auto"
});
const OrgOption = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1iao8v48"
})("display:flex;justify-content:space-between;align-items:center;padding:6px 8px;cursor:pointer;border-radius:4px;&:hover{background:", (0, _colors.color_shades_lightest), ";}");
const OrgOptionName = /*#__PURE__*/ (0, _baseDefault.default)("span", {
    target: "e1iao8v47"
})("font-size:14px;color:", (0, _colors.color_text_default), ";");
const AddIcon = /*#__PURE__*/ (0, _baseDefault.default)("span", {
    target: "e1iao8v46"
})("color:", (0, _colors.color_colors_growth), ";font-size:18px;font-weight:bold;");
const MoreText = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1iao8v45"
})("font-size:12px;color:", (0, _colors.color_text_light), ";padding:6px 8px;font-style:italic;");
const SelectedSection = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1iao8v44"
})({
    name: "xda5ep",
    styles: "margin-top:12px"
});
const SelectedTitle = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1iao8v43"
})("font-size:12px;font-weight:500;color:", (0, _colors.color_text_light), ";text-transform:uppercase;letter-spacing:0.05em;margin-bottom:8px;");
const SelectedOrg = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1iao8v42"
})("display:flex;justify-content:space-between;align-items:center;padding:6px 12px;background:", (0, _colors.color_defaults_white), ";border:1px solid ", (0, _colors.color_shades_light), ";border-radius:4px;margin-bottom:4px;");
const SelectedOrgName = /*#__PURE__*/ (0, _baseDefault.default)("span", {
    target: "e1iao8v41"
})("font-size:14px;color:", (0, _colors.color_text_default), ";");
const RemoveButton = /*#__PURE__*/ (0, _baseDefault.default)("button", {
    target: "e1iao8v40"
})("background:", (0, _colors.color_colors_decline), ";color:", (0, _colors.color_defaults_white), ";border:none;padding:4px 10px;border-radius:4px;cursor:pointer;font-size:12px;&:hover{opacity:0.9;}");
exports.default = OrganizationSelector;

},{"@emotion/styled/base":"lSuFu","@emotion/react":"djZKr","react":"6uln9","../../../constants/colors":"1p3OR","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"izvRg":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _base = require("@emotion/styled/base");
var _baseDefault = parcelHelpers.interopDefault(_base);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _billingConfigEditor = require("./BillingConfigEditor");
var _billingConfigEditorDefault = parcelHelpers.interopDefault(_billingConfigEditor);
var _revenueTable = require("./RevenueTable");
var _revenueTableDefault = parcelHelpers.interopDefault(_revenueTable);
var _billingConfig = require("../../../models/revenue/BillingConfig");
var _colors = require("../../../constants/colors");
var _loader = require("../../../components/general/Loader");
var _loaderDefault = parcelHelpers.interopDefault(_loader);
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const formatCurrency = (value)=>{
    return new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD",
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    }).format(value);
};
const getBillingSummary = (config)=>{
    const items = [];
    if (config.aiMinuteRate > 0) items.push(`AI: ${formatCurrency(config.aiMinuteRate)}/min`);
    if (config.postTransferMinuteRate > 0) items.push(`PT: ${formatCurrency(config.postTransferMinuteRate)}/min`);
    if (config.callRate > 0) items.push(`Calls: ${formatCurrency(config.callRate)}`);
    if (config.containedCallRate > 0) items.push(`Contained: ${formatCurrency(config.containedCallRate)}`);
    if (config.nonContainableCallRate > 0) items.push(`Non-containable: ${formatCurrency(config.nonContainableCallRate)}`);
    if (config.orderPlacedRate > 0) items.push(`Orders: ${formatCurrency(config.orderPlacedRate)}`);
    if (config.flatMonthlyFee > 0) items.push(`Flat: ${formatCurrency(config.flatMonthlyFee)}/mo`);
    return items.length > 0 ? items.join(" • ") : "No billing configured";
};
const OrganizationSection = ({ orgConfig, orgRevenue, revenueContainer, isExpanded, isLoading, onToggleExpand, onRemove, clipboardConfig, onCopyConfig })=>{
    const [showConfig, setShowConfig] = (0, _react1.useState)(false);
    const [editingOverrideAppId, setEditingOverrideAppId] = (0, _react1.useState)(null);
    const [searchTerm, setSearchTerm] = (0, _react1.useState)("");
    const [showDropdown, setShowDropdown] = (0, _react1.useState)(false);
    const orgId = orgConfig.organizationId;
    const engagementCount = (revenueContainer.state.engagementsByOrg[orgId] || []).length;
    const appCount = (revenueContainer.state.applicationsByOrg[orgId] || []).filter((app)=>app.isLive !== false && !orgConfig.ignoredApplicationIds.includes(app.id)).length;
    // Get all apps for this org
    const allApps = revenueContainer.state.applicationsByOrg[orgId] || [];
    // Filter apps based on search and exclude already force-included ones
    const forceIncludedIds = orgConfig.forceIncludeApplicationIds || [];
    const availableApps = searchTerm.trim().length > 0 ? allApps.filter((app)=>!forceIncludedIds.includes(app.id) && (app.name?.toLowerCase().includes(searchTerm.toLowerCase()) || app.id.toLowerCase().includes(searchTerm.toLowerCase()))) : [];
    const handleEditOverride = (appId)=>{
        setEditingOverrideAppId(editingOverrideAppId === appId ? null : appId);
    };
    const getOverrideConfig = (appId)=>{
        const override = orgConfig.applicationOverrides.find((ao)=>ao.applicationId === appId);
        return override ? override.config : null;
    };
    const handleOverrideChange = (appId, config)=>{
        revenueContainer.addApplicationOverride(orgId, appId, config);
    };
    const handleRemoveOverride = (appId)=>{
        revenueContainer.removeApplicationOverride(orgId, appId);
        setEditingOverrideAppId(null);
    };
    const handleExportOrgConfig = ()=>{
        try {
            const jsonString = revenueContainer.exportOrgConfig(orgId);
            const blob = new Blob([
                jsonString
            ], {
                type: "application/json"
            });
            const url = URL.createObjectURL(blob);
            const a = document.createElement("a");
            a.href = url;
            a.download = `org-${orgConfig.organizationName || orgId}-config.json`;
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
            URL.revokeObjectURL(url);
        } catch (e) {
            alert(`Failed to export config: ${e.message}`);
        }
    };
    const handleImportOrgConfig = ()=>{
        const input = document.createElement("input");
        input.type = "file";
        input.accept = ".json";
        input.onchange = (e)=>{
            const file = e.target?.files?.[0];
            if (!file) return;
            const reader = new FileReader();
            reader.onload = (event)=>{
                const jsonString = event.target?.result;
                const result = revenueContainer.importOrgConfig(jsonString);
                if (result.success) alert("Organization config imported successfully!");
                else alert(`Failed to import config: ${result.error}`);
            };
            reader.readAsText(file);
        };
        input.click();
    };
    const handleExportAppConfig = (appId)=>{
        try {
            const jsonString = revenueContainer.exportAppConfig(orgId, appId);
            const app = orgRevenue?.applications.find((a)=>a.applicationId === appId);
            const appName = app?.applicationName || appId;
            const blob = new Blob([
                jsonString
            ], {
                type: "application/json"
            });
            const url = URL.createObjectURL(blob);
            const a = document.createElement("a");
            a.href = url;
            a.download = `app-${appName}-config.json`;
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
            URL.revokeObjectURL(url);
        } catch (e) {
            alert(`Failed to export config: ${e.message}`);
        }
    };
    const handleImportAppConfig = ()=>{
        const input = document.createElement("input");
        input.type = "file";
        input.accept = ".json";
        input.onchange = (e)=>{
            const file = e.target?.files?.[0];
            if (!file) return;
            const reader = new FileReader();
            reader.onload = (event)=>{
                const jsonString = event.target?.result;
                const result = revenueContainer.importAppConfig(orgId, jsonString);
                if (result.success) alert("Application config imported successfully!");
                else alert(`Failed to import config: ${result.error}`);
            };
            reader.readAsText(file);
        };
        input.click();
    };
    return (0, _react.jsx)(Wrapper, null, (0, _react.jsx)(OrgHeader, {
        onClick: onToggleExpand
    }, (0, _react.jsx)(HeaderLeft, null, (0, _react.jsx)(ExpandIcon, null, isExpanded ? "▼" : "▶"), (0, _react.jsx)(OrgName, null, orgConfig.organizationName || orgConfig.organizationId), (0, _react.jsx)(ContractTypeSelect, {
        value: orgConfig.contractType || "",
        onClick: (e)=>e.stopPropagation(),
        onChange: (e)=>{
            e.stopPropagation();
            const val = e.target.value;
            revenueContainer.updateOrgContractType(orgId, val === "" ? undefined : val);
        },
        title: "Contract type"
    }, (0, _react.jsx)("option", {
        value: ""
    }, "No contract type"), (0, _billingConfig.CONTRACT_TYPES).map((ct)=>(0, _react.jsx)("option", {
            key: ct,
            value: ct
        }, ct))), isLoading && (0, _react.jsx)(LoadingBadge, null, "Loading..."), !isLoading && orgRevenue && (0, _react.jsx)(RevenueBadge, null, formatCurrency(orgRevenue.totalRevenue)), orgConfig.contractStatus && (0, _react.jsx)(ContractStatusBadge, {
        status: orgConfig.contractStatus
    }, orgConfig.contractStatus), orgConfig.totalPossibleLocations != null && (0, _react.jsx)(TotalLocationsBadge, {
        title: "Total possible locations"
    }, orgConfig.totalPossibleLocations, " locations"), (0, _react.jsx)(BillingSummary, {
        title: "Default billing configuration"
    }, getBillingSummary(orgConfig.defaultConfig))), (0, _react.jsx)(HeaderRight, null, clipboardConfig && (0, _react.jsx)(PasteConfigButton, {
        onClick: (e)=>{
            e.stopPropagation();
            revenueContainer.updateOrgDefaultConfig(orgId, clipboardConfig);
        },
        title: "Paste billing config from clipboard"
    }, "Paste Config"), (0, _react.jsx)(StatBadge, null, appCount, " locations"), (0, _react.jsx)(StatBadge, null, engagementCount.toLocaleString(), " conversations"), (0, _react.jsx)(RemoveOrgButton, {
        onClick: (e)=>{
            e.stopPropagation();
            onRemove();
        },
        title: "Remove organization"
    }, "X"))), isExpanded && (0, _react.jsx)(OrgBody, null, (0, _react.jsx)(ConfigToggle, {
        onClick: ()=>setShowConfig(!showConfig)
    }, showConfig ? "Hide Billing Config" : "Show Billing Config"), showConfig && (0, _react.jsx)(ConfigSection, null, (0, _react.jsx)(OrgMetadataRow, null, (0, _react.jsx)(MetadataField, null, (0, _react.jsx)(MetadataLabel, null, "Contract Status"), (0, _react.jsx)(MetadataSelect, {
        value: orgConfig.contractStatus || "",
        onChange: (e)=>{
            const val = e.target.value;
            revenueContainer.updateOrgContractStatus(orgId, val === "" ? undefined : val);
        }
    }, (0, _react.jsx)("option", {
        value: ""
    }, "Not set"), (0, _billingConfig.CONTRACT_STATUSES).map((cs)=>(0, _react.jsx)("option", {
            key: cs,
            value: cs
        }, cs)))), (0, _react.jsx)(MetadataField, null, (0, _react.jsx)(MetadataLabel, null, "Total Possible Locations"), (0, _react.jsx)(MetadataInput, {
        type: "number",
        min: "0",
        step: "1",
        placeholder: "Not set",
        value: orgConfig.totalPossibleLocations ?? "",
        onChange: (e)=>{
            const val = e.target.value;
            revenueContainer.updateOrgTotalPossibleLocations(orgId, val === "" ? undefined : Math.floor(Number(val)));
        }
    })), (0, _react.jsx)(MetadataField, null, (0, _react.jsx)(MetadataLabel, null, "Avg Revenue / Location Override"), (0, _react.jsx)(MetadataInput, {
        type: "number",
        min: "0",
        step: "0.01",
        placeholder: "Computed from data",
        value: orgConfig.avgRevenuePerLocation ?? "",
        onChange: (e)=>{
            const val = e.target.value;
            revenueContainer.updateOrgAvgRevenuePerLocation(orgId, val === "" ? undefined : Number(val));
        }
    }))), (0, _react.jsx)(ExportImportBar, null, (0, _react.jsx)(ExportImportButton, {
        onClick: handleExportOrgConfig,
        title: "Export this organization's full config to JSON file"
    }, "Export Org Config"), (0, _react.jsx)(ExportImportButton, {
        onClick: handleImportOrgConfig,
        title: "Import organization config from JSON file"
    }, "Import Org Config")), (0, _react.jsx)((0, _billingConfigEditorDefault.default), {
        config: orgConfig.defaultConfig,
        onChange: (config)=>revenueContainer.updateOrgDefaultConfig(orgId, config),
        title: "Organization Default Billing Config",
        onCopy: ()=>onCopyConfig(orgConfig.defaultConfig),
        onPaste: (config)=>revenueContainer.updateOrgDefaultConfig(orgId, config),
        onReset: ()=>revenueContainer.updateOrgDefaultConfig(orgId, {
                ...(0, _billingConfig.DEFAULT_BILLING_CONFIG)
            }),
        clipboardConfig: clipboardConfig
    }), (0, _react.jsx)(ForceIncludeSection, null, (0, _react.jsx)(ForceIncludeTitle, null, "Force Include Applications (always show, even with 0 conversations)"), (0, _react.jsx)(DropdownContainer, null, (0, _react.jsx)(SearchInput, {
        type: "text",
        placeholder: "Search applications...",
        value: searchTerm,
        onChange: (e)=>{
            setSearchTerm(e.target.value);
            setShowDropdown(true);
        },
        onFocus: ()=>setShowDropdown(true),
        onBlur: ()=>{
            // Delay to allow click on dropdown items
            setTimeout(()=>setShowDropdown(false), 200);
        }
    }), showDropdown && availableApps.length > 0 && (0, _react.jsx)(DropdownList, null, availableApps.slice(0, 10).map((app)=>(0, _react.jsx)(DropdownItem, {
            key: app.id,
            onMouseDown: (e)=>{
                e.preventDefault(); // Prevent blur
                revenueContainer.addForceIncludeApplication(orgId, app.id);
                setSearchTerm("");
                setShowDropdown(false);
            }
        }, (0, _react.jsx)(AppName, null, app.name || "Unnamed App"), (0, _react.jsx)(AppId, null, app.id))), availableApps.length > 10 && (0, _react.jsx)(DropdownHint, null, "...and ", availableApps.length - 10, " more (refine search)")), showDropdown && searchTerm && availableApps.length === 0 && (0, _react.jsx)(DropdownList, null, (0, _react.jsx)(DropdownHint, null, "No matching applications found"))), orgConfig.forceIncludeApplicationIds && orgConfig.forceIncludeApplicationIds.length > 0 && (0, _react.jsx)(ForceIncludeList, null, orgConfig.forceIncludeApplicationIds.map((appId)=>{
        const app = (revenueContainer.state.applicationsByOrg[orgId] || []).find((a)=>a.id === appId);
        return (0, _react.jsx)(ForceIncludeItem, {
            key: appId
        }, (0, _react.jsx)(ForceIncludeAppName, null, app?.name || appId, app?.name && (0, _react.jsx)(ForceIncludeAppId, null, appId)), (0, _react.jsx)(RemoveButton, {
            onClick: ()=>revenueContainer.removeForceIncludeApplication(orgId, appId),
            title: "Remove from force-include list"
        }, "Remove"));
    }))), (0, _react.jsx)(IgnoredSection, null, (0, _react.jsx)(IgnoredTitle, null, "Ignored Applications (excluded from revenue calculations)"), orgConfig.ignoredApplicationIds && orgConfig.ignoredApplicationIds.length > 0 ? (0, _react.jsx)(IgnoredList, null, orgConfig.ignoredApplicationIds.map((appId)=>{
        const app = (revenueContainer.state.applicationsByOrg[orgId] || []).find((a)=>a.id === appId);
        return (0, _react.jsx)(IgnoredItem, {
            key: appId
        }, (0, _react.jsx)(IgnoredAppName, null, app?.name || appId, app?.name && (0, _react.jsx)(IgnoredAppId, null, appId)), (0, _react.jsx)(RemoveButton, {
            onClick: ()=>revenueContainer.toggleIgnoreApplication(orgId, appId),
            title: "Remove from ignored list (include in calculations)"
        }, "Include"));
    })) : (0, _react.jsx)(EmptyIgnoredText, null, 'No applications are currently ignored. Use the "Ignore" button in the revenue table to exclude applications.'))), isLoading ? (0, _react.jsx)(LoadingContainer, null, (0, _react.jsx)((0, _loaderDefault.default), null), (0, _react.jsx)(LoadingText, null, "Loading conversation data...")) : orgRevenue ? (0, _react.jsx)((0, _reactDefault.default).Fragment, null, (0, _react.jsx)((0, _revenueTableDefault.default), {
        orgRevenue: orgRevenue,
        ignoredAppIds: orgConfig.ignoredApplicationIds,
        onToggleIgnore: (appId)=>revenueContainer.toggleIgnoreApplication(orgId, appId),
        onEditOverride: handleEditOverride,
        hasOverride: (appId)=>orgConfig.applicationOverrides.some((ao)=>ao.applicationId === appId)
    }), editingOverrideAppId && (0, _react.jsx)(OverrideEditor, null, (0, _react.jsx)(OverrideHeader, null, (0, _react.jsx)(OverrideTitle, null, "Billing Override for: ", orgRevenue.applications.find((a)=>a.applicationId === editingOverrideAppId)?.applicationName || editingOverrideAppId), (0, _react.jsx)(OverrideActions, null, getOverrideConfig(editingOverrideAppId) && (0, _react.jsx)((0, _reactDefault.default).Fragment, null, (0, _react.jsx)(ExportButton, {
        onClick: ()=>handleExportAppConfig(editingOverrideAppId),
        title: "Export this app's config to JSON file"
    }, "Export"), (0, _react.jsx)(RemoveOverrideButton, {
        onClick: ()=>handleRemoveOverride(editingOverrideAppId)
    }, "Remove Override")), !getOverrideConfig(editingOverrideAppId) && (0, _react.jsx)(ImportButton, {
        onClick: handleImportAppConfig,
        title: "Import app config from JSON file"
    }, "Import"), (0, _react.jsx)(CloseButton, {
        onClick: ()=>setEditingOverrideAppId(null)
    }, "Close"))), (0, _react.jsx)((0, _billingConfigEditorDefault.default), {
        config: getOverrideConfig(editingOverrideAppId) || orgConfig.defaultConfig,
        onChange: (config)=>handleOverrideChange(editingOverrideAppId, config),
        onCopy: ()=>onCopyConfig(getOverrideConfig(editingOverrideAppId) || orgConfig.defaultConfig),
        onPaste: (config)=>handleOverrideChange(editingOverrideAppId, config),
        clipboardConfig: clipboardConfig
    }))) : (0, _react.jsx)(EmptyState, null, 'No data loaded. Click "Load Data" to fetch conversation data for this month.')));
};
const Wrapper = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e5mg7u56"
})("border:1px solid ", (0, _colors.color_shades_dark), ";border-radius:8px;overflow:hidden;margin-bottom:16px;");
const OrgHeader = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e5mg7u55"
})("display:flex;justify-content:space-between;align-items:center;padding:14px 16px;background:", (0, _colors.color_shades_lightest), ";cursor:pointer;user-select:none;&:hover{background:", (0, _colors.color_shades_light), ";}");
const HeaderLeft = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e5mg7u54"
})({
    name: "1og3vwv",
    styles: "display:flex;align-items:center;gap:10px"
});
const HeaderRight = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e5mg7u53"
})({
    name: "1yydxi7",
    styles: "display:flex;align-items:center;gap:8px"
});
const ExpandIcon = /*#__PURE__*/ (0, _baseDefault.default)("span", {
    target: "e5mg7u52"
})("font-size:12px;color:", (0, _colors.color_text_light), ";width:16px;");
const OrgName = /*#__PURE__*/ (0, _baseDefault.default)("span", {
    target: "e5mg7u51"
})("font-size:16px;font-weight:600;color:", (0, _colors.color_text_default), ";");
const ContractTypeSelect = /*#__PURE__*/ (0, _baseDefault.default)("select", {
    target: "e5mg7u50"
})("font-size:11px;color:", (0, _colors.color_text_light), ";background:", (0, _colors.color_defaults_white), ";border:1px solid ", (0, _colors.color_shades_light), ";border-radius:3px;padding:3px 6px;cursor:pointer;&:focus{outline:none;border-color:", (0, _colors.color_colors_ocean), ";}");
const ContractStatusBadge = /*#__PURE__*/ (0, _baseDefault.default)("span", {
    target: "e5mg7u49"
})("font-size:11px;font-weight:600;padding:3px 8px;border-radius:3px;color:", ({ status })=>status === "Won" ? (0, _colors.color_colors_growth) : (0, _colors.color_colors_ocean), ";background:", ({ status })=>status === "Won" ? "rgba(88, 189, 153, 0.1)" : "rgba(30, 126, 185, 0.1)", ";");
const TotalLocationsBadge = /*#__PURE__*/ (0, _baseDefault.default)("span", {
    target: "e5mg7u48"
})("font-size:11px;color:", (0, _colors.color_text_light), ";background:", (0, _colors.color_defaults_white), ";padding:3px 8px;border-radius:3px;border:1px solid ", (0, _colors.color_shades_light), ";");
const OrgMetadataRow = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e5mg7u47"
})("display:flex;gap:16px;margin-bottom:12px;padding:10px 12px;background:", (0, _colors.color_defaults_white), ";border:1px solid ", (0, _colors.color_shades_light), ";border-radius:6px;");
const MetadataField = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e5mg7u46"
})({
    name: "urqszi",
    styles: "display:flex;flex-direction:column;gap:4px"
});
const MetadataLabel = /*#__PURE__*/ (0, _baseDefault.default)("label", {
    target: "e5mg7u45"
})("font-size:11px;font-weight:600;color:", (0, _colors.color_text_light), ";text-transform:uppercase;letter-spacing:0.5px;");
const MetadataSelect = /*#__PURE__*/ (0, _baseDefault.default)("select", {
    target: "e5mg7u44"
})("font-size:13px;padding:4px 8px;border:1px solid ", (0, _colors.color_shades_dark), ";border-radius:4px;background:", (0, _colors.color_defaults_white), ";color:", (0, _colors.color_text_default), ";&:focus{outline:none;border-color:", (0, _colors.color_colors_ocean), ";}");
const MetadataInput = /*#__PURE__*/ (0, _baseDefault.default)("input", {
    target: "e5mg7u43"
})("font-size:13px;padding:4px 8px;border:1px solid ", (0, _colors.color_shades_dark), ";border-radius:4px;width:120px;color:", (0, _colors.color_text_default), ";&:focus{outline:none;border-color:", (0, _colors.color_colors_ocean), ";}");
const RevenueBadge = /*#__PURE__*/ (0, _baseDefault.default)("span", {
    target: "e5mg7u42"
})("font-size:14px;font-weight:600;color:", (0, _colors.color_colors_growth), ";background:rgba(88, 189, 153, 0.1);padding:3px 10px;border-radius:4px;");
const LoadingBadge = /*#__PURE__*/ (0, _baseDefault.default)("span", {
    target: "e5mg7u41"
})("font-size:12px;color:", (0, _colors.color_colors_ocean), ";font-style:italic;");
const StatBadge = /*#__PURE__*/ (0, _baseDefault.default)("span", {
    target: "e5mg7u40"
})("font-size:12px;color:", (0, _colors.color_text_light), ";background:", (0, _colors.color_defaults_white), ";padding:3px 8px;border-radius:3px;border:1px solid ", (0, _colors.color_shades_light), ";");
const BillingSummary = /*#__PURE__*/ (0, _baseDefault.default)("span", {
    target: "e5mg7u39"
})("font-size:11px;color:", (0, _colors.color_text_light), ";background:", (0, _colors.color_shades_lightest), ";padding:4px 8px;border-radius:3px;border:1px solid ", (0, _colors.color_shades_light), ";font-family:monospace;max-width:500px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;");
const RemoveOrgButton = /*#__PURE__*/ (0, _baseDefault.default)("button", {
    target: "e5mg7u38"
})("background:transparent;color:", (0, _colors.color_colors_decline), ";border:1px solid ", (0, _colors.color_colors_decline), ";border-radius:4px;padding:4px 8px;cursor:pointer;font-size:12px;display:flex;align-items:center;justify-content:center;&:hover{background:", (0, _colors.color_colors_decline), ";color:", (0, _colors.color_defaults_white), ";}");
const PasteConfigButton = /*#__PURE__*/ (0, _baseDefault.default)("button", {
    target: "e5mg7u37"
})("background:", (0, _colors.color_colors_ocean), ";color:", (0, _colors.color_defaults_white), ";border:none;border-radius:4px;padding:4px 10px;cursor:pointer;font-size:12px;white-space:nowrap;&:hover{opacity:0.9;}");
const OrgBody = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e5mg7u36"
})("padding:16px;border-top:1px solid ", (0, _colors.color_shades_dark), ";");
const ConfigToggle = /*#__PURE__*/ (0, _baseDefault.default)("button", {
    target: "e5mg7u35"
})("background:transparent;border:1px solid ", (0, _colors.color_colors_ocean), ";color:", (0, _colors.color_colors_ocean), ";padding:6px 14px;border-radius:4px;cursor:pointer;font-size:13px;margin-bottom:12px;&:hover{background:", (0, _colors.color_colors_ocean), ";color:", (0, _colors.color_defaults_white), ";}");
const ConfigSection = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e5mg7u34"
})({
    name: "18uqayh",
    styles: "margin-bottom:16px"
});
const ExportImportBar = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e5mg7u33"
})({
    name: "1sj1o4x",
    styles: "display:flex;gap:8px;margin-bottom:12px"
});
const ExportImportButton = /*#__PURE__*/ (0, _baseDefault.default)("button", {
    target: "e5mg7u32"
})("background:", (0, _colors.color_colors_ocean), ";color:", (0, _colors.color_defaults_white), ";border:none;padding:6px 12px;border-radius:4px;cursor:pointer;font-size:12px;&:hover{opacity:0.9;}");
const LoadingContainer = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e5mg7u31"
})({
    name: "2z52dq",
    styles: "display:flex;flex-direction:column;align-items:center;padding:32px;gap:12px"
});
const LoadingText = /*#__PURE__*/ (0, _baseDefault.default)("span", {
    target: "e5mg7u30"
})("font-size:14px;color:", (0, _colors.color_text_light), ";");
const EmptyState = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e5mg7u29"
})("padding:24px;text-align:center;color:", (0, _colors.color_text_light), ";font-style:italic;");
const OverrideEditor = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e5mg7u28"
})("margin-top:16px;border:2px solid ", (0, _colors.color_colors_ocean), ";border-radius:6px;overflow:hidden;");
const OverrideHeader = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e5mg7u27"
})("display:flex;justify-content:space-between;align-items:center;padding:10px 14px;background:rgba(30, 126, 185, 0.08);border-bottom:1px solid ", (0, _colors.color_colors_ocean), ";");
const OverrideTitle = /*#__PURE__*/ (0, _baseDefault.default)("span", {
    target: "e5mg7u26"
})("font-size:14px;font-weight:600;color:", (0, _colors.color_colors_ocean), ";");
const ForceIncludeSection = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e5mg7u25"
})("margin-top:20px;padding:16px;background:", (0, _colors.color_shades_lightest), ";border:1px solid ", (0, _colors.color_shades_light), ";border-radius:6px;");
const ForceIncludeTitle = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e5mg7u24"
})("font-size:13px;font-weight:600;color:", (0, _colors.color_text_default), ";margin-bottom:12px;");
const DropdownContainer = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e5mg7u23"
})({
    name: "1vdoh3r",
    styles: "position:relative;margin-bottom:12px"
});
const SearchInput = /*#__PURE__*/ (0, _baseDefault.default)("input", {
    target: "e5mg7u22"
})("width:100%;padding:8px 12px;border:1px solid ", (0, _colors.color_shades_dark), ";border-radius:4px;font-size:13px;&:focus{outline:none;border-color:", (0, _colors.color_colors_ocean), ";}");
const DropdownList = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e5mg7u21"
})("position:absolute;top:100%;left:0;right:0;margin-top:4px;background:", (0, _colors.color_defaults_white), ";border:1px solid ", (0, _colors.color_shades_dark), ";border-radius:4px;box-shadow:0 4px 8px rgba(0, 0, 0, 0.1);max-height:300px;overflow-y:auto;z-index:1000;");
const DropdownItem = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e5mg7u20"
})("padding:10px 12px;cursor:pointer;border-bottom:1px solid ", (0, _colors.color_shades_lightest), ";&:hover{background:", (0, _colors.color_shades_lightest), ";}&:last-child{border-bottom:none;}");
const AppName = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e5mg7u19"
})("font-size:13px;font-weight:600;color:", (0, _colors.color_text_default), ";margin-bottom:2px;");
const AppId = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e5mg7u18"
})("font-size:11px;color:", (0, _colors.color_text_light), ";font-family:monospace;");
const DropdownHint = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e5mg7u17"
})("padding:8px 12px;font-size:12px;color:", (0, _colors.color_text_light), ";font-style:italic;text-align:center;");
const ForceIncludeList = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e5mg7u16"
})({
    name: "1xc5zxn",
    styles: "display:flex;flex-direction:column;gap:6px"
});
const ForceIncludeItem = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e5mg7u15"
})("display:flex;justify-content:space-between;align-items:center;padding:8px 12px;background:", (0, _colors.color_defaults_white), ";border:1px solid ", (0, _colors.color_shades_light), ";border-radius:4px;");
const ForceIncludeAppName = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e5mg7u14"
})("font-size:13px;color:", (0, _colors.color_text_default), ";display:flex;flex-direction:column;gap:2px;");
const ForceIncludeAppId = /*#__PURE__*/ (0, _baseDefault.default)("span", {
    target: "e5mg7u13"
})("font-size:11px;color:", (0, _colors.color_text_light), ";font-family:monospace;");
const RemoveButton = /*#__PURE__*/ (0, _baseDefault.default)("button", {
    target: "e5mg7u12"
})("padding:4px 10px;background:transparent;color:", (0, _colors.color_colors_decline), ";border:1px solid ", (0, _colors.color_colors_decline), ";border-radius:3px;cursor:pointer;font-size:11px;&:hover{background:", (0, _colors.color_colors_decline), ";color:", (0, _colors.color_defaults_white), ";}");
const IgnoredSection = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e5mg7u11"
})("margin-top:20px;padding:16px;background:rgba(255, 0, 0, 0.03);border:1px solid ", (0, _colors.color_shades_light), ";border-radius:6px;");
const IgnoredTitle = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e5mg7u10"
})("font-size:13px;font-weight:600;color:", (0, _colors.color_text_default), ";margin-bottom:12px;");
const IgnoredList = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e5mg7u9"
})({
    name: "1xc5zxn",
    styles: "display:flex;flex-direction:column;gap:6px"
});
const IgnoredItem = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e5mg7u8"
})("display:flex;justify-content:space-between;align-items:center;padding:8px 12px;background:", (0, _colors.color_defaults_white), ";border:1px solid ", (0, _colors.color_shades_light), ";border-radius:4px;opacity:0.7;");
const IgnoredAppName = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e5mg7u7"
})("font-size:13px;color:", (0, _colors.color_text_default), ";display:flex;flex-direction:column;gap:2px;text-decoration:line-through;");
const IgnoredAppId = /*#__PURE__*/ (0, _baseDefault.default)("span", {
    target: "e5mg7u6"
})("font-size:11px;color:", (0, _colors.color_text_light), ";font-family:monospace;");
const EmptyIgnoredText = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e5mg7u5"
})("font-size:12px;color:", (0, _colors.color_text_light), ";font-style:italic;");
const OverrideActions = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e5mg7u4"
})({
    name: "11jf4ye",
    styles: "display:flex;gap:8px"
});
const RemoveOverrideButton = /*#__PURE__*/ (0, _baseDefault.default)("button", {
    target: "e5mg7u3"
})("background:", (0, _colors.color_colors_decline), ";color:", (0, _colors.color_defaults_white), ";border:none;padding:4px 10px;border-radius:3px;cursor:pointer;font-size:12px;&:hover{opacity:0.9;}");
const ExportButton = /*#__PURE__*/ (0, _baseDefault.default)("button", {
    target: "e5mg7u2"
})("background:", (0, _colors.color_colors_ocean), ";color:", (0, _colors.color_defaults_white), ";border:none;padding:4px 10px;border-radius:3px;cursor:pointer;font-size:12px;&:hover{opacity:0.9;}");
const ImportButton = /*#__PURE__*/ (0, _baseDefault.default)("button", {
    target: "e5mg7u1"
})("background:", (0, _colors.color_colors_growth), ";color:", (0, _colors.color_defaults_white), ";border:none;padding:4px 10px;border-radius:3px;cursor:pointer;font-size:12px;&:hover{opacity:0.9;}");
const CloseButton = /*#__PURE__*/ (0, _baseDefault.default)("button", {
    target: "e5mg7u0"
})("background:", (0, _colors.color_shades_darker), ";color:", (0, _colors.color_defaults_white), ";border:none;padding:4px 10px;border-radius:3px;cursor:pointer;font-size:12px;&:hover{opacity:0.9;}");
exports.default = /*#__PURE__*/ (0, _reactDefault.default).memo(OrganizationSection, (prevProps, nextProps)=>{
    // Custom comparator: skip re-render when the data this component uses hasn't changed.
    // revenueContainer is a class instance — same reference always — so we compare
    // the specific state slices this component reads.
    if (prevProps.isExpanded !== nextProps.isExpanded) return false;
    if (prevProps.isLoading !== nextProps.isLoading) return false;
    if (prevProps.orgRevenue !== nextProps.orgRevenue) return false;
    if (prevProps.orgConfig !== nextProps.orgConfig) return false;
    if (prevProps.clipboardConfig !== nextProps.clipboardConfig) return false;
    // Check the state slices this component reads from the container
    const prevOrgId = prevProps.orgConfig.organizationId;
    const nextOrgId = nextProps.orgConfig.organizationId;
    const prevContainer = prevProps.revenueContainer.state;
    const nextContainer = nextProps.revenueContainer.state;
    if (prevContainer.applicationsByOrg[prevOrgId] !== nextContainer.applicationsByOrg[nextOrgId]) return false;
    if (prevContainer.engagementsByOrg[prevOrgId] !== nextContainer.engagementsByOrg[nextOrgId]) return false;
    return true;
});

},{"@emotion/styled/base":"lSuFu","@emotion/react":"djZKr","react":"6uln9","./BillingConfigEditor":"jW9Pg","./RevenueTable":"ciVKI","../../../models/revenue/BillingConfig":"9NytT","../../../constants/colors":"1p3OR","../../../components/general/Loader":"bnV5T","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jW9Pg":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _base = require("@emotion/styled/base");
var _baseDefault = parcelHelpers.interopDefault(_base);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _tooltipWrapper = require("../../../components/general/TooltipWrapper");
var _tooltipWrapperDefault = parcelHelpers.interopDefault(_tooltipWrapper);
var _billingConfig = require("../../../models/revenue/BillingConfig");
var _colors = require("../../../constants/colors");
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const infoIcon = "ⓘ"; // Unicode circled info
const BillingConfigEditor = ({ config, onChange, title, onCopy, onPaste, onReset, compact, clipboardConfig })=>{
    const [isExpanded, setIsExpanded] = (0, _react1.useState)(!compact);
    const [inputValues, setInputValues] = (0, _react1.useState)({});
    const handleNumericChange = (field, value)=>{
        // Allow typing - store the raw input value
        setInputValues({
            ...inputValues,
            [field]: value
        });
        // Allow empty string
        if (value === "") {
            onChange({
                ...config,
                [field]: 0
            });
            return;
        }
        // Allow partial decimals like "5.", "0.", "12."
        if (value.endsWith(".")) // Don't update the config yet, just allow typing
        return;
        // Validate and parse the number
        const num = parseFloat(value);
        if (!isNaN(num) && num >= 0) onChange({
            ...config,
            [field]: num
        });
    // If invalid, don't update the config (but we already stored the input)
    };
    const getDisplayValue = (field)=>{
        // If we have a pending input value, use that
        if (inputValues[field] !== undefined) return inputValues[field];
        // Otherwise show the config value
        return String(config[field]);
    };
    const handleRoundingChange = (value)=>{
        onChange({
            ...config,
            roundingMethod: value
        });
    };
    const renderField = (field, label, prefix, suffix)=>{
        if (field === "roundingMethod") return (0, _react.jsx)(FieldRow, {
            key: field
        }, (0, _react.jsx)(FieldLabel, null, (0, _react.jsx)((0, _tooltipWrapperDefault.default), {
            text: (0, _billingConfig.BILLING_FIELD_DESCRIPTIONS)[field],
            place: "right",
            maxWidth: 300
        }, (0, _react.jsx)("span", null, label, " ", (0, _react.jsx)(InfoIcon, null, infoIcon)))), (0, _react.jsx)(SelectInput, {
            value: config.roundingMethod,
            onChange: (e)=>handleRoundingChange(e.target.value)
        }, Object.entries((0, _billingConfig.ROUNDING_METHOD_LABELS)).map(([key, lbl])=>(0, _react.jsx)("option", {
                key: key,
                value: key
            }, lbl))));
        return (0, _react.jsx)(FieldRow, {
            key: field
        }, (0, _react.jsx)(FieldLabel, null, (0, _react.jsx)((0, _tooltipWrapperDefault.default), {
            text: (0, _billingConfig.BILLING_FIELD_DESCRIPTIONS)[field],
            place: "right",
            maxWidth: 300
        }, (0, _react.jsx)("span", null, label, " ", (0, _react.jsx)(InfoIcon, null, infoIcon)))), (0, _react.jsx)(InputWrapper, null, prefix && (0, _react.jsx)(InputPrefix, null, prefix), (0, _react.jsx)(NumberInput, {
            type: "text",
            inputMode: "decimal",
            value: getDisplayValue(field),
            onChange: (e)=>handleNumericChange(field, e.target.value),
            onBlur: ()=>{
                // Clear the input value cache on blur to sync with config
                setInputValues({
                    ...inputValues,
                    [field]: undefined
                });
            },
            hasPrefix: !!prefix,
            hasSuffix: !!suffix
        }), suffix && (0, _react.jsx)(InputSuffix, null, suffix)));
    };
    return (0, _react.jsx)(Wrapper, null, title && (0, _react.jsx)(Header, {
        onClick: ()=>compact && setIsExpanded(!isExpanded)
    }, (0, _react.jsx)(Title, null, title), (0, _react.jsx)(HeaderActions, null, onCopy && (0, _react.jsx)(ActionButton, {
        onClick: (e)=>{
            e.stopPropagation();
            onCopy();
        },
        title: "Copy billing config to clipboard"
    }, "Copy"), onPaste && clipboardConfig && (0, _react.jsx)(ActionButton, {
        onClick: (e)=>{
            e.stopPropagation();
            onPaste(clipboardConfig);
        },
        title: "Paste billing config from clipboard"
    }, "Paste"), onReset && (0, _react.jsx)(ResetActionButton, {
        onClick: (e)=>{
            e.stopPropagation();
            onReset();
        },
        title: "Reset to defaults"
    }, "Reset"), compact && (0, _react.jsx)(ExpandIcon, null, isExpanded ? "▲" : "▼"))), isExpanded && (0, _react.jsx)(FieldsGrid, null, renderField("aiMinuteRate", "AI Minute Rate", "$"), renderField("postTransferMinuteRate", "Post-Transfer Minute Rate", "$"), renderField("minutesIncluded", "Minutes Included", undefined, "min"), renderField("callRate", "Per-Call Rate", "$"), renderField("callsIncluded", "Calls Included"), renderField("roundingMethod", "Rounding Method"), renderField("flatMonthlyFee", "Flat Monthly Fee", "$"), renderField("containedCallRate", "Contained Call Rate", "$"), renderField("nonContainableCallRate", "Non-Containable Call Rate", "$"), renderField("orderPlacedRate", "Order Placed Rate", "$")));
};
const Wrapper = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1d2p58715"
})("background:", (0, _colors.color_defaults_white), ";border:1px solid ", (0, _colors.color_shades_light), ";border-radius:6px;overflow:hidden;");
const Header = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1d2p58714"
})("display:flex;justify-content:space-between;align-items:center;padding:10px 14px;background:", (0, _colors.color_shades_lightest), ";cursor:pointer;user-select:none;border-bottom:1px solid ", (0, _colors.color_shades_light), ";");
const Title = /*#__PURE__*/ (0, _baseDefault.default)("span", {
    target: "e1d2p58713"
})("font-size:14px;font-weight:600;color:", (0, _colors.color_text_default), ";");
const HeaderActions = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1d2p58712"
})({
    name: "1rzhkq6",
    styles: "display:flex;gap:6px;align-items:center"
});
const ActionButton = /*#__PURE__*/ (0, _baseDefault.default)("button", {
    target: "e1d2p58711"
})("background:", (0, _colors.color_colors_ocean), ";color:", (0, _colors.color_defaults_white), ";border:none;padding:3px 10px;border-radius:3px;cursor:pointer;font-size:11px;&:hover{opacity:0.9;}");
const ResetActionButton = /*#__PURE__*/ (0, _baseDefault.default)(ActionButton, {
    target: "e1d2p58710"
})("background:", (0, _colors.color_colors_decline), ";");
const ExpandIcon = /*#__PURE__*/ (0, _baseDefault.default)("span", {
    target: "e1d2p5879"
})("font-size:10px;color:", (0, _colors.color_text_light), ";margin-left:4px;");
const FieldsGrid = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1d2p5878"
})({
    name: "lwt7gk",
    styles: "display:grid;grid-template-columns:1fr 1fr;gap:8px;padding:12px 14px;@media (max-width: 900px){grid-template-columns:1fr;}"
});
const FieldRow = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1d2p5877"
})({
    name: "1t85ozr",
    styles: "display:flex;flex-direction:column;gap:3px"
});
const FieldLabel = /*#__PURE__*/ (0, _baseDefault.default)("label", {
    target: "e1d2p5876"
})("font-size:12px;font-weight:500;color:", (0, _colors.color_text_light), ";");
const InfoIcon = /*#__PURE__*/ (0, _baseDefault.default)("span", {
    target: "e1d2p5875"
})("font-size:11px;color:", (0, _colors.color_colors_ocean), ";cursor:help;");
const InputWrapper = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e1d2p5874"
})("display:flex;align-items:center;border:1px solid ", (0, _colors.color_shades_dark), ";border-radius:4px;overflow:hidden;&:focus-within{border-color:", (0, _colors.color_colors_ocean), ";box-shadow:0 0 0 3px ", (0, _colors.color_variants_ocean_light_1), ";}");
const InputPrefix = /*#__PURE__*/ (0, _baseDefault.default)("span", {
    target: "e1d2p5873"
})("padding:6px 8px;background:", (0, _colors.color_shades_lightest), ";color:", (0, _colors.color_text_light), ";font-size:13px;border-right:1px solid ", (0, _colors.color_shades_dark), ";");
const InputSuffix = /*#__PURE__*/ (0, _baseDefault.default)("span", {
    target: "e1d2p5872"
})("padding:6px 8px;background:", (0, _colors.color_shades_lightest), ";color:", (0, _colors.color_text_light), ";font-size:13px;border-left:1px solid ", (0, _colors.color_shades_dark), ";");
const NumberInput = /*#__PURE__*/ (0, _baseDefault.default)("input", {
    target: "e1d2p5871"
})("flex:1;padding:6px 8px;border:none;font-size:14px;color:", (0, _colors.color_text_default), ";outline:none;min-width:60px;");
const SelectInput = /*#__PURE__*/ (0, _baseDefault.default)("select", {
    target: "e1d2p5870"
})("padding:6px 8px;border:1px solid ", (0, _colors.color_shades_dark), ";border-radius:4px;font-size:14px;color:", (0, _colors.color_text_default), ";background:", (0, _colors.color_defaults_white), ";cursor:pointer;&:focus{outline:none;border-color:", (0, _colors.color_colors_ocean), ";box-shadow:0 0 0 3px ", (0, _colors.color_variants_ocean_light_1), ";}");
exports.default = BillingConfigEditor;

},{"@emotion/styled/base":"lSuFu","@emotion/react":"djZKr","react":"6uln9","../../../components/general/TooltipWrapper":"53pWd","../../../models/revenue/BillingConfig":"9NytT","../../../constants/colors":"1p3OR","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"ciVKI":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _base = require("@emotion/styled/base");
var _baseDefault = parcelHelpers.interopDefault(_base);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _colors = require("../../../constants/colors");
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const formatCurrency = (value)=>{
    return new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD",
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    }).format(value);
};
const formatNumber = (value, decimals = 1)=>{
    return value.toLocaleString("en-US", {
        minimumFractionDigits: 0,
        maximumFractionDigits: decimals
    });
};
const RevenueTable = ({ orgRevenue, ignoredAppIds, onToggleIgnore, onEditOverride, hasOverride })=>{
    if (orgRevenue.applications.length === 0) return (0, _react.jsx)(EmptyState, null, "No billable applications found for this month.", ignoredAppIds.length > 0 && ` (${ignoredAppIds.length} applications are currently ignored)`);
    return (0, _react.jsx)(TableWrapper, null, (0, _react.jsx)(Table, null, (0, _react.jsx)("thead", null, (0, _react.jsx)("tr", null, (0, _react.jsx)(Th, null, "Application"), (0, _react.jsx)(Th, {
        align: "right"
    }, "Conversations"), (0, _react.jsx)(Th, {
        align: "right"
    }, "AI Min"), (0, _react.jsx)(Th, {
        align: "right"
    }, "PT Min"), (0, _react.jsx)(Th, {
        align: "right"
    }, "Calls"), (0, _react.jsx)(Th, {
        align: "right"
    }, "Contained"), (0, _react.jsx)(Th, {
        align: "right"
    }, "Non-Containable"), (0, _react.jsx)(Th, {
        align: "right"
    }, "Orders"), (0, _react.jsx)(Th, {
        align: "right"
    }, "Flat Fee"), (0, _react.jsx)(Th, {
        align: "right"
    }, "Total Revenue"), (0, _react.jsx)(Th, {
        align: "center"
    }, "Actions"))), (0, _react.jsx)("tbody", null, orgRevenue.applications.map((app)=>{
        const isIgnored = ignoredAppIds.includes(app.applicationId);
        const isOverridden = hasOverride(app.applicationId);
        return (0, _react.jsx)(Tr, {
            key: app.applicationId,
            isIgnored: isIgnored
        }, (0, _react.jsx)(TdName, null, (0, _react.jsx)(AppNameCell, null, (0, _react.jsx)(AppName, null, app.applicationName), isOverridden && (0, _react.jsx)(OverrideBadge, null, "Override"))), (0, _react.jsx)(Td, {
            align: "right"
        }, formatNumber(app.engagementCount, 0)), (0, _react.jsx)(Td, {
            align: "right"
        }, (0, _react.jsx)(MetricCell, null, (0, _react.jsx)(MetricCount, null, formatNumber(app.breakdown.aiMinutes.count)), (0, _react.jsx)(MetricRevenue, null, formatCurrency(app.breakdown.aiMinutes.revenue)))), (0, _react.jsx)(Td, {
            align: "right"
        }, (0, _react.jsx)(MetricCell, null, (0, _react.jsx)(MetricCount, null, formatNumber(app.breakdown.postTransferMinutes.count)), (0, _react.jsx)(MetricRevenue, null, formatCurrency(app.breakdown.postTransferMinutes.revenue)))), (0, _react.jsx)(Td, {
            align: "right"
        }, (0, _react.jsx)(MetricCell, null, (0, _react.jsx)(MetricCount, null, formatNumber(app.breakdown.calls.count, 0)), (0, _react.jsx)(MetricRevenue, null, formatCurrency(app.breakdown.calls.revenue)))), (0, _react.jsx)(Td, {
            align: "right"
        }, (0, _react.jsx)(MetricCell, null, (0, _react.jsx)(MetricCount, null, formatNumber(app.breakdown.containedCalls.count, 0)), (0, _react.jsx)(MetricRevenue, null, formatCurrency(app.breakdown.containedCalls.revenue)))), (0, _react.jsx)(Td, {
            align: "right"
        }, (0, _react.jsx)(MetricCell, null, (0, _react.jsx)(MetricCount, null, formatNumber(app.breakdown.nonContainableCalls.count, 0)), (0, _react.jsx)(MetricRevenue, null, formatCurrency(app.breakdown.nonContainableCalls.revenue)))), (0, _react.jsx)(Td, {
            align: "right"
        }, (0, _react.jsx)(MetricCell, null, (0, _react.jsx)(MetricCount, null, formatNumber(app.breakdown.ordersPlaced.count, 0)), (0, _react.jsx)(MetricRevenue, null, formatCurrency(app.breakdown.ordersPlaced.revenue)))), (0, _react.jsx)(Td, {
            align: "right"
        }, formatCurrency(app.breakdown.flatFee)), (0, _react.jsx)(TdTotal, {
            align: "right"
        }, formatCurrency(app.totalRevenue)), (0, _react.jsx)(Td, {
            align: "center"
        }, (0, _react.jsx)(ActionGroup, null, (0, _react.jsx)(SmallButton, {
            onClick: ()=>onEditOverride(app.applicationId),
            title: isOverridden ? "Edit billing override" : "Add billing override"
        }, isOverridden ? "Edit" : "Override"), (0, _react.jsx)(IgnoreButton, {
            isIgnored: isIgnored,
            onClick: ()=>onToggleIgnore(app.applicationId),
            title: isIgnored ? "Include this application" : "Ignore this application"
        }, isIgnored ? "Include" : "Ignore"))));
    })), (0, _react.jsx)("tfoot", null, (0, _react.jsx)(TotalRow, null, (0, _react.jsx)(Td, null, (0, _react.jsx)("strong", null, "Organization Total")), (0, _react.jsx)(Td, {
        align: "right"
    }, (0, _react.jsx)("strong", null, formatNumber(orgRevenue.applications.reduce((s, a)=>s + a.engagementCount, 0), 0))), (0, _react.jsx)(Td, {
        align: "right"
    }, (0, _react.jsx)("strong", null, formatCurrency(orgRevenue.applications.reduce((s, a)=>s + a.breakdown.aiMinutes.revenue, 0)))), (0, _react.jsx)(Td, {
        align: "right"
    }, (0, _react.jsx)("strong", null, formatCurrency(orgRevenue.applications.reduce((s, a)=>s + a.breakdown.postTransferMinutes.revenue, 0)))), (0, _react.jsx)(Td, {
        align: "right"
    }, (0, _react.jsx)("strong", null, formatCurrency(orgRevenue.applications.reduce((s, a)=>s + a.breakdown.calls.revenue, 0)))), (0, _react.jsx)(Td, {
        align: "right"
    }, (0, _react.jsx)("strong", null, formatCurrency(orgRevenue.applications.reduce((s, a)=>s + a.breakdown.containedCalls.revenue, 0)))), (0, _react.jsx)(Td, {
        align: "right"
    }, (0, _react.jsx)("strong", null, formatCurrency(orgRevenue.applications.reduce((s, a)=>s + a.breakdown.nonContainableCalls.revenue, 0)))), (0, _react.jsx)(Td, {
        align: "right"
    }, (0, _react.jsx)("strong", null, formatCurrency(orgRevenue.applications.reduce((s, a)=>s + a.breakdown.ordersPlaced.revenue, 0)))), (0, _react.jsx)(Td, {
        align: "right"
    }, (0, _react.jsx)("strong", null, formatCurrency(orgRevenue.applications.reduce((s, a)=>s + a.breakdown.flatFee, 0)))), (0, _react.jsx)(TdTotal, {
        align: "right"
    }, (0, _react.jsx)("strong", null, formatCurrency(orgRevenue.totalRevenue))), (0, _react.jsx)(Td, null)))));
};
const TableWrapper = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e9hr5xr17"
})("overflow-x:auto;border:1px solid ", (0, _colors.color_shades_light), ";border-radius:6px;");
const Table = /*#__PURE__*/ (0, _baseDefault.default)("table", {
    target: "e9hr5xr16"
})({
    name: "1ohk2vg",
    styles: "width:100%;border-collapse:collapse;font-size:13px"
});
const Th = /*#__PURE__*/ (0, _baseDefault.default)("th", {
    target: "e9hr5xr15"
})("padding:10px 8px;text-align:", (p)=>p.align || "left", ";font-size:11px;font-weight:600;color:", (0, _colors.color_text_light), ";text-transform:uppercase;letter-spacing:0.05em;background:", (0, _colors.color_shades_lightest), ";border-bottom:2px solid ", (0, _colors.color_shades_dark), ";white-space:nowrap;");
const Tr = /*#__PURE__*/ (0, _baseDefault.default)("tr", {
    target: "e9hr5xr14"
})("opacity:", (p)=>p.isIgnored ? 0.4 : 1, ";text-decoration:", (p)=>p.isIgnored ? "line-through" : "none", ";&:hover{background:", (0, _colors.color_shades_lightest), ";}&:not(:last-child) td{border-bottom:1px solid ", (0, _colors.color_shades_light), ";}");
const Td = /*#__PURE__*/ (0, _baseDefault.default)("td", {
    target: "e9hr5xr13"
})("padding:8px;text-align:", (p)=>p.align || "left", ";color:", (0, _colors.color_text_default), ";white-space:nowrap;");
const TdName = /*#__PURE__*/ (0, _baseDefault.default)("td", {
    target: "e9hr5xr12"
})("padding:8px;text-align:left;color:", (0, _colors.color_text_default), ";");
const TdTotal = /*#__PURE__*/ (0, _baseDefault.default)(Td, {
    target: "e9hr5xr11"
})("font-weight:600;color:", (0, _colors.color_colors_growth), ";");
const TotalRow = /*#__PURE__*/ (0, _baseDefault.default)("tr", {
    target: "e9hr5xr10"
})("background:", (0, _colors.color_shades_lightest), ";td{border-top:2px solid ", (0, _colors.color_shades_dark), ";padding:10px 8px;}");
const AppNameCell = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e9hr5xr9"
})({
    name: "1pi78hi",
    styles: "display:flex;align-items:center;gap:6px"
});
const AppName = /*#__PURE__*/ (0, _baseDefault.default)("span", {
    target: "e9hr5xr8"
})({
    name: "f3vz0n",
    styles: "font-weight:500"
});
const OverrideBadge = /*#__PURE__*/ (0, _baseDefault.default)("span", {
    target: "e9hr5xr7"
})("font-size:10px;padding:1px 5px;border-radius:3px;background:", (0, _colors.color_colors_ocean), ";color:", (0, _colors.color_defaults_white), ";font-weight:500;");
const MetricCell = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e9hr5xr6"
})({
    name: "16mxts1",
    styles: "display:flex;flex-direction:column;align-items:flex-end;gap:1px"
});
const MetricCount = /*#__PURE__*/ (0, _baseDefault.default)("span", {
    target: "e9hr5xr5"
})("font-size:12px;color:", (0, _colors.color_text_light), ";");
const MetricRevenue = /*#__PURE__*/ (0, _baseDefault.default)("span", {
    target: "e9hr5xr4"
})({
    name: "43v6to",
    styles: "font-size:13px;font-weight:500"
});
const ActionGroup = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e9hr5xr3"
})({
    name: "1s8rng8",
    styles: "display:flex;gap:4px;justify-content:center"
});
const SmallButton = /*#__PURE__*/ (0, _baseDefault.default)("button", {
    target: "e9hr5xr2"
})("padding:3px 8px;font-size:11px;border:1px solid ", (0, _colors.color_colors_ocean), ";color:", (0, _colors.color_colors_ocean), ";background:transparent;border-radius:3px;cursor:pointer;white-space:nowrap;&:hover{background:", (0, _colors.color_colors_ocean), ";color:", (0, _colors.color_defaults_white), ";}");
const IgnoreButton = /*#__PURE__*/ (0, _baseDefault.default)("button", {
    target: "e9hr5xr1"
})("padding:3px 8px;font-size:11px;border:1px solid ", (p)=>p.isIgnored ? (0, _colors.color_colors_growth) : (0, _colors.color_colors_decline), ";color:", (p)=>p.isIgnored ? (0, _colors.color_colors_growth) : (0, _colors.color_colors_decline), ";background:transparent;border-radius:3px;cursor:pointer;white-space:nowrap;&:hover{background:", (p)=>p.isIgnored ? (0, _colors.color_colors_growth) : (0, _colors.color_colors_decline), ";color:", (0, _colors.color_defaults_white), ";}");
const EmptyState = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e9hr5xr0"
})("padding:24px;text-align:center;color:", (0, _colors.color_text_light), ";font-style:italic;");
exports.default = /*#__PURE__*/ (0, _reactDefault.default).memo(RevenueTable);

},{"@emotion/styled/base":"lSuFu","@emotion/react":"djZKr","react":"6uln9","../../../constants/colors":"1p3OR","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3ySUG":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _base = require("@emotion/styled/base");
var _baseDefault = parcelHelpers.interopDefault(_base);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _projectionsTable = require("./ProjectionsTable");
var _projectionsTableDefault = parcelHelpers.interopDefault(_projectionsTable);
var _projectionsChart = require("./ProjectionsChart");
var _projectionsChartDefault = parcelHelpers.interopDefault(_projectionsChart);
var _billingConfig = require("../../../models/revenue/BillingConfig");
var _colors = require("../../../constants/colors");
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const ProjectionsTab = ({ revenueContainer })=>{
    const orgConfigs = revenueContainer.state.revenueConfig.organizations;
    const projections = revenueContainer.state.revenueConfig.projections;
    const projectedRevenue = revenueContainer.state.projectedRevenueByOrg;
    // Initialize default projections once on mount (or when org count changes)
    // using a single batched setState call to avoid cascading re-renders.
    (0, _react1.useEffect)(()=>{
        if (orgConfigs.length === 0) return;
        const currentProjections = revenueContainer.state.revenueConfig.projections;
        const orgIdsNeedingInit = [];
        for (const orgConfig of orgConfigs){
            const orgProjection = currentProjections?.organizationProjections.find((op)=>op.organizationId === orgConfig.organizationId);
            if (!orgProjection || orgProjection.monthlyProjections.length === 0) orgIdsNeedingInit.push(orgConfig.organizationId);
        }
        // Single batched call — handles both init and calculate in one setState
        revenueContainer.initializeAllMissingProjections(orgIdsNeedingInit);
    }, [
        orgConfigs.length
    ]);
    const handleUpdateProjection = (0, _react1.useCallback)((orgId, month, locationCount)=>{
        revenueContainer.updateProjection(orgId, month, locationCount);
    }, [
        revenueContainer
    ]);
    const handleAddMonth = (0, _react1.useCallback)((orgId)=>{
        revenueContainer.addProjectionMonth(orgId);
    }, [
        revenueContainer
    ]);
    const handleRemoveMonth = (0, _react1.useCallback)((orgId, month)=>{
        revenueContainer.removeProjectionMonth(orgId, month);
    }, [
        revenueContainer
    ]);
    const handleInitialize = (0, _react1.useCallback)((orgId)=>{
        revenueContainer.initializeDefaultProjections(orgId);
    }, [
        revenueContainer
    ]);
    const handleClearProjections = (0, _react1.useCallback)((orgId)=>{
        revenueContainer.clearProjections(orgId);
    }, [
        revenueContainer
    ]);
    if (orgConfigs.length === 0) return (0, _react.jsx)(EmptyState, null, (0, _react.jsx)(EmptyTitle, null, "No organizations configured"), (0, _react.jsx)(EmptyDescription, null, 'Go to the Revenue tab and click "Settings" to add organizations first. Projections are based on your revenue configuration.'));
    const hasRevenueData = revenueContainer.state.revenueByOrg.length > 0;
    // Compute total projected revenue across all orgs for each month
    const allMonths = revenueContainer.getAllProjectionMonths();
    let totalProjected = 0;
    for (const orgProj of projectedRevenue)for (const mp of orgProj.monthlyProjections)totalProjected += mp.projectedRevenue;
    const contractTypeGroups = groupOrgsByContractType(orgConfigs);
    const showGroupHeaders = contractTypeGroups.length > 1 || contractTypeGroups.length === 1 && contractTypeGroups[0].contractType !== null;
    return (0, _react.jsx)(Container, null, (0, _react.jsx)(Header, null, (0, _react.jsx)(HeaderLeft, null, (0, _react.jsx)("h1", null, "Revenue Projections"), totalProjected > 0 && (0, _react.jsx)(TotalBadge, null, "Total Projected: ", formatCurrency(totalProjected), allMonths.length > 0 && (0, _react.jsx)(MonthRange, null, "(", allMonths[0], " to ", allMonths[allMonths.length - 1], ")")))), !hasRevenueData && (0, _react.jsx)(InfoPanel, null, "Revenue data has not been loaded yet. Load data from the Revenue tab to get accurate average revenue per location calculations. Without revenue data, projections will show $0."), (0, _react.jsx)((0, _projectionsChartDefault.default), {
        projectedRevenueByOrg: projectedRevenue,
        allMonths: allMonths
    }), contractTypeGroups.map((group)=>{
        const groupKey = group.contractType || "__uncategorized__";
        const groupProjectedTotal = group.orgs.reduce((sum, orgConfig)=>{
            const orgProj = projectedRevenue.find((r)=>r.organizationId === orgConfig.organizationId);
            if (!orgProj) return sum;
            return sum + orgProj.monthlyProjections.reduce((s, mp)=>s + mp.projectedRevenue, 0);
        }, 0);
        return (0, _react.jsx)(ContractTypeGroup, {
            key: groupKey
        }, showGroupHeaders && (0, _react.jsx)(ContractTypeHeader, null, (0, _react.jsx)(ContractTypeLabel, null, group.contractType || "Uncategorized"), (0, _react.jsx)(ContractTypeCount, null, group.orgs.length, " org", group.orgs.length !== 1 ? "s" : ""), groupProjectedTotal > 0 && (0, _react.jsx)(ContractTypeRevenue, null, formatCurrency(groupProjectedTotal))), group.orgs.map((orgConfig)=>{
            const orgProjected = projectedRevenue.find((r)=>r.organizationId === orgConfig.organizationId);
            const orgProjectionConfig = projections?.organizationProjections.find((op)=>op.organizationId === orgConfig.organizationId);
            return (0, _react.jsx)(OrgSection, {
                key: orgConfig.organizationId
            }, (0, _react.jsx)(OrgHeader, null, (0, _react.jsx)(OrgNameRow, null, (0, _react.jsx)(OrgName, null, orgConfig.organizationName || orgConfig.organizationId), orgConfig.contractStatus && (0, _react.jsx)(ContractStatusBadge, {
                status: orgConfig.contractStatus
            }, orgConfig.contractStatus), orgProjectionConfig && orgProjectionConfig.monthlyProjections.length > 0 && (0, _react.jsx)(ClearButton, {
                onClick: ()=>handleClearProjections(orgConfig.organizationId),
                title: "Clear all projections for this organization"
            }, "Clear")), (0, _react.jsx)(OrgStats, null, (0, _react.jsx)(StatItem, null, (0, _react.jsx)(StatLabel, null, "Current Locations"), (0, _react.jsx)(StatValue, null, orgProjected?.currentLocationCount ?? 0)), orgConfig.totalPossibleLocations != null && (0, _react.jsx)(StatItem, null, (0, _react.jsx)(StatLabel, null, "Total Possible"), (0, _react.jsx)(StatValue, null, orgConfig.totalPossibleLocations)), (0, _react.jsx)(StatItem, null, (0, _react.jsx)(StatLabel, null, "Avg Revenue / Location"), (0, _react.jsx)(StatValue, null, formatCurrency(orgProjected?.averageRevenuePerLocation ?? 0))))), (0, _react.jsx)((0, _projectionsTableDefault.default), {
                orgId: orgConfig.organizationId,
                monthlyProjections: orgProjectionConfig?.monthlyProjections || [],
                projectedRevenue: orgProjected?.monthlyProjections || [],
                averageRevenuePerLocation: orgProjected?.averageRevenuePerLocation ?? 0,
                onUpdateProjection: handleUpdateProjection,
                onAddMonth: handleAddMonth,
                onRemoveMonth: handleRemoveMonth,
                onInitialize: handleInitialize
            }));
        }));
    }));
};
const sortOrgsByName = (orgs)=>orgs.slice().sort((a, b)=>{
        const nameA = (a.organizationName || a.organizationId).toLowerCase();
        const nameB = (b.organizationName || b.organizationId).toLowerCase();
        return nameA.localeCompare(nameB);
    });
const groupOrgsByContractType = (orgs)=>{
    const groups = [];
    for (const ct of (0, _billingConfig.CONTRACT_TYPES)){
        const matching = orgs.filter((o)=>o.contractType === ct);
        if (matching.length > 0) groups.push({
            contractType: ct,
            orgs: sortOrgsByName(matching)
        });
    }
    const uncategorized = orgs.filter((o)=>!o.contractType);
    if (uncategorized.length > 0) groups.push({
        contractType: null,
        orgs: sortOrgsByName(uncategorized)
    });
    return groups;
};
const formatCurrency = (value)=>{
    return new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD",
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    }).format(value);
};
const Container = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "eesogzm23"
})("");
const Header = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "eesogzm22"
})("display:flex;justify-content:space-between;align-items:center;margin-bottom:20px;h1{margin:0;color:", (0, _colors.color_text_default), ";font-size:24px;}");
const HeaderLeft = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "eesogzm21"
})({
    name: "1wcglds",
    styles: "display:flex;align-items:center;gap:16px"
});
const TotalBadge = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "eesogzm20"
})("font-size:16px;font-weight:700;color:", (0, _colors.color_colors_growth), ";background:rgba(88, 189, 153, 0.1);padding:6px 16px;border-radius:6px;display:flex;align-items:center;gap:8px;");
const MonthRange = /*#__PURE__*/ (0, _baseDefault.default)("span", {
    target: "eesogzm19"
})("font-size:12px;font-weight:400;color:", (0, _colors.color_text_light), ";");
const InfoPanel = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "eesogzm18"
})("background:rgba(30, 126, 185, 0.08);border:1px solid ", (0, _colors.color_colors_ocean), ";border-radius:6px;padding:12px 16px;margin-bottom:20px;font-size:13px;color:", (0, _colors.color_colors_ocean), ";");
const OrgSection = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "eesogzm17"
})("background:", (0, _colors.color_shades_lightest), ";border:1px solid ", (0, _colors.color_shades_light), ";border-radius:8px;padding:20px;margin-bottom:16px;");
const OrgHeader = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "eesogzm16"
})({
    name: "2ptt9o",
    styles: "display:flex;justify-content:space-between;align-items:center;margin-bottom:16px"
});
const OrgName = /*#__PURE__*/ (0, _baseDefault.default)("h2", {
    target: "eesogzm15"
})("margin:0;font-size:18px;color:", (0, _colors.color_text_default), ";");
const OrgNameRow = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "eesogzm14"
})({
    name: "uh5xjc",
    styles: "display:flex;align-items:center;gap:12px"
});
const ClearButton = /*#__PURE__*/ (0, _baseDefault.default)("button", {
    target: "eesogzm13"
})("background:none;border:1px solid ", (0, _colors.dark_red), ";color:", (0, _colors.dark_red), ";font-size:12px;padding:4px 12px;border-radius:4px;cursor:pointer;transition:background 0.15s,color 0.15s;&:hover{background:", (0, _colors.dark_red), ";color:", (0, _colors.color_defaults_white), ";}");
const ContractStatusBadge = /*#__PURE__*/ (0, _baseDefault.default)("span", {
    target: "eesogzm12"
})("font-size:11px;font-weight:600;padding:3px 8px;border-radius:3px;color:", ({ status })=>status === "Won" ? (0, _colors.color_colors_growth) : (0, _colors.color_colors_ocean), ";background:", ({ status })=>status === "Won" ? "rgba(88, 189, 153, 0.1)" : "rgba(30, 126, 185, 0.1)", ";");
const OrgStats = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "eesogzm11"
})({
    name: "o72efq",
    styles: "display:flex;gap:24px"
});
const StatItem = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "eesogzm10"
})({
    name: "2qga7i",
    styles: "text-align:right"
});
const StatLabel = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "eesogzm9"
})("font-size:11px;color:", (0, _colors.color_text_light), ";text-transform:uppercase;letter-spacing:0.5px;");
const StatValue = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "eesogzm8"
})("font-size:16px;font-weight:600;color:", (0, _colors.color_text_default), ";");
const EmptyState = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "eesogzm7"
})({
    name: "zx0ln1",
    styles: "text-align:center;padding:60px 24px"
});
const EmptyTitle = /*#__PURE__*/ (0, _baseDefault.default)("h2", {
    target: "eesogzm6"
})("color:", (0, _colors.color_text_default), ";margin:0 0 8px 0;");
const EmptyDescription = /*#__PURE__*/ (0, _baseDefault.default)("p", {
    target: "eesogzm5"
})("color:", (0, _colors.color_text_light), ";font-size:14px;max-width:400px;margin:0 auto;");
const ContractTypeGroup = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "eesogzm4"
})({
    name: "5bhc30",
    styles: "margin-bottom:8px"
});
const ContractTypeHeader = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "eesogzm3"
})("display:flex;align-items:center;gap:12px;padding:10px 0 8px 0;margin-bottom:4px;border-bottom:2px solid ", (0, _colors.color_shades_light), ";");
const ContractTypeLabel = /*#__PURE__*/ (0, _baseDefault.default)("span", {
    target: "eesogzm2"
})("font-size:14px;font-weight:700;color:", (0, _colors.color_shades_darker), ";text-transform:uppercase;letter-spacing:0.5px;");
const ContractTypeCount = /*#__PURE__*/ (0, _baseDefault.default)("span", {
    target: "eesogzm1"
})("font-size:12px;color:", (0, _colors.color_text_light), ";");
const ContractTypeRevenue = /*#__PURE__*/ (0, _baseDefault.default)("span", {
    target: "eesogzm0"
})("font-size:13px;font-weight:600;color:", (0, _colors.color_colors_growth), ";margin-left:auto;");
exports.default = ProjectionsTab;

},{"@emotion/styled/base":"lSuFu","@emotion/react":"djZKr","react":"6uln9","./ProjectionsTable":"6wpc3","./ProjectionsChart":"1Z0yz","../../../models/revenue/BillingConfig":"9NytT","../../../constants/colors":"1p3OR","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6wpc3":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _base = require("@emotion/styled/base");
var _baseDefault = parcelHelpers.interopDefault(_base);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _moment = require("moment");
var _momentDefault = parcelHelpers.interopDefault(_moment);
var _colors = require("../../../constants/colors");
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const ProjectionsTable = ({ orgId, monthlyProjections, projectedRevenue, averageRevenuePerLocation, onUpdateProjection, onAddMonth, onRemoveMonth, onInitialize })=>{
    const handleLocationCountChange = (0, _react1.useCallback)((month, value)=>{
        const parsed = parseInt(value, 10);
        if (!isNaN(parsed) && parsed >= 0) onUpdateProjection(orgId, month, parsed);
    }, [
        orgId,
        onUpdateProjection
    ]);
    if (monthlyProjections.length === 0) return (0, _react.jsx)(EmptyTableState, null, (0, _react.jsx)("p", null, "No projections configured for this organization."), (0, _react.jsx)(InitButton, {
        onClick: ()=>onInitialize(orgId)
    }, "Initialize 12-Month Projection"));
    const formatMonth = (monthStr)=>{
        return (0, _momentDefault.default)(monthStr, "YYYY-MM").format("MMM YYYY");
    };
    const getProjectedRevenueForMonth = (month)=>{
        const pr = projectedRevenue.find((p)=>p.month === month);
        return pr ? pr.projectedRevenue : 0;
    };
    const totalProjectedRevenue = projectedRevenue.reduce((sum, pr)=>sum + pr.projectedRevenue, 0);
    return (0, _react.jsx)(TableContainer, null, (0, _react.jsx)(ScrollWrapper, null, (0, _react.jsx)(Table, null, (0, _react.jsx)("thead", null, (0, _react.jsx)("tr", null, (0, _react.jsx)(HeaderCell, {
        sticky: true
    }, "Metric"), monthlyProjections.map((mp)=>(0, _react.jsx)(HeaderCell, {
            key: mp.month
        }, (0, _react.jsx)(MonthHeader, null, (0, _react.jsx)("span", null, formatMonth(mp.month)), (0, _react.jsx)(RemoveButton, {
            onClick: ()=>onRemoveMonth(orgId, mp.month),
            title: "Remove this month"
        }, "x")))), (0, _react.jsx)(HeaderCell, null, (0, _react.jsx)(AddMonthButton, {
        onClick: ()=>onAddMonth(orgId),
        title: "Add another month"
    }, "+")), (0, _react.jsx)(HeaderCell, {
        sticky: true,
        right: true
    }, "Total"))), (0, _react.jsx)("tbody", null, (0, _react.jsx)("tr", null, (0, _react.jsx)(DataCell, {
        sticky: true,
        label: true
    }, "Location Count"), monthlyProjections.map((mp)=>(0, _react.jsx)(DataCell, {
            key: mp.month
        }, (0, _react.jsx)(LocationInput, {
            type: "number",
            min: "0",
            step: "1",
            value: mp.locationCount,
            onChange: (e)=>handleLocationCountChange(mp.month, e.target.value)
        }))), (0, _react.jsx)(DataCell, null), (0, _react.jsx)(DataCell, {
        sticky: true,
        right: true,
        label: true
    }, "-")), (0, _react.jsx)("tr", null, (0, _react.jsx)(DataCell, {
        sticky: true,
        label: true
    }, "Avg Rev / Location"), monthlyProjections.map((mp)=>(0, _react.jsx)(DataCell, {
            key: mp.month,
            muted: true
        }, formatCurrency(averageRevenuePerLocation))), (0, _react.jsx)(DataCell, null), (0, _react.jsx)(DataCell, {
        sticky: true,
        right: true,
        muted: true
    }, formatCurrency(averageRevenuePerLocation))), (0, _react.jsx)("tr", null, (0, _react.jsx)(DataCell, {
        sticky: true,
        label: true
    }, "Projected Revenue"), monthlyProjections.map((mp)=>(0, _react.jsx)(DataCell, {
            key: mp.month,
            revenue: true
        }, formatCurrency(getProjectedRevenueForMonth(mp.month)))), (0, _react.jsx)(DataCell, null), (0, _react.jsx)(DataCell, {
        sticky: true,
        right: true,
        revenue: true
    }, formatCurrency(totalProjectedRevenue)))))));
};
const formatCurrency = (value)=>{
    return new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD",
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    }).format(value);
};
const TableContainer = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e19mmzz710"
})({
    name: "hkh81z",
    styles: "margin-top:8px"
});
const ScrollWrapper = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e19mmzz79"
})("overflow-x:auto;border:1px solid ", (0, _colors.color_shades_light), ";border-radius:6px;");
const Table = /*#__PURE__*/ (0, _baseDefault.default)("table", {
    target: "e19mmzz78"
})({
    name: "gim41y",
    styles: "width:100%;border-collapse:collapse;min-width:600px;font-size:13px"
});
const HeaderCell = /*#__PURE__*/ (0, _baseDefault.default)("th", {
    target: "e19mmzz77"
})("padding:10px 12px;text-align:center;font-size:12px;font-weight:600;color:", (0, _colors.color_text_light), ";text-transform:uppercase;letter-spacing:0.3px;border-bottom:2px solid ", (0, _colors.color_shades_light), ";background:", (0, _colors.color_defaults_white), ";white-space:nowrap;", (props)=>props.sticky && `
        position: sticky;
        ${props.right ? "right: 0;" : "left: 0;"}
        z-index: 2;
        background: ${0, _colors.color_defaults_white};
        border-${props.right ? "left" : "right"}: 2px solid ${0, _colors.color_shades_light};
    `, ";");
const DataCell = /*#__PURE__*/ (0, _baseDefault.default)("td", {
    target: "e19mmzz76"
})("padding:8px 12px;text-align:center;border-bottom:1px solid ", (0, _colors.color_shades_light), ";background:", (0, _colors.color_defaults_white), ";white-space:nowrap;", (props)=>props.sticky && `
        position: sticky;
        ${props.right ? "right: 0;" : "left: 0;"}
        z-index: 1;
        background: ${0, _colors.color_defaults_white};
        border-${props.right ? "left" : "right"}: 2px solid ${0, _colors.color_shades_light};
    `, " ", (props)=>props.label && `
        text-align: left;
        font-weight: 600;
        color: ${0, _colors.color_text_default};
    `, " ", (props)=>props.muted && `
        color: ${0, _colors.color_text_light};
        font-size: 12px;
    `, " ", (props)=>props.revenue && `
        font-weight: 600;
        color: ${0, _colors.color_colors_growth};
    `, ";");
const MonthHeader = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e19mmzz75"
})({
    name: "mm0gtz",
    styles: "display:flex;align-items:center;justify-content:center;gap:6px"
});
const RemoveButton = /*#__PURE__*/ (0, _baseDefault.default)("button", {
    target: "e19mmzz74"
})("background:none;border:none;color:", (0, _colors.color_colors_decline), ";cursor:pointer;font-size:12px;font-weight:700;padding:0 4px;line-height:1;opacity:0.5;&:hover{opacity:1;}");
const AddMonthButton = /*#__PURE__*/ (0, _baseDefault.default)("button", {
    target: "e19mmzz73"
})("background:", (0, _colors.color_colors_ocean), ";color:", (0, _colors.color_defaults_white), ";border:none;border-radius:4px;width:28px;height:28px;cursor:pointer;font-size:16px;font-weight:700;display:flex;align-items:center;justify-content:center;&:hover{opacity:0.9;}");
const LocationInput = /*#__PURE__*/ (0, _baseDefault.default)("input", {
    target: "e19mmzz72"
})("width:70px;padding:4px 8px;border:1px solid ", (0, _colors.color_shades_light), ";border-radius:4px;font-size:13px;text-align:center;color:", (0, _colors.color_text_default), ";&:focus{outline:none;border-color:", (0, _colors.color_colors_ocean), ";}&::-webkit-inner-spin-button,&::-webkit-outer-spin-button{-webkit-appearance:none;margin:0;}-moz-appearance:textfield;");
const EmptyTableState = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e19mmzz71"
})("text-align:center;padding:24px;color:", (0, _colors.color_text_light), ";font-size:14px;p{margin:0 0 12px 0;}");
const InitButton = /*#__PURE__*/ (0, _baseDefault.default)("button", {
    target: "e19mmzz70"
})("background:", (0, _colors.color_colors_ocean), ";color:", (0, _colors.color_defaults_white), ";border:none;padding:8px 16px;border-radius:6px;cursor:pointer;font-size:13px;&:hover{opacity:0.9;}");
exports.default = /*#__PURE__*/ (0, _reactDefault.default).memo(ProjectionsTable);

},{"@emotion/styled/base":"lSuFu","@emotion/react":"djZKr","react":"6uln9","moment":"2meyw","../../../constants/colors":"1p3OR","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1Z0yz":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _base = require("@emotion/styled/base");
var _baseDefault = parcelHelpers.interopDefault(_base);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _line = require("@nivo/line");
var _moment = require("moment");
var _momentDefault = parcelHelpers.interopDefault(_moment);
var _chartTheme = require("../../../constants/chartTheme");
var _colors = require("../../../constants/colors");
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const ProjectionsChart = ({ projectedRevenueByOrg, allMonths })=>{
    if (allMonths.length === 0 || projectedRevenueByOrg.length === 0) return null;
    const hasData = projectedRevenueByOrg.some((org)=>org.monthlyProjections.length > 0);
    if (!hasData) return null;
    const colors = (0, _chartTheme.chartSequentialBlues) || [
        "#1E7EB9",
        "#2196F3",
        "#42A5F5",
        "#64B5F6",
        "#90CAF9",
        "#BBDEFB"
    ];
    // --- Total revenue line data ---
    const totalByMonth = {};
    for (const org of projectedRevenueByOrg)for (const mp of org.monthlyProjections){
        const key = (0, _momentDefault.default)(mp.month, "YYYY-MM").format("MMM YY");
        totalByMonth[key] = (totalByMonth[key] || 0) + mp.projectedRevenue;
    }
    const totalLineData = [
        {
            id: "Total Projected Revenue",
            color: "#2D2D39",
            data: allMonths.map((month)=>({
                    x: (0, _momentDefault.default)(month, "YYYY-MM").format("MMM YY"),
                    y: Math.round((totalByMonth[(0, _momentDefault.default)(month, "YYYY-MM").format("MMM YY")] || 0) * 100) / 100
                }))
        }
    ];
    // --- Per-client line data ---
    const clientLineData = projectedRevenueByOrg.filter((org)=>org.monthlyProjections.length > 0).map((org, index)=>({
            id: org.organizationName,
            color: colors[index % colors.length],
            data: org.monthlyProjections.map((mp)=>({
                    x: (0, _momentDefault.default)(mp.month, "YYYY-MM").format("MMM YY"),
                    y: Math.round(mp.projectedRevenue * 100) / 100
                }))
        }));
    const chartTheme = {
        ...(0, _chartTheme.nivoChartTheme),
        background: "#ffffff"
    };
    const renderChart = (data, title)=>(0, _react.jsx)(ChartPanel, null, (0, _react.jsx)(ChartTitle, null, title), (0, _react.jsx)(ChartWrapper, null, (0, _react.jsx)((0, _line.ResponsiveLine), {
            data: data,
            enableArea: true,
            areaOpacity: 0.06,
            animate: false,
            curve: "monotoneX",
            enableGridX: false,
            colors: (series)=>series.color,
            lineWidth: 2.5,
            pointSize: 6,
            pointBorderColor: (0, _colors.color_defaults_white),
            pointBorderWidth: 1.5,
            pointColor: (point)=>point.serieColor,
            useMesh: true,
            enableSlices: "x",
            sliceTooltip: ({ slice })=>(0, _react.jsx)(TooltipContainer, null, (0, _react.jsx)(TooltipTitle, null, slice.points[0]?.data.xFormatted), slice.points.map((point)=>(0, _react.jsx)(TooltipRow, {
                        key: point.id
                    }, (0, _react.jsx)(TooltipColorDot, {
                        style: {
                            background: point.serieColor
                        }
                    }), (0, _react.jsx)(TooltipLabel, null, point.serieId), (0, _react.jsx)(TooltipValue, null, formatCurrency(point.data.yFormatted))))),
            margin: {
                top: 20,
                right: 20,
                bottom: 50,
                left: 70
            },
            axisTop: null,
            axisRight: null,
            axisBottom: {
                tickSize: 0,
                tickPadding: 8,
                tickRotation: -45
            },
            axisLeft: {
                tickSize: 0,
                tickPadding: 8,
                tickRotation: 0,
                format: (value)=>formatCompactCurrency(value)
            },
            theme: chartTheme,
            legends: []
        })), (0, _react.jsx)(LegendContainer, null, data.map((series)=>(0, _react.jsx)(LegendItem, {
                key: series.id
            }, (0, _react.jsx)(LegendDot, {
                style: {
                    background: series.color
                }
            }), (0, _react.jsx)(LegendLabel, null, series.id)))));
    return (0, _react.jsx)(ChartsRow, null, renderChart(totalLineData, "Total Projected Revenue"), renderChart(clientLineData, "Projected Revenue by Client"));
};
const formatCurrency = (value)=>{
    return new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD",
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    }).format(value);
};
const formatCompactCurrency = (value)=>{
    if (value >= 1000000) return `$${(value / 1000000).toFixed(1)}M`;
    if (value >= 1000) return `$${(value / 1000).toFixed(0)}K`;
    return `$${value}`;
};
const ChartsRow = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e6lybz113"
})({
    name: "1emkx9l",
    styles: "display:flex;gap:16px;margin-bottom:24px"
});
const ChartPanel = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e6lybz112"
})("flex:1;min-width:0;background:", (0, _colors.color_defaults_white), ";border:1px solid ", (0, _colors.color_shades_light), ";border-radius:8px;padding:20px;");
const ChartTitle = /*#__PURE__*/ (0, _baseDefault.default)("h3", {
    target: "e6lybz111"
})("margin:0 0 16px 0;font-size:14px;color:", (0, _colors.color_text_default), ";");
const ChartWrapper = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e6lybz110"
})({
    name: "1gfe5of",
    styles: "height:350px"
});
const LegendContainer = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e6lybz19"
})({
    name: "5zop49",
    styles: "display:flex;gap:12px;justify-content:center;flex-wrap:wrap;margin-top:12px"
});
const LegendItem = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e6lybz18"
})({
    name: "1pi78hi",
    styles: "display:flex;align-items:center;gap:6px"
});
const LegendDot = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e6lybz17"
})({
    name: "hw5pzn",
    styles: "width:10px;height:10px;border-radius:2px"
});
const LegendLabel = /*#__PURE__*/ (0, _baseDefault.default)("span", {
    target: "e6lybz16"
})("font-size:11px;color:", (0, _colors.color_text_light), ";");
const TooltipContainer = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e6lybz15"
})("background:rgba(255, 255, 255, 0.95);backdrop-filter:blur(8px);padding:12px 16px;border-radius:8px;box-shadow:0 4px 16px rgba(0, 0, 0, 0.12);border:1px solid ", (0, _colors.color_shades_light), ";min-width:160px;");
const TooltipTitle = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e6lybz14"
})("font-weight:600;margin-bottom:8px;color:", (0, _colors.color_text_default), ";font-size:13px;");
const TooltipRow = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e6lybz13"
})({
    name: "ku7goz",
    styles: "display:flex;align-items:center;gap:8px;margin-bottom:4px;&:last-child{margin-bottom:0;}"
});
const TooltipColorDot = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e6lybz12"
})({
    name: "19tzyd4",
    styles: "width:10px;height:10px;border-radius:2px;flex-shrink:0"
});
const TooltipLabel = /*#__PURE__*/ (0, _baseDefault.default)("span", {
    target: "e6lybz11"
})("font-size:12px;color:", (0, _colors.color_text_light), ";flex:1;");
const TooltipValue = /*#__PURE__*/ (0, _baseDefault.default)("span", {
    target: "e6lybz10"
})("font-size:13px;font-weight:600;color:", (0, _colors.color_text_default), ";");
exports.default = /*#__PURE__*/ (0, _reactDefault.default).memo(ProjectionsChart);

},{"@emotion/styled/base":"lSuFu","@emotion/react":"djZKr","react":"6uln9","@nivo/line":"aa8Vk","moment":"2meyw","../../../constants/chartTheme":"1MLTJ","../../../constants/colors":"1p3OR","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"f63Qq":[function(require,module,exports) {
module.exports = require("ab5dd229f16a0671").getBundleURL("kVLro") + require("5994a7c1bb7bf50f").resolve("2uEnH");

},{"ab5dd229f16a0671":"c7Tr5","5994a7c1bb7bf50f":"fyJL2"}],"dwJHc":[function(require,module,exports) {
module.exports = require("be722a6b8c3ed78e").getBundleURL("kVLro") + require("8d45eafe5877d0c7").resolve("ifJ6S");

},{"be722a6b8c3ed78e":"c7Tr5","8d45eafe5877d0c7":"fyJL2"}],"8y8tE":[function(require,module,exports) {
module.exports = require("bb02f9a317b5e1f4").getBundleURL("kVLro") + require("503575c6e6542d31").resolve("aLfM3");

},{"bb02f9a317b5e1f4":"c7Tr5","503575c6e6542d31":"fyJL2"}],"dZZCl":[function(require,module,exports) {
module.exports = require("b41394ab76a95b7f").getBundleURL("kVLro") + require("933d01c581b543dc").resolve("2MncV");

},{"b41394ab76a95b7f":"c7Tr5","933d01c581b543dc":"fyJL2"}],"5XCm5":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _unstated = require("unstated");
var _organizationContainer = require("../../state/containers/OrganizationContainer");
var _organizationContainerDefault = parcelHelpers.interopDefault(_organizationContainer);
var _reactRouter = require("react-router");
var _authContainer = require("../../state/containers/AuthContainer");
var _authContainerDefault = parcelHelpers.interopDefault(_authContainer);
var _frontContainer = require("../../components/structure/FrontContainer");
var _frontContainerDefault = parcelHelpers.interopDefault(_frontContainer);
var _organizationSelectionForm = require("./components/OrganizationSelectionForm");
var _organizationSelectionFormDefault = parcelHelpers.interopDefault(_organizationSelectionForm);
var _landingContainer = require("../../components/structure/LandingContainer");
var _landingContainerDefault = parcelHelpers.interopDefault(_landingContainer);
class Organizations extends (0, _reactDefault.default).Component {
    render() {
        return (0, _react.jsx)((0, _landingContainerDefault.default), null, (0, _react.jsx)((0, _unstated.Subscribe), {
            to: [
                (0, _organizationContainerDefault.default),
                (0, _authContainerDefault.default)
            ]
        }, (orgs, auth)=>{
            // if we are logged in, go to root
            if (!auth.state.isAuthenticated) return (0, _react.jsx)((0, _reactRouter.Redirect), {
                to: "/login"
            });
            if (orgs.state.currentOrganization !== null) return (0, _react.jsx)((0, _reactRouter.Redirect), {
                to: "/v"
            });
            return (0, _react.jsx)((0, _frontContainerDefault.default), null, (0, _react.jsx)((0, _organizationSelectionFormDefault.default), {
                stateContainer: orgs
            }));
        }));
    }
}
exports.default = Organizations;

},{"@emotion/react":"djZKr","react":"6uln9","unstated":"grh7p","../../state/containers/OrganizationContainer":"dlbaM","react-router":"i3TiW","../../state/containers/AuthContainer":"cl1Qb","../../components/structure/FrontContainer":"6Af2K","./components/OrganizationSelectionForm":"047Vj","../../components/structure/LandingContainer":"l7sWG","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6Af2K":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _breakpoints = require("../../constants/breakpoints");
const watermark = require("18db4aeb1983bd94");
const FrontContainer = (props)=>(0, _react.jsx)("div", {
        className: containerStyle
    }, (0, _react.jsx)("div", {
        className: wrapperStyle
    }, props.children), (0, _react.jsx)("img", {
        className: "watermark",
        src: watermark
    }));
const containerStyle = /*#__PURE__*/ (0, _css.css)("width:100%;height:auto;background:#0c6085;color:white;background:-moz-linear-gradient(45deg, #0c6085 0%, #0074a6 50%, #249fd4 100%);background:-webkit-linear-gradient(45deg, #0c6085 0%,#0074a6 50%,#249fd4 100%);background:linear-gradient(45deg, #0c6085 0%,#0074a6 50%,#249fd4 100%);padding:32px 100px;.watermark{position:absolute;right:64px;top:200px;}label{color:white;}p{color:white;font-family:Muli;font-size:14px;font-weight:normal;font-style:normal;font-stretch:normal;line-height:normal;letter-spacing:normal;margin:32px 0;}h2{color:white;font-family:Muli;font-size:32px;font-weight:normal;font-style:normal;font-stretch:normal;line-height:normal;letter-spacing:normal;margin:32px 0;}", (0, _breakpoints.breakpoint_small), "{padding:32px;.watermark{display:none;}}", "");
const wrapperStyle = /*#__PURE__*/ (0, _css.css)("width:50%;height:auto;", (0, _breakpoints.breakpoint_small), "{width:100%;}", "");
exports.default = FrontContainer;

},{"@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","../../constants/breakpoints":"2F01A","18db4aeb1983bd94":"7FEZc","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"047Vj":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _formik = require("formik");
var _yup = require("yup");
var _button = require("../../../components/general/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _loader = require("../../../components/general/Loader");
var _loaderDefault = parcelHelpers.interopDefault(_loader);
var _selectField = require("../../../components/forms/SelectField");
var _selectFieldDefault = parcelHelpers.interopDefault(_selectField);
var _formFieldsContainer = require("../../../components/structure/FormFieldsContainer");
var _formFieldsContainerDefault = parcelHelpers.interopDefault(_formFieldsContainer);
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const buttonSplitStyle = /*#__PURE__*/ (0, _css.css)({
    name: "1162jj0",
    styles: "margin-top:60px;margin-bottom:-56px"
});
class InnerForm extends (0, _reactDefault.default).Component {
    componentWillMount() {
        this.props.stateContainer.getOrganizations();
    }
    handleChange(value) {
        const finalValue = value === null ? null : value.value;
        this.props.setFieldValue("organizationId", finalValue);
    }
    handleBlur(blur) {
        this.props.setFieldTouched("organizationId", blur);
    }
    render() {
        const { isLoadingOrgs, organizations } = this.props.stateContainer.state;
        if (isLoadingOrgs) return (0, _react.jsx)((0, _loaderDefault.default), null);
        return (0, _react.jsx)("form", {
            onSubmit: this.props.handleSubmit
        }, (0, _react.jsx)((0, _formFieldsContainerDefault.default), null, (0, _react.jsx)("h2", null, "Select an Organization"), (0, _react.jsx)("p", null, "Looks like you belong to more than one organization. You’re very popular. Which one would you like to start with? You may switch at any time from your account dropdown"), (0, _react.jsx)((0, _selectFieldDefault.default), {
            className: selectStyle,
            name: "organizationId",
            label: "Organization",
            onChange: this.handleChange.bind(this),
            onBlur: this.handleBlur.bind(this),
            value: this.props.values.organizationId,
            options: organizations.map((o)=>({
                    value: o.id,
                    label: o.name
                }))
        })), (0, _react.jsx)((0, _buttonDefault.default), {
            themes: [
                "primary",
                "wide"
            ],
            type: "submit",
            disabled: this.props.isSubmitting,
            text: "Go",
            additionalClasses: buttonSplitStyle
        }));
    }
}
const OrganizationSelectionForm = (0, _formik.withFormik)({
    mapPropsToValues: (props)=>({
            organizationId: null
        }),
    validationSchema: _yup.object().shape({
        organizationId: _yup.string().nullable().required("You must select an organization")
    }),
    handleSubmit: (values, { props, setSubmitting })=>{
        if (values.organizationId !== null) props.stateContainer.setCurrentOrgById(values.organizationId);
        setSubmitting(false);
    }
})(InnerForm);
const selectStyle = /*#__PURE__*/ (0, _css.css)({
    name: "y8nmv5",
    styles: "font-family:Muli sans-serif;font-weight:normal;font-style:normal;font-stretch:normal;line-height:normal;letter-spacing:normal;text-align:left;width:100%;margin-top:8px;.Select-control{border-radius:30px;min-height:56px;}.Select-placeholder,.Select-value{padding:15px 26px;font-family:Muli;font-size:14px;}.Select-value-label{margin-left:16px;}.Select-menu-outer{border-bottom-right-radius:30px;border-bottom-left-radius:30px;}.Select-option,Select-noresults{height:56px;padding:24px 26px;font-family:Muli;font-size:14px;}.Select-option:last-child{border-bottom-right-radius:30px;border-bottom-left-radius:30px;}.Select-input{margin:16px;font-family:Muli,sans-serif;}"
});
exports.default = OrganizationSelectionForm;

},{"@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","formik":"3YnOK","yup":"j2SJU","../../../components/general/Button":"6ymxN","../../../components/general/Loader":"bnV5T","../../../components/forms/SelectField":"405B3","../../../components/structure/FormFieldsContainer":"h3hzh","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hDPl8":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _unstated = require("unstated");
var _authContainer = require("../../state/containers/AuthContainer");
var _authContainerDefault = parcelHelpers.interopDefault(_authContainer);
var _reactRouter = require("react-router");
var _userContainer = require("../../state/containers/UserContainer");
var _userContainerDefault = parcelHelpers.interopDefault(_userContainer);
var _acceptor = require("./components/Acceptor");
var _acceptorDefault = parcelHelpers.interopDefault(_acceptor);
var _organizationContainer = require("../../state/containers/OrganizationContainer");
var _organizationContainerDefault = parcelHelpers.interopDefault(_organizationContainer);
var _applicationContainer = require("../../state/containers/ApplicationContainer");
var _applicationContainerDefault = parcelHelpers.interopDefault(_applicationContainer);
var _splash = require("../splash");
var _splashDefault = parcelHelpers.interopDefault(_splash);
var _featureContainer = require("../../state/containers/FeatureContainer");
var _featureContainerDefault = parcelHelpers.interopDefault(_featureContainer);
const AcceptInvitation = (props)=>{
    return (0, _react.jsx)("div", null, (0, _react.jsx)((0, _unstated.Subscribe), {
        to: [
            (0, _authContainerDefault.default),
            (0, _userContainerDefault.default),
            (0, _organizationContainerDefault.default),
            (0, _applicationContainerDefault.default),
            (0, _featureContainerDefault.default)
        ]
    }, (authContainer, userContainer, orgContainer, appContainer, featureContainer)=>{
        // if we are logged in, accept the invite
        // otherwise go to login
        if (authContainer.state.isAuthenticated === true) {
            // refresh token and data first
            if (authContainer.state.expirationDate < new Date() || !authContainer.state.accessToken) return (0, _react.jsx)((0, _splashDefault.default), {
                authContainer: authContainer,
                orgContainer: orgContainer,
                appContainer: appContainer,
                featureContainer: featureContainer
            });
            return (0, _react.jsx)((0, _acceptorDefault.default), {
                orgContainer: orgContainer,
                container: userContainer,
                invitationCode: props.match.params.invitationCode,
                history: props.history
            });
        }
        return (0, _react.jsx)((0, _reactRouter.Redirect), {
            to: `/login/${props.match.params.invitationCode}`
        });
    }));
};
exports.default = AcceptInvitation;

},{"@emotion/react":"djZKr","react":"6uln9","unstated":"grh7p","../../state/containers/AuthContainer":"cl1Qb","react-router":"i3TiW","../../state/containers/UserContainer":"jDrDR","./components/Acceptor":"bgRcf","../../state/containers/OrganizationContainer":"dlbaM","../../state/containers/ApplicationContainer":"cuqi2","../splash":"5FUTj","../../state/containers/FeatureContainer":"4ApGg","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"bgRcf":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _loader = require("../../../components/general/Loader");
var _loaderDefault = parcelHelpers.interopDefault(_loader);
var _pageError = require("../../../components/general/PageError");
var _pageErrorDefault = parcelHelpers.interopDefault(_pageError);
class Acceptor extends (0, _reactDefault.default).Component {
    componentWillMount() {
        this.props.container.acceptInvitation(this.props.invitationCode).then((result)=>{
            if (result.resultType == "Ok") {
                this.props.orgContainer.getOrganizations().then((orgResult)=>{
                    if (orgResult.resultType == "Ok") this.props.orgContainer.setCurrentOrgById(result.data.organizationId);
                });
                this.props.history.push("/v");
            }
        }).catch((error)=>{
            alert("Unable to accept the invitation. Please try again later.");
        });
    }
    render() {
        return (0, _react.jsx)("div", null, (0, _react.jsx)((0, _loaderDefault.default), null), (0, _react.jsx)((0, _pageErrorDefault.default), {
            errors: this.props.container.state.errors
        }));
    }
}
exports.default = Acceptor;

},{"@emotion/react":"djZKr","react":"6uln9","../../../components/general/Loader":"bnV5T","../../../components/general/PageError":"ezFTm","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"krCcZ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _unstated = require("unstated");
var _authContainer = require("../../state/containers/AuthContainer");
var _authContainerDefault = parcelHelpers.interopDefault(_authContainer);
var _frontContainer = require("../../components/structure/FrontContainer");
var _frontContainerDefault = parcelHelpers.interopDefault(_frontContainer);
var _landingContainer = require("../../components/structure/LandingContainer");
var _landingContainerDefault = parcelHelpers.interopDefault(_landingContainer);
var _userContainer = require("../../state/containers/UserContainer");
var _userContainerDefault = parcelHelpers.interopDefault(_userContainer);
var _forgotPasswordForm = require("./components/ForgotPasswordForm");
var _forgotPasswordFormDefault = parcelHelpers.interopDefault(_forgotPasswordForm);
var _resetSuccess = require("./components/ResetSuccess");
var _resetSuccessDefault = parcelHelpers.interopDefault(_resetSuccess);
class ForgotPassword extends (0, _reactDefault.default).Component {
    render() {
        return (0, _react.jsx)((0, _landingContainerDefault.default), null, (0, _react.jsx)((0, _unstated.Subscribe), {
            to: [
                (0, _userContainerDefault.default),
                (0, _authContainerDefault.default)
            ]
        }, (user, auth)=>{
            return (0, _react.jsx)((0, _frontContainerDefault.default), null, user.state.isResetRequestSent ? (0, _react.jsx)((0, _resetSuccessDefault.default), {
                history: this.props.history
            }) : (0, _react.jsx)((0, _forgotPasswordFormDefault.default), {
                stateContainer: user
            }));
        }));
    }
}
exports.default = ForgotPassword;

},{"@emotion/react":"djZKr","react":"6uln9","unstated":"grh7p","../../state/containers/AuthContainer":"cl1Qb","../../components/structure/FrontContainer":"6Af2K","../../components/structure/LandingContainer":"l7sWG","../../state/containers/UserContainer":"jDrDR","./components/ForgotPasswordForm":"gCK5z","./components/ResetSuccess":"g6qlz","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"gCK5z":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _formik = require("formik");
var _yup = require("yup");
var _button = require("../../../components/general/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _formFieldsContainer = require("../../../components/structure/FormFieldsContainer");
var _formFieldsContainerDefault = parcelHelpers.interopDefault(_formFieldsContainer);
var _textField = require("../../../components/forms/TextField");
var _textFieldDefault = parcelHelpers.interopDefault(_textField);
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const buttonSplitStyle = /*#__PURE__*/ (0, _css.css)({
    name: "1162jj0",
    styles: "margin-top:60px;margin-bottom:-56px"
});
class InnerForm extends (0, _reactDefault.default).Component {
    componentWillMount() {
        this.props.stateContainer.resetPasswordResetRequest();
    }
    render() {
        return (0, _react.jsx)((0, _formik.Form), {
            onSubmit: this.props.handleSubmit
        }, (0, _react.jsx)((0, _formFieldsContainerDefault.default), null, (0, _react.jsx)("h2", null, "Forgot Password"), (0, _react.jsx)("p", null, "Enter the email of the account. We will send you an email with instructions to reset your password."), (0, _react.jsx)((0, _textFieldDefault.default), {
            type: "email",
            name: "email",
            label: "Email",
            placeholder: "The one you sign in with",
            value: this.props.values.email,
            onChange: this.props.handleChange,
            onBlur: this.props.handleBlur
        })), (0, _react.jsx)((0, _buttonDefault.default), {
            themes: [
                "primary",
                "wide"
            ],
            type: "submit",
            disabled: this.props.isSubmitting,
            text: "Submit",
            additionalClasses: buttonSplitStyle
        }));
    }
}
const ForgotPasswordForm = (0, _formik.withFormik)({
    mapPropsToValues: (props)=>({
            email: ""
        }),
    validationSchema: _yup.object().shape({
        email: _yup.string().email("Must be a valid email").required("You must enter an email address")
    }),
    handleSubmit: (values, { props, setSubmitting })=>{
        if (values.email !== "") props.stateContainer.resetPassword(values.email).then((result)=>{
            setSubmitting(false);
        });
        else setSubmitting(false);
    }
})(InnerForm);
exports.default = ForgotPasswordForm;

},{"@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","formik":"3YnOK","yup":"j2SJU","../../../components/general/Button":"6ymxN","../../../components/structure/FormFieldsContainer":"h3hzh","../../../components/forms/TextField":"7a7bh","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"g6qlz":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _button = require("../../../components/general/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const buttonSplitStyle = /*#__PURE__*/ (0, _css.css)({
    name: "1162jj0",
    styles: "margin-top:60px;margin-bottom:-56px"
});
class ResetSuccess extends (0, _reactDefault.default).Component {
    handleBack() {
        this.props.history.goBack();
    }
    render() {
        return (0, _react.jsx)("div", null, (0, _react.jsx)("h2", null, "Reset Sent"), (0, _react.jsx)("p", null, "We've sent you an email with instructions to reset your password. Once you're done, you can come back here and sign in."), (0, _react.jsx)((0, _buttonDefault.default), {
            themes: [
                "primary",
                "wide"
            ],
            type: "button",
            text: "Back to Login",
            additionalClasses: buttonSplitStyle,
            onClick: this.handleBack.bind(this)
        }));
    }
}
exports.default = ResetSuccess;

},{"@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","../../../components/general/Button":"6ymxN","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"202ZC":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _unstated = require("unstated");
var _authContainer = require("../../state/containers/AuthContainer");
var _authContainerDefault = parcelHelpers.interopDefault(_authContainer);
var _frontContainer = require("../../components/structure/FrontContainer");
var _frontContainerDefault = parcelHelpers.interopDefault(_frontContainer);
var _landingContainer = require("../../components/structure/LandingContainer");
var _landingContainerDefault = parcelHelpers.interopDefault(_landingContainer);
var _userContainer = require("../../state/containers/UserContainer");
var _userContainerDefault = parcelHelpers.interopDefault(_userContainer);
var _resetSuccess = require("./components/ResetSuccess");
var _resetSuccessDefault = parcelHelpers.interopDefault(_resetSuccess);
var _resetPasswordForm = require("./components/ResetPasswordForm");
var _resetPasswordFormDefault = parcelHelpers.interopDefault(_resetPasswordForm);
class ResetPassword extends (0, _reactDefault.default).Component {
    render() {
        return (0, _react.jsx)((0, _landingContainerDefault.default), null, (0, _react.jsx)((0, _unstated.Subscribe), {
            to: [
                (0, _userContainerDefault.default),
                (0, _authContainerDefault.default)
            ]
        }, (user, auth)=>{
            return (0, _react.jsx)((0, _frontContainerDefault.default), null, user.state.isSetPasswordSent ? (0, _react.jsx)((0, _resetSuccessDefault.default), {
                history: this.props.history
            }) : (0, _react.jsx)((0, _resetPasswordFormDefault.default), {
                stateContainer: user,
                resetToken: this.props.match.params.resetToken
            }));
        }));
    }
}
exports.default = ResetPassword;

},{"@emotion/react":"djZKr","react":"6uln9","unstated":"grh7p","../../state/containers/AuthContainer":"cl1Qb","../../components/structure/FrontContainer":"6Af2K","../../components/structure/LandingContainer":"l7sWG","../../state/containers/UserContainer":"jDrDR","./components/ResetSuccess":"1NFs0","./components/ResetPasswordForm":"gilv6","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1NFs0":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _button = require("../../../components/general/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const buttonSplitStyle = /*#__PURE__*/ (0, _css.css)({
    name: "1162jj0",
    styles: "margin-top:60px;margin-bottom:-56px"
});
class ResetSuccess extends (0, _reactDefault.default).Component {
    handleBack() {
        this.props.history.push("/login");
    }
    render() {
        return (0, _react.jsx)("div", null, (0, _react.jsx)("h2", null, "New Password Set"), (0, _react.jsx)("p", null, "Your new password is all set. Now use it to sign in again!"), (0, _react.jsx)((0, _buttonDefault.default), {
            themes: [
                "primary",
                "wide"
            ],
            type: "button",
            text: "Back to Login",
            additionalClasses: buttonSplitStyle,
            onClick: this.handleBack.bind(this)
        }));
    }
}
exports.default = ResetSuccess;

},{"@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","../../../components/general/Button":"6ymxN","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"gilv6":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _css = require("@emotion/css");
var _formik = require("formik");
var _yup = require("yup");
var _button = require("../../../components/general/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _formFieldsContainer = require("../../../components/structure/FormFieldsContainer");
var _formFieldsContainerDefault = parcelHelpers.interopDefault(_formFieldsContainer);
var _textField = require("../../../components/forms/TextField");
var _textFieldDefault = parcelHelpers.interopDefault(_textField);
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const buttonSplitStyle = /*#__PURE__*/ (0, _css.css)({
    name: "1162jj0",
    styles: "margin-top:60px;margin-bottom:-56px"
});
class InnerForm extends (0, _reactDefault.default).Component {
    componentWillMount() {
        this.props.stateContainer.resetPasswordSetRequest();
    }
    render() {
        return (0, _react.jsx)((0, _formik.Form), {
            onSubmit: this.props.handleSubmit
        }, (0, _react.jsx)((0, _formFieldsContainerDefault.default), null, (0, _react.jsx)("h2", null, "Forgot Password"), (0, _react.jsx)("p", null, "Enter the email of the account. We will send you an email with instructions to reset your password."), (0, _react.jsx)((0, _textFieldDefault.default), {
            type: "password",
            name: "password",
            label: "New Password",
            placeholder: "Make sure it's a good one",
            value: this.props.values.password,
            onChange: this.props.handleChange,
            onBlur: this.props.handleBlur
        }), (0, _react.jsx)((0, _textFieldDefault.default), {
            type: "password",
            name: "confirmPassword",
            label: "Confirm New Password",
            placeholder: "One more time",
            value: this.props.values.confirmPassword,
            onChange: this.props.handleChange,
            onBlur: this.props.handleBlur
        })), (0, _react.jsx)((0, _buttonDefault.default), {
            themes: [
                "primary",
                "wide"
            ],
            type: "submit",
            disabled: this.props.isSubmitting,
            text: "Submit",
            additionalClasses: buttonSplitStyle
        }));
    }
}
const ResetPasswordForm = (0, _formik.withFormik)({
    mapPropsToValues: (props)=>({
            password: "",
            confirmPassword: ""
        }),
    validationSchema: _yup.object().shape({
        password: _yup.string().required("You must enter a new password"),
        confirmPassword: _yup.string().required("You must confirm your new password")
    }),
    handleSubmit: (values, { props, setSubmitting })=>{
        if (values.password !== "" && values.confirmPassword !== "" && values.confirmPassword === values.password) props.stateContainer.setPassword({
            newPassword: values.password,
            confirmNewPassword: values.confirmPassword,
            resetCode: props.resetToken
        }).then((result)=>{
            setSubmitting(false);
            if (result.resultType !== "Ok") alert(result.errors[0]);
        });
        else {
            alert("Your passwords don't match");
            setSubmitting(false);
        }
    }
})(InnerForm);
exports.default = ResetPasswordForm;

},{"@emotion/react":"djZKr","react":"6uln9","@emotion/css":"awUBr","formik":"3YnOK","yup":"j2SJU","../../../components/general/Button":"6ymxN","../../../components/structure/FormFieldsContainer":"h3hzh","../../../components/forms/TextField":"7a7bh","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"gGzZh":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _googleAuthorization = require("../../api/controllers/googleAuthorization");
class GoogleAuth extends (0, _reactDefault.default).Component {
    componentWillMount() {
        const urlParams = new URLSearchParams(window.location.search);
        var csrfToken = urlParams.get("state").split(";")[3];
        var idType = urlParams.get("state").split(";")[0];
        var primaryId = urlParams.get("state").split(";")[1];
        let applicationId = primaryId;
        if (idType != "applicationId" && urlParams.get("state").includes("applicationId")) applicationId = urlParams.get("state").split(";")[7];
        if (csrfToken === localStorage.getItem("google-salt")) {
            localStorage.removeItem("google-salt");
            (0, _googleAuthorization.googleAuthCallback)(window.location.search).then((res)=>{
                if (idType == "applicationId" || urlParams.get("state").includes("applicationId")) {
                    let url = `${window.location.origin}/v/apps/${applicationId}/appSettings/deployments`;
                    if (urlParams.get("state").includes("environmentId")) url = `${url}/${primaryId}`;
                    window.open(url, "_self");
                } else window.open(`${window.location.origin}/v/orgSettings/credentials`, "_self");
            });
        } else {
            //TODO: handle failure
            localStorage.removeItem("google-salt");
            window.open(window.location.origin, "_self");
        }
    }
    render() {
        return (0, _react.jsx)("div", null);
    }
}
exports.default = GoogleAuth;

},{"@emotion/react":"djZKr","react":"6uln9","../../api/controllers/googleAuthorization":"iV0if","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7mvfI":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _amazonAuthorization = require("../../api/controllers/amazonAuthorization");
class AmazonAuth extends (0, _reactDefault.default).Component {
    componentWillMount() {
        const urlParams = new URLSearchParams(window.location.search);
        var csrfToken = urlParams.get("state").split(";")[3];
        var idType = urlParams.get("state").split(";")[0];
        var primaryId = urlParams.get("state").split(";")[1];
        let applicationId = primaryId;
        if (idType != "applicationId" && urlParams.get("state").includes("applicationId")) applicationId = urlParams.get("state").split(";")[5];
        if (csrfToken === localStorage.getItem("amazon-salt")) {
            localStorage.removeItem("amazon-salt");
            (0, _amazonAuthorization.amazonAuthCallback)(window.location.search).then((res)=>{
                if (idType == "applicationId" || urlParams.get("state").includes("applicationId")) {
                    let url = `${window.location.origin}/v/apps/${applicationId}/appSettings/deployments`;
                    if (urlParams.get("state").includes("environmentId")) url = `${url}/${primaryId}`;
                    window.open(url, "_self");
                } else window.open(`${window.location.origin}/v/orgSettings/credentials`, "_self");
            });
        } else {
            //TODO: handle failure
            localStorage.removeItem("amazon-salt");
            window.open(window.location.origin, "_self");
        }
    }
    render() {
        return (0, _react.jsx)("div", null);
    }
}
exports.default = AmazonAuth;

},{"@emotion/react":"djZKr","react":"6uln9","../../api/controllers/amazonAuthorization":"86UFi","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9tVt4":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _loader = require("../../components/general/Loader");
var _loaderDefault = parcelHelpers.interopDefault(_loader);
var _api = require("../../api");
var _unstated = require("unstated");
var _organizationContainer = require("../../state/containers/OrganizationContainer");
var _organizationContainerDefault = parcelHelpers.interopDefault(_organizationContainer);
const OAuthRedirector = ()=>(0, _react.jsx)((0, _unstated.Subscribe), {
        to: [
            (0, _organizationContainerDefault.default)
        ]
    }, (ctr)=>(0, _react.jsx)(OAuthRedirectorChild, {
            organizationContainer: ctr
        }));
class OAuthRedirectorChild extends (0, _reactDefault.default).Component {
    componentWillMount() {
        const search = window.location.search;
        const urlParams = new URLSearchParams(search);
        var oAuthUrl = urlParams.get("oAuthUrl");
        var code = urlParams.get("code");
        var state = urlParams.get("state");
        if (this.props.organizationContainer.state.currentOrganization != null) this.resolveOAuth(this.props.organizationContainer.state.currentOrganization, oAuthUrl, code, state, search);
        else this.props.organizationContainer.getOrganizations().then((res)=>{
            this.resolveOAuth(res.data[0], oAuthUrl, code, state, search);
        });
    }
    resolveOAuth(organization, oAuthUrl, code, state, search) {
        var oAuthResult = {
            oAuthUrl,
            code,
            state
        };
        _api.sendIntegrationOauthResult(organization.id, oAuthResult, search).then((res)=>{
            window.open(window.location.origin, "_self");
        }).catch((err)=>{
            console.log(err);
            window.open(window.location.origin, "_self");
        });
    }
    render() {
        return (0, _react.jsx)((0, _loaderDefault.default), null);
    }
}
exports.default = OAuthRedirector;

},{"@emotion/react":"djZKr","react":"6uln9","../../components/general/Loader":"bnV5T","../../api":"loxM6","unstated":"grh7p","../../state/containers/OrganizationContainer":"dlbaM","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"b4Ylx":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _api = require("../../api");
class MicrosoftAuth extends (0, _reactDefault.default).Component {
    componentWillMount() {
        _api.microsoftAuthCallback(window.location.search).then((res)=>{
            window.open(window.location.origin, "_self");
        });
    }
    render() {
        return (0, _react.jsx)("div", null);
    }
}
exports.default = MicrosoftAuth;

},{"@emotion/react":"djZKr","react":"6uln9","../../api":"loxM6","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1nNyj":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _base = require("@emotion/styled/base");
var _baseDefault = parcelHelpers.interopDefault(_base);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _reactCookieConsent = require("react-cookie-consent");
var _reactCookieConsentDefault = parcelHelpers.interopDefault(_reactCookieConsent);
var _css = require("@emotion/css");
var _colors = require("../../constants/colors");
var _urls = require("../../constants/Urls");
var _breakpoints = require("../../constants/breakpoints");
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const cookiesIcon = require("4e7173175ed4e9cb");
const CookiesComponent = ()=>(0, _react.jsx)("div", {
        className: containerStyle
    }, (0, _react.jsx)((0, _reactCookieConsentDefault.default), {
        disableStyles: true,
        buttonText: "Accept & Close",
        buttonClasses: "accept"
    }, (0, _react.jsx)(CookiesConsentWrapper, null, (0, _react.jsx)("div", {
        className: "innerContainer"
    }, (0, _react.jsx)("div", {
        className: "header"
    }, (0, _react.jsx)("img", {
        src: cookiesIcon
    }), `Yup! We use cookies, too!`), (0, _react.jsx)("div", {
        className: "content"
    }, `And now it's mandated that we let you know. Check out our `, (0, _react.jsx)("a", {
        target: "blank",
        className: "link",
        href: (0, _urls.COOKIE_TERMS_URL)
    }, "Cookie Policy"), `. You can manage how cookies are used in your settings at any time.`)), (0, _react.jsx)("a", {
        href: (0, _urls.COOKIE_TERMS_URL),
        target: "_blank",
        className: "learn"
    }, " Learn More "))));
const CookiesConsentWrapper = /*#__PURE__*/ (0, _baseDefault.default)("div", {
    target: "e13da3zv0"
})({
    name: "1fttcpj",
    styles: "display:flex;flex-direction:column"
});
const containerStyle = /*#__PURE__*/ (0, _css.css)("background:transparent;border-radius:8px;display:block;color:white;z-index:102;position:absolute;bottom:20px;left:20px;overflow:hidden;font-family:Muli;font-size:18px;font-weight:lighter;font-style:normal;font-stretch:normal;letter-spacing:normal;", (0, _breakpoints.breakpoint_small), "{bottom:50px;left:auto;margin:16px;}.cookieConsent{background:", (0, _colors.color_shades_darkest), ";padding:16px 24px;width:575px;height:180px;", (0, _breakpoints.breakpoint_small), "{width:auto;height:auto;}}.innerConainer{position:relative;height:100%;}.header{border-bottom:solid 1px white;display:flex;flex-direction:row;line-height:1.33;padding-bottom:16px;margin-bottom:16px;img{padding-right:16px;}}.content{font-family:Muli;font-size:14px;font-style:normal;font-stretch:normal;line-height:1.43;letter-spacing:normal;.link{color:white;text-decoration:underline;}}.accept{position:relative;background:transparent;border-color:white;border-width:1px;cursor:pointer;width:148px;height:32px;border-style:solid;border-radius:16px;box-sizing:border-box;color:white;font-size:14px;}.learn{position:relative;top:23px;left:450px;border-color:transparent;border-style:none;font-size:14px;color:white;cursor:pointer;background:transparent;", (0, _breakpoints.breakpoint_small), "{margin:16px 0;top:auto;left:auto;}}", "");
exports.default = CookiesComponent;

},{"@emotion/styled/base":"lSuFu","@emotion/react":"djZKr","react":"6uln9","react-cookie-consent":"03Gqm","@emotion/css":"awUBr","../../constants/colors":"1p3OR","../../constants/Urls":"iTopY","../../constants/breakpoints":"2F01A","4e7173175ed4e9cb":"fp8yb","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"03Gqm":[function(require,module,exports) {
module.exports = /******/ function(modules) {
    /******/ // The module cache
    /******/ var installedModules = {};
    /******/ /******/ // The require function
    /******/ function __webpack_require__(moduleId) {
        /******/ /******/ // Check if module is in cache
        /******/ if (installedModules[moduleId]) /******/ return installedModules[moduleId].exports;
        /******/ // Create a new module (and put it into the cache)
        /******/ var module1 = installedModules[moduleId] = {
            /******/ i: moduleId,
            /******/ l: false,
            /******/ exports: {}
        };
        /******/ /******/ // Execute the module function
        /******/ modules[moduleId].call(module1.exports, module1, module1.exports, __webpack_require__);
        /******/ /******/ // Flag the module as loaded
        /******/ module1.l = true;
        /******/ /******/ // Return the exports of the module
        /******/ return module1.exports;
    /******/ }
    /******/ /******/ /******/ // expose the modules object (__webpack_modules__)
    /******/ __webpack_require__.m = modules;
    /******/ /******/ // expose the module cache
    /******/ __webpack_require__.c = installedModules;
    /******/ /******/ // identity function for calling harmony imports with the correct context
    /******/ __webpack_require__.i = function(value) {
        return value;
    };
    /******/ /******/ // define getter function for harmony exports
    /******/ __webpack_require__.d = function(exports, name, getter) {
        /******/ if (!__webpack_require__.o(exports, name)) /******/ Object.defineProperty(exports, name, {
            /******/ configurable: false,
            /******/ enumerable: true,
            /******/ get: getter
        });
    /******/ };
    /******/ /******/ // getDefaultExport function for compatibility with non-harmony modules
    /******/ __webpack_require__.n = function(module1) {
        /******/ var getter = module1 && module1.__esModule ? /******/ function getDefault() {
            return module1["default"];
        } : /******/ function getModuleExports() {
            return module1;
        };
        /******/ __webpack_require__.d(getter, "a", getter);
        /******/ return getter;
    /******/ };
    /******/ /******/ // Object.prototype.hasOwnProperty.call
    /******/ __webpack_require__.o = function(object, property) {
        return Object.prototype.hasOwnProperty.call(object, property);
    };
    /******/ /******/ // __webpack_public_path__
    /******/ __webpack_require__.p = "";
    /******/ /******/ // Load entry module and return exports
    /******/ return __webpack_require__(__webpack_require__.s = 6);
/******/ }([
    /* 0 */ /***/ function(module1, exports) {
        // shim for using process in browser
        var process = module1.exports = {};
        // cached from whatever global is present so that test runners that stub it
        // don't break things.  But we need to wrap it in a try catch in case it is
        // wrapped in strict mode code which doesn't define any globals.  It's inside a
        // function because try/catches deoptimize in certain engines.
        var cachedSetTimeout;
        var cachedClearTimeout;
        function defaultSetTimout() {
            throw new Error("setTimeout has not been defined");
        }
        function defaultClearTimeout() {
            throw new Error("clearTimeout has not been defined");
        }
        (function() {
            try {
                if (typeof setTimeout === "function") cachedSetTimeout = setTimeout;
                else cachedSetTimeout = defaultSetTimout;
            } catch (e) {
                cachedSetTimeout = defaultSetTimout;
            }
            try {
                if (typeof clearTimeout === "function") cachedClearTimeout = clearTimeout;
                else cachedClearTimeout = defaultClearTimeout;
            } catch (e) {
                cachedClearTimeout = defaultClearTimeout;
            }
        })();
        function runTimeout(fun) {
            if (cachedSetTimeout === setTimeout) //normal enviroments in sane situations
            return setTimeout(fun, 0);
            // if setTimeout wasn't available but was latter defined
            if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
                cachedSetTimeout = setTimeout;
                return setTimeout(fun, 0);
            }
            try {
                // when when somebody has screwed with setTimeout but no I.E. maddness
                return cachedSetTimeout(fun, 0);
            } catch (e) {
                try {
                    // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
                    return cachedSetTimeout.call(null, fun, 0);
                } catch (e) {
                    // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
                    return cachedSetTimeout.call(this, fun, 0);
                }
            }
        }
        function runClearTimeout(marker) {
            if (cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
            return clearTimeout(marker);
            // if clearTimeout wasn't available but was latter defined
            if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
                cachedClearTimeout = clearTimeout;
                return clearTimeout(marker);
            }
            try {
                // when when somebody has screwed with setTimeout but no I.E. maddness
                return cachedClearTimeout(marker);
            } catch (e) {
                try {
                    // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
                    return cachedClearTimeout.call(null, marker);
                } catch (e) {
                    // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
                    // Some versions of I.E. have different rules for clearTimeout vs setTimeout
                    return cachedClearTimeout.call(this, marker);
                }
            }
        }
        var queue = [];
        var draining = false;
        var currentQueue;
        var queueIndex = -1;
        function cleanUpNextTick() {
            if (!draining || !currentQueue) return;
            draining = false;
            if (currentQueue.length) queue = currentQueue.concat(queue);
            else queueIndex = -1;
            if (queue.length) drainQueue();
        }
        function drainQueue() {
            if (draining) return;
            var timeout = runTimeout(cleanUpNextTick);
            draining = true;
            var len = queue.length;
            while(len){
                currentQueue = queue;
                queue = [];
                while(++queueIndex < len)if (currentQueue) currentQueue[queueIndex].run();
                queueIndex = -1;
                len = queue.length;
            }
            currentQueue = null;
            draining = false;
            runClearTimeout(timeout);
        }
        process.nextTick = function(fun) {
            var args = new Array(arguments.length - 1);
            if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
            queue.push(new Item(fun, args));
            if (queue.length === 1 && !draining) runTimeout(drainQueue);
        };
        // v8 likes predictible objects
        function Item(fun, array) {
            this.fun = fun;
            this.array = array;
        }
        Item.prototype.run = function() {
            this.fun.apply(null, this.array);
        };
        process.title = "browser";
        process.browser = true;
        process.env = {};
        process.argv = [];
        process.version = ""; // empty string to avoid regexp issues
        process.versions = {};
        function noop() {}
        process.on = noop;
        process.addListener = noop;
        process.once = noop;
        process.off = noop;
        process.removeListener = noop;
        process.removeAllListeners = noop;
        process.emit = noop;
        process.prependListener = noop;
        process.prependOnceListener = noop;
        process.listeners = function(name) {
            return [];
        };
        process.binding = function(name) {
            throw new Error("process.binding is not supported");
        };
        process.cwd = function() {
            return "/";
        };
        process.chdir = function(dir) {
            throw new Error("process.chdir is not supported");
        };
        process.umask = function() {
            return 0;
        };
    /***/ },
    /* 1 */ /***/ function(module1, exports, __webpack_require__) {
        "use strict";
        /**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var ReactPropTypesSecret = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
        module1.exports = ReactPropTypesSecret;
    /***/ },
    /* 2 */ /***/ function(module1, exports, __webpack_require__) {
        "use strict";
        /* WEBPACK VAR INJECTION */ (function(process) {
            if (process.env.NODE_ENV === "production") module1.exports = __webpack_require__(12);
            else module1.exports = __webpack_require__(11);
        /* WEBPACK VAR INJECTION */ }).call(exports, __webpack_require__(0));
    /***/ },
    /* 3 */ /***/ function(module1, exports, __webpack_require__) {
        var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__; /*!
 * JavaScript Cookie v2.2.0
 * https://github.com/js-cookie/js-cookie
 *
 * Copyright 2006, 2015 Klaus Hartl & Fagner Brack
 * Released under the MIT license
 */ 
        (function(factory) {
            var registeredInModuleLoader = false;
            __WEBPACK_AMD_DEFINE_FACTORY__ = factory, __WEBPACK_AMD_DEFINE_RESULT__ = typeof __WEBPACK_AMD_DEFINE_FACTORY__ === "function" ? __WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module1) : __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module1.exports = __WEBPACK_AMD_DEFINE_RESULT__);
            registeredInModuleLoader = true;
            module1.exports = factory();
            registeredInModuleLoader = true;
            if (!registeredInModuleLoader) {
                var OldCookies = window.Cookies;
                var api = window.Cookies = factory();
                api.noConflict = function() {
                    window.Cookies = OldCookies;
                    return api;
                };
            }
        })(function() {
            function extend() {
                var i = 0;
                var result = {};
                for(; i < arguments.length; i++){
                    var attributes = arguments[i];
                    for(var key in attributes)result[key] = attributes[key];
                }
                return result;
            }
            function init(converter) {
                function api(key, value, attributes) {
                    var result;
                    if (typeof document === "undefined") return;
                    // Write
                    if (arguments.length > 1) {
                        attributes = extend({
                            path: "/"
                        }, api.defaults, attributes);
                        if (typeof attributes.expires === "number") {
                            var expires = new Date();
                            expires.setMilliseconds(expires.getMilliseconds() + attributes.expires * 864e+5);
                            attributes.expires = expires;
                        }
                        // We're using "expires" because "max-age" is not supported by IE
                        attributes.expires = attributes.expires ? attributes.expires.toUTCString() : "";
                        try {
                            result = JSON.stringify(value);
                            if (/^[\{\[]/.test(result)) value = result;
                        } catch (e) {}
                        if (!converter.write) value = encodeURIComponent(String(value)).replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent);
                        else value = converter.write(value, key);
                        key = encodeURIComponent(String(key));
                        key = key.replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent);
                        key = key.replace(/[\(\)]/g, escape);
                        var stringifiedAttributes = "";
                        for(var attributeName in attributes){
                            if (!attributes[attributeName]) continue;
                            stringifiedAttributes += "; " + attributeName;
                            if (attributes[attributeName] === true) continue;
                            stringifiedAttributes += "=" + attributes[attributeName];
                        }
                        return document.cookie = key + "=" + value + stringifiedAttributes;
                    }
                    // Read
                    if (!key) result = {};
                    // To prevent the for loop in the first place assign an empty array
                    // in case there are no cookies at all. Also prevents odd result when
                    // calling "get()"
                    var cookies = document.cookie ? document.cookie.split("; ") : [];
                    var rdecode = /(%[0-9A-Z]{2})+/g;
                    var i = 0;
                    for(; i < cookies.length; i++){
                        var parts = cookies[i].split("=");
                        var cookie = parts.slice(1).join("=");
                        if (!this.json && cookie.charAt(0) === '"') cookie = cookie.slice(1, -1);
                        try {
                            var name = parts[0].replace(rdecode, decodeURIComponent);
                            cookie = converter.read ? converter.read(cookie, name) : converter(cookie, name) || cookie.replace(rdecode, decodeURIComponent);
                            if (this.json) try {
                                cookie = JSON.parse(cookie);
                            } catch (e) {}
                            if (key === name) {
                                result = cookie;
                                break;
                            }
                            if (!key) result[name] = cookie;
                        } catch (e) {}
                    }
                    return result;
                }
                api.set = api;
                api.get = function(key) {
                    return api.call(api, key);
                };
                api.getJSON = function() {
                    return api.apply({
                        json: true
                    }, [].slice.call(arguments));
                };
                api.defaults = {};
                api.remove = function(key, attributes) {
                    api(key, "", extend(attributes, {
                        expires: -1
                    }));
                };
                api.withConverter = init;
                return api;
            }
            return init(function() {});
        });
    /***/ },
    /* 4 */ /***/ function(module1, exports, __webpack_require__) {
        /* WEBPACK VAR INJECTION */ (function(process) {
            if (process.env.NODE_ENV !== "production") {
                var ReactIs = __webpack_require__(2);
                // By explicitly using `prop-types` you are opting into new development behavior.
                // http://fb.me/prop-types-in-prod
                var throwOnDirectAccess = true;
                module1.exports = __webpack_require__(10)(ReactIs.isElement, throwOnDirectAccess);
            } else // By explicitly using `prop-types` you are opting into new production behavior.
            // http://fb.me/prop-types-in-prod
            module1.exports = __webpack_require__(9)();
        /* WEBPACK VAR INJECTION */ }).call(exports, __webpack_require__(0));
    /***/ },
    /* 5 */ /***/ function(module1, exports) {
        module1.exports = require("cc0f267969ea95e7");
    /***/ },
    /* 6 */ /***/ function(module1, exports, __webpack_require__) {
        "use strict";
        Object.defineProperty(exports, "__esModule", {
            value: true
        });
        exports.Cookies = exports.OPTIONS = undefined;
        var _extends = Object.assign || function(target) {
            for(var i = 1; i < arguments.length; i++){
                var source = arguments[i];
                for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
            }
            return target;
        };
        var _createClass = function() {
            function defineProperties(target, props) {
                for(var i = 0; i < props.length; i++){
                    var descriptor = props[i];
                    descriptor.enumerable = descriptor.enumerable || false;
                    descriptor.configurable = true;
                    if ("value" in descriptor) descriptor.writable = true;
                    Object.defineProperty(target, descriptor.key, descriptor);
                }
            }
            return function(Constructor, protoProps, staticProps) {
                if (protoProps) defineProperties(Constructor.prototype, protoProps);
                if (staticProps) defineProperties(Constructor, staticProps);
                return Constructor;
            };
        }();
        var _react = __webpack_require__(5);
        var _react2 = _interopRequireDefault(_react);
        var _propTypes = __webpack_require__(4);
        var _propTypes2 = _interopRequireDefault(_propTypes);
        var _jsCookie = __webpack_require__(3);
        var _jsCookie2 = _interopRequireDefault(_jsCookie);
        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                default: obj
            };
        }
        function _objectWithoutProperties(obj, keys) {
            var target = {};
            for(var i in obj){
                if (keys.indexOf(i) >= 0) continue;
                if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
                target[i] = obj[i];
            }
            return target;
        }
        function _classCallCheck(instance, Constructor) {
            if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
        }
        function _possibleConstructorReturn(self, call) {
            if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return call && (typeof call === "object" || typeof call === "function") ? call : self;
        }
        function _inherits(subClass, superClass) {
            if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
            subClass.prototype = Object.create(superClass && superClass.prototype, {
                constructor: {
                    value: subClass,
                    enumerable: false,
                    writable: true,
                    configurable: true
                }
            });
            if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
        }
        var OPTIONS = exports.OPTIONS = {
            TOP: "top",
            BOTTOM: "bottom",
            NONE: "none"
        };
        var CookieConsent = function(_Component) {
            _inherits(CookieConsent, _Component);
            function CookieConsent(props) {
                _classCallCheck(this, CookieConsent);
                var _this = _possibleConstructorReturn(this, (CookieConsent.__proto__ || Object.getPrototypeOf(CookieConsent)).call(this, props));
                _this.accept.bind(_this);
                _this.state = {
                    visible: false,
                    style: {
                        alignItems: "baseline",
                        background: "#353535",
                        color: "white",
                        display: "flex",
                        flexWrap: "wrap",
                        justifyContent: "space-between",
                        left: "0",
                        position: "fixed",
                        width: "100%",
                        zIndex: "999"
                    },
                    buttonStyle: {
                        background: "#ffd42d",
                        border: "0",
                        borderRadius: "0px",
                        boxShadow: "none",
                        color: "black",
                        cursor: "pointer",
                        flex: "0 0 auto",
                        padding: "5px 10px",
                        margin: "15px"
                    },
                    declineButtonStyle: {
                        background: "#c12a2a",
                        border: "0",
                        borderRadius: "0px",
                        boxShadow: "none",
                        color: "#e5e5e5",
                        cursor: "pointer",
                        flex: "0 0 auto",
                        padding: "5px 10px",
                        margin: "15px"
                    },
                    contentStyle: {
                        flex: "1 0 300px",
                        margin: "15px"
                    }
                };
                _this.handleScroll = _this.handleScroll.bind(_this);
                return _this;
            }
            _createClass(CookieConsent, [
                {
                    key: "componentDidMount",
                    value: function componentDidMount() {
                        var _props = this.props, cookieName = _props.cookieName, debug = _props.debug;
                        // if cookie undefined or debug
                        if (_jsCookie2.default.get(cookieName) === undefined || debug) this.setState({
                            visible: true
                        });
                        // if acceptOnScroll is set to true and (cookie is undefined or debug is set to true), add a listener.
                        if (this.props.acceptOnScroll && (_jsCookie2.default.get(cookieName) === undefined || debug)) window.addEventListener("scroll", this.handleScroll, {
                            passive: true
                        });
                    }
                },
                {
                    key: "componentWillUnmount",
                    value: function componentWillUnmount() {
                        // remove listener if still set
                        window.removeEventListener("scroll", this.handleScroll);
                    }
                },
                {
                    key: "handleScroll",
                    value: function handleScroll() {
                        // (top / height) - height * 100
                        var rootNode = document.documentElement, body = document.body, top = "scrollTop", height = "scrollHeight";
                        var percentage = (rootNode[top] || body[top]) / ((rootNode[height] || body[height]) - rootNode.clientHeight) * 100;
                        if (percentage > this.props.acceptOnScrollPercentage) this.accept();
                    }
                },
                {
                    key: "accept",
                    value: function accept() {
                        var _props2 = this.props, cookieName = _props2.cookieName, cookieValue = _props2.cookieValue, expires = _props2.expires, hideOnAccept = _props2.hideOnAccept, onAccept = _props2.onAccept, extraCookieOptions = _props2.extraCookieOptions;
                        // fire onAccept
                        onAccept();
                        // remove listener if set
                        window.removeEventListener("scroll", this.handleScroll);
                        _jsCookie2.default.set(cookieName, cookieValue, _extends({
                            expires: expires
                        }, extraCookieOptions));
                        if (hideOnAccept) this.setState({
                            visible: false
                        });
                    }
                },
                {
                    key: "decline",
                    value: function decline() {
                        var _props3 = this.props, cookieName = _props3.cookieName, declineCookieValue = _props3.declineCookieValue, expires = _props3.expires, hideOnDecline = _props3.hideOnDecline, onDecline = _props3.onDecline, extraCookieOptions = _props3.extraCookieOptions, setDeclineCookie = _props3.setDeclineCookie;
                        // fire onDecline
                        onDecline();
                        // remove listener if set
                        window.removeEventListener("scroll", this.handleScroll);
                        if (setDeclineCookie) _jsCookie2.default.set(cookieName, declineCookieValue, _extends({
                            expires: expires
                        }, extraCookieOptions));
                        if (hideOnDecline) this.setState({
                            visible: false
                        });
                    }
                },
                {
                    key: "render",
                    value: function render() {
                        var _this2 = this;
                        // If the bar shouldn't be visible don't render anything.
                        if (!this.state.visible) return null;
                        var _props4 = this.props, location = _props4.location, style = _props4.style, buttonStyle = _props4.buttonStyle, declineButtonStyle = _props4.declineButtonStyle, contentStyle = _props4.contentStyle, disableStyles = _props4.disableStyles, buttonText = _props4.buttonText, declineButtonText = _props4.declineButtonText, containerClasses = _props4.containerClasses, contentClasses = _props4.contentClasses, buttonClasses = _props4.buttonClasses, declineButtonClasses = _props4.declineButtonClasses, buttonId = _props4.buttonId, declineButtonId = _props4.declineButtonId, disableButtonStyles = _props4.disableButtonStyles, enableDeclineButton = _props4.enableDeclineButton, flipButtons = _props4.flipButtons, ButtonComponent = _props4.ButtonComponent;
                        var myStyle = {};
                        var myButtonStyle = {};
                        var myDeclineButtonStyle = {};
                        var myContentStyle = {};
                        if (disableStyles) {
                            // if styles are disabled use the provided styles (or none)
                            myStyle = _extends({}, style);
                            myButtonStyle = _extends({}, buttonStyle);
                            myDeclineButtonStyle = _extends({}, declineButtonStyle);
                            myContentStyle = _extends({}, contentStyle);
                        } else {
                            // if styles aren't disabled merge them with the styles that are provided (or use default styles)
                            myStyle = _extends({}, _extends({}, this.state.style, style));
                            myContentStyle = _extends({}, _extends({}, this.state.contentStyle, contentStyle));
                            // switch to disable JUST the button styles
                            if (disableButtonStyles) {
                                myButtonStyle = _extends({}, buttonStyle);
                                myDeclineButtonStyle = _extends({}, declineButtonStyle);
                            } else {
                                myButtonStyle = _extends({}, _extends({}, this.state.buttonStyle, buttonStyle));
                                myDeclineButtonStyle = _extends({}, _extends({}, this.state.declineButtonStyle, declineButtonStyle));
                            }
                        }
                        // syntactic sugar to enable user to easily select top / bottom
                        switch(location){
                            case OPTIONS.TOP:
                                myStyle.top = "0";
                                break;
                            case OPTIONS.BOTTOM:
                                myStyle.bottom = "0";
                                break;
                        }
                        var buttonsToRender = [];
                        // add decline button
                        enableDeclineButton && buttonsToRender.push(_react2.default.createElement(ButtonComponent, {
                            key: "declineButton",
                            style: myDeclineButtonStyle,
                            className: declineButtonClasses,
                            id: declineButtonId,
                            onClick: function onClick() {
                                _this2.decline();
                            }
                        }, declineButtonText));
                        // add accept button
                        buttonsToRender.push(_react2.default.createElement(ButtonComponent, {
                            key: "acceptButton",
                            style: myButtonStyle,
                            className: buttonClasses,
                            id: buttonId,
                            onClick: function onClick() {
                                _this2.accept();
                            }
                        }, buttonText));
                        if (flipButtons) buttonsToRender.reverse();
                        return _react2.default.createElement("div", {
                            className: "cookieConsent " + containerClasses,
                            style: myStyle
                        }, _react2.default.createElement("div", {
                            style: myContentStyle,
                            className: contentClasses
                        }, this.props.children), buttonsToRender.map(function(button) {
                            return button;
                        }));
                    }
                }
            ]);
            return CookieConsent;
        }(_react.Component);
        CookieConsent.propTypes = {
            location: _propTypes2.default.oneOf(Object.keys(OPTIONS).map(function(key) {
                return OPTIONS[key];
            })),
            style: _propTypes2.default.object,
            buttonStyle: _propTypes2.default.object,
            declineButtonStyle: _propTypes2.default.object,
            contentStyle: _propTypes2.default.object,
            children: _propTypes2.default.any,
            disableStyles: _propTypes2.default.bool,
            hideOnAccept: _propTypes2.default.bool,
            hideOnDecline: _propTypes2.default.bool,
            onAccept: _propTypes2.default.func,
            onDecline: _propTypes2.default.func,
            buttonText: _propTypes2.default.oneOfType([
                _propTypes2.default.string,
                _propTypes2.default.func,
                _propTypes2.default.element
            ]),
            declineButtonText: _propTypes2.default.oneOfType([
                _propTypes2.default.string,
                _propTypes2.default.func,
                _propTypes2.default.element
            ]),
            cookieName: _propTypes2.default.string,
            cookieValue: _propTypes2.default.oneOfType([
                _propTypes2.default.string,
                _propTypes2.default.bool,
                _propTypes2.default.number
            ]),
            declineCookieValue: _propTypes2.default.oneOfType([
                _propTypes2.default.string,
                _propTypes2.default.bool,
                _propTypes2.default.number
            ]),
            setDeclineCookie: _propTypes2.default.bool,
            debug: _propTypes2.default.bool,
            expires: _propTypes2.default.number,
            containerClasses: _propTypes2.default.string,
            contentClasses: _propTypes2.default.string,
            buttonClasses: _propTypes2.default.string,
            declineButtonClasses: _propTypes2.default.string,
            buttonId: _propTypes2.default.string,
            declineButtonId: _propTypes2.default.string,
            acceptOnScroll: _propTypes2.default.bool,
            acceptOnScrollPercentage: _propTypes2.default.number,
            extraCookieOptions: _propTypes2.default.object,
            disableButtonStyles: _propTypes2.default.bool,
            enableDeclineButton: _propTypes2.default.bool,
            flipButtons: _propTypes2.default.bool,
            ButtonComponent: _propTypes2.default.oneOfType([
                _propTypes2.default.func,
                _propTypes2.default.element
            ])
        };
        CookieConsent.defaultProps = {
            disableStyles: false,
            hideOnAccept: true,
            hideOnDecline: true,
            acceptOnScroll: false,
            acceptOnScrollPercentage: 25,
            location: OPTIONS.BOTTOM,
            onAccept: function onAccept() {},
            onDecline: function onDecline() {},
            cookieName: "CookieConsent",
            cookieValue: true,
            declineCookieValue: false,
            setDeclineCookie: true,
            buttonText: "I understand",
            declineButtonText: "I decline",
            debug: false,
            expires: 365,
            containerClasses: "",
            contentClasses: "",
            buttonClasses: "",
            declineButtonClasses: "",
            buttonId: "",
            declineButtonId: "",
            extraCookieOptions: {},
            disableButtonStyles: false,
            enableDeclineButton: false,
            flipButtons: false,
            ButtonComponent: function ButtonComponent(_ref) {
                var children = _ref.children, props = _objectWithoutProperties(_ref, [
                    "children"
                ]);
                return _react2.default.createElement("button", props, children);
            }
        };
        exports.default = CookieConsent;
        exports.Cookies = _jsCookie2.default;
    /***/ },
    /* 7 */ /***/ function(module1, exports, __webpack_require__) {
        "use strict";
        /*
object-assign
(c) Sindre Sorhus
@license MIT
*/ /* eslint-disable no-unused-vars */ var getOwnPropertySymbols = Object.getOwnPropertySymbols;
        var hasOwnProperty = Object.prototype.hasOwnProperty;
        var propIsEnumerable = Object.prototype.propertyIsEnumerable;
        function toObject(val) {
            if (val === null || val === undefined) throw new TypeError("Object.assign cannot be called with null or undefined");
            return Object(val);
        }
        function shouldUseNative() {
            try {
                if (!Object.assign) return false;
                // Detect buggy property enumeration order in older V8 versions.
                // https://bugs.chromium.org/p/v8/issues/detail?id=4118
                var test1 = new String("abc"); // eslint-disable-line no-new-wrappers
                test1[5] = "de";
                if (Object.getOwnPropertyNames(test1)[0] === "5") return false;
                // https://bugs.chromium.org/p/v8/issues/detail?id=3056
                var test2 = {};
                for(var i = 0; i < 10; i++)test2["_" + String.fromCharCode(i)] = i;
                var order2 = Object.getOwnPropertyNames(test2).map(function(n) {
                    return test2[n];
                });
                if (order2.join("") !== "0123456789") return false;
                // https://bugs.chromium.org/p/v8/issues/detail?id=3056
                var test3 = {};
                "abcdefghijklmnopqrst".split("").forEach(function(letter) {
                    test3[letter] = letter;
                });
                if (Object.keys(Object.assign({}, test3)).join("") !== "abcdefghijklmnopqrst") return false;
                return true;
            } catch (err) {
                // We don't expect any of the above to throw, but better to be safe.
                return false;
            }
        }
        module1.exports = shouldUseNative() ? Object.assign : function(target, source) {
            var from;
            var to = toObject(target);
            var symbols;
            for(var s = 1; s < arguments.length; s++){
                from = Object(arguments[s]);
                for(var key in from)if (hasOwnProperty.call(from, key)) to[key] = from[key];
                if (getOwnPropertySymbols) {
                    symbols = getOwnPropertySymbols(from);
                    for(var i = 0; i < symbols.length; i++)if (propIsEnumerable.call(from, symbols[i])) to[symbols[i]] = from[symbols[i]];
                }
            }
            return to;
        };
    /***/ },
    /* 8 */ /***/ function(module1, exports, __webpack_require__) {
        "use strict";
        /* WEBPACK VAR INJECTION */ (function(process) {
            var printWarning = function() {};
            if (process.env.NODE_ENV !== "production") {
                var ReactPropTypesSecret = __webpack_require__(1);
                var loggedTypeFailures = {};
                var has = Function.call.bind(Object.prototype.hasOwnProperty);
                printWarning = function(text) {
                    var message = "Warning: " + text;
                    if (typeof console !== "undefined") console.error(message);
                    try {
                        // --- Welcome to debugging React ---
                        // This error was thrown as a convenience so that you can use this stack
                        // to find the callsite that caused this warning to fire.
                        throw new Error(message);
                    } catch (x) {}
                };
            }
            /**
 * Assert that the values match with the type specs.
 * Error messages are memorized and will only be shown once.
 *
 * @param {object} typeSpecs Map of name to a ReactPropType
 * @param {object} values Runtime values that need to be type-checked
 * @param {string} location e.g. "prop", "context", "child context"
 * @param {string} componentName Name of the component for error messages.
 * @param {?Function} getStack Returns the component stack.
 * @private
 */ function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
                if (process.env.NODE_ENV !== "production") {
                    for(var typeSpecName in typeSpecs)if (has(typeSpecs, typeSpecName)) {
                        var error;
                        // Prop type validation may throw. In case they do, we don't want to
                        // fail the render phase where it didn't fail before. So we log it.
                        // After these have been cleaned up, we'll let them throw.
                        try {
                            // This is intentionally an invariant that gets caught. It's the same
                            // behavior as without this statement except with a better message.
                            if (typeof typeSpecs[typeSpecName] !== "function") {
                                var err = Error((componentName || "React class") + ": " + location + " type `" + typeSpecName + "` is invalid; " + "it must be a function, usually from the `prop-types` package, but received `" + typeof typeSpecs[typeSpecName] + "`.");
                                err.name = "Invariant Violation";
                                throw err;
                            }
                            error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
                        } catch (ex) {
                            error = ex;
                        }
                        if (error && !(error instanceof Error)) printWarning((componentName || "React class") + ": type specification of " + location + " `" + typeSpecName + "` is invalid; the type checker " + "function must return `null` or an `Error` but returned a " + typeof error + ". " + "You may have forgotten to pass an argument to the type checker " + "creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and " + "shape all require an argument).");
                        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
                            // Only monitor this failure once because there tends to be a lot of the
                            // same error.
                            loggedTypeFailures[error.message] = true;
                            var stack = getStack ? getStack() : "";
                            printWarning("Failed " + location + " type: " + error.message + (stack != null ? stack : ""));
                        }
                    }
                }
            }
            /**
 * Resets warning cache when testing.
 *
 * @private
 */ checkPropTypes.resetWarningCache = function() {
                if (process.env.NODE_ENV !== "production") loggedTypeFailures = {};
            };
            module1.exports = checkPropTypes;
        /* WEBPACK VAR INJECTION */ }).call(exports, __webpack_require__(0));
    /***/ },
    /* 9 */ /***/ function(module1, exports, __webpack_require__) {
        "use strict";
        /**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var ReactPropTypesSecret = __webpack_require__(1);
        function emptyFunction() {}
        function emptyFunctionWithReset() {}
        emptyFunctionWithReset.resetWarningCache = emptyFunction;
        module1.exports = function() {
            function shim(props, propName, componentName, location, propFullName, secret) {
                if (secret === ReactPropTypesSecret) // It is still safe when called from React.
                return;
                var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
                err.name = "Invariant Violation";
                throw err;
            }
            shim.isRequired = shim;
            function getShim() {
                return shim;
            }
            // Important!
            // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
            var ReactPropTypes = {
                array: shim,
                bool: shim,
                func: shim,
                number: shim,
                object: shim,
                string: shim,
                symbol: shim,
                any: shim,
                arrayOf: getShim,
                element: shim,
                elementType: shim,
                instanceOf: getShim,
                node: shim,
                objectOf: getShim,
                oneOf: getShim,
                oneOfType: getShim,
                shape: getShim,
                exact: getShim,
                checkPropTypes: emptyFunctionWithReset,
                resetWarningCache: emptyFunction
            };
            ReactPropTypes.PropTypes = ReactPropTypes;
            return ReactPropTypes;
        };
    /***/ },
    /* 10 */ /***/ function(module1, exports, __webpack_require__) {
        "use strict";
        /* WEBPACK VAR INJECTION */ (function(process) {
            var ReactIs = __webpack_require__(2);
            var assign = __webpack_require__(7);
            var ReactPropTypesSecret = __webpack_require__(1);
            var checkPropTypes = __webpack_require__(8);
            var has = Function.call.bind(Object.prototype.hasOwnProperty);
            var printWarning = function() {};
            if (process.env.NODE_ENV !== "production") printWarning = function(text) {
                var message = "Warning: " + text;
                if (typeof console !== "undefined") console.error(message);
                try {
                    // --- Welcome to debugging React ---
                    // This error was thrown as a convenience so that you can use this stack
                    // to find the callsite that caused this warning to fire.
                    throw new Error(message);
                } catch (x) {}
            };
            function emptyFunctionThatReturnsNull() {
                return null;
            }
            module1.exports = function(isValidElement, throwOnDirectAccess) {
                /* global Symbol */ var ITERATOR_SYMBOL = typeof Symbol === "function" && Symbol.iterator;
                var FAUX_ITERATOR_SYMBOL = "@@iterator"; // Before Symbol spec.
                /**
   * Returns the iterator method function contained on the iterable object.
   *
   * Be sure to invoke the function with the iterable as context:
   *
   *     var iteratorFn = getIteratorFn(myIterable);
   *     if (iteratorFn) {
   *       var iterator = iteratorFn.call(myIterable);
   *       ...
   *     }
   *
   * @param {?object} maybeIterable
   * @return {?function}
   */ function getIteratorFn(maybeIterable) {
                    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
                    if (typeof iteratorFn === "function") return iteratorFn;
                }
                /**
   * Collection of methods that allow declaration and validation of props that are
   * supplied to React components. Example usage:
   *
   *   var Props = require('ReactPropTypes');
   *   var MyArticle = React.createClass({
   *     propTypes: {
   *       // An optional string prop named "description".
   *       description: Props.string,
   *
   *       // A required enum prop named "category".
   *       category: Props.oneOf(['News','Photos']).isRequired,
   *
   *       // A prop named "dialog" that requires an instance of Dialog.
   *       dialog: Props.instanceOf(Dialog).isRequired
   *     },
   *     render: function() { ... }
   *   });
   *
   * A more formal specification of how these methods are used:
   *
   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
   *   decl := ReactPropTypes.{type}(.isRequired)?
   *
   * Each and every declaration produces a function with the same signature. This
   * allows the creation of custom validation functions. For example:
   *
   *  var MyLink = React.createClass({
   *    propTypes: {
   *      // An optional string or URI prop named "href".
   *      href: function(props, propName, componentName) {
   *        var propValue = props[propName];
   *        if (propValue != null && typeof propValue !== 'string' &&
   *            !(propValue instanceof URI)) {
   *          return new Error(
   *            'Expected a string or an URI for ' + propName + ' in ' +
   *            componentName
   *          );
   *        }
   *      }
   *    },
   *    render: function() {...}
   *  });
   *
   * @internal
   */ var ANONYMOUS = "<<anonymous>>";
                // Important!
                // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
                var ReactPropTypes = {
                    array: createPrimitiveTypeChecker("array"),
                    bool: createPrimitiveTypeChecker("boolean"),
                    func: createPrimitiveTypeChecker("function"),
                    number: createPrimitiveTypeChecker("number"),
                    object: createPrimitiveTypeChecker("object"),
                    string: createPrimitiveTypeChecker("string"),
                    symbol: createPrimitiveTypeChecker("symbol"),
                    any: createAnyTypeChecker(),
                    arrayOf: createArrayOfTypeChecker,
                    element: createElementTypeChecker(),
                    elementType: createElementTypeTypeChecker(),
                    instanceOf: createInstanceTypeChecker,
                    node: createNodeChecker(),
                    objectOf: createObjectOfTypeChecker,
                    oneOf: createEnumTypeChecker,
                    oneOfType: createUnionTypeChecker,
                    shape: createShapeTypeChecker,
                    exact: createStrictShapeTypeChecker
                };
                /**
   * inlined Object.is polyfill to avoid requiring consumers ship their own
   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
   */ /*eslint-disable no-self-compare*/ function is(x, y) {
                    // SameValue algorithm
                    if (x === y) // Steps 1-5, 7-10
                    // Steps 6.b-6.e: +0 != -0
                    return x !== 0 || 1 / x === 1 / y;
                    else // Step 6.a: NaN == NaN
                    return x !== x && y !== y;
                }
                /*eslint-enable no-self-compare*/ /**
   * We use an Error-like object for backward compatibility as people may call
   * PropTypes directly and inspect their output. However, we don't use real
   * Errors anymore. We don't inspect their stack anyway, and creating them
   * is prohibitively expensive if they are created too often, such as what
   * happens in oneOfType() for any type before the one that matched.
   */ function PropTypeError(message) {
                    this.message = message;
                    this.stack = "";
                }
                // Make `instanceof Error` still work for returned errors.
                PropTypeError.prototype = Error.prototype;
                function createChainableTypeChecker(validate) {
                    if (process.env.NODE_ENV !== "production") {
                        var manualPropTypeCallCache = {};
                        var manualPropTypeWarningCount = 0;
                    }
                    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
                        componentName = componentName || ANONYMOUS;
                        propFullName = propFullName || propName;
                        if (secret !== ReactPropTypesSecret) {
                            if (throwOnDirectAccess) {
                                // New behavior only for users of `prop-types` package
                                var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types");
                                err.name = "Invariant Violation";
                                throw err;
                            } else if (process.env.NODE_ENV !== "production" && typeof console !== "undefined") {
                                // Old behavior for people using React.PropTypes
                                var cacheKey = componentName + ":" + propName;
                                if (!manualPropTypeCallCache[cacheKey] && // Avoid spamming the console because they are often not actionable except for lib authors
                                manualPropTypeWarningCount < 3) {
                                    printWarning("You are manually calling a React.PropTypes validation function for the `" + propFullName + "` prop on `" + componentName + "`. This is deprecated " + "and will throw in the standalone `prop-types` package. " + "You may be seeing this warning due to a third-party PropTypes " + "library. See https://fb.me/react-warning-dont-call-proptypes " + "for details.");
                                    manualPropTypeCallCache[cacheKey] = true;
                                    manualPropTypeWarningCount++;
                                }
                            }
                        }
                        if (props[propName] == null) {
                            if (isRequired) {
                                if (props[propName] === null) return new PropTypeError("The " + location + " `" + propFullName + "` is marked as required " + ("in `" + componentName + "`, but its value is `null`."));
                                return new PropTypeError("The " + location + " `" + propFullName + "` is marked as required in " + ("`" + componentName + "`, but its value is `undefined`."));
                            }
                            return null;
                        } else return validate(props, propName, componentName, location, propFullName);
                    }
                    var chainedCheckType = checkType.bind(null, false);
                    chainedCheckType.isRequired = checkType.bind(null, true);
                    return chainedCheckType;
                }
                function createPrimitiveTypeChecker(expectedType) {
                    function validate(props, propName, componentName, location, propFullName, secret) {
                        var propValue = props[propName];
                        var propType = getPropType(propValue);
                        if (propType !== expectedType) {
                            // `propValue` being instance of, say, date/regexp, pass the 'object'
                            // check, but we can offer a more precise error message here rather than
                            // 'of type `object`'.
                            var preciseType = getPreciseType(propValue);
                            return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type " + ("`" + preciseType + "` supplied to `" + componentName + "`, expected ") + ("`" + expectedType + "`."));
                        }
                        return null;
                    }
                    return createChainableTypeChecker(validate);
                }
                function createAnyTypeChecker() {
                    return createChainableTypeChecker(emptyFunctionThatReturnsNull);
                }
                function createArrayOfTypeChecker(typeChecker) {
                    function validate(props, propName, componentName, location, propFullName) {
                        if (typeof typeChecker !== "function") return new PropTypeError("Property `" + propFullName + "` of component `" + componentName + "` has invalid PropType notation inside arrayOf.");
                        var propValue = props[propName];
                        if (!Array.isArray(propValue)) {
                            var propType = getPropType(propValue);
                            return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type " + ("`" + propType + "` supplied to `" + componentName + "`, expected an array."));
                        }
                        for(var i = 0; i < propValue.length; i++){
                            var error = typeChecker(propValue, i, componentName, location, propFullName + "[" + i + "]", ReactPropTypesSecret);
                            if (error instanceof Error) return error;
                        }
                        return null;
                    }
                    return createChainableTypeChecker(validate);
                }
                function createElementTypeChecker() {
                    function validate(props, propName, componentName, location, propFullName) {
                        var propValue = props[propName];
                        if (!isValidElement(propValue)) {
                            var propType = getPropType(propValue);
                            return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type " + ("`" + propType + "` supplied to `" + componentName + "`, expected a single ReactElement."));
                        }
                        return null;
                    }
                    return createChainableTypeChecker(validate);
                }
                function createElementTypeTypeChecker() {
                    function validate(props, propName, componentName, location, propFullName) {
                        var propValue = props[propName];
                        if (!ReactIs.isValidElementType(propValue)) {
                            var propType = getPropType(propValue);
                            return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type " + ("`" + propType + "` supplied to `" + componentName + "`, expected a single ReactElement type."));
                        }
                        return null;
                    }
                    return createChainableTypeChecker(validate);
                }
                function createInstanceTypeChecker(expectedClass) {
                    function validate(props, propName, componentName, location, propFullName) {
                        if (!(props[propName] instanceof expectedClass)) {
                            var expectedClassName = expectedClass.name || ANONYMOUS;
                            var actualClassName = getClassName(props[propName]);
                            return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type " + ("`" + actualClassName + "` supplied to `" + componentName + "`, expected ") + ("instance of `" + expectedClassName + "`."));
                        }
                        return null;
                    }
                    return createChainableTypeChecker(validate);
                }
                function createEnumTypeChecker(expectedValues) {
                    if (!Array.isArray(expectedValues)) {
                        if (process.env.NODE_ENV !== "production") {
                            if (arguments.length > 1) printWarning("Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. " + "A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z]).");
                            else printWarning("Invalid argument supplied to oneOf, expected an array.");
                        }
                        return emptyFunctionThatReturnsNull;
                    }
                    function validate(props, propName, componentName, location, propFullName) {
                        var propValue = props[propName];
                        for(var i = 0; i < expectedValues.length; i++){
                            if (is(propValue, expectedValues[i])) return null;
                        }
                        var valuesString = JSON.stringify(expectedValues, function replacer(key, value) {
                            var type = getPreciseType(value);
                            if (type === "symbol") return String(value);
                            return value;
                        });
                        return new PropTypeError("Invalid " + location + " `" + propFullName + "` of value `" + String(propValue) + "` " + ("supplied to `" + componentName + "`, expected one of " + valuesString + "."));
                    }
                    return createChainableTypeChecker(validate);
                }
                function createObjectOfTypeChecker(typeChecker) {
                    function validate(props, propName, componentName, location, propFullName) {
                        if (typeof typeChecker !== "function") return new PropTypeError("Property `" + propFullName + "` of component `" + componentName + "` has invalid PropType notation inside objectOf.");
                        var propValue = props[propName];
                        var propType = getPropType(propValue);
                        if (propType !== "object") return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type " + ("`" + propType + "` supplied to `" + componentName + "`, expected an object."));
                        for(var key in propValue)if (has(propValue, key)) {
                            var error = typeChecker(propValue, key, componentName, location, propFullName + "." + key, ReactPropTypesSecret);
                            if (error instanceof Error) return error;
                        }
                        return null;
                    }
                    return createChainableTypeChecker(validate);
                }
                function createUnionTypeChecker(arrayOfTypeCheckers) {
                    if (!Array.isArray(arrayOfTypeCheckers)) {
                        process.env.NODE_ENV !== "production" && printWarning("Invalid argument supplied to oneOfType, expected an instance of array.");
                        return emptyFunctionThatReturnsNull;
                    }
                    for(var i = 0; i < arrayOfTypeCheckers.length; i++){
                        var checker = arrayOfTypeCheckers[i];
                        if (typeof checker !== "function") {
                            printWarning("Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + getPostfixForTypeWarning(checker) + " at index " + i + ".");
                            return emptyFunctionThatReturnsNull;
                        }
                    }
                    function validate(props, propName, componentName, location, propFullName) {
                        for(var i = 0; i < arrayOfTypeCheckers.length; i++){
                            var checker = arrayOfTypeCheckers[i];
                            if (checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret) == null) return null;
                        }
                        return new PropTypeError("Invalid " + location + " `" + propFullName + "` supplied to " + ("`" + componentName + "`."));
                    }
                    return createChainableTypeChecker(validate);
                }
                function createNodeChecker() {
                    function validate(props, propName, componentName, location, propFullName) {
                        if (!isNode(props[propName])) return new PropTypeError("Invalid " + location + " `" + propFullName + "` supplied to " + ("`" + componentName + "`, expected a ReactNode."));
                        return null;
                    }
                    return createChainableTypeChecker(validate);
                }
                function createShapeTypeChecker(shapeTypes) {
                    function validate(props, propName, componentName, location, propFullName) {
                        var propValue = props[propName];
                        var propType = getPropType(propValue);
                        if (propType !== "object") return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type `" + propType + "` " + ("supplied to `" + componentName + "`, expected `object`."));
                        for(var key in shapeTypes){
                            var checker = shapeTypes[key];
                            if (!checker) continue;
                            var error = checker(propValue, key, componentName, location, propFullName + "." + key, ReactPropTypesSecret);
                            if (error) return error;
                        }
                        return null;
                    }
                    return createChainableTypeChecker(validate);
                }
                function createStrictShapeTypeChecker(shapeTypes) {
                    function validate(props, propName, componentName, location, propFullName) {
                        var propValue = props[propName];
                        var propType = getPropType(propValue);
                        if (propType !== "object") return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type `" + propType + "` " + ("supplied to `" + componentName + "`, expected `object`."));
                        // We need to check all keys in case some are required but missing from
                        // props.
                        var allKeys = assign({}, props[propName], shapeTypes);
                        for(var key in allKeys){
                            var checker = shapeTypes[key];
                            if (!checker) return new PropTypeError("Invalid " + location + " `" + propFullName + "` key `" + key + "` supplied to `" + componentName + "`." + "\nBad object: " + JSON.stringify(props[propName], null, "  ") + "\nValid keys: " + JSON.stringify(Object.keys(shapeTypes), null, "  "));
                            var error = checker(propValue, key, componentName, location, propFullName + "." + key, ReactPropTypesSecret);
                            if (error) return error;
                        }
                        return null;
                    }
                    return createChainableTypeChecker(validate);
                }
                function isNode(propValue) {
                    switch(typeof propValue){
                        case "number":
                        case "string":
                        case "undefined":
                            return true;
                        case "boolean":
                            return !propValue;
                        case "object":
                            if (Array.isArray(propValue)) return propValue.every(isNode);
                            if (propValue === null || isValidElement(propValue)) return true;
                            var iteratorFn = getIteratorFn(propValue);
                            if (iteratorFn) {
                                var iterator = iteratorFn.call(propValue);
                                var step;
                                if (iteratorFn !== propValue.entries) while(!(step = iterator.next()).done){
                                    if (!isNode(step.value)) return false;
                                }
                                else // Iterator will provide entry [k,v] tuples rather than values.
                                while(!(step = iterator.next()).done){
                                    var entry = step.value;
                                    if (entry) {
                                        if (!isNode(entry[1])) return false;
                                    }
                                }
                            } else return false;
                            return true;
                        default:
                            return false;
                    }
                }
                function isSymbol(propType, propValue) {
                    // Native Symbol.
                    if (propType === "symbol") return true;
                    // falsy value can't be a Symbol
                    if (!propValue) return false;
                    // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
                    if (propValue["@@toStringTag"] === "Symbol") return true;
                    // Fallback for non-spec compliant Symbols which are polyfilled.
                    if (typeof Symbol === "function" && propValue instanceof Symbol) return true;
                    return false;
                }
                // Equivalent of `typeof` but with special handling for array and regexp.
                function getPropType(propValue) {
                    var propType = typeof propValue;
                    if (Array.isArray(propValue)) return "array";
                    if (propValue instanceof RegExp) // Old webkits (at least until Android 4.0) return 'function' rather than
                    // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
                    // passes PropTypes.object.
                    return "object";
                    if (isSymbol(propType, propValue)) return "symbol";
                    return propType;
                }
                // This handles more types than `getPropType`. Only used for error messages.
                // See `createPrimitiveTypeChecker`.
                function getPreciseType(propValue) {
                    if (typeof propValue === "undefined" || propValue === null) return "" + propValue;
                    var propType = getPropType(propValue);
                    if (propType === "object") {
                        if (propValue instanceof Date) return "date";
                        else if (propValue instanceof RegExp) return "regexp";
                    }
                    return propType;
                }
                // Returns a string that is postfixed to a warning about an invalid type.
                // For example, "undefined" or "of type array"
                function getPostfixForTypeWarning(value) {
                    var type = getPreciseType(value);
                    switch(type){
                        case "array":
                        case "object":
                            return "an " + type;
                        case "boolean":
                        case "date":
                        case "regexp":
                            return "a " + type;
                        default:
                            return type;
                    }
                }
                // Returns class name of the object, if any.
                function getClassName(propValue) {
                    if (!propValue.constructor || !propValue.constructor.name) return ANONYMOUS;
                    return propValue.constructor.name;
                }
                ReactPropTypes.checkPropTypes = checkPropTypes;
                ReactPropTypes.resetWarningCache = checkPropTypes.resetWarningCache;
                ReactPropTypes.PropTypes = ReactPropTypes;
                return ReactPropTypes;
            };
        /* WEBPACK VAR INJECTION */ }).call(exports, __webpack_require__(0));
    /***/ },
    /* 11 */ /***/ function(module1, exports, __webpack_require__) {
        "use strict";
        /* WEBPACK VAR INJECTION */ (function(process) {
            if (process.env.NODE_ENV !== "production") (function() {
                "use strict";
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                // The Symbol used to tag the ReactElement-like types. If there is no native Symbol
                // nor polyfill, then a plain number is used for performance.
                var hasSymbol = typeof Symbol === "function" && Symbol.for;
                var REACT_ELEMENT_TYPE = hasSymbol ? Symbol.for("react.element") : 0xeac7;
                var REACT_PORTAL_TYPE = hasSymbol ? Symbol.for("react.portal") : 0xeaca;
                var REACT_FRAGMENT_TYPE = hasSymbol ? Symbol.for("react.fragment") : 0xeacb;
                var REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol.for("react.strict_mode") : 0xeacc;
                var REACT_PROFILER_TYPE = hasSymbol ? Symbol.for("react.profiler") : 0xead2;
                var REACT_PROVIDER_TYPE = hasSymbol ? Symbol.for("react.provider") : 0xeacd;
                var REACT_CONTEXT_TYPE = hasSymbol ? Symbol.for("react.context") : 0xeace;
                var REACT_ASYNC_MODE_TYPE = hasSymbol ? Symbol.for("react.async_mode") : 0xeacf;
                var REACT_CONCURRENT_MODE_TYPE = hasSymbol ? Symbol.for("react.concurrent_mode") : 0xeacf;
                var REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol.for("react.forward_ref") : 0xead0;
                var REACT_SUSPENSE_TYPE = hasSymbol ? Symbol.for("react.suspense") : 0xead1;
                var REACT_MEMO_TYPE = hasSymbol ? Symbol.for("react.memo") : 0xead3;
                var REACT_LAZY_TYPE = hasSymbol ? Symbol.for("react.lazy") : 0xead4;
                function isValidElementType(type) {
                    return typeof type === "string" || typeof type === "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
                    type === REACT_FRAGMENT_TYPE || type === REACT_CONCURRENT_MODE_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || typeof type === "object" && type !== null && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE);
                }
                /**
 * Forked from fbjs/warning:
 * https://github.com/facebook/fbjs/blob/e66ba20ad5be433eb54423f2b097d829324d9de6/packages/fbjs/src/__forks__/warning.js
 *
 * Only change is we use console.warn instead of console.error,
 * and do nothing when 'console' is not supported.
 * This really simplifies the code.
 * ---
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */ var lowPriorityWarning = function() {};
                var printWarning = function(format) {
                    for(var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
                    var argIndex = 0;
                    var message = "Warning: " + format.replace(/%s/g, function() {
                        return args[argIndex++];
                    });
                    if (typeof console !== "undefined") console.warn(message);
                    try {
                        // --- Welcome to debugging React ---
                        // This error was thrown as a convenience so that you can use this stack
                        // to find the callsite that caused this warning to fire.
                        throw new Error(message);
                    } catch (x) {}
                };
                lowPriorityWarning = function(condition, format) {
                    if (format === undefined) throw new Error("`lowPriorityWarning(condition, format, ...args)` requires a warning message argument");
                    if (!condition) {
                        for(var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++)args[_key2 - 2] = arguments[_key2];
                        printWarning.apply(undefined, [
                            format
                        ].concat(args));
                    }
                };
                var lowPriorityWarning$1 = lowPriorityWarning;
                function typeOf(object) {
                    if (typeof object === "object" && object !== null) {
                        var $$typeof = object.$$typeof;
                        switch($$typeof){
                            case REACT_ELEMENT_TYPE:
                                var type = object.type;
                                switch(type){
                                    case REACT_ASYNC_MODE_TYPE:
                                    case REACT_CONCURRENT_MODE_TYPE:
                                    case REACT_FRAGMENT_TYPE:
                                    case REACT_PROFILER_TYPE:
                                    case REACT_STRICT_MODE_TYPE:
                                    case REACT_SUSPENSE_TYPE:
                                        return type;
                                    default:
                                        var $$typeofType = type && type.$$typeof;
                                        switch($$typeofType){
                                            case REACT_CONTEXT_TYPE:
                                            case REACT_FORWARD_REF_TYPE:
                                            case REACT_PROVIDER_TYPE:
                                                return $$typeofType;
                                            default:
                                                return $$typeof;
                                        }
                                }
                            case REACT_LAZY_TYPE:
                            case REACT_MEMO_TYPE:
                            case REACT_PORTAL_TYPE:
                                return $$typeof;
                        }
                    }
                    return undefined;
                }
                // AsyncMode is deprecated along with isAsyncMode
                var AsyncMode = REACT_ASYNC_MODE_TYPE;
                var ConcurrentMode = REACT_CONCURRENT_MODE_TYPE;
                var ContextConsumer = REACT_CONTEXT_TYPE;
                var ContextProvider = REACT_PROVIDER_TYPE;
                var Element = REACT_ELEMENT_TYPE;
                var ForwardRef = REACT_FORWARD_REF_TYPE;
                var Fragment = REACT_FRAGMENT_TYPE;
                var Lazy = REACT_LAZY_TYPE;
                var Memo = REACT_MEMO_TYPE;
                var Portal = REACT_PORTAL_TYPE;
                var Profiler = REACT_PROFILER_TYPE;
                var StrictMode = REACT_STRICT_MODE_TYPE;
                var Suspense = REACT_SUSPENSE_TYPE;
                var hasWarnedAboutDeprecatedIsAsyncMode = false;
                // AsyncMode should be deprecated
                function isAsyncMode(object) {
                    if (!hasWarnedAboutDeprecatedIsAsyncMode) {
                        hasWarnedAboutDeprecatedIsAsyncMode = true;
                        lowPriorityWarning$1(false, "The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.");
                    }
                    return isConcurrentMode(object) || typeOf(object) === REACT_ASYNC_MODE_TYPE;
                }
                function isConcurrentMode(object) {
                    return typeOf(object) === REACT_CONCURRENT_MODE_TYPE;
                }
                function isContextConsumer(object) {
                    return typeOf(object) === REACT_CONTEXT_TYPE;
                }
                function isContextProvider(object) {
                    return typeOf(object) === REACT_PROVIDER_TYPE;
                }
                function isElement(object) {
                    return typeof object === "object" && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
                }
                function isForwardRef(object) {
                    return typeOf(object) === REACT_FORWARD_REF_TYPE;
                }
                function isFragment(object) {
                    return typeOf(object) === REACT_FRAGMENT_TYPE;
                }
                function isLazy(object) {
                    return typeOf(object) === REACT_LAZY_TYPE;
                }
                function isMemo(object) {
                    return typeOf(object) === REACT_MEMO_TYPE;
                }
                function isPortal(object) {
                    return typeOf(object) === REACT_PORTAL_TYPE;
                }
                function isProfiler(object) {
                    return typeOf(object) === REACT_PROFILER_TYPE;
                }
                function isStrictMode(object) {
                    return typeOf(object) === REACT_STRICT_MODE_TYPE;
                }
                function isSuspense(object) {
                    return typeOf(object) === REACT_SUSPENSE_TYPE;
                }
                exports.typeOf = typeOf;
                exports.AsyncMode = AsyncMode;
                exports.ConcurrentMode = ConcurrentMode;
                exports.ContextConsumer = ContextConsumer;
                exports.ContextProvider = ContextProvider;
                exports.Element = Element;
                exports.ForwardRef = ForwardRef;
                exports.Fragment = Fragment;
                exports.Lazy = Lazy;
                exports.Memo = Memo;
                exports.Portal = Portal;
                exports.Profiler = Profiler;
                exports.StrictMode = StrictMode;
                exports.Suspense = Suspense;
                exports.isValidElementType = isValidElementType;
                exports.isAsyncMode = isAsyncMode;
                exports.isConcurrentMode = isConcurrentMode;
                exports.isContextConsumer = isContextConsumer;
                exports.isContextProvider = isContextProvider;
                exports.isElement = isElement;
                exports.isForwardRef = isForwardRef;
                exports.isFragment = isFragment;
                exports.isLazy = isLazy;
                exports.isMemo = isMemo;
                exports.isPortal = isPortal;
                exports.isProfiler = isProfiler;
                exports.isStrictMode = isStrictMode;
                exports.isSuspense = isSuspense;
            })();
        /* WEBPACK VAR INJECTION */ }).call(exports, __webpack_require__(0));
    /***/ },
    /* 12 */ /***/ function(module1, exports, __webpack_require__) {
        "use strict";
        /** @license React v16.8.6
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ Object.defineProperty(exports, "__esModule", {
            value: !0
        });
        var b = "function" === typeof Symbol && Symbol.for, c = b ? Symbol.for("react.element") : 60103, d = b ? Symbol.for("react.portal") : 60106, e = b ? Symbol.for("react.fragment") : 60107, f = b ? Symbol.for("react.strict_mode") : 60108, g = b ? Symbol.for("react.profiler") : 60114, h = b ? Symbol.for("react.provider") : 60109, k = b ? Symbol.for("react.context") : 60110, l = b ? Symbol.for("react.async_mode") : 60111, m = b ? Symbol.for("react.concurrent_mode") : 60111, n = b ? Symbol.for("react.forward_ref") : 60112, p = b ? Symbol.for("react.suspense") : 60113, q = b ? Symbol.for("react.memo") : 60115, r = b ? Symbol.for("react.lazy") : 60116;
        function t(a) {
            if ("object" === typeof a && null !== a) {
                var u = a.$$typeof;
                switch(u){
                    case c:
                        switch(a = a.type, a){
                            case l:
                            case m:
                            case e:
                            case g:
                            case f:
                            case p:
                                return a;
                            default:
                                switch(a = a && a.$$typeof, a){
                                    case k:
                                    case n:
                                    case h:
                                        return a;
                                    default:
                                        return u;
                                }
                        }
                    case r:
                    case q:
                    case d:
                        return u;
                }
            }
        }
        function v(a) {
            return t(a) === m;
        }
        exports.typeOf = t;
        exports.AsyncMode = l;
        exports.ConcurrentMode = m;
        exports.ContextConsumer = k;
        exports.ContextProvider = h;
        exports.Element = c;
        exports.ForwardRef = n;
        exports.Fragment = e;
        exports.Lazy = r;
        exports.Memo = q;
        exports.Portal = d;
        exports.Profiler = g;
        exports.StrictMode = f;
        exports.Suspense = p;
        exports.isValidElementType = function(a) {
            return "string" === typeof a || "function" === typeof a || a === e || a === m || a === g || a === f || a === p || "object" === typeof a && null !== a && (a.$$typeof === r || a.$$typeof === q || a.$$typeof === h || a.$$typeof === k || a.$$typeof === n);
        };
        exports.isAsyncMode = function(a) {
            return v(a) || t(a) === l;
        };
        exports.isConcurrentMode = v;
        exports.isContextConsumer = function(a) {
            return t(a) === k;
        };
        exports.isContextProvider = function(a) {
            return t(a) === h;
        };
        exports.isElement = function(a) {
            return "object" === typeof a && null !== a && a.$$typeof === c;
        };
        exports.isForwardRef = function(a) {
            return t(a) === n;
        };
        exports.isFragment = function(a) {
            return t(a) === e;
        };
        exports.isLazy = function(a) {
            return t(a) === r;
        };
        exports.isMemo = function(a) {
            return t(a) === q;
        };
        exports.isPortal = function(a) {
            return t(a) === d;
        };
        exports.isProfiler = function(a) {
            return t(a) === g;
        };
        exports.isStrictMode = function(a) {
            return t(a) === f;
        };
        exports.isSuspense = function(a) {
            return t(a) === p;
        };
    /***/ }
]);

},{"cc0f267969ea95e7":"6uln9"}],"fp8yb":[function(require,module,exports) {
module.exports = require("4a6a22f2135dae67").getBundleURL("kVLro") + require("dd705af7a3c6a5bf").resolve("c9AgK");

},{"4a6a22f2135dae67":"c7Tr5","dd705af7a3c6a5bf":"fyJL2"}],"7qtwU":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _loader = require("../../components/general/Loader");
var _loaderDefault = parcelHelpers.interopDefault(_loader);
var _unstated = require("unstated");
var _authContainer = require("../../state/containers/AuthContainer");
var _authContainerDefault = parcelHelpers.interopDefault(_authContainer);
var _reactRouter = require("react-router");
var _userContainer = require("../../state/containers/UserContainer");
var _userContainerDefault = parcelHelpers.interopDefault(_userContainer);
class SingleSignOnLoginRedirector extends (0, _reactDefault.default).Component {
    render() {
        return (0, _react.jsx)((0, _unstated.Subscribe), {
            to: [
                (0, _authContainerDefault.default),
                (0, _userContainerDefault.default)
            ]
        }, (authContainer, userContainer)=>(0, _react.jsx)(SingleSignOnRedirectorChild, {
                authContainer: authContainer,
                userContainer: userContainer,
                invitationCode: this.props.match.params.invitationCode
            }));
    }
}
class SingleSignOnRedirectorChild extends (0, _reactDefault.default).Component {
    componentDidMount() {
        const urlParams = new URLSearchParams(window.location.search);
        const email = urlParams.get("email");
        const token = urlParams.get("token");
        this.props.authContainer.signInWithSingleSignOn(email, token).then((result)=>{
            if (result.resultType == "Ok" && this.props.invitationCode !== undefined) this.props.userContainer.acceptInvitation(this.props.invitationCode);
        });
    }
    render() {
        if (this.props.authContainer.state.isAuthenticated === true) return (0, _react.jsx)((0, _reactRouter.Redirect), {
            to: "/v"
        });
        return (0, _react.jsx)((0, _loaderDefault.default), null);
    }
}
exports.default = SingleSignOnLoginRedirector;

},{"@emotion/react":"djZKr","react":"6uln9","../../components/general/Loader":"bnV5T","unstated":"grh7p","../../state/containers/AuthContainer":"cl1Qb","react-router":"i3TiW","../../state/containers/UserContainer":"jDrDR","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3ttMK":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _loader = require("../../components/general/Loader");
var _loaderDefault = parcelHelpers.interopDefault(_loader);
var _unstated = require("unstated");
var _authContainer = require("../../state/containers/AuthContainer");
var _authContainerDefault = parcelHelpers.interopDefault(_authContainer);
var _acceptor = require("../acceptInvitation/components/Acceptor");
var _acceptorDefault = parcelHelpers.interopDefault(_acceptor);
var _organizationContainer = require("../../state/containers/OrganizationContainer");
var _organizationContainerDefault = parcelHelpers.interopDefault(_organizationContainer);
var _userContainer = require("../../state/containers/UserContainer");
var _userContainerDefault = parcelHelpers.interopDefault(_userContainer);
class SingleSignOnSignUpRedirector extends (0, _reactDefault.default).Component {
    render() {
        return (0, _react.jsx)((0, _unstated.Subscribe), {
            to: [
                (0, _authContainerDefault.default),
                (0, _userContainerDefault.default),
                (0, _organizationContainerDefault.default)
            ]
        }, (authContainer, userContainer, orgContainer)=>(0, _react.jsx)(SingleSignOnSignUpRedirectorChild, {
                authContainer: authContainer,
                invitationCode: this.props.match.params.invitationCode,
                orgContainer: orgContainer,
                userContainer: userContainer,
                history: this.props.history
            }));
    }
}
class SingleSignOnSignUpRedirectorChild extends (0, _reactDefault.default).Component {
    componentDidMount() {
        const urlParams = new URLSearchParams(window.location.search);
        const email = urlParams.get("email");
        const token = urlParams.get("token");
        if (this.props.invitationCode != null) this.props.authContainer.signInWithSingleSignOn(email, token);
    }
    render() {
        if (this.props.authContainer.state.isAuthenticated === true && this.props.invitationCode != null) return (0, _react.jsx)((0, _acceptorDefault.default), {
            orgContainer: this.props.orgContainer,
            container: this.props.userContainer,
            invitationCode: this.props.invitationCode,
            history: this.props.history
        });
        return (0, _react.jsx)((0, _loaderDefault.default), null);
    }
}
exports.default = SingleSignOnSignUpRedirector;

},{"@emotion/react":"djZKr","react":"6uln9","../../components/general/Loader":"bnV5T","unstated":"grh7p","../../state/containers/AuthContainer":"cl1Qb","../acceptInvitation/components/Acceptor":"bgRcf","../../state/containers/OrganizationContainer":"dlbaM","../../state/containers/UserContainer":"jDrDR","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8TU93":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _unstated = require("unstated");
var _authContainer = require("../../state/containers/AuthContainer");
var _authContainerDefault = parcelHelpers.interopDefault(_authContainer);
var _reactRouter = require("react-router");
var _userContainer = require("../../state/containers/UserContainer");
var _userContainerDefault = parcelHelpers.interopDefault(_userContainer);
var _acceptor = require("./components/Acceptor");
var _acceptorDefault = parcelHelpers.interopDefault(_acceptor);
var _organizationContainer = require("../../state/containers/OrganizationContainer");
var _organizationContainerDefault = parcelHelpers.interopDefault(_organizationContainer);
var _applicationContainer = require("../../state/containers/ApplicationContainer");
var _applicationContainerDefault = parcelHelpers.interopDefault(_applicationContainer);
var _splash = require("../splash");
var _splashDefault = parcelHelpers.interopDefault(_splash);
var _featureContainer = require("../../state/containers/FeatureContainer");
var _featureContainerDefault = parcelHelpers.interopDefault(_featureContainer);
const AcceptNewInvitation = (props)=>{
    return (0, _react.jsx)("div", null, (0, _react.jsx)((0, _unstated.Subscribe), {
        to: [
            (0, _authContainerDefault.default),
            (0, _userContainerDefault.default),
            (0, _organizationContainerDefault.default),
            (0, _applicationContainerDefault.default),
            (0, _featureContainerDefault.default)
        ]
    }, (authContainer, userContainer, orgContainer, appContainer, featureContainer)=>{
        // if we are logged in, accept the invite
        // otherwise go to login
        if (authContainer.state.isAuthenticated === true) {
            // refresh token and data first
            if (authContainer.state.expirationDate < new Date() || !authContainer.state.accessToken) return (0, _react.jsx)((0, _splashDefault.default), {
                authContainer: authContainer,
                orgContainer: orgContainer,
                appContainer: appContainer,
                featureContainer: featureContainer
            });
            return (0, _react.jsx)((0, _acceptorDefault.default), {
                orgContainer: orgContainer,
                container: userContainer,
                invitationCode: props.match.params.invitationCode,
                history: props.history
            });
        }
        return (0, _react.jsx)((0, _reactRouter.Redirect), {
            to: `/createAccount/${props.match.params.invitationCode}`
        });
    }));
};
exports.default = AcceptNewInvitation;

},{"@emotion/react":"djZKr","react":"6uln9","unstated":"grh7p","../../state/containers/AuthContainer":"cl1Qb","react-router":"i3TiW","../../state/containers/UserContainer":"jDrDR","./components/Acceptor":"bgRcf","../../state/containers/OrganizationContainer":"dlbaM","../../state/containers/ApplicationContainer":"cuqi2","../splash":"5FUTj","../../state/containers/FeatureContainer":"4ApGg","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4ljqB":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _unstated = require("unstated");
var _authContainer = require("../../state/containers/AuthContainer");
var _authContainerDefault = parcelHelpers.interopDefault(_authContainer);
var _reactRouter = require("react-router");
var _frontTabbedLayout = require("../../components/structure/FrontTabbedLayout");
var _frontTabbedLayoutDefault = parcelHelpers.interopDefault(_frontTabbedLayout);
var _reactTabs = require("react-tabs");
var _tabPanelBody = require("../../components/structure/TabPanelBody");
var _tabPanelBodyDefault = parcelHelpers.interopDefault(_tabPanelBody);
var _registerForm = require("./components/RegisterForm");
var _registerFormDefault = parcelHelpers.interopDefault(_registerForm);
var _userContainer = require("../../state/containers/UserContainer");
var _userContainerDefault = parcelHelpers.interopDefault(_userContainer);
var _landingContainer = require("../../components/structure/LandingContainer");
var _landingContainerDefault = parcelHelpers.interopDefault(_landingContainer);
var _createPasswordForm = require("./components/CreatePasswordForm");
var _createPasswordFormDefault = parcelHelpers.interopDefault(_createPasswordForm);
const NewUserLogin = (props)=>{
    const query = new URLSearchParams(window.location.search);
    const email = query.get("email");
    const firstName = query.get("firstName");
    const lastName = query.get("lastName");
    const applicationId = query.get("app");
    if (applicationId) sessionStorage.setItem("inviteTargetApplicationId", applicationId);
    return (0, _react.jsx)((0, _landingContainerDefault.default), null, (0, _react.jsx)((0, _unstated.Subscribe), {
        to: [
            (0, _authContainerDefault.default),
            (0, _userContainerDefault.default)
        ]
    }, (authContainer, userContainer)=>{
        // if we are logged in, go to root
        if (authContainer.state.isAuthenticated === true) return (0, _react.jsx)((0, _reactRouter.Redirect), {
            to: "/v"
        });
        const enteringPassword = userContainer.state.userRegistrationInformation.enteringPassword;
        return (0, _react.jsx)((0, _frontTabbedLayoutDefault.default), {
            tabs: [
                "Create Account"
            ]
        }, (0, _react.jsx)((0, _reactTabs.TabPanel), null, (0, _react.jsx)((0, _tabPanelBodyDefault.default), null, enteringPassword ? (0, _react.jsx)((0, _createPasswordFormDefault.default), {
            stateContainer: userContainer,
            authContainer: authContainer,
            invitationCode: props.match.params.invitationCode
        }) : (0, _react.jsx)((0, _registerFormDefault.default), {
            stateContainer: userContainer,
            authContainer: authContainer,
            invitationCode: props.match.params.invitationCode,
            email: email,
            firstName: firstName,
            lastName: lastName
        }))));
    }));
};
exports.default = NewUserLogin;

},{"@emotion/react":"djZKr","react":"6uln9","unstated":"grh7p","../../state/containers/AuthContainer":"cl1Qb","react-router":"i3TiW","../../components/structure/FrontTabbedLayout":"81aMg","react-tabs":"92Sgf","../../components/structure/TabPanelBody":"ePx7g","./components/RegisterForm":"7vD5Q","../../state/containers/UserContainer":"jDrDR","../../components/structure/LandingContainer":"l7sWG","./components/CreatePasswordForm":"kSoKM","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6DQJV":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
var _react1 = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _notificationsContainer = require("../../shared/hooks/NotificationsContainer");
var _notificationsContainerDefault = parcelHelpers.interopDefault(_notificationsContainer);
var _languageContainer = require("../../shared/hooks/LanguageContainer");
var _languageContainerDefault = parcelHelpers.interopDefault(_languageContainer);
var _simulatorContainer = require("../../shared/hooks/SimulatorContainer");
var _simulatorContainerDefault = parcelHelpers.interopDefault(_simulatorContainer);
var _termsContainer = require("../../shared/hooks/TermsContainer");
var _termsContainerDefault = parcelHelpers.interopDefault(_termsContainer);
var _dialogflowDeploymentContainer = require("../../shared/hooks/DialogflowDeploymentContainer");
var _dialogflowDeploymentContainerDefault = parcelHelpers.interopDefault(_dialogflowDeploymentContainer);
var _amazonDeploymentContainer = require("../../shared/hooks/AmazonDeploymentContainer");
var _amazonDeploymentContainerDefault = parcelHelpers.interopDefault(_amazonDeploymentContainer);
var _microsoftDeploymentContainer = require("../../shared/hooks/MicrosoftDeploymentContainer");
var _microsoftDeploymentContainerDefault = parcelHelpers.interopDefault(_microsoftDeploymentContainer);
var _customAssistantContainer = require("../../shared/hooks/CustomAssistantContainer");
var _customAssistantContainerDefault = parcelHelpers.interopDefault(_customAssistantContainer);
var _applicationNlpEntityContainer = require("../../shared/hooks/ApplicationNlpEntityContainer");
var _applicationNlpEntityContainerDefault = parcelHelpers.interopDefault(_applicationNlpEntityContainer);
var _interactionModelContainer = require("../../shared/hooks/InteractionModelContainer");
var _interactionModelContainerDefault = parcelHelpers.interopDefault(_interactionModelContainer);
var _interactionModelUiStateContainer = require("../../shared/hooks/InteractionModelUiStateContainer");
var _interactionModelUiStateContainerDefault = parcelHelpers.interopDefault(_interactionModelUiStateContainer);
var _nlpModelTrainingContainer = require("../../shared/hooks/NlpModelTrainingContainer");
var _nlpModelTrainingContainerDefault = parcelHelpers.interopDefault(_nlpModelTrainingContainer);
var _deploymentsContainer = require("../../shared/hooks/DeploymentsContainer");
var _deploymentsContainerDefault = parcelHelpers.interopDefault(_deploymentsContainer);
var _useCustomAssistantConfigurationSettings = require("../../shared/scenes/applicationSettings/hooks/useCustomAssistantConfigurationSettings");
var _useCustomAssistantConfigurationSettingsDefault = parcelHelpers.interopDefault(_useCustomAssistantConfigurationSettings);
var _sessionAnalyticsContainer = require("../../shared/hooks/SessionAnalyticsContainer");
var _sessionAnalyticsContainerDefault = parcelHelpers.interopDefault(_sessionAnalyticsContainer);
var _sessionAnalyticsContainerOld = require("../../shared/hooks/SessionAnalyticsContainerOld");
var _sessionAnalyticsContainerOldDefault = parcelHelpers.interopDefault(_sessionAnalyticsContainerOld);
var _applicationNlpMenuContainer = require("../../shared/hooks/ApplicationNlpMenuContainer");
var _applicationNlpMenuContainerDefault = parcelHelpers.interopDefault(_applicationNlpMenuContainer);
var _telephonyDeploymentContainer = require("../../shared/hooks/TelephonyDeploymentContainer");
var _telephonyDeploymentContainerDefault = parcelHelpers.interopDefault(_telephonyDeploymentContainer);
var _nlpContainer = require("../../shared/hooks/NlpContainer");
var _nlpContainerDefault = parcelHelpers.interopDefault(_nlpContainer);
var _analyticsEventStreamContainer = require("../../shared/hooks/AnalyticsEventStreamContainer");
var _analyticsEventStreamContainerDefault = parcelHelpers.interopDefault(_analyticsEventStreamContainer);
var _telephonyAnalyticsContainer = require("../../shared/hooks/TelephonyAnalyticsContainer");
var _telephonyAnalyticsContainerDefault = parcelHelpers.interopDefault(_telephonyAnalyticsContainer);
var _orgSetupContainer = require("../../shared/hooks/OrgSetupContainer");
var _orgSetupContainerDefault = parcelHelpers.interopDefault(_orgSetupContainer);
var _sparkContainer = require("../../shared/hooks/SparkContainer");
var _sparkContainerDefault = parcelHelpers.interopDefault(_sparkContainer);
var _orgAnalyticsContainer = require("../../shared/hooks/OrgAnalyticsContainer");
var _orgAnalyticsContainerDefault = parcelHelpers.interopDefault(_orgAnalyticsContainer);
var _sparkDeploymentContainer = require("../../shared/hooks/SparkDeploymentContainer");
var _sparkDeploymentContainerDefault = parcelHelpers.interopDefault(_sparkDeploymentContainer);
var _analyticsOrderStateContainer = require("../../shared/hooks/AnalyticsOrderStateContainer");
var _analyticsOrderStateContainerDefault = parcelHelpers.interopDefault(_analyticsOrderStateContainer);
var _menuContainer = require("../../shared/hooks/MenuContainer");
var _menuContainerDefault = parcelHelpers.interopDefault(_menuContainer);
var _menuSyncContainer = require("../../shared/hooks/MenuSyncContainer");
var _menuSyncContainerDefault = parcelHelpers.interopDefault(_menuSyncContainer);
var _outboundCallContainer = require("../../shared/hooks/OutboundCallContainer");
var _outboundCallContainerDefault = parcelHelpers.interopDefault(_outboundCallContainer);
var _contentContainer = require("../../shared/hooks/ContentContainer");
var _contentContainerDefault = parcelHelpers.interopDefault(_contentContainer);
var _applicationNlpGenAIContainer = require("../../shared/hooks/ApplicationNlpGenAIContainer");
var _applicationNlpGenAIContainerDefault = parcelHelpers.interopDefault(_applicationNlpGenAIContainer);
var _testCaseContainer = require("../../shared/hooks/TestCaseContainer");
var _testCaseContainerDefault = parcelHelpers.interopDefault(_testCaseContainer);
var _reviewUserContainer = require("../../shared/hooks/ReviewUserContainer");
var _reviewUserContainerDefault = parcelHelpers.interopDefault(_reviewUserContainer);
var _responsesContainer = require("../../shared/hooks/ResponsesContainer");
var _responsesContainerDefault = parcelHelpers.interopDefault(_responsesContainer);
var _applicationVariablesContainer = require("../../shared/hooks/ApplicationVariablesContainer");
var _applicationVariablesContainerDefault = parcelHelpers.interopDefault(_applicationVariablesContainer);
var _currentApplicationContainer = require("../../shared/hooks/CurrentApplicationContainer");
var _currentApplicationContainerDefault = parcelHelpers.interopDefault(_currentApplicationContainer);
var _convSuccessHistogramContainer = require("../../shared/components/charts/ConvSuccessHistogramContainer");
var _convSuccessHistogramContainerDefault = parcelHelpers.interopDefault(_convSuccessHistogramContainer);
var _scheduledAnalyticsEmailContainer = require("../../shared/hooks/ScheduledAnalyticsEmailContainer");
var _scheduledAnalyticsEmailContainerDefault = parcelHelpers.interopDefault(_scheduledAnalyticsEmailContainer);
const ContainerProvider = (props)=>{
    return (0, _react.jsx)((0, _telephonyAnalyticsContainerDefault.default).Provider, null, (0, _react.jsx)((0, _notificationsContainerDefault.default).Provider, null, (0, _react.jsx)((0, _currentApplicationContainerDefault.default).Provider, null, (0, _react.jsx)((0, _languageContainerDefault.default).Provider, null, (0, _react.jsx)((0, _termsContainerDefault.default).Provider, null, (0, _react.jsx)((0, _interactionModelContainerDefault.default).Provider, null, (0, _react.jsx)((0, _interactionModelUiStateContainerDefault.default).Provider, null, (0, _react.jsx)((0, _simulatorContainerDefault.default).Provider, null, (0, _react.jsx)((0, _telephonyDeploymentContainerDefault.default).Provider, null, (0, _react.jsx)((0, _customAssistantContainerDefault.default).Provider, null, (0, _react.jsx)((0, _dialogflowDeploymentContainerDefault.default).Provider, null, (0, _react.jsx)((0, _amazonDeploymentContainerDefault.default).Provider, null, (0, _react.jsx)((0, _microsoftDeploymentContainerDefault.default).Provider, null, (0, _react.jsx)((0, _applicationNlpEntityContainerDefault.default).Provider, null, (0, _react.jsx)((0, _applicationNlpMenuContainerDefault.default).Provider, null, (0, _react.jsx)((0, _applicationNlpGenAIContainerDefault.default).Provider, null, (0, _react.jsx)((0, _menuSyncContainerDefault.default).Provider, null, (0, _react.jsx)((0, _menuContainerDefault.default).Provider, null, (0, _react.jsx)((0, _outboundCallContainerDefault.default).Provider, null, (0, _react.jsx)((0, _nlpModelTrainingContainerDefault.default).Provider, null, (0, _react.jsx)((0, _deploymentsContainerDefault.default).Provider, null, (0, _react.jsx)((0, _useCustomAssistantConfigurationSettingsDefault.default).Provider, null, (0, _react.jsx)((0, _sessionAnalyticsContainerDefault.default).Provider, null, (0, _react.jsx)((0, _sessionAnalyticsContainerOldDefault.default).Provider, null, (0, _react.jsx)((0, _analyticsEventStreamContainerDefault.default).Provider, null, (0, _react.jsx)((0, _nlpContainerDefault.default).Provider, null, (0, _react.jsx)((0, _orgSetupContainerDefault.default).Provider, null, (0, _react.jsx)((0, _contentContainerDefault.default).Provider, null, (0, _react.jsx)((0, _sparkContainerDefault.default).Provider, null, (0, _react.jsx)((0, _sparkDeploymentContainerDefault.default).Provider, null, (0, _react.jsx)((0, _orgAnalyticsContainerDefault.default).Provider, null, (0, _react.jsx)((0, _analyticsOrderStateContainerDefault.default).Provider, null, (0, _react.jsx)((0, _testCaseContainerDefault.default).Provider, null, (0, _react.jsx)((0, _reviewUserContainerDefault.default).Provider, null, (0, _react.jsx)((0, _responsesContainerDefault.default).Provider, null, (0, _react.jsx)((0, _applicationVariablesContainerDefault.default).Provider, null, (0, _react.jsx)((0, _convSuccessHistogramContainerDefault.default).Provider, null, (0, _react.jsx)((0, _scheduledAnalyticsEmailContainerDefault.default).Provider, null, props.children))))))))))))))))))))))))))))))))))))));
};
exports.default = ContainerProvider;

},{"@emotion/react":"djZKr","react":"6uln9","../../shared/hooks/NotificationsContainer":"hNroK","../../shared/hooks/LanguageContainer":"lchkU","../../shared/hooks/SimulatorContainer":"gOZ3V","../../shared/hooks/TermsContainer":"fiAWm","../../shared/hooks/DialogflowDeploymentContainer":"aCLZk","../../shared/hooks/AmazonDeploymentContainer":"bZJPl","../../shared/hooks/MicrosoftDeploymentContainer":"aIoVz","../../shared/hooks/CustomAssistantContainer":"1Z9b9","../../shared/hooks/ApplicationNlpEntityContainer":"6IUi8","../../shared/hooks/InteractionModelContainer":"5cw5C","../../shared/hooks/InteractionModelUiStateContainer":"2A95n","../../shared/hooks/NlpModelTrainingContainer":"fdXHQ","../../shared/hooks/DeploymentsContainer":"54k9j","../../shared/scenes/applicationSettings/hooks/useCustomAssistantConfigurationSettings":"jrJ7j","../../shared/hooks/SessionAnalyticsContainer":"vk8Qc","../../shared/hooks/SessionAnalyticsContainerOld":"3KBHi","../../shared/hooks/ApplicationNlpMenuContainer":"jposS","../../shared/hooks/TelephonyDeploymentContainer":"2qU7b","../../shared/hooks/NlpContainer":"eDZih","../../shared/hooks/AnalyticsEventStreamContainer":"6VBs6","../../shared/hooks/TelephonyAnalyticsContainer":"214YQ","../../shared/hooks/OrgSetupContainer":"bXGCB","../../shared/hooks/SparkContainer":"jzXzx","../../shared/hooks/OrgAnalyticsContainer":"d3Eao","../../shared/hooks/SparkDeploymentContainer":"7t8XT","../../shared/hooks/AnalyticsOrderStateContainer":"bf7Hw","../../shared/hooks/MenuContainer":"kshI5","../../shared/hooks/MenuSyncContainer":"dn6gk","../../shared/hooks/OutboundCallContainer":"ewsHF","../../shared/hooks/ContentContainer":"guIYn","../../shared/hooks/ApplicationNlpGenAIContainer":"fxZ8I","../../shared/hooks/TestCaseContainer":"cLg3U","../../shared/hooks/ReviewUserContainer":"hbyu4","../../shared/hooks/ResponsesContainer":"dMnYo","../../shared/hooks/ApplicationVariablesContainer":"65mmm","../../shared/hooks/CurrentApplicationContainer":"4hT7h","../../shared/components/charts/ConvSuccessHistogramContainer":"lDrBg","../../shared/hooks/ScheduledAnalyticsEmailContainer":"4KJ2O","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"ewsHF":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _unstatedNext = require("unstated-next");
var _outboundCall = require("../api/controllers/outboundCall");
var _telephonyDeployment = require("../../shared/api/controllers/telephonyDeployment");
var _applicationAnalytics = require("../../shared/api/controllers/applicationAnalytics");
function useOutboundCallContainer() {
    const [application, setApplication] = (0, _react.useState)();
    const [organizationId, setOrganizationId] = (0, _react.useState)("");
    const [numbersToCall, setNumbersToCall] = (0, _react.useState)([]);
    const [assistantNumbers, setAssistantNumbers] = (0, _react.useState)([]);
    async function placeOutboundCall(outboundCallRequest) {
        try {
            const result = await _outboundCall.placeOutboundCall(outboundCallRequest);
            return result;
        } catch (e) {
            console.log(e);
            return {
                resultType: "Unexpected",
                data: null,
                errors: [
                    e.message
                ]
            };
        }
    }
    async function deleteOutboundCall(outboundCallId) {
        try {
            const result = await _outboundCall.deleteOutboundCall(organizationId, application.id, outboundCallId);
            return result;
        } catch (e) {
            console.log(e);
            return {
                resultType: "Unexpected",
                data: null,
                errors: [
                    e.message
                ]
            };
        }
    }
    async function fetchAssistantNumbers(applicationId) {
        try {
            const assistantNumbers = await _telephonyDeployment.getTelephonyDeployments(applicationId);
            if (assistantNumbers.resultType === "Ok") //Only the real phone numbers should be shown (virtual number does not work for outbound calls)
            setAssistantNumbers(assistantNumbers.data.filter((x)=>x.virtualNumber === "").map((x)=>({
                    number: x.phoneNumber,
                    name: x.name
                })));
        } catch (e) {
            console.log(e);
        }
    }
    async function fetchOutboundCalls(startDate, endDate) {
        try {
            if (!organizationId) return;
            const numbersResult = await _outboundCall.getOutboundCalls(organizationId, application.id, {
                startDate,
                endDate
            });
            if (numbersResult.resultType === "Ok") setNumbersToCall(numbersResult.data || []);
            else setNumbersToCall([]);
        } catch (e) {
            console.log(e);
            setNumbersToCall([]);
        }
    }
    async function createOutboundCall(request) {
        try {
            const result = await _outboundCall.createOutboundCall(organizationId, application.id, request);
            return result;
        } catch (e) {
            console.log(e);
            return {
                resultType: "Unexpected",
                data: null,
                errors: [
                    e.message
                ]
            };
        }
    }
    async function getOutboundCallAnsweredEvents(startDate, endDate) {
        try {
            const result = await _applicationAnalytics.getOutboundCallAnsweredEventsByApplication(application.id, {
                startDate,
                endDate
            });
            return result;
        } catch (e) {
            console.log(e);
            return {
                resultType: "Unexpected",
                data: null,
                errors: [
                    e.message
                ]
            };
        }
    }
    return {
        application,
        setApplication,
        organizationId,
        setOrganizationId,
        numbersToCall,
        setNumbersToCall,
        deleteOutboundCall,
        assistantNumbers,
        fetchAssistantNumbers,
        fetchOutboundCalls,
        createOutboundCall,
        placeOutboundCall,
        getOutboundCallAnsweredEvents
    };
}
const OutboundCallContainer = (0, _unstatedNext.createContainer)(useOutboundCallContainer);
exports.default = OutboundCallContainer;

},{"react":"6uln9","unstated-next":"61zE5","../api/controllers/outboundCall":"2RNSt","../../shared/api/controllers/telephonyDeployment":"hKhC3","../../shared/api/controllers/applicationAnalytics":"kCQLR","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2RNSt":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "placeOutboundCall", ()=>placeOutboundCall);
parcelHelpers.export(exports, "getOutboundCalls", ()=>getOutboundCalls);
parcelHelpers.export(exports, "createOutboundCall", ()=>createOutboundCall);
parcelHelpers.export(exports, "deleteOutboundCall", ()=>deleteOutboundCall);
var _urls = require("../../constants/Urls");
var _generic = require("./generic");
const placeOutboundCall = (request)=>{
    return (0, _generic.sendPost)(`${(0, _urls.OUTBOUND_CALL)}`, request, (0, _urls.getWebsocketAssistantUrl)());
};
const getOutboundCalls = (organizationId, applicationId, filter)=>{
    const filterQuery = `startDate=${filter.startDate}&endDate=${filter.endDate}`;
    return (0, _generic.sendGet)(`${(0, _urls.OUTBOUND_CALL_Config)}/org/${organizationId}/app/${applicationId}?${filterQuery}`);
};
const createOutboundCall = (organizationId, applicationId, request)=>{
    return (0, _generic.sendPost)(`${(0, _urls.OUTBOUND_CALL_Config)}/org/${organizationId}/app/${applicationId}`, request);
};
const deleteOutboundCall = (organizationId, applicationId, outboundCallId)=>{
    return (0, _generic.sendDelete)(`${(0, _urls.OUTBOUND_CALL_Config)}/org/${organizationId}/app/${applicationId}?outboundCallId=${outboundCallId}`);
};

},{"../../constants/Urls":"iTopY","./generic":"6oGDt","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}]},["52JVb"], "52JVb", "parcelRequire59eb")

//# sourceMappingURL=index.df5754c4.js.map
